(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["IzendaSynergy"] = factory();
	else
		root["IzendaSynergy"] = factory();
})(this, function() {
return webpackJsonpIzendaSynergy([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Connect.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var toClass = __webpack_require__(9).toClass;
  var withContext = __webpack_require__(9).withContext;

  var observer = __webpack_require__(10).observer;
  var withRouter = __webpack_require__(52).withRouter;
  var connectContextToProps = __webpack_require__(1476);
  var connectActions = __webpack_require__(1485);
  var Authorization = __webpack_require__(1487);
  var LicenseChecker = __webpack_require__(1488);

  var _require = __webpack_require__(1),
      forEach = _require.forEach,
      isObject = _require.isObject,
      isNil = _require.isNil,
      pull = _require.pull,
      head = _require.head,
      isPlainObject = _require.isPlainObject;

  /**
   * Connect the enhancers to component.
   */


  module.exports = function connect() {
    // convert arguments to real array
    var args = Array.prototype.slice.call(arguments);
    var authorizationEnhancer;
    var licenseCheckerEnhancer;
    forEach(function (arg) {
      if (isObject(arg)) {
        if (!isNil(arg.permissionKeys)) {
          authorizationEnhancer = Authorization.bind(null, arg.permissionKeys, arg.onAuth);
          args = pull(arg, args);
        }

        if (!isNil(arg.licenseKey)) {
          licenseCheckerEnhancer = LicenseChecker.bind(null, arg.licenseKey, arg.onLicense);
          args = pull(arg, args);
        }
      }
    }, args);

    // assume options will be passed at first argument if having
    var options = head(args);
    // take the rest of enhance functions
    var otherEnhancers = options && isPlainObject(options) ? args.slice(1) : args;

    var defaultEnhancers = [connectContextToProps, withRouter, connectActions];

    // determine whether needs to convert to statefull compoment using toClass
    var toClassEnhancer = options && isPlainObject(options) && options.toClass ? [toClass] : [];

    var changeContext = options && isPlainObject(options) && options.context ? [withContext(options.context.childContextTypes, options.context.getChildContext)] : [];

    var enhancers = toClassEnhancer.concat(changeContext).concat(defaultEnhancers).concat(otherEnhancers).concat([observer]);

    if (!isNil(authorizationEnhancer)) enhancers = enhancers.concat(authorizationEnhancer);

    if (!isNil(licenseCheckerEnhancer)) enhancers = enhancers.concat(licenseCheckerEnhancer);

    return compose.apply(null, enhancers);
  };
}();

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Localizer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var ensure = __webpack_require__(38);
  var config = __webpack_require__(40);

  var _require = __webpack_require__(1),
      get = _require.get,
      getOr = _require.getOr;

  function Localizer() {
    this.activeLanguage = config.DefaultLanguage;
    this.languages = {};
  }

  /**
   * Register language data
   * @param {Array} array of localization keys
   * @param {String} language
   */
  Localizer.prototype.registerLanguage = function (data, language) {
    ensure(data, 'Invalid data');
    ensure(language, 'Language must be set');

    this.languages[language] = data;
  };

  /**
   * Set active language
   * @param {String} language
   */
  Localizer.prototype.setActiveLanguage = function (language) {
    ensure(language, 'Language is not valid');

    var isLanguageSupported = !!get(this.activeLanguage, this.languages);

    if (isLanguageSupported) {
      this.activeLanguage = language;
    }
  };

  /**
   * Get localization text in active language
   * @param {type} language
   */
  Localizer.prototype.getText = function (key) {
    var activeLanguage = get(this.activeLanguage, this.languages);

    return getOr('', key, activeLanguage);
  };

  var singleton = new Localizer();

  module.exports = singleton;
}();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.GridLayout.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var MAX_COLS = 12;
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);

  var GridLayout = createGridLayoutElement('izenda-GridLayout');
  GridLayout.Row = createGridLayoutElement('izenda-GridLayout-Row');
  GridLayout.FullRow = createGridLayoutElement('izenda-GridLayout-Row_full');

  var _require = __webpack_require__(1),
      omit = _require.omit;

  GridLayout.Col = function (props) {
    var cols = props.cols || MAX_COLS;
    var colClass = 'izenda-GridLayout-Col' + cols;
    var xsColclass = props.xs && 'izenda-GridLayout-Col' + props.xs + '-xs';
    var offsetClass = props.offset && 'izenda-GridLayout-ColOffset' + props.offset;

    var className = classnames(colClass, xsColclass, offsetClass);
    var restProps = omit(['cols', 'offset', 'xs'], props);
    return createGridLayoutElement(className)(restProps);
  };

  function createGridLayoutElement(className) {
    return function (props) {
      var clazz = classnames(className, props.className);
      var restProps = omit('className', props);
      return React.createElement(
        'div',
        (0, _extends3.default)({ className: clazz }, restProps),
        props.children
      );
    };
  }

  module.exports = GridLayout;
}();

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
// ----------------------------------------------------------------------
// <copyright file="Izenda.UiState.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(167);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(482);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(115);

var _Izenda8 = __webpack_require__(245);

var _Izenda9 = _interopRequireDefault(_Izenda8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var UiState = (_dec = (0, _mobx.action)('setTenantId'), _dec2 = (0, _mobx.action)('setDisableSettingLevel'), _dec3 = (0, _mobx.action)('setCurrentUser'), (_class = function () {
  function UiState() {
    (0, _classCallCheck3.default)(this, UiState);

    _initDefineProp(this, 'detectChangeCount', _descriptor, this);

    _initDefineProp(this, 'detectChangeVisibleConnection', _descriptor2, this);

    _initDefineProp(this, 'tenantId', _descriptor3, this);

    _initDefineProp(this, 'disableSystemSetting', _descriptor4, this);

    _initDefineProp(this, 'onlyShowTenant', _descriptor5, this);

    _initDefineProp(this, 'checkDirtyFunction', _descriptor6, this);

    _initDefineProp(this, 'onOkDirtyForm', _descriptor7, this);

    _initDefineProp(this, 'systemError', _descriptor8, this);

    _initDefineProp(this, 'systemMode', _descriptor9, this);

    _initDefineProp(this, 'isMobile', _descriptor10, this);

    _initDefineProp(this, 'needLogin', _descriptor11, this);

    _initDefineProp(this, 'currentUser', _descriptor12, this);

    _initDefineProp(this, 'provisioningStatus', _descriptor13, this);

    _initDefineProp(this, 'notificationMessages', _descriptor14, this);

    _initDefineProp(this, 'exportingLoadings', _descriptor15, this);

    _initDefineProp(this, 'hasSetupDatabase', _descriptor16, this);

    _initDefineProp(this, 'expiredLicense', _descriptor17, this);

    this.defaultDirtyMessage = _Izenda6.default.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST');
    this.dirtyMessage = this.defaultDirtyMessage;
  } // used for enable/disable Setting Level dropdown
  // used for enable/disable Tenant Level dropdown


  (0, _createClass3.default)(UiState, [{
    key: 'resetCheckDirtyFunction',
    value: function resetCheckDirtyFunction() {
      this.setCheckDirtyFunction(null, null);
    }
  }, {
    key: 'setCheckDirtyFunction',
    value: function setCheckDirtyFunction(checkDirtyFunction, onOk, dirtyMessage) {
      this.checkDirtyFunction = checkDirtyFunction;
      this.onOkDirtyForm = onOk;
      this.dirtyMessage = !(0, _fp.isNil)(dirtyMessage) ? dirtyMessage : this.defaultDirtyMessage;
    }
  }, {
    key: 'getDetectChangeVisibleConnection',
    value: function getDetectChangeVisibleConnection() {
      return this.detectChangeVisibleConnection;
    }
  }, {
    key: 'increaseDetectChangeVisibleConnection',
    value: function increaseDetectChangeVisibleConnection() {
      return this.detectChangeVisibleConnection++;
    }
  }, {
    key: 'getDetectChangeCount',
    value: function getDetectChangeCount() {
      return this.detectChangeCount;
    }
  }, {
    key: 'increaseDetectChangeCount',
    value: function increaseDetectChangeCount() {
      return this.detectChangeCount++;
    }
  }, {
    key: 'getTenantId',
    value: function getTenantId() {
      return this.tenantId;
    }
  }, {
    key: 'setTenantId',
    value: function setTenantId(tenantId, keepState) {
      this.keepState = !!keepState;
      return this.tenantId = tenantId;
    }
  }, {
    key: 'setSystemError',
    value: function setSystemError(error) {
      this.systemError = error;
    }
  }, {
    key: 'resetSystemError',
    value: function resetSystemError() {
      this.systemError = null;
    }
  }, {
    key: 'setMobileVersion',
    value: function setMobileVersion(value) {
      this.isMobile = value;
    }
  }, {
    key: 'getMobileVersion',
    value: function getMobileVersion() {
      return this.isMobile;
    }

    /**
     * Disable system setting bar
     */

  }, {
    key: 'updateDisableSystemSetting',
    value: function updateDisableSystemSetting() {
      this.disableSystemSetting = true;
    }
  }, {
    key: 'enableSystemSetting',
    value: function enableSystemSetting() {
      this.disableSystemSetting = false;
    }

    /**
     * Set disable setting level. Clear the tenantId when setting level is disabled
     */

  }, {
    key: 'setDisableSettingLevel',
    value: function setDisableSettingLevel(disable) {
      this.disableSystemSetting = disable;
      if (disable) {
        this.tenantId = null;
        _Izenda9.default.removeSelectedTenant();
      }
    }

    /**
     * Update need login status.
     * @param  {boolean} value
     */

  }, {
    key: 'setNeedLogin',
    value: function setNeedLogin(value) {
      this.needLogin = value;
    }

    /**
     * Update current user detail.
     * @param  {Object} value
     */

  }, {
    key: 'setCurrentUser',
    value: function setCurrentUser(value) {
      value = value || {};
      this.tenantId = value.tenantId;
      this.currentUser.populate(value);
      value.cultureName && _Izenda6.default.setActiveLanguage(value.cultureName);
    }

    /**
     * Update Provisioning Status
     * @param value
     */

  }, {
    key: 'setProvisioningStatus',
    value: function setProvisioningStatus(value) {
      this.provisioningStatus = value;
    }

    /**
     * Add new Notification message
     * @param notification
     */

  }, {
    key: 'addNotification',
    value: function addNotification(notification) {
      var index = (0, _fp.findIndex)({ key: notification.key }, this.notificationMessages);
      index === -1 && this.notificationMessages.unshift(notification);
    }
  }, {
    key: 'removeNotification',
    value: function removeNotification(key) {
      var index = (0, _fp.findIndex)({ key: key }, this.notificationMessages);
      index > -1 && this.notificationMessages.splice(index, 1);
    }

    /**
     * Reset exporting loadings.
     */

  }, {
    key: 'resetExportingLoadings',
    value: function resetExportingLoadings() {
      this.exportingLoadings.clear();
    }

    /**
     * Update expire license
     */

  }, {
    key: 'updateLicenseStatus',
    value: function updateLicenseStatus(expired) {
      this.expiredLicense = expired;
    }

    /**
     * Set system mode
     * @param {Number} systemMode
     */

  }, {
    key: 'setSystemMode',
    value: function setSystemMode(systemMode) {
      this.systemMode = systemMode;
    }
  }, {
    key: 'isDirty',
    get: function get() {
      return this.checkDirtyFunction && this.checkDirtyFunction();
    }
  }, {
    key: 'hideSystemLevel',
    get: function get() {
      return this.systemMode === _Izenda2.default.SYSTEM_MODE || !this.currentUser.systemAdmin;
    }
  }, {
    key: 'canProvisioning',
    get: function get() {
      return this.provisioningStatus === _Izenda7.PROVISIONING_STATUS.NOT_STARTED || this.provisioningStatus === _Izenda7.PROVISIONING_STATUS.ERROR;
    }
  }, {
    key: 'isMapDataAvailable',
    get: function get() {
      return this.provisioningStatus === _Izenda7.PROVISIONING_STATUS.SUCCESS;
    }
  }, {
    key: 'isSingleTenantMode',
    get: function get() {
      return this.systemMode === _Izenda2.default.TENANT_MODE;
    }
  }]);
  return UiState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'detectChangeCount', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'detectChangeVisibleConnection', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'disableSystemSetting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'onlyShowTenant', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'checkDirtyFunction', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'onOkDirtyForm', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'systemError', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'systemMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda2.default.SYSTEM_MODE;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'isMobile', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'needLogin', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'currentUser', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda4.default();
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'provisioningStatus', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda7.PROVISIONING_STATUS.NOT_STARTED;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, 'notificationMessages', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, 'exportingLoadings', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, 'hasSetupDatabase', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, 'expiredLicense', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideSystemLevel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hideSystemLevel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'canProvisioning', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'canProvisioning'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isMapDataAvailable', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isMapDataAvailable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isSingleTenantMode', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isSingleTenantMode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setTenantId', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setTenantId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setDisableSettingLevel', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setDisableSettingLevel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setCurrentUser', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setCurrentUser'), _class.prototype)), _class));


var singleton = new UiState();
exports.default = singleton;
module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(45);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(42);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var VALID_REPORT_NAME_REGEX = /^[^/<>&]*$/;

var DRILL_DOWN_STYLE_OPTION_VALUES = {
  link: 'link',
  linknewwindow: 'linknewwindow',
  embedded: 'embedded',
  popup: 'popup'
};

var JOIN_TYPES = {
  LEFT: 'Left',
  RIGHT: 'Right'
};

/* Izenda data type*/
var DATA_TYPES = {
  NUMERIC: 'Numeric',
  TEXT: 'Text',
  DATE_TIME: 'Datetime',
  TIME: 'Time',
  IMAGE: 'Image',
  BOOLEAN: 'Boolean',
  MONEY: 'Money',
  CUSTOM: 'CustomFormat',
  LOB: 'Lob',
  XML: 'XML',
  JSON: 'JSON'
};

var REPORT_TYPE_ENUM = {
  REPORT: 0,
  TEMPLATE: 1
};

var REPORT_TYPE = [{
  id: REPORT_TYPE_ENUM.REPORT,
  get name() {
    return _Izenda2.default.getText('COMMON_LABEL_REPORTS');
  },
  value: 'Report'
}, {
  id: REPORT_TYPE_ENUM.TEMPLATE,
  get name() {
    return _Izenda2.default.getText('COMMON_LABEL_TEMPLATES');
  },
  value: 'Template'
}];

var GLOBAL_REPORT_ENUM = {
  GLOBAL: 1,
  LOCAL: 0
};

var COMPARISION_TYPE = {
  NONE: 'none',
  FIELD: 'field',
  VALUE: 'value',
  DATE_TIME: 'datetime',
  DATE: 'date',
  TIME: 'time'
};

var dataSourceConcatTreeMap = function dataSourceConcatTreeMap() {
  var isExpand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return [{
    prop: 'querySource',
    nodeType: 'QuerySource',
    expand: isExpand,
    children: [{
      prop: 'fields',
      nodeType: 'Field'
    }]
  }];
};

exports.default = {
  COLUMN_NAME_PREFIX: {
    ORIGINAL_VALUE: 'org_',
    PERCENTAGE_VALUE: 'percentage_'
  },

  NO_SORT_DATA_TYPES: [DATA_TYPES.JSON, DATA_TYPES.LOB, DATA_TYPES.IMAGE, DATA_TYPES.XML],

  FILTER_URL: {
    OVERIDE_MASTER_REPORT_FILTER: {
      REGEX: /^mp(\d+)value$/,
      FORMAT: 'mp{0}value'
    },
    OVERIDE_REPORT_FILTER: {
      REGEX: /^p(\d+)value$/,
      FORMAT: 'p{0}value'
    },
    SUB_REPORT_FIELD_MAPPING_KEY: {
      FORMAT: 'fm{0}_{1}'
    },
    OVERIDE_MASTER_REPORT_USE_USER_LOOKUP: {
      REGEX: /^mp(\d+)lookup$/,
      FORMAT: 'mp{0}lookup'
    }
  },

  DATA_OBJECT_SWAP_KEYS: [['joinDataSourceCategoryId', 'foreignDataSourceCategoryId'], ['JoinDataSourceCategoryName', 'foreignDataSourceCategoryName'], ['joinQuerySourceId', 'foreignQuerySourceId'], ['joinQuerySourceName', 'foreignQuerySourceName'], ['joinFieldId', 'foreignFieldId'], ['joinFieldName', 'foreignFieldName']],

  /**
   * this is id of Uncategorized
   */
  get UNCATEGORIZED() {
    return _Izenda2.default.getText('REPORTDESIGNER_LABEL_UNCATEGORIZED');
  },
  ADVANCED: 1,
  SIMPLE: 0,
  BUNDLE: {
    TOOLTIP: {
      FILTER: {
        get M07() {
          return _Izenda2.default.getText('REPORTDESIGNER_FILTER_TOOLTIP');
        }
      }
    },
    CRITERIA_LIST_SIMPLE_MODE: [{
      value: 'All',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_ALL');
      }
    }, {
      value: 'Category',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_SIMPLE_MODE_CATEGORY');
      }
    }, {
      value: 'DatabaseName',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_SIMPLE_MODE_DATABASE_NAME');
      }
    }, {
      value: 'DataObject',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_SIMPLE_MODE_DATA_OBJECT');
      }
    }, {
      value: 'DataObjectType',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_SIMPLE_MODE_DATA_OBJECT_TYPE');
      }
    }, {
      value: 'SchemaName',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_SIMPLE_MODE_SCHEMA_NAME');
      }
    }],
    CRITERIA_LIST_ADVANCED_MODE: [{
      value: 'All',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_ALL');
      }
    }, {
      value: 'Alias',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_ADVANCED_MODE_JOIN_ALIAS');
      }
    }, {
      value: 'JoinDataSourceCategoryName',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_ADVANCED_MODE_CATEGORY');
      }
    }, {
      value: 'JoinQuerySourceName',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_ADVANCED_MODE_DATA_OBJECT');
      }
    }, {
      value: 'JoinFieldName',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_ADVANCED_MODE_JOIN_FIELD');
      }
    }, {
      value: 'ForeignQuerySourceName',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_ADVANCED_MODE_FOREIGN_DATA_OBJECT');
      }
    }, {
      value: 'ForeignFieldName',
      get label() {
        return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CRITERIA_LIST_ADVANCED_MODE_FIELD');
      }
    }],
    SORT_ORDERS: {
      Category: 'DESC'
    },
    SORT_ORDERS_ADVANCED_MODE: {
      Alias: 'DESC',
      JoinType: '',
      Operator: '',
      JoinDataSourceCategoryId: '',
      JoinDataSourceCategoryName: '',
      JoinQuerySourceName: '',
      JoreignDataSourceCategoryId: '',
      JoreignDataSourceCategoryName: '',
      JoreignQuerySourceName: ''
    },
    MESSAGE: {
      get CANCEL() {
        return _Izenda2.default.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST');
      },
      get SAVE() {
        return _Izenda2.default.getText('COMMON_MESSAGES_CONFIRM_SAVE');
      },
      get DELETE_RELATIONSHIP() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_CONFIRM_DELETE_RELATIONSHIP');
      },
      get DELETE_RELATIONSHIP_WITH_KEYJOIN() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_CONFIRM_DELETE_RELATIONSHIP_WITH_KEYJOIN');
      },
      get DELETE_KEYJOIN() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_DELETE_KEYJOIN');
      },
      get ALLOW_NULL_TOOLTIP() {
        return _Izenda2.default.getText('REPORTDESIGNER_ALLOW_NULL_TOOLTIP');
      },
      get M01() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_COLUMN_NAME_REQUIRED');
      },
      get M02() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_FIELD_CANNOT_BE_FILTER');
      },
      get M03() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_CANNOT_DROP_RELATIONSHIP_IN_KEYJOIN_DEST');
      },
      get M04() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_CANNOT_DROP_KEYJOIN_HAVING_CROSS_JOIN');
      },
      get M06() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_VALID_SQL_STATEMENT');
      },
      get M08() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_FIELD_NAME_EXISTS');
      },
      get M09() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_FIELD_NAME_EXISTS_IN_REPORT_PART');
      },
      get M10() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_CONFIRM_SAVE_FILTER');
      },
      get M11() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_ADJUST_NUMBER_DATA_OBJECTS');
      },
      get M16() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_DATA_SOURCES_EXCEEDED_LIMITATION');
      },
      get SIMPLE_UNSELECT() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_SIMPLE_UNSELECT');
      },
      get ADVANCED_UNSELECT() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_ADVANCED_UNSELECT');
      },
      get SELECT_CROSS_JOIN() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_SELECT_CROSS_JOIN');
      },
      get CHANGE_JOIN_TYPE() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_CHANGE_JOIN_TYPE');
      },
      get FIELDS_EXCEEDED_LIMITATION() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_FIELDS_IN_REPORT_PART_EXCEEDED_LIMITATION');
      },
      get OPEN_SUB_REPORT_WARNING() {
        return _Izenda2.default.getText('OPEN_SUB_REPORT_WARNING_MESSAGE');
      },
      get CANNOT_ADD_RUNNIG_FILTER() {
        return _Izenda2.default.getText('REPORT_CANNOT_ADD_RUNNING_FILTER');
      },
      get CANNOT_ADD_REPEATER_RUNNING_FIELD() {
        return _Izenda2.default.getText('FORM_CANNOT_ADD_REPEATER_RUNNING_FIELD');
      },
      get FILTER_WILL_BE_IGNORED() {
        return _Izenda2.default.getText('UNSPECIFIED_FILTER_WILL_BE_IGNORED');
      }
    },

    DEFAULT_CRITERIA: 'All'
  },
  TABLE_CONFIG: {
    Table: {
      rowsCount: 10,
      rowHeight: 60,
      headerHeight: 60,
      width: 1400,
      height: 362,
      maxHeight: 800
    },
    Column: {
      width: 100
    }
  },
  ICON: {
    /* icon for stored-procedure */
    Table: 'icon-table',
    'Stored Procedure': 'icon-sp',
    Function: 'icon-fx-table',
    Relationship: 'icon-relationship',
    Schema: 'icon-schema',
    View: 'icon-view-table',

    /* icon for field type */
    Numeric: 'icon-type-no',
    Text: 'icon-type-text',
    Datetime: 'icon-type-calendar',
    Image: 'icon-picture',
    Boolean: 'icon-type-yn',
    Money: 'icon-money',
    Lob: 'icon-type-lob',
    Time: 'icon-clock'
  },
  TABLE_DEF: {
    SIMPLE_MODE: {
      category: {
        columnKey: 'Category',
        width: 250,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_SIMPLE_MODE_CATEGORY');
        },
        sortable: true
      },
      dbName: {
        columnKey: 'DatabaseName',
        width: 250,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_SIMPLE_MODE_DATABASE_NAME');
        },
        sortable: true
      },
      schemaName: {
        columnKey: 'SchemaName',
        width: 250,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_SIMPLE_MODE_SCHEMA_NAME');
        },
        sortable: true
      },
      dataObject: {
        columnKey: 'DataObject',
        width: 250,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_SIMPLE_MODE_DATA_OBJECT');
        },
        sortable: true
      },
      dataObjectType: {
        columnKey: 'DataObjectType',
        width: 250,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_SIMPLE_MODE_DATA_OBJECT_TYPE');
        },
        sortable: true
      }
    },
    ADVANCED_MODE: {
      parentId: { key: 'id' },
      alias: {
        key: 'alias',
        width: 100,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_ALIAS');
        }
      },
      joinType: {
        key: 'joinType',
        width: 100,
        get title() {
          return _Izenda2.default.getText('COMMON_LABEL_JOIN_TYPE');
        }
      },
      operator: {
        key: 'operator',
        width: 100,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_OPERATOR');
        }
      },
      category: {
        key: 'joinDataSourceCategoryId',
        labelKey: 'joinDataSourceCategoryName',
        width: 100,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_CATEGORY');
        }
      },
      dataObject: {
        key: 'joinQuerySourceId',
        labelKey: 'joinQuerySourceName',
        width: 100,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_DATA_OBJECT');
        }
      },
      selectedJoinSourceAlias: {
        key: 'selectedJoinSourceAlias',
        width: 100,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_SELECTED_JOIN_SOURCE_ALIAS');
        },
        sortable: true
      },
      joinField: {
        key: 'joinFieldId',
        labelKey: 'joinFieldName',
        width: 100,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_JOIN_FIELD');
        }
      },
      comparisonOperator: { width: 100, align: 'center', key: 'comparisonOperator' },
      foreignCategory: {
        key: 'foreignDataSourceCategoryId',
        labelKey: 'foreignDataSourceCategoryName',
        width: 100,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_FOREIGN_CATEGORY');
        }
      },
      foreignDataObject: {
        key: 'selectedForeignAlias',
        labelKey: 'foreignQuerySourceName',
        width: 110,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_FOREIGN_DATA_OBJECT');
        }
      },
      selectedForeignSourceAlias: {
        key: 'selectedForeignSourceAlias',
        width: 100,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_FOREIGN_SOURCE_ALIAS');
        },
        sortable: true
      },
      foreignJoinfield: {
        key: 'foreignFieldId',
        labelKey: 'foreignFieldName',
        width: 100,
        get title() {
          return _Izenda2.default.getText('REPORTDESIGNER_LABEL_TABLE_DEF_ADVANCED_MODE_FOREIGN_FIELD_NAME');
        }
      },
      action: {
        width: 80,
        get title() {
          return _Izenda2.default.getText('COMMON_LABEL_ACTION');
        }
      }
    }
  },
  DEFAULT_COMPARISION_OPERATOR: '= (Field)',
  COMPARISION_OPTIONS: [{
    label: _Izenda2.default.getText('COMPARISION_IS_NULL'),
    value: 'IS NULL',
    type: COMPARISION_TYPE.NONE,
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON]
  }, {
    label: _Izenda2.default.getText('COMPARISION_IS_NOT_NULL'),
    value: 'IS NOT NULL',
    type: COMPARISION_TYPE.NONE,
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON]
  }, {
    label: _Izenda2.default.getText('COMPARISION_IS_BLANK'),
    value: 'IS BLANK',
    type: COMPARISION_TYPE.NONE,
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON]
  }, {
    label: _Izenda2.default.getText('COMPARISION_IS_NOT_BLANK'),
    value: 'IS NOT BLANK',
    type: COMPARISION_TYPE.NONE,
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON]
  },
  // Field Comparision
  {
    label: '= (' + _Izenda2.default.getText('COMPARISION_FIELD') + ')',
    value: '= (Field)',
    type: COMPARISION_TYPE.FIELD,
    group: _Izenda2.default.getText('COMPARISION_FIELD_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON],
    forRelationship: true
  }, {
    label: '<> (' + _Izenda2.default.getText('COMPARISION_FIELD') + ')',
    value: '<> (Field)',
    type: COMPARISION_TYPE.FIELD,
    group: _Izenda2.default.getText('COMPARISION_FIELD_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON],
    forRelationship: true
  }, {
    label: '> (' + _Izenda2.default.getText('COMPARISION_FIELD') + ')',
    value: '> (Field)',
    type: COMPARISION_TYPE.FIELD,
    group: _Izenda2.default.getText('COMPARISION_FIELD_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON],
    forRelationship: true
  }, {
    label: '< (' + _Izenda2.default.getText('COMPARISION_FIELD') + ')',
    value: '< (Field)',
    type: COMPARISION_TYPE.FIELD,
    group: _Izenda2.default.getText('COMPARISION_FIELD_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON],
    forRelationship: true
  }, {
    label: '>= (' + _Izenda2.default.getText('COMPARISION_FIELD') + ')',
    value: '>= (Field)',
    type: COMPARISION_TYPE.FIELD,
    group: _Izenda2.default.getText('COMPARISION_FIELD_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON],
    forRelationship: true
  }, {
    label: '<= (' + _Izenda2.default.getText('COMPARISION_FIELD') + ')',
    value: '<= (Field)',
    type: COMPARISION_TYPE.FIELD,
    group: _Izenda2.default.getText('COMPARISION_FIELD_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.DATE_TIME, DATA_TYPES.TIME, DATA_TYPES.IMAGE, DATA_TYPES.BOOLEAN, DATA_TYPES.MONEY, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON],
    forRelationship: true
  },
  // Value Comparision
  {
    label: '=',
    value: '=',
    type: COMPARISION_TYPE.VALUE,
    group: _Izenda2.default.getText('COMPARISION_VALUE_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.MONEY]
  }, {
    label: '<>',
    value: '<>',
    type: COMPARISION_TYPE.VALUE,
    group: _Izenda2.default.getText('COMPARISION_VALUE_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.MONEY]
  }, {
    label: '>',
    value: '>',
    type: COMPARISION_TYPE.VALUE,
    group: _Izenda2.default.getText('COMPARISION_VALUE_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.MONEY]
  }, {
    label: '<',
    value: '<',
    type: COMPARISION_TYPE.VALUE,
    group: _Izenda2.default.getText('COMPARISION_VALUE_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.MONEY]
  }, {
    label: '>=',
    value: '>=',
    type: COMPARISION_TYPE.VALUE,
    group: _Izenda2.default.getText('COMPARISION_VALUE_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.MONEY]
  }, {
    label: '<=',
    value: '<=',
    type: COMPARISION_TYPE.VALUE,
    group: _Izenda2.default.getText('COMPARISION_VALUE_COMPRARISION'),
    DATA_TYPES: [DATA_TYPES.NUMERIC, DATA_TYPES.TEXT, DATA_TYPES.MONEY]
  },
  // Date & Time
  {
    label: '= (' + _Izenda2.default.getText('COMPARISION_DATE_AND_TIME') + ')',
    value: '= (Date & Time)',
    type: COMPARISION_TYPE.DATE_TIME,
    group: _Izenda2.default.getText('COMPARISION_DATE_AND_TIME'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '<> (' + _Izenda2.default.getText('COMPARISION_DATE_AND_TIME') + ')',
    value: '<> (Date & Time)',
    type: COMPARISION_TYPE.DATE_TIME,
    group: _Izenda2.default.getText('COMPARISION_DATE_AND_TIME'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '> (' + _Izenda2.default.getText('COMPARISION_DATE_AND_TIME') + ')',
    value: '> (Date & Time)',
    type: COMPARISION_TYPE.DATE_TIME,
    group: _Izenda2.default.getText('COMPARISION_DATE_AND_TIME'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '< (' + _Izenda2.default.getText('COMPARISION_DATE_AND_TIME') + ')',
    value: '< (Date & Time)',
    type: COMPARISION_TYPE.DATE_TIME,
    group: _Izenda2.default.getText('COMPARISION_DATE_AND_TIME'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '>= (' + _Izenda2.default.getText('COMPARISION_DATE_AND_TIME') + ')',
    value: '>= (Date & Time)',
    type: COMPARISION_TYPE.DATE_TIME,
    group: _Izenda2.default.getText('COMPARISION_DATE_AND_TIME'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '<= (' + _Izenda2.default.getText('COMPARISION_DATE_AND_TIME') + ')',
    value: '<= (Date & Time)',
    type: COMPARISION_TYPE.DATE_TIME,
    group: _Izenda2.default.getText('COMPARISION_DATE_AND_TIME'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  },
  // Date
  {
    label: '= (' + _Izenda2.default.getText('COMPARISION_DATE') + ')',
    value: '= (Date)',
    type: COMPARISION_TYPE.DATE,
    group: _Izenda2.default.getText('COMPARISION_DATE'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '<> (' + _Izenda2.default.getText('COMPARISION_DATE') + ')',
    value: '<> (Date)',
    type: COMPARISION_TYPE.DATE,
    group: _Izenda2.default.getText('COMPARISION_DATE'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '> (' + _Izenda2.default.getText('COMPARISION_DATE') + ')',
    value: '> (Date)',
    type: COMPARISION_TYPE.DATE,
    group: _Izenda2.default.getText('COMPARISION_DATE'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '< (' + _Izenda2.default.getText('COMPARISION_DATE') + ')',
    value: '< (Date)',
    type: COMPARISION_TYPE.DATE,
    group: _Izenda2.default.getText('COMPARISION_DATE'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '>= (' + _Izenda2.default.getText('COMPARISION_DATE') + ')',
    value: '>= (Date)',
    type: COMPARISION_TYPE.DATE,
    group: _Izenda2.default.getText('COMPARISION_DATE'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  }, {
    label: '<= (' + _Izenda2.default.getText('COMPARISION_DATE') + ')',
    value: '<= (Date)',
    type: COMPARISION_TYPE.DATE,
    group: _Izenda2.default.getText('COMPARISION_DATE'),
    DATA_TYPES: [DATA_TYPES.DATE_TIME]
  },
  // Time
  {
    label: '= (' + _Izenda2.default.getText('COMPARISION_TIME') + ')',
    value: '= (Time)',
    type: COMPARISION_TYPE.TIME,
    group: _Izenda2.default.getText('COMPARISION_TIME'),
    DATA_TYPES: [DATA_TYPES.TIME]
  }, {
    label: '<> (' + _Izenda2.default.getText('COMPARISION_TIME') + ')',
    value: '<> (Time)',
    type: COMPARISION_TYPE.TIME,
    group: _Izenda2.default.getText('COMPARISION_TIME'),
    DATA_TYPES: [DATA_TYPES.TIME]
  }, {
    label: '> (' + _Izenda2.default.getText('COMPARISION_TIME') + ')',
    value: '> (Time)',
    type: COMPARISION_TYPE.TIME,
    group: _Izenda2.default.getText('COMPARISION_TIME'),
    DATA_TYPES: [DATA_TYPES.TIME]
  }, {
    label: '< (' + _Izenda2.default.getText('COMPARISION_TIME') + ')',
    value: '< (Time)',
    type: COMPARISION_TYPE.TIME,
    group: _Izenda2.default.getText('COMPARISION_TIME'),
    DATA_TYPES: [DATA_TYPES.TIME]
  }, {
    label: '>= (' + _Izenda2.default.getText('COMPARISION_TIME') + ')',
    value: '>= (Time)',
    type: COMPARISION_TYPE.TIME,
    group: _Izenda2.default.getText('COMPARISION_TIME'),
    DATA_TYPES: [DATA_TYPES.TIME]
  }, {
    label: '<= (' + _Izenda2.default.getText('COMPARISION_TIME') + ')',
    value: '<= (Time)',
    type: COMPARISION_TYPE.TIME,
    group: _Izenda2.default.getText('COMPARISION_TIME'),
    DATA_TYPES: [DATA_TYPES.TIME]
  },
  // Boolean
  {
    label: (0, _fp.toUpper)(_Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_TRUE')),
    value: 'TRUE',
    type: COMPARISION_TYPE.NONE,
    group: _Izenda2.default.getText('COMPARISION_BOOLEAN'),
    DATA_TYPES: [DATA_TYPES.BOOLEAN]
  }, {
    label: (0, _fp.toUpper)(_Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_FALSE')),
    value: 'FALSE',
    type: COMPARISION_TYPE.NONE,
    group: _Izenda2.default.getText('COMPARISION_BOOLEAN'),
    DATA_TYPES: [DATA_TYPES.BOOLEAN]
  }],
  COMPARISION_TYPE: COMPARISION_TYPE,
  GENNERAL: {
    MIN_WIDTH: 155,
    FIELD_ITEM: 'FieldItem',
    FILTER_ITEM: 'FilterItem',
    BORDER_HOVER_ITEM: {
      COLOR: '#73AA2C',
      STYLE: 'solid'
    }
  },
  FIELDS: {
    get FILTERS_HEADER_LABEL() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_FIELDS_FILTERS_HEADER');
    },
    get SHOW_FILTERS_LABEL() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_FIELDS_SHOW_FILTERS');
    },
    get ADD_FILTER_LABEL() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_FIELDS_ADD_FILTER');
    },
    get FREEZE_LABEL() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_FIELDS_FREEZE');
    },
    get FILTER_LOGIC_LABEL() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_FIELDS_FILTER_LOGIC');
    },
    get FILTER_LOGIC_PLACEHOLDER() {
      return _Izenda2.default.getText('REPORTDESIGNER_PLACEHOLDER_FIELDS_FILTER_LOGIC');
    },
    get VALIDATE_SYNTAX_LABEL() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_FIELDS_VALIDATE_SYNTAX');
    },
    get VALID_FILTER_LOGIC_MESSAGE() {
      return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_VALID_FILTERLOGIC_STATEMENT');
    },
    get M24() {
      return _Izenda2.default.getText('REPORTDESIGNER_FILTER_FIELDS_TYPE_VALIDATE');
    },
    get M25() {
      return _Izenda2.default.getText('REPORTDESIGNER_FILTER_FIELDS_TYPE_VALIDATE_INFO');
    },
    NUMBER_OF_COLUMN: 4,
    FITLERS_PANEL_UI: {
      minHeight: 105,
      maxHeight: 210
    }
  },
  DATA_SOURCE: {
    FITLERS_PANEL_UI: {
      minHeight: 105,
      maxHeight: 210
    }
  },
  MENU_DEFINITION: [{
    key: 'DataSource',
    icon: 'icon-data-source',
    get title() {
      return _Izenda2.default.getText('COMMON_LABEL_DATA_SOURCE');
    },
    get tooltip() {
      return _Izenda2.default.getText('COMMON_TOOLTIP_DATA_SOURCE');
    },
    hoverShowTooltip: true
  }, {
    key: 'Fields',
    icon: 'icon-design-icon',
    get title() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_MENU_DEF_DESIGN');
    },
    get tooltip() {
      return _Izenda2.default.getText('REPORTDESIGNER_TOOLTIP_MENU_DEF_DESIGN');
    },
    hoverShowTooltip: true
  }, {
    key: 'Formats',
    icon: 'icon-format',
    get title() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_MENU_DEF_FORMAT');
    },
    get tooltip() {
      return _Izenda2.default.getText('REPORTDESIGNER_TOOLTIP_MENU_DEF_FORMAT');
    },
    hoverShowTooltip: true
  }, {
    key: 'Exporting',
    icon: 'icon-export',
    get title() {
      return _Izenda2.default.getText('COMMON_LABEL_EXPORTING');
    },
    licenseKey: _Izenda4.default.LICENSE_KEY.Exporting,
    excludeForMobile: true,
    get tooltip() {
      return _Izenda2.default.getText('COMMON_TOOLTIP_EXPORTING');
    },
    hoverShowTooltip: true
  }, {
    key: 'Schedule',
    icon: 'icon-schedule',
    get title() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_MENU_DEF_SCHEDULE');
    },
    permissions: [_Izenda6.default.PERMISSION_KEY.ReportsActionsSchedule],
    licenseKey: _Izenda4.default.LICENSE_KEY.Scheduling,
    get tooltip() {
      return _Izenda2.default.getText('REPORTDESIGNER_TOOLTIP_MENU_DEF_SCHEDULE');
    },
    hoverShowTooltip: true
  }, {
    key: 'Access',
    icon: 'icon-access',
    get title() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_MENU_DEF_ACCESS');
    },
    permissions: [_Izenda6.default.PERMISSION_KEY.ReportsActionsConfigureAccessRights],
    get tooltip() {
      return _Izenda2.default.getText('REPORTDESIGNER_TOOLTIP_MENU_DEF_ACCESS');
    },
    hoverShowTooltip: true
  }],

  REPORT_NAME: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_REPORT_NAME_REQUIRED');
      }
    }
  },
  CONSTRAINTS: {
    ADVANCED: {
      alias: {
        storeAction: {
          action: 'validateAlias'
        }
      },
      joinDataSourceCategoryId: {
        presence: {
          presence: true,
          get message() {
            return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
          }
        }
      },
      foreignDataSourceCategoryId: {
        presence: {
          presence: true,
          get message() {
            return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
          }
        }
      },
      joinQuerySourceId: {
        presence: {
          presence: true,
          get message() {
            return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
          }
        }
      },
      foreignQuerySourceId: {
        presence: {
          presence: true,
          get message() {
            return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
          }
        }
      },
      joinFieldId: {
        presence: {
          presence: true,
          get message() {
            return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
          }
        }
      },
      foreignFieldId: {
        presence: {
          presence: true,
          get message() {
            return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
          }
        }
      }
    },
    REPORT_NAME: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_REPORT_NAME_REQUIRED');
        }
      },
      format: {
        pattern: VALID_REPORT_NAME_REGEX,
        get message() {
          return _Izenda2.default.getText('INVALID_REPORT_NAME');
        }
      }
    },
    TEMPLATE_NAME: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_TEMPLATE_NAME_REQUIRED');
        }
      },
      format: {
        pattern: VALID_REPORT_NAME_REGEX,
        get message() {
          return _Izenda2.default.getText('INVALID_TEMPLATE_NAME');
        }
      }
    }
  },
  VALIDATION_KEY: 'validationKey',
  JOIN_TYPES: [{
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_JOIN_TYPE_INNER');
    },
    value: 'Inner'
  }, {
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_JOIN_TYPE_LEFT');
    },
    value: 'Left'
  }, {
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_JOIN_TYPE_RIGHT');
    },
    value: 'Right'
  }, {
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_JOIN_TYPE_CROSS');
    },
    value: 'Cross'
  }, {
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_JOIN_TYPE_FULL');
    },
    value: 'Full'
  }],
  SEARCH_ALL: 'all',
  JOIN_TYPE_CROSS: 'Cross',
  OPERATOR_TYPES: [{
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_OPERATOR_TYPE_AND');
    }
  }, {
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_OPERATOR_TYPE_OR');
    }
  }],
  TYPES: REPORT_TYPE,
  GLOBAL_REPORT_ENUM: GLOBAL_REPORT_ENUM,
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  FILTERS_LOGIC: {
    storeAction: {
      action: 'validateFilterSyntax'
    }
  },
  get DELETE_FILTER_MESSAGE() {
    return _Izenda2.default.getText('REPORTDESIGNER_LABEL_DELETE_FILTER');
  },
  get CASCADING_CHANGED_MESSAGE() {
    return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_CASCADING_CHANGED');
  },
  PREVIEW_RECORD: [{ label: '10', value: 10 }, { label: '100', value: 100 }, { label: '1000', value: 1000 }, { label: '10000', value: 10000 }, {
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    },
    value: -1
  }],
  get DEFAULT_REPORT_NAME() {
    return _Izenda2.default.getText('REPORTDESIGNER_LABEL_DEFAULT_REPORT_NAME');
  },
  get DEFAULT_TEMPLATE_NAME() {
    return _Izenda2.default.getText('REPORTDESIGNER_LABEL_DEFAULT_TEMPLATE_NAME');
  },
  DEFAULT_PREVIEW_RECORD: 10,
  DEFAULT_PAGE_INDEX: 1,
  DEFAULT_PAGE_SIZE: 10,
  OBJECT_STATE: {
    NONE: 0,
    INSERT: 1,
    DELETE: 2,
    UPDATE: 3
  },
  getReportSection: function getReportSection(section) {
    switch ((0, _fp.toLower)(section)) {
      case 'all':
        return 0;
      case 'datasource':
        return 1;
      case 'fields':
        return 2;
      default:
        return 0;
    }
  },

  get CANNOT_DELETE_PARAM_SP() {
    return _Izenda2.default.getText('REPORTDESIGNER_LABEL_CANNOT_DELETE_PARAM_SP');
  },
  REQUIRED_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
      }
    }
  },
  DRILL_DOWN_STYLE_OPTION_VALUES: DRILL_DOWN_STYLE_OPTION_VALUES,
  DRIL_DOWN_STYLE_OPTIONS: [{
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_LINK');
    },
    value: DRILL_DOWN_STYLE_OPTION_VALUES.link
  }, {
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_DRILL_DOWN_STYLE_LINK_NEW_WINDOW');
    },
    value: DRILL_DOWN_STYLE_OPTION_VALUES.linknewwindow
  }, {
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_DRILL_DOWN_STYLE_EMBEDDED');
    },
    value: DRILL_DOWN_STYLE_OPTION_VALUES.embedded
  }, {
    get label() {
      return _Izenda2.default.getText('REPORTDESIGNER_LABEL_DRILL_DOWN_STYLE_POPUP');
    },
    value: DRILL_DOWN_STYLE_OPTION_VALUES.popup
  }],
  DRIL_DOWN_STYLE: {
    LINK: 'link',
    LINK_NEW_WINDOW: 'linknewwindow',
    EMBEDDED: 'embedded',
    POPUP: 'popup'
  },
  PAGE_NAME: {
    DATA_SOURCE: 'DataSource',
    FIELDS: 'Fields',
    FORMATS: 'Formats',
    EXPORTING: 'Exporting',
    SCHEDULE: 'Schedule',
    ACCESS: 'Access'
  },
  DATETIME_FORMAT: 'MM/DD/YYYY HH:mm',
  SIMPLE_DATETIME_FORMAT: 'MM/DD/YYYY',
  EXPRESSION_SELECTION: {
    MIDDLE_FIELD: {
      FIELD_NAME: {
        enableDataSource: true,
        returnedFieldNameFormat: '[{0}].[{1}].[{2}].[{3}]',
        returnedOnlyFieldNameFormat: '[{0}]'
      }
    },
    REPORT_PART: {
      FIELD_NAME: {
        enableDataSource: true,
        returnedFieldNameFormat: '[{0}].[{1}].[{2}].[{3}]',
        returnedOnlyFieldNameFormat: '[{0}]',
        subOrGrandTotal: true
      }
    }
  },
  DETECT_CHANGE: {
    PHYSICAL: 'physical',
    LOGICAL: 'logical'
  },
  REPORT_PART_TYPE: {
    Chart: '0',
    Form: '1',
    Gauge: '2',
    Grid: '3',
    Map: '4'
  },
  JOIN_TYPE: JOIN_TYPES,
  DATA_TYPES: DATA_TYPES,
  REPORT_TYPE_ENUM: REPORT_TYPE_ENUM,

  EXPANDED_LEVEL: {
    ALL: -1,
    FIRST_LEVEL: 0
  },
  DEFAULT_VALUE_PROPERTIES: {
    HEADERS: {
      BACKGROUND_COLOR: '#E4E4E4'
    }
  },
  HINT_MESSAGE: {
    get CATEGORY() {
      return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_HINT_CATEGORY');
    },
    get SUB_CATEGORY() {
      return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_HINT_SUB_CATEGORY');
    }
  },
  REPORT_PART_PERMISSIONS: [{
    value: 0,
    permissions: [_Izenda6.default.PERMISSION_KEY.ReportsReportPartTypesChart]
  }, {
    value: 1,
    permissions: [_Izenda6.default.PERMISSION_KEY.ReportsReportPartTypesForm]
  }, {
    value: 2,
    permissions: [_Izenda6.default.PERMISSION_KEY.ReportsReportPartTypesGauge]
  }, {
    value: 4,
    permissions: [_Izenda6.default.PERMISSION_KEY.ReportsReportPartTypesMap]
  }],

  FIELD_TYPE: {
    AggregatedField: 'Aggregated Field'
  },

  EDITOR_CONFIG: {
    ReportPart: [{
      name: 'reportPartProps'
    }]
  },
  CALCULATED_FIELD_NAME: 'Calculated Fields',
  REPORT_DESIGNER_TAB: ['DataSource', 'Fields', 'Formats', 'Exporting', 'Schedule', 'Access'],
  ERROR_KEY: {
    reportPart: 'reportPart',
    calculatedfield: 'calculatedfield',
    filter: 'filter',
    relationship: 'relationship'
  },
  MENU_ACTIVE_LINK: 'Fields',
  MENU_DATASOURCE_LINK: 'DataSource',
  REPORT_STATE: {
    POSTED: 0,
    SAVED: 1,
    DRAFT: 2
  },
  DATA_SOURCE_CONCAT_TREE_MAP: dataSourceConcatTreeMap(),
  DATA_SOURCE_TREE_MAP: [{
    prop: 'category',
    expand: true,
    nodeType: 'Category',
    children: dataSourceConcatTreeMap()
  }],
  DATA_SOURCE_TREE_MAP_FOR_SEARCH: [{
    prop: 'category',
    expand: true,
    nodeType: 'Category',
    children: dataSourceConcatTreeMap(true)
  }],
  LAZY_LOADING_DATA_SOURCE_TREE_ITEMS: 50,
  VALID_REPORT_NAME_REGEX: VALID_REPORT_NAME_REGEX,
  MESSAGE_KEY: {
    DISTINCT: 'Distinct',
    CONCURRENCY: 'Concurrency'
  },
  FILTER_CHANGE_STATE: {
    ADDED: '1',
    UPDATED: '3'
  }
};
module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.Input.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * Input Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isNil = __webpack_require__(855);

var _isNil2 = _interopRequireDefault(_isNil);

var _omit = __webpack_require__(1626);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call.apply(_ref, [this].concat(args))), _this), _this.setRef = function (dom) {
      _this.input = dom;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * initial properties
   */


  (0, _createClass3.default)(Input, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkIndeterminate(this.props.indeterminate);
      this.props.shouldFocus && this.input.focus();
    }

    /**
     * Set refs for component
     * @param {Object} dom object
     */

  }, {
    key: 'checkIndeterminate',


    /**
     * Check indeterminate
     * @param {Boolean} indeterminate
     */
    value: function checkIndeterminate(indeterminate) {
      if (indeterminate) {
        this.input.indeterminate = true;
      } else {
        this.input.indeterminate = false;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.checkIndeterminate(this.props.indeterminate);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;

      var displayValue = !(0, _isNil2.default)(props.value) ? props.value : '';
      var value = props.isMasked ? '●●●●●●●●●●●●' : displayValue;
      var className = props.className;
      var isCheckBox = props.type === 'checkbox' || props.type === 'radio';
      if (className === 'form-control' && isCheckBox) {
        className = '';
      }
      var rest = (0, _omit2.default)(['containerClassName', 'className', 'value', 'indeterminate', 'isMasked', 'validateInfo', 'checked', 'validation', 'shouldFocus'], props);

      // Omit maxLength props when maxLength = 'MAX'
      if (props.maxLength === 'MAX') {
        rest = (0, _omit2.default)(['maxLength'], rest);
      }

      return isCheckBox ? _react2.default.createElement('input', (0, _extends3.default)({ className: className, checked: props.checked }, rest, { ref: this.setRef })) : _react2.default.createElement('input', (0, _extends3.default)({ className: className, value: value }, rest, { ref: this.setRef }));
    }
  }]);
  return Input;
}(_react.Component), _class.displayName = 'Input', _class.propTypes = {
  indeterminate: _propTypes2.default.bool, // Specific for the three state of input control
  isMasked: _propTypes2.default.bool,
  shouldFocus: _propTypes2.default.bool
}, _class.defaultProps = {
  containerClassName: 'col-md-10',
  className: 'form-control',
  name: '',
  type: 'text',
  value: '',
  onChange: undefined,
  onFocus: undefined,
  onKeyPress: undefined,
  disabled: false,
  isMasked: false,
  maxLength: 256
}, _temp2);
exports.default = Input;
module.exports = exports['default'];

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Validator.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  __webpack_require__(55);
  var React = __webpack_require__(0);
  var m = __webpack_require__(5);
  var TooltipUtils = __webpack_require__(854);

  var classnames = __webpack_require__(11);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      get = _require.get,
      isArray = _require.isArray,
      join = _require.join,
      omit = _require.omit,
      assign = _require.assign,
      isEmpty = _require.isEmpty,
      filter = _require.filter,
      flow = _require.flow,
      map = _require.map;

  /**
   * Return whether the validator state has changed
   * @param  {Object}  currState Current validator state
   * @param  {Object}  prevState Previous validator state
   */


  function isValidationStateChanged(currState, prevState) {
    return currState.isPristine !== prevState.isPristine || currState.error !== prevState.error || currState.messages.length !== prevState.messages.length || currState.messages[0] !== prevState.messages[0];
  }

  /**
   * A React higher order compoment that enhances the validation to target component
   * @param  {Object}  options
   * @return {Function}       A function that accept a target component.
   */
  function Validator(options) {
    return function (EditComponent) {
      var ValidatableEditor = React.createClass({
        hasTooltip: false,
        displayName: 'Validator(' + EditComponent.displayName + ')',
        contextTypes: {
          validation: React.PropTypes.object.isRequired
        },
        propTypes: {
          field: React.PropTypes.string.isRequired,
          validations: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object]),
          group: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
          onValidated: React.PropTypes.func,
          onReset: React.PropTypes.func,
          shouldInjectStateToChildren: React.PropTypes.bool
        },
        getDefaultProps: function getDefaultProps() {
          return {
            field: 'ValidatableEditor',
            shouldInjectStateToChildren: false,
            tooltipPosition: get('tooltipPosition', options) || 'top'
          };
        },
        getInitialState: function getInitialState() {
          return {
            isPristine: true, // Indicate fresh state without change and unvalidated.
            isUnvalidatedChange: false, // Indicate value has been changed but unvalidated
            error: false, // Indicate validated failed
            messages: [] // Validation error messages
          };
        },

        componentDidMount: function componentDidMount() {
          this.context.validation.attachComponent(this);

          var title = this.state.messages[0];
          if (isArray(this.state.messages[0]) && this.state.messages[0].length > 1) {
            title = flow(map(function (m) {
              return '- ' + m;
            }), join('\n'))(this.state.messages[0]);
          }

          var tooltipOption = {
            title: title,
            trigger: 'hover',
            placement: 'auto ' + this.props.tooltipPosition,
            template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow bg-errors"></div><div class="tooltip-inner bg-errors"></div></div>'
          };
          TooltipUtils.initTooltip(this.refs.editor, tooltipOption);
          TooltipUtils.disableTooltip(this.refs.editor);
        },

        componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
          if (isValidationStateChanged(this.state, prevState)) {
            if (!this.state.isPristine && this.state.error) {
              var title = this.state.messages[0];
              if (isArray(this.state.messages[0]) && this.state.messages[0].length > 1) {
                title = flow(map(function (mess) {
                  return '- ' + mess;
                }), join('\n'))(this.state.messages[0]);
              }
              TooltipUtils.updateTooltip(this.refs.editor, title);
            } else {
              TooltipUtils.disableTooltip(this.refs.editor);
            }
          }
        },

        componentWillUnmount: function componentWillUnmount() {
          this.context.validation.detachComponent(this);
          TooltipUtils.destroyTooltip(this.refs.editor);
        },

        render: function render() {
          var onChange = this.props.onChange;
          var shouldInjectStateToChildren = this.props.shouldInjectStateToChildren;

          var wrappedOnChange = function () {
            !this.state.isPristine && this.setUnvalidatedChange();
            if (onChange) {
              return onChange.apply(null, arguments);
            }
            return null;
          }.bind(this);

          var rest = omit(['field', 'group', 'validations', 'className', 'onChange', 'onValidated', 'onReset', 'shouldInjectStateToChildren', 'tooltipPosition'], this.props);

          if (shouldInjectStateToChildren) {
            rest = assign({
              validateInfo: this.state
            }, rest);
          }

          var classes = classnames(this.props.className, 'validator ', {
            unvalidated: !this.state.isPristine && this.state.isUnvalidatedChange,
            errors: !this.state.isPristine && !this.state.isUnvalidatedChange && this.state.error,
            success: !this.state.isPristine && !this.state.isUnvalidatedChange && !this.state.error
          });

          var key = this.context.validation.getKey(this);

          return React.createElement(
            'div',
            { ref: 'container', id: String.hashKeyId(key), className: this.props.containerClassName },
            React.createElement(EditComponent, (0, _extends3.default)({
              className: classes
            }, rest, {
              onChange: wrappedOnChange,
              ref: 'editor',
              'data-toggle': 'tooltip'
            }))
          );
        },

        /**
         * Get component value that will be used to validate
         */
        getValue: function getValue() {
          return options && options.getValue ? options.getValue(this.refs.editor) : this.refs.editor.props.value;
        },

        /**
         * Set pristine state of validator. By calling this, the validator
         * will reset its state.
         */
        setPristine: function setPristine() {
          this.props.onReset && this.props.onReset();
          this.isMounted() && this.setState({
            isPristine: true,
            isUnvalidatedChange: false,
            error: false,
            messages: []
          });
        },

        /**
         * Set error state including its error messages. The validator will show
         * error indicator and error messages.
         */
        setError: function setError(msgs) {
          this.props.onValidated && this.props.onValidated(false);
          this.isMounted() && this.setState({
            isPristine: false,
            isUnvalidatedChange: false,
            error: true,
            messages: this.getErrorMessages(m.toJS(msgs))
          });
        },

        /**
         * Get messages from list errors
         */
        getErrorMessages: function getErrorMessages(errorObject) {
          var result = [];

          var clientErrorMessages = filter(function (o) {
            return typeof o === 'string';
          }, errorObject);
          if (clientErrorMessages.length > 0) return clientErrorMessages;

          errorObject.map(function (error) {
            error.messages && result.push(error.messages);
          });
          return isEmpty(result) ? null : result;
        },

        /**
         * Set success state. The validator will show success indicator.
         */
        setSuccess: function setSuccess() {
          this.props.onValidated && this.props.onValidated(true);
          this.isMounted() && this.setState({
            isPristine: false,
            isUnvalidatedChange: false,
            error: false,
            messages: []
          });
        },
        /**
         * Set unvalidated changed state
         */
        setUnvalidatedChange: function setUnvalidatedChange() {
          this.isMounted() && this.setState({
            isPristine: false,
            isUnvalidatedChange: true,
            error: false,
            messages: []
          });
        }
      });
      return observer(ValidatableEditor);
    };
  }

  module.exports = Validator;
}();

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EventUtils.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      get = _require.get,
      isFunction = _require.isFunction;

  module.exports = {
    INPUT: 'target.value',
    DROPDOWN: 'value',
    CHECKBOX: 'target.checked',
    RADIO: 'target.checked',
    INPUT_BY_TYPE: 'value',

    notifyChange: function notifyChange(func, paramPath) {
      return function (arg1, arg2) {
        var value = paramPath ? get(paramPath, arg1) : arg1;
        return isFunction(func) && func(value, arg2);
      };
    },

    notify: function notify(func) {
      return function () {
        return isFunction(func) && func();
      };
    }
  };
}();

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ScrollBox.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(208);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _raf2 = __webpack_require__(296);

var _raf3 = _interopRequireDefault(_raf2);

var _tween = __webpack_require__(1416);

var _tween2 = _interopRequireDefault(_tween);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _style = __webpack_require__(168);

var _style2 = _interopRequireDefault(_style);

var _fastdom = __webpack_require__(486);

var _fastdom2 = _interopRequireDefault(_fastdom);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUMBER_ZERO = 0;
var NUMBER_TWO = 2;
var NUMBER_DEBOUNCE = 250;
var NUMBER_DETECT_SCROLLING = 100;
var NUMBER_TWEEN = 400;

var eventOptions = {
  capture: false,
  passive: true
};
var scrollbarWidth = void 0;

var TRACK_MIN_SIZE = 20;
var HORIZONTAL_TRACK_HEIGHT = 10;
var TRACK_PADDING = 2;

var ScrollBox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ScrollBox, _Component);

  function ScrollBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ScrollBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScrollBox.__proto__ || (0, _getPrototypeOf2.default)(ScrollBox)).call.apply(_ref, [this].concat(args))), _this), _this.handleScroll = function (event) {
      if (_this.props.isDisabled || _this.props.fullSize) {
        return;
      }
      _this.triggerOnScrollEvent && _this.props.onScroll && _this.props.onScroll(event);
      _this.triggerOnScrollEvent = true;

      _this.update(updateViewScrollPosition.bind(_this));
      _this.detectScrolling();

      function updateViewScrollPosition(values) {
        this.viewScrollLeft = values.scrollLeft;
        this.viewScrollTop = values.scrollTop;
      }
    }, _this.handelViewMouseEnter = function (event) {
      if (_this.targetInChildScrollbox(event)) {
        _this.handelViewMouseLeave();
        return;
      }

      _this.mouseEnterTimeout && clearTimeout(_this.mouseEnterTimeout);

      _this.mouseEnterTimeout = setTimeout(function () {
        _this.update();
        _this.handleScrollStartAutoHide();
      }, _this.props.showTrackTimeout);
    }, _this.handelViewMouseLeave = function () {
      _this.mouseLeaveTimeout && clearTimeout(_this.mouseLeaveTimeout);
      _this.mouseLeaveTimeout = setTimeout(function () {
        _this.handleScrollStopAutoHide();
      }, _this.props.showTrackTimeout);
    }, _this.handleHorizontalTrackMouseDown = function (event) {
      if (_this.props.fullSize) return;

      var view = _this.refs.view;
      var target = event.target;
      var clientX = event.clientX;
      var targetLeft = target.getBoundingClientRect().left;
      var thumbWidth = _this.getThumbHorizontalWidth();
      var offset = Math.abs(targetLeft - clientX) - thumbWidth / NUMBER_TWO;

      view.scrollLeft = _this.getScrollLeftForOffset(offset);
    }, _this.handleVerticalTrackMouseDown = function (event) {
      if (_this.props.fullSize) return;

      var view = _this.refs.view;
      var target = event.target;
      var clientY = event.clientY;
      var targetTop = target.getBoundingClientRect().top;
      var thumbHeight = _this.getThumbVerticalHeight();
      var offset = Math.abs(targetTop - clientY) - thumbHeight / NUMBER_TWO;

      view.scrollTop = _this.getScrollTopForOffset(offset);
    }, _this.handleHorizontalThumbMouseDown = function (event) {
      if (_this.props.fullSize) return;

      var target = event.target;
      var clientX = event.clientX;
      var offsetWidth = target.offsetWidth;
      var left = target.getBoundingClientRect().left;
      _this.handleDragStart(event);
      _this.prevPageX = offsetWidth - (clientX - left);
    }, _this.handleVerticalThumbMouseDown = function (event) {
      if (_this.props.fullSize) return;

      var target = event.target;
      var clientY = event.clientY;
      var offsetHeight = target.offsetHeight;
      var top = target.getBoundingClientRect().top;
      _this.handleDragStart(event);
      _this.prevPageY = offsetHeight - (clientY - top);
    }, _this.handleDragStart = function (event) {
      _this.dragging = true;
      event.stopImmediatePropagation();
      _this.setupDragging();
    }, _this.handleDrag = function (event) {
      var clientX = event.clientX;
      var clientY = event.clientY;
      var view = _this.refs.view;
      var trackHorizontal = void 0;
      var thumbWidth = void 0;
      var trackVertical = void 0;
      var thumbHeight = void 0;
      var trackTop = void 0;
      var clickPosition = void 0;
      var offset = void 0;
      var trackLeft = void 0;
      if (_this.prevPageX) {
        trackHorizontal = _this.refs.trackHorizontal;
        trackLeft = trackHorizontal.getBoundingClientRect().left;
        thumbWidth = _this.getThumbHorizontalWidth();
        clickPosition = thumbWidth - _this.prevPageX;
        offset = -trackLeft + clientX - clickPosition;
        view.scrollLeft = _this.getScrollLeftForOffset(offset);
      }
      if (_this.prevPageY) {
        trackVertical = _this.refs.trackVertical;
        trackTop = trackVertical.getBoundingClientRect().top;
        thumbHeight = _this.getThumbVerticalHeight();
        clickPosition = thumbHeight - _this.prevPageY;
        offset = -trackTop + clientY - clickPosition;
        view.scrollTop = _this.getScrollTopForOffset(offset);
      }
      return false;
    }, _this.handleDragEnd = function () {
      _this.dragging = false;
      _this.prevPageX = _this.prevPageY = 0;
      _this.teardownDragging();
      _this.handleDragEndAutoHide();
    }, _this.handleTrackMouseEnter = function (event) {
      if (_this.targetInChildScrollbox(event)) {
        _this.handelViewMouseLeave();
        return;
      }

      if (!_this.props.fullSize) {
        _this.trackMouseOver = true;
        _this.handleTrackMouseEnterAutoHide();
      }
    }, _this.handleTrackMouseLeave = function () {
      if (!_this.props.fullSize) {
        _this.trackMouseOver = false;
        _this.handleTrackMouseLeaveAutoHide();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ScrollBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
      this.update();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.onUpdate && this.props.onUpdate();
      this.update();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
      _fastdom2.default.clear(this.fastdomMeasure);
      _fastdom2.default.clear(this.fastdomMutate);
      this.hideTracksTimeout && clearTimeout(this.hideTracksTimeout);
      this.mouseEnterTimeout && clearTimeout(this.mouseEnterTimeout);
      this.mouseLeaveTimeout && clearTimeout(this.mouseLeaveTimeout);
      !(0, _fp.isNil)(this.detectScrollingInterval) && clearInterval(this.detectScrollingInterval);
    }

    /**
     * Get scroll left possition
     */

  }, {
    key: 'getScrollLeft',
    value: function getScrollLeft() {
      return this.refs.view && this.refs.view.scrollLeft;
    }

    /**
     * Get scroll top px
     */

  }, {
    key: 'getScrollTop',
    value: function getScrollTop() {
      return this.refs.view && this.refs.view.scrollTop;
    }

    /**
     * Get scroll width px
     */

  }, {
    key: 'getScrollWidth',
    value: function getScrollWidth() {
      return this.refs.view && this.refs.view.scrollWidth;
    }

    /**
     * Get scroll height px
     */

  }, {
    key: 'getScrollHeight',
    value: function getScrollHeight() {
      return this.refs.view && this.refs.view.scrollHeight;
    }

    /**
     * Get the client viewport width
     */

  }, {
    key: 'getClientWidth',
    value: function getClientWidth() {
      return this.refs.view && this.refs.view.clientWidth;
    }

    /**
     * Get the client viewport height
     */

  }, {
    key: 'getClientHeight',
    value: function getClientHeight() {
      return this.refs.view && this.refs.view.clientHeight;
    }

    /**
     * Get the view possition and dimmension
     */

  }, {
    key: 'getValues',
    value: function getValues() {
      var view = this.refs.view;
      return view ? {
        left: view.scrollLeft / (view.scrollWidth - view.clientWidth) || NUMBER_ZERO,
        top: view.scrollTop / (view.scrollHeight - view.clientHeight) || NUMBER_ZERO,
        scrollLeft: view.scrollLeft,
        scrollTop: view.scrollTop,
        scrollWidth: view.scrollWidth,
        scrollHeight: view.scrollHeight,
        clientWidth: view.clientWidth,
        clientHeight: view.clientHeight
      } : undefined;
    }

    /**
     * Get horizontal thumb width
     */

  }, {
    key: 'getThumbHorizontalWidth',
    value: function getThumbHorizontalWidth() {
      var view = this.refs.view;
      var trackWidth = getInnerWidth(this.refs.trackHorizontal);
      var width = view.clientWidth / view.scrollWidth * trackWidth;
      return trackWidth === width ? NUMBER_ZERO : Math.max(width, TRACK_MIN_SIZE);
    }

    /**
     * Get vertical thumb width
     */

  }, {
    key: 'getThumbVerticalHeight',
    value: function getThumbVerticalHeight() {
      var view = this.refs.view;
      var trackHeight = getInnerHeight(this.refs.trackVertical);
      var height = view.clientHeight / view.scrollHeight * trackHeight;
      return trackHeight === height ? NUMBER_ZERO : Math.max(height, TRACK_MIN_SIZE);
    }
  }, {
    key: 'getScrollLeftForOffset',
    value: function getScrollLeftForOffset(offset) {
      var view = this.refs.view;
      var trackWidth = getInnerWidth(this.refs.trackHorizontal);
      var thumbWidth = this.getThumbHorizontalWidth();
      return offset / (trackWidth - thumbWidth) * (view.scrollWidth - view.clientWidth);
    }
  }, {
    key: 'getScrollTopForOffset',
    value: function getScrollTopForOffset(offset) {
      var view = this.refs.view;
      var trackHeight = getInnerHeight(this.refs.trackVertical);
      var thumbHeight = this.getThumbVerticalHeight();
      return offset / (trackHeight - thumbHeight) * (view.scrollHeight - view.clientHeight);
    }
  }, {
    key: 'scrollVertical',
    value: function scrollVertical(position, withoutAnimate) {
      if (this.refs.view) {
        var view = this.refs.view;

        var start = { scrollTop: view.scrollTop };
        var end = { scrollTop: position };
        var onUpdate = function onUpdate() {
          view.scrollTop = position;
        };
        if (withoutAnimate) {
          onUpdate();
        } else {
          tween(start, end, onUpdate);
        }
      }
    }
  }, {
    key: 'isInsideOfViewport',
    value: function isInsideOfViewport() {
      if (this.refs.view && this.props.stickyScrollBottom) {
        var top = this.refs.view.getBoundingClientRect().top;
        return top + this.props.stickyScrollBottom + HORIZONTAL_TRACK_HEIGHT <= window.innerHeight;
      }
      return false;
    }
  }, {
    key: 'stickHorizontalScroll',
    value: function stickHorizontalScroll() {
      var _this2 = this;

      if (this.refs.trackHorizontal && this.refs.view) {
        var width = this.getClientWidth();
        var left = this.refs.view.getBoundingClientRect().left;
        var trackHorizontalStyle = this.refs.trackHorizontal.style;
        _fastdom2.default.mutate(function () {
          trackHorizontalStyle.position = 'fixed';
          trackHorizontalStyle.bottom = _this2.props.stickyScrollBottom + TRACK_PADDING + 'px';
          trackHorizontalStyle.left = left + TRACK_PADDING + 'px';
          trackHorizontalStyle.width = width - (HORIZONTAL_TRACK_HEIGHT + TRACK_PADDING) + 'px';
        });
      }
    }
  }, {
    key: 'unstickHorizontalScroll',
    value: function unstickHorizontalScroll() {
      if (this.refs.trackHorizontal) {
        var trackHorizontalStyle = this.refs.trackHorizontal.style;
        _fastdom2.default.mutate(function () {
          trackHorizontalStyle.position = '';
          trackHorizontalStyle.bottom = '';
          trackHorizontalStyle.left = '';
          trackHorizontalStyle.width = '';
        });
      }
    }
  }, {
    key: 'getTrackHeight',
    value: function getTrackHeight() {
      return HORIZONTAL_TRACK_HEIGHT;
    }
  }, {
    key: 'scrollHorizontal',
    value: function scrollHorizontal(position) {
      if (this.refs.view) {
        var view = this.refs.view;
        var start = { scrollLeft: view.scrollLeft };
        var end = { scrollLeft: position };
        var onUpdate = function onUpdate() {
          view.scrollLeft = position;
        };
        tween(start, end, onUpdate);
      }
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(position) {
      var _this3 = this;

      if (this.refs.view) {
        var view = this.refs.view;
        var start = { scrollLeft: view.scrollLeft, scrollTop: view.scrollTop };
        var end = { scrollLeft: position.left, scrollTop: position.top };

        var changeTriggerOnScrollEventValue = function changeTriggerOnScrollEventValue() {
          _this3.triggerOnScrollEvent = _this3.props.triggerOnScrollWhenScrollTo;
        };

        var onUpdate = function onUpdate() {
          view.scrollLeft = this.scrollLeft;
          view.scrollTop = this.scrollTop;
          changeTriggerOnScrollEventValue();
        };
        tween(start, end, onUpdate);
      }
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      var scrollbox = this;
      var view = this.refs.view;
      var trackHorizontal = this.refs.trackHorizontal;
      var trackVertical = this.refs.trackVertical;
      var thumbHorizontal = this.refs.thumbHorizontal;
      var thumbVertical = this.refs.thumbVertical;

      if (typeof document === 'undefined') {
        return;
      }

      view.addEventListener('scroll', this.handleScroll, eventOptions);

      // Show tracks when hover
      if (this.props.showWhenHover) {
        view.addEventListener('mouseover', this.handelViewMouseEnter, eventOptions);
        view.addEventListener('mouseleave', this.handelViewMouseLeave, eventOptions);
      }

      if (!getScrollbarWidth()) return;
      trackHorizontal.addEventListener('mouseover', this.handleTrackMouseEnter, eventOptions);
      trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave, eventOptions);
      trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown, eventOptions);
      trackVertical.addEventListener('mouseover', this.handleTrackMouseEnter, eventOptions);
      trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave, eventOptions);
      trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown, eventOptions);
      thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown, eventOptions);
      thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown, eventOptions);

      this.debouncedResize = (0, _fp.debounce)(NUMBER_DEBOUNCE, function () {
        scrollbox.handleWindowResize();
      });

      _Izenda2.default.listenTo(view, this.debouncedResize);
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      var view = this.refs.view;
      var trackHorizontal = this.refs.trackHorizontal;
      var trackVertical = this.refs.trackVertical;
      var thumbHorizontal = this.refs.thumbHorizontal;
      var thumbVertical = this.refs.thumbVertical;

      if (typeof document === 'undefined') {
        return;
      }

      view.removeEventListener('scroll', this.handleScroll, eventOptions);

      if (!getScrollbarWidth()) {
        return;
      }

      if (this.props.showWhenHover) {
        view.removeEventListener('mouseover', this.handelViewMouseEnter, eventOptions);
        view.removeEventListener('mouseleave', this.handelViewMouseLeave, eventOptions);
      }

      trackHorizontal.removeEventListener('mouseover', this.handleTrackMouseEnter, eventOptions);
      trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave, eventOptions);
      trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown, eventOptions);
      trackVertical.removeEventListener('mouseover', this.handleTrackMouseEnter, eventOptions);
      trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave, eventOptions);
      trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown, eventOptions);
      thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown, eventOptions);
      thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown, eventOptions);
      _Izenda2.default.removeAllListeners(view);

      this.teardownDragging();
    }
  }, {
    key: 'targetInChildScrollbox',

    /**
     * Check if the mouseover target is in child scrollbox of View
     * Only show the child scroll , hide the parent scroll
     */
    value: function targetInChildScrollbox(event) {
      var view = this.refs.view;
      var childScrollboxes = $izenda(view).find('.izenda-ScrollBox');

      return !!(0, _fp.some)(function (scrollbox) {
        return $izenda.contains(scrollbox, event.target);
      }, childScrollboxes);
    }
  }, {
    key: 'handleScrollStart',
    value: function handleScrollStart() {
      if (this.props.fullSize) return;

      this.props.onScrollStart && this.props.onScrollStart();
      this.handleScrollStartAutoHide();
    }
  }, {
    key: 'handleScrollStartAutoHide',
    value: function handleScrollStartAutoHide() {
      if (this.props.fullSize || !this.props.autoHide) return;

      this.showTracks();
    }
  }, {
    key: 'handleScrollStop',
    value: function handleScrollStop() {
      if (this.props.fullSize) return;

      this.props.onScrollStop && this.props.onScrollStop();
      this.handleScrollStopAutoHide();
    }
  }, {
    key: 'handleScrollStopAutoHide',
    value: function handleScrollStopAutoHide() {
      if (this.props.fullSize || !this.props.autoHide) return;

      this.hideTracks();
    }
  }, {
    key: 'handleWindowResize',
    value: function handleWindowResize() {
      this.update();
    }
  }, {
    key: 'setupDragging',
    value: function setupDragging() {
      document.addEventListener('mousemove', this.handleDrag);
      document.addEventListener('mouseup', this.handleDragEnd);
      document.onselectstart = function () {
        return false;
      };
    }
  }, {
    key: 'teardownDragging',
    value: function teardownDragging() {
      document.removeEventListener('mousemove', this.handleDrag);
      document.removeEventListener('mouseup', this.handleDragEnd);
      document.onselectstart = undefined;
    }
  }, {
    key: 'handleDragEndAutoHide',
    value: function handleDragEndAutoHide() {
      this.props.autoHide && this.hideTracks();
    }
  }, {
    key: 'handleTrackMouseEnterAutoHide',
    value: function handleTrackMouseEnterAutoHide() {
      this.props.autoHide && this.showTracks();
    }
  }, {
    key: 'handleTrackMouseLeaveAutoHide',
    value: function handleTrackMouseLeaveAutoHide() {
      this.props.autoHide && this.hideTracks();
    }
  }, {
    key: 'showTracks',
    value: function showTracks() {
      var _this4 = this;

      var fullHeight = this.props.fullHeight;
      var fullWidth = this.props.fullWidth;

      this.hideTracksTimeout && clearTimeout(this.hideTracksTimeout);
      this.hideTracksTimeout = null;
      _fastdom2.default.mutate(function () {
        if (_this4.refs.trackHorizontal && !fullWidth) {
          _this4.refs.trackHorizontal.style.opacity = 1;
          _this4.refs.trackHorizontal.style.visibility = 'visible';
        }
        if (_this4.refs.trackVertical && !fullHeight) {
          _this4.refs.trackVertical.style.opacity = 1;
          _this4.refs.trackVertical.style.visibility = 'visible';
        }
      });
    }
  }, {
    key: 'hideTracks',
    value: function hideTracks() {
      var _this5 = this;

      var alwaysShowHorizontalScroll = this.props.alwaysShowHorizontalScroll;
      var alwaysShowVerticalScroll = this.props.alwaysShowVerticalScroll;
      if (this.dragging || this.scrolling || this.trackMouseOver) {
        return;
      }

      this.hideTracksTimeout && clearTimeout(this.hideTracksTimeout);
      this.hideTracksTimeout = setTimeout(function () {
        _fastdom2.default.mutate(function () {
          if (_this5.refs.trackHorizontal && _this5.refs.trackVertical) {
            // Never hide sticky horizontal scroll
            if (!alwaysShowHorizontalScroll) {
              _this5.refs.trackHorizontal.style.visibility = 'hidden';
              _this5.refs.trackHorizontal.style.opacity = 0;
            }
            if (!alwaysShowVerticalScroll) {
              _this5.refs.trackVertical.style.opacity = 0;
              _this5.refs.trackVertical.style.visibility = 'hidden';
            }
          }
        });
      }, this.props.autoHideTimeout);
    }
  }, {
    key: 'detectScrolling',
    value: function detectScrolling() {
      var _this6 = this;

      var scrollbox = this;
      if (this.scrolling) {
        return;
      }
      this.scrolling = true;
      this.handleScrollStart();
      this.detectScrollingInterval = setInterval(function () {
        if (scrollbox.lastViewScrollLeft === scrollbox.viewScrollLeft && scrollbox.lastViewScrollTop === scrollbox.viewScrollTop) {
          !(0, _fp.isNil)(_this6.detectScrollingInterval) && clearInterval(_this6.detectScrollingInterval);
          scrollbox.scrolling = false;
          scrollbox.handleScrollStop();
        }
        scrollbox.lastViewScrollLeft = scrollbox.viewScrollLeft;
        scrollbox.lastViewScrollTop = scrollbox.viewScrollTop;
      }, NUMBER_DETECT_SCROLLING);
    }
  }, {
    key: 'raf',
    value: function raf(callback) {
      var _this7 = this;

      if (this.requestFrame) {
        _raf3.default.cancel(this.requestFrame);
      }

      this.requestFrame = (0, _raf3.default)(function () {
        _this7.requestFrame = undefined;
        callback();
      });
    }
  }, {
    key: 'update',
    value: function update(callback) {
      var _this8 = this;

      if (this.props.fullSize) {
        return;
      }

      this.raf(function () {
        _this8._update(callback);
      });
    }
  }, {
    key: '_update',
    value: function _update(callback) {
      var _this9 = this;

      this.props.onUpdate && this.props.onUpdate();
      var autoHeight = this.props.autoHeight;
      var fullWidth = this.props.fullWidth;
      var fullHeight = this.props.fullHeight;
      var thumbHorizontal = void 0;
      var thumbVertical = void 0;
      var trackHorizontal = void 0;
      var trackVertical = void 0;
      var trackHorizontalWidth = void 0;
      var thumbHorizontalWidth = void 0;
      var thumbHorizontalX = void 0;
      var thumbHorizontalStyle = void 0;
      var trackVerticalHeight = void 0;
      var thumbVerticalHeight = void 0;
      var thumbVerticalY = void 0;
      var thumbVerticalStyle = void 0;
      var trackHorizontalClass = void 0;
      var trackVerticalClass = void 0;

      var values = this.getValues();
      if (values && getScrollbarWidth()) {
        thumbHorizontal = this.refs.thumbHorizontal;
        thumbVertical = this.refs.thumbVertical;
        trackHorizontal = this.refs.trackHorizontal;
        trackVertical = this.refs.trackVertical;

        // Use fastdom to async/batch measure DOM to avoid layout thrashing.
        _fastdom2.default.clear(this.fastdomMeasure);
        this.fastdomMeasure = _fastdom2.default.measure(function () {
          trackHorizontalWidth = getInnerWidth(trackHorizontal);
          thumbHorizontalWidth = _this9.getThumbHorizontalWidth();
          thumbHorizontalX = values.scrollLeft / (values.scrollWidth - values.clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);

          thumbHorizontalStyle = {
            width: thumbHorizontalWidth + 'px',
            transform: 'translateX(' + thumbHorizontalX + 'px)',
            msTransform: 'translateX(' + thumbHorizontalX + 'px)',
            WebkitTransform: 'translateX(' + thumbHorizontalX + 'px)'
          };

          // const { scrollTop, clientHeight, scrollHeight } = values;
          trackVerticalHeight = getInnerHeight(trackVertical);
          thumbVerticalHeight = _this9.getThumbVerticalHeight();
          thumbVerticalY = values.scrollTop / (values.scrollHeight - values.clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
          thumbVerticalStyle = {
            height: thumbVerticalHeight + 'px',
            transform: 'translateY(' + thumbVerticalY + 'px)',
            msTransform: 'translateY(' + thumbVerticalY + 'px)',
            WebkitTransform: 'translateY(' + thumbVerticalY + 'px)'
          };
          trackHorizontalClass = values.scrollWidth > values.clientWidth && !fullWidth ? 'izenda-ScrollBox-Track_visible' : 'izenda-ScrollBox-Track_notVisible';
          trackVerticalClass = values.scrollHeight > values.clientHeight && !fullHeight ? 'izenda-ScrollBox-Track_visible' : 'izenda-ScrollBox-Track_notVisible';

          // Use fastdom to async/batch mutate DOM style to avoid layout thrashing.
          _fastdom2.default.clear(_this9.fastdomMutate);
          _this9.fastdomMutate = _fastdom2.default.mutate(function () {
            trackHorizontal.className = getTrackClasses(false, autoHeight, trackHorizontalClass);
            trackVertical.className = getTrackClasses(true, autoHeight, trackVerticalClass);

            (0, _style2.default)(thumbHorizontal, thumbHorizontalStyle);
            (0, _style2.default)(thumbVertical, thumbVerticalStyle);
          });
        });
      }

      if (typeof callback === 'function') {
        callback(values);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var scrollbarWidth = getScrollbarWidth();
      var autoHeight = this.props.autoHeight;
      var containerClass = this.props.className;
      var defaultContainerStyle = this.props.containerStyle;
      var autoHeightMin = this.props.autoHeightMin;
      var autoHeightMax = this.props.autoHeightMax;
      var fullSize = this.props.fullSize;
      var fullHeight = this.props.fullHeight;
      var shouldInjectScrollCallbackToChild = this.props.shouldInjectScrollCallbackToChild;

      var restProps = (0, _fp.omit)(['fullSize', 'onScroll', 'onScrollStart', 'onScrollStop', 'autoHide', 'autoHideTimeout', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'className', 'children', 'showWhenHover', 'showTrackTimeout', 'containerStyle', 'isDisabled', 'shouldInjectScrollCallbackToChild', 'viewClassName', 'fullHeight', 'fullWidth', 'stickyScrollBottom', 'alwaysShowHorizontalScroll', 'alwaysShowVerticalScroll', 'onUpdate', 'triggerOnScrollWhenScrollTo'], this.props);

      // Scrollbox classes and style
      var containerClasses = (0, _classnames2.default)(containerClass, {
        'izenda-ScrollBox': !fullSize,
        'izenda-ScrollBox_fullSize': fullSize,
        u_autoHeight: !fullSize && !!autoHeight
      });

      var containerStyle = (0, _fp.extend)(!fullSize && autoHeight ? { minHeight: autoHeightMin, maxHeight: autoHeightMax } : {}, defaultContainerStyle);

      var isScrollView = !fullSize && !autoHeight;

      // View classes and style
      var viewClasses = (0, _classnames2.default)({
        'izenda-ScrollBox-View': isScrollView,
        'izenda-ScrollBox-View_fullSize': fullSize,
        'izenda-ScrollBox-View_autoHeight': !fullSize && autoHeight,
        'izenda-ScrollBox-View-overflowXY': isScrollView && !fullHeight,
        'izenda-ScrollBox-View-overflowX': isScrollView && fullHeight
      }, this.props.viewClassName);

      var viewStyle = fullSize ? {} : (0, _fp.extend)(autoHeight ? {
        minHeight: autoHeightMin + scrollbarWidth,
        maxHeight: autoHeightMax + scrollbarWidth
      } : {}, this.props.isDisabled ? { overflow: 'hidden' } : autoHeight ? {
        // Hide scrollbars by setting a negative margin
        marginRight: scrollbarWidth ? -scrollbarWidth : NUMBER_ZERO,
        marginBottom: scrollbarWidth ? -scrollbarWidth : NUMBER_ZERO
      } : fullHeight ? { marginBottom: -scrollbarWidth } : {
        // Hide scrollbars by setting a negative right bottom corner
        top: 0,
        left: 0,
        bottom: -scrollbarWidth,
        right: -scrollbarWidth,
        position: 'absolute'
      });

      // Track classes and style
      var trackHorizontalClasses = getTrackClasses(false, autoHeight);
      var trackVerticalClasses = getTrackClasses(true, autoHeight);
      var trackStyle = !scrollbarWidth || this.props.fullSize ? { display: 'none' } : undefined;

      var getScrollTop = this.getScrollTop;
      var getScrollLeft = this.getScrollLeft;
      var getScrollWidth = this.getScrollWidth;
      var getScrollHeight = this.getScrollHeight;
      var scrollVertical = this.scrollVertical;
      var scrollHorizontal = this.scrollHorizontal;
      var scrollTo = this.scrollTo;

      var children = shouldInjectScrollCallbackToChild ? _react2.default.Children.map(this.props.children, function (child) {
        return child ? _react2.default.cloneElement(child, {
          getScrollTop: getScrollTop,
          getScrollLeft: getScrollLeft,
          getScrollWidth: getScrollWidth,
          getScrollHeight: getScrollHeight,
          scrollVertical: scrollVertical,
          scrollHorizontal: scrollHorizontal,
          scrollTo: scrollTo
        }) : null;
      }) : this.props.children;

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: containerClasses, style: containerStyle, ref: 'container' }, restProps),
        _react2.default.createElement(
          'div',
          { className: viewClasses, style: viewStyle, ref: 'view' },
          children
        ),
        _react2.default.createElement(
          'div',
          { className: trackHorizontalClasses, style: trackStyle, ref: 'trackHorizontal' },
          _react2.default.createElement('div', { className: 'izenda-ScrollBox-Thumb_horizontal', ref: 'thumbHorizontal' })
        ),
        _react2.default.createElement(
          'div',
          { className: trackVerticalClasses, style: trackStyle, ref: 'trackVertical' },
          _react2.default.createElement('div', { className: 'izenda-ScrollBox-Thumb_vertical', ref: 'thumbVertical' })
        )
      );
    }
  }]);
  return ScrollBox;
}(_react.Component), _class.propTypes = {
  onScroll: _propTypes2.default.func,
  fullSize: _propTypes2.default.bool,
  onScrollStart: _propTypes2.default.func,
  onScrollStop: _propTypes2.default.func,
  autoHide: _propTypes2.default.bool,
  autoHideTimeout: _propTypes2.default.number,
  showTrackTimeout: _propTypes2.default.number,
  autoHeight: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  autoHeightMin: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  autoHeightMax: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  showWhenHover: _propTypes2.default.bool,
  shouldInjectScrollCallbackToChild: _propTypes2.default.bool,
  viewClassName: _propTypes2.default.string,
  fullHeight: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  alwaysShowHorizontalScroll: _propTypes2.default.bool,
  alwaysShowVerticalScroll: _propTypes2.default.bool,
  onUpdate: _propTypes2.default.func,
  stickyScrollBottom: _propTypes2.default.number,
  triggerOnScrollWhenScrollTo: _propTypes2.default.bool
}, _class.defaultProps = {
  fullSize: false,
  autoHide: true,
  autoHideTimeout: 200,
  showTrackTimeout: 200,
  autoHeight: false,
  disabled: false,
  autoHeightMin: 0,
  autoHeightMax: 200,
  showWhenHover: true,
  shouldInjectScrollCallbackToChild: false,
  fullHeight: false,
  fullWidth: false,
  alwaysShowHorizontalScroll: false,
  alwaysShowVerticalScroll: false,
  triggerOnScrollWhenScrollTo: true
}, _temp2);
exports.default = ScrollBox;


function getScrollbarWidth() {
  if (scrollbarWidth) {
    return scrollbarWidth;
  }
  if (typeof document !== 'undefined') {
    var div = document.createElement('div');
    // Effect when resize event
    div.style.width = '100';
    div.style.height = '100';
    div.style.position = 'absolute';
    div.style.top = '-9999';
    div.style.overflow = 'scroll';
    div.style.border = 'none';
    div.style.overflowScrolling = 'touch';
    div.style.WebkitOverflowScrolling = 'touch';

    document.body.appendChild(div);
    scrollbarWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  } else {
    scrollbarWidth = NUMBER_ZERO;
  }
  return scrollbarWidth;
}

function getInnerHeight(elem) {
  var computedStyle = window.getComputedStyle(elem);
  return elem.clientHeight - parseFloat(computedStyle.paddingTop) - parseFloat(computedStyle.paddingBottom);
}

function getInnerWidth(elem) {
  var computedStyle = window.getComputedStyle(elem);
  return elem.clientWidth - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);
}

function getTrackClasses(isVertical, autoHeight, extraClass) {
  return (0, _classnames2.default)({
    'izenda-ScrollBox-Track_vertical': isVertical,
    'izenda-ScrollBox-Track_horizontal': !isVertical,
    'izenda-ScrollBox-Track_autoHeight': autoHeight
  }, extraClass);
}

function tween(start, end, onUpdate) {
  var tween = new _tween2.default.Tween(start).to(end, NUMBER_TWEEN).onUpdate(onUpdate);
  tween.start();
  animate();

  function animate(time) {
    (0, _raf3.default)(animate);
    _tween2.default.update(time);
  }
}
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Panel.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Panel component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(943);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Panel = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Panel, _Component);

  function Panel(props) {
    (0, _classCallCheck3.default)(this, Panel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Panel.__proto__ || (0, _getPrototypeOf2.default)(Panel)).call(this, props));

    _initialiseProps.call(_this);

    var header = props.header,
        initState = props.initState,
        parent = props.parent,
        collapsible = props.collapsible,
        expanedOption = props.expanedOption;


    _this.collapsible = parent || collapsible ? true : false;
    var expandedStatus = !!header && !(0, _fp.isNil)(header.expanedOption) && !(0, _fp.isEmpty)(header.expanedOption);
    _this.state = {
      isExpanded: initState || expanedOption || expandedStatus
    };
    return _this;
  }

  (0, _createClass3.default)(Panel, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var props = this.props,
          isExpanded = this.state.isExpanded;

      props.afterToggled && props.afterToggled(isExpanded);
    }

    /**
     * Component will receive props
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          header = _props.header,
          expanedOption = _props.expanedOption;

      var nextPropsHeader = nextProps.header;

      // Toggle expand content when current & next props is difference
      if (nextPropsHeader && !(0, _fp.isNil)(nextPropsHeader.expanedOption) && nextPropsHeader.expanedOption !== header.expanedOption) {
        expandedPanel.call(this, nextPropsHeader.expanedOption);
      }

      if (nextProps.expanedOption !== expanedOption) {
        expandedPanel.call(this, nextProps.expanedOption);
      }

      function expandedPanel(newState) {
        var expanded = !!newState;
        this.setState({
          isExpanded: expanded
        });
      }
    }

    /**
     * Show/hide content
     * @param {event} e
     */


    /**
     * Render resizable panel body
     */

  }, {
    key: 'render',


    /**
     * Render component
     * @returns {react-element}
     */
    value: function render() {
      var panel = this;
      var isExpanded = this.state.isExpanded,
          _props2 = this.props,
          className = _props2.className,
          style = _props2.style,
          panelKey = _props2.panelKey,
          id = _props2.id;


      var classes = (0, _classnames2.default)('panel', className);

      return _react2.default.createElement(
        'div',
        {
          className: classes,
          style: style,
          'aria-expanded': isExpanded,
          key: panelKey,
          id: id
        },
        this.renderHeader(),
        getBody.apply(this)
      );

      /**
       * Render panel-body
       * @returns {react-element}
       */
      function getBody() {
        if (panel.collapsible) {
          return panel.renderCollapseBody();
        } else {
          var footer = panel.renderFooter();
          return footer ? this.renderFixBody(panel.renderBody(), footer) : panel.renderBody();
        }
      }
    }

    /**
     * Render fixed panel body
     */

  }, {
    key: 'renderFixBody',
    value: function renderFixBody(body, footer) {
      return _react2.default.createElement(
        'div',
        null,
        body,
        footer
      );
    }

    /**
     * Handle click on title.
     */


    /**
     * Rendfer header
     * @returns {react-element}
     */


    /**
     * Render panel body: body & footer (for collapsible-component)
     * @returns {react-element}
     */


    /**
     * Render panel body
     * @returns {type}
     */


    /**
     * Render footer
     * @returns {type}
     */

  }]);
  return Panel;
}(_react.Component), _class2.propTypes = {
  resizable: _propTypes2.default.bool,
  collapsible: _propTypes2.default.bool,
  afterToggled: _propTypes2.default.func,
  idPanelBody: _propTypes2.default.bool,
  expanedOption: _propTypes2.default.bool,
  rerenderOnExpaned: _propTypes2.default.bool,
  header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  footer: _propTypes2.default.object,
  panelBodyClassName: _propTypes2.default.string
}, _class2.defaultProps = {
  resizable: false
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.collapseToggle = function () {
    _this2.setState({
      isExpanded: !_this2.state.isExpanded
    });
  };

  this.renderResizableBody = function (body, footer) {
    var _props3 = _this2.props,
        defaultValue = _props3.defaultValue,
        minValue = _props3.minValue,
        maxValue = _props3.maxValue,
        afterMove = _props3.afterMove;

    var config = { defaultValue: defaultValue, minValue: minValue, maxValue: maxValue };

    return _react2.default.createElement(
      'div',
      { className: 'filters-body-container' },
      _react2.default.createElement(
        'div',
        { style: { height: defaultValue } },
        body,
        footer
      ),
      _react2.default.createElement(_Izenda2.default, {
        afterMove: afterMove,
        config: config,
        orientation: 'vertical',
        nodeHandle: 'previousSibling'
      })
    );
  };

  this.onClickTitleHandle = function () {
    var _props4 = _this2.props,
        disabled = _props4.disabled,
        header = _props4.header,
        rawTitle = _props4.header.rawTitle;


    if (disabled) {
      return;
    }

    if (header.onClickTitle) {
      header.onClickTitle(rawTitle);
    }
  };

  this.renderHeader = function () {
    var panel = _this2;
    var isExpanded = _this2.state.isExpanded,
        header = _this2.props.header;


    if (!header) {
      return null;
    }

    var style = header.style,
        className = header.className,
        icon = header.icon,
        title = header.title;


    var classes = (0, _classnames2.default)('panel-heading', className);
    return _react2.default.createElement(
      'div',
      { className: classes, 'aria-expanded': isExpanded },
      getHeaderContent()
    );

    /**
     * Render header
     * @returns {react-component}
     */
    function getHeaderContent() {

      if (header.component) {
        return _react2.default.createElement(header.component, (0, _extends3.default)({ collapseToggle: panel.collapseToggle, isExpanded: isExpanded }, header));
      } else {
        if (header.onClickTitle) {
          return _react2.default.createElement(
            'strong',
            { style: style, className: className },
            icon ? _react2.default.createElement('i', { className: icon, onClick: panel.collapsible ? panel.collapseToggle : null }) : null,
            _react2.default.createElement(
              'a',
              { onClick: panel.onClickTitleHandle },
              header && title || header
            )
          );
        }
        return _react2.default.createElement(
          'strong',
          {
            onClick: panel.collapsible ? panel.collapseToggle : null,
            style: style,
            className: className
          },
          icon ? _react2.default.createElement('i', { className: icon }) : null,
          getHeader()
        );
      }

      function getHeader() {
        return (0, _fp.isString)(title) && title || (0, _fp.isString)(header) && header || '';
      }
    }
  };

  this.renderCollapseBody = function () {
    var isExpanded = _this2.state.isExpanded,
        _props5 = _this2.props,
        disabled = _props5.disabled,
        renderCollapseContent = _props5.renderCollapseContent,
        resizable = _props5.resizable;


    var classes = (0, _classnames2.default)('panel-collapse collapse', {
      in: isExpanded,
      'izenda-Panel_Disabled': disabled
    });

    var renderBody = void 0;

    if (renderCollapseContent) {
      renderBody = isExpanded ? getContent : null;
    } else {
      renderBody = getContent;
    }

    return _react2.default.createElement(
      'div',
      { className: classes, disabled: disabled },
      renderBody && renderBody.apply(_this2)
    );

    function getContent() {
      if (resizable) {
        return this.renderResizableBody(this.renderBody(), this.renderFooter());
      }

      return _react2.default.createElement(
        'div',
        null,
        this.renderBody(),
        this.renderFooter()
      );
    }
  };

  this.renderBody = function () {
    var _props6 = _this2.props,
        disabled = _props6.disabled,
        panelBodyClassName = _props6.panelBodyClassName,
        idPanelBody = _props6.idPanelBody,
        children = _props6.children;

    var classes = (0, _classnames2.default)('panel-body', panelBodyClassName);
    return _react2.default.createElement(
      'div',
      { id: idPanelBody, className: classes, disabled: disabled },
      children
    );
  };

  this.renderFooter = function () {
    var footer = _this2.props.footer;


    if (!footer) {
      return null;
    }
    var className = footer.className,
        title = footer.title;

    var classes = (0, _classnames2.default)('panel-footer', className);
    return _react2.default.createElement(
      'div',
      { className: classes },
      getContent()
    );

    /**
     * Render footer content
     * @returns {react-element}
     */
    function getContent() {
      if (footer.component) {
        return _react2.default.createElement(footer.component, footer);
      } else {
        return footer && title;
      }
    }
  };
}, _temp)) || _class;

exports.default = Panel;
module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Dropdown.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Dropdown component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(27);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(154);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(34);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(78);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HIDDEN_SELECTED_VALUE = '***HIDDEN VALUE***';

var DropDown = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(DropDown, _Component);

  function DropDown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DropDown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDown.__proto__ || (0, _getPrototypeOf2.default)(DropDown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      selected: _this.props.value,
      hiddenSelected: _this.props.maskedHidden
    }, _this.hideDropdown = function () {
      _this.setState({ isOpen: false });
    }, _this.handleMouseDown = function (event) {
      var _this$props = _this.props,
          isOnPopover = _this$props.isOnPopover,
          disabled = _this$props.disabled;

      if (isOnPopover && _Izenda8.default.isIEBrowser()) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (disabled) return;

      _this.props.onFocus && _this.props.onFocus();

      _this.setState({
        isOpen: !_this.state.isOpen
      });
    }, _this.setValue = function (value, label, selectedAdditionalValue) {
      // Don't trigger change if don't change current value
      if (value === _this.state.selected) {
        _this.setState({ isOpen: false });
        return;
      }

      var oldValue = _this.state.selected;

      _this.setState({
        selected: value,
        isOpen: false,
        hiddenSelected: false,
        selectedAdditionalValue: selectedAdditionalValue
      });

      if (_this.props.onChange) {
        var selectedItem = _this.findSelectedOption(value, _this.filteredOptions, selectedAdditionalValue);
        var change = { value: value, label: label, additionalValue: selectedAdditionalValue };

        (0, _bluebird.resolve)(_this.props.onChange(change, selectedItem)).catch(function () {
          // revert to old value if the promise is reject
          _this.setState({ selected: oldValue });
        });
      }
    }, _this.getValue = function (option) {
      var valueField = _this.props.valueField;


      if (!valueField) {
        return option;
      } else if ((0, _fp.isString)(valueField)) {
        return (0, _fp.get)(valueField, option);
      } else if ((0, _fp.isFunction)(valueField)) {
        return valueField(option);
      }
    }, _this.getLabel = function (option) {
      var labelField = _this.props.labelField;


      if (!labelField) {
        return option;
      } else if ((0, _fp.isString)(labelField)) {
        return (0, _fp.get)(labelField, option);
      } else if ((0, _fp.isFunction)(labelField)) {
        return labelField(option);
      }
    }, _this.getIcon = function (option) {
      var iconField = _this.props.iconField;


      if (!iconField) {
        return option;
      } else if ((0, _fp.isString)(iconField)) {
        return (0, _fp.get)(iconField, option);
      } else if ((0, _fp.isFunction)(iconField)) {
        return iconField(option);
      }
    }, _this.renderOption = function (option, index) {
      var value = _this.getValue(option);
      var label = _this.getLabel(option);
      var icon = _this.getIcon(option);
      var _this2 = _this,
          props = _this2.props,
          additionalKey = _this2.props.additionalKey;

      var key = additionalKey ? value + additionalKey : value;
      var tooltip = (0, _fp.getOr)(label, 'props.optionTooltip', option);
      var additionOptionProps = props.getOptionProperties && props.getOptionProperties(option);
      var additionalValue = props.additionalValueField ? (0, _fp.getOr)('', props.additionalValueField, option) : '';

      var optionClass = (0, _classnames2.default)({
        'izenda-Dropdown-option': true,
        'is-selected': value === _this.state.selected
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          key: index + '_' + key,
          title: tooltip,
          className: optionClass,
          onClick: _this.setValue.bind(_this, value, label, additionalValue)
        }, additionOptionProps),
        icon && _react2.default.createElement('span', { className: icon }),
        label
      );
    }, _this.renderListOption = function (options) {
      return !(0, _fp.isEmpty)(options) ? options.map(function (item, index) {
        return _this.renderOption(item, index);
      }) : [];
    }, _this.renderGroupOption = function (options) {
      var props = _this.props;
      var optionsGrouped = (0, _fp.groupBy)(function (option) {
        return (0, _fp.isFunction)(props.groupBy) ? props.groupBy(option) : option[props.groupBy];
      }, options) || {};

      return (0, _fp.map)(function (name) {
        var groupValue = optionsGrouped[name];
        var title = props.groupFormatText ? props.groupFormatText(groupValue[0]) : '';
        var label = props.buildGroupLabel ? props.buildGroupLabel(groupValue[0]) : name;

        return label !== 'undefined' ? _react2.default.createElement(
          'div',
          { className: 'izenda-Dropdown-group', key: name, label: label, title: title },
          _react2.default.createElement(
            'div',
            { className: 'izenda-Dropdown-title u_textTruncate', title: label },
            label
          ),
          _this.renderListOption(groupValue)
        ) : _this.renderListOption(groupValue);
      }, (0, _fp.keys)(optionsGrouped));
    }, _this.buildMenu = function (filteredOptions) {
      var _this$props2 = _this.props,
          groupBy = _this$props2.groupBy,
          blankOption = _this$props2.blankOption,
          disabledBlankOption = _this$props2.disabledBlankOption,
          blankOptionText = _this$props2.blankOptionText;

      var options = groupBy ? _this.renderGroupOption(filteredOptions) : _this.renderListOption(filteredOptions);

      !(0, _fp.isEmpty)(options) && blankOption && options.unshift(_react2.default.createElement(
        'div',
        {
          key: (0, _fp.uniqueId)('blankOption_'),
          className: 'izenda-Dropdown-option',
          disabled: disabledBlankOption,
          onClick: _this.setValue.bind(_this, '', '')
        },
        blankOptionText
      ));

      _this.state.hiddenSelected && options.push(_react2.default.createElement(
        'div',
        { key: (0, _fp.uniqueId)('hide_'), className: 'hide', onClick: _this.setValue.bind(_this, HIDDEN_SELECTED_VALUE, '') },
        _Izenda6.default.MASKED_TEXT
      ));

      return options;
    }, _this.findSelectedOption = function (value, options, selectedAdditionalValue) {
      var additionalValueField = _this.props.additionalValueField;


      return (0, _fp.find)(function (option) {
        return (0, _fp.isEqual)(_this.getValue(option), value) && (!additionalValueField || !selectedAdditionalValue || (0, _fp.isEqual)((0, _fp.getOr)('', additionalValueField, option), selectedAdditionalValue));
      }, options);
    }, _this.filterOptions = function () {
      var _this$props3 = _this.props,
          options = _this$props3.options,
          filterOptions = _this$props3.filterOptions;

      if ((0, _fp.isFunction)(filterOptions)) {
        return filterOptions(options);
      }

      return options;
    }, _this.setDomNode = function (dom) {
      _this.dropdownRef = dom;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DropDown, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        selected: nextProps.value,
        hiddenSelected: nextProps.maskedHidden
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var selectedValue = !(0, _fp.isNil)(this.state.selected) ? this.state.selected : '';
      var dropdown = this.dropdownRef;

      // sync value of control and component state
      if (dropdown && !selectedValue && dropdown.value !== selectedValue) {
        dropdown.value = selectedValue;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selected = _state.selected,
          hiddenSelected = _state.hiddenSelected,
          selectedAdditionalValue = _state.selectedAdditionalValue,
          isOpen = _state.isOpen,
          optionTooltip = _state.optionTooltip;
      var _props = this.props,
          defaultValue = _props.defaultValue,
          disabled = _props.disabled,
          blankOptionText = _props.blankOptionText,
          blankOption = _props.blankOption,
          className = _props.className,
          isOnPopover = _props.isOnPopover,
          autoWidth = _props.autoWidth,
          renderInContainer = _props.renderInContainer;

      var options = this.filteredOptions = this.filterOptions();
      var selectedValue = hiddenSelected ? HIDDEN_SELECTED_VALUE : !(0, _fp.isNil)(selected) ? selected : defaultValue;

      var selectedOption = this.findSelectedOption(selectedValue, options, selectedAdditionalValue);
      var selectedIcon = selectedOption && this.getIcon(selectedOption);
      var selectedText = selectedOption && this.getLabel(selectedOption);

      if ((0, _fp.isNil)(selectedOption)) {
        if (hiddenSelected) {
          selectedText = _Izenda6.default.MASKED_TEXT;
        } else if (blankOption) {
          selectedText = blankOptionText;
        }
      }

      var tooltip = (0, _fp.getOr)(selectedText, optionTooltip, selectedOption);
      var dropdownClass = (0, _classnames2.default)(className, {
        'izenda-Dropdown': true,
        'izenda-Dropdown_open': isOpen,
        'izenda-Dropdown_disabled': disabled
      });

      // Fix issue IE not fire event onClick on popover
      var onClickAction = isOnPopover && _Izenda8.default.isIEBrowser() ? { onMouseDown: this.handleMouseDown } : { onClick: this.handleMouseDown };

      return _react2.default.createElement(
        'div',
        { className: dropdownClass },
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({ ref: this.setDomNode, className: 'izenda-Dropdown-control', title: tooltip }, onClickAction),
          _react2.default.createElement(
            'div',
            { className: 'izenda-Dropdown-placeholder' },
            selectedIcon && _react2.default.createElement('span', { className: selectedIcon }),
            selectedText
          ),
          _react2.default.createElement('span', { className: 'izenda-Dropdown-arrow' })
        ),
        this.state.isOpen && _react2.default.createElement(
          _Izenda4.default,
          {
            anchor: this.dropdownRef,
            autoWidth: autoWidth,
            renderInContainer: renderInContainer,
            onClickOutside: this.hideDropdown,
            onParentScroll: this.hideDropdown
          },
          _react2.default.createElement(
            'div',
            { className: 'izenda-Dropdown-menu' },
            _react2.default.createElement(
              _Izenda2.default,
              { autoHeight: true, autoHeightMax: _Izenda6.default.dropdownMaxHeight },
              this.buildMenu(options)
            )
          )
        )
      );
    }
  }]);
  return DropDown;
}(_react.Component), _class2.propTypes = {
  id: _propTypes2.default.string,
  options: _propTypes2.default.oneOfType([_propTypes2.default.object.isRequired, _propTypes2.default.array.isRequired]),
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  valueField: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  labelField: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  groupBy: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  maskedHidden: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  groupFormatText: _propTypes2.default.func,
  blankOption: _propTypes2.default.bool,
  getOptionProperties: _propTypes2.default.func,
  buildGroupLabel: _propTypes2.default.func,
  optionTooltip: _propTypes2.default.string,
  additionalKey: _propTypes2.default.string,
  autoWidth: _propTypes2.default.bool,
  renderInContainer: _propTypes2.default.bool,
  additionalValueField: _propTypes2.default.string,
  isOnPopover: _propTypes2.default.bool,
  filterOptions: _propTypes2.default.any
}, _class2.defaultProps = {
  value: null,
  maskedHidden: false,
  valueField: 'value',
  labelField: 'label',
  iconField: 'icon',
  onChange: null,
  onFocus: null,
  disabled: false,
  blankOption: false,
  blankOptionText: '',
  optionTooltip: 'label',
  additionalValueField: null
}, _temp2)) || _class;

exports.default = DropDown;
module.exports = exports['default'];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.Button.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Button Component
 */
!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      noop = _require.noop;

  var Button = React.createClass({
    displayName: 'Button',

    /**
     * initial properties
     * @returns {Object}
     */
    getDefaultProps: function getDefaultProps() {
      return {
        className: '',
        label: '',
        onClick: noop,
        disabled: false
      };
    },

    componentDidMount: function componentDidMount() {
      // Initialize dropdown if parent (caller) component wants to render as dropdown
      if (this.props['data-toggle'] && this.props['data-toggle'] === 'dropdown') {
        $izenda(this.refs.btn).dropdown();
      }
    },

    /**
     * render component
     * @returns {Object}
     */
    render: function render() {
      var classes = classnames('btn btn-primary', this.props.className);
      var whitespace = this.props.label && React.Children.count(this.props.children) > 0 ? ' ' : '';
      var label = this.props.label + whitespace;

      return React.createElement(
        'button',
        {
          ref: 'btn',
          className: classes,
          onClick: this.props.onClick,
          disabled: this.props.disabled,
          title: this.props.title,
          'data-toggle': this.props['data-toggle']
        },
        label,
        this.props.children
      );
    }
  });

  module.exports = Button;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(38);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="RouteUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var config = __webpack_require__(40);
var ReportDesignerConstants = __webpack_require__(16);
var subReportLink = __webpack_require__(177);
var uiState = __webpack_require__(15);
var customURLConstants = __webpack_require__(82).CUSTOM_URL;
var SubReportUtils = __webpack_require__(246);
var SubReportLink = __webpack_require__(177);

__webpack_require__(1401);

var PREFIX_FILTER_KEY = 'p';

/**
 * Get configured route by name and path
 * @param {Array} args
 * @example getConfigRoute('Dashboard', 'List')
 */
function getConfigRoute() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if ((0, _fp.isEmpty)(args)) {
    return config.RoutesMerge;
  }

  var routesParams = (0, _fp.flatten)(args);
  var routePath = (0, _fp.join)('.children.', routesParams);

  return (0, _fp.get)(routePath, config.RoutesMerge);
}

/**
 * Get url for specific component
 * @param  {Object}    urlObject Url pattern
 * @param  {Object}    params   Params object to replace in URL pattern
 */
function getRouteUrl(urlObject) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var BaseUrl = config.BaseUrl;

  var buildUrl = function buildUrl(urlNode) {
    if (!urlNode) {
      return '';
    }
    return buildUrl(urlNode.parent) + '/' + urlNode.path;
  };

  var subRoute = buildUrl(urlObject);
  // replace react-router params url using pattern :param
  var url = (0, _keys2.default)(params).reduce(function (route, key) {
    var pattern = new RegExp('\\(?/?:' + key + '\\)?', 'i');
    var matched = pattern.exec(subRoute);
    var paramValue = matched && matched[0].indexOf('/') >= 0 ? '/' + params[key] : params[key];
    return route.replace(pattern, paramValue);
  }, subRoute);

  var resolvedUrl = url.replace(/\((.*?)\)?\)/, '').replace(')', '');

  return String.concatToUrl([BaseUrl, resolvedUrl]);
}

/**
 * Resolve url base on route configuration
 * @param {Array<string>} componentRoute Route name
 * @param {string} child Sub route name
 * @param {Object} params Route params
 */
function getUrl(componentRoute, child, params) {
  var rootComponentRoute = (0, _fp.get)(componentRoute, getConfigRoute());

  (0, _Izenda2.default)(rootComponentRoute, 'must have component route in Route Constants');
  var childrenRoute = (0, _fp.getOr)(rootComponentRoute, 'children.' + child, rootComponentRoute);

  return getRouteUrl(childrenRoute, params);
}

/**
 * Get NoPermission url
 */
function getNoPermissionUrl() {
  return (config.BaseUrl + '/NoPermission').replace('//', '/');
}

var partialGetUrl = (0, _fp.partial)(getUrl);

var getSettingsUrl = partialGetUrl(['Settings']);

var getDashboardUrl = partialGetUrl(['Dashboard']);

var getReportUrl = partialGetUrl(['Report']);

var getReportDesignerUrl = partialGetUrl(['ReportDesigner']);

var getViewerUrl = partialGetUrl(['Viewer']);

var getReportViewerUrl = partialGetUrl(['ReportViewer']);

var getMyProfileUrl = partialGetUrl(['MyProfile']);

/**
 * Transform query object to filter values
 * @param  {Object} query Query object in window.location
 * @example
 * Input: ?p1=123&p2=456%3B%23789
 * Output: [{positionString:"1",value:"123"}, {positionString:"2",value:"456;#789"}]
 */
function transformQueryToFilters(query) {
  var isPrefixedFilter = function isPrefixedFilter(key) {
    return (0, _fp.startsWith)(PREFIX_FILTER_KEY, (0, _fp.lowerCase)(key));
  };
  var toFilter = function toFilter(filterKey) {
    return {
      positionString: filterKey.substring(1),
      value: decodeURIComponent(query[filterKey])
    };
  };

  return (0, _fp.chain)(query).keys().filter(isPrefixedFilter).map(toFilter).value();
}

/**
 * Resolve and navigate to sub report url
 * @param {Object} props
 * @param {Object} subReport
 * @param {Array<Object>} record
 * @param {Object} fieldConfig
 */
function openSubReport(props, subReport, record, fieldConfig) {
  var reportPart = props.reportPart;
  var filterInfo = SubReportUtils.buildFilterDataCommon(record, subReport.mappingFields, reportPart);

  if (!filterInfo.success) {
    return props.confirmMessage('error', filterInfo.errors);
  }
  var filterInfoForSubReport = props.getFilterInfoForSubReport();
  var subReportId = subReport.selectedReport;

  if (subReport.style === ReportDesignerConstants.DRIL_DOWN_STYLE.POPUP) {
    var filterData = SubReportUtils.buildFilterDataForEmbededReportPart(filterInfo.fieldMapping, reportPart, subReport, filterInfoForSubReport);

    // ReportViewerPopup is declared here to avoid circula dependency
    var ReportViewerPopup = __webpack_require__(1402)();

    return props.openPopup(ReportViewerPopup, {
      reportId: subReportId,
      queryObject: filterData
    });
  }
  var urlData = SubReportUtils.buildFilterDataForURL(filterInfo.fieldMapping, reportPart, fieldConfig.fieldElement, subReport, filterInfoForSubReport);

  if (!urlData.success) {
    return props.confirmMessage('error', urlData.errors);
  }
  var query = SubReportLink.convertFilterToQuery((0, _fp.omit)(['success'], urlData));
  var paramsText = $izenda.param(query || {});
  var link = getReportUrl('View', {
    id: subReportId
  }) + '?' + paramsText;

  if (subReport.style === ReportDesignerConstants.DRIL_DOWN_STYLE.LINK) {
    if (uiState.isDirty) {
      return props.confirmMessage('info', ReportDesignerConstants.BUNDLE.MESSAGE.OPEN_SUB_REPORT_WARNING);
    } else {
      props.router.push(link);
      return null;
    }
  }

  window.open(makeAbsoluteUrl(link), '_blank');
}

/**
 * Resolve and navigate to custom field url of a report
 * @param {*} props
 * @param {*} param1
 * @param {*} mappingDataValues
 * @param {*} reportId Opening report identifier
 * @param {*} isExternal Open external url or internal app url
 * @param {*} fieldConfig
 */
function openCustomURL(_ref, _ref2, mappingDataValues, reportId, isExternal, fieldConfig) {
  var confirmDirtyForm = _ref.confirmDirtyForm,
      router = _ref.router;
  var url = _ref2.url,
      option = _ref2.option;

  var link = isExternal ? getCustomURLExternalLink(url, mappingDataValues, fieldConfig) : getCustomURLInternalLink(mappingDataValues, reportId);

  var _window = window,
      innerWidth = _window.innerWidth,
      innerHeight = _window.innerHeight;


  switch (option) {
    case customURLConstants.OPTIONS.LINK_CURRENT_WINDOW:
      confirmDirtyForm(uiState.isDirty, {
        onConfirmDirtyForm: uiState.onOkDirtyForm
      }).then(function () {
        if (isExternal) {
          window.open(link, '_top');
        } else {
          router.push(link);
        }
      });
      break;
    case customURLConstants.OPTIONS.LINK_NEW_WINDOW:
      window.open(isExternal ? link : makeAbsoluteUrl(link), // handle url for integrated mode
      '_blank', 'toolbar=1,location=1,menubar=1,statusbar=1,width=' + innerWidth + ',height=' + innerHeight);
      break;
    case customURLConstants.OPTIONS.LINK_NEW_TAB:
      // handle url for integrated mode
      window.open(isExternal ? link : makeAbsoluteUrl(link));
      break;
  }
  return null;
}

/**
 * Generate external custom url of a report
 * @param {string} url
 * @param {Array<Object>} mappingDataValues
 * @param {Object} fieldConfig
 */
function getCustomURLExternalLink(url, mappingDataValues, fieldConfig) {
  var fieldNameAlias = (0, _fp.get)('fieldElement.fieldNameAlias', fieldConfig);

  mappingDataValues.forEach(function (mapping) {
    var mappingValue = mapping.value;

    url = url.replace('{[' + mapping.fieldNameAlias + ']}', mappingValue);
    if (mapping.fieldNameAlias === fieldNameAlias) {
      url = url.replace('{0}', mappingValue);
    }
  });
  return url;
}

/**
 * Generate internal custom url of a report
 * @param {Array<Object>} mappingDataValues
 * @param {string} reportId
 */
function getCustomURLInternalLink(mappingDataValues, reportId) {
  var baseLink = getReportViewerUrl('ReportViewerDetail', {
    id: reportId
  });

  return baseLink + subReportLink.buildSubReportQuery(mappingDataValues);
}

/**
 * Convert relative URL to absolute URL appending query string params
 * @param {string} relativeUrl
 * @param {string} queryStringParams
 */
function makeAbsoluteUrl() {
  var relativeUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var queryStringParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var sourceRegex = /\?source=[^&]+&?/i;
  var hashRegex = /^#/;
  var slashRegex = /^\//;
  var endSlashRegext = /\/$/;

  var location = window.location;
  var hash = decodeURIComponent(location.hash);
  var origin = location.origin,
      pathname = location.pathname,
      search = location.search,
      protocol = location.protocol,
      hostname = location.hostname,
      port = location.port;


  if (!origin || origin === 'null') {
    origin = protocol + '//' + (hostname + (port ? ':' + port : port));
  }

  var queryString = queryStringParams ? (relativeUrl.indexOf('?') > -1 ? '&' : '?') + queryStringParams : '';
  var slash = origin.match(endSlashRegext) ? '' : '/';
  var absUrl = '' + origin + slash + relativeUrl.replace(slashRegex, '') + queryString;

  if (config.Integration) {
    // Sanitize the hash of request to remove "source" and extra "&"
    // For example: ?source=abc&p2=2&p3=3 --> #...?p2=2&p3=3
    var currentPath = hash ? hash.replace(sourceRegex, '') : '';

    // Construct url: https://developer.mozilla.org/en-US/docs/Learn/Common_questions/What_is_a_URL
    var hashParam = currentPath.replace(hashRegex, '');
    var absHostRoutingUrl = void 0;
    if (search.toLowerCase().indexOf(hashParam.toLowerCase()) >= 0) {
      absHostRoutingUrl = '' + origin + pathname + search + '#';
    } else {
      absHostRoutingUrl = '' + origin + pathname + search + '#' + hashParam;
    }

    var izendaSourceQuery = '' + relativeUrl + (queryStringParams ? '?' + queryStringParams : '');

    var questionMark = currentPath.indexOf('?') > -1 ? '' : '?';

    absUrl = '' + absHostRoutingUrl + questionMark + 'source=' + izendaSourceQuery;
  }

  return absUrl;
}

/**
 * Sync in-memory location with browser address bar
 * @param {Object} location
 */
function syncLocation(location, query) {
  if ((0, _fp.isNil)(location)) return;

  !(0, _fp.isNil)(query) && (location.query = query);
  var queryString = $izenda.param(location.query);
  var path = location.pathname + (queryString ? '?' + queryString : '');

  saveIzendaRoutingPath(path);
}

/**
 * Listen to history changed and sync hash of location
 * @param {Object} history
 */
function listenHistoryChange(_ref3, path, query) {
  var synergyHistory = _ref3.synergyHistory,
      isPageLoad = _ref3.isPageLoad;

  var isFirstLoad = true;

  // Do extra setup works on when embedded in customer frontend app
  UrlHashMonitor.init();
  synergyHistory.listenBefore(function (location) {
    syncLocation(location, isFirstLoad ? query : null);
  });

  if ('onhashchange' in window) {
    window.onhashchange = function (event) {
      removeListener();
      synergyHistory.push(getHashLocation());
    };
  }

  // Navigate to specific page
  navigateToSpecificPage(synergyHistory, isPageLoad, path);

  var removeListener = synergyHistory.listen(function (event) {
    // Sync in-memory location with browser address bar
    syncLocation(event, isFirstLoad ? query : null);
    isFirstLoad = false;
  });
}

/**
 * Navigate to specific page
 * @param {Object} history
 * @param {Boolean} isPageLoad
 * @param {Object} path
 */
function navigateToSpecificPage(history, isPageLoad, path) {
  if (isPageLoad) {
    var izendaPathFromSource = getHashLocation();
    if ((0, _fp.isEqual)(izendaPathFromSource, config.BaseUrl)) {
      history.push(path);
    } else {
      history.push(izendaPathFromSource);
    }
  } else {
    history.push(path);
  }
}

// parse hash string to location object
function getHashLocation() {
  return getIzendaRoutingPath(config.BaseUrl);
}

/**
 * get the previous link
 *   when in integration mode then get hash location
 *   when in stand alone then get the path name
 */
function getPreviousLink() {
  if (config.Integration) {
    return getHashLocation();
  }
  return window.location.pathname;
}

/* PRIVATE FUNCTION */
function saveIzendaRoutingPath(path) {
  // We keep the izenda path into location.hash (no impact to routing) so that
  // the corresponding page can be accessed later on by bookmarked url
  var decodedHash = decodeURIComponent(location.hash);
  var match = /^(.+?)\?source=?/g.exec(decodedHash);
  var currentPath = match ? match[1] : decodedHash;

  // TODO: Handle case location.hash has mutiple query params
  // (added either by customer frontend app or by ourself)
  location.hash = currentPath + '?source=' + path;
}

function getIzendaRoutingPath(defaultPath) {
  // For Angular (NeedToEncodeUrl = false) : need to decode hash before using
  var decodedHash = !config.NeedToEncodeUrl ? decodeURIComponent(location.hash) : location.hash;

  var match = /\?source=?(.+)/g.exec(decodedHash);
  var path = defaultPath;

  if (match) {
    var matchHashUrl = match[1];
    path = matchHashUrl || defaultPath;
  }

  return path;
}
/* END PRIVATE FUNCTION */

exports.default = {
  getUrl: getUrl,
  getSettingsUrl: getSettingsUrl,
  getDashboardUrl: getDashboardUrl,
  getMyProfileUrl: getMyProfileUrl,
  getReportUrl: getReportUrl,
  getReportDesignerUrl: getReportDesignerUrl,
  getViewerUrl: getViewerUrl,
  getReportViewerUrl: getReportViewerUrl,
  getConfigRoute: getConfigRoute,
  getRouteUrl: getRouteUrl,
  openSubReport: openSubReport,
  openCustomURL: openCustomURL,
  getCustomURLExternalLink: getCustomURLExternalLink,
  getCustomURLInternalLink: getCustomURLInternalLink,
  transformQueryToFilters: transformQueryToFilters,
  makeAbsoluteUrl: makeAbsoluteUrl,
  listenHistoryChange: listenHistoryChange,
  getHashLocation: getHashLocation,
  getPreviousLink: getPreviousLink,
  getNoPermissionUrl: getNoPermissionUrl
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* CHART TYPE */
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartDefaultConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var CHART_TYPE = {
  // izenda -value             //title - text
  Line: 'Line',
  Column: 'Column',
  Bar: 'Bar',
  Area: 'Area',
  Pie: 'Pie',
  Funnel: 'Funnel',
  Donut: 'Donut',
  Combination: 'Combination',
  TreeMap: 'TreeMap',
  HeatMap: 'HeatMap',
  Bubble: 'Bubble',
  Scatter: 'Scatter',
  Waterfall: 'Waterfall',
  Sparkline: 'Sparkline',

  SolidGauge: 'SolidGauge',
  LinearGauge: 'LinearGauge',
  SimpleGauge: 'SimpleGauge',

  Map: 'Map'
};

/* STACK TYPE CHART */
var STACK_TYPE_CHART = {
  get izNormal() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_NORMAL');
  },
  get izPercent() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_PERCENTAGE');
  }
};

var STACK_TYPE_CHART_VALUES = {
  izNormal: 'normal',
  izPercent: 'percent'
};

/* LINE STYLE: border, line-style */
var LINE_STYLE = {
  get solid() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_SOLID');
  },
  get dotted() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_DOT');
  },
  get dashed() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_DASH');
  }
};

var LINE_STYLE_VALUES = {
  solid: 'Solid',
  dotted: 'Dot',
  dashed: 'Dash'
};

/* TEXT ORIENTATION: data label, x/y label */
var LABEL_ROTATION = {
  izNormal: 'Normal',
  izCounterclockwise: 'Counterclockwise',
  izClockwise: 'Clockwise',
  izTextup: 'Textup',
  izTextdown: 'Textdown'
};

var LABEL_ROTATION_VALUES = {
  izNormal: 0,
  izCounterclockwise: -45,
  izClockwise: 45,
  izTextup: -90,
  izTextdown: 90
};

/* AXIS ALIGN */
var AXIS_ALIGN = {
  izHigh: 'high',
  izMiddle: 'middle',
  izLow: 'low'
};

var AXIS_ALIGN_VALUES = {
  izHigh: 'high',
  izMiddle: 'middle',
  izLow: 'low'
};

/* HORIZONTAL ALIGN */
var HORIZONTAL_ALIGN = {
  get izCenter() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_CENTER');
  },
  get izLeft() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_LEFT');
  },
  get izRight() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_RIGHT');
  }
};

var HORIZONTAL_ALIGN_VALUES = {
  izCenter: 'center',
  izLeft: 'left',
  izRight: 'right'
};

/* VERTICAL ALIGN */
var VERTICAL_ALIGN = {
  get izTop() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_TOP');
  },
  get izMiddle() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_MIDDLE');
  },
  get izBottom() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_BOTTOM');
  }
};

var VERTICAL_ALIGN_VALUES = {
  izTop: 'top',
  izMiddle: 'middle',
  izBottom: 'bottom'
};

var LAYOUT_ALIGN = {
  get izHorizontal() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_LAYOUT_HORIZONTAL');
  },
  get izVertical() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_LAYOUT_VERTICAL');
  }
};

var LAYOUT_ALIGN_VALUES = {
  izHorizontal: 'horizontal',
  izVertical: 'vertical'
};

/* ZOOM TYPE */
var ZOOM_TYPE = {
  izX: 'X',
  izY: 'Y',
  izXY: 'XY'
};

var ZOOM_TYPE_VALUES = {
  izX: 'x',
  izY: 'y',
  izXY: 'xy'
};

/* STEP TYPE */
var STEP_TYPE = {
  get izLeft() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_LEFT');
  },
  get izCenter() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_CENTER');
  },
  get izRight() {
    return _Izenda2.default.getText('CHART_DEFAULT_CONFIG_LABEL_RIGHT');
  }
};

var STEP_TYPE_VALUES = {
  izLeft: 'left',
  izCenter: 'center',
  izRight: 'right'
};

/* RANGE */
var RANGE = {
  get rangeOnly() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_RANGE_ONLY');
  },
  get rangeWithAverage() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_RANGE_WITH_AVERAGE');
  }
};

var PIE_CHART_STYPE = {
  get basic() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_BASIC');
  },
  get ring() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_RING');
  },
  get semiCirle() {
    return _Izenda2.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_SEMI_CIRCLE');
  }
};

var HEATMAP_DEFAULT_CONFIG = {
  MIN_COLOR: '#FFFFFF',
  LABEL_COLOR: '#000000',
  DEFAULT_SORT: {
    labels: 'Unsorted',
    values: 'Unsorted'
  }
};

var COMMON_DEFAULT_CONFIG = {
  DEFAULT_SORT: {
    labels: 'Unsorted',
    values: 'Unsorted',
    separators: 'ASC'
  }
};

var FUNNEL_DEFAULT_CONFIG = {
  DEFAULT_SORT: {
    labels: 'Unsorted',
    values: 'Unsorted',
    separators: 'ASC'
  }
};

var TREE_MAP_DEFAULT_CONFIG = {
  DEFAULT_SORT: {
    separators: 'ASC'
  }
};

var BUBBLE_DEFAULT_CONFIG = {
  DEFAULT_SORT: {
    labels: 'Unsorted',
    values: 'Unsorted'
  }
};

var SPARKLINE_DEFAULT_CONFIG = {
  DEFAULT_SORT: {
    intervals: 'Unsorted',
    labels: 'Unsorted',
    separators: 'ASC'
  }
};

var COMMON_GAUGE_DEFAULT_CONFIG = {
  DEFAULT_SORT: {
    labels: 'Unsorted',
    values: 'Unsorted',
    separators: 'ASC',
    sup_kpi: 'Unsorted'
  }
};

exports.default = {
  CHART_TYPE: CHART_TYPE,
  OptionsValue: {
    STACK_TYPE_CHART: STACK_TYPE_CHART,
    LINE_STYLE: LINE_STYLE,
    LABEL_ROTATION: LABEL_ROTATION,
    HORIZONTAL_ALIGN: HORIZONTAL_ALIGN,
    VERTICAL_ALIGN: VERTICAL_ALIGN,
    LAYOUT_ALIGN: LAYOUT_ALIGN,
    ZOOM_TYPE: ZOOM_TYPE,
    STEP_TYPE: STEP_TYPE,
    RANGE: RANGE,
    PIE_CHART_STYPE: PIE_CHART_STYPE
  },
  MappingValues: {
    AXIS_ALIGN_VALUES: AXIS_ALIGN_VALUES,
    STACK_TYPE_CHART_VALUES: STACK_TYPE_CHART_VALUES,
    LINE_STYLE_VALUES: LINE_STYLE_VALUES,
    LABEL_ROTATION_VALUES: LABEL_ROTATION_VALUES,
    HORIZONTAL_ALIGN_VALUES: HORIZONTAL_ALIGN_VALUES,
    VERTICAL_ALIGN_VALUES: VERTICAL_ALIGN_VALUES,
    LAYOUT_ALIGN_VALUES: LAYOUT_ALIGN_VALUES,
    ZOOM_TYPE_VALUES: ZOOM_TYPE_VALUES,
    STEP_TYPE_VALUES: STEP_TYPE_VALUES
  },

  DefaultConfig: {
    LEGEND_HORIZONTAL_ALIGNMENT: 'izRight',
    LEGEND_VERTICAL_ALIGNMENT: 'izBottom',
    LEGEND_LAYOUT_ALIGNMENT: 'izHorizontal',
    get METRIC_ALL() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    },
    HeatMap: HEATMAP_DEFAULT_CONFIG,
    Line: COMMON_DEFAULT_CONFIG,
    Column: COMMON_DEFAULT_CONFIG,
    Bar: COMMON_DEFAULT_CONFIG,
    Area: COMMON_DEFAULT_CONFIG,
    Pie: COMMON_DEFAULT_CONFIG,
    Funnel: FUNNEL_DEFAULT_CONFIG,
    Donut: COMMON_DEFAULT_CONFIG,
    Combination: COMMON_DEFAULT_CONFIG,
    TreeMap: TREE_MAP_DEFAULT_CONFIG,
    Bubble: BUBBLE_DEFAULT_CONFIG,
    Scatter: COMMON_DEFAULT_CONFIG,
    Waterfall: COMMON_DEFAULT_CONFIG,
    Sparkline: SPARKLINE_DEFAULT_CONFIG,
    SolidGauge: COMMON_GAUGE_DEFAULT_CONFIG,
    LinearGauge: COMMON_GAUGE_DEFAULT_CONFIG,
    SimpleGauge: COMMON_GAUGE_DEFAULT_CONFIG,
    Map: {}
  },

  getOptions: function getOptions(optionName, isGetKey) {
    var opts = this.OptionsValue[optionName];

    if (isGetKey) {
      var keys = (0, _keys2.default)(opts);
      var re = {};

      keys.forEach(function (keyProps) {
        re[keyProps] = keyProps;
      });

      return re;
    }

    return (0, _fp.chain)(opts).toPairs().map(function (item) {
      return {
        label: item[1],
        value: item[0]
      };
    }).value();
  }
};
module.exports = exports['default'];

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _maxSafeInteger = __webpack_require__(1299);

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _minSafeInteger = __webpack_require__(1302);

var _minSafeInteger2 = _interopRequireDefault(_minSafeInteger);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  fontFamily: {
    roboto: 'Roboto',
    georgia: 'Georgia',
    palatinoLinotype: 'Palatino Linotype',
    bookAntiqua: 'Book Antiqua',
    timesNewRoman: 'Times New Roman',
    arial: 'Arial',
    helvetica: 'Helvetica',
    arialBlack: 'Arial Black',
    impact: 'Impact',
    lucidaSansUnicode: 'Lucida Sans Unicode',
    tahoma: 'Tahoma',
    verdana: 'Verdana',
    courierNew: 'Courier New',
    lucidaConsole: 'Lucida Console'
  },
  fontSize: [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72],
  defaultFontSize: 14,
  defaultFontFamily: 'Roboto',
  defaultUnitType: 'px',
  copyright: 'Copyright 2016 Izenda, Inc.',
  columnWidthSetting: {
    get pixels() {
      return _Izenda2.default.getText('UI_CONSTANT_PIXELS');
    },
    get characters() {
      return _Izenda2.default.getText('UI_CONSTANT_CHARACTERS');
    }
  },
  borderColor: '#000',
  dashStyles: ['solid', 'dotted', 'dashed'],
  borderWidth: 1,
  borderWidthMin: 1,
  borderWidthMax: 6,
  reportPartGridDefault: {
    backgroundColor: '#fff'
  },
  backgroundColor: '#fff',
  textColor: '#000',
  textBackgrounColor: '#fff',
  defaultDashStyles: 'solid',
  MATH: {
    maxSignedInt32Bits: Math.pow(2, 31) - 1
  },
  SIZE: {
    WIDTH: {
      VALUE: null,
      UNIT: 'Pixels'
    }
  },

  Number: {
    DECIMAL_FORMAT: '-#,###.##',
    MIN: _minSafeInteger2.default,
    MAX: _maxSafeInteger2.default
  },

  CHECKBOX_STATUS: {
    CHECKED: 'checked',
    UNCHECK: 'unchecked',
    INDETERMINATE: 'indeterminate'
  },

  Messages: {
    get NoDataToShow() {
      return _Izenda2.default.getText('NO_DATA_TO_SHOW');
    }
  },
  UNDEFINED_VALUE: '[UNDEFINED VALUE]',
  NULL_VALUE: '[NULL]',
  BLANK_VALUE: '[BLANK]',
  dropdownMaxHeight: 240,
  DEFAUFT_DROPDOWN_ITEMS: 8,
  LAZY_LOADING_DEFAULT_ITEMS_NUMBER: 100,
  LAZY_LOADING_DEFAULT_PAGE_INDEX: 3,
  DEFAULT_DEBOUNCE_TIME: 500,
  MIDDLE_PANEL_LIST_MAX_HEIGHT: 780,
  BASE_PADDING_TOP_WITH_PARENT_PIXEL: 30,
  PAGING_SIZE_OPTIONS: [10, 25, 50, 100, 200],
  MASKED_TEXT: '●●●●●●●●●●'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.UIContants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var m = __webpack_require__(5);
  var LazyLoadingBar = __webpack_require__(351);
  var convertToDateTimeFormat = __webpack_require__(88);
  var convertToNumeralFormat = __webpack_require__(294);
  var routeUtils = __webpack_require__(31);
  var ReportPartElement = __webpack_require__(270);
  var ReportDesignerConstants = __webpack_require__(16);
  var ReportPartGridConstants = __webpack_require__(84);
  var ReportPartChartConstants = __webpack_require__(39);
  var commonDataUtils = __webpack_require__(2015);
  var reportPartElementUtils = __webpack_require__(171);
  var uiState = __webpack_require__(15);

  var fetcher = __webpack_require__(111);
  var validateExistingReport = fetcher.validateExistingReport;
  var validateExistingField = fetcher.validateExistingField;
  var cacheUtils = __webpack_require__(247);

  var moment = __webpack_require__(19);
  var ReportBodyConstants = __webpack_require__(53);
  var MESSAGE = ReportBodyConstants.MESSAGES;
  var ReportPartFieldConstants = __webpack_require__(64);
  var DEFAULT_FORMAT_BY_FUNCTION_DATA_TYPE = ReportPartFieldConstants.DEFAULT_FORMAT_BY_FUNCTION_DATA_TYPE;
  var DEFAULT_FORMAT_BY_DATA_TYPE = ReportPartFieldConstants.DEFAULT_FORMAT_BY_DATA_TYPE;
  var FIELD_FUNCTION_MODE = ReportPartFieldConstants.FIELD_FUNCTION_MODE;
  var FUNCTION = ReportPartFieldConstants.FUNCTION;
  var FUNCTION_GROUP_NAME = ReportPartFieldConstants.FUNCTION.GROUP.NAME;
  var TimeFormatConstants = __webpack_require__(176);
  var NumericAndMoneyFormatConstants = __webpack_require__(989);
  var DATE_TIME_FORMAT = TimeFormatConstants.DATE_TIME_FORMAT;
  var DATE_TIME_GROUP_BY = TimeFormatConstants.GROUP_BY;
  var FORMATS_NOT_AVAILABLE_FOR_RUNNING_FIELD = NumericAndMoneyFormatConstants.FORMATS_NOT_AVAILABLE_FOR_RUNNING_FIELD;
  var FORMATS_NOT_AVAILABLE_FOR_PART_TYPES = NumericAndMoneyFormatConstants.FORMATS_NOT_AVAILABLE_FOR_PART_TYPES;
  var FORMATS_ONLY_ON_PIVOT_GRID_VALUE_CONTAINER = NumericAndMoneyFormatConstants.FORMATS_ONLY_ON_PIVOT_GRID_VALUE_CONTAINER;
  var FORMAT_NOT_AVAILABLE_ON_FIELD_CAN_NOT_SET_SUBTOTAL = NumericAndMoneyFormatConstants.FORMAT_NOT_AVAILABLE_ON_FIELD_CAN_NOT_SET_SUBTOTAL;
  var DATA_TYPES = ReportDesignerConstants.DATA_TYPES;
  var REPORT_PART_TYPE = ReportDesignerConstants.REPORT_PART_TYPE;
  var GRID_STYLES = ReportPartGridConstants.GRID_STYLES;
  var GRID_CONTAINER_NAME = ReportPartGridConstants.CONTAINER_NAME;
  var AppGlobalConstants = __webpack_require__(115);
  var TIME_FORMAT = AppGlobalConstants.TIME_FORMAT;
  var EMPTY_GUID = __webpack_require__(50).EMPTY_GUID;
  var GridDefaultConfig = __webpack_require__(968);
  var ChartDefaultConfig = __webpack_require__(33);
  var FormDefaultConfig = __webpack_require__(2016);
  var AppGlobal = __webpack_require__(41);
  var config = __webpack_require__(40);

  var COLUMN_NAME_PREFIX = ReportDesignerConstants.COLUMN_NAME_PREFIX;

  var cacheOption = {
    persistent: true,
    resolver: function resolver() {
      return (0, _stringify2.default)(arguments);
    }
  };

  var getFunctionData = cacheUtils.memoize(commonDataUtils.getFunctionData, cacheOption);
  var getFormatData = cacheUtils.memoize(commonDataUtils.getFormatData, cacheOption);
  var getFunction = cacheUtils.memoize(commonDataUtils.getFunction, cacheOption);

  var _require = __webpack_require__(1),
      toString = _require.toString,
      head = _require.head,
      tail = _require.tail,
      invoke = _require.invoke,
      map = _require.map,
      mapValues = _require.mapValues,
      isUndefined = _require.isUndefined,
      curry = _require.curry,
      concat = _require.concat,
      escapeRegExp = _require.escapeRegExp,
      toNumber = _require.toNumber,
      isEmpty = _require.isEmpty,
      find = _require.find,
      isNil = _require.isNil,
      assign = _require.assign,
      flow = _require.flow,
      pick = _require.pick,
      forEach = _require.forEach,
      without = _require.without,
      isEqual = _require.isEqual,
      flatMap = _require.flatMap,
      uniqWith = _require.uniqWith,
      get = _require.get,
      getOr = _require.getOr,
      includes = _require.includes,
      inRange = _require.inRange,
      nth = _require.nth,
      has = _require.has,
      filter = _require.filter,
      first = _require.first,
      isBoolean = _require.isBoolean,
      remove = _require.remove,
      split = _require.split,
      last = _require.last,
      endsWith = _require.endsWith,
      startsWith = _require.startsWith,
      invokeArgs = _require.invokeArgs,
      isString = _require.isString,
      omit = _require.omit,
      each = _require.each,
      findIndex = _require.findIndex,
      some = _require.some,
      indexOfFrom = _require.indexOfFrom,
      reduce = _require.reduce,
      isNaN = _require.isNaN,
      isObject = _require.isObject;

  function buildDataSourceElement(reportPart, element) {
    return {
      columnName: flow(find({
        fieldNameAlias: element.field.fieldNameAlias
      }), get('columnName'))(reportPart.previewDataFieldsMapping),
      reportPartElm: element
    };
  }

  /**
   * get unique name for element
   * @method getUniqueName
   */
  function getUniqueName(reportPartContent, element, originalName) {
    var elements = flow(flatMap(flow(get('elements'), invoke('peek'))), without([element]))(reportPartContent.containerCollection);

    return String.generateNewName(originalName, elements, get('name'), '()');
  }

  /**
   * get new name after apply new function
   * @method getNewElementName
   */
  function getNewElementName(element, functionInfo) {
    var functionName = getOr('', 'name', functionInfo);
    var originalFunctionName = getOr('', 'properties.dataFormattings.functionInfo.name', element);
    var regexString = new RegExp(String.format(ReportBodyConstants.FIELD_NAME_ALIAS_REGEX, escapeRegExp(originalFunctionName)));
    var originalFieldNameAlias = element.name;

    if (regexString.test(originalFieldNameAlias)) {
      var matchGroup = regexString.exec(originalFieldNameAlias);

      originalFieldNameAlias = matchGroup[2] || matchGroup[3];
    }

    return !isEmpty(functionName) && functionName.indexOf('[') < 0 && functionName !== FUNCTION.GROUP.NAME ? String.format(ReportBodyConstants.FIELD_NAME_WITH_FUNCTION_TEMPLATE, functionName, originalFieldNameAlias) : originalFieldNameAlias;
  }

  function buildFilterDataSubReport(records, subReportMappingFields, previewDataFieldMapping) {
    var result = { success: true, filters: [] };
    var data = flow(m.toJS, map(mapValues(toString)))(records);

    result.filters = map(function (mappingField) {
      var selectedFieldMapping = find(function (fieldMapping) {
        return fieldMapping.fieldNameAlias === mappingField.fieldNameAlias;
      }, previewDataFieldMapping);

      if (!selectedFieldMapping) {
        result.success = false;
      }
      return {
        key: mappingField.fieldNameInSubReport,
        fieldNameAlias: mappingField.fieldNameAlias,
        columnName: get('columnName', selectedFieldMapping),
        linkReportFilter: true
      };
    }, subReportMappingFields);
    if (!result.success) {
      return result;
    }
    var listColumnName = map('columnName', result.filters);

    data = flow(map(pick(listColumnName)), uniqWith(isEqual))(data);

    if (data.length !== 1) {
      result.success = false;
      return result;
    }

    data = head(data);

    result.filters = map(function (filterItem) {
      var value = get(filterItem.columnName, data);
      var encodedValue = config.Integration ? encodeURIComponent(value) : value;

      return assign(filterItem, { value: encodedValue });
    }, result.filters);

    return result;
  }

  /**
   * set function for element
   * @method setFunctionElement
   */
  function setFunctionElement(reportPartContent, element, functionInfo, manualChange, keepOriginalName) {
    var newName = getNewElementName(element, functionInfo);
    var uniqueNewName = getUniqueName(reportPartContent, element, newName);

    !keepOriginalName && element.setName(uniqueNewName);
    element.properties.setFunction(functionInfo);

    return (0, _bluebird.resolve)(manualChange && invokeArgs('afterUpdateFunction', [element], reportPartContent));
  }

  /**
   * get default function for element
   * @method getDefaultFunctionFormat
   */
  function getDefaultFunctionFormat(reportPartContent, container, element) {
    var dataType = element.fieldDataType;
    var promiseFunction = (0, _bluebird.resolve)(null);
    var promiseFormat = (0, _bluebird.resolve)(null);

    if (!reportPartContent.getDefaultFunctionFormat || element.field.hasAggregatedFunction) {
      return getFormatData(dataType, getOr('', dataType, DEFAULT_FORMAT_BY_DATA_TYPE)).then(function (formatData) {
        return {
          functionData: {},
          formatData: formatData || {},
          defaultFunctionConfig: {}
        };
      });
    }

    var defaultData = reportPartContent.getDefaultFunctionFormat(container, dataType) || {
      FORMAT: { NAME: getOr('', dataType, DEFAULT_FORMAT_BY_DATA_TYPE) }
    };

    promiseFunction = getFunctionData(FIELD_FUNCTION_MODE.FieldProperty, dataType, getOr('', 'FUNCTION.NAME', defaultData));
    promiseFormat = getFormatData(dataType, getOr('', 'FORMAT.NAME', defaultData));

    return (0, _bluebird.join)(promiseFunction, promiseFormat, function (functionData, formatData) {
      return { functionData: functionData, formatData: formatData, defaultFunctionConfig: defaultData };
    });
  }

  function getDefaultFormat(configField, functionInfo) {
    functionInfo = functionInfo || configField.getValueByKey('functionInfo') || {};
    var dataType = functionInfo.formatDataType || configField.getValueByKey('dataFieldType');
    var functionName = getOr('', 'name', functionInfo);
    var defaultFormatName = get([dataType, functionName].join('.'), DEFAULT_FORMAT_BY_FUNCTION_DATA_TYPE) || get(dataType, DEFAULT_FORMAT_BY_DATA_TYPE);

    if (defaultFormatName) {
      return getFormatData(dataType, defaultFormatName);
    }
    return (0, _bluebird.resolve)();
  }

  /**
   * set default function for element
   * @method setDefaultFunctionElement
   */
  function setDefaultFunctionElement(reportPartContent, container, element) {
    return getDefaultFunctionFormat(reportPartContent, container, element).then(function (data) {
      data.formatData.id && element.properties.setFormat({
        formatId: data.formatData.customId,
        format: data.formatData.format,
        groupBy: data.formatData.groupBy,
        formatDataType: data.formatData.formatDataType
      });
      return setFunctionElement(reportPartContent, element, data.functionData, true);
    });
  }

  /**
   * set function for element without function
   * @method convertNonFunctionElementsToFunction
   * @param  {object}                             reportPartContent [description]
   * @param  {string}                             newFunctioName    !optional if don't provide use default function
   * @return {Promise}                                              [description]
   */
  function convertNonFunctionElementsToFunction(reportPartContent, newFunctioName) {
    return flow(flatMap(function (container) {
      return flow(filter({ haveFunction: false }), map(function (element) {
        if (newFunctioName) {
          var defaultFormatName = get([element.fieldDataType, newFunctioName].join('.'), DEFAULT_FORMAT_BY_FUNCTION_DATA_TYPE);
          var defaultFormatPromise = (0, _bluebird.resolve)({});

          if (defaultFormatName) {
            defaultFormatPromise = getFormatData(element.fieldDataType, defaultFormatName);
          }
          return (0, _bluebird.join)(defaultFormatPromise, getFunctionData(FIELD_FUNCTION_MODE.FieldProperty, element.fieldDataType, newFunctioName), m.action(function (formatData, functionData) {
            formatData.id && element.properties.setFormat({
              formatId: formatData.id,
              format: formatData.format,
              groupBy: formatData.groupBy,
              formatDataType: formatData.formatDataType
            });
            return setFunctionElement(reportPartContent, element, functionData);
          }));
        }
        return setDefaultFunctionElement(reportPartContent, container, element);
      }))(container.elements.peek());
    }), _bluebird.all)(reportPartContent.containerCollection);
  }

  // common check for function with have config object
  function checkCompatibleFunctionCommon(functionInfo, element, config) {
    var result = true;
    var hasAggregatedFunction = element.field.hasAggregatedFunction;
    var functionName = getOr(ReportPartFieldConstants.EMPTY_FUNCTION.name, 'name', functionInfo);

    if (functionInfo.userDefined) {
      // if function is userDefined treat it like group function
      functionName = FUNCTION.GROUP.NAME;
    }

    if (config.SUPPORTED) {
      var supportedList = config.SUPPORTED[element.fieldDataType] || config.SUPPORTED.DEFAULT;
      var supportedFunction = map('NAME', supportedList);

      hasAggregatedFunction && (supportedFunction = concat([ReportPartFieldConstants.EMPTY_FUNCTION.name], supportedFunction));
      result = includes(functionName, supportedFunction);
    }
    if (config.UNSUPPORTED) {
      var unsupportedList = config.UNSUPPORTED[element.fieldDataType] || config.UNSUPPORTED.DEFAULT;
      var unsupportedFunction = map('NAME', unsupportedList);

      hasAggregatedFunction && (unsupportedFunction = without([ReportPartFieldConstants.EMPTY_FUNCTION.name], unsupportedFunction));
      result = result && !includes(functionName, unsupportedFunction);
    }
    return result;
  }

  /**
   * @method checkedCompatibleFunctionHasAggregatedFunction
   * @param  {object}                                       functionInfo [description]
   * @return {Boolean}                                                    [description]
   */
  function checkedCompatibleFunctionHasAggregatedFunction(functionInfo) {
    return !functionInfo.name || functionInfo.userDefined;
  }

  /**
   * Apply data format to value
   * @param  {any} fieldValue
   * fieldValue {
        originalValue:
        value:
      }
   * @param  {object} fieldConfig
   * @param  {array} dataSource
   * @param  {array} isApplyAlternativeText
   * @return {string}
   */
  function getDataFormat(fieldValue, fieldConfig, dataSource, isApplyAlternativeText) {
    var _ref = isObject(fieldValue) ? fieldValue : { value: fieldValue, originalValue: null },
        value = _ref.value,
        originalValue = _ref.originalValue;

    if (isNil(fieldConfig)) {
      return value;
    }

    // apply alternative text by default
    isApplyAlternativeText = !isBoolean(isApplyAlternativeText) || isApplyAlternativeText;

    var valueForAlternativeText = !isNil(originalValue) ? originalValue : value;
    var alternativeText = isApplyAlternativeText && getAlternativeText(valueForAlternativeText, fieldConfig, dataSource);

    return alternativeText || applyFormater(fieldConfig.fieldDataType, fieldConfig.fieldFormatData, value, dataSource);
  }

  function applyFormater(dataType, fieldFormat, value, dataSource) {
    if (dataType === DATA_TYPES.TIME) {
      fieldFormat = fieldFormat || TIME_FORMAT;
    }

    if (!fieldFormat) {
      return value;
    }

    var fnFormatter;
    var inputFormat;

    switch (dataType) {
      case DATA_TYPES.NUMERIC:
      case DATA_TYPES.MONEY:
        fnFormatter = convertToNumeralFormat;
        break;
      case DATA_TYPES.TIME:
      case DATA_TYPES.DATE_TIME:
        inputFormat = get('element.reportPartElm.dateTimeFormatData.dataFormat', dataSource);
        var dateConfig = DATE_TIME_FORMAT[fieldFormat];

        if (dateConfig && dateConfig.FOR_DATE_SETTING && !includes(uiState.currentUser.dateFormat, dateConfig.FOR_DATE_SETTING)) {
          var groupBy = dateConfig.GROUP_BY;

          fieldFormat = DATE_TIME_GROUP_BY[groupBy].DEFAULT_FORMAT[uiState.currentUser.dateFormat];
        }
        fnFormatter = convertToDateTimeFormat;
        break;
      default:
      // do nothing
    }

    return fnFormatter ? fnFormatter(fieldFormat, value, null, inputFormat) : value;
  }

  function valueInRange(checkValue, item) {
    return inRange(toNumber(item.from), toNumber(item.to), checkValue) || checkValue === toNumber(item.to);
  }

  function getConfigDataByRange(value, configData, dataSource) {
    if (isNil(value) || !configData) {
      return null;
    }

    var fieldElement = get('element', dataSource);
    var definedText = [];
    var dateObject = null;

    if (get('reportPartElm.previewDataType', fieldElement) === DATA_TYPES.TIME) {
      value = convertToDateTimeFormat(TIME_FORMAT, value, false);
    }

    if (configData.value && configData.value.length) {
      // config by value
      dateObject = checkDateValue();
      definedText = configData.value.filter(function (item) {
        if (dateObject) {
          // compare between string and int
          return dateObject.value == item.key;
        }
        return value.toString().toUpperCase() === item.key.toString().toUpperCase();
      });
    } else if (configData.rangeValue && configData.rangeValue.length) {
      // config by range value
      dateObject = checkDateValue();
      definedText = configData.rangeValue.filter(function (item) {
        if (dateObject) {
          if (item.from <= item.to) {
            return item.from <= dateObject.value && dateObject.value <= item.to;
          }
          return item.from <= dateObject.value || dateObject.value <= item.to;
        }
        return valueInRange(toNumber(value), item);
      });
    } else if (configData.rangePercent && configData.rangePercent.length && has('record', dataSource)) {
      // config by range percent
      var valueByPercent = get(COLUMN_NAME_PREFIX.PERCENTAGE_VALUE + get('columnName', fieldElement), dataSource.record);

      definedText = !isNil(valueByPercent) && configData.rangePercent.filter(function (item) {
        return valueInRange(toNumber(valueByPercent), item);
      });
    }

    return get('text', head(definedText));

    function checkDateValue() {
      var dateTimeFormatData = get('reportPartElm.dateTimeFormatData', fieldElement);

      if (dateTimeFormatData) {
        var dateObj = dateTimeFormatData.dataFormat === 'D' // special case for day, we don't want to moment js to  use current month,
        ? // because current month may have only 28 day for feb
        // forcing all case to make sure it will convert to same month if return date object for chart
        moment().startOf('year').date(value) : moment(value, dateTimeFormatData.dataFormat, true);

        if (dateObj.isValid()) {
          var formattedValue = dateObj.format(dateTimeFormatData.compareFormat);
          // Day of week on FE use start of day 0, BE use 1
          if (dateTimeFormatData.compareFormat === 'E') {
            var dow = parseInt(value);
            if (!isNaN(dow) && dow >= 1 && dow <= 7) {
              formattedValue = nth(value, TimeFormatConstants.DAY_OF_WEEK_VALUES);
            }
          }
          return { value: formattedValue, format: dateTimeFormatData.compareFormat };
        }
      }
      return null;
    }
  }

  /**
   * Get alternative text
   * @param  {string} value           value need change to alternative text
   * @param  {object} alternativeText alternative text settings
   * @param  {array} dataSource       list field source
   */
  function getAlternativeText(value, fieldConfig, dataSource) {
    if (!fieldConfig || !fieldConfig.alternativeText) {
      return null;
    }

    // special case for null values only for Text fields to treat null as "null"
    if (isNil(value) && fieldConfig.fieldDataType === DATA_TYPES.TEXT) {
      var convertNullToEmpty = AppGlobal.advancedSettings.other.convertNullToEmptyStringValue;
      value = String.commonStringValue(value, convertNullToEmpty);
    }

    return getConfigDataByRange.call(null, value, fieldConfig.alternativeText, dataSource);
  }

  function openHyperlinkAction(props, fieldConfig, record, CommonActionPopup) {
    var subReport = get('subReport', fieldConfig);
    var customURL = get('customURL', fieldConfig);
    var embeddedJavascript = get('embeddedJavascript', fieldConfig);
    var numberOfPointActions = get('numberOfPointActions', fieldConfig);

    if (numberOfPointActions === 1) {
      get('selectedReport', subReport) && routeUtils.openSubReport(props, subReport, record, fieldConfig);
      get('url', customURL) && openCustomURL(props, customURL, record, fieldConfig);
      get('script', embeddedJavascript) && performEmbeddedJavascript(props, embeddedJavascript, record, fieldConfig);
    } else if (numberOfPointActions > 1) {
      props.openPopup(CommonActionPopup, { fieldConfig: fieldConfig }).then(function (action) {
        action === 'openSubReport' && routeUtils.openSubReport(props, subReport, record, fieldConfig);
        action === 'openCustomURL' && openCustomURL(props, customURL, record, fieldConfig);
        action === 'performEmbeddedJavascript' && performEmbeddedJavascript(props, embeddedJavascript, record, fieldConfig);
      });
    }
  }

  function openCustomURL(props, customURL, record, fieldConfig) {
    var reportPart = props.reportPart;
    var URL = customURL.url;
    var previewData = m.toJS(reportPart.previewData);
    var previewFieldsMapping = previewData.fieldsMapping;

    var httpReg = /^https?:\/\//i;
    var isExternal = httpReg.test(URL);

    return validateURL(reportPart, record, URL, isExternal, fieldConfig).then(function (msg) {
      if (!isEmpty(msg)) {
        return props.confirmMessage('error', msg.join(', '));
      }

      var mappingField;

      if (isExternal) {
        mappingField = getFilterMappingValuesWithExternalURL(record, previewFieldsMapping, URL, fieldConfig);
        routeUtils.openCustomURL(props, customURL, mappingField.filters, null, isExternal, fieldConfig);
      } else {
        mappingField = getFilterMappingValuesWithInternalURL(record, previewFieldsMapping, URL);
        var catAndReportName = findCatAndReportNameInUrl(URL);

        fetcher.getReportIdByNameAndCateName(catAndReportName.cat, catAndReportName.re, uiState.tenantId).then(function (result) {
          if (result.data) {
            var reportId = result.data;

            routeUtils.openCustomURL(props, customURL, mappingField.filters, reportId, isExternal, fieldConfig);
          }
        });
      }
    });
  }

  /**
   * Validate and execute embedded javascript
   * @param {any} props
   * @param {any} embeddedJavascript
   * @param {any} record
   * @param {any} fieldConfig
   */
  function performEmbeddedJavascript(props, embeddedJavascript, record, fieldConfig) {
    var reportPart = props.reportPart,
        previewFieldsMapping = props.reportPart.previewData.fieldsMapping;

    var script = embeddedJavascript.script;
    var httpReg = /^https?:\/\//i;

    // find all Urls in script
    var parseURlInScript = [];
    var regex = /urldecode<.*>/gi;
    var httpRegex = /(?:"|')https?:\/\/\S+(?:"|')/gi;
    var matched = void 0;

    while (matched = regex.exec(script)) {
      parseURlInScript.push({
        url: matched[0].substring('urldecode<'.length, matched[0].length - 1),
        index: matched.index,
        length: matched[0].length
      });
    }

    // Find url in script
    // Ex: window.open("http://www.google.com/?q={[ShipCountry]}")
    // matched = '"http://www.google.com/?q={[ShipCountry]}"'
    while (matched = httpRegex.exec(script)) {
      matched[0] = matched[0].substring(1, matched[0].length - 1);
      parseURlInScript.push({
        url: matched[0],
        index: matched.index + 1,
        length: matched[0].length
      });
    }

    (0, _bluebird.map)(parseURlInScript, function (_ref2) {
      var url = _ref2.url;
      return validateURL(reportPart, record, url, httpReg.test(url), fieldConfig);
    }).then(function (result) {
      var validateMessage = [];
      for (var i = 0; i < result.length; i++) {
        !isEmpty(result[i]) && validateMessage.push(result[i].join(', '));
      }

      // show error message if one of url in script has error
      if (!isEmpty(validateMessage[0])) {
        return props.confirmMessage('error', validateMessage[0]).then(function () {
          throw new Error();
        });
      }
    }).then(function () {
      // build urls with params replaced
      var getURLLinkPromise = [];

      parseURlInScript.forEach(function (item, index) {
        var url = item.url;
        var isExternal = httpReg.test(url);
        var mappingField = void 0;

        if (isExternal) {
          mappingField = getFilterMappingValuesWithExternalURL(record, previewFieldsMapping, url, fieldConfig);
          item.url = routeUtils.getCustomURLExternalLink(url, mappingField.filters);
        } else {
          mappingField = getFilterMappingValuesWithInternalURL(record, previewFieldsMapping, url);
          var catAndReportName = findCatAndReportNameInUrl(url);

          getURLLinkPromise.push(fetcher.getReportIdByNameAndCateName(catAndReportName.cat, catAndReportName.re, uiState.tenantId).then(function (_ref3) {
            var reportId = _ref3.data;

            if (reportId) {
              return {
                index: index,
                url: routeUtils.getCustomURLInternalLink(mappingField.filters, reportId)
              };
            }
          }));
        }
      });

      return (0, _bluebird.all)(getURLLinkPromise).then(function (result) {
        for (var i = 0; i < result.length; i++) {
          !isEmpty(result[i]) && (parseURlInScript[result[i].index].url = result[i].url);
        }
      });
    }).then(function () {
      parseURlInScript.forEach(function (item) {
        script = String.replaceAt(script, item.index, item.length, item.url);
      });
      var mappingField = getFilterMappingValuesWithExternalURL(record, previewFieldsMapping, script, fieldConfig);
      var formattedScript = routeUtils.getCustomURLExternalLink(script, mappingField.filters, fieldConfig);
      try {
        // NOSONAR
        new Function(formattedScript)();
      } catch (error) {
        return props.confirmMessage('error', MESSAGE.M11);
      }
    }).catch(function () {
      // do nothing
    });
  }

  function addContainers(source, containerName) {
    source[containerName] = {
      elements: [],
      name: containerName,
      visibleElement: function visibleElement() {
        return filter('isVisible', this.elements);
      },
      numElement: function numElement() {
        return this.visibleElement.length;
      }
    };
  }

  /**
   * Add in custom containers
   * @param {Array<any>} customContainers
   * @param {string} containerName
   * @returns {Object}
   */
  function addCustomContainers(customContainers, containerName) {
    var container = {
      elements: [],
      name: containerName,
      visibleElement: function visibleElement() {
        return filter('isVisible', this.elements);
      },
      numElement: function numElement() {
        return this.visibleElement.length;
      }
    };

    // Cannot use push() here. It makes mobx becomes unstable.
    customContainers.splice(-1, 0, container);

    return container;
  }

  function hasElement() {
    var isAllContainer = first(arguments);
    var dataContainerArr;

    if (isBoolean(isAllContainer)) {
      dataContainerArr = tail(arguments) || [];
    } else {
      isAllContainer = true;
      dataContainerArr = arguments;
    }

    var count = reduce(function (re, dataContainer) {
      dataContainer = isString(dataContainer) ? this[dataContainer] : dataContainer;

      var visibleElement = dataContainer.visibleElement || dataContainer.elements;
      var hasElement = visibleElement && visibleElement.length;

      return isAllContainer ? re && hasElement : re || hasElement;
    }.bind(this), isAllContainer, dataContainerArr);

    return count > 0;
  }

  function hasAtLeastElement() {
    return hasElement.apply(this, concat([false], arguments));
  }

  function getElements(container, activeSerieKey, containerName) {
    var elms = container && container.visibleElement || [];
    var checkContainer = containerName ? containerName === get('name', container) : true;

    if (checkContainer && activeSerieKey) {
      return elms.filter(function (elm) {
        return elm.fieldName === activeSerieKey;
      });
    }

    return elms;
  }

  function populateReportChartContainer(data, name, callback) {
    var source = {};

    addContainers(source, name);

    if (!data) {
      return source;
    }

    var pickData = omit('elements', data);
    var elements = data.elements;
    var elm;

    !pickData.name && (pickData.name = name);

    /* convert elements json object to become list of ReportPartElement*/
    var convertElements = map(function (item) {
      elm = new ReportPartElement().readData(item);
      callback && callback(pickData, elm, item);

      return elm;
    }, elements);

    source[name].elements = convertElements || [];

    m.extendObservable(pickData, source[name]);

    return pickData;
  }

  function populateReportChartCustomContainer(data, customContainers) {
    each(function (container) {
      var customContainer = find({ name: container.name }, customContainers);
      if (isNil(customContainer)) {
        customContainer = addCustomContainers(customContainers, name);
      }

      /* convert elements json object to become list of ReportPartElement*/
      var convertElements = map(function (item) {
        return new ReportPartElement().readData(item);
      }, container.elements);

      customContainer.elements = convertElements;
    }, data);
  }

  function buildMappingFields(reportPartType, subReport, filters) {
    switch (reportPartType) {
      case 0: // chart
      case 2: // gauge
      case 4:
        // map
        return buildMappingFieldsForChart(subReport, filters);
      default:
        return filters;
    }
  }

  function buildMappingFieldsForChart(subReport, filters) {
    var mappingFields = getOr([], 'mappingFields', subReport);
    var mappingField;

    each(function (filterItem) {
      mappingField = findMappingField(filterItem.key, mappingFields);

      filterItem.key = mappingField ? mappingField.fieldNameInSubReport : null;
    }, filters);

    return remove(isNil, filters);

    function findMappingField(fieldSourceName, mappingFields) {
      return find(function (mappingField) {
        return fieldSourceName === mappingField.fieldNameAlias;
      }, mappingFields);
    }
  }

  function validateURL(reportPart, foundRecords, url, isExternal, fieldConfig) {
    var fieldCollection = reportPart.fieldCollection;
    var previewData = m.toJS(reportPart.previewData);
    var previewFieldsMapping = previewData.fieldsMapping;

    var errorMessage = [];
    var mappingValues;
    var currentReportColumns = findColumnInURL(url);
    var fieldNameNotFound = [];

    currentReportColumns.forEach(function (column) {
      findIndex({ fieldName: column }, fieldCollection) === -1 && fieldNameNotFound.push(column);
    });
    if (!isEmpty(fieldNameNotFound)) {
      errorMessage.push(String.format(MESSAGE.M12, fieldNameNotFound.join(', ')));
      return (0, _bluebird.resolve)(errorMessage);
    }

    // validate reportName
    // does column exists
    // Check whether it has many data values
    if (isExternal) {
      mappingValues = getFilterMappingValuesWithExternalURL(foundRecords, previewFieldsMapping, url, fieldConfig);
      !mappingValues.success && errorMessage.push(MESSAGE.L02);
    } else {
      mappingValues = getFilterMappingValuesWithInternalURL(foundRecords, previewFieldsMapping, url);
      !mappingValues.success && errorMessage.push(MESSAGE.L02);
      var names = findCatAndReportNameInUrl(url);
      var catName = names.cat;
      var reportName = names.re;

      return validateExistingReport(catName, reportName, uiState.tenantId).then(function (result) {
        !result.data && errorMessage.push(MESSAGE.M11);
        return result.data;
      }).then(function (result) {
        if (result) {
          var destinationReportColumns = findColumnInURL(url);

          return validateExistingField(catName, reportName, destinationReportColumns, uiState.tenantId).then(function (result) {
            !result.data && errorMessage.push(String.format(MESSAGE.M13, destinationReportColumns.join(',')));
            return errorMessage;
          });
        }
        return errorMessage;
      });
    }

    return (0, _bluebird.resolve)(errorMessage);

    function findColumnInURL(url) {
      // Find p value like {[ShipCountry]}
      var fieldNamesRegex = /{\[(.*?)\]}/g;
      var groups = void 0,
          columns = [];
      while (groups = fieldNamesRegex.exec(url)) {
        columns.push(groups[1]);
      }

      return columns;
    }
  }

  function findCatAndReportNameInUrl(url) {
    var getCatAndReportName = flow(split('&'), head, split('?'), last, split('='), last);
    var cateAndReportName = getCatAndReportName(url);
    var cateName = head(cateAndReportName.split('/'));
    var reportName = last(cateAndReportName.split('/'));

    return { cat: cateName === ReportDesignerConstants.UNCATEGORIZED ? null : cateName, re: reportName };
  }

  function getFilterMappingValuesWithExternalURL(records, previewFieldsMapping, url, fieldConfig) {
    var getUrlMappingField = function getUrlMappingField(url) {
      var charIndex = 0;
      var startIndex = 0;
      var endIndex = 0;
      var length = getOr(0, 'length', url);
      var fieldText = '';
      var fieldMapping = [];

      if (isString(url)) {
        while (charIndex < length) {
          startIndex = indexOfFrom('{', charIndex, url);
          if (startIndex < 0) {
            break;
          }
          endIndex = indexOfFrom('}', startIndex, url);

          if (endIndex < 0) {
            break;
          }
          fieldText = url.substring(startIndex + 1, endIndex);
          if (fieldText === '0') {
            fieldMapping.push({ fieldNameAlias: fieldConfig.fieldElement.fieldNameAlias });
          } else if (startsWith('[', fieldText) && endsWith(']', fieldText)) {
            fieldMapping.push({
              fieldNameAlias: fieldText.substring(1, fieldText.length - 1)
            });
          }
          charIndex = endIndex + 1;
        }
      }
      return fieldMapping;
    };

    return buildFilterDataSubReport(records, getUrlMappingField(url), previewFieldsMapping);
  }

  function getFilterMappingValuesWithInternalURL(records, previewFieldsMapping, url) {
    var getUrlMappingField = flow(split('&'), tail, map(function (item) {
      var splitItem = item.split('=');

      if (splitItem.length === 2) {
        return {
          fieldNameInSubReport: splitItem[0].indexOf('{') > -1 ? splitItem[0].substring(1, splitItem[0].length - 1) : splitItem[0],
          fieldNameAlias: splitItem[1].substring(1, splitItem[1].length - 1)
        };
      }
    }));

    return buildFilterDataSubReport(records, getUrlMappingField(url), previewFieldsMapping);
  }

  function getContainerByField(containerCollection, field) {
    m.untracked(function () {
      if (!field) {
        return null;
      }
      return filter(function (container) {
        var found = filter(function (item) {
          return item === field;
        });

        return !!found;
      }, containerCollection);
    });
  }

  /**
   * Reset report part setting to default for threshold and xy plane on chart setting
   * @param  {Array} elements  list of elements field
   * @param  {string} key      'threshold or axis'
   */
  function resetDefaultSetting(elements, key) {
    flow(flatMap(function (element) {
      return element.properties.otherProps;
    }), forEach(function (otherProps) {
      otherProps[key] = undefined;
    }))(elements);
  }

  /**
   * Transform cross filter's filter into report part.
   * @param {Object} reportPart
   * @param {Array} filters
   */
  function transformFilterWithReportPart(reportPart, filters) {
    return map(function (item) {
      var key = void 0;
      var sourceAlias = get('field.reportPartElm.field.sourceAlias', item);
      var fieldName = get('field.reportPartElm.field.fieldName', item);
      var functionName = get('field.reportPartElm.properties.dataFormattings.functionInfo.name', item);
      var relationshipId = get('field.reportPartElm.field.relationshipId', item);
      var fieldId = get('field.reportPartElm.field.fieldId', item);
      var finalFieldId = null;

      if (isEmpty(fieldId)) {
        return item;
      }

      if (functionName === FUNCTION_GROUP_NAME || isEmpty(get('field.reportPartElm.properties.dataFormattings.functionInfo.id', item))) {
        if (isNil(relationshipId) || relationshipId === EMPTY_GUID) {
          key = null;
          finalFieldId = fieldId;
        } else {
          key = '[' + sourceAlias + '].[' + fieldName + ']';
        }
      } else {
        key = flow(find(function (item) {
          var relationshipIdValue = get('field.relationshipId', item);
          return get('field.fieldName', item) === fieldName && get('field.sourceAlias', item) === sourceAlias && (relationshipIdValue === relationshipId || isEmpty(relationshipIdValue)) && get('properties.dataFormattings.functionInfo.name', item) === functionName;
        }), get('field.fieldNameAlias'))(get('fieldCollection', reportPart));
      }

      var transformedFitler = {
        isCrossFilter: true,
        key: toString(key),
        value: item.value,
        dataFormat: get('field.reportPartElm.properties.dataFormattings.format.formatId', item)
      };

      finalFieldId && (transformedFitler.fieldId = finalFieldId);
      return transformedFitler;
    }, filters);
  }

  /**
   * Get default sort from default report part config.
   * @param {Object} defaultConfig
   * @param {String} reportPartStyle
   * @param {String} containerName
   * @return {String} defaultSort
   */
  function getDefaultSortFromDefaultConfig(defaultConfig, reportPartStyle, containerName) {
    return flow(get(reportPartStyle), get('DEFAULT_SORT'), get(containerName))(defaultConfig);
  }

  /**
   * Get default sort
   * @param {String} reportPartType
   * @param {String} reportPartStyle
   * @param {String} containerName
   * @return {String} defaultSort
   */
  function getDefaultSort(reportPartType, reportPartStyle, containerName) {
    switch (reportPartType) {
      case ReportDesignerConstants.REPORT_PART_TYPE.Grid:
        return getDefaultSortFromDefaultConfig(GridDefaultConfig.DefaultConfig, reportPartStyle, containerName);
      case ReportDesignerConstants.REPORT_PART_TYPE.Chart:
      case ReportDesignerConstants.REPORT_PART_TYPE.Gauge:
      case ReportDesignerConstants.REPORT_PART_TYPE.Map:
        return getDefaultSortFromDefaultConfig(ChartDefaultConfig.DefaultConfig, reportPartStyle, containerName);
      case ReportDesignerConstants.REPORT_PART_TYPE.Form:
        return getDefaultSortFromDefaultConfig(FormDefaultConfig.DefaultConfig, 'Form', containerName);
      default:
        return 'ASC';
    }
  }

  /**
   * Render lazy loading bar.
   */
  function renderLazyLoadingBar() {
    return React.createElement(LazyLoadingBar, { className: 'u_fullSize u_flex u_flexCenterAlignItems' });
  }

  /**
   * Check to render lazy loading bar
   * @param {Object} reportPart
   * @param {Boolean} printingMode
   */
  function needToRenderLazyLoadingBar(reportPart, printingMode) {
    if (printingMode) {
      return isNil(reportPart);
    } else {
      var isLoadingData = get('isLoadingData', reportPart);
      return isLoadingData === undefined || isLoadingData === true;
    }
  }

  /**
   * Filter format list to display
   * @param {*} reportPartContent
   * @param {*} formats
   * @param {*} isRunningField
   * @param {*} containerName
   */
  function filterFormatForField(reportPartContent, formats, isRunningField, containerName) {
    var partType = get('type', reportPartContent);
    var isPivotGrid = partType === REPORT_PART_TYPE.Grid && get('properties.generalInfo.gridStyle', reportPartContent) === GRID_STYLES.PIVOT.value;
    var isFieldInValuesContainerOfPivotGrid = isPivotGrid && containerName === GRID_CONTAINER_NAME.VALUES;

    var isFieldInColumnsContainerOfPivotGrid = isPivotGrid && containerName === GRID_CONTAINER_NAME.COLUMNS;

    var isInSeparatorContainerOfGrid = partType === REPORT_PART_TYPE.Grid && containerName === GRID_CONTAINER_NAME.SEPARATORS;

    return remove(function (format // Remove format for only part types
    ) {
      return includes(partType, FORMATS_NOT_AVAILABLE_FOR_PART_TYPES.partType) && includes(format.name, FORMATS_NOT_AVAILABLE_FOR_PART_TYPES.formats) || // Remove format not on running field
      isRunningField && includes(format.name, FORMATS_NOT_AVAILABLE_FOR_RUNNING_FIELD) || // Remove format only on pivot
      !isFieldInValuesContainerOfPivotGrid && includes(format.name, FORMATS_ONLY_ON_PIVOT_GRID_VALUE_CONTAINER) || // Remove format not available for fields can not set subtotal
      (isInSeparatorContainerOfGrid || isFieldInColumnsContainerOfPivotGrid) && includes(format.name, FORMAT_NOT_AVAILABLE_ON_FIELD_CAN_NOT_SET_SUBTOTAL);
    }, formats);
  }

  /**
   * Determine linear type from configField
   * @param {any} configField
   * @param {any} defaultOptionsByType
   */
  function isLinear(configField, defaultOptionsByType) {
    // Get type of xAxis
    var xAxisTypeCategory = get('properties.otherProps.axis.izCategory', configField);
    var fieldType = get('previewDataTypeByFunction', configField);
    var chartHaveXYPlaneSetting = defaultOptionsByType.hasOwnProperty('izXYplane');

    return chartHaveXYPlaneSetting && !xAxisTypeCategory && includes(fieldType, ReportPartChartConstants.LIST_COUNTABLE_DATA_TYPE);
  }

  /**
   * check if field in subtotal expressions
   * @param   {Object}  gridStyle             grid style
   * @param   {Object}  container             container
   * @param   {Object}  configField           current selected field
   * @param   {Object}  containerCollection   containerCollection info
   * @return  {Boolean}                       [can field allow unsort]
   */
  function checkCanUnsort(gridStyle, container, configField, containerCollection) {
    var containerName = getOr('', 'name', container);

    switch (gridStyle) {
      case ReportPartGridConstants.GRID_STYLES.VERTICAL.value: // VERTICAL
      case ReportPartGridConstants.GRID_STYLES.HORIZONTAL.value:
        // HORIZONTAL
        if (containerName === ReportPartGridConstants.CONTAINER_NAME.SEPARATORS) {
          return false;
        }
        if (!isUndefined(configField) && isFieldInSubtotalExpression(configField, containerCollection) && getTotalField(containerCollection) > 32) {
          return false;
        }
        return true;
      case ReportPartGridConstants.GRID_STYLES.DRILL_DOWN.value:
        // DRILL_DOWN
        return false;
      case ReportPartGridConstants.GRID_STYLES.PIVOT.value:
        // PIVOT
        return containerName === ReportPartGridConstants.CONTAINER_NAME.ROWS;
    }

    return false;
  }

  /**
   * Get total fields of grid
   * @param {Array} containerCollection
   */
  function getTotalField(containerCollection) {
    return flow(map(function (x) {
      return x.elements;
    }), flatMap(observableToArray))(containerCollection).length;
  }

  /**
   * check if field in subtotal expressions
   * @param   {Object}  configField           current selected field
   * @param   {Object}  containerCollection   containerCollection info
   * @return  {Boolean}
   */
  function isFieldInSubtotalExpression(configField, containerCollection) {
    if (configField.hasSubTotal && !isEmpty(configField.properties.dataFormattings.subTotal.function)) {
      return true;
    }
    return flow(map(function (x) {
      return x.elements;
    }), flatMap(observableToArray), filter(function (x) {
      return !isUndefined(x) && x.hasSubTotal;
    }), some(
    // && !isEmpty(x.properties.dataFormattings.function)),
    function (x) {
      return getOr('', 'properties.dataFormattings.subTotal.expression', x).toLowerCase().includes('[' + configField.fieldName.toLowerCase() + ']');
    }))(containerCollection);
  }

  /**
   * Return an object contain formated value and original value
   * @param {String} columnName field mapping name
   * @param {Object} record contain record returned form api
   */
  function getFieldValue(columnName, record) {
    var originalFieldName = ReportPartChartConstants.CUSTOM_FORMAT_PREFIX + columnName;
    var value = get(columnName, record);
    var originalValue = getOr(value, originalFieldName, record);
    return {
      value: value,
      originalValue: originalValue
    };
  }

  /**
   * get original value of a field
   * @param {Object} field
   * @param {Object} record
   * @returns {any}
   */
  function getOriginalValue(field, record) {
    var columnName = get('columnName', field);
    if (isNil(columnName)) {
      return undefined;
    }

    return !isNil(field) && reportPartElementUtils.checkUsingCustomFormat(field) ? get(ReportPartChartConstants.CUSTOM_FORMAT_PREFIX + columnName, record) : get(columnName, record);
  }

  /**
   * convert array of observable to array
   * @param   {ObservableArray}  observable   current selected field
   * @return  {Array}                         [container with elements typeof ReportPartElement]
   */
  var observableToArray = curry(function (observable) {
    var arrResult = [];
    observable.forEach(function (item) {
      return arrResult.push(item);
    });
    return arrResult;
  });

  module.exports = {
    getAlternativeText: getAlternativeText,
    getDefaultFunction: function getDefaultFunction(soure, type) {
      return get(type || '', soure) || get('Others', soure);
    },
    getFieldValue: getFieldValue,
    getOriginalValue: getOriginalValue,
    /**
     * Get data format of value based on its config
     * @type {[type]}
     */
    getDataFormat: getDataFormat,
    applyFormater: applyFormater,
    getConfigDataByRange: getConfigDataByRange,
    getFormatInfo: getFormatData,
    getDefaultFormat: getDefaultFormat,
    openHyperlinkAction: openHyperlinkAction,
    openCustomURL: openCustomURL,
    performEmbeddedJavascript: performEmbeddedJavascript,
    getDefaultFunctionFormat: getDefaultFunctionFormat,
    convertNonFunctionElementsToFunction: convertNonFunctionElementsToFunction,
    setDefaultFunctionElement: setDefaultFunctionElement,
    setFunctionElement: setFunctionElement,
    addContainers: addContainers,
    addCustomContainers: addCustomContainers,
    hasElement: hasElement,
    checkedCompatibleFunctionHasAggregatedFunction: checkedCompatibleFunctionHasAggregatedFunction,
    checkCompatibleFunctionCommon: checkCompatibleFunctionCommon,
    hasAtLeastElement: hasAtLeastElement,
    getElements: getElements,
    getUniqueName: getUniqueName,
    buildFilterDataSubReport: buildFilterDataSubReport,
    populateReportChartContainer: populateReportChartContainer,
    populateReportChartCustomContainer: populateReportChartCustomContainer,
    buildMappingFields: buildMappingFields,
    validateURL: validateURL,
    buildDataSourceElement: buildDataSourceElement,
    findCatAndReportNameInUrl: findCatAndReportNameInUrl,
    getContainerByField: getContainerByField,
    resetDefaultSetting: resetDefaultSetting,
    transformFilterWithReportPart: transformFilterWithReportPart,
    getDefaultSort: getDefaultSort,
    renderLazyLoadingBar: renderLazyLoadingBar,
    needToRenderLazyLoadingBar: needToRenderLazyLoadingBar,
    filterFormatForField: filterFormatForField,
    isLinear: isLinear,
    checkCanUnsort: checkCanUnsort,
    getFunction: getFunction
  };
}();

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.Popup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module: CommonPopup Component
 *  <Popup visible={store.showPopup} onClosed={this.closed}>
   *    <Popup.Header title='Hello'>
   *      <Popup.ConfirmationButton type='accept'>Save</Popup.ConfirmationButton>
   *      <Popup.ConfirmationButton type='cancel'>Cancel</Popup.ConfirmationButton>
   *
 </Popup.Header>
   *    <Popup.Body>
   *       Popup body message
   *
 </Popup.Body>
   *    <Popup.Footer>
   *      <Popup.ConfirmationButton type='accept'>Save</Popup.ConfirmationButton>
   *      <Popup.ConfirmationButton type='cancel'>Cancel</Popup.ConfirmationButton>
   *
 </Popup.Footer>
   *
 </Popup>
 *
 *  @param type = accept | cancel
 *  closed: function(type){
 *    setVisible(false);
 *    ....
 *  }
 *
 */
!function () {
  var React = __webpack_require__(0);
  var Button = __webpack_require__(30);
  var ScrollBox = __webpack_require__(27);
  var classnames = __webpack_require__(11);
  var Draggable = __webpack_require__(359);
  var Loading = __webpack_require__(152);

  var _require = __webpack_require__(1),
      assign = _require.assign,
      find = _require.find,
      concat = _require.concat,
      isArray = _require.isArray,
      isEmpty = _require.isEmpty;

  var Popup = React.createClass({
    displayName: 'Popup',

    propsType: {
      visible: React.PropTypes.bool,
      onClosed: React.PropTypes.func,
      type: React.PropTypes.oneOf(['default', 'warning', 'error', 'info', 'none', 'confirm']),
      sizeClass: React.PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
      return {
        visible: false,
        onClosed: null,
        autoClose: true,
        type: 'default',
        sizeClass: '',
        showLoading: false
      };
    },

    getInitialState: function getInitialState() {
      return {
        isVisible: !!this.props.visible,
        showLoading: this.props.showLoading
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        isVisible: nextProps.visible,
        showLoading: nextProps.showLoading
      });
    },

    render: function render() {
      var header = this.renderChildByType('Header', true);
      var body = this.renderChildByType('Body');
      var footer = this.renderChildByType('Footer', true);

      var finalHeader = header ? React.cloneElement(header, {
        onClosed: this.props.onClosed,
        onClosing: this.props.onClosing,
        autoClose: this.props.autoClose,
        hide: this.hide,
        type: this.props.type
      }) : null;

      var finalFooter = footer ? React.cloneElement(footer, {
        onClosed: this.props.onClosed,
        onClosing: this.props.onClosing,
        autoClose: this.props.autoClose,
        hide: this.hide
      }) : null;

      var modalClass = classnames('izenda-modal-dialog', this.props.sizeClass, this.props.containerClass);
      var style = assign(this.props.style, this.getStyle());
      var selectorHandle = header ? '.modal-header' : '.modal-content';
      var contentClass = classnames(this.props.type, {
        'modal-content': true,
        u_curMove: !header
      });

      return React.createElement(
        'div',
        null,
        this.state.isVisible && React.createElement('div', { className: 'modal-backdrop in' }),
        React.createElement(
          'div',
          { tabIndex: '-1', role: 'dialog', style: style, className: 'modal fade ' + this.getShowingClass() },
          React.createElement(
            ScrollBox,
            { shouldInjectScrollCallbackToChild: false },
            React.createElement(
              Draggable,
              { handle: selectorHandle, bounds: '.izenda', cancel: '.btn, input, .izenda-Disable-move' },
              React.createElement(
                'div',
                { className: modalClass },
                React.createElement(
                  'div',
                  { className: contentClass },
                  finalHeader,
                  body,
                  finalFooter,
                  React.createElement(Loading, { show: this.state.showLoading })
                )
              )
            )
          )
        )
      );
    },

    renderChildByType: function renderChildByType(childType, optional) {
      var foundChild = find(function (child) {
        return child && child.type.displayName === childType;
      })(concat([], this.props.children));

      ensure(optional || foundChild, 'Popup must have %s', childType);

      return foundChild;
    },

    getShowingClass: function getShowingClass() {
      return this.state.isVisible ? 'in' : '';
    },

    getStyle: function getStyle() {
      return this.state.isVisible ? { display: 'block' } : { display: 'none' };
    },

    hide: function hide() {
      this.setState({
        isVisible: false
      });
    }
  });

  /**
   * [wrappPopupButton description]
   * @param  {[type]} btns [description]
   * @return {[type]}      [description]
   */
  function wrappPopupButton(btns) {
    var newBtns = [];
    var props = this.props;

    btns = isArray(btns) ? btns : [btns];
    btns.forEach(function (btn, index) {
      if (btn && btn.type && btn.type.displayName === 'ConfirmationButton') {
        newBtns.push(React.cloneElement(btn, {
          key: props.key || index,
          onClosed: props.onClosed,
          onClosing: props.onClosing,
          autoClose: props.autoClose,
          hide: props.hide
        }));
      } else if (isArray(btn)) {
        newBtns.push(wrappPopupButton.bind(this)(btn));
      }
    }.bind(this));

    return newBtns;
  }

  Popup.Header = React.createClass({
    displayName: 'Header',

    propsType: {
      title: React.PropTypes.string,
      tooltip: React.PropTypes.string,
      showCloseButton: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
      return {
        title: '',
        tooltip: '',
        showCloseButton: true
      };
    },

    render: function render() {
      var props = this.props;

      return React.createElement(
        'div',
        { className: 'modal-header' },
        React.createElement(
          'h4',
          { className: 'modal-title u_floatLeft ' + props.type },
          props.title,
          !isEmpty(props.tooltip) && React.createElement(
            'a',
            { className: 'modal-tooltip' },
            React.createElement('span', { className: 'icon-info-circled', title: props.tooltip })
          )
        ),
        props.showCloseButton && React.createElement(
          'div',
          { className: 'pull-right' },
          React.createElement('span', { className: 'icon-cancel', 'aria-label': 'Close', onClick: closePopup })
        )
      );

      function closePopup() {
        props.onClosing && props.onClosing(function () {
          props.hide();
        }, 'cancel');
        props.onClosed && props.onClosed('cancel');
      }
    }
  });

  Popup.Body = React.createClass({
    displayName: 'Body',

    propsType: {
      className: React.PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
      return {
        className: ''
      };
    },

    render: function render() {
      var className = classnames('modal-body', this.props.className);

      return React.createElement(
        'div',
        { className: className },
        this.props.children
      );
    }
  });

  Popup.Footer = React.createClass({
    displayName: 'Footer',

    render: function render() {
      return React.createElement(
        'div',
        { className: 'modal-footer' },
        wrappPopupButton.call(this, this.props.children)
      );
    }
  });

  Popup.ConfirmationButton = React.createClass({
    displayName: 'ConfirmationButton',

    propTypes: {
      type: React.PropTypes.oneOf(['accept', 'cancel', 'close'])
    },

    render: function render() {
      return this.renderButton();
    },

    renderButton: function renderButton() {
      var close = function () {
        this.props.hide();
      }.bind(this);

      var saveCancelProcess = function () {
        var type = this.props.type;
        if (this.props.autoClose) {
          close();
          this.props.onClosed && this.props.onClosed(type);
        } else {
          this.props.onClosing && this.props.onClosing(close, type);
        }
      }.bind(this);

      if (this.props.type === 'accept') {
        return React.createElement(
          'button',
          { onClick: saveCancelProcess, type: 'button', className: 'btn btn-primary' },
          this.props.children
        );
      } else if (this.props.type === 'cancel') {
        return React.createElement(
          'button',
          { onClick: saveCancelProcess, type: 'button', className: 'btn btn-default' },
          this.props.children
        );
      } else if (this.props.type === 'close') {
        return React.createElement(
          'a',
          { onClick: saveCancelProcess },
          React.createElement(
            'span',
            { className: 'icon-cancel modal-close-button' },
            this.props.children
          )
        );
      } else {
        return React.createElement(Button, this.props);
      }
    }
  });

  module.exports = Popup;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonMessages.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Common messages
 */
!function () {
  var localizer = __webpack_require__(12);
  module.exports = {
    MESSAGE_TYPE: {
      INFO: 'info',
      ERROR: 'error',
      SUCCESS: 'success',
      WARNING: 'warning',
      INFO_ACCEPT: 'info_accept'
    },
    // Please keep items in order of key (order follow alphabet)
    SUPP_LBL_001: 'No record found.',

    SUPP_MSG_001: 'Are you sure? All your changes will be lost.',
    SUPP_MSG_005: 'Are you sure you want to save all of the modifications?',
    SUPP_MSG_006: 'Details were saved.',
    SUPP_MSG_007: 'Are you sure you want to cancel the changes?',
    SUPP_MSG_008: '{0} is required.',
    SUPP_MSG_019: '{0} must be a number smaller than or equal to {1}.',
    SUPP_MSG_026: 'Another user recently modified this data. Up-to-date data has been reloaded. You can now review and continue your work.',
    SUPP_MSG_028: 'No changes found.',
    M09: 'This foreign data object is invalid when the relationship is dropped here ',
    M10: 'This foreign data object is invalid when the key join is dropped here ',
    FORMAT_NUMBER: 'Please enter a valid value in Numeric format.',
    FORMAT_DATE: 'Please enter a valid value in \'MM/dd/yyyy hh:mm\' format.',
    // Notification Message
    EMPTY_MESSAGE: { type: 'info', message: '' },
    EMAIL_CONFIGURATION: 'The Email Settings for your system/tenant has not been configured yet. Please contact your System Administrator for assistance',
    PROVISION_MAP_DATA: {
      IMPORTING: localizer.getText('NOTIFICATION_PROVISION_MAP_DATA_IMPORTING'),
      IMPORT_FAILED: localizer.getText('NOTIFICATION_PROVISION_MAP_DATA_IMPORT_FAILED')
    }
  };
}();

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ensure;

// ----------------------------------------------------------------------
// <copyright file="Izenda.Ensure.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/* https://github.com/zertosh/invariant/blob/master/invariant.js */
/**
* Ensure the condition is met. Otherwise, raise an Error with formatted message
*
* Provide sprintf-style format message (only %s is supported) and arguments
* to provide information about what broke and what you were
* expecting.
*
* @param {boolean} condition
* @param {string} msg - Format message
* @param {Array<any>} args - Format arguments
*/
function ensure(condition, msg) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (!condition) {
    var argIndex = 0;
    var error = new Error(msg.replace(/%s/g, function () {
      return args[argIndex++];
    }));

    error.name = 'Pre-check Failed';

    throw error;
  }
}
module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(33);

var _Izenda4 = __webpack_require__(1307);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(16);

var _Izenda7 = __webpack_require__(175);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHART_SCHEMA_NAMES = {
  CHART_KEY: 'RP_CHART_TYPE',
  GROUPS: {
    GENERAL_INFO_GROUP: 'generalInfo',
    CHART_GROUP: 'chart',
    LABEL_GROUP: 'labels',
    LEGENDS_GROUP: 'legends',
    GROUPING_GROUP: 'grouping',
    DATA_GROUP: 'data',
    VIEW_GROUP: 'view',
    PRINTING_GROUP: 'printing'
  },
  FIELDS: {
    // General info fields
    GENERAL_INFO_CHART_TYPE: 'chartType',
    // Chart fields
    CHART_BORDER: 'izBorder',
    CHART_BGCOLOR: 'izBackgroundColor',
    CHART_XY_PLANE: 'izXYplane',
    CHART_GRID_LINE: 'izGridline',
    CHART_COLOR_THEME: 'colorTheme',
    CHART_MULTI_COLOR: 'izMultiColor',
    CHART_MULTI_LEVEL: 'izMultiLevel',
    // Label fields
    LABEL_ORIENTATION: 'izLabelOrientation',
    LABEL_ORIENTATION_X: 'izLabelOrientationX',
    LABEL_ORIENTATION_Y: 'izLabelOrientationY',
    LABEL_HOVER: 'izHoverLabels',
    // Legends fields
    LEGENDS_SETTINGS: 'legendSettings',
    // Grouping fields
    GROUPING_USE_SEPARATOR: 'izUseSeparator',
    GROUPING_STACKING: 'izStacking',
    GROUPING_BOTTOM_X_PERCENT: 'izBottomXpercent',
    // Data fields
    DATA_SHOW_PERCENTAGE: 'izShowPercentage',
    DATA_VALUE_LABEL: 'izValueLabel',
    DATA_SLICE_LABEL: 'izSliceLabel',
    DATA_RANGE: 'izRange',
    DATA_THRESHOLDS: 'izThresholds',
    DATA_REGRESSION_LINE: 'izRegressionLine',
    // View fields
    VIEW_ZOOM: 'izZoom',
    VIEW_INVERTED: 'izInverted',
    VIEW_STEP: 'izStep',
    VIEW_SPLINE: 'izSpline',
    VIEW_PIE_CHART_STYLE: 'izPieChartStyle',
    VIEW_DATA_REFRESH_INTERVAL: 'dataRefreshInterval',
    VIEW_DATA_USE_PAGINATION: 'izUsePagination',
    VIEW_ITEMS_PER_ROW: 'izItemPerRow',
    VIEW_SINGLE_YAXIS: 'izSingleYAxis',
    // Printing fields
    PRINTING_PAGE_BREAK_AFTER_SEPARATOR: 'izPageBreakAfterSeparator'
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartChartConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ContainerName = {
  LABELS: 'labels',
  VALUES: 'values',
  VALUES_LABELS: 'valuesLabels',
  SEPARATORS: 'separators',
  BUBBLE_SIZE: 'bubbleSize',
  DYNAMIC_THRESHOLD: 'dynamicThresholds'
};

var LIST_COUNTABLE_DATA_TYPE = ['Time', 'Datetime', 'Numeric', 'Money'];

var SORT_TYPES = {
  ASC: 'ASC',
  DESC: 'DESC'
};

var THRESHOLD_TYPES = {
  LINE: 'line',
  SPLINE: 'spline'
};

exports.default = {
  CHART_SCHEMA_NAMES: CHART_SCHEMA_NAMES,
  SORT_TYPES: SORT_TYPES,
  ContainerName: ContainerName,
  DefaultChartType: _Izenda3.CHART_TYPE.Line,
  DefaultFunction: _Izenda5.default,
  LABEL_TEXT: {
    get previewTitle() {
      return _Izenda2.default.getText('COMMON_LABEL_TITLE');
    },
    get description() {
      return _Izenda2.default.getText('COMMON_LABEL_DESCRIPTION');
    },
    get valueLabel() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_VALUE_LABEL');
    },
    get bubble() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_BUBBLE_SIZE');
    }
  },
  TABLE_DEF: {
    yAxis: {
      get title() {
        return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_Y_AXIS');
      }
    },
    value: {
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_VALUE');
      }
    },
    chartType: {
      get title() {
        return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_CHART_TYPE');
      }
    },
    settings: {
      get title() {
        return _Izenda2.default.getText('TOP_MENU_SETTINGS');
      }
    },
    showTotal: {
      get title() {
        return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_SHOW_TOTAL');
      }
    }
  },
  SPARK_LINE_CHART: {
    CHART_TYPE_DROPDOWN: {
      options: [{ value: _Izenda3.CHART_TYPE.Area, label: _Izenda3.CHART_TYPE.Area }, { value: _Izenda3.CHART_TYPE.Line, label: _Izenda3.CHART_TYPE.Line }, { value: _Izenda3.CHART_TYPE.Column, label: _Izenda3.CHART_TYPE.Column }],
      value: _Izenda3.CHART_TYPE.Area
    },
    DEFAULT_VALUE: {
      dashStyle: 'solid',
      lineWidth: 1,
      chartType: _Izenda3.CHART_TYPE.Area
    }
  },
  COMBINE_CHART: {
    CHART_TYPE_DROPDOWN: {
      options: [{ value: _Izenda3.CHART_TYPE.Line, label: _Izenda3.CHART_TYPE.Line }, { value: _Izenda3.CHART_TYPE.Column, label: _Izenda3.CHART_TYPE.Column }, { value: _Izenda3.CHART_TYPE.Area, label: _Izenda3.CHART_TYPE.Area }],
      value: _Izenda3.CHART_TYPE.Column
    },
    DEFAULT_VALUE: {
      dashStyle: 'solid',
      lineWidth: 1,
      chartType: _Izenda3.CHART_TYPE.Column
    }
  },
  VALUES_YAXIS_COLUMN_WIDTH: 80,
  VALUES_SETTING_COLUMN_WIDTH: 120,
  VALUES_TOTAL_COLUMN_WIDTH: 110,

  CHART_SETTINGS: {
    XY_PLANE: {
      XY_PLANE_TITLE_OPTION: [{ value: 'izLow' }, { value: 'izMiddle' }, { value: 'izHigh' }],
      xAxis: {
        TOOLTIP: {
          get INTERVALS() {
            return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_X_AXIS_INTERVALS');
          },
          get STARTING_POINT() {
            return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_X_AXIS_STARTING_POINT');
          }
        }
      },
      yAxis: {
        TOOLTIP: {
          get INTERVALS() {
            return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_Y_AXIS_INTERVALS');
          },
          get STARTING_POINT() {
            return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_Y_AXIS_STARTING_POINT');
          }
        }
      }
    },
    REGRESSION_TYPE: {
      linear: 'linear',
      polynomial: 'polynomial',
      logarithmic: 'logarithmic',
      exponential: 'exponential'
    },
    REGRESSION_TYPE_OPTIONS: [{ value: 'linear', label: _Izenda2.default.getText('REGRESSION_LINE_OPTION_LINEAR') }, { value: 'polynomial', label: _Izenda2.default.getText('REGRESSION_LINE_OPTION_POLYNOMIAL') }, { value: 'logarithmic', label: _Izenda2.default.getText('REGRESSION_LINE_OPTION_LOGARITHMIC') }, { value: 'exponential', label: _Izenda2.default.getText('REGRESSION_LINE_OPTION_EXPONENTIAL') }],
    REGRESSION_POLYNOMIAL_ORDER: [{ value: 2, label: '2', tooltip: _Izenda2.default.getText('REGRESSION_POLYNOMIAL_ORDER_TWO') }, { value: 3, label: '3', tooltip: _Izenda2.default.getText('REGRESSION_POLYNOMIAL_ORDER_THREE') }, { value: 4, label: '4', tooltip: _Izenda2.default.getText('REGRESSION_POLYNOMIAL_ORDER_FOUR') }],
    REGRESSION_LINEAR_DECIMAL_PLACES_DEFAULT_VALUE: 2,
    REGRESSION_LINEAR_DECIMAL_PLACES_MAX_VALUE: 100,
    REGRESSION_LINEAR_DECIMAL_PLACES_MIN_VALUE: 0,
    REGRESSION_EXTRAPOLATE_MAX_VALUE: 10000,
    REGRESSION_EXTRAPOLATE_MIN_VALUE: 0,
    DEFAULT_VALUE: {
      BLACK_COLOR: '#000',
      DASH_STYLE: 'solid',
      WIDTH: 1
    },
    // High chart font styles, which is used for converting to font style of our FontStyle component
    FONT_STYLE: {
      BOLD: 'bold',
      UNDERLINE: 'underline',
      ITALIC: 'italic'
    },
    OTHER_PROPS_KEY: {
      chartType: 'chartType',
      dashStyle: 'dashStyle',
      lineWidth: 'lineWidth',
      showTotal: 'showTotal'
    }
  },
  RANGE_ALIAS: {
    MIN_ALIAS: 'min;#',
    MAX_ALIAS: 'max;#',
    AVG_ALIAS: 'avg;#'
  },

  CONTAINER_KEYS: {
    values: 'values',
    labels: 'labels',
    valuesLabels: 'valuesLabels',
    separators: 'separators'
  },

  RANGE_OPTION_KEYS: {
    rangeOnly: 'rangeOnly',
    rangeWithAverage: 'rangeWithAverage'
  },

  LIST_COUNTABLE_DATA_TYPE: LIST_COUNTABLE_DATA_TYPE,
  DEFAULT_SETTING_VALUE: {
    tickInterval: 1,
    borderDefault: {
      'izEntire.borderColor': '#000',
      'izEntire.borderWidth': 0,
      'izEntire.borderStyle': 'solid'
    },
    borderNew: {
      'izEntire.borderColor': undefined,
      'izEntire.borderWidth': undefined,
      'izEntire.borderStyle': undefined
    },
    backGroundColorDefault: {
      'izEntire.backgroundColor': '#fff',
      'izPlot.backgroundColor': null
    },
    backGroundColorNew: {
      'izEntire.backgroundColor': undefined,
      'izPlot.backgroundColor': undefined
    },
    gridLineDefault: {
      'izGrid.lineColor': undefined,
      'izGrid.lineDashStyle': undefined,
      'izGrid.lineWidth': undefined
    },
    refreshIntervalDefault: {
      enable: false,
      isAll: true,
      latestRecord: 0,
      updateInterval: 0
    },
    titleDescriptionNew: function titleDescriptionNew(isTitle) {
      return {
        fontFamily: '',
        fontSize: 14,
        fontBold: isTitle,
        fontItalic: false,
        fontUnderline: false,
        fontColor: '',
        fontHighlightColor: '',
        alignment: ''
      };
    },

    titleDescriptionDefault: {
      fontFamily: 'Georgia',
      fontSize: 8,
      fontBold: undefined,
      fontItalic: undefined,
      fontUnderline: undefined,
      fontColor: '#000',
      fontHighlightColor: undefined,
      alignment: 'alignLeft'
    }
  },
  PAGE_SIZE_BACK_SIDE: 2,
  CUSTOM_FORMAT_PREFIX: 'org_',
  THRESHOLD_TYPES: THRESHOLD_TYPES,
  isChartType: _Izenda8.default.isReportPartStyle(_Izenda6.REPORT_PART_TYPE.Chart)
};
module.exports = exports['default'];

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ensure = __webpack_require__(38);

var _ensure2 = _interopRequireDefault(_ensure);

var _Izenda = __webpack_require__(200);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var webApiUrl = ''; // ----------------------------------------------------------------------
// <copyright file="Izenda.Config.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var baseUrl = '/';
var rootPath = '';
var cssFile = '';
var routeIntegration = true;
var routes = {
  Settings: 'settings',
  ReportDesigner: 'reportdesigner',
  Dashboard: 'dashboard',
  Report: 'report',
  ReportViewer: 'reportviewer',
  Viewer: 'viewer',
  Account: 'account',
  MyProfile: 'myprofile'
};

var routesMerge = (0, _Izenda.mergeRouteConfig)(routes);
var timeoutInSeconds = 3600;
var printingTimeout = 60 * 1000;
var printingRenderingTimeout = 6 * 1000;
var defaultLanguage = 'en-US';
var needToEncodeUrl = true;
var onReceiveUnauthorizedResponse = function onReceiveUnauthorizedResponse(message) {};
var uiPreferences = {
  ReportFilterSectionExpanded: true
};

/**
 * Option object
 */
exports.default = {
  /**
   * The URL of Izenda API. It needs have trailing slash.
   */
  get WebApiUrl() {
    return webApiUrl;
  },
  /**
   * The base URL of all Izenda report pages
   */
  get BaseUrl() {
    return baseUrl;
  },
  /**
   * The relative path of Izenda resources
   */
  get RootPath() {
    return rootPath;
  },

  get CssFile() {
    return cssFile;
  },

  /**
   * Indicates the app using integrated routing system. For example, if integrated, the routing
   * url of Izenda will be resolved by ?source= query string.
   * Customer frontend app should ignore this setting
   */
  get Integration() {
    return routeIntegration;
  },

  get Routes() {
    return routes;
  },

  get RoutesMerge() {
    return routesMerge;
  },

  get Timeout() {
    return timeoutInSeconds;
  },

  get PrintingTimeout() {
    return printingTimeout;
  },

  get PrintingRenderingTimeout() {
    return printingRenderingTimeout;
  },

  /**
   * Default language key of Izenda. The key setup here must match key in language file
   */
  get DefaultLanguage() {
    return defaultLanguage;
  },

  /**
   * This option is set in integration mode only. Default is true -> always encode url
   * For example, AngularJS automatically encodes the hash of URL. It causes the hash part
   * is encoded twice. Therefore, this setting is for ignoring url encoding by Izenda.
   */
  get NeedToEncodeUrl() {
    return needToEncodeUrl;
  },

  /**
   * In integration mode, when a request receives 401 status code -> this method is run
   */
  get OnReceiveUnauthorizedResponse() {
    return onReceiveUnauthorizedResponse;
  },
  /**
   * Defines all default value of UI appearance preferences
   */
  get UIPreferences() {
    return uiPreferences;
  },

  /**
   * Set options
   */
  set: function set(options) {
    (0, _ensure2.default)(options, 'Invalid options');
    (0, _ensure2.default)(options.WebApiUrl, 'WebApiUrl must be set');

    webApiUrl = (0, _fp.isFunction)(options.WebApiUrl) ? options.WebApiUrl() : options.WebApiUrl;
    routes = (0, _fp.merge)(routes, options.Routes);
    routesMerge = (0, _Izenda.mergeRouteConfig)(routes);
    baseUrl = options.BaseUrl || baseUrl;
    rootPath = options.RootPath || rootPath;
    cssFile = options.CssFile || cssFile;
    routeIntegration = (0, _fp.isNil)(options.Integration) ? routeIntegration : options.Integration;
    timeoutInSeconds = options.TimeOut || timeoutInSeconds;
    printingTimeout = options.PrintingTimeout || printingTimeout;
    printingRenderingTimeout = options.PrintingRenderingTimeout || printingRenderingTimeout;
    needToEncodeUrl = (0, _fp.isNil)(options.NeedToEncodeUrl) ? needToEncodeUrl : options.NeedToEncodeUrl;
    onReceiveUnauthorizedResponse = !(0, _fp.isFunction)(options.OnReceiveUnauthorizedResponse) ? onReceiveUnauthorizedResponse : options.OnReceiveUnauthorizedResponse;
    uiPreferences = (0, _fp.isNil)(options.UIPreferences) ? uiPreferences : (0, _fp.merge)(uiPreferences, options.UIPreferences);
  }
};
module.exports = exports['default'];

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AppGlobal.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var AppGlobal = (_class = function () {
  (0, _createClass3.default)(AppGlobal, [{
    key: 'dataSourceLimitValue',
    get: function get() {
      return this.advancedSettings.performance.dataSourceLimitValue;
    }
  }]);

  function AppGlobal() {
    (0, _classCallCheck3.default)(this, AppGlobal);

    _initDefineProp(this, 'advancedSettings', _descriptor, this);

    _initDefineProp(this, 'systemDate', _descriptor2, this);

    this.containerElement = null;
    this.countryCodes = [];
    this.currentUserContext = { token: null };
  }

  (0, _createClass3.default)(AppGlobal, [{
    key: 'setPerformance',
    value: function setPerformance(result) {
      this.advancedSettings.performance = result;
    }
  }, {
    key: 'setSecurity',
    value: function setSecurity(result) {
      this.advancedSettings.security = result;
    }
  }, {
    key: 'setOther',
    value: function setOther(result) {
      this.advancedSettings.other = result;
    }
  }, {
    key: 'setSystemDate',
    value: function setSystemDate(result) {
      this.systemDate = result;
    }
  }, {
    key: 'setCountryCodes',
    value: function setCountryCodes(result) {
      this.countryCodes = result;
    }
  }, {
    key: 'canShowPreview',
    value: function canShowPreview() {
      return (0, _fp.get)('advancedSettings.other.showPreviewValue', this);
    }

    /**
     * Get hide report header and footer setting
     * @returns { Boolean } A boolean value that indicates to hide report's header and footer.
     */

  }, {
    key: 'doesHideReportHeaderAndFooter',
    value: function doesHideReportHeaderAndFooter() {
      return (0, _fp.get)('advancedSettings.other.hideReportHeaderAndFooterValue', this);
    }
  }]);
  return AppGlobal;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'advancedSettings', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      performance: {},
      security: {},
      other: {}
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'systemDate', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'dataSourceLimitValue', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'dataSourceLimitValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setPerformance', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setPerformance'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSecurity', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setSecurity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setOther', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setOther'), _class.prototype)), _class);
exports.default = new AppGlobal();
module.exports = exports['default'];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthorizationConstants.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  PERMISSION_KEY: {
    FullReportAndDashboardAccess: 'fullReportAndDashboardAccess',
    SystemConfigurationScheduledInstancesValue: 'systemConfiguration.scheduledInstances.value',
    TenantSetupActionsCreate: 'tenantSetup.actions.create',
    TenantSetupActionsEdit: 'tenantSetup.actions.edit',
    TenantSetupActionsDel: 'tenantSetup.actions.del',
    TenantSetupPermissionsValue: 'tenantSetup.permissions.value',
    DataSetupDataModelValue: 'dataSetup.dataModel.value',
    DataSetupDataModelCustomViewCreate: 'dataSetup.dataModel.customView.create',
    DataSetupDataModelCustomViewEdit: 'dataSetup.dataModel.customView.edit',
    DataSetupDataModelCustomViewDelete: 'dataSetup.dataModel.customView.delete',
    DataSetupAdvancedSettingsCategory: 'dataSetup.advancedSettings.category',
    DataSetupAdvancedSettingsOthers: 'dataSetup.advancedSettings.others',
    UserSetupUserRoleAssociationValue: 'userSetup.userRoleAssociation.value',
    UserSetupActionsCreate: 'userSetup.actions.create',
    UserSetupActionsEdit: 'userSetup.actions.edit',
    UserSetupActionsDel: 'userSetup.actions.del',
    UserSetupActionsConfigureSecurityOptions: 'userSetup.actions.configureSecurityOptions',
    RoleSetupActionsCreate: 'roleSetup.actions.create',
    RoleSetupActionsEdit: 'roleSetup.actions.edit',
    RoleSetupActionsDel: 'roleSetup.actions.del',
    RoleSetupDataModelAccessValue: 'roleSetup.dataModelAccess.value',
    RoleSetupPermissionsValue: 'roleSetup.permissions.value',
    RoleSetupGrantRoleWithFullReportAndDashboardAccessValue: 'roleSetup.grantRoleWithFullReportAndDashboardAccess.value',
    ReportsCanCreateNewReportValue: 'reports.canCreateNewReport.value',
    ReportsDataSourcesSimpleDataSources: 'reports.dataSources.simpleDataSources',
    ReportsDataSourcesAdvancedDataSources: 'reports.dataSources.advancedDataSources',
    ReportsReportPartTypesChart: 'reports.reportPartTypes.chart',
    ReportsReportPartTypesForm: 'reports.reportPartTypes.form',
    ReportsReportPartTypesGauge: 'reports.reportPartTypes.gauge',
    ReportsReportPartTypesMap: 'reports.reportPartTypes.map',
    ReportsCanCreateNewCategoryValue: 'reports.reportCategoriesSubcategories.canCreateNewCategory.value',
    ReportsFilterPropertiesFilterLogic: 'reports.filterProperties.filterLogic',
    ReportsFilterPropertiesCrossFiltering: 'reports.filterProperties.crossFiltering',
    ReportsFieldPropertiesCustomURL: 'reports.fieldProperties.customURL',
    ReportsFieldPropertiesEmbeddedJavaScript: 'reports.fieldProperties.embeddedJavaScript',
    ReportsFieldPropertiesSubreport: 'reports.fieldProperties.subreport',
    ReportsActionsSchedule: 'reports.actions.schedule',
    ReportsActionsEmail: 'reports.actions.email',
    ReportsActionsViewReportHistory: 'reports.actions.viewReportHistory',
    ReportsActionsDel: 'reports.actions.del',
    ReportsActionsRegisterForAlerts: 'reports.actions.registerForAlerts',
    ReportsActionsPrint: 'reports.actions.print',
    ReportsActionsUnarchiveReportVersions: 'reports.actions.unarchiveReportVersions',
    ReportsActionsOverwriteExistingReport: 'reports.actions.overwriteExistingReport',
    ReportsActionsSubscribe: 'reports.actions.subscribe',
    ReportsActionsExporting: 'reports.actions.exporting',
    ReportsActionsConfigureAccessRights: 'reports.actions.configureAccessRights',
    DashboardsCanCreateNewDashboardValue: 'dashboards.canCreateNewDashboard.value',
    DashboardsCanCreateNewCategoryValue: 'dashboards.dashboardCategoriesSubcategories.canCreateNewCategory.value',
    DashboardsActionsSchedule: 'dashboards.actions.schedule',
    DashboardsActionsEmail: 'dashboards.actions.email',
    DashboardsActionsDel: 'dashboards.actions.del',
    DashboardsActionsSubscribe: 'dashboards.actions.subscribe',
    DashboardsActionsPrint: 'dashboards.actions.print',
    DashboardsActionsExporting: 'dashboards.actions.exporting',
    DashboardsActionsOverwriteExistingDashboard: 'dashboards.actions.overwriteExistingDashboard',
    DashboardsActionsConfigureAccessRights: 'dashboards.actions.configureAccessRights',
    SchedulingSchedulingScopeSystemUsers: 'scheduling.schedulingScope.systemUsers',
    SchedulingSchedulingScopeExternalUsers: 'scheduling.schedulingScope.externalUsers',
    EmailingDeliveryMethodLink: 'emailing.deliveryMethod.link',
    EmailingDeliveryMethodEmbeddedHTML: 'emailing.deliveryMethod.embeddedHTML',
    EmailingDeliveryMethodAttachment: 'emailing.deliveryMethod.attachment',
    EmailingAttachmentTypeWord: 'emailing.attachmentType.word',
    EmailingAttachmentTypeExcel: 'emailing.attachmentType.excel',
    EmailingAttachmentTypePdf: 'emailing.attachmentType.pdf',
    EmailingAttachmentTypeCsv: 'emailing.attachmentType.csv',
    EmailingAttachmentTypeXml: 'emailing.attachmentType.xml',
    EmailingAttachmentTypeJson: 'emailing.attachmentType.json',
    EmailingAttachmentTypeDefinition: 'emailing.attachmentType.definition',
    ExportingExportingFormatWord: 'exporting.exportingFormat.word',
    ExportingExportingFormatExcel: 'exporting.exportingFormat.excel',
    ExportingExportingFormatPdf: 'exporting.exportingFormat.pdf',
    ExportingExportingFormatCsv: 'exporting.exportingFormat.csv',
    ExportingExportingFormatXml: 'exporting.exportingFormat.xml',
    ExportingExportingFormatJson: 'exporting.exportingFormat.json',
    ExportingExportingFormatDefinition: 'exporting.exportingFormat.definition',
    ExportingExportingFormatQueryExecution: 'exporting.exportingFormat.queryExecution',
    SystemwideCanSeeSystemMessagesValue: 'systemwide.canSeeSystemMessages.value'
  },
  PERMISSION_OPERATOR: {
    And: '&&',
    Or: '||'
  },
  ACCESS_RIGHT: {
    // Highest is 1
    FullAccess: 1,
    SaveAs: 2,
    QuickEdit: 3,
    Locked: 4,
    ViewOnly: 5,
    NoAccess: 6
  }
};
module.exports = exports['default'];

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Table.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module Table component
 * @example
 *  <Table dataSource={array}                   // data of table
           rowProps={function}                  // set properties for each row based on its content
           onSortChange={function}              // [if sort is used] on sort call back
           sortInfo={object}                    // sort infor of each column
           >

      <Column cell={function|component} {...other property} />
 *  </Table>
 */
!function () {
  var observer = __webpack_require__(10).observer;
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var MobxPropTypes = __webpack_require__(10).propTypes;
  var classnames = __webpack_require__(11);
  var elementResizeDetector = __webpack_require__(208);
  var DomUtils = __webpack_require__(262);
  var BrowserUtils = __webpack_require__(78);

  var VirtualList = __webpack_require__(313);
  var Resizer = __webpack_require__(916);
  var ScrollBox = __webpack_require__(27);
  var Cell = __webpack_require__(564);
  var Column = __webpack_require__(1809);
  var ColumnGroup = __webpack_require__(1810);
  var Row = __webpack_require__(934);
  var HeaderCell = __webpack_require__(1811);
  var DraggableRow = __webpack_require__(1812);
  var TableUIStore = __webpack_require__(1813);
  var ResizeHandleWidth = 21;
  var localizer = __webpack_require__(12);
  var RowSpanColumn = __webpack_require__(1814);
  var RowSpanCell = __webpack_require__(935);

  var GroupHeaderCell = __webpack_require__(1815);

  var _require = __webpack_require__(1),
      memoize = _require.memoize,
      map = _require.map,
      get = _require.get,
      isNil = _require.isNil,
      curry = _require.curry,
      debounce = _require.debounce,
      compact = _require.compact,
      assign = _require.assign,
      constant = _require.constant,
      isEmpty = _require.isEmpty,
      invoke = _require.invoke,
      pick = _require.pick,
      flattenDeep = _require.flattenDeep,
      flatMap = _require.flatMap,
      concat = _require.concat,
      getOr = _require.getOr,
      join = _require.join,
      forEach = _require.forEach,
      omit = _require.omit,
      isFunction = _require.isFunction,
      identity = _require.identity,
      noop = _require.noop;

  var Table = React.createClass({
    displayName: 'Table',

    userResizing: false,
    newWidths: [],
    columnHeaderCounter: 0,
    maxDeepHeader: 0,
    headerGroups: [],
    // debouce function to make sure only run after render function at minimum time
    propTypes: {
      showScroll: PropTypes.bool,
      minHeight: PropTypes.number,
      maxHeight: PropTypes.number,
      dataSource: MobxPropTypes.arrayOrObservableArray,
      getChildItems: PropTypes.func,
      isHighLight: PropTypes.func,
      containerWidth: PropTypes.number,
      autoResize: PropTypes.bool,
      defaultColumnWidth: PropTypes.number,
      afterRenderCallBack: PropTypes.func,
      rowSpan: PropTypes.shape({
        data: PropTypes.array.isRequired,
        width: PropTypes.number,
        cell: PropTypes.func.isRequired,
        fnGetCellStyle: PropTypes.func,
        fnGetCellContentStyle: PropTypes.func
      }),
      isLoading: PropTypes.bool,
      loadingText: PropTypes.string,
      staticRender: PropTypes.bool // static render table rows instead of VirtualList
    },

    getDefaultProps: function getDefaultProps() {
      return {
        showScroll: true,
        minHeight: 238,
        maxHeight: 238,
        defaultColumnWidth: 150,
        autoResize: true,
        containerWidth: Infinity,
        isLoading: false,
        loadingText: ''
      };
    },
    componentWillMount: function componentWillMount() {
      var props = this.props;
      var showScroll = props.showScroll;
      var tableHeight = props.minHeight;
      var autoResize = props.autoResize;
      var defaultColumnWidth = props.defaultColumnWidth;

      this.tableStore = new TableUIStore(defaultColumnWidth, showScroll ? tableHeight : 0, autoResize, this.onTableWidthChanged);

      this.initColumnSizes(props, false);
      this.registerRenderCallback(props);

      this.memoizeRegisterHeaderGroup = memoize(function (headerGroupId) {
        return curry(this.registerHeaderGroupCell)(headerGroupId);
      }.bind(this));

      this.memoizeUnregisterHeaderGroup = memoize(function (headerGroupId) {
        return curry(this.unregisterHeaderGroupCell)(headerGroupId);
      }.bind(this));

      this.isSupportSticky = BrowserUtils.isSupportSticky();
    },
    componentWillUpdate: function componentWillUpdate(nextProps) {
      if (nextProps.children !== this.props.children) {
        this.initColumnSizes(nextProps, true);
      }
      if (this.props.afterRenderCallBack !== nextProps.afterRenderCallBack) {
        this.registerRenderCallback(nextProps);
      }
    },
    finishedRender: function finishedRender(prevProps) {
      var _this = this;

      var props = this.props;
      var tableElement = this.refs.table;
      var handleSize = props.draggableTable ? ResizeHandleWidth : 0;

      if (props.containerWidth === Infinity && props.autoResize && (isNil(prevProps) || prevProps.children !== props.children)) {
        var width = $izenda(tableElement).width();

        this.changeTableWidth(Math.floor(width) - handleSize, props.children, true);
      }

      if (props.showScroll) {
        this.tableStore.updateHeight(props.minHeight, this.refs.headerTable.clientHeight);
      }
      this.headerGroupAfterRenderCallBack();
      this.headerAfterRenderCallBack();
      this.cellAfterRenderCallBack();
      this.afterRenderCallBack();

      if (props.stickHorizontal) {
        var bodyWidth = this.refs.tableBody.offsetWidth;
        bodyWidth > 0 && tableElement.style.setProperty('width', bodyWidth + 'px');
      }

      if (!this.isSupportSticky) {
        // Sync size of virtual header if exist
        var headerTable = this.refs.headerTable;
        var parentScrollNode = DomUtils.findScrollableParent(tableElement);
        var virtualHeaderTable = this.refs.virtualHeaderTable;
        if (virtualHeaderTable) {
          virtualHeaderTable.style.setProperty('width', headerTable.offsetWidth + 'px');
          virtualHeaderTable.style.setProperty('height', headerTable.offsetHeight + 'px');
        }

        if (props.stickVertical || props.stickHorizontal) {
          var lastScrollTop = 0,
              lastScrollLeft = 0;
          $izenda(parentScrollNode).on('scroll', function (event) {
            var currentNode = event.target;
            if (lastScrollTop !== currentNode.scrollTop && props.stickVertical) {
              lastScrollTop = currentNode.scrollTop;
              _this.tableStore.updateTopPosition(currentNode, tableElement);
            }

            if (lastScrollLeft !== currentNode.scrollLeft && props.stickHorizontal) {
              lastScrollLeft = currentNode.scrollLeft;
              _this.tableStore.updateLeftPosition(currentNode, tableElement);
            }
          });
        }

        props.stickVertical ? this.tableStore.updateTopPosition(parentScrollNode, tableElement) : this.tableStore.resetTopPosition();

        props.stickHorizontal ? this.tableStore.updateLeftPosition(parentScrollNode, tableElement) : this.tableStore.resetLeftPosition();
      }
    },

    componentDidMount: function componentDidMount() {
      var props = this.props;
      var tableElement = this.refs.table;
      var handleSize = props.draggableTable ? ResizeHandleWidth : 0;

      if (props.containerWidth === Infinity && props.autoResize) {
        elementResizeDetector.listenTo(tableElement, debounce(250, function () {
          var width = $izenda(tableElement).width();
          // Only update table width when the container has been resized.

          !this.userResizing && this.changeTableWidth(Math.floor(width) - handleSize, this.props.children, true);
        }.bind(this)));
      }

      this.finishedRender();
    },
    componentDidUpdate: function componentDidUpdate(prevProps) {
      this.finishedRender(prevProps);
    },
    componentWillUnmount: function componentWillUnmount() {
      var tableElement = this.refs.table;

      if (this.props.containerWidth === Infinity && this.props.autoResize) {
        elementResizeDetector.removeAllListeners(tableElement);
      }
    },
    render: function render() {
      var tableStore = this.tableStore;
      var props = this.props;
      var columns = compact(React.Children.toArray(props.children));
      var autoWidth = props.containerWidth === Infinity;
      var tableStyle = autoWidth ? { width: '100%' } : null;

      var classes = classnames('table', props.className, {
        'default-table': !props.className
      });

      tableStore.resetHeaderGroups();
      this.columnHeaderCounter = 0;
      var headerClasses = classnames('table-header', {
        'u-stickTop': props.stickVertical
      });

      return React.createElement(
        'section',
        { ref: 'table', className: classes, style: assign(props.tableStyle, tableStyle) },
        props.stickVertical && !this.isSupportSticky && React.createElement('div', { className: 'u-posAbsolute u-virtualStickTop' }),
        React.createElement(
          'div',
          { className: headerClasses, ref: 'headerTable' },
          React.createElement(
            'div',
            { className: 'table-row' },
            props.draggableTable && React.createElement('div', { className: 'table-cell u_paddingAll' }),
            props.rowSpan && React.createElement(RowSpanCell, { width: props.rowSpan.width || props.defaultColumnWidth, cell: constant(null) }),
            props.stickHorizontal && !this.isSupportSticky && React.createElement('div', { className: 'u-virtualStickLeft' }),
            columns.map(this.renderHeaderCells.bind(this, 1, []))
          )
        ),
        this.props.showScroll ? React.createElement(
          ScrollBox,
          { onScroll: this.handleScroll, containerStyle: { height: tableStore.bodyHeight } },
          this.renderBody()
        ) : this.renderBody()
      );
    },

    renderBody: function renderBody() {
      var props = this.props;
      var tableBody = this.renderTableBody();

      if (props.rowSpan && !props.staticRender) {
        var classes = classnames('table-cell', {
          'u-stickLeft': props.stickHorizontal
        });
        return React.createElement(
          'div',
          { className: 'table-row', ref: 'tableBody' },
          props.stickHorizontal && !this.isSupportSticky && React.createElement('div', { className: 'u-virtualStickLeft' }),
          React.createElement(
            'div',
            { className: classes },
            React.createElement(RowSpanColumn, {
              tableStore: this.tableStore,
              rowSpan: props.rowSpan,
              width: props.rowSpan.width || props.defaultColumnWidth
            })
          ),
          React.createElement(
            'div',
            { className: 'table-cell' },
            tableBody
          )
        );
      }

      return tableBody;
    },

    renderTableBody: function renderTableBody() {
      var getChildItems = this.props.getChildItems;
      var dataSource = this.props.dataSource;

      return React.createElement(
        'div',
        { className: 'table-body', ref: 'tableBody' },
        isEmpty(dataSource) ? this.renderNoRecordFound() : this.props.staticRender ? this.renderRows(dataSource) : React.createElement(VirtualList, {
          bufferClassName: 'table-row',
          dataSource: dataSource,
          renderItem: this.renderRow,
          getItemKey: invoke('getId'),
          getChildItems: getChildItems,
          registerVirtualStore: this.registerVirtualStore
        })
      );
    },

    renderNoRecordFound: function renderNoRecordFound() {
      var noRecordText = this.props.isLoading ? this.props.loadingText : localizer.getText('COMMON_MESSAGES_NO_RECORD_FOUND');

      return React.createElement(
        'div',
        { className: 'u_paddingAll' },
        noRecordText
      );
    },

    staticRenderRowSpan: function staticRenderRowSpan(dataRow) {
      var props = this.props;
      var rowSpan = get('rowSpan', props);
      var firstRow = 0;
      var pickFn = pick(['fnGetCellStyle', 'fnGetCellContentStyle', 'cell'], rowSpan);
      var mapConvert = map.convert({ cap: false });

      return compact(mapConvert(function (rowSpanElement, index) {
        var lastRow = firstRow + rowSpanElement.size;
        var listRow = dataRow.slice(firstRow, lastRow);

        firstRow = lastRow;
        if (isEmpty(listRow)) {
          return null;
        }
        return React.createElement(
          'div',
          { key: firstRow, className: 'table-row' },
          React.createElement(RowSpanCell, (0, _extends3.default)({
            rowSpan: rowSpanElement,
            width: rowSpan.width || props.defaultColumnWidth
          }, pickFn, {
            index: index
          })),
          React.createElement(
            'div',
            { className: 'table-cell' },
            listRow
          )
        );
      }, rowSpan.data));
    },

    renderRows: function renderRows(dataSource) {
      var props = this.props;

      dataSource = dataSource || [];

      var dataRow = flattenDeep(dataSource.map(function (item, index) {
        var result = this.renderRow(item, index);

        return forEach(identity, result);
      }.bind(this)));

      if (get('rowSpan', props)) {
        return this.staticRenderRowSpan(dataRow);
      }
      return dataRow;
    },

    renderRow: function renderRow(item, index) {
      var props = this.props;
      var columns = this.getAllColumns(props.children);
      var widths = this.tableStore.columnWidths;

      var RowComponent = props.draggableTable ? DraggableRow : Row;

      return React.createElement(RowComponent, {
        key: item.getId && item.getId() || index,
        rowSpan: props.rowSpan,
        rowProps: props.rowProps,
        rowData: item,
        columns: columns,
        columnWidths: widths,
        move: props.move,
        canDrop: props.canDrop,
        index: index,
        canDrag: props.canDrag,
        warning: props.warning,
        onClickRow: props.onClickRow,
        isHighLight: props.isHighLight,
        didUpdate: this.afterRenderCallBack,
        registerCell: this.registerCell,
        unregisterCell: this.unregisterCell,
        stickHorizontal: props.stickHorizontal,
        isSupportSticky: this.isSupportSticky,
        tableStore: this.tableStore,
        cellAfterRenderCallBack: this.cellAfterRenderCallBack
      });
    },

    renderHeaderCells: function renderHeaderCells(deep, path, column, index) {
      // Don't render null column
      if (!column) {
        return null;
      }

      var props = this.props;
      var tableStore = this.tableStore;
      var columnProps = column.props;
      var restColumnProps = omit(['width', 'title', 'getTitle', 'resizable', 'fnGetCellStyle', 'fnGetCellContentStyle'], columnProps);
      var allowResize = columnProps.resizable;

      if (deep > this.maxDeepHeader) {
        this.maxDeepHeader = deep;
      }
      var renderTitle = function renderTitle(callBack) {
        var generatedTitle = column.props.title || isFunction(column.props.getTitle) && column.props.getTitle(callBack);
        // Add text for reserving height
        if (column.type === ColumnGroup && !!column.props.isInvisible && getOr(true, 'props.canRenderHeader', column) && isEmpty(generatedTitle)) {
          generatedTitle = 'blank';
        }
        return generatedTitle;
      };

      var headerCell = props.sortInfo ? React.createElement(HeaderCell, (0, _extends3.default)({}, props, columnProps)) : React.createElement(GroupHeaderCell, {
        infoIconOptions: columnProps.infoIconOptions,
        didUpdate: this.headerAfterRenderCallBack,
        renderTitle: renderTitle
      });

      var HeaderComponent = columnProps.headerComponent;
      var headerComponentProps = columnProps.headerComponentProps;
      var currentColumn = this.columnHeaderCounter;
      var columnWidth = tableStore.getColumnWidth(this.columnHeaderCounter);
      var columnMinWidth = columnProps.width;

      if (column.type === ColumnGroup) {
        var classesGroupHeader = classnames({
          'table-cell-group-header': true,
          'table-content-hidden': !!column.props.isInvisible
        });
        var supPath = concat(path, index);
        var refsGroupHeader = {
          path: supPath,
          ref: join('_', supPath),
          startColumn: this.columnHeaderCounter,
          index: index,
          deep: deep
        };

        var child = concat([], column.props.children).map(this.renderHeaderCells.bind(this, deep + 1, supPath));

        refsGroupHeader.endColumn = this.columnHeaderCounter;

        tableStore.addHeaderGroup(refsGroupHeader);

        var width = tableStore.calculateHeaderGroupWidth(refsGroupHeader);

        var groupHeaderCell = !getOr(true, 'props.canRenderHeader', column) ? null : React.createElement(
          'div',
          { className: classesGroupHeader },
          React.createElement(
            Cell,
            {
              columnIndex: index,
              fnGetCellStyle: columnProps.fnGetCellStyle,
              fnGetCellContentStyle: columnProps.fnGetCellContentStyle,
              width: width,
              didUpdate: this.headerGroupAfterRenderCallBack,
              registerCell: this.memoizeRegisterHeaderGroup(refsGroupHeader.ref),
              unregisterCell: this.memoizeUnregisterHeaderGroup(refsGroupHeader.ref)
            },
            React.createElement(
              'span',
              { className: 'table-cell-group-title' },
              columnProps.iconExpandCollapse,
              React.createElement(GroupHeaderCell, {
                infoIconOptions: columnProps.infoIconOptions,
                didUpdate: this.headerGroupAfterRenderCallBack,
                renderTitle: renderTitle
              })
            )
          )
        );

        var classes = classnames('table-cell-group', {
          'u-stickLeft': props.stickHorizontal && column.props.isColumnHeader
        });

        return React.createElement(
          'div',
          { key: index, className: classes },
          React.createElement(
            'div',
            { className: 'nested-table' },
            groupHeaderCell,
            React.createElement(
              'div',
              { className: 'table-row' },
              child
            )
          )
        );
      }

      if (column.type !== Column) {
        return null;
      }
      var onResize = this.handleColumnResize(this.columnHeaderCounter);
      var onResizeStop = this.handleResizeStop(this.columnHeaderCounter);

      this.columnHeaderCounter++;

      return allowResize ? React.createElement(
        Resizer,
        {
          key: index,
          width: columnWidth,
          rightResize: true,
          minConstraints: [props.defaultColumnWidth, 0],
          onResize: onResize,
          onResizeStop: onResizeStop
        },
        React.createElement(
          Cell,
          (0, _extends3.default)({
            fnGetCellContentStyle: columnProps.fnGetHeaderCellContentStyle,
            fnGetCellStyle: columnProps.fnGetHeaderCellStyle,
            deep: deep,
            columnIndex: currentColumn,
            registerCell: this.registerHeaderCell,
            unregisterCell: this.unregisterHeaderCell,
            didUpdate: this.headerAfterRenderCallBack
          }, restColumnProps),
          HeaderComponent ? React.createElement(HeaderComponent, headerComponentProps) : headerCell
        )
      ) : React.createElement(
        Cell,
        (0, _extends3.default)({
          key: index,
          width: columnWidth,
          fnGetCellContentStyle: columnProps.fnGetHeaderCellContentStyle,
          fnGetCellStyle: columnProps.fnGetHeaderCellStyle,
          deep: deep,
          columnIndex: currentColumn,
          registerCell: this.registerHeaderCell,
          unregisterCell: this.unregisterHeaderCell,
          didUpdate: this.headerAfterRenderCallBack
        }, restColumnProps),
        HeaderComponent ? React.createElement(HeaderComponent, headerComponentProps) : headerCell
      );
    },
    registerHeaderGroupCell: function registerHeaderGroupCell(headerGroupId, cellElem) {
      this.tableStore.registerHeaderGroupCell(cellElem, headerGroupId);
    },
    unregisterHeaderGroupCell: function unregisterHeaderGroupCell(headerGroupId, cellElem) {
      this.tableStore.unregisterHeaderGroupCell(cellElem, headerGroupId);
    },
    registerHeaderCell: function registerHeaderCell(cellElem, columnIndex, deep) {
      this.tableStore.registerHeaderCell(cellElem, columnIndex, deep);
    },
    unregisterHeaderCell: function unregisterHeaderCell(cellElem, columnIndex, deep) {
      this.tableStore.unregisterHeaderCell(cellElem, columnIndex, deep);
    },
    registerCell: function registerCell(cellElem, columnIndex) {
      this.tableStore.registerCell(cellElem, columnIndex);
    },
    unregisterCell: function unregisterCell(cellElem, columnIndex) {
      this.tableStore.unregisterCell(cellElem, columnIndex);
    },

    registerVirtualStore: function registerVirtualStore(virtualStore) {
      this.tableStore.registerVirtualStore(virtualStore);
    },

    registerRenderCallback: function registerRenderCallback(props) {
      this.afterRenderCallBack = debounce(100, props.afterRenderCallBack || noop);

      this.headerGroupAfterRenderCallBack = debounce(100, function () {
        if (!isEmpty(this.tableStore.headerGroups)) {
          this.tableStore.updateHeaderGroupHeight();
          this.afterRenderCallBack();
        }
      }.bind(this));

      this.headerAfterRenderCallBack = debounce(100, function () {
        if (!isEmpty(this.tableStore.headerGroups)) {
          this.tableStore.updateHeaderHeight();
          this.afterRenderCallBack();
        }
      }.bind(this));

      this.cellAfterRenderCallBack = debounce(100, function () {
        if (this.props.stickHorizontal && !isEmpty(this.tableStore.cellElements)) {
          this.tableStore.updateCellsHeight();
          this.afterRenderCallBack();
        }
      }.bind(this));
    },

    /**
     * Update header when scroll horizontal table body
     * @param  {Object} value
     */
    handleScroll: function handleScroll(value) {
      var headerTableElm = this.refs.headerTable;

      if (value.target.scrollLeft >= 0) {
        headerTableElm.style.left = -1 * value.target.scrollLeft + 'px';
      }
    },

    handleColumnResize: function handleColumnResize(index) {
      var table = this;
      var tableStore = this.tableStore;

      return function (newPos) {
        table.userResizing = true;
        tableStore.resizeColumn(index, newPos.width, true);
      };
    },

    handleResizeStop: function handleResizeStop(index) {
      var props = this.props;
      this.userResizing = false;
      return function (columnProps) {
        var columnOpts = {
          index: index,
          columnWidth: columnProps.width
        };
        return props.onResizeStopCallback && props.onResizeStopCallback(columnOpts);
      };
    },

    getAllColumns: function getAllColumns(children) {
      var getAllColumnRecursive = function getAllColumnRecursive(childRecursive) {
        childRecursive = concat([], childRecursive);

        if (isEmpty(childRecursive)) {
          return [];
        }

        return flatMap(function (child) {
          if (!child) {
            return [];
          }
          if (child.type === ColumnGroup) {
            return getAllColumnRecursive(child.props.children);
          }
          if (child.type === Column) {
            return [child];
          }
          return [];
        }, childRecursive);
      };

      return compact(getAllColumnRecursive(children));
    },

    initColumnSizes: function initColumnSizes(props, needUpdateColumn) {
      this.changeTableWidth(Infinity, props.children, needUpdateColumn);
    },

    changeTableWidth: function changeTableWidth(tableWidth, columns, needUpdateColumn) {
      var cols = this.getAllColumns(columns);
      var widthInfos = map(function (col) {
        return { width: col.props.width, fixed: !!col.props.fixed };
      }, cols);

      this.tableStore.updateWidths(tableWidth, widthInfos, needUpdateColumn);
    },

    onTableWidthChanged: function onTableWidthChanged(totalColumnWidth, index) {
      totalColumnWidth += this.props.draggableTable ? ResizeHandleWidth : 0;
      totalColumnWidth += this.props.rowSpan && this.props.staticRender ? this.props.rowSpan.width : 0;
      // Change width of body
      var tableBody = this.refs.tableBody;

      tableBody && $izenda(tableBody).width(totalColumnWidth); // (tableBody.style.width = totalColumnWidth + 'px');
    }
  });

  module.exports = {
    Table: observer(Table),
    Column: Column,
    ColumnGroup: ColumnGroup,
    DraggableRow: DraggableRow
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  LICENSE_KEY: {
    Alerting: 'Alerting',
    Form: 'Form',
    Dashboard: 'Dashboard',
    ReportTemplateComponent: 'Report Templates',
    Scheduling: 'Scheduling',
    Exporting: 'Exporting',
    ReportDesigner: 'Report Designer',
    Charting: 'Charting',
    Maps: 'Maps'
  },
  get MESSAGE() {
    return {
      MG02: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_CONNECTION_STRING_INVALID'),
      MG04: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_CONNECT_ERROR'),
      MG05: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_CANNOT_OPEN_DATABASE'),
      MG06: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_LOGIN_FAILED'),
      MG07: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_OVERRIDE_CONNECTION_STRING'),
      MG08: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_INVALID_CONNECTION_STRING')
    };
  },
  get Description() {
    return _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_CONNECTION_STRING_DESCRIPTION');
  },
  SERVER_TYPE: {
    MSSQL: '572bd576-8c92-4901-ab2a-b16e38144813',
    UNKNOWN: '00000000-0000-0000-0000-000000000000'
  },
  CONNECTION_STRING_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_CONNECTION_STRING_CONSTRAINT');
      }
    }
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseCheckerConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ensure = __webpack_require__(38);

var _ensure2 = _interopRequireDefault(_ensure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackable(target) {
  (0, _ensure2.default)(target, 'Target must be set');
  /**
   * A flag to indicate dirty changed status
   * @type {Boolean}
   */
  target.isDirty = false;

  /**
   * Reset dirty status
   */
  target.resetDirty = function () {
    target.isDirty = false;
  };

  /**
   * Mark trackable instance dirty
   */
  target.markDirty = function () {
    target.isDirty = true;
  };
  return target;
} // ----------------------------------------------------------------------
// <copyright file="Izenda.Tracker.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = trackable;
module.exports = exports['default'];

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(150);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Select.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/** https://github.com/JedWatson/react-select
 * Modified : Add feature - adding new item which is not matched with any existing item for multiple/single mode
 */

/**
 * Value component of multi selectbox
 * Example :
 * <Select multi
 *         simpleValue
 *         disabled={this.state.disabled}
 *         value={this.state.value}
 *         placeholder="Select your favourite(s)"
 *         options={this.state.options}
 *         onChange={this.handleSelectChange}>
 * </Select>
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(1801);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1802);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1803);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(12);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(34);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(154);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(27);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(313);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(219);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(351);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
var DEFAULT_ITEM_HEIGHT = 30;
var NUMBER_ZERO = 0;
var NUMBER_ONE = 1;
var CHECK_INDEX_BY_NUMBER = -1;
var BACKSPACE_KEYCODE = 8;
var TAB_KEYCODE = 9;
var ENTER_KEYCODE = 13;
var ESCAPE_KEYCODE = 27;

var Select = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Select, _Component);

  function Select(props) {
    (0, _classCallCheck3.default)(this, Select);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call(this, props));

    _initialiseProps.call(_this);

    var required = props.required,
        value = props.value,
        multi = props.multi;

    _this.state = {
      inputValue: '',
      isFocused: false,
      isOpen: false,
      isPseudoFocused: false,
      required: required && _this.handleRequired(value, multi)
    };
    return _this;
  }

  (0, _createClass3.default)(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autofocus) {
        this.focus();
      }

      this.onChangeWithDebounce = (0, _fp.debounce)(_Izenda10.default.DEFAULT_DEBOUNCE_TIME, function (input) {
        _this2.handleKeyEnterInput(input);
      });
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isOpen !== this.state.isOpen) {
        var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
        handler && handler();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // focus to the selected option
      var _state = this.state,
          isOpen = _state.isOpen,
          inputValue = _state.inputValue;

      if (this.refs.scrollBox && this.scrollTop && isOpen && !this.hasScrolledToOption) {
        this.hasScrolledToOption = true;
      } else if (!isOpen) {
        this.hasScrolledToOption = false;
      }

      if (prevState.inputValue !== inputValue && this.props.onInputChange) {
        this.props.onInputChange(inputValue);
      }
      if (prevProps.disabled !== this.props.disabled) {
        this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
      }
    }
  }, {
    key: 'handleKeyEnterInput',
    value: function handleKeyEnterInput(inputValue) {
      var _this3 = this;

      var pageInfoDefault = { fromIndex: 0, pageSize: _Izenda10.default.LAZY_LOADING_DEFAULT_ITEMS_NUMBER };
      if (this.props.onSearchLazy) {
        this.props.onSearchLazy(inputValue, pageInfoDefault).then(function (data) {
          _this3.isLoading = false;
          if (!(0, _fp.isEmpty)(data) || _this3.props.onAddNew) {
            _this3.setState({ isOpen: true });
          }
        });
      } else {
        this.isLoading = false;
        this.setState({ isOpen: true });
      }
    }
  }, {
    key: 'renderArrow',
    value: function renderArrow() {
      return _react2.default.createElement(
        'span',
        { className: 'Select-arrow-zone', onMouseDown: this.handleMouseDownOnArrow },
        _react2.default.createElement('span', { className: 'Select-arrow', onMouseDown: this.handleMouseDownOnArrow })
      );
    }
  }, {
    key: 'getOptionList',
    value: function getOptionList(options, valueArray, focusedOption) {
      var numOptions = options.length;
      var isSelected = false;

      return options.map(function (item, index) {
        isSelected = valueArray && valueArray.indexOf(item) > CHECK_INDEX_BY_NUMBER;

        return {
          isFirstItem: index === NUMBER_ZERO,
          isLastItem: index === numOptions - NUMBER_ONE,
          option: item,
          isSelected: isSelected,
          isFocused: item === focusedOption
        };
      });
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu(options) {
      var props = this.props;
      var hasValue = true;
      if (props.noResultsText && !(this._visibleOptions && this._visibleOptions.length && props.options && props.options.length)) {
        if (!props.isLazyLoading) {
          hasValue = false;
        } else if (props.onSearchLazy) {
          hasValue = false;
        }
      }

      if (!hasValue || this.isLoading) {
        return props.isLazyLoading && this.isLoading ? _react2.default.createElement(_Izenda20.default, { className: 'Select-option u_flex u_flexCenterAlignItems' }) : _react2.default.createElement(
          'div',
          { className: 'Select-noresults' },
          this.state.inputValue + ' ' + this.props.noResultsText
        );
      }

      if (props.isLazyLoading) {
        return _react2.default.createElement(_Izenda18.default, {
          data: this._visibleOptions,
          isLastPage: props.isLastPage,
          getData: props.getData,
          renderItem: this.renderItemLazy,
          viewHeight: _Izenda10.default.dropdownMaxHeight,
          itemHeight: DEFAULT_ITEM_HEIGHT,
          registerLazyLoadingStore: this.registerLazyLoadingStore
        });
      }

      if (options && options.length) {
        return _react2.default.createElement(_Izenda16.default, {
          dataSource: this.getOptionList.apply(this, arguments),
          getItemKey: this.getOptionKey,
          renderItem: this.renderOption
        });
      } else {
        return null;
      }
    }
  }, {
    key: 'renderSelectWithScroll',
    value: function renderSelectWithScroll(valueArray, isOpen) {
      return _react2.default.createElement(
        'div',
        {
          ref: 'control',
          className: 'Select-control',
          style: this.props.style,
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleMouseDown
        },
        _react2.default.createElement(
          _Izenda14.default,
          { autoHeight: true, autoHeightMax: this.props.inputMaxHeight },
          this.renderValue(valueArray, isOpen),
          this.renderInput(valueArray)
        ),
        !this.props.textboxMode && this.renderArrow()
      );
    }
  }, {
    key: 'renderInputValue',
    value: function renderInputValue(valueArray, isOpen) {
      return _react2.default.createElement(
        'div',
        {
          ref: 'control',
          className: 'Select-control',
          style: this.props.style,
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleMouseDown
        },
        this.renderValue(valueArray, isOpen),
        this.renderInput(valueArray),
        !this.props.textboxMode && this.renderArrow()
      );
    }
  }, {
    key: 'getSelectMenuStyle',
    value: function getSelectMenuStyle(options) {
      var items = (0, _fp.isEmpty)(options) && this.props.noResultsText ? NUMBER_ONE : Math.min(options.length, _Izenda10.default.DEFAUFT_DROPDOWN_ITEMS);

      return { height: items * DEFAULT_ITEM_HEIGHT };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          multi = _props.multi,
          disabled = _props.disabled,
          searchable = _props.searchable,
          inputMaxHeight = _props.inputMaxHeight,
          hiddenMenu = _props.hiddenMenu;
      var _state2 = this.state,
          isFocused = _state2.isFocused,
          isOpen = _state2.isOpen,
          isPseudoFocused = _state2.isPseudoFocused;

      var valueArray = this.getValueArray();
      var options = this._visibleOptions = this.filterOptions(multi ? valueArray : null);
      var focusedOption = this._focusedOption = this.getFocusableOption(valueArray[0]);
      var className = (0, _classnames2.default)('Select', this.props.className, {
        'Select--multi': multi,
        'is-disabled': disabled,
        'is-focused': isFocused,
        'is-open': isOpen,
        'is-pseudo-focused': isPseudoFocused,
        'is-searchable': searchable,
        'has-value': valueArray.length
      });

      var selectMenuStyle = this.getSelectMenuStyle(options);

      return _react2.default.createElement(
        'div',
        { ref: 'wrapper', className: className },
        this.renderHiddenField(valueArray),
        inputMaxHeight ? this.renderSelectWithScroll(valueArray, isOpen) : this.renderInputValue(valueArray, isOpen),
        !hiddenMenu && isOpen && _react2.default.createElement(
          _Izenda12.default,
          { anchor: this.refs.control, onParentScroll: this.closeMenu, onClickOutside: this.closeMenu },
          _react2.default.createElement(
            'div',
            { ref: 'menuContainer', className: 'Select-menu-outer' },
            _react2.default.createElement(
              _Izenda14.default,
              { autoHeight: true, autoHeightMax: _Izenda10.default.dropdownMaxHeight, ref: 'scrollBox' },
              _react2.default.createElement(
                'div',
                {
                  ref: 'menu',
                  className: 'Select-menu',
                  style: selectMenuStyle,
                  onMouseDown: this.handleMouseDownOnMenu
                },
                this.renderMenu(options, !multi ? valueArray : null, focusedOption)
              )
            )
          )
        )
      );
    }
  }]);
  return Select;
}(_react.Component), _class.displayName = 'Select', _class.propTypes = {
  autoBlur: _propTypes2.default.bool,
  autofocus: _propTypes2.default.bool, // autofocus the component on mount
  className: _propTypes2.default.string, // className for the outer element
  clearAllText: stringOrNode, // title for the "clear" control when multi: true
  clearValueText: stringOrNode, // title for the "clear" control
  clearable: _propTypes2.default.bool, // should it be possible to reset value
  delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
  disabled: _propTypes2.default.bool, // whether the Select is disabled or not
  filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
  // boolean to enable default filtering or function to filter the options array
  // ([options], filterString, [values])
  filterOptions: _propTypes2.default.any,
  ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
  inputProps: _propTypes2.default.object, // custom attributes for the Input
  labelKey: _propTypes2.default.string, // path of the label value in option objects
  matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
  multi: _propTypes2.default.bool, // multi-value input
  name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
  noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
  onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
  onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
  onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
  onClose: _propTypes2.default.func, // fires when the menu is closed
  onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
  onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
  onOpen: _propTypes2.default.func, // fires when the menu is opened
  onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
  optionComponent: _propTypes2.default.func, // option component to render in dropdown
  optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
  options: _propTypes2.default.any, // array of options
  placeholder: stringOrNode, // field placeholder, displayed when there's no value
  required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
  scalable: _propTypes2.default.bool, // scalable input width
  searchable: _propTypes2.default.bool, // whether to enable searching feature or not
  // pass the value to onChange as a simple value (legacy pre 1.0 mode),
  // defaults to false
  simpleValue: _propTypes2.default.bool,
  style: _propTypes2.default.object, // optional style to apply to the control
  tabIndex: _propTypes2.default.string, // optional tab index of the control
  value: _propTypes2.default.any, // initial field value
  valueComponent: _propTypes2.default.func, // value component to render
  valueKey: _propTypes2.default.string, // path of the label value in option objects
  valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
  // onAddNew handler: function (newValue) { return: boolean}
  // return result when add new option to list options, if fail does not call set value
  onAddNew: _propTypes2.default.func,
  isInsertOnBlur: _propTypes2.default.bool, // insert new value when blur select
  textboxMode: _propTypes2.default.bool, // make this select like text box
  openOnFocus: _propTypes2.default.bool, // always open options menu on focus
  inputMaxHeight: _propTypes2.default.number, // max height of control
  hiddenMenu: _propTypes2.default.bool // always hidden menu options
}, _class.defaultProps = {
  clearable: true,
  clearAllText: _Izenda8.default.getText('IZENDA_SELECT_CLEAR_ALL_TEXT'),
  clearValueText: _Izenda8.default.getText('IZENDA_SELECT_CLEAR_VALUE_TEXT'),
  delimiter: ',',
  disabled: false,
  filterOptions: true,
  ignoreCase: true,
  inputProps: {},
  labelKey: 'label',
  matchProp: 'label',
  multi: false,
  noResultsText: _Izenda8.default.getText('IZENDA_SELECT_NO_RESULT_TEXT'),
  onBlurResetsInput: true,
  optionComponent: _Izenda4.default,
  placeholder: _Izenda8.default.getText('IZENDA_SELECT_PLACE_HOLDER'),
  required: false,
  scalable: true,
  searchable: true,
  simpleValue: false,
  valueComponent: _Izenda6.default,
  valueKey: 'value',
  options: [],
  textboxMode: false
}, _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.focus = function () {
    var input = _this4.refs.input;

    if (!input) return;
    input.focus();
  };

  this.blurInput = function () {
    var input = _this4.refs.input;

    if (!input) return;
    input.blur();
  };

  this.handleMouseDown = function (event) {
    // if the event was triggered by a mousedown and not the primary
    // button, or if the component is disabled, ignore it.
    var _props2 = _this4.props,
        disabled = _props2.disabled,
        searchable = _props2.searchable;

    if (disabled || event.type === 'mousedown' && event.button !== NUMBER_ZERO) {
      return;
    }

    // prevent default event handlers
    event.stopPropagation();
    event.preventDefault();

    // for the non-searchable select, toggle the menu
    if (!searchable) {
      _this4.focus();
      return _this4.setState({
        isOpen: !_this4.state.isOpen
      });
    }

    // focus to open one dropdownlist at the same time
    _this4.focus();

    if (event.target.className === 'Select-arrow-zone' || event.target.className === 'Select-arrow') {
      // if the input is focused, ensure the menu is open
      _this4.setState({
        isOpen: true,
        isPseudoFocused: false
      });
    }
  };

  this.handleMouseDownOnArrow = function (event) {
    // if the event was triggered by a mousedown and not the primary
    // button, or if the component is disabled, ignore it.
    var _props3 = _this4.props,
        disabled = _props3.disabled,
        searchable = _props3.searchable,
        isLazyLoading = _props3.isLazyLoading;

    // in case of not searchable selects the "onMouseDown" handler do the same in method this.renderInputValue

    if (disabled || !searchable || _this4.isLoading || event.type === 'mousedown' && event.button !== NUMBER_ZERO) {
      return;
    }
    // If the menu isn't open, let the event bubble to the main handleMouseDown
    if (!_this4.state.isOpen) {
      if (isLazyLoading) {
        _this4.isLoading = true;
        _this4.onChangeWithDebounce('');
      } else {
        _this4.setState({ isOpen: true });
      }
      return;
    }
    // prevent default event handlers
    event.stopPropagation();
    event.preventDefault();
    // close the menu
    _this4.closeMenu();
  };

  this.handleMouseDownOnMenu = function (event) {
    // if the event was triggered by a mousedown and not the primary
    // button, or if the component is disabled, ignore it.
    if (_this4.props.disabled || event.type === 'mousedown' && event.button !== NUMBER_ZERO) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();

    _this4.focus();
  };

  this.closeMenu = function () {
    _this4.setState({
      isOpen: false,
      isPseudoFocused: _this4.state.isFocused && !_this4.props.multi,
      inputValue: ''
    });
    _this4.hasScrolledToOption = false;
    _this4.props.onCloseMenu && _this4.props.onCloseMenu();
  };

  this.handleInputFocus = function (event) {
    var isOpen = _this4.state.isOpen || _this4.props.openOnFocus;
    if (_this4.props.onFocus) {
      _this4.props.onFocus(event);
    }
    _this4.setState({
      isFocused: true,
      isOpen: isOpen
    });
  };

  this.handleInputBlur = function () {
    var menu = _this4.refs.menu;
    var _props4 = _this4.props,
        isInsertOnBlur = _props4.isInsertOnBlur,
        valueKey = _props4.valueKey,
        labelKey = _props4.labelKey,
        onBlurResetsInput = _props4.onBlurResetsInput;
    var inputValue = _this4.state.inputValue;

    if (menu && document.activeElement.isEqualNode(menu)) {
      return;
    }

    if (_this4.props.onBlur) {
      if (isInsertOnBlur) {
        var newObject = {};
        newObject[valueKey] = inputValue;
        newObject[labelKey] = inputValue;
        _this4.setState({
          inputValue: ''
        });
        _this4.props.onBlur(newObject);
        _this4.addValue(newObject);
      }
    }
    var onBlurredNextState = {
      isFocused: false,
      isPseudoFocused: false
    };
    if (onBlurResetsInput) {
      onBlurredNextState.inputValue = '';
    }
    _this4.setState(onBlurredNextState);
  };

  this.handleInputChange = function (event) {
    var value = event.target.value;

    var newState = _this4.props.isLazyLoading ? {
      inputValue: value
    } : {
      isOpen: !(0, _fp.isEmpty)(value),
      isPseudoFocused: false,
      inputValue: value
    };

    _this4.isLoading = true;
    _this4.setState(newState);
    _this4.onChangeWithDebounce(value);
  };

  this.handleKeyDown = function (event) {
    var _props5 = _this4.props,
        disabled = _props5.disabled,
        clearable = _props5.clearable;
    var _state3 = _this4.state,
        inputValue = _state3.inputValue,
        isOpen = _state3.isOpen;


    if (disabled) return;
    switch (event.keyCode) {
      case BACKSPACE_KEYCODE:
        if (!inputValue) {
          event.preventDefault();
          _this4.popValue();
        }
        return;
      case TAB_KEYCODE:
        if (event.shiftKey || !isOpen) {
          return;
        }
        _this4.selectFocusedOption(false);
        return;
      case ENTER_KEYCODE:
        if (!isOpen) return;
        event.stopPropagation();
        _this4.selectFocusedOption(true);
        break;
      case ESCAPE_KEYCODE:
        if (isOpen) {
          _this4.closeMenu();
        } else if (clearable) {
          _this4.clearValue(event);
        }
        break;
      default:
        return;
    }
    event.preventDefault();
  };

  this.handleValueClick = function (option, event) {
    if (!_this4.props.onValueClick) return;
    _this4.props.onValueClick(option, event);
  };

  this.handleRequired = function (value, multi) {
    if (!value) return true;
    return multi ? value.length === NUMBER_ZERO : (0, _keys2.default)(value).length === NUMBER_ZERO;
  };

  this.getOptionLabel = function (op) {
    return op[_this4.props.labelKey];
  };

  this.getValueArray = function () {
    var _props6 = _this4.props,
        value = _props6.value,
        multi = _props6.multi,
        delimiter = _props6.delimiter;

    var nextValue = value;
    if (multi) {
      if (typeof nextValue === 'string') nextValue = nextValue.split(delimiter);
      if (!Array.isArray(nextValue)) {
        if (nextValue === null || typeof nextValue === 'undefined') return [];
        nextValue = [value];
      }
      return nextValue.map(_this4.expandValue).filter(function (i) {
        return i;
      }.bind(_this4));
    }
    var expandedValue = _this4.expandValue(nextValue);
    return expandedValue ? [expandedValue] : [];
  };

  this.expandValue = function (value) {
    if (typeof value !== 'string' && typeof value !== 'number') return value;
    var _props7 = _this4.props,
        options = _props7.options,
        valueKey = _props7.valueKey;

    if (!options) return;
    for (var i = 0; i < options.length; i++) {
      if (options[i][valueKey] === value) return options[i];
    }
  };

  this.setValue = function (value) {
    var _props8 = _this4.props,
        labelKey = _props8.labelKey,
        multi = _props8.multi,
        valueKey = _props8.valueKey,
        delimiter = _props8.delimiter,
        required = _props8.required,
        simpleValue = _props8.simpleValue,
        autoBlur = _props8.autoBlur;

    var label = value && (value[labelKey] || null);
    var isNew = value && value.isNew;
    if (autoBlur) {
      _this4.blurInput();
    }
    if (!_this4.props.onChange) return;
    if (required) {
      _this4.setState({ required: _this4.handleRequired(value, multi) });
    }
    if (simpleValue && value) {
      value = multi ? value.map(function (i) {
        return i[valueKey];
      }.bind(_this4)).join(delimiter) : value[valueKey];
    }
    _this4.props.onChange(value, label, isNew);
  };

  this.selectValue = function (value) {
    _this4.hasScrolledToOption = false;
    if (_this4.props.multi) {
      _this4.addValue(value);
      _this4.setState({
        inputValue: ''
      });
    } else {
      _this4.setValue(value);
      _this4.setState({
        isOpen: false,
        inputValue: '',
        isFocused: '',
        isPseudoFocused: false
      });
      _this4.blurInput();
      _this4.props.onCloseMenu && _this4.props.onCloseMenu();
    }
  };

  this.addValue = function (value) {
    var valueArray = _this4.getValueArray();
    _this4.setValue(valueArray.concat(value));
  };

  this.popValue = function () {
    var valueArray = _this4.getValueArray();
    if (!valueArray.length) return;
    if (valueArray[valueArray.length - NUMBER_ONE].clearableValue === false) return;
    _this4.setValue(valueArray.slice(NUMBER_ZERO, valueArray.length - NUMBER_ONE));
  };

  this.removeValue = function (value) {
    var valueArray = _this4.getValueArray();
    var options = _this4.props.options;

    _this4.setValue(valueArray.filter(function (i) {
      return i !== value;
    }.bind(_this4)));

    // remove options of new item
    if (value.isNew) {
      var findIndex = options.indexOf(value);
      options.splice(findIndex, NUMBER_ONE);
    }
    _this4.focus();
  };

  this.clearValue = function (event) {
    // if the event was triggered by a mousedown and not the primary
    // button, ignore it.
    if (event && event.type === 'mousedown' && event.button !== NUMBER_ZERO) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    _this4.setValue(null);
    _this4.setState({
      isOpen: false,
      inputValue: ''
    }, _this4.focus);
  };

  this.focusOption = function (option) {
    _this4.setState({
      focusedOption: option
    });
  };

  this.selectFocusedOption = function (allowAddNew) {
    var _props9 = _this4.props,
        isLazyLoading = _props9.isLazyLoading,
        options = _props9.options,
        valueKey = _props9.valueKey,
        labelKey = _props9.labelKey,
        matchProp = _props9.matchProp,
        multi = _props9.multi;

    if (isLazyLoading && _this4.props.onAddNew && !(options && options.length)) {
      _this4.setState({ isOpen: false });
    }

    var inputValue = _this4.state.inputValue;

    var isMatch = false;
    if (_this4._focusedOption) {
      var valueTest = String(_this4._focusedOption[valueKey]).toLowerCase().trim();
      var labelTest = String(_this4._focusedOption[labelKey]).toLowerCase().trim();

      isMatch = matchProp !== 'label' && valueTest == inputValue || matchProp !== 'value' && labelTest == inputValue;
    }

    var canAddNew = false;
    var newObject = { isNew: true };
    if (allowAddNew && !isMatch && _this4.props.onAddNew) {
      // Add new when don't exist
      newObject[valueKey] = inputValue;
      newObject[labelKey] = inputValue;
      canAddNew = _this4.props.onAddNew(newObject) !== false;
    }

    if (_this4._focusedOption && (!allowAddNew || !_this4.props.onAddNew || isMatch)) {
      return _this4.selectValue(_this4._focusedOption);
    } else if (canAddNew) {
      if (multi) {
        _this4.setState({
          inputValue: ''
        });
        return _this4.addValue(newObject);
      } else {
        _this4.selectValue(newObject);
      }
    }
  };

  this.renderValue = function (valueArray, isOpen) {
    var renderLabel = _this4.props.valueRenderer || _this4.getOptionLabel;
    var ValueComponent = _this4.props.valueComponent;
    var _props10 = _this4.props,
        multi = _props10.multi,
        placeholder = _props10.placeholder,
        onValueClick = _props10.onValueClick,
        disabled = _props10.disabled,
        valueKey = _props10.valueKey;

    if (!valueArray.length) {
      return !_this4.state.inputValue ? _react2.default.createElement(
        'div',
        { className: 'Select-placeholder' },
        placeholder
      ) : null;
    }
    var onClick = onValueClick ? _this4.handleValueClick : null;
    if (multi) {
      return valueArray.map(function (value, i) {
        return _react2.default.createElement(
          ValueComponent,
          {
            disabled: disabled || value.clearableValue === false,
            key: 'value-' + i + '-' + value[valueKey],
            onClick: onClick,
            onRemove: this.removeValue,
            value: value
          },
          renderLabel(value)
        );
      }.bind(_this4));
    } else if (!_this4.state.inputValue) {
      if (isOpen) onClick = null;
      return _react2.default.createElement(
        ValueComponent,
        { disabled: disabled, onClick: onClick, value: valueArray[0] },
        renderLabel(valueArray[0])
      );
    }
  };

  this.renderInput = function () {
    var _props11 = _this4.props,
        inputProps = _props11.inputProps,
        disabled = _props11.disabled,
        searchable = _props11.searchable,
        tabIndex = _props11.tabIndex,
        scalable = _props11.scalable;
    var _state4 = _this4.state,
        required = _state4.required,
        inputValue = _state4.inputValue;

    var className = (0, _classnames2.default)('Select-input', inputProps.className);

    if (disabled || !searchable) {
      return _react2.default.createElement('div', (0, _extends3.default)({}, inputProps, {
        className: className,
        tabIndex: tabIndex || NUMBER_ZERO,
        onBlur: _this4.handleInputBlur,
        onFocus: _this4.handleInputFocus,
        ref: 'input',
        style: { border: 0, width: 1, display: 'inline-block' }
      }));
    }
    if (scalable) {
      return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, inputProps, {
        className: className,
        tabIndex: tabIndex,
        onBlur: _this4.handleInputBlur,
        onChange: _this4.handleInputChange,
        onFocus: _this4.handleInputFocus,
        minWidth: 5,
        ref: 'input',
        required: required,
        value: inputValue
      }));
    }
    return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, inputProps, {
      className: className,
      tabIndex: tabIndex,
      onBlur: _this4.handleInputBlur,
      onChange: _this4.handleInputChange,
      onFocus: _this4.handleInputFocus,
      ref: 'input',
      required: required,
      value: inputValue
    }));
  };

  this.filterOptions = function (excludeOptions) {
    var filterValue = _this4.state.inputValue;
    var options = _this4.props.options || [];
    var _props12 = _this4.props,
        ignoreCase = _props12.ignoreCase,
        matchProp = _props12.matchProp,
        valueKey = _props12.valueKey,
        labelKey = _props12.labelKey,
        isLazyLoading = _props12.isLazyLoading;

    if (typeof _this4.props.filterOptions === 'function') {
      return _this4.props.filterOptions.call(_this4, options, filterValue, excludeOptions);
    } else if (_this4.props.filterOptions) {
      if (ignoreCase) {
        filterValue = filterValue.toLowerCase().trim();
      }
      if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
        return i[valueKey];
      }.bind(_this4));
      return options.filter(function (option) {
        if (excludeOptions && excludeOptions.indexOf(option[valueKey]) > CHECK_INDEX_BY_NUMBER) return false;
        if (this.props.filterOption) return this.props.filterOption.call(this, option, filterValue);
        if (!filterValue) return true;
        if (filterValue && isLazyLoading) return true;
        var valueTest = String(option[valueKey]);
        var labelTest = String(option[labelKey]);
        if (ignoreCase) {
          if (matchProp !== 'label') valueTest = valueTest.toLowerCase();
          if (matchProp !== 'value') labelTest = labelTest.toLowerCase();
        }
        return matchProp !== 'label' && valueTest.indexOf(filterValue) >= NUMBER_ZERO || matchProp !== 'value' && labelTest.indexOf(filterValue) >= NUMBER_ZERO;
      }.bind(_this4));
    } else {
      return options;
    }
  };

  this.renderOption = function (optionInfo) {
    var Option = _this4.props.optionComponent;
    var renderLabel = _this4.props.optionRenderer || _this4.getOptionLabel;
    var optionRef = optionInfo.isFocused ? 'focused' : null;
    var optionClass = (0, _classnames2.default)('Select-option overflow-text', {
      'is-selected': optionInfo.isSelected,
      'is-focused': optionInfo.isFocused,
      'is-disabled': optionInfo.option.disabled
    });

    if ((0, _fp.isNil)(renderLabel(optionInfo.option)) || (0, _fp.isEmpty)(renderLabel(optionInfo.option))) {
      return null;
    }

    return _react2.default.createElement(
      Option,
      {
        className: optionClass,
        isDisabled: optionInfo.option.disabled,
        isFocused: optionInfo.isFocused,
        onSelect: _this4.selectValue,
        onFocus: _this4.focusOption,
        option: optionInfo.option,
        isSelected: optionInfo.isSelected,
        ref: optionRef,
        title: renderLabel(optionInfo.option)
      },
      renderLabel(optionInfo.option)
    );
  };

  this.getOptionKey = function (option) {
    return option[_this4.props.valueKey];
  };

  this.renderItemLazy = function (option) {
    var renderLabel = _this4.props.optionRenderer || _this4.getOptionLabel;
    var valueArray = _this4.getValueArray();
    var isSelected = valueArray && valueArray.indexOf(option) > CHECK_INDEX_BY_NUMBER;
    var optionClass = (0, _classnames2.default)('Select-option overflow-text', {
      'is-disabled': option.disabled,
      'is-selected': isSelected
    });

    var label = renderLabel(option);
    var optionTooltip = option[_this4.props.optionTooltip];
    !optionTooltip && (optionTooltip = label);

    if ((0, _fp.isEmpty)(label)) {
      return null;
    }

    return _react2.default.createElement(
      _Izenda4.default,
      {
        className: optionClass,
        isDisabled: option.disabled,
        onSelect: _this4.selectValue,
        isSelected: isSelected,
        onFocus: _this4.focusOption,
        option: option,
        title: optionTooltip
      },
      label
    );
  };

  this.registerLazyLoadingStore = function (store) {
    _this4.lazyLoadingStore = store;
  };

  this.renderHiddenField = function (valueArray) {
    if (!_this4.props.name) return;

    function stringifyValue(value) {
      if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
        return (0, _stringify2.default)(value);
      } else {
        return value;
      }
    }

    return valueArray.map(function (item, index) {
      return _react2.default.createElement(_Izenda2.default, {
        key: 'hidden.' + index,
        type: 'hidden',
        ref: 'value' + index,
        name: this.props.name,
        value: stringifyValue(item[this.props.valueKey]),
        disabled: this.props.disabled
      });
    }.bind(_this4));
  };

  this.getFocusableOption = function (selectedOption) {
    var options = _this4._visibleOptions;
    if (!options.length) return;
    var focusedOption = _this4.state.focusedOption || selectedOption;
    if (focusedOption && options.indexOf(focusedOption) > CHECK_INDEX_BY_NUMBER) return focusedOption;
    for (var i = 0; i < options.length; i++) {
      if (!options[i].disabled) return options[i];
    }
  };
}, _temp);
exports.default = Select;
module.exports = exports['default'];

/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportClass = exportClass;

var _Izenda = __webpack_require__(657);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function exportClass(name) {
  return function (Class) {
    _Izenda2.default.register(name, Class);
    return Class;
  };
} // ----------------------------------------------------------------------
// <copyright file="Izenda.ServiceProvider.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildListFilter(filters) {
  if ((0, _fp.isEmpty)(filters)) {
    return '';
  }

  var result = '<ul style="list-style-type: decimal" >';

  (0, _fp.forEach)(function (filter) {
    var filterString = '<li>' + filter.alias + '</li>';
    result += filterString;
  }, filters);

  result += '</ ul>';

  return result;
} // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportsConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var LEFT_MENU_CONCAT_TREE_MAP = [{
  prop: 'subCategories',
  expand: false,
  children: [{
    prop: 'subCategories',
    expand: false
  }]
}];

exports.default = {
  NO_PERMISSION: 'NO_PERMISSION',
  CATEGORY_TYPE: {
    REPORT: '0',
    TEMPLATES: '1',
    CATEGORY_ID: 'CategoryId',
    SUB_CATEGORY_ID: 'SubCategoryId'
  },
  reportTypeName: function reportTypeName(reportType) {
    return reportType === '0' ? 'report' : 'template';
  },

  REPORT_PROPERTY: {
    All: 0,
    DataSource: 1,
    Relationship: 2,
    Filter: 3,
    ReportPart: 4,
    CalculatedField: 5,
    DynamicQuerySourceField: 6,
    Scheduling: 7,
    Access: 8,
    Report: 9
  },
  ALL_CATEGORY_TYPES: {
    ALL_REPORTS: {
      get name() {
        return _Izenda2.default.getText('REPORTS_CONSTANTS_LABEL_ALL_REPORTS');
      },
      type: 0,
      id: '0000',
      isGlobal: null
    },
    ALL_TEMPLATES: {
      get name() {
        return _Izenda2.default.getText('REPORTS_CONSTANTS_LABEL_ALL_TEMPLATES');
      },
      type: 1,
      id: '0000',
      isGlobal: null
    }
  },
  ACTION_TYPES: {
    get MOVE_TITLE() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_LABEL_MOVE');
    },
    MOVE_CONTENT: ' move ',
    get COPY_TITTLE() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_LABEL_COPY');
    },
    COPY_CONTENT: ' copy '
  },

  SEARCH_CRITERIA: [{
    value: 'All',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: 'ReportName',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_REPORT_NAME');
    }
  }, {
    value: 'ReportDescription',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_REPORT_DESCRIPTION');
    }
  }, {
    value: 'CreatedBy',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_BY');
    }
  }, {
    value: 'CreatedDate',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_DATE');
    }
  }, {
    value: 'LastEditedBy',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_BY');
    }
  }, {
    value: 'LastEditedDate',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_DATE');
    }
  }, {
    value: 'Category',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_CATEGORY');
    }
  }, {
    value: 'Subcategory',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_SUBCATEGORY');
    }
  }],
  TEMPLATE_SEARCH_CRITERIA: [{
    value: 'All',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: 'ReportName',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_TEMPLATE_NAME');
    }
  }, {
    value: 'ReportDescription',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_TEMPLATE_DESCRIPTION');
    }
  }, {
    value: 'CreatedBy',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_BY');
    }
  }, {
    value: 'CreatedDate',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_DATE');
    }
  }, {
    value: 'LastEditedBy',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_BY');
    }
  }, {
    value: 'LastEditedDate',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_DATE');
    }
  }, {
    value: 'Category',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_CATEGORY');
    }
  }, {
    value: 'Subcategory',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_SUBCATEGORY');
    }
  }],
  SORT_CRITERIA: [{
    value: 'ReportName',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_REPORT_NAME');
    }
  }, {
    value: 'CreatedBy',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_BY');
    }
  }, {
    value: 'CreatedDate',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_DATE');
    }
  }, {
    value: 'LastEditedBy',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_BY');
    }
  }, {
    value: 'LastEditedDate',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_DATE');
    }
  }, {
    value: 'NumberOfView',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_NUMBER_OF_VIEWS');
    }
  }, {
    value: 'RenderingTime',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_AVERAGE_RENDERING_TIME');
    }
  }, {
    value: 'Category',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_CATEGORY');
    }
  }, {
    value: 'Subcategory',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_SUBCATEGORY');
    }
  }, {
    value: 'LastViewed',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_LAST_VIEWED');
    }
  }],
  TEMPLATE_SORT_CRITERIA: [{
    value: 'ReportName',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_TEMPLATE_NAME');
    }
  }, {
    value: 'CreatedBy',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_BY');
    }
  }, {
    value: 'CreatedDate',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_DATE');
    }
  }, {
    value: 'LastEditedBy',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_BY');
    }
  }, {
    value: 'LastEditedDate',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_DATE');
    }
  }, {
    value: 'NumberOfView',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_NUMBER_OF_VIEWS');
    }
  }, {
    value: 'RenderingTime',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_AVERAGE_RENDERING_TIME');
    }
  }, {
    value: 'Category',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_CATEGORY');
    }
  }, {
    value: 'Subcategory',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_SUBCATEGORY');
    }
  }, {
    value: 'LastViewed',
    get label() {
      return _Izenda2.default.getText('COMMON_CRITERIA_LAST_VIEWED');
    }
  }],
  SORT_TYPES: {
    ASC: 'asc',
    DESC: 'desc'
  },
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  UNCATEGORIZED: 'Uncategorized',
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  CONSTRAINTS: {
    NAME: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_REPORT_NAME_REQUIRED');
        }
      },
      format: {
        pattern: _Izenda3.VALID_REPORT_NAME_REGEX,
        get message() {
          return _Izenda2.default.getText('INVALID_REPORT_NAME');
        }
      }
    },
    TEMPLATE_NAME: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_TEMPLATE_NAME_REQUIRED');
        }
      },
      format: {
        pattern: _Izenda3.VALID_REPORT_NAME_REGEX,
        get message() {
          return _Izenda2.default.getText('INVALID_TEMPLATE_NAME');
        }
      }
    }
  },
  MESSAGES: {
    get M03() {
      return _Izenda2.default.getText('CATEGORY_MESSAGES_CONFIRM_DELETE_CATEGORY');
    },
    get M04() {
      return _Izenda2.default.getText('CATEGORY_MESSAGES_CONFIRM_DELETE_SUBCATEGORY');
    },
    get M05a() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_DELETE_REPORT');
    },
    get M05b() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_DELETE_TEMPLATE');
    },
    get M06a() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SUCCESSFULLY_COPIED');
    },
    get M06b() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SUCCESSFULLY_MOVED');
    },
    get SAVE_REPORT() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SAVE_REPORT');
    },
    get SAVE_AS_REPORT() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SAVE_AS_REPORT');
    },
    get INVALID_REPORT() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_INVALID_REPORT');
    },
    get CANCEL() {
      return _Izenda2.default.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST');
    },
    UPDATE_RESULT: function UPDATE_RESULT(filterFields) {
      var result = '<p> ' + _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_DIFFERENT_SCHEMA') + ' </p>';
      return result += buildListFilter(filterFields);
    },
    EMPTY_FILTER_PARAM: function EMPTY_FILTER_PARAM(filterFields) {
      var result = '<p> ' + _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_FILTER_VALUE') + '</p>';
      return result += buildListFilter(filterFields);
    },
    EMPTY_REQUIRED_FILTER: function EMPTY_REQUIRED_FILTER(filterFields) {
      var result = '<p> ' + _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_REQUIRE_AND_NOT_VISIBLE_FIELD') + '</p>';
      return result += buildListFilter(filterFields);
    },
    EMPTY_VISIBLE_REQUIRED_FILTER: function EMPTY_VISIBLE_REQUIRED_FILTER(filterFields) {
      var result = '<p> ' + _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_REQUIRE_AND_VISIBLE_FIELD') + '</p>';
      return result += buildListFilter(filterFields);
    },
    EMPTY_REQUIRED_PARAM_FILTER: function EMPTY_REQUIRED_PARAM_FILTER(paramFilters, requiredFilters) {
      var result = '';

      var paramsMessage = '<div> <p>- ' + _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_FILTER_VALUE') + '</p>';
      paramsMessage += buildListFilter(paramFilters) + '</div>';
      result += paramsMessage;

      var requiedMessage = '<div> <p>- ' + _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_REQUIRE_AND_NOT_VISIBLE_FIELD') + '</p>';
      requiedMessage += buildListFilter(requiredFilters) + '</div>';
      result += requiedMessage;

      return result;
    },

    get NEED_UPDATE_RESULTS() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_CLICK_UPDATE_RESULT');
    }
  },
  COPY_REPORT: {
    get TEXT_CREATE_CATEGORY() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_TEXT_CREATE_CATEGORY');
    },
    get TEXT_CREATE_SUB_CATEGORY() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_TEXT_CREATE_SUB_CATEGORY');
    }
  },
  get FREEZE_BTN_LABEL() {
    return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_LABEL_FREEZE_BTN_LABEL');
  },
  get UNFREEZE_BTN_LABEL() {
    return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_LABEL_UNFREEZE_BTN_LABEL');
  },
  FITLERS_PANEL_UI: {
    fullHeight: '100%',
    minHeight: 180,
    maxHeight: 345
  },
  SYSTEM_VARIABLES: {
    REPORT_NAME: '{reportName}',
    CURRENT_DATETIME: '{currentDateTime}',
    CURRENT_USERNAME: '{currentUserName}',
    TENANT_NAME: '{tenantName}'
  },
  MINIMUM_ROW: 4,
  DATETIME_FORMAT: 'MM/dd/yyyy',
  SUBREPORT_POPUP: {
    get popupTitle() {
      return _Izenda2.default.getText('REPORTS_CONSTANTS_REPORT_LABEL_SUBREPORT');
    },
    frameHeightInPx: '700px',
    frameWidthInPercent: '100%'
  },
  GRID_PREVIEW_POPUP_SIZE: {
    height: 500
  },
  REPORT_LIST_CONCAT_TREE_MAP: [{
    prop: 'subCategories',
    children: [{
      prop: 'subCategories',
      children: [{
        prop: 'reports'
      }]
    }]
  }],
  LEFT_MENU_CONCAT_TREE_MAP: LEFT_MENU_CONCAT_TREE_MAP,
  LEFT_MENU_TREE_MAP: [{
    prop: 'globalLocalCategory',
    expand: true,
    children: LEFT_MENU_CONCAT_TREE_MAP
  }]
};
module.exports = exports['default'];

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  REPORT_PART_MAX_WIDTH: 12,
  REPORT_PART_MAX_HEIGHT: 4,
  TITLES_COLS_SHOW_PREVIEW: 11,
  TITLES_COLS_NOT_SHOW_PREVIEW: 12,
  EVENT_ENTER_CHANGE_NUMBERS_OF_RECORDS: 13,
  get COLLAPSE_DEFAULT() {
    return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_COLLAPSE_DEFAULT');
  },
  get EXPAND_RIGHT() {
    return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_EXPAND_RIGHT');
  },
  get EXPAND_LEFT() {
    return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_EXPAND_LEFT');
  },
  MESSAGES: {
    get M01() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_DELETE');
    },
    get M02() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_NAME_EXISTS');
    },
    get M03() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_NUMBER_OF_FIELDS_LIMITATION');
    },
    get M05() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_HAS_DATA_TYPE_IMAGE_OR_LOB');
    },
    get M06() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_CHANGE_TO_AGGREGATED_FIELD_CONFIRM');
    },
    get M11() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_RESOURCE_CANNOT_FOUND');
    },
    get M12() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_FIELD_NOT_EXIST');
    },
    get M13() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_COLUMN_NOT_EXIST');
    },
    get L02() {
      return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_NO_RESULT_FOUND');
    },

    get M05_1() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_REMOVE_BINARY_FIELD');
    },
    get M08() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_CANNOT_GROUPED_OR_SORTED');
    },
    get M09() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_INVALID_COUNT_OPERATOR');
    },
    get M28() {
      return _Izenda2.default.getText('REPORT_CANNOT_ADD_RUNNING_FIELD');
    },
    get M29() {
      return _Izenda2.default.getText('REPORT_CONFIRM_DISABLE_MULTI_COLOR');
    },
    get M30() {
      return _Izenda2.default.getText('REGRESSION_LINE_REMOVE_WARNING');
    },
    get MAP_DATA_UNAVAILABLE() {
      return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_MESSAGE_UNAVAILABLE_MAP_DATA');
    },
    get OUTDATED_REPORT() {
      return _Izenda2.default.getText('COMMON_MESSAGES_OUTDATED_REPORT');
    }
  },
  get SWITCH_TO_PREVIEW() {
    return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_SWITCH_TO_PREVIEW');
  },
  get SWITCH_TO_CONFIGURATION() {
    return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_SWITCH_TO_CONFIGURATION');
  },
  NUMBER_OF_RECORD_LIMIT_CONSTRAINT: {
    numericality: {
      onlyInteger: true,
      lessThanOrEqualTo: Math.pow(2, 31),
      get notLessThanOrEqualTo() {
        return _Izenda2.default.getText('REPORT_BODY_CONSTANTS_NUMBER_OF_RECORD_LIMIT_CONSTRAINT');
      }
    }
  },
  DRAG_ITEM: {
    REPORT_PART_FIELD_ITEM: 'ReportPartFieldItem'
  },
  FIELD_CONTAINER_HEIGHT: 70,
  FIELD_HIDDEN_LABEL: '●●●',
  FIELD_NAME_ALIAS_REGEX: '^{0} (\\((.*)\\) \\(\\d+\\)|\\((.*)\\))$',
  FIELD_NAME_WITH_FUNCTION_TEMPLATE: '{0} ({1})',
  NUMBER_BODY_COLS: 12,
  NUMBER_BODY_ROWS: 7,
  BODY_CELL_HEIGHT: 90,
  BODY_CELL_WIDTH: 90,
  REPORT_PART_SPACING: 0.5,
  REPORT_PART_LABEL: {
    get CHART() {
      return _Izenda2.default.getText('COMMON_LABEL_CHART');
    },
    get FORM() {
      return _Izenda2.default.getText('COMMON_LABEL_FORM');
    },
    get GAUGE() {
      return _Izenda2.default.getText('COMMON_LABEL_GAUGE');
    },
    get GRID() {
      return _Izenda2.default.getText('COMMON_LABEL_GRID');
    },
    get MAP() {
      return _Izenda2.default.getText('COMMON_LABEL_MAP');
    }
  },
  REPORT_PART_MODE: {
    PREVIEW: 'preview',
    CONFIG: 'config'
  },
  TIMELAPSE: 500,
  REPORT_PART_SMALL_SIZE: 370,
  DIRECTION: {
    LEFT: 'left',
    RIGHT: 'right'
  },
  DIRECTION_STATE: {
    LEFT: 1,
    RIGHT: -1,
    NORMAL: 0
  },
  RUNNING_FUNCTION_INVALID_CONTAINER: {
    Grid: {
      Vertical: ['separators'],
      Horizontal: ['separators'],
      Drilldown: ['rows', 'separators'],
      Pivot: ['columns', 'rows', 'separators']
    },
    Chart: {
      Line: ['labels', 'separators'],
      Column: ['labels', 'separators'],
      Bar: ['labels', 'separators'],
      Area: ['labels', 'separators'],
      Pie: ['labels', 'separators'],
      Funnel: ['labels', 'separators'],
      Donut: ['labels', 'separators'],
      Combination: ['labels'],
      TreeMap: ['labels', 'separators'],
      HeatMap: ['labels', 'values'],
      Bubble: ['bubbleSize', 'valuesLabels'],
      Scatter: ['valuesLabels'],
      Waterfall: ['labels'],
      Sparkline: ['labels', 'separators']
    },
    Gauge: {
      LinearGauge: ['labels', 'separators'],
      SimpleGauge: ['labels', 'separators'],
      SolidGauge: ['labels', 'separators']
    },
    Map: {
      World: ['country', 'state', 'county', 'city', 'postalCode', 'latitude', 'longtitude'],
      Continent: ['country', 'state', 'county', 'city', 'postalCode', 'latitude', 'longtitude'],
      Country: ['country', 'state', 'county', 'city', 'postalCode', 'latitude', 'longtitude']
    }
  },
  CONSTRAINTS: {
    NAME: {
      format: {
        pattern: _Izenda3.VALID_REPORT_NAME_REGEX,
        get message() {
          return _Izenda2.default.getText('INVALID_REPORT_NAME');
        }
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(1832);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Change tracker decorator
 */
var tracker = (0, _Izenda2.default)({
  resetDirty: function resetDirty() {
    this.isDirty = false;
  },
  markDirty: function markDirty() {
    this.isDirty = true;
  }
}); // ----------------------------------------------------------------------
// <copyright file="Izenda.Tracker.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = tracker;
module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="StringUtilities.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * String utilities
 */
// TODO: test TOSRING
!function () {
  var _require = __webpack_require__(1),
      toString = _require.toString,
      isNil = _require.isNil,
      isEmpty = _require.isEmpty,
      trim = _require.trim,
      toUpper = _require.toUpper,
      some = _require.some,
      reject = _require.reject,
      join = _require.join,
      flow = _require.flow,
      isUndefined = _require.isUndefined,
      isNumber = _require.isNumber,
      escapeRegExp = _require.escapeRegExp,
      map = _require.map,
      includes = _require.includes,
      placeholder = _require.placeholder;

  var _require2 = __webpack_require__(50),
      EMPTY_GUID = _require2.EMPTY_GUID;
  /**
   * Format string with parameters
   * @returns {String}
   */


  String.format = function () {
    // The string containing the format items (e.g. "{0}")
    // will and always has to be the first argument.
    var theString = arguments[0];

    if (theString === undefined || theString === '') {
      return theString;
    }

    // start with the second argument (i = 1)
    for (var i = 1; i < arguments.length; i++) {
      // "gm" = RegEx options for Global search (more than one instance)
      // and for Multi-line search
      var regEx = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
      theString = theString.replace(regEx, arguments[i]);
    }

    return theString;
  };

  String.formatDate = function (dateString) {
    if (!dateString) {
      return '';
    }

    var yyyy = dateString.substring(0, 4);
    var mm = dateString.substring(5, 7);
    var dd = dateString.substring(8, 10);

    return mm + '/' + dd + '/' + yyyy;
  };

  String.convertArrayOfStringToString = function (arr) {
    var result = '';
    if (!arr || arr.length === 0) {
      return result;
    }

    arr.forEach(function (element) {
      result += element;
    });

    return result;
  };

  String.isGuidFormat = function (arr) {
    var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;

    if (arr && regexGuid.test(arr)) {
      return true;
    }

    return false;
  };

  /**
   * Hash key to remove '[' , ']', '.' from id
   * Prevent error for jquery selector
   */
  String.hashKeyId = function (key) {
    return key.replace(/[\[\]\.]/g, '');
  };
  /**
   * Format number to string with int format
   * @param  {Int} number  Format number
   * @return {String}   Result
   */
  String.numberToString = function (number) {
    if (isNil(number) || !isNumber(number)) {
      return number;
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  String.decimalToString = function (number, decimalPlace) {
    if (isNil(number) || !isNumber(number)) {
      return number;
    }
    decimalPlace = decimalPlace || 1;
    return number.toFixed(decimalPlace).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  };

  /**
   * Date to String
   * @param  {[type]} date [description]
   * @return {[type]}     [description]
   */
  String.dateToString = function (date) {
    if (isNil(date)) {
      return date;
    }
    return date.toLocaleDateString();
  };

  /**
   * generate new name base on original name with number indicator to prevent duplicate
   * ex:
   *
   *    String.generateNewName('base',['base','test'],null,'()') -> 'base (2)'
   *    String.generateNewName('base',['base','test'],) -> 'base 2'
   *    String.generateNewName('base',[{name: 'base'}, {name: 'Test'}], get('name')) -> 'base 2'
   *
   * @param  {string} baseName        base name need to generate
   * @param  {Array} list               Array of string or object, if object must provide getStringFunction
   * @param  {func} getName           get property function  from object
   *                                    !optional if list is arra of string
   * @param  {string} numberContainer   container to wrap next number
   *                                    !optional
   * @return {string}                   unique new name
   */
  String.generateNewName = function (originalName, list, getName, numberContainer) {
    ensure(isEmpty(numberContainer) || typeof numberContainer === 'string', 'number container character must be string or undefined');

    var openCharacter = !isEmpty(numberContainer) && numberContainer[0] || '';
    var closeCharacter = !isEmpty(numberContainer) && numberContainer[1] || openCharacter;
    var esc = escapeRegExp;

    var regexString = String.format('^{0}(?: {1}(\\d+){2})?$', esc(originalName), esc(openCharacter), esc(closeCharacter));
    var regex = new RegExp(regexString, 'i');

    var extractNumber = function extractNumber(item) {
      return parseInt(regex.exec(item)[1] || '1');
    };

    var nextNumber = (placeholder(list).map(function (item) {
      return getName ? getName(item) : item;
    }).filter(function (item) {
      ensure(isNil(item) || typeof item === 'string', 'getStringFunction must return string');
      return item && regex.test(item);
    }).map(extractNumber).max() || 0) + 1;

    return nextNumber === 1 ? originalName : String.format('{0} {1}{2}{3}', originalName, openCharacter, nextNumber, closeCharacter);
  };

  /**
   * check duplicate base on getFn
   * @method checkDuplicate
   * @param  {string} baseName        base name need to generate
   * @param  {Array}  list            Array of string or object, if object must provide getStringFunction
   * @param  {func}   getFn           Get property function  from object
   *                                  !optional if list is arra of string
   * @return {boolean}                Check duplicate result
   */
  String.checkDuplicate = function (newText, existingCollection, getFn) {
    var upperText = trim(toUpper(newText));

    return some(function (item) {
      var itemData = getFn ? getFn(item) : item;

      ensure(isNil(itemData) || typeof itemData === 'string', 'only support string data');
      return trim(toUpper(itemData)) === upperText;
    }, existingCollection);
  };

  /**
   * Check value is pattern format
   * @param  {string}   value
   * @param  {regex}    pattern
   * @return {boolean}  result
   */
  String.isPatternFormat = function (value, pattern) {
    return pattern.test(value);
  };

  String.concatToUrl = function (args) {
    var slashPattern = /^\/+|\/+$/gm;
    var excludeEmpty = reject(isEmpty);
    var concatenateWithSlash = join('/');
    var trimSlash = map(function (part) {
      return part.replace(slashPattern, '');
    });

    return '/' + flow(trimSlash, excludeEmpty, concatenateWithSlash)(args);
  };

  /**
   * Convert rgb to hexColor
   * @param  {String} color val [description]
   * @return {[type]}          [description]
   */
  String.rgbToHex = function (color) {
    var HEX_VALUE = 16;
    var RGB_LENGTH = 3;

    var parts = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (isNil(parts)) return;
    delete parts[0];

    for (var i = 1; i <= RGB_LENGTH; i++) {
      parts[i] = parseInt(parts[i]).toString(HEX_VALUE);

      if (parts[i].length == 1) {
        parts[i] = '0' + parts[i];
      }
    }

    return '#' + parts.join('');
  };

  String.compareString = function (a, b, ignoreCase) {
    ignoreCase = isUndefined(ignoreCase) ? true : ignoreCase;

    if (ignoreCase) {
      return (a || '').toString().toLowerCase() === (b || '').toString().toLowerCase();
    }

    return a === b;
  };

  /**
   * search string
   * @param  {String} source
   * @param  {String} searchText
   * @param  {boolean} ignoreCase
   * @return {boolean} isMatched
   */
  String.searchString = function (source, searchText, ignoreCase) {
    if (!source || !searchText) {
      return false;
    }

    if (ignoreCase) {
      return includes(searchText.toLowerCase(), source.toLowerCase());
    }
    return includes(searchText, source);
  };

  String.replaceAt = function (source, index, length, newStr) {
    return source.substr(0, index) + newStr + source.substr(index + length);
  };

  /**
   * [truncateString description]
   * @param  {[type]} str [description]
   * @param  {[type]} num [description]
   * @return {[type]}     [description]
   */
  String.truncateString = function (str, num) {
    if (str.length <= num) {
      return str;
    } else {
      return str.slice(0, num) + '...';
    }
  };

  /**
   * Convert to string value
   * @param  {any} value
   * @param  {boolean} convertNullToEmpty
   * @return {string}
   */
  String.commonStringValue = function (value, convertNullToEmpty) {
    if (isNil(value) || isUndefined(value)) {
      return convertNullToEmpty ? '' : 'null';
    } else {
      return toString(value);
    }
  };

  /**
   * Check is guid empty
   * @param  {String}  value
   * @return {Boolean}
   */
  String.isEmptyGuid = function (value) {
    return value === EMPTY_GUID;
  };

  /**
   * Create guid string
   * @return {String}
   */
  String.newGuid = function () {
    function random4Digit() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return '' + random4Digit() + random4Digit() + '-' + random4Digit() + '-' + random4Digit() + '-' + random4Digit() + '-' + random4Digit() + random4Digit() + random4Digit();
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.ObjectStateConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
* Constant data for other settings
*/

exports.default = {
  NONE: 0,
  INSERT: 1,
  DELETE: 2,
  UPDATE: 3
};
module.exports = exports["default"];

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  get MESSAGES() {
    return {
      M01: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_INCORECT_CREDENTIALS'),
      M02: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_RESET_PASSWORD_SUCCESSFULLY'),
      M04: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_PASSOWRD_EXPIRED'),
      M08: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_CONTACT_ADMIN'),
      M15: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_PASSWORD_LINK_EXPIRED'),
      M16: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_PASSWORD_EXPIRY')
    };
  },
  STEP_KEYS: {
    AccountInfo: 'AccountInfo',
    SecurityInfo: 'SecurityInfo',
    QuestionInfo: 'QuestionInfo',
    PasswordInfo: 'PasswordInfo'
  },
  get CONSTRAINTS() {
    return {
      tenantName: {
        // presence: {
        //   presence: true,
        //   message: 'Organization is required.'
        // }
      },
      userName: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_USERID_REQUIRED')
        }
      },
      firstName: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_FIRST_NAME_REQUIRED')
        }
      },
      lastName: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_LAST_NAME_REQUIRED')
        }
      },
      emailAddress: {
        format: {
          pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
          message: function message(value, attribute, validatorOptions, attributes, globalOptions) {
            return _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_INVALID_EMAIL');
          }
        }
      },
      password: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_NEW_PASSWORD_REQUIRED')
        }
      },
      currentPassword: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_CURRENT_PASSWORD_REQUIRED')
        }
      },
      confirmPassword: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_NEW_PASSWORD_CONFIRM')
        },
        equality: {
          attribute: 'password',
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_NEW_AND_CONFIRM_PASSOWRD_NOT_MATCHED'),
          comparator: function comparator(firstOperand, secondOperand) {
            return (0, _fp.isEqual)(firstOperand, secondOperand);
          }
        }
      },
      question: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_SECURITY_QUESTION_IS_REQUIRED')
        }
      },
      answer: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_SECURITY_ANSWER_IS_REQUIRED')
        }
      },
      yourAnswer: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('COMMON_LABEL_YOUR_ANSWER_IS_REQUIRED')
        }
      },
      loginPassword: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_PASSWORD_IS_REQUIRED')
        }
      }
    };
  },
  MODES: {
    PASSWORD_SETUP: 'PasswordSetup',
    RESET_PASSWORD: 'ResetPassword',
    FORGOT_PASSWORD: 'ForgotPassword'
  },
  HEADER_KEYS: {
    access_token: 'access_token',
    current_tenant: 'current_tenant',
    selected_tenant: 'selected_tenant',
    prefer: 'Prefer'
  },
  HEADER_PREFER: {
    minimal: 'return=minimal',
    representation: 'return=representation'
  },
  NOTIFICATION_KEYS: {
    PASSWORD_EXPIRY: 'PasswordExpiry'
  }
};
module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _class3, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AlertBox.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/**
 * @module Alert control - Display alert content inside a highlighted box
 * @example
 * <Alert type=['success'| 'info' |'warning'|'error'] dismissible=[true|false] autoHide=[true|false]>
 *   ...
 * </Alert>
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Alert = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Alert, _Component);

  function Alert(props) {
    (0, _classCallCheck3.default)(this, Alert);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Alert.__proto__ || (0, _getPrototypeOf2.default)(Alert)).call(this, props));

    _initDefineProp(_this, 'show', _descriptor, _this);

    _this.closeAlert = function () {
      _this.show = false;
      _this.props.onDismiss && _this.props.onDismiss();
    };

    _this.mounted = false;
    _this.setTimeout(_this.props);
    return _this;
  }

  (0, _createClass3.default)(Alert, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      window.clearTimeout(this.myTimeout);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      window.clearTimeout(this.myTimeout);
      this.show = true;
      this.setTimeout(nextProps);
    }
  }, {
    key: 'setTimeout',
    value: function setTimeout(props) {
      var _this2 = this;

      if (props.autoHide) {
        this.myTimeout = window.setTimeout(function () {
          _this2.mounted && (_this2.show = false);
          props.onAutoHide && props.onAutoHide();
        }, props.displayTime);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dismissible = _props.dismissible,
          className = _props.className,
          type = _props.type,
          children = _props.children;


      var dismissButton = dismissible && _react2.default.createElement(
        'a',
        { type: 'button', className: 'close', 'aria-label': 'Close', onClick: this.closeAlert },
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true' },
          '\xD7'
        )
      );

      var classes = (0, _classnames2.default)('izenda-Alert alert', className, {
        'alert-success': type === _Izenda.ALERT_TYPES.SUCCESS,
        'alert-info': type === _Izenda.ALERT_TYPES.INFO,
        'alert-warning': type === _Izenda.ALERT_TYPES.WARNING,
        'alert-danger': type === _Izenda.ALERT_TYPES.ERROR,
        'alert-dismissible': dismissible
      });

      return children && this.show ? _react2.default.createElement(
        'div',
        { className: classes, role: 'alert' },
        dismissButton,
        children
      ) : null;
    }
  }]);
  return Alert;
}(_react.Component), _class3.propTypes = {
  type: _propTypes2.default.oneOf([_Izenda.ALERT_TYPES.SUCCESS, _Izenda.ALERT_TYPES.INFO, _Izenda.ALERT_TYPES.WARNING, _Izenda.ALERT_TYPES.ERROR]),
  dismissible: _propTypes2.default.bool,
  autoHide: _propTypes2.default.bool,
  displayTime: _propTypes2.default.number,
  onAutoHide: _propTypes2.default.func,
  onDismiss: _propTypes2.default.func
}, _class3.defaultProps = {
  dismissible: false,
  autoHide: true,
  displayTime: _Izenda.DISPLAY_TIME
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'show', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
})), _class2)) || _class;

exports.default = Alert;
module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TextHighlight.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Text high light Component
 * Example :
 * <TextHighLight className="pull-left" onClick={this.clickEdit} highlight={dataSource.searchText} text={dataSource.name}></TextHighLight>
 */
!function () {
  var React = __webpack_require__(0);

  var _require = __webpack_require__(1),
      escape = _require.escape,
      escapeRegExp = _require.escapeRegExp;

  var TextHighLight = React.createClass({
    displayName: 'TextHighLight',

    propTypes: {
      className: React.PropTypes.string,
      onClick: React.PropTypes.func,
      highlight: React.PropTypes.string,
      text: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
      markTag: React.PropTypes.string,
      caseSensitive: React.PropTypes.bool,
      tooltip: React.PropTypes.string,
      notHighlight: React.PropTypes.bool
    },

    /**
     * initial properties
     * @returns {Object}
     */
    getDefaultProps: function getDefaultProps() {
      return {
        highlight: null,
        text: null,
        markTag: 'mark',
        caseSensitive: false,
        className: '',
        tooltip: ''
      };
    },

    /**
     * generate inner html
     */
    createMarkup: function createMarkup() {
      return this.props.notHighlight ? {
        __html: escape(this.props.text)
      } : {
        __html: this.mark(this.props.highlight, this.props.text, this.props.markTag, this.props.caseSensitive)
      };
    },

    /**
     * Mark search text
     */
    mark: function mark(val, str, markTag, caseSensitive) {
      val = val || '';

      str = escape(str);

      var escapeReg = escapeRegExp(escape(val));
      var tagStr = '<{tag}>$&</{tag}>'.replace(/{tag}/gi, markTag);

      markTag = markTag || 'mark';

      if (val.length === 0) {
        return str;
      }

      var regex = RegExp(escapeReg, caseSensitive ? 'g' : 'gi');

      return str.replace(regex, tagStr);
    },

    /**
     * render component
     * @returns {Object}
     */
    render: function render() {
      return React.createElement('span', {
        className: this.props.className,
        onClick: this.props.onClick,
        dangerouslySetInnerHTML: this.createMarkup(),
        title: this.props.tooltip
      });
    }
  });

  module.exports = TextHighLight;
}();

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  SORT_ORDERS: {
    ASC: {
      value: 'ASC',
      icon: 'icon-sort-name-up',
      headerIcon: 'icon-down-open'
    },
    DESC: {
      value: 'DESC',
      icon: 'icon-sort-name-down',
      headerIcon: 'icon-up-open'
    },
    Unsorted: {
      value: 'Unsorted',
      icon: 'icon-unsort'
    }
  },
  // report-part > field properties > function
  FIELD_FUNCTION_MODE: {
    FieldProperty: 0,
    SubTotal: 1,
    GrandTotal: 2
  },

  DEFAULT_FORMAT_BY_DATA_TYPE: {
    Time: 'HH:mm:ss'
  },

  DEFAULT_FORMAT_BY_FUNCTION_DATA_TYPE: {
    Datetime: {
      Group: 'Year'
    }
  },

  FUNCTION: {
    GROUP: {
      NAME: 'Group'
    },
    SUM: {
      NAME: 'Sum'
    },
    GROUP_DAYS_OLD: {
      NAME: 'Group Days Old'
    },
    COUNT: {
      NAME: 'Count'
    },
    NONE: {
      NAME: ''
    },
    DAYS_OLD: {
      NAME: 'Days Old'
    },
    MAXIMUM: {
      NAME: 'Maximum'
    },
    MINIMUM: {
      NAME: 'Minimum'
    }
  },

  EMPTY_FUNCTION: {
    id: null,
    name: ''
  },

  FORMAT_KEY: {
    MONTH: {
      NAME: 'Month'
    },
    YEAR: {
      NAME: 'Year'
    },
    NONE: '',
    DEFAULT_TIME: {
      NAME: 'HH:mm:ss'
    }
  },

  MESSAGES: {
    get M08() {
      return _Izenda2.default.getText('COMMON_MESSAGES_MUST_BE_FUNCTION');
    },
    get M10() {
      return _Izenda2.default.getText('REPORT_PART_FIELD_CONSTANTS_MESSAGES_NOT_ACCEPT_EMPTY_FUNCTION');
    }
  },

  ERROR_TYPE: {
    ERROR_MESSAGE: 'error',
    NOTIFY: 'notify'
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(214);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _bluebird = __webpack_require__(18);

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Izenda = __webpack_require__(204);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(175);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(181);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(305);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A function that invokes an array of functions with the same params and return the merged result
 * @param {Array<Function>} funcs Array of functions that should be executed
 */
var mergeResults = function mergeResults() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, parms = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      parms[_key2] = arguments[_key2];
    }

    return funcs.map(function (fn) {
      return fn.apply(undefined, parms);
    }).reduce(function (props, otherProps) {
      return (0, _fp.merge)(otherProps, props);
    }, {});
  };
};

/**
 * A function that invokes an array of functions with the same params and return the combined array
 * @param {Array<Function>} funcs Array of functions that should be executed
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartStyleConfigurationFactories.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var combineResults = function combineResults() {
  for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    funcs[_key3] = arguments[_key3];
  }

  return function () {
    for (var _len4 = arguments.length, parms = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      parms[_key4] = arguments[_key4];
    }

    return funcs.map(function (fn) {
      return fn.apply(undefined, parms);
    }).reduce(function (props, otherProps) {
      return otherProps ? [].concat((0, _toConsumableArray3.default)(props), (0, _toConsumableArray3.default)((0, _fp.isArray)(otherProps) ? otherProps : [otherProps])) : props;
    }, []);
  };
};

/**
 * A function that invokes an array of functions with the same params and return a Promise that merges the results
 * @param {Array<Function>} funcs Array of functions that should be executed
 */
var mergePromiseResult = function mergePromiseResult() {
  for (var _len5 = arguments.length, funcs = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    funcs[_key5] = arguments[_key5];
  }

  return function () {
    for (var _len6 = arguments.length, parms = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      parms[_key6] = arguments[_key6];
    }

    return function () {
      for (var _len7 = arguments.length, otherParams = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        otherParams[_key7] = arguments[_key7];
      }

      return (0, _bluebird.reduce)(funcs.map(function (fn) {
        return fn.apply(undefined, parms);
      }), function (props, fn) {
        return fn.apply(undefined, otherParams).then(function (otherProps) {
          return (0, _fp.merge)(otherProps, props);
        });
      }, {});
    };
  };
};

/**
 * A function that invokes an array of functions with the same params and return a Promise that merges the results
 * @param {Array<Function>} funcs Array of functions that should be executed
 */
var composePropertiesValueChanged = function composePropertiesValueChanged(onPropertiesValueChanged, onPropertiesValueChangedBase, onPropertiesValueChangedDefault) {
  return function () {
    var onValueChanged = onPropertiesValueChanged.apply(undefined, arguments);
    var onValueChangedBase = onPropertiesValueChangedBase && onPropertiesValueChangedBase.apply(undefined, arguments);
    var onValueChangedDefault = onPropertiesValueChangedDefault.apply(undefined, arguments);
    var composeChanged = function composeChanged(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, derivedChange) {
      return function (chartProperties) {
        onValueChanged(chartProperties, schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo);
        derivedChange && derivedChange(chartProperties);
      };
    };

    return function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, derivedChange) {
      return onValueChangedBase ? onValueChangedBase(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, composeChanged(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, derivedChange)) : onValueChangedDefault(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, composeChanged(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, derivedChange));
    };
  };
};

/**
 * Convert schema object to defined schema using in Properties Editor
 * @param {Object} obj The schema object
 * @param {Function} defaultFactory Default factory function
 */
var convertSchemaObject = function convertSchemaObject(obj, defaultFactory) {
  return (0, _keys2.default)(obj).reduce(function (items, key) {
    var _obj$key = obj[key],
        fields = _obj$key.fields,
        _obj$key$factory = _obj$key.factory,
        factory = _obj$key$factory === undefined ? defaultFactory : _obj$key$factory,
        itemProps = (0, _objectWithoutProperties3.default)(_obj$key, ['fields', 'factory']);

    var item = factory(itemProps);

    fields && (item['fields'] = convertSchemaObject(fields, null));

    return (0, _assign2.default)(items, (0, _defineProperty3.default)({}, key, item));
  }, {});
};

/**
 * Create defined schema using in Properties Editor
 * @param {Object} schema Schema
 */
var createDefinedSchema = function createDefinedSchema(schema) {
  return {
    schemaKey: schema.schemaKey,
    fields: convertSchemaObject(schema.groups, _Izenda7.createPanelGroupSchema)
  };
};

/**
 * Get a plain object with the properties that have key
 * @param {Object} mapping Object
 */
var getPropMappingObject = function getPropMappingObject(mappings) {
  return (0, _fp.mapValues)(function (mapping) {
    return (0, _keys2.default)(mapping).filter(function (key) {
      return (0, _fp.has)('propKey', mapping[key]);
    }).reduce(function (propsMapping, key) {
      return (0, _assign2.default)(propsMapping, (0, _defineProperty3.default)({}, key, mapping[key] ? { key: mapping[key].propKey, source: mapping[key].propSource } : null));
    }, {});
  }, mappings);
};

/**
 * Get a default value object from the mapping.
 * @param {Object} mapping Object
 */
var getPropDefaultObject = function getPropDefaultObject(mappings) {
  return (0, _fp.mapValues)(function (mapping) {
    return (0, _keys2.default)(mapping).filter(function (key) {
      return (0, _fp.has)('defaultValue', mapping[key]);
    }).reduce(function (obj, key) {
      return (0, _fp.merge)((0, _defineProperty3.default)({}, key, mapping[key].defaultValue), obj);
    }, {});
  }, mappings);
};

/**
 * Get the value of property of object until the value exists
 * @param {string} propName Property name to get value from
 * @param {Array<Object>} objs An array of object
 */
var getOrDefault = function getOrDefault(propName, objs) {
  return (0, _fp.compose)((0, _fp.find)((0, _fp.negate)(_fp.isNil)), (0, _fp.map)((0, _fp.get)(propName)))(objs);
};

/**
 * Generates key of report part type and style
 * @param {string} reportPartType Report part type
 * @param {string} reportPartStyle Report part style
 */
var composeKey = function composeKey(reportPartType, reportPartStyle) {
  return reportPartStyle + '-' + reportPartType;
};

var confFactories = new _Izenda2.default('Report Part Style Configuration', true);

exports.default = {
  /**
   * Extends a report part style configuration
   * @param {string} reportPartType The report part type
   * @param {string} reportPartStyle The new report part style
   * @param {string} baseStyle A chart type that new chart derives on
   * @param {Object} cfg New chart type configuration
   */
  extendConfiguration: function extendConfiguration(reportPartType, reportPartStyle, baseStyle, cfg) {
    ensure(reportPartStyle, 'New report part style must have a value');
    ensure(!baseStyle || confFactories.containKey(composeKey(reportPartType, baseStyle)), baseStyle + ' doesn\'t exist. It needs to be register before extending');
    ensure(cfg, 'New report part style configuration must have a value');

    var _cfg$fieldContainerSc = cfg.fieldContainerSchema,
        fieldContainerSchema = _cfg$fieldContainerSc === undefined ? [] : _cfg$fieldContainerSc,
        _cfg$propertyWidgets = cfg.propertyWidgets,
        propertyWidgets = _cfg$propertyWidgets === undefined ? {} : _cfg$propertyWidgets,
        _cfg$propertySchema = cfg.propertySchema,
        propertySchema = _cfg$propertySchema === undefined ? {} : _cfg$propertySchema,
        _cfg$propertyMappingP = cfg.propertyMappingProps,
        propertyMappingProps = _cfg$propertyMappingP === undefined ? (0, _fp.constant)({}) : _cfg$propertyMappingP,
        _cfg$propertyMappingS = cfg.propertyMappingSource,
        propertyMappingSource = _cfg$propertyMappingS === undefined ? (0, _fp.constant)({}) : _cfg$propertyMappingS,
        _cfg$propertyValueCha = cfg.propertyValueChange,
        propertyValueChange = _cfg$propertyValueCha === undefined ? function () {
      return function () {};
    } : _cfg$propertyValueCha,
        _cfg$optionsMapping = cfg.optionsMapping,
        optionsMapping = _cfg$optionsMapping === undefined ? {} : _cfg$optionsMapping;


    ensure(!fieldContainerSchema || (0, _fp.isArray)(fieldContainerSchema), 'fieldContainerSchema property of configuration must be an array');
    ensure(!propertyWidgets || (0, _fp.isPlainObject)(propertyWidgets), 'propertyWidgets property of configuration must be a plain object');
    ensure(!propertySchema || (0, _fp.isPlainObject)(propertySchema), 'propertySchema property of configuration must be a plain object');

    ensure(!propertyMappingProps || (0, _fp.isFunction)(propertyMappingProps), 'propertyMappingProps property of configuration must be a function');

    ensure(!propertyMappingSource || (0, _fp.isFunction)(propertyMappingSource), 'propertyMappingSource property of configuration must be a function');

    ensure(!propertyValueChange || (0, _fp.isFunction)(propertyValueChange), 'propertyValueChange property of configuration must be a function');

    ensure(!optionsMapping || (0, _fp.isPlainObject)(optionsMapping), 'optionsMapping property of configuration must be a plan object');

    // Provide function instead of the immediate object to avoid resolving base style configuration before the current style registration.
    var getBaseStyleCfg = baseStyle ? function () {
      return confFactories.create(composeKey(reportPartType, baseStyle));
    } : function () {
      return {
        propertyWidgets: {},
        propertySchema: {},
        propertyMappingProps: (0, _fp.constant)({}),
        propertyMappingSource: (0, _fp.constant)({}),
        optionsMapping: {}
      };
    };

    var defaultConfig = _Izenda6.default.getConfiguration(reportPartType);

    // Store chart info in external factories in order to
    // easily and quickly enumerate the basic report part style information as well as
    // preventing trigger heavy computation on report part style configuration (ie. schema, mappings...)
    _Izenda4.default.add(reportPartType, reportPartStyle, baseStyle, getOrDefault('visualLabel', [cfg, defaultConfig]), getOrDefault('visualPreviewCSS', [cfg, defaultConfig]));

    // Register chart configurations
    var newCfg = confFactories.register(composeKey(reportPartType, reportPartStyle), function () {
      // Resolve the base style configuration
      var baseStyleCfg = getBaseStyleCfg();
      var configSeq = [cfg, baseStyleCfg, defaultConfig];
      var baseContainerSchema = baseStyleCfg.fieldContainerSchema ? [baseStyleCfg.fieldContainerSchema] : defaultConfig.fieldContainerSchema;

      var optionMappingsConfig = (0, _fp.merge)(defaultConfig.optionsMapping, optionsMapping);

      return {
        visualEngine: getOrDefault('visualEngine', configSeq),
        visualType: getOrDefault('visualType', configSeq),
        optionsBuilder: getOrDefault('optionsBuilder', configSeq),
        model: getOrDefault('model', configSeq) /* Each cfg contains an array of schema factory functions. It composes multiple schema factories into a single factory */
        , fieldContainerSchema: combineResults.apply(undefined, [].concat((0, _toConsumableArray3.default)(baseContainerSchema), (0, _toConsumableArray3.default)(fieldContainerSchema))),
        propertyWidgets: (0, _fp.mergeAll)([baseStyleCfg.propertyWidgets, defaultConfig.propertyWidgets], propertyWidgets),
        propertySchema: createDefinedSchema((0, _fp.mergeAll)([baseStyleCfg.propertySchema, defaultConfig.propertySchema], propertySchema)),
        propertyMappingProps: mergeResults(propertyMappingProps, baseStyleCfg.propertyMappingProps, defaultConfig.propertyMappingProps),
        propertyMappingSource: mergeResults(propertyMappingSource, baseStyleCfg.propertyMappingSource, defaultConfig.propertyMappingSource),
        propertyValueChange: composePropertiesValueChanged(propertyValueChange, baseStyleCfg.propertyValueChange, defaultConfig.propertyValueChange),
        optionsMapping: (0, _fp.merge)(baseStyleCfg.optionsMapping, getPropMappingObject(optionMappingsConfig)),
        optionsDefault: (0, _fp.merge)(baseStyleCfg.optionsDefault, getPropDefaultObject(optionMappingsConfig))
      };
    });
  },


  /**
   * Get the configuration of report part style
   * @param {string} reportPartStyle Report part type
   */
  getConfiguration: function getConfiguration(reportPartType, reportPartStyle) {
    return confFactories.create(composeKey(reportPartType, reportPartStyle));
  },


  /**
   * Reset the factories data
   */
  reset: function reset() {
    _Izenda4.default.reset();
    confFactories.reset();
  }
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.OverflowText.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var OverflowText = function OverflowText(props) {
  var rest = (0, _fp.omit)(['text', 'tooltip', 'title', 'className'], props);
  return _react2.default.createElement(
    'span',
    (0, _extends3.default)({}, rest, { className: (0, _classnames2.default)(['overflow-text', props.className]), title: props.tooltip }),
    props.children || props.text
  );
};

OverflowText.propTypes = {
  text: _propTypes2.default.string,
  tooltip: _propTypes2.default.string
};
exports.default = OverflowText;
module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(34);

var _Izenda2 = __webpack_require__(39);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(80);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(164);

var _Izenda7 = __webpack_require__(41);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(88);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(35);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(220);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _highcharts = __webpack_require__(238);

var _highcharts2 = _interopRequireDefault(_highcharts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STACK_TYPE_CHART_VALUES = _Izenda9.MappingValues.STACK_TYPE_CHART_VALUES;

/**
 * Add point action link
 * @param {boolean} isMainAxis
 * @param {Object} chartOptions
 * @param {Object} configSource
 * @param {string} fieldName
 * @param {Object} fieldConfig
 * @param {Function} fnGetPointName
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.HighchartUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function addPointActionLink(isMainAxis, chartOptions, configSource, fieldName, fieldConfig, fnGetPointName) {
  var isMultiLevel = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var rotation = arguments[7];

  if (!(0, _fp.get)('numberOfPointActions', fieldConfig)) {
    return configSource;
  }

  var oldFormatter = (0, _fp.get)('formatter', configSource);
  var pointAction = (0, _fp.get)('commonActions.pointAction', chartOptions);
  var chartContainer = (0, _fp.get)('commonActions.chartContainer', chartOptions);
  var query = '' + (isMainAxis ? '.is-mainAxis' : '.is-subAxis');
  var classData = {
    name: 'hyperlink-action u_textLink ' + (isMainAxis ? 'is-mainAxis' : 'is-subAxis'),
    query: isMultiLevel ? query + '.' + fieldName : query
  };

  chartContainer && $izenda(chartContainer).off('click', classData.query);
  chartContainer && $izenda(chartContainer).on('click', classData.query, function (e) {
    e.stopPropagation();
    var $link = $izenda(e.currentTarget);
    var linkData = void 0;
    if ($link[0].nodeName.toUpperCase() === 'TSPAN') {
      // when label rotates, the highcharts create tspan instead of label formatter function result
      linkData = $link.parent().data();
    } else {
      linkData = $link.data();
    }
    var filters = JSON.parse(decodeURI(linkData.filters));
    var separator = JSON.parse(decodeURI(linkData.separator));

    pointAction(fieldConfig, [{
      key: filters[0],
      value: filters[1]
    }], separator.separatorColumnName && separator);
  });

  var config = $izenda.extend(configSource, {
    useHTML: true,
    hasPointAction: true,
    className: classData.name,
    getData: getDataByPoint,
    formatter: function formatter() {
      var text = oldFormatter.apply(this, arguments);

      // incase axix type is linear or datetime, only render link for value which have point link to it
      if (!(0, _fp.isNil)(this.axis) && !(0, _fp.size)(this.axis.categories) && !isPointValue(this.axis, this.chart.series, this.value)) {
        return text;
      }

      if (isMultiLevel && fieldName !== (0, _fp.get)('point.labelName', this) && fieldName !== (0, _fp.get)('point.series.userOptions.labelName', this)) {
        return text;
      }

      var data = getDataByPoint.call(this, text);
      var classname = isMultiLevel ? classData.name + ' ' + data.labelName : classData.name;
      var dataFilters = data['data-filters'];
      var dataSeparator = data['data-separator'];

      if (!(0, _fp.isNil)(rotation)) {
        // rotate data labels manually, because default highcharts rotation cancels
        // the "formatter: () => {...}" result and adds 2 <tspan> tags instead of it.
        // the second hidden span is needed for correct positioning.
        var rotationStyle = 'position: absolute; transform: rotate(' + (rotation || 0) + 'deg)';
        var result1 = '<a class="' + classname + '" style="' + rotationStyle + '" data-filters="' + dataFilters + '" data-separator="' + dataSeparator + '">' + text + '</a>';
        var result2 = '<span class="' + classname + '" style="visibility: hidden;">' + text + '</span>';
        return result1 + result2;
      } else {
        // the default link (rotation applied in highcharts configuration)
        return '<a class="' + classname + '" data-filters="' + dataFilters + '" data-separator="' + dataSeparator + '">' + text + '</a>';
      }

      function isPointValue(axis, series, value) {
        var result = false;
        if ((0, _fp.isNil)(series) || (0, _fp.isEmpty)(series)) {
          return result;
        }

        var xSerieData = (0, _fp.get)('processedXData', (0, _fp.head)(series));
        if ((0, _fp.isNil)(xSerieData)) {
          return result;
        }

        if (axis.isDatetimeAxis) {
          var valueInDate = axis.isDatetimeAxis ? new Date(value).getTime() : null;
          result = !!(0, _fp.find)(function (item) {
            return valueInDate === new Date(item).getTime();
          }, xSerieData);
        } else {
          result = (0, _fp.includes)(value, xSerieData);
        }

        return result || isPointValue(axis, (0, _fp.tail)(series), value);
      }
    }
  });
  isMultiLevel && delete config.className;
  return config;

  function getDataByPoint(displayText) {
    var userOption = (0, _fp.get)('series.userOptions', this);
    var separatorColumnName = (0, _fp.get)('separatorField.columnName', userOption);
    var separatorValue = (0, _fp.get)('separatorValue', userOption);
    var pointName = (0, _fp.isFunction)(fnGetPointName) ? fnGetPointName.call(this) : this.value || this.key || this.x;
    var isDateTypeType = (0, _fp.get)('nameField.reportPartElm.isDateTimeType', userOption);
    var fieldFormatData = (0, _fp.get)('nameField.reportPartElm.fieldFormatData', userOption);

    pointName = this.dateTimeLabelFormat ? displayText : isDateTypeType ? (0, _Izenda11.default)(fieldFormatData, pointName) : pointName;

    var config = (0, _fp.find)(function (i) {
      return i.name === pointName;
    }, (0, _fp.get)('data', userOption));
    var fieldNameValue = isMultiLevel ? config.labelName : fieldName;
    var data = {
      'data-filters': encodeURI((0, _stringify2.default)([fieldNameValue, pointName])),
      'data-separator': encodeURI((0, _stringify2.default)({
        separatorColumnName: separatorColumnName,
        separatorValue: separatorValue
      }))
    };

    if (isMultiLevel) {
      if ((0, _fp.get)('nameField.fieldNameAlias', config) !== fieldName) {
        $izenda.extend(data, {
          class: '' + config.labelName,
          labelName: config.labelName,
          isKeepDataInMultiLevel: true
        });
      } else {
        $izenda.extend(data, {
          class: classData.name + ' ' + config.labelName,
          labelName: config.labelName
        });
      }
    }

    return data;
  }
}

/**
 * set default axis name
 * @param {Object} chartOptions
 * @param {Object} chartData
 */
function setDefaultAxisName(chartOptions, chartData) {
  try {
    var containers = chartData.containers;
    var expandedLevel = chartData.expandedLevel;
    var labelsElements = containers.labels;
    var xAxis = (0, _fp.isArray)(chartOptions.xAxis) ? chartOptions.xAxis[expandedLevel] : chartOptions.xAxis;
    var labelsFieldName = labelsElements[expandedLevel] && labelsElements[expandedLevel].fieldName;
    var xTitle = {
      text: labelsFieldName
    };
    !xAxis.title && (xAxis.title = xTitle);

    var valuesElements = containers.values;
    var yAxis = chartOptions.yAxis;
    var valuesEleLength = valuesElements && valuesElements.length;
    var numberOne = 1;

    var yTitle = void 0;
    if (valuesEleLength > numberOne) {
      yTitle = {
        text: _Izenda9.DefaultConfig.METRIC_ALL
      };
      !yAxis.title && (yAxis.title = yTitle);
    } else if (valuesEleLength === numberOne) {
      yTitle = {
        text: removeMinMaxAlias(valuesElements[0].fieldName)
      };
      !yAxis.title && (yAxis.title = yTitle);
    }
  } catch (e) {}
  // do nothing


  // Remove Min/Max alias if it exits in field name alias
  function removeMinMaxAlias(name) {
    if (chartOptions.izendaOptions && !(0, _fp.isNil)(chartOptions.izendaOptions.range)) {
      return (0, _fp.flow)((0, _fp.trimCharsStart)(_Izenda2.RANGE_ALIAS.MIN_ALIAS), (0, _fp.trimCharsStart)(_Izenda2.RANGE_ALIAS.MAX_ALIAS), (0, _fp.trimCharsStart)(_Izenda2.RANGE_ALIAS.AVG_ALIAS))(name);
    }
    return name;
  }
}

/**
 * get point name
 * @param {Object} point
 */
function getPointName(point) {
  var name = getPointData('name', point);

  if (!(0, _fp.isNil)(name)) {
    return name;
  }

  if ((0, _fp.has)('category', point) && !(0, _fp.isDate)(point.category)) {
    return getPointData('x', point) || getPointData('category', point);
  }

  var key = getPointData('key', point);
  var x = getPointData('x', point);

  if (!(0, _fp.isNil)(key)) {
    return key;
  } else {
    return x;
  }
}

/**
 * Get point data
 * @param {string} key
 * @param {Object} point
 */
function getPointData(key, point) {
  var rawKey = key + 'RawData';

  if ((0, _fp.has)(rawKey, point)) {
    return (0, _fp.get)(rawKey, point);
  }

  if ((0, _fp.has)(key, point)) {
    return (0, _fp.get)(key, point);
  }

  return;
}

/**
 * get point value
 * @param {Object} point
 */
function getPointValue(point) {
  var val = getPointData('y', point);

  if (!(0, _fp.isNil)(val)) {
    return val;
  }

  return getPointData('value', point);
}

/**
 * get point options
 * @param {Object} point
 */
function getPointOptions(point) {
  var highchartPoint = (0, _fp.get)('point', point) || point;
  return highchartPoint && highchartPoint.options;
}

/**
 * get axis type
 * @param {Object}  field
 * @param {Array<any>} axisData
 * @param {Object} axisOption
 */
function getAxisType(field, axisData, axisOption) {
  var dataType = (0, _fp.get)('reportPartElm.previewDataType', field);
  var izCategory = axisOption ? !!axisOption.izCategory : false;

  var type = void 0,
      isCategory = void 0;
  switch (dataType) {
    case 'Money':
    case 'Numeric':
      type = 'linear';
      isCategory = izCategory;
      break;
    case 'Datetime':
    case 'Time':
      type = 'datetime';
      isCategory = izCategory;
      break;
    default:
      isCategory = true;
      type = 'category';
  }

  return {
    type: type,
    categories: isCategory ? (0, _fp.uniq)(axisData) : undefined
  };
}

/**
 * get color for a serie
 * @param {Object} chartOptions
 * @param {Object} serieConfig
 * @param {Object} serie
 * @return {Object}
 */
function getColorForSiries(chartOptions, serieConfig, serie) {
  var serieData = (0, _fp.get)('data', serie);
  if ((0, _fp.isNil)(serie) || (0, _fp.isNil)(serieData) || (0, _fp.isNil)(serieConfig)) {
    return;
  }

  var sameRange = true;
  var color = void 0;
  var firstGetColor = true;
  var yConfig = getSerieConfig(serie.yAxisField, serieConfig);

  for (var i = 0; i < serieData.length; ++i) {
    var value = getY(chartOptions, serieData[i], i);
    var cellColor = (0, _fp.get)('cellColor', yConfig);
    var record = serieData[i].record;
    if (!(0, _fp.isNil)(value)) {
      var colorInRange = _Izenda13.default.getConfigDataByRange(value, cellColor, {
        element: serie.yAxisField,
        record: record
      });

      if (firstGetColor) {
        firstGetColor = false;
        color = colorInRange;
      } else if (color != colorInRange) {
        sameRange = false;
        break;
      }
    }
  }
  return sameRange ? color : null;
}

/**
 * set color for series
 * @param {Object} userOptions: options and values
 * @param {Object} series: series data for chart
 * @param {Object} colors: array of color
 * @return {Object}
 */
function setColorPointForAreaLine(userOptions, series, colors) {
  if (userOptions.izMultiColor && !userOptions.izDisableMultiColor) {
    (0, _fp.forEach)(function (serie) {
      var colorIndex = 0;
      (0, _fp.forEach)(function (point) {
        var pointColor = !(0, _fp.isEmpty)(colors) ? colors[colorIndex] : null;
        if (!(0, _fp.isEmpty)(pointColor) && (0, _fp.isEmpty)(point.color)) {
          point.color = pointColor;
        }
        colorIndex++;
        if (colorIndex > colors.length - 1) {
          colorIndex = 0;
        }
      })(serie.data);
    })(series);
  }
}

/**
 * get color of point for serie
 * @param {Object} chartOptions
 * @param {Object} serieConfig
 * @param {Object} serie
 */
function getColorPointBySerie(chartOptions, serieConfig, serie) {
  var serieData = (0, _fp.get)('data', serie);
  if ((0, _fp.isNil)(serie) || (0, _fp.isNil)(serieData) || (0, _fp.isNil)(serieConfig)) {
    return;
  }

  var separatorColumnName = (0, _fp.get)('separatorField.columnName', serie);
  var separatorRecord = !(0, _fp.isNil)(serie.separatorField) ? (0, _fp.flow)((0, _fp.find)(function (item) {
    return !(0, _fp.isNil)(item.record) && (0, _fp.has)(separatorColumnName, item.record);
  }), (0, _fp.get)('record'))(serieData) : null;

  // color by serie
  var separatorOriginalValue = !(0, _fp.isNil)(serie.separatorField) ? _Izenda13.default.getOriginalValue(serie.separatorField, separatorRecord) : null;

  var separatorConfig = getSerieConfig(serie.separatorField, serieConfig);
  var serieColor = !(0, _fp.isNil)(separatorOriginalValue) && !(0, _fp.isNil)(separatorConfig) && (0, _Izenda4.getCellColor)(separatorOriginalValue, separatorConfig, {
    element: serie.separatorField,
    record: separatorRecord
  });
  serieColor && (serie.color = serieColor);
  // color by point
  var xConfigMaster = getSerieConfig(serie.xAxisField, serieConfig);
  var yConfigMaster = getSerieConfig(serie.yAxisField, serieConfig);
  var zConfigMaster = getSerieConfig(serie.zAxisField, serieConfig);
  var nameConfigMaster = getSerieConfig(serie.nameField, serieConfig);
  var valueConfigMaster = getSerieConfig(serie.valueField, serieConfig);
  var sizeOfData = (0, _fp.size)(serieData);

  if (hasFamilyRelationship(serieData)) {
    var populateColor = function populateColor(index, color) {
      color = color || getColor(serieData[index], index);
      if (color) {
        serieData[index].color = color;
        for (var i = 0; i < sizeOfData; i++) {
          if (serieData[i].parent && serieData[i].parent === serieData[index].id && (0, _fp.isUndefined)(getColor(serieData[i], i))) {
            populateColor(i, color);
          }
        }
      }
    };

    for (var i = 0; i < sizeOfData; i++) {
      populateColor(i);
    }
  } else {
    // color for separator siries
    var index = sizeOfData;
    while (index--) {
      var _color = getColor(serieData[index], index);
      _color && (serieData[index].color = _color);
    }
  }

  // color for legend
  var color = getColorForSiries(chartOptions, serieConfig, serie);
  color && (serie.color = color);

  function getColor(point, pointIndex) {
    var record = point.record;
    var value = !(0, _fp.isNil)(serie.valueField) ? _Izenda13.default.getOriginalValue(serie.valueField, record) : getPointData('value', point);
    var xConfig = xConfigMaster;
    var yConfig = yConfigMaster;
    var zConfig = zConfigMaster;
    var nameConfig = nameConfigMaster;
    var valueConfig = valueConfigMaster;

    !xConfig && (xConfig = getSerieConfig(point.xAxisField, serieConfig));
    !yConfigMaster && (yConfig = getSerieConfig(point.yAxisField, serieConfig));
    !zConfigMaster && (zConfig = getSerieConfig(point.zAxisField, serieConfig));
    !nameConfigMaster && (nameConfig = getSerieConfig(point.nameField, serieConfig));
    !valueConfigMaster && (valueConfig = getSerieConfig(point.valueField, serieConfig));

    return (0, _Izenda4.getCellColor)(value, valueConfig, {
      element: serie.valueField,
      record: record
    }) || (0, _Izenda4.getCellColor)(getPointData('z', point), zConfig, {
      element: serie.zAxisField,
      record: record
    }) || (0, _Izenda4.getCellColor)(getY(chartOptions, point, pointIndex), yConfig, {
      element: serie.yAxisField,
      record: record
    }) || (0, _Izenda4.getCellColor)(getPointData('originalNameValue', point) || getPointData('name', point), nameConfig, {
      element: serie.nameField,
      record: record
    }) || (0, _Izenda4.getCellColor)(getX(chartOptions, point, pointIndex), xConfig, {
      element: serie.xAxisField,
      record: record
    });
  }
}

/**
 * get color of point for serie
 * @param {Object} series
 * @param {Object} chartOptions
 * @param {Object} serieConfig
 */
function getColorPointBySeries(series, chartOptions, serieConfig) {
  (0, _fp.each)((0, _fp.curry)(getColorPointBySerie)(chartOptions, serieConfig), series);
}

/**
 * get serie config
 * @param  {Object} field
 * @param  {Object} seriesConfig
 * @return {Object}
 */
function getSerieConfig(field, seriesConfig) {
  return seriesConfig[(0, _Izenda6.getFieldName)(field)];
}

/**
 * Get value of X
 * @param  {Object} chartOptions
 * @param  {Object} point
 * @param  {number} pointIndex
 * @return {Object}
 */
function getX(chartOptions, point, pointIndex) {
  var xCategories = (0, _fp.get)('xAxis.categories', chartOptions);
  var xValue = point.xRawData;

  if (!(0, _fp.isNil)(xValue)) {
    return xValue;
  }

  if ((0, _fp.isArray)(xCategories)) {
    xValue = getPointData('key', point);
    if (!(0, _fp.isNil)(xValue)) {
      return xValue;
    }
    xValue = getPointData('x', point);
    return (0, _fp.isNil)(pointIndex) ? xCategories[xValue] : xCategories[xValue] || xCategories[pointIndex];
  }

  return getPointData('x', point) || getPointData('key', point) || getPointData('name', point);
}

/**
 * Get value of Y
 * @param  {Object} chartOptions
 * @param  {Object} point
 * @param  {number} pointIndex
 * @return {Object}
 */
function getY(chartOptions, point, pointIndex) {
  var yCategories = (0, _fp.get)('yAxis.categories', chartOptions);
  var yValue = point.yRawData;

  if (!(0, _fp.isNil)(yValue)) {
    return yValue;
  }

  yValue = getPointData('y', point);

  if ((0, _fp.isArray)(yCategories)) {
    return (0, _fp.isNil)(pointIndex) ? yCategories[yValue] : yCategories[yValue] || yCategories[pointIndex];
  }

  var chartPoint = (0, _fp.has)('point', point) ? point.point : point;

  // Get percentage value instead raw value
  var isStackedPercentage = (0, _fp.get)('plotOptions.series.stacking', chartOptions) === STACK_TYPE_CHART_VALUES.izPercent;

  if (isStackedPercentage && (0, _fp.has)('percentage', chartPoint)) {
    yValue = (0, _fp.get)('percentage', chartPoint);
  }

  return yValue;
}

/**
 * Get formatted value of axis
 * @param  {Object} axis
 * @param  {Object} chartOptions
 * @return {string}
 */
function getFormattedLabelAxis(axis, chartOptions) {
  axis = axis || this.axis || {};
  chartOptions = chartOptions || (0, _fp.getOr)({}, 'chart.userOptions', this);

  var axisFieldName = (axis.coll || 'xAxis') + 'Field';
  var axisField = (0, _fp.flow)(_fp.head, (0, _fp.get)(axisFieldName))(chartOptions.series);
  var axisCategories = axis.categories;
  var value = this.value;
  var formattedValue = void 0;

  if ((0, _fp.size)(axisCategories)) {
    value = (0, _fp.includes)(value, axisCategories) ? value : null;
  } else if (axis.isDatetimeAxis) {
    value = new Date(value);
  }

  formattedValue = formatterData(value, axisField, getSerieConfig(axisField, chartOptions.izendaSeriesConfig));
  return showText(formattedValue && formattedValue.data);
}

/**
 * Read data of point
 * @param  {string}  key
 * @param  {Object}  point
 * @param  {boolean} isFormatted TRUE: default
 * @return {Object}
 */
function getFormattedDataByPoint(key, point, isFormatted) {
  var series = (0, _fp.getOr)({}, 'series', point);
  var serieOpt = (0, _fp.get)('userOptions', series);
  var chartOptions = (0, _fp.getOr)({}, 'chart.userOptions', series);
  var serieConfig = chartOptions.izendaSeriesConfig;
  var result = void 0,
      fieldConfig = void 0;

  switch (key) {
    case 'x':
      result = getX(chartOptions, point);
      fieldConfig = serieOpt.xAxisField || point.xAxisField;
      break;
    case 'y':
      result = getY(chartOptions, point);
      fieldConfig = serieOpt.yAxisField || point.yAxisField;
      break;
    case 'z':
      result = getPointData('z', point);
      fieldConfig = serieOpt.zAxisField || point.zAxisField;
      break;
    case 'name':
      result = getPointData('name', point);
      fieldConfig = serieOpt.nameField || point.nameField;
      break;
    case 'value':
      result = getPointData('value', point);
      fieldConfig = serieOpt.valueField || point.valueField;
      break;
    default:
      result = point[key];
      fieldConfig = serieOpt[key + 'Field'];
  }

  return formatterData(result, fieldConfig, getSerieConfig(fieldConfig, serieConfig), {
    element: fieldConfig,
    record: (0, _fp.get)('options.record', (0, _fp.has)('point', point) ? point.point : point),
    nameFieldValue: {
      value: point.name,
      originalValue: point.originalNameValue
    }
  }, isFormatted, (0, _fp.getOr)(false, 'below', point));
}

/**
 * Format data
 * @param {Object} value
 * @param {Object} valueField
 * @param {Object} serieConfig
 * @param {Object} fieldSource
 * @param {boolean} isFormatted
 */
function formatterData(value, valueField, serieConfig, fieldSource, isFormatted) {
  var isBelow = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  isFormatted = (0, _fp.isNil)(isFormatted) ? true : isFormatted;
  var result = {
    fieldName: (0, _Izenda6.getFieldName)(valueField)
  };
  var record = (0, _fp.get)('record', fieldSource);

  var columnName = (0, _fp.get)('columnName', valueField);
  var jsFormatString = (0, _fp.get)('reportPartElm.properties.dataFormattings.format.jsFormatString', valueField);

  var formattedValue = void 0;
  if (jsFormatString) {
    var dataType = (0, _fp.get)('reportPartElm.properties.dataFormattings.functionInfo.formatDataType', valueField);
    var jsFormatId = (0, _fp.get)('reportPartElm.properties.dataFormattings.format.formatId', valueField);
    formattedValue = formatDataByStringFormat(jsFormatId, value, dataType);
  }

  var valueStyle = void 0;
  if (!(0, _fp.isEmpty)(record) && columnName) {
    var fieldValues = void 0;
    if ((0, _fp.has)(columnName, record)) {
      if (isBelow && (0, _fp.startsWith)(_Izenda2.RANGE_ALIAS.MAX_ALIAS, columnName)) {
        columnName = columnName.replace(_Izenda2.RANGE_ALIAS.MAX_ALIAS, _Izenda2.RANGE_ALIAS.MIN_ALIAS);
      }
      fieldValues = _Izenda13.default.getFieldValue(columnName, record);
    } else {
      var originalValue = (0, _fp.getOr)(value, 'nameFieldValue.originalValue', fieldSource);
      fieldValues = {
        value: value,
        originalValue: originalValue
      };
    }

    if (jsFormatString) {
      fieldValues.value = formattedValue;
    }

    valueStyle = isFormatted && _Izenda5.default.getValueStyle(fieldValues, serieConfig, fieldSource);
    result.data = (0, _fp.getOr)(value, 'fomattedValue', valueStyle);
  } else {
    valueStyle = isFormatted && _Izenda5.default.getValueStyle({
      value: value
    }, serieConfig, fieldSource);

    result.data = jsFormatString ? formattedValue : (0, _fp.getOr)(value, 'valueWithoutAltText', valueStyle);
  }

  return result;
}

/**
 * Show text
 * @param {Object} value
 */
function showText(value) {
  var stringValue = String.commonStringValue(value, _Izenda8.default.advancedSettings.other.convertNullToEmptyStringValue);
  return (0, _fp.escape)(stringValue);
}

/**
 * Check if point is in a regression series
 * @param {Point} point
 */
function isRegressionLineSerie(point) {
  return (0, _fp.get)('series.userOptions.isRegressionLine', point);
}

/**
 * Return tooltip for each series
 * This function is used for all chart-type
 * @param {boolean} needReverse
 * @return {string}
 */
function getTooltipFormatter(needReverse) {
  var tooltip = [];
  var points = this.points || [this.point];
  needReverse && (points = (0, _fp.reverse)(points));

  if (points.length === 1 && !isRegressionLineSerie((0, _fp.head)(points))) {
    showAllInfo((0, _fp.head)(points));
  } else {
    // all info should have the same name (x-axis value)
    var firstPoint = points[0] || {};
    var x = getFormattedDataByPoint('x', firstPoint);

    tooltip.push('<b>' + showText(x.data) + '</b>');
    points.forEach(showMainInfo);
  }

  return tooltip.join('<br>');

  function pointColorStyle(point) {
    return '<span style="color:' + (point.color || point.series.color) + '">\u25CF</span>';
  }

  function pointResultYValue(point) {
    var y = getFormattedDataByPoint('y', point);
    var yRawData = getRawYData(point);
    var userOptions = (0, _fp.get)('series.userOptions', point);
    var isSeparatorUsed = userOptions && userOptions.separatorField;
    var seriesName = isSeparatorUsed ? (0, _fp.get)('series.userOptions.name', point) : null;

    var result = '<span>' + showText(!(0, _fp.isNil)(seriesName) ? seriesName : y.fieldName) + ':       ' + showText(yRawData.useYRawData ? yRawData.yRawData : y.data);

    var series = (0, _fp.getOr)({}, 'series', point);
    var chartOptions = (0, _fp.getOr)({}, 'chart.userOptions', series);
    var isStackedPercentage = (0, _fp.get)('plotOptions.series.stacking', chartOptions) === STACK_TYPE_CHART_VALUES.izPercent;

    if (isStackedPercentage && (0, _fp.has)('percentage', point)) {
      var percentage = (0, _fp.get)('percentage', point);
      result += _highcharts2.default.format(' ({percentage:.2f}%)', { percentage: percentage });
    }

    result += '</span>';
    return result;
  }

  function showMainInfo(point) {
    var isDefaultValue = (0, _fp.get)('point.options.isDefaultValue', point);

    !isDefaultValue && tooltip.push(pointColorStyle(point) + ' ' + pointResultYValue(point));
  }

  function getRawYData(point) {
    var yRawData = (0, _fp.get)('point.options.yRawData', point);
    var useYRawData = !(0, _fp.isUndefined)(yRawData);
    yRawData = String.commonStringValue(yRawData, _Izenda8.default.advancedSettings.other.convertNullToEmptyStringValue);
    return {
      useYRawData: useYRawData,
      yRawData: yRawData
    };
  }

  function showAllInfo(point) {
    var name = getFormattedDataByPoint('name', point);
    var value = getFormattedDataByPoint('value', point);
    var x = getFormattedDataByPoint('x', point);
    var y = getFormattedDataByPoint('y', point);
    var z = getFormattedDataByPoint('z', point);
    var pointOptions = getPointOptions(point);

    if (pointOptions.isSum) {
      y.fieldName && tooltip.push('<span>' + showText(pointOptions.sumTitle) + ' <b>' + showText(y.data) + '</b></span>');
      return;
    }

    name.fieldName && tooltip.push(pointColorStyle(point) + ' <b>' + showText(name.fieldName) + ': ' + showText(name.data) + '</b>');
    value.fieldName && tooltip.push(pointColorStyle(point) + ' <b>' + showText(value.fieldName) + ': ' + showText(value.data) + '</b>');

    if (!name.fieldName && !value.fieldName) {
      x.fieldName && tooltip.push(pointColorStyle(point) + ' <b>' + showText(x.data) + '</b>');
    } else {
      x.fieldName && tooltip.push('<span>' + showText(x.fieldName) + ': ' + showText(x.data) + '</span>');
    }

    y.fieldName && tooltip.push('' + pointResultYValue(point));
    z.fieldName && tooltip.push('<span>' + showText(z.fieldName) + ': ' + showText(z.data) + '</span>');
  }
}

/**
 * Action drill down on gauge
 * @param {Object} userOptions
 * @param {Array} serie
 */
function onDrilldownGauge(userOptions, serie) {
  return function () {
    var drilldownAction = (0, _fp.get)('commonActions.onDrilldown', userOptions);
    var pointName = (0, _fp.get)('data[0].name', serie);

    if (!(0, _fp.isFunction)(drilldownAction)) {
      return;
    }

    drilldownAction({
      field: serie.xAxisField,
      value: getVal(pointName),
      record: (0, _fp.get)('data[0].record', serie)
    }, {
      field: serie.separatorField,
      value: getVal(serie.separatorValue)
    });
  };

  function getVal(val) {
    return val === _Izenda.UNDEFINED_VALUE ? '' : val;
  }
}

/**
 * Get custom format
 * @param {Object} userOptions
 * @returns {string}
 */
function getCustomFormat(userOptions) {
  var record = (0, _fp.get)('series[0].data[0].record', userOptions);
  var yAxisField = (0, _fp.flow)((0, _fp.get)('series'), _fp.head, (0, _fp.get)('yAxisField'))(userOptions);

  var yAxisColumnName = (0, _fp.flow)((0, _fp.get)('series'), _fp.head, (0, _fp.get)('yAxisField.columnName'))(userOptions);
  var jsFormatString = (0, _fp.get)('reportPartElm.properties.dataFormattings.format.jsFormatString', yAxisField);

  if (jsFormatString) {
    var dataType = (0, _fp.get)('reportPartElm.properties.dataFormattings.functionInfo.formatDataType', yAxisField);
    var jsFormatId = (0, _fp.get)('reportPartElm.properties.dataFormattings.format.formatId', yAxisField);
    return formatDataByStringFormat(jsFormatId, (0, _fp.get)(yAxisColumnName, record), dataType);
  }

  var hasCustomFormat = (0, _fp.has)(_Izenda3.default.CUSTOM_FORMAT_PREFIX + yAxisColumnName, record);

  return hasCustomFormat ? (0, _fp.get)(yAxisColumnName, record) : null;
}

/**
 * format data by string format
 * @param  {string} stringFormat java script string format
 * @param  {any} data         data to format
 * @return {string}              data after format
 */
function formatDataByStringFormat(stringFormat, value, dataType) {
  var data = void 0;
  if ((0, _fp.isNil)(value) || (0, _fp.isEqual)(value, '')) {
    data = null;
  } else {
    data = dataType === 'Datetime' ? new Date(value) : value;
  }

  return _Izenda15.default.format(stringFormat, data, value);
}

function getFormatedValueByStringFormat(reportPartElm, value, fieldDataType) {
  var formatedValue = void 0;
  var jsFormatString = (0, _fp.get)('properties.dataFormattings.format.jsFormatString', reportPartElm);
  var dataType = !(0, _fp.isNil)(fieldDataType) ? fieldDataType : (0, _fp.get)('field.dataFieldType', reportPartElm);

  if (jsFormatString) {
    var jsFormatId = (0, _fp.get)('properties.dataFormattings.format.formatId', reportPartElm);
    formatedValue = formatDataByStringFormat(jsFormatId, value, dataType);
  }

  return formatedValue;
}

/**
 * Whether serie has parent relationship
 * @param {Array<Object>} serie
 */
function hasFamilyRelationship(serie) {
  return (0, _fp.some)(function (i) {
    return !(0, _fp.isNil)(i.parent);
  }, serie);
}

exports.default = {
  setDefaultAxisName: setDefaultAxisName,
  addPointActionLink: addPointActionLink,
  getPointName: getPointName,
  getPointValue: getPointValue,
  formatterData: formatterData,
  getFormatedValueByStringFormat: getFormatedValueByStringFormat,
  getPointOptions: getPointOptions,
  getAxisType: getAxisType,
  getColorPointBySerie: getColorPointBySerie,
  getColorPointBySeries: getColorPointBySeries,
  getColorForSiries: getColorForSiries,
  getFormattedLabelAxis: getFormattedLabelAxis,
  getFormattedDataByPoint: getFormattedDataByPoint,
  getTooltipFormatter: getTooltipFormatter,
  onDrilldownGauge: onDrilldownGauge,
  showText: showText,
  getCustomFormat: getCustomFormat,
  formatDataByStringFormat: formatDataByStringFormat,
  setColorPointForAreaLine: setColorPointForAreaLine
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure, $izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _bluebird = __webpack_require__(18);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

exports.default = function (path, config) {
  return new Fetcher(path, config);
};

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda3 = __webpack_require__(60);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(120);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(12);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(40);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Resolve API url from path
 * @param {string} path
 * @returns {string}
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.Fetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function resolveUrl(path) {
  ensure(path || path !== '', 'Path of url must be provided');
  var root = _config2.default.WebApiUrl;
  var safePath = path ? path[0] === '/' ? path.substring(1) : path : '';
  return root.concat(root.slice(-1) !== '/' ? '/'.concat(safePath) : safePath);
}

/**
 * get timeout for ajax query, then convert to milliseconds by multiply with 1000
 * @returns {number} timeout
 */
function getTimeout() {
  return (_Izenda2.default.advancedSettings.performance.queryTimeoutValue || _Izenda2.default.advancedSettings.performance.queryTimeoutDefaultValue || _config2.default.TimeOut) * 1000;
}

/**
 * Build request headers.
 * @param {Object} config
 * @param {Object} securityManager
 * @returns {Object}
 */
function buildHeaders(config, securityManager) {
  var headers = {};

  (0, _assign2.default)(headers, buildAuthHeaders(config, securityManager));

  return headers;
}

/**
 * Build auth request headers.
 * @param {Object} config
 * @param {Object} securityManager
 * @returns {Object}
 */
function buildAuthHeaders(config, securityManager) {
  config = config || {};
  if (config.excludeAuthHeader) return null;

  var headers = {};
  var HEADER_KEYS = _Izenda4.default.HEADER_KEYS,
      HEADER_PREFER = _Izenda4.default.HEADER_PREFER;


  var accessToken = securityManager.getAccessToken();
  if (!(0, _fp.isNil)(accessToken)) {
    headers[HEADER_KEYS.access_token] = accessToken;
  }

  var currentTenantValue = _IzendaUiState2.default.currentUser.tenantId;
  if (!(0, _fp.isNil)(currentTenantValue)) {
    headers[HEADER_KEYS.current_tenant] = currentTenantValue;
  }

  headers[HEADER_KEYS.selected_tenant] = _IzendaUiState2.default.tenantId;

  if (!(0, _fp.isNil)(config.prefer)) {
    headers[HEADER_KEYS.prefer] = HEADER_PREFER[config.prefer];
  }

  return headers;
}

/**
 * Invoke AJAX call to path with associated options
 * @param {string} path
 * @param {Object} options
 * @returns {Promise}
 */
function ajax(path, options) {
  var final = (0, _fp.merge)({
    cache: false,
    url: resolveUrl(path),
    contentType: 'application/json',
    timeout: getTimeout(),
    async: !(0, _fp.isNil)(options.async) ? options.async : true,
    error: function error(jqXHR, textStatus) {
      switch (jqXHR.status) {
        case 401:
          if (_Izenda10.default.Integration) {
            var message = (0, _fp.getOr)('', 'responseJSON.message', jqXHR);
            (0, _fp.isFunction)(_Izenda10.default.OnReceiveUnauthorizedResponse) && _Izenda10.default.OnReceiveUnauthorizedResponse(message);
          } else {
            _IzendaUiState2.default.setNeedLogin(true);
          }
          break;
        case 408:
          _IzendaUiState2.default.setSystemError('Query timeout expired.');
          break;
        case 0:
          _IzendaUiState2.default.setSystemError(_Izenda8.default.getText('COMMON_MESSAGES_GENERIC_ERROR'));
          break;
      }
    },
    headers: buildHeaders(options.config, options.securityManager)
  }, options);

  return (0, _bluebird.resolve)($izenda.ajax(final));
}

/**
 * API communicator
 */

var Fetcher = function () {
  /**
   * Web API data fetcher
   * @constructor
   * @param {string} path - Query url path
   * @param {Object} config - Advanced configuration.
   */
  function Fetcher(path, config) {
    (0, _classCallCheck3.default)(this, Fetcher);

    this.path = path;
    this.config = config;
    this.securityManager = new _Izenda6.default();
  }

  /**
   * GET request
   * @returns {Promise}
   */


  (0, _createClass3.default)(Fetcher, [{
    key: 'get',
    value: function get() {
      return ajax(this.path, {
        type: 'GET',
        config: this.config,
        securityManager: this.securityManager
      });
    }

    /**
     * POST request with payload data
     * @param {Object} payload - POST data
     * @param {Object} cacheKey
     * @param {boolean} async (default is true)
     * @returns {Promise}
     */

  }, {
    key: 'post',
    value: function post(payload, cacheKey) {
      var async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return ajax(this.path, {
        type: 'POST',
        data: payload ? (0, _stringify2.default)(payload) : payload,
        config: this.config,
        securityManager: this.securityManager,
        async: async
      });
    }

    /**
     * DELETE request with payload data
     * @param {Object} payload - POST data
     * @returns {Promise}
     */

  }, {
    key: 'delete',
    value: function _delete(payload) {
      return ajax(this.path, {
        type: 'DELETE',
        data: payload ? (0, _stringify2.default)(payload) : payload,
        config: this.config,
        securityManager: this.securityManager
      });
    }

    /**
     * POST request with files
     * @param {Array} files
     * @returns {Promise}
     */

  }, {
    key: 'upload',
    value: function upload(files) {
      var formData = new FormData();
      (0, _fp.forEach)(function (file) {
        formData.append(file.name, file);
      }, files);

      return ajax(this.path, {
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        enctype: 'multipart/form-data',
        config: this.config,
        securityManager: this.securityManager
      });
    }

    /**
     * Get auth header
     * @return {Object}
     */

  }, {
    key: 'getAuthHeader',
    value: function getAuthHeader() {
      return buildAuthHeaders(this.config, this.securityManager);
    }
  }]);
  return Fetcher;
}();

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(26)))

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Label;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Label(props) {
  var className = props.className,
      htmlFor = props.htmlFor,
      children = props.children;

  return _react2.default.createElement(
    'label',
    { className: className, htmlFor: htmlFor },
    children
  );
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.Label.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(45);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var SECTION = {
  SystemConfiguration: 'systemConfiguration',
  TenantSetup: 'tenantSetup',
  DataSetup: 'dataSetup',
  UserSetup: 'userSetup',
  RoleSetup: 'roleSetup',
  Reports: 'reports',
  Dashboards: 'dashboards',
  Access: 'access',
  Scheduling: 'scheduling',
  Emailing: 'emailing',
  Exporting: 'exporting',
  SystemWide: 'systemwide'
};

var SECTION_LIST_FULL_REPORT_DASHBOARD_ACCESS = [{
  key: SECTION.SystemConfiguration,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_SYSTEM_CONFIGURATION');
  }
}, {
  key: SECTION.TenantSetup,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_TENANT_SETUP');
  },
  alwaysShow: true
}, {
  key: SECTION.DataSetup,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_DATA_SETUP');
  }
}, {
  key: SECTION.UserSetup,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_USER_SETUP');
  }
}, {
  key: SECTION.RoleSetup,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_ROLE_SETUP');
  }
}, {
  key: SECTION.SystemWide,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_SYSTEM_WIDE');
  }
}];

var SECTION_LIST = [{
  key: SECTION.SystemConfiguration,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_SYSTEM_CONFIGURATION');
  },
  licenseKey: 'Scheduling'
}, {
  key: SECTION.TenantSetup,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_TENANT_SETUP');
  },
  alwaysShow: true
}, {
  key: SECTION.DataSetup,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_DATA_SETUP');
  }
}, {
  key: SECTION.UserSetup,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_USER_SETUP');
  }
}, {
  key: SECTION.RoleSetup,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_ROLE_SETUP');
  }
}, {
  key: SECTION.Reports,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_REPORTS');
  }
}, {
  key: SECTION.Dashboards,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_DASHBOARDS');
  },
  licenseKey: 'Dashboard'
}, {
  key: SECTION.Access,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_ACCESS');
  }
}, {
  key: SECTION.Scheduling,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_SCHEDULING');
  },
  licenseKey: 'Scheduling'
}, {
  key: SECTION.Emailing,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_EMAILING');
  }
}, {
  key: SECTION.Exporting,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_EXPORTING');
  },
  licenseKey: 'Exporting'
}, {
  key: SECTION.SystemWide,
  get value() {
    return _Izenda2.default.getText('COMMON_LABEL_SYSTEM_WIDE');
  }
}];

var CATEGORY_TYPE = {
  REPORT: 0,
  DASHBOARD: 1
};

var ROLE_TYPE = {
  ACCESS: 0,
  SCHEDULE: 1
};

var TREE_TYPE = {
  CATEGORY: 0,
  ACCESS: 1
};

var NUMBER_CATEGORY_TAKE = {
  VISIBLE: 2,
  SAVEABLE: 3
};

var ROLE_PERMISSION_CONCAT_TREE_MAP = [{
  prop: 'childNodes',
  nodeType: 'User'
}];

var ROLE_PERMISSION_TREE_MAP = [{
  prop: 'childNodes',
  nodeType: 'Role',
  expand: true,
  showTotal: true,
  children: ROLE_PERMISSION_CONCAT_TREE_MAP
}];

exports.default = {
  SECTION: SECTION,
  SECTION_LIST: SECTION_LIST,
  SECTION_LIST_FULL_REPORT_DASHBOARD_ACCESS: SECTION_LIST_FULL_REPORT_DASHBOARD_ACCESS,
  CATEGORY_TYPE: CATEGORY_TYPE,
  ROLE_TYPE: ROLE_TYPE,
  TREE_TYPE: TREE_TYPE,
  NUMBER_CATEGORY_TAKE: NUMBER_CATEGORY_TAKE,
  ROLE_PERMISSION_TREE_MAP: ROLE_PERMISSION_TREE_MAP,
  ROLE_PERMISSION_CONCAT_TREE_MAP: ROLE_PERMISSION_CONCAT_TREE_MAP,
  ICON_TRIANGLE: {
    ICON_DOWN: 'icon-triangle-down',
    ICON_RIGHT: 'icon-triangle-right'
  }
};
module.exports = exports['default'];

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var SAVE_KEY = 0;
var COPY_KEY = 1;
var MOVE_KEY = 2;

var REQUIRED_FILTER = 'RequiredFilters';
var LEFT_MENU_CONCAT_TREE_MAP = [{
  prop: 'subCategories',
  expand: false,
  children: [{
    prop: 'subCategories',
    expand: false
  }]
}];

exports.default = {
  DASHBOARD_PART_MIN_WIDTH: 5,

  get GLOBAL_DASHBOARD() {
    return _Izenda2.default.getText('COMMON_LABEL_GLOBAL_DASHBOARD');
  },
  get UNCATEGORIZED() {
    return _Izenda2.default.getText('COMMON_LABEL_UNCATEGORIZED');
  },
  get DASHBOARD_DEFAULT_NAME() {
    return _Izenda2.default.getText('DASHBOARD_DEFAULT_NAME');
  },
  TITLE_MAX_LENGTH: 256,
  get ALL_CATEGORY_TYPES() {
    return {
      ALL_DASHBOARDS: {
        name: _Izenda2.default.getText('DASHBOARD_LABEL_ALL_DASHBOARD'),
        type: 0,
        id: '0000',
        isGlobal: null
      }
    };
  },
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  get CONSTRAINTS() {
    return {
      NAME: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('DASHBOARD_CONSTRAINTS_REQUIRED_NAME')
        }
      }
    };
  },
  get TOOLBAR_CONTROL() {
    return [{ label: _Izenda2.default.getText('DASHBOARD_LABEL_PRESENTATION'), value: 0 }, { label: _Izenda2.default.getText('DASHBOARD_LABEL_ACCESS'), value: 1 }, { label: _Izenda2.default.getText('COMMON_LABEL_SUBSCRIBE'), value: 2 }, { label: _Izenda2.default.getText('COMMON_LABEL_SCHEDULE'), value: 3 }, { label: _Izenda2.default.getText('COMMON_LABEL_SAVE'), value: 4 }];
  },
  get TILE_TYPE() {
    return {
      reportPart: {
        type: 'reportPart',
        label: _Izenda2.default.getText('COMMON_LABEL_REPORT_PART'),
        icon: 'icon-report-format',
        needPopup: true
      },
      text: {
        type: 'text',
        label: _Izenda2.default.getText('COMMON_LABEL_TEXT'),
        icon: 'icon-text-format',
        needPopup: false
      }
    };
  },
  get SEARCH_CRITERIA() {
    return [{ value: 'All', label: _Izenda2.default.getText('COMMON_LABEL_ALL') }, { value: 'DashboardName', label: _Izenda2.default.getText('DASHBOARD_LABEL_NAME') }, { value: 'DashboardDescription', label: _Izenda2.default.getText('DASHBOARD_LABEL_DASHBOARD_DESCRIPTION') }, { value: 'CreatedBy', label: _Izenda2.default.getText('COMMON_CRITERIA_CREATED_BY') }, { value: 'CreatedDate', label: _Izenda2.default.getText('COMMON_CRITERIA_CREATED_DATE') }, { value: 'LastEditedBy', label: _Izenda2.default.getText('COMMON_CRITERIA_EDITED_BY') }, { value: 'LastEditedDate', label: _Izenda2.default.getText('COMMON_CRITERIA_EDITED_DATE') }, { value: 'Category', label: _Izenda2.default.getText('COMMON_LABEL_CATEGORY') }, { value: 'Subcategory', label: _Izenda2.default.getText('COMMON_LABEL_SUBCATEGORY') }, { value: 'LastViewed', label: _Izenda2.default.getText('COMMON_CRITERIA_LAST_VIEWED') }];
  },
  get SORT_CRITERIA() {
    return [{ value: 'DashboardName', label: _Izenda2.default.getText('DASHBOARD_LABEL_NAME') }, { value: 'CreatedBy', label: _Izenda2.default.getText('COMMON_CRITERIA_CREATED_BY') }, { value: 'CreatedDate', label: _Izenda2.default.getText('COMMON_CRITERIA_CREATED_DATE') }, { value: 'LastEditedBy', label: _Izenda2.default.getText('COMMON_CRITERIA_EDITED_BY') }, { value: 'LastEditedDate', label: _Izenda2.default.getText('COMMON_CRITERIA_EDITED_DATE') }, { value: 'NumberOfView', label: _Izenda2.default.getText('COMMON_CRITERIA_NUMBER_OF_VIEWS') }, { value: 'RenderingTime', label: _Izenda2.default.getText('COMMON_CRITERIA_AVERAGE_RENDERING_TIME') }, { value: 'Category', label: _Izenda2.default.getText('COMMON_LABEL_CATEGORY') }, { value: 'Subcategory', label: _Izenda2.default.getText('COMMON_LABEL_SUBCATEGORY') }];
  },
  SORT_TYPES: {
    ASC: 'asc',
    DESC: 'desc'
  },
  CATEGORY_TYPE: {
    CATEGORY_ID: 'CategoryId',
    SUB_CATEGORY_ID: 'SubCategoryId'
  },
  STICKY: {
    top: 165,
    topOffset: -204,
    bottomOffset: 0
  },
  DATETIME_FORMAT: 'MM/dd/yyyy',
  get MESSAGE() {
    return {
      M01: _Izenda2.default.getText('DASHBOARD_MESSAGE_CONFIRM_DELETE'),
      M06a: _Izenda2.default.getText('DASHBOARD_MESSAGE_MOVE_SUCCESSFULLY'),
      M06b: _Izenda2.default.getText('DASHBOARD_MESSAGE_COPY_SUCCESSFULLY'),
      M07: _Izenda2.default.getText('DASHBOARD_MESSAGE_SPECIFY_DESTINATION'),
      INVALID_IMAGE_URL: _Izenda2.default.getText('DASHBOARD_MESSAGE_INVALID_IMAGE_URL')
    };
  },
  get TILE_LABEL_TEXT() {
    return {
      contentTitle: _Izenda2.default.getText('COMMON_LABEL_TITLE'),
      contentDescription: _Izenda2.default.getText('COMMON_LABEL_DESCRIPTION'),
      body: _Izenda2.default.getText('DASHBOARD_LABEL_BODY_TEXT')
    };
  },
  get SAVE_POPUP_CONFIG() {
    return {
      DASHBOARD_NAME: _Izenda2.default.getText('DASHBOARD_LABEL_NAME'),
      CATEGORY: _Izenda2.default.getText('COMMON_LABEL_CATEGORY'),
      SUBCATEGORY: _Izenda2.default.getText('COMMON_LABEL_SUBCATEGORY'),
      SAVEINTO: _Izenda2.default.getText('COMMON_LABEL_SAVEINTO')
    };
  },
  get ACTION_ENUM() {
    return {
      0: _Izenda2.default.getText('COMMON_LABEL_SAVE'),
      1: _Izenda2.default.getText('COMMON_LABEL_COPY'),
      2: _Izenda2.default.getText('COMMON_LABEL_MOVE')
    };
  },
  get SELECT_CATEGORY_HINT() {
    return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_HINT_CATEGORY');
  },
  get SELECT_SUB_CATEGORY_HINT() {
    return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_HINT_SUB_CATEGORY');
  },
  SAVE_KEY: SAVE_KEY,
  COPY_KEY: COPY_KEY,
  MOVE_KEY: MOVE_KEY,
  get DASHBOARD() {
    return _Izenda2.default.getText('COMMON_LABEL_DASHBOARD');
  },
  get DESCRIPTION() {
    return {
      DESCRIPTION_LABEL: _Izenda2.default.getText('DASHBOARD_MESSAGE_MISSING_DESCRIPTION'),
      TITLE: _Izenda2.default.getText('DASHBOARD_LABEL_DASHBOARD_DESCRIPTION')
    };
  },
  get BACKGROUND_IMAGE() {
    return {
      IMAGE_URL_LABEL: _Izenda2.default.getText('DASHBOARD_LABEL_IMAGE_URL'),
      STRETCH_IMAGE_LABEL: _Izenda2.default.getText('DASHBOARD_LABEL_STRETCH_IMAGE'),
      TITLE: _Izenda2.default.getText('DASHBOARD_LABEL_BACKGROUND_IMAGE')
    };
  },
  validateFilterMessage: function validateFilterMessage(result) {
    var validateMessage = '';

    var messages = result.messages;
    // Messages level : Just 1 message required for now
    if (messages.length > 0 && messages[0].messages[0]) {
      validateMessage += '<p>' + messages[0].messages[0] + '</p>';
    } else {
      return '';
    }

    validateMessage += '<ul style="list-style-type: decimal" >';

    result.messages[0].detail.forEach(function (detail) {
      var reportParts = '';
      var COMMON_FILTER_FIELD = {
        KEY: 'CommonFilterFields',
        NAME: _Izenda2.default.getText('DASHBOARD_COMMON_FILTER_FIELDS')
      };

      // Report parts level
      var reportPartName = detail.key === COMMON_FILTER_FIELD.KEY ? COMMON_FILTER_FIELD.NAME : detail.key;

      reportParts = '<li>' + reportPartName;
      reportParts += '<ul style="list-style-type: decimal" >';
      // Filters Level
      (0, _fp.forEach)(function (value) {
        reportParts += '<li>' + value + '</li>';
      }, detail.value);

      reportParts += '</ul></li>';

      validateMessage += reportParts;
    });

    validateMessage += '</ul>';

    return validateMessage;
  },

  DASHBOARD_LIST_CONCAT_TREE_MAP: [{
    prop: 'subCategories',
    children: [{
      prop: 'subCategories',
      children: [{
        prop: 'dashboards'
      }]
    }]
  }],
  LEFT_MENU_CONCAT_TREE_MAP: LEFT_MENU_CONCAT_TREE_MAP,
  LEFT_MENU_TREE_MAP: [{
    prop: 'globalLocalCategory',
    expand: true,
    children: LEFT_MENU_CONCAT_TREE_MAP
  }],
  DASHBOARD_PART_WORKER_CHUNK: 3
};
module.exports = exports['default'];

/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(247);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'systemSetting/';
// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemSettingFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  BASE_PATH: ROOT_URL,
  /**
   * Fetch system mode from API
   * @returns {Promise}
   */
  getSystemMode: function getSystemMode() {
    return (0, _Izenda2.default)(ROOT_URL + 'systemMode').get().then((0, _fp.get)('systemMode'));
  },


  /**
   * Fetch system mode from API
   * @returns {Promise}
   */
  getSystemVariables: function getSystemVariables() {
    return (0, _Izenda2.default)(ROOT_URL + 'systemVariables').get();
  },


  /**
   * Fetch system indicator from API
   * @param {string} tenantId
   * @returns {Promise}
   */
  getSystemIndicator: function getSystemIndicator(tenantId) {
    var tenant = (0, _fp.isNil)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)(ROOT_URL + 'systemIndicator/' + tenant).get();
  },

  /**
   * fetch number of connection to disable context menu link
   * @param  {String} tenantId
   */
  getNumberOfConnection: function getNumberOfConnection(tenantId) {
    var tenant = (0, _fp.isNil)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)('connection/visible/' + tenant + '/count').get();
  },


  /**
   * Fetch list active tenant
   * @returns {Promise}
   */
  getTenants: function getTenants() {
    return (0, _Izenda2.default)('tenant/activeTenants').get();
  },


  /**
   * [getAllUsers Fetch list users]
   * @param {string} tenantId
   * @return {Array}
   */
  getAllUsers: function getAllUsers(tenantId) {
    tenantId = tenantId || '';
    return (0, _Izenda2.default)('user/all/' + tenantId).get();
  },


  /**
   * [getPartialUsers Fetch list users]
   * @param {Object} params
   * @return {Array}
   */
  getPartialUsers: function getPartialUsers(params) {
    return (0, _Izenda2.default)('user/all/').post(params);
  },


  /**
   * Load Schedules
   * @param {object} data
   * @returns {Promise}
   */
  loadSchedules: function loadSchedules(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadSchedules').post(data);
  },


  /**
   * Delete Schedules, data is array of schedule ID
   * @param {array} data
   * @returns {Promise}
   */
  deleteSchedules: function deleteSchedules(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'deleteSchedules').post(data);
  },


  /**
   * Get Report Dashboard Name
   * @param {string}
   * @param tenantId
   * @returns {promise}
   */
  getReportDashboardNameByTenant: function getReportDashboardNameByTenant(reportingType, tenantId) {
    var param = tenantId || '';
    return (0, _Izenda2.default)(ROOT_URL + 'schedules/reportDashboardName/' + reportingType + '/' + param).get();
  },


  /**
   * Get Recipients by Tenant
   * @param {string} tenantId
   * @returns {promise}
   */
  getRecipientByTenant: function getRecipientByTenant(tenantId) {
    var param = tenantId || '';
    return (0, _Izenda2.default)(ROOT_URL + 'schedules/recipients/' + param).get();
  },


  /**
   * get Creator by Tenant
   * @param {string} tenantId
   * @returns {promise}
   */
  getCreatedByTenant: function getCreatedByTenant(tenantId) {
    var param = tenantId || '';
    return (0, _Izenda2.default)(ROOT_URL + 'schedules/creators/' + param).get();
  },


  /**
   * Load email variables
   * @param  {Number} reportingType
   * @param  {Object} pageInfo
   */
  loadEmailVariables: function loadEmailVariables(reportingType, pageInfo) {
    pageInfo = pageInfo || {};
    var defaultPageIndex = 1;
    var defaultPageSize = 10;

    var requestData = {
      reportingType: reportingType,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || defaultPageIndex,
      pageSize: pageInfo.pageSize || defaultPageSize,
      sortOrders: pageInfo.sortOrders || [{
        key: 'name',
        descending: false
      }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadEmailVariables').post(requestData);
  },


  /**
   * load Security Policies
   * @return {pormise}
   */
  loadSecurityPolicies: function loadSecurityPolicies() {
    return (0, _Izenda2.default)(ROOT_URL + 'securityPolicy').get();
  },


  /**
   * save Security Policies
   * @param {Object} any
   * @return {promise}
   */
  saveSecurityPolicies: function saveSecurityPolicies(data) {
    data = data || {};
    return (0, _Izenda2.default)(ROOT_URL + 'securityPolicy').post(data);
  },


  /**
   * Load security questions.
   * @param {string} userName
   * @param {string} tenantDisplayID
   */
  securityQuestions: function securityQuestions(_ref) {
    var userName = _ref.userName,
        tenantDisplayID = _ref.tenantDisplayID;

    var request = {
      userName: userName,
      tenantDisplayID: tenantDisplayID
    };
    return (0, _Izenda2.default)(ROOT_URL + 'securityQuestions').post(request);
  },


  /**
   * Check database setup.
   */
  databaseSetup: function databaseSetup() {
    return (0, _Izenda2.default)(ROOT_URL + 'databaseSetup').get();
  },


  /**
   * Load Email Configuration
   * @param {string} tenantId
   * @returns {promise}
   */
  loadEmailConfiguration: function loadEmailConfiguration(tenantId) {
    tenantId = tenantId || '';
    return (0, _Izenda2.default)(ROOT_URL + 'email/' + tenantId).get();
  },


  /**
   * Save Email Configuration
   * @param {Object} data
   */
  saveEmailConfiguration: function saveEmailConfiguration(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'email').post(data);
  },


  /**
   * Check whether Email is configured or not
   * @param {string} tenantId
   * @returns {promise}
   */
  isHavemailConfiguration: function isHavemailConfiguration(tenantId) {
    tenantId = tenantId || '';
    return (0, _Izenda2.default)(ROOT_URL + 'email/status/' + tenantId).get();
  },


  /**
   * load All Languages
   * @return {promise}
   */
  loadAllLanguages: function loadAllLanguages() {
    return (0, _Izenda2.default)(ROOT_URL + 'language').get();
  },


  /**
   * load All Date Format
   * @return {promise}
   */
  loadAllDateFormat: function loadAllDateFormat() {
    return (0, _Izenda2.default)(ROOT_URL + 'dateFormat').get();
  },

  /**
   * load System Setting Mode
   * @return {promise}
   */
  loadSystemModeSettings: function loadSystemModeSettings() {
    return (0, _Izenda2.default)(ROOT_URL + 'systemModeSettings').get();
  },


  /**
   * save System Setting Mode
   * @param {Object} data
   * @return {promise}
   */
  saveSystemModeSettings: function saveSystemModeSettings(data) {
    data = data || {};
    return (0, _Izenda2.default)(ROOT_URL + 'systemModeSettings').post(data);
  },


  /**
   * Fetch deployment mode from API
   * @returns {Promise}
   */
  getDeploymentMode: function getDeploymentMode() {
    return (0, _Izenda2.default)(ROOT_URL + 'deploymentMode').get();
  },


  /**
   * Get Report Configuration
   * @param {String} settings
   * @return {Promise}
   */
  getReportConfiguration: function getReportConfiguration() {
    return (0, _Izenda2.default)(ROOT_URL + 'reportSetting').get();
  },


  /**
   * Save Report Configuration
   * @param  {Object} data
   */
  saveReportConfiguration: function saveReportConfiguration(data) {
    data = data || {};
    return (0, _Izenda2.default)(ROOT_URL + 'reportSetting').post(data);
  },


  /**
   * Get Help System URL
   */
  getHelpSystemUrl: function getHelpSystemUrl() {
    return (0, _Izenda2.default)(ROOT_URL + 'helpSystemUrl').get();
  },


  /**
   * Load category settings.
   */
  categorySetting: function categorySetting() {
    return (0, _Izenda2.default)(ROOT_URL + 'categorySetting').get();
  },


  /**
   * Fetch pre-defined themes
   */
  fetchThemes: _Izenda4.default.memoize(function () {
    return (0, _Izenda2.default)(ROOT_URL + 'themes').get();
  }),

  /**
   * Fetch System Date
   */
  loadSystemDate: function loadSystemDate() {
    return (0, _Izenda2.default)(ROOT_URL + 'Status').get();
  }
};
module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _Izenda = __webpack_require__(222);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(88);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(50);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

var _Izenda9 = __webpack_require__(78);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(264);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PrintingUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function getNativeStyle(_ref) {
  var height = _ref.height,
      display = _ref.display,
      margin = _ref.margin;

  return 'height: ' + height + '; position: relative; display: ' + display + '; margin: ' + margin;
}

exports.default = {
  /**
   * get config style for ReportPart container
   * @param  {any} props
   * @return {any} style object
   */
  getReportPartContainerStyle: function getReportPartContainerStyle(props) {
    // we only build style for preview of export format setting.
    if (!props.setting || !props.exportFormatSetting) {
      return null;
    }

    var exportFormatSetting = props.exportFormatSetting || {};
    var centerOnPage = exportFormatSetting.centerOnPage;
    var pageSize = _Izenda2.default.getPageSize(exportFormatSetting.pageSizeKey, exportFormatSetting.orientation);
    var usePageBreakAfterSeparator = props.reportPart.reportPartContent.checkBreakPage();

    return {
      display: 'table',
      margin: centerOnPage.horizontally ? 'auto' : 0,
      height: centerOnPage.vertically ? _Izenda2.default.getContainerHeight(pageSize.heightInInches, props.isFirstReportPart) : 'auto'
    };
  },


  /**
   * get config style for ReportPart separator
   * @param  {any} props
   * @param  {boolean} exportFormatSetting
   * @return {any} style object
   */
  getSeparatorContainerStyle: function getSeparatorContainerStyle(props, convertToNativeStyle) {
    // we only build style for preview of export format setting.
    if (!props.setting || !props.exportFormatSetting) {
      return null;
    }

    var exportFormatSetting = props.exportFormatSetting || {};
    var centerOnPage = exportFormatSetting.centerOnPage;
    var pageSize = _Izenda2.default.getPageSize(exportFormatSetting.pageSizeKey, exportFormatSetting.orientation);
    var usePageBreakAfterSeparator = props.reportPart.reportPartContent.checkBreakPage();

    var styleObject = usePageBreakAfterSeparator && pageSize ? {
      height: centerOnPage.vertically ? _Izenda2.default.formatCSSValueInInches(pageSize.heightInInches - 0.8) : 0,
      display: 'table',
      margin: centerOnPage.horizontally ? 'auto' : 0
    } : {};
    return convertToNativeStyle ? getNativeStyle(styleObject) : styleObject;
  },


  /**
   * get Report Part className
   * @param  {any} props
   * @return {any} className object
   */
  getReportPartClassName: function getReportPartClassName(props) {
    // we only build style for preview of export format setting.
    if (!props.setting || !props.exportFormatSetting) {
      return null;
    }

    var exportFormatSetting = props.exportFormatSetting;
    var centerOnPage = exportFormatSetting ? exportFormatSetting.centerOnPage : {};
    var shouldAlignMiddle = centerOnPage.vertically && !props.reportPart.reportPartContent.checkBreakPage();

    return (0, _classnames2.default)('u_tableCell', {
      u_alignMiddle: shouldAlignMiddle
    });
  },


  /**
   * get separator className
   * @param  {any} props
   * @return {any} className object
   */
  getSeparatorClassName: function getSeparatorClassName(props) {
    // we only build style for preview of export format setting.
    if (!props.setting || !props.exportFormatSetting) {
      return null;
    }

    var exportFormatSetting = props.exportFormatSetting;
    var centerOnPage = exportFormatSetting ? exportFormatSetting.centerOnPage : {};
    var shouldAlignMiddle = centerOnPage.vertically && props.reportPart.reportPartContent.checkBreakPage();

    return (0, _classnames2.default)('u_tableCell', {
      u_alignMiddle: shouldAlignMiddle
    });
  },


  /**
   * replace style & class for Form
   * @param  {any} props
   * @param  {string} content
   * @return {string} replaced content
   */
  replaceFormStyles: function replaceFormStyles(props, content) {
    if (!props.printingMode) {
      return null;
    }

    var style = this.getSeparatorContainerStyle(props, true);
    var classes = this.getSeparatorClassName(props);
    var replaceString = '<div style=' + style + '><div class="' + classes + '">';

    content = (0, _fp.replace)('<div>', replaceString, content);
    content = (0, _fp.replace)('</div>', '</div></div>', content);
    return content;
  },


  /**
   * Create a singleton render promise of part.
   * @param  {string} partId
   */
  createPartRenderPromise: function createPartRenderPromise(partId) {
    var newPromise = (0, _fp.memoize)(function () {
      var resolvePromise = null;
      var renderPromise = new _bluebird2.default(function (resolve, reject) {
        resolvePromise = resolve;
      });
      return {
        partId: partId,
        promise: renderPromise,
        resolve: resolvePromise
      };
    });

    return newPromise();
  },


  /**
   * Resolve value for system variable.
   * @param  {any} store
   * @param  {string} value
   */
  replaceSystemVariable: function replaceSystemVariable(store, item) {
    var value = item.value;
    var reportStore = store.reportStore || {};
    var reportModel = reportStore.model || {};

    switch (value) {
      case _Izenda8.default.SYSTEM_VARIABLES.REPORT_NAME:
        value = reportModel.reportName;
        break;
      case _Izenda8.default.SYSTEM_VARIABLES.CURRENT_DATETIME:
        var format = item.format || _Izenda4.default.currentUser.dateFormat;
        var currentDate = _Izenda12.default.getUtcTimeWithTimestampOffset();
        value = (0, _Izenda6.default)(format, currentDate);
        break;
      case _Izenda8.default.SYSTEM_VARIABLES.CURRENT_USERNAME:
        value = _Izenda4.default.currentUser.fullName;
        break;
      case _Izenda8.default.SYSTEM_VARIABLES.TENANT_NAME:
        value = _Izenda4.default.currentUser.tenantName;
        break;
    }

    return value;
  },


  /**
   * Get current DPI.
   */
  getDPI: function getDPI() {
    // REF: https://github.com/ryanve/res
    var one = {
      dpi: 96
    };

    // Get resolution in dppx on IE.
    function ie() {
      return Math.sqrt(screen.deviceXDPI * screen.deviceYDPI) / one.dpi;
    }

    // Get resolution in dppx
    function dppx() {
      // devicePixelRatio: Webkit (Chrome/Android/Safari), Opera (Presto 2.8+), FF 18+
      return typeof window === 'undefined' ? 0 : +window.devicePixelRatio || ie() || 0;
    }

    return dppx() * one.dpi;
  },


  /**
   * Compose css style for transform scale.
   * @param  {number} scaleX
   * @param  {number} scaleY
   */
  buildScaleStyle: function buildScaleStyle(scaleX, scaleY) {
    var scale = (0, _fp.isNil)(scaleY) ? 'scale(' + scaleX + ')' : 'scale(' + scaleX + ', ' + scaleY + ')';
    var transformOrigin = '0 0 0';

    return {
      transformOrigin: transformOrigin,
      MozTransformOrigin: transformOrigin,
      MsTransformOrigin: transformOrigin,
      WebkitTransformOrigin: transformOrigin,
      OTransformOrigin: transformOrigin,
      transform: scale,
      MozTransform: scale,
      MsTransform: scale,
      WebkitTransform: scale,
      OTransform: scale
    };
  },


  /**
   * Get render listener by id.
   * @param  {Array<any>} renderListeners
   * @param  {string} id
   */
  getRenderListenerById: function getRenderListenerById(renderListeners, id) {
    return (0, _fp.find)(function (listener) {
      return listener.partId === id;
    }, renderListeners);
  },


  /**
   * Get finished render promise by id.
   * @param  {Array<any>} renderListeners
   * @param  {string} id
   */
  getFinishedRenderPromiseById: function getFinishedRenderPromiseById(renderListeners, id) {
    var renderListener = this.getRenderListenerById(renderListeners, id);
    return renderListener && renderListener.resolve;
  },


  /**
   * Push render listener into directory by id
   * @param  {Array<any>} renderListeners
   * @param  {string} id
   */
  pushRenderListener: function pushRenderListener(renderListeners, id) {
    var renderListener = (0, _fp.find)(function (item) {
      return item.partId === id;
    }, renderListeners);
    !renderListener && renderListeners.push(this.createPartRenderPromise(id));
    return renderListeners;
  },


  /**
   * publish finished render event
   * @param  {Array<any>} renderListeners
   * @param  {any} callback
   */
  publishFinishedRender: function publishFinishedRender(renderListeners, callback) {
    var childPromises = (0, _fp.map)(function (item) {
      return item.promise;
    }, renderListeners);

    (0, _bluebird.all)(childPromises).then(function () {
      callback && callback();
    });
  },


  /**
   * Print html. This is intended to print html from API.
   * @param {string} content
   */
  printHtml: function printHtml(content) {
    var printTab = _Izenda10.default.openNewTab();
    if (!printTab) return;
    var doc = printTab.document;
    var printIntervalMs = 100;
    printTab.document.write(content);
    printTab.document.close();
    var print = function print(printInterval) {
      printTab.print();
      printInterval && clearInterval(printInterval);
    };

    printTab.document.body.onload = function () {
      var cssnum = doc.styleSheets.length;
      var printInterval = setInterval(function () {
        var cssRuleSets = (0, _fp.filter)(function (s) {
          try {
            return !!s.cssRules;
          } catch (err) {
            return true;
          }
        }, doc.styleSheets);
        cssRuleSets.length === cssnum && print(printInterval);
      }, printIntervalMs);
    };
  }
};
module.exports = exports['default'];

/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// ----------------------------------------------------------------------
// <copyright file="Izenda.BrowserUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var IPAD_LANDSCAPE_WIDTH = 1100;
var MOBILE_WIDTH = 1024;

/**
 * This utilities is for handling browser (close tab, open tab, open tab and print, etc)
 */
exports.default = {
  /**
   * Open new tab
   * @param {string} url
   */
  openNewTab: function openNewTab(url) {
    return window.open(url);
  },

  /**
   * Check mobile device
   * @return {Boolean} [description]
   */
  isMobileDevice: function isMobileDevice() {
    return window.innerWidth <= MOBILE_WIDTH;
  },

  /**
   * Check is ipad device
   * @return {Boolean} [description]
   */
  isIpadDevice: function isIpadDevice() {
    return window.innerWidth < IPAD_LANDSCAPE_WIDTH;
  },

  /**
   * Get screen size
   * @return {Object} [description]
   */
  getScreenSize: function getScreenSize() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  },

  /**
   * Check if the current browser is IE
   */
  isIEBrowser: function isIEBrowser() {
    return (/(?:MSIE |Trident\/.*; rv:)(\d+)/.test(navigator.userAgent)
    );
  },

  /**
  * Check if the current browser is Edge
  */
  isEdgeBrowser: function isEdgeBrowser() {
    return navigator.userAgent.indexOf("Edge") > -1;
  },

  /**
  * Check if the current browser is Edge or IE
  */
  isIEOrEdgeBrowser: function isIEOrEdgeBrowser() {
    return this.isIEBrowser() || this.isEdgeBrowser();
  },

  /**
   * Check if the current browser is Chrome
   */
  isChromeBrowser: function isChromeBrowser() {
    return (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
    );
  },

  /**
   * Check if the current browser is Safari
   */
  isSafariBrowser: function isSafariBrowser() {
    return (/Safari/.test(navigator.userAgent) && /Apple/.test(navigator.vendor)
    );
  },

  /**
   * Check if current browser support position sticky
   */
  isSupportSticky: function isSupportSticky() {
    var testNode = document.createElement('div');
    return ['', '-webkit-', '-moz-', '-ms-'].some(function (prefix) {
      try {
        testNode.style.position = prefix + 'sticky';
      } catch (e) {}

      return testNode.style.position != '';
    });
  }
};
module.exports = exports['default'];

/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(164);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(35);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobx = __webpack_require__(5);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = __webpack_require__(88);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(33);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartDataParser.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
var SEPARATOR_SIGN = ';#';

var _require = __webpack_require__(1),
    isObject = _require.isObject;

exports.default = {
  parser: parser,
  getSerieProppertiesByField: getSerieProppertiesByField,
  getValueStyle: getValueStyle,
  processDataByBottomPercent: processDataByBottomPercent,
  getTextColor: getTextColor,
  getCellColor: getCellColor,
  getName: getName,
  getPartNames: getPartNames
};

/**
 * build parser for chart
 * @param  {object} containers
 * @param  {number} expandedLevel
 * @param  {object} previewData
 * @param  {object} dataStructure
 * @return {object}
 */

function parser(containers, expandedLevel, previewData, dataStructure) {
  var fieldsMapping = previewData.fieldsMapping;
  var records = previewData.records || {};
  var fieldContainers = containers;
  var fields = (0, _mobx.isObservable)(fieldsMapping) ? (0, _mobx.toJS)(fieldsMapping) : fieldsMapping;

  dataStructure = dataStructure || _Izenda2.default.restructureField(fieldContainers, fields);

  return {
    expandedLevel: expandedLevel || 0,
    dataStructure: dataStructure,
    fieldsMapping: fields,
    records: records,
    cities: (0, _fp.get)('cities', previewData),
    postalCodes: (0, _fp.get)('postalCodes', previewData),
    rawData: previewData.rawData,
    containers: fieldContainers,

    groupData: groupData,

    hasSeparator: function hasSeparator(separatorKey) {
      return dataStructure[separatorKey] && !!dataStructure[separatorKey].length;
    },

    getSeparatorInfo: function getSeparatorInfo(separatorKey) {
      return dataStructure[separatorKey] && dataStructure[separatorKey][0];
    },

    getConfigDataByRange: _Izenda4.default.getConfigDataByRange,
    getFormatData: _Izenda4.default.getDataFormat,

    getConfigField: function getConfigField(value, fieldMapping, callbacks) {
      var fieldElement = (0, _fp.getOr)({}, 'reportPartElm', fieldMapping) || {};
      var configField = {};

      // Config field for sub-report
      if (fieldElement.hasSubReport) {
        configField.className = configField.className ? [configField.className, 'u_textLink'].join(' ') : 'u_textLink';
        configField.onClick = function () {
          callbacks.onOpenSubReport && callbacks.onOpenSubReport(value);
        };
      }

      return configField;
    },

    getDataByField: function getDataByField(fieldInfo, source, fieldConfig) {
      if (!fieldInfo) {
        return {};
      }

      return {
        name: fieldInfo.fieldNameAlias,
        data: _Izenda2.default.getListValueByField(fieldInfo, source || records, fieldConfig)
      };
    },

    getSerieName: function getSerieName(name) {
      name = name && name.split(SEPARATOR_SIGN) || [];

      return {
        name: name.length > 1 ? name[1] : name[0],
        other: name[0]
      };
    },
    getValueStyle: getValueStyle,
    setRecord: function setRecord(newRecords) {
      records = newRecords;
    }
  };

  /**
   * Group data based on separatorKey, first element of component will be used to group data
   * @param  {string | object} container-key or field-info
   * @param  {Array<object>} groupNames
   * @param  {Array<object>} groupRecords
   * @return {object}
   */
  function groupData(groupInfo, groupNames, groupRecords) {
    var source = groupRecords || records;
    var names = [];
    var columnName = void 0,
        groupedData = void 0;

    // groupInfo is container-name: group by first-field of container
    groupInfo = (0, _fp.isString)(groupInfo) ? (0, _fp.first)(dataStructure[groupInfo]) : groupInfo;
    columnName = (0, _fp.get)('columnName', groupInfo);

    groupedData = columnName ? groupData(columnName, source) : source;
    (0, _fp.forEach)(function (name) {
      groupNames.push(name);
    }, (0, _fp.uniq)(names));

    return groupedData;

    function groupData(columnName, source) {
      var groupName = void 0;
      return (0, _fp.groupBy)(function (record) {
        groupName = record[columnName];

        names && names.push(groupName);
        return groupName;
      }, source);
    }
  }
}

/**
 * get style value
 * @param {object} val
 * @param {object} config
 * @param {object} fieldSource
 */
function getValueStyle(val, config, fieldSource) {
  config = config || {};
  var originalValue = (0, _fp.getOr)(null, 'originalValue', val);
  var valueField = isObject(val) ? val : { value: val };

  return {
    fomattedValue: _Izenda4.default.getDataFormat(valueField, config, fieldSource),
    valueWithoutAltText: _Izenda4.default.getDataFormat(valueField, config, fieldSource, false),
    style: {
      color: getTextColor(originalValue, config, fieldSource),
      cellColor: getCellColor(originalValue, config, fieldSource)
    }
  };
}

/**
 * get text color value
 * @param {object} val
 * @param {object} config
 * @param {object} fieldSource
 */
function getTextColor(val, config, fieldSource) {
  var textColor = (0, _fp.get)('textColor', config);
  return !(0, _fp.isNil)(val) && !(0, _fp.isNil)(textColor) ? _Izenda4.default.getConfigDataByRange(val, textColor, fieldSource) : undefined;
}

/**
 * get cell color value
 * @param {object} val
 * @param {object} config
 * @param {object} fieldSource
 */
function getCellColor(val, config, fieldSource) {
  var cellColor = (0, _fp.get)('cellColor', config);
  return !(0, _fp.isNil)(val) && !(0, _fp.isNil)(cellColor) && !(0, _fp.isNil)(fieldSource.record) ? _Izenda4.default.getConfigDataByRange(val, cellColor, fieldSource) : undefined;
}

/**
 * read properties of fields and return property which need to apply to chart
 * @param  {object} field
 * @return {object}
 */
function getSerieProppertiesByField(field) {
  field = field || {};

  var serieName = field.fieldName;

  if (!serieName) {
    return {};
  }

  var seriesProps = field.properties || {};
  var getValueByKey = seriesProps.getValueByKey && seriesProps.getValueByKey.bind(seriesProps);
  var otherProps = seriesProps.otherProps || {};
  var alternativeText = getValueByKey && getValueByKey('alternativeText');
  var subReport = getValueByKey && getValueByKey('subReport') || {};
  var customURL = getValueByKey && getValueByKey('customURL');
  var embeddedJavascript = getValueByKey && getValueByKey('embeddedJavascript');

  var textCellColor = getValueByKey && getValueByKey('color');
  var textColor = (0, _fp.getOr)({}, 'textColor', textCellColor);
  var cellColor = (0, _fp.getOr)({}, 'cellColor', textCellColor);

  return {
    fieldElement: field,
    fieldDataType: field.previewDataType,
    fieldFormatData: field.fieldFormatData,
    numberOfPointActions: field.numberOfPointActions,
    alternativeText: {
      rangePercent: alternativeText.rangePercent,
      rangeValue: alternativeText.rangeValue,
      value: alternativeText.value
    },

    textColors: textColor,
    textColor: {
      rangePercent: textColor.rangePercent,
      rangeValue: textColor.rangeValue,
      value: textColor.value
    },

    cellColors: cellColor,
    cellColor: {
      rangePercent: cellColor.rangePercent,
      rangeValue: cellColor.rangeValue,
      value: cellColor.value
    },
    customURL: customURL.url ? customURL : null,
    embeddedJavascript: embeddedJavascript.script ? embeddedJavascript : null,

    chartOptions: {
      chartType: otherProps.chartType,
      izLineDashStyle: otherProps.dashStyle,
      izLineWidth: otherProps.lineWidth
    },

    subReport: subReport.selectedReport ? subReport : null,
    showTotal: otherProps.showTotal, // sparkline
    axisOption: parseAxisOption(field, otherProps.axis),
    threshold: parseThresholdOption(field, otherProps.threshold),
    dynamicThresholds: parseThresholdOption(field, otherProps.dynamicThresholds),
    regression: parseRegressionOption(otherProps.regression)
  };
}

/**
 * Clean data with bottom percent
 * @param {number} percent
 * @param {Array<object>} data
 * @param {string} nameField
 * @param {string} valueField
 */
function processDataByBottomPercent(percent, data, nameField, valueField) {
  var sum = 0;
  var val = void 0;

  var sortedData = (0, _fp.sortBy)(function (item) {
    val = (0, _fp.get)(valueField, item);
    sum += val;
    return val;
  }, data);

  var totalBottomValue = (percent * sum / 100).toFixed(2);
  var counting = 0;
  var index = 0;
  var otherItems = [];
  var otherItem = void 0;

  // find items which need to replaced by other-item
  while (counting < totalBottomValue && index < sortedData.length) {
    otherItems.push(sortedData[index]);
    counting += (0, _fp.get)(valueField, sortedData[index]);
    index++;
  }

  if (counting > totalBottomValue) {
    counting -= (0, _fp.get)(valueField, otherItems.pop());
  }

  // do not have data for other-group
  if (!otherItems.length) {
    return {
      otherItems: null,
      otherItem: null,
      newData: data
    };
  }

  // other item info
  otherItem = (0, _fp.set)(nameField, 'Others', otherItem);
  otherItem = (0, _fp.set)(valueField, counting, otherItem);

  // remove item which is in other-group
  var newData = (0, _fp.remove)(function (item) {
    return !!(0, _fp.find)(function (otherItem) {
      return (0, _fp.get)(nameField, item) === (0, _fp.get)(nameField, otherItem);
    }, otherItems);
  }, data);

  newData.push(otherItem);

  return {
    otherItems: otherItems,
    otherItem: otherItem,
    newData: newData
  };
}

/**
 * Get name's parts
 * @param {object} field
 */
function getPartNames(field) {
  var fileNameAlias = (0, _fp.getOr)('', 'fieldNameAlias', field);
  return fileNameAlias.split(SEPARATOR_SIGN);
}

/**
 * Get name of field
 * @param {object} field
 */
function getName(field) {
  return (0, _fp.last)(getPartNames(field));
}

/**
 * Format value of Threshold for Data Time data type
 * @param {object} field
 * @param {object} thresholds
 */
function parseThresholdOption(field, thresholds) {
  var result = (0, _mobx.toJS)(thresholds);
  if (field.previewDataType === _Izenda5.DATA_TYPES.DATE_TIME) {
    (0, _fp.map)(function (threshold) {
      threshold.izValue = (0, _Izenda7.default)(field.fieldFormatData, threshold.izValue, false);
    }, result);
  }

  return result;
}

/**
 * Format value of Axis option for Data Time data type
 * @param {object} field
 * @param {object} axisOption
 */
function parseAxisOption(field, axisOption) {
  var result = (0, _mobx.toJS)(axisOption);

  if (field.previewDataType === _Izenda5.DATA_TYPES.DATE_TIME) {
    !!(0, _fp.get)('izStartingPoint', result) && (result.izStartingPoint = Date.parse((0, _Izenda7.default)(field.fieldFormatData, (0, _fp.get)('izStartingPoint', result), false)));
  }

  return result;
}

/**
 * Parse regression option value
 * @param {object} regression
 */
function parseRegressionOption(regression) {
  if ((0, _fp.isNil)(regression)) return regression;
  var result = (0, _mobx.toJS)(regression);
  result.dashStyle = _Izenda8.MappingValues.LINE_STYLE_VALUES[regression.dashStyle];
  return result;
}
module.exports = exports['default'];

/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(34);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// define CUSTOM_URL
// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesBuilderConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var CUSTOM_URL = {
  NAME: 'customURL',
  get CONTENT_DESCRIPTION() {
    return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_CUSTOM_URL_CONTENT_DESCRIPTION');
  },
  CONSTRAINTS: {
    URL: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_CUSTOM_URL_CONSTRAINTS_MESSAGE_URL_IS_REQUIRED');
        }
      }
    }
  },
  DEFAULT_VALUE: 'LINK_NEW_WINDOW',
  OPTIONS: {
    LINK_NEW_WINDOW: 'LINK_NEW_WINDOW',
    LINK_NEW_TAB: 'LINK_NEW_TAB',
    LINK_CURRENT_WINDOW: 'LINK_CURRENT_WINDOW'
  }
};
// define EMBEDDED_JAVASCRIPT
var EMBEDDED_JAVASCRIPT = {
  NAME: 'embeddedJavascript',
  get CONTENT_DESCRIPTION() {
    return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_EMBEDDED_JAVASCRIPT_CONTENT_DESCRIPTION');
  },
  CONSTRAINTS: {
    SCRIPT: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_EMBEDDED_JAVASCRIPT_MESSAGE_JAVASCRIPT_IS_REQUIRED');
        }
      }
    }
  }
};
// define SUB_REPORT
var SUB_REPORT = {
  NAME: 'subReport',
  get SUBREPORT_FILTER_TEXT() {
    return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_SUBREPORT_FILTER_TEXT');
  },
  TABLE_DEF: {
    fieldInCurrentReport: {
      key: 'fieldInCurrentReport',
      width: 240,
      get title() {
        return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_TABLE_DEF_FIELD_IN_CURRENT_REPORT');
      },
      sortable: false
    },
    fieldInSubReport: {
      key: 'fieldInSubReport',
      width: 240,
      get title() {
        return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_TABLE_DEF_FIELD_IN_SUB_REPORT');
      },
      sortable: false
    },
    deleteField: { key: 'deleteField', width: 20, sortable: false }
  },
  ERROR_MESSAGE: {
    get MULTIPLE_VALUE() {
      return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_ERRORS_MULTIPLE_VALUE');
    },
    get CANT_RESOLVE_FIELD() {
      return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_ERRORS_CANT_RESOLVE_FIELD');
    },
    get NEED_UPDATE_RESULT() {
      return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_ERRORS_NEED_UPDATE_RESOLVE');
    }
  },
  CONSTRAINTS: {
    REPORTS_CONSTRAINTS: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_CONSTRAINTS_REPORTS_IS_REQUIRED');
        }
      }
    },
    STYLE_CONSTRAINTS: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_CONSTRAINTS_STYLE_IS_REQUIRED');
        }
      }
    },
    REPORT_PART_USED_CONSTRAINTS: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_CONSTRAINTS_REPORT_PART_USED_IS_REQUIRED');
        }
      }
    },
    REQUIRED_CONSTRAINT: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
        }
      }
    }
  },
  ICON_TYPES: [{ value: 'iconLink01', icon: 'icon-link-01' }, { value: 'iconLink02', icon: 'icon-link-02' }, { value: 'iconLink03', icon: 'icon-link-03' }, { value: 'iconLink04', icon: 'icon-link-04' }, { value: 'iconLink05', icon: 'icon-link-05' }, { value: 'iconLink06', icon: 'icon-link-06' }, { value: 'iconLink07', icon: 'icon-link-07' }],
  DEFAULT_ICON: { value: 'iconLink01', icon: 'icon-link-01' },
  get UNCATEGORIZED() {
    return _Izenda2.default.getText('COMMON_LABEL_UNCATEGORIZED');
  },
  UNDEFINED: '00000000-0000-0000-0000-000000000000',
  ALL_OPTION: {
    get title() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    },
    id: 'All'
  },
  SUB_REPORT_GRID: {
    get DUPLICATE_ERROR_MESSAGE() {
      return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_DUPLICATE_MAPPING');
    },
    VALIDATOR_GROUP: 'Subreport'
  }
};
// define MESSAGE
var MESSAGE = {
  get COLUMN_GROUP_TOOLTIP() {
    return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_MESSAGE_COLUMN_GROUP_TOOLTIP');
  },
  get DUPLICATE_VIEW_SETTING() {
    return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_MESSAGE_DUPLICATE_VIEW_SETTING');
  },
  get EMBEDDED_LINK_SUB_REPORT() {
    return _Izenda2.default.getText('PROPERTIES_BUILDER_CONSTANTS_MESSAGE_EMBEDDED_LINK_SUB_REPORT');
  }
};
// define DEFAULT_PROPERTIES_VALUE
var DEFAULT_PROPERTIES_VALUE = {
  dataFormattings: {
    color: {
      textColor: {},
      defaultRangeObject: {
        rangePercent: null,
        rangeValue: null,
        value: null
      },
      cellColor: {}
    },
    alternativeText: {
      rangePercent: null,
      rangeValue: null,
      value: null
    },
    customURL: {
      url: '',
      get option() {
        return CUSTOM_URL.DEFAULT_VALUE;
      }
    },
    embeddedJavascript: {
      script: ''
    },
    subTotal: {
      label: '',
      function: '',
      expression: '',
      dataType: '',
      previewResult: '',
      levels: []
    },
    grandTotal: {
      label: '',
      function: '',
      expression: '',
      dataType: '',
      previewResult: '',
      format: {}
    }
  },
  drillDown: {
    subReport: {
      selectedReport: null,
      style: null,
      reportPartUsed: null,
      reportFilter: true,
      mappingFields: [],
      selectedIconValue: null,
      viewSettingByLink: null
    }
  }
};

exports.default = {
  // report-part > field properties > custom url
  CUSTOM_URL: CUSTOM_URL,
  // report-part > field properties > embedded script
  EMBEDDED_JAVASCRIPT: EMBEDDED_JAVASCRIPT,
  // report-part > field properties > sub report
  SUB_REPORT: SUB_REPORT,
  MESSAGE: MESSAGE,
  CHECK_UNIQ_OPTIONS: [CUSTOM_URL.NAME, EMBEDDED_JAVASCRIPT.NAME, SUB_REPORT.NAME],
  DEFAULT_PROPERTIES_VALUE: DEFAULT_PROPERTIES_VALUE
};
module.exports = exports['default'];

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Dimensions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Measure = __webpack_require__(852);

  var observable = __webpack_require__(5).observable;
  var action = __webpack_require__(5).action;
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      omit = _require.omit;

  function Dimensions(ComposedComponent) {
    var DimensionsComponent = React.createClass({
      displayName: String.format('Dimensions({0})', ComposedComponent.displayName),
      componentWillMount: function componentWillMount() {
        this.dim = observable({
          width: 0,
          height: 0
        });
      },
      render: function render() {
        var measureBeforeMount = this.props.measureBeforeMount;
        var rest = omit(['measureBeforeMount'], this.props);
        var width = this.dim.width;
        var height = this.dim.height;

        return React.createElement(
          Measure,
          { measureBeforeMount: measureBeforeMount, onChange: this.onChange },
          React.createElement(ComposedComponent, (0, _extends3.default)({}, rest, { width: width, height: height }))
        );
      },
      onChange: action(function changeDimension(width, height) {
        this.dim.width = width;
        this.dim.height = height;
      })
    });

    return observer(DimensionsComponent);
  }

  module.exports = Dimensions;
}();

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GRID_STYLES = {
  VERTICAL: {
    value: 'Vertical',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_VERTICAL');
    },
    className: 'vertical'
  },
  HORIZONTAL: {
    value: 'Horizontal',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_HORIZONTAL');
    },
    className: 'horizontal'
  },
  PIVOT: {
    value: 'Pivot',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_PIVOT');
    },
    className: 'pivot'
  },
  DRILL_DOWN: {
    value: 'Drilldown',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_DRILL_DOWN');
    },
    className: 'drill-down'
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ALTERNATIVE_BACKGROUND = {
  NONE: {
    value: 'None',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_NONE');
    }
  },
  COLUMNS: {
    value: 'Columns',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_COLUMNS');
    }
  },
  ROWS: {
    value: 'Rows',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_ROWS');
    }
  },
  COLUMNS_AND_ROWS: {
    value: 'Column and Rows',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_COLUMNS_AND_ROWS');
    }
  }
};
var CONTAINER_NAME = {
  COLUMNS: 'columns',
  ROWS: 'rows',
  SEPARATORS: 'separators',
  VALUES: 'values'
};
var FREEZE_HEADERS = {
  VERTICALLY: {
    value: 'vertically',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_VERTICALLY');
    }
  },
  HORIZONTALLY: {
    value: 'horizontally',
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_HORIZONTALLY');
    }
  }
};

exports.default = {
  FIELD_PROPERTY_CONFIG: {
    Vertical: {
      separators: {
        hideSubTotal: true,
        hideAllHeaderFormating: true
      }
    },
    Horizontal: {
      separators: {
        hideSubTotal: true,
        hideAllHeaderFormating: true
      }
    },
    Pivot: {
      columns: {
        hideSubTotal: true,
        hideConflitHeaderFormating: true
      },
      separators: {
        hideSubTotal: true,
        hideAllHeaderFormating: true
      },
      values: {
        hideColumnGroup: true
      }
    },
    Drilldown: {
      rows: {
        hideSubTotal: true
      },
      separators: {
        hideSubTotal: true,
        hideAllHeaderFormating: true
      }
    }
  },
  NUMBER_OF_PREVIEW_SEPARATOR: 2,
  GRID_STYLES: GRID_STYLES,
  ALTERNATIVE_BACKGROUND: ALTERNATIVE_BACKGROUND,
  FREEZE_HEADERS: FREEZE_HEADERS,
  CONTAINER_NAME: CONTAINER_NAME,
  MAX_ROW: 50,
  SEPARATOR_STYLE: {
    COMMA: {
      value: 'Comma',
      get label() {
        return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_COMMA');
      },
      className: 'comma',
      multiLevel: false,
      withLabel: false,
      multiLine: false
    },
    COMMA_WITH_LABEL: {
      value: 'CommaWithLabel',
      get label() {
        return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_COMMA_WITH_LABEL');
      },
      className: 'comma-label',
      multiLevel: false,
      withLabel: true,
      multiLine: false
    },
    LINE: {
      value: 'Line',
      get label() {
        return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_LINE');
      },
      className: 'line',
      multiLevel: false,
      withLabel: false,
      multiLine: true
    },
    LINE_WITH_LABEL: {
      value: 'LineWithLabel',
      get label() {
        return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_LINE_WITH_LABEL');
      },
      className: 'line-label',
      multiLevel: false,
      withLabel: true,
      multiLine: true
    },
    MULTI_LEVEL: {
      value: 'MultiLevel',
      get label() {
        return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_MULTI_LEVEL');
      },
      className: 'multi-level',
      multiLevel: true,
      withLabel: false,
      multiLine: false
    },
    MULTI_LEVEL_WITH_LABEL: {
      value: 'MultiLevelWithLabel',
      get label() {
        return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_MULTI_LEVEL_WITH_LABEL');
      },
      className: 'multi-level-label',
      multiLevel: true,
      withLabel: true,
      multiLine: false
    }
  },
  MAPPING_GRID_STYLE: [{
    fromStyle: GRID_STYLES.VERTICAL.value,
    toStyle: GRID_STYLES.HORIZONTAL.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.COLUMNS],
      toContainer: CONTAINER_NAME.ROWS
    }]
  }, {
    fromStyle: GRID_STYLES.VERTICAL.value,
    toStyle: GRID_STYLES.DRILL_DOWN.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.COLUMNS],
      toContainer: CONTAINER_NAME.ROWS
    }, {
      fromContainer: [CONTAINER_NAME.SEPARATORS],
      toContainer: CONTAINER_NAME.SEPARATORS
    }]
  }, {
    fromStyle: GRID_STYLES.VERTICAL.value,
    toStyle: GRID_STYLES.PIVOT.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.COLUMNS],
      toContainer: CONTAINER_NAME.ROWS
    }, {
      fromContainer: [CONTAINER_NAME.SEPARATORS],
      toContainer: CONTAINER_NAME.SEPARATORS
    }]
  }, {
    fromStyle: GRID_STYLES.HORIZONTAL.value,
    toStyle: GRID_STYLES.VERTICAL.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.ROWS],
      toContainer: CONTAINER_NAME.COLUMNS
    }]
  }, {
    fromStyle: GRID_STYLES.HORIZONTAL.value,
    toStyle: GRID_STYLES.PIVOT.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.ROWS],
      toContainer: CONTAINER_NAME.ROWS
    }, {
      fromContainer: [CONTAINER_NAME.SEPARATORS],
      toContainer: CONTAINER_NAME.SEPARATORS
    }]
  }, {
    fromStyle: GRID_STYLES.HORIZONTAL.value,
    toStyle: GRID_STYLES.DRILL_DOWN.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.ROWS],
      toContainer: CONTAINER_NAME.ROWS
    }, {
      fromContainer: [CONTAINER_NAME.SEPARATORS],
      toContainer: CONTAINER_NAME.SEPARATORS
    }]
  }, {
    fromStyle: GRID_STYLES.PIVOT.value,
    toStyle: GRID_STYLES.VERTICAL.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.COLUMNS, CONTAINER_NAME.ROWS, CONTAINER_NAME.VALUES],
      toContainer: CONTAINER_NAME.COLUMNS
    }]
  }, {
    fromStyle: GRID_STYLES.PIVOT.value,
    toStyle: GRID_STYLES.HORIZONTAL.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.COLUMNS, CONTAINER_NAME.VALUES],
      toContainer: CONTAINER_NAME.ROWS
    }]
  }, {
    fromStyle: GRID_STYLES.PIVOT.value,
    toStyle: GRID_STYLES.DRILL_DOWN.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.COLUMNS, CONTAINER_NAME.VALUES],
      toContainer: CONTAINER_NAME.ROWS
    }]
  }, {
    fromStyle: GRID_STYLES.DRILL_DOWN.value,
    toStyle: GRID_STYLES.VERTICAL.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.VALUES],
      toContainer: CONTAINER_NAME.COLUMNS
    }]
  }, {
    fromStyle: GRID_STYLES.DRILL_DOWN.value,
    toStyle: GRID_STYLES.HORIZONTAL.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.VALUES],
      toContainer: CONTAINER_NAME.ROWS
    }]
  }, {
    fromStyle: GRID_STYLES.DRILL_DOWN.value,
    toStyle: GRID_STYLES.PIVOT.value,
    mappings: [{
      fromContainer: [CONTAINER_NAME.ROWS, CONTAINER_NAME.VALUES],
      toContainer: CONTAINER_NAME.ROWS
    }]
  }],
  GRID_STYLES_CONSTANT_PROPERTIES: {
    Pivot: [{
      key: CONTAINER_NAME.COLUMNS,
      properties: {
        addSideTotal: false,
        useExpanders: false
      }
    }, {
      key: CONTAINER_NAME.ROWS,
      properties: {
        useExpanders: false
      }
    }]
  },
  MESSAGES: {
    get SEPARATOR_CONFIRM() {
      return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_MESSAGE_SEPARATOR_CONFIRM');
    },
    get FUNCTION_INCONSISTENT() {
      return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_MESSAGE_FUNCTION_INCONSISTENT');
    },
    get M07() {
      return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_MESSAGE_CHANGE_FUNCTION_TYPE');
    }
  },
  DEFAULT_VALUE_PROPERTIES: {
    TABLE: {
      ALTERNATIVE_BACKGROUND: 'None',
      ALTERNATIVE_BACKGROUND_COLOR: '#EFEFEF'
    },
    COLUMNS: {
      WIDTH: {
        VALUE: 150,
        UNIT: 'Pixels'
      },
      WORDWRAP: false,
      ALIGNMENT: 'left',
      VERTICAL_ALIGNMENT: 'middle'
    },
    ROWS: {
      HEIGHT: 40
    },
    HEADERS: {
      FONT: {
        FAMILY: 'Roboto',
        SIZE: 14,
        COLOR: '#000000',
        BACKGROUND_COLOR: '#E4E4E4',
        BOLD: true,
        ITALIC: false,
        UNDERLINE: false
      },
      DISPLAY: 'inline-block',
      ALIGNMENT: 'center',
      VERTICAL_ALIGNMENT: 'middle',
      WORDWRAP: false
    }
  },
  MAXIMUM_FIELD: {
    PIVOT: {
      LABEL: 3,
      VALUE: 3
    }
  },
  DEFAULT_CELL_STYLE: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  EMPTY_CELL_BACKGROUND_COLOR: '#FFF',
  MAX_LENGTH_PREVIEW_TITLE: 256,
  get TITTLE_SETTINGS_TOOLTIP() {
    return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_TITTLE_SETTINGS_TOOLTIP');
  },
  get DESCRIPTION_SETTING_TOOLTIP() {
    return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_DESCRIPTION_SETTING_TOOLTIP');
  },
  RECORDS_MAX_LENGTH: 50,
  DEFAULT_SETTING_VALUE: {
    refreshIntervalDefault: {
      enable: false,
      isAll: true,
      latestRecord: 0,
      updateInterval: 0
    },
    border: {
      top: {
        color: null,
        dashStyle: null,
        thinkness: null
      },
      right: {
        color: null,
        dashStyle: null,
        thinkness: null
      },
      bottom: {
        color: null,
        dashStyle: null,
        thinkness: null
      },
      midVer: {
        color: null,
        dashStyle: null,
        thinkness: null
      },
      left: {
        color: null,
        dashStyle: null,
        thinkness: null
      },
      midHor: {
        color: null,
        dashStyle: null,
        thinkness: null
      }
    }
  },
  COLLAPSE_STATUS: {
    COLLAPSE: -1,
    EXPAND: 1,
    DEFAULT: 0
  }
};
module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// ----------------------------------------------------------------------
// <copyright file="Izenda.VisualTypeMapping.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  //izenda-value                //highchart-value
  Line: 'izendaLine',
  Column: 'column',
  Bar: 'bar',
  Area: 'izendaArea',
  Pie: 'pie',
  Funnel: 'funnel',
  Donut: 'donut',
  TreeMap: 'treemap',
  Combination: 'combination',
  HeatMap: 'heatmap',
  Bubble: 'bubble',
  Scatter: 'scatter',
  Waterfall: 'waterfall',
  Sparkline: 'sparkline',

  SolidGauge: 'izendaSolidGauge',
  LinearGauge: 'izendaLinearGauge',
  SimpleGauge: 'izendaSimpleGauge',
  Map: 'map'
};
module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor; // ----------------------------------------------------------------------
// <copyright file="Izenda.IconMenu.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * IconMenu component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(153);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var IconMenu = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(IconMenu, _Component);

  function IconMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IconMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isExpanded', _descriptor, _this), _this.handleClick = function () {
      _Izenda2.default.toggleIconMenu();
      _Izenda2.default.toggleMiddelPanel(false);
      _Izenda2.default.toggleSideBar();

      _this.isExpanded = !_this.isExpanded;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IconMenu, [{
    key: 'render',
    value: function render() {
      var iconClasses = (0, _classnames2.default)({
        'izenda-NavIcon': true,
        expanded: this.isExpanded,
        collapsed: !this.isExpanded
      });

      return _react2.default.createElement(
        'a',
        {
          className: (0, _classnames2.default)(['izenda-IconMenu', this.props.className]),
          onClick: this.handleClick,
          'aria-expanded': 'false'
        },
        _react2.default.createElement(
          'div',
          { className: iconClasses },
          _react2.default.createElement('span', null),
          _react2.default.createElement('span', null),
          _react2.default.createElement('span', null),
          _react2.default.createElement('span', null),
          _react2.default.createElement('span', null),
          _react2.default.createElement('span', null)
        )
      );
    }
  }]);
  return IconMenu;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isExpanded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class;

exports.default = IconMenu;
module.exports = exports['default'];

/***/ }),
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (pattern, value, isFormatted, inputFormat) {
  pattern = pattern || _Izenda2.DEFAULT_FORMAT_PATTERN;

  if ((0, _fp.isNil)(value)) {
    return null;
  }

  if (value === '') {
    return '';
  }

  // For special case, pattern = 'Day of Week'
  // Start day of Week in momentjs = 0 but in BE it will be 1
  // Currently, only 'en' is loaded into moment package.
  if (pattern === 'Day of Week') {
    var dow = parseInt(value);
    if (!(0, _fp.isNaN)(dow)) {
      if (dow >= 1 && dow <= 7) {
        value = (0, _fp.nth)(value, _Izenda2.DAY_OF_WEEK_VALUES);
      }
    }
  }

  var dataTime = '';
  var momentDateTime = void 0;
  var outputFormat = (0, _fp.getOr)(_Izenda4.default.currentUser.dateFormat, 'MOMENT_OUTPUT', _Izenda2.DATE_TIME_FORMAT[pattern]);

  if ((0, _fp.isDate)(value)) {
    momentDateTime = (0, _moment2.default)(value);
  } else if (inputFormat) {
    momentDateTime = (0, _moment2.default)(value, inputFormat);
  } else {
    var patternGroupBy = (0, _fp.get)('GROUP_BY', _Izenda2.DATE_TIME_FORMAT[pattern]);
    var groupByInputFormat = (0, _fp.get)('GROUP_BY_EXPECTED_FORMAT', _Izenda2.GROUP_BY[patternGroupBy]);
    momentDateTime = (0, _moment2.default)(value, groupByInputFormat ? [groupByInputFormat, _Izenda.DATE_TIME_FORMAT] : _Izenda.DATE_TIME_FORMAT);
    !momentDateTime.isValid() && (momentDateTime = (0, _moment2.default)(value, _Izenda.DATE_TIME_FORMAT_WITH_TIMEZONE));
  }

  // special case for day, we don't want to moment js to  use current month,
  // because current month may have only 28 day
  // forcing all case to make sure it will convert to same month if return date object for chart
  if (pattern === 'Day' && ((0, _fp.isString)(value) && /^\d{1,2}$/.test(value) || (0, _fp.isNumber)(value))) {
    momentDateTime = (0, _moment2.default)().startOf('year').date(value);
  }

  if (isFormatted === false) {
    // return date object
    return momentDateTime.toDate();
  }
  dataTime = momentDateTime.isValid() ? momentDateTime.format(outputFormat) : value;

  return dataTime;
};

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda = __webpack_require__(115);

var _Izenda2 = __webpack_require__(176);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ConvertToDatimeFormat.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];
/**
 *
 * @param pattern
 * @param value
 * @param isFormatted
 * @param inputFormat
 * @returns {*}
 */

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* List of operator group */
var OPERATOR_GROUP = {
  UNKNOWN: '...',
  BOOLEAN: 'boolean',
  COMPARISON: 'comparison',
  DATETIME: 'date&time',
  EQUIVALENCE: 'equivalence',
  FIELDCOMPARISON: 'fieldcomparison',
  STRING: 'string'
};

/* List of operator group based on data-type*/
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterDetailsConfigConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var OPERATER_BY_DATA_TYPE = {
  numeric: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.COMPARISON, OPERATOR_GROUP.EQUIVALENCE, OPERATOR_GROUP.FIELDCOMPARISON],
  datetime: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.COMPARISON, OPERATOR_GROUP.EQUIVALENCE, OPERATOR_GROUP.FIELDCOMPARISON, OPERATOR_GROUP.DATETIME],
  time: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.COMPARISON, OPERATOR_GROUP.EQUIVALENCE, OPERATOR_GROUP.FIELDCOMPARISON, OPERATOR_GROUP.DATETIME],
  text: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.COMPARISON, OPERATOR_GROUP.EQUIVALENCE, OPERATOR_GROUP.FIELDCOMPARISON, OPERATOR_GROUP.STRING],
  boolean: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE, OPERATOR_GROUP.FIELDCOMPARISON, OPERATOR_GROUP.BOOLEAN],
  money: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.COMPARISON, OPERATOR_GROUP.EQUIVALENCE, OPERATOR_GROUP.FIELDCOMPARISON],
  lob: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE],
  xml: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE],
  json: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE],
  image: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE]
};

var DATA_TYPE = {
  NUMBER: 'Numeric',
  DATE: 'Datetime',
  TEXT: 'Text',
  MONEY: 'Money',
  TIME: 'Time'
};

exports.default = {
  DEFAUFT_OPERATOR_GROUP: {
    numeric: OPERATOR_GROUP.EQUIVALENCE,
    datetime: OPERATOR_GROUP.DATETIME,
    text: OPERATOR_GROUP.EQUIVALENCE,
    boolean: OPERATOR_GROUP.EQUIVALENCE,
    money: OPERATOR_GROUP.EQUIVALENCE,
    time: OPERATOR_GROUP.DATETIME,
    image: OPERATOR_GROUP.EQUIVALENCE,
    lob: OPERATOR_GROUP.EQUIVALENCE,
    json: OPERATOR_GROUP.EQUIVALENCE,
    xml: OPERATOR_GROUP.EQUIVALENCE
  },

  BLANK_NULL_OPERATOR: ['image', 'lob', 'json', 'xml'],

  OPERATOR_GROUP: OPERATOR_GROUP,

  OPERATER_BY_DATA_TYPE: OPERATER_BY_DATA_TYPE,

  OPERATOR: {
    UNKNOWN: '...',
    BLANK: 'blank',
    NOTBLANK: 'notblank',
    NULL: 'null',
    NOTNULL: 'notnull'
  },

  /* define [sourceType] which is used to select which API is called for different group/operator (used in field-store) */
  OPERATOR_VALUE_SOURCE: {
    fieldcomparison: 'fieldSource',
    equivalence: {
      'equals(checkbox)': 'dataSource',
      'notequal(checkbox)': 'dataSource',
      'equals(popup)': 'dataSource',
      'notequal(popup)': 'dataSource',
      'equals(tree)': 'dataSourceTree',
      'notequal(tree)': 'dataSourceTree',
      'equals(manualentry)': 'dataSource',
      'equals(manualentrynoauto-complete)': 'dataSource',
      'notequal(manualentry)': 'dataSource',
      'notequal(manualentrynoauto-complete)': 'dataSource',
      'equals(selection)': 'dataSource',
      'notequal(selection)': 'dataSource'
    },
    'date&time': 'inTimePeriod'
  },

  CONSTRAINTS: {
    presence: false
  },

  CONSTRAINTS_NAME: 'value',

  REGEX: {
    DATETIMEFORMAT: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4} (0[0-9]|1[0-9]|2[0-3])\:(0[0-9]|[1-5][0-9])$/,
    NUMBER: /^-?\d+\.?\d*$/,
    INT_NUMBER: /^\d*$/,
    TIME: /^\d+$/
  },

  DATA_TYPE: DATA_TYPE,

  SELECT_SETTINGS: {
    SINGLE: 'single',
    MULTIPLE: 'multiple'
  },
  get SELECT_TEXT() {
    return {
      get SINGLE() {
        return _Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_SINGLE_SELECTION');
      },
      get MULTIPLE() {
        return _Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_MULTIPLE_SELECTION');
      }
    };
  },
  get SELECT_MODE() {
    return {
      get SINGLE() {
        return _Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_LABEL_SINGLE');
      },
      get MULTIPLE() {
        return _Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_LABEL_MULTIPLE');
      }
    };
  },
  DEFAUFT_VALUE: {
    ALL: '[ALL]',
    BLANK: '[BLANK]',
    NULL: '[NULL]'
  },

  get ERROR_MESSAGE_BY_DATA_TYPE() {
    return {
      Money: _Izenda2.default.getText('COMMON_MESSAGES_FORMAT_NUMBER'),
      Numeric: _Izenda2.default.getText('COMMON_MESSAGES_FORMAT_NUMBER'),
      Datetime: _Izenda2.default.getText('COMMON_MESSAGES_FORMAT_DATE'),
      Time: _Izenda2.default.getText('COMMON_MESSAGES_FORMAT_TIME')
    };
  },

  get ERROR_MESSAGE() {
    return {
      M01: _Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_MESSAGE_FILTER_ALIAS_EXISTS')
    };
  },

  OPERATOR_VALUE_LIST: ['Blank', 'Not Blank', 'Null', 'Not Null', 'True', 'False'],

  OPERATOR_NAMES: ['...', 'Blank', 'Not Blank', 'Null', 'Not Null', 'True', 'False'],

  BLANK_VALUE_LIST: ['...', 'Blank', 'Not Blank', 'Null', 'Not Null'],

  get DEFAUFT_OPERATOR_LABEL() {
    return _Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_LABEL_EQUALS');
  },

  SHOW_MODE_OPERATOR: ['equals(manualentry)', 'equals(manualentrynoauto-complete)', 'notequal(manualentry)', 'notequal(manualentrynoauto-complete)', 'equals(selection)', 'notequal(selection)'],

  NO_AUTOCOMPLETE_OPERATOR: ['equals(manualentrynoauto-complete)', 'notequal(manualentrynoauto-complete)'],

  SORT_TYPE: {
    ASC: 'ASC',
    DESC: 'DESC'
  },

  OPERATOR_GROUP_KEYS: {
    BOOLEAN: 'Boolean'
  },

  OPERATOR_KEYS: ['Blank', 'Not Blank', 'Null', 'Not Null'],

  EXCLUDE_FILTER_DATA_TYPE: {
    SYS_REFCURSOR: 'SYS_REFCURSOR',
    REF_CURSOR: 'REF CURSOR'
  },
  MAX_HEIGHT: 85,

  PARAM_OPERATOR_BY_DATA_TYPE: {
    Datetime: ['equals(date&time)', 'equals(date)', 'equals(manualentry)', 'equals(manualentrynoauto-complete)', 'equals(selection)'],
    Time: ['equals(time)', 'equals(manualentry)', 'equals(manualentrynoauto-complete)', 'equals(selection)']
  },

  HIDDEN_DATA_TYPE: ['REF CURSOR', 'SYS CURSOR']
};
module.exports = exports['default'];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda3 = __webpack_require__(247);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(207);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'report/';
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Designer Data Fetcher.
 */

var FUSION_URL = 'fusion/';

var getRequestForm = function getRequestForm(reportKey) {
  return {
    reportKey: {
      key: reportKey
    }
  };
};

var fetchers = {
  /**
   * Get all categories
   * @param {string} saveAsType
   * @param {string} tenantId
   * @param {boolean} isGlobal
   * @param {boolean} loadVisible
   * @returns {promise}
   */
  loadCategories: function loadCategories(saveAsType, tenantId, isGlobal, loadVisible) {
    (0, _fp.isNil)(tenantId) && (tenantId = '');
    (0, _fp.isNil)(isGlobal) && (isGlobal = false);
    (0, _fp.isNil)(loadVisible) && (loadVisible = false);
    return (0, _Izenda2.default)(ROOT_URL + 'category/' + saveAsType + '/' + tenantId + '?isGlobal=' + isGlobal + '&loadVisible=' + loadVisible).get();
  },


  /**
   * Get all sub-categories
   * @param {string} categoryId
   * @param {boolean} loadVisible
   * @returns {promise}
   */
  loadSubCategories: function loadSubCategories(categoryId, loadVisible) {
    (0, _fp.isNil)(loadVisible) && (loadVisible = false);
    return (0, _Izenda2.default)(ROOT_URL + 'subcategory/' + categoryId + '?loadVisible=' + loadVisible).get();
  },


  /**
   * Get query source
   * @param {string} reportId
   * @returns {promise}
   */
  loadQuerySource: function loadQuerySource(reportId) {
    var data = {
      tenantId: _IzendaUiState2.default.getTenantId(),
      reportKey: {
        key: reportId
      }
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadDataSourceCategory').post(data);
  },


  /**
   * Load query sources
   * @param {string} querySources
   * @param {any} pageInfo
   * @param {string} reportId
   * @returns {any}
   */
  loadQuerySources: function loadQuerySources(querySources, pageInfo, reportId) {
    pageInfo = pageInfo || {};

    var requestData = {
      objectId: reportId,
      querySources: querySources,
      tenantId: _IzendaUiState2.default.getTenantId(),
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{
        key: 'name',
        descending: true
      }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadQuerySources').post(requestData);
  },


  /**
   * Save report designer
   * @param {any} data
   * @returns {promise}
   */
  saveReportDesigner: function saveReportDesigner(data) {
    return (0, _Izenda2.default)(ROOT_URL).post(data);
  },


  /**
   * Save draft report designer
   * @param {any} data
   * @returns {promise}
   */
  saveDaftReportDesigner: function saveDaftReportDesigner(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'draft').post(data);
  },


  /**
   * Validate report name
   * @param {any} data
   * @returns {promise}
   */
  validateReportName: function validateReportName(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateReportName').post(data);
  },


  /**
   * Validate report id
   * @param {string} reportId
   * @returns {promise}
   */
  validateReportId: _Izenda4.default.memoize(function (reportId) {
    return (0, _Izenda2.default)(ROOT_URL + 'isReportValid/' + reportId).get();
  }),

  /**
   * Validate report id
   * @param {string} reportId
   * @returns {promise}
   */
  validateReportIdNoCache: function validateReportIdNoCache(reportId, fromDesigner) {
    return (0, _Izenda2.default)(ROOT_URL + 'isReportValid/' + reportId + '?fromdesigner=' + fromDesigner).get();
  },

  /**
   * Validate relationships
   * @param {any} data
   * @returns {promise}
   */
  validateRelationships: function validateRelationships(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateRelationships').post(data);
  },


  /**
   * Validate cycle relationship
   * @param {any} data
   */
  validateCycleRelationships: function validateCycleRelationships(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateCycleRelationships').post(data);
  },


  /**
   * Validate relationships syntax
   * @param {any} data
   * @returns {promise}
   */
  validateRelationshipSyntax: function validateRelationshipSyntax(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateRelationshipSyntax').post(data);
  },


  /**
   * Validate simple mode relationships
   * @param {any} data
   * @returns {promise}
   */
  validateSimpleModeRelationship: function validateSimpleModeRelationship(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateSimpleModeRelationship').post(data);
  },


  /**
   * Filter section: load filter source
   * @param {any} data
   */
  loadFilterSource: function loadFilterSource(data) {
    if (!data) {
      return (0, _bluebird.resolve)([]);
    }

    if ((0, _fp.isString)(data)) {
      data = getRequestForm(data);
    } else {
      // Remove report key when data is report definition
      data.reportKey.key = null;
    }

    return (0, _Izenda2.default)(ROOT_URL + 'loadFilterDataSource').post(data);
  },


  /**
   * Filter section: load filter of certain report
   * @param {string} reportKey
   */
  loadFilterOfReport: function loadFilterOfReport(reportKey) {
    if (!reportKey) {
      return (0, _bluebird.resolve)({});
    }
    return (0, _Izenda2.default)(ROOT_URL + 'loadFilter').post(getRequestForm(reportKey));
  },


  /**
   * Get list of operator group and its operators
   */
  loadFilterOperatorGroup: _Izenda4.default.memoize(function () {
    return (0, _Izenda2.default)(ROOT_URL + 'filter/operators').get();
  }, { persistent: true }),

  /**
   * Get relationship list
   * @param {string} reportId
   * @param {string} querySources
   * @param {any} pageInfo
   * @param {Array<any>} relationshipOrders
   * @param {boolean} selectedDataSourceChanged
   * @returns {promise}
   */
  getRelationships: function getRelationships(reportId, querySources, pageInfo, relationshipOrders, selectedDataSourceChanged) {
    pageInfo = pageInfo || {};

    var requestData = {
      objectId: reportId,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: 1000,
      querySources: querySources,
      relationshipOrders: relationshipOrders,
      tenantId: _IzendaUiState2.default.getTenantId(),
      selectedDataSourceChanged: !!selectedDataSourceChanged
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadRelationships/').post(requestData);
  },


  /**
   * Get data for middle panel of Fields
   * @param {any} data
   * @returns {promise}
   */
  availableQuerySourceFields: function availableQuerySourceFields(data, isLoadDraft) {
    if ((0, _fp.isString)(data)) {
      data = getRequestForm(data);
    } else {
      // Remove report key when data is report definition
      data.reportKey.key = null;
    }

    data.loadDraft = isLoadDraft;
    if (data) {
      return (0, _Izenda2.default)(ROOT_URL + 'availableQuerySourceFields').post(data);
    }
    return (0, _bluebird.resolve)([]);
  },


  /**
   * Get report mode
   * @param {string} reportId
   * @returns {promise}
   */
  getReportMode: function getReportMode(reportId) {
    var id = reportId ? reportId : '';

    return (0, _Izenda2.default)(ROOT_URL + 'reportMode/' + id).get();
  },


  /**
   * Validate type of filters of subreport
   * @param {string} reportId
   * @param {string} masterReportId
   * @param {boolean} inheritFilter
   * @returns {promise}
   */
  validateFilterFieldsTypeSubReport: function validateFilterFieldsTypeSubReport(reportId, masterReportId, inheritFilter) {
    var id = reportId ? reportId : '';
    var url = 'validateFilterFieldsType/' + id;
    !!masterReportId && (url += '?masterReportId=' + masterReportId + '&inheritMasterReportFilter=' + inheritFilter);

    return (0, _Izenda2.default)(ROOT_URL + url).get();
  },


  /**
   * Validate logic syntax of filters.
   * @param {string} syntax
   * @param {Array<any>} filterIndexes
   * @param {Array<any>} filterFields
   * @returns {promise}
   */
  validateFilterSyntax: function validateFilterSyntax(syntax, filterIndexes, filterFields) {
    var requestData = {
      Syntax: syntax,
      AvailableFilter: filterIndexes,
      filterFields: filterFields
    };

    return (0, _Izenda2.default)(ROOT_URL + 'validateFilterSyntax/').post(requestData);
  },


  /**
   * Validate type of filter field
   * @param {any} data
   * @returns {promise}
   */
  validateFilterFieldsType: function validateFilterFieldsType(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateFilterFieldsType/').post(data);
  },


  /**
   * Cancel all the modifications in report, it will delete temporary reportKey and back to the previous
   * @param {string} reportKey
   * @returns {promise}
   */
  cancelReportChanges: function cancelReportChanges(reportKey) {
    var data = {
      reportKey: {
        key: reportKey
      }
    };
    return (0, _Izenda2.default)(ROOT_URL + 'cancel').post(data);
  },


  /**
   * Validate Report Designer
   * @param {any} data
   * @returns {promise}
   */
  validate: function validate(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validate/').post(data);
  },


  /**
   * Load list field for compare field dropdown list.
   * @param {string} reportKey
   * @param {string} dataType
   * @returns {promise}
   */
  loadFilterDataSource: function loadFilterDataSource(reportKey, dataType) {
    var requestData = {
      reportKey: {
        key: reportKey
      },
      dataType: dataType
    };
    return (0, _Izenda2.default)(ROOT_URL + 'loadFilterComparisonFields/').post(requestData);
  },


  /** Load list time periods
   * @returns {promise}
   */
  loadTimeperiods: _Izenda4.default.memoize(function () {
    return (0, _Izenda2.default)(ROOT_URL + 'filter/timeperiods/').get();
  }, { persistent: true }),

  /**
   * Load filter field data
   * @param {any} filterDetails
   * @param {boolean} byTree
   *        TRUE  data is grouped by tree
   *        FALSE data is rended by array
   * @returns {array}
   */
  loadFilterFieldData: function loadFilterFieldData(filterDetails, byTree) {
    var url = byTree ? 'loadFilterFieldDataAsTree' : 'loadFilterFieldData';

    return (0, _Izenda2.default)(ROOT_URL + url).post(filterDetails);
  },


  /**
   * Load partial filter field data
   * @param  {any} filterDetails
   * @return {promise}
   */
  loadPartialFilterFieldData: function loadPartialFilterFieldData(filterDetails) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadPartialFilterFieldData').post(filterDetails);
  },


  /**
   * Load list of data format of filter properties (based on data-type of field)
   * @param {string} dataType
   * @returns {promise}
   */
  loadFilterDataFormat: function loadFilterDataFormat(dataType) {
    if (!dataType) {
      return (0, _bluebird.resolve)([]);
    }
    return (0, _Izenda2.default)(ROOT_URL + 'filter/dataFormat/' + dataType).get();
  },


  /**
   * Load report function
   * @param {number} functionMode
   * @param {string} dataFormatType
   * @param {string} tenatId
   * @param {string} querySourceIds
   * @returns {promise}
   */
  loadReportFunction: function loadReportFunction(functionMode, dataFormatType, tenatId, querySourceIds) {
    functionMode = functionMode || '0';

    // querySourceIds can be nil or must be an array
    ensure((0, _fp.isNil)(querySourceIds) || (0, _fp.isArray)(querySourceIds), 'querySourceIds must be an array');

    var params = (0, _fp.compact)(['function', functionMode, dataFormatType, tenatId]);

    if (!dataFormatType) {
      return (0, _bluebird.resolve)([]);
    }

    return (0, _Izenda2.default)(ROOT_URL + params.join('/')).post({
      querySourceIds: querySourceIds
    });
  },


  /**
   * Load list of data format of filter properties (based on data-type of field)
   * @param {string} dataFormatType
   * @returns {promise}
   */
  loadReportFieldDataFormat: function loadReportFieldDataFormat(dataFormatType) {
    if (!dataFormatType) {
      return (0, _bluebird.resolve)([]);
    }

    return (0, _Izenda2.default)(ROOT_URL + ['field/dataFormat', dataFormatType].join('/')).get();
  },


  /**
   * Load list of available reports by tenant and category
   * @param {string} tenantId
   * @returns {promise} List reports
   */
  loadReports: function loadReports(tenantId) {
    var id = tenantId || '';
    return (0, _Izenda2.default)(ROOT_URL + 'allReports/' + id).get();
  },


  /**
   * Load Report data
   * @param {string} reportKey
   * @returns {promise} report data
   */
  loadForEdit: function loadForEdit(reportKey) {
    var isLoadDraft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var needValidateDataSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var increaseView = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!reportKey) {
      return (0, _bluebird.resolve)({});
    }

    var requestData = getRequestForm(reportKey);
    requestData.loadDraft = isLoadDraft;
    if (!needValidateDataSource) {
      requestData.validateReportDataSource = needValidateDataSource;
    }
    // TODO : edit later
    if (increaseView) {
      requestData.increaseView = increaseView;
    }

    return (0, _Izenda2.default)(ROOT_URL + 'loadforedit').post(requestData);
  },


  /**
   * Add calculated field and return added one
   * @param data
   * @returns {promise}
   */
  addCalculatedField: function addCalculatedField(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'calculatedfield').post(data);
  },


  /**
   * Delete calculated field
   * @param data
   * @returns {promise}
   */
  deleteReportCalculatedField: function deleteReportCalculatedField(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'deleteReportCalculatedField').post(data);
  },


  /**
   * Check if this calculated field is used in existing report
   * @param {string} fieldId
   * @returns {promise}
   */
  hasReportUseCalculatedField: function hasReportUseCalculatedField(fieldId) {
    return (0, _Izenda2.default)(ROOT_URL + 'hasReportUseCalculatedField/' + fieldId).get();
  },


  /**
   * Get preview data
   * @param {any} data
   * @returns {promise}
   */
  getPreviewData: function getPreviewData(data) {
    return (0, _Izenda2.default)(FUSION_URL + 'loadData').post(data);
  },


  /**
   * Get preview data of report part
   * @param {any} data
   * @returns {promise}
   */
  getConfigReportPartPreviewData: function getConfigReportPartPreviewData(data) {
    return (0, _Izenda2.default)(FUSION_URL + 'reportPartPreview').post(data);
  },


  /**
   * Get random preview data by expanded level
   * @param {any} data
   * @returns {promise}
   */
  getRandomPreviewData: function getRandomPreviewData(data) {
    return (0, _Izenda2.default)(FUSION_URL + 'retrieveRandomExpandedLevelData').post(data);
  },


  /**
   * Validate calculated field
   * @param {any} model
   * @returns {promise}
   */
  validateFieldExpression: function validateFieldExpression(model) {
    return (0, _Izenda2.default)(FUSION_URL + 'validateExpression').post(model);
  },


  /**
   * Validate SubTotal Expression
   * @param  {any} model
   * @return {promise}
   */
  validateSubTotalExpression: function validateSubTotalExpression(model) {
    return (0, _Izenda2.default)(FUSION_URL + 'validateSubTotalExpression').post(model);
  },


  /**
   * Validate Grand Total Expression
   * @param  {any} model
   * @return {promise}
   */
  validateGrandTotalExpression: function validateGrandTotalExpression(model) {
    return (0, _Izenda2.default)(FUSION_URL + 'validateGrandTotalExpression').post(model);
  },


  /**
   * Detect change when save/save draft report
   * @param {any} data
   * @returns {promise}
   */
  detectReportChange: function detectReportChange(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'detectReportChange').post(data);
  },


  /**
   * Preview result of calculated field in DataSource
   * @param {any} data
   * @returns {string} preview result
   */
  previewDSCalculatedField: function previewDSCalculatedField(data) {
    return (0, _Izenda2.default)(FUSION_URL + 'previewCalculatedField').post(data);
  },


  /**
   * Preview result of calculated field in Grand Total
   * @param {any} data
   * @returns {promise}
   */
  previewGrandTotal: function previewGrandTotal(data) {
    return (0, _Izenda2.default)(FUSION_URL + 'previewGrandTotal').post(data);
  },


  /**
   * Preview result of calculated field in Sub Total
   * @param {any} data
   * @returns {promise}
   */
  previewSubTotal: function previewSubTotal(data) {
    return (0, _Izenda2.default)(FUSION_URL + 'previewSubTotal').post(data);
  },


  /**
   * Check relationship is used in report or not
   * @param {string} relationshipId
   * @returns {promise}
   */
  hasReportUseRelationship: function hasReportUseRelationship(relationshipId) {
    var relationship = (0, _fp.isNil)(relationshipId) ? '' : relationshipId;
    return (0, _Izenda2.default)(ROOT_URL + 'hasReportUseRelationship/' + relationship).get();
  },


  /**
   * Fetch definition of report part.
   * @param  {string} id
   * @param  {string} reportId
   * @returns {promise}
   */
  loadReportPartDefinition: _Izenda4.default.memoize(function (id, reportId, page) {
    var url = ROOT_URL + 'reportPart/' + id;
    if (reportId) {
      url += '/' + reportId;
    }
    if (!(0, _fp.isNil)(page)) {
      url += '?page=' + page;
    }
    return (0, _Izenda2.default)(url).get();
  }, {
    resolver: function resolver() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (0, _fp.compact)(args).join('_');
    }
  }),

  /**
   * Update result
   * @param  {any} data
   * @returns {promise}
   */
  updateResults: function updateResults(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'updateResults/').post(data);
  },


  /**
   * Load access priority
   * @param {string} id
   * @returns {promise}
   */
  accessPriority: function accessPriority(id) {
    return (0, _Izenda2.default)(ROOT_URL + 'accessPriority/' + id).get();
  },


  /**
   * Load Partial DataSource Category
   * @param {any} data
   * @returns {promise}
   */
  loadPartialDataSourceCategory: function loadPartialDataSourceCategory(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadPartialDataSourceCategory').post(data);
  },


  /**
   * Load data source field
   * @param {any} data
   */
  loadDataSourceFields: function loadDataSourceFields(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadDataSourceFields').post(data);
  },


  /**
   * Load original query source from relationship id
   * @param {any} data
   * @return {promise}
   */
  loadJoinQuerySourceByRelationship: function loadJoinQuerySourceByRelationship(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadJoinQuerySourceByRelationship').post(data);
  },

  /**
   * Load related query sources
   * @param  {data}
   * @return {promise}
   */
  loadRelatedQuerySources: function loadRelatedQuerySources(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadRelatedQuerySources').post(data);
  },


  /**
   * Load Dynamic Data Source Category
   * @param  {any} data
   * @return {promise}
   */
  loadDynamicDataSourceCategory: function loadDynamicDataSourceCategory(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadDynamicDataSourceCategory').post(data);
  }
};

_Izenda6.default.linkToLoadingProgress(fetchers, {
  saveReportDesigner: {
    allowToCancel: false
  },

  saveDaftReportDesigner: {
    allowToCancel: false
  },

  addCalculatedField: {
    allowToCancel: false
  },
  deleteReportCalculatedField: {
    allowToCancel: false
  }
});

exports.default = fetchers;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REPORT_LIST_CONCAT_TREE_MAP = [{
  prop: 'subCategories',
  showTotal: false,
  defaultName: 'UNSUBCATEGORIZED',
  children: [{
    prop: 'reports',
    showTotal: false
  }]
}]; // ----------------------------------------------------------------------
// <copyright file="Izenda.CopyManagementConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

var DATE_MODEL_CONCAT_TREE_MAP = [{
  prop: 'querySources',
  showTotal: true,
  children: [{
    prop: 'Tables',
    showTotal: true,
    disabledIfNoChild: true,
    children: [{
      prop: 'items',
      showTotal: false
    }]
  }, {
    prop: 'Functions',
    showTotal: true,
    disabledIfNoChild: true,
    children: [{
      prop: 'items',
      showTotal: false
    }]
  }, {
    prop: 'Views',
    showTotal: true,
    disabledIfNoChild: true,
    children: [{
      prop: 'items',
      showTotal: false
    }]
  }, {
    prop: 'StoredProcedures',
    showTotal: true,
    disabledIfNoChild: true,
    children: [{
      prop: 'items',
      showTotal: false
    }]
  }]
}];

exports.default = {
  get DEFAULT_WORKSPACE_NAME() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_DEFAULT_WORKSPACE_NAME');
  },
  WORKSPACE_NAME: 'workspaceName',
  get UNKNOWN_STATUS() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_UNKNOWN_STATUS');
  },
  WORKSPACE_NAME_MAX_LENGTH: 150,

  get WORKSPACE_NAME_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_WORKSPACE_NAME_CONSTRAINT_PRESENCE')
      },
      length: {
        maximum: 150,
        message: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_WORKSPACE_NAME_CONSTRAINT_LENGTH')
      }
    };
  },
  get DESTINATION_CONSTRAINTS() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_DESTINATION_CONSTRAINT')
      }
    };
  },
  get systemSource() {
    return {
      id: '00000000-0000-0000-0000-000000000000',
      name: _Izenda2.default.getText('COMMON_LABEL_SYSTEM')
    };
  },
  get M01() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_CONFIRM_DELETE_WORKSPACE');
  },
  get M11() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_CONFIRM_DELETE_TENANT');
  },
  get TABLE_DESTINATION_DEFINITION() {
    return {
      tenantName: {
        key: 'tenantName',
        columnKey: 'tenantName',
        width: 80,
        title: _Izenda2.default.getText('COMMON_LABEL_TENANT'),
        sortable: true
      },
      status: {
        key: 'status',
        columnKey: 'status',
        width: 80,
        title: _Izenda2.default.getText('COMMON_LABEL_STATUS'),
        sortable: true
      },
      action: {
        key: 'status',
        columnKey: 'action',
        width: 100,
        align: 'center',
        title: _Izenda2.default.getText('COMMON_LABEL_ACTION'),
        sortable: false,
        fixed: true
      }
    };
  },
  get STATUS_OF_DESTINATION() {
    return {
      '0': {
        status: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_NEED_VALIDATION'),
        class: 'need-validated',
        iconClass: '',
        iconOkClass: ''
      },
      '1': {
        status: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_READY_TO_COPY'),
        class: 'ready-to-copy',
        iconClass: '',
        iconOkClass: 'ready-to-copy'
      },
      '2': {
        status: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_MISSING_AUTHEN'),
        class: 'authentication-missing',
        iconClass: 'icon-info-circled',
        iconOkClass: 'ready-to-copy'
      },
      '3': {
        status: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_VALIDATION_ERROR'),
        class: 'validation-error',
        iconClass: 'icon-info-circled',
        iconOkClass: 'icon-disabled'
      },
      NEED_VALIDATION: 0,
      READY_TO_COPY: 1,
      AUTHENTICATION_MISSION: 2,
      VALIDATION_ERROR: 3
    };
  },
  get VALIDATION_ERROR_TOOLTIP() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_VALIDATION_ERROR_TOOLTIP');
  },
  get COPY_MANAGEMENT_OBJECT_TOOLTIP() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_OBJECT_TOOLTIP');
  },
  get SAVE_WORKSPACE_CONSTRAINTS() {
    return {
      NAME: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_SAVE_WORKSPACE_CONSTRAINTS_NAME')
        }
      },
      OWNER: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_SAVE_WORKSPACE_CONSTRAINTS_OWNER')
        }
      },
      WORKSPACE_NAME: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_SAVE_WORKSPACE_CONSTRAINTS_WORKSPACE_NAME')
        }
      }
    };
  },
  get TABLE_DEF() {
    return {
      GLOBAL_MAPPING: {
        fromDatabaseName: {
          key: 'fromDatabaseName',
          columnKey: 'fromDatabaseName',
          width: 170,
          title: _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_TABLE_DEF_GLOBAL_MAPPING_FROM_DB_NAME')
        },
        type: { key: 'type', columnKey: 'type', width: 150, title: _Izenda2.default.getText('COMMON_LABEL_TYPE') },
        fromObject: {
          key: 'fromObject',
          columnKey: 'fromObject',
          width: 150,
          title: _Izenda2.default.getText('COMMON_LABEL_OBJECT')
        },
        toDatabaseName: {
          key: 'toDatabaseName',
          columnKey: 'toDatabaseName',
          width: 150,
          title: _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_TABLE_DEF_GLOBAL_MAPPING_TO_DB_NAME')
        },
        toObject: {
          key: 'toObject',
          columnKey: 'toObject',
          width: 150,
          title: _Izenda2.default.getText('COMMON_LABEL_OBJECT'),
          infoIconOptions: {
            iconClass: 'icon-info-circled',
            iconTitle: _Izenda2.default.getText('COPY_MANAGEMENT_OBJECT_TOOLTIP')
          }
        },
        tenant: {
          key: 'workspaceMappingTenants',
          columnKey: 'workspaceMappingTenants',
          width: 200,
          title: _Izenda2.default.getText('COMMON_LABEL_TENANT')
        },
        action: {
          width: 70,
          fixed: true,
          align: 'center',
          title: _Izenda2.default.getText('COMMON_LABEL_ACTION'),
          className: 'align-bottom'
        }
      },
      TENANT_MAPPING: {
        fromDatabaseName: {
          key: 'fromDatabaseName',
          columnKey: 'fromDatabaseName',
          width: 170,
          title: _Izenda2.default.getText('COMMON_LABEL_DATA_SOURCE')
        },
        type: { key: 'type', columnKey: 'type', width: 150, title: _Izenda2.default.getText('COMMON_LABEL_TYPE') },
        fromObject: {
          key: 'fromObject',
          columnKey: 'fromObject',
          width: 150,
          title: _Izenda2.default.getText('COMMON_LABEL_OBJECT')
        },
        toDatabaseName: {
          key: 'toDatabaseName',
          columnKey: 'toDatabaseName',
          width: 150,
          title: _Izenda2.default.getText('COMMON_LABEL_DATA_SOURCE')
        },
        toObject: {
          key: 'toObject',
          columnKey: 'toObject',
          width: 150,
          title: _Izenda2.default.getText('COMMON_LABEL_OBJECT'),
          infoIconOptions: {
            iconClass: 'icon-info-circled',
            iconTitle: _Izenda2.default.getText('COPY_MANAGEMENT_OBJECT_TOOLTIP')
          }
        },
        action: {
          width: 70,
          fixed: true,
          align: 'center',
          title: _Izenda2.default.getText('COMMON_LABEL_ACTION'),
          className: 'align-bottom'
        }
      }
    };
  },
  DESTINATION_SORT_DIR: {
    version: 'DESC'
  },
  get MAPPING_HEADER() {
    return {
      GLOBAL: _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_MAPPING_HEADER_GLOBAL'),
      TENANT: _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_MAPPING_HEADER_TENANT'),
      ALL_MAPPING_TOOLTIP: _Izenda2.default.getText('COPY_MANAGEMENT_ALL_MAPPING_TOOLTIP'),
      MERGE_DUPLICATE_TOOLTIP: _Izenda2.default.getText('COPY_MANAGEMENT_MERGE_DUPLICATE_TOOLTIP'),
      SPECIFIC_MAPPING_TOOLTIP: _Izenda2.default.getText('COPY_MANAGEMENT_SPECIFIC_MAPPING_TOOLTIP')
    };
  },
  get REQUIRE_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED')
      }
    };
  },
  get MAPPING_TYPES() {
    return [{ label: _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_MAPPING_TYPE_SCHEMA'), value: 1 }, { label: _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_MAPPING_TYPE_DATABASE'), value: 2 }];
  },
  MAPPING_TYPE: {
    Schema: 1,
    Database: 2
  },

  DETECTED_CHANGE_LEVEL: {
    NONE: 0,
    ADDED: 1,
    MODIFIED: 2
  },
  get CONSISTENT_DATA_MODEL() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_CONSISTENT_DATA_MODEL');
  },
  get INCONSISTENT_DATA_MODEL() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_INCONSISTENT_DATA_MODEL');
  },
  get CHANGED_DATA_TYPE() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_CHANGED_DATA_TYPE');
  },
  get DELETED_DATA_SOURCE() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_DELETED_DATA_SOURCE');
  },

  APPROVAL_LEVEL: {
    PENDING: 0,
    QUERY_SOURCE: 1,
    QUERY_SOURCE_FIELD: 2
  },
  TENANT_TOKEN: '@TenantID',
  TENANT_NAME_TOKEN: '@TenantName',
  get OVERRIDE_CONFIRMATION() {
    return {
      MG01: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_OVERRIDE_CONFIRMATION_HAVING_SETUP'),
      MG02: _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_OVERRIDE_CONFIRMATION_SELECT_TO_OVERWRITTEN')
    };
  },
  DATETIME_FORMAT: 'MM/dd/yyyy HH:mm:ss tt',
  get RUN_COPY_SUCCESS() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_COPY_PROCESS_DONE');
  },
  get COPY_FILTER_LOOKUP_MESSAGE() {
    return _Izenda2.default.getText('COPY_MANAGEMENT_MESSAGE_COPY_FILTER_LOOKUP');
  },
  CONCURRENCY_ERROR: {
    SOURCE: 1,
    DESTINATION: 2
  },
  MODULE_ANCHORS: {
    DATA_MODEL_SETTING: 'DataModelSetting',
    ROLE_SETTING: 'RoleSetting',
    ROLE_PERMISSION_SETTING: 'RolePermissionSetting'
  },
  NODE_TYPE: {
    STORE_PROCEDURE: 'Stored Procedure',
    FUNCTION: 'Function',
    TABLE: 'Table',
    VIEW: 'View'
  },
  REPORT_LIST_CONCAT_TREE_MAP: REPORT_LIST_CONCAT_TREE_MAP,
  REPORT_LIST_TREE_MAP: [{
    prop: 'all',
    showTotal: false,
    children: [{
      prop: 'categories',
      showTotal: false,
      defaultName: 'UNCATEGORIZED',
      children: REPORT_LIST_CONCAT_TREE_MAP
    }]
  }],
  DATE_MODEL_CONCAT_TREE_MAP: DATE_MODEL_CONCAT_TREE_MAP,
  DATE_MODEL_TREE_MAP: [{
    prop: 'connections',
    showTotal: false,
    children: DATE_MODEL_CONCAT_TREE_MAP
  }],
  SOURCE_TYPE_DEFINITIONS: [{
    CollectionKey: 'Tables',
    Key: 'Table',
    totalChildrenKey: 'totalTableChildNodes',
    numOfCheckedChildren: 'totalTableCheckedNodes'
  }, {
    CollectionKey: 'Views',
    Key: 'View',
    totalChildrenKey: 'totalViewChildNodes',
    numOfCheckedChildren: 'totalViewCheckedNodes'
  }, {
    CollectionKey: 'StoredProcedures',
    Key: 'Stored Procedure',
    totalChildrenKey: 'totalStoredProcedureChildNodes',
    numOfCheckedChildren: 'totalStoredProcedureCheckedNodes'
  }, {
    CollectionKey: 'Functions',
    Key: 'Function',
    totalChildrenKey: 'totalFunctionChildNodes',
    numOfCheckedChildren: 'totalFunctionCheckedNodes'
  }]
};
module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

var ACCESS_MODE = {
  REPORT: 0,
  DASHBOARD: 1,
  TENANT: 2
};

var USER_ACCESS_MODE = {
  ACCESS: 1,
  SCHEDULE: 2
};

exports.default = {
  get DEFAULT_VALUE() {
    return {
      SEARCH_CRITERIA: 'All',
      SORT_DIRS: {
        shareWith: 'DESC'
      }
    };
  },
  get ACCESS_TABLE_DEF() {
    return {
      selected: {
        key: 'selected',
        width: 30,
        title: '',
        sortable: false,
        columnKey: 'selected ',
        fixed: true,
        align: 'center'
      },
      shareWith: {
        key: 'shareWith',
        width: 300,
        title: _Izenda2.default.getText('ACCESS_CONSTANT_ACCESS_TABLE_DEF_SHARE_WITH'),
        sortable: true,
        columnKey: 'shareWith'
      },
      accessRight: {
        key: 'accessRight',
        width: 150,
        title: _Izenda2.default.getText('ACCESS_CONSTANT_ACCESS_TABLE_DEF_ACCESS_RIGHT'),
        sortable: true,
        columnKey: 'accessRight',
        fixed: true
      },
      actions: {
        key: 'actions',
        width: 80,
        title: _Izenda2.default.getText('COMMON_LABEL_ACTION'),
        sortable: false,
        columnKey: 'actions',
        fixed: true,
        align: 'center'
      }
    };
  },
  get SEARCH_OPTIONS() {
    return [{ value: 'All', label: _Izenda2.default.getText('COMMON_LABEL_ALL') }, { value: 'shareWith', label: _Izenda2.default.getText('ACCESS_CONSTANT_LABEL_SEARCH_OPTION_SHARE_WITH') }, { value: 'accessRight', label: _Izenda2.default.getText('ACCESS_CONSTANT_LABEL_SEARCH_OPTION_ACCESS_RIGHT') }];
  },
  get ASSIGNED_TYPE() {
    return [{ value: 1, label: _Izenda2.default.getText('ACCESS_CONSTANT_LABEL_ASSIGNED_TYPE_EVERYONE') }, { value: 2, label: _Izenda2.default.getText('COMMON_LABEL_ROLE') }, { value: 3, label: _Izenda2.default.getText('ACCESS_CONSTANT_LABEL_ASSIGNED_TYPE_USER') }];
  },
  COMPONENT_CONFIG: {
    1: null,
    2: {
      component: __webpack_require__(1996),
      props: {
        usingPopup: true,
        valueField: 'id',
        textField: 'name'
      }
    },
    3: {
      component: __webpack_require__(418),
      props: {
        useSearchName: true,
        usingPopup: true,
        valueField: 'id',
        textField: 'name',
        userModeType: 1,
        useEmailInOptions: true
      }
    }
  },
  get CONSTRAINTS() {
    return {
      SHARE_WITH: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED')
        }
      },
      ACCESS_RIGHT: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCESS_CONSTANT_CONSTRAINT_ACCESS_RIGHT')
        }
      },
      USER: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCESS_CONSTANT_CONSTRAINT_USER')
        }
      },
      ROLE: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCESS_CONSTANT_CONSTRAINT_ROLE')
        }
      },
      REPORT_OWNER: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCESS_CONSTANT_CONSTRAINT_REPORT_OWNER')
        }
      },
      DASHBOARD_OWNER: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('ACCESS_CONSTANT_CONSTRAINT_DASHBOARD_OWNER')
        }
      }
    };
  },
  get MESSAGE() {
    return {
      M01a: _Izenda2.default.getText('ACCESS_CONSTANT_MESSAGE_CONFIRM_DELETE_SHARED_INSTANCE'),
      M01b: _Izenda2.default.getText('ACCESS_CONSTANT_MESSAGE_CONFIRM_DELETE_SELECTED_SHARED_INSTANCES'),
      M02a: _Izenda2.default.getText('ACCESS_CONSTANT_MESSAGE_CONFIRM_DELETE_DEFAULT_ACCESS_RIGHT'),
      M02b: _Izenda2.default.getText('ACCESS_CONSTANT_MESSAGE_CONFIRM_DELETE_SELECTED_DEFAULT_ACCESS_RIGHT'),
      REMOVE_ROLE: _Izenda2.default.getText('ACCESS_CONSTANT_MESSAGE_REMOVE_ROLES'),
      REMOVE_USER: _Izenda2.default.getText('ACCESS_CONSTANT_MESSAGE_REMOVE_USERS'),
      REMOVE_DASHBOARD_USER: _Izenda2.default.getText('DASHBOARD_CONSTANT_MESSAGE_REMOVE_USERS'),
      REMOVE_DASHBOARD_ROLE: _Izenda2.default.getText('DASHBOARD_CONSTANT_MESSAGE_REMOVE_ROLES')
    };
  },
  get PERMISSION_ACCESS_TABLE_DEF() {
    return {
      selected: {
        key: 'selected',
        width: 30,
        title: '',
        sortable: false,
        columnKey: 'selected ',
        fixed: true,
        align: 'center'
      },
      shareWith: {
        key: 'shareWith',
        width: 200,
        get title() {
          return _Izenda2.default.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_SHARE_WITH');
        },
        sortable: true,
        columnKey: 'shareWith'
      },
      reportAccessRightId: {
        key: 'reportAccessRight',
        width: 200,
        get title() {
          return _Izenda2.default.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_REPORT_ACCESS_RIGHT');
        },
        sortable: true,
        columnKey: 'reportAccessRights',
        fixed: true
      },
      dashboardAccessRightId: {
        key: 'dashboardAccessRight',
        width: 200,
        get title() {
          return _Izenda2.default.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_DASHBOARD_ACCESS_RIGHT');
        },
        sortable: true,
        columnKey: 'dashboardAccessRights',
        fixed: true
      },
      actions: {
        key: 'actions',
        width: 80,
        get title() {
          return _Izenda2.default.getText('COMMON_LABEL_ACTION');
        },
        sortable: false,
        columnKey: 'actions',
        fixed: true,
        align: 'center'
      }
    };
  },
  get PERMISSION_SEARCH_OPTIONS() {
    return [{ value: 'All', label: _Izenda2.default.getText('COMMON_LABEL_ALL') }, { value: 'shareWith', label: _Izenda2.default.getText('ACCESS_CONSTANT_LABEL_PERMISSION_SEARCH_OPTION_SHARE_WITH') }, {
      value: 'reportAccessRights',
      label: _Izenda2.default.getText('ACCESS_CONSTANT_LABEL_PERMISSION_SEARCH_OPTION_REPORT_ACCESS_RIGHT')
    }, {
      value: 'dashboardAccessRights',
      label: _Izenda2.default.getText('ACCESS_CONSTANT_LABEL_PERMISSION_SEARCH_OPTION_DASHBOARD_ACCESS_RIGHT')
    }];
  },
  get ACCESS_MODE() {
    return ACCESS_MODE;
  },
  get BUTTON() {
    return {
      ADD_SHARING_LABEL: _Izenda2.default.getText('ACCESS_CONSTANT_LABEL_ADD_SHARING'),
      ADD_DEFAULT_ACCESS: _Izenda2.default.getText('ACCESS_CONSTANT_LABEL_ADD_DEFAULT_ACCESS')
    };
  },
  get USER_ACCESS_MODE() {
    return USER_ACCESS_MODE;
  },
  get ACCESS_DEFAULT_GRID() {
    return {
      assignedTypeName: {
        key: 'assignedTypeName',
        width: 150,
        get title() {
          return _Izenda2.default.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_SHARE_WITH');
        },
        sortable: true,
        columnKey: 'assignedTypeName ',
        fixed: true
      },
      accessorNames: {
        key: 'accessorNames',
        width: 340,
        get title() {
          return _Izenda2.default.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_SHARING_SELECTION');
        },
        sortable: true,
        columnKey: 'accessorNames',
        fixed: true
      },
      reportAccessRights: {
        key: 'reportAccessRights',
        width: 180,
        get title() {
          return _Izenda2.default.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_REPORT_ACCESS_RIGHT');
        },
        sortable: true,
        columnKey: 'reportAccessRights',
        fixed: true
      },
      dashboardAccessRights: {
        key: 'dashboardAccessRights',
        width: 200,
        get title() {
          return _Izenda2.default.getText('ACCESS_CONSTANT_PERMISSION_ACCESS_TABLE_DEF_DASHBOARD_ACCESS_RIGHT');
        },
        sortable: true,
        columnKey: 'dashboardAccessRights'
      }
    };
  },
  ASSIGN_TYPE: {
    ALL: 1,
    ROLE: 2,
    USER: 3
  }
};
module.exports = exports['default'];

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FUNCTION_NAME = {
  NONE: '',
  EXPRESSION: '[Expression]',
  DEFAULT: 'Default',
  AVERAGE: 'Average',
  COUNT: 'Count',
  COUNT_DISTINCT: 'Count Distinct',
  MAXIMUM: 'Maximum',
  MINIMUM: 'Minimum',
  SUM: 'Sum',
  SUM_DISTINCT: 'Sum Distinct'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  get DATA_TYPES() {
    return [
    // { lable, value, functions for data type values, can change to data types }
    {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_NUMERIC'),
      value: 'Numeric',
      functions: [FUNCTION_NAME.NONE, FUNCTION_NAME.EXPRESSION, FUNCTION_NAME.DEFAULT, FUNCTION_NAME.AVERAGE, FUNCTION_NAME.COUNT, FUNCTION_NAME.COUNT_DISTINCT, FUNCTION_NAME.MAXIMUM, FUNCTION_NAME.MINIMUM, FUNCTION_NAME.SUM, FUNCTION_NAME.SUM_DISTINCT],
      toDataTypes: ['Text', 'Boolean', 'Money', 'Lob']
    }, {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_DATETIME'),
      value: 'Datetime',
      functions: [FUNCTION_NAME.NONE, FUNCTION_NAME.EXPRESSION, FUNCTION_NAME.COUNT, FUNCTION_NAME.COUNT_DISTINCT, FUNCTION_NAME.MAXIMUM, FUNCTION_NAME.MINIMUM],
      toDataTypes: ['Numeric', 'Text', 'Boolean', 'Money', 'Lob']
    }, {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_TEXT'),
      value: 'Text',
      functions: [FUNCTION_NAME.NONE, FUNCTION_NAME.EXPRESSION, FUNCTION_NAME.COUNT, FUNCTION_NAME.COUNT_DISTINCT, FUNCTION_NAME.MAXIMUM, FUNCTION_NAME.MINIMUM],
      toDataTypes: ['Numeric', 'Datetime', 'Image', 'Boolean', 'Money', 'Lob']
    }, {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_IMAGE'),
      value: 'Image',
      functions: [],
      toDataTypes: ['Lob']
    }, {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_BOOLEAN'),
      value: 'Boolean',
      functions: [FUNCTION_NAME.NONE, FUNCTION_NAME.EXPRESSION, FUNCTION_NAME.AVERAGE, FUNCTION_NAME.COUNT, FUNCTION_NAME.COUNT_DISTINCT, FUNCTION_NAME.SUM, FUNCTION_NAME.SUM_DISTINCT],
      toDataTypes: ['Numeric', 'Text', 'Money', 'Lob']
    }, {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_MONEY'),
      value: 'Money',
      functions: [FUNCTION_NAME.NONE, FUNCTION_NAME.EXPRESSION, FUNCTION_NAME.DEFAULT, FUNCTION_NAME.AVERAGE, FUNCTION_NAME.COUNT, FUNCTION_NAME.COUNT_DISTINCT, FUNCTION_NAME.MAXIMUM, FUNCTION_NAME.MINIMUM, FUNCTION_NAME.SUM, FUNCTION_NAME.SUM_DISTINCT],
      toDataTypes: ['Numeric', 'Datetime', 'Text', 'Boolean', 'Lob']
    }, {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_LABEL_DATA_TYPES_LOB'),
      value: 'Lob',
      functions: [],
      toDataTypes: ['Datetime', 'Image', 'Boolean', 'Money']
    }];
  },
  get FUNCTIONS() {
    return [{ label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_NONE'), value: FUNCTION_NAME.NONE }, {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_EXPRESSION'),
      value: FUNCTION_NAME.EXPRESSION
    }, { label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_DEFAULT'), value: FUNCTION_NAME.DEFAULT }, { label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_AVERAGE'), value: FUNCTION_NAME.AVERAGE }, { label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_COUNT'), value: FUNCTION_NAME.COUNT }, {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_COUNT_DISTINCT'),
      value: FUNCTION_NAME.COUNT_DISTINCT
    }, { label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_MAXIMUM'), value: FUNCTION_NAME.MAXIMUM }, { label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_MINIMUM'), value: FUNCTION_NAME.MINIMUM }, { label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_SUM'), value: FUNCTION_NAME.SUM }, {
      label: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_NAME_SUM_DISTINCT'),
      value: FUNCTION_NAME.SUM_DISTINCT
    }];
  },
  FUNCTION_NAME: FUNCTION_NAME,
  TYPES: {
    ADD: {
      get title() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_ADD_TITLE');
      },
      get name() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_ADD_NAME');
      },
      enableValidateDataType: false
    },
    EDIT: {
      get title() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_EDIT_TITLE');
      },
      get name() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_EDIT_NAME');
      },
      enableValidateDataType: false
    },
    GRAND_TOTAL: {
      get title() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_GRAND_TOTAL_TITLE');
      },
      get name() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_GRAND_TOTAL_NAME');
      },
      get functionLabel() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_GRAND_TOTAL_FUNCTION_LABEL');
      },
      enableValidateDataType: true,
      grandTotalProperties: 'grandTotal'
    },
    SUB_TOTAL: {
      get title() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_SUB_TOTAL_TITLE');
      },
      get name() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_SUB_TOTAL_NAME');
      },
      get functionLabel() {
        return _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_SUB_TOTAL_FUNCTION_LABEL');
      },
      enableValidateDataType: true,
      subTotalProperties: 'subTotal'
    }
  },
  EXPRESSION_EXAMPLE: 'COUNT([FieldName1]) + SUM([FieldName2])',
  COLUMN_NAME_CONSTRAINT: function COLUMN_NAME_CONSTRAINT(name) {
    return {
      presence: {
        presence: true,
        message: name + _Izenda2.default.getText('COMMON_REQUIRE_CONSTRAINT')
      }
    };
  },
  EXPRESSION_CONSTRAINT: function EXPRESSION_CONSTRAINT(disabledExpression) {
    if (!disabledExpression) return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_EXPRESSION_CONSTRAINT')
      }
    };
  },

  get EXPRESSION_SELECTION_TABS() {
    return {
      fieldName: {
        title: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_TITLE_EXPRESSION_SELECTION_TABS_FIELD_NAME'),
        tabkey: 'fieldName'
      },
      functionOperator: {
        title: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_TITLE_EXPRESSION_SELECTION_TABS_FUNCTION_OPERATOR'),
        tabkey: 'functionOperator'
      }
    };
  },

  get FIELD_NAME() {
    return {
      instruction: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FIELD_NAME_INSTRUCTION'),
      dataSourceLabel: _Izenda2.default.getText('COMMON_LABEL_DATA_SOURCE'),
      enableDataSource: true
    };
  },

  get FUNCTION_OPERATOR() {
    return {
      instruction: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_OPERATOR_INSTRUCTION')
    };
  },

  get TABLE_DEFINITION() {
    return {
      FieldName: {
        fieldName: {
          columnKey: 'name',
          title: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_TABLE_DEFINITION_FIELD_NAME_FIELD_NAME'),
          sortable: true,
          width: 150
        },
        dataType: {
          columnKey: 'dataType',
          title: _Izenda2.default.getText('COMMON_LABEL_DATA_TYPE'),
          sortable: true,
          width: 150
        },
        description: {
          columnKey: 'description',
          title: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_TABLE_DEFINITION_FIELD_NAME_DESCRIPTION'),
          sortable: true,
          width: 160
        }
      },
      FunctionOperator: {
        name: {
          columnKey: 'name',
          title: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_TABLE_DEFINITION_FUNCTION_OPERATOR_NAME'),
          sortable: true,
          width: 230
        },
        syntax: {
          columnKey: 'syntax',
          title: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_TABLE_DEFINITION_FUNCTION_OPERATOR_SYNTAX'),
          sortable: true,
          width: 230
        }
      }
    };
  },
  get MESSAGES() {
    return {
      M01: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_DELETE_CALCULATED_FIELD'),
      M02: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_DELETE_CALCULATED_FIELD_REPORT_PART'),
      M04: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_RESULT_CANNOT_FORMATED'),
      DUPLICATE_NAME: _Izenda2.default.getText('CALCULATED_FIELD_CONSTANTS_MESSAGE_DUPLICATE_NAME')
    };
  },
  VALIDATION_FIELD_NAME: 'columnName',
  VALIDATION_SUB_TOTAL_FIELD_NAME: 'name',
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  VALIDATION_DATA_TYPE: 'izendaDataType'
};
module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

// ----------------------------------------------------------------------
// <copyright file="Izenda.Paginator.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1820);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(208);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda7 = __webpack_require__(1821);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _bluebird = __webpack_require__(18);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _fp = __webpack_require__(1);

var _Izenda9 = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SMALL_WIDTH = 325;

var Paginator = (_dec = (0, _Izenda2.default)(_Izenda8.default), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(Paginator, _Component);

  function Paginator() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Paginator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Paginator.__proto__ || (0, _getPrototypeOf2.default)(Paginator)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'paginatorStatus', _descriptor, _this), _this._onClickFirst = function () {
      var totalPage = _this.props.totalPage;

      if (totalPage > 0) {
        _this.goTo(1);
      }
    }, _this._onClickLast = function () {
      var totalPage = _this.props.totalPage;

      if (totalPage > 0) {
        _this.goTo(totalPage);
      }
    }, _this._onClickNext = function () {
      var _this$props = _this.props,
          pageIndex = _this$props.pageIndex,
          totalPage = _this$props.totalPage;


      if (pageIndex < totalPage) {
        _this.goTo(pageIndex + 1);
      }
    }, _this._onClickPrev = function () {
      var pageIndex = _this.props.pageIndex;


      if (pageIndex > 1) {
        _this.goTo(pageIndex - 1);
      }
    }, _this._onPageNumberChange = function (e) {
      _this.paginatorStatus.pageIndexInputVal = e.target.value;
    }, _this._onKeyPress = function (e) {
      if (e.key === 'Enter') {
        var page = parseInt(e.target.value, 10) || 1;
        var totalPage = _this.props.totalPage;


        _this.paginatorStatus.pageIndexInputVal = page;

        if (page >= 1 && page <= totalPage) {
          _this.goTo(page);
        }
      }
    }, _this._onDropdownChange = function (obj) {
      var _this2 = _this,
          props = _this2.props;


      return props.confirmDirtyForm(props.isDirty && props.isDirty()).then(function () {
        return _bluebird2.default.resolve(props.onDropdownChange(parseInt(obj.value, 10))).then(function () {
          _this.paginatorStatus.pageIndexInputVal = 1;
        });
      });
    }, _this.setDomNode = function (component) {
      _this.domNode = component;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Paginator, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pageIndex = nextProps.pageIndex;

      if (pageIndex) {
        this.paginatorStatus.pageIndexInputVal = pageIndex;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListener();
    }

    /**
     * Go to specific page
     * @param {Number} page
     */

  }, {
    key: 'goTo',
    value: function goTo(page) {
      var _this3 = this;

      var props = this.props,
          pageIndex = this.props.pageIndex;


      props.confirmDirtyForm(props.isDirty && props.isDirty()).then(function () {
        if (page !== pageIndex) {
          _bluebird2.default.resolve(props.onChange(page)).then(function () {
            _this3.paginatorStatus.pageIndexInputVal = page;
          });
        }
      });
    }
  }, {
    key: 'addListener',
    value: function addListener() {
      var _this4 = this;

      this.domNode && _Izenda6.default.listenTo(this.domNode, function (element) {
        if (element.clientWidth < SMALL_WIDTH) {
          !_this4.paginatorStatus.isSmall && (_this4.paginatorStatus.isSmall = true);
        } else {
          _this4.paginatorStatus.isSmall && (_this4.paginatorStatus.isSmall = false);
        }
      });
    }
  }, {
    key: 'removeListener',
    value: function removeListener() {
      this.domNode && _Izenda6.default.removeAllListeners(this.domNode);
    }
  }, {
    key: 'renderNoRecordFound',
    value: function renderNoRecordFound() {
      var _props = this.props,
          localization = _props.localization,
          className = _props.className;

      var classes = this.getPaginatorClass(className);
      return _react2.default.createElement(
        'nav',
        { className: classes },
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_MESSAGES_NO_RECORD_FOUND')
        )
      );
    }

    /**
     * Get class name for navigate buttons
     * @param {Boolean} isForwardButtons
     */

  }, {
    key: 'getButtonsClassName',
    value: function getButtonsClassName(isForwardButtons) {
      var _props2 = this.props,
          currentPage = _props2.pageIndex,
          totalPage = _props2.totalPage;


      return (0, _classnames2.default)({
        disabled: currentPage === (isForwardButtons ? totalPage : 1)
      });
    }
  }, {
    key: 'getPaginatorClass',
    value: function getPaginatorClass(className) {
      return (0, _classnames2.default)('paginator', className);
    }
  }, {
    key: 'renderPaging',
    value: function renderPaging() {
      var _props3 = this.props,
          localization = _props3.localization,
          totalPage = _props3.totalPage,
          canChangePageSize = _props3.canChangePageSize,
          beginRecord = _props3.beginRecord,
          endRecord = _props3.endRecord,
          className = _props3.className,
          totalRecords = _props3.totalRecords;

      var classes = this.getPaginatorClass(className);
      var isSmall = this.paginatorStatus.isSmall;


      var PAGINATOR_ITEMS_PER_PAGE_TEXT = !canChangePageSize || isSmall ? localization.getText('PAGINATOR_WITHOUT_ITEMS_PER_PAGE') : localization.getText('PAGINATOR_ITEMS_PER_PAGE');

      var itemPerPagesText = String.format(PAGINATOR_ITEMS_PER_PAGE_TEXT, beginRecord, endRecord, totalRecords);

      return _react2.default.createElement(
        'nav',
        { className: classes, ref: this.setDomNode },
        _react2.default.createElement(
          'div',
          null,
          itemPerPagesText,
          !isSmall && canChangePageSize && this.renderItemPerPageControl()
        ),
        _react2.default.createElement(
          'div',
          { className: 'paginate' },
          isSmall && canChangePageSize && this.renderItemPerPageControl(),
          _react2.default.createElement(
            'a',
            { onClick: this._onClickFirst, className: this.getButtonsClassName(false) },
            _react2.default.createElement('i', { className: 'icon-step-backward' })
          ),
          _react2.default.createElement(
            'a',
            { onClick: this._onClickPrev, className: this.getButtonsClassName(false) },
            _react2.default.createElement('i', { className: 'icon-triangle-left' })
          ),
          _react2.default.createElement('input', {
            type: 'text',
            pattern: '[0-9]*',
            value: this.paginatorStatus.pageIndexInputVal,
            onChange: this._onPageNumberChange,
            onKeyPress: this._onKeyPress
          }),
          '/',
          totalPage,
          _react2.default.createElement(
            'a',
            { onClick: this._onClickNext, className: this.getButtonsClassName(true) },
            _react2.default.createElement('i', { className: 'icon-triangle-right' })
          ),
          _react2.default.createElement(
            'a',
            { onClick: this._onClickLast, className: this.getButtonsClassName(true) },
            _react2.default.createElement('i', { className: 'icon-step-forward' })
          )
        )
      );
    }
  }, {
    key: 'getPageSizeOptions',
    value: function getPageSizeOptions(values) {
      return (0, _fp.map)(function (val) {
        return { value: val };
      }, values);
    }
  }, {
    key: 'renderItemPerPageControl',
    value: function renderItemPerPageControl() {
      var _props4 = this.props,
          pageSizes = _props4.pageSizes,
          pageSize = _props4.pageSize;

      return _react2.default.createElement(_Izenda4.default, {
        className: 'u_marginRight',
        options: this.getPageSizeOptions(pageSizes || _Izenda9.PAGING_SIZE_OPTIONS),
        value: pageSize,
        labelField: 'value',
        valueField: 'value',
        onChange: this._onDropdownChange,
        ref: 'searchDropdown'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var totalRecords = this.props.totalRecords;


      if (!totalRecords) {
        return null;
      }

      return totalRecords !== 0 ? this.renderPaging() : this.renderNoRecordFound();
    }
  }]);
  return Paginator;
}(_react.Component), _class3.displayName = 'Paginator', _class3.propTypes = {
  totalRecords: _react.PropTypes.number.isRequired,
  pageSize: _react.PropTypes.number.isRequired,
  pageSizes: _react.PropTypes.array,
  pageIndex: _react.PropTypes.number.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  onDropdownChange: _react.PropTypes.func.isRequired,
  className: _react.PropTypes.string,
  canChangePageSize: _react.PropTypes.bool
}, _class3.defaultProps = {
  canChangePageSize: true
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'paginatorStatus', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      pageIndexInputVal: this.props.pageIndex,
      isSmall: false
    };
  }
})), _class2)) || _class);
exports.default = Paginator;
module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      ceil = _require.ceil,
      omitBy = _require.omitBy,
      isEmpty = _require.isEmpty;

  var DEFAULT_PAGE_SIZE = 10;
  var SEARCH_OPERATION = {
    EQUALS: 0,
    LIKE: 1
  };

  var SORT_DESC = 'DESC';

  /**
   * @param {object} colSortDirs
   * @param {string} searchProperty
   * @param {string} searchText
   * @returns {Paging} object
   */
  function Paging(colSortDirs, searchProperty, searchText) {
    /* for request object to backend only */
    this.sortOrders = [];
    this.searchCriteria = [];

    m.extendObservable(this, {
      pageIndex: 1, // for paging
      pageSize: DEFAULT_PAGE_SIZE, // for paging, only change when user change page size dropdown
      colSortDirs: colSortDirs, // for sorting in UI only
      searchProperty: searchProperty || '', // for searching in UI only
      searchText: searchText || '', // for searching in UI only
      totalRecords: 0,
      totalPage: 0
    });
  }

  Paging.prototype.setPageIndex = m.action(function (pageIndex) {
    this.pageIndex = pageIndex;
  });

  Paging.prototype.setPageSize = m.action(function (pageSize) {
    this.pageSize = pageSize;
    this.totalPage = ceil(this.totalRecords / this.pageSize) || 1;
  });

  Paging.prototype.setTotalRecords = m.action(function (totalRecords) {
    this.totalRecords = totalRecords;
    this.totalPage = ceil(totalRecords / this.pageSize) || 1;
  });

  Paging.prototype.increaseRecord = m.action(function () {
    this.totalRecords++;
  });

  Paging.prototype.descreaseRecord = m.action(function () {
    this.totalRecords && this.totalRecords--;
  });

  Paging.prototype.setColSortDirs = m.action(function (key, value) {
    this.colSortDirs[key] = value;
    this.colSortDirs = omitBy(isEmpty, this.colSortDirs);
  });

  /* For searching */
  Paging.prototype.setSearchValues = m.action(function (searchProperty, searchText) {
    this.searchProperty = searchProperty;
    this.searchText = searchText;
  });

  /**
   * Wrapping Paging object for matching Paging object from backend
   * Sample output Paging object:
   *  {number} pageIndex
   *  {number} pageSize
   *  {array} sortOrders -> sample [{key: 'colName', descending: boolean }]
   *  {array} searchCriteria -> sample [{key: 'colName', value: string, operation: EQUALS || LIKE }]
   */
  Paging.prototype.buildPagingRequest = m.action(function () {
    this.buildSortOrder();
    this.buildSearchCriteria();
  });

  /**
   * Build sortOrders request object to backend
   * Sample format -> sample [{key: 'colName', descending: boolean }]
   */
  Paging.prototype.buildSortOrder = m.action(function () {
    var newOrders = [];

    for (var col in this.colSortDirs) {
      if (!isEmpty(this.colSortDirs[col])) {
        newOrders.push({
          key: col,
          descending: isDescending(this.colSortDirs[col])
        });
      }
    }
    this.sortOrders = newOrders;
    return this.sortOrders;
  });

  /**
   * Build searchCriteria request object to backend
   * Sample format -> [{key: 'colName', value: string, operation: EQUALS || LIKE }]
   */
  Paging.prototype.buildSearchCriteria = m.action(function () {
    this.searchCriteria = [{
      key: this.searchProperty,
      value: this.searchText,
      operation: SEARCH_OPERATION.LIKE
    }];
  });

  function isDescending(sortDir) {
    if (sortDir && sortDir === SORT_DESC) {
      return true;
    }
    return false;
  }

  module.exports = Paging;
}();

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStaticLabelSchema = exports.createSeparatorSchema = exports.createTotalLabelSchema = exports.createBubbleSizeSchema = exports.createValuesLabelsSchema = exports.createGaugeYAxisMetricsSchema = exports.createYAxisMetricsSchema = exports.createYAxisSchemaWithTransposedLabel = exports.createYAxisSchema = exports.createYAxisCustomNameSchema = exports.createXAxisSchemaWithTransposedLabel = exports.createXAxisSchema = exports.createXAxisCustomNameSchema = exports.createConditionalContainerSchema = exports.createContainerSchema = exports.YAXIS_VALUE_KEY = exports.YAXIS_LABEL_KEY = exports.XAXIS_VALUE_KEY = exports.XAXIS_LABEL_KEY = undefined;

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XAXIS_LABEL_KEY = exports.XAXIS_LABEL_KEY = 'REPORTDESIGNER_LABEL_LABELS';
var XAXIS_VALUE_KEY = exports.XAXIS_VALUE_KEY = 'REPORTDESIGNER_LABEL_VALUES';
var YAXIS_LABEL_KEY = exports.YAXIS_LABEL_KEY = 'REPORTDESIGNER_LABEL_LABELS';
var YAXIS_VALUE_KEY = exports.YAXIS_VALUE_KEY = 'REPORTDESIGNER_LABEL_VALUES';

var REPORTDESIGNER_LABEL_X_AXIS_NAME_KEY = 'REPORTDESIGNER_LABEL_X_AXIS_NAME';
var REPORTDESIGNER_LABEL_Y_AXIS_NAME_KEY = 'REPORTDESIGNER_LABEL_Y_AXIS_NAME';

var USE_SEPARATOR_PROP_PATH = 'properties.optionByType.izUseSeparator';
var DEFAULT_CONTAINER_HEIGHT = 70;
/**
 * Create a general label input container
 * @param {string} containerKey key
 * @param {string|Function} label The label text value or a function return a text
 * @param {string} dataKey Data key
 * @param {int} height Height of container
 * @param {int} maximumField Maximum number of fields in the container
 * @param {boolean} isHorizontal Is horizontal alignment between label and input
 */
var createContainerSchema = exports.createContainerSchema = function createContainerSchema(containerKey, label, dataKey, height, maximumField) {
  var isHorizontal = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return function () {
    return {
      container: {
        containerKey: containerKey,
        get label() {
          return (0, _fp.isFunction)(label) ? label() : label;
        },
        dataKey: dataKey,
        height: height || DEFAULT_CONTAINER_HEIGHT,
        maximumField: maximumField,
        isHorizontal: isHorizontal
      }
    };
  };
};

/**
 * Create a conditional general label input container
 * @param {Function} predicateFn A predicate to determine whether render the container or not
 * @param {string} containerKey key
 * @param {string|Function} label The label text value or a function return a text
 * @param {string} dataKey Data key
 * @param {int} height Height of container
 * @param {int} maximumField Maximum number of fields in the container
 * @param {boolean} [isHorizontal=false] Is horizontal alignment between label and input
 */
var createConditionalContainerSchema = exports.createConditionalContainerSchema = function createConditionalContainerSchema(predicateFn, containerKey, label, dataKey, height, maximumField) {
  var isHorizontal = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  return function (reportPartContent) {
    return predicateFn(reportPartContent) ? {
      container: {
        containerKey: containerKey,
        get label() {
          return (0, _fp.isFunction)(label) ? label() : label;
        },
        dataKey: dataKey,
        height: height,
        maximumField: maximumField,
        isHorizontal: isHorizontal
      }
    } : null;
  };
};

/**
 * Create a X-Axis container with custom label.
 * @param {int} maximumField Maximum number of fields in the container
 * @param {string} xAxisName Localized x-axis name.
 * @param {boolean} isLocalizationNeeded Whether we need to pass througth the localization or not.
 */
var createXAxisCustomNameSchema = exports.createXAxisCustomNameSchema = function createXAxisCustomNameSchema(maximumField, xAxisName) {
  var isLocalizationNeeded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function () {
    return {
      chart_xaxis: {
        maximumField: maximumField,
        axisCustomName: isLocalizationNeeded ? _Izenda2.default.getText(xAxisName) : xAxisName
      }
    };
  };
};

/**
 * Create a X-Axis container
 * @param {int} maximumField Maximum number of fields in the container
 * @param {string} xAxisNameKey The locale key of xAxis name. Default value is 'Label'.
 */
var createXAxisSchema = exports.createXAxisSchema = function createXAxisSchema(maximumField) {
  var xAxisNameKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : XAXIS_LABEL_KEY;
  return createXAxisCustomNameSchema(maximumField, String.format(_Izenda2.default.getText(REPORTDESIGNER_LABEL_X_AXIS_NAME_KEY), _Izenda2.default.getText(xAxisNameKey)));
};

/**
 * Create a X-Axis container for transposed chart (labeled as "Y-axis")
 * @param {int} maximumField Maximum number of fields in the container
 * @param {string} xAxisNameKey The locale key of xAxis name. Default value is 'Label'.
 */
var createXAxisSchemaWithTransposedLabel = exports.createXAxisSchemaWithTransposedLabel = function createXAxisSchemaWithTransposedLabel(maximumField) {
  var xAxisNameKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : YAXIS_LABEL_KEY;
  return createXAxisCustomNameSchema(maximumField, String.format(_Izenda2.default.getText(REPORTDESIGNER_LABEL_Y_AXIS_NAME_KEY), _Izenda2.default.getText(xAxisNameKey)));
};

/**
 * Create a Y-Axis container with custom label.
 * @param {int} maximumField Maximum number of fields in the container
 * @param {string} yAxisName Localized y-axis name.
 * @param {boolean} isLocalizationNeeded Whether we need to pass througth the localization or not.
 */
var createYAxisCustomNameSchema = exports.createYAxisCustomNameSchema = function createYAxisCustomNameSchema(maximumField, yAxisName) {
  var isLocalizationNeeded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function () {
    return {
      chart_yaxis: {
        maximumField: maximumField,
        axisCustomName: isLocalizationNeeded ? _Izenda2.default.getText(yAxisName) : yAxisName
      }
    };
  };
};

/**
 * Create a Y-Axis container  
 * @param {int} maximumField Maximum number of fields in the container
 * @param {string} yAxisNameKey The locale key of yAxis name. Default value is 'Value'.
 */
var createYAxisSchema = exports.createYAxisSchema = function createYAxisSchema(maximumField) {
  var yAxisNameKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : YAXIS_VALUE_KEY;
  return createYAxisCustomNameSchema(maximumField, String.format(_Izenda2.default.getText(REPORTDESIGNER_LABEL_Y_AXIS_NAME_KEY), _Izenda2.default.getText(yAxisNameKey)));
};

/**
 * Create a Y-Axis container for transposed chart (labeled as "X-axis")
 * @param {int} maximumField Maximum number of fields in the container
 * @param {string} yAxisNameKey The locale key of yAxis name. Default value is 'Value'.
 */
var createYAxisSchemaWithTransposedLabel = exports.createYAxisSchemaWithTransposedLabel = function createYAxisSchemaWithTransposedLabel(maximumField) {
  var yAxisNameKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : XAXIS_VALUE_KEY;
  return createYAxisCustomNameSchema(maximumField, String.format(_Izenda2.default.getText(REPORTDESIGNER_LABEL_X_AXIS_NAME_KEY), _Izenda2.default.getText(yAxisNameKey)));
};

/**
 * Create Y-Axis Metrics container
 */
var createYAxisMetricsSchema = exports.createYAxisMetricsSchema = function createYAxisMetricsSchema() {
  return { chart_yaxisMetrics: true };
};

/**
 * Create Y-Axis Gauge Metrics container
 */
var createGaugeYAxisMetricsSchema = exports.createGaugeYAxisMetricsSchema = function createGaugeYAxisMetricsSchema() {
  return { gauge_yaxisMetrics: true };
};

/**
 * Create Value Labels container
 * @param {int} maximumField Maximum number of fields in the container
 */
var createValuesLabelsSchema = exports.createValuesLabelsSchema = function createValuesLabelsSchema(maximumField) {
  return function () {
    return { chart_valuesLabels: { maximumField: maximumField } };
  };
};

/**
 * Create Bubble Size container
 * @param {int} maximumField Maximum number of fields in the container
 */
var createBubbleSizeSchema = exports.createBubbleSizeSchema = function createBubbleSizeSchema(maximumField) {
  return function () {
    return { chart_bubbleSize: { maximumField: maximumField } };
  };
};

/**
 * Create Total Label container
 */
var createTotalLabelSchema = exports.createTotalLabelSchema = function createTotalLabelSchema() {
  return { chart_totalLabel: true };
};

/**
 * Create Separator container
 * @param {Object} reportPartContent
 */
var createSeparatorSchema = exports.createSeparatorSchema = function createSeparatorSchema(reportPartContent) {
  return (0, _fp.getOr)(false, USE_SEPARATOR_PROP_PATH, reportPartContent) ? { chart_separators: { maximumField: 1 } } : {};
};

/**
 * Create a static label
 * @param {string} key The unique container key
 * @param {string|Function} label The label text value or a function return a text
 */
var createStaticLabelSchema = exports.createStaticLabelSchema = function createStaticLabelSchema(key, label) {
  return function () {
    return {
      staticLabel: {
        containerKey: key,
        get label() {
          return (0, _fp.isFunction)(label) ? label() : label;
        }
      }
    };
  };
};

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AppStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(936);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(937);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(938);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(130);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(120);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(565);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(315);

var _Izenda16 = _interopRequireDefault(_Izenda15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var AppStore = (_class = function () {
  function AppStore() {
    (0, _classCallCheck3.default)(this, AppStore);

    _initDefineProp(this, 'hasSetupAndLicense', _descriptor, this);

    _initDefineProp(this, 'licenseInfoStore', _descriptor2, this);

    _initDefineProp(this, 'provisionMapDataStore', _descriptor3, this);

    _initDefineProp(this, 'performanceStore', _descriptor4, this);

    _initDefineProp(this, 'securityStore', _descriptor5, this);

    _initDefineProp(this, 'otherSettingsStore', _descriptor6, this);

    _initDefineProp(this, 'accountStore', _descriptor7, this);

    _initDefineProp(this, 'securityManager', _descriptor8, this);
  }

  (0, _createClass3.default)(AppStore, [{
    key: 'loadAppState',
    value: function loadAppState() {
      var accessToken = this.securityManager.getAccessToken();
      if (!(0, _fp.isNil)(accessToken)) {
        this.loadAppSettings();
      }
    }

    /**
     * Load app setting data.
     */

  }, {
    key: 'loadAppSettings',
    value: function loadAppSettings() {
      return (0, _bluebird.all)([this.loadPerformance(), this.loadSecurity(), this.loadOther(), this.loadSystemDate()]);
    }
  }, {
    key: 'loadPerformance',
    value: function loadPerformance() {
      return this.performanceStore.loadPerformance().then(_Izenda2.default.setPerformance.bind(_Izenda2.default));
    }
  }, {
    key: 'loadSecurity',
    value: function loadSecurity() {
      return this.securityStore.loadSecurity().then(_Izenda2.default.setSecurity.bind(_Izenda2.default));
    }
  }, {
    key: 'loadOther',
    value: function loadOther() {
      return this.otherSettingsStore.loadOther().then(_Izenda2.default.setOther.bind(_Izenda2.default));
    }
  }, {
    key: 'loadSystemDate',
    value: function loadSystemDate() {
      return this.otherSettingsStore.loadSystemDate().then(_Izenda2.default.setSystemDate.bind(_Izenda2.default));
    }
  }, {
    key: 'getProvisionMapDataStatus',
    value: function getProvisionMapDataStatus() {
      var accessToken = this.securityManager.getAccessToken();
      if (!(0, _fp.isNil)(accessToken)) {
        this.provisionMapDataStore.getProvisioningStatus();
      }
    }

    /**
     * Load category settings.
     */

  }, {
    key: 'loadCategorySettings',
    value: function loadCategorySettings() {
      return this.otherSettingsStore.loadCategorySettings();
    }
  }]);
  return AppStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'hasSetupAndLicense', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'licenseInfoStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda14.default;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'provisionMapDataStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda16.default;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'performanceStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda4.default();
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'securityStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda6.default();
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'otherSettingsStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda8.default();
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'accountStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda10.default();
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'securityManager', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda12.default();
  }
})), _class);


var singleton = new AppStore();
exports.default = singleton;
module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _Izenda = __webpack_require__(64);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(265);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FUNCTION = _Izenda2.default.FUNCTION; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGaugeConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FORMAT_KEY = _Izenda2.default.FORMAT_KEY;

var MAP_TYPES = {
  World: 'World',
  Continent: 'Continent',
  Country: 'Country'
};

var CHART_TYPES = {
  get World() {
    return _Izenda6.default.getText('REPORT_PART_MAP_CONSTANTS_WORLD');
  },
  get Continent() {
    return _Izenda6.default.getText('REPORT_PART_MAP_CONSTANTS_CONTINENT');
  },
  get Country() {
    return _Izenda6.default.getText('REPORT_PART_MAP_CONSTANTS_COUNTRY');
  }
};

var ContainerName = {
  // Point Options

  POINT_OPTIONS: 'pointOptions', // save to back-end
  COUNTRY: 'country',
  STATE: 'state',
  COUNTY: 'county',
  CITY: 'city',
  POSTAL_CODE: 'postalCode',
  LATITUDE: 'latitude',
  LONGTITUDE: 'longtitude',

  // Values
  SHADING_VALUES: 'shadingMetric',
  BUBBLE_VALUES: 'bubbleMetrics'
};

var POINT_OPTIONS_CONTAINERS = [ContainerName.COUNTRY, ContainerName.STATE, ContainerName.COUNTY, ContainerName.CITY, ContainerName.POSTAL_CODE, ContainerName.LATITUDE, ContainerName.LONGTITUDE];
var VALUES_CONTAINERS = [ContainerName.SHADING_VALUES, ContainerName.BUBBLE_VALUES];

/* MAPPING_KEY */
var MappingKey = {};
MappingKey[ContainerName.COUNTRY] = ['hc-key', 'hc-a2', 'name', 'country-abbrev', 'iso-a3', 'iso-a2'];
MappingKey[ContainerName.STATE] = ['hc-key', 'hc-a2', 'state-fips', 'flips', 'name', 'woeName', 'hcA2'];
MappingKey[ContainerName.COUNTY] = ['hc-key', 'hc-a2', 'state-fips', 'fips', 'name'];
MappingKey[ContainerName.CITY] = ['geonameId', 'name', 'asciiName', 'alternateNames'];
MappingKey[ContainerName.POSTAL_CODE] = ['postalCode', 'postalName'];

/* Default function for each fields based on its container */
var DefaultFunction = {};

DefaultFunction[ContainerName.COUNTRY] = DefaultFunction[ContainerName.STATE] = DefaultFunction[ContainerName.COUNTY] = DefaultFunction[ContainerName.CITY] = DefaultFunction[ContainerName.POSTAL_CODE] = DefaultFunction[ContainerName.LATITUDE] = DefaultFunction[ContainerName.LONGTITUDE] = DefaultFunction[ContainerName.COUNTRY] = {
  Datetime: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.YEAR
  },
  Time: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.DEFAULT_TIME
  },

  Others: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.NONE
  }
};

DefaultFunction[ContainerName.SHADING_VALUES] = DefaultFunction[ContainerName.BUBBLE_VALUES] = {
  Numeric: {
    FUNCTION: FUNCTION.SUM,
    FORMAT: FORMAT_KEY.NONE
  },

  Money: {
    FUNCTION: FUNCTION.SUM,
    FORMAT: FORMAT_KEY.NONE
  },

  Others: {
    FUNCTION: FUNCTION.COUNT,
    FORMAT: FORMAT_KEY.NONE
  }
};

/* Maximum number of fields for each container */
var MaximumField = {};

MaximumField[ContainerName.COUNTRY] = MaximumField[ContainerName.STATE] = MaximumField[ContainerName.COUNTY] = MaximumField[ContainerName.CITY] = MaximumField[ContainerName.POSTAL_CODE] = MaximumField[ContainerName.LATITUDE] = MaximumField[ContainerName.LONGTITUDE] = MaximumField[ContainerName.COUNTRY] = MaximumField[ContainerName.SHADING_VALUES] = 1;

/* Messages */
var Message = {};

/* Other rules */
var POINTS_OPTIONS_ORDER = [ContainerName.COUNTRY, ContainerName.STATE, ContainerName.COUNTY, ContainerName.CITY, ContainerName.POSTAL_CODE, ContainerName.LATITUDE, ContainerName.LONGTITUDE];

var POINTS_OPTIONS_FOR_SHADING = [ContainerName.COUNTRY, ContainerName.STATE, ContainerName.COUNTY];
var POINTS_OPTIONS_FOR_BUBBLE_ALL = [ContainerName.COUNTRY, ContainerName.STATE, ContainerName.COUNTY, ContainerName.CITY, ContainerName.POSTAL_CODE, ContainerName.LATITUDE, ContainerName.LONGTITUDE];
var POINTS_OPTIONS_FOR_BUBBLE_WITHOUT_LONGLAT = [ContainerName.COUNTRY, ContainerName.STATE, ContainerName.COUNTY, ContainerName.CITY, ContainerName.POSTAL_CODE];

//anytime when those values change >> drilldownInfo need to reset
var PROPS_APPLY_NEW_DRILLDOWN = ['chartType', 'continent', 'country', 'state'];

var DRILLDOWN_LEVELS = {
  WORLD: 'WORLD',
  CONTINENT: 'CONTINENT',
  COUNTRY: 'COUNTRY',
  STATE: 'STATE'
};

var DRILLDOWN_ORDERS = [DRILLDOWN_LEVELS.WORLD, DRILLDOWN_LEVELS.CONTINENT, DRILLDOWN_LEVELS.COUNTRY, DRILLDOWN_LEVELS.STATE];

/* Map Constant UI */
var MapUIConstant = {
  backgroundMapColor: '#f2f2f2',
  hoverColor: '#BADA55',
  bubbleMinSize: 4,
  bubbleMaxSize: '10%'
};

/* Key to get value for map label */
var DATA_LABELS = {
  WORLD: 'hc-a2',
  CONTINENT: 'hc-a2',
  COUNTRY: 'postal-code',
  STATE: 'name'
};

var FUNCTION_CONFIG = {
  POINT_OPTIONS: {
    SUPPORTED: {
      Datetime: [FUNCTION.GROUP, FUNCTION.GROUP_DAYS_OLD],
      DEFAULT: [FUNCTION.GROUP]
    }
  },

  VALUES: {
    UNSUPPORTED: {
      DEFAULT: [FUNCTION.NONE, FUNCTION.GROUP],
      Datetime: [FUNCTION.NONE, FUNCTION.GROUP, FUNCTION.MAXIMUM, FUNCTION.MINIMUM]
    }
  }
};

var DEFAULT_SETTING_VALUE = {
  borderDefault: {
    'izEntire.borderColor': '#000',
    'izEntire.borderWidth': undefined,
    'izEntire.borderStyle': 'solid'
  },
  borderNew: {
    'izEntire.borderColor': undefined,
    'izEntire.borderWidth': undefined,
    'izEntire.borderStyle': undefined
  },
  backGroundColorDefault: {
    'izEntire.backgroundColor': '#fff',
    'izPlot.backgroundColor': undefined
  },
  backGroundColorNew: {
    'izEntire.backgroundColor': undefined,
    'izPlot.backgroundColor': undefined
  },
  refreshIntervalDefault: {
    enable: false,
    isAll: true,
    latestRecord: 0,
    updateInterval: 0
  }
};

var PROVISION_DATA_NOTIFICATION_MESSAGE_KEY = {
  PROVISIONING: 'ProvisionImporting',
  SUCCESS: 'ProvisionSuccess',
  ERROR: 'ProvisionError'
};

exports.default = {
  CHART_TYPES: CHART_TYPES,
  MAP_TYPES: MAP_TYPES,
  ContainerName: ContainerName,

  DefaultChartType: MAP_TYPES.World,
  DefaultGEOBackground: 'world',
  DefaultContinent: 'central-america',
  DefaultCountry: 'al',

  DefaultFunction: DefaultFunction,
  MaximumField: MaximumField,

  MappingKey: MappingKey,
  MapUIConstant: MapUIConstant,

  PointOptionsContainers: POINT_OPTIONS_CONTAINERS,
  ValuesContainers: VALUES_CONTAINERS,

  PointsOptionsOrder: POINTS_OPTIONS_ORDER,
  PointsOptionsForShading: POINTS_OPTIONS_FOR_SHADING,
  PointsOptionsForBubbleAll: POINTS_OPTIONS_FOR_BUBBLE_ALL,
  PointsOptionsForBubbleWithoutLongLat: POINTS_OPTIONS_FOR_BUBBLE_WITHOUT_LONGLAT,
  PropsApplyNewDrilldown: PROPS_APPLY_NEW_DRILLDOWN,
  DrilldownLevels: DRILLDOWN_LEVELS,
  DrilldownOrders: DRILLDOWN_ORDERS,
  DataLabels: DATA_LABELS,

  get KeyNames() {
    var _ref;

    return _ref = {}, (0, _defineProperty3.default)(_ref, ContainerName.COUNTRY, _Izenda6.default.getText('REPORT_PART_MAP_POINT_country')), (0, _defineProperty3.default)(_ref, ContainerName.STATE, _Izenda6.default.getText('REPORT_PART_MAP_POINT_state')), (0, _defineProperty3.default)(_ref, ContainerName.COUNTY, _Izenda6.default.getText('REPORT_PART_MAP_POINT_county')), (0, _defineProperty3.default)(_ref, ContainerName.CITY, _Izenda6.default.getText('REPORT_PART_MAP_POINT_city')), (0, _defineProperty3.default)(_ref, ContainerName.POSTAL_CODE, _Izenda6.default.getText('REPORT_PART_MAP_POINT_postalCode')), (0, _defineProperty3.default)(_ref, ContainerName.LATITUDE, _Izenda6.default.getText('REPORT_PART_MAP_POINT_latitude')), (0, _defineProperty3.default)(_ref, ContainerName.LONGTITUDE, _Izenda6.default.getText('REPORT_PART_MAP_POINT_longtitude')), (0, _defineProperty3.default)(_ref, ContainerName.SHADING_VALUES, _Izenda6.default.getText('REPORT_PART_MAP_CONSTANTS_SHADING_METRIC')), (0, _defineProperty3.default)(_ref, ContainerName.BUBBLE_VALUES, _Izenda6.default.getText('REPORT_PART_MAP_CONSTANTS_BUBBLE_METRIC')), _ref;
  },
  FunctionConfig: FUNCTION_CONFIG,
  DEFAULT_SETTING_VALUE: DEFAULT_SETTING_VALUE,
  PROVISION_DATA_NOTIFICATION_MESSAGE_KEY: PROVISION_DATA_NOTIFICATION_MESSAGE_KEY
};
module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(34);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerFormatsConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FORMAT_GROUP_CONFIG = {
  FILTER: 'filter',
  HEADER: 'reportHeader',
  FOOTER: 'reportFooter',
  TITLE_DESCRIPTION: 'reportTitleDescription'
};

var DEFAULT_ITEM_MIN_HEIGHT = 1;

var FORMAT_GROUP = [{
  get label() {
    return _Izenda2.default.getText('REPORTDESIGNER_LABEL_FIELDS_FILTERS_HEADER');
  },
  value: FORMAT_GROUP_CONFIG.FILTER
}, {
  get label() {
    return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_HEADER');
  },
  value: FORMAT_GROUP_CONFIG.HEADER
}, {
  get label() {
    return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_TITLE_DESCRIPTION');
  },
  value: FORMAT_GROUP_CONFIG.TITLE_DESCRIPTION
}, {
  get label() {
    return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_FOOTER');
  },
  value: FORMAT_GROUP_CONFIG.FOOTER
}];

/*Default value for format item*/
var ITEMS_TYPE = {
  image: {
    value: 'image',
    get label() {
      return _Izenda2.default.getText('COMMON_DATA_TYPE_IMAGE');
    },
    defaultName: 'image',
    defaultValue: '',
    width: 6,
    height: 6,
    imageUrl: 'http://',
    defaultImgBtn: 'button'
  },
  text: {
    value: 'text',
    get label() {
      return _Izenda2.default.getText('COMMON_DATA_TYPE_TEXT');
    },
    defaultName: 'text',
    defaultValue: '',
    width: 8,
    height: 2,
    minHeight: 2
  },
  horizontalRule: {
    value: 'horizontalRule',
    get label() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_ITEMS_TYPE_HORIZONTAL_RULE');
    },
    defaultName: 'horizontalRule',
    defaultValue: '{horizontalRule}',
    width: 12,
    height: 1
  },
  thinHorizontalRule: {
    value: 'thinHorizontalRule',
    get label() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_ITEMS_TYPE_HORIZONTAL_RULE');
    },
    defaultName: 'horizontalRule',
    defaultValue: '{horizontalRule}',
    width: 16,
    height: 1
  },
  verticalRule: {
    value: 'verticalRule',
    get label() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_ITEMS_TYPE_VERTICAL_RULE');
    },
    defaultName: 'verticalRule ',
    defaultValue: '{verticalRule}',
    width: 1,
    height: 5
  },
  dateTime: {
    value: 'dateTime',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_DATE_TIME');
    },
    defaultName: 'currentDateTime',
    defaultValue: '{currentDateTime}',
    width: 8,
    height: 2,
    minHeight: 2
  },
  pageNumber: {
    value: 'pageNumber',
    get label() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_ITEMS_TYPE_PAGE_NUMBER');
    },
    defaultName: 'pageNumber',
    defaultValue: '{pageNumber}',
    width: 8,
    height: 2,
    minHeight: 2
  },
  title: {
    value: 'title',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_TITLE');
    }
  },
  description: {
    value: 'description',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_DESCRIPTION');
    }
  }
};

/*Property option by format type*/
var OPTIONS_BY_FORMAT_TYPE = {
  image: {
    type: ITEMS_TYPE.image.value,
    label: ITEMS_TYPE.image.label,
    name: '',
    imageUrl: ITEMS_TYPE.image.imageUrl,
    defaultImgBtn: ITEMS_TYPE.image.defaultImgBtn
  },
  text: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    name: '',
    value: '',
    fontFormat: {},
    fontStyle: {},
    alignment: null
  },
  dateTime: {
    type: ITEMS_TYPE.dateTime.value,
    label: ITEMS_TYPE.dateTime.label,
    name: '',
    value: '',
    format: null,
    fontFormat: {},
    fontStyle: {},
    alignment: null
  },
  pageNumber: {
    type: ITEMS_TYPE.pageNumber.value,
    label: ITEMS_TYPE.pageNumber.label,
    name: '',
    value: '',
    format: null,
    fontFormat: {},
    fontStyle: {},
    alignment: null
  },
  horizontalRule: {
    type: ITEMS_TYPE.horizontalRule.value,
    label: ITEMS_TYPE.horizontalRule.label,
    name: '',
    value: '',
    color: '',
    dashStyle: '',
    thickness: 1
  },
  thinHorizontalRule: {
    type: ITEMS_TYPE.thinHorizontalRule.value,
    label: ITEMS_TYPE.thinHorizontalRule.label,
    name: '',
    value: '',
    color: '',
    dashStyle: '',
    thickness: 1
  },
  verticalRule: {
    type: ITEMS_TYPE.verticalRule.value,
    label: ITEMS_TYPE.verticalRule.label,
    name: '',
    value: '',
    color: '',
    dashStyle: '',
    thickness: 1
  },
  title: {
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_TITLE');
    },
    fontFormat: {},
    fontStyle: {},
    alignment: null
  },
  description: {
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_DESCRIPTION');
    },
    fontFormat: {},
    fontStyle: {},
    alignment: null
  }
};

/*List option add item*/
var ITEMS = [{
  value: ITEMS_TYPE.image.value,
  get label() {
    return ITEMS_TYPE.image.label;
  }
}, {
  value: ITEMS_TYPE.text.value,
  get label() {
    return ITEMS_TYPE.text.label;
  }
}, {
  value: ITEMS_TYPE.dateTime.value,
  get label() {
    return ITEMS_TYPE.dateTime.label;
  }
}, {
  value: ITEMS_TYPE.pageNumber.value,
  get label() {
    return ITEMS_TYPE.pageNumber.label;
  }
}, {
  value: ITEMS_TYPE.horizontalRule.value,
  get label() {
    return ITEMS_TYPE.horizontalRule.label;
  }
}, {
  value: ITEMS_TYPE.verticalRule.value,
  get label() {
    return ITEMS_TYPE.verticalRule.label;
  }
}];

/*Default header items*/
var HEADER_ITEMS = {
  image: {
    type: ITEMS_TYPE.image.value,
    label: ITEMS_TYPE.image.label,
    positionX: 0,
    positionY: 0,
    width: 6,
    height: 6,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_LOGO_IMAGE');
    },
    value: '',
    imageUrl: 'http://'
  },
  reportName: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 0,
    width: 12,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return _Izenda2.default.getText('COMMON_LABEL_REPORT_NAME');
    },
    value: '{reportName}'
  },
  upperSeparatorLine: {
    type: ITEMS_TYPE.thinHorizontalRule.value,
    label: ITEMS_TYPE.thinHorizontalRule.label,
    positionX: 20,
    positionY: 4,
    width: 12,
    height: 1,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_UPPER_SEPARATOR_LINE');
    },
    value: '{horizontalRule}',
    thickness: 2,
    color: _Izenda4.default.borderColor
  },
  reportGenerate: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 5,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_GENERATED');
    },
    value: 'Report Generated:'
  },
  user: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 7,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_USER');
    },
    value: 'User:'
  },
  tenant: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 9,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return _Izenda2.default.getText('COMMON_LABEL_TENANT');
    },
    value: 'Tenant:'
  },
  currentDateTime: {
    type: ITEMS_TYPE.dateTime.value,
    label: ITEMS_TYPE.dateTime.label,
    positionX: 26,
    positionY: 5,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.dateTime.minHeight,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_CURRENT_DATE_TIME');
    },
    value: '{currentDateTime}'
  },
  currentUserName: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 26,
    positionY: 7,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_CURRENT_USER_NAME');
    },
    value: '{currentUserName}'
  },
  tenantName: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 26,
    positionY: 9,
    width: 6,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return _Izenda2.default.getText('COMMON_LABEL_TENANT_NAME');
    },
    value: '{tenantName}'
  },
  lowerSeparatorLine: {
    type: ITEMS_TYPE.horizontalRule.value,
    label: ITEMS_TYPE.horizontalRule.label,
    positionX: 0,
    positionY: 11,
    width: 32,
    height: 1,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_LOWER_SEPARATOR_LINE');
    },
    value: '{horizontalRule}',
    thickness: 4,
    color: _Izenda4.default.borderColor
  }
};

/*Default footer value*/
var FOOTER_ITEMS = {
  separatorLine: {
    type: ITEMS_TYPE.horizontalRule.value,
    label: ITEMS_TYPE.horizontalRule.label,
    positionX: 0,
    positionY: 0,
    width: 32,
    height: 1,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_SEPARATOR_LINE');
    },
    value: '{horizontalRule}',
    thickness: 4,
    color: _Izenda4.default.borderColor
  },
  footerText: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 0,
    positionY: 1,
    width: 10,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_FOOTER_TEXT');
    },
    value: 'Footer Text'
  },
  page: {
    type: ITEMS_TYPE.text.value,
    label: ITEMS_TYPE.text.label,
    positionX: 20,
    positionY: 1,
    width: 4,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_PAGE');
    },
    value: 'Page'
  },
  pageNumber: {
    type: ITEMS_TYPE.pageNumber.value,
    label: ITEMS_TYPE.pageNumber.label,
    positionX: 24,
    positionY: 1,
    width: 8,
    height: 2,
    minHeight: ITEMS_TYPE.text.minHeight,
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_PAGE_NUMBER');
    },
    value: '{pageNumber}'
  }
};

var TITLE_DESCRIPTION_ITEMS = {
  title: {
    type: ITEMS_TYPE.title.value,
    label: ITEMS_TYPE.title.label,
    name: ITEMS_TYPE.title.label,
    value: ''
  },
  description: {
    type: ITEMS_TYPE.description.value,
    label: ITEMS_TYPE.description.label,
    name: ITEMS_TYPE.description.label,
    value: ''
  }
};

var MESSAGES = {
  get M01() {
    return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_MESSAGES_ITEM_NAME_EXISTS');
  }
};

exports.default = {
  FORMAT_GROUP_CONFIG: FORMAT_GROUP_CONFIG,
  FORMAT_GROUP: FORMAT_GROUP,
  get TITLE() {
    return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_TITLE_REPORT_FORMATTING');
  },
  HEADER_FOOTER: {
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_HEADER_FOOTER');
    },
    items: ITEMS
  },
  TITLE_DESCRIPTION: {
    get name() {
      return _Izenda2.default.getText('REPORT_DESIGNER_FORMAT_CONSTANTS_LABEL_REPORT_TITLE_DESCRIPTION');
    }
  },
  NUMBER_HEADER_COLS: 32,
  NUMBER_HEADER_ROWS: 12,
  NUMBER_FOOTER_COLS: 32,
  NUMBER_FOOTER_ROWS: 5,
  ROW_HEIGHT: 25,
  ITEMS_TYPE: ITEMS_TYPE,
  reportHeader: HEADER_ITEMS,
  reportFooter: FOOTER_ITEMS,
  reportTitleDescription: TITLE_DESCRIPTION_ITEMS,
  OPTIONS_BY_FORMAT_TYPE: OPTIONS_BY_FORMAT_TYPE,
  MESSAGES: MESSAGES,
  DEFAULT_ITEM_MIN_HEIGHT: DEFAULT_ITEM_MIN_HEIGHT
};
module.exports = exports['default'];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchTextBox.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Input = __webpack_require__(17);
  var Icon = __webpack_require__(314);
  var classnames = __webpack_require__(11);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      omit = _require.omit,
      debounce = _require.debounce,
      noop = _require.noop;

  var SearchTextBox = React.createClass({
    displayName: 'SearchTextBox',

    getInitialState: function getInitialState() {
      return {
        searchValue: this.props.value
      };
    },
    componentWillMount: function componentWillMount() {
      this.debounceSearch = this.props.clickable && !this.props.debounceOnChange ? this.props.onChange : debounce(350, this.props.onChange);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          searchValue: nextProps.value
        });
      }
    },
    render: function render() {
      var props = this.props;
      var clazz = classnames('izenda-SearchTextBox', props.className);
      var placeHolder = props.placeHolder || localizer.getText('ROLE_SETUP_USERS_LABEL_SEARCH');
      var clickable = props.clickable || false;
      var searchValue = this.state.searchValue;

      var onClick = props.onClick || noop();
      var rest = omit(['className', 'type', 'placeholder', 'clickable', 'onClick', 'value', 'onChange', 'debounceOnChange'], props);

      var iconClazz = classnames('icon-search', {
        'izenda-SearchTextBox-Button': !clickable,
        'izenda-SearchTextBox-Button_clickable': clickable
      });

      return React.createElement(
        'div',
        { className: clazz },
        React.createElement(Input, (0, _extends3.default)({
          type: 'text',
          className: 'izenda-SearchTextBox-TextBox',
          placeholder: placeHolder,
          value: searchValue,
          onChange: this.onSearchChange
        }, rest)),
        React.createElement(Icon, { className: iconClazz, onClick: onClick })
      );
    },
    onSearchChange: function onSearchChange(e) {
      (!this.props.clickable || this.props.debounceOnChange) && e.persist();
      this.debounceSearch(e);
      this.setState({
        searchValue: e.target.value
      });
    }
  });
  module.exports = SearchTextBox;
}();

/***/ }),
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.NumericInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Numeric Input component
 */

var _simpleNumber = __webpack_require__(1760);

var _simpleNumber2 = _interopRequireDefault(_simpleNumber);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWidgets = __webpack_require__(923);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _simpleNumber2.default)();

var NumericInput = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NumericInput, _Component);

  function NumericInput() {
    (0, _classCallCheck3.default)(this, NumericInput);
    return (0, _possibleConstructorReturn3.default)(this, (NumericInput.__proto__ || (0, _getPrototypeOf2.default)(NumericInput)).apply(this, arguments));
  }

  (0, _createClass3.default)(NumericInput, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var isHideSpinner = props.isHideSpinner,
          showInfoIcon = props.showInfoIcon,
          isDecimal = props.isDecimal,
          hint = props.hint,
          max = props.max,
          min = props.min;


      var classes = (0, _classnames2.default)({
        'numeric-input': true,
        'hide-spinner': isHideSpinner,
        'show-icon': showInfoIcon
      });
      var omitProps = (0, _fp.omit)(['hint', 'showInfoIcon', 'isDecimal', 'isHideSpinner', 'containerClassName', 'onChange', 'groupByDateTime'], props);
      omitProps.value === '' && (omitProps.value = null);
      isDecimal && (omitProps = (0, _fp.assign)(omitProps, { format: _Izenda.Number.DECIMAL_FORMAT }));

      var changeInput = function changeInput(value) {
        if (!isDecimal && value) {
          var integerString = (0, _fp.replace)('.', '', value.toString());
          value = parseInt(integerString);
        }

        props.onChange && props.onChange(value);
      };

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(_reactWidgets.NumberPicker, (0, _extends3.default)({ max: max, min: min, onChange: changeInput }, omitProps)),
        showInfoIcon ? _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', { className: 'icon-info-circled', title: hint })
        ) : null
      );
    }
  }]);
  return NumericInput;
}(_react.Component), _class.propTypes = {
  isHideSpinner: _react.PropTypes.bool,
  showInfoIcon: _react.PropTypes.bool,
  hint: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  isDecimal: _react.PropTypes.bool,
  max: _react.PropTypes.number,
  min: _react.PropTypes.number
}, _class.defaultProps = {
  isHideSpinner: true,
  showInfoIcon: false,
  hint: '',
  isDecimal: true,
  max: _Izenda.Number.MAX,
  min: _Izenda.Number.MIN
}, _temp);
exports.default = NumericInput;
module.exports = exports['default'];

/***/ }),
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(207);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(247);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportsDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Reports Data Fetcher.
 */
var ROOT_URL = 'report/';

var fetchers = {
  /**
   * Get all categories
   * @param {String} saveType
   * @returns {promise}
   */
  loadAllCategories: function loadAllCategories(type, tenantId) {
    tenantId = (0, _fp.isNil)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)(ROOT_URL + 'allcategories/' + type + '/' + tenantId).get();
  },


  /**
   * Get categories for copy popup
   * @param {Number}    type      report type
   * @param {String}    tenantId  current tenant id
   * @param {Boolean}   isGlobal  flag global report
   * @returns {Promise}
   */
  loadCategoriesForCopyPopup: function loadCategoriesForCopyPopup(type, tenantId, isGlobal) {
    (0, _fp.isNil)(tenantId) && (tenantId = '');
    return (0, _Izenda2.default)(ROOT_URL + 'category/' + type + '/' + tenantId + '?isGlobal=' + !!isGlobal).get();
  },


  /**
   * Get all sub-categories
   * @param {String} categoryId
   * @returns {promise}
   */
  loadSubCategoriesForCopyPopup: function loadSubCategoriesForCopyPopup(categoryId) {
    return (0, _Izenda2.default)(ROOT_URL + 'subcategory/' + categoryId).get();
  },


  /**
   * Load all report Categories
   * @param  {Object} data [description]
   * @return {Promise}      [description]
   */
  loadReportCategories: function loadReportCategories(data, includeHashCode) {
    includeHashCode = (0, _fp.isNil)(includeHashCode) ? false : includeHashCode;
    return (0, _Izenda2.default)(ROOT_URL + 'list?includeHashCode=' + includeHashCode).post(data);
  },


  /**
   * Load list report history
   * @param {String} tenantId
   * @param {Object} pageInfo
   * @param {typeString} reportId
   * @returns {Array} List of report history
   */
  loadReportHistory: function loadReportHistory(tenantId, pageInfo, reportId) {
    pageInfo = pageInfo || {};

    var requestData = {
      reportId: reportId,
      tenantId: tenantId,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{ key: 'version', descending: true }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'history').post(requestData);
  },


  /**
   * Update Subscribed Instances
   * @param {Array} subscriptions
   * @returns {Promise}
   */
  updateSubscriptions: function updateSubscriptions(instances) {
    instances = instances || [];
    return (0, _Izenda2.default)(ROOT_URL + 'subscriptions').post(instances);
  },


  /**
   * Load report subscription
   * @param  {string} tenantId
   * @param  {object} pageInfo
   * @param  {string} reportId
   */
  loadSubscription: function loadSubscription(tenantId, pageInfo, reportId, isSubscriptionMode) {
    pageInfo = pageInfo || {};

    var requestData = {
      reportId: reportId,
      isSubscription: isSubscriptionMode,
      tenantId: tenantId,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{ key: 'name', descending: true }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadSubscriptions').post(requestData);
  },


  /**
   * Load schedule
   * @param  {string} reportId
   * @param  {Object} subscriptions
   * @param  {Object} pageInfo
   */
  loadSchedules: function loadSchedules(reportId, subscriptions, pageInfo) {
    pageInfo = pageInfo || {};

    var requestData = {
      reportId: reportId,
      subscriptions: subscriptions,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{ key: 'name', descending: true }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadSchedules').post(requestData);
  },


  /**
   * validate category name
   * @param  {object} category
   * @returns {Promise}
   */
  validateCategoryName: function validateCategoryName(category) {
    return (0, _Izenda2.default)(ROOT_URL + 'category').post(category);
  },


  /**
   * Get Report Id by it's name and categoryName
   * @param catName
   * @param reportName
   */
  getReportIdByNameAndCateName: function getReportIdByNameAndCateName(catName, reportName, tenantId) {
    tenantId = tenantId ? tenantId : '';
    reportName = reportName ? '?reportName=' + reportName : '';
    catName = catName ? '&categoryName=' + catName : '';
    return (0, _Izenda2.default)(ROOT_URL + 'reportId/' + tenantId + reportName + catName).get();
  },


  /**
   * Check whether report exists or not
   */
  validateExistingReport: function validateExistingReport(cateName, reportName, tenantId) {
    var data = {
      tenantId: tenantId,
      reportName: reportName,
      categoryName: cateName
    };
    return (0, _Izenda2.default)(ROOT_URL + 'validateExistingReport').post(data);
  },


  /**
   * Check whether fields exist in report or not
   * @param reportName
   * @param cateName
   * @param field
   * @returns {*}
   */
  validateExistingField: function validateExistingField(cateName, reportName, field, tenantId) {
    var data = {
      tenantId: tenantId,
      reportName: reportName,
      categoryName: cateName,
      columnFullReference: field
    };
    return (0, _Izenda2.default)(ROOT_URL + 'validateExistingField').post(data);
  },


  /**
   * Rename report
   * @param  {Object} data [description]
   * @return {Promise}      [description]
   */
  renameReport: function renameReport(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'rename').post(data);
  },


  /**
   * DeleteReport description]
   * @param  {[type]} data [description]
   * @return {[type]}      [description]
   */
  deleteReport: function deleteReport(data, version) {
    version = version || '';

    return (0, _Izenda2.default)(ROOT_URL + 'delete/' + version).post(data);
  },


  /**
   * Delete a ReportCategory by id
   * @param {string} reportCategoryId
   * @returns {promise}
   */
  deleteReportCategory: function deleteReportCategory(reportCategoryId) {
    return (0, _Izenda2.default)(ROOT_URL + 'category/' + reportCategoryId).delete();
  },


  /**
   * Copy new report
   * @param  {[type]} data [description]
   * @return {Promise}      [description]
   */
  copyNewReport: function copyNewReport(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'copy').post(data);
  },


  /**
   * [moveReport this function is move report category]
   * @param  {[type]} data [description]
   * @return {[Promise]}
   */
  moveReport: function moveReport(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'move').post(data);
  },

  /**
   * Validate subscription instance.
   * @param  {Object} instance
   * @returns {Promise}
   */
  validateSubscription: function validateSubscription(instance) {
    return (0, _Izenda2.default)(ROOT_URL + 'subscription/validate').post(instance);
  },


  /**
   * Get email templates
   * @returns {promise}
   */
  fetchEmailTemplates: function fetchEmailTemplates(templateType) {
    return (0, _Izenda2.default)(ROOT_URL + 'emailTemplates/' + templateType).get();
  },


  /**
   * Load report at specific version
   * @param {String} reportId
   * @param {String} version
   * @returns {Promise}
   */
  loadReportVersion: function loadReportVersion(reportId, version, data) {
    return (0, _Izenda2.default)(ROOT_URL + 'version/' + reportId + '/' + version).post(data || {});
  },


  /**
   * Delete a report history
   * @param {String} reportId
   * @param {String} version
   * @returns {Promise}
   */
  deleteReportHistory: function deleteReportHistory(reportId, version) {
    version = version || 0;

    return (0, _Izenda2.default)(ROOT_URL + 'history/' + reportId + '/' + version).delete();
  },


  /**
   * Report information
   * @param {String} reportId
   * @returns {Promise}
   */
  reportInfo: function reportInfo(reportId, version) {
    version = version || null;

    return (0, _Izenda2.default)(ROOT_URL + 'info/' + reportId + '/' + version).get();
  },


  /**
   * Report information
   * @param {String} reportId
   * @returns {Promise}
   */
  reportByProperty: _Izenda6.default.memoize(function (reportId, reportProperty) {
    return (0, _Izenda2.default)(ROOT_URL + 'reportByProperty/' + reportId + '/' + reportProperty).get();
  }, {
    resolver: function resolver() {
      return (0, _fp.join)('_', arguments);
    }
  }),

  /**
   * load list of report
   * @method function
   * @param  {[type]} querry [description]
   * @return {[type]}        [description]
   */
  searchReport: function searchReport(query) {
    return (0, _Izenda2.default)(ROOT_URL + 'advancedSearch').post(query);
  },


  /**
   * Load all filter field data for list filter
   * @param {Object} data
   * @returns {Promise}
   */
  loadAllFilterFieldsData: _Izenda6.default.memoize(function (data) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadAllFilterFieldsData').post(data);
  }, {
    resolver: function resolver(data) {
      return (0, _stringify2.default)(data);
    }
  }),

  /**
   * Detect Schema Change
   * @param {type} data
   * @returns {type}
   */
  detectSchemaChange: function detectSchemaChange(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'detectSchemaChange').post(data);
  },


  /**
   * Load accesses
   * @param  {string} reportId
   * @param  {Object} subscriptions
   * @param  {Object} pageInfo
   */
  loadAccesses: function loadAccesses(reportId, data, pageInfo) {
    pageInfo = pageInfo || {};

    var requestData = {
      reportId: reportId,
      accesses: data,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{ key: 'all', descending: true }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadAccesses').post(requestData);
  },


  /**
   * update renderingTime
   * @param  {string} reportId
   * @param  {Number} renderingTime
   */
  updateRenderingTime: function updateRenderingTime(reportId, renderingTime) {
    var requestData = {
      id: reportId,
      renderingTime: renderingTime
    };

    return (0, _Izenda2.default)(ROOT_URL + 'updateRenderingTime').post(requestData);
  },


  /**
   * Clear Archived Version
   * @return {Promise} [description]
   */
  clearArchivedVersion: function clearArchivedVersion() {
    return (0, _Izenda2.default)(ROOT_URL + 'deleteAllArchiveVersions').post();
  },
  postPrintDraftData: function postPrintDraftData(draftData) {
    return (0, _Izenda2.default)(ROOT_URL + 'printDraft').post(draftData);
  },
  getPrintDraftData: function getPrintDraftData(draftId) {
    return (0, _Izenda2.default)(ROOT_URL + 'printDraft/' + draftId).get();
  },
  validateRequiredFilters: function validateRequiredFilters(reportId) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateFilter/' + reportId).get();
  },


  /**
   * Load all report Categories
   * @param  {Object} data [description]
   * @return {Promise}      [description]
   */
  lazyLoadingReports: function lazyLoadingReports(data, includeHashCode) {
    var url = 'list2';
    url += !(0, _fp.isNil)(includeHashCode) ? '?includeHashCode=' + includeHashCode : '';
    return (0, _Izenda2.default)(ROOT_URL + url).post(data);
  },


  /**
   * Get all categories
   * @param {Object} param
   * @returns {promise}
   */
  loadLazyLoadingCategories: function loadLazyLoadingCategories(param) {
    return (0, _Izenda2.default)(ROOT_URL + 'allcategories/').post(param);
  },


  /**
   * Search report Categories
   * @param  {Object} data [description]
   * @return {Promise} array of ReportCategories
   */
  lazyLoadingSearchCategories: function lazyLoadingSearchCategories(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'list2').post(request);
  },


  /**
   * Load categories data for lazy loading
   * @param {Object} request 
   */
  loadLazyLoadingAllowedSavingCategories: function loadLazyLoadingAllowedSavingCategories(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'allowedSavingCategories').post(request);
  },


  /**
   * Load subcategory for dashboard (lazyload)
   */
  loadLazyLoadAllowedSavingSubCategories: function loadLazyLoadAllowedSavingSubCategories(searchFilter) {
    return (0, _Izenda2.default)(ROOT_URL + 'allowedSavingSubCategories').post(searchFilter);
  }
};

_Izenda4.default.linkToLoadingProgress(fetchers, {
  updateSubscriptions: {
    allowToCancel: false
  },

  renameReport: {
    allowToCancel: false
  },

  deleteReport: {
    allowToCancel: false
  },

  deleteReportCategory: {
    allowToCancel: false
  },

  copyNewReport: {
    allowToCancel: false
  },

  moveReport: {
    allowToCancel: false
  },

  deleteReportHistory: {
    allowToCancel: false
  },

  lazyLoadingReports: {
    allowToCancel: false
  },

  loadLazyLoadingCategories: {
    allowToCancel: false
  },

  lazyLoadingSearchCategories: {
    allowToCancel: false
  }
});

exports.default = fetchers;
module.exports = exports['default'];

/***/ }),
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(72);

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var INDETERMINATE_STATUS = 2;
var CHECKED_STATUS = 1;
var UNCHECK_STATUS = 0;

/**
 * Toggle section
 * @param {Object} props
 * @param {String} propsName
 * @param {Object} event
 */
var toggle = function toggle(props, propsName, event) {
  props.permissionStore[propsName] = !props.permissionStore[propsName];
};

/**
 * get Icon Class
 * @param  {object} props
 * @param  {string} propsName
 * @return {string} iconClass
 */
var getIconClass = function getIconClass(props, propsName) {
  return props.permissionStore[propsName] ? _Izenda.ICON_TRIANGLE.ICON_DOWN : _Izenda.ICON_TRIANGLE.ICON_RIGHT;
};

/**
 * Update section
 * @param {Object} props
 * @param {String} section
 * @param {Boolean} isLast
 */
var updateSectionCommon = function updateSectionCommon(props, section, isLast) {
  if (!props.permissionStore.model.isClickedSection) {
    props.permission.updateSection(section);
  }

  if (isLast) {
    props.permissionStore.model.isClickedSection = false;
  }
};

/**
 * Get indeterminate
 * @param {Object} props
 * @param {Object} data
 * @returns {Boolean} indeterminate
 */
var getIndeterminateCommon = function getIndeterminateCommon(props, data) {
  return data.tenantAccess === INDETERMINATE_STATUS;
};

/**
 * Update section
 * @param {Object} props
 * @param {String} section
 */
var getCheckedCommon = function getCheckedCommon(props, data) {
  if ((0, _fp.isNumber)(data)) {
    return data === CHECKED_STATUS;
  } else {
    return data;
  }
};

/**
 * Check show group common
 * @param {Object} props
 * @param {String} data
 * @return {Boolean} showGroupStatus
 */
var checkShowGroupCommon = function checkShowGroupCommon(props, data) {
  var newData = (0, _mobx.isObservable)(data) ? (0, _fp.cloneDeep)(data) : data;
  newData = (0, _fp.omit)(['propsCloned', 'section', 'isTenantSetup', 'cleanDirty', 'isDirty'], newData);

  var result = {
    isShowByTenantAccess: (0, _fp.isNil)(data.tenantAccess) ? false : data.tenantAccess !== UNCHECK_STATUS,
    isShowByOtherFields: false
  };

  /**
   * Check show group common
   * @param {Object} obj
   * @param {Object} result
   */
  var checkShowGroupByOtherFields = function checkShowGroupByOtherFields(obj, result) {
    for (var key in (0, _fp.omit)('tenantAccess', obj)) {
      if (!(0, _fp.isFunction)(obj[key]) && !(0, _mobx.isObservableArray)(obj[key])) {
        if ((0, _fp.isPlainObject)(obj[key])) {
          checkShowGroupByOtherFields(obj[key], result);
        } else {
          result.isShowByOtherFields = result.isShowByOtherFields || obj[key];
        }
      }
    }
  };

  /**
   * Check show group by tenant access commonF
   * @param {Object} props
   * @param {Object} result
   */
  var checkShowGroupByTenantAccess = function checkShowGroupByTenantAccess(obj, result) {
    if (obj.tenantAccess === UNCHECK_STATUS) return false;

    var checkTenantAccess = function checkTenantAccess(result, obj) {
      for (var key in obj) {
        if ((0, _fp.isPlainObject)(obj[key])) {
          checkTenantAccess(result, obj[key]);
        } else {
          if (key === 'tenantAccess') {
            result.isShowByTenantAccess = result.isShowByTenantAccess || obj[key] !== UNCHECK_STATUS;
          }
        }
      }
    };

    checkTenantAccess(result, (0, _fp.omit)('tenantAccess', obj));
  };

  checkShowGroupByTenantAccess(newData, result);
  checkShowGroupByOtherFields(newData, result);

  return result.isShowByTenantAccess && result.isShowByOtherFields;
};

/**
 * Permission Update Data
 * @param {Object} props
 * @param {Object} data
 * @param {String} value
 * @param {Object} event
 */
var permissionUpdateData = function permissionUpdateData(props, data, value, event) {
  props.permission.updateData(data, value, event.target.checked);
};

/**
 * Permission Update Tenant Access
 * @param {Object} props
 * @param {Object} data
 * @param {Object} value
 * @param {Object} event
 */
var permissionUpdateTenantAccess = function permissionUpdateTenantAccess(props, data, value, event) {
  props.permission.updateTenantAccess(data, value, event.target.checked);
};

/**
 * Permission Update Tenant Access Parent
 * @param {Object} props
 * @param {Object} data
 * @param {Object} event
 */
var permissionUpdateTenantAccessParent = function permissionUpdateTenantAccessParent(props, data, event) {
  props.permission.updateTenantAccessParent(data, event.target.checked);
};

var PermissionActions = (0, _recompose.compose)((0, _recompose.withHandlers)({
  toggle: (0, _fp.curry)(toggle),
  getIconClass: (0, _fp.curry)(getIconClass),
  updateSectionCommon: (0, _fp.curry)(updateSectionCommon),
  getIndeterminateCommon: (0, _fp.curry)(getIndeterminateCommon),
  getCheckedCommon: (0, _fp.curry)(getCheckedCommon),
  checkShowGroupCommon: (0, _fp.curry)(checkShowGroupCommon),
  permissionUpdateData: (0, _fp.curry)(permissionUpdateData),
  permissionUpdateTenantAccess: (0, _fp.curry)(permissionUpdateTenantAccess),
  permissionUpdateTenantAccessParent: (0, _fp.curry)(permissionUpdateTenantAccessParent),
  getRolePermission: function getRolePermission(props) {
    return function () {
      if (!props.permissionStore.isTenantSetup || !(0, _fp.isNil)(props.permissionStore.tenantId)) {
        props.permissionStore.getRolePermission();
      }
    };
  },
  getCategoryAccessibility: function getCategoryAccessibility(props) {
    return function () {
      // get category accessibility for dashboard
      props.permissionStore.loadLazyCategory(props.permissionStore.dashboardCategoryAccessibility, _Izenda.CATEGORY_TYPE.DASHBOARD);
      // get category accessibility for report
      props.permissionStore.loadLazyCategory(props.permissionStore.reportCategoryAccessibility, _Izenda.CATEGORY_TYPE.REPORT);
    };
  }
}));

exports.default = PermissionActions;
module.exports = exports['default'];

/***/ }),
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  PROVISIONING_STATUS: {
    NOT_STARTED: 0,
    PROVISIONING: 1,
    SUCCESS: 2,
    ERROR: 3
  },
  DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
  DATE_TIME_FORMAT_WITH_TIMEZONE: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  DATE_FORMAT: 'YYYY-MM-DD',
  TIME_FORMAT: 'HH:mm:ss',
  get DEFAULT_VALUES() {
    return {
      GLOBAL_NAME: _Izenda2.default.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_GLOBAL_NAME'),
      LOCAL_NAME: _Izenda2.default.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_LOCAL_NAME')
    };
  },
  LOCAL_CATEGORY_NAME: 32,
  GLOBAL_CATEGORY_NAME: 64,
  SELECTED_TENANT_COOKIE_NAME: 'selected_tenant'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.AppGlobalConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(150);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty4 = __webpack_require__(20);

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6; // ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoadingUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.concatTree = concatTree;
exports.updateTree = updateTree;
exports.concatArray = concatArray;
exports.parseToTree = parseToTree;
exports.updateInteractiveTree = updateInteractiveTree;

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty5.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var TreeNode = (_class = function () {
  function TreeNode(data) {
    (0, _classCallCheck3.default)(this, TreeNode);

    _initDefineProp(this, 'nodeType', _descriptor, this);

    _initDefineProp(this, 'source', _descriptor2, this);

    _initDefineProp(this, 'isLeafNode', _descriptor3, this);

    _initDefineProp(this, 'showTotal', _descriptor4, this);

    _initDefineProp(this, 'expand', _descriptor5, this);

    _initDefineProp(this, 'disabled', _descriptor6, this);

    this.map = {};
    this.childNodes = [];
    this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} data
   */


  (0, _createClass3.default)(TreeNode, [{
    key: 'populateData',
    value: function populateData(data) {
      this.nodeType = data.mapItem.nodeType;
      this.source = data.child;
      this.expand = (0, _fp.isNil)(data.child.expand) ? data.mapItem.expand : data.child.expand;
      this.isLeafNode = (0, _fp.isNil)(data.mapItem.children);
      this.showTotal = data.mapItem.showTotal;
      this.disabled = data.mapItem.disabledIfNoChild && (0, _fp.isEmpty)(data.childNodes);
      this.childNodes = data.childNodes;
      this.map = data.mapItem;
    }

    /**
     * Change state tree node
     */

  }, {
    key: 'onChange',
    value: function onChange(source, parent, event) {
      return onChangeNode(this.map.children, source, parent, event);
    }

    /**
     * Get Child Nodes
     * @return {Array}
     */

  }, {
    key: 'getChildNodes',
    value: function getChildNodes() {
      return this.isLeafNode ? [] : this.childNodes;
    }
  }]);
  return TreeNode;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'nodeType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'source', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'isLeafNode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'showTotal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'expand', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'disabled', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'populateData'), _class.prototype)), _class);

/**
 * Concat tree
 * @param {Array} tree
 * @param {Array} newData
 * @param {Object} treeMap
 * @param {Number} numOfChilds
 * @param {Array} parentIds
 */

function concatTree(tree, newData, treeMap, numOfChilds, parentIds) {
  // Append new data when original tree is empty
  if ((0, _fp.isEmpty)(tree)) {
    newData.forEach(function (data, index) {
      tree.push(data);
      if (index === newData.length - 1) {
        createVirtualNode(tree, data, treeMap, numOfChilds, parentIds);
      }
    });

    return;
  }

  // recursive to concat data to original tree base on tree map
  recursiveConcat(tree, newData, treeMap, numOfChilds, parentIds, null, false);

  function recursiveConcat(recTree, recData, recMap, numOfChilds, parentIds, parentStatus, isLastPage) {
    recData.forEach(function (data, index) {
      var node = (0, _fp.find)(['id', data.id], recTree);

      // check node existing in original tree
      if (node) {
        (0, _fp.forEach)(function (map) {
          // Create next parent id array
          var nextParentIds = (0, _fp.clone)(parentIds);
          nextParentIds.push(data.id);
          var status = {
            checked: node.checked,
            indeterminate: node.indeterminate
          };

          // continue to recursive concat for while this node doesn't existing in original tree
          recursiveConcat(node[map.prop], data[map.prop], map.children, data.numOfChilds, nextParentIds, status, data.isLastPage);
        }, recMap);
      } else {
        // if original tree branch has virtual node, it always remove virtual node first
        (0, _fp.some)('isVirtualNode', recTree) && recTree.splice(recTree.length - 1, 1);

        // Update child checked if parent status with indeterminate flase or checked is true
        if (parentStatus && !(0, _fp.isNil)(parentStatus.checked) && !(!parentStatus.checked && parentStatus.indeterminate)) {
          updateChildChecked(data, parentStatus.checked);
        }
        // append data to original tree branch
        recTree.push(data);

        // append a virtual node at last position
        if (!isLastPage && index === recData.length - 1) {
          createVirtualNode(recTree, data, recMap, numOfChilds, parentIds);
        }
      }
    });

    // If data for a virtual node is empty, we also remove this virtual node.
    (0, _fp.isEmpty)(recData) && (0, _fp.some)('isVirtualNode', recTree) && recTree.splice(recTree.length - 1, 1);
  }
}

/**
 * Update child checked
 * @param  {Object} data
 * @param  {boolean} checked
 */
function updateChildChecked(data, checked) {
  data.checked = checked;
  data.indeterminate = false;
  data.numOfCheckedChilds = checked ? data.numOfChilds : 0;
  data.childNodes && data.childNodes.forEach(function (child) {
    return updateChildChecked(child, checked);
  });
}

/**
 * Update Tree Node
 * @param  {Array} tree
 * @param  {Array} newTree
 * @param  {Array} treeMap
 * @param  {Array} props
 */
function updateTree(tree, newTree, treeMap, props) {
  if ((0, _fp.isEmpty)(newTree)) {
    return;
  }

  // recursive to concat data to original tree base on tree map
  recursiveUpdate(tree, newTree, treeMap);

  function recursiveUpdate(recTree, recData, recMap) {
    (0, _fp.forEach)(function (data) {
      var node = (0, _fp.find)(['id', data.id], recTree);

      // check node existing in original tree
      if (node) {
        var numOfCheckedChilds = (0, _fp.reduce)(function (total, item) {
          return item.checked ? total + 1 : total;
        }, 0, data.childNodes);
        if (data.checked || !(data.checked || data.indeterminate) || data.numOfCheckedChilds === numOfCheckedChilds && data.interacted) {
          node.childNodes && node.childNodes.forEach(function (child) {
            child.checked = data.checked;
            child.indeterminate = false;
          });
        }
        // Update value
        var keys = (0, _keys2.default)(node);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if (needUpdate(key) && (0, _typeof3.default)(node[key]) !== 'object' && node[key] !== data[key]) {
            node[key] = data[key];
          }
        }

        (0, _fp.forEach)(function (map) {
          // continue to recursive concat for while this node doesn't existing in original tree
          recursiveUpdate(node[map.prop], data[map.prop], map.children);
        }, recMap);
      }
    }, recData);
  }

  function needUpdate(key) {
    return (0, _fp.isNil)(props) ? true : (0, _fp.includes)(key, props);
  }
}

/**
 * Concat array
 * @param  {Array} tree
 * @param  {Array} data
 * @param  {String} key
 * @param  {Boolean} needVirtualNode
 * @return {Array} tree modified
 */
function concatArray(tree, data, key, needVirtualNode) {
  if ((0, _fp.isEmpty)(tree)) {
    data.forEach(function (d, index) {
      tree.push(d);
      needVirtualNode && index === data.length - 1 && tree.push(virtualNode([], tree.length));
    });
    return tree;
  }

  // if original tree branch has virtual node, it always remove virtual node first
  (0, _fp.some)('isVirtualNode', tree) && tree.splice(tree.length - 1, 1);

  // append data to original tree branch
  data.forEach(function (i) {
    return !(0, _fp.some)((0, _defineProperty3.default)({}, key, i[key]), tree) && tree.push(i);
  });

  // append a virtual node at last position
  needVirtualNode && tree.push(virtualNode([], tree.length));
  return tree;
}

/**
 * Create virtual node
 * @param {any} recTree
 * @param {any} data
 * @param {any} recMap
 * @param {any} numOfChilds
 * @param {any} parentIds
 */
function createVirtualNode(recTree, data, recMap, numOfChilds, parentIds) {
  // Create virtual node for itself
  if (numOfChilds !== recTree.length) {
    recTree.push(virtualNode(parentIds, recTree.length));
  }

  parentIds.push(data.id);
  recursiveCreate(data, recMap, parentIds);

  function recursiveCreate(data, recMap, parentIds) {
    (0, _fp.forEach)(function (map) {
      var nextNodeList = data[map.prop];
      if (!(0, _fp.isEmpty)(nextNodeList)) {
        var latestNode = nextNodeList[nextNodeList.length - 1];
        var nextParentIds = (0, _fp.clone)(parentIds);
        nextParentIds.push(latestNode.id);
        recursiveCreate(latestNode, map.children, nextParentIds);
        if (!data.isLastPage && data.numOfChilds !== nextNodeList.length) {
          nextNodeList.push(virtualNode(parentIds, nextNodeList.length));
        }
      }
    }, recMap);
  }
}

function virtualNode(parentIds, fromIndex) {
  return {
    id: (0, _fp.uniqueId)('VirtualNode_'),
    name: 'Virtual Node',
    isVirtualNode: true,
    isRendering: false,
    parentIds: parentIds,
    fromIndex: fromIndex
  };
}

/**
 * Build report tree
 * @param {Object} props
 * @param {Object} data
 * @returns {Object} tree
 */
function parseToTree(data, treeMap) {
  var getChildren = function getChildren(mapItem, firstNode, parentId, child) {
    var childNodes = [],
        parentStatus = this;

    if (parentStatus && !parentStatus.indeterminate) {
      child.checked = parentStatus.checked;
      child.indeterminate = false;
    }
    if (!child.indeterminate) {
      child.numOfCheckedChilds = child.checked ? child.numOfChilds : 0;
    }

    (0, _fp.isNil)(child.name) && (child.name = mapItem.defaultName);
    var status = {
      checked: child.checked,
      indeterminate: child.indeterminate
    };

    var isLeafNode = (0, _fp.isNil)(mapItem.children);
    !isLeafNode && (0, _fp.forEach)(function (m) {
      var nodes = (0, _fp.flow)((0, _fp.map)(getChildren.bind(status, m, false, child.id)), (0, _fp.filter)(function (c) {
        return !(0, _fp.isNil)(c);
      }))(child[m.prop]);

      childNodes = childNodes.concat(nodes);
    }, mapItem.children);

    return new TreeNode({
      mapItem: mapItem,
      child: child,
      firstNode: firstNode,
      childNodes: childNodes
    });
  };

  var childNodes = [];
  (0, _fp.forEach)(function (mapItem) {
    var nodes = (0, _fp.flow)((0, _fp.map)(getChildren.bind(null, mapItem, true, null)), (0, _fp.filter)(function (c) {
      return !(0, _fp.isNil)(c);
    }))(data);
    childNodes = childNodes.concat(nodes);
  }, treeMap);

  return childNodes;
}

/**
 * onchange node
 * @param {Array} treeMap
 * @param {Object} source
 * @param {Object} parent
 * @param {Object} input
 */
function onChangeNode(childrenMap, source, parent, e) {
  var check = e.target.checked;
  var previousStatus = getPreviousStatus(source);

  updateNodeInfo(source, check);
  updateChildNodeInfo(source, check, childrenMap);
  updateParentNode(parent, check, previousStatus, source.indeterminate);
}

/**
 * Get previous status
 * @param  {Object} source
 * @return {Boolean}
 */
function getPreviousStatus(source) {
  return source.indeterminate ? false : source.checked;
}

/**
 * Update node information
 * @param {Object} source
 * @param {Boolean} check
 */
function updateNodeInfo(source, check) {
  source.checked = check;
  !(0, _fp.isNil)(source.indeterminate) && (source.indeterminate = false);
  !(0, _fp.isNil)(source.numOfCheckedChilds) && !(0, _fp.isNil)(source.numOfChilds) && (check ? source.numOfCheckedChilds = source.numOfChilds : source.numOfCheckedChilds = 0);
}

/**
 * Update child node information
 * @param {Object} source
 * @param {Boolean} check
 * @param {Array} treeMap
 * @param {Number} level
 */
function updateChildNodeInfo(source, check, childrenMap) {
  (0, _fp.forEach)(function (map) {
    (0, _fp.forEach)(function (child) {
      updateNodeInfo(child, check);
      updateChildNodeInfo(child, check, map.children);
    }, source[map.prop]);
  }, childrenMap);
}

/**
 * update parent node
 * @param {Object} parent
 * @param {Object} check
 */
function updateParentNode(parent, check, previousStatus, parentIndeterminate) {
  if (!(0, _fp.isNil)(parent)) {
    var parentSource = parent.data.source;
    if (parentIndeterminate) {
      previousStatus && parentSource.numOfCheckedChilds--;
      previousStatus = getPreviousStatus(parentSource);
      parentSource.indeterminate = true;
    } else {
      if (check) {
        parentSource.numOfCheckedChilds++;
        if (parentSource.numOfCheckedChilds === parentSource.numOfChilds) {
          parentSource.checked = true;
          parentSource.indeterminate = false;
        } else {
          parentSource.indeterminate = true;
        }
      } else {
        previousStatus && parentSource.numOfCheckedChilds--;
        previousStatus = getPreviousStatus(parentSource);
        if (parentSource.numOfCheckedChilds === 0 && (0, _fp.every)(function (item) {
          return !item.source.indeterminate;
        }, parent.data.childNodes)) {
          parentSource.checked = false;
          parentSource.indeterminate = false;
        } else {
          parentSource.indeterminate = true;
        }
      }
    }

    if (!(0, _fp.isNil)(parent.parent)) {
      updateParentNode(parent.parent, parentSource.checked, previousStatus, parentSource.indeterminate);
    }
  }
}

/**
 * Update interactive tree
 * @param {Array} node
 * @param {Object} parent
 * @param {Object} tree
 */
function updateInteractiveTree(node, parent, tree) {
  var singleTree = buildInteractiveTree(node);
  singleTree.interacted = true;
  while (parent !== null) {
    singleTree = buildInteractiveTree(parent.data, singleTree);
    parent = parent.parent;
  }

  recursiveUpdateInteractiveTree(tree, singleTree);
}

/**
 * Build interactive tree
 * @param  {Object} parent
 * @param  {Object} child
 * @return {Object}
 */
function buildInteractiveTree(parent, child) {
  var newItem = (0, _fp.pick)(['id', 'name', 'checked', 'interacted', 'indeterminate', 'numOfCheckedChilds', 'uncheckedSSO'], parent.source);
  newItem.childNodes = child ? [child] : [];

  return newItem;
}

/**
 * Recursive update interactive tree
 * @param  {Array} caches
 * @param  {Object} treeItem
 */
function recursiveUpdateInteractiveTree(caches, treeItem) {
  var cacheItem = (0, _fp.find)(function (item) {
    return item.id === treeItem.id;
  }, caches);
  if (cacheItem) {
    cacheItem.checked = treeItem.checked;
    cacheItem.interacted = cacheItem.interacted || treeItem.interacted;
    cacheItem.indeterminate = treeItem.indeterminate;
    cacheItem.numOfCheckedChilds = treeItem.numOfCheckedChilds;

    if ((0, _fp.isEmpty)(cacheItem.childNodes)) {
      cacheItem.childNodes = treeItem.childNodes;
    } else if ((0, _fp.isEmpty)(treeItem.childNodes)) {
      cacheItem.childNodes = [];
    } else {
      recursiveUpdateInteractiveTree(cacheItem.childNodes, treeItem.childNodes[0]);
    }
  } else {
    caches.push(treeItem);
  }
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DELIVERY_METHOD = {
  link: 'link',
  embedded: 'Embedded HTML',
  attachment: 'attachment'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  EMAIL: {
    sale: 'mailto:sales@izenda.com',
    licenseAssistance: 'mailto:sales@izenda.com?Subject=License%20Assistance',
    connectionStringAssistance: 'mailto:customersupport@izenda.com?Subject=Connection%20String%20Assistance'
  },
  MESSAGE: {
    M12a: _Izenda2.default.getText('EMAIL_MESSAGE_SENT_SUCCESSFULLY'),
    M12b: _Izenda2.default.getText('EMAIL_MESSAGE_SENT_FAIL')
  },
  get REQUIRE_CONSTRAINTS() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('EMAIL_MESSAGE_CONSTRAINT')
      }
    };
  },
  get EMAIL_VALIDATION() {
    return {
      REGEX: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      MESSAGE: function MESSAGE(emails) {
        return _Izenda2.default.getText('EMAIL_MESSAGE_VALIDATION') + emails.join('; ');
      }
    };
  },
  DELIVERY_METHOD: DELIVERY_METHOD,
  DELIVERY_OPTIONS: [{
    value: DELIVERY_METHOD.link,
    key: 'EmailingDeliveryMethodLink',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_LINK');
    }
  }, {
    value: DELIVERY_METHOD.embedded,
    key: 'EmailingDeliveryMethodEmbeddedHTML',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EMBEDDED_HTML');
    }
  }, {
    value: DELIVERY_METHOD.attachment,
    key: 'EmailingDeliveryMethodAttachment',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ATTACHMENT');
    }
  }],
  ATTACH_TYPE_OPTIONS: [{ value: 'Word', label: 'Word', key: 'EmailingAttachmentTypeWord' }, { value: 'Excel', label: 'Excel', key: 'EmailingAttachmentTypeExcel' }, { value: 'Pdf', label: 'PDF', key: 'EmailingAttachmentTypePdf' }, { value: 'Csv', label: 'CSV', key: 'EmailingAttachmentTypeCsv' }, { value: 'Xml', label: 'XML', key: 'EmailingAttachmentTypeXml' }, { value: 'Json', label: 'JSON', key: 'EmailingAttachmentTypeJson' }, {
    value: 'Definition',
    key: 'EmailingAttachmentTypeDefinition',
    get label() {
      return _Izenda2.default.getText('PERMISSION_LABEL_DEFINITION');
    }
  }],
  EMAIL_TYPE: {
    report: 'report',
    dashboard: 'dashboard'
  },
  EMAIL_SUBJECT: {
    KEY: 'Subject',
    CLASS: '.email-subject',
    DEFAULT: {
      report: '{reportName}',
      dashboard: '{dashboardName}'
    }
  },
  EMAIL_BODY: {
    KEY: 'Body',
    CLASS: '.email-body'
  },
  TEMPLATE_TYPE: 2
};
module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _typeof2 = __webpack_require__(150);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityManager.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
// $FlowFixMe

// $FlowFixMe


var _ensure = __webpack_require__(38);

var _ensure2 = _interopRequireDefault(_ensure);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(42);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(45);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(815);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(483);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(484);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _mobx = __webpack_require__(5);

var _Izenda13 = __webpack_require__(245);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SecurityManager = (_class = function () {
  function SecurityManager() {
    (0, _classCallCheck3.default)(this, SecurityManager);
  }

  (0, _createClass3.default)(SecurityManager, [{
    key: 'setAccessToken',


    /**
     * Set access token
     * @param {String} token
     */
    value: function setAccessToken(token) {
      _Izenda14.default.setAccessToken(token);
    }

    /**
     * Get access token
     * @returns {String} access token
     */

  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      return _Izenda14.default.getAccessToken();
    }

    /**
     * Remove authorization cookie
     */

  }, {
    key: 'removeAuthCookies',
    value: function removeAuthCookies() {
      _Izenda14.default.removeAuthCookies();
    }

    /**
     * Clear data
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.removeAuthCookies();
      _Izenda12.default.clear();
    }

    /**
     * Clear permission
     */

  }, {
    key: 'clearPermission',
    value: function clearPermission() {
      _Izenda12.default.clear();
    }

    /**
     * Check privileges
     * @param {Array} keys array which has 3 types: array of string, array of object(left, operator, right) and function.
     * @param {String} operator
     * @returns {Boolean} has privileges
     */

  }, {
    key: 'checkPrivileges',
    value: function checkPrivileges(keys, operator) {
      var _this = this;

      (0, _ensure2.default)(keys, 'permission keys must be set');

      var hasPrivilege = void 0;
      var permission = _Izenda12.default.permission;

      if ((0, _fp.isNil)(permission) || (0, _fp.isNil)(this.getAccessToken())) {
        return null;
      } else {
        if ((0, _fp.isFunction)(keys)) {
          return keys.call(this, permission);
        }

        (0, _fp.forEach)(function (key) {
          if ((0, _fp.isObject)(key)) {
            if ((0, _fp.isNil)(hasPrivilege)) {
              hasPrivilege = _this.checkPrivilegesByObject(key, permission);
            } else {
              if (!(0, _fp.isNil)(operator) && operator === _Izenda2.default.PERMISSION_OPERATOR.Or) {
                hasPrivilege = hasPrivilege || _this.checkPrivilegesByObject(key, permission);
              } else {
                hasPrivilege = hasPrivilege && _this.checkPrivilegesByObject(key, permission);
              }
            }
          } else {
            if ((0, _fp.isNil)(hasPrivilege)) {
              hasPrivilege = _this.checkPrivilegesByKey(key, permission);
            } else {
              if (!(0, _fp.isNil)(operator) && operator === _Izenda2.default.PERMISSION_OPERATOR.Or) {
                hasPrivilege = hasPrivilege || _this.checkPrivilegesByKey(key, permission);
              } else {
                hasPrivilege = hasPrivilege && _this.checkPrivilegesByKey(key, permission);
              }
            }
          }
        }, keys);

        return hasPrivilege;
      }
    }

    /**
     * Check privileges by object type
     * @param {String} permission key
     * @param {Object} permission data
     * @returns {Boolean} has privileges
     */

  }, {
    key: 'checkPrivilegesByObject',
    value: function checkPrivilegesByObject(key, permission) {
      var hasLeftPrivilege = false;
      if ((0, _fp.isObject)(key.left)) {
        hasLeftPrivilege = this.checkPrivilegesByObject(key.left, permission);
      } else {
        hasLeftPrivilege = (0, _fp.get)(key.left, permission);
      }

      var hasRightPrivilege = false;
      if ((0, _fp.isObject)(key.right)) {
        hasRightPrivilege = this.checkPrivilegesByObject(key.right, permission);
      } else {
        hasRightPrivilege = (0, _fp.get)(key.right, permission);
      }

      var operator = key.operator;
      if (operator === _Izenda2.default.PERMISSION_OPERATOR.Or) {
        return hasLeftPrivilege || hasRightPrivilege;
      } else {
        return hasLeftPrivilege && hasRightPrivilege;
      }
    }

    /**
     * Check privileges by key
     * @param {String} permission key
     * @param {Object} permission data
     * @returns {Boolean} has privileges
     */

  }, {
    key: 'checkPrivilegesByKey',
    value: function checkPrivilegesByKey(key, permission) {
      return (0, _fp.get)(key, permission);
    }

    /**
     * Check login status.
     */

  }, {
    key: 'checkLoginStatus',
    value: function checkLoginStatus() {
      return !(0, _fp.isNil)(_Izenda14.default.getAccessToken());
    }

    /**
     * Check is system running under integration mode.
     */

  }, {
    key: 'isIntegrationMode',
    value: function isIntegrationMode() {
      return _Izenda8.default.isIntegrationMode;
    }

    /**
     * Check license
     */

  }, {
    key: 'checkLicense',
    value: function checkLicense(key) {
      (0, _ensure2.default)(key, 'license key must be set');

      var licenseModules = _Izenda6.default.currentUser.currentModules;
      if ((0, _fp.isNil)(licenseModules) || (0, _fp.isNil)(this.getAccessToken())) {
        return null;
      } else {
        if ((0, _fp.isFunction)(key)) {
          return key.call(this, licenseModules);
        }

        var hasLicense = !(0, _fp.isEmpty)((0, _fp.filter)(function (module) {
          return (0, _fp.isEqual)(module, key);
        }, licenseModules));

        return hasLicense;
      }
    }

    /**
     * Get default link
     */

  }, {
    key: 'getDefaultLink',
    value: function getDefaultLink(routeUtils) {
      var noLicenseSetup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var links = [{
        key: _Izenda4.default.LICENSE_KEY.ReportDesigner,
        url: routeUtils.getRouteUrl(routeUtils.getConfigRoute('Report'))
      }, {
        key: _Izenda4.default.LICENSE_KEY.Dashboard,
        url: routeUtils.getRouteUrl(routeUtils.getConfigRoute('Dashboard'))
      }, { url: routeUtils.getRouteUrl(routeUtils.getConfigRoute('Settings')) }];

      var accessToken = _Izenda14.default.getAccessToken();
      var licenseModules = _Izenda10.default.modules;
      if ((0, _fp.isNil)(accessToken)) {
        return routeUtils.getRouteUrl(routeUtils.getConfigRoute('Account', 'Login'));
      } else {
        if ((0, _fp.isNil)(licenseModules) || noLicenseSetup) {
          return routeUtils.getRouteUrl(routeUtils.getConfigRoute('Settings'));
        } else {
          var _loop = function _loop(i) {
            var link = (0, _fp.find)(function (module) {
              return (0, _fp.isNil)((0, _fp.get)('key', links[i])) || (0, _fp.isEqual)(module.name, (0, _fp.get)('key', links[i]));
            }, licenseModules);
            if (!(0, _fp.isNil)(link)) {
              return {
                v: links[i].url
              };
            }
          };

          for (var i = 0; i < links.length; i++) {
            var _ret = _loop(i);

            if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
          }
        }
      }

      return routeUtils.getRouteUrl(routeUtils.getConfigRoute('Report'));
    }
  }, {
    key: 'isCompleteLoad',
    get: function get() {
      return _Izenda12.default.isLoaded;
    }
  }]);
  return SecurityManager;
}(), (_applyDecoratedDescriptor(_class.prototype, 'isCompleteLoad', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isCompleteLoad'), _class.prototype)), _class);
exports.default = SecurityManager;
module.exports = exports['default'];

/***/ }),
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormGroup;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.FormGroup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * FormGroup Component
 */

function FormGroup(props) {
  var className = props.className,
      children = props.children;

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(className, 'form-group') },
    children
  );
}
module.exports = exports['default'];

/***/ }),
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD_USER_TABLE_DEF = {
  selected: { key: 'selected', width: 30, title: '', sortable: false, columnKey: 'selected ', fixed: true },
  fullName: {
    key: 'fullName',
    width: 250,
    get title() {
      return _Izenda2.default.getText('USER_LABEL_USER_NAME');
    },
    sortable: true,
    columnKey: 'fullName',
    fixed: true
  },
  emailAddress: {
    key: 'emailAddress',
    width: 250,
    get title() {
      return _Izenda2.default.getText('USER_LABEL_EMAIL_ADDRESS');
    },
    sortable: true,
    columnKey: 'emailAddress',
    fixed: true
  },
  roles: {
    key: 'roles',
    width: 320,
    get title() {
      return _Izenda2.default.getText('USER_LABEL_ROLE');
    },
    sortable: false,
    columnKey: 'roles'
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.UserAccountConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

var SEARCH_OPTIONS = [{
  value: 'all',
  get label() {
    return _Izenda2.default.getText('USER_LABEL_ALL');
  }
}, {
  value: 'fullName',
  get label() {
    return _Izenda2.default.getText('USER_LABEL_USER_NAME');
  }
}, {
  value: 'emailAddress',
  get label() {
    return _Izenda2.default.getText('USER_LABEL_EMAIL_ADDRESS');
  }
}, {
  value: 'role',
  get label() {
    return _Izenda2.default.getText('USER_LABEL_ROLE');
  }
}];

exports.default = {
  DEFAULT_VALUE: {
    SEARCH_CRITERIA: 'all',
    SORT_DIRS: {
      fullName: 'DESC'
    }
  },
  ADD_USER_TABLE_DEF: ADD_USER_TABLE_DEF,
  SEARCH_OPTIONS: SEARCH_OPTIONS,
  PASSWORD_OPSTIONS: {
    EMAIL_NEW_PASSWORD_CONSTRAINTS: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('USER_MESSAGE_FIELD_IS_REQUIRED');
        }
      }
    },
    get SEND_PASSWORD() {
      return _Izenda2.default.getText('USER_MESSAGE_SEND_PASSWORD');
    },
    get EMAIL() {
      return _Izenda2.default.getText('USER_MESSAGE_EMAIL');
    }
  },
  USER_STATE: {
    get ACTIVATE() {
      return _Izenda2.default.getText('USER_STATE_ACTIVATE');
    },
    get DEACTIVATE() {
      return _Izenda2.default.getText('USER_STATE_DEACTIVATE');
    }
  },
  MESSAGE: {
    get DEACTIVE() {
      return _Izenda2.default.getText('USER_MESSAGE_DEACTIVE');
    },
    get DELETE() {
      return _Izenda2.default.getText('USER_MESSAGE_DELETE');
    },
    get LAST_SYSTEM_ADMIN() {
      return _Izenda2.default.getText('USER_MESSAGE_DELETE_LAST_SYSTEM_ADMIN');
    }
  },
  INACTIVE_REASON: {
    get 1() {
      return _Izenda2.default.getText('USER_INACTIVE_REASON_ACTIVE');
    },
    get 2() {
      return _Izenda2.default.getText('USER_INACTIVE_REASON_INACTIVE_USER');
    },
    get 3() {
      return _Izenda2.default.getText('USER_INACTIVE_REASON_INACTIVE_PASSWORD');
    },
    get 4() {
      return _Izenda2.default.getText('USER_INACTIVE_REASON_INACTIVE_LOGIN');
    },
    get INTEGRATION() {
      return _Izenda2.default.getText('USER_INACTIVE_REASON_INTEGRATION');
    }
  },
  NUMBER_INACTIVE_REASON_STATUS: {
    ACTIVE: 1,
    DEACTIVATED: 2,
    NO_PASSWORD_SET: 3,
    FAILED_LOGIN: 4
  },
  USER_SETUP_CONSTRAINTS: {
    USER_ID: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('USER_MESSAGE_USER_ID_IS_REQUIRED');
        }
      }
    },
    FIRST_NAME: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('USER_MESSAGE_FIRST_NAME_IS_REQUIRED');
        }
      }
    },
    LAST_NAME: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('USER_MESSAGE_LAST_NAME_REQUIRED');
        }
      }
    },
    ROLE: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('USER_MESSAGE_ROLE_IS_REQUIRED');
        }
      }
    },
    RECIPIENTS: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('USER_MESSAGE_RECIPIENT_IS_REQUIRED');
        }
      }
    },
    EMAIL: {
      format: {
        pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message: function message(value, attribute, validatorOptions, attributes, globalOptions) {
          return _Izenda2.default.getText('ACCOUNT_CONSTANTS_MESSAGE_INVALID_EMAIL');
        }
      }
    }
  },
  VALIDATE_RESULT_ROLE_ASSOCIATION_KEYS: {
    get InvalidReportInVisibleCategoiesKey() {
      return _Izenda2.default.getText('USER_SETUP_ERROR_ROLE_REPORT_ASSOCIATION_EDITABLE');
    },
    get InvalidReportInSavableCategoiesKey() {
      return _Izenda2.default.getText('USER_SETUP_ERROR_ROLE_REPORT_ASSOCIATION_ACCESSIBLE');
    },
    get InvalidDashboardVisibleCategoiesKey() {
      return _Izenda2.default.getText('USER_SETUP_ERROR_ROLE_DASHBOARD_ASSOCIATION_EDITABLE');
    },
    get InvalidDashboardSavableCategoiesKey() {
      return _Izenda2.default.getText('USER_SETUP_ERROR_ROLE_DASHBOARD_ASSOCIATION_ACCESSIBLE');
    }
  },
  USER_LIST_SEARCH_KEY: 'FullName'
};
module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda7 = __webpack_require__(36);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(72);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(92);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2329);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RightPanelContent.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var RightPanelContent = (0, _Izenda2.default)()(function (props) {
  var renderLabelColumn = function renderLabelColumn(data) {
    var localization = props.localization;
    var listLabel = [];

    // Data for popup
    var popupData = void 0;

    // Padding for inner item
    var addToRenderList = function addToRenderList(item, shouldPadding) {
      var value = (0, _fp.isObject)(item) ? item.name : item;
      var className = (0, _classnames2.default)('u_textTruncate', { 'tree-data-inner': shouldPadding });
      listLabel.push(_react2.default.createElement(
        'div',
        { className: className },
        value
      ));
    };

    if (props.treeType === _Izenda10.default.TREE_TYPE.CATEGORY) {
      var globalCategories = (0, _fp.find)(function (item) {
        return item.isGlobal;
      }, data);
      var localCategories = (0, _fp.find)(function (item) {
        return !item.isGlobal;
      }, data);
      var savableCategories = props.savableCategories;

      var renderCategory = function renderCategory(category, shouldPadding) {
        if (!(0, _fp.isNil)(category)) {
          !savableCategories && listLabel.push(_react2.default.createElement(
            'div',
            { className: 'u_textTruncate' },
            category.name
          ));
          // Maximum 3 line
          // If global or local category label is render, only take 2 items from category, otherwise take 3
          var itemsToTake = savableCategories ? _Izenda10.default.NUMBER_CATEGORY_TAKE.SAVEABLE : _Izenda10.default.NUMBER_CATEGORY_TAKE.VISIBLE;
          var subCategories = (0, _fp.take)(itemsToTake, (0, _fp.filter)(function (item) {
            return !savableCategories || item.savable;
          }, category.subCategories));

          subCategories.forEach(function (item) {
            addToRenderList(item, shouldPadding);
          });
        }
      };
      !savableCategories && renderCategory(globalCategories, true);
      renderCategory(localCategories, !savableCategories);

      popupData = savableCategories ? (0, _fp.filter)(function (item) {
        return !item.isGlobal;
      }, data) : data;
    } else if (props.treeType === _Izenda10.default.TREE_TYPE.ACCESS) {
      (0, _fp.take)(3, data).forEach(function (item, index) {
        if (props.isAccessDefault) {
          var sharingSelection = item.assignedType === _Izenda12.default.ASSIGN_TYPE.ALL ? localization.getText('ACCESS_CONSTANT_LABEL_ASSIGNED_TYPE_EVERYONE') : (0, _fp.join)(', ', item.accessorNames.sort());
          var value = index + 1 + ' ' + sharingSelection;

          addToRenderList(value, false);
        } else {
          addToRenderList(item, false);
        }
      });
      popupData = data;
    }

    // Add more button if and only if the cell is not empty
    if (!(0, _fp.isEmpty)(listLabel)) {
      var onClick = function onClick() {
        props.openPopup(MoreInfoPopup, {
          isAccessDefault: props.isAccessDefault,
          popupData: popupData,
          treeType: props.treeType,
          checkSavable: props.savableCategories,
          popupTitle: props.popupTitle,
          popupMessage: props.popupMessage
        });
      };

      listLabel.push(_react2.default.createElement(
        'a',
        { className: 'u-colorBlue u_textUnderline u_floatRight', onClick: onClick },
        localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_MORE')
      ));
    }
    return listLabel;
  };

  var renderCheckboxColumn = function renderCheckboxColumn() {
    var columns = [];
    var model = props.model;


    model && !(0, _fp.isEmpty)(model.permissionSummary) && (0, _fp.forEach)(function (item) {
      var value = (0, _fp.get)(props.keysPath, item.permission);

      columns.push(_react2.default.createElement(
        _Izenda4.default.Col,
        {
          cols: 1,
          className: (0, _classnames2.default)('grid-small-column u_borderRight', {
            'grid-medium-column': props.notShowBlankCharacter && (0, _fp.isEmpty)(value),
            'grid-medium-column-has-content': props.showRole && !(0, _fp.isEmpty)(value)
          }),
          key: (0, _fp.uniqueId)(item.id)
        },
        !props.isParent && _react2.default.createElement(_Izenda6.default, { type: 'checkbox', checked: value, disabled: true }),
        props.isParent && (!props.notShowBlankCharacter || (0, _fp.isEmpty)(value)) && _react2.default.createElement(
          'span',
          null,
          '\xA0'
        ),
        props.showRole && !(0, _fp.isEmpty)(value) && renderLabelColumn(value),
        props.showRadioButton && _react2.default.createElement(_Izenda6.default, { type: 'radio', checked: value, disabled: true })
      ));
    }, (0, _fp.take)(12, model.permissionSummary));
    return columns;
  };

  return _react2.default.createElement(
    _Izenda4.default.Col,
    { cols: '9', className: 'u_noPaddingAll text-center' },
    _react2.default.createElement(
      _Izenda4.default.Row,
      { className: 'u_noMarginAll' },
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        renderCheckboxColumn()
      )
    )
  );
});

var MoreInfoPopup = (0, _Izenda2.default)()(function (props) {
  var localization = props.localization,
      checkSavable = props.checkSavable,
      popupData = props.popupData,
      treeType = props.treeType;
  // Property to render and access path to child nodes

  var childPath = void 0,
      namePath = void 0,
      altNamePath = void 0;

  var isCategoryType = treeType === _Izenda10.default.TREE_TYPE.CATEGORY;
  if (isCategoryType) {
    childPath = 'subCategories';
    namePath = 'name';
  } else {
    childPath = 'users';
    namePath = 'fullName';
    altNamePath = 'name';
  }

  var renderAccessDefault = function renderAccessDefault(data) {
    return _react2.default.createElement(_Izenda14.default, { data: data });
  };

  // Recursive render category/role
  var renderTree = function renderTree(items, depth) {
    // Remove most outer item when view saving category (don't show 'Local Categories' label)
    var removeMostOuterItem = !!(checkSavable && depth === 0);
    var style = {
      paddingLeft: depth * 10 + 'px'
    };
    return _react2.default.createElement(
      'div',
      null,
      (0, _fp.map)(function (item) {
        return !(isCategoryType && checkSavable && !item.savable || !isCategoryType && depth !== 0 && item.notAllowSharing) && _react2.default.createElement(
          'div',
          { style: style },
          !removeMostOuterItem && _react2.default.createElement(
            _Izenda4.default.Row,
            { key: item.id },
            (0, _fp.isNil)(item[namePath]) ? item[altNamePath] : item[namePath]
          ),
          item[childPath] && renderTree(item[childPath], depth + 1)
        );
      }, items)
    );
  };

  var popupMessages = (0, _fp.split)('\n', props.popupMessage);

  return _react2.default.createElement(
    _Izenda8.default,
    { visible: true, type: 'none', onClosing: props.onReject, autoClose: false, sizeClass: 'modal-lg' },
    _react2.default.createElement(_Izenda8.default.Header, { title: props.popupTitle, className: 'u_floatLeft' }),
    _react2.default.createElement(
      _Izenda8.default.Body,
      null,
      _react2.default.createElement(
        _Izenda4.default,
        { className: 'izenda-PasswordOptions' },
        (0, _fp.map)(function (message) {
          return _react2.default.createElement(
            _Izenda4.default.Row,
            null,
            message
          );
        }, popupMessages),
        props.isAccessDefault ? renderAccessDefault(popupData) : renderTree(popupData, 0)
      )
    ),
    _react2.default.createElement(
      _Izenda8.default.Footer,
      null,
      _react2.default.createElement(
        _Izenda8.default.ConfirmationButton,
        { type: 'cancel' },
        localization.getText('COMMON_LABEL_CLOSE')
      )
    )
  );
});

exports.default = RightPanelContent;
module.exports = exports['default'];

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var AccountInfo = __webpack_require__(482);
  var SecurityQuestionReadOnly = __webpack_require__(814);
  var fetcher = __webpack_require__(941);
  var systemSettingFetcher = __webpack_require__(75);
  var AccountConstants = __webpack_require__(60);
  var uiState = __webpack_require__(15);
  var MyProfileMenuStore = __webpack_require__(1842);

  var SecurityManager = __webpack_require__(120);

  var _require = __webpack_require__(1),
      find = _require.find,
      isEmpty = _require.isEmpty,
      map = _require.map,
      trim = _require.trim,
      pick = _require.pick,
      mapValues = _require.mapValues;

  function AccountStore(mode) {
    var props = {
      model: new AccountInfo(mode),
      tenantId: function tenantId() {
        return uiState.getTenantId();
      },
      tenantDisplayId: function tenantDisplayId() {
        return uiState.currentUser.tenantDisplayID;
      },
      userName: function userName() {
        return uiState.currentUser.userName;
      }
    };

    this.contextMenu = new MyProfileMenuStore();
    m.extendObservable(this, props);
  }

  /**
   * Init Account Store
   */
  AccountStore.prototype.init = function (systemConfig) {
    uiState.setCheckDirtyFunction(function () {
      return this.model.isDirty;
    }.bind(this));
  };

  /**
   * Destroy Account Store
   */
  AccountStore.prototype.destroy = function (systemConfig) {
    uiState.resetCheckDirtyFunction();
  };

  /**
   * Populate model info
   * @param  {String} tenantId
   * @param  {String} verification
   */
  AccountStore.prototype.populateTenantInfo = function () {
    return this.populateTenantConfig().bind(this).then(m.action(function (result) {
      return this.model.populateSystemConfig(result);
    }));
  };

  /**
   * Load security questions of user
   * @param  {Array} questions
   */
  AccountStore.prototype.loadUserSecurityQuestions = function (questions) {
    return this.populateTenantInfo().bind(this).then(function () {
      return this.model.populateUserSecurityQuestions(questions);
    });
  };

  /**
   * Validate expiration of password link.
   * @param  {String} verification
   */
  AccountStore.prototype.validateExpirationPasswordLink = function (verification) {
    return fetcher.validateExpirationPasswordLink({
      verification: verification
    });
  };

  /**
   * Validate password link.
   */
  AccountStore.prototype.validatePasswordLink = m.action(function () {
    // Trim data for validate
    var request = mapValues(trim, pick(['tenantName', 'userName', 'firstName', 'lastName', 'emailAddress', 'verification'], this.model));

    var fn = this.model.verification ? fetcher.validatePasswordLink : fetcher.validateUserInfo;

    return fn(request).bind(this).then(function (result) {
      if (result.success) {
        this.model.updateProperty('tenantDisplayID', result.data.tenantDisplayId);
        switch (this.model.mode) {
          case AccountConstants.MODES.PASSWORD_SETUP:
            return (0, _bluebird.join)([this.model.updateCurrentStep(AccountConstants.STEP_KEYS.SecurityInfo), this.loadUserSecurityQuestions()]);
          case AccountConstants.MODES.FORGOT_PASSWORD:
          case AccountConstants.MODES.RESET_PASSWORD:
            this.model.id = result.data.id;
            return (0, _bluebird.join)(this.model.updateCurrentStep(AccountConstants.STEP_KEYS.QuestionInfo), this.loadSecurityQuestionsOfUser(), function (obj, questionsResult) {
              return this.loadUserSecurityQuestions(questionsResult.data);
            }.bind(this));
        }
      }
      this.model.updateProperty('message', AccountConstants.MESSAGES.M01);
      return result;
    });
  });

  /**
   * Active account.
   */
  AccountStore.prototype.passwordAndSecurityQuestion = function () {
    var request = pick(['tenantDisplayID', 'tenantName', 'password', 'verification', 'userName', 'firstName', 'lastName', 'emailAddress'], this.model);
    request.userSecurityQuestions = map(function (item) {
      return item.buildDataForSaving();
    }, this.model.userSecurityQuestions);
    request.autoLogin = true;

    return fetcher.passwordAndSecurityQuestion(request);
  };

  /**
   * Load security questions.
   */
  AccountStore.prototype.loadSecurityQuestions = function () {
    var request = pick(['tenantDisplayID', 'tenantName', 'userName'], this.model);
    return systemSettingFetcher.securityQuestions(request).then(function (result) {
      return map(function (item) {
        return new SecurityQuestionReadOnly(item);
      }, result);
    });
  };

  /**
   * Build tenant config info.
   * @param  {String} tenantId
   */
  AccountStore.prototype.populateTenantConfig = function () {
    return (0, _bluebird.join)(this.loadSecurityQuestions(), this.loadSystemConfig(), function (questions, config) {
      return {
        fullSecurityQuestions: questions,
        numberOfQuestionProfile: config.numberOfQuestionProfile
      };
    });
  };

  /**
   * Login.
   */
  AccountStore.prototype.login = function () {
    var request = pick(['tenantName', 'password', 'userName'], this.model);
    return fetcher.login(request);
  };

  /**
   * Logout.
   */
  AccountStore.prototype.logout = function () {
    return fetcher.logout();
  };

  /**
   * Load security question of user.
   */
  AccountStore.prototype.loadSecurityQuestionsOfUser = function () {
    var request = pick(['tenantDisplayID', 'userName'], this.model);
    return fetcher.securityQuestion(request);
  };

  /**
   * Validate security question of user.
   */
  AccountStore.prototype.validateSecurityQuestion = function () {
    var request = pick(['tenantDisplayID', 'userName'], this.model);
    request.userSecurityQuestions = this.model.buildUserSecurityQuestionsForSaving();
    return fetcher.validateSecurityQuestion(request);
  };

  /**
   * Update password info of user.
   */
  AccountStore.prototype.updatePassword = function () {
    var request = pick(['tenantDisplayID', 'tenantName', 'password', 'userName', 'id'], this.model);
    request.userSecurityQuestions = map(function (item) {
      return item.buildDataForSaving();
    }, this.model.userSecurityQuestions);
    request.autoLogin = true;
    return fetcher.password(request);
  };

  /**
   * Update account info after checked password link.
   * @param  {String} verification
   * @param  {Boolean} isExpired
   */
  AccountStore.prototype.updateInfoAfterCheckedPasswordLink = m.action(function (verification, isExpired) {
    this.model.updateProperty('verification', verification);
    this.model.updateProperty('isExpiration', isExpired);
  });

  /**
   * Load general error message.
   * @param  {Array} messages
   */
  AccountStore.prototype.loadGeneralErrorMessage = function (messages) {
    var message = find(function (item) {
      return isEmpty(item.key);
    }, messages);

    if (message) {
      this.model.updateProperty('message', message.messages);
    }
  };

  /**
   * Load system config info.
   * @param  {String} tenantId
   */
  AccountStore.prototype.loadSystemConfig = function () {
    return systemSettingFetcher.loadSecurityPolicies();
  };

  /**
   * Check database setup.
   */
  AccountStore.prototype.checkDatabaseSetup = function () {
    return systemSettingFetcher.databaseSetup();
  };

  /**
   * Load System Mode
   */
  AccountStore.prototype.loadSystemMode = function () {
    return systemSettingFetcher.loadSystemModeSettings();
  };

  /**
   * Load information of current user.
   */
  AccountStore.prototype.loadCurrentUser = function () {
    return fetcher.loadCurrentUser();
  };

  /**
   * Get my preference information
   */
  AccountStore.prototype.getMyProfile = function () {
    var securityQuestionsRequest = {
      tenantDisplayID: this.tenantDisplayId,
      userName: this.userName
    };

    return (0, _bluebird.join)(this.loadCurrentUser(), systemSettingFetcher.loadAllLanguages(), systemSettingFetcher.loadAllDateFormat(), systemSettingFetcher.securityQuestions(securityQuestionsRequest), this.loadSystemConfig(), function (currentUser, languageList, dateFormatList, questions, config) {
      this.model.populateMyProfile(currentUser, languageList, dateFormatList, questions, config);
    }.bind(this));
  };

  /**
   * save my profile
   */
  AccountStore.prototype.save = function () {
    var data = this.model.buildDataForSaving();
    var hasChangeLanguage = data.hasChangeLanguage;

    return fetcher.saveUserProfile(data).bind(this).then(m.action(function (result) {
      if (result.success) {
        this.model.populate(result.data);
        // Update for current user which uses for global system.
        uiState.currentUser.populate(result.data);
        // Reset dirty
        this.model.resetDirty();

        result.hasChangeLanguage = hasChangeLanguage;
        return (0, _bluebird.resolve)(result);
      } else {
        return result;
      }
    }));
  };

  /**
   * Update new password
   * @param {String} current password
   * @param {String} new password
   */
  AccountStore.prototype.updateNewPassword = function (currentPassword, newPassword) {
    var data = {
      newPassword: newPassword,
      password: currentPassword,
      userName: this.model.userName,
      Id: this.model.id
    };
    return fetcher.updateNewPassword(data).bind(this).then(function (result) {
      if (result.success) {
        new SecurityManager().setAccessToken(result.data.token);
        return (0, _bluebird.resolve)(true);
      } else {
        return result;
      }
    });
  };

  /**
   * Update security questions
   * @param {String} current password
   * @param {String} new password
   * returns {Object} promise
   */
  AccountStore.prototype.updateSecurityQuesitions = function (currentPassword, newPassword) {
    var data = this.model.buildForUpdateSecurityQuestions();
    return fetcher.updateSecurityQuesitions(data).bind(this).then(function (result) {
      if (result.success) {
        this.model.resetAnswers();
        this.loadCurrentUser().bind(this).then(function (result) {
          this.model.populate(result.data);
        });
        return (0, _bluebird.resolve)(true);
      } else {
        return result;
      }
    });
  };

  module.exports = AccountStore;
}();

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Tab.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Tab Component
 * Example :
 * <Tabs>
    <Tab title='Tab 1'>
      <h2>Content 1 here</h2>
    </Tab>
    <Tab title='Tab 2'>
      <h2>Content 2 here</h2>
    </Tab>
  </Tabs>
 */

!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);
  var MenuToolbar = __webpack_require__(1862);
  var uiState = __webpack_require__(15);

  var connect = __webpack_require__(2);
  var BrowserUtils = __webpack_require__(78);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      get = _require.get;

  /**
   * Tab Container Component
   */


  var Tabs = React.createClass({
    displayName: 'Tabs',

    propTypes: {
      activeTabKey: React.PropTypes.string,
      onChange: React.PropTypes.func,
      canChangeTab: React.PropTypes.func,
      beforeChangeTab: React.PropTypes.func,
      isResponsive: React.PropTypes.bool,
      children: React.PropTypes.oneOfType([React.PropTypes.array, React.PropTypes.element]).isRequired,
      navigationClass: React.PropTypes.string,
      isOnPopover: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
      return {
        activeTabKey: '',
        isResponsive: false
      };
    },
    getInitialState: function getInitialState() {
      return {
        activeTabKey: this.props.activeTabKey || this.getDefaultTabKey()
      };
    },

    getDefaultTabKey: function getDefaultTabKey() {
      if (this.props.children.length > 0) {
        var firstTabKey = this.props.children[0].props.tabKey;
        return firstTabKey;
      }
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
      if (newProps.activeTabKey && newProps.activeTabKey !== this.state.activeTabKey) {
        this.setState({
          activeTabKey: newProps.activeTabKey
        });
      }
    },

    render: function render() {
      var className = classnames('tabs', this.props.className);
      return React.createElement(
        'div',
        { className: className },
        this.getMenuItems(),
        this.getSelectedPanel()
      );
    },

    openHref: function openHref(href) {
      this.props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).bind(this).then(function () {
        this.props.router.push(href);
      });
    },

    setActive: function setActive(index, e) {
      e && e.preventDefault();

      var props = this.props;
      var onChange = this.props.onChange;
      var canChangeTab = this.props.canChangeTab;
      var $selectedPanel = this.refs['tab-panel'];
      var $selectedTabMenu = this.refs['tab-menu-' + index];
      var activeTabKey = this.props.children[index - 1].props.tabKey;

      if (this.props.children[index - 1].props.isDisabled) {
        return;
      }

      var setTab = function () {
        if (activeTabKey === this.state.activeTabKey) {
          return;
        }

        props.beforeChangeTab && props.beforeChangeTab(activeTabKey);

        this.setState({
          activeTabKey: activeTabKey
        }, function () {
          if (onChange) {
            onChange(index, $selectedPanel, $selectedTabMenu, activeTabKey);
          }
        });
      }.bind(this);

      if (canChangeTab) {
        canChangeTab(index, $selectedPanel, $selectedTabMenu, activeTabKey).then(function (result) {
          if (result) {
            setTab();
          }
        });
      } else {
        setTab();
      }
    },

    getMenuItems: function getMenuItems() {
      var navigationClasses = classnames('nav', 'nav-tabs', 'tabs-navigation', this.props.navigationClass);

      // Convert to list for children before render
      if (!Array.isArray(this.props.children)) {
        this.props.children = [this.props.children];
      }

      var menuItems = this.props.children.map(function (panel) {
        return typeof panel === 'function' ? panel() : panel;
      }).filter(function (panel) {
        return panel;
      }).map(function (panel, index) {
        var refIndex = index + 1;
        var ref = 'tab-menu-' + refIndex;
        var title = panel.props.title;
        var tabKey = panel.props.tabKey;
        var href = panel.props.href;
        var classes = classnames(panel.props.headerClassName, {
          active: this.state.activeTabKey === panel.props.tabKey,
          'tabs-menu-item': !this.props.isResponsive
        });
        var popoverOnIE = this.props.isOnPopover && BrowserUtils.isIEBrowser();

        // Fix issue IE not fire event onClick on popover
        var onClickText = popoverOnIE ? { onMouseDown: this.setActive.bind(this, refIndex) } : { onClick: this.setActive.bind(this, refIndex) };

        var onClickHref = popoverOnIE ? { onMouseDown: this.openHref.bind(this, href) } : { onClick: this.openHref.bind(this, href) };

        return React.createElement(
          'li',
          { role: 'presentation', ref: ref, key: tabKey, className: classes },
          isNil(href) ? React.createElement(
            'a',
            onClickText,
            title
          ) : React.createElement(
            'a',
            onClickHref,
            title
          )
        );
      }.bind(this));

      return this.props.isResponsive ? React.createElement(MenuToolbar, { menuItems: menuItems }) : React.createElement(
        'ul',
        { className: navigationClasses },
        menuItems
      );
    },

    getSelectedPanel: function getSelectedPanel() {
      var props = this.props;
      var panel = props.children.filter(function (panel) {
        return get('props.tabKey', panel) === this.state.activeTabKey;
      }.bind(this));

      var classes = classnames('tab-panel', props.panelClassName);

      return React.createElement(
        'div',
        { ref: 'tab-panel', className: classes },
        panel
      );
    }
  });

  /**
   * Tab Component
   */
  var Tab = React.createClass({
    displayName: 'Tab',

    propTypes: {
      title: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.string]).isRequired,
      tabKey: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
      children: React.PropTypes.oneOfType([React.PropTypes.array, React.PropTypes.element]).isRequired,
      href: React.PropTypes.string
    },
    render: function render() {
      return React.createElement(
        'div',
        { className: this.props.className },
        this.props.children
      );
    }
  });

  module.exports = { Tabs: connect({ toClass: true })(Tabs), Tab: Tab };
}();

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  TAB_VISUAL: { index: 0, value: 'Visual', key: 'visual' },
  TAB_HTML: { index: 1, value: 'HTML', key: 'html' },
  MESSAGES: {
    get M01() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_FIELD_NOT_UNIQUE');
    },
    get M02() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_FIELD_NOT_FOUND');
    },
    get M03() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_REPORT_NOT_FOUND');
    },
    get M04() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_REPORT_PART_NAME_NOT_UNIQUE');
    },
    get M05() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_REPORT_PART_NOT_FOUND');
    },
    get M06() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NO_SUBTOTAL_INFO_SET_UP');
    },
    get M07() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_SUBTOTAL_INSIDE_REPEATER');
    },
    get M08() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_OPEN_NEW_FORM');
    },
    get M09() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NO_GRAND_TOTOAL_INFO_SET_UP');
    },
    get M10() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NOTHING_FOUND');
    },
    get M11() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NOTHING_TO_REPLACE');
    },
    get M12() {
      return _Izenda2.default.getText('COMMON_MESSAGES_MUST_BE_FUNCTION');
    },
    get M13() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_INCORRECT_GRAND_TOTAL_SYNTAX');
    },
    get M14() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_INCORRECT_SUBTOTAL_SYNTAX');
    },
    get M15() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_NO_TEMPLATE_DEFINED');
    },
    get M16() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_FIELD_NAME_ALIAS_NOT_UNIQUE');
    },
    get ERROR_MESS_IN_LOW_LEVEL() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_SUBTOTAL_IN_CHILD_LEVEL');
    },
    get ERROR_MESSAGE_FOR_SUBTOTAL_IN_PARALLEL() {
      return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_MESSAGE_DOES_NOT_ALLOW_SUBTOTAL_IN_PARALLEL');
    }
  },
  FORM_STYLE_DEFAULT: {
    borderStyle: 'solid',
    borderColor: '#000',
    borderWidth: 1,
    backgroundColor: '#FFF'
  },
  FORMAT_CONFIG: {
    FONT_NAME: {
      Arial: 'arial,helvetica,sans-serif',
      'Arial Black': 'arial black,sans-serif',
      'Book Antiqua': 'book antiqua,palatino,serif',
      'Courier New': 'courier new,courier,monospace',
      Georgia: 'georgia,palatino,serif',
      Helvetica: 'helvetica,arial,sans-serif',
      Impact: 'impact,sans-serif',
      'Lucida Console': 'lucida console,monaco,monospace',
      'Lucida Sans Unicode': 'lucida sans unicode,lucida grande,sans-serif',
      'Palatino Linotype': 'palatino linotype,book antiqua,palatino,serif',
      Roboto: 'roboto,sans-serif',
      Tahoma: 'tahoma,arial,helvetica,sans-serif',
      'Times New Roman': 'times new roman,times,serif',
      Verdana: 'verdana,geneva,sans-serif'
    },
    FONT_SIZE: ['8px', '9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '36px', '48px', '72px'],
    HEADING: [{
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_1');
      },
      value: 'h1',
      className: 'format-h1'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_2');
      },
      value: 'h2',
      className: 'format-h2'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_3');
      },
      value: 'h3',
      className: 'format-h3'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_4');
      },
      value: 'h4',
      className: 'format-h4'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_5');
      },
      value: 'h5',
      className: 'format-h5'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_HEADING_6');
      },
      value: 'h6',
      className: 'format-h6'
    }],
    BLOCK: [{
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_PARAGRAPH');
      },
      value: 'p'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_BLOCKQUOTE');
      },
      value: 'blockquote'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_DIV');
      },
      value: 'div'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_PRE');
      },
      value: 'pre'
    }],
    NUMBER_LIST: [{
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_DEFAULT');
      },
      value: ''
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_LOWER_ALPHA');
      },
      value: 'lower-alpha'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_LOWER_GREEK');
      },
      value: 'lower-greek'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_LOWER_ROMAN');
      },
      value: 'lower-roman'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_UPPER_ALPHA');
      },
      value: 'upper-alpha'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_UPPER_ROMAN');
      },
      value: 'upper-roman'
    }],
    BULLET_LIST: [{
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_DEFAULT');
      },
      value: ''
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_CIRCLE');
      },
      value: 'circle'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_DISC');
      },
      value: 'disc'
    }, {
      get label() {
        return _Izenda2.default.getText('REPORT_PART_FORM_CONSTANTS_LABEL_SQUARE');
      },
      value: 'square'
    }],
    REPEATER_LIST: [{
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_ADD');
      },
      value: 'Add'
    }, {
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_REMOVE');
      },
      value: 'Remove'
    }],
    SMARTTAG_LIST: [{
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_DATE_TIME');
      },
      value: 'DateTime'
    }, {
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_SUBTOTAL');
      },
      value: 'Subtotal'
    }, {
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_GRAND_TOTAL');
      },
      value: 'GrandTotal'
    }]
  },
  DEFAULT_SETTING_VALUE: {
    refreshIntervalDefault: {
      enable: false,
      isAll: true,
      latestRecord: 0,
      updateInterval: 0
    },
    boder: {}
  },

  DEFAULT_SORT_VALUE: 'ASC'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get SUBSCRIPTION_REPORT() {
    return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_REPORT');
  },
  CUSTOM_RECURRENCE: '8',
  EMAIL_SUBJECT: {
    REPORT: '{reportName}',
    DASHBOARD: '{dashboardName}'
  },
  MESSAGE: {
    get M01a() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_DELETE_INSTANCE');
    },
    get M01b() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_DELETE_SELECTED_INSTANTCES');
    },
    get M03a() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_END_DATE_CANNOT_PRIOR_CURRENT_DATE');
    },
    get M03b() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_START_DATE_CANNOT_AFTER_END_DATE');
    },
    get M04() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_CANNOT_BE_SUBSCRIBE');
    },
    get M05() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_NAME_EXIST');
    },
    get M06() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_ADJUSTED_ACCORDINGLY');
    },
    get requiredOccurrence() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_REQUIRED_OCCURRENCE');
    }
  },
  TABLE_DEF: {
    selectedValue: {
      key: 'selectedValue',
      width: 30,
      title: '',
      sortable: false
    },
    name: {
      key: 'name',
      width: 200,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_INSTANCE_NAME');
      },
      sortable: true,
      columnKey: 'name'
    },
    schedule: {
      key: 'schedule',
      width: 220,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_SCHEDULE');
      },
      sortable: true,
      columnKey: 'schedule'
    },
    filterValueSelection: {
      key: 'filterValueSelection',
      width: 100,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_FILTER_VALUE_SELECTION');
      },
      sortable: true,
      columnKey: 'filterValueSelection'
    },
    deliveryType: {
      key: 'deliveryType',
      width: 80,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_DELIVERY_TYPE');
      },
      sortable: true,
      columnKey: 'deliveryType'
    },
    deliveryMethodView: {
      key: 'deliveryMethodView',
      width: 150,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_DELIVERY_METHOD');
      },
      sortable: true,
      columnKey: 'deliveryMethodView'
    },
    action: {
      key: 'action',
      width: 80,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_ACTION');
      },
      sortable: false,
      fixed: true
    }
  },
  PAGE_TEXT: {
    get AddText() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_ADD');
    },
    get EditText() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_EDIT');
    },
    get CopyText() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_COPY');
    },
    get DeleteText() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_DELETE');
    }
  },
  SEARCH_OPTION: [{
    value: 'All',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: 'Name',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_INSTANCE_NAME');
    }
  }, {
    value: 'Schedule',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_SCHEDULE');
    }
  }, {
    value: 'FilterValueSelection',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_FILTER_VALUE_SELECTION');
    }
  }, {
    value: 'DeliveryType',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_DELIVERY_TYPE');
    }
  }, {
    value: 'DeliveryMethod',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_DELIVERY_METHOD');
    }
  }],

  DEFAULT_VALUE: {
    get SEARCH_CRITERIA() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    },
    SORT_DIRS: {
      name: 'DESC'
    }
  },

  SUBSCRIPTION_TYPE: [{
    value: 'Subscribed Reporting Item',
    get label() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_TYPE_REPORTING_ITEM');
    }
  }, {
    value: 'Subscribed Alert',
    get label() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_TYPE_ALERT');
    }
  }],

  EXPORT_TYPE: [{
    value: 'Word',
    label: 'Word'
  }, {
    value: 'Excel',
    label: 'Excel'
  }, {
    value: 'PDF',
    label: 'PDF'
  }, {
    value: 'CSV',
    label: 'CSV'
  }, {
    value: 'XML',
    label: 'XML'
  }, {
    value: 'JSON',
    label: 'JSON'
  }],

  DELIVERY_TYPE: [{
    value: 'Email',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EMAIL');
    },
    deliveryMethod: [{
      value: 'Link',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_LINK');
      }
    }, {
      value: 'Attachment',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_ATTACHMENT');
      }
    }, {
      value: 'Embedded HTML',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_EMBEDDED_HTML');
      }
    }]
  }, {
    value: 'File Location',
    get label() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_FILE_LOCATION');
    },
    deliveryMethod: [{
      value: 'Send to disk',
      get label() {
        return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_SEND_TO_DISK');
      }
    }]
  }],

  CONTRAINTS: {
    INSTANCE_NAME: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_INSTANCE_NAME_REQUIRED');
        }
      }
    },
    START_DATE: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_START_DATE_REQUIED');
        }
      }
    },
    START_TIME: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_START_TIME_REQUIED');
        }
      }
    },
    DELIVERY_TYPE: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_DELIVERY_TYPE_REQUIED');
        }
      }
    },
    DELIVERY_METHOD: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_DELIVERY_METHOD_REQUIED');
        }
      }
    }
  },

  SUBSCRIPTION_TYPE_VALUES: {
    get subscriptionReport() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_TYPE_REPORTING_ITEM');
    },
    get subscriptionAlert() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_TYPE_ALERT');
    }
  },

  DELIVERY_METHOD_VALUES: {
    get Attachment() {
      return _Izenda2.default.getText('COMMON_LABEL_ATTACHMENT');
    }
  },

  DELIVERY_METHOD_VIEW_PATTERN: '{0} ({1})',

  SCHEDULER_TAB: {
    index: 1,
    key: 'schedule'
  },
  DELIVERY_TAB: {
    index: 2,
    key: 'delivery'
  },

  FIELD_KEY: {
    Recipients: 'Recipients',
    StartTime: 'StartTime',
    EndDate: 'EndDate',
    StartDate: 'StartDate'
  },

  SYSTEM_VARIABLES: {
    get TITLE() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_SYSTEM_VARIABLES_TITLE');
    },
    get INSTRUCTION() {
      return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_SYSTEM_VARIABLES_INSTRUCTION');
    },
    TABLE_DEF: {
      name: {
        columnKey: 'name',
        get title() {
          return _Izenda2.default.getText('REPORT_SUBCRIPTION_CONSTANT_SYSTEM_VARIABLES_TITLE');
        },
        sortable: true,
        width: 150
      },
      dataType: {
        columnKey: 'dataType',
        get title() {
          return _Izenda2.default.getText('COMMON_LABEL_DATA_TYPE');
        },
        sortable: true,
        width: 150
      },
      description: {
        columnKey: 'description',
        get title() {
          return _Izenda2.default.getText('COMMON_LABEL_DESCRIPTION');
        },
        sortable: true,
        width: 160
      }
    },
    DEFAULT_VALUE: {
      get SEARCH_CRITERIA() {
        return _Izenda2.default.getText('COMMON_LABEL_ALL');
      },
      SORT_DIRS: {
        name: 'ASC'
      }
    }
  },

  ELEMENTS: {
    EMAIL_SUBJECT: {
      KEY: 'subject',
      CLASS: '.email-subject'
    },
    EMAIL_BODY: {
      KEY: 'body',
      CLASS: '.email-body'
    }
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportSubscriptionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//
/**
 * ReportSubscriptionConstants
 */

module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CheckboxAllPermission.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var connect = __webpack_require__(2);
  var React = __webpack_require__(0);
  var Input = __webpack_require__(17);
  var EventsUtils = __webpack_require__(24);
  var m = __webpack_require__(10);
  var GridLayout = __webpack_require__(13);

  var SelectAllPermissionCheckBox = m.observer(function (props) {
    var notifyChange = EventsUtils.notifyChange;
    var permission = props.permission;
    var section = props.section;
    var tenantPermission = props.tenantPermission;

    var isIndeterminate = permission.isTenantSetup ? permission.isAllTenantSectionIndeterminate(section) : permission.isAllRoleSectionIndeterminate(section, tenantPermission);

    var isChecked = permission.isTenantSetup ? permission.isAllTenantSectionChecked(section) : permission.isAllRoleSectionChecked(section, tenantPermission);

    var onChangeCheckbox = permission.isTenantSetup ? notifyChange(permission.updateAllTenantSection.bind(permission, section), EventsUtils.CHECKBOX) : notifyChange(permission.updateAllRoleSection.bind(permission, section, tenantPermission), EventsUtils.CHECKBOX);

    return React.createElement(Input, {
      type: 'checkbox',
      readOnly: props.readOnly,
      indeterminate: isIndeterminate,
      checked: isChecked,
      onChange: onChangeCheckbox });
  });

  var CheckboxAllPermission = function CheckboxAllPermission(props) {
    var permission = props.permission;
    var notifyChange = EventsUtils.notifyChange;
    var localization = this.props.localization;

    //For select all section role or tenant
    if (!props.selectAllPermimssion) {
      return React.createElement(
        'label',
        { className: 'u_noBorderAll' },
        React.createElement(SelectAllPermissionCheckBox, props),
        React.createElement(
          'span',
          { className: 'u_marginLeftRight u_textNormal' },
          localization.getText('TENANT_SELECT_ALL')
        )
      );
    }

    //For select all tenant setup
    return React.createElement(
      'div',
      { className: 'u_paddingLeftRight u_borderBottom' },
      React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          { className: 'u_noBorder' },
          React.createElement(
            GridLayout.Col,
            { cols: 11 },
            React.createElement(
              'label',
              { className: 'u_noBorderAll' },
              React.createElement(SelectAllPermissionCheckBox, props),
              React.createElement(
                'span',
                { className: 'u_marginLeftRight u_textNormal' },
                localization.getText('TENANT_SELECT_ALL')
              )
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 1, className: 'u_textCenter' },
            permission.isTenantSetup && props.selectAllPermimssion && React.createElement(Input, {
              indeterminate: permission.isAllTenantIndeterminate(permission),
              type: 'checkbox',
              readOnly: props.readOnly,
              checked: permission.isAllTenantAccessChecked(permission),
              onChange: notifyChange(permission.updateAllTenantAccess.bind(permission, permission), EventsUtils.CHECKBOX) })
          )
        )
      )
    );
  };

  CheckboxAllPermission.displayName = 'CheckboxAllPermission';

  CheckboxAllPermission.propTypes = {
    selectAllPermimssion: React.PropTypes.bool,
    permission: React.PropTypes.object.isRequired,
    section: React.PropTypes.object.isRequired,
    tenantPermission: React.PropTypes.object
  };

  module.exports = connect()(CheckboxAllPermission);
}();

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Header.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var Header = (0, _Izenda2.default)()(function (props) {
  function renderColumn() {
    var columns = [];
    props.model && !(0, _fp.isEmpty)(props.model.permissionSummary) && (0, _fp.forEach)(function (item) {
      columns.push(_react2.default.createElement(
        _Izenda4.default.Col,
        { cols: '1', className: 'grid-small-column u_borderRight', key: (0, _fp.uniqueId)(item.id) },
        '\xA0'
      ));
    }, (0, _fp.take)(12, props.model.permissionSummary));
    return columns;
  }

  return _react2.default.createElement(
    'div',
    { onClick: props.collapseToggle },
    _react2.default.createElement(
      _Izenda4.default.Row,
      { className: 'u_noMarginAll' },
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: '3', className: 'grid-small-column u_borderRight u-bgGrayBlue text-bold' },
          _react2.default.createElement('i', { className: 'icon-toggle-triangle' }),
          _react2.default.createElement(
            'label',
            { className: 'panel-title' },
            props.headerName
          )
        ),
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: '9', className: 'u_noPaddingAll' },
          _react2.default.createElement(
            _Izenda4.default.Row,
            { className: 'u_noMarginAll' },
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGray' },
              renderColumn()
            )
          )
        )
      )
    )
  );
});

exports.default = Header;
module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var presence = {
  presence: true,
  message: _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED')
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ImportConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  DEFAULT_TABLE_HEIGHT: 328,
  DEFAULT_REST_HEIGHT: 122,
  DEFAULT_DATABASE_MAPPING_HEIGHT: 238,

  get TableDefinition() {
    return {
      get ImportSourceType() {
        return {
          fileName: {
            columnKey: 'FileName',
            width: 250,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_FILENAME');
            },
            sortable: true
          },
          type: {
            columnKey: 'Type',
            width: 200,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_TYPE');
            },
            sortable: true
          },
          newReportName: {
            columnKey: 'NewReportName',
            width: 300,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_NEW_REPORT_NAME');
            },
            sortable: true
          },
          newReportOrDashboardName: {
            columnKey: 'NewReportName/DashboardName',
            width: 300,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_NEW_REPORT_OR_DASHBOARD_NAME');
            },
            sortable: true
          },
          saveInto: {
            columnKey: 'SaveInto',
            width: 250,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_SAVE_INTO');
            },
            sortable: true
          },
          category: {
            columnKey: 'Category',
            width: 250,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_CATEGORY');
            },
            sortable: true
          },
          subCategory: {
            columnKey: 'SubCategory',
            width: 250,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_SUB_CATEGORY');
            },
            sortable: true
          },
          gear: {
            columnKey: 'Gear',
            width: 60,
            title: '',
            sortable: true
          }
        };
      },

      get DatabaseMappingSourceType() {
        return {
          physicalDatabase: {
            columnKey: 'PhysicalDatabase',
            width: 150,
            get title() {
              return _Izenda2.default.getText('DATABASE_MAPPING_PHYSICAL_DATABASE');
            },
            sortable: true
          },
          databaseName: {
            columnKey: 'DatabaseName',
            width: 150,
            get title() {
              return _Izenda2.default.getText('DATABASE_MAPPING_DATABASE_NAME');
            },
            sortable: true
          },
          schema: {
            columnKey: 'Schema',
            width: 150,
            get title() {
              return _Izenda2.default.getText('DATABASE_MAPPING_SCHEMA');
            },
            sortable: true
          },
          action: {
            columnKey: 'Action',
            width: 50,
            get title() {
              return _Izenda2.default.getText('DATABASE_MAPPING_ACTION');
            },
            sortable: true
          }
        };
      },

      get ReportInformation() {
        return {
          shareWith: {
            columnKey: 'ShareWith',
            width: 450,
            get title() {
              return _Izenda2.default.getText('COMMON_LABEL_SHARE_WITH');
            },
            sortable: true
          },
          accessRights: {
            columnKey: 'AccessRights',
            width: 150,
            get title() {
              return _Izenda2.default.getText('COMMON_LABEL_ACCESS_RIGHT');
            },
            sortable: true
          }
        };
      }
    };
  },

  getReportType: function getReportType(reportType) {
    return reportType === 0 ? 'Report' : 'Template';
  },


  // Import List
  KEY_NEW_REPORT_NAME: 'newReportName',
  KEY_NEW_REPORT_DASHBOARD_NAME: 'newReportDashboardName',
  KEY_SAVE_INTO: 'saveInto',
  KEY_CATEGORY: 'category',
  KEY_SUBCATEGORY: 'subCategory',

  // Database Mapping List
  KEY_TO_DATABASE_NAME: 'toDatabaseName',
  KEY_TO_SCHEMA: 'toSchema',

  REQUIRED_VALIDATION_RULES: {
    presence: {
      presence: true,
      message: _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED')
    },
    format: {
      pattern: /^[^/<>&]*$/,
      get message() {
        return _Izenda2.default.getText('INVALID_TEMPLATE_NAME');
      }
    }
  },
  FILE_EXTENSION: {
    REPORT: '.birt',
    DASHBOARD: '.bidb'
  },
  REPORT_NAME_VALIDATION_RULES: {
    presence: presence,
    format: {
      pattern: /^[^/<>&]*$/,
      get message() {
        return _Izenda2.default.getText('INVALID_REPORT_NAME');
      }
    }
  },
  TEMPLATE_NAME_VALIDATION_RULES: {
    presence: presence,
    format: {
      pattern: /^[^/<>&]*$/,
      get message() {
        return _Izenda2.default.getText('INVALID_TEMPLATE_NAME');
      }
    }
  },
  DASHBOARD_NAME_VALIDATION_RULES: {
    presence: presence,
    format: {
      pattern: /^[^/<>&]*$/,
      get message() {
        return _Izenda2.default.getText('INVALID_DASHBOARD_NAME');
      }
    }
  },

  IMPORT_PROGRESS_LIST_MAX_HEIGHT: 300,
  get ImportStatus() {
    return {
      NOT_PROCESSED: { value: 0, label: _Izenda2.default.getText('IMPORT_STATUS_NOT_PROCESSED') },
      SUCCESS: { value: 1, label: _Izenda2.default.getText('IMPORT_STATUS_SUCCESS') },
      FAILED: { value: 2, label: _Izenda2.default.getText('IMPORT_STATUS_FAILED') },
      CANCELED: { value: 3, label: '' },
      IN_PROGRESS: { value: 4, label: '' }
    };
  },
  IMPORT_STATUS_REFRESH_INTERVAL: 2000,

  // KEY TYPES TITLE
  TYPE_REPORT: 1,
  TYPE_DASHBOARD: 2,

  // KEY TYPE TO LOAD ACCESS RIGHTS
  TYPE_ACCESS_REPORT: 0,
  TYPE_ACCESS_DASHBOARD: 1,

  get TitlesData() {
    return {
      get settingLevel() {
        return _Izenda2.default.getText('IMPORT_SETTING_LEVEL');
      },
      get databases() {
        return _Izenda2.default.getText('IMPORT_DATABASES');
      },
      get dataSources() {
        return _Izenda2.default.getText('IMPORT_DATA_SOURCES');
      },
      get customViews() {
        return _Izenda2.default.getText('IMPORT_CUSTOM_VIEWS');
      },
      get calculatedFields() {
        return _Izenda2.default.getText('IMPORT_CALCULATED_FIELDS');
      }
    };
  },

  HINT_MESSAGE: {
    get CATEGORY() {
      return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_HINT_CATEGORY');
    },
    get SUB_CATEGORY() {
      return _Izenda2.default.getText('REPORTDESIGNER_MESSAGE_HINT_SUB_CATEGORY');
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.ReportPartTypeManager.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartTypeManager
 */
!function () {
  var ensure = __webpack_require__(38);
  var notFound = __webpack_require__(213);
  var ReportPartActions = __webpack_require__(1633);
  var DISPLAY_SECTION = {
    Dashboard: 'Dashboard',
    Viewer: 'Viewer',
    Report: 'Report'
  };

  var _require = __webpack_require__(1),
      chain = _require.chain,
      filter = _require.filter,
      indexOf = _require.indexOf,
      placeholder = _require.placeholder;

  var reportPartManager = {};

  var notFoundReportPart = {
    component: {
      BackSide: notFound,
      FrontSide: notFound
    }
  };

  module.exports = {
    DISPLAY_SECTION: DISPLAY_SECTION,

    /**
     * Register your Report Part here
     * @param  {ReportPart} reportPart: reportPart
     * @param  {String} key
     * @return {array} the list objects data object
     * Sample: ReportPartTypeManager.registerReportPartType(ReportPartConfig, 'key')
     */
    registerReportPartType: function registerReportPartType(reportPart, key) {
      ensure(reportPart, 'Invalid reportPart');
      ensure(key, 'Invalid reportPart key');

      reportPartManager[key] = reportPart;
    },

    /**
     * get Report Part
     * @param  {String} key
     * @return {ReportPart} reportPart
     */
    getReportPartType: function getReportPartType(key, properties) {
      properties = properties || 'value';
      var reportPart = chain(reportPartManager).values().find([properties, key]).value();
      return reportPart ? reportPart : notFoundReportPart;
    },

    getReportFrontSide: function getReportFrontSide(key, forDisplay) {
      var FrontSide = this.getReportPartType(key).component.FrontSide;
      var action = null;

      switch (forDisplay) {
        case DISPLAY_SECTION.Dashboard:
          action = ReportPartActions.dashboard;
          break;
        case DISPLAY_SECTION.Viewer:
          action = ReportPartActions.viewer;
          break;
        default:
          action = ReportPartActions.report;
      }
      return action(FrontSide);
    },

    /**
     * filter report part
     * @param  {Array or ReportPart} reportParts array of report part need to filter
     * @return {Array of ReportPart}             array of report part after
     */
    filterSupportedReports: function filterSupportedReports(reportParts) {
      var supportReportPart = placeholder(reportPartManager).values().map('value').value();

      // Only get report part have type in registerReportPartType
      return filter(function (item) {
        return indexOf(item.type, supportReportPart) >= 0;
      }, reportParts);
    }
  };
}();

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DataGridSearch.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module DataGridSearch component
 * @example
 *   <DropDownList></DropDownList>
 *   <TextBox></TextBox>
 *   <SearchButton></SearchButton>
 */
!function () {
  var React = __webpack_require__(0);
  var DropDown = __webpack_require__(29);
  var SearchTextBox = __webpack_require__(107);
  var UiState = __webpack_require__(15);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      debounce = _require.debounce,
      noop = _require.noop,
      isNil = _require.isNil,
      isString = _require.isString;

  var DataGridSearch = React.createClass({
    displayName: 'DataGridSearch',

    searchProperty: '',

    propTypes: {
      searchPropClass: React.PropTypes.string,
      searchInputClass: React.PropTypes.string,
      options: React.PropTypes.oneOfType([React.PropTypes.object.isRequired, React.PropTypes.array.isRequired]),
      value: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
      searchValue: React.PropTypes.string,
      onChange: React.PropTypes.func,
      onSearchPropertiesChange: React.PropTypes.func,
      onSizeStateChange: React.PropTypes.func
    },

    getInitialState: function getInitialState() {
      var props = this.props;

      return {
        searchProperty: props.value,
        searchInput: props.searchValue || '',
        isMinState: UiState.isMobile,
        isMobile: UiState.isMobile
      };
    },

    componentWillMount: function componentWillMount() {
      this.registerOnChangeFn(this.props);
    },

    registerOnChangeFn: function registerOnChangeFn(props) {
      this.debounceOnChange = debounce(300, props.onSearchPropertiesChange || noop);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        searchProperty: nextProps.value,
        // need to set searchInput to empty string so only check if nextProps is null or undefined
        searchInput: isNil(nextProps.searchValue) ? this.state.searchInput : nextProps.searchValue
      });
      if (this.props.onSearchPropertiesChange !== nextProps.onSearchPropertiesChange) {
        this.registerOnChangeFn(nextProps);
      }

      if (this.state.isMobile !== UiState.isMobile) {
        this.setState({
          isMinState: UiState.isMobile,
          isMobile: UiState.isMobile
        });
      }
    },

    renderFullState: function renderFullState() {
      var classes = classnames('izenda-DataGridSearch', this.props.className);
      var isResponsive = this.props.responsive || false;
      var isMobile = this.state.isMobile || false;
      return React.createElement(
        'div',
        { className: classes, ref: 'dataGridSearch', 'aria-expanded': 'false' },
        React.createElement(
          'div',
          { className: 'u_tableCell izenda-DataGridSearch-select' },
          React.createElement(DropDown, {
            options: this.props.options,
            value: this.state.searchProperty,
            labelField: 'label',
            valueField: 'value',
            onChange: this._onDropdownChange,
            className: this.props.searchPropClass,
            autoWidth: true
          })
        ),
        React.createElement(SearchTextBox, {
          className: this.props.searchInputClass,
          onChange: this.changeSearchText,
          value: this.state.searchInput,
          clickable: true,
          onKeyPress: this._onKeyPress,
          onClick: this._onSearch
        }),
        isMobile && isResponsive && React.createElement(
          'div',
          { className: 'izenda-DataGridSearch-cancel' },
          React.createElement(
            'button',
            { type: 'button', className: 'btn btn-icon', onClick: this.showMin },
            React.createElement('span', { className: 'icon-cancel-circled' })
          )
        )
      );
    },

    renderMinState: function renderMinState() {
      var classes = classnames('izenda-DataGridSearch', this.props.className);

      return React.createElement(
        'div',
        { className: classes, ref: 'dataGridSearch', 'aria-expanded': 'false' },
        React.createElement(
          'a',
          { className: 'izenda-DataGridSearch-iconSearch', onClick: this.onMinSearchIconClick },
          React.createElement('span', { className: 'icon-search' })
        )
      );
    },

    render: function render() {
      if (!this.props.responsive) return this.renderFullState();
      return this.state.isMinState ? this.renderMinState() : this.renderFullState();
    },

    onMinSearchIconClick: function onMinSearchIconClick(e) {
      e.preventDefault();
      this.showFull();
      return false;
    },

    showFull: function showFull() {
      var onSizeStateChange = this.props.onSizeStateChange;
      this.setState({
        isMinState: false
      }, function () {
        onSizeStateChange && onSizeStateChange(this.state.isMinState);
      });
    },

    showMin: function showMin() {
      var onSizeStateChange = this.props.onSizeStateChange;
      this.setState({
        isMinState: true
      }, function () {
        onSizeStateChange && onSizeStateChange(this.state.isMinState);
      });
    },

    changeSearchText: function changeSearchText(e) {
      this.setState({ searchInput: e.target.value });
      this.debounceOnChange(this.state.searchProperty, e.target.value);
    },

    _onDropdownChange: function _onDropdownChange(obj) {
      this.setState({ searchProperty: obj.value });
      if (this.state.searchInput) {
        this._onSearch(obj.value);
      }

      this.props.onSearchPropertiesChange && this.props.onSearchPropertiesChange(obj.value, this.state.searchInput);
    },

    _onKeyPress: function _onKeyPress(e) {
      if (e.key === 'Enter') {
        this._onSearch();
      }
    },

    _onSearch: function _onSearch(value) {
      var state = this.state;
      var keySearch = isString(value) ? value : state.searchProperty;
      this.props.onSearch(keySearch, state.searchInput);
    }
  });

  module.exports = DataGridSearch;
}();

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Action bar component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(30);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBar = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ActionBar, _Component);

  function ActionBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      disabled: _this.props.disabled
    }, _this.enableComponent = function (isDisabled) {
      _this.setState({
        disabled: isDisabled
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.enableComponent(this.props.disabled);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.enableComponent(nextProps.disabled);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var state = this.state;
      var statefullChildren = _react2.default.Children.map(props.children, makeStatefull);

      return _react2.default.createElement(
        'div',
        { className: 'izenda-ActionBarRight' },
        statefullChildren,
        _react2.default.createElement(_Izenda4.default, {
          onClick: props.onSave,
          disabled: state.disabled,
          label: _Izenda2.default.getText('COMMON_LABEL_SAVE')
        }),
        _react2.default.createElement(_Izenda4.default, {
          onClick: props.onCancel,
          disabled: state.disabled,
          label: _Izenda2.default.getText('COMMON_LABEL_CANCEL')
        })
      );

      function makeStatefull(elem) {
        return elem && _react2.default.cloneElement(elem, { disabled: state.disabled });
      }
    }
  }]);
  return ActionBar;
}(_react.Component), _class.propTypes = {
  onSave: _react2.default.PropTypes.func.isRequired,
  onCancel: _react2.default.PropTypes.func.isRequired,
  disabled: _react2.default.PropTypes.bool
}, _temp2);
exports.default = ActionBar;
module.exports = exports['default'];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthorizationValidator.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var m = __webpack_require__(5);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      omit = _require.omit,
      assign = _require.assign;

  function AuthorizationValidator() {
    return function (BaseComponent) {
      var AuthorizableEditor = React.createClass({
        displayName: 'Authorization(' + BaseComponent.displayName + ')',
        propTypes: {
          // Authorization keys
          keys: React.PropTypes.oneOfType([React.PropTypes.object.isRequired, React.PropTypes.array.isRequired]),
          // Hide in integration mode
          integrationHidden: React.PropTypes.bool,
          // Hide when not having sufficient privilege
          authHidden: React.PropTypes.bool,
          // Overriding authorization function
          onAuth: React.PropTypes.func
        },
        contextTypes: {
          authorization: React.PropTypes.oneOfType([React.PropTypes.array, React.PropTypes.object])
        },
        getDefaultProps: function getDefaultProps() {
          return {
            authHidden: true,
            integrationHidden: false
          };
        },

        componentWillMount: function componentWillMount() {
          // User has sufficient privilege to see the component
          this.hasPrivilege = this.context.authorization.checkPrivileges(this.props.keys);
          // The component should be hidden as the system is in integration mode.
          this.hideAsIntegration = this.props.integrationHidden && this.context.authorization.isIntegrationMode();
        },

        /**
         * Build properties
         * @returns {Object} rest of properties
         */
        buildProps: function buildProps() {
          var rest = omit(['keys', 'authHidden', 'integrationHidden'], this.props);

          if (isNil(this.props.onAuth)) {
            return rest;
          } else {
            return assign(rest, this.props.onAuth());
          }
        },

        render: function render() {
          var rest = this.buildProps();

          // Hide the component when
          //    - NOT have privilege and it needs to be hidden by privilege
          //    - OR hide in integration mode
          var shouldHide = !this.hasPrivilege && this.props.authHidden || this.hideAsIntegration;

          return shouldHide ? null : React.createElement(BaseComponent, rest);
        }
      });

      return observer(AuthorizableEditor);
    };
  }

  module.exports = AuthorizationValidator;
}();

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Loading.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      invoke = _require.invoke;

  var Loading = observer(React.createClass({
    displayName: 'Loading',

    onCancel: function onCancel() {
      invoke('onCancel', this.props);
    },

    render: function render() {
      var props = this.props;

      if (!props.show) {
        return null;
      }

      var loadingStrip = React.createElement('div', {
        className: 'progress-bar progress-bar-striped active u_fullWidth',
        'aria-valuenow': '100',
        'aria-valuemin': '0',
        'aria-valuemax': '100'
      });

      loadingStrip = invoke('allowToCancelProgress', props) ? renderWithCancelBtn.call(this, loadingStrip) : loadingStrip;

      var loadingContent = props.withoutBorder ? loadingStrip : React.createElement(
        'div',
        { className: 'Reporting-Loading-Overlay' },
        React.createElement(
          'div',
          { className: 'Reporting-Loading-Canvas' },
          loadingStrip
        )
      );

      if (props.classNameContainer) {
        return React.createElement(
          'div',
          { className: props.classNameContainer },
          loadingContent
        );
      } else {
        return loadingContent;
      }

      function renderWithCancelBtn(loadingStrip) {
        return React.createElement(
          'div',
          { className: 'Loading-With-Btns u-posRelative' },
          React.createElement(
            'div',
            { className: 'progress-section' },
            loadingStrip
          ),
          React.createElement(
            'div',
            { className: 'btn-section u-posAbsolute u-posTopRight' },
            React.createElement(
              'a',
              { label: 'Cancel', onClick: this.onCancel },
              'Cancel'
            )
          )
        );
      }
    }
  }));

  Loading.propTypes = {
    show: React.PropTypes.bool,
    withoutBorder: React.PropTypes.bool
  };
  module.exports = Loading;
}();

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.LayoutUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var UiState = __webpack_require__(15);
  var BrowserUtils = __webpack_require__(78);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  function toggle(element, option) {
    if (element.getAttribute('aria-expanded') === 'false') {
      show(element);
    } else {
      hide(element, option);
    }
  }

  function hide(element, option) {
    element.setAttribute('aria-expanded', 'false');
    !option && $izenda('.izenda-Overlay').attr('aria-expanded', 'false');
  }

  function show(element) {
    element.setAttribute('aria-expanded', 'true');
    $izenda('.izenda-Overlay').attr('aria-expanded', 'true');
  }

  function handleToggle(value, className, option) {
    if (!BrowserUtils.isMobileDevice()) {
      return;
    }

    var element = document.getElementsByClassName(className)[0];

    if (isNil(element)) return;

    switch (value) {
      case true:
        show(element);
        break;
      case false:
        hide(element, option);
        break;
      default:
        toggle(element, option);
    }
  }

  function toggleMiddelPanel(value, option) {
    handleToggle(value, 'izenda-MiddlePanel', option);
  }

  function toggleSideBar(value) {
    handleToggle(value, 'izenda-Sidebar');
  }

  function togglePropertiesEditor(value) {
    handleToggle(value, 'izenda-RightPanel');
    handleToggle(value, 'izenda-PropertiesContainer');
  }

  function toggleIconMenu(value) {
    handleToggle(value, 'izenda-IconMenu');
  }

  function toggleOverlay(value) {
    handleToggle(value, 'izenda-Overlay');
  }

  function toggleTopMenu(value) {
    handleToggle(value, 'izenda-TopMenu-nav');
  }

  module.exports = {
    toggleSideBar: toggleSideBar,
    toggleOverlay: toggleOverlay,
    toggleTopMenu: toggleTopMenu,
    toggleIconMenu: toggleIconMenu,
    toggleMiddelPanel: toggleMiddelPanel,
    togglePropertiesEditor: togglePropertiesEditor
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FloatAffixed.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * FloatAffixed component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);

  var domHelperEvents = __webpack_require__(308);
  var FloatAffixedController = __webpack_require__(1754);
  var Portal = __webpack_require__(919);

  var FloatAffixed = React.createClass({
    displayName: 'FloatAffixed',

    propTypes: {
      children: React.PropTypes.oneOfType([React.PropTypes.element, React.PropTypes.array]).isRequired,
      anchor: React.PropTypes.object.isRequired,
      edges: React.PropTypes.string,
      renderInContainer: React.PropTypes.bool,
      onClickOutside: React.PropTypes.func,
      onParentScroll: React.PropTypes.func,
      autoWidth: React.PropTypes.bool,
      minWidth: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string])
    },

    getDefaultProps: function getDefaultProps() {
      return {
        minWidth: 160,
        renderInContainer: true
      };
    },

    componentWillMount: function componentWillMount() {
      var props = this.props;

      this.anchor = props.anchor;
      this.controller = props.floatAffixedController || new FloatAffixedController();
    },

    componentDidMount: function componentDidMount() {
      this.eventWithAnchorAncestors(function (e) {
        domHelperEvents.on(e, "scroll", this.handleElementScroll);
      }.bind(this));
      domHelperEvents.on(window, 'resize', this.handleWindowResize);
      domHelperEvents.on(window, 'mousedown', this.handleDocumentClick);
      domHelperEvents.on(window, 'touchend', this.handleDocumentClick);

      this.controller.reposition(this.props, this.popup);
    },

    componentWillUnmount: function componentWillUnmount() {
      this.eventWithAnchorAncestors(function (e) {
        domHelperEvents.off(e, "scroll", this.handleElementScroll);
      }.bind(this));
      domHelperEvents.off(window, 'resize', this.handleWindowResize);
      domHelperEvents.off(window, 'mousedown', this.handleDocumentClick);
      domHelperEvents.off(window, 'touchend', this.handleDocumentClick);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (nextProps != this.props) {
        this.controller.reposition(nextProps, this.popup);
      }
    },

    handleDocumentClick: function handleDocumentClick(event) {
      var isInsidePopup = this.popup.contains(event.target) || this.popup === event.target;
      var isInsideAnchor = this.anchor.contains(event.target) || this.anchor === event.target;

      if (!isInsidePopup && !isInsideAnchor && !hasClass(event.target, "izenda")) {
        this.props.onClickOutside && this.props.onClickOutside(event);
      }

      function hasClass(element, cls) {
        return element.className && new RegExp("(\\s|^)" + cls + "(\\s|$)").test(element.className);
      }
    },

    eventWithAnchorAncestors: function eventWithAnchorAncestors(fn) {
      if (this.anchor) {
        var element = this.anchor.parentNode;
        while (element !== null && element !== window) {
          fn(element);
          element = element.parentNode;
        }
      }
    },

    handleElementScroll: function handleElementScroll(event) {
      this.controller.reposition(this.props, this.popup);
      this.props.onParentScroll && this.props.onParentScroll(event);
    },

    handleWindowResize: function handleWindowResize() {
      this.controller.reposition(this.props, this.popup);
    },

    refPopup: function refPopup(node) {
      this.popup = node;
    },

    render: function render() {
      var props = this.props;
      var popupStyle = {
        left: this.controller.translation.x,
        top: this.controller.translation.y,
        width: this.anchor.offsetWidth
      };
      if (props.autoWidth) {
        popupStyle.width = this.anchor.offsetWidth > props.minWidth ? this.anchor.offsetWidth : props.minWidth;
      }

      var popupClasses = classnames({
        'izenda-FloatAffixed': true,
        'invisible': !this.controller.isElementInView(this.anchor, this.anchor.offsetParent)
      }, props.className, this.controller.schemeName);

      return props.renderInContainer ? React.createElement(
        Portal,
        null,
        React.createElement(
          'div',
          { ref: this.refPopup, style: popupStyle, className: popupClasses },
          props.children
        )
      ) : React.createElement(
        'div',
        { ref: this.refPopup, style: popupStyle, className: popupClasses },
        props.children
      );
    }
  });

  module.exports = observer(FloatAffixed);
}();

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerCommonDataStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Other Settings Store
 */
!function () {
  var fetcher = __webpack_require__(90);
  var jsFormatService = __webpack_require__(220);

  var _require = __webpack_require__(16),
      DATA_TYPES = _require.DATA_TYPES;

  var _require2 = __webpack_require__(1),
      isNil = _require2.isNil,
      forEach = _require2.forEach,
      filter = _require2.filter;

  var commonData = {
    DATA_TYPE: {}
  };

  /**
   * Get data from commonData based on dataType and key
   * @param  {[type]} dataType [description]
   * @param  {[type]} key      [description]
   * @return {[type]}          [description]
   */
  function getData(dataType, key) {
    return commonData[dataType] && commonData[dataType][key];
  }

  /**
   * Set data to commonData based on dataType, key and value
   * @param {[type]} dataType [description]
   * @param {[type]} key      [description]
   * @param {[type]} value    [description]
   */
  function setData(dataType, key, value) {
    commonData[dataType] = commonData[dataType] || {};
    commonData[dataType][key] = value;
  }

  module.exports = {
    /**
     * Load list of data format based on dataType for filter
     * @param  {string} dataFormatType
     * @return {promise}
     */
    loadFilterDataFormat: function loadFilterDataFormat(dataFormatType) {
      var key = 'FILTER_DATA_TYPE';
      var cachedPromise = getData(key, dataFormatType);

      if (isNil(cachedPromise) || cachedPromise.isRejected()) {
        // cache promised object
        cachedPromise = fetcher.loadFilterDataFormat(dataFormatType);
        setData(key, dataFormatType, cachedPromise);
      }

      return cachedPromise.catch(function () {
        return [];
      });
    },

    /**
     * Load list of function for report part: field properties, sub total, grand total
     * @param  {string} functionMode
     * @param  {string} dataFormatType
     * @param  {array} querySourceIds
     * @return {promise}
     */
    loadReportFunction: function loadReportFunction(functionMode, dataFormatType, tenantId, querySourceIds) {
      return fetcher.loadReportFunction(functionMode, dataFormatType, tenantId, querySourceIds);
    },

    /**
     * Get list of data-format for report part, field properties
     * @param  {[type]} dataFormatType [description]
     * @return {[type]}                [description]
     */
    loadReportFieldDataFormat: function loadReportFieldDataFormat(dataFormatType, withoutCache) {
      var key = 'RP_FIELD_DATA_TYPE';
      var cachedPromise;

      if (!withoutCache) {
        cachedPromise = getData(key, dataFormatType);
      }

      // check if have cached or cached promise is rejected
      if (isNil(cachedPromise) || cachedPromise.isRejected()) {
        // cache promised object
        cachedPromise = fetcher.loadReportFieldDataFormat(dataFormatType);
        !withoutCache && setData(key, dataFormatType, cachedPromise);
      }

      return cachedPromise.catch(function () {
        return [];
      });
    },

    /**
     * Get list of custom data-format for report part, field properties
     * @param  {[type]} dataFormatType [description]
     * @return {[type]}                [description]
     */
    loadCustomDataFormat: function loadCustomDataFormat(dataFormatType, withoutCache) {
      var key = 'RP_FIELD_DATA_TYPE';
      var cachedPromise;

      if (!withoutCache) {
        cachedPromise = getData(key, dataFormatType);
      }

      if (isNil(cachedPromise) || cachedPromise.isRejected()) {
        cachedPromise = fetcher.loadReportFieldDataFormat(DATA_TYPES.CUSTOM).then(function (data) {
          var customDataFormats = filter(function (item) {
            return item.jsFormatString !== null;
          }, data);
          forEach(function (customDataFormat) {
            jsFormatService.registerJsFormatString(customDataFormat.name, customDataFormat.jsFormatString);
          }, customDataFormats);
        });
        !withoutCache && setData(key, dataFormatType, cachedPromise);
      }

      return cachedPromise.catch(function () {
        return [];
      });
    }
  };
}();

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="MainContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


/**
 * Main Content component
 */

!function () {

  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);

  var MainContent = React.createClass({
    displayName: 'MainContent',

    /**
    * Get default properties
    */
    getDefaultProps: function getDefaultProps() {
      return {
        hidden: false
      };
    },
    render: function render() {
      var props = this.props;

      return props.hidden ? null : React.createElement(
        'section',
        { className: classnames(['izenda-MainContent', props.className]) },
        this.props.children
      );
    }
  });

  module.exports = MainContent;
}();

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

var _bluebird = __webpack_require__(18);

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditorManager.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * PropertiesEditorManager
 */
!function () {
  var m = __webpack_require__(5);
  var PERMISSION_KEY = __webpack_require__(42).PERMISSION_KEY;
  var SecurityManager = __webpack_require__(120);
  var securityManager = new SecurityManager();

  var _require = __webpack_require__(1),
      isArray = _require.isArray,
      flow = _require.flow,
      keys = _require.keys,
      find = _require.find,
      reduce = _require.reduce,
      isString = _require.isString,
      isObject = _require.isObject,
      uniqueId = _require.uniqueId,
      forEach = _require.forEach,
      includes = _require.includes,
      zipObject = _require.zipObject,
      isFunction = _require.isFunction,
      concat = _require.concat,
      get = _require.get,
      getOr = _require.getOr,
      invokeArgs = _require.invokeArgs,
      head = _require.head;

  var DEFAULT_COMPONENT_NAME = 'defaultEditor';

  // save information of editor: name, schema, default action....
  var componentManager = {};

  // save status of each editor: is observerble object, allow to add action when ever its status changed (active/deactive)
  var showingEditors = m.observable({});

  // save information of registed-component: component, propeties...
  var showingComponents = {};

  var handlersInfo = {};

  // Default state
  var viewStyle = m.observable({
    simpleState: false
  });

  /**
   * Find editorId by names
   * @param  {array} editorNames
   * @return {string}
   */
  function findEditorIdByName(editorNames) {
    editorNames = isArray(editorNames) ? editorNames : [editorNames];

    var found = flow(keys, find(hasEditor))(componentManager);

    return found;

    function hasEditor(editorId) {
      var editorInfo = componentManager[editorId] || {};
      var names = editorInfo.editorNames || [];

      return reduce(function (re, editorName) {
        return re && includes(editorName, names);
      }, true, editorNames);
    }
  }

  /**
   * Reset editors
   * @param {String | Object} editors
   */
  function resetEditor(editors) {
    editors = editors || DEFAULT_COMPONENT_NAME;

    var editorNames;

    if (isString(editors)) {
      editorNames = [editors];
    } else if (isObject(editors)) {
      editorNames = (0, _keys2.default)(editors);
    }

    if (!editorNames) {
      throw new Error('Cannot add editor');
    }

    var editorId = findEditorIdByName(editorNames);

    componentManager[editorId] && delete componentManager[editorId];
    showingEditors[editorId] && delete showingEditors[editorId];
    showingComponents[editorId] && delete showingComponents[editorId];
    handlersInfo[editorId] && delete handlersInfo[editorId];
  }

  /**
   * Add editor
   * @param {object}  component       react-component
   * @param {object}  editors         editors information
   * @param {array}   defaultParams   used to build schema-data
   */
  function addEditor(component, editors, defaultParams) {
    editors = editors || DEFAULT_COMPONENT_NAME;

    var editorNames;

    if (isString(editors)) {
      editorNames = [editors];
    } else if (isObject(editors)) {
      editorNames = (0, _keys2.default)(editors);
    }

    if (!editorNames) {
      throw new Error('Cannot add editor');
    }

    var newEditorId = uniqueId('editor_');

    componentManager[newEditorId] = {
      component: component,
      defaultParams: defaultParams,
      editorNames: editorNames
    };

    // init status for each editor in showingEditors: default status is disabled
    showingComponents[newEditorId] = {};
    showingEditors[newEditorId] = {};
    handlersInfo[newEditorId] = {};

    forEach(function (name) {
      m.extendObservable(showingEditors[newEditorId], zipObject([name], [false]));
    }, editorNames);

    component.setEditorInfo && component.setEditorInfo({
      handlers: handlersInfo[newEditorId]
    });

    return isObject(editors) ? getDefaultSchema(editors, defaultParams) : null;

    function getDefaultSchema(editors, defaultParams) {
      var defaultSchemas = {};
      var editorName, definedEditor;

      for (editorName in editors) {
        definedEditor = editors[editorName];
        if (isFunction(definedEditor.defaultSchema)) {
          defaultSchemas[editorName] = getSchema(newEditorId, definedEditor.defaultSchema);
        }
      }

      return defaultSchemas;
    }
  }

  /**
   * Build schema data
   * @param  {String} editorId
   * @param  {Function} definedSchema
   * @param  {Array} params
   * @return {Object}
   */
  function getSchema(editorId, definedSchema, params) {
    var componentInfo = componentManager[editorId];
    var editorComp = componentInfo.component;
    var defaultParams = getOr([], 'defaultParams', componentInfo);

    return definedSchema.apply(null, concat([editorComp], concat(defaultParams, params)));
  }

  /**
   * Rerender prop-editor with new config
   * @param  {[type]} editorComp [description]
   * @return {[type]}            [description]
   */
  function renderEditor(editorComp, editorId, activeEditorName, registerComponent, registerProps, propsEditors) {
    if (!editorComp || !editorComp.forceUpdate) {
      return;
    }

    invokeArgs('beforeRender', editorComp, [registerComponent]);

    editorComp.forceUpdate && editorComp.forceUpdate();
  }

  /**
   * Regist to to show defined-schema in added-editor
   * @param  {Object} registerComponent react-component
   * @param  {Object} registerProps
   * @param  {Object} propsEditors
   * @return {Any}
   */
  function registerByEditors(registerComponent, registerProps, propsEditors) {
    if (!propsEditors) {
      return;
    }

    var args = Array.prototype.slice.call(arguments, 3);
    var usingEditors = getEditorInfo(propsEditors);
    var editorId = findEditorIdByName(usingEditors.names);

    if (!editorId) {
      throw new Error('Cannot not render, using editors are not added');
    }

    var newActiveEditor = usingEditors.active;
    var showingEditor = showingEditors[editorId];
    var showingComponent = get(newActiveEditor, showingComponents[editorId]);

    // new regist-editor is active
    if (showingEditor[newActiveEditor]) {
      // registerProps is same as current-active-editor
      if (registerProps === get('props', showingComponent)) {
        return;
      }

      if (!registerProps.isRerenderOnActive && get('getDefinedSchema', usingEditors.activeInfo) === get('propsEditors.getDefinedSchema', showingComponent)) {
        return;
      }
    }

    var editorComp = get('component', componentManager[editorId]);

    // 1. get schema def to each-editor
    propsEditors.forEach(function (editor) {
      editor.schemaDef = editor.getDefinedSchema && getSchema(editorId, editor.getDefinedSchema, concat(registerProps, args));
    });

    if (!editorComp) {
      throw new Errow('Cannot render');
    }

    // 2. save status of registed-component & update status of editor and update default view mode
    for (var name in showingEditors[editorId]) {
      showingEditors[editorId][name] = false;
    }

    showingEditors[editorId][newActiveEditor] = true;
    showingComponents[editorId][newActiveEditor] = {
      component: registerComponent,
      props: registerProps,
      propsEditors: usingEditors.activeInfo
    };

    viewStyle.simpleState = !securityManager.checkPrivileges([PERMISSION_KEY.ReportsDataSourcesAdvancedDataSources]);

    // 3. update config info to editor-component
    editorComp.setPropertySchemas && editorComp.setPropertySchemas(editorId, propsEditors, usingEditors.active);

    // 4.re-render properties editor for new schema
    renderEditor(editorComp, editorId, usingEditors.active, registerComponent, registerProps, propsEditors);
  }

  /**
   * Get editor information
   * @param  {Array} propsEditors
   * @return {Object}
   */
  function getEditorInfo(propsEditors) {
    var info = {
      names: [],
      active: '',
      activeInfo: null
    };

    forEach(function (editor) {
      info.names.push(editor.name);

      if (editor.isActive) {
        info.active = editor.name;
        info.activeInfo = editor;
      }
    }, propsEditors);

    // acitve editor is not default, first editor will be active as default
    if (!info.active) {
      info.activeInfo = head(propsEditors);
      info.active = get('name', info.activeInfo);
    }

    return info;
  }

  /**
   * Set active editor: in-case added-editor is tab-list (tab change will be change acitve-editor)
   * @param {[type]} editorName [description]
   */
  function setActiveEditor(editorName) {
    var editorId = findEditorIdByName(editorName);
    if (editorId) {
      for (var name in showingEditors[editorId]) {
        showingEditors[editorId][name] = false;
      }

      showingEditors[editorId][editorName] = true;

      // set default editor here
      viewStyle.simpleState = !securityManager.checkPrivileges([PERMISSION_KEY.ReportsDataSourcesAdvancedDataSources]);
      return true;
    }

    return false;
  }

  /**
   * Check whethers editor is active or not
   * @param  {Object}  editors
   * @return {Boolean}
   */
  function isShowingPropsEditor(editors) {
    var editorInfo = getEditorInfo(editors);

    var editorId = findEditorIdByName(editorInfo.names);

    if (editorId && showingEditors[editorId][editorInfo.active]) {
      return true;
    }

    return false;
  }

  /**
   *  Get component info for active editors
   * @param  {Object} editors
   * @return {Object}
   */
  function getShowingComponentInfo(editors) {
    var isShowingEditor = isShowingPropsEditor(editors);

    var editorInfo;
    var editorId;

    if (isShowingEditor) {
      editorInfo = getEditorInfo(editors);
      editorId = findEditorIdByName(editorInfo.active);

      return editorId && get(editorInfo.active, showingComponents[editorId]);
    }

    return null;
  }

  /**
   * Check whether active other editor
   * @param  {Object} editors
   * @return {Promise}
   */
  function canSwitch(editors) {
    var editorInfo = getEditorInfo(editors);
    var editorId = findEditorIdByName(editorInfo.active);

    var editorComp = get('component', componentManager[editorId]);

    // check validation
    var validation = get('component.props.validation', componentManager[editorId]) || {};

    if (isFunction(validation.validate)) {
      return validation.validate();
    }

    return (0, _bluebird.resolve)(true);
  }

  /**
   * Get editor status
   * @param  {Object} editors
   * @return {Object}
   */
  function getEditorStatus(editors) {
    var editorInfo = getEditorInfo(editors);
    var editorId = findEditorIdByName(editorInfo.active);

    return editorId && getEditorInfoById(editorId);
  }

  /**
   * Get editor info by editor-id
   * @param  {Object} editorId
   * @return {Object}
   */
  function getEditorInfoById(editorId) {
    return {
      info: componentManager[editorId],
      status: showingEditors[editorId],
      registedComponent: showingComponents[editorId]
    };
  }

  /**
   * Find editor Id
   * @param  {Object} editors
   * @return {String}
   */
  function findEditorId(editors) {
    var editorInfo = getEditorInfo(editors);
    return findEditorIdByName(editorInfo.active);
  }

  function addHandlers(editorId, handlerName, handlers) {
    var newHandlers = {};
    newHandlers[handlerName] = handlers;

    $izenda.extend(handlersInfo[editorId], newHandlers);
  }

  function takeAction(editorId, actionName, editorName, editorInfo) {
    var args = Array.prototype.slice.call(arguments, 4);

    invokeArgs(actionName, args, editorInfo);
    invokeArgs(editorName, args, get(actionName, handlersInfo[editorId]));
  }

  function getViewStyle() {
    return viewStyle;
  }

  function switchViewMode() {
    viewStyle.simpleState = !viewStyle.simpleState;
  }

  module.exports = {
    addEditor: m.action(addEditor),
    resetEditor: m.action(resetEditor),
    registerByEditors: m.action(registerByEditors),
    setActiveEditor: m.action(setActiveEditor),
    addHandlers: addHandlers,

    isShowingPropsEditor: isShowingPropsEditor,
    canSwitch: canSwitch,

    getShowingComponentInfo: getShowingComponentInfo,
    getEditorStatus: getEditorStatus,
    getEditorInfoById: getEditorInfoById,
    findEditorId: findEditorId,
    findEditorIdByName: findEditorIdByName,
    takeAction: m.action(takeAction),
    // Control simple or advance view on properties editor
    getViewStyle: getViewStyle,
    switchViewMode: switchViewMode
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAST_SUCCESS_RUN_VALUE = {
  DATE: 'date',
  EMPTY: '',
  CANNOT_BE_SEND: 'The report cannot be sent',
  HAS_NOT_STATED: 'The schedule has not started'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.SchedulingSearchConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var DELIVERY_TYPE_VALUE = {
  EMPTY: '',
  EMAIL: 'Email',
  FILE_LOCATION: 'File Location'
};

var DELIVER_METHOD_VALUE = {
  EMPTY: '',
  LINK: 'link',
  ATTACHMENT: 'Attachment',
  EMBEDDED_HTML: 'Embedded HTML',
  SEND_TO_DISK: 'Send to Disk'
};

var RECURRENCE_VALUE = {
  EMPTY: '',
  EVERY_HOURLY: '0',
  EVERY_DAILY: '1',
  EVERY_DAY: '2',
  EVERY_WEEKDAY: '3',
  EVERY_WEEK: '4',
  EVERY_TWO_WEEK: '5',
  EVERY_MONTH: '6',
  EVERY_QUARTER: '7',
  CUSTOM: '8'
};

var REPORT_TYPE_VALUE = {
  Report: 1,
  Dashboard: 2
};

var INSTANCE_TYPE_VALUE = {
  EMPTY: '',
  SCHEDULE_REPORT: 'Scheduled Reporting Item',
  SCHEDULE_ALERT: 'Scheduled Alert',
  SUBSCRIBE_REPORTING_ITEM: 'Subscribed Reporting Item',
  SUBSCRIBE_ALERT: 'Subscribed Alert'
};

exports.default = {
  PAGE_SEARCH_SIZE: 10,
  LAST_SUCCESS_RUN_VALUE: LAST_SUCCESS_RUN_VALUE,
  DELIVERY_TYPE_VALUE: DELIVERY_TYPE_VALUE,
  RECURRENCE_VALUE: RECURRENCE_VALUE,
  INSTANCE_TYPE_VALUE: INSTANCE_TYPE_VALUE,
  DELIVER_METHOD_VALUE: DELIVER_METHOD_VALUE,
  REPORT_TYPE_VALUE: REPORT_TYPE_VALUE,
  VALIDATE_DATE_MESSAGE: 'To Date must be greater than or equal to From Date',
  TOOLTIP: {
    get EXPAND() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_TOOLTIP_EXPAND');
    },
    get COLLAPSE() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_TOOLTIP_COLLAPSE');
    }
  },
  DEFAULT_OPTION: {
    value: '',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  },
  REPORT_TYPE: [{
    value: '',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: 'Report',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_REPORTS');
    }
  }, {
    value: 'Dashboard',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_DASHBOARD');
    }
  }],
  INSTANCE_TYPE: [{
    value: '',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: INSTANCE_TYPE_VALUE.SCHEDULE_REPORT,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE_SCHEDULE_REPORT');
    }
  }, {
    value: INSTANCE_TYPE_VALUE.SCHEDULE_ALERT,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE_SCHEDULE_ALERT');
    },
    alertingLicense: true
  }, {
    value: INSTANCE_TYPE_VALUE.SUBSCRIBE_REPORTING_ITEM,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE_SUBSCRIBE_REPORT');
    }
  }, {
    value: INSTANCE_TYPE_VALUE.SUBSCRIBE_ALERT,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE_SUBSCRIBE_ALERT');
    },
    alertingLicense: true
  }],
  RECURRENCE: [{
    value: RECURRENCE_VALUE.EMPTY,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: RECURRENCE_VALUE.EVERY_DAY,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_DATE');
    }
  }, {
    value: RECURRENCE_VALUE.EVERY_WEEKDAY,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_WEEKDAY');
    }
  }, {
    value: RECURRENCE_VALUE.EVERY_WEEK,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_WEEK');
    }
  }, {
    value: RECURRENCE_VALUE.EVERY_TWO_WEEK,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_TWO_WEEK');
    }
  }, {
    value: RECURRENCE_VALUE.EVERY_MONTH,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_MONTH');
    }
  }, {
    value: RECURRENCE_VALUE.EVERY_QUARTER,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_QUARTER');
    }
  }, {
    value: RECURRENCE_VALUE.EVERY_HOURLY,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECURRENCE_EVERY_HOURLY');
    }
  }, {
    value: RECURRENCE_VALUE.EVERY_DAILY,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECURRENCE_EVERY_DAILY');
    }
  }, {
    value: RECURRENCE_VALUE.CUSTOM,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECURRENCE_CUSTOM');
    }
  }],
  DELIVERY_TYPE: [{
    value: DELIVERY_TYPE_VALUE.EMPTY,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: DELIVERY_TYPE_VALUE.EMAIL,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EMAIL');
    }
  }, {
    value: DELIVERY_TYPE_VALUE.FILE_LOCATION,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_DELIVERY_TYPE_FILE_LOCATION');
    }
  }],
  DELIVERY_METHOD: [{
    value: DELIVER_METHOD_VALUE.EMPTY,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: DELIVER_METHOD_VALUE.LINK,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_LINK');
    }
  }, {
    value: DELIVER_METHOD_VALUE.ATTACHMENT,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ATTACHMENT');
    }
  }, {
    value: DELIVER_METHOD_VALUE.EMBEDDED_HTML,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EMBEDDED_HTML');
    }
  }, {
    value: DELIVER_METHOD_VALUE.SEND_TO_DISK,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_DELIVERY_METHOD_SEND_TO_DISK');
    }
  }],
  EXPORT_FILE_TYPE: [{
    value: '',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, { value: 'PDF', label: 'PDF' }, { value: 'Word', label: 'Word' }, { value: 'Excel', label: 'Excel' }, { value: 'CSV', label: 'CSV' }],
  LAST_SUCCESS_RUN: [{
    value: LAST_SUCCESS_RUN_VALUE.EMPTY,
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: LAST_SUCCESS_RUN_VALUE.DATE,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_DATE');
    }
  }, {
    value: LAST_SUCCESS_RUN_VALUE.CANNOT_BE_SEND,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_LAST_SUCCESS_RUN_CANNOT_BE_SEND');
    }
  }, {
    value: LAST_SUCCESS_RUN_VALUE.HAS_NOT_STATED,
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_LAST_SUCCESS_RUN_NOT_STARTED');
    }
  }],
  NEXT_SCHEDULED_RUN: [{
    value: '',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: 'date',
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_DATE');
    }
  }, {
    value: 'No recurrence',
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_NEXT_SCHEDULED_RUN_NO_RECURRENCE');
    }
  }, {
    value: 'The Schedule has ended',
    get label() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_NEXT_SCHEDULED_RUN_ENDED');
    }
  }],
  SEARCH_KEY: {
    reportType: 'ReportingType',
    name: 'ReportDashboardName',
    deliveryType: 'DeliveryType',
    deliveryMethod: 'DeliveryMethod',
    recipients: 'Recipients',
    instanceType: 'Type',
    lastSuccessfulRun: 'LastSuccessfulRun',
    nextScheduledRun: 'NextScheduledRun',
    nextScheduledRunFrom: 'NextScheduledRunFrom',
    nextScheduledRunTo: 'NextScheduledRunTo',
    lastSuccessfulRunFrom: 'LastSuccessfulRunFrom',
    lastSuccessfulRunTo: 'LastSuccessfulRunTo',
    recurrence: 'RecurrenceType',
    exportFileType: 'ExportFileType',
    createdBy: 'CreatedBy'
  },
  TABLE_DEF: {
    selected: { key: 'selected', width: 30, title: '', sortable: false, columnKey: 'selected' },
    reportingType: {
      key: 'reportingType',
      width: 120,
      get title() {
        return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_REPORT_TYPE');
      },
      sortable: true,
      columnKey: 'reportingType'
    },
    reportDashboardName: {
      key: 'reportDashboardName',
      width: 140,
      get title() {
        return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_REPORTING_NAME');
      },
      sortable: true,
      columnKey: 'reportDashboardName'
    },
    name: {
      key: 'name',
      width: 140,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_INSTANCE_NAME');
      },
      sortable: true,
      columnKey: 'name'
    },
    type: {
      key: 'type',
      width: 100,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_TYPE');
      },
      sortable: true,
      columnKey: 'type'
    },
    schedule: {
      key: 'schedule',
      width: 220,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_SCHEDULE');
      },
      sortable: true,
      columnKey: 'schedule'
    },
    deliveryType: {
      key: 'deliveryType',
      width: 120,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_DELIVERY_TYPE');
      },
      sortable: true,
      columnKey: 'deliveryType'
    },
    deliveryMethod: {
      key: 'deliveryMethod',
      width: 140,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_DELIVERY_METHOD');
      },
      sortable: true,
      columnKey: 'deliveryMethod'
    },
    exportFileType: {
      key: 'exportFileType',
      width: 140,
      get title() {
        return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_EXPORT_FILE_TYPE');
      },
      sortable: true,
      columnKey: 'exportFileType'
    },
    recipients: {
      key: 'recipients',
      width: 120,
      get title() {
        return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECIPENT');
      },
      sortable: true,
      columnKey: 'recipients'
    },
    lastSuccessfulRun: {
      key: 'lastSuccessfulRun',
      width: 170,
      get title() {
        return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_LAST_SUCCESS_RUN');
      },
      sortable: true,
      columnKey: 'lastSuccessfulRun'
    },
    nextScheduledRun: {
      key: 'nextScheduledRun',
      width: 170,
      get title() {
        return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_NEXT_SCHEDULED_RUN');
      },
      sortable: true,
      columnKey: 'nextScheduledRun'
    },
    createdBy: {
      key: 'createdBy',
      width: 100,
      get title() {
        return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_CREATED_BY');
      },
      sortable: true,
      columnKey: 'createdBy'
    },
    action: {
      key: 'action',
      width: 80,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_ACTION');
      },
      sortable: false,
      fixed: true
    }
  },
  ACTION_TEXT: {
    get EditText() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_ACTION_EDIT_TEXT');
    },
    get DeleteText() {
      return _Izenda2.default.getText('SCHEDULING_SEARCH_CONSTANT_ACTION_DELETE_TEXT');
    }
  },
  DEFAULT_SORT_ORDER: {
    name: 'DESC'
  },
  TEMPLATE_TYPE: 0
};
module.exports = exports['default'];

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  QUERY_SOURCE_TYPE: {
    TABLE: 'Table',
    VIEW: 'View',
    FUNCTION: 'Function',
    STORED_PROC: 'Stored Procedure'
  },

  STORED_PROC_TYPE: {
    STATIC: 'STATIC',
    DYNAMIC: 'DYNAMIC',
    NON_DYNAMIC: 'NON_DYNAMIC'
  },

  FIELD_TYPE: {
    SCHEMA: 0,
    PARAM: 1
  },

  FILTER_TYPE: {
    DB_STRUCTURE: '1',
    USER_DEFINED: '2'
  },

  BUNDLE: {
    MESSAGE: {
      get MG01() {
        return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_MESSAGE_REQUIRE_PARAMETER');
      },
      get MG02() {
        return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_MESSAGE_CHANGE_PROCEDURE_TYPE');
      },
      get MG03() {
        return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_MESSAGE_CHANGE_FIELD');
      }
    },

    CRITERIALIST: {
      Function: [{
        value: 'All',
        get label() {
          return _Izenda2.default.getText('COMMON_LABEL_ALL');
        }
      }, {
        value: 'DatabaseName',
        get label() {
          return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_CRITERIALIST_DATABASE_NAME');
        }
      }, {
        value: 'DataSourceName',
        get label() {
          return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_CRITERIALIST_FUNCTION_NAME');
        }
      }],
      DEFAULT_CRITERIA_LIST: [{
        value: 'All',
        get label() {
          return _Izenda2.default.getText('COMMON_LABEL_ALL');
        }
      }, {
        value: 'Category',
        get label() {
          return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_CATEGORY');
        }
      }, {
        value: 'DatabaseName',
        get label() {
          return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_DATABASE_NAME');
        }
      }, {
        value: 'DataSourceName',
        get label() {
          return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_DATA_SOURCE_NAME');
        }
      }, {
        value: 'DataSourceAlias',
        get label() {
          return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_DATA_SOURCE_ALIAS');
        }
      }, {
        value: 'ColumnName',
        get label() {
          return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_COLUMN_NAME');
        }
      }, {
        value: 'ColumnAlias',
        get label() {
          return _Izenda2.default.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_COLUMN_ALIAS');
        }
      }]
    },

    SORTDEFAULTLIST: {
      Function: { DatabaseName: 'DESC' },
      DEFAULT_SORT: { Category: 'DESC' }
    },

    DEFAULT_CRITERIA: 'All'
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  FIELDCHECK: {
    JOIN_QUERYSOURCE_FIELD: 'joinQuerySourceId',
    POSITION_ID: 'positionId',
    JOIN_FIELD: 'joinFieldId',
    FOREIGN_QUERYSOURCE_FIELD: 'foreignQuerySourceId',
    FOREIGN_FIELD: 'foreignFieldId',
    JOIN_TYPE: 'joinType',
    DATABASE_FIELD: 'joinConnectionId',
    FOREIGN_DATABASE_FIELD: 'foreignConnectionId'
  },

  TABLE_DEF: {
    joinType: {
      key: 'joinType',
      width: 110,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_JOIN_TYPE');
      },
      sortAble: false
    },
    positionId: {
      key: 'PositionId',
      width: 110,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_POSITION');
      },
      sortAble: true
    },
    dbName: {
      key: 'DatabaseName',
      width: 150,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_DATABASE_NAME');
      },
      sortAble: true
    },
    dataObject: {
      key: 'DataObject',
      width: 150,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_DATA_OBJECT');
      },
      sortAble: true
    },
    joinField: {
      key: 'JoinField',
      width: 150,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_JOIN_FIELD');
      },
      sortAble: true
    },
    equal: { key: 'equal', width: 60, title: '', sortAble: false, fixed: true },
    frDbName: {
      key: 'ForeignDatabaseName',
      width: 150,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_DATABASE_NAME');
      },
      sortAble: true
    },
    frDataObject: {
      key: 'ForeignDataObject',
      width: 200,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_FOREIGN_DATA_OBJECT');
      },
      sortAble: true
    },
    frField: {
      key: 'Field',
      width: 150,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_FIELD');
      },
      sortAble: true
    },
    action: { key: 'action', width: 100, title: '', sortAble: false }
  },

  BUNDLE: {
    DEFAULT_CRITERIA_LIST: [{
      value: 'All',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_ALL');
      }
    }, {
      value: 'DatabaseName',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_DATABASE_NAME');
      }
    }, {
      value: 'DataObject',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_DATA_OBJECT');
      }
    }, {
      value: 'ForeignDataObject',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_FOREIGN_DATA_OBJECT');
      }
    }, {
      value: 'JoinField',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_JOIN_FIELD');
      }
    }, {
      value: 'Field',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_FIELD');
      }
    }],
    DATASOURCE_CRITERIA_LIST: [{
      value: 'All',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_ALL');
      }
    }, {
      value: 'DatabaseName',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_DATABASE_NAME');
      }
    }, {
      value: 'ForeignDataObject',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_FOREIGN_DATA_OBJECT');
      }
    }, {
      value: 'JoinField',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_JOIN_FIELD');
      }
    }, {
      value: 'Field',
      get label() {
        return _Izenda2.default.getText('COMMON_LABEL_FIELD');
      }
    }],
    SORTDEFAULTLIST: {
      DEFAULT_SORT: { PositionId: 'ASC' }
    },
    DEFAULT_CRITERIA: 'All'
  },

  get CONFIRM_DELETE_RELATIONSHIP_HAS_USED() {
    return _Izenda2.default.getText('RELATIONSHIP_MESSAGE_CONFIRM_DELETE_RELATIONSHIP_HAS_USED');
  },
  get CONFIRM_DELETE_RELATIONSHIP() {
    return _Izenda2.default.getText('RELATIONSHIP_MESSAGE_CONFIRM_DELETE_RELATIONSHIP');
  },
  get RELATIONSHIP_LABEL() {
    return _Izenda2.default.getText('RELATIONSHIP_LABEL_RELATIONSHIP');
  },

  REQUIRED_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
      }
    }
  },

  POSITION_ID: {
    FORMAT: '####',
    PATTERN: /^[1-9]\d{0,8}$/
  },

  JOIN_TYPE_CROSS: 'Cross'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var objectState = __webpack_require__(58);
  var DashboardConstants = __webpack_require__(73);
  var StaticDashboardDetail = __webpack_require__(2419);
  var WorkspaceDashboardDetail = __webpack_require__(2420);
  var ReportDetail = __webpack_require__(2423);
  var uiState = __webpack_require__(15);
  var CONSTANT = __webpack_require__(50);

  var _require = __webpack_require__(1),
      forEach = _require.forEach,
      map = _require.map,
      isNil = _require.isNil;

  function CategoryDetail(data, hasGetDashboardParts) {
    var props = {
      id: '',
      type: CONSTANT.CATEGORY_TYPE.REPORT,
      name: '',
      parentId: '',
      dateTimeNow: '',
      status: objectState.NONE,
      state: objectState.NONE,
      modified: null,
      canDelete: true,
      subCategories: [],
      dashboards: [],
      reports: [],
      checked: false,
      indeterminate: false,
      numOfCheckedChilds: 0,
      numOfChilds: 0,
      isGlobal: false,
      isEditing: false, // used for one-instance editing purpose
      editable: true,

      tenantId: uiState.tenantId,

      isUncategorized: function isUncategorized() {
        return isNil(this.id) || this.id === CONSTANT.EMPTY_GUID;
      },

      isSubCategory: function isSubCategory() {
        return !isNil(this.parentId);
      },

      isRootCategory: function isRootCategory() {
        return this.id === DashboardConstants.ALL_CATEGORY_TYPES.ALL_DASHBOARDS.id;
      },

      isUneditable: function isUneditable() {
        return this.isRootCategory || this.id === CONSTANT.EMPTY_GUID || isNil(this.id) || !this.editable;
      },

      isEmpty: function isEmpty() {
        return this.canDelete;
      }
    };

    m.extendObservable(this, props);
    data && this.populateData(data, hasGetDashboardParts);
  }

  /**
   * Populate data
   * @param  {Object} category detail data
   */
  CategoryDetail.prototype.populateData = m.action(function (data, hasGetDashboardParts) {
    data = data || {};
    this.id = data.id;
    this.type = data.type;
    this.name = data.name;
    this.parentId = data.parentId;
    this.tenantId = data.tenantId;
    this.dateTimeNow = data.dateTimeNow;
    this.status = data.status;
    this.state = data.state;
    this.modified = data.modified;
    this.subCategories = data.subCategories;
    this.canDelete = data.canDelete;
    this.editable = data.editable;
    this.checked = data.checked;
    this.numOfCheckedChilds = data.numOfCheckedChilds;
    this.numOfChilds = data.numOfChilds;
    this.isGlobal = data.isGlobal;

    this.populateSubCategories(data.subCategories, hasGetDashboardParts);
    this.populateDashboardData(data.dashboards, hasGetDashboardParts);
    this.populateReportData(data.reports);
  });

  /**
   * Populate data for global/local categories
   * @param  {Object} data categories detail data
   */
  CategoryDetail.prototype.populateDataForGlobalLocalCategory = m.action(function (data) {
    data = data || {};

    this.id = data.id;
    this.type = data.type;
    this.name = data.name;
    this.parentId = data.parentId;
    this.tenantId = data.tenantId;
    this.dateTimeNow = data.dateTimeNow;
    this.status = data.status;
    this.state = data.state;
    this.modified = data.modified;
    this.subCategories = data.subCategories;
    this.canDelete = data.canDelete;
    this.editable = data.editable;
    this.checked = data.checked;
    this.numOfCheckedChilds = data.numOfCheckedChilds;
    this.numOfChilds = data.numOfChilds;
    this.isGlobal = data.isGlobal;
    this.subCategories = map(function (subCategory) {
      return new CategoryDetail(subCategory);
    }, data.subCategories);
  });

  /**
   * Populate sub categories
   * @param  {Object} sub category data
   */
  CategoryDetail.prototype.populateSubCategories = m.action(function (data, hasGetDashboardParts) {
    data = data || [];
    this.subCategories = data.map(function (item) {
      return new CategoryDetail(item, hasGetDashboardParts);
    });
  });

  /**
   * update category name
   * @param {String} name
   */
  CategoryDetail.prototype.updateName = function (value) {
    this.name = value;
  };

  /**
   * update isEditing
   * @param {Boolean} isEditing
   */
  CategoryDetail.prototype.updateIsEditing = function (isEditing) {
    this.isEditing = isEditing;
  };

  /**
   * Populate dashboard items
   * @param  {Array} data
   */
  CategoryDetail.prototype.populateDashboardData = function (data, hasGetDashboardParts) {
    data = data || [];
    this.dashboards = data.map(function (item) {
      return hasGetDashboardParts ? new WorkspaceDashboardDetail(item) : new StaticDashboardDetail(item);
    });
  };

  /**
   * Populate report items
   * @param  {Array} data
   */
  CategoryDetail.prototype.populateReportData = function (data) {
    data = data || [];
    this.reports = data.map(function (item) {
      return new ReportDetail(item);
    });
  };

  /**
   * Reset subscribe all reports
   */
  CategoryDetail.prototype.resetSubscribes = m.action(function () {
    forEach(function (item) {
      item.isSubscribeMode = false;
    }, this.reports);

    forEach(function (subCategory) {
      forEach(function (item) {
        item.isSubscribeMode = false;
      }, subCategory.reports);
    }, this.subCategories);
  });

  module.exports = CategoryDetail;
}();

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityPoliciesConstant.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var REQUIRED_MIN_VALUE = 0;

exports.default = {
  REQUIRED_MIN_VALUE: 0,
  REQUIRED_MIN_POSITIVE_VALUE: 1,
  REQUIRED_VALUE_NO_PASSWORD_KEEP: 5,
  REQUIRED_VALUE_NO_SECURITY_QUESTIONS: 18,
  PASSWORD_VALIDITY: {
    get MIN_PASSWORD_AGE() {
      return _Izenda2.default.getText('SECURITY_POLICIES_CONSTANT_MIN_PASSWORD_AGE');
    },
    get MAX_PASSWORD_AGE() {
      return _Izenda2.default.getText('SECURITY_POLICIES_CONSTANT_MAX_PASSWORD_AGE');
    }
  },
  SECURITY_QUESTION_FIELD_NAME: {
    get USER_PROFILE() {
      return _Izenda2.default.getText('SECURITY_POLICIES_CONSTANT_USER_PROFILE');
    },
    get RESET_PASSWORD() {
      return _Izenda2.default.getText('SECURITY_POLICIES_CONSTANT_RESET_PASSWORD');
    }
  },
  get SECURITY_QUESTIONS() {
    return _Izenda2.default.getText('SECURITY_POLICIES_CONSTANT_SECURITY_QUESTIONS');
  },
  numberLimitConstraints: function numberLimitConstraints(isMinField, fieldNameMinValue, fieldNameMaxValue, minValue, maxValue, sumAllValue) {
    var requireConstraint = void 0;

    // convert to number
    minValue = (0, _fp.toNumber)(minValue);
    maxValue = (0, _fp.toNumber)(maxValue);

    // check the relationship business constraints between min & max values
    if (minValue < maxValue && sumAllValue) {
      var greaterThanOrEqualTo = void 0;
      if (isMinField) {
        greaterThanOrEqualTo = minValue < sumAllValue ? sumAllValue : null;
      } else {
        greaterThanOrEqualTo = maxValue < sumAllValue ? sumAllValue : null;
      }
      requireConstraint = {
        presence: {
          presence: true,
          message: String.format(_Izenda2.default.getText('COMMON_MESSAGES_REQUIRED'), isMinField ? fieldNameMinValue : fieldNameMaxValue)
        },
        numericality: {
          onlyInteger: true,
          greaterThanOrEqualTo: greaterThanOrEqualTo,
          get notGreaterThanOrEqualTo() {
            return isMinField ? _Izenda2.default.getText('SECURITY_POLICIES_CONSTANT_ERROR_MIN_VALUE') : _Izenda2.default.getText('SECURITY_POLICIES_CONSTANT_ERROR_MAX_VALUE');
          }
        }
      };
    } else {
      var errorCompareValueMessage = String.format(_Izenda2.default.getText('SECURITY_POLICIES_CONSTANT_MUST_BE_SMALLER_THAN'), fieldNameMinValue, fieldNameMaxValue);
      requireConstraint = {
        presence: {
          presence: true,
          message: String.format(_Izenda2.default.getText('COMMON_MESSAGES_REQUIRED'), isMinField ? fieldNameMinValue : fieldNameMaxValue)
        },
        numericality: {
          onlyInteger: true,
          lessThan: isMinField ? maxValue : null,
          greaterThan: !isMinField ? minValue : null,
          notLessThan: isMinField ? errorCompareValueMessage : null,
          notGreaterThan: !isMinField ? errorCompareValueMessage : null
        }
      };
    }

    return requireConstraint;
  },
  requiredConstraints: function requiredConstraints(fieldName) {
    return {
      presence: {
        presence: true,
        message: String.format(_Izenda2.default.getText('COMMON_MESSAGES_REQUIRED'), fieldName)
      },
      numericality: {
        onlyInteger: true
      }
    };
  },
  securityQuestionConstraint: function securityQuestionConstraint(isMinField, fieldNameMinValue, fieldNameMaxValue, minValue, maxValue) {
    var errorMessage = _Izenda2.default.getText('SECURITY_POLICIES_CONSTANT_MESSAGE_ERROR_SECURITY_QUESTION_RESET_PASSWORD');
    // convert to number
    minValue = (0, _fp.toNumber)(minValue);
    maxValue = (0, _fp.toNumber)(maxValue);
    if (maxValue === REQUIRED_MIN_VALUE) {
      return null;
    }
    var constraints = {
      presence: {
        presence: true,
        message: String.format(_Izenda2.default.getText('COMMON_MESSAGES_REQUIRED'), isMinField ? fieldNameMinValue : fieldNameMaxValue)
      },
      numericality: {
        onlyInteger: true,
        lessThanOrEqualTo: isMinField ? maxValue : null,
        greaterThanOrEqualTo: !isMinField ? minValue : null,
        notLessThanOrEqualTo: errorMessage,
        notGreaterThanOrEqualTo: errorMessage
      }
    };

    return constraints;
  }
};
module.exports = exports['default'];

/***/ }),
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ProcessDataUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var RANGE_ALIAS = __webpack_require__(39).RANGE_ALIAS;
  var AppGlobal = __webpack_require__(41);
  var SORT_ORDERS = __webpack_require__(64).SORT_ORDERS;
  var ReportPartUtils = __webpack_require__(35);

  var _require = __webpack_require__(1),
      head = _require.head,
      tail = _require.tail,
      orderBy = _require.orderBy,
      toLower = _require.toLower,
      map = _require.map,
      mapValues = _require.mapValues,
      isUndefined = _require.isUndefined,
      curry = _require.curry,
      concat = _require.concat,
      flatten = _require.flatten,
      toNumber = _require.toNumber,
      isNull = _require.isNull,
      find = _require.find,
      isNil = _require.isNil,
      sortBy = _require.sortBy,
      flow = _require.flow,
      compact = _require.compact,
      clone = _require.clone,
      forEach = _require.forEach,
      union = _require.union,
      isEqual = _require.isEqual,
      flatMap = _require.flatMap,
      uniqWith = _require.uniqWith,
      get = _require.get,
      getOr = _require.getOr;
  /**
   * group by data using array of fields
   * @param {array of object} data       original data
   * @param {array of string} arrayField list of field need to group by
   * @param {number} level current recursive group level
   * @param {boolean} shouldSortData should sort BE data
   * @return array of field value and data in format :
   * [field1.value1,{data group by value1}, field1.value2, {data group by value 2}]
   */


  function groupByRecursive(data, arrayField, level, shouldSortData) {
    var newLevel = level || 1;
    var topField = head(arrayField);
    var remainFields = tail(arrayField);

    if (!topField) {
      return [];
    }

    // Should not order data as BE has already sort before and FE using different sort algorithm compare to BE
    var sortOrder = topField.element.properties.getDataValueByKey('sort');
    var getdata = function getdata(pair) {
      var key = pair[0];

      // Use '' to make sure null value make to the top
      return isNull(key) ? '' : !isNaN(key) ? toNumber(key) : key;
    };

    var orderFn = null;

    if (shouldSortData && (sortOrder === SORT_ORDERS.ASC.value || sortOrder === SORT_ORDERS.DESC.value)) {
      orderFn = orderBy([getdata], [toLower(sortOrder)]);
    } else {
      // Do nothing, return data for the map
      orderFn = function orderFn(unsortData) {
        return unsortData;
      };
    }

    var convertDataToString = function convertDataToString(splitData) {
      return map(mapValues(function (value) {
        return String.commonStringValue(value, AppGlobal.advancedSettings.other.convertNullToEmptyStringValue);
      }), splitData);
    };

    var groupByAndToPairs = function groupByAndToPairs(columnName, records) {
      var result = [];

      // Group by and to pair
      records.forEach(function (record) {
        var value = isUndefined(record[columnName]) ? 'undefined' : record[columnName];
        var existingGroup = find(function (group) {
          return group[0] === value;
        }, result);
        if (existingGroup) {
          existingGroup[1].push(record);
        } else {
          result.push([value, [record]]);
        }
      });

      return result;
    };

    var flowData = flow(curry(groupByAndToPairs)(topField.columnName), orderFn, map(function (item) {
      var splitData = item[1];
      var key = {
        level: newLevel,
        columnName: topField.columnName,
        element: topField.element,
        value: String.commonStringValue(item[0], AppGlobal.advancedSettings.other.convertNullToEmptyStringValue)
      };
      if (remainFields.length > 0) {
        return {
          key: [key],
          data: convertDataToString(splitData),
          subGroup: groupByRecursive(splitData, remainFields, newLevel + 1, shouldSortData)
        };
      }
      return {
        key: [key],
        data: convertDataToString(splitData)
      };
    }));

    return flowData(data);
  }

  /**
   * flatten data from multi level into single level
   * @param  {Array of JSON} data          Data had been grouped into multi level
   * @param  {Array of JSON} levelKeyArray List of Key from upper level
   * @return {Array of JSON}               List of data had been flatten
   */
  function flatenGroupByRecursive(data, levelKeyArray) {
    var newLevelKeyArray = levelKeyArray || [];
    var subLevelKeyArray = [];
    var flowData = flow(map(function (item) {
      var key = item.key;
      ensure(key, 'key must exists');
      subLevelKeyArray = concat(newLevelKeyArray, key);

      if (item.subGroup) {
        return flatenGroupByRecursive(item.subGroup, subLevelKeyArray);
      }
      return {
        key: subLevelKeyArray,
        data: item.data || []
      };
    }), flatten);
    return flowData(data);
  }

  /**
   * split data into grouped data by using separator
   * @param  {Array of JSON} data       raw data from API
   * @param  {Array of mapping} separator  each object have fieldNameAlias and fieldMappingName
   * @param  {boolean} multiLevel break data into multi level structure or nextPosition
   * @param  {boolean} shouldSortData should sort data
   * @return {Array of JSON}            data had been group
   */
  function splitDataForSeparator(data, separator, multiLevel, shouldSortData) {
    var firstLevel = 1;
    var groupedByData = groupByRecursive(data, separator, firstLevel, shouldSortData);
    if (multiLevel) {
      return groupedByData;
    }
    return flatenGroupByRecursive(groupedByData);
  }

  function filterMappingByContainer(fieldsMapping, container) {
    var containerElements = isNil(container) ? [] : sortBy('position', container.elements);

    return flow(map(function (item) {
      var field = item.field || {};
      var newMappingItem = clone(find({
        fieldNameAlias: field.fieldNameAlias,
        fieldId: field.fieldId
      }, fieldsMapping));

      if (newMappingItem) {
        newMappingItem.element = item;
      }
      return newMappingItem;
    }), compact)(containerElements);
  }

  function restructureField(data, fieldMappings) {
    var result = {};
    var keys = (0, _keys2.default)(data);

    keys.forEach(function (key) {
      var elements = data[key];

      var fieldByKey = [];
      elements.map(function (element) {
        var matchingField = fieldMappings.filter(function (field) {
          return field.fieldNameAlias === RANGE_ALIAS.MIN_ALIAS + element.name || field.fieldNameAlias === RANGE_ALIAS.MAX_ALIAS + element.name || field.fieldNameAlias === RANGE_ALIAS.AVG_ALIAS + element.name || field.fieldNameAlias === element.name;
        });

        // link to report-part-element
        forEach(function (field) {
          field.reportPartElm = element;
        }, matchingField);

        fieldByKey = union(matchingField, fieldByKey);
      });

      result[key] = uniqWith(isEqual, fieldByKey);
    });

    return result;
  }

  /**
   * Get list value by field mapping
   * @param {Object} fieldMapping
   * @param {Array} listRecords
   * @param {Object} fieldConfig
   * @returns {Array} list value look up form listRecords
   */
  function getListValueByField(fieldMapping, listRecords) {
    var fieldConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return flatMap(function (record) {
      var originalValue = ReportPartUtils.getOriginalValue(fieldMapping, record);
      var alternativeText = ReportPartUtils.getAlternativeText(originalValue, fieldConfig, record);
      return alternativeText || originalValue;
    }, listRecords);
  }

  /**
   * Get list value by field mapping
   * @param {Object} fieldMapping
   * @param {Array} listRecords
   * @returns {Array} list value look up form listRecords
   */
  function getListValueByGroup(label, fieldMapping, listRecords) {
    var columnName = fieldMapping.columnName;
    var listValues = listRecords.filter(function (record) {
      return !!record[columnName];
    });

    return flatMap(function (value) {
      return {
        key: value[label.columnName],
        value: value[columnName]
      };
    }, listValues);
  }

  /**
   * Get data for field
   * @param  {object} field         data source field
   * @param  {[type]} fieldsMapping field (returned from calling API (fusion))
   * @param  {[type]} record        record (returned from calling API (fusion))
   * @return {any}
   */
  function getValueOfField(field, fieldsMapping, record) {
    if (!field) {
      return null;
    }

    var fieldContainers = {
      field: [field]
    };

    var restructuredField = restructureField(fieldContainers, fieldsMapping);
    restructuredField = getOr({}, 'field[0]', restructuredField);

    return record[restructuredField.columnName];
  }

  function getValueFromMappingField(fieldMapping, records) {
    var columnName = fieldMapping.columnName;

    if (!columnName) {
      return null;
    }

    if (records.length) {
      return map(columnName, records);
    }

    return records[fieldMapping.columnName];
  }

  /**
   * get serie config
   * @param  {Object} field
   * @param  {Object} seriesConfig
   * @return {Object}
   */

  function getFieldName(field) {
    return get('fieldNameAlias', field);
  }

  module.exports = {
    splitDataForSeparator: splitDataForSeparator,
    filterMappingByContainer: filterMappingByContainer,
    getListValueByGroup: getListValueByGroup,
    restructureField: restructureField,
    getListValueByField: getListValueByField,
    getValueOfField: getValueOfField,
    getValueFromMappingField: getValueFromMappingField,
    getFieldName: getFieldName
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  availableLevels: [{
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_SYSTEM');
    },
    value: 'System'
  }, {
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_TENANT');
    },
    value: 'Tenant'
  }],
  SYSTEM_MODE: 1,
  TENANT_MODE: 0
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPicker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Color Picker component
 */
!function () {

  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);

  var FloatAffixed = __webpack_require__(154);
  var ColorDialog = __webpack_require__(932);
  var connect = __webpack_require__(2);

  var ColorPicker = React.createClass({
    displayName: 'ColorPicker',


    propsType: {
      color: React.PropTypes.String,
      iconName: React.PropTypes.String,
      onChange: React.PropTypes.func,
      isHighlightControl: React.PropTypes.bool,
      title: React.PropTypes.String
    },

    getInitialState: function getInitialState() {
      var props = this.props;
      return {
        color: props.color || props.value || props.loadValue || props.defaultColor,
        isOpen: false
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        color: nextProps.color || nextProps.value || nextProps.defaultColor
      });
    },

    handleShowColorPicker: function handleShowColorPicker(event) {
      if (this.props.disabled) {
        return;
      }

      this.setState({ isOpen: !this.state.isOpen });
    },

    handleAccept: function handleAccept(newColor) {
      this.setState({ color: newColor });
      this.hideColorPicker();

      this.props.onChange && this.props.onChange(newColor);
    },

    hideColorPicker: function hideColorPicker() {
      this.setState({ isOpen: false });
    },

    render: function render() {
      var props = this.props;

      var divStyle = props.disabled ? null : { background: this.state.color };
      var pickerStyle = props.isHighlightControl ? { backgroundColor: this.state.color } : null;

      var fullSize = !props.iconName;
      var pickerClasses = classnames(props.className, {
        'color-picker': true,
        'full-size-picker': fullSize
      });

      var indicatorClasses = classnames({
        'color-indicator': true,
        'full-size-indicator': fullSize
      });

      return React.createElement(
        'div',
        {
          ref: 'colorPicker',
          style: pickerStyle,
          title: props.title,
          className: pickerClasses,
          onMouseDown: this.handleShowColorPicker
        },
        React.createElement(
          'a',
          { title: props.title },
          !fullSize ? React.createElement('span', { className: this.props.iconName }) : null,
          props.hadSetting && React.createElement(
            'div',
            { className: 'u_floatRight u-posRelative' },
            React.createElement('i', { className: 'icon-ok u_smallIcon u-hadSetting u-colorWhite u-bgGreen' })
          ),
          React.createElement('div', { className: indicatorClasses, style: divStyle }),
          this.state.isOpen && React.createElement(
            FloatAffixed,
            {
              autoWidth: true,
              minWidth: 515,
              anchor: this.refs.colorPicker,
              onClickOutside: this.hideColorPicker
            },
            React.createElement(ColorDialog, {
              color: this.state.color,
              onAccept: this.handleAccept,
              onCancel: this.hideColorPicker })
          )
        )
      );
    }
  });

  module.exports = connect()(ColorPicker);
}();

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _typeof2 = __webpack_require__(150);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimePicker.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(154);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(218);

var _Izenda8 = __webpack_require__(933);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(115);

var _Izenda11 = __webpack_require__(15);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

var ISO_REGEX = /((\d{4}-\d\d-\d\d)[tT]([\d:.]*)?)([zZ]|([+-])(\d\d):?(\d\d))/;

var DateTimePicker = (_dec = (0, _Izenda2.default)({ toClass: true }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(DateTimePicker, _Component);

  function DateTimePicker(props) {
    (0, _classCallCheck3.default)(this, DateTimePicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DateTimePicker.__proto__ || (0, _getPrototypeOf2.default)(DateTimePicker)).call(this, props));

    _initialiseProps.call(_this);

    var _this$getDateTimeInpu = _this.getDateTimeInput(),
        datetime = _this$getDateTimeInpu.datetime,
        input = _this$getDateTimeInpu.input,
        type = _this$getDateTimeInpu.type;

    _this.datetime = datetime;
    _this.input = input;
    _this.type = type;

    _this.toggleFalse = _this.toggle.bind(_this, false);
    return _this;
  }

  (0, _createClass3.default)(DateTimePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props != nextProps) {
        var _getDateTimeInput = this.getDateTimeInput(nextProps),
            datetime = _getDateTimeInput.datetime,
            input = _getDateTimeInput.input;

        this.validate(datetime, null, true);
        this.datetime = datetime;
        this.input = input;
      }
    }

    /**
     * Get date time input
     * @param {Object} props
     */

  }, {
    key: 'getDateTimeInput',
    value: function getDateTimeInput(props) {
      var currentProps = props || this.props;
      var value = currentProps.value || null;
      var datetime = void 0,
          input = void 0,
          type = void 0;

      if ((0, _fp.isNull)(value)) {
        datetime = (0, _moment2.default)();
        input = null;
        type = _Izenda7.Types.MOMENT;
      } else {
        datetime = this.parse(value);
        input = datetime.format(this.format(currentProps));

        switch (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) {
          case 'object':
            type = _moment2.default.isDate(value) ? _Izenda7.Types.JS_DATE : _moment2.default.isMoment(value) ? _Izenda7.Types.MOMENT : null;
            break;
          case 'string':
            type = value.match(ISO_REGEX) ? _Izenda7.Types.ISO : _Izenda7.Types.STRING;
            break;
        }
      }

      return { datetime: datetime, input: input, type: type };
    }

    /**
     * Get default level
     */

  }, {
    key: 'getDefaultLevel',
    value: function getDefaultLevel() {
      return this.props.time ? _Izenda7.Units.HOUR : _Izenda7.Units.DAY;
    }

    /**
     * Get date time string in format
     */

  }, {
    key: 'format',
    value: function format(props) {
      var currentProps = props || this.props;
      var displayFormat = currentProps.displayFormat,
          calendar = currentProps.calendar,
          time = currentProps.time;

      var dateFormat = _Izenda12.default.currentUser.dateFormat || DEFAULT_DATE_FORMAT;

      return typeof displayFormat !== 'undefined' ? displayFormat : calendar === false ? _Izenda10.TIME_FORMAT : time ? dateFormat + ' ' + _Izenda10.TIME_FORMAT : dateFormat;
    }

    /**
     * Get the format of this date time value
     */

  }, {
    key: 'storeFormat',
    value: function storeFormat(props) {
      var currentProps = props || this.props;
      var storeFormat = currentProps.storeFormat,
          time = currentProps.time;


      return typeof storeFormat !== 'undefined' ? storeFormat : !time ? _Izenda10.DATE_FORMAT : _Izenda10.DATE_TIME_FORMAT;
    }
  }, {
    key: 'toggle',
    value: function toggle(visible) {
      var currentVisible = this.visible;

      if (visible !== currentVisible && !this.props.disabled) {
        if (typeof visible === 'undefined') {
          visible = !currentVisible;
        }

        if (visible !== currentVisible) {
          this.visible = visible;
        }
      }
    }

    /**
     * Parse input to Moment value
     * @param {object} input
     */

  }, {
    key: 'parse',
    value: function parse(input) {
      if ((0, _fp.isNull)(input)) return null;
      var value = null;
      var formats = [this.storeFormat(), _Izenda12.default.currentUser.dateFormat, _Izenda10.DATE_TIME_FORMAT, _Izenda10.DATE_FORMAT, _Izenda10.TIME_FORMAT];

      // Try parse string to date time by each format, and set the value at the first one that parse successfully
      var tryParseFormats = function tryParseFormats() {
        return (0, _fp.reduce)(function (parseResult, format) {
          // Ignore if the input had been parsed successfully before
          if (parseResult) return true;

          var test = (0, _moment2.default)(input, format, true);
          test.isValid() && (value = test);
          return test.isValid();
        }, false, formats);
      };

      var result = tryParseFormats();
      return result ? value : (0, _moment2.default)(this.datetime || (0, _moment2.default)());
    }

    /**
     * Save the date time value
     * @param {Moment} savingValue
     */

  }, {
    key: 'save',
    value: function save(savingValue) {
      this.datetime = savingValue;
      this.input = savingValue.format(this.format());

      this.validate(savingValue, null, true) && this.commit(savingValue);
    }

    /**
     * Validate the date time
     */

  }, {
    key: 'commit',


    /**
     * Notify the change
     * @param {Moment} datetime
     */
    value: function commit(datetime) {
      var _this2 = this;

      var returnAs = this.props.returnAs || this.type;
      var getResult = function getResult() {
        switch (returnAs) {
          case _Izenda7.Types.ISO:
            return datetime.toISOString();
          case _Izenda7.Types.JS_DATE:
            return datetime.toDate();
          case _Izenda7.Types.MOMENT:
            return datetime;
          case _Izenda7.Types.STRING:
            return (0, _moment2.default)(datetime).format(_this2.storeFormat());
        }
      };

      this.props.onChange && this.props.onChange(getResult());
    }

    /**
     * On blur input
     */


    /**
     * On change input
     */


    /**
     * On select new date time value
     */


    /**
     * On key down input
     */


    /**
     * On click calendar icon
     */


    /**
     * On clock time icon
     */


    /**
     * Set dom node to the input element in Input Component
     */

  }, {
    key: 'renderControlButtons',


    /**
     * Render calendar and time button
     */
    value: function renderControlButtons() {
      return _react2.default.createElement(
        'div',
        { className: 'izenda-DateTimePicker-controls' },
        this.props.calendar && _react2.default.createElement(
          'button',
          { className: 'izenda-DateTimePicker-button', onClick: this.onCalendarClick },
          _react2.default.createElement('span', { className: 'icon-calendar-new' })
        ),
        this.props.time && _react2.default.createElement(
          'button',
          { className: 'izenda-DateTimePicker-button', onClick: this.onTimeClick },
          _react2.default.createElement('span', { className: 'icon-clock' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          calendar = _props.calendar,
          time = _props.time,
          name = _props.name,
          disabled = _props.disabled,
          placeholder = _props.placeholder,
          id = _props.id,
          options = _props.options;
      var input = this.input,
          datetime = this.datetime,
          visible = this.visible,
          level = this.level;


      var mainClasses = (0, _classnames2.default)(className, 'izenda-DateTimePicker', {
        'once-control': !(calendar && time)
      });

      return _react2.default.createElement(
        'div',
        { className: mainClasses },
        _react2.default.createElement(_Izenda6.default, {
          type: 'text',
          ref: this.setDomNode,
          value: input || '',
          onBlur: this.onBlurInput,
          onKeyDown: this.onKeyDown,
          onChange: this.onChangeInput,
          placeholder: placeholder,
          name: name,
          className: 'izenda-DateTimePicker-input',
          disabled: disabled
        }),
        this.renderControlButtons(),
        visible && _react2.default.createElement(
          _Izenda4.default,
          { anchor: this.inputNode, onClickOutside: this.toggleFalse, onParentScroll: this.toggleFalse },
          _react2.default.createElement(_Izenda9.default, {
            id: id,
            datetime: datetime,
            onSelect: this.onSelect,
            above: this.handleAbove,
            level: level,
            setLevel: this.setLevel,
            validate: this.validate,
            options: options
          })
        )
      );
    }
  }]);
  return DateTimePicker;
}(_react.Component), _class3.propTypes = {
  time: _propTypes2.default.bool,
  calendar: _propTypes2.default.bool,
  min: _propTypes2.default.any,
  max: _propTypes2.default.any,
  format: _propTypes2.default.string,
  onChangeInput: _propTypes2.default.func,
  returnAs: _propTypes2.default.oneOf([_Izenda7.Types.ISO, _Izenda7.Types.JS_DATE, _Izenda7.Types.MOMENT, _Izenda7.Types.STRING]),
  closeOnSelect: _propTypes2.default.bool,
  closeOnBlur: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  name: _propTypes2.default.string,
  options: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  visible: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onSelect: _propTypes2.default.func
}, _class3.defaultProps = {
  closeOnSelect: true,
  closeOnBlur: true,
  visible: false,
  calendar: true,
  time: true,
  returnAs: _Izenda7.Types.STRING
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.above = false;

  _initDefineProp(this, 'datetime', _descriptor, this);

  _initDefineProp(this, 'input', _descriptor2, this);

  _initDefineProp(this, 'type', _descriptor3, this);

  _initDefineProp(this, 'visible', _descriptor4, this);

  _initDefineProp(this, 'level', _descriptor5, this);

  this.validate = function (datetime, timeUnit) {
    var _props2 = _this3.props,
        min = _props2.min,
        max = _props2.max;

    var isOutRange = min && (0, _moment2.default)(datetime).isBefore(min) || max && (0, _moment2.default)(datetime).isAfter(max);

    return !(isOutRange && timeUnit !== 'hours' && ((0, _moment2.default)(datetime).isSame(min, timeUnit) || (0, _moment2.default)(datetime).isSame(max, timeUnit)));
  };

  this.onBlurInput = function (e) {
    var closeOnBlur = _this3.props.closeOnBlur;
    var input = _this3.input,
        datetime = _this3.datetime;


    if (_this3.above) {
      _this3.inputNode && _this3.inputNode.focus();
    } else if (closeOnBlur) {
      _this3.toggle(false);
      _this3.props.onBlur && _this3.props.onBlur(e);
    }

    if (input != datetime.format(_this3.format())) {
      var savingData = _this3.parse(input);
      savingData && _this3.save(savingData);
    }
  };

  this.onChangeInput = function (e) {
    _this3.props.onChangeInput && _this3.props.onChangeInput(e);

    var input = e.target.value;

    var datetime = (0, _moment2.default)(input, _this3.format(), true);
    if (datetime.isValid()) {
      _this3.save(datetime);
    } else if (input === '') {
      _this3.datetime = null;
      _this3.input = '';
      _this3.props.onChange && _this3.props.onChange(null);
    } else {
      _this3.input = input;
    }
  };

  this.onSelect = function (datetime, close, timeUnit) {
    var shouldClose = close;
    var visible = _this3.visible;
    var closeOnSelect = _this3.props.closeOnSelect;


    if (timeUnit && !_this3.validate(datetime, timeUnit.unit) || !_this3.validate(datetime)) {
      shouldClose = false;
    }

    if (close && shouldClose === false) return;

    var willBeVisible = closeOnSelect && shouldClose ? !visible : visible;

    _this3.visible = willBeVisible;
    _this3.save(datetime);

    _this3.props.onSelect && _this3.props.onSelect(datetime, willBeVisible);
  };

  this.onKeyDown = function (e) {
    var keyCode = e.keyCode;
    var level = _this3.level,
        input = _this3.input,
        visible = _this3.visible;

    var datetime = _this3.datetime || (0, _moment2.default)();
    var lvl = _Izenda7.Levels[level];

    switch (keyCode) {
      case _Izenda7.Keys.UP:
        _this3.onSelect(datetime.subtract(lvl.key.span, lvl.key.unit));
        break;
      case _Izenda7.Keys.DOWN:
        _this3.onSelect(datetime.add(lvl.key.span, lvl.key.unit));
        break;
      case _Izenda7.Keys.ENTER:
        if (lvl.down) {
          _this3.level = lvl.down;
        } else {
          if (input == datetime.format(_this3.format()) && !_this3.validate(datetime)) {
            _this3.toggle(true);
          } else {
            !visible && _this3.toggle(true);
            var savingValue = _this3.parse(input);
            savingValue && _this3.save(savingValue);
          }
        }
        break;
    }
  };

  this.onCalendarClick = function () {
    if (!_this3.props.disabled) {
      _this3.inputNode.focus();
      _this3.level = _Izenda7.Units.DAY;
      _this3.visible = true;
    }
  };

  this.onTimeClick = function () {
    if (!_this3.props.disabled) {
      _this3.inputNode.focus();
      _this3.level = _Izenda7.Units.HOUR;
      _this3.visible = true;
    }
  };

  this.handleAbove = function (value) {
    return typeof value === 'undefined' ? _this3.above : _this3.above = value;
  };

  this.setLevel = function (level) {
    _this3.level = level;
  };

  this.setDomNode = function (inputNode) {
    inputNode && (_this3.inputNode = inputNode.input);
  };
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'datetime', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'input', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'visible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'level', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return this.getDefaultLevel();
  }
})), _class2)) || _class);
exports.default = DateTimePicker;
module.exports = exports['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      get = _require.get,
      isNil = _require.isNil,
      isEmpty = _require.isEmpty;

  var ReportDesignerConstants = __webpack_require__(16);
  var FORMAT_VALUE_INPUT = __webpack_require__(115).DATE_TIME_FORMAT;
  var ReportPartFieldConstants = __webpack_require__(64);
  var DATE_GROUP_BY = __webpack_require__(176).GROUP_BY;

  function previewDataTypeByFunction(functionInfo, dataFieldType) {
    return functionInfo.formatDataType || dataFieldType;
  }

  function getDateTimeFormatData(originalDataType, functionInfo, format) {
    var dataType = get('formatDataType', functionInfo) || originalDataType;

    if (dataType === ReportDesignerConstants.DATA_TYPES.DATE_TIME) {
      var groupBy = get('groupBy', format);
      var settingByGroupBy = get(groupBy, DATE_GROUP_BY);

      return {
        groupBy: groupBy,
        settingByGroupBy: settingByGroupBy,
        dataFormat: get('name', functionInfo) === ReportPartFieldConstants.FUNCTION.GROUP.NAME && get('GROUP_BY_EXPECTED_FORMAT', settingByGroupBy) || FORMAT_VALUE_INPUT,
        compareFormat: get('COMPARE_FORMAT', settingByGroupBy) || FORMAT_VALUE_INPUT
      };
    }
    return null;
  }

  function checkUsingCustomFormat(element) {
    var formatName = get('reportPartElm.properties.dataFormattings.format.format', element);
    var formatId = get('reportPartElm.properties.dataFormattings.format.formatId', element);
    return !isNil(formatId) && (isEmpty(formatName) || isNil(formatName));
  }

  function checkUsingCustomStringFormat(element) {
    var jsFormatString = get('reportPartElm.properties.dataFormattings.format.jsFormatString', element);
    return !isNil(jsFormatString) || !isEmpty(jsFormatString);
  }

  module.exports = {
    previewDataTypeByFunction: previewDataTypeByFunction,
    getDateTimeFormatData: getDateTimeFormatData,
    checkUsingCustomFormat: checkUsingCustomFormat,
    checkUsingCustomStringFormat: checkUsingCustomStringFormat
  };
}();

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeView.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var TreeViewItemList = __webpack_require__(1869);
  var ScrollBox = __webpack_require__(27);
  var FlattenTreeUIStore = __webpack_require__(1871);

  var observer = __webpack_require__(10).observer;
  var asReference = __webpack_require__(5).asReference;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      flatMap = _require.flatMap,
      isNil = _require.isNil;

  var TreeView = React.createClass({
    displayName: 'TreeView',

    flattenTree: null,
    propTypes: {
      nodes: ObservablePropTypes.arrayOrObservableArray,
      getChildNodes: PropTypes.func.isRequired,
      getKey: PropTypes.func.isRequired,
      renderNode: PropTypes.func.isRequired,
      collapsed: PropTypes.bool,
      nodeExpand: PropTypes.func
    },
    getDefaultProps: function getDefaultProps() {
      return {
        collapsed: true
      };
    },
    componentWillMount: function componentWillMount() {
      this.flattenTree = new FlattenTreeUIStore();
    },
    render: function render() {
      var props = this.props;
      var className = props.className;
      var nodes = props.nodes;
      var renderNode = props.renderNode;
      var getChildNodes = props.getChildNodes;
      var getKey = props.getKey;
      var nodeExpand = props.nodeExpand;
      var collapsed = props.collapsed;

      var flattenFirstLevelNode = curry(flatten, 6)(0, // node level. Zero is for root node.
      nodeExpand, // check whether node is expanded
      getChildNodes, // retrieve child nodes of a particular tree node
      getKey, // retrieve key value of a node. It must be unique
      collapsed, // tree is collapsed by default
      null // parent tree node. Null is for root node.
      );

      var flattenNodes = flatMap(flattenFirstLevelNode, nodes);

      return React.createElement(
        ScrollBox,
        null,
        React.createElement(TreeViewItemList, {
          className: className,
          treeViewItemClassName: props.treeViewItemClassName,
          flattenNodes: flattenNodes,
          treeStore: this.flattenTree,
          renderNode: renderNode
        })
      );
    }
  });

  function flatten(level, nodeExpand, getChildNodes, getKey, collapsed, parent, node) {
    if (!node) return [];

    var currentLevel = level;
    var key = getKey(node);
    var childNodeIndex, childrenLength, grandChildren;
    var nodeExpanded = !isNil(nodeExpand) && nodeExpand(node);
    var defaultExpanded = !collapsed;

    // Node is expanded if it's expanded by data logic, or by default setting
    // or by user actions.
    var shouldExpanded = nodeExpanded || defaultExpanded;

    var childNodes = getChildNodes(node) || [];

    var currentTreeNode = toTreeNode(currentLevel, key, shouldExpanded, childNodes.length, parent, node);

    var flattenList = [currentTreeNode];

    // Use native FOR loop to maximize performance while walking thru child nodes list.
    for (childNodeIndex = 0, childrenLength = childNodes.length; childNodeIndex < childrenLength; childNodeIndex++) {
      grandChildren = flatten(currentLevel + 1, nodeExpand, getChildNodes, getKey, collapsed, currentTreeNode, childNodes[childNodeIndex]);

      Array.prototype.push.apply(flattenList, grandChildren);
    }
    return flattenList;
  }

  function toTreeNode(level, key, shouldExpanded, childCount, parent, dataNode) {
    return {
      level: level,
      data: asReference(dataNode),
      key: key,
      parent: parent,
      childCount: childCount,
      expanded: shouldExpanded
    };
  }

  module.exports = observer(TreeView);
}();

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityPoliciesDetailAction.js" company="Izenda">
// Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var withProps = __webpack_require__(9).withProps;
  var withHandlers = __webpack_require__(9).withHandlers;
  var lifecycle = __webpack_require__(9).lifecycle;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var PropTypes = __webpack_require__(0).PropTypes;
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(162);

  var observer = __webpack_require__(10).observer;
  var commonMessage = __webpack_require__(37);
  var SecurityPoliciesStore = __webpack_require__(2508);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isEmpty = _require.isEmpty,
      isNil = _require.isNil,
      toNumber = _require.toNumber;

  var securityPoliciesDetailAction = compose(withProps({
    store: new SecurityPoliciesStore()
  }), withHandlers({
    onBlurFocusField: curry(onBlurFocusField),
    onChangeValueCheckbox: curry(onChangeValueCheckbox),
    onChangeSettingValueMinPasswordLength: curry(onChangeSettingValueMinPasswordLength),
    onChangeSettingValueMaxPasswordLength: curry(onChangeSettingValueMaxPasswordLength),
    onChangeRequiredValue: curry(onChangeRequiredValue),
    onChangeRequiredPositiveValue: curry(onChangeRequiredPositiveValue),
    onSave: curry(onSave),
    onCancel: curry(onCancel),
    getFieldValidateBeforeSave: curry(getFieldValidateBeforeSave)
  }));

  /**
   * on Blur Focus Field
   * @param  {object} props
   * @param  {array} validateField
   */
  function onBlurFocusField(props, validateField, e, _) {
    var valManager = props.validation;
    valManager.validate(validateField);
  }

  /**
   * onChange Value Check box
   * @param  {object} props
   * @param  {string} field
   * @param  {array} validateField
   * @param  {boolean} value
   */
  function onChangeValueCheckbox(props, field, value, e) {
    var model = props.store.model;
    if (!value) {
      props.validation.reset();
    }
    model.updateValueByKey(field, value);
  }

  /**
   * onChange Setting Value Min Password Length
   * @param  {object} props
   * @param  {string} field
   */
  function onChangeSettingValueMinPasswordLength(props, field, value, e) {
    var model = props.store.model;
    model.updateValueByKey(field, value);
    model.autoCalculateMinPasswordLength();
  }

  /**
   * onChange Setting Value Max Password Length
   * @param  {object} props
   * @param  {string} field
   */
  function onChangeSettingValueMaxPasswordLength(props, field, value, e) {
    var model = props.store.model;
    model.updateValueByKey(field, value);
    model.autoCalculateMaxPasswordLength();
  }

  /**
   * onChange Number Password Keep
   * @param  {object} props
   * @param  {string} field
   * @param  {number} requiredValue
   * @param  {string} value
   */
  function onChangeRequiredValue(props, field, requiredValue, value, e) {
    var model = props.store.model;
    if (isEmpty(value)) {
      model.updateValueByKey(field, value);
    } else {
      value = model.toNumber(value);
      value >= constants.REQUIRED_MIN_VALUE && value <= requiredValue && model.updateValueByKey(field, value);
    }
  }

  /**
   * onChange Required Positive Value
   * @param  {object} props
   * @param  {string} field
   * @param  {number} value
   */
  function onChangeRequiredPositiveValue(props, field, value, e) {
    props.store.model.updateValueByKey(field, value, constants.REQUIRED_MIN_POSITIVE_VALUE);
  }

  /**
   * Click Save Detail
   */
  function onSave(props, e) {
    var store = props.store;
    var loader = props.loader;
    var valManager = props.validation;
    var localization = props.localization;
    var needValidateFields = getFieldValidateBeforeSave(props);

    valManager.validate(needValidateFields).then(function (success) {
      if (success) {
        loader.startLoading();
        store.save().then(function (result) {
          if (!isNil(result.messages)) {
            if (isEmpty(result.messages[0].key)) {
              props.store.alertMessage = {
                type: 'error',
                message: result.messages[0].messages[0]
              };
            } else {
              valManager.updateErrors(result.messages);
            }
          } else {
            this.setAlertMessage('success', localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
          }

          return null;
        }).finally(loader.endLoading.bind(loader));
      }
    });
  }

  /**
   * Click cancel Detail
   */
  function onCancel(props, e) {
    var loader = props.loader;
    var store = props.store;

    loader.startLoading();
    props.validation.reset();
    store.loadSecurityPoliciesDetail().finally(loader.endLoading.bind(loader));
  }

  /**
   * get Field Validate Before Save
   * @return {object}
   */
  function getFieldValidateBeforeSave(props) {
    var needValidateFields = [];
    var model = props.store.model;
    model.passwordLength && needValidateFields.push('minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght');
    model.numberSpecialCharacters && needValidateFields.push('minNumberOfSpecialCharacter', 'maxNumberOfSpecialCharacter');
    model.numberUppercaseCharacters && needValidateFields.push('minNumberOfUppercaseCharacter', 'maxNumberOfUppercaseCharacter');
    model.numberLowercaseCharacters && needValidateFields.push('minNumberOfLowercaseCharacter', 'maxNumberOfLowercaseCharacter');
    model.numberNumericCharacters && needValidateFields.push('minNumberOfNumericCharacte', 'maxNumberOfNumericCharacter');
    model.numberNumericCharacters && needValidateFields.push('minNumberOfNumericCharacte', 'maxNumberOfNumericCharacter');
    model.maxNumberSequentialRepeated && needValidateFields.push('maxNumberOfRepeatSequential');
    model.passwordAge && needValidateFields.push('minNumberOfPasswordAge', 'maxNumberOfPasswordAge');
    model.notifyUser && needValidateFields.push('notifyUseDuring');
    model.enforcePasswordHistory && needValidateFields.push('numberOfPasswordToKeep');
    model.passwordLinkValidityChecked && needValidateFields.push('passwordLinkValidit');
    model.useSecurityQuestions && needValidateFields.push('numberOfQuestionProfile');
    model.useSecurityQuestions && toNumber(model.numberOfQuestionProfile) !== 0 && needValidateFields.push('numberOfQuestionResetPassword');
    model.numberFailedLogonAttemptsAllowed && needValidateFields.push('numberOfFailedLogonAllowed');
    model.numberFailedSecurityQuestionAttemptsAllowed && needValidateFields.push('numberOfFailedAnswerAllowed');
    (toNumber(model.numberOfFailedAnswerAllowed) === 0 || toNumber(model.numberOfFailedLogonAllowed) === 0) && needValidateFields.push('lockoutPeriod');

    return needValidateFields;
  }

  module.exports = securityPoliciesDetailAction;
}();

/***/ }),
/* 174 */,
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(204);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartStyleFactories.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
var ciFactories = new _Izenda2.default('Report Part Style');
var composeKey = function composeKey(reportPartType, reportPartStyle) {
  return reportPartStyle + '-' + reportPartType;
};

exports.default = {
  /**
   * Add chart info
   */
  add: function add(reportPartType, reportPartStyle, baseStyle, label, previewCSS) {
    ciFactories.register(composeKey(reportPartType, reportPartStyle), function () {
      return {
        type: reportPartType,
        style: reportPartStyle,
        baseStyle: baseStyle,
        label: label,
        previewCSS: previewCSS
      };
    });
  },


  /**
   * Get all chart infos
   */
  getAll: function getAll(reportPartType) {
    return ciFactories.values().map(function (fn) {
      return fn();
    }).filter(function (_ref) {
      var type = _ref.type;
      return type === reportPartType;
    });
  },


  /**
   * Get base style of a report part style
   */
  getBaseStyle: function getBaseStyle(reportPartType) {
    ensure(reportPartType, 'reportPartType must have a value');

    return function (reportPartStyle) {
      ensure(reportPartStyle, 'reportPartStyle must have a value');

      var key = composeKey(reportPartType, reportPartStyle);

      var _ref2 = ciFactories.containKey(key) ? ciFactories.create(key) : {},
          baseStyle = _ref2.baseStyle;

      return baseStyle;
    };
  },


  /**
   * Determine whether a report part style is compatible with any base styles
   * @param {string} reportPartType The report part type
   * @param {string} reportPartStyle The report part style
   * @param {Array<string>} baseStyles The array of base report part styles to compatible with
   */
  isReportPartStyle: function isReportPartStyle(reportPartType) {
    var _this = this;

    var getBase = this.getBaseStyle(reportPartType);

    return function (reportPartStyle) {
      for (var _len = arguments.length, baseStyles = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        baseStyles[_key - 1] = arguments[_key];
      }

      ensure(reportPartType, 'reportPartType must have a value');
      ensure(reportPartStyle, 'reportPartStyle must have a value');
      ensure(baseStyles && baseStyles.length > 0, 'baseStyles must have a value');

      if ((0, _fp.includes)(reportPartStyle, baseStyles)) {
        return true;
      }

      var next = getBase(reportPartStyle);
      if ((0, _fp.isNil)(next) || (0, _fp.isEmpty)(next)) {
        return false;
      }

      return _this.isReportPartStyle(reportPartType).apply(undefined, [next].concat(baseStyles));
    };
  },

  /**
   * Reset the factories data
   */
  reset: function reset() {
    ciFactories.reset();
  }
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.TimeFormatConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// Expected format receive from BackEnd when using group by and date time

exports.default = {
  DEFAULT_FORMAT_PATTERN: 'MM/dd/yyyy',
  DATE_TIME_FORMAT: {
    // setting template
    /*
        format : {
          FOR_DATE_SETTING: array of string,  // array of supported user's date format setting
          GROUP_BY: string,  // format group by, use for finding default format if current format not supported by user's date format setting
                            please prefer DEFAULT_FORMAT property of GROUP_BY section
          MOMENT_OUTPUT:  string // format define by moment
        }
       */

    /* Short Date*/
    'MM/dd/yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'MM/DD/YYYY',
      INTERVAL_VALUE: 'd'
    },
    'M/d/yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'M/D/YYYY',
      INTERVAL_VALUE: 'd'
    },
    'MM/dd/yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'MM/DD/YY',
      INTERVAL_VALUE: 'd'
    },
    'M/d/yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'M/D/YY',
      INTERVAL_VALUE: 'd'
    },
    'dd/MM/yyyy': {
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'DD/MM/YYYY',
      INTERVAL_VALUE: 'd'
    },
    'd/M/yyyy': {
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'D/M/YYYY',
      INTERVAL_VALUE: 'd'
    },
    'dd/MM/yy': {
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'DD/MM/YY',
      INTERVAL_VALUE: 'd'
    },
    'd/M/yy': {
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'D/M/YY',
      INTERVAL_VALUE: 'd'
    },
    'yyyy/MM/dd': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'YYYY/MM/DD',
      INTERVAL_VALUE: 'd'
    },
    'yyyy/M/d': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'YYYY/M/D',
      INTERVAL_VALUE: 'd'
    },
    'MM-yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'MM-YY',
      INTERVAL_VALUE: 'M'
    },
    'M-yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'M-YY',
      INTERVAL_VALUE: 'M'
    },
    'MM-yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'MM-YYYY',
      INTERVAL_VALUE: 'M'
    },
    'M-yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'M-YYYY',
      INTERVAL_VALUE: 'M'
    },
    'yy-MM': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YY-MM',
      INTERVAL_VALUE: 'M'
    },
    'yy-M': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YY-M',
      INTERVAL_VALUE: 'M'
    },
    'yyyy-MM': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YYYY-MM',
      INTERVAL_VALUE: 'M'
    },
    'yyyy-M': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YYYY-M',
      INTERVAL_VALUE: 'M'
    },
    /* Long date*/
    '[Month Name]-yy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'MMMM-YY',
      INTERVAL_VALUE: 'M'
    },
    '[Month Name]-yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY', 'DD/MM/YYYY'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'MMMM-YYYY',
      INTERVAL_VALUE: 'M'
    },
    'yyyy-[Month Name]': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YYYY-MMMM',
      INTERVAL_VALUE: 'M'
    },
    'yy-[Month Name]': {
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      GROUP_BY: 'yearandmonth',
      MOMENT_OUTPUT: 'YY-MMMM',
      INTERVAL_VALUE: 'M'
    },
    '[Day Names of the Week], [Month Name] dd, yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'dddd, MMMM DD, YYYY',
      INTERVAL_VALUE: 'd'
    },
    '[Day Names of the Week], [Month Name] d, yyyy': {
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      GROUP_BY: 'date',
      MOMENT_OUTPUT: 'dddd, MMMM D, YYYY',
      INTERVAL_VALUE: 'd'
    },
    Day: {
      GROUP_BY: 'day',
      MOMENT_OUTPUT: 'DD',
      INTERVAL_VALUE: 'd'
    },
    Month: {
      GROUP_BY: 'month',
      MOMENT_OUTPUT: 'MM',
      INTERVAL_VALUE: 'M'
    },
    Year: {
      GROUP_BY: 'year',
      MOMENT_OUTPUT: 'YYYY',
      INTERVAL_VALUE: 'y'
    },
    'Month Name': {
      GROUP_BY: 'month',
      MOMENT_OUTPUT: 'MMMM',
      INTERVAL_VALUE: 'M'
    },
    'Day of Week': {
      GROUP_BY: 'weekday',
      MOMENT_OUTPUT: 'dddd',
      INTERVAL_VALUE: 'd'
    },
    Date: {
      GROUP_BY: 'date', // special case which depend on user setting
      INTERVAL_VALUE: 'd'
    },
    'Week Number': {
      GROUP_BY: 'weeknumber',
      MOMENT_OUTPUT: '[Week] WW - YYYY',
      INTERVAL_VALUE: 'w'
    },
    'yyyy - Qtr': {
      GROUP_BY: 'yearandquarter',
      MOMENT_OUTPUT: 'YYYY[ - Q]Q',
      INTERVAL_VALUE: 'Q'
    },
    Qtr: {
      GROUP_BY: 'quarter',
      MOMENT_OUTPUT: '[Q]Q',
      INTERVAL_VALUE: 'Q'
    },

    /* Short Hour */
    'HH:mm tt (12-hour time)': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'hh:mm A',
      INTERVAL_VALUE: 'm'
    },
    'H:mm tt (12-hour time)': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'h:mm A',
      INTERVAL_VALUE: 'm'
    },
    'HH:mm (24-hour time)': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'HH:mm',
      INTERVAL_VALUE: 'm'
    },
    'H:mm (24-hour time)': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'H:mm',
      INTERVAL_VALUE: 'm'
    },
    /* Long Hour */
    'HH:mm:ss tt': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'H:mm:ss tt': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'h:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'HH:mm:ss': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'H:mm:ss': {
      GROUP_BY: 'time',
      MOMENT_OUTPUT: 'H:mm:ss',
      INTERVAL_VALUE: 's'
    },

    /* Short Date & Long Hour – It should separate into 2 groups: 12-hour and 24-hour */
    /* 12-hour */
    'MM/dd/yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM/DD/YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'M/d/yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M/D/YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'MM/dd/yy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM/DD/YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'M/d/yy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M/D/YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'dd/MM/yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'DD/MM/YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'd/M/yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'D/M/YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'dd/MM/yy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'DD/MM/YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'd/M/yy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'D/M/YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy/MM/dd HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY/MM/DD hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy/M/d HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY/M/D hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'MM-yy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM-YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'M-yy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M-YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'MM-yyyy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM-YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'M-yyyy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M-YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yy-MM HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YY-MM hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yy-M HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YY-M hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy-MM HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-MM hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy-M HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-M hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },

    /* 24-hour */
    'MM/dd/yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM/DD/YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'M/d/yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M/D/YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'MM/dd/yy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM/DD/YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'M/d/yy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M/D/YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'dd/MM/yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'DD/MM/YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'd/M/yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'D/M/YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'dd/MM/yy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'DD/MM/YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'd/M/yy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY'],
      MOMENT_OUTPUT: 'D/M/YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy/MM/dd HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY/MM/DD HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy/M/d HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY/M/D HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'MM-yy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM-YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'M-yy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M-YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'MM-yyyy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MM-YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'M-yyyy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'M-YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yy-MM HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'YY-MM HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yy-M HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'YY-M HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy-MM HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-MM HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy-M HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-M HH:mm:ss',
      INTERVAL_VALUE: 's'
    },

    /* Long Date & Long Hour – It should separate into 2 groups: 12-hour and 24-hour */
    /* 12-hour */
    '[Month Name]-yy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MMMM-YY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    '[Month Name]-yyyy HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MMMM-YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yyyy-[Month Name] HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-MMMM hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    'yy-[Month Name] HH:mm:ss tt': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YY-MMMM hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    '[Day Names of the Week], [Month Name] dd, yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'dddd, MMMM DD, YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },
    '[Day Names of the Week], [Month Name] d, yyyy HH:mm:ss tt': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'dddd, MMMM D, YYYY hh:mm:ss A',
      INTERVAL_VALUE: 's'
    },

    /* 24-hour */
    '[Month Name]-yy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MMMM-YY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    '[Month Name]-yyyy HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['DD/MM/YYYY', 'MM/DD/YYYY'],
      MOMENT_OUTPUT: 'MMMM-YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yyyy-[Month Name] HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YYYY-MMMM HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    'yy-[Month Name] HH:mm:ss': {
      GROUP_BY: 'yearmonthandtime',
      FOR_DATE_SETTING: ['YYYY/MM/DD'],
      MOMENT_OUTPUT: 'YY-MMMM HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    '[Day Names of the Week], [Month Name] dd, yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'dddd, MMMM DD, YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    },
    '[Day Names of the Week], [Month Name] d, yyyy HH:mm:ss': {
      GROUP_BY: 'dateandtime',
      FOR_DATE_SETTING: ['MM/DD/YYYY'],
      MOMENT_OUTPUT: 'dddd, MMMM D, YYYY HH:mm:ss',
      INTERVAL_VALUE: 's'
    }
  },
  GROUP_BY: {
    // setting template
    /*
          groupByType : {
            SETTINGS_VALUE_TYPE: array // list of supported setting by range drop down options
                                      // posible value : ['value', 'rangeValue']
            GROUP_BY_EXPECTED_FORMAT : string // expected format receive from fusion when function is group
            RANGE_CYCLE: boolean // define if setting by range can define from > to. example : From December to May. if false we will validate from and to value
            COMPARE_FORMAT: 'string' // standize format to compare between fusion value in setting value. we force all data into same format for easier to compare.
            DEFAULT_FORMAT: object // define alternative format if current format not supported by user's date format setting.
                                  // Must have 3 property match with 3 value in user's date format setting
            DISPLAY_DATE_FORMAT : string | object // display format for date picker
                                  //if this format depend on user's date time setting provide object with 3 property match with 3 value in user's date format setting
            NUMBER_PICKER_PROPS : object // Inpect props for Number picker
            DATE_PICKER_PROPS : object // Inpect props for Date Time picker
          }
         */
    day: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'D',
      NUMBER_PICKER_PROPS: {
        min: 1,
        max: 31
      },
      RANGE_CYCLE: true,
      COMPARE_FORMAT: 'DD'
    },
    month: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'M',
      NUMBER_PICKER_PROPS: {
        min: 1,
        max: 12
      },
      RANGE_CYCLE: true,
      COMPARE_FORMAT: 'MM'
    },
    year: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'YYYY',
      COMPARE_FORMAT: 'YYYY'
    },
    weekday: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'E',
      COMPARE_FORMAT: 'E',
      DISPLAY_DATE_FORMAT: 'dddd'
    },
    date: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: false,
        calendar: true
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-M-D',
      COMPARE_FORMAT: 'YYYY-MM-DD',
      DEFAULT_FORMAT: {
        'YYYY/MM/DD': 'yyyy/MM/dd',
        'MM/DD/YYYY': 'MM/dd/yyyy',
        'DD/MM/YYYY': 'dd/MM/yyyy'
      }
    },
    weeknumber: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: false,
        calendar: true
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-W',
      COMPARE_FORMAT: 'YYYY-WW',
      DISPLAY_DATE_FORMAT: '[Week] WW - YYYY'
    },
    yearandquarter: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: false,
        calendar: true,
        initialView: 'year'
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-Q',
      COMPARE_FORMAT: 'YYYY-Q',
      DISPLAY_DATE_FORMAT: 'YYYY-[Q]Q'
    },
    quarter: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      NUMBER_PICKER_PROPS: {
        min: 1,
        max: 4
      },
      GROUP_BY_EXPECTED_FORMAT: 'Q',
      RANGE_CYCLE: true,
      COMPARE_FORMAT: 'Q'
    },
    yearandmonth: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: false,
        calendar: true,
        initialView: 'year'
      },
      DISPLAY_DATE_FORMAT: {
        'YYYY/MM/DD': 'YYYY-MM',
        'MM/DD/YYYY': 'MM-YYYY',
        'DD/MM/YYYY': 'MM-YYYY'
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-M',
      COMPARE_FORMAT: 'YYYY-MM',
      DEFAULT_FORMAT: {
        'YYYY/MM/DD': 'yy-MM',
        'MM/DD/YYYY': 'MM-yy',
        'DD/MM/YYYY': 'MM-yy'
      }
    },
    time: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      GROUP_BY_EXPECTED_FORMAT: 'H:m:s',
      RANGE_CYCLE: true,
      DATE_PICKER_PROPS: {
        time: true,
        calendar: false
      },
      COMPARE_FORMAT: 'HH:mm:ss'
    },
    dateandtime: {
      SETTINGS_VALUE_TYPE: ['value', 'rangeValue'],
      DATE_PICKER_PROPS: {
        time: true,
        calendar: true
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-M-D H:m:s',
      COMPARE_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
      DEFAULT_FORMAT: {
        'YYYY/MM/DD': 'yyyy/MM/dd HH:mm:ss tt',
        'MM/DD/YYYY': 'MM/dd/yyyy HH:mm:ss tt',
        'DD/MM/YYYY': 'dd/MM/yyyy HH:mm:ss tt'
      }
    },
    yearmonthandtime: {
      SETTINGS_VALUE_TYPE: ['value'],
      DATE_PICKER_PROPS: {
        time: true,
        calendar: true
      },
      DISPLAY_DATE_FORMAT: {
        'YYYY/MM/DD': 'YYYY-MM HH:mm:ss',
        'MM/DD/YYYY': 'MM-YYYY HH:mm:ss',
        'DD/MM/YYYY': 'MM-YYYY HH:mm:ss'
      },
      GROUP_BY_EXPECTED_FORMAT: 'YYYY-M H:m:s',
      COMPARE_FORMAT: 'YYYY-MMTHH:mm:ss',
      DEFAULT_FORMAT: {
        'YYYY/MM/DD': 'yy-MM HH:mm:ss tt',
        'MM/DD/YYYY': 'MM-yy HH:mm:ss tt',
        'DD/MM/YYYY': 'MM-yy HH:mm:ss tt'
      }
    }
  },
  DAY_OF_WEEK_VALUES: [, 7, 1, 2, 3, 4, 5, 6]
};
module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(40);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(89);

var _Izenda6 = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OVERIDING_FILTER_VALUE_REGEX = /^m?p(\d+)value$/;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReportLink.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var OVERIDING_FILTER_LOOKUP_REGEX = _Izenda6.FILTER_URL.OVERIDE_MASTER_REPORT_USE_USER_LOOKUP.REGEX;
// Use lodash version with support key
var convertSetting = { cap: false };

var readSubReportQuery = function readSubReportQuery(query) {
  var mapWithKey = _fp.map.convert(convertSetting);
  var pickByWithKey = _fp.pickBy.convert(convertSetting);

  var pickPropertyStartWithFilters = pickByWithKey(function (value, key) {
    return (0, _fp.startsWith)('filters', (0, _fp.toLower)(key));
  });

  var mapObjectToArray = mapWithKey(function (value, key) {
    return {
      key: (0, _fp.toLower)((0, _fp.replace)(/^filters(\[[0-9]+\])?_/, '', key)),
      value: value,
      linkReportFilter: true
    };
  });

  var overridingFilterValue = {};

  var filters = (0, _fp.flow)(pickPropertyStartWithFilters, mapObjectToArray, (0, _fp.forEach)(function (filter) {
    OVERIDING_FILTER_VALUE_REGEX.test((0, _fp.toLower)(filter.key)) && (overridingFilterValue[(0, _fp.toLower)(filter.key)] = filter.value);
  }), (0, _fp.filter)(function (filter) {
    return !OVERIDING_FILTER_VALUE_REGEX.test((0, _fp.toLower)(filter.key));
  }))(query);

  var subReportFilter = {
    filters: filters,
    overridingFilterValue: overridingFilterValue
  };

  if (query.masterReportId) {
    subReportFilter = (0, _fp.assign)(subReportFilter, {
      masterReportId: query.masterReportId,
      inheritMasterReportFilter: true
    });
  }

  return subReportFilter;
};

var buildSubReportQuery = function buildSubReportQuery(filters, masterReportId) {
  var removeFiltersWithKeyIsNil = (0, _fp.reject)((0, _fp.flow)((0, _fp.get)('key'), _fp.isNil));
  var groupFiltersBySameKey = (0, _fp.groupBy)('key');
  var mapFiltersToStringArray = (0, _fp.flatMap)(function (sameKeyFilters) {
    if (sameKeyFilters.length === 1) {
      var uniqueFilter = sameKeyFilters[0];
      return ['filters_' + encodeURIComponent((0, _fp.toLower)(uniqueFilter.key)) + '=' + encodeURIComponent(uniqueFilter.value)];
    }

    return sameKeyFilters.map(function (filter, index) {
      return 'filters[' + index + ']_' + encodeURIComponent((0, _fp.toLower)(filter.key)) + '=' + encodeURIComponent(filter.value);
    });
  });

  var filterPartSection = (0, _fp.flow)(removeFiltersWithKeyIsNil, groupFiltersBySameKey, mapFiltersToStringArray)(filters);

  var masterReportSection = masterReportId ? 'masterReportId=' + masterReportId : '';

  return '?' + (0, _fp.flow)((0, _fp.concat)(filterPartSection), _fp.compact, (0, _fp.join)('&'))([masterReportSection]);
};

/**
 * Convert parameter to Query Object that React Router is able understand
 * @param  {[type]} object
 * Ex:
 * {
 *  masterReportId: '',
    inheritMasterReportFilter : true/false,
    // filter based on master report field mapping
    masterReportPartId: '',
    // container name
    containerName: '',
    fieldsMapping: [{
      // field mapping 2 of item with position 1 in container
      key: 'fm1_2',
      value: 'a',
      originalValue: 'b',
      dataFormat: 'c',
      linkReportFilter: true
    }],
    filters: {
      // filter based on report part element alias
      key: fieldNameAlias,
      value: 'a',
    }],
    overridingFilterValue:{
      // overide value of filter 1 in sub report
      // p(\d+)value : p1

      p1value: 'a',
      // overide value of filter 2 in master report
      // mp(\d+)value
      mp2value: 'b'
  * }
  * @return {[type]}                           [object]
  * Ex:
  *{
      masterReportId: 123412431234,
      inheritFilter: true,
      masterReportPartId: 1243123123,
      containerName: 'containerName',
      fm1_2_value: 'a',
      fm1_2_originalValue: 'b',
      fm1_2_dataFormat: 'c',
      field_fieldNameAlias: 'a',
      p1value: 'a',
      mp2value: 'b'
  * }
 */

var convertFilterToQuery = function convertFilterToQuery(param) {
  if (!param) return null;

  var masterReportId = param.masterReportId,
      inheritFilter = param.inheritMasterReportFilter,
      masterReportPartId = param.masterReportPartId,
      containerName = param.containerName,
      fieldsMapping = param.fieldsMapping,
      filters = param.filters,
      overridingFilterValue = param.overridingFilterValue;


  var masterQueryObject = {
    masterReportId: masterReportId,
    inheritFilter: inheritFilter,
    masterReportPartId: masterReportPartId,
    containerName: containerName,
    tenantId: _Izenda2.default.tenantId
  };

  var pickProps = ['value', 'originalValue', 'dataFormat', 'function', 'dataType'];

  (0, _fp.forEach)(function (fieldMapping) {
    var key = fieldMapping.key;

    var query = {};

    pickProps.forEach(function (prop) {
      var objProp = key + '_' + prop;
      var propsValue = (0, _fp.get)(prop, fieldMapping);

      // For Angular, the URL will be decode by default
      // Need to encode params value 2 times to make sure it value still decode when save to Izenda Routing path
      if (!_Izenda4.default.NeedToEncodeUrl && prop === 'value') {
        propsValue = encodeURIComponent(propsValue);
      }

      query = (0, _fp.set)(objProp, propsValue, query);
    });

    masterQueryObject = (0, _fp.merge)(masterQueryObject, query);
  }, fieldsMapping);

  (0, _fp.forEach)(function (filter) {
    var key = filter.key,
        value = filter.value;

    var fieldAliasProperty = 'field_' + key;

    masterQueryObject[fieldAliasProperty] = value;
  }, filters);

  masterQueryObject = (0, _fp.merge)(masterQueryObject, overridingFilterValue);
  masterQueryObject = (0, _fp.omitBy)(_fp.isUndefined, masterQueryObject);

  return masterQueryObject;
};

var convertQueryToFilter = function convertQueryToFilter(queryObject) {
  if (!queryObject) return null;

  var masterReportId = queryObject.masterReportId || undefined;
  var masterReportPartId = queryObject.masterReportPartId || undefined;
  var containerName = queryObject.containerName || undefined;
  var inheritFilter = queryObject.inheritFilter;


  var filterObject = {
    masterReportId: masterReportId,
    masterReportPartId: masterReportPartId,
    containerName: containerName,
    inheritMasterReportFilter: inheritFilter === 'true' || undefined
  };

  var fieldsMapping = [];
  var filters = [];
  var overridingFilterValue = {};
  var forOwnWithKey = _fp.forOwn.convert(convertSetting);
  var regexFm = /^(fm(\d+)_(\d+))_(value|originalvalue|dataformat|function|datatype)$/;
  var regexField = /^(field)_(.*)/;

  forOwnWithKey(function (value, prop) {
    // Convert 'null' to filter null value
    value = value === 'null' ? _Izenda5.DEFAUFT_VALUE.NULL : value;

    if (OVERIDING_FILTER_LOOKUP_REGEX.test((0, _fp.toLower)(prop))) {
      overridingFilterValue[(0, _fp.toLower)(prop)] = !/false/.test((0, _fp.toLower)(value));
    }

    if (OVERIDING_FILTER_VALUE_REGEX.test((0, _fp.toLower)(prop))) {
      overridingFilterValue[(0, _fp.toLower)(prop)] = value;
    }

    if (regexField.test(prop)) {
      var arr = regexField.exec((0, _fp.toLower)(prop));
      filters.push({
        key: arr[2],
        value: value
      });
    }

    if (masterReportPartId && containerName && masterReportId && regexFm.test((0, _fp.toLower)(prop))) {
      var _arr = regexFm.exec((0, _fp.toLower)(prop));
      var key = _arr[1];
      var name = _arr[4];

      var filterObj = (0, _fp.find)(function (fieldMapping) {
        return fieldMapping.key === key;
      }, fieldsMapping);

      if (!filterObj) {
        fieldsMapping.push((0, _defineProperty3.default)({
          key: key,
          linkReportFilter: true
        }, name, value));
      } else {
        filterObj[name] = value;
      }
    }
  }, queryObject);

  var checkEmpty = function checkEmpty(collection) {
    return (0, _fp.isEmpty)(collection) ? undefined : collection;
  };

  filterObject.filters = checkEmpty(filters);
  filterObject.fieldsMapping = checkEmpty(fieldsMapping);
  filterObject.overridingFilterValue = checkEmpty(overridingFilterValue);

  return (0, _fp.omitBy)(_fp.isUndefined, filterObject);
};

exports.default = {
  readSubReportQuery: readSubReportQuery,
  buildSubReportQuery: buildSubReportQuery,
  convertFilterToQuery: convertFilterToQuery,
  convertQueryToFilter: convertQueryToFilter
};
module.exports = exports['default'];

/***/ }),
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AppContext.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      assignAll = _require.assignAll;

  var PropTypes = __webpack_require__(0).PropTypes;
  var PageService = __webpack_require__(1477);
  var ValidationManager = __webpack_require__(1478);
  var DialogService = __webpack_require__(1481);
  var SecurityManager = __webpack_require__(120);
  var AuthorizationConstants = __webpack_require__(42);
  var Localizer = __webpack_require__(12);
  var ExportPageService = __webpack_require__(1484);

  module.exports = {
    validationShape: {
      validation: PropTypes.object.isRequired
    },
    loaderShape: {
      loader: PropTypes.object.isRequired
    },
    dialogsShape: {
      dialogs: PropTypes.object.isRequired
    },
    authorizationShape: {
      authorization: PropTypes.object.isRequired
    },
    authorizationConstantsShape: {
      authorizationConstants: PropTypes.object.isRequired
    },
    localizationShape: {
      localization: PropTypes.object.isRequired
    },
    exportLoaderShape: {
      exportLoader: PropTypes.object.isRequired
    },
    createValidationContext: function createValidationContext() {
      return {
        validation: new ValidationManager()
      };
    },
    createLoaderContext: function createLoaderContext() {
      return {
        loader: new PageService()
      };
    },
    createExportLoaderContext: function createExportLoaderContext() {
      return {
        exportLoader: new ExportPageService()
      };
    },
    createDialogsContext: function createDialogsContext() {
      return {
        dialogs: new DialogService()
      };
    },
    createAppContextShape: function createAppContextShape() {
      return assignAll([this.validationShape, this.loaderShape, this.dialogsShape, this.authorizationShape, this.authorizationConstantsShape, this.localizationShape, this.exportLoaderShape]);
    },
    createAuthorizationContext: function createAuthorizationContext() {
      return {
        authorization: new SecurityManager()
      };
    },
    createAuthorizationConstantsContext: function createAuthorizationConstantsContext() {
      return {
        authorizationConstants: AuthorizationConstants
      };
    },
    createLocalizerContext: function createLocalizerContext() {
      return {
        localization: Localizer
      };
    },
    createAppContext: function createAppContext() {
      var validationContext = this.createValidationContext();
      var loaderContext = this.createLoaderContext();
      var dialogsContext = this.createDialogsContext();
      var authorizationContext = this.createAuthorizationContext();
      var authorizationConstantsContext = this.createAuthorizationConstantsContext();
      var localizerContext = this.createLocalizerContext();
      var exportLoaderContext = this.createExportLoaderContext();

      return assignAll([validationContext, loaderContext, dialogsContext, authorizationContext, authorizationConstantsContext, localizerContext, exportLoaderContext]);
    }
  };
}();

/***/ }),
/* 180 */,
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(204);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configFactories = new _Izenda2.default('Report Part Configuration', true);
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartConfigurationFactories.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * Set configuration of a report part type
   * @param {string} reportPartType Report part type
   * @param {Object} configuration Report part configuration
   */
  setConfiguration: function setConfiguration(reportPartType, configuration) {
    ensure(reportPartType, 'ReportPartType must have a value');
    ensure(configuration, 'Configuration must have a value');
    ensure(configuration.model, 'Configuration must defined a model class of report part type');

    configFactories.containKey(reportPartType) && configFactories.unregister(reportPartType);
    configFactories.register(reportPartType, function () {
      return configuration;
    });
  },


  /**
   * Get configuration of a report part type
   * @param {string} reportPartType Report part type
   */
  getConfiguration: function getConfiguration(reportPartType) {
    return configFactories.create(reportPartType);
  },


  /**
   * Reset the factories data
   */
  reset: function reset() {
    configFactories.reset();
  }
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  TABLE_REPORT: {
    height: 400
  },
  TABLE_REPORT_PART: {
    height: 180
  },
  TABLE_DEF_REPORT: {
    selectedIcon: {
      key: 'selectedIcon',
      labelKey: 'selectedIcon',
      width: 30,
      fixed: true,
      renderMethod: 'renderRadioButton'
    },
    reportName: {
      columnKey: 'reportname',
      key: 'name',
      labelKey: 'name',
      width: 200,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_REPORT_NAME');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    saveInto: {
      columnKey: 'isGlobal',
      key: 'isGlobal',
      labelKey: 'isGlobal',
      width: 120,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_SAVE_INTO');
      },
      sortable: true,
      renderMethod: 'renderSaveInto'
    },
    category: {
      columnKey: 'category',
      key: 'categoryName',
      labelKey: 'categoryName',
      width: 120,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_CATEGORY');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    subCategory: {
      columnKey: 'subCategory',
      key: 'subCategoryName',
      labelKey: 'subCategoryName',
      width: 120,
      get title() {
        return _Izenda2.default.getText('REPORT_PART_SELECTION_CONSTANTS_SUB_CATEGORY');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    createdBy: {
      columnKey: 'createdBy',
      key: 'createdBy',
      labelKey: 'createdBy',
      width: 105,
      get title() {
        return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_BY');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    created: {
      columnKey: 'createdDate',
      key: 'created',
      labelKey: 'created',
      width: 120,
      get title() {
        return _Izenda2.default.getText('COMMON_CRITERIA_CREATED_DATE');
      },
      sortable: true,
      fixed: true,
      renderMethod: 'renderReportData'
    },
    modifiedBy: {
      columnKey: 'lastEditedBy',
      key: 'modifiedBy',
      labelKey: 'modifiedBy',
      width: 125,
      get title() {
        return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_BY');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    modified: {
      columnKey: 'lastEditedDate',
      key: 'modified',
      labelKey: 'modified',
      width: 135,
      get title() {
        return _Izenda2.default.getText('COMMON_CRITERIA_EDITED_DATE');
      },
      sortable: true,
      fixed: true,
      renderMethod: 'renderReportData'
    }
  },
  TABLE_DEF_REPORT_PART: {
    selectedIcon: {
      key: 'selectedIcon',
      labelKey: 'selectedIcon',
      width: 30,
      fixed: true
    },
    reportPartTitle: {
      columnKey: 'title',
      key: 'title',
      labelKey: 'title',
      width: 400,
      get title() {
        return _Izenda2.default.getText('REPORT_PART_SELECTION_CONSTANTS_REPORT_PART_TITLE');
      },
      sortable: true
    },
    reportPartTypeName: {
      columnKey: 'reportPartTypeName',
      key: 'reportPartTypeName',
      labelKey: 'reportPartTypeName',
      width: 400,
      get title() {
        return _Izenda2.default.getText('REPORT_PART_SELECTION_CONSTANTS_REPORT_PART_TYPE');
      },
      sortable: true
    }
  },
  TYPE: {
    REPORT: 'report',
    REPORT_PART: 'report part'
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FontFormat.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Font Format component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var DropDown = __webpack_require__(29);
  var constants = __webpack_require__(34);
  var GridLayout = __webpack_require__(13);

  var _require = __webpack_require__(1),
      clone = _require.clone,
      values = _require.values;

  var FontFormat = React.createClass({
    displayName: 'FontFormat',

    propTypes: {
      value: React.PropTypes.object,
      onChange: React.PropTypes.func.isRequired,
      disabled: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
      return {
        value: {
          fontFamily: constants.fontFamily.roboto,
          fontSize: constants.fontSize[0]
        },
        blankOption: false,
        disabled: false
      };
    },

    handleChangeFontSize: function handleChangeFontSize(e) {
      var props = this.props;
      var fontFormat = clone(props.value);

      fontFormat.fontSize = parseInt(e.value, 10) || '';
      props.onChange && props.onChange({ value: fontFormat }, { keyChange: 'fontSize' });
    },

    handleChangeFontFamily: function handleChangeFontFamily(e) {
      var props = this.props;
      var fontFormat = clone(props.value);

      fontFormat.fontFamily = e.value;
      props.onChange && props.onChange({ value: fontFormat }, { keyChange: 'fontFamily' });
    },

    render: function render() {
      var props = this.props;
      var disabled = props.disabled;
      var fontFormat = this.props.value || {};
      var listFontFamily = values(constants.fontFamily);
      var fontSize = parseInt(fontFormat.fontSize);

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.FullRow,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 7, className: 'u_noPaddingRight' },
            React.createElement(DropDown, {
              className: 'font-family',
              valueField: '',
              labelField: '',
              options: listFontFamily,
              value: fontFormat.fontFamily,
              disabled: disabled,
              onChange: this.handleChangeFontFamily,
              blankOption: props.blankOption
            })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 5, className: 'u_noPaddingLeft' },
            React.createElement(DropDown, {
              className: 'font-size',
              valueField: '',
              labelField: '',
              options: constants.fontSize,
              value: fontSize,
              disabled: disabled,
              onChange: this.handleChangeFontSize,
              blankOption: props.blankOption
            })
          )
        )
      );
    }
  });

  module.exports = observer(FontFormat);
}();

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(157);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Remove unsed-properties
 * @param  {object} fieldSchema
 * @return {object}
 */
function removeProps(propsSchema, unusedProps) {
  if (!(0, _fp.has)('definedSchema', propsSchema)) {
    return;
  }

  var newSchema = propsSchema.definedSchema;

  // remove un-used properties
  unusedProps.forEach(function (pathItem) {
    newSchema = (0, _fp.unset)(pathItem, newSchema);
  });

  // update new schema
  propsSchema.definedSchema = newSchema;
} // ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditorUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function switchToEditor(editorComp, editorData, editor) {
  return _Izenda2.default.canSwitch(editor).then((0, _mobx.action)(function (canSwitch) {
    if (canSwitch) {
      (0, _fp.invoke)('beforeShowProps', editorData);
      _Izenda2.default.registerByEditors.apply(null, [editorComp, editorData, editor]);
    }

    return canSwitch;
  }));
}

function takeAction(actionName, editorName, editorInfo) {
  var editorId = _Izenda2.default.findEditorIdByName(editorName);
  _Izenda2.default.takeAction(editorId, actionName, editorName, editorInfo || {});
}

/**
 *
 * @param {Object} schemaDefinition Properties editor GUI schema
 * @param {Object} widgets Widget components using in schema definition
 * @param {Object} mappingProps Compoment properties that are bound to widget component when it renders
 * @param {Object} source Source mapping object
 * @param {Object} mappingSource Source mapping object
 * @param {Function} onChangeValue Handle value changed event
 */
function createSchema(schemaDefinition, widgets, mappingProps) {
  var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var mappingSource = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var onChangeValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};

  ensure(schemaDefinition, 'schemaDefinition must be defined');
  ensure(mappingProps, 'mappingProps must be defined');

  return {
    // define data to render UI
    definedSchema: schemaDefinition,
    // list of widgets which are used to render UI
    widgets: widgets,
    // data to binding to fields
    source: source,
    // properties for different fields
    mappingProps: mappingProps,
    // defined-function which fields need to execute to get its data
    mappingSource: mappingSource,
    onChangeValue: onChangeValue
  };
}

exports.default = {
  removeProps: removeProps,
  switchToEditor: switchToEditor,
  takeAction: takeAction,
  createSchema: createSchema
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerWidget.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {

  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;

  var connect = __webpack_require__(2);
  var PropertiesEditorUtils = __webpack_require__(187);
  var PropertiesEditorManager = __webpack_require__(157);

  var _require = __webpack_require__(1),
      invoke = _require.invoke;

  function registerPropertiesEditor(MainComponent) {
    var ReportDesignerWidget = observer(React.createClass({
      displayName: 'ReportDesignerWidget',

      propTypes: {
        propsEditors: React.PropTypes.array,
        checkRegistedItem: React.PropTypes.func,
        beforeShowProps: React.PropTypes.func,
        showPropOnMount: React.PropTypes.func,
        isRerenderOnActive: React.PropTypes.bool
      },

      isShowingPropsEditor: function isShowingPropsEditor() {
        var props = this.props;
        var propsEditors = props.propsEditors;
        return PropertiesEditorManager.isShowingPropsEditor(propsEditors);
      },

      getShowingComponentInfo: function getShowingComponentInfo() {
        var props = this.props;
        var propsEditors = props.propsEditors;
        return PropertiesEditorManager.getShowingComponentInfo(propsEditors);
      },

      componentDidUpdate: function componentDidUpdate() {
        var props = this.props;
        this.isShowingPropsEditor() && props.afterActiveEditor && props.afterActiveEditor();
      },

      render: function render() {

        var props = this.props;
        var propsEditors = props.propsEditors;
        var checkRegistedItem = this.props.checkRegistedItem;

        var isShowingPropsEditor = invoke('isShowingPropsEditor', this);

        this.isRegistedItem = isShowingPropsEditor && (checkRegistedItem ? checkRegistedItem(this.getShowingComponentInfo()) : true);

        return React.createElement(MainComponent, (0, _extends3.default)({}, props, {
          isRegistedItem: this.isRegistedItem,
          onClick: this.onClick,
          isShowingPropsEditor: this.isShowingPropsEditor,
          getShowingComponentInfo: this.getShowingComponentInfo
        }));

        function onClick() {}
      },

      onClick: function onClick() {
        var props = this.props;
        var propsEditors = props.propsEditors;

        props.onClick && props.onClick.apply(this, arguments);
        return PropertiesEditorUtils.switchToEditor(this, props, propsEditors);
      }
    }));

    return connect({ toClass: true })(ReportDesignerWidget);
  }

  module.exports = {
    wrapper: registerPropertiesEditor
  };
}();

/***/ }),
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Thinkness.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 *  Height Setting component
 */
!function () {
  var UIConstants = __webpack_require__(34);
  var React = __webpack_require__(0);
  var NumericInput = __webpack_require__(109);

  var Thinkness = React.createClass({
    displayName: 'Thinkness',

    propTypes: {
      value: React.PropTypes.number,
      onChange: React.PropTypes.func,
      disabled: React.PropTypes.bool
    },

    getInitialState: function getInitialState() {
      return {
        value: this.props.value || UIConstants.borderWidth
      };
    },

    onValueChange: function onValueChange(newValue) {
      var props = this.props;
      this.setState({
        value: newValue
      });

      props.onChange && props.onChange({ value: newValue });
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'thinkness input-group' },
        React.createElement(NumericInput, { value: this.state.value,
          onChange: this.onValueChange,
          min: UIConstants.borderWidthMin,
          max: UIConstants.borderWidthMax,
          disabled: this.props.disabled }),
        React.createElement(
          'div',
          { className: 'input-group-addon' },
          'px'
        )
      );
    }
  });

  module.exports = Thinkness;
}();

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'DataModel/';
// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseSetupDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var FUSION_URL = 'fusion/';

exports.default = {
  /**
   * Load query source's columns
   * @param {Object} querySourceDetails
   * @param {Object} sortInfo
   * @param {Object} pageInfo
   * @param {String} tenantId
   * @returns {Object}
   */
  loadQuerySourceFields: function loadQuerySourceFields(querySourceDetails, sortInfo, pageInfo, tenantId) {
    pageInfo = pageInfo || {};

    var requestData = {
      querySource: querySourceDetails,
      criteria: [],
      tenantId: tenantId,
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: 1000,
      sortOrders: sortInfo
    };

    return (0, _Izenda2.default)(ROOT_URL + 'LoadQuerySourceFields').post(requestData);
  },


  /**
   * Save Query Source
   * @returns {Object}
   */
  updateQuerySource: function updateQuerySource(data) {
    return (0, _Izenda2.default)(ROOT_URL).post(data);
  },


  /**
   * Load query sources of query source type
   * @param {String} tenantId
   * @param {String} querySourceType
   * @param {Object} pageInfo
   * @param {Object} sortInfo
   * @param {Object} criteria
   * @returns {Object}
   */
  loadQuerySources: function loadQuerySources(tenantId, querySourceType, pageInfo, sortInfo, criteria) {
    pageInfo = pageInfo || {};

    var requestData = {
      querySourceType: querySourceType,
      tenantId: tenantId,
      criteria: criteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: sortInfo || [{ key: 'name', descending: true }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'LoadQuerySources').post(requestData);
  },


  /**
   * Invoke a stored procedure
   * @param {String} querySourceId
   * @param {Array} postedParameter
   * @param {Object} sortInfo
   * @returns {Object}
   */
  executeStoredProc: function executeStoredProc(querySourceId, postedParameter, sortInfo) {
    var requestData = {
      querySourceId: querySourceId,
      postedParameters: postedParameter || [],
      sortOrders: sortInfo
    };

    return (0, _Izenda2.default)(ROOT_URL + 'ReloadQuerySourceFields').post(requestData);
  },


  /**
   * Get license schemas
   * @param {String} tenantId
   * @returns {Promise}
   */
  getSchemaDetails: function getSchemaDetails(tenantId) {
    var tenant = (0, _fp.isEmpty)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)(ROOT_URL + 'Schema/' + tenant).get();
  },


  /**
   * Get Join Types
   * @returns {Promise}
   */
  getJoinTypes: function getJoinTypes() {
    return (0, _Izenda2.default)(ROOT_URL + '/relationship/joinTypes/').get();
  },


  /**
   * Get list of Databases with basic info
   * @param {String} tenantId
   * @returns {Promise}
   */
  getBasicConnectionsInfo: function getBasicConnectionsInfo(tenantId) {
    var tenant = (0, _fp.isEmpty)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)(ROOT_URL + 'basicConnectionsInfo/' + tenant).get();
  },


  /**
   * Get list of table with basic info
   * @param {String} connectionId
   * @returns {Promise}
   */
  getBasicQuerySourcesInfo: function getBasicQuerySourcesInfo(connectionId) {
    return (0, _Izenda2.default)(ROOT_URL + 'basicQuerySourcesInfo/' + connectionId).get();
  },


  /**
   * Get list of table with detail info
   * @param {String} connectionId
   * @returns {Promise}
   */
  getQuerySourcesInfo: function getQuerySourcesInfo(connectionId) {
    return (0, _Izenda2.default)(ROOT_URL + 'querySourcesInfo/' + connectionId).get();
  },


  /**
   * Get list of field with basic info
   * @param {String} querySourceId
   * @returns {Promise}
   */
  getBasicQuerySourceFieldsInfo: function getBasicQuerySourceFieldsInfo(querySourceId) {
    return (0, _Izenda2.default)(ROOT_URL + 'basicQuerySourceFieldsInfo/' + querySourceId + '?type=1').get();
  },


  /**
   * Get relationship list
   * @param {String} querySourceId
   * @param {String} tenantId
   * @param {Object} pageInfo
   * @param {Array} sortInfo
   * @param {Array} criteria
   * @returns {Promise}
   */
  getRelationships: function getRelationships(querySourceId, tenantId, pageInfo, sortInfo, criteria) {
    pageInfo = pageInfo || {};

    var requestData = {
      querySourceId: querySourceId,
      tenantId: tenantId,
      criteria: criteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: sortInfo || [{ key: 'DataObject', descending: true }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadRelationships/').post(requestData);
  },


  /**
   * Get Invalid Relationships
   * @param {String} querySourceId
   * @param {String} tenantId
   * @param {Array} criteria
   * @param {Array} modifiedRelationships
   * @returns {Promise}
   */
  getInvalidRelationships: function getInvalidRelationships(querySourceId, tenantId, sortInfo, criteria, modifiedRelationships) {
    var requestData = {
      querySourceId: querySourceId,
      tenantId: tenantId,
      criteria: criteria || [],
      sortOrders: sortInfo,
      modifiedRelationships: modifiedRelationships
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadInvalidRelationships/').post(requestData);
  },


  /**
   * Validate Relationships
   * @param {Object} data
   * @returns {Promise}
   */
  validateRelationships: function validateRelationships(data) {
    var header = {
      modifiedRelationships: data
    };
    return (0, _Izenda2.default)(ROOT_URL + 'validateRelationships/').post(header);
  },


  /**
   * Save Query Source
   *  @param {Object} data
   * @returns {Object}
   */
  saveRelationships: function saveRelationships(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'relationships/').post(data);
  },


  /**
   * Load indicator
   *  @param {String} tenantId
   * @returns {Promise}
   */
  loadIndicator: function loadIndicator(tenantId) {
    var tenant = (0, _fp.isNil)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)(ROOT_URL + 'indicator/' + tenant).get();
  },


  /**
   * Delate relationship
   *  @param {String} relationshipId
   * @returns {Promise}
   */
  deleteRelationship: function deleteRelationship(relationshipId) {
    return (0, _Izenda2.default)(ROOT_URL + 'relationship/' + relationshipId).delete();
  },


  /**
   * Delate Query Source 
   *  @param {String} querySourceFieldId
   * @returns {Promise}
   */
  deleteQuerySourceField: function deleteQuerySourceField(querySourceFieldId) {
    return (0, _Izenda2.default)(ROOT_URL + 'querySourceField/' + querySourceFieldId).delete();
  },


  /**
   * Load function/operators
   * @param {String} tenantId
   * @param {String} querySourceId
   * @param {Array} includeCustomJsonFunction
   * @returns {Promise}
   */
  fetchFunctionOperators: function fetchFunctionOperators(tenantId, querySourceId, includeCustomJsonFunction) {
    var data = {
      querySourceIds: (0, _fp.isArray)(querySourceId) ? querySourceId : [querySourceId],
      tenantId: tenantId,
      includeCustomJsonFunction: includeCustomJsonFunction
    };
    return (0, _Izenda2.default)(ROOT_URL + 'functionOperators').post(data);
  },


  /**
   * validate expression in data source
   * @param {String} querySourceId
   * @param {String} expression
   * @param {String} izendaDataType
   * @param {String} querySourceFieldId
   */
  validateExpression: function validateExpression(querySourceId, expression, izendaDataType, querySourceFieldId) {
    var data = {
      querySourceId: querySourceId,
      expression: expression,
      izendaDataType: izendaDataType,
      querySourceFieldId: querySourceFieldId,
      tenantId: _Izenda4.default.tenantId
    };

    return (0, _Izenda2.default)(FUSION_URL + 'validateDataModelExpression').post(data);
  },


  /**
   * Preview result of calculated field
   * @param {String} querySourceId
   * @param {String} expression
   * @param {String} izendaDataType
   * @param {String} querySourceFieldId
   * @returns {String} preview result
   */
  previewCalculatedField: function previewCalculatedField(querySourceId, expression, izendaDataType, querySourceFieldId) {
    var data = {
      querySourceId: querySourceId,
      expression: expression,
      izendaDataType: izendaDataType,
      querySourceFieldId: querySourceFieldId,
      tenantId: _Izenda4.default.tenantId
    };

    return (0, _Izenda2.default)(FUSION_URL + 'calculatedFieldValue').post(data);
  },


  /**
   * Load database name for custom view popup
   * @param {Object} data
   * @returns {Promise}
   */
  getDatabases: function getDatabases(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'basicConnectionsInfo').post(data);
  },


  /**
   * Load database name for import/database mapping
   * @param {Object} requestData
   * @returns {Promise}
   */
  getConnectionInfo: function getConnectionInfo(requestData) {
    return (0, _Izenda2.default)(ROOT_URL + 'connectionsInfo').post(requestData);
  },


  /**
   * Load schema name for custom view popup
   * @param {Object} data
   * @returns {Promise}
   */
  getSchemas: function getSchemas(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'basicQuerySourceCategoriesInfo').post(data);
  },


  /**
   * Validation for custom view popup
   * @param {Object} data
   * @returns {Promise}
   */
  validateCustomQuerySource: function validateCustomQuerySource(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateCustomQuerySource').post(data);
  },


  /**
   * Save custom view
   * @param {Object} data
   * @returns {Promise}
   */
  saveCustomQuerySource: function saveCustomQuerySource(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'customQuerySource').post(data);
  },


  /**
   * Delete custom query source
   * @param {Object} data
   * @return {Promise}
   */
  deleteCustomQuerySource: function deleteCustomQuerySource(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'deleteCustomQuerySource').post(data);
  }
};
module.exports = exports['default'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(207);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'dashboard/';
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Dashboard Data Fetcher.
 */


var fetchers = {
  /**
   * Get all categories
   * @param {String} saveType
   * @returns {promise}
   */
  loadAllCategories: function loadAllCategories(tenantId) {
    tenantId = (0, _fp.isNil)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)(ROOT_URL + 'categories/' + tenantId).get();
  },

  /**
   * Load category for dashboard (lazy load)
   */
  loadLazyLoadCategories: function loadLazyLoadCategories(searchFilter) {
    return (0, _Izenda2.default)(ROOT_URL + 'allowedSavingCategories').post(searchFilter);
  },

  /**
   * Load subcategory for dashboard (lazy load)
   */
  loadLazyLoadSubcategories: function loadLazyLoadSubcategories(searchFilter) {
    return (0, _Izenda2.default)(ROOT_URL + 'allowedSavingSubCategories').post(searchFilter);
  },

  getSubCategories: function getSubCategories(searchFilter) {
    return (0, _Izenda2.default)(ROOT_URL + 'subcategories');
  },

  /**
   * Search report Categories
   * @param  {Object} data [description]
   * @return {Promise} array of ReportCategories
   */
  searchCategories: function searchCategories(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'search').post(request);
  },

  /**
   * Lazy search dashboard categories
   * @param  {Object} data
   * @return {Promise}
   */
  lazyLoadingSearchCategories: function lazyLoadingSearchCategories(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'search2').post(request);
  },

  /**
   * validate category name
   * @param  {object} category
   * @returns {Promise}
   */
  validateCategoryName: function validateCategoryName(category) {
    return (0, _Izenda2.default)(ROOT_URL + 'category').post(category);
  },

  /**
   * Delete dashboard
   * @param  {string}  dashboardId dashboard id
   * @return {Promise}
   */
  deleteDashboard: function deleteDashboard(dashboardId) {
    return (0, _Izenda2.default)(ROOT_URL + dashboardId).delete();
  },

  /**
   * Delete a ReportCategory by id
   * @param {string} reportCategoryId
   * @returns {promise}
   */
  deleteReportCategory: function deleteReportCategory(reportCategoryId) {
    return (0, _Izenda2.default)(ROOT_URL + 'category/' + reportCategoryId).delete();
  },

  /**
   * Load dashboard subscription
   * @param  {string} tenantId
   * @param  {object} pageInfo
   * @param  {string} dashboardId
   * @param  {Boolean} isSubscribe - Subscribe or Scheduling
   */
  loadSubscription: function loadSubscription(tenantId, pageInfo, dashboardId, isSubscribe) {
    pageInfo = pageInfo || {};

    var requestData = {
      dashboardId: dashboardId,
      isSubscription: isSubscribe,
      tenantId: tenantId,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{ key: 'name', descending: true }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadSubscriptions').post(requestData);
  },

  /**
   * Get email templates
   * @returns {promise}
   */
  fetchEmailTemplates: function fetchEmailTemplates(templateType) {
    return (0, _Izenda2.default)(ROOT_URL + 'emailTemplates/' + templateType).get();
  },

  /**
   * Validate subscription instance.
   * @param  {Object} instance
   * @param {Array} commonFilterFields
   * @returns {Promise}
   */
  validateSubscription: function validateSubscription(instance, commonFilterFields) {
    var requestInfo = {
      subscription: (0, _fp.omit)(['reportFilter'], instance),
      commonFilterFields: commonFilterFields
    };

    return (0, _Izenda2.default)(ROOT_URL + 'subscription/validate').post(requestInfo);
  },

  /**
   * Load list field for compare field dropdown list.
   * @param {Object} requestInfo
   * @returns {promise}
   */
  loadFilterDataSource: function loadFilterDataSource(requestInfo) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadFilterComparisonFields').post(requestInfo);
  },

  /**
   * Load filter field data
   * @param {Object} requestInfo
   * @returns {array}
   */
  loadFilterFieldData: function loadFilterFieldData(requestInfo) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadFilterFieldData').post(requestInfo);
  },

  /**
   * Load partial filter field data
   * @param {Object} requestInfo
   * @returns {array}
   */
  loadPartialFilterFieldData: function loadPartialFilterFieldData(requestInfo) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadPartialFilterFieldData').post(requestInfo);
  },

  /**
   * Load filter field data as tree style.
   * @param {Object} requestInfo
   * @returns {array}
   */
  loadFilterFieldDataAsTree: function loadFilterFieldDataAsTree(requestInfo) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadFilterFieldDataAsTree').post(requestInfo);
  },

  /**
   * Load partial filter field data as tree style.
   * @param {Object} requestInfo
   * @returns {array}
   */
  loadPartialFilterFieldDataAsTree: function loadPartialFilterFieldDataAsTree(requestInfo) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadPartialFilterFieldDataAsTree').post(requestInfo);
  },

  /**
   * Load all dashboard categories
   * @param  {Object} data
   * @return {Promise}
   */
  loadDashboardCategories: function loadDashboardCategories(data, includeHashCode) {
    includeHashCode = (0, _fp.isNil)(includeHashCode) ? false : includeHashCode;
    return (0, _Izenda2.default)(ROOT_URL + 'list?includeHashCode=' + includeHashCode).post(data);
  },

  /**
   * Load lazy all dashboards
   * @param  {Object} data
   * @param  {Boolean} includeHashCode
   * @return {Promise}
   */
  lazyLoadingDashboards: function lazyLoadingDashboards(data, includeHashCode) {
    includeHashCode = (0, _fp.isNil)(includeHashCode) ? false : includeHashCode;
    return (0, _Izenda2.default)(ROOT_URL + 'list2?includeHashCode=' + includeHashCode).post(data);
  },

  /**
   * Move dashboard to another category/ sub-categories
   * @param  {Object} data moved dashboad
   * @return {Promise}
   */
  moveDashboard: function moveDashboard(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'move').post(data);
  },

  /**
   * Rename dashboad
   * @param  {Object} data rename dashboad
   * @return {Promise}
   */
  renameDashboard: function renameDashboard(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'rename').post(data);
  },

  /**
   * Copy existing dashboad
   * @param  {Object} data copy dashboad
   * @return {Promise}
   */
  copyDashboard: function copyDashboard(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'copy').post(data);
  },

  /**
   * Validate dashboard name
   * @param {Object} dashboard detail model
   * @returns {promise}
   */
  validateDashboardName: function validateDashboardName(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateDashboardName').post(data);
  },

  /**
   * Load dashboard
   * @param {String} dashboard params
   * @returns {Object}
   */
  loadDashboard: function loadDashboard(dashboardParams) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadDashboard').post(dashboardParams);
  },

  /**
   * load common filter
   * @method loadCommonFilters
   * @param  {[type]}          dashboardDefinition [description]
   * @return {[type]}                              [description]
   */
  loadCommonFilters: function loadCommonFilters(dashboardDefinition) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadCommonFilters').post(dashboardDefinition);
  },

  /**
   * load dashboardpart fielterDesription
   * @method loadFilterDescription
   * @param  {[type]}              request [description]
   * @return {[type]}                      [description]
   */
  loadFilterDescription: function loadFilterDescription(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadFilterDescription').post(request);
  },

  /**
   * for saved dashboard
   * @method loadDashboardPartData
   * @param  {[type]}              request [description]
   * @return {[type]}                      [description]
   */
  loadDashboardPartData: function loadDashboardPartData(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadDashboardPartData').post(request);
  },

  /**
   * for editing dashboard
   * @method previewDashboardPartData
   * @param  {[type]}                 request [description]
   * @return {[type]}                         [description]
   */
  previewDashboardPartData: function previewDashboardPartData(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'previewDashboardPartData').post(request);
  },

  /**
   * Save dashboard
   * @param {Object} dashboard detail
   * @returns {Object}
   */
  saveDashboard: function saveDashboard(dashboardDetail) {
    return (0, _Izenda2.default)(ROOT_URL).post(dashboardDetail);
  },

  /**
   * Save dashboard subscriptions
   * @param  {Object} data
   * @returns {Promise}
   */
  saveSubscriptions: function saveSubscriptions(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'subscriptions').post(data);
  },

  /**
   * Fetch definition of dashboard part.
   * @param  {String} id
   */
  loadDashboardPartDefinition: function loadDashboardPartDefinition(id) {
    return (0, _Izenda2.default)(ROOT_URL + 'dashboardPart/' + id).get();
  },

  /**
   * Load accesses
   * @param  {string} reportId
   * @param  {Object} subscriptions
   * @param  {Object} pageInfo
   */
  loadAccesses: function loadAccesses(dashboardId, data, pageInfo) {
    pageInfo = pageInfo || {};

    var requestData = {
      dashboardId: dashboardId,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{ key: 'all', descending: true }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'loadAccesses').post(requestData);
  },

  /**
   * Validationn dashboard accesses
   * @param  {object} requestData
   */
  validateAccesses: function validateAccesses(requestData) {
    return (0, _Izenda2.default)(ROOT_URL + 'accesses/validate').post(requestData);
  },

  /**
   * Validate dashboard
   * @param {Object} dashboard detail
   * @returns {Object}
   */
  validateDashboard: function validateDashboard(dashboardDetail) {
    return (0, _Izenda2.default)(ROOT_URL + 'validate').post(dashboardDetail);
  },

  /**
   * Get allowed saving categories
   * @param {String} tenant id
   * @returns {Object}
   */
  getAllowedSavingCategories: function getAllowedSavingCategories(tenantId) {
    tenantId = (0, _fp.isNil)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)(ROOT_URL + 'allowedSavingCategories/' + tenantId).get();
  },

  /**
   * update renderingTime
   * @param  {string} id
   * @param  {Number} renderingTime
   */
  updateRenderingTime: function updateRenderingTime(dashboardId, renderingTime) {
    var requestData = {
      id: dashboardId,
      renderingTime: renderingTime
    };

    return (0, _Izenda2.default)(ROOT_URL + 'updateRenderingTime').post(requestData);
  },

  /**
   * Get dashboard common filter fields
   * @param  {string} dashboardId
   * @return {Promise}
   */
  getCommonFilterById: function getCommonFilterById(dashboardId) {
    return (0, _Izenda2.default)(ROOT_URL + 'commonFilters/' + dashboardId).get();
  },

  /**
   * save draft data use for printing
   * @method saveDraftDataForPrint
   * @param  {JSON}              dashboardDefinition [description]
   * @return {Promise}                                  [description]
   */
  saveDraftDataForPrint: function saveDraftDataForPrint(dashboardDefinition) {
    return (0, _Izenda2.default)(ROOT_URL + 'draft').post(dashboardDefinition);
  },

  /**
   * use draft id when save draft to get draft data
   * @method getDraftDataForPrint
   * @param  {string}              draftId [description]
   * @return {Promise}                                  [description]
   */
  getDraftDataForPrint: function getDraftDataForPrint(draftId) {
    return (0, _Izenda2.default)(ROOT_URL + 'draft/' + draftId).get();
  },

  /**
   * Get all categories
   * @param {Object} param
   * @returns {promise}
   */
  loadLazyLoadingCategories: function loadLazyLoadingCategories(param) {
    return (0, _Izenda2.default)(ROOT_URL + 'categories/').post(param);
  },

  /**
   * Validate Global Dashboard.
   */
  validateGlobalDashboard: function validateGlobalDashboard(dashboardDefinition) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateGlobalDashboard').post(dashboardDefinition);
  },

  /**
   * Load related dashboard part
   */
  loadRelatedDashboardParts: function loadRelatedDashboardParts(id) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadRelatedDashboardParts/' + id).get();
  }
};

_Izenda4.default.linkToLoadingProgress(fetchers, {
  deleteDashboard: {
    allowToCancel: false
  },
  deleteReportCategory: {
    allowToCancel: false
  },
  moveDashboard: {
    allowToCancel: false
  },
  renameDashboard: {
    allowToCancel: false
  },
  copyDashboard: {
    allowToCancel: false
  },
  saveDashboard: {
    allowToCancel: false
  },
  saveSubscriptions: {
    allowToCancel: false
  },
  lazyLoadingDashboards: {
    allowToCancel: false
  },
  loadLazyLoadingCategories: {
    allowToCancel: false
  }
});

exports.default = fetchers;
module.exports = exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartSettingsContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ChartSettingsContainer Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(351);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(404);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(15);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(41);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(268);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(35);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ChartSettingsContainer = (_dec = (0, _Izenda15.exportClass)('ChartSettingsContainer'), _dec(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(ChartSettingsContainer, _Component);

  function ChartSettingsContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ChartSettingsContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChartSettingsContainer.__proto__ || (0, _getPrototypeOf2.default)(ChartSettingsContainer)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'containerSize', _descriptor, _this), _this.setContainer = function (container) {
      _this.container = container;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ChartSettingsContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.container) {
        this.containerSize.width = this.container.clientWidth;
        this.containerSize.height = this.container.clientHeight;
      }
    }

    /**
     * Set container
     * @param {any} container
     */

  }, {
    key: 'render',
    value: function render() {
      var props = this.props,
          _props = this.props,
          assignChartOptions = _props.assignChartOptions,
          configurationDef = _props.configurationDef,
          chartData = _props.chartData,
          type = _props.type;

      var allChartProps = ((0, _fp.isFunction)(props.allChartProps) ? props.allChartProps() : props.allChartProps) || {};
      var chartOptions = (0, _fp.assign)((0, _mobx.toJS)(allChartProps.chartOptions) || {}, assignChartOptions);
      chartOptions = (0, _fp.merge)(chartOptions, props.chartOptions);
      chartOptions = (0, _fp.merge)(chartOptions, { isSetting: true });

      // Add property for correct sort on chart type
      if (!chartOptions.sort) {
        chartOptions.sort = { chartType: chartOptions.chartType };
      }

      var className = (0, _classnames2.default)('chart-settings u_table u_fullWidth', props.className);

      return _react2.default.createElement(
        'section',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: 'configuration u_tableCell' },
          _react2.default.createElement(
            'label',
            { className: 'setting-header' },
            _Izenda6.default.getText('COMMON_LABEL_CONFIGURATION')
          ),
          _react2.default.createElement(_Izenda12.default, { propertyConfig: configurationDef, className: 'hover-none-background u_marginAll' })
        ),
        !_Izenda8.default.isMobile && _Izenda10.default.canShowPreview() && _react2.default.createElement(
          'div',
          { className: 'preview u_tableCell' },
          _react2.default.createElement(
            'label',
            { className: 'setting-header' },
            _Izenda6.default.getText('COMMON_LABEL_PREVIEW')
          ),
          _react2.default.createElement(
            'div',
            { ref: this.setContainer, className: 'body u_DisabledPointerEvent' },
            !props.isLoading && _react2.default.createElement(_Izenda4.default, {
              type: type,
              chartType: chartOptions.chartType,
              isPreview: true,
              chartOptions: chartOptions,
              seriesOptions: allChartProps.seriesOptions,
              chartData: chartData || allChartProps.chartData,
              containerSize: this.containerSize
            }),
            props.isLoading && _react2.default.createElement(_Izenda2.default, { className: 'u_fullSize u_flex u_flexCenterAlignItems' })
          )
        )
      );
    }
  }]);
  return ChartSettingsContainer;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'containerSize', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      width: null,
      height: null
    };
  }
})), _class2)) || _class);
exports.default = ChartSettingsContainer;
module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IzendaConfig = __webpack_require__(40);

var _IzendaConfig2 = _interopRequireDefault(_IzendaConfig);

var _reactRouter = __webpack_require__(52);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var synergyHistory = null;

// Return corresponding react-router history object
// in either standalone (izenda frontend app) or integration mode (customer frontend app)

// ----------------------------------------------------------------------
// <copyright file="Izenda.Config.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = function (createNew) {
  var isPageLoad = (0, _fp.isNil)(synergyHistory);
  if ((0, _fp.isNil)(synergyHistory) || createNew) {
    var Integration = _IzendaConfig2.default.Integration;

    synergyHistory = Integration ? (0, _reactRouter.createMemoryHistory)() : _reactRouter.browserHistory;
  }

  return { synergyHistory: synergyHistory, isPageLoad: isPageLoad };
};

module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.List.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module List component
 * @example
 *  <List>
      <p>Item 1</p>
      <p>Item 2</p>
 *  </List>
 */
!function () {
  var React = __webpack_require__(0);

  var _require = __webpack_require__(1),
      omit = _require.omit;

  var List = React.createClass({
    displayName: 'List',

    propTypes: {
      itemClass: React.PropTypes.string
    },
    /**
     * Render component
     * @returns {type}
     */
    render: function render() {
      var props = this.props;

      var items = this.props.children.map(function (item, index) {
        return React.createElement(
          'li',
          { className: props.itemClass, key: index },
          item
        );
      });

      var rest = omit(['children', 'itemClass'], this.props);

      return React.createElement(
        'ul',
        rest,
        items
      );
    }
  });

  module.exports = List;
}();

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MiddlePanel.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


/**
 * MiddlePanel component
 */
!function () {
  var ReactDOM = __webpack_require__(32);
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);
  var LayoutUtils = __webpack_require__(153);
  var BrowserUtils = __webpack_require__(78);
  var Divider = __webpack_require__(943);

  var DEFAULT_MIDDLE_PANEL_WIDTH = 250;
  var DEFAULT_SIDEBAR_WIDTH = 250;

  var MiddlePanel = React.createClass({

    displayName: 'MiddlePanel',
    /**
     * Get default properties
     */
    getDefaultProps: function getDefaultProps() {
      return {
        disabled: false,
        hidden: false
      };
    },

    hideSidebar: function hideSidebar() {
      LayoutUtils.toggleMiddelPanel(false, true);
    },

    getMaxContainerWidth: function getMaxContainerWidth() {
      var screenWidth = BrowserUtils.getScreenSize().width;
      // calculate with padding left sidebar
      return screenWidth / 2 - DEFAULT_SIDEBAR_WIDTH - 10;
    },

    render: function render() {
      var config = {
        defaultValue: DEFAULT_MIDDLE_PANEL_WIDTH,
        minValue: 0,
        maxValue: this.getMaxContainerWidth()
      };

      var classes = classnames({
        "izenda-MiddlePanel": true,
        "disabled-elm": this.props.disabled
      });

      return this.props.hidden ? null : React.createElement(
        'div',
        { className: classes, 'aria-expanded': 'false' },
        React.createElement(
          'div',
          { className: 'izenda-Wrapper' },
          React.createElement(
            'div',
            { className: 'izenda-MiddlePanel-icon' },
            React.createElement(
              'div',
              { className: 'izenda-NavIcon expanded', onClick: this.hideSidebar },
              React.createElement('span', null),
              React.createElement('span', null),
              React.createElement('span', null),
              React.createElement('span', null),
              React.createElement('span', null),
              React.createElement('span', null)
            )
          ),
          this.props.children,
          React.createElement(Divider, { config: config, orientation: 'horizontal', nodeHandle: 'parentNode.parentNode' })
        )
      );
    }
  });

  module.exports = MiddlePanel;
}();

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  TEXT_INPUT_TYPE: 'text',
  PASSWORD_INPUT_TYPE: 'password',
  DATA_SERVER_TYPE_VALUE: 'dataServerTypeValue',
  DATABASE_NAME: 'databaseName',
  CONNECTION_STRING: 'connectionString',
  CONNECTION_STRING_INPUT_TYPE: 'connectionStringInputType',
  CONNECTION_STRING_STATUS: 'connectionStringStatus',
  IS_DISABLED: 'isDisabled',

  QUERY_SOURCE_TYPE: {
    TABLE: 'Table',
    VIEW: 'View',
    STOREPROCEDURE: 'Stored Procedure',
    FUNCTION: 'Function'
  },

  get UNKNOWN_STATUS() {
    return _Izenda2.default.getText('CONNECTION_UNKNOWN_STATUS');
  },
  get VALID_STATUS() {
    return _Izenda2.default.getText('CONNECTION_VALID_STATUS');
  },
  get INVALID_STATUS() {
    return _Izenda2.default.getText('CONNECTION_INVALID_STATUS');
  },

  get DATA_SOURCE_CHANGES() {
    return _Izenda2.default.getText('CONNECTION_DATA_SOURCE_CHANGES');
  },
  get DELETED_DATA_SOURCE() {
    return _Izenda2.default.getText('CONNECTION_DELETED_DATA_SOURCE');
  },
  get NEW_DATA_SOURCE() {
    return _Izenda2.default.getText('CONNECTION_NEW_DATA_SOURCE');
  },

  get GUIDE_CONTENT() {
    return _Izenda2.default.getText('CONNECTION_GUIDE_CONTENT');
  },

  DATABASE_NAME_MAX_LENGTH: 150,

  get DATABASE_NAME_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('CONNECTION_REQUIRE_DATABASE_NAME')
      },
      length: {
        maximum: 150,
        message: _Izenda2.default.getText('CONNECTION_MAX_LENGTH_DATABASE_NAME')
      }
    };
  },

  get CONNECTION_STRING_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('CONNECTION_REQUIRE_CONNECTION_STRING')
      }
    };
  },

  get CONNECT_TYPE() {
    return {
      RECONNECT: _Izenda2.default.getText('CONNECTION_TYPE_RECONNECT'),
      CONNECT: _Izenda2.default.getText('CONNECTION_TYPE_CONNECT')
    };
  },

  DETECTED_CHANGE_LEVEL: {
    NONE: 0,
    ADDED: 1,
    MODIFIED: 2,
    DELETED: 3
  },

  APPROVAL_LEVEL: {
    PENDING: 0,
    QUERY_SOURCE: 1,
    QUERY_SOURCE_FIELD: 2
  },

  CONNECTION_STRING_HASH: '************************************************************************************************************',

  get DELETE_MESSAGE() {
    return _Izenda2.default.getText('CONNECTION_DELETE_MESSAGE');
  },
  get INVISIBLE_MESSAGE() {
    return _Izenda2.default.getText('CONNECTION_INVISIBLE_MESSAGE');
  },
  get VISIBLE_MESSAGE() {
    return _Izenda2.default.getText('CONNECTION_VISIBLE_MESSAGE');
  },
  get M03() {
    return _Izenda2.default.getText('CONNECTION_DELETED_DATASOURCE_MESSAGE');
  },
  get M05() {
    return _Izenda2.default.getText('CONNECTION_OVERRIDE_MESSAGE');
  },

  get MISMATCH_CONNECIONSTRING_DATASOURCE() {
    return _Izenda2.default.getText('CONNECTION_MISMATCH_CONNECIONSTRING_DATASOURCE');
  },
  get NEW_CONNECTIONSTRING_DIFFERENT_SCHEMA() {
    return _Izenda2.default.getText('CONNECTION_NEW_CONNECTIONSTRING_DIFFERENT_SCHEMA');
  },

  get GUIDECONTENT() {
    return _Izenda2.default.getText('CONNECTION_GUIDECONTENT');
  },

  SERVER_TYPE: {
    MSSQL: '572bd576-8c92-4901-ab2a-b16e38144813'
  },
  get REVERSE_CONNECTION_STRING() {
    return _Izenda2.default.getText('CONNECTION_REVERSE_CONNECTION_STRING');
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get MENU() {
    return [{
      key: 'tables',
      icon: 'icon-table',
      title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_TABLE'),
      backendType: 'Table'
    }, {
      key: 'views',
      icon: 'icon-view-table',
      title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_VIEW'),
      backendType: 'View'
    }, {
      key: 'storeprocedures',
      icon: 'icon-sp',
      title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_STORED_PROCEDURES'),
      backendType: 'Stored Procedure'
    }, {
      key: 'functions',
      icon: 'icon-fx-table',
      title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_FUNCTIONS'),
      backendType: 'Function'
    }, {
      key: 'relationship',
      icon: 'icon-relationship',
      title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_MENU_RELATIONSHIP'),
      backendType: 'Relationship'
    }];
  },

  QUERY_SOURCE_TYPE: {
    TABLE: 'tables',
    VIEW: 'views',
    STOREPROCEDURES: 'storeprocedures',
    FUNCTIONS: 'functions',
    RELATIONSHIP: 'relationship',
    SCHEMA: 'schema'
  },

  DETECTED_CHANGE_LEVEL: {
    NONE: 0,
    ADDED: 1,
    MODIFIED: 2,
    DELETED: 3
  },

  APPROVAL_LEVEL: {
    PENDING: 0,
    QUERY_SOURCE: 1,
    QUERY_SOURCE_FIELD: 2
  },
  get DELETED_FUNCTION() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_DELETED_FUNCTION');
  },

  get FUNCTION_CHANGE() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_FUNCTION_CHANGE');
  },

  get FUNCTION_ADD() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_FUNCTION_ADD');
  },
  get NEW_DATA_SOURCE() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_NEW_DATA_SOURCE');
  },
  get DATA_SOURCE_CHANGES() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_DATA_SOURCE_CHANGES');
  },
  get DELETED_DATA_SOURCE() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_DELETED_DATA_SOURCE');
  },
  get NEW_FIELD() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_NEW_FIELD');
  },
  get DATA_TYPE_CHANGES() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_DATA_TYPE_CHANGES');
  },
  get DELETED_FIELD() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_DELETED_FIELD');
  },
  get CHANGED_INDICATOR() {
    return _Izenda2.default.getText('DATA_MODEL_CONSTANTS_CHANGED_INDICATOR');
  },
  get TENANT_FIELD() {
    return _Izenda2.default.getText('COMMON_LABEL_TENANT_FIELD');
  },
  DEFAULT_TABLE_HEIGHT: 238,
  DEFAULT_REST_HEIGHT: 36,
  DEFAULT_DETAIL_REST_HEIGHT: 326,

  get TableDefinition() {
    return {
      /* Settings > Data Setup > Data Model: Tables, Views, Stored procedure, Functions */
      get QuerySourceType() {
        return {
          category: {
            columnKey: 'Category',
            width: 250,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_CATEGORY'),
            sortable: true
          },
          dbName: {
            columnKey: 'DatabaseName',
            width: 250,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DATABASE_NAME'),
            sortable: true
          },
          dbSourceName: {
            columnKey: 'DataSourceName',
            width: 250,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_SOURCE_NAME'),
            sortable: true
          },
          functionName: {
            columnKey: 'DataSourceName',
            width: 250,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_FUNCTION_NAME'),
            sortable: true
          },
          dbSourceAlias: {
            columnKey: 'DataSourceAlias',
            width: 250,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_SOURCE_ALIAS'),
            sortable: true
          },
          returnedValue: {
            columnKey: 'returnedValue',
            width: 200,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_RETURNED_VALUE')
          },
          inputParams: {
            columnKey: 'inputParams',
            width: 190,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_INPUT_PARAMS')
          },
          fieldLevel: {
            columnKey: 'fieldLevel',
            width: 160,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_FIELD_LEVEL')
          },
          expressionLevel: {
            columnKey: 'expressionLevel',
            width: 200,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_EXPRESSION_LEVEL')
          },
          dynamic: {
            columnKey: 'dynamic',
            width: 100,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DYNAMIC'),
            fixed: true
          },
          controlBtn: { columnKey: 'controlBtn', width: 70, fixed: true }
        };
      },

      /* Settings > Data Setup > Data Model > Fields: Tables, Views, Stored procedure, Functions */
      get QuerySourceTypeDetails() {
        return {
          columnName: {
            columnKey: 'ColumnName',
            width: 250,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DETAIL_COLUMN_NAME'),
            sortable: true
          },
          dataType: {
            columnKey: 'DataType',
            width: 200,
            title: _Izenda2.default.getText('COMMON_LABEL_DATA_TYPE'),
            sortable: true
          },
          columnAlias: {
            columnKey: 'ColumnAlias',
            width: 250,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DETAIL_COLUMN_ALIAS'),
            sortable: true
          },
          filter: {
            columnKey: 'filter',
            width: 300,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DETAIL_FILTER_VALUE')
          },
          visible: {
            columnKey: 'visible',
            width: 80,
            fixed: true,
            title: _Izenda2.default.getText('COMMON_LABEL_VISIBLE')
          },
          filterable: {
            columnKey: 'filterable',
            width: 80,
            fixed: true,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_TITLE_QUERY_SOURCE_TYPE_DETAIL_FILTERABLE')
          },
          deletable: { columnKey: 'deletable', width: 50, fixed: true }
        };
      },

      /* Settings > Data Setup > Data Model: Relationship */
      get Relationship() {
        return {
          joinType: {
            columnKey: 'joinType',
            width: 105,
            title: _Izenda2.default.getText('COMMON_LABEL_JOIN_TYPE'),
            sortable: false
          },
          positionId: {
            columnKey: 'PositionId',
            width: 105,
            title: _Izenda2.default.getText('COMMON_LABEL_POSITION'),
            sortable: true
          },
          dbName: {
            columnKey: 'DatabaseName',
            width: 150,
            title: _Izenda2.default.getText('COMMON_LABEL_DATABASE_NAME'),
            sortable: true
          },
          dataObject: {
            columnKey: 'DataObject',
            width: 180,
            title: _Izenda2.default.getText('COMMON_LABEL_DATA_OBJECT'),
            sortable: true
          },
          joinField: {
            columnKey: 'JoinField',
            width: 150,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_RELATIONSHIP_JOIN_FIELD'),
            sortable: true
          },
          equal: { columnKey: 'equal', width: 40, title: '', sortable: false, fixed: true },
          frDbName: {
            columnKey: 'ForeignDatabaseName',
            width: 150,
            title: _Izenda2.default.getText('COMMON_LABEL_DATABASE_NAME'),
            sortable: true
          },
          frDataObject: {
            columnKey: 'ForeignDataObject',
            width: 180,
            title: _Izenda2.default.getText('COMMON_LABEL_FOREIGN_DATA_OBJECT'),
            sortable: true
          },
          frField: {
            columnKey: 'Field',
            width: 150,
            title: _Izenda2.default.getText('DATA_MODEL_CONSTANTS_RELATIONSHIP_FIELD'),
            sortable: true
          },
          action: { columnKey: 'action', width: 100, title: '', sortable: false, fixed: true }
        };
      }
    };
  },
  EXPRESSION_SELECTION: {
    FIELD_NAME: {
      enableDataSource: false,
      returnedOnlyFieldNameFormat: '[{0}]'
    }
  },
  DEFAULT_SEARCH_PROPERTY: 'All'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.DataModelConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(160);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Relationship Column
 */
function RelationshipColumn() {
  var _props = this.props,
      ChildComponent = _props.component,
      relationshipVM = _props.store,
      fieldCheck = _props.fieldCheck,
      classes = _props.classes,
      rowIndex = _props.rowIndex,
      validationsRules = _props.validationsRules,
      componentOptions = _props.componentOptions,
      selectedFunction = _props.selectedFunction,
      setFunction = _props.setFunction;


  var disabledWhenShowOnlyOneDataSource = !!relationshipVM.querySource && (fieldCheck == _Izenda2.default.FIELDCHECK.DATABASE_FIELD || fieldCheck == _Izenda2.default.FIELDCHECK.JOIN_QUERYSOURCE_FIELD);
  var disabled = !this.props.relationshipItem.editable ? true : disabledWhenShowOnlyOneDataSource ? true : this.props.relationshipItem.isDisableField(fieldCheck);

  return _react2.default.createElement(ChildComponent, (0, _extends3.default)({
    disabled: disabled,
    className: 'validation-border ' + classes,
    field: fieldCheck,
    group: _Izenda2.default.RELATIONSHIP_LABEL + rowIndex,
    value: selectedFunction,
    onChange: setFunction,
    validations: validationsRules
  }, componentOptions));
}

RelationshipColumn.propTypes = {
  relationshipItem: _propTypes2.default.object.isRequired,
  store: _propTypes2.default.object.isRequired,
  fieldCheck: _propTypes2.default.string.isRequired,
  selectedFunction: _propTypes2.default.any,
  setFunction: _propTypes2.default.func,
  component: _propTypes2.default.func.isRequired,
  componentOptions: _propTypes2.default.object
};

RelationshipColumn.defaultProps = {
  validationsRules: _Izenda2.default.REQUIRED_CONSTRAINT
};

exports.default = (0, _mobxReact.observer)(RelationshipColumn);
module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var setParent = function setParent(object) {
  (0, _fp.forIn)(function (child) {
    child.parent = object;
    setParent(child);
  }, object.children);
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedSettingConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var routeConfig = {
  Settings: {
    name: 'Settings',
    optionalParam: ['(/:notSetupDatabase)']
  },
  Report: {
    name: 'Report',
    children: {
      List: {
        name: 'ReportList',
        path: 'list/:reportType(/:catId(/:isGlobal))'
      },
      View: {
        name: 'View',
        path: 'view/:id(/:version)'
      },
      Edit: {
        name: 'ReportsEdit',
        path: 'edit/:id(/:version)'
      }
    }
  },
  Dashboard: {
    name: 'Dashboard',
    children: {
      List: {
        name: 'DashboardList',
        path: 'list/:catId(/:dashboardId(/:isGlobal))'
      },
      New: {
        name: 'NewDashboard',
        path: 'new'
      },
      Edit: {
        name: 'EditDashboard',
        path: 'edit/:id'
      },
      DashboardViewer: {
        name: 'DashboardViewer',
        path: ':id'
      }
    }
  },
  ReportDesigner: {
    name: 'ReportDesigner',
    children: {
      ReportDesignerDetail: {
        name: 'ReportDesignerDetail',
        path: ':reportId'
      }
    }
  },
  ReportViewer: {
    name: 'ReportViewer',
    children: {
      ReportViewerDetail: {
        name: 'ReportViewerDetail',
        path: ':id'
      }
    }
  },
  Viewer: {
    name: 'Viewer',
    children: {
      ReportPart: {
        name: 'ReportPart',
        path: 'reportpart/:id'
      },
      DashboardPart: {
        name: 'DashboardPart',
        path: 'dashboardpart/:id'
      },
      ReportBody: {
        name: 'ReportBody',
        path: 'reportbody/:id'
      },
      Dashboard: {
        name: 'Dashboard',
        path: 'dashboard/:id'
      }
    }
  },
  Account: {
    name: 'account',
    children: {
      Activation: {
        name: 'Activation',
        path: 'activation'
      },
      Login: {
        name: 'Login',
        path: 'login'
      },
      ResetPassword: {
        name: 'ResetPassword',
        path: 'resetPassword'
      },
      ForgotPassword: {
        name: 'ForgotPassword',
        path: 'forgotPassword'
      }
    }
  },
  MyProfile: {
    name: 'MyProfile',
    children: {
      PersonalInfo: {
        name: 'PersonalInfo',
        path: 'personalinfo'
      },
      SecurityOptions: {
        name: 'SecurityOptions',
        path: 'securityoptions'
      }
    }
  }
};

(0, _fp.forIn)(setParent, routeConfig);

// This contents the uri for going back later using router.
var SOURCE_PATH_QUERY_KEY = 'spath';

exports.default = {
  routeConfig: routeConfig,
  mergeRouteConfig: (0, _fp.mergeWith)(function (objValue, srcValue) {
    srcValue.path = (0, _fp.compact)((0, _fp.concat)(objValue, srcValue.optionalParam)).join('');
    return srcValue;
  }, _fp.placeholder, routeConfig),
  SOURCE_PATH_QUERY_KEY: SOURCE_PATH_QUERY_KEY
};
module.exports = exports['default'];

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = __webpack_require__(651);

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Factories.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Manage the factories of a type
 */
var Factories = function () {
  /**
   * Create Factories object
   * @param {string} type Factory type
   * @param {boolean} cache Allow cached result
   */
  function Factories(type) {
    var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var cacheKeyResolver = arguments[2];
    (0, _classCallCheck3.default)(this, Factories);

    this.type = type;
    this.factories = new _map2.default();
    this.cache = cache ? new _map2.default() : null;
    this.cacheKeyResolver = cacheKeyResolver;
  }

  /**
   * Register a factory associated with a key
   * @param {string} key The key of factory
   * @param {Function} factory The factory function that returns the object
   */


  (0, _createClass3.default)(Factories, [{
    key: "register",
    value: function register(key, factory) {
      this.factories.set(key, factory);
    }

    /**
     * Determine whether a key has been registered with a factory
     * @param {string} key The factory key
     */

  }, {
    key: "containKey",
    value: function containKey(key) {
      return this.factories.has(key);
    }

    /**
     * Get all defined values in the factories
     */

  }, {
    key: "values",
    value: function values() {
      return [].concat((0, _toConsumableArray3.default)(this.factories.values()));
    }

    /**
     * Unregister a factory associated with a key
     * @param {string} key The factory key
     */

  }, {
    key: "unregister",
    value: function unregister(key) {
      this.factories.delete(key);
      this.cache && this.cache.delete(key);
    }

    /**
     * Reset the factories. All registrations are clean up.
     * This function is mostly used in unit test in order to reset the test data.
     */

  }, {
    key: "reset",
    value: function reset() {
      this.factories.clear();
      this.cache && this.cache.clear();
    }

    /**
     * Create an object by using a keyed factory with passing params
     * @param {string} key The factory key
     * @param {Array<any>} props The factory params
     */

  }, {
    key: "create",
    value: function create(key) {
      ensure(this.factories.has(key), key + " must be defined as a " + this.type);

      for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
      }

      var cacheKey = this.cacheKeyResolver && this.cacheKeyResolver.apply(this, [key].concat(props)) || key;
      if (this.cache && this.cache.has(cacheKey)) {
        return this.cache.get(cacheKey);
      }

      var obj = this.factories.get(key).apply(undefined, [key].concat(props));

      this.cache && this.cache.set(key, obj);

      return obj;
    }
  }]);
  return Factories;
}();

exports.default = Factories;
module.exports = exports["default"];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 205 */,
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      get = _require.get,
      isNil = _require.isNil,
      isPlainObject = _require.isPlainObject,
      omit = _require.omit,
      concat = _require.concat,
      cloneDeep = _require.cloneDeep,
      isArrayLike = _require.isArrayLike,
      isObject = _require.isObject,
      isBoolean = _require.isBoolean;

  var ROLE_EXCLUDED = ['simpleDataSources', 'advancedDataSources', 'isTenantSetup', 'tenantAccess', 'isClickedSection', 'propsCloned', 'section', 'isDirty', 'dataSources'];

  var TENANT_EXCLUDED = ['simpleDataSources', 'advancedDataSources', 'isTenantSetup', 'tenantAccess', 'isClickedSection', 'propsCloned', 'section', 'isDirty', 'tenantSetup', 'dataSources', 'fullReportAndDashboardAccess'];

  var TENANT_ACCESS_EXCLUDE = ['propsCloned', 'tenantSetup', 'categoryAccessibility'];
  /**
   * Get omit keys list by tenant permision, role permission
   * @returns:  {array} list omit key
   */
  var getOmitList = function getOmitList() {
    return isNil(uiState.tenantId) ? ROLE_EXCLUDED : concat(ROLE_EXCLUDED, ['tenantSetup']);
  };

  /**
   * Check tenant permission: return true if tenantPermision or key null.
   * @param: {Object}   tenantPermission
   * @param: {String}   key
   */
  var checkTenantPermissionByKey = function checkTenantPermissionByKey(tenantPermision, key) {
    if (isNil(tenantPermision) || isNil(key)) {
      return true;
    }

    return tenantPermision[key];
  };

  function PermissionDetail(data, isTenantSetup) {
    var props = {
      fullReportAndDashboardAccess: false,
      systemConfiguration: {
        scheduledInstances: {
          value: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      tenantSetup: {
        actions: {
          create: false,
          edit: false,
          del: false,
          tenantAccess: 0
        },
        permissions: {
          value: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      dataSetup: {
        dataModel: {
          value: false,
          tenantAccess: 0,
          customView: {
            create: false,
            edit: false,
            delete: false,
            tenantAccess: 0
          }
        },
        advancedSettings: {
          category: false,
          others: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      userSetup: {
        userRoleAssociation: {
          value: false,
          tenantAccess: 0
        },
        actions: {
          create: false,
          edit: false,
          del: false,
          configureSecurityOptions: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      roleSetup: {
        actions: {
          create: false,
          edit: false,
          del: false,
          tenantAccess: 0
        },
        dataModelAccess: {
          value: false,
          tenantAccess: 0
        },
        permissions: {
          value: false,
          tenantAccess: 0
        },
        grantRoleWithFullReportAndDashboardAccess: {
          value: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      reports: {
        canCreateNewReport: {
          value: false,
          tenantAccess: 0
        },
        dataSources: {
          simpleDataSources: false,
          advancedDataSources: false,
          tenantAccess: 0
        },
        reportPartTypes: {
          chart: false,
          form: false,
          gauge: false,
          map: false,
          tenantAccess: 0
        },
        reportCategoriesSubcategories: {
          canCreateNewCategory: {
            value: false,
            tenantAccess: 0
          },
          categoryAccessibility: {
            categories: m.asFlat([]),
            tenantAccess: 0
          }
        },
        filterProperties: {
          filterLogic: false,
          crossFiltering: false,
          tenantAccess: 0
        },
        fieldProperties: {
          customURL: false,
          embeddedJavaScript: false,
          subreport: false,
          tenantAccess: 0
        },
        actions: {
          schedule: false,
          email: false,
          viewReportHistory: false,
          del: false,
          registerForAlerts: false,
          print: false,
          unarchiveReportVersions: false,
          overwriteExistingReport: false,
          subscribe: false,
          exporting: false,
          configureAccessRights: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      dashboards: {
        canCreateNewDashboard: {
          value: false,
          tenantAccess: 0
        },
        dashboardCategoriesSubcategories: {
          canCreateNewCategory: {
            value: false,
            tenantAccess: 0
          },
          categoryAccessibility: {
            categories: m.asFlat([]),
            tenantAccess: 0
          }
        },
        actions: {
          schedule: false,
          email: false,
          del: false,
          subscribe: false,
          print: false,
          overwriteExistingDashboard: false,
          configureAccessRights: false,
          exporting: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      access: {
        accessLimits: {
          value: m.asFlat([]),
          tenantAccess: 0
        },
        accessDefaults: {
          value: m.asFlat([]),
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      scheduling: {
        schedulingLimits: {
          value: m.asFlat([]),
          tenantAccess: 0
        },
        schedulingScope: {
          systemUsers: false,
          externalUsers: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      emailing: {
        deliveryMethod: {
          link: false,
          embeddedHTML: false,
          attachment: false,
          tenantAccess: 0
        },
        attachmentType: {
          word: false,
          excel: false,
          pdf: false,
          csv: false,
          xml: false,
          json: false,
          definition: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      exporting: {
        exportingFormat: {
          word: false,
          excel: false,
          pdf: false,
          csv: false,
          xml: false,
          json: false,
          queryExecution: false,
          definition: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },
      systemwide: {
        canSeeSystemMessages: {
          value: false,
          tenantAccess: 0
        },
        tenantAccess: 0
      },

      section: null,
      isTenantSetup: isTenantSetup
    };

    this.schedulingLimitsTree = [];
    this.accessLimitsTree = [];
    this.isClickedSection = false;
    this.propsCloned = cloneDeep(props);
    m.extendObservable(trackable(this), props);
    data && this.populateData(data, this.propsCloned, this);
  }

  /**
   * populate data
   * @param {object} data
   */
  PermissionDetail.prototype.populateData = m.action(function (data, props, permissionDetail) {
    for (var key in omit(['section', 'isTenantSetup'], props)) {
      var newData = isNil(data) ? this.propsCloned[key] : data[key];

      if (isPlainObject(props[key])) {
        this.populateData(newData, props[key], permissionDetail[key]);
      } else {
        permissionDetail[key] = !isNil(newData.value) ? newData.value : newData;
      }
    }
    this.resetDirty && this.resetDirty();
  });

  /**
   * Update view section
   * @param {String} section
   */
  PermissionDetail.prototype.updateSection = function (section) {
    this.section = section;
  };

  /**
   * Update tenant access parent
   * @param {object} permission section
   * @param {Boolean} isChecked
   */
  PermissionDetail.prototype.updateTenantAccessParent = m.action(function (permissionSection, isChecked) {
    for (var key in permissionSection) {
      var d = permissionSection[key];

      if (!isArrayLike(d)) {
        if (isObject(d)) {
          this.updateTenantAccessParent(d, isChecked);
        } else if (key === 'tenantAccess') {
          permissionSection.tenantAccess = isChecked ? 1 : 0;
        }
      }
    }

    this.markDirty();
  });

  /**
   * Update report actions schedule
   * @param {Object} permission section
   * @param {Boolean} isChecked
   */
  PermissionDetail.prototype.updateReportActionSchedule = m.action(function (permissionSection, isChecked) {
    this.updateData(permissionSection, 'schedule', isChecked);
    !isChecked && this.updateData(permissionSection, 'registerForAlerts', isChecked);
  });

  /**
   * Update user setup edit
   * @param {Object} permission section
   * @param {Boolean} isChecked
   */

  PermissionDetail.prototype.updateUserSetupEdit = m.action(function (permissionSection, isChecked) {
    this.updateData(permissionSection, 'edit', isChecked);
    !isChecked && this.updateData(permissionSection, 'configureSecurityOptions', isChecked);
  });

  // Custom View settings.
  /**
   * Update tenant access parent for data setup (custom view)
   * @param {object} permission section
   * @param {Boolean} input
   */
  PermissionDetail.prototype.updateTenantAccessParentDataSetup = m.action(function (permissionSection, input) {
    var isChecked = input.target ? input.target.checked : input;
    for (var key in permissionSection) {
      var d = permissionSection[key];

      if (!isArrayLike(d)) {
        if (isObject(d)) {
          this.updateTenantAccessParentDataSetup(d, isChecked);
        } else if (key === 'tenantAccess') {
          permissionSection.tenantAccess = isChecked ? 1 : 0;
        }
      }
    }

    this.markDirty();
  });

  /**
   * Update tenant access parent from Child (Custom View)
   * @param {Object} permissionSection section
   */
  PermissionDetail.prototype.updateTenantAccessParentFromChild = m.action(function (permissionSection) {
    var section = permissionSection;

    if (permissionSection.dataModel.value === false) {
      section = omit('dataModel.customView', permissionSection);
    }

    var tenantAccesses = this.getTenantAccesses(section);
    var hasTenantAccesses = filter(function (tenantAccess) {
      return tenantAccess === 1;
    }, tenantAccesses);

    if (hasTenantAccesses.length === 0) {
      permissionSection.tenantAccess = 0;
    } else if (hasTenantAccesses.length === tenantAccesses.length) {
      permissionSection.tenantAccess = 1;
    } else {
      permissionSection.tenantAccess = 2;
    }
  });

  /**
   * Update tenant access for Data Setup (Custom View)
   * @param {Object} permission section
   * @param {Object} data tenant access
   * @param {Boolean} isChecked
   */
  PermissionDetail.prototype.updateTenantAccessDataModel = m.action(function (permissionSection, data, input) {
    var isChecked = input.target.checked;
    if (!isChecked && permissionSection.dataModel.customView.tenantAccess) {
      permissionSection.dataModel.customView.tenantAccess = 0;
    }
    data.tenantAccess = isChecked ? 1 : 0;
    this.updateTenantAccessParentFromChild(permissionSection);

    this.markDirty();
  });

  /**
   * Update tenant access for Data Setup (Custom View)
   * @param {Object} permission section
   * @param {Object} data tenant access
   * @param {Boolean} isChecked
   */
  PermissionDetail.prototype.updateTenantAccessDataSetup = m.action(function (permissionSection, data, input) {
    var isChecked = input.target.checked;
    data.tenantAccess = isChecked ? 1 : 0;
    this.updateTenantAccessParentFromChild(permissionSection);

    this.markDirty();
  });

  /**
   * Update tenant access for Data Setup (Custom View)
   * @param {Object} permissionSection section
   * @param {Object} data tenant access
   * @param {Boolean} input
   */
  PermissionDetail.prototype.updateTenantAccessCustomView = m.action(function (permissionSection, data, input) {
    var isChecked = input.target.checked;
    data.tenantAccess = isChecked ? 1 : 0;
    if (isChecked) {
      permissionSection.dataModel.tenantAccess = 1;
    }
    this.updateTenantAccessParentFromChild(permissionSection);

    this.markDirty();
  });

  /**
   * Update data for Data Setup property (Custom View)
   * @param {Object} data section
   * @param {Object} value tenant access
   * @param {Boolean} input
   */
  PermissionDetail.prototype.updateDataSetup = m.action(function (data, value, input) {
    data[value] = input.target.checked;
    this.markDirty();
  });

  /**
   * Update data for Data Model property (Custom View)
   * @param {Object} permission section
   * @param {Object} data tenant access
   * @param {Boolean} input
   */
  PermissionDetail.prototype.updateDataModel = m.action(function (permission, value, input) {
    var data = permission.dataModel;
    var isChecked = input.target.checked;
    data[value] = isChecked;
    if (!isChecked) {
      data.customView.tenantAccess = false;
      data.customView.create = false;
      data.customView.delete = false;
      data.customView.edit = false;
    }
    this.updateTenantAccessParentFromChild(permission);

    this.markDirty();
  });

  /**
   * Update tenant access
   * @param {Object} permission section
   * @param {Object} permission tenant access
   * @param {Boolean} isChecked
   */
  PermissionDetail.prototype.updateTenantAccess = m.action(function (permissionSection, data, isChecked) {
    data.tenantAccess = isChecked ? 1 : 0;
    var tenantAccesses = this.getTenantAccesses(permissionSection);
    var hasTenantAccesses = filter(function (ta) {
      return ta === 1;
    }, tenantAccesses);

    if (hasTenantAccesses.length === 0) {
      permissionSection.tenantAccess = 0;
    } else if (hasTenantAccesses.length === tenantAccesses.length) {
      permissionSection.tenantAccess = 1;
    } else {
      permissionSection.tenantAccess = 2;
    }

    this.markDirty();
  });

  /**
   * Get list of tenant access
   * @param {Object} permission section
   * @param {Boolean} isChecked
   * @returns {Object} list of tenant access object
   */
  PermissionDetail.prototype.getTenantAccesses = m.action(function (permissionSection) {
    var tenantAccesses = [];
    var data = omit(['tenantAccess'], permissionSection);

    this.getTenantAccess(data, tenantAccesses);
    return tenantAccesses;
  });

  /**
   * Get tenant access
   * @param {Object} permission section
   * @param {Object} list of tenant access
   */
  PermissionDetail.prototype.getTenantAccess = m.action(function (permissionSection, tenantAccesses) {
    for (var key in permissionSection) {
      var d = permissionSection[key];

      if (isObject(d)) {
        this.getTenantAccess(d, tenantAccesses);
      } else {
        if (key === 'tenantAccess') {
          tenantAccesses.push(d);
        }
      }
    }
  });

  /**
   * Update data for property
   * @param {Object} permission tenant access
   * @param {Object} isChekced
   */
  PermissionDetail.prototype.updateData = m.action(function (data, value, isChecked) {
    data[value] = isChecked;
    this.markDirty();
  });

  /**
   * Update list access default
   * @param {array} list access
   */
  PermissionDetail.prototype.updateAccessDefault = m.action(function (data) {
    this.access.accessDefaults.value = data;
  });

  /**
   * Clean model dirty
   */
  PermissionDetail.prototype.cleanDirty = function () {
    this.resetDirty();
  };

  /**
   * Toggle report data sources
   * @param {Boolean} checked
   */
  PermissionDetail.prototype.toggleReportDataSources = m.action(function (checked) {
    this.reports.dataSources.simpleDataSources = checked;
    this.reports.dataSources.advancedDataSources = !checked;
    this.markDirty();
  });

  /**
   * Update access for all data setup section
   * @param: {Object} section
   * @param: {Object} tenantPermission
   * @param: {Boolean} isChecked
   */
  PermissionDetail.prototype.updateAllRoleSection = m.action('Update all role section', function (section, tenantPermision, isChecked) {
    for (var key in omit(getOmitList(), section)) {
      if (isBoolean(section[key]) && (key === 'fullReportAndDashboardAccess' || checkTenantPermissionByKey(tenantPermision, key))) {
        section[key] = isChecked;
      } else if (isPlainObject(section[key])) {
        this.updateAllRoleSection(section[key], get(key, tenantPermision), isChecked);
      }
    }

    this.markDirty();
  });

  /**
   * check all item in section is check
   * @param  {[type]}  permissionSetion
   * @param  {[type]}  tenantPermisionSection
   * @return {Boolean}
   */
  PermissionDetail.prototype.isAllRoleSectionChecked = function (permissionSetion, tenantPermisionSection) {
    var result = true;

    /**
     * Check all item is checked
     * @param  {Object} section
     * @return {Boolean}
     */
    function checkShow(section, tenantPermision) {
      for (var key in omit(getOmitList(), section)) {
        if (section[key] === false && (checkTenantPermissionByKey(tenantPermision, key) || key === 'fullReportAndDashboardAccess')) {
          result = false;
        } else if (isPlainObject(section[key])) {
          checkShow(section[key], get(key, tenantPermision));
        }
      }
    }

    checkShow(permissionSetion, tenantPermisionSection);
    return result;
  };

  /**
   * check all item in section is check
   * @param  {[type]}  permissionSetion
   * @param  {[type]}  tenantPermisionSection
   * @return {Boolean}
   */
  PermissionDetail.prototype.isAllRoleSectionIndeterminate = function (permissionSetion, tenantPermisionSection) {
    var haveAllPermission = true;
    var hasPermission = false;

    /**
     * Check checkShowIndeterminate
     * @param  {Object} section
     * @return {Boolean}
     */
    function checkShowIndeterminate(section, tenantPermision) {
      for (var key in omit(getOmitList(), section)) {
        if (section[key] === false && (key === 'fullReportAndDashboardAccess' || checkTenantPermissionByKey(tenantPermision, key))) {
          haveAllPermission = false;
        } else if (section[key] === true) {
          hasPermission = true;
        } else if (isPlainObject(section[key])) {
          checkShowIndeterminate(section[key], get(key, tenantPermision));
        }
      }
    }

    checkShowIndeterminate(permissionSetion, tenantPermisionSection);

    return hasPermission === true && haveAllPermission === false;
  };

  /**
   * Update access for all data setup section
   * @param: {Object} section
   * @param: {Boolean} isChecked
   */
  PermissionDetail.prototype.updateAllTenantSection = m.action('Update all tenant section', function (section, isChecked) {
    for (var key in omit(TENANT_EXCLUDED, section)) {
      if (isBoolean(section[key])) {
        section[key] = isChecked;
      } else if (isPlainObject(section[key])) {
        this.updateAllTenantSection(section[key], isChecked);
      }
    }
    section.dataModel && this.updateTenantAccessParentFromChild(section);

    this.markDirty();
  });

  /**
   * check all item in section is check
   * @param  {[type]}  permissionSetion
   * @return {Boolean}
   */
  PermissionDetail.prototype.isAllTenantSectionChecked = function (permissionSetion) {
    var result = true;
    /**
     * Check all item is checked
     * @param  {Object} section
     * @return {Boolean}
     */
    function checkAllItemChecked(section) {
      for (var key in omit(TENANT_EXCLUDED, section)) {
        if (section[key] === false) {
          result = false;
        } else if (isPlainObject(section[key])) {
          checkAllItemChecked(section[key]);
        }
      }
    }

    checkAllItemChecked(permissionSetion);
    return result;
  };

  /**
   * check all item in section is check
   * @param  {[type]}  permissionSetion
   * @return {Boolean}
   */
  PermissionDetail.prototype.isAllTenantSectionIndeterminate = function (permissionSetion) {
    var haveAllPermission = true;
    var hasPermission = false;
    /**
     * Check checkShowIndeterminate
     * @param  {Object} section
     * @return {Boolean}
     */
    function checkShowIndeterminate(section) {
      for (var key in omit(TENANT_EXCLUDED, section)) {
        if (section[key] === false) {
          haveAllPermission = false;
        } else if (section[key] === true) {
          hasPermission = true;
        } else if (isPlainObject(section[key])) {
          checkShowIndeterminate(section[key]);
        }
      }
    }

    checkShowIndeterminate(permissionSetion);

    return hasPermission === true && haveAllPermission === false;
  };

  /**
   * Check is all tenant access have check
   * @param:    {Object}  permissionnSection
   * @returns:  {Boolean} result
   */
  PermissionDetail.prototype.isAllTenantAccessChecked = function (permissionSection) {
    var result = true;
    var section = permissionSection;

    // Remove custom view when data model is not checked
    if (permissionSection.dataSetup.dataModel.value === false) {
      section = omit('dataSetup.dataModel.customView', permissionSection);
    }
    /**
     * Check all tenant access have check
     */
    function checkAllTenantAccessChecked(section) {
      for (var key in omit(TENANT_ACCESS_EXCLUDE, section)) {
        if (key === 'tenantAccess' && (section[key] === 0 || section[key] === 2)) {
          result = false;
        } else if (isPlainObject(section[key])) {
          checkAllTenantAccessChecked(section[key]);
        }
      }
    }

    checkAllTenantAccessChecked(section);

    return result;
  };

  /**
   * Check tenant access is indeterminate
   * @param: {Object}   permissionSection
   * @param: {Boolean}  result
   */
  PermissionDetail.prototype.isAllTenantIndeterminate = function (permissionSection) {
    var haveAllPermission = true;
    var hasAtLeastOnePermission = false;
    var result = false;
    var section = permissionSection;

    // Remove custom view when data model is not checked
    if (permissionSection.dataSetup.dataModel.value === false) {
      section = omit('dataSetup.dataModel.customView', permissionSection);
    }

    function checkAllItemIndeterminate(section) {
      for (var key in omit(TENANT_ACCESS_EXCLUDE, section)) {
        if (result) {
          break;
        }
        if (key === 'tenantAccess' && section[key] === 2) {
          result = true;
          break;
        } else if (key === 'tenantAccess' && section[key] === 1) {
          if (!haveAllPermission) {
            result = true;
            break;
          }
          hasAtLeastOnePermission = true;
        } else if (key === 'tenantAccess' && section[key] === 0) {
          if (hasAtLeastOnePermission) {
            result = true;
            break;
          }
          haveAllPermission = false;
        } else if (isPlainObject(section[key])) {
          checkAllItemIndeterminate(section[key]);
        }
      }
    }

    checkAllItemIndeterminate(section);

    return result;
  };

  /**
   * Update all tenant access
   * @param: {Object}   section
   * @param: {Boolean}  isChecked
   */
  PermissionDetail.prototype.updateAllTenantAccess = m.action('updateAllTenantAccess', function (section, isChecked) {
    var value = isChecked ? 1 : 0;

    for (var key in omit(['propsCloned'], section)) {
      if (key === 'tenantAccess') {
        section[key] = value;
      } else if (isPlainObject(section[key])) {
        this.updateAllTenantAccess(section[key], isChecked);
      }
    }

    this.markDirty();
  });

  PermissionDetail.prototype.updateFullReportAndDashBoardAccess = m.action('updateFullReportAndDashBoardAccess', function (isChecked) {
    this.updateData(this, 'fullReportAndDashboardAccess', isChecked);
    var updateAllFunction = this.isTenantSetup ? this.updateAllTenantSection : this.updateAllRoleSection;

    // Select all Report selection
    updateAllFunction.call(this, get('reports', this), this, isChecked);
    // Select all Dashboard section
    updateAllFunction.call(this, get('dashboards', this), this, isChecked);
    // Select all Exporting section
    updateAllFunction.call(this, get('exporting', this), this, isChecked);
    // Select all Emailing section
    updateAllFunction.call(this, get('emailing', this), this, isChecked);
  });

  module.exports = PermissionDetail;
}();

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.LoadingManager.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * LoadingManager
 */
!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      size = _require.size,
      findIndex = _require.findIndex,
      nth = _require.nth,
      forEach = _require.forEach,
      getOr = _require.getOr,
      reduce = _require.reduce,
      invoke = _require.invoke,
      concat = _require.concat,
      map = _require.map,
      curry = _require.curry,
      last = _require.last,
      has = _require.has,
      head = _require.head,
      tail = _require.tail,
      keys = _require.keys,
      get = _require.get;

  // save all loading instance and fetchings which are linked to loading instance


  var loadingItems = [];

  // save fetchings which do not link to any loading instance (global loading)
  var anonymousFetching = {
    fetchingPromise: [],
    loadingConfig: m.observable({
      allowToCancel: null
    })
  };

  /**
   * Add loading instance >> a loading-indicate will be showed
   * @param {PageService} loadingInstance
   */
  function addLoadingWatcher(loadingInstance) {
    var foundIndex = findLoadingIndex(loadingInstance);

    if (foundIndex >= 0) {
      throw new Error('loading instance is watched');
    }

    loadingItems.push({
      instance: loadingInstance,
      fetchingPromise: [],
      loadingConfig: m.observable({
        allowToCancel: null
      })
    });
  }

  /**
   * Remove loading instance >> a loading-indicate will be destroyed
   * @param  {PageService} loadingInstance
   * @return {undefined}
   */
  function removeLoadingWatcher(loadingInstance) {
    var foundIndex = findLoadingIndex(loadingInstance);

    if (foundIndex < 0) {
      throw new Error('loading instance is not added');
    }

    if (!size(loadingItems[foundIndex].fetchingPromise)) {
      anonymousFetching.fetchingPromise = [];
      anonymousFetching.loadingConfig.allowToCancel = null;
    }

    loadingItems.splice(foundIndex, 1);
  }

  /**
   * find loading instance and return its index
   * @param  {PageService} loadingInstance
   * @return {number}
   */
  function findLoadingIndex(loadingInstance) {
    // use function instead of object to prevent lodash use isEqual
    return findIndex(function (item) {
      return item.instance === loadingInstance;
    }, loadingItems);
  }

  /**
   * find loading instance and return its info (if any)
   * @param  {PageService} loadingInstance
   * @return {object}
   */
  function findLoadingInfo(loadingInstance) {
    var index = findLoadingIndex(loadingInstance);
    return index < 0 ? null : nth(index, loadingItems);
  }

  /**
   * Loading-indicator is cancelled
   * Reject all fetchings link to cancelled-loading
   * If dont have any fechings link to cancelled-loading, reject all fetchings in anonymousFetching
   * @param  {PageService} loadingInstance
   * @return {undefined}
   */
  function rejectLoading(loadingInstance) {
    var foundIndex = findLoadingIndex(loadingInstance);

    if (foundIndex < 0) {
      // reject all watched-loading
      forEach(reject, loadingItems);
    }

    var found = nth(foundIndex, loadingItems);

    reject(found);

    function reject(loadingItem) {
      // that loading item do not have fetching promise >> reject the anonymous fetching
      if (!size(loadingItem.fetchingPromise)) {
        loadingItem = anonymousFetching;
      }

      var promises = loadingItem.fetchingPromise;

      // reject promise
      forEach(function (promise) {
        invoke('cancel', promise);
      }, promises);

      // remove rejected-promise
      promises.splice(0, promises.length);

      // reset config to default values
      loadingItem.loadingConfig.allowToCancel = null;
    }
  }

  /**
   * Check loading instance is showed or not
   * @param  {PageService} loadingInstance
   * @return {boolean}
   */
  function checkShowLoading(loadingInstance) {
    var found = findLoadingIndex(loadingInstance);

    if (found < 0) {
      return reduce(function (re, loading) {
        return re || isShow(loading);
      }, false, loadingItems);
    }

    return isShow(nth(found, loadingItems));

    function isShow(loading) {
      return !!getOr(0, 'loadingCounter', loading.instance);
    }
  }

  /**
   * check whether to cancel loading
   * @param  {PageService} loadingInstance
   * @return {boolean}
   */
  function allowToCancelProgress(loadingInstance) {
    var index = findLoadingIndex(loadingInstance);

    if (index < 0) {
      return false;
    }

    var found = nth(index, loadingItems);
    var sizeItemFetching = size(found.fetchingPromise);
    var sizeAnonymousFetching = size(anonymousFetching.fetchingPromise);

    var allowCancelItemFetching = allowToCancel(found);
    var allowCancelAnonymous = allowToCancel(anonymousFetching);

    if (sizeItemFetching > 0) {
      return allowCancelItemFetching;
    } else {
      return allowCancelAnonymous;
    }

    function allowToCancel(loading) {
      return getOr(false, 'allowToCancel', loading.loadingConfig);
    }
  }

  /**
   * isLoadingInstance description]
   * @param  {[type]}  loader [description]
   * @return {Boolean}        [description]
   */
  function isLoadingInstance(loader) {
    return has('loadingCounter', loader) && has('notifyLoadingChanged', loader);
  }

  /**
   * attach loading watcher
   * @return {Function}
   */
  function attachLoadingWatcher() {
    var args = arguments;
    var numArgs = size(args);
    var loadingDataFn = last(args);
    var loadingInfo = {};

    var fetchersCollection = [];
    var i = 0;
    for (i; i < numArgs - 1; i++) {
      fetchersCollection.push(args[i]);
    }

    return function () {
      var loadingInstance = head(arguments);
      var i = 0;

      if (!isLoadingInstance(loadingInstance)) {
        return loadingDataFn.apply(this, concat([null], fetchersCollection)).apply(this, arguments);
      }

      // build fetchers link to to loader
      var linkedLoaderFetchersColllection = map(curry(attachWacher)(loadingInstance), fetchersCollection);
      return loadingDataFn.apply(null, concat([loadingInstance], linkedLoaderFetchersColllection)).apply(this, tail(arguments));
    };

    function attachWacher(loadingInstance, fetchers) {
      var fetcherNames = keys(fetchers);

      var newFetchers = {};

      forEach(function (fetcherName) {
        newFetchers[fetcherName] = function () {
          return fetchers[fetcherName].apply(fetchers, concat(loadingInstance, arguments));
        };
      }, fetcherNames);
      return newFetchers;
    }
  }

  /**
   * attach loading ưatchers
   * @param  {Object} fetchers
   * @param  {Object} config
   * @return {Object}
   */
  function attachLoadingWatchers(fetchers, config) {
    var fetcherNames = keys(fetchers);
    var sourceFetchers = fetchers;

    forEach(curry(addWatcher)(sourceFetchers), fetcherNames);

    return sourceFetchers;

    function addWatcher(source, name) {
      var oldFetcher = fetchers[name].bind(fetchers);

      source[name] = function () {
        var loadingInstance, loadingInfo, args;

        loadingInstance = head(arguments);

        if (isLoadingInstance(loadingInstance)) {
          loadingInfo = findLoadingInfo(loadingInstance);
          args = tail(arguments);
        } else {
          loadingInfo = anonymousFetching;
          args = arguments;
        }

        var isShowLoading = checkShowLoading(loadingInstance);

        if (!isShowLoading) {
          return oldFetcher.apply(null, args);
        }

        // if global loading is showed
        var loadingPromise = createFakePromise(oldFetcher, get(name, config), args);

        loadingInfo.fetchingPromise.push(loadingPromise);

        if (loadingInfo.loadingConfig.allowToCancel !== false) {
          // hack - to prevent observable value is changed while its is used to render UI
          setTimeout(function () {
            loadingInfo.loadingConfig.allowToCancel = getOr(true, 'allowToCancel', get(name, config));
          }, 0);
        }

        return loadingPromise;
      };
    }

    function createFakePromise(fnFetchingData, config, args) {
      var fakePromise = new _bluebird2.default(function (resolve) {
        resolve(fnFetchingData.apply(null, args));
      });

      return fakePromise;
    }
  }

  module.exports = {
    // for fetcher & store
    linkToLoadingProgress: attachLoadingWatchers,
    addLoadingProgress: attachLoadingWatcher,

    // for loading progress
    addLoadingWatcher: addLoadingWatcher,
    removeLoadingWatcher: removeLoadingWatcher,
    cancelLoading: rejectLoading,
    allowToCancelGlobalProgress: allowToCancelProgress
  };
}();

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SizeDetector.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  // Keep single on element resize detector in the whole application.
  var elementResizeDetector = __webpack_require__(1405)({ callOnAdd: false });

  module.exports = elementResizeDetector;
}();

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.NotFound.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
function NotFound() {
  return _react2.default.createElement(
    'h3',
    null,
    _Izenda2.default.getText('NOT_FOUND_PAGE')
  );
}
module.exports = exports['default'];

/***/ }),
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimeConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  Keys: {
    ENTER: 13,
    ESC: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
  },
  Units: {
    YEAR: 'years',
    MONTH: 'months',
    DAY: 'days',
    HOUR: 'hours'
  },
  Types: {
    JS_DATE: 'JS_DATE',
    MOMENT: 'MOMENT',
    ISO: 'ISO',
    STRING: 'STRING',
    TIME: 'TIME'
  },
  Levels: {
    years: {
      up: null,
      down: 'months',
      nav: {
        unit: 'years',
        span: 10
      },
      key: {
        unit: 'year',
        span: 1
      }
    },
    months: {
      up: 'years',
      down: 'days',
      nav: {
        unit: 'year',
        span: 1
      },
      key: {
        unit: 'month',
        span: 1
      }
    },
    days: {
      up: 'months',
      down: null,
      nav: {
        unit: 'month',
        span: 1
      },
      key: {
        unit: 'day',
        span: 1
      }
    },
    hours: {
      up: null,
      down: null,
      key: {
        unit: 'minutes',
        span: 30
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _class3, _class4, _temp3; // ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoading.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Izenda = __webpack_require__(1806);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobxReact = __webpack_require__(10);

var _Izenda5 = __webpack_require__(262);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda7 = __webpack_require__(1807);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(351);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyLoading = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LazyLoading, _Component);

  function LazyLoading(props) {
    (0, _classCallCheck3.default)(this, LazyLoading);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LazyLoading.__proto__ || (0, _getPrototypeOf2.default)(LazyLoading)).call(this, props));

    _this.onScroll = function () {
      _this.loadVirtualNode();
    };

    _this.loadVirtualNode = function () {
      var store = _this.store;
      var node = store.getVirtualNode(_this.scrollParent);
      if (!(0, _fp.isNil)(node)) {
        store.showLoading();
        store.setRenderingNode(node);
        _this.getData(node);
      } else {
        _this.endLoading();
      }
    };

    _this.setDom = function (dom) {
      dom && (_this.scrollParent = _Izenda6.default.findScrollableParent(dom));
    };

    _this.store = new _Izenda2.default(props);
    return _this;
  }

  (0, _createClass3.default)(LazyLoading, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.registerLazyLoadingStore();
      this.addEvent();

      if (this.store.training) {
        this.setViewHeight();
        this.getData();
      } else {
        this.endLoading();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvent();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var data = _ref.data,
          isLastPage = _ref.isLastPage;

      this.store.updateData(data, isLastPage);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _store = this.store,
          isLoading = _store.isLoading,
          isLastPage = _store.isLastPage;

      this.store.removeVirtualNode();
      !isLoading && this.loadVirtualNode();
      isLastPage && this.endLoading();
    }
  }, {
    key: 'endLoading',
    value: function endLoading() {
      this.props.loader && this.props.loader.endLoading();
    }
  }, {
    key: 'registerLazyLoadingStore',
    value: function registerLazyLoadingStore() {
      (0, _fp.invokeArgs)('registerLazyLoadingStore', [this.store], this.props);
    }
  }, {
    key: 'setViewHeight',
    value: function setViewHeight() {
      var viewHeight = this.props.viewHeight;

      if (viewHeight) {
        this.store.setViewHeight(viewHeight);
      } else {
        // don't use clientHeight here, because we use custom scroll bar.
        var calViewHeight = (0, _fp.isNil)(this.scrollParent) ? 0 : this.scrollParent.offsetHeight - this.getScrollbarWidth();
        this.store.setViewHeight(calViewHeight);
      }
    }
  }, {
    key: 'getScrollbarWidth',
    value: function getScrollbarWidth() {
      var scrollbarWidth = 0;

      if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        div.className = 'izenda-ScrollBox-WidthMeasure';
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
      }

      return scrollbarWidth;
    }
  }, {
    key: 'getData',
    value: function getData(node) {
      var getData = this.props.getData;

      getData(this.store.getPageInfo(node));
    }
  }, {
    key: 'addEvent',
    value: function addEvent() {
      this.scrollParent && this.scrollParent.addEventListener('scroll', this.loadVirtualNode, {
        capture: false,
        passive: true
      });
    }
  }, {
    key: 'removeEvent',
    value: function removeEvent() {
      this.scrollParent && this.scrollParent.removeEventListener('scroll', this.loadVirtualNode, {
        capture: false,
        passive: true
      });
    }
  }, {
    key: 'renderLazyLoadingItemList',
    value: function renderLazyLoadingItemList() {
      var _this2 = this;

      var store = this.store;
      var _props = this.props,
          renderItem = _props.renderItem,
          itemClassName = _props.itemClassName,
          itemKey = _props.itemKey;

      var items = store.getItemsOnViewScreen;
      store.resetVirtualNodes();

      if (!(0, _fp.isEmpty)(items)) {
        return (0, _fp.map)(function (item) {
          if ((0, _fp.get)('data.source.isVirtualNode', item)) {
            store.virtualNodes.push(item.data.source);
            return _react2.default.createElement(_Izenda8.default, { key: item.key, store: store, source: item.data.source, className: itemClassName });
          } else if ((0, _fp.get)('isVirtualNode', item)) {
            store.virtualNodes.push(item);
            return _react2.default.createElement(_Izenda8.default, { key: item.id, store: store, source: item, className: itemClassName });
          } else {
            return _react2.default.createElement(
              LazyLoadingItem,
              {
                store: store,
                getData: _this2.getData,
                className: itemClassName,
                key: item[itemKey],
                item: item
              },
              renderItem(item, store.pageSize, _this2.loadVirtualNode)
            );
          }
        }, items);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { ref: this.setDom, className: (0, _classnames2.default)('izenda-LazyLoading', this.props.className) },
        this.renderLazyLoadingItemList(),
        _react2.default.createElement(_Izenda10.default, { store: this.store, className: 'u_inlineBlock u_fullWidth' })
      );
    }
  }]);
  return LazyLoading;
}(_react.Component), _class2.propTypes = {
  data: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  defaultItemsNumber: _react.PropTypes.number,
  viewHeight: _react.PropTypes.number,
  itemHeight: _react.PropTypes.number,
  getData: _react.PropTypes.func.isRequired,
  isLastPage: _react.PropTypes.bool.isRequired,
  registerLazyLoadingStore: _react.PropTypes.func
}, _class2.defaultProps = {
  itemKey: 'key'
}, _temp)) || _class;

exports.default = LazyLoading;

var LazyLoadingItem = (0, _mobxReact.observer)(_class3 = (_temp3 = _class4 = function (_Component2) {
  (0, _inherits3.default)(LazyLoadingItem, _Component2);

  function LazyLoadingItem() {
    var _ref2;

    var _temp2, _this3, _ret;

    (0, _classCallCheck3.default)(this, LazyLoadingItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = LazyLoadingItem.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadingItem)).call.apply(_ref2, [this].concat(args))), _this3), _this3.setDom = function (dom) {
      _this3.itemDom = dom;
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(LazyLoadingItem, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.item !== this.props.item;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var itemDom = _reactDom2.default.findDOMNode(this.itemDom);
      var store = this.props.store;

      if (store.training) {
        store.setItemHeight(itemDom.offsetHeight);
        store.training = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { ref: this.setDom, className: (0, _classnames2.default)('izenda-LazyLoadingItem', this.props.className) },
        this.props.children
      );
    }
  }]);
  return LazyLoadingItem;
}(_react.Component), _class4.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp3)) || _class3;

module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = __webpack_require__(651);

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _highcharts = __webpack_require__(238);

var _highcharts2 = _interopRequireDefault(_highcharts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFormatString = function isFormatString(value) {
  return (/\{(.*)\}/.test(value)
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.JsFormatService.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var JsFormatService = function () {
  function JsFormatService() {
    (0, _classCallCheck3.default)(this, JsFormatService);
    this.jsFormats = new _map2.default();
    this.jsFormatStringList = new _map2.default();
  }

  (0, _createClass3.default)(JsFormatService, [{
    key: 'addJsFormat',


    /**
     * Add a JS format function associated with a format string name
     */
    value: function addJsFormat(formatName, formatFn) {
      this.jsFormats.set(formatName, formatFn);
    }
  }, {
    key: 'removeJsFormat',
    value: function removeJsFormat(formatName) {
      this.jsFormats.delete(formatName);
    }

    /**
     * Add a JS js format string associated with a format string name
     */

  }, {
    key: 'registerJsFormatString',
    value: function registerJsFormatString(formatName, formatString) {
      this.jsFormatStringList.set(formatName, formatString);
    }
  }, {
    key: 'removeJsFormatString',
    value: function removeJsFormatString(formatName) {
      this.jsFormatStringList.delete(formatName);
    }
  }, {
    key: 'format',
    value: function format(formatName, value) {
      var originalValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var jsFormatString = this.jsFormatStringList.get(formatName);

      if (isFormatString(jsFormatString)) {
        return _highcharts2.default.format(jsFormatString, { value: value });
      }

      var formatFn = this.jsFormats.get(jsFormatString);
      if (!formatFn) return originalValue ? originalValue : value;

      return formatFn(value);
    }
  }]);
  return JsFormatService;
}();

exports.default = new JsFormatService();
module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(64);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(33);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGaugeConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FUNCTION = _Izenda4.default.FUNCTION;
var FORMAT_KEY = _Izenda4.default.FORMAT_KEY;

var CHART_TYPES = [{
  get label() {
    return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_LINEAR_GAUGE');
  },
  value: _Izenda5.CHART_TYPE.LinearGauge,
  className: 'gauge-linear'
}, {
  get label() {
    return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_SIMPLE_GAUGE');
  },
  value: _Izenda5.CHART_TYPE.SimpleGauge,
  className: 'gauge-simple'
}, {
  get label() {
    return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_SOLID_GAUGE');
  },
  value: _Izenda5.CHART_TYPE.SolidGauge,
  className: 'gauge-solid'
}];

/* Container which defined fields to get data */
var ContainerName = {
  LABELS: 'labels',
  VALUES: 'values',
  SEPARATORS: 'separators',
  THRESHOLD: 'threshold',
  SUP_KPI: 'sup_kpi',
  DRILLDOWN: 'labels', // labels
  METRIC_DROPDOWN: 'values' // values
};

/* Default function for each fields based on its container */
var DefaultFunction = {};

// SOLID GAUGE
DefaultFunction[_Izenda5.CHART_TYPE.SolidGauge] = {};

// SOLID GAUGE -  labels container
DefaultFunction[_Izenda5.CHART_TYPE.SolidGauge][ContainerName.LABELS] = {
  Datetime: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.YEAR
  },
  Time: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.DEFAULT_TIME
  },

  Others: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.NONE
  }
};

// SOLID GAUGE -  values container
DefaultFunction[_Izenda5.CHART_TYPE.SolidGauge][ContainerName.VALUES] = {
  Numeric: {
    FUNCTION: FUNCTION.SUM,
    FORMAT: FORMAT_KEY.NONE
  },

  Money: {
    FUNCTION: FUNCTION.SUM,
    FORMAT: FORMAT_KEY.NONE
  },

  Others: {
    FUNCTION: FUNCTION.COUNT,
    FORMAT: FORMAT_KEY.NONE
  }
};

// SOLID GAUGE -  separators container (same as labels)
DefaultFunction[_Izenda5.CHART_TYPE.SolidGauge][ContainerName.SEPARATORS] = DefaultFunction[_Izenda5.CHART_TYPE.SolidGauge][ContainerName.LABELS];

// SOLID GAUGE -  threshold container (same as values)
DefaultFunction[_Izenda5.CHART_TYPE.SolidGauge][ContainerName.THRESHOLD] = DefaultFunction[_Izenda5.CHART_TYPE.SolidGauge][ContainerName.VALUES];

// LINEAR (same as solid gauge)
DefaultFunction[_Izenda5.CHART_TYPE.LinearGauge] = DefaultFunction[_Izenda5.CHART_TYPE.SolidGauge];

// SIMPLE (same as solid/linear gauge and has supplementary KPI)
DefaultFunction[_Izenda5.CHART_TYPE.SimpleGauge] = DefaultFunction[_Izenda5.CHART_TYPE.SolidGauge];
DefaultFunction[_Izenda5.CHART_TYPE.SimpleGauge][ContainerName.SUP_KPI] = DefaultFunction[_Izenda5.CHART_TYPE.LinearGauge][ContainerName.VALUES];

/* Maximum number of fields for each container */
var MaximumField = {};

// Solid
MaximumField[_Izenda5.CHART_TYPE.SolidGauge] = {};
// MaximumField[CHART_TYPE.SolidGauge][ContainerName.VALUES] = 5;
MaximumField[_Izenda5.CHART_TYPE.SolidGauge][ContainerName.SEPARATORS] = 1;
MaximumField[_Izenda5.CHART_TYPE.SolidGauge][ContainerName.THRESHOLD] = 1;

// Linear (same as solid)
MaximumField[_Izenda5.CHART_TYPE.LinearGauge] = MaximumField[_Izenda5.CHART_TYPE.SolidGauge];

// Simple (same as solid/linear and has supplementary KPI)
MaximumField[_Izenda5.CHART_TYPE.SimpleGauge] = MaximumField[_Izenda5.CHART_TYPE.SolidGauge];
MaximumField[_Izenda5.CHART_TYPE.SimpleGauge][ContainerName.SUP_KPI] = 1;

/* Messages */
var Message = {
  get M01() {
    return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_MESSAGE_LOW_VALUE_MUST_LESS_THAN_HIGH_VALUE');
  },
  get M02() {
    return _Izenda2.default.getText('GAUGE_MESSAGE_THRESHOL_NUMBER');
  },
  get M04() {
    return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_MESSAGE_THRESHOLDS_MUST_BE_WITHIN_SCALE_FORM_SCALE_TO');
  },
  get M05() {
    return _Izenda2.default.getText('COMMON_MESSAGES_MUST_BE_FUNCTION');
  },
  get M06() {
    return _Izenda2.default.getText('GAUGE_MESSAGE_SCALE_RANGE');
  },
  get M07() {
    return _Izenda2.default.getText('GAUGE_MESSAGE_THRESHOLD_MAX_VALUE');
  },
  get M08() {
    return _Izenda2.default.getText('GAUGE_MESSAGE_THRESHOLD_MIN_VALUE');
  }
};

/* Setting value: for threshold & supplementary KPI */
var SETTING_VALUES = {
  STATIC: {
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_STATIC');
    },
    value: 'static'
  },
  DYNAMIC: {
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_DYNAMIC');
    },
    value: 'dynamic'
  }
};

var THRESHOLD_SETTINGS = SETTING_VALUES;

var THRESHOLD_OPERATORS = {
  LESS_THAN: {
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_LESS_THAN');
    },
    value: 'less than'
  },
  BETWEEN: {
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_BETWEEN');
    },
    value: 'between'
  },
  GREAT_THAN: {
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_GREATER_THAN');
    },
    value: 'greater than'
  }
};

var THRESHOLD_VALUES = {
  LOW: {
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_LOW');
    },
    value: 'low',
    defautColor: '#55BF3B',
    defautOperator: THRESHOLD_OPERATORS.LESS_THAN.value
  },
  TARGET: {
    get label() {
      return _Izenda2.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_TARGET');
    },
    value: 'target',
    defautColor: '#DDDF0D',
    defautOperator: THRESHOLD_OPERATORS.LESS_THAN.value
  },
  HIGH: {
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_HIGH');
    },
    value: 'high',
    defautColor: '#DF5353',
    defautOperator: THRESHOLD_OPERATORS.GREAT_THAN.value
  }
};

var SUPP_SETTINGS = SETTING_VALUES;

exports.default = {
  ContainerName: ContainerName,
  MaximumField: MaximumField,
  Message: Message,
  DefaultFunction: DefaultFunction,
  DefaultChartType: _Izenda5.CHART_TYPE.SolidGauge,
  CHART_TYPES: CHART_TYPES,
  SETTING_VALUES: SETTING_VALUES,
  THRESHOLD_SETTINGS: THRESHOLD_SETTINGS,
  THRESHOLD_OPERATORS: THRESHOLD_OPERATORS,
  THRESHOLD_VALUES: THRESHOLD_VALUES,

  SUPP_SETTINGS: SUPP_SETTINGS,

  ITEM_PER_ROWS: 3,

  getOptions: function getOptions(key) {
    var data = this[key] || {};

    return (0, _fp.values)(data);
  },

  DEFAULT_SETTING_VALUE: {
    borderDefault: {
      'izEntire.borderColor': '#000',
      'izEntire.borderWidth': undefined,
      'izEntire.borderStyle': 'solid'
    },
    borderNew: {
      'izEntire.borderColor': undefined,
      'izEntire.borderWidth': undefined,
      'izEntire.borderStyle': undefined
    },
    refreshIntervalDefault: {
      enable: false,
      isAll: true,
      latestRecord: 0,
      updateInterval: 0
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.PrintConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var PAGE_SIZES = {
  A0: {
    widthInInches: 33.1,
    heightInInches: 46.8
  },
  A1: {
    widthInInches: 23.4,
    heightInInches: 33.1
  },
  A2: {
    widthInInches: 16.5,
    heightInInches: 23.4
  },
  A3: {
    widthInInches: 11.7,
    heightInInches: 16.5
  },
  A4: {
    widthInInches: 8.25,
    heightInInches: 11.69
  },
  A5: {
    widthInInches: 5.8,
    heightInInches: 8.3
  }
};

var ORIENTATION = {
  PORTRAIT: 0,
  LANDSCAPE: 1
};

var DEFAULT_PAGE_SIZE_KEY = 'A4';
var HEADER_HEIGHT = 3.12; // 300px
var MIN_SIZE_UI_SETTING = 0.02; // in inches

exports.default = {
  PAGE_SIZES: PAGE_SIZES,
  DEFAULT_PAGE_SIZE_KEY: DEFAULT_PAGE_SIZE_KEY,
  MIN_SIZE_UI_SETTING: MIN_SIZE_UI_SETTING,

  /**
   * Calculate size of content (in inches)
   * @param  {String} pageSizeKey
   * @param  {Object} pageMargins
   * @param  {Number} headerMargin
   * @param  {Number} footerMargin
   * @param  {String} orientation
   */
  getContentSizeInInches: function getContentSizeInInches(pageSizeKey, pageMargins, headerHeightInInches, footerHeightInInches, orientation) {
    var pageSize = PAGE_SIZES[pageSizeKey];
    if (!pageSize) return null;

    var widthOfPrintPageInInches = void 0;
    var heightOfPrintPageInInches = void 0;
    if (!orientation || orientation === ORIENTATION.PORTRAIT) {
      widthOfPrintPageInInches = pageSize.widthInInches;
      heightOfPrintPageInInches = pageSize.heightInInches;
    } else {
      widthOfPrintPageInInches = pageSize.heightInInches;
      heightOfPrintPageInInches = pageSize.widthInInches;
    }

    var widthOfContentInInches = widthOfPrintPageInInches;
    var heightOfContentInInches = heightOfPrintPageInInches;

    return {
      widthOfContentInInches: widthOfContentInInches,
      heightOfContentInInches: heightOfContentInInches
    };
  },


  /**
   * Calculate size of content (in inches)
   * @param  {String} pageSizeKey
   * @param  {Object} pageMargins
   * @param  {Number} headerMargin
   * @param  {Number} footerMargin
   * @param  {String} orientation
   */
  getBodyContentSizeInInches: function getBodyContentSizeInInches(pageSizeKey, pageMargins, headerHeightInInches, footerHeightInInches, orientation) {
    var pageSize = PAGE_SIZES[pageSizeKey];
    if (!pageSize) return null;

    var widthOfPrintPageInInches = void 0;
    var heightOfPrintPageInInches = void 0;
    if (!orientation || orientation === ORIENTATION.PORTRAIT) {
      widthOfPrintPageInInches = pageSize.widthInInches;
      heightOfPrintPageInInches = pageSize.heightInInches;
    } else {
      widthOfPrintPageInInches = pageSize.heightInInches;
      heightOfPrintPageInInches = pageSize.widthInInches;
    }

    var widthOfContentInInches = widthOfPrintPageInInches - (pageMargins.left + pageMargins.right);
    var heightOfContentInInches = heightOfPrintPageInInches - (pageMargins.top + pageMargins.bottom + headerHeightInInches + footerHeightInInches);

    return {
      widthOfContentInInches: widthOfContentInInches,
      heightOfContentInInches: heightOfContentInInches
    };
  },


  /**
   * Format CSS value in inches string.
   * @param  {Number} value
   */
  formatCSSValueInInches: function formatCSSValueInInches(value, isFirstReportPart) {
    return value + 'in';
  },


  /**
   * get container height in inches string.
   * @param  {Number} value
   */
  getContainerHeight: function getContainerHeight(height, isFirstReportPart) {
    var value = isFirstReportPart ? height - HEADER_HEIGHT : height;
    return value + 'in';
  },


  /**
   * Format CSS value in percent string.
   * @param  {Number} value
   */
  formatCSSValueInPercent: function formatCSSValueInPercent(value) {
    return value + '%';
  },
  getPageSize: function getPageSize(pageSizeKey, orientation) {
    var widthOfPrintPageInInches = void 0;
    var heightOfPrintPageInInches = void 0;

    pageSizeKey = pageSizeKey || DEFAULT_PAGE_SIZE_KEY;
    var pageSize = PAGE_SIZES[pageSizeKey];

    if (!orientation || orientation === ORIENTATION.PORTRAIT) {
      widthOfPrintPageInInches = pageSize.widthInInches;
      heightOfPrintPageInInches = pageSize.heightInInches;
    } else {
      widthOfPrintPageInInches = pageSize.heightInInches;
      heightOfPrintPageInInches = pageSize.widthInInches;
    }

    return {
      widthInInches: widthOfPrintPageInInches,
      heightInInches: heightOfPrintPageInInches
    };
  }
};
module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.setValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  'use strict';

  var _require = __webpack_require__(1),
      isUndefined = _require.isUndefined;

  module.exports = function (obj, path, value) {
    return obj && !isUndefined(value) && (obj[path] = value);
  };
}();

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportTitle.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(1903);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(53);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda4 = __webpack_require__(2);

var _Izenda5 = _interopRequireDefault(_Izenda4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartTitle = (_dec = (0, _Izenda5.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartTitle, _Component);

  function ReportPartTitle() {
    (0, _classCallCheck3.default)(this, ReportPartTitle);
    return (0, _possibleConstructorReturn3.default)(this, (ReportPartTitle.__proto__ || (0, _getPrototypeOf2.default)(ReportPartTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportPartTitle, [{
    key: 'renderConfig',
    value: function renderConfig() {
      var reportPart = this.props.reportPart;
      var localization = this.props.localization;
      var classes = (0, _classnames2.default)(this.props.className, 'report-part-title');

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(_Izenda2.default, {
          reportPart: reportPart,
          dataKey: 'previewTitle',
          title: localization.getText('REPORTDESIGNER_LABEL_TITLE_SETTINGS')
        }),
        _react2.default.createElement(_Izenda2.default, {
          reportPart: reportPart,
          dataKey: 'description',
          title: localization.getText('REPORTDESIGNER_LABEL_DESCRIPTION_SETTINGS')
        })
      );
    }
  }, {
    key: 'renderPreview',
    value: function renderPreview() {
      var reportPart = this.props.reportPart;
      var title = getStyle('previewTitle');
      var description = getStyle('description');
      var classes = (0, _classnames2.default)(this.props.className, 'u_textBreak');

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { style: title.gridStyle },
          _react2.default.createElement(
            'span',
            { style: title.spanStyle },
            getHeaderInfo('previewTitle')
          )
        ),
        _react2.default.createElement(
          'div',
          { style: description.gridStyle },
          _react2.default.createElement(
            'span',
            { style: description.spanStyle },
            getHeaderInfo('description')
          )
        )
      );

      function getHeaderInfo(key) {
        var re = reportPart.getDataValueByKey && reportPart.getDataValueByKey(key);
        return re && re.text;
      }

      function getStyle(key) {
        var settings = reportPart[key] && reportPart[key].settings || {};
        var font = settings.font || {};
        var alignment = settings.alignment && settings.alignment.alignment;

        var style = {
          fontFamily: font.family,
          fontSize: font.size + 'px',
          fontWeight: font.bold ? 'bold' : 'normal',
          textAlign: alignment || 'none',
          textDecoration: font.underline ? 'underline' : 'none',
          fontStyle: font.italic ? 'italic' : 'normal',
          color: font.color
        };

        return {
          gridStyle: style,
          spanStyle: {
            backgroundColor: font.highlightColor
          }
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.mode === _Izenda3.REPORT_PART_MODE.CONFIG ? this.renderConfig() : this.renderPreview();
    }
  }]);
  return ReportPartTitle;
}(_react.Component), _class2.propTypes = {
  mode: _react.PropTypes.oneOf([_Izenda3.REPORT_PART_MODE.CONFIG, _Izenda3.REPORT_PART_MODE.PREVIEW]),
  reportPart: _react.PropTypes.object
}, _temp)) || _class);
exports.default = ReportPartTitle;
module.exports = exports['default'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/**
 * Report utilities
 */

!function () {
  var CONSTANTS = __webpack_require__(39);
  var fetcher = __webpack_require__(111);

  var _require = __webpack_require__(1),
      contains = _require.contains,
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      isNil = _require.isNil,
      get = _require.get,
      placeholder = _require.placeholder;

  /**
   * Get dirty report part elements.
   * This method is used for trackable.
   */


  var dirtyReportPartElementField = function dirtyReportPartElementField(elements) {
    var dirtyElements = placeholder(elements).chain().flatMap(function (item) {
      return item.elements ? item.elements.peek() : [];
    }).filter(function (element) {
      return element.checkDirty && element.checkDirty();
    }).value();

    return dirtyElements;
  };

  /**
   * Return list field has data type countable
   * @param  {[array]} listElement
   * @return {[array]}
   */
  var getCountableElements = function getCountableElements(listElement) {
    return filter(function (item) {
      return contains(item.previewDataType, CONSTANTS.LIST_COUNTABLE_DATA_TYPE);
    }, listElement);
  };

  /**
   * Get list visible field from list container element
   * @return {array} visible fields list
   */
  var getVisibleField = function getVisibleField() {
    return filter('isVisible', this.elements);
  };

  /**
   * Check required filters before export, print of email
   * @return {Promise} Result
   */
  var checkRequiredFilters = function checkRequiredFilters(designerStore, reportId) {
    if (isNil(designerStore)) {
      return fetcher.validateRequiredFilters(reportId);
    }

    return (0, _bluebird.resolve)(isEmpty(get('fieldsStore.reportFilters.emptyVisibleRequiredFilter', designerStore)));
  };

  module.exports = {
    dirtyReportPartElementField: dirtyReportPartElementField,
    getCountableElements: getCountableElements,
    getVisibleField: getVisibleField,
    checkRequiredFilters: checkRequiredFilters
  };
}();

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.IconDropdownSetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * IconDropdownSetting component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);
  var FORMAT_CONFIG = __webpack_require__(132).FORMAT_CONFIG;

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var IconDropdownSetting = React.createClass({
    displayName: 'IconDropdownSetting',

    propTypes: {
      onChange: React.PropTypes.func
    },

    handleSelectItem: function handleSelectItem(item, type) {
      var props = this.props;
      var editorControl = props.editorControl;

      switch (type) {
        case 'numbered':
          editorControl && editorControl.applyListFormat('OL', item.value);
          props.applyListFormat && props.applyListFormat('OL', item.value);
          break;
        case 'bullet':
          editorControl && editorControl.applyListFormat('UL', item.value);
          props.applyListFormat && props.applyListFormat('UL', item.value);
          break;
        case 'repeater':
          editorControl && editorControl.updateRepeater(item.value);
          break;
        default:
          editorControl && editorControl.toggleFormat(item.value);
      }
    },

    renderOption: function renderOption(item, type) {
      var props = this.props;
      var classes = classnames(item.className, {
        active: !isNil(props.value) && (props.value[item.value] || props.value[type] === item.value)
      });

      return React.createElement(
        'li',
        { key: item.value, className: classes },
        React.createElement(
          'a',
          { onClick: this.handleSelectItem.bind(this, item, type) },
          React.createElement('i', { className: item.icon }),
          item.label
        )
      );
    },

    renderOptions: function renderOptions() {
      var items = [];
      var type = this.props.data.type;
      switch (type) {
        case 'heading':
          items = FORMAT_CONFIG.HEADING;
          break;
        case 'block':
          items = FORMAT_CONFIG.BLOCK;
          break;
        case 'numbered':
          items = FORMAT_CONFIG.NUMBER_LIST;
          break;
        case 'bullet':
          items = FORMAT_CONFIG.BULLET_LIST;
          break;
        case 'repeater':
          items = FORMAT_CONFIG.REPEATER_LIST;
          break;
      }

      return items.map(function (item) {
        return this.renderOption(item, type);
      }.bind(this));
    },

    render: function render() {
      var props = this.props;
      var data = props.data;

      return React.createElement(
        'span',
        { className: 'u-posRelative izenda-FormSettings' },
        React.createElement(
          'a',
          {
            ref: function ref(dom) {
              dom && $izenda(dom).dropdown();
            },
            className: 'btn',
            'data-toggle': 'dropdown',
            title: data.title
          },
          React.createElement('i', { className: data.className }),
          React.createElement('span', { className: 'caret' })
        ),
        React.createElement(
          'ul',
          { className: 'dropdown-menu' },
          this.renderOptions()
        )
      );
    }
  });

  module.exports = observer(IconDropdownSetting);
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(247);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Access Data Fetcher.
 */

var ROOT_URL = 'accessright/';

exports.default = {
  /**
   * Get all access right
   * @param {String} saveType
   * @returns {promise}
   */
  loadAccessRight: _Izenda4.default.memoize(function (type) {
    return (0, _Izenda2.default)(ROOT_URL + 'reportDashboard/' + type).get();
  }),

  /**
   * Get all access right for tenant settings
   * @param {String} saveType
   * @returns {promise}
   */
  loadTenantSettingAccessRight: function loadTenantSettingAccessRight(type) {
    return (0, _Izenda2.default)(ROOT_URL + 'authentication/' + type).get();
  },


  /**
   * Load accesses
   * @param  {string} tenantId
   * @param  {Object} subscriptions
   * @param  {Object} pageInfo
   */
  loadAccesses: function loadAccesses(data, pageInfo) {
    pageInfo = pageInfo || {};

    var requestData = {
      accesses: data,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{ key: 'shareWith', descending: true }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'load').post(requestData);
  },


  /**
   * Validation tenant accesses
   * @param  {object} requestData
   */
  validateAccesses: function validateAccesses(requestData) {
    return (0, _Izenda2.default)(ROOT_URL + 'validate').post(requestData);
  },


  /**
   * Load access default for report/ dash board when create new document
   * @param  {int} type  type of document
   * @return {Promise}
   */
  loadDefaultAccess: function loadDefaultAccess(type) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadAccessDefaults/' + type).get();
  },


  /**
   * Load users access
   * @return {Promise}
   */
  loadUsersAccess: function loadUsersAccess(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'users').post(data);
  },


  /**
   * Load roles access
   * @return {Promise}
   */
  loadRolesAccess: function loadRolesAccess(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'roles').post(data);
  }
};
module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  FILTER_MODE: {
    DbStructure: 'DbStructure',
    UserDefined: 'UserDefined'
  },

  FILTER_LOOKUP_STATUSES: {
    VALID: 0,
    INVALID_QUERY_SOURCE: 1,
    INVALID_CONNECTION: 2,
    LOOKUP_IS_TENANT_FIELD: 4,
    LOOKUP_INVISIBLE: 8,
    DISPLAY_IS_TENANT_FIELD: 16,
    DISPLAY_INVISIBLE: 32
  },

  CONSTRAINTS: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
      }
    }
  },

  FILTER_LOOKUP_TYPES: {
    NONE: 0,
    LOOKUP_KEY: 1,
    USER_DEFINED: 2
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.FilterLookupConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SubscriptionDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      map = _require.map,
      isEqual = _require.isEqual,
      omit = _require.omit,
      trim = _require.trim,
      uniqueId = _require.uniqueId,
      chain = _require.chain,
      union = _require.union,
      indexOf = _require.indexOf,
      isArray = _require.isArray,
      split = _require.split,
      find = _require.find,
      compact = _require.compact;

  var m = __webpack_require__(5);
  var uiState = __webpack_require__(15);
  var trackable = __webpack_require__(46);
  var TimezoneConstant = __webpack_require__(994);
  var momentTimezone = __webpack_require__(276);
  var Constant = __webpack_require__(133);
  var DashboardConstant = __webpack_require__(277);
  var ObjectStateConstants = __webpack_require__(58);
  var ScheduleConstants = __webpack_require__(230);
  var SCHEDULE_SEARCH_CONSTANTS = __webpack_require__(158);
  var AppGlobalConstants = __webpack_require__(115);
  var DATE_FORMAT = AppGlobalConstants.DATE_FORMAT;

  function SubscriptionDetails(data, emailTemplates, reportFilter) {
    this.tenantId = uiState.tenantId;

    var props = {
      name: null,
      schedule: null,
      filterValueSelection: null,
      type: null,
      timeZoneName: null,
      timeZoneValue: null,
      startDate: null,
      startTime: null,
      recurrenceType: null,
      recurrencePattern: null,
      recurrencePatternSetting: null,
      dailyRecurrencePatternSetting: {
        isEveryWeekday: false,
        recurrenceDay: 1
      },
      weeklyRecurrencePatternSetting: {
        recurrenceWeek: 1,
        selectedDayValue: find(function (d) {
          return d.label === momentTimezone().format('dddd');
        }, ScheduleConstants.DAYNAME_LIST).value.toString()
      },
      monthlyRecurrencePatternSetting: {
        useOrdinalDay: false,
        day: momentTimezone()._d.getDate(),
        recurrenceMonth: 1,
        ordinalDay: Math.round(momentTimezone()._d.getDate() / 7),
        ordinalDayValue: momentTimezone()._d.getDay() + 1,
        ordinalRecurrenceMonth: 0
      },
      yearlyRecurrencePatternSetting: {
        recurrenceYear: 1,
        useOrdinalDay: false,
        monthValue: momentTimezone()._d.getMonth() + 1,
        day: momentTimezone()._d.getDate(),
        ordinalDay: Math.round(momentTimezone()._d.getDate() / 7),
        ordinalDayValue: momentTimezone()._d.getDay() + 1,
        ordinalMonthValue: momentTimezone()._d.getMonth() + 1
      },
      isEndless: null,
      occurrence: 0,
      endDate: null,
      deliveryType: null,
      deliveryMethod: null,
      deliveryMethodView: function deliveryMethodView() {
        if (this.deliveryMethod === Constant.DELIVERY_METHOD_VALUES.Attachment) {
          return String.format(Constant.DELIVERY_METHOD_VIEW_PATTERN, this.deliveryMethod, this.exportAttachmentType);
        }
        return this.deliveryMethod;
      },
      exportFileType: null,
      exportAttachmentType: null,
      emailSubject: null,
      emailBody: null,
      subscriptionFilterFields: null,
      subscriptionCommonFilterFields: null,
      reportId: null,
      dashboardId: null,
      createdBy: null,
      createdById: null,
      id: null,
      state: null,
      modified: null,
      dateTimeNow: null,
      version: null,
      isSubscription: true,
      recipients: null,
      lastSuccessfulRun: null,
      nextScheduledRun: null,

      emailTemplates: null,
      reportFilter: null,
      isEndAfter: false,
      isEndBy: false,
      isEdit: false,
      selectedValue: false,

      // For UI logic.
      currentTab: Constant.SCHEDULER_TAB.key
    };

    m.extendObservable(trackable(this), props);
    this.populate(data, emailTemplates, reportFilter);
  }

  /**
   * Populate information.
   * @param {Object} data
   * @param {Array} emailTemplates
   * @param {Object} reportFilter
   */
  SubscriptionDetails.prototype.populate = m.action(function (data, emailTemplates, reportFilter) {
    data = data || {};

    this.name = data.name;
    this.schedule = data.schedule;
    this.filterValueSelection = data.filterValueSelection;
    this.type = data.type;
    this.timeZoneName = data.timeZoneName;
    this.timeZoneValue = data.timeZoneValue;
    this.startDate = data.startDate;
    this.startTime = data.startTime;
    this.recurrenceType = data.recurrenceType;
    this.recurrencePattern = data.recurrencePattern;
    this.recurrencePatternSetting = data.recurrencePatternSetting || {};
    this.isEndless = data.isEndless;
    this.occurrence = data.occurrence;
    this.endDate = data.endDate;
    this.deliveryType = data.deliveryType;
    this.deliveryMethod = data.deliveryMethod;
    this.exportFileType = data.exportFileType;
    this.exportAttachmentType = data.exportAttachmentType;
    this.emailSubject = data.emailSubject;
    this.emailBody = this.replaceBrTagInEmailBody(data.emailBody);
    this.subscriptionFilterFields = data.subscriptionFilterFields || [];
    this.subscriptionCommonFilterFields = data.subscriptionCommonFilterFields || [];
    this.reportId = data.reportId;
    this.dashboardId = data.dashboardId;
    this.createdBy = data.createdBy || '';
    this.createdById = data.createdById;
    this.id = data.id || uniqueId('newInstance_');
    this.state = data.state;
    this.modified = data.modified;
    this.dateTimeNow = data.dateTimeNow;
    this.version = data.version;
    this.isSubscription = data.isSubscription;
    this.recipients = data.recipients;
    this.lastSuccessfulRun = data.lastSuccessfulRun;
    this.nextScheduledRun = data.nextScheduledRun;

    this.emailTemplates = emailTemplates && emailTemplates.map(function (template) {
      template.value = this.replaceBrTagInEmailBody(template.value);
      return template;
    }.bind(this));
    this.reportFilter = reportFilter;
    this.isEndBy = !!data.endDate && data.occurrence === 0;
    this.isEndAfter = !!data.occurrence;
    data.isEdit && (this.isEdit = data.isEdit);

    data.dailyRecurrencePatternSetting && (this.dailyRecurrencePatternSetting = data.dailyRecurrencePatternSetting);
    data.weeklyRecurrencePatternSetting && (this.weeklyRecurrencePatternSetting = data.weeklyRecurrencePatternSetting);
    data.monthlyRecurrencePatternSetting && (this.monthlyRecurrencePatternSetting = data.monthlyRecurrencePatternSetting);
    data.yearlyRecurrencePatternSetting && (this.yearlyRecurrencePatternSetting = data.yearlyRecurrencePatternSetting);

    this.updateRecurrencePatternSetting(data);

    this.resetDirty();
  });

  /**
   * Update recurrence pattern setting
   * @param {Object} data
   */
  SubscriptionDetails.prototype.updateRecurrencePatternSetting = function (data) {
    if (this.isEdit) {
      var recurrencePatternConstants = ScheduleConstants.RECURRENCE_PATTERN;
      switch (data.recurrencePattern) {
        case recurrencePatternConstants[0].value:
          // Daily
          this.dailyRecurrencePatternSetting = data.recurrencePatternSetting;
          break;
        case recurrencePatternConstants[1].value:
          // Weekly
          this.weeklyRecurrencePatternSetting = data.recurrencePatternSetting;
          break;
        case recurrencePatternConstants[2].value:
          // Monthly
          this.monthlyRecurrencePatternSetting = data.recurrencePatternSetting;
          break;
        case recurrencePatternConstants[3].value:
          // Yearly
          this.yearlyRecurrencePatternSetting = data.recurrencePatternSetting;
          break;
      }
      this.markDirty();
    }
  };

  /**
   * Update property using key
   * @param {String} key
   * @param {Object} value
   */
  SubscriptionDetails.prototype.updateProperty = function (key, value) {
    this[key] = value;
    this.markDirty();
  };

  /**
   * Check dirty status.
   * @return {boolean} dirty status
   */
  SubscriptionDetails.prototype.checkDirty = function () {
    return this.isDirty;
  };

  /**
   * Clean dirty status.
   */
  SubscriptionDetails.prototype.cleanDirty = function () {
    this.resetDirty();
  };

  /**
   * Init data
   * @return {object} SubscriptionDetails
   */
  SubscriptionDetails.prototype.init = m.action(function () {
    var recurrenceList = ScheduleConstants.RECURRENCE_REPORTLIST;
    var tz = this.timezone();

    this.type = this.isSubscription ? SCHEDULE_SEARCH_CONSTANTS.INSTANCE_TYPE_VALUE.SUBSCRIBE_REPORTING_ITEM : DashboardConstant.SCHEDULE_REPORT;
    this.timeZoneName = tz.label;
    this.timeZoneValue = tz.value;
    this.startDate = momentTimezone().format(DATE_FORMAT);
    this.startTime = null;
    this.recurrenceType = recurrenceList[0].value;
    this.isEndless = true;
    this.isEndAfter = !!this.occurrence;
    this.isEndBy = !!this.endDate;
    this.deliveryType = Constant.DELIVERY_TYPE[0].value;
    this.deliveryMethod = Constant.DELIVERY_TYPE[0].deliveryMethod[0].value;
    this.emailSubject = this.reportId ? Constant.EMAIL_SUBJECT.REPORT : Constant.EMAIL_SUBJECT.DASHBOARD;
    this.getEmailBody();
    this.state = this.id.indexOf('newInstance_') >= 0 ? ObjectStateConstants.INSERT : ObjectStateConstants.UPDATE;
    this.endDate = momentTimezone().add(3, 'month').format(DATE_FORMAT);
    this.recurrencePattern = 1;
    this.recurrencePatternSetting = this.weeklyRecurrencePatternSetting;
    this.isEdit = false;

    return this;
  });

  /**
   * Get timezone object
   * @return {object} timezone
   */
  SubscriptionDetails.prototype.timezone = function () {
    var props = this || {};
    var timeZoneValue;
    if (props.timeZoneValue) {
      timeZoneValue = props.timeZoneValue;
    } else {
      timeZoneValue = TimezoneConstant.TIMEZONE[0].value;
    }

    return find(function (tz) {
      return isEqual(tz.value, timeZoneValue) || tz.abr && indexOf(timeZoneValue, tz.abr) > -1;
    }, TimezoneConstant.TIMEZONE);
  };

  /**
   * Get email body
   */
  SubscriptionDetails.prototype.getEmailBody = function () {
    var deliveryMethod = this.deliveryMethod;
    var matchedBody = find(function (item) {
      return deliveryMethod === item.key;
    }, this.emailTemplates);

    this.emailBody = matchedBody && this.replaceBrTagInEmailBody(matchedBody.value);
    this.markDirty();
  };

  /**
   * Build data for saving
   */
  SubscriptionDetails.prototype.buildDataForSaving = function () {
    this.buildRecurrencePatternSetting();
    this.syncRangeRecurrenceData();
    this.buildEmailTemplateForSave();
  };

  /**
   * Build recurrence pattern setting from UI values.
   */
  SubscriptionDetails.prototype.buildRecurrencePatternSetting = function () {
    var recurrencePatternConstants = ScheduleConstants.RECURRENCE_PATTERN;
    switch (this.recurrencePattern) {
      case recurrencePatternConstants[0].value:
        this.recurrencePatternSetting = this.dailyRecurrencePatternSetting;
        break;
      case recurrencePatternConstants[1].value:
        this.recurrencePatternSetting = this.weeklyRecurrencePatternSetting;
        break;
      case recurrencePatternConstants[2].value:
        this.recurrencePatternSetting = this.monthlyRecurrencePatternSetting;
        break;
      case recurrencePatternConstants[3].value:
        this.recurrencePatternSetting = this.yearlyRecurrencePatternSetting;
        break;
    }
  };

  /**
   * Synchronize range of recurrence data before saving
   */
  SubscriptionDetails.prototype.syncRangeRecurrenceData = function () {
    !this.isEndAfter && (this.occurrence = 0);
    !this.isEndBy && (this.endDate = null);
    if (this.isEndless) {
      this.occurrence = 0;
      this.endDate = null;
    }
    this.markDirty();
  };

  /**
   * Replace new line characer by html <Br> tag
   */
  SubscriptionDetails.prototype.buildEmailTemplateForSave = function () {
    var reg = new RegExp('\\n', 'g');
    var emailBody = this.emailBody;
    emailBody && (this.emailBody = emailBody.replace(reg, '<br>'));
    this.markDirty();
  };

  /**
   * Add recipients
   * @param {Object} List of user account detail object
   */
  SubscriptionDetails.prototype.addRecipients = function (userAccountList) {
    this.recipients = chain(userAccountList).flatMap(function (userAccount) {
      return userAccount.emailAddress;
    }).join(';').value();
    this.markDirty();
  };

  /**
   * Get recipients
   * @param {Object} List of user account detail object
   */
  SubscriptionDetails.prototype.getRecipients = function () {
    if (!this.recipients) return null;

    var recipientList = isArray(this.recipients) ? this.recipients : compact(split(';', this.recipients));
    return map(function (recipient) {
      return { emailAddress: recipient };
    }, recipientList);
  };

  /**
   * Omit data for saving
   * @return {object} subscription details
   */
  SubscriptionDetails.prototype.omitData = function () {
    return omit(['dailyRecurrencePatternSetting', 'weeklyRecurrencePatternSetting', 'monthlyRecurrencePatternSetting', 'yearlyRecurrencePatternSetting', 'reportFilter'], this);
  };

  /**
   * Update data for edit mode
   * @return {object} data
   */
  SubscriptionDetails.prototype.updateDataForEditMode = m.action(function (data) {
    this.emailTemplates = data.emailTemplates, this.state = data.state;
    this.isEdit = true;
    this.isSubscription = data.isSubscription;
    this.markDirty();
  });

  /**
   * Update data selected value
   * @return {boolean} value
   */
  SubscriptionDetails.prototype.updateSelectedValue = function (value) {
    this.selectedValue = value;
    this.markDirty();
  };

  /**
   * Add recipients
   * @param {Object} List of user account detail object
   */
  SubscriptionDetails.prototype.addMoreRecipients = function (userAccountList) {
    var currentRecipients = isArray(this.recipients) ? this.recipients : compact(split(';', this.recipients));

    var newRecipients = map('emailAddress', userAccountList);

    this.recipients = filter(function (item) {
      return !isEmpty(item);
    }, union(currentRecipients, newRecipients)).join(';');
    this.markDirty();
  };

  /**
   * Update current tab value.
   * @param {Object} value
   */
  SubscriptionDetails.prototype.setCurrentTab = function (value) {
    this.currentTab = value;
  };

  /**
   * Replace all html <br> tag in email by newline character
   * @param email
   * @returns {*|string}
   */
  SubscriptionDetails.prototype.replaceBrTagInEmailBody = function (email) {
    return email && email.split(/<br\/?>/).map(trim).join('\n');
  };

  module.exports = SubscriptionDetails;
}();

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DAYOFWEEK = {
  SUNDAY: 1,
  MONDAY: 2,
  TUESDAY: 3,
  WEDNESDAY: 4,
  THURSDAY: 5,
  FRIDAY: 6,
  SATURDAY: 7
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

/**
 * ScheduleConstants
 */

exports.default = {
  DAYOFWEEK: DAYOFWEEK,
  //TODO: Not apply localization, need to fix line 88 in Izenda.RecurrencePattern.jsx
  RECURRENCE_PATTERN: [{ value: 0, label: 'daily' }, { value: 1, label: 'weekly' }, { value: 2, label: 'monthly' }, { value: 3, label: 'yearly' }],

  RECURRENCE_REPORTLIST: [{
    value: '2',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_DATE');
    }
  }, {
    value: '3',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_WEEKDAY');
    }
  }, {
    value: '4',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_WEEK');
    }
  }, {
    value: '5',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_TWO_WEEK');
    }
  }, {
    value: '6',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_MONTH');
    }
  }, {
    value: '7',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_EVERY_QUARTER');
    }
  }, {
    value: '8',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_RECURRENCE_REPORTLIST_CUSTOM_RECURRENCE');
    }
  }],

  RECURRENCE_ALERTLIST: [{
    value: '0',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_RECURRENCE_ALERTLIST_ALERT_HOURLY');
    }
  }, {
    value: '1',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_RECURRENCE_ALERTLIST_ALERT_DAILY');
    }
  }, {
    value: '8',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_RECURRENCE_REPORTLIST_CUSTOM_RECURRENCE');
    }
  }],

  ORDINAL_LIST: [{
    value: '1',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_FIRST');
    }
  }, {
    value: '2',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_SECOND');
    }
  }, {
    value: '3',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_THIRD');
    }
  }, {
    value: '4',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_FOURTH');
    }
  }, {
    value: '100',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_ORDINAL_LIST_LAST');
    }
  }],

  //TODO: Not apply localization, need to fix line 66 in Izenda.SubscriptionDetails.jsx
  DAYNAME_LIST: [{ value: DAYOFWEEK.SUNDAY, label: 'Sunday' }, { value: DAYOFWEEK.MONDAY, label: 'Monday' }, { value: DAYOFWEEK.TUESDAY, label: 'Tuesday' }, { value: DAYOFWEEK.WEDNESDAY, label: 'Wednesday' }, { value: DAYOFWEEK.THURSDAY, label: 'Thursday' }, { value: DAYOFWEEK.FRIDAY, label: 'Friday' }, { value: DAYOFWEEK.SATURDAY, label: 'Saturday' }],

  MONTHNAME_LIST: [{
    value: '1',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_JANUARY');
    }
  }, {
    value: '2',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_FEBRUARY');
    }
  }, {
    value: '3',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_MARCH');
    }
  }, {
    value: '4',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_APRIL');
    }
  }, {
    value: '5',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_MAY');
    }
  }, {
    value: '6',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_JUNE');
    }
  }, {
    value: '7',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_JULY');
    }
  }, {
    value: '8',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_AUGUST');
    }
  }, {
    value: '9',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_SEPTEMBER');
    }
  }, {
    value: '10',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_OCTOBER');
    }
  }, {
    value: '11',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_NOVEMBER');
    }
  }, {
    value: '12',
    get label() {
      return _Izenda2.default.getText('SCHEDULE_CONSTANTS_MONTHNAME_LIST_DECEMBER');
    }
  }],
  DATE_SIMPLE_FORMAT: 'MM/DD/YYYY',
  DEFAULT_OCCURRENCE: 1
};
module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.IntegrationStyleAction.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report page component
 */

!function () {
  var React = __webpack_require__(0);
  var recompose = __webpack_require__(9);
  var withContext = recompose.withContext;
  var getContext = recompose.getContext;
  var compose = recompose.compose;
  var branch = recompose.branch;
  var renderNothing = recompose.renderNothing;
  var mapProps = recompose.mapProps;
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      get = _require.get,
      identity = _require.identity,
      omit = _require.omit;

  var contextShape = {
    integrationStyle: React.PropTypes.object
  };

  var defineContext = withContext(contextShape, function (props) {
    return {
      integrationStyle: props.integrationStyle
    };
  });

  var accessContext = getContext(contextShape);

  var checkDisplayByKey = function checkDisplayByKey(key) {
    return compose(accessContext, observer, branch(function (props) {
      return get(key, props.integrationStyle);
    }, renderNothing, identity), mapProps(function (props) {
      return omit('integrationStyle', props);
    }));
  };

  module.exports = {
    defineContext: defineContext,
    accessContext: accessContext,
    checkDisplayByKey: checkDisplayByKey
  };
}();

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleSetupConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var REPORT = (0, _fp.toLower)(_Izenda2.default.getText('COMMON_LABEL_REPORT'));
var DASHBOARD = (0, _fp.toLower)(_Izenda2.default.getText('COMMON_LABEL_DASHBOARD'));
var EDITABLE = (0, _fp.toLower)(_Izenda2.default.getText('ROLE_SETUP_PERMISSION_CATEGORIES_ERROR_EDITABLE'));
var ACCESSIBLE = (0, _fp.toLower)(_Izenda2.default.getText('ROLE_SETUP_PERMISSION_CATEGORIES_ERROR_ACCESSIBLE'));
var DATA_SOURCE_CONCAT_TREE_MAP = [{
  prop: 'childNodes',
  children: [{
    prop: 'childNodes',
    showTotal: true,
    children: [{
      prop: 'childNodes',
      children: [{
        prop: 'childNodes'
      }]
    }]
  }]
}];

exports.default = {
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
  MIDDLE_MIN_WIDTH: 0,
  MIDDLE_MAX_WIDTH: 250,
  MESSAGE: {
    get DELETE() {
      return _Izenda2.default.getText('ROLE_SETUP_CONSTANT_MESSAGE_DELETE');
    },
    get DEACTIVE() {
      return _Izenda2.default.getText('ROLE_SETUP_CONSTANT_MESSAGE_DEACTIVE');
    },
    get PERMISSION_ERROR() {
      return _Izenda2.default.getText('ROLE_SETUP_PERMISSION_CATEGORIES_ERROR');
    }
  },
  PERMISSION_ERROR: {
    validateReportUneditableCategoryKey: {
      type: REPORT,
      permission: EDITABLE
    },
    validateReportInaccessibleCategoryKey: {
      type: REPORT,
      permission: ACCESSIBLE
    },
    validateDashboardUneditableCategoryKey: {
      type: DASHBOARD,
      permission: EDITABLE
    },
    validateDashboardInaccessibleCategoryKey: {
      type: DASHBOARD,
      permission: ACCESSIBLE
    }
  },
  ROLE_STATE: {
    get ACTIVATE() {
      return _Izenda2.default.getText('COMMON_LABEL_ACTIVATE');
    },
    get DEACTIVATE() {
      return _Izenda2.default.getText('COMMON_LABEL_DEACTIVATE');
    }
  },
  CONSTRAINTS: {
    ROLE_NAME: {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText('ROLE_SETUP_CONSTANT_CONSTRAINTS_REQUIRE_VALUE');
        }
      }
    }
  },
  ROLE_SETUP: {
    get USERS() {
      return _Izenda2.default.getText('ROLE_SETUP_CONSTANT_ROLE_SETUP_USERS');
    }
  },
  DEFAULT_ITEMS_LAZY_LOADING: 100,
  DATA_SOURCE_CONCAT_TREE_MAP: DATA_SOURCE_CONCAT_TREE_MAP,
  DATA_SOURCE_TREE_MAP: [{
    prop: 'childNodes',
    children: DATA_SOURCE_CONCAT_TREE_MAP
  }]
};
module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionButton.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Action Button component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var FloatAffixed = __webpack_require__(154);
  var UiState = __webpack_require__(15);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isObject = _require.isObject;

  var ActionButton = React.createClass({
    displayName: 'ActionButton',

    getInitialState: function getInitialState() {
      return {
        isOpen: false
      };
    },

    hideMenu: function hideMenu(event) {
      this.setState({ isOpen: false });
    },

    showMenu: function showMenu(event) {
      this.setState({
        isOpen: !this.state.isOpen
      });
    },

    renderActionButtons: function renderActionButtons() {
      var buttons = filter(function (item) {
        return isObject(item) && !item.props.keepDisplay;
      }, this.props.children);
      return buttons.map(function (item, index) {
        return React.createElement(
          'div',
          { key: index, onClick: this.hideMenu },
          ' ',
          item,
          ' '
        );
      }.bind(this));
    },

    renderStaticButtons: function renderStaticButtons() {
      return filter(function (item) {
        return isObject(item) && item.props.keepDisplay;
      }, this.props.children);
    },

    render: function render() {
      if (!UiState.isMobile) {
        return React.createElement(
          'div',
          { className: 'u_inlineBlock izenda-ActionButton' },
          this.props.children
        );
      }

      return React.createElement(
        'div',
        { className: 'u_inlineBlock izenda-ActionButton' },
        React.createElement(
          'button',
          { ref: 'btnAction', onMouseDown: this.showMenu, className: 'btn btn-primary' },
          localizer.getText('COMMON_LABEL_ACTION'),
          ' \xA0',
          React.createElement('span', { className: 'caret' })
        ),
        this.renderStaticButtons(),
        this.state.isOpen && React.createElement(
          FloatAffixed,
          {
            className: 'izenda-ActionButton-menu',
            edges: 'under,over',
            renderInContainer: false,
            autoWidth: true,
            anchor: this.refs.btnAction,
            onClickOutside: this.hideMenu
          },
          React.createElement(
            'div',
            null,
            this.renderActionButtons()
          )
        )
      );
    }
  });

  module.exports = observer(ActionButton);
}();

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(60);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _jsCookie = __webpack_require__(1399);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _Izenda3 = __webpack_require__(41);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Remove cookies
 * @param {Array}
 */
// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _removeCookies = function _removeCookies(values) {
  (0, _fp.forEach)(function (item) {
    _jsCookie2.default.remove(item.key, item.options);
  }, values);
};

var AuthUtils = {
  /**
     * Get cookie
     * @param {String} key
     * @returns {Object} Cookie
     */
  getCookie: function getCookie(key) {
    return _jsCookie2.default.get(key);
  },


  /**
   * Set cookie
   * @param {String} key
   * @param {Object} value
   * @param {Object} option
   */
  setCookie: function setCookie(key, value, options) {
    (0, _fp.isNil)(options) ? _jsCookie2.default.set(key, value) : _jsCookie2.default.set(key, value, options);
  },


  /**
   * Remove cookie.
   * @param  {String} key
   * @param  {Object} options
   */
  removeCookie: function removeCookie(key, options) {
    _jsCookie2.default.remove(key, options);
  },


  /**
   * Update set of cookies
   * @param {Array}
   */
  updateCookies: function updateCookies(values) {
    (0, _fp.forEach)(function (item) {
      _jsCookie2.default.set(item.key, item.value, item.options);
    }, values);
  },


  /**
   * Remove set of cookies
   * @param {Array}
   */
  removeCookies: function removeCookies(values) {
    _removeCookies(values);
  },


  /**
   * Remove auth cookies
   * @param {Array}
   */
  removeAuthCookies: function removeAuthCookies() {
    _removeCookies([{ key: _Izenda2.default.HEADER_KEYS.access_token }, { key: _Izenda2.default.HEADER_KEYS.selected_tenant }]);
  },


  /**
   * Get current token
   * @returns {Object} token
   */
  getAccessToken: function getAccessToken() {
    if (!(0, _fp.isNil)(_Izenda4.default.currentUserContext.token)) {
      return _Izenda4.default.currentUserContext.token;
    } else {
      var currentAccesstToken = this.getCookie(_Izenda2.default.HEADER_KEYS.access_token);
      if (!(0, _fp.isNil)(currentAccesstToken)) {
        return currentAccesstToken;
      }
    }
    return null;
  },


  /**
   * Set access token
   * @param {String} token
   */
  setAccessToken: function setAccessToken(token) {
    this.setCookie(_Izenda2.default.HEADER_KEYS.access_token, token);
  },


  /**
   * Get tenant ID from cookie
   * @param {String} selectedTenant
   */
  getSelectedTenant: function getSelectedTenant() {
    return this.getCookie(_Izenda2.default.HEADER_KEYS.selected_tenant);
  },


  /**
   * Set tenant ID to cookie
   * @param {String} selectedTenant
   */
  setSelectedTenant: function setSelectedTenant(selectedTenant) {
    this.setCookie(_Izenda2.default.HEADER_KEYS.selected_tenant, selectedTenant);
  },


  /**
   * Remove tenant ID in cookie
   * @param {String} selectedTenant
   */
  removeSelectedTenant: function removeSelectedTenant() {
    this.removeCookie(_Izenda2.default.HEADER_KEYS.selected_tenant);
  }
};
exports.default = AuthUtils;
module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(90);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(82);

var _Izenda5 = __webpack_require__(89);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReportLink.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ERROR_MESSAGE = _Izenda4.SUB_REPORT.ERROR_MESSAGE;

/**
 * Builder filter data common
 * @param {Array} records
 * @param {Array} subReportMappingFields
 */

function buildFilterDataCommon(records, subReportMappingFields, _ref) {
  var previewDataFieldsMapping = _ref.previewDataFieldsMapping,
      fieldCollection = _ref.fieldCollection;

  var result = {
    success: true
  };

  var filterData = (0, _fp.flow)(_mobx.toJS, (0, _fp.map)((0, _fp.mapValues)(function (value) {
    return (0, _fp.isNull)(value) || (0, _fp.isEqual)('null', value) ? _Izenda5.DEFAUFT_VALUE.NULL : (0, _fp.isEqual)('', value) ? _Izenda5.DEFAUFT_VALUE.BLANK : (0, _fp.toString)(value);
  })))(records);

  var formatFieldName = (0, _fp.flow)(_fp.trim, _fp.toUpper);
  var listFieldDontHaveMapping = [];

  var filters = subReportMappingFields.map(function (mappingField, index) {
    var mappingFieldName = formatFieldName(mappingField.fieldNameAlias);

    var selectedFieldMapping = (0, _fp.find)(function (fieldMapping) {
      return formatFieldName(fieldMapping.fieldNameAlias) === mappingFieldName;
    }, previewDataFieldsMapping);
    var selectedElement = (0, _fp.find)(function (fieldElement) {
      return formatFieldName(fieldElement.name) === mappingFieldName;
    }, fieldCollection);

    var functionId = (0, _fp.get)('properties.dataFormattings.function', selectedElement);
    var formatData = (0, _fp.get)('properties.dataFormattings.format.formatId', selectedElement);

    if (!selectedFieldMapping || !selectedElement) {
      // dont find field in current report part, need to reconfig sub report seeting
      result.success = false;
      listFieldDontHaveMapping.push(mappingField.fieldNameAlias);
    }

    return {
      mappingField: mappingField,
      mappingFieldIndex: index,
      dataFormat: formatData || undefined,
      function: functionId || undefined,
      columnName: (0, _fp.get)('columnName', selectedFieldMapping),
      dataType: (0, _fp.get)('field.dataFieldType', selectedElement)
    };
  });

  if (!result.success) {
    // dont find field in current report part, need to reconfig sub report seeting
    result.errors = String.format(ERROR_MESSAGE.CANT_RESOLVE_FIELD, listFieldDontHaveMapping.join(', '));
    return result;
  }
  var listColumnName = (0, _fp.uniq)((0, _fp.map)('columnName', filters));
  var pickColumnName = (0, _fp.pick)(listColumnName);

  filterData = (0, _fp.uniqWith)(function (arrVal, othVal) {
    return (0, _fp.isEqual)(pickColumnName(arrVal), pickColumnName(othVal));
  }, filterData);

  if (filterData.length != 1) {
    // there are multiple data so can't handle field mapping
    result.success = false;
    var listFieldHaveMultipleValue = [];

    (0, _fp.forEach)(function (columnName) {
      if ((0, _fp.uniq)((0, _fp.map)(columnName, filterData)).length !== 1) {
        listFieldHaveMultipleValue.push((0, _fp.flow)((0, _fp.filter)({ columnName: columnName }), (0, _fp.map)('mappingField.fieldNameAlias'), _fp.uniq)(filters));
      }
    }, listColumnName);

    listFieldHaveMultipleValue = (0, _fp.uniq)(listFieldHaveMultipleValue);

    result.errors = String.format(ERROR_MESSAGE.MULTIPLE_VALUE, listFieldHaveMultipleValue.join(', '));
    return result;
  }

  filterData = (0, _fp.head)(filterData);
  var listFieldDontHaveValue = [];

  filters = (0, _fp.map)(function (filterItem) {
    var value = (0, _fp.get)(filterItem.columnName, filterData);
    var originalValue = (0, _fp.get)(_Izenda3.COLUMN_NAME_PREFIX.ORIGINAL_VALUE + filterItem.columnName, filterData);
    if ((0, _fp.isUndefined)(value)) {
      result.success = false;
      listFieldDontHaveValue.push(filterItem.mappingField.fieldNameAlias);
    }
    return (0, _fp.flow)((0, _fp.assign)(_fp.placeholder, {
      value: value,
      originalValue: originalValue
    }), (0, _fp.unset)('columnName'))(filterItem);
  }, filters);

  if (!result.success) {
    // dont find field in current report part, need to reconfig sub report seeting
    result.errors = String.format(ERROR_MESSAGE.CANT_RESOLVE_FIELD, listFieldDontHaveValue.join(', '));
    return result;
  }

  return (0, _fp.flow)((0, _fp.set)('fieldMapping', filters), (0, _fp.omit)(['errors']))(result);
}

/**
 * Build filter object for embeded sub report part and sub report popup
 * @param {Object} fieldMapping
 * @param {Object} reportPart
 * @param {Object} subReport
 * @param {Object} overridingFilterValue
 */
function buildFilterDataForEmbededReportPart(fieldMapping, reportPart, subReport, overridingFilterValue) {
  var result = {
    filters: (0, _fp.map)(function (filterItem) {
      var key = filterItem.mappingField.fieldNameInSubReport;

      return (0, _fp.flow)((0, _fp.set)('key', key), (0, _fp.set)('linkReportFilter', true), (0, _fp.omit)(['mappingField', 'mappingFieldIndex']))(filterItem);
    }, fieldMapping)
  };

  return subReport.reportFilter ? (0, _fp.assign)(result, {
    masterReportId: reportPart.reportId,
    inheritMasterReportFilter: true,
    overridingFilterValue: overridingFilterValue
  }) : result;
}

/**
 * Build filter object for link type sub report, this fillter object will be convert into URL
 * @param {Object} fieldMapping
 * @param {Object} reportPart
 * @param {Object} fieldElement
 * @param {Object} subReport
 * @param {Object} overridingFilterValue
 */
function buildFilterDataForURL(fieldMapping, reportPart, fieldElement, subReport, overridingFilterValue) {
  var elementInfo = (0, _fp.find)(function (info) {
    return info.element === fieldElement;
  }, reportPart.elementInfo);
  var elementContainer = elementInfo.container,
      elementPosition = elementInfo.position;
  var masterReportId = reportPart.reportId,
      masterReportPartId = reportPart.id;


  if (!elementInfo || !String.isGuidFormat(masterReportPartId)) {
    return {
      success: false,
      errors: ERROR_MESSAGE.NEED_UPDATE_RESULT
    };
  }

  var fieldsMapping = (0, _fp.map)(function (filterItem) {
    return (0, _fp.flow)((0, _fp.assign)(_fp.placeholder, {
      key: String.format(_Izenda3.FILTER_URL.SUB_REPORT_FIELD_MAPPING_KEY.FORMAT, elementPosition, filterItem.mappingFieldIndex)
    }), (0, _fp.omit)(['mappingField', 'mappingFieldIndex']), (0, _fp.omitBy)(_fp.isUndefined))(filterItem);
  }, fieldMapping);

  var result = {
    success: true,
    fieldsMapping: (0, _fp.isEmpty)(fieldsMapping) ? undefined : fieldsMapping,
    overridingFilterValue: (0, _fp.isEmpty)(overridingFilterValue) || !subReport.reportFilter ? undefined : overridingFilterValue,
    inheritMasterReportFilter: !!subReport.reportFilter || undefined
  };

  if (result.fieldsMapping) {
    result = (0, _fp.assign)(result, {
      masterReportId: masterReportId,
      containerName: elementContainer,
      masterReportPartId: masterReportPartId
    });
  }

  if (result.fieldsMapping || result.overridingFilterValue || result.inheritMasterReportFilter) {
    result = (0, _fp.assign)(result, {
      masterReportId: masterReportId
    });
  }

  return result;
}

/**
 * Load master report model to convert from URL fillter to field mapping in master report part
 * @param {Object} subReportFilterFromQuery
 */
function resolveSubReportFilter(subReportFilterFromQuery) {
  var masterReportId = (0, _fp.get)('masterReportId', subReportFilterFromQuery);
  var fieldsMapping = (0, _fp.get)('fieldsMapping', subReportFilterFromQuery);
  var masterReportPartId = (0, _fp.get)('masterReportPartId', subReportFilterFromQuery);
  var containerName = (0, _fp.get)('containerName', subReportFilterFromQuery);

  if (masterReportId && masterReportPartId && containerName && !(0, _fp.isEmpty)(fieldsMapping)) {
    return _Izenda2.default.loadForEdit(masterReportId).then(function (data) {
      return !(0, _fp.isNil)(data.report) ? data.report : data;
    }).then(function (report) {
      var regex = /fm(\d+)_(\d+)/;
      var key = (0, _fp.get)([0, 'key'], fieldsMapping);
      var elementPosition = (0, _fp.toNumber)(regex.exec(key)[1]);

      var resolveFieldMapping = (0, _fp.flow)((0, _fp.get)('reportPart'), (0, _fp.find)({ id: masterReportPartId }), (0, _fp.getOr)([], ['reportPartContent', containerName, 'elements']), (0, _fp.find)({ position: elementPosition }), (0, _fp.get)('properties.drillDown.subReport.mappingFields'), function (mappingFields) {
        if ((0, _fp.isNil)(mappingFields)) return [];

        return (0, _fp.map)(function (mapping) {
          var mappingKey = mapping.key;
          var mappingIndex = (0, _fp.toNumber)(regex.exec(mappingKey)[2]);
          return (0, _fp.flow)((0, _fp.omit)(['key']), (0, _fp.assign)({
            key: mappingFields[mappingIndex].fieldNameInSubReport,
            linkReportFilter: true
          }))(mapping);
        }, fieldsMapping);
      })(report);

      var filters = (0, _fp.compact)((0, _fp.concat)(subReportFilterFromQuery.filters, resolveFieldMapping));
      filters = (0, _fp.isEmpty)(filters) ? undefined : filters;

      return (0, _fp.flow)((0, _fp.omit)(['fieldsMapping', 'masterReportPartId', 'containerName']), (0, _fp.set)('filters', filters), (0, _fp.omitBy)(_fp.isUndefined))(subReportFilterFromQuery);
    });
  }

  return (0, _bluebird.resolve)(subReportFilterFromQuery);
}

exports.default = {
  buildFilterDataCommon: buildFilterDataCommon,
  buildFilterDataForEmbededReportPart: buildFilterDataForEmbededReportPart,
  buildFilterDataForURL: buildFilterDataForURL,
  resolveSubReportFilter: resolveSubReportFilter
};
module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _create = __webpack_require__(442);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CacheUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var cacheTimeOut = 3000;
  var AuthUtils = __webpack_require__(245);

  var _require = __webpack_require__(1),
      constant = _require.constant,
      uniqueId = _require.uniqueId,
      identity = _require.identity,
      get = _require.get,
      invoke = _require.invoke,
      cloneDeep = _require.cloneDeep;

  module.exports = {
    /**
     * [memoize description]
     * @method memoize
     * @param  {[type]} func   [description]
     * @param  {Object} option Optional params include:
     *                         resolver : function to get key for cacheTimeOut
     *                         timeOut : timeout value for result to keep in cache after it become fullFill
     *                         persistent : don't time out
     * @return {[type]}        [description]
     */
    memoize: function memoize(func, option) {
      option = option || {};
      var cache = (0, _create2.default)(null);
      var lastAccessToken = AuthUtils.getAccessToken();
      var resolver = option.resolver || (func.length === 0 ? constant(uniqueId('memoizeCache_')) : identity);
      var persistent = !!get('persistent', option);
      var timeOut = option.timeOut || cacheTimeOut;

      return function () {
        var currentAccessToken = AuthUtils.getAccessToken();
        // reset cache when access token is changed
        if (currentAccessToken !== lastAccessToken) {
          cache = (0, _create2.default)(null);
          lastAccessToken = currentAccessToken;
        }

        var originalArugment = arguments;
        var key = resolver.apply(this, arguments);
        var resultPromise = cache[key];
        var removeCache = function removeCache() {
          delete cache[key];
        };

        if (resultPromise && !invoke('isRejected', resultPromise)) {
          // make new object for both promise and fullFill data
          return resultPromise.then(cloneDeep);
        }

        cache[key] = resultPromise = func.apply(this, originalArugment);

        resultPromise.then(function () {
          !persistent && window.setTimeout(removeCache, timeOut);
        }).catch(removeCache);

        // make new object for both promise and fullFill data
        return resultPromise.then(cloneDeep);
      };
    }
  };
}();

/***/ }),
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Draggable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/** http://gaearon.github.io/react-dnd/docs-overview.html */

!function () {
  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var DragSource = __webpack_require__(378).DragSource;

  var _require = __webpack_require__(1),
      isNil = _require.isNil;
  /**
   * A higher-order component that make a react component becomes draggable
   * @param  {ReactComponent} Component
   * @param  {String} type - Only the drop targets registered for the same type will react to the items produced by this drag source.
   * @param  {Object} options - Set of drag behaviors
   * @return {DraggableComponent}
   * @example
   *    var types = {
   *     CARD: 'CARD',
   *    };
   *
   *    var sourceOptions = {
   *      beginDrag: function (props) { },
   *      endDrag: function (props, monitor, component) { },
   *      ...
   *     };
   *    var InnerCard = require('./Card');
   *    var Card = draggable(types.CARD, sourceOptions)(InnerCard);
   * 		...
   * 		<Card id={1} />
   */


  function draggable(type, options, selfDrag) {
    selfDrag = isNil(selfDrag) || selfDrag;

    return function (Component) {
      /**
       * The collecting function.
       * Specifies which props to inject into your component. It should return a plain object of the props to inject into your component.
       * @param  {DragSourceConnector} connect
       * @param  {DragSourceMonitor} monitor
       * @return {Object}
       */
      function collect(connect, monitor) {
        return {
          connectDragSource: connect.dragSource(),
          connectDragPreview: connect.dragPreview(),
          isDragging: monitor.isDragging()
        };
      }

      var DraggableComponent = React.createClass({
        displayName: 'DraggableComponent',

        render: function render() {
          var connectDragSource = this.props.connectDragSource;

          var getRef = function getRef(instance) {
            return selfDrag && connectDragSource(ReactDOM.findDOMNode(instance));
          };

          return React.createElement(Component, (0, _extends3.default)({}, this.props, { ref: getRef }));
        }
      });

      return m.observer(DragSource(type, options, collect)(DraggableComponent));
    };
  }

  module.exports = draggable;
}();

/***/ }),
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

exports.default = function (editorComp, reportDesignerModel, fieldStore, itemProps) {
  var _itemProps$configFiel = itemProps.configField,
      configField = _itemProps$configFiel === undefined ? {} : _itemProps$configFiel,
      authorization = itemProps.authorization,
      PERMISSION_KEY = itemProps.authorizationConstants.PERMISSION_KEY;

  var configReportPart = reportDesignerModel.configReportPart || {};
  var reportFields = reportDesignerModel.reportFields || {};
  var reportFilters = reportFields.reportFilter || {};
  var reportPartContent = configReportPart.reportPartContent || {};
  var containerName = (0, _fp.get)('fieldContainerDetails.name', itemProps);

  ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

  return {
    // define data to render UI
    definedSchema: (0, _fp.cloneDeep)(_Izenda5.default),

    UPDATE_DATA_BY_KEY_CHANGE: ['function', 'subTotal', 'grandTotal', 'format', 'sort', 'fieldNameAlias', 'fieldItemVisible', 'embeddedJavascript'],

    // list of widgets which are used to render UI
    widgets: WIDGETS,

    // data to binding to fields
    source: configField,

    // properties for different fields
    mappingProps: {
      fieldStore: itemProps.fieldStore,

      stypeOptions: _Izenda3.DRIL_DOWN_STYLE_OPTIONS,

      changeFieldNameAlias: function changeFieldNameAlias(newValue, oldAlias) {
        // Update new alias to agrregated field
        reportFilters.updateAggregatedFieldReportFieldAlias(oldAlias, newValue.value, configReportPart.headerTitle);

        configReportPart.updateContentWithFieldName && configReportPart.updateContentWithFieldName(oldAlias, newValue.value);
      },
      beforeChangeFormat: function beforeChangeFormat(newVal, otherInfo) {
        // Reset data in Report Part Element Properties
        var newFormat = (0, _fp.getOr)({}, (0, _fp.get)('format', otherInfo), _Izenda24.DATE_TIME_FORMAT);
        var oldFormat = (0, _fp.getOr)({}, (0, _fp.get)('fieldFormatData', otherInfo), _Izenda24.DATE_TIME_FORMAT);

        newFormat.INTERVAL_VALUE !== oldFormat.INTERVAL_VALUE && configField.properties.changeFunctionFormatAction && configField.properties.changeFunctionFormatAction();

        if (newVal && (0, _fp.isNil)(newVal.value)) {
          var originalArguments = arguments;

          return _Izenda12.default.getDefaultFormat(configField).then(function (defaultFormatInfo) {
            return defaultFormatInfo ? [{ value: (0, _fp.get)('id', defaultFormatInfo) }, defaultFormatInfo] : originalArguments;
          });
        }
        return (0, _bluebird.resolve)(arguments);
      },
      beforeChangeFunction: function beforeChangeFunction(newVal, otherInfo) {
        var container = itemProps.fieldContainerDetails;
        var originalArguments = arguments;
        var validateResult = reportPartContent.validateFunction(container, otherInfo);
        var confirmMessage = itemProps.confirmMessage;

        // Reset data in Report Part Element Properties
        configField.properties.changeFunctionFormatAction && configField.properties.changeFunctionFormatAction();

        var checkAggregatedFields = function checkAggregatedFields(itemProps) {
          var configField = itemProps.configField;
          var filterFields = itemProps.fieldStore.reportFilters.filterFields;

          if (configField.isAggregatedField) {
            var aggregatedFields = (0, _fp.filter)(function (field) {
              return !(0, _fp.isNil)(field.reportPartTitle);
            }, filterFields);

            if (!(0, _fp.isEmpty)(aggregatedFields)) {
              return itemProps.confirmFn('Confirmation', {
                description: _Izenda2.default.MESSAGES.M06
              });
            }
          }
          return (0, _bluebird.resolve)();
        };

        var getDefaultFunctionFormat = function getDefaultFunctionFormat(reportPartContent, container, configField) {
          return _Izenda12.default.getDefaultFunctionFormat(reportPartContent, container, configField).then(function (data) {
            var updateChangedOthersInfo = data.functionData;
            var defaultFunctionConfig = data.defaultFunctionConfig || {};
            // this field does not accept empty function

            if (defaultFunctionConfig.ON_NULL_FUNCTION === _Izenda6.ERROR_TYPE.ERROR_MESSAGE) {
              confirmMessage('error', String.format(_Izenda6.MESSAGES.M10, configField.field.fieldName));
            } else if (defaultFunctionConfig.ON_NULL_FUNCTION === _Izenda6.ERROR_TYPE.NOTIFY) {
              // this field accept empty function but warning message
              confirmMessage('error', _Izenda6.MESSAGES.M08);
            }

            if (updateChangedOthersInfo) {
              updateChangedOthersInfo.defaultFormat = data.formatData ? {
                formatId: data.formatData.id,
                format: data.formatData.format,
                groupBy: data.formatData.groupBy,
                formatDataType: data.formatData.formatDataType
              } : '';
              return [{
                value: updateChangedOthersInfo.id
              }, updateChangedOthersInfo];
            }

            return originalArguments;
          });
        };

        return checkAggregatedFields(itemProps).then(function () {
          if (!validateResult.status && validateResult.useDefaultFunction) {
            return getDefaultFunctionFormat(reportPartContent, container, configField);
          }
          var functionInfo = originalArguments[1];
          var originalValue = originalArguments[0];

          return _Izenda12.default.getDefaultFormat(configField, functionInfo).then(function (defaultFormatInfo) {
            if (defaultFormatInfo) {
              functionInfo = functionInfo || {};
              functionInfo.defaultFormat = {
                formatId: defaultFormatInfo.customId,
                format: defaultFormatInfo.format,
                groupBy: defaultFormatInfo.groupBy,
                formatDataType: defaultFormatInfo.formatDataType
              };
            }
            return [originalValue, functionInfo];
          });
        });
      },
      beforeChangeSorting: function beforeChangeSorting(newVal, otherInfo) {
        if (_Izenda14.default.isBinary(configField.field.dataFieldType)) {
          itemProps.confirmMessage('error', _Izenda2.default.MESSAGES.M08);
          return (0, _bluebird.reject)();
        }
        return (0, _bluebird.resolve)();
      },
      canUnsort: function canUnsort() {
        return reportPartContent.checkCanUnsort && reportPartContent.checkCanUnsort(itemProps.fieldContainerDetails);
      },
      resetDefaultAlternativeText: function resetDefaultAlternativeText() {
        configField.resetDefaultAlternativeText && configField.resetDefaultAlternativeText();
        // update html for form after a changed of field property.
        reportPartContent.updateHTMLCodeFieldContent && reportPartContent.updateHTMLCodeFieldContent(configField);
      },
      resetDefaultCustomURL: function resetDefaultCustomURL() {
        configField.resetDefaultCustomURL && configField.resetDefaultCustomURL();
        // update html for form after a changed of field property.
        reportPartContent.updateHTMLCodeFieldContent && reportPartContent.updateHTMLCodeFieldContent(configField);
      },
      resetDefaultSubReport: function resetDefaultSubReport() {
        configField.resetDefaultSubReport && configField.resetDefaultSubReport();
        // update html for form after a changed of field property.
        reportPartContent.updateHTMLCodeFieldContent && reportPartContent.updateHTMLCodeFieldContent(configField);
      },
      resetDefaultEmbeddedJavascript: function resetDefaultEmbeddedJavascript() {
        configField.resetDefaultEmbeddedJavascript && configField.resetDefaultEmbeddedJavascript();
        // update html for form after a changed of field property.
        reportPartContent.updateHTMLCodeFieldContent && reportPartContent.updateHTMLCodeFieldContent(configField);
      },

      resetDefaultSubTotal: (0, _mobx.action)(function () {
        configField.resetDefaultSubTotal && configField.resetDefaultSubTotal();
        // update html for form after a changed of field property.
        reportPartContent.updateHTMLCodeFieldContent && reportPartContent.updateHTMLCodeFieldContent(configField);
        // get new report part review data
        configReportPart.shouldUpdatePreview && itemProps.fieldStore.needUpdatePreview(configReportPart);
      }),
      resetDefaultGrandTotal: (0, _mobx.action)(function () {
        configField.resetDefaultGrandTotal && configField.resetDefaultGrandTotal();
        // update html for form after a changed of field property.
        reportPartContent.updateHTMLCodeFieldContent && reportPartContent.updateHTMLCodeFieldContent(configField);
        // get new report part review data
        configReportPart.shouldUpdatePreview && itemProps.fieldStore.needUpdatePreview(configReportPart);
      }),
      fnResetTextDefaultValue: function fnResetTextDefaultValue() {
        configField.resetTextDefaultValue && configField.resetTextDefaultValue();
        // update html for form after a changed of field property.
        reportPartContent.updateHTMLCodeFieldContent && reportPartContent.updateHTMLCodeFieldContent(configField);
      },
      fnResetCellDefaultValue: function fnResetCellDefaultValue() {
        configField.resetCellDefaultValue && configField.resetCellDefaultValue();
        // update html for form after a changed of field property.
        reportPartContent.updateHTMLCodeFieldContent && reportPartContent.updateHTMLCodeFieldContent(configField);
      },
      hasSettingAlternativeText: function hasSettingAlternativeText() {
        return !(0, _fp.isEqual)((0, _mobx.toJS)(configField.properties.dataFormattings.alternativeText), _Izenda15.DEFAULT_PROPERTIES_VALUE.dataFormattings.alternativeText);
      },
      getAlternativeText: function getAlternativeText() {
        var alternativeText = (0, _mobx.toJS)(configField.properties.dataFormattings.alternativeText) || _Izenda15.DEFAULT_PROPERTIES_VALUE.dataFormattings.alternativeText;

        return alternativeText;
      },
      getCustomUrl: function getCustomUrl() {
        var customURL = (0, _fp.getOr)({}, 'properties.dataFormattings.customURL', configField);
        return (0, _fp.pick)(['url', 'option', 'selectedIconValue', 'viewSettingByLink'], customURL);
      },
      hasSettingCustomURL: function hasSettingCustomURL() {
        return !!configField.properties.dataFormattings.customURL.url;
      },
      getEmbeddedScript: function getEmbeddedScript() {
        var embeddedJavascript = (0, _fp.getOr)({}, 'properties.dataFormattings.embeddedJavascript', configField);
        return (0, _fp.pick)(['script', 'selectedIconValue', 'viewSettingByLink'], embeddedJavascript);
      },
      hasSettingEmbeddedJavascript: function hasSettingEmbeddedJavascript() {
        return !!configField.properties.dataFormattings.embeddedJavascript.script;
      },
      getSubReport: function getSubReport() {
        var subReport = (0, _fp.getOr)({}, 'properties.drillDown.subReport', configField);
        return (0, _fp.pick)(['style', 'selectedReport', 'reportPartUsed', 'reportFilter', 'mappingFields', 'selectedIconValue', 'viewSettingByLink'], subReport);
      },
      hasSettingSubReport: function hasSettingSubReport() {
        var subReport = (0, _fp.getOr)({}, 'properties.drillDown.subReport', configField);

        return !!subReport.selectedReport;
      },
      hasSettingSubTotal: function hasSettingSubTotal() {
        var subTotal = (0, _fp.getOr)({}, 'properties.dataFormattings.subTotal', configField);

        return !(0, _fp.isEmpty)(subTotal.label);
      },
      hasSettingGrandTotal: function hasSettingGrandTotal() {
        var grandTotal = (0, _fp.getOr)({}, 'properties.dataFormattings.grandTotal', configField);
        return !(0, _fp.isEmpty)(grandTotal.label);
      },
      getDataSubTotal: function getDataSubTotal() {
        var subTotalData = configField.properties.dataFormattings.subTotal;

        subTotalData.querySourceId = configField.field.querySouceId;
        subTotalData.fieldDataType = configField.field.dataFieldType;
        subTotalData.previewRecord = reportDesignerModel.previewRecord;

        return subTotalData;
      },
      getDataGrandTotal: function getDataGrandTotal() {
        var grandTotalData = configField.properties.dataFormattings.grandTotal;

        grandTotalData.querySourceId = configField.field.querySouceId;
        grandTotalData.fieldDataType = configField.field.dataFieldType;
        grandTotalData.previewRecord = reportDesignerModel.previewRecord;

        return grandTotalData;
      },
      getDataTypeTextCellColor: function getDataTypeTextCellColor() {
        return {
          dataType: (0, _fp.get)('previewDataType', configField),
          dateTimeFormatData: (0, _fp.get)('dateTimeFormatData', configField),
          settingValue: (0, _mobx.toJS)(configField.properties.dataFormattings.color)
        };
      },
      getDateTimeFormatData: function getDateTimeFormatData() {
        return (0, _fp.get)('dateTimeFormatData', configField);
      },
      getSortValue: function getSortValue() {
        return configField.properties.dataFormattings;
      },
      getWordWrapValue: function getWordWrapValue() {
        return configField.properties.headerFormating;
      },
      getSortList: function getSortList() {
        if (reportPartContent.checkCanUnsort && !reportPartContent.checkCanUnsort(itemProps.fieldContainerDetails, itemProps.configField)) {
          return (0, _fp.map)((0, _fp.omit)(['headerIcon']), [_Izenda6.SORT_ORDERS.ASC, _Izenda6.SORT_ORDERS.DESC]);
        } else {
          return (0, _fp.map)((0, _fp.omit)(['headerIcon']), [_Izenda6.SORT_ORDERS.Unsorted, _Izenda6.SORT_ORDERS.ASC, _Izenda6.SORT_ORDERS.DESC]);
        }
      }
    },

    // defined-function which fields need to execute to get its data
    mappingSource: {
      getWidthValue: function getWidthValue() {
        return configField.properties.dataFormattings;
      },
      getFieldName: function getFieldName() {
        return configField.field && configField.field.visible ? configField.field.fieldName : _Izenda2.default.FIELD_HIDDEN_LABEL;
      },
      getFieldNameAlias: function getFieldNameAlias() {
        return configField.field && configField.field.visible ? configField.field.fieldNameAlias : _Izenda2.default.FIELD_HIDDEN_LABEL;
      },
      getDataType: function getDataType() {
        return configField.previewDataType;
      },
      isHiddenFunction: function isHiddenFunction() {
        var dataFieldType = configField && configField.getValueByKey('dataFieldType') || {};

        // We do not show function component when range option of chart is not null
        if (configReportPart.reportPartContent.type === _Izenda3.REPORT_PART_TYPE.Chart && (0, _fp.includes)(configReportPart.reportPartContent.chartType, [_Izenda10.CHART_TYPE.Column, _Izenda10.CHART_TYPE.Area, _Izenda10.CHART_TYPE.Bar]) && configReportPart.reportPartContent.properties.optionByType && configReportPart.reportPartContent.properties.optionByType.izRange && itemProps.fieldContainerDetails.name === 'values') {
          return true;
        }

        // hide functionf field-data-type is LargerObject (CLOB or BLOB or Image)
        return dataFieldType === 'LargerObject';
      },
      isHiddenCustomURL: function isHiddenCustomURL() {
        return authorization && !authorization.checkPrivileges([PERMISSION_KEY.ReportsFieldPropertiesCustomURL]);
      },
      isHiddenEmbeddedJavascript: function isHiddenEmbeddedJavascript() {
        return authorization && !authorization.checkPrivileges([PERMISSION_KEY.ReportsFieldPropertiesEmbeddedJavaScript]);
      },
      hiddenByReportPartType: function hiddenByReportPartType() {
        return reportPartContent.type !== _Izenda3.REPORT_PART_TYPE.Form;
      },
      isHiddenSubReport: function isHiddenSubReport() {
        return authorization && !authorization.checkPrivileges([PERMISSION_KEY.ReportsFieldPropertiesSubreport]);
      },
      isHiddenSort: function isHiddenSort() {
        // Hide sort in y-Axis for linear type
        var hideSortForValue = false;
        if (reportPartContent.type === _Izenda3.REPORT_PART_TYPE.Chart) {
          hideSortForValue = reportPartContent.isLinear() && containerName === _Izenda7.ContainerName.VALUES;
        }

        return configField.field.isRunningField || configField.hiddenSortFeature || !!(0, _fp.invokeArgs)('checkHiddenSortField', [configField, itemProps.fieldContainerDetails], configReportPart.reportPartContent) || hideSortForValue;
      },
      getFunctions: function getFunctions() {
        function filterData(data) {
          data = (0, _fp.concat)([_Izenda6.EMPTY_FUNCTION], data);

          if (!reportPartContent.checkedCompatibleFunction) {
            return data;
          }

          return (0, _fp.filter)(reportPartContent.checkedCompatibleFunction.bind(reportPartContent, itemProps.fieldContainerDetails, configField), data);
        }

        var querySourceId = (0, _fp.get)('querySourceId', configField.field);

        return _Izenda9.default.loadReportFunction(_Izenda6.FIELD_FUNCTION_MODE.FieldProperty, configField.getValueByKey('dataFieldType'), _Izenda17.default.tenantId, [querySourceId]).then(filterData);
      },
      getDataFormats: function getDataFormats() {
        var functionInfo = configField.getValueByKey('functionInfo') || {};
        var dataType = functionInfo.formatDataType || configField.getValueByKey('dataFieldType');

        return _Izenda9.default.loadReportFieldDataFormat(dataType).then(function (formats) {
          if (dataType === _Izenda3.DATA_TYPES.DATE_TIME) {
            // filter date time format that current user setting can supported
            return _Izenda23.default.filterDateTimeFormat(formats);
          }
          if (dataType === _Izenda3.DATA_TYPES.MONEY || dataType === _Izenda3.DATA_TYPES.NUMERIC) {
            return _Izenda12.default.filterFormatForField(reportPartContent, formats, configField.field.isRunningField, containerName);
          }

          return formats;
        });
      },
      getDataFormatsWidth: function getDataFormatsWidth() {
        return configField.properties.getDataValueByKey('width').value;
      },
      getDataFormatType: function getDataFormatType() {
        var format = configField.getValueByKey('format') || {};

        return format.formatId;
      },
      getDataFontFormat: function getDataFontFormat() {
        var fontConfig = configField.properties.dataFormattings.font || {};

        return {
          fontFamily: fontConfig.family,
          fontSize: fontConfig.size
        };
      },
      getDataFontStyle: function getDataFontStyle() {
        var fontConfig = configField.getValueByKey('font') || {};

        return {
          fontUnderline: fontConfig.underline,
          fontItalic: fontConfig.italic,
          fontBold: fontConfig.bold
        };
      },
      getHeaderFontFormat: function getHeaderFontFormat() {
        var fontConfig = configField.properties.headerFormating.font || {};

        return {
          fontFamily: fontConfig.family,
          fontSize: fontConfig.size
        };
      },
      getHeaderFontStyle: function getHeaderFontStyle() {
        var fontConfig = configField.properties.headerFormating.font || {};

        return {
          fontUnderline: fontConfig.underline,
          fontItalic: fontConfig.italic,
          fontBold: fontConfig.bold
        };
      },
      getDataAlignmentFormat: function getDataAlignmentFormat() {
        return configField.properties.dataFormattings.alignment;
      },
      getDataWordWrap: function getDataWordWrap() {
        return configField.properties.dataFormattings.wordWrap;
      },
      getHeaderAlignmentFormat: function getHeaderAlignmentFormat() {
        return configField.properties.headerFormating.alignment;
      },
      getHeaderVerticalAlignmentFormat: function getHeaderVerticalAlignmentFormat() {
        return configField.properties.headerFormating.verticalAlignment;
      },
      getDataFormattingVerticalAlignmentFormat: function getDataFormattingVerticalAlignmentFormat() {
        return configField.properties.dataFormattings.verticalAlignment;
      },
      getFieldStore: function getFieldStore() {
        return itemProps.fieldStore;
      },
      getSettingDataType: function getSettingDataType() {
        return (0, _fp.get)('previewDataType', configField);
      },
      getHeaderColorStyling: function getHeaderColorStyling() {
        return {
          textColor: configField.properties.headerFormating.font.color,
          backgroundColor: configField.properties.headerFormating.font.backgroundColor
        };
      },
      hiddenIconSettingSubReport: function hiddenIconSettingSubReport() {
        var type = configReportPart.reportPartContent.type;

        return (0, _fp.includes)(type, [_Izenda3.REPORT_PART_TYPE.Chart, _Izenda3.REPORT_PART_TYPE.Gauge, _Izenda3.REPORT_PART_TYPE.Map]);
      },
      checkUniqLinkOption: function checkUniqLinkOption() {
        var properties = configField.properties || {};

        return properties.checkUniqLinkOption.bind(properties);
      },
      checkEmbeddedLinkOption: function checkEmbeddedLinkOption() {
        var properties = configField.properties || {};

        return properties.checkEmbeddedLinkOption.bind(properties);
      },
      getAliasValidation: function getAliasValidation() {
        return {
          presence: {
            presence: true,
            message: _Izenda19.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_FIELD_NAME_ALIAS_MESSAGE_REQUIRED')
          },
          action: (0, _mobx.asReference)(function () {
            return function validateAlias(newName) {
              var isExisting = configReportPart.checkExistingFieldNameAlias && configReportPart.checkExistingFieldNameAlias(configField, newName);
              if (isExisting) {
                return (0, _bluebird.resolve)(String.format(MESSAGES.M09, reportDesignerModel.configReportPart.headerTitle));
              }

              // Field name can not contain '[', ']' character
              var invalidName = newName.indexOf('[') > -1 || newName.indexOf(']') > -1;
              if (invalidName) {
                return (0, _bluebird.resolve)(_Izenda19.default.getText('CALCULATED_FIELD_MESSAGE_INVALID_NAME'));
              }

              return (0, _bluebird.resolve)('');
            };
          })
        };
      },


      /**
       * Get field setting alias
       * @return {String} field name alias
       */
      getFieldSetting: function getFieldSetting() {
        return (0, _fp.getOr)('', 'field.fieldNameAlias', configField);
      },
      hiddenAlternativeTextByReportPartType: function hiddenAlternativeTextByReportPartType() {
        return reportPartContent.type === _Izenda3.REPORT_PART_TYPE.Grid || reportPartContent.type === _Izenda3.REPORT_PART_TYPE.Map;
      },
      hiddenColorByReportPartType: function hiddenColorByReportPartType() {
        return reportPartContent.type === _Izenda3.REPORT_PART_TYPE.Grid;
      },
      isRunningField: function isRunningField() {
        return (0, _fp.get)('field.isRunningField', configField);
      }
    },

    onChangeValue: (0, _mobx.action)('OnChangedFieldProps', function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
      var _this = this;

      var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
      var fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      // flag to check whether need to reload percentage-data to use for
      // setting: alternative text, text color, cell color...(range percent)
      var beforeUpdateNeedPercentageData = (0, _fp.invoke)('needPercentageData', configField.properties);

      var needUpdateChangeKey = this.UPDATE_DATA_BY_KEY_CHANGE || [];
      var oldAlias = configField.name;

      var dataFormattings = (0, _fp.getOr)({}, 'dataFormattings', schemaData) || {};
      var dataFormattingsFontFormat = (0, _fp.getOr)({}, 'fontFormat.value', dataFormattings) || {};
      var dataFormattingsFontStyle = (0, _fp.getOr)({}, 'fontStyle.value', dataFormattings) || {};
      var dataFormattingsAlternativeText = (0, _fp.getOr)({}, 'alternativeText.value', dataFormattings) || {};
      var customURL = (0, _fp.getOr)({}, 'customURL.value', dataFormattings);
      var embeddedJavascript = (0, _fp.getOr)({}, 'embeddedJavascript.value', dataFormattings);
      var headerFormating = (0, _fp.getOr)({}, 'headerFormating', schemaData) || {};
      var headerFormatingFontFormat = (0, _fp.getOr)({}, 'fontFormat.value', headerFormating) || {};
      var headerFormatingFontStyle = (0, _fp.getOr)({}, 'fontStyle.value', headerFormating) || {};
      var drillDown = (0, _fp.getOr)({}, 'drillDown', schemaData) || {};
      var subreport = (0, _fp.getOr)({}, 'subReport', drillDown) || {};
      var subReportValue = (0, _fp.getOr)({}, 'value', subreport) || {};
      var dataSource = (0, _fp.getOr)({}, 'dataSource', schemaData) || {};
      var headerFormatingColor = (0, _fp.getOr)({}, 'color.value', headerFormating) || {};
      var grandTotalData = (0, _fp.getOr)({}, 'grandTotal.value', dataFormattings) || {};
      var subTotalData = (0, _fp.getOr)({}, 'subTotal.value', dataFormattings) || {};
      var otherProps = (0, _fp.getOr)({}, 'otherProps', schemaData) || {};
      var dataFormattingsWidth = (0, _fp.get)('width.value', dataFormattings);

      if (changedKey !== 'width') {
        var width = (0, _fp.get)('width', dataFormattings);
        var values = (0, _fp.getOr)('props.values', width);
        values && (dataFormattingsWidth = (0, _fp.get)(values.propertyKey, values.loadValue));
      }

      var isChangeFunction = changedKey === 'function';

      if (changedKey === 'customURL' || changedKey === 'embeddedJavascript' || changedKey === 'subReport') {
        if ((0, _fp.get)('url', customURL) || (0, _fp.get)('selectedReport', subreport) || (0, _fp.get)('script', embeddedJavascript)) {
          reportPartContent.enableValueLabel && reportPartContent.enableValueLabel();
        }
      }

      if (changedKey === 'subReport' && (0, _fp.get)('style.value', subreport) === _Izenda3.DRIL_DOWN_STYLE.EMBEDDED) {
        switchToUseIconOptionInHyperlink();
      }

      var fieldInfo = {
        fieldNameAlias: changedKey === 'fieldNameAlias' || isChangeFunction ? (0, _fp.get)('fieldNameAlias.value', dataSource) : configField.name,
        visible: (0, _fp.get)('dataSource.visible.value', schemaData)
      };
      var format = isChangeFunction && changedOthersInfo && !(0, _fp.isNil)(changedOthersInfo.defaultFormat) ? changedOthersInfo.defaultFormat : getDataFormatValue();

      var cellColorSetting = (0, _fp.get)('color.value.settingValue.cellColor', dataFormattings);
      var textColorSetting = (0, _fp.get)('color.value.settingValue.textColor', dataFormattings);

      if (isChangeFunction || changedKey === FILED_OPTIONS.FormatKey) {
        resetSettingByRangeDataWhenChangeFuntionOrFormat();
      }

      var defaultAlternativeText = _Izenda15.DEFAULT_PROPERTIES_VALUE.dataFormattings.alternativeText;

      var propertiesInfo = {
        fieldItemVisible: (0, _fp.get)('dataSource.fieldItemVisible.value', schemaData),
        dataFormattings: {
          format: format,
          font: {
            family: dataFormattingsFontFormat.fontFamily,
            size: dataFormattingsFontFormat.fontSize,
            bold: dataFormattingsFontStyle.fontBold,
            italic: dataFormattingsFontStyle.fontItalic,
            underline: dataFormattingsFontStyle.fontUnderline
          },
          width: {
            value: dataFormattingsWidth
          },
          alignment: (0, _fp.get)('alignment.value', dataFormattings),
          verticalAlignment: (0, _fp.get)('verticalAlignment.value', dataFormattings),
          wordWrap: (0, _fp.get)('columnWordWrap.value', dataFormattings),
          sort: (0, _fp.get)('sort.value', dataFormattings) || '',
          color: {
            textColor: textColorSetting,
            cellColor: cellColorSetting
          },
          alternativeText: {
            value: (0, _fp.getOr)(defaultAlternativeText.value, 'value', dataFormattingsAlternativeText),
            rangeValue: (0, _fp.getOr)(defaultAlternativeText.rangeValue, 'rangeValue', dataFormattingsAlternativeText),
            rangePercent: (0, _fp.getOr)(defaultAlternativeText.rangePercent, 'rangePercent', dataFormattingsAlternativeText)
          },
          customURL: {
            url: (0, _fp.get)('url', customURL),
            option: (0, _fp.get)('option', customURL),
            selectedIconValue: (0, _fp.get)('selectedIconValue', customURL),
            viewSettingByLink: (0, _fp.get)('viewSettingByLink', customURL)
          },
          embeddedJavascript: {
            script: (0, _fp.get)('script', embeddedJavascript),
            selectedIconValue: (0, _fp.get)('selectedIconValue', embeddedJavascript),
            viewSettingByLink: (0, _fp.get)('viewSettingByLink', embeddedJavascript)
          },
          subTotal: subTotalData,
          grandTotal: grandTotalData
        },
        headerFormating: {
          font: {
            family: (0, _fp.get)('fontFamily', headerFormatingFontFormat),
            size: (0, _fp.get)('fontSize', headerFormatingFontFormat),
            bold: (0, _fp.get)('fontBold', headerFormatingFontStyle),
            italic: (0, _fp.get)('fontItalic', headerFormatingFontStyle),
            underline: (0, _fp.get)('fontUnderline', headerFormatingFontStyle),
            color: (0, _fp.get)('textColor', headerFormatingColor),
            backgroundColor: (0, _fp.get)('backgroundColor', headerFormatingColor)
          },
          alignment: (0, _fp.get)('alignment.value', headerFormating),
          verticalAlignment: (0, _fp.get)('verticalAlignment.value', headerFormating),
          wordWrap: (0, _fp.get)('wordWrap.value', headerFormating),
          columnGroup: (0, _fp.get)('columnGroup.value', headerFormating)
        },
        drillDown: {
          subReport: {
            selectedReport: subReportValue.selectedReport,
            style: subReportValue.style,
            reportPartUsed: subReportValue.reportPartUsed,
            reportFilter: subReportValue.reportFilter,
            mappingFields: subReportValue.gridData,
            selectedIconValue: subReportValue.selectedIconValue,
            viewSettingByLink: subReportValue.viewSettingByLink
          }
        },
        otherProps: otherProps
      };

      configField.updateData(fieldInfo, propertiesInfo);
      (0, _fp.invokeArgs)('changePropertiesByField', [configField, propertiesInfo, changedKey], configReportPart.reportPartContent);

      (0, _bluebird.resolve)().bind(this).then(function () {
        var manualChange = true;
        var mappingSource = _this.mappingSource;

        if (isChangeFunction) {
          // Remove filter details when change function to GROUP or GROUP DAYS OLD NAME
          var needRemoveAggregated = changedOthersInfo.name === _Izenda6.FUNCTION.GROUP.NAME || changedOthersInfo.name === _Izenda6.FUNCTION.GROUP_DAYS_OLD.NAME;

          var baseUpdate = function baseUpdate() {
            // update field name alias by changing of function.
            configField.field && configField.field.visible && (schemaData.dataSource.fieldNameAlias.value = configField.name);
            var formatSchema = schemaData.dataFormattings.format;
            // reload format data source by changing of function.
            mappingSource.getDataFormats().then(function (result) {
              formatSchema.props.promiseProps.options = result;
            });
            // update format value
            formatSchema.value = configField.properties.dataFormattings.format.formatId;
            // update sort value if chart is linear type
            reportPartContent.type === _Izenda3.REPORT_PART_TYPE.Chart && _Izenda12.default.isLinear(configField, reportPartContent.defaultOptionsByType) && (0, _fp.includes)(configField, reportPartContent.labelsElements) && reportPartContent.resetSortAscending(configField) && (schemaData.dataFormattings.sort.value = _Izenda7.SORT_TYPES.ASC);
            return null;
          };

          var afterUpdateFunction = (0, _fp.constant)(null);

          if (needRemoveAggregated) {
            reportFilters.removeAggregatedField(configField);
          } else {
            afterUpdateFunction = function afterUpdateFunction() {
              var newAlias = configField.name;

              reportFilters.updateAggregatedFieldReportFieldAlias(oldAlias, newAlias, configReportPart.headerTitle);
            };
          }

          return _Izenda12.default.setFunctionElement(reportPartContent, configField, (0, _fp.omit)('defaultFormat', changedOthersInfo) || {}, manualChange).then(afterUpdateFunction).then(baseUpdate);
        }
        return null;
      }).then(function () {
        if (oldAlias !== configField.name) {
          configReportPart.processAfterChangeFieldNameAlias(oldAlias, configField.name);
        }

        // update html for form after a changed of field property.
        reportPartContent.updateHTMLCodeFieldContent && reportPartContent.updateHTMLCodeFieldContent(configField);

        var afterUpdateNeedPercentageData = (0, _fp.invoke)('needPercentageData', configField.properties);

        if (changedKey === 'subReport') {
          var reportDesignerStore = fieldStore.reportStore;

          reportDesignerStore.model.setIgnoreCheckChange();

          return reportDesignerStore.saveDraftReport(_Izenda3.PAGE_NAME.FIELDS, true).then(function () {
            if (changedKey === 'subReport' && (0, _fp.get)('value.style', subreport) === _Izenda3.DRIL_DOWN_STYLE.EMBEDDED) {
              fieldStore.validateFilterFieldsTypeSubReport().then(function (result) {
                result && itemProps.confirmFn('Information', {
                  type: 'info_accept',
                  description: _Izenda19.default.getText('REPORTDESIGNER_FILTER_LOGIC_SUBREPORT'),
                  showCancel: false
                });
              });
            }
          });
        }

        if (reportPartContent.type === _Izenda3.REPORT_PART_TYPE.Form) {
          return null;
        } else if (needUpdateChangeKey.indexOf(changedKey) >= 0 || beforeUpdateNeedPercentageData != afterUpdateNeedPercentageData && afterUpdateNeedPercentageData) {
          return configReportPart.shouldUpdatePreview && itemProps.fieldStore.needUpdatePreview(configReportPart);
        }
        return null;
      });

      /**
       * check if need to reset setting by range data like Text Color, Cell Color, Alternative Text
       * @method resetSettingByRangeDataWhenChangeFuntionOrFormat
       */
      function resetSettingByRangeDataWhenChangeFuntionOrFormat() {
        var needResetSettingByrange = false;
        var functionInfo = isChangeFunction ? (0, _fp.omit)('defaultFormat', changedOthersInfo) : (0, _fp.getOr)({}, 'properties.dataFormattings.functionInfo', configField);

        var originalDataType = (0, _fp.get)('field.dataFieldType', configField);

        var curentDataType = configField.previewDataTypeByFunction;
        var nextDataType = _Izenda21.default.previewDataTypeByFunction(functionInfo, originalDataType);

        needResetSettingByrange = curentDataType !== nextDataType;

        if (!needResetSettingByrange && nextDataType === _Izenda3.DATA_TYPES.DATE_TIME) {
          // special case for date time
          var currentDateSetting = configField.dateTimeFormatData;
          var nextDateSetting = _Izenda21.default.getDateTimeFormatData(originalDataType, functionInfo, format);
          needResetSettingByrange = (0, _fp.isNil)(currentDateSetting) !== (0, _fp.isNil)(nextDateSetting) || (0, _fp.get)('groupBy', currentDateSetting) !== (0, _fp.get)('groupBy', nextDateSetting);
        }

        if (needResetSettingByrange) {
          dataFormattingsAlternativeText = (0, _fp.cloneDeep)(settingByRangeDefaultObj);
          textColorSetting = (0, _fp.cloneDeep)(settingByRangeDefaultObj);
          cellColorSetting = (0, _fp.assignWith)(function (objValue) {
            return (0, _fp.isUndefined)(objValue) ? (0, _fp.cloneDeep)(settingByRangeDefaultObj) : null;
          }, (0, _fp.cloneDeep)(settingByRangeDefaultObj), (0, _fp.get)('color.value.settingValue.cellColor', dataFormattings));
        }
      }

      /**
       * Get data for data format: id and groupBy value
       * @return {[type]} [description]
       */
      function getDataFormatValue() {
        changedOthersInfo = changedOthersInfo || {};
        var formatDataType = isChangeFunction && _Izenda21.default.previewDataTypeByFunction(changedOthersInfo, (0, _fp.get)('field.dataFieldType', configField));

        if (changedKey === FILED_OPTIONS.FormatKey) {
          if (!dataFormattings.format.value) {
            return {};
          }

          return {
            formatId: dataFormattings.format.value,
            format: changedOthersInfo.format || '',
            groupBy: changedOthersInfo.groupBy || null,
            formatDataType: changedOthersInfo.formatDataType,
            jsFormatString: changedOthersInfo.jsFormatString
          };
        } else if (isChangeFunction && formatDataType !== configField.previewDataType) {
          return {};
        }
        return undefined;
      }

      function switchToUseIconOptionInHyperlink() {
        if (customURL && customURL.url && customURL.viewSettingByLink) {
          customURL.viewSettingByLink = false;
          customURL.selectedIconValue = (0, _fp.find)(function (item) {
            return item.value != (0, _fp.get)('selectedIconValue.value', embeddedJavascript);
          }, ICON_TYPES);
        }
        if (embeddedJavascript && embeddedJavascript.script && embeddedJavascript.viewSettingByLink) {
          embeddedJavascript.viewSettingByLink = false;
          embeddedJavascript.selectedIconValue = (0, _fp.find)(function (item) {
            return item.value != (0, _fp.get)('selectedIconValue.value', customURL);
          }, ICON_TYPES);
        }
      }
    })
  };
};

__webpack_require__(55);

var _Izenda = __webpack_require__(53);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(1755);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(64);

var _Izenda7 = __webpack_require__(39);

var _Izenda8 = __webpack_require__(155);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _mobx = __webpack_require__(5);

var _Izenda10 = __webpack_require__(33);

var _Izenda11 = __webpack_require__(35);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(316);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(82);

var _Izenda16 = __webpack_require__(15);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(12);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(171);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(264);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(176);

var _Izenda25 = __webpack_require__(28);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(266);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _Izenda29 = __webpack_require__(186);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _Izenda31 = __webpack_require__(566);

var _Izenda32 = _interopRequireDefault(_Izenda31);

var _Izenda33 = __webpack_require__(944);

var _Izenda34 = _interopRequireDefault(_Izenda33);

var _Izenda35 = __webpack_require__(267);

var _Izenda36 = _interopRequireDefault(_Izenda35);

var _Izenda37 = __webpack_require__(317);

var _Izenda38 = _interopRequireDefault(_Izenda37);

var _Izenda39 = __webpack_require__(1849);

var _Izenda40 = _interopRequireDefault(_Izenda39);

var _Izenda41 = __webpack_require__(1850);

var _Izenda42 = _interopRequireDefault(_Izenda41);

var _Izenda43 = __webpack_require__(396);

var _Izenda44 = _interopRequireDefault(_Izenda43);

var _Izenda45 = __webpack_require__(945);

var _Izenda46 = _interopRequireDefault(_Izenda45);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var MESSAGES = _Izenda3.BUNDLE.MESSAGE;
var ICON_TYPES = _Izenda15.SUB_REPORT.ICON_TYPES;

var settingByRangeDefaultObj = {
  rangePercent: null,
  rangeValue: null,
  value: null
};

var WIDGETS = {
  Panel: _Izenda26.default,
  FontStyle: _Izenda28.default,
  FontFormat: _Izenda30.default,
  ButtonHighlight: _Izenda32.default,
  SizeSetting: _Izenda34.default,
  ColorStyling: _Izenda36.default,
  AlignmentSetting: _Izenda38.default,
  VerticalAlignmentSetting: _Izenda46.default,
  TextCellColorSettings: _Izenda40.default,
  CalculatedFieldProperties: _Izenda42.default,
  CustomInput: _Izenda44.default
};

var FILED_OPTIONS = {
  FormatKey: 'format',
  FunctionGroup: 'Group'
};

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  VALUE_TYPES: {
    none: {
      get label() {
        return _Izenda2.default.getText('SETTINGS_LABEL_NONE');
      }
    },
    value: {
      get label() {
        return _Izenda2.default.getText('SETTINGS_LABEL_VALUE');
      },
      dataStructure: {
        name: '',
        key: '',
        text: '',
        canDelete: true
      }
    },
    rangeValue: {
      get label() {
        return _Izenda2.default.getText('SETTINGS_LABEL_VALUE_RANGE');
      },
      dataStructure: {
        name: '',
        from: '',
        to: '',
        text: '',
        canDelete: true
      }
    },
    rangePercent: {
      get label() {
        return _Izenda2.default.getText('SETTINGS_LABEL_PERCENTAGE_RANGE');
      },
      dataStructure: {
        name: '',
        from: '',
        to: '',
        text: '',
        canDelete: true
      }
    }
  },
  BOOLEAN_OPTION: {
    options: [{
      value: 'true',
      get label() {
        return _Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_TRUE');
      }
    }, {
      value: 'false',
      get label() {
        return _Izenda2.default.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_FALSE');
      }
    }],
    blankOption: true
  },
  CONSTRAINTS: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('ROLE_SETUP_CONSTANT_CONSTRAINTS_REQUIRE_VALUE');
      }
    }
  },
  MESSAGE: {
    M02: {
      get DUPLICATE_NAME() {
        return _Izenda2.default.getText('SETTINGS_MESSAGE_NAME_HAS_BEEN_DEFINED');
      },
      get VALUE() {
        return _Izenda2.default.getText('SETTINGS_MESSAGE_COLOR_HAS_BEEN_DEFINED');
      },
      get RANGE_VALUE() {
        return _Izenda2.default.getText('SETTINGS_MESSAGE_RANGE_COLOR_HAS_BEEN_DEFINED');
      },
      get RANGE_PERCENT() {
        return _Izenda2.default.getText('SETTINGS_MESSAGE_PERCENT_COLOR_HAS_BEEN_DEFINED');
      },
      get INVALID_RANGE() {
        return _Izenda2.default.getText('SETTINGS_MESSAGE_INVALID_RANGE');
      }
    },
    M03: {
      get VALUE() {
        return _Izenda2.default.getText('SETTINGS_MESSAGE_ALTERNATIVE_TEXT_HAS_BEEN_DEFINED');
      },
      get RANGE_VALUE() {
        return _Izenda2.default.getText('SETTINGS_MESSAGE_RANGE_ALTERNATIVE_TEXT_HAS_BEEN_DEFINED');
      },
      get RANGE_PERCENT() {
        return _Izenda2.default.getText('SETTINGS_MESSAGE_PERCENT_ALTERNATIVE_TEXT_HAS_BEEN_DEFINED');
      },
      get INVALID_RANGE() {
        return _Izenda2.default.getText('SETTINGS_MESSAGE_INVALID_RANGE');
      }
    }
  },
  DATA_TYPE: {
    TEXT: 'Text',
    BOOLEAN: 'Boolean',
    NUMERIC: 'Numeric',
    DATETIME: 'Datetime',
    TIME: 'Time',
    MONEY: 'Money'
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRangeConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Droppable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/** http://gaearon.github.io/react-dnd/docs-overview.html */

!function () {
  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var DropTarget = __webpack_require__(378).DropTarget;

  var _require = __webpack_require__(1),
      pick = _require.pick;
  /**
   * A higher-order component that make a react component becomes droppable
   * @param  {ReactComponent} Component
   * @param  {String} types - This drop target will only react to the items produced by the drag sources of the specified type or types.
   * @param  {Object} options - Set of drop behaviors
   * @return {DroppableComponent}
   * @example
   *    var types = {
   *      CARD: 'CARD',
   *      DUMMY: 'DUMMY'
   *    };
   *
   *    var targetOptions = {
   *      drop: function (props, monitor, component) { },
   *      canDrop: function (props, monitor) { },
   *      ...
   *     };
   *    var InnerBox = require('./Box');
   *    var Box = droppable([types.CARD, types.DUMMY], targetOptions)(InnerBox);
   * 		...
   * 		<Box store={items} />
   */


  function droppable(types, options) {
    return function (Component) {
      /**
       * The collecting function.
       * Specifies which props to inject into your component. It should return a plain object of the props to inject into your component.
       * @param  {DropTargetConnector} connect
       * @param  {DropTargetMonitor} monitor
       * @return {Object}
       */
      function collect(connect, monitor) {
        return {
          connectDropTarget: connect.dropTarget(),
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
          item: monitor.getItem(), // A plain object representing the currently dragged item.
          canAccess: options.canAccess, // Handle can access callback.
          itemType: monitor.getItemType()
        };
      }

      /**
       * Build drop target specifications.
       * React dnd only accepts some spec methods.
       * @return {Object}
       */
      function specOptions() {
        return pick(['canDrop', 'hover', 'drop'], options);
      }

      var DroppableComponent = React.createClass({
        displayName: 'DroppableComponent',

        componentDidMount: function componentDidMount() {
          this.props.connectDropTarget(ReactDOM.findDOMNode(this));
        },
        render: function render() {
          var connectDropTarget = this.props.connectDropTarget;

          var getRef = function getRef(instance) {
            return connectDropTarget(ReactDOM.findDOMNode(instance));
          };

          return React.createElement(Component, (0, _extends3.default)({}, this.props, { ref: getRef }));
        }
      });

      return m.observer(DropTarget(types, specOptions(), collect)(DroppableComponent));
    };
  }

  module.exports = droppable;
}();

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.InputByDataType.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

__webpack_require__(1759);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(556);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputByDataType = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(InputByDataType, _Component);

  function InputByDataType() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, InputByDataType);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = InputByDataType.__proto__ || (0, _getPrototypeOf2.default)(InputByDataType)).call.apply(_ref, [this].concat(args))), _this), _this.onChangePopup = function (data) {
      return _this.onChange((0, _fp.getOr)(data, 'value', data));
    }, _this.onChange = function (newVal, arg) {
      var props = _this.props;
      var beforeOnChange = props.beforeOnChange;

      var newArgs = (0, _fp.concat)({ value: (0, _fp.isNaN)(newVal) ? null : newVal }, arg);

      var applyOnChange = function (updateParam) {
        newArgs = updateParam || newArgs;
        return (0, _bluebird.resolve)((0, _fp.invokeArgs)('onChange', newArgs, props));
      }.bind(_this);

      if (beforeOnChange) {
        return beforeOnChange.apply(_this, newArgs).then(applyOnChange);
      }
      return applyOnChange();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(InputByDataType, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var shouldUpdate = void 0;
      try {
        shouldUpdate = (0, _stringify2.default)(nextProps) !== (0, _stringify2.default)(this.props);
      } catch (e) {
        shouldUpdate = true;
      }

      return shouldUpdate;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var type = props.type;

      var hasValidation = (0, _fp.has)('validations', props);
      var rest = (0, _fp.omit)(['className', 'onChange', 'beforeOnChange', 'type', 'keyPath', 'validation', 'groupByDateTime', 'hiddenByState', !hasValidation ? 'field' : ''], props);

      //!hasValidation && (rest = omit('field', rest));

      if (!type) {
        return null;
      }

      var editProps = (0, _assign2.default)((0, _fp.omit)(['onChange', 'beforeOnChange'], props), {
        onChange: this.onChange.bind(this),
        onChangePopup: this.onChangePopup.bind(this)
      });

      var control = _Izenda2.default.create(type, editProps) || {
        component: _react2.default.createElement(
          'span',
          null,
          'Not support [',
          type,
          '] control'
        )
      };

      var newProps = (0, _assign2.default)(control.props || {}, rest);
      return _react2.default.createElement(
        control.component,
        newProps,
        (0, _fp.isNil)(control.child) ? null : control.child
      );
    }
  }]);
  return InputByDataType;
}(_react.Component), _class2.propTypes = {
  type: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  beforeOnChange: _react.PropTypes.func
}, _temp2)) || _class;

exports.default = InputByDataType;
module.exports = exports['default'];

/***/ }),
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

// ----------------------------------------------------------------------
// <copyright file="Izenda.DomUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Find parent node that has scrollbars
 * @param  {DOMElement} node DOM element to check
 */
function findScrollableParent(node) {
  while (node && node.parentNode) {
    node = node.parentNode;

    if (node === document) {
      // This particular node does not have a computed style.
      continue;
    }

    if (node === document.documentElement) {
      // This particular node does not have a scroll bar, it uses the window.
      continue;
    }

    if (node instanceof DocumentFragment) {
      continue;
    }

    var style = window.getComputedStyle(node);
    var overflowY = style.getPropertyValue('overflow-y') || style.getPropertyValue('overflow');

    if (overflowY === 'auto' || overflowY === 'scroll') {
      return node;
    }
  }
  return null;
}

/**
 * Detect collision between 2 DOM element node
 * @return {Boolean}       Whether collide or not
 */
function isNodeCollided(nodeA, nodeB) {
  var topA = nodeA.offsetTop;
  var leftA = nodeA.offsetLeft;
  var rightA = leftA + nodeA.offsetWidth;
  var bottomA = topA + nodeA.offsetHeight;

  var topB = nodeB.offsetTop;
  var leftB = nodeB.offsetLeft;
  var rightB = leftB + nodeB.offsetWidth;
  var bottomB = topB + nodeB.offsetHeight;

  return !(topA >= bottomB || rightA <= leftB || bottomA <= topB || leftA >= rightB);
}

function findRelativePositionToAcesstor(child, ancestor) {
  var childPosition = $izenda(child).offset();
  var ancestorPosition = $izenda(ancestor).offset();

  return {
    top: childPosition.top - ancestorPosition.top,
    left: childPosition.left - ancestorPosition.left
  };
}

exports.default = {
  isNodeCollided: isNodeCollided,
  findScrollableParent: findScrollableParent,
  findRelativePositionToAcesstor: findRelativePositionToAcesstor
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedSettingDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var ROOT_URL = 'advancedSetting/';

exports.default = {
  BASE_PATH: ROOT_URL,
  /**
   * Load Performance
   * @param {type} tenantId
   * @returns {type}
   */
  loadPerformance: function loadPerformance(tenantId) {
    var tenant = (0, _fp.isEmpty)(tenantId) ? '' : tenantId;

    return (0, _Izenda2.default)(ROOT_URL + 'Performance/' + tenant).get();
  },


  /**
   * Save Performance
   * @param {type} data
   * @returns {type}
   */
  savePerformance: function savePerformance(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'Performance/').post(data);
  },


  /**
   * Load other settings
   * @param {type} tenantId
   * @returns {type}
   */
  loadOther: function loadOther(tenantId) {
    var tenant = (0, _fp.isEmpty)(tenantId) ? '' : tenantId;

    return (0, _Izenda2.default)(ROOT_URL + 'miscSetting/' + tenant).get();
  },


  /**
   * Save other settings
   * @param {type} data
   * @returns {type}
   */
  saveOther: function saveOther(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'miscSetting/').post(data);
  },


  /**
   * Get all categories
   * @param {String} tenantId
   * @returns {promise}
   */
  getAllCategories: function getAllCategories(tenantId) {
    return (0, _Izenda2.default)(ROOT_URL + 'category/' + tenantId).get();
  },


  /**
   * Save Categories
   * @param {type} data
   * @returns {type}
   */
  saveCategories: function saveCategories(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'category/').post(data);
  },


  /**
   * Delete Category
   * @param {type} data
   * @returns {type}
   */
  deleteCategory: function deleteCategory(id) {
    return (0, _Izenda2.default)(ROOT_URL + 'category/' + id).delete();
  },


  /**
   * Get Tenant Security
   * @param {type} tenantId
   * @returns {type}
   */
  getTenantSecurity: function getTenantSecurity(tenantId) {
    var tenant = (0, _fp.isEmpty)(tenantId) ? '' : tenantId;

    return (0, _Izenda2.default)(ROOT_URL + 'security/' + tenant).get();
  },


  /**
   * Save Tenant Security
   * @param {type} data
   * @returns {type}
   */
  saveTenantSecurity: function saveTenantSecurity(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'security/').post(data);
  },


  /**
   * Get default image url
   * @returns {promise}
   */
  getDefaultImageUrl: function getDefaultImageUrl(tenantId) {
    if ((0, _fp.isNil)(tenantId)) {
      return (0, _Izenda2.default)(ROOT_URL + 'defaultImageUrl').get();
    }
    return (0, _Izenda2.default)(ROOT_URL + 'defaultImageUrl?tenantId=' + tenantId).get();
  },


  /**
   * Save default image url
   * @returns {promise}
   */
  saveDefaultImageUrl: function saveDefaultImageUrl(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'defaultImageUrl').post(data);
  },


  /**
   * Get default theme
   * @param {string} tenantId 
   */
  getDefaultTheme: function getDefaultTheme(tenantId) {
    var uri = (0, _fp.isNil)(tenantId) ? ROOT_URL + 'defaultTheme' : ROOT_URL + 'defaultTheme/' + tenantId;
    return (0, _Izenda2.default)(uri).get();
  },


  /**
   * Save default theme
   * @param {Object} data 
   */
  saveDefaultTheme: function saveDefaultTheme(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'defaultTheme').post(data);
  }
};
module.exports = exports['default'];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(176);

var _Izenda2 = __webpack_require__(15);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _fp = __webpack_require__(1);

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda4 = __webpack_require__(41);

var _Izenda5 = _interopRequireDefault(_Izenda4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  TimeZoneOffset: {
    // pattern for check when typing offset in input
    onChangePattern: /^(\+|\-)?((1[0-2])|0?[0-9])?$/,
    // pattern for check when finish typing, need to have number
    finishedPattern: /^(\+|\-)?((1[0-2])|0?[0-9])$/,
    // check value match with typing pattern
    checkTimeZoneFormatOnTyping: function checkTimeZoneFormatOnTyping(value) {
      return this.onChangePattern.test(value);
    },
    // check value match with finished pattern
    checkTimeZoneFormat: function checkTimeZoneFormat(value) {
      return this.finishedPattern.test(value);
    },
    // format number to have plus sign if possitive
    formatTimeZone: function formatTimeZone(value) {
      var prefix = value > 0 ? '+' : '';
      return prefix + value;
    }
  },

  /**
   * Get list of support date
   * @param {any} format date time format
   */
  filterDateTimeFormat: (0, _fp.filter)(function (format) {
    var listSupportedDateSetting = (0, _fp.get)('FOR_DATE_SETTING', _Izenda.DATE_TIME_FORMAT[format.name]);
    return (0, _fp.isNil)(listSupportedDateSetting) || (0, _fp.includes)(_Izenda3.default.currentUser.dateFormat, listSupportedDateSetting);
  }),

  /**
   * compare date string Format
   * @param {any} str1 first date string
   * @param {any} str2 second date string
   */
  compareDateStringFormat: function compareDateStringFormat(str1, str2) {
    var date1 = new Date(str1);
    var date2 = new Date(str2);

    return date1.getTime() > date2.getTime();
  },

  /**
   * Get current date time base on UTC time and time stamp offset
   */
  getUtcTimeWithTimestampOffset: function getUtcTimeWithTimestampOffset() {
    var currentDate = _moment2.default.utc();
    var defaultTimestampOffset = (0, _fp.getOr)(0, 'advancedSettings.other.timezoneForTimestampOffsetValue', _Izenda5.default);
    var userTimestampOffset = (0, _fp.get)('currentUser.timestampOffset', _Izenda3.default);
    var timestampOffset = !(0, _fp.isNil)(userTimestampOffset) ? userTimestampOffset : defaultTimestampOffset;
    currentDate.add(timestampOffset, 'hours');
    return currentDate;
  }
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimeUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.MapCollectionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

var WORLDS = {
  world: ['World', 'world']
};

var CONTINENTS = {
  africa: ['Africa', 'continents/africa'],
  antarctica: ['Antarctica', 'continents/antarctica'],
  asia: ['Asia', 'continents/asia'],
  'british-isles': ['British-Isles', 'continents/british-isles'],
  'usa-and-canada': ['Canada-and-United-States-of-America', 'continents/usa-and-canada'],
  'central-america': ['Central America', 'continents/central-america'],
  europe: ['Europe', 'continents/europe'],
  'middle-east': ['Middle East', 'continents/middle-east'],
  'nordic-countries': ['Nordic-Countries', 'continents/nordic-countries'],
  'north-america': ['North America', 'continents/north-america'],
  scandinavia: ['Scandinavia', 'continents/scandinavia'],
  'south-america': ['South America', 'continents/south-america']
};

var COUNTRIES = {
  af: ['Afghanistan', 'countries/af-all'],
  al: ['Albania', 'countries/al-all'],
  dz: ['Algeria', 'countries/dz-all'],
  as: ['American Samoa', 'countries/as-all'],
  ad: ['Andorra', 'countries/ad-all'],
  ao: ['Angola', 'countries/ao-all'],
  ag: ['Antigua and Barbuda', 'countries/ag-all'],
  ar: ['Argentina', 'countries/ar-all'],
  am: ['Armenia', 'countries/am-all'],
  au: ['Australia', 'countries/au-all'],
  at: ['Austria', 'countries/at-all'],
  az: ['Azerbaijan', 'countries/az-all'],
  bh: ['Bahrain', 'countries/bh-all'],
  bd: ['Bangladesh', 'countries/bd-all'],
  bb: ['Barbados', 'countries/bb-all'],
  by: ['Belarus', 'countries/by-all'],
  be: ['Belgium', 'countries/be-all'],
  bz: ['Belize', 'countries/bz-all'],
  bj: ['Benin', 'countries/bj-all'],
  bt: ['Bhutan', 'countries/bt-all'],
  bo: ['Bolivia', 'countries/bo-all'],
  ba: ['Bosnia and Herzegovina', 'countries/ba-all'],
  bw: ['Botswana', 'countries/bw-all'],
  br: ['Brazil', 'countries/br-all'],
  bn: ['Brunei', 'countries/bn-all'],
  bg: ['Bulgaria', 'countries/bg-all'],
  bf: ['Burkina Faso', 'countries/bf-all'],
  bi: ['Burundi', 'countries/bi-all'],
  kh: ['Cambodia', 'countries/kh-all'],
  cm: ['Cameroon', 'countries/cm-all'],
  ca: ['Canada', 'countries/ca-all', { STATE_LIST_NAME: 'CANADA_STATES', COUNTY_MAP: 'countries/ca-all-all' }],
  cv: ['Cape Verde', 'countries/cv-all'],
  cf: ['Central African Republic', 'countries/cf-all'],
  td: ['Chad', 'countries/td-all'],
  cl: ['Chile', 'countries/cl-all'],
  cn: ['China', 'countries/cn-all'],
  co: ['Colombia', 'countries/co-all'],
  km: ['Comoros', 'countries/km-all'],
  ck: ['Cook Islands', 'countries/ck-all'],
  cr: ['Costa Rica', 'countries/cr-all'],
  hr: ['Croatia', 'countries/hr-all'],
  cu: ['Cuba', 'countries/cu-all'],
  cy: ['Cyprus', 'countries/cy-all'],
  cz: ['Czech Republic', 'countries/cz-all'],
  cd: ['Democratic Republic of the Congo', 'countries/cd-all'],
  dk: ['Denmark', 'countries/dk-all'],
  dj: ['Djibouti', 'countries/dj-all'],
  dm: ['Dominica', 'countries/dm-all'],
  do: ['Dominican Republic', 'countries/do-all'],
  tl: ['East Timor', 'countries/tl-all'],
  ec: ['Ecuador', 'countries/ec-all'],
  eg: ['Egypt', 'countries/eg-all'],
  sv: ['El Salvador', 'countries/sv-all'],
  gq: ['Equatorial Guinea', 'countries/gq-all'],
  er: ['Eritrea', 'countries/er-all'],
  ee: ['Estonia', 'countries/ee-all'],
  et: ['Ethiopia', 'countries/et-all'],
  fo: ['Faroe Islands', 'countries/fo-all'],
  fj: ['Fiji', 'countries/fj-all'],
  fi: ['Finland', 'countries/fi-all'],
  fr: ['France', 'countries/fr-all'],
  ga: ['Gabon', 'countries/ga-all'],
  gm: ['Gambia', 'countries/gm-all'],
  ge: ['Georgia', 'countries/ge-all'],
  de: ['Germany', 'countries/de-all'],
  gh: ['Ghana', 'countries/gh-all'],
  gr: ['Greece', 'countries/gr-all'],
  gl: ['Greenland', 'countries/gl-all'],
  gd: ['Grenada', 'countries/gd-all'],
  gu: ['Guam', 'countries/gu-all'],
  gt: ['Guatemala', 'countries/gt-all'],
  gn: ['Guinea', 'countries/gn-all'],
  gw: ['Guinea Bissau', 'countries/gw-all'],
  gy: ['Guyana', 'countries/gy-all'],
  ht: ['Haiti', 'countries/ht-all'],
  hn: ['Honduras', 'countries/hn-all'],
  hu: ['Hungary', 'countries/hu-all'],
  is: ['Iceland', 'countries/is-all'],
  in: ['India', 'countries/in-all'],
  id: ['Indonesia', 'countries/id-all'],
  ir: ['Iran', 'countries/ir-all'],
  iq: ['Iraq', 'countries/iq-all'],
  ie: ['Ireland', 'countries/ie-all'],
  il: ['Israel', 'countries/il-all'],
  it: ['Italy', 'countries/it-all'],
  ci: ['Ivory Coast', 'countries/ci-all'],
  jm: ['Jamaica', 'countries/jm-all'],
  jp: ['Japan', 'countries/jp-all'],
  jo: ['Jordan', 'countries/jo-all'],
  kz: ['Kazakhstan', 'countries/kz-all'],
  ke: ['Kenya', 'countries/ke-all'],
  kv: ['Kosovo', 'countries/kv-all'],
  kw: ['Kuwait', 'countries/kw-all'],
  kg: ['Kyrgyzstan', 'countries/kg-all'],
  la: ['Laos', 'countries/la-all'],
  lv: ['Latvia', 'countries/lv-all'],
  lb: ['Lebanon', 'countries/lb-all'],
  ls: ['Lesotho', 'countries/ls-all'],
  lr: ['Liberia', 'countries/lr-all'],
  ly: ['Libya', 'countries/ly-all'],
  li: ['Liechtenstein', 'countries/li-all'],
  lt: ['Lithuania', 'countries/lt-all'],
  lu: ['Luxembourg', 'countries/lu-all'],
  mk: ['Macedonia', 'countries/mk-all'],
  mg: ['Madagascar', 'countries/mg-all'],
  mw: ['Malawi', 'countries/mw-all'],
  my: ['Malaysia', 'countries/my-all'],
  ml: ['Mali', 'countries/ml-all'],
  mt: ['Malta', 'countries/mt-all'],
  mr: ['Mauritania', 'countries/mr-all'],
  mu: ['Mauritius', 'countries/mu-all'],
  mx: ['Mexico', 'countries/mx-all'],
  md: ['Moldova', 'countries/md-all'],
  mc: ['Monaco', 'countries/mc-all'],
  mn: ['Mongolia', 'countries/mn-all'],
  me: ['Montenegro', 'countries/me-all'],
  ma: ['Morocco', 'countries/ma-all'],
  mz: ['Mozambique', 'countries/mz-all'],
  mm: ['Myanmar', 'countries/mm-all'],
  na: ['Namibia', 'countries/na-all'],
  nr: ['Nauru', 'countries/nr-all'],
  np: ['Nepal', 'countries/np-all'],
  nc: ['New Caledonia', 'countries/nc-all'],
  nz: ['New Zealand', 'countries/nz-all'],
  ni: ['Nicaragua', 'countries/ni-all'],
  ne: ['Niger', 'countries/ne-all'],
  ng: ['Nigeria', 'countries/ng-all'],
  kp: ['North Korea', 'countries/kp-all'],
  mp: ['Northern Mariana Islands', 'countries/mp-all'],
  no: ['Norway', 'countries/no-all'],
  om: ['Oman', 'countries/om-all'],
  pk: ['Pakistan', 'countries/pk-all'],
  pw: ['Palau', 'countries/pw-all'],
  pa: ['Panama', 'countries/pa-all'],
  pg: ['Papua New Guinea', 'countries/pg-all'],
  py: ['Paraguay', 'countries/py-all'],
  pe: ['Peru', 'countries/pe-all'],
  ph: ['Philippines', 'countries/ph-all'],
  pl: ['Poland', 'countries/pl-all'],
  pt: ['Portugal', 'countries/pt-all'],
  pr: ['Puerto Rico', 'countries/pr-all'],
  qa: ['Qatar', 'countries/qa-all'],
  rs: ['Republic of Serbia', 'countries/rs-all'],
  cg: ['Republic of the Congo', 'countries/cg-all'],
  ro: ['Romania', 'countries/ro-all'],
  ru: ['Russia', 'countries/ru-all'],
  rw: ['Rwanda', 'countries/rw-all'],
  kn: ['Saint Kitts and Nevis', 'countries/kn-all'],
  lc: ['Saint Lucia', 'countries/lc-all'],
  vc: ['Saint Vincent and the Grenadines', 'countries/vc-all'],
  ws: ['Samoa', 'countries/ws-all'],
  sm: ['San Marino', 'countries/sm-all'],
  st: ['Sao Tome and Principe', 'countries/st-all'],
  sa: ['Saudi Arabia', 'countries/sa-all'],
  sn: ['Senegal', 'countries/sn-all'],
  sc: ['Seychelles', 'countries/sc-all'],
  sl: ['Sierra Leone', 'countries/sl-all'],
  sg: ['Singapore', 'countries/sg-all'],
  sk: ['Slovakia', 'countries/sk-all'],
  si: ['Slovenia', 'countries/si-all'],
  sb: ['Solomon Islands', 'countries/sb-all'],
  so: ['Somalia', 'countries/so-all'],
  sx: ['Somaliland', 'countries/sx-all'],
  za: ['South Africa', 'countries/za-all'],
  kr: ['South Korea', 'countries/kr-all'],
  ss: ['South Sudan', 'countries/ss-all'],
  es: ['Spain', 'countries/es-all'],
  lk: ['Sri Lanka', 'countries/lk-all'],
  sd: ['Sudan', 'countries/sd-all'],
  sr: ['Suriname', 'countries/sr-all'],
  sz: ['Swaziland', 'countries/sz-all'],
  se: ['Sweden', 'countries/se-all'],
  ch: ['Switzerland', 'countries/ch-all'],
  sy: ['Syria', 'countries/sy-all'],
  tw: ['Taiwan', 'countries/tw-all'],
  tj: ['Tajikistan', 'countries/tj-all'],
  th: ['Thailand', 'countries/th-all'],
  bs: ['The Bahamas', 'countries/bs-all'],
  nl: ['The Netherlands', 'countries/nl-all'],
  tg: ['Togo', 'countries/tg-all'],
  tt: ['Trinidad and Tobago', 'countries/tt-all'],
  tn: ['Tunisia', 'countries/tn-all'],
  tr: ['Turkey', 'countries/tr-all'],
  tm: ['Turkmenistan', 'countries/tm-all'],
  ug: ['Uganda', 'countries/ug-all'],
  ua: ['Ukraine', 'countries/ua-all'],
  ae: ['United Arab Emirates', 'countries/ae-all'],
  gb: ['United Kingdom', 'countries/gb-all'],
  tz: ['United Republic of Tanzania', 'countries/tz-all'],
  vi: ['United States Virgin Islands', 'countries/vi-all'],
  us: ['United States of America', 'countries/us-all', { STATE_LIST_NAME: 'US_STATES', COUNTY_MAP: 'countries/us-all-all' }],
  'us-all-territories': ['United States of America with Territories', 'countries/us-all-territories', { STATE_LIST_NAME: 'US_STATES', COUNTY_MAP: 'countries/us-all-all', BASE_NAME: 'United States of America' }],
  uy: ['Uruguay', 'countries/uy-all'],
  uz: ['Uzbekistan', 'countries/uz-all'],
  vu: ['Vanuatu', 'countries/vu-all'],
  ve: ['Venezuela', 'countries/ve-all'],
  vn: ['Vietnam', 'countries/vn-all'],
  wf: ['Wallis and Futuna', 'countries/wf-all'],
  eh: ['Western Sahara', 'countries/eh-all'],
  ye: ['Yemen', 'countries/ye-all'],
  zm: ['Zambia', 'countries/zm-all'],
  zw: ['Zimbabwe', 'countries/zw-all']
};

var CANADA_STATES = {
  'ca-ab': ['Alberta', 'ca/ca-ab-all'],
  'ca-bc': ['British Columbia', 'ca/ca-bc-all'],
  'ca-mb': ['Manitoba', 'ca/ca-mb-all'],
  'ca-nb': ['New Brunswick', 'ca/ca-nb-all'],
  'ca-nl': ['Newfoundland and Labrador', 'ca/ca-nf-all'],
  'ca-nt': ['Northwest Territories', 'ca/ca-nt-all'],
  'ca-ns': ['Nova Scotia', 'ca/ca-ns-all'],
  'ca-nu': ['Nunavut', 'ca/ca-nu-all'],
  'ca-on': ['Ontario', 'ca/ca-on-all'],
  'ca-pe': ['Prince Edward Island', 'ca/ca-pe-all'],
  'ca-qc': ['Quebec', 'ca/ca-qc-all'],
  'ca-sk': ['Saskatchewan', 'ca/ca-sk-all'],
  'ca-yt': ['Yukon', 'ca/ca-yt-all']
};

var US_STATES = {
  'us-al': ['Alabama', 'us/us-al-all'],
  'us-ak': ['Alaska', 'us/us-ak-all'],
  'us-az': ['Arizona', 'us/us-az-all'],
  'us-ar': ['Arkansas', 'us/us-ar-all'],
  'us-ca': ['California', 'us/us-ca-all'],
  'us-co': ['Colorado', 'us/us-co-all'],
  'us-ct': ['Connecticut', 'us/us-ct-all'],
  'us-de': ['Delaware', 'us/us-de-all'],
  'us-dc': ['District of Columbia', 'us/us-dc-all'],
  'us-fl': ['Florida', 'us/us-fl-all'],
  'us-ga': ['Georgia', 'us/us-ga-all'],
  'us-hi': ['Hawaii', 'us/us-hi-all'],
  'us-id': ['Idaho', 'us/us-id-all'],
  'us-il': ['Illinois', 'us/us-il-all'],
  'us-in': ['Indiana', 'us/us-in-all'],
  'us-ia': ['Iowa', 'us/us-ia-all'],
  'us-ks': ['Kansas', 'us/us-ks-all'],
  'us-ky': ['Kentucky', 'us/us-ky-all'],
  'us-la': ['Louisiana', 'us/us-la-all'],
  'us-me': ['Maine', 'us/us-me-all'],
  'us-md': ['Maryland', 'us/us-md-all'],
  'us-ma': ['Massachusetts', 'us/us-ma-all'],
  'us-mi': ['Michigan', 'us/us-mi-all'],
  'us-mn': ['Minnesota', 'us/us-mn-all'],
  'us-ms': ['Mississippi', 'us/us-ms-all'],
  'us-mo': ['Missouri', 'us/us-mo-all'],
  'us-mt': ['Montana', 'us/us-mt-all'],
  'us-ne': ['Nebraska', 'us/us-ne-all'],
  'us-nv': ['Nevada', 'us/us-nv-all'],
  'us-nh': ['New Hampshire', 'us/us-nh-all'],
  'us-nj': ['New Jersey', 'us/us-nj-all'],
  'us-nm': ['New Mexico', 'us/us-nm-all'],
  'us-ny': ['New York', 'us/us-ny-all'],
  'us-nc': ['North Carolina', 'us/us-nc-all'],
  'us-nd': ['North Dakota', 'us/us-nd-all'],
  'us-oh': ['Ohio', 'us/us-oh-all'],
  'us-ok': ['Oklahoma', 'us/us-ok-all'],
  'us-or': ['Oregon', 'us/us-or-all'],
  'us-pa': ['Pennsylvania', 'us/us-pa-all'],
  'us-ri': ['Rhode Island', 'us/us-ri-all'],
  'us-sc': ['South Carolina', 'us/us-sc-all'],
  'us-sd': ['South Dakota', 'us/us-sd-all'],
  'us-tn': ['Tennessee', 'us/us-tn-all'],
  'us-tx': ['Texas', 'us/us-tx-all'],
  'us-ut': ['Utah', 'us/us-ut-all'],
  'us-vt': ['Vermont', 'us/us-vt-all'],
  'us-va': ['Virginia', 'us/us-va-all'],
  'us-wa': ['Washington', 'us/us-wa-all'],
  'us-wv': ['West Virginia', 'us/us-wv-all'],
  'us-wi': ['Wisconsin', 'us/us-wi-all'],
  'us-wy': ['Wyoming', 'us/us-wy-all']
};

/**
 * Get map information
 * @param  {string} key
 * @param  {array} mapList
 * @return {object}
 */
function getMapInfo(key, mapList) {
  var mapDetails = mapList ? mapList[key] : WORLDS[key] || CONTINENTS[key] || COUNTRIES[key] || [];
  return buildMapInfo(key, mapDetails);
}

/**
 * Build map information based on its definition,
 * key              value
 * first element    name
 * second element   file-path to get GEO file from server
 * third element    other information
 * @param  {string} key
 * @param  {array} mapDetails
 * @return {object}
 */
function buildMapInfo(key, mapDetails) {
  return {
    label: (0, _fp.nth)(0, mapDetails),
    value: key,
    geoFile: (0, _fp.nth)(1, mapDetails),
    others: (0, _fp.nth)(2, mapDetails)
  };
}

/**
 * build list of map
 * @param  {array} mapList
 * @return {array}
 */
function getList(mapList) {
  return (0, _keys2.default)(mapList).map(function (key) {
    return getMapInfo(key, mapList);
  });
}

/**
 * search map info by map level
 * @param  {string} mapLevel
 * @param  {object} geoPointProps
 * @return {object}
 */
function searchMapInfoByMapLevel(mapLevel, geoPointProps) {
  switch (mapLevel) {
    case 'CONTINENT':
      var continentName = (0, _fp.get)('properties.continent', geoPointProps) || (0, _fp.get)('continent', geoPointProps);
      return findMap(continentName, CONTINENTS);

    case 'COUNTRY':
      var countryId = (0, _fp.get)('id', geoPointProps) || (0, _fp.get)('hc-a2', geoPointProps);
      var countryKey = countryId.toLowerCase();
      return COUNTRIES[countryKey] && buildMapInfo(countryKey, COUNTRIES[countryKey]);

    case 'STATE':
      var stateKey = (0, _fp.get)('hc-key', geoPointProps) || (0, _fp.get)('hc-key', geoPointProps.properties);
      stateKey = (0, _fp.toLower)(stateKey);

      // only support states for Canada & US
      var map = CANADA_STATES[stateKey] || US_STATES[stateKey];
      return map && buildMapInfo(stateKey, map);
    default:
      return null;
  }
}

function findMap(name, mapDefs) {
  var found = (0, _fp.find)(function (map) {
    return name.toLowerCase() === map[0].toLowerCase();
  }, (0, _fp.values)(mapDefs));

  return found && buildMapInfo(null, found);
}

exports.default = {
  WORLDS: WORLDS,
  CONTINENTS: getList(CONTINENTS),
  COUNTRIES: getList(COUNTRIES),
  CANADA_STATES: getList(CANADA_STATES),
  US_STATES: getList(US_STATES),
  SUPPORTED_COUNTRY_COUNTRIES: ['ca', 'us', 'us-all-territories'],

  getMapInfo: getMapInfo,
  searchMapInfoByMapLevel: searchMapInfoByMapLevel
};
module.exports = exports['default'];

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FontStyle.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Font Style component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FontStyle = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(FontStyle, _Component);

  function FontStyle() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FontStyle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontStyle.__proto__ || (0, _getPrototypeOf2.default)(FontStyle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fontStyle: _this.props.value
    }, _this.handleClick = function (e) {
      var props = _this.props;
      var fontStyle = _this.state.fontStyle;
      fontStyle[e.target.value] = !fontStyle[e.target.value];

      _this.setState({ fontStyle: fontStyle }, function () {
        props.onChange && props.onChange({ value: fontStyle });
      });
    }, _this.renderButton = function (btnName) {
      var CLASS_FONTS = {
        fontBold: {
          class: 'text-bold',
          icon: 'B',
          title: _Izenda2.default.getText('FONT_STYLE_BOLD_TOOLTIP')
        },
        fontItalic: {
          class: 'text-italic',
          icon: 'I',
          title: _Izenda2.default.getText('FONT_STYLE_ITALIC_TOOLTIP')
        },
        fontUnderline: {
          class: 'text-underline',
          icon: 'U',
          title: _Izenda2.default.getText('FONT_STYLE_UNDERLINE_TOOLTIP')
        }
      };
      var fontStyle = _this.state.fontStyle;
      var buttonClass = (0, _classnames2.default)(CLASS_FONTS[btnName].class, 'btn-highlight', {
        active: fontStyle[btnName],
        'font-style-border': _this.props.border
      });

      return _react2.default.createElement(
        'button',
        {
          key: btnName,
          className: buttonClass,
          type: 'button',
          value: btnName,
          title: CLASS_FONTS[btnName].title,
          onClick: _this.handleClick
        },
        CLASS_FONTS[btnName].icon
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FontStyle, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ fontStyle: nextProps.value });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('btn-group font-style', this.props.className);

      return _react2.default.createElement(
        'div',
        { className: className, 'aria-label': _Izenda2.default.getText('FONT_STYLE_ARIA_LABEL') },
        this.renderButton('fontBold'),
        this.renderButton('fontItalic'),
        this.renderButton('fontUnderline')
      );
    }
  }]);
  return FontStyle;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  border: _propTypes2.default.bool
}, _class.defaultProps = {
  value: {
    fontBold: false,
    fontItalic: false,
    fontUnderline: false
  },
  border: false
}, _temp2);
exports.default = FontStyle;
module.exports = exports['default'];

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorStyling.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * ColorStyling Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(169);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(34);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColorStyling = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ColorStyling, _Component);

  function ColorStyling(props) {
    (0, _classCallCheck3.default)(this, ColorStyling);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ColorStyling.__proto__ || (0, _getPrototypeOf2.default)(ColorStyling)).call(this, props));

    _initialiseProps.call(_this);

    var value = _this.props.value || {};

    _this.state = {
      textColor: value.textColor,
      backgroundColor: value.backgroundColor
    };
    return _this;
  }

  (0, _createClass3.default)(ColorStyling, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value || {};

      this.setState({
        textColor: value.textColor,
        backgroundColor: value.backgroundColor
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var state = this.state;
      var _props = this.props,
          options = _props.options,
          className = _props.className;


      return _react2.default.createElement(
        'div',
        { className: className },
        !(0, _fp.isNil)(options.text) && this.renderColorPicker(state.textColor, 'textColor', 'icon-font', _Izenda4.default.getText('COLOR_STYLING_TEXT_TOOLTIP')),
        !(0, _fp.isNil)(options.background) && this.renderColorPicker(state.backgroundColor, 'backgroundColor', 'icon-tint', _Izenda4.default.getText('COLOR_STYLING_BACKGROUND_TOOLTIP'))
      );
    }
  }]);
  return ColorStyling;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.object,
  options: _propTypes2.default.object,
  type: _propTypes2.default.string,
  onChangeColor: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
}, _class.defaultProps = {
  value: {
    textColor: _Izenda6.default.textColor,
    backgroundColor: _Izenda6.default.backgroundColor
  },
  options: {
    text: true,
    background: true
  }
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.renderColorPicker = function (color, type, iconName, title) {
    var props = _this2.props;

    var onChangeColor = function onChangeColor(color) {
      var newValue = {};
      newValue[type] = color;

      _this2.setState(newValue, function () {
        props.onChange && props.onChange({ value: _this2.state }, { keyChange: type });
      });
    };

    return _react2.default.createElement(_Izenda2.default, {
      color: color,
      disabled: props.disabled,
      iconName: iconName,
      type: props.type,
      position: props.position,
      onChange: onChangeColor,
      title: title
    });
  };
}, _temp);
exports.default = ColorStyling;
module.exports = exports['default'];

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditorContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(1865);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(157);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1866);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PropertiesEditorContainer = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PropertiesEditorContainer, _React$Component);

  function PropertiesEditorContainer() {
    (0, _classCallCheck3.default)(this, PropertiesEditorContainer);
    return (0, _possibleConstructorReturn3.default)(this, (PropertiesEditorContainer.__proto__ || (0, _getPrototypeOf2.default)(PropertiesEditorContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(PropertiesEditorContainer, [{
    key: 'setPropertySchema',
    value: function setPropertySchema(propertyConfig) {
      this.propertyConfig = propertyConfig || {};
    }
  }, {
    key: 'buildSchemaData',
    value: function buildSchemaData(props) {
      var propertyConfig = props.propertyConfig || this.propertyConfig || {};
      this.propertiesEditorModel.setPropertyConfig(propertyConfig);
      this.schemaData = this.propertiesEditorModel.getDataBySchema();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.editorName && nextProps.editorName !== this.props.editorName) {
        _Izenda4.default.resetEditor(this.props.editorName);
        _Izenda4.default.addEditor(this, nextProps.editorName);
      }
      this.buildSchemaData(nextProps);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var editorName = this.props.editorName;
      editorName && _Izenda4.default.addEditor(this, editorName);

      this.propertiesEditorModel = new _Izenda2.default();
      this.buildSchemaData(this.props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var editorName = this.props.editorName;
      editorName && _Izenda4.default.resetEditor(editorName);
    }
  }, {
    key: 'render',
    value: function render() {
      var propertyConfig = this.props.propertyConfig || this.propertyConfig || {};

      return _react2.default.createElement(_Izenda6.default, (0, _extends3.default)({}, propertyConfig, {
        className: this.props.className,
        propertiesEditorModel: this.propertiesEditorModel,
        schemaData: this.schemaData
      }));
    }
  }]);
  return PropertiesEditorContainer;
}(_react2.default.Component), _class2.displayName = "PropertiesEditorContainer", _class2.propTypes = {
  propertyConfig: _react.PropTypes.object,
  editorName: _react.PropTypes.string,
  className: _react.PropTypes.string
}, _temp)) || _class;

exports.default = PropertiesEditorContainer;
module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure, $izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartDetails model
 */

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(270);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1900);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(53);

var _Izenda6 = __webpack_require__(35);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(16);

var _Izenda9 = __webpack_require__(84);

var _Izenda10 = __webpack_require__(96);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(41);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(54);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(181);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportPartDetails = (0, _Izenda15.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(ReportPartDetails, [{
    key: 'isBeingBuild',


    // check if report part is ready to get data
    get: function get() {
      return this.reportPartContent && this.reportPartContent.isBeingBuild;
    }
  }, {
    key: 'containerCollection',
    get: function get() {
      return this.reportPartContent && this.reportPartContent.containerCollection ? this.reportPartContent.containerCollection : [];
    }
  }, {
    key: 'fieldCollection',
    get: function get() {
      return (0, _fp.flatMap)(function (item) {
        return item.elements ? item.elements.slice() : [];
      }, this.containerCollection);
    }
  }, {
    key: 'configurableFieldCollection',
    get: function get() {
      return (0, _fp.flow)((0, _fp.filter)(function (item) {
        return item.name !== _Izenda18.ContainerName.DYNAMIC_THRESHOLD;
      }), (0, _fp.flatMap)(function (item) {
        return item.elements ? item.elements.slice() : [];
      }))(this.containerCollection);
    }
  }, {
    key: 'visibleFieldCollection',
    get: function get() {
      return (0, _fp.filter)(function (item) {
        return !!item.field.visible;
      }, this.fieldCollection);
    }
  }, {
    key: 'autoSize',
    get: function get() {
      return (0, _fp.getOr)(false, 'autoSize', this.reportPartContent);
    }
  }, {
    key: 'embededInfo',
    get: function get() {
      var result = (0, _fp.reduce)(function (acc, item) {
        acc.reportIds.push((0, _fp.get)('embededInfo.reportId', item));
        acc.reportPartIds = acc.reportPartIds.concat((0, _fp.getOr)([], 'embededInfo.reportPartIds', item));
        return acc;
      }, {
        reportIds: [],
        reportPartIds: []
      }, this.fieldCollection);
      var getUniq = (0, _fp.flow)(_fp.compact, _fp.uniq);

      return (0, _fp.mapValues)(getUniq, result);
    }
  }, {
    key: 'type',
    get: function get() {
      return this.reportPartContent && this.reportPartContent.type;
    }
  }, {
    key: 'isNew',
    get: function get() {
      return !String.isGuidFormat(this.id);
    }
  }, {
    key: 'isDelete',
    get: function get() {
      return this.state === _Izenda8.OBJECT_STATE.DELETE;
    }
  }, {
    key: 'previewData',
    get: function get() {
      return this.queryData.length === 1 ? this.queryData[0] : this.queryData;
    }
  }, {
    key: 'previewDataFieldsMapping',
    get: function get() {
      return this.previewData.fieldsMapping || [];
    }
  }, {
    key: 'previewDataRecords',
    get: function get() {
      return this.previewData.records || [];
    }
  }, {
    key: 'cities',
    get: function get() {
      return this.previewData.cities || [];
    }
  }, {
    key: 'postalCodes',
    get: function get() {
      return this.previewData.postalCodes || [];
    }
  }, {
    key: 'existInvisibleField',
    get: function get() {
      var invisibleField = (0, _fp.find)(function (item) {
        return !item.properties.fieldItemVisible;
      }, this.fieldCollection);
      return !!invisibleField;
    }
  }, {
    key: 'aggregatedFieldCollection',
    get: function get() {
      var _this = this;

      return (0, _fp.map)(function (field) {
        if (!_this.isDelete && (0, _fp.get)('isAggregatedField', field)) {
          return {
            dataType: field.fieldDataType,
            sourceFieldName: field.field.fieldNameAlias,
            reportFieldAlias: field.field.fieldNameAlias,
            querySourceFieldId: field.fieldId,
            sourceDataObjectName: 'Aggregated Field',
            querySourceType: 'Aggregated Field',
            sourceFieldVisible: true,
            sourceFieldFilterable: true,
            sortType: 'Unsorted',
            reportPartTitle: _this.headerTitle
          };
        }
      }, this.fieldCollection);
    }
  }, {
    key: 'shouldUpdatePreview',
    get: function get() {
      return _Izenda13.default.canShowPreview() && this.stateReview !== _Izenda5.DIRECTION_STATE.LEFT;
    }

    /**
     * Constructor
     * @param {Object} data
     * @param {boolean} isCopy
     * @param {Object} accessPriority
     */

  }]);

  function ReportPartDetails(data, isCopy, accessPriority) {
    (0, _classCallCheck3.default)(this, ReportPartDetails);

    _initDefineProp(this, 'accessPriority', _descriptor, this);

    _initDefineProp(this, 'isActive', _descriptor2, this);

    _initDefineProp(this, 'reportPartContent', _descriptor3, this);

    _initDefineProp(this, 'headerTitle', _descriptor4, this);

    _initDefineProp(this, 'previewTitle', _descriptor5, this);

    _initDefineProp(this, 'description', _descriptor6, this);

    _initDefineProp(this, 'reportId', _descriptor7, this);

    _initDefineProp(this, 'id', _descriptor8, this);

    _initDefineProp(this, 'positionX', _descriptor9, this);

    _initDefineProp(this, 'positionY', _descriptor10, this);

    _initDefineProp(this, 'width', _descriptor11, this);

    _initDefineProp(this, 'height', _descriptor12, this);

    _initDefineProp(this, 'state', _descriptor13, this);

    _initDefineProp(this, 'modified', _descriptor14, this);

    _initDefineProp(this, 'numberOfRecord', _descriptor15, this);

    _initDefineProp(this, 'isBackSide', _descriptor16, this);

    _initDefineProp(this, 'allowToSave', _descriptor17, this);

    _initDefineProp(this, 'queryData', _descriptor18, this);

    _initDefineProp(this, 'configField', _descriptor19, this);

    _initDefineProp(this, 'isLoadingData', _descriptor20, this);

    _initDefineProp(this, 'newestField', _descriptor21, this);

    _initDefineProp(this, 'onDrilldown', _descriptor22, this);

    _initDefineProp(this, 'stateReview', _descriptor23, this);

    this.clone = function () {
      var cloned = new ReportPartDetails();
      cloned.readData(this);
      cloned.headerTitle = this.headerTitle;

      var currentData = (0, _fp.getOr)({}, 'queryData[0]', this);
      cloned.setQueryData(currentData);
      return cloned;
    };

    this.accessPriority = accessPriority;
    this.embedReportDef = {
      reports: {},
      reportParts: {}
    };

    // element info store the container and position of report part element after save.
    // The element may change container and position when edit so we need to cache this info for sub report field mapping
    this.elementInfo = [];

    this.colorPalettes = [];
    this.validateDetail = null;
    data && this.readData(data, isCopy, accessPriority);
    this.cleanDirty();
  }

  /**
   * read data from API or from ReportBody addReportPart function
   * @param {Object} data JSON object preresent data
   * @param {boolean} isCopy
   * @param {Object} accessPriority
   */


  (0, _createClass3.default)(ReportPartDetails, [{
    key: 'readData',
    value: function readData(data, isCopy, accessPriority) {
      var type = data.reportPartContent && data.reportPartContent.type;
      this.id = data.id;
      this.isActive = data.isActive;
      this.headerTitle = data.title || '';
      this.reportId = data.reportId;
      this.positionX = data.positionX;
      this.positionY = data.positionY;
      this.width = data.width;
      this.height = data.height;
      this.state = (0, _fp.getOr)(_Izenda8.OBJECT_STATE.INSERT, 'state', data);
      this.numberOfRecord = data.numberOfRecord;
      if (!(0, _fp.isUndefined)(accessPriority)) {
        this.accessPriority = accessPriority;
      }

      this.setReportPartType(type);
      this.reportPartContent.readData && this.reportPartContent.readData(data.reportPartContent, isCopy);
      this.elementInfo = this.buildElementInfo();

      if (data.reportPartContent) {
        data.reportPartContent.title && (this.previewTitle = data.reportPartContent.title);
        data.reportPartContent.description && (this.description = data.reportPartContent.description);
      }

      this.newestField = null;
      this.allowToSave = data.allowToSave;
    }

    /**
     * build report part object for save
     * @returns {Object} save object
     */

  }, {
    key: 'buildDataForSave',
    value: function buildDataForSave() {
      var saveObject = (0, _fp.omit)(['id', 'headerTitle', 'previewTitle', 'description', 'previewData', 'embedReportDef', 'queryData', 'positionX', 'positionY', 'elementInfo', 'newestField', 'isLoadingData', 'onDrilldown', 'isBackSide'], this);

      // TODO: ask Tung Thach about ReportBodyContent line 94-101
      // HACK: ceil value of positionY and positionX when save data because backend only support interger
      saveObject.positionY = (0, _fp.floor)(this.positionY);
      saveObject.positionX = (0, _fp.floor)(this.positionX);

      saveObject.title = this.headerTitle;
      if (!saveObject.reportPartContent) {
        saveObject.reportPartContent = {};
      }
      if ((0, _fp.isFunction)(saveObject.reportPartContent.buildDataForSave)) {
        saveObject.reportPartContent = saveObject.reportPartContent.buildDataForSave();
      }
      saveObject.reportPartContent.title = this.previewTitle;
      saveObject.reportPartContent.description = this.description;

      this.checkDirty() && saveObject.state === _Izenda8.OBJECT_STATE.NONE && (saveObject.state = _Izenda8.OBJECT_STATE.UPDATE);
      !this.isNew && (saveObject.id = this.id);
      return saveObject;
    }

    /**
     * Set report part position
     * @param {Object} position object
     * @param {boolean} whether mark dirty or not
     */

  }, {
    key: 'setPosition',
    value: function setPosition(position, manual) {
      this.positionX = position.positionX;
      this.positionY = position.positionY;
      this.width = position.width;
      this.height = position.height;

      manual && this.markDirty();
    }

    /**
     * Set report part type
     * @param {string} value Type of report part
     */

  }, {
    key: 'setReportPartType',
    value: function setReportPartType(reportPartType) {
      var cfg = reportPartType && _Izenda17.default.getConfiguration(reportPartType);

      var hasConfig = cfg && cfg.model;

      this.reportPartContent = hasConfig ? new cfg.model() : { type: reportPartType };

      // If report part type is auto-sized, set fix width & height as it doesn't
      // have any meanings. Its size is dynamically determined when rendering, not
      // at design time.
      if (this.isNew && this.reportPartContent.autoSize) {
        this.width = 0;
        this.height = 0;
      }

      this.markDirty();
    }

    /**
     * clear all field in container
     * sample use case : clear separators container when uncheck
     * @param {Object} container
     */

  }, {
    key: 'clearContainer',
    value: function clearContainer(container) {
      container.elements = (0, _mobx.observable)([]);
    }

    /**
     * check drity status of this report part
     * @returns {boolean} dirty status
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      var reportPartContent = this.reportPartContent;

      return this.isDirty || reportPartContent && reportPartContent.checkDirty && reportPartContent.checkDirty();
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      (0, _fp.invoke)('cleanDirty', this.reportPartContent);

      this.resetDirty();
    }

    /**
     * insert new field as element into report part container
     * @param {Object} container   container will be insertFieldToContainer
     * @param {Object} field       field that element preresent
     * @param {Object} querySource query source contain field
     * @param {number} position
     * @returns {Object}
     */

  }, {
    key: 'insertFieldToContainer',
    value: function insertFieldToContainer(container, field, querySource, position, functionData) {
      var fieldName = field.alias || field.name;
      var nextPosition = position || ((0, _fp.flow)((0, _fp.map)('position'), _fp.max)(container.elements) || 0) + 1;

      var reportPartType = this.reportPartContent.type;
      var reportPartStyle = this.reportPartContent.reportPartStyle;
      var containerName = container.name;
      var defaultSort = _Izenda7.default.getDefaultSort(reportPartType, reportPartStyle, containerName);
      var newElement = new _Izenda2.default(field, querySource, fieldName, nextPosition, defaultSort);

      functionData && newElement.properties.setFunction(functionData);

      return this.commonInsertField(fieldName, newElement, container, nextPosition, !!functionData);
    }

    /**
     * Common Insert Field
     * @param {string} fieldName
     * @param {Object} newElement
     * @param {Object} container
     * @param {number} nextPosition
     * @param {boolean} notUpdateSelectedField
     * @returns {Object}
     */

  }, {
    key: 'commonInsertField',
    value: function commonInsertField(fieldName, newElement, container, nextPosition, notUpdateSelectedField) {
      var _this2 = this;

      var addDefaultFunctionPromise = (0, _bluebird.resolve)();
      nextPosition = nextPosition || ((0, _fp.flow)((0, _fp.map)('position'), _fp.max)(container.elements) || 0) + 1;

      newElement.setUniqueName(fieldName, this);
      this.markDirty();

      if (!newElement.haveFunction && !newElement.field.isRunningField) {
        addDefaultFunctionPromise = _Izenda7.default.setDefaultFunctionElement(this.reportPartContent, container, newElement);
      }

      var insertElementToContainerElementsArray = (0, _mobx.action)(function () {
        var needIncreasePosition = true;
        var uniqueNewName = _Izenda7.default.getUniqueName(_this2.reportPartContent, newElement, newElement.fieldNameAlias);

        newElement.setName(uniqueNewName);

        if (container.elements.slice()[nextPosition - 1]) {
          container.elements.splice(nextPosition - 1, 0, newElement);
        } else {
          needIncreasePosition = false;
          if (nextPosition > container.elements.length) {
            container.elements.length = nextPosition;
          }
          container.elements[nextPosition - 1] = newElement;
        }

        // keep a reference to latest element which is added to element-list
        !notUpdateSelectedField && (_this2.newestField = newElement);

        // update position of each field
        if (needIncreasePosition) {
          for (var i = nextPosition; i < container.elements.length; i++) {
            container.elements[i].position++;
          }
        }
        // update isLoadingData to prevent render old data in report part
        _this2.isLoadingData = true;

        return (0, _fp.invokeArgs)('afterInsertFieldToContainer', [container, newElement], _this2.reportPartContent) || null;
      });

      return addDefaultFunctionPromise.then(insertElementToContainerElementsArray).return(newElement);
    }

    /**
     * set report part name
     * @param {string} name new name
     */

  }, {
    key: 'setReportPartName',
    value: function setReportPartName(name) {
      this.headerTitle = (0, _fp.trim)(name);
      this.markDirty();
    }

    /**
     * set number of record
     * @param {string} numRecord input from ui
     */

  }, {
    key: 'setNumberOfRecord',
    value: function setNumberOfRecord(numRecord) {
      var number = parseInt(numRecord, 10);
      if ((0, _fp.isNaN)(number)) {
        this.numberOfRecord = '';
      } else {
        this.numberOfRecord = number <= 0 ? 0 : number;
      }
      this.markDirty();
    }

    /**
     * remove elements from report part
     * @param {Object} container container need remove elements
     * @param {Object} deleteElement element need to delete
     */

  }, {
    key: 'removeFieldFromContainer',
    value: function removeFieldFromContainer(container, deleteElement) {
      var idx = container.elements.indexOf(deleteElement);

      // reset config field
      if (this.configField === deleteElement) {
        this.resetConfigField();
      }

      // remove from container
      idx > -1 && container.elements.splice(idx, 1);

      // update position of elements after it
      (0, _fp.flow)((0, _fp.filter)(function (current) {
        return current.position > deleteElement.position;
      }), (0, _fp.forEach)(function (item) {
        item.position = item.position - 1;
      }))(container.elements);
      (0, _fp.invoke)('delete', deleteElement);

      this.reportPartContent.afterRemoveField && this.reportPartContent.afterRemoveField(container, deleteElement);

      this.markDirty();
    }

    /**
     * mark report part deleted
     */

  }, {
    key: 'delete',
    value: function _delete() {
      ensure(!this.isDelete, 'can\'t delete deleted object');
      !this.isNew && this.markDirty();
      this.state = _Izenda8.OBJECT_STATE.DELETE;

      // clear data refresh intervals (if any)
      this.clearRefreshData();
    }

    /**
     * Change position of field
     * @param {Object} field
     * @param {number} newPosition
     * @param {Object} container
     */

  }, {
    key: 'changePositionField',
    value: function changePositionField(field, newPosition, container) {
      if (newPosition > field.position + 1) {
        for (var i = field.position; i < newPosition - 1; i++) {
          container.elements[i].position--;
        }
        field.position = newPosition - 1;
      } else if (newPosition < field.position) {
        for (var _i = newPosition - 1; _i < field.position - 1; _i++) {
          container.elements[_i].position++;
        }
        field.position = newPosition;
      }

      if (container) {
        container.elements = (0, _mobx.observable)((0, _fp.sortBy)('position', container.elements));
      }

      (0, _fp.invokeArgs)('changePositionField', arguments, this.reportPartContent);
      this.markDirty();
    }

    /**
     * Change container of a field
     * @param {Object} field
     * @param {Object} newPosition
     * @param {Object} sourceContainer
     * @param {Object} targetContainer
     * @returns {Object}
     */

  }, {
    key: 'changeFieldContainer',
    value: function changeFieldContainer(field, newPosition, sourceContainer, targetContainer) {
      var reportPartType = (0, _fp.get)('reportPartContent.type', this);
      var reportPartStyle = (0, _fp.get)('reportPartContent.reportPartStyle', this);
      var containerName = targetContainer.name;

      var defaultSort = _Izenda7.default.getDefaultSort(reportPartType, reportPartStyle, containerName);
      // Clone new element
      var newElement = new _Izenda2.default().readData(field);
      newElement.position = newPosition;
      newElement.resetProperties(defaultSort);

      // Remove field from source conatiner avoid wrong field name alias
      this.removeFieldFromContainer(sourceContainer, field);

      return this.commonInsertField(newElement.field.fieldName, newElement, targetContainer, newPosition);
    }

    /**
     * Check duplicate field name alias in report part.
     * @param {any} checkingField
     * @param {string} newName
     * @returns {boolean}
     */

  }, {
    key: 'checkExistingFieldNameAlias',
    value: function checkExistingFieldNameAlias(checkingField, newName) {
      var currentAlias = (0, _fp.flow)([(0, _fp.remove)(function (item) {
        return item === checkingField;
      }), (0, _fp.map)((0, _fp.get)('fieldNameAlias'))])(this.fieldCollection);

      return String.checkDuplicate(newName, currentAlias);
    }

    /**
     * update title settings
     * @param {Object} titleSettings
     */

  }, {
    key: 'updateTitleSettings',
    value: function updateTitleSettings(titleSettings) {
      this.previewTitle.settings = this.getFontSettings(titleSettings);
      this.markDirty();
    }

    /**
     * update title text
     * @param {string} newPreviewTitle
     */

  }, {
    key: 'updateReportPartPreviewTitle',
    value: function updateReportPartPreviewTitle(newPreviewTitle) {
      this.previewTitle.text = newPreviewTitle.length <= _Izenda9.MAX_LENGTH_PREVIEW_TITLE ? newPreviewTitle : this.previewTitle.text;
      this.markDirty();
    }

    /**
     * update description settings
     * @param {Object} descriptionSettings
     */

  }, {
    key: 'updateDescriptionSettings',
    value: function updateDescriptionSettings(descriptionSettings) {
      this.description.settings = this.getFontSettings(descriptionSettings);
      this.markDirty();
    }

    /**
     * update description text
     * @param {string} descriptionText [new description text]
     */

  }, {
    key: 'updateReportPartDescription',
    value: function updateReportPartDescription(descriptionText) {
      this.description.text = descriptionText;
      this.markDirty();
    }

    /**
     * convert to font setting for UI
     * @param {Object} settings object contain font settings
     * @returns {Object}         object contain convert font setting
     */

  }, {
    key: 'getFontSettings',
    value: function getFontSettings(settings) {
      var fontSettings = {
        font: {
          family: settings.fontFamily,
          size: settings.fontSize,
          bold: settings.fontBold,
          italic: settings.fontItalic,
          underline: settings.fontUnderline,
          color: settings.fontColor,
          highlightColor: settings.fontHighlightColor
        },
        alignment: {
          alignment: settings.alignment
        }
      };

      return fontSettings;
    }

    /**
     * update previewData that use for display preview report part
     * @param {Object} previewData preview data from api
     * @param {boolean} isLoadingData
     */

  }, {
    key: 'setQueryData',
    value: function setQueryData(previewData, isLoadingData) {
      var data = (0, _fp.isArray)(previewData) ? previewData : [previewData];
      this.setLookupErrorMassage(previewData.messages);
      previewData.messages && (data = []);

      // NOTE: we cannot use replace() of ObservableArray here. The EVO cannot run that method.
      this.queryData = (0, _fp.map)(function (dataset) {
        return new _Izenda4.default(dataset);
      }, data);
      this.isLoadingData = isLoadingData || false;

      // this.previewData = previewData;
    }

    /**
     * Get data by data key
     * @param {string} key
     * @returns {Object}
     */

  }, {
    key: 'getDataValueByKey',
    value: function getDataValueByKey(key) {
      return this[key];
    }

    /**
     * set Report Part Properties
     * @param {Object} reportPartProperties
     */

  }, {
    key: 'setReportPartProperties',
    value: function setReportPartProperties(reportPartProperties) {
      var reportPartContent = this.reportPartContent;

      if (!reportPartContent) {
        return;
      }

      if (reportPartContent.setReportPartProperties) {
        reportPartContent.setReportPartProperties(reportPartProperties);
        return;
      }

      this.reportPartContent.properties = {};
      $izenda.extend(true, this.reportPartContent.properties, reportPartProperties);
    }

    /**
     * Get Report Part Properties
     * @returns {Object}
     */

  }, {
    key: 'getReportPartProperties',
    value: function getReportPartProperties() {
      if (!this.reportPartContent) {
        return null;
      }

      if (this.reportPartContent.getReportPartProperties) {
        return this.reportPartContent.getReportPartProperties();
      }

      return this.reportPartContent.properties;
    }

    /**
     * Set Config Field
     * @param {Object} field
     */

  }, {
    key: 'setConfigField',
    value: function setConfigField(field) {
      this.configField = field;
      // Update selected html element on form.
      field && this.reportPartContent.setSelectedFieldElement && this.reportPartContent.setSelectedFieldElement(field.fieldNameAlias);

      // Update selected field to chart
      field && this.reportPartContent.setConfigField && this.reportPartContent.setConfigField(field);
    }

    /**
     * Reset Config Field
     */

  }, {
    key: 'resetConfigField',
    value: function resetConfigField() {
      this.setConfigField(null);
    }

    /**
     * Mark all field visible
     */

  }, {
    key: 'setAllFieldVisible',
    value: function setAllFieldVisible() {
      this.fieldCollection.forEach(function (field) {
        field.properties.fieldItemVisible = true;
      });
      this.markDirty();
    }

    /**
     * Reload data based on data-refresh interval
     * @param {Object} dataRefreshInterval
     * @param {Function} fnGetData
     * @returns {undefined}
     */

  }, {
    key: 'refreshData',
    value: function refreshData(dataRefreshInterval, fnGetData) {
      dataRefreshInterval = dataRefreshInterval || {};

      var updateInterval = dataRefreshInterval.updateInterval;

      if (!dataRefreshInterval.enable || !dataRefreshInterval.updateInterval) {
        return this.clearRefreshData();
      }

      // refesh interval is changed
      if (this.refreshDataInterval !== updateInterval) {
        this.clearRefreshData();
      }

      if (!this.refreshDataProcess) {
        this.refreshDataInterval = updateInterval;
        this.refreshDataProcess = setInterval(function () {
          fnGetData(0);
        }, updateInterval * 1000);
      }
    }

    /**
     * Clear refresh data
     */

  }, {
    key: 'clearRefreshData',
    value: function clearRefreshData() {
      this.refreshDataProcess && clearInterval(this.refreshDataProcess);
      this.refreshDataProcess = null;
      this.refreshDataInterval = null;
    }

    /**
     * Calculate width height in px for container
     * @param {number} containerWidth
     * @param {number} containerHeigth
     * @returns {Object}
     */

  }, {
    key: 'getContainerSize',
    value: function getContainerSize(containerWidth, containerHeigth) {
      if (this.autoSize) {
        return {};
      }

      var width = _Izenda5.BODY_CELL_WIDTH * this.width;
      var height = _Izenda5.BODY_CELL_HEIGHT * this.height;

      if (containerWidth) {
        height = containerHeigth || containerWidth * height / width;
        width = containerWidth;
      }
      return this.autoSize ? {} : {
        height: height + 'px',
        width: width + 'px'
      };
    }

    /**
     * Get container info of report-part element
     * @param {Object} field
     */

  }, {
    key: 'getContainerDetails',
    value: function getContainerDetails(field) {
      var _this3 = this;

      return (0, _mobx.untracked)(function () {
        if (!field) {
          return null;
        }

        var fieldAlias = field.fieldName;
        var foundField = void 0;
        return (0, _fp.find)(function (container) {
          foundField = container.elements && (0, _fp.find)({
            fieldName: fieldAlias
          }, container.elements);

          return !!foundField;
        }, _this3.containerCollection);
      });
    }

    /**
     * Start load data
     */

  }, {
    key: 'startLoadData',
    value: function startLoadData() {
      this.isLoadingData = true;
    }

    /**
     * Read embeded report
     * @param {Object} embededReportDef
     */

  }, {
    key: 'readEmbededReportDef',
    value: function readEmbededReportDef(embededReportDef) {
      this.embedReportDef = embededReportDef;
    }

    /**
     * Update field name.
     * (For update name of calculated field)
     * @param {string} id
     * @param {string} originalName
     * @param {string} name
     * @param {Object} updatedCalField
     * @returns {boolean}
     */

  }, {
    key: 'updateField',
    value: function updateField(id, originalName, name, updatedCalField) {
      var change = false;

      (0, _fp.forEach)(function (fieldDetail) {
        if (fieldDetail.field.fieldId === id) {
          // update field name.
          fieldDetail.field.fieldName = name;
          if (updatedCalField) {
            fieldDetail.field.hasAggregatedFunction = updatedCalField.hasAggregatedFunction;
            fieldDetail.field.hasSupportDefaultTotal = updatedCalField.hasSupportDefaultTotal;
            fieldDetail.field.isRunningField = updatedCalField.isRunningField;
          }
          change = true;
        }
      }, this.fieldCollection);

      this.reportPartContent.updateContentWithFieldName && (change = this.reportPartContent.updateContentWithFieldName(originalName, name) || change);

      change && this.markDirty();
      return change;
    }

    /**
     * Check this report part has use calculated field
     * @param {string} id
     * @param {string} name
     * @returns {boolean}
     */

  }, {
    key: 'hasCalculatedField',
    value: function hasCalculatedField(id, name) {
      // Use in report part field
      var hasCalculatedField = !!(0, _fp.find)(function (fieldDetail) {
        return fieldDetail.field.fieldId === id;
      }, this.fieldCollection);

      // Use in grand total , sub total
      (0, _fp.forEach)(function (fieldDetail) {
        var subTotal = fieldDetail.properties.dataFormattings.subTotal;
        var grandTotal = fieldDetail.properties.dataFormattings.grandTotal;

        if (subTotal && subTotal.function === _Izenda11.default.FUNCTION_NAME.EXPRESSION && subTotal.expression.indexOf('[' + name + ']') > -1 || grandTotal && grandTotal.function === _Izenda11.default.FUNCTION_NAME.EXPRESSION && grandTotal.expression.indexOf('[' + name + ']') > -1) {
          hasCalculatedField = true;
        }

        return !hasCalculatedField;
      }, this.fieldCollection);

      return hasCalculatedField;
    }

    /**
     * Cache element position and container after receive from api for sub report field mapping
     * @returns {Object}
     */

  }, {
    key: 'buildElementInfo',
    value: function buildElementInfo() {
      var getContainerName = this.reportPartContent.getContainerName || (0, _fp.get)('name');
      var processElement = function processElement(container) {
        var containerName = getContainerName(container);

        return (0, _fp.map)(function (element) {
          return {
            element: element,
            container: containerName,
            position: element.position
          };
        }, container.elements);
      };

      return (0, _fp.flatMap)(processElement, this.containerCollection);
    }

    /**
     * Set cross filtering setting
     * @param {boolean} value
     */

  }, {
    key: 'setCrossFiltering',
    value: function setCrossFiltering(value) {
      this.reportPartContent.isCrossFiltering = value;
      this.markDirty();
    }

    /**
     * Do process after user change field name alias
     * + Update in Grand/Sub Total's Expression
     * + Update in Sub report mapping Fields
     * @param {string} oldAlias
     * @param {string} newAlias
     */

  }, {
    key: 'processAfterChangeFieldNameAlias',
    value: function processAfterChangeFieldNameAlias(oldAlias, newAlias) {
      (0, _fp.forEach)(function (field) {
        field.properties.updateGrandSubTotal(oldAlias, newAlias);
      }, this.fieldCollection);

      var fieldSubreport = (0, _fp.find)({
        fieldNameAlias: oldAlias
      }, (0, _fp.getOr)([], 'properties.subReport.mappingFields', this.configField));
      fieldSubreport && (fieldSubreport.fieldNameAlias = newAlias);
    }

    /**
     * Get cross filtering filter
     * @returns {Array<any>}
     */

  }, {
    key: 'getCrossFilteringFilter',
    value: function getCrossFilteringFilter() {
      var filters = (0, _fp.invoke)('getCrossFilteringInfo', this.reportPartContent);
      if (!(0, _fp.isEmpty)(filters)) {
        return filters.map(function (filterItem) {
          return {
            key: (0, _fp.get)('key', filterItem),
            value: (0, _fp.get)('value', filterItem),
            fieldId: (0, _fp.get)('field.fieldId', filterItem),
            field: (0, _fp.get)('field', filterItem)
          };
        });
      }

      return [];
    }

    /**
     * Update State Review
     * @param {number} value
     */

  }, {
    key: 'updateStateReview',
    value: function updateStateReview(value) {
      this.stateReview = value;
    }

    /**
     * Get theme colors
     * @param {Object} props
     */

  }, {
    key: 'getThemeColors',
    value: function getThemeColors(props) {
      var theme = (0, _fp.find)(function (item) {
        return (0, _fp.isUndefined)(props.colorTheme) ? item.isDefaultTheme : item.name === props.colorTheme;
      }, this.colorPalettes);
      return theme ? theme.colors : null;
    }

    /**
     * Clone report part detail
     * @return {Object}
     */

  }, {
    key: 'setLookupErrorMassage',


    /**
     * Update validate lookup filter error.
     * @param {Array<Object>} error 
     */
    value: function setLookupErrorMassage(error) {
      this.validateDetail = error;
    }

    /**
     * Get validate lookup filter error.
     * @param {Array<Object>} error 
     */

  }, {
    key: 'getLookupErrorMessage',
    value: function getLookupErrorMessage() {
      return (0, _fp.head)((0, _fp.get)('messages', (0, _fp.head)(this.validateDetail)));
    }
  }]);
  return ReportPartDetails;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'accessPriority', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isActive', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'reportPartContent', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'headerTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'previewTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      text: '',
      properties: {},
      settings: {
        font: {
          family: '',
          size: 14,
          bold: true,
          italic: false,
          underline: false,
          color: '',
          highlightColor: ''
        },
        alignment: {
          alignment: ''
        }
      },
      elements: []
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'description', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      text: '',
      properties: {},
      settings: {
        font: {
          family: '',
          size: 14,
          bold: false,
          italic: false,
          underline: false,
          color: '',
          highlightColor: ''
        },
        alignment: {
          alignment: ''
        }
      },
      elements: []
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'reportId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '0';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'positionX', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'positionY', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'width', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'height', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'state', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'modified', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'numberOfRecord', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'isBackSide', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'allowToSave', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'queryData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, 'configField', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, 'isLoadingData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, 'newestField', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, 'onDrilldown', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, 'stateReview', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda13.default.canShowPreview() ? _Izenda5.DIRECTION_STATE.NORMAL : _Izenda5.DIRECTION_STATE.LEFT;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'isBeingBuild', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isBeingBuild'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'containerCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'containerCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fieldCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'fieldCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'configurableFieldCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'configurableFieldCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'visibleFieldCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'visibleFieldCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'autoSize', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'autoSize'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'embededInfo', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'embededInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'type', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'type'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isNew', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isNew'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isDelete', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'previewData', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'previewData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'previewDataFieldsMapping', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'previewDataFieldsMapping'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'previewDataRecords', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'previewDataRecords'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cities', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cities'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'postalCodes', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'postalCodes'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'existInvisibleField', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'existInvisibleField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'aggregatedFieldCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'aggregatedFieldCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'shouldUpdatePreview', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'shouldUpdatePreview'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPosition', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setPosition'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setReportPartType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportPartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clearContainer', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clearContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'insertFieldToContainer', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'insertFieldToContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'commonInsertField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'commonInsertField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setReportPartName', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportPartName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setNumberOfRecord', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setNumberOfRecord'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeFieldFromContainer', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeFieldFromContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'delete', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'delete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changePositionField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changePositionField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeFieldContainer', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changeFieldContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateTitleSettings', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateTitleSettings'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateReportPartPreviewTitle', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateReportPartPreviewTitle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDescriptionSettings', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDescriptionSettings'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateReportPartDescription', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateReportPartDescription'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setQueryData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setQueryData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setReportPartProperties', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportPartProperties'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setConfigField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setConfigField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetConfigField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetConfigField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setAllFieldVisible', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setAllFieldVisible'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'startLoadData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'startLoadData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setCrossFiltering', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setCrossFiltering'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processAfterChangeFieldNameAlias', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processAfterChangeFieldNameAlias'), _class2.prototype)), _class2)) || _class;

exports.default = ReportPartDetails;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(26)))

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartElement.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartElement model
 */
!function () {
  var m = __webpack_require__(5);
  var setValue = __webpack_require__(223);
  var ReportPartElementUtils = __webpack_require__(171);
  var ReportPartElementProperties = __webpack_require__(960);
  var ReportDesignerConstants = __webpack_require__(16);
  var DATA_TYPES = ReportDesignerConstants.DATA_TYPES;
  var NO_SORT_DATA_TYPES = ReportDesignerConstants.NO_SORT_DATA_TYPES;
  var trackable = __webpack_require__(46);
  var FUNCTION = __webpack_require__(64).FUNCTION;
  var propertiesBuilderConstants = __webpack_require__(82);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      flow = _require.flow,
      get = _require.get,
      clone = _require.clone,
      includes = _require.includes,
      flatMap = _require.flatMap,
      trim = _require.trim,
      without = _require.without;

  /**
   * ReportPartElement
   * @param {field} field        Field of elements
   * @param {querySource} querySource querySource of elements
   * @param {string} name        name of elements
   * @param {int} position    position in container
   */


  function ReportPartElement(field, querySource, name, position, defaultSort) {
    field = field || {};
    querySource = querySource || {};
    this.reportPartContent = null;

    var props = {
      repeaterLevel: 0,
      name: name || '',
      properties: new ReportPartElementProperties(defaultSort),
      position: position || 0,
      field: {
        fieldId: field.id,
        fieldName: field.name,
        fieldNameAlias: name,
        dataFieldType: field.izendaDataType,
        querySourceId: field.querySourceId,
        querySourceType: querySource.isAlias ? null : querySource.type,
        sourceAlias: querySource.name,
        relationshipId: querySource.isAlias ? querySource.id : null,
        visible: true, // false
        calculatedTree: null,
        schemaName: querySource.querySourceCategoryName,
        querySourceName: querySource.name,
        databaseName: querySource.connectionName,
        isCalculated: field.isCalculated,
        isRunningField: field.isRunningField,
        hasAggregatedFunction: field.hasAggregatedFunction,
        hasSupportDefaultTotal: field.hasSupportDefaultTotal
      },

      embededInfo: function embededInfo() {
        var subReport = get('drillDown.subReport', this.properties);
        var selectedReport = get('selectedReport', subReport);
        var reportPartUsed = get('reportPartUsed', subReport);
        if (subReport.style !== ReportDesignerConstants.DRILL_DOWN_STYLE_OPTION_VALUES.embedded) {
          return {
            reportId: null,
            reportPartIds: []
          };
        }
        return {
          reportId: reportPartUsed === 'All' ? selectedReport : null,
          reportPartIds: reportPartUsed !== 'All' ? reportPartUsed.split(',') : []
        };
      },

      haveFunction: function haveFunction() {
        return this.field.hasAggregatedFunction || !!this.properties.dataFormattings.function;
      },

      fieldId: function fieldId() {
        return this.field.fieldId;
      },

      fieldFullName: function fieldFullName() {
        return String.format('[{0}].[{1}].[{2}].[{3}]', this.field.databaseName, this.field.schemaName, this.field.querySourceName, this.field.fieldName);
      },

      fieldName: function fieldName() {
        return this.field.fieldNameAlias || this.field.fieldName || this.name;
      },

      fieldNameAlias: function fieldNameAlias() {
        return this.fieldName;
      },
      isDeleted: false,
      isSelected: false,

      fieldFormatData: function fieldFormatData() {
        var properties = this.properties;
        var fieldFormat = properties.getValueByKey && properties.getValueByKey('format');

        return fieldFormat && fieldFormat.format;
      },

      previewDataType: function previewDataType() {
        return this.previewDataTypeByFunction;
      },

      isDateTimeType: function isDateTimeType() {
        return this.fieldDataType === ReportDesignerConstants.DATA_TYPES.DATE_TIME;
      },

      dateTimeFormatData: m.asStructure(function () {
        return ReportPartElementUtils.getDateTimeFormatData(get('field.dataFieldType', this), this.properties.getDataValueByKey('functionInfo'), this.properties.getValueByKey('format'));
      }),

      previewDataTypeByFunction: function previewDataTypeByFunction() {
        return ReportPartElementUtils.previewDataTypeByFunction(this.properties.getDataValueByKey('functionInfo') || {}, get('field.dataFieldType', this));
      },

      isVisible: function isVisible() {
        return get('field.visible', this) && get('properties.fieldItemVisible', this);
      },

      isNumericPreviewData: function isNumericPreviewData() {
        return [DATA_TYPES.NUMERIC, DATA_TYPES.MONEY].indexOf(this.previewDataType) > -1;
      },

      hasSubReport: function hasSubReport() {
        return !!get('drillDown.subReport.selectedReport', this.properties);
      },

      hasSubTotal: function hasSubTotal() {
        return !isEmpty(this.properties.dataFormattings.subTotal.label);
      },

      fieldDataType: function fieldDataType() {
        return this.field && this.field.dataFieldType;
      },

      hiddenSortFeature: function hiddenSortFeature() {
        return includes(this.previewDataType, NO_SORT_DATA_TYPES);
      },

      numberOfPointActions: function numberOfPointActions() {
        var properties = this.properties;
        var subReport = properties.getValueByKey('subReport');
        var customURL = properties.getValueByKey('customURL');
        var embeddedJavascript = properties.getValueByKey('embeddedJavascript');
        var count = 0;
        subReport && subReport.selectedReport && count++;
        customURL && customURL.url && count++;
        embeddedJavascript && embeddedJavascript.script && count++;
        return count;
      },

      isAggregatedField: function isAggregatedField() {
        var functionInfo = this.functionInfo;
        return !this.isDeleted && !isEmpty(functionInfo) && !!functionInfo.name && functionInfo.name !== FUNCTION.GROUP.NAME && functionInfo.name !== FUNCTION.GROUP_DAYS_OLD.NAME;
      },
      functionInfo: function functionInfo() {
        var properies = this.properties || {};
        var dataFormattings = properies.dataFormattings || {};
        var functionInfo = dataFormattings.functionInfo || {};

        return functionInfo;
      }
    };

    m.extendObservable(trackable(this), props);

    m.autorun(function () {
      return this.hiddenSortFeature && this.properties.setSortValue('');
    }.bind(this));

    this.cleanDirty();
  }

  ReportPartElement.prototype.getValueByKey = function (key) {
    return !this.isDeleted ? this[key] || this.field[key] || this.properties.getValueByKey(key) : undefined;
  };

  ReportPartElement.prototype.delete = m.action(function () {
    this.isDeleted = true;
  });

  ReportPartElement.prototype.resetProperties = m.action(function (defaultSort) {
    this.properties = new ReportPartElementProperties(defaultSort);
  });

  /**
   * read data from api to populate data for this object
   * @param  {Object} data [elements JSON from api]
   * @return {ReportPartElement}      [this object]
   */
  ReportPartElement.prototype.readData = m.action(function (data) {
    setValue(this, 'name', data.name);
    setValue(this, 'position', data.position);

    var field = this.field;
    var fieldData = data.field || {};

    setValue(field, 'querySourceId', fieldData.querySourceId);
    setValue(field, 'fieldId', fieldData.fieldId);
    setValue(field, 'fieldName', fieldData.fieldName);
    setValue(field, 'fieldNameAlias', fieldData.fieldNameAlias);
    setValue(field, 'dataFieldType', fieldData.dataFieldType);
    setValue(field, 'visible', fieldData.visible);
    setValue(field, 'schemaName', fieldData.schemaName);
    setValue(field, 'querySourceName', fieldData.querySourceName);
    setValue(field, 'databaseName', fieldData.databaseName);
    setValue(field, 'calculatedTree', fieldData.calculatedTree);
    setValue(field, 'isCalculated', fieldData.isCalculated);
    setValue(field, 'querySourceType', fieldData.querySourceType);
    setValue(field, 'sourceAlias', fieldData.sourceAlias);
    setValue(field, 'relationshipId', fieldData.relationshipId);
    setValue(field, 'hasAggregatedFunction', fieldData.hasAggregatedFunction);
    setValue(field, 'hasSupportDefaultTotal', fieldData.hasSupportDefaultTotal);
    setValue(field, 'isRunningField', fieldData.isRunningField);

    this.properties.updateData(data.properties);
    this.cleanDirty();
    return this;
  });

  /**
   * check drity status of this elements
   * @return {boolean} dirty status
   */
  ReportPartElement.prototype.checkDirty = function () {
    return this.isDirty || this.properties.checkDirty && this.properties.checkDirty();
  };

  /**
   * Clean dirty status.
   */
  ReportPartElement.prototype.cleanDirty = m.action(function () {
    this.properties.resetDirty && this.properties.resetDirty();

    this.resetDirty();
  });

  /**
   * Update data of field in report parts and its properties
   * @param  {[type]} fieldInfo       [description]
   * @param  {[type]} propertiesInfo  [description]
   * @param  {[type]} querySourceInfo [description]
   * @return {[type]}                 [description]
   */
  ReportPartElement.prototype.updateData = m.action(function (fieldInfo, propertiesInfo, querySourceInfo) {
    var field = this.field;

    fieldInfo = fieldInfo || {};
    querySourceInfo = querySourceInfo || {};

    this.setName(fieldInfo.fieldNameAlias);

    setValue(field, 'querySouceId', querySourceInfo.querySouceId);

    setValue(field, 'fieldId', fieldInfo.fieldId);
    setValue(field, 'fieldName', fieldInfo.fieldName);
    setValue(field, 'dataFieldType', fieldInfo.dataFieldType);
    setValue(field, 'calculatedTree', fieldInfo.calculatedTree);
    setValue(field, 'isCalculated', fieldInfo.isCalculated);
    setValue(field, 'querySourceType', fieldInfo.querySourceType);
    setValue(field, 'sourceAlias', fieldInfo.sourceAlias);
    setValue(field, 'relationshipId', fieldInfo.relationshipId);

    this.setProperties(propertiesInfo);

    this.markDirty();
  });

  /**
   * Set properties of field
   * @param  {object} propertiesInfo
   * @return undefined
   */
  ReportPartElement.prototype.setProperties = m.action(function (propertiesInfo) {
    // update field properties
    this.properties.updateData(propertiesInfo || {});
    this.markDirty();
  });

  /**
   * Set other properties
   */
  ReportPartElement.prototype.setOtherProps = m.action(function (key, value) {
    // update field properties
    this.properties.setOtherProps(key, value);
    this.markDirty();
  });

  /**
   * [setUniqueName Set Unique name for field]
   * @method setUniqueName
   * @param  {string}      name             Base string
   * @param  {ReportPartDetail}      reportPartDetail ReportPartDetail
   */
  ReportPartElement.prototype.setUniqueName = m.action(function (name, reportPartDetail) {
    var elements = flow(flatMap(function (container) {
      return container.elements ? container.elements.peek() : [];
    }), without([this]))(reportPartDetail.containerCollection);
    var newNameAlias = String.generateNewName(name, elements, get('name'), '()');

    this.setName(newNameAlias);
  });

  /**
   * set Name for field
   * @method setName
   * @param  {string} name New name for element
   */
  ReportPartElement.prototype.setName = m.action(function (name) {
    this.field.fieldNameAlias = this.name = trim(name);
  });

  /**
   * set function and format for field
   * @method setFunctionFormat
   * @param  {string} data                        Function Data and format data
   * @param  {ReportPartDetails} reportPartDetail Root Object of current report Part
   */
  ReportPartElement.prototype.setFunctionFormat = m.action(function (data, reportPartDetail) {
    data.formatData && this.properties.setFormat({
      formatId: data.formatData.id,
      format: data.formatData.format,
      groupBy: data.formatData.groupBy
    });
    return this.setFieldFunction(data.functionData, reportPartDetail);
  });

  ReportPartElement.prototype.setSelected = function (value) {
    this.isSelected = value;
  };

  /**
   * Reset default alternative text setting to default value
   */
  ReportPartElement.prototype.resetDefaultAlternativeText = m.action('resetDefaultAlternativeText', function () {
    this.properties.dataFormattings.alternativeText = clone(propertiesBuilderConstants.DEFAULT_PROPERTIES_VALUE.dataFormattings.alternativeText);
    this.markDirty();
  });

  /**
   * Reset default custom url setting to default value
   */
  ReportPartElement.prototype.resetDefaultCustomURL = m.action('resetDefaultCustomURL', function () {
    this.properties.dataFormattings.customURL = clone(propertiesBuilderConstants.DEFAULT_PROPERTIES_VALUE.dataFormattings.customURL);
    this.markDirty();
  });

  /**
   * Reset default sub report setting to default value
   */
  ReportPartElement.prototype.resetDefaultSubReport = m.action('resetDefaultSubReport', function () {
    this.properties.drillDown.subReport = clone(propertiesBuilderConstants.DEFAULT_PROPERTIES_VALUE.drillDown.subReport);
    this.markDirty();
  });

  /**
   * Reset default embedded javascript setting to default value
   */
  ReportPartElement.prototype.resetDefaultEmbeddedJavascript = m.action('resetDefaultEmbeddedJavascript', function () {
    this.properties.dataFormattings.embeddedJavascript = clone(propertiesBuilderConstants.DEFAULT_PROPERTIES_VALUE.dataFormattings.embeddedJavascript);
    this.markDirty();
  });

  /**
   * Reset default sub total setting to default value
   */
  ReportPartElement.prototype.resetDefaultSubTotal = m.action('resetDefaultSubTotal', function () {
    this.properties.dataFormattings.subTotal = clone(propertiesBuilderConstants.DEFAULT_PROPERTIES_VALUE.dataFormattings.subTotal);
    this.markDirty();
  });

  /**
   * Reset default alternative text setting to default value
   */
  ReportPartElement.prototype.resetDefaultGrandTotal = m.action('resetDefaultGrandTotal', function () {
    this.properties.dataFormattings.grandTotal = clone(propertiesBuilderConstants.DEFAULT_PROPERTIES_VALUE.dataFormattings.grandTotal);
    this.markDirty();
  });

  /**
   * Reset default alternative text setting to default value
   */
  ReportPartElement.prototype.resetTextDefaultValue = m.action('resetTextDefaultValue', function () {
    this.properties.dataFormattings.color.textColor = {};
    this.markDirty();
  });

  /**
   * Reset default alternative text setting to default value
   */
  ReportPartElement.prototype.resetCellDefaultValue = m.action('resetCellDefaultValue', function () {
    this.properties.dataFormattings.color.cellColor = {};
    this.markDirty();
  });

  /*
   * Update column width
   * columnWidth {number}
   */
  ReportPartElement.prototype.updateColumnWidth = m.action(function (columnWidth) {
    if (columnWidth) {
      this.properties.dataFormattings.width.value = columnWidth;
      this.markDirty();
    }
  });

  ReportPartElement.prototype.clone = function () {
    var cloned = new ReportPartElement();
    return cloned.readData(this);
  };

  ReportPartElement.prototype.setRepeaterLevel = function (value) {
    this.repeaterLevel = value;
  };

  module.exports = ReportPartElement;
}();

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.TinyMCEConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  REPEATER_START: '<repeater>',
  REPEATER_END: '</repeater>',
  PAGE_BREAK_HTML: "<div style='page-break-after:always;'></div>",
  FIELD: 'field',
  REPEATER_START_FORTABLE: '<!-- [repeater] -->',
  REPEATER_END_FORTABLE: '<!-- [/repeater] -->',
  SUBTOTAL_START: 'SUBTOTAL_',
  SUBTOTAL_END: '_SUBTOTAL'
};
module.exports = exports['default'];

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ArrayUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  'use strict';

  var _require = __webpack_require__(1),
      isString = _require.isString,
      isNil = _require.isNil,
      map = _require.map;
  /**
   * Compare string.
   * @param  {String} firstOperand
   * @param  {String} secondOperand
   */


  function compareString(firstOperand, secondOperand) {
    // We do not care case-insensitive when compare strings.
    return firstOperand.localeCompare(secondOperand, undefined /* Ignore language */, { sensitivity: 'base' });
  }

  /**
   * Compare function.
   * @param  {Object} sortInfo
   */
  function dynamicSort(sortInfo) {
    return function (firstOperand, secondOperand) {
      var result = 0;

      if (isString(firstOperand)) {
        result = compareString(firstOperand[sortInfo.key], secondOperand[sortInfo.key]);
      } else {
        result = firstOperand[sortInfo.key] > secondOperand[sortInfo.key] ? 1 : firstOperand[sortInfo.key] < secondOperand[sortInfo.key] ? -1 : 0;
      }

      return sortInfo.descending ? -1 * result : result;
    };
  }

  /**
   * Compare function for multi props.
   */
  function dynamicSortMultiple() {
    var props = arguments;
    return function (firstOperand, secondOperand) {
      var i = 0,
          result = 0,
          numberOfProperties = props.length;
      while (result === 0 && i < numberOfProperties) {
        result = dynamicSort(props[i])(firstOperand, secondOperand);
        i++;
      }
      return result;
    };
  }

  module.exports = {
    /**
     * Sort items of array with support asc/desc.
     * Item is an object.
     */
    sortArray: function sortArray(items, sortInfos) {
      // Handle invalid sort order detail.
      if (isNil(sortInfos)) {
        return items;
      }

      var sortedItems = items.sort(dynamicSortMultiple.apply(null, sortInfos));
      return sortedItems;
    },

    /**
     * Update array
     * This is a helper for update observable array, also can use for array.
     */
    updateArray: function updateArray(target, source, transfomer) {
      //Clean current list and append new list
      target.splice.apply(target, [0, target.length].concat(map(transfomer, source)));
    }
  };
}();

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.AlertConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  ALERT_TYPES: {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error'
  },

  SHOW_TYPES: {
    ALWAYS: 'always',
    BRIEF: 'brief',
    RESET: 'reset'
  },

  DISPLAY_TIME: 10000
};
module.exports = exports['default'];

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleSetupFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var ROOT_URL = 'role/';

exports.default = {
  /**
   * Get list role
   * @returns {*}
   */
  getRoleList: function getRoleList(tenantID, includeHashcode, basicInfo) {
    tenantID = tenantID || '';
    includeHashcode = (0, _fp.toString)(!!includeHashcode);
    basicInfo = (0, _fp.toString)(!!basicInfo);

    var getRoleListUrl = ROOT_URL + 'all/' + tenantID + '?includeHashcode=' + includeHashcode + '&basicInfo=' + basicInfo;

    return (0, _Izenda2.default)(getRoleListUrl).get();
  },


  /**
   * Get list Access role
   * @returns {*}
   */
  getTypedRole: function getTypedRole(type, tenantID) {
    tenantID = tenantID || '';
    return (0, _Izenda2.default)(String.format('{0}availableRole/{1}/{2}', ROOT_URL, type, tenantID)).get();
  },


  /**
   * Get list Access role
   * @returns {*}
   */
  getTypedCategory: function getTypedCategory(type, tenantID) {
    tenantID = tenantID || '';
    return (0, _Izenda2.default)(String.format('{0}availableCategory/{1}/{2}', ROOT_URL, type, tenantID)).get();
  },


  /**
   * Load Lazy Typed Category
   * @returns {*}
   */
  loadLazyTypedCategory: function loadLazyTypedCategory(data) {
    return (0, _Izenda2.default)(String.format('{0}availableCategory/', ROOT_URL)).post(data);
  },


  /**
   * activate Role
   * @method activateRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  activateRole: function activateRole(roleId, tenantId) {
    var tenantParam = tenantId ? '/' + tenantId : '';
    return (0, _Izenda2.default)(ROOT_URL + 'active/' + roleId + tenantParam).post();
  },


  /**
   * deactivate Role
   * @method deactivateRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  deactivateRole: function deactivateRole(roleId, tenantId) {
    var tenantParam = tenantId ? '/' + tenantId : '';
    return (0, _Izenda2.default)(ROOT_URL + 'deactive/' + roleId + tenantParam).post();
  },


  /**
   * delete Role
   * @method deleteRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  deleteRole: function deleteRole(roleId) {
    return (0, _Izenda2.default)(ROOT_URL + roleId).delete();
  },


  /**
   * load Role
   * @method loadRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  loadRole: function loadRole(roleId) {
    return (0, _Izenda2.default)(ROOT_URL + roleId, { prefer: 'minimal' }).get();
  },


  /**
   * save Role
   * @method saveRole
   * @param  {string}     roleId Role ID
   * @return {Promise}           API Promise
   */
  saveRole: function saveRole(saveData) {
    return (0, _Izenda2.default)(ROOT_URL, { prefer: 'minimal' }).post(saveData);
  },


  /**
   * load Permission Summary
   * @param  {string} tenantId
   * @return {promise}
   */
  loadPermissionSummary: function loadPermissionSummary(tenantId) {
    tenantId = tenantId || '';
    return (0, _Izenda2.default)(ROOT_URL + 'summaries/' + tenantId).get();
  },


  /**
   * Load list sharing roles
   * @return Promise: roles list.
   */
  loadAllowedSharingRoles: function loadAllowedSharingRoles(requestData) {
    return (0, _Izenda2.default)(ROOT_URL + 'allowedSharingRoles').post(requestData);
  },


  /**
   * Load list sharing roles paging
   * @return {Promise}
   */
  loadAllowedSharingRolesPaging: function loadAllowedSharingRolesPaging(requestData) {
    return (0, _Izenda2.default)(ROOT_URL + 'allowedSharingRolesPaging').post(requestData);
  },


  /**
   * Load partial access limits
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialAccessLimits: function loadPartialAccessLimits(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'accessLimits').post(data);
  },


  /**
   * Load partial schedule limits
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialScheduleLimits: function loadPartialScheduleLimits(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'scheduleLimits').post(data);
  },


  /**
   * Load Partial DataModel Access
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialDataModelAccess: function loadPartialDataModelAccess(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadPartialDataModelAccess').post(data);
  }
};
module.exports = exports['default'];

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(150);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.MobxUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);

  /**
    * Basically, a deep clone, so that no reactive property will exist anymore.
    * This is a customized of https://github.com/mobxjs/mobx/blob/master/src/api/tojs.ts
    * Only use for mobx ver. 2.1.7
    */
  function toJS(source, detectCycles, __alreadySeen) {
    "use strict";

    if (typeof m.toJS === 'function') {
      return m.toJS(source, detectCycles, __alreadySeen);
    }

    var isObservableValue = function isObservableValue(i) {
      return typeof i.get === "function";
    };

    if (!source || source instanceof Date || source instanceof RegExp) {
      return source;
    }

    if (Array.isArray(source) || m.isObservableArray(source)) {
      var res = [];
      var toAdd = source.map(function (value) {
        return toJS(value);
      });
      res.length = toAdd.length;
      for (var i = 0, l = toAdd.length; i < l; i++) {
        res[i] = toAdd[i];
      }
      return res;
    }
    if (m.isObservableMap(source)) {
      var _res = {};
      source.forEach(function (value, key) {
        return _res[key] = toJS(value);
      });
      return _res;
    }

    if (m.isObservable(source) && isObservableValue(source.$mobx)) return toJS(source());

    if (isObservableValue(source)) return toJS(source.get());

    if ((typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) === "object") {
      var _res2 = {};
      for (var key in source) {
        _res2[key] = toJS(source[key]);
      }return _res2;
    }
    return source;
  }

  module.exports = {
    toJS: toJS
  };
}();

/***/ }),
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get SCHEDULE_REPORT() {
    return _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_REPORT');
  },
  get SEARCH_OPTION() {
    return [{ value: 'All', label: _Izenda2.default.getText('COMMON_LABEL_ALL') }, { value: 'Name', label: _Izenda2.default.getText('COMMON_LABEL_INSTANCE_NAME') }, { value: 'Type', label: _Izenda2.default.getText('COMMON_LABEL_TYPE') }, { value: 'Schedule', label: _Izenda2.default.getText('COMMON_LABEL_SCHEDULE') }, { value: 'FilterValueSelection', label: _Izenda2.default.getText('COMMON_LABEL_FILTER_VALUE_SELECTION') }, { value: 'DeliveryType', label: _Izenda2.default.getText('COMMON_LABEL_DELIVERY_TYPE') }, { value: 'DeliveryMethod', label: _Izenda2.default.getText('COMMON_LABEL_DELIVERY_METHOD') }, { value: 'Recipients', label: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_RECIPIENTS') }, {
      value: 'LastSuccessfulRun',
      label: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_LAST_SUCCESS_RUN')
    }, {
      value: 'NextScheduledRun',
      label: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_NEXT_SCHEDULED_RUN')
    }];
  },
  get SCHEDULE_TYPE() {
    return [{
      value: 'Scheduled Reporting Item',
      label: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_TYPE_LABEL_REPORTING_ITEM')
    }, {
      value: 'Scheduled Alert',
      label: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_TYPE_LABEL_SCHEDULED_ALERT')
    }];
  },
  get SCHEDULE_TYPE_VALUES() {
    return {
      scheduleReport: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_TYPE_VALUES_SCHEDULE_REPORT'),
      scheduleAlert: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_SCHEDULE_TYPE_VALUES_SCHEDULE_ALERT')
    };
  },
  get PAGE_TEXT() {
    return {
      AddText: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_ADD'),
      EditText: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_EDIT'),
      CopyText: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_COPY'),
      DeleteText: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_DELETE')
    };
  },

  get TABLE_DEF() {
    return {
      selectedValue: { key: 'selectedValue', width: 30, title: '', sortable: false },
      name: {
        key: 'name',
        width: 150,
        title: _Izenda2.default.getText('COMMON_LABEL_INSTANCE_NAME'),
        sortable: true,
        columnKey: 'name'
      },
      type: {
        key: 'type',
        width: 100,
        title: _Izenda2.default.getText('COMMON_LABEL_TYPE'),
        sortable: true,
        columnKey: 'type'
      },
      schedule: {
        key: 'schedule',
        width: 180,
        title: _Izenda2.default.getText('COMMON_LABEL_SCHEDULE'),
        sortable: true,
        columnKey: 'schedule'
      },
      filterValueSelection: {
        key: 'filterValueSelection',
        width: 180,
        title: _Izenda2.default.getText('COMMON_LABEL_FILTER_VALUE_SELECTION'),
        sortable: true,
        columnKey: 'filterValueSelection'
      },
      deliveryType: {
        key: 'deliveryType',
        width: 150,
        title: _Izenda2.default.getText('COMMON_LABEL_DELIVERY_TYPE'),
        sortable: true,
        columnKey: 'deliveryType'
      },
      deliveryMethodView: {
        key: 'deliveryMethodView',
        width: 150,
        title: _Izenda2.default.getText('COMMON_LABEL_DELIVERY_METHOD'),
        sortable: true,
        columnKey: 'deliveryMethodView'
      },
      recipients: {
        key: 'recipients',
        width: 120,
        title: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_RECIPIENTS'),
        sortable: true,
        columnKey: 'recipients'
      },
      lastSuccessfulRun: {
        key: 'lastSuccessfulRun',
        width: 180,
        title: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_LAST_SUCCESS_RUN'),
        sortable: true,
        columnKey: 'lastSuccessfulRun'
      },
      nextScheduledRun: {
        key: 'nextScheduledRun',
        width: 180,
        title: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_TABLE_DEF_TITLE_NEXT_SCHEDULED_RUN'),
        sortable: true,
        columnKey: 'nextScheduledRun'
      },
      action: {
        key: 'action',
        width: 80,
        title: _Izenda2.default.getText('COMMON_LABEL_ACTION'),
        sortable: false,
        fixed: true
      }
    };
  },
  get MESSAGE() {
    return {
      M01a: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_MESSAGE_DELETE_SCHEDULE_INSTANTCE'),
      M01b: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_MESSAGE_DELETE_SELECTED_SCHEDULE_INSTANTCE')
    };
  },
  get CONTRAINTS() {
    return {
      RECIPIENTS: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_CONTRAINTS_MESSAGE_RECIPIENTS_IS_REQUIRE')
        }
      }
    };
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardSchedulingConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

module.exports = exports['default'];

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantManagementDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var ROOT_URL = 'tenant/';

exports.default = {
  /**
   * Get list tenant (full)
   * @returns {*}
   */
  getAllTenantList: function getAllTenantList() {
    return (0, _Izenda2.default)(ROOT_URL + 'allTenants/').get();
  },


  /**
   * Get list tenant (basic)
   * @returns {*}
   */
  getAllBasicTenantList: function getAllBasicTenantList() {
    return (0, _Izenda2.default)(ROOT_URL + 'basicInfos/').get();
  },


  /**
   * Get list tenant (name)
   * @returns {*}
   */
  getAllNameTenantList: function getAllNameTenantList() {
    return (0, _Izenda2.default)(ROOT_URL + 'namesOnly/').get();
  },


  /**
   * get all modules base on license
   * @returns {*[]}
   */
  getAllModulesOfLicense: function getAllModulesOfLicense() {
    return (0, _Izenda2.default)('License/currenttoken/').get().then(function (result) {
      return result && result.modules;
    });
  },


  /**
   * Save a tenant
   * @param tenant
   * @returns {promise}
   */
  saveTenant: function saveTenant(tenant) {
    return (0, _Izenda2.default)(ROOT_URL, { prefer: 'minimal' }).post(tenant);
  },


  /**
   * Delete a tenant
   * @param id
   * @returns {promise}
   */
  deleteTenant: function deleteTenant(id) {
    return (0, _Izenda2.default)(ROOT_URL + id).delete();
  },


  /**
   * Active a tenant
   * @param id
   * @returns {*}
   */
  activeTenant: function activeTenant(id) {
    return (0, _Izenda2.default)(ROOT_URL + 'active/' + id).post();
  },


  /**
   * Deactive a tenant
   * @param id
   * @returns {*}
   */
  deactiveTenant: function deactiveTenant(id) {
    return (0, _Izenda2.default)(ROOT_URL + 'deactive/' + id).post();
  },


  /**
   * Get detail tenant
   * @returns {Object}
   */
  loadTenant: function loadTenant(id) {
    return (0, _Izenda2.default)((0, _fp.isNil)(id) ? ROOT_URL : ROOT_URL + id, { prefer: 'minimal' }).get();
  },


  /**
   * load category accessibility available
   * @param  {number} type [0 - Report/template; 1 - Dashboard]
   * @return {Promise}
   */
  getCategoryAccessibility: function getCategoryAccessibility(type) {
    return (0, _Izenda2.default)(ROOT_URL + 'availableCategory/' + type).get();
  },


  /**
   * Load partial access limits
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialAccessLimits: function loadPartialAccessLimits(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'accessLimits').post(data);
  },


  /**
   * Load partial schedule limits
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialScheduleLimits: function loadPartialScheduleLimits(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'scheduleLimits').post(data);
  }
};
module.exports = exports['default'];

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  MIDDLE_MIN_WIDTH: 0,
  MIDDLE_MAX_WIDTH: 250,
  MESSAGE: {
    get CANCEL() {
      return _Izenda2.default.getText('TENANT_CONSTANT_MESSAGE_CANCEL');
    },
    get SAVE() {
      return _Izenda2.default.getText('TENANT_CONSTANT_MESSAGE_SAVE');
    },
    get DELETE() {
      return _Izenda2.default.getText('TENANT_CONSTANT_MESSAGE_DELETE');
    },
    get DEACTIVATE() {
      return _Izenda2.default.getText('TENANT_CONSTANT_MESSAGE_DEACTIVATE');
    }
  },

  TENANT_ID_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('TENANT_CONSTANT_MESSAGE_TENANT_ID_CONSTRAINT');
      }
    }
  },

  TENANT_NAME_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('TENANT_CONSTANT_MESSAGE_TENANT_NAME_CONSTRAINT');
      }
    }
  },

  TENANT_STATE: {
    get ACTIVATE() {
      return _Izenda2.default.getText('COMMON_LABEL_ACTIVATE');
    },
    get DEACTIVATE() {
      return _Izenda2.default.getText('COMMON_LABEL_DEACTIVATE');
    }
  },

  TENANT_PERMISSIONS: {
    ACCESS: {
      ACCESS_LIMIT: {
        get AVAILABLE_TREE_HEADER() {
          return _Izenda2.default.getText('TENANT_CONSTANT_TENANT_PERMISSIONS_AVAILABLE_TREE_HEADER');
        },
        get SHARE_WITH_TREE_HEADER() {
          return _Izenda2.default.getText('TENANT_CONSTANT_TENANT_PERMISSIONS_SHARE_WITH_TREE_HEADER');
        }
      }
    },
    REPORT: {
      CATEGORY_ACCESSIBILITY: {
        get AVAILABLE_TREE_HEADER() {
          return _Izenda2.default.getText('TENANT_CONSTANT_REPORT_AVAILABLE_TREE_HEADER');
        },
        get VISIBLE_TREE_HEADER() {
          return _Izenda2.default.getText('TENANT_CONSTANT_REPORT_VISIBLE_TREE_HEADER');
        },
        get SAVABLE_TREE_HEADER() {
          return _Izenda2.default.getText('TENANT_CONSTANT_REPORT_SAVABLE_TREE_HEADER');
        }
      }
    },
    DASHBOARD: {
      CATEGORY_ACCESSIBILITY: {
        get AVAILABLE_TREE_HEADER() {
          return _Izenda2.default.getText('TENANT_CONSTANT_DASHBOARD_AVAILABLE_TREE_HEADER');
        },
        get VISIBLE_TREE_HEADER() {
          return _Izenda2.default.getText('TENANT_CONSTANT_DASHBOARD_VISIBLE_TREE_HEADER');
        },
        get SAVABLE_TREE_HEADER() {
          return _Izenda2.default.getText('TENANT_CONSTANT_DASHBOARD_SAVABLE_TREE_HEADER');
        }
      }
    }
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.IntegrationRoutes.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Route = __webpack_require__(52).Route;
  var IndexRedirect = __webpack_require__(52).IndexRedirect;
  var Redirect = __webpack_require__(52).Redirect;
  var Config = __webpack_require__(40);
  var ReportRoutes = __webpack_require__(1197);
  var SettingsRoutes = __webpack_require__(1142);
  var ReportDesignerRoutes = __webpack_require__(1201);
  var DashboardRoutes = __webpack_require__(1211);
  var DashboardDesignerContainer = __webpack_require__(2806);
  var ReportViewerContainer = __webpack_require__(1179);
  var routeUtils = __webpack_require__(31);
  var IntegrationContainer = __webpack_require__(640);
  var viewerRoute = __webpack_require__(1222);
  var NoPermission = __webpack_require__(613);
  var IntergrateStore = __webpack_require__(319);

  var IntegrationRoutes = function IntegrationRoutes(mainRoute) {
    var BaseUrl = Config.BaseUrl || '/';
    var REPORT_VIEWER_ROUTE = routeUtils.getConfigRoute('ReportViewer');
    var REPORT_VIEWER__DETAIL_ROUTE = routeUtils.getConfigRoute('ReportViewer', 'ReportViewerDetail');
    var MAIN_ROUTE = mainRoute;
    var DASHBOARD_VIEWER_ROUTE = routeUtils.getConfigRoute('Dashboard');
    var DASHBOARD_VIEWER_DETAIL_ROUTE = routeUtils.getConfigRoute('Dashboard', 'DashboardViewer');
    var page = IntergrateStore.syncPageManifest();
    var reportViewerRedirectPath = BaseUrl + '/' + routeUtils.getConfigRoute('Report').path + '/' + routeUtils.getConfigRoute('Report', 'View').path;
    var dashboardViewerRedirectPath = BaseUrl + '/' + routeUtils.getConfigRoute('Dashboard').path + '/' + routeUtils.getConfigRoute('Dashboard', 'Edit').path + '/';

    return React.createElement(
      Route,
      { path: BaseUrl, component: IntegrationContainer },
      React.createElement(IndexRedirect, { to: MAIN_ROUTE.path, query: MAIN_ROUTE.query }),
      SettingsRoutes(),
      ReportDesignerRoutes(),
      DashboardRoutes(),
      ReportRoutes(),
      React.createElement(
        Route,
        { path: REPORT_VIEWER_ROUTE.path },
        React.createElement(Redirect, {
          from: REPORT_VIEWER__DETAIL_ROUTE.path,
          to: reportViewerRedirectPath,
          state: { page: page } })
      ),
      React.createElement(
        Route,
        { path: DASHBOARD_VIEWER_ROUTE.path },
        React.createElement(Redirect, {
          from: DASHBOARD_VIEWER_DETAIL_ROUTE.path,
          to: dashboardViewerRedirectPath,
          state: { page: page } })
      ),
      React.createElement(Route, { path: 'NoPermission', component: NoPermission }),
      viewerRoute()
    );
  };
  module.exports = IntegrationRoutes;
}();

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (pattern, orgVal, arrayValue) {
  if ((0, _fp.isString)(orgVal) && (0, _fp.isEmpty)(orgVal) || (0, _fp.isNaN)(Number(orgVal)) || (0, _fp.isEmpty)(pattern)) {
    return orgVal;
  }

  var value = Number(orgVal || DEFAULT_VALUE).toFixed(DECIMAL_POINT);

  switch (pattern) {
    case PERCENTAGE_GROUP:
    case PERCENTAGE_SUBTOTAL:
    case PERCENTAGE_GRANDTOTAL:
    case PERCENTAGE_SIDETOTAL:
      return formatPercent(calculatedPercentageGroup(value, arrayValue), DECIMAL_POINT);
    case PERCENTAGE_GROUP_ROUNDED:
    case PERCENTAGE_SUBTOTAL_ROUNDED:
    case PERCENTAGE_GRANDTOTAL_ROUNDED:
    case PERCENTAGE_SIDETOTAL_ROUNDED:
      return formatPercent(calculatedPercentageGroup(value, arrayValue), ROUNDED_DECIMAL_POINT);
    case THOUSAND:
      return formatNumberWithDevidend(value, THOUSAND_DEVIDEND, 'Abbreviation', 'K');
    case MILLION:
      return formatNumberWithDevidend(value, MILLION_DEVIDEND, 'Abbreviation', 'M');
    case BILLION:
      return formatNumberWithDevidend(value, BILLION_DEVIDEND, 'Abbreviation', 'B');
    case '$/100':
      return formatNumberWithDevidend(value, HUNDRED_DEVIDEND, pattern, '');
    case '0.00%':
    case '0,000.00%':
    case '0000%':
      return formatNumberWithDevidend(value, PERCENT_DIVIDEND, pattern, '');
    default:
      return FORMAT_TYPE[pattern] ? formatNumberWithDevidend(value, NO_DEVIDEND, pattern, '') : orgVal;
  }
};

var _numeral = __webpack_require__(1400);

var _numeral2 = _interopRequireDefault(_numeral);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ConvertToNumeralFormat.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FORMAT_TYPE = {
  /* key: Format of Izenda defined*/ /* value: Format of library Numeral.js*/
  /* Number */
  '0.00': '0.00',
  '0,000.00': '0,000.00',
  '0000': '0000',

  /* Currency */
  '$0.00': '$0.00',
  '$0,000.00': '$0,000.00',
  $0000: '$0000',
  '$/100': '$0.00',

  /* Percentage */
  '0.00%': '0.00%',
  '0,000.00%': '0,000.00%',
  '0000%': '0%',

  /* Grouping abbreviation styles : '1K', '1M', '1B' */
  Abbreviation: '0,000.00'
};

var PERCENTAGE_GROUP = '% of Group';
var PERCENTAGE_GROUP_ROUNDED = '% of Group (with rounding)';
var PERCENTAGE_SUBTOTAL = '% of Subtotal';
var PERCENTAGE_SUBTOTAL_ROUNDED = '% of Subtotal (with rounding)';
var PERCENTAGE_GRANDTOTAL = '% of Grandtotal';
var PERCENTAGE_GRANDTOTAL_ROUNDED = '% of Grandtotal (with rounding)';
var PERCENTAGE_SIDETOTAL = '% of Sidetotal';
var PERCENTAGE_SIDETOTAL_ROUNDED = '% of Sidetotal (with rounding)';
var NO_DEVIDEND = 1;
var HUNDRED_DEVIDEND = 100;
var THOUSAND = '1K';
var THOUSAND_DEVIDEND = 1000;
var MILLION = '1M';
var MILLION_DEVIDEND = 1000000;
var BILLION = '1B';
var BILLION_DEVIDEND = 1000000000;
var DECIMAL_POINT = 8;
var ROUNDED_DECIMAL_POINT = 1;
var DEFAULT_VALUE = 0;
var PERCENT_DIVIDEND = 100;

// Calcuate the percentage of value/array value
function calculatedPercentageGroup(value, arrayValue) {
  if ((0, _fp.isEmpty)(arrayValue)) {
    return value;
  }

  return value / (0, _fp.sum)(arrayValue) * PERCENT_DIVIDEND;
}

function formatNumberWithDevidend(value, dividendNumber, formatType, symbol) {
  var absValue = Math.abs(value / dividendNumber);
  var isNegative = value < 0;

  return '' + (isNegative ? '-' : '') + (0, _numeral2.default)(absValue).format(FORMAT_TYPE[formatType]) + symbol;
}

function formatPercent(value, decimalPoint) {
  var eValue = Number(value + ('e+' + decimalPoint));
  return +(Math.round(eValue) + ('e-' + decimalPoint)) + '%';
}

/**
 * Convert to numeral format
 * @param {string} pattern format pattern
 * @param {number} orgVal original value
 * @param {Array<number>} arrayValue this is optional parameter 
 *                                   when pattern is '% of Group' or '% of Group (with rounding)'
 */
module.exports = exports['default'];

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get MESSAGE() {
    return {
      MG01a: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_CHANGE_TO_OFFLINE'),
      MG01b: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_CHANGE_TO_ONLINE'),
      MG03: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_LICENSE_KEY_INVALID'),
      MG04: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_TOKEN_INVALID'),
      MG05: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_DAYS_TILL_EXPIRED'),
      MG05a: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_DAYS_EXPIRED'),
      MG05b: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_EXPIRED'),
      MG06: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_NEW_LICENSE_OR_TOKEN_INVALID'),
      MG07a: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_VALIDATE_ON_OR_AFTER'),
      MG08: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_TOKEN_REQUIRED'),
      MG09: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_LICENSE_KEY_REQUIRED'),
      MG10: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_LICENSE_NO_LONGER_VALID'),
      MG11: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_NEW_LICENSE_INVALID'),
      CANNOT_REACH_LICENSE_SERVER: _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_LOST_CONNECTION_TO_LICENSE_SERVER')
    };
  },
  get Description() {
    return _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_ENTER_LICENSE_DESCRIPTION');
  },
  LICENSE_KEY_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_LICENSE_KEY_CONSTRAINT');
      }
    }
  },
  TOKEN_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return _Izenda2.default.getText('LICENSE_CHECKER_MESSAGE_TOKEN_CONSTRAINT');
      }
    }
  },
  MAP_MODULES_NAME: 'Maps',
  LICENSE_NOTIFICATION_MESSAGE_KEY: {
    NO_LONGER_VALID: 'noLongerValid',
    VALID_IN_ALLOW_PERIOD: 'validInAllowPeriod'
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseInfoConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.GridView.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Izenda = __webpack_require__(1491);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1496);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda5 = __webpack_require__(38);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridView = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GridView, _Component);

  function GridView(props) {
    (0, _classCallCheck3.default)(this, GridView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GridView.__proto__ || (0, _getPrototypeOf2.default)(GridView)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        layoutStore = _this$props.layoutStore,
        layoutData = _this$props.layoutData,
        snapToGrid = _this$props.snapToGrid,
        printingMode = _this$props.printingMode;


    !printingMode && layoutStore.setSnapToGrid(snapToGrid);
    layoutStore.setLayout(layoutData, true);

    _this.onMoveStart = _this.onInteractStart(true /* move */);
    _this.onMove = _this.onInteracting(true /* move */);
    _this.onMoveStop = _this.onInteractStop(true /* move */);
    _this.onResizeStart = _this.onInteractStart(false /* not move */);
    _this.onResize = _this.onInteracting(false /* not move */);
    _this.onResizeStop = _this.onInteractStop(false /* not move */);
    return _this;
  }

  (0, _createClass3.default)(GridView, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          snapToGrid = _props.snapToGrid,
          layoutData = _props.layoutData;
      var layoutStore = nextProps.layoutStore;

      if (nextProps.snapToGrid !== snapToGrid && !nextProps.printingMode) {
        layoutStore.setSnapToGrid(nextProps.snapToGrid);
      }
      if (!(0, _fp.isEqual)(nextProps.layoutData, layoutData)) {
        var gridItemsContainer = _reactDom2.default.findDOMNode(this.gridItemsContainer);
        if (gridItemsContainer && gridItemsContainer.clientWidth > 0 && gridItemsContainer.clientWidth !== layoutStore.innerWidth) {
          layoutStore.setViewWidth(gridItemsContainer.clientWidth);
        }

        layoutStore.setLayout(nextProps.layoutData, false);
        layoutStore.resize = false;
        layoutStore.layout.length && nextProps.onUpdateItemPositions && nextProps.onUpdateItemPositions(layoutStore.layout.map(function (item) {
          return {
            id: item.id,
            top: item.gridTop,
            left: item.gridLeft,
            width: item.gridWidth,
            height: item.gridHeight
          };
        }));
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props2 = this.props,
          layoutStore = _props2.layoutStore,
          _props2$layoutStore = _props2.layoutStore,
          isFullSize = _props2$layoutStore.isFullSize,
          fullSizedItem = _props2$layoutStore.fullSizedItem,
          isSnapEditOn = _props2$layoutStore.isSnapEditOn;

      var fullSize = isFullSize || !!fullSizedItem;
      // Scroll to top left corner of view port
      fullSize && this.scrollTo({ top: 0, left: 0 });

      isSnapEditOn && layoutStore.compactLayout();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          layoutStore = _props3.layoutStore,
          editable = _props3.editable,
          allowAddInline = _props3.allowAddInline,
          onAddItem = _props3.onAddItem,
          className = _props3.className,
          printingMode = _props3.printingMode,
          maxWidth = _props3.maxWidth,
          horizontalAlign = _props3.horizontalAlign,
          children = _props3.children,
          fullHeight = _props3.fullHeight,
          stickyScrollBottom = _props3.stickyScrollBottom,
          alwaysShowHorizontalScroll = _props3.alwaysShowHorizontalScroll,
          alwaysShowVerticalScroll = _props3.alwaysShowVerticalScroll;
      var fullSizedItem = layoutStore.fullSizedItem,
          isFullSize = layoutStore.isFullSize,
          height = layoutStore.height,
          width = layoutStore.width;

      var gridViewClasses = (0, _classnames2.default)('izenda-GridView', className);
      var fullSize = isFullSize || !!fullSizedItem;
      var style = {
        height: !printingMode ? height : null
      };

      // Only show grid lines in editing mode.
      var gridLines = editable ? _react2.default.createElement(_Izenda2.default, { layoutStore: layoutStore, allowAddInline: allowAddInline, onAddItem: onAddItem }) : null;

      var gridItems = _react2.default.Children.map(children, this.attachViewProps);

      var scrollBoxStyle = this.getScrollBoxStyle();
      if (horizontalAlign) {
        scrollBoxStyle.width = maxWidth ? maxWidth : width;
        scrollBoxStyle.margin = 'auto';
      }
      var viewClassName = printingMode ? 'u-posRelative' : '';
      return _react2.default.createElement(_Izenda4.default, {
        stickyScrollBottom: stickyScrollBottom,
        alwaysShowHorizontalScroll: alwaysShowHorizontalScroll,
        alwaysShowVerticalScroll: alwaysShowVerticalScroll,
        ref: this.setGridItemsContainer,
        printingMode: printingMode,
        className: gridViewClasses,
        style: style,
        editable: editable,
        fullSize: fullSize,
        fullHeight: fullHeight,
        scrollBoxStyle: scrollBoxStyle,
        viewClassName: viewClassName,
        gridLines: gridLines,
        gridItems: gridItems,
        layoutStore: layoutStore
      });
    }

    /**
     * Attach grid view properties to grid item
     */

  }, {
    key: 'getScrollBoxStyle',


    /**
     * Get style for scrollbox inside grid view
     */
    value: function getScrollBoxStyle() {
      var _props4 = this.props,
          gridHeight = _props4.gridHeight,
          layoutStore = _props4.layoutStore,
          printingMode = _props4.printingMode,
          forDashboard = _props4.forDashboard,
          fullHeight = _props4.fullHeight;
      var viewHeight = layoutStore.height;

      if (fullHeight) return {};
      if (gridHeight && viewHeight > gridHeight) return { height: gridHeight };
      return printingMode && !forDashboard ? {
        minHeight: viewHeight + 'px',
        overflow: 'hidden'
      } : {
        height: viewHeight + 'px'
      };
    }

    /**
     * Get scroll box
     */

  }, {
    key: 'getScrollBox',
    value: function getScrollBox() {
      return (0, _fp.get)('refs.scrollBox', this.gridItemsContainer);
    }

    /**
     * Get scroll top position of scroll box
     */


    /**
     * Scroll to particular position
     */


    /**
     * On start moving or resizing
     */


    /**
     * On stop moving or resizing
     * @param  {Boolean} move Moving or resizing
     */


    /**
     * On moving or resizing
     * @param  {Boolean} move Moving or resizing
     */

  }]);
  return GridView;
}(_react.Component), _class2.propTypes = {
  layoutStore: _mobxReact.propTypes.observableObject,
  layoutData: _propTypes2.default.array,
  // Allow user to change grid view items & layout
  editable: _propTypes2.default.bool,
  // Grid view to automatically snap items to left side.
  snapToGrid: _propTypes2.default.bool,
  // Allow user to add a grid item inline.
  allowAddInline: function allowAddInline(props, propName) {
    var editable = props.editable;

    var value = props[propName];
    (0, _Izenda6.default)((0, _fp.isBoolean)(value), 'allowAddInline must be boolean');
    (0, _Izenda6.default)(editable || !value, 'Only allowAddInline when is editable');
  },
  // On adding an grid item
  onAddItem: _propTypes2.default.func,
  // On updating grid items
  onUpdateItemPositions: _propTypes2.default.func,
  // Show loading while interacting
  showLoading: _propTypes2.default.bool,
  printingMode: _propTypes2.default.bool
}, _class2.defaultProps = {
  editable: false,
  allowAddInline: false,
  showLoading: true,
  snapToGrid: false,
  printingMode: false
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setGridItemsContainer = function (ref) {
    _this2.gridItemsContainer = ref;
  };

  this.attachViewProps = function (gridItem) {
    var _props5 = _this2.props,
        layoutStore = _props5.layoutStore,
        editable = _props5.editable,
        showLoading = _props5.showLoading;
    var infinityRows = layoutStore.infinityRows,
        infinityCols = layoutStore.infinityCols,
        fullSizedItem = layoutStore.fullSizedItem,
        cellWidth = layoutStore.cellWidth,
        cellHeight = layoutStore.cellHeight,
        minItemWidth = layoutStore.minItemWidth,
        minItemHeight = layoutStore.minItemHeight,
        gridWidth = layoutStore.gridWidth,
        gridHeight = layoutStore.gridHeight,
        width = layoutStore.width,
        height = layoutStore.height;
    var _gridItem$props = gridItem.props,
        id = _gridItem$props.id,
        useItemMinHeight = _gridItem$props.useItemMinHeight,
        minHeight = _gridItem$props.minHeight;

    var layoutItem = layoutStore.getLayoutItem(id);
    var isHidden = !!fullSizedItem && !layoutItem.isFullSize;

    var childProps = {
      editable: editable,
      // Attach layout item
      layoutItem: layoutItem,
      // Attach scrollbox
      scrollTo: _this2.scrollTo,
      getScrollTop: _this2.getScrollTop,
      // Attach grid cell dimension
      cellWidth: cellWidth,
      cellHeight: cellHeight,
      // Min size
      minWidth: minItemWidth,
      minHeight: useItemMinHeight ? minHeight : minItemHeight,
      // Max size
      maxWidth: infinityCols ? Infinity : gridWidth,
      maxHeight: infinityRows ? Infinity : gridHeight,
      // Attach move & resize handler
      onMoveStop: _this2.onMoveStop,
      onMoveStart: _this2.onMoveStart,
      onMove: _this2.onMove,
      onResizeStop: _this2.onResizeStop,
      onResizeStart: _this2.onResizeStart,
      onResize: _this2.onResize,
      onSizeChanged: _this2.onItemSizeChanged,
      // Show loading while interacting
      showLoading: showLoading,
      isHidden: isHidden,
      containerWidth: width,
      containerHeight: height
    };

    return _react2.default.cloneElement(gridItem, childProps);
  };

  this.getScrollTop = function () {
    var scrollBox = _this2.getScrollBox();
    return scrollBox ? scrollBox.getScrollTop() : 0;
  };

  this.scrollTo = function (pos) {
    var scrollBox = _this2.getScrollBox();
    return scrollBox && scrollBox.scrollTo(pos);
  };

  this.onInteractStart = function (move) {
    return function (layoutItem, pos) {
      var layoutStore = _this2.props.layoutStore;

      layoutStore.setOverlayPosition(pos);
    };
  };

  this.onInteractStop = function (move) {
    return function (layoutItem, pos) {
      var _props6 = _this2.props,
          layoutStore = _props6.layoutStore,
          isSnapEditOn = _props6.layoutStore.isSnapEditOn;

      var onUpdateItemPositions = _this2.props.onUpdateItemPositions;

      if (isSnapEditOn) {
        var compactedLayout = layoutStore.getLastCompactedLayout();
        compactedLayout.length > 0 && onUpdateItemPositions && onUpdateItemPositions(compactedLayout, true);
      } else {
        var changedItemPositions = layoutStore.updatePosition(layoutItem, pos, move);
        onUpdateItemPositions && onUpdateItemPositions(changedItemPositions, true);
      }
    };
  };

  this.onInteracting = function (move) {
    return function (layoutItem, pos) {
      var _props7 = _this2.props,
          layoutStore = _props7.layoutStore,
          isSnapEditOn = _props7.layoutStore.isSnapEditOn;

      var snappedPosition = layoutStore.snap(pos);

      if (isSnapEditOn) {
        layoutStore.snapArrange(layoutItem.id, snappedPosition, move);
      } else {
        layoutStore.setOverlayPosition(snappedPosition);
      }
    };
  };

  this.onItemSizeChanged = function (item, width, height) {
    if (item.isLoading && item.isLoading()) {
      return;
    }

    var _props8 = _this2.props,
        layoutStore = _props8.layoutStore,
        onUpdateItemPositions = _props8.onUpdateItemPositions;
    var oldItemWidth = item.gridWidth,
        oldItemHeight = item.gridHeight;

    layoutStore.resize = true;
    layoutStore.updateLayoutItemSize(item, width, height);

    if (oldItemWidth !== item.gridWidth || oldItemHeight !== item.gridHeight) {
      onUpdateItemPositions && onUpdateItemPositions([{
        id: item.id,
        top: item.gridTop,
        left: item.gridLeft,
        width: item.gridWidth,
        height: item.gridHeight
      }]);
    }
  };
}, _temp)) || _class;

exports.default = GridView;
module.exports = exports['default'];

/***/ }),
/* 300 */,
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.GridItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Grid item component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(850);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1504);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(852);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1506);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(510);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Grid item animation content that showing when animating
 */
var GridItemAnimation = (0, _mobxReact.observer)(function GridItemAnimation(props) {
  var layoutItem = props.layoutItem,
      interpolatingStyle = props.interpolatingStyle,
      mixinResizable = props.mixinResizable,
      mixinDraggable = props.mixinDraggable,
      isHidden = props.isHidden,
      targetTop = props.targetTop,
      targetLeft = props.targetLeft,
      targetWidth = props.targetWidth,
      targetHeight = props.targetHeight,
      onMeasureChange = props.onMeasureChange,
      printingMode = props.printingMode,
      isFirstItem = props.isFirstItem;


  var autoSize = layoutItem.autoSize;
  var position = {
    top: targetTop,
    left: targetLeft,
    width: targetWidth,
    height: targetHeight
  };

  var doesBreakPage = printingMode && props.doesBreakPage;

  if (props.fillWidth) {
    interpolatingStyle.width = layoutItem.gridWidth * 100 / props.cols + '%';
    interpolatingStyle.left = layoutItem.gridLeft * 100 / props.cols + '%';
  }

  var style = layoutItem.isFullSize ? _Izenda8.default.transformToFullSizeStyle(interpolatingStyle) : _Izenda8.default.transformToDefaultStyle(interpolatingStyle, true, doesBreakPage, printingMode, autoSize, isFirstItem);

  var className = (0, _classnames2.default)({
    u_hidden: isHidden
  });

  if (isHidden) {
    // Item needs to be visible, to ensure properly calculating size.
    // Keep the item displayed, but put it out of view portion.
    style.position = 'fixed';
    style.zIndex = -1000;
    style.top = -100000;
    style.left = -100000;
  }

  return mixinDraggable(mixinResizable(_react2.default.createElement(
    'div',
    { className: className, style: style },
    _react2.default.createElement(
      _Izenda6.default,
      { onChange: onMeasureChange },
      props.children
    )
  ), position), position);
});

/**
 * Grid item component in grid view
 */

var GridItem = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(GridItem, _Component);

  function GridItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GridItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GridItem.__proto__ || (0, _getPrototypeOf2.default)(GridItem)).call.apply(_ref, [this].concat(args))), _this), _this.mixinDraggable = function (child, pos) {
      var _this$props = _this.props,
          maxWidth = _this$props.maxWidth,
          cellWidth = _this$props.cellWidth,
          maxHeight = _this$props.maxHeight,
          cellHeight = _this$props.cellHeight;

      var maxRight = maxWidth * cellWidth;
      var maxBottom = maxHeight * cellHeight;

      return _react2.default.createElement(
        _Izenda4.default,
        {
          draggableOptions: _this.draggableOptions,
          onMoveStart: _this.onMoveStart,
          onMove: _this.onMove,
          onMoveStop: _this.onMoveStop,
          top: pos.top,
          left: pos.left,
          width: pos.width,
          height: pos.height,
          maxRight: maxRight,
          maxBottom: maxBottom
        },
        child
      );
    }, _this.mixinResizable = function (child, position) {
      var props = _this.props;
      var style = props.style;
      var minWidth = props.minWidth * props.cellWidth;
      var minHeight = props.minHeight * props.cellHeight;
      var maxRight = props.maxWidth === Infinity ? Infinity : props.maxWidth * props.cellWidth;
      var maxBottom = props.maxHeight === Infinity ? Infinity : props.maxHeight * props.cellHeight;

      var minConstraints = [minWidth, minHeight];
      var maxConstraints = [maxRight, maxBottom];

      return _react2.default.createElement(
        _Izenda2.default,
        {
          width: position.width,
          height: position.height,
          style: style,
          topResize: true,
          leftResize: true,
          rightResize: true,
          bottomResize: true,
          topLeftResize: true,
          topRightResize: true,
          bottomLeftResize: true,
          bottomRightResize: true,
          minConstraints: minConstraints,
          maxConstraints: maxConstraints,
          onResizeStop: _this.onResizeStop,
          onResizeStart: _this.onResizeStart,
          onResize: _this.onResize
        },
        child
      );
    }, _this.mergeParentProps = function (child) {
      var _this$props2 = _this.props,
          layoutItem = _this$props2.layoutItem,
          cellWidth = _this$props2.cellWidth,
          cellHeight = _this$props2.cellHeight,
          minWidth = _this$props2.minWidth,
          minHeight = _this$props2.minHeight;

      var itemClass = _this.props.className;

      var childClassName = (0, _classnames2.default)(itemClass, child.props.className);
      var childStyle = layoutItem.isFullSize || !layoutItem.autoSize ? (0, _fp.merge)({
        height: '100%'
      }, child.props.style) : (0, _fp.merge)({
        width: 'auto',
        height: 'auto',
        display: 'inline-block'
      }, child.props.style);

      var restChildProps = (0, _fp.omit)(['className', 'style'], child.props);

      var newChildProps = (0, _fp.assignAll)([{
        className: childClassName,
        minWidth: minWidth * cellWidth,
        minHeight: minHeight * cellHeight,
        style: childStyle,
        onMeasureChange: _this.onMeasureChange
      }, restChildProps]);

      return _react2.default.cloneElement(child, newChildProps);
    }, _this.scrollToMe = function () {
      var _this$props3 = _this.props,
          layoutItem = _this$props3.layoutItem,
          scrollTo = _this$props3.scrollTo;


      scrollTo({
        top: layoutItem.pxTop,
        left: layoutItem.pxLeft
      });
    }, _this.onResizeHandler = function (eventName) {
      return function (newPosition) {
        var layoutItem = _this.props.layoutItem;

        var isResizing = eventName === 'onResizeStart' || eventName === 'onResize';
        layoutItem.resizing(isResizing);
        _this.props[eventName] && _this.props[eventName](layoutItem, newPosition);
      };
    }, _this.onMoveHandler = function (eventName) {
      return function (newPosition) {
        var layoutItem = _this.props.layoutItem;

        var isDragging = eventName === 'onMoveStart' || eventName === 'onMove';
        layoutItem.moving(isDragging);
        _this.props[eventName] && _this.props[eventName](layoutItem, newPosition);
      };
    }, _this.onMeasureChange = function (width, height) {
      var _this$props4 = _this.props,
          layoutItem = _this$props4.layoutItem,
          cellWidth = _this$props4.cellWidth,
          cellHeight = _this$props4.cellHeight;
      var isFullSize = layoutItem.isFullSize,
          autoSize = layoutItem.autoSize;


      var actualWidth = _Izenda10.default.roundWidth(width, cellWidth);
      var actualHeight = _Izenda10.default.roundHeight(height, cellHeight);

      if (!isFullSize && autoSize && _this.props.onSizeChanged) {
        _this.props.onSizeChanged(layoutItem, actualWidth, actualHeight);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GridItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var props = this.props;

      this.onMoveStart = this.onMoveHandler('onMoveStart');
      this.onMoveStop = this.onMoveHandler('onMoveStop');
      this.onMove = this.onMoveHandler('onMove');
      this.onResizeStart = this.onResizeHandler('onResizeStart');
      this.onResizeStop = this.onResizeHandler('onResizeStop');
      this.onResize = this.onResizeHandler('onResize');

      this.draggableOptions = {
        handle: props.handle,
        cancel: props.cancel
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // If i'm the recently added item, scroll to me.
      this.props.moveToMe && this.scrollToMe();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var editable = props.editable,
          layoutItem = props.layoutItem,
          showLoading = props.showLoading,
          containerWidth = props.containerWidth,
          containerHeight = props.containerHeight,
          isHidden = props.isHidden,
          printingMode = props.printingMode,
          doesBreakPage = props.doesBreakPage,
          isFirstItem = props.isFirstItem;

      var isDraggable = props.isDraggable && editable;
      var isResizable = props.isResizable && editable;
      var onMeasureChange = this.onMeasureChange;

      // If this item is full sized, its position & size is to fit the grid view
      var itemLeft = layoutItem.isFullSize ? 0 : layoutItem.pxLeft;
      var itemTop = layoutItem.isFullSize ? 0 : layoutItem.pxTop;
      var itemWidth = layoutItem.isFullSize ? containerWidth : layoutItem.pxWidth;
      var itemHeight = layoutItem.isFullSize ? containerHeight : layoutItem.pxHeight;

      var child = this.mergeParentProps(_react2.default.Children.only(props.children));
      var mixinResizable = isResizable ? this.mixinResizable : _fp.identity;
      var mixinDraggable = isDraggable ? this.mixinDraggable : _fp.identity;

      var itemPositionStyle = {
        top: itemTop,
        left: itemLeft,
        width: itemWidth,
        height: itemHeight,
        rotate: layoutItem.isFullSize ? 180 : 0
      };

      return _react2.default.createElement(
        GridItemAnimation,
        {
          layoutItem: layoutItem,
          targetTop: itemTop,
          targetLeft: itemLeft,
          targetWidth: itemWidth,
          targetHeight: itemHeight,
          interpolatingStyle: itemPositionStyle,
          mixinResizable: mixinResizable,
          mixinDraggable: mixinDraggable,
          showLoading: showLoading,
          isHidden: isHidden,
          printingMode: printingMode,
          doesBreakPage: doesBreakPage,
          onMeasureChange: onMeasureChange,
          isFirstItem: isFirstItem,
          fillWidth: props.fillWidth,
          cols: props.cols
        },
        child
      );
    }

    /**
     * Extend child element to be draggable
     * @param  {Element} child Child element
     * @return {Element}       Child wrapped in Draggable
     */


    /**
     * Extend child element to be resizable
     * @param  {Element} child    Child element of grid item
     * @param  {Object} position  Current DOM element position of grid item
     */


    /**
     * Merge grid item's props with child's props into new child instance
     * @param  {Element} child Grid item's child element
     */


    /**
     * Scroll to current grid item
     */


    /**
     * Call when user resizes the grid item
     * @param  {string} eventName Resize event name
     */


    /**
     * Call when user moves the grid item
     * @param  {string} eventName Move event name
     */


    /**
     * Update new position including grid position of grid item
     * when its content size changed
     * @param  {number} top    Top value of grid item
     * @param  {number} left   Left value of grid item
     * @param  {number} width  Width value of grid item
     * @param  {number} height Height value of grid item
     */

  }]);
  return GridItem;
}(_react.Component), _class2.propTypes = {
  id: _propTypes2.default.string.isRequired,
  // Grid item is editable or just view only
  editable: _propTypes2.default.bool,

  // Only one child
  children: _propTypes2.default.element,

  // Observable grid item state
  layoutItem: _mobxReact.propTypes.observableObject,

  // Item state
  moveToMe: _propTypes2.default.bool,

  // ScrollBox funcs
  scrollVertical: _propTypes2.default.func,

  // Width (pixel) of container
  containerWidth: _propTypes2.default.number,
  // Height (pixel) of container
  containerHeight: _propTypes2.default.number,

  // Grid layout cell's dimension
  cellWidth: _propTypes2.default.number,
  cellHeight: _propTypes2.default.number,

  // Layout columns & rows numbers
  cols: _propTypes2.default.number.isRequired,
  rows: _propTypes2.default.number.isRequired,

  // Min/max size of grid item
  minWidth: _propTypes2.default.number,
  minHeight: _propTypes2.default.number,
  maxWidth: _propTypes2.default.number,
  maxHeight: _propTypes2.default.number,

  // Interactive event handlers
  onDragStop: _propTypes2.default.func,
  onDragStart: _propTypes2.default.func,
  onDrag: _propTypes2.default.func,
  onResizeStop: _propTypes2.default.func,
  onResizeStart: _propTypes2.default.func,
  onResize: _propTypes2.default.func,

  // Handle on size of grid item changed
  onSizeChanged: _propTypes2.default.func,

  // Allow user drag
  isDraggable: _propTypes2.default.bool.isRequired,
  // Allow user resize
  isResizable: _propTypes2.default.bool.isRequired,

  // Selector for draggable handle
  handle: _propTypes2.default.string,
  // Selector for draggable cancel (see react-draggable)
  cancel: _propTypes2.default.string,
  // Show loading when interacting
  showLoading: _propTypes2.default.bool,
  // Should be hidden
  isHidden: _propTypes2.default.bool,

  // Actual width & height pixel
  width: _propTypes2.default.number,
  height: _propTypes2.default.number
}, _class2.defaultProps = {
  cancel: '',
  cols: 1,
  rows: 1,
  minWidth: 1,
  minHeight: 1,
  cellWidth: 0,
  cellHeight: 0,
  maxWidth: Infinity,
  maxHeight: Infinity,
  handle: '[draggable="true"]',
  isHidden: false
}, _temp2)) || _class;

exports.default = GridItem;
module.exports = exports['default'];

/***/ }),
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNumberSchema = exports.createSelectSchema = exports.createOrientationSettingsSchema = exports.createCheckBoxSchema = exports.createColorPaletteSettingSchema = exports.createPopupSettingSchema = exports.createDropDownSchema = exports.createFieldSchema = exports.createPanelGroupSchema = exports.createGroupSchema = undefined;

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _defineEnumerableProperties2 = __webpack_require__(1638);

var _defineEnumerableProperties3 = _interopRequireDefault(_defineEnumerableProperties2);

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createGroupSchema = exports.createGroupSchema = function createGroupSchema(component, props, isHidden) {
  return {
    component: component,
    isHidden: isHidden,
    props: props,
    appendChild: function appendChild(name, fieldSchema) {
      this.fields[name] = fieldSchema;
      return this;
    }
  };
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.PropsEditorGuiSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
var createPanelGroupSchema = exports.createPanelGroupSchema = function createPanelGroupSchema(_ref) {
  var title = _ref.title,
      _ref$iconClass = _ref.iconClass,
      iconClass = _ref$iconClass === undefined ? 'icon-toggle-triangle' : _ref$iconClass,
      isHidden = _ref.isHidden,
      hiddenByState = _ref.hiddenByState,
      className = _ref.className;
  return createGroupSchema('Panel', {
    initState: true,
    collapsible: true,
    hiddenByState: hiddenByState,
    className: className,
    header: {
      get title() {
        return (0, _fp.isFunction)(title) ? title() : title;
      },
      icon: iconClass
    }
  }, isHidden);
};

var createFieldSchema = exports.createFieldSchema = function createFieldSchema(_ref2) {
  var _title, _infoIcon, _ref3, _mutatorMap;

  var type = _ref2.type,
      component = _ref2.component,
      title = _ref2.title,
      info = _ref2.info,
      value = _ref2.value,
      props = _ref2.props,
      staticProps = _ref2.staticProps,
      isHidden = _ref2.isHidden;
  return _ref3 = {}, (0, _defineProperty3.default)(_ref3, type ? 'type' : 'component', type || component), _title = 'title', _mutatorMap = {}, _mutatorMap[_title] = _mutatorMap[_title] || {}, _mutatorMap[_title].get = function () {
    return (0, _fp.isFunction)(title) ? title() : title;
  }, _infoIcon = 'infoIcon', _mutatorMap[_infoIcon] = _mutatorMap[_infoIcon] || {}, _mutatorMap[_infoIcon].get = function () {
    return (0, _fp.isFunction)(info) ? info() : info;
  }, (0, _defineProperty3.default)(_ref3, 'isHidden', isHidden), (0, _defineProperty3.default)(_ref3, 'fnValue', value), (0, _defineProperty3.default)(_ref3, 'props', props), (0, _defineProperty3.default)(_ref3, 'staticProps', staticProps), (0, _defineEnumerableProperties3.default)(_ref3, _mutatorMap), _ref3;
};

var createDropDownSchema = exports.createDropDownSchema = function createDropDownSchema(_ref4) {
  var title = _ref4.title,
      info = _ref4.info,
      value = _ref4.value,
      props = _ref4.props,
      isHidden = _ref4.isHidden;
  return createFieldSchema({
    component: 'CustomDropdown',
    title: title,
    info: info,
    value: value,
    isHidden: isHidden,
    props: props
  });
};

var createPopupSettingSchema = exports.createPopupSettingSchema = function createPopupSettingSchema(_ref5) {
  var title = _ref5.title,
      info = _ref5.info,
      value = _ref5.value,
      isHidden = _ref5.isHidden,
      props = _ref5.props,
      staticProps = _ref5.staticProps;
  return createFieldSchema({
    type: 'btnPopup',
    title: title,
    info: info,
    value: value,
    isHidden: isHidden,
    props: props,
    staticProps: (0, _assign2.default)({
      className: 'icon-setting btn-icon',
      popupProps: {
        type: 'none',
        autoClose: false,
        sizeClass: 'modal-lg',
        containerClass: 'izenda-ThresholdSettings izenda-ChartSettingsPopup'
      }
    }, staticProps)
  });
};

var createColorPaletteSettingSchema = exports.createColorPaletteSettingSchema = function createColorPaletteSettingSchema(_ref6) {
  var title = _ref6.title,
      info = _ref6.info,
      value = _ref6.value,
      isHidden = _ref6.isHidden,
      props = _ref6.props;
  return createFieldSchema({
    component: 'ColorPaletteSetting',
    title: title,
    info: info,
    value: value,
    isHidden: isHidden,
    props: props
  });
};

var createCheckBoxSchema = exports.createCheckBoxSchema = function createCheckBoxSchema(_ref7) {
  var title = _ref7.title,
      info = _ref7.info,
      value = _ref7.value,
      isHidden = _ref7.isHidden;
  return createFieldSchema({
    type: 'checkbox',
    title: title,
    info: info,
    value: value,
    isHidden: isHidden
  });
};

var createOrientationSettingsSchema = exports.createOrientationSettingsSchema = function createOrientationSettingsSchema(_ref8) {
  var title = _ref8.title,
      info = _ref8.info,
      value = _ref8.value,
      isHidden = _ref8.isHidden;
  return createFieldSchema({
    component: 'OrientationSettings',
    title: title,
    info: info,
    value: value,
    isHidden: isHidden
  });
};

var createSelectSchema = exports.createSelectSchema = function createSelectSchema(_ref9) {
  var title = _ref9.title,
      info = _ref9.info,
      value = _ref9.value,
      isHidden = _ref9.isHidden,
      props = _ref9.props,
      staticProps = _ref9.staticProps;
  return createFieldSchema({
    type: 'select',
    title: title,
    info: info,
    value: value,
    isHidden: isHidden,
    props: props,
    staticProps: staticProps
  });
};

var createNumberSchema = exports.createNumberSchema = function createNumberSchema(_ref10) {
  var title = _ref10.title,
      info = _ref10.info,
      value = _ref10.value,
      isHidden = _ref10.isHidden,
      props = _ref10.props;
  return createFieldSchema({
    type: 'number',
    title: title,
    info: info,
    value: value,
    isHidden: isHidden,
    props: props
  });
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectWithoutProperties2 = __webpack_require__(214);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.FieldContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Container for Drop Field
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _recompose = __webpack_require__(9);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(255);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1751);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(53);

var _Izenda6 = __webpack_require__(153);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(15);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(49);

var _Izenda11 = __webpack_require__(2);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(916);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(12);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(555);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(1867);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraggableItem = (0, _Izenda2.default)(_Izenda5.DRAG_ITEM.REPORT_PART_FIELD_ITEM, _Izenda4.default.sourceOptions);

var FieldItem = (0, _recompose.compose)(DraggableItem)(__webpack_require__(1884));

var propsEditors = [{
  name: 'fieldProps',
  getDefinedSchema: _Izenda18.default
}];

var FieldList = (0, _mobxReact.observer)(function (props) {
  var item = props.item,
      container = props.container,
      onDeleteElement = props.onDeleteElement,
      reportPart = props.reportPart,
      store = props.store,
      isOver = props.isOver,
      showPlaceHolder = props.showPlaceHolder,
      quickEdit = props.quickEdit,
      openSelectionFieldPopup = props.openSelectionFieldPopup,
      additionalClassName = props.additionalClassName,
      canAccess = props.canAccess;


  var allowAccess = canAccess && canAccess(props, item);
  var haveField = !(0, _fp.isEmpty)(container.elements);

  var handleClick = function handleClick() {
    return _Izenda7.default.togglePropertiesEditor(true);
  };
  var setConfigField = function setConfigField(element) {
    return function () {
      return reportPart.setConfigField(element);
    };
  };

  var fields = (0, _fp.flow)((0, _fp.get)('elements'), (0, _fp.sortBy)('position'), (0, _fp.map)(function (elm) {
    return elm ? _react2.default.createElement(FieldItem, {
      itemData: elm,
      container: container,
      onDeleteElement: onDeleteElement,
      onClick: handleClick,
      reportPart: reportPart,
      key: elm.position,
      store: store,
      fieldContainerDetails: container,
      propsEditors: propsEditors,
      beforeShowProps: setConfigField(elm),
      isOverContainer: isOver
    }) : null;
  }), _fp.compact)(container);

  var placeholder = showPlaceHolder && _react2.default.createElement(
    'section',
    { className: 'u_textCenter' },
    !quickEdit && !_Izenda9.default.isMobile && _Izenda16.default.getText('REPORTDESIGNER_LABEL_DRAG_FIELD'),
    _react2.default.createElement(
      'a',
      { onClick: openSelectionFieldPopup },
      _Izenda16.default.getText('REPORTDESIGNER_LABEL_ADD_NEW_FIELD')
    )
  );

  var fieldListClassName = (0, _classnames2.default)('input-drop-container form-control', additionalClassName, {
    'field-container': haveField,
    'can-drop': isOver && allowAccess,
    'cannot-drop': isOver && !allowAccess
  });

  return _react2.default.createElement(
    'div',
    { className: fieldListClassName },
    haveField ? fields : placeholder
  );
});

var FieldContainer = (_dec = (0, _Izenda10.exportClass)('FieldContainer'), _dec2 = (0, _Izenda12.default)(_Izenda20.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FieldContainer, _Component);

  function FieldContainer() {
    (0, _classCallCheck3.default)(this, FieldContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FieldContainer.__proto__ || (0, _getPrototypeOf2.default)(FieldContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FieldContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          height = _props.height,
          props = (0, _objectWithoutProperties3.default)(_props, ['height']);

      var container = props.container;
      var store = this.props.store;

      var className = (0, _classnames2.default)('field-container-wrapper', props.additionalClassName);

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          _Izenda14.default,
          {
            bottomRightResize: true,
            bottomRightResizeClass: 'icon-drag',
            width: '100%',
            height: height,
            minConstraints: [225, 70]
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'field-container-drag-resize' },
              _react2.default.createElement(FieldList, props),
              _react2.default.createElement(
                'a',
                { onClick: this.props.openSelectionFieldPopup },
                _react2.default.createElement('span', { className: 'field-container-icon field-container-icon-plus icon-plus' })
              )
            )
          )
        )
      );
    }
  }]);
  return FieldContainer;
}(_react.Component), _class2.propTypes = {
  container: _react.PropTypes.object,
  additionalClassName: _react.PropTypes.string,
  reportPart: _react.PropTypes.object,
  showPlaceHolder: _react.PropTypes.bool,
  canAccess: _react.PropTypes.func,
  openSelectionFieldPopup: _react.PropTypes.func,
  store: _react.PropTypes.object,
  isOver: _react.PropTypes.bool
}, _class2.defaultProps = {
  container: { elements: [] },
  additionalClassName: '',
  showPlaceHolder: true,
  height: 70,
  resizable: true,
  maximumField: null
}, _temp)) || _class) || _class);
exports.default = FieldContainer;
module.exports = exports['default'];

/***/ }),
/* 307 */,
/* 308 */,
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _bluebird = __webpack_require__(18);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps, _dec2, _class3, _class4, _temp2, _initialiseProps2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PopupInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * PopupInput Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(30);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(36);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(920);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopupInputContent = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PopupInputContent, _Component);

  function PopupInputContent(props) {
    (0, _classCallCheck3.default)(this, PopupInputContent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PopupInputContent.__proto__ || (0, _getPrototypeOf2.default)(PopupInputContent)).call(this, props));

    _initialiseProps.call(_this);

    var value = props.uiState.value || {};
    var popupContentProps = props.popupContentProps || {};
    var settingsBtn = popupContentProps.settingsBtn || [];

    // Get button state
    var buttonSettingState = {};
    settingsBtn.forEach(function (btnInfo, index) {
      var disabledButton = btnInfo.disabledBy && !value[btnInfo.disabledBy];
      buttonSettingState[btnInfo.ref || index] = !!disabledButton;
    });

    _this.buttonSettingState = (0, _mobx.observable)(buttonSettingState);
    return _this;
  }

  // Notify to change button state


  (0, _createClass3.default)(PopupInputContent, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var _props$popupContentPr = props.popupContentProps,
          popupContentProps = _props$popupContentPr === undefined ? {} : _props$popupContentPr,
          localization = props.localization;

      var confirmButtonLabel = popupContentProps.confirmButtonLabel || localization.getText('COMMON_LABEL_OK');

      return _react2.default.createElement(
        _Izenda6.default,
        (0, _extends3.default)({}, props.popupProps, { visible: true, onClosing: this.closingPopup, onClosed: this.closePopup }),
        _react2.default.createElement(_Izenda6.default.Header, { title: props.popupTitle || localization.getText('POPUP_INPUT_DEFAULT_TITLE') }),
        _react2.default.createElement(
          _Izenda6.default.Body,
          null,
          props.popupContent ? _react2.default.createElement(props.popupContent, (0, _extends3.default)({}, props, popupContentProps, {
            settingValue: props.uiState.settingValue,
            value: props.uiState.value,
            notifySettingButtonState: this.notifySettingButtonState,
            ref: this.setDom
          })) : 'empty-popup'
        ),
        _react2.default.createElement(
          _Izenda6.default.Footer,
          null,
          this.getSettingButtons(),
          _react2.default.createElement(
            _Izenda6.default.ConfirmationButton,
            { type: 'accept' },
            confirmButtonLabel
          ),
          _react2.default.createElement(
            _Izenda6.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return PopupInputContent;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.closePopup = function (type) {
    var props = _this2.props;

    if (type === 'accept') {
      var value = (0, _fp.invoke)('getValue', _this2.popupContent);
      (0, _bluebird.resolve)(props.onChange && props.onChange({ value: value })).finally(function () {
        props.onAccept();
      });
    }

    props.onReject();
  };

  this.closingPopup = function (callback, type) {
    var props = _this2.props;
    var _props$popupContentPr2 = props.popupContentProps,
        popupContentProps = _props$popupContentPr2 === undefined ? {} : _props$popupContentPr2,
        validation = props.validation;

    var popupContent = _this2.popupContent;

    beforeClosingPopup(type).then(function (canClose) {
      if (canClose) {
        if (type === 'accept') {
          validation.validate().then(function (success) {
            if (success) {
              return (0, _bluebird.resolve)(props.onChange && props.onChange({ value: popupContent.getValue && popupContent.getValue() })).finally(function () {
                validation.reset();
                props.onAccept();
              });
            }
          });
        } else {
          (0, _fp.invoke)('resetData', popupContent);
          validation.reset();
          props.onAccept();
        }
      }
    });

    function beforeClosingPopup(btnType) {
      var beforeCloseFn = popupContentProps.beforeClosing;

      if (beforeCloseFn && popupContent[beforeCloseFn]) {
        return (0, _bluebird.resolve)(popupContent[beforeCloseFn](validation, btnType));
      }
      return (0, _bluebird.resolve)(true);
    }
  };

  this.handleConfirm = function (index) {
    var validation = _this2.props.validation;

    var settingsBtn = (0, _fp.getOr)([], 'popupContentProps.settingsBtn', _this2.props);
    var popupContent = _this2.popupContent;

    // access popupContent as the time of onClick call not when render first time
    validation.reset();
    var action = settingsBtn[index].action;
    action && popupContent[action] && popupContent[action]();
  };

  this.getSettingButtons = function () {
    var settingsBtn = (0, _fp.getOr)([], 'popupContentProps.settingsBtn', _this2.props);

    return settingsBtn.map(function (btnInfo, index) {
      return _react2.default.createElement(_Izenda6.default.ConfirmationButton, (0, _extends3.default)({
        disabled: _this2.buttonSettingState[btnInfo.ref || index],
        ref: btnInfo.ref,
        key: index
      }, btnInfo, {
        onClick: _this2.handleConfirm.bind(_this2, index)
      }));
    });
  };

  this.notifySettingButtonState = function (buttonRef, disabled) {
    _this2.buttonSettingState[buttonRef] = disabled;
  };

  this.setDom = function (dom) {
    _this2.popupContent = dom;
  };
}, _temp)) || _class);
var PopupInput = (_dec2 = (0, _Izenda2.default)(), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(PopupInput, _Component2);

  function PopupInput(props) {
    (0, _classCallCheck3.default)(this, PopupInput);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (PopupInput.__proto__ || (0, _getPrototypeOf2.default)(PopupInput)).call(this, props));

    _initialiseProps2.call(_this3);

    _this3.uiState = new _Izenda8.default();
    _this3.uiState.update(_this3.props);
    return _this3;
  }

  (0, _createClass3.default)(PopupInput, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this.uiState.update(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var hadSetting = this.uiState.hadSetting;
      var localization = props.localization,
          label = props.label,
          popupTitle = props.popupTitle,
          className = props.className;

      var classes = (0, _classnames2.default)('izenda-PopupInput', props.containerClassName);

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          _Izenda4.default,
          { className: className, label: label, onClick: this.onClick, title: popupTitle },
          hadSetting && _react2.default.createElement(
            'div',
            { className: 'u_floatRight u-posRelative' },
            _react2.default.createElement('i', { className: 'icon-ok u_smallIcon u-hadSetting u-colorWhite u-bgGreen' })
          )
        ),
        hadSetting && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('i', {
            className: 'icon-cancel u-colorRed',
            title: localization.getText('PROPERTIES_EDITOR_REMOVE_SETTING'),
            onClick: this.onResetValue
          })
        )
      );
    }
  }]);
  return PopupInput;
}(_react.Component), _class4.propTypes = {
  // Condition to show warning before open popup
  warningCondition: _propTypes2.default.func,
  // Action when user accept the warning
  warningAction: _propTypes2.default.func
}, _initialiseProps2 = function _initialiseProps2() {
  var _this4 = this;

  this.onClick = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var props = _this4.props;

    if (props.onClick) {
      (0, _bluebird.resolve)(props.onClick(args)).then(function (data) {
        return !(0, _fp.isNil)(data) && _this4.openPopup();
      });
    } else {
      if (props.warningCondition && props.warningCondition()) {
        return props.confirmFn('Confirmation', {
          description: props.warningMessage
        }).then(function () {
          props.warningAction && props.warningAction();
          _this4.openPopup();
        });
      } else {
        _this4.openPopup();
      }
    }
  };

  this.openPopup = function () {
    var cloneProps = _this4.props;
    var uiState = _this4.uiState;
    !cloneProps.uiState && (cloneProps = (0, _assign2.default)({}, cloneProps, { uiState: uiState }));
    cloneProps.uiState.update(cloneProps);
    cloneProps.openPopup(PopupInputContent, cloneProps);
  };

  this.onResetValue = function () {
    var props = _this4.props;
    var defaultValue = null;
    if (props.fnResetDefaultValue) {
      defaultValue = props.fnResetDefaultValue();
    }

    props.onChange && props.onChange(defaultValue);
  };
}, _temp2)) || _class3);
exports.default = PopupInput;
module.exports = exports['default'];

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.VirtualList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var Utils = __webpack_require__(262);
  var VirtualListItem = __webpack_require__(1804);
  var VirtualListUIStore = __webpack_require__(1805);
  var ScrollBox = __webpack_require__(27);

  var resizeDetector = __webpack_require__(208);
  var observer = __webpack_require__(10).observer;

  var DEFAULT_SCROLL_THROTTLE = 150;
  var DEFAULT_PAGE_TO_SCREEN_RATIO = 3;

  var _require = __webpack_require__(1),
      invokeArgs = _require.invokeArgs,
      debounce = _require.debounce;

  var VirtualHeight = observer(function (props) {
    var virtualHeight = props.virtualStore.virtualHeight;

    return React.createElement(
      'div',
      { className: props.className, ref: props.childRef, style: { height: virtualHeight } },
      props.children
    );
  });

  var BufferHeight = observer(function (props) {
    var bufferHeight = props.virtualStore.bufferHeight;

    return React.createElement('div', { style: { height: bufferHeight }, className: props.className });
  });

  var VirtualList = React.createClass({
    displayName: 'VirtualList',

    virtualStore: null,
    propTypes: {
      dataSource: ObservablePropTypes.arrayOrObservableArray.isRequired,
      renderItem: PropTypes.func.isRequired,
      getChildItems: PropTypes.func,
      getItemKey: PropTypes.func,
      pageToScreenRatio: PropTypes.number,
      // Throttle milisecond of scrolling event
      scrollThrottle: PropTypes.number,
      // Indicate the virtual list has its own scroll bars
      ownScroll: PropTypes.bool
    },
    getDefaultProps: function getDefaultProps() {
      return {
        pageToScreenRatio: DEFAULT_PAGE_TO_SCREEN_RATIO,
        scrollThrottle: DEFAULT_SCROLL_THROTTLE,
        ownScroll: false
      };
    },
    componentWillMount: function componentWillMount() {
      var props = this.props;
      var pageToScreenRatio = props.pageToScreenRatio;
      var dataSource = props.dataSource;
      this.virtualStore = new VirtualListUIStore(pageToScreenRatio, dataSource);
      invokeArgs('registerVirtualStore', [this.virtualStore], props);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var dataSource = nextProps.dataSource;
      var getChildItems = this.props.getChildItems;

      this.virtualStore.initialize(dataSource, getChildItems);
    },
    componentDidMount: function componentDidMount() {
      var dataSource = this.props.dataSource;
      var getChildItems = this.props.getChildItems;
      this.virtualStore.initialize(dataSource, getChildItems);
      this.listen();
    },
    componentWillUnmount: function componentWillUnmount() {
      this.unlisten && this.unlisten();
      this.virtualStore.release();
      this.virtualStore = null;
      this.unlisten = null;
    },
    render: function render() {
      var props = this.props;
      var ownScroll = props.ownScroll;

      return ownScroll ? React.createElement(
        VirtualHeight,
        { className: props.className, childRef: this.setViewDom, virtualStore: this.virtualStore },
        React.createElement(
          ScrollBox,
          { onScroll: this.onScroll },
          React.createElement(BufferHeight, { virtualStore: this.virtualStore, className: props.bufferClassName }),
          this.renderList()
        )
      ) : React.createElement(
        VirtualHeight,
        { className: props.className, childRef: this.setViewDom, virtualStore: this.virtualStore },
        React.createElement(BufferHeight, { virtualStore: this.virtualStore, className: props.bufferClassName }),
        this.renderList()
      );
    },
    renderList: function renderList() {
      var itemIndex, itemsLength;
      var virtualStore = this.virtualStore;
      var virtualListItems = [];
      var virtualItemsOnScreen = virtualStore.virtualItemsOnScreen;
      for (itemIndex = 0, itemsLength = virtualItemsOnScreen.length; itemIndex < itemsLength; itemIndex++) {
        virtualListItems.push(this.renderItem(virtualItemsOnScreen[itemIndex]));
      }

      return virtualListItems;
    },
    renderItem: function renderItem(virtualItem) {
      var renderItem = this.props.renderItem;
      var getItemKey = this.props.getItemKey;
      var dataItem = virtualItem.dataItem;
      var item = renderItem(dataItem, virtualItem.itemIndex);
      var key = getItemKey(dataItem) || virtualItem.itemIndex;

      return item && React.createElement(
        VirtualListItem,
        { item: virtualItem, key: key },
        item
      );
    },
    setViewDom: function setViewDom(dom) {
      this.viewDom = dom;
    },
    getView: function getView() {
      return this.viewDom;
    },
    getBuffer: function getBuffer() {
      return this.refs.buffer;
    },
    listen: function listen() {
      var _this = this;

      var virtual = this;
      var ownScroll = this.props.ownScroll;
      var scrollThrottle = this.props.scrollThrottle;
      var view = this.getView();
      var scrollParent = Utils.findScrollableParent(view);
      if (scrollParent) {
        var viewport = scrollParent.parentNode;

        this.virtualStore.setViewportDimension(viewport.clientWidth, viewport.clientHeight);
        // Listen to virtual view resizing
        var throttleResize = debounce(scrollThrottle, function (elm) {
          virtual.onResize(elm);
        });
        resizeDetector.listenTo(viewport, throttleResize);

        if (!ownScroll) {
          this.onScroll(scrollParent);
          this.throttleScroll = debounce(scrollThrottle, function (scrollEvent) {
            return _this.onScroll(scrollEvent.target);
          }, {
            maxWait: scrollThrottle * 3
          });
          scrollParent.addEventListener('scroll', this.throttleScroll, {
            capture: false,
            passive: true
          });
        }

        this.unlisten = function () {
          resizeDetector.removeListener(viewport, throttleResize);

          if (!ownScroll) {
            scrollParent.removeEventListener('scroll', this.throttleScroll, {
              capture: false,
              passive: true
            });
          }
        };
      }
    },
    onResize: function onResize(elm) {
      var width = elm.clientWidth;
      var height = elm.clientHeight;
      if (this.isMounted()) {
        this.virtualStore.setViewportDimension(width, height);
      }
    },
    onScroll: function onScroll(viewNode) {
      var position = viewNode.scrollTop;
      var view = this.getView();

      if (!this.props.ownScroll) {
        var relativePosition = Utils.findRelativePositionToAcesstor(view, viewNode);
        position = -relativePosition.top;
      }

      this.virtualStore && this.virtualStore.calculateStartIndex(position);
    }
  });
  module.exports = observer(VirtualList);
}();

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Icon Component
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.Icon.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var Icon = function Icon(props) {
  var rest = (0, _fp.omit)('className', props);
  var className = props.className;
  /**
   * render component
   * @returns {Object}
   */

  return _react2.default.createElement('i', (0, _extends3.default)({ className: className }, rest));
};

Icon.defaultProps = {
  className: 'form-control'
};

exports.default = Icon;
module.exports = exports['default'];

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ProvisionMapDataStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var action = __webpack_require__(5).action;
  var databaseSetupDataFetcher = __webpack_require__(942);
  var uiState = __webpack_require__(15);

  var AppGlobalConstants = __webpack_require__(115);
  var CommonMessages = __webpack_require__(37);
  var PROVISIONING_STATUS = AppGlobalConstants.PROVISIONING_STATUS;
  var PROVISION_DATA_NOTIFICATION_MESSAGE_KEY = __webpack_require__(105).PROVISION_DATA_NOTIFICATION_MESSAGE_KEY;
  var MESSAGE_TYPE = CommonMessages.MESSAGE_TYPE;
  var PROVISION_MAP_DATA = CommonMessages.PROVISION_MAP_DATA;

  function ProvisionMapDataStore() {}

  ProvisionMapDataStore.prototype.importMapData = function () {
    return databaseSetupDataFetcher.provisionStaticData().then(action(function (result) {
      uiState.setProvisioningStatus(result);
      uiState.removeNotification(PROVISION_DATA_NOTIFICATION_MESSAGE_KEY.ERROR);
      uiState.addNotification({
        key: PROVISION_DATA_NOTIFICATION_MESSAGE_KEY.PROVISIONING,
        type: MESSAGE_TYPE.INFO,
        message: PROVISION_MAP_DATA.IMPORTING
      });
      return result;
    }));
  };

  ProvisionMapDataStore.prototype.getProvisioningStatus = function () {
    return databaseSetupDataFetcher.provisionStaticDataStatus().then(action(function (result) {
      uiState.setProvisioningStatus(result);
      switch (result) {
        case PROVISIONING_STATUS.ERROR:
          uiState.removeNotification(PROVISION_DATA_NOTIFICATION_MESSAGE_KEY.PROVISIONING);
          uiState.addNotification({
            key: PROVISION_DATA_NOTIFICATION_MESSAGE_KEY.ERROR,
            type: MESSAGE_TYPE.INFO,
            message: PROVISION_MAP_DATA.IMPORT_FAILED
          });
          break;
        case PROVISIONING_STATUS.PROVISIONING:
          uiState.removeNotification(PROVISION_DATA_NOTIFICATION_MESSAGE_KEY.ERROR);
          uiState.addNotification({
            key: PROVISION_DATA_NOTIFICATION_MESSAGE_KEY.PROVISIONING,
            type: MESSAGE_TYPE.INFO,
            message: PROVISION_MAP_DATA.IMPORTING
          });
          break;
        case PROVISIONING_STATUS.SUCCESS:
          uiState.removeNotification(PROVISION_DATA_NOTIFICATION_MESSAGE_KEY.ERROR);
          uiState.removeNotification(PROVISION_DATA_NOTIFICATION_MESSAGE_KEY.PROVISIONING);
          break;
      }
      return result;
    }));
  };

  module.exports = new ProvisionMapDataStore();
}();

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function () {
  var ReportDesignerConstants = __webpack_require__(16);

  var _require = __webpack_require__(1),
      includes = _require.includes;

  function isImage(dataType) {
    return includes(dataType, ReportDesignerConstants.DATA_TYPES.IMAGE);
  }

  function isBinary(dataType) {
    var DATA_TYPES = ReportDesignerConstants.DATA_TYPES;
    return includes(dataType, [DATA_TYPES.IMAGE, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON]);
  }

  module.exports = {
    isImage: isImage,
    isBinary: isBinary
  };
}();

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AlignmentSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * AlignmentSetting Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlignmentSetting = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(AlignmentSetting, _Component);

  function AlignmentSetting() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AlignmentSetting);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AlignmentSetting.__proto__ || (0, _getPrototypeOf2.default)(AlignmentSetting)).call.apply(_ref, [this].concat(args))), _this), _this.state = { alignmentStyle: _this.props.value }, _this.renderButton = function (btnName, className, title) {
      var props = _this.props;
      var onClick = function onClick() {
        _this.setState({ alignmentStyle: btnName }, function () {
          props.onChange && props.onChange({ value: btnName });
        });
      };

      return _react2.default.createElement('button', {
        key: btnName,
        type: 'button',
        className: className + ' btn-highlight',
        onClick: onClick,
        title: title
      });
    }, _this.renderButtons = function () {
      var alignmentStyle = _this.state.alignmentStyle;
      var btnConfig = [{
        btnName: 'left',
        className: 'icon-align-left align-left',
        title: _Izenda2.default.getText('COMMON_LABEL_ALIGN_LEFT')
      }, {
        btnName: 'center',
        className: 'icon-align-center align-right',
        title: _Izenda2.default.getText('COMMON_LABEL_ALIGN_CENTER')
      }, {
        btnName: 'right',
        className: 'icon-align-right align-center',
        title: _Izenda2.default.getText('COMMON_LABEL_ALIGN_RIGHT')
      }, {
        btnName: 'justify',
        className: 'icon-align-justify align-justify',
        title: _Izenda2.default.getText('COMMON_LABEL_ALIGN_JUSTIFY')
      }];

      return (0, _fp.map)(function (value) {
        var classes = (0, _classnames2.default)(value.className, {
          active: value.btnName === alignmentStyle
        });

        return _this.renderButton(value.btnName, classes, value.title);
      }, btnConfig);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AlignmentSetting, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ alignmentStyle: nextProps.value });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('alignment-setting', this.props.className);
      return _react2.default.createElement(
        'div',
        { className: className },
        this.renderButtons()
      );
    }
  }]);
  return AlignmentSetting;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func
}, _class.defaultProps = {
  value: 'left'
}, _temp2);
exports.default = AlignmentSetting;
module.exports = exports['default'];

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbededReportUtils.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      map = _require.map,
      isBoolean = _require.isBoolean,
      set = _require.set,
      reduce = _require.reduce,
      compact = _require.compact,
      get = _require.get,
      getOr = _require.getOr;

  module.exports = {
    buildPromiseFetcher: function buildPromiseFetcher(reportPart, reportPartDefinitionFetcher, reportDefinitionFetcher, increaseView) {
      var listEmbededReportPartPromise = (0, _bluebird.all)(map(function (reportPartId) {
        return reportPartDefinitionFetcher(reportPartId).catch(function (error) {
          return null;
        });
      }, reportPart.embededInfo.reportPartIds));
      var listEmbededReportPromise = (0, _bluebird.all)(map(function (reportId) {
        return reportDefinitionFetcher(reportId, undefined, undefined, increaseView).then(function (data) {
          if (!data || isBoolean(get('success', data)) && !data.success) {
            return null;
          }
          return data;
        }).catch(function (error) {
          return null;
        });
      }, reportPart.embededInfo.reportIds));

      return (0, _bluebird.join)(listEmbededReportPartPromise, listEmbededReportPromise, function (listEmbededReportPartDef, listEmbededReportDef) {
        return {
          reportParts: reduce(function (acc, item) {
            return set(item.id, item, acc);
          }, {}, compact(listEmbededReportPartDef)),
          reports: reduce(function (acc, item) {
            var report = item.report;
            return set(report.id, report.reportPart, acc);
          }, {}, compact(listEmbededReportDef))
        };
      });
    },
    readEmbededReportDef: function readEmbededReportDef(reportPart, fieldInfo) {
      var listEmbededReportPart = [];

      if (fieldInfo.embededInfo.reportId) {
        listEmbededReportPart = getOr([], 'embedReportDef.reports.' + fieldInfo.embededInfo.reportId, reportPart);
      } else {
        listEmbededReportPart = compact(map(function (id) {
          return get('embedReportDef.reportParts.' + id, reportPart);
        }, fieldInfo.embededInfo.reportPartIds));
      }

      return listEmbededReportPart;
    }
  };
}();

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.IntergrateStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntergrateStore = (_temp = _class = function () {
  function IntergrateStore() {
    (0, _classCallCheck3.default)(this, IntergrateStore);
  }

  (0, _createClass3.default)(IntergrateStore, null, [{
    key: 'addPart',


    /**
     * Catch a part info.
     * @param {Object} param
     */
    value: function addPart(param) {
      var index = (0, _fp.findIndex)(function (info) {
        return info.id === param.id;
      }, this.partInfos);
      index === -1 && this.partInfos.push(param);
    }

    /**
     * Remove a cached part by its id.
     * @param {String} id
     */

  }, {
    key: 'removePart',
    value: function removePart(id) {
      var index = (0, _fp.findIndex)(function (info) {
        return info.id === id;
      }, this.partInfos);
      index !== -1 && this.partInfos.splice(index, 1);
    }

    /**
     * Add a cross filtering.
     * @param {Object} filter
     */

  }, {
    key: 'addFilter',
    value: function addFilter(filter) {
      var index = (0, _fp.findIndex)(function (item) {
        return filter.key === item.key;
      }, this.crossFilteringFilters);
      if (index === -1) {
        this.crossFilteringFilters.push(filter);
      } else {
        this.crossFilteringFilters[index].value = filter.value;
      }
    }

    /**
     * Add filter collection.
     * @param {Array} filters
     */

  }, {
    key: 'addFilters',
    value: function addFilters(filters) {
      (0, _fp.forEach)(this.addFilter.bind(this), filters);
    }

    /**
     * Check whether a part was cached.
     * @param {String} reportPartId
     */

  }, {
    key: 'isCachedCrossFilteringPart',
    value: function isCachedCrossFilteringPart(reportPartId) {
      var index = (0, _fp.findIndex)(function (item) {
        return item.id === reportPartId && item.reportPart && item.reportPart.reportPartContent.isCrossFiltering;
      }, this.partInfos);
      return index !== -1;
    }

    /**
     * Clean cross filterings.
     */

  }, {
    key: 'cleanFilter',
    value: function cleanFilter() {
      var _this = this;

      this.crossFilteringFilters = (0, _fp.remove)(function (item) {
        var index = (0, _fp.flow)((0, _fp.flatMap)(function (part) {
          return (0, _fp.getOr)([], 'reportPartContent.drilldown.filters', part.reportPart);
        }), (0, _fp.findIndex)(function (filter) {
          return filter.key === item.key;
        }))(_this.partInfos);

        return index === -1;
      }, this.crossFilteringFilters);
    }

    /**
     * Update report part data into cached part.
     * @param {Object} reportPart
     */

  }, {
    key: 'updateReportPart',
    value: function updateReportPart(reportPart) {
      if (!(0, _fp.isNil)(reportPart)) {
        var partInfo = (0, _fp.find)(function (item) {
          return item.id === reportPart.id;
        }, this.partInfos);
        partInfo && (partInfo.reportPart = reportPart);
      }
    }

    /**
     * Load parts for updating.
     * @param {String} reportId
     * @param {String} excludedPartId
     */

  }, {
    key: 'loadUpdatingReportParts',
    value: function loadUpdatingReportParts(reportId, excludedPartId) {
      var partInfo = (0, _fp.find)(function (item) {
        return item.id === reportId;
      }, this.partInfos) || {};
      if (!partInfo.reportPart.reportPartContent.isCrossFiltering) {
        return [partInfo];
      }

      return (0, _fp.filter)(function (part) {
        return part.reportId === partInfo.reportId && part.id !== excludedPartId && part.reportPart.reportPartContent.isCrossFiltering;
      }, this.partInfos);
    }

    /**
     * Reset store.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.partIds = [];
      this.resetCrossFilteringFilters();
    }

    /**
     * Reset cross filtering's filters.
     */

  }, {
    key: 'resetCrossFilteringFilters',
    value: function resetCrossFilteringFilters() {
      this.crossFilteringFilters = [];
    }

    /**
     * Sync current page manifest
     */

  }, {
    key: 'syncPageManifest',
    value: function syncPageManifest() {
      window.izenda = window.izenda || {};
      var _window$izenda = window.izenda,
          page = _window$izenda.page,
          url = _window$izenda.url;

      var absUrl = (0, _Izenda.makeAbsoluteUrl)();

      if (url !== absUrl) {
        page = String.newGuid();
        url = absUrl;
        window.izenda.page = page;
        window.izenda.url = url;
      }

      return page;
    }
  }]);
  return IntergrateStore;
}(), _class.partInfos = [], _class.crossFilteringFilters = [], _temp);
exports.default = IntergrateStore;
;
module.exports = exports['default'];

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(164);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(321);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1902);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(39);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generate data object for row
 * @param  {array} records
 * @param  {array} previewData
 * @param  {array} rowsContainer
 * @return {array} row data object
 */
// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.ReportPartGridProcessData.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridProcessData
 * Utility for processing data for Pivot/DrillDown grid
 */

var createRowDataObject = function createRowDataObject(records, previewData, rowsContainer, keyPath, forDrillDown, isExpand) {
  var filterMappingValue = _Izenda2.default.filterMappingByContainer(previewData.fieldsMapping, rowsContainer);
  var multiLevelData = _Izenda2.default.splitDataForSeparator(records, filterMappingValue, !forDrillDown);

  return (0, _fp.map)(_Izenda6.default.createRowDataObject.bind(null, rowsContainer.elements.length, keyPath, isExpand), multiLevelData);
};

/**
 * Generate data object headers for row
 * @param  {object} rowsContainer
 * @param  {object} columnsContainer
 * @return {array} row header data object
 */
var createRowHeadersDataObject = function createRowHeadersDataObject(rowsContainer) {
  var leafRowHeaders = (0, _fp.map)(function (item) {
    return _Izenda4.default.createLeafNode(1, null, '', _Izenda4.default.COLUMN_TYPE.ROW, {
      element: item
    }, true);
  }, rowsContainer.visibleElement);

  return leafRowHeaders;
};

/**
 * Filter Mapping By Container
 * @param  {Array} fieldsMapping
 * @param  {Object} container
 * @return {Array}
 */
var filterMappingByContainer = function filterMappingByContainer(fieldsMapping, container) {
  var filterMapping = _Izenda2.default.filterMappingByContainer(fieldsMapping, container);
  return (0, _fp.filter)(function (item) {
    return !!(0, _fp.get)('element.properties.fieldItemVisible', item);
  }, filterMapping);
};

/**
 * Generate data object headers for column
 * @param  {array} records Raw data
 * @param  {object} previewData
 * @param  {object} columnsContainer
 * @param  {object} valueContainer
 * @return {array} column header data object
 */
var createColumnDataObject = function createColumnDataObject(records, previewData, columnsContainer, valueContainer, separatorContainer, keyPath) {
  var filterMappingColumn = _Izenda2.default.filterMappingByContainer(previewData.fieldsMapping, columnsContainer);
  var filterMappingValue = filterMappingByContainer(previewData.fieldsMapping, valueContainer);
  var maxLevel = void 0;
  var sideTotalsMapping = void 0;
  var result = [];
  var multiLevelData = [];

  if ((0, _fp.isEmpty)(filterMappingColumn)) {
    // Process Data Column for DrillDown
    result = (0, _fp.map)(_Izenda4.default.createLeafNode.bind(null, 1, null, '', _Izenda4.default.COLUMN_TYPE.VALUE), filterMappingValue);
  } else {
    // Process Data Column for Pivot
    maxLevel = filterMappingColumn.length + 1;

    // generate siteTotalsMapping
    sideTotalsMapping = (0, _fp.sortBy)('position', (0, _fp.reduce)(function (mapping, item) {
      var valueElement = (0, _fp.find)(['field.fieldNameAlias', item.fieldNameAlias], valueContainer.visibleElement);
      if (valueElement) {
        var newItem = (0, _fp.clone)(item);
        newItem.element = valueElement;
        mapping.push(newItem);
      }

      return mapping;
    }, [], previewData.sideTotalMapping));

    multiLevelData = _Izenda2.default.splitDataForSeparator(records.slice(), filterMappingColumn, true, true);

    result = (0, _fp.map)(_Izenda4.default.createBranchNode.bind(null, filterMappingValue, maxLevel, sideTotalsMapping, []), multiLevelData);
  }
  return result;
};

var flattenRowDataObject = function flattenRowDataObject(rowDataObject, forDrillDown, haveSuptotal) {
  var partialFunc = (0, _fp.partial)(flattenRowDataObject, [_fp.placeholder, forDrillDown, haveSuptotal]);

  if ((0, _fp.isArrayLike)(rowDataObject)) {
    return (0, _fp.flatMap)(partialFunc, rowDataObject);
  }
  var currentRow = {
    rowDataObject: rowDataObject,
    firstRow: true
  };

  if ((rowDataObject.isExpand || rowDataObject.element && !rowDataObject.element.isVisible) && !(0, _fp.isEmpty)(rowDataObject.childs)) {
    var childDataRecords = (0, _fp.flatMap)(partialFunc, rowDataObject.childs);

    if (forDrillDown && rowDataObject.element.isVisible) {
      childDataRecords = (0, _fp.concat)([{ currentRow: currentRow, rowDataObjects: {} }], childDataRecords);
      if (haveSuptotal) {
        childDataRecords = (0, _fp.concat)(childDataRecords, [{ currentRow: (0, _fp.set)('isSupTotalRow', true, (0, _fp.set)('firstRow', false, currentRow)), rowDataObjects: {} }]);
      }
    }
    var lastRowIndex = childDataRecords.length - 1;

    childDataRecords.map(function (item, index) {
      item.rowDataObjects[rowDataObject.uniqueFieldNameAlias] = {
        rowDataObject: rowDataObject,
        firstRow: index === 0,
        isSupTotalRow: index === lastRowIndex && forDrillDown && haveSuptotal && rowDataObject.size > 1
      };
    });
    return childDataRecords;
  }
  // last group
  var returnRow = {
    currentRow: currentRow,
    rowDataObjects: {}
  };

  returnRow.currentRow.isSupTotalRow = forDrillDown && haveSuptotal && !(0, _fp.isEmpty)(rowDataObject.childs) && !rowDataObject.isExpand;

  returnRow.rowDataObjects[rowDataObject.uniqueFieldNameAlias] = currentRow;
  return [returnRow];
};

var updateSideTotalMapping = function updateSideTotalMapping(sideTotalColumnDataObject, sideTotalMapping, columnsContainer) {
  if (!(0, _fp.isEmpty)(sideTotalMapping)) {
    var columnFieldNameAlias = (0, _fp.map)((0, _fp.get)('field.fieldNameAlias'), columnsContainer.visibleElement);
    var sideTotalsMapping = (0, _fp.reject)(function (item) {
      return (0, _fp.includes)(item.groupFieldLevel, columnFieldNameAlias);
    }, sideTotalMapping);

    (0, _fp.forEach)(function (item) {
      var mapping = (0, _fp.find)({
        fieldNameAlias: item.element.field.fieldNameAlias
      }, sideTotalsMapping);

      mapping && !(0, _fp.includes)(mapping.columnName, item.keyList) && item.keyList.unshift(mapping.columnName);
    }, sideTotalColumnDataObject);
  }
};
/**
 * create subtotals headers
 * @param  {array} columnDataObjects
 * @return {array} subtotal
 */
var createSideTotal = function createSideTotal(previewData, valueContainer) {
  var filterMappingValue = _Izenda2.default.filterMappingByContainer(previewData.fieldsMapping, valueContainer);
  var sideTotalColumns = (0, _fp.map)(_Izenda4.default.createLeafNode.bind(null, 1, null, 'Total', _Izenda4.default.COLUMN_TYPE.SIDE_TOTAL), filterMappingValue);

  return (0, _fp.filter)(function (item) {
    item.forcePrefix = true;
    return item.element.isVisible;
  }, sideTotalColumns);
};

/**
 * recursive function for generating blank row headers
 * @param  {int}           level          [current level]
 * @param  {int}           maxLevel       [max level can be insert]
 * @param  {array of ColumnDataObject}           leafRowHeaders [leaf ColumnDataObject]
 */
function createBlankHeaders(level, maxLevel, leafRowHeaders, isVisible) {
  var header = new _Izenda4.default.ColumnDataObject(true);
  var newLevel = level + 1;

  setHeaderValue(header);

  if (newLevel >= maxLevel) {
    header.childs = leafRowHeaders;
    return header;
  }

  function setHeaderValue(itemHeader) {
    itemHeader.isLeaf = false;
    itemHeader.isHidden = true;
    itemHeader.level = newLevel;
    itemHeader.isInvisible = !isVisible;
  }

  header.childs[0] = createBlankHeaders(newLevel, maxLevel, leafRowHeaders, isVisible);

  return header;
}

/**
 * create first row ('All' row) for DrillDown grid
 * @param  {String} fieldNameAlias
 * @param  {Array}  childs
 * @param  {Array}  keyPath
 * @param  {Number} level
 * @param  {Object} RowDataObject
 */
function createAllRowDataObject(fieldNameAlias, childs, keyPath, level) {
  var item = {
    key: [{
      columnName: '',
      value: 'All'
    }],
    data: []
  };
  var rowDataObject = _Izenda6.default.createRowDataObject(-1, [], true, item);

  rowDataObject.childs = childs;
  rowDataObject.isExpand = true;
  rowDataObject.level = level;
  rowDataObject.ascendingLevel = -1;
  rowDataObject.subKeyPath = keyPath || [];
  rowDataObject.isAllRow = true;

  var currentRow = {
    rowDataObject: rowDataObject,
    isSupTotalRow: false,
    firstRow: true,
    mustHaveExpander: true
  };
  // last group
  var returnRow = {
    currentRow: currentRow,
    rowDataObjects: {}
  };

  returnRow.rowDataObjects[fieldNameAlias] = currentRow;
  return returnRow;
}
function createSupTotalRowDataObject(fieldNameAlias, childs, element, value, data) {
  var item = {
    key: [{
      columnName: '',
      element: element,
      value: value
    }],
    data: data
  };
  var rowDataObject = _Izenda6.default.createRowDataObject(0, [], true, item);

  var currentRow = {
    rowDataObject: rowDataObject,
    isSupTotalRow: true,
    firstRow: false
  };
  // last group
  var returnRow = {
    currentRow: currentRow,
    rowDataObjects: {}
  };

  rowDataObject.childs = childs;
  rowDataObject.isExpand = true;
  returnRow.rowDataObjects[fieldNameAlias] = currentRow;
  return returnRow;
}

function buildRawRecordFilterForPivotGrid(columnData, records) {
  var data = (0, _fp.flow)(_mobx.toJS, (0, _fp.map)((0, _fp.mapValues)(_fp.toString)))(records);

  return (0, _fp.filter)((0, _fp.fromPairs)(columnData.keyPath), data);
}

/**
 * Get cell data
 * @param  {Object} columnData
 * @param  {Object} rowData
 * @param  {Array}  rowExpanders
 * @param  {Object} forDrillDown
 * @param  {Array}  subTotalMapping
 * @return {Object} data object
 */
function getDataForCell(columnData, rowData, rowExpanders, forDrillDown, subTotalMapping) {
  var currentRow = rowData.currentRow;

  if (columnData.type === _Izenda4.default.COLUMN_TYPE.ROW && (!currentRow.isSupTotalRow || forDrillDown)) {
    var currentRowInfo = rowData.rowDataObjects[columnData.uniqueFieldNameAlias];

    return {
      isEmpty: !currentRowInfo || rowExpanders && !currentRowInfo.isSupTotalRow && !currentRowInfo.firstRow,
      data: (0, _fp.get)('rowDataObject.value', currentRowInfo),
      isAllRow: (0, _fp.get)('rowDataObject.isAllRow', currentRowInfo)
    };
  } else if (!currentRow.isSupTotalRow) {
    var rowDataObject = currentRow.rowDataObject;
    var isEmptyRow = rowExpanders && rowDataObject.isExpand && !(0, _fp.isEmpty)(rowDataObject);
    var data = !isEmptyRow && getDataByKey(rowDataObject.data, (0, _fp.fromPairs)(columnData.keyPath), (0, _fp.concat)(columnData.keyList, columnData.key));
    var orgData = !isEmptyRow && getDataByKey(rowDataObject.data, (0, _fp.fromPairs)(columnData.keyPath), '' + _Izenda7.CUSTOM_FORMAT_PREFIX + columnData.key);

    return {
      isEmpty: isEmptyRow,
      dataNotFound: (0, _fp.isNil)(data),
      data: data || '',
      // if the original value is undefined leave as it is. no need to replace it with an empty string. in order to distinguish empty string and absence of data.
      orgData: orgData
    };
  }
  var searchCriteria = {
    fieldNameAlias: columnData.uniqueFieldNameAlias
  };
  rowDataObject = rowData.currentRow.rowDataObject;

  if (columnData.type !== _Izenda4.default.COLUMN_TYPE.ROW) {
    searchCriteria.groupFieldLevel = forDrillDown ? rowDataObject.uniqueFieldNameAlias : columnData.groupFieldLevel;
  }

  var datas = [];
  if (rowDataObject.isAllRow) {
    datas = rowDataObject.data;
    subTotalMapping = rowDataObject.subTotalMapping;
  } else {
    datas = rowDataObject.childsData;
  }

  // compare using undefined for groupFieldLevel
  var key = (0, _fp.find)(function (item) {
    return item.fieldNameAlias === searchCriteria.fieldNameAlias && (searchCriteria.groupFieldLevel === item.groupFieldLevel || !searchCriteria.groupFieldLevel && (0, _fp.isEmpty)(item.groupFieldLevel));
  }, subTotalMapping);

  return {
    isEmpty: !key,
    data: key && (0, _fp.flow)((0, _fp.find)((0, _fp.fromPairs)(columnData.keyPath)), (0, _fp.get)(key.columnName))(datas)
  };
}

function getDataByKey(data, keyPath, keyList) {
  return (0, _fp.flow)((0, _fp.find)(keyPath), (0, _fp.at)(keyList), (0, _fp.remove)(_fp.isNil), _fp.head)(data);
}

function getRawData(columnData, rowData) {
  var rawData = void 0;

  if (columnData.type === _Izenda4.default.COLUMN_TYPE.ROW) {
    rawData = rowData.rowDataObjects[columnData.uniqueFieldNameAlias].rowDataObject.childsData;
  } else {
    rawData = rowData.currentRow.rowDataObject.childsData;
  }

  return buildRawRecordFilterForPivotGrid(columnData, rawData);
}

var getMultiLevelData = function getMultiLevelData(records, previewData, rowsContainer) {
  var filterMappingValue = _Izenda2.default.filterMappingByContainer(previewData.fieldsMapping, rowsContainer);
  return _Izenda2.default.splitDataForSeparator(records, filterMappingValue, true);
};

exports.default = {
  buildRawRecordFilterForPivotGrid: buildRawRecordFilterForPivotGrid,
  createRowDataObject: createRowDataObject,
  createColumnDataObject: createColumnDataObject,
  createRowHeadersDataObject: createRowHeadersDataObject,
  createBlankHeaders: createBlankHeaders,
  createSideTotal: createSideTotal,
  updateSideTotalMapping: updateSideTotalMapping,
  flattenRowDataObject: flattenRowDataObject,
  createSupTotalRowDataObject: createSupTotalRowDataObject,
  getDataForCell: getDataForCell,
  createAllRowDataObject: createAllRowDataObject,
  getRawData: getRawData,
  getMultiLevelData: getMultiLevelData
};
module.exports = exports['default'];

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor; // ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.ColumnDataObject.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ColumnDataObject
 */

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var COLUMN_TYPE = {
  ROW: 'row',
  COLUMN: 'column',
  SIDE_TOTAL: 'side total',
  VALUE: 'value'
};

var ColumnDataObject = (_class = function () {
  (0, _createClass3.default)(ColumnDataObject, [{
    key: 'title',
    get: function get() {
      if (!this.isLeaf) {
        return this.value;
      } else if (this.forcePrefix) {
        return this.sideTotalTitle;
      }

      return this.element.field.fieldNameAlias;
    }
  }, {
    key: 'pivotColumn',
    get: function get() {
      if (this.type !== COLUMN_TYPE.COLUMN) {
        return 0;
      }
      return (0, _fp.sumBy)('pivotColumn', this.childs) || 1;
    }
  }, {
    key: 'sideTotalColumns',
    get: function get() {
      if (this.type !== COLUMN_TYPE.COLUMN) {
        return [];
      }
      return (0, _fp.flow)((0, _fp.flatMap)('sideTotalColumns'), (0, _fp.concat)(_fp.placeholder, this.sideTotals))(this.childs);
    }
  }, {
    key: 'sideTotalTitle',
    get: function get() {
      return String.format('{0} {1}', this.prefix, (0, _fp.get)('field.fieldNameAlias', this.element));
    }
  }]);

  function ColumnDataObject(isColumnHeader) {
    (0, _classCallCheck3.default)(this, ColumnDataObject);

    _initDefineProp(this, 'isExpand', _descriptor, this);

    // check if this node is leaf or branch
    this.isLeaf = true;
    this.key = '';
    this.keyList = [];
    this.element = null;
    this.value = '';
    this.childs = [];
    this.sideTotals = [];
    this.level = 1; // decrease from max > 1
    this.forcePrefix = false;
    this.isInvisible = false;
    this.type = COLUMN_TYPE.COLUMN;
    this.uniqueFieldNameAlias = '';
    this.groupFieldLevel = '';
    this.keyPath = [];
    this.isColumnHeader = isColumnHeader || false;
  }

  (0, _createClass3.default)(ColumnDataObject, [{
    key: 'toggleExpand',
    value: function toggleExpand() {
      this.isExpand = !this.isExpand;
    }

    /**
     * [toLeafNode Convert base ColumnDataObject to leafNode]
     * @method toLeafNode
     * @param  {int}   level   [level]
     * @param  {array of json}   keyPath [filter value]
     * @param  {json}   item    [base data to build node]
     * @param  {string}     prefix  [Prefix for side total column name]
     * @return {ColumnDataObject}           [this object]
     */

  }, {
    key: 'toLeafNode',
    value: function toLeafNode(level, keyPath, prefix, type, item, isColumnHeader) {
      this.isLeaf = true;
      this.key = item.columnName;
      this.element = item.element;
      this.uniqueFieldNameAlias = item.element.field.fieldNameAlias;
      this.keyPath = keyPath;
      this.prefix = prefix;
      this.type = type;
      this.groupFieldLevel = item.groupFieldLevel;
      this.isColumnHeader = isColumnHeader || false;
      return this;
    }

    /**
     * [toBranchNode convert base ColumnDataObject to branchNode]
     * @method toBranchNode
     * @param  {Array json}         valueMapping      [Mapping for value container to correct field in data]
     * @param  {int}         level             [level of object]
     * @param  {Array of json}         sideTotalsMapping [Mapping for side total]
     * @param  {array of json}         keyPath           [filter value]
     * @param  {json}         item              [base data to build node]
     * @return {ColumnDataObject}                           [ColumnDataObject with isLeaf = false]
     */

  }, {
    key: 'toBranchNode',
    value: function toBranchNode(valueMapping, level, sideTotalsMapping, keyPath, item) {
      // create branch node for each sub group
      var subKeyPath = void 0;
      var childBranchArray = void 0;
      var firstItemKey = item.key[0];

      this.isLeaf = false;
      this.key = firstItemKey.columnName;
      this.element = firstItemKey.element;
      this.value = firstItemKey.value;
      this.data = item.data;
      this.level = level;

      this.keyPath = subKeyPath = (0, _fp.concat)(keyPath || [], [[this.key, this.value]]);
      childBranchArray = (0, _fp.map)(createBranchNode.bind(null, valueMapping, level - 1, sideTotalsMapping, subKeyPath), item.subGroup);

      if (!(0, _fp.isEmpty)(childBranchArray)) {
        this.childs = childBranchArray;
        var newSideTotalsMapping = (0, _fp.flow)((0, _fp.filter)({ groupFieldLevel: firstItemKey.element.field.fieldNameAlias }), (0, _fp.sortBy)('position'))(sideTotalsMapping);
        this.sideTotals = (0, _fp.map)(createLeafNode.bind(null, level, subKeyPath, this.value, COLUMN_TYPE.SIDE_TOTAL), newSideTotalsMapping);
      } else {
        var newValueMapping = (0, _fp.map)(function (itemValue) {
          return (0, _fp.set)('groupFieldLevel', firstItemKey.element.field.fieldNameAlias, (0, _fp.clone)(itemValue));
        }, valueMapping);
        this.childs = (0, _fp.map)(createLeafNode.bind(null, 1, subKeyPath, '', COLUMN_TYPE.VALUE), newValueMapping);
      }

      return this;
    }
  }]);
  return ColumnDataObject;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isExpand', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'title', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'title'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'pivotColumn', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'pivotColumn'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'sideTotalColumns', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'sideTotalColumns'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'sideTotalTitle', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'sideTotalTitle'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleExpand', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleExpand'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toBranchNode', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toBranchNode'), _class.prototype)), _class);

/**
 * [createLeafNode Create new leaf node object]
 * @method createLeafNode
 * @param  {int}       level   [level of item]
 * @param  {array of json}       keyPath [filter value to get correct data]
 * @param  {json}       item    [Based data to build object]
 * @param  {string}     prefix  [Prefix for side total column name]
 * @return {ColumnDataObject}               [ColumnDataObject with isLeaf = true]
 */

var createLeafNode = function createLeafNode(level, keyPath, prefix, type, item, isColumnHeader) {
  return new ColumnDataObject().toLeafNode(level, keyPath, prefix, type, item, isColumnHeader);
};

/**
 * [createBranchNode Create new branch node object]
 * @method createBranchNode
 * @param  {Array json}         valueMapping      [Mapping for value container to correct field in data]
 * @param  {int}         level             [level of object]
 * @param  {Array of json}         sideTotalsMapping [Mapping for side total]
 * @param  {array of json}         keyPath           [filter value]
 * @param  {json}         item              [base data to build node]
 * @return {ColumnDataObject}                           [ColumnDataObject with isLeaf = false]
 */
var createBranchNode = function createBranchNode(valueMapping, level, sideTotalsMapping, keyPath, item) {
  return new ColumnDataObject().toBranchNode(valueMapping, level, sideTotalsMapping, keyPath, item);
};

exports.default = {
  ColumnDataObject: ColumnDataObject,
  createBranchNode: createBranchNode,
  createLeafNode: createLeafNode,
  COLUMN_TYPE: COLUMN_TYPE
};
module.exports = exports['default'];

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashStyle.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


/**
 * Border Settings component
 */
!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);
  var dashStyles = __webpack_require__(34).dashStyles;

  var DashStyle = React.createClass({
    displayName: 'DashStyle',


    propTypes: {
      onChange: React.PropTypes.func,
      dashStyle: React.PropTypes.string,
      disabled: React.PropTypes.bool
    },

    getInitialState: function getInitialState() {
      return {
        dashStyle: this.props.dashStyle
      };
    },

    getDefaultProps: function getDefaultProps() {
      return {
        dashStyle: 'dotted'
      };
    },

    onClick: function onClick(value) {
      this.setState({
        dashStyle: value
      });

      this.props.onChange && this.props.onChange(value);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        dashStyle: nextProps.dashStyle
      });
    },

    render: function render() {
      var state = this.state;

      var listStyles = dashStyles.map(function (item) {
        var classes = classnames('line-style', {
          'selected': item === state.dashStyle
        });

        return React.createElement(
          'div',
          { className: classes, onClick: this.onClick.bind(this, item), key: item },
          React.createElement('div', { className: item })
        );
      }.bind(this));

      var classes = classnames('dash-style', this.props.className, {
        'disabled-elm': this.props.disabled
      });

      return React.createElement(
        'div',
        { className: classes },
        listStyles
      );
    }

  });
  module.exports = DashStyle;
}();

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DataRefreshSetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataRefreshSetting Component
 */
!function () {
  var React = __webpack_require__(0);
  var Validator = __webpack_require__(23);
  var Input = __webpack_require__(17);
  var GridLayout = __webpack_require__(13);

  var ValidatorInput = Validator()(Input);
  var EventsUtils = __webpack_require__(24);
  var Constants = __webpack_require__(1949);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      clone = _require.clone;

  var GRID_SIZE_LABEL = 3;
  var GRID_SIZE_CONTROL = 9;

  var DataRefreshSetting = React.createClass({
    displayName: 'DataRefreshSetting',

    getInitialState: function getInitialState() {
      return {
        enable: false,
        updateInterval: 0
      };
    },

    componentWillMount: function componentWillMount() {
      var data = this.props.value;
      this.setState({
        enable: data.enable,
        updateInterval: data.updateInterval
      });
    },

    // Handle "data auto refreshed" checkbox change
    onChangeAutoRefreshed: function onChangeAutoRefreshed(enable) {
      this.setState({
        enable: enable
      });
    },

    // Handle "Update interval textbox" change
    onChangeUpdateInterval: function onChangeUpdateInterval(interval) {
      this.setState({
        updateInterval: parseInt(interval, 10)
      });
    },

    // Return data for update data.
    getValue: function getValue() {
      var dataRefreshSetting = clone(this.state);
      if (!dataRefreshSetting.updateInterval) {
        dataRefreshSetting.updateInterval = 0;
      }
      return dataRefreshSetting;
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var updateIntervalValue;
      if (this.state.updateInterval) updateIntervalValue = this.state.updateInterval;

      var latestRecordValue;
      var intervalConstraint = this.state.enable ? Constants.NUMBER_CONSTRAINT.UPDATE_INTERVAL : {};

      return React.createElement(
        'div',
        { className: 'izenda-DataRefreshSetting' },
        React.createElement(
          GridLayout,
          { className: 'form-horizontal' },
          React.createElement(
            GridLayout.Row,
            { className: 'form-group' },
            React.createElement(
              GridLayout.Col,
              { cols: GRID_SIZE_LABEL },
              localizer.getText('REPORTDESIGNER_LABEL_DATA_AUTO_REFRESHED')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: GRID_SIZE_CONTROL },
              React.createElement(Input, {
                type: 'checkbox',
                onChange: notifyChange(this.onChangeAutoRefreshed, EventsUtils.CHECKBOX),
                checked: this.state.enable
              })
            )
          ),
          React.createElement(
            GridLayout.Row,
            { className: 'form-group' },
            React.createElement(
              GridLayout.Col,
              { cols: GRID_SIZE_LABEL },
              localizer.getText('REPORTDESIGNER_LABEL_UPDATE_INTERVAL')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: GRID_SIZE_CONTROL },
              React.createElement(
                'div',
                { className: 'form-text' },
                React.createElement(ValidatorInput, {
                  className: 'form-control input-text',
                  onChange: notifyChange(this.onChangeUpdateInterval, EventsUtils.INPUT),
                  value: updateIntervalValue,
                  validations: intervalConstraint,
                  field: 'interval'
                })
              ),
              React.createElement(
                'div',
                { className: 'interval' },
                '(s)'
              )
            )
          )
        )
      );
    }
  });

  module.exports = DataRefreshSetting;
}();

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerStore.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

// Child store


var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(90);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(111);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(227);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1985);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(326);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda13 = __webpack_require__(41);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(104);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(400);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(120);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(42);

var _Izenda22 = __webpack_require__(421);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(593);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _Izenda26 = __webpack_require__(2007);

var _Izenda27 = _interopRequireDefault(_Izenda26);

var _Izenda28 = __webpack_require__(594);

var _Izenda29 = _interopRequireDefault(_Izenda28);

var _Izenda30 = __webpack_require__(12);

var _Izenda31 = _interopRequireDefault(_Izenda30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * [ReportDesignerStore master store for report desginer]
 */
var ReportDesignerStore = (_class = function () {
  function ReportDesignerStore(viewMode, reportId, cachedData, isReload) {
    (0, _classCallCheck3.default)(this, ReportDesignerStore);

    _initDefineProp(this, 'model', _descriptor, this);

    _initDefineProp(this, 'reportAccessPriority', _descriptor2, this);

    _initDefineProp(this, 'alertDetails', _descriptor3, this);

    _initDefineProp(this, 'saveAsMode', _descriptor4, this);

    _initDefineProp(this, 'disabled', _descriptor5, this);

    _initDefineProp(this, 'isNewReport', _descriptor6, this);

    _initDefineProp(this, 'disableReportDesigner', _descriptor7, this);

    _initDefineProp(this, 'advancedMode', _descriptor8, this);

    _initDefineProp(this, 'isCompleteLoad', _descriptor9, this);

    _initDefineProp(this, 'globalReportName', _descriptor10, this);

    _initDefineProp(this, 'localReportName', _descriptor11, this);

    _initDefineProp(this, 'isShowingHeaderFooter', _descriptor12, this);

    this.isLoadDraft = false;

    this.switchToDesignReportContainer = false;
    this.disposers = [];
    this.model = cachedData ? cachedData : new _Izenda10.default(viewMode, reportId, isReload);
    this.canSaveAs = !(0, _fp.isNil)(reportId);
    this.isNewReport = !reportId;
    this.isCompleteLoad = !!cachedData;
    this.fieldsStore = new _Izenda23.default(this, viewMode);
    this.dataSourceStore = new _Izenda25.default(this);
    this.scheduleStore = new _Izenda27.default(this);
    this.accessStore = new _Izenda29.default(this.model.reportAccess, this.reportId);
    this.reportListURI = null;

    this.reactiveStore(this);
  }
  // Control to whether load draft or not.


  (0, _createClass3.default)(ReportDesignerStore, [{
    key: 'reactiveStore',
    value: function reactiveStore(store) {
      var reloadDisposer = (0, _mobx.observe)(store, 'reportId', function () {
        store.loadReportDesigner();
      });
      store.disposers.push(reloadDisposer);
    }

    /**
     * To validate report name on API
     * @param  {object} data [report designer model]
     * @return {Promise}      Result form API
     */

  }, {
    key: 'validateReportName',
    value: function validateReportName(data) {
      // call validate on server
      return _Izenda4.default.validateReportName(data);
    }

    /**
     * To get the name text "Global/ Local" for category type
     */

  }, {
    key: 'loadCategorySettings',
    value: function loadCategorySettings() {
      var _this = this;

      _Izenda16.default.loadCategorySettings().bind(this).then((0, _mobx.action)(function (result) {
        var globalReportType = (0, _fp.find)({ isGlobal: true }, result);
        var localReportType = (0, _fp.find)({ isGlobal: false }, result);
        _this.globalReportName = (0, _fp.getOr)(null, 'name', globalReportType);
        _this.localReportName = (0, _fp.getOr)(null, 'name', localReportType);
      }));
    }

    /**
     * Detect physicial change before save/save draft
     */

  }, {
    key: 'detectReportChange',
    value: function detectReportChange(section) {
      var data = this.model.getReportDefinition(section);
      if (this.model.isGlobal && !(0, _fp.isNil)(this.accessStore.tenantId)) {
        data.category = undefined;
        data.categoryId = undefined;
        data.report.category = undefined;
        data.report.categoryId = undefined;
      }
      // only get reportDataSource in first loading time when we have no data
      data.report.reportDataSource = !(0, _fp.isEmpty)(data.report.reportDataSource) ? data.report.reportDataSource : this.model.reportDataSource;

      return _Izenda4.default.detectReportChange(data);
    }

    /**
     * Save Report Designer
     * @param {string} section [section of report designer need save]
     * * @param {string} section [section of report designer need save]
     * @return {promise} [promise result from API]
     */

  }, {
    key: 'saveReport',
    value: function saveReport(section, saveFromViewer) {
      return this.saveOrSaveDraftReport(section, false, saveFromViewer);
    }

    /**
     * Save draft when switch page on Report Designer
     * @param {string} section [section of report designer need save]
     * @return {promise} [promise result from API]
     */

  }, {
    key: 'saveDraftReport',
    value: function saveDraftReport(section, keepReportBodyStates) {
      return this.saveOrSaveDraftReport(section, true /* is draft*/, false, keepReportBodyStates);
    }

    /**
     * Save Report Designer
     * @param {string} section [section of report designer need save]
     * @return {promise} [promise result from API]
     */

  }, {
    key: 'saveOrSaveDraftReport',
    value: function saveOrSaveDraftReport(section, isSaveDraft, saveFromViewer, keepReportBodyStates) {
      !isSaveDraft && this.model.removeUnuseDynamicThresholds();
      var data = this.model.getReportDefinition(section);
      var saveFunction = isSaveDraft ? _Izenda4.default.saveDaftReportDesigner : _Izenda4.default.saveReportDesigner;
      // When to call save or save draft, it will keep this status for load data.
      this.isLoadDraft = isSaveDraft;

      this.alertDetails.reset();
      this.model.updateErrorMessages(null);

      return this.checkDataObjectLimitation().then(function (result) {
        if (result.success || saveFromViewer) {
          return saveFunction(data).then((0, _mobx.action)(function updateReportDesigner(result) {
            if (result.report) {
              isSaveDraft && (result.report.version = data.report.version);

              if (!(0, _fp.isNil)((0, _fp.getOr)(null, 'report.reportFilter.filterFields', result))) {
                result.report.reportFilter.filterFields.filter(function (item) {
                  return item.isParameter && !(0, _fp.isNil)(item.value) && !(0, _fp.isEmpty)(item.value);
                }).forEach(function (item) {
                  item.value = item.value.replace('[Current User]', '[User: ' + _IzendaUiState2.default.currentUser.userName + ']');
                  if (!_IzendaUiState2.default.currentUser.systemAdmin) {
                    item.value = item.value.replace('[Current Tenant]', '[Tenant: ' + _IzendaUiState2.default.currentUser.tenantDisplayID + ']');
                  }
                });
              }

              var isDirty = this.model.checkDirty();
              var isAdvancedMode = this.model.dataSource.reportMode === _Izenda2.default.ADVANCED;
              this.model.updateReportInfo(result.reportKey.key, result.report, isAdvancedMode, keepReportBodyStates);
              this.accessStore.updateReporId(result.report.id);
              this.updateSchedules(result.report.id, isSaveDraft);

              // TODO: should we switch to this.model.setIgnoreCheckChange(true) ?
              this.ignoreCheckChange = true;

              // only do this when saving, not save draft
              if (!isSaveDraft) {
                this.fieldsStore.getFilterData();
                this.alertDetails.set({
                  success: true,
                  message: _Izenda31.default.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED')
                });
                this.canSaveAs = true;
                this.accessStore.model.cleanDraftAccesses();
                this.model.cleanDirty();
              } else {
                !isDirty && this.model.cleanDirty();
              }
              // Reset data source grid dirty form for breaking cycle relationships
              this.dataSourceStore.resetDataSourceGridDirty();
            }

            if (!(0, _fp.isEmpty)(result.messages)) {
              this.model.updateErrorMessages(result.messages);
            } else {
              this.model.resetSaveAs();
              this.scheduleStore.subscribedInstancesStore.model.cleanDirty();
            }

            // Get operator source value after save
            var configFilterField = (0, _fp.get)('reportFilters.configField', this.fieldsStore);
            this.fieldsStore.getOperatorValueSource(configFilterField);

            return {
              success: (0, _fp.isEmpty)(result.messages),
              messages: result.messages,
              reportId: result.reportKey && result.reportKey.key
            };
          }.bind(this)));
        }
        return result;
      }.bind(this));
    }

    /**
     * Update schedules
     * @param {String} report id
     * @param {Boolean} save draft
     */

  }, {
    key: 'updateSchedules',
    value: function updateSchedules(reportId, isSaveDraft) {
      if (!isSaveDraft) {
        this.model.schedules = [];
        var subscribedInstancesStore = this.scheduleStore.subscribedInstancesStore;
        subscribedInstancesStore.updateReportId(reportId);
        subscribedInstancesStore.loadSchedules(true, null);
      }
    }

    /**
     * validate relationships syntax
     * @param {string} section [section of report designer need validate]
     * @return {promise} [promise result from API]
     */

  }, {
    key: 'validateRelationshipSyntax',
    value: function validateRelationshipSyntax(section) {
      var data = this.model.getReportDefinition(section);

      return _Izenda4.default.validateRelationshipSyntax(data);
    }

    /**
     * validate simple mode relationships
     * @param {string} section [section of report designer need validate]
     * @return {promise} [promise result from API]
     */

  }, {
    key: 'validateSimpleModeRelationship',
    value: function validateSimpleModeRelationship(section) {
      var data = this.model.getReportDefinition(section);

      return _Izenda4.default.validateSimpleModeRelationship(data);
    }

    /**
     * Cancel all the changes by getting the origin report key
     * @returns {*|Promise.<TResult>} [promise result from API]
     */

  }, {
    key: 'cancelChanges',
    value: function cancelChanges() {
      var model = this.model;

      model.cleanDirty();
      return _Izenda4.default.cancelReportChanges(model.reportId);
    }

    /**
     *  Handle when change report type, reload list category and sub-category
     * @param {string} value [new report type]
     * @return {Promise} [promise result from API]
     */

  }, {
    key: 'changeType',
    value: function changeType(value) {
      this.model.updateType(value);
      return this.loadCategories(value);
    }

    /**
     *  Handle when change global type in SaveAs popup, reload list category and sub-category
     * @param {string} value
     * @return {Promise} [promise result from API]
     */

  }, {
    key: 'changeSaveInto',
    value: function changeSaveInto(value) {
      this.model.changeGlobalType(value);
      return this.loadCategories(this.model.reportType, null, value);
    }

    /**
     *  Handle when change report's category, reload list sub-category
     * @param {GUI|string} id [new category id]
     * @param {string} name [new category name]
     * @return {promise} [promise result from API]
     */

  }, {
    key: 'changeCategory',
    value: function changeCategory(id, name) {
      this.model.updateCategory(id, name);
      this.model.updateSubCategory();
      return this.loadSubCategories(id);
    }

    /**
     *  Handle when change report's category, reload list sub-category
     * @param {int} type
     * @param {string} tenantId
     * @param {Boolean} isGlobal
     * @return {promise} [promise result from API]
     */

  }, {
    key: 'loadCategories',
    value: function loadCategories(type, tenantId, isGlobal) {
      var model = this.model;
      var reportType = type || model.reportType;
      var checkIsGlobal = (0, _fp.isNil)(isGlobal) ? model.isGlobal : isGlobal;
      var fetchTenantId = (0, _fp.isNil)(tenantId) || !String.isGuidFormat(tenantId) ? _IzendaUiState2.default.getTenantId() : tenantId;

      return _Izenda4.default.loadCategories(reportType, fetchTenantId, checkIsGlobal).then(model.readCategoryData.bind(model));
    }

    /**
     *  Load list of sub category with teamplate and tenant from API
     */

  }, {
    key: 'loadSubCategories',
    value: function loadSubCategories(categoryId) {
      var model = this.model;
      var isValidCategoryId = !(0, _fp.isNil)(categoryId) && String.isGuidFormat(categoryId);

      return isValidCategoryId ? _Izenda4.default.loadSubCategories(categoryId).then(model.readSubCategoryData.bind(model)) : (0, _bluebird.resolve)(model.readSubCategoryData());
    }

    /**
     *  Handle validate report name
     */

  }, {
    key: 'validate',
    value: function validate(reportName) {
      var data = this.model.getGeneralData();
      // Set tenant Id
      var tenantId = _IzendaUiState2.default.getTenantId();
      tenantId && (data.tenantId = tenantId);
      // Assign the new report name for validate
      reportName && (data.name = reportName);

      // clear reportId if in save as mode
      if (this.saveAsMode) {
        data.id = null;
        this.saveAsMode = false;
      }

      return this.model.reportName ? this.validateReportName(data).then((0, _fp.get)('messages')) : (0, _bluebird.resolve)('');
    }

    /**
     *  Set Alert Detail
     */

  }, {
    key: 'setAlertDetails',
    value: function setAlertDetails(data) {
      this.alertDetails.set(data);
    }

    /**
     *  Reset alert
     */

  }, {
    key: 'resetAlertDetails',
    value: function resetAlertDetails() {
      this.alertDetails.reset();
    }

    /**
     * Change global report type
     * @param {int} value
     */

  }, {
    key: 'changeGlobalType',
    value: function changeGlobalType(value) {
      this.model.changeGlobalType(value);
    }

    /**
     * Clear category
     */

  }, {
    key: 'clearCategory',
    value: function clearCategory() {
      this.model.clearCategory();
    }

    /**
     * Clear sub-category
     */

  }, {
    key: 'clearSubCategory',
    value: function clearSubCategory() {
      this.model.clearSubCategory();
    }

    /**
     *  Get bundle from constants file
     */

  }, {
    key: 'getBundle',
    value: function getBundle() {
      return _Izenda2.default.BUNDLE;
    }

    /**
     *  Support add new report part from Toolbar
     */

  }, {
    key: 'addNewReportPart',
    value: function addNewReportPart() {
      this.model.reportFields.reportBody.addReportPart();
    }

    /**
     * compare selected items with data object limitation from db
     * @returns {boolean} result
     */

  }, {
    key: 'checkDataObjectLimitation',
    value: function checkDataObjectLimitation(isValid) {
      if (!(0, _fp.isNil)(isValid) && !isValid) {
        return (0, _bluebird.resolve)({ success: false });
      }
      var model = this.model;
      var defaultSelectedDataSourcesCount = 0;

      // only get reportDataSource in first loading time when we have no data
      var reportDataSource = !(0, _fp.isEmpty)(model.dataSource.dataTree.selectedItems) ? model.dataSource.dataTree.selectedItems : this.model.reportDataSource;
      var selectedDataSourcesCount = !(0, _fp.isNil)(reportDataSource) ? reportDataSource.length : defaultSelectedDataSourcesCount;
      var dataSourceLimitValue = _Izenda14.default.advancedSettings.performance.dataSourceLimitValue;

      if (selectedDataSourcesCount > dataSourceLimitValue) {
        model.updateErrorMessages(_Izenda2.default.BUNDLE.MESSAGE.M11);
        return (0, _bluebird.resolve)({ isDisableReport: true, success: false });
      } else {
        return (0, _bluebird.resolve)({ success: true });
      }
    }

    /**
     * Get warning message for ignored filters
     * @return {string}
     */

  }, {
    key: 'getUnspecifiedFilterWarning',
    value: function getUnspecifiedFilterWarning() {
      var reportFilter = (0, _fp.getOr)({}, 'model.reportFields.reportFilter', this);
      var logic = reportFilter.logic,
          filterFields = reportFilter.filterFields;

      var firstIndex = 0;
      var message = '';
      if (logic && filterFields) {
        var result = (0, _fp.find)(function (item) {
          return item.state !== _Izenda2.default.OBJECT_STATE.DELETE && logic.indexOf(item.position) < firstIndex;
        }, filterFields);
        if (result) {
          message = _Izenda2.default.BUNDLE.MESSAGE.FILTER_WILL_BE_IGNORED;
        }
      }
      return message;
    }

    /**
     * Validate filter logic.
     * @returns {Promise}
     */

  }, {
    key: 'validateFilterSyntax',
    value: function validateFilterSyntax() {
      var reportFilter = (0, _fp.getOr)({}, 'model.reportFields.reportFilter', this);
      var logic = reportFilter.logic,
          filterFields = reportFilter.filterFields;

      var positions = filterFields && (0, _fp.flow)((0, _fp.filter)(function (item) {
        return item.state !== _Izenda2.default.OBJECT_STATE.DELETE;
      }), (0, _fp.map)(function (item) {
        return item.position;
      }))(filterFields);
      return logic ? _Izenda4.default.validateFilterSyntax(logic, positions) : (0, _bluebird.resolve)({ success: true });
    }

    /**
     * Update save mode
     * @param {boolean} value
     */

  }, {
    key: 'setSaveAsMode',
    value: function setSaveAsMode(value) {
      this.saveAsMode = value;
    }

    /**
     * Update isNewReport
     * @param {boolean} value
     */

  }, {
    key: 'setNewReport',
    value: function setNewReport(value) {
      this.isNewReport = value;
    }

    /**
     * Detect schema change
     * @param {string} pageName report designer page
     */

  }, {
    key: 'detectSchemaChange',
    value: function detectSchemaChange(pageName) {
      var data = this.model.getReportDefinition(_Izenda2.default.PAGE_NAME.FIELDS);
      var hasDynamicStore = pageName === _Izenda2.default.PAGE_NAME.DATA_SOURCE ? this.model.dataSource.dataTree.hasDynamicStore(true) : this.model.reportFields.dataTree.hasDynamicStore(true);

      if (hasDynamicStore) {
        return _Izenda6.default.detectSchemaChange(data);
      } else {
        return (0, _bluebird.resolve)({ hasChanged: false });
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.disabled = true;
    }

    /**
     * Load report designer definition by its version.
     * @param {integer} version
     */

  }, {
    key: 'loadReportDesigner',
    value: function loadReportDesigner(version, callback, pageId, isCancelled) {
      var reportDesigner = this.model;
      var reportId = reportDesigner.reportId;
      var subReportFilter = reportDesigner.subReportFilter;
      var inheritMaterReportOption = (0, _fp.omit)(['filters'], subReportFilter);

      !(0, _fp.isNil)(pageId) && (inheritMaterReportOption.page = pageId);

      var loadReport = void 0;

      isCancelled && (inheritMaterReportOption.action = 2);

      if (this.model.draftId) {
        loadReport = _Izenda6.default.getPrintDraftData(this.model.draftId);
      } else {
        loadReport = !(0, _fp.isNil)(version) ? _Izenda6.default.loadReportVersion(reportId, version, inheritMaterReportOption) : _Izenda4.default.loadForEdit(reportId, this.isLoadDraft, false).then(function (data) {
          if (!(0, _fp.isNil)(data.report)) {
            return data.report;
          } else {
            return data;
          }
        });
      }

      return loadReport.then((0, _mobx.action)(function (report) {
        if (!this.isNewReport) {
          if ((0, _fp.isNil)(report.messages)) {
            reportDesigner.read(report);

            callback && callback();

            // set tenantId for system according to report's tenantID
            if (!(0, _fp.isNil)(report.tenantId)) {
              // prevent loading new report when changing tenant
              _IzendaUiState2.default.setTenantId(report.tenantId, true);
            }
          } else {
            this.disableReportDesigner = !(0, _fp.isEmpty)(report.messages[0].detail);
          }
        }

        this.advancedMode = report.advancedMode;
        this.isCompleteLoad = true;
        return report;
      }).bind(this));
    }

    /**
     * Release all subscribers
     */

  }, {
    key: 'dispose',
    value: function dispose() {
      this.disposers && (0, _fp.placeholder)(this.disposers).forEach(function (disposer) {
        disposer();
      });
    }
  }, {
    key: 'savePrintDraft',
    value: function savePrintDraft() {
      return _Izenda6.default.postPrintDraftData(this.model.getReportDefinition());
    }

    /**
     *  Handle validate report
     */

  }, {
    key: 'validateReport',
    value: function validateReport() {
      var data = this.model.getReportDefinition();
      data.ignoreCheckName = true;

      return _Izenda4.default.validate(data);
    }

    /**
     * Validate cycle relationship
     */

  }, {
    key: 'validateCycleRelationships',
    value: function validateCycleRelationships() {
      var data = this.model.getReportRelationship();

      return _Izenda4.default.validateCycleRelationships(data);
    }

    /**
     *  Update Result when detech schema change
     */

  }, {
    key: 'updateResults',
    value: function updateResults() {
      var _this2 = this;

      var data = this.model.getReportDefinition();

      return _Izenda4.default.updateResults(data).then(function (result) {
        // Keep the old report name & preview record
        result.report.name = data.report.name;
        result.report.previewRecord = data.report.previewRecord;

        _this2.model.updateReportInfo(result.reportKey.key, result.report, true);
        result.success && _this2.model.read(result.report);

        return result.report;
      }).then(function (report) {
        if (report.dynamicQuerySourceFields.length) {
          _this2.dataSourceStore.updateDynamicQuerySourceFields();
        }
      });
    }

    /*
     * Reset model
     */

  }, {
    key: 'resetModel',
    value: function resetModel() {
      this.model = new _Izenda10.default();
    }

    /**
     * link between store and uiState
     */

  }, {
    key: 'init',
    value: function init() {
      _IzendaUiState2.default.setCheckDirtyFunction(function () {
        var authorization = new _Izenda20.default();
        var checkPrivileges = authorization.checkPrivileges([_Izenda21.PERMISSION_KEY.ReportsActionsOverwriteExistingReport]);
        if (!checkPrivileges || !this.isNewReport && !this.model.checkSavePermission()) return false;
        return this.model.checkDirty();
      }.bind(this), this.cancelChanges.bind(this));
    }

    /**
     * unlink between store and uiState
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      _IzendaUiState2.default.resetCheckDirtyFunction();
    }

    /**
     * export query excution
     * @param {string} url
     * @param {string} format
     * @param {string} reportId //unused
     * @param {array} filters //unused
     * @param {string} draftId //unused
     * @param {string} queryString //unused
     * @param {object} successCallBack
     * @param {object} failCallBack
     * @returns {Promise}
     */

  }, {
    key: 'exportReport',
    value: function exportReport(url, format, reportId, filters, exportObj, successCallBack, failCallBack) {
      var reportDefinition = this.model.getReportDefinition();

      return _Izenda18.default.export({
        url: url,
        reportKey: reportDefinition.reportKey.key,
        reportDefinition: (0, _stringify2.default)(reportDefinition.report),
        format: format,
        filters: filters,
        draftId: (0, _fp.get)('draftId', exportObj),
        subReportFilters: (0, _fp.get)('subReportFilter', exportObj),
        queryString: (0, _fp.get)('queryString', exportObj),
        tenantId: _IzendaUiState2.default.getTenantId() // for export API.
      }, successCallBack, failCallBack);
    }

    /**
     * Load access default when create new report
     * @returns {Promise}
     */

  }, {
    key: 'loadDefaultAccess',
    value: function loadDefaultAccess() {
      var _this3 = this;

      var reportTemplateType = 0;
      return _Izenda8.default.loadDefaultAccess(reportTemplateType).bind(this).then(function (result) {
        _this3.model.reportAccess.populateAccessDefault(result);
      });
    }

    /**
     * Update Report Category, used when moving report
     */

  }, {
    key: 'updateReportCategory',
    value: function updateReportCategory(category, subCategory) {
      this.model.updateCategory((0, _fp.get)('id', category), (0, _fp.get)('name', category));
      this.model.updateSubCategory((0, _fp.get)('id', subCategory), (0, _fp.get)('name', subCategory));
    }

    /**
     * Validate report by id
     * @param  {Boolean} isViewer
     */

  }, {
    key: 'validateReportId',
    value: function validateReportId(isViewer) {
      var _this4 = this;

      var reportId = this.model.reportId;
      var model = this.model;
      if ((0, _fp.isNil)(reportId)) return (0, _bluebird.resolve)(true);

      return _Izenda4.default.validateReportIdNoCache(reportId, !isViewer).then(function (result) {
        if (!result.success) {
          if (isViewer) {
            var messagesResult = result.messages;
            var msg = !(0, _fp.isNil)(messagesResult) && (0, _fp.isArray)(messagesResult) && messagesResult.length > 0 && !(0, _fp.isEmpty)(messagesResult[0].key) ? messagesResult[0].messages[0] : _Izenda31.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_INVALID_REPORT');

            _this4.alertDetails.set({
              errors: [{
                message: msg
              }],
              success: false,
              key: 'report'
            });
          } else {
            if (!(0, _fp.isNil)(result.messages)) {
              var keys = [_Izenda2.default.ERROR_KEY.calculatedfield, _Izenda2.default.ERROR_KEY.filter, _Izenda2.default.ERROR_KEY.relationship];
              var key = (0, _fp.includes)(result.messages[0].key, keys) ? 'report' : null;
              var errorMessage = result.messages[0].messages[0];

              // If there is any error when load report => allow user to save change
              if (errorMessage) {
                model.markDirty();
              }

              _this4.alertDetails.set({
                errors: (0, _fp.map)(function (message) {
                  return { message: message.messages[0] };
                }, result.messages),
                success: false,
                key: key
              });
            }
          }
        }
        return result.success;
      });
    }
  }, {
    key: 'setAccessPriority',
    value: function setAccessPriority(accessPriority) {
      this.reportAccessPriority = accessPriority;
    }

    /**
     * Update report list uri
     */

  }, {
    key: 'updateReportListURI',
    value: function updateReportListURI(uri) {
      this.reportListURI = uri;
    }

    /**
     * Reset show/hide report header and footer to default.
     */

  }, {
    key: 'resetShowingHeaderFooter',
    value: function resetShowingHeaderFooter() {
      this.isShowingHeaderFooter = !_Izenda14.default.doesHideReportHeaderAndFooter();
    }
  }, {
    key: 'isEnableOverlay',
    get: function get() {
      return this.isNewReport && !this.model.hasSelectedDataSource;
    }
  }, {
    key: 'canSaveGlobalReport',
    get: function get() {
      if (this.model.isGlobal) {
        return (0, _fp.isNil)(_IzendaUiState2.default.tenantId) && _IzendaUiState2.default.currentUser.systemAdmin;
      }
      return true;
    }
  }, {
    key: 'reportId',
    get: function get() {
      return this.model.reportId;
    }
  }, {
    key: 'disableSubCategory',
    get: function get() {
      return (0, _fp.isEmpty)(this.model.categoryId) || (0, _fp.isNil)(this.model.categoryId);
    }
  }, {
    key: 'disableReportType',
    get: function get() {
      return (0, _fp.isEmpty)(this.model.reportFields.reportFilter.filterFields) && this.model.reportFields.reportBody.hasAnyField;
    }
  }, {
    key: 'statusSaveInto',
    get: function get() {
      return {
        visible: (0, _fp.isNil)(_IzendaUiState2.default.tenantId) && !!_IzendaUiState2.default.currentUser.systemAdmin
      };
    }
  }, {
    key: 'showCascadingChangedMessage',
    get: function get() {
      return this.fieldsStore.reportFilters.hasCascadingChanged && this.fieldsStore.reportFilters.showCascadingChangedMessage;
    }
  }, {
    key: 'needUpdateResult',
    get: function get() {
      return (0, _fp.get)('reportFilters.needUpdateResult', this.fieldsStore);
    }
  }, {
    key: 'statusGlobalCheckbox',
    get: function get() {
      var visible = void 0;
      var disabled = true;
      var checked = this.model.isGlobal;
      if (this.isNewReport) {
        visible = false;
        if (_IzendaUiState2.default.currentUser.systemAdmin && (0, _fp.isNil)(_IzendaUiState2.default.tenantId)) {
          visible = true;
          disabled = false;
        }
      } else {
        if (this.model.isGlobal) {
          visible = true;
          if (_IzendaUiState2.default.currentUser.isSystemUser && !_IzendaUiState2.default.currentUser.systemAdmin && !(0, _fp.isNil)(_IzendaUiState2.default.tenantId) || !_IzendaUiState2.default.currentUser.isSystemUser && (0, _fp.isNil)(_IzendaUiState2.default.tenantId)) {
            visible = false;
          }
        } else {
          visible = false;
          if (_IzendaUiState2.default.currentUser.systemAdmin && (0, _fp.isNil)(_IzendaUiState2.default.tenantId)) {
            visible = true;
          }
        }
      }
      return {
        visible: visible,
        disabled: disabled,
        checked: checked
      };
    }
  }, {
    key: 'previewRecord',
    get: function get() {
      return this.model.previewRecord;
    }
  }]);
  return ReportDesignerStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'reportAccessPriority', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'alertDetails', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda12.default();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'saveAsMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'disabled', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'isNewReport', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'disableReportDesigner', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'advancedMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'isCompleteLoad', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'globalReportName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'localReportName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'isShowingHeaderFooter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return !_Izenda14.default.doesHideReportHeaderAndFooter();
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isEnableOverlay', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isEnableOverlay'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'canSaveGlobalReport', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'canSaveGlobalReport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reportId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reportId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'disableSubCategory', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'disableSubCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'disableReportType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'disableReportType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'statusSaveInto', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'statusSaveInto'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showCascadingChangedMessage', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'showCascadingChangedMessage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'needUpdateResult', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'needUpdateResult'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'statusGlobalCheckbox', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'statusGlobalCheckbox'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'previewRecord', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'previewRecord'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'detectReportChange', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'detectReportChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveReport', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveReport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveDraftReport', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveDraftReport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveOrSaveDraftReport', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveOrSaveDraftReport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateSchedules', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateSchedules'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validateRelationshipSyntax', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validateRelationshipSyntax'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validateSimpleModeRelationship', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validateSimpleModeRelationship'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cancelChanges', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cancelChanges'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeSaveInto', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeSaveInto'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadCategories'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadSubCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadSubCategories'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validate', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setAlertDetails', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setAlertDetails'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetAlertDetails', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetAlertDetails'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeGlobalType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeGlobalType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clearCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearSubCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clearSubCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addNewReportPart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addNewReportPart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validateFilterSyntax', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validateFilterSyntax'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSaveAsMode', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setSaveAsMode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setNewReport', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setNewReport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'detectSchemaChange', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'detectSchemaChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'disable', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'disable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadReportDesigner', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadReportDesigner'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validateReport', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validateReport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validateCycleRelationships', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validateCycleRelationships'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateResults', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateResults'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetModel', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetModel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'init', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'init'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'destroy', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'destroy'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validateReportId', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validateReportId'), _class.prototype)), _class);
exports.default = ReportDesignerStore;
module.exports = exports['default'];

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.Access.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var PagingModel = __webpack_require__(98);
  var AccessConstants = __webpack_require__(92);
  var DEFAULT_VALUE = AccessConstants.DEFAULT_VALUE;
  var AccessDetail = __webpack_require__(2002);
  var ObjectStateConstants = __webpack_require__(58);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      every = _require.every,
      some = _require.some,
      map = _require.map,
      forEach = _require.forEach,
      unionBy = _require.unionBy,
      omit = _require.omit,
      remove = _require.remove,
      uniqueId = _require.uniqueId,
      invoke = _require.invoke,
      find = _require.find;

  function Access(data) {
    this.draftAccesses = []; // This keep access list orign and add new access for support search, pagging, sort.
    this.accessRight = [], this.reportAccessRight = [], this.dashboardAccessRight = [];

    var props = {
      pageInfo: new PagingModel(DEFAULT_VALUE.SORT_DIRS, DEFAULT_VALUE.SEARCH_CRITERIA),
      accessList: [], // It's a array of the AccessDetail item
      visibleAccessList: function visibleAccessList() {
        return filter(function (access) {
          return access.state !== 2;
        }, this.accessList);
      },
      hasNoActiveAccess: function hasNoActiveAccess() {
        return isEmpty(this.visibleAccessList);
      },
      hasSelectAllActiveAccess: function hasSelectAllActiveAccess() {
        if (this.hasNoActiveAccess) {
          return false;
        }
        return every('selected', this.visibleAccessList);
      },

      hasActiveInstancesSelected: function hasActiveInstancesSelected() {
        if (this.hasNoActiveAccess) {
          return false;
        }
        return some('selected', this.visibleAccessList);
      },

      hasAsLeastAccessHasRoleSelect: function hasAsLeastAccessHasRoleSelect() {
        return some('hasRolesAccessor', this.visibleAccessList);
      },

      hasAsLeastAccessHasUserSelect: function hasAsLeastAccessHasUserSelect() {
        return some('hasUserAccessor', this.visibleAccessList);
      }
    };

    m.extendObservable(trackable(this), props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} access object
   */
  Access.prototype.populateData = m.action(function (data) {
    this.accessList = map(function (item) {
      return new AccessDetail(item);
    }, data.accessList);
    // update access Id for draft access if need
    forEach(function (access) {
      var item = find({ tempId: access.tempId }, this.draftAccesses);
      if (item) {
        item.id = access.id;
      }
    }.bind(this), data.accessList);

    this.resetDirty();
  });

  /**
   * Populate data
   * @param  {Object} List data of access  detail
   */
  Access.prototype.populateAccessDetails = m.action(function (access) {
    this.accessList = map(function (accessDetail) {
      return new AccessDetail(accessDetail);
    }, access.result);

    this.pageInfo.setTotalRecords(access.total || 0);
    this.resetDirty();
  });

  /**
   * Check report access dirty or not
   * @return {boolean} result of dirty
   */
  Access.prototype.checkDirty = function () {
    var dirtyItems = filter(function (item) {
      return item.checkDirty && item.checkDirty();
    }, this.accessList);

    return !isEmpty(dirtyItems) || this.isDirty;
  };

  /**
   * Add new access
   */
  Access.prototype.addAccess = m.action(function () {
    var access = new AccessDetail();
    this.accessList.splice(0, 0, access);
    this.pageInfo.increaseRecord();
    this.markDirty();
  });

  /**
   * Delete access
   */
  Access.prototype.deleteAccess = m.action(function () {
    var pageInfo = this.pageInfo;
    forEach(function (item) {
      if (item.selected) {
        item.delete();
        pageInfo.descreaseRecord();
      }
    }, this.accessList);
    this.markDirty();
  });

  /**
   * Populate list access right data
   * @param {array} access right data
   */
  Access.prototype.populateAccessRight = function (data) {
    this.accessRight = data;
  };

  /**
   * Merge current list access on grid with origin list return when save draft, add new for load data when search, sort, pagging
   * @return {array} list of access
   */
  Access.prototype.mergeWithReportDraftAccess = m.action(function () {
    var updateAccesses = this.getUpdateAccess();
    this.draftAccesses = unionBy('tempId', updateAccesses, this.draftAccesses);
  });

  /**
   * Merge list access update, insert, delete
   * @return {array} list of access
   */
  Access.prototype.getUpdateAccess = function () {
    return filter(function (access) {
      return access.state !== ObjectStateConstants.NONE;
    }, this.accessList);
  };

  /**
   * Update data for access when save
   * @param  {object}  report data
   */
  Access.prototype.readFromReport = m.action(function (report) {
    ensure(report, 'Report cannot be null or undefined');

    this.accessList = map(function (item) {
      return new AccessDetail(item);
    }, report.accesses);
  });

  /**
   * Populate list access right data
   * @param {array} access right data
   */
  Access.prototype.populateReportAccessRight = function (data) {
    this.reportAccessRight = data;
  };

  /**
   * Populate list access right data
   * @param {array} access right data
   */
  Access.prototype.populateDashboardAccessRight = function (data) {
    this.dashboardAccessRight = data;
  };

  /**
   * [getAccessRightByKey description]
   * @param  {[type]} key [description]
   * @return {[type]}     [description]
   */
  Access.prototype.getAccessRightByKey = function (key) {
    return this[key] || [];
  };

  /**
   * getAccessForSave description
   * @param: {bool}  includeStateProperties
   * @return {array} list of access
   */
  Access.prototype.getAccessForSave = function (includeStateProperties) {
    var accesses = filter(function (access) {
      return access.state !== ObjectStateConstants.DELETE;
    }, this.accessList);

    return map(function (access) {
      return includeStateProperties ? access.buildDataForSaveAccessSettings() : omit('state', access.buildDataForSaveAccessSettings());
    }, accesses);
  };

  /**
   * Remove list accessor when move user/role from selected tree to avaiable tree
   * @param  {array} accessor list accessor (user/role)
   */
  Access.prototype.removeAccessor = function (accessor) {
    forEach(function (access) {
      access.accessors = remove(function (item) {
        return some({ id: item }, accessor);
      }, access.accessors);
      access.accessorNames = remove(function (item) {
        return some({ name: item }, accessor);
      }, access.accessorNames);
    }, this.accessList);
  };

  /**
   * Clean model dirty
   */
  Access.prototype.cleanDirty = m.action(function () {
    this.resetDirty();
    forEach(function (access) {
      access.resetDirty();
    }, this.accessList);
  });

  /**
   * Populates list access default to access when create new report/template/dashboard
   * @param  {array} accessDefaults
   */
  Access.prototype.populateAccessDefault = function (accessDefaults) {
    this.draftAccesses = map(function (item) {
      item.state = ObjectStateConstants.INSERT;
      item.tempId = uniqueId();

      return new AccessDetail(item);
    }, accessDefaults);
  };

  /**
   * Clean draft access after save report
   */
  Access.prototype.cleanDraftAccesses = m.action(function () {
    // clean draft access after save
    this.draftAccesses = [];
    // Clean state of access:
    forEach(function (item) {
      item.state = ObjectStateConstants.NONE;
    }, this.accessList);
  });

  /**
   * Clear all access records have share with equal user when checkbok global report checked.
   */
  Access.prototype.clearAllUserAccessor = m.action(function () {
    forEach(function (item) {
      if (item.assignedType === AccessConstants.ASSIGN_TYPE.USER) {
        item.state = ObjectStateConstants.DELETE;
      }
    }, this.accessList);

    this.markDirty();
  });

  /**
   * Remove all global roles in accessor list
   */
  Access.prototype.removeAllGlobalRolesOnAccessor = m.action('removeAllGlobalRolesOnAccessor', function () {
    forEach(invoke('removeAllGlobalRoles'), this.accessList);
  });

  module.exports = Access;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AlertDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var AlertDetails = (_class = function () {
  (0, _createClass3.default)(AlertDetails, [{
    key: 'alertType',
    get: function get() {
      return this.type || (this.success ? _Izenda.ALERT_TYPES.SUCCESS : _Izenda.ALERT_TYPES.ERROR);
    }
  }]);

  function AlertDetails() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AlertDetails);

    _initDefineProp(this, 'type', _descriptor, this);

    _initDefineProp(this, 'message', _descriptor2, this);

    _initDefineProp(this, 'success', _descriptor3, this);

    _initDefineProp(this, 'errors', _descriptor4, this);

    _initDefineProp(this, 'key', _descriptor5, this);

    _initDefineProp(this, 'showType', _descriptor6, this);

    data && this.set(data);
  }

  /**
   * Set alert details
   * @param {Object} data
   */


  (0, _createClass3.default)(AlertDetails, [{
    key: 'set',
    value: function set() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      data = data || {};
      this.success = data.success;
      this.message = data.message;
      this.errors = data.errors;
      this.key = data.key;
      this.showType = data.showType;
      this.type = data.type;
    }

    /**
     * Reset alert details
     * @param {boolean} resetSavedMessage Indicate reset saved message
     */

  }, {
    key: 'reset',
    value: function reset() {
      var resetSavedMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.set({
        message: null,
        success: true,
        errors: [],
        key: null,
        showType: resetSavedMessage ? _Izenda.SHOW_TYPES.RESET : _Izenda.SHOW_TYPES.BRIEF,
        type: null
      });
    }
  }]);
  return AlertDetails;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'message', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'success', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'errors', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'key', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'showType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda.SHOW_TYPES.BRIEF;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'alertType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'alertType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'set', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'set'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reset', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reset'), _class.prototype)), _class);
exports.default = AlertDetails;
module.exports = exports['default'];

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.SubscribedInstancesStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var ReportFetcher = __webpack_require__(111);
  var DashboardFetcher = __webpack_require__(192);
  var SubscribedInstances = __webpack_require__(2008);
  var ObjectStateConstants = __webpack_require__(58);
  var SubscriptionDetails = __webpack_require__(229);
  var MobxUtils = __webpack_require__(275);
  var SystemVariables = __webpack_require__(2012);
  var systemSettingFetcher = __webpack_require__(75);
  var REPORTING_TYPE = {
    REPORT: 1,
    DASHBOARD: 2
  };
  var TEMPLATE_TYPE = {
    SCHEDULE: 0,
    SUBSCRIPTION: 1
  };
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      map = _require.map,
      cloneDeep = _require.cloneDeep,
      placeholder = _require.placeholder;

  function SubscribedInstancesStore(isDashboard, store) {
    this.fetcher = !isNil(isDashboard) && isDashboard ? DashboardFetcher : ReportFetcher;

    var props = {
      model: new SubscribedInstances(),
      systemVariables: new SystemVariables(),
      reportId: null,
      dashboardId: null,

      activeInstances: function activeInstances() {
        return this.model.loadActiveInstances();
      },

      isSubscriptionMode: function isSubscriptionMode() {
        return this.model.isSubscriptionMode;
      },
      tenantId: function tenantId() {
        return uiState.getTenantId();
      },
      templateType: function templateType() {
        return this.isSubscriptionMode ? TEMPLATE_TYPE.SUBSCRIPTION : TEMPLATE_TYPE.SCHEDULE;
      }
    };

    m.extendObservable(this, props);
    store && this.setObserveSubscriptions(store);
  }

  /**
   * Load system variables
   */
  SubscribedInstancesStore.prototype.fetchSystemVariables = m.action(function () {
    var reportingType = !isNil(this.reportId) ? REPORTING_TYPE.REPORT : REPORTING_TYPE.DASHBOARD;
    this.systemVariables.pageInfo.buildPagingRequest();

    return systemSettingFetcher.loadEmailVariables(reportingType, this.systemVariables.pageInfo).bind(this).then(function (data) {
      return this.systemVariables.populateData(data);
    });
  });

  /**
   * Load Instances
   */
  SubscribedInstancesStore.prototype.updateReportId = m.action(function (reportId) {
    this.model.resetPageModel();
    this.reportId = reportId;
  });

  /**
   * Reset store model
   * @param {String} dashboard id
   */
  SubscribedInstancesStore.prototype.updateDashboardId = m.action(function (dashboardId, isSubscriptionMode) {
    if (this.dashboardId !== dashboardId) {
      this.model = new SubscribedInstances();
      this.model.isSubscriptionMode = isSubscriptionMode;
      this.dashboardId = dashboardId;
    }
  });

  /**
   * Load Instances
   */
  SubscribedInstancesStore.prototype.loadInstances = m.action(function (subscribedInstances) {
    // TODO: tenantId will be update later
    var model = this.model;

    if (subscribedInstances && subscribedInstances.length > 0) {
      model.populateData({
        result: subscribedInstances,
        total: subscribedInstances.length
      });

      return this.fetcher.fetchEmailTemplates(this.templateType).then(m.action(function (emailTemplates) {
        model.populateEmailTemplates(emailTemplates);
        return (0, _bluebird.resolve)(true);
      }));
    }

    return this.loadInstancesWithEmailTemplates();
  });

  /**
   * Load Instances with email templates.
   */
  SubscribedInstancesStore.prototype.loadInstancesWithEmailTemplates = m.action(function () {
    // TODO: tenantId will be update later
    var model = this.model;
    model.pageInfo.buildPagingRequest();

    return (0, _bluebird.join)(this.fetcher.loadSubscription(this.tenantId, model.pageInfo, this.reportId || this.dashboardId, this.isSubscriptionMode), this.fetcher.fetchEmailTemplates(this.templateType), m.action(function (instances, emailTemplates) {
      model.populateData(instances);
      model.populateEmailTemplates(emailTemplates);
      return (0, _bluebird.resolve)(true);
    }));
  });

  /**
   * Save Subscribed Instance(s)
   */
  SubscribedInstancesStore.prototype.saveInstances = function () {
    var subscribedInstances = map(function (item) {
      return item.omitData();
    }, this.model.buildDataForSaving());
    return this.fetcher.updateSubscriptions(subscribedInstances);
  };

  /**
   * Handle when page size change
   */
  SubscribedInstancesStore.prototype.onPageSizeChange = function (pageSize) {
    this.model.pageInfo.setPageSize(pageSize);
    return this.goToPage(1);
  };

  /**
   * Handle go to page
   * @param  {int} pageIndex
   */
  SubscribedInstancesStore.prototype.goToPage = function (pageIndex) {
    var pageInfo = this.model.pageInfo;
    pageInfo.setPageIndex(pageIndex);
    return this.loadInstances();
  };

  /**
   * Search subscription
   * @param  {string} searchProperty
   * @param  {string} searchText
   */
  SubscribedInstancesStore.prototype.search = function (searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);
    return this.goToPage(1);
  };

  /**
   * Change sort orders
   * @param {string} columnKey
   * @param {object} sortDir
   */
  SubscribedInstancesStore.prototype.onSortChange = function (columnKey, sortDir) {
    this.model.pageInfo.setColSortDirs(columnKey, sortDir);
    return this.loadInstances();
  };

  /**
   * Sort system variables
   * @param  {String} columnKey
   * @param  {String} sortDir
   */
  SubscribedInstancesStore.prototype.sortSystemVariables = m.action(function (columnKey, sortDir) {
    this.systemVariables.pageInfo.setColSortDirs(columnKey, sortDir);
    return this.fetchSystemVariables();
  });

  /**
   * Handle when page size of system variables change
   * @param  {Number} pageSize
   */
  SubscribedInstancesStore.prototype.onSystemVariablesPageSizeChange = m.action(function (pageSize) {
    this.systemVariables.pageInfo.setPageSize(pageSize);
    return this.fetchSystemVariables();
  });

  /**
   * Handle go to page of system variables.
   * @param  {Number} pageIndex
   */
  SubscribedInstancesStore.prototype.goToSystemVariablesPage = m.action(function (pageIndex) {
    this.model.systemVariables.setPageIndex(pageIndex);
    return this.fetchSystemVariables();
  });

  /**
   * Update filter criteria information.
   * @param {String} searchProperty
   * @param {String} searchText
   */
  SubscribedInstancesStore.prototype.updateSearchCriteria = function (searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);
  };

  /**
   * Copy a subscribed instances by its id.
   * @param {String} id
   */
  SubscribedInstancesStore.prototype.copySubscribedInstance = function (id) {
    this.model.copySubscribedInstance(id);
  };

  /**
   * Delete selected instance.
   * @param {Array} ids
   */
  SubscribedInstancesStore.prototype.removeSubscribedInstances = function (ids) {
    this.model.removeSubscribedInstances(ids);
  };
  /**
   * Load email templates
   */
  SubscribedInstancesStore.prototype.fetchEmailTemplates = function () {
    return this.fetcher.fetchEmailTemplates(this.templateType).then(function (result) {
      return this.model.populateEmailTemplates(result);
    }.bind(this));
  };

  /**
   * Validate subscription instance.
   * @param {Object} instance
   * @param {Array} commonFilterFields
   * @returns {Promise}
   */
  SubscribedInstancesStore.prototype.validateSubscription = function (instance, commonFilterFields) {
    var clonedInstance = new SubscriptionDetails(cloneDeep(instance));
    clonedInstance.buildRecurrencePatternSetting();
    clonedInstance.subscriptionFilterFields = instance.subscriptionFilterFields && cloneDeep(MobxUtils.toJS(instance.subscriptionFilterFields));
    clonedInstance.subscriptionCommonFilterFields = instance.subscriptionCommonFilterFields && cloneDeep(MobxUtils.toJS(instance.subscriptionCommonFilterFields));

    if (clonedInstance.state === ObjectStateConstants.INSERT) {
      clonedInstance.id = null;
    }

    clonedInstance.dashboardId = this.dashboardId;

    return this.fetcher.validateSubscription(clonedInstance.omitData(), commonFilterFields);
  };

  /**
   * Set observe subscriptions.
   */
  SubscribedInstancesStore.prototype.setObserveSubscriptions = function (store) {
    this.disposeSubscriptions = m.observe(store.model.dashboardDetail.dashboard, 'id', function () {
      this.model.subscribedInstances = map(function (item) {
        return new SubscriptionDetails(item);
      }, store.model.dashboardDetail.dashboard.subscriptions);
    }.bind(this));
  };

  /**
   * Dispose observe subscriptions.
   */
  SubscribedInstancesStore.prototype.disposeObserveSubscriptions = function () {
    this.disposeSubscriptions();
  };

  /**
   * Load Schedules
   * @param {Boolean} isNew
   * @param {Object} subscriptions
   * @returns {Object} Promise
   */
  SubscribedInstancesStore.prototype.loadSchedules = function (isNew, subscriptions) {
    var model = this.model;
    model.pageInfo.buildPagingRequest();

    return (0, _bluebird.join)(this.fetcher.loadSchedules(this.reportId, subscriptions, model.pageInfo), this.fetcher.fetchEmailTemplates(this.templateType), function (instances, emailTemplates) {
      m.transaction(function () {
        model.populateData(instances);
        model.updateScheduleInstances(isNew);
        model.populateEmailTemplates(emailTemplates);
      });
      return (0, _bluebird.resolve)(true);
    });
  };

  /**
   * Search schedules
   * @param  {string} searchProperty
   * @param  {string} searchText
   */
  SubscribedInstancesStore.prototype.searchSchedules = function (searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);
    var pageInfo = this.model.pageInfo;
    pageInfo.setPageIndex(1);

    var schedules = placeholder(this.model.scheduleInstances).chain().map(function (item) {
      return new SubscriptionDetails(item);
    }).filter(function (item) {
      return item.state !== ObjectStateConstants.NONE;
    }).forEach(function (i) {
      if (i.state === ObjectStateConstants.INSERT) {
        i.id = null;
      }
    }).value();

    return this.loadSchedules(false, schedules);
  };

  /**
   * Clean Subcription model
   */
  SubscribedInstancesStore.prototype.cleanSubscription = function () {
    this.model = new SubscribedInstances();
  };

  module.exports = SubscribedInstancesStore;
}();

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda = __webpack_require__(424);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(49);

var _Izenda4 = __webpack_require__(33);

var _Izenda5 = __webpack_require__(175);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(34);

var _Izenda8 = __webpack_require__(39);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(69);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(35);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(16);

var _Izenda15 = __webpack_require__(176);

var _Izenda16 = __webpack_require__(115);

var _Izenda17 = __webpack_require__(64);

var _Izenda18 = __webpack_require__(171);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(41);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(88);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(80);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// for null value >> treat it as zero
var DEFAULT_NUMERIC_VALUE = 0;
var TICK_SPACE = 30;

var isChartType = _Izenda6.default.isReportPartStyle(_Izenda14.REPORT_PART_TYPE.Chart);
var getPointName = _Izenda11.default.getPointName;
var getPointValue = _Izenda11.default.getPointValue;
var getAxisType = _Izenda11.default.getAxisType;

var getCellColor = _Izenda25.default.getCellColor;
var getName = _Izenda25.default.getName;
var DefaultChartOptionsBuilder = (_dec = (0, _Izenda3.exportClass)('DefaultChartOptionsBuilder'), _dec(_class = function (_HighchartOptionsBuil) {
  (0, _inherits3.default)(DefaultChartOptionsBuilder, _HighchartOptionsBuil);

  function DefaultChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, DefaultChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = DefaultChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(DefaultChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @returns {Object}
   */


  (0, _createClass3.default)(DefaultChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var _this2 = this;

      var _constants$ContainerN = _Izenda9.default.ContainerName,
          LABELS = _constants$ContainerN.LABELS,
          VALUES = _constants$ContainerN.VALUES,
          SEPARATORS = _constants$ContainerN.SEPARATORS;

      var xAxisContainerName = (0, _fp.getOr)(LABELS, 'X_AXIS_CONTAINER_NAME', userOptions);
      var yAxisContainerName = (0, _fp.getOr)(VALUES, 'Y_AXIS_CONTAINER_NAME', userOptions);
      var separatorContainerName = (0, _fp.getOr)(SEPARATORS, 'SEPARATOR_CONTAINER_NAME', userOptions);

      var dataStructure = dataParser.dataStructure || {};
      var yAxisContainerFields = dataStructure[yAxisContainerName];
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};

      var xAxisField = (0, _fp.nth)(dataParser.expandedLevel, dataStructure[xAxisContainerName]);

      function axisTickPositions(axisField, axisOptions, interval) {
        // Only apply tick Position for Date Time format and linear type
        var fieldDataType = (0, _fp.get)('reportPartElm.fieldDataType', axisField);
        var DATE_TIME = _Izenda14.DATA_TYPES.DATE_TIME,
            TIME = _Izenda14.DATA_TYPES.TIME;

        if ((0, _fp.isEmpty)(xAxisType.categories) && (fieldDataType === DATE_TIME || fieldDataType === TIME) && interval && this.dataMax !== null && this.dataMin !== null) {
          var positions = [];
          var fieldFormatData = xAxisField.reportPartElm.fieldFormatData;
          var cloneInterval = interval;
          var intervalKey = (0, _fp.getOr)('s', 'INTERVAL_VALUE', _Izenda15.DATE_TIME_FORMAT[fieldFormatData]);
          var tickValue = (0, _moment2.default)(axisOptions.min || this.dataMin);
          var maxValue = (0, _moment2.default)(this.dataMax);

          // Calculate Tick Number
          // If actual tick number > maxTickNumber use maxTickNumber and
          var containerWidth = $izenda(chartContainer).width();
          var maxTickNumber = containerWidth / TICK_SPACE;
          var momentTickValue = (0, _moment2.default)(new Date(0)).add(cloneInterval, intervalKey);
          var eachTickValue = Date.parse(momentTickValue);
          var actualTicks = (Date.parse(maxValue) - Date.parse(tickValue)) / eachTickValue;

          if (actualTicks > maxTickNumber) {
            cloneInterval = (actualTicks * cloneInterval / maxTickNumber).toFixed(0);
          }

          while (tickValue <= maxValue) {
            positions.push(tickValue.valueOf());

            tickValue.add(cloneInterval, intervalKey);
          }

          return positions;
        }

        return null;
      }

      /**
       * Get YAxis Option by metrics
       */
      var getYAxisOptionByMetrics = function getYAxisOptionByMetrics(series) {
        var option = void 0;
        var commonXYAxis = (0, _fp.get)('commonXYAxis', userOptions);
        var length = getNumberFieldInMetricsContainer(series);
        if (length > 1) {
          option = (0, _fp.get)('metricAllOption', commonXYAxis);
        } else {
          var yAxisField = (0, _fp.get)('yAxisField', (0, _fp.nth)(0, series));
          option = _this2.getAxisFieldValue(yAxisField, 'axisOption', izendaSeriesConfig);
        }
        return (0, _fp.merge)(option, (0, _fp.get)('yAxis', commonXYAxis));
      };

      /**
       * Get static threshold by metrics
       */
      var getYStaticThresholdOptionByMetrics = function getYStaticThresholdOptionByMetrics(series) {
        var length = getNumberFieldInMetricsContainer(series);

        if (length > 1) {
          // if length > 1 ==> user selected All metric
          var staticThresholdLineMetric = [];
          (0, _fp.each)(function (serie) {
            var yAxisField = (0, _fp.get)('yAxisField', serie);
            var thresholds = _this2.getAxisFieldValue(yAxisField, 'threshold', izendaSeriesConfig);
            if ((0, _fp.size)(thresholds) > 0) {
              staticThresholdLineMetric.push.apply(staticThresholdLineMetric, (0, _toConsumableArray3.default)(thresholds));
            }
          }, series);
          return staticThresholdLineMetric;
        } else {
          // user selected a metric
          var yAxisField = (0, _fp.get)('yAxisField', (0, _fp.nth)(0, series));
          var thresholds = _this2.getAxisFieldValue(yAxisField, 'threshold', izendaSeriesConfig);
          return thresholds;
        }
      };

      /**
       * Get number of metrics
       */
      var getNumberFieldInMetricsContainer = function getNumberFieldInMetricsContainer(series) {
        return (0, _fp.flow)((0, _fp.map)((0, _fp.get)('yAxisField.fieldNameAlias')), _fp.uniq, _fp.size)(series);
      };

      /**
       * Get static threshold option
       */
      var getXThresholdOption = function getXThresholdOption() {
        return _this2.getAxisFieldValue(xAxisField, 'threshold', izendaSeriesConfig);
      };

      var getValueFromSeriesConfig = this.getValueFromSeriesConfig;
      var xAxisOptions = this.getXAxisOption(xAxisField, userOptions);
      var xAxisFieldConfig = getValueFromSeriesConfig(xAxisField, izendaSeriesConfig);
      var xAxisInfo = dataParser.getDataByField(xAxisField, null, xAxisFieldConfig);
      var xAxisName = xAxisInfo.name;

      var xAxisType = getAxisType(xAxisField, xAxisInfo.data, xAxisOptions);
      var isLinearAxis = (0, _fp.getOr)(false, 'reportPartElm.isNumericPreviewData', xAxisField);
      var xAxisData = xAxisType.categories;
      var xAxisOption = this.getAxisFieldValue(xAxisField, 'axisOption', izendaSeriesConfig);
      var tickInterval = (0, _fp.get)('izCategory', xAxisOption) ? (0, _fp.getOr)(null, 'tickCategoryInterval', xAxisOption) : (0, _fp.get)('tickInterval', xAxisOption);
      var chartContainer = userOptions.commonActions.chartContainer;

      // important - use defaul-value (zero) for all point which dont have data
      var series = !(0, _fp.isNil)(xAxisField) && !(0, _fp.isNil)(yAxisContainerFields) ? this.getSeries(dataParser, userOptions, xAxisField, (0, _fp.uniq)(xAxisInfo.data), yAxisContainerFields) : [];

      var yAxisOptions = series && getYAxisOptionByMetrics(series);
      var separatorField = (0, _fp.nth)(dataParser.expandedLevel, dataStructure[separatorContainerName]);
      var nullIndex = (0, _fp.findIndex)(function (ele) {
        return ele === null;
      }, xAxisData);

      nullIndex > -1 && xAxisData.splice(nullIndex, 1, 'null');

      var sortLinear = (0, _fp.get)('sort.valueXAxisForLinear', userOptions);

      var needReverse = sortLinear === _Izenda17.SORT_ORDERS.DESC.value ? userOptions.chart.type !== 'bar' : undefined;
      var needReverseSeries = sortLinear === _Izenda17.SORT_ORDERS.DESC.value && (userOptions.chart.type === 'column' || userOptions.chart.type === 'bar');
      needReverseSeries && (series = (0, _fp.reverse)(series));

      var chartType = (0, _fp.get)('chart.type', userOptions);
      this.configureRegression(izendaSeriesConfig, series);

      var chartOptions = {
        series: series,
        xAxis: {
          axisName: xAxisName,
          categories: xAxisData,
          type: xAxisType.type,
          labels: {
            formatter: _Izenda11.default.getFormattedLabelAxis,
            useHTML: true
          },
          plotLines: getXThresholdOption(),
          tickPositioner: function tickPositioner() {
            return axisTickPositions.bind(this)(xAxisField, xAxisOptions, tickInterval);
          },

          tickInterval: tickInterval,
          // Use this "reversed" option when xAxis type = Linear (field type is numeric/ money/ datetime/ time)
          // When chart type = Bar, it's actually a Column type + Inverted
          reversed: needReverse
        },

        yAxis: {
          gridLineColor: 'transparent',
          labels: {
            formatter: _Izenda11.default.getFormattedLabelAxis,
            useHTML: true
          },
          plotLines: getYStaticThresholdOptionByMetrics(series)
        },
        legend: {
          labelFormatter: function labelFormatter() {
            if (isChartType((0, _fp.upperFirst)(chartType), _Izenda4.CHART_TYPE.Pie, _Izenda4.CHART_TYPE.Funnel)) {
              var separatorConfig = getValueFromSeriesConfig(separatorField, izendaSeriesConfig);
              var _xAxisFieldConfig = getValueFromSeriesConfig(xAxisField, izendaSeriesConfig);

              var fieldElement = _xAxisFieldConfig.fieldElement,
                  fieldDataType = _xAxisFieldConfig.fieldDataType;

              var record = (0, _fp.get)('record', this);
              var columnName = (0, _fp.isNil)(separatorConfig) ? (0, _fp.get)('columnName', xAxisField) : (0, _fp.get)('series.options.nameField.columnName', this);

              var fieldValues = _Izenda13.default.getFieldValue(columnName, record);
              var valueStringFormated = _Izenda11.default.getFormatedValueByStringFormat(fieldElement, fieldValues.originalValue, fieldDataType);

              if (!(0, _fp.isNil)(valueStringFormated)) {
                fieldValues.value = valueStringFormated;
              }
              return dataParser.getFormatData(fieldValues, _xAxisFieldConfig);
            }
            return this.name;
          }
        }
      };

      chartOptions.yAxis = (0, _fp.merge)(chartOptions.yAxis, yAxisOptions || {});
      chartOptions.xAxis = (0, _fp.merge)(chartOptions.xAxis, xAxisOptions || {});

      var removedAxisOption = {
        minorTickLength: 0,
        tickLength: 0,
        title: {
          text: null
        },
        labels: {
          enabled: false
        }
      };

      if (!(0, _fp.get)('izendaHiddenAllAxis', userOptions.izendaOptions)) {
        _Izenda11.default.setDefaultAxisName(chartOptions, dataParser);
      } else {
        chartOptions.yAxis = (0, _fp.merge)(chartOptions.yAxis, removedAxisOption);
        chartOptions.xAxis = (0, _fp.merge)(chartOptions.xAxis, removedAxisOption);
      }

      // add sub-report to x-axis
      !(userOptions.izMultiLevel && isChartType(this.chartOptions.chartType, _Izenda4.CHART_TYPE.TreeMap)) && _Izenda11.default.addPointActionLink(true, userOptions, chartOptions.xAxis.labels, xAxisName, (0, _fp.get)(xAxisName, izendaSeriesConfig));

      // Disable colorByPoint
      if (userOptions.izDisableMultiColor) {
        var plotOptions = {
          series: {
            colorByPoint: false
          }
        };

        chartOptions.plotOptions = (0, _fp.merge)(chartOptions.plotOptions, plotOptions);
      }

      return chartOptions;
    }

    /**
     * Get value from izendaSeriesConfig
     * Because DB column name may have dot character so we have to enlosed by '[]'
     * @field {*} axisField: X or X axisField
     * @izendaSeriesConfig:  all configuration of series
     */

  }, {
    key: 'getValueFromSeriesConfig',
    value: function getValueFromSeriesConfig(field, izendaSeriesConfig) {
      var fieldName = getName(field);
      return (0, _fp.get)('[\'' + fieldName + '\']', izendaSeriesConfig);
    }

    /**
     * Get X Axis options
     * @param {*} axisField: X or X axisField
     * @param {*} userOptions: user option build from property panel
     */

  }, {
    key: 'getXAxisOption',
    value: function getXAxisOption(xAxisField, userOptions) {
      var commonXYAxis = (0, _fp.get)('commonXYAxis.xAxis', userOptions);
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
      var options = this.getAxisFieldValue(xAxisField, 'axisOption', izendaSeriesConfig);
      var xAxisOption = (0, _fp.merge)(options, commonXYAxis);
      // Clear tickInterval if this field is datetime type
      if ((0, _fp.get)('reportPartElm.fieldDataType', xAxisField) === _Izenda14.DATA_TYPES.DATE_TIME && !xAxisOption.izCategory) {
        xAxisOption.tickInterval = null;
      }

      // Set tickInterval = tickCategoryInterval if izCategory = true
      if (xAxisOption.izCategory) {
        xAxisOption.tickInterval = xAxisOption.tickCategoryInterval;
      }

      return xAxisOption;
    }

    /**
     * Get X or Y Axis Field Value
     * Because DB column name may have dot character so we have to enlosed by '[]'
     * @param {*} axisField: X or X axisField
     * @param {*} propName: property name of axisField
     * @izendaSeriesConfig:  all configuration of series
     */

  }, {
    key: 'getAxisFieldValue',
    value: function getAxisFieldValue(axisField, propName, izendaSeriesConfig) {
      var izendaSeriesConfigValue = this.getValueFromSeriesConfig(axisField, izendaSeriesConfig);
      return (0, _fp.get)('[\'' + propName + '\']', izendaSeriesConfigValue);
    }

    /**
     * Build series
     * @param {*} dataParser: The data was formated for hightchart
     * @param {*} userOptions: The options user are able to select
     * @param {*} xAxisField: The field of X container
     * @param {*} xAxisData: The data of X field
     * @param {*} yAxisFields: The field of Y container
     */

  }, {
    key: 'getSeries',
    value: function getSeries(dataParser, userOptions, xAxisField, xAxisData, yAxisFields) {
      var _this3 = this;

      var series = [];
      var SEPARATORS = _Izenda9.default.ContainerName.SEPARATORS;

      var separatorContainerName = (0, _fp.getOr)(SEPARATORS, 'SEPARATOR_CONTAINER_NAME', userOptions);
      var dataStructure = dataParser.dataStructure || {};
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
      var xAxisInfo = dataParser.getDataByField(xAxisField);
      var xAxisOptions = this.getXAxisOption(xAxisField, userOptions);
      var xAxisType = getAxisType(xAxisField, xAxisInfo.data, xAxisOptions);
      var xAxisName = xAxisInfo.name;
      var xAxisConfig = izendaSeriesConfig[xAxisName];
      // 1. parse data
      if (dataParser.hasSeparator(separatorContainerName)) {
        var separatorField = (0, _fp.first)(dataStructure[separatorContainerName]);

        var groupNames = [];
        var groupData = dataParser.groupData(separatorField, groupNames);

        // each data for each group
        (0, _fp.each)(function (groupKey) {
          var separatorSeriesOption = _this3.getValueFromSeriesConfig(separatorField, izendaSeriesConfig);

          var record = (0, _fp.head)(groupData[groupKey]);

          var _ReportPartUtils$getF = _Izenda13.default.getFieldValue(separatorField.columnName, record),
              originalValue = _ReportPartUtils$getF.originalValue;

          var reportPartElm = separatorField.reportPartElm,
              fieldDataType = separatorField.fieldDataType;

          var formatedValue = _Izenda11.default.getFormatedValueByStringFormat(reportPartElm, groupKey, fieldDataType);

          var fieldValue = {
            value: (0, _fp.isNil)(formatedValue) ? groupKey : formatedValue,
            originalValue: originalValue
          };

          series = (0, _fp.concat)(series, getSeriesData(xAxisField, groupData[groupKey], {
            field: separatorField,
            rawValue: groupKey === _Izenda7.UNDEFINED_VALUE ? '' : groupKey,
            value: dataParser.getFormatData(fieldValue, separatorSeriesOption, {
              element: {
                columnName: separatorField.columnName,
                reportPartElm: separatorSeriesOption.fieldElement
              },
              record: record
            }),
            groupNamesSize: groupNames.length
          }, !(0, _fp.isNil)(xAxisType.categories) ? xAxisData : null, yAxisFields, 0));
        }, groupNames);
      } else {
        series = (0, _fp.concat)(series, getSeriesData(xAxisField, dataParser.records, null, null, yAxisFields));
      }

      // 2. set config to series
      addConfig(series);

      // 3. return
      return series;

      function addConfig(series) {
        // set color to serie (based on separator)
        var serieColor = void 0;

        var serieData = void 0;
        (0, _fp.each)(parseSerieData, series);

        function parseSerieData(serie) {
          var serieData = serie.data;
          var tempData = void 0;

          // For Category Type : remove x value
          if (xAxisType.categories) {
            tempData = removeXValue(serieData);
          } else {
            switch (xAxisType.type) {
              case 'linear':
                parseData(serieData);
                tempData = sortData(serieData);
                break;

              case 'datetime':
                parseData(serieData, function (point) {
                  var fieldDataType = (0, _fp.get)('fieldDataType', xAxisConfig);
                  var pattern = fieldDataType === _Izenda14.DATA_TYPES.TIME ? (0, _fp.getOr)(_Izenda16.TIME_FORMAT, 'fieldFormatData', xAxisConfig) : (0, _fp.get)('fieldFormatData', xAxisConfig);

                  point.xRawData = point.x;
                  point.x = (0, _Izenda23.default)(pattern, point.x, false);
                });

                tempData = sortData(serieData);
                break;
            }
          }
          // update data
          serie.data = tempData;

          function sortData(serieData) {
            var x = void 0;
            return (0, _fp.flow)((0, _fp.filter)(function (item) {
              x = item.x;
              return (0, _fp.isDate)(x) ? !!x.getTime() : !!x;
            }), (0, _fp.sortBy)('x'))(serieData);
          }

          function parseData(serieData, updateData) {
            return (0, _fp.forEach)(updateData, serieData);
          }

          function removeXValue(serieData) {
            parseData(serieData, function (point) {
              point.xRawData = point.x;
              delete point.x;
            });
            return serieData;
          }
        }
      }

      function getSeriesData(xAxisField, source, groupInfo, basedXAxisData, yAxisFields, defaultValue) {
        var seriesObj = {};
        var xaxisColumnName = xAxisField.columName;
        var xaxisData = void 0;

        initData(seriesObj, source, yAxisFields);

        // loop records
        (0, _fp.each)(function (record) {
          updateData(seriesObj, _Izenda13.default.getOriginalValue(xAxisField, record), record, yAxisFields, xAxisField);
        }, source);

        return (0, _fp.map)(function (serie) {
          basedXAxisData && buildData(basedXAxisData, serie, DEFAULT_NUMERIC_VALUE);

          return serie;
        }, seriesObj);

        function buildData(basedXAxisData, serie, defaultVal) {
          var basedValues = [];
          var values = serie.data;
          var labels = (0, _fp.map)((0, _fp.get)('x'), serie.data);
          var foundIndex = void 0;
          var item = void 0;

          (0, _fp.each)(function (xAxisData) {
            foundIndex = labels.indexOf(xAxisData);

            if (foundIndex > -1) {
              item = values[foundIndex];
            } else {
              item = {
                x: xAxisData,
                y: defaultVal,
                isDefaultValue: true
              };
            }

            basedValues.push(item);
          }, basedXAxisData);

          serie.data = basedValues;
        }

        function getSeriePartNames(field) {
          var fieldNamesParts = _Izenda25.default.getPartNames(field);
          var fieldName = getName(field);

          return {
            name: (0, _fp.last)(fieldNamesParts),
            data: (0, _fp.size)(fieldNamesParts) > 1 ? (0, _fp.head)(fieldNamesParts) : null
          };
        }

        function updateData(source, xaxisData, record, yAxisFields, xAxisField) {
          var yAxisData = {};
          var yVal = void 0;
          var point = void 0;

          // loop by value-fields
          (0, _fp.each)(function (field) {
            getYValue(field);
          }, yAxisFields);

          for (var yAxisName in yAxisData) {
            var yRawData = yAxisData[yAxisName];
            var isValidValue = !(0, _fp.isNil)(yRawData) && yRawData !== '';
            yVal = isValidValue ? yRawData : DEFAULT_NUMERIC_VALUE;

            point = {
              x: xaxisData,
              record: record
            };

            if (!isValidValue) {
              point.yRawData = yRawData;
            }

            if ((0, _fp.isObject)(yVal)) {
              point = (0, _fp.assignIn)(point, yVal);
            } else {
              point.y = yVal;
            }

            source[yAxisName].data.push(point);
          }

          function getYValue(field, hasData) {
            var partNames = getSeriePartNames(field);

            var value = _Izenda13.default.getOriginalValue(field, record);
            var partValue = void 0;

            if ((0, _fp.isNil)(partNames.data)) {
              yAxisData[partNames.name] = value;
            } else {
              partValue = {};
              partValue[partNames.data] = value;

              if ((0, _fp.has)(partNames.name, yAxisData)) {
                yAxisData[partNames.name] = (0, _fp.assignIn)(yAxisData[partNames.name], partValue);
              } else {
                yAxisData[partNames.name] = partValue;
              }
            }
          }
        }

        function initData(source, records, yAxisFields) {
          var partNames = void 0;
          var groupName = (0, _fp.get)('rawValue', groupInfo);
          var numMetric = (0, _fp.size)(yAxisFields);

          (0, _fp.each)(function (field) {
            partNames = getSeriePartNames(field);

            source[partNames.name] = (0, _fp.assignIn)({
              separatorField: (0, _fp.get)('field', groupInfo),
              separatorValue: groupName,
              name: (0, _fp.toString)(getSerieName(groupInfo || {}, partNames.name)),
              xAxisField: xAxisField,
              yAxisField: field,
              data: [],
              dataLabels: {
                formatter: function getDataLabelFormat() {
                  if (!(0, _fp.isNil)(this.y)) {

                    var isDefaultValue = (0, _fp.get)('options.isDefaultValue', this.point);
                    var valueLabel = (0, _fp.get)('data', _Izenda11.default.getFormattedDataByPoint('y', this.point, true));
                    return !isDefaultValue ? _Izenda11.default.showText(valueLabel) : null;
                  }

                  if (!(0, _fp.isNil)(this.value)) {
                    return (0, _fp.get)('data', _Izenda11.default.getFormattedDataByPoint('value', this.point, true));
                  }

                  return '';
                }
              }
            }, (0, _fp.get)('chartOptions', izendaSeriesConfig[partNames.name]));
          }, yAxisFields);

          function getSerieName(groupInfo, yAxisFieldName) {
            var groupName = (0, _fp.isNil)(groupInfo.rawValue) && (0, _fp.isNil)(groupInfo.value) ? String.commonStringValue(groupInfo.rawValue, _Izenda21.default.advancedSettings.other.convertNullToEmptyStringValue) : (0, _fp.get)('value', groupInfo);
            var isShowGroupName = groupInfo.groupNamesSize >= 1;

            if (numMetric > 1) {
              return (!(0, _fp.isNil)(groupName) && isShowGroupName ? groupName + ' / ' : '') + yAxisFieldName;
            } else {
              return isShowGroupName ? groupName : yAxisFieldName;
            }
          }
        }
      }
    }

    /**
     * Configure regression line for series
     * @param {Array<Object>} izendaSeriesConfig
     * @param {Array<Object>} series
     */

  }, {
    key: 'configureRegression',
    value: function configureRegression(izendaSeriesConfig, series) {
      if ((0, _fp.isEmpty)(izendaSeriesConfig) || (0, _fp.isEmpty)(series)) return;

      (0, _fp.forEach)(function (serie) {
        var serieConfig = izendaSeriesConfig[serie.name];
        if (!serieConfig && !(0, _fp.isNil)(serie.nameField)) {
          var fieldNameAlias = serie.nameField.fieldNameAlias;
          var serieConfigKey = (0, _fp.find)(function (key) {
            return key === fieldNameAlias;
          }, (0, _fp.keys)(izendaSeriesConfig));
          serieConfig = izendaSeriesConfig[serieConfigKey];
        }
        var regression = (0, _fp.get)('regression', serieConfig);
        var regressionBySerie = {
          regression: !!regression,
          regressionSettings: regression
        };

        (0, _assign2.default)(serie, regressionBySerie);
      }, series);
    }
  }]);
  return DefaultChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = DefaultChartOptionsBuilder;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthorizationStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = __webpack_require__(5);
  var fetcher = __webpack_require__(2122);
  var reportDesignerDataFetcher = __webpack_require__(90);
  var PermissionDetail = __webpack_require__(206);

  function AuthorizationStore() {
    var props = {
      model: new PermissionDetail()
    };

    m.extendObservable(this, props);
  }

  /**
   * Load all permissions     
   * @returns {promise}
   */
  AuthorizationStore.prototype.loadAllPermissions = function () {
    return fetcher.loadAllPermissions();
  };

  /**
   * Load access priority of dashboard/report.
   * @param  {String} id
   */
  AuthorizationStore.prototype.loadAccessPriority = function (id) {
    return reportDesignerDataFetcher.accessPriority(id);
  };

  module.exports = AuthorizationStore;
}();

/***/ }),
/* 330 */,
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="SettingsLevel.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var DropDown = __webpack_require__(29);
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);
  var settingConstant = __webpack_require__(167);
  var uiState = __webpack_require__(15);

  var SettingsLevel = React.createClass({
    displayName: 'SettingsLevel',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },
    componentDidMount: function componentDidMount() {
      this.props.store.loadTenants();
    },

    /**
     *
     * @returns {type}
     */
    render: function render() {
      var store = this.props.store;
      var localization = this.props.localization;
      var classes = classnames({
        'izenda-SettingLevel': true,
        'disabled-elm': store.settingLevel.disableSystemSetting
      });

      return !uiState.hideSystemLevel ? React.createElement(
        'section',
        { className: classes },
        React.createElement(
          'div',
          { className: 'form-inline' },
          this.createRoleList(localization),
          this.renderTenants(localization)
        )
      ) : null;
    },

    /**
     * Build setting level element
     * @returns {Object}
     */
    createRoleList: function createRoleList(localization) {
      var store = this.props.store;
      var classes = classnames({
        'form-group u_noMarginAll u_marginRight u_inlineBlock': true,
        'disabled-elm': store.settingLevel.disableRoleDropdown
      });

      return React.createElement(
        'div',
        { className: 'form-group u_noMarginAll u_marginRight u_inlineBlock' },
        React.createElement(
          'label',
          { className: 'u_marginRight' },
          localization.getText("SETTING_LEVEL_LABEL_SETTING_LEVEL")
        ),
        React.createElement(
          'div',
          { className: 'u_inlineBlock' },
          React.createElement(DropDown, {
            options: store.settingLevel.availableLevels,
            value: store.settingLevel.selectedLevel(),
            labelField: 'label',
            valueField: 'value',
            onChange: this.changeSystemMode,
            disabled: store.settingLevel.disableRoleDropdown
          })
        )
      );
    },

    /**
     * Build list tenant element
     * @returns {Object}
     */
    renderTenants: function renderTenants(localization) {
      var settingLevel = this.props.store.settingLevel;
      var disabled = this.props.store.settingLevel.disableSystemSetting;
      var classes = classnames({
        'form-group u_noMarginAll u_inlineBlock izenda-SettingLevel-TenantName': true,
        'disabled-elm': disabled
      });

      return settingLevel.showTenants() ? React.createElement(
        'div',
        { className: classes },
        React.createElement(
          'label',
          { className: 'u_marginLeft u_marginRight' },
          localization.getText("COMMON_LABEL_TENANT_NAME")
        ),
        React.createElement(
          'div',
          { className: 'u_inlineBlock' },
          React.createElement(DropDown, {
            options: settingLevel.tenants,
            value: settingLevel.selectedTenant,
            labelField: 'name',
            valueField: 'id',
            onChange: this.changeTenant,
            disabled: disabled
          })
        )
      ) : null;
    },

    changeSystemMode: function changeSystemMode(change) {
      var store = this.props.store;
      var selectedLevel = store.settingLevel.selectedLevel();

      if (selectedLevel !== change.value) {
        return this.props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(function () {
          return store.changeSystemMode(change);
        });
      }
    },

    changeTenant: function changeTenant(change) {
      var settingLevel = this.props.store.settingLevel;
      if (settingLevel.selectedTenant !== change.value) {
        return this.props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(function () {
          return settingLevel.changeTenant(change);
        });
      }
    }
  });
  module.exports = connect()(SettingsLevel);
}();

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Sidebar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var ScrollBox = __webpack_require__(27);

  var classnames = __webpack_require__(11);

  var SIDEBAR_EXPANDED = 'expanded';
  var SIDEBAR_COLLAPSED = 'collapsed';

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var Sidebar = React.createClass({
    displayName: 'Sidebar',

    propTypes: {
      isHiddenOnCollapsed: React.PropTypes.bool,
      isExpanded: React.PropTypes.bool,
      hasScrollBox: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
      return {
        hasScrollBox: true
      };
    },

    getInitialState: function getInitialState() {
      return {
        isExpanded: true
      };
    },

    componentWillMount: function componentWillMount() {
      this.updateExpanded(this.props.isExpanded);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.updateExpanded(nextProps.isExpanded);
    },

    updateExpanded: function updateExpanded(isExpanded) {
      if (!isNil(isExpanded)) {
        this.setState({ isExpanded: isExpanded });
      }
    },

    toggleSidebar: function toggleSidebar() {
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    },

    getCollapsibleStatus: function getCollapsibleStatus() {
      return this.state.isExpanded ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED;
    },

    render: function render() {
      var classes = classnames(this.getCollapsibleStatus(), {
        'izenda-Sidebar': true
      });

      return React.createElement(
        'div',
        { className: classes, 'aria-expanded': 'false' },
        React.createElement(
          'div',
          { className: 'u_marginLeft u_fullHeight' },
          this.renderContent()
        )
      );
    },

    renderContent: function renderContent() {
      var props = this.props;
      var isHidden = props.isHiddenOnCollapsed && !this.state.isExpanded;
      var className = classnames(this.props.className, this.getCollapsibleStatus());

      var content = React.createElement(
        'div',
        null,
        this.renderCollapsibleSection(),
        !isHidden && React.createElement(
          'div',
          { className: className },
          this.props.children
        )
      );

      return this.props.hasScrollBox ? React.createElement(
        ScrollBox,
        { shouldInjectScrollCallbackToChild: false },
        content
      ) : content;
    },

    renderCollapsibleSection: function renderCollapsibleSection() {
      return React.createElement(
        'div',
        { className: 'collapsible' },
        React.createElement(
          'div',
          { className: classnames('izenda-NavIcon', this.getCollapsibleStatus()), onClick: this.toggleSidebar },
          React.createElement('span', null),
          React.createElement('span', null),
          React.createElement('span', null),
          React.createElement('span', null),
          React.createElement('span', null),
          React.createElement('span', null)
        )
      );
    }
  });
  module.exports = Sidebar;
}();

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MainWrapper.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Main Wrapper component
 */

!function () {

  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);
  var UiState = __webpack_require__(15);
  var BrowserUtils = __webpack_require__(78);

  var MainWrapper = React.createClass({
    displayName: 'MainWrapper',

    componentDidMount: function componentDidMount() {
      window.addEventListener('resize', this.handleWindowResize, false);
    },

    componentWillUnmount: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize, false);
    },

    handleWindowResize: function handleWindowResize() {
      var isMobileDevice = BrowserUtils.isMobileDevice();
      if (isMobileDevice !== UiState.isMobile) {
        UiState.setMobileVersion(isMobileDevice);
      }
    },

    render: function render() {
      var props = this.props;

      var wrapperClass = classnames(props.className, {
        'izenda-Main-wrapper-system-mode': UiState.hideSystemLevel,
        'izenda-Main-wrapper': !UiState.hideSystemLevel
      });

      return React.createElement(
        'section',
        { className: wrapperClass },
        props.children,
        React.createElement('section', { className: 'izenda-Overlay', 'aria-expanded': 'false' })
      );
    }
  });

  module.exports = connect()(MainWrapper);
}();

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="ContextMenu.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/* eslint-disable no-undefined */

/**
 * ContextMenu component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(410);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(195);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda5 = __webpack_require__(78);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(153);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2214);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContextMenu = (_dec = (0, _Izenda10.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ContextMenu, _Component);

  function ContextMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ContextMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContextMenu.__proto__ || (0, _getPrototypeOf2.default)(ContextMenu)).call.apply(_ref, [this].concat(args))), _this), _this.renderTopItem = function (topItem) {
      if (!_this.props.enabled) {
        return _react2.default.createElement(
          _Izenda2.default.Item,
          { className: 'panel disabled-pointer-event', key: topItem.key },
          _react2.default.createElement(
            _Izenda2.default.ItemHeader,
            { className: 'panel-heading' },
            _this.renderItemHeader(topItem)
          )
        );
      }
      return _react2.default.createElement(
        _Izenda2.default.Item,
        {
          className: 'panel',
          key: topItem.key,
          itemExpanded: (0, _fp.includes)(_this.props.activeKey, (0, _fp.map)('key', topItem.items))
        },
        _react2.default.createElement(
          _Izenda2.default.ItemHeader,
          { className: 'panel-heading' },
          _this.renderItemHeader(topItem)
        ),
        _react2.default.createElement(
          _Izenda2.default.ItemBody,
          { className: 'panel-body' },
          _this.renderSubItems(topItem.items, topItem.key)
        )
      );
    }, _this.renderItemHeader = function (topItem) {
      var handleClick = !topItem.items ? _this.handleClick : undefined;
      return _this.renderMenuItem(handleClick)(topItem);
    }, _this.renderSubItems = function (childItems, key) {
      return _react2.default.createElement(
        _Izenda4.default,
        { className: 'list-group', key: key },
        (0, _fp.map)(_this.renderMenuItem(_this.handleClick))(childItems)
      );
    }, _this.renderMenuItem = function (handleClick) {
      var _this$props = _this.props,
          enabled = _this$props.enabled,
          activeKey = _this$props.activeKey,
          renderChangedIcon = _this$props.renderChangedIcon;

      return function (item) {
        return _react2.default.createElement(_Izenda12.default, {
          item: item,
          key: item.key,
          enabled: enabled,
          activeKey: activeKey,
          handleClick: handleClick,
          renderChangedIcon: renderChangedIcon
        });
      };
    }, _this.handleClick = function (e) {
      var dataName = $izenda(e.currentTarget).data('name');

      var _this$props2 = _this.props,
          activeKey = _this$props2.activeKey,
          enabled = _this$props2.enabled;


      if (_Izenda6.default.isMobileDevice()) {
        if (dataName === activeKey) {
          _Izenda8.default.toggleMiddelPanel(true);
        }

        if (enabled && dataName !== activeKey) {
          _Izenda8.default.toggleSideBar(false);
          _Izenda8.default.toggleIconMenu(false);
        }
      }

      if (!enabled) {
        return;
      }
      var onSelected = _this.props.onSelected;
      onSelected && onSelected(dataName, activeKey);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ContextMenu, [{
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)(this.props.className, 'panel-group collapsible-list-items context-menu');
      return _react2.default.createElement(
        _Izenda2.default,
        { className: classes },
        (0, _fp.map)(this.renderTopItem)(this.props.dataSource)
      );
    }
  }]);
  return ContextMenu;
}(_react.Component), _class2.propTypes = {
  enabled: _propTypes2.default.bool,
  activeKey: _propTypes2.default.string,
  onSelected: _propTypes2.default.func,
  className: _propTypes2.default.string
}, _temp2)) || _class);
exports.default = ContextMenu;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoadingTreeView.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(27);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2256);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2257);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyLoadingTreeView = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LazyLoadingTreeView, _Component);

  function LazyLoadingTreeView(props) {
    (0, _classCallCheck3.default)(this, LazyLoadingTreeView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LazyLoadingTreeView.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadingTreeView)).call(this, props));

    _this.setScrollboxRef = function (element) {
      _this.scrollBox = element;
      (0, _fp.invokeArgs)('getTreeScrollbox', [element], _this.props);
    };

    _this.flattenTree = new _Izenda4.default();
    return _this;
  }

  (0, _createClass3.default)(LazyLoadingTreeView, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var className = props.className,
          nodes = props.nodes,
          renderNode = props.renderNode,
          getChildNodes = props.getChildNodes,
          getKey = props.getKey,
          nodeExpand = props.nodeExpand,
          collapsed = props.collapsed;


      var flattenFirstLevelNode = (0, _fp.curry)(flatten, 6)(0, // node level. Zero is for root node.
      nodeExpand, // check whether node is expanded
      getChildNodes, // retrieve child nodes of a particular tree node
      getKey, // retrieve key value of a node. It must be unique
      collapsed, // tree is collapsed by default
      null // parent tree node. Null is for root node.
      );

      var flattenNodes = (0, _fp.flatMap)(flattenFirstLevelNode, nodes);

      return _react2.default.createElement(
        _Izenda2.default,
        { ref: this.setScrollboxRef },
        _react2.default.createElement(_Izenda6.default, {
          className: className,
          treeViewItemClassName: props.treeViewItemClassName,
          flattenNodes: flattenNodes,
          isLastPage: props.isLastPage,
          treeStore: this.flattenTree,
          renderNode: renderNode,
          getData: props.getData,
          viewHeight: props.viewHeight,
          itemHeight: props.itemHeight,
          defaultItemsNumber: props.defaultItemsNumber,
          registerLazyLoadingStore: props.registerLazyLoadingStore
        })
      );
    }
  }]);
  return LazyLoadingTreeView;
}(_react.Component), _class2.propTypes = {
  nodes: _mobxReact.propTypes.arrayOrObservableArray,
  getChildNodes: _propTypes2.default.func.isRequired,
  getKey: _propTypes2.default.func.isRequired,
  renderNode: _propTypes2.default.func.isRequired,
  collapsed: _propTypes2.default.bool,
  nodeExpand: _propTypes2.default.func,
  getData: _propTypes2.default.func.isRequired,
  isLastPage: _propTypes2.default.bool.isRequired,
  registerLazyLoadingStore: _react2.default.PropTypes.func
}, _class2.defaultProps = {
  collapsed: true
}, _temp)) || _class;

exports.default = LazyLoadingTreeView;


function flatten(level, nodeExpand, getChildNodes, getKey, collapsed, parent, node) {
  if (!node) return [];

  var currentLevel = level;
  var key = getKey(node);
  var childNodeIndex = void 0,
      childrenLength = void 0,
      grandChildren = void 0;
  var nodeExpanded = !(0, _fp.isNil)(nodeExpand) && nodeExpand(node);
  var defaultExpanded = !collapsed;

  // Node is expanded if it's expanded by data logic, or by default setting
  // or by user actions.
  var shouldExpanded = nodeExpanded || defaultExpanded;
  var childNodes = getChildNodes(node) || [];
  var currentTreeNode = toTreeNode(currentLevel, key, shouldExpanded, childNodes.length, parent, node);
  var flattenList = [currentTreeNode];

  // Use native FOR loop to maximize performance while walking thru child nodes list.
  for (childNodeIndex = 0, childrenLength = childNodes.length; childNodeIndex < childrenLength; childNodeIndex++) {
    grandChildren = flatten(currentLevel + 1, nodeExpand, getChildNodes, getKey, collapsed, currentTreeNode, childNodes[childNodeIndex]);

    Array.prototype.push.apply(flattenList, grandChildren);
  }

  return flattenList;
}

function toTreeNode(level, key, shouldExpanded, childCount, parent, dataNode) {
  return {
    level: level,
    data: (0, _mobx.asReference)(dataNode),
    key: key,
    parent: parent,
    childCount: childCount,
    expanded: shouldExpanded
  };
}
module.exports = exports['default'];

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTile.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(73);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(269);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(58);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(54);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2421);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(588);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2422);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(34);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(1159);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(587);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(89);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var BUTTON_ALIGN_VERTICAL = _Izenda18.default.BUTTON_ALIGN_VERTICAL;
var ZERO = 0;
function getFilterInfo(keyPattern, keyLookupPattern) {
  return (0, _fp.reduce)(function (acc, filter) {
    var position = (0, _fp.get)('configField.fieldDetails.position', filter);

    if (!position) {
      return acc;
    }

    var value = filter.value;

    var overideFilterValue = (0, _fp.set)(String.format(keyPattern, position), value, acc);
    return keyLookupPattern ? (0, _fp.set)(String.format(keyLookupPattern, position), (0, _fp.get)('configField.fieldDetails.useLookup', filter), overideFilterValue) : overideFilterValue;
  }, {}, this.filters);
}

var DashboardTile = (0, _Izenda8.default)(_class = (_class2 = function () {
  function DashboardTile(data) {
    (0, _classCallCheck3.default)(this, DashboardTile);

    _initDefineProp(this, 'id', _descriptor, this);

    _initDefineProp(this, 'dashboardId', _descriptor2, this);

    _initDefineProp(this, 'positionX', _descriptor3, this);

    _initDefineProp(this, 'positionY', _descriptor4, this);

    _initDefineProp(this, 'width', _descriptor5, this);

    _initDefineProp(this, 'height', _descriptor6, this);

    _initDefineProp(this, 'title', _descriptor7, this);

    _initDefineProp(this, 'editingTitle', _descriptor8, this);

    _initDefineProp(this, 'isBackSide', _descriptor9, this);

    _initDefineProp(this, 'filterDescription', _descriptor10, this);

    _initDefineProp(this, 'isFullScreenMode', _descriptor11, this);

    _initDefineProp(this, 'numberOfRecord', _descriptor12, this);

    _initDefineProp(this, 'state', _descriptor13, this);

    _initDefineProp(this, 'filters', _descriptor14, this);

    _initDefineProp(this, 'type', _descriptor15, this);

    _initDefineProp(this, 'contentTitle', _descriptor16, this);

    _initDefineProp(this, 'contentDescription', _descriptor17, this);

    _initDefineProp(this, 'contentFromPreset', _descriptor18, this);

    _initDefineProp(this, 'bodyContent', _descriptor19, this);

    _initDefineProp(this, 'reportId', _descriptor20, this);

    _initDefineProp(this, 'reportPartId', _descriptor21, this);

    _initDefineProp(this, 'report', _descriptor22, this);

    _initDefineProp(this, 'reportPart', _descriptor23, this);

    _initDefineProp(this, 'disableViewReport', _descriptor24, this);

    _initDefineProp(this, 'disableViewReportMessage', _descriptor25, this);

    _initDefineProp(this, 'disableViewReportMessageKey', _descriptor26, this);

    _initDefineProp(this, 'filterRequired', _descriptor27, this);

    this.reportDataSource = [];

    this.getReportPartSize = function (baseWidth, infoSize) {
      var rawSize = this.getRawContainerSize(baseWidth);

      return (0, _fp.isEmpty)(rawSize) ? {} : {
        height: rawSize.height - infoSize.height + 'px',
        width: rawSize.width - infoSize.width + 'px'
      };
    };

    this.reportDataSource = [];
    this.id = (0, _fp.uniqueId)('dashboardTile_');
    this.dashboardId = null;
    this.positionX = 0;
    this.positionY = 0;
    this.width = 0;
    this.height = 0;
    this.title = '';
    this.editingTitle = '';
    this.isBackSide = false;
    this.filterDescription = null;
    this.isFullScreenMode = false;
    this.numberOfRecord = -1;
    this.state = _Izenda6.default.INSERT;
    this.filters = [];
    this.type = null;
    this.contentTitle = new _Izenda14.default();
    this.contentDescription = new _Izenda14.default();
    this.contentFromPreset = false;
    this.bodyContent = {
      text: '',
      config: {
        fontFamily: _Izenda16.default.defaultFontFamily,
        fontSize: _Izenda16.default.defaultFontSize,
        bold: false,
        italic: false,
        underline: false,
        strikethrough: false,
        textColor: '',
        backgroundColor: '',
        alignleft: false,
        aligncenter: false,
        alignright: false,
        alignjustify: false,
        bullet: '',
        numbered: '',
        alignTop: false,
        alignMiddle: false,
        alignBottom: false
      }
    };
    this.reportId = null;
    this.reportPartId = null;
    this.report = null;
    this.reportPart = null;
    this.disableViewReport = false;
    this.disableViewReportMessage = null;
    this.disableViewReportMessageKey = null;
    this.originalPosition = null;

    // for printing
    this.filterInfoForReport = (0, _fp.partial)(getFilterInfo, ['p{0}value']);
    // for open sub report
    this.filterInfoForSubReport = (0, _fp.partial)(getFilterInfo, ['mp{0}value', 'mp{0}lookup']);
    data && this.populateData(data);
  }

  (0, _createClass3.default)(DashboardTile, [{
    key: 'emptyVisibleRequiredFilter',


    /**
     * Get list required filter with empty value
     * @returns {Array}
     */
    value: function emptyVisibleRequiredFilter() {
      var _this = this;

      // Using action for don't allow rerender when filterItem.value change.
      return (0, _mobx.untracked)(function () {
        return (0, _fp.filter)(function (filterItem) {
          var filterField = filterItem.filterField,
              value = filterItem.value;


          var isEmptyValue = ((0, _fp.isEmpty)((0, _fp.trim)(value)) || (0, _fp.includes)('', (0, _fp.split)(';#', value))) && (0, _fp.isEmpty)((0, _fp.trim)(filterField.value));
          var operatorName = filterField.operatorName;
          var emptyValue = !filterField.isParameter && filterField.required && isEmptyValue && operatorName && !(0, _fp.includes)(operatorName, _Izenda21.OPERATOR_NAMES);
          return emptyValue && filterField.visible;
        }, _this.filters);
      });
    }

    /**
     * Check Dirty for Dashboard Tile
     * @returns {boolean}
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty || (0, _fp.some)('isDirty', this.filters);
    }

    /**
     * Clean Dirty for Dashboard Tile
     * @param {type} )
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      // Reset dirty dashboard tile
      this.resetDirty();

      // Reset dirty dashboard filter
      (0, _fp.forEach)(function (filter) {
        filter.resetDirty();
      }, this.filters);
    }

    /**
     * initial data for this object
     * @method populateData
     * @param  {any}     data Data from api/ preset
     */

  }, {
    key: 'populateData',
    value: function populateData(data) {
      data.id && (this.id = data.id);
      this.dashboardId = data.dashboardId;
      this.positionX = data.positionX;
      this.positionY = data.positionY;
      this.filters = (0, _fp.map)(function (item) {
        item = (0, _fp.cloneDeep)((0, _mobx.toJS)(item));
        if (item.filterField) {
          item.filterField.value = item.value;
          item.filterField.uniqueId = (0, _fp.uniqueId)();
          item.filterField = new _Izenda20.default(item.filterField);
        }
        return new _Izenda10.default(item);
      }, data.filters);
      this.state = data.state;
      this.editingTitle = this.title = data.title;
      this.filterDescription = data.filterDescription;
      this.width = data.width;
      this.height = data.height;
      this.type = data.type;
      this.reportId = data.reportId;
      this.reportPartId = data.reportPartId;
      this.numberOfRecord = data.numberOfRecord;
      this.contentTitle.populateData((0, _fp.get)('dashboardPartContent.contentTitle', data) || data.contentTitle);
      this.contentDescription.populateData((0, _fp.get)('dashboardPartContent.contentDescription', data) || data.contentDescription);
      this.contentFromPreset = (0, _fp.get)('dashboardPartContent.contentFromPreset', data) || data.contentFromPreset;
      if (this.isTextType) {
        var textTypeContent = (0, _fp.cloneDeep)((0, _mobx.toJS)((0, _fp.get)('dashboardPartContent.textTypeContent', data) || (0, _fp.get)('bodyContent.text', data)));

        this.bodyContent.text = textTypeContent || '';
      }
      this.reportDataSource = data.reportDataSource;

      this.cleanDirty();
    }

    /**
     * set report part position
     * @param {Object} position object
     */

  }, {
    key: 'setPosition',
    value: function setPosition(position) {
      this.positionX = position.positionX;
      this.positionY = position.positionY;
      this.width = position.width;
      this.height = position.height;

      this.markDirty();
    }

    /**
     * set original position for report part
     * @param {Object} position object
     */

  }, {
    key: 'setOriginalPosition',
    value: function setOriginalPosition(position) {
      this.originalPosition = {
        positionX: position.positionX,
        positionY: position.positionY,
        width: position.width,
        height: position.height
      };
    }
    /**
     * select type for dashboard part
     * @method setType
     * @param  {any} typeConfig [description]
     * @param  {any} report     [description]
     * @param  {any} reportPart [description]
     */

  }, {
    key: 'setType',
    value: function setType(typeConfig, reportPart, report) {
      this.type = typeConfig.type;
      if (reportPart) {
        this.reportId = reportPart.reportId;
        this.reportPartId = reportPart.id;
        this.setNumberOfRecord(reportPart.numberOfRecord);
        this.readReportInfo(report, reportPart);
        this.buildFilters(report);
      }
      this.markDirty();
    }

    /**
     * Calculate filter list.
     * @param {any} report
     */

  }, {
    key: 'buildFilters',
    value: function buildFilters(report) {
      var _this2 = this;

      this.filters = (0, _fp.map)(function (filterField) {
        return new _Izenda10.default({
          filterFieldId: filterField.id,
          value: filterField.value,
          operatorId: filterField.operatorId,
          isCommon: false,
          dashboardPartId: !_this2.isNew && _this2.id || null,
          filterField: new _Izenda20.default(filterField),
          displayName: filterField.alias
        });
      }, (0, _fp.getOr)([], 'reportFilter.filterFields', report));
    }

    /**
     * set number of record
     * @method Set number of record
     * @param  {numRecord} numRecord New Number of record
     */

  }, {
    key: 'setNumberOfRecord',
    value: function setNumberOfRecord(numRecord) {
      var number = parseInt(numRecord, 10);

      if ((0, _fp.isNaN)(number)) {
        this.numberOfRecord = -1;
      } else {
        this.numberOfRecord = number <= ZERO ? ZERO : number;
      }
      this.markDirty();
    }

    /**
     * Get data by key
     * @param {string} key
     */

  }, {
    key: 'getDataByKey',
    value: function getDataByKey(key) {
      return this[key];
    }

    /**
     * Read report information
     * @param {any} reportDef
     * @param {any} reportPartDef
     */

  }, {
    key: 'readReportInfo',
    value: function readReportInfo(reportDef, reportPartDef) {
      var detail = (0, _fp.get)('detail', reportDef);
      this.report = reportDef;
      if (this.reportPart) {
        this.reportPart.readData(reportPartDef, null, reportDef.accessPriority);
      } else {
        this.reportPart = new _Izenda4.default(reportPartDef, null, reportDef.accessPriority);
      }
      if (!(0, _fp.isNil)(detail)) {
        this.disableViewReport = true;
        this.disableViewReportMessage = detail.message;
        this.disableViewReportMessageKey = detail.messageKey;
      }
    }

    /**
     * Toggle side mode
     * @param {boolean} isBackSide
     */

  }, {
    key: 'toggleSide',
    value: function toggleSide(isBackSide) {
      this.isBackSide = (0, _fp.isBoolean)(isBackSide) ? isBackSide : !this.isBackSide;
    }

    /**
     * set name of dashboard part
     * @method setName
     * @param  {string} newName New Name
     */

  }, {
    key: 'setTitle',
    value: function setTitle(newName) {
      this.editingTitle = this.title = (0, _fp.trim)(newName);
      this.markDirty();
    }

    /**
     * update editing title
     * @method setEditingTitle
     * @param  {string} newName
     */

  }, {
    key: 'setEditingTitle',
    value: function setEditingTitle(newName) {
      this.editingTitle = newName;
      this.markDirty();
    }

    /**
     * Update Text of Title
     * @param {string} text
     */

  }, {
    key: 'updateContentTitle',
    value: function updateContentTitle(text) {
      this.contentTitle.updateText(text);
      this.markDirty();
    }

    /**
     * Update Text of Description
     * @param {string} text
     */

  }, {
    key: 'updateContentDescription',
    value: function updateContentDescription(text) {
      this.contentDescription.updateText(text);
      this.markDirty();
    }

    /**
     * Update font settings of Title's text
     * @param {any} settings
     */

  }, {
    key: 'updateContentTitleSettings',
    value: function updateContentTitleSettings(settings) {
      this.contentTitle.updateSettings(settings);
      this.markDirty();
    }

    /**
     * Update font setting of Description's text
     * @param {any} setting
     */

  }, {
    key: 'updateContentDescriptionSettings',
    value: function updateContentDescriptionSettings(settings) {
      this.contentDescription.updateSettings(settings);
      this.markDirty();
    }

    /**
     * toggle fullscreen mode for dashboard tile
     */

  }, {
    key: 'toggleFullScreenMode',
    value: function toggleFullScreenMode() {
      this.isFullScreenMode = !this.isFullScreenMode;
    }

    /**
     * Get Body content config
     */

  }, {
    key: 'getBodyConfig',
    value: function getBodyConfig() {
      return (0, _fp.get)('config', this.bodyContent);
    }

    /**
     * Get Body content text
     * @returns {string}
     */

  }, {
    key: 'getBodyText',
    value: function getBodyText() {
      return (0, _fp.get)('text', this.bodyContent);
    }

    /**
     * Set vertical align base on value (top|middle|bottom)
     * @param {string} value
     */

  }, {
    key: 'setVerticalAlignConfig',
    value: function setVerticalAlignConfig(value) {
      var config = this.bodyContent.config;
      var keys = (0, _keys2.default)(BUTTON_ALIGN_VERTICAL);

      keys.forEach(function (key) {
        config[key] = value === key;
      });

      this.markDirty();
    }

    /**
     * Prepare data for save
     */

  }, {
    key: 'prepareDataForSave',
    value: function prepareDataForSave() {
      var returnObject = (0, _fp.omit)(['report', 'reportPart', 'id', 'contentTitle', 'contentDescription', 'filters', 'contentFromPreset', 'editingTitle'], this);

      if (this.state !== _Izenda6.default.INSERT) {
        returnObject.id = this.id;
      } else {
        returnObject.id = null;
      }

      if (this.isDirty && this.state === _Izenda6.default.NONE) {
        returnObject.state = _Izenda6.default.UPDATE;
      }

      returnObject.reportId = this.reportId;
      returnObject.reportPartId = this.reportPartId;
      returnObject.dashboardPartContent = {
        contentTitle: this.contentTitle,
        contentDescription: this.contentDescription,
        contentFromPreset: this.contentFromPreset,
        textTypeContent: this.bodyContent.text
      };

      returnObject.filters = (0, _fp.invokeMap)('buildDataForSaving', this.filters);

      return returnObject;
    }

    /**
     * delete this dashboard tile
     * @method delete
     */

  }, {
    key: 'delete',
    value: function _delete() {
      this.state = _Izenda6.default.DELETE;
      this.markDirty();
    }

    /**
     * Build config field list for this dashboard tile
     * @method buildConfigFieldList
     * @param {any} operatorGroup Result data from api
     * @param {Function} markUpdateResultFunc
     */

  }, {
    key: 'buildConfigFieldList',
    value: function buildConfigFieldList(operatorGroup, markUpdateResultFunc) {
      var dashboardTile = this;

      (0, _fp.forEach)(function (item) {
        var filterDetailsConfig = new _Izenda12.default(item.filterField, markUpdateResultFunc);

        filterDetailsConfig.commonData.operatorGroup = (0, _fp.clone)(operatorGroup);
        filterDetailsConfig.value = item.value;

        filterDetailsConfig.setFilterValue = function (filterValue) {
          _Izenda12.default.prototype.setFilterValue.call(filterDetailsConfig, filterValue);
          item.setFilterValue(this.fieldDetails.value);
          item.setOperatorId(this.fieldDetails.operatorId);
          item.configField.value = this.fieldDetails.value;
          item.operatorId = this.fieldDetails.operatorId;
          dashboardTile.markDirty();
        };

        item.configField = filterDetailsConfig;
      }, this.filters);
    }

    /**
     * Calculate width, height for container
     * @param  {number} baseWidth
     */

  }, {
    key: 'getRawContainerSize',
    value: function getRawContainerSize(baseWidth) {
      var autoSize = !(0, _fp.isNil)(this.type) && this.type !== _Izenda2.default.TILE_TYPE.text.type ? (0, _fp.getOr)(false, 'autoSize', this.reportPart) : false;

      return autoSize ? {} : {
        height: baseWidth * this.height,
        width: baseWidth * this.width
      };
    }

    /**
     * Calculate width height in px for container
     * @param  {number} baseWidth
     */

  }, {
    key: 'getContainerSize',
    value: function getContainerSize(baseWidth) {
      var rawSize = this.getRawContainerSize(baseWidth);

      return (0, _fp.isEmpty)(rawSize) ? {} : {
        height: rawSize.height + 'px',
        width: rawSize.width + 'px'
      };
    }

    /**
     * Calculate width height in px for report part.
     * Minus size of information session.
     * @param  {number} baseWidth
     * @param  {any} infoSize
     */

  }, {
    key: 'isNew',
    get: function get() {
      return this.state === _Izenda6.default.INSERT;
    }
  }, {
    key: 'isDelete',
    get: function get() {
      return this.state === _Izenda6.default.DELETE;
    }
  }, {
    key: 'isFullSize',
    get: function get() {
      return this.isBackSide;
    }
  }, {
    key: 'getDefaultName',
    get: function get() {
      if (this.type === _Izenda2.default.TILE_TYPE.text.type) {
        return _Izenda2.default.TILE_TYPE.text.type;
      }

      var nameArray = (0, _fp.compact)([(0, _fp.get)('categoryName', this.report) || _Izenda2.default.UNCATEGORIZED, (0, _fp.get)('subCategoryName', this.report), (0, _fp.get)('name', this.report), (0, _fp.get)('headerTitle', this.reportPart)]);

      return (0, _fp.join)('/', nameArray);
    }
  }, {
    key: 'typeConfig',
    get: function get() {
      return (0, _fp.flow)(_fp.values, (0, _fp.find)({
        type: this.type
      }))(_Izenda2.default.TILE_TYPE);
    }
  }, {
    key: 'isReportPartType',
    get: function get() {
      return this.type === _Izenda2.default.TILE_TYPE.reportPart.type;
    }
  }, {
    key: 'isTextType',
    get: function get() {
      return this.type === _Izenda2.default.TILE_TYPE.text.type;
    }
  }, {
    key: 'numberOfRecordDisplayValue',
    get: function get() {
      return this.numberOfRecord < ZERO ? '' : this.numberOfRecord;
    }
  }, {
    key: 'showNumberOfRecord',
    get: function get() {
      return this.isReportPartType;
    }
  }, {
    key: 'showRefeshButton',
    get: function get() {
      return this.isReportPartType && !this.isBackSide;
    }

    // for display filter setting value

  }, {
    key: 'individualConfigFieldList',
    get: function get() {
      return (0, _fp.flow)((0, _fp.filter)({
        isCommon: false
      }), (0, _fp.map)('configField'))(this.displayFilters);
    }

    // for display filter description

  }, {
    key: 'fullConfigFieldList',
    get: function get() {
      return (0, _fp.flow)((0, _fp.sortBy)([(0, _fp.negate)((0, _fp.get)('isCommon')), (0, _fp.get)('configField.fieldDetails.position')]), (0, _fp.map)('configField'))(this.displayFilters);
    }
  }, {
    key: 'displayFilters',
    get: function get() {
      return (0, _fp.filter)(function (filter) {
        return !(0, _fp.isNil)(filter.filterField) && filter.filterField.dataType != _Izenda22.default.EXCLUDE_FILTER_DATA_TYPE.REF_CURSOR && filter.filterField.dataType != _Izenda22.default.EXCLUDE_FILTER_DATA_TYPE.SYS_REFCURSOR;
      }, this.filters);
    }
  }]);
  return DashboardTile;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'dashboardId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'positionX', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'positionY', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'width', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'height', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'title', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'editingTitle', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'isBackSide', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'filterDescription', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'isFullScreenMode', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'numberOfRecord', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'state', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'filters', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'contentTitle', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'contentDescription', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'contentFromPreset', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, 'bodyContent', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, 'reportId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, 'reportPartId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, 'report', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, 'reportPart', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, 'disableViewReport', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class2.prototype, 'disableViewReportMessage', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class2.prototype, 'disableViewReportMessageKey', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class2.prototype, 'filterRequired', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'isNew', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isNew'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isDelete', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isFullSize', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isFullSize'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getDefaultName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getDefaultName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'typeConfig', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'typeConfig'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isReportPartType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isReportPartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isTextType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isTextType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'numberOfRecordDisplayValue', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'numberOfRecordDisplayValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showNumberOfRecord', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showNumberOfRecord'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showRefeshButton', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showRefeshButton'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'individualConfigFieldList', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'individualConfigFieldList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fullConfigFieldList', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'fullConfigFieldList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'displayFilters', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'displayFilters'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPosition', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setPosition'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'buildFilters', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'buildFilters'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setNumberOfRecord', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setNumberOfRecord'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readReportInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readReportInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleSide', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleSide'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setTitle', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setTitle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setEditingTitle', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setEditingTitle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateContentTitle', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateContentTitle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateContentDescription', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateContentDescription'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateContentTitleSettings', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateContentTitleSettings'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateContentDescriptionSettings', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateContentDescriptionSettings'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleFullScreenMode', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleFullScreenMode'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setVerticalAlignConfig', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setVerticalAlignConfig'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'delete', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'delete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'buildConfigFieldList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'buildConfigFieldList'), _class2.prototype)), _class2)) || _class;

exports.default = DashboardTile;
module.exports = exports['default'];

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1160);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ALL_TENANT_ID = 'AllTenantId';
var MAPPING_TYPE = {
  Schema: 1,
  Database: 2
};

/**
 * Build mapping key.
 * @param {Object} sourceData 
 */
function buildMappingKey(sourceData) {
  // Same with optionFromDatabaseNameValue.
  return String.format('{0} - [{1}] {2}', sourceData.databaseServer, sourceData.serverTypeName, sourceData.databaseName);
}

exports.default = {
  get TABLE_DEF() {
    return {
      fromDatabaseName: {
        key: 'fromDatabaseName',
        columnKey: 'fromDatabaseName',
        width: 150,
        title: _Izenda2.default.getText('DATABASE_MAPPING_LABEL_TABLE_DEF_GLOBAL_MAPPING_FROM_DB_NAME')
      },
      type: {
        key: 'type',
        columnKey: 'type',
        width: 150,
        title: _Izenda2.default.getText('COMMON_LABEL_TYPE')
      },
      fromObject: {
        key: 'fromObject',
        columnKey: 'fromObject',
        width: 150,
        title: _Izenda2.default.getText('COMMON_LABEL_OBJECT')
      },
      toDatabaseName: {
        key: 'toDatabaseName',
        columnKey: 'toDatabaseName',
        width: 150,
        title: _Izenda2.default.getText('DATABASE_MAPPING_LABEL_TABLE_DEF_GLOBAL_MAPPING_TO_DB_NAME')
      },
      toObject: {
        key: 'toObject',
        columnKey: 'toObject',
        width: 150,
        title: _Izenda2.default.getText('COMMON_LABEL_OBJECT'),
        infoIconOptions: {
          iconClass: 'icon-info-circled',
          iconTitle: _Izenda2.default.getText('COPY_MANAGEMENT_OBJECT_TOOLTIP')
        }
      },
      tenant: {
        key: 'mappingTenants',
        columnKey: 'mappingTenants',
        width: 200,
        title: _Izenda2.default.getText('DATABASE_MAPPING_LABEL_TENANT_COLUMN')
      },
      action: {
        width: 60,
        fixed: true,
        align: 'center',
        title: _Izenda2.default.getText('COMMON_LABEL_ACTION'),
        className: 'align-bottom'
      }
    };
  },
  get REQUIRE_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED')
      }
    };
  },
  get MAPPING_TYPES() {
    return [{
      label: _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_MAPPING_TYPE_SCHEMA'),
      value: MAPPING_TYPE.Schema
    }, {
      label: _Izenda2.default.getText('COPY_MANAGEMENT_LABEL_MAPPING_TYPE_DATABASE'),
      value: MAPPING_TYPE.Database
    }];
  },
  MAPPING_TYPE: MAPPING_TYPE,
  MAPPING_HEIGHT: 40,
  ALL_TENANT_ID: ALL_TENANT_ID,
  ALL_TENANT_OPTION: new _Izenda4.default({
    id: ALL_TENANT_ID,
    name: _Izenda2.default.getText('DATABASE_MAPPING_ALL_TENANTS')
  }),
  ALL_MAPPINGS_OPTION: new _Izenda4.default({
    id: ALL_TENANT_ID,
    name: _Izenda2.default.getText('DATABASE_MAPPING_ALL_MAPPINGS')
  }),
  DATABASE_NAME_OPTION_MAPPINGS: [{
    source: function source(sourceData) {
      return buildMappingKey(sourceData);
    },

    target: 'key' // Unique key for lazy loading
  }, {
    source: function source(sourceData) {
      return buildMappingKey(sourceData);
    },

    target: 'valueField' // Key for option in drop-down
  }, {
    source: function source(sourceData) {
      return String.format('[{0}] {1}', sourceData.serverTypeName, sourceData.databaseName);
    },

    target: 'labelField' // Display value, also value to communicate with api.
  }, {
    source: function source(sourceData) {
      return String.format('{0} - {1} - {2}', sourceData.serverTypeName, sourceData.databaseServer, sourceData.databaseName);
    },

    target: 'optionTooltip' // Tooltip value
  }, {
    source: function source(sourceData) {
      return sourceData.databaseServer;
    },

    target: 'databaseServer' // Server information.
  }],
  DATABASE_NAME_KEY: 'valueField',
  OBJECT_OPTION_MAPPINGS: [{
    source: function source(sourceData) {
      return sourceData;
    },

    target: 'key'
  }, {
    source: function source(sourceData) {
      return sourceData;
    },

    target: 'valueField'
  }, {
    source: function source(sourceData) {
      return sourceData;
    },

    target: 'labelField'
  }],
  OBJECT_KEY: 'valueField',
  DEFAULT_PAGE_INDEX: 1,
  DEFAULT_PAGE_SIZE: 10,
  ID_PREFIX: 'temp_',
  MAPPING_HASH_PATTERN: '{0}#{1}#{2}#{3}#{4}#{5}#{6}'
};
module.exports = exports['default'];

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(192);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(90);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(336);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(400);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(111);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2499);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(15);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(73);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(16);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(1163);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(327);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(58);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(594);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(12);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _Izenda29 = __webpack_require__(92);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _Izenda31 = __webpack_require__(318);

var _Izenda32 = _interopRequireDefault(_Izenda31);

var _Izenda33 = __webpack_require__(50);

var _Izenda34 = __webpack_require__(118);

var _Izenda35 = __webpack_require__(161);

var _Izenda36 = _interopRequireDefault(_Izenda35);

var _Izenda37 = __webpack_require__(417);

var _Izenda38 = _interopRequireDefault(_Izenda37);

var _IzendaDashboardWorker = __webpack_require__(2503);

var _IzendaDashboardWorker2 = _interopRequireDefault(_IzendaDashboardWorker);

var _Izenda39 = __webpack_require__(120);

var _Izenda40 = _interopRequireDefault(_Izenda39);

var _Izenda41 = __webpack_require__(42);

var _Izenda42 = __webpack_require__(992);

var _Izenda43 = __webpack_require__(991);

var _Izenda44 = _interopRequireDefault(_Izenda43);

var _Izenda45 = __webpack_require__(76);

var _Izenda46 = _interopRequireDefault(_Izenda45);

var _Izenda47 = __webpack_require__(408);

var _Izenda48 = _interopRequireDefault(_Izenda47);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DashboardStore = (_dec = (0, _mobx.action)('initial'), _dec2 = (0, _mobx.action)('destroy'), _dec3 = (0, _mobx.action)('createNewDashboard'), _dec4 = (0, _mobx.action)('setDashboardTileType'), _dec5 = (0, _mobx.action)('mapCommonFilterValueToDashboardPartFilter'), _dec6 = (0, _mobx.action)('saveDashboard'), _dec7 = (0, _mobx.action)('loadDashboard'), _dec8 = (0, _mobx.action)('loadDashboards'), _dec9 = (0, _mobx.action)('deleteDashboardPart'), _dec10 = (0, _mobx.action)('removeDashboard'), _dec11 = (0, _mobx.action)('readDashboardDefinition'), _dec12 = (0, _mobx.action)('copyDashboardPart'), _dec13 = (0, _mobx.action)('cancelDashboard'), _dec14 = (0, _mobx.action)('validateBackgroundImage'), _dec15 = (0, _mobx.action)('initSubscription'), _dec16 = (0, _mobx.action)('initAccess'), _dec17 = (0, _mobx.action)('loadDashboardPart'), _dec18 = (0, _mobx.action)('associateReportDefToDashboardPart'), _dec19 = (0, _mobx.action)('lazyLoadingDashboards'), _dec20 = (0, _mobx.action)('loadLazyLoadingCategories'), _dec21 = (0, _mobx.action)('changeGlobalType'), _dec22 = (0, _mobx.action)('onRemovingPillHandler'), _dec23 = (0, _mobx.action)('onRemovingAllPillHandler'), _dec24 = (0, _mobx.action)('onDashboardPartDrillDown'), _dec25 = (0, _mobx.action)('removeRelatedDrillDownInfo'), _dec26 = (0, _mobx.action)('reloadRelatedCrossFilteringDashboardParts'), _dec27 = (0, _mobx.action)('startDashboardDataWorker'), _dec28 = (0, _mobx.action)('getDashboardPartData'), _dec29 = (0, _mobx.action)('terminateAllWorker'), (_class = function () {
  function DashboardStore() {
    var _this = this;

    (0, _classCallCheck3.default)(this, DashboardStore);

    _initDefineProp(this, 'model', _descriptor, this);

    _initDefineProp(this, 'selectedCategoryId', _descriptor2, this);

    _initDefineProp(this, 'dashboardFilterStore', _descriptor3, this);

    _initDefineProp(this, 'subscribedInstancesStore', _descriptor4, this);

    _initDefineProp(this, 'accessStore', _descriptor5, this);

    this.exportReportPart = function (url, format, reportPartId, reportId, filters, dashboardPartId, successCallBack, failCallBack) {
      var filtersData = (0, _fp.map)(function (filter) {
        return filter.filterField;
      }, filters);
      var dashboardDetail = this.dashboardDetail;
      var dashboardDefintion = dashboardDetail.getDashboardDefinition();
      var activeDashboard = (0, _fp.findIndex)({ id: dashboardPartId }, dashboardDetail.dashboard.dashboardParts);

      return _Izenda8.default.export({
        url: url,
        dashboardPartIndex: activeDashboard,
        dashboardDefinition: (0, _stringify2.default)(dashboardDefintion),
        format: format,
        reportId: reportId,
        reportPartId: reportPartId,
        filters: (0, _stringify2.default)(filtersData),
        tenantId: this.tenantId // for export API.
      }, successCallBack, failCallBack);
    };

    this.loadOperatorGroupPromise = function () {
      var operatorGroupPromise = function operatorGroupPromise() {
        return (0, _bluebird.resolve)(_this.operatorGroup);
      };
      if ((0, _fp.isNil)(_this.operatorGroup)) {
        operatorGroupPromise = _this.operatorGroupPromise;
      }
      return operatorGroupPromise();
    };

    this.contentLazyLoadingStore = {};
    this.leftMenuLazyLoadingStore = {};
    this.dashboardWorkerPendingList = [];
    this.relatedDashboardPartIds = [];
    this.printingMode = false;
    this.draftId = null;
    this.operatorGroup = null;

    // Color palettes for dashboard tile
    this.colorPalettes = [];
    this.initial();
  }

  (0, _createClass3.default)(DashboardStore, [{
    key: 'initial',
    value: function initial() {
      var _this2 = this;

      this.model = new _Izenda12.default();
      this.dashboardFilterStore = new _Izenda20.default(this.model.dashboardDetail);

      _Izenda14.default.setCheckDirtyFunction(function () {
        return _this2.isDirty;
      });
      this.initSubscription();
      this.operatorGroupPromise = function () {
        return _this2.dashboardFilterStore.fetchFilterOperatorGroup().then(function (result) {
          _this2.operatorGroup = result;
          return result;
        });
      };
    }

    /**
     * Destroy check Dirty function
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      _Izenda14.default.resetCheckDirtyFunction();
      this.operatorGroup = null;
    }

    /**
     * create new dashboard detail
     * @method createNewDashboard
     */

  }, {
    key: 'createNewDashboard',
    value: function createNewDashboard() {
      var isNewDashboard = this.dashboardDetail.dashboard.isNewDashboard;
      if (isNewDashboard) {
        this.initSubscription();
      }

      this.dashboardDesignerMode.resetAlertDetails();
      this.model.createNewDashboard();
      this.dashboardFilterStore = new _Izenda20.default(this.model.dashboardDetail);
    }

    /**
     * Load all categories
     * @return {[type]}
     */

  }, {
    key: 'loadAllCategories',
    value: function loadAllCategories() {
      var model = this.model;

      return _Izenda2.default.loadAllCategories(this.tenantId).then((0, _mobx.action)(model.readDashboardCategoryTree.bind(model))).return(null);
    }

    /**
     * lazy loading for categories
     * @param {Object} object object:
     * {
     *  pageIndex: int,
     *  pageSize: int,
     *  type: int
     *  criteria: search filter,
     *  parentIds: []
     *  includeUnCategory: bool
     *  tenantId: tenantId
     * }
     */

  }, {
    key: 'lazyLoadCategories',
    value: function lazyLoadCategories(request) {
      return _Izenda2.default.loadLazyLoadCategories(request).then(function (response) {
        var categoryList = response.data || [];
        var categories = categoryList.map(function (item) {
          return new _Izenda36.default(item);
        });

        return {
          categories: categories,
          isLastPage: response.isLastPage
        };
      });
    }

    /**
     * lazy loading for subCategories
     * @param {Object} object object:
     * {
     *  pageIndex: int,
     *  pageSize: int,
     *  type: int
     *  criteria: search filter,
     *  parentIds: []
     *  tenantId: tenantId
     * }
     */

  }, {
    key: 'lazyLoadSubCategories',
    value: function lazyLoadSubCategories(request) {
      return _Izenda2.default.loadLazyLoadSubcategories(request).then(function (response) {
        var subCategoryList = response.data || [];
        var subcategories = subCategoryList.map(function (item) {
          return new _Izenda36.default(item);
        });

        return {
          subCategories: subcategories,
          isLastPage: response.isLastPage
        };
      });
    }

    /**
     * validate category name
     * @param  {object} category
     * @returns {Promise}
     */

  }, {
    key: 'validateCategoryName',
    value: function validateCategoryName(category) {
      return _Izenda2.default.validateCategoryName(category).then(function (result) {
        return result.messages;
      });
    }

    /**
     * get data for report part in preview mode
     * @method getReportPartData
     * @param  {object} dashboardPart Dashboard Part need update data
     * @return {Promise} Ajax request
     */

  }, {
    key: 'getReportPartData',
    value: function getReportPartData(_ref, savedMode, drillDownData, pageIndex, pageSize, printingMode) {
      var reportPart = _ref.reportPart,
          disableViewReport = _ref.disableViewReport;

      var _this3 = this;

      if ((0, _fp.isNil)(reportPart) || disableViewReport) {
        return (0, _bluebird.resolve)();
      }

      reportPart.startLoadData();
      var embededReportDefPromise = _Izenda32.default.buildPromiseFetcher(reportPart, _Izenda4.default.loadReportPartDefinition.bind(_Izenda4.default), _Izenda4.default.loadForEdit.bind(_Izenda4.default));
      var colorPaletteStore = new _Izenda48.default();

      return (0, _bluebird.join)(this.getDrilldownInfo.apply(this, arguments), embededReportDefPromise, colorPaletteStore.loadThemes(), (0, _mobx.action)(function (result, embededReportDef, palettes) {
        reportPart.setQueryData(result);
        if (!result.messages) {
          reportPart.readEmbededReportDef(embededReportDef);
          reportPart.colorPalettes = palettes;
          _this3.setColorPalettes(palettes);
        }
        // return null instead of undefined
        return result.messages || null;
      })).catch(function () {
        reportPart.setQueryData([]);
      });
    }
  }, {
    key: 'getDrilldownInfo',
    value: function getDrilldownInfo(dashboardPart, savedMode, drillDownData, pageIndex, pageSize, printingMode) {
      var reportPart = dashboardPart.reportPart,
          reportPartContent = dashboardPart.reportPart.reportPartContent,
          _dashboardPart$report = dashboardPart.reportPart.reportPartContent.optionalParams,
          optionalParams = _dashboardPart$report === undefined ? {} : _dashboardPart$report,
          reportId = dashboardPart.reportId,
          reportPartId = dashboardPart.reportPartId,
          filters = dashboardPart.filters,
          numberOfRecord = dashboardPart.numberOfRecord,
          id = dashboardPart.id,
          dashboardId = dashboardPart.dashboardId;


      if (!reportPartContent.isBeingBuild) {
        return (0, _bluebird.resolve)().return({});
      }

      var request = void 0;
      var requestPromise = void 0;

      if (savedMode && !this.draftId) {
        if (this.printingMode) {
          optionalParams = (0, _fp.omit)(['paging'], optionalParams);
          optionalParams.loadAll = true;
        }

        if (!this.printingMode) {
          var crossFiltering = this.dashboardDetail.getCrossFilteringForDashboardPart(dashboardPart, false);
          !(0, _fp.isEmpty)(crossFiltering) && (optionalParams.filters = crossFiltering);
        }

        request = (0, _fp.assign)({ dashboardPartId: id }, optionalParams);
        requestPromise = _Izenda2.default.loadDashboardPartData(request);
      } else {
        // pagination
        if (reportPartContent.usePagination || reportPartContent.properties.usePagination || (0, _fp.get)('properties.view.usePagination', reportPartContent)) {
          optionalParams.paging = {
            pageIndex: pageIndex || _Izenda18.default.DEFAULT_PAGE_INDEX,
            pageSize: reportPartContent.properties.pageSize || _Izenda18.default.DEFAULT_PAGE_SIZE
          };
        }

        drillDownData = drillDownData || (0, _fp.isFunction)(reportPartContent.getDrilldownInfo) && reportPartContent.getDrilldownInfo();
        if (drillDownData) {
          optionalParams.filters = drillDownData.filters || [];
          optionalParams.expandedLevel = !(0, _fp.isNil)(drillDownData.expandedLevel) ? drillDownData.expandedLevel : optionalParams.filters.length;
        }

        var _crossFiltering = this.dashboardDetail.getCrossFilteringForDashboardPart(dashboardPart, false);
        !(0, _fp.isEmpty)(_crossFiltering) && Array.prototype.push.apply(optionalParams.filters || [], _crossFiltering);

        if (this.printingMode) {
          optionalParams = (0, _fp.omit)(['paging'], optionalParams);
          optionalParams.loadAll = true;
        }

        var reportPartState = void 0;
        if (reportPart.type === _Izenda18.default.REPORT_PART_TYPE.Map) {
          reportPartState = (0, _fp.get)('properties.reportPartState', reportPartContent);
        }

        request = {
          dashboardPart: {
            reportId: reportId,
            reportPartId: reportPartId,
            filters: (0, _fp.map)((0, _fp.pick)(['filterFieldId', 'value', 'operatorId']), filters),
            dashboardId: dashboardId,
            numberOfRecord: numberOfRecord,
            reportPartState: reportPartState
          },
          dataRequest: optionalParams || {}
        };
        requestPromise = _Izenda2.default.previewDashboardPartData(request);
      }

      return requestPromise;
    }

    /**
     * Validate Dashboard Name
     * @param {Object} boardDetail
     * @returns {Promise}
     */

  }, {
    key: 'validateName',
    value: function validateName(_ref2) {
      var id = _ref2.id,
          name = _ref2.name,
          categoryId = _ref2.categoryId,
          subCategoryId = _ref2.subCategoryId;

      var data = {
        tenantId: this.tenantId,
        dashboardId: id,
        name: name,
        categoryId: categoryId,
        subCategoryId: subCategoryId
      };

      return _Izenda2.default.validateDashboardName(data).then(function (result) {
        return result.messages;
      });
    }

    /**
     * set dashboard type for dashboard part
     * @method setDashboardTileType
     * @param  {[type]}             dashboardPart [description]
     * @param  {[type]}             type          [description]
     * @param  {[type]}             reportPart    [description]
     */

  }, {
    key: 'setDashboardTileType',
    value: function setDashboardTileType(dashboardPart, type, reportPart, report) {
      var _this4 = this;

      var dashboardDetail = this.dashboardDetail;

      // check if user is changing report part in dash board -> remove all cross filtering in that dashboard part.
      !(0, _fp.isNil)(dashboardPart.reportPart) && this.removeRelatedDrillDownInfo(dashboardPart);

      if ((0, _fp.isNil)(reportPart)) {
        dashboardDetail.setType(dashboardPart, type);
        return (0, _bluebird.resolve)();
      }

      var getCommonData = function getCommonData() {
        return _this4.getCommonFilters().then(function () {
          return _this4.getReportPartData(dashboardPart);
        });
      };

      var reportPartId = reportPart.id;
      var reportId = report.id;


      return this.associateReportDefToDashboardPart(dashboardPart, reportId, reportPartId, (0, _mobx.action)(function (reportDef, reportPartDef) {
        dashboardDetail.setType(dashboardPart, type, reportPartDef, reportDef);
      })).then(getCommonData);
    }

    /**
     * get common filter
     * @method getCommonFilters
     * @return {[type]}         [description]
     */

  }, {
    key: 'getCommonFilters',
    value: function getCommonFilters(commonFilters, shouldUpdateFilterData) {
      var dashboardDetail = this.dashboardDetail;
      var dashboardFilterStore = this.dashboardFilterStore;

      return _Izenda2.default.loadCommonFilters(dashboardDetail.getDashboardDefinition()).then(function (data) {
        (0, _fp.isArray)(data) && dashboardDetail.readCommonFilters(data, commonFilters);
        return true;
      }).then(dashboardFilterStore.getFilterData.bind(dashboardFilterStore, null, null, shouldUpdateFilterData, true));
    }

    /**
     * Update filters' value of dashboard part with value from common filters' value.
     * @param  {Object} dashboardPart
     */

  }, {
    key: 'mapCommonFilterValueToDashboardPartFilter',
    value: function mapCommonFilterValueToDashboardPartFilter(_ref3) {
      var filters = _ref3.filters;

      var commonFilterFields = this.model.dashboardDetail.dashboard.commonFilterFields;

      (0, _fp.forEach)(function (commonFilter) {
        (0, _fp.forEach)(function (filterField) {
          var matchedIndex = (0, _fp.findIndex)(function (item) {
            return item.filterFieldId === filterField.filterFieldId;
          }, filters);

          if (matchedIndex !== -1) {
            filters[matchedIndex].value = commonFilter.value;
            // Handle update state of filter
            if ((0, _fp.isNil)(filters[matchedIndex].state) || filters[matchedIndex].state === _Izenda24.default.INSERT) {
              filters[matchedIndex].updateState(_Izenda24.default.INSERT);
            } else {
              filters[matchedIndex].updateState(_Izenda24.default.UPDATE);
            }
          }
        }, commonFilter.filterFields);
      }, commonFilterFields);
    }

    /**
     * refresh dashboard part
     * @method refreshDashboardPart
     * @param  {[type]}             dashboardPart [description]
     * @return {[type]}                           [description]
     */

  }, {
    key: 'refreshDashboardPart',
    value: function refreshDashboardPart(dashboardPart) {
      this.mapCommonFilterValueToDashboardPartFilter(dashboardPart);
      return this.getReportPartData(dashboardPart, !dashboardPart.checkDirty());
    }

    /**
     * Validate dashboard name
     * @param {Object} dashboard detail model
     */

  }, {
    key: 'validateDashboardName',
    value: function validateDashboardName(dashboardDetail) {
      var data = dashboardDetail.getInitialData();
      return _Izenda2.default.validateDashboardName(data).then(function (result) {
        return result.messages;
      });
    }

    /**
     * Validate Dashboard Name
     * @param {Object} boardDetail
     * @returns {Promise}
     */

  }, {
    key: 'rename',
    value: function rename(boardDetail) {
      return _Izenda2.default.renameDashboard({
        name: boardDetail.name,
        dashboardId: boardDetail.id
      }).then(function (result) {
        return result;
      });
    }

    /**
     * Save dashboard
     * @param {Object} cloned dashboard model
     * @returns {Object}
     */

  }, {
    key: 'saveDashboard',
    value: function saveDashboard(clonedModel) {
      var _this5 = this;

      var model = (0, _fp.isEmpty)(clonedModel) ? this.model : clonedModel;
      var dashboardDefinition = model.dashboardDetail.buildDataForSaving();

      function updateAccess(dashboardId) {
        this.accessStore.updateReporId(dashboardId);
        this.accessStore.loadAllAccess(dashboardId);
      }

      return _Izenda2.default.saveDashboard(dashboardDefinition).bind(this).then((0, _mobx.action)(function (result) {
        if (result.success) {
          // Remove all Cross Filtering after saving successfully.
          _this5.dashboardDetail.removeAllDrillDowns();
          _this5.dashboardDetail.removeAllCrossFilterings();
          // Load for left navigation
          _this5.loadAllCategories();
          // Switch edit mode
          _this5.dashboardDesignerMode.setEditMode();
          // Reset need update result
          _this5.dashboardFilterStore.reportFilter.resetUpdateResult();
          // set Alert messages
          _this5.dashboardDesignerMode.setAlertDetails({
            success: true,
            message: _Izenda28.default.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED')
          });

          // get access here
          var authorization = new _Izenda40.default();
          if (authorization.checkPrivileges([_Izenda41.PERMISSION_KEY.DashboardsActionsConfigureAccessRights])) {
            var initAccessPromise = void 0;
            if ((0, _fp.isEmpty)(_this5.accessStore)) {
              initAccessPromise = _this5.initAccess();
            }

            if (initAccessPromise) {
              initAccessPromise.then(function () {
                updateAccess.call(_this5, result.dashboard.id);
              });
            } else {
              updateAccess.call(_this5, result.dashboard.id);
            }
          }

          if (authorization.checkPrivileges([_Izenda41.PERMISSION_KEY.DashboardsActionsSubscribe])) {
            // Load subscriptions
            _this5.subscribedInstancesStore.dashboardId = result.dashboard.id;
            _this5.subscribedInstancesStore.loadInstances();
          }

          // Load dashboard
          return _this5.readDashboardDefinition(result.dashboard, null, true).return(result);
        }

        return result;
      }));
    }

    /**
     * Load dashboard
     * @param {Object} id[dashboard id]
     * @returns {Object}
     */

  }, {
    key: 'loadDashboard',
    value: function loadDashboard(id, commonFilters, pageId, isCanceled) {
      var _this6 = this;

      var dashboardParams = { dashboardId: id, action: isCanceled ? 2 : 1 };

      !(0, _fp.isNil)(pageId) && (dashboardParams.page = pageId);
      var loadDashboardPromise = this.draftId ? _Izenda2.default.getDraftDataForPrint(this.draftId) : _Izenda2.default.loadDashboard(dashboardParams).get('dashboard');
      var colorPaletteStore = new _Izenda48.default();

      return (0, _bluebird.join)(loadDashboardPromise, !this.draftId && _Izenda2.default.loadRelatedDashboardParts(id), colorPaletteStore.loadThemes(), (0, _mobx.action)(function (dashboard, relatedDashboardPartIds, palettes) {
        _this6.readDashboardDefinition(dashboard, commonFilters);
        _this6.relatedDashboardPartIds = relatedDashboardPartIds;
        _this6.setColorPalettes(palettes);
        !_this6.draftId && _this6.startDashboardDataWorker(0);
        return (0, _bluebird.resolve)();
      }));
    }

    /**
     * Load dashboard list
     * @param  {string} catId
     * @return {array}
     */

  }, {
    key: 'loadDashboards',
    value: function loadDashboards(catId) {
      var _this7 = this;

      catId && (this.selectedCategoryId = catId);
      var dataObject = {
        tenantId: this.tenantId,
        isUncategorized: this.isUncategorized
      };
      var items = this.items;

      if (!this.isRootCategory && !this.isUncategorized) {
        dataObject.criterias = [{
          key: _Izenda16.default.CATEGORY_TYPE.CATEGORY_ID,
          value: this.selectedCategoryId
        }];
      }

      return _Izenda2.default.loadDashboardCategories(dataObject).bind(this).then(function (data) {
        items.readBoardList(data);
        return data;
      }).then(function () {
        return _this7.loadAllCategories();
      });
    }

    /**
     * Delete dashboard
     * @param {Object} dashboard id
     * @param {Object} dashboardSubCategory
     * @returns {Promise}
     */

  }, {
    key: 'deleteDashboard',
    value: function deleteDashboard(dashboardId, dashboardSubCategory) {
      var _this8 = this;

      return _Izenda2.default.deleteDashboard(dashboardId).bind(this).then((0, _mobx.action)(function (result) {
        return result && _this8.removeDashboard(dashboardId, dashboardSubCategory);
      }));
    }

    /**
     * delete dashboard part
     * @method deleteDashboardPart
     * @param  {[type]}            dashboardPart [description]
     * @return {[type]}                          [description]
     */

  }, {
    key: 'deleteDashboardPart',
    value: function deleteDashboardPart(dashboardPart) {
      this.dashboardDetail.deleteDashboardPart(dashboardPart);
      this.removeRelatedDrillDownInfo(dashboardPart);
      // No need to load common filters when delete not-report-part type
      return dashboardPart.type === _Izenda16.default.TILE_TYPE.reportPart.type ? this.getCommonFilters(null, true) : (0, _bluebird.resolve)();
    }

    /**
     * Remove dashboard from sub categories
     * @param {type} dashboardId
     * @param {type} dashboardSubCategory
     */

  }, {
    key: 'removeDashboard',
    value: function removeDashboard(dashboardId, boardSubCategory) {
      var dashboardItem = (0, _fp.find)({ id: dashboardId }, boardSubCategory.dashboards);
      boardSubCategory.dashboards.remove(dashboardItem);

      if (boardSubCategory.dashboards.length === 0) {
        this.lazyLoadingDashboards(null, true, null);
        this.loadLazyLoadingCategories(true);
      }

      return null;
    }

    /**
     * Read Dashboard Definition
     * @param {Object} id[dashboard id]
     * @returns {Object}
     */

  }, {
    key: 'readDashboardDefinition',
    value: function readDashboardDefinition(dashboardDefinition, commonFilters, shouldUpdateFilterData) {
      var dashboardDetail = this.model.dashboardDetail;

      dashboardDetail.readDashboardDefinition(dashboardDefinition, commonFilters);
      dashboardDetail.cleanDirty();

      return this.getCommonFilters(commonFilters, shouldUpdateFilterData);
    }

    /**
     * Move dashboard to another category or subcategory
     * @param {Object} data move data
     * @returns {Object} Promise
     */

  }, {
    key: 'moveDashboard',
    value: function moveDashboard(data) {
      return _Izenda2.default.moveDashboard((0, _assign2.default)({ tenantId: this.tenantId }, data));
    }

    /**
     * Copy dashboard
     * @param {Object} data move data
     * @returns {Object} Promise
     */

  }, {
    key: 'copyDashboard',
    value: function copyDashboard(data) {
      return _Izenda2.default.copyDashboard((0, _assign2.default)({ tenantId: this.tenantId }, data));
    }

    /**
     * Save dashboard subscriptions
     * This is used for save subscribed instances in dashboard list.
     * @param {String} dashboardId
     * @param {Array} subscriptions
     * @returns {Promise}
     */

  }, {
    key: 'saveDashboardSubscriptions',
    value: function saveDashboardSubscriptions(dashboardId, subscriptions) {
      var data = {
        id: dashboardId,
        subscriptions: subscriptions
      };

      return _Izenda2.default.saveSubscriptions(data);
    }

    /**
     * copy dashboardPart
     * @method copyDashboardPart
     * @param  {DashboardTile}          dashboardPart Original DashboardPart
     * @return {Promise}                        [description]
     */

  }, {
    key: 'copyDashboardPart',
    value: function copyDashboardPart(dashboardPart) {
      var newDashboardPart = this.dashboardDetail.copyDashboardPart(dashboardPart);
      this.loadDashboardPart(newDashboardPart);
      if (!newDashboardPart.isReportPartType) {
        return (0, _bluebird.resolve)();
      }

      return this.getCommonFilters();
    }

    /**
     * cancel dashboard
     * @method cancelDashboard
     * @return {Promise}        [description]
     */

  }, {
    key: 'cancelDashboard',
    value: function cancelDashboard() {
      var _dashboardDetail = this.dashboardDetail,
          preset = _dashboardDetail.preset,
          _dashboardDetail$dash = _dashboardDetail.dashboard,
          id = _dashboardDetail$dash.id,
          isNewDashboard = _dashboardDetail$dash.isNewDashboard;

      this.createNewDashboard();

      if (isNewDashboard) {
        this.initSubscription();
        this.dashboardDetail.readPreset(preset);
        return (0, _bluebird.resolve)();
      }

      return this.loadDashboard(id, undefined, undefined, true);
    }

    /**
     * validate backgroundImage
     */

  }, {
    key: 'validateBackgroundImage',
    value: function validateBackgroundImage() {
      var dashboardDesignerMode = this.dashboardDesignerMode;

      this.validateImageUrl(this.dashboardDetail.dashboard.imageUrl).then(function (message) {
        !(0, _fp.isEmpty)(message) && dashboardDesignerMode.setAlertDetails({ message: message });
      });
    }

    /**
     * validate image url can access
     * @type {[type]}
     */

  }, {
    key: 'validateImageUrl',
    value: function validateImageUrl(imageUrl) {
      if (!imageUrl) {
        return (0, _bluebird.resolve)('');
      }

      var validatePromise = new _bluebird2.default(function (resolve, reject) {
        var img = new Image();

        img.onload = function () {
          resolve();
        };
        img.onerror = function () {
          reject();
        };
        img.src = imageUrl;
      });

      return validatePromise.then(function () {
        return '';
      }).catch(function () {
        return _Izenda16.default.MESSAGE.INVALID_IMAGE_URL;
      });
    }

    /**
     * Update results
     */

  }, {
    key: 'updateResults',
    value: function updateResults(loadMode) {
      var _this9 = this;

      var loadFunction = loadMode ? this.refreshDashboardPart.bind(this) : this.getReportPartData.bind(this);
      return (0, _bluebird.map)(this.dashboardDetail.dashboard.reportPartDashboardParts, (0, _fp.ary)(1, loadFunction)).then(function () {
        return _this9.dashboardFilterStore.reportFilter.resetUpdateResult();
      });
    }

    /**
     * Send Email
     * @param {string} dashboardId
     * @param {object} email
     */

  }, {
    key: 'sendEmail',
    value: function sendEmail(dashboardId, email) {
      return _Izenda8.default.email({ dashboardId: dashboardId }, email);
    }

    /**
     * Load definition of dashboard part.
     * @param  {String} id
     */

  }, {
    key: 'loadDashboardPartDefinition',
    value: function loadDashboardPartDefinition(id) {
      return _Izenda2.default.loadDashboardPartDefinition(id);
    }

    /**
     * Load definition of report part.
     * @param  {String} id
     */

  }, {
    key: 'loadReportPartDefinition',
    value: function loadReportPartDefinition(id) {
      return _Izenda4.default.loadReportPartDefinition(id);
    }

    /**
     * Go to subscription page
     */

  }, {
    key: 'initSubscription',
    value: function initSubscription() {
      var isSubscribe = this.model.dashboardDesignerMode.isSubscribe;
      this.subscribedInstancesStore = new _Izenda22.default(true, this, isSubscribe);
      this.subscribedInstancesStore.model.setType(isSubscribe);
    }

    /**
     * Init access, user, role store.
     */

  }, {
    key: 'initAccess',
    value: function initAccess() {
      if (this.accessStore) return;
      var ACCESS_MODE = _Izenda30.default.ACCESS_MODE.DASHBOARD;
      var _model$dashboardDetai = this.model.dashboardDetail,
          accessModel = _model$dashboardDetai.accessModel,
          _model$dashboardDetai2 = _model$dashboardDetai.dashboard,
          id = _model$dashboardDetai2.id,
          isNewDashboard = _model$dashboardDetai2.isNewDashboard,
          isGlobal = _model$dashboardDetai2.isGlobal;


      this.accessStore = new _Izenda26.default(accessModel, id, ACCESS_MODE);
      this.accessStore.updateReporId(id);
      return this.accessStore.initialAccessDashboardPage(id, ACCESS_MODE, isGlobal, isNewDashboard);
    }

    /**
     * Validate access.
     * @return {object} promise result
     */

  }, {
    key: 'validateAccesses',
    value: function validateAccesses() {
      var _this10 = this;

      function validate() {
        var _model$dashboardDetai3 = this.model.dashboardDetail.dashboard,
            id = _model$dashboardDetai3.id,
            ownerId = _model$dashboardDetai3.ownerId;

        var data = {
          id: id,
          ownerId: ownerId,
          accesses: this.accessStore.model.accessList
        };
        return _Izenda2.default.validateAccesses(data);
      }

      if (new _Izenda40.default().checkPrivileges([_Izenda41.PERMISSION_KEY.DashboardsActionsConfigureAccessRights])) {
        var initAccessPromise = void 0;
        if ((0, _fp.isEmpty)(this.accessStore)) {
          initAccessPromise = this.initAccess();
        }

        if (initAccessPromise) {
          return initAccessPromise.then(function () {
            return validate.apply(_this10);
          });
        }
        return validate.apply(this);
      } else {
        return (0, _bluebird.resolve)({ success: true });
      }
    }

    /**
     * Validate Dashboard
     * @param {type} clonedModel
     */

  }, {
    key: 'validateDashboard',
    value: function validateDashboard(clonedModel) {
      var model = (0, _fp.isEmpty)(clonedModel) ? this.model : clonedModel;
      var dashboardDefinition = model.dashboardDetail.buildDataForSaving();

      return _Izenda2.default.validateDashboard(dashboardDefinition.dashboard);
    }

    /**
     * Load dashboard part data
     * @param {Object} dashboardPart
     * @param {Boolean} printingMode
     */

  }, {
    key: 'loadDashboardPart',
    value: function loadDashboardPart(dashboardPart, printingMode) {
      var _this11 = this;

      if (!dashboardPart.reportId) {
        return (0, _bluebird.resolve)();
      }

      var reportId = dashboardPart.reportId,
          reportPartId = dashboardPart.reportPartId;

      return this.associateReportDefToDashboardPart(dashboardPart, reportId, reportPartId, (0, _mobx.action)(function (reportDef, reportPartDef) {
        dashboardPart.readReportInfo(reportDef, reportPartDef);
      }), printingMode).then(function () {
        // when switching between configuration mode and view mode,
        // dashboardPart will be reloaded and removed all drillDown info.
        _this11.removeRelatedDrillDownInfo(dashboardPart);
        _this11.getReportPartData(dashboardPart, !dashboardPart.checkDirty(), null, null, null, printingMode);
      });
    }

    /**
     * Get allowed saving categories
     * @param {type} clonedModel
     */

  }, {
    key: 'getAllowedSavingCategories',
    value: function getAllowedSavingCategories(clonedModel) {
      return _Izenda2.default.getAllowedSavingCategories(this.tenantId).then(function (categories) {
        clonedModel.getAllCategory(categories);
      });
    }

    /**
     * Export report part on dashboard
     * @param  {string} url
     * @param  {string} format    export format
     * @param  {string} reportId  report id
     * @param  {array}  filters    report filters
     * @param  {string} dashboard part id
     * @param  {object} successCallBack
     * @param  {object} failCallBack
     * @return {Promise}
     */

  }, {
    key: 'associateReportDefToDashboardPart',


    /**
     * Load all neccessary report data (report definition, filters...) for
     * dashboard part and associate report def with current dashboard part.
     * @param [Object] Dashboard part
     * @param [String] Report id
     * @param [Boolean] Indicate that it should load actual report part data or preview data.
     * @param [Boolean] Indicate the current dashboard part should reset its dirty tracking
     * @param [associateReportDef] A callback that get report definition
     */
    value: function associateReportDefToDashboardPart(dashboardPart, reportId, reportPartId, associateReportDef, printingMode) {
      var _this12 = this;

      var reportFilter = this.dashboardFilterStore.reportFilter;

      return _Izenda4.default.validateReportId(reportId).then(function (reportStatus) {
        var reportIdForLoad = printingMode ? reportId : null;
        return (0, _bluebird.join)(_Izenda10.default.reportByProperty(reportId, _Izenda33.REPORT_PROPERTY.Filter).catch(function (error) {
          return error.responseJSON;
        }), _Izenda4.default.loadReportPartDefinition(reportPartId, reportIdForLoad), _this12.loadOperatorGroupPromise(), (0, _mobx.action)(function (reportDef, reportPartDef, operatorGroup) {
          if (!reportStatus.success && !(0, _fp.isNil)(reportDef)) {
            reportDef.detail = {
              message: (0, _fp.get)('messages[0].messages[0]', reportStatus)
            };
          }
          associateReportDef(reportDef, reportPartDef);
          dashboardPart.buildConfigFieldList(operatorGroup, reportFilter.markUpdateResult.bind(reportFilter));
          return null;
        }));
      });
    }

    /**
     * update renderingTime
     * @param {Number} renderingTime
     */

  }, {
    key: 'updateRenderingTime',
    value: function updateRenderingTime(renderingTime) {
      var dashboardId = this.model.dashboardDetail.dashboard.id;
      return _Izenda2.default.updateRenderingTime(dashboardId, renderingTime);
    }

    /**
     * resolve URL options params
     * @method readURLOptions
     * @param  {[type]}       query [description]
     * @return {[type]}             [description]
     */

  }, {
    key: 'readURLOptions',
    value: function readURLOptions(query) {
      this.printingMode = !!(0, _fp.getOr)(false, 'print', query);
      this.printingMode && (this.draftId = (0, _fp.getOr)(null, 'draftId', query));
    }

    /**
     * Update common filter
     * @param  {stirng} id
     * @return {Promise}
     */

  }, {
    key: 'updateCommonFilter',
    value: function updateCommonFilter(id) {
      var _this13 = this;

      return _Izenda2.default.getCommonFilterById(id).bind(this).then((0, _mobx.action)(function (result) {
        return _this13.model.dashboardDetail.updateCommonFilter(result);
      }));
    }

    /**
     * save draft dashboard definition and return draft id to build URL
     * @method saveDraftDataForPrint
     * @return {Promise}              [description]
     */

  }, {
    key: 'saveDraftDataForPrint',
    value: function saveDraftDataForPrint() {
      var dashboardDefinition = this.model.dashboardDetail.getDashboardDefinition();
      return _Izenda2.default.saveDraftDataForPrint(dashboardDefinition).get('id');
    }

    /**
     * Lazy load dashboard list
     * @param  {String} catId
     * @param  {Boolean} isReset
     * @return {Promise}
     */

  }, {
    key: 'lazyLoadingDashboards',
    value: function lazyLoadingDashboards(catId, isReset, isGlobal, pageInfo) {
      var _this14 = this;

      this.selectedCategoryId = catId;
      pageInfo = pageInfo || this.contentLazyLoadingStore.pageInfoForFirstTime;

      var dataObject = {
        tenantId: this.tenantId,
        isUncategorized: this.isUncategorized,
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        parentIds: pageInfo.parentIds,
        includeGlobalCategory: true,
        isGlobal: this.parseIsGlobalValue(isGlobal)
      };

      if (!this.isRootCategory && !this.isUncategorized) {
        dataObject.criterias = [{
          key: _Izenda16.default.CATEGORY_TYPE.CATEGORY_ID,
          value: this.selectedCategoryId
        }];
      }

      return _Izenda2.default.lazyLoadingDashboards(dataObject, true).bind(this).then((0, _mobx.action)(function (result) {
        return _this14.items.populate(result, isReset, _Izenda16.default.DASHBOARD_LIST_CONCAT_TREE_MAP);
      }));
    }

    /**
     * Lazy search dashboard list
     * @returns {Promise}
     */

  }, {
    key: 'lazyLoadingSearch',
    value: function lazyLoadingSearch(isGlobal, pageInfo) {
      var _this15 = this;

      var model = this.items;
      var isReset = (0, _fp.isNil)(pageInfo);
      pageInfo = pageInfo || this.contentLazyLoadingStore.pageInfoForFirstTime;
      var request = {
        criterias: [],
        isUncategorized: this.isUncategorized,
        sortCriteria: {
          key: model.sortBy,
          descending: model.sortDir === _Izenda16.default.SORT_TYPES.ASC ? false : true
        },
        tenantId: this.tenantId,
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        parentIds: pageInfo.parentIds,
        includeGlobalCategory: true,
        isGlobal: this.parseIsGlobalValue(isGlobal)
      };

      // handling criterias
      if (!this.isRootCategory && !(0, _fp.isNil)(this.selectedCategoryId)) {
        request.criterias.push({
          key: _Izenda16.default.CATEGORY_TYPE.CATEGORY_ID,
          value: this.selectedCategoryId
        });
      }

      (!(0, _fp.isNil)(model.searchType) || !(0, _fp.isNil)(model.searchText)) && request.criterias.push({
        key: model.searchType,
        value: model.searchText
      });

      return _Izenda2.default.lazyLoadingSearchCategories(request).bind(this).then(function (result) {
        return _this15.items.populate(result, isReset, _Izenda16.default.DASHBOARD_LIST_CONCAT_TREE_MAP);
      });
    }

    /**
     * Load all categories
     * @param  {Number} reportType
     * @return {array}
     */

  }, {
    key: 'loadLazyLoadingCategories',
    value: function loadLazyLoadingCategories(isReset, pageInfo) {
      var _this16 = this;

      pageInfo = pageInfo || this.leftMenuLazyLoadingStore.pageInfoForFirstTime;
      var param = {
        tenantId: this.tenantId,
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        parentIds: pageInfo.parentIds,
        includeGlobalCategory: true
      };

      // TODO: null report type on view mode.
      return _Izenda2.default.loadLazyLoadingCategories(param).bind(this).then((0, _mobx.action)(function (result) {
        var data = result.data;
        var categories = (0, _fp.map)(function (item) {
          var globalLocalCategory = new _Izenda36.default();
          globalLocalCategory.populateDataForGlobalLocalCategory(item);
          return globalLocalCategory;
        }, data);

        if (isReset) {
          _this16.model.leftMenuCategories.splice(0, _this16.model.leftMenuCategories.length);
        }

        if (!(0, _fp.isEmpty)(_this16.model.leftMenuCategories)) {
          _this16.model.leftMenuCategories.shift();
        }

        _this16.model.isLeftMenuLastPage = result.isLastPage;
        (0, _Izenda34.concatTree)(_this16.model.leftMenuCategories, categories, _Izenda16.default.LEFT_MENU_CONCAT_TREE_MAP, result.numOfChilds, []);

        _this16.model.leftMenuCategories.splice(0, 0, _this16.model.createAllItem());
        _this16.model.leftMenuCategoryTree = (0, _Izenda34.parseToTree)(_this16.model.leftMenuCategories, _Izenda16.default.LEFT_MENU_TREE_MAP);

        return (0, _bluebird.resolve)();
      }));
    }

    /**
     * Register content lazy loading store
     * @param {Object} lazyLoadingStore
     */

  }, {
    key: 'registerContentLazyLoadingStore',
    value: function registerContentLazyLoadingStore(lazyLoadingStore) {
      this.contentLazyLoadingStore = lazyLoadingStore;
    }

    /**
     * Register left menu lazyLoadingStore
     */

  }, {
    key: 'registerLeftMenuLazyLoadingStore',
    value: function registerLeftMenuLazyLoadingStore(lazyLoadingStore) {
      this.leftMenuLazyLoadingStore = lazyLoadingStore;
    }

    /**
     * Change global dashboard value
     * @param {boolean} value
     */

  }, {
    key: 'changeGlobalType',
    value: function changeGlobalType(value) {
      this.dashboardDetail.dashboard.isGlobal = value;
      this.dashboardDetail.markDirty();
    }

    /**
     * Validate global dashboard if it is containing any local report?
     */

  }, {
    key: 'validateGlobalDashboard',
    value: function validateGlobalDashboard(dashboardDefinition) {
      return _Izenda2.default.validateGlobalDashboard(dashboardDefinition);
    }

    /**
     * Parse IsGlobal Value
     * @param  {any} value
     * @return {any}
     */

  }, {
    key: 'parseIsGlobalValue',
    value: function parseIsGlobalValue(value) {
      switch (value) {
        case 'true':
          return true;
        case 'false':
          return false;
        case 'null':
          return null;
        case undefined:
          return null;
        default:
          return value;
      }
    }

    /**
     * clicked on remove Pill
     * @param pillDefinition: pill which is being removed.
     */

  }, {
    key: 'onRemovingPillHandler',
    value: function onRemovingPillHandler(pillDefinition) {
      var dashboardPart = (0, _fp.find)(function (dashboardPart) {
        return dashboardPart.id === pillDefinition.parentId;
      }, this.dashboardDetail.dashboard.dashboardParts);
      this.dashboardDetail.onClearDrillDown(dashboardPart);
      this.getReportPartData(dashboardPart, false, null, null, null, false);
      this.onDashboardPartDrillDown(dashboardPart);
      this.dashboardDetail.calculateCrossFilteringColors();
    }

    /**
     * Removing all pills, click removed all
     */

  }, {
    key: 'onRemovingAllPillHandler',
    value: function onRemovingAllPillHandler() {
      var _this17 = this;

      var reportIds = [];
      (0, _fp.forEach)(function (drillDownInfo) {
        reportIds = (0, _fp.concat)(reportIds, [drillDownInfo.dashboardPart.reportId]);
      }, this.dashboardDetail.dashboard.dashboarPartDrillDowns);
      reportIds = (0, _fp.uniq)(reportIds);

      this.dashboardDetail.removeAllDrillDowns();
      this.dashboardDetail.removeAllCrossFilterings();

      var activeDashboardParts = (0, _fp.get)('dashboard.activeDashboardParts', this.dashboardDetail);

      (0, _fp.forEach)(function (reportId) {
        (0, _fp.flow)((0, _fp.filter)(function (dashboardPart) {
          return dashboardPart.reportId === reportId;
        }), (0, _fp.forEach)(function (dashboardPart) {
          _this17.dashboardDetail.onClearDrillDown(dashboardPart);
          _this17.getReportPartData(dashboardPart, false, null, null, null, false);
        }))(activeDashboardParts);
      }, reportIds);
    }

    /**
     * action when drilldown in dashboard part.
     * @param: dashboardPart: dirilling down dashboard part.
     */

  }, {
    key: 'onDashboardPartDrillDown',
    value: function onDashboardPartDrillDown(dashboardPart) {
      if (!this.dashboardDetail.isCrossFiltering(dashboardPart) || !this.dashboardDetail.isAllowedCrossFiltering(dashboardPart)) {
        return;
      }
      this.dashboardDetail.updateDrillDownCollection(dashboardPart);
      this.reloadRelatedCrossFilteringDashboardParts(dashboardPart);
      this.processDashboardPartIsLoading(dashboardPart.id);
      this.dashboardDetail.onDrillDownUpdatePill(dashboardPart);
      this.dashboardDetail.calculateCrossFilteringColors();
    }

    /**
     * Process for the dashboard part is loading
     * @param {String} id
     */

  }, {
    key: 'processDashboardPartIsLoading',
    value: function processDashboardPartIsLoading(id) {
      var _this18 = this;

      var pendingWorkerList = this.dashboardWorkerPendingList;
      (0, _fp.flow)((0, _fp.find)(function (partId) {
        return (0, _fp.includes)(id, partId);
      }), (0, _fp.filter)(function (partId) {
        return partId !== id;
      }), (0, _fp.map)(function (partId) {
        return (0, _fp.find)(function (workerPending) {
          return workerPending.dashboardPart.id === partId;
        }, pendingWorkerList);
      }), (0, _fp.filter)(function (pendingWorker) {
        return !(0, _fp.isNil)(pendingWorker);
      }), (0, _fp.forEach)(function (loadingPart) {
        loadingPart.worker.terminate();
        _this18.createDashboardPartWorker(loadingPart.dashboardPart, loadingPart.index);
      }))(this.relatedDashboardPartIds);
    }

    /**
     * after deleting dashboard part.
     * do some logic to remove cross Filtering, remove related Pill, reload data.
     * @param dashboardPart, dashboard tile which is removing related drilldown.
     */

  }, {
    key: 'removeRelatedDrillDownInfo',
    value: function removeRelatedDrillDownInfo(dashboardPart) {
      if (!this.dashboardDetail.isCrossFiltering(dashboardPart)) {
        return;
      }
      var relatedDrillDown = this.dashboardDetail.getRelatedDrillDown(dashboardPart);
      if (relatedDrillDown) {
        // remove related drill down if any.
        this.dashboardDetail.removeDrillDownInCollection(dashboardPart);
        // remove it own pill
        this.dashboardDetail.removePill((0, _fp.get)('report.id', dashboardPart), (0, _fp.get)('id', dashboardPart));
        // reload all related dashboardParts
        this.reloadRelatedCrossFilteringDashboardParts(dashboardPart);
        this.dashboardDetail.calculateCrossFilteringColors();
      }
    }

    /**
     * Get all related Cross Filtering Dashboard, then do reload data for each DashboardPart. except the currentDashboardParts.
     * @param: dashboardPart, dashboard tile which's related dashboard parts need to be reloaded.
     */

  }, {
    key: 'reloadRelatedCrossFilteringDashboardParts',
    value: function reloadRelatedCrossFilteringDashboardParts(dashboardPart) {
      var _this19 = this;

      var relatedDashboardParts = this.dashboardDetail.getRelatedCrossFilteringDashboardParts(dashboardPart);
      !(0, _fp.isEmpty)(relatedDashboardParts) && (0, _fp.forEach)(function (dashboardPart) {
        _this19.getReportPartData(dashboardPart, false, null, null, null, false);
      }, relatedDashboardParts);
    }

    /**
     * Start to load dashboard data worker
     * @param {Number} start
     */

  }, {
    key: 'startDashboardDataWorker',
    value: function startDashboardDataWorker(start) {
      var parts = (0, _fp.filter)(function (dashboardPart) {
        return !(0, _fp.isNil)(dashboardPart.reportId);
      }, this.dashboardDetail.dashboard.activeDashboardParts);
      var end = start + _Izenda44.default.WORKER_CHUNK;
      for (var i = start; i < end && i < parts.length; i++) {
        this.createDashboardPartWorker(parts[i], i);
      }
    }

    /**
     * Create dashboard part worker
     * @param {Object} dashboardPart
     * @param {Number} index
     * @param {Boolean} printingMode
     */

  }, {
    key: 'createDashboardPartWorker',
    value: function createDashboardPartWorker(dashboardPart, index, printingMode) {
      if (typeof Worker !== 'undefined') {
        var dashboardWorker = new _IzendaDashboardWorker2.default();
        dashboardWorker.onmessage = this.getDashboardPartData.bind(this, dashboardWorker, index);
        dashboardWorker.postMessage(getPostData.apply(this));

        // Add dashboard worker list which is used for drilldown
        this.dashboardWorkerPendingList.push({
          dashboardPart: dashboardPart,
          worker: dashboardWorker,
          index: index
        });
      }

      function getPostData() {
        var crossFiltering = this.dashboardDetail.getCrossFilteringForDashboardPart(dashboardPart, true);

        return {
          type: 'DASHBOARD_PART',
          dashboardPart: JSON.parse((0, _stringify2.default)(dashboardPart)),
          reportId: dashboardPart.reportId,
          reportPartId: dashboardPart.reportPartId,
          reportIdForLoad: printingMode ? dashboardPart.reportId : null,
          printingMode: printingMode,
          apiInfo: (0, _Izenda42.getApiInfo)(),
          filters: (0, _fp.isEmpty)(crossFiltering) ? [] : crossFiltering
        };
      }
    }

    /**
     * Get dashboard part data
     * @param {Object} dashboardWorker
     * @param {Number} index
     * @param {Object} event
     */

  }, {
    key: 'getDashboardPartData',
    value: function getDashboardPartData(dashboardWorker, index, event) {
      var _event$data = event.data,
          id = _event$data.id,
          reportDef = _event$data.reportDef,
          reportPartDef = _event$data.reportPartDef,
          dashboardPartData = _event$data.dashboardPartData,
          embeddedReports = _event$data.embeddedReports,
          messages = _event$data.messages,
          isSuccess = _event$data.isSuccess;

      // Remove pending dashboard worker in list

      this.dashboardWorkerPendingList.splice((0, _fp.findIndex)(function (dashboardWorker) {
        return dashboardWorker.dashboardPart.id === id;
      }, this.dashboardWorkerPendingList), 1);

      var part = (0, _fp.find)({ id: id }, this.dashboardDetail.dashboard.activeDashboardParts);
      if (isSuccess === false) {
        // Messages level : Just 1 message required for now
        var mesgText = _Izenda28.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_INVALID_REPORT');
        var messageKey = null;
        if (!(0, _fp.isNil)(messages) && (0, _fp.isArray)(messages) && !(0, _fp.isEmpty)(messages)) {
          var _head = (0, _fp.head)(messages),
              msg = _head.messages,
              key = _head.key;

          if (!(0, _fp.isEmpty)(key)) {
            mesgText = (0, _fp.head)(msg);
            messageKey = key;
          }
        }

        reportDef = {
          detail: {
            message: mesgText,
            messageKey: messageKey
          }
        };
        part.readReportInfo(reportDef);
      } else {
        var reportFilter = this.dashboardFilterStore.reportFilter;


        part.readReportInfo(reportDef, reportPartDef);
        this.loadOperatorGroupPromise().then(function (operatorGroup) {
          part.buildConfigFieldList(operatorGroup, reportFilter.markUpdateResult.bind(reportFilter));
        });

        part.reportPart.startLoadData();
        part.reportPart.colorPalettes = this.colorPalettes;
        this.removeRelatedDrillDownInfo(part);

        part.reportPart.setQueryData(dashboardPartData);
        this.getEmbeddedReports(part, embeddedReports);
      }

      // Start other worker
      (index + 1) % _Izenda44.default.WORKER_CHUNK === 0 && this.startDashboardDataWorker(index + 1);

      // Terminate worker after complete its task.
      dashboardWorker.terminate();
    }

    /**
     * Get embedded reports
     * @param {Object} dashboardPart
     * @param {Array} embeddedReports
     */

  }, {
    key: 'getEmbeddedReports',
    value: function getEmbeddedReports(dashboardPart, embeddedReports) {
      var embededReportDef = {
        reportParts: (0, _fp.reduce)(function (acc, item) {
          return (0, _fp.set)(item.id, item, acc);
        }, {}, (0, _fp.compact)(embeddedReports.reportParts)),
        reports: (0, _fp.reduce)(function (acc, item) {
          var report = item;
          return (0, _fp.set)(report.id, report.reportPart, acc);
        }, {}, (0, _fp.compact)(embeddedReports.reports))
      };

      var reportPart = dashboardPart.reportPart,
          disableViewReport = dashboardPart.disableViewReport;

      if ((0, _fp.isNil)(reportPart) || disableViewReport) {
        return;
      }

      reportPart.readEmbededReportDef(embededReportDef);
    }

    /**
     * Get api terminateAllWorker
     */

  }, {
    key: 'terminateAllWorker',
    value: function terminateAllWorker() {
      (0, _fp.forEach)(function (dashboardItem) {
        dashboardItem.worker.terminate();
      }, this.dashboardWorkerPendingList);

      this.dashboardWorkerPendingList = [];
      this.relatedDashboardPartIds = [];
    }

    /**
     * export dashboard
     * @param  {string} dashboardId  dashboard id
     * @param  {string} format
     * @param  {any} successCallBack
     * @param  {any} failCallBack
     * @return {Promise}
     */

  }, {
    key: 'exportDashboard',
    value: function exportDashboard(dashboardId, format, successCallBack, failCallBack) {
      return _Izenda8.default.export({
        dashboardId: dashboardId,
        format: format,
        tenantId: _Izenda14.default.tenantId
      }, successCallBack, failCallBack);
    }

    /**
     * Print dashboard
     * @param {String} dashboardId
     * @param {String} format
     * @param {Object} successCallBack
     * @param {Object} failCallBack
     * @return {Promise}
     */

  }, {
    key: 'printDashboard',
    value: function printDashboard(dashboardId, format, successCallBack, failCallBack) {
      return _Izenda8.default.export({
        dashboardId: dashboardId,
        format: format,
        tenantId: _Izenda14.default.tenantId
      }).then(function (data) {
        successCallBack();
        _Izenda46.default.printHtml(data);
      }, failCallBack);
    }

    /**
     * Set color palettes
     * @param {Array} palettes
     */

  }, {
    key: 'setColorPalettes',
    value: function setColorPalettes(palettes) {
      (0, _fp.isEmpty)(this.colorPalettes) && (this.colorPalettes = palettes);
    }

    /**
     * Load operator group promise builder
     */

  }, {
    key: 'categoryTree',
    get: function get() {
      return this.model.categoryTree;
    }
  }, {
    key: 'dashboardDetail',
    get: function get() {
      return this.model.dashboardDetail;
    }
  }, {
    key: 'dashboardDesignerMode',
    get: function get() {
      return this.model.dashboardDesignerMode;
    }
  }, {
    key: 'items',
    get: function get() {
      return this.model.items;
    }
  }, {
    key: 'tenantId',
    get: function get() {
      return _Izenda14.default.getTenantId();
    }
  }, {
    key: 'isRootCategory',
    get: function get() {
      return this.selectedCategoryId === _Izenda16.default.ALL_CATEGORY_TYPES.ALL_DASHBOARDS.id;
    }
  }, {
    key: 'isUncategorized',
    get: function get() {
      return this.selectedCategoryId === _Izenda16.default.EMPTY_GUID;
    }
  }, {
    key: 'isDirty',
    get: function get() {
      return this.dashboardDetail.checkDirty() || this.subscribedInstancesStore.model.checkDirty() || this.dashboardFilterStore.reportFilter.checkDirty();
    }

    /**
     * initial dashboard
     * @method initial
     * @return {[type]} [description]
     */

  }]);
  return DashboardStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'selectedCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'dashboardFilterStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'subscribedInstancesStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'accessStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'categoryTree', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'categoryTree'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'dashboardDetail', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'dashboardDetail'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'dashboardDesignerMode', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'dashboardDesignerMode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'items', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'items'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tenantId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isRootCategory', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isRootCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isUncategorized', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isUncategorized'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initial', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initial'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'destroy', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'destroy'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createNewDashboard', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createNewDashboard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setDashboardTileType', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setDashboardTileType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'mapCommonFilterValueToDashboardPartFilter', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'mapCommonFilterValueToDashboardPartFilter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveDashboard', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveDashboard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadDashboard', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadDashboard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadDashboards', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadDashboards'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteDashboardPart', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteDashboardPart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeDashboard', [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'removeDashboard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readDashboardDefinition', [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readDashboardDefinition'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'copyDashboardPart', [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'copyDashboardPart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cancelDashboard', [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cancelDashboard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validateBackgroundImage', [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validateBackgroundImage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initSubscription', [_dec15], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initSubscription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initAccess', [_dec16], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initAccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadDashboardPart', [_dec17], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadDashboardPart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'associateReportDefToDashboardPart', [_dec18], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'associateReportDefToDashboardPart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'lazyLoadingDashboards', [_dec19], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'lazyLoadingDashboards'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadLazyLoadingCategories', [_dec20], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadLazyLoadingCategories'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeGlobalType', [_dec21], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeGlobalType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onRemovingPillHandler', [_dec22], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onRemovingPillHandler'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onRemovingAllPillHandler', [_dec23], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onRemovingAllPillHandler'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onDashboardPartDrillDown', [_dec24], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDashboardPartDrillDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeRelatedDrillDownInfo', [_dec25], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'removeRelatedDrillDownInfo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reloadRelatedCrossFilteringDashboardParts', [_dec26], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reloadRelatedCrossFilteringDashboardParts'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'startDashboardDataWorker', [_dec27], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'startDashboardDataWorker'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getDashboardPartData', [_dec28], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getDashboardPartData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'terminateAllWorker', [_dec29], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'terminateAllWorker'), _class.prototype)), _class));
exports.default = DashboardStore;
module.exports = exports['default'];

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var fetcher = __webpack_require__(75);
  var SettingLevel = __webpack_require__(2557);
  var uiState = __webpack_require__(15);
  var m = __webpack_require__(5);

  var ContextMenuStore = __webpack_require__(1141);
  var LicenseCheckerStore = __webpack_require__(2558);
  var DataModelStore = __webpack_require__(2561);
  var AdvancedSettingsStore = __webpack_require__(2564);
  var TenantManagementStore = __webpack_require__(2565);
  var SchedulingSearchStore = __webpack_require__(2567);
  var EmailConfigurationStore = __webpack_require__(2572);
  var ReportConfigurationStore = __webpack_require__(2574);
  var systemSettingFetcher = __webpack_require__(75);

  var disablePages = ['setupAndLicense', 'tenantManagement', 'copyManagement', 'securityPolicies', 'databaseMapping'];
  var onlyShowTenant = [];

  var _require = __webpack_require__(1),
      forEach = _require.forEach,
      invoke = _require.invoke;

  function SettingsStore() {
    this.settingLevel = new SettingLevel();

    this.contextMenu = new ContextMenuStore();
    this.licenseChecker = new LicenseCheckerStore();
    this.dataModel = new DataModelStore();
    this.advanceSettings = new AdvancedSettingsStore();
    this.tenantManagement = new TenantManagementStore();
    this.schedulingSearch = new SchedulingSearchStore();
    this.emailConfiguration = new EmailConfigurationStore();
    this.reportConfiguration = new ReportConfigurationStore();

    var instances = [this.contextMenu, this.licenseChecker, this.dataModel, this.advanceSettings, this.tenantManagement, this.schedulingSearch, this.emailConfiguration, this.reportConfiguration];

    forEach(invoke('init'), instances);
  }

  /**
   * Load Setting Level
   */
  SettingsStore.prototype.loadSettingLevel = m.action(function () {
    fetcher.getSystemMode().then(function (systemMode) {
      this.settingLevel.loadInitial(systemMode);
      !systemMode && this.loadTenants();
    }.bind(this));
  });

  /**
   * Load tenants
   */
  SettingsStore.prototype.loadTenants = function (shouldLoadDefaultTenant) {
    return fetcher.getTenants().then(this.settingLevel.readTenants.bind(this.settingLevel, shouldLoadDefaultTenant));
  };

  /**
   * Change system mode
   */
  SettingsStore.prototype.changeSystemMode = m.action(function (change) {
    return change.value === 'Tenant' ? this.loadTenants(true) : this.settingLevel.setSelectedTenant(null);
  });

  SettingsStore.prototype.onlyShowTenant = m.action(function (change) {
    uiState.onlyShowTenant = change;
    if (change) {
      uiState.enableSystemSetting(change);
      !uiState.tenantId && this.loadTenants(true);
    }
  });

  SettingsStore.prototype.checkSettingLevel = m.action(function (newLink) {
    newLink = newLink || this.contextMenu.contextMenuActiveLink;
    uiState.setDisableSettingLevel(disablePages.indexOf(newLink) > -1);
    this.onlyShowTenant(onlyShowTenant.indexOf(newLink) > -1);
  });

  /**
   * Check if database had already setup
   * @returns {type}
   */
  SettingsStore.prototype.checkDatabaseSetup = function () {
    return systemSettingFetcher.databaseSetup();
  };

  SettingsStore.prototype.destroy = function () {
    var instances = [this.contextMenu, this.licenseChecker, this.dataModel, this.advanceSettings, this.tenantManagement, this.schedulingSearch, this.emailConfiguration, this.reportConfiguration];

    forEach(invoke('destroy'), instances);
  };

  module.exports = SettingsStore;
}();

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.QueryStringUtil.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

// Based on query-string of react-router idea with enhances.

/**
 * Parse a query string into an object.
 * @param {string} str
 */
var parseQuery = function parseQuery(queryString) {
  if (typeof queryString !== 'string') {
    return {};
  }
  queryString = queryString.trim().replace(/^(\?|#|&)/, '');
  if (!queryString) {
    return {};
  }
  return queryString.split('&').reduce(function (result, param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    // Firefox (pre 40) decodes `%3D` to `=`
    // https://github.com/sindresorhus/query-string/pull/37
    var key = parts.shift();
    var val = parts.length > 0 ? parts.join('=') : undefined;
    key = decodeURIComponent(key);
    // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
    val = val === undefined ? null : decodeURIComponent(val);
    if (!result.hasOwnProperty(key)) {
      result[key] = val;
    } else if (Array.isArray(result[key])) {
      result[key].push(val);
    } else {
      result[key] = [result[key], val];
    }
    return result;
  }, {});
};

/**
 * Merge query objects
 * @param {Array<string|Object>} queries
 */
var mergeQuery = function mergeQuery() {
  for (var _len = arguments.length, queries = Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }

  return queries.reduce(function (result, query) {
    var queryObj = query;
    if (typeof query === 'string') {
      queryObj = parseQuery(query);
    }
    return (0, _assign2.default)(result, queryObj);
  }, {});
};

/**
 * Get value of a key in query
 * @param {string|Object} query
 * @param {string} key
 */
var getValueByKey = function getValueByKey(query, key) {
  var queryObj = query || {};
  if (typeof query === 'string') {
    queryObj = parseQuery(query);
  }
  return queryObj[key];
};

exports.default = {
  mergeQuery: mergeQuery,
  getValueByKey: getValueByKey
};
module.exports = exports['default'];

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SubscriptionGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportSubscriptionGrid component
 */


var _mobxReact = __webpack_require__(10);

var _mobxReact2 = _interopRequireDefault(_mobxReact);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(68);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(146);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(44);

var _Izenda8 = __webpack_require__(30);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(97);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(17);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(229);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(58);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(13);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(1162);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda22 = __webpack_require__(15);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(133);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubscriptionGrid = (_dec = (0, _Izenda2.default)({ toClass: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SubscriptionGrid, _Component);

  function SubscriptionGrid() {
    (0, _classCallCheck3.default)(this, SubscriptionGrid);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SubscriptionGrid.__proto__ || (0, _getPrototypeOf2.default)(SubscriptionGrid)).call(this));

    _this.onSortChange = function () {
      var _this$props = _this.props,
          store = _this$props.store,
          model = _this$props.store.model,
          confirmDirtyForm = _this$props.confirmDirtyForm;

      confirmDirtyForm(model.checkDirty()).then(function () {
        store.onSortChange();
      });
    };

    _this.renderTextCell = function (data, key, rowIndex, column) {
      switch (key) {
        case 'recipients':
          return _this.renderSeparatedLine(data[key], ';');
        case 'filterValueSelection':
          return _this.renderSeparatedLine(data[key], ';#');
        default:
          return _react2.default.createElement(_Izenda4.default, { tooltip: data[key], text: data[key] });
      }
    };

    _this.renderAction = function (data, key, rowIndex, column) {
      var _this$props2 = _this.props,
          store = _this$props2.store,
          _this$props2$pageCons = _this$props2.pageConstants,
          pageText = _this$props2$pageCons.PAGE_TEXT,
          MESSAGE = _this$props2$pageCons.MESSAGE,
          onCopy = _this$props2.onCopy,
          onSyncSubscription = _this$props2.onSyncSubscription,
          doesSaveToDB = _this$props2.doesSaveToDB,
          confirmFn = _this$props2.confirmFn,
          onDelete = _this$props2.onDelete;


      var onCopySetting = function onCopySetting() {
        if (!(0, _fp.isNil)(onCopy)) {
          onCopy(data.id);
        } else {
          store.copySubscribedInstance(data.id);
          onSyncSubscription && onSyncSubscription(store.model.subscribedInstances);
          doesSaveToDB && _this.onClickSave();
        }
      };

      var onDeleteSetting = function onDeleteSetting(e) {
        confirmFn('Confirmation', {
          description: MESSAGE.M01a
        }).then(function () {
          if (!(0, _fp.isNil)(onDelete)) {
            onDelete([data.id]);
          } else {
            store.removeSubscribedInstances([data.id]);
            onSyncSubscription && onSyncSubscription(store.model.subscribedInstances);
            doesSaveToDB && _this.onClickSave();
          }
        });
      };

      var onClickEdit = function onClickEdit(e) {
        data.updateDataForEditMode({
          emailTemplates: store.model.emailTemplates,
          state: (0, _fp.isNil)(data.id) || data.id.indexOf('newInstance_') >= 0 ? _Izenda17.default.INSERT : _Izenda17.default.UPDATE,
          isSubscription: store.model.isSubscriptionMode
        });
        _this.showSubscriptionPopup(data);
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', { title: pageText.EditText, className: 'icon-pencil', onClick: onClickEdit, value: data })
        ),
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', { title: pageText.CopyText, className: 'icon-copy', onClick: onCopySetting, value: data })
        ),
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', { title: pageText.DeleteText, className: 'icon-cancel', onClick: onDeleteSetting, value: rowIndex })
        )
      );
    };

    _this.getSelectedInstanceIds = function () {
      var store = _this.props.store || {};
      var ids = (0, _fp.placeholder)(store.activeInstances).chain().filter(function (item) {
        return item.selectedValue;
      }).map(function (i) {
        return i.id;
      }).value();

      return ids;
    };

    _this.onClickDelete = function (e) {
      var _this$props3 = _this.props,
          store = _this$props3.store,
          confirmFn = _this$props3.confirmFn,
          pageConstants = _this$props3.pageConstants,
          onSyncSubscription = _this$props3.onSyncSubscription,
          doesSaveToDB = _this$props3.doesSaveToDB,
          onDelete = _this$props3.onDelete;


      confirmFn('Confirmation', {
        description: pageConstants.MESSAGE.M01b
      }).then(function () {
        var ids = _this.getSelectedInstanceIds();
        if (!(0, _fp.isNil)(onDelete)) {
          onDelete(ids);
        } else {
          store.removeSubscribedInstances(ids);
          onSyncSubscription && onSyncSubscription(store.model.subscribedInstances);
          doesSaveToDB && _this.onClickSave();
        }
      });
    };

    _this.onClickAdd = function () {
      var _this$props4 = _this.props,
          store = _this$props4.store,
          confirmMessage = _this$props4.confirmMessage;

      if (store.reportId && (0, _fp.isNil)(_Izenda23.default.currentUser.emailAddress)) {
        return confirmMessage('error', _Izenda25.default.MESSAGE.M04);
      }
      var subscriptionDetails = new _Izenda15.default({
        dashboardId: store.dashboardId,
        reportId: store.reportId,
        state: _Izenda17.default.INSERT,
        isSubscription: store.model.isSubscriptionMode
      }, store.model.emailTemplates);

      var subData = subscriptionDetails.init();
      _this.showSubscriptionPopup(subData);
    };

    _this.showSubscriptionPopup = function (data) {
      var _this$props5 = _this.props,
          store = _this$props5.store,
          openPopup = _this$props5.openPopup,
          reportState = _this$props5.reportState,
          onSavePopupDesigner = _this$props5.onSavePopupDesigner,
          dashboardDetail = _this$props5.dashboardDetail,
          updateCascadingFilterValue = _this$props5.updateCascadingFilterValue;

      var model = store.model;
      return openPopup(_Izenda21.default, {
        reportState: reportState,
        data: data,
        onSave: onSavePopupDesigner,
        onCheckDuplicateInstanceName: model.checkDuplicateInstanceName.bind(model),
        onValidateSubscription: store.validateSubscription.bind(store),
        dashboardDetail: dashboardDetail,
        store: store,
        updateCascadingFilterValue: updateCascadingFilterValue
      });
    };

    _this.checkAll = function (value) {
      _this.props.store.model.selectAll(value);
    };

    _this.beforeClosing = function (valManager, btnType) {
      var store = _this.props.store || {};
      if (btnType === 'cancel') {
        return _this.props.confirmDirtyForm(store.model.checkDirty() === true).then(function () {
          return true;
        });
      } else {
        return true;
      }
    };

    _this.onClickClose = function () {
      var props = _this.props;
      var store = props.store || {};
      var isDirty = store.model.checkDirty();

      var close = function close() {
        props.onClose && props.onClose();
      };

      if (isDirty) {
        props.confirmDirtyForm(isDirty).then(function () {
          close();
        });
      } else {
        close();
      }
    };

    _this.onClickSave = function () {
      _this.props.onSave && _this.props.onSave();
    };

    _this.renderTable = function () {
      var _this$props6 = _this.props,
          store = _this$props6.store,
          tableDef = _this$props6.pageConstants.TABLE_DEF;

      var model = store.model || {};
      var pageInfo = model.pageInfo || {};
      var data = model.activeInstances || [];

      var checkBoxSelectAllProps = {
        checked: model.hasAllActiveInstancesSelected,
        onChange: (0, _EventUtils.notifyChange)(_this.checkAll, _EventUtils2.default.CHECKBOX),
        type: 'checkbox'
      };

      var selectRowDefinition = (0, _fp.merge)(tableDef['selectedValue'], {
        headerComponent: _Izenda13.default,
        headerComponentProps: checkBoxSelectAllProps
      }, {});

      /**
       * Render columns component
       */
      var renderColumns = function renderColumns() {
        return (0, _fp.map)(function (item) {
          switch (item.key) {
            case 'selectedValue':
              return _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, selectRowDefinition, { cell: _this.renderSelectCell }));
            case 'action':
              return _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, item, { cell: _this.renderAction }));
            default:
              return _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, item, { cell: _this.renderTextCell }));
          }
        }, (0, _fp.values)(tableDef));
      };

      return _react2.default.createElement(
        _Izenda7.Table,
        { dataSource: data, onSortChange: _this.onSortChange, draggableTable: false, sortInfo: pageInfo.colSortDirs },
        renderColumns()
      );
    };

    _this.updateSearchCriteria = function () {
      var _store$updateSearchCr;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var store = _this.props.store || {};
      return (_store$updateSearchCr = store.updateSearchCriteria).call.apply(_store$updateSearchCr, [store].concat(args));
    };

    _this.onSearch = function () {
      var _store$search;

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = _this.props.store || {};
      return (_store$search = store.search).call.apply(_store$search, [store].concat(args));
    };

    _this.goToPage = function () {
      var _store$goToPage;

      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      var store = _this.props.store || {};
      return (_store$goToPage = store.goToPage).call.apply(_store$goToPage, [store].concat(args));
    };

    _this.onPageSizeChange = function () {
      var _store$onPageSizeChan;

      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      var store = _this.props.store || {};
      return (_store$onPageSizeChan = store.onPageSizeChange).call.apply(_store$onPageSizeChan, [store].concat(args));
    };

    _this.onDataGridSearchSizeChange = function (isMinState) {
      _this.setState({
        isDataSearchMinSize: isMinState
      });
    };

    _this.state = {
      isDataSearchMinSize: _Izenda23.default.isMobile
    };
    return _this;
  }

  /**
   * Handle when sort grid
   */


  (0, _createClass3.default)(SubscriptionGrid, [{
    key: 'renderSelectCell',
    value: function renderSelectCell(data, key, rowIndex, column) {
      var onChange = function onChange(value) {
        data.updateSelectedValue(value);
      };

      return _react2.default.createElement('input', {
        type: 'checkbox',
        value: data[key],
        checked: data[key],
        onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils2.default.CHECKBOX)
      });
    }

    /**
     * Show subscription popup.
     */

  }, {
    key: 'renderSeparatedLine',


    /**
     * Render recipients
     */
    value: function renderSeparatedLine(data, separator) {
      if (data) {
        return (0, _fp.map)(function (item) {
          return _react2.default.createElement(_Izenda4.default, { tooltip: item, text: item });
        }, (0, _fp.split)(separator, data));
      }
    }

    /**
     * Render table component
     */


    /**
     * Update search detail
     */


    /**
     * Handle search
     */


    /**
     * Handle change page
     */


    /**
     * Handle change page size
     */

  }, {
    key: 'render',


    /**
     * Render component
     */
    value: function render() {
      var props = this.props;
      var isDashboardMode = props.isDashboardMode,
          pageConstants = props.pageConstants,
          localization = props.localization,
          onSearch = props.onSearch,
          isPopupMode = props.isPopupMode;

      var store = props.store || {};
      var model = store.model || {};
      var pageInfo = model.pageInfo || {};

      var pageText = pageConstants.PAGE_TEXT;
      var searchOptions = pageConstants.SEARCH_OPTION;
      var currentPageSize = (0, _fp.getOr)(0, 'length', model.activeInstances);

      var isDataSearchMinSize = this.state.isDataSearchMinSize;
      var widthOnMobile = isDataSearchMinSize ? 1 : 12;
      var isVisible = isDataSearchMinSize || !_Izenda23.default.isMobile;
      var buttonContainerClass = (0, _classnames2.default)('u_textRight', {
        'hidden-xs': !isVisible
      });
      return _react2.default.createElement(
        _Izenda19.default,
        { className: 'subscription-grid' },
        _react2.default.createElement(
          _Izenda19.default.Row,
          null,
          _react2.default.createElement(
            _Izenda19.default.Col,
            { cols: '8', xs: widthOnMobile },
            _react2.default.createElement(_Izenda6.default, {
              options: searchOptions,
              value: model.pageInfo.searchProperty,
              onSearch: onSearch || this.onSearch,
              onSizeStateChange: this.onDataGridSearchSizeChange,
              responsive: true,
              onSearchPropertiesChange: this.updateSearchCriteria
            })
          ),
          !isPopupMode && _react2.default.createElement(
            _Izenda19.default.Col,
            { cols: '4', xs: '11', className: buttonContainerClass },
            _react2.default.createElement(
              'div',
              { className: 'izenda-ActionBarRight' },
              _react2.default.createElement(_Izenda9.default, { label: pageText.AddText, onClick: this.onClickAdd }),
              isDashboardMode && _react2.default.createElement(_Izenda9.default, { label: localization.getText('COMMON_LABEL_CLOSE'), onClick: this.onClickClose }),
              _react2.default.createElement(_Izenda9.default, {
                className: 'icon-trash-empty',
                disabled: !model.hasActiveInstancesSelected,
                onClick: this.onClickDelete
              })
            )
          )
        ),
        this.renderTable(),
        _react2.default.createElement(
          'div',
          { className: 'table-footer' },
          _react2.default.createElement(_Izenda11.default, {
            onChange: this.goToPage,
            onDropdownChange: this.onPageSizeChange,
            pageInfo: pageInfo,
            currentPageSize: currentPageSize,
            isDirty: model.checkDirty
          }),
          isPopupMode && _react2.default.createElement(
            'div',
            { className: 'text-right' },
            _react2.default.createElement(_Izenda9.default, { label: pageText.AddText, onClick: this.onClickAdd }),
            _react2.default.createElement(_Izenda9.default, {
              className: 'icon-trash-empty',
              disabled: !model.hasActiveInstancesSelected,
              onClick: this.onClickDelete
            })
          )
        )
      );
    }
  }]);
  return SubscriptionGrid;
}(_react.Component), _class2.displayName = 'SubscriptionGrid', _class2.propTypes = {
  isPopupMode: _react.PropTypes.bool,
  store: _react.PropTypes.object,
  pageConstants: _react.PropTypes.object.isRequired,
  onSearch: _react.PropTypes.func,
  onDelete: _react.PropTypes.func,
  onCopy: _react.PropTypes.func,
  onSavePopupDesigner: _react.PropTypes.func.isRequired,
  onSyncSubscription: _react.PropTypes.func
}, _temp)) || _class);
exports.default = SubscriptionGrid;
module.exports = exports['default'];

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTile.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobxReact = __webpack_require__(10);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda3 = __webpack_require__(413);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(179);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2723);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(1216);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2734);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tileLoader = {};

var DashboardTile = (_dec = (0, _Izenda8.default)({
  context: {
    childContextTypes: _Izenda6.default.loaderShape,
    getChildContext: function getChildContext(props) {
      var dashboardPart = props.dashboardPart;
      if (!tileLoader[dashboardPart.id]) {
        tileLoader[dashboardPart.id] = _Izenda6.default.createLoaderContext();
      }
      return tileLoader[dashboardPart.id];
    }
  }
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DashboardTile, _Component);

  function DashboardTile() {
    (0, _classCallCheck3.default)(this, DashboardTile);
    return (0, _possibleConstructorReturn3.default)(this, (DashboardTile.__proto__ || (0, _getPrototypeOf2.default)(DashboardTile)).apply(this, arguments));
  }

  (0, _createClass3.default)(DashboardTile, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var localization = props.localization,
          _props$dashboardDetai = props.dashboardDetail,
          dashboardDetail = _props$dashboardDetai === undefined ? {} : _props$dashboardDetai,
          dashboardPart = props.dashboardPart,
          fullScreen = props.fullScreen,
          viewMode = props.viewMode,
          store = props.store,
          printingMode = props.printingMode,
          editDashboard = props.editDashboard;
      var type = dashboardPart.type,
          disableViewReport = dashboardPart.disableViewReport,
          disableViewReportMessage = dashboardPart.disableViewReportMessage,
          filterRequired = dashboardPart.filterRequired;

      var dashboard = (0, _fp.getOr)({}, 'dashboard', dashboardDetail);
      var accessPriority = dashboard.accessPriority;

      if ((0, _fp.isNil)(type) && _Izenda2.default.isMobile) return null;

      var header = !fullScreen && !printingMode && _react2.default.createElement(_Izenda14.default, {
        editDashboard: editDashboard,
        store: store,
        dashboardPart: dashboardPart,
        dashboardDetail: dashboardDetail,
        viewMode: viewMode,
        presentationMode: props.presentationMode
      });

      var bodyClass = (0, _classnames2.default)('u_fullSize izenda-DashboardTile-Content-Body', {
        u_paddingAll: !viewMode,
        u_paddingLeftRight: viewMode,
        'izenda-DashboardTile-Content-Body-fixed': viewMode && !store.dashboardDesignerMode.isFullscreen,
        u_table: disableViewReport
      });

      var tileBody = _react2.default.createElement(
        'div',
        { className: 'u_fullSize ' },
        _react2.default.createElement(
          'div',
          { className: bodyClass },
          !disableViewReport ? _react2.default.createElement(_Izenda12.default, {
            filterRequired: filterRequired,
            dashboardPart: dashboardPart,
            viewMode: viewMode,
            store: store,
            printingMode: printingMode,
            finishedRender: props.finishedRender,
            accessPriority: accessPriority
          }) : _react2.default.createElement(
            'div',
            { className: 'u_tableCell u_alignMiddle u_textCenter' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('span', { className: 'icon-info-circled u_LargeIcon' })
            ),
            _react2.default.createElement(
              'span',
              { className: 'white-space-pre-line' },
              (0, _fp.isNil)(disableViewReportMessage) ? localization.getText('COMMON_MESSAGES_NOPERMISSION_VIEWREPORT') : disableViewReportMessage
            )
          )
        )
      );

      var blankBody = _react2.default.createElement(_Izenda10.default, {
        disabled: !editDashboard,
        dashboardDetail: dashboardDetail,
        dashboardPart: dashboardPart,
        store: store,
        viewMode: viewMode
      });

      var body = (0, _fp.isNil)(type) ? blankBody : tileBody;
      // Default style for dashboard tile in presentation mode
      var dashboardTileStyle = props.presentationMode ? props.dashboardTileStyle : {};

      return _react2.default.createElement(
        'div',
        { className: 'u_fullSize izenda-DashboardTile', style: dashboardTileStyle },
        _react2.default.createElement(
          'div',
          { className: 'u_fullSize izenda-DashboardTile-Content u-posRelative' },
          header,
          body,
          _react2.default.createElement(_Izenda4.default, null)
        )
      );
    }
  }]);
  return DashboardTile;
}(_react.Component), _class2.propTypes = {
  store: _mobxReact.propTypes.observableObject.isRequired,
  dashboardPart: _mobxReact.propTypes.observableObject.isRequired,
  dashboardDetail: _mobxReact.propTypes.observableObject,
  fullScreen: _propTypes2.default.bool,
  viewMode: _propTypes2.default.bool
}, _temp)) || _class);
exports.default = DashboardTile;
module.exports = exports['default'];

/***/ }),
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoadingBar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var LazyLoadingBar = (0, _mobxReact.observer)(function (_ref) {
  var className = _ref.className,
      store = _ref.store;

  return store.isLoading && _react2.default.createElement(
    "div",
    { className: className },
    _react2.default.createElement(
      "div",
      { className: "izenda-LazyLoadingIndicator" },
      _react2.default.createElement("span", null),
      _react2.default.createElement("span", null),
      _react2.default.createElement("span", null)
    )
  );
});

LazyLoadingBar.displayName = "LazyLoadingBar";
LazyLoadingBar.defaultProps = {
  store: {
    isLoading: true
  }
};

exports.default = LazyLoadingBar;
module.exports = exports["default"];

/***/ }),
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.LabelFieldContainer.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(306);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelFieldContainer = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LabelFieldContainer, _Component);

  function LabelFieldContainer() {
    (0, _classCallCheck3.default)(this, LabelFieldContainer);
    return (0, _possibleConstructorReturn3.default)(this, (LabelFieldContainer.__proto__ || (0, _getPrototypeOf2.default)(LabelFieldContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(LabelFieldContainer, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var label = props.label,
          dataKey = props.dataKey,
          isHorizontal = props.isHorizontal;

      var labelCols = isHorizontal ? 3 : 12;
      var inputCols = isHorizontal ? 9 : 12;
      var containerData = (0, _fp.get)('reportPart.reportPartContent.' + dataKey, props);
      return _react2.default.createElement(
        _Izenda4.default.Row,
        null,
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: labelCols },
          isHorizontal ? _react2.default.createElement(
            'span',
            { className: 'u_paddingLeft' },
            label
          ) : label
        ),
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: inputCols },
          props.children || _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, props, { container: containerData }))
        )
      );
    }
  }]);
  return LabelFieldContainer;
}(_react.Component), _class2.defaultProps = {
  isHorizontal: false
}, _temp)) || _class;

exports.default = LabelFieldContainer;
module.exports = exports['default'];

/***/ }),
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _bluebird = __webpack_require__(18);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRange.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * SettingsByRange component
 */


var _Izenda = __webpack_require__(258);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1756);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(30);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(13);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(12);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(1757);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATA_TYPE = _Izenda2.default.DATA_TYPE;
var VALUE_TYPES = _Izenda2.default.VALUE_TYPES;

function getDateTimeFormatData(dateTimeFormatDataFn) {
  return (0, _fp.isFunction)(dateTimeFormatDataFn) ? dateTimeFormatDataFn() : dateTimeFormatDataFn;
}

var SettingsByRange = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SettingsByRange, _Component);

  function SettingsByRange(props) {
    (0, _classCallCheck3.default)(this, SettingsByRange);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingsByRange.__proto__ || (0, _getPrototypeOf2.default)(SettingsByRange)).call(this, props));

    _initialiseProps.call(_this);

    _this.model = new _Izenda4.default();
    _this.model.setSettingValue(props.settingValue);
    var dateTimeFormatData = getDateTimeFormatData(props.dateTimeFormatData);
    _this.model.setValueTypeByDataType(props.defaultValueType, dateTimeFormatData);
    _this.initData();
    return _this;
  }

  (0, _createClass3.default)(SettingsByRange, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.model.setSettingValue(nextProps.settingValue);
      var dateTimeFormatData = getDateTimeFormatData(nextProps.dateTimeFormatData);
      this.model.setValueTypeByDataType(nextProps.defaultValueType, dateTimeFormatData);
    }
  }, {
    key: 'render',
    value: function render() {
      var haveName = this.props.haveName;

      var model = this.model;
      var selectedValueType = model.selectedValueType;
      var selectedSettingsValue = model.settingsValue[selectedValueType] || [];

      return _react2.default.createElement(
        'section',
        { className: 'setting-by-range u_paddingAll' },
        this.renderHeader(),
        selectedSettingsValue.length > 0 ? this.renderGrid() : null,
        selectedValueType === 'none' || selectedValueType === 'value' && haveName ? null : _react2.default.createElement(_Izenda8.default, {
          className: 'u_floatRight',
          label: _Izenda12.default.getText('SETTING_BY_RANGE_ADD_SETTING'),
          onClick: this.addNewSetting
        })
      );
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var props = this.props,
          model = this.model;

      var valueProps = (0, _fp.getOr)({}, 'valueProps', props);

      return _react2.default.createElement(
        _Izenda10.default,
        { className: 'izenda-SettingByRange-Header' },
        _react2.default.createElement(
          _Izenda10.default.Row,
          null,
          _react2.default.createElement(
            _Izenda10.default.Col,
            { cols: 5, className: 'u_controlHeight' },
            _react2.default.createElement(
              'span',
              null,
              valueProps.title
            )
          ),
          _react2.default.createElement(
            _Izenda10.default.Col,
            { cols: 7 },
            _react2.default.createElement(_Izenda6.default, {
              options: getOptions(),
              value: model.selectedValueType,
              labelField: 'label',
              valueField: 'key',
              onChange: changeValueType.bind(this)
            })
          )
        )
      );

      function getOptions() {
        var getValueTypes = function getValueTypes(input) {
          var arr = [];
          for (var key in VALUE_TYPES) {
            if (input.indexOf(key) > -1) {
              arr.push((0, _fp.assign)(VALUE_TYPES[key], { key: key }));
            }
          }
          return arr;
        };

        if (props.haveName) {
          if (props.isHiddenValueOption) {
            return getValueTypes(['none', 'rangeValue', 'rangePercent']);
          }
          return getValueTypes(['none', 'value', 'rangeValue', 'rangePercent']);
        }

        switch (props.dataType) {
          case DATA_TYPE.TEXT:
          case DATA_TYPE.BOOLEAN:
            return getValueTypes(['value']);
          case DATA_TYPE.DATETIME:
            var dateTimeFormatData = getDateTimeFormatData(props.dateTimeFormatData);
            return getValueTypes((0, _fp.getOr)(['value', 'rangeValue'], 'settingByGroupBy.SETTINGS_VALUE_TYPE', dateTimeFormatData));
          case DATA_TYPE.TIME:
            return getValueTypes(['value', 'rangeValue']);
          case DATA_TYPE.MONEY:
          case DATA_TYPE.NUMERIC:
            return getValueTypes(['value', 'rangeValue', 'rangePercent']);
          default:
            return getValueTypes(['value', 'rangeValue', 'rangePercent']);
        }
      }

      function changeValueType(newVal, newValDetails) {
        model.setValueType(newVal.value);
        this.initData();
      }
    }
  }, {
    key: 'renderGrid',
    value: function renderGrid() {
      var props = this.props,
          haveName = this.props.haveName,
          _model = this.model,
          selectedValueType = _model.selectedValueType,
          settingsValue = _model.settingsValue;

      var selectedSettingsValue = settingsValue[selectedValueType] || [];
      var canMove = selectedValueType !== 'value';

      return _react2.default.createElement(
        'table',
        { className: 'table table-bordered u_fullWidth' },
        _react2.default.createElement(
          'thead',
          null,
          renderGridHeader()
        ),
        _react2.default.createElement(
          'tbody',
          null,
          selectedSettingsValue.map(function (item, index) {
            return _react2.default.createElement(_Izenda14.default, (0, _extends3.default)({}, props, {
              itemData: item,
              itemIndex: index,
              valueType: selectedValueType,
              key: item.id,
              canMove: canMove,
              onMove: handleMoveItem,
              onDelete: handleDeleteItem.bind(null, index)
            }));
          })
        )
      );

      function renderGridHeader() {
        return _react2.default.createElement(
          'tr',
          null,
          canMove ? _react2.default.createElement('th', null) : null,
          haveName ? _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(
              'label',
              null,
              _Izenda12.default.getText('COMMON_LABEL_NAME')
            )
          ) : null,
          _react2.default.createElement(
            'th',
            { className: 'izenda-SettingByRange_ValueLabel' },
            _react2.default.createElement(
              'label',
              null,
              _Izenda12.default.getText('COMMON_LABEL_VALUE')
            )
          ),
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(
              'label',
              null,
              (0, _fp.get)('valueProps.title', props)
            )
          ),
          haveName && selectedValueType === 'value' ? null : _react2.default.createElement('th', null)
        );
      }

      function handleDeleteItem(index) {
        selectedSettingsValue.splice(index, 1);
      }

      function handleMoveItem(from, to) {
        if (to < 0) to = 0;
        if (to >= selectedSettingsValue.length) to = selectedSettingsValue.length - 1;
        if (from === to) return;
        selectedSettingsValue.splice(to, 0, selectedSettingsValue.splice(from, 1)[0]);
      }
    }

    /* Initialize default data for value settings */

  }, {
    key: 'initData',
    value: function initData() {
      var haveName = this.props.haveName;
      var model = this.model;
      var props = this.props;
      var selectedValueType = model.selectedValueType;
      var selectedSettingsValue = model.settingsValue[selectedValueType] || [];

      if (haveName && selectedValueType === 'value' && selectedSettingsValue.length === 0) {
        model.addNewSetting({
          name: _Izenda12.default.getText('COMMON_LABEL_LOW'),
          key: '',
          text: props.minColor || '',
          id: (0, _fp.uniqueId)('setting_'),
          canDelete: false
        });
        model.addNewSetting({
          name: _Izenda12.default.getText('COMMON_LABEL_HIGH'),
          key: '',
          text: props.maxColor || '',
          id: (0, _fp.uniqueId)('setting_'),
          canDelete: false
        });
      }
    }
  }]);
  return SettingsByRange;
}(_react.Component), _class2.propsType = {
  dataType: _react2.default.PropTypes.string,
  settingValue: _react2.default.PropTypes.object,
  valueProps: _react2.default.PropTypes.object,
  haveName: _react2.default.PropTypes.bool
}, _class2.getDefaultProps = {
  haveName: false
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getValue = function () {
    return _this2.model.getSettingValue();
  };

  this.beforeClosing = function (valManager, btnType) {
    var validateMessage = (0, _fp.getOr)({}, 'validateMessages', _this2.props);

    _this2.valManager = valManager;
    if (btnType === 'cancel') {
      return true;
    }
    var model = _this2.model;
    var haveName = _this2.props.haveName;

    model.removeEmptySettingValue(haveName);

    if (!model.isExistsUncompleteRangeValue(haveName)) {
      var listNameDup = haveName && model.checkDuplicateName() || [];
      var dateTimeFormatData = getDateTimeFormatData(_this2.props.dateTimeFormatData);
      var settingInvaid = model.checkConstrains(_this2.props.dataType, (0, _fp.getOr)(false, 'settingByGroupBy.RANGE_CYCLE', dateTimeFormatData));
      var listRangeDup = settingInvaid.duplicate;
      var invalidRange = settingInvaid.invalidRange;
      var error = [];

      if (listNameDup.length > 0) {
        error = _this2.buildNameValidationError(listNameDup);
      }
      if (listRangeDup.length > 0) {
        error = (0, _fp.concat)(error, _this2.buildOverlapRangeError(listRangeDup));
      }
      if (invalidRange.length > 0) {
        error = (0, _fp.concat)(error, _this2.buildErrorList(invalidRange, validateMessage.INVALID_RANGE));
      }

      if (error.length > 0) {
        valManager.reset();
        valManager.updateErrors(error);
        return (0, _bluebird.resolve)(false);
      }
    }
    return (0, _bluebird.resolve)(true);
  };

  this.buildNameValidationError = function (listNameDup) {
    var validateMessage = (0, _fp.getOr)({}, 'validateMessages', _this2.props);
    var msg = validateMessage.DUPLICATE_NAME;
    var error = [];

    listNameDup.forEach(function (item) {
      error.push({
        key: item.id + '_name',
        messages: [msg]
      });
    });
    return error;
  };

  this.buildErrorList = function (listNameDup, msg) {
    var selected = _this2.model.selectedValueType;

    return (0, _fp.flatMap)(function (item) {
      if (selected === 'value') {
        return [{
          key: item.id,
          messages: [msg]
        }];
      }
      return [{
        key: item.id + '_from',
        messages: [msg]
      }, {
        key: item.id + '_to',
        messages: [msg]
      }];
    }, listNameDup);
  };

  this.buildOverlapRangeError = function (list) {
    var validateMessage = (0, _fp.getOr)({}, 'validateMessages', _this2.props);
    var selected = _this2.model.selectedValueType;
    var msg = getValidationMessage();

    function getValidationMessage() {
      var msg = '';

      switch (selected) {
        case 'value':
          msg = validateMessage.VALUE;
          break;
        case 'rangeValue':
          msg = validateMessage.RANGE_VALUE;
          break;
        case 'rangePercent':
          msg = validateMessage.RANGE_PERCENT;
          break;
      }
      return msg;
    }

    return _this2.buildErrorList(list, msg);
  };

  this.addNewSetting = function () {
    _this2.valManager && _this2.valManager.reset();
    _this2.model.addNewSetting();
  };
}, _temp)) || _class;

exports.default = SettingsByRange;
module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ButtonGroup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ButtonGroup component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);

  var ButtonGroup = React.createClass({
    displayName: 'ButtonGroup',


    propTypes: {
      buttons: React.PropTypes.object,
      onChange: React.PropTypes.func,
      editorControl: React.PropTypes.object,
      onExecCommand: React.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
      return {
        buttons: []
      };
    },

    handleClickButton: function handleClickButton(item) {
      var props = this.props;

      item.isExecute && props.onExecCommand && props.onExecCommand(item.value);
      if (item.isExecute && !!props.editorControl) {
        props.editorControl.execCommand(item.value);
        return;
      }

      props.onChange && props.onChange({ value: item.value }, item.value);
    },

    renderButton: function renderButton(item, index, key) {
      if (this.props.buttonsHidden && this.props.buttonsHidden[key]) {
        return null;
      }

      if (!!item.component) {
        return React.createElement(item.component, (0, _extends3.default)({}, this.props, { data: item, key: index }));
      }

      var value = this.props.value || {};
      var classesBtn = classnames({
        'btn': true,
        'active': value[key]
      });

      return React.createElement(
        'span',
        { key: index },
        React.createElement(
          'a',
          {
            className: classesBtn,
            title: item.title,
            onClick: this.handleClickButton.bind(null, item) },
          React.createElement(
            'span',
            { className: item.className },
            item.text
          )
        ),
        item.breakLine ? React.createElement('br', null) : null
      );
    },

    renderButtons: function renderButtons() {
      var buttons = this.props.buttons;

      return (0, _keys2.default)(buttons).map(function (key, index) {
        return this.renderButton(buttons[key], index, key);
      }.bind(this));
    },

    render: function render() {
      var classes = classnames('button-group', this.props.className);

      return React.createElement(
        'div',
        { className: classes },
        this.renderButtons()
      );
    }
  });

  module.exports = observer(ButtonGroup);
}();

/***/ }),
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CustomInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Input Component
 */
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var connect = __webpack_require__(2);

  var EventsUtils = __webpack_require__(24);
  var Validator = __webpack_require__(23);
  var Input = Validator()(__webpack_require__(17));

  var CustomInput = React.createClass({
    displayName: 'CustomInput',

    getDefaultProps: function getDefaultProps() {
      return {
        className: 'form-control',
        type: 'text',
        value: ''
      };
    },

    getInitialState: function getInitialState() {
      return {
        value: this.props.value,
        previousValue: this.props.value
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    },

    handleBlurInput: function handleBlurInput() {
      var props = this.props;

      if (this.props.value === this.state.value) {
        return;
      }

      this.props.validation.validate().then(function (success) {
        if (success) {
          if (props.onValidate && props.onValidate(this.state.value)) {
            ReactDOM.findDOMNode(this.refs.input.refs.editor).focus();
            return;
          }
          props.beforeOnChange && props.beforeOnChange({ value: this.state.value }, props.value);
          props.onChange && props.onChange({ value: this.state.value });
        }
      }.bind(this));
    },

    handleChangeValue: function handleChangeValue(value) {
      this.setState({ value: value });
    },

    handleEnter: function handleEnter(e) {
      if (e.key === 'Enter') {
        this.handleBlurInput();
      }
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;

      return React.createElement(Input, {
        ref: 'input',
        className: this.props.className,
        field: this.props.field,
        value: this.state.value,
        validations: this.props.validations,
        onChange: notifyChange(this.handleChangeValue, EventsUtils.INPUT),
        onBlur: this.handleBlurInput,
        onKeyDown: this.handleEnter });
    }
  });

  module.exports = connect()(CustomInput);
}();

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorDialogUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var tinycolor = __webpack_require__(1790);

  var _require = __webpack_require__(1),
      forEach = _require.forEach;

  function toState(data, oldHue) {
    var color = data.hex ? tinycolor(data.hex) : tinycolor(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    if (hsl.s === 0) {
      hsl.h = oldHue || 0;
      hsv.h = oldHue || 0;
    }

    return {
      hsl: hsl,
      hex: '#' + color.toHex(),
      rgb: color.toRgb(),
      hsv: hsv,
      oldHue: data.h || oldHue || hsl.h,
      source: data.source
    };
  }

  function simpleCheckForValidColor(data) {
    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'a', 'v'];
    var checked = 0;
    var passed = 0;
    forEach(function (letter) {
      if (data[letter]) {
        checked++;
        if (!isNaN(data[letter])) {
          passed++;
        }
      }
    }, keysToCheck);

    return checked === passed ? data : false;
  }

  function isValidHex(hex) {
    return tinycolor(hex).isValid();
  }

  function saturationCalculateChange(e, skip, props, container) {
    !skip && e.preventDefault();
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
    var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
    var top = y - (container.getBoundingClientRect().top + (inIFrame ? 0 : window.pageYOffset));

    if (left < 0) {
      left = 0;
    } else if (left > containerWidth) {
      left = containerWidth;
    } else if (top < 0) {
      top = 0;
    } else if (top > containerHeight) {
      top = containerHeight;
    }

    var saturation = left * 100 / containerWidth;
    var bright = -(top * 100 / containerHeight) + 100;

    return {
      h: props.hsl.h,
      s: saturation,
      v: bright,
      a: props.hsl.a,
      source: 'rgb'
    };
  }

  function hueCalculateChange(e, skip, props, container) {
    !skip && e.preventDefault();
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var inIFrame = window.self !== window.top || window.document !== container.ownerDocument;
    var left = x - (container.getBoundingClientRect().left + (inIFrame ? 0 : window.pageXOffset));
    var top = y - (container.getBoundingClientRect().top + (inIFrame ? 0 : window.pageYOffset));

    if (props.direction === 'vertical') {
      var h;
      if (top < 0) {
        h = 359;
      } else if (top > containerHeight) {
        h = 0;
      } else {
        var percent = -(top * 100 / containerHeight) + 100;
        h = 360 * percent / 100;
      }

      if (props.hsl.h !== h) {
        return {
          h: h,
          s: props.hsl.s,
          l: props.hsl.l,
          a: props.hsl.a,
          source: 'rgb'
        };
      }
    }
    return null;
  }

  module.exports = {
    simpleCheckForValidColor: simpleCheckForValidColor,
    toState: toState,
    isValidHex: isValidHex,
    saturationCalculateChange: saturationCalculateChange,
    hueCalculateChange: hueCalculateChange
  };
}();

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.TextArea.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * TextArea Component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TextArea, _Component);

  function TextArea() {
    (0, _classCallCheck3.default)(this, TextArea);
    return (0, _possibleConstructorReturn3.default)(this, (TextArea.__proto__ || (0, _getPrototypeOf2.default)(TextArea)).apply(this, arguments));
  }

  (0, _createClass3.default)(TextArea, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('textarea', this.props);
    }
  }]);
  return TextArea;
}(_react.Component), _class.defaultProps = {
  className: 'form-control'
}, _temp);
exports.default = TextArea;
module.exports = exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartSelectionPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Popup = __webpack_require__(36);

  var SearchCriteria = __webpack_require__(1816);
  var SearchResult = __webpack_require__(1817);
  var SearchProcessBar = __webpack_require__(1824);
  var constants = __webpack_require__(185);
  var connect = __webpack_require__(2);
  var action = __webpack_require__(1825);

  var ReportPartSelectionPopup = connect(action)(React.createClass({
    displayName: 'ReportPartSelectionPopup',

    propTypes: {
      reportPartSelectionStore: React.PropTypes.object.isRequired,
      onAccept: React.PropTypes.func.isRequired,
      onReject: React.PropTypes.func.isRequired
    },

    componentWillUnmount: function componentWillUnmount() {
      this.props.reportPartSelectionStore.destroy();
    },

    render: function render() {
      var props = this.props;
      var localization = props.localization;
      var reportPartSelectionStore = props.reportPartSelectionStore;
      var reportPartSelection = props.reportPartSelectionStore.reportPartSelection;
      var header = props.type === constants.TYPE.REPORT_PART ? localization.getText('DASHBOARD_LABEL_REPORT_PART_SELECTION') : localization.getText('DASHBOARD_LABEL_REPORT_SELECTION');

      return React.createElement(
        Popup,
        { visible: true,
          type: 'none',
          sizeClass: 'modal-lg',
          onClosing: props.onReject,
          containerClass: 'izenda-ReportPartSelectionPopup-modal' },
        React.createElement(Popup.Header, { title: header }),
        React.createElement(
          Popup.Body,
          { className: 'izenda-ReportPartSelectionPopup' },
          !props.isShowResult && React.createElement(SearchCriteria, {
            reportPartSelectionStore: reportPartSelectionStore,
            reportPartSelection: reportPartSelection,
            showResult: props.showResult,
            excludeIds: props.excludeIds }),
          React.createElement(SearchProcessBar, {
            reportPartSelectionStore: reportPartSelectionStore }),
          props.isShowResult && React.createElement(SearchResult, (0, _extends3.default)({ reportPartSelection: reportPartSelection }, props))
        )
      );
    }
  }));

  ReportPartSelectionPopup.$popupName = 'ReportSelectionPopup';

  module.exports = ReportPartSelectionPopup;
}();

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1845);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(120);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

var _Izenda7 = __webpack_require__(401);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var ROOT_URL = 'export/';

exports.default = {
  export: function _export(options, successCallBack, failCallBack) {
    ensure(options.format, 'Format must be defined');
    ensure(options.reportId || options.dashboardId || options.reportDefinition, 'Ether report or dashboard ID must be set');

    var exportUrl = ROOT_URL + options.format;
    var exportData = (0, _fp.omit)('format', options);

    exportData.fileSessionKey = exportData.reportId || exportData.dashboardId;

    if (!!_config2.default.Integration) {
      exportData.token = new _Izenda6.default().getAccessToken();
    }

    var exportUtil = (0, _Izenda4.default)(exportUrl);

    return options.format !== _Izenda8.default.HTML.value ? exportUtil.post(exportData, successCallBack, failCallBack, this.checkExportStatus) : (0, _Izenda2.default)(ROOT_URL + 'html').post(exportData);
  },


  /**
   * Send Email
   * @param {object} objectID
   * @param {object }email
   * @returns {Promise}
   */
  email: function email(objectID, _email) {
    var data = (0, _fp.assign)(objectID, {
      deliveryType: 'Email',
      deliveryMethod: _email.deliveryMethod,
      exportAttachmentType: _email.attachmentType,
      emailSubject: _email.subject,
      emailBody: _email.body,
      recipients: _email.to,
      additionalRecipients: _email.cc
    });
    return (0, _Izenda2.default)(ROOT_URL + 'email').post(data);
  },


  /**
   * export performanceStatisticsTrend
   */
  exportPerformanceStatisticsTrend: function exportPerformanceStatisticsTrend() {
    var exportUrl = ROOT_URL + 'performanceStatisticsTrend';
    var exportData = { fileSessionKey: 'Performance Statistics Trend' };
    return (0, _Izenda4.default)(exportUrl).post(exportData);
  },


  /**
   * check status of export file
   */
  checkExportStatus: function checkExportStatus(fileSession) {
    var checkStatusUrl = ROOT_URL + 'checkExportStatus/' + fileSession;
    return (0, _Izenda2.default)(checkStatusUrl).get();
  }
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Word: { label: 'Word', value: 'word' },
  Excel: { label: 'Excel', value: 'excel' },
  Pdf: { label: 'PDF', value: 'pdf' },
  Csv: { label: 'CSV', value: 'csv' },
  Xml: { label: 'XML', value: 'xml' },
  Json: { label: 'JSON', value: 'json' },
  HTML: { label: 'HTML', value: 'html' },
  Query: {
    get label() {
      return _Izenda2.default.getText('PERMISSION_LABEL_QUERY_EXECUTION');
    },
    value: 'query'
  },
  Definition: {
    get label() {
      return _Izenda2.default.getText('PERMISSION_LABEL_DEFINITION');
    },
    value: 'definition'
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ExportFormatConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedField Component
 */


__webpack_require__(55);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__(5);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(96);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(36);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1852);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalculatedField = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(CalculatedField, _React$Component);

  function CalculatedField(props) {
    (0, _classCallCheck3.default)(this, CalculatedField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CalculatedField.__proto__ || (0, _getPrototypeOf2.default)(CalculatedField)).call(this, props));

    _initialiseProps.call(_this);

    _this.uiStore = (0, _mobx.observable)({
      showLoading: false
    });

    var _this$props = _this.props,
        store = _this$props.store,
        _this$props$value = _this$props.value,
        value = _this$props$value === undefined ? {} : _this$props$value,
        type = _this$props.type;


    store.init();
    var model = store.clonedModel;

    model.readInitialData(value, type);

    _this.disposeAutoRun = (0, _mobx.autorun)(function () {
      return store.getFormatsByType(store.clonedModel.izendaDataType);
    });
    return _this;
  }

  (0, _createClass3.default)(CalculatedField, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disposeAutoRun();
    }

    /**
     * When click button OK on popup
     */

  }, {
    key: 'validateIzendaDataType',
    value: function validateIzendaDataType() {
      var izendaDataType = this.props.store.clonedModel.izendaDataType;

      return (0, _fp.isNil)(izendaDataType);
    }

    /**
     * Validate duplicate name before save
     */

  }, {
    key: 'validateDuplicateName',
    value: function validateDuplicateName() {
      var _props = this.props,
          store = _props.store,
          model = _props.store.clonedModel,
          isCheckDuplicateWithActualField = _props.isCheckDuplicateWithActualField,
          type = _props.type;


      if (type.name === _Izenda2.default.TYPES.SUB_TOTAL.name || type.name === _Izenda2.default.TYPES.GRAND_TOTAL.name) {
        return false;
      }

      // Get fieldNames from dataSource first
      var dataSource = store.expressionSelection.expressionFieldName.dataSources;
      var fieldNames = (0, _fp.flatten)(dataSource.map(function (source) {
        return (0, _mobx.toJS)(source.fieldNames);
      }));

      // check and get fieldName directly from fieldNames
      fieldNames = (0, _fp.remove)(_fp.isUndefined, fieldNames);
      if ((0, _fp.isEmpty)(fieldNames)) {
        fieldNames = store.expressionSelection.expressionFieldName.fieldNames;
      }

      var duplicatedItem = (0, _fp.find)(function (field) {
        return isCheckDuplicateWithActualField ? field.isCalculated && field.querySourceId === _Izenda2.default.EMPTY_GUID && (0, _fp.toLower)(field.name) === (0, _fp.toLower)(model.name) && (field.tempId ? field.tempId !== model.tempId : field.id !== model.id) : (0, _fp.toLower)(field.name) === (0, _fp.toLower)(model.name) && (field.id ? field.id !== model.id : field.tempId !== model.tempId);
      }, fieldNames);

      return !!duplicatedItem;
    }

    /**
     * Validate not contain character '[',']' before save
     */

  }, {
    key: 'validateName',
    value: function validateName() {
      var model = this.props.store.clonedModel;

      return model.name && (model.name.indexOf(']') > -1 || model.name.indexOf('[') > -1);
    }

    /**
     * When click button Cancel on popup
     * @param  {Object} hidePopup function
     */


    /**
     * Handle when popup closing
     * @param  {Object} closeCallback function
     * @param  {Object} type of close button click
     */


    /**
     * validate Expression when focus out expression field
     */


    /**
     * Update error to validation context
     */

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          localization = _props2.localization,
          popupLabels = _props2.type,
          store = _props2.store,
          validation = _props2.validation,
          reportDesigner = _props2.reportDesigner,
          reportPart = _props2.reportPart,
          expressionConfig = _props2.expressionConfig,
          requireLabel = _props2.requireLabel,
          querySourceId = _props2.querySourceId;


      return _react2.default.createElement(
        _Izenda6.default,
        {
          visible: true,
          onClosing: this.onClosing,
          autoClose: false,
          type: 'none',
          sizeClass: 'modal-lg',
          showLoading: this.uiStore.showLoading
        },
        _react2.default.createElement(_Izenda6.default.Header, { title: popupLabels.title }),
        _react2.default.createElement(
          _Izenda6.default.Body,
          null,
          _react2.default.createElement(_Izenda8.default, {
            ref: 'calculatedFieldContainer',
            store: store,
            validation: validation,
            type: popupLabels,
            localization: localization,
            reportDesigner: reportDesigner,
            reportPart: reportPart,
            expressionConfig: expressionConfig,
            validateExpression: this.validateExpression,
            startLoading: this.startLoading,
            endLoading: this.endLoading,
            updateError: this.updateError,
            requireLabel: requireLabel,
            querySourceId: querySourceId
          })
        ),
        _react2.default.createElement(
          _Izenda6.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda6.default.ConfirmationButton,
            { key: 'accept', type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda6.default.ConfirmationButton,
            { key: 'cancel', type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return CalculatedField;
}(_react2.default.Component), _class.propTypes = {
  store: _react.PropTypes.object.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  type: _react.PropTypes.object.isRequired,
  reportPart: _react.PropTypes.object,
  reportDesigner: _react.PropTypes.object,
  requireLabel: _react.PropTypes.bool,
  isCheckDuplicateWithActualField: _react.PropTypes.bool
}, _class.defaultProps = {
  type: _Izenda2.default.TYPES.ADD,
  requireLabel: true,
  isCheckDuplicateWithActualField: true
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.startLoading = function () {
    _this2.uiStore.showLoading = true;
  };

  this.endLoading = function () {
    _this2.uiStore.showLoading = false;
  };

  this.onAcceptClosing = function () {
    var _props3 = _this2.props,
        store = _props3.store,
        localization = _props3.localization,
        valManager = _props3.validation,
        requireLabel = _props3.requireLabel,
        onClose = _props3.onClose,
        onAccept = _props3.onAccept;


    _this2.startLoading();
    return _this2.validateExpression(true).bind(_this2).then(function (result) {
      _this2.endLoading();
      return result;
    }).then(function (isValidExpress) {
      if (!isValidExpress) return;

      return valManager.validate().then(function (success) {
        var isDuplicate = _this2.validateDuplicateName();
        var isInvalidName = _this2.validateName();

        if (isDuplicate) {
          valManager.updateErrors([{
            key: _Izenda2.default.VALIDATION_FIELD_NAME,
            messages: String.format(_Izenda2.default.MESSAGES.DUPLICATE_NAME, store.clonedModel.name)
          }]);
          return null;
        }

        if (isInvalidName) {
          valManager.updateErrors([{
            key: requireLabel ? _Izenda2.default.VALIDATION_FIELD_NAME : _Izenda2.default.VALIDATION_SUB_TOTAL_FIELD_NAME,
            messages: localization.getText('CALCULATED_FIELD_MESSAGE_INVALID_NAME')
          }]);
          return null;
        }

        if (requireLabel && _this2.validateIzendaDataType()) {
          valManager.updateErrors([{
            key: _Izenda2.default.VALIDATION_DATA_TYPE,
            messages: localization.getText('CALCULATED_FIELD_MESSAGE_MISSING_DATA_TYPE')
          }]);
          return null;
        }

        if (success) {
          valManager.reset();
          store.acceptClonedModel(); // merge final cloned data to real model
          onClose(store.clonedModel);
          onAccept();
        }
        return success;
      });
    });
  };

  this.onCancelClosing = function (hidePopup) {
    _this2.props.validation.reset();
    hidePopup();
  };

  this.onClosing = function (closeCallback, type) {
    var hidePopup = function hidePopup() {
      _this2.props.onAccept();
      _this2.props.onClose();
      closeCallback();
    };

    // close expression selection
    _this2.refs.calculatedFieldContainer.closeExpressionSelection();

    if (type === 'accept') {
      return _this2.onAcceptClosing();
    } else if (type === 'cancel') {
      return _this2.onCancelClosing(hidePopup);
    }
  };

  this.validateExpression = function (noUpdateDataType) {
    var _props4 = _this2.props,
        store = _props4.store,
        valManager = _props4.validation,
        _props4$reportDesigne = _props4.reportDesigner,
        reportDesigner = _props4$reportDesigne === undefined ? {} : _props4$reportDesigne,
        reportPart = _props4.reportPart,
        querySourceId = _props4.querySourceId,
        type = _props4.type;

    var previewRecord = (0, _fp.get)('previewRecord', reportDesigner);
    valManager.reset();

    switch (type.name) {
      case _Izenda2.default.TYPES.SUB_TOTAL.name:
      case _Izenda2.default.TYPES.GRAND_TOTAL.name:
        return store.validateExpressionWithReportKey(reportDesigner, reportPart, noUpdateDataType).then(function (errors) {
          return _this2.updateError(errors);
        });
      default:
        return store.validateExpression(querySourceId, noUpdateDataType, previewRecord).then(function (errors) {
          return _this2.updateError(errors);
        });
    }
  };

  this.updateError = function (errors) {
    if (!(0, _fp.isEmpty)(errors)) {
      _this2.props.validation.updateErrors(errors);
      return false;
    }

    return true;
  };
}, _temp);
exports.default = (0, _Izenda4.default)(_recompose.pure)(CalculatedField);
module.exports = exports['default'];

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Popover.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Popover Component
 * Note:
 * - Children of popover can call this.props.hidePopover() method to hide the popover.
 * - Should to supply the position {left, top} of popover.
 *
 * Usage example:
 *  var Button = function (props) {
 *    var onClick = function () {
 *      props.hidePopover();
 *    };
 *    return (
 *      <button
 *        className='btn btn-default'
 *        onClick={onClick}>
 *        {props.label}
 *      </button>
 *    );
 *  };
 *
 *  <Popover
 *    visible={true}
 *    positionLeft={500}
 *    positionTop={200}
 *    title={'Popover Title'}
 *    hasArrow={true}
 *    placement={PopoverOptions.PLACEMENT.RIGHT}
 *    arrowOffsetTop={'50%'}>
 *    <Button label={'Click me to hide Popover...'} />
 *  </Popover>
 */

!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      omit = _require.omit;

  var PopoverTitle = function PopoverTitle(props) {
    return props.title ? React.createElement(
      'h3',
      { className: 'popover-title' },
      props.title
    ) : null;
  };

  var PopoverArrow = function PopoverArrow(props) {
    var arrowStyle = {
      left: props.arrowOffsetLeft,
      top: props.arrowOffsetTop
    };

    return props.hasArrow ? React.createElement('div', { className: 'arrow', style: arrowStyle }) : null;
  };

  var PLACEMENT = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };

  var Popover = React.createClass({
    displayName: 'Popover',

    propsType: {
      /**
       * Sets the direction the Popover is positioned towards.
       */
      placement: React.PropTypes.oneOf([PLACEMENT.TOP, PLACEMENT.RIGHT, PLACEMENT.BOTTOM, PLACEMENT.LEFT]),

      /**
       * The "left" position value for the Popover.
       */
      positionLeftPixel: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),

      /**
       * The "top" position value for the Popover.
       */
      positionTopPixel: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),

      /**
       * The "left" position value for the Popover arrow.
       */
      arrowOffsetLeft: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),

      /**
       * The "top" position value for the Popover arrow.
       */
      arrowOffsetTop: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),

      /**
       * Title text
       */
      title: React.PropTypes.node,

      /**
       * Specify whether the popover should trigger onHide when the user clicks outside the popover
       */
      rootClose: React.PropTypes.bool,

      /**
       * A callback invoked by the popover when it wishes to be hidden. Required if
       * `rootClose` is specified.
       */
      onHide: React.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
      return {
        placement: PLACEMENT.RIGHT,
        rootClose: false
      };
    },

    getInitialState: function getInitialState() {
      return {
        isVisible: this.props.visible
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        isVisible: nextProps.visible
      });
    },

    componentDidMount: function componentDidMount() {
      window.addEventListener('mousedown', this.handleDocumentClick, false);
    },

    componentWillUnmount: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.handleDocumentClick, false);
    },

    handleDocumentClick: function handleDocumentClick(event) {
      var props = this.props;
      if (this.state.isVisible && this.props.rootClose) {
        var popoverElement = ReactDOM.findDOMNode(this.refs.popover);
        var isInside = popoverElement.contains(event.target) || popoverElement === event.target;

        if (!isInside) {
          this.setState({ isVisible: false });
          props.onHide && props.onHide(event);
        }
      }
    },

    render: function render() {
      if (!this.state.isVisible) {
        return null;
      }

      var style = {
        left: this.props.positionLeft,
        top: this.props.positionTop,
        display: 'block',
        zIndex: 1600
      };

      var popoverclassnames = classnames('popover popover-container fade', {
        in: this.state.isVisible
      });

      var rest = omit(['visible', 'positionLeft', 'positionTop', 'onHide', 'rootClose', 'placement'], this.props);

      return React.createElement(
        'div',
        (0, _extends3.default)({
          className: popoverclassnames + ' ' + this.buildPlacementClass(),
          role: 'tooltip',
          ref: 'popover'
        }, rest, {
          style: style
        }),
        React.createElement(PopoverArrow, this.props),
        React.createElement(PopoverTitle, this.props),
        this.renderContent()
      );
    },

    /**
     * Base on placement value, we build CSS class for popover.
     */
    buildPlacementClass: function buildPlacementClass() {
      return this.props.placement;
    },

    /**
     * Hide popover
     */
    hide: function hide() {
      this.setState({
        isVisible: false
      });
    },

    /**
     * Render content of popover.
     */
    renderContent: function renderContent() {
      var children = this.props.children;
      if (!children) {
        return null;
      }

      // Send hide popover action into its children then they can hide popover.
      var childrenWithHidePopoverCallback = React.Children.map(children, function (child) {
        return React.cloneElement(child, {
          hidePopover: this.hide
        });
      }.bind(this));

      return React.createElement(
        'div',
        { className: 'popover-content' },
        childrenWithHidePopoverCallback
      );
    }
  });

  module.exports = {
    Popover: Popover,
    PopoverOptions: {
      PLACEMENT: PLACEMENT
    }
  };
}();

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(214);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.AutoresizeChart.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(33);

var _Izenda2 = __webpack_require__(16);

var _fp = __webpack_require__(1);

var _recompose = __webpack_require__(9);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _Izenda3 = __webpack_require__(175);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1887);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1888);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(405);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(571);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(951);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(1889);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(1890);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(80);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(1892);

var _Izenda22 = _interopRequireDefault(_Izenda21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isChartType = _Izenda4.default.isReportPartStyle(_Izenda2.REPORT_PART_TYPE.Chart);

/**
 * Render chart container with NoData component
 * @param {Object} props
 */
var NoDataChartContainer = function NoDataChartContainer(props) {
  return _react2.default.createElement(
    _Izenda14.default,
    props,
    props.children,
    _react2.default.createElement(
      'div',
      { className: 'chart-body' },
      _react2.default.createElement(_Izenda12.default, { finishedRender: props.finishedRender })
    )
  );
};

/**
 * Determine whether chart is not empty
 * @param {Object} chartData Chart data
 */
var hasData = function hasData(chartData) {
  return (0, _fp.has)('rawData', chartData) && ((0, _fp.isArrayLike)(chartData.rawData) ? (0, _fp.isEmpty)((0, _fp.flatMap)((0, _fp.flow)((0, _fp.get)('records'), _mobx.toJS), chartData.rawData)) : (0, _fp.isEmpty)(chartData.rawData.records));
};

/**
 * A HOC to render NoData when chart data is empty
 */
var WithNoData = (0, _recompose.compose)((0, _recompose.branch)(function (_ref) {
  var chartData = _ref.chartData;
  return hasData(chartData);
}, (0, _recompose.renderComponent)(_Izenda12.default), _fp.identity));

/**
 * A HOC to render chart container with NoData when chart data is empty
 */
var WithNoDataChartContainer = (0, _recompose.compose)((0, _recompose.branch)(function (_ref2) {
  var chartData = _ref2.chartData;
  return hasData(chartData);
}, (0, _recompose.renderComponent)(NoDataChartContainer), _fp.identity));

/**
 * The Gauge chart types
 */
var GAUGE_CHARTS = [_Izenda.CHART_TYPE.SimpleGauge, _Izenda.CHART_TYPE.LinearGauge, _Izenda.CHART_TYPE.SolidGauge];

/**
 * The Pie chart types
 */
var PIE_CHARTS = [_Izenda.CHART_TYPE.Pie, _Izenda.CHART_TYPE.Donut, _Izenda.CHART_TYPE.Funnel, _Izenda.CHART_TYPE.TreeMap];

/**
 * Get Grid chart action by chart type
 * @param {string} chartType The rendering chart type
 */
var getGridAction = function getGridAction(chartType) {
  switch (true) {
    case isChartType.apply(undefined, [chartType].concat(GAUGE_CHARTS)):
      return _Izenda6.default;
    case isChartType.apply(undefined, [chartType].concat(PIE_CHARTS)):
      return _Izenda8.default;
    default:
      return _fp.identity;
  }
};

var GridChartContainer = (0, _recompose.compose)((0, _recompose.withProps)(function (props) {
  return getGridAction(props.chartType)(props);
}), WithNoDataChartContainer)(_Izenda18.default);

/**
 * Get properties of each field which will be used to draw chart
 */
var getSeriesOptions = function getSeriesOptions(seriesOptions) {
  var seriesOpts = {};

  seriesOptions = seriesOptions || {};
  seriesOptions.map && seriesOptions.forEach(function (serie) {
    var serieName = serie && serie.fieldName;

    if (!serieName) {
      return null;
    }

    seriesOpts[serieName] = _Izenda20.default.getSerieProppertiesByField(serie);
  });

  return seriesOpts;
};

/**
 * Chart component to render all Charts, Gauges and Map
 */

var Chart = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(Chart, _Component);

  function Chart() {
    (0, _classCallCheck3.default)(this, Chart);
    return (0, _possibleConstructorReturn3.default)(this, (Chart.__proto__ || (0, _getPrototypeOf2.default)(Chart)).apply(this, arguments));
  }

  (0, _createClass3.default)(Chart, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          reportPart = _props.reportPart,
          props = (0, _objectWithoutProperties3.default)(_props, ['reportPart']);
      var isLoading = props.isLoading,
          type = props.type,
          chartType = props.chartType,
          seriesOptions = props.seriesOptions;

      // Trick - this function will be used in render function to trigger react-mobx
      // re-render whenever field-element-prop is changed
      // get properties of each field which will be used to draw chart

      var seriesOptionsProps = getSeriesOptions(seriesOptions);

      switch (!isLoading) {
        case isChartType.apply(undefined, [chartType].concat([].concat(GAUGE_CHARTS, PIE_CHARTS))):
          return _react2.default.createElement(GridChartContainer, (0, _extends3.default)({}, props, { seriesOptions: seriesOptionsProps }));
        case isChartType(chartType, _Izenda.CHART_TYPE.Sparkline):
          return this.renderInChartContainer(WithNoData(_Izenda16.default), seriesOptionsProps);
        case type === _Izenda2.REPORT_PART_TYPE.Map:
          return this.renderInChartContainer(_Izenda22.default, seriesOptionsProps);
        default:
          return this.renderInChartContainer(WithNoData(_Izenda10.default), seriesOptionsProps);
      }

      return null;
    }

    /**
     * Render component inside container
     * @param {Component} ChartComponent The chart component to be rendered inside container
     * @param {Object} seriesOptionsProps The series options
     */

  }, {
    key: 'renderInChartContainer',
    value: function renderInChartContainer(ChartComponent, seriesOptionsProps) {
      var props = this.props;
      var reportPart = props.reportPart,
          style = props.style,
          chartProps = (0, _objectWithoutProperties3.default)(props, ['reportPart', 'style']);
      var printingMode = chartProps.printingMode,
          children = chartProps.children,
          chartOptions = chartProps.chartOptions,
          className = chartProps.className;

      // Remove chart dimension in printing mode

      var chartStyle = printingMode ? (0, _fp.omit)(['height', 'width'], style) : style;

      return _react2.default.createElement(
        _Izenda14.default,
        { chartOptions: chartOptions, className: className, style: chartStyle, printingMode: printingMode },
        !printingMode && children,
        _react2.default.createElement(
          'div',
          { className: 'chart-body izenda-Wrapper-content' },
          _react2.default.createElement(ChartComponent, (0, _extends3.default)({}, chartProps, { style: chartStyle, seriesOptions: seriesOptionsProps }))
        )
      );
    }
  }]);
  return Chart;
}(_react.Component)) || _class;

exports.default = Chart;
module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(570);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(451);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(65);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleChart = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(SimpleChart, _Component);

  function SimpleChart() {
    (0, _classCallCheck3.default)(this, SimpleChart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SimpleChart.__proto__ || (0, _getPrototypeOf2.default)(SimpleChart)).call(this));

    _this.renderCompleted = function (chart) {
      // Remove clipping after animation had been completed to help IE not stuttering when scrolling with sticky
      if (chart && chart.clipRect && chart.clipRect.clipPath) {
        chart.clipRect.clipPath.destroy();
        chart.clipRect.clipPath = null;
      }

      var _this$props = _this.props,
          finishedRender = _this$props.finishedRender,
          fulfilledData = _this$props.fulfilledData;

      if (finishedRender && fulfilledData) {
        finishedRender();
      }
    };

    _this.state = {
      chartMsg: ''
    };
    return _this;
  }

  (0, _createClass3.default)(SimpleChart, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({ chartMsg: null });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderChart();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderChart();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.chart && this.chart.destroy && this.chart.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = this.props.style || {};
      return _react2.default.createElement(
        'div',
        { ref: 'chart', className: 'izenda-chart', style: style },
        this.state.chartMsg
      );
    }
  }, {
    key: 'renderChart',
    value: function renderChart() {
      // do not draw chart
      if (this.state.chartMsg) {
        var finishedRender = this.props.finishedRender;

        if (typeof finishedRender === 'function') {
          finishedRender();
        }

        return;
      }

      var _props = this.props,
          reportPartType = _props.type,
          reportPartStyle = _props.chartType;


      try {
        // Get configuration of the report part style
        var _cfgFactories$getConf = _Izenda6.default.getConfiguration(reportPartType, reportPartStyle),
            visualEngine = _cfgFactories$getConf.visualEngine,
            visualType = _cfgFactories$getConf.visualType,
            optionsMapping = _cfgFactories$getConf.optionsMapping,
            optionsBuilder = _cfgFactories$getConf.optionsBuilder;

        // Get visualization engine of the report part style. This viz engine was associated with the particular
        // report part style in its configuration.


        var vizEngine = _Izenda4.default.getVisualizationEngine(visualEngine, reportPartStyle);

        // Build the visualization options,aka configuration in order to guide the visualization to render
        var options = this.buildOptions(optionsMapping, visualType, optionsBuilder);

        // Invoke viz engine to execute drawing into chart container
        this.chart = vizEngine.draw(this.refs.chart, visualType, options, this.renderCompleted);
      } catch (e) {
        console && console.error(e.message, e);
        this.setState({ chartMsg: 'Can\'t draw chart' });
      }
    }

    /**
     * Constructs the visualization specific options using configured builder
     * @param {Object} optionsMapping Options mapping
     * @param {string} visualType The visualization spec type, e.g. 'line' in Highchart.
     * @param {Function} optionsBuilder The option builder class
     */

  }, {
    key: 'buildOptions',
    value: function buildOptions(optionsMapping, visualType, optionsBuilder) {
      var _props2 = this.props,
          chartOptions = _props2.chartOptions,
          chartData = _props2.chartData,
          seriesOptions = _props2.seriesOptions,
          onClickXLabel = _props2.onClickXLabel,
          onClickYLabel = _props2.onClickYLabel;


      var Builder = optionsBuilder || _Izenda2.default;

      var builder = new Builder(visualType, this.refs.chart, chartData, chartOptions, seriesOptions);
      builder.mapOptionValues(optionsMapping);

      onClickXLabel && builder.setOnClickXLabel(function (e) {
        return onClickXLabel(e);
      });
      onClickYLabel && builder.setOnClickYLabel(function (e) {
        return onClickYLabel(e);
      });

      return builder.build();
    }
  }]);
  return SimpleChart;
}(_react.Component)) || _class;

exports.default = SimpleChart;
module.exports = exports['default'];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ErrorContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Error Container Component
 */
!function () {
  var React = __webpack_require__(0);
  var GridLayout = __webpack_require__(13);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;

  var ErrorContainer = React.createClass({
    displayName: 'ErrorContainer',

    /**
     * render component
     * @returns {Object}
     */
    render: function render() {
      var errors = this.props.errors;
      if (isEmpty(errors)) {
        return null;
      }

      var errorItems = errors.map(function (error, index) {
        return React.createElement(
          GridLayout.Col,
          { className: 'error static-message', key: index },
          error
        );
      });

      return React.createElement(
        GridLayout.Row,
        null,
        errorItems
      );
    }
  });

  module.exports = ErrorContainer;
}();

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFrontSideViewer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(1899);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(152);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(27);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(142);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(246);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(319);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(40);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(155);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartFrontSideViewer = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartFrontSideViewer, _Component);

  function ReportPartFrontSideViewer(props) {
    (0, _classCallCheck3.default)(this, ReportPartFrontSideViewer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartFrontSideViewer.__proto__ || (0, _getPrototypeOf2.default)(ReportPartFrontSideViewer)).call(this, props));

    _this.completedRender = function () {
      var _this$props = _this.props,
          finishedRender = _this$props.finishedRender,
          printingMode = _this$props.printingMode;


      printingMode && typeof evoPdfConverter !== 'undefined' && evoPdfConverter.startConversion();

      typeof finishedRender === 'function' && finishedRender();
    };

    _this.mountReportPartDom = function (ref) {
      _this.mounted = true;
      _this.frontSidePartRef = ref;
    };

    _this.state = {
      fulfilledData: false
    };
    var reportPart = props.reportPart;

    _this.mounted = false;
    // Load custom format here, it's will remove when 20193 implement
    _Izenda16.default.loadCustomDataFormat();

    _this.reportPartStore = new _Izenda2.default();
    _this.reportPartStore.pageId = props.page;

    if (reportPart) {
      // already have report part provide by parent component
      //  don't need to load report part definition and report part data
      _this.reportPartStore.reportPart = props.reportPart;
      _this.reportPartStore.readyData = true;
    } else {
      _this.reloadData(props).then(function () {
        _this.mounted && _this.reportPartStore.readyData && _this.setState({ fulfilledData: true });
      });
    }
    return _this;
  }

  (0, _createClass3.default)(ReportPartFrontSideViewer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          notInvokeRenderCallBackAfterDidMount = _props.notInvokeRenderCallBackAfterDidMount,
          reportPart = _props.reportPart,
          printingMode = _props.printingMode;

      if (!notInvokeRenderCallBackAfterDidMount) {
        (0, _fp.invoke)('afterRenderCallBack', this.props);
      }

      reportPart && _Izenda14.default.Integration && _Izenda12.default.updateReportPart(reportPart);

      if (reportPart && printingMode) {
        this.setState({ fulfilledData: true });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var props = this.props,
          reportPartStore = this.reportPartStore;
      var previewRecords = props.previewRecords;

      if (props.reportPartId !== nextProps.reportPartId || props.reportPartDef !== nextProps.reportPartDef || !(0, _fp.isEqual)(props.subReportFilter, nextProps.subReportFilter)) {
        this.reloadData(nextProps);
      } else if (!props.setting && (!(0, _fp.isEqual)(props.subReportFilter, nextProps.subReportFilter) || _Izenda14.default.Integration && reportPartStore.reportPart)) {
        reportPartStore.updatePreviewData(nextProps.subReportFilter, reportPartStore.reportPart, { filters: nextProps.crosssfilters }, null, nextProps.printingMode, true, previewRecords);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(nextProps.printingMode && this.state.fulfilledData === nextState.fulfilledData);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      _Izenda14.default.Integration && _Izenda12.default.updateReportPart(this.reportPartStore.reportPart);
      (0, _fp.invoke)('afterRenderCallBack', this.props);
    }
  }, {
    key: 'reloadData',
    value: function reloadData(props) {
      var reportPartDef = props.reportPartDef,
          printingMode = props.printingMode,
          intergrateMode = props.intergrateMode,
          location = props.location,
          subReportFilterFromQuery = props.subReportFilterFromQuery,
          subReportFilter = props.subReportFilter,
          reportPartId = props.reportPartId,
          reportId = props.reportId,
          previewRecords = props.previewRecords;
      var reportPartStore = this.reportPartStore;

      var query = intergrateMode ? props.query : (0, _fp.get)('query', location);

      var draftId = (0, _fp.getOr)(null, 'draftId', query);
      var reportPartName = (0, _fp.getOr)(null, 'reportPartName', query);
      var filterPromise = subReportFilterFromQuery ? _Izenda10.default.resolveSubReportFilter(subReportFilterFromQuery) : (0, _bluebird.resolve)(subReportFilter);

      return filterPromise.then(function (subReportFilter) {
        if (draftId && reportPartName) {
          return reportPartStore.getDraftReportPartDefinition(draftId, reportPartName, subReportFilter, printingMode, previewRecords);
        } else if (reportPartDef) {
          return reportPartStore.updateDefinition(reportPartDef, subReportFilter, printingMode, previewRecords);
        }
        return reportPartStore.getReportPartDefinition(reportPartId, subReportFilter, printingMode, reportId, previewRecords);
      });
    }

    /**
     * Call when the report part completes rendering its content.
     */

  }, {
    key: 'checkBreakPage',


    /**
     * Check break page.
     * This is intended to support exporting get part with specific separator value.
     */
    value: function checkBreakPage() {
      var reportPart = this.reportPartStore.reportPart;

      return reportPart.reportPartContent.checkBreakPage && reportPart.reportPartContent.checkBreakPage();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;

      var store = this.props.store || this.reportPartStore;
      var reportPart = this.reportPartStore.reportPart;
      var _props2 = this.props,
          subReportFilter = _props2.subReportFilter,
          printingMode = _props2.printingMode,
          hideGridPopup = _props2.hideGridPopup,
          embededReportPart = _props2.embededReportPart,
          containerSizeFixed = _props2.containerSizeFixed,
          forExporting = _props2.forExporting,
          width = _props2.width,
          height = _props2.height,
          exportFormatSetting = _props2.exportFormatSetting,
          setting = _props2.setting,
          afterRenderCallBack = _props2.afterRenderCallBack,
          isFirstReportPart = _props2.isFirstReportPart,
          hideTitle = _props2.hideTitle,
          separator = _props2.separator,
          publishDrillInfo = _props2.publishDrillInfo,
          forDashboard = _props2.forDashboard,
          viewMode = _props2.viewMode,
          previewRecords = _props2.previewRecords;

      if (!reportPart) {
        return _react2.default.createElement(_Izenda4.default, { show: true });
      }

      var FrontSide = _Izenda8.default.getReportFrontSide(reportPart.type, props.reportPart && props.store ? _Izenda8.default.DISPLAY_SECTION.Report : _Izenda8.default.DISPLAY_SECTION.Viewer);

      var defaultSize = { width: '100%', height: '100%' };
      var containerWidth = void 0,
          containerHeight = void 0;

      if (embededReportPart) {
        containerWidth = props.containerWidth;
        containerHeight = props.containerHeight;
      }

      var style = containerSizeFixed ? reportPart.getContainerSize(containerWidth, containerHeight) : defaultSize;
      var containerStyle = !printingMode ? style : defaultSize;

      if (forExporting) {
        containerStyle.width = width;
        containerStyle.height = height;
      }

      var content = _react2.default.createElement(FrontSide, {
        style: printingMode && !forExporting ? style : defaultSize,
        reportPart: reportPart,
        store: store,
        subReportFilter: subReportFilter,
        afterRenderCallBack: afterRenderCallBack,
        printingMode: printingMode,
        setting: setting,
        exportFormatSetting: exportFormatSetting,
        finishedRender: this.completedRender,
        fulfilledData: this.state.fulfilledData,
        doesBreakPage: this.checkBreakPage(),
        isFirstReportPart: isFirstReportPart,
        hideTitle: hideTitle,
        separator: separator,
        forExporting: forExporting,
        embededReportPart: embededReportPart,
        hideGridPopup: printingMode || hideGridPopup || embededReportPart,
        publishDrillInfo: publishDrillInfo,
        forDashboard: forDashboard,
        viewMode: viewMode,
        frontSidePartRef: this.frontSidePartRef,
        previewRecords: previewRecords
      });
      return _react2.default.createElement(
        'div',
        { style: containerStyle, ref: this.mountReportPartDom, className: 'izenda-ReportPartFrontSideViewer-container' },
        printingMode || props.containerSizeFixed && reportPart.autoSize ? content : _react2.default.createElement(
          _Izenda6.default,
          null,
          content
        )
      );
    }
  }]);
  return ReportPartFrontSideViewer;
}(_react.Component), _class2.propTypes = {
  containerSizeFixed: _propTypes2.default.bool
}, _class2.defaultProps = {
  containerSizeFixed: true
}, _temp)) || _class;

exports.default = ReportPartFrontSideViewer;
module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPaletteStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(75);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(961);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ColorPaletteStore = (_class = function () {
  function ColorPaletteStore() {
    (0, _classCallCheck3.default)(this, ColorPaletteStore);

    _initDefineProp(this, 'palettes', _descriptor, this);

    this.originalColorPalette = null;
    this.currentColorPalette = null;
    this.needMaskDefault = false;
  }

  (0, _createClass3.default)(ColorPaletteStore, [{
    key: 'init',


    /**
     * Initial instant
     * @param {string} originalColorPalette
     * @param {boolean} needMaskDefault
     */
    value: function init(originalColorPalette, needMaskDefault, defaultColorThemeLabel) {
      this.originalColorPalette = this.currentColorPalette = originalColorPalette;
      this.needMaskDefault = needMaskDefault;
      return this.loadThemes(defaultColorThemeLabel);
    }

    /**
     * Load themes
     * @param {string} defaultColorThemeLabel
     */

  }, {
    key: 'loadThemes',
    value: function loadThemes(defaultColorThemeLabel) {
      var _this = this;

      return _Izenda2.default.fetchThemes().then(function (result) {
        _this.palettes = result.map(function (item) {
          return new _Izenda4.default(item, defaultColorThemeLabel);
        });
        return result;
      });
    }

    /**
     * Get color palette detail by name
     * @param {string} name
     */

  }, {
    key: 'getColorPaletteDetail',
    value: function getColorPaletteDetail(name) {
      var _this2 = this;

      if (!this.palettes) {
        return null;
      }

      var matchingPalette = this.palettes.find(function (item) {
        return item.name === name;
      });
      if (!matchingPalette) {
        matchingPalette = this.palettes.find(function (item) {
          return item.name === _this2.defaultColorPalette;
        });
      }

      if (!!matchingPalette && this.needMaskDefault && matchingPalette.name === this.defaultColorPalette) {
        var defaultText = _Izenda6.default.getText('COLORPALETTE_DEFAULT');
        matchingPalette.displayName = matchingPalette.displayName + ' (' + defaultText + ')';
      }

      this.currentColorPalette = matchingPalette.name;
      this.originalColorPalette = matchingPalette.name;
      return matchingPalette;
    }

    /**
     * Set current selected color palette
     * @param {string} name
     */

  }, {
    key: 'updateSelectedPalette',
    value: function updateSelectedPalette(name) {
      this.currentColorPalette = name;
    }

    /**
     * Reset current palette to original one
     */

  }, {
    key: 'resetSelectedPalette',
    value: function resetSelectedPalette() {
      if ((0, _fp.isUndefined)(this.originalColorPalette)) {
        this.currentColorPalette = this.defaultColorPalette;
      } else {
        this.currentColorPalette = this.originalColorPalette;
      }
    }

    /**
     * Update original after selected ok
     * @param {string} name 
     */

  }, {
    key: 'updateOriginalPalette',
    value: function updateOriginalPalette(name) {
      this.originalColorPalette = name;
    }
  }, {
    key: 'defaultColorPalette',
    get: function get() {
      var palette = (0, _fp.find)('isDefaultTheme', this.palettes);
      return palette ? palette.name : null;
    }
  }]);
  return ColorPaletteStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'palettes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'defaultColorPalette', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'defaultColorPalette'), _class.prototype)), _class);
exports.default = ColorPaletteStore;
module.exports = exports['default'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(962);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(84);

var _Izenda4 = __webpack_require__(35);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(320);

var _Izenda7 = _interopRequireDefault(_Izenda6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_VERTICAL_ALIGNMENT = _Izenda3.DEFAULT_VALUE_PROPERTIES.VERTICAL_ALIGNMENT; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridStylingUtil.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Part Gris Setting component
 */

exports.default = {
  /**
   * get Cell style for Pivot header
   * @param  {Object} columnData
   * @return {Object} style of header
   */
  getCellStyleForPivotHeader: function getCellStyleForPivotHeader(columnData, columnLocInfo) {
    var _props = this.props,
        reportPart = _props.reportPart,
        records = _props.records;

    var properties = reportPart.getReportPartProperties();
    var border = (0, _fp.get)('border', properties.table);
    var reportPartHeaderProperties = properties.headers;
    var stylePivotHeader = {};

    if (columnData.isColumnHeader) {
      return { backgroundColor: _Izenda3.EMPTY_CELL_BACKGROUND_COLOR };
    }

    // Border top for first level only
    if (border.top && columnLocInfo.deep === 1 && !columnData.hideTopLeftBorder) {
      stylePivotHeader = (0, _fp.assign)(stylePivotHeader, _Izenda2.default.getBorderStyle('Top', border.top));
    }

    // Border middle if it not first level
    if (border.midHor && columnLocInfo.deep !== 1 && !columnData.hideTopLeftBorder) {
      stylePivotHeader = (0, _fp.assign)(stylePivotHeader, _Izenda2.default.getBorderStyle('Top', border.midHor));
    }

    // Border left
    if (border.left && columnLocInfo.firstColumn && !columnData.hideTopLeftBorder) {
      stylePivotHeader = (0, _fp.assign)(stylePivotHeader, _Izenda2.default.getBorderStyle('Left', border.left));
    }

    // Border mid vertical
    if (border.midVer && !columnLocInfo.firstColumn) {
      stylePivotHeader = (0, _fp.assign)(stylePivotHeader, _Izenda2.default.getBorderStyle('Left', border.midVer));
    }

    if (border.right && columnLocInfo.lastColumn && !columnData.hideTopLeftBorder) {
      stylePivotHeader = (0, _fp.assign)(stylePivotHeader, _Izenda2.default.getBorderStyle('Right', border.right));
    }

    var backGroundColor = '';
    var wordWrapStyle = {};
    var verticalAlign = '';
    if (columnData.isColumnGroup) {
      if (columnData.value) {
        backGroundColor = (0, _fp.get)('font.backgroundColor', reportPartHeaderProperties);
        verticalAlign = (0, _fp.get)('verticalAlignment', reportPartHeaderProperties);
        wordWrapStyle = (0, _fp.get)('wordWrap', reportPartHeaderProperties) ? {
          wordWrap: 'break-word',
          whiteSpace: 'normal'
        } : {
          wordWrap: 'normal',
          whiteSpace: 'nowrap'
        };
      } else {
        backGroundColor = _Izenda3.EMPTY_CELL_BACKGROUND_COLOR;
      }
    } else if (columnData.element) {
      var element = columnData.element;
      var defaultBackGroundColor = columnData.element.properties.getDefaultsHeaderProperty('font.backgroundColor', reportPartHeaderProperties);

      var rawRecord = element.properties.hasRangePercent ? _Izenda7.default.buildRawRecordFilterForPivotGrid(columnData, records)[0] : {};

      var dataSource = {
        element: {
          columnName: (0, _fp.flow)((0, _fp.find)({ fieldNameAlias: element.field.fieldNameAlias }), (0, _fp.get)('columnName'))(reportPart.previewDataFieldsMapping),
          element: element
        },
        record: rawRecord
      };

      backGroundColor = _Izenda5.default.getConfigDataByRange(columnData.title, element.properties.dataFormattings.color.cellColor, dataSource) || defaultBackGroundColor;

      verticalAlign = element.properties.dataFormattings.verticalAlignment || properties.columns.verticalAlignment;

      if (columnData.element.properties.getDefaultsHeaderProperty('font.wordWrap', reportPartHeaderProperties)) {
        wordWrapStyle = {
          wordWrap: 'break-word',
          whiteSpace: 'normal'
        };
      } else {
        wordWrapStyle = {
          wordWrap: 'normal',
          whiteSpace: 'nowrap'
        };
      }
    } else {
      backGroundColor = properties.table && properties.table.backgroundColor;
    }

    return (0, _fp.flow)((0, _fp.defaults)(_fp.placeholder, {
      background: backGroundColor,
      verticalAlign: verticalAlign
    }), (0, _fp.defaults)(_fp.placeholder, wordWrapStyle))(stylePivotHeader);
  },


  /**
   * Create style object
   * @param  {Object} cellStyle
   * @return {Object}
   */
  createStyleObject: function createStyleObject(cellStyle) {
    return (0, _fp.defaults)(_Izenda3.DEFAULT_CELL_STYLE, {
      fontFamily: cellStyle.fontFamily,
      fontSize: cellStyle.fontSize + 'px',
      fontWeight: cellStyle.bold ? 'bold' : 'normal',
      textAlign: cellStyle.alignment || 'none',
      textDecoration: cellStyle.underline ? 'underline' : 'none',
      fontStyle: cellStyle.italic ? 'italic' : 'normal',
      color: cellStyle.textColor || '',
      wordWrap: cellStyle.wordWrap ? 'break-word' : 'normal',
      whiteSpace: cellStyle.wordWrap ? 'normal' : 'nowrap'
    });
  },


  /**
   * get Cell style setting
   * @param  {Object} reportPart
   * @param  {Object} columnData
   * @param  {Object} rowIndex
   * @param  {Object} columnIndex
   * @return {Object} cellStyleSetting
   */
  getCellStyleSetting: function getCellStyleSetting(reportPart, columnLocInfo, rowIndex, columnIndex, numberOfRow, isHeader) {
    var borderStyle = {};
    var background = void 0;
    var properties = reportPart.getReportPartProperties();
    var border = (0, _fp.get)('border', properties.table);
    var getBorderStyle = _Izenda2.default.getBorderStyle;
    var alternativeBackgroundColor = (0, _fp.get)('alternativeBackgroundColor', properties.table);
    var alternativebackgroundColorColumn = (0, _fp.get)('alterBackgroundColor', properties.columns) ? 1 : 0;
    var alternativebackgroundColorRow = (0, _fp.get)('alterBackgroundColor', properties.rows) ? 1 : 0;
    var tableBackgroundColor = (0, _fp.get)('backgroundColor', properties.table);
    var headerColor = (0, _fp.get)('backgroundColor', properties.headers.font);
    var headerVerticalAlign = (0, _fp.get)('verticalAlignment', properties.headers);
    var rowsHeight = (0, _fp.get)('height', properties.rows);

    /* Border setting*/
    // Border top
    if (border.top && isHeader) {
      borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Top', border.top));
    }

    // Border bottom
    if (border.bottom && rowIndex === numberOfRow) {
      borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Bottom', border.bottom));
    }

    // Border mid vertical
    if (border.midVer && !columnLocInfo.firstColumn) {
      borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Left', border.midVer));
    }

    // Border left
    if (border.left && columnLocInfo.firstColumn) {
      borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Left', border.left));
    }

    // Border right
    if (border.right && columnLocInfo.lastColumn) {
      borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Right', border.right));
    }

    // Border mid Horizontal
    if (border.midHor && (rowIndex < numberOfRow || isHeader)) {
      borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Bottom', border.midHor));
    }

    /* Color setting*/
    if (tableBackgroundColor) {
      background = (columnIndex * alternativebackgroundColorColumn + rowIndex * alternativebackgroundColorRow) % 2 === 0 ? tableBackgroundColor : alternativeBackgroundColor;
    }

    return (0, _fp.defaults)(borderStyle, {
      backgroundColor: isHeader ? headerColor : background,
      verticalAlign: isHeader ? headerVerticalAlign : DEFAULT_VERTICAL_ALIGNMENT,
      height: rowsHeight
    });
  },


  /**
   * get Data Formattings (font/alignment, Color/BackGroundColor, Alternating Text)
   * @param  {Object} element
   * @param  {String} value
   * @return {Object} cellStyleSetting
   */
  getDataFormattings: function getDataFormattings(element, value, rawRecord, reportPart) {
    var styleObject = this.createStyleObject(element.properties.getUIStyle());
    var colorSetting = this.getColorSetting(element, value, rawRecord, reportPart);

    return (0, _fp.defaults)(styleObject, colorSetting);
  },


  /**
   * get Color/BackGroundColor setting
   * @param  {Object} element
   * @param  {String} value
   * @return {Object} colorSetting
   */
  getColorSetting: function getColorSetting(element, value, rawRecord, reportPart) {
    var dataSource = {
      element: _Izenda5.default.buildDataSourceElement(reportPart, element),
      record: rawRecord[0]
    };

    return {
      backgroundColor: _Izenda5.default.getConfigDataByRange(value, element.properties.dataFormattings.color.cellColor, dataSource),
      color: _Izenda5.default.getConfigDataByRange(value, element.properties.dataFormattings.color.textColor, dataSource)
    };
  }
};
module.exports = exports['default'];

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure, $izenda) {

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.List.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module CollapsibleList component
 * @example
 *   <CollapsibleList>
 *     <CollapsibleList.Item>
 *       <CollapsibleList.ItemHeader>
 *       </CollapsibleList.ItemHeader>
 *       <CollapsibleList.ItemBody>
 *       </CollapsibleList.ItemBody>
 *     </CollapsibleList.Item>
 *   </CollapsibleList>
 */
!function () {
  var React = __webpack_require__(0);

  var classnames = __webpack_require__(11);
  var m = __webpack_require__(5);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      omit = _require.omit,
      each = _require.each,
      concat = _require.concat,
      find = _require.find,
      castArray = _require.castArray,
      chain = _require.chain,
      isNil = _require.isNil,
      isString = _require.isString,
      invoke = _require.invoke;

  var excludeProps = omit;

  var CollapsibleList = React.createClass({
    displayName: 'CollapsibleList',

    propTypes: {
      autoCollapse: React.PropTypes.bool,
      defaultExpand: React.PropTypes.bool
    },
    getDefaultProps: function getDefaultProps() {
      return {
        autoCollapse: true,
        defaultExpand: false
      };
    },
    render: function render() {
      return React.createElement(
        'div',
        (0, _extends3.default)({}, excludeProps(['children', 'autoCollapse', 'defaultExpand', 'afterToogleCallback'], this.props), {
          'data-container': 'true'
        }),
        this.renderItems()
      );
    },

    renderItems: function renderItems() {
      var isItem = each(function (child) {
        return child.type === 'Item';
      });

      ensure(isItem(this.props.children), 'Child item of CollapsibleList must be CollapsibleList.Item');
      var children = castArray(this.props.children);

      return children.map(function (child) {
        return React.cloneElement(child, {
          autoCollapse: this.props.autoCollapse,
          defaultExpand: this.props.defaultExpand
        });
      }.bind(this));
    }
  });

  CollapsibleList.Item = observer(React.createClass({
    displayName: 'Item',

    getDefaultProps: function getDefaultProps() {
      return {
        autoCollapse: true,
        defaultExpand: false
      };
    },
    componentWillMount: function componentWillMount() {
      this.defaultExpand = this.props.itemExpanded || !!this.props.defaultExpand;
      this.observableProps = m.observable({
        expanded: this.defaultExpand
      });
    },
    componentDidMount: function componentDidMount() {
      this.defaultExpand = false;
    },
    render: function render() {
      var header = this.renderChildByType('ItemHeader');
      var body = this.renderChildByType('ItemBody', true);

      var finalHeader = React.cloneElement(header, {
        expanded: this.observableProps.expanded,
        autoCollapse: this.props.autoCollapse,
        toggleCollapse: this.toggleCollapse
      });

      var finalBody = body ? React.cloneElement(body, {
        expanded: this.observableProps.expanded,
        defaultExpand: this.defaultExpand,
        afterToogleCallback: this.props.afterToogleCallback,
        ref: 'itemBody'
      }) : undefined;

      var rest = excludeProps(['children', 'autoCollapse', 'defaultExpand', 'itemExpanded', 'toggleCollapse', 'expanded', 'afterToogleCallback'], this.props);

      return React.createElement(
        'div',
        (0, _extends3.default)({}, rest, { 'aria-expanded': this.observableProps.expanded }),
        finalHeader,
        finalBody
      );
    },
    renderChildByType: function renderChildByType(childType, optional) {
      var foundChild = find(function (child) {
        return child.type.displayName === childType;
      })(concat([], this.props.children));

      ensure(optional || foundChild, 'CollapsibleList.Item must have %s', childType);

      return foundChild;
    },

    toggleCollapse: m.action(function () {
      this.refs.itemBody && this.refs.itemBody.collapse(this.observableProps);
    })
  }));

  CollapsibleList.ItemHeader = React.createClass({
    displayName: 'ItemHeader',

    render: function render() {
      var props = this.props;

      var safeChildren = chain(props.children).castArray().filter(function (item) {
        return !isNil(item);
      }).value();

      var rest = excludeProps(['children', 'expanded', 'autoCollapse', 'toggleCollapse', 'afterToogleCallback'], props);
      return React.createElement(
        'div',
        (0, _extends3.default)({ onClick: props.autoCollapse ? props.toggleCollapse : null, 'aria-expanded': props.expanded }, rest),
        safeChildren.map(function (child) {
          if (isString(child.type)) {
            return child;
          }
          return React.cloneElement(child, {
            toggleCollapse: props.toggleCollapse
          });
        })
      );
    }
  });
  CollapsibleList.ItemBody = React.createClass({
    displayName: 'ItemBody',

    // this property only affect first render
    componentWillMount: function componentWillMount() {
      this.defaultExpand = this.props.defaultExpand;
      this.animationStatus = false;
    },
    componentWillUnmount: function componentWillUnmount() {
      this.dom && $izenda(this.dom).off('hide.bs.collapse show.bs.collapse hidden.bs.collapse shown.bs.collapse');
    },
    setDom: function setDom(dom) {
      if (this.dom && this.dom !== dom) {
        $izenda(this.dom).off('hide.bs.collapse show.bs.collapse hidden.bs.collapse shown.bs.collapse');
        this.endAnimation();
      }
      this.dom = dom;
      dom && $izenda(dom).off('hide.bs.collapse show.bs.collapse hidden.bs.collapse shown.bs.collapse').on('hide.bs.collapse show.bs.collapse', this.startAnimation).on('hidden.bs.collapse shown.bs.collapse', this.endAnimation);
    },
    render: function render() {
      var props = this.props;

      var classes = classnames(props.className, 'collapse', {
        in: this.defaultExpand
      });
      var rest = excludeProps(['children', 'className', 'defaultExpand', 'toggleCollapse', 'expanded', 'afterToogleCallback'], props);

      return React.createElement(
        'div',
        (0, _extends3.default)({ className: classes, ref: this.setDom, 'aria-expanded': props.expanded }, rest),
        props.children
      );
    },
    startAnimation: function startAnimation() {
      this.animationStatus = true;
    },
    endAnimation: function endAnimation() {
      this.animationStatus = false;
      invoke('afterToogleCallback', this.props);
    },
    collapse: function collapse(observerObject) {
      this.defaultExpand = false;
      if (!this.animationStatus) {
        var expanded = observerObject.expanded = !observerObject.expanded;
        $izenda(this.dom).collapse(expanded ? 'show' : 'hide');
      }
    }
  });

  module.exports = CollapsibleList;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(26)))

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Font.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var FontFormat = __webpack_require__(186);
  var FontStyle = __webpack_require__(266);
  var ColorPicker = __webpack_require__(169);
  var UIConstants = __webpack_require__(34);

  var Font = React.createClass({
    displayName: 'Font',


    propTypes: {
      value: React.PropTypes.object,
      onChange: React.PropTypes.func,
      disabled: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
      return {
        value: {
          style: {},
          format: {},
          color: UIConstants.textColor,
          backgroundColor: UIConstants.textBackgrounColor
        },
        showBackgroundColor: true,
        disabled: false
      };
    },

    getInitialState: function getInitialState() {
      var props = this.props;
      var value = props.value || {};
      return {
        style: value.style,
        format: value.format,
        color: value.color,
        backgroundColor: value.backgroundColor,
        disabled: props.disabled
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value || {};
      this.setState({
        style: value.style,
        format: value.format,
        color: value.color,
        backgroundColor: value.backgroundColor,
        disabled: nextProps.disabled
      });
    },

    changeState: function changeState(key, value) {
      var obj = {};
      obj[key] = value;
      this.setState(obj, function () {
        var props = this.props;
        props.onChange && props.onChange({ value: this.state });
      }.bind(this));
    },

    render: function render() {
      var state = this.state;
      var props = this.props;

      var handleFontFormatChanged = function (format) {
        this.changeState('format', format.value);
      }.bind(this);

      var handleFontStyleChanged = function (fontStyle) {
        this.changeState('style', fontStyle.value);
      }.bind(this);

      var handleColorChanged = function (color) {
        this.changeState('color', color);
      }.bind(this);

      var handleBackgroundChanged = function (color) {
        this.changeState('backgroundColor', color);
      }.bind(this);

      return React.createElement(
        'fieldset',
        { className: 'font', disabled: state.disabled },
        React.createElement(FontFormat, { disabled: state.disabled, value: state.format, onChange: handleFontFormatChanged }),
        React.createElement(
          'div',
          { className: 'color-font-style' },
          React.createElement(FontStyle, { value: state.style, border: true, onChange: handleFontStyleChanged, className: 'u_floatLeft' }),
          React.createElement(ColorPicker, { iconName: 'icon-font',
            color: state.color,
            disabled: state.disabled,
            onChange: handleColorChanged,
            position: this.props.position }),
          props.showBackgroundColor && React.createElement(ColorPicker, { iconName: 'icon-font',
            isHighlightControl: true,
            color: state.backgroundColor,
            disabled: state.disabled,
            onChange: handleBackgroundChanged,
            position: this.props.position })
        )
      );
    }

  });

  module.exports = Font;
}();

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor; // ----------------------------------------------------------------------
// <copyright file="Izenda.VerticalLayout.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * VerticalLayout component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var VerticalLayout = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(VerticalLayout, _Component);

  function VerticalLayout() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VerticalLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VerticalLayout.__proto__ || (0, _getPrototypeOf2.default)(VerticalLayout)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'sizeOfTitle', _descriptor, _this), _this.getContainerSize = function () {
      if ((0, _fp.isNil)(_this.container)) {
        return {};
      }

      return {
        width: _this.container.clientWidth,
        height: _this.container.clientHeight - _this.title.clientHeight
      };
    }, _this.setContainer = function (container) {
      _this.container = container;
    }, _this.setTitle = function (title) {
      _this.title = title;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VerticalLayout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.sizeOfTitle.height = this.title.clientHeight;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className;

      var containerSize = this.getContainerSize();
      var classes = (0, _classnames2.default)('u_fullSize', className);

      return _react2.default.createElement(
        'div',
        { className: classes, ref: this.setContainer },
        _react2.default.createElement(
          'div',
          { ref: this.setTitle },
          children[0]
        ),
        !(0, _fp.isNil)(this.sizeOfTitle.height) && _react2.default.createElement(
          'div',
          { style: containerSize },
          _react2.default.cloneElement(children[1], { containerSize: containerSize })
        )
      );
    }
  }]);
  return VerticalLayout;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'sizeOfTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return { height: null };
  }
})), _class2)) || _class;

exports.default = VerticalLayout;
module.exports = exports['default'];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.LoadingIndicator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(152);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(207);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingIndicator = (_dec = (0, _Izenda6.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LoadingIndicator, _Component);

  function LoadingIndicator(props) {
    (0, _classCallCheck3.default)(this, LoadingIndicator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoadingIndicator.__proto__ || (0, _getPrototypeOf2.default)(LoadingIndicator)).call(this, props));

    _this.onLoadingChanged = function (loading, loadingProps) {
      _this.loadingProps = loadingProps || {};
      _this.isMountedStatus && _this.setState({
        show: loading
      });
    };

    _this.onCancel = function () {
      _Izenda4.default.cancelLoading(_this.props.loader);
    };

    _this.allowToCancelProgress = function () {
      // loading is mapped to global mapping (show/hide though PageService & LoadingIndicator)
      return _Izenda4.default.allowToCancelGlobalProgress(_this.props.loader);
    };

    _this.state = {
      show: false
    };

    _this.isMountedStatus = false;
    _this.unregister = props.loader.registerLoadingChanged(_this.onLoadingChanged);
    return _this;
  }

  (0, _createClass3.default)(LoadingIndicator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isMountedStatus = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unregister();
      this.isMountedStatus = false;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Izenda2.default, { show: this.state.show, onCancel: this.onCancel, allowToCancelProgress: this.allowToCancelProgress });
    }
  }]);
  return LoadingIndicator;
}(_react.Component), _class2.propTypes = {
  loader: _propTypes2.default.object.isRequired
}, _temp)) || _class);
exports.default = LoadingIndicator;
module.exports = exports['default'];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Header
 */
!function () {
  var React = __webpack_require__(0);
  var ReportFormatElement = __webpack_require__(980);
  var CONSTANTS = __webpack_require__(106);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      omit = _require.omit;

  var ReportHeader = React.createClass({
    displayName: 'ReportHeader',

    componentDidMount: function componentDidMount() {
      var store = this.props.store;
      store.loadDefaultImageUrl(store.tenantId);
    },
    publishFinishedRender: function publishFinishedRender() {
      var props = this.props;
      props.finishedRender && props.finishedRender();
    },
    componentDidUpdate: function componentDidUpdate() {
      this.props.printingMode && this.publishFinishedRender();
    },
    render: function render() {
      var props = this.props;
      var store = props.store;
      var headerElement = store.reportHeader;
      var masterModel = store.masterModel || {};
      var reportFormats = masterModel.reportFormats || {};
      var headerFooter = reportFormats.headerFooter || {};
      var localization = props.localization;
      var afterToggled = props.afterToggled;
      var className = classnames('report-format-header', props.className);

      return props.viewMode && (isEmpty(headerElement.formatItems) || !headerFooter.visible) ? null : React.createElement(ReportFormatElement, (0, _extends3.default)({
        store: store,
        className: className,
        afterToggled: afterToggled,
        title: localization.getText('REPORTDESIGNER_TOOLTIP_REPORT_HEADER'),
        formatElement: headerElement,
        cols: CONSTANTS.NUMBER_HEADER_COLS,
        rows: CONSTANTS.NUMBER_HEADER_ROWS,
        viewMode: props.viewMode
      }, omit(['className'], props), {
        setting: props.setting,
        horizontalAlign: props.horizontalAlign,
        fillWidth: props.printingMode
      }));
    }
  });

  module.exports = connect()(ReportHeader);
}();

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFooter.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Footer
 */
!function () {
  var React = __webpack_require__(0);
  var ReportFormatElement = __webpack_require__(980);
  var CONSTANTS = __webpack_require__(106);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      omit = _require.omit;

  var ReportFooter = React.createClass({
    displayName: 'ReportFooter',

    publishFinishedRender: function publishFinishedRender() {
      var props = this.props;
      props.finishedRender && props.finishedRender();
    },
    componentDidUpdate: function componentDidUpdate() {
      this.props.printingMode && this.publishFinishedRender();
    },
    render: function render() {
      var props = this.props;
      var store = props.store;
      var footerElement = store.reportFooter;
      var masterModel = store.masterModel || {};
      var reportFormats = masterModel.reportFormats || {};
      var headerFooter = reportFormats.headerFooter || {};
      var localization = props.localization;
      var className = classnames('report-format-footer', props.className);

      return props.viewMode && (isEmpty(footerElement.formatItems) || !headerFooter.visible) ? null : React.createElement(ReportFormatElement, (0, _extends3.default)({
        store: store,
        className: className,
        title: localization.getText('REPORTDESIGNER_TOOLTIP_REPORT_FOOTER'),
        formatElement: footerElement,
        cols: CONSTANTS.NUMBER_FOOTER_COLS,
        rows: CONSTANTS.NUMBER_FOOTER_ROWS,
        viewMode: props.viewMode,
        style: props.style
      }, omit(['className'], props), {
        setting: props.setting,
        horizontalAlign: props.horizontalAlign,
        fillWidth: props.printingMode
      }));
    }
  });

  module.exports = connect()(ReportFooter);
}();

/***/ }),
/* 416 */,
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _descriptor2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PillDefinition.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INCreadDashboardDefinition.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(269);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var PillDefinition = (_class = function PillDefinition(id, reportPart, tooltip) {
  (0, _classCallCheck3.default)(this, PillDefinition);

  _initDefineProp(this, 'reportPart', _descriptor, this);

  _initDefineProp(this, 'tooltip', _descriptor2, this);

  this.reportPart = reportPart;
  this.id = id;
  this.tooltip = tooltip;
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'reportPart', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'tooltip', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class);
exports.default = PillDefinition;
module.exports = exports['default'];

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1999);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorSelect = (0, _Izenda6.default)()(_Izenda8.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.UserLookUp.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * UserLookUp component
 */

var UserLookUp = function UserLookUp(props) {
  return _react2.default.createElement(
    'div',
    { className: 'izenda-Recipient-Container' },
    _react2.default.createElement(ValidatorSelect, {
      textboxMode: true,
      multi: true,
      hiddenMenu: true,
      searchable: false,
      clearable: false,
      disabled: props.disabled || props.readOnly,
      options: props.data,
      valueKey: props.valueField,
      labelKey: props.textField,
      value: props.value,
      validations: props.validations,
      field: props.field,
      group: props.group,
      onChange: props.onChange
    }),
    props.usingPopup && _react2.default.createElement(
      'a',
      null,
      _react2.default.createElement('span', {
        onClick: !props.readOnly && props.openPopupAddUserPopup,
        className: 'icon-plus',
        title: _Izenda4.default.getText('USER_LABEL_SELECT_USER')
      })
    )
  );
};

UserLookUp.propTypes = {
  disabled: _propTypes2.default.bool,
  usingPopup: _propTypes2.default.bool,
  data: _propTypes2.default.array,
  valueField: _propTypes2.default.string,
  textField: _propTypes2.default.string,
  field: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  validations: _propTypes2.default.object,
  userModeType: _propTypes2.default.number
};

exports.default = (0, _Izenda2.default)(_Izenda10.default)(UserLookUp);
module.exports = exports['default'];

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
// ----------------------------------------------------------------------
// <copyright file="Izenda.UserAccountStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(941);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(75);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(274);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(12);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2001);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(985);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(275);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(15);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(124);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(54);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var UserAccountStore = (0, _Izenda22.default)(_class = (_class2 = function () {
  function UserAccountStore(loadUsers, userModeType) {
    (0, _classCallCheck3.default)(this, UserAccountStore);

    _initDefineProp(this, 'model', _descriptor, this);

    _initDefineProp(this, 'configUser', _descriptor2, this);

    _initDefineProp(this, 'configUserCloned', _descriptor3, this);

    _initDefineProp(this, 'alertMessage', _descriptor4, this);

    _initDefineProp(this, 'isLoadingData', _descriptor5, this);

    this.loadUsers = loadUsers;
    this.userModeType = userModeType; // This config for get avaiable user
  }

  (0, _createClass3.default)(UserAccountStore, [{
    key: 'loadAllUserAccounts',
    value: function loadAllUserAccounts() {
      var _this = this;

      var model = this.model;
      var populateUserAccounts = (0, _mobx.action)(function (userAccount) {
        _this.isLoadingData = false;
        userAccount && _this.model.populateUserAccountList(userAccount);
        return (0, _bluebird.resolve)(true);
      });

      model.pageInfo.buildPagingRequest();
      this.isLoadingData = true;

      var fetcherFn = (0, _fp.isNil)(this.loadUsers) ? _Izenda4.default.loadAllUserAccounts(this.tenantId, model.pageInfo, null, this.userModeType) : this.loadUsers(model.pageInfo);

      return fetcherFn.then(populateUserAccounts);
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      _Izenda18.default.setCheckDirtyFunction(function () {
        return _this2.isDirty;
      });
    }

    /**
     * destroy observe
     * @method destroy
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      (0, _fp.invoke)('disposeReaction', this.model);
      _Izenda18.default.resetCheckDirtyFunction();
    }

    /**
     * load All User Setup
     * @return {Promise}
     */

  }, {
    key: 'loadAllUserSetup',
    value: function loadAllUserSetup() {
      var tenantId = this.tenantId;
      var model = this.model;
      var onlyBasicInfo = true;

      return (0, _bluebird.join)(_Izenda6.default.loadAllLanguages(), _Izenda6.default.loadAllDateFormat(), _Izenda8.default.getRoleList(tenantId, null, onlyBasicInfo), (0, _mobx.action)(function (languageList, dateFormatList, roleList) {
        model.populateLanguageList(languageList);
        model.populateDateFormatList(dateFormatList);
        model.populateRoleList(roleList);
      }));
    }

    /**
     * set Select First User
     * @return {promise}
     */

  }, {
    key: 'setSelectFirstUser',
    value: function setSelectFirstUser() {
      if (!(0, _fp.isEmpty)(this.model.userAccountList)) {
        this.selectUser(this.model.userAccountList[0]);
      } else {
        this.addUser();
      }
      return (0, _bluebird.resolve)(true);
    }

    /**
     * Handle when page size change
     */

  }, {
    key: 'onPageSizeChange',
    value: function onPageSizeChange(pageSize) {
      this.model.pageInfo.setPageSize(pageSize);
      return this.goToPage(1);
    }

    /**
     * Handle go to page
     * @param  {int} pageIndex
     */

  }, {
    key: 'goToPage',
    value: function goToPage(pageIndex) {
      var pageInfo = this.model.pageInfo;
      pageInfo.setPageIndex(pageIndex);
      return this.loadAllUserAccounts();
    }

    /**
     * Search subscription
     * @param  {string} searchProperty
     * @param  {string} searchText
     */

  }, {
    key: 'search',
    value: function search(searchProperty, searchText) {
      this.model.pageInfo.setSearchValues(searchProperty, searchText);
      return this.goToPage(1);
    }

    /**
     * Change sort orders
     * @param {string} columnKey
     * @param {object} sortDir
     */

  }, {
    key: 'onSortChange',
    value: function onSortChange(columnKey, sortDir) {
      this.model.pageInfo.setColSortDirs(columnKey, sortDir);
      return this.loadAllUserAccounts();
    }

    /**
     * Update filter criteria information.
     * @param {String} searchProperty
     * @param {String} searchText
     */

  }, {
    key: 'updateSearchCriteria',
    value: function updateSearchCriteria(searchProperty, searchText) {
      this.model.pageInfo.setSearchValues(searchProperty, searchText);
    }

    /**
     * load user list
     * @return {promise}
     */

  }, {
    key: 'loadUserList',
    value: function loadUserList() {
      var _this3 = this;

      var tenantId = this.tenantId;
      return _Izenda6.default.getAllUsers(tenantId).then(function (respone) {
        return _this3.usersList.readUserListInfo(respone);
      });
    }

    /**
     * Load partial user list for lazy loading
     * @return {promise}
     */

  }, {
    key: 'getPartialUsers',
    value: function getPartialUsers(pageInfo, isSearching) {
      var _this4 = this;

      var searchKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var userAccountList = (0, _fp.get)('model.userAccountList', this);
      var isFirstLoad = (0, _fp.isNil)(pageInfo) || (0, _fp.isEmpty)(userAccountList);
      pageInfo = pageInfo || this.lazyLoadingStore.pageInfoForFirstTime;

      var params = {
        tenantId: this.tenantId,
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        criteria: [{
          key: _Izenda20.default.USER_LIST_SEARCH_KEY,
          value: searchKey
        }]
      };

      return _Izenda6.default.getPartialUsers(params).then(function (respone) {
        var filterText = (0, _fp.get)('filterText', _this4.model);
        (searchKey === filterText || (0, _fp.isEmpty)(searchKey) === (0, _fp.isEmpty)(filterText)) && _this4.model.populateLazyUserAccountList(respone, isSearching);
        isFirstLoad && _this4.setSelectFirstUser();
      });
    }

    /**
     * add new user
     * @type {[type]}
     */

  }, {
    key: 'addUser',
    value: function addUser() {
      var otherConfig = _Izenda2.default.advancedSettings.other;
      this.model.resetAllSelected();
      this.resetAlertMessage();
      this.configUser = new _Izenda14.default();
      this.configUser.dataOffset = otherConfig.timezoneForDataOffsetValue;
      this.configUser.timestampOffset = otherConfig.timezoneForTimestampOffsetValue;
      this.cloneUserSetupDetail();
    }

    /**
     * select User
     * @param  {object} user
     */

  }, {
    key: 'selectUser',
    value: function selectUser(user) {
      this.resetAlertMessage();
      this.model.resetAllSelected();
      this.configUser = user;
      this.configUser.updateSelected(true);
      this.cloneUserSetupDetail();
    }

    /**
     * reset alert message
     */

  }, {
    key: 'resetAlertMessage',
    value: function resetAlertMessage() {
      this.alertMessage = {};
    }

    /**
     * generate Password Link
     */

  }, {
    key: 'generatePasswordLink',
    value: function generatePasswordLink() {
      var user = this.configUserCloned;
      var data = {
        id: user.id,
        username: user.userName,
        firstname: user.firstName,
        lastname: user.lastName,
        emailaddress: user.emailAddress
      };
      return _Izenda4.default.generatePasswordLink(data).then(user.populatePasswordLink.bind(user));
    }

    /**
     * set User Status
     * @param {object} userInfo
     * @param {boolean} activate
     */

  }, {
    key: 'setUserStatus',
    value: function setUserStatus(userInfo, activate) {
      var _this5 = this;

      var fn = activate ? _Izenda4.default.activateUser : _Izenda4.default.deactivateUser;
      var readUserStatus = (0, _mobx.action)(function (result) {
        if ((0, _fp.isNil)(result.messages)) {
          userInfo.populateData(result);
          _this5.cloneUserSetupDetail();
          return true;
        }
        return result;
      });
      return fn(userInfo).bind(this).then(readUserStatus);
    }

    /**
     * clone User Setup Detail
     */

  }, {
    key: 'cloneUserSetupDetail',
    value: function cloneUserSetupDetail() {
      this.configUserCloned = new _Izenda14.default((0, _fp.cloneDeep)(_Izenda16.default.toJS(this.configUser)));
    }

    /**
     * save user setup detail cloned
     * @return {promise}
     */

  }, {
    key: 'save',
    value: function save() {
      var _this6 = this;

      var configUser = this.configUser;
      var configUserCloned = this.configUserCloned;
      var data = configUserCloned.getDataForSave(configUserCloned);
      var handleAfterSave = (0, _mobx.action)(function (result) {
        if ((0, _fp.isNil)(result.messages)) {
          result.hasChangeLanguage = configUserCloned.hasChangeLanguage;
          if (configUserCloned.isNew) {
            var newUser = _this6.model.addUser(result.data);
            _this6.selectUser(newUser);
          } else {
            configUser.populateData(result.data);
            configUserCloned.populateData(result.data);
          }
          // populate data for my profile
          if (_Izenda18.default.currentUser.id === result.data.id) {
            _Izenda18.default.currentUser.populate(result.data);
          }
          configUserCloned.resetDirty();
          configUserCloned.resetRecipientValue();
          configUserCloned.resetPasswordLink();
          _this6.alertMessage = {
            type: 'success',
            message: _Izenda10.default.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED')
          };
        }

        return result;
      });

      (0, _assign2.default)(data, {
        tenantId: this.tenantId
      });
      return _Izenda4.default.save(data).bind(this).then(handleAfterSave);
    }

    /**
     * save Password Options
     * @return {promise}
     */

  }, {
    key: 'savePasswordOptions',
    value: function savePasswordOptions() {
      var _this7 = this;

      var data = this.configUserCloned.getDataForSavePasswordOptions();
      var handleAfterSave = (0, _mobx.action)(function (success) {
        if (success) {
          _this7.alertMessage = {
            type: 'success',
            message: _Izenda10.default.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED')
          };
          return success;
        }

        return null;
      });
      return _Izenda4.default.savePasswordOptions(data).bind(this).then(handleAfterSave);
    }

    /**
     * delete User
     * @param  {object} user
     */

  }, {
    key: 'deleteUser',
    value: function deleteUser(user) {
      var _this8 = this;

      var userId = user.id;
      var handleDelete = (0, _mobx.action)(function (result) {
        if ((0, _fp.isNil)(result.messages)) {
          // Remove delete user
          _this8.model.deleteUser(user);
          _this8.setSelectFirstUser();
        }
        return result;
      });
      return _Izenda4.default.deleteUser(userId).bind(this).then(handleDelete);
    }

    /**
     * find RoleId
     * @return {array}
     */

  }, {
    key: 'findRoleId',
    value: function findRoleId(oldRoles, newRoles) {
      var listRoles = [];
      var listOldRoles = oldRoles && (0, _fp.split)(',', oldRoles);
      !(0, _fp.isEmpty)(listOldRoles) && listOldRoles.forEach(function (role) {
        !String.searchString(newRoles, role) && listRoles.push(role);
      });

      return listRoles;
    }

    /**
     * validate User Role Association
     * @return {promise}
     */

  }, {
    key: 'validateUserRoleAssociation',
    value: function validateUserRoleAssociation() {
      var configUserCloned = this.configUserCloned;

      if (configUserCloned.systemAdmin) {
        return (0, _bluebird.resolve)(true);
      }

      var oldRoles = this.configUser.rolesValue;
      var newRoles = configUserCloned.rolesValue;
      // find remove role id based on the the original role
      var removedRoleIds = this.findRoleId(oldRoles, newRoles);
      // find newly added role
      var addedRoleIds = this.findRoleId(newRoles, oldRoles);

      if ((0, _fp.isEmpty)(removedRoleIds)) {
        return (0, _bluebird.resolve)(true);
      }
      var data = {
        userId: configUserCloned.id,
        removedRoleIds: removedRoleIds,
        addedRoleIds: addedRoleIds
      };
      return _Izenda4.default.validateUserRoleAssociation(data).then(function (result) {
        if (!(0, _fp.isNil)(result.messages)) {
          !(0, _fp.isEmpty)(result.messages[0]) && configUserCloned.populateAfterValidateRoleAssociation(result.messages[0].detail);
        }

        return result;
      });
    }

    /**
     * check Last System Admin
     * @return {boolean}
     */

  }, {
    key: 'checkLastSystemAdmin',
    value: function checkLastSystemAdmin() {
      return _Izenda4.default.checkLastSystemAdmin();
    }

    /**
     * check Last System Admin
     * @return {boolean}
     */

  }, {
    key: 'validateEmails',
    value: function validateEmails(data) {
      var users = (0, _fp.filter)(function (user) {
        return (0, _fp.isEmpty)(user.emailAddress) || (0, _fp.isNil)(user.emailAddress);
      }, data);
      var message = _Izenda10.default.getText('DASHBOARD_SCHEDULING_CONSTANTS_RECIPIENT_NO_EMAIL');
      var errorMesaage = String.format(message, (0, _fp.flatMap)('fullName', users));
      this.alertMessage = { type: 'error', message: errorMesaage };
    }

    /**
     * Register lazy loading store
     */

  }, {
    key: 'registerLazyLoadingStore',
    value: function registerLazyLoadingStore(store) {
      this.lazyLoadingStore = store;
    }
  }, {
    key: 'tenantId',
    get: function get() {
      return _Izenda18.default.getTenantId();
    }
  }, {
    key: 'isDirty',
    get: function get() {
      return this.configUserCloned.isDirty;
    }

    /**
    * Load all user accounts
    */

  }]);
  return UserAccountStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda12.default();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'configUser', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'configUserCloned', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'alertMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'isLoadingData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'tenantId'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadAllUserAccounts', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadAllUserAccounts'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadAllUserSetup', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadAllUserSetup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setSelectFirstUser', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setSelectFirstUser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onPageSizeChange', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPageSizeChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'goToPage', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'goToPage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'search', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'search'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSortChange', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSortChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateSearchCriteria', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateSearchCriteria'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadUserList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadUserList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getPartialUsers', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getPartialUsers'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addUser', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addUser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'selectUser', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'selectUser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetAlertMessage', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetAlertMessage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'generatePasswordLink', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'generatePasswordLink'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setUserStatus', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setUserStatus'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cloneUserSetupDetail', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cloneUserSetupDetail'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'save', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'save'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'savePasswordOptions', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'savePasswordOptions'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteUser', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteUser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'validateEmails', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'validateEmails'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'registerLazyLoadingStore', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'registerLazyLoadingStore'), _class2.prototype)), _class2)) || _class;

exports.default = UserAccountStore;
module.exports = exports['default'];

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_VALUE = 0; // ----------------------------------------------------------------------
// <copyright file="Izenda.ExportConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//

var DEFAULT_SETTINGS = [{
  type: 0,
  topValue: 0.75,
  bottomValue: 0.75,
  leftValue: 0.7,
  rightValue: 0.7,
  headerValue: 0.3,
  footerValue: 0.3
}, {
  type: 1,
  topValue: 0.75,
  bottomValue: 0.75,
  leftValue: 0.25,
  rightValue: 0.25,
  headerValue: 0.3,
  footerValue: 0.3
}, {
  type: 2,
  topValue: 1,
  bottomValue: 1,
  leftValue: 1,
  rightValue: 1,
  headerValue: 0.5,
  footerValue: 0.5
}, {
  type: 3,
  topValue: 0.75,
  bottomValue: 0.75,
  leftValue: 0.7,
  rightValue: 0.7,
  headerValue: 0.3,
  footerValue: 0.3
}];
var MARGIN_VALUE = {
  NORMAL: 0,
  NARROW: 1,
  WIDE: 2,
  CUSTOM: 3
};
var ORIENTATION_VALUE = {
  PORTRAIT: 0,
  LANDSCAPE: 1
};

var SETTINGS_KEY = {
  ORIENTATION: 'orientation',
  MARGIN: 'margins',
  HORIZONTALLY: 'horizontally',
  VERTICALLY: 'vertically',
  PAGEBREAK: 'pageBreakAfterReportPart'
};
var COLS_LAYOUT = {
  MIN: 2,
  MEDIUM: 4,
  MAX: 8
};

var MARGIN_KEY = {
  TOP: 'top',
  LEFT: 'left',
  BOTTOM: 'bottom',
  HEADER: 'header',
  RIGHT: 'right',
  FOOTER: 'footer'
};

exports.default = {
  DEFAULT_VALUE: DEFAULT_VALUE,
  DEFAULT_SETTINGS: DEFAULT_SETTINGS,
  get MARGIN_OPTIONS() {
    return [{ label: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_NORMAL'), value: MARGIN_VALUE.NORMAL }, { label: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_NARROW'), value: MARGIN_VALUE.NARROW }, { label: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_WIDE'), value: MARGIN_VALUE.WIDE }, { label: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_CUSTOM'), value: MARGIN_VALUE.CUSTOM }];
  },
  get ORIENTATION_OPTIONS() {
    return [{
      label: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_PORTRAINT'),
      value: ORIENTATION_VALUE.PORTRAIT,
      icon: 'icon-doc'
    }, {
      label: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_LANDSCAPE'),
      value: ORIENTATION_VALUE.LANDSCAPE,
      icon: 'icon-doc-landscape'
    }];
  },
  SETTINGS_KEY: SETTINGS_KEY,
  MARGIN_VALUE: MARGIN_VALUE,
  ORIENTATION_VALUE: ORIENTATION_VALUE,
  COLS_LAYOUT: COLS_LAYOUT,
  LABEL_COL: 5,
  CONTROL_COL: 7,
  get MARGIN_INPUT() {
    return {
      TOP: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_MARGIN_TOP'),
      LEFT: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_MARGIN_LEFT'),
      BOTTOM: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_MARGIN_BOTTOM'),
      HEADER: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_MARGIN_HEADER'),
      RIGHT: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_MARGIN_RIGHT'),
      FOOTER: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_MARGIN_FOOTER')
    };
  },
  get LABEL() {
    return {
      ORIENTATION: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_ORIENTATION'),
      MARGIN: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_MARGIN'),
      CENTER_ON_PAGE: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_CENTER_ON_PAGE'),
      HORIZONTALLY: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_HORIZONTALLY'),
      VERTICALLY: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_VERTICALLY'),
      PAGE_BREAK: _Izenda2.default.getText('EXPORT_CONSTANTS_LABEL_PAGE_BREAK')
    };
  },
  MARGIN_KEY: MARGIN_KEY,
  MAX_WIDTH: 7.78,
  MAX_HEIGHT: 11.68,
  MIN_WIDTH: 0.5,
  MIN_HEIGHT: 0.01
};
module.exports = exports['default'];

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerFieldsStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(39);

var _Izenda2 = __webpack_require__(90);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(263);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda6 = __webpack_require__(987);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(191);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(16);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(89);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(58);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(12);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(318);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(35);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(106);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(207);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _IzendaReportWorker = __webpack_require__(2006);

var _IzendaReportWorker2 = _interopRequireDefault(_IzendaReportWorker);

var _Izenda26 = __webpack_require__(991);

var _Izenda27 = _interopRequireDefault(_Izenda26);

var _Izenda28 = __webpack_require__(992);

var _Izenda29 = __webpack_require__(422);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _Izenda31 = __webpack_require__(408);

var _Izenda32 = _interopRequireDefault(_Izenda31);

var _Izenda33 = __webpack_require__(155);

var _Izenda34 = _interopRequireDefault(_Izenda33);

var _Izenda35 = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * ReportDesignerFieldsStore
 */

var ReportDesignerFieldsStore = (_class = (_temp = _class2 = function () {
  function ReportDesignerFieldsStore(reportStore, viewMode, reportState) {
    (0, _classCallCheck3.default)(this, ReportDesignerFieldsStore);

    _initialiseProps.call(this);

    // master store
    this.reportStore = reportStore;
    this.viewMode = viewMode;
    this.tenantId = _IzendaUiState2.default.getTenantId();
    // Report info when get data for filter source
    this.reportState = reportState || _Izenda11.default.REPORT_STATE.POSTED;

    this.reportWorkerPendingList = [];
    this.reportWorkerPendingExecuted = [];
    this.previousPreviewData;

    /* main model of store */
    this.masterModel = reportStore.model;
  }

  (0, _createClass3.default)(ReportDesignerFieldsStore, [{
    key: 'loadAvailableQuerySourceFields',


    /**
     * Load available query source.
     * @param  {string} reportId
     * @return {promise}
     */
    value: function loadAvailableQuerySourceFields(reportId) {
      var dataTree = this.dataTree,
          masterModel = this.masterModel;

      var data = reportId || masterModel.getReportDefinition();

      return _Izenda3.default.availableQuerySourceFields(data).then(function (result) {
        dataTree.readDataSource(result);
        return (0, _bluebird.resolve)(true);
      });
    }

    /**
     * Get filter data
     * @param  {any} version
     * @param  {any} value
     * @param  {boolean} fromDataSourcePage
     * @param  {function} updateFilterDataCallBack
     * @param  {boolean} editMode
     * @return {promise}
     */

  }, {
    key: 'getFilterData',
    value: function getFilterData(version, value, fromDataSourcePage, updateFilterDataCallBack, editMode) {
      var _this = this;

      var dataTreeModel = this.dataTree;
      var reportFiltersModel = this.reportFilters;
      var reportId = this.reportId;
      var reportBody = this.model.reportBody;
      var data = fromDataSourcePage ? this.masterModel.getReportDefinition() : reportId;

      return (0, _bluebird.join)(_Izenda3.default.loadFilterOperatorGroup(), fromDataSourcePage ? _Izenda3.default.availableQuerySourceFields(data, this.reportStore.isLoadDraft) : null, !this.viewMode || editMode ? _Izenda3.default.loadFilterSource(data) : null, // Dont call this fetcher in View/Print mode
      (0, _mobx.action)(function (filterOperatorGroup, availableQuerySourceFields, querySource) {
        /* report filter */
        reportFiltersModel.populateOperatorGroup(filterOperatorGroup);
        !(0, _fp.isNil)(querySource) && reportFiltersModel.populateFilterQuerySource(querySource);
        reportFiltersModel.updateConfigFieldList(value, [], reportBody.viewMode);

        /* data source tree */
        !(0, _fp.isNil)(availableQuerySourceFields) && dataTreeModel.readDataSource(availableQuerySourceFields);
        (0, _fp.isFunction)(updateFilterDataCallBack) && updateFilterDataCallBack();

        return null;
      })).then(function () {
        var promiseList = [];
        reportFiltersModel.configFieldList.forEach(function (configField) {
          if ((0, _fp.contains)(configField.filterInfo.sourceType, ['fieldSource', 'inTimePeriod']) || (0, _fp.contains)(configField.filterInfo.operator.key, ['equals(checkbox)', 'notequal(checkbox)'])) {
            promiseList.push(_this.getOperatorValueSource(configField));
          }
        });

        return (0, _bluebird.all)(promiseList);
      }).then(function () {
        (!_this.viewMode || editMode) && _this.fillCalculatedFieldData();
        return true;
      });
    }

    /**
     * Load data for field or format page in report designer
     * @return {promise}
     */

  }, {
    key: 'loadInitial',
    value: function loadInitial() {
      var _this2 = this;

      var dataTree = this.dataTree,
          reportFilters = this.reportFilters,
          reportId = this.reportId;
      // Reset loadedDataSource when load inital data

      dataTree.loadedDataSource = false;

      return (0, _bluebird.join)(_Izenda3.default.loadFilterOperatorGroup(), _Izenda3.default.availableQuerySourceFields(reportId, this.reportStore.isLoadDraft), _Izenda3.default.loadFilterSource(reportId), (0, _mobx.action)(function (filterOperatorGroup, availableQuerySourceFields, querySource) {
        /* report filter */
        reportFilters.populateOperatorGroup(filterOperatorGroup);
        !(0, _fp.isNil)(querySource) && reportFilters.populateFilterQuerySource(querySource);

        // when receive operator data, recheck disable cascading
        reportFilters.disableCascading();

        /* data source tree */
        !(0, _fp.isNil)(availableQuerySourceFields) && dataTree.readDataSource(availableQuerySourceFields);

        _this2.fillCalculatedFieldData();
      }));
    }

    /**
     * Fill calculated field data
     * @param {string} excludeFieldId
     * @param {Array<any>} fields
     * @return {promise}
     */

  }, {
    key: 'fillCalculatedFieldData',
    value: function fillCalculatedFieldData(excludeFieldId, fields, includeCustomJsonFunction) {
      var _this3 = this;

      var source = this.dataTree.details;
      if (source.length === 0 || !source[0].querySource || source[0].querySource.length === 0) {
        return;
      }

      var selectedDataSource = source[0].querySource[0];

      var fieldFilterById = function fieldFilterById(items, id) {
        return (0, _fp.filter)(function (item) {
          return item.id !== excludeFieldId;
        }, items);
      };

      var dataSources = (0, _mobx.toJS)(source[0].querySource);

      source.length > 1 && source[1].querySource && (dataSources = dataSources.concat((0, _mobx.toJS)(source[1].querySource)));

      // Load fields data
      if (!fields) {
        fields = selectedDataSource && selectedDataSource.fields.map(function (field) {
          return {
            name: field.name,
            dataType: field.izendaDataType || field.dataType,
            description: field.expression
          };
        });
      }

      var selectedQuerySourceIds = (0, _fp.map)('id', source[0].querySource);

      return _Izenda9.default.fetchFunctionOperators(this.tenantId, selectedQuerySourceIds, includeCustomJsonFunction).then(function (functionExpression) {
        _this3.calculatedStore.fillCalculatedFieldData({
          databaseName: selectedDataSource.connectionName,
          fields: fieldFilterById(selectedDataSource.fields, excludeFieldId),
          id: selectedDataSource.id,
          name: selectedDataSource.name,
          schemaName: selectedDataSource.querySourceCategoryName
        }, dataSources, functionExpression, _this3.reportId, fields);
      });
    }

    /**
     * List all of api for filter-operator
     * @param {any}  configField
     * @param {any}  reportFilter
     * @returns {promise}
     */

  }, {
    key: 'getOperatorValueSource',
    value: function getOperatorValueSource(configField, reportFilter) {
      var filterDetails = configField && configField.filterInfo || {};

      if ((0, _fp.includes)((0, _fp.get)('operator.key', filterDetails), _Izenda13.default.NO_AUTOCOMPLETE_OPERATOR)) {
        return;
      }
      var dataType = configField.fieldDetails.izendaDataType || configField.fieldDetails.dataType;
      var reportId = this.reportId;
      var sourceType = filterDetails.sourceType;
      var data = this.masterModel.getReportDefinition();
      data.reportState = this.reportState;

      if (!!reportFilter) {
        data.report.reportFilter = reportFilter;
        (0, _fp.forEach)(function (item) {
          item.value = null;
          item.id === configField.fieldDetails.id && (item.selected = true);
        }, data.report.reportFilter.filterFields);
      } else {
        // Set selected field
        (0, _fp.forEach)(function (item) {
          if (item.uniqueId === configField.fieldDetails.uniqueId) {
            item.selected = true;
          }
        }, data.report.reportFilter.filterFields);
      }

      var populateData = function populateData(response) {
        configField.populateOperatorSourceValue(sourceType, response);
      };

      switch (sourceType) {
        case 'fieldSource':
          return _Izenda3.default.loadFilterDataSource(reportId, dataType).then(populateData);
        case 'inTimePeriod':
          return _Izenda3.default.loadTimeperiods().then(populateData);
        case 'dataSource':
          return _Izenda3.default.loadFilterFieldData(data).then(populateData);
        case 'dataSourceTree':
          return _Izenda3.default.loadFilterFieldData(data, true).then(populateData);
        default:
          // TODO - for testing
          return _Izenda3.default.loadFilterDataSource(reportId, dataType).then(populateData);
        // return Promise.resolve();
      }
    }

    /**
     * Load data source for filters
     * Use for individual filter in dashboard part.
     * @param {any} configFields
     * @param {any} reportFilter
     * @return {promise}
     */

  }, {
    key: 'getOperatorValueSources',
    value: function getOperatorValueSources(configFields, reportFilter) {
      var _this4 = this;

      var listPromise = [];

      (0, _fp.forEach)(function (item) {
        listPromise.push(_this4.getOperatorValueSource(item, (0, _fp.cloneDeep)((0, _mobx.toJS)(reportFilter))));
      }, configFields);

      return (0, _bluebird.all)(listPromise);
    }

    /**
     * Get partial data for filter value
     * @param  {any} pageInfo
     * @param  {any} configField
     * @param  {string} searchKey
     * @param  {boolean} isSearching
     * @param  {boolean} forDashboard
     * @return {promise}
     */

  }, {
    key: 'getData',
    value: function getData(pageInfo, configField, searchKey, isSearching, forDashboard) {
      var data = this.masterModel.getReportDefinition();
      var filterDetails = configField && configField.filterInfo || {};
      forDashboard && (data.report.reportFilter.filterFields = (0, _fp.map)(function (item) {
        return (0, _mobx.toJS)(item.fieldDetails);
      }, this.reportFilters.configFieldList));

      // Set selected field
      (0, _fp.forEach)(function (item) {
        item.selected = item.uniqueId === configField.fieldDetails.uniqueId;
      }, data.report.reportFilter.filterFields);

      data.reportState = this.reportState;

      var param = {
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        reportParameter: data,
        includeAll: false,
        includeBlank: false,
        criteria: [{
          key: 'filter',
          value: searchKey
        }]
      };

      if ((0, _fp.includes)(filterDetails.operator.key, ['equals(popup)', 'notequal(popup)'])) {
        param.includeBlank = true;
      }
      if ((0, _fp.includes)(filterDetails.operator.key, ['equals(manualentry)', 'equals(manualentrynoauto-complete)', 'notequal(manualentry)', 'notequal(manualentrynoauto-complete)', 'equals(selection)', 'notequal(selection)'])) {
        param.includeBlank = true;
        if (configField.fieldDetails.operatorSetting === _Izenda13.default.SELECT_SETTINGS.MULTIPLE) {
          param.includeAll = true;
        }
      }

      return _Izenda3.default.loadPartialFilterFieldData(param).then((0, _mobx.action)(function (response) {
        configField.updateOperatorSourceDisplay(response, isSearching);
      }));
    }

    /**
     * Update cascading filter value
     * @param  {any} configFields
     * @return {promise}
     */

  }, {
    key: 'updateCascadingValue',
    value: function updateCascadingValue(configFields) {
      var configFieldList = this.reportFilters.configFieldList || [];
      var filterIndex = configFieldList.indexOf(configFields);

      if (filterIndex < 0) {
        return (0, _bluebird.resolve)();
      }

      var promiseList = [];
      var isCascadingFilter = configFields.fieldDetails.cascading;
      if (isCascadingFilter) {
        for (var i = filterIndex + 1; i < configFieldList.length; i++) {
          promiseList.push(this.getOperatorValueSource(configFieldList[i]));
          configFieldList[i].fieldDetails.updateByKey('value', null);
          configFieldList[i].resetOperatorSourceDisplay();

          if (!configFieldList[i].fieldDetails.cascading) {
            break;
          }
        }
      }

      return (0, _bluebird.all)(promiseList);
    }

    /**
     * Update cascading filter value for Report Designer
     * @param  {any} fieldDetail
     */

  }, {
    key: 'updateReportDesignerCascadingFilter',
    value: function updateReportDesignerCascadingFilter(fieldDetail) {
      var filterFields = this.reportFilters.filterFields || [];
      var filterIndex = filterFields.indexOf(fieldDetail);

      if (filterIndex < 0) {
        return;
      }

      var isCascadingFilter = fieldDetail.cascading;
      if (isCascadingFilter) {
        for (var i = filterIndex + 1; i < filterFields.length; i++) {
          // Do not reset value of parameter filter field
          !filterFields[i].isParameter && filterFields[i].updateByKey('value', '');

          if (!filterFields[i].cascading) {
            break;
          }
        }
      }
    }

    /**
     * Validate filter type in subReport
     * @param {any} subreport
     * @returns {promise}
     */

  }, {
    key: 'validateFilterFieldsTypeSubReport',
    value: function validateFilterFieldsTypeSubReport(subReportData) {
      var reportFilter = this.model.reportFilter || {};
      var logic = reportFilter.logic;
      var subReport = subReportData || (0, _fp.getOr)({}, 'configReportPart.configField.properties.drillDown.subReport', this.reportBody);

      var reportId = subReport.selectedReport;
      var masterReportId = subReport.masterReportId || this.reportId;
      var inheritFilter = subReport.reportFilter;

      return !this.viewMode || logic ? _Izenda3.default.validateFilterFieldsTypeSubReport(reportId, masterReportId, inheritFilter) : (0, _bluebird.resolve)();
    }

    /**
     * Get warning message for ignored filters
     * @return {string}
     */

  }, {
    key: 'getUnspecifiedFilterWarning',
    value: function getUnspecifiedFilterWarning() {
      var reportFilter = this.model.reportFilter || {};
      var logic = reportFilter.logic,
          filterFields = reportFilter.filterFields;

      var message = '';
      if (logic && filterFields) {
        var result = (0, _fp.find)(function (item) {
          return item.state !== _Izenda11.default.OBJECT_STATE.DELETE && logic.indexOf(item.position) < 0;
        }, filterFields);
        if (result) {
          message = _Izenda11.default.BUNDLE.MESSAGE.FILTER_WILL_BE_IGNORED;
        }
      }
      return message;
    }

    /**
     * Validate filter syntax
     * @returns {promise}
     */

  }, {
    key: 'validateFilterSyntax',
    value: function validateFilterSyntax() {
      var reportFilter = this.model.reportFilter || {};
      var logic = reportFilter.logic,
          filterFields = reportFilter.filterFields;

      var positions = filterFields && (0, _fp.flow)((0, _fp.filter)(function (item) {
        return item.state !== _Izenda11.default.OBJECT_STATE.DELETE;
      }), (0, _fp.map)(function (item) {
        return item.position;
      }))(filterFields);

      var listFilterFields = (0, _fp.flatMap)(function (filter) {
        return (0, _fp.pick)(['alias', 'position', 'operatorId', 'isParameter'], filter);
      }, filterFields);

      var filterTypeValidate = (0, _fp.get)('report.reportFilter', this.masterModel.getReportDefinition('Fields'));

      return logic ? _Izenda3.default.validateFilterFieldsType(filterTypeValidate).then(function (result) {
        if (result) {
          return _Izenda11.default.FIELDS.M24;
        } else {
          return _Izenda3.default.validateFilterSyntax(logic, positions, listFilterFields).then(function (result) {
            return result.messages;
          });
        }
      }) : (0, _bluebird.resolve)('');
    }

    /**
     * Validate fields
     * @returns {promise}
     */

  }, {
    key: 'validateFields',
    value: function validateFields() {
      var reportStore = this.reportStore;
      var model = reportStore.model;
      var reportDesignerData = model.getReportDefinition();

      return _Izenda3.default.validate(reportDesignerData).then(function (result) {
        reportStore.setAlertDetails(result);
        return (0, _bluebird.resolve)(result.success);
      }, function (error) {
        var errors = error.responseJSON;
        reportStore.setAlertDetails({
          errors: [errors],
          message: errors.message,
          success: false
        });
        return (0, _bluebird.resolve)(false);
      });
    }

    /**
     * Load Initial Data For SubReport : Reports List, Fields
     * @param {string} selectedReportId
     * @return {promise}
     */

  }, {
    key: 'loadInitialSubReports',
    value: function loadInitialSubReports(selectedReportId) {
      var configReportPart = this.model.reportBody.configReportPart;

      return (0, _bluebird.join)(_Izenda3.default.loadFilterSource(selectedReportId), _Izenda3.default.loadForEdit(selectedReportId, this.reportStore.isLoadDraft), function (filterSource, reportData) {
        return {
          fieldInCurrentReportPart: configReportPart.visibleFieldCollection,
          fieldInSubReport: filterSource,
          reportData: reportData.report || {}
        };
      });
    }

    /**
     * Load Subreport data
     * @param {string} reportId
     * @return {promise}
     */

  }, {
    key: 'loadSubReportData',
    value: function loadSubReportData(reportId) {
      return (0, _bluebird.join)(_Izenda3.default.loadForEdit(reportId, this.reportStore.isLoadDraft), _Izenda3.default.loadFilterSource(reportId), function (reportData, filterSource) {
        return {
          reportData: reportData.report || {},
          fieldInSubReport: filterSource
        };
      });
    }

    /**
     * Get alertDetails from report store
     * @return {any}
     */

  }, {
    key: 'getAlertDetail',
    value: function getAlertDetail() {
      return this.reportStore.alertDetails;
    }

    /**
     * Add calculated field and bind result back to report middle panel and fill new data into calculated field
     * @param {any} calculatedData
     * @returns {promise}
     */

  }, {
    key: 'addCalculatedField',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(calculatedData) {
        var data, result, updatedCalField;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                calculatedData = calculatedData || {};
                data = {
                  reportKey: {
                    key: this.reportId
                  },
                  calculatedField: {
                    id: calculatedData.id || null,
                    name: calculatedData.name,
                    functionName: calculatedData.functionName,
                    expression: calculatedData.expression,
                    izendaDataType: calculatedData.izendaDataType
                  }
                };
                _context.next = 4;
                return _Izenda3.default.addCalculatedField(data);

              case 4:
                result = _context.sent;

                result.success !== false && this.dataTree.readCalculatedDataSource(result, true);
                _context.next = 8;
                return this.fillCalculatedFieldData(result);

              case 8:
                _context.next = 10;
                return this.getFilterSources();

              case 10:
                updatedCalField = (0, _fp.find)({ id: data.calculatedField.id }, result.querySource[0].fields);

                if (this.reportBody.updateElementInfo(data.calculatedField.id, data.calculatedField.name, updatedCalField)) {
                  this.updateReportsParts();
                }
                return _context.abrupt('return', true);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addCalculatedField(_x) {
        return _ref.apply(this, arguments);
      }

      return addCalculatedField;
    }()

    /**
     * Delete calculated field
     * @param {any} calculatedData
     * @returns {promise}
     */

  }, {
    key: 'deleteCalculatedField',
    value: function deleteCalculatedField(calculatedData) {
      var _this5 = this;

      calculatedData = calculatedData || {};
      var data = {
        reportKey: {
          key: this.reportId
        },
        calculatedField: {
          id: calculatedData.id || null
        }
      };
      return _Izenda3.default.deleteReportCalculatedField(data).then((0, _mobx.action)(function (result) {
        result && _this5.dataTree.deleteCalculatedField(calculatedData);
        return result;
      })).then(this.getFilterSources.bind(this));
    }

    /**
     * update data request common for both view mode and edi mode
     * @param {any} request
     * @param {any} reportPart
     * @param {any} drillDownData
     * @param {number} pageIndex
     * @returns {promise}
     */

  }, {
    key: 'buildCommonParamsGetDataRequest',
    value: function buildCommonParamsGetDataRequest(request, reportPart, drillDownData, pageIndex) {
      // Common params for both mode
      var reportPartContent = reportPart.reportPartContent;
      var optionalParams = reportPartContent.optionalParams || {};

      // pagination
      if (reportPartContent.usePagination || (0, _fp.get)('properties.usePagination', reportPartContent) || (0, _fp.get)('properties.view.usePagination', reportPartContent)) {
        optionalParams.paging = {
          pageIndex: pageIndex || _Izenda11.default.DEFAULT_PAGE_INDEX,
          pageSize: reportPartContent.properties.pageSize || _Izenda11.default.DEFAULT_PAGE_SIZE
        };
      }

      request = (0, _fp.assign)(request, optionalParams);

      drillDownData = drillDownData || (0, _fp.invokeArgs)('getDrilldownInfo', [this.masterModel.printingMode], reportPartContent);

      if (reportPartContent.isCrossFiltering) {
        Array.prototype.push.apply(drillDownData.filters, _Izenda21.default.transformFilterWithReportPart(reportPart, this.reportBody.crossFilteringDrillFilterInfo));
        drillDownData.filters = (0, _fp.uniqBy)(function (item) {
          return (0, _stringify2.default)((0, _fp.pick)(['key', 'fieldId', 'value', 'dataFormat'], item));
        }, drillDownData.filters);
      }

      if (drillDownData) {
        request = this.getDrillDownData(request, drillDownData);
      }

      request = (0, _fp.assign)(request, (0, _fp.omit)(['overridingFilterValue', 'filters'], this.masterModel.subReportFilter));
      request.filters = (0, _fp.concat)(request.filters || [], (0, _fp.getOr)([], 'filters', this.masterModel.subReportFilter));

      // in print mode we will get all data and ignore usePagination option
      if (this.masterModel.printingMode) {
        request = (0, _fp.omit)(['paging'], request);
      }

      return request;
    }

    /**
     * build data request for edit mode. System consider edit mode when report designer model is dirty
     * @param {any} reportPart
     * @param {any} drillDownData
     * @param {number} pageIndex
     * @returns {promise}
     */

  }, {
    key: 'buildRequestDataForEditMode',
    value: function buildRequestDataForEditMode(reportPart, drillDownData, pageIndex, useForThreshold) {
      // get data for
      var data = this.masterModel.getReportDefinition('Fields');

      // Filter report part, only send data for request report part
      data.report.reportPart = (0, _fp.flow)((0, _fp.filter)({
        title: reportPart.headerTitle
      }), (0, _fp.reject)({
        state: _Izenda15.default.DELETE
      }))(data.report.reportPart);
      if (useForThreshold) {
        var newReportPart = (0, _fp.head)(data.report.reportPart);
        newReportPart.reportPartContent = (0, _fp.assignIn)(newReportPart.reportPartContent, { customContainers: reportPart.reportPartContent.customContainers });
        data.report.reportPart.splice(0, 1, newReportPart);
      }

      data.title = reportPart.headerTitle;

      // Remove reportRelationships in Simple mode
      if (!data.report.advancedMode) {
        data.report.reportRelationship = [];
      }
      return this.buildCommonParamsGetDataRequest(data, reportPart, drillDownData, pageIndex);
    }

    /**
     * build data request for view mode. System consider edit mode when report designer model is not diry
     * @param {any} reportPart
     * @param {any} drillDownData
     * @param {number} pageIndex
     * @returns {promise}
     */

  }, {
    key: 'buildRequestDataForViewMode',
    value: function buildRequestDataForViewMode(reportPart, drillDownData, pageIndex) {
      var data = {
        loadDraft: this.reportStore.isLoadDraft,
        reportId: this.reportId,
        reportPartId: reportPart.id,
        tenantId: _IzendaUiState2.default.getTenantId(),
        userAction: this.viewMode ? _Izenda17.default.getText('REPORTDESIGNER_LOGGING_VIEWER_MODE') : _Izenda17.default.getText('REPORTDESIGNER_LOGGING_MODE')
      };

      data.overridingFilterValue = (0, _fp.get)('overridingFilterValue', this.masterModel.subReportFilter);

      return this.buildCommonParamsGetDataRequest(data, reportPart, drillDownData, pageIndex);
    }

    /**
     * get Report part data, only return promise that have data not modify report part object, common method for all get report part data
     * @param  {any} reportPart
     * @param  {any} drillDownData
     * @param  {number} pageIndex
     * @return {promise}
     */


    /**
     * get Report part data except Chart, only return promise that have data not modify report part object, common method
     * @param  {any} data
     * @return {promise}
     */

  }, {
    key: 'getDrillDownRecords',


    /**
     * get DrillDown Record for Grid Pivot/DrillDown This method only return raw data not modify report part object
     * @param  {any} reportPart
     * @param  {any} drillDownOption
     * @param  {number} pageIndex
     * @return {promise}
     */
    value: function getDrillDownRecords(reportPart, drillDownOption, pageIndex) {
      var configReportPart = reportPart || this.model.reportBody && this.model.reportBody.configReportPart;
      if (!configReportPart || !configReportPart.isBeingBuild) {
        configReportPart && configReportPart.setQueryData && configReportPart.setQueryData({});
        return (0, _bluebird.resolve)(false);
      }
      return this.getReportPartData(reportPart, drillDownOption, pageIndex);
    }

    /**
     * needUpdatePreview function is to get the data source to manage to show it in the preview
     * @param  {any} reportPart
     * @param  {any} drillDownOption
     * @param  {number} pageIndex
     * @param  {boolean} isHiddenLoading
     * @param  {boolean} isPrintMode
     * @param  {boolean} notUpdateFilter
     * @return {promise}
     */

  }, {
    key: 'needUpdatePreview',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(reportPart, drillDownData, pageIndex, isHiddenLoading, isPrintMode, notUpdateFilter, forceUpdate) {
        var configReportPart, data, type, postData, haveRefresh, colorPaletteStore, palettes;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                configReportPart = reportPart || this.model.reportBody && this.model.reportBody.configReportPart;


                !notUpdateFilter && this.model.reportBody.updateCrossFiltering(configReportPart, drillDownData);
                data = void 0, type = void 0;

                if (this.masterModel.checkDirty() || this.masterModel.draftId || !this.masterModel.active || configReportPart.useForThreshold) {
                  data = this.buildRequestDataForEditMode(configReportPart, drillDownData, pageIndex, configReportPart.useForThreshold);
                  type = 'REPORT_PART_REVIEW_DATA_CONFIG';
                } else {
                  data = this.buildRequestDataForViewMode(configReportPart, drillDownData, pageIndex);
                  type = 'REPORT_PART_REVIEW_DATA';
                }

                postData = JSON.parse((0, _stringify2.default)(data));
                haveRefresh = configReportPart && !(0, _fp.isNil)(configReportPart.refreshDataProcess);

                if (!(!haveRefresh && this.previousPreviewData && (0, _Izenda30.default)(this.previousPreviewData, postData) && !forceUpdate)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return', (0, _bluebird.resolve)(false));

              case 8:

                this.previousPreviewData = postData;

                // TODO: this check will be removed when all of report part types have lazy loading.
                // Currently, we run this check because QA cannot test with others part type.

                if (!(0, _fp.any)(function (type) {
                  return configReportPart.reportPartContent.type === type;
                }, [_Izenda11.default.REPORT_PART_TYPE.Chart, _Izenda11.default.REPORT_PART_TYPE.Map, _Izenda11.default.REPORT_PART_TYPE.Gauge])) {
                  _context2.next = 27;
                  break;
                }

                if (!(!configReportPart || !configReportPart.isBeingBuild)) {
                  _context2.next = 15;
                  break;
                }

                configReportPart && configReportPart.setQueryData && configReportPart.setQueryData({});
                return _context2.abrupt('return', (0, _bluebird.resolve)(false));

              case 15:
                // if master model is dirty we will use edit mode api, where we send all the report definition
                // if we use draft data we also need to send draft data definition
                configReportPart.setQueryData({}, true);

                // When this report part is used for exporting or printing, we set this flag so that the No. records loaded
                // should be adjusted for the purpose this actions
                this.masterModel.printingMode && (data.loadAll = true);
                colorPaletteStore = new _Izenda32.default();

                if (!(0, _fp.isEmpty)(configReportPart.colorPalettes)) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 21;
                return colorPaletteStore.loadThemes();

              case 21:
                palettes = _context2.sent;

                configReportPart.colorPalettes = palettes;

              case 23:

                this.createReportPartWorker(configReportPart, data, type);
                return _context2.abrupt('return', (0, _bluebird.resolve)({}));

              case 25:
                _context2.next = 28;
                break;

              case 27:
                return _context2.abrupt('return', this.needUpdatePreviewForGridForm(data, reportPart, drillDownData, pageIndex, isHiddenLoading, isPrintMode, notUpdateFilter));

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function needUpdatePreview(_x2, _x3, _x4, _x5, _x6, _x7, _x8) {
        return _ref2.apply(this, arguments);
      }

      return needUpdatePreview;
    }()

    /**
     * deletePreviousPreviewData is to clear the old report part preview data after deleting the report part
     */

  }, {
    key: 'deletePreviousPreviewData',
    value: function deletePreviousPreviewData() {
      this.previousPreviewData = null;
    }

    /**
     * needUpdatePreview function is to get the data source to manage to show it in the preview
     * @param  {any} data
     * @param  {any} reportPart
     * @param  {any} drillDownOption
     * @param  {number} pageIndex
     * @param  {boolean} isHiddenLoading
     * @param  {boolean} isPrintMode
     * @param  {boolean} notUpdateFilter
     * @param  {any} updateReviewData
     * @return {promise}
     */

  }, {
    key: 'loadReportPartDataByCrossFiltering',


    /**
     * Load data for related report parts by changed of cross filtering
     * @param {string} excludedPartId
     */
    value: function loadReportPartDataByCrossFiltering(excludedPartId) {
      var _this6 = this;

      // remove waiting executed cross-filter report part
      this.reportWorkerPendingExecuted = (0, _fp.filter)(function (reportWorkerPending) {
        return !reportWorkerPending.reportPart.isCrossFiltering;
      }, this.reportWorkerPendingExecuted);

      // Terminate cross-filter report part in process
      (0, _fp.forEach)(function (reportPending) {
        if (reportPending.reportPart.isCrossFiltering && excludedPartId !== reportPending.reportPart.id) {
          reportPending.worker.terminate();
        }
      }, this.reportWorkerPendingList);

      // remove cross-filter report part in process
      this.reportWorkerPendingList = (0, _fp.filter)(function (reportWorkerPending) {
        return !reportWorkerPending.reportPart.isCrossFiltering;
      }, this.reportWorkerPendingList);

      // apply worker list here
      (0, _fp.flow)((0, _fp.filter)(function (part) {
        return part.reportPartContent.isCrossFiltering && part.id !== excludedPartId;
      }), (0, _fp.forEach)(function (part) {
        var drillInfo = part.reportPartContent.getDrilldownInfo();
        Array.prototype.push.apply(drillInfo.filters, _Izenda21.default.transformFilterWithReportPart(part, _this6.reportBody.crossFilteringDrillFilterInfo));
        drillInfo.filters = (0, _fp.uniqBy)(function (item) {
          return (0, _stringify2.default)((0, _fp.pick)(['key', 'fieldId', 'value', 'dataFormat'], item));
        }, drillInfo.filters);
        _this6.needUpdatePreview(part, drillInfo, null, null, null, true);
      }))(this.model.reportBody.activeReportParts);
    }

    /**
    * Remove cross filtering items belong to report part.
    * @param {Object} reportPart
    */

  }, {
    key: 'removePillByReportPart',
    value: function removePillByReportPart(reportPart) {
      this.model.reportBody.removePillByReportPart(reportPart);
      this.loadReportPartDataByCrossFiltering();
    }

    /**
     * Remove a cross filtering item.
     * @param {any} pill
     */

  }, {
    key: 'removePill',
    value: function removePill(pill) {
      this.model.reportBody.removePill(pill);
      this.loadReportPartDataByCrossFiltering();
    }

    /**
     * Remove all cross filtering item.
     */

  }, {
    key: 'removeAllPills',
    value: function removeAllPills() {
      this.model.reportBody.removeAllPills();
      this.loadReportPartDataByCrossFiltering();
    }

    /**
     * Get random preview data by expanded level
     * @param {any} expandedLevel
     */

  }, {
    key: 'getRandomPreviewData',
    value: function getRandomPreviewData(expandedLevel) {
      var data = this.masterModel.getReportDefinition('Fields');
      data.title = _Izenda17.default.getText('COMMON_LABEL_CHART');
      data.expandedLevel = expandedLevel;
      data.filters = null;
      return _Izenda3.default.getRandomPreviewData(data);
    }

    /**
     * getDrillDownData function is to get the drill down data to manage to show it in the preview
     * @param {any} data
     * @param {any} drillDownData
     * @return report definition object.
     */

  }, {
    key: 'getDrillDownData',
    value: function getDrillDownData(data, drillDownData) {
      data.filters = drillDownData.filters || [];
      data.expandedLevel = !(0, _fp.isNil)(drillDownData.expandedLevel) ? drillDownData.expandedLevel : data.filters.length;
      return data;
    }

    /**
     * Load definition of report part.
     * @param  {string} id
     * @return {promise}
     */

  }, {
    key: 'loadReportPartDefinition',
    value: function loadReportPartDefinition(id) {
      return _Izenda3.default.loadReportPartDefinition(id);
    }

    /**
     * Update all report parts , use for Update Results button
     * @param {any} loader
     * @return {promise}
     */

  }, {
    key: 'updateReportsParts',
    value: function updateReportsParts(loader) {
      var _this7 = this;

      var model = this.model;
      var reportBody = model.reportBody || {};
      var promises = [];

      // reset all filters
      reportBody.removeAllPills();
      (0, _fp.flow)((0, _fp.reject)({ type: undefined }), (0, _fp.forEach)(function (reportPart) {
        _this7.needUpdatePreview(reportPart);
      }))(reportBody.activeReportParts);
      return (0, _bluebird.resolve)({});
    }

    /**
     * Get filter sources , add cuclated and aggregated field
     * @return {promise}
     */

  }, {
    key: 'getFilterSources',
    value: function getFilterSources() {
      return _Izenda3.default.loadFilterSource(this.reportId).then(this.reportFilters.populateFilterQuerySource.bind(this.reportFilters));
    }

    /**
     * Toggle snap to grid
     * @return {promise}
     */

  }, {
    key: 'toggleSnapToGrid',
    value: function toggleSnapToGrid() {
      var reportBody = this.reportBody;
      reportBody.snapToGrid = !reportBody.snapToGrid;
      reportBody.markDirty();
    }

    /**
     * Load report filter
     * @return {promise}
     */

  }, {
    key: 'loadReportFilter',
    value: function loadReportFilter() {
      var _this8 = this;

      return _Izenda3.default.loadFilterOfReport(this.reportId).then(function (result) {
        _this8.model.reportFilter.populateFilterList(result.filterFields);
        return result.filterFields;
      });
    }

    /**
     * Get default image url
     * @param {string}
     * @return {promise}
     */

  }, {
    key: 'loadDefaultImageUrl',
    value: function loadDefaultImageUrl(tenantId) {
      var _this9 = this;

      return _Izenda5.default.getDefaultImageUrl(tenantId).then(function (result) {
        var imageUrl = (0, _fp.get)('value', result);
        if (!(0, _fp.isEmpty)(imageUrl)) {
          var imageItems = _this9.reportHeader.formatItems.filter(function (item) {
            return item.type === 'image';
          });
          imageItems.forEach(function (item) {
            if (item.imageUrl === _Izenda23.default.ITEMS_TYPE.image.imageUrl || (0, _fp.isEmpty)(item.imageUrl)) {
              item.imageUrl = result.value;
            }
          });
        }
        _this9.masterModel.defaultImageUrl = result;
      });
    }

    /**
     * Clean cross filter setting
     */

  }, {
    key: 'resetCrossFilterDefaultValue',
    value: function resetCrossFilterDefaultValue() {
      this.removeAllPills();
      this.reportBody.cleanCrossFiltering();
    }

    /**
     * Create report part worker.
     * @param {any} reportPart
     * @param {any} data
     * @param {number} type
     */

  }, {
    key: 'createReportPartWorker',
    value: function createReportPartWorker(reportPart, data, type) {
      var currentIndex = (0, _fp.findIndex)(function (worker) {
        return worker.reportPart.id === reportPart.id;
      }, this.reportWorkerPendingList);

      // Get request data here
      var getPostData = function getPostData() {
        return {
          type: type,
          requestData: JSON.parse((0, _stringify2.default)(data)),
          apiInfo: (0, _Izenda28.getApiInfo)()
        };
      };

      // Terminate worker in list if another worker call
      if (currentIndex > -1) {
        var worker = this.reportWorkerPendingList[currentIndex].worker;
        worker.terminate();
        this.reportWorkerPendingList.splice(currentIndex, 1);
      }

      if (typeof Worker !== 'undefined') {
        if (this.reportWorkerPendingList.length < _Izenda27.default.WORKER_CHUNK) {
          var reportWorker = new _IzendaReportWorker2.default();
          reportWorker.onmessage = this.populateReportPartData.bind(this, reportWorker, reportPart);
          reportWorker.postMessage(getPostData());

          // Add report worker list which is used for drilldown
          this.reportWorkerPendingList.push({
            reportPart: reportPart,
            worker: reportWorker
          });
        } else {
          this.reportWorkerPendingExecuted.push({
            reportPart: reportPart,
            data: data,
            type: type
          });
        }
      }
    }

    /**
     * Populate report part data
     * @param {any} reportWorker
     * @param {any} reportPart
     * @param {any} event
     */

  }, {
    key: 'populateReportPartData',
    value: function populateReportPartData(reportWorker, reportPart, event) {
      var result = event.data;
      var reportStore = this.reportStore;
      // populate data or post error message to report part
      if (!result.messages) {
        reportPart.setQueryData && reportPart.setQueryData(result);
      } else {
        if (result.messages[0].key === _Izenda11.default.ERROR_KEY.reportPart) {
          this.reportPartErrorMessages.push({
            reportPartId: reportPart.id,
            message: result.messages[0].messages[0]
          });
          reportStore.setAlertDetails({
            errors: [{
              message: _Izenda17.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_INVALID_REPORTPART')
            }],
            success: false
          });
        } else {
          var keys = [_Izenda11.default.ERROR_KEY.calculatedfield, _Izenda11.default.ERROR_KEY.filter, _Izenda11.default.ERROR_KEY.relationship];
          var key = (0, _fp.includes)(result.messages[0].key, keys) ? 'report' : null;
          reportStore.setAlertDetails({
            errors: [{
              message: (0, _fp.find)({ key: '' }, result.messages).messages[0]
            }],
            success: false,
            key: key
          });
        }
        reportPart.setQueryData({});
      }

      // remove pending report worker in list
      this.reportWorkerPendingList.splice((0, _fp.findIndex)(function (worker) {
        return worker.reportPart.id === reportPart.id;
      }, this.reportWorkerPendingList), 1);

      // terminate reportWorker
      reportWorker.terminate();

      // start other worker if has
      if (this.reportWorkerPendingExecuted.length > 0) {
        var waitingReportPart = this.reportWorkerPendingExecuted[0];
        this.reportWorkerPendingExecuted.splice(0, 1);
        this.createReportPartWorker(waitingReportPart.reportPart, waitingReportPart.data, waitingReportPart.type);
      }
    }

    /**
     * Terminate AllReportPartWorker
     */

  }, {
    key: 'terminateAllReportPartWorker',
    value: function terminateAllReportPartWorker() {
      // Terminate all pending worker
      this.reportWorkerPendingExecuted = [];
      (0, _fp.forEach)(function (reportPending) {
        reportPending.worker.terminate();
      }, this.reportWorkerPendingList);

      // remove waiting list
      this.reportWorkerPendingList = [];
    }

    /**
     * Reset the function and format setting of all fields inside a report part content
     * @param {Object} reportPartContent Report part content
     */

  }, {
    key: 'resetFunctionFormat',
    value: function resetFunctionFormat(reportPartContent) {
      var valuesElements = reportPartContent.valuesElements,
          values = reportPartContent.values;

      var getFunction = function getFunction(_ref3) {
        var functionData = _ref3.functionData,
            formatData = _ref3.formatData;

        if (functionData) {
          functionData.defaultFormat = formatData ? {
            formatId: formatData.id,
            format: formatData.format,
            groupBy: formatData.groupBy,
            formatDataType: formatData.formatDataType
          } : '';
          return functionData;
        }
        return {};
      };

      var setElementFormatAndFunction = function setElementFormatAndFunction(element, info) {
        return (0, _mobx.action)(function (formatData) {
          element.properties.setFormat({
            formatId: formatData.id || null,
            format: formatData.format || null,
            groupBy: formatData.groupBy || null,
            formatDataType: formatData.formatDataType || null
          });

          return _Izenda21.default.setFunctionElement(reportPartContent, element, (0, _fp.omit)('defaultFormat', info) || {}, true /* manualChange */
          , true /* keep name */
          );
        });
      };

      return (0, _bluebird.all)(valuesElements.map(function (element) {
        return _Izenda21.default.getDefaultFunctionFormat(reportPartContent, values, element).then(getFunction).then(function (info) {
          var defaultFormatName = (0, _fp.get)([element.fieldDataType, info.name].join('.'), _Izenda35.DEFAULT_FORMAT_BY_FUNCTION_DATA_TYPE);
          var defaultFormatPromise = defaultFormatName ? _Izenda34.default.loadReportFieldDataFormat(element.fieldDataType).then((0, _fp.flow)((0, _fp.find)({ format: defaultFormatName }), defaults({}))) : (0, _bluebird.resolve)({});

          return defaultFormatPromise.then(setElementFormatAndFunction(element, info));
        });
      }));
    }
  }, {
    key: 'model',
    get: function get() {
      return this.reportStore.model.reportFields;
    }
  }, {
    key: 'dataTree',
    get: function get() {
      return this.model.dataTree;
    }
  }, {
    key: 'reportFilters',
    get: function get() {
      return this.model.reportFilter;
    }
  }, {
    key: 'reportId',
    get: function get() {
      return this.reportStore.reportId;
    }
  }, {
    key: 'reportBody',
    get: function get() {
      return this.model.reportBody;
    }
  }, {
    key: 'reportHeader',
    get: function get() {
      return this.model.reportHeader;
    }
  }, {
    key: 'reportFooter',
    get: function get() {
      return this.model.reportFooter;
    }
  }, {
    key: 'reportFormats',
    get: function get() {
      return this.reportStore.model.reportFormats;
    }
  }, {
    key: 'fieldQuerySource',
    get: function get() {
      var calculatedFieldDatSource = [];
      var querySource = (0, _mobx.toJS)(this.dataTree.details[0].querySource);

      var visibleQuerySource = (0, _fp.map)(function (querySource) {
        querySource.filterFields = (0, _fp.filter)({ inaccessible: false }, querySource.filterFields);
        querySource.fields = (0, _fp.filter)({ inaccessible: false }, querySource.fields);
        return querySource;
      }, querySource);

      if (this.dataTree.details.length > 1) {
        calculatedFieldDatSource = (0, _mobx.toJS)(this.dataTree.details[1].querySource);
      }

      return (0, _fp.concat)(visibleQuerySource.slice(), calculatedFieldDatSource);
    }
  }, {
    key: 'displayFieldQuerySource',
    get: function get() {
      var isHiddenDataType = function isHiddenDataType(field) {
        return _Izenda13.default.HIDDEN_DATA_TYPE.indexOf(field.dataType) === -1;
      };

      return (0, _fp.map)(function (querySource) {
        querySource.filterFields = (0, _fp.filter)(isHiddenDataType, querySource.filterFields);
        querySource.fields = (0, _fp.filter)(isHiddenDataType, querySource.fields);

        return querySource;
      }, this.fieldQuerySource);
    }
  }, {
    key: 'isVisibleHeaderFooter',
    get: function get() {
      return this.reportFormats.headerFooter.visible;
    }
  }, {
    key: 'isVisibleTitleDescription',
    get: function get() {
      return this.reportFormats.titleDescription.visible;
    }
  }, {
    key: 'reportTitleDescription',
    get: function get() {
      return this.model.reportTitleDescription;
    }
  }, {
    key: 'crossFilteringDrillFilterInfo',
    get: function get() {
      return this.model.reportBody.crossFilteringDrillFilterInfo;
    }
  }]);
  return ReportDesignerFieldsStore;
}(), _initialiseProps = function _initialiseProps() {
  var _this10 = this;

  _initDefineProp(this, 'masterModel', _descriptor, this);

  _initDefineProp(this, 'calculatedStore', _descriptor2, this);

  _initDefineProp(this, 'isLoading', _descriptor3, this);

  _initDefineProp(this, 'reportPartErrorMessages', _descriptor4, this);

  this.getReportPartData = _Izenda25.default.addLoadingProgress(_Izenda3.default, function (loader, fetcher) {
    return function (reportPart, drillDownData, pageIndex) {
      var data = null;
      var fetcherPromise = null;

      // if master model is dirty we will use edit mode api, where we send all the report definition
      // if we use draft data we also need to send draft data definition
      if (_this10.masterModel.checkDirty() || _this10.masterModel.draftId || !_this10.masterModel.active) {
        data = _this10.buildRequestDataForEditMode(reportPart, drillDownData, pageIndex);
        fetcherPromise = fetcher.getConfigReportPartPreviewData;
      } else {
        data = _this10.buildRequestDataForViewMode(reportPart, drillDownData, pageIndex);
        fetcherPromise = fetcher.getPreviewData;
      }

      // When this report part is used for exporting or printing, we set this flag so that the No. records loaded
      // should be adjusted for the purpose this actions
      if (_this10.masterModel.printingMode) {
        data.loadAll = true;
      }

      return fetcherPromise(data);
    };
  });
  this.getReportPartDataForReportPart = _Izenda25.default.addLoadingProgress(_Izenda3.default, function (loader, fetcher) {
    return function (data) {
      var fetcherPromise = null;
      // if master model is dirty we will use edit mode api, where we send all the report definition
      // if we use draft data we also need to send draft data definition
      if (_this10.masterModel.checkDirty() || _this10.masterModel.draftId || !_this10.masterModel.active) {
        fetcherPromise = fetcher.getConfigReportPartPreviewData;
      } else {
        fetcherPromise = fetcher.getPreviewData;
      }
      // When this report part is used for exporting or printing, we set this flag so that the No. records loaded
      // should be adjusted for the purpose this actions
      if (_this10.masterModel.printingMode) {
        data.loadAll = true;
      }
      return fetcherPromise(data);
    };
  });
  this.needUpdatePreviewForGridForm = _Izenda25.default.addLoadingProgress(_Izenda3.default, function (loader, fetcher) {
    return function (data, reportPart, drillDownData, pageIndex, isHiddenLoading, isPrintMode, notUpdateFilter, updateReviewData) {
      var configReportPart = reportPart || _this10.model.reportBody && _this10.model.reportBody.configReportPart;
      if (!configReportPart || !configReportPart.isBeingBuild) {
        configReportPart && configReportPart.setQueryData && configReportPart.setQueryData({});
        return (0, _bluebird.resolve)(false);
      }

      !notUpdateFilter && _this10.model.reportBody.updateCrossFiltering(configReportPart, drillDownData);
      !isHiddenLoading && (_this10.isLoading = true);

      var reportStore = _this10.reportStore;
      configReportPart.startLoadData();

      var embededReportDefPromise = _Izenda19.default.buildPromiseFetcher(configReportPart, fetcher.loadReportPartDefinition.bind(fetcher), fetcher.loadForEdit.bind(fetcher), _this10.viewMode);

      return (0, _bluebird.join)(_this10.getReportPartDataForReportPart.apply(_this10, (0, _fp.concat)(loader ? [loader] : [], [data])), embededReportDefPromise, function (result, embededReportDef) {
        if (!result.messages) {
          (0, _mobx.transaction)(function () {
            configReportPart.setQueryData(result);
            configReportPart.readEmbededReportDef(embededReportDef);
          });
        } else {
          if (result.messages[0].key === _Izenda11.default.ERROR_KEY.reportPart) {
            _this10.reportPartErrorMessages.push({
              reportPartId: configReportPart.id,
              message: result.messages[0].messages[0]
            });
            reportStore.setAlertDetails({
              errors: [{
                message: _Izenda17.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_INVALID_REPORTPART')
              }],
              success: false
            });
          } else {
            var keys = [_Izenda11.default.ERROR_KEY.calculatedfield, _Izenda11.default.ERROR_KEY.filter, _Izenda11.default.ERROR_KEY.relationship];
            var key = (0, _fp.includes)(result.messages[0].key, keys) ? 'report' : null;
            reportStore.setAlertDetails({
              errors: [{
                message: (0, _fp.find)({ key: '' }, result.messages).messages[0]
              }],
              success: false,
              key: key
            });
          }
          configReportPart.setQueryData({});
        }
        return result.messages || null;
      }).catch(function (error) {
        var errors = error.responseJSON || {};
        reportStore.setAlertDetails({
          errors: [errors],
          message: errors.message,
          success: false
        });
        configReportPart.setQueryData({});
        return false;
      }).finally(function () {
        !isHiddenLoading && (_this10.isLoading = false);
      });
    };
  });
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'masterModel', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'calculatedStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda7.default();
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'reportPartErrorMessages', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'model'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'dataTree', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'dataTree'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reportFilters', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reportFilters'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reportId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reportId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reportBody', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reportBody'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reportHeader', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reportHeader'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reportFooter', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reportFooter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reportFormats', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reportFormats'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fieldQuerySource', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fieldQuerySource'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'displayFieldQuerySource', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'displayFieldQuerySource'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isVisibleHeaderFooter', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isVisibleHeaderFooter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isVisibleTitleDescription', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isVisibleTitleDescription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reportTitleDescription', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reportTitleDescription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'crossFilteringDrillFilterInfo', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'crossFilteringDrillFilterInfo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadInitial', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadInitial'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateCascadingValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateCascadingValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateReportDesignerCascadingFilter', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateReportDesignerCascadingFilter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteCalculatedField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteCalculatedField'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'needUpdatePreview', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'needUpdatePreview'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateReportsParts', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateReportsParts'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getFilterSources', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getFilterSources'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleSnapToGrid', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleSnapToGrid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadReportFilter', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadReportFilter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetCrossFilterDefaultValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetCrossFilterDefaultValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'terminateAllReportPartWorker', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'terminateAllReportPartWorker'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetFunctionFormat', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetFunctionFormat'), _class.prototype)), _class);
exports.default = ReportDesignerFieldsStore;
module.exports = exports['default'];

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compare;

var _fp = __webpack_require__(1);

function compare(nextProps, props) {
  var hasEqual = true;
  (0, _fp.forEach)(function (key) {
    if (!(0, _fp.has)(key, props)) {
      hasEqual = false;
      return false;
    }
    if (!(0, _fp.isFunction)(nextProps[key])) {
      if (!(0, _fp.isEqual)(props[key], nextProps[key])) {
        if ((0, _fp.isPlainObject)(nextProps[key])) {
          hasEqual && (hasEqual = compare(nextProps[key], props[key]));
          if (!hasEqual) return false;
        } else {
          hasEqual = (0, _fp.isEqual)(props[key], nextProps[key]);
        }
      }
    }

    if (!hasEqual) return false;
  }, (0, _fp.keys)(nextProps));

  return hasEqual;
} // ----------------------------------------------------------------------
// <copyright file="Izenda.PropsComparison.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

module.exports = exports["default"];

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPaletteSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1113);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2057);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(30);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Color Palette Setting component
 */
var ColorPaletteSetting = (_dec = (0, _Izenda2.default)(_Izenda6.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ColorPaletteSetting, _Component);

  function ColorPaletteSetting() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ColorPaletteSetting);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ColorPaletteSetting.__proto__ || (0, _getPrototypeOf2.default)(ColorPaletteSetting)).call.apply(_ref, [this].concat(args))), _this), _this.renderGearIcon = function (isDefaultTheme) {
      var _this$props = _this.props,
          localization = _this$props.localization,
          displaySettingStatus = _this$props.displaySettingStatus;

      var displayIcon = displaySettingStatus && !isDefaultTheme;

      return _react2.default.createElement(
        'div',
        { className: 'izenda-ColorPalette-GearIcon' },
        _react2.default.createElement(
          _Izenda8.default,
          {
            className: 'btn btn-primary btn-icon icon-setting',
            onClick: _this.props.showColorPaletteSelectionPopup,
            title: localization.getText('COLORTHEME_OPTION_TOOLTIP')
          },
          displayIcon && _react2.default.createElement(
            'div',
            { className: 'u_floatRight u-posRelative' },
            _react2.default.createElement('i', { className: 'icon-ok u_smallIcon u-hadSetting u-colorWhite u-bgGreen' })
          )
        ),
        displayIcon && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('i', {
            className: 'icon-cancel u-colorRed',
            title: localization.getText('PROPERTIES_EDITOR_REMOVE_SETTING'),
            onClick: _this.props.resetDefaultValue
          })
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ColorPaletteSetting, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.init(this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          selectedPaletteName = _props.selectedPaletteName,
          displaySettingStatus = _props.displaySettingStatus,
          _props$value = _props.value,
          value = _props$value === undefined ? {} : _props$value;

      var paletteName = (0, _fp.isUndefined)(selectedPaletteName) ? value.colorPalette : selectedPaletteName;
      if (store.palettes.length === 0) {
        return null;
      }

      var model = store.getColorPaletteDetail(paletteName);
      var isDefaultTheme = (0, _fp.isUndefined)(value.isDefaultTheme) ? model.isDefaultTheme : value.isDefaultTheme;

      return _react2.default.createElement(
        'div',
        { className: 'izenda-ColorPaletteSetting' },
        _react2.default.createElement(_Izenda4.default, { model: model, isDefaultTheme: isDefaultTheme, displaySettingStatus: displaySettingStatus }),
        this.renderGearIcon(isDefaultTheme)
      );
    }
  }]);
  return ColorPaletteSetting;
}(_react.Component), _class2.propsType = {
  selectedPaletteName: _propTypes2.default.string,
  resetDefaultValue: _propTypes2.default.func,
  displaySettingStatus: _propTypes2.default.bool,
  selectionPopupTitle: _propTypes2.default.string,
  updateSelectedPalette: _propTypes2.default.func,
  needMaskDefault: _propTypes2.default.bool
}, _temp2)) || _class);
exports.default = ColorPaletteSetting;
module.exports = exports['default'];

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(214);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.HighchartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(570);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _highcharts = __webpack_require__(238);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = __webpack_require__(34);

var _Izenda5 = __webpack_require__(33);

var _Izenda6 = __webpack_require__(49);

var _Izenda7 = __webpack_require__(35);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(85);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LABEL_ROTATION_VALUES = _Izenda5.MappingValues.LABEL_ROTATION_VALUES;

var SERIES_ITEM_MAX_HEIGHT = 200;
var SERIES_ITEM_PADDING = 20;
var SERIES_ITEM_TITLE_SIZE = '12px';
var SERIES_ITEM_TITLE_ALIGN = 'bottom';
var CHART_SPACING_TOP = 70;
var CHART_SPACING_RIGHT = 70;

var HighchartOptionsBuilder = (_dec = (0, _Izenda6.exportClass)('HighchartOptionsBuilder'), _dec(_class = function (_ChartOptionsBuilder) {
  (0, _inherits3.default)(HighchartOptionsBuilder, _ChartOptionsBuilder);

  function HighchartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, HighchartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = HighchartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(HighchartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  (0, _createClass3.default)(HighchartOptionsBuilder, [{
    key: 'build',
    value: function build() {
      var chartData = this.chartData,
          chartOptions = this.chartOptions,
          fieldOptions = this.fieldOptions,
          visualType = this.visualType,
          chartContainer = this.chartContainer;

      // Build common highchart options

      var commonOptions = this.buildCommonHighchartOptions(chartContainer, visualType, chartData, {
        chartOptions: chartOptions,
        fieldOptions: fieldOptions
      });

      // Adjust chart spacing on particular label orientation
      this.adjustChartSpacings(commonOptions);

      // Depends on each chart type, the chart data is convert into Highchart options that are required to
      // render particular chart properly.
      var optionsByType = this.buildOptionsByType(visualType, commonOptions, chartData);

      var xAxis = commonOptions.xAxis,
          yAxis = commonOptions.yAxis,
          izendaSeriesConfig = commonOptions.izendaSeriesConfig,
          restCommonOpts = (0, _objectWithoutProperties3.default)(commonOptions, ['xAxis', 'yAxis', 'izendaSeriesConfig']);

      // Merge and let optionsByType override the commonOptions.
      // This is important step to ensure the final options will take all of optgionsByType.
      // The commonOptions acts as the default options.

      var highchartOptions = escapeChartTitle((0, _fp.mergeAll)([{ izendaSeriesConfig: izendaSeriesConfig }, restCommonOpts], optionsByType));

      // add color to each point
      (0, _fp.size)(highchartOptions.series) > 0 && (0, _Izenda3.getColorPointBySeries)(highchartOptions.series, highchartOptions, izendaSeriesConfig);

      // omit all properties that have null or undefined value of highchart options.
      // It ensures the Highchart library doesn't throw error when processing null value.
      return (0, _fp.omitBy)(_fp.isNil, highchartOptions);
    }

    /**
     * Build Highchart variable options for each chart type
     * @param {string} visualType Highchart chart type
     * @param {Object} highchartOptions Highchart options
     * @param {Object} chartData Chart data
     */

  }, {
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, highchartOptions, chartData) {
      throw new Error('The buildOptionsByType() method must be implemented for ' + visualType + ' chart before using');
    }

    /**
     * Build common Highchart option structure
     * @param {DOMElement} container DOM element of chart
     * @param {string} visualType Highchart chart type
     * @param {Object} chartData Chart data
     * @param {Object} options Options
     */

  }, {
    key: 'buildCommonHighchartOptions',
    value: function buildCommonHighchartOptions(container, visualType, chartData, _ref2) {
      var chartOptions = _ref2.chartOptions,
          fieldOptions = _ref2.fieldOptions;

      ensure(chartOptions, 'chartOptions must be set');

      var onClickOnPoint = this.onClickOnPoint;
      var onClickOnChart = this.onClickOnChart;
      var getClassList = this.getClassList;

      var commonOptions = chartOptions.commonOptions,
          optionByType = chartOptions.optionByType,
          commonActions = chartOptions.commonActions,
          xAxis = chartOptions.xAxis,
          yAxis = chartOptions.yAxis,
          commonXYAxis = chartOptions.commonXYAxis,
          sort = chartOptions.sort,
          colors = chartOptions.colors;


      return (0, _fp.mergeAll)([optionByType, commonOptions], {
        izendaSeriesConfig: fieldOptions,
        credits: {
          // disable credits text
          enabled: false
        },
        chart: {
          label: {
            enabled: false
          },
          type: visualType,
          events: {
            click: function click() {
              var point = (0, _fp.getOr)({}, 'hoverPoints[0]', this);
              return onClickOnChart(point, commonActions);
            }
          }
        },
        title: { text: null },
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0)',
          borderWidth: 0,
          borderRadius: 0,
          shadow: false,
          shared: true,
          useHTML: true,
          formatter: function formatter() {
            // disable title of chart - always
            var sortValue = (0, _fp.get)('valueXAxisForLinear', this.sort);
            var needReverseTooltip = sortValue === 'DESC' && (visualType === 'column' || visualType === 'bar');
            return _Izenda3.getTooltipFormatter.call(this, needReverseTooltip);
          }
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            label: {
              enabled: false
            },
            point: {
              events: {
                click: function click(e) {
                  var fromPoint = (0, _fp.findIndex)(function (c) {
                    return c === 'highcharts-point';
                  }, getClassList(e.srcElement)) !== -1;
                  if (fromPoint) onClickOnPoint(this, commonActions);
                }
              }
            },
            turboThreshold: Number.MAX_VALUE,
            connectNulls: true,
            marker: {
              enabled: true,
              states: {
                hover: {
                  fillColor: function fillColor() {
                    return true;
                  }
                }
              }
            }
          }
        },
        data: chartData && chartData.parsedData,
        commonActions: (0, _extends3.default)({}, commonActions, { chartContainer: container }),
        xAxis: xAxis,
        yAxis: yAxis,
        commonXYAxis: commonXYAxis,
        sort: sort,
        colors: colors
      });
    }
  }, {
    key: 'getClassList',
    value: function getClassList(svgElement) {
      if (svgElement.classList) return svgElement.classList;
      var className = svgElement.getAttribute('class') || '';
      return className.split(' ');
    }

    /**
     * Adjust chart spacing according to labels orientation
     * @param {Object} highChartOptions Highchart options
     */

  }, {
    key: 'adjustChartSpacings',
    value: function adjustChartSpacings(highChartOptions) {
      if ((highChartOptions.chart.type === _Izenda10.default.Combination || highChartOptions.chart.type === _Izenda10.default.Line || highChartOptions.chart.type === _Izenda10.default.Column || highChartOptions.chart.type === _Izenda10.default.Area) && highChartOptions.commonXYAxis.yAxis.labels && (highChartOptions.commonXYAxis.yAxis.labels.rotation === LABEL_ROTATION_VALUES.izClockwise || highChartOptions.commonXYAxis.yAxis.labels.rotation === LABEL_ROTATION_VALUES.izCounterclockwise || highChartOptions.commonXYAxis.yAxis.labels.rotation === LABEL_ROTATION_VALUES.izTextdown || highChartOptions.commonXYAxis.yAxis.labels.rotation === LABEL_ROTATION_VALUES.izTextup)) {
        highChartOptions.chart.spacingTop = CHART_SPACING_TOP;
      }

      // if chart type is combination/line/area,
      //  ==> set spacingRight when xAxis is clockwise
      if ((highChartOptions.chart.type === _Izenda10.default.Combination || highChartOptions.chart.type === _Izenda10.default.Line || highChartOptions.chart.type === _Izenda10.default.Area) && highChartOptions.commonXYAxis.xAxis.labels && highChartOptions.commonXYAxis.xAxis.labels.rotation === LABEL_ROTATION_VALUES.izClockwise) {
        highChartOptions.chart.spacingRight = CHART_SPACING_RIGHT;
      }

      // if chart type is bar, set spacingTop when xAxis is clockwise and spacingRight if yAxis is clockwise
      if (highChartOptions.chart.type === _Izenda10.default.Bar && highChartOptions.commonXYAxis.xAxis.labels) {
        if (highChartOptions.commonXYAxis.xAxis.labels.rotation === LABEL_ROTATION_VALUES.izClockwise) {
          highChartOptions.chart.spacingTop = CHART_SPACING_TOP;
        }
        if (highChartOptions.commonXYAxis.yAxis.labels.rotation === LABEL_ROTATION_VALUES.izClockwise) {
          highChartOptions.chart.spacingRight = CHART_SPACING_RIGHT;
        }
      }
    }

    /**
     * Handle click event on chart
     * @param {Object} point Data point at mouse pointer
     * @param {Object} commonActions Common defined actions on chart
     */

  }, {
    key: 'onClickOnChart',
    value: function onClickOnChart(point, commonActions) {
      if ((0, _fp.isEmpty)(point)) {
        return;
      }

      var serieOpt = (0, _fp.get)('series.userOptions', point);
      !serieOpt.isRegressionLine && commonActions.onDrilldown && commonActions.onDrilldown({
        field: serieOpt.xAxisField,
        value: (0, _Izenda3.getPointName)(point),
        record: (0, _fp.get)('options.record', point)
      });
    }

    /**
     * Handle click event on data point
     * @param {Object} point Data point
     * @param {Object} commonActions Common defined actions on chart
     */

  }, {
    key: 'onClickOnPoint',
    value: function onClickOnPoint(point, commonActions) {
      var serieOpt = (0, _fp.getOr)({}, 'series.userOptions', point);

      // Do not drilldown on regression line
      if (serieOpt.isRegressionLine) {
        return;
      }
      var pointValue = (0, _Izenda3.getPointName)(point);
      var separatorField = (0, _fp.get)('separatorField', serieOpt);
      var record = (0, _fp.get)('record', point);
      var originalValue = _Izenda8.default.getOriginalValue(separatorField, record);

      commonActions.onDrilldown && commonActions.onDrilldown({ field: serieOpt.xAxisField || serieOpt.nameField, value: pointValue, record: (0, _fp.get)('options.record', point) }, {
        field: serieOpt.separatorField,
        value: serieOpt.separatorValue === _Izenda4.UNDEFINED_VALUE ? '' : originalValue
      });
    }
  }, {
    key: 'DefaultColors',
    get: function get() {
      return _highcharts2.default.getOptions().colors;
    }
  }]);
  return HighchartOptionsBuilder;
}(_Izenda2.default)) || _class);

/**
 * Escape text value in chart options
 * @param {Object} param0 Chart options
 */

exports.default = HighchartOptionsBuilder;
function escapeChartTitle(_ref3) {
  var xAxis = _ref3.xAxis,
      yAxis = _ref3.yAxis,
      izendaOptions = _ref3.izendaOptions,
      restOpts = (0, _objectWithoutProperties3.default)(_ref3, ['xAxis', 'yAxis', 'izendaOptions']);

  if (!(0, _fp.isNil)(xAxis) && !(0, _fp.isNil)(xAxis.title)) {
    xAxis.title.text = (0, _fp.escape)(xAxis.title.text);
  }

  if ((0, _fp.isArray)(yAxis)) {
    (0, _fp.forEach)(function (obj) {
      if (!(0, _fp.isNil)(obj.title)) {
        obj.title.text = (0, _fp.escape)(obj.title.text);
      }
    }, yAxis);
  } else if (!(0, _fp.isNil)(yAxis) && !(0, _fp.isNil)(yAxis.title)) {
    yAxis.title.text = (0, _fp.escape)(yAxis.title.text);
  }

  if (!(0, _fp.isNil)(izendaOptions)) {
    izendaOptions.dataUnit = (0, _fp.escape)(izendaOptions.dataUnit);
  }

  return (0, _extends3.default)({
    xAxis: xAxis,
    yAxis: yAxis,
    izendaOptions: izendaOptions
  }, restOpts);
}
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__(20);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty4 = __webpack_require__(94);

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


var _Izenda = __webpack_require__(175);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(35);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(65);

var _fp = __webpack_require__(1);

var _Izenda6 = __webpack_require__(49);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty3.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportPartContent = (_dec = (0, _Izenda6.exportClass)('ReportPartContent'), _dec2 = (0, _mobx.action)('readData'), _dec(_class = (_class2 = function () {
  function ReportPartContent(type) {
    (0, _classCallCheck3.default)(this, ReportPartContent);

    _initDefineProp(this, 'customContainers', _descriptor, this);

    this.type = type;
    this.optionsDefaultFunc = function (style) {
      return (0, _fp.compose)((0, _fp.get)('optionsDefault'), _Izenda5.getConfiguration)(type, style);
    };

    this.isChartType = _Izenda2.default.isReportPartStyle(this.type);
    this.getBaseChartType = _Izenda2.default.getBaseStyle(this.type);
  }

  (0, _createClass3.default)(ReportPartContent, [{
    key: 'addCustomContainer',


    /**
     * Add a custom field container
     * @param {string} containerName The custom container name
     */
    value: function addCustomContainer(containerName) {
      ensure(containerName, 'Container name must have a value');
      ensure(!(0, _fp.has)(containerName, this), 'The container name ' + containerName + ' has been used.');

      var newCustomContainer = _Izenda4.default.addCustomContainers(this.customContainers, containerName);

      (0, _mobx.extendObservable)(this, (0, _defineProperty5.default)({}, containerName, newCustomContainer));
    }
  }, {
    key: 'readData',
    value: function readData(content) {
      content = content || {};

      var customContainersContent = (0, _fp.get)('customContainers', content);

      if (customContainersContent && customContainersContent.length > 0) {
        var newCustomContainers = this.customContainers.map(function (container) {
          var containerName = container.name;

          var customContent = (0, _fp.find)(['name', containerName], customContainersContent);
          return customContent ? _Izenda4.default.populateReportChartContainer(customContent, containerName) : container;
        });

        this.customContainers.replace(newCustomContainers);
      }
    }
  }, {
    key: 'autoSize',


    /**
     * Determine whether the report part content automatically sizes its container or not
     */
    get: function get() {
      return false;
    }
  }, {
    key: 'optionsDefault',
    get: function get() {
      return this.optionsDefaultFunc(this.reportPartStyle);
    }
  }, {
    key: 'defaultOptionsByType',
    get: function get() {
      return this.optionsDefault.optionsByType;
    }
  }, {
    key: 'defaultCommonOptions',
    get: function get() {
      return this.optionsDefault.commonOptions;
    }
  }, {
    key: 'reportPartStyle',
    get: function get() {
      throw new Error('The report part content has not defined report part style');
    }
  }]);
  return ReportPartContent;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'customContainers', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'readData', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readData'), _class2.prototype)), _class2)) || _class);
exports.default = ReportPartContent;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartHasThresholdOptionBuilder" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(328);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(39);

var _Izenda4 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartHasThresholdOptionBuilder = (_dec = (0, _Izenda4.exportClass)('ChartHasThresholdOptionBuilder'), _dec(_class = function (_DefaultChartOptionsB) {
  (0, _inherits3.default)(ChartHasThresholdOptionBuilder, _DefaultChartOptionsB);

  function ChartHasThresholdOptionBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, ChartHasThresholdOptionBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = ChartHasThresholdOptionBuilder.__proto__ || (0, _getPrototypeOf2.default)(ChartHasThresholdOptionBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }
  /**
   * Build chart which has threshold
   * @param {string} visualType Highchart chart type
   * @param {Object} userOptions User's options selected
   * @param {Object} chartData Chart data
   * @param {boolean} supportMetricAll for charts which support metric ALL or Not
   */


  (0, _createClass3.default)(ChartHasThresholdOptionBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var supportMetricAll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var LABELS = _Izenda3.ContainerName.LABELS,
          VALUES = _Izenda3.ContainerName.VALUES,
          DYNAMIC_THRESHOLD = _Izenda3.ContainerName.DYNAMIC_THRESHOLD;

      var dataStructure = dataParser.dataStructure || {};
      var yAxisContainerName = (0, _fp.getOr)(VALUES, 'Y_AXIS_CONTAINER_NAME', userOptions);
      var xAxisContainerName = (0, _fp.getOr)(LABELS, 'X_AXIS_CONTAINER_NAME', userOptions);

      var allDynamicThresholdFields = dataStructure[DYNAMIC_THRESHOLD];
      var yAxisContainerFields = dataStructure[yAxisContainerName];
      var xAxisField = (0, _fp.nth)(dataParser.expandedLevel, dataStructure[xAxisContainerName]);

      var xAxisInfo = dataParser.getDataByField(xAxisField);
      var chartOptions = (0, _get3.default)(ChartHasThresholdOptionBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(ChartHasThresholdOptionBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser);
      var metricAllDynamicThresholdOption = (0, _fp.getOr)([], 'commonXYAxis.metricAllDynamicThresholdOption', userOptions);
      var staticThresholdMetricAll = (0, _fp.getOr)([], 'commonXYAxis.metricAllPlotLinesOption', userOptions);

      var _findThresholdFields = this.findThresholdFields(allDynamicThresholdFields, yAxisContainerFields, metricAllDynamicThresholdOption, supportMetricAll),
          dynamicThresholdSettings = _findThresholdFields.dynamicThresholdSettings,
          thresholdFields = _findThresholdFields.thresholdFields;

      var thresholdSeries = !(0, _fp.isNil)(xAxisField) && !(0, _fp.isNil)(thresholdFields) ? this.getSeries(dataParser, userOptions, xAxisField, (0, _fp.uniq)(xAxisInfo.data), thresholdFields) : [];

      thresholdSeries = this.buildStyleForSeries(thresholdSeries, dynamicThresholdSettings, userOptions);

      if (supportMetricAll) {
        // static threshold for all
        var plotLines = (0, _fp.getOr)([], 'yAxis.plotLines', chartOptions);
        plotLines.push.apply(plotLines, (0, _toConsumableArray3.default)(staticThresholdMetricAll));

        chartOptions = (0, _fp.assignIn)(chartOptions, {
          plotLines: plotLines
        });
      }

      return (0, _fp.assignIn)(chartOptions, {
        thresholdSeries: thresholdSeries
      });
    }

    /**
    * Find the threshold fields
    * @param {Array} allThresholdFields array of threshold field in the Custom Container
    * @param {Array} yFields array of field on the Y container
    * @param {Object} metricAllDynamicThresholdOption that contain dynamic setting for option all
    * @param {boolean} supportMetricAll for charts which support metric ALL or Not
    * @return {object} return object which container threshold and their setting
    */

  }, {
    key: 'findThresholdFields',
    value: function findThresholdFields(allThresholdFields, yFields, metricAllDynamicThresholdOption, supportMetricAll) {
      var fieldOptions = this.fieldOptions;
      var thresholdFields = [];
      var dynamicThresholdSettings = [];

      var addThresholdField = function addThresholdField(fieldName) {
        var thresholdField = (0, _fp.find)({ fieldNameAlias: fieldName }, allThresholdFields);
        if (!(0, _fp.isNil)(thresholdField)) {
          thresholdFields.push(thresholdField);
        }
      };

      // go through all fields of Y container to get the list of threshold field belong to
      (0, _fp.each)(function (field) {
        var fieldNameAlias = field.fieldNameAlias;
        var dynamicThreshold = (0, _fp.flow)((0, _fp.get)(fieldNameAlias), (0, _fp.getOr)([], 'dynamicThresholds'))(fieldOptions);

        if ((0, _fp.size)(dynamicThreshold) > 0) {
          dynamicThresholdSettings.push.apply(dynamicThresholdSettings, (0, _toConsumableArray3.default)(dynamicThreshold));
          (0, _fp.each)(function (line) {
            addThresholdField(line.fieldName);
          }, dynamicThreshold);
        }
      }, yFields);

      // go through all threshold setting of metric ALL and combine with threshold field of Y field
      if (supportMetricAll) {
        (0, _fp.each)(function (setting) {
          dynamicThresholdSettings.push(setting);
          addThresholdField(setting.fieldName);
        }, metricAllDynamicThresholdOption);
      }
      return { dynamicThresholdSettings: dynamicThresholdSettings, thresholdFields: thresholdFields };
    }

    /**
    * Build series for threshold
    * @param {Array} thresholdSeries list of serie
    * @param {Array} dynamicThresholdSettings setting of threshold
    * @param {Object} userOptions User's options selected
    * @return {Array} threshold series were apply setting
    */

  }, {
    key: 'buildStyleForSeries',
    value: function buildStyleForSeries(thresholdSeries, dynamicThresholdSettings, userOptions) {
      var isSpline = (0, _fp.getOr)(false, 'izendaOptions.spline', userOptions);

      thresholdSeries = (0, _fp.map)(function (serie) {
        var setting = (0, _fp.find)({ fieldName: serie.yAxisField.fieldNameAlias }, dynamicThresholdSettings);
        var text = (0, _fp.get)('label.text', setting);
        serie = (0, _fp.assignIn)(serie, {
          label: {
            enabled: true
          },
          marker: {
            enabled: false
          },
          type: isSpline ? _Izenda3.THRESHOLD_TYPES.SPLINE : _Izenda3.THRESHOLD_TYPES.LINE,
          color: setting.color,
          colorByPoint: false,
          lineWidth: setting.width,
          dashStyle: setting.dashStyle,
          isThreshold: true
        });

        serie.name = text;
        return serie;
      }, thresholdSeries);
      return thresholdSeries;
    }
  }]);
  return ChartHasThresholdOptionBuilder;
}(_Izenda2.default)) || _class);
exports.default = ChartHasThresholdOptionBuilder;
module.exports = exports['default'];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PieChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(328);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(220);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(80);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(69);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(39);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

var _Izenda11 = __webpack_require__(49);

var _Izenda12 = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showText = _Izenda8.default.showText;

var PieChartOptionsBuilder = (_dec = (0, _Izenda11.exportClass)('PieChartOptionsBuilder'), _dec(_class = function (_DefaultChartOptionsB) {
  (0, _inherits3.default)(PieChartOptionsBuilder, _DefaultChartOptionsB);

  function PieChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, PieChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = PieChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(PieChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */


  (0, _createClass3.default)(PieChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var chartOptions = (0, _get3.default)(PieChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(PieChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser);

      var izendaOptions = userOptions.izendaOptions || {};
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
      var isShowDataLabels = izendaOptions.showValueLabel || izendaOptions.showSliceLabel || izendaOptions.showPercentage || false;
      var chartSizePercent = 100;
      var chartInnerSizePercent = Math.round(chartSizePercent / 2);

      var xAxis = chartOptions.xAxis;
      var xAxisName = xAxis.axisName;

      if (userOptions.series) {
        chartOptions = (0, _fp.omit)('series', chartOptions);
      }

      userOptions.series = removeNegativeData(userOptions.series || chartOptions.series);

      if (izendaOptions.bottomXpercent) {
        applyBottomPercent(izendaOptions);
      }

      chartOptions = (0, _fp.merge)(chartOptions, {
        chart: {
          type: 'pie'
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: isShowDataLabels,
              formatter: getDataLabelFormat,
              useHTML: true
            }
          },
          pie: {
            showInLegend: true,
            size: chartSizePercent + '%',
            dataLabels: {
              padding: 0
            }
          }
        }
      });

      if (izendaOptions.showPercentage) {
        chartOptions = (0, _fp.assign)(chartOptions, {
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          }
        });
      }

      // add sub-report to x-axis
      !(userOptions.izMultiLevel && (0, _Izenda9.isChartType)(this.chartOptions.chartType, _Izenda12.CHART_TYPE.TreeMap)) && _Izenda8.default.addPointActionLink(true, userOptions, (0, _fp.get)('plotOptions.series.dataLabels', chartOptions), xAxisName, (0, _fp.get)(xAxisName, izendaSeriesConfig));

      if (izendaOptions.pieChartStyle === 'ring') {
        return $izenda.extend(true, chartOptions, {
          plotOptions: {
            pie: {
              innerSize: chartInnerSizePercent + '%'
            }
          }
        });
      } else if (izendaOptions.pieChartStyle === 'semiCirle') {
        return $izenda.extend(true, chartOptions, {
          plotOptions: {
            pie: {
              startAngle: -90,
              endAngle: 90,
              center: ['50%', '80%'],
              innerSize: chartInnerSizePercent + '%'
            }
          }
        });
      }

      return chartOptions;

      function removeNegativeData(series) {
        if ((0, _fp.isArray)(series)) {
          return series.filter(function (serie) {
            serie.data = (0, _fp.filter)(function (data) {
              data.value = data.y;
              return (0, _fp.get)('y', data) > 0;
            }, serie.data);

            return (0, _fp.size)(serie.data);
          });
        } else {
          return series;
        }
      }

      function getDataLabelFormat() {
        var point = this.point;
        var pointOpts = (0, _fp.get)('options', point);
        var dataLabel = [];
        var userOptions = this.series.userOptions || {};

        var pointFormatedName = (0, _fp.find)(function (val) {
          return !(0, _fp.isNil)(val);
        }, [pointOpts.key, pointOpts.name, point.x]);
        var pointName = (0, _fp.find)(function (val) {
          return !(0, _fp.isNil)(val);
        }, [pointOpts.key, pointOpts.originalNameValue, pointOpts.name, point.x]);

        // For null value , just show 'null' text on chart
        (0, _fp.isNull)(pointOpts.name) && (pointName = 'null');

        var customFormat = getCustomFormat(pointOpts, userOptions.yAxisField);
        var labelNameConfig = izendaSeriesConfig[userOptions.labelName] || izendaSeriesConfig[point.labelName];
        var dataType = (0, _fp.get)('fieldElement.properties.dataFormattings.functionInfo.formatDataType', labelNameConfig);

        var jsFormatStringLabelName = (0, _fp.get)('fieldElement.properties.dataFormattings.format.jsFormatString', labelNameConfig);

        var sliceLabel = void 0;
        if (jsFormatStringLabelName) {
          var pointData = void 0;
          if ((0, _fp.isNil)(pointName)) {
            pointData = null;
          } else {
            if ((0, _fp.isDate)(pointName) && dataType === 'Datetime') {
              pointData = new Date(pointName);
            } else {
              pointData = pointName;
            }
          }

          var _jsFormatId = (0, _fp.get)('fieldElement.properties.dataFormattings.format.formatId', labelNameConfig);

          sliceLabel = _Izenda4.default.format(_jsFormatId, pointData, pointName);
        } else {
          sliceLabel = dataParser.getFormatData({
            value: pointFormatedName,
            originalValue: pointName
          }, labelNameConfig);
        }
        !!izendaOptions.showSliceLabel && dataLabel.push(String.format('<span class="point-label">{0}</span>', showText(sliceLabel)));

        // data label
        var valueLabel = void 0;
        var nameConfig = izendaSeriesConfig[userOptions.name] || izendaSeriesConfig[point.name];
        var jsFormatString = (0, _fp.get)('fieldElement.properties.dataFormattings.format.jsFormatString', nameConfig);

        var jsFormatId = (0, _fp.get)('fieldElement.properties.dataFormattings.format.formatId', nameConfig);

        if (jsFormatString) {
          customFormat = _Izenda4.default.format(jsFormatId, pointOpts.y || this.point.value);
        }

        var fieldValue = {
          value: customFormat || pointOpts.y || this.point.value,
          originalValue: pointOpts.y || this.point.value
        };

        valueLabel = dataParser.getFormatData(fieldValue, nameConfig);

        !!izendaOptions.showValueLabel && dataLabel.push(String.format('<span class="point-value">  {0}</span>', showText(valueLabel)));

        // percentage
        !!izendaOptions.showPercentage && dataLabel.push(String.format('<span class="point-percent">  ({0}%)</span>', this.percentage.toFixed(2)));

        return String.format('<span class="pie-serie-label">{0}</span>', dataLabel.join(' '));
      }

      // Get custom format for data label
      function getCustomFormat(pointOpts, yAxisField) {
        var result = null;
        var columnName = (0, _fp.get)('columnName', yAxisField);
        var hasCustomFormat = (0, _fp.flow)((0, _fp.get)('record'), (0, _fp.has)(_Izenda10.default.CUSTOM_FORMAT_PREFIX + columnName))(pointOpts);

        if (hasCustomFormat) {
          result = (0, _fp.flow)((0, _fp.get)('record'), (0, _fp.get)(columnName))(pointOpts);
        }

        return result;
      }

      function applyBottomPercent(izendaOptions) {
        var series = userOptions.series || chartOptions.series;
        var data = (0, _fp.get)('[0].data', series);

        if (data) {
          series[0].data = (0, _fp.get)('newData', _Izenda6.default.processDataByBottomPercent(izendaOptions.bottomXpercent, data, 'name', 'y'));
        }
      }
    }
  }]);
  return PieChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = PieChartOptionsBuilder;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.HighmapOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


var _Izenda = __webpack_require__(570);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(80);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(105);

var _Izenda6 = __webpack_require__(69);

var _Izenda7 = __webpack_require__(35);

var _Izenda8 = __webpack_require__(49);

var _IzendaHighchartUtils = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADJUST_LEGEND_X = 30;
var LENGTH_ALLOW_TWO = 2;
var FONT_SIZE_DEFAULT = 1.2;
/**
 * An implementation of ChartOptionsBuilder for Highmap.
 * This builder constructs the Highmap specific options, aka configuration.
 */
var HighmapOptionsBuilder = (_dec = (0, _Izenda8.exportClass)('HighmapOptionsBuilder'), _dec(_class = function (_ChartOptionsBuilder) {
  (0, _inherits3.default)(HighmapOptionsBuilder, _ChartOptionsBuilder);

  function HighmapOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, HighmapOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = HighmapOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(HighmapOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  (0, _createClass3.default)(HighmapOptionsBuilder, [{
    key: 'build',
    value: function build() {
      var chartOptions = this.chartOptions,
          fieldOptions = this.fieldOptions,
          chartContainer = this.chartContainer;


      var mappedChartOptions = chartOptions;
      var mappedSeriesConfig = fieldOptions;

      var commonActions = mappedChartOptions.commonActions,
          commonOptions = mappedChartOptions.commonOptions,
          optionByType = mappedChartOptions.optionByType,
          colors = mappedChartOptions.colors;

      // add container to commonActions

      $izenda.extend(mappedChartOptions.commonActions, { chartContainer: chartContainer });

      // merge all optionByType into commonOptions
      $izenda.extend(true, commonOptions, optionByType);

      var izendaOptions = (0, _fp.get)('izendaOptions', commonOptions);
      var backgroundMap = (0, _fp.get)('backgroundMap', izendaOptions);
      var seriesMap = (0, _fp.getOr)({}, 'seriesMap', izendaOptions);
      var pointOption = (0, _fp.getOr)({}, 'pointOption', seriesMap);
      var printingMode = (0, _fp.get)('printingMode', izendaOptions);
      var activePointOption = (0, _fp.get)('activePointOption', izendaOptions);
      var pointType = (0, _fp.get)('pointType', activePointOption);

      // Create series data
      var bgSeries = getBackgroundMapSerie(mappedChartOptions, izendaOptions, pointOption, mappedSeriesConfig, seriesMap.backgroundMap);

      var _getShadingMapSeriesA = getShadingMapSeriesAndColors(mappedChartOptions, izendaOptions, pointOption, pointType, mappedSeriesConfig, seriesMap.shadingSeries),
          series = _getShadingMapSeriesA.series,
          colorAxises = _getShadingMapSeriesA.colorAxises;

      var highmapSeries = [].concat((0, _toConsumableArray3.default)(bgSeries), (0, _toConsumableArray3.default)(series));

      // just init bubble series - do not draw
      // bubble series will be added and redawn later
      // to remove point which do not belong to current geo-map
      var bubbleSeries = getBubbleMapSeries(mappedChartOptions, izendaOptions, pointOption, mappedSeriesConfig, seriesMap.bubbleSeries, pointType, printingMode);
      // this is needed to put bubble series afterwards the shading series:
      var maxLegendPosition = (0, _fp.max)((0, _fp.map)(function (x) {
        return x.legendIndex;
      }, highmapSeries)) || 0;
      bubbleSeries && bubbleSeries.forEach(function (x) {
        return x.legendIndex = maxLegendPosition + (!(0, _fp.isNil)(x.legendIndex) ? x.legendIndex : bubbleSeries.length);
      });

      // apply cell-color of point-options
      activePointOption && applyPointOptionsColor(highmapSeries, activePointOption, mappedSeriesConfig);
      activePointOption && applyPointOptionsColor(bubbleSeries, activePointOption, mappedSeriesConfig);

      // Generate Highmap options
      var highmapOptions = this.buildHighmapOptions(commonOptions, pointOption, highmapSeries, bubbleSeries, colorAxises, colors, seriesMap, backgroundMap, mappedSeriesConfig, commonActions);

      // Adjust legend position
      adjustLegendPosition(highmapOptions, seriesMap, chartContainer);

      return (0, _extends3.default)({
        applyPointOptionsColor: applyPointOptionsColor,
        bubbleSeries: bubbleSeries,
        activePointOption: activePointOption,
        seriesConfig: mappedSeriesConfig
      }, highmapOptions);
    }

    /**
     * Build Highmap options
     */

  }, {
    key: 'buildHighmapOptions',
    value: function buildHighmapOptions(commonOptions, pointOption, highmapSeries, bubbleSeries, colorAxises, colors, seriesMap, backgroundMap, seriesConfig, commonActions) {
      var _this2 = this;

      var onMapAreaClick = function onMapAreaClick(_ref2) {
        var options = _ref2.options;

        var point = options;
        if ((0, _fp.isEmpty)(seriesMap.shadingSeries) && !(0, _fp.isEmpty)(seriesMap.bubbleSeries)) {
          point = (0, _fp.find)({ code: point.code }, bubbleSeries[0].data) || point;
        }

        _this2.onDrilldown(point, commonActions);
      };

      var geojson = (0, _fp.get)('geojson', backgroundMap);

      // Map options
      var highmapOptions = $izenda.extend(true, commonOptions, {
        chart: { type: 'map' },
        title: {
          // do not show title
          text: ''
        },
        credits: { enabled: false },
        plotOptions: {
          map: {
            allAreas: false,
            point: {
              events: {
                click: function click(e) {
                  var $target = $izenda(e.target);
                  if (!$target.hasClass('hyperlink-action')) onMapAreaClick(this);else return false;
                }
              }
            }
          },
          series: { mapData: geojson }
        },
        tooltip: {
          formatter: function formatter() {
            return showMapTooltip(this.point, pointOption, seriesConfig);
          },
          useHTML: true,
          backgroundColor: 'rgba(255,255,255,0)',
          borderWidth: 0,
          borderRadius: 0,
          shadow: false
        }
      });

      // set series to map-options
      highmapOptions.series = highmapSeries;
      highmapOptions.colorAxis = (0, _fp.head)(colorAxises);

      // apply theme colors for map
      !(0, _fp.isNil)(colors) && (highmapOptions.colors = colors);

      // omit all properties that have null or undefined value of highchart options.
      // It ensures the Highchart library doesn't throw error when processing null value.
      return (0, _fp.omitBy)(_fp.isNil, highmapOptions);
    }

    /**
     * Handle drilldown action when user click on the map
     * @param {Object} point Point value on the Map
     */

  }, {
    key: 'onDrilldown',
    value: function onDrilldown(point, commonActions) {
      return commonActions.onDrilldown && commonActions.onDrilldown({ point: point });
    }
  }]);
  return HighmapOptionsBuilder;
}(_Izenda2.default)) || _class);

/**
 * Show map tooltip
 */

exports.default = HighmapOptionsBuilder;
function showMapTooltip(point, pointOption, seriesConfig) {
  // background map: do not show tooltip
  if ((0, _fp.get)('series.userOptions.isBackgroundMap', point)) {
    return false;
  }

  var options = point.options,
      valueField = point.valueField,
      series = point.series;

  var fieldValue = (0, _Izenda7.getFieldValue)(options.valueField.columnName, options.record);
  var pointName = (0, _fp.getOr)(point.name, 'pointName', options);
  var fieldFormat = (0, _fp.get)('fieldElement.properties.dataFormattings.format', seriesConfig[valueField.fieldNameAlias]);
  var formatedValue = void 0;

  var pointOptionStyle = pointName && _Izenda4.default.getValueStyle(pointName, seriesConfig[pointOption.label], {
    element: options.nameField,
    record: options.record
  }) || {};

  // Check if exist jsFormatString to be prioritized in formating value
  if (!(0, _fp.isNil)(fieldFormat.jsFormatString) && fieldFormat.jsFormatString !== '') {
    formatedValue = (0, _IzendaHighchartUtils.formatDataByStringFormat)(fieldFormat.formatId, fieldValue.value, seriesConfig[valueField.fieldNameAlias].fieldDataType);
  }

  var valueStyle = _Izenda4.default.getValueStyle({ originalValue: fieldValue.originalValue, value: !(0, _fp.isNil)(formatedValue) ? formatedValue : fieldValue.value }, seriesConfig[valueField.fieldNameAlias], {
    element: options.valueField,
    record: options.record
  }) || {};

  var pointNameString = (0, _fp.has)('fomattedValue', pointOptionStyle) ? (0, _fp.escape)(pointOptionStyle.fomattedValue) : buildPointNameByLongLat(point);

  return '<span style="color:' + point.color + '">\u25CF</span>      <span> ' + (0, _fp.escape)(series.userOptions.name) + '</span><br>      <span>' + pointNameString + ': ' + (0, _fp.escape)(valueStyle.fomattedValue) + '</span>';
}

/**
 * Show data label
 * @param {boolean} isSupportedPointAction
 * @param {Object} activePointOption
 */
function showDataLabel(chartOptions, izendaOptions, pointOption, seriesConfig, isSupportedPointAction, activePointOption) {
  var activePointOptionName = (0, _fp.get)('field.name', activePointOption);
  var dataLabelConfig = {
    enabled: (0, _fp.get)('dataLabels', izendaOptions) || (0, _fp.get)('mapLabel', izendaOptions),
    padding: 0,
    rotation: 0,
    formatter: function formatter() {
      var point = this.point;
      var pointOpts = point.options || {};
      var poinOptionName = (0, _fp.get)('label', pointOption);
      var pointName = void 0;
      var config = seriesConfig[poinOptionName];
      var userOptions = (0, _fp.getOr)({}, 'series.userOptions', point);
      var fieldSource = {
        element: pointOpts.nameField,
        record: pointOpts.record
      };

      if (!userOptions.isBackgroundMap && (0, _fp.get)('dataLabels', izendaOptions)) {
        pointName = getPointName.call(this);
        return pointName ? (0, _fp.escape)(getFormatteData(pointName, config, fieldSource)) : buildPointNameByLongLat(seriesConfig, point);
      }

      if (izendaOptions.mapLabel) {
        pointName = (0, _fp.getOr)('', izendaOptions.dataLabelKey || 'name', pointOpts.pointInfo.properties);
        return (0, _fp.escape)(pointName ? getFormatteData(pointName, config, fieldSource) : undefined);
      }

      return undefined;
    }
  };

  var rotation = (0, _fp.getOr)(undefined, 'commonOptions.plotOptions.series.dataLabels.rotation', chartOptions);
  var result = isSupportedPointAction && activePointOption && (0, _Izenda6.addPointActionLink)(true, chartOptions, dataLabelConfig, activePointOptionName, seriesConfig[activePointOptionName], getPointName, false, rotation);
  return result || dataLabelConfig;
}

/**
 * Get background map serie
 * @param {Object} series
 * @param {Object} backgroundMap
 */
function getBackgroundMapSerie(chartOptions, izendaOptions, pointOption, seriesConfig, backgroundMap) {
  if (!backgroundMap) {
    return [];
  }

  (0, _fp.each)(function (item) {
    item.color = _Izenda5.MapUIConstant.backgroundMapColor;
  }, backgroundMap.data);

  return [{
    isBackgroundMap: true,
    data: backgroundMap.data,
    joinBy: backgroundMap.joinBy,
    color: _Izenda5.MapUIConstant.backgroundMapColor,
    showInLegend: false,
    dataLabels: showDataLabel(chartOptions, izendaOptions, pointOption, seriesConfig, false),
    tooltip: {
      enabled: false
    }
  }];
}

/**
 * Get bubble map series
 * @param {Object} seriesConfig
 * @param {Object} bubbleMap
 * @param {string} pointType
 * @param {boolean} printingMode
 */
function getBubbleMapSeries(chartOptions, izendaOptions, pointOption, seriesConfig, bubbleMap, pointType, printingMode) {
  if (!bubbleMap) {
    return [];
  }

  return (0, _fp.flatMap)(function (serieKey) {
    var bubble = bubbleMap[serieKey];

    bubble.data.forEach(function (point) {
      point.z = !(0, _fp.isNil)(point.originalValue) && point.originalValue !== '' ? point.originalValue : point.value;
    });

    var childSeries = splitSeriesByColor(serieKey, bubble, (0, _fp.get)(['cellColors', pointType].join('.'), seriesConfig[serieKey]));

    return childSeries.map(function (serie) {
      return $izenda.extend({}, bubble, {
        type: 'mapbubble',
        name: serieKey,
        showInLegend: true,
        /** turn off animation in printing mode */
        animation: !printingMode,
        dataLabels: showDataLabel(chartOptions, izendaOptions, pointOption, seriesConfig, true, bubble.activePointOption),
        joinBy: ['hc-key', 'code'],
        minSize: _Izenda5.MapUIConstant.bubbleMinSize,
        maxSize: _Izenda5.MapUIConstant.bubbleMaxSize
      }, serie);
    });
  }, (0, _keys2.default)(bubbleMap));
}

function splitSeriesByColor(serieName, serie, cellColorConfig) {
  if (!cellColorConfig) {
    return [serie];
  }

  var rangeColors = cellColorConfig.rangePercent || cellColorConfig.rangeValue || [];
  var colorsInOriginalOrder = [].concat((0, _toConsumableArray3.default)(rangeColors.map(function (x) {
    return x.text;
  })), ['NO_COLOR']);

  var groupSeries = (0, _fp.groupBy)(function (point) {
    return (0, _Izenda7.getConfigDataByRange)(point.originalValue || point.value, cellColorConfig, {
      element: point.valueField,
      record: point.record
    }) || 'NO_COLOR';
  }, serie.data);

  return (0, _keys2.default)(groupSeries).map(function (color) {
    var childSerieName = getNameOfCellConfig(color, cellColorConfig);
    var legendIndex = colorsInOriginalOrder.indexOf(color);
    return {
      name: childSerieName || serieName,
      color: childSerieName ? color : null,
      hasColor: !!childSerieName, // flag: [TRUE] do not apply point-option color
      data: groupSeries[color],
      legendIndex: legendIndex >= 0 ? legendIndex : undefined
    };
  });
}

/**
 * Get shading map series and color axises
 * @param {Object} shadingSeries
 * @param {Object} axisColorSource
 */
function getShadingMapSeriesAndColors(chartOptions, izendaOptions, pointOption, pointType, seriesConfig, shadingSeries) {
  if (!shadingSeries) {
    return [];
  }
  var colorAxises = [];

  var series = (0, _fp.flatMap)(function (serieKey) {
    var shading = shadingSeries[serieKey];

    shading.data.forEach(function (point) {
      point.z = !(0, _fp.isNil)(point.originalValue) && point.originalValue !== '' ? point.originalValue : point.value;
    });

    // only have 1 axis color
    var colorAxis = getColorAxis(serieKey, shading, (0, _fp.get)(['cellColors', pointType].join('.'), seriesConfig[serieKey]));
    colorAxis && colorAxises.push(colorAxis);

    var childSeries = splitSeriesByColor(serieKey, shading, (0, _fp.get)(['cellColors', pointType].join('.'), seriesConfig[serieKey]));

    return childSeries.map(function (serie) {
      return $izenda.extend({}, shading, {
        data: shading.data,
        hasColor: colorAxis ? true : false,
        name: serieKey,
        joinBy: ['hc-key', 'code'], // TODO

        dataLabels: showDataLabel(chartOptions, izendaOptions, pointOption, seriesConfig, true, shading.activePointOption),
        showInLegend: true
      }, serie);
    });
  }, (0, _keys2.default)(shadingSeries));

  return { series: series, colorAxises: colorAxises };
}

/**
 * Apply Point Options Color
 * @param {Object} highmapSeries
 * @param {Object} activePointOption
 * @param {Object} fieldConfig
 * @param {Object} seriesConfig
 */
function applyPointOptionsColor(highmapSeries, activePointOption, seriesConfig) {
  var fieldConfig = (0, _fp.getOr)({}, (0, _fp.get)('field.name', activePointOption), seriesConfig);
  var cellColor = void 0;

  (0, _fp.each)(function (serie) {
    if (serie.isBackgroundMap || serie.hasColor) {
      return true; // continue
    }

    (0, _fp.each)(function (item) {
      cellColor = getPointColor(serie, item, seriesConfig, fieldConfig);
      cellColor && (item.color = cellColor);
    }, serie.data);
  }, highmapSeries);
}

function getPointColor(serie, point, seriesConfig, fieldConfig) {
  var color = void 0;

  if (serie.isUserDefinedPoint) {
    var latConfig = (0, _fp.get)((0, _fp.get)('fieldNameAlias', serie.latField), seriesConfig);
    var lonConfig = (0, _fp.get)((0, _fp.get)('fieldNameAlias', serie.lonField), seriesConfig);

    var latStyle = _Izenda4.default.getValueStyle(point.lat, latConfig, {
      element: serie.latField,
      record: point.record
    });
    var lonStyle = _Izenda4.default.getValueStyle(point.lon, lonConfig, {
      element: serie.lonField,
      record: point.record
    });

    color = (0, _fp.get)('style.cellColor', latStyle) || (0, _fp.get)('style.cellColor', lonStyle);
    return color;
  }

  return (0, _fp.get)('style.cellColor', _Izenda4.default.getValueStyle(point.pointName, fieldConfig, {
    element: point.valueField,
    record: point.record
  }));
}

/**
 * Adjust Legend Position
 * @param {String} serieName
 * @param {Object} serieInfo
 * @param {Object} cellColor
 * @return {Object} colorAxis
 */

function getColorAxis(serieName, serieInfo, cellColor) {
  if (!cellColor) {
    return null;
  }

  if (cellColor.value && cellColor.value.length === LENGTH_ALLOW_TWO) {
    var config = cellColor.value;
    var min = getNumber('key', config[1]);
    var _max = getNumber('key', config[0]);

    return {
      minColor: (0, _fp.getOr)(undefined, 'text', config[1]),
      maxColor: (0, _fp.getOr)(undefined, 'text', config[0]),

      min: (0, _fp.isNil)(min) ? serieInfo.min : min,
      max: (0, _fp.isNil)(_max) ? serieInfo.max : _max
    };
  }

  return null;
}

function getAxis(serieName, config, isRangePercent, firstPointVal, firstPointValPercent) {
  var getValue = function getValue(key, item) {
    var val = getNumber(key, item);
    return isRangePercent ? val * firstPointVal / firstPointValPercent : val;
  };

  return (0, _fp.size)(config) ? {
    dataClasses: config.map(function (item) {
      return {
        name: (0, _fp.getOr)(serieName, 'name', item),
        color: (0, _fp.get)('text', item),
        from: getValue('from', item),
        to: getValue('to', item)
      };
    })
  } : null;
}

/**
 * Adjust Legend Position
 * @param {Object} chartOptions
 * @param {Object} seriesMap
 * @param {Object} container
 */
function adjustLegendPosition(chartOptions, seriesMap, container) {
  var legend = (0, _fp.getOr)({}, 'legend', chartOptions);

  // adjust symbol size
  var fontSizeItem = parseInt((0, _fp.get)('itemStyle.fontSize', legend));

  fontSizeItem && (legend.symbolWidth = fontSizeItem * FONT_SIZE_DEFAULT);

  // do not show legend no serie
  var sizeMapAllow = 1;
  if ((0, _fp.size)(seriesMap.bubbleSeries) + (0, _fp.size)(seriesMap.shadingSeries) < sizeMapAllow) {
    chartOptions.series.forEach(function (serie) {
      serie.isBackgroundMap && (serie.showInLegend = true);
    });
  }

  if (legend.enabled) {
    var containerWidth = container.clientWidth - ADJUST_LEGEND_X;
    var legendWidth = legend.layout === 'horizontal' && legend.verticalAlign != 'middle' ? containerWidth : containerWidth / 2;

    (0, _assign2.default)(legend.title.style, {
      width: legendWidth,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    });
  }
}

/**
 * Get formatted data
 * @param {string} val
 * @param {Object} config
 * @param {Object} fieldSource
 */
function getFormatteData(val, config, fieldSource) {
  return (0, _fp.getOr)('', 'fomattedValue', _Izenda4.default.getValueStyle(val, config, fieldSource));
}

/**
 * Get point name
 */
function getPointName() {
  return (0, _fp.getOr)('', 'options.pointName', this.point);
}

/**
 * Get Name Of Cell Config
 * @param {string} color
 * @param {Object} cellConfig
 */
function getNameOfCellConfig(color, cellConfig) {
  var findName = function findName(config) {
    return (0, _fp.find)({ text: color }, config);
  };
  var found = findName(cellConfig.rangeValue) || findName(cellConfig.rangePercent);
  return (0, _fp.get)('name', found);
}

/**
 * Get number
 * @param {string} path
 * @param {Object} config
 */
function getNumber(path, config) {
  return (0, _fp.flow)((0, _fp.get)(path), _fp.toNumber)(config);
}

/**
 * Build Point Name By Long Lat
 * @param {Object} point
 */
function buildPointNameByLongLat(seriesConfig, point) {
  if (!(0, _fp.has)('lat', point) || !(0, _fp.has)('lon', point)) {
    return '';
  }

  var series = (0, _fp.getOr)({}, 'series', point);
  var serieOpt = (0, _fp.get)('userOptions', series);
  var latConfig = (0, _fp.get)((0, _fp.get)('fieldNameAlias', serieOpt.latField), seriesConfig);
  var lonConfig = (0, _fp.get)((0, _fp.get)('fieldNameAlias', serieOpt.lonField), seriesConfig);

  var lat = _Izenda4.default.getValueStyle(point.lat, latConfig, {
    element: serieOpt.latField,
    record: point.record
  });
  var lon = _Izenda4.default.getValueStyle(point.lon, lonConfig, {
    element: serieOpt.lonField,
    record: point.record
  });

  return '(' + (0, _fp.get)('fomattedValue', lat) + ', ' + (0, _fp.get)('fomattedValue', lon) + ')';
}
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(37);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(625);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _recompose.withHandlers)({
  onSave: (0, _fp.curry)(onSave),
  onCancel: (0, _fp.curry)(onCancel),
  onChangeTime: (0, _fp.curry)(onChangeTime),
  onClearArchivedVersion: (0, _fp.curry)(onClearArchivedVersion),
  setEnforceVersionHistory: (0, _fp.curry)(setEnforceVersionHistory),
  setNumOfArchivedVersionToKeep: (0, _fp.curry)(setNumOfArchivedVersionToKeep),
  defaultImageUrlHander: (0, _fp.curry)(defaultImageUrlHander),
  onCheckRemoveArchivedVersions: (0, _fp.curry)(onCheckRemoveArchivedVersions)
});

/**
 * On cancel handler
 * @param {Object} props
 * @param {Object} e
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfigurationAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function onCancel(props, e) {
  props.validation.reset();
  var store = props.store,
      reportConfiguration = props.store.reportConfiguration,
      loader = props.loader;


  if (!reportConfiguration.isDirty) {
    store.updateAlertMessage(_Izenda2.default.MESSAGE_TYPE.INFO, _Izenda4.default.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
    return;
  }

  props.confirmFn('Confirmation', {
    description: _Izenda4.default.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
  }).then(function () {
    loader.startLoading();
    return store.onCancel().finally(loader.endLoading.bind(loader));
  });
}

/**
 * Check duplicate global and local names
 * @param {Object} store
 */
function validateDuplicateGlobalAndLocalNames(store) {
  var reportConfiguration = store.reportConfiguration;

  if (store.doesNeedToValidateGlobalAndLocalNames() && reportConfiguration.doesDuplicateGlobalAndLocalName()) {
    store.updateAlertMessage(_Izenda2.default.MESSAGE_TYPE.ERROR, _Izenda6.default.MESSAGES.M04);
    return false;
  }
  return true;
}

/**
 * On save handler
 * @param {Object} props
 * @param {Object} e
 */
function onSave(props, e) {
  var store = props.store,
      reportConfiguration = props.store.reportConfiguration,
      loader = props.loader;


  if (!reportConfiguration.isDirty) {
    store.updateAlertMessage(_Izenda2.default.MESSAGE_TYPE.INFO, _Izenda4.default.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
    return;
  }

  props.validation.validate().then(function (success) {
    success = success && validateDuplicateGlobalAndLocalNames(store);

    if (success) {
      loader.startLoading();
      return store.onSave().then(function (result) {
        if (result.success) {
          store.updateAlertMessage(_Izenda2.default.MESSAGE_TYPE.SUCCESS, _Izenda4.default.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
        } else {
          var messages = result.messages;
          if (reportConfiguration.recurrentReportSetting.once) {
            switch (messages[0].key) {
              case 'StartDate':
                messages[0].key = 'atDate';
                break;
              case 'StartTime':
                messages[0].key = 'atTime';
                break;
            }
          }
          props.validation.updateErrors(messages);
        }
      }).then(loader.endLoading.bind(loader));
    }
  });
}

/**
 * On clear archived version handler
 * @param {Object} props
 * @param {Object} e
 */
function onClearArchivedVersion(props, e) {
  e.stopPropagation();
  var store = props.store,
      loader = props.loader;


  props.confirmFn('Confirmation', {
    description: _Izenda4.default.getText('SYSTEM_CONFIGURATION_REPORT_SYSTEM_REMOVE_ALL_ARCHIVED')
  }).then(function () {
    loader.startLoading();
    return store.onClearArchivedVersion().finally(loader.endLoading.bind(loader));
  });
}

/**
 * On change time handler
 * @param {Object} props
 * @param {string} type
 * @param {string} value
 */
function onChangeTime(props, type, value) {
  var reportConfiguration = props.store.reportConfiguration;
  reportConfiguration.setValueByKey(type, value);
}

/**
 * On set enforce version history handler
 * @param {Object} props
 * @param {Object} e
 */
function setEnforceVersionHistory(props, e) {
  var value = e.target.checked;
  if (!value) {
    props.confirmFn('Confirmation', {
      description: _Izenda4.default.getText('SYSTEM_CONFIGURATION_REPORT_ALL_ARCHIVED_WILL_REMOVED')
    }).then(function () {
      props.store.reportConfiguration.setValueByKey('enforceVersionHistory', false);
    });
  } else {
    props.store.reportConfiguration.setValueByKey('enforceVersionHistory', true);
  }
}

/**
 * On set num of archived version to keep
 * @param {Object} props
 * @param {Object} value
 */
function setNumOfArchivedVersionToKeep(props, value) {
  if (value === 0) {
    props.confirmFn('Information', {
      description: _Izenda4.default.getText('SYSTEM_CONFIGURATION_REPORT_CONFIRM_AFTER_SAVING_SETTING'),
      type: 'info',
      showCloseIndicator: true
    });
  }
}

/**
 * On change default image handler
 * @param {Object} props
 * @param {Object} e
 */
function defaultImageUrlHander(props, e) {
  var model = props.store.reportConfiguration;
  model.setValueByKey.call(model, 'defaultImageUrl', e.target.value);
}

/**
 * On check remove archived versions handler
 * @param {Object} props
 * @param {Object} e
 */
function onCheckRemoveArchivedVersions(props, e) {
  var model = props.store.reportConfiguration;
  model.setValueByKey.call(model, 'removeArchivedVersions', e.target.checked);
}
module.exports = exports['default'];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  NUMBER_COLS: 12,
  NUMBER_ROWS: 5,
  GRID_CELL_SIZE: 90,
  DEFAULT_TILE_WIDTH: 12,
  DEFAULT_TILE_HEIGHT: 4,
  DEFAULT_TILE_HEIGHT_MOBILE: 400,
  TILE_MAX_HEIGHT: 440,
  get DELETE_CONFIRM_MESSAGE() {
    return _Izenda2.default.getText('DASHBOARD_GRID_CONSTANTS_DELETE_CONFIRM_MESSAGE');
  },
  get DELETE_ICON_TOOLTIP() {
    return _Izenda2.default.getText('COMMON_LABEL_DELETE');
  },
  get DUPLICATE_MESSAGE() {
    return _Izenda2.default.getText('DASHBOARD_GRID_CONSTANTS_DUPLICATE_MESSAGE');
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardGridConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(119);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda2 = __webpack_require__(2);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(2578);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(1168);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(327);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(36);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(2580);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(13);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(2581);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(29);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(567);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(23);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(1167);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _Izenda26 = __webpack_require__(403);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconAfterCursorInputValidator = (0, _Izenda23.default)()(_Izenda21.default);

function EmailInputOption(props) {
  var label = props.label,
      options = props.options,
      value = props.value;

  return _react2.default.createElement(
    _Izenda15.default.Row,
    null,
    _react2.default.createElement(
      _Izenda15.default.Col,
      { cols: 2, className: 'Izenda-EmailPopup-Input' },
      _react2.default.createElement(
        'span',
        null,
        label
      )
    ),
    _react2.default.createElement(
      _Izenda15.default.Col,
      { cols: 10 },
      _react2.default.createElement(_Izenda19.default, { options: options, value: value, onChange: props.onChange })
    )
  );
}

var EmailPopup = (_dec = (0, _Izenda3.default)(_Izenda5.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(EmailPopup, _Component);

  function EmailPopup(props) {
    (0, _classCallCheck3.default)(this, EmailPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EmailPopup.__proto__ || (0, _getPrototypeOf2.default)(EmailPopup)).call(this, props));

    _initialiseProps.call(_this);

    _this.systemVariablesUI = new _Izenda7.default();
    _this.subscribedInstancesStore = new _Izenda9.default();

    var _this$props = _this.props,
        type = _this$props.type,
        dashboardId = _this$props.dashboardId,
        reportId = _this$props.reportId,
        authorization = _this$props.authorization,
        PERMISSION_KEY = _this$props.authorizationConstants.PERMISSION_KEY;

    _this.domNodes = {};

    type === _Izenda.EMAIL_TYPE.dashboard ? _this.subscribedInstancesStore.updateDashboardId(dashboardId) : _this.subscribedInstancesStore.updateReportId(reportId);

    // Get list of delivery method that user can use
    _this.deliveryOptions = (0, _fp.filter)(function (option) {
      return authorization.checkPrivileges([PERMISSION_KEY[option.key]]);
    }, _Izenda.DELIVERY_OPTIONS);
    return _this;
  }

  (0, _createClass3.default)(EmailPopup, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var type;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = this.props.type;
                _context.next = 3;
                return this.props.getEmailTemplates(type);

              case 3:
                this.emailTemplates = _context.sent;

                if (!(0, _fp.isEmpty)(this.deliveryOptions)) {
                  this.setDeliveryMethod((0, _fp.head)(this.deliveryOptions));
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'findTemplateMatchWithDeliveryMethod',


    /**
     * Find email body template for delivery method
     * @param {string} value 
     */
    value: function findTemplateMatchWithDeliveryMethod(value) {
      return (0, _fp.get)('value', (0, _fp.find)(function (template) {
        return template.key.toLowerCase() === value.toLowerCase();
      }, this.emailTemplates));
    }
  }, {
    key: 'showSystemVariablesPopup',
    value: function showSystemVariablesPopup(sourceType, position) {
      var domNode = _reactDom2.default.findDOMNode(this.domNodes[sourceType]);
      if (!domNode) return;

      var _domNode$offsetParent = domNode.offsetParent,
          offsetLeft = _domNode$offsetParent.offsetLeft,
          offsetTop = _domNode$offsetParent.offsetTop;


      var left = offsetLeft + (position && position.left + 20);
      var top = offsetTop + (position && position.top + 20);

      var $sourceNode = sourceType === _Izenda.EMAIL_SUBJECT.KEY ? $izenda(_Izenda.EMAIL_SUBJECT.CLASS) : $izenda(_Izenda.EMAIL_BODY.CLASS);

      var cursorPosition = $izenda($sourceNode).prop('selectionStart');
      var currentVisible = this.systemVariablesUI.visible;

      this.systemVariablesUI.populateData({
        visible: !currentVisible,
        left: left,
        top: top,
        sourceType: sourceType,
        cursorPosition: cursorPosition,
        $sourceNode: $sourceNode
      });
    }

    /**
     * Handle when select system variable
     * @param {*} name
     */

  }, {
    key: 'renderSystemVariablesPopover',


    /**
     * Render system variable popover
     */
    value: function renderSystemVariablesPopover() {
      return _react2.default.createElement(
        _Izenda26.Popover,
        {
          visible: this.systemVariablesUI.visible,
          positionLeft: this.systemVariablesUI.left,
          positionTop: this.systemVariablesUI.top
        },
        _react2.default.createElement(_Izenda25.default, { store: this.subscribedInstancesStore, onSelect: this.onSelectSystemVariable })
      );
    }
  }, {
    key: 'renderEmailContainer',
    value: function renderEmailContainer() {
      var props = this.props;
      var email = props.email,
          _props$email = props.email,
          to = _props$email.to,
          cc = _props$email.cc,
          subject = _props$email.subject,
          deliveryMethod = _props$email.deliveryMethod,
          body = _props$email.body,
          localization = props.localization;


      return _react2.default.createElement(
        _Izenda15.default,
        null,
        _react2.default.createElement(_Izenda17.default, {
          multi: true,
          label: localization.getText('EMAIL_LABEL_TO'),
          value: to,
          onChange: props.setToAddress,
          addNewEmail: props.addNewEmail,
          addRecipientsFromPopup: props.addToEmailFromPopup,
          email: email,
          isRequired: true
        }),
        _react2.default.createElement(_Izenda17.default, {
          multi: true,
          label: localization.getText('EMAIL_LABEL_CC'),
          value: cc,
          onChange: props.setCcAddress,
          addRecipientsFromPopup: props.addCcEmailFromPopup,
          email: email,
          addNewEmail: props.addNewEmail
        }),
        _react2.default.createElement(
          _Izenda15.default.Row,
          null,
          _react2.default.createElement(
            _Izenda15.default.Col,
            { cols: 2, className: 'Izenda-EmailPopup-Input' },
            _react2.default.createElement(
              'span',
              null,
              localization.getText('EMAIL_LABEL_SUBJECT')
            )
          ),
          _react2.default.createElement(
            _Izenda15.default.Col,
            { cols: 10 },
            _react2.default.createElement(IconAfterCursorInputValidator, {
              ref: this.setDomNodeSubject,
              type: 'input',
              className: 'form-control email-subject',
              value: subject,
              onChange: props.setSubject,
              onClickIcon: this.showSubjectSystemVariables,
              field: _Izenda.EMAIL_SUBJECT.KEY,
              validations: _Izenda.REQUIRE_CONSTRAINTS
            })
          )
        ),
        _react2.default.createElement(EmailInputOption, {
          label: localization.getText('EMAIL_LABEL_METHOD'),
          options: this.deliveryOptions,
          value: deliveryMethod,
          onChange: this.setDeliveryMethod
        }),
        this.renderAttachment(),
        _react2.default.createElement(
          _Izenda15.default.Row,
          null,
          _react2.default.createElement(
            _Izenda15.default.Col,
            { cols: 2 },
            _react2.default.createElement(
              'span',
              null,
              localization.getText('EMAIL_LABEL_EMAIL_BODY')
            )
          ),
          _react2.default.createElement(
            _Izenda15.default.Col,
            { cols: 10 },
            _react2.default.createElement(IconAfterCursorInputValidator, {
              ref: this.setDomNodeBody,
              className: 'form-control email-body',
              rows: '8',
              value: body,
              onChange: props.setEmailBody,
              field: _Izenda.EMAIL_BODY.KEY,
              onClickIcon: this.showBodySystemVariables,
              validations: _Izenda.REQUIRE_CONSTRAINTS
            })
          )
        )
      );
    }

    /**
     * Render attachment dropdown
     */

  }, {
    key: 'renderAttachment',
    value: function renderAttachment() {
      var props = this.props;
      var _props$email2 = props.email,
          deliveryMethod = _props$email2.deliveryMethod,
          attachmentType = _props$email2.attachmentType,
          localization = props.localization,
          authorization = props.authorization,
          PERMISSION_KEY = props.authorizationConstants.PERMISSION_KEY;


      if (deliveryMethod !== _Izenda.DELIVERY_METHOD.attachment) return null;

      var attachmentOptions = (0, _fp.filter)(function (option) {
        return authorization.checkPrivileges([PERMISSION_KEY[option.key]]);
      }, _Izenda.ATTACH_TYPE_OPTIONS);

      return _react2.default.createElement(EmailInputOption, {
        label: localization.getText('EMAIL_LABEL_ATTACHMENT'),
        options: attachmentOptions,
        value: attachmentType,
        onChange: props.setAttachment
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var localization = props.localization;


      return _react2.default.createElement(
        _Izenda11.default,
        { visible: true, onClosing: props.onClosing, type: 'none', autoClose: false, sizeClass: 'modal-lg' },
        _react2.default.createElement(_Izenda11.default.Header, { title: localization.getText('EMAIL_TOOLTIP_COMPOSE_EMAIL') }),
        _react2.default.createElement(
          _Izenda11.default.Body,
          null,
          this.renderEmailContainer(),
          this.renderSystemVariablesPopover(),
          _react2.default.createElement(_Izenda13.default, { setLoadingPromise: props.setLoadingPromise, promiseFunction: props.loadingPromise })
        ),
        _react2.default.createElement(
          _Izenda11.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda11.default.ConfirmationButton,
            { key: 'accept', type: 'accept' },
            localization.getText('COMMON_LABEL_SEND')
          ),
          _react2.default.createElement(
            _Izenda11.default.ConfirmationButton,
            { key: 'cancel', type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return EmailPopup;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setDeliveryMethod = function (value) {
    var emailBody = _this2.findTemplateMatchWithDeliveryMethod(value.value);
    _this2.props.setDeliveryMethod(emailBody, value.value);
  };

  this.onSelectSystemVariable = function (name) {
    var props = _this2.props;
    var systemVariablesUI = _this2.systemVariablesUI;
    var _props$email3 = props.email,
        subject = _props$email3.subject,
        body = _props$email3.body;


    var sourceValue = systemVariablesUI.sourceType === _Izenda.EMAIL_SUBJECT.KEY ? subject : body;
    var updateFn = systemVariablesUI.sourceType === _Izenda.EMAIL_SUBJECT.KEY ? props.setSubject : props.setEmailBody;

    var cursorPos = systemVariablesUI.cursorPosition;
    var textBefore = sourceValue.substring(0, cursorPos);
    var textAfter = sourceValue.substring(cursorPos, sourceValue.length);
    updateFn({ target: { value: '' + textBefore + name + textAfter } });

    systemVariablesUI.updateVisible(false);
    systemVariablesUI.$sourceNode.focus();
  };

  this.showSubjectSystemVariables = function (position) {
    _this2.showSystemVariablesPopup(_Izenda.EMAIL_SUBJECT.KEY, position);
  };

  this.showBodySystemVariables = function (position) {
    _this2.showSystemVariablesPopup(_Izenda.EMAIL_BODY.KEY, position);
  };

  this.setDomNodeSubject = function (dom) {
    _this2.domNodes[_Izenda.EMAIL_SUBJECT.KEY] = dom;
  };

  this.setDomNodeBody = function (dom) {
    _this2.domNodes[_Izenda.EMAIL_BODY.KEY] = dom;
  };
}, _temp)) || _class);
exports.default = EmailPopup;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GroupPanel.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


/**
 * GroupPanel component
 */
!function () {

  var React = __webpack_require__(0);

  var GroupPanel = React.createClass({
    displayName: 'GroupPanel',

    render: function render() {
      var groupPanel = this;
      var props = this.props;
      var childPanels = createChildPanel();

      return React.createElement(
        'div',
        { className: 'panel-group ' + (props.className || ''),
          ref: 'panelGroup' },
        childPanels
      );

      function createChildPanel() {
        // set parent to each child-panel
        return React.Children.map(props.children, function (child) {
          return React.cloneElement(child, {
            parent: groupPanel
          });
        });
      }
    }
  });

  module.exports = GroupPanel;
}();

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportNameEditor.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Name Editor component
 */
!function () {
  var connect = __webpack_require__(2);
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var AppGlobal = __webpack_require__(41);

  var Validator = __webpack_require__(23);
  var DropDown = __webpack_require__(29);
  var actions = __webpack_require__(2671);
  var constants = __webpack_require__(16);
  var Input = __webpack_require__(17);
  var InputWithValidator = Validator()(Input);
  var EventsUtils = __webpack_require__(24);
  var notifyChange = EventsUtils.notifyChange;
  var localizer = __webpack_require__(12);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      merge = _require.merge;

  var ReportDesignerTooltip = observer(function (props) {
    var otherSetting = AppGlobal.advancedSettings.other;
    return this.props.showTooltip ? React.createElement(
      'div',
      { className: 'tool-tip u_paddingAll u_marginBottom' },
      React.createElement('i', { className: 'icon-lightbulb' }),
      otherSetting.showIntroductionTextValue ? otherSetting.introductionTextValue : ''
    ) : null;
  });

  var ReportPreviewRecord = observer(function (props) {
    var isPreviewRecord = this.props.isPreviewRecord;
    var previewRecord = this.props.previewRecord;
    var updatePreviewRecord = this.props.updatePreviewRecord;

    return isPreviewRecord ? React.createElement(
      'div',
      { className: 'col-md-4' },
      React.createElement(
        'div',
        { className: 'u_table u_fullWidth u_paddingInner u-bgWhite preview-records' },
        React.createElement(
          'span',
          { className: 'u_tableCell control-label u_alignMiddle' },
          localizer.getText('REPORTDESIGNER_LABEL_PREVIEW_RECORDS')
        ),
        React.createElement(
          'div',
          { className: 'u_tableCell u_fullWidth' },
          React.createElement(DropDown, {
            options: constants.PREVIEW_RECORD,
            value: previewRecord,
            labelField: 'label',
            valueField: 'value',
            onChange: notifyChange(updatePreviewRecord, EventsUtils.DROPDOWN)
          })
        )
      )
    ) : null;
  });

  var GlobalReportCheckbox = observer(function (props) {
    var store = props.store;
    var status = store.statusGlobalCheckbox;
    var className = classnames(props.className, 'global-report');
    return status.visible ? React.createElement(
      'div',
      { className: className },
      React.createElement(
        'label',
        { className: 'u_table u_fullWidth' },
        React.createElement(Input, {
          type: 'checkbox',
          className: 'global-checkbox',
          disabled: status.disabled,
          checked: status.checked,
          onChange: notifyChange(props.onChangeGlobalValue, EventsUtils.CHECKBOX)
        }),
        localizer.getText('COMMON_LABEL_GLOBAL_REPORT')
      )
    ) : null;
  });

  var ReportNameEditor = React.createClass({
    displayName: 'ReportNameEditor',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      name: React.PropTypes.string.isRequired,
      isPreviewRecord: React.PropTypes.bool.isRequired,
      showTooltip: React.PropTypes.bool.isRequired
    },

    /**
     * Component will receive props
     */
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (nextProps.name !== this.props.name) {
        nextProps.updateReportName(nextProps.name);
      }
    },

    renderEditMode: function renderEditMode() {
      var props = this.props;
      var store = props.store;
      var reportName = props.reportName;
      var reportType = store.model.reportType;
      var onSave = props.onSave;
      var onCancel = props.onCancel;
      var onKeyPress = props.onKeyPress;
      var onBlur = props.onBlur;
      var updateReportName = props.updateReportName;
      var localization = props.localization;
      var reportNameValidation = merge(store.isNewReport || reportType === constants.REPORT_TYPE_ENUM.REPORT ? constants.CONSTRAINTS.REPORT_NAME : constants.CONSTRAINTS.TEMPLATE_NAME, {
        action: function action() {
          return store.validate.bind(store, reportName);
        }
      });

      // Use onMouseDown event instead of onClick event to pass onBlur of report name.
      return React.createElement(
        'div',
        { className: 'title-edit' },
        React.createElement(
          'div',
          { className: 'input-group' },
          React.createElement(InputWithValidator, {
            value: reportName,
            onChange: notifyChange(updateReportName, EventsUtils.INPUT),
            onBlur: onSave,
            onKeyPress: onKeyPress,
            field: 'reportName',
            validations: reportNameValidation,
            className: 'form-control',
            autoFocus: true
          }),
          React.createElement(
            'span',
            { className: 'input-group-btn' },
            React.createElement(
              'button',
              {
                className: 'btn btn-default',
                onMouseDown: onSave,
                title: localization.getText('COMMON_TOOLTIP_UPDATE_CHANGE')
              },
              React.createElement('span', { className: 'icon-ok success-color' })
            ),
            React.createElement(
              'button',
              {
                className: 'btn btn-default',
                onMouseDown: onCancel,
                title: localization.getText('COMMON_TOOLTIP_CANCEL_CHANGE')
              },
              React.createElement('span', { className: 'icon-cancel' })
            )
          )
        )
      );
    },

    renderNormalMode: function renderNormalMode() {
      var reportName = this.props.name;
      var onEdit = this.props.onEdit;
      var localization = this.props.localization;
      return React.createElement(
        'div',
        { className: 'u_flexHorizontal' },
        React.createElement(
          'div',
          { className: 'u_textTruncate' },
          React.createElement(
            'span',
            { className: 'text-bold' },
            reportName
          )
        ),
        React.createElement(
          'div',
          { className: 'u_fullInlineBlock' },
          React.createElement('i', { className: 'icon-pencil-new', title: localization.getText('COMMON_TOOLTIP_RENAME'), onClick: onEdit })
        )
      );
    },

    renderReportNameEditor: function renderReportNameEditor() {
      var editMode = this.props.editMode;
      var isGlobalReportCheckbox = this.props.store.statusGlobalCheckbox.visible;
      var classes;
      if (this.props.isPreviewRecord) {
        classes = classnames({
          'col-md-5': isGlobalReportCheckbox,
          'col-md-8': !isGlobalReportCheckbox
        });
      } else {
        classes = classnames({
          'col-md-9': isGlobalReportCheckbox,
          'col-md-12': !isGlobalReportCheckbox
        });
      }

      return React.createElement(
        'div',
        { className: 'report-name ' + classes },
        React.createElement(
          'div',
          null,
          editMode ? this.renderEditMode() : this.renderNormalMode()
        )
      );
    },

    render: function render() {
      var props = this.props;
      var reportDesignerModel = props.store.model;
      var showTooltip = props.showTooltip;
      var isPreviewRecord = props.isPreviewRecord;
      var previewRecord = reportDesignerModel.previewRecord;

      var updatePreviewRecord = function updatePreviewRecord(value) {
        reportDesignerModel.updatePreviewRecord(value);
        props.onChangePreviewRecord && props.onChangePreviewRecord(props);
      };

      return React.createElement(
        'div',
        { className: 'izenda-ReportDesignerToolBar' },
        React.createElement(
          'div',
          { className: 'row izenda-ReportHeader' },
          this.renderReportNameEditor(),
          React.createElement(GlobalReportCheckbox, {
            store: props.store,
            className: 'col-md-3',
            onChangeGlobalValue: props.onChangeGlobalValue
          }),
          React.createElement(ReportPreviewRecord, {
            isPreviewRecord: isPreviewRecord,
            previewRecord: previewRecord,
            updatePreviewRecord: updatePreviewRecord
          })
        ),
        React.createElement(ReportDesignerTooltip, { showTooltip: showTooltip })
      );
    }
  });

  module.exports = connect(actions)(ReportNameEditor);
}();

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(60);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(167);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(104);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _mobx = __webpack_require__(5);

var _Izenda7 = __webpack_require__(37);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(31);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// $FlowFixMe
var MESSAGE_TYPE = _Izenda8.default.MESSAGE_TYPE;

exports.default = {
  /**
   * Check show organization.
   */
  checkShowOrganization: function checkShowOrganization() {
    return function checkShowOrganization(store) {
      store.model.updateProperty('enableForEnter', false);
      return store.loadSystemMode().then((0, _mobx.action)(function (result) {
        store.model.updateProperty('hasOrg', result.systemMode === _Izenda4.default.TENANT_MODE && result.allowDuplicateUser);
        store.model.updateProperty('enableForEnter', true);
        return (0, _bluebird.resolve)(true);
      }));
    };
  },


  /**
   * Update password expiry notify.
   * @param  {Number} count
   */
  updatePasswordExpiryNotify: function updatePasswordExpiryNotify(count) {
    var notificationKey = _Izenda2.default.NOTIFICATION_KEYS.PASSWORD_EXPIRY;
    if (!count) {
      _IzendaUiState2.default.removeNotification(notificationKey);
      return;
    }

    _IzendaUiState2.default.addNotification({
      key: notificationKey,
      type: MESSAGE_TYPE.INFO,
      // $FlowFixMe
      message: String.format(_Izenda2.default.MESSAGES.M16, count)
    });
  },


  /**
   * Set up auth information
   * @param  {Object} result - login result
   * @param  {Object} props
   */
  setUpAuthInfo: function setUpAuthInfo(result, props, url) {
    var fromLoginPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var data = result.data || {};
    var updatePasswordExpiryNotify = this.updatePasswordExpiryNotify;

    props.authorization.setAccessToken(data.token);
    updatePasswordExpiryNotify(data.notifyDuringDay);
    var defaultLink = props.authorization.getDefaultLink(_Izenda10.default, fromLoginPage && (0, _fp.isEmpty)((0, _fp.get)('licenseInfoStore.licenseInfo.licenseStatus', _Izenda6.default)));
    url = !(0, _fp.isNil)(url) ? url : defaultLink;

    // rewrite url
    history.replaceState && history.replaceState({}, document.title, url);
    props.router.replace(url);
    return (0, _bluebird.resolve)(true);
  }
};
module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var UiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil;

  var MyPreferenceActions = compose(withHandlers({
    updateValue: curry(updateValue),
    resetDataOffset: curry(resetDataOffset),
    resetTimestampOffset: curry(resetTimestampOffset)
  }));

  /**
   * Toggle section
   * @param {Object} props
   * @param {String} props name
   */
  function updateValue(props, key, element) {
    props.store.model.updateProperty(key, isNil(element.target) ? element : element.target.value);
  }

  /**
   * Reset data offset
   * @param {Object} props
   */
  function resetDataOffset(props) {
    props.store.model.updateProperty('dataOffset', UiState.currentUser.dataOffset);
  }

  /**
   * Reset timestamp offset
   * @param {Object} props
   */
  function resetTimestampOffset(props) {
    props.store.model.updateProperty('timestampOffset', UiState.currentUser.timestampOffset);
  }

  module.exports = MyPreferenceActions;
}();

/***/ }),
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(204);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(459);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.VizEngineFactories.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var vizFactories = new _Izenda2.default('Visualization Engine', true, function (name, chartType) {
  return name + '_' + chartType;
});

exports.default = {
  /**
   * Register a visualization engine with a name
   * @param {string} name The name of visualization engine
   * @param {any} vizEngineClazz The class of visualization engine
   */
  registerVisualizationEngine: function registerVisualizationEngine(name, vizEngineClazz) {
    ensure(vizEngineClazz.prototype instanceof _Izenda4.default, 'Visualization engine class must inherit from VizEngine');

    vizFactories.containKey(name) && vizFactories.unregister(name);

    vizFactories.register(name, function (key, chartType) {
      return new vizEngineClazz();
    });
  },


  /**
   * Get visualization engine by name
   * @param {string} name The name of visualization engine
   * @param {string} chartType The chart type
   */
  getVisualizationEngine: function getVisualizationEngine(name, chartType) {
    // Pass additional chart type for resolving cache key of factories
    return vizFactories.create(name, chartType);
  },


  /**
   * Reset the factories data
   */
  reset: function reset() {
    vizFactories.reset();
  }
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof2 = __webpack_require__(150);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.VizEngine.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * A visualizaiton engine base class
 */


var _Izenda = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VizEngine = (_dec = (0, _Izenda.exportClass)('VizEngine'), _dec(_class = function () {
  function VizEngine() {
    (0, _classCallCheck3.default)(this, VizEngine);
  }

  (0, _createClass3.default)(VizEngine, [{
    key: 'draw',

    /**
     * Draw visualization into container and return instance with releasing function
     * @param {DOMElement} chartContainer DOM element of virtualization
     * @param {string} chartType Chart type
     * @param {Object} options Chart options
     * @param {Function} onCompleted A callback function to be invoked after finished rendering
     */
    value: function draw(chartContainer, chartType, options, onCompleted) {}

    /**
     * Log highchart options for troubleshooting purpose
     * @param {Object} options Highchart options
     */

  }, {
    key: 'logHighchartOptions',
    value: function logHighchartOptions(options) {
      if (!console) {
        return;
      }

      var cache = [];
      var jsonOptions = (0, _stringify2.default)(options, function (key, value) {
        if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value !== null) {
          if (cache.indexOf(value) !== -1) {
            // Circular reference found, discard key
            return;
          }
          // Store value in our collection
          cache.push(value);
        }
        // Ignore chartContainer or background map object as it just contains the reference data
        return key === 'chartContainer' || key === 'backgroundMap' || key === 'mapData' ? null : value;
      });
      cache = null;
      console.log('Highchart options ', jsonOptions);
    }
  }]);
  return VizEngine;
}()) || _class);
exports.default = VizEngine;
module.exports = exports['default'];

/***/ }),
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountInfo.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      map = _require.map,
      forEach = _require.forEach,
      isEqual = _require.isEqual,
      min = _require.min,
      differenceBy = _require.differenceBy,
      take = _require.take,
      find = _require.find;

  var m = __webpack_require__(5);
  var SecurityQuestion = __webpack_require__(1398);
  var AccountConstants = __webpack_require__(60);
  var trackable = __webpack_require__(46);
  var SecurityQuestionReadOnly = __webpack_require__(814);

  function AccountInfo(mode, data, systemConfig) {
    // NOTE: intended for activation.
    this.numberOfQuestionProfile = null;
    this.fullSecurityQuestions = null; // array of SecurityQuestionReadOnly
    this.mode = mode || AccountConstants.MODES.PASSWORD_SETUP;

    var props = {
      // DTO
      id: null,
      systemAdmin: false,
      userName: null,
      firstName: null,
      lastName: null,
      emailAddress: null,
      verification: null,
      userSecurityQuestions: [], // Array of SecurityQuestion
      password: null,
      tenantDisplayID: null,
      tenantName: null,
      roles: [],
      dataOffset: null,
      timestampOffset: null,
      cultureName: 'en-US',
      dateFormat: 'MM/DD/YYYY',
      tenantId: null,
      fullName: null,
      passwordLastChanged: null,
      securityQuestionLastChanged: null,

      // For UI logic
      isExpiration: null, // null: not check yet, false: expired, true: not expiration.
      confirmPassword: null,
      message: null,
      currentStep: null,
      hasOrg: false,
      enableForEnter: false,
      hasChangeLanguage: false,
      // Computed
      securityQuestions: function () {
        return differenceBy('securityQuestionId', this.fullSecurityQuestions, this.userSecurityQuestions);
      }.bind(this),

      isSystemUser: function isSystemUser() {
        return isNil(this.tenantId);
      },

      languageList: [],
      dateFormatList: [],
      alertMessage: {},
      selectedQuestionList: [],
      currentModules: []
    };

    m.extendObservable(trackable(this), props);
    systemConfig && this.populateSystemConfig(systemConfig);
    data && this.populate(data);
  }

  /**
   * Populate system (system/tenant) config info.
   * @param  {Object} systemConfig
   */
  AccountInfo.prototype.populateSystemConfig = function (systemConfig) {
    this.numberOfQuestionProfile = systemConfig.numberOfQuestionProfile;
    this.fullSecurityQuestions = systemConfig.fullSecurityQuestions;
    return (0, _bluebird.resolve)(true);
  };

  /**
   * Populate date.
   * @param  {Object} data
   */
  AccountInfo.prototype.populate = m.action(function (data) {
    this.tenantDisplayID = data.tenantDisplayId;
    this.tenantName = data.tenantName;
    this.id = data.id;
    this.systemAdmin = data.systemAdmin;
    this.userName = data.userName;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.fullName = data.fullName;
    this.emailAddress = data.emailAddress;
    this.verification = data.verification;
    this.tenantId = data.tenantId;
    this.roles = data.roles;
    this.dataOffset = data.dataOffset;
    this.timestampOffset = data.timestampOffset;
    this.cultureName = data.cultureName;
    this.dateFormat = data.dateFormat;
    this.passwordLastChanged = data.passwordLastChanged;
    this.securityQuestionLastChanged = data.securityQuestionLastChanged;
    this.hasChangeLanguage = false;
    this.currentModules = data.currentModules;

    this.populateUserSecurityQuestions(data.userSecurityQuestions);
    this.getSelectedQuestionList();
  });

  /**
   * Update current step.
   * @param  {String} value
   */
  AccountInfo.prototype.updateCurrentStep = m.action(function (value) {
    this.currentStep = value;
    this.message = null;

    switch (value) {
      case AccountConstants.STEP_KEYS.SecurityInfo:
        this.resetPasswordInfo();
        this.resetUserSecurityQuestions();
        break;
      case AccountConstants.STEP_KEYS.QuestionInfo:
        this.resetUserSecurityQuestions();
        break;
      case AccountConstants.STEP_KEYS.PasswordInfo:
        this.resetPasswordInfo();
        break;
    }
  });

  /**
   * Reset security info.
   */
  AccountInfo.prototype.resetSecurityInfo = m.action(function () {
    this.password = null;
    this.confirmPassword = null;
  });

  /**
   * Update property's value.
   */
  AccountInfo.prototype.updateProperty = m.action(function (key, value) {
    this[key] = value;
    this.markDirty();

    // mark change language
    if (key === 'cultureName') {
      this.hasChangeLanguage = true;
    }
  });

  /**
   * Reset security info.
   */
  AccountInfo.prototype.resetUserSecurityQuestions = m.action(function () {
    forEach(function (item) {
      item.answer = null;
    }, this.userSecurityQuestions);
  });

  /**
   * Reset password info.
   */
  AccountInfo.prototype.resetPasswordInfo = m.action(function () {
    this.password = null;
    this.confirmPassword = null;
  });

  /**
   * Check whether given step is the current step.
   * @param  {String} value
   */
  AccountInfo.prototype.isCurrentStep = function (value) {
    return isEqual(value, this.currentStep);
  };

  /**
   * Check mode.
   * @param  {String} value
   */
  AccountInfo.prototype.isMode = function (value) {
    return isEqual(value, this.mode);
  };

  /**
   * Build default security questions.
   * It based con config and number of questions.
   */
  AccountInfo.prototype.populateUserSecurityQuestions = m.action(function (defaultQuestions) {
    this.userSecurityQuestions && this.userSecurityQuestions.clear();
    if (isNil(defaultQuestions) && !isNil(this.fullSecurityQuestions)) {
      var count = min([this.numberOfQuestionProfile, this.fullSecurityQuestions.length]);
      defaultQuestions = take(count, this.fullSecurityQuestions);
    }

    forEach(function (item) {
      this.userSecurityQuestions.push(new SecurityQuestion(item, this.fullSecurityQuestions));
    }.bind(this), defaultQuestions);

    return (0, _bluebird.resolve)(true);
  });

  /**
   * Get selected question list
   */
  AccountInfo.prototype.getSelectedQuestionList = m.action(function () {
    this.selectedQuestionList = map(function (q) {
      var data = {
        securityQuestionId: q.securityQuestionId
      };
      return new SecurityQuestion(data, this.fullSecurityQuestions);
    }.bind(this), this.userSecurityQuestions);

    var count = this.numberOfQuestionProfile - this.userSecurityQuestions.length;
    if (count > 0) {
      var remainingQuestionList = differenceBy('securityQuestionId', this.fullSecurityQuestions, this.userSecurityQuestions);
      remainingQuestionList = map(function (q) {
        var data = {
          securityQuestionId: q.securityQuestionId
        };
        return new SecurityQuestion(data, this.fullSecurityQuestions);
      }.bind(this), take(count, remainingQuestionList));
      forEach(function (q) {
        this.selectedQuestionList.push(q);
      }.bind(this), remainingQuestionList);
    }
  });

  /**
   * Update security question (include answer)
   * @param  {Object} question
   * @param  {String} property
   * @param  {String} value
   */
  AccountInfo.prototype.updateUserSecurityQuestion = m.action(function (question, property, value) {
    var matchedQuestion = find(function (item) {
      return isEqual(item.securityQuestionId, question.securityQuestionId);
    }, this.userSecurityQuestions);

    if (!isNil(matchedQuestion)) {
      matchedQuestion[property] = value;
    }
  });

  /**
   * Build security questions for saving
   */
  AccountInfo.prototype.buildUserSecurityQuestionsForSaving = function () {
    return map(function (item) {
      return {
        userId: this.id,
        securityQuestionId: item.securityQuestionId,
        answer: item.answer
      };
    }.bind(this), this.userSecurityQuestions);
  };

  /**
   * Populate my preference information
   * @param {Array} language list
   * @param {Array} date format list
   * @param {Array} role list
   */
  AccountInfo.prototype.populateMyProfile = m.action(function getMyPreferenceInfo(currentUser, languageList, dateFormatList, questions, config) {
    this.numberOfQuestionProfile = config.numberOfQuestionProfile;
    this.fullSecurityQuestions = map(function (item) {
      return new SecurityQuestionReadOnly(item);
    }, questions);
    this.populate(currentUser.data);
    this.languageList = languageList;
    this.dateFormatList = map(function (item) {
      return {
        labelDateFormat: item,
        dateFormat: item
      };
    }, dateFormatList);
  });

  /**
   * Build data for saving
   * @returns {Object} data
   */
  AccountInfo.prototype.buildDataForSaving = function () {
    return {
      id: this.id,
      systemAdmin: this.systemAdmin,
      userName: this.userName,
      firstName: this.firstName,
      lastName: this.lastName,
      cultureName: this.cultureName,
      dateFormat: this.dateFormat,
      tenantId: this.tenantId,
      emailAddress: this.emailAddress,
      roles: this.roles,
      dataOffset: this.dataOffset,
      timestampOffset: this.timestampOffset,
      tenantName: this.tenantName,
      hasChangeLanguage: this.hasChangeLanguage
    };
  };

  /**
   * Reset
   * @param {Object} current user
   */
  AccountInfo.prototype.reset = m.action(function (currentUser) {
    if (!isNil(currentUser)) {
      this.userName = currentUser.userName;
      this.firstName = currentUser.firstName;
      this.lastName = currentUser.lastName;
      this.cultureName = currentUser.cultureName;
      this.dateFormat = currentUser.dateFormat;
      this.emailAddress = currentUser.emailAddress;
      this.dataOffset = currentUser.dataOffset;
      this.timestampOffset = currentUser.timestampOffset;
    }
    this.alertMessage = {};
  });

  /**
   * Get remaining question list
   * @param {Object} question
   * @returns {Object} remaining question list
   */
  AccountInfo.prototype.getRemainingQuestionList = function (question) {
    var remainingQuestions = [question];
    var remainingQuestionList = differenceBy('securityQuestionId', this.fullSecurityQuestions, this.selectedQuestionList);

    forEach(function (q) {
      var data = {
        securityQuestionId: q.securityQuestionId
      };
      remainingQuestions.push(new SecurityQuestion(data, this.fullSecurityQuestions));
    }.bind(this), remainingQuestionList);

    return remainingQuestions;
  };

  /**
   * Build for update security questions
   * @returns {Object} security questions
   */
  AccountInfo.prototype.buildForUpdateSecurityQuestions = function () {
    return {
      userSecurityQuestions: map(function (q) {
        return {
          securityQuestionId: q.securityQuestionId,
          answer: q.answer
        };
      }, this.selectedQuestionList),
      userName: this.userName,
      id: this.id
    };
  };

  /**
   * Reset answers
   */
  AccountInfo.prototype.resetAnswers = m.action(function () {
    forEach(function (q) {
      q.answer = null;
    }, this.selectedQuestionList);
  });

  /**
   * Reset validation
   */
  AccountInfo.prototype.resetValidation = function () {
    this.alertMessage = {};
  };

  /**
   * Reset for login
   */
  AccountInfo.prototype.resetForLogin = m.action(function () {
    this.password = null;
    this.isExpiration = null;
    this.confirmPassword = null;
    this.message = null;
    this.currentStep = null;
    this.hasOrg = false;
    this.enableForEnter = false;
    this.hasChangeLanguage = false;
    this.populate({});
  });

  module.exports = AccountInfo;
}();

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseInfo.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var extendObservable = __webpack_require__(5).extendObservable;
  var localizer = __webpack_require__(12);
  var CONSTANTS = __webpack_require__(295);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      find = _require.find;

  function LicenseInfo() {
    this.hasValidLicense = false;

    var props = {
      licenseInfoDetail: {},
      licenseStatus: {},
      // For hidden license token and key on UI
      validatedLicense: false,
      isValidLicense: false,
      disableLicense: true,
      exceedLostConnectionAllowPeriod: false,
      validationError: {},
      licenseInValidMsg: '',
      productVersion: '',
      isConnectedToLicenseServer: true,
      isActiveLicense: function isActiveLicense() {
        return this.integrationActiveLicense && this.isValidLicense;
      },
      integrationActiveLicense: function integrationActiveLicense() {
        return this.numberOfDayToExpire > 0 && this.numberOfDayToValid === 0 && !this.disableLicense && !this.exceedLostConnectionAllowPeriod;
      },
      startDate: function startDate() {
        return this.licenseInfoDetail.startDate || '';
      },
      endDate: function endDate() {
        return this.licenseInfoDetail.endDate || '';
      },
      tokenKey: function tokenKey() {
        return this.licenseInfoDetail.tokenKey || '';
      },
      licenseKey: function licenseKey() {
        return this.licenseInfoDetail.licenseKey || '';
      },
      enableValidateButton: function enableValidateButton() {
        return this.licenseOnlineMode ? !!this.licenseKey : !!(this.tokenKey && this.licenseKey);
      },
      licenseOnlineMode: function licenseOnlineMode() {
        return this.licenseInfoDetail.licenseOnlineMode;
      },
      licenseEndDate: function licenseEndDate() {
        return this.licenseInfoDetail.licenseEndDate || '';
      },
      previousStartDate: function previousStartDate() {
        return this.licenseInfoDetail.previousStartDate || '';
      },
      previousEndDate: function previousEndDate() {
        return this.licenseInfoDetail.previousEndDate || '';
      },
      modules: function modules() {
        return this.licenseInfoDetail.modules || [];
      },
      previousModules: function previousModules() {
        return this.licenseInfoDetail.previousModules || [];
      },
      hasMapModules: function hasMapModules() {
        return !!find(function (module) {
          return module.name === CONSTANTS.MAP_MODULES_NAME;
        }, this.modules);
      },
      numberOfDayToValid: function numberOfDayToValid() {
        return this.licenseInfoDetail && this.licenseInfoDetail.numberOfDayToValid || this.licenseStatus && this.licenseStatus.numberOfDayToValid;
      },
      meetExprireWarningPeriod: function meetExprireWarningPeriod() {
        return this.licenseStatus && this.licenseStatus.meetExprireWarningPeriod || false;
      },
      numberOfDayToExpire: function numberOfDayToExpire() {
        return this.licenseStatus && this.licenseStatus.numberOfDayToExpire;
      },
      trialLicense: function trialLicense() {
        return this.licenseStatus && this.licenseStatus.trialLicense || false;
      },
      isOnlineLicenseValidInLostConnectionAllowPeriod: function isOnlineLicenseValidInLostConnectionAllowPeriod() {
        return this.licenseOnlineMode && this.isValidLicense && !this.isConnectedToLicenseServer && !this.exceedLostConnectionAllowPeriod;
      }
    };

    extendObservable(this, props);
  }

  /**
   * [readLicenseStatus description]
   * @param  {object} status [receive from API]
   */
  LicenseInfo.prototype.readLicenseStatus = m.action(function (status) {
    status = status || {};
    this.licenseStatus = status;
    this.disableLicense = status.disabled;
    this.exceedLostConnectionAllowPeriod = status.exceedLostConnectionAllowPeriod;
    this.isConnectedToLicenseServer = status.connected;
    status.exceedLostConnectionAllowPeriod && (this.isValidLicense = false);
  });

  /**
   * read validate response from api
   * @param  {object} response [from API]
   */
  LicenseInfo.prototype.readValidateLicense = m.action(function (response) {
    this.validatedLicense = true;
    this.isValidLicense = response.success;
    if (response.success) {
      this.licenseInfoDetail = response;
      this.hasValidLicense = true;
    }
  });

  /**
   * read license information response from api
   * @param  {object} response from api
   */
  LicenseInfo.prototype.readLicenseInforation = m.action(function (response) {
    // Set default license mode = online
    if (!response.success) {
      response.licenseOnlineMode = true;
    }
    this.hasValidLicense = this.isValidLicense = this.validatedLicense = isNil(response.success) ? !!response.licenseKey : response.success;
    this.disableLicense = !response.licenseEnable;
    this.validationError = this.disableLicense ? [CONSTANTS.MESSAGE.MG10] : [];
    this.licenseInValidMsg = '';
    this.licenseInfoDetail = response;
    this.productVersion = response.productVersion ? String.format(localizer.getText('COMMON_CRITERIA_VERSION') + ' {0}', response.productVersion) : '';
  });

  /**
   * Reset license information
   */
  LicenseInfo.prototype.resetLicenseInfo = m.action(function () {
    this.validatedLicense = false;
    this.isValidLicense = false;
    this.hasValidLicense = false;
    this.exceedLostConnectionAllowPeriod = false;
    this.licenseInfoDetail = {};
    this.licenseStatus = {};
  });

  /**
   * Update license info by key
   * This license info will be set as editable and invalid license
   * @param {type} key
   * @param {type} value
   */
  LicenseInfo.prototype.updateLicenseInfoByKey = m.action(function (key, value) {
    if (this.validatedLicense) {
      this.validatedLicense = false;
    }

    if (this.isValidLicense) {
      this.isValidLicense = false;
    }
    this.licenseInfoDetail[key] = value;
  });

  /**
   * license info construtor for test
   * @type {construtor}
   */
  LicenseInfo.prototype.LicenseInfo = LicenseInfo;

  module.exports = exports = new LicenseInfo();
}();

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      get = _require.get,
      isPlainObject = _require.isPlainObject,
      omit = _require.omit,
      isBoolean = _require.isBoolean,
      isNil = _require.isNil;

  var m = __webpack_require__(5);
  var PermissionDetail = __webpack_require__(206);
  var AccountInfo = __webpack_require__(482);
  var UiState = __webpack_require__(15);

  function SecurityDetail() {
    var props = {
      permission: new PermissionDetail(),
      isLoaded: false
    };

    m.extendObservable(this, props);
  }

  /**
   * Populate data
   * @param {Object} permission
   * @param {Object} tenantDetail
   * @param {Boolean} isLoaded
   */
  SecurityDetail.prototype.populate = m.action(function (permission, tenantDetail, isLoaded) {
    this.getPermission(permission, get('permission', tenantDetail));
    this.permission.populateData(permission, this.permission.propsCloned, this.permission);
    this.isLoaded = isLoaded;
  });

  /**
   * Get permission
   * @param {Object} permission
   * @param {Object} tenantPermission
   */
  SecurityDetail.prototype.getPermission = function (permission, tenantPermission) {
    if (permission.fullReportAndDashboardAccess) {
      updatePermission(permission.reports, get('reports', tenantPermission));
      updatePermission(permission.dashboards, get('dashboards', tenantPermission));
      updatePermission(permission.access, get('access', tenantPermission));
      updatePermission(permission.scheduling, get('scheduling', tenantPermission));
      updatePermission(permission.emailing, get('emailing', tenantPermission));
      updatePermission(permission.exporting, get('exporting', tenantPermission));
    }

    function updatePermission(permission, tenantPermission) {
      for (var key in omit('tenantAccess', permission)) {
        var data = permission[key];
        var tenant = get(key, tenantPermission);

        if (isPlainObject(data)) {
          updatePermission(data, tenant);
        } else if (isBoolean(data)) {
          if (isNil(tenantPermission)) {
            permission[key] = true;
          } else {
            permission[key] = tenant;
          }
        }
      }
    }
  };

  /**
   * Clear data
   */
  SecurityDetail.prototype.clear = m.action(function () {
    this.permission = new PermissionDetail();
    UiState.currentUser = new AccountInfo();
    // UiState.setTenantId(null);
    this.isLoaded = false;
  });

  var singleton = new SecurityDetail();
  module.exports = singleton;
}();

/***/ }),
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportBodyViewer.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * This component is intended to show only report body content.
 * Parameters locate in the params property.
 * id: required. Id of report part.
 *
 * Example build URI:
 * var ContentRoutes = require('routes/Izenda.ContentRoutes').contentRoutes;
 * var ROUTE = require('routes/Izenda.ContentRoutes').route;
 * var uri = routeUtils.getViewerUrl(
 *   'ReportBody',
 *   {
 *     id: 'e395dca2-088a-4ff2-8c54-9412fca495bf',
 *   }
 * );
 * // result: /viewer/reportbody/e395dca2-088a-4ff2-8c54-9412fca495bf?type=pdf
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1490);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(978);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(414);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(415);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(584);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(324);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(177);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(246);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2014);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(76);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(27);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda25 = __webpack_require__(222);

var _Izenda26 = _interopRequireDefault(_Izenda25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportBodyViewer = (_dec = (0, _Izenda2.default)(_Izenda20.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportBodyViewer, _Component);

  function ReportBodyViewer(props) {
    (0, _classCallCheck3.default)(this, ReportBodyViewer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportBodyViewer.__proto__ || (0, _getPrototypeOf2.default)(ReportBodyViewer)).call(this, props));

    var params = props.params,
        loader = props.loader,
        setting = props.setting,
        id = props.id,
        viewMode = props.viewMode,
        queryObject = props.queryObject,
        printingMode = props.printingMode,
        confirmFn = props.confirmFn,
        localization = props.localization;

    var location = props.location || {};
    var query = location.query || {};
    var defaultVersion = 0;
    var defaultVersionWithSetting = -1;
    var version = query.version || defaultVersion;
    _this.renderListeners = [];
    var reportId = id || params.id;
    _this.designerStore = new _Izenda14.default(viewMode, reportId);
    var fieldsStore = _this.designerStore.fieldsStore;

    setting && !version && (version = defaultVersionWithSetting);

    _this.reportHeaderKey = 'ReportHeader';
    _this.reportFooterKey = 'ReportFooter';
    _Izenda22.default.pushRenderListener(_this.renderListeners, _this.reportHeaderKey);
    _Izenda22.default.pushRenderListener(_this.renderListeners, _this.reportFooterKey);

    // build render listener
    var buildRenderListeners = function buildRenderListeners() {
      var renderListeners = _this.renderListeners;
      var activeReportParts = fieldsStore.reportBody.activeReportParts;
      (0, _fp.forEach)(function (part) {
        renderListeners.push(_Izenda22.default.createPartRenderPromise(part.id));
      }, activeReportParts);
    };

    loader.startLoading();

    var promiseResolveQuery = (0, _bluebird.resolve)();

    if (queryObject) {
      // queryObject is filter data that already process, if these filter data in URL we need a step to reprocess data
      _this.designerStore.model.setSubReportFilters(queryObject, false);
    } else if (query) {
      var subReportFilterFromQuery = _Izenda16.default.convertQueryToFilter(query);
      _this.designerStore.model.setSubReportFilters(subReportFilterFromQuery, true);
      promiseResolveQuery = _Izenda18.default.resolveSubReportFilter(subReportFilterFromQuery).then(function (subReportFilter) {
        _this.designerStore.model.setSubReportFilters(subReportFilter, false);
        return null;
      });
    }

    _this.designerStore.model.readURLOptions(query);

    promiseResolveQuery.then(function () {
      return _this.designerStore.loadReportDesigner(version, printingMode && !setting && buildRenderListeners);
    }).then(function () {
      if (!printingMode) {
        var subReportFilter = _this.designerStore.model.subReportFilter;
        var subReport = {
          selectedReport: reportId,
          masterReportId: subReportFilter.masterReportId,
          reportFilter: subReportFilter.inheritMasterReportFilter
        };
        fieldsStore.validateFilterFieldsTypeSubReport(subReport).then(function (result) {
          result && confirmFn('Information', {
            type: 'info_accept',
            description: localization.getText('REPORTDESIGNER_FILTER_LOGIC_SUBREPORT'),
            showCancel: false
          });
        });
      }
      return fieldsStore.getFilterData();
    }).then(function () {
      if (setting) {
        loader.endLoading();
        return (0, _bluebird.resolve)(true);
      }
    });
    return _this;
  }

  (0, _createClass3.default)(ReportBodyViewer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var fieldsStore = this.designerStore.fieldsStore;
      fieldsStore.terminateAllReportPartWorker();
    }
  }, {
    key: 'checkPageBreak',
    value: function checkPageBreak() {
      var exportFormatSetting = this.props.exportFormatSetting || this.designerStore.model.export;
      var doesBreakPage = exportFormatSetting.pageBreakAfterReportPart;

      var activeReportParts = this.designerStore.fieldsStore.reportBody.activeReportParts;

      !doesBreakPage && (0, _fp.forEach)(function (item) {
        if (item.reportPartContent.checkBreakPage && item.reportPartContent.checkBreakPage()) {
          doesBreakPage = true;
          return false;
        }
      }, activeReportParts);
      return doesBreakPage;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var setting = props.setting,
          hideHeaderFooter = props.hideHeaderFooter,
          hideGridPopup = props.hideGridPopup,
          className = props.className,
          printingMode = props.printingMode,
          getContainerClassName = props.getContainerClassName;

      var exportFormatSetting = props.exportFormatSetting || this.designerStore.model.export;
      var marginSettingInInches = exportFormatSetting.marginSettingInInches;
      var doesBreakPage = this.checkPageBreak();
      var fieldsStore = this.designerStore.fieldsStore;
      var showReportHeaderAndFooter = !setting && !hideHeaderFooter;

      var headerStyle = {
        height: marginSettingInInches.header,
        overflow: 'hidden'
      };

      var footerStyle = {
        height: marginSettingInInches.footer,
        overflow: 'hidden'
      };

      var containerClass = (0, _classnames2.default)('content-container', className);

      var content = _react2.default.createElement(
        'div',
        { className: containerClass },
        showReportHeaderAndFooter && _react2.default.createElement(_Izenda8.default, {
          store: fieldsStore,
          viewMode: true,
          replaceSystemVariable: _Izenda22.default.replaceSystemVariable,
          style: headerStyle,
          finishedRender: _Izenda22.default.getFinishedRenderPromiseById(this.renderListeners, this.reportHeaderKey),
          printingMode: printingMode
        }),
        _react2.default.createElement(_Izenda12.default, { store: fieldsStore, viewMode: true }),
        _react2.default.createElement(_Izenda6.default, { store: fieldsStore }),
        _react2.default.createElement(_Izenda4.default, {
          store: fieldsStore,
          viewMode: true,
          hideGridPopup: hideGridPopup,
          printingMode: printingMode,
          doesBreakPage: doesBreakPage,
          pageBreakAfterReportPart: exportFormatSetting.pageBreakAfterReportPart,
          exportFormatSetting: exportFormatSetting,
          renderListeners: this.renderListeners,
          setting: setting
        }),
        showReportHeaderAndFooter && _react2.default.createElement(_Izenda10.default, {
          store: fieldsStore,
          viewMode: true,
          style: footerStyle,
          finishedRender: _Izenda22.default.getFinishedRenderPromiseById(this.renderListeners, this.reportFooterKey),
          printingMode: printingMode
        })
      );

      var contentSizeInInches = {};

      if (setting) {
        contentSizeInInches = _Izenda26.default.getBodyContentSizeInInches(exportFormatSetting.pageSizeKey, exportFormatSetting.getMarginSetting, exportFormatSetting.getMarginSetting.header, exportFormatSetting.getMarginSetting.footer, exportFormatSetting.orientation);
      }

      var printablePageStyle = setting ? {
        width: _Izenda26.default.formatCSSValueInInches(contentSizeInInches.widthOfContentInInches),
        height: _Izenda26.default.formatCSSValueInInches(contentSizeInInches.heightOfContentInInches)
      } : {};
      return _react2.default.createElement(
        'section',
        { className: getContainerClassName(exportFormatSetting), style: printablePageStyle },
        printingMode ? content : _react2.default.createElement(
          _Izenda24.default,
          null,
          content
        )
      );
    }
  }]);
  return ReportBodyViewer;
}(_react.Component), _class2.propTypes = {
  params: _propTypes2.default.object
}, _class2.defaultProps = {
  hideHeaderFooter: false,
  hideGridPopup: false,
  viewMode: true
}, _temp)) || _class);
exports.default = ReportBodyViewer;
module.exports = exports['default'];

/***/ }),
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LayoutComputerUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      get = _require.get,
      map = _require.map,
      sortBy = _require.sortBy,
      forEach = _require.forEach,
      placeholder = _require.placeholder;

  module.exports = {
    getGridLeft: function getGridLeft(left, cellWidth) {
      return Math.floor(left / cellWidth);
    },
    getGridTop: function getGridTop(top, cellHeight) {
      return Math.floor(top / cellHeight);
    },
    getGridWidth: function getGridWidth(width, cellWidth) {
      return Math.ceil(width / cellWidth);
    },
    getGridHeight: function getGridHeight(height, cellHeight) {
      return Math.ceil(height / cellHeight);
    },
    getDomLeft: function getDomLeft(gridX, cellWidth) {
      return (gridX || 0) * cellWidth;
    },
    getDomTop: function getDomTop(gridY, cellHeight) {
      return (gridY || 0) * cellHeight;
    },
    getDomWidth: function getDomWidth(gridW, cellWidth) {
      return (gridW || 0) * cellWidth;
    },
    getDomHeight: function getDomHeight(gridH, cellHeight) {
      return (gridH || 0) * cellHeight;
    },
    getDomPosition: function getDomPosition(gridX, gridY, gridW, gridH, cellWidth, cellHeight) {
      return {
        left: this.getDomLeft(gridX, cellWidth),
        top: this.getDomTop(gridY, cellHeight),
        width: gridW === Infinity ? gridW : this.getDomWidth(gridW, cellWidth),
        height: gridH === Infinity ? gridH : this.getDomWidth(gridH, cellHeight)
      };
    },
    getGridPosition: function getGridPosition(domX, domY, domW, domH, cellWidth, cellHeight) {
      return {
        left: this.getGridLeft(domX, cellWidth),
        top: this.getGridTop(domY, cellHeight),
        width: this.getGridWidth(domW, cellWidth),
        height: this.getGridWidth(domH, cellHeight)
      };
    },

    /**
     * Round width value of grid view by multiplied of grid's cell width.
     * @param  {Number} domW DOM element's width
     * @return {Number}      Rounded DOM element's width
     */
    roundWidth: function roundWidth(domW, cellWidth) {
      return Math.ceil(domW / cellWidth) * cellWidth;
    },

    /**
     * Round height value of grid view by multiplied of grid's cell height.
     * @param  {Number} domH DOM element's height
     * @return {Number}      Rounded DOM element's height
     */
    roundHeight: function roundHeight(domH, cellHeight) {
      return Math.ceil(domH / cellHeight) * cellHeight;
    },

    /**
     * Convert grid item state to layout item
     */
    convertToLayoutItem: function convertToLayoutItem(gridItem, cellWidth, cellHeight, ignorePx) {
      return ignorePx ? {
        id: gridItem.id,
        top: gridItem.gridTop,
        left: gridItem.gridLeft,
        width: gridItem.gridWidth,
        height: gridItem.gridHeight
      } : {
        id: gridItem.id,
        top: gridItem.pxTop ? this.getGridTop(gridItem.pxTop, cellHeight) : gridItem.gridTop,
        left: gridItem.pxLeft ? this.getGridLeft(gridItem.pxLeft, cellWidth) : gridItem.gridLeft,
        width: gridItem.pxWidth ? this.getGridWidth(gridItem.pxWidth, cellWidth) : gridItem.gridWidth,
        height: gridItem.pxHeight ? this.getGridHeight(gridItem.pxHeight, cellHeight) : gridItem.gridHeight
      };
    },

    convertToRect: function convertToRect(id, x, y, w, h) {
      return {
        id: id,
        x1: x,
        y1: y,
        x2: x + w,
        y2: y + h
      };
    },
    /**
     * Convert layout item to rectangle object
     */
    convertLayoutItemToRect: function convertLayoutItemToRect(cellWidth, cellHeight) {
      var computer = this;
      return function (item) {
        var itemWidth = item.autoSize ? computer.getGridWidth(item.pxWidth, cellWidth) : item.gridWidth;
        var itemHeight = item.autoSize ? computer.getGridHeight(item.pxHeight, cellHeight) : item.gridHeight;

        return computer.convertToRect(item.id, item.gridLeft, item.gridTop, itemWidth, itemHeight);
      };
    },
    /**
     * Convert all layout items to array of rectangle objects
     */
    convertLayoutsToRects: function convertLayoutsToRects(layouts, cellWidth, cellHeight) {
      var toRect = this.convertLayoutItemToRect(cellWidth, cellHeight);
      return map(toRect, layouts);
    },
    /**
     * Convert rectangle to layout item
     */
    convertRectToLayoutItem: function convertRectToLayoutItem(rect, cellWidth, cellHeight) {
      var width = rect.x2 - rect.x1;
      var height = rect.y2 - rect.y1;
      return {
        gridLeft: rect.x1,
        gridTop: rect.y1,
        gridWidth: width,
        gridHeight: height,
        pxTop: this.getDomTop(rect.y1, cellHeight),
        pxLeft: this.getDomLeft(rect.x1, cellWidth),
        pxWidth: this.getDomWidth(width, cellWidth),
        pxHeight: this.getDomHeight(height, cellHeight)
      };
    },
    /**
     * Calculate intersection area of two rectangles
     * @return {Number}              Intersection area
     */
    calculateIntersection: function calculateIntersection(checkingRect, runningRect) {
      // See http://stackoverflow.com/questions/9324339/how-much-do-two-rectangles-overlap
      var minX2 = Math.min(checkingRect.x2, runningRect.x2);
      var minY2 = Math.min(checkingRect.y2, runningRect.y2);

      var maxX1 = Math.max(checkingRect.x1, runningRect.x1);
      var maxY1 = Math.max(checkingRect.y1, runningRect.y1);

      return Math.max(0, minX2 - maxX1) * Math.max(0, minY2 - maxY1);
    },
    /**
     * Calculate interaction area ratio with checking rectangle
     */
    calculateIntersectionRatio: function calculateIntersectionRatio(checkingRect, runningRect) {
      var interArea = this.calculateIntersection(checkingRect, runningRect);
      var checkingWidth = checkingRect.x2 - checkingRect.x1;
      var checkingHeight = checkingRect.y2 - checkingRect.y1;
      var checkingArea = checkingWidth * checkingHeight;

      return checkingArea <= 0 ? 0.0 : interArea / checkingArea;
    },
    /**
     * Calculate spare offset at (x,y) position in the layout
     * @param  {Number} x             X value
     * @param  {Number} y             Y value
     * @param  {Array} occupiedRects  Array of occupied rectangles
     */
    calculateSpareOffset: function calculateSpareOffset(x, y, occupiedRects) {
      var x1 = x;
      var x2 = x;
      var y1 = y;
      var y2 = y + 1;

      var winnerX = placeholder(occupiedRects).filter(function (rect) {
        return rect.x1 > x2 && rect.y1 < y + 3 && rect.y2 > y1;
      }).map(get('x1')).min();

      var winnerY = placeholder(occupiedRects).filter(function (rect) {
        return rect.y1 >= y2 && rect.x1 < (winnerX || Infinity) && rect.x2 > x1;
      }).map(get('y1')).min();

      return {
        left: x,
        top: y,
        width: winnerX ? winnerX - x : Infinity,
        height: winnerY ? winnerY - y : Infinity
      };
    },
    /**
     * Check collision of two rectangle
     */
    collide: function collide(checkingRect) {
      var utils = this;
      return function (runningRect) {
        return utils.calculateIntersection(checkingRect, runningRect) > 0;
      };
    },

    /**
     * Check whether runningRect is swappable with checkingRect
     */
    swappable: function swappable(checkingRect, swapIntersectionRatio) {
      var utils = this;
      return function (runningRect) {
        var ratio = utils.calculateIntersectionRatio(checkingRect, runningRect);
        return ratio > swapIntersectionRatio;
      };
    },

    sortLayout: function sortLayout(layout) {
      return placeholder(layout).sortBy(['y1', 'x1']);
    },

    getAllCollisions: function getAllCollisions(checkingItem, layout) {
      return placeholder(layout).filter(this.collide(checkingItem));
    },

    getFirstCollision: function getFirstCollision(checkingItem, layout) {
      return placeholder(layout).find(this.collide(checkingItem));
    },

    getBottom: function getBottom(layout) {
      return placeholder(layout).map(get('y2')).max();
    },
    getRight: function getRight(layout) {
      return placeholder(layout).map(get('x2')).max();
    },
    compactLayout: function compactLayout(layout, oldLayoutItem, resize) {
      var index = 0,
          len = layout.length;
      var detectingItem, restItems, movingItems, spare, occupiedRects, detectingRect;
      var sorted = sortBy(['left', 'top'], layout);

      // If it doesn't specify an item, scan all collisions in layout and expand
      // the layout items to remove collisions.
      if (!oldLayoutItem) {
        // Detect any collided items
        for (; index < len; index++) {
          // Pick item for collision detecting sequentially
          detectingItem = sorted[index];

          // Detect collisions with the rest of items. Note that layout has been sorted
          // by position.
          restItems = placeholder(sorted).slice(index + 1).value();

          occupiedRects = placeholder(restItems).map(function (item) {
            return this.convertToRect(item.id, item.left, item.top, item.width, item.height);
          }.bind(this)).value();

          detectingRect = this.convertToRect(detectingItem.id, detectingItem.left, detectingItem.top, detectingItem.width, detectingItem.height);

          if (resize || this.getFirstCollision(detectingRect, occupiedRects)) {
            // The movement distance is the collision space. Take the spare space
            // as old layout item position will ensure that.
            spare = this.calculateSpareOffset(detectingItem.left, detectingItem.top, occupiedRects);
            movingItems = this.compactLayout(sorted, {
              id: detectingItem.id,
              top: spare.top,
              left: spare.left,
              width: spare.width,
              height: spare.height
            });

            // Move items to available position.
            placeholder(movingItems).forEach(function (move) {
              var updateItem = placeholder(sorted).find(['id', move.id]);
              updateItem.top = move.top;
              updateItem.left = move.left;
            });
          }
        }

        return sorted;
      }

      var currentLayoutItem = placeholder(sorted).find(['id', oldLayoutItem.id]);
      var currentLayoutItemIdx = placeholder(sorted).indexOf(currentLayoutItem);
      var checkingLayout = placeholder(sorted).slice(currentLayoutItemIdx + 1).value();

      var deltaX = currentLayoutItem.width - oldLayoutItem.width;
      var deltaY = currentLayoutItem.height - oldLayoutItem.height;
      var getHeight = deltaX > 0 ? Math.max : Math.min;

      var horizontalCheck = {
        id: currentLayoutItem.id,
        top: currentLayoutItem.top,
        left: currentLayoutItem.left,
        width: oldLayoutItem.width,
        height: getHeight(oldLayoutItem.height, currentLayoutItem.height)
      };
      var horizontalCollisions = this.getPossibleCollision(horizontalCheck, checkingLayout, collidesRight);
      var horizontalUpdates = this.moveItems(horizontalCollisions, checkingLayout, deltaX, false);

      forEach(function (horzUpdate) {
        var item = placeholder(checkingLayout).find(['id', horzUpdate.id]);
        item.left = horzUpdate.left;
      }, horizontalUpdates);

      var getWidth = deltaY > 0 ? Math.max : Math.min;
      var verticalCheck = {
        id: currentLayoutItem.id,
        top: currentLayoutItem.top,
        left: currentLayoutItem.left,
        width: getWidth(oldLayoutItem.width, currentLayoutItem.width),
        height: oldLayoutItem.height
      };
      var verticalCollisions = this.getPossibleCollision(verticalCheck, checkingLayout, collidesBottom);
      var verticalUpdates = this.moveItems(verticalCollisions, checkingLayout, deltaY, true);

      return horizontalUpdates.concat(verticalUpdates);

      function collidesRight(anchor, checking) {
        return checking.left >= anchor.left + anchor.width && checking.top < anchor.top + anchor.height && checking.top + checking.height > anchor.top;
      }

      function collidesBottom(anchor, checking) {
        return checking.top >= anchor.top + anchor.height && checking.left < anchor.left + anchor.width && checking.left + checking.width > anchor.left;
      }
    },

    moveItems: function moveItems(movingItems, layout, movingDistance, isVertical) {
      var movingIdx, movingLen, movingItem, finalMove, bound, boundDistance;
      var output = [],
          collisions;
      var move = isVertical ? moveY : moveX;
      var max = isVertical ? maxY : maxX;
      var distance = isVertical ? distanceY : distanceX;
      var collides = isVertical ? collidesTop : collidesLeft;

      var staticLayouts = placeholder(layout).reject(function (item) {
        return placeholder(movingItems).findIndex(['id', item.id]) >= 0;
      }).value();

      for (movingIdx = 0, movingLen = movingItems.length; movingIdx < movingLen; movingIdx++) {
        movingItem = movingItems[movingIdx];

        if (movingDistance < 0) {
          // Movement becomes more sophisticated when collapsing item's position.
          // Before collapsing position, it needs to count available space for collapsing
          // and only collapses in the available space.
          collisions = this.getPossibleCollision(movingItem, staticLayouts, collides);
          bound = max(collisions) || 0;
          boundDistance = distance(movingItem, bound);
          movingDistance = Math.max(boundDistance, movingDistance);
        }
        finalMove = move(movingItem, movingDistance);
        staticLayouts.push(finalMove);
        output.push(finalMove);
      }
      return output;

      function maxX(items) {
        return placeholder(items).map(function (item) {
          return item.left + item.width;
        }).max();
      }

      function maxY(items) {
        return placeholder(items).map(function (item) {
          return item.top + item.height;
        }).max();
      }

      function distanceX(item, bound) {
        return bound - item.left;
      }

      function distanceY(item, bound) {
        return bound - item.top;
      }

      function moveX(item, distance) {
        return {
          id: item.id,
          top: item.top,
          left: item.left + distance,
          width: item.width,
          height: item.height
        };
      }

      function moveY(item, distance) {
        return {
          id: item.id,
          top: item.top + distance,
          left: item.left,
          width: item.width,
          height: item.height
        };
      }

      function collidesLeft(anchor, checking) {
        return checking.left + checking.width <= anchor.left && checking.top < anchor.top + anchor.height && checking.top + checking.height > anchor.top;
      }

      function collidesTop(anchor, checking) {
        return checking.top + checking.height <= anchor.top && checking.left < anchor.left + anchor.width && checking.left + checking.width > anchor.left;
      }
    },

    getPossibleCollision: function getPossibleCollision(item, layout, collides) {
      var utils = this;
      var groups = placeholder(layout).partition(function (rect) {
        return collides(item, rect);
      }).value();

      var collisions = groups[0];
      var remains = groups[1];

      if (collisions.length === 0) {
        return [];
      }
      return placeholder(collisions).reduce(function (result, collided) {
        result.push(collided);
        return result.concat(utils.getPossibleCollision(collided, remains, collides));
      }, []);
    }
  };
}();

/***/ }),
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartCommonActionPopup.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var ChartCommonActionPopup = function ChartCommonActionPopup(props) {
  var fieldConfig = props.fieldConfig;
  var subReport = (0, _fp.get)('subReport', fieldConfig);
  var customURL = (0, _fp.get)('customURL', fieldConfig);
  var embeddedJavascript = (0, _fp.get)('embeddedJavascript', fieldConfig);
  var localization = props.localization;

  return _react2.default.createElement(
    _Izenda4.default,
    { visible: true, onClosed: handleClosed, type: 'none', sizeClass: 'modal-sm' },
    _react2.default.createElement(_Izenda4.default.Header, { title: localization.getText('REPORTDESIGNER_LABEL_OPEN_ACTIONS') }),
    _react2.default.createElement(
      _Izenda4.default.Body,
      null,
      renderContainer(localization)
    )
  );

  function handleClosed(type) {
    props.onAccept();
  }

  function renderContainer(localization) {
    return _react2.default.createElement(
      _Izenda6.default,
      null,
      (0, _fp.get)('selectedReport', subReport) ? _react2.default.createElement(
        _Izenda6.default.Row,
        null,
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 1 },
          (0, _fp.get)('viewSettingByLink', subReport) ? null : _react2.default.createElement('span', { className: (0, _fp.get)('selectedIconValue.icon', subReport) })
        ),
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 11 },
          _react2.default.createElement(
            'a',
            { onClick: handleOpenSubReport },
            localization.getText('REPORTDESIGNER_LABEL_OPEN_SUBREPORT')
          )
        )
      ) : null,
      (0, _fp.get)('url', customURL) ? _react2.default.createElement(
        _Izenda6.default.Row,
        null,
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 1 },
          (0, _fp.get)('viewSettingByLink', customURL) ? null : _react2.default.createElement('span', { className: (0, _fp.get)('selectedIconValue.icon', customURL) })
        ),
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 11 },
          _react2.default.createElement(
            'a',
            { onClick: handleOpenLink },
            localization.getText('REPORTDESIGNER_LABEL_OPEN_LINK')
          )
        )
      ) : null,
      (0, _fp.get)('script', embeddedJavascript) ? _react2.default.createElement(
        _Izenda6.default.Row,
        null,
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 1 },
          (0, _fp.get)('viewSettingByLink', embeddedJavascript) ? null : _react2.default.createElement('span', { className: (0, _fp.get)('selectedIconValue.icon', embeddedJavascript) })
        ),
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 11 },
          _react2.default.createElement(
            'a',
            { onClick: handlePerformAction },
            localization.getText('REPORTDESIGNER_LABEL_PERFORM_ACTION')
          )
        )
      ) : null
    );
  }

  function handleOpenSubReport() {
    props.onAccept('openSubReport');
  }

  function handleOpenLink() {
    props.onAccept('openCustomURL');
  }

  function handlePerformAction() {
    props.onAccept('performEmbeddedJavascript');
  }
};

ChartCommonActionPopup.propsType = {
  fieldConfig: _react2.default.PropTypes.object
};

exports.default = (0, _Izenda2.default)()(ChartCommonActionPopup);
module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(142);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(42);

var _Izenda6 = __webpack_require__(45);

var _Izenda7 = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REPORT_PART_TYPES = [{
  key: 'chart',
  value: _Izenda7.REPORT_PART_TYPE.Chart,
  icon: 'icon-chart-bar',
  get label() {
    return _Izenda4.default.getText('COMMON_LABEL_CHART');
  },
  haveDashboardScroll: false,
  component: {
    BackSide: __webpack_require__(541),
    FrontSide: __webpack_require__(1885)
  },
  properties: {
    reportPart: __webpack_require__(574),
    fieldProps: __webpack_require__(1909)
  },
  permissions: [_Izenda5.PERMISSION_KEY.ReportsReportPartTypesChart],
  licenseKey: _Izenda6.LICENSE_KEY.Charting
}, {
  key: 'form',
  value: _Izenda7.REPORT_PART_TYPE.Form,
  icon: 'icon-doc-text',
  get label() {
    // for size of container
    return _Izenda4.default.getText('COMMON_LABEL_FORM');
  },
  haveDashboardScroll: true,
  component: {
    BackSide: __webpack_require__(1910),
    FrontSide: __webpack_require__(1932)
  },
  properties: {
    reportPart: __webpack_require__(1938),
    fieldProps: __webpack_require__(1951)
  },
  permissions: [_Izenda5.PERMISSION_KEY.ReportsReportPartTypesForm],
  licenseKey: _Izenda6.LICENSE_KEY.Form
}, {
  key: 'gauge',
  value: _Izenda7.REPORT_PART_TYPE.Gauge,
  icon: 'icon-gauge',
  get label() {
    // for size of container
    return _Izenda4.default.getText('COMMON_LABEL_GAUGE');
  },
  component: {
    BackSide: __webpack_require__(541),
    FrontSide: __webpack_require__(1952)
  },
  properties: {
    reportPart: __webpack_require__(574),
    fieldProps: __webpack_require__(1954)
  },
  permissions: [_Izenda5.PERMISSION_KEY.ReportsReportPartTypesGauge],
  licenseKey: _Izenda6.LICENSE_KEY.Charting
}, {
  key: 'grid',
  value: _Izenda7.REPORT_PART_TYPE.Grid,
  icon: 'icon-grid',
  get label() {
    // for size of container
    return _Izenda4.default.getText('COMMON_LABEL_GRID');
  },
  haveDashboardScroll: true,
  width: 0,
  height: 0,
  component: {
    BackSide: __webpack_require__(1955),
    FrontSide: __webpack_require__(1956)
  },
  properties: {
    reportPart: __webpack_require__(1966),
    fieldProps: __webpack_require__(1969)
  }
}, {
  key: 'map',
  value: _Izenda7.REPORT_PART_TYPE.Map,
  icon: 'icon-globe',
  get label() {
    // for size of container
    return _Izenda4.default.getText('COMMON_LABEL_MAP');
  },
  haveDashboardScroll: false,
  component: {
    BackSide: __webpack_require__(541),
    FrontSide: __webpack_require__(1970)
  },
  properties: {
    reportPart: __webpack_require__(574),
    fieldProps: __webpack_require__(1974)
  },
  permissions: [_Izenda5.PERMISSION_KEY.ReportsReportPartTypesMap],
  licenseKey: _Izenda6.LICENSE_KEY.Maps
}]; // for size of container

/**
 * Option object
 */
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTypeRegistry.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartTypeRegistry component
 */
exports.default = {
  REPORT_PART_TYPES: REPORT_PART_TYPES,

  /**
   * Initialize ReportPartTypes to ReportPartTypeManager registry
   */
  initRegistry: function initRegistry() {
    REPORT_PART_TYPES.forEach(function (reportPart) {
      _Izenda2.default.registerReportPartType(reportPart, reportPart.key);
    });
  }
};
module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(214);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartBackSideConfiguration.js"
// company="Izenda">  Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(65);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(542);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(377);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartBackSideConfiguration = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartBackSideConfiguration, _Component);

  function ReportPartBackSideConfiguration() {
    (0, _classCallCheck3.default)(this, ReportPartBackSideConfiguration);
    return (0, _possibleConstructorReturn3.default)(this, (ReportPartBackSideConfiguration.__proto__ || (0, _getPrototypeOf2.default)(ReportPartBackSideConfiguration)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportPartBackSideConfiguration, [{
    key: 'render',
    value: function render() {
      var props = this.props;

      var containers = this.getContainers();
      var createContainer = function createContainer(_ref) {
        var component = _ref.component,
            key = _ref.key,
            others = (0, _objectWithoutProperties3.default)(_ref, ['component', 'key']);

        var Comp = component || _Izenda10.default;
        return _react2.default.createElement(Comp, (0, _extends3.default)({ key: key }, others, props));
      };

      return _react2.default.createElement(
        _Izenda4.default,
        { className: 'izenda-ReportPartConfiguration u_paddingBottom' },
        containers.map(createContainer)
      );
    }
  }, {
    key: 'getContainers',
    value: function getContainers() {
      var reportPartContent = this.props.reportPart.reportPartContent;


      var reportPartStyle = reportPartContent.reportPartStyle;
      var reportPartType = reportPartContent.type;

      var _cfgFactories$getConf = _Izenda6.default.getConfiguration(reportPartType, reportPartStyle),
          fieldContainerSchema = _cfgFactories$getConf.fieldContainerSchema;

      var confSchemas = fieldContainerSchema(reportPartContent);

      var containers = confSchemas.map(function (s) {
        var key = (0, _keys2.default)(s)[0];
        return key ? _Izenda8.default.create(key, s[key]) : undefined;
      });

      return (0, _fp.compact)(containers);
    }
  }]);
  return ReportPartBackSideConfiguration;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object,
  reportPart: _react.PropTypes.object
}, _temp)) || _class);
exports.default = ReportPartBackSideConfiguration;
module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(204);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Izenda2.default('Field Container');
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldContainerFactories.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsContainerSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var WIDGETS = {
    ReportPartFieldPropsContainer: __webpack_require__(1752)
  };

  module.exports = function (editorComp, reportDesignerModel, fieldStore) {
    var SCHEMA_DEF = {
      title: '',
      schemaKey: 'REPORT_PART_FIELD_PROPERTIES',
      component: 'ReportPartFieldPropsContainer',
      props: {
        reportDesignerModel: 'reportDesignerModel',
        fieldStore: 'fieldStore'
      },
      fields: {}
    };

    return {
      // define data to render UI
      definedSchema: SCHEMA_DEF,

      // list of widgets which are used to render UI
      widgets: WIDGETS,

      // data to binding to fields
      source: {},

      // properties for different fields
      mappingProps: {
        reportDesignerModel: reportDesignerModel,
        fieldStore: fieldStore
      },

      // defined-function which fields need to execute to get its data
      mappingSource: {},

      onChangeValue: function onChangeValue(schemaData, changedKey, changedKeyPath, changedOthersInfo) {}
    };
  };
}();

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _Izenda = __webpack_require__(204);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesFieldEditorFactories.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = new _Izenda2.default('Property Editor');
module.exports = exports['default'];

/***/ }),
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimePickerByDateElement.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Date Time Picker component
 */


var _fp = __webpack_require__(1);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda = __webpack_require__(176);

var _Izenda2 = __webpack_require__(170);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(109);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(15);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _EventUtils = __webpack_require__(24);

var _Izenda8 = __webpack_require__(29);

var _Izenda9 = _interopRequireDefault(_Izenda8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateTimePickerByDateElement = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DateTimePickerByDateElement, _Component);

  function DateTimePickerByDateElement(props) {
    (0, _classCallCheck3.default)(this, DateTimePickerByDateElement);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DateTimePickerByDateElement.__proto__ || (0, _getPrototypeOf2.default)(DateTimePickerByDateElement)).call(this, props));

    _this.getWeekdayOptions();
    return _this;
  }

  (0, _createClass3.default)(DateTimePickerByDateElement, [{
    key: "getWeekdayOptions",
    value: function getWeekdayOptions() {
      this.weekdayOptions = (0, _fp.map)(function (index) {
        return {
          value: index + 1,
          label: (0, _moment2.default)(index + 1, _Izenda.GROUP_BY.weekday.COMPARE_FORMAT, true).format(_Izenda.GROUP_BY.weekday.DISPLAY_DATE_FORMAT)
        };
      }, (0, _fp.times)(_fp.identity, 7));
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var groupBy = props.groupByDateTime,
          onChange = props.onChange;

      var rest = (0, _fp.omit)(["groupBy"], props);

      if (!groupBy) {
        return _react2.default.createElement(_Izenda3.default, rest);
      }

      var setting = _Izenda.GROUP_BY[groupBy];
      switch (setting) {
        case _Izenda.GROUP_BY.day:
        case _Izenda.GROUP_BY.month:
        case _Izenda.GROUP_BY.year:
        case _Izenda.GROUP_BY.quarter:
          return _react2.default.createElement(_Izenda5.default, (0, _extends3.default)({}, rest, setting.NUMBER_PICKER_PROPS));
        case _Izenda.GROUP_BY.weekday:
          return _react2.default.createElement(_Izenda9.default, (0, _extends3.default)({}, rest, {
            onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils.DROPDOWN),
            options: this.weekdayOptions,
            labelKey: "label",
            valueKey: "value"
          }));
        default:
          return _react2.default.createElement(_Izenda3.default, (0, _extends3.default)({}, (0, _fp.omit)(["dateTimeFormatData"], props), setting.DATE_PICKER_PROPS, {
            displayFormat: (0, _fp.getOr)(setting.DISPLAY_DATE_FORMAT, "[" + _Izenda7.default.currentUser.dateFormat + "]", setting.DISPLAY_DATE_FORMAT),
            storeFormat: (0, _fp.get)("COMPARE_FORMAT", setting)
          }));
      }
    }
  }]);
  return DateTimePickerByDateElement;
}(_react.Component), _class.propTypes = {
  groupByDateTime: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.instanceOf(Date)])
}, _temp);
exports.default = DateTimePickerByDateElement;
module.exports = exports["default"];

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; // ----------------------------------------------------------------------
// <copyright file='Izenda.ViewSetting.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(82);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewSetting = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ViewSetting, _Component);

  function ViewSetting() {
    (0, _classCallCheck3.default)(this, ViewSetting);
    return (0, _possibleConstructorReturn3.default)(this, (ViewSetting.__proto__ || (0, _getPrototypeOf2.default)(ViewSetting)).apply(this, arguments));
  }

  (0, _createClass3.default)(ViewSetting, [{
    key: 'selectedIcon',
    value: function selectedIcon() {
      var selectedIconValue = this.props.selectedIconValue;

      return _react2.default.createElement(
        'a',
        null,
        _react2.default.createElement('i', { className: selectedIconValue.icon, value: selectedIconValue.value })
      );
    }
  }, {
    key: 'renderListIcons',
    value: function renderListIcons() {
      var props = this.props;
      var onClick = function onClick(value) {
        return function () {
          props.updateSelectedViewSettingIcon(value);
        };
      };

      return (0, _fp.map)(function (item) {
        return _react2.default.createElement(
          'li',
          { className: 'no-padding', key: item.value, onClick: onClick(item.value) },
          _react2.default.createElement('a', { className: item.icon, value: item.value })
        );
      }, _Izenda3.SUB_REPORT.ICON_TYPES);
    }
  }, {
    key: 'renderIconDropDownList',
    value: function renderIconDropDownList() {
      var viewSettingByLink = this.props.viewSettingByLink;

      var iconDropdownClass = (0, _classnames2.default)('form-control custom-drop-down', { disabled: viewSettingByLink });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            ref: function ref(dom) {
              dom && $izenda(dom).dropdown();
            },
            className: iconDropdownClass,
            'data-toggle': 'dropdown',
            disabled: viewSettingByLink
          },
          this.selectedIcon(),
          _react2.default.createElement('span', { className: 'icon-triangle-down pull-right' })
        ),
        _react2.default.createElement(
          'ul',
          { className: 'dropdown-menu' },
          this.renderListIcons()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var localization = props.localization;

      return _react2.default.createElement(
        'div',
        { className: 'input-group col-md-12 border-view-setting' },
        _react2.default.createElement(
          'label',
          { className: 'col-md-12 no-padding' },
          localization.getText('REPORTDESIGNER_LABEL_VIEW_SETTING_AS')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-12 no-padding' },
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'viewSetting',
            checked: props.viewSettingByLink,
            onChange: props.updateViewSettingByLink
          }),
          localization.getText('COMMON_LABEL_LINK')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-12 no-padding' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-2 no-padding' },
            _react2.default.createElement('input', {
              type: 'radio',
              name: 'viewSetting',
              checked: !props.viewSettingByLink,
              onChange: props.updateViewSettingByLink
            }),
            localization.getText('COMMON_LABEL_ICON')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-3 no-padding' },
            this.renderIconDropDownList()
          )
        )
      );
    }
  }]);
  return ViewSetting;
}(_react.Component), _class2.propTypes = {
  viewSettingByLink: _react.PropTypes.bool.isRequired,
  selectedIconValue: _react.PropTypes.object.isRequired,
  updateSelectedViewSettingIcon: _react.PropTypes.func.isRequired,
  updateViewSettingByLink: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = ViewSetting;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.TableCell.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(34);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_HEIGHT_CELL = 29;

var TableCell = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TableCell, _Component);

  function TableCell() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableCell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableCell.__proto__ || (0, _getPrototypeOf2.default)(TableCell)).call.apply(_ref, [this].concat(args))), _this), _this.setDom = function (dom) {
      _this.dom = dom;
    }, _this.getContentStyle = function (fnGetCellContentStyle, rowData, columnKey, rowIndex, column, columnIndex, cellData) {
      var props = _this.props;
      var customCellStyle = fnGetCellContentStyle && fnGetCellContentStyle(rowData, columnKey, rowIndex, column, columnIndex, cellData) || {};

      return (0, _fp.assign)({ textAlign: props.align }, customCellStyle);
    }, _this.getCellStyle = function (fnGetCellStyle, rowData, rowIndex, columnIndex, cellData) {
      var cellWidth = void 0;
      var props = _this.props;
      var style = fnGetCellStyle && fnGetCellStyle(rowData, rowIndex, columnIndex, cellData) || {};
      if (props.newWidth || props.width) {
        cellWidth = props.width + (props.widthUnit === _Izenda2.default.columnWidthSetting.characters ? 'ch' : 'px');

        style.width = props.newWidth ? props.newWidth + 'px' : cellWidth;
        style.maxWidth = props.newWidth ? props.newWidth + 'px' : cellWidth;
        style.minWidth = cellWidth;
        style.minHeight = MIN_HEIGHT_CELL;
      }

      return style;
    }, _this.getCellContent = function (cell, rowData, column, rowIndex, columnIndex, cellData) {
      if ((0, _fp.isFunction)(cell)) {
        return cell(rowData, (0, _fp.get)('key', column), rowIndex, column, columnIndex, _this.props.didUpdate, cellData);
      } else {
        return cell;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableCell, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var props = this.props;
      props.didUpdate && props.didUpdate();
      props.cellAfterRenderCallBack && props.cellAfterRenderCallBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      var columnIndex = props.columnIndex,
          deep = props.deep;


      props.didUpdate && props.didUpdate();
      props.cellAfterRenderCallBack && props.cellAfterRenderCallBack();
      props.registerCell && props.registerCell(this.dom, columnIndex, deep);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var props = this.props;
      var columnIndex = props.columnIndex,
          deep = props.deep;


      props.unregisterCell && props.unregisterCell(this.dom, columnIndex, deep);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props || {};
      var cellProps = props.fnGetCellProps && props.fnGetCellProps(props.rowData);

      var contentStyle = this.getContentStyle(props.fnGetCellContentStyle, props.rowData, props.columnKey, props.rowIndex, props.column, props.columnIndex, props.cellData);
      var cellStyle = this.getCellStyle(props.fnGetCellStyle, props.rowData, props.rowIndex, props.columnIndex, props.cellData);

      var cellClass = (0, _classnames2.default)('table-cell', props.className);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ ref: this.setDom }, cellProps, { className: cellClass, style: cellStyle }),
        _react2.default.createElement(
          'div',
          { className: 'table-cell-content', style: contentStyle },
          props.children || this.getCellContent(props.cell, props.rowData, props.column, props.rowIndex, props.columnIndex, props.cellData)
        )
      );
    }
  }]);
  return TableCell;
}(_react.Component), _class2.propTypes = {
  fnGetCellProps: _react.PropTypes.func,
  fnGetCellStyle: _react.PropTypes.func,
  fnGetCellContentStyle: _react.PropTypes.func,
  rowData: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.array]),
  rowIndex: _react.PropTypes.number,
  columnIndex: _react.PropTypes.number,
  column: _react.PropTypes.object,
  registerCell: _react.PropTypes.func,
  unregisterCell: _react.PropTypes.func
}, _temp2)) || _class;

exports.default = TableCell;
module.exports = exports['default'];

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseInfoStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * License Info Store
 */
!function () {
  var m = __webpack_require__(5);
  var licenseDataFetcher = __webpack_require__(1844);
  var exportFetcher = __webpack_require__(400);
  var licenseInfo = __webpack_require__(483);

  var MESSAGE_TYPE = __webpack_require__(37).MESSAGE_TYPE;
  var CONSTANT = __webpack_require__(295);
  var LICENSE_NOTIFICATION_MESSAGE_KEY = CONSTANT.LICENSE_NOTIFICATION_MESSAGE_KEY;
  var uiState = __webpack_require__(15);

  function LicenseInfoStore() {
    this.licenseInfo = licenseInfo;
  }

  /**
   * get license Status
   */
  LicenseInfoStore.prototype.getLicenseStatus = function () {
    var licenseInfo = this.licenseInfo;
    return licenseDataFetcher.getLicenseStatus().then(function (status) {
      licenseInfo.readLicenseStatus(status);
      this.checkOnlineLicenseValid();
      return status;
    }.bind(this));
  };

  /**
   * Handle for online license mode
   */
  LicenseInfoStore.prototype.checkOnlineLicenseValid = function () {
    var licenseInfo = this.licenseInfo;
    if (licenseInfo.isOnlineLicenseValidInLostConnectionAllowPeriod) {
      uiState.addNotification({
        key: LICENSE_NOTIFICATION_MESSAGE_KEY.VALID_IN_ALLOW_PERIOD,
        type: MESSAGE_TYPE.ERROR,
        message: CONSTANT.MESSAGE.CANNOT_REACH_LICENSE_SERVER
      });
    } else if (licenseInfo.exceedLostConnectionAllowPeriod) {
      uiState.removeNotification(LICENSE_NOTIFICATION_MESSAGE_KEY.VALID_IN_ALLOW_PERIOD);
      uiState.addNotification({
        key: LICENSE_NOTIFICATION_MESSAGE_KEY.NO_LONGER_VALID,
        type: MESSAGE_TYPE.ERROR,
        message: CONSTANT.MESSAGE.MG10
      });
    } else {
      uiState.removeNotification(LICENSE_NOTIFICATION_MESSAGE_KEY.VALID_IN_ALLOW_PERIOD);
      uiState.removeNotification(LICENSE_NOTIFICATION_MESSAGE_KEY.NO_LONGER_VALID);
    }
  };

  /**
   * Validate license
   * @param {string} licenseKey
   * @param {string} tokenKey
   * @returns {promise}
   */
  LicenseInfoStore.prototype.validateLicense = m.action(function () {
    var tokenKey = this.licenseInfo.licenseOnlineMode ? null : this.licenseInfo.tokenKey;
    return licenseDataFetcher.validateLicense(this.licenseInfo.licenseKey, tokenKey).then(m.action(function (response) {

      this.licenseInfo.readValidateLicense(response);
      uiState.updateLicenseStatus(!!response.expired);
      response.success && this.getLicenseStatus();

      return response.messages;
    }).bind(this));
  });

  /**
   * Get license information
   * @returns {promise}
   */
  LicenseInfoStore.prototype.getLicenseInformation = function () {
    var licenseInfo = this.licenseInfo;
    return this.getLicenseInfo().then(licenseInfo.readLicenseInforation.bind(licenseInfo));
  };

  /**
   * Get license information
   * @returns {promise}
   */
  LicenseInfoStore.prototype.getLicenseInfo = function () {
    return licenseDataFetcher.getLicenseInformation();
  };

  /**
   * export performanceStatisticsTrend
   */
  LicenseInfoStore.prototype.exportPerformanceStatisticsTrend = function () {
    return exportFetcher.exportPerformanceStatisticsTrend();
  };

  /**
   * construtor for create seperate object for test
   * @type {construtor}
   */
  LicenseInfoStore.prototype.LicenseInfoStore = LicenseInfoStore;

  module.exports = exports = new LicenseInfoStore();
}();

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ButtonHighlight.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module Button Highlight component
 * @example
 *  <ButtonHighlight value={false} states={[{value: val-state, icon: 'sate-icon'}]} description={''} onClick={} />
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_INDEX = 0;
var NEXT_INDEX = 1;

var ButtonHighlight = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ButtonHighlight, _Component);

  function ButtonHighlight() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ButtonHighlight);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonHighlight.__proto__ || (0, _getPrototypeOf2.default)(ButtonHighlight)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      var _this$props = _this.props,
          propertyKey = _this$props.propertyKey,
          value = _this$props.value,
          loadValue = _this$props.loadValue,
          states = _this$props.states,
          loadStates = _this$props.loadStates,
          onChange = _this$props.onChange,
          beforeOnChange = _this$props.beforeOnChange;

      var stateList = (0, _fp.isFunction)(loadStates) ? loadStates() : states;
      var val = (0, _fp.isFunction)(loadValue) ? (0, _fp.get)(propertyKey, loadValue()) : value;
      var currentState = (0, _fp.findIndex)(function (item) {
        return item.value === val;
      }, stateList);

      if (currentState < 0) {
        currentState = NEXT_INDEX;
      } else if (currentState >= stateList.length - 1) {
        currentState = DEFAULT_INDEX;
      } else {
        currentState++;
      }
      var newArgs = [{
        value: stateList[currentState].value
      }];
      var applyOnChange = function applyOnChange(updateParam) {
        newArgs = updateParam || newArgs;
        onChange && onChange.apply(null, newArgs);
      };

      if (beforeOnChange) {
        beforeOnChange.apply(_this, newArgs).then(applyOnChange);
      } else {
        applyOnChange();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ButtonHighlight, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          propertyKey = _props.propertyKey,
          value = _props.value,
          loadValue = _props.loadValue,
          className = _props.className,
          states = _props.states,
          loadStates = _props.loadStates,
          defaultIcon = _props.defaultIcon,
          description = _props.description;

      var val = (0, _fp.isFunction)(loadValue) ? (0, _fp.get)(propertyKey, loadValue()) : value;
      var classes = (0, _classnames2.default)(className, 'btn-highlight', {
        active: val
      });
      var stateList = (0, _fp.isFunction)(loadStates) ? loadStates() : states;
      var current = (0, _fp.find)(function (item) {
        return item.value === val;
      }, stateList) || (0, _fp.first)(stateList);
      var icon = (0, _fp.getOr)(defaultIcon, 'icon', current);
      var rest = (0, _fp.omit)(['states', 'description', 'onClick', 'keyPath', 'disabledIcon', 'beforeOnChange', 'hiddenByState', 'loadValue', 'propertyKey', 'defaultIcon', 'showInactiveState', 'loadStates'], this.props);
      return _react2.default.createElement(
        'button',
        (0, _extends3.default)({}, rest, { value: val, className: classes, title: description, onClick: this.onClick }),
        _react2.default.createElement('span', { className: icon, value: val })
      );
    }
  }]);
  return ButtonHighlight;
}(_react.Component), _class2.propTypes = {
  description: _react.PropTypes.string,
  states: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]),
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
  onChange: _react.PropTypes.func
}, _class2.defaultProps = {
  states: [],
  onClick: null,
  description: ''
}, _temp2)) || _class;

exports.default = ButtonHighlight;
module.exports = exports['default'];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.IconAfterCursor.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var getCaretCoordinates = __webpack_require__(1856);

  var _require = __webpack_require__(1),
      omit = _require.omit;

  var SPACE_ICON_BELOW_CURSOR = 15;
  var ICON_HEIGHT = 30;
  var TYPE = {
    TEXT_AREA: 'textarea',
    INPUT: 'input'
  };

  var IconAfterCursorInput = React.createClass({
    displayName: 'IconAfterCursorInput',

    getDefaultProps: function getDefaultProps() {
      return {
        iconClassName: 'icon-lightbulb',
        type: TYPE.TEXT_AREA
      };
    },

    getInitialState: function getInitialState() {
      return {
        isInitial: true,
        style: {
          top: 0,
          left: 0,
          height: ICON_HEIGHT
        }
      };
    },

    setMinMaxTop: function setMinMaxTop() {
      var input = this.refs.input;
      var coordinates = getCaretCoordinates(input, input.selectionEnd);
      var topPosition = coordinates.top + SPACE_ICON_BELOW_CURSOR;

      if (topPosition < input.clientLeft + SPACE_ICON_BELOW_CURSOR) {
        topPosition = coordinates.top;
      }

      if (topPosition > input.offsetHeight - ICON_HEIGHT) {
        topPosition = input.offsetHeight - ICON_HEIGHT;
      }

      return topPosition;
    },

    updatePosition: function updatePosition() {
      var input = this.refs.input;
      var coordinates = getCaretCoordinates(input, input.selectionEnd);
      this.setState({
        style: {
          top: this.setMinMaxTop(),
          left: input.offsetLeft - input.scrollLeft + coordinates.left
        }
      });
    },

    renderInput: function renderInput() {
      var props = this.props;
      var inputType = props.type;

      var onClick = props.onClick;
      var onKeyUp = props.onKeyUp;
      var onScroll = props.onScroll;
      props = omit(['iconClassName', 'componentType', 'onClickIcon', 'onClick', 'onKeyUp', 'onScroll'], props);

      function handleClick(e) {
        this.updatePosition();
        onClick && onClick(e);
      }

      function handelKeyUp(e) {
        this.updatePosition();
        onKeyUp && onKeyUp(e);
      }

      function handleScroll(e) {
        this.updatePosition();
        onScroll && onScroll(e);
      }

      var inputProps = {
        className: 'form-control',
        onClick: handleClick.bind(this),
        onKeyUp: handelKeyUp.bind(this),
        onScroll: handleScroll.bind(this),
        ref: 'input'
      };

      function createInput() {
        switch (inputType) {
          case TYPE.TEXT_AREA:
            return React.createElement('textarea', (0, _extends3.default)({}, inputProps, props));
          case TYPE.INPUT:
            return React.createElement('input', (0, _extends3.default)({}, inputProps, props));
          default:
            return React.createElement('textarea', (0, _extends3.default)({}, inputProps, props));
        }
      }

      return createInput();
    },

    render: function render() {
      var props = this.props;

      function handleIconClick(e) {
        e.preventDefault();
        e.stopPropagation();
        props.onClickIcon && props.onClickIcon(this.state.style);
      }

      function renderIcon() {
        if (!this.state.isInitial && !props.disabled) {
          return React.createElement(
            'a',
            { onMouseDown: handleIconClick.bind(this), style: this.state.style },
            React.createElement('span', { className: props.iconClassName })
          );
        }
        return null;
      }

      function handleClick(e) {
        this.setState({ isInitial: false });
      }

      return React.createElement(
        'div',
        { onClick: handleClick.bind(this), className: 'icon-after-cursor' },
        this.renderInput(),
        renderIcon.call(this)
      );
    }
  });

  module.exports = IconAfterCursorInput;
}();

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(157);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ToggleViewModePropertyEditor.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ToggleViewModePropertyEditor component
 */
var ToggleViewModePropertyEditor = function ToggleViewModePropertyEditor() {
  var propetyPanelStyle = _Izenda2.default.getViewStyle();
  var title = propetyPanelStyle.simpleState ? _Izenda4.default.getText('PROPERTIES_EDITOR_MORE_STATE') : _Izenda4.default.getText('PROPERTIES_EDITOR_LESS_STATE');

  return _react2.default.createElement(
    'a',
    { className: 'u_floatRight u_textUnderline', onClick: _Izenda2.default.switchViewMode },
    title
  );
};

exports.default = (0, _mobxReact.observer)(ToggleViewModePropertyEditor);
module.exports = exports['default'];

/***/ }),
/* 569 */,
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(214);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartOptionsBuilder = (_dec = (0, _Izenda.exportClass)('ChartOptionsBuilder'), _dec(_class = function () {
  function ChartOptionsBuilder(visualType, chartContainer, chartData, chartOptions, fieldOptions) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ChartOptionsBuilder);

    this.visualType = visualType;
    this.chartOptions = chartOptions || {};
    this.chartData = chartData || [];
    this.fieldOptions = fieldOptions;
    this.chartContainer = chartContainer;

    // Set axis name base on chart data
    this.chartOptions.xAxis && this.chartOptions.xAxis.forEach(function (axis) {
      axis && (axis.axisName = _this.chartData[0] && _this.chartData[0][0]);
    });
  }

  (0, _createClass3.default)(ChartOptionsBuilder, [{
    key: 'setOnClickXLabel',
    value: function setOnClickXLabel(xLabelClickHandler) {
      this.chartOptions.onClickXLabel = xLabelClickHandler;
    }
  }, {
    key: 'setOnClickYLabel',
    value: function setOnClickYLabel(yLabelClickHandler) {
      this.chartOptions.onClickYLabel = yLabelClickHandler;
    }
  }, {
    key: 'mapOptionValues',
    value: function mapOptionValues(optionsMapping) {
      var _mapOptionValues2 = _mapOptionValues(this.chartOptions, this.fieldOptions, optionsMapping),
          chartOptions = _mapOptionValues2.chartOptions,
          fieldOptions = _mapOptionValues2.fieldOptions;

      this.chartOptions = chartOptions;
      this.fieldOptions = fieldOptions;
    }
  }, {
    key: 'build',
    value: function build() {
      throw new Error('The build() method of ChartOptionsBuilder must be implementated appropriately.');
    }
  }]);
  return ChartOptionsBuilder;
}()) || _class);

/**
 * Map Izenda option values into Highchart option values
 * @param {Object} chartOptions Izenda chart options
 * @param {Object} fieldOptions Izenda field options
 */

exports.default = ChartOptionsBuilder;
function _mapOptionValues(chartOptions, fieldOptions, optionsMapping) {
  var _ref = optionsMapping || {},
      commonOptionsMapping = _ref.commonOptions,
      optionByTypeMapping = _ref.optionsByType,
      axisOptionsMapping = _ref.axisOptions,
      thresholdOptionsMapping = _ref.thresholdOptions;

  var _ref2 = chartOptions || {},
      commonOptions = _ref2.commonOptions,
      optionByType = _ref2.optionByType,
      commonXYAxis = _ref2.commonXYAxis,
      restChartOpts = (0, _objectWithoutProperties3.default)(_ref2, ['commonOptions', 'optionByType', 'commonXYAxis']);

  // firstly, Restructure axis option from commonXYAxis(izGridline, izLabelOrientation), then parse it to highchart option


  var xAxis = (0, _extends3.default)({
    izLabelOrientation: (0, _fp.get)('izLabelOrientationX', commonXYAxis)
  }, (0, _fp.get)('izGridLine.xAxis', commonXYAxis), (0, _fp.getOr)({}, 'xAxis', commonXYAxis));
  var yAxis = (0, _extends3.default)({
    izLabelOrientation: (0, _fp.get)('izLabelOrientationY', commonXYAxis)
  }, (0, _fp.get)('izGridLine.yAxis', commonXYAxis), (0, _fp.getOr)({}, 'yAxis', commonXYAxis));

  return {
    chartOptions: (0, _extends3.default)({
      commonOptions: parseOptions(commonOptions, commonOptionsMapping),
      optionByType: parseOptions(optionByType, optionByTypeMapping),
      commonXYAxis: {
        xAxis: parseOptions(xAxis, axisOptionsMapping),
        yAxis: parseOptions(yAxis, axisOptionsMapping),
        metricAllOption: parseOptions((0, _fp.get)('metricAllOption', commonXYAxis), axisOptionsMapping),
        metricAllPlotLinesOption: parseOptions(getVisibleThresholdSetting((0, _fp.get)('metricAllPlotLinesOption', commonXYAxis)), thresholdOptionsMapping),
        metricAllDynamicThresholdOption: parseOptions(getVisibleThresholdSetting((0, _fp.get)('allDynamicThresholdLine', commonXYAxis)), thresholdOptionsMapping)
      }
    }, restChartOpts),
    fieldOptions: (0, _fp.mapValues)(function (_ref3) {
      var chartOptions = _ref3.chartOptions,
          axisOption = _ref3.axisOption,
          threshold = _ref3.threshold,
          dynamicThresholds = _ref3.dynamicThresholds,
          restSerieOpts = (0, _objectWithoutProperties3.default)(_ref3, ['chartOptions', 'axisOption', 'threshold', 'dynamicThresholds']);
      return (0, _extends3.default)({
        chartOptions: parseOptions(chartOptions, optionByTypeMapping),
        axisOption: parseOptions(axisOption, axisOptionsMapping),
        threshold: parseOptions(getVisibleThresholdSetting(threshold), thresholdOptionsMapping),
        dynamicThresholds: parseOptions(getVisibleThresholdSetting(dynamicThresholds), thresholdOptionsMapping)
      }, restSerieOpts);
    }, fieldOptions)
  };
}

/**
 * Get visible threshold setting
 * @param {Object} thresholdSettings
 */
function getVisibleThresholdSetting(thresholdSettings) {
  return (0, _fp.filter)(function (item) {
    return item.izVisibleThresholdsSetting && !!item.izValue;
  }, thresholdSettings);
}

/**
 * Parse options
 * @param {Object} objValue
 * @param {Object} objMapping
 */
function parseOptions(objValue, objMapping) {
  switch (true) {
    case !objValue || !objMapping:
      return objValue;
    case (0, _fp.isString)(objValue):
      return objMapping[objValue];
    case (0, _fp.isArray)(objValue) || (0, _mobx.isObservableArray)(objValue):
      return (0, _fp.map)(function (item) {
        return parseOptions(item, objMapping);
      }, objValue);
    case (0, _fp.isObject)(objValue):
      {
        var libOptions = (0, _keys2.default)(objValue).reduce(function (acc, prop) {
          var mapping = objMapping[prop];
          return mapping && objValue[prop] != null ? (0, _fp.merge)((0, _defineProperty3.default)({}, mapping.key, mapping.source ? parseOptions(objValue[prop], mapping.source) : objValue[prop]), acc) : objValue[prop] != null ? (0, _fp.merge)((0, _defineProperty3.default)({}, prop, objValue[prop]), acc) : acc;
        }, {});

        // Run thru the properties then break into hierarchical object.
        // For example "izBorder.style.font = value" to be { izBorder : { style : { font: value }}}
        return (0, _keys2.default)(libOptions).reduce(function (acc, prop) {
          return (0, _fp.set)(prop, libOptions[prop], acc);
        }, {});
      }
    default:
      throw new Error('Cannot recognize objValue type to parse');
  }
}
module.exports = exports['default'];

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.NoData.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 *  NoData component
 */

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoData = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NoData, _Component);

  function NoData() {
    (0, _classCallCheck3.default)(this, NoData);
    return (0, _possibleConstructorReturn3.default)(this, (NoData.__proto__ || (0, _getPrototypeOf2.default)(NoData)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoData, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var finishedRender = this.props.finishedRender;

      if (typeof finishedRender === 'function') {
        finishedRender();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _Izenda2.default.getText('NO_RECORD_FOUND')
      );
    }
  }]);
  return NoData;
}(_react.Component), _class.propTypes = {
  finishedRender: _propTypes2.default.func
}, _temp);
exports.default = NoData;
module.exports = exports['default'];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartToolbar = function ReportPartToolbar(_ref) {
  var className = _ref.className,
      children = _ref.children;

  var classes = (0, _classnames2.default)('izenda-ReportPartToolbar form-inline izenda-Wrapper-header', className);
  return _react2.default.createElement(
    'section',
    { className: classes },
    children
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReporPartToolbar.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * MapToolbar component
 */

exports.default = (0, _mobxReact.observer)(ReportPartToolbar);
module.exports = exports['default'];

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(83);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(407);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(35);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(246);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(318);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(539);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda17 = __webpack_require__(76);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReportLink.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var EmbededReport = (0, _Izenda4.default)(function (_Component) {
  (0, _inherits3.default)(EmbeddedSubReport, _Component);

  function EmbeddedSubReport() {
    (0, _classCallCheck3.default)(this, EmbeddedSubReport);
    return (0, _possibleConstructorReturn3.default)(this, (EmbeddedSubReport.__proto__ || (0, _getPrototypeOf2.default)(EmbeddedSubReport)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmbeddedSubReport, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          width = _props.width,
          height = _props.height;

      if (width !== prevProps.width || height !== prevProps.height) {
        (0, _fp.invoke)('afterRenderCallBack', this.props);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props,
          width = this.props.width;

      var containerWidth = (0, _fp.isUndefined)(props.containerWidth) ? width : props.containerWidth || 0;
      var omitProps = ['width', 'height', 'containerWidth'];

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Izenda6.default, (0, _extends3.default)({ containerWidth: containerWidth }, (0, _fp.omit)(omitProps, props), { embededReportPart: true }))
      );
    }
  }]);
  return EmbeddedSubReport;
}(_react.Component));
// $FlowFixMe


var SupReportLink = function SupReportLink(props) {
  var reportPart = props.reportPart,
      rawRecord = props.rawRecord,
      fieldElement = props.fieldElement;


  var elementProperties = (0, _fp.get)('properties', fieldElement);

  var subReport = (0, _fp.get)('subReport', elementProperties);
  var customURL = (0, _fp.get)('customURL', elementProperties);
  var embeddedJavascript = (0, _fp.get)('embeddedJavascript', elementProperties);
  var numberOfPointActions = (0, _fp.get)('numberOfPointActions', fieldElement);

  var fieldConfig = {
    subReport: subReport,
    customURL: customURL,
    embeddedJavascript: embeddedJavascript,
    numberOfPointActions: numberOfPointActions,
    fieldElement: fieldElement
  };

  if (subReport && subReport.style === _Izenda8.default.DRILL_DOWN_STYLE_OPTION_VALUES.embedded) {
    return applySubReportEmbedded();
  } else {
    var icon = void 0;
    var isLink = false;

    if (numberOfPointActions === 1) {
      subReport && subReport.selectedReport && (subReport.viewSettingByLink ? isLink = true : icon = subReport.selectedIconValue.icon);
      customURL && customURL.url && (customURL.viewSettingByLink ? isLink = true : icon = customURL.selectedIconValue.icon);
      embeddedJavascript && embeddedJavascript.script && (embeddedJavascript.viewSettingByLink ? isLink = true : icon = embeddedJavascript.selectedIconValue.icon);
    } else if (numberOfPointActions > 1) {
      isLink = true;
    }

    if (isLink) {
      return _react2.default.createElement(
        'a',
        null,
        _react2.default.createElement(
          'span',
          { className: 'u_textLink', onClick: hyperlinkAction },
          props.children
        )
      );
    }
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'a',
        null,
        _react2.default.createElement('span', { className: (0, _classnames2.default)('u_textLink', icon), onClick: hyperlinkAction })
      ),
      props.children
    );
  }

  function applySubReportEmbedded() {
    var filters = _Izenda12.default.buildFilterDataCommon(rawRecord, subReport.mappingFields, reportPart);

    if (!filters.success) {
      return _react2.default.createElement(
        'section',
        null,
        filters.errors
      );
    }
    var overideFilterValue = props.getFilterInfoForSubReport();
    var subReportFilter = _Izenda12.default.buildFilterDataForEmbededReportPart(filters.fieldMapping, reportPart, subReport, overideFilterValue);

    // Insert CustomURLLink/embeddedJavascriptLink beside subReport embedded
    var customUrlIcon = (0, _fp.get)('url', customURL) && (0, _fp.get)('selectedIconValue.icon', customURL);
    var embeddedJavascriptIcon = (0, _fp.get)('script', embeddedJavascript) && (0, _fp.get)('selectedIconValue.icon', embeddedJavascript);

    var listEmbededReportPart = _Izenda14.default.readEmbededReportDef(reportPart, fieldElement);

    var renderListeners = [];

    /**
     * Build child render promises
     */
    function buildChildPromises() {
      (0, _fp.forEach)(function (part) {
        _Izenda18.default.pushRenderListener(renderListeners, part.id);
      }, listEmbededReportPart);
    }

    /**
     * Publish finished render event.
     */
    function publishFinishedRender() {
      props.printingMode && _Izenda18.default.publishFinishedRender(renderListeners, function () {
        props.finishedRender && props.finishedRender();
      });
    }

    buildChildPromises();
    publishFinishedRender();

    return _react2.default.createElement(
      'section',
      null,
      customUrlIcon && _react2.default.createElement('span', { className: customUrlIcon, onClick: openCustomURL }),
      embeddedJavascriptIcon && _react2.default.createElement('span', { className: embeddedJavascriptIcon, onClick: performEmbeddedJavascript }),
      (0, _fp.isEmpty)(listEmbededReportPart) ? props.children : listEmbededReportPart.map(function (reportPartDef) {
        return _react2.default.createElement(EmbededReport, {
          key: reportPartDef.id,
          reportPartDef: reportPartDef,
          subReportFilter: subReportFilter,
          printingMode: props.printingMode,
          containerWidth: props.containerWidth,
          finishedRender: _Izenda18.default.getFinishedRenderPromiseById(renderListeners, reportPartDef.id),
          afterRenderCallBack: props.afterRenderCallBack
        });
      })
    );
  }

  function hyperlinkAction() {
    _Izenda10.default.openHyperlinkAction(props, fieldConfig, rawRecord, _Izenda16.default);
  }

  function openCustomURL() {
    _Izenda10.default.openCustomURL(props, customURL, rawRecord);
  }

  function performEmbeddedJavascript() {
    _Izenda10.default.performEmbeddedJavascript(props, embeddedJavascript, rawRecord);
  }
};

exports.default = (0, _Izenda2.default)()(SupReportLink);
module.exports = exports['default'];

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create the Property editor configuration of the report part. This configuration defines
 * how Property editor components shoulw be arranged, rendered and reacted to user change.
 * @param {Object} reportDesignerModel Report designer model
 * @param {Object} reportPartDetails Report part detail
 * @param {Object} fieldStore Field store
 */
exports.default = function (reportDesignerModel, reportPartDetails, fieldStore) {
  ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

  // Pick the report part type and report part style
  var reportPartStyle = (0, _fp.get)('reportPartContent.reportPartStyle', reportPartDetails);
  var reportPartType = reportPartDetails.type;

  var _cfgFactories$getConf = _Izenda2.default.getConfiguration(reportPartType, reportPartStyle),
      propertyWidgets = _cfgFactories$getConf.propertyWidgets,
      propertySchema = _cfgFactories$getConf.propertySchema,
      propertyMappingProps = _cfgFactories$getConf.propertyMappingProps,
      propertyMappingSource = _cfgFactories$getConf.propertyMappingSource,
      propertyValueChange = _cfgFactories$getConf.propertyValueChange;

  return {
    definedSchema: propertySchema,
    widgets: propertyWidgets,
    mappingProps: propertyMappingProps(reportPartDetails, fieldStore),
    source: {},
    mappingSource: propertyMappingSource(reportPartDetails, fieldStore),
    onChangeValue: function onChangeValue(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
      return propertyValueChange(reportPartDetails, fieldStore)(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo).then(function (_ref) {
        var needToUpdate = _ref.needToUpdate,
            chartProperties = _ref.chartProperties;

        ensure(!(0, _fp.isUndefined)(needToUpdate), 'onChangeValue handler must return object containing a boolean needToUpdate property');

        return needToUpdate ? fieldStore.needUpdatePreview(reportPartDetails) : (0, _bluebird.resolve)(true);
      });
    }
  };
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPropsSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.TinyMCE.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

var _tinymce = __webpack_require__(576);

var _tinymce2 = _interopRequireDefault(_tinymce);

__webpack_require__(1912);

var _Izenda = __webpack_require__(1913);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(34);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(132);

var _Izenda6 = __webpack_require__(271);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(12);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var existingIndex = 0;
var secondIndex = 1;
var HANDLER_NAMES = _Izenda2.default.EVENTS.map(function (event) {
  return 'on' + (0, _fp.head)(event).toUpperCase() + event.substring(secondIndex);
});

var TinyMCE = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TinyMCE, _Component);

  function TinyMCE(props) {
    (0, _classCallCheck3.default)(this, TinyMCE);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TinyMCE.__proto__ || (0, _getPrototypeOf2.default)(TinyMCE)).call(this, props));

    _initialiseProps.call(_this);

    var id = props.id,
        value = props.value;


    _this.state = {
      id: id,
      value: value
    };

    _this.tinymce = _tinymce2.default;
    _this.id = _this.id || id;
    return _this;
  }

  (0, _createClass3.default)(TinyMCE, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var config = (0, _fp.clone)(this.props.config);
      this.initTinyMCE(config);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _fp.isEqual)(this.props.config, nextProps.config)) {
        this.initTinyMCE((0, _fp.clone)(nextProps.config), nextProps.content);
      }
      if (!(0, _fp.isEqual)(this.props.id, nextProps.id)) {
        this.id = nextProps.id;
      }
      if (!(0, _fp.isEqual)(this.props.content, nextProps.content)) {
        this.tinymce.get(this.id).setContent(nextProps.content);
      }

      this.toggleShowInvisibleChars(nextProps);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _fp.isEqual)(this.props.content, nextProps.content) || !(0, _fp.isEqual)(this.props.config, nextProps.config);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTinyMCE();
    }
  }, {
    key: 'replaceContent',
    value: function replaceContent(node, content) {
      node.execCommand('mceReplaceContent', false, content);
    }

    /**
     * Update repeater.
     * @param {string} repeater type
     */


    /**
     * Remove repeater.
     */


    /**
     * Insert smart tag.
     * @param {string} smart tag type
     * @param {string} value
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          content = _props.content;

      return _react2.default.createElement('textarea', { id: this.id, className: className, defaultValue: content, ref: this.updateNodeRef });
    }
  }]);
  return TinyMCE;
}(_react.Component), _class.propTypes = {
  config: _propTypes2.default.object,
  content: _propTypes2.default.string,
  id: _propTypes2.default.string
}, _class.defaultProps = {
  config: {},
  content: ''
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.toggleShowInvisibleChars = function (props) {
    // Toggle support show invisible character
    if (props.visualChars !== _this2.props.visualChars) {
      _this2.tinymce.activeEditor.execCommand('mceVisualChars', true, null, { skip_focus: true });
    }
  };

  this.initTinyMCE = function (config, content) {
    if (_this2.isInit) {
      _this2.removeTinyMCE();
    }

    var context = _this2;

    _this2.node.style.hidden = 'hidden';
    var setupCallback = config.setup;
    var hasSetupCallback = typeof setupCallback === 'function';

    config.pagebreak_separator = _Izenda7.default.PAGE_BREAK_HTML;
    config.selector = '#' + _this2.id;
    config = (0, _fp.assignIn)(_Izenda2.default.DEFAULT_CONFIG, config);

    if (!(0, _fp.isEmpty)(_config2.default.RootPath)) {
      _this2.tinymce.baseURL = _config2.default.RootPath;
    }

    if (!(0, _fp.isEmpty)(_config2.default.CssFile)) {
      config.content_css = _config2.default.RootPath + '/' + _config2.default.CssFile;
    }

    config.setup = function (editor) {
      _Izenda2.default.EVENTS.forEach(function (event, index) {
        var handler = context.props[HANDLER_NAMES[index]];
        if (typeof handler !== 'function') return;

        editor.on(event, function (e) {
          handler(e, editor);
        });
      });

      editor.on('NodeChange', function (e) {
        context.handleNodeChange(e, editor);
      });

      editor.on('init', function () {
        _Izenda2.default.FORMAT_CHANGES.forEach(function (name) {
          editor.formatter.formatChanged(name, function (state, data) {
            context.props.onFormatChange && context.props.onFormatChange(data.format, state);
          });
        });

        if (!(0, _fp.isNil)(content)) {
          editor.setContent(content);
        }

        if (context.props.visualChars) {
          context.tinymce.activeEditor.execCommand('mceVisualChars', true, null, { skip_focus: true });
        }
      });

      editor.addMenuItem('spell_checker', {
        text: _Izenda9.default.getText('TINY_MCE_SPELL_CHECKER'),
        onclick: context.handleSpellCheck,
        onPostRender: context.handleDisabledState
      });

      editor.on('contextmenu', function () {
        context.handleContextMenu();
      });

      // Fix issues on Firefox
      editor.on('BeforeSetContent', function (e) {
        e.content = e.content.replace('<br _moz_editor_bogus_node="TRUE" />', '');
      });

      if (hasSetupCallback) {
        setupCallback(editor);
      }
    };

    _this2.tinymce.init(config);
    _this2.node.style.hidden = '';
    _this2.isInit = true;
  };

  this.handleContextMenu = function () {
    if ((0, _fp.isNil)(_this2.spellCheckItem)) {
      return;
    }
    _this2.checkContentSelected();
  };

  this.handleDisabledState = function (item) {
    _this2.spellCheckItem = item.control;
    _this2.checkContentSelected();
  };

  this.checkContentSelected = function () {
    var selectedContent = _this2.tinymce.get(_this2.id).selection.getContent();
    if (!selectedContent || $izenda('<div>' + selectedContent + '</div>').find('field').length) {
      _this2.spellCheckItem.disabled(true);
    } else {
      _this2.spellCheckItem.disabled(false);
    }
  };

  this.handleSpellCheck = function () {
    if (_this2.props.onSpellCheck) {
      var selection = _this2.tinymce.get(_this2.id).selection;
      var selectionContent = selection.getContent();
      var selectedRange = selection.getRng();

      _this2.props.onSpellCheck(selectionContent, selectedRange.startOffset, selectedRange.endOffset);
    }
  };

  this.removeElement = function (element) {
    _this2.tinymce.get(_this2.id).dom.remove(element);
  };

  this.handleNodeChange = function (e) {
    var props = _this2.props;
    var fontSettings = {};

    var size = _this2.getFormatValue(e, _Izenda5.FORMAT_CONFIG.FONT_SIZE, 'fontsize');
    var fontname = _this2.getFormatValue(e, _Izenda5.FORMAT_CONFIG.FONT_NAME, 'fontname');

    fontSettings.fontSize = size ? size.replace(_Izenda4.default.defaultUnitType, '') : _Izenda4.default.defaultFontSize;
    fontSettings.fontFamily = fontname ? (0, _fp.findKey)(function (val) {
      return val === fontname;
    }, _Izenda5.FORMAT_CONFIG.FONT_NAME) : _Izenda4.default.defaultFontFamily;

    fontSettings.textColor = _this2.getCurrentColor('forecolor') || _Izenda4.default.textColor;
    fontSettings.backgroundColor = _this2.getCurrentColor('hilitecolor') || _Izenda4.default.backgroundColor;
    fontSettings.bullet = _this2.getSelectionList(e, 'ul');
    fontSettings.numbered = _this2.getSelectionList(e, 'ol');

    if (props.onFormatChange) {
      for (var key in fontSettings) {
        if (fontSettings.hasOwnProperty(key)) {
          props.onFormatChange(key, fontSettings[key]);
        }
      }
    }
  };

  this.getSelectionList = function (e, type) {
    var editor = _this2.tinymce.get(_this2.id);
    var parents = editor.dom.getParent(editor.selection.getNode(), type);
    return editor.dom.getStyle(parents, 'listStyleType') || '';
  };

  this.getCurrentColor = function (format) {
    var color = '';
    var editor = _tinymce2.default.get(_this2.id);

    editor.dom.getParents(editor.selection.getStart(), function (elm) {
      var value = elm.style && elm.style[format == 'forecolor' ? 'color' : 'background-color'];
      if (value) {
        color = String.rgbToHex(value);
      }
    });

    return color;
  };

  this.getFormatValue = function (e, items, formatName) {
    var formatter = _this2.tinymce.get(_this2.id).formatter;
    var value = null;

    (0, _fp.forEach)(function (node) {
      (0, _fp.forEach)(function (item) {
        if (formatter.matchNode(node, formatName, { value: item })) {
          value = item;
        }
      }, items);
    }, e.parents);

    return value;
  };

  this.removeTinyMCE = function () {
    if (_this2.tinymce.get(_this2.id).getBody()) {
      _this2.tinymce.EditorManager.execCommand('mceRemoveEditor', true, _this2.id);
    }
    _this2.isInit = false;
  };

  this.insertContent = function (content) {
    _this2.tinymce.get(_this2.id).execCommand('mceInsertContent', false, content);
  };

  this.toggleFormat = function (fmt) {
    _this2.tinymce.get(_this2.id).execCommand('mceToggleFormat', false, fmt);
  };

  this.applyFormat = function (format, value) {
    var editor = _this2.tinymce.get(_this2.id);
    editor.undoManager.transact(function () {
      editor.focus();
      editor.formatter.apply(format, { value: value });
      editor.nodeChanged();
    });
  };

  this.applyListFormat = function (listName, styleValue) {
    var editor = _this2.tinymce.get(_this2.id);

    editor.undoManager.transact(function () {
      var list = void 0,
          dom = editor.dom,
          sel = editor.selection;
      list = dom.getParent(sel.getNode(), 'ol,ul');

      if (!list || list.nodeName !== listName || styleValue === '') {
        var detail = { 'list-style-type': styleValue };
        editor.execCommand(listName === 'UL' ? 'InsertUnorderedList' : 'InsertOrderedList', false, detail);
      }

      list = dom.getParent(sel.getNode(), 'ol,ul');
      if (list) {
        dom.setStyle(list, 'listStyleType', styleValue ? styleValue : null);
        list.removeAttribute('data-mce-style');
      }

      editor.focus();
    });
  };

  this.insertContentDnD = function (content) {
    var editor = _this2.tinymce.get(_this2.id);
    var body = editor.getBody();
    var dom = editor.dom,
        selection = editor.selection;

    var range = selection.getRng();

    // user don't set selection, move selection to inside body lastChild
    if (range.startContainer.nodeName === 'BODY' && body.firstChild.firstChild.nodeName === 'STYLE' || range.startContainer.nodeName === 'STYLE') {
      range = dom.createRng();
      range.setStartAfter(body.lastChild);
      range.setEndAfter(body.lastChild);
      selection.setRng(range);
    }

    editor.execCommand('mceInsertContent', false, content);
  };

  this.updateRepeater = function (repeaterType) {
    var editor = _this2.tinymce.get(_this2.id);
    switch (repeaterType) {
      case 'Add':
        {
          var selectionContent = editor.selection.getContent();
          if (selectionContent.indexOf('<field') >= existingIndex) {
            var repeaterContent = _Izenda7.default.REPEATER_START + selectionContent + _Izenda7.default.REPEATER_END;
            var content = _this2.getContent();
            if (content.indexOf(selectionContent) < existingIndex) {
              editor.insertContent(repeaterContent);
            } else {
              content = content.replace(selectionContent, repeaterContent);
              editor.setContent(content);
            }
          }
          break;
        }
      case 'Remove':
        _this2.removeRepeater(editor);
        break;
    }
  };

  this.getContent = function () {
    return _this2.tinymce.get(_this2.id).getContent();
  };

  this.removeRepeater = function (editor) {
    var selectionContent = editor.selection.getContent();

    if (selectionContent.indexOf(_Izenda7.default.REPEATER_START) >= existingIndex) {
      editor.focus();
      $izenda('repeater', editor.selection.getNode()).unwrap();
    } else {
      var node = _this2.tinymce.get(_this2.id).selection.getNode();
      if (node.nodeName === 'REPEATER') {
        selectionContent = $izenda(_this2.tinymce.get(_this2.id).selection.getNode().parentNode).html();
        selectionContent = (0, _fp.chain)(selectionContent).split(_Izenda7.default.REPEATER_START).join('').split(_Izenda7.default.REPEATER_END).join('').value();

        editor.focus();
        _this2.tinymce.get(_this2.id).selection.getNode().parentNode.innerHTML = selectionContent;
      }
    }
  };

  this.insertSmartTag = function (smartTagType, value) {
    var editor = _this2.tinymce.get(_this2.id);
    editor.focus();

    switch (smartTagType) {
      case 'DateTime':
        _this2.insertContent('<datetime class="field-wrapper"><span class="icon-attached"></span>' + value + '</datetime>');
        break;
      case 'Subtotal':
        _this2.insertContent('<subtotal class="field-wrapper"><span class="icon-subtotal"></span>Click here to select field</subtotal>');
        break;
      case 'GrandTotal':
        _this2.insertContent('<grandtotal class="field-wrapper">' + '<span class="icon-grandtotal"></span>Click here to select field</grandtotal>');
        break;
    }
  };

  this.execCommand = function (cmd, value) {
    _this2.tinymce.get(_this2.id).execCommand(cmd, false, value);
    var isNeedUpdateContent = (0, _fp.includes)(cmd, ['Undo', 'Redo']);
    if (isNeedUpdateContent) {
      _this2.props.onChange && _this2.props.onChange({ target: _this2.tinymce.get(_this2.id) });
    }
  };

  this.isSelectedCell = function () {
    var editor = _this2.tinymce.get(_this2.id);
    if (!editor.dom) {
      return false;
    }
    var selectedCells = editor.dom.select('td[data-mce-selected],th[data-mce-selected]');
    var selectedElm = (0, _fp.head)(selectedCells);
    if (!selectedElm) {
      selectedElm = editor.selection.getStart();
    }

    return !!editor.dom.getParent(selectedElm, 'td,th');
  };

  this.insertTable = function (cols, rows) {
    var editor = _this2.tinymce.get(_this2.id);
    var baseY = 0;
    var baseX = 0;
    var y = void 0,
        x = void 0,
        html = void 0,
        tableElm = void 0;
    html = '<table id="__mce"><tbody>';
    for (y = baseY; y < rows; y++) {
      html += '<tr>';
      for (x = baseX; x < cols; x++) {
        html += '<td><br></td>';
      }
      html += '</tr>';
    }
    html += '</tbody></table>';

    editor.undoManager.transact(function () {
      editor.insertContent(html);
      tableElm = editor.dom.get('__mce');
      editor.dom.setAttrib(tableElm, 'id', null);
      editor.dom.setAttribs(tableElm, editor.settings.table_default_attributes || {});
      editor.dom.setStyles(tableElm, editor.settings.table_default_styles || {});
    });

    return tableElm;
  };

  this.updateNodeRef = function (node) {
    _this2.node = node;
  };
}, _temp);
exports.default = TinyMCE;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 576 */,
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReportStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var EmbedReport = __webpack_require__(1915);

  function EmbedReportStore() {
    var props = {
      model: new EmbedReport()
    };

    m.extendObservable(this, props);
  }

  module.exports = EmbedReportStore;
}();

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerDataTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1934);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(54);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * DataSource Tree Model
 */
var ReportDesignerDataTree = (0, _Izenda6.default)(_class = (_class2 = function () {
  function ReportDesignerDataTree() {
    (0, _classCallCheck3.default)(this, ReportDesignerDataTree);

    _initDefineProp(this, 'details', _descriptor, this);

    _initDefineProp(this, 'filterText', _descriptor2, this);

    _initDefineProp(this, 'loadedDataSource', _descriptor3, this);

    _initDefineProp(this, 'relationItemIds', _descriptor4, this);

    _initDefineProp(this, 'isLastPage', _descriptor5, this);

    _initDefineProp(this, 'displayData', _descriptor6, this);

    _initDefineProp(this, 'selectedTree', _descriptor7, this);

    this.selectedCategories = [];
  }

  // TODO: BE will check valid field in the future, then remove this variable
  // using for checking data source before render in form


  // TODO: Remove when BE validate valid field


  // This property will be observe because left menu need to know user has select any fields or not
  // to disable others tabs


  // used for advanced mode grid


  (0, _createClass3.default)(ReportDesignerDataTree, [{
    key: 'checkDirty',


    /**
     * Check Dirty
     */
    value: function checkDirty() {
      return this.isDirty || (0, _fp.flow)((0, _fp.flatMap)(function (x) {
        return x.querySource ? x.querySource.slice() : [];
      }), (0, _fp.some)(['isDirty', true]))(this.details);
    }

    /**
     * Clean Dirty
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();

      (0, _fp.forEach)(function (item) {
        item.resetDirty && item.resetDirty();
      }, this.details);
    }
  }, {
    key: 'cleanCalculatedFieldDirty',
    value: function cleanCalculatedFieldDirty() {
      var calculatedFieldQuerySource = (0, _fp.find)({ name: _Izenda2.default.CALCULATED_FIELD_NAME }, this.details);

      if (!(0, _fp.isNil)(calculatedFieldQuerySource)) {
        var querySouces = (0, _fp.getOr)([], 'querySource', calculatedFieldQuerySource);
        (0, _fp.forEach)(function (querySouce) {
          querySouce.resetDirty && querySouce.resetDirty();
        }, querySouces);
      }
    }

    /**
     * Get list of data tree item
     * @param {Object} dataObject
     * @returns {type}
     */

  }, {
    key: 'getDataTreeItems',
    value: function getDataTreeItems(dataObject) {
      var _this = this;

      var result = [];
      var uncategorizedText = _Izenda2.default.UNCATEGORIZED;

      this.selectedCategories = [];
      (0, _fp.forEach)(function (item) {
        (0, _fp.forEach)(function (querySource) {
          if (querySource.isVirtualNode) {
            return;
          }

          result.push({
            querySourceId: querySource.id,
            selected: querySource.selected,
            physicalChange: dataObject && querySource.id === dataObject.id ? 2 : 0,
            state: dataObject && dataObject.selected ? _Izenda2.default.OBJECT_STATE.INSERT : _Izenda2.default.OBJECT_STATE.DELETE
          });

          // just add selected querySource or categorized category to selectedCategories
          if (!querySource.selected) {
            return;
          }

          var key = item.id || _Izenda2.default.EMPTY_GUID;
          if ((0, _fp.isNil)(_this.selectedCategories[key])) {
            _this.selectedCategories[key] = {
              name: (0, _fp.isNil)(item.name) ? uncategorizedText : item.name,
              dataObjects: [querySource]
            };
          } else {
            _this.selectedCategories[key].dataObjects.push(querySource);
          }
        }, item.querySource);
      }, this.selectedTree);

      return result;
    }

    /**
     * Show data objects which have relationship with selected objects
     * @param {any} relationItems
     */

  }, {
    key: 'showRelationship',
    value: function showRelationship(relationItems) {
      if (!(0, _fp.isEmpty)(relationItems)) {
        this.relationItemIds = (0, _fp.map)((0, _fp.get)('querySourceId'), relationItems);
      }
    }

    /**
     * Get Icon
     * @param {any} objectName
     * @returns {string}
     */

  }, {
    key: 'getIcon',
    value: function getIcon(objectName) {
      return (0, _fp.getOr)('', objectName, _Izenda2.default.ICON);
    }

    /**
     * Read data source
     */

  }, {
    key: 'readDataSource',
    value: function readDataSource(result) {
      var details = this.details;
      (0, _fp.forEach)(function (category) {
        if (category.isVirtualNode) {
          return;
        }
        category.querySource = (0, _fp.map)(function (detail) {
          detail.fields = (0, _fp.filter)({ inaccessible: false }, detail.fields);
          if (detail.isVirtualNode) {
            return detail;
          }
          return new _Izenda4.default(detail);
        }, category.querySource);
      }, result);

      if (result && !result.isFromDataSource) {
        details.replace(result);
      }

      // TODO: Remove when BE validate valid field
      this.loadedDataSource = true;
    }

    /**
     * Convert raw data to ReportDesignerQuerySourceDetail
     * @param  {Array} result
     * @return {Array}
     */

  }, {
    key: 'convertDataSource',
    value: function convertDataSource(result) {
      var _this2 = this;

      (0, _fp.forEach)(function (category) {
        category.expand = true;
        category.querySource = (0, _fp.map)(function (detail) {
          detail.expand = !!_this2.filterText;
          detail.fields = (0, _fp.filter)({ inaccessible: false }, detail.fields);
          return new _Izenda4.default(detail);
        }, category.querySource);
      }, result);

      return result;
    }

    /**
     * Read calculated data source
     */

  }, {
    key: 'readCalculatedDataSource',
    value: function readCalculatedDataSource(result, isDirty) {
      result.querySource = (0, _fp.map)(function (detail) {
        var querySourceDetail = new _Izenda4.default(detail);
        isDirty && querySourceDetail.markDirty();
        return querySourceDetail;
      }, result.querySource);

      this.details.length >= 1 && (this.details[1] = result);
    }

    /**
     * Delete calculated field
     */

  }, {
    key: 'deleteCalculatedField',
    value: function deleteCalculatedField(field) {
      var calculatedField = this.details[1] || {};
      var calculatedFieldQuerySource = calculatedField.querySource[0];
      var fields = calculatedFieldQuerySource.fields;

      fields = (0, _fp.remove)(function (fieldDetail) {
        return fieldDetail.id === field.id;
      }, fields);

      if ((0, _fp.isEmpty)(fields)) {
        this.details.splice(1, 1);
      } else {
        this.details[1].querySource[0].fields = fields;
      }
    }

    /**
     * Check if selected data sources have a dynamic store
     */

  }, {
    key: 'hasDynamicStore',
    value: function hasDynamicStore() {
      return (0, _fp.flow)((0, _fp.flatMap)(function (category) {
        return category.querySource ? category.querySource.slice() : [];
      }), (0, _fp.filter)('isDynamic'), (0, _fp.negate)(_fp.isEmpty))(this.selectedTree);
    }

    /**
     * Get Selected Items
     */

  }, {
    key: 'getSelectedItems',
    value: function getSelectedItems(dataTreeData) {
      var result = [];
      (0, _fp.forEach)(function (item) {
        (0, _fp.forEach)(function (querySource) {
          if (querySource.selected) {
            var primaryFields = (0, _fp.filter)(function (field) {
              var ext = !(0, _fp.isEmpty)(field.extendedProperties) ? JSON.parse(field.extendedProperties) : {};
              return !(0, _fp.isEmpty)(ext) && ext.PrimaryKey;
            }, querySource.fields);

            result.push({
              aliasId: querySource.aliasId,
              querySourceId: querySource.id,
              querySourceName: querySource.name,
              selected: true,
              categoryId: item.id,
              primaryFields: primaryFields
            });
          }
        }, item.querySource);
      }, dataTreeData);
      return result;
    }

    /**
     * Get query sources from selected tree
     */

  }, {
    key: 'getSelectedQuerySources',
    value: function getSelectedQuerySources() {
      return (0, _fp.flow)((0, _fp.flatMap)(function (category) {
        return category.querySource.slice();
      }), (0, _fp.filter)('selected'))(this.selectedTree);
    }

    /**
     * Check is another calculated field used this calculated field
     */

  }, {
    key: 'isAnotherCalculatedFieldUse',
    value: function isAnotherCalculatedFieldUse(field) {
      return (0, _fp.some)(function (calculatedField) {
        return calculatedField.id !== field.id && calculatedField.expression.indexOf('[' + field.name + ']') > -1;
      }, this.calculatedFields);
    }

    /**
     * Update report calculated field id when save as report
     * @param {any} calculatedFields
     */

  }, {
    key: 'populateDataForCalculatedFields',
    value: function populateDataForCalculatedFields(calculatedFields) {
      var _this3 = this;

      (0, _fp.forEach)(function (calculatedField) {
        var item = (0, _fp.find)(function (_ref) {
          var name = _ref.name;
          return name === calculatedField.name;
        }, _this3.calculatedFields);

        if (item) {
          item.id = calculatedField.id;
        }
      }, calculatedFields);

      this.cleanCalculatedFieldDirty();
    }
  }, {
    key: 'hasLoadDataSource',
    get: function get() {
      return this.loadedDataSource;
    }
  }, {
    key: 'filterSource',
    get: function get() {
      var filterText = (0, _fp.toLower)(this.filterText);
      var regx = new RegExp((0, _fp.escapeRegExp)(filterText), 'ig');
      var relationItemIds = this.relationItemIds;

      (0, _fp.forEach)(function (category) {
        category.querySource && (0, _fp.forEach)(function (dataObject) {
          // filter fields
          var filterFields = (0, _fp.filter)(function (field) {
            return (0, _fp.toLower)(field.name).indexOf(filterText) > -1;
          }, dataObject.fields);
          dataObject.filterFields = filterFields;
        }, category.querySource);

        // filter data object
        var filterQuerySource = category.querySource && (0, _fp.filter)(function (dataObject) {
          return (dataObject.filterFields && dataObject.filterFields.length || dataObject.name.search(regx) > -1) && (
          // filter relation querySources for Simple mode
          relationItemIds.indexOf(dataObject.id) > -1 || relationItemIds.length === 0);
        }, category.querySource);

        category.filterQuerySource = filterQuerySource;
      }, this.details);

      return (0, _fp.filter)(function (category) {
        return category.filterQuerySource && category.filterQuerySource.length > 0;
      }, this.details);
    }
  }, {
    key: 'showAllowNull',
    get: function get() {
      var countSelected = 0;

      (0, _fp.forEach)(function (category) {
        countSelected = countSelected + (0, _fp.filter)('selected', category.querySource).length;
        // early break to prevent
        if (countSelected > 1) return false;
      }, this.details);

      return countSelected > 1;
    }
  }, {
    key: 'selectedItems',
    get: function get() {
      return this.getSelectedItems(this.details);
    }
  }, {
    key: 'isAllDataOjectUncategory',
    get: function get() {
      var itemHasCategory = (0, _fp.filter)(function (item) {
        return item.id !== _Izenda2.default.EMPTY_GUID;
      }, this.details);
      return (0, _fp.isEmpty)(this.details) || !(0, _fp.isEmpty)(itemHasCategory) ? false : true;
    }
  }, {
    key: 'getItemIsOnlyOne',
    get: function get() {
      return this.selectedItems.length === 1 ? this.selectedItems[0] : null;
    }
  }, {
    key: 'parameterFieldIds',
    get: function get() {
      return (0, _fp.flow)((0, _fp.flatMap)(function (item) {
        return (0, _mobx.toJS)(item.querySource);
      }), (0, _fp.filter)('selected'), (0, _fp.flatMap)(function (querySource) {
        return (0, _mobx.toJS)(querySource.fields);
      }), (0, _fp.filter)('isParameter'), (0, _fp.filter)('filterable'), (0, _fp.filter)('visible'), (0, _fp.filter)({ inaccessible: false }), (0, _fp.map)((0, _fp.get)('id')))(this.details);
    }
  }, {
    key: 'noCategory',
    get: function get() {
      return this.details.length === 1;
    }
  }, {
    key: 'haveDataObjects',
    get: function get() {
      return !(0, _fp.isEmpty)(this.selectedItems);
    }
  }, {
    key: 'calculatedFields',
    get: function get() {
      var calculatedFieldQuerySource = (0, _fp.find)({ name: _Izenda2.default.CALCULATED_FIELD_NAME }, this.details);
      if (calculatedFieldQuerySource) {
        return calculatedFieldQuerySource.querySource[0].fields;
      }

      return [];
    }
  }, {
    key: 'flattenQuerySourceIncludeCalculatedField',
    get: function get() {

      var result = [];
      (0, _fp.forEach)(function (item) {
        (0, _fp.forEach)(function (childItem) {
          result = (0, _fp.concat)(result, childItem.flattenQuerySource);
        }, item.querySource);
      }, this.details);

      return result;
    }
  }]);
  return ReportDesignerDataTree;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'details', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'filterText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'loadedDataSource', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'relationItemIds', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'isLastPage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'displayData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'selectedTree', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'hasLoadDataSource', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasLoadDataSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filterSource', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filterSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showAllowNull', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showAllowNull'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'selectedItems', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'selectedItems'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isAllDataOjectUncategory', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isAllDataOjectUncategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getItemIsOnlyOne', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getItemIsOnlyOne'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'parameterFieldIds', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'parameterFieldIds'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'noCategory', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'noCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'haveDataObjects', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'haveDataObjects'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'calculatedFields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'calculatedFields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'flattenQuerySourceIncludeCalculatedField', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'flattenQuerySourceIncludeCalculatedField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanCalculatedFieldDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanCalculatedFieldDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getDataTreeItems', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getDataTreeItems'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showRelationship', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showRelationship'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readDataSource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readDataSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readCalculatedDataSource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readCalculatedDataSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteCalculatedField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteCalculatedField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateDataForCalculatedFields', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateDataForCalculatedFields'), _class2.prototype)), _class2)) || _class;

exports.default = ReportDesignerDataTree;
module.exports = exports['default'];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CustomDropdown.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Drop Down List component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var observable = __webpack_require__(5).observable;
  var action = __webpack_require__(5).action;
  var classnames = __webpack_require__(11);

  var UiState = __webpack_require__(15);
  var UIContants = __webpack_require__(34);
  var FloatAffixed = __webpack_require__(154);
  var ScrollBox = __webpack_require__(27);
  var DEFAULT_IMAGE_MIN_WIDTH = 230;

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      find = _require.find;

  var ImageHover = observer(function (props) {
    var imageState = props.imageState;
    return imageState.classSprite && imageState.isHover && !UiState.isMobile ? React.createElement(
      FloatAffixed,
      {
        anchor: imageState.anchor,
        edges: 'left',
        autoWidth: true,
        minWidth: DEFAULT_IMAGE_MIN_WIDTH,
        className: 'izenda-DropdownImageSprite'
      },
      React.createElement(
        'div',
        { className: 'image-hover' },
        React.createElement(
          'div',
          { className: 'image-logo' },
          React.createElement('div', { className: imageState.classSprite })
        )
      )
    ) : null;
  });

  var CustomDropdown = React.createClass({
    displayName: 'CustomDropdown',

    propTypes: {
      id: React.PropTypes.string,
      options: React.PropTypes.object.isRequired,
      value: React.PropTypes.string,
      valueField: React.PropTypes.string,
      labelField: React.PropTypes.string,
      onChange: React.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
      return {
        value: null,
        valueField: 'value',
        labelField: 'label',
        onChange: null
      };
    },

    getInitialState: function getInitialState() {
      var props = this.props;

      this.imageState = observable({
        isHover: false,
        anchor: null,
        classSprite: ''
      });

      return {
        isOpen: false,
        selected: props.value === null && props.options.length !== 0 ? props.options[0][props.valueField] : props.value
      };
    },

    handleChange: function handleChange(option) {
      this.hideListOptions();
      this.props.onChange && this.props.onChange({ value: option.value });
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        selected: isNil(nextProps.value) && nextProps.options.length ? nextProps.options[0][nextProps.valueField] : nextProps.value
      });
    },

    showListOptions: function showListOptions(event) {
      this.setState({ isOpen: !this.state.isOpen });
    },

    hideListOptions: function hideListOptions(event) {
      this.hideImageSprite();
      this.setState({ isOpen: false });
    },

    showImageSprite: action(function (event) {
      var dataset = event.target.dataset;
      this.imageState.isHover = true;
      this.imageState.anchor = this.refs['customDropdown' + dataset.index];
      this.imageState.classSprite = dataset.sprite;
    }),

    hideImageSprite: action(function () {
      this.imageState.isHover = false;
    }),

    renderListOptions: function renderListOptions() {
      var props = this.props;

      return props.options.map(function (option, index) {
        var key = option[props.valueField];
        var label = option[props.labelField];
        var classSprite = option.className && classnames('sprite', option.className);
        var itemClasses = classnames({
          'izenda-CustomDropdown-item': true,
          active: key === props.selected
        });

        return React.createElement(
          'li',
          {
            ref: 'customDropdown' + index,
            key: key,
            value: key,
            onClick: this.handleChange.bind(this, option),
            className: itemClasses,
            'data-sprite': classSprite,
            'data-index': index,
            onMouseMove: this.showImageSprite,
            onMouseLeave: this.hideImageSprite
          },
          label
        );
      }.bind(this));
    },

    render: function render() {
      var props = this.props;
      var state = this.state;
      var selectedItem = find({ value: state.selected }, props.options);

      return React.createElement(
        'div',
        { className: 'dropdown izenda-CustomDropdown' },
        React.createElement(
          'div',
          {
            ref: 'customDropdown',
            className: 'btn btn-default izenda-CustomDropdown-control',
            onClick: this.showListOptions
          },
          React.createElement(
            'span',
            { className: 'select-value' },
            selectedItem.label
          ),
          React.createElement('span', { className: 'select-arrow' })
        ),
        state.isOpen && React.createElement(
          FloatAffixed,
          {
            className: 'izenda-CustomDropdown-content',
            edges: 'under,over',
            anchor: this.refs.customDropdown,
            onClickOutside: this.hideListOptions
          },
          React.createElement(
            ScrollBox,
            { autoHeight: true, autoHeightMax: UIContants.dropdownMaxHeight },
            React.createElement(
              'ul',
              { className: 'izenda-CustomDropdown-list' },
              this.renderListOptions()
            )
          ),
          React.createElement(ImageHover, { imageState: this.imageState })
        )
      );
    }
  });

  module.exports = CustomDropdown;
}();

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GridLayoutUIStore.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var extendObservable = __webpack_require__(5).extendObservable;
  var toJS = __webpack_require__(5).toJS;
  var action = __webpack_require__(5).action;
  var transaction = __webpack_require__(5).transaction;

  var layoutComputerUtils = __webpack_require__(510);
  var GridItemState = __webpack_require__(581);
  var SnapUtils = __webpack_require__(1978);

  var _require = __webpack_require__(1),
      find = _require.find,
      isNil = _require.isNil,
      filter = _require.filter,
      some = _require.some,
      assign = _require.assign,
      chain = _require.chain,
      placeholder = _require.placeholder;
  // Determine intersection area ratio for swapping


  var SWAP_INTERSECT_RATIO = 0.33;
  // Determine intersection ratio for snapping
  var SNAP_RATIO = 0.5;
  // Determine additional grid columns in case of having infinity columns
  var DEFAULT_ADD_COLS = 1;
  // Determine additional grid rows in case of having infinity rows
  var DEFAULT_ADD_ROWS = 1;

  function GridLayoutUIStore(cellWidth, cellHeight, width, rows, cols, infinityRows, infinityCols, isFullSize, allowSwap, minItemWidth, minItemHeight, maxHeight) {
    this.rows = rows;
    this.cols = cols;
    this.infinityRows = infinityRows;
    this.infinityCols = infinityCols;
    this.allowSwap = allowSwap;
    this.minItemHeight = minItemHeight || 1;
    this.minItemWidth = minItemWidth || 1;
    this.maxHeight = maxHeight;
    this.resize = false;

    extendObservable(this, {
      // Original width px set by outside.
      innerWidth: width,
      // Grid cell width in pixel
      cellWidth: cellWidth,
      // Grid cell height in pixel
      cellHeight: cellHeight,
      // Layout item that is interacting
      overlayItem: function overlayItem() {
        return find('isInteracting', this.layout);
      },
      // Current position of interacting overlay box
      overlayPosition: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      },
      // Snap editing mode
      isSnapEditOn: false,
      // Temp layouts for updating after user stop interacting
      compactedLayout: [],
      // Grid layout full size
      isFullSize: isFullSize,
      // Full height only
      isFullHeightOnly: false,
      // List of layout item
      layout: [],
      // Actual view width
      width: function width() {
        // Only round width value by multiply of cell width in front-side mode.
        // In back-side mode (showing a full size item), its width must be the same
        // with container width. Because the back side UI of report part must fit
        // the size of container.
        return this.fullSizedItem || this.isFullSize ? this.innerWidth : layoutComputerUtils.roundWidth(this.innerWidth, this.cellWidth);
      },
      // Actual view height
      height: function height() {
        return !isNil(this.maxHeight) && this.hasFullSizeItem ? this.maxHeight : this.calcHeight();
      },
      gridWidth: function gridWidth() {
        return layoutComputerUtils.getGridWidth(this.width, this.cellWidth);
      },
      gridHeight: function gridHeight() {
        return layoutComputerUtils.getGridHeight(this.height, this.cellHeight);
      },
      // Determine has any full size layout item
      hasFullSizeItem: function hasFullSizeItem() {
        return !!this.fullSizedItem;
      },
      // Determine whether an item is resizing
      isResizing: function isResizing() {
        return some('isResizing', this.layout);
      },
      // Determine whether an item is moving
      isMoving: function isMoving() {
        return some('isMoving', this.layout);
      },
      // Determine whether an item is interacting (moving or resizing)
      isInteracting: function isInteracting() {
        return this.isResizing || this.isMoving;
      },
      // Full size layout item
      fullSizedItem: function fullSizedItem() {
        return find({
          isFullSize: true
        }, this.layout);
      },
      // Max rows numbers that contains all items
      maxItemRows: function maxItemRows() {
        var cellHeight = this.cellHeight;
        var getBottom = function getBottom(item) {
          var pxBottom = item.pxTop + item.pxHeight;
          return layoutComputerUtils.getGridHeight(pxBottom, cellHeight);
        };
        return placeholder(this.layout).map(getBottom).max() || 0;
      },
      // Max cols numbers that contains all items
      maxItemCols: function maxItemCols() {
        var cellWidth = this.cellWidth;
        var getRight = function getRight(item) {
          var pxRight = item.pxLeft + item.pxWidth;
          return layoutComputerUtils.getGridWidth(pxRight, cellWidth);
        };
        return placeholder(this.layout).map(getRight).max() || 0;
      }
    });
  }

  /**
   * Toggle snap edit state.
   */
  GridLayoutUIStore.prototype.setSnapToGrid = action(function setSnapToGrid(value) {
    this.isSnapEditOn = value;
  });

  /**
   * Set layout data whenever it changed for synching data & layout UI logic.
   */
  GridLayoutUIStore.prototype.setLayout = action(function setLayout(layoutData, initial) {
    var layoutStore = this;
    var sourceItems = layoutStore.layout;
    var updatedItems = layoutData || [];

    var updateSourceItem = function updateSourceItem(updatedItem) {
      // Find existing layout item
      var match = find({
        id: updatedItem.id
      }, sourceItems);

      var layoutItem = {
        id: updatedItem.id,
        isLoading: updatedItem.isLoading,
        isFullSize: updatedItem.isFullSize,
        autoSize: updatedItem.autoSize,
        gridLeft: updatedItem.x,
        gridTop: updatedItem.y,
        gridWidth: updatedItem.width < layoutStore.minItemWidth ? layoutStore.minItemWidth : updatedItem.width,
        gridHeight: updatedItem.height < layoutStore.minItemHeight ? layoutStore.minItemHeight : updatedItem.height
      };

      if (match) {
        match.copy(layoutItem);
      } else {
        // Add new layout item
        sourceItems.push(createLayoutItem(layoutItem));
      }
    };

    var removeItem = sourceItems.remove.bind(sourceItems);

    var deletedItems = filter(function (item) {
      return !some(['id', item.id], updatedItems);
    }, sourceItems);

    // Update existing or add new to sourceItems
    updatedItems.forEach(updateSourceItem);
    // Delete absent item in updatedItems
    deletedItems.forEach(removeItem);

    this.arrange(null);
  });

  /**
   * Update view width (px) of grid layout
   */
  GridLayoutUIStore.prototype.setViewWidth = action(function setViewWidth(width) {
    this.innerWidth = width;
  });
  /**
   * Set auto sizing of grid view
   */
  GridLayoutUIStore.prototype.setAutoSize = action(function setAutoSize(fullSize) {
    this.isFullSize = fullSize;
  });
  /**
   * Set Height only
   */
  GridLayoutUIStore.prototype.setFullHeightOnly = action(function setFullHeightOnly(fullHeightOnly) {
    this.isFullHeightOnly = fullHeightOnly;
  });
  /**
   * Set position of interacting overlay box. It will be periodically updated accordingly
   * with new position when user moving or resizing
   */
  GridLayoutUIStore.prototype.setOverlayPosition = action(function setOverlayPosition(newPos) {
    this.overlayPosition = newPos;
  });

  /**
   * Calculate grid view height that respects auto size mode
   */
  GridLayoutUIStore.prototype.calcHeight = function () {
    /* Cases break down
      - (infinityRows: true, isFullSize: true)
          Take max value of (total rows of items + 1) and default rows number. So that it makes
          sure its min rows is default rows number in case of empty. See in dashboard
      - (infinityRows: false, isFullSize: true)
          Take max value of (total rows of item) and default rows number. See report viewer
          and format.
      - (infinityRows: true, isFullSize: false)
          Take default rows number. See report designer.
      - (infinityRows: false, isFullSize: false)
          Take default rows number. See report viewer in quick edit mode.
    */
    var scaleByRows = this.isFullHeightOnly || this.infinityRows && this.isFullSize && !this.hasFullSizeItem;
    var maxRows = Math.max(this.maxItemRows, this.rows);
    var rows = this.isFullHeightOnly ? maxRows : this.infinityRows || !this.isFullSize ? this.rows : maxRows;

    var containingRows = scaleByRows ? this.maxItemRows + 1 : rows;
    return this.cellHeight * Math.max(containingRows, this.rows);
  };

  /**
   * Get layout item by its id
   * @param  {String} id Layout item id
   */
  GridLayoutUIStore.prototype.getLayoutItem = function (id) {
    return find({
      id: id
    }, this.layout);
  };

  /**
   * Get actual position (pixel) of a layout item by its id
   * @param  {String} id Layout item id
   */
  GridLayoutUIStore.prototype.getActualPositionById = function (id) {
    var itemState = this.getLayoutItem(id);
    return this.getActualPosition(itemState);
  };

  /**
   * Get actual position (pixel) of a layout item.
   * @param  {String} id Layout item id
   */
  GridLayoutUIStore.prototype.getActualPosition = function (layoutItem) {
    return layoutComputerUtils.getDomPosition(layoutItem.x || layoutItem.gridLeft || 0, layoutItem.y || layoutItem.gridTop || 0, layoutItem.width || layoutItem.gridWidth || 0, layoutItem.height || layoutItem.gridHeight || 0, this.cellWidth, this.cellHeight);
  };

  /**
   * Convert actual DOM position to grid view position
   * @param  {Object} position DOM's element position
   */
  GridLayoutUIStore.prototype.toGridPosition = function (domPosition) {
    return layoutComputerUtils.getGridPosition(domPosition.left, domPosition.top, domPosition.width, domPosition.height, this.cellWidth, this.cellHeight);
  };

  /**
   * Calculate new position (pixel) that snaps to grid layout
   * @param  {Obect} position Checking position
   */
  GridLayoutUIStore.prototype.snap = function (position) {
    var top = position.top;
    var left = position.left;
    var right = position.left + position.width;
    var bottom = position.top + position.height;

    var slackTop = top % this.cellHeight;
    var slackLeft = left % this.cellWidth;
    var slackRight = right % this.cellWidth;
    var slackBottom = bottom % this.cellHeight;

    var adjustTop = slackTop === 0 ? 0 : slackTop / this.cellHeight < SNAP_RATIO ? -slackTop : this.cellHeight - slackTop;
    var adjustLeft = slackLeft === 0 ? 0 : slackLeft / this.cellWidth < SNAP_RATIO ? -slackLeft : this.cellWidth - slackLeft;

    var adjustRight = slackRight === 0 ? 0 : slackRight / this.cellWidth < SNAP_RATIO ? -slackRight : this.cellWidth - slackRight;

    var adjustBottom = slackBottom === 0 ? 0 : slackBottom / this.cellHeight < SNAP_RATIO ? -slackBottom : this.cellHeight - slackBottom;

    var snapTop = top + adjustTop;
    var snapLeft = left + adjustLeft;
    var snapRight = right + adjustRight;
    var snapBottom = bottom + adjustBottom;

    return {
      top: snapTop,
      left: snapLeft,
      width: snapRight - snapLeft,
      height: snapBottom - snapTop
    };
  };

  /**
   * Detect new position of a report part that collides to any others parts
   * @param  {String} id       Report part id (layout item id)
   * @param  {Object} position New actual DOM position of report part
   * @return {Boolean}         Collided or not
   */
  GridLayoutUIStore.prototype.detectCollision = function (id, domPosition) {
    var gridPosition = layoutComputerUtils.getGridPosition(domPosition.left, domPosition.top, domPosition.width, domPosition.height, this.cellWidth, this.cellHeight);
    gridPosition.id = id;

    var itemToRect = function itemToRect(item) {
      return layoutComputerUtils.convertToRect(item.id, item.left, item.top, item.width, item.height);
    };
    var checkingRect = itemToRect(gridPosition);

    return chain(this.layout).reject(['id', id]).map(function (layoutItem) {
      return {
        id: layoutItem.id,
        top: layoutItem.gridTop,
        left: layoutItem.gridLeft,
        width: layoutItem.gridWidth,
        height: layoutItem.gridHeight
      };
    }).map(itemToRect).some(layoutComputerUtils.collide(checkingRect)).value();
  };

  /**
   * Detect any report part is swappable with current moving one.
   * It returns the swappable report part position and its identity
   * @param  {String} id          Current report part id
   * @param  {Object} domPosition Current report part position
   * @return {Object}             Swappable report part position & id
   */
  GridLayoutUIStore.prototype.detectSwap = function (id, domPosition) {
    var gridPosition = layoutComputerUtils.getGridPosition(domPosition.left, domPosition.top, domPosition.width, domPosition.height, this.cellWidth, this.cellHeight);
    var itemToRect = function itemToRect(item) {
      return layoutComputerUtils.convertToRect(item.id, item.left, item.top, item.width, item.height);
    };

    var checkingRect = itemToRect(gridPosition);

    var swappableRect = placeholder(this.layout).reject(['id', id]).map(function (layoutItem) {
      return {
        id: layoutItem.id,
        top: layoutItem.gridTop,
        left: layoutItem.gridLeft,
        width: layoutItem.gridWidth,
        height: layoutItem.gridHeight
      };
    }).map(itemToRect).find(layoutComputerUtils.swappable(checkingRect, SWAP_INTERSECT_RATIO));

    return swappableRect ? {
      id: swappableRect.id,
      left: swappableRect.x1,
      top: swappableRect.y1,
      width: swappableRect.x2 - swappableRect.x1,
      height: swappableRect.y2 - swappableRect.y1
    } : null;
  };

  /**
   * Calculate the size of grid that's able to contain all layout items.
   *
   * @return {Object} Actual grid size (width, height)
   */
  GridLayoutUIStore.prototype.calcActualGridSize = function () {
    var additionalCols = this.infinityCols ? DEFAULT_ADD_COLS : 0;
    var additionalRows = this.infinityRows ? DEFAULT_ADD_ROWS : 0;
    var overlayPosition = this.overlayPosition;
    var overlayRight = overlayPosition ? overlayPosition.left + overlayPosition.width : 0;
    var overlayBottom = overlayPosition ? overlayPosition.top + overlayPosition.height : 0;

    // Calculate total width/height of layout items.
    var itemsWidth = (this.maxItemCols + additionalCols) * this.cellWidth;
    var itemsHeight = (this.maxItemRows + additionalRows) * this.cellHeight;

    // Calculate the static size that is the widest size to contain all static items( not overlay item)
    // As having any full size item, the grid view shows only that full size item.
    // So that in that case, return the view size.
    var staticWidth = this.hasFullSizeItem ? this.width : Math.max(itemsWidth, this.width);
    var staticHeight = this.hasFullSizeItem ? this.height : Math.max(itemsHeight, this.height);

    var dynamicWidth = overlayRight + additionalCols * this.cellWidth;
    var dynamicHeight = overlayBottom + additionalRows * this.cellHeight;

    return {
      width: this.hasFullSizeItem ? this.width : Math.max(staticWidth, dynamicWidth),
      height: this.hasFullSizeItem ? this.height : Math.max(staticHeight, dynamicHeight)
    };
  };

  /**
   * Implement algorithm to smart positioning of a report part position.
   * In some scenarios, it affects to other part positions that will be included
   * in result.
   * @param  {String} id           Report part item id
   * @param  {Object} itemPosition Report part item position
   * @return {Array}               Array of changing report part positions
   */
  GridLayoutUIStore.prototype.rearrange = function (layoutItem, position, move) {
    var id = layoutItem.id;
    var orgPosition = this.getActualPositionById(id);
    // If collision occurs, restore original position. Otherwise, update
    // new position.
    var collided = this.detectCollision(id, position);
    var swappableGridItem, swappableGridPxPosition;
    var swappableGridPosition = this.allowSwap && move && this.detectSwap(id, position);
    var needUpdatePosition = !collided;

    var gridItemPosition = needUpdatePosition ? this.toGridPosition(position) : this.toGridPosition(orgPosition);

    if (!needUpdatePosition && !swappableGridPosition) {
      // Restore position for overlay.
      this.setOverlayPosition(orgPosition);
    } else if (swappableGridPosition) {
      swappableGridItem = this.getLayoutItem(swappableGridPosition.id);
      swappableGridPxPosition = swappableGridItem.getPxPosition();

      // Swap actual pixel positions between 2 layout item.
      swappableGridItem.updatePosition(orgPosition);
      layoutItem.updatePosition(swappableGridPxPosition);

      // swap its id if swappable.
      id = swappableGridItem.id;
      swappableGridPosition.id = layoutItem.id;
    } else {
      // Update current layout to new position
      layoutItem.updatePosition(position);
    }

    gridItemPosition.id = id;
    return swappableGridPosition ? [gridItemPosition, swappableGridPosition] : [gridItemPosition];
  };

  GridLayoutUIStore.prototype.addItemAt = function (x, y) {
    var occupiedRects = layoutComputerUtils.convertLayoutsToRects(this.layout, this.cellWidth, this.cellHeight);
    var offset = layoutComputerUtils.calculateSpareOffset(x, y, occupiedRects);

    // Ensure min item width, height when adding new item.
    // If offset width or height is smaller than min size, take the min size.
    return {
      top: offset.top,
      left: offset.left,
      width: Math.max(this.minItemWidth, offset.width),
      height: Math.max(this.minItemHeight, offset.height)
    };
  };

  GridLayoutUIStore.prototype.keepLastAdjustedLayout = action(function (compactedLayout) {
    this.compactedLayout = compactedLayout;
  });

  GridLayoutUIStore.prototype.getLastCompactedLayout = function () {
    var minItemWidth = this.minItemWidth;
    var minItemHeight = this.minItemHeight;
    var compactedLayout = placeholder(this.compactedLayout).map(function (layout) {
      return {
        id: layout.id,
        top: layout.top || 0,
        left: layout.left || 0,
        width: layout.width || minItemWidth,
        height: layout.height || minItemHeight
      };
    }).value();
    this.keepLastAdjustedLayout([]);
    return compactedLayout || [];
  };

  GridLayoutUIStore.prototype.snapArrange = function (id, positionToMove, move) {
    var minItemWidth = this.minItemWidth;
    var minItemHeight = this.minItemHeight;

    var gridPosition = {
      top: layoutComputerUtils.getGridTop(positionToMove.top, this.cellHeight) || 0,
      left: layoutComputerUtils.getGridLeft(positionToMove.left, this.cellWidth) || 0,
      height: layoutComputerUtils.getGridHeight(positionToMove.height, this.cellHeight) || minItemHeight,
      width: layoutComputerUtils.getGridWidth(positionToMove.width, this.cellWidth) || minItemWidth
    };

    var cloneLayout = this.getLayout();
    var layoutItem = find({
      id: id
    }, cloneLayout);

    var adjustedLayout = SnapUtils.move(cloneLayout, layoutItem, gridPosition, true);
    var compactedLayout = SnapUtils.compact(adjustedLayout);

    // For fix case: The overlayItem is not fit to layoutItem when resizing.
    if (move) {
      this.setOverlayPosition(positionToMove);
    } else {
      var focusingLayout = find({
        id: id
      }, compactedLayout);
      var focusingPosition = layoutComputerUtils.getDomPosition(focusingLayout.left, focusingLayout.top, focusingLayout.width, focusingLayout.height, this.cellWidth, this.cellHeight);
      this.setOverlayPosition(focusingPosition);
    }

    // Keep data for update all items when interaction is stopped.
    this.keepLastAdjustedLayout(compactedLayout);
    this.updateLayoutPosition(compactedLayout);
  };

  GridLayoutUIStore.prototype.compactLayout = action(function compactLayout() {
    var cloneLayout = this.getLayout();
    var compactedLayout = SnapUtils.compact(cloneLayout);

    // Keep data for update all items after interact Stop.
    this.keepLastAdjustedLayout(compactedLayout);
    this.updateLayoutPosition(compactedLayout);
  });

  GridLayoutUIStore.prototype.updateLayoutItemSize = action(function updateLayoutItemSize(item, newDomWidth, newDomHeight) {
    var isFirstRender = item.pxWidth === 0 && item.pxHeight === 0;

    var oldItem = isFirstRender ? null : assign({
      gridTop: layoutComputerUtils.getGridTop(item.pxTop, this.cellHeight),
      gridLeft: layoutComputerUtils.getGridLeft(item.pxLeft, this.cellWidth),
      gridWidth: layoutComputerUtils.getGridWidth(item.pxWidth, this.cellWidth),
      gridHeight: layoutComputerUtils.getGridHeight(item.pxHeight, this.cellHeight)
    }, item);

    item.updateActualSize(newDomWidth, newDomHeight);
    item.updateGridPosition({
      top: item.gridTop,
      left: item.gridLeft,
      width: layoutComputerUtils.getGridWidth(newDomWidth, this.cellWidth),
      height: layoutComputerUtils.getGridHeight(newDomHeight, this.cellHeight)
    });
    this.arrange(oldItem);
  });

  GridLayoutUIStore.prototype.arrange = action(function arrange(oldGridItem) {
    var cellWidth = this.cellWidth;
    var cellHeight = this.cellHeight;

    // Convert old grid item state to layout item
    var oldLayoutItem = oldGridItem ? layoutComputerUtils.convertToLayoutItem(oldGridItem, cellWidth, cellHeight) : null;

    // Convert grid layout items
    var compactLayout = this.getLayout(true);

    // Arrange layout
    var output = layoutComputerUtils.compactLayout(compactLayout, oldLayoutItem, this.resize);

    // Update layout
    this.updateLayoutPosition(output);
  });

  GridLayoutUIStore.prototype.updatePosition = action(function updatePosition(layoutItem, newPosition, move) {
    var snappedPosition = this.snap(newPosition);
    return this.rearrange(layoutItem, snappedPosition, move);
  });

  GridLayoutUIStore.prototype.getLayout = function (ignorePx) {
    var cellWidth = this.cellWidth;
    var cellHeight = this.cellHeight;

    return placeholder(this.layout).map(function (gridItem) {
      return layoutComputerUtils.convertToLayoutItem(gridItem, cellWidth, cellHeight, ignorePx);
    }).sortBy(['left', 'top']).value();
  };

  GridLayoutUIStore.prototype.updateLayoutPosition = action(function updateLayoutPosition(updates) {
    var cellWidth = this.cellWidth;
    var cellHeight = this.cellHeight;

    placeholder(this.layout).forEach(function (item) {
      var updated = placeholder(updates).find(['id', item.id]);
      if (updated) {
        item.updatePosition({
          top: layoutComputerUtils.getDomTop(updated.top, cellHeight),
          left: layoutComputerUtils.getDomLeft(updated.left, cellWidth),
          width: layoutComputerUtils.getDomWidth(updated.width, cellWidth),
          height: layoutComputerUtils.getDomHeight(updated.height, cellHeight)
        });
        item.updateGridPosition(updated);
      }
    });
  });

  GridLayoutUIStore.prototype.recalculateLayoutPosition = function () {
    var compactLayout = this.getLayout(true);

    // Update layout
    this.updateLayoutPosition(compactLayout);
  };

  /**
   * Create an instance of GridItemState
   */
  function createLayoutItem(layoutItem) {
    return new GridItemState(layoutItem.id, layoutItem.gridLeft, layoutItem.gridTop, layoutItem.gridWidth, layoutItem.gridHeight, layoutItem.isFullSize, layoutItem.autoSize, layoutItem.isLoading);
  }

  module.exports = GridLayoutUIStore;
}();

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GridItemState.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var action = __webpack_require__(5).action;
  var extendObservable = __webpack_require__(5).extendObservable;

  /**
   * Represent an observable grid layout item
   * @param {String}  id            Grid item identity
   * @param {Number}  gridLeft      Grid item left position
   * @param {Number}  gridTop       Grid item top position
   * @param {Number}  gridWidth     Grid item width
   * @param {Number}  gridHeight    Grid item height
   * @param {Boolean} isFullSize    Grid item is showing full size of its container.
   * @param {Boolean} autoSize      Grid item determine its size by itself, not by user design.
   */
  function GridItemState(id, gridLeft, gridTop, gridWidth, gridHeight, isFullSize, autoSize, isLoading) {

    this.id = id;
    this.autoSize = autoSize;
    this.isLoading = isLoading;

    extendObservable(this, {
      // Left position in grid coordination
      gridLeft: gridLeft,
      // Top position in grid coordination
      gridTop: gridTop,
      // Width in grid coordination
      gridWidth: gridWidth,
      // Height in grid coordination
      gridHeight: gridHeight,
      // Actual top pixel in relative with grid view
      pxTop: 0,
      // Actual left pixel in relative with grid view
      pxLeft: 0,
      // Actual width pixel in relative with grid view
      pxWidth: 0,
      // Actual height pixel in relative with grid view
      pxHeight: 0,
      // Need to show the item in full grid view
      isFullSize: isFullSize,
      // Determine the grid item is moving
      isMoving: false,
      // Determine the grid item is resizing
      isResizing: false,
      // Determine the grid item is interacting by user
      isInteracting: function isInteracting() {
        return this.isResizing || this.isMoving;
      },
      // Determine the grid item needs to be animated, normally
      // happens after user commit their changes (size, position)
      needAnimation: false
    });
  }
  /**
   * Moving grid item
   */
  GridItemState.prototype.moving = action(function moving(isMoving) {
    this.isMoving = isMoving;
  });
  /**
   * Resizing grid item
   */
  GridItemState.prototype.resizing = action(function resizing(isResizing) {
    this.isResizing = isResizing;
  });
  /**
   * Animating grid item
   */
  GridItemState.prototype.animating = action(function animating(isAnimating) {
    this.needAnimation = isAnimating;
  });

  GridItemState.prototype.getPxPosition = function () {
    return {
      top: this.pxTop,
      left: this.pxLeft,
      width: this.pxWidth,
      height: this.pxHeight
    };
  };

  /**
   * Update the pixel position of grid item
   */
  GridItemState.prototype.updatePosition = action(function updatePosition(position) {
    this.pxTop = position.top;
    this.pxLeft = position.left;

    (!this.autoSize || this.pxWidth === 0) && (this.pxWidth = position.width);
    (!this.autoSize || this.pxHeight === 0) && (this.pxHeight = position.height);
  });

  /**
   * Update grid-coordination position of grid item
   */
  GridItemState.prototype.updateGridPosition = action(function updateGridPosition(gridPosition) {
    this.gridTop = gridPosition.top;
    this.gridLeft = gridPosition.left;
    this.gridWidth = gridPosition.width;
    this.gridHeight = gridPosition.height;
  });

  GridItemState.prototype.updateActualSize = action(function updateActualSize(pxWidth, pxHeight) {
    this.pxWidth = pxWidth;
    this.pxHeight = pxHeight;
  });

  /**
   * Update data of grid item
   */
  GridItemState.prototype.copy = action(function updateItem(layoutItem) {
    // Indicate that needs to animate the layout changes.
    this.animating(isItemChanged(this, layoutItem));

    // Update changed values to grid item
    this.isFullSize = layoutItem.isFullSize;
    this.autoSize = layoutItem.autoSize;
    this.gridLeft = layoutItem.gridLeft;
    this.gridTop = layoutItem.gridTop;
    this.gridWidth = layoutItem.gridWidth;
    this.gridHeight = layoutItem.gridHeight;
    this.isLoading = layoutItem.isLoading;
  });

  GridItemState.prototype.clone = function () {
    return {
      id: this.id,
      isFullSize: this.isFullSize,
      autoSize: this.autoSize,
      gridLeft: this.gridLeft,
      gridTop: this.gridTop,
      gridWidth: this.gridWidth,
      gridHeight: this.gridHeight,
      pxTop: this.pxTop,
      pxLeft: this.pxLeft,
      pxWidth: this.pxWidth,
      pxHeight: this.pxHeight,
      isLoading: this.isLoading
    };
  };

  /**
   * Detect grid item state changed
   */
  function isItemChanged(oldItem, newItem) {
    return oldItem.gridLeft !== newItem.gridLeft || oldItem.gridTop !== newItem.gridTop || oldItem.gridWidth !== newItem.gridWidth || oldItem.gridHeight !== newItem.gridHeight || oldItem.isFullSize !== newItem.isFullSize || oldItem.autoSize !== newItem.autoSize;
  }

  module.exports = GridItemState;
}();

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatItemPropertiesSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var SCHEMA_DEF = {
    title: '',
    component: 'FormatItemPropsContainer',
    props: {
      reportDesignerModel: 'reportDesignerModel',
      fieldStore: 'fieldStore'
    },
    fields: {}
  };

  var WIDGETS = {
    FormatItemPropsContainer: __webpack_require__(1982)
  };

  module.exports = function (editorComp, reportDesignerModel, fieldStore) {
    ensure(!!reportDesignerModel, 'reportDesignerModel must be set');
    return {
      // define data to render UI
      definedSchema: SCHEMA_DEF,
      // list of widgets which are used to render UI
      widgets: WIDGETS,
      // data to binding to fields
      source: {},
      // properties for different fields
      mappingProps: {
        reportDesignerModel: reportDesignerModel,
        fieldStore: fieldStore
      },
      // defined-function which fields need to execute to get its data
      mappingSource: {},
      // mapping data from editor to report-designer- model
      onChangeValue: function onChangeValue(schemaData) {}
    };
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DnDFormatsConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DnDFormatConfig
 */
!function () {
  module.exports = {
    sourceOptions: {
      beginDrag: function beginDrag(props) {
        var subItem = props.subItem || {};
        return {
          type: subItem.value,
          defaultWidth: subItem.width,
          defaultHeight: subItem.height
        };
      }
    },
    targetOptions: {
      drop: function drop(props, monitor, component) {
        if (monitor.didDrop()) {
          return;
        };
        var item = monitor.getItem();
        item && props.onDrop && props.onDrop(item);
      },
      canAccess: function canAccess(item) {
        return !!item;
      }
    }
  };
}();

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportTitleAndDescription.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Title And Description component
 */
!function () {
  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var EventsUtils = __webpack_require__(24);
  var reportDesignerWidget = __webpack_require__(188);
  var FormatItemPropertiesSchema = __webpack_require__(582);
  var Input = reportDesignerWidget.wrapper(__webpack_require__(17));
  var TextArea = reportDesignerWidget.wrapper(__webpack_require__(398));
  var GridLayout = __webpack_require__(13);
  var Panel = __webpack_require__(28);
  var Label = __webpack_require__(71);
  var FormatStyleUtils = __webpack_require__(981);
  var localizer = __webpack_require__(12);
  var PROPS_EDITOR = [{
    name: 'formatItemProps',
    getDefinedSchema: FormatItemPropertiesSchema
  }];

  var TitleDescription = m.observer(function (props) {

    var store = props.store || {};
    var viewMode = props.viewMode;
    var afterToggled = props.afterToggled;
    var reportDesignerModel = store.model || {};
    var reportTitleDescription = reportDesignerModel.reportTitleDescription;
    var formatItems = reportTitleDescription.formatItems;
    var title = formatItems[0];
    var description = formatItems[1];

    var header = {
      title: localizer.getText('REPORTDESIGNER_TOOLTIP_REPORT_TITLE_AND_DESCRIPTION'),
      icon: 'icon-toggle-thick'
    };

    var handleOnMouseDown = function handleOnMouseDown(item) {
      reportDesignerModel.updateFormatItem && reportDesignerModel.updateFormatItem(item, reportTitleDescription.name);
      props.onClick && props.onClick();
    };

    var handleChangeTitle = function handleChangeTitle(value) {
      title.updateValueByKey('value', value);
    };

    var handleChangeDescription = function handleChangeDescription(value) {
      description.updateValueByKey('value', value);
    };

    var renderTitle = function () {
      var style = FormatStyleUtils.getStyle(title);
      var backgroundColor = FormatStyleUtils.getBackgroundStyle(title);
      return viewMode ? React.createElement(
        'div',
        { style: style },
        React.createElement(
          'span',
          { style: backgroundColor },
          title.value
        )
      ) : React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: '3' },
          React.createElement(
            Label,
            null,
            localizer.getText('COMMON_LABEL_TITLE')
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '9' },
          React.createElement(Input, { className: 'form-control',
            itemData: title,
            propsEditors: PROPS_EDITOR,
            onClick: handleOnMouseDown.bind(this, title),
            value: title.value,
            onChange: EventsUtils.notifyChange(handleChangeTitle, EventsUtils.INPUT) })
        )
      );
    }.bind(this);

    var renderDescription = function () {
      var style = FormatStyleUtils.getStyle(description);
      var backgroundColor = FormatStyleUtils.getBackgroundStyle(description);
      return viewMode ? React.createElement(
        'div',
        { style: style },
        React.createElement(
          'span',
          { style: backgroundColor },
          description.value
        )
      ) : React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: '3' },
          React.createElement(
            Label,
            null,
            localizer.getText('COMMON_LABEL_DESCRIPTION')
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '9' },
          React.createElement(TextArea, { itemData: description,
            className: 'form-control',
            propsEditors: PROPS_EDITOR,
            onClick: handleOnMouseDown.bind(this, description),
            value: description.value,
            onChange: EventsUtils.notifyChange(handleChangeDescription, EventsUtils.INPUT) })
        )
      );
    }.bind(this);

    return viewMode ? React.createElement(
      'div',
      { className: 'report-format-element u_paddingAll' },
      renderTitle(),
      renderDescription()
    ) : React.createElement(
      Panel,
      { header: header,
        afterToggled: afterToggled,
        collapsible: true,
        initState: true,
        className: 'report-format-element',
        ref: 'reportElement' },
      React.createElement(
        GridLayout,
        { className: 'u_paddingAll' },
        renderTitle(),
        renderDescription()
      )
    );
  });

  module.exports = TitleDescription;
}();

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerRelationshipDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(16);

var _Izenda2 = __webpack_require__(982);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(54);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportDesignerRelationshipDetail = (_dec = (0, _mobx.action)('populateData'), _dec2 = (0, _mobx.action)('cleanDirty'), _dec3 = (0, _mobx.action)('setJoinDataSourceCategory'), _dec4 = (0, _mobx.action)('resetKeyJoinCategory'), _dec5 = (0, _mobx.action)('resetKeyJoinDataObject'), _dec6 = (0, _mobx.action)('setForeignDataSourceCategory'), _dec7 = (0, _mobx.action)('setJoinQuerySource'), _dec8 = (0, _mobx.action)('setForeignQuerySource'), _dec9 = (0, _mobx.action)('setJoinField'), _dec10 = (0, _mobx.action)('setForeignField'), _dec11 = (0, _mobx.action)('setDefaultValueByQuerySource'), _dec12 = (0, _mobx.action)('addNewKeyJoin'), _dec13 = (0, _mobx.action)('copyKeyJoin'), _dec14 = (0, _mobx.action)('updateState'), _dec15 = (0, _mobx.action)('setAlias'), _dec16 = (0, _mobx.action)('updateRelationshipItem'), _dec17 = (0, _mobx.action)('newId'), _dec18 = (0, _mobx.action)('cloneRelationship'), _dec19 = (0, _mobx.action)('reindexKeyJoinsPosition'), _dec20 = (0, _mobx.action)('updateJoinType'), _dec21 = (0, _mobx.action)('clearKeyJoin'), _dec22 = (0, _mobx.action)('createDataForCopying'), _dec23 = (0, _mobx.action)('setComparisionOperator'), _dec24 = (0, _mobx.action)('setComparisionValue'), (0, _Izenda5.default)(_class = (_class2 = function () {

  /**
   * Create new relationship detail
   * @param {any} detail
   */
  function ReportDesignerRelationshipDetail(detail) {
    (0, _classCallCheck3.default)(this, ReportDesignerRelationshipDetail);

    _initDefineProp(this, 'joinConnectionId', _descriptor, this);

    _initDefineProp(this, 'foreignConnectionId', _descriptor2, this);

    _initDefineProp(this, 'joinQuerySourceId', _descriptor3, this);

    _initDefineProp(this, 'joinQuerySourceName', _descriptor4, this);

    _initDefineProp(this, 'joinDataSourceCategoryName', _descriptor5, this);

    _initDefineProp(this, 'joinDataSourceCategoryId', _descriptor6, this);

    _initDefineProp(this, 'foreignDataSourceCategoryName', _descriptor7, this);

    _initDefineProp(this, 'foreignDataSourceCategoryId', _descriptor8, this);

    _initDefineProp(this, 'foreignQuerySourceId', _descriptor9, this);

    _initDefineProp(this, 'foreignQuerySourceName', _descriptor10, this);

    _initDefineProp(this, 'joinFieldId', _descriptor11, this);

    _initDefineProp(this, 'joinFieldName', _descriptor12, this);

    _initDefineProp(this, 'foreignFieldId', _descriptor13, this);

    _initDefineProp(this, 'foreignFieldName', _descriptor14, this);

    _initDefineProp(this, 'alias', _descriptor15, this);

    _initDefineProp(this, 'aliasTempId', _descriptor16, this);

    _initDefineProp(this, 'systemRelationship', _descriptor17, this);

    _initDefineProp(this, 'joinType', _descriptor18, this);

    _initDefineProp(this, 'parentRelationshipId', _descriptor19, this);

    _initDefineProp(this, 'position', _descriptor20, this);

    _initDefineProp(this, 'relationshipKeyJoins', _descriptor21, this);

    _initDefineProp(this, 'reportId', _descriptor22, this);

    _initDefineProp(this, 'selectedForeignAlias', _descriptor23, this);

    _initDefineProp(this, 'isForeignDataObjectAlias', _descriptor24, this);

    _initDefineProp(this, 'id', _descriptor25, this);

    _initDefineProp(this, 'state', _descriptor26, this);

    _initDefineProp(this, 'validationKey', _descriptor27, this);

    _initDefineProp(this, 'relationshipPosition', _descriptor28, this);

    _initDefineProp(this, 'needAlias', _descriptor29, this);

    _initDefineProp(this, 'level', _descriptor30, this);

    _initDefineProp(this, 'comparisonOperator', _descriptor31, this);

    _initDefineProp(this, 'comparisonValue', _descriptor32, this);

    _initDefineProp(this, 'hidden', _descriptor33, this);

    _initDefineProp(this, 'invalidAlias', _descriptor34, this);

    this.previousAlias = '';
    this.tempId = '';
    this.hasBeenModified = false;

    this.populateData(detail || {});
    this.cleanDirty();
  }
  // This flag is use to mark the foreign data object of this relationship use alias


  (0, _createClass3.default)(ReportDesignerRelationshipDetail, [{
    key: 'populateData',
    value: function populateData(detail) {
      this.tempId = (0, _fp.get)('id', detail) || (0, _fp.uniqueId)('relationship_');
      this.joinConnectionId = (0, _fp.getOr)(null, 'joinConnectionId', detail);
      this.foreignConnectionId = (0, _fp.getOr)(null, 'foreignConnectionId', detail);
      this.joinQuerySourceId = (0, _fp.getOr)(null, 'joinQuerySourceId', detail);
      this.joinQuerySourceName = (0, _fp.get)('joinQuerySourceName', detail) || '';
      this.joinDataSourceCategoryName = (0, _fp.get)('joinDataSourceCategoryName', detail) || '';
      this.joinDataSourceCategoryId = (0, _fp.getOr)(null, 'joinDataSourceCategoryId', detail);
      this.foreignDataSourceCategoryName = (0, _fp.get)('foreignDataSourceCategoryName', detail) || '';
      this.foreignDataSourceCategoryId = (0, _fp.getOr)(null, 'foreignDataSourceCategoryId', detail);
      this.foreignQuerySourceId = (0, _fp.getOr)(null, 'foreignQuerySourceId', detail);
      this.foreignQuerySourceName = (0, _fp.get)('foreignQuerySourceName', detail) || '';
      this.joinFieldId = (0, _fp.getOr)(null, 'joinFieldId', detail);
      this.joinFieldName = (0, _fp.get)('joinFieldName', detail) || '';
      this.foreignFieldId = (0, _fp.getOr)(null, 'foreignFieldId', detail);
      this.foreignFieldName = (0, _fp.get)('foreignFieldName', detail) || '';
      this.alias = (0, _fp.get)('alias', detail) || '';
      this.aliasTempId = (0, _fp.get)('aliasTempId', detail) || (0, _fp.uniqueId)('alias_');
      this.systemRelationship = (0, _fp.get)('systemRelationship', detail) || false;
      this.joinType = (0, _fp.get)('joinType', detail) || 'Inner';
      this.parentRelationshipId = (0, _fp.getOr)(null, 'parentRelationshipId', detail);
      this.position = (0, _fp.getOr)(null, 'position', detail);
      this.reportId = (0, _fp.getOr)(null, 'reportId', detail);
      this.selectedForeignAlias = (0, _fp.get)('selectedForeignAlias', detail) || '';
      // This flag is use to mark the foreign data object of this relationship use alias
      this.isForeignDataObjectAlias = (0, _fp.getOr)(null, 'isForeignDataObjectAlias', detail);
      this.id = (0, _fp.getOr)(null, 'id', detail);
      this.state = !(0, _fp.isNil)(detail.state) ? detail.state : _Izenda.OBJECT_STATE.INSERT;
      this.validationKey = (0, _fp.get)('id', detail) || this.tempId;
      this.relationshipPosition = (0, _fp.get)('relationshipPosition', detail) || 0;
      this.needAlias = !!detail.alias;
      this.previousAlias = (0, _fp.get)('alias', detail) || '';
      this.level = (0, _fp.getOr)(null, 'level', detail);
      this.comparisonOperator = (0, _fp.get)('comparisonOperator', detail) || _Izenda.DEFAULT_COMPARISION_OPERATOR;
      this.comparisonValue = (0, _fp.getOr)(null, 'comparisonValue', detail);

      this.populateRelationshipKeyJoins((0, _fp.get)('relationshipKeyJoins', detail) || []);
      this.setModify(!!detail.hasBeenModified);
    }

    /**
     * Populate key joins.
     * @param {array} keyJoins
     */

  }, {
    key: 'populateRelationshipKeyJoins',
    value: function populateRelationshipKeyJoins(keyJoins) {
      this.relationshipKeyJoins = [];

      for (var i = 0; i < keyJoins.length; i++) {
        this.relationshipKeyJoins.push(new _Izenda3.default(keyJoins[i]));
      }
    }

    /**
     * Check Dirty
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty || (0, _fp.some)(['isDirty', true], this.relationshipKeyJoins);
    }

    /**
     * Clean Dirty
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();

      (0, _fp.forEach)(function (keyJoin) {
        keyJoin.resetDirty();
      }, this.relationshipKeyJoins);
    }

    /**
     * Update join data source category.
     * @param  {string} id
     * @param  {string} name
     */

  }, {
    key: 'setJoinDataSourceCategory',
    value: function setJoinDataSourceCategory(id, name) {
      this.joinDataSourceCategoryId = id;
      this.joinDataSourceCategoryName = name;
      this.setJoinQuerySource(null);
      this.updateState();
    }

    /**
     * Reset key join category
     * @param {array} categoryIds
     */

  }, {
    key: 'resetKeyJoinCategory',
    value: function resetKeyJoinCategory(categoryIds) {
      if (this.relationshipKeyJoins.length > 0) {
        this.relationshipKeyJoins.forEach(function (keyjoin) {
          !(0, _fp.includes)(keyjoin.foreignDataSourceCategoryId, categoryIds) && keyjoin.setForeignDataSourceCategory(null);
          !(0, _fp.includes)(keyjoin.joinDataSourceCategoryId, categoryIds) && keyjoin.setJoinDataSourceCategory(null);
        });
      }
    }

    /**
     * Reset key join data object
     */

  }, {
    key: 'resetKeyJoinDataObject',
    value: function resetKeyJoinDataObject() {
      if (this.displayKeyJoins.length > 0) {
        this.displayKeyJoins.forEach(function (keyjoin) {
          keyjoin.setJoinQuerySource(null, null);
          keyjoin.setForeignQuerySource(null, null);
        });
      }
    }

    /**
     * Update foreign data source category
     * @param  {string} id
     */

  }, {
    key: 'setForeignDataSourceCategory',
    value: function setForeignDataSourceCategory(id) {
      this.foreignDataSourceCategoryId = id;
      this.setForeignQuerySource(null);
      this.markDirty();
    }

    /**
     * Update join query source.
     * @param  {string} id
     * @param  {string} name
     */

  }, {
    key: 'setJoinQuerySource',
    value: function setJoinQuerySource(id, name) {
      this.joinQuerySourceId = id;
      this.joinQuerySourceName = name;
      this.joinFieldId = null;
      this.resetKeyJoinDataObject();
    }

    /**
     * Update foreign query source
     * @param {string} id
     * @param {string} name
     * @param {boolean} isDataSourceAlias
     */

  }, {
    key: 'setForeignQuerySource',
    value: function setForeignQuerySource(id, name, isDataSourceAlias) {
      this.isForeignDataObjectAlias = !!isDataSourceAlias;
      this.selectedForeignAlias = id;
      this.foreignQuerySourceName = name;
      this.foreignFieldId = null;
      this.resetKeyJoinDataObject();
    }

    /**
     * Set primary for join field
     * @param  {string} id
     * @param  {string} name
     */

  }, {
    key: 'setJoinField',
    value: function setJoinField(id, name) {
      this.joinFieldId = id;
      this.joinFieldName = name;
      this.updateState();
    }

    /**
     * Set primary for foreign field
     * @param  {string} id
     * @param  {string} name
     */

  }, {
    key: 'setForeignField',
    value: function setForeignField(id, name) {
      this.foreignFieldId = id;
      this.foreignFieldName = name;
      this.updateState();
    }

    /**
     * Update default value by query source
     * In case user select only one dataObject then we will set default value for relationship base on dataSource selected
     * @param  {any} selectedItem
     * @param  {any} dataTree
     */

  }, {
    key: 'setDefaultValueByQuerySource',
    value: function setDefaultValueByQuerySource(selectedItem, dataTree) {
      if (!(0, _fp.isNil)(selectedItem)) {
        var primaryField = !(0, _fp.isEmpty)(selectedItem.primaryFields) ? selectedItem.primaryFields[0] : null;

        this.joinDataSourceCategoryId = selectedItem.categoryId;
        this.foreignDataSourceCategoryId = selectedItem.categoryId;

        this.joinQuerySourceId = selectedItem.querySourceId;
        this.selectedForeignAlias = selectedItem.aliasId;

        this.joinQuerySourceName = selectedItem.querySourceName;
        this.foreignQuerySourceName = selectedItem.querySourceName;

        this.joinFieldId = !(0, _fp.isEmpty)(primaryField) ? primaryField.id : null;
        this.foreignFieldId = !(0, _fp.isEmpty)(primaryField) ? primaryField.id : null;

        // update CategoryName & FieldName
        var selectedCategory = (0, _fp.find)({ id: selectedItem.categoryId }, dataTree);
        if (selectedCategory && this.joinFieldId) {
          var selectedDataObject = (0, _fp.find)({ aliasId: selectedItem.aliasId }, selectedCategory.querySource);
          var selectedField = (0, _fp.find)({ id: this.joinFieldId }, selectedDataObject.fields);

          this.joinDataSourceCategoryName = selectedCategory.name;
          this.foreignDataSourceCategoryName = selectedCategory.name;
          this.joinFieldName = selectedField.name;
          this.foreignFieldName = selectedField.name;
        }
      }
    }

    /**
     * Add an exiting key join
     * @param {any} keyJoin
     * @param {number} index
     */

  }, {
    key: 'addKeyJoin',
    value: function addKeyJoin(keyJoin, index) {
      index ? this.relationshipKeyJoins.splice(index, 0, keyJoin) : this.relationshipKeyJoins.push(keyJoin);
    }

    /**
     * Add new key join
     * @param {boolean} isAllDataObjectUncategory
     */

  }, {
    key: 'addNewKeyJoin',
    value: function addNewKeyJoin(isAllDataObjectUncategory) {
      var keyJoin = new _Izenda3.default();
      keyJoin.setParentId(this.tempId);

      if (isAllDataObjectUncategory) {
        keyJoin.setJoinDataSourceCategory(_Izenda.EMPTY_GUID);
        keyJoin.setForeignDataSourceCategory(_Izenda.EMPTY_GUID);
      }
      this.addKeyJoin(keyJoin);
      this.reindexKeyJoinsPosition();
    }

    /**
     * Copy a key join
     * @param {any} keyJoin
     */

  }, {
    key: 'copyKeyJoin',
    value: function copyKeyJoin(keyJoin) {
      var newKeyJoin = keyJoin.clone();
      var index = (0, _fp.findIndex)({ tempId: keyJoin.tempId }, this.relationshipKeyJoins);
      this.addKeyJoin(newKeyJoin, index + 1);
      this.reindexKeyJoinsPosition();
    }

    /**
     * Set delete status is true.
     */

  }, {
    key: 'delete',
    value: function _delete() {
      this.state = _Izenda.OBJECT_STATE.DELETE;
    }

    /**
     * Set state
     * @param {number} state
     */

  }, {
    key: 'setState',
    value: function setState(state) {
      this.state = state;
    }

    /**
     * Set value indicate this relationship has been modified with data model relationship
     * @param {boolean} value 
     */

  }, {
    key: 'setModify',
    value: function setModify(value) {
      this.hasBeenModified = value;
    }

    /**
     * Update state
     */

  }, {
    key: 'updateState',
    value: function updateState() {
      // just update state to UPDATE when editing existing item
      this.id && this.setState(_Izenda.OBJECT_STATE.UPDATE);
      this.markDirty();
    }

    /**
     * Set alias text for the relationship.
     * @param {string} value
     */

  }, {
    key: 'setAlias',
    value: function setAlias(value) {
      this.alias = value;
      this.updateState();
    }

    /**
     * Update current foreign alias when the source alias was changed
     * @param {string} joinQuerySourceId
     * @param {string} alias
     * @param {string} previousAlias
     */

  }, {
    key: 'updateForeignAlias',
    value: function updateForeignAlias(joinQuerySourceId, alias, previousAlias) {
      if (this.selectedForeignAlias === joinQuerySourceId + '_' + previousAlias) {
        this.selectedForeignAlias = joinQuerySourceId + '_' + alias;
      }
    }

    /**
     * Update current foreign alias for key join when the source alias was changed
     * @param {string} joinQuerySourceId
     * @param {string} alias
     * @param {string} previousAlias
     */

  }, {
    key: 'updateKeyJoinForeignAlias',
    value: function updateKeyJoinForeignAlias(joinQuerySourceId, alias, previousAlias) {
      (0, _fp.forEach)(function (keyJoin) {
        keyJoin.updateAlias(joinQuerySourceId, previousAlias, alias);
      }, this.relationshipKeyJoins);
    }

    /**
     * Update value for a property by its name
     * @param {string} key
     * @param {any} value
     * @param {boolean} notModifyState should modify state
     */

  }, {
    key: 'updateRelationshipItem',
    value: function updateRelationshipItem(key, value, notModifyState) {
      this[key] = value;
      !notModifyState && this.updateState();
    }

    /**
     * Get id value.
     */

  }, {
    key: 'getId',
    value: function getId() {
      return this.id || this.tempId;
    }

    /**
     * Populate new id value.
     */

  }, {
    key: 'newId',
    value: function newId() {
      this.id = null;
      this.tempId = this.validationKey = (0, _fp.uniqueId)('relationship_');
    }

    /**
     * Update relationship's position
     * @param {number} position
     */

  }, {
    key: 'setRelationshipPosition',
    value: function setRelationshipPosition(position) {
      this.relationshipPosition = position;
    }

    /**
     * Update hidden status
     * @param {any} hidden
     */

  }, {
    key: 'setHidden',
    value: function setHidden(hidden) {
      this.hidden = hidden;
    }

    /**
     * clone a totally a new relationship including keyJoins
     */

  }, {
    key: 'cloneRelationship',
    value: function cloneRelationship() {
      var relationshipJson = (0, _mobx.toJS)(this);
      var cloneObj = (0, _fp.cloneDeep)(relationshipJson);
      var keyJoins = (0, _fp.cloneDeep)((0, _mobx.toJS)(relationshipJson.relationshipKeyJoins));

      cloneObj.relationshipKeyJoins = [];
      (0, _fp.placeholder)(keyJoins).forEach(function (item) {
        cloneObj.relationshipKeyJoins.push(new _Izenda3.default(item));
      });

      return cloneObj;
    }

    /**
     * Delete a key join
     * @param {any} keyJoin
     */

  }, {
    key: 'deleteKeyJoin',
    value: function deleteKeyJoin(keyJoin) {
      (0, _fp.isEmpty)(keyJoin.id) ? this.relationshipKeyJoins.splice(this.relationshipKeyJoins.indexOf(keyJoin), 1) : keyJoin.delete();
    }

    /**
     * Reindex Alias Level & Relationship Position of DataSourceGrid.
     * Then update Alias Level from new row -> end
     */

  }, {
    key: 'reindexKeyJoinsPosition',
    value: function reindexKeyJoinsPosition() {
      function updatePositionAndLevel(level) {
        return (0, _mobx.action)(function (item, index) {
          item.position = index;
          item.level = level;
        });
      }

      var updatePositionAndLevelProcess = updatePositionAndLevel(this.level);

      this.relationshipKeyJoins.forEach(updatePositionAndLevelProcess);
    }

    /**
     * Update Join Type : Clear, Disable Field & Join Field when value = 'Cross'
     * @param {string} key
     * @param {any} value
     */

  }, {
    key: 'updateJoinType',
    value: function updateJoinType(key, value) {
      this[key] = value;
      this.joinType === _Izenda.JOIN_TYPE_CROSS && (this.relationshipKeyJoins = []);
      this.updateState();
    }

    /**
     * Clear key joins : Clear all key joins when user select 'Cross'
     */

  }, {
    key: 'clearKeyJoin',
    value: function clearKeyJoin() {
      this.relationshipKeyJoins = [];
      this.updateState();
    }

    /**
     * create data for copying relationship
     */

  }, {
    key: 'createDataForCopying',
    value: function createDataForCopying() {
      this.level++;
      this.newId();
      this.setState(_Izenda.OBJECT_STATE.INSERT);
      this.generateAliasTempId();
    }

    /**
     * Set level for relationship
     * @param {number} level
     */

  }, {
    key: 'setLevel',
    value: function setLevel(level) {
      this.level = level;
    }

    /**
     * generate aliasTempId
     */

  }, {
    key: 'generateAliasTempId',
    value: function generateAliasTempId() {
      this.aliasTempId = (0, _fp.uniqueId)('alias_');
    }

    /**
     * Set Comparison Operator
     * @param {any} value
     */

  }, {
    key: 'setComparisionOperator',
    value: function setComparisionOperator(value) {
      this.comparisonOperator = value;
      this.updateState();
    }

    /**
     * Set Comparison Value
     * @param {any} value
     */

  }, {
    key: 'setComparisionValue',
    value: function setComparisionValue(value) {
      this.comparisonValue = value;
      this.updateState();
    }
  }, {
    key: 'displayKeyJoins',
    get: function get() {
      return (0, _fp.filter)({ deleted: false }, this.relationshipKeyJoins);
    }
  }, {
    key: 'deleted',
    get: function get() {
      return this.state === _Izenda.OBJECT_STATE.DELETE;
    }
  }, {
    key: 'isJoinQuerySourceReady',
    get: function get() {
      return !(0, _fp.isEmpty)(this.joinDataSourceCategoryId);
    }
  }, {
    key: 'isforeignQuerySourceReady',
    get: function get() {
      return !(0, _fp.isEmpty)(this.foreignDataSourceCategoryId);
    }
  }, {
    key: 'isJoinFieldReady',
    get: function get() {
      return !(0, _fp.isEmpty)(this.joinQuerySourceId);
    }
  }, {
    key: 'isForeignFieldReady',
    get: function get() {
      return !(0, _fp.isEmpty)(this.selectedForeignAlias);
    }
  }, {
    key: 'keyJoinCount',
    get: function get() {
      var availableRelationships = (0, _fp.filter)(function (relationship) {
        return relationship.state !== _Izenda.OBJECT_STATE.DELETE;
      }, this.relationshipKeyJoins.slice());
      return availableRelationships.length;
    }
  }, {
    key: 'originalAliasId',
    get: function get() {
      if (this.selectedForeignAlias && this.selectedForeignAlias.indexOf('_') >= 0) {
        var underscoreIndex = this.selectedForeignAlias.indexOf('_');
        return this.selectedForeignAlias.substring(0, underscoreIndex);
      }
      return this.selectedForeignAlias;
    }

    /**
     * Populate data for relationship
     * (This is intended to populating which is returned from API.)
     * @param {any} detail
     */

  }]);
  return ReportDesignerRelationshipDetail;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'joinConnectionId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'foreignConnectionId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'joinQuerySourceId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'joinQuerySourceName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'joinDataSourceCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'joinDataSourceCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'foreignDataSourceCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'foreignDataSourceCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'foreignQuerySourceId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'foreignQuerySourceName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'joinFieldId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'joinFieldName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'foreignFieldId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'foreignFieldName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'alias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'aliasTempId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'systemRelationship', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'joinType', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, 'parentRelationshipId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, 'position', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, 'relationshipKeyJoins', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, 'reportId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, 'selectedForeignAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, 'isForeignDataObjectAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class2.prototype, 'state', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class2.prototype, 'validationKey', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class2.prototype, 'relationshipPosition', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class2.prototype, 'needAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class2.prototype, 'level', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class2.prototype, 'comparisonOperator', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class2.prototype, 'comparisonValue', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class2.prototype, 'hidden', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class2.prototype, 'invalidAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'displayKeyJoins', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'displayKeyJoins'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleted', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleted'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isJoinQuerySourceReady', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isJoinQuerySourceReady'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isforeignQuerySourceReady', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isforeignQuerySourceReady'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isJoinFieldReady', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isJoinFieldReady'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isForeignFieldReady', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isForeignFieldReady'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'keyJoinCount', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'keyJoinCount'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'originalAliasId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'originalAliasId'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDirty', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setJoinDataSourceCategory', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setJoinDataSourceCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetKeyJoinCategory', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetKeyJoinCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetKeyJoinDataObject', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetKeyJoinDataObject'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setForeignDataSourceCategory', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setForeignDataSourceCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setJoinQuerySource', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setJoinQuerySource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setForeignQuerySource', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setForeignQuerySource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setJoinField', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setJoinField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setForeignField', [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setForeignField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setDefaultValueByQuerySource', [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setDefaultValueByQuerySource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addNewKeyJoin', [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addNewKeyJoin'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'copyKeyJoin', [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'copyKeyJoin'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateState', [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateState'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setAlias', [_dec15], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setAlias'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateKeyJoinForeignAlias', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateKeyJoinForeignAlias'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateRelationshipItem', [_dec16], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateRelationshipItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'newId', [_dec17], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'newId'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cloneRelationship', [_dec18], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cloneRelationship'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reindexKeyJoinsPosition', [_dec19], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reindexKeyJoinsPosition'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateJoinType', [_dec20], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateJoinType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clearKeyJoin', [_dec21], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clearKeyJoin'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'createDataForCopying', [_dec22], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'createDataForCopying'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setComparisionOperator', [_dec23], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setComparisionOperator'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setComparisionValue', [_dec24], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setComparisionValue'), _class2.prototype)), _class2)) || _class);
exports.default = ReportDesignerRelationshipDetail;
module.exports = exports['default'];

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(16);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DataTreeUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * Get available query source from available tree
   */
  getAvailableQuerySources: function getAvailableQuerySources(dataTree) {
    return (0, _fp.isEmpty)(dataTree) ? [] : (0, _fp.flow)(_fp.head, (0, _fp.get)("querySource"))(dataTree);
  },

  /**
   * Check if selected tree remain at least one selected
   * Note: selected tree contains field that mark unselected
   */
  haveSelectedAtLeastOneQuerySource: function haveSelectedAtLeastOneQuerySource(dataTree) {
    return (0, _fp.some)(function (cat) {
      return (0, _fp.some)(function (source) {
        return source.selected;
      }, cat.querySource);
    }, dataTree);
  },

  /**
   * Get selected query sources
   */
  getSelectedQuerySources: function getSelectedQuerySources(dataTree) {
    var result = [];
    dataTree.forEach(function (category) {
      category.querySource.forEach(function (qs) {
        if (qs.selected) {
          var primaryFields = (0, _fp.filter)(function (field) {
            var ext = !(0, _fp.isEmpty)(field.extendedProperties) ? JSON.parse(field.extendedProperties) : {};
            return !(0, _fp.isEmpty)(ext) && ext.PrimaryKey;
          }, qs.fields);

          result.push({
            aliasId: qs.aliasId,
            querySourceId: qs.id,
            querySourceName: qs.name,
            selected: true,
            categoryId: category.id,
            primaryFields: primaryFields
          });
        }
      });
    });

    return result;
  }
};
module.exports = exports["default"];

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Filter Details model
 */

var _Izenda = __webpack_require__(223);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var _Izenda3 = __webpack_require__(54);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = __webpack_require__(34);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(58);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _fp = __webpack_require__(1);

var _Izenda10 = __webpack_require__(228);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var defaultFontFormat = {
  fontFamily: _Izenda7.default.defaultFontFamily,
  fontSize: _Izenda7.default.defaultFontSize || _Izenda7.default.fontSize[0]
};

var FilterDetails = (0, _Izenda4.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(FilterDetails, [{
    key: 'sourceDataObjectFullName',
    get: function get() {
      return '{' + this.connectionName + '}.{' + this.querySourceCategoryName + '}.{' + this.sourceDataObjectName + '}';
    }
    // UI properties

  }, {
    key: 'hasUserDefinedLookup',
    get: function get() {
      return this.filterLookupType === _Izenda10.FILTER_LOOKUP_TYPES.USER_DEFINED;
    }
  }, {
    key: 'hasValidLookupKey',
    get: function get() {
      return this.filterLookupType === _Izenda10.FILTER_LOOKUP_TYPES.LOOKUP_KEY && this.filterLookupStatus === _Izenda10.FILTER_LOOKUP_STATUSES.VALID;
    }
  }, {
    key: 'showUseLookupCheckbox',
    get: function get() {
      return this.hasValidLookupKey && !this.isParameter;
    }
  }]);

  function FilterDetails(data, filterList, markUpdateResult) {
    (0, _classCallCheck3.default)(this, FilterDetails);

    _initDefineProp(this, 'connectionName', _descriptor, this);

    _initDefineProp(this, 'querySourceCategoryName', _descriptor2, this);

    _initDefineProp(this, 'sourceFieldName', _descriptor3, this);

    _initDefineProp(this, 'sourceFieldVisible', _descriptor4, this);

    _initDefineProp(this, 'sourceFieldFilterable', _descriptor5, this);

    _initDefineProp(this, 'sourceDataObjectName', _descriptor6, this);

    _initDefineProp(this, 'dataType', _descriptor7, this);

    _initDefineProp(this, 'filterId', _descriptor8, this);

    _initDefineProp(this, 'querySourceFieldId', _descriptor9, this);

    _initDefineProp(this, 'querySourceType', _descriptor10, this);

    _initDefineProp(this, 'querySourceId', _descriptor11, this);

    _initDefineProp(this, 'relationshipId', _descriptor12, this);

    _initDefineProp(this, 'alias', _descriptor13, this);

    _initDefineProp(this, 'position', _descriptor14, this);

    _initDefineProp(this, 'visible', _descriptor15, this);

    _initDefineProp(this, 'required', _descriptor16, this);

    _initDefineProp(this, 'cascading', _descriptor17, this);

    _initDefineProp(this, 'operatorId', _descriptor18, this);

    _initDefineProp(this, 'operatorName', _descriptor19, this);

    _initDefineProp(this, 'operatorSetting', _descriptor20, this);

    _initDefineProp(this, 'value', _descriptor21, this);

    _initDefineProp(this, 'sortType', _descriptor22, this);

    _initDefineProp(this, 'fontFamily', _descriptor23, this);

    _initDefineProp(this, 'fontSize', _descriptor24, this);

    _initDefineProp(this, 'textColor', _descriptor25, this);

    _initDefineProp(this, 'backgroundColor', _descriptor26, this);

    _initDefineProp(this, 'fontBold', _descriptor27, this);

    _initDefineProp(this, 'fontItalic', _descriptor28, this);

    _initDefineProp(this, 'fontUnderline', _descriptor29, this);

    _initDefineProp(this, 'id', _descriptor30, this);

    _initDefineProp(this, 'state', _descriptor31, this);

    _initDefineProp(this, 'modified', _descriptor32, this);

    _initDefineProp(this, 'dateTimeNow', _descriptor33, this);

    _initDefineProp(this, 'selected', _descriptor34, this);

    _initDefineProp(this, 'reportPartTitle', _descriptor35, this);

    _initDefineProp(this, 'reportFieldAlias', _descriptor36, this);

    _initDefineProp(this, 'dataFormatId', _descriptor37, this);

    _initDefineProp(this, 'dataFormat', _descriptor38, this);

    _initDefineProp(this, 'isInheritableFilter', _descriptor39, this);

    _initDefineProp(this, 'filterLookupType', _descriptor40, this);

    _initDefineProp(this, 'filterLookupStatus', _descriptor41, this);

    _initDefineProp(this, 'useLookup', _descriptor42, this);

    _initDefineProp(this, 'isParameter', _descriptor43, this);

    _initDefineProp(this, 'isDisableCascading', _descriptor44, this);

    this.commonFilterRequired = false;

    this.markUpdateResult = markUpdateResult;
    this.filterList = filterList || [];
    this.filterItemDom = {};

    // unique Id for Filter Body. using this id as key will prevent component
    // from unmount and willMount new component thus keep the validation status
    if ((0, _fp.get)('uniqueId', data)) {
      this.uniqueId = data.uniqueId;
    } else {
      this.uniqueId = (0, _fp.uniqueId)();
    }

    data && this.setFilterDetails(data);
    this.cleanDirty();
  }

  /**
   * Set data source for filter
   * @param {Object} data Source Data
   * @param {Boolean} isUpdate
   */


  (0, _createClass3.default)(FilterDetails, [{
    key: 'setDataSource',
    value: function setDataSource(data, isUpdate) {
      var isCalculatedField = data.querySourceType === _Izenda5.CALCULATED_FIELD_NAME;

      (0, _Izenda2.default)(this, 'connectionName', data.connectionName);
      (0, _Izenda2.default)(this, 'querySourceCategoryName', data.querySourceCategoryName);
      (0, _Izenda2.default)(this, 'sourceFieldName', data.sourceFieldName);
      (0, _Izenda2.default)(this, 'sourceDataObjectName', isCalculatedField ? _Izenda5.CALCULATED_FIELD_NAME : data.sourceDataObjectName);
      (0, _Izenda2.default)(this, 'dataType', data.dataType);
      !isUpdate && (0, _Izenda2.default)(this, 'filterId', data.filterId);
      (0, _Izenda2.default)(this, 'querySourceFieldId', data.querySourceFieldId);
      (0, _Izenda2.default)(this, 'querySourceId', data.querySourceId);
      (0, _Izenda2.default)(this, 'relationshipId', data.relationshipId);
      (0, _Izenda2.default)(this, 'querySourceType', data.querySourceType);
      (0, _Izenda2.default)(this, 'sourceFieldVisible', data.sourceFieldVisible);

      (0, _Izenda2.default)(this, 'sourceFieldFilterable', data.sourceFieldFilterable);
      (0, _Izenda2.default)(this, 'reportPartTitle', data.reportPartTitle);
      (0, _Izenda2.default)(this, 'reportFieldAlias', data.reportFieldAlias);

      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }
    /**
     * Set filter setting
     * @param {Object} data
     */

  }, {
    key: 'setFilterSettings',
    value: function setFilterSettings(data) {
      var _this = this;

      var alias = String.generateNewName(data.sourceFieldName, (0, _fp.remove)(function (obj) {
        return _this.alias === obj.alias;
      }, this.filterList), (0, _fp.get)('alias'));

      // if alias is null, it will be value of sourceFieldName
      (0, _Izenda2.default)(this, 'alias', data.alias || alias);
      (0, _Izenda2.default)(this, 'visible', data.visible);
      (0, _Izenda2.default)(this, 'required', data.required);
      (0, _Izenda2.default)(this, 'cascading', data.cascading);
      (0, _Izenda2.default)(this, 'operatorId', data.operatorId);
      (0, _Izenda2.default)(this, 'operatorName', data.operatorName);
      (0, _Izenda2.default)(this, 'operatorSetting', data.operatorSetting);
      (0, _Izenda2.default)(this, 'value', data.value);
      (0, _Izenda2.default)(this, 'sortType', data.sortType);

      data.position && (0, _Izenda2.default)(this, 'position', data.position);
      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Set filter lookup
     * @param {Object} data
     */

  }, {
    key: 'setFilterLookup',
    value: function setFilterLookup(data) {
      (0, _Izenda2.default)(this, 'filterLookupType', (0, _fp.getOr)(_Izenda10.FILTER_LOOKUP_TYPES.NONE, 'filterLookupType', data));
      (0, _Izenda2.default)(this, 'filterLookupStatus', (0, _fp.getOr)(_Izenda10.FILTER_LOOKUP_STATUSES.VALID, 'filterLookupStatus', data));
      (0, _Izenda2.default)(this, 'useLookup', !this.showUseLookupCheckbox || (0, _fp.getOr)(true, 'useLookup', data));

      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Set format for filter
     * @param {Object} data
     */

  }, {
    key: 'setFilterFormat',
    value: function setFilterFormat(data) {
      (0, _Izenda2.default)(this, 'fontFamily', data.fontFamily || defaultFontFormat.fontFamily);
      (0, _Izenda2.default)(this, 'fontSize', data.fontSize || defaultFontFormat.fontSize);
      (0, _Izenda2.default)(this, 'textColor', data.textColor);
      (0, _Izenda2.default)(this, 'backgroundColor', data.backgroundColor);
      (0, _Izenda2.default)(this, 'fontBold', data.fontBold);
      (0, _Izenda2.default)(this, 'fontItalic', data.fontItalic);
      (0, _Izenda2.default)(this, 'fontUnderline', data.fontUnderline);
      (0, _Izenda2.default)(this, 'dataFormatId', data.dataFormatId);
      (0, _Izenda2.default)(this, 'dataFormat', data.dataFormat || null);
      (0, _Izenda2.default)(this, 'commonFilterRequired', data.commonFilterRequired);
      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Set common data of filter List
     * @param {Object} data
     * @param {Boolean} isUpdate
     */

  }, {
    key: 'setCommon',
    value: function setCommon(data, isUpdate) {
      if (this.state === _Izenda9.default.DELETE) return;
      !isUpdate && (0, _Izenda2.default)(this, 'id', data.id);
      (0, _Izenda2.default)(this, 'state', isUpdate ? _Izenda9.default.UPDATE : data.state);
      (0, _Izenda2.default)(this, 'modified', data.modified);
      (0, _Izenda2.default)(this, 'dateTimeNow', data.dateTimeNow);
      // UI properties
      (0, _Izenda2.default)(this, 'isParameter', data.isParameter);
      (0, _Izenda2.default)(this, 'isInheritableFilter', data.isInheritableFilter);
      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Set filter details
     * @param {Object} data
     * @param {Boolean} isUpdate
     */

  }, {
    key: 'setFilterDetails',
    value: function setFilterDetails(data, isUpdate) {
      this.setCommon(data, isUpdate);
      this.setDataSource(data, isUpdate);
      this.setFilterSettings(data);
      this.setFilterLookup(data);
      this.setFilterFormat(data);
    }

    /**
     * Update FilterDetails properties
     * @param {String} key
     * @param {Object} value
     */

  }, {
    key: 'updateByKey',
    value: function updateByKey(key, value) {
      if (this.state === _Izenda9.default.DELETE) return;
      (0, _Izenda2.default)(this, key, value);
      this.state !== _Izenda9.default.INSERT && (0, _Izenda2.default)(this, 'state', _Izenda9.default.UPDATE);
      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Update Operator Details
     * @param {Object} data
     */

  }, {
    key: 'updateOperatorDetail',
    value: function updateOperatorDetail(data) {
      data = data || {};

      (0, _Izenda2.default)(this, 'operatorId', data.operatorId);
      (0, _Izenda2.default)(this, 'operatorName', data.operatorName);
      (0, _Izenda2.default)(this, 'operatorSetting', data.operatorSetting);
      (0, _Izenda2.default)(this, 'value', data.value);

      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Get dirty status.
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty;
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();
    }

    /**
     * Get Filter Details
     */

  }, {
    key: 'getFilterDetails',
    value: function getFilterDetails() {
      return {
        connectionName: this.connectionName,
        querySourceCategoryName: this.querySourceCategoryName,
        sourceFieldName: this.sourceFieldName,
        sourceFieldVisible: this.sourceFieldVisible,
        sourceFieldFilterable: this.sourceFieldFilterable,
        sourceDataObjectName: this.sourceDataObjectName,
        dataType: this.dataType,
        filterId: this.filterId,
        querySourceFieldId: this.querySourceFieldId,
        querySourceType: this.querySourceType,
        querySourceId: this.querySourceId,
        relationshipId: this.relationshipId,
        alias: this.alias,
        position: this.position,
        visible: this.visible,
        required: this.required,
        cascading: this.cascading,
        operatorId: this.operatorId,
        operatorName: this.operatorName,
        operatorSetting: this.operatorSetting,
        value: this.value,
        sortType: this.sortType,
        fontFamily: this.fontFamily,
        fontSize: this.fontSize,
        textColor: this.textColor,
        backgroundColor: this.backgroundColor,
        fontBold: this.fontBold,
        fontItalic: this.fontItalic,
        fontUnderline: this.fontUnderline,
        id: this.id,
        state: this.state,
        modified: this.modified,
        dateTimeNow: this.dateTimeNow,
        isParameter: this.isParameter,
        sourceDataObjectFullName: this.sourceDataObjectFullName,
        selected: this.selected,
        dataFormatId: this.dataFormatId,
        reportPartTitle: this.reportPartTitle,
        reportFieldAlias: this.reportFieldAlias,
        uniqueId: this.uniqueId,
        isInheritableFilter: this.isInheritableFilter,
        useLookup: this.useLookup
      };
    }

    /**
     * Update operator setting.
     * @param  {Object} value
     */

  }, {
    key: 'setOperatorSetting',
    value: function setOperatorSetting(value) {
      (0, _Izenda2.default)(this, 'operatorSetting', value);
    }

    /**
     * Get unique filter id
     */

  }, {
    key: 'getFilterId',
    value: function getFilterId() {
      var querySourceFieldId = this.querySourceType === _Izenda5.FIELD_TYPE.AggregatedField ? '' : this.querySourceFieldId;
      return this.reportPartTitle ? querySourceFieldId + this.reportPartTitle + this.reportFieldAlias : querySourceFieldId && this.sourceDataObjectName ? querySourceFieldId + this.sourceDataObjectName : null;
    }

    /**
     * Get display style
     */

  }, {
    key: 'getDisplayStyle',
    value: function getDisplayStyle() {
      return {
        fontFamily: this.fontFamily,
        fontSize: this.fontSize,
        fontWeight: this.fontBold ? 'bold' : 'normal',
        fontStyle: this.fontIt ? 'italic' : 'normal',
        textDecoration: this.fontUnderline ? 'underline' : 'none',
        color: this.textColor,
        backgroundColor: this.backgroundColor
      };
    }

    /**
     * Set disable cascading
     * @returns {boolean} The value indicate if the cascading has been changed
     */

  }, {
    key: 'setDisableCascading',
    value: function setDisableCascading(value) {
      this.isDisableCascading = value;
      if (value && this.cascading) {
        // Mark dirty when cascading change
        this.markDirty();
        this.cascading = false;
        return true;
      }
      return false;
    }
  }]);
  return FilterDetails;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'connectionName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'querySourceCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'sourceFieldName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'sourceFieldVisible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'sourceFieldFilterable', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'sourceDataObjectName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'dataType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'filterId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'querySourceFieldId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'querySourceType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'querySourceId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'relationshipId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'alias', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'position', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'visible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'required', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'cascading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'operatorId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, 'operatorName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, 'operatorSetting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, 'sortType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, 'fontFamily', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return defaultFontFormat.fontFamily;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, 'fontSize', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return defaultFontFormat.fontSize;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class2.prototype, 'textColor', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda7.default.textColor;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class2.prototype, 'backgroundColor', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda7.default.backgroundColor;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class2.prototype, 'fontBold', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class2.prototype, 'fontItalic', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class2.prototype, 'fontUnderline', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class2.prototype, 'state', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class2.prototype, 'modified', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class2.prototype, 'dateTimeNow', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class2.prototype, 'selected', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class2.prototype, 'reportPartTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class2.prototype, 'reportFieldAlias', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class2.prototype, 'dataFormatId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class2.prototype, 'dataFormat', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class2.prototype, 'isInheritableFilter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class2.prototype, 'filterLookupType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda10.FILTER_LOOKUP_TYPES.NONE;
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class2.prototype, 'filterLookupStatus', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda10.FILTER_LOOKUP_STATUSES.VALID;
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class2.prototype, 'useLookup', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class2.prototype, 'isParameter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class2.prototype, 'isDisableCascading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'sourceDataObjectFullName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'sourceDataObjectFullName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasUserDefinedLookup', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasUserDefinedLookup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasValidLookupKey', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasValidLookupKey'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showUseLookupCheckbox', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showUseLookupCheckbox'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setDataSource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setDataSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setFilterSettings', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setFilterSettings'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setFilterLookup', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setFilterLookup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setFilterFormat', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setFilterFormat'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setCommon', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setCommon'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setFilterDetails', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setFilterDetails'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateOperatorDetail', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateOperatorDetail'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setDisableCascading', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setDisableCascading'), _class2.prototype)), _class2)) || _class;

exports.default = FilterDetails;
module.exports = exports['default'];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterDetailsConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * FilterDetailsConfig model
 */


var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(89);

var _Izenda2 = __webpack_require__(58);

var _Izenda3 = __webpack_require__(54);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(35);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(15);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

__webpack_require__(55);

var FilterDetailsConfig = (0, _Izenda4.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(FilterDetailsConfig, [{
    key: 'filterValue',
    get: function get() {
      return this.parseFilterValue(this.fieldDetails.value, true);
    }
  }, {
    key: 'operatorGroup',
    get: function get() {
      var dataType = this.fieldDetails && this.fieldDetails.dataType || '';
      var def = (0, _fp.concat)(_Izenda.OPERATER_BY_DATA_TYPE[dataType.toLowerCase()], [_Izenda.OPERATOR_GROUP.UNKNOWN]);

      return this.commonData.operatorGroup.filter(function (_ref) {
        var key = _ref.key;
        return def.indexOf(key) > -1;
      });
    }

    /*
     * exclude COMPARISON/FIELDCOMPARISON group if filter is SP
     */

  }, {
    key: 'availableOperatorGroup',
    get: function get() {
      return this.fieldDetails.isParameter ? this.operatorGroup.filter(function (_ref2) {
        var key = _ref2.key;
        return !(0, _fp.includes)((0, _fp.lowerCase)(key), [_Izenda.OPERATOR_GROUP.COMPARISON, _Izenda.OPERATOR_GROUP.FIELDCOMPARISON, _Izenda.OPERATOR_GROUP.STRING]);
      }) : this.operatorGroup;
    }
  }, {
    key: 'operators',
    get: function get() {
      return (0, _fp.get)('group.filterOperators', this.filterInfo);
    }
  }, {
    key: 'operatorSourceValue',
    get: function get() {
      return this.operatorSourceInfo.data;
    }
  }, {
    key: 'isUpdateSource',
    get: function get() {
      return this.filterInfo.sourceType !== this.operatorSourceInfo.sourceType;
    }
  }, {
    key: 'filterInfo',
    get: function get() {
      var generalInfo = this.getGroupAndOperatorByOperatorId(this.fieldDetails.operatorId) || {};
      var sGroup = generalInfo.group;
      var sOperator = generalInfo.operator;

      return {
        groupId: sGroup && sGroup.id,
        group: sGroup,
        operatorId: sOperator && sOperator.id,
        operator: sOperator,
        value: this.filterValue,
        sourceType: generalInfo.sourceTypeByGroup
      };
    }
  }, {
    key: 'sourceFieldName',
    get: function get() {
      return this.fieldDetails.sourceFieldName;
    }

    // TODO THU - consider to remove this.

  }, {
    key: 'doesSupportDataSourceLazyLoading',
    get: function get() {
      return (0, _fp.contains)(this.filterInfo.sourceType, ['dataSource', 'dataSourceTree']);
    }
  }]);

  function FilterDetailsConfig(fieldDetails, markUpdateResult) {
    (0, _classCallCheck3.default)(this, FilterDetailsConfig);

    _initDefineProp(this, 'fieldDetails', _descriptor, this);

    _initDefineProp(this, 'commonData', _descriptor2, this);

    _initDefineProp(this, 'selectedOperatorId', _descriptor3, this);

    _initDefineProp(this, 'operatorSourceInfo', _descriptor4, this);

    _initDefineProp(this, 'operatorSourceDisplay', _descriptor5, this);

    this.markUpdateResult = markUpdateResult;

    fieldDetails && this.setFieldDetails(fieldDetails);
    this.resetDirty();
  }

  /**
   * Check Dirty
   */


  (0, _createClass3.default)(FilterDetailsConfig, [{
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty;
    }

    /**
     * Clean Dirty
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();
    }

    /**
     * Update list of operator group (mostly this data comes from API)
     * @param {Array<any>} operatorGroups
     */

  }, {
    key: 'populateOperatorGroup',
    value: function populateOperatorGroup(operatorGroup) {
      this.commonData.operatorGroup = operatorGroup;
    }

    /**
     * Parse filter value from string to array
     * List of values wil be join by [;#]
     * @param {string|Array<any>} filterValue
     * @param {boolean} flag
     *              TRUE    parse from string to array (data from server)
     *              FALSE   parse from array to string (to save data)
     * @returns {string|Array<any>}
     */

  }, {
    key: 'parseFilterValue',
    value: function parseFilterValue(filterValue, flag) {
      if (flag) {
        filterValue = filterValue || '';
        return filterValue && filterValue.split(';#') || [];
      } else {
        filterValue = filterValue || [];
        return (0, _fp.isEqual)((0, _fp.compact)(filterValue), []) ? '' : filterValue.join(';#');
      }
    }

    /**
     * Set filter value (filter value is depended on selected-operator-group and selected-operator)
     * @param {string|Array<any>} filterValue
     */

  }, {
    key: 'setFilterValue',
    value: function setFilterValue(filterValue) {
      filterValue = (0, _fp.isArray)(filterValue) ? filterValue : [filterValue];
      filterValue = this.parseFilterValue(filterValue, false);

      this.fieldDetails && this.fieldDetails.updateByKey('value', filterValue);
      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Update filter value
     * @param {Object} subData
     * @param {string} filterFieldId
     * @param {boolean} isDashboardDetail
     * @param {string|Array<any>} filterValue
     * @param {string} operatorId
     * @param {string} operatorSetting
     */

  }, {
    key: 'updateFilterValue',
    value: function updateFilterValue(subData, filterFieldId, isDashboardDetail, filterValue, operatorId, operatorSetting) {
      if (isDashboardDetail) {
        return this.updateCommonFilterValue(subData, filterFieldId, filterValue, operatorId, operatorSetting);
      }

      filterValue = (0, _fp.isArray)(filterValue) ? filterValue : [filterValue];
      filterValue = this.parseFilterValue(filterValue, false);

      this.fieldDetails && this.fieldDetails.updateByKey('value', filterValue);

      var filter = (0, _fp.find)(function (s) {
        return (0, _fp.isEqual)(s.filterFieldId, filterFieldId);
      }, subData.subscriptionFilterFields);

      if ((0, _fp.isNil)(filter)) {
        subData.subscriptionFilterFields.push({
          filterFieldId: filterFieldId,
          value: filterValue,
          state: _Izenda2.INSERT,
          operatorId: operatorId,
          operatorSetting: operatorSetting
        });
      } else {
        var i = (0, _fp.indexOf)(filter, subData.subscriptionFilterFields);
        subData.subscriptionFilterFields[i].operatorId = operatorId;
        subData.subscriptionFilterFields[i].operatorSetting = operatorSetting;
        subData.subscriptionFilterFields[i].value = filterValue;
        subData.subscriptionFilterFields[i].state !== _Izenda2.INSERT && (subData.subscriptionFilterFields[i].state = _Izenda2.UPDATE);
      }
      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Update CommonFilterValue
     * @param {string} filterFieldId
     * @param {string|Array<any>} filterValue
     * @param {string} operatorId
     * @param {string} operatorSetting
     */

  }, {
    key: 'updateCommonFilterValue',
    value: function updateCommonFilterValue(_ref3, filterFieldId, filterValue, operatorId, operatorSetting) {
      var subscriptionCommonFilterFields = _ref3.subscriptionCommonFilterFields;

      filterValue = (0, _fp.isArray)(filterValue) ? filterValue : [filterValue];
      filterValue = this.parseFilterValue(filterValue, false);

      this.fieldDetails && this.fieldDetails.updateByKey('value', filterValue);

      var filter = (0, _fp.find)(function (_ref4) {
        var commonFilterFieldId = _ref4.commonFilterFieldId;
        return (0, _fp.isEqual)(commonFilterFieldId, filterFieldId);
      }, subscriptionCommonFilterFields);

      if ((0, _fp.isNil)(filter)) {
        subscriptionCommonFilterFields.push({
          commonFilterFieldId: filterFieldId,
          value: filterValue,
          state: _Izenda2.INSERT,
          operatorId: operatorId,
          operatorSetting: operatorSetting
        });
      } else {
        var i = (0, _fp.indexOf)(filter, subscriptionCommonFilterFields);
        subscriptionCommonFilterFields[i].value = filterValue;
        subscriptionCommonFilterFields[i].state !== _Izenda2.INSERT && (subscriptionCommonFilterFields[i].state = _Izenda2.UPDATE);
      }
      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Update operatorId and filter value from filterInfo to field-details
     */

  }, {
    key: 'updateFilterValueToField',
    value: function updateFilterValueToField() {
      var _this = this;

      var filterInfo = this.filterInfo;

      (0, _mobx.transaction)(function () {
        _this.setOperatorId(filterInfo.operatorId);
        _this.setFilterValue(filterInfo.value);
      });
    }

    /**
     * Get operator group's id by operator id
     * @param {string} operatorId
     */

  }, {
    key: 'getGroupByOperatorId',
    value: function getGroupByOperatorId(operatorId) {
      var operator = this.getOperatorById(operatorId);

      return operator && this.getGroupById(operator.operatorGroupId);
    }

    /**
     * Return details of operator group based on group Id
     * @param {string} operatorGroupId
     * @returns {Object}
     */

  }, {
    key: 'getGroupById',
    value: function getGroupById(operatorGroupId) {
      return (0, _fp.find)({ id: operatorGroupId }, this.commonData.operatorGroup);
    }

    /**
     * Return details of operator group based on group key
     * @param {string} groupKey
     * @returns {Object}
     */

  }, {
    key: 'getGroupByKey',
    value: function getGroupByKey(groupKey) {
      return (0, _fp.find)({ key: groupKey }, this.commonData.operatorGroup);
    }

    /**
     * Get details of operator based on operator Id
     * @param {string} operatorId
     * @returns {Object}
     */

  }, {
    key: 'getOperatorById',
    value: function getOperatorById(operatorId) {
      return (0, _fp.flow)((0, _fp.flatMap)(function (_ref5) {
        var filterOperators = _ref5.filterOperators;
        return (0, _mobx.toJS)(filterOperators);
      }), (0, _fp.find)({ id: operatorId }))(this.commonData.operatorGroup);
    }

    /**
     * Return operator details of certain group based on index
     * @param {string} operatorGroupId
     * @param {string} dataType
     * @returns {Object}
     */

  }, {
    key: 'getOperatorByIndex',
    value: function getOperatorByIndex(operatorGroupId, dataType) {
      var group = this.getGroupById(operatorGroupId) || {};
      var operators = group.filterOperators || [];
      var isBlankOperator = _Izenda.BLANK_NULL_OPERATOR.indexOf(dataType) > -1;

      return !isBlankOperator && (0, _fp.find)({ id: group.defaultOperatorId }, operators) || operators[0];
    }

    /**
     * Get value of field which is in config mode based on keyName
     * @param {string} keyName
     * @returns {Object}
     */

  }, {
    key: 'getValueByKey',
    value: function getValueByKey() {
      var keyName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return this[keyName] || this.fieldDetails[keyName];
    }

    /**
     * Get value of field which is in config mode based on keyName
     * @param {string} aliasName
     */

  }, {
    key: 'updateFilterConfig',
    value: function updateFilterConfig(aliasName) {
      var _this2 = this;

      var fieldDetails = this.fieldDetails;
      (0, _mobx.transaction)(function () {
        // Only update filter value and filter operator when operator Id change
        if (_this2.selectedOperatorId !== fieldDetails.operatorId) {
          // reset filter value
          _this2.setFilterValue([]);
          fieldDetails.updateByKey('operatorId', _this2.selectedOperatorId);
        }
        fieldDetails.updateByKey('alias', aliasName);
      });
    }

    /**
     * Get group and operator by operator id
     * @param {string} operatorId
     */

  }, {
    key: 'getGroupAndOperatorByOperatorId',
    value: function getGroupAndOperatorByOperatorId(operatorId) {
      var sGroup = this.getGroupByOperatorId(operatorId) || {};
      var sOperator = this.getOperatorById(operatorId) || {};
      var dataType = this.fieldDetails && this.fieldDetails.dataType || '';
      var defaultOperatorGroup = _Izenda.DEFAUFT_OPERATOR_GROUP[dataType.toLowerCase()];

      var sourceTypeByGroup = void 0;
      if (!sGroup.id) {
        sGroup = this.getGroupByKey(defaultOperatorGroup) || {};
        sOperator = sGroup.filterOperators && this.getOperatorByIndex(sGroup.id, dataType.toLowerCase());
      }

      sourceTypeByGroup = _Izenda.OPERATOR_VALUE_SOURCE[sGroup.key];
      sourceTypeByGroup = (0, _fp.isObject)(sourceTypeByGroup) ? sourceTypeByGroup[sOperator.key] : sourceTypeByGroup;

      return {
        group: sGroup,
        operator: sOperator,
        sourceTypeByGroup: sourceTypeByGroup
      };
    }

    /**
     * Get FilterInfoDisplayName
     * @param {number} position
     * @param {Array<FilterDetailsConfig>} operatorSource
     */

  }, {
    key: 'getFilterInfoDisplayName',
    value: function getFilterInfoDisplayName(position, operatorSource) {
      var fieldDetails = this.fieldDetails || {};
      var filterInfo = this.filterInfo || {};
      var filterValue = this.filterValue || [];
      var fieldDataType = fieldDetails.dataType;

      // For case value is a field source (Operator group = comparision)
      var valueObject = (0, _fp.find)({ querySourceFieldId: filterValue[0] }, this.operatorSourceValue) || {};

      // For case value is BLANK, NOTBLANK, TRUE, FALSE
      var operator = (0, _fp.find)({ id: filterInfo.operatorId }, this.operators) || {};
      var value = (0, _fp.includes)(operator.name, _Izenda.OPERATOR_VALUE_LIST) ? operator.name : filterValue;

      var applyFormater = (0, _fp.partial)(_Izenda6.default.applyFormater, [fieldDataType, (0, _fp.get)('dataFormat.format', fieldDetails), _fp.placeholder, null]);
      var isUsingGuid = (0, _fp.isArray)(value) && value.length === 1 && String.isGuidFormat(value[0]);

      if (isUsingGuid) {
        var isTimePeriod = filterInfo.sourceType === 'inTimePeriod';
        var isFieldComparison = filterInfo.sourceType === 'fieldSource';
        if (isTimePeriod || isFieldComparison) {
          var source = (0, _fp.flow)((0, _fp.find)(function (item) {
            return item.operatorSourceInfo.sourceType === filterInfo.sourceType;
          }), (0, _fp.get)('operatorSourceInfo.data'))(operatorSource);

          value = isFieldComparison ? (0, _fp.flow)((0, _fp.find)({ querySourceFieldId: value[0] }), (0, _fp.get)('sourceFieldName'))(source) : (0, _fp.flow)((0, _fp.find)({ id: value[0] }), (0, _fp.get)('name'))(source);
        } else {
          // For Field Compare
          value = valueObject.sourceFieldName;
        }
      } else if ((0, _fp.isArray)(value)) {
        value = (0, _fp.flow)((0, _fp.filter)((0, _fp.negate)(_fp.isEmpty)), (0, _fp.map)(applyFormater), (0, _fp.join)(', '))(value);
      } else {
        value = applyFormater(value);
      }

      var mapToUserContextVariable = function mapToUserContextVariable(val) {
        return val.replace('[Current User]', _Izenda8.default.currentUser.userName).replace('[Current Tenant]', _Izenda8.default.currentUser.tenantDisplayID || '[Current Tenant]').replace(/\[(User|Tenant|Role): (.+?)\]/g, '$2');
      };
      !(0, _fp.isEmpty)(value) && (value = mapToUserContextVariable(value));

      return (0, _fp.isEmpty)(fieldDetails.alias) || (0, _fp.isNil)(filterInfo.operator) ? null : ((0, _fp.isFinite)(position) ? position : fieldDetails.position) + '       ' + fieldDetails.alias + '       ' + filterInfo.operator.label + '       ' + value;
    }

    /**
     * Set field details
     * @param {Object} fieldDetails
     */

  }, {
    key: 'setFieldDetails',
    value: function setFieldDetails(fieldDetails) {
      fieldDetails = fieldDetails || {};
      // update field details && set config mode to new field
      this.selectedOperatorId = fieldDetails.operatorId;
      this.fieldDetails = fieldDetails;
      this.resetOperatorSourceValue();
    }

    /**
     * Set operator source(different operator need to call different API)
     * @param {string} sourceType
     * @param {Object} operatorSourceValue
     */

  }, {
    key: 'populateOperatorSourceValue',
    value: function populateOperatorSourceValue(sourceType, operatorSourceValue) {
      var filterSource = sourceType === 'fieldSource' ? (0, _fp.map)(function (item) {
        return !!item.sourceFieldVisible && {
          querySourceFieldId: (0, _fp.isNil)(item.relationshipId) ? item.querySourceFieldId : item.querySourceFieldId + '##' + item.relationshipId,
          sourceFieldName: item.sourceFieldName,
          sourceDataObjectName: item.sourceDataObjectName
        };
      }, operatorSourceValue) : operatorSourceValue;

      this.operatorSourceInfo.data = (0, _fp.compact)(filterSource);
      this.operatorSourceInfo.sourceType = sourceType;
    }

    /**
     * Populate existing filter values
     * @param {Object} existingConfigField
     */

  }, {
    key: 'populateExistingSourceValue',
    value: function populateExistingSourceValue(existingConfigField) {
      this.operatorSourceInfo = (0, _fp.get)('operatorSourceInfo', existingConfigField);
    }

    /**
     * Update operator source display
     * @param {boolean} isSearching
     */

  }, {
    key: 'updateOperatorSourceDisplay',
    value: function updateOperatorSourceDisplay(_ref6, isSearching) {
      var result = _ref6.result,
          isLastPage = _ref6.isLastPage;

      this.operatorSourceDisplay.isLastPage = isLastPage;
      isSearching && (this.operatorSourceDisplay.data = []);
      (0, _Izenda9.concatArray)(this.operatorSourceDisplay.data, convertData(result, this.filterValue), 'key', !isLastPage);

      return this.operatorSourceDisplay.data;

      function convertData(list, filterValue) {
        var isCheckAll = filterValue.length === 1 && filterValue[0] === _Izenda.DEFAUFT_VALUE.ALL;
        return list.map(function (value) {
          return (0, _mobx.observable)({
            key: value,
            value: value,
            label: value,
            checked: isCheckAll ? true : (0, _fp.includes)(value, filterValue)
          });
        });
      }
    }

    /**
     * Reset operator source display
     */

  }, {
    key: 'resetOperatorSourceDisplay',
    value: function resetOperatorSourceDisplay() {
      this.operatorSourceDisplay.data = [];
      this.operatorSourceDisplay.isLastPage = false;
    }

    /**
     * Reset operator source value
     */

  }, {
    key: 'resetOperatorSourceValue',
    value: function resetOperatorSourceValue() {
      this.operatorSourceInfo.data = [];
      this.operatorSourceInfo.sourceType = '';
    }

    /**
     * Set operator group id and reset operator Id (first item will be selectd)
     * @param {string} operatorGroupId
     */

  }, {
    key: 'setOperatorGroupId',
    value: function setOperatorGroupId(operatorGroupId) {
      // update operator - first item is selected by default
      var dataType = (0, _fp.getOr)('', 'dataType', this.fieldDetails);
      var operator = this.getOperatorByIndex(operatorGroupId, dataType.toLowerCase());
      this.setOperatorId(operator && operator.id);
      this.markDirty();
      this.markUpdateResult && this.markUpdateResult();
    }

    /**
     * Set operator Id and reset filter value (empty string) for subscription.
     * @param {Object} subData
     * @param {string} filterFieldId
     * @param {boolean} isDashboardDetail
     */

  }, {
    key: 'setOperatorIdSubscription',
    value: function setOperatorIdSubscription(subData, filterFieldId, isDashboardDetail, _ref7) {
      var selectedOperatorId = _ref7.selectedOperatorId;

      this.selectedOperatorId = selectedOperatorId;
      this.fieldDetails && this.fieldDetails.updateByKey('operatorId', selectedOperatorId);

      if (isDashboardDetail) {
        return this.setCommonOperatorIdSubscription(subData, filterFieldId, selectedOperatorId);
      }

      var filter = (0, _fp.find)(function (s) {
        return (0, _fp.isEqual)(s.filterFieldId, filterFieldId);
      }, subData.subscriptionFilterFields);

      if ((0, _fp.isNil)(filter)) {
        subData.subscriptionFilterFields.push({
          filterFieldId: filterFieldId,
          operatorId: selectedOperatorId,
          state: _Izenda2.INSERT
        });
      } else {
        var i = (0, _fp.indexOf)(filter, subData.subscriptionFilterFields);
        subData.subscriptionFilterFields[i].operatorId = selectedOperatorId;
        subData.subscriptionFilterFields[i].state !== _Izenda2.INSERT && (subData.subscriptionFilterFields[i].state = _Izenda2.UPDATE);
      }

      // reset filter value
      this.setFilterValue([]);
    }

    /**
     * Set operator Id and reset filter value (empty string) for subscription.
     * @param {string} commonFilterFieldId
     * @param {string} operatorId
     */

  }, {
    key: 'setCommonOperatorIdSubscription',
    value: function setCommonOperatorIdSubscription(_ref8, commonFilterFieldId, operatorId) {
      var subscriptionCommonFilterFields = _ref8.subscriptionCommonFilterFields;

      this.selectedOperatorId = operatorId;
      this.fieldDetails && this.fieldDetails.updateByKey('operatorId', operatorId);

      var filter = (0, _fp.find)(function (s) {
        return (0, _fp.isEqual)(s.commonFilterFieldId, commonFilterFieldId);
      }, subscriptionCommonFilterFields);

      if ((0, _fp.isNil)(filter)) {
        subscriptionCommonFilterFields.push({
          commonFilterFieldId: commonFilterFieldId,
          operatorId: operatorId,
          state: _Izenda2.INSERT
        });
      } else {
        var i = (0, _fp.indexOf)(filter, subscriptionCommonFilterFields);
        subscriptionCommonFilterFields[i].operatorId = operatorId;
        subscriptionCommonFilterFields[i].state !== _Izenda2.INSERT && (subscriptionCommonFilterFields[i].state = _Izenda2.UPDATE);
      }

      // reset filter value
      this.setFilterValue([]);
    }

    /**
     * Set operator Id and reset filter value (empty string)
     * @param {string} operatorId
     */

  }, {
    key: 'setOperatorId',
    value: function setOperatorId(operatorId) {
      this.selectedOperatorId = operatorId;
      this.fieldDetails && this.fieldDetails.updateByKey('operatorId', operatorId);
      var operatorName = (0, _fp.get)('operator.name', this.filterInfo);
      this.fieldDetails.updateByKey('operatorName', operatorName);
      // reset filter value
      this.setFilterValue([]);
    }
  }]);
  return FilterDetailsConfig;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'fieldDetails', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'commonData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return { operatorGroup: [] };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'selectedOperatorId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'operatorSourceInfo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      sourceType: '',
      data: []
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'operatorSourceDisplay', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      isLastPage: false,
      data: []
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'filterValue', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filterValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'operatorGroup', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'operatorGroup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'availableOperatorGroup', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'availableOperatorGroup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'operators', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'operators'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'operatorSourceValue', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'operatorSourceValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isUpdateSource', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isUpdateSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filterInfo', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filterInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'sourceFieldName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'sourceFieldName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'doesSupportDataSourceLazyLoading', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'doesSupportDataSourceLazyLoading'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setFieldDetails', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setFieldDetails'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateOperatorSourceValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateOperatorSourceValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateExistingSourceValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateExistingSourceValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateOperatorSourceDisplay', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateOperatorSourceDisplay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetOperatorSourceDisplay', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetOperatorSourceDisplay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetOperatorSourceValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetOperatorSourceValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setOperatorGroupId', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setOperatorGroupId'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setOperatorIdSubscription', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setOperatorIdSubscription'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setCommonOperatorIdSubscription', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setCommonOperatorIdSubscription'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setOperatorId', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setOperatorId'), _class2.prototype)), _class2)) || _class;

exports.default = FilterDetailsConfig;
module.exports = exports['default'];

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GridLayoutUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/**
 * Report utilities
 */

!function () {
  var _require = __webpack_require__(1),
      get = _require.get,
      some = _require.some,
      max = _require.max,
      map = _require.map,
      isNil = _require.isNil;
  /**
   * Check intersects
   * @param  {Object}   tile         Current Object need to check position
   * @param  {Array}    otherTiles   Other Object already on grid
   * @return {Boolean}
   */


  var checkIntersects = function checkIntersects(tile, otherTiles) {
    var aLeft = tile.positionX;
    var aRight = tile.positionX + tile.width - 1;
    var aTop = tile.positionY;
    var aBottom = tile.positionY + tile.height - 1;

    var colliding = function colliding(b) {
      var bLeft = b.positionX;
      var bRight = b.positionX + b.width - 1;
      var bTop = b.positionY;
      var bBottom = b.positionY + b.height - 1;

      return !(bLeft > aRight || bRight < aLeft || bTop > aBottom || bBottom < aTop);
    };

    return some(colliding, otherTiles);
  };

  module.exports = function (numbderOfColumn, defaultWidth, defaultHeight) {
    /**
     * Get default dimension of new tile
     * @param  {Array} tiles     List of existing object
     * @return {Object}
     */
    var getDefaultDimension = function getDefaultDimension(tiles) {
      var lastPositionY = max(map(function (item) {
        return item.positionY + (item.height || 3);
      }, tiles)) || 0;

      return {
        positionX: 0,
        positionY: lastPositionY,
        width: defaultWidth,
        height: defaultHeight
      };
    };

    /**
     * Get dimension of new tile
     * @param  {Object} left
     * @param  {String} top
     * @return {String}
     */
    var getDimension = function getDimension(otherTiles, left, top) {
      if (isNil(left) || isNil(top)) {
        return getDefaultDimension(otherTiles);
      }
      var dims = {
        positionX: left || 0,
        positionY: top || 0,
        width: 1,
        height: 1
      };

      while (!checkIntersects(dims, otherTiles) && dims.width < defaultWidth && dims.width + dims.positionX < numbderOfColumn) {
        dims.width++;
      }
      if (checkIntersects(dims, otherTiles)) {
        dims.width--;
      }
      while (!checkIntersects(dims, otherTiles) && dims.height < defaultHeight) {
        dims.height++;
      }
      if (checkIntersects(dims, otherTiles)) {
        dims.height--;
      }
      return dims;
    };

    /**
     * get avaiable position to add new item
     * @param  {Array} otherTiles   Existing objects
     * @param  {int} width          Defaullt width of new object
     * @param  {int} height         Default height of new object
     */
    var getAvaiablePosition = function getAvaiablePosition(otherTiles, width, height) {
      if (isNil(width) || isNil(height)) {
        return getDefaultDimension(otherTiles);
      }
      var dims = {
        positionX: 0,
        positionY: 0,
        width: width,
        height: height
      };

      // Check with row
      while (true) {
        dims.positionX = 0;
        // With position row n column m check avaiable position
        while (dims.positionX < numbderOfColumn - dims.width) {
          if (!checkIntersects(dims, otherTiles)) {
            break;
          }
          dims.positionX++;
        }
        if (!checkIntersects(dims, otherTiles)) {
          break;
        }
        dims.positionY++;
      }
      return dims;
    };

    return {
      getDefaultDimension: getDefaultDimension,
      checkIntersects: checkIntersects,
      getDimension: getDimension,
      getAvaiablePosition: getAvaiablePosition
    };
  };
}();

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AddUserPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AddUserPopup Component
 */
!function () {
  __webpack_require__(55);
  var CANCEL_TEXT = 'cancel';
  var ACCEPT_TEXT = 'accept';
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var PopupInput = __webpack_require__(309);
  var AddUserGrid = __webpack_require__(2000);
  var classnames = __webpack_require__(11);
  var Popup = __webpack_require__(36);
  var connect = __webpack_require__(2);
  var UserAccountStore = __webpack_require__(419);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      every = _require.every;

  var AddUserPopup = React.createClass({
    displayName: 'AddUserPopup',

    propTypes: {
      store: React.PropTypes.object,
      onChange: React.PropTypes.func.isRequired,
      selectedItems: React.PropTypes.array
    },

    componentWillMount: function componentWillMount() {
      this.userAccountStore = new UserAccountStore(this.props.loadUsers, this.props.userModeType);
    },

    componentDidMount: function componentDidMount() {
      var loader = this.props.loader;
      loader.startLoading();
      this.userAccountStore.loadAllUserAccounts().finally(loader.endLoading.bind(loader));
    },

    /**
     * Handle when popup closing
     * @param  {Object} closeCallback function
     * @param  {Object} type of close button click
     */
    onClosing: function onClosing(closeCallback, type) {
      var model = this.userAccountStore.model;
      var props = this.props;
      var userAccountList = model.userAccountList || [];

      var data = filter(function (userAccount) {
        return userAccount.selected;
      }, userAccountList);

      if (type === ACCEPT_TEXT) {
        // Validate selectedUser hasEmail
        if (props.validateEmails && !every('emailAddress', data)) {
          // get error message
          this.userAccountStore.validateEmails(data);
          return;
        }
        props.onChange(data);
        props.onAccept();
      } else if (type === CANCEL_TEXT) {
        props.onReject();
      }
    },

    /**
     * Render component
     * @return {[type]} [description]
     */
    render: function render() {
      var localization = this.props.localization;

      return React.createElement(
        Popup,
        { visible: true, onClosing: this.onClosing, autoClose: false, type: 'none', sizeClass: 'modal-lg' },
        React.createElement(Popup.Header, { title: localization.getText('USER_LABEL_ALL_USERS') }),
        React.createElement(
          Popup.Body,
          null,
          React.createElement(AddUserGrid, {
            store: this.userAccountStore,
            singleUser: this.props.singleUser,
            selectedItems: this.props.selectedItems
          })
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  });

  module.exports = connect()(AddUserPopup);

  module.exports.$popupName = 'AddUserPopup';
}();

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionFieldName.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var updateArray = __webpack_require__(272).updateArray;
  var sortArray = __webpack_require__(272).sortArray;
  var PagingModel = __webpack_require__(98);
  var AppGlobal = __webpack_require__(41);

  var _require = __webpack_require__(1),
      getOr = _require.getOr;

  function FieldName(detail) {
    this.id = detail.id;
    this.tempId = detail.tempId;
    this.name = detail.name;
    this.dataType = detail.dataType || detail.izendaDataType;
    this.description = detail.description || detail.expression;
    this.databaseName = detail.databaseName;
    this.schemaName = detail.schemaName;
    this.querySourceName = detail.querySourceName;
  }

  function DataSource(detail) {
    this.id = detail.id;
    this.name = detail.name;
    this.fieldNames = detail.fields;
    this.databaseName = detail.connectionName;
    this.schemaName = detail.querySourceCategoryName;
  }

  function ExpressionFieldName(data) {
    var colSortDir = {
      name: AppGlobal.advancedSettings.other.sortColumnNameValue ? null : 'ASC'
    };

    this.backupFieldNames = [];
    var props = {
      fieldNames: [], // array of FieldName
      selectedDataSource: {}, // data source object
      dataSources: [], // array of DataSource
      pageInfo: new PagingModel(colSortDir)
    };

    m.extendObservable(this, props);

    this.fetchData(data);
  }

  /**
   * Populate detail for object.
   * @param  {object} data
   */
  ExpressionFieldName.prototype.fetchData = function (data) {
    data = data || {};
    m.transaction(function () {
      this.fetchFieldNames(data.fieldNames);
      this.updateSelectedDataSource(data.selectedDataSource);
      this.fetchDataSources(data.dataSources);
    }.bind(this));
  };

  /**
   * Populate detail for field name list.
   * @param  {object} fieldNames
   */
  ExpressionFieldName.prototype.fetchFieldNames = function (fieldNames) {
    var createFieldName = function createFieldName(itemData) {
      return new FieldName(itemData);
    };

    updateArray(this.fieldNames, fieldNames, createFieldName);
    this.sort(this.fieldNames);
    updateArray(this.backupFieldNames, fieldNames, createFieldName);
  };

  /**
   * Populate detail for data source list.
   * @param  {object} dataSources
   */
  ExpressionFieldName.prototype.fetchDataSources = function (dataSources) {
    var createDataSource = function createDataSource(itemData) {
      return new DataSource(itemData);
    };

    updateArray(this.dataSources, dataSources, createDataSource);
  };

  /**
   * Populate selected data source.
   * @param  {object} datasource
   */
  ExpressionFieldName.prototype.updateSelectedDataSource = function (datasource) {
    this.selectedDataSource = datasource;
  };

  /**
   * Load id of selected data source.
   */
  ExpressionFieldName.prototype.getSelectedDataSourceId = function () {
    return getOr(null, 'id', this.selectedDataSource);
  };

  /**
   * Sort file name list.
   */
  ExpressionFieldName.prototype.sort = function () {
    this.pageInfo.buildPagingRequest();
    var sortOrders = this.pageInfo.sortOrders;

    var sortedFieldNames = [];
    if (!sortOrders) {
      sortedFieldNames = this.backupFieldNames;
    } else {
      sortedFieldNames = sortArray(this.fieldNames, sortOrders);
    }

    updateArray(this.fieldNames, sortedFieldNames, function (itemData) {
      return new FieldName(itemData);
    });
  };

  module.exports = ExpressionFieldName;
}();

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionFunctionOperator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var updateArray = __webpack_require__(272).updateArray;
  var sortArray = __webpack_require__(272).sortArray;
  var PagingModel = __webpack_require__(98);

  function FunctionDetail(detail) {
    this.name = detail.name;
    this.syntax = detail.syntax;
    this.expressionSyntax = detail.expressionSyntax;
  }

  function ExpressionFunctionOperator(data) {
    var colSortDir = {
      name: 'ASC'
    };
    this.backupFunctionOperators = [];

    var props = {
      functionOperators: [], // array of FunctionOperator
      pageInfo: new PagingModel(colSortDir)
    };

    m.extendObservable(this, props);

    this.fetchData(data);
  }

  ExpressionFunctionOperator.prototype.fetchData = function (data) {
    data = data || {};

    var createFunctionOperator = function createFunctionOperator(itemData) {
      return new FunctionDetail(itemData);
    };

    updateArray(this.functionOperators, data.functionOperators, createFunctionOperator);

    this.sort(this.functionOperators);

    updateArray(this.backupFunctionOperators, data.functionOperators, createFunctionOperator);
  };

  ExpressionFunctionOperator.prototype.sort = function () {
    this.pageInfo.buildPagingRequest();
    var sortOrders = this.pageInfo.sortOrders;

    var sortedFunctionOperators = [];
    if (!sortOrders) {
      sortedFunctionOperators = this.backupFunctionOperators;
    } else {
      sortedFunctionOperators = sortArray(this.functionOperators, sortOrders);
    }

    updateArray(this.functionOperators, sortedFunctionOperators, function (itemData) {
      return new FunctionDetail(itemData);
    });
  };

  module.exports = ExpressionFunctionOperator;
}();

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerDataSourceStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**s
 * Data Source View Model
 */

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(90);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(118);

var _Izenda8 = __webpack_require__(993);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ReportDesignerDataSourceStore = (_class = function () {
  (0, _createClass3.default)(ReportDesignerDataSourceStore, [{
    key: 'model',
    get: function get() {
      return this.reportStore.model.dataSource;
    }
  }, {
    key: 'dataSourceDetail',
    get: function get() {
      return this.model.dataSourceDetail;
    }
  }, {
    key: 'dataTree',
    get: function get() {
      return this.model.dataTree;
    }
  }, {
    key: 'tenantId',
    get: function get() {
      return _Izenda2.default.getTenantId();
    }
  }, {
    key: 'fieldsStoreDataTree',
    get: function get() {
      return this.reportStore.fieldsStore.dataTree.details;
    }
  }]);

  function ReportDesignerDataSourceStore(reportStore) {
    (0, _classCallCheck3.default)(this, ReportDesignerDataSourceStore);

    _initDefineProp(this, 'isAllQuerySourceUncategorized', _descriptor, this);

    // master store
    this.reportStore = reportStore;
    // Update isAllQuerySourceUncategorized only one time
    this.stopUpdateIsAllQuerySource = false;
    // this.lazyLoadingPartialPromise = Promise.resolve();
  }

  /**
   * Load Initial Data
   */


  (0, _createClass3.default)(ReportDesignerDataSourceStore, [{
    key: 'loadInitial',
    value: function loadInitial(reportId) {
      // Update selected query source if exist
      this.updateSelectedQuerySource().then(this.updateRelationshipsQuerySourceCategory.bind(this));

      // Get report mode
      var currentReportId = reportId ? reportId : this.reportStore.reportId;
      return _Izenda4.default.getReportMode(currentReportId).then(this.model.readReportMode.bind(this.model));
    }

    /**
     * Load Initial Data in case directed from report viewer
     */

  }, {
    key: 'loadInitialWithUpdateFilter',
    value: function loadInitialWithUpdateFilter(reportId) {
      // Check and call needed api only
      if ((0, _fp.isEmpty)(this.fieldsStoreDataTree)) {
        this.getFilterData();
        this.loadQuerySourceFieldsForUpdateRelationship(this.reportStore.reportId);
      }
      return this.loadInitial(reportId);
    }
  }, {
    key: 'updateSelectedQuerySource',
    value: function updateSelectedQuerySource() {
      var _this = this;

      if (this.fieldsStoreDataTree.length) {
        var availableQuerySources = this.fieldsStoreDataTree[0].querySource;

        if (this.model.reportMode === _Izenda6.default.SIMPLE) {
          this.setSelectedTreeFromFieldTree(availableQuerySources);
          return (0, _bluebird.resolve)();
        }

        var relationshipIds = (0, _fp.flow)((0, _fp.filter)({ dataSourceCategoryId: null }), (0, _fp.map)('id'))(availableQuerySources);

        // When switch from Fields to Data Source, get original query sources from join alias query sources
        return this.loadOriginalJoinAliasQuerySource(relationshipIds).then(function (originalQuerySources) {
          originalQuerySources && originalQuerySources.forEach(function (originalQuerySource) {
            var joinAliasQuerySource = (0, _fp.find)({ id: originalQuerySource.relationshipId }, availableQuerySources);

            // Set correct data for selected tree
            if (joinAliasQuerySource) {
              joinAliasQuerySource.selected = true;
              joinAliasQuerySource.id = originalQuerySource.querySourceId;
              joinAliasQuerySource.dataSourceCategoryId = originalQuerySource.dataSourceCategoryId;
              joinAliasQuerySource.dataSourceCategoryName = originalQuerySource.dataSourceCategoryName;
              joinAliasQuerySource.name = originalQuerySource.querySourceName;
            }
          });

          // Avoid duplicate when self-join
          availableQuerySources = (0, _fp.uniqBy)('id', availableQuerySources);
          _this.setSelectedTreeFromFieldTree(availableQuerySources);
        });
      }

      return (0, _bluebird.resolve)();
    }

    /**
     * Get data for filter when load data source in report designer
     */

  }, {
    key: 'getFilterData',
    value: function getFilterData() {
      var _this2 = this;

      var reportFilter = this.reportStore.model.reportFields.reportFilter;
      return _Izenda4.default.loadFilterOperatorGroup().then(function (querySource) {
        /* report filter */
        !(0, _fp.isNil)(querySource) && reportFilter.populateFilterQuerySource(querySource);
        reportFilter.configFieldList.forEach(function (configField) {
          if ((0, _fp.contains)(configField.filterInfo.sourceType, ['fieldSource', 'inTimePeriod']) || (0, _fp.contains)(configField.filterInfo.operator.key, ['equals(checkbox)', 'notequal(checkbox)'])) {
            _this2.getOperatorValueSource(configField);
          }
        });
      });
    }

    /**
     * Load available query source for update relationship on data source page.
     * @param  {string} reportId
     */

  }, {
    key: 'loadQuerySourceFieldsForUpdateRelationship',
    value: function loadQuerySourceFieldsForUpdateRelationship(reportId) {
      var _this3 = this;

      if (!(0, _fp.isNil)(reportId) && !(0, _fp.isEmpty)(reportId)) {
        _Izenda4.default.availableQuerySourceFields(reportId, this.reportStore.isLoadDraft).then(function (result) {
          if (!(0, _fp.isNil)(result)) {
            result.isFromDataSource = true;
            _this3.dataTree.readDataSource(result);
            _this3.reportStore.fieldsStore.dataTree.details = result;
            // Update selected query source if exist
            _this3.updateSelectedQuerySource().then(_this3.updateRelationshipsQuerySourceCategory.bind(_this3));
          }
        });
      }
    }

    /**
     * Set selected tree
     * @param {array} availableQuerySources
     */

  }, {
    key: 'setSelectedTreeFromFieldTree',
    value: function setSelectedTreeFromFieldTree(availableQuerySources) {
      this.dataTree.selectedTree = (0, _fp.flow)((0, _fp.groupBy)('dataSourceCategoryId'), (0, _fp.map)(function (value) {
        var firstItem = (0, _fp.head)(value);
        return {
          id: firstItem.dataSourceCategoryId,
          name: firstItem.dataSourceCategoryName,
          querySource: value
        };
      }))(availableQuerySources);
    }

    /**
     * Load original join alias query source
     * @param {array} relationshipIds
     */

  }, {
    key: 'loadOriginalJoinAliasQuerySource',
    value: function loadOriginalJoinAliasQuerySource(relationshipIds) {
      if ((0, _fp.isEmpty)(relationshipIds)) {
        return (0, _bluebird.resolve)(null);
      }
      var data = {
        reportKey: {
          key: this.reportStore.model.reportId
        },
        tenantId: _Izenda2.default.getTenantId(),
        relationshipIds: relationshipIds
      };
      return _Izenda4.default.loadJoinQuerySourceByRelationship(data);
    }

    /**
     * toggle Selected/Unselected item
     * @param {type} dataObject
     * @param {type} isSelected
     */

  }, {
    key: 'updateSelected',
    value: function updateSelected(dataObject, isSelected) {
      dataObject.selected = isSelected;
      // only remove relationships when user unchecking dataObject
      !isSelected && this.dataSourceDetail.removeUncheckRelationships(dataObject);
      return (0, _bluebird.resolve)(dataObject);
    }

    /**
     * Build page info
     * @return {Object}
     */

  }, {
    key: 'buildPageInfo',
    value: function buildPageInfo() {
      var pageInfo = this.dataSourceDetail.pageInfo;
      pageInfo.buildPagingRequest();
      return pageInfo;
    }

    /**
     * Check has item selected
     * @param {type} selectedQuerySource
     */

  }, {
    key: 'checkRemoveSelectedRelation',
    value: function checkRemoveSelectedRelation(dataObject) {
      // Remove parameter in filter section
      this.model.removeFilterParams(dataObject);

      return (0, _bluebird.resolve)({
        hasRemovedRelationship: (0, _Izenda8.hasRemovedRelationship)(this.dataTree, this.dataSourceDetail.dataSourceGrid, dataObject),
        dataObject: dataObject
      });
    }

    /**
     * Load Data Source Detail
     * @param {Object} dataObject
     * @param {Boolean} isSelectingDataObject: is selecting dataObject or not
     */

  }, {
    key: 'loadDataSourceDetail',
    value: function loadDataSourceDetail(dataObject, isSelectingDataObject) {
      var selectedQuerySource = [];

      if (dataObject) {
        selectedQuerySource = this.dataTree.getDataTreeItems(dataObject);
      } else if (this.dataTree) {
        selectedQuerySource = this.dataTree.getDataTreeItems();
      }

      if ((0, _fp.isEmpty)(selectedQuerySource)) {
        return (0, _bluebird.resolve)();
      }

      return this.loadDataSource(selectedQuerySource, dataObject, isSelectingDataObject);
    }

    /**
     * Search Data Source
     */

  }, {
    key: 'searchDataSource',
    value: function searchDataSource() {
      var selectedItems = this.dataTree.getDataTreeItems(null);
      this.loadDataSource(selectedItems);
    }

    /**
     * Load Data Source
     * @param {type} selectedQuerySource
     */

  }, {
    key: 'loadDataSource',
    value: function loadDataSource(selectedQuerySource, changedDataObject, isSelectingDataObject) {
      var _this4 = this;

      var populateDataSource = (0, _mobx.action)(function (dataSourceDetail) {
        return _this4.dataSourceDetail.populateData(dataSourceDetail, changedDataObject, _this4.model.reportMode, isSelectingDataObject);
      });

      return (0, _Izenda8.loadRelationship)(this.reportStore.model.reportId, this.model.reportMode, selectedQuerySource, this.buildPageInfo(), (0, _fp.isBoolean)(isSelectingDataObject), this.model.reportMode === _Izenda6.default.ADVANCED ? this.dataSourceDetail.getDbRelationshipIds() : []).bind(this).then(populateDataSource);
    }

    /**
     * Update category of query source in relationship, when category had been changed in data model
     */

  }, {
    key: 'updateRelationshipsQuerySourceCategory',
    value: function updateRelationshipsQuerySourceCategory() {
      var _this5 = this;

      if (!(0, _fp.isEmpty)(this.dataTree.selectedTree) && !(0, _fp.isEmpty)(this.dataSourceDetail.dataSourceGrid)) {
        var selectedQuerySources = this.dataTree.getSelectedQuerySources();

        selectedQuerySources.forEach(function (querySource) {
          var querySourceId = querySource.id,
              dataSourceCategoryId = querySource.dataSourceCategoryId,
              dataSourceCategoryName = querySource.dataSourceCategoryName;

          _this5.dataSourceDetail.dataSourceGrid.forEach(function (relationship) {
            // Update data source category of join query source
            if (relationship.joinQuerySourceId === querySourceId && relationship.joinDataSourceCategoryId !== dataSourceCategoryId) {
              relationship.joinDataSourceCategoryId = dataSourceCategoryId;
              relationship.joinDataSourceCategoryName = dataSourceCategoryName;
            }
            // Update data source category of foreign query source
            if (relationship.foreignQuerySourceId === querySourceId && relationship.foreignDataSourceCategoryId !== dataSourceCategoryId) {
              relationship.foreignDataSourceCategoryId = dataSourceCategoryId;
              relationship.foreignDataSourceCategoryName = dataSourceCategoryName;
            }
          });
        });
      }
    }

    /**
     * Go to page
     * @param {type} pageIndex
     */

  }, {
    key: 'goToPage',
    value: function goToPage(pageIndex) {
      this.dataSourceDetail.pageInfo.setPageIndex(pageIndex);

      this.loadDataSourceDetail();
    }

    /**
     * Start Loading Relationship
     */

  }, {
    key: 'startLoadingRelationship',
    value: function startLoadingRelationship() {
      return (0, _Izenda8.startLoadingRelationship)(this.dataSourceDetail);
    }

    /**
     * End Loading Relationship
     */

  }, {
    key: 'endLoadingRelationship',
    value: function endLoadingRelationship() {
      return (0, _Izenda8.endLoadingRelationship)(this.dataSourceDetail);
    }

    /**
     * LazyLoading QuerySource
     * @param  {Object}  pageInfo
     * @param  {Boolean} isReset
     * @return {Promise}
     */

  }, {
    key: 'lazyLoadingQuerySource',
    value: function lazyLoadingQuerySource(pageInfo, isReset, searchKey) {
      searchKey = searchKey || this.dataTree.filterText;
      var querySources = this.dataTree.getDataTreeItems();

      if (this.model.reportMode === _Izenda6.default.SIMPLE && (0, _fp.some)('selected', querySources)) {
        return this.lazyLoadingQuerySourceSimpleMode(searchKey);
      }

      return this.lazyLoadingDataSourceCategory(pageInfo, isReset, searchKey);
    }

    /**
     * LazyLoading QuerySource Simple Mode
     * @return {Promise}
     */

  }, {
    key: 'lazyLoadingQuerySourceSimpleMode',
    value: function lazyLoadingQuerySourceSimpleMode(searchKey) {
      var _this6 = this;

      if (this.model.reportMode === _Izenda6.default.ADVANCED) {
        return (0, _bluebird.resolve)();
      }

      // Cancel pending load partial promise when load related query source
      // if (this.lazyLoadingPartialPromise.isPending()) {
      //   this.lazyLoadingPartialPromise.cancel();
      // }

      var reportId = this.reportStore.model.reportId;
      var querySources = this.dataTree.getDataTreeItems();

      if (!(0, _fp.some)('selected', querySources)) {
        return this.lazyLoadingDataSourceCategory(null, true, searchKey);
      }

      var param = {
        objectId: reportId,
        querySources: querySources,
        tenantId: _Izenda2.default.getTenantId(),
        criteria: [{
          key: 'Name',
          value: searchKey
        }]
      };

      return _Izenda4.default.loadRelatedQuerySources(param).then(function (_ref) {
        var data = _ref.data,
            isLastPage = _ref.isLastPage,
            numOfChilds = _ref.numOfChilds;

        return _this6.processTreeData(data, isLastPage, numOfChilds, true);
      });
    }

    /**
     * LazyLoading DataSource Category
     * @param  {Object}  pageInfo
     * @param  {Boolean} isReset
     * @return {Promise}
     */

  }, {
    key: 'lazyLoadingDataSourceCategory',
    value: function lazyLoadingDataSourceCategory(pageInfo, isReset, searchKey) {
      var _this7 = this;

      pageInfo = pageInfo || this.lazyLoadingStore.pageInfoForFirstTime;

      var param = {
        tenantId: _Izenda2.default.getTenantId(),
        reportKey: {
          key: this.reportStore.model.reportId
        },
        criteria: [{
          key: 'Name',
          value: searchKey
        }],
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        parentIds: pageInfo.parentIds
      };

      var lazyLoadingPartialPromise = _Izenda4.default.loadPartialDataSourceCategory(param);
      return lazyLoadingPartialPromise.then(function (_ref2) {
        var data = _ref2.data,
            isLastPage = _ref2.isLastPage,
            numOfChilds = _ref2.numOfChilds;

        if ((0, _fp.toString)(searchKey) === (0, _fp.toString)(_this7.dataTree.filterText)) {
          return _this7.processTreeData(data, isLastPage, numOfChilds, isReset);
        } else {
          return (0, _bluebird.resolve)();
        }
      });
    }

    /**
     * Process TreeData
     * @param  {Object}  data
     * @param  {Boolean} isLastPage
     * @param  {Number}  numOfChilds
     * @param  {Boolean} isReset
     * @return {Object}
     */

  }, {
    key: 'processTreeData',
    value: function processTreeData(data, isLastPage, numOfChilds, isReset) {
      var dataTree = this.dataTree;
      var newDetails = dataTree.convertDataSource(data);
      dataTree.isLastPage = isLastPage;

      if (isReset) {
        dataTree.details = [];
        dataTree.displayData = [];
      }

      (0, _Izenda7.concatTree)(dataTree.details, newDetails, _Izenda6.default.DATA_SOURCE_CONCAT_TREE_MAP, numOfChilds, []);

      (0, _Izenda7.updateTree)(dataTree.details, dataTree.selectedTree, _Izenda6.default.DATA_SOURCE_CONCAT_TREE_MAP, ['selected']);

      dataTree.displayData = (0, _Izenda7.parseToTree)(dataTree.details, dataTree.filterText ? _Izenda6.default.DATA_SOURCE_TREE_MAP_FOR_SEARCH : _Izenda6.default.DATA_SOURCE_TREE_MAP);

      if (!this.stopUpdateIsAllQuerySource) {
        this.stopUpdateIsAllQuerySource = true;
        this.isAllQuerySourceUncategorized = (0, _fp.every)(function (cat) {
          return cat.id === _Izenda6.default.EMPTY_GUID;
        }, dataTree.details);
      }

      return data;
    }

    /**
     * Register LazyLoading Store
     * @param  {Object} store
     */

  }, {
    key: 'registerLazyLoadingStore',
    value: function registerLazyLoadingStore(store) {
      this.lazyLoadingStore = store;
    }

    /**
     * Update Dynamic QuerySource Fields
     * @return {Promise}
     */

  }, {
    key: 'updateDynamicQuerySourceFields',
    value: function updateDynamicQuerySourceFields() {
      var _this8 = this;

      var param = {
        tenantId: _Izenda2.default.getTenantId(),
        reportKey: {
          key: this.reportStore.model.reportId
        }
      };

      return _Izenda4.default.loadDynamicDataSourceCategory(param).then(function (_ref3) {
        var data = _ref3.data,
            isLastPage = _ref3.isLastPage,
            numOfChilds = _ref3.numOfChilds;

        // Update field in selected tree
        _this8.updateDynamicQuerySourceInSelectedTree(data);
        return _this8.processTreeData(data, isLastPage, numOfChilds);
      });
    }

    /**
     * UpdateDynamicQuerySourceInSelectedTree
     * @param  {Object} data
     */

  }, {
    key: 'updateDynamicQuerySourceInSelectedTree',
    value: function updateDynamicQuerySourceInSelectedTree(data) {
      var selectedTree = this.dataTree.selectedTree;


      data.forEach(function (resultCategory) {
        var selectedCategory = (0, _fp.find)({ id: resultCategory.id }, selectedTree);
        if (selectedCategory) {
          resultCategory.querySource.forEach(function (resultQuerySource) {
            var selectedQuerySource = (0, _fp.find)({ id: resultQuerySource.id }, selectedCategory.querySource);
            selectedQuerySource && (selectedQuerySource.fields = resultQuerySource.fields);
          });
        }
      });
    }

    /**
     * Update selected tree
     * @param  {Object}  dataSource
     * @param  {Boolean}  status
     * @param  {Boolean} isSearching
     * @return {Promise}
     */

  }, {
    key: 'updateSelectedTree',
    value: function updateSelectedTree(dataSource, status, isSearching) {
      var selectedTree = this.dataTree.selectedTree;
      var dataSourceCategoryId = dataSource.dataSourceCategoryId,
          dataSourceCategoryName = dataSource.dataSourceCategoryName;
      var reportMode = this.model.reportMode,
          reportId = this.reportStore.model.reportId;


      var existedCategoryNode = (0, _fp.find)({ id: dataSourceCategoryId }, selectedTree);
      var querySourceClone = (0, _assign2.default)({}, dataSource, {
        selected: status,
        aliasId: dataSource.aliasId,
        isStoreProcedure: dataSource.isStoreProcedure
      });

      var didAddNewQuerySource = false;

      if (existedCategoryNode) {
        var existedQueryNode = (0, _fp.find)({ id: dataSource.id }, existedCategoryNode.querySource);
        // Should not delete query source from this tree as it will make relationship go wrong
        // Mark unselect status to tell loadRelationships API that we unselected those fields
        // loadRelationships API cannot change since it was published
        if (existedQueryNode) {
          existedQueryNode.selected = status;
        } else {
          existedCategoryNode.querySource.push(querySourceClone);
          didAddNewQuerySource = true;
        }
      } else {
        var newCategoryNode = {
          id: dataSourceCategoryId,
          name: dataSourceCategoryName,
          querySource: [querySourceClone]
        };

        selectedTree.push(newCategoryNode);
        didAddNewQuerySource = true;
      }

      // When new query source is add to the tree, load its fields
      // Only load when user is searching and advanced mode (for relationship), otherwise use data source fields
      if (didAddNewQuerySource && isSearching && reportMode === _Izenda6.default.ADVANCED) {
        var param = {
          reportKey: {
            key: reportId
          },
          tenantId: _Izenda2.default.getTenantId(),
          querySourceId: querySourceClone.id
        };
        return _Izenda4.default.loadDataSourceFields(param).then(function (fields) {
          querySourceClone.fields = fields;
        });
      }

      return (0, _bluebird.resolve)();
    }

    /**
     * Handle change selected querySource
     * @param  {Object} dataObject
     * @param  {Boolean} state
     * @param  {TreeNode} node
     * @return {Promise}
     */

  }, {
    key: 'handleChangeSelectedQuerySource',
    value: function handleChangeSelectedQuerySource(dataObject, state, node) {
      this.updateSelected(dataObject, state);

      if (!state && dataObject.isDynamic && !(0, _fp.every)('isParameter', dataObject.fields)) {
        dataObject.fields = (0, _fp.filter)('isParameter', dataObject.fields);
        node.childNodes = (0, _fp.filter)(function (node) {
          return node.source.isParameter;
        }, node.childNodes);
      }

      return (0, _bluebird.all)([this.updateSelectedTree(dataObject, state, !(0, _fp.isEmpty)(this.dataTree.filterText)), this.loadDataSourceDetail(dataObject, state), this.lazyLoadingQuerySourceSimpleMode(this.dataTree.filterText)]);
    }

    /**
     * Reset data source grid dirty
     */

  }, {
    key: 'resetDataSourceGridDirty',
    value: function resetDataSourceGridDirty() {
      this.dataSourceDetail.resetDataSourceGridDirty();
    }
  }]);
  return ReportDesignerDataSourceStore;
}(), (_applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'model'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'dataSourceDetail', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'dataSourceDetail'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'dataTree', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'dataTree'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tenantId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fieldsStoreDataTree', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fieldsStoreDataTree'), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, 'isAllQuerySourceUncategorized', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'loadInitial', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadInitial'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadInitialWithUpdateFilter', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadInitialWithUpdateFilter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateSelectedQuerySource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateSelectedQuerySource'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateSelected', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateSelected'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'buildPageInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'buildPageInfo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'checkRemoveSelectedRelation', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'checkRemoveSelectedRelation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadDataSource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadDataSource'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRelationshipsQuerySourceCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRelationshipsQuerySourceCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'goToPage', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'goToPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'lazyLoadingQuerySource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'lazyLoadingQuerySource'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'lazyLoadingQuerySourceSimpleMode', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'lazyLoadingQuerySourceSimpleMode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'lazyLoadingDataSourceCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'lazyLoadingDataSourceCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'processTreeData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'processTreeData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDynamicQuerySourceInSelectedTree', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateDynamicQuerySourceInSelectedTree'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateSelectedTree', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateSelectedTree'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleChangeSelectedQuerySource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleChangeSelectedQuerySource'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetDataSourceGridDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetDataSourceGridDirty'), _class.prototype)), _class);
exports.default = ReportDesignerDataSourceStore;
module.exports = exports['default'];

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = __webpack_require__(18);

var _slicedToArray2 = __webpack_require__(416);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(92);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(111);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(227);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(192);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(15);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var AccessStore = (_class = function () {
  // List available role can grant access
  function AccessStore(model, documentId, accessMode) {
    (0, _classCallCheck3.default)(this, AccessStore);

    _initDefineProp(this, 'model', _descriptor, this);

    _initDefineProp(this, 'documentId', _descriptor2, this);

    _initDefineProp(this, 'accessMode', _descriptor3, this);

    _initDefineProp(this, 'accessFor', _descriptor4, this);

    _initDefineProp(this, 'roles', _descriptor5, this);

    _initDefineProp(this, 'users', _descriptor6, this);

    _initDefineProp(this, 'tenantId', _descriptor7, this);

    this.isGlobal = false;
    this.model = model;
    this.documentId = documentId;
    this.accessMode = accessMode;
  }

  /**
   * Load access for search/sort...
   * @param {string}    report Id
   * @param {object}    access data
   * @return {object} Promise
   */
  // List available user can grant access


  (0, _createClass3.default)(AccessStore, [{
    key: 'loadAllAccess',
    value: function loadAllAccess(documentId, data) {
      var _this = this;

      var model = this.model;
      model.pageInfo.buildPagingRequest();
      var dataFetcher = this.accessMode === _Izenda2.default.ACCESS_MODE.DASHBOARD ? _Izenda8.default : _Izenda4.default;

      return dataFetcher.loadAccesses(documentId, data, model.pageInfo).then((0, _mobx.action)(function (access) {
        _this.model.populateAccessDetails(access);
        return (0, _bluebird.resolve)(true);
      }));
    }

    /**
     * Handle when page size change
     * @param {int}    page number
     * @return {object} Promise
     */

  }, {
    key: 'onPageSizeChange',
    value: function onPageSizeChange(pageSize) {
      this.model.pageInfo.setPageSize(pageSize);
      return this.goToPage(1);
    }

    /**
     * Handle go to page
     * @param  {int} pageIndex
     * @return {object} Promise
     */

  }, {
    key: 'goToPage',
    value: function goToPage(pageIndex) {
      var pageInfo = this.model.pageInfo;
      pageInfo.setPageIndex(pageIndex);
      this.model.mergeWithReportDraftAccess();
      return this.loadAllAccess(this.documentId, this.model.draftAccesses);
    }

    /**
     * Search subscription
     * @param  {string} searchProperty
     * @param  {string} searchText
     * @return {object} Promise
     */

  }, {
    key: 'search',
    value: function search(searchProperty, searchText) {
      this.model.pageInfo.setSearchValues(searchProperty, searchText);
      return this.goToPage(1);
    }

    /**
     * Change sort orders
     * @param {string} columnKey
     * @param {object} sortDir
     * @return {object} Promise
     */

  }, {
    key: 'onSortChange',
    value: function onSortChange(columnKey, sortDir) {
      this.model.pageInfo.setColSortDirs(columnKey, sortDir);
      this.model.mergeWithReportDraftAccess();
      return this.loadAllAccess(this.documentId, this.model.draftAccesses);
    }

    /**
     * Update filter criteria information.
     * @param {String} searchProperty
     * @param {String} searchText
     */

  }, {
    key: 'updateSearchCriteria',
    value: function updateSearchCriteria(searchProperty, searchText) {
      this.model.pageInfo.setSearchValues(searchProperty, searchText);
    }

    /**
     * Get all data for report/dashboard access page
     * @param  {string} documentId report id
     * @param  {object} data        current access
     * @return {object}             Promise
     */

  }, {
    key: 'initialAccessReportPage',
    value: function initialAccessReportPage(documentId, data, isGlobal) {
      var _this2 = this;

      var model = this.model;
      model.pageInfo.buildPagingRequest();
      this.isGlobal = isGlobal;

      return (0, _bluebird.join)(_Izenda6.default.loadAccessRight(_Izenda2.default.ACCESS_MODE.REPORT), _Izenda4.default.loadAccesses(documentId, data, model.pageInfo), (0, _mobx.action)(function (accessRights, access) {
        _this2.model.populateAccessDetails(access);
        _this2.model.populateAccessRight(accessRights);
      }));
    }

    /**
     * Update report/dashboardId Id after save or save draft report
     * @param  {string} documentId report/dashboard id
     */

  }, {
    key: 'updateReporId',
    value: function updateReporId(documentId) {
      this.documentId = documentId;
    }

    /**
     * Load data for dashboard
     * @param  {string}   dashboarddId
     * @param  {string}   accessMode
     * @param  {boolean}  isGlobal
     * @param  {boolean}  isNew
     * @return {object}   Promise result
     */

  }, {
    key: 'initialAccessDashboardPage',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dashboardId, accessMode, isGlobal, isNew) {
        var model, fetcherFn, _ref2, _ref3, access, accessRights, result;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                model = this.model;

                model.pageInfo.buildPagingRequest();
                this.isGlobal = isGlobal;
                this.documentId = dashboardId;

                fetcherFn = isNew ? _Izenda6.default.loadDefaultAccess(1) : _Izenda8.default.loadAccesses(dashboardId, null, model.pageInfo);
                _context.next = 7;
                return (0, _bluebird.all)([fetcherFn, _Izenda6.default.loadAccessRight(_Izenda2.default.ACCESS_MODE.DASHBOARD)]);

              case 7:
                _ref2 = _context.sent;
                _ref3 = (0, _slicedToArray3.default)(_ref2, 2);
                access = _ref3[0];
                accessRights = _ref3[1];
                result = isNew ? { result: access } : access;

                model.populateAccessRight(accessRights);
                model.populateAccessDetails(result);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initialAccessDashboardPage(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return initialAccessDashboardPage;
    }()

    /**
     * Populate roles list
     * @param  {array} roles
     */

  }, {
    key: 'populateRoles',
    value: function populateRoles(roles) {
      this.roles = (0, _fp.map)(function (role) {
        return {
          id: role.id,
          name: role.name,
          notAllowSharing: role.notAllowSharing,
          tenantId: role.tenantId
        };
      }, roles);
    }

    /**
     * Populate avaiable users can grant access
     * @param  {array} users
     */

  }, {
    key: 'populateUsers',
    value: function populateUsers(users) {
      this.users = (0, _fp.map)(function (user) {
        var searchName = (0, _fp.isNil)(user.emailAddress) || (0, _fp.isEmpty)(user.emailAddress) ? String.format('{0} {1}', user.firstName, user.lastName) : String.format('{0} {1} ({2})', user.firstName, user.lastName, user.emailAddress);

        return {
          id: user.id,
          userName: user.userName,
          firstName: user.firstName,
          lastName: user.lastName,
          fullName: String.format('{0} {1}', user.firstName, user.lastName),
          searchName: searchName,
          emailAddress: user.emailAddress,
          notAllowSharing: user.notAllowSharing,
          isCurrentUser: user.id === _Izenda10.default.currentUser.id
        };
      }, users);
    }

    /**
     * Validate access list when change global checkbox
     * @param  {Boolean}  isGlobal
     * @param  {Boolean}  isReport
     * @return {Boolean or String}  result or warning message
     */

  }, {
    key: 'validateAccessListOnUpdateGlobalReport',
    value: function validateAccessListOnUpdateGlobalReport(isGlobal, isReport) {
      var model = this.model;
      this.isGlobal = isGlobal;

      if (isGlobal && model.hasAsLeastAccessHasUserSelect) {
        return isReport ? _Izenda2.default.MESSAGE.REMOVE_USER : _Izenda2.default.MESSAGE.REMOVE_DASHBOARD_USER;
      }

      if (!isGlobal && model.hasAsLeastAccessHasRoleSelect) {
        return isReport ? _Izenda2.default.MESSAGE.REMOVE_ROLE : _Izenda2.default.MESSAGE.REMOVE_DASHBOARD_ROLE;
      }

      return false;
    }

    /**
     * Update list accessor
     * @param{Boolean} isGlobal
     */

  }, {
    key: 'updateListAccessor',
    value: function updateListAccessor(isGlobal) {
      // Clear all sharing with user if change to global
      isGlobal && this.model.clearAllUserAccessor();

      // Clean all global roles on access detail.
      !isGlobal && this.model.removeAllGlobalRolesOnAccessor();
    }

    /**
     * Get role option
     * @param  {Boolean} isGlobal
     * @return {Object}
     */

  }, {
    key: 'getRoleOption',
    value: function getRoleOption() {
      return this.accessMode === _Izenda2.default.ACCESS_MODE.DASHBOARD ? {
        dashboardId: this.documentId,
        tenantId: this.tenantId,
        isGlobal: this.isGlobal
      } : {
        reportId: this.documentId,
        tenantId: this.tenantId,
        isGlobal: this.isGlobal
      };
    }
  }]);
  return AccessStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'documentId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'accessMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'accessFor', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'roles', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'users', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda10.default.getTenantId();
  }
}), _applyDecoratedDescriptor(_class.prototype, 'initialAccessDashboardPage', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initialAccessDashboardPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateListAccessor', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateListAccessor'), _class.prototype)), _class);
exports.default = AccessStore;
module.exports = exports['default'];

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.ChartBorderSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * ChartBorderSettings Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(34);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(193);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(596);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartBorderSettings = (_dec = (0, _Izenda9.exportClass)('ChartBorderSettings'), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(ChartBorderSettings, _React$Component);

  function ChartBorderSettings(props) {
    (0, _classCallCheck3.default)(this, ChartBorderSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChartBorderSettings.__proto__ || (0, _getPrototypeOf2.default)(ChartBorderSettings)).call(this, props));

    _this.getDefaultValue = function () {
      return {
        'izEntire.borderWidth': 0,
        'izEntire.borderColor': _Izenda2.default.borderColor
      };
    };

    _this.onChangeValue = function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
      var groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
      var fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      var borderWidth = schemaData.borderWidth.value;
      var isVisible = schemaData.visible.value;

      if (isVisible) {
        borderWidth = changedKey === 'visible' && !borderWidth ? _Izenda2.default.borderWidth : borderWidth;
      } else {
        borderWidth = 0;
      }

      _this.setState({
        visible: isVisible,
        borderWidth: borderWidth,
        borderColor: schemaData.borderColor.value,
        borderStyle: schemaData.borderStyle.value
      });
    };

    _this.getValue = function () {
      var state = _this.state;

      return {
        'izEntire.borderWidth': state.visible ? state.borderWidth : 0,
        'izEntire.borderColor': state.borderColor,
        'izEntire.borderStyle': state.borderStyle
      };
    };

    _this.getSchema = function (state) {
      return {
        schemaKey: 'BORDER_SCHEMA',
        fields: {
          // visible
          visible: {
            title: _Izenda6.default.getText('COMMON_LABEL_VISIBLE'),
            type: 'checkbox',
            controlClassName: 'u_controlHeight'
          },

          // color
          borderColor: {
            title: _Izenda6.default.getText('COMMON_LABEL_COLOR'),
            type: 'color',
            props: {
              disabled: !state.visible
            }
          },

          // border style
          borderStyle: {
            title: _Izenda6.default.getText('BORDER_SETTING_LABEL_DASH_STYLE'),
            component: 'DashStyle',
            props: {
              disabled: !state.visible
            }
          },

          // thickness
          borderWidth: {
            title: _Izenda6.default.getText('BORDER_SETTING_LABEL_THICKNESS'),
            component: __webpack_require__(190),
            props: {
              disabled: !state.visible
            }
          }
        }
      };
    };

    _this.allChartProps = (0, _mobx.toJS)(props.allChartProps);
    var value = props && props.value || {};

    _this.state = {
      visible: !!value['izEntire.borderWidth'],
      borderWidth: value['izEntire.borderWidth'],
      borderColor: value['izEntire.borderColor'] || _Izenda2.default.borderColor,
      borderStyle: value['izEntire.borderStyle'] || _Izenda2.default.defaultDashStyles
    };
    return _this;
  }

  (0, _createClass3.default)(ChartBorderSettings, [{
    key: 'render',
    value: function render() {
      var state = this.state;
      var chartOptions = {
        commonOptions: {
          'izEntire.borderWidth': state.borderWidth,
          'izEntire.borderColor': state.borderColor,
          'izEntire.borderStyle': state.borderStyle
        }
      };

      var configurationDef = {
        source: state,
        widgets: { DashStyle: _Izenda8.default },
        definedSchema: this.getSchema(state),
        onChangeValue: this.onChangeValue
      };

      return _react2.default.createElement(_Izenda4.default, {
        type: this.props.reportPartType,
        configurationDef: configurationDef,
        chartOptions: chartOptions,
        allChartProps: this.allChartProps
      });
    }
  }]);
  return ChartBorderSettings;
}(_react2.default.Component)) || _class);
exports.default = ChartBorderSettings;
module.exports = exports['default'];

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashStyleDropdown.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 *  DashStyleDropdown component
 */
!function () {
  var React = __webpack_require__(0);
  var m = __webpack_require__(10);

  var UIConstants = __webpack_require__(34);
  var FloatAffixed = __webpack_require__(154);
  var classnames = __webpack_require__(11);

  var DashStyleDropdown = React.createClass({
    displayName: 'DashStyleDropdown',


    propsType: {
      value: React.PropTypes.object,
      onChange: React.PropTypes.func
    },

    getInitialState: function getInitialState() {
      return {
        isOpen: false
      };
    },

    getDefaultProps: function getDefaultProps() {
      return {
        value: UIConstants.defaultDashStyles
      };
    },

    onChange: function onChange(value) {
      this.props.onChange && this.props.onChange(value);
      this.hideDashStyles();
    },

    showDashStyles: function showDashStyles() {
      this.setState({ isOpen: !this.state.isOpen });
    },

    hideDashStyles: function hideDashStyles() {
      this.setState({ isOpen: false });
    },

    render: function render() {
      var listStyles = UIConstants.dashStyles.map(function (item) {
        return React.createElement(
          'div',
          { className: 'izenda-Dropdown-option',
            value: item,
            onClick: this.onChange.bind(this, item),
            key: item },
          React.createElement('div', { className: item })
        );
      }.bind(this));

      var selectItem = this.props.value ? this.props.value + ' review-icon' : 'dotted review-icon';
      var classes = classnames('izenda-DashStyleDropDown u_controlHeight', {
        'disabled-elm': this.props.disabled
      });

      return React.createElement(
        'div',
        { className: classes },
        React.createElement(
          'div',
          { ref: 'dashStyle', className: 'line-style', onMouseDown: this.showDashStyles },
          React.createElement('div', { className: selectItem }),
          React.createElement('i', { className: 'icon-triangle-down' })
        ),
        this.state.isOpen && React.createElement(
          FloatAffixed,
          {
            anchor: this.refs.dashStyle,
            onClickOutside: this.hideDashStyles,
            onParentScroll: this.hideDashStyles,
            className: 'izenda-Dropdown izenda-DashStyleDropDown'
          },
          React.createElement(
            'div',
            { className: 'izenda-Dropdown-menu' },
            listStyles
          )
        )
      );
    }
  });

  module.exports = m.observer(DashStyleDropdown);
}();

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ThresholdGridConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
/**
 * ThresholdGridConstants
 */

var DYNAMIC_TABLE_DEF = {
  type: {
    columnKey: 'Type',
    width: 100,
    get title() {
      return 'Type';
    },
    sortable: false,
    key: 'label'
  },
  field: {
    columnKey: 'Field',
    width: 140,
    get title() {
      return 'Field';
    },
    sortable: true,
    key: 'label'
  },
  label: {
    columnKey: 'Label',
    width: 120,
    get title() {
      return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_LABEL');
    },
    sortable: false,
    key: 'label'
  },
  value: {
    columnKey: 'Value',
    width: 140,
    get title() {
      return _Izenda2.default.getText('COMMON_LABEL_VALUE');
    },
    sortable: false,
    key: 'value'
  },
  dashStyle: {
    columnKey: 'DashStyle',
    width: 100,
    get title() {
      return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_DASHSTYLE');
    },
    sortable: false,
    key: 'dashStyle'
  },
  color: {
    columnKey: 'Color',
    width: 50,
    get title() {
      return _Izenda2.default.getText('COMMON_LABEL_COLOR');
    },
    sortable: false,
    key: 'color',
    align: 'center'
  },
  thickness: {
    columnKey: 'Thickness',
    width: 80,
    get title() {
      return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_THICKNESS');
    },
    sortable: false,
    key: 'thickness'
  },
  visible: {
    columnKey: 'Visible',
    width: 50,
    get title() {
      return _Izenda2.default.getText('COMMON_LABEL_VISIBLE');
    },
    sortable: false,
    key: 'visible',
    align: 'center'
  },
  action: {
    columnKey: 'Action',
    width: 50,
    get title() {
      return _Izenda2.default.getText('COMMON_LABEL_ACTION');
    },
    sortable: false,
    key: 'action',
    align: 'center'
  }
};
var TABLE_CONTAINER_STYLE = {
  width: (0, _fp.flow)(_fp.values, (0, _fp.sumBy)('width'))(DYNAMIC_TABLE_DEF)
};
exports.default = {
  MESSAGE: {
    get M03() {
      return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_MESSAGE_THRESHOLD_EXIST');
    },
    get M04() {
      return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_MESSAGE_THRESHOLD_VALUE_EXIST');
    },
    get M05() {
      return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_MESSAGE_THRESHOLD_REQUIRED_VALUE');
    },
    get M06() {
      return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_MESSAGE_THRESHOLD_REQUIRED_LABEL');
    }
  },
  TABLE_DEF: {
    label: {
      columnKey: 'Label',
      width: 130,
      get title() {
        return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_LABEL');
      },
      sortable: true,
      key: 'label'
    },
    value: {
      columnKey: 'Value',
      width: 130,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_VALUE');
      },
      sortable: true,
      key: 'value'
    },
    dashStyle: {
      columnKey: 'DashStyle',
      width: 100,
      get title() {
        return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_DASHSTYLE');
      },
      sortable: true,
      key: 'dashStyle'
    },
    color: {
      columnKey: 'Color',
      width: 60,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_COLOR');
      },
      sortable: true,
      key: 'color',
      align: 'center'
    },
    thickness: {
      columnKey: 'Thickness',
      width: 100,
      get title() {
        return _Izenda2.default.getText('THRESHOLD_GRID_CONSTANT_THICKNESS');
      },
      sortable: true,
      key: 'thickness'
    },
    visible: {
      columnKey: 'Visible',
      width: 60,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_VISIBLE');
      },
      sortable: true,
      key: 'visible',
      align: 'center'
    },
    action: {
      columnKey: 'Action',
      width: 60,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_ACTION');
      },
      sortable: true,
      key: 'action',
      align: 'center'
    }
  },
  DEFAULT_VALUE: {
    COLOR: '#000',
    DASH_STYLE: 'solid',
    WIDTH: 1,
    FONT_STYLE: 'italic',
    FONT_WEIGHT: 'bold',
    TEXT_DECORATION: 'underline',
    ALIGNMENT: 'left',
    FONT_SIZE: 8
  },
  NUMBER_REGEX: /^-?\d*\.?\d*$/,
  SORT_DIRS: {
    name: 'DESC'
  },
  THRESHOLD_MAX_HEIGHT: 500,
  THRESLOD_TYPE: [{ value: 'static', label: 'Static' }, { value: 'dynamic', label: 'Dynamic' }],
  DYNAMIC_TABLE_DEF: DYNAMIC_TABLE_DEF,
  TABLE_CONTAINER_STYLE: TABLE_CONTAINER_STYLE
};
module.exports = exports['default'];

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AXIS_OPTIONS = exports.THRESHOLDS_LINE = exports.COMMON_OPTIONS = undefined;

var _Izenda = __webpack_require__(33);

var LABEL_ROTATION_VALUES = _Izenda.MappingValues.LABEL_ROTATION_VALUES,
    HORIZONTAL_ALIGN_VALUES = _Izenda.MappingValues.HORIZONTAL_ALIGN_VALUES,
    VERTICAL_ALIGN_VALUES = _Izenda.MappingValues.VERTICAL_ALIGN_VALUES,
    LINE_STYLE_VALUES = _Izenda.MappingValues.LINE_STYLE_VALUES,
    AXIS_ALIGN_VALUES = _Izenda.MappingValues.AXIS_ALIGN_VALUES,
    LAYOUT_ALIGN_VALUES = _Izenda.MappingValues.LAYOUT_ALIGN_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartOptionsMapping.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var COMMON_OPTIONS = exports.COMMON_OPTIONS = {
  izHeight: { propKey: 'chart.height', defaultValue: undefined },
  izWidth: { propKey: 'chart.width', defaultValue: undefined },
  izMargin: { propKey: 'chart.margin', defaultValue: undefined },
  izDisableMultiColor: { defaultValue: false },
  izColorPattern: { propKey: 'colors', defaultValue: undefined },
  'izEntire.borderColor': { defaultValue: undefined },
  'izEntire.borderWidth': { defaultValue: undefined },
  'izEntire.borderStyle': { defaultValue: undefined },
  'izEntire.backgroundColor': { propKey: 'chart.backgroundColor', defaultValue: undefined },
  'izPlot.borderColor': { propKey: 'chart.plotBorderColor', defaultValue: undefined },
  'izPlot.borderWidth': { propKey: 'chart.plotBorderWidth', defaultValue: undefined },
  'izPlot.backgroundColor': { propKey: 'chart.plotBackgroundColor', defaultValue: undefined },
  izHoverLabels: { propKey: 'plotOptions.series.states.hover.enabled', defaultValue: true },
  izLabelOrientation: { propKey: 'plotOptions.series.dataLabels.rotation', propSource: LABEL_ROTATION_VALUES },
  'izLegend.visibility': { propKey: 'legend.enabled', defaultValue: false },
  'izLegend.horizontalAlign': { propKey: 'legend.align', propSource: HORIZONTAL_ALIGN_VALUES, defaultValue: 'izRight' },
  'izLegend.verticalAlign': {
    propKey: 'legend.verticalAlign',
    propSource: VERTICAL_ALIGN_VALUES,
    defaultValue: 'izBottom'
  },
  'izLegend.borderColor': { propKey: 'legend.borderColor', defaultValue: undefined },
  'izLegend.borderWidth': { propKey: 'legend.borderWidth', defaultvalue: 0 },
  'izLegend.fontStyling': { propKey: 'legend.itemStyle', defaultValue: undefined },
  'izLegend.title': { propKey: 'legend.title', defaultValue: undefined },
  'izLegend.layout': { propKey: 'legend.layout', propSource: LAYOUT_ALIGN_VALUES, defaultValue: undefined },
  'izLegend.backgroundColor': { propKey: 'legend.backgroundColor', defaultValue: undefined },
  izDataRefreshInterval: { defaultValue: undefined },
  'izMarker.radius': { propKey: 'plotOptions.series.marker.radius', defaultValue: undefined },
  izChartStyle: { propKey: 'chart.style', defaultValue: {} },
  izendaHiddenAllAxis: { propKey: 'izendaOptions.izendaHiddenAllAxis', defaultValue: false },
  'izTooltip.enabled': { propKey: 'tooltip.enabled', defaultValue: undefined },
  'izTooltip.backgrounColor': { propKey: 'tooltip.backgroundColor', defaultValue: undefined },
  'izTooltip.borderWidth': { propKey: 'tooltip.borderWidth', defaultValue: undefined },
  'izTooltip.shadow': { propKey: 'tooltip.shadow', defaultValue: undefined },
  'izTooltip.useHTML': { propKey: 'tooltip.useHTML', defaultValue: undefined },
  'izTooltip.hideDelay': { propKey: 'tooltip.hideDelay', defaultValue: undefined },
  'izTooltip.shared': { propKey: 'tooltip.shared', defaultValue: undefined },
  'izTooltip.padding': { propKey: 'tooltip.backgroundColor', defaultValue: undefined },
  'izTooltip.positioner': { propKey: 'tooltip.positioner', defaultValue: undefined },
  izFillContainer: { propKey: 'izendaOptions.fillContainer' }
};

var THRESHOLDS_LINE = exports.THRESHOLDS_LINE = {
  'izLabel.text': {
    propKey: 'label.text',
    defaultValue: ''
  },
  'izLabel.horizontalAlign': {
    propKey: 'label.align',
    propSource: HORIZONTAL_ALIGN_VALUES,
    defaultValue: HORIZONTAL_ALIGN_VALUES.izLeft
  },
  'izLabel.verticalAlign': {
    propKey: 'label.verticalAlign',
    propSource: VERTICAL_ALIGN_VALUES,
    defaultValue: VERTICAL_ALIGN_VALUES.izTop
  },
  'izLabel.style': {
    propKey: 'label.style',
    propSource: LINE_STYLE_VALUES,
    defaultValue: {}
  },
  izValue: {
    propKey: 'value',
    defaultValue: 0
  },
  izWidth: {
    propKey: 'width',
    defaultValue: 0
  },
  izDashStyle: {
    propKey: 'dashStyle',
    propSource: LINE_STYLE_VALUES,
    defaultValue: LINE_STYLE_VALUES.izSolid
  },
  izIndex: {
    propKey: 'zIndex',
    defaultValue: 1
  },
  izThresholdColor: {
    propKey: 'color',
    defaultValue: ''
  },
  'izLabel.textAlign': {
    propKey: 'label.textAlign',
    defaultValue: ''
  }
};

var AXIS_OPTIONS = exports.AXIS_OPTIONS = {
  /* label */
  izLabelOrientation: {
    propKey: 'labels.rotation',
    propSource: LABEL_ROTATION_VALUES,
    defaultValue: null
  },
  'izLabel.enabled': {
    propKey: 'labels.enabled',
    defaultValue: null
  },
  izStartOnTick: {
    propKey: 'startOnTick',
    defaultValue: true
  },
  izEndOnTick: {
    propKey: 'endOnTick',
    defaultValue: true
  },
  izTickPositions: {
    propKey: 'tickPositions',
    defaultValue: null /* axis */
  }, 'izTitle.enabled': {
    propKey: 'title.enabled',
    defaultValue: true
  },
  'izTitle.text': {
    propKey: 'title.text',
    defaultValue: ''
  },
  'izTitle.style': {
    propKey: 'title.style',
    defaultValue: null
  },
  'izTitle.align': {
    propKey: 'title.align',
    propSource: AXIS_ALIGN_VALUES,
    defaultValue: AXIS_ALIGN_VALUES.izLeft
  },
  izTickInterval: {
    propKey: 'tickInterval',
    defaultValue: 0
  },
  izTickCategoryInterval: {
    propKey: 'tickCategoryInterval',
    defaultValue: 0
  },
  izStartingPoint: {
    propKey: 'min',
    defaultValue: 0
  },
  izCategory: {
    defaultValue: false
  },
  /* grid */
  'izGrid.lineWidth': {
    propKey: 'gridLineWidth',
    defaultValue: 1
  },
  'izGrid.lineColor': {
    propKey: 'gridLineColor',
    defaultValue: ''
  },
  'izGrid.lineDashStyle': {
    propKey: 'gridLineDashStyle',
    propSource: LINE_STYLE_VALUES,
    defaultValue: LINE_STYLE_VALUES.izSolid
  }
};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _Izenda = __webpack_require__(270);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(132);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1119);

var _Izenda6 = __webpack_require__(2088);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(271);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(53);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get list node by its node name.
 * @param  {String} htmlString
 * @param  {String} nodeName
 * @return {String} name
 */
var filterByNodeName = function filterByNodeName(htmlString, nodeName) {
  return $izenda('<div>' + htmlString + '</div>').find(nodeName);
};

/**
 * Transform a field-prop tag to a ReportPartElement object
 * @param  {Array} nodes
 * @param  {Object} baseObject
 * @return {Object} ReportPartElement
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Report Part Form Content Utils
 */

var mapFromHTMLToObject = function mapFromHTMLToObject(nodes, baseObject) {
  var obj = {};
  var listKey = [];
  var element = new _Izenda2.default();

  (0, _fp.forEach)(function (node) {
    var $node = $izenda(node);
    var key = $node.attr('key');
    var keySetting = _Izenda5.FieldPropertiesPaths[key];
    if (keySetting) {
      var value = keySetting.dataType.parseValue($node.attr('value'));

      obj = (0, _fp.set)(keySetting.path, value, obj);
      listKey.push(key);
    }
  }, nodes);

  // because the setting for default value for data type is different with default
  // value set in report part element property
  // Ex: sort is string and default value is empty, so when sort is empty we don't generate HTML for it
  // when we read back from HTML because in HTML don't have node for sort so when we create new element object in
  // (:95) it will get the default value in report part element property which is ASC. thus change the value of field
  (0, _fp.flow)((0, _fp.omit)(listKey), _fp.values, (0, _fp.filter)({ needDefaultValue: true }), (0, _fp.forEach)(function (keySetting) {
    var value = (0, _fp.get)(keySetting.path, element);

    obj = (0, _fp.set)(keySetting.path, value, obj);
  }))(_Izenda5.FieldPropertiesPaths);

  // Reset functionInfo to null if there is not selected function.
  var funcInfoIdKey = 'funcInfoId';
  if (!(0, _fp.get)(_Izenda5.FieldPropertiesPaths[funcInfoIdKey].path, obj)) {
    obj = (0, _fp.set)(_Izenda5.FieldPropertiesPaths[funcInfoIdKey].path, null, obj);
  }

  // if baseObject is null or undifined. That means the field was disabled in Data Model.
  // So we could not get the default value from data tree
  // because that field is not available for report
  // then we need to set the element is invisible
  if ((0, _fp.isNil)(baseObject) || (0, _fp.isNil)(baseObject.field)) {
    element.field.visible = false;
  } else {
    element.readData(baseObject);
  }

  element.readData(obj);

  // Set default fieldItemVisible based on visible of field.
  if ((0, _fp.isNil)((0, _fp.get)('properties.fieldItemVisible', element)) && element.field) {
    element.properties.fieldItemVisible = element.field.visible;
  }

  return element;
};

/**
 * Transform html content to ReportPartElement objects
 * @param  {Array} originalColumns
 * @param  {Array} originalSeparators
 * @param  {String} htmlString
 * @param  {Object} dataTree
 * @return void
 */
var syncFromHTMLToElements = function syncFromHTMLToElements(originalColumns, originalSeparators, htmlString, dataTree) {
  var columns = [];
  var separators = [];
  var fields = filterByNodeName(htmlString, 'field');

  // build element from html
  fields.each(function (index, field) {
    var fieldName = $izenda(field).attr('field-name');
    var fieldNameAlias = (0, _fp.trim)($izenda(field).text());

    if (fieldNameAlias === _Izenda11.default.FIELD_HIDDEN_LABEL) {
      fieldName = $izenda(field).attr('field-name');
      var matches = fieldName.match(/\[(.*?)\]/g);
      var lastMatched = matches[matches.length - 1].replace('[', '').replace(']', '');
      fieldNameAlias = lastMatched;
    }

    var fieldProps = filterByNodeName(field.innerHTML, 'field-prop');
    var element = {};

    // load default value which is get from field-name.
    var defaultField = dataTree && fieldName && parseFieldNameIntoFieldProps(fieldName, dataTree);
    element.field = (0, _fp.cloneDeep)(defaultField);
    // update with current html value.
    element = mapFromHTMLToObject(fieldProps, element);

    // Update field name alias
    // - The value of name, fieldNameAlias, and text of each element must be same.
    // - Cannot use  set here, because we want to use computed value later.
    element.field && (element.field.fieldNameAlias = fieldNameAlias);
    element.name = fieldNameAlias;
    element.position = index;

    columns.push(element);
  });

  var impactElements = updateReportPartContent(columns, originalColumns.elements, originalSeparators.elements);
  updateReportPartContent(separators, originalSeparators.elements, impactElements);

  updateCorrectPosition(originalColumns);
  updateCorrectPosition(originalSeparators);
};

/**
 * Update position of elements inside container after move between container
 * @param {Object} container
 * @return void
 */
var updateCorrectPosition = function updateCorrectPosition(container) {
  container.elements = (0, _fp.orderBy)(['position'], ['asc'], container.elements);
  var elementsLength = container.elements.length;
  for (var i = 0; i < elementsLength; i++) {
    container.elements[i].position = i;
  }
};

/**
 * Update report part content
 * @param {Array} elements
 * @param {Array} originalElements
 * @return {Object} ReportPartElement
 */
var updateReportPartContent = function updateReportPartContent(elements, originalElements, impactElements) {
  var removedElements = [];
  // remove

  var _loop = function _loop(i) {
    var matchingItem = (0, _fp.find)(function (item) {
      return item.name == originalElements[i].name;
    }, elements);

    if (!matchingItem) {
      removedElements.push(originalElements[i]);
      originalElements.remove(originalElements[i]);
    }
  };

  for (var i = originalElements.length - 1; i >= 0; i--) {
    _loop(i);
  }

  // update

  var _loop2 = function _loop2(i) {
    var element = originalElements[i];
    var index = (0, _fp.findIndex)(function (item) {
      return item.name == element.name;
    }, elements);

    if (index !== -1) {
      originalElements[i].readData(elements[index]);
      elements.splice(index, 1);
    }
  };

  for (var i = 0; i < originalElements.length; i++) {
    _loop2(i);
  }

  // insert
  (0, _fp.forEach)(function (element) {
    var newElement = (0, _fp.find)({ fieldNameAlias: element.fieldNameAlias }, impactElements);
    originalElements.push((0, _fp.isNil)(newElement) ? element : newElement);
  }, elements);

  return removedElements;
};

/**
 * Build field object which is used in form definition.
 * @param  {Object} querysource
 * @param  {Object} field
 * @return {Object} field
 */
var buildField = function buildField(querysource, field) {
  return querysource && field && {
    fieldId: field.id,
    fieldName: field.name,
    fieldNameAlias: field.alias || field.name,
    dataFieldType: field.izendaDataType,
    querySourceId: field.querySourceId,
    querySourceType: querysource.isAlias ? null : querysource.type,
    sourceAlias: querysource.name,
    relationshipId: querysource.isAlias ? querysource.id : null,
    visible: field.visible,
    calculatedTree: field.calculatedTree,
    schemaName: querysource.querySourceCategoryName,
    querySourceName: querysource.name,
    databaseName: querysource.connectionName,
    isCalculated: field.isCalculated
  };
};

/**
 * Find fields in query sources
 * @param  {Object} querySources
 * @param  {Function} filterFn
 * @return {Array} match items
 */
var findFields = function findFields(querySources, filterFn) {
  var matchingItems = [];

  (0, _fp.forEach)(function (querysource) {
    var matchingField = querysource.fields && (0, _fp.find)(function (item) {
      return filterFn(querysource, item);
    }, querysource.fields);

    if (matchingField) {
      matchingItems.push(buildField(querysource, matchingField));
    }
  }, querySources);

  return !(0, _fp.isEmpty)(matchingItems) && matchingItems;
};

/**
 * Build a field object in form definition from field-name attribute.
 * @param  {String} fieldName
 * @param  {Object} dataTree
 * @return {Object} field
 */
var parseFieldNameIntoFieldProps = function parseFieldNameIntoFieldProps(fieldName, dataTree) {
  return (0, _fp.head)(buildFieldsByFieldNameHtml(fieldName, dataTree));
};

/**
 * Build field object(s) in form definition from field-name attribute.
 * @param  {String} fieldName
 * @param  {Object} dataTree
 * @return {Object} field
 */
var buildFieldsByFieldNameHtml = function buildFieldsByFieldNameHtml(fieldName, dataTree) {
  fieldName = fieldName.substring(1, fieldName.length - 1);
  var sections = (0, _fp.split)('].[', fieldName);
  var numOfSections = sections.length;
  var fields = null;

  var querySources = (0, _fp.flatMap)(function (item) {
    return item.querySource.toJS();
  }, dataTree.details);

  /**
   * Validate data source name
   * @param  {Object} querysource
   * @param  {String} name
   */
  var checkDataSourceName = function checkDataSourceName(querysource, name) {
    return querysource.isAlias && querysource.name === name || !querysource.isAlias && (querysource.originalName === name || querysource.name === name);
  };

  switch (numOfSections) {
    case 1:
      {
        // [field name alias]
        // [field actual name]
        var firstOperand = sections[0];
        fields = findFields(querySources, function (querysource, field) {
          return field.alias === firstOperand;
        }) || findFields(querySources, function (querysource, field) {
          return field.name === firstOperand;
        });
        break;
      }
    case 2:
      {
        // [data source name].[field name alias] (|| [data source alias].[field name alias])
        // [data source name].[field actual name]
        // [join alias].[field name alias]
        // [join alias].[field actual name]
        var _firstOperand = sections[0];
        var secondOperand = sections[1];
        fields = findFields(querySources, function (querysource, field) {
          return checkDataSourceName(querysource, _firstOperand) && field.alias === secondOperand;
        }) || findFields(querySources, function (querysource, field) {
          return checkDataSourceName(querysource, _firstOperand) && field.name === secondOperand;
        });
        break;
      }
    case 3:
      {
        // [schema name].[data source name].[field name alias]
        // [schema name].[data source name].[field actual name]
        var _firstOperand2 = sections[0];
        var _secondOperand = sections[1];
        var thirdOperand = sections[2];
        fields = findFields(querySources, function (querysource, field) {
          return querysource.querySourceCategoryName === _firstOperand2 && checkDataSourceName(querysource, _secondOperand) && field.alias === thirdOperand;
        }) || findFields(querySources, function (querysource, field) {
          return querysource.querySourceCategoryName === _firstOperand2 && checkDataSourceName(querysource, _secondOperand) && field.name === thirdOperand;
        });
        break;
      }
    case 4:
      {
        // [database name].[schema name].[data source name].[field name alias]
        // [database name].[schema name].[data source name].[field actual name]
        var _firstOperand3 = sections[0];
        var _secondOperand2 = sections[1];
        var _thirdOperand = sections[2];
        var fourthOperand = sections[3];
        fields = findFields(querySources, function (querysource, field) {
          return querysource.connectionName === _firstOperand3 && querysource.querySourceCategoryName === _secondOperand2 && checkDataSourceName(querysource, _thirdOperand) && field.alias === fourthOperand;
        }) || findFields(querySources, function (querysource, field) {
          return querysource.connectionName === _firstOperand3 && querysource.querySourceCategoryName === _secondOperand2 && checkDataSourceName(querysource, _thirdOperand) && field.name === fourthOperand;
        });
        break;
      }
  }

  // If there is not any matched field then fields' value is false.
  // We return null for this case.
  return fields ? fields : null;
};

/**
 * Validate a field tag with current context.
 * @param  {Object} field
 * @param  {Object} context
 * @return {Object} result
 */
var validateField = function validateField(field, context) {
  var validations = [];
  validations.push(validateFieldName);
  validations.push(validateFieldNameAlias);

  var result = null;
  var index = 0;
  while ((0, _fp.isNil)(result) && index < validations.length) {
    result = validations[index](field, context);
    index++;
  }

  return result;
};

/**
 * Validate field name.
 * @param  {Object} field
 * @param  {Object} context
 * @return {String} validate messsage
 */
var validateFieldName = function validateFieldName(field, context) {
  var dataTree = context.dataTree;
  if ((0, _fp.isNil)(dataTree)) return null;

  var fieldName = $izenda(field).attr('field-name');
  var fields = buildFieldsByFieldNameHtml(fieldName, dataTree);

  var validateMessage = null;
  if ((0, _fp.isNil)(fields)) {
    validateMessage = String.format(_Izenda4.default.MESSAGES.M02, fieldName);
  } else if (fields.length > 1) {
    validateMessage = String.format(_Izenda4.default.MESSAGES.M01, fieldName);
  }

  return validateMessage;
};

/**
 * Validate field name alias.
 * @param  {Object} field
 * @param  {Object} context
 * @return {String} error message
 */
var validateFieldNameAlias = function validateFieldNameAlias(field, context) {
  var fieldNameAliases = context.fieldNameAliases;
  if ((0, _fp.isNil)(fieldNameAliases)) return null;

  var fieldNameAlias = (0, _fp.trim)($izenda(field).text());
  var matchingItems = (0, _fp.filter)(function (item) {
    return item === fieldNameAlias;
  }, fieldNameAliases);

  return matchingItems.length > 1 ? String.format(_Izenda4.default.MESSAGES.M16, fieldNameAlias) : null;
};

/**
 * Build a field-prop tag with supplied key and value
 * @param  {String} key
 * @param  {Object} value
 * @return {Object} field
 */
var generateHTMLFieldPropTag = function generateHTMLFieldPropTag(key, value) {
  var compiledTemplateWithValueFn = (0, _fp.template)('<field-prop key="<%- key %>" value="<%- value %>"></field-prop>');
  if (!_Izenda5.FieldPropertiesPaths[key]) {
    return '';
  }
  var defaultConfigField = new _Izenda2.default();
  var defaultValue = (0, _fp.get)(_Izenda5.FieldPropertiesPaths[key].path, defaultConfigField);
  // We only render props has value and its value is not a default value of its data type.
  if (!(0, _fp.isNil)(defaultValue) && value !== defaultValue || (0, _fp.isNil)(defaultValue) && !_Izenda5.FieldPropertiesPaths[key].dataType.isDefaultValue(value)) {
    value = value.toJS ? value.toJS() : value;

    if ((0, _fp.isArray)(value)) {
      value = (0, _stringify2.default)(value);
    }

    return compiledTemplateWithValueFn({
      key: key,
      value: value
    });
  }
  return '';
};

/**
 * Build html content for field properties
 * @param  {Object} configField
 * @param  {Object} isInitial
 * @return {String} field content
 */
var buildHTMLCodeFieldContent = function buildHTMLCodeFieldContent(configField, isInitial) {
  var result = '';
  var keys = (0, _keys2.default)(_Izenda5.FieldPropertiesPaths);
  var excludedKeys = (0, _keys2.default)(_Izenda5.ExcludeOnHtmlViewPaths);
  keys = (0, _fp.difference)(keys, excludedKeys);
  var defaultConfigField = new _Izenda2.default();

  if (isInitial) {
    keys = (0, _keys2.default)(_Izenda5.InitialFieldPropertiesPaths);
  }

  keys.forEach(function (key) {
    var value = (0, _fp.get)(_Izenda5.FieldPropertiesPaths[key].path, configField);
    var defaultValue = (0, _fp.get)(_Izenda5.FieldPropertiesPaths[key].path, defaultConfigField);
    !(0, _fp.isNil)(value) && value !== defaultValue && (result += generateHTMLFieldPropTag(key, value));
  });

  return result;
};

/**
 * Validate embedded report
 * @param {String} embeddedReportContent
 * @param {Object} embedde report data
 * @returns {Object} error messages or object
 */
var validateEmbeddedReport = function validateEmbeddedReport(emId, embeddedReportContent) {
  var contentList = (0, _fp.split)('/', embeddedReportContent);
  return _Izenda7.default.validateEmbeddedReport(null, emId, contentList[0], contentList[1]).then(function (result) {
    if (!(0, _fp.isNil)(result.success) && !result.success) {
      return result.messages[0].messages[0];
    }
    return result;
  });
};

/**
 * Get html between two elements
 * @param {Object} first element
 * @param {Object} second element
 * @param {String} html content
 * @returns {String} text
 */
var getHtmlBetweenTwoElement = function getHtmlBetweenTwoElement(e1, e2, htmlContent) {
  var editorHtml = $izenda('<div>' + htmlContent + '</div>').html();
  var e1Html = $izenda(e1).get(0).outerHTML;
  var e2Html = $izenda(e2).get(0).outerHTML;
  return editorHtml.substring(editorHtml.indexOf(e1Html) + e1Html.length, editorHtml.indexOf(e2Html));
};

/**
 * Clean html string from TinyMCE.
 * @param  {String} htmlContent
 * @return {String} html content
 */
var cleanHtmlFromTinyMCE = function cleanHtmlFromTinyMCE(htmlContent) {
  var $htmlContentWrapper = $izenda('<div/>').html(htmlContent);
  $izenda('field', $htmlContentWrapper).removeAttr('contenteditable').removeAttr('data-mce-selected');
  return $izenda($htmlContentWrapper)[0].innerHTML;
};

/**
 * Check a filed whether inside repeater element
 * @param {String} htmlContent
 * @param {String} fieldContent
 * @return {Boolean} result
 */
var checkFieldInsideRepeater = function checkFieldInsideRepeater(htmlContent, fieldContent) {
  var repeaterStartTag = void 0,
      repeaterEndTag = void 0;

  if (htmlContent.indexOf(_Izenda9.default.REPEATER_START) >= 0) {
    repeaterStartTag = _Izenda9.default.REPEATER_START;
    repeaterEndTag = _Izenda9.default.REPEATER_END;
  } else if (htmlContent.indexOf(_Izenda9.default.REPEATER_START_FORTABLE) >= 0) {
    repeaterStartTag = _Izenda9.default.REPEATER_START_FORTABLE;
    repeaterEndTag = _Izenda9.default.REPEATER_END_FORTABLE;
  } else {
    return false;
  }

  var start = htmlContent.indexOf(repeaterStartTag);
  var end = htmlContent.lastIndexOf(repeaterEndTag);
  var content = htmlContent.substring(start, end);

  return content.indexOf(fieldContent) >= 0;
};

exports.default = {
  syncFromHTMLToElements: syncFromHTMLToElements,
  generateHTMLFieldPropTag: generateHTMLFieldPropTag,
  FieldPropertiesPaths: _Izenda5.FieldPropertiesPaths,
  validateField: validateField,
  buildHTMLCodeFieldContent: buildHTMLCodeFieldContent,
  validateEmbeddedReport: validateEmbeddedReport,
  getHtmlBetweenTwoElement: getHtmlBetweenTwoElement,
  filterByNodeName: filterByNodeName,
  cleanHtmlFromTinyMCE: cleanHtmlFromTinyMCE,
  mapFromHTMLToObject: mapFromHTMLToObject
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RepeaterNode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FUNCTION_GROUP_NAME = _Izenda.FUNCTION.GROUP.NAME;

var RepeaterNode = function () {
  (0, _createClass3.default)(RepeaterNode, [{
    key: 'fieldHasSubtotalConfig',
    get: function get() {
      return (0, _fp.filter)(function (field) {
        return (0, _fp.get)('fieldInfo.hasSubTotal', field);
      }, this.fieldSupportSubtotal);
    }
  }, {
    key: 'fieldHasNoGroupingData',
    get: function get() {
      return (0, _fp.filter)(function (field) {
        return !((0, _fp.get)('fieldInfo.haveFunction', field) && (0, _fp.get)('fieldInfo.functionInfo.name', field) !== _Izenda.FUNCTION.DAYS_OLD.NAME) || (0, _fp.get)('fieldInfo.functionInfo.userDefined', field);
      }, this.fields);
    }
  }, {
    key: 'fieldGroupingData',
    get: function get() {
      return (0, _fp.filter)(function (field) {
        return (0, _fp.get)('fieldInfo.haveFunction', field);
      }, this.fields);
    }
  }, {
    key: 'totalFieldGroupingData',
    get: function get() {
      var fieldsInChild = (0, _fp.reduce)(function (result, item) {
        return (0, _fp.concat)(result, item.totalFieldGroupingData);
      }, [], this.childNodes);

      return (0, _fp.concat)(this.fieldGroupingData, fieldsInChild);
    }
  }, {
    key: 'totalFieldHasNoGroupingData',
    get: function get() {
      var fieldsInChild = (0, _fp.reduce)(function (result, item) {
        return (0, _fp.concat)(result, item.totalFieldHasNoGroupingData);
      }, [], this.childNodes);

      return (0, _fp.concat)(this.fieldHasNoGroupingData, fieldsInChild);
    }
  }, {
    key: 'fieldIsRunning',
    get: function get() {
      if (this.level === 0 || this.childNodes.length === 0) return [];
      return (0, _fp.filter)(function (field) {
        return (0, _fp.get)('fieldInfo.field.isRunningField', field);
      }, this.fields);
    }
  }, {
    key: 'validSubtotalSmartTag',
    get: function get() {
      return (0, _fp.filter)(function (item) {
        return item.isValidSubTotalSmartTag;
      }, this.smartTagInContent);
    }
  }, {
    key: 'hasSupportUnsort',
    get: function get() {
      return (0, _fp.isEmpty)(this.childNodes);
    }
  }, {
    key: 'totalFields',
    get: function get() {
      var fieldsInChild = (0, _fp.reduce)(function (result, item) {
        return (0, _fp.concat)(result, item.totalFields);
      }, [], this.childNodes);

      return (0, _fp.concat)(this.fields, fieldsInChild);
    }
  }, {
    key: 'hasGroupingData',
    get: function get() {
      return (0, _fp.size)(this.totalFieldGroupingData) === (0, _fp.size)(this.totalFields);
    }
  }, {
    key: 'totalFieldRunningField',
    get: function get() {
      var fieldsInChild = (0, _fp.reduce)(function (result, item) {
        return (0, _fp.concat)(result, item.totalFieldRunningField);
      }, [], this.childNodes);

      return (0, _fp.concat)(this.fieldIsRunning, fieldsInChild);
    }
  }, {
    key: 'allFieldIsNotGroupingData',
    get: function get() {
      return (0, _fp.size)(this.totalFieldHasNoGroupingData) === (0, _fp.size)(this.totalFields);
    }
  }]);

  function RepeaterNode(repeaterNode) {
    (0, _classCallCheck3.default)(this, RepeaterNode);
    this.level = 0;
    this.fields = [];
    this.fieldSupportSubtotal = [];
    this.subTotalSmartTag = [];
    this.placeHolderPattern = '';
    this.placeHolderKey = '';
    this.pattern = '';
    this.childNodes = [];

    this.populateData(repeaterNode);
  }

  /**
   * populate data for repeater node
   * @param repeaterNode {Object}
   */


  (0, _createClass3.default)(RepeaterNode, [{
    key: 'populateData',
    value: function populateData(repeaterNode) {
      this.childNodes = repeaterNode.childNodes;
      this.level = repeaterNode.level;
      this.fields = repeaterNode.fields;
      this.smartTagInContent = repeaterNode.smartTagInContent;
      this.fieldSupportSubtotal = repeaterNode.fieldSupportSubtotal;
      this.subTotalSmartTag = repeaterNode.subTotalSmartTag;
      this.placeHolderPattern = repeaterNode.placeHolderPattern;
      this.placeHolderKey = repeaterNode.placeHolderKey;
      this.pattern = repeaterNode.pattern;
    }
  }]);
  return RepeaterNode;
}();

exports.default = RepeaterNode;
module.exports = exports['default'];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(99);

exports.default = [(0, _Izenda.createXAxisSchema)(), _Izenda.createGaugeYAxisMetricsSchema, _Izenda.createSeparatorSchema];
// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonGaugeFieldContainerSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(33);

var HORIZONTAL_ALIGN_VALUES = _Izenda.MappingValues.HORIZONTAL_ALIGN_VALUES,
    VERTICAL_ALIGN_VALUES = _Izenda.MappingValues.VERTICAL_ALIGN_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonMapOptionsMapping.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  optionsByType: {
    izValueLabel: { propKey: 'izendaOptions.dataLabels', defaultValue: false },
    izShowTooltip: { propKey: 'tooltip.enabled', defaultValue: true },
    izMapLabel: { propKey: 'izendaOptions.mapLabel', defaultValue: false },
    'izMapNavigation.enabled': { propKey: 'mapNavigation.enabled', defaultValue: false },
    'izMapNavigation.align': {
      propKey: 'mapNavigation.buttonOptions.align',
      propSource: HORIZONTAL_ALIGN_VALUES,
      defaultValue: undefined
    },
    'izMapNavigation.verticalAlign': {
      propKey: 'mapNavigation.buttonOptions.verticalAlign',
      propSource: VERTICAL_ALIGN_VALUES,
      defaultValue: undefined
    },
    legendSettings: { defaultValue: true }
  }
};
module.exports = exports['default'];

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(99);

var _fp = __webpack_require__(1);

var _Izenda2 = __webpack_require__(265);

var _Izenda3 = __webpack_require__(105);

var _Izenda4 = __webpack_require__(16);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultMapContainersSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var isNotCountry = function isNotCountry(_ref) {
  var isMapStyle = _ref.isMapStyle;
  return !isMapStyle(_Izenda3.MAP_TYPES.Country);
};

var isWorldOrSupportedCountry = function isWorldOrSupportedCountry(_ref2) {
  var isMapStyle = _ref2.isMapStyle,
      country = _ref2.properties.country;
  return isMapStyle(_Izenda3.MAP_TYPES.World) || _Izenda2.SUPPORTED_COUNTRY_COUNTRIES.indexOf(country) > -1;
};

var CONTAINER_HEIGHT = 70;

exports.default = [(0, _Izenda.createStaticLabelSchema)('LabelPoint', function () {
  return _Izenda6.default.getText('REPORTDESIGNER_LABEL_POINT_OPTIONS');
}), (0, _Izenda.createConditionalContainerSchema)(isNotCountry, 'countryContainer', function () {
  return _Izenda6.default.getText('REPORT_PART_MAP_POINT_country');
}, _Izenda3.ContainerName.COUNTRY, CONTAINER_HEIGHT, 1, true), (0, _Izenda.createContainerSchema)('stateContainer', function () {
  return _Izenda6.default.getText('REPORT_PART_MAP_POINT_state');
}, _Izenda3.ContainerName.STATE, CONTAINER_HEIGHT, 1, true), (0, _Izenda.createConditionalContainerSchema)(isWorldOrSupportedCountry, 'countyContainer', function () {
  return _Izenda6.default.getText('REPORT_PART_MAP_POINT_county');
}, _Izenda3.ContainerName.COUNTY, CONTAINER_HEIGHT, 1, true), (0, _Izenda.createContainerSchema)('cityContainer', function () {
  return _Izenda6.default.getText('REPORT_PART_MAP_POINT_city');
}, _Izenda3.ContainerName.CITY, CONTAINER_HEIGHT, 1, true), (0, _Izenda.createContainerSchema)('postalCodeContainer', function () {
  return _Izenda6.default.getText('REPORT_PART_MAP_POINT_postalCode');
}, _Izenda3.ContainerName.POSTAL_CODE, CONTAINER_HEIGHT, 1, true), (0, _Izenda.createContainerSchema)('latContainer', function () {
  return _Izenda6.default.getText('REPORT_PART_MAP_POINT_latitude');
}, _Izenda3.ContainerName.LATITUDE, CONTAINER_HEIGHT, 1, true), (0, _Izenda.createContainerSchema)('lonContainer', function () {
  return _Izenda6.default.getText('REPORT_PART_MAP_POINT_longtitude');
}, _Izenda3.ContainerName.LONGTITUDE, CONTAINER_HEIGHT, 1, true), (0, _Izenda.createStaticLabelSchema)('LabelValues', function () {
  return _Izenda6.default.getText('REPORTDESIGNER_LABEL_VALUES');
}), (0, _Izenda.createContainerSchema)('shadingContainer', function () {
  return _Izenda6.default.getText('REPORT_PART_MAP_CONSTANTS_SHADING_METRIC');
}, _Izenda3.ContainerName.SHADING_VALUES, CONTAINER_HEIGHT, 1, true), (0, _Izenda.createContainerSchema)('bubbleContainer', function () {
  return _Izenda6.default.getText('REPORT_PART_MAP_CONSTANTS_BUBBLE_METRIC');
}, _Izenda3.ContainerName.BUBBLE_VALUES, undefined, undefined, true)];
module.exports = exports['default'];

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ExposeMethodAction.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var withContext = __webpack_require__(9).withContext;
  var getContext = __webpack_require__(9).getContext;

  var contextShape = {
    registerExposeMethod: React.PropTypes.func,
    unregisterExposeMethod: React.PropTypes.func
  };

  var defineContext = withContext(contextShape, function (props) {
    return {
      registerExposeMethod: props.registerExposeMethod,
      unregisterExposeMethod: props.unregisterExposeMethod
    };
  });

  var accessContext = getContext(contextShape);

  module.exports = {
    defineContext: defineContext,
    accessContext: accessContext
  };
}();

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Container.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(104);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(120);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(606);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2124);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(413);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2126);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2128);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _recompose = __webpack_require__(9);

var _mobxReact = __webpack_require__(10);

var _Izenda17 = __webpack_require__(2201);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(15);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(31);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(78);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _reactRouter = __webpack_require__(52);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda25 = __webpack_require__(613);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(130);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _Izenda29 = __webpack_require__(12);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DevTools = void 0;

if (false) {
  DevTools = require('mobx-react-devtools').default;
}

var Container = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Container, _Component);

  function Container() {
    (0, _classCallCheck3.default)(this, Container);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Container.__proto__ || (0, _getPrototypeOf2.default)(Container)).call(this));

    _this.handleNeedLogin = function () {
      if (_Izenda20.default.needLogin) {
        if (_this.props.isNeedLoginForm) {
          _this.securityManager.clear();
          _this.context.dialogs.reset();
          var loginLink = _Izenda22.default.getRouteUrl(_Izenda22.default.getConfigRoute('Account', 'Login'), {
            redirectTo: _this.props.location.pathname + _this.props.location.search
          });
          _this.props.router.push(loginLink);
        } else {
          _this.setState({ showPermissionError: true });
        }
      }
    };

    _this.state = {
      store: _Izenda4.default,
      showPermissionError: false
    };

    _this.securityManagerStore = new _Izenda8.default();
    _this.securityManager = new _Izenda6.default();
    _this.accountStore = new _Izenda28.default();

    _this.getSecurity();

    _this.needLoginDisposer = (0, _mobx.observe)(_Izenda20.default, 'needLogin', _this.handleNeedLogin);
    _Izenda20.default.setMobileVersion(_Izenda24.default.isMobileDevice());

    // Check Dirty for Integration Mode
    window.onbeforeunload = function () {
      // A popup with text 'null' will be displayed if this return null in IE browser
      if (_Izenda20.default.isDirty) {
        return _Izenda30.default.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST');
      }
    };
    return _this;
  }

  (0, _createClass3.default)(Container, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.state.store.getProvisionMapDataStatus();
      this.ensureDatabaseConfigured();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.needLoginDisposer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.getSecurity();
    }

    /**
       * Ensure database configured
       */

  }, {
    key: 'ensureDatabaseConfigured',
    value: function ensureDatabaseConfigured() {
      var _this2 = this;

      this.accountStore.checkDatabaseSetup().then(function (dbConfigured) {
        if (!dbConfigured) {
          _this2.securityManager.clear();
          var settingLink = _Izenda22.default.getSettingsUrl(null, { notSetupDatabase: true });

          // Redirect to setting page
          if (_this2.props.router) {
            _this2.props.router.push(settingLink);
          } else {
            window.location.href = settingLink;
          }
        }

        return dbConfigured;
      });
    }

    /**
       * Get security data
       */

  }, {
    key: 'getSecurity',
    value: function getSecurity() {
      var accessToken = this.securityManager.getAccessToken();
      if (!(0, _fp.isNil)(accessToken)) {
        this.securityManagerStore.fetchData();
      }
    }
  }, {
    key: 'checkPrintMode',
    value: function checkPrintMode() {
      var props = this.props;
      var query = props.location && props.location.query;
      return query && query.print === 'true';
    }
  }, {
    key: 'setContainerElement',
    value: function setContainerElement(container) {
      _Izenda2.default.containerElement = container;
    }
  }, {
    key: 'render',
    value: function render() {
      var dialogs = this.context.dialogs;
      var showPermissionError = this.state.showPermissionError;
      var accessToken = this.securityManager.getAccessToken();
      var isPrintMode = this.checkPrintMode();
      var className = (0, _classnames2.default)('izenda page', {
        u_overflowVisible: isPrintMode,
        u_inline: isPrintMode,
        u_overflowHidden: !isPrintMode,
        'izenda-print': isPrintMode
      });

      return ((0, _fp.isNil)(accessToken) || this.securityManager.isCompleteLoad) && _react2.default.createElement(
        'div',
        { className: 'izenda-root izenda-container' },
        _react2.default.createElement(
          'section',
          { ref: this.setContainerElement, className: className },
          showPermissionError ? _react2.default.createElement(_Izenda26.default, null) : this.props.children,
          _react2.default.createElement(_Izenda10.default, { dialog: dialogs.child }),
          _react2.default.createElement(_Izenda12.default, null),
          _react2.default.createElement(_Izenda14.default, { loaders: _Izenda20.default.exportingLoadings }),
           false ? _react2.default.createElement(DevTools, null) : null,
          _react2.default.createElement(_Izenda18.default, null)
        )
      );
    }
  }]);
  return Container;
}(_react.Component), _class.contextTypes = {
  dialogs: _react.PropTypes.object
}, _class.propTypes = {
  isNeedLoginForm: _react.PropTypes.bool
}, _class.defaultProps = {
  isNeedLoginForm: true
}, _temp);


var connectContainer = (0, _recompose.compose)(_reactRouter.withRouter, _Izenda16.default, _mobxReact.observer);
exports.default = connectContainer(Container);
module.exports = exports['default'];

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _desc, _value, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityManagerStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(278);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(75);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(329);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(130);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(565);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2123);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(484);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(15);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(104);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(245);

var _Izenda20 = _interopRequireDefault(_Izenda19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SecurityManagerStore = (_dec = (0, _mobx.action)('fetchData'), (_class = function () {
  function SecurityManagerStore() {
    (0, _classCallCheck3.default)(this, SecurityManagerStore);

    this.authorizationStore = new _Izenda6.default();
    this.accountStore = new _Izenda8.default();
    this.licenseInfoStore = _Izenda10.default;
    this.integrationSettingStore = new _Izenda12.default();
  }

  /**
   * Fetch data
   */


  (0, _createClass3.default)(SecurityManagerStore, [{
    key: 'fetchData',
    value: function fetchData() {
      var _this = this;

      if (!_Izenda14.default.isLoaded) {
        var licenseInfoStore = this.licenseInfoStore;
        var tenantId = _Izenda20.default.getSelectedTenant();
        var allowUpdateTenantId = true;

        return (0, _bluebird.join)(this.accountStore.loadCurrentUser(), licenseInfoStore.getLicenseInfo(), this.integrationSettingStore.getDeploymentMode(), _Izenda4.default.getSystemMode(), (0, _mobx.action)(function (userInfo, licenseInfo, integrationSetting, systemMode) {
          _Izenda16.default.setCurrentUser(userInfo.data);
          _Izenda16.default.setSystemMode(systemMode);
          if (!userInfo.data.systemAdmin) {
            _Izenda20.default.removeSelectedTenant();
            allowUpdateTenantId = false;
          }
          _Izenda16.default.updateLicenseStatus(licenseInfo.expired);
          licenseInfoStore.licenseInfo.readLicenseInforation(licenseInfo);
          _this.integrationSettingStore.integrationSetting.readDeploymentMode(integrationSetting);
          return (0, _bluebird.join)(_this.authorizationStore.loadAllPermissions(), _Izenda2.default.loadTenant(_Izenda16.default.tenantId), (0, _mobx.action)(function (permission, tenantDetail) {
            _Izenda14.default.populate(permission, tenantDetail, true);
            allowUpdateTenantId && tenantId && _Izenda16.default.setTenantId(tenantId);
            return (0, _bluebird.resolve)();
          })).then(_Izenda18.default.loadAppSettings.bind(_Izenda18.default));
        }).bind(this)).then(licenseInfoStore.getLicenseStatus.bind(licenseInfoStore));
      }
    }
  }, {
    key: 'checkAccessPage',


    /**
     * Check access permission on report/dashboard.
     * @param  {Object} props
     * @param  {String} id
     * @param  {Function} checkAccessFn
     */
    value: function checkAccessPage(props, id, checkAccessFn) {
      return this.authorizationStore.loadAccessPriority(id).then(function (result) {
        if (!checkAccessFn) {
          return (0, _bluebird.resolve)(true);
        }

        var canAccessPage = checkAccessFn(result);
        if (!canAccessPage) {
          props.router.push('NoPermission');
        }

        return (0, _bluebird.resolve)(canAccessPage);
      });
    }
  }]);
  return SecurityManagerStore;
}(), (_applyDecoratedDescriptor(_class.prototype, 'fetchData', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fetchData'), _class.prototype)), _class));
exports.default = SecurityManagerStore;
module.exports = exports['default'];

/***/ }),
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.NoPermission.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = function () {
  return _react2.default.createElement(
    'h3',
    null,
    _Izenda2.default.getText('NO_PERMISSION_TEXT')
  );
};

module.exports = exports['default'];

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SecuredInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(17);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecuredInput = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SecuredInput, _Component);

  function SecuredInput(props) {
    (0, _classCallCheck3.default)(this, SecuredInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SecuredInput.__proto__ || (0, _getPrototypeOf2.default)(SecuredInput)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      value: props.value,
      secure: props.secure
    };
    return _this;
  }

  (0, _createClass3.default)(SecuredInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props !== nextProps) {
        this.setState({
          value: nextProps.value,
          secure: nextProps.secure
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props,
          state = this.state;

      var rest = (0, _fp.omit)(['className', 'onChange', 'onReset', 'enabled', 'secure', 'value'], props);
      return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({
        autoComplete: 'new-password',
        className: props.className,
        type: state.secure ? 'password' : 'text',
        onChange: this.guardOnChange,
        value: state.value,
        onFocus: this.reset,
        disabled: !props.enabled
      }, rest));
    }
  }]);
  return SecuredInput;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.string,
  secure: _propTypes2.default.bool,
  enabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onReset: _propTypes2.default.func
}, _class.defaultProps = {
  value: '',
  secure: false,
  enabled: true,
  onChange: function onChange() {},
  onReset: function onReset() {}
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.reset = function () {
    var props = _this2.props;

    if (props.secure) {
      _this2.setState({
        value: '',
        secure: false
      }, function () {
        props.onReset && props.onReset();
      });
    }
  };

  this.guardOnChange = function (e) {
    var props = _this2.props,
        state = _this2.state;

    if (!state.secure) {
      props.onChange(e);
    }
  };
}, _temp);
exports.default = SecuredInput;
module.exports = exports['default'];

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AccessGrid component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(92);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(68);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(146);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(44);

var _Izenda12 = __webpack_require__(30);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(97);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(13);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(17);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(2259);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(29);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(2261);

var _Izenda25 = _interopRequireDefault(_Izenda24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notifyChange = _EventUtils2.default.notifyChange;
var ValidatorDropDown = (0, _Izenda6.default)()(_Izenda23.default);

var AccessGrid = (_dec = (0, _Izenda2.default)(_Izenda25.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AccessGrid, _Component);

  function AccessGrid() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AccessGrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AccessGrid.__proto__ || (0, _getPrototypeOf2.default)(AccessGrid)).call.apply(_ref, [this].concat(args))), _this), _this.goToPage = function (page) {
      var store = _this.props.store;

      store.goToPage(page);
    }, _this.onPageSizeChange = function (value) {
      var store = _this.props.store;

      store.onPageSizeChange(value);
    }, _this.renderSelectCell = function (data, key, rowIndex, column) {
      return _react2.default.createElement('input', {
        type: 'checkbox',
        readOnly: _this.props.readOnly,
        value: data[key],
        checked: data[key],
        onChange: notifyChange(_this.props.onChangeSelectCell.bind(null, data), _EventUtils2.default.CHECKBOX)
      });
    }, _this.renderTextCell = function (data, key, rowIndex, column) {
      var text = data[key] || '';
      return _react2.default.createElement(_Izenda8.default, { tooltip: text, text: text, readOnly: _this.props.readOnly });
    }, _this.renderAction = function (data, key, rowIndex, column) {
      var localization = _this.props.localization;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', {
            title: localization.getText('ACCESS_LABEL_DELETE_ACCESS'),
            className: 'icon-cancel',
            onClick: !_this.props.readOnly && _this.props.deleteAccess.bind(null, data),
            value: rowIndex
          })
        )
      );
    }, _this.renderShareWith = function (data, key, rowIndex, column) {
      var props = _this.props;

      return _react2.default.createElement(_Izenda21.default, {
        isGlobal: props.isGlobal,
        accessors: data.accessors,
        model: props.store.model,
        data: data,
        store: props.store,
        change: _this.props.changeShareWith.bind(null, data),
        users: props.users,
        roles: props.roles,
        loadUsers: props.loadUsers,
        loadRoles: props.loadRoles,
        readOnly: _this.props.readOnly
      });
    }, _this.renderAccessRights = function (data, key, rowIndex, column) {
      var props = _this.props;
      var model = props.store.model;

      var dataOptions = model.getAccessRightByKey(key);
      key = String.format('{0}Id', key);

      return _react2.default.createElement(ValidatorDropDown, {
        validations: _Izenda4.default.CONSTRAINTS.ACCESS_RIGHT,
        blankOption: true,
        options: dataOptions,
        value: data[key],
        valueField: 'id',
        labelField: 'name',
        field: key,
        group: data.tempId,
        onChange: _this.props.changeAccessRight.bind(null, data, key),
        disabled: _this.props.readOnly
      });
    }, _this.renderColumns = function () {
      var props = _this.props;
      var tableDef = props.tableDef,
          model = props.store.model;


      var checkBoxSelectAllProps = {
        onChange: notifyChange(props.checkAll, _EventUtils2.default.CHECKBOX),
        type: 'checkbox',
        checked: model.hasSelectAllActiveAccess,
        disabled: model.hasNoActiveAccess || props.readOnly
      };

      var selectRowDefinition = (0, _fp.merge)(tableDef['selected'], {
        headerComponent: _Izenda19.default,
        headerComponentProps: checkBoxSelectAllProps
      }, {});

      return (0, _fp.map)(function (item) {
        switch (item.key) {
          case 'selected':
            return _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, selectRowDefinition, { cell: _this.renderSelectCell }));
          case 'shareWith':
            return _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, item, { cell: _this.renderShareWith }));
          case 'dashboardAccessRight':
          case 'reportAccessRight':
          case 'accessRight':
            return _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, item, { cell: _this.renderAccessRights }));
          case 'actions':
            return _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, item, { cell: _this.renderAction }));
          default:
            return _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, item, { cell: _this.renderTextCell }));
        }
      }, (0, _fp.values)(tableDef));
    }, _this.renderTable = function () {
      var props = _this.props;
      var model = props.store.model;

      var pageInfo = model.pageInfo;

      return _react2.default.createElement(
        _Izenda11.Table,
        { dataSource: model.visibleAccessList, onSortChange: props.onSortChange, sortInfo: pageInfo.colSortDirs },
        _this.renderColumns()
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Render select cell
   * @param  {Object} data
   * @param  {string} key
   * @param  {number} rowIndex
   * @param  {string} column
   * @return {object}   React components
   */


  /**
   * Render text cell
   */


  /**
   * Render action cell
   * @param  {Object} data
   * @param  {string} key
   * @param  {number} rowIndex
   * @param  {string} column
   * @return {object}   React components
   */


  /**
   * Render share with cell
   * @param  {Object} data
   * @param  {string} key
   * @param  {number} rowIndex
   * @param  {string} column
   * @return {object}   React components
   */


  /**
   * Render access right cell
   * @param  {Object} data
   * @param  {string} key
   * @param  {number} rowIndex
   * @param  {string} column
   * @return {object}   React components
   */


  /**
   * Render columns component
   */


  /**
   * Render table component
   */


  (0, _createClass3.default)(AccessGrid, [{
    key: 'render',


    /**
     * Render component
     */
    value: function render() {
      var props = this.props;
      var model = props.store.model;

      var pageInfo = model.pageInfo;

      var label = props.accessMode === _Izenda4.default.ACCESS_MODE.TENANT ? _Izenda4.default.BUTTON.ADD_DEFAULT_ACCESS : _Izenda4.default.BUTTON.ADD_SHARING_LABEL;
      var currentPageSize = (0, _fp.getOr)(0, 'length', model.visibleAccessList);

      return _react2.default.createElement(
        _Izenda17.default,
        null,
        _react2.default.createElement(
          _Izenda17.default.Row,
          { className: 'u_borderAll  u-bgWhite u_noMarginAll u_paddingTopBottom' },
          _react2.default.createElement(
            _Izenda17.default.Col,
            { cols: '7', className: 'u_noBorder' },
            _react2.default.createElement(_Izenda10.default, {
              options: props.searchOptions,
              value: pageInfo.searchProperty,
              onSearch: props.search,
              onSearchPropertiesChange: props.updateSearchCriteria
            })
          ),
          _react2.default.createElement(
            _Izenda17.default.Col,
            { cols: '5', className: 'u_textRight u_noBorder' },
            _react2.default.createElement(
              'div',
              { className: 'izenda-ActionBarRight' },
              _react2.default.createElement(_Izenda13.default, { label: label, onClick: props.onClickAdd, disabled: props.readOnly }),
              _react2.default.createElement(_Izenda13.default, {
                className: 'icon-trash-empty',
                disabled: !model.hasActiveInstancesSelected || props.readOnly,
                onClick: props.onClickDelete
              })
            )
          )
        ),
        _react2.default.createElement(
          _Izenda17.default.Row,
          { className: 'u_noBorder' },
          _react2.default.createElement(
            _Izenda17.default.Col,
            { cols: '12', className: 'u_noBorder' },
            this.renderTable()
          )
        ),
        _react2.default.createElement(
          _Izenda17.default.Row,
          { className: 'u_noBorder' },
          _react2.default.createElement(
            _Izenda17.default.Col,
            { cols: '12', className: 'u_noBorder' },
            _react2.default.createElement(_Izenda15.default, {
              pageInfo: pageInfo,
              onChange: this.goToPage,
              isDirty: props.checkDirty,
              currentPageSize: currentPageSize,
              onDropdownChange: this.onPageSizeChange
            })
          )
        )
      );
    }
  }]);
  return AccessGrid;
}(_react.Component), _class2.propTypes = {
  store: _mobxReact.propTypes.observableObject,
  users: _mobxReact.propTypes.arrayOrObservableArray,
  roles: _mobxReact.propTypes.arrayOrObservableArray,
  tableDef: _propTypes2.default.object,
  searchOptions: _propTypes2.default.array
}, _temp2)) || _class);
exports.default = AccessGrid;
module.exports = exports['default'];

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionStringDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Connection String Data Fetcher.
 */

exports.default = {
  /*
   * Load list of connection string
   * @returns {promise}
   */
  getAllConnectionString: function getAllConnectionString(tenantId) {
    tenantId = (0, _fp.isEmpty)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)('connection/' + tenantId).get();
  },


  /**
   * Visible a connection
   * @param {string} connectionId
   * @returns {promise}
   */
  visible: function visible(connectionId) {
    return (0, _Izenda2.default)('connection/visible/' + connectionId).post();
  },


  /**
   * Invisible a connection
   * @param {string} connectionId
   * @returns {promise}
   */
  invisible: function invisible(connectionId) {
    return (0, _Izenda2.default)('connection/invisible/' + connectionId).post();
  },


  /**
   * Delete a connection by its id
   * @param {string} connectionId
   * @returns {promise}
   */
  delete: function _delete(connectionId) {
    return (0, _Izenda2.default)('connection/' + connectionId).delete();
  },


  /**
   * Test a connection string (well-format and can work)
   * @param {type} data
   * @returns {promise}
   */
  testConnectionString: function testConnectionString(data) {
    return (0, _Izenda2.default)('connection/verify').post(data);
  },


  /**
   * Load supporting database server types
   * @returns {promise}
   */
  getSupportedDatabaseType: function getSupportedDatabaseType() {
    return (0, _Izenda2.default)('dataadaptor/').get();
  },


  /**
   * Load database name for a connection
   * @param {Object} databaseNameRequest
   * @returns {promise}
   */
  getDatabaseName: function getDatabaseName(databaseNameRequest) {
    return (0, _Izenda2.default)('connection/DatabaseName').post(databaseNameRequest);
  },


  /**
   * Load schema of a database
   * @param {string} connectionString
   * @param {string} serverType
   * @returns {promise}
   */
  getRemoteSchema: function getRemoteSchema(connectionString, serverType) {
    var params = {
      connectionString: connectionString,
      serverTypeId: serverType
    };

    return (0, _Izenda2.default)('connection/loadRemoteSchema').post(params);
  },


  /**
   * Load detail of connection
   * @param {String} connectionId
   * @returns {promise}
   */
  getConnectionString: function getConnectionString(connectionId) {
    return (0, _Izenda2.default)('connection/detail/' + connectionId).get();
  },


  /**
   * Load Source connections
   * @param {String} sourceId
   * @returns {promise}
   */
  getConnectionDetailInfo: function getConnectionDetailInfo(sourceId, isLoadField, params) {
    var paramsText = $izenda.param(params || {});

    return (0, _Izenda2.default)('connection/detailInfo/' + sourceId + '/' + isLoadField + '?' + paramsText).get();
  },


  /**
   * Load Source connections (lazy)
   * @param {Object} request
   * @returns {promise}
   */
  getLazyConnectionDetailInfo: function getLazyConnectionDetailInfo(request) {
    return (0, _Izenda2.default)('connection/detailInfo').post(request);
  },


  /**
   * Update connection details
   * @param {Object} connectionStringDetail
   * @returns {promise}
   */
  updateConnectionString: function updateConnectionString(connectionStringDetail) {
    var postData = connectionStringDetail;

    var pickQuerySourceCategory = (0, _fp.pick)(['id', 'connectionId', 'name']);
    var pickQuerySource = (0, _fp.pick)(['id', 'name', 'type', 'selected', 'physicalChange', 'approval', 'categoryId']);

    var querySources = (0, _fp.map)(function (category) {
      var props = pickQuerySourceCategory(category);
      var querySources = (0, _fp.map)(pickQuerySource, category.querySources);
      return (0, _fp.assign)(props, {
        querySources: querySources
      });
    }, postData.dBSource.querySources);

    postData.dBSource.querySources = querySources;

    return (0, _Izenda2.default)('connection').post(postData);
  },


  /**
   * Validate schema
   * @param {Object} connectionStringDetail
   * @returns {promise}
   */
  validateSchema: function validateSchema(connectionStringDetail) {
    return (0, _Izenda2.default)('connection/validateSchema').post(connectionStringDetail);
  },


  /**
   * reload remote schema
   * @param {Object} connectionDetail
   * @returns {promise}
   */
  reloadRemoteSchema: function reloadRemoteSchema(connectionDetail) {
    var params = {
      connectionId: connectionDetail.id,
      connectionString: connectionDetail.connectionString,
      serverTypeId: connectionDetail.serverTypeId
    };

    return (0, _Izenda2.default)('connection/reloadRemoteSchema').post(params);
  }
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

var _bluebird = __webpack_require__(18);

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Relationship View Model
 */
!function () {
  var m = __webpack_require__(5);
  var dataModelDataFetcher = __webpack_require__(191);
  var reportDesignerFetcher = __webpack_require__(90);
  var Paging = __webpack_require__(98);
  var RelationshipDetail = __webpack_require__(2293);
  var BUNDLE = __webpack_require__(160).BUNDLE;
  var objectState = __webpack_require__(58);
  var constants = __webpack_require__(16);
  var uiState = __webpack_require__(15);
  var CommonMessages = __webpack_require__(37);

  var _require = __webpack_require__(1),
      find = _require.find,
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      some = _require.some,
      clone = _require.clone,
      map = _require.map,
      assign = _require.assign,
      placeholder = _require.placeholder,
      flatten = _require.flatten,
      omitBy = _require.omitBy,
      isNil = _require.isNil,
      maxBy = _require.maxBy,
      findIndex = _require.findIndex;

  function RelationshipVM(querySource) {
    var colSortDirs = {
      PositionId: 'ASC'
    };
    this.querySource = querySource;
    this.querySourceId = !!querySource ? querySource.id : null;
    this.dataObjectName = !!querySource ? querySource.name : '';
    this.databaseId = !!querySource ? querySource.connectionId : null;
    this.editable = true;
    this.modifiedRelationships = [];

    m.extendObservable(this, {
      joinTypes: [],
      databases: [],
      relationshipList: [],
      isLoading: true,
      pageInfo: new Paging(),
      alertMessage: CommonMessages.EMPTY_MESSAGE,
      showInvalidScreen: false,
      showInvalidMessage: false,
      hasChange: function hasChange() {
        if (this.showInvalidScreen) {
          return true;
        }

        return some(['isDirty', true], this.relationshipList);
      },
      defaultSort: function defaultSort() {
        return this.relationshipList.length > 0 ? colSortDirs : {};
      }
    });
  }

  RelationshipVM.prototype.initData = function (isPopup) {
    this.disposeObserveTenantID = m.observe(uiState, 'tenantId', function () {
      this.setShowInvalidScreen(false);
      this.goToPage(1);
    }.bind(this));

    if (this.showInvalidScreen) {
      this.modifiedRelationships = [];
      this.syncModifiedRelationships();
    }

    this.resetData();
    !isPopup && uiState.setCheckDirtyFunction(function () {
      return this.hasChange;
    }.bind(this));

    return !this.showInvalidScreen ? (0, _bluebird.join)(this.getRelationships(), this.getJoinTypes()) : (0, _bluebird.join)(this.getInvalidRelationships(), this.getJoinTypes());
  };

  RelationshipVM.prototype.destroy = function (isPopup) {
    !isPopup && uiState.resetCheckDirtyFunction();
    this.setShowInvalidScreen(false);
    this.disposeObserveTenantID();
  };

  /**
   * Get init data (list of stored procedure)
   */
  RelationshipVM.prototype.resetData = function () {
    this.relationshipList = [];
    this.isLoading = true;
    var DefaultSortCollection = BUNDLE.SORTDEFAULTLIST;
    var colSortDir = clone(DefaultSortCollection.DEFAULT_SORT);
    this.pageInfo = new Paging(colSortDir, BUNDLE.DEFAULT_CRITERIA);
  };

  /**
   * get relationship List from db
   */
  RelationshipVM.prototype.getRelationships = function () {
    var pageInfo = {
      pageSize: this.pageInfo.pageSize,
      pageIndex: this.pageInfo.pageIndex
    };

    // TODO for sort
    this.pageInfo.buildPagingRequest();
    var sortOrders = this.pageInfo.sortOrders;

    return (0, _bluebird.join)(dataModelDataFetcher.getRelationships(this.querySourceId, uiState.getTenantId(), pageInfo, sortOrders, this.pageInfo.searchCriteria), dataModelDataFetcher.getBasicConnectionsInfo(uiState.getTenantId()),
    // populate data only after get list of database name for that tenant/system setting
    this.populateData.bind(this));
  };

  /**
   * get modified relationships
   */
  RelationshipVM.prototype.getModifiedRelationships = function () {
    var updateList = filter(function (o) {
      return o.state != objectState.NONE;
    }, this.relationshipList);

    // create list of Relationship
    var newData = map(function (item) {
      return {
        id: item.id,
        joinConnectionId: item.joinConnectionId,
        foreignConnectionId: item.foreignConnectionId,
        joinQuerySourceId: item.joinQuerySourceId,
        foreignQuerySourceId: item.foreignQuerySourceId,
        joinFieldId: item.joinFieldId,
        foreignFieldId: item.foreignFieldId,
        alias: item.alias,
        systemRelationship: item.systemRelationship,
        joinType: item.joinType,
        modified: item.modified,
        positionId: item.positionId,
        position: parseInt(item.position),
        state: item.state
      };
    }, updateList);

    return newData;
  };

  /**
   * Sync modified relationship in invalid screen
   */
  RelationshipVM.prototype.syncModifiedRelationships = function () {
    var _this = this;

    var newData = this.getModifiedRelationships();
    if (!isEmpty(newData)) {
      // Store all modified relationship for Invalid Screen sort/search
      if (isEmpty(this.modifiedRelationships)) {
        this.modifiedRelationships = [].concat((0, _toConsumableArray3.default)(this.modifiedRelationships), (0, _toConsumableArray3.default)(newData));
      } else {
        map(function (item) {
          if (!some(['position', item.position], _this.modifiedRelationships)) {
            _this.modifiedRelationships.push(item);
          } else {
            // Replace data for the relationship on original array
            var indexInModified = _this.getIndexOfModified(item);
            _this.modifiedRelationships[indexInModified] = assign(_this.modifiedRelationships[indexInModified], item);
          }
        }, newData);
      }
    }
  };

  /**
   * get invalid relationship List from db
   */
  RelationshipVM.prototype.getInvalidRelationships = function () {
    this.syncModifiedRelationships();
    this.pageInfo.buildPagingRequest();
    var sortOrders = this.pageInfo.sortOrders;

    return (0, _bluebird.join)(dataModelDataFetcher.getInvalidRelationships(this.querySourceId, uiState.getTenantId(), sortOrders, this.pageInfo.searchCriteria, this.modifiedRelationships), dataModelDataFetcher.getBasicConnectionsInfo(uiState.getTenantId()),
    // populate data only after get list of database name for that tenant/system setting
    this.populateData.bind(this));
  };

  /**
   * Create list of query source details
   * @param {array} spDetails
   */
  RelationshipVM.prototype.populateData = function (relationships, databaseList) {
    var _this2 = this;

    this.databases = databaseList || [];
    var editable = this.editable;
    var showInvalidScreen = this.showInvalidScreen;

    relationships = relationships || {};
    var relationshipList = relationships.result;

    // create list of Relationship
    var newData = map(function (querySource) {
      var newRelationship = new RelationshipDetail(querySource);
      newRelationship.setEditable(editable);
      if (showInvalidScreen) {
        var indexInModified = _this2.getIndexOfModified(newRelationship);
        indexInModified !== -1 && (_this2.modifiedRelationships[indexInModified].invalid = querySource.invalid);
        newRelationship.markDirty();
      }
      return newRelationship;
    }, relationshipList);

    // update to model
    this.relationshipList = newData;

    // update page info
    var pageInfo = this.pageInfo;
    pageInfo.setTotalRecords(relationships.total);
    return null;
  };

  /**
   * Create list of invalid errors
   * @param {array} fieldCheck
   */
  RelationshipVM.prototype.getInvalidErrors = function (fieldCheck) {
    var allError = map(function (item) {
      var errors = m.toJS(item.errors);
      if (!isEmpty(errors)) {
        var relationshipErrors = find({ key: 'Relationships' }, errors);
        if (relationshipErrors) {
          map(function (field) {
            if (field == 'positionId') return;
            errors.push({
              key: relationshipErrors.key + '[' + item.position + ']' + field,
              messages: relationshipErrors.messages
            });
          }, fieldCheck);
        }

        return errors;
      }
    }, this.relationshipList);

    return omitBy(isNil, flatten(allError));
  };

  RelationshipVM.prototype.getCriteriaList = function () {
    var criteriaCollection = !!this.querySource ? BUNDLE.DATASOURCE_CRITERIA_LIST : BUNDLE.DEFAULT_CRITERIA_LIST;
    return criteriaCollection;
  };

  /**
   * Go to page
   * @param {number} pageIndex
   * @returns
   */
  RelationshipVM.prototype.goToPage = function (pageIndex) {
    this.pageInfo.setPageIndex(pageIndex);
    this.getRelationships();
  };

  /**
   * Get data for Join Type dropdown list
   */
  RelationshipVM.prototype.getJoinTypes = function () {
    var assignJoinTypes = function (result) {
      result = result || {};
      // create list of join type
      this.joinTypes = map(function (item) {
        return {
          value: item,
          key: item
        };
      }, result);
    }.bind(this);

    return dataModelDataFetcher.getJoinTypes().then(assignJoinTypes);
  };

  RelationshipVM.prototype.validateModifiedRelationships = function () {
    // Validate on invalid relationship screen
    if (this.showInvalidScreen) {
      this.syncModifiedRelationships();
      return dataModelDataFetcher.validateRelationships(this.modifiedRelationships);
    }

    // Validate on normal relationship screen
    var newData = this.getModifiedRelationships();
    if (newData.length > 0) {
      return dataModelDataFetcher.validateRelationships(newData);
    } else {
      return (0, _bluebird.resolve)({ success: true });
    }
  };

  /**
   * Validate all relationships
   */
  RelationshipVM.prototype.validate = function () {
    var isValid = true;

    m.transaction(function () {
      this.relationshipList.forEach(function (relationship) {
        isValid = relationship.validate() && isValid;
      });
    }.bind(this));

    return isValid;
  };

  /**
   * Show error message for each relationship
   */
  RelationshipVM.prototype.processErrorAfterSave = function (result) {
    var relationshipErrors = result.relationshipErrors;
    var requestError = result.messages;

    // reset error to ensure only show new error
    var list = map(function (item) {
      item.generalEror = '';
      return item;
    }, this.relationshipList);

    if (!isEmpty(relationshipErrors)) {
      m.transaction(function () {
        placeholder(relationshipErrors).forEach(function (err) {
          var item = $izenda.grep(list, function (value) {
            return value.position === err.id;
          });

          if (!isEmpty(item)) {
            item[0].generalEror = err.message;
          }
        });
      });
    }
    if (!isEmpty(requestError)) {
      return requestError;
    }
  };

  /**
   * save all relationships
   */
  RelationshipVM.prototype.save = function () {
    var newData = this.getModifiedRelationships();

    if (newData.length > 0) {
      return dataModelDataFetcher.saveRelationships(newData);
    } else {
      return (0, _bluebird.resolve)({ success: true });
    }
  };

  /**
   * delete selected relationship item
   */
  RelationshipVM.prototype.handleDeleteAction = function (relationship) {
    var _this3 = this;

    var handleOnEmptyRelationship = function handleOnEmptyRelationship(relationships) {
      if (!some(function (item) {
        return !isNil(item);
      }, relationships) && isEmpty(_this3.modifiedRelationships)) {
        _this3.setShowInvalidScreen(false);
        _this3.resetData();
        return _this3.getRelationships();
      }
      return (0, _bluebird.resolve)(relationships);
    };

    var removeRelationship = function removeRelationship(relationship) {
      var indexInModified = _this3.getIndexOfModified(relationship);
      _this3.relationshipList.splice(_this3.relationshipList.indexOf(relationship), 1);
      _this3.modifiedRelationships.splice(indexInModified, 1);
    };

    if (!isEmpty(relationship.id)) {
      var handleAfterDeleteRelationship = function handleAfterDeleteRelationship(result) {
        if (result.success) {
          if (_this3.showInvalidScreen) {
            removeRelationship(relationship);
            return _this3.getInvalidRelationships().then(function () {
              return handleOnEmptyRelationship(_this3.relationshipList);
            });
          }
          return _this3.getRelationships();
        }
        return null;
      };

      return dataModelDataFetcher.deleteRelationship(relationship.id).then(handleAfterDeleteRelationship);
    } else {
      removeRelationship(relationship);
      if (this.showInvalidScreen) {
        return this.getInvalidRelationships().then(function () {
          return handleOnEmptyRelationship(_this3.relationshipList);
        });
      } else {
        this.pageInfo.descreaseRecord();
      }
    }
    return (0, _bluebird.resolve)();
  };

  /**
   * get new position
   */
  RelationshipVM.prototype.getNewPosition = function () {
    var maxPosition = maxBy(function (item) {
      return parseInt(item.position);
    }, this.relationshipList);
    return !isNil(maxPosition) && maxPosition.position ? parseInt(maxPosition.position) + 1 : null;
  };

  /**
   * add new relationship
   */
  RelationshipVM.prototype.addNew = function () {
    /**
     * "id": "id",
     * "joinConnectionId": "join connection id",
     * "foreignConnectionId": "foreign connection id",
     * "joinQuerySourceId": "join query source id",
     * "foreignQuerySourceId": "foreign query source id",
     * "joinFieldId": "join field id",
     * "foreignFieldId": "foreign field id",
     * "alias": "alias",
     * "systemRelationship": true/false,
     * "joinType": "join type",
     * "position": "empty string"
     */

    var item = {
      id: null,
      joinConnectionId: this.databaseId,
      foreignConnectionId: null,
      joinQuerySourceId: this.querySourceId,
      foreignQuerySourceId: null,
      joinFieldId: null,
      foreignFieldId: null,
      alias: '',
      systemRelationship: false,
      joinType: 'Inner',
      position: this.getNewPosition()
    };

    var relationship = new RelationshipDetail(item);
    this.relationshipList.unshift(relationship);
    relationship.markDirty();
    this.pageInfo.increaseRecord();

    return (0, _bluebird.resolve)();
  };

  /**
   * Copy selected relationships
   */
  RelationshipVM.prototype.copy = function (source) {
    var item = {
      id: null,
      joinConnectionId: source.joinConnectionId,
      foreignConnectionId: source.foreignConnectionId,
      joinQuerySourceId: source.joinQuerySourceId,
      joinQuerySourceName: source.joinQuerySourceName,
      foreignQuerySourceId: source.foreignQuerySourceId,
      foreignQuerySourceName: source.foreignQuerySourceName,
      joinFieldId: source.joinFieldId,
      foreignFieldId: source.foreignFieldId,
      alias: source.alias,
      systemRelationship: false,
      joinType: source.joinType,
      position: this.getNewPosition()
    };

    var indexOfRelationship = this.relationshipList.indexOf(source) + 1;
    var relationship = new RelationshipDetail(item);
    relationship.markDirty();
    this.relationshipList.splice(indexOfRelationship, 0, relationship);
    this.pageInfo.increaseRecord();

    return (0, _bluebird.resolve)();
  };

  /**
   * Reset new value to default
   * Relationship which is not allow to add new value
   * from dropdown list
   * {Params} value, label, isNew (flag)
   */
  RelationshipVM.prototype.resetNewValueToDefault = function (value, label, isNew) {
    return isNew ? { value: '', label: '', isNew: isNew } : { value: value, label: label, isNew: isNew };
  };

  /**
   * Check this relationship is used in report
   * @param {type} relationship
   */
  RelationshipVM.prototype.hasReportUseRelationship = function (relationship) {
    return reportDesignerFetcher.hasReportUseRelationship(relationship.id);
  };

  /**
   * set alert message
   * @param {String} type
   * @param {String} message
   */
  RelationshipVM.prototype.setAlertMessage = function (type, message) {
    this.alertMessage = {
      type: type,
      message: message
    };
  };

  /**
   * Check join type between two entities in one relationship
   * @param {object} currentRow
   */
  RelationshipVM.prototype.checkExistEntities = function (currentRow) {
    var newJoinType = currentRow.joinType;
    if (!currentRow.joinQuerySourceId || !currentRow.foreignQuerySourceId) {
      return null;
    }

    return find(function (dataSource) {
      if (currentRow === dataSource) {
        return false;
      }
      return dataSource.joinQuerySourceId === currentRow.joinQuerySourceId && dataSource.foreignQuerySourceId === currentRow.foreignQuerySourceId && dataSource.joinType !== newJoinType || dataSource.joinQuerySourceId === currentRow.foreignQuerySourceId && dataSource.foreignQuerySourceId === currentRow.joinQuerySourceId && (dataSource.joinType !== newJoinType && (dataSource.joinType !== constants.JOIN_TYPE.LEFT || newJoinType !== constants.JOIN_TYPE.RIGHT) && (dataSource.joinType !== constants.JOIN_TYPE.RIGHT || newJoinType !== constants.JOIN_TYPE.LEFT) || dataSource.joinType === constants.JOIN_TYPE.LEFT && newJoinType === constants.JOIN_TYPE.LEFT || dataSource.joinType === constants.JOIN_TYPE.RIGHT && newJoinType === constants.JOIN_TYPE.RIGHT);
    }, this.relationshipList);
  };

  /**
   * Update join type between two entities in one relationship
   * @param {type} currentRow
   */
  RelationshipVM.prototype.updateJoinTypeForSameEntities = m.action(function (currentRow) {
    if (!currentRow.joinQuerySourceId || !currentRow.foreignQuerySourceId) {
      return null;
    }

    // clear Field/JoinField when joinType is CROSS
    if (currentRow.joinType === constants.JOIN_TYPE_CROSS) {
      currentRow.joinFieldId = null;
      currentRow.foreignFieldId = null;
    }

    map(function (dataSource) {
      if (currentRow === dataSource || dataSource.state === constants.OBJECT_STATE.DELETE) {
        return false;
      }

      if (dataSource.joinQuerySourceId === currentRow.foreignQuerySourceId && dataSource.foreignQuerySourceId === currentRow.joinQuerySourceId || dataSource.joinQuerySourceId === currentRow.joinQuerySourceId && dataSource.foreignQuerySourceId === currentRow.foreignQuerySourceId && (dataSource.joinType !== currentRow.joinType && (dataSource.joinType !== constants.JOIN_TYPE.LEFT || currentRow.joinType !== constants.JOIN_TYPE.RIGHT) && (dataSource.joinType !== constants.JOIN_TYPE.RIGHT || currentRow.joinType !== constants.JOIN_TYPE.LEFT) || dataSource.joinType === constants.JOIN_TYPE.LEFT && currentRow.joinType === constants.JOIN_TYPE.LEFT || dataSource.joinType === constants.JOIN_TYPE.RIGHT && currentRow.joinType === constants.JOIN_TYPE.RIGHT)) {
        switch (currentRow.joinType) {
          case constants.JOIN_TYPE.LEFT:
            dataSource.setJoinType(constants.JOIN_TYPE.RIGHT);
            break;
          case constants.JOIN_TYPE.RIGHT:
            dataSource.setJoinType(constants.JOIN_TYPE.LEFT);
            break;
          default:
            dataSource.setJoinType(currentRow.joinType);
        }
      }

      if (dataSource.joinQuerySourceId === currentRow.joinQuerySourceId && dataSource.foreignQuerySourceId === currentRow.foreignQuerySourceId && dataSource.joinType !== currentRow.joinType) {
        dataSource.setJoinType(currentRow.joinType);
      }

      if (dataSource.joinType === constants.JOIN_TYPE_CROSS) {
        dataSource.joinFieldId = null;
        dataSource.foreignFieldId = null;
      }
    }, this.relationshipList);
  });

  /**
   * Get index of a modified relationship in modifiedRelationships
   * @param {object} relationship
   */
  RelationshipVM.prototype.getIndexOfModified = function (relationship) {
    return findIndex(function (item) {
      return item.position == relationship.position;
    }, this.modifiedRelationships);
  };

  /**
   * Set editable for fields in Relationship List
   * @param {boolean} isEditable
   */
  RelationshipVM.prototype.setEditable = function (isEditable) {
    this.editable = isEditable;
  };

  /**
   * Toggle Invalid Screen
   * @param {boolean} isInvalid
   */
  RelationshipVM.prototype.setShowInvalidScreen = function (isInvalid) {
    this.showInvalidScreen = isInvalid;
  };

  module.exports = RelationshipVM;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Relationship List component
 */
!function () {
  var commonMessages = __webpack_require__(37);

  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var m = __webpack_require__(5);
  var observable = __webpack_require__(5).observable;
  var connect = __webpack_require__(2);
  var Dimensions = __webpack_require__(83);
  var uiState = __webpack_require__(15);

  var ScrollBox = __webpack_require__(27);
  var Table = __webpack_require__(44).Table;
  var Column = __webpack_require__(44).Column;
  var Paginator = __webpack_require__(97);

  var JoinTypeColumn = __webpack_require__(2297);
  var PositionIdColumn = __webpack_require__(2298);
  var DatabaseColumn = __webpack_require__(2299);
  var DataObjectColumn = __webpack_require__(2300);
  var JoinFieldColumn = __webpack_require__(2301);
  var ForeignDatabaseColumn = __webpack_require__(2302);
  var ForeignDataObjectColumn = __webpack_require__(2303);
  var ForeignJoinFieldColumn = __webpack_require__(2304);
  var ActionColumn = __webpack_require__(2305);
  var constants = __webpack_require__(16);
  var DataModelConstants = __webpack_require__(198);
  var fieldCheck = __webpack_require__(160).FIELDCHECK;
  var TableDefinition = DataModelConstants.TableDefinition;

  var _require = __webpack_require__(1),
      getOr = _require.getOr;

  var RelationshipList = React.createClass({
    displayName: 'RelationshipList',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      isPopup: React.PropTypes.bool,
      isHideActionColumn: React.PropTypes.bool,
      isHidePaging: React.PropTypes.bool,
      isSort: React.PropTypes.bool
    },

    componentWillMount: function componentWillMount() {
      this.size = observable({ height: 0 });

      var validation = this.props.validation;
      this.disposeObserveTenantID = m.observe(uiState, 'tenantId', function () {
        validation.reset();
      });
    },

    componentDidMount: function componentDidMount() {
      var dom = ReactDOM.findDOMNode(this);
      var domHeight = dom.clientHeight;
      domHeight > 0 && domHeight !== this.size.height && (this.size.height = domHeight);
    },

    componentWillUnmount: function componentWillUnmount() {
      this.disposeObserveTenantID();
    },

    getDefaultProps: function getDefaultProps() {
      return {
        isSort: true
      };
    },

    onSortChange: function onSortChange(columnKey, sortDir) {
      var _this = this;

      if (!this.props.isSort) {
        return;
      }

      var _props = this.props,
          store = _props.store,
          validation = _props.validation;


      var refreshData = function refreshData() {
        _this.props.validation.reset();
        store.pageInfo.setColSortDirs(columnKey, sortDir);

        if (store.showInvalidScreen) {
          return store.getInvalidRelationships().then(function () {
            var allErrors = store.getInvalidErrors(fieldCheck);
            validation.updateErrors(allErrors);
          });
        }

        return store.getRelationships();
      };
      // Sorting in Invalid Screen
      if (store.showInvalidScreen) {
        return refreshData();
      }

      return this.props.confirmDirtyForm(store.hasChange).then(refreshData);
    },

    onPageSizeChange: function onPageSizeChange(pageSize) {
      var _this2 = this;

      return this.props.confirmDirtyForm(this.props.store.hasChange).then(function () {
        _this2.props.validation.reset();
        _this2.props.store.pageInfo.setPageSize(pageSize);
        return _this2.goToPage(1);
      });
    },

    goToPage: function goToPage(pageIndex) {
      var _this3 = this;

      return this.props.confirmDirtyForm(this.props.store.hasChange).then(function () {
        _this3.props.validation.reset();
        _this3.props.store.goToPage(pageIndex);
      });
    },

    /**
     * render main function
     */
    render: function render() {
      var store = this.props.store;
      var props = this.props;
      var size = this.size;

      var relationshipList = store.relationshipList;
      var currentPageSize = getOr(0, 'length', relationshipList);
      var TABLE_DEF = TableDefinition.Relationship;

      var actualHeight = (props.height || size.height || DataModelConstants.DEFAULT_TABLE_HEIGHT) - DataModelConstants.DEFAULT_REST_HEIGHT;
      return React.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        React.createElement(
          ScrollBox,
          null,
          React.createElement(
            'section',
            { className: 'u_paddingLeftRight u_fullHeight' },
            React.createElement(
              Table,
              {
                dataSource: relationshipList,
                rowProps: this.getRowProps,
                onSortChange: this.onSortChange,
                sortInfo: props.isSort ? store.pageInfo.colSortDirs : '',
                minHeight: actualHeight,
                maxHeight: actualHeight,
                isLoading: props.isLoading
              },
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['joinType'], { cell: JoinTypeColumn.bind(this) })),
              !this.props.isPopup && React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['positionId'], { cell: PositionIdColumn.bind(this) })),
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['dbName'], { cell: DatabaseColumn.bind(this) })),
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['dataObject'], { cell: DataObjectColumn.bind(this) })),
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['joinField'], { cell: JoinFieldColumn.bind(this) })),
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['equal'], { cell: React.createElement(
                  'div',
                  { className: 'equal-sign-in-cell u_textCenter' },
                  '='
                ) })),
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['frDbName'], { cell: ForeignDatabaseColumn.bind(this) })),
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['frDataObject'], { cell: ForeignDataObjectColumn.bind(this) })),
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['frField'], { cell: ForeignJoinFieldColumn.bind(this) })),
              !this.props.isHideActionColumn && React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['action'], { cell: ActionColumn.bind(this) }))
            ),
            !this.props.isHidePaging && React.createElement(Paginator, {
              onChange: this.goToPage,
              onDropdownChange: this.onPageSizeChange,
              pageInfo: store.pageInfo,
              currentPageSize: currentPageSize
            })
          )
        )
      );
    },
    getRowProps: function getRowProps(spDetails) {
      var store = this.props.store;

      if (!store.selectedQuerySource) {
        return null;
      }

      return {
        className: spDetails.isSelected ? 'selected-row' : ''
      };
    },

    /**
     * check existing entities with current relationship
     * @param {Object} relationshipItem
     * @param {String} currentValue
     * @param {Function} rollbackValueFunc
     */
    checkExistEntities: function checkExistEntities(relationshipItem, currentValue, rollbackValueFunc) {
      var props = this.props;
      var store = props.store;
      var existedItem = store.checkExistEntities(relationshipItem);

      var updateValue = function updateValue() {
        store.updateJoinTypeForSameEntities(relationshipItem, true);
      };
      var rollbackValue = function rollbackValue() {
        rollbackValueFunc.call(relationshipItem, currentValue);
      };

      if (existedItem) {
        var message = String.format(constants.BUNDLE.MESSAGE.CHANGE_JOIN_TYPE, existedItem.joinQuerySourceName, existedItem.foreignQuerySourceName);

        props.confirmFn('Confirmation', { description: message }).then(updateValue).catch(rollbackValue);
      } else {
        updateValue();
      }
    }
  });

  module.exports = connect(Dimensions)(RelationshipList);
}();

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceFieldDetailsStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// should be consistent to backend


var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(198);

var _Izenda4 = __webpack_require__(228);

var _Izenda5 = __webpack_require__(58);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(159);

var _mobx = __webpack_require__(5);

var _Izenda8 = __webpack_require__(54);

var _Izenda9 = _interopRequireDefault(_Izenda8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var QuerySourceFieldDetailsStore = (0, _Izenda9.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(QuerySourceFieldDetailsStore, [{
    key: 'isVisible',


    /**
     * Is visible
     */
    get: function get() {
      return this.details.visible;
    }

    /**
     * Is filterable
     */

  }, {
    key: 'isFilterable',
    get: function get() {
      return this.details.filterable;
    }

    /**
     * Is match tenant
     */

  }, {
    key: 'isMatchTenant',
    get: function get() {
      return this.details.matchedTenant;
    }

    /**
     * Is parameter
     */

  }, {
    key: 'isParameter',
    get: function get() {
      return this.details.type === _Izenda7.FIELD_TYPE.PARAM;
    }

    /**
     * Is disable visible
     */

  }, {
    key: 'isDisabledVisible',
    get: function get() {
      return this.details.matchedTenant && !this.showTenantFieldValue || this.details.physicalChange === _Izenda3.DETECTED_CHANGE_LEVEL.DELETED;
    }

    /**
     * Is diasble filterable
     */

  }, {
    key: 'isDisabledFilterable',
    get: function get() {
      return this.details.isCompositeField || this.details.isRunningField || this.details.matchedTenant && !this.showTenantFieldValue || !this.details.visible;
    }

    /**
     * Is disable filter lookup
     */

  }, {
    key: 'isDisableFilterLookup',
    get: function get() {
      return this.details.physicalChange === _Izenda3.DETECTED_CHANGE_LEVEL.DELETED;
    }

    /**
     * Is change to invisible
     */

  }, {
    key: 'isChangeToInvisible',
    get: function get() {
      return this.isVisible == false && this.visibleChanged == true;
    }

    /**
     * Is change to unfilterable
     */

  }, {
    key: 'isChangeToUnfilterable',
    get: function get() {
      return this.isFilterable == false && this.filterableChanged == true;
    }

    /**
     * Is new field
     */

  }, {
    key: 'isNewField',
    get: function get() {
      return this.details.approval < _Izenda3.APPROVAL_LEVEL.QUERY_SOURCE_FIELD && this.details.physicalChange === _Izenda3.DETECTED_CHANGE_LEVEL.ADDED;
    }

    /**
     * Is invalid filter lookup
     */

  }, {
    key: 'isInvalidFilterLookup',
    get: function get() {
      return this.details.filterLookupStatus !== _Izenda4.FILTER_LOOKUP_STATUSES.VALID;
    }
  }]);

  function QuerySourceFieldDetailsStore(details) {
    (0, _classCallCheck3.default)(this, QuerySourceFieldDetailsStore);

    _initDefineProp(this, 'visibleChanged', _descriptor, this);

    _initDefineProp(this, 'filterableChanged', _descriptor2, this);

    _initDefineProp(this, 'details', _descriptor3, this);

    _initDefineProp(this, 'aliasError', _descriptor4, this);

    this.showTenantFieldValue = _Izenda2.default.advancedSettings.security.showTenantFieldValue;
    details.filteredValue = JSON.parse(details.filteredValue || '{}');
    this.details = details;
  }

  /**
   * Get data type
   */


  (0, _createClass3.default)(QuerySourceFieldDetailsStore, [{
    key: 'getDataType',
    value: function getDataType() {
      return this.details.dataType || this.details.izendaDataType;
    }

    /**
     * Get column name
     */

  }, {
    key: 'getColumnName',
    value: function getColumnName() {
      return this.details.name;
    }

    /**
     * Get column alias
     */

  }, {
    key: 'getColumnAlias',
    value: function getColumnAlias() {
      return this.details.alias;
    }

    /**
     * Get filter lookup status
     */

  }, {
    key: 'getFilterLookupStatus',
    value: function getFilterLookupStatus() {
      return this.details.filterLookupStatus;
    }

    /**
     * Set column alias
     * @param {string} newAlias 
     */

  }, {
    key: 'setColumnAlias',
    value: function setColumnAlias(newAlias) {
      this.aliasError && (this.aliasError = '');
      this.details.alias = newAlias;
      this.setUpdateState();
      this.markDirty();
    }

    /**
     * Set update state
     */

  }, {
    key: 'setUpdateState',
    value: function setUpdateState() {
      this.details.state === _Izenda6.default.NONE && (this.details.state = _Izenda6.default.UPDATE);
    }

    /**
     * Get filter values
     */

  }, {
    key: 'getFilterValues',
    value: function getFilterValues() {
      return this.details.filteredValue;
    }

    /**
     * Set filter values
     * @param {string} newValue 
     */

  }, {
    key: 'setFilterValues',
    value: function setFilterValues(newValue) {
      this.details.filteredValue = newValue;
      this.markDirty();
    }

    /**
     * Set visible
     * @param {boolean} newValue 
     */

  }, {
    key: 'setVisible',
    value: function setVisible(newValue) {
      this.details.visible = newValue;
      !newValue && (this.details.filterable = newValue);
      this.setUpdateState();
      this.markDirty();
      this.markVisibeDirty();
    }

    /**
     * Set filterable
     * @param {boolean} newValue 
     */

  }, {
    key: 'setFilterable',
    value: function setFilterable(newValue) {
      this.details.filterable = newValue;
      this.setUpdateState();
      this.markDirty();
      this.markFilterableDirty();
    }

    /**
     * Mark visible dirty
     */

  }, {
    key: 'markVisibeDirty',
    value: function markVisibeDirty() {
      this.visibleChanged = true;
    }

    /**
     * Mark filterable dirty
     */

  }, {
    key: 'markFilterableDirty',
    value: function markFilterableDirty() {
      this.filterableChanged = true;
    }

    /**
     * Get details
     */

  }, {
    key: 'getDetails',
    value: function getDetails() {
      return this.details;
    }

    /**
     * Set valid filter lookup
     */

  }, {
    key: 'setValidFilterLookup',
    value: function setValidFilterLookup() {
      this.details.filterLookupStatus = _Izenda4.FILTER_LOOKUP_STATUSES.VALID;
    }
  }]);
  return QuerySourceFieldDetailsStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'visibleChanged', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'filterableChanged', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'details', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'aliasError', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'isVisible', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isVisible'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isFilterable', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isFilterable'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isMatchTenant', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isMatchTenant'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isParameter', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isParameter'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isDisabledVisible', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isDisabledVisible'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isDisabledFilterable', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isDisabledFilterable'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isDisableFilterLookup', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isDisableFilterLookup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isChangeToInvisible', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isChangeToInvisible'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isChangeToUnfilterable', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isChangeToUnfilterable'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isNewField', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isNewField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isInvalidFilterLookup', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isInvalidFilterLookup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setColumnAlias', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setColumnAlias'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setFilterValues', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setFilterValues'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setVisible', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setVisible'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setFilterable', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setFilterable'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setValidFilterLookup', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setValidFilterLookup'), _class2.prototype)), _class2)) || _class;

exports.default = QuerySourceFieldDetailsStore;
module.exports = exports['default'];

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionAccessStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var accessFetcher = __webpack_require__(227);
  var AccessConstants = __webpack_require__(92);
  var PermissionAccess = __webpack_require__(325);

  function PermissionAccessStore(model) {
    var props = {
      model: model || new PermissionAccess()
    };
    this.accessOrigin = null;
    m.extendObservable(this, props);
  }

  /**
   * Load access for search/sort...
   * @param {object}    access data
   * @return {object} Promise
   */
  PermissionAccessStore.prototype.loadAllAccess = function (data) {
    var model = this.model;
    model.pageInfo.buildPagingRequest();

    return accessFetcher.loadAccesses(data, model.pageInfo).then(m.action(function (access) {
      this.model.populateAccessDetails(access);
      return (0, _bluebird.resolve)(true);
    }.bind(this)));
  };

  /**
   * Handle when page size change
   * @param {int}    page number
   * @return {object} Promise
   */
  PermissionAccessStore.prototype.onPageSizeChange = function (pageSize) {
    this.model.pageInfo.setPageSize(pageSize);
    return this.goToPage(1);
  };

  /**
   * Handle go to page
   * @param  {int} pageIndex
   * @return {object} Promise
   */
  PermissionAccessStore.prototype.goToPage = function (pageIndex) {
    var pageInfo = this.model.pageInfo;
    pageInfo.setPageIndex(pageIndex);
    return this.loadAllAccess(this.accessOrigin);
  };

  /**
   * Search subscription
   * @param  {string} searchProperty
   * @param  {string} searchText
   * @return {object} Promise
   */
  PermissionAccessStore.prototype.search = function (searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);
    return this.goToPage(1);
  };

  /**
    * Change sort orders
    * @param {string} columnKey
    * @param {object} sortDir
    * @return {object} Promise
    */
  PermissionAccessStore.prototype.onSortChange = function (columnKey, sortDir) {
    this.model.pageInfo.setColSortDirs(columnKey, sortDir);
    return this.loadAllAccess(this.accessOrigin);
  };

  /**
   * Update filter criteria information.
   * @param {String} searchProperty
   * @param {String} searchText
   */
  PermissionAccessStore.prototype.updateSearchCriteria = function (searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);
  };

  /**
   * Get all data for tenant access page
   * @param  {string} tenantId tennant id
   * @param  {object} data     current access
   * @return {object}          Promise
   */
  PermissionAccessStore.prototype.initialAccessGrid = m.action(function (data) {
    var model = this.model;
    model.pageInfo.buildPagingRequest();
    this.accessOrigin = data;

    return (0, _bluebird.join)(accessFetcher.loadAccesses(data, model.pageInfo), accessFetcher.loadTenantSettingAccessRight(AccessConstants.ACCESS_MODE.REPORT), accessFetcher.loadTenantSettingAccessRight(AccessConstants.ACCESS_MODE.DASHBOARD), m.action(function (access, reportAccessRights, dashboardAccessRights) {
      this.model.populateAccessDetails(access);
      this.model.populateReportAccessRight(reportAccessRights);
      this.model.populateDashboardAccessRight(dashboardAccessRights);
    }).bind(this));
  });

  /**
   * Update access origin
   * @param  {array} data)
   */
  PermissionAccessStore.prototype.updateAccessOrigin = function (data) {
    this.accessOrigin = data;
  };

  PermissionAccessStore.prototype.updateModel = m.action(function (model) {
    this.model = model;
  });

  module.exports = PermissionAccessStore;
}();

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceTree.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * SourceTree component
 */
!function () {

  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);

  var m = __webpack_require__(5);
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);

  var Panel = __webpack_require__(28);
  var List = __webpack_require__(195);
  var ScrollBox = __webpack_require__(27);
  var CollapsibleList = __webpack_require__(410);
  var DropDown = __webpack_require__(29);
  var SourceTreeItem = __webpack_require__(2385);
  var SearchTextBox = __webpack_require__(107);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      isFunction = _require.isFunction;

  function createTreeItem(tree, store, props) {
    return function (node) {
      return React.createElement(SourceTreeItem, {
        key: node.id,
        node: node,
        store: store,
        filter: tree.filter.text,
        showCheckbox: props.showCheckbox,
        showIcon: props.showIcon,
        showSelected: props.showSelected
      });
    };
  }

  /**
   * check rules of display nodes/fields of QuerySourceTree
   * @param  {Object}  querySourceNode
   * @param  {Boolean} showFieldNode
   * @return {Boolean} should display TreeNode (true) or TreeItem (false)
   */
  function checkDisplayingNode(querySourceNode, showFieldNode) {
    // only display TreeNode if childNodes have items or this node is TypeGroup
    if (!isEmpty(querySourceNode.childNodes) || querySourceNode.isTypeGroup()) {
      // only display TreeNode if this node is FieldNode & showFieldNode is ON
      return querySourceNode.isFieldNode && showFieldNode || !querySourceNode.isFieldNode ? true : false;
    }
    return false;
  }

  /**
   * display TreeNode/TreeItem of QuerySourceTree
   * @param  {Object}  tree
   * @param  {Object}  store
   * @param  {Object}  querySourceNode
   * @param  {Object} props
   * @return {Object} TreeNode/TreeItem
   */
  function treeNode(tree, store, querySourceNode, props) {
    var treeItem = createTreeItem(tree, store, props);

    return checkDisplayingNode(querySourceNode, props.showFieldNode) ? React.createElement(
      CollapsibleList,
      {
        className: 'panel-group collapsible-list-items datasource',
        key: querySourceNode.id,
        autoCollapse: false,
        defaultExpand: true
      },
      React.createElement(
        CollapsibleList.Item,
        { expanded: true, key: querySourceNode.id },
        React.createElement(
          CollapsibleList.ItemHeader,
          { className: 'panel-heading' },
          treeItem(querySourceNode)
        ),
        React.createElement(
          CollapsibleList.ItemBody,
          { className: 'panel-body' },
          React.createElement(
            List,
            { className: 'list-group', key: querySourceNode.id },
            querySourceNode.childNodes.map(function (child) {
              return renderChildNode(querySourceNode, child);
            })
          )
        )
      )
    ) : treeItem(querySourceNode);

    function renderChildNode(querySourceNode, child) {
      if (isFunction(props.showSelected)) {
        if (props.showSelected(child)) {
          return querySourceNode.isFieldNode ? treeItem(child) : treeNode(tree, store, child, props);
        } else {
          return null;
        }
      }

      return props.showSelected && !child.checked ? querySourceNode.isFieldNode ? treeItem(child) : null : treeNode(tree, store, child, props);
    }
  }

  function searchBox(tree, store) {
    var notifyChange = EventUtils.notifyChange;

    var invisibleClassName = classnames('search-box', {
      invisible: !store.item.haveDataSource
    });

    return React.createElement(
      'div',
      { className: 'search-box' },
      React.createElement(SearchTextBox, {
        value: tree.filter.text,
        onChange: notifyChange(tree.setFilter.bind(tree), EventUtils.INPUT),
        disabled: !store.item.haveDataSource
      })
    );
  }

  var SourceTree = React.createClass({
    displayName: 'SourceTree',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      tree: React.PropTypes.object.isRequired,
      title: React.PropTypes.string.isRequired,
      showSelected: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.bool]),
      showCheckbox: React.PropTypes.bool,
      showFieldNode: React.PropTypes.bool,
      showIcon: React.PropTypes.bool
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var tree;

      if (props.isDataModel) {
        tree = store.item.querySourceTree;
      } else if (props.isTenant) {
        tree = store.item.selectedTenant.querySourceTree;
      } else if (props.isDestination) {
        tree = store.item.selectedTenant.destinationQuerySourceTree;
      }

      var title = props.localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SOURCE');

      var header = {
        component: Header,
        title: title,
        store: store,
        onChangeSourceDropDown: this.onChangeSourceDropDown,
        hideDropdown: props.hideDropdown
      };

      return React.createElement(
        Panel,
        { className: 'u_borderAll workspace-tree u_noMarginAll' },
        searchBox(tree, store),
        React.createElement(
          'div',
          { className: classnames(props.className, 'workspace-tree-wraper') },
          React.createElement(
            ScrollBox,
            null,
            tree.root.map(function (treeRootItem) {
              return treeRootItem.childNodes.map(function (node) {
                if (isFunction(props.showSelected)) {
                  return props.showSelected(node) ? treeNode(tree, store, node, props) : null;
                }

                if (props.showSelected && !node.checked) {
                  return null;
                }

                return treeNode(tree, store, node, props);
              });
            })
          )
        )
      );
    },

    onChangeSourceDropDown: m.action(function (sourceId) {
      var store = this.props.store;
      var loader = this.props.loader;

      loader.startLoading();
      store.item.updateDataForDestination(sourceId);
      store.item.updateSelectedTenantsForDestination(store.item.selectedDestinationTenantIDs, sourceId).finally(loader.endLoading.bind(loader));
    })
  });

  var Header = React.createClass({
    displayName: 'Header',

    render: function render() {
      var props = this.props;
      return React.createElement(
        'div',
        null,
        React.createElement(
          'span',
          { className: 'u_inlineBlock text-bold' },
          props.title
        ),
        props.hideDropdown ? null : React.createElement(
          'span',
          { className: 'u_inlineBlock padding-left' },
          React.createElement(DropDown, {
            options: props.store.tenantList,
            onChange: EventUtils.notifyChange(props.onChangeSourceDropDown, EventUtils.DROPDOWN),
            value: props.store.item.sourceId,
            valueField: 'id',
            labelField: 'name'
          })
        )
      );
    }
  });

  module.exports = connect()(SourceTree);
}();

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Tree.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * Tree component
 */
!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var TreeView = __webpack_require__(172);
  var Input = __webpack_require__(17);
  var TextHighLight = __webpack_require__(62);
  var actions = __webpack_require__(2402);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      invoke = _require.invoke;

  var Tree = React.createClass({
    displayName: 'Tree',

    propTypes: {
      resetWorkspaceTenantsStatus: React.PropTypes.func,
      data: React.PropTypes.object.isRequired,
      dataPrev: React.PropTypes.array,
      filterText: React.PropTypes.string,
      resetPrevData: React.PropTypes.func,
      leafKey: React.PropTypes.string.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.tree = this.props.buildTree(this.props.data, this.props.filterText);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextState) {
      this.tree = this.props.buildTree(nextProps.data, nextProps.filterText);
    },

    /**
     * Render node
     * @param {Object} node
     * @param {String} toggleIcon
     * @param {Boolean} toggle
     * @param {Boolean} isCollapsed
     */
    renderNode: function renderNode(node, toggleIcon, toggle, isCollapsed, parent) {
      var props = this.props;
      var leafKey = props.leafKey;
      var source = node.source;
      var onChangeFunc;
      var isLastItem = false;

      switch (node.nodeType) {
        case 'All':
          onChangeFunc = props.onChangeAll.bind(props, source, parent);
          break;
        case 'Category':
          onChangeFunc = props.onChangeCategory.bind(props, source, parent);
          break;
        case 'SubCategory':
          onChangeFunc = props.onChangeSubCategory.bind(props, source, parent);
          break;
        case leafKey:
          onChangeFunc = props.onChangeLeafNode.bind(props, source, parent);
          isLastItem = true;
          break;
        default:
          return null;
      }

      return this.renderData(node.source, toggleIcon, toggle, isCollapsed, parent, isLastItem, onChangeFunc);
    },

    /**
     * Render data
     * @param {Object} node
     * @param {String} toggleIcon
     * @param {Boolean} toggle
     * @param {Boolean} isCollapsed
     */
    renderData: function renderData(source, toggleIcon, toggle, isCollapsed, parent, isLastItem, onChangeFunc) {
      var props = this.props;
      var name = isEmpty(source.name) ? 'UNCATEGORIZED' : source.name;

      return React.createElement(
        'div',
        null,
        React.createElement(Input, {
          type: 'checkbox',
          indeterminate: source.indeterminate,
          checked: source.checked,
          onChange: onChangeFunc
        }),
        React.createElement(TextHighLight, {
          highlight: props.filterText,
          onClick: toggle,
          text: name,
          className: 'selectable u_inline u_paddingLeft',
          tooltip: name
        }),
        isLastItem ? null : toggleIcon
      );
    },

    render: function render() {
      var props = this.props;
      var getChildNodes = invoke('getChildNodes');

      return React.createElement(TreeView, {
        className: 'u_paddingRight',
        nodes: this.tree,
        renderNode: this.renderNode,
        getKey: props.getKey,
        getChildNodes: getChildNodes,
        collapsed: false
      });
    }
  });

  module.exports = connect(actions)(Tree);
}();

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      has = _require.has,
      isEmpty = _require.isEmpty,
      map = _require.map,
      partition = _require.partition,
      values = _require.values,
      escapeRegExp = _require.escapeRegExp,
      some = _require.some,
      matchesProperty = _require.matchesProperty,
      filter = _require.filter;

  // TODO: This list should be collected from API and it varies per database
  // server types.


  var SourceTypes = {
    TABLE: 'Table',
    VIEW: 'View',
    PROCEDURE: 'Stored Procedure',
    FUNCTION: 'Function'
  };

  /**
   * Check whether query source has name that matches the filter string (non-case
   * sensitive)
   * @param  {String}  filter
   * @return {Boolean} Matched or not
   */
  function isMatchedSource(filter) {
    return function (item) {
      var filterRegex = new RegExp(escapeRegExp(filter.text), 'ig');
      var filteredQuerySourceFields = filterQuerySourceFields(item.querySourceFields, filter, filterRegex);

      // only filter if item not is TypeGroup or querySourceFields is empty
      return !has('type', item) || !isEmpty(filteredQuerySourceFields) || filterRegex.test(item.name);
    };
  }

  /**
   * filter querySourceFields that matches with the filter string
   * @param  {Array}  querySourceFields
   * @param  {String}  filterItem
   * @param  {RegExp}  filterRegex
   * @return {Array}
   */
  function filterQuerySourceFields(querySourceFields, filterItem, filterRegex) {
    return filterItem.isFilterFields ? filter(function (field) {
      return filterRegex.test(field.name);
    }, querySourceFields) : [];
  }

  /**
   * Recursively create child nodes of a query source node. It allows to auto-group
   * child nodes by its type.
   * @param  {String} filter                        Name-matching filter string
   * @param  {Boolean} autoGroupByType              Group by query source type
   * @param  {Function} querySourceNodeTransformer  Query source node factory
   * @param  {Array} querySources                   Query source array
   * @return {Array}                                Query source node array
   */
  function createChildNodes(filter, autoGroupByType, querySourceNodeTransformer, querySources, parentNode) {
    var match = isMatchedSource(filter);
    var selectSatisfiedSources = querySources.filter(match);
    var childNodes = [];
    var processingSources = selectSatisfiedSources;
    if (autoGroupByType) {
      // Divide query sources into type and non-type category
      // It returns two 2 arrays according to type and non-type category.
      var groups = partition(has('type'), selectSatisfiedSources);
      var typeGroup = groups[0];
      var nonTypeGroup = groups[1];

      if (!isEmpty(typeGroup)) {
        processingSources = nonTypeGroup;

        childNodes = values(SourceTypes).map(function (type) {
          var childNodes = typeGroup.filter(function (item) {
            return item.type === type;
          });
          return {
            id: type,
            name: type,
            group: true,
            parentNode: parentNode,
            querySources: childNodes,
            // just checked Group type if at least 1 child was selected
            checked: childNodes.filter(matchesProperty('checked', true)).length > 0
          };
        }).map(querySourceNodeTransformer(filter, false, parentNode));
      }
    }

    var rest = processingSources.map(querySourceNodeTransformer(filter, autoGroupByType, parentNode));

    return childNodes.concat(rest);
  }

  /**
   * Reactive query source -> node transformer
   * @param  {Object} querySource
   * @return {QuerySourceNode}
   */
  var querySourceNodeTransformer = function querySourceNodeTransformer(filter, autoGroupByType, parentNode, isFilterChecked) {
    return isFilterChecked && !querySource.checked ? null : function (querySource) {
      return new QuerySourceNode(filter, autoGroupByType, querySource, parentNode);
    };
  };

  /**
   * It is a model of a node in query source tree. It carries the query source
   * instance and relevant UI info.
   * @param {[type]} filter          [description]
   * @param {[type]} autoGroupByType [description]
   * @param {[type]} item            [description]
   */
  function QuerySourceNode(filter, autoGroupByType, item, parentNode) {
    this.dataSource = item;
    var querySources = !isEmpty(item.querySources) ? item.querySources : item.querySourceFields;
    var isFieldNode = !isEmpty(item.querySourceFields);

    var props = {
      id: item.id,
      name: item.name,
      change: item.physicalChange,
      approval: item.approval,
      checked: item.checked,
      parentNode: parentNode,
      childNodes: function childNodes() {
        return isEmpty(querySources) ? [] : createChildNodes(filter, autoGroupByType, querySourceNodeTransformer, querySources, this);
      },
      isFieldNode: isFieldNode // use for checking Field Node
    };

    // all data to init node
    item && (this.initData = item);

    m.extendObservable(this, props);
  }

  /**
   * Count child nodes that satisfies passing predication.
   * @param  {Function} predicate
   */
  QuerySourceNode.prototype.childCount = function (predicate) {
    return predicate ? this.childNodes.filter(predicate).length : this.childNodes.length;
  };

  /**
   * set checked property of item
   * @param {Boolean} checked
   */
  QuerySourceNode.prototype.setChecked = function (checked) {
    m.transaction(function () {
      this.dataSource.checked = checked;
      this.toggleSelect(checked);
      this.toggleParentSelect(checked);
    }.bind(this));
  };

  /**
   * Toggle selection of current node and its child nodes regarding to
   * the selecting status.
   * @param  {bool} checked Only toggle selection of selecting status.
   */
  QuerySourceNode.prototype.toggleSelect = function (checked) {
    if (!isEmpty(this.childNodes)) {
      var listResult = this.childNodes.filter(matchesProperty('dataSource.checked', !checked)).map(function (child) {
        child.dataSource.checked = checked;
        child.toggleSelect(checked);
      });
      return some(Boolean, listResult);
    }
    return false;
  };

  /**
   * Toggle selection of its parent nodes regarding to the selecting status.
   * @param  {bool} checked Only toggle selection of selecting status.
   */
  QuerySourceNode.prototype.toggleParentSelect = function (checked) {
    var parentNode = this.parentNode;
    if (parentNode) {
      var listResult = parentNode.childNodes.filter(matchesProperty('dataSource.checked', true));
      parentNode.dataSource.checked = listResult.length > 0 ? true : false;
      parentNode.toggleParentSelect && parentNode.toggleParentSelect(checked);
    }
  };

  /**
   * Is typed group node of query source (ie. tables, functions, SPs...)
   * @return {Boolean}
   */
  QuerySourceNode.prototype.isTypeGroup = function () {
    return !!this.dataSource.group;
  };

  /**
   * Tree model of query source. It starts by default root node (id:#root).
   * @param {Array} querySources
   * @param {Bool} isFilterChecked should filter checked or not
   * @param {Bool} isFilterFields should filter querySourceFields or not
   */
  function QuerySourceTree(querySources, isFilterChecked, isFilterFields) {
    // Only take query sources that satisfies predication
    var props = {
      filter: {
        text: '',
        isFilterFields: isFilterFields
      },
      querySources: querySources,
      root: function root() {
        return map(function (connection) {
          connection.querySources = connection.dbSource.querySources;
          return querySourceNodeTransformer(this.filter, true, isFilterChecked)({
            id: '#root',
            name: 'root',
            querySources: [connection]
          });
        }.bind(this), this.querySources);
      }
    };

    m.extendObservable(this, props);
  }

  /**
   * Set name-matching filter string for query source tree.
   * Whenever it set, all decendant node's name must satisfy filter string.
   * @param {String} newVal New filter string value.
   */
  QuerySourceTree.prototype.setFilter = function (newVal) {
    this.filter.text = newVal;
  };

  /**
   * set querySources for QuerySourceTree
   * Whenever it set, all QuerySourceNode will be re-calculate
   * @param {Array} querySources
   */
  QuerySourceTree.prototype.setQuerySources = function (querySources) {
    this.querySources = querySources;
  };

  module.exports = QuerySourceTree;
}();

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingDetailActions.js" company="Izenda">
// Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var compose = __webpack_require__(9).compose;
  var pure = __webpack_require__(9).pure;
  var withHandlers = __webpack_require__(9).withHandlers;

  var constants = __webpack_require__(337);
  var TABLE_DEF = constants.TABLE_DEF;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isObject = _require.isObject,
      isNil = _require.isNil,
      find = _require.find;

  var mappingDetailActions = compose(pure, withHandlers({
    onDeleteMapping: curry(onDeleteMapping),
    onChangeMergeDuplicateMappings: curry(onChangeMergeDuplicateMappings),
    onChangeMappingItem: curry(onChangeMappingItem),
    onChangeDatabaseName: curry(onChangeDatabaseName),
    onChangeType: curry(onChangeType),
    onChangeMappingTenant: curry(onChangeMappingTenant)
  }));

  /**
   * Handle on delete mapping item.
   * @param {Object} props
   * @param {Object} mappingItem
   */
  function onDeleteMapping(props, mappingItem) {
    handleErrorValidation(props);
    props.store.databaseMappingDetail.deleteMapping(mappingItem.id);
  }

  /**
   * Handle on change merge duplicate mappings.
   * @param {Object} props
   * @param {Boolean} e
   */
  function onChangeMergeDuplicateMappings(props, e) {
    handleErrorValidation(props);
    props.store.databaseMappingDetail.setPropertyValue('doesMergeDuplicate', e.target.checked);
  }

  /**
   * Handle on change mapping item.
   * @param {Object} props
   * @param {String} key
   * @param {Object} mappingItem
   * @param {Object} e
   */
  function onChangeMappingItem(props, key, mappingItem, e) {
    mappingItem.setPropertyValue(key, !isObject(e) ? e : isNil(e.value) ? e.target.value : e.value);
  }

  /**
   * Handle on change mapping tenant.
   * @param {Object} props
   * @param {Object} e
   */
  function onChangeMappingTenant(props, e) {
    handleErrorValidation(props);
    props.store.databaseMappingDetail.setPropertyValue('selectedTenantId', e.value, true);
  }

  /**
   * Handle on change database name.
   * @param {Object} props
   * @param {String} key
   * @param {Object} mappingItem
   * @param {Object} e
   */
  function onChangeDatabaseName(props, key, mappingItem, e) {
    var isFromDatabase = key === TABLE_DEF.fromDatabaseName.key;
    var dataSource = isFromDatabase ? props.store.fromDatabaseNameDataSource : props.store.toDatabaseNameDataSource;

    var matchedDataSource = find(function (item) {
      return item[constants.DATABASE_NAME_KEY] === e;
    }, dataSource.items);

    if (!matchedDataSource) return;

    var server = matchedDataSource.databaseServer;
    var databaseName = matchedDataSource.labelField;

    m.action(function () {
      onChangeMappingItem(props, key, mappingItem, databaseName);
      onChangeMappingItem(props, isFromDatabase ? 'fromServer' : 'toServer', mappingItem, server);
      isFromDatabase && onChangeType(props, 'type', mappingItem, constants.MAPPING_TYPE.Schema);
    })();
  }

  /**
   * Handle on change type.
   * @param {Object} props
   * @param {String} key
   * @param {Object} mappingItem
   * @param {Object} e
   */
  function onChangeType(props, key, mappingItem, e) {
    m.action(function () {
      onChangeMappingItem(props, key, mappingItem, e);
      props.store.loadObjects(mappingItem);
    })();
  }

  /**
   * Handle error validations when user makes an action.
   * @param {Object} props
   */
  function handleErrorValidation(props) {
    props.validation.reset();
  }

  module.exports = mappingDetailActions;
}();

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get CONSTRAINTS() {
    return {
      GLOBAL_NAME: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('SYSTEM_CONFIGURATION_REPORT_GLOBAL_NAME_REQUIRED')
        }
      },
      LOCAL_NAME: {
        presence: {
          presence: true,
          message: _Izenda2.default.getText('SYSTEM_CONFIGURATION_REPORT_LOCAL_NAME_REQUIRED')
        }
      }
    };
  },
  get MESSAGES() {
    return {
      M04: _Izenda2.default.getText('SYSTEM_CONFIGURATION_REPORT_DUPLICATE_GLOBAL_LOCAL_NAME')
    };
  },
  get DEFAULT_VALUES() {
    return {
      GLOBAL_NAME: _Izenda2.default.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_GLOBAL_NAME'),
      LOCAL_NAME: _Izenda2.default.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_LOCAL_NAME')
    };
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.SystemConfigurationConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(17);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1165);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(627);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2481);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2484);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2486);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(89);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get component render function
 * @param  {object} object Component object
 * @param  {string} key Operator filter key
 * @return {function} Render component function
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Filter Properties component
 */
function getComponentRender(object, key) {
  return (0, _fp.get)(key, object);
}

/**
 * Operator group filter value
 * @type {Object}
 */
var filterValuesComponents = {
  fieldcomparison: {
    component: _Izenda4.default,
    props: {
      labelField: 'sourceFieldName',
      valueField: 'querySourceFieldId',
      groupBy: 'sourceDataObjectName'
    }
  },
  'date&time': {
    component: _Izenda8.default
  },
  string: {
    component: _Izenda6.default
  },
  comparison: {
    component: _Izenda10.default
  },
  boolean: {
    component: _Izenda2.default
  },
  equivalence: {
    component: _Izenda12.default
  }
};

exports.default = (0, _mobxReact.observer)(function OperatorValue(props) {
  var filterInfo = props.filterInfo;

  var group = filterInfo.group || {};
  var operator = filterInfo.operator || {};
  var groupKey = group.key;
  var operatorKey = operator.key;


  var componentInfo = getComponentRender(filterValuesComponents, groupKey);

  function isValueRequired() {
    var groups = [_Izenda13.OPERATOR_GROUP.BOOLEAN, _Izenda13.OPERATOR_GROUP.UNKNOWN];

    var operators = [_Izenda13.OPERATOR.BLANK, _Izenda13.OPERATOR.NOTBLANK, _Izenda13.OPERATOR.UNKNOWN, _Izenda13.OPERATOR.NULL, _Izenda13.OPERATOR.NOTNULL];

    return !(0, _fp.some)(function (g) {
      return g === groupKey;
    }, groups) && !(0, _fp.some)(function (o) {
      return o === operatorKey;
    }, operators);
  }

  return !(0, _fp.isNil)(componentInfo) && isValueRequired() && _react2.default.createElement(
    'div',
    { className: 'u_marginTop' },
    _react2.default.createElement(componentInfo.component, (0, _extends3.default)({}, componentInfo.props, props))
  );
});
module.exports = exports['default'];

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueInput component
 */
!function () {
  __webpack_require__(55);
  var React = __webpack_require__(0);
  var Input = __webpack_require__(17);
  var constants = __webpack_require__(89);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      isEmpty = _require.isEmpty;

  var OperatorValueInput = React.createClass({
    displayName: 'OperatorValueInput',

    getInitialState: function getInitialState() {
      var value = isNil(this.props.filterInfo.value) ? null : this.props.filterInfo.value[0];
      return { filterValue: value };
    },

    propTypes: {
      filterInfo: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var filterInfo = props.filterInfo || {};

      return React.createElement(Input, {
        onChange: onChange.bind(this),
        value: filterInfo.value && filterInfo.value[0],
        className: 'form-control',
        disabled: props.disabled
      });

      function onChange(e) {
        if (props.isNumberInput && !isEmpty(e.target.value) && !String.isPatternFormat(e.target.value, constants.REGEX.INT_NUMBER)) {
          return;
        }

        this.setState({ filterValue: e.target.value });
        props.onChange([e.target.value]);
      }
    }
  });

  module.exports = OperatorValueInput;
}();

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorGroup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorGroup Component
 */


var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(29);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(626);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(89);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OperatorGroup = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(OperatorGroup, _Component);

  function OperatorGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OperatorGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OperatorGroup.__proto__ || (0, _getPrototypeOf2.default)(OperatorGroup)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeOperatorGroup = function (_ref2) {
      var value = _ref2.value;

      _this.props.configField.setOperatorGroupId(value);
      _this.updateOperatorForStoreProcedure();
      _this.updateSourceFilter();
      _this.updateDisableCascading();
    }, _this.onChangeOperator = function (_ref3) {
      var value = _ref3.value;

      _this.props.configField.setOperatorId(value);
      _this.updateSourceFilter();
      _this.updateDisableCascading();
    }, _this.onChangeOperatorValue = function (filterValue) {
      var _this$props = _this.props,
          configField = _this$props.configField,
          fieldDetails = _this$props.configField.fieldDetails,
          store = _this$props.store;

      configField.setFilterValue(filterValue);
      store.updateReportDesignerCascadingFilter(fieldDetails);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OperatorGroup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      function getPosition(props) {
        return (0, _fp.get)('configField.fieldDetails.position', props);
      }
      if (getPosition(this.props) !== getPosition(nextProps)) {
        this.updateSourceFilter();
      }
    }

    /**
     * Update operator for SP
     */

  }, {
    key: 'updateOperatorForStoreProcedure',
    value: function updateOperatorForStoreProcedure() {
      var _props = this.props,
          configField = _props.configField,
          _props$configField = _props.configField,
          operators = _props$configField.operators,
          isParameter = _props$configField.fieldDetails.isParameter;

      if (isParameter) {
        var allowParameterOperators = (0, _fp.filter)({ allowParameter: true }, operators);
        allowParameterOperators.length > 0 && configField.setOperatorId(allowParameterOperators[0].id);
      }
    }

    /**
     * Get list operators
     * @param {FilterDetailsConfig} configField
     * @param {boolean} notInReportDesignerMode
     * @param {boolean} isBlankDataType
     */

  }, {
    key: 'getOperators',
    value: function getOperators(configField, notInReportDesignerMode, isBlankDataType) {
      var operators = configField.operators;

      var valueList = isBlankDataType ? _Izenda6.default.BLANK_VALUE_LIST : _Izenda6.default.OPERATOR_VALUE_LIST;

      return notInReportDesignerMode || isBlankDataType ? (0, _fp.filter)(function (operator) {
        return (0, _fp.includes)(operator.name, valueList);
      }, operators) : operators;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          configField = _props2.configField,
          notInReportDesignerMode = _props2.notInReportDesignerMode,
          _props2$configField = _props2.configField,
          operatorSourceValue = _props2$configField.operatorSourceValue,
          availableOperatorGroup = _props2$configField.availableOperatorGroup,
          filterInfo = _props2$configField.filterInfo,
          _props2$configField$f = _props2$configField.filterInfo,
          groupId = _props2$configField$f.groupId,
          operatorId = _props2$configField$f.operatorId,
          isParameter = _props2$configField.fieldDetails.isParameter,
          className = _props2.className,
          hideValue = _props2.hideValue,
          store = _props2.store,
          isLazyLoading = _props2.isLazyLoading,
          updateSourceValue = _props2.updateSourceValue;

      var fieldDataType = (0, _fp.get)('fieldDetails.dataType', configField);
      var isBlankDataType = _Izenda6.default.BLANK_NULL_OPERATOR.indexOf((0, _fp.toLower)(fieldDataType)) > -1;
      var operators = this.getOperators(configField, notInReportDesignerMode, isBlankDataType);

      // Only show operator for SP params
      if (isParameter) {
        operators = (0, _fp.filter)(function (operator) {
          var paramOperator = (0, _fp.get)(fieldDataType, _Izenda6.default.PARAM_OPERATOR_BY_DATA_TYPE);
          return operator.allowParameter && (!paramOperator || paramOperator.indexOf(operator.key) > -1);
        }, operators);
      }

      var groupClassName = (0, _classnames2.default)(className, {
        'operator-group': !notInReportDesignerMode
      });

      return _react2.default.createElement(
        'section',
        { className: groupClassName },
        !notInReportDesignerMode && _react2.default.createElement(_Izenda2.default, {
          options: availableOperatorGroup,
          onChange: this.onChangeOperatorGroup,
          value: groupId,
          valueField: 'id',
          labelField: 'name'
        }),
        !(0, _fp.isEmpty)(operators) && _react2.default.createElement(_Izenda2.default, {
          className: 'operator',
          options: operators,
          onChange: this.onChangeOperator,
          value: operatorId,
          valueField: 'id',
          labelField: 'name'
        }),
        !(hideValue === true || isBlankDataType) && _react2.default.createElement(_Izenda4.default, {
          filterSource: operatorSourceValue,
          filterInfo: filterInfo,
          updateSourceValue: updateSourceValue,
          operatorGroup: configField,
          onChange: this.onChangeOperatorValue,
          store: store,
          isLazyLoading: isLazyLoading,
          configField: configField
        })
      );
    }

    /**
     * On change operator group
     */


    /**
     * On change operator
     */


    /**
     * On change operator value
     */

  }, {
    key: 'updateSourceFilter',


    /**
     * Update source filter
     */
    value: function updateSourceFilter() {
      var _props3 = this.props,
          configField = _props3.configField,
          _props3$configField = _props3.configField,
          filterInfo = _props3$configField.filterInfo,
          fieldDetails = _props3$configField.fieldDetails,
          isUpdateSource = _props3$configField.isUpdateSource,
          notInReportDesignerMode = _props3.notInReportDesignerMode,
          hideValue = _props3.hideValue;


      var operatorId = filterInfo.operatorId;
      if ((0, _fp.isNil)(fieldDetails.operatorId) && operatorId) {
        configField.setOperatorId(operatorId);
      }

      if (notInReportDesignerMode) {
        this.props.updateSourceValue(configField);
      } else if (hideValue !== true) {
        configField.resetOperatorSourceValue();
        isUpdateSource && this.props.updateSourceValue(configField);
      }
    }

    /**
     * Update disable cascading when change operator
     */

  }, {
    key: 'updateDisableCascading',
    value: function updateDisableCascading() {
      var reportFilters = this.props.reportFilters;

      reportFilters.disableCascading();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var operatorGroupElm = _reactDom2.default.findDOMNode(this);
      var operatorElm = operatorGroupElm.getElementsByClassName('operator');

      operatorElm = operatorElm.length ? operatorElm[0] : null;

      if (operatorGroupElm.getElementsByClassName && operatorGroupElm.getElementsByClassName('btn-popup').length) {
        operatorElm && operatorElm.setAttribute('data-inlineOpValue', true);
      } else {
        operatorElm && operatorElm.setAttribute('data-inlineOpValue', false);
      }
    }
  }]);
  return OperatorGroup;
}(_react.Component), _class2.propTypes = {
  configField: _propTypes2.default.object.isRequired,
  updateSourceValue: _propTypes2.default.func.isRequired
}, _temp2)) || _class;

exports.default = OperatorGroup;
module.exports = exports['default'];

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AffixContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var EdgeDetector = __webpack_require__(2504);
  var Utils = __webpack_require__(262);
  var requestAnimationFrame = __webpack_require__(928);
  var clazz = __webpack_require__(1170);
  var style = __webpack_require__(168);
  var removeStyle = __webpack_require__(819);
  var offset = __webpack_require__(251);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var AffixContainer = React.createClass({
    displayName: 'AffixContainer',

    propTypes: {
      affixClass: React.PropTypes.string,
      getAffix: React.PropTypes.func.isRequired,
      onAffix: React.PropTypes.func
    },
    componentDidMount: function componentDidMount() {
      this.listen();
    },
    componentWillUnmount: function componentWillUnmount() {
      this.unlisten();
    },
    render: function render() {
      return React.createElement(
        EdgeDetector,
        { className: this.props.className, onChanged: this.onAffixChanged },
        React.createElement('div', { ref: 'spaceDiv', style: { height: '0px' } }),
        this.props.children
      );
    },
    /**
     * Listen to scroll and resize event to update affix position accordingly
     */
    listen: function listen() {
      var onScroll = function () {
        this.onAffixChanged(null);
      }.bind(this);

      var affix = this.props.getAffix();
      var scrollableAncestor = Utils.findScrollableParent(affix);

      scrollableAncestor && scrollableAncestor.addEventListener('scroll', onScroll, { passive: true });

      this.unlisten = function () {
        scrollableAncestor && scrollableAncestor.removeEventListener('scroll', onScroll, { passive: true });
      };
    },
    /**
     * Notify affix changed (its positions)
     */
    onAffixChanged: function onAffixChanged(onEdge) {
      if (isNil(onEdge)) {
        this.update(this.onEdge, false);
      } else {
        this.onEdge = onEdge;

        if (this.rafCancelId) {
          requestAnimationFrame.cancel(this.rafCancelId);
        }
        this.rafCancelId = requestAnimationFrame(function () {
          this.update(this.onEdge, true);
        }.bind(this));
      }
    },
    /**
     * Update affix element position
     */
    update: function update(onEdge, isLast) {
      var affix = this.props.getAffix();
      if (!affix) {
        return;
      }

      var scrollableAncestor = Utils.findScrollableParent(affix);
      var positioning = onEdge ? 'absolute' : 'static';
      var affixOffset = offset(affix);
      var spaceDiv = this.refs.spaceDiv;

      this.scrollTop = scrollableAncestor ? scrollableAncestor.scrollTop : 0;

      if (onEdge) {
        this.lastOffset = affixOffset;

        style(affix, {
          position: positioning,
          width: '100%',
          zIndex: 1,
          top: (this.scrollTop || 0) + 'px'
        });
        clazz.addClass(affix, this.props.affixClass || 'affix');
        style(spaceDiv, {
          height: affixOffset.height + 'px'
        });

        this.props.onAffix && this.props.onAffix(isLast);
      } else if (this.lastOffset) {
        removeStyle(affix, 'width');
        removeStyle(affix, 'z-index');
        style(affix, {
          position: positioning,
          top: this.lastOffset.top + 'px'
        });

        clazz.removeClass(affix, this.props.affixClass || 'affix');
        style(spaceDiv, {
          height: '0px'
        });
      }
    }
  });

  module.exports = AffixContainer;
}();

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IMPORT_URL = 'importManagement/';
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
exports.default = {
  BASE_PATH: IMPORT_URL,
  /**
   * Validate import's content
   * @param {Object} data
   * @returns {promise}
   */
  validateImportContent: function validateImportContent(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'validate').post(data);
  },


  /**
   * Upload files
   * @param  {Array} files
   * @return {Promise}
   */
  uploadFiles: function uploadFiles(files) {
    return (0, _Izenda2.default)(IMPORT_URL + 'file').upload(files);
  },


  /**
   * Get detail file
   * @param {Object} data
   * @returns {promise}
   */
  getDetailFile: function getDetailFile(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'information').post(data);
  },


  /**
   * Validate overwrite reports/dashboard
   * @param {Object} data
   * @returns {promise}
   */
  validateOverride: function validateOverride(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'validateOverride').post(data);
  },


  /**
   * Begin import files
   * @param {Object} data
   */
  importFiles: function importFiles(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'import').post(data);
  },


  /**
   * Cancel import
   * @param {Object} data
   */
  cancelImport: function cancelImport(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'cancel').post(data);
  },


  /**
   * Get import status
   * @param {Array<string>} data
   */
  getImportStatus: function getImportStatus(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'status').post(data);
  },


  /**
   * Get new database mappings
   * @param {Array} data
   */
  getDatabaseMappings: function getDatabaseMappings(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'databaseMapping').post(data);
  },


  /**
   * Remove importing files by their ids.
   * @param {Array<string>} data
   * @returns {Promise} A promise object of invoking REST API result
   */
  removeFiles: function removeFiles(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'removeFiles').post(data);
  },


  /**
   * Remove importing files by their ids (sync).
   * @param {Array<string>} data
   * @returns {Promise} A promise object of invoking REST API result
   */
  removeFilesSync: function removeFilesSync(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'removeFiles').post(data, null, false);
  },


  /**
   * Get import histories
   * @param {Object} data
   * @returns {Promise}
   */
  loadImportHistories: function loadImportHistories(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'loadImportHistories').post(data);
  },


  /**
   * Delete histories
   * @param {Array<string>} data 
   */
  deleteHistories: function deleteHistories(data) {
    return (0, _Izenda2.default)(IMPORT_URL + 'deleteHistories').post(data);
  }
};
module.exports = exports['default'];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp;
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewer.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(324);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(329);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(421);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(593);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(16);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(50);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2576);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2597);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(636);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(1190);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(638);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(2629);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(438);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _Izenda29 = __webpack_require__(177);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _Izenda31 = __webpack_require__(246);

var _Izenda32 = _interopRequireDefault(_Izenda31);

var _Izenda33 = __webpack_require__(1195);

var _Izenda34 = _interopRequireDefault(_Izenda33);

var _Izenda35 = __webpack_require__(2632);

var _Izenda36 = _interopRequireDefault(_Izenda35);

var _Izenda37 = __webpack_require__(61);

var _Izenda38 = _interopRequireDefault(_Izenda37);

var _Izenda39 = __webpack_require__(15);

var _Izenda40 = _interopRequireDefault(_Izenda39);

var _Izenda41 = __webpack_require__(30);

var _Izenda42 = _interopRequireDefault(_Izenda41);

var _Izenda43 = __webpack_require__(31);

var _Izenda44 = _interopRequireDefault(_Izenda43);

var _Izenda45 = __webpack_require__(42);

var _Izenda46 = __webpack_require__(45);

var _Izenda47 = _interopRequireDefault(_Izenda46);

var _Izenda48 = __webpack_require__(1192);

var _Izenda49 = _interopRequireDefault(_Izenda48);

var _Izenda50 = __webpack_require__(83);

var _Izenda51 = _interopRequireDefault(_Izenda50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportViewer = (_dec = (0, _Izenda2.default)(_Izenda36.default, _Izenda51.default), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ReportViewer, _Component);

  function ReportViewer(props) {
    (0, _classCallCheck3.default)(this, ReportViewer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportViewer.__proto__ || (0, _getPrototypeOf2.default)(ReportViewer)).call(this, props));

    _initDefineProp(_this, 'viewerContentHeight', _descriptor, _this);

    _initDefineProp(_this, 'footerHeight', _descriptor2, _this);

    _this.handleNeedUpdateResultChanged = function (change) {
      _this.props.handleNeedUpdateResultChanged(change, _this.masterStore.alertDetails);
    };

    _initDefineProp(_this, 'updateViewerContentHeight', _descriptor3, _this);

    _this.updateReportParts = function () {
      var loader = _this.props.loader;
      var fieldStore = _this.reportDesignerFieldsStore;
      loader.startLoading();
      var updatePromise = void 0;
      if (!_this.props.editMode) {
        fieldStore.model.reportFilter.updateFilterInfoForSubReport();
        updatePromise = fieldStore.updateReportsParts(loader);
      } else {
        updatePromise = _this.masterStore.saveDraftReport(_Izenda12.default.PAGE_NAME.FIELDS, true).then(function () {
          return fieldStore.updateReportsParts(loader);
        });
      }

      return updatePromise.finally(function () {
        loader.endLoading();
      });
    };

    _this.removeCrossFiltering = function (pill) {
      _this.reportDesignerFieldsStore.removePill(pill);
    };

    _this.removeAllCrossFiltering = function () {
      _this.reportDesignerFieldsStore.removeAllPills();
    };

    _this.resetDefaultValue = function () {
      _this.reportDesignerFieldsStore.resetCrossFilterDefaultValue();
    };

    _this.setViewerContentRef = function (node) {
      _this.viewerContentNode = node;
      _this.updateViewerContentHeight();
    };

    _this.cancelReport = function () {
      var _this$props = _this.props,
          loader = _this$props.loader,
          store = _this$props.store,
          router = _this$props.router,
          reportName = _this$props.route.name,
          reportId = _this$props.params.id,
          inheritFilter = _this$props.location.query.inheritFilter;
      // Clear cached data report

      store.readReport(null);

      _this.returnToReportDefinition(inheritFilter, reportName, reportId, router);
      // Cancel change remove draft
      loader.startLoading();
      return store.cancelChanges().then(function () {
        loader.endLoading();
        // Init report
        _this.init(undefined, true);
      });
    };

    _this.resetReport = function () {
      var _this$props2 = _this.props,
          store = _this$props2.store,
          router = _this$props2.router,
          reportName = _this$props2.route.name,
          reportId = _this$props2.params.id,
          inheritFilter = _this$props2.location.query.inheritFilter;
      // Clear cached data report

      store.readReport(null);

      _this.returnToReportDefinition(inheritFilter, reportName, reportId, router);
      // Cancel change remove draft
      return store.cancelChanges().then(function () {
        // Init report
        _this.init(undefined, true);
      });
    };

    _this.setViewerRef = function (node) {
      _this.viewerNode = node;
    };

    _this.returnToReportDefinition = function (inheritFilter, reportName, reportId, router) {
      if (inheritFilter) {
        var reportUrl = _Izenda44.default.getReportUrl(reportName, { id: reportId });
        router.push({ pathname: reportUrl });
      }
    };

    _this.startTime = new Date().getTime();
    _this.initState(props);
    return _this;
  }

  (0, _createClass3.default)(ReportViewer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // This function is not call when change from VIEW MODE to EDIT MODE opposite, they use different component
      // for when react router change history for these case:
      // SAVE AS : need to reload data with new ID, name, category/sub category
      // MOVE : need to reload data with the same ID but have different name,cateogry, sub catogry
      // OPEN SUB REPORT: differenct report ID,
      // CHANGE VERSION OF REPORT: reload report definition

      // from report list to report viewer
      var fromReportList = (0, _fp.get)('state.fromList', nextProps.location);
      // from report designer
      var fromReportDesigner = (0, _fp.get)('state.fromReportDesigner', nextProps.location);
      // from quick edit
      var fromQuickEdit = (0, _fp.get)('state.fromQuickEdit', nextProps.location);

      var currentPathName = (0, _fp.get)('location.pathname', this.props);
      var nextPathName = (0, _fp.get)('location.pathname', nextProps);

      if (currentPathName !== nextPathName && !fromReportList && !fromReportDesigner && !fromQuickEdit) {
        this.initState(nextProps);
        return this.init(nextProps);
      }
    }

    /**
     * Init state
     * @param {Object} props
     */

  }, {
    key: 'initState',
    value: function initState(props) {
      var store = props.store,
          params = props.params,
          location = props.location;

      // Set tenantId for selected.
      // TODO: Technical debt: set tenant id in router

      var tenantId = (0, _fp.get)('query.tenantId', location);
      if (!(0, _fp.isEmpty)(tenantId)) {
        _Izenda40.default.setTenantId(tenantId, true);
      }

      if (store.selectedReportId !== params.id || store.selectedReportId === params.id && store.version !== params.version) {
        store.resetModel();
      }

      // Init report designer store
      this.masterStore = new _Izenda4.default(true, params.id, store.report);
      this.authorizationStore = new _Izenda6.default();
      this.reportDesignerFieldsStore = new _Izenda8.default(this.masterStore, true);
      this.reportDesignerDataSource = new _Izenda10.default(this.masterStore);

      this.observeNeedUpdateResult();

      store.updateReportId(params.id, params.version);
      store.model.resetReportList();
    }

    /**
     * Init
     * @param {Object} nextProps
     */

  }, {
    key: 'init',
    value: function init(nextProps, isCancelled) {
      var _this2 = this;

      var props = nextProps || this.props;
      var store = props.store,
          loader = props.loader;

      var id = (0, _fp.get)('params.id', props);

      loader.startLoading();
      return (0, _bluebird.join)(this.masterStore.validateReportId(true), this.authorizationStore.loadAccessPriority(id), (0, _mobx.action)(function (validateResult, reportAccessRight) {
        _this2.masterStore.setAccessPriority(reportAccessRight);
        return validateResult && _this2.masterStore.cancelChanges().then(function () {
          return (0, _bluebird.all)([_this2.loadInitialData(props, store.version, isCancelled), _this2.masterStore.init()]);
        });
      })).finally(loader.endLoading.bind(loader));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.cascadingChangedDisposer = (0, _mobx.observe)(this.masterStore, 'showCascadingChangedMessage', this.props.handleCascadingChanged);

      this.needUpdateResultChangedDisposer = (0, _mobx.observe)(this.masterStore, 'needUpdateResult', this.handleNeedUpdateResultChanged);

      this.init().then(function () {
        var renderingTime = new Date().getTime() - _this3.startTime;
        return _this3.props.store.updateRenderingTime(renderingTime);
      });
      this.updateViewerContentHeight();
    }

    /**
     * Observe need update result to show info message
     */

  }, {
    key: 'observeNeedUpdateResult',
    value: function observeNeedUpdateResult() {
      // Remove old observe
      this.needUpdateResultChangedDisposer && this.needUpdateResultChangedDisposer();

      this.needUpdateResultChangedDisposer = (0, _mobx.observe)(this.masterStore, 'needUpdateResult', this.handleNeedUpdateResultChanged);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Terminate all report part worker if leave report viewer
      this.reportDesignerFieldsStore.terminateAllReportPartWorker();

      // Store report model in ReportStore
      this.props.store.readReport(this.masterStore.model);
      this.cascadingChangedDisposer && this.cascadingChangedDisposer();
      this.needUpdateResultChangedDisposer && this.needUpdateResultChangedDisposer();
      this.masterStore.destroy();
    }

    /**
     * Load initial data
     * @param {Object} props
     * @param {number} version
     */

  }, {
    key: 'loadInitialData',
    value: function loadInitialData(props, version, isCancelled) {
      var _this4 = this;

      var store = props.store,
          params = props.params,
          location = props.location;

      var fieldStore = this.reportDesignerFieldsStore;
      var masterStore = this.masterStore;
      var query = location.query;
      var pageId = (0, _fp.getOr)(null, 'state.page', location);

      if ((0, _fp.get)('tempUrl', query)) {
        this.subReportFilter = _Izenda30.default.readSubReportQuery(query);
        this.masterStore.model.setSubReportFilters(this.subReportFilter, false);
      } else {
        this.subReportFilterFromQuery = _Izenda30.default.convertQueryToFilter(query);
        this.masterStore.model.setSubReportFilters(this.subReportFilterFromQuery, true);
      }

      store.updateReportId(params.id, params.version);
      // Reset Subscription mode
      this.masterStore.model.displayMode.reset();
      var promise = this.subReportFilterFromQuery ? _Izenda32.default.resolveSubReportFilter(this.subReportFilterFromQuery) : (0, _bluebird.resolve)(this.subReportFilter);

      return promise.then(function (subReportFilter) {
        _this4.masterStore.model.setSubReportFilters(subReportFilter, false);
        return null;
      }).then(function () {
        return !store.report ? _this4.masterStore.loadReportDesigner(store.version, null, pageId, isCancelled) : (0, _bluebird.resolve)();
      }).then(function (result) {
        var reportDef = result || {};
        var noPermission = !(0, _fp.isNil)(reportDef) && !(0, _fp.isNil)(reportDef.messages) && !(0, _fp.isEmpty)(reportDef.messages[0].detail) && reportDef.messages[0].detail === 'NoPermission';
        if (!(0, _fp.isEmpty)(reportDef)) {
          // Update report relationship
          _this4.masterStore.model.dataSource.readDataSourceGrid((0, _fp.get)('reportRelationship', reportDef));

          // These following lines are copied from the function getReportInfo in ReportStore
          store.reportType = (0, _fp.getOr)(_Izenda14.default.CATEGORY_TYPE.REPORT, 'type', reportDef).toString();
          store.reportName = (0, _fp.getOr)('', 'name', reportDef);
          store.categoryId = reportDef.categoryId || _Izenda14.default.EMPTY_GUID;
          !store.selectedCategoryId && (store.selectedCategoryId = reportDef.subCategoryId || reportDef.categoryId);

          var subReport = {
            selectedReport: params.id,
            masterReportId: query.masterReportId,
            reportFilter: query.inheritFilter
          };
          fieldStore.validateFilterFieldsTypeSubReport(subReport).then(function (result) {
            if (result) {
              masterStore.alertDetails.set({
                success: true,
                message: props.localization.getText('REPORTDESIGNER_FILTER_LOGIC_REPORT')
              });
              fieldStore.reportFilters.setLogic('');
            }
          });
        }
        var filterFields = result.reportFilter.filterFields;

        var isDirtyReportFilter = (0, _fp.some)('isOveridingInheritedFilter', filterFields);
        isDirtyReportFilter && _this4.masterStore.model.markDirty();
        return !noPermission && props.detectReportChange(_this4.masterStore);
      }).then(function (success) {
        return success ? (0, _bluebird.join)(fieldStore.getFilterData(store.version, null, null, null, props.editMode), fieldStore.loadAvailableQuerySourceFields(masterStore.reportId)) : success;
      });
    }

    /**
     * Update viewer content height
     */


    /**
     * Update all report parts
     */


    /**
     * Remove cross filtering
     * @param {Object} pill selected pill
     */


    /**
     * Remove all cross filtering
     */


    /**
     * Reset default value
     */

  }, {
    key: 'renderReportFilter',


    /**
     * Render report filter
     */
    value: function renderReportFilter() {
      var fieldsStore = this.reportDesignerFieldsStore;
      var reportBody = fieldsStore.reportBody;
      var accessPriority = (0, _fp.get)('reportStore.model.accessPriority', fieldsStore);
      var props = this.props;

      return props.editMode ? _react2.default.createElement(
        _Izenda28.default,
        { className: 'izenda-FilterGroupPanel u_noMarginAll' },
        _react2.default.createElement(_Izenda22.default, {
          store: fieldsStore,
          viewMode: false,
          editMode: props.editMode,
          uiStore: _Izenda49.default.targetOptions,
          afterToggled: this.updateViewerContentHeight,
          afterMove: this.updateViewerContentHeight
        })
      ) : _react2.default.createElement(_Izenda20.default, {
        accessPriority: accessPriority,
        afterToggled: this.updateViewerContentHeight,
        afterMove: this.updateViewerContentHeight,
        fieldStore: fieldsStore,
        configFields: fieldsStore.reportFilters.displayConfigFields,
        isLazyLoading: true,
        isReport: true,
        removeCrossFiltering: this.removeCrossFiltering,
        hadSetting: reportBody.hadCrossFilteringSetting,
        removeAllCrossFiltering: this.removeAllCrossFiltering,
        resetDefaultValue: this.resetDefaultValue,
        enableDeleteAll: reportBody.enableDeleteAll,
        crossFilteringDetails: reportBody.crossFilteringDetail,
        showCrossFilteringOption: true,
        enableCrossFilteringOption: reportBody.enableCrossFiltering
      });
    }

    /**
     * Set ref to content
     * @param {Object} node
     */

  }, {
    key: 'renderReportViewerMode',


    /**
     * Render report viewer.
     */
    value: function renderReportViewerMode() {
      var store = this.props.store;

      var isSubscriptionMode = (0, _fp.get)('model.displayMode.isSubscriptionMode', this.masterStore);

      if (isSubscriptionMode) {
        return null;
      }

      return _react2.default.createElement(_Izenda26.default, (0, _extends3.default)({
        setViewerContentRef: this.setViewerContentRef,
        className: 'content-container',
        bottom: this.footerHeight
      }, this.props, {
        store: this.reportDesignerFieldsStore,
        reportViewerStore: store,
        viewerContentHeight: this.viewerContentHeight
      }));
    }

    /**
     * Render subscription.
     * @param {string} reportId
     */

  }, {
    key: 'renderSubscriptionMode',
    value: function renderSubscriptionMode(reportId) {
      var isSubscriptionMode = (0, _fp.get)('model.displayMode.isSubscriptionMode', this.masterStore);

      if (!isSubscriptionMode) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'u_paddingLeftRight' },
        _react2.default.createElement(_Izenda34.default, {
          reportId: reportId,
          reportType: this.props.store.reportType,
          subscribedInstancesStore: this.props.reportSubscriptionStore
        })
      );
    }

    /**
     * Cancel Report
     */


    /**
     * Reset to original report if the report is inherited
     */


    /**
     * Set ref to report viewer
     * @param {Object} node
     */


    /**
     * Navigate to report definition
     * @param {string} inheritFilter
     * @param {string} reportName
     * @param {string} reportId
     * @param {any} router
     */

  }, {
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('izenda-ReportViewer izenda-Wrapper', {
        hide: this.props.store.disabled
      });

      var errorKey = this.masterStore.alertDetails.key;
      return _react2.default.createElement(
        'section',
        { className: className, ref: this.setViewerRef },
        (0, _fp.isEqual)(errorKey, 'report') ? this.renderErrorReport() : this.renderContent()
      );
    }

    /**
     * Render error report
     */

  }, {
    key: 'renderErrorReport',
    value: function renderErrorReport() {
      var _this5 = this;

      var handleClickDesign = function handleClickDesign() {
        var reportId = _this5.masterStore.reportId;
        var viewReportDesignerUrl = _Izenda44.default.getReportDesignerUrl('ReportDesignerDetail', { reportId: reportId });
        _this5.props.router.push(viewReportDesignerUrl);
      };

      var _props = this.props,
          authorization = _props.authorization,
          localization = _props.localization;

      var alertDetails = this.masterStore.alertDetails;
      var hasReportDesignerLicense = authorization.checkLicense(_Izenda47.default.LICENSE_KEY.ReportDesigner);
      var accessPriority = this.masterStore.reportAccessPriority;

      return _react2.default.createElement(
        'div',
        { className: 'u_table izenda-Wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'u_tableCell u_alignMiddle u_textCenter' },
          _react2.default.createElement(
            _Izenda38.default,
            { type: 'error', className: 'white-space-pre-line align-left', autoHide: false },
            (0, _fp.map)(function (item) {
              return _react2.default.createElement(
                'div',
                { key: item.message },
                _react2.default.createElement(
                  'span',
                  null,
                  item.message
                )
              );
            }, alertDetails.errors)
          ),
          hasReportDesignerLicense && (accessPriority === _Izenda45.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda45.ACCESS_RIGHT.SaveAs) && _react2.default.createElement(
            'div',
            { className: 'u_paddingTop' },
            _react2.default.createElement(
              _Izenda42.default,
              { onClick: handleClickDesign },
              localization.getText('REPORT_LABEL_DESIGN')
            )
          )
        )
      );
    }

    /**
     * Render content
     */

  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props2 = this.props,
          localization = _props2.localization,
          store = _props2.store,
          params = _props2.params;

      var reportDesignerModel = this.masterStore.model;
      var fieldsStore = this.reportDesignerFieldsStore;

      var reportDetail = {
        type: store.reportType,
        name: reportDesignerModel.reportName,
        id: params.id,
        isGlobal: reportDesignerModel.isGlobal
      };

      return _react2.default.createElement(
        'div',
        null,
        this.masterStore.disableReportDesigner && _react2.default.createElement(
          _Izenda38.default,
          { type: 'error', autoHide: false },
          localization.getText('COMMON_MESSAGES_NOPERMISSION_VIEWREPORT')
        ),
        this.masterStore.isCompleteLoad && !this.masterStore.disableReportDesigner && _react2.default.createElement(_Izenda16.default, (0, _extends3.default)({}, this.props, {
          store: store,
          reportId: params.id,
          fieldStore: fieldsStore,
          designerStore: this.masterStore,
          boardDetail: reportDetail,
          updateReportParts: this.updateReportParts,
          cancelReport: this.cancelReport,
          resetReport: this.resetReport
        })),
        this.masterStore.isCompleteLoad && !this.masterStore.disableReportDesigner && _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          _react2.default.createElement(
            'div',
            { className: 'izenda-TableLayout' },
            _react2.default.createElement(
              'div',
              { className: 'izenda-TableLayout-Cell' },
              _react2.default.createElement(
                'div',
                { className: 'u_fullHeight' },
                _react2.default.createElement(
                  'div',
                  { className: 'u_paddingLeftRight' },
                  _react2.default.createElement(_Izenda18.default, (0, _extends3.default)({}, this.props, {
                    boardDetail: reportDetail,
                    fieldStore: fieldsStore,
                    updateReportName: reportDesignerModel.changeName.bind(reportDesignerModel),
                    updateReportParts: this.updateReportParts
                  })),
                  this.renderReportFilter()
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'u_fullHeight' },
                  this.renderReportViewerMode(),
                  this.renderSubscriptionMode(params.id)
                )
              )
            ),
            this.props.editMode && _react2.default.createElement(_Izenda24.default, { fieldStore: fieldsStore, reportDesignerModel: reportDesignerModel })
          )
        )
      );
    }
  }]);
  return ReportViewer;
}(_react.Component), _class3.propTypes = {
  store: _propTypes2.default.object,
  editMode: _propTypes2.default.bool
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'viewerContentHeight', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'footerHeight', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'updateViewerContentHeight', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function () {
      if (_this6.viewerNode) {
        var _viewerNode$getBoundi = _this6.viewerNode.getBoundingClientRect(),
            top = _viewerNode$getBoundi.top,
            height = _viewerNode$getBoundi.height;

        var newFooterHeight = window.innerHeight - top - height;
        newFooterHeight !== _this6.footerHeight && (_this6.footerHeight = newFooterHeight);
      }

      if (_this6.viewerContentNode) {
        var _viewerContentNode$ge = _this6.viewerContentNode.getBoundingClientRect(),
            _top = _viewerContentNode$ge.top;

        var newViewerContentHeight = window.innerHeight - _top - _this6.footerHeight;
        newViewerContentHeight !== _this6.viewerContentHeight && (_this6.viewerContentHeight = newViewerContentHeight);
      }
    };
  }
})), _class2)) || _class);
exports.default = ReportViewer;
module.exports = exports['default'];

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerAlerts.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(61);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = __webpack_require__(5);

var _Izenda3 = __webpack_require__(326);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var AlertItem = (0, _mobxReact.observer)(function AlertItem(props) {
  var item = props.item,
      className = props.className;


  return _react2.default.createElement(
    'div',
    { key: item.message },
    _react2.default.createElement(
      'span',
      { className: className },
      item.message
    ),
    item.itemErrors ? _react2.default.createElement(
      'ol',
      null,
      (0, _fp.map)(function (message) {
        return _react2.default.createElement(
          'li',
          { key: message },
          message
        );
      }, item.itemErrors)
    ) : null
  );
});

var ReportDesignerAlerts = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(ReportDesignerAlerts, _Component);

  function ReportDesignerAlerts() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportDesignerAlerts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportDesignerAlerts.__proto__ || (0, _getPrototypeOf2.default)(ReportDesignerAlerts)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showOldAlertDetails', _descriptor, _this), _this.savedInfo = new _Izenda4.default(), _this.onAutoHide = function () {
      if (_this.savedInfo.showType === _Izenda5.SHOW_TYPES.ALWAYS) {
        _this.showOldAlertDetails = true;
      }
    }, _this.onDismiss = function () {
      _this.props.onDismiss && _this.props.onDismiss();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReportDesignerAlerts, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var showType = nextProps.showType,
          alertKey = nextProps.alertKey,
          message = nextProps.message,
          success = nextProps.success,
          errors = nextProps.errors,
          type = nextProps.type;


      if (showType === _Izenda5.SHOW_TYPES.ALWAYS) {
        this.savedInfo.set({
          showType: showType,
          key: alertKey,
          message: message,
          success: success,
          errors: errors,
          type: type
        });
      } else if (showType === _Izenda5.SHOW_TYPES.RESET) {
        this.savedInfo.reset();
      }

      this.showOldAlertDetails = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2 = this.showOldAlertDetails ? this.savedInfo : this.props,
          _ref2$errors = _ref2.errors,
          errors = _ref2$errors === undefined ? [] : _ref2$errors,
          alertType = _ref2.alertType,
          alertKey = _ref2.alertKey,
          success = _ref2.success,
          showType = _ref2.showType,
          message = _ref2.message;

      var className = (0, _classnames2.default)({
        'alert-item-header': errors && errors.length > 1
      });

      var alertProps = {
        type: alertType,
        displayTime: _Izenda5.DISPLAY_TIME,
        onAutoHide: this.onAutoHide,
        onDismiss: this.onDismiss,
        dismissible: this.savedInfo.showType === _Izenda5.SHOW_TYPES.ALWAYS
      };

      if ((0, _fp.isEqual)(alertKey, 'report') || showType === _Izenda5.SHOW_TYPES.ALWAYS) {
        alertProps = (0, _fp.assign)({ autoHide: false }, alertProps);
      }

      var alertText = success ? !(0, _fp.isEmpty)(message) ? message : null : !(0, _fp.isEmpty)(errors) ? errors.map(function (item, index) {
        return _react2.default.createElement(AlertItem, { key: index, item: item, className: className });
      }) : null;

      return _react2.default.createElement(
        _Izenda2.default,
        alertProps,
        alertText
      );
    }
  }]);
  return ReportDesignerAlerts;
}(_react.Component), _class3.propTypes = {
  showType: _propTypes2.default.string,
  alertKey: _propTypes2.default.string,
  message: _propTypes2.default.string,
  errors: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  type: _propTypes2.default.string,
  success: _propTypes2.default.bool,
  onDismiss: _propTypes2.default.func
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showOldAlertDetails', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class;

exports.default = ReportDesignerAlerts;
module.exports = exports['default'];

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportButtons.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  module.exports = {
    ViewReportButton: __webpack_require__(2583),
    SubscribeReportButton: __webpack_require__(2584),
    ExportReportButton: __webpack_require__(634),
    EditReportButton: __webpack_require__(2586),
    UpdateReportButton: __webpack_require__(2591),
    SaveReportButton: __webpack_require__(2592),
    CancelViewReportButton: __webpack_require__(2594),
    CloseViewReportButton: __webpack_require__(2595),
    PrintReportButton: __webpack_require__(2596)
  };
}();

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file='Izenda.ExportButton.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);

  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);
  var Button = __webpack_require__(30);

  var action = __webpack_require__(635);

  var _require = __webpack_require__(1),
      map = _require.map;

  var ExportButton = React.createClass({
    displayName: 'ExportButton',

    componentDidMount: function componentDidMount() {
      var $ul = $izenda(ReactDOM.findDOMNode(this.refs.menu));
      var $button = $izenda(ReactDOM.findDOMNode(this.refs.button));
      var $group = $izenda(ReactDOM.findDOMNode(this.refs.group));

      $button.click(function () {
        var ulOffset = $ul.offset();
        var spaceUp = ulOffset.top - $button.height() - $ul.height() - $izenda(window).scrollTop();
        var spaceDown = $izenda(window).scrollTop() + $izenda(window).height() - (ulOffset.top + $ul.height());

        if (spaceDown < 0 && (spaceUp >= 0 || spaceUp > spaceDown)) {
          $group.addClass('dropup');
        } else {
          $group.removeClass('dropup');
        }
      });
    },

    render: function render() {
      var props = this.props;
      var disabled = props.disabled;
      var exportFormatList = props.getExportFormats('');
      var localization = props.localization;
      var label = localization.getText('COMMON_LABEL_EXPORT');
      var exportFn = props.isDashboard ? props.exportDashboard : props.exportReport;
      return exportFormatList.length > 0 && React.createElement(
        'div',
        { ref: 'group', className: 'btn-group' },
        React.createElement(
          Button,
          { ref: 'button', label: label, className: 'dropdown-toggle', 'data-toggle': 'dropdown', disabled: disabled },
          React.createElement('span', { className: 'caret' })
        ),
        React.createElement(
          'ul',
          { ref: 'menu', className: classnames('dropdown-menu', { 'dropdown-menu-right': props.menuRight }) },
          map(function (format) {
            return React.createElement(
              'li',
              { key: format.label },
              React.createElement(
                'a',
                { onClick: exportFn(format.value) },
                format.label
              )
            );
          }, exportFormatList)
        )
      );
    }
  });

  module.exports = connect(action)(ExportButton);
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportReportAction.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var ExportFormat = __webpack_require__(401);
  var exportUtils = __webpack_require__(1180);
  var subReportLink = __webpack_require__(177);
  var ReportUtils = __webpack_require__(225);

  var _require = __webpack_require__(1),
      get = _require.get,
      getOr = _require.getOr,
      uniqueId = _require.uniqueId,
      curry = _require.curry,
      omit = _require.omit,
      isNil = _require.isNil,
      filter = _require.filter;

  var ExportButtonAction = compose(withHandlers({
    exportReport: curry(exportReport),
    exportDashboard: curry(exportDashboard),
    getExportFormats: curry(getExportFormats)
  }));

  /**
   * Get info of export loading
   */
  function getInfoExportLoading(format, name, key, isReport) {
    var formatType = exportUtils.getFileTypeByFormat(format, isReport);
    var exportName = void 0,
        isPrinting = void 0;

    if (format === ExportFormat.HTML.value) {
      exportName = name;
      isPrinting = true;
    } else {
      exportName = '"' + name + '.' + formatType + '"';
    }

    return {
      isPrinting: isPrinting,
      name: exportName,
      key: key,
      error: false
    };
  }

  /*
   * Call export dashboard by format
   * @param: {object} props   React props
   * @param: {string} format  Export type
   * @param: {event}  event   React event
   */
  function exportDashboard(props, format, event) {
    var name = props.name;
    var exportLoader = props.exportLoader;
    var key = uniqueId(name);
    var id = props.id;

    exportLoader.startExportLoading(getInfoExportLoading(format, name, key, false));
    var isDesignerMode = props.isDesignerMode;
    if (isDesignerMode) {
      props.store.saveDraftDataForPrint().then(function (draftId) {
        return props.export(draftId, format, exportLoader.endExportLoading.bind(exportLoader, key), exportLoader.updateError.bind(exportLoader, key));
      });
    } else {
      return props.export(id, format, exportLoader.endExportLoading.bind(exportLoader, key), exportLoader.updateError.bind(exportLoader, key));
    }
  }

  /*
   * Call export report by format
   * @param: {object} props   React props
   * @param: {string} format  Export type
   * @param: {event}  event   React event
   */
  function exportReport(props, format, event) {
    var name = props.name;
    var exportLoader = props.exportLoader;
    var key = uniqueId(name);

    var store = props.store;
    var id = props.id;
    var designerStore = props.designerStore;

    function saveDraft() {
      if (props.designerStore) {
        return props.designerStore.savePrintDraft().get('id').then(function (draftId) {
          var subReportFilter = get('model.subReportFilter', props.designerStore);
          var subReportFilterFromQuery = getOr({}, 'model.subReportFilterFromQuery', props.designerStore);
          var filters = getOr([], 'filters', subReportFilter);
          var query = subReportLink.convertFilterToQuery(omit(['success', 'overideFilterValue'], subReportFilterFromQuery));

          return {
            draftId: draftId,
            subReportFilter: filters,
            queryString: $izenda.param(query || {})
          };
        });
      }

      return (0, _bluebird.resolve)(null);
    }

    function exportFn(exportObj) {
      exportLoader.startExportLoading(getInfoExportLoading(format, name, key, true));
      var url = window.location.href;
      var actionFn = format === ExportFormat.HTML.value ? props.print.bind(props.store) : props.export.bind(props.store);

      return actionFn(url, format, props.id, props.filters, exportObj, exportLoader.endExportLoading.bind(exportLoader, key), exportLoader.updateError.bind(exportLoader, key));
    }

    function beginExport() {
      return saveDraft().then(exportFn);
    }

    function checkFiltersAndExport() {
      if (format === ExportFormat.Query.value || format === ExportFormat.Definition.value) {
        return beginExport();
      }
      var errorMessage = props.localization.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_REQUIRED_FILTER_EXPORT');
      return ReportUtils.checkRequiredFilters(designerStore, props.id).then(function (isValidFilter) {
        if (isValidFilter) {
          return beginExport();
        } else {
          if (isNil(designerStore)) {
            props.confirmMessage('error', errorMessage);
          } else {
            designerStore.alertDetails.set({
              success: false,
              errors: [{ message: errorMessage }]
            });
          }
        }
        return false;
      });
    }

    if (store.checkValidReportId) {
      return store.checkValidReportId(id).then(function (result) {
        if (!result.success) {
          var message = result.messages[0] || {};
          var errorMessage = message.messages[0] || '';

          return props.confirmMessage('error', errorMessage);
        }
        return checkFiltersAndExport();
      });
    }

    return checkFiltersAndExport();
  }

  /**
   * Get export format options
   * @param: {object} props   React props
   * @param: {object} event   React event handle
   */
  function getExportFormats(props, event) {
    var authorization = props.authorization;
    var permissionKeys = props.authorizationConstants.PERMISSION_KEY;

    var hasWordPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatWord]);
    var hasExcelPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatExcel]);
    var hasPdfPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatPdf]);
    var hasCsvPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatCsv]);
    var hasXmlPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatXml]);
    var hasJsonPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatJson]);
    var hasQueryPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatQueryExecution]);
    var hasDefinitionPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatDefinition]);

    if (props.reportDesignerMode) {
      return filter(function (format) {
        return hasQueryPrivilege && format.value === 'query' && format.value !== ExportFormat.HTML.value;
      }, ExportFormat);
    }

    return filter(function (format) {
      return format.value !== ExportFormat.HTML.value && (hasWordPrivilege || format.value !== 'word') && (hasExcelPrivilege || format.value !== 'excel') && (hasPdfPrivilege || format.value !== 'pdf') && (hasCsvPrivilege || format.value !== 'csv') && (hasXmlPrivilege || format.value !== 'xml') && (hasJsonPrivilege || format.value !== 'json') && (hasQueryPrivilege && !props.isDashboard || format.value !== 'query') && (hasDefinitionPrivilege || format.value !== 'definition');
    }, ExportFormat);
  }

  module.exports = ExportButtonAction;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerFilters.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(28);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(50);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2599);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(13);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(27);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(1184);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(1189);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(42);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(231);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var integrationStyleAction = _Izenda20.default.checkDisplayByKey('hideFilter');

var FiltersHeader = (0, _Izenda8.default)()(function (_ref) {
  var uiStore = _ref.uiStore,
      localization = _ref.localization,
      authorization = _ref.authorization,
      haveFreeze = _ref.haveFreeze,
      crossFilteringDetails = _ref.crossFilteringDetails,
      hadSetting = _ref.hadSetting,
      removeCrossFiltering = _ref.removeCrossFiltering,
      removeAllCrossFiltering = _ref.removeAllCrossFiltering,
      fieldStore = _ref.fieldStore,
      resetDefaultValue = _ref.resetDefaultValue,
      enableDeleteAll = _ref.enableDeleteAll,
      isReport = _ref.isReport,
      enableCrossFilteringOption = _ref.enableCrossFilteringOption,
      openPopup = _ref.openPopup,
      collapseToggle = _ref.collapseToggle;

  var btnName = haveFreeze && uiStore.doesFreeze ? _Izenda4.default.UNFREEZE_BTN_LABEL : _Izenda4.default.FREEZE_BTN_LABEL;
  var onClickFreeze = function onClickFreeze() {
    uiStore.doesFreeze = !uiStore.doesFreeze;
  };

  var showCrossFilteringOption = isReport && authorization.checkPrivileges([_Izenda18.default.PERMISSION_KEY.FullReportAndDashboardAccess, _Izenda18.default.PERMISSION_KEY.ReportsFilterPropertiesCrossFiltering], _Izenda18.default.PERMISSION_OPERATOR.Or);

  /**
   * Open popup when click cross filter
   */
  var onCrossFilteringOptionClick = function onCrossFilteringOptionClick() {
    openPopup(_Izenda16.default, { store: fieldStore });
  };

  /**
   * Check show Cross Filtering Section
   */
  var validateShowCrossFilteringSection = function validateShowCrossFilteringSection() {
    if (isReport) {
      return !(0, _fp.isEmpty)(crossFilteringDetails);
    } else {
      return !(0, _fp.flow)(_fp.head, (0, _fp.get)('pillDefinitions'), _fp.isEmpty)(crossFilteringDetails);
    }
  };

  var showCrossFiltering = validateShowCrossFilteringSection();

  return _react2.default.createElement(
    'div',
    { className: 'u_table izenda-FilterHeader ' },
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell u_alignMiddle', onClick: collapseToggle },
      _react2.default.createElement('i', { className: 'icon-toggle-thick' }),
      _react2.default.createElement(
        'strong',
        null,
        localization.getText('REPORT_LABEL_FILTERS')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell u_alignMiddle u_fullWidth izenda-FilterHeader__CrossFilteringContainer' },
      showCrossFiltering && _react2.default.createElement(_Izenda14.default, {
        crossFilteringDetail: crossFilteringDetails,
        showCrossFilteringOption: false,
        hadSetting: false,
        removeCrossFiltering: removeCrossFiltering,
        removeAllCrossFiltering: removeAllCrossFiltering,
        onCrossFilteringOptionClick: onCrossFilteringOptionClick,
        resetDefaultValue: resetDefaultValue,
        enableDeleteAll: enableDeleteAll,
        enableCrossFilteringOption: enableCrossFilteringOption
      })
    ),
    haveFreeze && _react2.default.createElement(
      'div',
      { className: 'u_table izenda-FilterHeader__headerButton' },
      _react2.default.createElement(
        'button',
        { className: 'btn btn-primary btn-freeze u_tableCell', onClick: onClickFreeze },
        btnName
      ),
      ' '
    )
  );
});

FiltersHeader.displayName = 'FiltersHeader';

var ReportViewerFilters = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportViewerFilters, _Component);

  function ReportViewerFilters() {
    (0, _classCallCheck3.default)(this, ReportViewerFilters);
    return (0, _possibleConstructorReturn3.default)(this, (ReportViewerFilters.__proto__ || (0, _getPrototypeOf2.default)(ReportViewerFilters)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportViewerFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          uiStore = _props.uiStore,
          configFields = _props.configFields,
          haveFreeze = _props.haveFreeze,
          crossFilteringDetails = _props.crossFilteringDetails,
          showCrossFilteringOption = _props.showCrossFilteringOption,
          hadSetting = _props.hadSetting,
          removeCrossFiltering = _props.removeCrossFiltering,
          removeAllCrossFiltering = _props.removeAllCrossFiltering,
          resetDefaultValue = _props.resetDefaultValue,
          enableDeleteAll = _props.enableDeleteAll,
          isReport = _props.isReport,
          enableCrossFilteringOption = _props.enableCrossFilteringOption,
          accessPriority = _props.accessPriority,
          isLazyLoading = _props.isLazyLoading,
          afterToggled = _props.afterToggled,
          afterMove = _props.afterMove;

      var fieldStore = this.props.fieldStore || {};

      var header = {
        component: FiltersHeader,
        uiStore: uiStore,
        haveFreeze: haveFreeze,
        crossFilteringDetails: crossFilteringDetails,
        showCrossFilteringOption: showCrossFilteringOption,
        hadSetting: hadSetting,
        removeCrossFiltering: removeCrossFiltering,
        removeAllCrossFiltering: removeAllCrossFiltering,
        resetDefaultValue: resetDefaultValue,
        enableDeleteAll: enableDeleteAll,
        isReport: isReport,
        fieldStore: fieldStore,
        enableCrossFilteringOption: enableCrossFilteringOption
      };

      var filterItem = configFields.map(function (item, index) {
        var updateCascadingValue = function updateCascadingValue() {
          return fieldStore.updateCascadingValue && fieldStore.updateCascadingValue.call(fieldStore, item);
        };

        return item.fieldDetails.visible && item.fieldDetails.sourceFieldVisible && item.fieldDetails.sourceFieldFilterable ? _react2.default.createElement(_Izenda6.default, {
          key: index,
          index: index,
          configField: item,
          updateCascadingValue: updateCascadingValue,
          displayName: (0, _fp.get)('fieldDetails.alias'),
          viewMode: true,
          accessPriority: accessPriority,
          fieldStore: fieldStore,
          isLazyLoading: isLazyLoading
        }) : null;
      });

      var chunkFilterItem = (0, _fp.chunk)(4, (0, _fp.compact)(filterItem));
      var children = _react2.default.Children.count(this.props.children) === 0 ? null : this.props.children;
      var filterExpanded = _config2.default.UIPreferences.ReportFilterSectionExpanded;

      return _react2.default.createElement(
        _Izenda2.default,
        {
          className: 'filters-container view-mode-filter',
          header: header,
          collapsible: true,
          initState: filterExpanded,
          afterToggled: afterToggled,
          afterMove: afterMove,
          resizable: true,
          defaultValue: _Izenda4.default.FITLERS_PANEL_UI.minHeight,
          minValue: _Izenda4.default.FITLERS_PANEL_UI.minHeight,
          maxValue: _Izenda4.default.FITLERS_PANEL_UI.maxHeight
        },
        _react2.default.createElement(
          _Izenda12.default,
          null,
          _react2.default.createElement(
            _Izenda10.default,
            { className: 'u_paddingTop' },
            chunkFilterItem.map(function (item, index) {
              return _react2.default.createElement(
                _Izenda10.default.Row,
                { key: index, className: 'u_noMarginAll' },
                item
              );
            })
          ),
          children
        )
      );
    }
  }]);
  return ReportViewerFilters;
}(_react.Component), _class2.propTypes = {
  uiStore: _react.PropTypes.object,
  configFields: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]),
  haveFreeze: _react.PropTypes.bool,
  fieldStore: _react.PropTypes.object
}, _class2.defaultProps = {
  uiStore: {}
}, _class2.displayName = 'ReportViewerFilters', _temp)) || _class;

exports.default = integrationStyleAction(ReportViewerFilters);
module.exports = exports['default'];

/***/ }),
/* 637 */,
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RightContentFieldDetail.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Right Content Field Detail component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var RightPanel = __webpack_require__(2619);

  var ReportDesignerPropertiesEditors = __webpack_require__(2620);

  var RightContent = React.createClass({
    displayName: 'RightContent',

    render: function render() {
      var props = this.props;

      return React.createElement(
        RightPanel,
        { initState: false, ref: 'rightPanel', className: 'u_fullHeight' },
        React.createElement(ReportDesignerPropertiesEditors, (0, _extends3.default)({}, props, {
          fieldStore: props.fieldStore,
          reportDesignerModel: props.reportDesignerModel,
          onActiveEditor: this.onSetActiveEditor }))
      );
    },

    /**
     * action when a tab is set as active
     **/
    onSetActiveEditor: function onSetActiveEditor(newActiveTab) {
      this.refs.rightPanel && this.refs.rightPanel.toggleRightPanel(!!newActiveTab);
    }
  });

  module.exports = connect()(RightContent);
}();

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(61);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MyProfileAlert(_ref) {
  var alertMessage = _ref.alertMessage;
  var type = alertMessage.type,
      message = alertMessage.message;

  return _react2.default.createElement(
    'div',
    { className: 'izenda-Alert-container' },
    _react2.default.createElement(
      _Izenda2.default,
      { type: type },
      message
    )
  );
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfileAlert.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
exports.default = (0, _Izenda4.default)()(MyProfileAlert);
module.exports = exports['default'];

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(605);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.IntegrationContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Setting page component
 */

var IntegrationContainer = function IntegrationContainer(props) {
  return _react2.default.createElement(
    _Izenda2.default,
    (0, _extends3.default)({}, props, { isNeedLoginForm: false }),
    props.children
  );
};

exports.default = IntegrationContainer;
module.exports = exports['default'];

/***/ }),
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(204);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceFactories = new _Izenda2.default('Service'); // ----------------------------------------------------------------------
// <copyright file="Izenda.ServiceFactories.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  register: function register(name, clazz) {
    serviceFactories.register(name, function () {
      return clazz;
    });
  },
  get: function get(name) {
    return serviceFactories.create(name);
  }
};
module.exports = exports['default'];

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.HighchartVizEngine.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(459);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _highcharts = __webpack_require__(238);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _highchartsMore = __webpack_require__(1293);

var _highchartsMore2 = _interopRequireDefault(_highchartsMore);

var _funnel = __webpack_require__(1294);

var _funnel2 = _interopRequireDefault(_funnel);

var _heatmap = __webpack_require__(1295);

var _heatmap2 = _interopRequireDefault(_heatmap);

var _treemap = __webpack_require__(1296);

var _treemap2 = _interopRequireDefault(_treemap);

var _solidGauge = __webpack_require__(1297);

var _solidGauge2 = _interopRequireDefault(_solidGauge);

var _Izenda3 = __webpack_require__(1298);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2017);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2018);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2019);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2020);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2021);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2022);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2023);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

var _Izenda19 = __webpack_require__(34);

var _Izenda20 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Apply highchart extensions
[_highchartsMore2.default, _funnel2.default, _heatmap2.default, _treemap2.default, _solidGauge2.default, _Izenda4.default, _Izenda6.default, _Izenda8.default, _Izenda12.default, _Izenda14.default, _Izenda16.default, _Izenda18.default, _Izenda10.default].forEach(function (fn) {
  return fn(_highcharts2.default);
});

// Apply global settings to Highchart library
_highcharts2.default.setOptions({ global: { useUTC: false } });

/**
 * Highchart visualization engine
 */
var HighchartVizEngine = (_dec = (0, _Izenda20.exportClass)('HighchartVizEngine'), _dec(_class = (_temp = _class2 = function (_VizEngine) {
  (0, _inherits3.default)(HighchartVizEngine, _VizEngine);

  function HighchartVizEngine() {
    (0, _classCallCheck3.default)(this, HighchartVizEngine);
    return (0, _possibleConstructorReturn3.default)(this, (HighchartVizEngine.__proto__ || (0, _getPrototypeOf2.default)(HighchartVizEngine)).apply(this, arguments));
  }

  (0, _createClass3.default)(HighchartVizEngine, [{
    key: 'draw',


    /**
     * Draw chart into chart container and return chart instance with releasing function
     * @param {DOMElement} chartContainer DOM element of chart
     * @param {string} chartType Izenda chart type
     * @param {Object} options Chart options
     * @param {Function} onCompleted A callback function to be invoked after finished rendering
     */
    value: function draw(chartContainer, chartType, options, onCompleted) {
      false && this.logHighchartOptions(options);

      var afterRender = this.afterRender;

      if (!(0, _fp.size)(options.series)) {
        return $izenda(chartContainer).empty().text(_Izenda19.Messages.NoDataToShow);
      }

      var chartInstance = new _highcharts2.default.Chart(chartContainer, options, function () {
        afterRender(this);

        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        onCompleted(params);
      });

      return {
        chartInstance: chartInstance,
        destroy: function destroy() {
          chartInstance && chartInstance.hasRendered && chartInstance.destroy();
        }
      };
    }

    /**
     *
     * @param {Object} highchartInstance Highchart Chart instance
     */

  }, {
    key: 'afterRender',
    value: function afterRender(highchartInstance) {}
  }]);
  return HighchartVizEngine;
}(_Izenda2.default), _class2.VisualizationLibrary = _highcharts2.default, _temp)) || _class);
exports.default = HighchartVizEngine;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityQuestionReadOnly.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  function SecurityQuestionReadOnly(data) {
    this.securityQuestionId = null;
    this.question = null;

    data && this.populate(data);
  }

  SecurityQuestionReadOnly.prototype.populate = function (data) {
    this.securityQuestionId = data.securityQuestionId || data.id;
    this.question = data.question;
  };

  module.exports = SecurityQuestionReadOnly;
}();

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.IntegrationSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var extendObservable = __webpack_require__(5).extendObservable;

  function IntegrationSetting() {
    var props = {
      // For hidden license token and key on UI
      deploymentMode: 0,
      isIntegrationMode: function isIntegrationMode() {
        return this.deploymentMode > 0;
      }
    };

    extendObservable(this, props);
  }

  /**
   * read Integration Setting information response from api
   * @param  {object} response from api
   */
  IntegrationSetting.prototype.readDeploymentMode = function (response) {
    this.deploymentMode = response.deploymentMode;
  };

  module.exports = new IntegrationSetting();
}();

/***/ }),
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Cancellation.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  function Cancellation() {
    this.suppressUnhandledRejections = true;
  }
  Cancellation.prototype = Error.prototype;

  module.exports = Cancellation;
}();

/***/ }),
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Resizable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var _propTypes;

  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var PropTypes = React.PropTypes;
  var DraggableCore = __webpack_require__(359).DraggableCore;
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);
  var query = __webpack_require__(844);
  var ResizableController = __webpack_require__(851);
  var Handle = ResizableController.Handle;
  var EventName = ResizableController.EventName;

  var _require = __webpack_require__(1),
      isEqual = _require.isEqual,
      assign = _require.assign,
      omit = _require.omit,
      assignAll = _require.assignAll,
      placeholder = _require.placeholder;

  var Resizable = React.createClass({
    displayName: 'Resizable',

    propTypes: (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, '' + EventName.Resize, PropTypes.func), (0, _defineProperty3.default)(_propTypes, '' + EventName.ResizeStart, PropTypes.func), (0, _defineProperty3.default)(_propTypes, '' + EventName.ResizeStop, PropTypes.func), (0, _defineProperty3.default)(_propTypes, 'style', PropTypes.object), (0, _defineProperty3.default)(_propTypes, 'children', PropTypes.element.isRequired), (0, _defineProperty3.default)(_propTypes, 'width', PropTypes.oneOfType([PropTypes.number, PropTypes.string])), (0, _defineProperty3.default)(_propTypes, 'height', PropTypes.oneOfType([PropTypes.number, PropTypes.string])), (0, _defineProperty3.default)(_propTypes, 'draggableOptions', PropTypes.object), (0, _defineProperty3.default)(_propTypes, 'minConstraints', PropTypes.arrayOf(PropTypes.number)), (0, _defineProperty3.default)(_propTypes, 'maxConstraints', PropTypes.arrayOf(PropTypes.number)), (0, _defineProperty3.default)(_propTypes, 'topResize', React.PropTypes.bool), (0, _defineProperty3.default)(_propTypes, 'leftResize', React.PropTypes.bool), (0, _defineProperty3.default)(_propTypes, 'rightResize', React.PropTypes.bool), (0, _defineProperty3.default)(_propTypes, 'bottomResize', React.PropTypes.bool), (0, _defineProperty3.default)(_propTypes, 'topLeftResize', React.PropTypes.bool), (0, _defineProperty3.default)(_propTypes, 'topRightResize', React.PropTypes.bool), (0, _defineProperty3.default)(_propTypes, 'bottomLeftResize', React.PropTypes.bool), (0, _defineProperty3.default)(_propTypes, 'bottomRightResize', React.PropTypes.bool), (0, _defineProperty3.default)(_propTypes, 'topResizeClass', React.PropTypes.string), (0, _defineProperty3.default)(_propTypes, 'leftResizeClass', React.PropTypes.string), (0, _defineProperty3.default)(_propTypes, 'rightResizeClass', React.PropTypes.string), (0, _defineProperty3.default)(_propTypes, 'bottomResizeClass', React.PropTypes.string), (0, _defineProperty3.default)(_propTypes, 'topLeftResizeClass', React.PropTypes.string), (0, _defineProperty3.default)(_propTypes, 'topRightResizeClass', React.PropTypes.string), (0, _defineProperty3.default)(_propTypes, 'bottomLeftResizeClass', React.PropTypes.string), (0, _defineProperty3.default)(_propTypes, 'bottomRightResizeClass', React.PropTypes.string), (0, _defineProperty3.default)(_propTypes, 'resizableController', React.PropTypes.object), _propTypes),
    getDefaultProps: function getDefaultProps() {
      return {
        minConstraints: [20, 20],
        maxConstraints: [Infinity, Infinity],
        topResize: false,
        leftResize: false,
        rightResize: false,
        bottomResize: false,
        topLeftResize: false,
        topRightResize: false,
        bottomLeftResize: false,
        bottomRightResize: false,
        topResizeClass: '',
        leftResizeClass: '',
        rightResizeClass: '',
        bottomResizeClass: '',
        topLeftResizeClass: '',
        topRightResizeClass: '',
        bottomLeftResizeClass: '',
        bottomRightResizeClass: ''
      };
    },
    componentWillMount: function componentWillMount() {
      var props = this.props;
      // Initial component variables
      this.controller = props.resizableController || new ResizableController(0, 0, props.width, props.height, props.minConstraints, props.maxConstraints);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (!isEqual(this.props.minConstraints, nextProps.minConstraints)) {
        this.controller.setMinConstraints(nextProps.minConstraints);
      }
      if (!isEqual(this.props.maxConstraints, nextProps.maxConstraints)) {
        this.controller.setMaxConstraints(nextProps.maxConstraints);
      }
    },
    render: function render() {
      var props = this.props;
      var child = React.Children.only(props.children);
      var width = props.width;
      var height = props.height;
      var className = classnames('izenda-Resizable', props.className, child.props.className);

      var rest = omit(['children', 'className', 'width', 'height', 'minConstraints', 'maxConstraints', 'onResize', 'onResizeStop', 'onResizeStart', 'style', 'resizableController', 'topResize', 'leftResize', 'rightResize', 'bottomResize', 'topLeftResize', 'topRightResize', 'bottomLeftResize', 'bottomRightResize', 'topResizeClass', 'leftResizeClass', 'rightResizeClass', 'bottomResizeClass', 'topLeftResizeClass', 'topRightResizeClass', 'bottomLeftResizeClass', 'bottomRightResizeClass'], props);

      var style = assign(props.style, child.props.style);

      var childProps = assignAll([rest, { width: width, height: height }, { style: style }, { className: className }]);

      var grandchildren = React.Children.toArray(child.props.children).concat(this.getHandles());

      return React.cloneElement(child, childProps, grandchildren);
    },
    getHandles: function getHandles() {
      var _handleInfo;

      var props = this.props;
      var resizerHandler = this.resizeHandler;

      var handleInfo = (_handleInfo = {}, (0, _defineProperty3.default)(_handleInfo, '' + Handle.top, {
        allow: props.topResize,
        className: classnames('izenda-Handle-HorizontalTop', props.topResizeClass)
      }), (0, _defineProperty3.default)(_handleInfo, '' + Handle.left, {
        allow: props.leftResize,
        className: classnames('izenda-Handle-VerticalLeft', props.leftResizeClass)
      }), (0, _defineProperty3.default)(_handleInfo, '' + Handle.right, {
        allow: props.rightResize,
        className: classnames('izenda-Handle-VerticalRight', props.rightResizeClass)
      }), (0, _defineProperty3.default)(_handleInfo, '' + Handle.bottom, {
        allow: props.bottomResize,
        className: classnames('izenda-Handle-HorizontalBottom', props.bottomResizeClass)
      }), (0, _defineProperty3.default)(_handleInfo, '' + Handle.topLeft, {
        allow: props.topLeftResize,
        className: classnames('izenda-Handle-CornerLeftTop', props.topLeftResizeClass)
      }), (0, _defineProperty3.default)(_handleInfo, '' + Handle.topRight, {
        allow: props.topRightResize,
        className: classnames('izenda-Handle-CornerRightTop', props.topRightResizeClass)
      }), (0, _defineProperty3.default)(_handleInfo, '' + Handle.bottomLeft, {
        allow: props.bottomLeftResize,
        className: classnames('izenda-Handle-CornerLeftBottom', props.bottomLeftResizeClass)
      }), (0, _defineProperty3.default)(_handleInfo, '' + Handle.bottomRight, {
        allow: props.bottomRightResize,
        className: classnames('izenda-Handle-CornerRightBottom', props.bottomRightResizeClass)
      }), _handleInfo);

      return placeholder(Handle).chain().values().filter(function (handle) {
        return handleInfo[handle].allow;
      }).map(createResizeHandle).value();

      function createResizeHandle(handle) {
        var info = handleInfo[handle];
        var handleClassName = classnames('js-resize-handle', info.className);
        return React.createElement(
          DraggableCore,
          (0, _extends3.default)({
            key: handle,
            onStop: resizerHandler(EventName.ResizeStop, handle),
            onStart: resizerHandler(EventName.ResizeStart, handle),
            onDrag: resizerHandler(EventName.Resize, handle)
          }, props.draggableOptions),
          React.createElement('div', { className: handleClassName })
        );
      }
    },
    synchSize: function synchSize() {
      var node = ReactDOM.findDOMNode(this);
      var props = this.props;
      var width = props.width;
      var height = props.height;
      var draggableOptions = props.draggableOptions;
      var offsetParent = draggableOptions ? draggableOptions.offsetParent : null;
      var position = query.position(node, offsetParent);

      width = position.width;
      height = position.height;

      this.controller.updatePosition(position.left, position.top, width, height);
    },
    resizeHandler: function resizeHandler(eventName, handle) {
      var controller = this.controller;
      var synchSize = this.synchSize;
      var resizeCallback = this.props[eventName];

      return function (e, dragData) {
        if (eventName === EventName.ResizeStart) {
          synchSize();
        }

        controller.resizeHandler(eventName, handle, dragData, resizeCallback);
      };
    }
  });

  module.exports = observer(Resizable);
}();

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function () {
  var action = __webpack_require__(5).action;
  var extendObservable = __webpack_require__(5).extendObservable;

  var _require = __webpack_require__(1),
      max = _require.max,
      min = _require.min;

  var Handle = {
    top: 'TOP',
    left: 'LEFT',
    right: 'RIGHT',
    bottom: 'BOTTOM',
    topLeft: 'TOP_LEFT',
    topRight: 'TOP_RIGHT',
    bottomLeft: 'BOTTOM_LEFT',
    bottomRight: 'BOTTOM_RIGHT'
  };

  var EventName = {
    Resize: 'onResize',
    ResizeStart: 'onResizeStart',
    ResizeStop: 'onResizeStop'
  };

  function ResizableController(defaultX, defaultY, defaultWidth, defaultHeight, minConstraints, maxConstraints) {
    this.minConstraints = minConstraints;
    this.maxConstraints = maxConstraints;

    extendObservable(this, {
      width: defaultWidth,
      height: defaultHeight,
      slackWidth: 0,
      slackHeight: 0,
      x: defaultX,
      y: defaultY
    });
  }

  ResizableController.prototype.updatePosition = action(function updatePosition(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  });

  ResizableController.prototype.setWidthHeight = action(function setWidthHeight(width, height) {
    this.width = width;
    this.height = height;
  });

  ResizableController.prototype.setMinConstraints = action(function updatePosition(minConstraints) {
    this.minConstraints = minConstraints;
  });

  ResizableController.prototype.setMaxConstraints = action(function setWidthHeight(maxConstraints) {
    this.maxConstraints = maxConstraints;
  });

  ResizableController.prototype.resizeHandler = action(function resizeHandler(eventName, handle, dragData, resizeCallback) {
    if (eventName === EventName.ResizeStart) {
      this.slackWidth = 0;
      this.slackHeight = 0;
    }

    var deltaX = detectChangeX(handle) ? -dragData.deltaX : dragData.deltaX;
    var deltaY = detectChangeY(handle) ? -dragData.deltaY : dragData.deltaY;

    var newWidth = this.width + deltaX;
    var newHeight = this.height + deltaY;
    var finalDim = this.runConstraints(newWidth, newHeight, handle);

    var widthChanged = this.width !== finalDim.width && detectChangeWidth(handle);
    var heightChanged = this.height !== finalDim.height && detectChangeHeight(handle);

    if (eventName === EventName.Resize && !widthChanged && !heightChanged) {
      return;
    }

    if (this.width !== finalDim.width && detectChangeWidth(handle)) {
      detectChangeX(handle) && (this.x += this.width - finalDim.width);
      this.width = finalDim.width;
    }
    if (this.height !== finalDim.height && detectChangeHeight(handle)) {
      detectChangeY(handle) && (this.y += this.height - finalDim.height);
      this.height = finalDim.height;
    }

    resizeCallback && resizeCallback({
      left: this.x,
      top: this.y,
      width: this.width,
      height: this.height
    });
  });

  ResizableController.prototype.runConstraints = action(function runConstraints(width, height, side) {
    var oldWidth = width;
    var oldHeight = height;
    var slackWidth = this.slackWidth;
    var slackHeight = this.slackHeight;
    var mostRight = this.maxConstraints ? this.maxConstraints[0] : Infinity;
    var mostBottom = this.maxConstraints ? this.maxConstraints[1] : Infinity;
    var changeX = detectChangeX(side);
    var changeY = detectChangeY(side);
    var mostWidth = changeX ? this.x + this.width : mostRight - this.x;
    var mostHeight = changeY ? this.y + this.height : mostBottom - this.y;

    var maxWidth = mostRight === Infinity ? Infinity : mostWidth;
    var maxHeight = mostBottom === Infinity ? Infinity : mostHeight;

    if (!this.minConstraints && !this.maxConstraints) {
      return { width: width, height: height };
    }
    width += slackWidth;
    height += slackHeight;

    if (this.minConstraints) {
      width = max([this.minConstraints[0], width]);
      height = max([this.minConstraints[1], height]);
    }

    if (this.maxConstraints) {
      width = min([maxWidth, width]);
      height = min([maxHeight, height]);
    }

    this.slackWidth += oldWidth - width;
    this.slackHeight += oldHeight - height;

    return { width: width, height: height };
  });

  function detectChangeWidth(handle) {
    return (/(LEFT|RIGHT)/g.test(handle)
    );
  }
  function detectChangeHeight(handle) {
    return (/(TOP|BOTTOM)/g.test(handle)
    );
  }
  function detectChangeX(handle) {
    return (/LEFT/g.test(handle)
    );
  }
  function detectChangeY(handle) {
    return (/TOP/g.test(handle)
    );
  }

  ResizableController.Handle = Handle;

  ResizableController.EventName = EventName;

  module.exports = ResizableController;
}();

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Measure.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var PropTypes = React.PropTypes;

  var observer = __webpack_require__(10).observer;
  var observable = __webpack_require__(5).observable;
  var fastdom = __webpack_require__(486);
  var elementResizeDetector = __webpack_require__(208);
  var DEFAULT_DEBOUNCE_TIME = 450;

  var _require = __webpack_require__(1),
      debounce = _require.debounce,
      isNil = _require.isNil,
      omit = _require.omit;

  var Measure = React.createClass({
    displayName: 'Measure',

    propTypes: {
      children: PropTypes.element,
      measureBeforeMount: PropTypes.bool,
      onChange: PropTypes.func
    },
    getDefaultProps: function getDefaultProps() {
      return {
        measureBeforeMount: false
      };
    },

    componentWillMount: function componentWillMount() {
      this.dimensionState = observable({
        mounted: false
      });
    },

    onChange: function onChange(element) {
      var onChange = this.props.onChange;
      fastdom.measure(function () {
        element && onChange && onChange(element.clientWidth, element.clientHeight);
      });
    },

    initListener: function initListener(domNode) {
      var listener = domNode && elementResizeDetector.listenTo(domNode, debounce(DEFAULT_DEBOUNCE_TIME, this.onChange));

      // this.onChange(domNode);

      this.domNode = domNode;
      this.listener = listener;
    },

    componentDidMount: function componentDidMount() {
      var domNode = ReactDOM.findDOMNode(this);
      this.dimensionState.mounted = true;
      this.initListener(domNode);
    },

    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
      var domNode = ReactDOM.findDOMNode(this);
      if (this.listener && this.domNode !== domNode) {
        elementResizeDetector.removeListener(this.domNode, this.listener);
        this.initListener(domNode);
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      var domNode = ReactDOM.findDOMNode(this);
      !isNil(domNode) && elementResizeDetector.removeAllListeners(domNode);
    },

    render: function render() {
      if (this.props.measureBeforeMount && !this.dimensionState.mounted) return React.createElement('div', (0, _extends3.default)({ style: { width: this.dimensionState.width } }, omit(['measureBeforeMount', 'children'], this.props)));

      return this.props.children;
    }
  });

  module.exports = observer(Measure);
}();

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1507);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(179);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1508);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1976);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(1977);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(975);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(976);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(16);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(413);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(188);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(540);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEEP_COMPARE_PROPERTIES = ['style'];
var PADDING_SIZE = 10;
var DEFAULT_REPORT_BODY_HEIGHT = 38;

_Izenda24.default.initRegistry();

var ReportPartContainer = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ReportPartContainer, _Component);

  function ReportPartContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportPartContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportPartContainer.__proto__ || (0, _getPrototypeOf2.default)(ReportPartContainer)).call.apply(_ref, [this].concat(args))), _this), _this.destroyReaction = function () {
      (0, _fp.invoke)('disposeReaction', _this);
    }, _this.initReaction = function (props) {
      var switchToDesignReportContainer = _this.props.store.reportStore.switchToDesignReportContainer;

      _this.destroyReaction();
      _this.disposeReaction = (0, _mobx.reaction)(function () {
        return (0, _fp.get)('reportPartContent', props.gridItem);
      }, function () {
        // use lasted props don't need to bind to current props object when create observe
        !switchToDesignReportContainer && props.loadReportPartData();
      });
    }, _this.changeReportPartSide = function () {
      var _this$props = _this.props,
          reportBody = _this$props.reportBody,
          gridItem = _this$props.gridItem,
          viewMode = _this$props.viewMode;
      // if the page in view mode then report part should be front side

      if (viewMode && gridItem.isBackSide) {
        reportBody.changeReportPartSide(gridItem, false);
      }
    }, _this.setDom = function (dom) {
      _this.containerRef = dom;
    }, _this.renderContent = function (partProps, isDefault) {
      var props = _this.props;
      if (isDefault) {
        return _react2.default.createElement(_Izenda10.default, (0, _extends3.default)({}, partProps, {
          beforeShowProps: props.beforeShowProps,
          propsEditors: _Izenda18.default.EDITOR_CONFIG.ReportPart
        }));
      }

      return props.gridItem.isBackSide ? _react2.default.createElement(_Izenda12.default, (0, _extends3.default)({}, partProps, { stateReview: props.stateReview })) : _react2.default.createElement(_Izenda14.default, partProps);
    }, _this.checkPrivileges = function () {
      var _this$props2 = _this.props,
          gridItem = _this$props2.gridItem,
          authorization = _this$props2.authorization;


      var reportPartConfig = (0, _fp.find)(function (item) {
        return item.value === gridItem.type;
      }, _Izenda18.default.REPORT_PART_PERMISSIONS);

      if (!(0, _fp.isNil)(reportPartConfig) && reportPartConfig.permissions) {
        return authorization.checkPrivileges(reportPartConfig.permissions);
      }

      return true;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReportPartContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var reportStore = this.props.store.reportStore;


      if (!reportStore.switchToDesignReportContainer) {
        this.props.loadReportPartData();
        this.initReaction(this.props);
        this.changeReportPartSide();
      } else {
        reportStore.switchToDesignReportContainer = false;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroyReaction();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var switchToDesignReportContainer = this.props.store.reportStore.switchToDesignReportContainer;

      // for full screen, if change config report part we need to load data

      if (this.props.gridItem !== nextProps.gridItem && !switchToDesignReportContainer) {
        nextProps.loadReportPartData();
        this.initReaction(nextProps);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props = this.props,
          width = _props.width,
          height = _props.height;


      if (nextProps.width !== width || nextProps.height !== height && height !== DEFAULT_REPORT_BODY_HEIGHT) {
        return false;
      }

      var reduceWithKey = _fp.reduce.convert({ cap: false });
      // Reduce render for style object
      var result = reduceWithKey(function (acc, value, key) {
        var cur = (0, _fp.get)(key, acc);
        if (DEEP_COMPARE_PROPERTIES.indexOf(key) > -1 ? (0, _fp.isEqual)(cur, value) : cur === value) {
          return (0, _fp.unset)(key, acc);
        }
        return (0, _fp.set)(key, [key, cur], acc);
      }, (0, _fp.clone)(nextProps), this.props);

      return !(0, _fp.isEmpty)(result);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          onMeasureChange = _props2.onMeasureChange,
          autoSize = _props2.autoSize;
      var _containerRef = this.containerRef,
          clientWidth = _containerRef.clientWidth,
          clientHeight = _containerRef.clientHeight;

      autoSize && onMeasureChange && onMeasureChange(clientWidth, clientHeight);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = props.store,
          uiStore = props.uiStore,
          viewMode = props.viewMode,
          printingMode = props.printingMode,
          quickEdit = props.quickEdit,
          _props$reportBody = props.reportBody,
          reportBody = _props$reportBody === undefined ? {} : _props$reportBody,
          autoSize = props.autoSize,
          minWidth = props.minWidth,
          minHeight = props.minHeight,
          loader = props.loader,
          hideGridPopup = props.hideGridPopup;

      var reportPart = props.gridItem;
      var reportPartId = reportPart.id;
      var hasPrivileges = this.checkPrivileges();
      var isDefault = (0, _fp.isNil)(reportPart.type);
      var partProps = {
        reportPart: reportPart,
        reportBody: reportBody,
        store: store,
        viewMode: viewMode,
        quickEdit: quickEdit,
        hasPrivileges: hasPrivileges,
        autoSize: autoSize,
        loader: loader,
        hideGridPopup: hideGridPopup
      };

      var contentStyle = (0, _extends3.default)({}, !reportPart.isLoadingData && { minWidth: minWidth - PADDING_SIZE || 0, minHeight: minHeight - PADDING_SIZE || 0 });

      var header = {
        component: hasPrivileges ? _Izenda22.default.wrapper(_Izenda8.default) : _Izenda8.default
      };

      if (printingMode) {
        var reportId = store.reportId;

        return _react2.default.createElement(
          'div',
          { id: reportPartId, ref: this.setDom, className: 'report-part u-bgWhite u_noPaddingAll' },
          _react2.default.createElement(
            'div',
            { className: 'report-content u-bgWhite', style: contentStyle },
            _react2.default.createElement(_Izenda16.default, {
              reportPart: reportPart,
              store: store,
              reportPartId: reportPartId,
              reportId: reportId,
              exportFormatSetting: props.exportFormatSetting,
              printingMode: printingMode,
              hideGridPopup: true,
              setting: props.setting,
              finishedRender: props.finishedRender,
              doesBreakPage: props.doesBreakPage,
              isFirstReportPart: props.isFirstReportPart
            })
          ),
          props.pageBreakAfterReportPart && !props.isLastReportPart && _react2.default.createElement('div', { className: 'u_alwaysBreakAfter' })
        );
      }

      return _react2.default.createElement(
        'div',
        { id: reportPartId, ref: this.setDom, className: 'report-part', style: props.style },
        _react2.default.createElement(
          'div',
          { className: 'report-content', style: contentStyle },
          _react2.default.createElement(header.component, {
            itemData: reportPart,
            reportPart: reportPart,
            reportBody: reportBody,
            store: store,
            uiStore: uiStore,
            viewMode: viewMode,
            quickEdit: quickEdit,
            propsEditors: _Izenda18.default.EDITOR_CONFIG.ReportPart,
            beforeShowProps: props.beforeShowProps,
            setStateReview: props.setStateReview,
            stateReview: props.stateReview,
            hasPrivileges: hasPrivileges,
            onChangeFullScreen: props.onChangeFullScreen,
            loadReportPartData: props.loadReportPartData
          }),
          this.renderContent(partProps, isDefault),
          reportPart.type !== _Izenda18.default.REPORT_PART_TYPE.Chart && _react2.default.createElement(_Izenda20.default, null)
        )
      );
    }
  }]);
  return ReportPartContainer;
}(_react.Component), _class.propTypes = {
  store: _propTypes2.default.object,
  gridItem: _propTypes2.default.object.isRequired,
  reportBody: _propTypes2.default.object,
  uiStore: _propTypes2.default.object,
  minWidth: _propTypes2.default.number,
  minHeight: _propTypes2.default.number,
  autoSize: _propTypes2.default.bool,
  isSnapEditOn: _propTypes2.default.bool
}, _temp2);


var partLoaders = {};
exports.default = (0, _Izenda2.default)({
  context: {
    childContextTypes: _Izenda6.default.loaderShape,
    getChildContext: function getChildContext(props) {
      var reportPart = props.gridItem;

      if (!partLoaders[reportPart.id]) {
        partLoaders[reportPart.id] = _Izenda6.default.createLoaderContext();
      }
      return partLoaders[reportPart.id];
    }
  }
}, _Izenda4.default)(ReportPartContainer);
module.exports = exports['default'];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTooltip = initTooltip;
exports.updateTooltip = updateTooltip;
exports.disableTooltip = disableTooltip;
exports.destroyTooltip = destroyTooltip;

var _reactDom = __webpack_require__(32);

/**
 * Initialize BS tooltip
 * @param  {Object} com       React component that has tooltip
 * @param  {Object} option     Tooltip title
 */
function initTooltip(com, option) {
  var node = (0, _reactDom.findDOMNode)(com);
  node && option && $izenda(node).tooltip(option);
}

/**
 * Work-around update tooltip content by updating its data-original-title
 * @param  {Object} com   React component that has tooltip
 * @param  {string} title New tooltip title
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.TooltipUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/* eslint-disable react/no-find-dom-node */
function updateTooltip(com, title) {
  var node = (0, _reactDom.findDOMNode)(com);
  if (node) {
    $izenda(node).tooltip('enable');
    $izenda(node).attr('data-original-title', title);
  }
}

/**
 * Disable tooltip
 * @param  {Object} com React component that has tooltip
 */
function disableTooltip(com) {
  var node = (0, _reactDom.findDOMNode)(com);
  node && $izenda(node).tooltip('disable');
}

/**
 * Destroy tooltip
 * @param  {Object} com React component that has tooltip
 */
function destroyTooltip(com) {
  var node = (0, _reactDom.findDOMNode)(com);
  node && $izenda(node).tooltip('destroy');
}

exports.default = {
  initTooltip: initTooltip,
  updateTooltip: updateTooltip,
  disableTooltip: disableTooltip,
  destroyTooltip: destroyTooltip
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Resizer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ResizableController = __webpack_require__(851);
  var Resizable = __webpack_require__(850);

  var observer = __webpack_require__(10).observer;
  var Resizer = React.createClass({
    displayName: 'Resizer',

    propTypes: {
      children: PropTypes.element.isRequired,
      width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      onResize: PropTypes.func,
      onResizeStop: PropTypes.func,
      minConstraints: PropTypes.arrayOf(PropTypes.number),
      maxConstraints: PropTypes.arrayOf(PropTypes.number),
      rightResize: React.PropTypes.bool,
      bottomResize: React.PropTypes.bool,
      bottomRightResize: React.PropTypes.bool,
      rightResizeClass: React.PropTypes.string,
      bottomResizeClass: React.PropTypes.string,
      bottomRightResizeClass: React.PropTypes.string
    },
    getDefaultProps: function getDefaultProps() {
      return {
        width: 'auto',
        height: 'auto',
        rightResize: false,
        bottomResize: false,
        bottomRightResize: false
      };
    },
    componentWillMount: function componentWillMount() {
      var props = this.props;
      // Initial component variables
      this.controller = new ResizableController(0, 0, props.width, props.height, props.minConstraints, props.maxConstraints);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (nextProps.width !== this.props.width || nextProps.height !== this.props.height) {
        this.controller.setWidthHeight(nextProps.width, nextProps.height);
      }
    },
    render: function render() {
      var props = this.props;
      var minConstraints = props.minConstraints;
      var maxConstraints = props.maxConstraints;
      var rightResize = props.rightResize;
      var bottomResize = props.bottomResize;
      var bottomRightResize = props.bottomRightResize;
      var rightResizeClass = props.rightResizeClass;
      var bottomResizeClass = props.bottomResizeClass;
      var bottomRightResizeClass = props.bottomRightResizeClass;
      var onResize = props.onResize;
      var onResizeStop = props.onResizeStop;

      var style = {
        width: this.controller.width,
        height: this.controller.height
      };

      return React.createElement(
        Resizable,
        {
          width: this.controller.width,
          height: this.controller.height,
          minConstraints: minConstraints,
          maxConstraints: maxConstraints,
          rightResize: rightResize,
          bottomResize: bottomResize,
          bottomRightResize: bottomRightResize,
          rightResizeClass: rightResizeClass,
          bottomResizeClass: bottomResizeClass,
          bottomRightResizeClass: bottomRightResizeClass,
          resizableController: this.controller,
          style: style,
          onResize: onResize,
          onResizeStop: onResizeStop
        },
        this.props.children
      );
    }
  });

  module.exports = observer(Resizer);
}();

/***/ }),
/* 917 */,
/* 918 */,
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Portal.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Portal component
 */
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var AppGlobal = __webpack_require__(41);

  var Portal = React.createClass({
    displayName: 'Portal',

    componentDidMount: function componentDidMount() {
      this.renderOverlay();
    },

    componentDidUpdate: function componentDidUpdate() {
      this.renderOverlay();
    },

    renderOverlay: function renderOverlay() {
      var overlay = !this.props.children ? null : React.Children.only(this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        this.mountOverlayTarget();
        this.overlayInstance = ReactDOM.unstable_renderSubtreeIntoContainer(this, overlay, this.overlayTarget);
      } else {
        // Unrender if the component is null for transitions to null
        this.unrenderOverlay();
        this.unmountOverlayTarget();
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      this.unrenderOverlay();
      this.unmountOverlayTarget();
    },

    mountOverlayTarget: function mountOverlayTarget() {
      if (!this.overlayTarget) {
        this.overlayTarget = document.createElement('div');
        this.portalContainerNode = AppGlobal.containerElement;
        this.portalContainerNode.appendChild(this.overlayTarget);
      }
    },

    unmountOverlayTarget: function unmountOverlayTarget() {
      if (this.overlayTarget) {
        this.portalContainerNode.removeChild(this.overlayTarget);
        this.overlayTarget = null;
      }
      this.portalContainerNode = null;
    },

    unrenderOverlay: function unrenderOverlay() {
      if (this.overlayTarget) {
        ReactDOM.unmountComponentAtNode(this.overlayTarget);
        this.overlayInstance = null;
      }
    },

    render: function render() {
      return null;
    },

    getMountNode: function getMountNode() {
      return this.overlayTarget;
    },

    getOverlayDOMNode: function getOverlayDOMNode() {
      if (!this.isMounted()) {
        return;
      }

      if (this.overlayInstance) {
        return ReactDOM.findDOMNode(this.overlayInstance);
      }

      return null;
    }
  });

  module.exports = Portal;
}();

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PopupInputUIState.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var PopupInputUIState = (_class = function () {
  function PopupInputUIState() {
    (0, _classCallCheck3.default)(this, PopupInputUIState);

    _initDefineProp(this, 'hadSetting', _descriptor, this);

    _initDefineProp(this, 'value', _descriptor2, this);

    _initDefineProp(this, 'settingValue', _descriptor3, this);
  }

  (0, _createClass3.default)(PopupInputUIState, [{
    key: 'update',
    value: function update(props) {
      this.value = (0, _fp.isFunction)(props.loadValue) ? props.loadValue() : props.value;
      this.settingValue = (0, _fp.isFunction)(props.loadValue) ? props.loadValue() : props.settingValue;
      this.hadSetting = (0, _fp.isFunction)(props.hadSetting) ? props.hadSetting() : props.hadSetting;
    }
  }]);
  return PopupInputUIState;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'hadSetting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'settingValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'update', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'update'), _class.prototype)), _class);
exports.default = PopupInputUIState;
module.exports = exports['default'];

/***/ }),
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorDialog.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var Hue = __webpack_require__(1789);
  var Saturation = __webpack_require__(1791);
  var ColorPreviews = __webpack_require__(1792);
  var ColorFields = __webpack_require__(1793);
  var ColorDialogUtils = __webpack_require__(397);

  var _require = __webpack_require__(1),
      assign = _require.assign;

  var ColorDialog = React.createClass({
    displayName: 'ColorDialog',

    getDefaultProps: function getDefaultProps() {
      return {
        color: {
          h: 0,
          s: 0,
          l: 1,
          a: 0
        }
      };
    },

    getInitialState: function getInitialState() {
      var props = this.props;
      return assign(ColorDialogUtils.toState(props.color, 0), {
        visible: props.display,
        currentColor: props.color
      });
    },

    handleChange: function handleChange(data) {
      var isValidColor = ColorDialogUtils.simpleCheckForValidColor(data);

      if (isValidColor) {
        var colors = ColorDialogUtils.toState(data, data.h || this.state.oldHue);
        this.setState(colors);
        this.props.onChangeComplete && this.debounce(this.props.onChangeComplete, colors);
        this.props.onChange && this.props.onChange(colors);
      }
    },

    handleAccept: function handleAccept() {
      this.props.onAccept && this.props.onAccept(this.state.hex);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState(assign(ColorDialogUtils.toState(nextProps.color, this.state.oldHue), {
        visible: nextProps.display
      }));
    },

    render: function render() {
      var localization = this.props.localization;

      return React.createElement(
        'div',
        { className: 'izenda-ColorDialog' },
        React.createElement(
          'div',
          { className: 'izenda-ColorDialog-header' },
          localization.getText('COLOR_DIALOG_LABEL_TITLE')
        ),
        React.createElement(
          'div',
          { className: 'izenda-ColorDialog-content' },
          React.createElement(
            'div',
            { className: 'izenda-ColorDialog-saturation izenda-Disable-move' },
            React.createElement(Saturation, { hsl: this.state.hsl, hsv: this.state.hsv, onChange: this.handleChange })
          ),
          React.createElement(
            'div',
            { className: 'izenda-ColorDialog-hue izenda-Disable-move' },
            React.createElement(Hue, { direction: 'vertical', hsl: this.state.hsl, onChange: this.handleChange })
          ),
          React.createElement(
            'div',
            { className: 'izenda-ColorDialog-controls' },
            React.createElement(
              'div',
              { className: 'u_flex' },
              React.createElement(
                'div',
                { className: 'izenda-ColorDialog-previews' },
                React.createElement(ColorPreviews, { rgb: this.state.rgb, currentColor: this.state.currentColor })
              ),
              React.createElement(
                'div',
                { className: 'izenda-ColorDialog-actions' },
                React.createElement(
                  'div',
                  { className: 'izenda-ColorDialog-button', onClick: this.handleAccept },
                  localization.getText('COMMON_LABEL_OK')
                ),
                React.createElement(
                  'div',
                  { className: 'izenda-ColorDialog-button', onClick: this.props.onCancel },
                  localization.getText('COMMON_LABEL_CANCEL')
                ),
                React.createElement(ColorFields, {
                  rgb: this.state.rgb,
                  hsv: this.state.hsv,
                  hex: this.state.hex,
                  onChange: this.handleChange
                })
              )
            )
          )
        )
      );
    }
  });

  module.exports = connect()(ColorDialog);
}();

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimeCalendar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(1795);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(27);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1796);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1797);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(218);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var preYears = 4;
var nextYears = 7;
var firstWeekday = 0;
var lastWeekday = 6;

var DateTimeCalendar = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(DateTimeCalendar, _Component);

  function DateTimeCalendar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DateTimeCalendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateTimeCalendar.__proto__ || (0, _getPrototypeOf2.default)(DateTimeCalendar)).call.apply(_ref, [this].concat(args))), _this), _this.scrollToHour = function () {
      if (_this.props.level == 'hours' && _this.datetimeCellRef) {
        var parentNode = _this.datetimeCellRef.parentNode.parentNode;

        var deltaTop = 6;
        parentNode.scrollTop = parentNode.offsetTop - deltaTop;
      }
    }, _this.onNavigateCell = function (datetime) {
      var lvl = _Izenda7.Levels[_this.props.level];
      if (lvl.down) _this.props.setLevel(lvl.down);
      _this.props.onSelect(datetime, !lvl.down, lvl.key);
    }, _this.onNavigateUp = function () {
      var lvl = _Izenda7.Levels[_this.props.level];
      if (lvl.up) _this.props.setLevel(lvl.up);
    }, _this.onNavigateLeft = function () {
      var lvl = _Izenda7.Levels[_this.props.level].nav;
      _this.props.onSelect(_this.props.datetime.subtract(lvl.span, lvl.unit));
    }, _this.onNavigateRight = function () {
      var lvl = _Izenda7.Levels[_this.props.level].nav;
      _this.props.onSelect(_this.props.datetime.add(lvl.span, lvl.unit));
    }, _this.onToday = function () {
      var lvl = _Izenda7.Levels[_this.props.level];
      if ((0, _moment2.default)(_this.props.datetime).isSame((0, _moment2.default)(), 'day')) {
        _this.props.onSelect((0, _moment2.default)(), !lvl.down);
      } else {
        _this.props.onSelect((0, _moment2.default)());
      }
    }, _this.getTitle = function (unit, datetime) {
      datetime = datetime || (0, _moment2.default)();
      switch (unit) {
        case 'years':
          {
            var start = datetime.clone().subtract(preYears, 'years');
            var end = datetime.clone().add(nextYears, 'years');
            var years = [];

            (0, _moment2.default)().range(start, end).by(_Izenda7.Units.YEAR, function (year) {
              years.push({
                label: year.format('YYYY'),
                selected: year.isSame(datetime, 'year')
              });
            });
            return [(0, _fp.head)(years).label, (0, _fp.last)(years).label].join('-');
          }
        case 'months':
          return datetime.format('YYYY');

        case 'days':
          return datetime.format('MMMM');

        case 'hours':
          return null;
      }
    }, _this.getCells = function (unit, datetime) {
      datetime = datetime || (0, _moment2.default)();
      var start = void 0,
          end = void 0,
          format = void 0;
      switch (unit) {
        case 'years':
          {
            start = datetime.clone().subtract(preYears, 'years');
            end = datetime.clone().add(nextYears, 'years');
            format = (0, _fp.get)('options.format.year', _this.props) || 'YYYY';
            var years = [];

            (0, _moment2.default)().range(start, end).by(_Izenda7.Units.YEAR, function (year) {
              years.push({
                moment: year,
                label: year.format(format),
                selected: year.isSame(datetime, 'year')
              });
            });

            return years;
          }

        case 'months':
          {
            start = datetime.clone().startOf('year');
            end = datetime.clone().endOf('year');
            format = (0, _fp.get)('options.format.month', _this.props) || 'MM';
            var months = [];

            (0, _moment2.default)().range(start, end).by(_Izenda7.Units.MONTH, function (month) {
              months.push({
                moment: month,
                label: month.format(format),
                selected: month.isSame(datetime, 'month')
              });
            });

            return months;
          }

        case 'days':
          {
            start = datetime.clone().startOf('month').weekday(firstWeekday);
            end = datetime.clone().endOf('month').weekday(lastWeekday);
            format = (0, _fp.get)('options.format.day', _this.props) || 'DD';
            var days = [];

            _moment2.default.weekdaysMin().forEach(function (day) {
              days.push({
                label: day,
                header: true
              });
            });

            (0, _moment2.default)().range(start, end).by(_Izenda7.Units.DAY, function (day) {
              days.push({
                moment: day,
                label: day.format(format),
                past: day.isBefore(datetime, 'month'),
                future: day.isAfter(datetime, 'month'),
                selected: day.isSame(datetime, 'day'),
                today: day.isSame((0, _moment2.default)(), 'day')
              });
            });

            return days;
          }

        case 'hours':
          {
            start = datetime.clone().startOf('day');
            end = datetime.clone().endOf('day');
            format = (0, _fp.get)('options.format.hour', _this.props) || 'HH:mm:ss';

            var hours = [];
            var deltaCloseMinutes = 31;
            var closeBefore = datetime.clone().subtract(deltaCloseMinutes, 'minutes');
            var closeAfter = datetime.clone().add(deltaCloseMinutes, 'minutes');

            (0, _moment2.default)().range(start, end).by(_Izenda7.Units.HOUR, function (hour) {
              hours.push({
                moment: hour,
                label: hour.format(format),
                selected: hour.isSame(datetime, 'minute'),
                nearestBefore: hour.isBetween(closeBefore, datetime),
                nearestAfter: hour.isBetween(datetime, closeAfter)
              });
              var deltaHalfHour = 30;
              var halfHour = hour.clone().add(deltaHalfHour, 'minutes');
              hours.push({
                moment: halfHour,
                label: halfHour.format(format),
                selected: halfHour.isSame(datetime, 'minute'),
                nearestBefore: halfHour.isBetween(closeBefore, datetime),
                nearestAfter: halfHour.isBetween(datetime, closeAfter)
              });
            });

            return hours;
          }
      }
    }, _this.handleClick = function (value) {
      return function () {
        _this.props.above && _this.props.above(value);
      };
    }, _this.updateDateTimeCellRef = function (cell) {
      return function (dom) {
        _this.datetimeCellRef = cell.selected || cell.nearestBefore ? dom : null;
      };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DateTimeCalendar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToHour();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!this.props.above()) {
        this.scrollToHour();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var datetime = props.datetime,
          id = props.id,
          level = props.level;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-DateTimeCalendar', onMouseDown: this.handleClick(true), onMouseUp: this.handleClick(false) },
        level === 'hours' && _react2.default.createElement(
          'div',
          { className: 'izenda-DateTimeCalendar-hours' },
          _react2.default.createElement(
            _Izenda2.default,
            null,
            this.getCells(level, datetime).map(function (cell, i) {
              return _react2.default.createElement(_Izenda4.default, {
                key: i,
                ref: this.updateDateTimeCellRef(cell),
                label: cell.label,
                level: 'hours',
                type: 'base',
                selected: cell.selected,
                today: cell.today,
                moment: cell.moment,
                onClick: this.onNavigateCell,
                invalid: props.validate(cell.moment, level)
              });
            }.bind(this))
          )
        ),
        level !== 'hours' && _react2.default.createElement(
          'div',
          { className: 'izenda-DateTimeCalendar-container' },
          _react2.default.createElement(_Izenda6.default, {
            id: id,
            onPrev: this.onNavigateLeft,
            onNext: this.onNavigateRight,
            onTitle: this.onNavigateUp,
            title: this.getTitle(level, datetime)
          }),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('izenda-DateTimeCalendar-content', level) },
            this.getCells(level, datetime).map(function (cell, i) {
              var type = void 0;
              switch (true) {
                case cell.header:
                  type = 'header';
                  break;
                case cell.past:
                  type = 'past';
                  break;
                case cell.future:
                  type = 'future';
                  break;
                default:
                  type = 'base';
                  break;
              }
              return _react2.default.createElement(_Izenda4.default, {
                key: i,
                ref: _this2.updateDateTimeCellRef(cell),
                label: cell.label,
                level: level,
                type: type,
                selected: cell.selected,
                today: cell.today,
                moment: cell.moment,
                onClick: _this2.onNavigateCell,
                invalid: props.validate(cell.moment, level)
              });
            }),
            _react2.default.createElement(
              'div',
              { onClick: this.onToday, className: 'izenda-DateTimeCell-today' },
              (0, _fp.get)('options.format.today', props) || 'Today'
            )
          )
        )
      );
    }
  }]);
  return DateTimeCalendar;
}(_react.Component), _class.propTypes = {
  datetime: _propTypes2.default.object.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  level: _propTypes2.default.string.isRequired,
  setLevel: _propTypes2.default.func.isRequired,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func
}, _temp2);
exports.default = DateTimeCalendar;
module.exports = exports['default'];

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.TableRow.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(564);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableRow = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TableRow, _Component);

  function TableRow() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.renderCell = function (column, index) {
      var props = _this.props;
      var columnWidths = props.columnWidths,
          rowData = props.rowData;

      var rest = (0, _fp.omit)(['newWidth'], column.props);
      var cellData = {};

      if (rest.fnGetCellData && rowData) {
        cellData = rest.fnGetCellData(rowData);
      }

      return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({
        key: index,
        rowData: rowData,
        column: column,
        columnIndex: index,
        rowIndex: props.index,
        newWidth: columnWidths[index],
        didUpdate: props.didUpdate,
        cellAfterRenderCallBack: props.cellAfterRenderCallBack,
        registerCell: props.registerCell,
        unregisterCell: props.unregisterCell,
        cellData: cellData
      }, rest));
    }, _this.handleRowClick = function () {
      var _this$props = _this.props,
          onClickRow = _this$props.onClickRow,
          rowData = _this$props.rowData;


      onClickRow && onClickRow(rowData);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableRow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          stickHorizontal = _props.stickHorizontal,
          index = _props.index,
          tableStore = _props.tableStore;

      if (stickHorizontal && index > 0) {
        var firstColumns = tableStore.cellElements[0];
        var firstCell = firstColumns[0];
        var left = parseInt(firstCell.style.left);
        left > 0 && tableStore.setLeftPosition(firstColumns[index], left);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var connectDragSource = props.connectDragSource,
          rowData = props.rowData,
          columns = props.columns;

      var draggable = !(0, _fp.isNil)(connectDragSource);

      if (rowData && (rowData.deleted || rowData.hidden)) {
        return _react2.default.createElement('div', null);
      }

      var rowProps = (0, _fp.invokeArgs)('rowProps', [rowData], props);
      var rowClasses = (0, _fp.getOr)('', 'className', rowProps);
      var item = props.item || {};

      var classes = (0, _classnames2.default)('table-row', rowClasses, {
        'can-drop': item.isDroppable && props.isOver,
        'cannot-drop': !item.isDroppable && props.isOver,
        'selectable': !!props.onClickRow,
        'highlight-row': props.isHighLight && props.isHighLight(rowData)
      });
      var headerClasses = (0, _classnames2.default)('table-cell', {
        'u-stickLeft': props.stickHorizontal
      });
      var styles = props.rowSpan ? { left: props.rowSpan.width } : {};

      var headerCells = [],
          normalCells = [];
      columns.forEach(function (column, index) {
        column.props.isColumnHeader ? headerCells.push(_this2.renderCell(column, index)) : normalCells.push(_this2.renderCell(column, index));
      });

      return draggable ? props.connectDragPreview(_react2.default.createElement(
        'div',
        (0, _extends3.default)({}, rowProps, { className: classes, onClick: this.handleRowClick }),
        connectDragSource(_react2.default.createElement('div', { className: 'icon-draggable table-cell' })),
        columns.map(this.renderCell)
      )) : props.stickHorizontal ? _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, rowProps, { className: classes, onClick: this.handleRowClick }),
        !props.isSupportSticky && _react2.default.createElement('div', { style: styles, className: 'u-virtualStickLeft' }),
        !(0, _fp.isEmpty)(headerCells) && _react2.default.createElement(
          'div',
          { className: headerClasses },
          headerCells
        ),
        normalCells
      ) : _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, rowProps, { className: classes, onClick: this.handleRowClick }),
        [].concat(headerCells, normalCells)
      );
    }
  }]);
  return TableRow;
}(_react.Component), _class2.propTypes = {
  registerCell: _react.PropTypes.func.isRequired,
  unregisterCell: _react.PropTypes.func.isRequired,
  rowData: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.array]),
  rowProps: _react.PropTypes.func,
  columns: _react.PropTypes.array,
  columnWidths: _mobxReact.propTypes.arrayOrObservableArray,
  index: _react.PropTypes.number,
  isOver: _react.PropTypes.bool,
  isHighLight: _react.PropTypes.func
}, _temp2)) || _class;

exports.default = TableRow;
module.exports = exports['default'];

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _initialiseProps; // ----------------------------------------------------------------------
// <copyright file="Izenda.RowSpanCell.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(564);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RowSpanCell = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RowSpanCell, _Component);

  function RowSpanCell(props) {
    (0, _classCallCheck3.default)(this, RowSpanCell);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RowSpanCell.__proto__ || (0, _getPrototypeOf2.default)(RowSpanCell)).call(this, props));

    _initialiseProps.call(_this);

    _this.buildFn(_this.props);
    return _this;
  }

  (0, _createClass3.default)(RowSpanCell, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.fnGetCellStyle !== nextProps.fnGetCellStyle) {
        this.buildFn(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          cell = _props.cell,
          rowSpan = _props.rowSpan,
          index = _props.index;


      return _react2.default.createElement(_Izenda2.default, {
        cell: cell,
        rowData: rowSpan,
        fnGetCellStyle: this.fnGetCellStyle,
        fnGetCellContentStyle: this.fnGetCellContentStyle,
        columnIndex: index,
        rowIndex: index
      });
    }
  }]);
  return RowSpanCell;
}(_react.Component), _class2.propTypes = {
  rowSpan: _propTypes2.default.object,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  fnGetCellStyle: _propTypes2.default.func,
  fnGetCellContentStyle: _propTypes2.default.func,
  cell: _propTypes2.default.func,
  index: _propTypes2.default.number
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.injectHeigth = function () {
    var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var height = _this2.props.height;

    return height ? (0, _fp.assign)(style, { height: height }) : style;
  };

  this.injectMaxHeigth = function () {
    var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var height = _this2.props.height;

    return height ? (0, _fp.assign)(style, { maxHeight: height }) : style;
  };

  this.injectWidth = function () {
    var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var width = _this2.props.width;

    return width ? (0, _fp.assign)(style, { width: width, minWidth: width, maxWidth: width }) : style;
  };

  this.buildFn = function (props) {
    _this2.fnGetCellStyle = (0, _fp.flow)(props.fnGetCellStyle || _fp.noop, _this2.injectWidth, _this2.injectHeigth);
    _this2.fnGetCellContentStyle = (0, _fp.flow)(props.fnGetCellContentStyle || _fp.noop, _this2.injectMaxHeigth);
  };
}, _temp)) || _class;

exports.default = RowSpanCell;
module.exports = exports['default'];

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PerformanceStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Performace View Model
 */
!function () {
  var m = __webpack_require__(5);
  var action = __webpack_require__(5).action;
  var fetcher = __webpack_require__(263);
  var PerformanceModel = __webpack_require__(1828);
  var uiState = __webpack_require__(15);
  var AppGlobal = __webpack_require__(41);

  function PerformanceStore() {
    this.performanceModel = new PerformanceModel();
  }

  /**
   * init for the first time componentWillMount, link between UISTate and store
   */
  PerformanceStore.prototype.init = action(function () {

    this.observeTenantId();
    uiState.setCheckDirtyFunction(function () {
      return this.performanceModel.isDirty;
    }.bind(this));

    return this.getInitial();
  });

  /**
   * Observe tenantID on setting level
   */
  PerformanceStore.prototype.observeTenantId = action(function () {
    this.disposePerformance = m.observe(uiState, 'tenantId', function () {
      this.getInitial();
    }.bind(this));
  });

  /**
   * unlink between UIState and store
   */
  PerformanceStore.prototype.destroy = action(function () {
    this.disposePerformance();
    uiState.resetCheckDirtyFunction();
  });

  /**
   * Load Initial Data
   */
  PerformanceStore.prototype.getInitial = action(function () {
    this.performanceModel.resetErrorMessage();
    return this.updateData();
  });

  /**
   * [description]
   * @param  {[type]} ) [description]
   * @return {[type]}   [description]
   */
  PerformanceStore.prototype.updateData = action(function () {
    return fetcher.loadPerformance(uiState.getTenantId()).then(this.performanceModel.readPerformanceData.bind(this.performanceModel));
  });

  /**
  * Save Performance
  */
  PerformanceStore.prototype.onSave = action(function () {
    var performanceModel = this.performanceModel;
    var saveData = performanceModel.buildSaveData(uiState.getTenantId());

    return fetcher.savePerformance(saveData).then(performanceModel.showAlertMessage.bind(performanceModel)).then(performanceModel.resetDirty).then(this.updateData.bind(this)).then(AppGlobal.setPerformance.bind(AppGlobal, saveData)); // update AppGlobal when have changes
  });

  /**
   * Load Performace
   */
  PerformanceStore.prototype.loadPerformance = action(function () {
    return fetcher.loadPerformance(uiState.getTenantId());
  });

  module.exports = PerformanceStore;
}();

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Security View Model
 */
!function () {
  var observe = __webpack_require__(5).observe;
  var fetcher = __webpack_require__(263);
  var uiState = __webpack_require__(15);
  var AppGlobal = __webpack_require__(41);

  var securityConstants = __webpack_require__(1829);
  var SecurityModel = __webpack_require__(1830);

  function SecurityStore() {
    this.model = new SecurityModel();
  }

  /**
   * init for the first time componentWillMount, link between UISTate and store
   */
  SecurityStore.prototype.init = function () {
    this.observeTenantId();
    uiState.setCheckDirtyFunction(function () {
      return this.model.isDirty;
    }.bind(this));

    return this.getInitial();
  };

  /**
   * Observe tenantID on setting level
   */
  SecurityStore.prototype.observeTenantId = function () {
    this.disposeSecurity = observe(uiState, 'tenantId', function () {
      this.getInitial();
    }.bind(this));
  };

  /**
   * Load Initial Data
   */
  SecurityStore.prototype.getInitial = function () {
    this.model.resetErrorMessage();

    return fetcher.getTenantSecurity(uiState.getTenantId()).then(this.model.readSecuritySetting.bind(this.model));
  };

  /**
   * unlink between UIState and store
   */
  SecurityStore.prototype.destroy = function () {
    uiState.resetCheckDirtyFunction();
    this.disposeSecurity();
  };

  /**
   * Save tenant security
   */
  SecurityStore.prototype.saveTenantSecurity = function () {
    var data = this.model.buildSaveData(uiState.getTenantId());

    return fetcher.saveTenantSecurity(data).then(this.model.showAlertMessage.bind(this.model)).then(this.model.resetDirty).then(AppGlobal.setSecurity.bind(AppGlobal, data)); // update AppGlobal when have changes
  };

  /**
   * Load Security Setting
   */
  SecurityStore.prototype.loadSecurity = function () {
    return fetcher.getTenantSecurity(uiState.getTenantId());
  };

  /**
   * Get Bundle
   * @returns {object} bundle
   */
  SecurityStore.prototype.getBundle = function () {
    return securityConstants.BUNDLE;
  };

  module.exports = SecurityStore;
}();

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.OtherSettingsStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Other Settings Store
 */

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(263);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(75);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1831);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(15);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(12);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var OtherSettingsStore = (_class = function () {
  function OtherSettingsStore() {
    (0, _classCallCheck3.default)(this, OtherSettingsStore);
    this.otherSettings = new _Izenda8.default();
  }

  (0, _createClass3.default)(OtherSettingsStore, [{
    key: 'init',


    /**
     * link uiState and store
     */
    value: function init() {
      var _this = this;

      this.observeTenantId();
      _Izenda10.default.setCheckDirtyFunction(function () {
        return _this.otherSettings.isDirty;
      });

      this.otherSettings.resetErrorMessage();
      return this.getInitial(_Izenda10.default.getTenantId());
    }

    /**
     * unlink between uistate and store
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this.disposeLoadOthersSetting();
      _Izenda10.default.resetCheckDirtyFunction();
    }

    /**
     * Observe tenantID on setting level
     */

  }, {
    key: 'observeTenantId',
    value: function observeTenantId() {
      var _this2 = this;

      this.disposeLoadOthersSetting = (0, _mobx.observe)(_Izenda10.default, 'tenantId', function () {
        _this2.getInitial(_Izenda10.default.getTenantId());
      });
    }

    /**
     * Load default data
     * @param {string} tenantId
     */

  }, {
    key: 'getInitial',
    value: function getInitial(tenantId) {
      var _this3 = this;

      tenantId = tenantId || _Izenda10.default.getTenantId();
      this.otherSettings.tenantId = tenantId;
      var assignOtherSettings = function assignOtherSettings(result) {
        return _this3.otherSettings.readOtherSettingsDetail(result);
      };

      return _Izenda4.default.loadOther(tenantId).then(assignOtherSettings);
    }

    /**
     * Save other data
     */

  }, {
    key: 'onSave',
    value: function onSave() {
      var otherSettings = this.otherSettings;
      var showSaveResult = function showSaveResult(result) {
        var message = _Izenda12.default.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED');
        if (!result.success) {
          var messageData = result.messages[0];
          (0, _fp.isObject)(messageData) ? message = messageData.messages : message = messageData;
        }
        otherSettings.alertMessage = {
          type: result.success ? 'success' : 'error',
          message: message
        };
        result.success && otherSettings.resetDirty();
      };

      var data = {
        sortColumnNameValue: otherSettings.sortColumnNameValue,
        trimTimeInJoinsValue: otherSettings.trimTimeInJoinsValue,
        timezoneForDataOffsetValue: otherSettings.timezoneForDataOffsetValue,
        timezoneForTimestampOffsetValue: otherSettings.timezoneForTimestampOffsetValue,
        convertNullToEmptyStringValue: otherSettings.convertNullToEmptyStringValue,
        showSchemaNameValue: otherSettings.showSchemaNameValue,
        showIntroductionTextValue: otherSettings.showIntroductionTextValue,
        introductionTextValue: otherSettings.introductionTextValue,
        sendToDiskPathValue: otherSettings.sendToDiskPathValue,
        commonFilterSettingValue: otherSettings.commonFilterSettingValue,
        multipleSortOnGridHeaderValue: otherSettings.multipleSortOnGridHeaderValue,
        sortColumnNameDefaultValue: otherSettings.sortColumnNameDefaultValue,
        trimTimeInJoinsDefaultValue: otherSettings.trimTimeInJoinsDefaultValue,
        timezoneForDataOffsetDefaultValue: otherSettings.timezoneForDataOffsetDefaultValue,
        timezoneForTimestampOffsetDefaultValue: otherSettings.timezoneForTimestampOffsetDefaultValue,
        convertNullToEmptyStringDefaultValue: otherSettings.convertNullToEmptyStringDefaultValue,
        showSchemaNameDefaultValue: otherSettings.showSchemaNameDefaultValue,
        showIntroductionTextDefaultValue: otherSettings.showIntroductionTextDefaultValue,
        introductionTextDefaultValue: otherSettings.introductionTextDefaultValue,
        sendToDiskPathDefaultValue: otherSettings.sendToDiskPathDefaultValue,
        commonFilterSettingDefaultValue: otherSettings.commonFilterSettingDefaultValue,
        multipleSortOnGridHeaderDefaultValue: otherSettings.multipleSortOnGridHeaderDefaultValue,
        showPreviewValue: otherSettings.showPreviewValue,
        tenantId: otherSettings.tenantId,
        modified: otherSettings.modified,
        hideReportHeaderAndFooterValue: otherSettings.hideReportHeaderAndFooterValue
      };

      return _Izenda4.default.saveOther(data).then(showSaveResult).then(this.getInitial.bind(this, _Izenda10.default.getTenantId())).then(_Izenda2.default.setOther.bind(_Izenda2.default, data));
    }

    /**
     * Load Other
     */

  }, {
    key: 'loadOther',
    value: function loadOther() {
      return _Izenda4.default.loadOther(_Izenda10.default.getTenantId());
    }

    /**
     * Load Category Setting.
     */

  }, {
    key: 'loadCategorySettings',
    value: function loadCategorySettings() {
      return _Izenda6.default.categorySetting();
    }

    /**
     * Load System Date.
     */

  }, {
    key: 'loadSystemDate',
    value: function loadSystemDate() {
      return _Izenda6.default.loadSystemDate();
    }
  }]);
  return OtherSettingsStore;
}(), (_applyDecoratedDescriptor(_class.prototype, 'getInitial', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getInitial'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSave', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSave'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadOther', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadOther'), _class.prototype)), _class);
exports.default = OtherSettingsStore;
module.exports = exports['default'];

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  BUNDLE: {
    get SORT_COLUMN_NAME() {
      return _Izenda2.default.getText('OTHER_SETTINGS_SORT_COLUMN_NAME');
    },
    get TRIM_TIME_IN_JOINS() {
      return _Izenda2.default.getText('OTHER_SETTINGS_TRIM_TIME_IN_JOINS');
    },
    get TIME_ZONE() {
      return _Izenda2.default.getText('OTHER_SETTINGS_TIME_ZONE');
    },
    get RESET_TO_DEFAULT() {
      return _Izenda2.default.getText('OTHER_SETTINGS_RESET_TO_DEFAULT');
    }
  },

  DEFAULT_DATA: [{ name: 'Sort Column Name', value: false }, { name: 'Trim Time In Joins', value: false }, { name: 'Timezone Offset', value: 0 }],

  requiredConstraints: function requiredConstraints(type) {
    return {
      presence: {
        presence: true,
        message: String.format(_Izenda2.default.getText('COMMON_MESSAGES_REQUIRED'), type)
      }
    };
  },

  ARCHIVED_VERSIONS_MIN_VALUE: 0,
  ARCHIVED_VERSIONS_MAX_VALUE: 999999
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.OtherSettingsConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
* Constant data for other settings
*/

module.exports = exports['default'];

/***/ }),
/* 940 */,
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'user/'; // ----------------------------------------------------------------------
// <copyright file="Izenda.UserAccountDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * Load user account
   * @param  {string} tenantId
   * @param  {object} pageInfo
   * @returns {Promise}
   */
  loadAllUserAccounts: function loadAllUserAccounts(tenantId, pageInfo, limitData, userModeType) {
    pageInfo = pageInfo || {};

    var requestData = {
      userModeType: userModeType,
      searchByRole: limitData,
      tenantId: tenantId,
      criteria: pageInfo.searchCriteria || [],
      pageIndex: pageInfo.pageIndex || 1,
      pageSize: pageInfo.pageSize || 10,
      sortOrders: pageInfo.sortOrders || [{
        key: 'userName',
        descending: true
      }]
    };

    return (0, _Izenda2.default)(ROOT_URL + 'load').post(requestData);
  },


  /**
   * generate Password Link
   * @param  {object} data
   * @return {promise}
   */
  generatePasswordLink: function generatePasswordLink(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'generatePasswordLink').post(data);
  },


  /**
   * activate User
   * @param  {object} data
   * @return {boolean}
   */
  activateUser: function activateUser(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'active/').post(data);
  },


  /**
   * deactivate User
   * @param  {object} data
   * @return {boolean}
   */
  deactivateUser: function deactivateUser(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'deactive/').post(data);
  },


  /**
   * save user set up detail
   * @param  {object} data
   * @return {promise}
   */
  save: function save(data) {
    data = data || {};
    return (0, _Izenda2.default)(ROOT_URL).post(data);
  },


  /**
   * delete user set up detail
   * @param  {string} userId
   * @return {boolean}
   */
  deleteUser: function deleteUser(userId) {
    userId = userId || '';
    return (0, _Izenda2.default)(ROOT_URL + userId).delete();
  },


  /**
   * save Password Options
   * @param  {object} data
   * @return {promise}
   */
  savePasswordOptions: function savePasswordOptions(data) {
    data = data || {};
    return (0, _Izenda2.default)(ROOT_URL + 'sendPasswordLink').post(data);
  },


  /**
   * Validate expiration of password link.
   * @param  {String} data
   */
  validateExpirationPasswordLink: function validateExpirationPasswordLink(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateExpirationPasswordLink').post(data);
  },


  /**
   * Validate password link.
   * @param  {Object} data
   */
  validatePasswordLink: function validatePasswordLink(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validatePasswordLink').post(data);
  },


  /**
   * Validate password link.
   * @param  {Object} data
   */
  validateUserInfo: function validateUserInfo(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateUserInfo').post(data);
  },


  /**
   * Active account.
   * @param  {Object} data
   */
  passwordAndSecurityQuestion: function passwordAndSecurityQuestion(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'passwordAndSecurityQuestion').post(data);
  },


  /**
   * Login.
   * @param  {Object} data
   */
  login: function login(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'login', {
      excludeAuthHeader: true
    }).post(data);
  },


  /**
   * Logout.
   */
  logout: function logout() {
    return (0, _Izenda2.default)(ROOT_URL + 'logout').post();
  },


  /**
   * Fetch security questions of user.
   * @param  {Object} data
   */
  securityQuestion: function securityQuestion(data) {
    var uri = 'securityQuestion/' + data.userName;
    if (data.tenantDisplayID) {
      uri += '/' + data.tenantDisplayID;
    }
    return (0, _Izenda2.default)(ROOT_URL + uri).get();
  },


  /**
   * Validate security questions of user.
   * @param  {Object} data
   */
  validateSecurityQuestion: function validateSecurityQuestion(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'validateSecurityQuestion').post(data);
  },


  /**
   * Update password info of user.
   * @param  {Object} data
   */
  password: function password(data) {
    return (0, _Izenda2.default)(ROOT_URL + 'password').post(data);
  },


  /**
   * Load information of current user.
   */
  loadCurrentUser: function loadCurrentUser() {
    return (0, _Izenda2.default)(ROOT_URL).get();
  },


  /**
   * Load all user sharing
   * @param  {object} requestData
   * @return {Promise}
   */
  loadAllowedSharingUsers: function loadAllowedSharingUsers(requestData) {
    return (0, _Izenda2.default)(ROOT_URL + 'allowedSharingUsers/').post(requestData);
  },


  /**
   * save user set up detail
   * @param  {object} data
   * @return {promise}
   */
  saveUserProfile: function saveUserProfile(data) {
    data = data || {};
    return (0, _Izenda2.default)(ROOT_URL + 'userProfile').post(data);
  },


  /**
   * Update new password
   * @param  {object} data
   * @return {promise}
   */
  updateNewPassword: function updateNewPassword(data) {
    data = data || {};
    return (0, _Izenda2.default)(ROOT_URL + 'passwordProfile').post(data);
  },


  /**
   * Validate User Role Association
   * @param  {object} data
   * @return {promise}
   */
  validateUserRoleAssociation: function validateUserRoleAssociation(data) {
    data = data || {};
    return (0, _Izenda2.default)(ROOT_URL + 'validateUserRoleAssociation').post(data);
  },


  /**
   * Update new password
   * @param  {object} data
   * @return {promise}
   */
  updateSecurityQuesitions: function updateSecurityQuesitions(data) {
    data = data || {};
    return (0, _Izenda2.default)(ROOT_URL + 'securityQuesitions').post(data);
  },


  /**
   * check this is the Last System Admin or not
   * @return {promise}
   */
  checkLastSystemAdmin: function checkLastSystemAdmin() {
    return (0, _Izenda2.default)(ROOT_URL + 'isLastSystemAdmin').get();
  }
};
module.exports = exports['default'];

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'databaseSetup/'; // ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseSetupDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  getSupportedDatabaseType: function getSupportedDatabaseType() {
    return (0, _Izenda2.default)(ROOT_URL + 'SupportedDatabaseType').get();
  },
  testConnection: function testConnection(serverType, connectionString) {
    return (0, _Izenda2.default)(ROOT_URL + 'TestConnection').post({ ServerTypeId: serverType, ConnectionString: connectionString });
  },
  setupDatabase: function setupDatabase(serverType, connectionString) {
    return (0, _Izenda2.default)(ROOT_URL + 'DatabaseInfo').post({ ServerTypeId: serverType, ConnectionString: connectionString });
  },
  getConnectionInfo: function getConnectionInfo() {
    return (0, _Izenda2.default)(ROOT_URL + 'DatabaseInfo').get();
  },
  provisionStaticData: function provisionStaticData() {
    return (0, _Izenda2.default)(ROOT_URL + 'provisionStaticData').post();
  },
  provisionStaticDataStatus: function provisionStaticDataStatus() {
    return (0, _Izenda2.default)(ROOT_URL + 'provisionStaticDataStatus').get();
  }
};
module.exports = exports['default'];

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Divider.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Divider component
 */
!function () {
  var React = __webpack_require__(0);
  var Draggable = __webpack_require__(359);
  var connect = __webpack_require__(2);
  var actions = __webpack_require__(1848);

  var Divider = React.createClass({
    displayName: 'Divider',

    render: function render() {
      var props = this.props;

      return React.createElement(
        Draggable,
        {
          axis: props.axis,
          defaultClassName: props.orientation,
          defaultClassNameDragging: '',
          defaultClassNameDragged: '',
          position: props.position,
          onStop: props.onStop,
          onDrag: props.onDrag
        },
        React.createElement(
          'div',
          { className: 'izenda-Divider', ref: props.setDomNode },
          React.createElement(
            'div',
            { className: 'izenda-Divider-dots' },
            React.createElement('span', { className: 'cirle-dot' }),
            React.createElement('span', { className: 'cirle-dot' }),
            React.createElement('span', { className: 'cirle-dot' })
          )
        )
      );
    }
  });

  module.exports = connect({ toClass: true }, actions)(Divider);
}();

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SizeSetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 *  Size Setting component
 */
!function () {
  var React = __webpack_require__(0);
  var m = __webpack_require__(10);
  var classnames = __webpack_require__(11);
  var NumericInput = __webpack_require__(109);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      cloneDeep = _require.cloneDeep,
      get = _require.get;

  var SizeSetting = React.createClass({
    displayName: 'SizeSetting',

    getInitialState: function getInitialState() {
      var originalValue = cloneDeep(this.props.value);
      return {
        value: this.props.value,
        originalValue: originalValue
      };
    },

    propTypes: {
      value: React.PropTypes.number,
      onChange: React.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
      return {
        value: 0
      };
    },

    onValueChange: function onValueChange(e) {
      var props = this.props;
      var value = e;
      this.setState({ value: value });
      props.onChange && props.onChange({ value: value });
    },

    /**
     * Handle on blur.
     */
    onBlur: function onBlur(e) {
      var currentValue = this.state.value;
      var originalValue = this.state.originalValue;
      if (currentValue < 0 || currentValue > Math.pow(2, 32)) {
        this.setState({ value: originalValue });
      }
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({ value: get(this.props.propertyKey, nextProps.loadValue) });
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.value !== nextState.value;
    },

    componentWillUpdate: function componentWillUpdate() {
      this.setState({ value: get(this.props.propertyKey, this.props.loadValue) });
    },

    render: function render() {
      var className = classnames('height-format input-group', this.props.className);
      return React.createElement(
        'div',
        { className: className },
        React.createElement(NumericInput, {
          value: get(this.props.propertyKey, this.props.loadValue),
          onChange: this.onValueChange,
          onBlur: this.onBlur
        }),
        React.createElement(
          'span',
          { className: 'height-unit input-group-addon' },
          localizer.getText('UI_CONSTANT_PIXEL')
        )
      );
    }
  });

  module.exports = m.observer(SizeSetting);
}();

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AlignmentSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * VerticalAlignmentSetting Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(84);

var _Izenda2 = __webpack_require__(12);

var _Izenda3 = _interopRequireDefault(_Izenda2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_VERTICAL_ALIGNMENT = _Izenda.DEFAULT_VALUE_PROPERTIES.VERTICAL_ALIGNMENT;

var VerticalAlignmentSetting = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(VerticalAlignmentSetting, _Component);

  function VerticalAlignmentSetting() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VerticalAlignmentSetting);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VerticalAlignmentSetting.__proto__ || (0, _getPrototypeOf2.default)(VerticalAlignmentSetting)).call.apply(_ref, [this].concat(args))), _this), _this.renderButton = function (btnName, className, title) {
      var props = _this.props;
      var onClick = function onClick() {
        props.onChange && props.onChange({ value: btnName });
      };

      return _react2.default.createElement('button', { key: btnName, type: 'button', className: className + ' btn-highlight', onClick: onClick, title: title });
    }, _this.renderButtons = function () {
      var verticalAlignmentStyle = _this.props.value;
      var btnConfig = [{
        btnName: 'top',
        className: 'icon-top-vertical-alignment',
        title: _Izenda3.default.getText('COMMON_LABEL_TOP')
      }, {
        btnName: 'middle',
        className: 'icon-middle-vertical-alignment',
        title: _Izenda3.default.getText('COMMON_LABEL_MIDDLE')
      }, {
        btnName: 'bottom',
        className: 'icon-bottom-vertical-alignment',
        title: _Izenda3.default.getText('COMMON_LABEL_BOTTOM')
      }];

      return (0, _fp.map)(function (value) {
        var classes = (0, _classnames2.default)(value.className, {
          active: value.btnName === verticalAlignmentStyle
        });

        return _this.renderButton(value.btnName, classes, value.title);
      }, btnConfig);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VerticalAlignmentSetting, [{
    key: 'render',
    value: function render() {
      var className = (0, _classnames2.default)('alignment-setting', this.props.className);
      return _react2.default.createElement(
        'div',
        { className: className },
        this.renderButtons()
      );
    }
  }]);
  return VerticalAlignmentSetting;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func
}, _class.defaultProps = {
  value: DEFAULT_VERTICAL_ALIGNMENT
}, _temp2);
exports.default = VerticalAlignmentSetting;
module.exports = exports['default'];

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.TreeSelectionField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * TreeSelectionField component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(172);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(68);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1872);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TreeSelectionField = (_dec = (0, _Izenda2.default)(_Izenda10.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TreeSelectionField, _Component);

  function TreeSelectionField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TreeSelectionField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TreeSelectionField.__proto__ || (0, _getPrototypeOf2.default)(TreeSelectionField)).call.apply(_ref, [this].concat(args))), _this), _this.renderNode = function (item, toggleIcon, toggle, isCollapsed, parent) {
      return _react2.default.createElement(
        'label',
        { className: 'overflow-text checkbox-inline' },
        _react2.default.createElement(_Izenda6.default, {
          type: 'checkbox',
          indeterminate: item.indeterminate,
          checked: item.checked,
          onChange: _this.props.onChange.bind(_this, item, parent)
        }),
        _react2.default.createElement(_Izenda8.default, { text: item.value, tooltip: item.value })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TreeSelectionField, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Izenda4.default, {
        nodes: this.props.treeData,
        renderNode: this.renderNode,
        getKey: (0, _fp.get)('key'),
        getChildNodes: (0, _fp.get)('nodes'),
        collapsed: false
      });
    }
  }]);
  return TreeSelectionField;
}(_react.Component), _class2.propTypes = {
  treeData: _react.PropTypes.array
}, _temp2)) || _class);
exports.default = TreeSelectionField;
module.exports = exports['default'];

/***/ }),
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartContainer = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(ChartContainer, _Component);

  function ChartContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ChartContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChartContainer.__proto__ || (0, _getPrototypeOf2.default)(ChartContainer)).call.apply(_ref, [this].concat(args))), _this), _this.setBackgroundColorImportant = function (dom) {
      if (!(0, _fp.isNil)(dom)) {
        var color = dom.style.backgroundColor;
        !(0, _fp.isEmpty)(color) && dom.style.setProperty('background-color', color, 'important');
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ChartContainer, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var printingMode = props.printingMode,
          style = props.style,
          className = props.className,
          children = props.children;

      var commonOptions = (0, _fp.getOr)({}, 'chartOptions.commonOptions', props);
      var containerStyle = {
        borderStyle: commonOptions['izEntire.borderStyle'] || 'solid',
        borderColor: commonOptions['izEntire.borderColor'],
        borderWidth: commonOptions['izEntire.borderWidth'] || 0,
        backgroundColor: commonOptions['izEntire.backgroundColor'] || _Izenda.backgroundColor,
        height: printingMode ? style.height : null
      };

      var classes = (0, _classnames2.default)('izenda-ChartContainer izenda-Wrapper', className);

      return _react2.default.createElement(
        'section',
        { ref: this.setBackgroundColorImportant, className: classes, style: containerStyle },
        children
      );
    }

    /**
     * Set important inline style for background setting
     * Avoid override by bootstrap CSS
     */

  }]);
  return ChartContainer;
}(_react.Component)) || _class;

exports.default = ChartContainer;
module.exports = exports['default'];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(80);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(35);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartPointAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _mobxReact.observer)(function ChartPointAction(props) {
  var getLabel = function getLabel(value) {
    return (0, _fp.isUndefined)(value) ? { fomattedValue: '' } : _Izenda2.default.getValueStyle(value, configField, props.fieldSource) || {};
  };

  var pointAction = function pointAction(formattedValue) {
    var pointAction = props.pointAction,
        linkTo = props.linkTo,
        fieldName = props.fieldName;

    var separator = linkTo ? {
      separatorColumnName: (0, _fp.get)('groupField.columnName', linkTo),
      separatorValue: (0, _fp.get)('groupName', linkTo)
    } : null;

    pointAction && pointAction(configField, [{
      key: fieldName,
      value: formattedValue
    }], separator);
  };

  var _props$configField = props.configField,
      configField = _props$configField === undefined ? {} : _props$configField,
      value = props.value,
      fieldSource = props.fieldSource;
  var numberOfPointActions = configField.numberOfPointActions;

  var record = (0, _fp.get)('record', fieldSource);
  var fieldElement = (0, _fp.get)('element', fieldSource);
  var originalValue = void 0;
  if (!(0, _fp.isNil)(record)) {
    originalValue = _Izenda6.default.getOriginalValue(fieldElement, record);
  }

  var valueFormatedByFormatString = _Izenda4.default.getFormatedValueByStringFormat(configField.fieldElement, value);

  var formattedName = getLabel({
    value: !(0, _fp.isNil)(valueFormatedByFormatString) ? valueFormatedByFormatString : value,
    originalValue: originalValue
  });

  return numberOfPointActions > 0 ? _react2.default.createElement(
    'a',
    {
      className: 'overflow-text u_textLink',
      style: formattedName.style,
      onClick: pointAction.bind(this, formattedName.valueWithoutAltText)
    },
    formattedName.fomattedValue
  ) : _react2.default.createElement(
    'span',
    { className: 'overflow-text', style: formattedName.style },
    formattedName.fomattedValue
  );
});
module.exports = exports['default'];

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.MapStaticContentStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Other Settings Store
 */
!function () {
  var MAX_CACHE_BACKGROUND_ITEMS = 3;
  var ReportPartMapConstants = __webpack_require__(105);
  var MappingKey = ReportPartMapConstants.MappingKey;
  var fetcher = __webpack_require__(1893);

  var _require = __webpack_require__(1),
      find = _require.find,
      get = _require.get,
      invoke = _require.invoke,
      compact = _require.compact,
      groupBy = _require.groupBy,
      deburr = _require.deburr,
      memoize = _require.memoize;

  function createMappingData(values, mappingValues, mappingKeys) {
    var groupName;

    var matchedPoints = groupBy(function (mapVal) {
      groupName = find(function (val) {
        return isMatchedPoint(val, mapVal, mappingKeys);
      }, values);

      return groupName;
    }, mappingValues);

    return matchedPoints;

    function isMatchedPoint(pointVal, source, mappingKeys) {
      return !!find(function (mappingField) {
        return String.compareString(deburr(source[mappingField]), deburr(pointVal));
      }, mappingKeys);
    }
  }

  module.exports = {
    /**
     * Get GEO file based on map name, map name is defined in MapCollectionConstants
     * @param  {string} mapName
     * @return {json}
     */
    getGEOJson: memoize(function (mapName) {
      // check - clear cache if more than 3 items are cached
      var cache = get('cache', this.getGEOJson);
      cache.size > MAX_CACHE_BACKGROUND_ITEMS && invoke('clear', cache);

      return fetcher.getGEOJson(mapName);
    }),

    /**
     * Get details of cities by state
     * @param  {array} values
     * @param  {array} mappingValues
     * @return {any} the point to draw on the map
     */
    getCitiesByState: function getCitiesByState(values, mappingValues) {
      var mappingData = createMappingData(compact(values), mappingValues, MappingKey.state);
      return (0, _bluebird.resolve)(mappingData);
    },

    /**
     * Get details of cities
     * @param  {array} criterias
     * @param  {array} values
     * @return {array}
     */
    getCities: function getCities(values, mappingValues) {
      var mappingData = createMappingData(compact(values), mappingValues, MappingKey.city);
      return (0, _bluebird.resolve)(mappingData);
    },

    /**
     * Get details of postal code
     * @param  {array} criterias
     * @param  {array} values
     * @return {array}
     */
    getPostalCode: function getPostalCode(values, mappingValues) {
      var mappingData = createMappingData(compact(values), mappingValues, MappingKey.postalCode);
      return (0, _bluebird.resolve)(mappingData);
    },

    /**
     * Get list of country codes
     * @return {array}
     */
    getCountryCode: function getCountryCode() {
      return fetcher.getCountryCode();
    }
  };
}();

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(572);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(955);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(956);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

var _Izenda9 = __webpack_require__(1896);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _Izenda8.default)(_Izenda10.default)(function ChartToolbar(props) {
  var isShowMetric = (0, _fp.getOr)(true, 'isShowMetric', props);
  var isShowBreadcrumb = (0, _fp.getOr)(true, 'isShowBreadcrumb', props);
  var localization = props.localization,
      hideGridPopup = props.hideGridPopup,
      showGridPreviewPopup = props.showGridPreviewPopup;

  var showToolbar = isShowMetric || !hideGridPopup;
  var breadCrumbProps = (0, _fp.pick)(['reportPart', 'reportPartContent', 'onDrillDown', 'points', 'getPoints', 'className', 'hideAllLevel'], props);
  var chartMetricProps = (0, _fp.pick)(['reportPart', 'className'], props);

  return _react2.default.createElement(
    _Izenda2.default,
    null,
    isShowBreadcrumb && _react2.default.createElement(_Izenda6.default, (0, _extends3.default)({}, breadCrumbProps, { className: 'izenda-ReportPartChartToolbar_leftSide' })),
    showToolbar && _react2.default.createElement(
      'div',
      { className: 'izenda-ReportPartToolbar_rightSide u-posTopRight u-posAbsolute u_textRight' },
      !hideGridPopup && _react2.default.createElement(
        'a',
        { className: 'izenda-GridPopupIcon', title: localization.getText('GRID_POPUP_TOOLTIP') },
        _react2.default.createElement('span', { className: 'icon-grid', onClick: showGridPreviewPopup })
      ),
      isShowMetric && _react2.default.createElement(_Izenda4.default, chartMetricProps)
    )
  );
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.CharToolbar.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * CharToolbar component
 */

module.exports = exports['default'];

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(29);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(1895);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartMetrics = function ChartMetrics(_ref) {
  var reportPart = _ref.reportPart,
      className = _ref.className,
      localization = _ref.localization,
      onChange = _ref.onChange;

  var reportPartContent = reportPart.reportPartContent || {};
  var options = reportPartContent.serieChartList;
  var classes = (0, _classnames2.default)(className);

  return options.length && _react2.default.createElement(
    'span',
    { className: classes },
    _react2.default.createElement(
      'span',
      { className: 'u_paddingLeftRight izenda-ChartMetrics-text' },
      localization.getText('REPORTDESIGNER_LABEL_METRICS')
    ),
    _react2.default.createElement(_Izenda2.default, {
      options: options,
      onChange: onChange,
      value: (0, _fp.get)('fieldName', reportPartContent.activeSerie),
      blankOption: true,
      blankOptionText: localization.getText('COMMON_LABEL_ALL'),
      valueField: 'fieldName',
      labelField: 'fieldName',
      renderInContainer: false
    })
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartMetrics.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ChartMetrics component
 */


ChartMetrics.propTypes = {
  reportPart: _propTypes2.default.object,
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

exports.default = (0, _Izenda4.default)(_Izenda6.default)(ChartMetrics);
module.exports = exports['default'];

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(957);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartDrilldownBreadcrumb = (0, _recompose.withProps)(function (props) {
  return {
    getPoints: function getPoints() {
      return (0, _fp.getOr)([], 'reportPart.reportPartContent.drilldownInfo.filters', props);
    }
  };
})(_Izenda2.default); // ----------------------------------------------------------------------
// <copyright file="Izenda.ChartDrilldownBreadcrumb.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Chart Drilldown Breadcrumb Component
 */

exports.default = ChartDrilldownBreadcrumb;
module.exports = exports['default'];

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(35);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(80);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(34);

var _Izenda8 = __webpack_require__(2);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DrilldownBreadcrumb.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var SEPARATOR_SIGN = '|';

exports.default = (0, _Izenda9.default)()(function DrilldownBreadcrumb(props) {
  var _this = this;

  var reportPartContent = props.reportPartContent || (0, _fp.get)('reportPart.reportPartContent', props);
  // do not show drill down
  if (!reportPartContent || !reportPartContent.hasDrillDown) {
    return null;
  }

  var onClickBreadcrumb = function onClickBreadcrumb(point) {
    (0, _fp.isFunction)(props.onDrillDown) && props.onDrillDown(point, null);
  };

  var getValue = function getValue(point) {

    var columnName = (0, _fp.get)('field.columnName', point);
    var record = (0, _fp.get)('record', point);
    var fieldValues = _Izenda2.default.getFieldValue(columnName, record);
    var reportPartElm = (0, _fp.get)('field.reportPartElm', point);
    var fieldDataType = (0, _fp.get)('field.reportPartElm.fieldDataType', point);

    var stringFormatValue = _Izenda4.default.getFormatedValueByStringFormat(reportPartElm, fieldValues.value, fieldDataType);
    if (!(0, _fp.isNil)(stringFormatValue)) {
      fieldValues.value = stringFormatValue;
    }

    return _Izenda2.default.getDataFormat(fieldValues, _Izenda6.default.getSerieProppertiesByField((0, _fp.get)('field.reportPartElm', point)), {
      record: point.record,
      element: point.field
    });
  };

  var getPointValue = function getPointValue(point) {
    var value = getValue(point);
    switch (value) {
      case null:
        return _Izenda7.NULL_VALUE;
      case '':
        return _Izenda7.BLANK_VALUE;
      default:
        return value;
    }
  };

  var localization = props.localization;

  var renderTopLevel = function renderTopLevel(levelSize) {
    var TOP_LEVEL = localization.getText('COMMON_LABEL_ALL');
    if (levelSize === 0) {
      return _react2.default.createElement(
        'span',
        { title: TOP_LEVEL },
        TOP_LEVEL
      );
    }
    return _react2.default.createElement(
      'a',
      { title: TOP_LEVEL, onClick: onClickBreadcrumb.bind(_this, null) },
      TOP_LEVEL
    );
  };

  var points = props.points || props.getPoints && props.getPoints();
  var classes = (0, _classnames2.default)('izenda-ReportPartChart-Breadcrumb overflow-text', props.className);
  return _react2.default.createElement(
    'div',
    { className: classes },
    !props.hideAllLevel && renderTopLevel((0, _fp.size)(points)),
    points.map(function (point, index) {
      var pointValue = getPointValue(point);
      var itemKey = index + pointValue;
      var showSeparator = !(props.hideAllLevel && index === 0);

      if (index === points.length - 1) {
        return _react2.default.createElement(
          'span',
          { key: itemKey, title: pointValue },
          showSeparator && SEPARATOR_SIGN,
          ' ',
          pointValue
        );
      }
      return _react2.default.createElement(
        'a',
        { key: itemKey, title: pointValue, onClick: onClickBreadcrumb.bind(_this, point) },
        showSeparator && SEPARATOR_SIGN,
        ' ',
        pointValue
      );
    })
  );
});
module.exports = exports['default'];

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.GridPreviewPopup.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GridPreviewPopup component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1897);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(27);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1898);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(35);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(571);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(959);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(963);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(50);

var _Izenda20 = __webpack_require__(1905);

var _Izenda21 = _interopRequireDefault(_Izenda20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingComponent = function LoadingComponent() {
  return _react2.default.createElement(
    'div',
    { style: _Izenda19.GRID_PREVIEW_POPUP_SIZE },
    _react2.default.createElement(
      _Izenda8.default,
      null,
      _Izenda12.default.renderLazyLoadingBar()
    )
  );
};

var DeferredReportPartGridVerticalHorizontal = (0, _Izenda21.default)(_Izenda16.default, LoadingComponent);

var GridPreviewPopup = (_dec = (0, _Izenda2.default)(_Izenda6.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(GridPreviewPopup, _Component);

  function GridPreviewPopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GridPreviewPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GridPreviewPopup.__proto__ || (0, _getPrototypeOf2.default)(GridPreviewPopup)).call.apply(_ref, [this].concat(args))), _this), _this.renderHeader = (0, _fp.curry)(function (props, container, fieldElement, title, callBack) {
      return title;
    }), _this.renderMainComponent = function () {
      var _this2 = _this,
          props = _this2.props,
          _this2$props = _this2.props,
          gridPreviewStore = _this2$props.gridPreviewStore,
          gridReportParts = _this2$props.gridPreviewStore.gridReportParts;
      var _gridReportParts$grid = gridReportParts[gridPreviewStore.showingPartIndex],
          partDefinition = _gridReportParts$grid.partDefinition,
          previewDataRecords = _gridReportParts$grid.partDefinition.previewDataRecords;


      if (!(0, _fp.isEmpty)(previewDataRecords)) {
        var restProps = (0, _fp.omit)(['reportPart'], props);
        if (partDefinition.reportPartContent.useSeparator) {
          return _react2.default.createElement(_Izenda18.default, (0, _extends3.default)({
            records: previewDataRecords,
            mainComponent: DeferredReportPartGridVerticalHorizontal,
            reportPart: partDefinition
          }, restProps, {
            staticRender: false,
            viewMode: true,
            renderHeader: _this.renderHeader(props)
          }));
        }
        return _react2.default.createElement(DeferredReportPartGridVerticalHorizontal, (0, _extends3.default)({
          records: previewDataRecords,
          reportPart: partDefinition
        }, restProps, {
          staticRender: false,
          viewMode: true,
          renderHeader: _this.renderHeader(props)
        }));
      }

      return props.reportPart.isLoadingData ? _Izenda12.default.renderLazyLoadingBar() : _react2.default.createElement(_Izenda14.default, null);
    }, _this.renderWithMetric = function () {
      var _this$props = _this.props,
          gridPreviewStore = _this$props.gridPreviewStore,
          gridReportParts = _this$props.gridPreviewStore.gridReportParts;


      return _react2.default.createElement(
        'div',
        { style: _Izenda19.GRID_PREVIEW_POPUP_SIZE, className: 'izenda-GridPreviewPopup izenda-Wrapper' },
        _react2.default.createElement(_Izenda10.default, {
          onChange: _this.props.onChangeGridPreviewPopupMetric,
          selectedPart: gridReportParts[gridPreviewStore.showingPartIndex],
          gridReportParts: gridReportParts
        }),
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          _react2.default.createElement(
            _Izenda8.default,
            null,
            _this.renderMainComponent()
          )
        )
      );
    }, _this.renderWithoutMetric = function () {
      return _react2.default.createElement(
        'div',
        { className: 'izenda-GridPreviewPopup', style: _Izenda19.GRID_PREVIEW_POPUP_SIZE },
        _react2.default.createElement(
          _Izenda8.default,
          null,
          _this.renderMainComponent()
        )
      );
    }, _this.renderLoadingBar = function () {
      return _react2.default.createElement(LoadingComponent, null);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GridPreviewPopup, [{
    key: 'componentDidMount',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _props, reportPart, gridPreviewStore, buildGridData, selectedMetricIndex;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, reportPart = _props.reportPart, gridPreviewStore = _props.gridPreviewStore, buildGridData = _props.buildGridData;

                this.refreshDataObserver = (0, _mobx.observe)(reportPart, 'queryData', buildGridData.bind(this));
                _context.next = 4;
                return buildGridData.apply(this);

              case 4:
                selectedMetricIndex = gridPreviewStore.selectedMetricIndex;

                gridPreviewStore.updateShowingPartIndex(Math.max(0, selectedMetricIndex));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref2.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.refreshDataObserver();
    }

    /**
     * Render content with metric
     * @param {Object} containerStyle
     */


    /**
     * Render content without metric
     */


    /**
     * Render loading bar
     */

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          gridPreviewStore = _props2.gridPreviewStore,
          _props2$gridPreviewSt = _props2.gridPreviewStore,
          gridReportParts = _props2$gridPreviewSt.gridReportParts,
          selectedMetricIndex = _props2$gridPreviewSt.selectedMetricIndex;

      var showMetric = gridReportParts.length > 1 && selectedMetricIndex < 0;
      var renderContentFn = this.renderLoadingBar;
      if (!gridPreviewStore.isProcessingData) {
        renderContentFn = showMetric ? this.renderWithMetric : this.renderWithoutMetric;
      }

      return _react2.default.createElement(
        _Izenda4.default,
        { sizeClass: 'modal-lg', visible: true, autoClose: false, onClosing: this.props.onClosing, type: 'none' },
        _react2.default.createElement(_Izenda4.default.Header, null),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          renderContentFn()
        )
      );
    }
  }]);
  return GridPreviewPopup;
}(_react.Component), _class2.propTypes = {
  reportPart: _mobxReact.propTypes.observableObject.isRequired
}, _temp2)) || _class);
exports.default = GridPreviewPopup;
module.exports = exports['default'];

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridHorizontal.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridVerticalHorizontal component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(44);

var _Izenda4 = __webpack_require__(35);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda6 = __webpack_require__(84);

var _Izenda7 = __webpack_require__(39);

var _Izenda8 = __webpack_require__(573);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(76);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(1901);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(316);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(41);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _fp = __webpack_require__(1);

var _Izenda18 = __webpack_require__(171);

var _Izenda19 = _interopRequireDefault(_Izenda18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNDEFINED_VALUES = ['null', ''];

var ReportPartGridVerticalHorizontal = (_dec = (0, _Izenda2.default)(_Izenda13.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartGridVerticalHorizontal, _Component);

  function ReportPartGridVerticalHorizontal() {
    (0, _classCallCheck3.default)(this, ReportPartGridVerticalHorizontal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartGridVerticalHorizontal.__proto__ || (0, _getPrototypeOf2.default)(ReportPartGridVerticalHorizontal)).call(this));

    _this.renderTable = function (page, index) {
      var props = _this.props;
      var staticRender = props.staticRender,
          afterRenderCallBack = props.afterRenderCallBack,
          reportPart = props.reportPart,
          getStickyValue = props.getStickyValue;
      var headers = page.headers,
          rowSpan = page.rowSpan;

      var gridStyle = reportPart.reportPartContent.gridStyle;
      var properties = reportPart.getReportPartProperties();

      var className = (0, _classnames2.default)('report-part-grid-preview', { hide: (0, _fp.isNil)(headers) }, { 'vertical-grid': gridStyle === _Izenda6.GRID_STYLES.VERTICAL.value }, { 'horizontal-grid': gridStyle === _Izenda6.GRID_STYLES.HORIZONTAL.value });

      if (rowSpan) {
        rowSpan.cell = (0, _fp.get)('title');
        rowSpan.fnGetCellStyle = props.getColumnGroupCellStyle(rowSpan.data.length);
        rowSpan.fnGetCellContentStyle = props.getColumnGroupCellContentStyle;
      }

      return _react2.default.createElement(
        'section',
        { key: index, className: className },
        index > 0 && _react2.default.createElement('div', { className: 'u_alwaysBreakAfter' }),
        _react2.default.createElement(
          _Izenda3.Table,
          {
            showScroll: false,
            dataSource: page.records,
            className: 'custom-table',
            autoResize: false,
            afterRenderCallBack: afterRenderCallBack,
            rowSpan: rowSpan,
            staticRender: staticRender,
            onResizeStopCallback: _this.onResizeStopCallback,
            stickVertical: getStickyValue(properties.isHeaderStickVertical),
            stickHorizontal: getStickyValue(properties.isHeaderStickHorizontal)
          },
          _this.renderColumns(page.headers, index, page.records.length)
        )
      );
    };

    _this.onResizeStopCallback = function (resizeInfo) {
      var index = resizeInfo.index,
          columnWidth = resizeInfo.columnWidth;

      var columnCollection = (0, _fp.get)('reportPart.reportPartContent.columns.elements', _this.props);

      if (!(0, _fp.isEmpty)(columnCollection)) {
        var field = (0, _fp.find)({ position: index + 1 }, columnCollection);
        field && field.updateColumnWidth(columnWidth);
      }
    };

    _this.renderColumnContent = function (header, pageIndex, dataRow, columnKey, rowIndex, column, columnIndex, afterRenderCallBack) {
      // get cell data from vertical/horizontal table
      var props = _this.props;
      var printingMode = props.printingMode,
          reportPart = props.reportPart;

      var properties = reportPart.getReportPartProperties();
      var rawRecords = props.records.slice();
      var isHorizontal = properties.generalInfo.gridStyle === _Izenda6.GRID_STYLES.HORIZONTAL.value ? 1 : 0;
      if (isHorizontal && !dataRow[columnIndex]) {
        return null;
      }
      var pivotColumnsPerExportedPage = properties.view.pivotColumnsPerExportedPage || 0;
      var columnHeader = isHorizontal ? dataRow : header;
      var fieldElement = (0, _fp.get)('element', columnHeader);
      var cell = void 0,
          originalCell = void 0;
      var isSubTotal = isHorizontal ? dataRow[columnIndex].className === 'sub-total' : (0, _fp.get)('isSubTotal', dataRow);
      var originalColumnKey = !(0, _fp.isNil)(header.columnKey) ? _Izenda7.CUSTOM_FORMAT_PREFIX + header.columnKey : null;

      if (isSubTotal) {
        cell = isHorizontal ? dataRow[columnIndex] : dataRow[fieldElement.fieldNameAlias];
      } else {
        cell = !(0, _fp.isNil)(dataRow[header.columnKey]) ? dataRow[header.columnKey] : dataRow[columnIndex];
        originalCell = !(0, _fp.isNil)(originalColumnKey) ? dataRow[originalColumnKey] : dataRow[columnIndex];
      }

      var basedData = isHorizontal || (0, _fp.isObject)(cell) ? cell && cell.data : cell;
      var originalData = isHorizontal || (0, _fp.isObject)(originalCell) ? originalCell && originalCell.originalData : originalCell;
      var convertNullToEmpty = _Izenda17.default.advancedSettings.other.convertNullToEmptyStringValue;
      var cellData = String.commonStringValue(basedData, convertNullToEmpty);
      var fieldElementProperties = (0, _fp.get)('properties', fieldElement);
      var cellFormat = isSubTotal ? (0, _fp.get)('subTotalFormat.format', cell) : (0, _fp.get)('dataFormattings.format.format', fieldElementProperties);
      var subTotalDataType = (0, _fp.get)('subTotalDataType', cell);

      if (!isHorizontal || columnIndex > 0) {
        // get correct data row index in real data source. if horizontal it is column index + pagesize number
        var dataRowIndex = !isHorizontal ? rowIndex : pageIndex * pivotColumnsPerExportedPage + columnIndex - 1;
        // use this data row for filter in sub report/ custom URL
        var rawRecord = rawRecords[dataRowIndex];

        cellData = _Izenda5.default.getDataFormat({
          originalValue: originalData,
          value: cellData
        }, {
          alternativeText: (0, _fp.get)('dataFormattings.alternativeText', fieldElementProperties),
          fieldFormatData: cellFormat,
          fieldDataType: isSubTotal ? subTotalDataType : (0, _fp.get)('previewDataType', fieldElement)
        }, {
          element: _Izenda5.default.buildDataSourceElement(reportPart, fieldElement),
          record: rawRecord
        });

        var numberOfPointActions = (0, _fp.get)('numberOfPointActions', fieldElement);
        var label = (0, _fp.getOr)(cellData, 'title', cell);

        if (rawRecord && numberOfPointActions > 0) {
          var id = [pageIndex, columnIndex, rowIndex].join('.');
          _Izenda11.default.pushRenderListener(_this.renderListeners, id);
          return _react2.default.createElement(
            _Izenda9.default,
            {
              reportPart: reportPart,
              fieldElement: fieldElement,
              afterRenderCallBack: afterRenderCallBack,
              printingMode: printingMode,
              finishedRender: _Izenda11.default.getFinishedRenderPromiseById(_this.renderListeners, id),
              getFilterInfoForSubReport: props.getFilterInfoForSubReport,
              rawRecord: [rawRecord]
            },
            cellData
          );
        }
      }
      if (isHorizontal && columnIndex === 0) {
        return props.renderHeader(reportPart.reportPartContent.rows, fieldElement, cellData, afterRenderCallBack);
      }

      return _Izenda15.default.isImage(columnHeader.element.field.dataFieldType) && (!isHorizontal || isHorizontal && columnIndex > 0) && !(0, _fp.any)(function (value) {
        return cellData === value;
      }, UNDEFINED_VALUES) ? _react2.default.createElement('img', { src: cellData }) : _react2.default.createElement(
        'span',
        { key: cellData, title: label, className: cell && cell.className || dataRow.className },
        cellData
      );
    };

    _this.renderColumn = function (totalColumns, numberOfRecord, pageIndex, header, index) {
      var props = _this.props;
      var properties = props.reportPart.getReportPartProperties();
      var isHeaderStickHorizontal = properties.isHeaderStickHorizontal,
          gridStyle = properties.generalInfo.gridStyle;

      var isHorizontal = gridStyle === _Izenda6.GRID_STYLES.HORIZONTAL.value;
      var isStickyLeft = props.getStickyValue(index === 0 && isHorizontal && isHeaderStickHorizontal);

      return _react2.default.createElement(_Izenda3.Column, (0, _extends3.default)({
        className: isStickyLeft ? 'u-stickLeft' : '',
        key: header.columnKey
      }, header, {
        cell: _this.renderColumnContent.bind(_this, header, pageIndex),
        fnGetCellContentStyle: props.fnGetCellContentStyle(header),
        fnGetHeaderCellStyle: props.getCellStyle(header, numberOfRecord, totalColumns),
        fnGetHeaderCellContentStyle: props.getHeaderCellStyle(header),
        fnGetCellStyle: props.getCellStyle(header, numberOfRecord, totalColumns)
      }));
    };

    _this.renderColumns = function (headers, pageIndex, numberOfRecord) {
      var props = _this.props;
      var totalColumns = (0, _fp.reduce)(function (acc, header) {
        if (header.isColumnGroup) {
          return acc + header.child.length;
        }
        return acc + 1;
      }, 0, headers);

      return headers.map(function (header, index) {
        if (!header.isColumnGroup) {
          return _this.renderColumn(totalColumns, numberOfRecord, pageIndex, header, index);
        }
        return _react2.default.createElement(
          _Izenda3.ColumnGroup,
          {
            key: index,
            title: header.title,
            fnGetCellStyle: props.getColumnGroupCellStyle(headers.length, header, index),
            fnGetCellContentStyle: props.getColumnGroupCellContentStyle(header)
          },
          (0, _fp.map)(function (headerItem) {
            return _this.renderColumn(totalColumns, numberOfRecord, pageIndex, headerItem, index);
          }, header.child)
        );
      });
    };

    _this.renderListeners = []; // for cells
    return _this;
  }

  (0, _createClass3.default)(ReportPartGridVerticalHorizontal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      props.printingMode && _Izenda11.default.publishFinishedRender(this.renderListeners, function () {
        props.finishedRender && props.finishedRender();
      });
    }

    /**
     * render table
     */

  }, {
    key: 'render',
    value: function render() {
      var result = this.props.generateHeaderData(this.props);
      return _react2.default.createElement(
        'section',
        null,
        result.map(this.renderTable)
      );
    }

    /**
     * render table
     */


    /**
     * on resize Stop Callback
     * @param  {[type]} resizeInfo
     */


    /**
     * render cell content base on value and style
     * @method renderColumnContent
     * @param  {[type]}            dataRow        [record for this dataRow]
     * @return {React.element}                    [cell content]
     */


    /**
     * Render column
     */


    /**
     * Render columns
     */

  }]);
  return ReportPartGridVerticalHorizontal;
}(_react.Component), _class2.propTypes = {
  reportPart: _propTypes2.default.object.isRequired,
  records: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired
}, _temp)) || _class);
exports.default = ReportPartGridVerticalHorizontal;
module.exports = exports['default'];

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartElementProperties.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartElementProperties model
 */
!function () {
  var m = __webpack_require__(5);
  var setValue = __webpack_require__(223);
  var trackable = __webpack_require__(46);
  var customURLConstants = __webpack_require__(82).CUSTOM_URL;
  var propertiesBuilderConstants = __webpack_require__(82);
  var reportDesingerConstants = __webpack_require__(16);
  var Uiconstants = __webpack_require__(34);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      some = _require.some,
      isNil = _require.isNil,
      get = _require.get,
      getOr = _require.getOr,
      cloneDeep = _require.cloneDeep,
      trim = _require.trim,
      replace = _require.replace,
      merge = _require.merge,
      set = _require.set,
      assignIn = _require.assignIn;

  function ReportPartElementProperties(defaultSort) {
    var props = {
      fieldItemVisible: true,
      dataFormattings: {
        function: '',
        functionInfo: {
          dataType: null,
          expression: null,
          expressionSyntax: null,
          extendedProperties: {},
          id: '',
          isOperator: null,
          name: null,
          syntax: null,
          userDefined: false
        },
        format: {},
        font: {
          family: Uiconstants.fontFamily.roboto,
          size: Uiconstants.defaultFontSize,
          bold: false,
          italic: false,
          underline: false,
          color: '',
          backgroundColor: ''
        },
        width: {
          value: Uiconstants.SIZE.WIDTH.VALUE
        },
        alignment: null,
        verticalAlignment: null,
        wordWrap: null,
        sort: defaultSort,
        color: {
          textColor: {
            rangePercent: null,
            rangeValue: null,
            value: null
          },
          cellColor: {
            rangePercent: null,
            rangeValue: null,
            value: null
          }
        },
        alternativeText: {
          rangePercent: null,
          rangeValue: null,
          value: null
        },
        customURL: {
          url: '',
          option: customURLConstants.DEFAULT_VALUE
        },
        embeddedJavascript: {
          script: ''
        },
        subTotal: {
          label: '',
          function: '',
          expression: '',
          dataType: '',
          format: {},
          previewResult: '',
          levels: []
        },
        grandTotal: {
          label: '',
          function: '',
          expression: '',
          dataType: '',
          format: {},
          previewResult: ''
        }
      },
      headerFormating: {
        font: {
          family: null,
          size: null,
          bold: null,
          italic: null,
          underline: null,
          color: null,
          backgroundColor: null
        },
        alignment: null,
        verticalAlignment: null,
        wordWrap: null,
        columnGroup: ''
      },
      drillDown: {
        subReport: {
          selectedReport: null,
          style: null,
          reportPartUsed: null,
          reportFilter: true,
          mappingFields: [],
          selectedIconValue: {
            icon: null,
            value: null
          },
          viewSettingByLink: null
        }
      },
      otherProps: {},
      subReport: function subReport() {
        return this.drillDown.subReport;
      },
      customURL: function customURL() {
        return this.dataFormattings.customURL;
      },
      embeddedJavascript: function embeddedJavascript() {
        return this.dataFormattings.embeddedJavascript;
      },
      hasRangePercent: function hasRangePercent() {
        var _dataFormattings$colo = this.dataFormattings.color,
            textColor = _dataFormattings$colo.textColor,
            cellColor = _dataFormattings$colo.cellColor;

        return !(isEmpty(textColor.rangePercent) && isEmpty(cellColor.rangePercent));
      }
    };

    m.extendObservable(trackable(this), props);

    this.dataFormattings.functionInfo.formatDataType = null;

    this.cleanDirty();
  }

  /**
   * Return value of model based on its key
   * @param  {string} key
   * @return {}
   */
  ReportPartElementProperties.prototype.getValueByKey = function (key) {
    return this[key] || this.getDataValueByKey(key) || this.getHeaderValueByKey(key) || this.getDrilldownValueByKey(key) || this.getOtherProps(key);
  };

  /**
   * Return value of data formattings based on its key
   * @param  {string} key
   * @return {}
   */
  ReportPartElementProperties.prototype.getDataValueByKey = function (key) {
    return cloneDeep(m.toJS(this.dataFormattings[key]));
  };

  /**
   * Return value of header formattings based on its key
   * @param  {string} key
   * @return {}
   */
  ReportPartElementProperties.prototype.getHeaderValueByKey = function (key) {
    return this.headerFormating[key];
  };

  /**
   * Return value of drill down config based on its key
   * @param  {string} key
   * @return {}
   */
  ReportPartElementProperties.prototype.getDrilldownValueByKey = function (key) {
    return this.drillDown[key];
  };

  /**
   * Update value of data formating
   * @param  {object} newVal
   * @return {null}
   */
  ReportPartElementProperties.prototype.setDataFormattings = m.action(function (newVal) {
    newVal = newVal || {};

    var dataFormattings = this.dataFormattings;
    var font = newVal.font || {};
    var width = newVal.width || {};
    var grandTotal = newVal.grandTotal || {};
    var subTotal = newVal.subTotal || {};

    newVal.functionInfo && this.setFunctionInfo(newVal.functionInfo);
    setValue(dataFormattings, 'function', newVal.function);
    setValue(dataFormattings, 'format', newVal.format);
    setValue(dataFormattings.font, 'family', font.family);
    setValue(dataFormattings.font, 'size', font.size);
    setValue(dataFormattings.font, 'bold', font.bold);
    setValue(dataFormattings.font, 'italic', font.italic);
    setValue(dataFormattings.font, 'underline', font.underline);
    setValue(dataFormattings.width, 'value', width.value);
    setValue(dataFormattings, 'alignment', newVal.alignment);
    setValue(dataFormattings, 'verticalAlignment', newVal.verticalAlignment);
    setValue(dataFormattings, 'wordWrap', newVal.wordWrap);
    setValue(dataFormattings.customURL, 'url', newVal.customURL && newVal.customURL.url);
    setValue(dataFormattings.customURL, 'option', newVal.customURL && newVal.customURL.option);
    setValue(dataFormattings.customURL, 'viewSettingByLink', newVal.customURL && newVal.customURL.viewSettingByLink);
    setValue(dataFormattings.customURL, 'selectedIconValue', newVal.customURL && newVal.customURL.selectedIconValue);

    setValue(dataFormattings.embeddedJavascript, 'script', newVal.embeddedJavascript && newVal.embeddedJavascript.script);
    setValue(dataFormattings.embeddedJavascript, 'viewSettingByLink', newVal.embeddedJavascript && newVal.embeddedJavascript.viewSettingByLink);
    setValue(dataFormattings.embeddedJavascript, 'selectedIconValue', newVal.embeddedJavascript && newVal.embeddedJavascript.selectedIconValue);

    this.updateGrandTotalData(grandTotal);
    this.updateSubTotalData(subTotal);
    this.updateSetingByRange(dataFormattings.alternativeText, newVal.alternativeText);
    this.updateSetingByRange(dataFormattings.color.cellColor, get('color.cellColor', newVal));
    this.updateSetingByRange(dataFormattings.color.textColor, get('color.textColor', newVal));
    this.setSortValue(newVal.sort);

    dataFormattings.format = dataFormattings.format || {};
    dataFormattings.format.createNewHiddenPercenOfGroupField = this.needPercentageData();

    this.markDirty();
  });

  ReportPartElementProperties.prototype.setSortValue = m.action(function (newValue) {
    var dataFormattings = this.dataFormattings;

    setValue(dataFormattings, 'sort', newValue);
  });

  /**
   * Update setting by range
   */
  ReportPartElementProperties.prototype.updateSetingByRange = m.action(function (target, source) {
    source && m.extendObservable(target, source);
  });

  /**
   * Update setting by range
   */
  ReportPartElementProperties.prototype.needPercentageData = m.action(function () {
    var dataFormattings = this.dataFormattings || {};

    var alternativeText = dataFormattings.alternativeText;
    var cellColor = get('color.cellColor', dataFormattings);
    var textColor = get('color.textColor', dataFormattings);

    return hasPercentConfig(alternativeText) || hasPercentConfig(cellColor) || hasPercentConfig(textColor);

    function hasPercentConfig(config) {
      if (!isNil(get('rangePercent', config))) {
        return true;
      }

      return some(function (item) {
        return !isNil(item) && !isNil(item.rangePercent);
      }, config);
    }
  });

  /**
   * Update value of header formating
   * @param  {object} newVal
   * @return {null}
   */
  ReportPartElementProperties.prototype.setHeaderFormattings = m.action(function (newVal) {
    newVal = newVal || {};
    var headerFormating = this.headerFormating;
    var font = newVal.font || {};

    setValue(headerFormating.font, 'family', font.family);
    setValue(headerFormating.font, 'size', font.size);
    setValue(headerFormating.font, 'bold', font.bold);
    setValue(headerFormating.font, 'italic', font.italic);
    setValue(headerFormating.font, 'underline', font.underline);
    setValue(headerFormating, 'wordWrap', newVal.wordWrap);
    setValue(headerFormating, 'alignment', newVal.alignment);
    setValue(headerFormating, 'verticalAlignment', newVal.verticalAlignment);
    setValue(headerFormating, 'columnGroup', trim(newVal.columnGroup));
    setValue(headerFormating.font, 'color', font.color);
    setValue(headerFormating.font, 'backgroundColor', font.backgroundColor);

    this.markDirty();
  });

  /**
   * Set DrillDown Config
   * @param {type} newVal
   */
  ReportPartElementProperties.prototype.setDrillDownConfig = m.action(function (newVal) {
    newVal = newVal || {};
    var drillDown = this.drillDown || {};
    var subReport = newVal.subReport || {};

    setValue(drillDown.subReport, 'selectedReport', subReport.selectedReport);
    setValue(drillDown.subReport, 'style', subReport.style);
    setValue(drillDown.subReport, 'reportPartUsed', subReport.reportPartUsed);
    setValue(drillDown.subReport, 'reportFilter', subReport.reportFilter);
    setValue(drillDown.subReport, 'mappingFields', subReport.mappingFields);
    setValue(drillDown.subReport, 'selectedIconValue', subReport.selectedIconValue);
    setValue(drillDown.subReport, 'viewSettingByLink', subReport.viewSettingByLink);

    this.markDirty();
  });

  /**
   * Update value of model: dataFormattings, headerFormatings and drilldown config
   * @param  {object} newVal
   * @return {null}
   */
  ReportPartElementProperties.prototype.updateData = m.action(function (properties) {
    properties = properties || {};
    this.setDataFormattings(properties.dataFormattings);
    this.setHeaderFormattings(properties.headerFormating);
    this.setDrillDownConfig(properties.drillDown);
    this.setOtherProps(null, merge(this.otherProps, properties.otherProps));
    this.fieldItemVisible = properties.fieldItemVisible;

    this.markDirty();
  });

  /**
   * Update grand total data
   * @param {Object} grandData
   */
  ReportPartElementProperties.prototype.updateGrandTotalData = m.action(function (grandData) {
    grandData = grandData || {};

    var dataFormattings = this.dataFormattings;
    var grandTotal = dataFormattings.grandTotal;

    setValue(grandTotal, 'label', !isNil(grandData.name) ? grandData.name : grandData.label);
    setValue(grandTotal, 'function', !isNil(grandData.functionName) ? grandData.functionName : grandData.function);
    setValue(grandTotal, 'expression', grandData.expression);
    setValue(grandTotal, 'dataType', !isNil(grandData.izendaDataType) ? grandData.izendaDataType : grandData.dataType);
    setValue(grandTotal, 'previewResult', grandData.previewResult);
    setValue(grandTotal, 'format', grandData.format);
  });

  /**
   * Update sub total data
   * @param {Object} subTotalData
   */
  ReportPartElementProperties.prototype.updateSubTotalData = m.action(function (subTotalData) {
    subTotalData = subTotalData || {};

    var dataFormattings = this.dataFormattings;
    var subTotal = dataFormattings.subTotal;

    setValue(subTotal, 'label', !isNil(subTotalData.name) ? subTotalData.name : subTotalData.label);
    setValue(subTotal, 'function', !isNil(subTotalData.functionName) ? subTotalData.functionName : subTotalData.function);
    setValue(subTotal, 'expression', subTotalData.expression);
    setValue(subTotal, 'dataType', !isNil(subTotalData.izendaDataType) ? subTotalData.izendaDataType : subTotalData.dataType);
    setValue(subTotal, 'previewResult', subTotalData.previewResult);
    setValue(subTotal, 'format', subTotalData.format);
  });

  /**
   * Get dirty status.
   */
  ReportPartElementProperties.prototype.checkDirty = function () {
    return this.isDirty;
  };

  /**
   * Clean dirty status.
   */
  ReportPartElementProperties.prototype.cleanDirty = function () {
    this.resetDirty();
  };

  ReportPartElementProperties.prototype.getDefaultsHeaderProperty = function (path, parent) {
    return get(path, this.headerFormating) || get(path, parent);
  };

  ReportPartElementProperties.prototype.getUIStyle = function () {
    return {
      fontFamily: get('font.family', this.dataFormattings),
      fontSize: get('font.size', this.dataFormattings),
      bold: get('font.bold', this.dataFormattings),
      italic: get('font.italic', this.dataFormattings),
      underline: get('font.underline', this.dataFormattings),
      alignment: get('alignment', this.dataFormattings),
      verticalAlignment: get('verticalAlignment', this.dataFormattings),
      wordWrap: get('wordWrap', this.dataFormattings)
    };
  };

  ReportPartElementProperties.prototype.getHeaderCellStyle = function (parent) {
    return {
      fontFamily: this.getDefaultsHeaderProperty('font.family', parent),
      fontSize: this.getDefaultsHeaderProperty('font.size', parent),
      bold: this.getDefaultsHeaderProperty('font.bold', parent),
      italic: this.getDefaultsHeaderProperty('font.italic', parent),
      underline: this.getDefaultsHeaderProperty('font.underline', parent),
      textColor: this.getDefaultsHeaderProperty('font.color', parent),
      backgroundColor: this.getDefaultsHeaderProperty('font.backgroundColor', parent),
      alignment: this.getDefaultsHeaderProperty('alignment', parent),
      verticalAlignment: this.getDefaultsHeaderProperty('verticalAlignment', parent),
      wordWrap: this.getDefaultsHeaderProperty('wordWrap', parent)
    };
  };

  /**
   * Get other properties, these props can be different based on different report-type
   * @return {string} key
   */
  ReportPartElementProperties.prototype.getOtherProps = function (key) {
    return key ? this.otherProps[key] : this.otherProps;
  };

  /**
   * Set other properties, these props can be different based on different report-type
   * @return {}
   */
  ReportPartElementProperties.prototype.setOtherProps = m.action(function (key, newVal) {
    if (key) {
      // create new otherProps object so it will trigger re-render/computed field
      this.otherProps = set(key, newVal, this.otherProps);
    } else {
      this.otherProps = assignIn(this.otherProps, newVal);
    }
  });

  /**
   * Set format
   * @method setFormat
   * @param  {json}  formatData Format data
   */
  ReportPartElementProperties.prototype.setFormat = m.action(function (formatData) {
    setValue(this.dataFormattings, 'format', formatData);
  });

  /**
   * Set format
   * @method setFormat
   * @param  {json}  formatData Format data
   */
  ReportPartElementProperties.prototype.setDataFormatByKey = m.action(function (key, value) {
    setValue(this.dataFormattings, key, value);
    this.markDirty();
  });

  /**
   * set function
   * @method setFunction
   * @param  {json}    functionData Function Data
   */
  ReportPartElementProperties.prototype.setFunction = m.action(function (functionData) {
    setValue(this.dataFormattings, 'function', functionData.id || '');
    this.setFunctionInfo(functionData);
  });

  /**
   * Update function info value.
   * @param {Object} functionData
   */
  ReportPartElementProperties.prototype.setFunctionInfo = m.action(function setFunctionInfo(functionData) {
    this.dataFormattings.functionInfo.dataType = get('dataType', functionData);
    this.dataFormattings.functionInfo.expression = get('expression', functionData);
    this.dataFormattings.functionInfo.expressionSyntax = get('expressionSyntax', functionData);
    this.dataFormattings.functionInfo.extendedProperties = get('extendedProperties', functionData);
    this.dataFormattings.functionInfo.formatDataType = get('formatDataType', functionData);
    this.dataFormattings.functionInfo.id = getOr(null, 'id', functionData);
    this.dataFormattings.functionInfo.isOperator = get('isOperator', functionData);
    this.dataFormattings.functionInfo.name = getOr('', 'name', functionData);
    this.dataFormattings.functionInfo.syntax = get('syntax', functionData);
    this.dataFormattings.functionInfo.userDefined = get('userDefined', functionData);
  });

  /**
   * Check uniq link option in : Custom URL , Embbeded Javascript, Sub Report
   * @param {bool} popupContent
   * @param {string} currentPopupName
   * @returns {bool} this link option is uniq or not
   */
  ReportPartElementProperties.prototype.checkUniqLinkOption = function (popupContent, currentPopupName) {
    var excludeCurrentPopup = filter(function (option) {
      return option != currentPopupName;
    }, propertiesBuilderConstants.CHECK_UNIQ_OPTIONS);

    var isValid = true;

    excludeCurrentPopup.forEach(function (option) {
      var selectedIconValue = this[option].selectedIconValue || {};

      // If option contains style = Embedded, skip this option
      var isEmbeddedSubReport = this[option].style && this[option].style === reportDesingerConstants.DRIL_DOWN_STYLE.EMBEDDED;

      var isEmptySubReport = option === propertiesBuilderConstants.SUB_REPORT.NAME ? !get('selectedReport', this[option]) : false;

      if (!isEmbeddedSubReport && !isEmptySubReport && !this[option].viewSettingByLink && // only check for icon option
      popupContent.viewSettingByLink && selectedIconValue.value === popupContent.selectedIconValue.value) {
        isValid = false;
      }
    }.bind(this));

    return isValid;
  };

  /**
   * Check if Sub report style = embedded & custom URL/embedded javascript view option = Link
   */
  ReportPartElementProperties.prototype.checkEmbeddedLinkOption = function (style) {
    style = style || this.subReport.style;

    if (style === reportDesingerConstants.DRILL_DOWN_STYLE_OPTION_VALUES.embedded && (this.customURL.viewSettingByLink || this.embeddedJavascript.viewSettingByLink)) {
      return false;
    }

    return true;
  };

  /**
   * After change function/format :
   * - Reset Interval and Starting Point
   */
  ReportPartElementProperties.prototype.changeFunctionFormatAction = m.action(function (style) {
    var otherProps = this.otherProps;
    var axis = otherProps.axis;

    if (axis) {
      axis.izTickInterval = null;
      axis.izTickCategoryInterval = null;
      axis.izStartingPoint = null;
      axis.izCategory = false;
    }
  });

  /**
   * Update Grand Total/ Sub Total when change Field Name Alias
   * Update Expression in Grand/Sub Total
   */
  ReportPartElementProperties.prototype.updateGrandSubTotal = m.action(function (oldAlias, newAlias) {
    var dataFormattings = this.dataFormattings;
    var grandTotal = dataFormattings.grandTotal;
    var subTotal = dataFormattings.subTotal;
    var oldFieldName = '[' + oldAlias + ']';
    var newFieldName = '[' + newAlias + ']';

    // Update Grand Total
    !isEmpty(grandTotal.expression) && (grandTotal.expression = replace(oldFieldName, newFieldName, grandTotal.expression));

    // Update Sub Total
    !isEmpty(subTotal.expression) && (subTotal.expression = replace(oldFieldName, newFieldName, subTotal.expression));
  });

  module.exports = ReportPartElementProperties;
}();

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPalette.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INCreadDashboardDefinition.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var ColorPalette =

/**
 * Initial instant
 * @param {string} name
 * @param {Array<string>} colors
 * @param {boolean} isDefaultTheme
 */
function ColorPalette(_ref, displayName) {
  var name = _ref.name,
      colors = _ref.colors,
      isDefaultTheme = _ref.isDefaultTheme;
  (0, _classCallCheck3.default)(this, ColorPalette);
  this.name = null;
  this.colors = null;
  this.displayName = null;
  this.isDefaultTheme = false;

  this.name = name;
  this.colors = colors;
  this.isDefaultTheme = isDefaultTheme;
  this.displayName = name ? name : displayName;
};

exports.default = ColorPalette;
module.exports = exports["default"];

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Part Gris Setting component
 */
!function () {
  module.exports = {
    /**
     * Get border style value
     * @param  {String} position ['top', 'right', 'left', 'bottom']
     * @param  {Object} value    [description]
     * @return {Object}          [style]
     */
    getBorderStyle: function getBorderStyle(position, value) {
      var style = {};

      style['border' + position + 'Style'] = value.dashStyle;
      style['border' + position + 'Width'] = value.thinkness;
      style['border' + position + 'Color'] = value.color;

      return style;
    }
  };
}();

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridSeparator.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridSeparator component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var CollapsibleList = __webpack_require__(410);
  var ReportPartTitle = __webpack_require__(224);
  var ProcessDataUtils = __webpack_require__(164);
  var constants = __webpack_require__(84);
  var SupReportLink = __webpack_require__(573);
  var stylingUtil = __webpack_require__(409);
  var ReportPartUtils = __webpack_require__(35);
  var PrintingUtils = __webpack_require__(76);
  var REPORT_PART_MODE = __webpack_require__(53).REPORT_PART_MODE;
  var COLLAPSE_STATUS = constants.COLLAPSE_STATUS;
  var CUSTOM_FORMAT_PREFIX = __webpack_require__(39).CUSTOM_FORMAT_PREFIX;

  var _require = __webpack_require__(1),
      map = _require.map,
      concat = _require.concat,
      isEmpty = _require.isEmpty,
      omit = _require.omit,
      get = _require.get,
      sortBy = _require.sortBy,
      take = _require.take,
      isNil = _require.isNil,
      head = _require.head;

  var SeparatorItem = function SeparatorItem(props) {
    var separatorContent = props.separatorContent;
    var separatorStyle = props.separatorStyle;
    var reportPart = props.reportPart;

    return React.createElement(
      'div',
      null,
      React.createElement(SeparatorHeader, {
        separatorStyle: separatorStyle,
        keyCollection: separatorContent.key,
        separatorContent: separatorContent,
        reportPart: reportPart,
        getFilterInfoForSubReport: props.getFilterInfoForSubReport,
        renderListeners: props.renderListeners
      }),
      React.createElement(SeparatorBody, (0, _extends3.default)({}, props, { staticRender: props.staticRender }))
    );
  };

  var SeparatorBody = React.createClass({
    displayName: 'SeparatorBody',

    componentWillMount: function componentWillMount() {
      this.renderListeners = [];
    },

    componentDidMount: function componentDidMount() {
      var props = this.props;

      props.printingMode && PrintingUtils.publishFinishedRender(this.renderListeners, function () {
        props.finishedRender && props.finishedRender();
      });
    },
    render: function render() {
      var separatorContent = this.props.separatorContent;
      var props = this.props;
      var renderListeners = this.renderListeners;
      var currentKeyPath = map(function (item) {
        return { element: item.element, value: item.value };
      }, separatorContent.key);
      var subKeyPath = concat(props.keyPath || [], currentKeyPath);

      if (!isEmpty(separatorContent.subGroup)) {
        return React.createElement(
          'div',
          null,
          map(function (item) {
            var key = map('value', item.key).join('_');

            PrintingUtils.pushRenderListener(renderListeners, key);
            return React.createElement(SeparatorItem, (0, _extends3.default)({}, props, {
              separatorContent: item,
              key: key,
              keyPath: subKeyPath,
              staticRender: props.staticRender,
              finishedRender: PrintingUtils.getFinishedRenderPromiseById(renderListeners, key)
            }));
          }, separatorContent.subGroup)
        );
      }

      var keyString = (0, _stringify2.default)(subKeyPath);
      var separatorBodyKey = 'SeparatorBody.' + keyString;

      PrintingUtils.pushRenderListener(renderListeners, separatorBodyKey);

      var GridComponent = this.props.mainComponent;
      var records = separatorContent.data || separatorContent;
      var restProps = omit(['finishedRender'], this.props);

      // Add grid detail here
      return React.createElement(GridComponent, (0, _extends3.default)({}, restProps, {
        records: records,
        keyPath: subKeyPath,
        staticRender: props.staticRender,
        finishedRender: PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorBodyKey)
      }));
    }
  });

  var SeparatorHeaderItem = observer(React.createClass({
    displayName: 'SeparatorHeaderItem',

    componentDidMount: function componentDidMount() {
      var props = this.props;
      var item = props.item;
      var fieldElement = item.element;
      var numberOfPointActions = get('numberOfPointActions', fieldElement);

      !numberOfPointActions && props.printingMode && props.finishedRender && props.finishedRender();
    },
    render: function render() {
      var props = this.props;
      var item = props.item;
      var separatorContent = props.separatorContent;
      var reportPart = props.reportPart;
      var rawRecord = separatorContent.data;

      var _ReportPartUtils$getF = ReportPartUtils.getFieldValue(item.columnName, head(rawRecord)),
          originalValue = _ReportPartUtils$getF.originalValue;

      var displayValue = getDisplayValueForHeader(item, originalValue, props.separatorStyle, separatorContent);
      var dataFormattingsStyles = stylingUtil.getDataFormattings(item.element, !isNil(originalValue) ? originalValue : item.value, rawRecord, reportPart);

      var fieldElement = item.element;
      var numberOfPointActions = get('numberOfPointActions', fieldElement);

      if (numberOfPointActions > 0) {
        return React.createElement(
          SupReportLink,
          {
            reportPart: reportPart,
            fieldElement: fieldElement,
            rawRecord: rawRecord,
            afterRenderCallBack: props.afterRenderCallBack,
            printingMode: props.printingMode,
            containerWidth: get('properties.dataFormattings.width.value', fieldElement),
            getFilterInfoForSubReport: props.getFilterInfoForSubReport,
            finishedRender: props.finishedRender
          },
          React.createElement(
            'span',
            { key: displayValue, style: dataFormattingsStyles },
            displayValue
          )
        );
      }

      return React.createElement(
        'span',
        { key: displayValue, style: dataFormattingsStyles, onClick: props.toggleCollapse },
        displayValue
      );
    }
  }));

  var SeparatorHeader = observer(React.createClass({
    displayName: 'SeparatorHeader',

    componentWillMount: function componentWillMount() {
      this.renderListeners = [];
    },

    componentDidMount: function componentDidMount() {
      var props = this.props;

      props.printingMode && PrintingUtils.publishFinishedRender(this.renderListeners, function () {
        props.finishedRender && props.finishedRender();
      });
    },

    render: function render() {
      var props = this.props;
      var separatorStyle = props.separatorStyle;
      var keyCollection = props.keyCollection;
      var separatorContent = props.separatorContent;
      var reportPart = props.reportPart;
      var prevItem;
      var renderListeners = this.renderListeners;

      if (separatorStyle.multiLine) {
        return React.createElement(
          'div',
          { className: 'header-group separator-title u_fullWidth' },
          map(function (item) {
            var keyString = (0, _stringify2.default)(item);
            var separatorHeaderKey = 'SeparatorHeader.' + keyString;

            PrintingUtils.pushRenderListener(renderListeners, separatorHeaderKey);

            return React.createElement(
              'div',
              null,
              React.createElement(SeparatorHeaderItem, {
                item: item,
                separatorStyle: separatorStyle,
                separatorContent: separatorContent,
                reportPart: reportPart,
                toggleCollapse: props.toggleCollapse,
                afterRenderCallBack: props.printingMode && props.afterRenderCallBack,
                printingMode: props.printingMode,
                getFilterInfoForSubReport: props.getFilterInfoForSubReport,
                finishedRender: PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorHeaderKey)
              })
            );
          }, keyCollection)
        );
      }
      return React.createElement(
        'div',
        { className: 'inline-block header-group separator-title u_fullWidth' },
        keyCollection.map(function (item, index) {
          var keyString = (0, _stringify2.default)(item);
          var separatorHeaderKey = 'SeparatorHeader.' + keyString;

          PrintingUtils.pushRenderListener(renderListeners, separatorHeaderKey);

          return React.createElement(
            'span',
            { key: index },
            getSeparatorSign(index, item),
            React.createElement(SeparatorHeaderItem, {
              item: item,
              separatorStyle: separatorStyle,
              separatorContent: separatorContent,
              reportPart: reportPart,
              toggleCollapse: props.toggleCollapse,
              afterRenderCallBack: props.printingMode && props.afterRenderCallBack,
              printingMode: props.printingMode,
              getFilterInfoForSubReport: props.getFilterInfoForSubReport,
              finishedRender: PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorHeaderKey)
            })
          );
        })
      );

      /**
       * get separator sign (,) for each separator
       * @return {String} sign
       */
      function getSeparatorSign(index, item) {
        var isPrevItemVisible = prevItem && prevItem.element.properties.fieldItemVisible;

        prevItem = item;
        return isPrevItemVisible ? ', ' : '';
      }
    }
  }));

  var CollapsibleHeader = observer(function (props) {
    return React.createElement(
      'section',
      null,
      React.createElement('i', { className: 'icon-toggle-triangle collapse-icon', onClick: props.toggleCollapse }),
      React.createElement(SeparatorHeader, {
        separatorStyle: props.separatorStyle,
        keyCollection: props.keyCollection,
        separatorContent: props.separatorContent,
        toggleCollapse: props.toggleCollapse,
        getFilterInfoForSubReport: props.getFilterInfoForSubReport,
        reportPart: props.reportPart
      })
    );
  });

  var ReportPartGridSeparator = React.createClass({
    displayName: 'ReportPartGridSeparator',

    createSeparatorList: function createSeparatorList(reportPart) {
      var previewDataFieldsMapping = reportPart.previewDataFieldsMapping;

      return {
        separatorList: ProcessDataUtils.filterMappingByContainer(previewDataFieldsMapping, reportPart.reportPartContent.separators)
      };
    },
    getInitialState: function getInitialState() {
      return this.createSeparatorList(this.props.reportPart);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (this.props.records !== nextProps.records) {
        this.setState(this.createSeparatorList(nextProps.reportPart));
      }
    },
    componentWillMount: function componentWillMount() {
      this.renderListeners = []; // for cells
    },

    componentDidMount: function componentDidMount() {
      var props = this.props;

      props.printingMode && PrintingUtils.publishFinishedRender(this.renderListeners, function () {
        props.finishedRender && props.finishedRender();
      });
    },

    componentDidUpdate: function componentDidUpdate() {
      // Reset default collapse
      this.props.reportPart.reportPartContent.setCollapseStatus(COLLAPSE_STATUS.DEFAULT);
    },

    render: function render() {
      var props = this.props;
      var records = props.records;
      var separatorList = sortBy('element.position', this.state.separatorList);
      var separatorStyle = props.reportPart.reportPartContent.separatorStyle;
      var convertData = ProcessDataUtils.splitDataForSeparator(records, separatorList, separatorStyle.multiLevel);

      if (props.isPreview) {
        convertData = take(constants.NUMBER_OF_PREVIEW_SEPARATOR, convertData);
      }

      return props.printingMode ? this.renderPrintingMode(convertData, separatorStyle) : this.renderNormalMode(convertData, separatorStyle);
    },

    expandAll: function expandAll() {
      var reportPartContent = this.props.reportPart.reportPartContent;
      reportPartContent.setCollapseStatus(COLLAPSE_STATUS.EXPAND);
      this.updateDrillDownRecords(reportPartContent.getDrilldownInfo(true));
    },

    collapseAll: function collapseAll() {
      var reportPartContent = this.props.reportPart.reportPartContent;
      reportPartContent.setCollapseStatus(COLLAPSE_STATUS.COLLAPSE);
      this.updateDrillDownRecords(reportPartContent.getDrilldownInfo(false, COLLAPSE_STATUS.DEFAULT));
    },

    updateDrillDownRecords: function updateDrillDownRecords(drillDownOption) {
      var reportPart = this.props.reportPart;
      var loader = this.props.loader;
      loader.startLoading();
      this.props.getDrillDownRecords(reportPart, drillDownOption, reportPart.previewData.paging.pageIndex).then(function (previewData) {
        return reportPart.setQueryData(previewData);
      }).finally(loader.endLoading.bind(loader));
    },

    renderNormalMode: function renderNormalMode(convertData, separatorStyle) {
      var props = this.props;
      var reportPart = props.reportPart;
      var localization = props.localization;
      var forDrillDown = reportPart.reportPartContent.gridStyle === constants.GRID_STYLES.DRILL_DOWN.value;

      return React.createElement(
        'div',
        null,
        forDrillDown && React.createElement(
          'div',
          null,
          React.createElement('span', {
            className: 'icon-plus-circled',
            title: localization.getText('REPORT_PART_GRID_CONSTANTS_LABEL_EXPAND_ALL_TOOLTIP'),
            onClick: this.expandAll
          }),
          React.createElement('span', {
            className: 'icon-minus-circled',
            title: localization.getText('REPORT_PART_GRID_CONSTANTS_LABEL_COLLAPSE_ALL_TOOLTIP'),
            onClick: this.collapseAll
          })
        ),
        React.createElement(
          CollapsibleList,
          {
            defaultExpand: true,
            className: 'panel separator-grid',
            autoCollapse: false,
            afterToogleCallback: props.afterRenderCallBack
          },
          map(function (item) {
            var key = map('value', item.key).join('_');

            return React.createElement(
              CollapsibleList.Item,
              { key: key },
              React.createElement(
                CollapsibleList.ItemHeader,
                { className: 'row panel-heading separator-header' },
                React.createElement(CollapsibleHeader, {
                  key: key,
                  separatorStyle: separatorStyle,
                  keyCollection: item.key,
                  separatorContent: item,
                  getFilterInfoForSubReport: props.getFilterInfoForSubReport,
                  reportPart: reportPart
                })
              ),
              React.createElement(
                CollapsibleList.ItemBody,
                { className: 'separator-body' },
                React.createElement(SeparatorBody, (0, _extends3.default)({}, props, { separatorContent: item, separatorStyle: separatorStyle }))
              )
            );
          }, convertData)
        )
      );
    },

    renderPrintingMode: function renderPrintingMode(convertData, separatorStyle) {
      var props = this.props;
      var reportPart = props.reportPart;
      var usePageBreakAfterSeparator = reportPart.reportPartContent.usePageBreakAfterSeparator;
      var index = 0;
      var numOfRows = convertData && convertData.length;
      var renderListeners = this.renderListeners;

      return React.createElement(
        'section',
        { className: 'printMode u-bgWhite' },
        map(function (item) {
          var elements = [];

          var header = {
            component: SeparatorHeader,
            separatorStyle: separatorStyle,
            keyCollection: item.key,
            separatorContent: item,
            reportPart: reportPart
          };

          var restProps = omit(['finishedRender'], props);
          var keyString = (0, _stringify2.default)(item.key);
          var separatorHeaderKey = 'SeparatorHeader.' + keyString;
          var separatorBodyKey = 'SeparatorBody.' + keyString;

          PrintingUtils.pushRenderListener(renderListeners, separatorHeaderKey);
          PrintingUtils.pushRenderListener(renderListeners, separatorBodyKey);

          elements.push(React.createElement(
            'div',
            { style: PrintingUtils.getSeparatorContainerStyle(props) },
            React.createElement(
              'div',
              { className: PrintingUtils.getSeparatorClassName(props) },
              usePageBreakAfterSeparator && index === 0 && React.createElement(ReportPartTitle, {
                mode: REPORT_PART_MODE.PREVIEW,
                reportPart: reportPart,
                className: 'u_marginBottom izenda-reportPartGrid_titl'
              }),
              React.createElement(SeparatorHeader, {
                separatorStyle: separatorStyle,
                keyCollection: item.key,
                separatorContent: item,
                reportPart: reportPart,
                printingMode: true,
                afterRenderCallBack: props.afterRenderCallBack,
                getFilterInfoForSubReport: props.getFilterInfoForSubReport,
                finishedRender: PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorHeaderKey)
              }),
              React.createElement(SeparatorBody, (0, _extends3.default)({}, restProps, {
                separatorContent: item,
                separatorStyle: separatorStyle,
                staticRender: true,
                finishedRender: PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorBodyKey)
              }))
            )
          ));

          index < numOfRows - 1 && usePageBreakAfterSeparator && elements.push(React.createElement('p', { className: 'pageBreak' }));

          index++;
          return elements;
        }, convertData)
      );
    }
  });

  /**
   * get display value for Separator Header
   * @param  {Object} item
   * @param  {any} originalValue
   * @param  {Object} separatorStyle
   * @param  {Object} separatorContent
   */
  function getDisplayValueForHeader(item, originalValue, separatorStyle, separatorContent) {
    var element = item.element;
    var fieldElementProperties = element.properties;
    var fieldItemVisible = fieldElementProperties.fieldItemVisible;
    var records = separatorContent.data || separatorContent;

    // return blank if this separator is invisible
    if (!fieldItemVisible) {
      return null;
    }
    var value = ReportPartUtils.getDataFormat({
      value: item.value,
      originalValue: originalValue
    }, {
      alternativeText: get('dataFormattings.alternativeText', fieldElementProperties),
      fieldFormatData: get('dataFormattings.format.format', fieldElementProperties),
      fieldDataType: get('previewDataType', element)
    }, {
      element: {
        columnName: item.columnName,
        reportPartElm: element
      },
      record: records[0]
    });

    var displayValue = separatorStyle.withLabel ? String.format('{0}: {1}', get('field.fieldNameAlias', element), value) : value;

    return displayValue;
  }

  module.exports = observer(ReportPartGridSeparator);
}();

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FontSettingsPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
//</copyright>
// ----------------------------------------------------------------------

!function () {
  "use strict";

  var React = __webpack_require__(0);
  var Popup = __webpack_require__(36);
  var AlignmentSetting = __webpack_require__(317);
  var Font = __webpack_require__(411);
  var GridLayout = __webpack_require__(13);
  var Constants = __webpack_require__(34);
  var localizer = __webpack_require__(12);
  var ALIGNMENT_DEFAULT = 'alignLeft';

  var FontSettingsPopup = React.createClass({
    displayName: 'FontSettingsPopup',

    propTypes: {
      save: React.PropTypes.func,
      close: React.PropTypes.func,
      font: React.PropTypes.object,
      title: React.PropTypes.string
    },

    getInitialState: function getInitialState() {
      var font = this.props.font;
      return {
        font: {
          style: {
            fontBold: font.fontBold,
            fontItalic: font.fontItalic,
            fontUnderline: font.fontUnderline
          },
          format: {
            fontFamily: font.fontFamily || Constants.fontFamily.georgia,
            fontSize: font.fontSize || Constants.fontSize[0]
          },
          color: font.fontColor || Constants.textColor,
          backgroundColor: font.fontHighlightColor
        },
        alignment: font.alignment || ALIGNMENT_DEFAULT
      };
    },

    closePopup: function closePopup(type) {
      var state = this.state;
      var font = state.font;
      var format = font.format;
      var style = font.style;
      if (type === 'accept') {
        this.props.save({
          fontFamily: format.fontFamily,
          fontSize: format.fontSize,
          fontBold: style.fontBold,
          fontItalic: style.fontItalic,
          fontUnderline: style.fontUnderline,
          fontColor: font.color,
          fontHighlightColor: font.backgroundColor,
          alignment: state.alignment
        });
        this.props.onAccept();
      } else {
        this.props.onReject();
      }
    },

    handleFontChanged: function handleFontChanged(font) {
      this.setState({
        font: font.value
      });
    },

    handleAlignmentChanged: function handleAlignmentChanged(alignment) {
      this.setState({
        alignment: alignment.value
      });
    },

    renderContainer: function renderContainer() {

      var state = this.state;
      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 3 },
            React.createElement(
              'span',
              null,
              localizer.getText("FONT_SETTINGS_LABEL_FONT")
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 9 },
            React.createElement(Font, { value: state.font, onChange: this.handleFontChanged })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 3 },
            React.createElement(
              'span',
              null,
              localizer.getText("FONT_SETTINGS_LABEL_ALIGNMENT")
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 9 },
            React.createElement(AlignmentSetting, { value: state.alignment, onChange: this.handleAlignmentChanged })
          )
        )
      );
    },

    render: function render() {

      var props = this.props;

      return React.createElement(
        Popup,
        { visible: true, onClosed: this.closePopup, type: 'none', sizeClass: 'modal-xsm' },
        React.createElement(Popup.Header, { title: props.title }),
        React.createElement(
          Popup.Body,
          null,
          this.renderContainer()
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localizer.getText("COMMON_LABEL_OK")
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localizer.getText("COMMON_LABEL_CANCEL")
          )
        )
      );
    }
  });

  module.exports = FontSettingsPopup;
}();

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _bluebird = __webpack_require__(18);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
// ----------------------------------------------------------------------
// <copyright file="Izenda.GridPreviewStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(966);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(84);

var _Izenda4 = __webpack_require__(269);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(967);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(33);

var _Izenda9 = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var GridPreviewStore = (_class = function () {
  function GridPreviewStore() {
    (0, _classCallCheck3.default)(this, GridPreviewStore);
    this.gridReportParts = [];

    _initDefineProp(this, 'selectedMetricIndex', _descriptor, this);

    _initDefineProp(this, 'showingPartIndex', _descriptor2, this);

    _initDefineProp(this, 'isProcessingData', _descriptor3, this);

    _initDefineProp(this, 'buildGridReportParts', _descriptor4, this);
  }
  // Current metric selected in report part chart

  // Current grid to show in the grid preview in case there are multiple record set


  (0, _createClass3.default)(GridPreviewStore, [{
    key: 'getMappingContainers',


    /**
     * Get ordering containers of report part content by mapping definition
     * @param {any} reportPartContent
     * @returns {Array<any>} Collection of containers.
     */
    value: function getMappingContainers(reportPartContent) {
      var isLabelsValuesGroup = (0, _Izenda9.isChartType)(reportPartContent.chartType, _Izenda8.CHART_TYPE.Line, _Izenda8.CHART_TYPE.Column, _Izenda8.CHART_TYPE.Bar, _Izenda8.CHART_TYPE.Area, _Izenda8.CHART_TYPE.Pie, _Izenda8.CHART_TYPE.Funnel, _Izenda8.CHART_TYPE.Donut, _Izenda8.CHART_TYPE.TreeMap, _Izenda8.CHART_TYPE.Combination, _Izenda8.CHART_TYPE.Waterfall, _Izenda8.CHART_TYPE.Sparkline);

      var isLabelsValuesValuesLabelsGroup = (0, _Izenda9.isChartType)(reportPartContent.chartType, _Izenda8.CHART_TYPE.HeatMap, _Izenda8.CHART_TYPE.Scatter);

      var isLabelsValuesBubbleSizeValuesLabelGroup = (0, _Izenda9.isChartType)(reportPartContent.chartType, _Izenda8.CHART_TYPE.Bubble);

      var isGaugeGroup = (0, _Izenda9.isChartType)(reportPartContent.chartType, _Izenda8.CHART_TYPE.SolidGauge, _Izenda8.CHART_TYPE.LinearGauge, _Izenda8.CHART_TYPE.SimpleGauge);

      var mapping = [];

      switch (true) {
        case isLabelsValuesGroup:
          mapping = [_Izenda9.ContainerName.LABELS, _Izenda9.ContainerName.VALUES];
          break;
        case isLabelsValuesValuesLabelsGroup:
          mapping = [_Izenda9.ContainerName.LABELS, _Izenda9.ContainerName.VALUES, _Izenda9.ContainerName.VALUES_LABELS];
          break;

        case isLabelsValuesBubbleSizeValuesLabelGroup:
          mapping = [_Izenda9.ContainerName.LABELS, _Izenda9.ContainerName.VALUES, _Izenda9.ContainerName.BUBBLE_SIZE, _Izenda9.ContainerName.VALUES_LABELS];
          break;
        case isGaugeGroup:
          mapping = [_Izenda9.ContainerName.LABELS, _Izenda9.ContainerName.VALUES];
          break;
      }

      var containers = mapping.reduce(function (result, type) {
        return (0, _fp.concat)(result, (0, _fp.get)(type, reportPartContent));
      }, []);
      // DYNAMIC_THRESHOLD value will be gathered in another story.
      var selectedCustomContainers = (0, _fp.filter)(function (c) {
        return (0, _fp.get)('name', c) !== _Izenda9.ContainerName.DYNAMIC_THRESHOLD;
      }, reportPartContent.customContainers);

      return [].concat((0, _toConsumableArray3.default)(containers), (0, _toConsumableArray3.default)(selectedCustomContainers));
    }

    /**
     * Build column collection
     * @param {any} reportPart
     * @returns {any} column detail
     */

  }, {
    key: 'buildColumns',
    value: function buildColumns(reportPart) {
      var containers = this.getMappingContainers(reportPart.reportPartContent);
      var expandedLevel = (0, _fp.getOr)(0, 'reportPartContent.expandedLevel', reportPart);
      var metricContainerName = reportPart.reportPartContent.getMetricContainer();
      var activeSerie = reportPart.reportPartContent.activeSerie;

      return {
        elements: (0, _fp.flow)((0, _fp.flatMap)(this.applyExpandedLevelAndMetric(expandedLevel, metricContainerName, activeSerie)), (0, _fp.reduce)(function (result, items) {
          return (0, _fp.concat)(result, items);
        }, []), (0, _fp.map)(this.removeLinkedObject))(containers)
      };
    }

    /**
     * Remove field which are not include in expand level or not the current metric
     * @param {number} expandedLevel
     * @param {string} metricContainerName
     * @param {any} activeSerie
     */

  }, {
    key: 'applyExpandedLevelAndMetric',
    value: function applyExpandedLevelAndMetric(expandedLevel, metricContainerName, activeSerie) {
      return function (container) {
        var visibleElement = container.visibleElement,
            name = container.name;

        if (name === _Izenda9.ContainerName.LABELS && expandedLevel >= 0) {
          return (0, _fp.take)(++expandedLevel, visibleElement);
        } else if (name === metricContainerName && activeSerie) {
          return (0, _fp.filter)(function (ele) {
            return ele === activeSerie;
          }, visibleElement);
        }
        return visibleElement;
      };
    }

    /**
     * Build separator collection
     * @param {any} reportPart
     */

  }, {
    key: 'buildSeparators',
    value: function buildSeparators(reportPart) {
      return {
        elements: (0, _fp.map)(this.removeLinkedObject, (0, _fp.get)('separators.elements', reportPart.reportPartContent))
      };
    }

    /**
     * Remove linked object from field, to ensure no subreport, custom URL or embedded javascript showed
     * @param {any} element
     */

  }, {
    key: 'removeLinkedObject',
    value: function removeLinkedObject(element) {
      var newElement = (0, _mobx.toJS)(element);
      if (element && element.properties) {
        var properties = newElement.properties;

        properties.drillDown.subReport.selectedReport = null;
        properties.drillDown.subReport.reportPartUsed = null;
        properties.dataFormattings.customURL.url = '';
        properties.dataFormattings.embeddedJavascript.script = '';
      }
      return newElement;
    }

    /**
     * Build vertical grid detail
     * @param {any} reportPart
     * @param {any} queryData
     * @param {number} index
     * @param {Array<any>} metricContainer
     */

  }, {
    key: 'buildVerticalGridDetail',
    value: function buildVerticalGridDetail(reportPart, queryData, index, metricContainer) {
      var columns = this.buildColumns(reportPart);
      var separators = this.buildSeparators(reportPart);
      var data = (0, _assign2.default)({}, reportPart.reportPartContent, {
        type: _Izenda3.GRID_STYLES.VERTICAL.value,
        columns: columns,
        separators: separators
      });

      data.properties = new _Izenda7.default();
      data.properties.grouping.useSeparator = true;
      data.properties.view = reportPart.reportPartContent.properties.view;
      data.properties.headers.freezeHeaders = _Izenda3.FREEZE_HEADERS.VERTICALLY.value;

      var gridPart = new _Izenda5.default();
      gridPart.reportPartContent = new _Izenda2.default(data);
      gridPart.queryData = queryData;

      return {
        partDefinition: gridPart,
        metric: { label: (0, _fp.get)('name', metricContainer.elements[index]), value: index }
      };
    }

    /**
     * Build all grid report parts
     * @param {any} reportPart
     */

  }, {
    key: 'updateShowingPartIndex',


    /**
     * Update selected showing part index
     * @param {Number} value
     */
    value: function updateShowingPartIndex(value) {
      this.showingPartIndex = value;
    }

    /**
     * Turn off processing data flag
     */

  }, {
    key: 'turnOffProcessingDataIndicator',
    value: function turnOffProcessingDataIndicator() {
      this.isProcessingData = false;
    }
  }]);
  return GridPreviewStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'selectedMetricIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return -1;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'showingPartIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'isProcessingData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'buildGridReportParts', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this = this;

    return function (reportPart) {
      _this.isProcessingData = true;
      var queryData = reportPart.queryData;

      var metricContainerName = reportPart.reportPartContent.getMetricContainer();
      var metricContainer = (0, _fp.find)(function (con) {
        return con.name === metricContainerName;
      }, reportPart.containerCollection);

      _this.gridReportParts = queryData.map(function (data, index) {
        return _this.buildVerticalGridDetail(reportPart, data, index, metricContainer);
      });

      var defaultIndex = -1;
      if (_this.gridReportParts.length > 1) {
        var activeSerie = reportPart.reportPartContent.activeSerie;
        var queryIndex = (0, _fp.findIndex)(function (ele) {
          return ele === activeSerie;
        }, metricContainer.elements);
        _this.selectedMetricIndex = queryIndex >= 0 ? queryIndex : defaultIndex;
      }

      return (0, _bluebird.resolve)(true);
    };
  }
})), _class);
exports.default = GridPreviewStore;
module.exports = exports['default'];

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _bluebird = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartDetails model
 */

var m = __webpack_require__(5);
var ReportPartElement = __webpack_require__(270);
var ReportPartGridProperties = __webpack_require__(967);
var ReportPartGridConstants = __webpack_require__(84);
var GridDefaultConfig = __webpack_require__(968);
var trackable = __webpack_require__(46);
var ReportUtils = __webpack_require__(225);
var ReportDesignerConstants = __webpack_require__(16);
var ReportPartFieldConstants = __webpack_require__(64);
var availableFunction = __webpack_require__(1907);
var reportPartUtils = __webpack_require__(35);
var ReportBodyConstants = __webpack_require__(53);
var ObjectUtils = __webpack_require__(316);
var SORT_ORDERS = ReportPartFieldConstants.SORT_ORDERS;
var FUNCTION = __webpack_require__(64).FUNCTION;

var _require = __webpack_require__(1),
    filter = _require.filter,
    isEmpty = _require.isEmpty,
    some = _require.some,
    forEach = _require.forEach,
    map = _require.map,
    isNil = _require.isNil,
    flow = _require.flow,
    getOr = _require.getOr,
    omit = _require.omit,
    get = _require.get,
    assign = _require.assign,
    compact = _require.compact,
    flatMap = _require.flatMap,
    defaults = _require.defaults,
    includes = _require.includes,
    invoke = _require.invoke,
    each = _require.each,
    clone = _require.clone,
    max = _require.max,
    find = _require.find;

/**
 * create a container from data from api
 * @param  {Object} data [data from api]
 * @return {container}   [container with elements typeof ReportPartElement]
 */


function populateReportPartContainer(name, data) {
  if (!data) {
    return {
      elements: [],
      name: name,
      visibleElement: ReportUtils.getVisibleField
    };
  }
  var pickData = omit('elements', data);
  var elements = data.elements;
  /* convert elements json object to become list of ReportPartElement*/
  var convertElements = map(function (item) {
    return new ReportPartElement().readData(item);
  }, elements);

  return m.observable(assign(pickData, {
    elements: convertElements || [],
    name: name,
    visibleElement: ReportUtils.getVisibleField
  }));
}

function ReportPartGridContent(data) {
  this.subReportDefinitionCollection = [];
  this.collapseStatus = 0;
  this.autoSize = true;

  var props = {
    isCrossFiltering: false,
    type: ReportDesignerConstants.REPORT_PART_TYPE.Grid,
    columns: populateReportPartContainer('columns'),
    rows: populateReportPartContainer('rows'),
    values: populateReportPartContainer('values'),
    separators: populateReportPartContainer('separators'),
    properties: new ReportPartGridProperties(),
    settings: {},
    changeGridStyleStatus: true,
    containerCollection: function containerCollection() {
      return compact([this.columns, this.rows, this.values, this.separators]);
    },
    gridStyle: function gridStyle() {
      return this.properties.generalInfo.gridStyle;
    },
    optionalParams: function optionalParams() {
      var sortOrders = map(function (field) {
        var sortValue = get('properties.dataFormattings.sort', field);

        return { key: field.field.fieldNameAlias, sortingType: sortValue || SORT_ORDERS.Unsorted.value };
      }, this.fieldCollection);

      var params = { expandedLevel: ReportDesignerConstants.EXPANDED_LEVEL.ALL, sortOrders: sortOrders };

      if (this.properties.view.usePagination) {
        params = defaults(params, {
          paging: {
            pageIndex: ReportDesignerConstants.DEFAULT_PAGE_INDEX,
            pageSize: this.properties.view.pageSize || ReportDesignerConstants.DEFAULT_PAGE_SIZE
          }
        });
      }

      return params;
    },
    isBeingBuild: function isBeingBuild() {
      if (this.inconsitentFunction) {
        return false;
      }
      switch (this.gridStyle) {
        case ReportPartGridConstants.GRID_STYLES.VERTICAL.value:
          return !isEmpty(this.columns.visibleElement);
        case ReportPartGridConstants.GRID_STYLES.HORIZONTAL.value:
          return !isEmpty(this.rows.visibleElement);
        case ReportPartGridConstants.GRID_STYLES.DRILL_DOWN.value:
          return !isEmpty(this.rows.visibleElement) && !isEmpty(this.values.visibleElement);
        default:
          return !isEmpty(this.columns.visibleElement) && !isEmpty(this.rows.visibleElement) && !isEmpty(this.values.visibleElement);
      }
    },
    haveRowExpander: function haveRowExpander() {
      switch (this.gridStyle) {
        case ReportPartGridConstants.GRID_STYLES.DRILL_DOWN.value:
          return true;
        case ReportPartGridConstants.GRID_STYLES.PIVOT.value:
          return get('properties.useExpanders', this.rows);
        default:
          return false;
      }
    },
    useSeparator: function useSeparator() {
      return this.properties.grouping.useSeparator && !isEmpty(this.separators.elements);
    },
    containersNeedDefaultFunction: function containersNeedDefaultFunction() {
      switch (this.gridStyle) {
        case ReportPartGridConstants.GRID_STYLES.PIVOT.value:
          return [this.columns, this.values, this.rows, this.separators];
        case ReportPartGridConstants.GRID_STYLES.DRILL_DOWN.value:
          return [this.values, this.rows, this.separators];
        default:
          return [];
      }
    },
    fieldCollection: function fieldCollection() {
      return flatMap(function (item) {
        return item.elements ? item.elements.slice() : [];
      }, this.containerCollection);
    },
    haveFunction: function haveFunction() {
      return some('haveFunction', this.fieldCollection);
    },
    separatorStyle: function separatorStyle() {
      return find({ value: this.properties.generalInfo.separatorStyle }, ReportPartGridConstants.SEPARATOR_STYLE);
    },
    inconsitentFunction: false,
    usePageBreakAfterSeparator: function usePageBreakAfterSeparator() {
      return this.properties.printing.usePageBreakAfterSeparator;
    },
    dataRefreshInterval: function dataRefreshInterval() {
      return get('view.dataRefreshInterval', this.properties);
    },
    reportPartStyle: function reportPartStyle() {
      return this.properties.generalInfo.gridStyle;
    }
  };

  m.extendObservable(trackable(this), props);

  data && this.readData(data);

  this.cleanDirty();
}

ReportPartGridContent.prototype.checkHiddenSortField = function (field, container) {
  return includes(this.gridStyle, [ReportPartGridConstants.GRID_STYLES.PIVOT.value, ReportPartGridConstants.GRID_STYLES.DRILL_DOWN.value]) && container.name === ReportPartGridConstants.CONTAINER_NAME.VALUES;
};

ReportPartGridContent.prototype.validateCanAddField = function (reportDesigner, container, fieldCollection) {
  var isDistinct = get('dataSource.distinct', reportDesigner);
  var gridStyle = this.properties.generalInfo.gridStyle;
  var containerName = container.name;
  var messageTemplate = null;
  var warning = true;

  if (isDistinct) {
    messageTemplate = ReportBodyConstants.MESSAGES.M05_1;
  } else {
    switch (gridStyle) {
      case ReportPartGridConstants.GRID_STYLES.VERTICAL.value: // VERTICAL
      case ReportPartGridConstants.GRID_STYLES.HORIZONTAL.value:
        // HORIZONTAL
        if (containerName === ReportPartGridConstants.CONTAINER_NAME.SEPARATORS) {
          warning = false;
          messageTemplate = ReportBodyConstants.MESSAGES.M08;
        } else if (this.haveFunction) {
          messageTemplate = ReportBodyConstants.MESSAGES.M08;
        }
        break;
      case ReportPartGridConstants.GRID_STYLES.DRILL_DOWN.value: // DRILL_DOWN
      case ReportPartGridConstants.GRID_STYLES.PIVOT.value:
        // PIVOT
        warning = false;
        messageTemplate = containerName === ReportPartGridConstants.CONTAINER_NAME.VALUES ? ReportBodyConstants.MESSAGES.M09 : ReportBodyConstants.MESSAGES.M08;
        break;
    }
  }

  var errorField = filter(function (field) {
    return ObjectUtils.isBinary(field.izendaDataType || field.fieldDataType);
  }, fieldCollection);

  if (messageTemplate && !isEmpty(errorField)) {
    return {
      message: String.format(messageTemplate, map('name', errorField).join(', ')),
      errorField: !warning ? errorField : []
    };
  }

  return {
    message: null,
    errorField: []
  };
};
/**
 * check if function is compatible with element
 * @method checkedCompatibleFunction
 * @param  {Object}                  container    Container that element belong
 * @param  {Object}                  element      Element need to validate
 * @param  {Object}                  functionInfo Function infomation
 * @return {Boolean}                              Result
 */
ReportPartGridContent.prototype.checkedCompatibleFunction = function (container, element, functionInfo) {
  var result = true;

  if (element.field.hasAggregatedFunction) {
    result = reportPartUtils.checkedCompatibleFunctionHasAggregatedFunction(functionInfo);
  }

  var config = availableFunction.AVAILABLE_FUNCTION_CONFIG[this.gridStyle];

  config = config && container && config[container.name];

  if (!config || !result) {
    return result;
  }

  return reportPartUtils.checkCompatibleFunctionCommon(functionInfo, element, config);
};

/**
 * read data from api/create report part to update data
 * @param {Object} content [data from api/create report part]
 */
ReportPartGridContent.prototype.readData = m.action(function (content) {
  content = content || {};
  this.type = content.type;
  this.isCrossFiltering = content.isCrossFiltering;
  this.columns = populateReportPartContainer('columns', content.columns);
  this.rows = populateReportPartContainer('rows', content.rows);
  this.values = populateReportPartContainer('values', content.values);
  this.separators = populateReportPartContainer('separators', content.separators);
  content.properties && this.properties.setReportPartProperties(content.properties);
  this.settings = content.settings;
  this.dataSource = content.dataSource || {};
  this.markDirty();
});

/**
 * validate function based on container
 * @method validateFunction
 * @param  {object}         container    container need validateFunction
 * @param  {object}         functionInfo Function need validate
 * @return {json}                      validate result
 */
ReportPartGridContent.prototype.validateFunction = function (container, functionInfo) {
  if (!functionInfo && includes(container, this.containersNeedDefaultFunction)) {
    return {
      status: false,
      useDefaultFunction: true
    };
  }

  return {
    status: true
  };
};

/**
 * [getDefaultFunctionFormat Get Default Function And Format for field in container]
 * @method getDefaultFunctionFormat
 * @param  {json}                 container Container have element need get default dataType
 * @param  {string}                 dataType  Data Type for field
 * @return {json}                           default data
 */
ReportPartGridContent.prototype.getDefaultFunctionFormat = function (container, dataType) {
  var fieldContainerName = container.name;
  var gridStyleDefault = GridDefaultConfig.DefaultConfig[this.gridStyle];
  var functionDefine = this.haveFunction ? gridStyleDefault.DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION : gridStyleDefault.DEFAULT_FUNCTION;
  var functionContainer = functionDefine[fieldContainerName] || {};

  return functionContainer[dataType];
};

/**
 * action invoke after insert new field into container
 * @method afterInsertFieldToContainer
 * @param  {json}                      container        Container with new field
 * @param  {ReportPartElement}         field            Field just created
 * @return {promise}
 */
ReportPartGridContent.prototype.afterInsertFieldToContainer = function (container, field) {
  if (field.haveFunction) {
    return reportPartUtils.convertNonFunctionElementsToFunction(this, ReportPartFieldConstants.FUNCTION.GROUP.NAME);
  }
  return (0, _bluebird.resolve)();
};

/**
 * after update function for field
 * @method afterUpdateFunction
 * @param  {ReportPartElement}            field            Field just update function
 * @return {Promise}                                       return promise
 */
ReportPartGridContent.prototype.afterUpdateFunction = m.action(function (field) {
  var checkInconsistentFunction = function () {
    this.inconsitentFunction = some({ haveFunction: true }, this.fieldCollection) && some({ haveFunction: false }, this.fieldCollection);
  }.bind(this);
  if (field.haveFunction) {
    var functionName = get('functionInfo.name', field);
    return functionName !== FUNCTION.DAYS_OLD.NAME && reportPartUtils.convertNonFunctionElementsToFunction(this, ReportPartFieldConstants.FUNCTION.GROUP.NAME).then(checkInconsistentFunction);
  }
  return (0, _bluebird.resolve)().then(checkInconsistentFunction);
});

/**
 * Return data object that represents for a report part.
 */
ReportPartGridContent.prototype.getData = function () {
  return omit('dataSource', m.toJS(this));
};

/**
 * Get dirty status.
 */
ReportPartGridContent.prototype.checkDirty = function () {
  var dirtyElements = ReportUtils.dirtyReportPartElementField(this.containerCollection);
  var properties = this.properties;

  return this.isDirty || !isEmpty(dirtyElements) || properties && properties.checkDirty && properties.checkDirty();
};

/**
 * Clean dirty status.
 */
ReportPartGridContent.prototype.cleanDirty = function () {
  var dirtyElements = ReportUtils.dirtyReportPartElementField(this.containerCollection);

  each(function (item) {
    item.resetDirty && item.resetDirty();
  }, dirtyElements);

  var properties = this.properties;

  invoke('resetDirty', properties);

  this.resetDirty();
};

ReportPartGridContent.prototype.changeGridStyle = m.action(function (oldStyle, newStyle, reportPartDetail) {
  forEach(function (item) {
    item.properties = null;
  }, this.containerCollection);

  forEach(function (item) {
    this[item.key].properties = m.observable(clone(item.properties));
  }.bind(this), ReportPartGridConstants.GRID_STYLES_CONSTANT_PROPERTIES[newStyle]);

  this.properties.generalInfo.gridStyle = newStyle;

  var mappings = find({
    fromStyle: oldStyle,
    toStyle: newStyle
  }, ReportPartGridConstants.MAPPING_GRID_STYLE);

  if (!mappings) {
    return (0, _bluebird.resolve)();
  }

  /**
   * each mapping map from mulltiple container to 1 container
   * @type {[type]}
   */
  forEach(function (mapping) {
    var toContainer = get(mapping.toContainer, this);
    var newArray = [];

    /**
     * move each element to new container
     * @method moveToContainer
     * @param  {[type]}        element [description]
     * @return {[type]}                [description]
     */
    var moveToContainer = function moveToContainer(element) {
      element.position = (flow(map('position'), max)(newArray) || 0) + 1;
      newArray.push(element);
    };

    forEach(function (item) {
      var fromContainer = get(item, this);
      var elements = fromContainer.elements;

      forEach(moveToContainer, elements);
      fromContainer.elements = [];
    }.bind(this), mapping.fromContainer);

    toContainer.elements = newArray;
  }.bind(this), mappings.mappings);

  var promiseArray = flow(flatMap(function (container) {
    return map(function (element) {
      var needUpdateFunction = !this.checkedCompatibleFunction(container, element, getOr({}, 'properties.dataFormattings.functionInfo', element));

      /**
       * update function if the current function not compatible
       */
      if (needUpdateFunction) {
        return reportPartUtils.setDefaultFunctionElement(this, container, element);
      }

      return null;
    }.bind(this), container.elements);
  }.bind(this)), compact)(this.containerCollection);

  this.changeGridStyleStatus = isEmpty(promiseArray);
  return (0, _bluebird.all)(promiseArray);
});

ReportPartGridContent.prototype.updateColumnsUseExpanders = m.action(function (value) {
  this.columns.properties.useExpanders = value;
  this.markDirty();
});

ReportPartGridContent.prototype.changePageSize = m.action(function (pageSize) {
  this.properties.changePageSize(pageSize);
  this.markDirty();
});

ReportPartGridContent.prototype.updateColumnsAddSideTotal = m.action(function (value) {
  this.columns.properties.addSideTotal = value;
  this.markDirty();
});

ReportPartGridContent.prototype.updateRowsUseExpanders = m.action(function (value) {
  this.rows.properties.useExpanders = value;
  this.markDirty();
});

/**
 * Check need to break page when printing.
 */
ReportPartGridContent.prototype.checkBreakPage = function () {
  return this.useSeparator && this.usePageBreakAfterSeparator;
};

ReportPartGridContent.prototype.getNewSortValue = function (container, oldValue, configField) {
  switch (oldValue) {
    case SORT_ORDERS.ASC.value:
      return SORT_ORDERS.DESC.value;
    case SORT_ORDERS.DESC.value:
      return this.checkCanUnsort(container, configField) ? '' : SORT_ORDERS.ASC.value;
    default:
      return SORT_ORDERS.ASC.value;
  }
};

/**
 * Reset sort values
 * @param {Object} container
 */
ReportPartGridContent.prototype.resetSortValue = m.action(function (container) {
  forEach(function (element) {
    return element.properties.setSortValue(SORT_ORDERS.Unsorted.value);
  }, container.elements);
});

/**
 * Check if this field can have state Unsort
 * @param {type} reportDesigner
 * @param {type} container
 */
ReportPartGridContent.prototype.checkCanUnsort = function (container, configField) {
  return reportPartUtils.checkCanUnsort(this.gridStyle, container, configField, this.containerCollection);
};

/**
 * Get drill info.
 */
ReportPartGridContent.prototype.getDrilldownInfo = function (expandByDefault, defaultValue) {
  var hasSubTotal = some('hasSubTotal', this.values.visibleElement);
  var expandedLevel;

  if (expandByDefault || hasSubTotal) {
    expandedLevel = -1;
  } else if (!isNil(defaultValue)) {
    expandedLevel = defaultValue;
  } else {
    expandedLevel = this.properties.view.collapseDrilldownByDefault ? 0 : -1;
  }
  if (expandedLevel >= 0) {
    var firstVisibleLevel = Math.min.apply(Math, (0, _toConsumableArray3.default)(this.rows.visibleElement.map(function (e) {
      return e.position;
    }))) - 1;
    expandedLevel = Math.max(expandedLevel, firstVisibleLevel);
  }
  return {
    expandedLevel: expandedLevel,
    filters: []
  };
};

ReportPartGridContent.prototype.setCollapseStatus = function (status) {
  this.collapseStatus = status;
};

module.exports = ReportPartGridContent;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridProperties.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * other settings model
 */


var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(223);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(84);

var _Izenda6 = __webpack_require__(34);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * report part grid properties
 * @constructor ReportPartGridProperties
 * @param  {json} data JSON data from api
 */
var ReportPartGridProperties = (0, _Izenda2.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(ReportPartGridProperties, [{
    key: 'pageSize',
    get: function get() {
      return this.view.pageSize;
    }
  }, {
    key: 'isHeaderStickVertical',
    get: function get() {
      return this.headers.freezeHeaders === _Izenda5.FREEZE_HEADERS.VERTICALLY.value;
    }
  }, {
    key: 'isHeaderStickHorizontal',
    get: function get() {
      return this.headers.freezeHeaders === _Izenda5.FREEZE_HEADERS.HORIZONTALLY.value;
    }
  }]);

  function ReportPartGridProperties(data) {
    (0, _classCallCheck3.default)(this, ReportPartGridProperties);

    _initDefineProp(this, 'generalInfo', _descriptor, this);

    _initDefineProp(this, 'table', _descriptor2, this);

    _initDefineProp(this, 'columns', _descriptor3, this);

    _initDefineProp(this, 'rows', _descriptor4, this);

    _initDefineProp(this, 'headers', _descriptor5, this);

    _initDefineProp(this, 'grouping', _descriptor6, this);

    _initDefineProp(this, 'view', _descriptor7, this);

    _initDefineProp(this, 'printing', _descriptor8, this);

    this.view.pivotColumnsPerExportedPage = '';
    data && this.setReportPartProperties(data);

    this.cleanDirty();
  }

  /**
   * get properties from table object
   * @param  {string} key name of properties
   * @return {object}     value of properties
   */


  (0, _createClass3.default)(ReportPartGridProperties, [{
    key: 'getTableByKey',
    value: function getTableByKey(key) {
      return (0, _fp.get)(key, this.table);
    }

    /**
     * get properties from headers object
     * @param  {string} key name of properties
     * @return {object}     value of properties
     */

  }, {
    key: 'getHeadersByKey',
    value: function getHeadersByKey(key) {
      return (0, _fp.get)(key, this.headers);
    }

    /**
     * get properties from columns object
     * @param  {string} key name of properties
     * @return {object}     value of properties
     */

  }, {
    key: 'getColumnsByKey',
    value: function getColumnsByKey(key) {
      return (0, _fp.get)(key, this.columns);
    }

    /**
     * get properties from columns object
     * @param  {string} key name of properties
     * @return {object}     value of properties
     */

  }, {
    key: 'getColumnWidth',
    value: function getColumnWidth() {
      return (0, _fp.get)('width.value', this.columns);
    }

    /**
     * get properties from rows object
     * @param  {string} key name of properties
     * @return {object}     value of properties
     */

  }, {
    key: 'getRowsByKey',
    value: function getRowsByKey(key) {
      return (0, _fp.get)(key, this.rows);
    }

    /**
     * get properties from general info object
     * @param  {string} key name of properties
     * @return {object}     value of properties
     */

  }, {
    key: 'getGeneralInfoByKey',
    value: function getGeneralInfoByKey(key) {
      return (0, _fp.get)(key, this.generalInfo);
    }

    /**
     * get properties from grouping object
     * @param  {string} key name of properties
     * @return {object}     value of properties
     */

  }, {
    key: 'getGroupingByKey',
    value: function getGroupingByKey(key) {
      return (0, _fp.get)(key, this.grouping);
    }

    /**
     * get properties from grouping object
     * @param  {string} key name of properties
     * @return {object}     value of properties
     */

  }, {
    key: 'getViewByKey',
    value: function getViewByKey(key) {
      return (0, _fp.get)(key, this.view);
    }

    /**
     * update repoert part properties from data from properties editor or api
     * @param {object} data [update data]
     */

  }, {
    key: 'setReportPartProperties',
    value: function setReportPartProperties(data) {
      (0, _Izenda4.default)(this.generalInfo, 'gridStyle', (0, _fp.get)('generalInfo.gridStyle', data));
      (0, _Izenda4.default)(this.generalInfo, 'separatorStyle', (0, _fp.get)('generalInfo.separatorStyle', data));
      this.setTable(data.table);
      (0, _Izenda4.default)(this.rows, 'alterBackgroundColor', (0, _fp.get)('rows.alterBackgroundColor', data));
      (0, _Izenda4.default)(this.grouping, 'useSeparator', (0, _fp.get)('grouping.useSeparator', data));
      (0, _Izenda4.default)(this.printing, 'usePageBreakAfterSeparator', (0, _fp.get)('printing.usePageBreakAfterSeparator', data));
      this.setHeaders(data.headers);
      this.setView(data.view);
      this.setColumns(data.columns);

      this.markDirty();
    }
  }, {
    key: 'setTable',
    value: function setTable(data) {
      var setDetail = (0, _mobx.action)(function setDetail(key) {
        var detail = (0, _fp.get)(key, border);
        (0, _Izenda4.default)(table.border[key], 'color', (0, _fp.getOr)(null, 'color', detail));
        (0, _Izenda4.default)(table.border[key], 'dashStyle', (0, _fp.getOr)(null, 'dashStyle', detail));
        (0, _Izenda4.default)(table.border[key], 'thinkness', (0, _fp.getOr)(null, 'thinkness', detail));
      });

      var table = this.table;
      var border = (0, _fp.get)('border', data);

      (0, _Izenda4.default)(table, 'backgroundColor', (0, _fp.get)('backgroundColor', data));
      (0, _Izenda4.default)(table, 'alternativeBackgroundColor', (0, _fp.get)('alternativeBackgroundColor', data));
      setDetail('bottom');
      setDetail('left');
      setDetail('midHor');
      setDetail('midVer');
      setDetail('right');
      setDetail('top');
    }
  }, {
    key: 'setColumns',
    value: function setColumns(data) {
      var columns = this.columns;

      (0, _Izenda4.default)(columns.width, 'value', (0, _fp.get)('width.value', data));
      (0, _Izenda4.default)(columns, 'alterBackgroundColor', (0, _fp.get)('alterBackgroundColor', data));
      (0, _Izenda4.default)(columns, 'wordWrap', (0, _fp.get)('wordWrap', data));
      (0, _Izenda4.default)(columns, 'alignment', (0, _fp.get)('alignment', data));
      (0, _Izenda4.default)(columns, 'verticalAlignment', (0, _fp.get)('verticalAlignment', data));
    }
  }, {
    key: 'setView',
    value: function setView(data) {
      var view = this.view;

      (0, _Izenda4.default)(view, 'dataRefreshInterval', (0, _fp.get)('dataRefreshInterval', data));
      (0, _Izenda4.default)(view, 'usePagination', (0, _fp.get)('usePagination', data));
      (0, _Izenda4.default)(view, 'collapseDrilldownByDefault', (0, _fp.get)('collapseDrilldownByDefault', data));
      (0, _Izenda4.default)(view, 'pivotColumnsPerExportedPage', (0, _fp.toNumber)((0, _fp.get)('pivotColumnsPerExportedPage', data)) || '');
      (0, _Izenda4.default)(view, 'pageSize', (0, _fp.get)('pageSize', data));
    }

    /**
     * set Headers
     */

  }, {
    key: 'setHeaders',
    value: function setHeaders(data) {
      var headers = this.headers;

      (0, _Izenda4.default)(headers.font, 'family', (0, _fp.get)('font.family', data));
      (0, _Izenda4.default)(headers.font, 'size', (0, _fp.get)('font.size', data));
      (0, _Izenda4.default)(headers.font, 'bold', (0, _fp.get)('font.bold', data));
      (0, _Izenda4.default)(headers.font, 'italic', (0, _fp.get)('font.italic', data));
      (0, _Izenda4.default)(headers.font, 'underline', (0, _fp.get)('font.underline', data));
      (0, _Izenda4.default)(headers.font, 'color', (0, _fp.get)('font.color', data));
      (0, _Izenda4.default)(headers.font, 'backgroundColor', (0, _fp.get)('font.backgroundColor', data));

      (0, _Izenda4.default)(headers, 'alignment', (0, _fp.get)('alignment', data));
      (0, _Izenda4.default)(headers, 'verticalAlignment', (0, _fp.get)('verticalAlignment', data));
      (0, _Izenda4.default)(headers, 'wordWrap', (0, _fp.get)('wordWrap', data));
      (0, _Izenda4.default)(headers, 'removeHeaderForExport', (0, _fp.get)('removeHeaderForExport', data));
      (0, _Izenda4.default)(headers, 'freezeHeaders', (0, _fp.get)('freezeHeaders', data));
    }

    /**
     * Get Header Cell Style
     * @return {Object}
     */

  }, {
    key: 'getHeaderCellStyle',
    value: function getHeaderCellStyle() {
      var headers = this.headers;
      return {
        fontFamily: (0, _fp.get)('font.family', headers),
        fontSize: (0, _fp.get)('font.size', headers),
        bold: (0, _fp.get)('font.bold', headers),
        italic: (0, _fp.get)('font.italic', headers),
        underline: (0, _fp.get)('font.underline', headers),
        textColor: (0, _fp.get)('font.color', headers),
        backgroundColor: (0, _fp.get)('font.backgroundColor', headers),
        alignment: (0, _fp.get)('alignment', headers),
        verticalAlignment: (0, _fp.get)('verticalAlignment', headers),
        wordWrap: (0, _fp.get)('wordWrap', headers)
      };
    }

    /**
     * Get dirty status.
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty;
    }
  }, {
    key: 'changePageSize',
    value: function changePageSize(pageSize) {
      this.view.pageSize = pageSize;
      this.markDirty();
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();
    }
  }, {
    key: 'getPageBreakAfterSeparator',
    value: function getPageBreakAfterSeparator(key) {
      return (0, _fp.get)(key, this.printing);
    }

    /**
     * Reset border default value
     */

  }, {
    key: 'resetBorderDefaultValue',
    value: function resetBorderDefaultValue() {
      this.table.border = (0, _fp.cloneDeep)(_Izenda5.DEFAULT_SETTING_VALUE.border);
      this.markDirty();
    }

    /**
     * Reset refresh interval setting to default value
     */

  }, {
    key: 'resetRefreshInterval',
    value: function resetRefreshInterval() {
      this.view.dataRefreshInterval = _Izenda5.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
      this.markDirty();
    }
  }]);
  return ReportPartGridProperties;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'generalInfo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      gridStyle: _Izenda5.GRID_STYLES.VERTICAL.value,
      separatorStyle: _Izenda5.SEPARATOR_STYLE.COMMA.value
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'table', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      border: (0, _fp.cloneDeep)(_Izenda5.DEFAULT_SETTING_VALUE.border),
      backgroundColor: _Izenda7.default.reportPartGridDefault.backgroundColor,
      alternativeBackgroundColor: _Izenda5.DEFAULT_VALUE_PROPERTIES.TABLE.ALTERNATIVE_BACKGROUND_COLOR
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'columns', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      width: {
        value: _Izenda5.DEFAULT_VALUE_PROPERTIES.COLUMNS.WIDTH.VALUE
      },
      alterBackgroundColor: false,
      wordWrap: _Izenda5.DEFAULT_VALUE_PROPERTIES.COLUMNS.WORDWRAP,
      alignment: _Izenda5.DEFAULT_VALUE_PROPERTIES.COLUMNS.ALIGNMENT,
      verticalAlignment: _Izenda5.DEFAULT_VALUE_PROPERTIES.COLUMNS.VERTICAL_ALIGNMENT
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'rows', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      alterBackgroundColor: false
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'headers', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      font: {
        family: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.FAMILY,
        size: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.SIZE,
        bold: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.BOLD,
        italic: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.ITALIC,
        underline: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.UNDERLINE,
        color: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.COLOR,
        backgroundColor: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.BACKGROUND_COLOR
      },
      alignment: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.ALIGNMENT,
      verticalAlignment: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.VERTICAL_ALIGNMENT,
      wordWrap: _Izenda5.DEFAULT_VALUE_PROPERTIES.HEADERS.WORDWRAP,
      removeHeaderForExport: false,
      freezeHeaders: null
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'grouping', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      useSeparator: true
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'view', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      dataRefreshInterval: {
        enable: false,
        updateInterval: 0,
        isAll: true,
        latestRecord: 0
      },
      usePagination: true,
      collapseDrilldownByDefault: false,
      pageSize: _Izenda8.DEFAULT_PAGE_SIZE
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'printing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      usePageBreakAfterSeparator: false
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'pageSize', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'pageSize'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isHeaderStickVertical', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isHeaderStickVertical'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isHeaderStickHorizontal', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isHeaderStickHorizontal'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setReportPartProperties', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportPartProperties'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setTable', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setTable'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setColumns', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setColumns'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setView', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setView'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setHeaders', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setHeaders'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changePageSize', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changePageSize'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetBorderDefaultValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetBorderDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetRefreshInterval', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetRefreshInterval'), _class2.prototype)), _class2)) || _class;

exports.default = ReportPartGridProperties;
module.exports = exports['default'];

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(1906);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_SORT_VIRTICAL_HORIZONTAL = {
  columns: 'Unsorted',
  separators: 'ASC',
  rows: 'Unsorted'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.GridDefaultConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var DEFAULT_SORT_DRILL_DOWN = {
  rows: 'ASC',
  separators: 'ASC'
};

var DEFAULT_SORT_PIVOT = {
  rows: 'Unsorted',
  columns: 'ASC',
  separators: 'ASC'
};

var HORIZONTAL_DEFAULT_CONFIG = {
  DEFAULT_FUNCTION: _Izenda2.default.HORIZONTAL_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_SEPARATORS: _Izenda2.default.HORIZONTAL_DEFAULT_FUNCTION_WITH_SEPARATORS,
  DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: _Izenda2.default.HORIZONTAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION,
  DEFAULT_SORT: DEFAULT_SORT_VIRTICAL_HORIZONTAL
};
var VERTICAL_DEFAULT_CONFIG = {
  DEFAULT_FUNCTION: _Izenda2.default.VERTICAL_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_SEPARATORS: _Izenda2.default.VERTICAL_DEFAULT_FUNCTION_WITH_SEPARATORS,
  DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: _Izenda2.default.VERTICAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION,
  DEFAULT_SORT: DEFAULT_SORT_VIRTICAL_HORIZONTAL
};
var DRILL_DOWN_DEFAULT_CONFIG = {
  DEFAULT_FUNCTION: _Izenda2.default.DRILL_DOWN_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_SEPARATORS: _Izenda2.default.DRILL_DOWN_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: _Izenda2.default.DRILL_DOWN_DEFAULT_FUNCTION,
  DEFAULT_SORT: DEFAULT_SORT_DRILL_DOWN
};
var PIVOT_DEFAULT_CONFIG = {
  DEFAULT_FUNCTION: _Izenda2.default.PIVOT_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_SEPARATORS: _Izenda2.default.PIVOT_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: _Izenda2.default.PIVOT_DEFAULT_FUNCTION,
  DEFAULT_SORT: DEFAULT_SORT_PIVOT
};

exports.default = {
  DefaultConfig: {
    Pivot: PIVOT_DEFAULT_CONFIG,
    Horizontal: HORIZONTAL_DEFAULT_CONFIG,
    Vertical: VERTICAL_DEFAULT_CONFIG,
    Drilldown: DRILL_DOWN_DEFAULT_CONFIG
  }
};
module.exports = exports['default'];

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReport.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataRefreshSetting Component
 */
!function () {
  var React = __webpack_require__(0);
  var GridLayout = __webpack_require__(13);
  var Select = __webpack_require__(47);
  var Input = __webpack_require__(17);
  var observer = __webpack_require__(10).observer;
  var EmbedReportStore = __webpack_require__(577);
  var localizer = __webpack_require__(12);
  var ReportPartSelectionPopup = __webpack_require__(399);
  var ReportPartSelectionConstants = __webpack_require__(185);
  var Icon = __webpack_require__(314);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      map = _require.map;

  var EmbedReport = React.createClass({
    displayName: 'EmbedReport',

    componentWillMount: function componentWillMount() {
      this.store = this.props.store || new EmbedReportStore();
    },

    getValue: function getValue() {
      var model = this.store.model;
      return {
        selectedReport: model.selectedReport
      };
    },

    /**
     * Get selected report
     * @param {Object} report Report Definition
     */
    setSelectedReport: function setSelectedReport(result) {
      var report = result.report;
      this.store.model.setSelectedReport(report);
    },

    /**
     * Get report parts
     * @param {Object} props
     * @param {String} report id
     */
    setSelectedReportPart: function setSelectedReportPart(id) {
      this.store.model.selectedReport.setSelectedReportPart(id);
    },

    /**
     * Get selected report parts
     * @param {Object} props
     * @param {String} selected report parts
     * @returns {Array} id list
     */
    getSelectedReportParts: function getSelectedReportParts() {
      return map(function (rp) {
        return rp.id;
      }, this.store.model.selectedReport.selectedReportParts);
    },

    // Open report selection popup
    openSearchReportPopup: function openSearchReportPopup() {
      var props = this.props;

      props.openPopup(ReportPartSelectionPopup, {
        onChange: this.setSelectedReport,
        type: ReportPartSelectionConstants.TYPE.REPORT,
        excludeIds: isNil(props.reportId) ? [] : [props.reportId]
      });
    },

    render: function render() {
      var store = this.store;
      var selectedReport = store.model.selectedReport;

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '3' },
            localizer.getText('COMMON_LABEL_REPORTS')
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '8' },
            React.createElement(Input, { value: selectedReport.name, className: 'form-control', disabled: true })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '1' },
            React.createElement(Icon, { className: 'icon-search', onClick: this.openSearchReportPopup })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '3' },
            localizer.getText('REPORTDESIGNER_LABEL_REPORT_PART_USED')
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '8' },
            React.createElement(Select, {
              simpleValue: true,
              multi: true,
              options: selectedReport.reportParts,
              labelKey: 'title',
              valueKey: 'id',
              onChange: this.setSelectedReportPart,
              value: this.getSelectedReportParts(),
              scalable: false
            })
          )
        )
      );
    }
  });

  module.exports = observer(EmbedReport);
}();

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormDnD.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormDnD
 */
!function () {
  var AppGlobal = __webpack_require__(41);
  var droppable = __webpack_require__(259);
  var ReportDesignerConstants = __webpack_require__(16);

  var _require = __webpack_require__(1),
      constant = _require.constant;

  module.exports = function (component) {
    var targetOptions = {
      drop: function drop(props, monitor, com) {
        if (monitor.didDrop()) {
          return;
        }

        var reportPartContent = props.reportPart.reportPartContent;
        var item = monitor.getItem() || {};

        var fieldLimitValue = AppGlobal.advancedSettings.performance.fieldLimitValue;

        if (props.reportPart.fieldCollection.length >= fieldLimitValue) {
          props.confirmFn('Information', {
            description: ReportDesignerConstants.BUNDLE.MESSAGE.FIELDS_EXCEEDED_LIMITATION,
            type: 'error',
            showCloseIndicator: true
          });

          return;
        }

        reportPartContent.updateContainerField();
        props.reportPart.insertFieldToContainer(reportPartContent.columns, item.querySourceField, item.dataObject).then(function (addedField) {
          var code = reportPartContent.getHTMLCodeField(addedField, item.dataObject);

          reportPartContent.getEditorControl().insertContentDnD(code);
        });
      },

      canAccess: constant(true)
    };

    return droppable([ReportDesignerConstants.GENNERAL.FIELD_ITEM], targetOptions)(component);
  };
}();

/***/ }),
/* 971 */,
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CustomCheckbox.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var CustomCheckbox = function CustomCheckbox(props) {
  var className = props.className,
      title = props.title;

  return _react2.default.createElement(
    'label',
    { className: (0, _classnames2.default)(['custom-checkbox', className]) },
    _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox' }, props)),
    _react2.default.createElement(
      'span',
      { className: 'fontello-icon' },
      title
    )
  );
};

exports.default = CustomCheckbox;
module.exports = exports['default'];

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(957);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapDrilldownBreadcrumb = (0, _recompose.withProps)(function (props) {
  return {
    getPoints: function getPoints() {
      var drillDownInfo = (0, _fp.getOr)([], 'reportPart.reportPartContent.drilldownInfo', props);

      return (0, _fp.map)(function (level) {
        var point = (0, _fp.getOr)({}, 'point', level);
        return (0, _fp.assign)(level, {
          value: point.name || (0, _fp.get)('mapInfo.backgroundMap.label', level)
        });
      }, drillDownInfo);
    }
  };
})(_Izenda2.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.MapDrilldownBreadcrumb.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Map Drilldown Breadcrumb Component
 */

exports.default = MapDrilldownBreadcrumb;
module.exports = exports['default'];

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.MenuContext.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * MenuContext Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(919);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(41);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_PREFIX = 'Izenda-MenuContext_';
var ZERO = 0;

var MenuContext = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MenuContext, _Component);

  function MenuContext(props) {
    (0, _classCallCheck3.default)(this, MenuContext);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MenuContext.__proto__ || (0, _getPrototypeOf2.default)(MenuContext)).call(this, props));

    _this.initListener = function () {
      document.addEventListener('click', _this.onClickOverMenu);
      document.addEventListener('mousedown', _this.onClickOverMenu);
      document.addEventListener('mousewheel', _this.onClickOverMenu);
      window.addEventListener('resize', _this.onClickOverMenu);
    };

    _this.destroyListener = function () {
      document.removeEventListener('click', _this.onClickOverMenu);
      document.removeEventListener('mousedown', _this.onClickOverMenu);
      document.removeEventListener('mousewheel', _this.onClickOverMenu);
      window.removeEventListener('resize', _this.onClickOverMenu);
    };

    _this.getMousePosition = function (event) {
      var element = _Izenda4.default.containerElement.getBoundingClientRect();
      var xPos = event.clientX || (0, _fp.getOr)(ZERO, 'touches[0].pageX', event);
      var yPos = event.clientY || (0, _fp.getOr)(ZERO, 'touches[0].pageY', event);
      var xOffset = Math.max(document.documentElement.scrollLeft, document.body.scrollLeft);
      var yOffset = Math.max(document.documentElement.scrollTop, document.body.scrollTop);

      return {
        left: xPos + xOffset - element.left,
        top: yPos + yOffset - element.top
      };
    };

    _this.show = function (position) {
      if (_this.props.isDisabled) {
        return;
      }

      _this.setState({
        isShowMenuContext: true,
        top: position.top,
        left: position.left
      });
    };

    _this.hide = function () {
      _this.setState({
        isShowMenuContext: false
      });
    };

    _this.onClickOverMenu = function (event) {
      var container = _this.mountNode;
      function isBelongToMenuCheck(dom) {
        while (dom != null && dom.parentNode != window) {
          if (dom === container) return true;
          dom = dom.parentNode;
        }
        return false;
      }

      var isBelongToMenu = isBelongToMenuCheck(event.target);

      if (isBelongToMenu && typeof event.target.click === 'function' && event.type === 'click') {
        _this.hide();
        event.preventDefault();
        event.stopPropagation();
        return false;
      }

      !isBelongToMenu && _this.hide();
      return false;
    };

    _this.onShowMenuContextEvent = function (event) {
      _this.state.isShowMenuContext && event.type !== _this.customEventName && _this.hide();
      (0, _fp.isNumber)(event.detail.top) && (0, _fp.isNumber)(event.detail.left) && _this.show(event.detail);
    };

    _this.dispatchEvent = function (dataToDispatch) {
      var customEvent = new CustomEvent(_this.customEventName, { detail: dataToDispatch });
      document.dispatchEvent(customEvent);
    };

    _this.onContextMenuEvent = function (event) {
      var pos = _this.getMousePosition(event);
      (0, _fp.isNumber)(pos.top) && (0, _fp.isNumber)(pos.left) && _this.dispatchEvent(pos);

      event.preventDefault();
      event.stopPropagation();
      return false;
    };

    _this.getPositionStyle = function () {
      var isShowMenuContext = _this.state.isShowMenuContext || false;

      return {
        position: 'absolute',
        top: _this.state.top,
        left: _this.state.left,
        display: isShowMenuContext ? null : 'none',
        zIndex: 1000
      };
    };

    _this.setMountNode = function (ref) {
      _this.mountNode = ref ? ref.getMountNode() : ref;
    };

    _this.state = {
      left: 0,
      top: 0,
      isShowMenuContext: false,
      isDisabled: props.isDisabled || false
    };
    _this.customEventName = EVENT_PREFIX + props.id;
    return _this;
  }

  (0, _createClass3.default)(MenuContext, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener(this.customEventName, this.onShowMenuContextEvent, false);
      this.initListener();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.isShowMenuContext !== this.state.isShowMenuContext || nextState.top !== this.state.top || nextState.left !== this.state.left || !(0, _fp.isEqual)(nextProps, this.props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener(this.customEventName, this.onShowMenuContextEvent);
      this.destroyListener();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'izenda-MenuContext', onContextMenu: this.onContextMenuEvent },
        this.props.children,
        this.state.isShowMenuContext && _react2.default.createElement(
          _Izenda2.default,
          { ref: this.setMountNode },
          _react2.default.createElement(
            'div',
            { style: this.getPositionStyle() },
            this.props.menuComponent
          )
        )
      );
    }
  }]);
  return MenuContext;
}(_react.Component), _class.propTypes = {
  isDisabled: _propTypes2.default.bool,
  id: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.element.isRequired,
  menuComponent: _propTypes2.default.element.isRequired
}, _temp);
exports.default = MenuContext;
module.exports = exports['default'];

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFrontSide.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(83);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(142);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(27);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(155);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartFrontSide = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartFrontSide, _Component);

  function ReportPartFrontSide() {
    (0, _classCallCheck3.default)(this, ReportPartFrontSide);
    return (0, _possibleConstructorReturn3.default)(this, (ReportPartFrontSide.__proto__ || (0, _getPrototypeOf2.default)(ReportPartFrontSide)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportPartFrontSide, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var autoSize = props.autoSize;

      var restProps = (0, _fp.omit)(['autoSize'], props);
      var FrontSideView = _Izenda4.default.getReportFrontSide(props.reportPart.type);
      var error = (0, _fp.flow)((0, _fp.find)(function (message) {
        return message.reportPartId === props.reportPart.id;
      }), (0, _fp.get)('message'))(props.store.reportPartErrorMessages);

      return _react2.default.createElement(
        'div',
        { className: 'report-part-front-side' },
        !(0, _fp.isNil)(error) ? _react2.default.createElement(
          'div',
          { className: 'front-side-content' },
          error
        ) : autoSize ? _react2.default.createElement(
          'div',
          { className: 'front-side-content' },
          _react2.default.createElement(FrontSideView, restProps)
        ) : _react2.default.createElement(
          _Izenda6.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'front-side-content' },
            _react2.default.createElement(FrontSideView, restProps)
          )
        )
      );
    }
  }]);
  return ReportPartFrontSide;
}(_react.Component), _class2.propTypes = {
  reportPart: _react2.default.PropTypes.object
}, _temp)) || _class;

var ReportPartFrontSideContainer = function ReportPartFrontSideContainer(props) {
  var reportConfig = _Izenda4.default.getReportPartType(props.reportPart.type);
  _Izenda9.default.loadCustomDataFormat();

  if ((0, _fp.includes)(reportConfig.value, [_Izenda7.REPORT_PART_TYPE.Chart, _Izenda7.REPORT_PART_TYPE.Gauge, _Izenda7.REPORT_PART_TYPE.Map])) {
    return _react2.default.createElement((0, _Izenda2.default)(ReportPartFrontSide), props);
  } else {
    return _react2.default.createElement(ReportPartFrontSide, props);
  }
};

ReportPartFrontSideContainer.displayName = 'ReportPartFrontSideContainer';

exports.default = ReportPartFrontSideContainer;
module.exports = exports['default'];

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartViewer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Part Viewer component
 */

/**
 * This component is intended to show only report part content.
 * Parameters locate in the params property.
 * id: required. Id of report part.
 * containerId: required. Id of report which contents report part.
 * Options from query:
 * - width: option (default is 100%), in pixel.
 * - height: option (default is 100%), in pixel.
 * - hideTitle: option (default is undefined), in truthy value.
 * - separator: option (default is undefined), encoded separator value.
 * - draftId : draftId to get draft report definition
 * - reportPartName : report part tile for print draft
 *
 * Example build URI:
 * var ContentRoutes = require('routes/Izenda.ContentRoutes').contentRoutes;
 * var ROUTE = require('routes/Izenda.ContentRoutes').route;
 * var uri = routeUtils.getViewerUrl(
 *   'ReportPart',
 *   {
 *     id: '00867012-9060-4347-8460-ac41aa3291f2'
 *   }
 * );
 * // result: /viewer/reportpart/00867012-9060-4347-8460-ac41aa3291f2?width=100&height=200
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(177);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(27);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(407);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(15);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(104);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartViewer = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartViewer, _Component);

  function ReportPartViewer(props) {
    (0, _classCallCheck3.default)(this, ReportPartViewer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartViewer.__proto__ || (0, _getPrototypeOf2.default)(ReportPartViewer)).call(this, props));

    _this.setDom = function (domNode) {
      _this.dom = domNode;
    };

    var printingMode = props.printingMode,
        reportPartId = props.reportPartId,
        reportId = props.reportId,
        queryObject = props.queryObject;

    var params = props.params || {};
    var location = props.location || {};
    var query = location.query || queryObject || {};

    // Set current user to use user date format in case exporting, the page did not set current user before
    if ((0, _fp.isNull)(_Izenda10.default.currentUser.userName)) {
      _Izenda12.default.accountStore.loadCurrentUser().then(function (result) {
        result.success && _Izenda10.default.setCurrentUser(result.data);
      });
    }

    _this.printingMode = (0, _fp.get)('print', query) === 'true' || printingMode;
    _this.reportPartId = reportPartId || params.id;
    _this.reportId = reportId;

    if (queryObject) {
      _this.subReportFilter = queryObject;
    } else if (query) {
      if (query.tempUrl) {
        _this.subReportFilter = _Izenda4.default.readSubReportQuery(query);
      } else {
        _this.subReportFilterFromQuery = _Izenda4.default.convertQueryToFilter(query);
      }
    }
    return _this;
  }

  (0, _createClass3.default)(ReportPartViewer, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var isFirstReportPart = props.isFirstReportPart,
          afterRenderCallBack = props.afterRenderCallBack,
          notInvokeRenderCallBackAfterDidMount = props.notInvokeRenderCallBackAfterDidMount,
          doesBreakPage = props.doesBreakPage,
          finishedRender = props.finishedRender,
          exportFormatSetting = props.exportFormatSetting,
          setting = props.setting,
          hideGridPopup = props.hideGridPopup,
          reportPart = props.reportPart,
          store = props.store;

      var location = props.location || {};
      var query = location.query || {};
      var hideTitle = query.hideTitle,
          separator = query.separator,
          width = query.width,
          height = query.height;


      var frontSide = _react2.default.createElement(
        'div',
        { ref: this.setDom },
        _react2.default.createElement(_Izenda8.default, {
          reportPart: reportPart,
          store: store,
          forExporting: width && height,
          width: width,
          height: height,
          reportId: this.reportId,
          reportPartId: this.reportPartId,
          location: location,
          subReportFilter: this.subReportFilter,
          subReportFilterFromQuery: this.subReportFilterFromQuery,
          printingMode: this.printingMode,
          hideGridPopup: hideGridPopup,
          setting: setting,
          exportFormatSetting: exportFormatSetting,
          finishedRender: finishedRender,
          doesBreakPage: doesBreakPage,
          isFirstReportPart: isFirstReportPart,
          afterRenderCallBack: afterRenderCallBack,
          notInvokeRenderCallBackAfterDidMount: notInvokeRenderCallBackAfterDidMount,
          hideTitle: hideTitle,
          separator: separator
        })
      );

      return _react2.default.createElement(
        'div',
        { className: 'u_fullSize izenda-ReportPartViewer' },
        this.printingMode ? frontSide : _react2.default.createElement(
          _Izenda6.default,
          null,
          frontSide
        )
      );
    }
  }]);
  return ReportPartViewer;
}(_react.Component), _class2.propTypes = {
  params: _propTypes2.default.object,
  location: _propTypes2.default.object
}, _temp)) || _class);
exports.default = ReportPartViewer;
module.exports = exports['default'];

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyLayoutUIStore.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var GridLayoutUIStore = __webpack_require__(580);
  var GridItemState = __webpack_require__(581);
  var CONSTANTS = __webpack_require__(53);
  var MIN_PART_WIDTH = 3;
  var MIN_PART_HEIGHT = 3;

  var _require = __webpack_require__(1),
      create = _require.create;

  function ReportBodyLayoutUIStore(width, fullSize, infinityRows, infinityCols) {
    GridLayoutUIStore.call(this, CONSTANTS.BODY_CELL_WIDTH, // default grid cell width
    CONSTANTS.BODY_CELL_HEIGHT, // default grid cell height
    width, // report body width
    CONSTANTS.NUMBER_BODY_ROWS, // report body layout rows
    CONSTANTS.NUMBER_BODY_COLS, // report body layout cols
    infinityRows, // allow infinity rows
    infinityCols, // allow infinity cols
    fullSize, // view in full size mode
    true, MIN_PART_WIDTH, MIN_PART_HEIGHT);
  }

  ReportBodyLayoutUIStore.prototype = create(GridLayoutUIStore.prototype, {
    'constructor': ReportBodyLayoutUIStore
  });

  module.exports = ReportBodyLayoutUIStore;
}();

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(979);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportViewerFilterDescriptions = function ReportViewerFilterDescriptions(props) {
  var store = props.store,
      localization = props.localization;

  var reportFilters = store.reportFilters;
  var configFields = reportFilters.displayConfigFields;

  return reportFilters.visible && !(0, _fp.isEmpty)(configFields) && _react2.default.createElement(
    'div',
    { className: 'u_paddingAll u-bgWhite' },
    _react2.default.createElement(
      'p',
      null,
      localization.getText('REPORT_LABEL_REPORT_FILTER_INFO')
    ),
    configFields.map(function (configField, index) {
      return _react2.default.createElement(_Izenda4.default, { key: index, field: configField, position: index + 1, operatorSource: configFields });
    })
  );
}; // ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerFilterDescriptions.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

ReportViewerFilterDescriptions.propTypes = {
  store: _propTypes2.default.object
};

exports.default = (0, _Izenda2.default)()(ReportViewerFilterDescriptions);
module.exports = exports['default'];

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(1979);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.FilterDescription.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
var FilterDescription = function FilterDescription(props) {
  var field = props.field,
      position = props.position,
      operatorSource = props.operatorSource,
      filterSource = props.filterSource;

  var source = (0, _fp.compact)(operatorSource);
  var filterDescription = field.getFilterInfoDisplayName(position, (0, _fp.isEmpty)(source) ? (0, _fp.compact)(filterSource) : source);

  return !(0, _fp.isEmpty)(filterDescription) && _react2.default.createElement(
    'p',
    { style: field.fieldDetails.getDisplayStyle() },
    filterDescription
  );
};

FilterDescription.propTypes = {
  field: _propTypes2.default.object.isRequired,
  position: _propTypes2.default.number
};

FilterDescription.displayName = 'FilterDescription';

exports.default = (0, _Izenda2.default)(FilterDescription);
module.exports = exports['default'];

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFormatElement.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Format Element
 */
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var connect = __webpack_require__(2);
  var transaction = __webpack_require__(5).transaction;
  var classnames = __webpack_require__(11);

  var Panel = __webpack_require__(28);
  var FormatItem = __webpack_require__(1980);
  var Dimensions = __webpack_require__(83);
  var ReportBodyConstants = __webpack_require__(53);
  var GridItem = __webpack_require__(301);
  var AddItemPopup = __webpack_require__(1981);
  var FormatItemPropertiesSchema = __webpack_require__(582);
  var ReportFormatLayoutUIStore = __webpack_require__(1984);

  var Droppable = __webpack_require__(259);
  var DnDFormatItemConfig = __webpack_require__(583);
  var GridView = __webpack_require__(299);
  var FormatGridView = Droppable(ReportBodyConstants.DRAG_ITEM.REPORT_PART_FIELD_ITEM, DnDFormatItemConfig.targetOptions)(GridView);

  var _require = __webpack_require__(1),
      forEach = _require.forEach,
      some = _require.some,
      find = _require.find,
      placeholder = _require.placeholder;

  var CONSTANTS = __webpack_require__(106);
  var FORMAT_ITEM_EDITOR = [{
    name: 'formatItemProps',
    getDefinedSchema: FormatItemPropertiesSchema
  }];

  var ReportFormatElement = React.createClass({
    displayName: 'ReportFormatElement',

    propTypes: {
      store: React.PropTypes.object,
      formatElement: React.PropTypes.object,
      title: React.PropTypes.string,
      cols: React.PropTypes.number,
      rows: React.PropTypes.number,
      width: React.PropTypes.number,
      afterToggled: React.PropTypes.func
    },

    /**
     * Make ElementResizeDetector listen to the DOM when this component is mounted
     */
    componentWillMount: function componentWillMount() {
      var width = this.props.width;
      var rows = this.props.rows;
      var cols = this.props.cols;
      this.layoutStore = new ReportFormatLayoutUIStore(width, rows, cols);

      // this.dispose = this.reactiveUpdateLayout();
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (nextProps.width !== this.props.width) {
        this.layoutStore.setViewWidth(nextProps.width);
      }
    },

    componentDidMount: function componentDidMount() {
      var dom = ReactDOM.findDOMNode(this);
      this.layoutStore.setViewWidth(dom.clientWidth);
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return nextProps.width !== this.props.width;
    },

    /**
     * render list format items
     * @returns {Array}
     */
    renderListFormatItems: function renderListFormatItems() {
      var props = this.props || {};
      var store = props.store || {};
      var formatElement = props.formatElement;
      var formatItems = formatElement.formatItems;
      var context = this.context || {};

      return formatItems.map(function (data) {
        return React.createElement(
          GridItem,
          {
            key: data.id,
            id: data.id,
            isDraggable: true,
            isResizable: true,
            cancel: 'input.form-control, a',
            fillWidth: props.fillWidth,
            minHeight: data.minHeight,
            useItemMinHeight: true,
            cols: props.cols
          },
          React.createElement(FormatItem, (0, _extends3.default)({
            itemData: data,
            propsEditors: FORMAT_ITEM_EDITOR,
            formatElement: formatElement,
            context: context,
            store: store
          }, props))
        );
      });
    },

    /**
     * Calculate real width side.
     */
    getRealValueOnXAxis: function getRealValueOnXAxis() {
      var props = this.props || {};
      var formatElement = props.formatElement;
      var formatItems = formatElement.formatItems;
      var maxValue = 0;

      forEach(function (item) {
        var value = item.positionX + item.width;
        if (value > maxValue) {
          maxValue = value;
        }
      }, formatItems);

      return maxValue;
    },

    /**
     * Render header of panel
     * @param  {Object} props
     */
    renderHeader: function renderHeader(collapsibleProps) {
      var props = this.props;
      var viewMode = props.viewMode;
      var formatElement = props.formatElement;

      var onChange = function onChange(item) {
        var defaultConfig = CONSTANTS.ITEMS_TYPE[item.value];
        formatElement.addItem && formatElement.addItem(item.value, defaultConfig.width, defaultConfig.height);
      };

      return React.createElement(
        'div',
        { className: 'inline-block full-width' },
        React.createElement(
          'strong',
          { onClick: collapsibleProps.collapseToggle, className: 'report-format-label' },
          React.createElement('i', { className: 'icon-toggle-thick' }),
          ' ',
          props.title
        ),
        viewMode ? null : React.createElement(AddItemPopup, { className: 'pull-right', onChange: onChange })
      );
    },

    render: function render() {
      var props = this.props;
      var formatElement = props.formatElement;
      var afterToggled = props.afterToggled;

      var header = {
        component: this.renderHeader
      };

      var layoutStore = this.layoutStore;
      var layoutData = formatElement.formatItems.map(toFormatLayoutItem);

      var renderContent = function () {
        // Note that this view need to attach onDrop for
        // drop in function.
        return React.createElement(
          FormatGridView,
          {
            className: this.props.className,
            layoutStore: layoutStore,
            layoutData: layoutData,
            flatTransformStyle: true,
            editable: !props.viewMode,
            onDrop: this.onDrop,
            allowAddInline: false,
            onUpdateItemPositions: this.onUpdateItemPositions,
            showLoading: false,
            horizontalAlign: props.horizontalAlign,
            maxWidth: this.getRealValueOnXAxis() * layoutStore.cellWidth
          },
          this.renderListFormatItems()
        );
      }.bind(this);

      var reportFormatElementClass = props.setting ? classnames('report-format-element', props.className) : classnames('report-format-element');

      return props.viewMode ? React.createElement(
        'div',
        { className: reportFormatElementClass, style: props.style },
        ' ',
        renderContent(),
        ' '
      ) : React.createElement(
        Panel,
        { header: header, afterToggled: afterToggled, collapsible: true, initState: true, className: 'report-format-element' },
        renderContent()
      );
    },
    /**
     * Update new report format item positions
     * @param  {Array} newItemPos    Array of new item positions
     */
    onUpdateItemPositions: function onUpdateItemPositions(newItemPos) {
      var needItemUpdate = function needItemUpdate(item) {
        return some({ id: item.id }, newItemPos);
      };

      var setPosition = function setPosition(item) {
        var newPos = find({ id: item.id }, newItemPos);
        item.setPosition({
          positionX: newPos.left,
          positionY: newPos.top,
          width: newPos.width,
          height: newPos.height
        });
      };

      var formatItems = this.props.formatElement.formatItems;
      transaction(function () {
        placeholder(formatItems).filter(needItemUpdate).forEach(setPosition);
      });
    },
    /**
     * Calls when a format item has been dropped in.
     * @param  {Object} item A format item including type
     */
    onDrop: function onDrop(item) {
      var defaultConfig = CONSTANTS.ITEMS_TYPE[item.type];
      var formatElement = this.props.formatElement;
      formatElement.addItem(item.type, defaultConfig.width, defaultConfig.height);
    }
  });

  /**
   * Convert report format item to grid layout item
   */
  function toFormatLayoutItem(item) {
    return {
      id: item.id,
      x: item.positionX,
      y: item.positionY,
      width: item.width,
      height: item.height,
      isFullSize: false
    };
  }

  module.exports = connect(Dimensions)(ReportFormatElement);
}();

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatStyleUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  'use strict';

  var CONSTANTS = __webpack_require__(106);
  var ITEMS_TYPE = CONSTANTS.ITEMS_TYPE;

  module.exports = {
    /**
     * Get style object for item
     */
    getStyle: function getStyle(item) {
      var font = item.font || {};
      var alignment = item.alignment;
      var imageUrl = item.imageUrl;

      var style = {
        fontFamily: font.family,
        fontSize: font.size + 'px',
        fontWeight: font.bold ? 'bold' : 'normal',
        textAlign: alignment || 'none',
        textDecoration: font.underline ? 'underline' : 'none',
        fontStyle: font.italic ? 'italic' : 'normal',
        color: font.color
      };

      imageUrl && (style.backgroundImage = 'url(' + imageUrl + ')');
      return style;
    },

    /**
     * Get background style
     */
    getBackgroundStyle: function getBackgroundStyle(item) {
      var font = item.font || {};

      return {
        backgroundColor: font.backgroundColor
      };
    },

    /**
     * Get line style
     */
    getLineStyle: function getLineStyle(item, viewMode) {
      var color = viewMode ? item.color : '#000';
      var dashStyle = viewMode ? item.dashStyle : 'solid';
      var thickness = viewMode ? item.thickness : 4;

      switch (item.type) {
        case ITEMS_TYPE.horizontalRule.value:
        case ITEMS_TYPE.thinHorizontalRule.value:
          return {
            borderTopColor: color,
            borderTopStyle: dashStyle,
            borderTopWidth: thickness
          };
        case ITEMS_TYPE.verticalRule.value:
          return {
            borderLeftColor: color,
            borderLeftStyle: dashStyle,
            borderLeftWidth: thickness
          };
      }
    }
  };
}();

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerKeyJoinDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(16);

var _Izenda2 = __webpack_require__(54);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportDesignerKeyJoinDetail = (_dec = (0, _mobx.action)('populateData'), _dec2 = (0, _mobx.action)('setJoinDataSourceCategory'), _dec3 = (0, _mobx.action)('setForeignDataSourceCategory'), _dec4 = (0, _mobx.action)('setJoinQuerySource'), _dec5 = (0, _mobx.action)('setForeignQuerySource'), _dec6 = (0, _mobx.action)('setJoinField'), _dec7 = (0, _mobx.action)('setForeignField'), _dec8 = (0, _mobx.action)('clone'), _dec9 = (0, _mobx.action)('setAlias'), _dec10 = (0, _mobx.action)('updateKeyJoinItem'), _dec11 = (0, _mobx.action)('newId'), _dec12 = (0, _mobx.action)('setComparisionOperator'), _dec13 = (0, _mobx.action)('setComparisionValue'), _dec14 = (0, _mobx.action)('updateForeignDataObjectAlias'), (0, _Izenda3.default)(_class = (_class2 = function () {
  function ReportDesignerKeyJoinDetail(detail) {
    (0, _classCallCheck3.default)(this, ReportDesignerKeyJoinDetail);

    _initDefineProp(this, 'parentId', _descriptor, this);

    _initDefineProp(this, 'isKeyJoin', _descriptor2, this);

    _initDefineProp(this, 'relationshipId', _descriptor3, this);

    _initDefineProp(this, 'joinFieldId', _descriptor4, this);

    _initDefineProp(this, 'foreignFieldId', _descriptor5, this);

    _initDefineProp(this, 'operator', _descriptor6, this);

    _initDefineProp(this, 'joinQuerySourceId', _descriptor7, this);

    _initDefineProp(this, 'joinQuerySourceName', _descriptor8, this);

    _initDefineProp(this, 'joinDataSourceCategoryId', _descriptor9, this);

    _initDefineProp(this, 'joinDataSourceCategoryName', _descriptor10, this);

    _initDefineProp(this, 'joinFieldName', _descriptor11, this);

    _initDefineProp(this, 'foreignFieldName', _descriptor12, this);

    _initDefineProp(this, 'foreignQuerySourceId', _descriptor13, this);

    _initDefineProp(this, 'foreignQuerySourceName', _descriptor14, this);

    _initDefineProp(this, 'foreignDataSourceCategoryId', _descriptor15, this);

    _initDefineProp(this, 'foreignDataSourceCategoryName', _descriptor16, this);

    _initDefineProp(this, 'joinSourceAlias', _descriptor17, this);

    _initDefineProp(this, 'foreignSourceAlias', _descriptor18, this);

    _initDefineProp(this, 'selectedJoinSourceAlias', _descriptor19, this);

    _initDefineProp(this, 'selectedForeignSourceAlias', _descriptor20, this);

    _initDefineProp(this, 'id', _descriptor21, this);

    _initDefineProp(this, 'state', _descriptor22, this);

    _initDefineProp(this, 'modified', _descriptor23, this);

    _initDefineProp(this, 'dateTimeNow', _descriptor24, this);

    _initDefineProp(this, 'validationKey', _descriptor25, this);

    _initDefineProp(this, 'position', _descriptor26, this);

    _initDefineProp(this, 'level', _descriptor27, this);

    _initDefineProp(this, 'comparisonOperator', _descriptor28, this);

    _initDefineProp(this, 'comparisonValue', _descriptor29, this);

    _initDefineProp(this, 'isForeignDataObjectAlias', _descriptor30, this);

    this.tempId = '';
    this.convertedFromRelationshipId = '';
    this.populateData(detail || {});
    this.resetDirty();
  }

  (0, _createClass3.default)(ReportDesignerKeyJoinDetail, [{
    key: 'populateData',
    value: function populateData(detail) {
      this.tempId = (0, _fp.get)('id', detail) || (0, _fp.uniqueId)('keyjoin_');
      this.parentId = (0, _fp.getOr)(null, 'relationshipId', detail);
      this.isKeyJoin = true;
      this.relationshipId = (0, _fp.getOr)(null, 'relationshipId', detail);
      this.joinFieldId = (0, _fp.getOr)(null, 'joinFieldId', detail);
      this.foreignFieldId = (0, _fp.getOr)(null, 'foreignFieldId', detail);
      this.operator = (0, _fp.get)('operator', detail) || _Izenda.OPERATOR_TYPES[0].label;
      this.joinQuerySourceId = (0, _fp.getOr)(null, 'joinQuerySourceId', detail);
      this.joinQuerySourceName = (0, _fp.get)('joinQuerySourceName', detail) || '';
      this.joinDataSourceCategoryId = (0, _fp.getOr)(null, 'joinDataSourceCategoryId', detail);
      this.joinDataSourceCategoryName = (0, _fp.get)('joinDataSourceCategoryName', detail) || '';
      this.joinFieldName = (0, _fp.get)('joinFieldName', detail) || '';
      this.foreignFieldName = (0, _fp.get)('foreignFieldName', detail) || '';
      this.foreignQuerySourceId = (0, _fp.getOr)(null, 'foreignQuerySourceId', detail);
      this.foreignQuerySourceName = (0, _fp.get)('foreignQuerySourceName', detail) || '';
      this.foreignDataSourceCategoryId = (0, _fp.getOr)(null, 'foreignDataSourceCategoryId', detail);
      this.foreignDataSourceCategoryName = (0, _fp.get)('foreignDataSourceCategoryName', detail) || '';
      this.joinSourceAlias = (0, _fp.get)('joinSourceAlias', detail) || '';
      this.foreignSourceAlias = (0, _fp.get)('foreignSourceAlias', detail) || '';
      this.selectedJoinSourceAlias = (0, _fp.get)('selectedJoinSourceAlias', detail) || '';
      this.selectedForeignSourceAlias = (0, _fp.get)('selectedForeignSourceAlias', detail) || '';
      this.id = (0, _fp.getOr)(null, 'id', detail);
      this.state = !(0, _fp.isNil)(detail.state) ? detail.state : _Izenda.OBJECT_STATE.INSERT, this.modified = null;
      this.dateTimeNow = null;
      this.validationKey = (0, _fp.get)('id', detail) || this.tempId;
      this.position = (0, _fp.get)('position', detail) || 0;
      this.level = null;
      this.comparisonOperator = (0, _fp.get)('comparisonOperator', detail) || _Izenda.DEFAULT_COMPARISION_OPERATOR;
      this.comparisonValue = (0, _fp.getOr)(null, 'comparisonValue', detail);
      // This flag is use to mark the foreign data object of this relationship use alias
      this.isForeignDataObjectAlias = (0, _fp.get)('isForeignDataObjectAlias', detail) || false;
      this.convertedFromRelationshipId = (0, _fp.get)('convertedFromRelationshipId', detail);
    }

    /**
     * Update join data source category.
     * @param {string} id
     * @param {string} name
     */

  }, {
    key: 'setJoinDataSourceCategory',
    value: function setJoinDataSourceCategory(id, name) {
      this.joinDataSourceCategoryId = id;
      this.joinDataSourceCategoryName = name;
      this.setJoinQuerySource(null);
      this.updateState();
    }

    /**
     * Update foreign data source category.
     * @param {string} id
     * @param {string} name
     */

  }, {
    key: 'setForeignDataSourceCategory',
    value: function setForeignDataSourceCategory(id, name) {
      this.foreignDataSourceCategoryId = id;
      this.foreignDataSourceCategoryName = name;
      this.setForeignQuerySource(null);
      this.updateState();
    }

    /**
     * Update join query source.
     * @param {string} id
     * @param {string} name
     */

  }, {
    key: 'setJoinQuerySource',
    value: function setJoinQuerySource(id, name) {
      this.selectedJoinSourceAlias = id;
      this.joinQuerySourceName = name;
      this.joinFieldId = null;
      this.updateState();
    }

    /**
     * Update foreign query source.
     * @param {string} id
     * @param {string} name
     * @param {boolean} isDataSourceAlias
     */

  }, {
    key: 'setForeignQuerySource',
    value: function setForeignQuerySource(id, name, isDataSourceAlias) {
      this.isForeignDataObjectAlias = !!isDataSourceAlias;
      this.selectedForeignSourceAlias = id;
      this.foreignQuerySourceName = name;
      this.foreignFieldId = null;
      this.updateState();
    }

    /**
     * Set primary for join field
     * @param  {string} id
     * @param  {string} name
     */

  }, {
    key: 'setJoinField',
    value: function setJoinField(id, name) {
      this.joinFieldId = id;
      this.joinFieldName = name;
      this.updateState();
    }

    /**
     * Set primary for foreign field
     * @param  {string} id
     * @param  {string} name
     */

  }, {
    key: 'setForeignField',
    value: function setForeignField(id, name) {
      this.foreignFieldId = id;
      this.foreignFieldName = name;
      this.updateState();
    }

    /**
     * Clone a new KeyJoinDetail with new Id
     */

  }, {
    key: 'clone',
    value: function clone() {
      var cloneObj = (0, _fp.clone)(this);
      var keyJoin = new ReportDesignerKeyJoinDetail(cloneObj);
      keyJoin.setParentId(cloneObj.parentId);
      keyJoin.newId();
      return keyJoin;
    }

    /**
     * Set delete status.
     */

  }, {
    key: 'delete',
    value: function _delete() {
      this.state = _Izenda.OBJECT_STATE.DELETE;
    }

    /**
     * Set alias
     * @param {any} value
     */

  }, {
    key: 'setAlias',
    value: function setAlias(value) {
      this.alias = value;
      this.updateState();
    }

    /**
     * Set state
     * @param {number} state
     */

  }, {
    key: 'setState',
    value: function setState(state) {
      this.state = state;
    }

    /**
     * Update state
     */

  }, {
    key: 'updateState',
    value: function updateState() {
      // just update state to UPDATE when editing existing item
      // do not update deleted item's state
      this.id && this.state !== _Izenda.OBJECT_STATE.DELETE && this.setState(_Izenda.OBJECT_STATE.UPDATE);
    }

    /**
     * Update hidden status
     * @param {boolean} hidden
     */

  }, {
    key: 'setHidden',
    value: function setHidden(hidden) {
      this.hidden = hidden;
    }

    /**
     * Update key join item value.
     * @param {string} key
     * @param {any} value
     */

  }, {
    key: 'updateKeyJoinItem',
    value: function updateKeyJoinItem(key, value) {
      this[key] = value;
      this.updateState();
    }

    /**
     * Get id of key join
     */

  }, {
    key: 'getId',
    value: function getId() {
      return this.id || this.tempId;
    }

    /**
     * Build and update new id value.
     */

  }, {
    key: 'newId',
    value: function newId() {
      this.id = null;
      this.tempId = (0, _fp.uniqueId)('keyjoin_');
    }

    /**
     * Update parent id.
     * @param {string} parentId
     */

  }, {
    key: 'setParentId',
    value: function setParentId(parentId) {
      this.parentId = parentId;
    }

    /**
     * Set Comparison Operator
     * @param {any} value
     */

  }, {
    key: 'setComparisionOperator',
    value: function setComparisionOperator(value) {
      this.comparisonOperator = value;
      this.markDirty();
      this.updateState();
    }

    /**
     * Set Comparison Value
     * @param {any} value
     */

  }, {
    key: 'setComparisionValue',
    value: function setComparisionValue(value) {
      this.comparisonValue = value;
      this.markDirty();
      this.updateState();
    }

    /**
     * Update Foreign Data Object Alias
     * @param {string} originAlias
     * @param {string} newAlias
     */

  }, {
    key: 'updateForeignDataObjectAlias',
    value: function updateForeignDataObjectAlias(originAlias, newAlias) {
      if (this.isForeignDataObjectAlias && this.selectedForeignSourceAlias === this.originalAliasId + '_' + originAlias) {
        this.selectedForeignSourceAlias = this.originalAliasId + '_' + newAlias;
      }
    }

    /**
     * Update Data Object alias and Foreign Data Object alias
     * @param {string} joinQuerySourceId
     * @param {string} originAlias
     * @param {string} newAlias
     */

  }, {
    key: 'updateAlias',
    value: function updateAlias(joinQuerySourceId, originAlias, newAlias) {
      var originAliasString = this.createAliasString(joinQuerySourceId, originAlias);
      var newAliasString = this.createAliasString(joinQuerySourceId, newAlias);
      if (this.isJoinFieldReady && this.selectedJoinSourceAlias === originAliasString) {
        this.selectedJoinSourceAlias = newAliasString;
      }

      if (this.isForeignFieldReady && this.selectedForeignSourceAlias === originAliasString) {
        this.selectedForeignSourceAlias = newAliasString;
      }
    }

    /**
     * Create a string template for alias
     * @param {string} sourceId
     * @param {string} alias
     */

  }, {
    key: 'createAliasString',
    value: function createAliasString(sourceId, alias) {
      return sourceId + '_' + alias;
    }
  }, {
    key: 'deleted',
    get: function get() {
      return this.state === _Izenda.OBJECT_STATE.DELETE;
    }
  }, {
    key: 'isJoinQuerySourceReady',
    get: function get() {
      return !(0, _fp.isEmpty)(this.joinDataSourceCategoryId);
    }
  }, {
    key: 'isforeignQuerySourceReady',
    get: function get() {
      return !(0, _fp.isEmpty)(this.foreignDataSourceCategoryId);
    }
  }, {
    key: 'isJoinFieldReady',
    get: function get() {
      return !(0, _fp.isEmpty)(this.selectedJoinSourceAlias);
    }
  }, {
    key: 'isForeignFieldReady',
    get: function get() {
      return !(0, _fp.isEmpty)(this.selectedForeignSourceAlias);
    }
  }, {
    key: 'originalAliasId',
    get: function get() {
      if (this.selectedForeignSourceAlias && this.selectedForeignSourceAlias.indexOf('_') >= 0) {
        var underscoreIndex = this.selectedForeignSourceAlias.indexOf('_');
        return this.selectedForeignSourceAlias.substring(0, underscoreIndex);
      }
      return this.selectedForeignSourceAlias;
    }

    /**
     * Populate data for key join
     * (This is intended to populating which is returned from API.)
     * @param {any} detail
     */

  }]);
  return ReportDesignerKeyJoinDetail;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'parentId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isKeyJoin', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'relationshipId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'joinFieldId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'foreignFieldId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'operator', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'joinQuerySourceId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'joinQuerySourceName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'joinDataSourceCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'joinDataSourceCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'joinFieldName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'foreignFieldName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'foreignQuerySourceId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'foreignQuerySourceName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'foreignDataSourceCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'foreignDataSourceCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'joinSourceAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'foreignSourceAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, 'selectedJoinSourceAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, 'selectedForeignSourceAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, 'state', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, 'modified', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, 'dateTimeNow', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class2.prototype, 'validationKey', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class2.prototype, 'position', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class2.prototype, 'level', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class2.prototype, 'comparisonOperator', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class2.prototype, 'comparisonValue', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class2.prototype, 'isForeignDataObjectAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'deleted', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleted'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isJoinQuerySourceReady', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isJoinQuerySourceReady'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isforeignQuerySourceReady', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isforeignQuerySourceReady'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isJoinFieldReady', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isJoinFieldReady'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isForeignFieldReady', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isForeignFieldReady'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'originalAliasId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'originalAliasId'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setJoinDataSourceCategory', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setJoinDataSourceCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setForeignDataSourceCategory', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setForeignDataSourceCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setJoinQuerySource', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setJoinQuerySource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setForeignQuerySource', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setForeignQuerySource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setJoinField', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setJoinField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setForeignField', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setForeignField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clone', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clone'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setAlias', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setAlias'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateKeyJoinItem', [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateKeyJoinItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'newId', [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'newId'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setComparisionOperator', [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setComparisionOperator'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setComparisionValue', [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setComparisionValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateForeignDataObjectAlias', [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateForeignDataObjectAlias'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAlias', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAlias'), _class2.prototype)), _class2)) || _class);
exports.default = ReportDesignerKeyJoinDetail;
module.exports = exports['default'];

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerFilter.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(587);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(34);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(54);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(89);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(588);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(58);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportDesignerFilter = (0, _Izenda8.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(ReportDesignerFilter, [{
    key: 'visibleConfigFields',

    /* common data for filter section */
    get: function get() {
      return (0, _fp.filter)(function (item) {
        return (0, _fp.get)('fieldDetails.visible', item);
      }, this.configFieldList);
    }

    /* Get empty and required param filters */


    // Should not show the cascading changed message when reload

    // unsaved value

  }, {
    key: 'emptyRequiredParamFilters',
    get: function get() {
      return (0, _fp.filter)(function (field) {
        return field.required;
      }, this.emptyParamFilters);
    }

    /* Find filter made from input params with empty value */

  }, {
    key: 'emptyParamFilters',
    get: function get() {
      return (0, _fp.filter)(function (field) {
        var booleanName = _Izenda10.default.OPERATOR_GROUP_KEYS.BOOLEAN;
        var isParameter = field.isParameter,
            dataType = field.dataType,
            value = field.value,
            operatorId = field.operatorId;

        return isParameter && (dataType !== booleanName && (0, _fp.isEmpty)(value) || dataType === booleanName && !operatorId);
      }, this.displayFilterFields);
    }
    /* Find normal filter marked as "Required" and "Not Visible" with empty value */

  }, {
    key: 'emptyNotVisibleRequiredFilter',
    get: function get() {
      var _this = this;

      return (0, _fp.filter)(function (field) {
        return _this.isEmptyRequiredFilter(field) && !field.visible;
      }, this.displayFilterFields);
    }
    /* Find normal filter marked as "Required" and "Visible" with empty value */

  }, {
    key: 'emptyVisibleRequiredFilter',
    get: function get() {
      var _this2 = this;

      return (0, _fp.filter)(function (field) {
        return _this2.isEmptyRequiredFilter(field) && field.visible;
      }, this.displayFilterFields);
    }
  }, {
    key: 'paramFilterFields',
    get: function get() {
      return (0, _fp.filter)({ isParameter: true }, this.displayFilterFields);
    }
  }, {
    key: 'displayFilterFields',
    get: function get() {
      return (0, _fp.filter)(function (field) {
        return field.dataType != _Izenda9.EXCLUDE_FILTER_DATA_TYPE.REF_CURSOR && field.dataType != _Izenda9.EXCLUDE_FILTER_DATA_TYPE.SYS_REFCURSOR && field.state !== _Izenda6.default.OBJECT_STATE.DELETE;
      }, this.filterFields);
    }
  }, {
    key: 'availableFilterFields',
    get: function get() {
      return (0, _fp.filter)(function (_ref) {
        var state = _ref.state;
        return state !== _Izenda6.default.OBJECT_STATE.DELETE;
      }, this.filterFields);
    }
  }, {
    key: 'displayConfigFields',
    get: function get() {
      return (0, _fp.filter)(function (configField) {
        var field = configField.fieldDetails;
        return !(0, _fp.isEqual)(field.dataType, _Izenda9.EXCLUDE_FILTER_DATA_TYPE.REF_CURSOR) && !(0, _fp.isEqual)(field.dataType, _Izenda9.EXCLUDE_FILTER_DATA_TYPE.SYS_REFCURSOR) && field.state !== _Izenda6.default.OBJECT_STATE.DELETE && field.visible;
      }, this.configFieldList);
    }
  }]);

  function ReportDesignerFilter(initData) {
    var isReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    (0, _classCallCheck3.default)(this, ReportDesignerFilter);

    _initDefineProp(this, 'id', _descriptor, this);

    _initDefineProp(this, 'logic', _descriptor2, this);

    _initDefineProp(this, 'visible', _descriptor3, this);

    _initDefineProp(this, 'filterFields', _descriptor4, this);

    _initDefineProp(this, 'configField', _descriptor5, this);

    _initDefineProp(this, 'configFieldList', _descriptor6, this);

    _initDefineProp(this, 'needUpdateResult', _descriptor7, this);

    _initDefineProp(this, 'commonData', _descriptor8, this);

    _initDefineProp(this, 'newestFilter', _descriptor9, this);

    _initDefineProp(this, 'hasCascadingChanged', _descriptor10, this);

    this.showCascadingChangedMessage = true;

    this.showCascadingChangedMessage = !isReload;
    initData && this.populateData(initData);
    this.cleanDirty();
  }

  /**
   * Reset config field to default
   */


  (0, _createClass3.default)(ReportDesignerFilter, [{
    key: 'resetConfigField',
    value: function resetConfigField() {
      this.configField.setFieldDetails(null);
    }

    /**
     * Set field which is set as configuration mode (user can edit its properties)
     * @param {FilterDetails} newField
     */

  }, {
    key: 'setConfigModeToField',
    value: function setConfigModeToField(newField) {
      if (!newField) {
        return this.resetConfigField();
      }

      if ((0, _fp.isEqual)(this.configField.fieldDetails, newField)) {
        // already in config mode, do nothing
        return;
      }

      var currentConfigField = this.configField;

      if (currentConfigField.fieldDetails && currentConfigField.fieldDetails.querySourceFieldId) {
        // update filter value to field details
        currentConfigField.updateFilterValueToField();
        // reset cache filter data
        currentConfigField.resetOperatorSourceDisplay();
      }

      // set newField in config mode
      this.configField.setFieldDetails(newField);
    }

    /**
     * Update configField list
     * @param {Object} subscriptionFilterFields
     * @param {Object} filterSourceData
     * @param {boolean} viewMode
     */

  }, {
    key: 'updateConfigFieldList',
    value: function updateConfigFieldList(subscriptionFilterFields, filterSourceData, viewMode) {
      var _this3 = this;

      filterSourceData = filterSourceData || [];

      var filterFields = this.filterFields;
      this.configFieldList = (0, _fp.map)(function (item) {
        var filterDetailsConfig = new _Izenda12.default(item, _this3.markUpdateResult);
        filterDetailsConfig.commonData = _this3.configField.commonData;

        if (!viewMode) {
          filterDetailsConfig.operatorSourceInfo = (0, _fp.clone)(_this3.configField.operatorSourceInfo);
          if (subscriptionFilterFields && subscriptionFilterFields.length > 0) {
            var fieldDetails = filterDetailsConfig.fieldDetails;
            var subscriptionFilterField = (0, _fp.find)({ filterFieldId: fieldDetails.id }, subscriptionFilterFields);
            if (!(0, _fp.isNil)(subscriptionFilterField)) {
              var value = subscriptionFilterField.value,
                  operatorId = subscriptionFilterField.operatorId,
                  operatorSetting = subscriptionFilterField.operatorSetting,
                  position = subscriptionFilterField.position;

              fieldDetails.value = value;
              fieldDetails.operatorId = operatorId;
              filterDetailsConfig.selectedOperatorId = operatorId;
              fieldDetails.operatorSetting = operatorSetting;
              fieldDetails.position = position;
            }
          }
        }

        return filterDetailsConfig;
      }, filterFields);
    }

    /**
     * populate filter data
     * @param {Object} filterSourceData
     */

  }, {
    key: 'populatedFilterSourceData',
    value: function populatedFilterSourceData(filterSourceData) {
      var _this4 = this;

      var filterFields = this.filterFields;
      filterSourceData = filterSourceData || [];

      this.configFieldList = (0, _fp.map)(function (item) {
        var filterDetailsConfig = new _Izenda12.default(item, _this4.markUpdateResult.bind(_this4));
        filterDetailsConfig.commonData = _this4.configField.commonData;

        var sourceType = filterDetailsConfig.filterInfo.sourceType;
        var filterId = filterDetailsConfig.fieldDetails.id;
        var filterData = (0, _fp.find)({
          filterFieldId: filterId
        }, filterSourceData) || {};
        var operatorSourceValue = (0, _fp.getOr)([], 'data', filterData);
        filterDetailsConfig.populateOperatorSourceValue(sourceType, operatorSourceValue);

        return filterDetailsConfig;
      }, filterFields);
    }

    /**
     * Reset config mode (field for config will be set as null)
     */

  }, {
    key: 'resetConfigMode',
    value: function resetConfigMode() {
      this.setConfigModeToField(null);
    }

    /**
     * Populate data of filter-report (mostly data form API)
     * @param {object} data
     */

  }, {
    key: 'populateData',
    value: function populateData(data) {
      this.id = data.id;
      this.logic = data.logic;
      this.visible = data.visible;
      this.populateFilterList(data.filterFields);
      this.updateFilterInfoForSubReport();
      this.cleanDirty();
    }

    /**
     * Populate data of list of filter-fields (mostly data form API)
     * @param {type} filterList
     */

  }, {
    key: 'populateFilterList',
    value: function populateFilterList(filterList) {
      var _this5 = this;

      filterList = filterList || [];

      filterList = (0, _fp.filter)(function (item) {
        return item.state !== _Izenda6.default.OBJECT_STATE.DELETE;
      }, filterList);

      this.filterFields = filterList.map(function (item) {
        return new _Izenda2.default(item, filterList, _this5.markUpdateResult.bind(_this5));
      });

      // Set filterList for filterDetail
      this.filterFields.forEach(function (filterField) {
        filterField.filterList = _this5.filterFields;
      });

      // Mark the cascading of one field has changed so the designer can show message to notify user
      this.hasCascadingChanged = this.disableCascading();

      // Set field detail for configField
      var configFieldDetails = this.configField.fieldDetails;
      if (!(0, _fp.isEmpty)(configFieldDetails)) {
        var fieldDetail = (0, _fp.find)({ sourceFieldName: configFieldDetails.sourceFieldName }, this.filterFields);
        this.configField.setFieldDetails(fieldDetail);
      }
    }

    /**
     * Set cascading to false when having filter lookup
     * @returns {boolean} The value indicate that at least one cascading value changed
     */

  }, {
    key: 'disableCascading',
    value: function disableCascading() {
      var _this6 = this;

      var filterFieldsToDisable = [];
      var availableItems = (0, _fp.flow)((0, _fp.filter)(function (item) {
        return item.state !== _Izenda6.default.OBJECT_STATE.DELETE;
      }), (0, _fp.orderBy)('position', 'asc'))(this.filterFields);

      availableItems.forEach(function (item, index) {
        var nextItem = availableItems[index + 1];

        // Apply to the field which next filter having valid filter lookup
        if (nextItem && (0, _fp.get)('allowLookup', _this6.configField.getOperatorById(nextItem.operatorId)) && (nextItem.hasValidLookupKey && nextItem.useLookup || nextItem.hasUserDefinedLookup)) {
          filterFieldsToDisable.push(item);
        }
      });

      var hasCascadingChanged = false;
      filterFieldsToDisable.forEach(function (item) {
        return hasCascadingChanged = hasCascadingChanged || item.setDisableCascading(true);
      });
      var filterFieldsToEnable = (0, _fp.difference)(availableItems, filterFieldsToDisable);
      filterFieldsToEnable.forEach(function (item) {
        return item.setDisableCascading(false);
      });

      return hasCascadingChanged;
    }

    /**
     * Populate data of operator group ( to config fitler properties, mostly data form API)
     * @param {type} operatorGroup
     */

  }, {
    key: 'populateOperatorGroup',
    value: function populateOperatorGroup(operatorGroup) {
      this.configField.populateOperatorGroup(operatorGroup);
    }

    /**
     * Populate data of query source (mostly data form API)
     * @param {type} querySource
     */

  }, {
    key: 'populateFilterQuerySource',
    value: function populateFilterQuerySource(querySource) {
      this.commonData.querySource = querySource;
    }

    /**
     * Remove report filter
     * @param {object} details
     */

  }, {
    key: 'removeFilter',
    value: function removeFilter(details) {
      var currentPos = details.position;

      var fieldIndex = (0, _fp.findIndex)(function (item) {
        return item.position === currentPos && item.state !== _Izenda6.default.OBJECT_STATE.DELETE;
      }, this.filterFields);

      if (fieldIndex === -1) return;

      if (this.filterFields[fieldIndex].id === _Izenda6.default.EMPTY_GUID || this.filterFields[fieldIndex].id === null) {
        this.filterFields.splice(fieldIndex, 1);
      } else {
        this.filterFields[fieldIndex].state = _Izenda6.default.OBJECT_STATE.DELETE;
      }
      this.reorderPosition();
      this.markDirty();
      this.markUpdateResult();
    }

    /**
     * Reorder report filter by its index
     * @param {number} startIndex
     */

  }, {
    key: 'reorderPosition',
    value: function reorderPosition() {
      var length = this.filterFields.length;
      var position = 1;

      for (var i = 0; i < length; i++) {
        needToSetPosition(this.filterFields[i]) && (this.filterFields[i].position = position++);
      }

      this.disableCascading();

      function needToSetPosition(filterField) {
        return filterField.state !== _Izenda6.default.OBJECT_STATE.DELETE; // && (!filterField.isParameter);
      }
    }

    /**
     * Update visible value
     * @param {boolean} value
     */

  }, {
    key: 'setVisible',
    value: function setVisible(value) {
      this.visible = value;

      this.markDirty();
      this.markUpdateResult();
    }

    /**
     * Update logic
     * @param {string} value
     */

  }, {
    key: 'setLogic',
    value: function setLogic(value) {
      this.logic = value;
      this.markDirty();
      this.markUpdateResult();
    }

    /**
     * Add filter by its details
     * @param {Object} details
     * @param {number} indexToAddInView
     */

  }, {
    key: 'addFilter',
    value: function addFilter(details, indexToAddInView) {
      details = details || {};
      details.state = _Izenda6.default.OBJECT_STATE.INSERT;
      details.visible = true;
      details.cascading = !details.isParameter;
      details.textColor = _Izenda4.default.textColor;
      details.backgroundColor = _Izenda4.default.backgroundColor;
      details.sortType = 'ASC';
      details.id = null;

      var filterItem = new _Izenda2.default(details, this.filterFields, this.markUpdateResult.bind(this));

      if (!(0, _fp.isNil)(indexToAddInView)) {
        // Find index of the item right before it
        // Add the item with that index + 1
        var indexToAddInList = this.findIndexInFilterListByViewIndex(indexToAddInView - 1) + 1;
        this.filterFields.splice(indexToAddInList, 0, filterItem);
      } else {
        this.filterFields.push(filterItem);
      }
      this.reorderPosition();
      this.markDirty();
      this.markUpdateResult();

      // keep a reference to latest filter which is added to filter-list
      this.newestFilter = filterItem;

      // remove filter value for all cascading filter that exists after this new filter
      if (filterItem.cascading) {
        (0, _fp.flow)((0, _fp.filter)(function (filterSearch) {
          return filterSearch.position > filterItem.position && filterSearch.cascading;
        }), (0, _fp.forEach)((0, _fp.invokeArgs)('updateByKey', ['value', ''])))(this.filterFields);
      }
    }

    /**
     * Load default operator.
     * @param {any} detail
     */

  }, {
    key: 'loadDefaultOperator',
    value: function loadDefaultOperator(detail) {
      var commonData = this.configField.commonData;
      var dataType = detail.dataType || '';
      dataType = dataType.toLowerCase();
      var defaultOperatorGroup = _Izenda10.default.DEFAUFT_OPERATOR_GROUP[dataType];
      var groupByKey = (0, _fp.find)({ key: defaultOperatorGroup }, commonData.operatorGroup) || {};
      if (groupByKey.filterOperators) {
        var group = (0, _fp.find)({ id: groupByKey.id }, commonData.operatorGroup) || {};
        var operators = group.filterOperators || [];
        var isBlankOperator = _Izenda10.default.BLANK_NULL_OPERATOR.indexOf(dataType) > -1;
        var defaultOperator = (0, _fp.head)(operators);
        var operator = void 0;
        if (dataType === _Izenda10.default.DATA_TYPE.TIME.toLowerCase()) {
          operator = (0, _fp.find)({ key: _Izenda10.default.PARAM_OPERATOR_BY_DATA_TYPE.Time[0] }, operators) || defaultOperator;
        } else {
          operator = !isBlankOperator && (0, _fp.find)({ id: group.defaultOperatorId }, operators) || defaultOperator;
        }
        detail.operatorId = operator.id;
        detail.operatorName = operator.name;
      }
    }

    /**
     * Add filter by id, details of field will be search on querySource
     * @param {string} fieldId
     * @param {Object} sourceDataObjectName
     * @param {Object} details
     * @param {number} itemIndex
     */

  }, {
    key: 'addFilterById',
    value: function addFilterById(fieldId, sourceDataObjectName, details, itemIndex) {
      var detailsByQuerySource = this.getFieldDetailsByIdAndSourceDataObjectName(fieldId, sourceDataObjectName) || {};

      detailsByQuerySource = (0, _mobx.toJS)(detailsByQuerySource);
      detailsByQuerySource = (0, _fp.assign)(detailsByQuerySource, details);
      !detailsByQuerySource.operatorId && this.loadDefaultOperator(detailsByQuerySource);

      if (detailsByQuerySource) {
        this.addFilter(detailsByQuerySource, itemIndex);
        this.markDirty();
        this.markUpdateResult();
      }
    }

    /**
     * Add list of filter by id list
     * @param {type} fieldIds
     * @param {type} commonDetails
     */

  }, {
    key: 'addFilterByIds',
    value: function addFilterByIds(fieldIds, commonDetails) {
      var _this7 = this;

      var filterFields = this.filterFields;
      fieldIds = fieldIds || [];

      fieldIds.forEach(function (itemId) {
        !findFilterByQuerySourceFieldId(itemId) && _this7.addFilterById(itemId, null, commonDetails);
      });

      function findFilterByQuerySourceFieldId(querySourceFieldId) {
        return !!(0, _fp.find)(function (item) {
          return item.querySourceFieldId === querySourceFieldId && item.state !== _Izenda14.default.DELETE;
        }, filterFields);
      }
    }

    /**
     * Find in query source to return field details based on fieldId and data source name (if any)
     * @param {string} fieldId
     * @param {string} sourceDataObjectName
     */

  }, {
    key: 'getFieldDetailsByIdAndSourceDataObjectName',
    value: function getFieldDetailsByIdAndSourceDataObjectName(fieldId, sourceDataObjectName) {
      return (0, _fp.find)(function (item) {
        return item.querySourceFieldId === fieldId && (!sourceDataObjectName || item.sourceDataObjectName === sourceDataObjectName);
      }, this.commonData.querySource);
    }

    /**
     * Build data for report saving
     */

  }, {
    key: 'buildDataForSaving',
    value: function buildDataForSaving() {
      var filterFiedls = this.filterFields || [];

      var filterFiedlsData = filterFiedls.map(function (item) {
        return item.getFilterDetails();
      });

      return {
        logic: this.logic,
        visible: this.visible,
        filterFields: filterFiedlsData,
        id: this.id
      };
    }

    /**
     * move filter
     * @param {number} prevIndex
     * @param {number} nextIndex
     */

  }, {
    key: 'moveTo',
    value: function moveTo(prevIndex, nextIndex) {
      if (!(0, _fp.isNumber)(nextIndex)) {
        return;
      }

      var availableFilters = (0, _fp.filter)(function (_ref2) {
        var state = _ref2.state;
        return state !== _Izenda14.default.DELETE;
      }, this.filterFields);
      if (nextIndex < 0 || nextIndex > (0, _fp.size)(availableFilters)) {
        return;
      }

      var firstIndexToSwap = this.findIndexInFilterListByViewIndex(prevIndex);
      var secondIndexToSwap = this.findIndexInFilterListByViewIndex(nextIndex);

      // remove the element from the array
      var movingItem = this.filterFields.splice(firstIndexToSwap, 1);
      (0, _fp.size)(movingItem) && this.filterFields.splice(secondIndexToSwap, 0, (0, _fp.head)(movingItem));

      this.reorderPosition();
      this.markDirty();
      this.markUpdateResult();
    }

    /**
     * Get dirty status.
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      // Check dirty for filterFields.
      var dirtyItems = (0, _fp.filter)(function (item) {
        return item.checkDirty && item.checkDirty();
      }, this.filterFields);

      var configFieldDirty = (0, _fp.some)(['isDirty', true], this.configFieldList);

      return this.isDirty || configFieldDirty || dirtyItems && dirtyItems.length > 0;
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      if (!this.hasCascadingChanged) {
        // clean dirty for filterFields
        (0, _fp.forEach)(function (item) {
          item.cleanDirty && item.cleanDirty();
        }, this.filterFields);

        (0, _fp.forEach)(function (item) {
          item.cleanDirty && item.cleanDirty();
        }, this.configFieldList);

        this.resetDirty();
        this.resetUpdateResult();
      }
    }

    /**
     * Check for Existing Filter
     * @param {Object} value
     * @param {Object} currentObject
     */

  }, {
    key: 'checkExistingFilter',
    value: function checkExistingFilter(value, currentObject) {
      return String.checkDuplicate(value, (0, _fp.without)([currentObject], this.availableFilterFields), (0, _fp.get)('alias'));
    }

    /**
     * Find index of a item in the list by the index of view list
     * @param {Number} viewIndex
     */

  }, {
    key: 'findIndexInFilterListByViewIndex',
    value: function findIndexInFilterListByViewIndex(viewIndex) {
      // Position start from 1, so the item we need to find has position = index + 1 and haven't been deleted
      return (0, _fp.findIndex)(function (_ref3) {
        var state = _ref3.state,
            position = _ref3.position;
        return state !== _Izenda14.default.DELETE && position === viewIndex + 1;
      }, this.filterFields);
    }

    /**
     * Check if this filter use aggregated field
     * @param {Object} field
     * @param {Object} filterDetail
     */

  }, {
    key: 'isFilterUseAggregatedField',
    value: function isFilterUseAggregatedField(field, filterDetail) {
      return filterDetail.reportFieldAlias === field.field.fieldNameAlias && filterDetail.querySourceFieldId === field.fieldId && filterDetail.sourceDataObjectName === _Izenda6.default.FIELD_TYPE.AggregatedField;
    }

    /**
     * Remove AggregatedField
     * @param {Object} field
     */

  }, {
    key: 'removeAggregatedField',
    value: function removeAggregatedField(field) {
      var _this8 = this;

      // Find filter use deleted aggregated field
      this.filterFields = (0, _fp.map)(function (filterDetail) {
        if (_this8.isFilterUseAggregatedField(field, filterDetail)) {
          var details = (0, _fp.clone)(filterDetail);
          details.state = _Izenda6.default.OBJECT_STATE.DELETE;
          details.alias = '';
          details.cascading = !filterDetail.isParameter;
          return new _Izenda2.default(details, _this8.filterFields);
        }
        return filterDetail;
      }, this.filterFields);
    }

    /**
     * Update report part chart title of filter detail which using aggregated field
     * @param {string} oldTitle
     * @param {string} newTitle
     */

  }, {
    key: 'updateAggregatedFieldReportPartTitle',
    value: function updateAggregatedFieldReportPartTitle(oldTitle, newTitle) {
      (0, _fp.forEach)(function (filterDetail) {
        if (filterDetail.reportPartTitle === oldTitle) {
          filterDetail.reportPartTitle = newTitle;
        }
      }, this.filterFields);
    }

    /**
     * Update report field name alias filter detail which using aggregated field
     * @param {string} oldAlias
     * @param {string} newAlias
     * @param {string} reportPartTitle
     */

  }, {
    key: 'updateAggregatedFieldReportFieldAlias',
    value: function updateAggregatedFieldReportFieldAlias(oldAlias, newAlias, reportPartTitle) {
      (0, _fp.forEach)(function (filterDetail) {
        if (filterDetail.reportPartTitle === reportPartTitle && filterDetail.reportFieldAlias === oldAlias) {
          filterDetail.sourceFieldName = newAlias;
          filterDetail.reportFieldAlias = newAlias;
        }
      }, this.filterFields);
    }

    /**
     * Find normal filter marked as "Required" with empty value
     * @param {Object} field
     */

  }, {
    key: 'isEmptyRequiredFilter',
    value: function isEmptyRequiredFilter(field) {
      var isEmptyValue = (0, _fp.isEmpty)((0, _fp.trim)(field.value)) || (0, _fp.includes)('', (0, _fp.split)(';#', field.value));
      return !field.isParameter && field.required && isEmptyValue && this.needCheckOperatorValue(field);
    }

    /**
     * Which operator is need to check it's value
     * @param {Object} field
     */

  }, {
    key: 'needCheckOperatorValue',
    value: function needCheckOperatorValue(field) {
      var operatorName = field.operatorName;
      return operatorName && !(0, _fp.includes)(operatorName, _Izenda9.OPERATOR_NAMES);
    }

    /**
     * Remove filters which related which uncheck DataObject
     * @param {Object} dataObject
     */

  }, {
    key: 'removeFiltersOfUncheckedDataObject',
    value: function removeFiltersOfUncheckedDataObject(dataObject) {
      for (var index = 0; index < this.filterFields.length; index++) {
        var item = this.filterFields[index];
        if (item.querySourceId === dataObject.id && item.state !== _Izenda14.default.DELETE) {
          if (!item.id) {
            this.filterFields.splice(index, 1);
            index--;
          } else {
            item.state = _Izenda14.default.DELETE;
          }
        }
      }
      this.reorderPosition();
    }

    /**
     * Check if report filter use this field
     * @param {Object} field
     */

  }, {
    key: 'isFilterUseCalculatedField',
    value: function isFilterUseCalculatedField(field) {
      return !!(0, _fp.find)(function (filterDetail) {
        return filterDetail.state != _Izenda14.default.DELETE && filterDetail.querySourceType === _Izenda6.default.CALCULATED_FIELD_NAME && filterDetail.sourceFieldName === field.name;
      }, this.filterFields);
    }

    /**
     * Set Dirty
     */

  }, {
    key: 'markUpdateResult',
    value: function markUpdateResult() {
      this.needUpdateResult = true;
    }

    /**
     * Reset Update result
     */

  }, {
    key: 'resetUpdateResult',
    value: function resetUpdateResult() {
      this.needUpdateResult = false;
    }

    /**
     * Update FilterInfo For SubReport
     */

  }, {
    key: 'updateFilterInfoForSubReport',
    value: function updateFilterInfoForSubReport() {
      var format = _Izenda5.FILTER_URL.OVERIDE_MASTER_REPORT_FILTER.FORMAT;
      var useUserLookUp = _Izenda5.FILTER_URL.OVERIDE_MASTER_REPORT_USE_USER_LOOKUP.FORMAT;

      this.filterInfoForSubReport = (0, _fp.reduce)(function (acc, filterDetail) {
        var value = (0, _fp.set)(String.format(format, filterDetail.position), filterDetail.value, acc);
        return (0, _fp.set)(String.format(useUserLookUp, filterDetail.position), filterDetail.useLookup, value);
      }, {}, this.filterFields);
    }
  }]);
  return ReportDesignerFilter;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'logic', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'visible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'filterFields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'configField', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda12.default({}, this.markUpdateResult.bind(this));
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'configFieldList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'needUpdateResult', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'commonData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return { querySource: [] };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'newestFilter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'hasCascadingChanged', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'visibleConfigFields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'visibleConfigFields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'emptyRequiredParamFilters', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'emptyRequiredParamFilters'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'emptyParamFilters', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'emptyParamFilters'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'emptyNotVisibleRequiredFilter', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'emptyNotVisibleRequiredFilter'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'emptyVisibleRequiredFilter', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'emptyVisibleRequiredFilter'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'paramFilterFields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'paramFilterFields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'displayFilterFields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'displayFilterFields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'availableFilterFields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'availableFilterFields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'displayConfigFields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'displayConfigFields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetConfigField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetConfigField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setConfigModeToField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setConfigModeToField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateConfigFieldList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateConfigFieldList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populatedFilterSourceData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populatedFilterSourceData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateFilterList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateFilterList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'disableCascading', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'disableCascading'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateOperatorGroup', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateOperatorGroup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateFilterQuerySource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateFilterQuerySource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeFilter', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeFilter'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reorderPosition', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorderPosition'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setVisible', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setVisible'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setLogic', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setLogic'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addFilter', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addFilter'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadDefaultOperator', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadDefaultOperator'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addFilterById', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addFilterById'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addFilterByIds', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addFilterByIds'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'moveTo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'moveTo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeAggregatedField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeAggregatedField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAggregatedFieldReportPartTitle', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAggregatedFieldReportPartTitle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAggregatedFieldReportFieldAlias', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAggregatedFieldReportFieldAlias'), _class2.prototype)), _class2)) || _class;

exports.default = ReportDesignerFilter;
module.exports = exports['default'];

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor; // ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilteringDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(417);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CrossFilteringDetail = (_class = function CrossFilteringDetail(reportId, reportName, pillDefinitions) {
  (0, _classCallCheck3.default)(this, CrossFilteringDetail);

  _initDefineProp(this, 'pillDefinitions', _descriptor, this);

  this.reportId = reportId;
  this.reportName = reportName;
  this.pillDefinitions = pillDefinitions;
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'pillDefinitions', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
})), _class);
exports.default = CrossFilteringDetail;
module.exports = exports['default'];

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.UserAccountDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      join = _require.join,
      map = _require.map,
      split = _require.split,
      chain = _require.chain,
      isEmpty = _require.isEmpty;

  var m = __webpack_require__(5);
  var routeUtils = __webpack_require__(31);
  var trackable = __webpack_require__(46);
  var constants = __webpack_require__(124);
  var config = __webpack_require__(40);

  function UserAccountDetail(data) {
    var props = {
      id: null,
      systemAdmin: false,
      userName: null,
      password: null,
      tenantId: null,
      emailAddress: null,
      roles: [],
      state: null,
      inserted: null,
      version: null,
      created: null,
      createdBy: null,
      modified: null,
      modifiedBy: null,
      selected: false,
      lastName: null,
      firstName: null,
      fullName: null,
      active: false,
      initPassword: false,
      passwordHash: null,
      passwordSalt: null,
      currentTokenHash: null,
      deleted: false,
      userSecurityQuestions: null,
      userRoles: null,
      dataOffset: 0,
      timestampOffset: 0,
      passwordLink: null,
      failedlogin: false,
      status: null,
      isNew: function isNew() {
        return !this.id;
      },
      inactiveReason: function inactiveReason() {
        return config.Integration && !this.active ? constants.INACTIVE_REASON.INTEGRATION : constants.INACTIVE_REASON[this.status];
      },
      rolesValue: null,
      recipientValue: [],
      clearSercurityQuestion: false,
      sendEmail: false,
      cultureName: 'en-US',
      dateFormat: 'MM/DD/YYYY',
      validateResultRoleAssociation: [],
      formHasErrors: false, // form has errors or not
      hasChangeLanguage: false
    };

    m.extendObservable(trackable(this), props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} user account detail data
   */
  UserAccountDetail.prototype.populateData = m.action(function (data) {
    data = data || {};
    this.id = data.id;
    this.systemAdmin = data.systemAdmin;
    this.userName = data.userName;
    this.tenantId = data.tenantId;
    this.emailAddress = data.emailAddress;
    this.roles = data.roles;
    this.state = data.state;
    this.inserted = data.inserted;
    this.version = data.version;
    this.created = data.created;
    this.createdBy = data.createdBy;
    this.modified = data.modified;
    this.modifiedBy = data.modifiedBy;
    this.lastName = data.lastName;
    this.firstName = data.firstName;
    this.fullName = data.fullName;
    this.active = data.active;
    this.password = data.password;
    this.passwordHash = data.passwordHash;
    this.passwordSalt = data.passwordSalt;
    this.currentTokenHash = data.currentTokenHash;
    this.deleted = data.deleted;
    this.userSecurityQuestions = data.userSecurityQuestions;
    this.userRoles = data.userRoles;
    this.dataOffset = data.dataOffset;
    this.timestampOffset = data.timestampOffset;
    this.initPassword = data.initPassword;
    this.status = data.status;
    this.cultureName = data.cultureName;
    this.dateFormat = data.dateFormat;

    // populate roles
    this.populateRole();
    this.hasChangeLanguage = false;
  });

  /**
   * Update selected user account
   * @param  {boolean} value
   */
  UserAccountDetail.prototype.updateSelected = function (value) {
    this.selected = value;
    this.markDirty();
  };

  /**
   * Check user account dirty or not
   * @return {boolean} result of dirty
   */
  UserAccountDetail.prototype.checkDirty = function () {
    return this.isDirty;
  };
  /**
   * populate Password Link
   * @param  {string} password
   */
  UserAccountDetail.prototype.populatePasswordLink = function (result) {
    if (result.success) {
      var password = result.data;
      var encodePassworkLink = encodeURIComponent(password);
      var urlConfig = routeUtils.getRouteUrl(routeUtils.getConfigRoute('Account', 'Activation'));
      if (urlConfig) {
        this.passwordLink = routeUtils.makeAbsoluteUrl(urlConfig, 'verification=' + encodePassworkLink);
      }
    }

    return result;
  };

  /**
   * update User Active status
   * @param  {boolean} state
   */
  UserAccountDetail.prototype.updateUserActive = function (state) {
    this.active = state;
  };

  /**
   * update User name
   * @param  {string} username
   */
  UserAccountDetail.prototype.updateUserName = function (userName) {
    this.userName = userName;
    this.markDirty();
  };

  /**
   * update First Name
   * @param  {string} firstName
   */
  UserAccountDetail.prototype.updateFirstName = function (firstName) {
    this.firstName = firstName;
    this.markDirty();
  };

  /**
   * update last Name
   * @param  {string} lastName
   */
  UserAccountDetail.prototype.updateLastName = function (lastName) {
    this.lastName = lastName;
    this.markDirty();
  };

  /**
   * update Email Address
   * @param  {string} email
   */
  UserAccountDetail.prototype.updateEmail = function (email) {
    this.emailAddress = email;
    this.markDirty();
  };

  /**
   * add Email Recipient into Password options pop up
   */
  UserAccountDetail.prototype.addEmailRecipient = function () {
    this.emailAddress && this.recipientValue.push({ emailAddress: this.emailAddress });
  };

  /**
   * update Role
   * @param  {string} roles
   */
  UserAccountDetail.prototype.populateRole = function () {
    this.rolesValue = join(',', map('id', this.roles));
  };

  /**
   * update Role
   * @param  {string} roles
   */
  UserAccountDetail.prototype.updateRole = function (roles) {
    this.rolesValue = roles;
    this.markDirty();
  };

  /**
   * update Timezone DataOffset
   * @param  {string} dataOffset
   */
  UserAccountDetail.prototype.updateTimezoneDataOffset = function (dataOffset) {
    this.dataOffset = dataOffset;
    this.markDirty();
  };

  /**
   * update Timezone Timestamp Offset
   * @param  {string} timestampOffset
   */
  UserAccountDetail.prototype.updateTimezoneTimestampOffset = function (timestampOffset) {
    this.timestampOffset = timestampOffset;
    this.markDirty();
  };

  /**
   * get Data For Save
   * @return {object}
   */
  UserAccountDetail.prototype.getDataForSave = m.action(function (configUser) {
    var listRoleSelected = split(',', configUser.rolesValue);
    var userRoles = [];
    listRoleSelected.forEach(function (roleIdItem) {
      userRoles.push({ id: roleIdItem });
    });
    var data = {
      id: configUser.id,
      systemAdmin: configUser.systemAdmin,
      userName: configUser.userName,
      tenantId: configUser.tenantId,
      emailAddress: configUser.emailAddress,
      roles: !configUser.systemAdmin ? userRoles : [],
      state: configUser.state,
      inserted: configUser.inserted,
      version: configUser.version,
      created: configUser.created,
      createdBy: configUser.createdBy,
      modified: configUser.modified,
      modifiedBy: configUser.modifiedBy,
      lastName: configUser.lastName,
      firstName: configUser.firstName,
      fullName: configUser.fullName,
      active: configUser.active,
      password: configUser.password,
      passwordHash: configUser.passwordHash,
      passwordSalt: configUser.passwordSalt,
      currentTokenHash: configUser.currentTokenHash,
      deleted: configUser.deleted,
      userSecurityQuestions: configUser.userSecurityQuestions,
      userRoles: configUser.userRoles,
      dataOffset: configUser.dataOffset,
      timestampOffset: configUser.timestampOffset,
      initPassword: configUser.initPassword,
      status: configUser.status,
      cultureName: configUser.cultureName,
      dateFormat: configUser.dateFormat
    };

    return data;
  });

  /**
   * add Recipients
   * @param {array} userAccountList
   */
  UserAccountDetail.prototype.addRecipients = m.action(function (userAccountList) {
    this.resetRecipientValue();
    this.recipientValue.push(chain(userAccountList).flatMap(function (userAccount) {
      return userAccount.emailAddress;
    }).join(';').value());

    isEmpty(this.recipientValue[0]) && this.resetRecipientValue();
  });

  /**
   * get Recipients
   * @return {array} recipientList
   */
  UserAccountDetail.prototype.getRecipients = m.action(function (userAccountList) {
    this.resetRecipientValue();
    userAccountList.forEach(function (item) {
      item.selected && !isEmpty(item.emailAddress) && this.recipientValue.push({ emailAddress: item.emailAddress });
    }.bind(this));
  });

  /**
   * reset Rcipient Value
   * @return  empty array
   */
  UserAccountDetail.prototype.resetRecipientValue = function () {
    this.recipientValue = [];
  };

  /**
   * reset password link Value
   * @return null value
   */
  UserAccountDetail.prototype.resetPasswordLink = function () {
    this.passwordLink = null;
  };

  /**
   * update Send Email State
   * @param  {boolean} state
   */
  UserAccountDetail.prototype.updateSendEmailState = function (state) {
    this.sendEmail = state;
  };

  /**
   * get Data For Save Password Options
   * @return {object}
   */
  UserAccountDetail.prototype.getDataForSavePasswordOptions = function () {
    var emailAddress = [];
    this.recipientValue && this.recipientValue.forEach(function (item) {
      emailAddress.push(item.emailAddress);
    });
    var data = {
      passwordLink: this.passwordLink,
      user: {
        userName: this.userName,
        id: this.id
      },
      sendEmail: this.sendEmail,
      clearSercurityQuestion: false,
      emailAddresses: emailAddress
    };

    return data;
  };

  /**
   * update Language
   * @param  {string} language
   */
  UserAccountDetail.prototype.updateLanguage = m.action(function (language) {
    this.cultureName = language.value;
    this.hasChangeLanguage = true;
    this.markDirty();
  });

  /**
   * update date format
   * @param  {string} dateFormat
   */
  UserAccountDetail.prototype.updateDateFormat = m.action(function (dateFormat) {
    this.dateFormat = dateFormat.value;
    this.markDirty();
  });

  /**
   * reset Value Time Zone
   * @param  {string} type
   */
  UserAccountDetail.prototype.resetValueTimeZone = m.action(function (type) {
    this[type] = 0;
    this.markDirty();
  });

  /**
   * update formHasErrors
   * @param {Boolean} hasErrors
   */
  UserAccountDetail.prototype.updateFormHasErrors = function (hasErrors) {
    this.formHasErrors = hasErrors;
  };

  /**
   * update Selected System Admin
   * @param  {boolean} value
   */
  UserAccountDetail.prototype.updateSelectedSystemAdmin = m.action(function (value) {
    this.systemAdmin = value;
    this.markDirty();
  });

  /**
   * populate data to show in pop up after validate Role Association
   * @param  {[type]} value [description]
   */
  UserAccountDetail.prototype.populateAfterValidateRoleAssociation = m.action(function (data) {
    this.validateResultRoleAssociation = data;
    this.markDirty();
  });

  module.exports = UserAccountDetail;
}();

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryMetadata.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var extendObservable = __webpack_require__(5).extendObservable;
  var trackable = __webpack_require__(46);
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      uniqueId = _require.uniqueId,
      assign = _require.assign,
      omit = _require.omit;

  function CategoryMetadata(item) {
    var baseObject = {
      key: uniqueId(),
      id: null,
      tenantId: uiState.getTenantId() || null,
      name: '',
      modified: null
    };

    item = assign(baseObject, item || {});

    extendObservable(trackable(this), item);
  }

  /**
   * prepare json object for save request
   * @return {JSON} [description]
   */
  CategoryMetadata.prototype.prepareRequestJSON = function () {
    return omit(['isDirty', 'key'], this);
  };

  module.exports = CategoryMetadata;
}();

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(191);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(90);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2005);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(988);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(591);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(592);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(96);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(155);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(16);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(264);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(58);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(989);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * Izenda Performace View Model
 */
var CalculatedFieldStore = (_class = function () {
  function CalculatedFieldStore() {
    (0, _classCallCheck3.default)(this, CalculatedFieldStore);

    _initDefineProp(this, 'model', _descriptor, this);

    _initDefineProp(this, 'clonedModel', _descriptor2, this);

    _initDefineProp(this, 'expressionSelection', _descriptor3, this);

    this.reportKey = null;

    this.init();
    this.expressionSelection = new _Izenda8.default();
    this.reportKey = null;
  }

  /**
   * init for the first time
   */


  (0, _createClass3.default)(CalculatedFieldStore, [{
    key: 'init',
    value: function init() {
      this.model = new _Izenda6.default();
      this.clonedModel = this.model.clone();
    }

    /**
     * Preview result
     * @param {any} querySourceId
     */

  }, {
    key: 'preview',
    value: function preview(querySourceId) {
      var clonedModel = this.clonedModel;
      var reportKey = this.reportKey;

      var expression = clonedModel.expression,
          izendaDataType = clonedModel.izendaDataType,
          querySourceFieldId = clonedModel.id,
          previewRecord = clonedModel.previewRecord;


      if (reportKey) {
        var data = {
          reportKey: {
            key: reportKey
          },
          expression: expression,
          izendaDataType: izendaDataType,
          querySourceFieldId: querySourceFieldId,
          previewRecord: previewRecord
        };

        return _Izenda4.default.previewDSCalculatedField(data).then(clonedModel.readPreviewResult.bind(clonedModel));
      }

      return _Izenda2.default.previewCalculatedField(querySourceId, expression, izendaDataType, querySourceFieldId).then(clonedModel.readPreviewResult.bind(clonedModel));
    }

    /**
     * Preview Result in Sub Total/Grand Total
     * @param {any} reportDesigner
     * @param {any} reportPart
     */

  }, {
    key: 'previewReportProperties',
    value: function previewReportProperties(reportDesigner, reportPart) {
      var _this = this;

      var clonedModel = this.clonedModel;
      var type = clonedModel.type;


      if (!reportDesigner && !reportPart) {
        return (0, _bluebird.resolve)();
      }

      var configField = this.getConfigFieldInReportDefinition(reportDesigner.getReportDefinition().report, reportPart);
      var calculatedDetail = this.getCalculatedDetail(reportDesigner, reportPart);

      switch (type.name) {
        case _Izenda14.default.TYPES.GRAND_TOTAL.name:
          return _Izenda4.default.previewGrandTotal(calculatedDetail).then(function (result) {
            _this.revertToBackupData(configField);
            return clonedModel.readPreviewResult(result);
          });
        case _Izenda14.default.TYPES.SUB_TOTAL.name:
          return _Izenda4.default.previewSubTotal(calculatedDetail).then(function (result) {
            _this.revertToBackupData(configField);
            return clonedModel.readPreviewResult(result);
          });
        default:
          return (0, _bluebird.resolve)();
      }
    }

    /**
     * revert config field to backup data
     * @param {any} configField
     */

  }, {
    key: 'revertToBackupData',
    value: function revertToBackupData(configField) {
      var backupSubTotal = (0, _fp.cloneDeep)((0, _fp.get)('properties.dataFormattings.subTotal', configField));
      var backupGrandTotal = (0, _fp.cloneDeep)((0, _fp.get)('properties.dataFormattings.grandTotal', configField));

      if (configField) {
        var properties = configField.properties;

        properties.updateSubTotalData(backupSubTotal);
        properties.updateGrandTotalData(backupGrandTotal);
      }
    }

    /**
     * Validate Expression
     * @param {any} querySourceId
     * @param {boolean} noUpdateDataType
     */

  }, {
    key: 'validateExpression',
    value: function validateExpression(querySourceId, noUpdateDataType) {
      var _this2 = this;

      var _clonedModel = this.clonedModel,
          modelQuerySourceId = _clonedModel.querySourceId,
          expression = _clonedModel.expression,
          izendaDataType = _clonedModel.izendaDataType,
          id = _clonedModel.id;

      if (this.reportKey) {
        return this.validateFieldExpression().then(function (result) {
          return _this2.readDataType(result, noUpdateDataType);
        });
      }
      return _Izenda2.default.validateExpression(querySourceId || modelQuerySourceId, expression, izendaDataType, id).then(function (result) {
        return _this2.readDataType(result, noUpdateDataType);
      });
    }

    /**
     * Read data type
     * @param {any} result
     * @param {boolean} noUpdateDataType
     */

  }, {
    key: 'readDataType',
    value: function readDataType(data, noUpdateDataType) {
      var model = this.clonedModel;

      if (!noUpdateDataType) {
        return model.readDataType(data);
      }
      var result = data.result,
          messages = data.messages;

      if (result) {
        model.suggestedDataType = (0, _fp.defaultTo)(null, result.izendaDataType);
        model.validExpression = (0, _fp.isEmpty)(messages);
        model.isRunningField = (0, _fp.defaultTo)(false, result.isRunningField);
        model.isCompositeField = (0, _fp.defaultTo)(false, result.isCompositeField);
        if ((0, _fp.isNil)(model.izendaDataType)) {
          model.izendaDataType = (0, _fp.defaultTo)(null, result.izendaDataType);
        }
        return messages;
      } else {
        return messages;
      }
    }

    /**
     * Validate field expression with report key
     * Validate for Data Model, Add/Edit Calculated Field
     */

  }, {
    key: 'validateFieldExpression',
    value: function validateFieldExpression() {
      var _clonedModel2 = this.clonedModel,
          expression = _clonedModel2.expression,
          izendaDataType = _clonedModel2.izendaDataType,
          querySourceFieldId = _clonedModel2.id,
          previewRecord = _clonedModel2.previewRecord;

      var validateDetail = {
        reportKey: {
          key: this.reportKey
        },
        expression: expression,
        izendaDataType: izendaDataType,
        querySourceFieldId: querySourceFieldId,
        previewRecord: previewRecord
      };

      return _Izenda4.default.validateFieldExpression(validateDetail);
    }

    /**
     * Validate expression with report key for sub total or grand total
     * @param {any} reportDesigner
     * @param {Object} reportPart
     * @param {boolean} noUpdateDataType
     */

  }, {
    key: 'validateExpressionWithReportKey',
    value: function validateExpressionWithReportKey(reportDesigner, reportPart, noUpdateDataType) {
      var _this3 = this;

      if (!reportDesigner && !reportPart) {
        return (0, _bluebird.resolve)();
      }

      var type = this.clonedModel.type;

      var configField = this.getConfigFieldInReportDefinition(reportDesigner.getReportDefinition().report, reportPart);
      var validateDetail = this.getCalculatedDetail(reportDesigner, reportPart);

      if ((0, _fp.isEqual)(type, _Izenda14.default.TYPES.GRAND_TOTAL)) {
        return _Izenda4.default.validateGrandTotalExpression(validateDetail).then(function (data) {
          return _this3.updateDataType(configField, data, noUpdateDataType);
        });
      } else if ((0, _fp.isEqual)(type, _Izenda14.default.TYPES.SUB_TOTAL)) {
        return _Izenda4.default.validateSubTotalExpression(validateDetail).then(function (data) {
          return _this3.updateDataType(configField, data, noUpdateDataType);
        });
      } else {
        return (0, _bluebird.resolve)();
      }
    }

    /**
     * update data type
     * @param {any} configField
     * @param {any} data
     * @param {boolean} noUpdateDataType
     */

  }, {
    key: 'updateDataType',
    value: function updateDataType(configField, data, noUpdateDataType) {
      var model = this.clonedModel;
      this.revertToBackupData(configField);
      !noUpdateDataType && model.readDataType(data);
      return data.messages;
    }

    /**
     * Fill calculated field data to store, usually call this method when a new calculated field added
     * @param selectedDataSource
     * @param dataSource
     * @param functionOperators
     * @param reportKey
     */

  }, {
    key: 'fillCalculatedFieldData',
    value: function fillCalculatedFieldData(selectedDataSource, dataSource, functionOperators, reportKey, fieldNames) {
      this.reportKey = reportKey;
      this.expressionSelection = new _Izenda8.default({
        expressionFieldName: new _Izenda10.default({
          fieldNames: fieldNames,
          selectedDataSource: selectedDataSource,
          dataSources: dataSource
        }),
        expressionFunctionOperators: new _Izenda12.default({
          functionOperators: functionOperators
        })
      });
    }

    /**
     * Get calculated data for validate/preview in Grand Total/Sub Total
     * @param {Object} reportPart
     * @returns {Object}
     */

  }, {
    key: 'getCalculatedDetail',
    value: function getCalculatedDetail(reportDesigner, reportPart) {
      var _clonedModel3 = this.clonedModel,
          type = _clonedModel3.type,
          name = _clonedModel3.name,
          functionName = _clonedModel3.functionName,
          izendaDataType = _clonedModel3.izendaDataType,
          previewResult = _clonedModel3.previewResult,
          format = _clonedModel3.format,
          expression = _clonedModel3.expression,
          id = _clonedModel3.id,
          previewRecord = _clonedModel3.previewRecord;

      var selectedField = reportPart.configField;
      var reportDefinition = reportDesigner.getReportDefinition();
      var report = reportDefinition.report;
      var tenantId = reportDefinition.reportKey.tenantId;

      var isSubTotal = type.title === _Izenda14.default.TYPES.SUB_TOTAL.title;

      var propertiesData = {
        label: name,
        function: functionName,
        expression: functionName === _Izenda14.default.FUNCTION_NAME.EXPRESSION ? expression : '',
        dataType: izendaDataType,
        previewResult: previewResult,
        format: format
      };

      var configField = this.getConfigFieldInReportDefinition(report, reportPart);

      // update new subtotal/grandtotal set on popup
      if (configField) {
        var properties = configField.properties;

        isSubTotal ? properties.updateSubTotalData(propertiesData) : properties.updateGrandTotalData(propertiesData);

        if (reportPart.type === _Izenda18.default.REPORT_PART_TYPE.Form && isSubTotal) {
          var subTotal = (0, _fp.invokeArgs)('getDataValueByKey', ['subTotal'], properties);
          if (!!subTotal.label) {
            subTotal.levels = [''];
            (0, _fp.invokeArgs)('setDataFormatByKey', ['subTotal', subTotal], properties);
          }
        }
      }
      return {
        reportKey: {
          key: this.reportKey,
          tenantId: tenantId
        },
        report: report,
        title: reportPart.headerTitle,
        expression: expression,
        izendaDataType: izendaDataType,
        reportField: selectedField.field,
        querySourceFieldId: id,
        previewRecord: previewRecord
      };
    }

    /**
     * Get config field in report definition
     * @param {Object} reportDefinition
     * @param {Object} reportPart
     */

  }, {
    key: 'getConfigFieldInReportDefinition',
    value: function getConfigFieldInReportDefinition(reportDefinition, reportPart) {
      // Set information for field in report part
      var filteredReportPart = (0, _fp.find)(function (item) {
        return item.state !== _Izenda22.default.DELETE && item.title === reportPart.headerTitle;
      }, reportDefinition.reportPart);
      var reportPartContent = filteredReportPart.reportPartContent;


      var compareField = function compareField(element, reportPart) {
        return (0, _fp.get)('field.fieldId', element) === (0, _fp.get)('configField.field.fieldId', reportPart) && (0, _fp.get)('name', element) === (0, _fp.get)('configField.name', reportPart);
      };
      // Lookup field in columns container
      var configField = (0, _fp.find)(function (ele) {
        return compareField(ele, filteredReportPart);
      }, (0, _fp.get)('columns.elements', reportPartContent));
      // Lookup field in rows container
      if (!configField) {
        configField = (0, _fp.find)(function (ele) {
          return compareField(ele, filteredReportPart);
        }, (0, _fp.get)('rows.elements', reportPartContent));
      }
      // Lookup field in values container (in case of pivot/drilldown grid)
      if (!configField) {
        configField = (0, _fp.find)(function (ele) {
          return compareField(ele, filteredReportPart);
        }, (0, _fp.get)('values.elements', reportPartContent));
      }
      // Lookup field in seperator container
      if (!configField) {
        configField = (0, _fp.find)(function (ele) {
          return compareField(ele, filteredReportPart);
        }, (0, _fp.get)('separators.elements', reportPartContent));
      }

      return configField;
    }

    /**
     * Get format by type
     * @param {any} type
     */

  }, {
    key: 'getFormatsByType',
    value: function getFormatsByType(type) {
      var model = this.clonedModel;
      return _Izenda16.default.loadReportFieldDataFormat(type).then(function (formats) {
        // filter date time format that current user setting can supported
        if (model.izendaDataType === _Izenda17.DATA_TYPES.DATE_TIME) {
          formats = _Izenda20.default.filterDateTimeFormat(formats);
        }

        // Remove format for subtotal or grandtotal popup
        if (model.izendaDataType === _Izenda17.DATA_TYPES.NUMERIC || model.izendaDataType === _Izenda17.DATA_TYPES.MONEY) {
          formats = (0, _fp.remove)(function (format) {
            return (
              // Remove format only on field grid pivot
              ((0, _fp.has)('subTotalProperties', model.type) || (0, _fp.has)('grandTotalProperties', model.type)) && (0, _fp.includes)(format.name, _Izenda24.default.FORMATS_ONLY_ON_PIVOT_GRID_VALUE_CONTAINER) ||
              // Remove subtotal format from grid separator and grand total popup
              ((0, _fp.has)('grandTotalProperties', model.type) || !model.canSetSubtotal) && (0, _fp.includes)(format.name, _Izenda24.default.FORMAT_NOT_AVAILABLE_ON_FIELD_CAN_NOT_SET_SUBTOTAL)
            );
          }, formats);
        }
        model.formats = formats;
        return formats;
      });
    }

    /**
     * clone model
     */

  }, {
    key: 'acceptClonedModel',
    value: function acceptClonedModel() {
      var data = this.clonedModel;
      this.model.populateData(data);
    }
  }]);
  return CalculatedFieldStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'clonedModel', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'expressionSelection', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'init', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'init'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'revertToBackupData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'revertToBackupData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readDataType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readDataType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDataType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateDataType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fillCalculatedFieldData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fillCalculatedFieldData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getFormatsByType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getFormatsByType'), _class.prototype)), _class);
exports.default = CalculatedFieldStore;
module.exports = exports['default'];

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionSelection.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var ExpressionFieldName = __webpack_require__(591);
  var ExpressionFunctionOperator = __webpack_require__(592);

  function ExpressionSelection(data) {

    var props = {
      expressionFieldName: new ExpressionFieldName(),
      expressionFunctionOperators: new ExpressionFunctionOperator()
    };

    m.extendObservable(this, props);

    data && this.fetchData(data);
  }

  /**
   * Populate initial data.
   * @param {ExpressionSelection} data
   */
  ExpressionSelection.prototype.fetchData = m.action(function (data) {
    this.expressionFieldName = data.expressionFieldName;
    this.expressionFunctionOperators = data.expressionFunctionOperators;
  });

  /**
   * Update expression field name
   * @param {ExpressionFieldName} data
   */
  ExpressionSelection.prototype.updateFieldName = function (data) {
    this.expressionFieldName && this.expressionFieldName.fetchData(data);
  };

  /**
   * Get id of selected data source
   */
  ExpressionSelection.prototype.getSelectedDataSourceId = function () {
    this.expressionFieldName && this.expressionFieldName.getSelectedDataSourceId();
  };

  module.exports = ExpressionSelection;
}();

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(16);

exports.default = {
  FORMATS_NOT_AVAILABLE_FOR_RUNNING_FIELD: ['% of Group', '% of Group (with rounding)', '% of Subtotal', '% of Subtotal (with rounding)', '% of Grandtotal', '% of Grandtotal (with rounding)', '% of Sidetotal', '% of Sidetotal (with rounding)'],
  FORMAT_NOT_AVAILABLE_ON_FIELD_CAN_NOT_SET_SUBTOTAL: ['% of Subtotal', '% of Subtotal (with rounding)'],
  FORMATS_NOT_AVAILABLE_FOR_PART_TYPES: {
    partType: [_Izenda.REPORT_PART_TYPE.Chart, _Izenda.REPORT_PART_TYPE.Gauge, _Izenda.REPORT_PART_TYPE.Map],
    formats: ['% of Subtotal', '% of Subtotal (with rounding)', '% of Grandtotal', '% of Grandtotal (with rounding)', '% of Sidetotal', '% of Sidetotal (with rounding)']
  },
  FORMATS_ONLY_ON_PIVOT_GRID_VALUE_CONTAINER: ['% of Sidetotal', '% of Sidetotal (with rounding)']
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.NumericAndMoneyFormatConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 990 */,
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkerConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


exports.default = {
  WORKER_CHUNK: 3
};
module.exports = exports["default"];

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApiInfo = getApiInfo;

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda = __webpack_require__(120);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getApiInfo() {
  var securityManager = new _Izenda2.default();
  return {
    tenantId: _IzendaUiState2.default.tenantId,
    headers: {
      access_token: securityManager.getAccessToken(),
      tenantId: _IzendaUiState2.default.tenantId,
      currentTenantId: _IzendaUiState2.default.currentUser.tenantId
    },
    webApiUrl: _config2.default.WebApiUrl
  };
} // ----------------------------------------------------------------------
// <copyright file="Izenda.WorkerUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

exports.loadRelationship = loadRelationship;
exports.startLoadingRelationship = startLoadingRelationship;
exports.endLoadingRelationship = endLoadingRelationship;
exports.hasRemovedRelationship = hasRemovedRelationship;

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(90);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(585);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(982);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Fetch relationship for simple mode.
 * @param {string} reportId
 * @param {any} selectedQuerySource
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerRelationshipStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Report Designer Relationship Store
 */

function loadRelationshipSimpleMode(selectedQuerySource, pageInfo, reportId) {
  return _Izenda2.default.loadQuerySources(selectedQuerySource, pageInfo, reportId);
}

/**
 * Fetch relationship for advanced mode.
 * @param {string} reportId
 * @param {any} selectedQuerySource
 * @param {any} pageInfo
 * @param {boolean} selectedDataSourceChanged
 * @param {any} dbRelationshipIds
 */
function loadRelationshipAdvancedMode(reportId, selectedQuerySource, pageInfo, selectedDataSourceChanged, dbRelationshipIds) {
  return _Izenda2.default.getRelationships(reportId, selectedQuerySource, pageInfo, dbRelationshipIds, selectedDataSourceChanged);
}

/**
 * Fetch relationship.
 * @param {string} reportId
 * @param {number} reportMode
 * @param {any} selectedQuerySource
 * @param {any} pageInfo
 * @param {boolean} selectedDataSourceChanged
 * @param {any} dbRelationshipIds
 */
function loadRelationship(reportId, reportMode, selectedQuerySource, pageInfo, selectedDataSourceChanged, dbRelationshipIds) {
  var loadRelationshipPromise = reportMode === _Izenda4.default.ADVANCED ? loadRelationshipAdvancedMode(reportId, selectedQuerySource, pageInfo, selectedDataSourceChanged, dbRelationshipIds) : loadRelationshipSimpleMode(selectedQuerySource, pageInfo, reportId);

  function populateRelationships(data) {
    return (0, _fp.map)(function (item) {
      item.relationshipKeyJoins = (0, _fp.map)(function (keyJoin) {
        return new _Izenda8.default(keyJoin);
      }, item.relationshipKeyJoins);
      return new _Izenda6.default(item);
    }, data);
  }

  return loadRelationshipPromise.then(function (dataSourceDetail) {
    reportMode === _Izenda4.default.ADVANCED && (dataSourceDetail.result = populateRelationships(dataSourceDetail.result));
    return dataSourceDetail;
  });
}

/**
 * Start to load relationship.
 * @param {any} dataSourceDetail
 */
function startLoadingRelationship(dataSourceDetail) {
  dataSourceDetail.isLoadingRelationship = true;
  return (0, _bluebird.resolve)();
}

/**
 * End to load relationship.
 * @param {any} dataSourceDetail
 */
function endLoadingRelationship(dataSourceDetail) {
  dataSourceDetail.isLoadingRelationship = false;
  return (0, _bluebird.resolve)();
}

/**
 * Check whether any removed relationship.
 * @param {any} dataTree
 * @param {any} dataSourceGrid
 * @param {any} dataObject
 */
function hasRemovedRelationship(dataTree, dataSourceGrid, dataObject) {
  var selectedQuerySource = dataObject ? dataTree.getDataTreeItems(dataObject) : [];
  var uncheckedItem = (0, _fp.find)(function (item) {
    return item.querySourceId === dataObject.id;
  }, selectedQuerySource);

  uncheckedItem && (uncheckedItem.selected = false);

  var relatedObject = (0, _fp.find)(function (relationship) {
    return (0, _fp.includes)(uncheckedItem.querySourceId, [relationship.joinQuerySourceId, relationship.originalAliasId, relationship.foreignQuerySourceId]);
  }, (0, _mobx.toJS)(dataSourceGrid));

  return !(0, _fp.isEmpty)(relatedObject);
}

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.TimezoneConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * TimezoneConstants
 * Abr: https://en.wikipedia.org/wiki/List_of_time_zone_abbreviations
 */

exports.default = {
  TIMEZONE: [{
    label: '(UTC-12:00) International Date Line West',
    value: 'Dateline Standard Time',
    abr: ['BIT']
  }, {
    label: '(UTC-11:00) Coordinated Universal Time-11',
    value: 'UTC-11',
    abr: ['NUT', 'SST']
  }, {
    label: '(UTC-10:00) Hawaii',
    value: 'Hawaiian Standard Time',
    abr: ['CKT', 'HAST', 'TAHT']
  }, {
    label: '(UTC-09:00) Alaska',
    value: 'Alaskan Standard Time',
    abr: ['HADT', 'GIT', 'GAMT', 'AKST']
  }, {
    label: '(UTC-08:00) Baja California',
    value: 'Pacific Standard Time (Mexico)',
    abr: ['AKDT', 'CIST', 'PST']
  }, { label: '(UTC-08:00) Pacific Time (US & Canada)', value: 'Pacific Standard Time' }, {
    label: '(UTC-07:00) Arizona',
    value: 'US Mountain Standard Time',
    abr: ['MST', 'PDT']
  }, { label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan', value: 'Mountain Standard Time (Mexico)' }, { label: '(UTC-07:00) Mountain Time (US & Canada)', value: 'Mountain Standard Time' }, {
    label: '(UTC-06:00) Central America',
    value: 'Central America Standard Time',
    abr: ['MDT', 'GALT', 'EAST', 'CST']
  }, { label: '(UTC-06:00) Central Time (US & Canada)', value: 'Central Standard Time' }, { label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey', value: 'Central Standard Time (Mexico)' }, { label: '(UTC-06:00) Saskatchewan', value: 'Canada Central Standard Time' }, {
    label: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
    value: 'SA Pacific Standard Time',
    abr: ['ACT', 'CDT', 'COT', 'CST', 'EASST', 'ECT', 'EST', 'PET']
  }, { label: '(UTC-05:00) Chetumal', value: 'Eastern Standard Time (Mexico)' }, { label: '(UTC-05:00) Eastern Time (US & Canada)', value: 'Eastern Standard Time' }, { label: '(UTC-05:00) Indiana (East)', value: 'US Eastern Standard Time' }, { label: '(UTC-04:30) Caracas', value: 'Venezuela Standard Time' }, {
    label: '(UTC-04:00) Asuncion',
    value: 'Paraguay Standard Time',
    abr: ['AMT', 'AST', 'BOT', 'CDT', 'CLT', 'COST', 'ECT', 'EDT', 'FKT', 'GYT', 'PYT', 'VET']
  }, { label: '(UTC-04:00) Atlantic Time (Canada)', value: 'Atlantic Standard Time' }, { label: '(UTC-04:00) Cuiaba', value: 'Central Brazilian Standard Time' }, { label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan', value: 'SA Western Standard Time' }, {
    label: '(UTC-03:30) Newfoundland',
    value: 'Newfoundland Standard Time',
    abr: ['NST', 'NT']
  }, {
    label: '(UTC-03:00) Brasilia',
    value: 'E. South America Standard Time',
    abr: ['ADT', 'AMST', 'ART', 'BRT', 'CLST', 'FKST', 'GFT', 'PMST', 'ROTT', 'SRT', 'UYT']
  }, { label: '(UTC-03:00) Cayenne, Fortaleza', value: 'SA Eastern Standard Time' }, { label: '(UTC-03:00) City of Buenos Aires', value: 'Argentina Standard Time' }, { label: '(UTC-03:00) Greenland', value: 'Greenland Standard Time' }, { label: '(UTC-03:00) Montevideo', value: 'Montevideo Standard Time' }, { label: '(UTC-03:00) Salvador', value: 'Bahia Standard Time' }, { label: '(UTC-03:00) Santiago', value: 'Pacific SA Standard Time' }, {
    label: '(UTC-02:00) Coordinated Universal Time-02',
    value: 'UTC-02',
    abr: ['BRST', 'FNT', 'GST', 'PMDT', 'UYST']
  }, { label: '(UTC-02:00) Mid-Atlantic - Old', value: 'Mid-Atlantic Standard Time' }, {
    label: '(UTC-01:00) Azores',
    value: 'Azores Standard Time',
    abr: ['EGT', 'CVT', 'AZOT']
  }, { label: '(UTC-01:00) Cabo Verde Is.', value: 'Cape Verde Standard Time' }, {
    label: '(UTC) Casablanca',
    value: 'Morocco Standard Time',
    abr: ['AZOST', 'EGST', 'WET']
  }, { label: '(UTC) Coordinated Universal Time', value: 'UTC' }, {
    label: '(UTC) Dublin, Edinburgh, Lisbon, London',
    value: 'GMT Standard Time',
    abr: ['GMT']
  }, { label: '(UTC) Monrovia, Reykjavik', value: 'Greenwich Standard Time' }, {
    label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: 'W. Europe Standard Time',
    abr: ['BST', 'CET', 'DFT', 'IST', 'MET', 'WAT', 'WEST']
  }, { label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', value: 'Central Europe Standard Time' }, { label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', value: 'Romance Standard Time' }, { label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', value: 'Central European Standard Time' }, { label: '(UTC+01:00) West Central Africa', value: 'W. Central Africa Standard Time' }, { label: '(UTC+01:00) Windhoek', value: 'Namibia Standard Time' }, {
    label: '(UTC+02:00) Amman',
    value: 'Jordan Standard Time',
    abr: ['CAT', 'CEST', 'EET', 'HAEC', 'IST', 'MEST', 'SAST', 'USZ1', 'WAST']
  }, { label: '(UTC+02:00) Athens, Bucharest', value: 'GTB Standard Time' }, { label: '(UTC+02:00) Beirut', value: 'Middle East Standard Time' }, { label: '(UTC+02:00) Cairo', value: 'Egypt Standard Time' }, { label: '(UTC+02:00) Damascus', value: 'Syria Standard Time' }, { label: '(UTC+02:00) E. Europe', value: 'E. Europe Standard Time' }, { label: '(UTC+02:00) Harare, Pretoria', value: 'South Africa Standard Time' }, { label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', value: 'FLE Standard Time' }, { label: '(UTC+02:00) Istanbul', value: 'Turkey Standard Time' }, { label: '(UTC+02:00) Jerusalem', value: 'Israel Standard Time' }, { label: '(UTC+02:00) Kaliningrad (RTZ 1)', value: 'Kaliningrad Standard Time' }, { label: '(UTC+02:00) Tripoli', value: 'Libya Standard Time' }, {
    label: '(UTC+03:00) Baghdad',
    value: 'Arabic Standard Time',
    abr: ['AST', 'EAT', 'EEST', 'FET', 'IDT', 'IOT', 'MSK', 'SYOT']
  }, { label: '(UTC+03:00) Kuwait, Riyadh', value: 'Arab Standard Time' }, { label: '(UTC+03:00) Minsk', value: 'Belarus Standard Time' }, { label: '(UTC+03:00) Moscow, St. Petersburg, Volgograd (RTZ 2)', value: 'Russian Standard Time' }, { label: '(UTC+03:00) Nairobi', value: 'E. Africa Standard Time' }, {
    label: '(UTC+03:30) Tehran',
    value: 'Iran Standard Time',
    abr: ['IRST']
  }, {
    label: '(UTC+04:00) Abu Dhabi, Muscat',
    value: 'Arabian Standard Time',
    abr: ['AMT', 'AZT', 'GET', 'GST', 'MUT', 'RET', 'SAMT', 'SCT', 'VOLT']
  }, { label: '(UTC+04:00) Baku', value: 'Azerbaijan Standard Time' }, { label: '(UTC+04:00) Izhevsk, Samara (RTZ 3)', value: 'Russia Time Zone 3' }, { label: '(UTC+04:00) Port Louis', value: 'Mauritius Standard Time' }, { label: '(UTC+04:00) Tbilisi', value: 'Georgian Standard Time' }, { label: '(UTC+04:00) Yerevan', value: 'Caucasus Standard Time' }, {
    label: '(UTC+04:30) Kabul',
    value: 'Afghanistan Standard Time',
    abr: ['AFT', 'IRDT']
  }, {
    label: '(UTC+05:00) Ashgabat, Tashkent',
    value: 'West Asia Standard Time',
    abr: ['HMT', 'MAWT', 'MVT', 'ORAT', 'PKT', 'TFT', 'TJT', 'TMT', 'UZT', 'YEKT']
  }, { label: '(UTC+05:00) Ekaterinburg (RTZ 4)', value: 'Ekaterinburg Standard Time' }, { label: '(UTC+05:00) Islamabad, Karachi', value: 'Pakistan Standard Time' }, {
    label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: 'India Standard Time',
    abr: ['IST', 'SLST']
  }, { label: '(UTC+05:30) Sri Jayawardenepura', value: 'Sri Lanka Standard Time' }, {
    label: '(UTC+05:45) Kathmandu',
    value: 'Nepal Standard Time',
    abr: ['NPT']
  }, {
    label: '(UTC+06:00) Astana',
    value: 'Central Asia Standard Time',
    abr: ['ACT', 'BIOT', 'BST', 'BTT', 'KGT', 'OMST', 'VOST']
  }, { label: '(UTC+06:00) Dhaka', value: 'Bangladesh Standard Time' }, { label: '(UTC+06:00) Novosibirsk (RTZ 5)', value: 'N. Central Asia Standard Time' }, {
    label: '(UTC+06:30) Yangon (Rangoon)',
    value: 'Myanmar Standard Time',
    abr: ['CCT', 'MMT']
  }, {
    label: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    value: 'SE Asia Standard Time',
    abr: ['CXT', 'DAVT', 'HOVT', 'ICT', 'KRAT', 'THA', 'WIT']
  }, { label: '(UTC+07:00) Krasnoyarsk (RTZ 6)', value: 'North Asia Standard Time' }, {
    label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    value: 'China Standard Time',
    abr: ['AWST', 'BDT', 'CHOT', 'CIT', 'CST', 'CT', 'HKT', 'HOVST', 'IRKT', 'PST', 'WST']
  }, { label: '(UTC+08:00) Irkutsk (RTZ 7)', value: 'North Asia East Standard Time' }, {
    label: '(UTC+08:00) Kuala Lumpur, Singapore',
    value: 'Singapore Standard Time',
    abr: ['MST', 'MYT', 'SGT', 'SST']
  }, { label: '(UTC+08:00) Perth', value: 'W. Australia Standard Time' }, { label: '(UTC+08:00) Taipei', value: 'Taipei Standard Time' }, {
    label: '(UTC+08:00) Ulaanbaatar',
    value: 'Ulaanbaatar Standard Time',
    abr: ['ULAT']
  }, { label: '(UTC+08:30) Pyongyang', value: 'North Korea Standard Time' }, {
    label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    value: 'Tokyo Standard Time',
    abr: ['CHOST', 'EIT', 'JST', 'KST', 'TLT', 'ULAST', 'YAKT']
  }, { label: '(UTC+09:00) Seoul', value: 'Korea Standard Time' }, { label: '(UTC+09:00) Yakutsk (RTZ 8)', value: 'Yakutsk Standard Time' }, {
    label: '(UTC+09:30) Adelaide',
    value: 'Cen. Australia Standard Time',
    abr: ['ACST', 'ACST']
  }, { label: '(UTC+09:30) Darwin', value: 'AUS Central Standard Time' }, {
    label: '(UTC+10:00) Brisbane',
    value: 'E. Australia Standard Time',
    abr: ['CHST', 'CHUT', 'DDUT', 'PGT', 'VLAT']
  }, {
    label: '(UTC+10:00) Canberra, Melbourne, Sydney',
    value: 'AUS Eastern Standard Time',
    abr: ['AEST']
  }, { label: '(UTC+10:00) Guam, Port Moresby', value: 'West Pacific Standard Time' }, { label: '(UTC+10:00) Hobart', value: 'Tasmania Standard Time' }, { label: '(UTC+10:00) Magadan', value: 'Magadan Standard Time' }, { label: '(UTC+10:00) Vladivostok, Magadan (RTZ 9)', value: 'Vladivostok Standard Time' }, {
    label: '(UTC+11:00) Chokurdakh (RTZ 10)',
    value: 'Russia Time Zone 10',
    abr: ['AEDT', 'BST', 'AEDT', 'KOST', 'LHST', 'MIST', 'NCT', 'NFT', 'PONT', 'SAKT', 'SBT', 'SRET', 'VUT']
  }, { label: '(UTC+11:00) Solomon Is., New Caledonia', value: 'Central Pacific Standard Time' }, {
    label: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky (RTZ 11)',
    value: 'Russia Time Zone 11',
    abr: ['GILT', 'MAGT', 'MHT', 'NZST', 'PETT', 'TVT', 'WAKT']
  }, { label: '(UTC+12:00) Auckland, Wellington', value: 'New Zealand Standard Time' }, { label: '(UTC+12:00) Coordinated Universal Time+12', value: 'UTC+12' }, {
    label: '(UTC+12:00) Fiji',
    value: 'Fiji Standard Time',
    abr: ['FJT']
  }, { label: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', value: 'Kamchatka Standard Time' }, {
    label: "(UTC+13:00) Nuku'alofa",
    value: 'Tonga Standard Time',
    abr: ['NZDT', 'PHOT', 'TKT', 'TOT']
  }, { label: '(UTC+13:00) Samoa', value: 'Samoa Standard Time' }, {
    label: '(UTC+14:00) Kiritimati Island',
    value: 'Line Islands Standard Time',
    abr: ['LINT']
  }]
};
module.exports = exports['default'];

/***/ }),
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectWithoutProperties2 = __webpack_require__(214);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _Izenda = __webpack_require__(459);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _highmaps = __webpack_require__(2024);

var _highmaps2 = _interopRequireDefault(_highmaps);

var _Izenda3 = __webpack_require__(49);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.HighmapVizEngine.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// It must export proj4 into global as it is using by highmap to convert
// the lon/lat point into actuall map position in order to properly draw bubble on the map
window.proj4 = __webpack_require__(2025);

/**
 * An implementation of viz engine using Highmap.
 * This viz engine is only used for rendering the Map
 */
var HighmapVizEngine = (_dec = (0, _Izenda3.exportClass)('HighmapVizEngine'), _dec(_class = (_temp = _class2 = function (_VizEngine) {
  (0, _inherits3.default)(HighmapVizEngine, _VizEngine);

  function HighmapVizEngine() {
    (0, _classCallCheck3.default)(this, HighmapVizEngine);
    return (0, _possibleConstructorReturn3.default)(this, (HighmapVizEngine.__proto__ || (0, _getPrototypeOf2.default)(HighmapVizEngine)).apply(this, arguments));
  }

  (0, _createClass3.default)(HighmapVizEngine, [{
    key: 'draw',


    /**
     * Draw visualization into container and return instance with releasing function
     * @param {DOMElement} chartContainer DOM element of virtualization
     * @param {string} chartType Chart type
     * @param {Object} options Chart options
     * @param {Function} onCompleted A callback function to be invoked after finished rendering
     */
    value: function draw(chartContainer, chartType, _ref, onCompleted) {
      var _this2 = this;

      var applyPointOptionsColor = _ref.applyPointOptionsColor,
          bubbleSeries = _ref.bubbleSeries,
          activePointOption = _ref.activePointOption,
          seriesConfig = _ref.seriesConfig,
          options = (0, _objectWithoutProperties3.default)(_ref, ['applyPointOptionsColor', 'bubbleSeries', 'activePointOption', 'seriesConfig']);

      // Log options for troubleshooting in DEV mode
      false && this.logHighchartOptions(options);

      var callback = function callback(map) {
        drawBubbleAfterRender(map, bubbleSeries, activePointOption, seriesConfig, applyPointOptionsColor);

        _this2.afterRender(map);

        onCompleted(map);
      };

      // Draw map
      var mapInstance = new _highmaps2.default.Map(chartContainer, options, callback);

      return {
        mapInstance: mapInstance,
        destroy: function destroy() {
          mapInstance && mapInstance.hasRendered && mapInstance.destroy();
        }
      };
    }

    /**
     * Call after render
     * @param {Object} map Highmap map instance
     */

  }, {
    key: 'afterRender',
    value: function afterRender(map) {}
  }]);
  return HighmapVizEngine;
}(_Izenda2.default), _class2.VisualizationLibrary = _highmaps2.default, _temp)) || _class);
exports.default = HighmapVizEngine;


function drawBubbleAfterRender(map, bubbleSeries, activePointOption, seriesConfig, applyPointOptionsColor) {
  // 1. find map range
  var mapRange = findMapRange(map);
  var checkLat = (0, _fp.curry)((0, _fp.inRange)(mapRange.min[0], mapRange.max[0]));
  var checkLon = (0, _fp.curry)((0, _fp.inRange)(mapRange.min[1], mapRange.max[1]));

  // 2. remove points which do not belong to showing-geo-background
  var latlonPoint = void 0;
  var addingSeries = (0, _fp.filter)(function (serie) {
    serie.data = (0, _fp.filter)(function (point) {
      if ((0, _fp.has)('lat', point) && (0, _fp.has)('lon', point)) {
        // draw point based on lat/lon
        latlonPoint = map.fromLatLonToPoint(point);
        return checkLat(latlonPoint.x) && checkLon(latlonPoint.y);
      } else {
        // draw point based on geo-json
        return true;
      }
    }, serie.data);

    return !!(0, _fp.size)(serie.data);
  }, bubbleSeries);

  // 3. apply cell-color of point-options
  activePointOption && applyPointOptionsColor(addingSeries, activePointOption, seriesConfig);

  // 4. add & redraw bubble-series
  var numSeries = (0, _fp.size)(addingSeries);
  var index = 0;

  while (index < numSeries - 1) {
    map.addSeries(addingSeries[index], false);
    index++;
  }

  map.addSeries((0, _fp.last)(addingSeries), true);
}

function findMapRange(map) {
  var mapRange = { min: [], max: [] };

  (0, _fp.each)(function (axis) {
    mapRange.min[axis.isXAxis ? 0 : 1] = axis.min;
    mapRange.max[axis.isXAxis ? 0 : 1] = axis.max;
  }, map.axes);

  return mapRange;
}
module.exports = exports['default'];

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// ----------------------------------------------------------------------
// <copyright file="Izenda.HighchartVizNames.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  Highchart: 'Highchart',
  Highmap: 'Highmap'
};
module.exports = exports['default'];

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Metrics.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var Panel = __webpack_require__(28);
  var classnames = __webpack_require__(11);
  var Button = __webpack_require__(30);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      omit = _require.omit;

  var propsType = {
    dataSource: React.PropTypes.array.required,
    itemComponent: React.PropTypes.element.required,
    onAddMetric: React.PropTypes.func,
    onDeleteMetric: React.PropTypes.func,
    maximumMetrics: React.PropTypes.number,
    canAdd: React.PropTypes.bool,
    canDelete: React.PropTypes.bool,
    isExpanded: React.PropTypes.bool
  };

  var Metrics = React.createClass({
    displayName: 'Metrics',

    propsType: propsType,

    getDefaultProps: function getDefaultProps() {
      return {
        dataSource: [],
        isExpanded: true,
        canAdd: true,
        canDelete: true
      };
    },

    createMetric: function createMetric(item, index) {
      var handleDelete = function () {
        var props = this.props;
        props.onDeleteMetric && props.onDeleteMetric(index);
      }.bind(this);

      var headerComponent = function (props) {
        var classes = classnames('pull-right', { 'disabled-elm': !this.props.canDelete });
        var hint = props.isExpanded ? localizer.getText('COMMON_LABEL_COLLAPSE') : localizer.getText('COMMON_LABEL_EXPAND');
        return React.createElement(
          'div',
          { className: 'left-header-metric' },
          React.createElement(
            'div',
            { className: 'inline-block', onClick: props.collapseToggle },
            React.createElement('i', { title: hint, className: 'icon-toggle' }),
            React.createElement(
              'span',
              { className: 'panel-title' },
              [localizer.getText('COMMON_LABEL_METRIC'), index + 1].join(' ')
            )
          ),
          React.createElement(
            'a',
            { title: localizer.getText('COMMON_LABEL_DELETE'), className: classes, onClick: handleDelete },
            React.createElement('span', { className: 'icon-cancel' })
          )
        );
      }.bind(this);

      var header = {
        component: headerComponent
      };

      var props = this.props;
      var itemProps = omit((0, _keys2.default)(propsType), props);
      return React.createElement(
        Panel,
        { key: index, header: header, collapsible: true, initState: props.isExpanded },
        React.createElement(props.itemComponent, (0, _extends3.default)({}, itemProps, { value: item, index: index }))
      );
    },

    render: function render() {
      var props = this.props;
      var dataSource = props.dataSource;
      var classes = classnames('metrics', props.className);

      var handleAddMetric = function () {
        if (!props.canAdd) return;
        if (props.maximumMetrics) {
          dataSource.length < props.maximumMetrics && props.onAddMetric && props.onAddMetric();
          return;
        }
        props.onAddMetric && props.onAddMetric();
      }.bind(this);

      var isAddButtonDisabled = !props.canAdd || dataSource.length >= props.maximumMetrics;
      return React.createElement(
        'div',
        { className: classes },
        dataSource.map(this.createMetric),
        React.createElement(
          'div',
          { className: 'metrics-footer' },
          React.createElement(Button, {
            disabled: isAddButtonDisabled,
            className: 'pull-right',
            label: localizer.getText('COMPONENT_CONTROL_LABEL_ADD_METRIC'),
            onClick: handleAddMetric
          })
        )
      );
    }
  });

  module.exports = Metrics;
}();

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGaugeValueDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGaugeValueDetails model
 */
!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      find = _require.find,
      isNil = _require.isNil,
      get = _require.get,
      nth = _require.nth,
      values = _require.values,
      has = _require.has,
      reduce = _require.reduce;

  var setValue = __webpack_require__(223);
  var trackable = __webpack_require__(46);
  var CONSTANTS = __webpack_require__(221);
  var THRESHOLD_SETTINGS = CONSTANTS.THRESHOLD_SETTINGS;
  var THRESHOLD_VALUES = CONSTANTS.THRESHOLD_VALUES;
  var ReportPartElement = __webpack_require__(270);
  function ReportPartGaugeValueDetails(initData) {
    var props = {
      scale: {
        from: null,
        to: null
      },
      unitLabel: '',
      thresholds: {
        setting: '',
        levels: []
      },
      supplementaryKPI: {
        valueType: '',
        unitLabel: '',
        value: null,
        element: null
      },

      isStaticSupKPI: function isStaticSupKPI() {
        return this.supplementaryKPI.valueType === THRESHOLD_SETTINGS.STATIC.value;
      },

      isStaticThreshold: function isStaticThreshold() {
        return this.thresholds.setting === THRESHOLD_SETTINGS.STATIC.value;
      }
    };

    m.extendObservable(trackable(this), props);
    initData && this.updateData(initData);

    this.cleanDirty();
  }

  /**
   * Update value of data formating
   * @param  {object} newVal
   * @return {null}
   */
  ReportPartGaugeValueDetails.prototype.updateData = m.action(function (newVal) {
    // scale
    setValue(this.scale, 'from', get('scale.from', newVal));
    setValue(this.scale, 'to', get('scale.to', newVal));

    // unit label
    setValue(this, 'unitLabel', get('unitLabel', newVal));

    // thresholds
    setValue(this.thresholds, 'setting', get('thresholds.setting', newVal));
    this.setThresholdSettingLevels(get('thresholds.levels', newVal));

    // supplementaryKPI
    setValue(this.supplementaryKPI, 'valueType', get('supplementaryKPI.valueType', newVal));
    setValue(this.supplementaryKPI, 'unitLabel', get('supplementaryKPI.unitLabel', newVal));
    setValue(this.supplementaryKPI, 'value', get('supplementaryKPI.value', newVal));

    // convert supplementaryKPI element JSON to Report Part Element
    var supplementaryKPIElement = this.supplementaryKPI.element;
    if (supplementaryKPIElement) {
      supplementaryKPIElement.readData(get('supplementaryKPI.element', newVal));
    } else {
      var newElement = new ReportPartElement();
      var supplementaryKPIData = get('supplementaryKPI.element', newVal);

      supplementaryKPIData && newElement.readData(supplementaryKPIData) && setValue(this.supplementaryKPI, 'element', newElement);
    }

    this.markDirty();
  });

  /**
   * Get dirty status.
   */
  ReportPartGaugeValueDetails.prototype.checkDirty = function () {
    return this.isDirty;
  };

  /**
   * Clean dirty status.
   */
  ReportPartGaugeValueDetails.prototype.cleanDirty = function () {
    this.resetDirty();
  };

  /**
   * Set supplementary KPI,
   * Sup-KPI = static > value is number
   * Sup-KPI = dynamic > value is field
   * @param  {any} newValue
   * @return {undefined}
   */
  ReportPartGaugeValueDetails.prototype.setSupKpiValue = function (newValue) {
    var supplementaryKPI = this.supplementaryKPI;
    var isStatic = this.isStaticSupKPI;

    supplementaryKPI[isStatic ? 'value' : 'element'] = newValue && newValue.value ? newValue.value : newValue;
  };

  /**
   * Set threshold setting levels
   * @param {object} newVal
   */
  ReportPartGaugeValueDetails.prototype.setThresholdSettingLevels = m.action(function (levels) {
    var createReportPartElement = function createReportPartElement(data) {
      var element = new ReportPartElement();
      element.readData(data);
      return element;
    };
    var thresholdLevels = !isNil(levels) ? levels.map(function (level) {
      level.elementUpper && (level.elementUpper = createReportPartElement(level.elementUpper));
      level.element && (level.element = createReportPartElement(level.element));
      return level;
    }) : [];

    setValue(this.thresholds, 'levels', m.observable(thresholdLevels));
  });

  /**
   * set threshold value
   * @param {Boolean} isThresholdValue
   * @param {object}  thresholdData
   * @param {string}  dataKey
   * @param {any}  dataVal
   * @param {Boolean} isUpperBound
   * @param {object}  settingInfo
   */
  ReportPartGaugeValueDetails.prototype.setThresholdValue = function (isThresholdValue, thresholdData, dataKey, dataVal, isUpperBound, settingInfo) {
    var thresholds = this.thresholds;
    var thresholdName = thresholdData.name;
    var isStatic = this.isStaticThreshold;

    dataKey = dataKey || getValueKey(isStatic, isUpperBound);

    m.transaction(function () {
      // TODO apply logic to each change of threshold
      thresholdData[dataKey] = dataVal;

      if (!isThresholdValue) {
        return;
      }

      switch (thresholdName) {
        case THRESHOLD_VALUES.LOW.value:
          setThresholdVal('TARGET', dataVal);
          break;
        case THRESHOLD_VALUES.TARGET.value:
          setThresholdVal(isUpperBound ? 'HIGH' : 'LOW', dataVal, !isUpperBound);
          break;
        case THRESHOLD_VALUES.HIGH.value:
          setThresholdVal('TARGET', dataVal, true);
          break;
        default:
        // do nothing
      }

      this.markDirty();
    }.bind(this));

    function setThresholdVal(thresholdKey, value, isUpperBound) {
      thresholdKey = THRESHOLD_VALUES[thresholdKey].value;

      var threshold = find({
        name: thresholdKey
      }, thresholds.levels) || {};
      var fieldKey = getValueKey(isStatic, isUpperBound);

      threshold[fieldKey] = value;
    }

    function getValueKey(isStatic, isUpperBound) {
      return (isStatic ? 'value' : 'element') + (isUpperBound ? 'Upper' : '');
    }
  };

  /**
   * set threshold setting
   * @param {number|object} newVal
   */
  ReportPartGaugeValueDetails.prototype.setThresholdSetting = function (newVal) {
    var thresholds = this.thresholds;

    m.transaction(function () {
      switch (newVal) {
        case THRESHOLD_SETTINGS.STATIC.value:
        case THRESHOLD_SETTINGS.DYNAMIC.value:
          thresholds.levels = initThresholdValues.call(this);
          break;
        default:
          thresholds.levels = [];
      }

      thresholds.setting = newVal;

      this.markDirty();
    }.bind(this));

    /**
     * init data for threshold item
     * @return {[type]} [description]
     */
    function initThresholdValues() {
      return values(CONSTANTS.THRESHOLD_VALUES).map(function (thresholdInfo) {
        return {
          name: thresholdInfo.value,
          color: thresholdInfo.defautColor,
          operator: thresholdInfo.defautOperator,
          value: null,
          valueUpper: null,
          element: null,
          elementUpper: null
        };
      });
    }
  };

  /**
   * Reset scale data: scale from & scale to
   */
  ReportPartGaugeValueDetails.prototype.resetScaleData = function () {
    m.transaction(function () {
      this.scale.from = this.scale.to = null;

      this.markDirty();
    }.bind(this));
  };

  /**
   * Reset supplementary KPI setting
   */
  ReportPartGaugeValueDetails.prototype.resetSupplementaryKPISetting = function () {
    this.setSupplementaryKPISetting();
  };

  /**
   * set supplementary KPI setting
   * @param {objct} newVal
   */
  ReportPartGaugeValueDetails.prototype.setSupplementaryKPISetting = function (newVal) {
    var supplementaryKPI = this.supplementaryKPI;
    var SuppSettings = CONSTANTS.SUPP_SETTINGS;

    newVal = newVal || '';

    m.transaction(function () {
      switch (newVal) {
        case SuppSettings.STATIC:
          supplementaryKPI.element = {};
          break;

        case SuppSettings.DYNAMIC:
          supplementaryKPI.value = null;
          break;

        default:
          supplementaryKPI.unitLabel = '';
          supplementaryKPI.value = null;
          supplementaryKPI.element = null;
      }

      supplementaryKPI.valueType = newVal;

      this.markDirty();
    }.bind(this));
  };

  /**
   * set value based on key
   * @param  {string} keyPath
   * @param  {any} newVal
   * @return {undefined}
   */
  ReportPartGaugeValueDetails.prototype.setDataByKey = function (keyPath, newVal) {
    if (!has(keyPath)) {
      return;
    }

    m.transaction(function () {
      var paths = keyPath.split('.');
      var changedKey = paths.pop();
      var des = this;

      des = reduce(function (des, path) {
        des = des[path];
        return des;
      }, des, paths);

      des[changedKey] = newVal;

      this.markDirty();
    }.bind(this));
  };

  /**
   * return threshold by range
   * @return {object}
   */
  ReportPartGaugeValueDetails.prototype.getThresholdByRange = function () {
    var from, to;

    var thresholdsByRange = [];

    this.thresholds.levels.forEach(function (thresold) {
      from = thresold.value || thresold.element;
      to = thresold.valueUpper || thresold.elementUpper;

      if (from || to) {
        thresholdsByRange.push({
          from: from,
          to: to,
          color: thresold.color
        });
      }
    });
    return thresholdsByRange;
  };

  /**
   * Validation threshold value
   * @param  {string} fieldValidation
   * @return {object}
   */
  ReportPartGaugeValueDetails.prototype.validateThreshold = function (fieldValidation) {
    var thresholds = this.thresholds;
    var levels = thresholds.levels;

    var low = get('valueUpper', nth(0, levels));
    var high = get('value', nth(2, levels));
    var scaleFrom = get('scale.from', this);
    var scaleTo = get('scale.to', this);

    var messageLow = [];
    var messageHigh = [];
    var messageFrom = [];
    var messageTo = [];

    // Validate value of low threshold with high threshold
    if (!isNil(low) && !isNil(high) && low >= high) {
      messageLow.push(CONSTANTS.Message.M01);
      messageHigh.push(CONSTANTS.Message.M01);
    }
    // Validate value of low threshold with scale to
    if (!isNil(low) && !isNil(scaleTo) && low > scaleTo) {
      messageLow.push(CONSTANTS.Message.M04);
      messageTo.push(CONSTANTS.Message.M04);
    }
    // Validate value of high threshold with scale from
    if (!isNil(high) && !isNil(scaleFrom) && scaleFrom > high) {
      messageHigh.push(CONSTANTS.Message.M04);
      messageFrom.push(CONSTANTS.Message.M04);
    }
    // Validate value of low threshold with scale from
    if (!isNil(low) && !isNil(scaleFrom) && scaleFrom > low) {
      messageLow.push(CONSTANTS.Message.M04);
      messageFrom.push(CONSTANTS.Message.M04);
    }
    // Validate value of high threshold with scale to
    if (!isNil(high) && !isNil(scaleTo) && high > scaleTo) {
      messageTo.push(CONSTANTS.Message.M04);
      messageHigh.push(CONSTANTS.Message.M04);
    }

    switch (fieldValidation) {
      case 'low':
        if (messageLow.length > 0) return { key: '', messages: messageLow };
        break;
      case 'high':
        if (messageHigh.length > 0) return { key: '', messages: messageHigh };
        break;
      case 'from':
        if (messageFrom.length > 0) return { key: fieldValidation, messages: messageFrom };
        break;
      case 'to':
        if (messageTo.length > 0) return { key: fieldValidation, messages: messageTo };
        break;
    }
  };

  module.exports = ReportPartGaugeValueDetails;
}();

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps; // ----------------------------------------------------------------------
// <copyright file="Izenda.DebouncedInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DebouncedInput = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DebouncedInput, _Component);

  function DebouncedInput(props) {
    (0, _classCallCheck3.default)(this, DebouncedInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DebouncedInput.__proto__ || (0, _getPrototypeOf2.default)(DebouncedInput)).call(this, props));

    _initialiseProps.call(_this);

    var onChangeValue = props.onChangeValue,
        value = props.value;


    _this.state = {
      input: value
    };

    _this.onChangeWithDebounce = (0, _fp.debounce)(_Izenda.DEFAULT_DEBOUNCE_TIME, function (input) {
      onChangeValue(input);
    });
    return _this;
  }

  (0, _createClass3.default)(DebouncedInput, [{
    key: 'render',
    value: function render() {
      var input = this.state.input;
      var disabled = this.props.disabled;


      return _react2.default.createElement('input', { className: 'form-control', type: 'text', value: input, onChange: this.handleInputChange, disabled: disabled });
    }
  }]);
  return DebouncedInput;
}(_react.Component), _class.propTypes = {
  onChangeValue: _react.PropTypes.func.isRequired,
  disabled: _react.PropTypes.bool
}, _class.defaultProps = {
  disabled: false
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleInputChange = function (e) {
    e.persist();
    var value = e.target.value;


    _this2.setState({ input: value });
    _this2.onChangeWithDebounce(value);
  };
}, _temp);
exports.default = DebouncedInput;
module.exports = exports['default'];

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartBackgroundColorSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * ChartBackgroundColorSettings Component
 */
!function () {
  var React = __webpack_require__(0);
  var m = __webpack_require__(5);
  var UIConstants = __webpack_require__(34);
  var ChartSettingsContainer = __webpack_require__(193);
  var ENTIRE_CHART_MODE = 'entireChart';
  var PLOT_AREA_MODE = 'plotArea';
  var localizer = __webpack_require__(12);

  var ChartBackgroundColorSettings = React.createClass({
    displayName: 'ChartBackgroundColorSettings',

    /**
     * Get inittial state
     */
    getInitialState: function getInitialState() {
      var props = this.props;
      this.allChartProps = m.toJS(props.allChartProps);
      var value = props && props.value || {};
      return {
        backgroundColor: value['izEntire.backgroundColor'] || value['izPlot.backgroundColor'] || UIConstants.backgroundColor,
        appliedTo: value['izPlot.backgroundColor'] ? PLOT_AREA_MODE : ENTIRE_CHART_MODE
      };
    },

    /**
     * Handle changed value of background color setting compponent
     * @param  {object} schemaData schema data
     */
    onChangeValue: function onChangeValue(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
      var groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
      var fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      this.setState({
        backgroundColor: schemaData.backgroundColor.value,
        appliedTo: schemaData.appliedTo.value
      });
    },

    /**
     * Get value of background color component
     */
    getValue: function getValue() {
      var state = this.state;
      var isAppliedEntire = this.checkAppliedToMode(this.state.appliedTo);
      return {
        'izEntire.backgroundColor': isAppliedEntire ? state.backgroundColor : null,
        'izPlot.backgroundColor': isAppliedEntire ? null : state.backgroundColor
      };
    },

    /**
     * Check background color setting for entire or plot
     * @param  {string} value
     */
    checkAppliedToMode: function checkAppliedToMode(value) {
      return value === ENTIRE_CHART_MODE;
    },

    /**
     * Render background color setting component
     * @return {Object}  react component
     */
    render: function render() {
      var state = this.state;
      var isAppliedEntire = this.checkAppliedToMode(this.state.appliedTo);
      this.allChartProps = this.allChartProps;

      var chartOptions = {
        commonOptions: {
          'izEntire.backgroundColor': isAppliedEntire ? state.backgroundColor : null,
          'izPlot.backgroundColor': isAppliedEntire ? null : state.backgroundColor
        }
      };

      var configurationDef = {
        definedSchema: getSchema.bind(this)(),
        source: state,
        onChangeValue: this.onChangeValue
      };

      return React.createElement(ChartSettingsContainer, {
        type: this.props.reportPartType,
        configurationDef: configurationDef,
        chartOptions: chartOptions,
        allChartProps: this.allChartProps
      });

      /**
       * Define background color component schema
       * @return {object} background component schema
       */
      function getSchema() {
        return {
          schemaKey: 'BACKGROUND_COLOR_SCHEMA',
          fields: {
            // color
            backgroundColor: {
              title: localizer.getText('COMMON_LABEL_COLOR'),
              type: 'color'
            },
            // applied to
            appliedTo: {
              title: localizer.getText('REPORTDESIGNER_TOOLTIP_APPLIED_TO'),
              component: __webpack_require__(2040),
              value: this.state.appliedTo,
              props: {
                options: [{ label: localizer.getText('REPORTDESIGNER_LABEL_ENTIRE_CHART'), value: ENTIRE_CHART_MODE }, { label: localizer.getText('REPORTDESIGNER_LABEL_PLOT_AREA'), value: PLOT_AREA_MODE }]
              }
            }
          }
        };
      }
    }
  });

  module.exports = ChartBackgroundColorSettings;
}();

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _desc2, _value2, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _class5;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartLegendSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(193);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(39);

var _Izenda4 = __webpack_require__(33);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(105);

var _Izenda7 = __webpack_require__(34);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(12);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(411);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(190);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(1107);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var WIDGET = {
  Font: _Izenda12.default,
  Thickness: _Izenda14.default,
  DebouncedInput: _Izenda16.default
};
var FONT_STYLE = _Izenda3.CHART_SETTINGS.FONT_STYLE;

var UNUSED_LEGEND_CHART_PROPS = ['title', 'titleFont', 'layout'];

var Title = (_class = function () {
  function Title(detail) {
    (0, _classCallCheck3.default)(this, Title);

    _initDefineProp(this, 'text', _descriptor, this);

    _initDefineProp(this, 'style', _descriptor2, this);

    this.update(detail);
  }

  (0, _createClass3.default)(Title, [{
    key: 'update',
    value: function update(_ref) {
      var text = _ref.text,
          style = _ref.style;

      this.text = text;
      this.style = style;
    }
  }]);
  return Title;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'text', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'style', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'update', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'update'), _class.prototype)), _class);
var Legend = (_class3 = function () {
  function Legend(detail) {
    (0, _classCallCheck3.default)(this, Legend);

    _initDefineProp(this, 'visible', _descriptor3, this);

    _initDefineProp(this, 'borderVisible', _descriptor4, this);

    _initDefineProp(this, 'horizontalAlign', _descriptor5, this);

    _initDefineProp(this, 'verticalAlign', _descriptor6, this);

    _initDefineProp(this, 'borderColor', _descriptor7, this);

    _initDefineProp(this, 'borderWidth', _descriptor8, this);

    _initDefineProp(this, 'font', _descriptor9, this);

    _initDefineProp(this, 'title', _descriptor10, this);

    _initDefineProp(this, 'layout', _descriptor11, this);

    _initDefineProp(this, 'backgroundColor', _descriptor12, this);

    this.title = new Title({});
    this.update(detail);
  }

  (0, _createClass3.default)(Legend, [{
    key: 'update',
    value: function update(_ref2) {
      var visible = _ref2.visible,
          title = _ref2.title,
          horizontalAlign = _ref2.horizontalAlign,
          verticalAlign = _ref2.verticalAlign,
          layout = _ref2.layout,
          backgroundColor = _ref2.backgroundColor,
          borderVisible = _ref2.borderVisible,
          borderColor = _ref2.borderColor,
          borderWidth = _ref2.borderWidth,
          font = _ref2.font;

      this.visible = visible;
      this.title.update(title);
      this.horizontalAlign = horizontalAlign;
      this.verticalAlign = verticalAlign;
      this.layout = layout;
      this.backgroundColor = backgroundColor;
      this.borderVisible = borderVisible;
      this.borderColor = borderColor;
      this.borderWidth = borderWidth;
      this.font = font;
    }
  }]);
  return Legend;
}(), (_descriptor3 = _applyDecoratedDescriptor(_class3.prototype, 'visible', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'borderVisible', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'horizontalAlign', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, 'verticalAlign', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, 'borderColor', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, 'borderWidth', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, 'font', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, 'title', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, 'layout', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class3.prototype, 'backgroundColor', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class3.prototype, 'update', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'update'), _class3.prototype)), _class3);

var ChartLegendSettings = (0, _mobxReact.observer)(_class5 = function (_Component) {
  (0, _inherits3.default)(ChartLegendSettings, _Component);

  function ChartLegendSettings(props) {
    (0, _classCallCheck3.default)(this, ChartLegendSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChartLegendSettings.__proto__ || (0, _getPrototypeOf2.default)(ChartLegendSettings)).call(this, props));

    _this.getValue = function () {
      var _this$model = _this.model,
          visible = _this$model.visible,
          borderVisible = _this$model.borderVisible,
          horizontalAlign = _this$model.horizontalAlign,
          verticalAlign = _this$model.verticalAlign,
          borderColor = _this$model.borderColor,
          borderWidth = _this$model.borderWidth,
          font = _this$model.font,
          title = _this$model.title,
          layout = _this$model.layout,
          backgroundColor = _this$model.backgroundColor;

      var nonWidth = 0;
      return {
        'izLegend.visibility': visible,
        'izLegend.horizontalAlign': horizontalAlign,
        'izLegend.verticalAlign': verticalAlign,
        'izLegend.borderColor': borderColor,
        'izLegend.borderWidth': visible && borderVisible ? borderWidth : nonWidth,
        'izLegend.fontStyling': font,
        'izLegend.title': title,
        'izLegend.layout': layout,
        'izLegend.backgroundColor': backgroundColor
      };
    };

    _this.getConfigurationDef = function () {
      var that = _this;
      var _this$model2 = _this.model,
          visible = _this$model2.visible,
          borderVisible = _this$model2.borderVisible,
          title = _this$model2.title,
          _this$model2$title = _this$model2.title,
          text = _this$model2$title.text,
          style = _this$model2$title.style,
          horizontalAlign = _this$model2.horizontalAlign,
          verticalAlign = _this$model2.verticalAlign,
          layout = _this$model2.layout,
          borderColor = _this$model2.borderColor,
          borderWidth = _this$model2.borderWidth,
          font = _this$model2.font;


      var getSchema = function getSchema() {
        return {
          schemaKey: 'LEGEND_SETTINGS',
          fields: {
            visible: {
              title: _Izenda10.default.getText('COMMON_LABEL_VISIBLE'),
              type: 'checkbox',
              fnValue: 'getVisible',
              controlClassName: 'u_controlHeight'
            },
            title: {
              title: _Izenda10.default.getText('COMMON_LABEL_TITLE'),
              component: 'DebouncedInput',
              fnValue: 'getTitle',
              props: {
                disabled: !visible,
                onChangeValue: 'handleChangeTitle'
              }
            },
            titleFont: {
              title: _Izenda10.default.getText('FONT_SETTINGS_LABEL_FONT'),
              component: 'Font',
              fnValue: 'getTitleFont',
              titleClassName: 'izenda-Legend-TitleFont',
              props: {
                disabled: !visible
              },
              staticProps: {
                showBackgroundColor: false
              }
            },
            horizontalAlignment: {
              title: _Izenda10.default.getText('REPORTDESIGNER_LABEL_HORIZONTAL_ALIGNMENT'),
              type: 'select',
              fnValue: 'getHorizontalAlignment',
              props: {
                options: _Izenda5.default.getOptions('HORIZONTAL_ALIGN'),
                defaultValue: _Izenda5.default.DefaultConfig.LEGEND_HORIZONTAL_ALIGNMENT,
                disabled: !visible
              }
            },
            verticalAlignment: {
              title: _Izenda10.default.getText('REPORTDESIGNER_LABEL_VERTICAL_ALIGNMENT'),
              type: 'select',
              fnValue: 'getVerticalAlignment',
              props: {
                options: _Izenda5.default.getOptions('VERTICAL_ALIGN'),
                defaultValue: _Izenda5.default.DefaultConfig.LEGEND_VERTICAL_ALIGNMENT,
                disabled: !visible
              }
            },
            layout: {
              title: 'Layout',
              type: 'select',
              fnValue: 'getLayout',
              props: {
                options: _Izenda5.default.getOptions('LAYOUT_ALIGN'),
                defaultValue: _Izenda5.default.DefaultConfig.LEGEND_LAYOUT_ALIGNMENT,
                disabled: !visible
              }
            },
            border: {
              title: _Izenda10.default.getText('REPORTDESIGNER_LABEL_BORDER'),
              type: 'checkbox',
              fnValue: 'getBorderVisible',
              controlClassName: 'u_controlHeight',
              props: {
                checked: borderVisible,
                disabled: !visible
              }
            },
            color: {
              title: _Izenda10.default.getText('COMMON_LABEL_COLOR'),
              titleClassName: 'izenda-Legend-BorderColor',
              type: 'color',
              fnValue: 'getColor',
              props: {
                disabled: !borderVisible || !visible
              }
            },
            thickness: {
              title: _Izenda10.default.getText('BORDER_SETTING_LABEL_THICKNESS'),
              component: 'Thickness',
              titleClassName: 'izenda-Legend-Thickness',
              fnValue: 'getThickness',
              props: {
                disabled: !borderVisible || !visible
              }
            },
            font: {
              title: _Izenda10.default.getText('FONT_SETTINGS_LABEL_FONT'),
              component: 'Font',
              fnValue: 'getFont',
              props: {
                disabled: !visible
              }
            }
          }
        };
      };

      var constructFont = function constructFont(font) {
        font = font || {};
        return {
          style: {
            fontBold: font.fontWeight === FONT_STYLE.BOLD,
            fontItalic: font.fontStyle === FONT_STYLE.ITALIC,
            fontUnderline: font.textDecoration === FONT_STYLE.UNDERLINE
          },
          format: {
            fontFamily: font.fontFamily || _Izenda8.default.defaultFontFamily,
            fontSize: font.fontSize || _Izenda8.default.defaultFontSize
          },
          color: font.color || _Izenda3.CHART_SETTINGS.DEFAULT_VALUE.BLACK_COLOR,
          backgroundColor: font.backgroundColor || _Izenda8.default.backgroundColor
        };
      };

      var chartType = _this.props.chartType;
      var schema = getSchema();
      // Remove unused props if we're configuring for chart
      if (!(0, _fp.find)(function (type) {
        return chartType === type;
      }, (0, _fp.values)(_Izenda6.MAP_TYPES))) {
        schema.fields = (0, _fp.omit)(UNUSED_LEGEND_CHART_PROPS, schema.fields);
      }

      return {
        definedSchema: schema,
        widgets: WIDGET,
        source: {},
        mappingSource: {
          getVisible: function getVisible() {
            return visible;
          },
          getTitle: function getTitle() {
            return text;
          },
          getTitleFont: function getTitleFont() {
            return constructFont(style);
          },
          getHorizontalAlignment: function getHorizontalAlignment() {
            return horizontalAlign;
          },
          getVerticalAlignment: function getVerticalAlignment() {
            return verticalAlign;
          },
          getLayout: function getLayout() {
            return layout;
          },
          getBorderVisible: function getBorderVisible() {
            return borderVisible;
          },
          getColor: function getColor() {
            return borderColor;
          },
          getThickness: function getThickness() {
            return borderWidth;
          },
          getFont: function getFont() {
            return constructFont(font);
          }
        },
        mappingProps: {
          handleChangeTitle: function handleChangeTitle(value) {
            var newTitle = (0, _fp.merge)(title, { text: value });
            that.model.title = newTitle;
          }
        },
        onChangeValue: _this.onChangeValue
      };
    };

    _this.onChangeValue = function (schemaData, changedKey, changedKeyPath, changedValue) {
      var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
      var fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      // Don't update Map every times text in title changed
      if (changedKey === 'title') {
        return;
      }

      function constructLegendStyle(font) {
        font = font || {};
        var style = font.style || {};
        var format = font.format || {};
        var fontSize = format.fontSize;

        return {
          fontWeight: style.fontBold ? FONT_STYLE.BOLD : '',
          fontStyle: style.fontItalic ? FONT_STYLE.ITALIC : '',
          textDecoration: style.fontUnderline ? FONT_STYLE.UNDERLINE : '',
          fontSize: fontSize + 'px',
          fontFamily: format.fontFamily,
          color: font.color,
          backgroundColor: font.backgroundColor
        };
      }

      var font = schemaData.font.value;
      var visible = schemaData.visible.value;
      var borderVisible = visible && schemaData.border.value;
      var title = {
        text: (0, _fp.get)('title.value', schemaData),
        style: constructLegendStyle((0, _fp.get)('titleFont.value', schemaData))
      };
      _this.model.update({
        visible: visible,
        title: title,
        horizontalAlign: schemaData.horizontalAlignment.value,
        verticalAlign: schemaData.verticalAlignment.value,
        layout: (0, _fp.get)('layout.value', schemaData),
        backgroundColor: (0, _fp.get)('backgroundColor', font),
        borderVisible: borderVisible,
        borderColor: schemaData.color.value,
        borderWidth: schemaData.thickness.value,
        font: constructLegendStyle(font)
      });
    };

    _this.init();
    return _this;
  }

  (0, _createClass3.default)(ChartLegendSettings, [{
    key: 'init',
    value: function init() {
      var value = this.props.value || {};
      var visible = value['izLegend.visibility'] || false;
      var borderColor = value['izLegend.borderColor'];
      var borderWidth = value['izLegend.borderWidth'];
      var title = value['izLegend.title'];
      this.model = new Legend({
        visible: visible,
        title: {
          text: (0, _fp.get)('text', title),
          style: (0, _fp.getOr)({}, 'style', title)
        },
        horizontalAlign: value['izLegend.horizontalAlign'] || _Izenda5.default.DefaultConfig.LEGEND_HORIZONTAL_ALIGNMENT,
        verticalAlign: value['izLegend.verticalAlign'] || _Izenda5.default.DefaultConfig.LEGEND_VERTICAL_ALIGNMENT,
        layout: value['izLegend.layout'] || _Izenda5.default.DefaultConfig.LEGEND_LAYOUT_ALIGNMENT,
        backgroundColor: value['izLegend.backgroundColor'],
        borderVisible: visible && !!borderWidth,
        borderColor: borderColor || _Izenda3.CHART_SETTINGS.DEFAULT_VALUE.BLACK_COLOR,
        borderWidth: borderWidth || _Izenda3.CHART_SETTINGS.DEFAULT_VALUE.WIDTH,
        font: value['izLegend.fontStyling']
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _model = this.model,
          visible = _model.visible,
          borderVisible = _model.borderVisible,
          title = _model.title,
          horizontalAlign = _model.horizontalAlign,
          verticalAlign = _model.verticalAlign,
          layout = _model.layout,
          borderColor = _model.borderColor,
          borderWidth = _model.borderWidth,
          font = _model.font,
          backgroundColor = _model.backgroundColor;


      var chartOptions = {
        commonOptions: {
          'izLegend.visibility': visible,
          'izLegend.horizontalAlign': horizontalAlign,
          'izLegend.verticalAlign': verticalAlign,
          'izLegend.borderColor': visible && borderVisible ? borderColor : undefined,
          'izLegend.borderWidth': visible && borderVisible ? borderWidth : undefined,
          'izLegend.fontStyling': font,
          'izLegend.title': title,
          'izLegend.layout': layout,
          'izLegend.backgroundColor': backgroundColor
        }
      };

      return _react2.default.createElement(_Izenda2.default, {
        className: 'legend-settings',
        type: this.props.reportPartType,
        configurationDef: this.getConfigurationDef(),
        chartOptions: chartOptions,
        allChartProps: this.props.allChartProps
      });
    }
  }]);
  return ChartLegendSettings;
}(_react.Component)) || _class5;

exports.default = ChartLegendSettings;
module.exports = exports['default'];

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DynamicThresholdGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(44);

var _Izenda2 = __webpack_require__(596);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(2);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(30);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(29);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(17);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(2046);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(169);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(109);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(597);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(2047);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(23);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(2048);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _Izenda26 = __webpack_require__(33);

var _Izenda27 = __webpack_require__(34);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _mobx = __webpack_require__(5);

var _Izenda29 = __webpack_require__(1111);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _Izenda31 = __webpack_require__(562);

var _Izenda32 = _interopRequireDefault(_Izenda31);

var _Izenda33 = __webpack_require__(39);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ValidateInput = (0, _Izenda23.default)()(_Izenda11.default);
var ValidateAddFieldSetting = (0, _Izenda23.default)()(_Izenda25.default);
var TABLE_DEF = _Izenda19.default.DYNAMIC_TABLE_DEF;
var TABLE_CONTAINER_STYLE = _Izenda19.default.TABLE_CONTAINER_STYLE;
var THRESHOLD_TABLE_HEIGHT = 170;

var DynamicThresholdGrid = (_dec = (0, _Izenda5.default)(_Izenda21.default), _dec(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(DynamicThresholdGrid, _Component);

  function DynamicThresholdGrid() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DynamicThresholdGrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DynamicThresholdGrid.__proto__ || (0, _getPrototypeOf2.default)(DynamicThresholdGrid)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'sortDirs', _descriptor, _this), _this.renderType = function (data) {
      /**
       * change threshold type value
       */
      var onChange = function onChange(e) {
        data.updateThresholdType(e.value);
        data.updateValue(null);
        data.clearDynamicValue();
      };

      return _react2.default.createElement(_Izenda9.default, {
        labelField: 'label',
        valueField: 'value',
        options: _Izenda19.default.THRESLOD_TYPE,
        value: data.thresholdType,
        onChange: onChange
      });
    }, _this.renderMetric = function (data) {
      var options = _this.props.options;

      /**
       * Change metric value
       */

      var onChange = function onChange(e) {
        data.updateFieldMappingAlias(e.value);
        _this.onChangeSettingValue();
      };

      return _react2.default.createElement(_Izenda9.default, {
        labelField: 'label',
        value: data.fieldMappingAlias,
        valueField: 'value',
        options: options,
        onChange: onChange
      });
    }, _this.onClosing = function () {
      _this.props.onReject();
    }, _this.renderLabel = function (data, key, rowIndex) {
      var props = _this.props;
      var rowKey = rowIndex + props.axis;

      var constraints = {
        presence: function presence() {
          return {
            presence: true,
            message: _Izenda19.default.MESSAGE.M06
          };
        }
      };

      var openPopup = function openPopup() {
        props.openPopup(_Izenda13.default, {
          onChange: onChangeLabelSetting,
          value: data.labelSetting
        });
      };

      var updateLabel = function updateLabel(e) {
        data.updateLabel(e.target.value);
        _this.onChangeSettingValue();
      };

      var onChangeLabelSetting = function onChangeLabelSetting(e) {
        data.updateLabelSetting(e.value);
        _this.onChangeSettingValue();
      };

      var className = data.thresholdType !== 'dynamic' ? 'label-input' : '';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(ValidateInput, {
            field: rowKey,
            group: rowIndex + key,
            validations: constraints,
            className: 'form-control',
            onChange: updateLabel,
            value: data.label
          })
        ),
        data.thresholdType !== 'dynamic' && _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', { className: 'icon-setting', onClick: openPopup })
        )
      );
    }, _this.onChangeSettingValue = function () {
      _this.props.onChange({ value: _this.props.thresholdData }, _Izenda33.ContainerName.DYNAMIC_THRESHOLD);
    }, _this.renderValue = function (data, key, rowIndex) {
      var _this2 = _this,
          props = _this2.props,
          _this2$props = _this2.props,
          options = _this2$props.options,
          reportPartContent = _this2$props.reportPartContent,
          dataTree = _this2$props.dataTree;

      var currentXAxis = (0, _fp.find)(function (axis) {
        return axis.value === data.fieldMappingAlias;
      }, options);
      var rowKey = rowIndex + _this.props.axis;

      var constraints = {
        presence: function presence() {
          return {
            presence: true,
            message: _Izenda19.default.MESSAGE.M05
          };
        }
      };

      var onOk = function onOk(changeData) {
        props.addDynamicThreholdsField(data, changeData);
      };

      var onChangeInput = function onChangeInput(e) {
        if (!String.isPatternFormat(e.target.value, _Izenda19.default.NUMBER_REGEX)) {
          return;
        }
        data.updateValue(e.target.value);
        _this.onChangeSettingValue(true);
      };

      var onChangeDateTime = function onChangeDateTime(value) {
        data.updateValue(value);
        _this.onChangeSettingValue(true);
      };

      if (data.thresholdType === 'dynamic') {
        return _react2.default.createElement(ValidateAddFieldSetting, {
          openPopup: props.openPopup,
          localization: props.localization,
          dataTree: dataTree,
          field: rowKey,
          group: rowIndex + key,
          validations: constraints,
          reportPartContent: reportPartContent,
          onOk: onOk,
          value: data.value,
          data: data
        });
      } else {
        return currentXAxis && !(0, _fp.isNil)(currentXAxis.dateTimeFormatData) ? _react2.default.createElement(_Izenda32.default, {
          groupByDateTime: (0, _fp.get)('dateTimeFormatData.groupBy', currentXAxis),
          onChange: onChangeDateTime,
          value: data.value
        }) : _react2.default.createElement(ValidateInput, {
          field: rowKey,
          group: rowIndex + key,
          validations: constraints,
          className: 'form-control',
          onChange: onChangeInput,
          value: data.value
        });
      }
    }, _this.renderDashStyle = function (data) {
      var props = _this.props;

      var onChange = function onChange(changeData) {
        props.onChangeDashType(data, changeData);
      };

      return _react2.default.createElement(_Izenda3.default, { value: data.dashStyle, onChange: onChange });
    }, _this.renderColor = function (data) {
      var onChange = function onChange(e) {
        data.updateColor(e);
        _this.onChangeSettingValue();
      };
      return _react2.default.createElement(_Izenda15.default, { color: data.color, onChange: onChange });
    }, _this.renderThickness = function (data) {
      var onChange = function onChange(value) {
        data.updateThickness(value);
        _this.onChangeSettingValue();
      };
      return _react2.default.createElement(
        'div',
        { className: 'input-group' },
        _react2.default.createElement(_Izenda17.default, {
          min: _Izenda28.default.borderWidthMin,
          max: _Izenda28.default.borderWidthMax,
          onChange: onChange,
          value: data.thickness
        }),
        _react2.default.createElement(
          'span',
          { className: 'input-group-addon' },
          'px'
        )
      );
    }, _this.renderVisible = function (data, key, rowIndex) {
      var onChange = function onChange(e) {
        data.updateVisible(e.target.checked);
        _this.onChangeSettingValue();
      };
      return _react2.default.createElement(ValidateInput, {
        group: rowIndex + key,
        type: 'checkbox',
        onChange: onChange,
        checked: data.visible,
        value: data.visible
      });
    }, _this.renderAction = function (data, key, rowIndex) {
      var _this3 = _this,
          props = _this3.props,
          localization = _this3.props.localization;

      var deleteFn = props.deleteThreshold.bind(null, rowIndex);
      var copyFn = props.copyThreshold.bind(null, rowIndex);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', {
            title: localization.getText('REPORTDESIGNER_LABEL_COPY_SETTING'),
            className: 'icon-copy',
            onClick: copyFn
          })
        ),
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', {
            title: localization.getText('REPORTDESIGNER_LABEL_DELETE_SETTING'),
            className: 'icon-cancel',
            onClick: deleteFn
          })
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Render column type of threshold ( dynamic - static)
   */


  /**
   * Render column type of threshold ( dynamic - static)
   */


  /**
   * Close popup
   */

  /**
   * Render threshold label
   */


  /**
   * Apply change setting
   */


  /**
   * Render value
   */


  /**
   * Render dash style
   */


  /**
   * Render dash style
   */


  /**
   * Render dash style
   */


  /**
   * Render visible threshold column
   */


  /**
   * Render action column
   */


  (0, _createClass3.default)(DynamicThresholdGrid, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          staticThreshold = _props.staticThreshold,
          thresholdData = _props.thresholdData,
          chartType = _props.chartType;

      var renderDynamic = !(0, _Izenda33.isChartType)(chartType, _Izenda26.CHART_TYPE.Scatter, _Izenda26.CHART_TYPE.Bubble) && !staticThreshold;

      return _react2.default.createElement(
        'section',
        { style: TABLE_CONTAINER_STYLE },
        _react2.default.createElement(
          _Izenda.Table,
          {
            dataSource: thresholdData,
            onSortChange: this.props.onSortChange,
            draggableTable: false,
            sortInfo: this.sortDirs,
            minHeight: THRESHOLD_TABLE_HEIGHT,
            maxHeight: THRESHOLD_TABLE_HEIGHT
          },
          renderDynamic && _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['type'], { cell: this.renderType })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['field'], { cell: this.renderMetric })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['label'], { cell: this.renderLabel })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['value'], { cell: this.renderValue })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['dashStyle'], { cell: this.renderDashStyle })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['color'], { cell: this.renderColor })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['thickness'], { cell: this.renderThickness })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['visible'], { cell: this.renderVisible })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['action'], { cell: this.renderAction }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-12 text-right add-setting' },
            _react2.default.createElement(_Izenda7.default, { label: localization.getText('COMMON_LABEL_ADD_SETTING'), onClick: this.props.addNewThreshold })
          )
        )
      );
    }
  }]);
  return DynamicThresholdGrid;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'sortDirs', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
})), _class2)) || _class);
exports.default = DynamicThresholdGrid;
module.exports = exports['default'];

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ThresholdsDataObject.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(597);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(54);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(960);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1112);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ThresholdsDataObject = (0, _Izenda4.default)(_class = (_class2 = function () {
  function ThresholdsDataObject(data) {
    (0, _classCallCheck3.default)(this, ThresholdsDataObject);

    _initDefineProp(this, 'possion', _descriptor, this);

    _initDefineProp(this, 'id', _descriptor2, this);

    _initDefineProp(this, 'label', _descriptor3, this);

    _initDefineProp(this, 'value', _descriptor4, this);

    _initDefineProp(this, 'dashStyle', _descriptor5, this);

    _initDefineProp(this, 'color', _descriptor6, this);

    _initDefineProp(this, 'thickness', _descriptor7, this);

    _initDefineProp(this, 'visible', _descriptor8, this);

    _initDefineProp(this, 'labelSetting', _descriptor9, this);

    _initDefineProp(this, 'mappingField', _descriptor10, this);

    _initDefineProp(this, 'thresholdType', _descriptor11, this);

    _initDefineProp(this, 'fieldMappingAlias', _descriptor12, this);

    _initDefineProp(this, 'fieldId', _descriptor13, this);

    _initDefineProp(this, 'functionId', _descriptor14, this);

    _initDefineProp(this, 'functionName', _descriptor15, this);

    _initDefineProp(this, 'format', _descriptor16, this);

    _initDefineProp(this, 'querySourceId', _descriptor17, this);

    _initDefineProp(this, 'thresholdFieldElement', _descriptor18, this);

    this.populateData(data || {});
  }

  (0, _createClass3.default)(ThresholdsDataObject, [{
    key: 'populateData',
    value: function populateData(data) {
      var labelStyle = (0, _fp.getOr)({}, 'izLabel.style', data);
      this.label = (0, _fp.getOr)('', 'izLabel.text', data);
      this.value = (0, _fp.getOr)('', 'izValue', data);
      this.thickness = (0, _fp.getOr)(_Izenda2.default.DEFAULT_VALUE.WIDTH, 'izWidth', data);
      this.color = (0, _fp.getOr)(_Izenda2.default.DEFAULT_VALUE.COLOR, 'izThresholdColor', data);
      this.visible = (0, _fp.getOr)(true, 'izVisibleThresholdsSetting', data);
      this.dashStyle = (0, _fp.getOr)(_Izenda2.default.DEFAULT_VALUE.DASH_STYLE, 'izDashStyle', data);
      this.labelSetting = {
        fontSize: labelStyle.fontSize,
        fontFamily: labelStyle.fontFamily,
        fontStyle: {
          fontBold: labelStyle.fontWeight === _Izenda2.default.DEFAULT_VALUE.FONT_WEIGHT,
          fontItalic: labelStyle.fontStyle === _Izenda2.default.DEFAULT_VALUE.FONT_STYLE,
          fontUnderline: labelStyle.textDecoration === _Izenda2.default.DEFAULT_VALUE.TEXT_DECORATION
        },
        textColor: labelStyle.color || _Izenda2.default.DEFAULT_VALUE.COLOR,
        alignment: (0, _fp.getOr)(_Izenda2.default.DEFAULT_VALUE.ALIGNMENT, 'izLabel.textAlign', data)
      };
      this.fieldMappingAlias = (0, _fp.getOr)('', 'fieldMappingAlias', data);
      this.thresholdType = (0, _fp.getOr)('static', 'thresholdType', data);
      this.fieldId = (0, _fp.getOr)('', 'fieldId', data);
      this.functionId = (0, _fp.getOr)('', 'functionId', data);
      this.format.update((0, _fp.getOr)({}, 'format', data));
      this.functionName = (0, _fp.getOr)('', 'functionName', data);
      this.querySourceId = (0, _fp.getOr)('', 'querySourceId', data);
      this.possion = (0, _fp.getOr)(0, 'possion', data);
      this.fieldName = data.fieldName;
    }

    /**
     * Clear all dynamic value
     */

  }, {
    key: 'clearDynamicValue',
    value: function clearDynamicValue() {
      this.value = null;
      this.thresholdFieldElement = null;
      this.functionId = null;
      this.fieldId = null;
      this.fieldName = null;
      this.functionId = null;
      this.format.reset();
    }

    /**
     * Update dynamic threshold element
     * @param {object} element
     */

  }, {
    key: 'updateElement',
    value: function updateElement(element) {
      this.thresholdFieldElement = element;
      if (!(0, _fp.isEmpty)(this.thresholdFieldElement)) {
        this.thresholdFieldElement.properties.setFormat(this.format);
      }
      this.fieldName = (0, _fp.getOr)('', 'name', element);
    }

    /**
     * Update field name
     * @param {string} element
     */

  }, {
    key: 'updateFieldName',
    value: function updateFieldName(fieldName) {
      this.fieldName = fieldName;
      this.markDirty();
    }
  }, {
    key: 'updateThresholdType',
    value: function updateThresholdType(value) {
      this.thresholdType = value;
      this.markDirty();
    }
  }, {
    key: 'updateFieldMappingAlias',
    value: function updateFieldMappingAlias(value) {
      this.fieldMappingAlias = value;
      this.markDirty();
    }

    /**
     * Update label name of threshold setting
     * @param  {string} value
     */

  }, {
    key: 'updateLabel',
    value: function updateLabel(value) {
      this.label = value;
      this.markDirty();
    }
  }, {
    key: 'updateField',
    value: function updateField(value, fieldId, functionId, functionName, format, querySourceId) {
      this.value = value;
      this.fieldId = fieldId;
      this.functionId = functionId;
      this.functionName = functionName;
      this.format.update(format);
      if (!(0, _fp.isEmpty)(this.thresholdFieldElement)) {
        this.thresholdFieldElement.properties.setFormat(this.format);
      }
      this.querySourceId = querySourceId;
      this.markDirty();
    }

    /**
     * Update threshold setting value
     * @param  {string} value
     */

  }, {
    key: 'updateValue',
    value: function updateValue(value) {
      this.value = value;
      this.markDirty();
    }

    /**
     * Update threshold dash style
     * @param  {string} value
     */

  }, {
    key: 'updateDashStyle',
    value: function updateDashStyle(value) {
      this.dashStyle = value;
      this.markDirty();
    }

    /**
     * Update threshold color
     * @param  {string} value
     */

  }, {
    key: 'updateColor',
    value: function updateColor(value) {
      this.color = value;
      this.markDirty();
    }

    /**
     * Update threshold thick ness (width)
     * @param  {string} value
     */

  }, {
    key: 'updateThickness',
    value: function updateThickness(value) {
      this.thickness = value;
      this.markDirty();
    }

    /**
     * Update threshold thick setting visible
     * @param  {string} value
     */

  }, {
    key: 'updateVisible',
    value: function updateVisible(value) {
      this.visible = value;
      this.markDirty();
    }

    /**
     * Export to chart config setting
     * @return {object} threshold chart setting
     */

  }, {
    key: 'exportToChartConfig',
    value: function exportToChartConfig() {
      var labelSettings = this.labelSetting || {};
      var fontStyle = labelSettings.fontStyle || {};

      return {
        'izLabel.text': (0, _fp.escape)(this.label),
        izValue: this.value,
        izDashStyle: this.dashStyle,
        izThresholdColor: this.color,
        izWidth: this.thickness,
        izVisibleThresholdsSetting: this.visible,
        'izLabel.style': {
          fontSize: labelSettings.fontSize,
          color: labelSettings.textColor,
          fontFamily: labelSettings.fontFamily,
          fontStyle: fontStyle.fontItalic ? _Izenda2.default.DEFAULT_VALUE.FONT_STYLE : '',
          fontWeight: fontStyle.fontBold ? _Izenda2.default.DEFAULT_VALUE.FONT_WEIGHT : '',
          textDecoration: fontStyle.fontUnderline ? _Izenda2.default.DEFAULT_VALUE.TEXT_DECORATION : ''
        },
        'izLabel.textAlign': this.labelSetting.alignment,
        izIndex: 5, // the zIndex of the plotLine within chart, the number 5 make it above the other(series, etc )
        fieldMappingAlias: this.fieldMappingAlias,
        thresholdType: this.thresholdType,
        fieldId: this.fieldId,
        format: this.format,
        querySourceId: this.querySourceId,
        functionId: this.functionId,
        functionName: this.functionName,
        possion: this.possion,
        fieldName: this.fieldName
      };
    }

    /**
     * Update label settings of text label name
     * @param  {object} value
     */

  }, {
    key: 'updateLabelSetting',
    value: function updateLabelSetting(value) {
      value = value || {};

      this.labelSetting.textColor = value.textColor;
      this.labelSetting.fontSize = value.fontSize;
      this.labelSetting.fontFamily = value.fontFamily;
      this.labelSetting.fontStyle = value.fontStyle;
      this.labelSetting.alignment = value.alignment;

      this.markDirty();
    }
  }, {
    key: 'displayName',
    get: function get() {
      return this.thresholdFieldElement ? this.thresholdFieldElement.field.visible ? !(0, _fp.isNil)(this.functionName) && !(0, _fp.isEmpty)(this.functionName) ? this.functionName + ' (' + this.thresholdFieldElement.field.fieldName + ')' : this.thresholdFieldElement.field.fieldName : '' : null;
    }
  }]);
  return ThresholdsDataObject;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'possion', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'label', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'dashStyle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'color', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'thickness', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'visible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'labelSetting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      fontSize: 0,
      fontFamily: '',
      fontStyle: {
        fontBold: '',
        fontItalic: '',
        fontUnderline: ''
      },
      textColor: '',
      alignment: ''
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'mappingField', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'thresholdType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 'static';
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'fieldMappingAlias', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'fieldId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'functionId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'functionName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'format', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda8.default();
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'querySourceId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'thresholdFieldElement', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'displayName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'displayName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clearDynamicValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clearDynamicValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateElement', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateElement'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateFieldName', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateFieldName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateThresholdType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateThresholdType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateFieldMappingAlias', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateFieldMappingAlias'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateLabel', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateLabel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDashStyle', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDashStyle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateColor', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateColor'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateThickness', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateThickness'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateVisible', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateVisible'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateLabelSetting', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateLabelSetting'), _class2.prototype)), _class2)) || _class;

exports.default = ThresholdsDataObject;
module.exports = exports['default'];

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormatDataType = function () {
  function FormatDataType(formatValue) {
    (0, _classCallCheck3.default)(this, FormatDataType);
    this.format = null;
    this.formatId = null;
    this.jsFormatString = null;
    this.groupBy = null;
    this.formatDataType = null;

    this.update(formatValue);
  }

  /**
   * Update format value
   * @param {any} formatValue
   */


  (0, _createClass3.default)(FormatDataType, [{
    key: 'update',
    value: function update(formatValue) {
      if ((0, _fp.isEmpty)(formatValue)) {
        return;
      }

      var format = formatValue.format,
          formatId = formatValue.formatId,
          jsFormatString = formatValue.jsFormatString,
          groupBy = formatValue.groupBy,
          formatDataType = formatValue.formatDataType;

      if ((0, _fp.isEmpty)(formatId)) {
        this.reset();
      } else {
        this.format = format;
        this.formatId = formatId;
        this.jsFormatString = jsFormatString;
        this.groupBy = groupBy;
        this.formatDataType = formatDataType;
      }
    }

    /**
     * Reset format value
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.format = null;
      this.formatId = null;
      this.jsFormatString = null;
      this.groupBy = null;
      this.formatDataType = null;
    }
  }]);
  return FormatDataType;
}();
// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatDataType.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


exports.default = FormatDataType;
module.exports = exports['default'];

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPalette.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(2056);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Color Palette component
 */
var ColorPalette = (_dec = (0, _Izenda2.default)({ toClass: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ColorPalette, _Component);

  function ColorPalette() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ColorPalette);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ColorPalette.__proto__ || (0, _getPrototypeOf2.default)(ColorPalette)).call.apply(_ref, [this].concat(args))), _this), _this.renderColorsCol = function (rowIndex, colors) {
      return colors.map(function (color, index) {
        return _react2.default.createElement(
          _Izenda4.default.Col,
          {
            cols: ColorPalette.Cols,
            xs: ColorPalette.Cols,
            key: rowIndex + '_' + index,
            className: 'u_noPaddingAll izenda-ColorPalette-Col'
          },
          _react2.default.createElement(_Izenda6.default, { value: color })
        );
      });
    }, _this.renderColorsRow = function (colors) {
      var paddingArray = function paddingArray(newLength) {
        return function (source) {
          if ((0, _fp.isArray)(source) && (0, _fp.isInteger)(newLength)) {
            var addingItemsCount = newLength - source.length;
            var addingItems = addingItemsCount > 0 ? (0, _fp.fill)(0, addingItemsCount, null, Array(addingItemsCount)) : new Array();
            return source.concat(addingItems);
          }
          return null;
        };
      };

      var rows = (0, _fp.flow)(paddingArray(ColorPalette.MaxColorCount), (0, _fp.take)(ColorPalette.MaxColorCount), (0, _fp.chunk)(ColorPalette.ColumnCount))(colors);

      return rows.map(function (colorsRow, index) {
        return _react2.default.createElement(
          _Izenda4.default.Row,
          { key: index, className: 'u_noMarginAll' },
          _this.renderColorsCol(index, colorsRow)
        );
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ColorPalette, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          selected = _props.selected,
          className = _props.className,
          isDefaultTheme = _props.isDefaultTheme,
          localization = _props.localization,
          displaySettingStatus = _props.displaySettingStatus;


      var displayName = (0, _fp.get)('model.displayName', this.props);
      var isDisplayDefaultText = displaySettingStatus && isDefaultTheme;
      var defaultText = isDisplayDefaultText ? '(' + localization.getText('COLORPALETTE_DEFAULT') + ')' : '';
      var colors = (0, _fp.get)('model.colors', this.props);
      var classNames = (0, _classnames2.default)('izenda-ColorPalette', className, {
        'izenda-ColorPalette-selected': selected
      });

      return _react2.default.createElement(
        _Izenda4.default,
        { className: classNames },
        _react2.default.createElement(
          _Izenda4.default.Row,
          { className: 'u_noMarginAll izenda-ColorPalette-InforRowContainer' },
          _react2.default.createElement(
            'div',
            { className: 'u_textTruncate', title: displayName + ' ' + defaultText },
            displayName,
            isDisplayDefaultText && _react2.default.createElement(
              'small',
              { className: 'u_marginLeftInnerSpace' },
              defaultText
            )
          )
        ),
        colors && _react2.default.createElement(
          _Izenda4.default.Row,
          { className: 'u_noMarginAll izenda-ColorPalette-ColorRowsContainer' },
          this.renderColorsRow(colors)
        )
      );
    }
  }]);
  return ColorPalette;
}(_react.Component), _class2.MaxColorCount = 12, _class2.ColumnCount = 6, _class2.Cols = 2, _temp2)) || _class);
exports.default = ColorPalette;
module.exports = exports['default'];

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.OrientationSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 *  OrientationSettings component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrientationSettings = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(OrientationSettings, _Component);

  function OrientationSettings() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OrientationSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrientationSettings.__proto__ || (0, _getPrototypeOf2.default)(OrientationSettings)).call.apply(_ref, [this].concat(args))), _this), _this.renderOption = function (data) {
      var onClick = function onClick(value) {
        var _props = this.props,
            onChange = _props.onChange,
            currentValue = _props.value;


        if (onChange && currentValue !== value) {
          onChange({ value: value });
        }
      };

      return _react2.default.createElement(
        'li',
        { key: data.name },
        _react2.default.createElement(
          'a',
          { onClick: onClick.bind(_this, data.value) },
          _react2.default.createElement('i', { className: data.icon }),
          data.name
        )
      );
    }, _this.renderOptions = function (data) {
      return (0, _fp.map)(function (value) {
        return _this.renderOption(value);
      }, data);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OrientationSettings, [{
    key: 'domNode',
    value: function domNode(dom) {
      dom && $izenda(dom).dropdown();
    }
  }, {
    key: 'render',
    value: function render() {
      var OPTIONS_CONFIG = [{ value: 'izNormal', icon: 'icon-text-normal', name: _Izenda2.default.getText('ORIENTATION_SETTING_NORMAL') }, {
        value: 'izCounterclockwise',
        icon: 'icon-counter-clockwise',
        name: _Izenda2.default.getText('ORIENTATION_SETTING_ANGLE_COUNTER')
      }, { value: 'izClockwise', icon: 'icon-clock-wise', name: _Izenda2.default.getText('ORIENTATION_SETTING_ANGLE_CLOCKWISE') }, { value: 'izTextup', icon: 'icon-text-up', name: _Izenda2.default.getText('ORIENTATION_SETTING_ROTATE_TEXT_UP') }, { value: 'izTextdown', icon: 'icon-text-down', name: _Izenda2.default.getText('ORIENTATION_SETTING_ROTATE_TEXT_DOWN') }];

      var currentValue = (0, _fp.find)({ value: this.props.value }, OPTIONS_CONFIG) || {};
      var icon = currentValue.icon || OPTIONS_CONFIG[0].icon;
      var title = currentValue.name || OPTIONS_CONFIG[0].name;

      return _react2.default.createElement(
        'div',
        { className: 'btn-group orientation-setting' },
        _react2.default.createElement('i', { type: 'button', title: title, className: icon, 'data-toggle': 'dropdown', ref: this.domNode }),
        _react2.default.createElement(
          'ul',
          { className: 'dropdown-menu' },
          this.renderOptions(OPTIONS_CONFIG)
        )
      );
    }
  }]);
  return OrientationSettings;
}(_react.Component), _class2.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func
}, _class2.defaultProps = {
  value: 'izNormal'
}, _temp2)) || _class;

exports.default = OrientationSettings;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.LineChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(426);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LineChartOptionsBuilder = (_dec = (0, _Izenda5.exportClass)('LineChartOptionsBuilder'), _dec(_class = function (_ChartHasThresholdOpt) {
  (0, _inherits3.default)(LineChartOptionsBuilder, _ChartHasThresholdOpt);

  function LineChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, LineChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = LineChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(LineChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @returns {Object}
   */


  (0, _createClass3.default)(LineChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var chartOptions = (0, _get3.default)(LineChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(LineChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser);
      var thresholdSeries = chartOptions.thresholdSeries;
      var series = chartOptions.series;
      var colors = (0, _fp.isNil)(userOptions.colors) ? this.DefaultColors : userOptions.colors;

      _Izenda4.default.setColorPointForAreaLine(userOptions, series, colors);
      var lineSeries = [].concat((0, _toConsumableArray3.default)(series), (0, _toConsumableArray3.default)(thresholdSeries));

      return (0, _fp.assignIn)(chartOptions, {
        series: lineSeries
      });
    }
  }]);
  return LineChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = LineChartOptionsBuilder;
module.exports = exports['default'];

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColumnChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(1117);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(39);

var _fp = __webpack_require__(1);

var _Izenda4 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnChartOptionsBuilder = (_dec = (0, _Izenda4.exportClass)('ColumnChartOptionsBuilder'), _dec(_class = function (_AreaChartOptionsBuil) {
  (0, _inherits3.default)(ColumnChartOptionsBuilder, _AreaChartOptionsBuil);

  function ColumnChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, ColumnChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = ColumnChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(ColumnChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @return {Object} 
   */


  (0, _createClass3.default)(ColumnChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var chartOptions = (0, _get3.default)(ColumnChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(ColumnChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser) || {};
      var _userOptions$izendaOp = userOptions.izendaOptions,
          izendaOptions = _userOptions$izendaOp === undefined ? {} : _userOptions$izendaOp;

      // Change y value to null to only show point has data

      (0, _fp.flow)((0, _fp.flatMap)('data'), (0, _fp.forEach)(function (data) {
        data.isDefaultValue && (data.y = null);
      }))(chartOptions.series);

      // Range only options
      if (izendaOptions.range === _Izenda3.RANGE_OPTION_KEYS.rangeOnly) {
        return (0, _fp.merge)(chartOptions, {
          chart: {
            type: 'columnrange'
          },
          plotOptions: {
            series: {
              minPointLength: 3
            }
          }
        });
      }

      return (0, _fp.merge)(chartOptions, {
        chart: {
          type: 'column'
        },
        xAxis: {
          crosshair: true
        }
      });
    }
  }]);
  return ColumnChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = ColumnChartOptionsBuilder;
module.exports = exports['default'];

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AreaChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(426);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(39);

var _fp = __webpack_require__(1);

var _Izenda6 = __webpack_require__(85);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AreaChartOptionsBuilder = (_dec = (0, _Izenda8.exportClass)('AreaChartOptionsBuilder'), _dec(_class = function (_ChartHasThresholdOpt) {
  (0, _inherits3.default)(AreaChartOptionsBuilder, _ChartHasThresholdOpt);

  function AreaChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, AreaChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = AreaChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(AreaChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @returns {Object}
   */


  (0, _createClass3.default)(AreaChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var chartOptions = (0, _get3.default)(AreaChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(AreaChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser);

      var izendaOptions = userOptions.izendaOptions || {};
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
      var stacking = (0, _fp.get)('plotOptions.series.stacking', userOptions);
      var xAxisField = (0, _fp.get)('series[0].xAxisField', chartOptions);
      var yAxisField = (0, _fp.get)('series[0].yAxisField', chartOptions);
      var separatorField = (0, _fp.get)('series[0].separatorField', chartOptions);
      var series = chartOptions.series;
      var thresholdSeries = chartOptions.thresholdSeries;
      var areaSeries = [].concat((0, _toConsumableArray3.default)(series), (0, _toConsumableArray3.default)(thresholdSeries));

      var xAxisData = (0, _fp.flow)((0, _fp.get)('data'), _fp.uniq)(dataParser.getDataByField(xAxisField));
      var groupNames = [];
      var groupedData = dataParser.groupData(separatorField, groupNames);

      var colors = (0, _fp.isNil)(userOptions.colors) ? this.DefaultColors : userOptions.colors;

      var isAreaChart = visualType === _Izenda7.default.Area;

      if (isAreaChart) {
        _Izenda4.default.setColorPointForAreaLine(userOptions, series, colors);
      }

      // For Area Chart with Stack & Separator, we need to add more point with yAxis Data = 0
      if (!!separatorField && !!stacking && !(0, _fp.isEmpty)(groupedData) && isAreaChart) {
        groupNames.forEach(function (groupName) {
          var groupRecords = groupedData[groupName];
          xAxisData.forEach(function (xAxisValue) {
            var existingPoint = (0, _fp.find)(function (record) {
              return record[xAxisField.columnName] === xAxisValue;
            }, groupRecords);
            if (!existingPoint) {
              var newRecord = {};
              newRecord[xAxisField.columnName] = xAxisValue;
              newRecord[yAxisField.columnName] = 0;
              newRecord[separatorField.columnName] = groupName;
              groupRecords.push(newRecord);
            }
          });
        });
        dataParser.setRecord((0, _fp.flatMap)(function (data) {
          return data;
        }, groupedData));
        chartOptions = (0, _get3.default)(AreaChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(AreaChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser) || {};
      }

      chartOptions = (0, _fp.assignIn)(chartOptions, {
        series: areaSeries
      });

      /** [range only] option **/
      if (izendaOptions.range === _Izenda5.RANGE_OPTION_KEYS.rangeOnly) {
        var seriesByRange = parserSeriesByRange(chartOptions.series);
        return {
          chart: {
            type: 'arearange'
          },
          series: seriesByRange,

          xAxis: chartOptions.xAxis,
          yAxis: (0, _fp.assignIn)(chartOptions.yAxis, {
            labels: {
              formatter: function formatter() {
                return dataParser.getFormatData(this.value, izendaSeriesConfig[seriesByRange[0].name], [100]);
              }
            }
          }),

          tooltip: {
            formatter: getTooltipFormatByRange
          }
        };
      }

      /** [rangeWithAverage] option **/
      if (izendaOptions.range === _Izenda5.RANGE_OPTION_KEYS.rangeWithAverage) {
        var _seriesByRange = parserSeriesByRangeWithAverage(chartOptions.series);
        return {
          series: _seriesByRange,

          xAxis: chartOptions.xAxis,
          yAxis: (0, _fp.assignIn)(chartOptions.yAxis, {
            labels: {
              formatter: function formatter() {
                return dataParser.getFormatData(this.value, izendaSeriesConfig[_seriesByRange[0].name], [100]);
              }
            }
          }),

          tooltip: {
            crosshairs: false,
            shared: true,
            formatter: getTooltipFormatByRangeWithAverage
          }
        };
      }

      /** [spline] option **/
      if (izendaOptions.spline) {
        return (0, _fp.assignIn)({
          chart: {
            type: 'areaspline'
          }
        }, chartOptions);
      }

      return chartOptions;

      function getTooltipFormatByRange() {
        var tooltip = [];
        var points = this.points || [this.point];
        var firstPoint = points[0] || {};
        var xAxis = chartOptions.xAxis || {};
        var formattedData = dataParser.getFormatData(firstPoint.key || firstPoint.name || firstPoint.x, izendaSeriesConfig[xAxis.axisName]);
        tooltip.push('<b>' + formattedData + '</b><br/>');

        // point
        points.forEach(function (serie) {
          var point = serie.point || {};
          var serieName = point.series.name;
          var low = dataParser.getFormatData(point.low || point.value, izendaSeriesConfig[serieName], point.series.yData);
          var high = dataParser.getFormatData(point.high || point.value, izendaSeriesConfig[serieName], point.series.yData);

          tooltip.push('<span style="color:' + point.color + '">\u25CF</span>' + serieName + ': <b>' + low + ' - ' + high + '</b><br/>');
        });

        return tooltip.join('');
      }

      /**
       * Build tooltip for range with average.
       */
      function getTooltipFormatByRangeWithAverage() {
        var tooltip = [];
        var points = this.points || [this.point];
        var firstPoint = points[0] || {};
        var xAxis = chartOptions.xAxis || {};
        var tooltipColors = [];
        var tooltipColorIndex = 0;
        var formattedData = dataParser.getFormatData(firstPoint.key || firstPoint.name || firstPoint.x, izendaSeriesConfig[xAxis.axisName]);
        tooltip.push('<b>' + formattedData + '</b><br/>');

        // On line
        for (var i = 0; i < points.length; i++) {
          var point = points[i].point || {};
          if (!(0, _fp.isNil)(point.low)) continue;
          var serieName = point.series.name;
          var avg = dataParser.getFormatData(point.y || point.value, izendaSeriesConfig[serieName], point.series.yData);
          tooltipColors.push(point.color);

          tooltip.push('<span style="color:' + point.color + '">\u25CF</span>' + serieName + ': <b>' + avg + '</b><br/>');
        }

        // On range
        for (var j = 0; j < points.length; j++) {
          var _point = points[j].point || {};
          if ((0, _fp.isNil)(_point.low)) continue;
          var _serieName = _point.series.name;
          var low = dataParser.getFormatData(_point.low || _point.value, izendaSeriesConfig[_serieName], _point.series.yData);
          var high = dataParser.getFormatData(_point.high || _point.value, izendaSeriesConfig[_serieName], _point.series.yData);
          var tooltipColor = tooltipColors[tooltipColorIndex];
          tooltip.push('<span style="color:' + tooltipColor + '">\u25CF</span>' + _serieName + ': <b>' + low + ' - ' + high + '</b><br/>');
          tooltipColorIndex = tooltipColorIndex + 1;
        }

        return tooltip.join('');
      }

      function parserSeriesByRange(series) {
        series.forEach(function (serie) {
          serie.data = (0, _fp.map)(function (point) {
            return (0, _fp.merge)({
              low: point.min,
              high: point.max
            }, point);
          }, serie.data);
        });

        return series;
      }

      /**
       * Build series for range with average.
       * @param  {Array} series
       */
      function parserSeriesByRangeWithAverage(series) {
        var newSeries = [];

        (0, _fp.forEach)(function (serie) {
          newSeries = (0, _fp.concat)(buildChartData(serie), newSeries);
        }, series);

        return newSeries;

        function buildChartData(serie) {
          var lineSerie = (0, _fp.assign)(serie, {
            type: 'line',
            zIndex: 1,
            name: serie.name + '_AVG',
            data: []
          });

          var areaSerie = (0, _fp.assign)(serie, {
            type: 'arearange',
            lineWidth: 0,
            linkedTo: ':previous', // To link to the previous series.
            name: serie.name + '_Range',
            data: [],
            fillOpacity: 0.3,
            zIndex: 0
          });

          (0, _fp.map)(function (point) {
            lineSerie.data.push((0, _fp.merge)({
              y: point.avg
            }, point));

            areaSerie.data.push((0, _fp.merge)({
              low: point.min,
              high: point.max
            }, point));
          }, serie.data);

          return [areaSerie, lineSerie];
        }
      }
    }
  }]);
  return AreaChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = AreaChartOptionsBuilder;
module.exports = exports['default'];

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.BubbleChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(328);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(49);

var _Izenda6 = __webpack_require__(164);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(88);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(35);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var X_AXIS_CONTAINER_NAME = 'labels';
var Y_AXIS_CONTAINER_NAME = 'values';
var Z_AXIS_CONTAINER_NAME = 'bubbleSize';
var NAME_CONTAINER_NAME = 'valuesLabels';

var BubbleChartOptionsBuilder = (_dec = (0, _Izenda5.exportClass)('BubbleChartOptionsBuilder'), _dec(_class = function (_DefaultChartOptionsB) {
  (0, _inherits3.default)(BubbleChartOptionsBuilder, _DefaultChartOptionsB);

  function BubbleChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, BubbleChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = BubbleChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(BubbleChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */


  (0, _createClass3.default)(BubbleChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var optionsBuilder = this;
      var xAxisContainerName = (0, _fp.getOr)(X_AXIS_CONTAINER_NAME, 'X_AXIS_CONTAINER_NAME', userOptions);
      var containers = dataParser.containers || {};
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
      var defaultColors = this.DefaultColors;

      var xAxisField = (0, _fp.nth)(dataParser.expandedLevel, containers[xAxisContainerName]);
      var yAxisField = (0, _fp.nth)(0, containers[Y_AXIS_CONTAINER_NAME]);
      var yAxisOptions = getYAxisOption();
      var xAxisOptions = getXAxisOption();

      var series = getSeries(userOptions);
      var axisCat = getAxisCategories(series);

      var chartOptions = {
        series: series,
        yAxis: { labels: { formatter: _Izenda4.default.getFormattedLabelAxis }, plotLines: getYThresholdOption(series) },
        xAxis: { labels: { formatter: _Izenda4.default.getFormattedLabelAxis }, plotLines: getXThresholdOption() }
      };

      // Disable colorByPoint because we handle multi-colors manually.
      var plotOptions = { series: { colorByPoint: false } };

      chartOptions.plotOptions = (0, _fp.merge)(chartOptions.plotOptions, plotOptions);

      chartOptions.yAxis = (0, _fp.merge)(chartOptions.yAxis, yAxisOptions);
      chartOptions.xAxis = (0, _fp.merge)(chartOptions.xAxis, xAxisOptions);

      _Izenda4.default.setDefaultAxisName(chartOptions, dataParser);
      this.configureRegression(izendaSeriesConfig, series);

      return $izenda.extend(true, chartOptions, axisCat);

      /**
       * Get x-axis option
       */
      function getXAxisOption() {
        var commonXYAxis = (0, _fp.get)('commonXYAxis.xAxis', userOptions);
        return (0, _fp.merge)((0, _fp.get)(xAxisField.fieldName + '.axisOption', izendaSeriesConfig), commonXYAxis);
      }

      /**
       * Get x-threshold option
       */
      function getXThresholdOption() {
        return (0, _fp.get)(xAxisField.fieldName + '.threshold', izendaSeriesConfig);
      }

      // Get Y-axis options needed when user change chart's metric, by comparing Y-axis's name with metric's name.
      function getYAxisOption() {
        var commonXYAxis = (0, _fp.get)('commonXYAxis', userOptions);
        var fieldName = (0, _fp.get)('fieldName', yAxisField);
        var option = (0, _fp.get)(fieldName + '.axisOption', izendaSeriesConfig);
        return (0, _fp.merge)(option, (0, _fp.get)('yAxis', commonXYAxis));
      }

      /**
       * Get y-threshold option
       */
      function getYThresholdOption() {
        var fieldName = (0, _fp.get)('fieldName', yAxisField);
        return (0, _fp.get)(fieldName + '.threshold', izendaSeriesConfig);
      }

      /**
       * Get axis categories
       * @param {any} series
       */
      function getAxisCategories(series) {
        var firstSeries = (0, _fp.first)(series);
        var axisCategories = {};

        addConfigToAxis('x');
        addConfigToAxis('y');

        return axisCategories;

        function addConfigToAxis(name) {
          var cat = (0, _fp.get)(name + 'Categories', firstSeries);
          var axisName = name + 'Axis';
          var axisConfig = axisCategories[axisName] = axisCategories[axisName] || {};

          axisConfig.type = firstSeries[name + 'AxisType'];

          if (cat && cat.length) {
            axisConfig.categories = cat;
            axisConfig.tickPositions = (0, _fp.range)(0, cat.length);
          }
        }
      }

      /**
       * Get series
       * @param {any} userOptions
       */
      function getSeries(userOptions) {
        var rawData = dataParser.rawData;
        var containers = dataParser.containers;
        var xCategories = { obj: {}, arr: [] };
        var yCategories = { obj: {}, arr: [] };

        var series = (rawData.length ? rawData : [rawData]).map(function (tuple) {
          return getSerie(tuple.fieldsMapping, tuple.records, xCategories, yCategories, userOptions);
        });

        return (0, _fp.compact)((0, _fp.flattenDeep)(series));

        function getSerie(fieldsMapping, records, xCategories, yCategories, userOptions) {
          if (!fieldsMapping || !records) {
            return null;
          }

          var dataStructure = _Izenda7.default.restructureField(containers, fieldsMapping) || {};
          var xAxisFieldMapping = (0, _fp.nth)(dataParser.expandedLevel, dataStructure[X_AXIS_CONTAINER_NAME]) || {};
          var yAxisFieldMapping = (0, _fp.nth)(0, dataStructure[Y_AXIS_CONTAINER_NAME]) || {};
          var nameFieldMapping = (0, _fp.nth)(0, dataStructure[NAME_CONTAINER_NAME]) || {};
          var bubbleSize = (0, _fp.nth)(0, dataStructure[Z_AXIS_CONTAINER_NAME]) || {};

          var xAxisType = (0, _fp.get)('type', _Izenda4.default.getAxisType(xAxisFieldMapping));
          var yAxisType = (0, _fp.get)('type', _Izenda4.default.getAxisType(yAxisFieldMapping));

          var xAxisConfig = (0, _fp.get)(xAxisFieldMapping.fieldNameAlias, izendaSeriesConfig);
          var yAxisConfig = (0, _fp.get)(yAxisFieldMapping.fieldNameAlias, izendaSeriesConfig);

          var point = void 0,
              xRawData = void 0,
              yRawData = void 0;

          if (!nameFieldMapping || !nameFieldMapping.columnName) {
            return null;
          }

          // Check category option
          if (xAxisType !== 'category' && !!xAxisOptions.izCategory) {
            xAxisType = 'category';
          }

          var colorByPoint = userOptions.plotOptions.series.colorByPoint,
              izDisableMultiColor = userOptions.izDisableMultiColor;


          var isMultiColor = colorByPoint && !izDisableMultiColor;

          var serieData = records.map(function (record) {
            xRawData = _Izenda11.default.getOriginalValue(xAxisFieldMapping, record);
            yRawData = _Izenda11.default.getOriginalValue(yAxisFieldMapping, record);
            var originalNameValue = _Izenda11.default.getOriginalValue(nameFieldMapping, record);
            var size = _Izenda11.default.getOriginalValue(bubbleSize, record);

            point = {
              x: optionsBuilder.getAxisData(xRawData, xCategories, xAxisType, xAxisConfig),
              xRawData: xRawData,
              y: optionsBuilder.getAxisData(yRawData, yCategories, yAxisType, yAxisConfig),
              yRawData: yRawData,
              z: size,
              name: (0, _fp.get)(nameFieldMapping.columnName, record),
              originalNameValue: originalNameValue,
              record: record
            };

            return point;
          });

          if (xAxisType !== 'category') {
            serieData = (0, _fp.filter)(function (point) {
              return !!point.x && !!point.y;
            }, serieData);
          }
          var params = [nameFieldMapping, bubbleSize, xAxisFieldMapping, xAxisType, xCategories, yAxisFieldMapping, yAxisType, yCategories, userOptions, izendaSeriesConfig];

          return isMultiColor ? optionsBuilder.parseMultiColorSeriesData(userOptions, defaultColors, serieData, params) : [optionsBuilder.getSerieOption.apply(optionsBuilder, [nameFieldMapping.fieldNameAlias, serieData].concat(params))];
        }
      }
    }

    /**
     *
     * @param {any} val The axis raw data
     * @param {Object} categoriesInfo The categories info
     * @param {string} axisType Axis type, e.g. linear, datetime or category
     * @param {Object} axisConfig The axis configuration info
     */

  }, {
    key: 'getAxisData',
    value: function getAxisData(val, categoriesInfo, axisType, axisConfig) {
      switch (axisType) {
        case 'linear':
          {
            return (0, _fp.toNumber)(val);
          }

        case 'datetime':
          {
            val = (0, _Izenda9.default)((0, _fp.get)('fieldFormatData', axisConfig), val, false);
            return val.getTime ? val.getTime() : val;
          }

        default:
          {
            var obj = categoriesInfo.obj = categoriesInfo.obj || {};
            var arr = categoriesInfo.arr = categoriesInfo.arr || [];

            if ((0, _fp.has)(val, obj)) {
              return obj[val];
            } else {
              obj[val] = arr.length;
              arr.push(val);
              return arr.length - 1;
            }
          }
      }
    }

    /**
     * Get serie options
     */

  }, {
    key: 'getSerieOption',
    value: function getSerieOption(name, serieData, nameFieldMapping, bubbleSize, xAxisFieldMapping, xAxisType, xCategories, yAxisFieldMapping, yAxisType, yCategories, userOptions, izendaSeriesConfig) {
      var serieOption = {
        name: name,
        data: serieData,
        xFieldName: xAxisFieldMapping.fieldNameAlias,
        yFieldName: yAxisFieldMapping.fieldNameAlias,
        xCategories: xCategories.arr,
        yCategories: yCategories.arr,
        xAxisType: xAxisType,
        yAxisType: yAxisType,
        xAxisField: xAxisFieldMapping,
        yAxisField: yAxisFieldMapping,
        zAxisField: bubbleSize,
        nameField: nameFieldMapping,
        nameFieldName: nameFieldMapping.fieldNameAlias,
        bubbleFieldName: bubbleSize.fieldNameAlias,
        dataLabels: { useHTML: true, formatter: this.getDataLabelFormat }
      };

      // Add sub-report to data-labels
      _Izenda4.default.addPointActionLink(true, userOptions, serieOption.dataLabels, nameFieldMapping.fieldNameAlias, (0, _fp.get)(nameFieldMapping.fieldNameAlias, izendaSeriesConfig));

      return serieOption;
    }

    /**
     * Get data label format
     */

  }, {
    key: 'getDataLabelFormat',
    value: function getDataLabelFormat() {
      var formattedValue = _Izenda4.default.getFormattedDataByPoint('name', this.point, true);
      return (0, _fp.get)('data', formattedValue);
    }

    /**
    * Parse multi colors series' data
    * @param {Object} userOptions
    * @param {Array<Object>} defaultColors
    * @param {Array<Object>} serieData
    * @param {Object} params
    * @returns {Array<Object>}
    */

  }, {
    key: 'parseMultiColorSeriesData',
    value: function parseMultiColorSeriesData(userOptions, defaultColors, serieData, params) {
      var optionsBuilder = this;
      var colors = (0, _fp.isNil)(userOptions.colors) ? defaultColors : userOptions.colors;
      var names = (0, _fp.flow)((0, _fp.map)(function (x) {
        return x.name.toString();
      }), _fp.uniq)(serieData);

      var groupedSeries = (0, _fp.flow)((0, _fp.groupBy)('name'), _fp.toPairs, (0, _fp.map)(function (_ref2) {
        var key = _ref2[0],
            value = _ref2[1];

        return { key: key, value: optionsBuilder.getSerieOption.apply(optionsBuilder, [key, value].concat((0, _toConsumableArray3.default)(params))) };
      }))(serieData);

      return (0, _fp.map)(function (name, index) {
        var serieValue = (0, _fp.find)(function (item) {
          return item.key === name;
        }, groupedSeries).value;
        (0, _fp.forEach)(function (v) {
          return v.color = colors[(index + 1) % colors.length];
        }, serieValue.data);
        return serieValue;
      }, names);
    }
  }]);
  return BubbleChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = BubbleChartOptionsBuilder;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var DataType = {
  string: {
    parseValue: function parseValue(input) {
      return input ? (0, _fp.toString)(input) : null;
    },
    isDefaultValue: function isDefaultValue(value) {
      return !value;
    },

    defaultValue: (0, _fp.constant)('')
  },
  number: {
    parseValue: function parseValue(input) {
      return (0, _fp.toNumber)(input);
    },
    isDefaultValue: function isDefaultValue(value) {
      return !value;
    },

    defaultValue: (0, _fp.constant)(0)
  },
  boolean: {
    parseValue: function parseValue(input) {
      switch ((0, _fp.toLower)(input)) {
        case 'true':
        case 'yes':
        case '1':
          return true;
        default:
          return false;
      }
    },
    isDefaultValue: function isDefaultValue(value) {
      return !value;
    },

    defaultValue: (0, _fp.constant)(false)
  },
  array: {
    parseValue: function parseValue(input) {
      return (0, _fp.isArray)(input) ? input : JSON.parse(input);
    },
    isDefaultValue: function isDefaultValue(value) {
      return (0, _fp.isNil)(value) || (0, _fp.isEmpty)(value);
    },
    defaultValue: function defaultValue() {
      return [];
    }
  },
  object: {
    parseValue: function parseValue(input) {
      return input;
    },
    isDefaultValue: function isDefaultValue(value) {
      return (0, _fp.isNil)(value) || (0, _fp.isEmpty)(value);
    },
    defaultValue: function defaultValue() {
      return {};
    }
  }
};

// Schema of field properties in form.
// ----------------------------------------------------------------------
// <copyright file="Izenda.FormFieldPropertiesPaths.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Report Part Form Content Utils
 */
var FieldPropertiesPaths = {
  name: {
    key: 'name',
    path: 'name',
    dataType: DataType['string']
  },

  // properties
  isFieldVisible: {
    key: 'isFieldVisible',
    path: 'properties.fieldItemVisible',
    dataType: DataType['boolean']
  },

  function: {
    key: 'function',
    path: 'properties.dataFormattings.function',
    dataType: DataType['string']
  },
  // properties.dataFormattings.functionInfo
  funcInfoId: {
    key: 'funcInfoId',
    path: 'properties.dataFormattings.functionInfo.id',
    dataType: DataType['string']
  },
  funcName: {
    key: 'funcName',
    path: 'properties.dataFormattings.functionInfo.name',
    dataType: DataType['string']
  },
  funcExpression: {
    key: 'funcExpression',
    path: 'properties.dataFormattings.functionInfo.expression',
    dataType: DataType['string']
  },
  funcDataType: {
    key: 'funcDataType',
    path: 'properties.dataFormattings.functionInfo.dataType',
    dataType: DataType['string']
  },
  funcFormatDataType: {
    key: 'funcFormatDataType',
    path: 'properties.dataFormattings.functionInfo.formatDataType',
    dataType: DataType['string']
  },
  funcSyntax: {
    key: 'funcSyntax',
    path: 'properties.dataFormattings.functionInfo.syntax',
    dataType: DataType['string']
  },
  funcExpressionSyntax: {
    key: 'funcExpressionSyntax',
    path: 'properties.dataFormattings.functionInfo.expressionSyntax',
    dataType: DataType['string']
  },
  funcIsOperator: {
    key: 'funcIsOperator',
    path: 'properties.dataFormattings.functionInfo.isOperator',
    dataType: DataType['boolean']
  },

  // properties.dataFormattings.format
  formatId: {
    key: 'formatId',
    path: 'properties.dataFormattings.format.formatId',
    dataType: DataType['string']
  },
  format: {
    key: 'format',
    path: 'properties.dataFormattings.format.format',
    dataType: DataType['string']
  },
  formatGroupBy: {
    key: 'formatGroupBy',
    path: 'properties.dataFormattings.format.groupBy',
    dataType: DataType['string']
  },

  width: {
    key: 'width',
    path: 'properties.dataFormattings.width.value',
    dataType: DataType['number']
  },

  // properties.dataFormattings.font
  fontFamily: {
    key: 'fontFamily',
    path: 'properties.dataFormattings.font.family',
    dataType: DataType['string']
  },
  fontSize: {
    key: 'fontSize',
    path: 'properties.dataFormattings.font.size',
    dataType: DataType['number']
  },
  fontBold: {
    key: 'fontBold',
    path: 'properties.dataFormattings.font.bold',
    dataType: DataType['boolean']
  },
  fontItalic: {
    key: 'fontItalic',
    path: 'properties.dataFormattings.font.italic',
    dataType: DataType['boolean']
  },
  fontUnderline: {
    key: 'fontUnderline',
    path: 'properties.dataFormattings.font.underline',
    dataType: DataType['boolean']
  },
  fontColor: {
    key: 'fontColor',
    path: 'properties.dataFormattings.font.color',
    dataType: DataType['string']
  },
  fontBackgroundColor: {
    key: 'fontBackgroundColor',
    path: 'properties.dataFormattings.font.backgroundColor',
    dataType: DataType['string']
  },

  alignment: {
    key: 'alignment',
    path: 'properties.dataFormattings.alignment',
    dataType: DataType['string']
  },
  wordWrap: {
    key: 'wordWrap',
    path: 'properties.dataFormattings.wordWrap',
    dataType: DataType['boolean']
  },
  sort: {
    key: 'sort',
    path: 'properties.dataFormattings.sort',
    dataType: DataType['string'],
    needDefaultValue: true
  },

  // properties.dataFormattings.color.textColor
  textColorRangePercent: {
    key: 'textColorRangePercent',
    path: 'properties.dataFormattings.color.textColor.rangePercent',
    dataType: DataType['array']
  },
  textColorRangeValue: {
    key: 'textColorRangeValue',
    path: 'properties.dataFormattings.color.textColor.rangeValue',
    dataType: DataType['array']
  },
  textColorValue: {
    key: 'textColorValue',
    path: 'properties.dataFormattings.color.textColor.value',
    dataType: DataType['array']
  },

  // properties.dataFormattings.color.cellColor
  cellColorRangePercent: {
    key: 'cellColorRangePercent',
    path: 'properties.dataFormattings.color.cellColor.rangePercent',
    dataType: DataType['array']
  },
  cellColorRangeValue: {
    key: 'cellColorRangeValue',
    path: 'properties.dataFormattings.color.cellColor.rangeValue',
    dataType: DataType['array']
  },
  cellColorValue: {
    key: 'cellColorValue',
    path: 'properties.dataFormattings.color.cellColor.value',
    dataType: DataType['array']
  },

  // properties.dataFormattings.alternativeText
  altTextRangePercent: {
    key: 'altTextRangePercent',
    path: 'properties.dataFormattings.alternativeText.rangePercent',
    dataType: DataType['array']
  },
  altTextRangeValue: {
    key: 'altTextRangeValue',
    path: 'properties.dataFormattings.alternativeText.rangeValue',
    dataType: DataType['array']
  },
  altValue: {
    key: 'altValue',
    path: 'properties.dataFormattings.alternativeText.value',
    dataType: DataType['array']
  },

  // properties.dataFormattings.customURL
  customURL: {
    key: 'customURL',
    path: 'properties.dataFormattings.customURL.url',
    dataType: DataType['string']
  },
  customURLOption: {
    key: 'customURLOption',
    path: 'properties.dataFormattings.customURL.option',
    dataType: DataType['string']
  },

  // properties.dataFormattings.embeddedJavascript
  embeddedJavascript: {
    key: 'embeddedJavascript',
    path: 'properties.dataFormattings.embeddedJavascript.script',
    dataType: DataType['string']
  },

  // properties.dataFormattings.subTotal
  subTotalLabel: {
    key: 'subTotalLabel',
    path: 'properties.dataFormattings.subTotal.label',
    dataType: DataType['string']
  },
  subTotalFunction: {
    key: 'subTotalFunction',
    path: 'properties.dataFormattings.subTotal.function',
    dataType: DataType['string']
  },
  subTotalExpression: {
    key: 'subTotalExpression',
    path: 'properties.dataFormattings.subTotal.expression',
    dataType: DataType['string']
  },
  subTotalDataType: {
    key: 'subTotalDataType',
    path: 'properties.dataFormattings.subTotal.dataType',
    dataType: DataType['string']
  },
  subTotalFormatId: {
    key: 'subTotalFormatId',
    path: 'properties.dataFormattings.subTotal.format.formatId',
    dataType: DataType['string']
  },
  subTotalFormat: {
    key: 'subTotalFormat',
    path: 'properties.dataFormattings.subTotal.format.format',
    dataType: DataType['string']
  },
  subTotalPreviewResult: {
    key: 'subTotalPreviewResult',
    path: 'properties.dataFormattings.subTotal.previewResult',
    dataType: DataType['string']
  },
  subTotalFieldDataType: {
    key: 'subTotalFieldDataType',
    path: 'properties.dataFormattings.subTotal.fieldDataType',
    dataType: DataType['string']
  },

  // properties.dataFormattings.grandTotal
  grandTotalLabel: {
    key: 'grandTotalLabel',
    path: 'properties.dataFormattings.grandTotal.label',
    dataType: DataType['string']
  },
  grandTotalFunction: {
    key: 'grandTotalFunction',
    path: 'properties.dataFormattings.grandTotal.function',
    dataType: DataType['string']
  },
  grandTotalExpression: {
    key: 'grandTotalExpression',
    path: 'properties.dataFormattings.grandTotal.expression',
    dataType: DataType['string']
  },
  grandTotalDataType: {
    key: 'grandTotalDataType',
    path: 'properties.dataFormattings.grandTotal.dataType',
    dataType: DataType['string']
  },
  grandTotalFormat: {
    key: 'grandTotalFormat',
    path: 'properties.dataFormattings.grandTotal.format.format',
    dataType: DataType['string']
  },
  grandTotalFormatId: {
    key: 'grandTotalDataType',
    path: 'properties.dataFormattings.grandTotal.format.formatId',
    dataType: DataType['string']
  },
  grandTotalPreviewResult: {
    key: 'grandTotalPreviewResult',
    path: 'properties.dataFormattings.grandTotal.previewResult',
    dataType: DataType['string']
  },
  grandTotalFieldDataType: {
    key: 'grandTotalFieldDataType',
    path: 'properties.dataFormattings.grandTotal.fieldDataType',
    dataType: DataType['string']
  },

  // properties.headerFormating.font
  headerFontFamily: {
    key: 'headerFontFamily',
    path: 'properties.headerFormating.font.family',
    dataType: DataType['string']
  },
  headerFontSize: {
    key: 'headerFontSize',
    path: 'properties.headerFormating.font.size',
    dataType: DataType['number']
  },
  headerFontBold: {
    key: 'headerFontBold',
    path: 'properties.headerFormating.font.bold',
    dataType: DataType['boolean']
  },
  headerFontItalic: {
    key: 'headerFontItalic',
    path: 'properties.headerFormating.font.italic',
    dataType: DataType['boolean']
  },
  headerFormatingFontUnderline: {
    key: 'headerFormatingFontUnderline',
    path: 'properties.headerFormating.font.underline',
    dataType: DataType['boolean']
  },
  headerFontColor: {
    key: 'headerFontColor',
    path: 'properties.headerFormating.font.color',
    dataType: DataType['string']
  },
  headerFontBackgroundColor: {
    key: 'headerFontBackgroundColor',
    path: 'properties.headerFormating.font.backgroundColor',
    dataType: DataType['string']
  },

  headerAlign: {
    key: 'headerAlign',
    path: 'properties.headerFormating.alignment',
    dataType: DataType['string']
  },
  headerWordWrap: {
    key: 'headerWordWrap',
    path: 'properties.headerFormating.wordWrap',
    dataType: DataType['boolean']
  },
  headerColumnGroup: {
    key: 'headerColumnGroup',
    path: 'properties.headerFormating.columnGroup',
    dataType: DataType['string']
  },

  // properties.drillDown.subReport
  subReportSelReport: {
    key: 'subReportSelReport',
    path: 'properties.drillDown.subReport.selectedReport',
    dataType: DataType['string']
  },
  subReportStyle: {
    key: 'subReportStyle',
    path: 'properties.drillDown.subReport.style',
    dataType: DataType['string']
  },
  subReportReportPartUsed: {
    key: 'subReportReportPartUsed',
    path: 'properties.drillDown.subReport.reportPartUsed',
    dataType: DataType['string']
  },
  subReportFilter: {
    key: 'subReportFilter',
    path: 'properties.drillDown.subReport.reportFilter',
    dataType: DataType['boolean']
  },
  subReportMappingFields: {
    key: 'subReportMappingFields',
    path: 'properties.drillDown.subReport.mappingFields',
    dataType: DataType['array']
  },
  subReportSelectedIconValue: {
    key: 'subReportSelectedIconValue',
    path: 'properties.drillDown.subReport.selectedIconValue.value',
    dataType: DataType['string']
  },
  subReportSelectedIcon: {
    key: 'subReportSelectedIcon',
    path: 'properties.drillDown.subReport.selectedIconValue.icon',
    dataType: DataType['string']
  },

  subReportViewSettingByLink: {
    key: 'subReportSelectedIcon',
    path: 'properties.drillDown.subReport.viewSettingByLink',
    dataType: DataType['boolean'],
    needDefaultValue: true
  },

  position: {
    key: 'position',
    path: 'position',
    dataType: DataType['number']
  },

  // field
  fieldId: {
    key: 'fieldId',
    path: 'field.fieldId',
    dataType: DataType['string']
  },
  fieldName: {
    key: 'fieldName',
    path: 'field.fieldName',
    dataType: DataType['string']
  },
  fieldNameAlias: {
    key: 'fieldNameAlias',
    path: 'field.fieldNameAlias',
    dataType: DataType['string']
  },
  dataFieldType: {
    key: 'dataFieldType',
    path: 'field.dataFieldType',
    dataType: DataType['string']
  },
  querySourceId: {
    key: 'querySourceId',
    path: 'field.querySourceId',
    dataType: DataType['string']
  },
  querySourceType: {
    key: 'querySourceType',
    path: 'field.querySourceType',
    dataType: DataType['string']
  },
  sourceAlias: {
    key: 'sourceAlias',
    path: 'field.sourceAlias',
    dataType: DataType['string']
  },
  relationshipId: {
    key: 'relationshipId',
    path: 'field.relationshipId',
    dataType: DataType['string']
  },
  visible: {
    key: 'visible',
    path: 'field.visible',
    dataType: DataType['boolean']
  },
  calculatedTree: {
    key: 'calculatedTree',
    path: 'field.calculatedTree',
    dataType: DataType['string']
  },
  schemaName: {
    key: 'schemaName',
    path: 'field.schemaName',
    dataType: DataType['string']
  },
  querySourceName: {
    key: 'querySourceName',
    path: 'field.querySourceName',
    dataType: DataType['string']
  },
  databaseName: {
    key: 'databaseName',
    path: 'field.databaseName',
    dataType: DataType['string']
  },
  isCalculated: {
    key: 'isCalculated',
    path: 'field.isCalculated',
    dataType: DataType['boolean']
  },

  isDeleted: {
    key: 'isDeleted',
    path: 'isDeleted',
    dataType: DataType['boolean']
  }
};

var InitialFieldPropertiesPaths = (0, _fp.assign)({
  fieldId: FieldPropertiesPaths['fieldId'],
  querySourceId: FieldPropertiesPaths['querySourceId'],
  dataFieldType: FieldPropertiesPaths['dataFieldType'],
  sort: FieldPropertiesPaths['sort']
}, {});

var ExcludeOnHtmlViewPaths = (0, _fp.assign)({
  fieldNameAlias: FieldPropertiesPaths['fieldNameAlias'],
  name: FieldPropertiesPaths['name'],
  fieldName: FieldPropertiesPaths['fieldName'],
  querySourceType: FieldPropertiesPaths['querySourceType'],
  sourceAlias: FieldPropertiesPaths['sourceAlias'],
  schemaName: FieldPropertiesPaths['schemaName'],
  querySourceName: FieldPropertiesPaths['querySourceName'],
  databaseName: FieldPropertiesPaths['databaseName']
}, {});

exports.default = {
  FieldPropertiesPaths: FieldPropertiesPaths,
  InitialFieldPropertiesPaths: InitialFieldPropertiesPaths,
  ExcludeOnHtmlViewPaths: ExcludeOnHtmlViewPaths
};
module.exports = exports['default'];

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _Izenda = __webpack_require__(88);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _momentTimezone = __webpack_require__(276);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _Izenda3 = __webpack_require__(132);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(271);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(35);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

__webpack_require__(55);

var _Izenda9 = __webpack_require__(600);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormSmartTag.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ReportPartFormSmartTag = function () {
  (0, _createClass3.default)(ReportPartFormSmartTag, [{
    key: 'isValidSubTotalSmartTag',
    get: function get() {
      var fieldHasConfigSubtotal = (0, _fp.get)('fieldInfo.hasSubTotal', this.configField);
      return !(0, _fp.isEmpty)(this.configField) && this.repeaterLevel <= this.configField.fieldInfo.repeaterLevel && fieldHasConfigSubtotal;
    }
  }, {
    key: 'isValidSubTotalSmartTagLevel',
    get: function get() {
      return this.repeaterLevel <= (0, _fp.get)('configField.fieldInfo.repeaterLevel', this);
    }
  }]);

  function ReportPartFormSmartTag() {
    var smartTagConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ReportPartFormSmartTag);
    this.configField = {};
    this.subTotalDom = null;
    this.type = null;
    this.setRepeaterLevel = null;
    this.name = null;

    this.subTotalDom = smartTagConfig.subTotalDom;
    this.name = smartTagConfig.name;
    this.type = smartTagConfig.type;
    this.configField = smartTagConfig.configField;
    this.repeaterLevel = smartTagConfig.repeaterLevel;
  }

  /**
   * Check if the field is set to invisible
   * @param {Object} field
   */


  (0, _createClass3.default)(ReportPartFormSmartTag, [{
    key: 'isFieldInvisible',
    value: function isFieldInvisible(field) {
      return $izenda(field).find('field-prop[key=\'isFieldVisible\'][value=\'false\']').length > 0;
    }

    /**
     * Get smart tag html
     * @param {String} html
     * @returns {Object} smart tag html
     */

  }, {
    key: 'generateDateTimeSmartTag',
    value: function generateDateTimeSmartTag(htmlContent) {
      var datetimeList = $izenda('<div>' + htmlContent + '</div>').find('datetime');
      datetimeList.each(function (index, datetime) {
        var datetimeFormat = $izenda(datetime).text();
        var datetimeFormated = (0, _Izenda2.default)(datetimeFormat, (0, _momentTimezone2.default)());
        htmlContent = htmlContent.replace($izenda(datetime).get(0).outerHTML, datetimeFormated);
      });

      return htmlContent;
    }

    /**
     * Get smart tag html
     * @param {Array} sub total mapping
     * @param {Object} data records
     * @param {String} html content
     * @returns {Object} smart tag html
     */

  }, {
    key: 'generateGrandTotalSmartTag',
    value: function generateGrandTotalSmartTag(fieldElements, grandTotalMappingList, records, htmlContent) {
      var _this = this;

      var htmlDOM = $izenda('<div>' + htmlContent + '</div>');
      var grandTotalDOMList = $izenda(htmlDOM).find('grandtotal');
      var results = [];

      grandTotalDOMList.each(function (index, grandTotalDOM) {
        var grandTotalMapping = (0, _fp.find)({ fieldNameAlias: (0, _fp.trim)(grandTotalDOM.textContent) }, grandTotalMappingList);
        var validateResult = _this.validateGrandTotalSmartTag(grandTotalMapping, htmlDOM, grandTotalDOM);
        var fieldElement = (0, _fp.find)({ fieldName: (0, _fp.get)('fieldNameAlias', grandTotalMapping) }, fieldElements);
        var dataType = (0, _fp.get)('properties.dataFormattings.grandTotal.dataType', fieldElement);
        var grandTotal = (0, _fp.get)('properties.dataFormattings.grandTotal.format', fieldElement);

        var formattedData = grandTotal && _Izenda8.default.applyFormater(dataType, grandTotal.format, records[0][grandTotalMapping.columnName]);
        if ((0, _fp.isNil)(validateResult)) {
          results.push({
            dom: $izenda(grandTotalDOM).get(0).outerHTML,
            data: formattedData || records[0][grandTotalMapping.columnName]
          });
        } else {
          results.push({
            dom: $izenda(grandTotalDOM).get(0).outerHTML,
            data: validateResult
          });
        }
      });

      (0, _fp.forEach)(function (r) {
        htmlContent = htmlContent.replace(r.dom, r.data);
      }, results);

      return htmlContent;
    }

    /**
     * Get smart tag html
     * @param {Array} sub total mapping
     * @param {Object} data records
     * @param {String} html content
     * @returns {Object} smart tag html
     */

  }, {
    key: 'validateSubTotalSmartTag',
    value: function validateSubTotalSmartTag(subTotalMapping, htmlContent, subTotalDOM) {
      // Find field by sub total
      var subtotalFieldName = $izenda(subTotalDOM).text().trim();
      var subtotalField = void 0;
      var htmlDOM = $izenda('<div>' + htmlContent + '</div>');
      $izenda(htmlDOM).find('field').each(function (index, field) {
        if ($izenda(field).text().trim() === subtotalFieldName) {
          subtotalField = field;
          return;
        }
      });

      if ((0, _fp.isNil)(subtotalField)) {
        return '&lt;subtotal&gt;' + subtotalFieldName + '&lt;/subtotal&gt;';
      }

      if ((0, _fp.isNil)(subTotalMapping)) {
        return this.isFieldInvisible(subtotalField) ? '' : String.format(_Izenda4.default.MESSAGES.M06, subtotalFieldName);
      }

      if (this.isFieldInvisible(subtotalField)) {
        return '';
      }

      var isWithin = checkFieldWithinRepeater(htmlContent, _Izenda6.default.REPEATER_START, _Izenda6.default.REPEATER_END);
      !isWithin && (isWithin = checkFieldWithinRepeater(htmlContent, _Izenda6.default.REPEATER_START_FORTABLE, _Izenda6.default.REPEATER_END_FORTABLE));
      if (!isWithin) {
        return String.format(_Izenda4.default.MESSAGES.M07, subtotalFieldName);
      }

      return null;

      function checkFieldWithinRepeater(htmlContent, startTemplate, endTemplate) {
        if (htmlContent.indexOf(startTemplate) === -1) return false;

        var outerHtmlField = $izenda(subtotalField).get(0).outerHTML;
        var latestBeginRepeater = htmlContent.lastIndexOf(startTemplate);
        var endRepeaterOfLatestRepeater = htmlContent.indexOf(endTemplate, latestBeginRepeater) + endTemplate.length;
        var latestRepeaterContent = htmlContent.substring(latestBeginRepeater, endRepeaterOfLatestRepeater);

        var tmpHtml = '<div>' + latestRepeaterContent + '</div>';
        var content = $izenda(tmpHtml).get(0).outerHTML;

        if (content.indexOf(outerHtmlField) > -1) {
          return true;
        }

        var newHtmlContent = htmlContent.replace(latestRepeaterContent, '');
        return checkFieldWithinRepeater(newHtmlContent, startTemplate, endTemplate);
      }
    }

    /**
     * Get smart tag html
     * @param {Array} sub total mapping
     * @param {Object} data records
     * @param {String} html content
     * @returns {Object} smart tag html
     */

  }, {
    key: 'validateGrandTotalSmartTag',
    value: function validateGrandTotalSmartTag(grandTotalMapping, htmlDOM, grandTotalDOM) {
      if ($izenda(grandTotalDOM).find('field').length > 0) {
        return _Izenda4.default.MESSAGES.M13;
      }

      var grandtotalFieldName = grandTotalDOM.textContent;
      var grandtotalField = void 0;
      $izenda(htmlDOM).find('field').each(function (index, field) {
        if ((0, _fp.trim)($izenda(field).text()) === (0, _fp.trim)(grandtotalFieldName)) {
          grandtotalField = field;
          return;
        }
      });

      if ((0, _fp.isNil)(grandtotalField)) {
        return '&lt;grandtotal&gt;' + grandtotalFieldName + '&lt;/grandtotal&gt;';
      }

      if ((0, _fp.isNil)(grandTotalMapping)) {
        return this.isFieldInvisible(grandtotalField) ? '' : String.format(_Izenda4.default.MESSAGES.M09, grandtotalFieldName);
      }

      if (this.isFieldInvisible(grandtotalField)) {
        return '';
      }

      return null;
    }

    /**
     * Insert Embedded Report HTML
     * @param  {Array} List data of report part object
     * @return {String} embedded report html
     */

  }, {
    key: 'updateGrandTotalHtml',
    value: function updateGrandTotalHtml(fieldName, selectedElement) {
      var grandTotalHtml = String.format('<grandtotal class=\'field-wrapper\'><span class=\'icon-grandtotal\'></span>{0}</grandtotal>', fieldName);

      selectedElement.outerHTML = grandTotalHtml;
    }

    /**
     * Insert Embedded Report HTML
     * @param  {Array} List data of report part object
     * @return {String} embedded report html
     */

  }, {
    key: 'updateSubTotalHtml',
    value: function updateSubTotalHtml(fieldName, selectedElement) {
      var subTotalHtml = String.format('<subtotal class=\'field-wrapper\'><span class=\'icon-subtotal\'></span>{0}</subtotal>', fieldName);

      selectedElement.outerHTML = subTotalHtml;
    }

    /**
     * Check repeater has parallel.
     * @param {Array} repeaterNode
     */

  }, {
    key: 'checkParallelInRepeater',
    value: function checkParallelInRepeater(repeaterNode) {
      if ((0, _fp.isNil)(repeaterNode)) return false;

      return (0, _fp.get)('childNodes.length', repeaterNode) > 1;
    }

    /**
     * Split string by place holdes
     * @param {String} originString
     * @param {Array}  placeHolderKeys
     * @return {Array}
     */

  }, {
    key: 'splitByPlacesHolders',
    value: function splitByPlacesHolders(originString, placeHolderKeys) {
      var result = [];
      (0, _fp.forEach)(function (item) {
        if ((0, _fp.isEmpty)(result)) {
          result = originString.split(item);
        } else {
          var chunks = [];
          (0, _fp.forEach)(function (subString) {
            chunks = (0, _fp.concat)(chunks, subString.split(item));
          }, result);
          result = chunks;
        }
      }, placeHolderKeys);
      return result;
    }

    /**
     *
     * @param {Array} repeaterNode
     * @param {String} newHTMLContent
     * @param {Boolean} isParallel
     */

  }, {
    key: 'validateSubTotalSmartTagInRepeater',
    value: function validateSubTotalSmartTagInRepeater(repeaterNode, htmlContent, isParallel) {
      var _this2 = this;

      var newHTMLContent = htmlContent;
      if ((0, _fp.isNil)(repeaterNode.placeHolderPattern)) return;
      var smartTagInContent = repeaterNode.smartTagInContent;

      if (!(0, _fp.isEmpty)(repeaterNode.placeHolderKey)) {
        var splitByPlaceHolderKey = this.splitByPlacesHolders(repeaterNode.placeHolderPattern, repeaterNode.placeHolderKey);

        (0, _fp.forEach)(function (item) {
          newHTMLContent = _this2.validateBySubTotalDom(item, smartTagInContent, newHTMLContent, isParallel);
        }, splitByPlaceHolderKey);

        isParallel = isParallel || this.checkParallelInRepeater(repeaterNode);

        // call recusive
        (0, _fp.forEach)(function (item) {
          newHTMLContent = _this2.validateSubTotalSmartTagInRepeater(item, newHTMLContent, isParallel);
        }, repeaterNode.childNodes);
      } else {
        newHTMLContent = this.validateBySubTotalDom(repeaterNode.placeHolderPattern, smartTagInContent, newHTMLContent, isParallel);
      }
      return newHTMLContent;
    }

    /**
     * Generate new html for subtotal smartag
     * @param {String} htmlContent
     * @param {Array} repeaterNodes
     */

  }, {
    key: 'validationSubTotalSmartTag',
    value: function validationSubTotalSmartTag(htmlContent, repeaterNodes) {
      var repeaterNode = (0, _fp.head)(repeaterNodes);
      if ((0, _fp.isNil)(repeaterNode)) return htmlContent;

      return this.validateSubTotalSmartTagInRepeater(repeaterNode, htmlContent, false);
    }

    /**
     * Validate smart tag by subtotal dom
     * @param {string} placeHolderPattern
     * @param {Object} smartTagInContent
     * @param {string} newHTMLContent
     */

  }, {
    key: 'validateBySubTotalDom',
    value: function validateBySubTotalDom(placeHolderPattern, smartTagInContent, newHTMLContent, isParallel) {
      var newHTML = placeHolderPattern;
      var subtotalDoms = this.getSubTotalsByHtml(placeHolderPattern);
      subtotalDoms.each(function (index, subTotalDOM) {
        var subtotal = $izenda(subTotalDOM).get(0).outerHTML;
        var smartTagConfig = (0, _fp.find)(['name', (0, _fp.trim)(subTotalDOM.textContent)], smartTagInContent);
        var validSubtotal = (0, _fp.get)('configField.fieldInfo.hasSubTotal', smartTagConfig);
        var subtotalFieldName = (0, _fp.trim)(subTotalDOM.textContent);
        var startIndex = newHTMLContent.indexOf(newHTML);
        var startLength = newHTML.length;
        var errorMessage = subtotal;

        switch (true) {
          // check smart tag has config field
          case (0, _fp.isNil)((0, _fp.get)('configField.fieldInfo', smartTagConfig)):
            errorMessage = '&lt;subtotal&gt;' + subtotalFieldName + '&lt;/subtotal&gt;';
            break;
          // check config field is visible
          case !(0, _fp.get)('configField.fieldInfo.isVisible', smartTagConfig):
            errorMessage = '';
            break;
          // check field out side repeater
          case smartTagConfig.configField.fieldInfo && smartTagConfig.configField.fieldInfo.repeaterLevel === 0:
            errorMessage = String.format(_Izenda4.default.MESSAGES.M07, subtotalFieldName);
            break;
          // check field parallel
          case isParallel:
            errorMessage = _Izenda4.default.MESSAGES.ERROR_MESSAGE_FOR_SUBTOTAL_IN_PARALLEL;
            break;
          // check smart tag lower level with config field
          case !smartTagConfig.isValidSubTotalSmartTagLevel:
            errorMessage = _Izenda4.default.MESSAGES.ERROR_MESS_IN_LOW_LEVEL;
            break;
          case smartTagConfig.configField && !validSubtotal:
            // check config field has already config subtotal
            errorMessage = String.format(_Izenda4.default.MESSAGES.M06, subtotalFieldName);
            break;
        }

        if (!(startIndex < 0) && errorMessage !== subtotal) {
          newHTML = newHTML.replace(subtotal, errorMessage);
          newHTMLContent = String.replaceAt(newHTMLContent, startIndex, startLength, newHTML);
        }
      });

      return newHTMLContent;
    }

    /**
     *get subtotal dom by html content
     * @param {*} htmlContent
     */

  }, {
    key: 'getSubTotalsByHtml',
    value: function getSubTotalsByHtml(htmlContent) {
      var htmlDOM = $izenda('<div>' + htmlContent + '</div>');
      return $izenda(htmlDOM).find('subtotal');
    }
  }]);
  return ReportPartFormSmartTag;
}();

exports.default = ReportPartFormSmartTag;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _Izenda = __webpack_require__(35);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(271);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(599);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(34);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(16);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(318);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(76);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(316);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(246);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(41);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartFormField = function () {
  function ReportPartFormField() {
    (0, _classCallCheck3.default)(this, ReportPartFormField);
  }

  (0, _createClass3.default)(ReportPartFormField, [{
    key: 'showValue',
    value: function showValue(value) {
      return String.commonStringValue(value, _Izenda20.default.advancedSettings.other.convertNullToEmptyStringValue);
    }

    /**
     * Generate field html
     * @param {Object} field mapping list
     * @param {Object} records
     * @param {Object} properties
     * @param {Object} data tree
     * @param {Object} visible elements
     * @param {String} html content
     * @param {String} report Id
     * @returns {Object} { htmlContent, embeddedSubReports }
     */

  }, {
    key: 'generateField',
    value: function generateField(props, fieldsMapping, records, properties, dataTree, visibleElement, newHtmlContent, reportId, filterForSubReport) {
      var _this = this;

      var listFields = $izenda('<div>' + newHtmlContent + '</div>').find('field');
      var embeddedSubReports = [];
      var printingMode = props.printingMode,
          reportPart = props.reportPart,
          viewMode = props.viewMode;


      if (!(0, _fp.isEmpty)(listFields)) {
        var result = '';
        var cachedData = {};
        var pagebreakHtml = _Izenda4.default.PAGE_BREAK_HTML;
        var fieldNameAliases = buildListOfFieldNameAlias(listFields);
        var validationContext = {
          dataTree: dataTree,
          fieldNameAliases: fieldNameAliases
        };

        listFields.each(function (index, item) {
          // Get column name from fields mapping and field info from elements to config
          var textContent = (0, _fp.trim)(item.textContent);
          var fieldMapping = (0, _fp.find)({ fieldNameAlias: textContent }, fieldsMapping) || {};
          var fieldInfo = (0, _fp.find)({ fieldName: textContent }, visibleElement) || {};

          var detail = null;
          if (!(0, _fp.get)('isVisible', fieldInfo)) {
            detail = {
              invisible: true,
              index: index
            };
          } else {
            var validationResult = _this.validateField(item, validationContext);

            if (!printingMode && !viewMode && validationResult) {
              detail = {
                error: validationResult,
                index: index
              };
            } else {
              detail = {
                value: fieldMapping.columnName,
                fieldInfo: fieldInfo,
                index: index
              };
            }
          }

          cachedData[item.outerHTML] = detail;
        });

        records.forEach(function (record, index) {
          var newContent = newHtmlContent;
          var domContent = $izenda('<div>' + newHtmlContent + '</div>');
          var listFields = domContent.find('field');

          (0, _fp.mapKeys)(function (key) {
            var newText = cachedData[key].error;
            var fieldInfo = cachedData[key].fieldInfo;

            if (!(0, _fp.get)('invisible', cachedData[key]) && (0, _fp.isNil)(newText) && fieldInfo.properties) {
              var columnName = cachedData[key].value;

              var mapValue = _Izenda2.default.getFieldValue(columnName, record);
              mapValue.value = _this.showValue(mapValue.value);

              var indexHtml = newHtmlContent.indexOf(key);

              var data = _this.formatField({
                reportPartElm: fieldInfo,
                columnName: columnName
              }, mapValue, reportId, index, reportPart, record, fieldsMapping, filterForSubReport, indexHtml);
              newText = data.newText;
              if (!(0, _fp.isEmpty)(data.embeddedSubReports)) {
                embeddedSubReports = embeddedSubReports.concat(data.embeddedSubReports);
              }
            }

            $izenda(listFields.get(cachedData[key].index)).replaceWith(newText);
            newContent = domContent.html();
          }, cachedData);

          // Page Break After Each Entry
          if (properties && properties.pageBreakAfterEachEntry && props.printingMode) {
            newContent = _Izenda14.default.replaceFormStyles(props, newContent);
            newContent += pagebreakHtml;
          }

          result += newContent;
        });

        // Handle if haven't records return, so only replace field element with ''
        if ((0, _fp.isEmpty)(records)) {
          result = newHtmlContent;
          (0, _fp.mapKeys)(function (key) {
            result = result.replace(key, '');
          }, cachedData);
        }

        return {
          htmlContent: result,
          embeddedSubReports: embeddedSubReports
        };
      }
      return {
        htmlContent: newHtmlContent,
        embeddedSubReports: embeddedSubReports
      };

      /**
       * Build list of field name alias.
       * @param  {Array} listFields
       */
      function buildListOfFieldNameAlias(listFields) {
        return (0, _fp.map)(function (field) {
          return (0, _fp.trim)($izenda(field).text());
        }, listFields);
      }
    }
    /**
     * Format fields
     * @param {Object} field information
     * @param {Object} value
     * @param {String} report id
     * @param {Number} index
     * @param {Object} report part
     * @param {Object} record data
     * @returns {Object} fields
     */

  }, {
    key: 'formatField',
    value: function formatField(field, mapValue, reportId, index, reportPart, record, fieldsMapping, filterForSubReport, indexHtml) {
      var _this2 = this;

      var fieldInfo = field.reportPartElm;
      var embeddedSubReports = [];
      var fieldInfoProperties = fieldInfo.properties;
      var dataFormattings = fieldInfoProperties.dataFormattings;
      var dataType = fieldInfo.previewDataType;

      var subReportConfig = (0, _fp.getOr)({}, 'drillDown.subReport', fieldInfoProperties);

      var newText = this.getTextWithFormat(dataFormattings, mapValue, dataType, field, record);

      if (subReportConfig.selectedReport && subReportConfig.style === _Izenda10.default.DRILL_DOWN_STYLE_OPTION_VALUES.embedded) {
        var subReportFilter = this.getSubReportQuery(fieldInfo, record, fieldsMapping, reportId, reportPart, filterForSubReport);
        // CustomURLLink and EmbededJavasript link/icon
        var divText = this.applySubReportEmbedded(newText, fieldInfo, index);
        if ((0, _fp.isBoolean)(subReportFilter.success) && !subReportFilter.success) {
          divText = divText + ('<div>' + subReportFilter.errors + '</div>');
        } else {
          var listEmbededReportPart = _Izenda12.default.readEmbededReportDef(reportPart, fieldInfo);

          listEmbededReportPart.forEach(function (reportPartDef) {
            var reportPartObject = _this2.getSubReportObject(fieldInfo, index, reportPartDef.id, (0, _fp.omit)(['success'], subReportFilter), reportPartDef);
            divText = divText + ('<div class="u_fullWidth ' + reportPartObject.reportPartDomId + '"></div>');
            reportPartObject.index = indexHtml;
            embeddedSubReports.push(reportPartObject);
          });
        }

        newText = divText;
      } else {
        newText = this.applyHyperLink(newText, fieldInfo, index);
      }

      return {
        newText: newText,
        embeddedSubReports: embeddedSubReports
      };
    }

    /**
     * Get text with format
     * @param {Object} data formatting list
     * @param {Object} mapValue
     * {
     *  originalValue:
        value:
       }
     * @param {String} data type
     * @returns {String} text with format
     */

  }, {
    key: 'getTextWithFormat',
    value: function getTextWithFormat(dataFormattings, mapValue, dataType, field, record) {
      var font = dataFormattings.font;
      var fieldInfo = field.reportPartElm;
      var originalValue = mapValue.originalValue,
          value = mapValue.value;

      if (_Izenda16.default.isImage(fieldInfo.field.dataFieldType)) {
        return String.format('<img src=\'{0}\' />', value);
      }

      var formatSource = {
        element: field,
        record: record
      };
      var textColor = _Izenda2.default.getConfigDataByRange(originalValue, dataFormattings.color.textColor, formatSource);
      var backgroundColor = _Izenda2.default.getConfigDataByRange(originalValue, dataFormattings.color.cellColor, formatSource);
      var styles = '';

      if (font.family !== _Izenda8.default.defaultFontFamily) {
        styles += String.format('font-family:{0};', font.family);
      }

      if (font.size !== _Izenda8.default.defaultFontSize) {
        styles += String.format('font-size:{0}px;', font.size);
      }

      styles += font.bold ? 'font-weight:bold;' : '';
      styles += font.italic ? 'font-style:italic;' : '';
      styles += font.underline ? 'text-decoration:underline;' : '';
      styles += textColor ? 'color:' + textColor + ';' : '';
      styles += backgroundColor ? String.format('background-color:{0};', backgroundColor) : '';

      var valueFormated = _Izenda2.default.getDataFormat(mapValue, {
        alternativeText: dataFormattings.alternativeText,
        fieldFormatData: dataFormattings.format.format,
        fieldDataType: dataType
      }, formatSource);

      return '<span style="' + styles + '">' + valueFormated + '</span>';
    }
  }, {
    key: 'applySubReportEmbedded',
    value: function applySubReportEmbedded(originalText, fieldInfo, index) {
      var fieldInfoProperties = fieldInfo.properties;

      var customURLAttribute = 'data-selectedfieldname="' + encodeURI((0, _stringify2.default)(fieldInfo.fieldName)) + '" data-recordIndex="' + index + '" data-hyperlinkaction="true" data-isCustomURL="true"';
      var customURL = (0, _fp.get)('customURL', fieldInfoProperties);
      var customUrlIcon = (0, _fp.get)('url', customURL) && (0, _fp.get)('selectedIconValue.icon', customURL);
      var customURLLink = customUrlIcon && String.format('<span {1} class="{0}" />', customUrlIcon, customURLAttribute);

      var embeddedJsAttribute = 'data-selectedfieldname="' + encodeURI((0, _stringify2.default)(fieldInfo.fieldName)) + '" data-recordIndex="' + index + '" data-hyperlinkaction="true" data-isEmbeddedJavascript="true"';

      var embeddedJavascript = (0, _fp.get)('embeddedJavascript', fieldInfoProperties);
      var embeddedJavascriptIcon = (0, _fp.get)('script', embeddedJavascript) && (0, _fp.get)('selectedIconValue.icon', embeddedJavascript);
      var embeddedJavascriptLink = embeddedJavascriptIcon && String.format('<span {1} class="{0}" />', embeddedJavascriptIcon, embeddedJsAttribute);

      return [customURLLink, embeddedJavascriptLink].join('');
    }
  }, {
    key: 'applyHyperLink',
    value: function applyHyperLink(text, fieldInfo, index) {
      var fieldInfoProperties = fieldInfo.properties;
      var subReportConfig = (0, _fp.get)('subReport', fieldInfoProperties);
      var customURL = (0, _fp.get)('customURL', fieldInfoProperties);
      var embeddedJavascript = (0, _fp.get)('embeddedJavascript', fieldInfoProperties);

      var numberOfPointActions = fieldInfo.numberOfPointActions;

      var attribute = 'data-selectedfieldname="' + encodeURI((0, _stringify2.default)(fieldInfo.fieldName)) + '" data-recordIndex="' + index + '" data-hyperlinkaction="true"';

      var isLink = false;
      var icon = void 0;
      if (numberOfPointActions === 1) {
        subReportConfig.selectedReport && (subReportConfig.viewSettingByLink ? isLink = true : icon = subReportConfig.selectedIconValue.icon);
        customURL.url && (customURL.viewSettingByLink ? isLink = true : icon = customURL.selectedIconValue.icon);
        embeddedJavascript.script && (embeddedJavascript.viewSettingByLink ? isLink = true : icon = embeddedJavascript.selectedIconValue.icon);
      } else if (numberOfPointActions > 1) {
        isLink = true;
      } else if (numberOfPointActions === 0) {
        return text;
      }

      if (isLink) {
        return '<a ' + attribute + ' >' + text + '</any>';
      }
      return '<a class="' + icon + '" ' + attribute + ' ></any>' + text;
    }

    /**
     * Validate a field by its field-name attribute.
     * @param  {Object} field
     * @param  {Object} context
     */

  }, {
    key: 'validateField',
    value: function validateField(field, context) {
      return _Izenda6.default.validateField(field, context);
    }

    /**
     * Update container field
     * @return {[type]} [description]
     */

  }, {
    key: 'updateContainerField',
    value: function updateContainerField(elements, content) {
      var fields = $izenda('<div>' + content + '</div>').find('field');
      var arrayTempFields = [];

      if (fields.length === elements.length) {
        return null;
      }

      fields.each(function (index, item) {
        arrayTempFields.push({
          fieldName: item.textContent
        });
      });

      return (0, _fp.intersectionBy)('fieldName', elements, arrayTempFields);
    }

    /**
     * Get subReport object for embedded ReportPart
     * @return {Object} subReportObject
     */

  }, {
    key: 'getSubReportObject',
    value: function getSubReportObject(fieldInfo, index, reportPartUsed, subReportFilter, reportPartDef) {
      var embeddedReportPartId = ['EmbededSubReport', index, reportPartUsed, fieldInfo.position].join('_');

      return {
        id: reportPartUsed,
        reportPartDomId: embeddedReportPartId,
        queryObject: subReportFilter,
        reportPartDef: reportPartDef,
        fieldInfo: fieldInfo
      };
    }

    /**
     *get subReport queryObject for embedded ReportPart
     * @return {Object} [description]
     */

  }, {
    key: 'getSubReportQuery',
    value: function getSubReportQuery(fieldInfo, data, previewDataFieldsMapping, reportId, reportPart, overideFilterValue) {
      var fieldInfoProperties = fieldInfo.properties;
      var subReportConfig = (0, _fp.get)('subReport', fieldInfoProperties);
      var rawRecord = [data];

      var filters = _Izenda18.default.buildFilterDataCommon(rawRecord, subReportConfig.mappingFields, reportPart);

      if (!filters.success) {
        return filters;
      }
      return _Izenda18.default.buildFilterDataForEmbededReportPart(filters.fieldMapping, reportPart, subReportConfig, overideFilterValue);
    }
  }]);
  return ReportPartFormField;
}();
// $FlowFixMe

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = ReportPartFormField;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SolidGaugeOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(424);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(220);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(171);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

var _Izenda9 = __webpack_require__(49);

var _Izenda10 = __webpack_require__(35);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TICK_COLOR = '#f2f2f2';

var SolidGaugeOptionsBuilder = (_dec = (0, _Izenda9.exportClass)('SolidGaugeOptionsBuilder'), _dec(_class = function (_HighchartOptionsBuil) {
  (0, _inherits3.default)(SolidGaugeOptionsBuilder, _HighchartOptionsBuil);

  function SolidGaugeOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, SolidGaugeOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = SolidGaugeOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(SolidGaugeOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */


  (0, _createClass3.default)(SolidGaugeOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
      var izendaOptions = userOptions.izendaOptions;

      var min = Math.floor(izendaOptions.scaleFrom);
      var max = Math.ceil(izendaOptions.scaleTo);

      var serieName = izendaOptions.serieName;
      var plotBands = izendaOptions.threshold ? getPlotBands(izendaOptions.threshold, min, max) : [];
      var valueData = (0, _fp.get)('[0].data[0].y', userOptions.series);

      userOptions.yAxis = {};

      return {
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        chart: {
          events: {
            click: _Izenda4.default.onDrilldownGauge(userOptions, (0, _fp.head)(userOptions.series))
          }
        },
        title: {
          text: (0, _fp.get)('showLabels', izendaOptions) ? serieName : '',
          verticalAlign: 'top',
          floating: true,
          style: {
            fontSize: '13px'
          }
        },
        plotOptions: {
          series: {
            events: {
              click: undefined
            },
            dataLabels: {
              crop: false,
              overflow: 'none',
              enabled: true,
              useHTML: true,
              y: 0,
              borderWidth: 0,
              formatter: getFormatData
            },
            zones: getZones(plotBands, valueData)
          }
        },

        yAxis: {
          title: {
            enabled: false
          },
          min: min,
          max: max,

          labels: {
            formatter: getFormatLabel
          },
          plotBands: plotBands,
          tickLength: 0,
          tickWidth: 0,
          tickColor: TICK_COLOR,
          gridLineColor: TICK_COLOR,
          gridLineWidth: 0,
          minorTickInterval: 0,
          minorTickWidth: 0,
          minorGridLineWidth: 0
        }
      };

      function getFormatLabel() {
        var val = this.value;

        if (val === min) {
          val = izendaOptions.scaleFrom;
        } else if (val === max) {
          val = izendaOptions.scaleTo;
        }

        return getDataFormat(val, false);
      }

      function getFormatData() {
        return getDataFormat(this.value || this.y, true);
      }

      function getDataFormat(value, isApplyAlternativeText) {
        var record = (0, _fp.flow)(_fp.head, (0, _fp.get)('data'), _fp.head, (0, _fp.get)('record'))(userOptions.series);
        var element = (0, _fp.flow)(_fp.head, (0, _fp.get)('yAxisField'))(userOptions.series);

        var fieldValues = _Izenda11.default.getFieldValue(element.columnName, record);
        var jsFormatString = (0, _fp.get)('reportPartElm.properties.dataFormattings.format.jsFormatString', element);
        var jsFormatId = (0, _fp.get)('reportPartElm.properties.dataFormattings.format.formatId', element);
        fieldValues.value = jsFormatString ? _Izenda6.default.format(jsFormatId, value) : value;

        return dataParser.getFormatData(fieldValues, izendaSeriesConfig[serieName], {
          record: record,
          element: element
        }, isApplyAlternativeText);
      }

      function getPlotBands(thresholds, min, max) {
        // convert from izenda form to highchart-form
        return thresholds ? thresholds : [];
      }

      function getZones(thresholds, valueData) {
        var zones = thresholds.map(function (threshold) {
          return {
            value: threshold.to,
            color: threshold.color
          };
        });

        if (!zones.length) {
          return zones;
        }

        // highcharts trick- for zone, data range [a,b); [b,c)
        // for cases valueData = zone[last][value] >> need to be plus 1
        zones[zones.length - 1].value = Math.max(zones[zones.length - 1].value, max, valueData) + 1;
        return zones;
      }
    }
  }]);
  return SolidGaugeOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = SolidGaugeOptionsBuilder;
module.exports = exports['default'];

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Version.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  module.exports = {
    VERSION: '2.18.0'
  };
}();

/***/ }),
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ContextMenuStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var AuthorizationConstants = __webpack_require__(42);
  var LicenseCheckerConstants = __webpack_require__(45);
  var localizer = __webpack_require__(12);
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isNil = _require.isNil,
      lowerFirst = _require.lowerFirst,
      forEach = _require.forEach,
      find = _require.find,
      placeholder = _require.placeholder;

  var menuDefinition = [{
    key: 'setupAndLicense',
    icon: 'icon-key',
    forSystemAdmin: true,
    get title() {
      return localizer.getText('CONTEXT_MENU_LABEL_SYSTEM_DB_LICENSE');
    }
  }, {
    key: 'tenantManagement',
    icon: 'icon-group',
    forSystemUser: true,
    forMultipleTenant: true,
    get title() {
      return localizer.getText('CONTEXT_MENU_LABEL_TENANT_SETUP');
    },
    permissionKeys: [AuthorizationConstants.PERMISSION_KEY.TenantSetupActionsCreate, AuthorizationConstants.PERMISSION_KEY.TenantSetupActionsEdit, AuthorizationConstants.PERMISSION_KEY.TenantSetupActionsDel, AuthorizationConstants.PERMISSION_KEY.TenantSetupPermissionsValue],
    permissionOperator: AuthorizationConstants.PERMISSION_OPERATOR.Or
  }, {
    key: 'dataSetup',
    icon: 'icon-datasetup',
    get title() {
      return localizer.getText('CONTEXT_MENU_LABEL_DATA_SETUP');
    },
    isDirty: false,
    permissionKeys: [AuthorizationConstants.PERMISSION_KEY.DataSetupDataModelValue, AuthorizationConstants.PERMISSION_KEY.DataSetupAdvancedSettingsCategory, AuthorizationConstants.PERMISSION_KEY.DataSetupAdvancedSettingsOthers],
    permissionOperator: AuthorizationConstants.PERMISSION_OPERATOR.Or,
    items: [{
      key: 'connectionString',
      icon: 'icon-connectionstring',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_CONNECTION_STRING');
      },
      isDirty: false,
      forSystemAdmin: true
    }, {
      key: 'dataModel',
      icon: 'icon-datamodel',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_DATA_MODEL');
      },
      isDirty: false,
      needConnectionString: true,
      isDisabled: false,
      permissionKeys: [AuthorizationConstants.PERMISSION_KEY.DataSetupDataModelValue]
    }, {
      key: 'advanceSettings',
      icon: 'icon-advancesetting',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_ADVANCED_SETTINGS');
      },
      isDisabled: false,
      permissionKeys: function permissionKeys() {
        return function () {
          // Check user is a system user.
          if (uiState.currentUser.systemAdmin) return true;

          // check others
          return this.checkPrivileges([AuthorizationConstants.PERMISSION_KEY.DataSetupAdvancedSettingsCategory, AuthorizationConstants.PERMISSION_KEY.DataSetupAdvancedSettingsOthers], AuthorizationConstants.PERMISSION_OPERATOR.Or);
        };
      }
    }, {
      key: 'copyManagement',
      icon: 'icon-copy-mng',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_COPY_MANAGEMENT');
      },
      isDisabled: false,
      forSystemAdmin: true,
      forMultipleTenant: true
    }, {
      key: 'databaseMapping',
      icon: 'icon-mapping',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_DATABASE_MAPPING');
      },
      isDisabled: false,
      forSystemAdmin: true,
      forMultipleTenant: true
    }, {
      key: 'import',
      icon: 'icon-import',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_IMPORT');
      },
      isDisable: false,
      forSystemAdmin: true
    }, {
      key: 'importHistory',
      icon: 'icon-import-history',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_IMPORT_HISTORY');
      },
      isDisable: false,
      forSystemAdmin: true
    }]
  }, {
    key: 'roleSetup',
    icon: 'icon-group',
    get title() {
      return localizer.getText('CONTEXT_MENU_LABEL_ROLE_SETUP');
    },
    permissionKeys: [AuthorizationConstants.PERMISSION_KEY.RoleSetupActionsCreate, AuthorizationConstants.PERMISSION_KEY.RoleSetupActionsEdit, AuthorizationConstants.PERMISSION_KEY.RoleSetupActionsDel, AuthorizationConstants.PERMISSION_KEY.RoleSetupDataModelAccessValue, AuthorizationConstants.PERMISSION_KEY.RoleSetupPermissionsValue, AuthorizationConstants.PERMISSION_KEY.RoleSetupGrantRoleWithFullReportAndDashboardAccessValue],
    permissionOperator: AuthorizationConstants.PERMISSION_OPERATOR.Or
  }, {
    key: 'userSetup',
    icon: 'icon-useradmin',
    get title() {
      return localizer.getText('CONTEXT_MENU_LABEL_USER_SETUP');
    },
    permissionKeys: [AuthorizationConstants.PERMISSION_KEY.UserSetupActionsCreate, AuthorizationConstants.PERMISSION_KEY.UserSetupActionsEdit, AuthorizationConstants.PERMISSION_KEY.UserSetupActionsDel, AuthorizationConstants.PERMISSION_KEY.UserSetupActionsConfigureSecurityOptions, AuthorizationConstants.PERMISSION_KEY.UserSetupUserRoleAssociationValue],
    permissionOperator: AuthorizationConstants.PERMISSION_OPERATOR.Or
  }, {
    key: 'systemConfig',
    icon: 'icon-systemconfig',
    get title() {
      return localizer.getText('CONTEXT_MENU_LABEL_SYSTEM_CONFIGURATION');
    },
    permissionKeys: [AuthorizationConstants.PERMISSION_KEY.SystemConfigurationScheduledInstancesValue],
    items: [{
      key: 'securityPolicies',
      icon: 'icon-lock',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_SECURITY_POLICIES');
      },
      forSystemAdmin: true
    }, {
      key: 'emailConfiguration',
      icon: 'icon-mail',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_EMAIL');
      },
      forSystemAdmin: true
    }, {
      key: 'reportConfiguration',
      icon: 'icon-report',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_REPORT');
      },
      forSystemAdmin: true
    }, {
      key: 'scheduling',
      icon: 'icon-calendar',
      get title() {
        return localizer.getText('CONTEXT_MENU_LABEL_SCHEDULING');
      },
      permissionKeys: [AuthorizationConstants.PERMISSION_KEY.SystemConfigurationScheduledInstancesValue],
      licenseKey: LicenseCheckerConstants.LICENSE_KEY.Scheduling
    }]
  }];

  var extendObservable = __webpack_require__(5).extendObservable;
  var action = __webpack_require__(5).action;
  var fetcher = __webpack_require__(75);

  function ContextMenuStore() {
    extendObservable(this, {
      contextMenuActiveLink: 'setupAndLicense',
      activeLink: null,
      menuStatus: true,
      contextMenu: menuDefinition,
      flattenContextMenu: function flattenContextMenu() {
        return placeholder(this.contextMenu).flatMap(function (item) {
          var tempArray = isNil(item.items) ? [] : item.items.toJSON();
          tempArray.push(item);
          return tempArray;
        }).flattenDeep();
      },
      isCurrentActiveLinkDisable: function isCurrentActiveLinkDisable() {
        return !!this.flattenContextMenu.findLast({
          key: this.contextMenuActiveLink
        }).isDisabled;
      }
    });
  }

  ContextMenuStore.prototype.changeActiveLink = action(function (newLink) {
    this.contextMenuActiveLink = this.activeLink = newLink;
  });

  /**
   * load system indicator for detecting changes
   */
  ContextMenuStore.prototype.loadSystemIndicator = function () {
    var updateMenuDefinition = function updateMenuDefinition(result) {
      var dataSetupMenu = find({
        key: 'dataSetup'
      }, this.contextMenu);
      var DIRTY_STATUS = '2';

      forEach(function (item) {
        item.isDirty = false;
      }, dataSetupMenu.items);

      dataSetupMenu.isDirty = false;

      if (!isNil(find({
        value: DIRTY_STATUS
      }, result))) {
        dataSetupMenu.isDirty = true;
        filter({
          value: DIRTY_STATUS
        }, result).forEach(function (item) {
          var dbKey = lowerFirst(item.key);

          find({
            key: dbKey
          }, dataSetupMenu.items).isDirty = true;
        });
      }
    };

    return fetcher.getSystemIndicator(uiState.getTenantId()).then(updateMenuDefinition.bind(this));
  };

  /**
   * disabled some for setting menu item if visible connetion == 0
   * @return {Promise} for unit test to make sure testing after complete set
   */
  ContextMenuStore.prototype.disabledLinkBasedOnConnectionString = function () {
    var needUpdateList = this.flattenContextMenu.filter('needConnectionString');

    var updateMenuDefinition = function updateMenuDefinition(result) {
      needUpdateList.forEach(function (item) {
        item.isDisabled = result === 0;
      });
      return result;
    };

    var resetMenuDefinition = function resetMenuDefinition() {
      needUpdateList.forEach(function (item) {
        item.isDisabled = true;
      });

      return 0;
    };

    return fetcher.getNumberOfConnection(uiState.getTenantId()).then(updateMenuDefinition.bind(this), resetMenuDefinition.bind(this));
  };

  /**
   * Get Context Menu Store
   */
  ContextMenuStore.prototype.getHelpSystemUrl = function () {
    return fetcher.getHelpSystemUrl();
  }, module.exports = ContextMenuStore;
}();

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

var _Izenda = __webpack_require__(1143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsRoutes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = function () {
  var ROUTE = _config2.default.RoutesMerge.Settings;
  return _react2.default.createElement(_reactRouter.Route, { path: ROUTE.path, component: _Izenda.Container });
};

module.exports = exports['default'];

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Store = exports.Component = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2211);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(339);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsContainer = function (_Component) {
  (0, _inherits3.default)(SettingsContainer, _Component);

  function SettingsContainer() {
    (0, _classCallCheck3.default)(this, SettingsContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingsContainer.__proto__ || (0, _getPrototypeOf2.default)(SettingsContainer)).call(this));

    _this.store = new _Izenda4.default();
    return _this;
  }

  (0, _createClass3.default)(SettingsContainer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var hasSetupDatabase = this.props.params.notSetupDatabase !== 'true';
      return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, this.props, { hasSetupDatabase: hasSetupDatabase, store: this.store }));
    }
  }]);
  return SettingsContainer;
}(_react.Component);
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

exports.Component = _Izenda2.default;
exports.Store = _Izenda4.default;
exports.Container = SettingsContainer;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class3, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionStringBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Connection String Builder component
 */


__webpack_require__(55);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(29);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(36);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2220);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(23);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(17);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var InputValidator = (0, _Izenda10.default)()(_Izenda12.default);
var ConnectionStringBuilder = (_dec = (0, _Izenda2.default)(), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ConnectionStringBuilder, _Component);

  function ConnectionStringBuilder(props) {
    (0, _classCallCheck3.default)(this, ConnectionStringBuilder);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ConnectionStringBuilder.__proto__ || (0, _getPrototypeOf2.default)(ConnectionStringBuilder)).call(this, props));

    _initDefineProp(_this, 'serverName', _descriptor, _this);

    _initDefineProp(_this, 'database', _descriptor2, _this);

    _initDefineProp(_this, 'authentication', _descriptor3, _this);

    _initDefineProp(_this, 'login', _descriptor4, _this);

    _initDefineProp(_this, 'password', _descriptor5, _this);

    _initDefineProp(_this, 'options', _descriptor6, _this);

    _this.handleServerNameInput = function (e) {
      _this.serverName = e.target.value;
    };

    _this.handleDatabaseInput = function (e) {
      _this.database = e.target.value;
    };

    _this.handleAuthenticationInput = function (e) {
      _this.authentication = e.value;
    };

    _this.handleLoginInput = function (e) {
      _this.login = e.target.value;
    };

    _this.handlePasswordInput = function (e) {
      _this.password = e.target.value;
    };

    _this.handleOptionsInput = function (e) {
      _this.options = e.target.value;
    };

    _this.onClosing = function (cb, type) {
      if (type === 'accept') {
        _this.onOkHandle();
      } else if (type === 'cancel') {
        _this.props.onReject();
      }
    };

    var connectionInfo = props.connectionInfo || {};
    _this.serverName = connectionInfo.serverName || '';
    _this.database = connectionInfo.database || '';
    _this.authentication = _Izenda8.default.AUTHENTICATION_TYPES['Standard'].value || '';
    _this.login = connectionInfo.login || '';
    _this.password = connectionInfo.password || '';
    _this.options = connectionInfo.options || '';
    return _this;
  }

  /**
   * Handle onChange for ServerName
   * @param {Object} event
   */


  /**
   * Handle onChange for Database
   * @param {Object} event
   */


  /**
   * Handle onChange for Authentication
   * @param {Object} event
   */


  /**
   * Handle onChange for Login
   * @param {Object} event
   */


  /**
   * Handle onChange for Password
   * @param {Object} event
   */


  /**
   * Handle onChange for Options
   * @param {Object} event
   */


  (0, _createClass3.default)(ConnectionStringBuilder, [{
    key: 'buildAuthenticationOptions',


    /**
     * Build options for the buildAuthenticationOptions element
     * @returns {Object}
     */
    value: function buildAuthenticationOptions() {
      var serverType = this.props.serverType || '';
      var AUTHENTICATION_TYPES = _Izenda8.default.AUTHENTICATION_TYPES;

      var options = [{
        value: AUTHENTICATION_TYPES['Standard'].value,
        label: String.format(AUTHENTICATION_TYPES['Standard'].displayPattern, serverType)
      }, {
        value: AUTHENTICATION_TYPES['Trusted'].value,
        label: AUTHENTICATION_TYPES['Trusted'].displayPattern
      }];

      return _react2.default.createElement(_Izenda4.default, {
        id: 'connectionStringBuilder_Authentication',
        options: options,
        value: this.authentication,
        labelField: 'label',
        valueField: 'value',
        onChange: this.handleAuthenticationInput
      });
    }

    /**
     * Compose connection string
     */

  }, {
    key: 'composeConnectionString',
    value: function composeConnectionString() {
      var password = this.password,
          login = this.login,
          database = this.database,
          serverName = this.serverName,
          authentication = this.authentication;
      var AUTHENTICATION_TYPES = _Izenda8.default.AUTHENTICATION_TYPES;

      var connectionStringPattern = '';
      var connectionString = undefined;

      if (authentication === AUTHENTICATION_TYPES['Standard'].value) {
        connectionStringPattern = AUTHENTICATION_TYPES['Standard'].connectionStringPattern;
      } else if (authentication === AUTHENTICATION_TYPES['Trusted'].value) {
        connectionStringPattern = AUTHENTICATION_TYPES['Trusted'].connectionStringPattern;
      }

      if (connectionStringPattern !== '') {
        connectionString = String.format(connectionStringPattern, serverName, database, login, password);
      }

      return connectionString;
    }

    /**
     * Handle ok button's click event
     */

  }, {
    key: 'onOkHandle',
    value: function onOkHandle() {
      var _this2 = this;

      var validation = this.props.validation;

      validation.validate().then(function (success) {
        return success ? _this2.props.onOk && _this2.props.onOk(_this2.composeConnectionString()) : false;
      }).then(function (success) {
        success && _this2.props.onAccept();
      });
    }

    /**
     * Render connection string builder
     * @returns {Object}
     */

  }, {
    key: 'renderContent',
    value: function renderContent(localization) {
      var authentication = this.authentication,
          serverName = this.serverName,
          database = this.database,
          login = this.login,
          options = this.options,
          password = this.password;
      var AUTHENTICATION_TYPES = _Izenda8.default.AUTHENTICATION_TYPES,
          SERVER_NAME_CONSTRAINT = _Izenda8.default.SERVER_NAME_CONSTRAINT,
          DATABASE_CONSTRAINT = _Izenda8.default.DATABASE_CONSTRAINT;

      var isWindowAuthenMode = authentication == AUTHENTICATION_TYPES['Trusted'].value;

      return _react2.default.createElement(
        'form',
        null,
        _react2.default.createElement(
          'div',
          { className: 'form-horizontal' },
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { className: 'control-label col-md-3 validation required' },
              localization.getText('CONNECTION_STRING_BUILDER_LABEL_SERVER_NAME')
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-9' },
              _react2.default.createElement(InputValidator, {
                className: 'form-control',
                name: 'serverName',
                onChange: this.handleServerNameInput,
                value: serverName,
                type: 'text',
                validations: SERVER_NAME_CONSTRAINT,
                field: 'serverName'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { className: 'control-label col-md-3 validation required' },
              localization.getText('CONNECTION_STRING_BUILDER_LABEL_DATABASE')
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-9' },
              _react2.default.createElement(InputValidator, {
                className: 'form-control',
                name: 'database',
                onChange: this.handleDatabaseInput,
                value: database,
                type: 'text',
                validations: DATABASE_CONSTRAINT,
                field: 'database'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { className: 'control-label col-md-3' },
              localization.getText('CONNECTION_STRING_BUILDER_TEXT_AUTHENTICATION')
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-9' },
              this.buildAuthenticationOptions()
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { className: 'control-label col-md-3' },
              localization.getText('COMMON_LABEL_LOGIN')
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-9' },
              _react2.default.createElement(InputValidator, {
                className: 'form-control text-box single-line',
                name: 'Login',
                type: 'text',
                value: login,
                onChange: this.handleLoginInput,
                disabled: isWindowAuthenMode
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { className: 'control-label col-md-3' },
              localization.getText('COMMON_LABEL_PASSWORD')
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-9' },
              _react2.default.createElement('input', {
                className: 'form-control text-box single-line',
                name: 'Password',
                type: 'password',
                value: password,
                onChange: this.handlePasswordInput,
                disabled: isWindowAuthenMode
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { className: 'control-label col-md-3' },
              localization.getText('COMMON_LABEL_OPTIONS')
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-md-9' },
              _react2.default.createElement(InputValidator, {
                className: 'form-control text-box single-line',
                name: 'Options',
                type: 'text',
                value: options,
                onChange: this.handleOptionsInput
              })
            )
          )
        )
      );
    }

    /**
     * Render connection string builder modal
     * @returns {Object}
     */

  }, {
    key: 'render',
    value: function render() {
      var localization = this.props.localization;


      return _react2.default.createElement(
        _Izenda6.default,
        { visible: true, onClosing: this.onClosing, type: 'none', autoClose: false },
        _react2.default.createElement(_Izenda6.default.Header, { title: localization.getText('CONNECTION_STRING_BUILDER_LABEL_DATABASE_CONNECTION') }),
        _react2.default.createElement(
          _Izenda6.default.Body,
          null,
          this.renderContent(localization)
        ),
        _react2.default.createElement(
          _Izenda6.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda6.default.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda6.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }

    /**
     * on closing
     * @param {Object} cb
     * @param {String} type
     */

  }]);
  return ConnectionStringBuilder;
}(_react.Component), _class3.propTypes = {
  serverName: _propTypes2.default.string,
  database: _propTypes2.default.string,
  login: _propTypes2.default.string,
  password: _propTypes2.default.string,
  options: _propTypes2.default.string,
  onOk: _propTypes2.default.func.isRequired
}, _class3.defaultProps = {
  serverName: '',
  database: '',
  login: '',
  password: '',
  options: '',
  modalId: 'myModal'
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'serverName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'database', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'authentication', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'login', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'password', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'options', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
})), _class2)) || _class);
exports.default = ConnectionStringBuilder;
module.exports = exports['default'];

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Permissions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
// 
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2234);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2236);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(113);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Permissions = (_dec = (0, _Izenda2.default)(_Izenda8.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Permissions, _Component);

  function Permissions() {
    (0, _classCallCheck3.default)(this, Permissions);
    return (0, _possibleConstructorReturn3.default)(this, (Permissions.__proto__ || (0, _getPrototypeOf2.default)(Permissions)).apply(this, arguments));
  }

  (0, _createClass3.default)(Permissions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;

      props.getCategoryAccessibility();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.permissionStore.reset();
    }

    /**
     * render component
     * @return {Object} component
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          permissionStore = _props.permissionStore,
          disabledTab = _props.disabledTab,
          accessStore = _props.accessStore,
          readOnly = _props.readOnly;


      return _react2.default.createElement(
        'div',
        { className: 'u_fullHeight izenda-Permission' },
        _react2.default.createElement(_Izenda4.default, { permissionStore: permissionStore, disabledTab: disabledTab }),
        _react2.default.createElement(_Izenda6.default, {
          permissionStore: permissionStore,
          disabledTab: disabledTab,
          accessStore: accessStore,
          readOnly: readOnly
        })
      );
    }
  }]);
  return Permissions;
}(_react.Component), _class2.propTypes = {
  permissionStore: _propTypes2.default.object.isRequired
}, _temp)) || _class);
exports.default = Permissions;
module.exports = exports['default'];

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryPermission.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var GridLayout = __webpack_require__(13);
  var CommonTree = __webpack_require__(2246);
  var connect = __webpack_require__(2);
  var action = __webpack_require__(2247);

  var CategoryPermission = function CategoryPermission(props) {
    return React.createElement(
      'div',
      { className: 'izenda-CategoryPermission' },
      React.createElement(
        GridLayout,
        { className: 'u-posRelative u_fullHeight' },
        React.createElement(
          GridLayout.Row,
          { className: 'u_fullHeight' },
          React.createElement(
            GridLayout.Col,
            { cols: 4, className: 'u_fullHeight' },
            React.createElement(
              'div',
              { className: 'u_fullSize' },
              React.createElement(CommonTree, {
                header: props.leftHeader,
                nodes: props.leftTree,
                filter: props.leftTreeFilter,
                readOnly: props.readOnly })
            )
          ),
          React.createElement(
            'div',
            { className: 'u-posAbsolute izenda-CategoryPermission-ControllArrow izenda-CategoryPermission-Available_Visible' },
            React.createElement(
              'div',
              { onClick: !props.readOnly && props.fromLeftToMiddle },
              React.createElement('i', { className: 'icon-right-open' })
            ),
            React.createElement(
              'div',
              { onClick: !props.readOnly && props.fromMiddleToLeft },
              React.createElement('i', { className: 'icon-left-open' })
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 4, className: 'u_fullHeight' },
            React.createElement(
              'div',
              { className: 'u_fullSize' },
              React.createElement(CommonTree, {
                header: props.middleHeader,
                nodes: props.middleTree,
                filter: props.middleTreeFilter,
                readOnly: props.readOnly })
            )
          ),
          React.createElement(
            'div',
            { className: 'u-posAbsolute izenda-CategoryPermission-ControllArrow izenda-CategoryPermission-Visible_Save' },
            React.createElement(
              'div',
              { onClick: !props.readOnly && props.fromMiddleToRight },
              React.createElement('i', { className: 'icon-right-open' })
            ),
            React.createElement(
              'div',
              { onClick: !props.readOnly && props.fromRightToMiddle },
              React.createElement('i', { className: 'icon-left-open' })
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 4, className: 'u_fullHeight' },
            React.createElement(
              'div',
              { className: 'u_fullSize' },
              React.createElement(CommonTree, {
                header: props.rightHeader,
                nodes: props.rightTree,
                filter: props.rightTreeFilter,
                readOnly: props.readOnly })
            )
          )
        )
      )
    );
  };

  module.exports = connect(action)(CategoryPermission);
}();

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.UserRolePermission.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(17);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(107);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(62);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(335);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonTreeSearch = (0, _recompose.compose)((0, _recompose.mapProps)(function (props) {
  return {
    debounceOnChange: true,
    value: props.rolePermission.filterText,
    onChange: function onChange(e) {
      props.rolePermission.filterText = e.target.value;
      props.searchRoles(props.rolePermission.filterText);
    }
  };
}))(_Izenda6.default);

var UserRolePermission = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(UserRolePermission, _Component);

  function UserRolePermission() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, UserRolePermission);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UserRolePermission.__proto__ || (0, _getPrototypeOf2.default)(UserRolePermission)).call.apply(_ref, [this].concat(args))), _this), _this.renderNode = function (node, toggleIcon, toggle, isCollapsed, parent) {
      var source = node.source,
          disabled = node.disabled,
          showTotal = node.showTotal;

      var onChangeFunc = _this.handleChange.bind(_this, node, parent);
      var filterText = _this.props.rolePermission.filterText;


      return _react2.default.createElement(
        'div',
        { className: 'checkbox u_noMarginAll' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda4.default, {
            type: 'checkbox',
            indeterminate: source.indeterminate,
            checked: disabled ? false : source.checked,
            onChange: onChangeFunc,
            disabled: disabled
          }),
          _react2.default.createElement(_Izenda8.default, { text: source.name, highlight: filterText, className: 'u_textNormal' }),
          showTotal && _react2.default.createElement(
            'span',
            { className: 'selectable u_inline' },
            '(',
            source.numOfChilds,
            ')'
          )
        ),
        toggleIcon
      );
    }, _this.getKey = function (node) {
      return node.source.id + '_' + node.source.parentId;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(UserRolePermission, [{
    key: 'handleChange',
    value: function handleChange(node, parent, evt) {
      node.onChange(node.source, parent, evt);
      this.props.updateSelectedNode(node, parent, this.props.accessModel);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          rolePermission = _props.rolePermission,
          store = _props.store,
          getData = _props.getData,
          searchRoles = _props.searchRoles,
          localization = _props.localization;
      var lazyLoadingStore = rolePermission.lazyLoadingStore,
          isLastPage = rolePermission.isLastPage,
          displayData = rolePermission.displayData;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-UserRolePermision u_table u_fullSize u_borderAll' },
        _react2.default.createElement(
          'div',
          { className: 'u_tableRow' },
          _react2.default.createElement(
            'div',
            { className: 'u_tableCell u_paddingAll u_borderBottom' },
            _react2.default.createElement('span', { className: 'icon-menu u_marginRight' }),
            _react2.default.createElement(
              'span',
              { className: 'u_textBold' },
              localization.getText('TENANT_CONSTANT_TENANT_PERMISSIONS_SHARE_WITH_TREE_HEADER')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_tableRow' },
          _react2.default.createElement(
            'div',
            { className: 'u_tableCell u_paddingAll u_borderBottom' },
            _react2.default.createElement(
              'div',
              { className: 'u-posRelative' },
              _react2.default.createElement(CommonTreeSearch, { rolePermission: rolePermission, searchRoles: searchRoles })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_tableRow' },
          _react2.default.createElement(
            'div',
            { className: 'u_tableCell u_fullSize' },
            _react2.default.createElement(_Izenda10.default, {
              nodes: displayData,
              getKey: this.getKey,
              className: 'u_paddingRight u_paddingBottom',
              renderNode: this.renderNode,
              getChildNodes: (0, _fp.invoke)('getChildNodes'),
              isLastPage: isLastPage,
              getData: getData,
              viewHeight: lazyLoadingStore.viewHeight,
              itemHeight: lazyLoadingStore.itemHeight,
              registerLazyLoadingStore: rolePermission.registerLazyLoadingStore.bind(rolePermission)
            })
          )
        )
      );
    }
  }]);
  return UserRolePermission;
}(_react.Component)) || _class);
exports.default = UserRolePermission;
module.exports = exports['default'];

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Span = function Span(props) {
  return _react2.default.createElement(
    'span',
    { className: props.className },
    props.children
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.Span.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Span Component
 */


Span.defaultProps = {
  className: ''
};

exports.default = Span;
module.exports = exports['default'];

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.CustomViewPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * CustomViewPopup component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(398);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2295);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(23);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(47);

var _Izenda16 = _interopRequireDefault(_Izenda15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorInput = (0, _Izenda14.default)()(_Izenda8.default);
var ValidatorSelect = (0, _Izenda14.default)()(_Izenda16.default);
var ValidatorTextArea = (0, _Izenda14.default)()(_Izenda10.default);

var CustomViewPopup = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(CustomViewPopup, _Component);

  function CustomViewPopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CustomViewPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomViewPopup.__proto__ || (0, _getPrototypeOf2.default)(CustomViewPopup)).call.apply(_ref, [this].concat(args))), _this), _this.renderDatabaseName = function () {
      var customView = _this.customView;
      var options = customView.databases.length ? customView.databases : [];
      var selectedDatabase = customView.databaseId && {
        key: customView.databaseId,
        value: customView.databaseName
      };

      return _react2.default.createElement(ValidatorSelect, {
        options: options,
        simpleValue: true,
        searchable: false,
        onChange: _this.onChangeDatabase,
        value: selectedDatabase,
        valueKey: 'key',
        labelKey: 'value',
        field: 'database',
        validations: _this.constraint,
        isLastPage: customView.isLastPageDatabase,
        getData: _this.getDatabases,
        isLazyLoading: true
      });
    }, _this.renderSchemaName = function () {
      var customView = _this.customView;
      var disabled = !customView.databaseId;
      var options = customView.schemas.length ? customView.schemas : [];
      var selectedSchema = customView.schemaId && {
        key: customView.schemaId,
        value: customView.schemaName
      };

      return _react2.default.createElement(ValidatorSelect, {
        options: options,
        simpleValue: true,
        searchable: false,
        onChange: _this.onChangeSchema,
        value: selectedSchema,
        valueKey: 'key',
        labelKey: 'value',
        field: 'schema',
        validations: _this.constraint,
        disabled: disabled,
        isLastPage: customView.isLastPageSchema,
        getData: _this.getSchemas,
        isLazyLoading: true
      });
    }, _this.saveCustomQuerySource = function () {
      var _this$props = _this.props,
          store = _this$props.store,
          onAccept = _this$props.onAccept,
          confirmFn = _this$props.confirmFn,
          localization = _this$props.localization;


      return store.saveCustomQuerySource(_this.customView).then(function (_ref2) {
        var success = _ref2.success,
            messages = _ref2.messages;

        _this.processingSave = false;
        if ((0, _fp.isNil)(success) || success) {
          store.reload();
          return !_this.customView.id ? confirmFn('Confirmation', {
            type: 'info',
            description: localization.getText('DATA_MODEL_LABEL_ADD_CUSTOM_VIEW_SAVE_SUCCESSFUL_MESSAGE'),
            showCloseIndicator: true
          }).then(onAccept) : onAccept();
        }
        confirmFn('Information', {
          type: 'error',
          description: messages[0].messages[0],
          showCancel: false,
          showCloseIndicator: true
        });

        return null;
      });
    }, _this.onClosing = function (callback, type) {
      if (!_this.processingSave) {
        _this.processingSave = true;
        var _this$props2 = _this.props,
            confirmFn = _this$props2.confirmFn,
            store = _this$props2.store,
            onReject = _this$props2.onReject,
            validation = _this$props2.validation;


        if (type === 'accept') {
          validation.validate().then(function (result) {
            if (result) {
              store.validateCustomQuerySource(_this.customView).then(function (_ref3) {
                var success = _ref3.success,
                    confirmation = _ref3.confirmation,
                    messages = _ref3.messages;

                if (success) {
                  confirmation ? confirmFn('Confirmation', { description: messages[0] }).then(function () {
                    messages.length > 1 ? confirmFn('Confirmation', { description: messages[1] }).then(_this.saveCustomQuerySource).catch(function () {
                      _this.processingSave = false;
                    }) : _this.saveCustomQuerySource();
                  }).catch(function () {
                    _this.processingSave = false;
                  }) : _this.saveCustomQuerySource();
                } else {
                  messages[0].key === 'Name' ? validation.updateErrors(messages) : confirmFn('Information', {
                    type: 'error',
                    description: messages[0].messages[0],
                    showCancel: false,
                    showCloseIndicator: true
                  });
                  _this.processingSave = false;
                }
              });
            } else {
              _this.processingSave = false;
            }
          });
        } else {
          onReject();
        }
      }
    }, _this.renderContainer = function () {
      var localization = _this.props.localization;
      var _this$customView = _this.customView,
          query = _this$customView.query,
          updateQuery = _this$customView.updateQuery,
          viewName = _this$customView.viewName,
          updateViewName = _this$customView.updateViewName;


      return _react2.default.createElement(
        _Izenda6.default,
        null,
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: 2 },
            localization.getText('DATA_MODEL_LABEL_ADD_CUSTOM_VIEW_VIEW_NAME')
          ),
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: 10 },
            _react2.default.createElement(ValidatorInput, {
              type: 'text',
              field: 'Name',
              value: viewName,
              onChange: updateViewName,
              validations: _this.constraint,
              className: 'form-control'
            })
          )
        ),
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: 2 },
            localization.getText('DATA_MODEL_LABEL_ADD_CUSTOM_VIEW_DATABASE_NAME')
          ),
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: 10 },
            _this.renderDatabaseName()
          )
        ),
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: 2 },
            localization.getText('DATA_MODEL_LABEL_ADD_CUSTOM_VIEW_SCHEMA_NAME')
          ),
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: 10 },
            _this.renderSchemaName()
          )
        ),
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: 2 },
            localization.getText('DATA_MODEL_LABEL_ADD_CUSTOM_VIEW_QUERY')
          ),
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: 10 },
            _react2.default.createElement(ValidatorTextArea, {
              rows: '15',
              value: query,
              onChange: updateQuery,
              validations: _this.constraint,
              className: 'form-control',
              field: 'queryString'
            })
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CustomViewPopup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          localization = _props.localization,
          detail = _props.detail,
          store = _props.store;


      this.customView = new _Izenda12.default(detail);

      this.onChangeDatabase = this.customView.setDatabase.bind(this.customView);
      this.onChangeSchema = this.customView.setSchema.bind(this.customView);
      this.getDatabases = store.getDatabases.bind(store, this.customView);
      this.getSchemas = store.getSchemas.bind(store, this.customView);
      this.title = localization.getText(detail ? 'DATA_MODEL_LABEL_EDIT_CUSTOM_VIEW' : 'DATA_MODEL_LABEL_ADD_CUSTOM_VIEW');
      this.constraint = {
        presence: {
          presence: true,
          message: localization.getText('COMMON_CONSTRAINT_REQUIRED')
        }
      };
      this.processingSave = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var localization = this.props.localization;

      return _react2.default.createElement(
        _Izenda4.default,
        { visible: true, autoClose: false, onClosing: this.onClosing, type: 'none', sizeClass: 'modal-lg' },
        _react2.default.createElement(_Izenda4.default.Header, { title: this.title }),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          this.renderContainer()
        ),
        _react2.default.createElement(
          _Izenda4.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'accept' },
            localization.getText('DATA_MODEL_LABEL_ADD_CUSTOM_VIEW_SAVE_EXECUTE')
          ),
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return CustomViewPopup;
}(_react.Component)) || _class);
exports.default = CustomViewPopup;
module.exports = exports['default'];

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.Relationship.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Relationship component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(86);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(30);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(147);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(618);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(146);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(61);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(37);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(1151);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2306);

var _Izenda20 = _interopRequireDefault(_Izenda19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Relationship = (_dec = (0, _Izenda2.default)(_Izenda18.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Relationship, _Component);

  function Relationship() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Relationship);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Relationship.__proto__ || (0, _getPrototypeOf2.default)(Relationship)).call.apply(_ref, [this].concat(args))), _this), _this.resetAlertMessage = function () {
      var store = _this.props.store;

      store.alertMessage = _Izenda16.default.EMPTY_MESSAGE;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Relationship, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      var store = props.store,
          loader = props.loader,
          validation = props.validation,
          isPopup = props.isPopup;


      props.updateLoading(true);
      loader.startLoading();
      store.initData(isPopup).then(function () {
        props.updateLoading(false);
        loader.endLoading();
        validation.validate();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.destroy(this.props.isPopup);
    }
  }, {
    key: 'render',


    /**
     * render main function
     */
    value: function render() {
      var _props = this.props,
          store = _props.store,
          alertMessage = _props.store.alertMessage,
          localization = _props.localization;


      return !store.showInvalidScreen ? _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-header' },
          _react2.default.createElement(_Izenda4.default, null),
          _react2.default.createElement(
            'div',
            { className: 'izenda-Alert-container' },
            _react2.default.createElement(
              _Izenda14.default,
              { type: alertMessage.type, onAutoHide: this.resetAlertMessage },
              alertMessage.message
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock' },
            _react2.default.createElement(_Izenda12.default, {
              onSearch: this.props.onSearch,
              value: store.pageInfo.searchProperty,
              options: store.getCriteriaList()
            })
          ),
          _react2.default.createElement(
            _Izenda8.default,
            { onSave: this.props.onSave, onCancel: this.props.onCancel },
            _react2.default.createElement(_Izenda6.default, { onClick: this.props.onAdd, label: localization.getText('REPORTDESIGNER_LABEL_ADD_RELATIONSHIP') })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          _react2.default.createElement(_Izenda10.default, {
            store: store,
            width: this.props.width,
            isPopup: this.props.isPopup,
            isLoading: this.props.isLoading
          })
        )
      ) : _react2.default.createElement(_Izenda20.default, this.props);
    }
  }]);
  return Relationship;
}(_react.Component)) || _class);


Relationship.defaultProps = {
  isPopup: false
};

Relationship.propTypes = {
  store: _propTypes2.default.object.isRequired,
  querySourceId: _propTypes2.default.string,
  isPopup: _propTypes2.default.bool
};

exports.default = Relationship;
module.exports = exports['default'];

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(37);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(160);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
var actions = (0, _recompose.compose)((0, _recompose.withState)('isLoading', 'updateLoading', true), (0, _recompose.withHandlers)({
  onSave: (0, _fp.curry)(onSave),
  onAdd: (0, _fp.curry)(onAdd),
  onSearch: (0, _fp.curry)(onSearch),
  onCancel: (0, _fp.curry)(onCancel)
}));

function validateInvalidRelationships(store, validation) {
  // Reset validation to remove current invalid required
  validation.reset();
  var allErrors = store.getInvalidErrors(_Izenda3.FIELDCHECK);
  return validation.updateErrors(allErrors);
}

function onSave(props, placeholder) {
  var store = props.store,
      loader = props.loader,
      localization = props.localization,
      dataModelStore = props.parentStore,
      validation = props.validation,
      isPopup = props.isPopup;


  var saveDone = function saveDone(result) {
    if (!result) {
      return null;
    }

    if (!result.success) {
      var requestErrors = store.processErrorAfterSave(result);
      !requestErrors[0].key && props.confirmMessage('error', requestErrors[0].messages);
    } else if (isPopup) {
      props.onClosePopup();
    } else {
      store.setShowInvalidScreen(false);
      store.setAlertMessage(_Izenda2.default.MESSAGE_TYPE.SUCCESS, localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
      store.resetData();
      return store.getRelationships();
    }

    return result.messages;
  };

  var handleAfterValidate = function handleAfterValidate(result) {
    if (!result) {
      return null;
    }

    if (!result.success) {
      if (!store.showInvalidScreen) {
        store.setShowInvalidScreen(true);
      } else {
        store.getInvalidRelationships().then(function () {
          validateInvalidRelationships(store, validation);
        });
      }
      return null;
    } else {
      var message = result.hasPositionId ? localization.getText('RELATIONSHIP_MESSAGES_CONFIRM_SAVE_WITH_POSITION_ID') : localization.getText('RELATIONSHIP_MESSAGES_CONFIRM_SAVE_WITHOUT_POSITION_ID');
      return props.confirmFn('Confirmation', {
        description: message
      }).then(store.save.bind(store));
    }
  };

  validation.validate().then(function (success) {
    if (success && !store.hasChange) {
      if (isPopup) {
        props.onClosePopup();
      }
      store.alertMessage = {
        type: _Izenda2.default.MESSAGE_TYPE.INFO,
        message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
      };
    } else if (success) {
      loader.startLoading();
      // Do not check invalid or has Position ID in pop up display
      if (isPopup) {
        return props.confirmFn('Confirmation', {
          description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
        }).then(store.save.bind(store));
      } else {
        return store.validateModifiedRelationships().then(handleAfterValidate);
      }
    }
    if (!success) {
      return store.showInvalidScreen ? store.validateModifiedRelationships().then(handleAfterValidate) : validation.validate();
    }
    return null;
  }).then(saveDone).then(function (saveErrors) {
    if (!(0, _fp.isEmpty)(saveErrors)) {
      validation.updateErrors(saveErrors);
    }
    return saveErrors;
  })
  // Reload indicator for middle panel after save successfully
  .then(function (saveErrors) {
    (0, _fp.isEmpty)(saveErrors) && dataModelStore.loadIndicator();
  }).finally(loader.endLoading.bind(loader));
}

function onAdd(props, placeholder) {
  var validation = props.validation,
      store = props.store;


  return store.addNew().then(function () {
    validation.validate();
    return null;
  });
}

function onSearch(props, searchProperty, searchText) {
  var store = props.store,
      validation = props.validation;


  var refreshData = function refreshData() {
    props.validation.reset();
    // Update modified data before reseting
    store.syncModifiedRelationships();

    store.resetData();
    store.pageInfo.setSearchValues(searchProperty, searchText);
    props.updateLoading(true);
    props.loader.startLoading();

    return store.showInvalidScreen ? store.getInvalidRelationships().then(props.updateLoading.bind(props, false)).finally(function () {
      validateInvalidRelationships(store, validation);
      props.loader.endLoading();
    }) : store.getRelationships().then(props.updateLoading.bind(props, false)).finally(function () {
      props.loader.endLoading();
      validation.validate();
    });
  };

  if (store.showInvalidScreen) {
    return refreshData();
  }

  return props.confirmDirtyForm(store.hasChange).then(refreshData.bind(this));
}

function onCancel(props, placeholder) {
  var store = props.store,
      loader = props.loader;


  return props.confirmDirtyForm(store.hasChange).then(function () {
    if (props.isPopup) {
      props.onClosePopup();
    } else {
      store.setShowInvalidScreen(false);
      loader.startLoading();
      store.resetData();
      return store.getRelationships().finally(loader.endLoading.bind(loader));
    }
  });
}

exports.default = actions;
module.exports = exports['default'];

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(148);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DeleteIcon.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

function DeleteIcon(props) {
  return _react2.default.createElement('span', (0, _extends3.default)({ className: 'icon-cancel' }, props));
}

exports.default = (0, _Izenda2.default)()(DeleteIcon);
module.exports = exports['default'];

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(274);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(278);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(227);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2356);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(206);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2357);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(72);

var _Izenda14 = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var PermissionStore = (_class = function () {
  // For using rolesetup pages

  function PermissionStore(model, tenantId, isTenantSetup) {
    (0, _classCallCheck3.default)(this, PermissionStore);

    _initDefineProp(this, 'model', _descriptor, this);

    _initDefineProp(this, 'tenantId', _descriptor2, this);

    _initDefineProp(this, 'roleAccessLimits', _descriptor3, this);

    _initDefineProp(this, 'roleSchedulingLimits', _descriptor4, this);

    _initDefineProp(this, 'dashboardCategoryAccessibility', _descriptor5, this);

    _initDefineProp(this, 'reportCategoryAccessibility', _descriptor6, this);

    _initDefineProp(this, 'tenantDetail', _descriptor7, this);

    _initDefineProp(this, 'isShowSystemConfiguration', _descriptor8, this);

    _initDefineProp(this, 'isShowTenantSetup', _descriptor9, this);

    _initDefineProp(this, 'isShowDataSetup', _descriptor10, this);

    _initDefineProp(this, 'isShowUserSetup', _descriptor11, this);

    _initDefineProp(this, 'isShowRoleSetup', _descriptor12, this);

    _initDefineProp(this, 'isShowReports', _descriptor13, this);

    _initDefineProp(this, 'isShowDashboards', _descriptor14, this);

    _initDefineProp(this, 'isShowAccess', _descriptor15, this);

    _initDefineProp(this, 'isShowScheduling', _descriptor16, this);

    _initDefineProp(this, 'isShowEmailing', _descriptor17, this);

    _initDefineProp(this, 'isShowExporting', _descriptor18, this);

    _initDefineProp(this, 'isShowSystemWide', _descriptor19, this);

    this.model = model || new _Izenda10.default();
    this.tenantId = tenantId || null;
    this.roleId = null;
    this.dashboardCategoryAccessibility = new _Izenda12.default(isTenantSetup);
    this.reportCategoryAccessibility = new _Izenda12.default(isTenantSetup);
    this.isTenantSetup = !!isTenantSetup;
    this.accessLimitsCache = [];
    this.schedulingLimitsCache = [];
  }

  /**
   * Set role detail id
   * @param {string} id
   */


  (0, _createClass3.default)(PermissionStore, [{
    key: 'setRoleDetailId',
    value: function setRoleDetailId(id) {
      this.roleId = id;
    }

    /**
     * Reset data
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.accessLimitsCache = [];
      this.schedulingLimitsCache = [];
      this.roleAccessLimits.reset();
      this.roleSchedulingLimits.reset();
    }

    /**
     * get role list for current tenant
     * @method getRoleList
     * @return {promise}
     */

  }, {
    key: 'getRolePermission',
    value: function getRolePermission() {
      var _this = this;

      var roleAccessLimits = this.roleAccessLimits;
      var roleSchedulingLimits = this.roleSchedulingLimits;
      roleAccessLimits.reset();
      roleSchedulingLimits.reset();

      var readAccessLimit = (0, _mobx.action)(function (data) {
        roleAccessLimits.readBasicInfo(data);
        roleAccessLimits.readPermissionInfo(_this.model.access.accessLimits.value);
      });
      var readSchedulingLimits = (0, _mobx.action)(function (data) {
        roleSchedulingLimits.readBasicInfo(data);
        roleSchedulingLimits.readPermissionInfo(_this.model.scheduling.schedulingLimits.value);
      });

      if (this.isTenantSetup) {
        var readRoleList = (0, _mobx.action)(function (data) {
          readAccessLimit(data);
          readSchedulingLimits(data);
        });

        return _Izenda2.default.getRoleList(this.tenantId).then(readRoleList);
      }

      return (0, _bluebird.all)([_Izenda2.default.getTypedRole(_Izenda13.ROLE_TYPE.ACCESS, this.tenantId).then(readAccessLimit), _Izenda2.default.getTypedRole(_Izenda13.ROLE_TYPE.SCHEDULE, this.tenantId).then(readSchedulingLimits)]);
    }

    /**
     * Update cache data
     * @param  {object} node
     * @param  {object} parent
     * @param  {Array} cache
     */

  }, {
    key: 'updateCacheData',
    value: function updateCacheData(node, parent, cache) {
      if (parent === null) {
        var newItem = (0, _fp.pick)(['id', 'name', 'checked', 'indeterminate', 'numOfCheckedChilds'], node.source);
        newItem.isVirtual = true;
        newItem.childNodes = [];

        var cachedItem = (0, _fp.find)({ id: newItem.id }, cache);
        if (cachedItem) {
          cachedItem.checked = newItem.checked;
          cachedItem.indeterminate = newItem.indeterminate;
          cachedItem.numOfCheckedChilds = newItem.numOfCheckedChilds;
        } else {
          cache.push(newItem);
        }
      } else {
        var _newItem = (0, _fp.pick)(['id', 'name', 'checked', 'indeterminate', 'numOfCheckedChilds'], parent.data.source);
        _newItem.isVirtual = true;
        var newChildItem = (0, _fp.pick)(['id', 'name', 'checked', 'indeterminate'], node.source);
        _newItem.childNodes = [newChildItem];

        var _cachedItem = (0, _fp.find)({ id: _newItem.id }, cache);
        if (_cachedItem) {
          _cachedItem.checked = _newItem.checked;
          _cachedItem.indeterminate = _newItem.indeterminate;
          _cachedItem.numOfCheckedChilds = _newItem.numOfCheckedChilds;

          var cachedChildItem = (0, _fp.find)({ id: newChildItem.id }, _cachedItem.childNodes);
          if (cachedChildItem) {
            cachedChildItem.checked = newChildItem.checked;
            cachedChildItem.indeterminate = newChildItem.indeterminate;
          } else {
            _cachedItem.childNodes.push(newChildItem);
          }
        } else {
          cache.push(_newItem);
        }
      }
    }

    /**
     * update to permission model for access limit data
     * @method updateAccessLimitData
     */

  }, {
    key: 'updateAccessLimitData',
    value: function updateAccessLimitData(node, parent, accessModel) {
      this.updateCacheData(node, parent, this.accessLimitsCache);
      this.model.accessLimitsTree = this.accessLimitsCache;
      this.model.markDirty();

      var source = node.source;
      if (accessModel && !source.checked) {
        var removeList = [{ id: source.id, name: source.name }];

        if (!(0, _fp.isEmpty)(node.childNodes)) {
          removeList = (0, _fp.concat)(removeList, node.childNodes.map(function (item) {
            return (0, _fp.pick)(['id', 'name'], item.source);
          }));
        }

        accessModel.removeAccessor(removeList);
      }
    }

    /**
     * update to permission model for scheduling limit data
     * @method updateSchedulingLimitsData
     */

  }, {
    key: 'updateSchedulingLimitsData',
    value: function updateSchedulingLimitsData(node, parent) {
      this.updateCacheData(node, parent, this.schedulingLimitsCache);
      this.model.schedulingLimitsTree = this.schedulingLimitsCache;
      this.model.markDirty();
    }

    /**
     * Update report accessibility category to permission details
     */

  }, {
    key: 'updateReportAccessibilityCategory',
    value: function updateReportAccessibilityCategory() {
      this.model.reports.reportCategoriesSubcategories.categoryAccessibility.categories = this.reportCategoryAccessibility.prepareDataForSave();
      this.model.markDirty();
    }

    /**
     * Update dashboard accessibility category to permission details
     */

  }, {
    key: 'updateDashboardAccessibilityCategory',
    value: function updateDashboardAccessibilityCategory() {
      this.model.dashboards.dashboardCategoriesSubcategories.categoryAccessibility.categories = this.dashboardCategoryAccessibility.prepareDataForSave();
      this.model.markDirty();
    }

    /**
     * get category accessibility list for current tenant
     * @param {Object} category
     * @param {string} type
     * @return {Promise}
     */

  }, {
    key: 'getCategoryAccessibility',
    value: function getCategoryAccessibility(category, type) {
      var _this2 = this;

      var tenantDetail = this.tenantDetail;

      category.reset();

      var readCategoryList = (0, _mobx.action)(function (data) {
        category.populateData(data);
        var categoryAccessibility = void 0,
            tenantCategoryDetail = void 0;
        if (type === _Izenda13.CATEGORY_TYPE.REPORT) {
          categoryAccessibility = _this2.model.reports.reportCategoriesSubcategories.categoryAccessibility.categories;
          tenantCategoryDetail = (0, _fp.get)('reports.reportCategoriesSubcategories.categoryAccessibility.categories', tenantDetail);
        } else {
          categoryAccessibility = _this2.model.dashboards.dashboardCategoriesSubcategories.categoryAccessibility.categories;
          tenantCategoryDetail = (0, _fp.get)('dashboards.dashboardCategoriesSubcategories.categoryAccessibility.categories', tenantDetail);
        }

        category.readCategoryAccessibility(categoryAccessibility, tenantCategoryDetail);
      });

      if (this.isTenantSetup) {
        return _Izenda4.default.getCategoryAccessibility(type).then(readCategoryList);
      }

      return _Izenda2.default.getTypedCategory(type, this.tenantId).then(readCategoryList);
    }

    /**
     * Build param
     * @param {string} type
     */

  }, {
    key: 'buildParam',
    value: function buildParam(type) {
      return {
        type: type,
        tenantId: this.tenantId,
        skipItems: 0,
        pageSize: -1,
        parentIds: [],
        defaultChecked: false,
        isUncategorized: false
      };
    }

    /**
     * Load lazy category accessibility list for current tenant
     * @param {Object} category
     * @param {string} type
     * @return {Promise}
     */

  }, {
    key: 'loadLazyCategory',
    value: function loadLazyCategory(category, type) {
      var _this3 = this;

      var param = this.buildParam(type);

      category.reset();

      var readCategoryList = (0, _mobx.action)(function (data) {
        category.populateData(data.result);
        var categoryAccessibility = void 0;
        if (type === _Izenda13.CATEGORY_TYPE.REPORT) {
          categoryAccessibility = _this3.model.reports.reportCategoriesSubcategories.categoryAccessibility.categories;
        } else {
          categoryAccessibility = _this3.model.dashboards.dashboardCategoriesSubcategories.categoryAccessibility.categories;
        }

        category.readCategoryAccessibility(categoryAccessibility);
      });

      return _Izenda2.default.loadLazyTypedCategory(param).then(readCategoryList);
    }

    /**
     * Get param lazyload
     * @param  {Object} pageInfo
     * @param  {string} searchKey
     * @return {Object}
     */

  }, {
    key: 'getParamLazyload',
    value: function getParamLazyload(pageInfo, searchKey) {
      return {
        roleId: this.roleId,
        tenantId: this.tenantId,
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        parentIds: pageInfo.parentIds,
        criteria: [{
          key: 'name',
          value: searchKey
        }]
      };
    }

    /**
     * Load partial role permission
     * @param  {Array}  roleLimits
     * @param  {Fucntion}  fetcherFn
     * @param  {Object}  pageInfo
     * @param  {boolean} isReset
     * @param  {string}  searchKey
     * @return {Object}
     */

  }, {
    key: 'loadPartialRolePermission',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dataInfo, pageInfo, isReset, searchKey) {
        var roleLimits, cacheData, loadPartialData, params, _ref2, isLastPage, childNodes, numOfChilds, newData;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                roleLimits = dataInfo.roleLimits, cacheData = dataInfo.cacheData, loadPartialData = dataInfo.loadPartialData;

                searchKey = searchKey || roleLimits.filterText;
                pageInfo = pageInfo || roleLimits.lazyLoadingStore.pageInfoForFirstTime;
                params = this.getParamLazyload(pageInfo, searchKey);
                _context.next = 6;
                return loadPartialData(params);

              case 6:
                _ref2 = _context.sent;
                isLastPage = _ref2.isLastPage;
                childNodes = _ref2.childNodes;
                numOfChilds = _ref2.numOfChilds;
                newData = roleLimits.convertData(childNodes);

                roleLimits.isLastPage = isLastPage;
                if (isReset) {
                  roleLimits.roles = [];
                  roleLimits.displayData = [];
                }

                if ((0, _fp.toString)(searchKey) === (0, _fp.toString)(roleLimits.filterText)) {
                  (0, _Izenda14.concatTree)(roleLimits.roles, newData, _Izenda13.ROLE_PERMISSION_CONCAT_TREE_MAP, numOfChilds, []);
                  (0, _Izenda14.updateTree)(roleLimits.roles, cacheData, _Izenda13.ROLE_PERMISSION_TREE_MAP, ['checked', 'indeterminate', 'numOfCheckedChilds']);
                  roleLimits.displayData = (0, _Izenda14.parseToTree)(roleLimits.roles, _Izenda13.ROLE_PERMISSION_TREE_MAP);
                }

                return _context.abrupt('return', roleLimits);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadPartialRolePermission(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return loadPartialRolePermission;
    }()

    /**
     * Load partial permission access
     * @param  {Object}  pageInfo
     * @param  {boolean} isReset
     * @param  {string}  searchKey
     * @return {Promise}
     */

  }, {
    key: 'loadPartialPermissionAccess',
    value: function loadPartialPermissionAccess(pageInfo, isReset, searchKey) {
      var fetcherFn = this.isTenantSetup ? _Izenda4.default : _Izenda2.default;
      var dataInfo = {
        roleLimits: this.roleAccessLimits,
        cacheData: this.accessLimitsCache,
        loadPartialData: fetcherFn.loadPartialAccessLimits
      };

      return this.loadPartialRolePermission(dataInfo, pageInfo, isReset, searchKey);
    }

    /**
     * Load partial permission schedule
     * @param  {Object}  pageInfo
     * @param  {boolean} isReset
     * @param  {string}  searchKey
     * @return {Promise}
     */

  }, {
    key: 'loadPartialPermissionSchedule',
    value: function loadPartialPermissionSchedule(pageInfo, isReset, searchKey) {
      var fetcherFn = this.isTenantSetup ? _Izenda4.default : _Izenda2.default;
      var dataInfo = {
        roleLimits: this.roleSchedulingLimits,
        cacheData: this.schedulingLimitsCache,
        loadPartialData: fetcherFn.loadPartialScheduleLimits
      };
      return this.loadPartialRolePermission(dataInfo, pageInfo, isReset, searchKey);
    }

    /**
     * Get request param for available roles or users
     * @param  {Object} pageInfo
     * @return {Object}
     */

  }, {
    key: 'getRequestParam',
    value: function getRequestParam(pageInfo) {
      return {
        roleId: this.roleId,
        tenantId: this.tenantId,
        localTree: this.accessLimitsCache,
        criteria: pageInfo.searchCriteria || [],
        pageIndex: pageInfo.pageIndex || 1,
        pageSize: pageInfo.pageSize || 10,
        sortOrders: pageInfo.sortOrders || [{
          key: 'name',
          descending: true
        }]
      };
    }

    /**
     * Load users for role
     * @param  {Object} pageInfo
     * @return {Promise}
     */

  }, {
    key: 'loadAvailableUsers',
    value: function loadAvailableUsers() {
      var pageInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var requestData = this.getRequestParam(pageInfo);

      return _Izenda6.default.loadUsersAccess(requestData);
    }

    /**
     * Load users for role
     * @param  {Object} pageInfo
     * @return {Promise}
     */

  }, {
    key: 'loadAvailableRoles',
    value: function loadAvailableRoles() {
      var pageInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var requestData = this.getRequestParam(pageInfo);

      return _Izenda6.default.loadRolesAccess(requestData);
    }

    /**
     * Toggle all
     * @param {boolean} isShow
     */

  }, {
    key: 'toggleAll',
    value: function toggleAll(isShow) {
      this.isShowSystemConfiguration = isShow;
      this.isShowTenantSetup = isShow;
      this.isShowDataSetup = isShow;
      this.isShowUserSetup = isShow;
      this.isShowRoleSetup = isShow;
      this.isShowReports = isShow;
      this.isShowDashboards = isShow;
      this.isShowAccess = isShow;
      this.isShowScheduling = isShow;
      this.isShowEmailing = isShow;
      this.isShowExporting = isShow;
      this.isShowSystemWide = isShow;
    }

    /**
     * Update tenant detail
     * @param {any} tenantDetail
     */

  }, {
    key: 'updateTenantDetail',
    value: function updateTenantDetail(tenantDetail) {
      this.tenantDetail = tenantDetail;
    }
  }]);
  return PermissionStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'roleAccessLimits', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda8.default();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'roleSchedulingLimits', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda8.default();
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'dashboardCategoryAccessibility', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'reportCategoryAccessibility', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'tenantDetail', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'isShowSystemConfiguration', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'isShowTenantSetup', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'isShowDataSetup', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'isShowUserSetup', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'isShowRoleSetup', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'isShowReports', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, 'isShowDashboards', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, 'isShowAccess', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, 'isShowScheduling', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, 'isShowEmailing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, 'isShowExporting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, 'isShowSystemWide', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'reset', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reset'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getRolePermission', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getRolePermission'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateAccessLimitData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateAccessLimitData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateSchedulingLimitsData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateSchedulingLimitsData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateReportAccessibilityCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateReportAccessibilityCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDashboardAccessibilityCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateDashboardAccessibilityCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getCategoryAccessibility', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getCategoryAccessibility'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadLazyCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadLazyCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadPartialRolePermission', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadPartialRolePermission'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadPartialPermissionAccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadPartialPermissionAccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadPartialPermissionSchedule', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadPartialPermissionSchedule'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleAll', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleAll'), _class.prototype)), _class);
exports.default = PermissionStore;
module.exports = exports['default'];

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

exports.default = {
  get CONSTRAINTS() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('CATEGORY_REQUIRED_NAME')
      }
    };
  },

  get CATEGORY_TREE() {
    return {
      CONSTRAINTS: {
        CATEGORY_NAME: {
          presence: {
            presence: true,
            message: _Izenda2.default.getText('CATEGORY_REQUIRED_NAME')
          }
        },
        SUB_CATEGORY_NAME: {
          presence: {
            presence: true,
            message: _Izenda2.default.getText('CATEGORY_REQUIRED_SUBCATEGORY')
          }
        }
      },
      MESSAGES: {
        M03: _Izenda2.default.getText('CATEGORY_MESSAGES_CONFIRM_DELETE_CATEGORY'),
        M04: _Izenda2.default.getText('CATEGORY_MESSAGES_CONFIRM_DELETE_SUBCATEGORY')
      }
    };
  },

  get ERROR_MESSAGE_TEMPLATE() {
    return (0, _fp.template)(_Izenda2.default.getText('CATEGORY_ERROR_MESSAGE_TEMPLATE'));
  }
};
module.exports = exports['default'];

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Mapping.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Mapping component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(91);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2386);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(28);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(44);

var _Izenda12 = __webpack_require__(17);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(47);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(29);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = (0, _Izenda6.default)()(_Izenda15.default);
var DropDown = (0, _Izenda6.default)()(_Izenda17.default);
var ValidatableInput = (0, _Izenda6.default)()(_Izenda13.default);

var Mapping = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Mapping, _Component);

  function Mapping() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Mapping);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Mapping.__proto__ || (0, _getPrototypeOf2.default)(Mapping)).call.apply(_ref, [this].concat(args))), _this), _this.loadDestinationConnections = function () {
      var _this$props = _this.props,
          store = _this$props.store,
          loader = _this$props.loader,
          item = _this$props.item;

      loader.startLoading();

      item.resetWorkspaceTenantsStatus();
      return store.loadDestinationConnections().finally(loader.endLoading.bind(loader));
    }, _this.deleteMapping = function (mappingItem) {
      var _this$props2 = _this.props,
          item = _this$props2.item,
          dataSource = _this$props2.dataSource,
          tenantMode = _this$props2.tenantMode;

      var deletedIndex = dataSource.indexOf(mappingItem);
      var deleteCount = 1;

      dataSource.splice(deletedIndex, deleteCount);
      tenantMode && item.selectedTenant.setDirty();

      _this.loadDestinationConnections();
    }, _this.changeMappingItem = function (key, mappingItem, e) {
      var _this$props3 = _this.props,
          valManager = _this$props3.validation,
          item = _this$props3.item;


      mappingItem[key] = (0, _fp.isNil)(e.value) ? e.target.value : e.value;
      mappingItem.type == _Izenda4.default.MAPPING_TYPE.Database && _this.updateDataObject(key, mappingItem);
      item.markDirty();
      valManager.reset();

      _this.loadDestinationConnections();
    }, _this.updateDataObject = function (key, mappingItem) {
      var _this$props4 = _this.props,
          item = _this$props4.item,
          tenantMode = _this$props4.tenantMode;

      var selectedDB = item.findSelectedDatabase(mappingItem.fromDatabaseName) || {};
      var selectedConnection = item.findSelectedConnection(mappingItem.toDatabaseName);
      item.resetWorkspaceTenantsStatus();

      // Not in tenant mode: only change from Object
      if (!tenantMode) {
        mappingItem.fromObject = selectedDB.name;
      } else if (selectedConnection) {
        mappingItem.fromObject = selectedDB.name;
        mappingItem.toObject = selectedConnection.name;
      }
    }, _this.renderDatabaseName = function (mappingItem, key, rowIndex) {
      var _this$props5 = _this.props,
          _this$props5$item = _this$props5.item,
          selectedTenant = _this$props5$item.selectedTenant,
          mapppingDatabasesSource = _this$props5$item.mapppingDatabasesSource,
          distinctConnections = _this$props5$item.distinctConnections,
          tenantMode = _this$props5.tenantMode;

      var TABLE_DEF = _Izenda4.default.TABLE_DEF.GLOBAL_MAPPING;
      var isFromDatabase = key === TABLE_DEF.fromDatabaseName.key;
      var options = isFromDatabase ? mapppingDatabasesSource : tenantMode ? selectedTenant.databaseSources : distinctConnections;
      var isMatchOption = !!(0, _fp.find)({ fullDBName: mappingItem[key] }, options);
      var value = isMatchOption ? mappingItem[key] : null;
      var changeMappingItem = _this.changeMappingItem;

      var changeDatabaseName = function changeDatabaseName(e) {
        // Update database name
        changeMappingItem(key, mappingItem, e);
        // Update from/to server
        if (e.additionalValue) {
          if (isFromDatabase) {
            mappingItem.fromServer = e.additionalValue;
          } else {
            mappingItem.toServer = e.additionalValue;
          }
        }
      };

      return _react2.default.createElement(DropDown, {
        options: options,
        blankOption: true,
        onChange: changeDatabaseName,
        value: value,
        valueField: 'fullDBName',
        labelField: 'fullDBName',
        optionTooltip: 'databaseTooltip',
        field: key + rowIndex,
        additionalKey: key + rowIndex,
        additionalValueField: 'databaseServer',
        validations: _Izenda4.default.REQUIRE_CONSTRAINT,
        group: 'mapping' + rowIndex
      });
    }, _this.renderDataObject = function (mappingItem, key, rowIndex) {
      var _this$props6 = _this.props,
          item = _this$props6.item,
          mapppingDataObjects = _this$props6.item.mapppingDataObjects;

      var options = (0, _fp.getOr)([], mappingItem.fromDatabaseName, mapppingDataObjects);
      var value = mappingItem[key];
      var disabled = false;

      // For Database type : Disabled dropdown and show database alias name
      if (mappingItem.type == _Izenda4.default.MAPPING_TYPE.Database) {
        var selectedDB = item.findSelectedDatabase(mappingItem.fromDatabaseName);
        if (selectedDB) {
          options = [{ id: selectedDB.name, name: selectedDB.name }];
          value = selectedDB.name;
          disabled = true;
        }
      }

      var isMatchOption = !!(0, _fp.find)({ name: value }, options);
      value = isMatchOption ? value : null;

      return _react2.default.createElement(DropDown, {
        options: options,
        blankOption: true,
        onChange: _this.changeMappingItem.bind(_this, key, mappingItem),
        value: value,
        valueField: 'name',
        labelField: 'name',
        field: key + rowIndex,
        additionalKey: key + rowIndex,
        disabled: disabled,
        validations: _Izenda4.default.REQUIRE_CONSTRAINT,
        group: 'mapping' + rowIndex
      });
    }, _this.renderType = function (mappingItem, key, rowIndex) {
      return _react2.default.createElement(DropDown, {
        options: _Izenda4.default.MAPPING_TYPES,
        blankOption: true,
        onChange: _this.changeMappingItem.bind(_this, key, mappingItem),
        value: mappingItem[key],
        additionalKey: key + rowIndex,
        field: key + rowIndex,
        validations: _Izenda4.default.REQUIRE_CONSTRAINT,
        group: 'mapping' + rowIndex
      });
    }, _this.renderToObject = function (mappingItem, key, rowIndex) {
      return _react2.default.createElement(ValidatableInput, {
        onChange: _this.changeMappingItem.bind(_this, key, mappingItem),
        value: mappingItem[key],
        className: 'form-control',
        field: key + rowIndex,
        validations: _Izenda4.default.REQUIRE_CONSTRAINT,
        group: 'mapping' + rowIndex
      });
    }, _this.renderTenantObject = function (mappingItem, key, rowIndex) {
      var selectedTenant = _this.props.item.selectedTenant;

      var value = (0, _fp.toLower)(mappingItem[key]);
      var disabled = false;

      var selectedToDataSource = (0, _fp.find)({ fullDBName: mappingItem.toDatabaseName }, selectedTenant.databaseSources);
      var options = selectedToDataSource ? selectedToDataSource.dbSource.querySources : [];
      options = (0, _fp.flatMap)(function (item) {
        return { name: item.name, value: (0, _fp.toLower)(item.name) };
      }, options);

      // For Database type : Disabled dropdown and show database alias name
      if (mappingItem.type == _Izenda4.default.MAPPING_TYPE.Database && selectedToDataSource) {
        var databaseName = selectedToDataSource.name;
        options = [{ value: databaseName, name: databaseName }];
        if ((0, _fp.isEmpty)(value) || (0, _fp.toLower)(value) === (0, _fp.toLower)(databaseName)) {
          value = databaseName;
        }
        disabled = true;
      }

      var isMatchOption = !!(0, _fp.find)(function (option) {
        return (0, _fp.toLower)(option.name) === (0, _fp.toLower)(value);
      }, options);
      value = isMatchOption ? value : null;

      return _react2.default.createElement(DropDown, {
        options: options,
        blankOption: true,
        onChange: _this.changeMappingItem.bind(_this, key, mappingItem),
        value: value,
        valueField: 'value',
        labelField: 'name',
        field: key + rowIndex,
        additionalKey: key + rowIndex,
        disabled: disabled,
        validations: _Izenda4.default.REQUIRE_CONSTRAINT,
        group: 'mapping' + rowIndex
      });
    }, _this.renderTenant = function (mappingItem, key, rowIndex) {
      var workspaceTenants = _this.props.store.item.workspaceTenants;


      return _react2.default.createElement(
        'div',
        { className: 'select-box' },
        _react2.default.createElement(Select, {
          multi: true,
          simpleValue: true,
          options: workspaceTenants,
          labelKey: 'tenantName',
          valueKey: 'tenantId',
          noResultsText: 'No result',
          allowCreate: false,
          onChange: mappingItem.updateMappingTenant.bind(mappingItem),
          value: mappingItem.mappingTenantIds,
          blankOption: true,
          group: 'mapping' + rowIndex
        })
      );
    }, _this.renderActionColumn = function (mappingItem) {
      var localization = _this.props.localization;

      return _react2.default.createElement(
        'a',
        { onClick: _this.deleteMapping.bind(_this, mappingItem), className: 'action-column' },
        _react2.default.createElement('span', { title: localization.getText('COMMON_LABEL_DELETE'), className: 'icon-cancel ' })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Mapping, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          tenantMode = _props.tenantMode,
          item = _props.item,
          addMapping = _props.addMapping,
          dataSource = _props.dataSource;

      var TABLE_DEF = tenantMode ? _Izenda4.default.TABLE_DEF.TENANT_MAPPING : _Izenda4.default.TABLE_DEF.GLOBAL_MAPPING;

      var header = {
        component: _Izenda8.default,
        item: item,
        tenantMode: tenantMode,
        addMapping: addMapping,
        localization: localization
      };

      return _react2.default.createElement(
        _Izenda10.default,
        { header: header, className: 'izenda-CopyManagementMappings u_borderAll' },
        _react2.default.createElement(
          _Izenda11.Table,
          { dataSource: dataSource, minHeight: 200, maxHeight: 200 },
          _react2.default.createElement(
            _Izenda11.ColumnGroup,
            { title: localization.getText('COMMON_LABEL_FROM') },
            _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, TABLE_DEF['fromDatabaseName'], { cell: this.renderDatabaseName })),
            _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, TABLE_DEF['type'], { cell: this.renderType })),
            _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, TABLE_DEF['fromObject'], { cell: this.renderDataObject }))
          ),
          _react2.default.createElement(
            _Izenda11.ColumnGroup,
            { title: localization.getText('COMMON_LABEL_TO') },
            _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, TABLE_DEF['toDatabaseName'], { cell: this.renderDatabaseName })),
            _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, TABLE_DEF['toObject'], { cell: tenantMode ? this.renderTenantObject : this.renderToObject })),
            !tenantMode ? _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, TABLE_DEF['tenant'], { cell: this.renderTenant })) : null
          ),
          _react2.default.createElement(
            _Izenda11.ColumnGroup,
            { title: '\xA0' },
            _react2.default.createElement(_Izenda11.Column, (0, _extends3.default)({}, TABLE_DEF['action'], { cell: this.renderActionColumn }))
          )
        )
      );
    }

    /*
     * Load Destination connections
     */


    /*
     * Delete mapping item
     */


    /*
     * Change mapping item
     */


    /**
     * Update data object when change database name
     */


    /*
     * Render Database column
     */


    /*
     * Render Data Object column
     */


    /*
     * Render Type column
     */


    /*
     * Render To Object column
     */


    /*
     * Render To Object column for Advanced Copy
     */


    /**
     * Render Tenant Mapping column
     */


    /*
     * Render Action Column
     */

  }]);
  return Mapping;
}(_react.Component), _class2.propTypes = {
  // Workspace detail store
  store: _propTypes2.default.object.isRequired,
  // Workspace detail item
  item: _propTypes2.default.object.isRequired,
  addMapping: _propTypes2.default.func.isRequired,
  dataSource: _propTypes2.default.object.isRequired,
  // Use for Tenant mapping in Advanced Copy
  tenantMode: _propTypes2.default.bool,
  width: _propTypes2.default.number
}, _temp2)) || _class);
exports.default = Mapping;
module.exports = exports['default'];

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT = 'copyManagement/'; // ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Workspace Data Fetcher.
 */

exports.default = {
  /*
    * Load list of workspaces
    * @returns {promise}
    */
  getAllWorkspaces: function getAllWorkspaces() {
    var showOnlyMyWorkspace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var tenantId = 'null';
    return (0, _Izenda2.default)(ROOT + 'workspaces/' + tenantId + '/' + showOnlyMyWorkspace).get();
  },
  getAvailableSources: function getAvailableSources() {
    return null;
  },


  /**
     * [getWorkspaceDetail get workspace detail information]
     * @param  {[string]} workspaceId
     * @return {[object]}
     */
  getWorkspaceDetail: function getWorkspaceDetail(workspaceId) {
    workspaceId = workspaceId || 'null';
    return (0, _Izenda2.default)(ROOT + 'workspace/' + workspaceId).get();
  },


  /**
     * Delete a workspace by its id
     * @param {string} workspaceId
     * @returns {promise}
     */
  delete: function _delete(workspaceId) {
    return (0, _Izenda2.default)(ROOT + 'workspace/' + workspaceId).delete();
  },


  /**
     * [saveWorkspaceDetail save workspace with the detail]
     */
  saveWorkspaceDetail: function saveWorkspaceDetail(data) {
    return (0, _Izenda2.default)(ROOT).post(data);
  },


  /**
     * Load destination connections
     * @param {Object} tenant
     * @returns {promise}
     */
  loadDestinationConnections: function loadDestinationConnections(data) {
    return (0, _Izenda2.default)(ROOT + 'workspace/loadDestinationConnections/').post(data);
  },


  /**
     * validate Workspace Tenant
     * @param  {[object]} {workspaceTenant, mappings}
     * @returns {promise}
     */
  validateWorkspaceTenant: function validateWorkspaceTenant(data) {
    return (0, _Izenda2.default)(ROOT + 'workspace/validateWorkspaceTenant').post(data);
  },


  /**
     * Load connection by list tenants
     * @param {Array} tenants
     * @returns {promise}
     */
  loadDistinctConnections: function loadDistinctConnections(tenants) {
    var data = {
      tenantIds: tenants
    };
    return (0, _Izenda2.default)('connection/loadDistinctConnections/').post(data);
  },


  /**
     * validate WorkspaceName
     * @param  {object} data 
     * @return {promise}      
     */
  validateWorkspaceName: function validateWorkspaceName(data) {
    return (0, _Izenda2.default)(ROOT + 'workspace/validateName').post(data);
  },


  /**
     * check Connection Has Data Model
     * @param  {[array]} data 
     * @return {promise}     
     */
  checkConnectionHasDataModel: function checkConnectionHasDataModel(data) {
    return (0, _Izenda2.default)(ROOT + 'connectionsHasDataModel').post(data);
  },


  /**
     * detect Conflicting Role Permission
     * @param  {[array]} data 
     * @return {promise}     
     */
  detectConflictingRolePermission: function detectConflictingRolePermission(data) {
    return (0, _Izenda2.default)(ROOT + 'workspace/detectConflictingRolePermission').post(data);
  },


  /**
     * detect Conflicting Tenant Permissions
     * @param  {[array]} data 
     * @return {promise}      
     */
  detectConflictingTenantPermissions: function detectConflictingTenantPermissions(data) {
    return (0, _Izenda2.default)(ROOT + 'workspace/detectConflictingTenantPermissions').post(data);
  },


  /**
     * detect Conflicting Advanced Settings
     * @param  {[array]} data 
     * @return {promise}   
     */
  detectConflictingAdvancedSettings: function detectConflictingAdvancedSettings(data) {
    return (0, _Izenda2.default)(ROOT + 'workspace/detectConflictingAdvancedSettings').post(data);
  },


  /**
     * detect conflicting dashboards
     * @param  {[array]} data 
     * @return {promise}   
     */
  detectConflictingDashboards: function detectConflictingDashboards(data) {
    return (0, _Izenda2.default)(ROOT + 'workspace/detectConflictingDashboard').post(data);
  },


  /**
     * detect conflicting report
     * @param  {[array]} data 
     * @return {promise}   
     */
  detectConflictingReports: function detectConflictingReports(data) {
    return (0, _Izenda2.default)(ROOT + 'workspace/detectConflictingReport').post(data);
  },


  /**
     * detect conflicting template
     * @param  {[array]} data 
     * @return {promise}   
     */
  detectConflictingTemplates: function detectConflictingTemplates(data) {
    return (0, _Izenda2.default)(ROOT + 'workspace/detectConflictingTemplate').post(data);
  },


  /**
     * [runCopy description]
     * @param  {[object]} data [WorkspaceDetail]
     * @return {[object]} 
     */
  runCopy: function runCopy(data) {
    return (0, _Izenda2.default)(ROOT + 'copy').post(data);
  }
};
module.exports = exports['default'];

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CopyManagementUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  'use strict';

  var _require = __webpack_require__(1),
      forEach = _require.forEach;

  function updateDataSoucreBasedOnLinkedReport(connection) {
    var totalLinkedReportByConnection = 0;

    forEach(function (querySourceCategory) {
      var totalLinkedReportByCat = 0;

      forEach(function (dataObject) {
        totalLinkedReportByCat += dataObject.belongToCopiedReport;
      }, querySourceCategory.querySources);

      querySourceCategory.belongToCopiedReport = totalLinkedReportByCat > 0;
      totalLinkedReportByConnection += totalLinkedReportByCat;
    }, connection.dbSource.querySources);

    connection.belongToCopiedReport = totalLinkedReportByConnection > 0;
    return totalLinkedReportByConnection > 0;
  }

  module.exports = {
    updateDataSoucreBasedOnLinkedReport: updateDataSoucreBasedOnLinkedReport
  };
}();

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceMapping.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      uniqueId = _require.uniqueId,
      map = _require.map,
      split = _require.split,
      toLower = _require.toLower,
      find = _require.find;

  var m = __webpack_require__(5);
  var constants = __webpack_require__(91);
  var trackable = __webpack_require__(46);
  var WorkspaceMappingTenant = __webpack_require__(2417);

  function WorkspaceMapping(data, databaseSources, sourceConnections) {
    var props = {
      uniqueId: uniqueId,
      // State props
      workspaceId: null,
      fromDatabaseName: '',
      type: constants.MAPPING_TYPE.Schema,
      fromObject: '',
      fromServer: '',
      toDatabaseName: '',
      toObject: '',
      toServer: '',
      isGlobal: false,
      id: null,
      inserted: false,
      version: null,
      created: null,
      createdBy: null,
      modified: null,
      modifiedBy: null,
      workspaceMappingTenants: [],
      mappingTenantIds: function mappingTenantIds() {
        return map(function (tenant) {
          return tenant.tenantId;
        }, this.workspaceMappingTenants).toString();
      }
    };

    m.extendObservable(trackable(this), props);

    data && this.readWorkspaceMapping(data, databaseSources, sourceConnections);
  }

  /**
   * Read workspace mapping object
   * @param {Object} data
   */
  WorkspaceMapping.prototype.readWorkspaceMapping = m.action(function (data, databaseSources, sourceConnections) {
    this.workspaceId = data.workspaceId || null;
    this.fromDatabaseName = data.fromDatabaseName || '';
    this.type = data.type || constants.MAPPING_TYPE.Schema;
    this.fromObject = this.getFromObject(data, databaseSources);
    this.fromServer = data.fromServer;
    this.toDatabaseName = data.toDatabaseName || '';
    this.toObject = this.getToObject(data, sourceConnections);
    this.toServer = data.toServer;
    this.isGlobal = data.isGlobal || false;
    this.id = data.id || null;
    this.inserted = data.inserted || false;
    this.version = data.version || null;
    this.created = data.created || null;
    this.createdBy = data.createdBy || null;
    this.modified = data.modified || null;
    this.modifiedBy = data.modifiedBy || null;
    this.workspaceMappingTenants = map(function (tenant) {
      return new WorkspaceMappingTenant(tenant);
    }, data.workspaceMappingTenants);
  });

  /**
   * Logic get from data object
   * @param {type} data
   */
  WorkspaceMapping.prototype.getFromObject = function (data, databaseSources) {
    if (!data.fromObject && this.type === constants.MAPPING_TYPE.Database) {
      var selectedDB = find({ fullDBName: data.fromDatabaseName }, databaseSources);
      return selectedDB ? selectedDB.name : '';
    }

    return data.fromObject;
  };

  /**
   * Logic get to data object
   * @param {type} data
   */
  WorkspaceMapping.prototype.getToObject = function (data, databaseSources) {
    if (!data.toObject && this.type === constants.MAPPING_TYPE.Database) {
      var selectedDB = find({ fullDBName: data.toDatabaseName }, databaseSources);
      return selectedDB ? selectedDB.name : '';
    }

    return data.toObject;
  };

  /**
   * Update Mapping Tenant
   */
  WorkspaceMapping.prototype.updateMappingTenant = m.action(function (tenants) {
    var listSelectedTenant = split(',', tenants);
    var workspaceId = this.workspaceId;

    this.workspaceMappingTenants = map(function (tenantId) {
      return new WorkspaceMappingTenant({ tenantId: tenantId, workspaceId: workspaceId });
    }, listSelectedTenant);
  });

  /**
   * Check database is in options list or not
   * If not exist , set the default = first value
   */
  WorkspaceMapping.prototype.checkDatabaseName = function (databaseNames, key) {
    var selectedDatabase = find({ fullDBName: this[key] }, databaseNames);
    if (!selectedDatabase) {
      this[key] = databaseNames[0].fullDBName;
    }
  };

  /**
   * Check data object is in options list or not
   * If not exist , set the default = first value
   */
  WorkspaceMapping.prototype.checkDataObject = function (dataObjects) {
    var selectedDataObject = find({ name: this.fromObject }, dataObjects);
    if (!selectedDataObject) {
      this.fromObject = dataObjects[0].name;
    }
  };

  /**
   * Compare 2 mapping item
   * @param {type} mappingItem
   */
  WorkspaceMapping.prototype.compare = function (mappingItem, selectedTenant) {
    return this.workspaceId === mappingItem.workspaceId && this.fromDatabaseName === mappingItem.fromDatabaseName && this.type === mappingItem.type && this.fromObject === mappingItem.fromObject && (toLower(this.toObject) === toLower(mappingItem.toObject) || toLower(this.toObject).indexOf(constants.TENANT_TOKEN) > -1 && toLower(mappingItem.toObject).replace(selectedTenant.tenantUniqueName, constants.TENANT_TOKEN) === toLower(this.toObject) || toLower(this.toObject).indexOf(constants.TENANT_NAME_TOKEN) > -1 && toLower(mappingItem.toObject).replace(selectedTenant.name, constants.TENANT_NAME_TOKEN) === toLower(this.toObject));
  };

  /**
   * Add mapping tenant
   * @param {type} mappingItem
   */
  WorkspaceMapping.prototype.addMappingTenant = function (tenantId) {
    var isExistTenant = find({ tenantId: tenantId }, this.workspaceMappingTenants);
    !isExistTenant && this.workspaceMappingTenants.push({ workspaceMappingId: this.id, tenantId: tenantId });
  };

  module.exports = WorkspaceMapping;
}();

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get BUTTON_STYLE() {
    return {
      get bold() {
        return {
          className: 'u_textBold',
          title: _Izenda2.default.getText('FONT_STYLE_BOLD_TOOLTIP'),
          value: 'bold',
          text: 'B',
          isExecute: true
        };
      },
      get italic() {
        return {
          className: 'u_textItalic',
          title: _Izenda2.default.getText('FONT_STYLE_ITALIC_TOOLTIP'),
          value: 'italic',
          text: 'I',
          isExecute: true
        };
      },
      get underline() {
        return {
          className: 'u_textUnderline',
          title: _Izenda2.default.getText('FONT_STYLE_UNDERLINE_TOOLTIP'),
          value: 'underline',
          text: 'U',
          isExecute: true
        };
      },
      get strikethrough() {
        return {
          className: 'icon-del-text',
          title: _Izenda2.default.getText('COMMON_LABEL_STRIKETHROUGH'),
          value: 'strikethrough',
          isExecute: true
        };
      }
    };
  },
  get BUTTON_ALIGN() {
    return {
      get alignleft() {
        return {
          className: 'icon-align-left',
          title: _Izenda2.default.getText('COMMON_LABEL_ALIGN_LEFT'),
          value: 'JustifyLeft',
          isExecute: true
        };
      },
      get aligncenter() {
        return {
          className: 'icon-align-center',
          title: _Izenda2.default.getText('COMMON_LABEL_ALIGN_CENTER'),
          value: 'JustifyCenter',
          isExecute: true
        };
      },
      get alignright() {
        return {
          className: 'icon-align-right',
          title: _Izenda2.default.getText('COMMON_LABEL_ALIGN_RIGHT'),
          value: 'JustifyRight',
          isExecute: true
        };
      },
      get alignjustify() {
        return {
          className: 'icon-align-justify',
          title: _Izenda2.default.getText('COMMON_LABEL_ALIGN_JUSTIFY'),
          value: 'JustifyFull',
          isExecute: true
        };
      }
    };
  },
  get BUTTON_ALIGN_VERTICAL() {
    return {
      get alignTop() {
        return {
          className: 'icon-align-top',
          title: _Izenda2.default.getText('COMMON_LABEL_TOP'),
          value: 'alignTop'
        };
      },
      get alignMiddle() {
        return {
          className: 'icon-align-middle',
          title: _Izenda2.default.getText('COMMON_LABEL_MIDDLE'),
          value: 'alignMiddle'
        };
      },
      get alignBottom() {
        return {
          className: 'icon-align-bottom',
          title: _Izenda2.default.getText('COMMON_LABEL_BOTTOM'),
          value: 'alignBottom'
        };
      }
    };
  },
  get BUTTON_LIST() {
    return {
      get bullet() {
        return {
          type: 'bullet',
          component: __webpack_require__(226),
          className: 'icon-list-bullet',
          title: _Izenda2.default.getText('COMMON_LABEL_BULLET_LIST')
        };
      },
      get numbered() {
        return {
          type: 'numbered',
          component: __webpack_require__(226),
          className: 'icon-numbered',
          title: _Izenda2.default.getText('COMMON_LABEL_NUMBERED_LIST')
        };
      }
    };
  },
  get BUTTON_INDENT() {
    return {
      get indent() {
        return {
          className: 'icon-cl',
          title: _Izenda2.default.getText('DASHBOARD_TEXT_TITLE_TOOLBAR_CONSTANTS_INCREASE_INDENT'),
          value: 'Indent',
          isExecute: true
        };
      },
      get outdent() {
        return {
          className: 'icon-ex',
          title: _Izenda2.default.getText('DASHBOARD_TEXT_TITLE_TOOLBAR_CONSTANTS_DECREASE_INDENT'),
          value: 'Outdent',
          isExecute: true
        };
      }
    };
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTextTileToolbarConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingTenant.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  function MappingTenant(data) {
    data = data || {};
    this.id = data.id;
    this.tenantID = data.tenantID;
    this.name = data.name;
    this.displayValue = !isNil(this.tenantID) ? String.format('{0} - {1}', this.tenantID, this.name) : this.name;
  }

  module.exports = MappingTenant;
}();

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfigInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);
  var classnames = __webpack_require__(11);
  var observer = __webpack_require__(10).observer;
  var Validator = __webpack_require__(23);
  var Input = __webpack_require__(17);
  var ValidateInput = Validator()(__webpack_require__(17));
  var Numeric = Validator()(__webpack_require__(109));
  var GridLayout = __webpack_require__(13);

  var REQUIRE_CONSTRAINTS = __webpack_require__(119).REQUIRE_CONSTRAINTS;

  var _require = __webpack_require__(1),
      assign = _require.assign;

  var EmailConfigInput = function EmailConfigInput(props) {
    var type = props.type;
    var clazzName = classnames({ 'validation required': props.isRequired });

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: 3 },
        React.createElement(
          'label',
          { className: clazzName },
          props.title
        )
      ),
      React.createElement(
        GridLayout.Col,
        { cols: 9 },
        renderControl()
      )
    );

    function renderControl() {
      var InputControl = Input;
      var inputProps = {
        className: 'form-control',
        type: props.type,
        value: props.value,
        maxLength: 256,
        onChange: EventUtils.notifyChange(handleChange, EventUtils.INPUT)
      };
      if (props.isRequired) {
        InputControl = ValidateInput;
        inputProps = assign(inputProps, {
          field: props.dataKey,
          validations: REQUIRE_CONSTRAINTS
        });
      }

      if (type === 'checkbox') {
        return React.createElement(Input, {
          checked: props.value,
          type: 'checkbox',
          onChange: EventUtils.notifyChange(handleChange, EventUtils.CHECKBOX)
        });
      } else if (type === 'numeric') {
        return React.createElement(Numeric, {
          value: props.value,
          onChange: handleChange,
          field: props.dataKey,
          validations: REQUIRE_CONSTRAINTS
        });
      } else {
        return React.createElement(InputControl, inputProps);
      }
    }

    function handleChange(value) {
      props.onChange(props.dataKey, value);
    }
  };

  module.exports = observer(EmailConfigInput);
}();

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SubscriptionPopupDesinger.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(75);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(36);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(131);

var _Izenda10 = __webpack_require__(2470);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(2478);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(28);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(58);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(133);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(119);

var _Izenda21 = __webpack_require__(229);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(2498);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(275);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CANCEL_TEXT = 'cancel';
var ACCEPT_TEXT = 'accept';
var NUMBER_CHECK_INDEX = -1;
var SubscriptionPopup = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SubscriptionPopup, _Component);

  function SubscriptionPopup(props) {
    (0, _classCallCheck3.default)(this, SubscriptionPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SubscriptionPopup.__proto__ || (0, _getPrototypeOf2.default)(SubscriptionPopup)).call(this, props));

    _this.onClosing = function (closeCallback, type) {
      switch (type) {
        case ACCEPT_TEXT:
          _this.onAcceptClosing();
          break;
        case CANCEL_TEXT:
          _this.onCancelClosing();
          break;
      }
    };

    _this.cloneData();
    return _this;
  }

  (0, _createClass3.default)(SubscriptionPopup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.cloneData();
    }

    /**
     * Clone data object
     */

  }, {
    key: 'cloneData',
    value: function cloneData() {
      var _this2 = this;

      var data = this.props.data;

      (0, _mobx.transaction)(function () {
        _this2.subscriptionData = new _Izenda22.default((0, _fp.cloneDeep)(data), data.emailTemplates, data.reportFilter);
        _this2.subscriptionData.updateProperty('subscriptionFilterFields', data.subscriptionFilterFields && (0, _fp.cloneDeep)(_Izenda26.default.toJS(data.subscriptionFilterFields)));
        _this2.subscriptionData.updateProperty('subscriptionCommonFilterFields', data.subscriptionCommonFilterFields && (0, _fp.cloneDeep)(_Izenda26.default.toJS(data.subscriptionCommonFilterFields)));
        _this2.subscriptionData.cleanDirty();
      });
    }

    /**
     * Get title
     */

  }, {
    key: 'getTitle',
    value: function getTitle() {
      var localization = this.props.localization;
      var _subscriptionData = this.subscriptionData,
          isSubscription = _subscriptionData.isSubscription,
          isEdit = _subscriptionData.isEdit;

      if (isSubscription) return isEdit ? localization.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_EDIT') : localization.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_ADD');
      return isEdit ? localization.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_EDIT') : localization.getText('DASHBOARD_SCHEDULING_CONSTANTS_PAGE_TEXT_ADD');
    }

    /**
     * Validate Occurrence value.
     * @return {Promise}
     */

  }, {
    key: 'validateOccurrence',
    value: function validateOccurrence() {
      var validation = this.props.validation;


      if (this.subscriptionData.isEndAfter) {
        var tempValue = parseInt(this.subscriptionData.occurrence, 10);

        if (!tempValue) {
          validation.updateErrors([{
            key: 'occurrence',
            messages: [_Izenda19.default.MESSAGE.requiredOccurrence]
          }]);
          return (0, _bluebird.resolve)(false);
        }

        this.subscriptionData.occurrence = tempValue;
      }

      return (0, _bluebird.resolve)(true);
    }

    /**
     * Validate subscription instance.
     * @param {Boolean} forSaving
     * @return {Promise}
     */

  }, {
    key: 'validateSubscription',
    value: function validateSubscription(forSaving) {
      var _this3 = this;

      var validation = this.props.validation;

      return validation.validate().then(function (success) {
        if (success) {
          return _this3.validateOccurrence().then(function (result) {
            if (result) {
              if (forSaving) {
                return _this3.checkDuplicateInstanceName(forSaving);
              }
              return (0, _bluebird.resolve)(true);
            }
            return (0, _bluebird.resolve)(false);
          });
        }

        return success;
      });
    }

    /**
     * Check Duplicate instance name.
     * We check on browser first, then check with api if pass.
     * @return {Promise}
     */

  }, {
    key: 'checkDuplicateInstanceName',
    value: function checkDuplicateInstanceName(forSaving) {
      var _this4 = this;

      var _props = this.props,
          validation = _props.validation,
          dashboardDetail = _props.dashboardDetail;

      var commonFilterFields = (0, _fp.get)('dashboard.commonFilterFields', dashboardDetail);
      if (!this.props.onCheckDuplicateInstanceName(this.subscriptionData)) {
        var newCommonFilterFields = dashboardDetail && commonFilterFields.toJSON();

        return this.props.onValidateSubscription(this.subscriptionData, newCommonFilterFields).then(function (result) {
          if (result.success) {
            var originalId = _this4.subscriptionData.id;
            forSaving && _this4.subscriptionData.buildDataForSaving();
            _this4.subscriptionData.populate(result.subscription, _this4.subscriptionData.emailTemplates, _this4.subscriptionData.reportFilter);
            var subscription = (0, _fp.get)('subscription', result);
            if (subscription && subscription.state === _Izenda17.default.INSERT) {
              _this4.subscriptionData.id = originalId;
            }
            _this4.subscriptionData.markDirty();

            if (result.subscription.isStartDateAdjusted && forSaving) {
              return _this4.props.confirmMessage('warning', _Izenda19.default.MESSAGE.M06).then(function () {
                return (0, _bluebird.resolve)(false);
              });
            }
          }

          if (!result.success) {
            var errorKeys = (0, _fp.map)(function (item) {
              return item.key;
            }, result.messages);

            _this4.handleRedirectTabWhenError(errorKeys);

            validation.updateErrors(result.messages);
            return (0, _bluebird.resolve)(!forSaving);
          }

          validation.updateErrors(result.messages);
          return (0, _bluebird.resolve)(result.success);
        });
      } else {
        validation.updateErrors([{
          key: 'name',
          messages: [_Izenda19.default.MESSAGE.M05]
        }]);
        return (0, _bluebird.resolve)(false);
      }
    }

    /**
     * Handle redirect among tabs when error occurs
     */

  }, {
    key: 'handleRedirectTabWhenError',
    value: function handleRedirectTabWhenError(errorKeys) {
      var activeTabKey = this.refs.tabs.props.activeTabKey;
      // If there is only error of 'Recipients', then move to 'Delivery' tab.

      if (this.isAllErrorInSet([_Izenda19.default.FIELD_KEY.Recipients], errorKeys) && activeTabKey !== _Izenda19.default.DELIVERY_TAB.key) {
        this.setActiveTab(_Izenda19.default.DELIVERY_TAB.key);
      } else if (this.isAllErrorInSet([_Izenda19.default.FIELD_KEY.StartDate, _Izenda19.default.FIELD_KEY.StartTime, _Izenda19.default.FIELD_KEY.EndDate], errorKeys) && activeTabKey !== _Izenda19.default.SCHEDULER_TAB.key) {
        this.setActiveTab(_Izenda19.default.SCHEDULER_TAB.key);
      }
    }

    /**
     * Handle redirect among tabs when error occurs
     */

  }, {
    key: 'isAllErrorInSet',
    value: function isAllErrorInSet(set, errorKeys) {
      var result = true;
      (0, _fp.forEach)(function (key) {
        var index = (0, _fp.findIndex)(function (item) {
          return item === key;
        }, set);

        if (index === NUMBER_CHECK_INDEX) {
          result = false;
          return false;
        }
      }, errorKeys);
      return result;
    }

    /**
     * Set active tab
     * @param  {String} value
     */

  }, {
    key: 'setActiveTab',
    value: function setActiveTab(value) {
      this.subscriptionData.setCurrentTab(value);
    }

    /**
     * When click button OK on popup
     * @return {Promise} promise to handle async action
     */

  }, {
    key: 'onAcceptClosing',
    value: function onAcceptClosing() {
      var _this5 = this;

      var props = this.props,
          _props2 = this.props,
          localization = _props2.localization,
          validation = _props2.validation;

      var subscriptionData = this.subscriptionData;

      _Izenda4.default.isHavemailConfiguration(_Izenda6.default.tenantId).then(function (result) {
        if (!result.success && subscriptionData.deliveryType === (0, _fp.head)(_Izenda19.default.DELIVERY_TYPE).value) {
          return props.confirmMessage('error', result.message);
        }
        _this5.validateSubscription(true).then(function (result) {
          if (result && _this5.validateEmailFormat()) {
            props.onSave(subscriptionData);
            validation.reset();
            props.onAccept(subscriptionData);
          }
          return result;
        });
      });
    }

    /**
     * Validate email format recipients
     * @return {Boolean}
     */

  }, {
    key: 'validateEmailFormat',
    value: function validateEmailFormat() {
      var validation = this.props.validation;

      var emails = (0, _fp.split)(';', this.subscriptionData.recipients);
      var invalidEmails = [];
      (0, _fp.forEach)(function (email) {
        if (email && !_Izenda20.EMAIL_VALIDATION.REGEX.test(email)) {
          invalidEmails.push(email);
        }
      }, emails);

      if ((0, _fp.isEmpty)(invalidEmails)) return true;

      validation.updateErrors([{
        key: _Izenda19.default.FIELD_KEY.Recipients,
        messages: [_Izenda20.EMAIL_VALIDATION.MESSAGE(invalidEmails)]
      }]);

      return false;
    }

    /**
     * When click button Cancel on popup
     * @param  {Object} hidePopup function
     */

  }, {
    key: 'onCancelClosing',
    value: function onCancelClosing() {
      this.props.validation.reset();
      this.props.onReject();
    }

    /**
     * Closing popup
     * @param {text} type
     */

  }, {
    key: 'render',


    /**
     * Render component
     */
    value: function render() {
      var _this6 = this;

      var data = this.subscriptionData;
      var localization = this.props.localization;


      var canChangeTab = function canChangeTab(index, tabPanel, tabMenu, activeTabKey) {
        return _this6.validateSubscription().then(function (result) {
          if (result) {
            _this6.subscriptionData.setCurrentTab(activeTabKey);
          }
          return false;
        });
      };

      return _react2.default.createElement(
        _Izenda8.default,
        { visible: true, onClosing: this.onClosing, autoClose: false, type: 'none', sizeClass: 'modal-xs' },
        _react2.default.createElement(_Izenda8.default.Header, { title: this.getTitle() }),
        _react2.default.createElement(
          _Izenda8.default.Body,
          null,
          _react2.default.createElement(
            'div',
            { className: 'subscription' },
            _react2.default.createElement(
              'div',
              { className: 'form-horizontal' },
              _react2.default.createElement(_Izenda24.default, { data: data }),
              _react2.default.createElement('hr', { className: 'izenda-full-hr' }),
              _react2.default.createElement(
                _Izenda15.default,
                { className: 'panel-header-custom' },
                _react2.default.createElement(
                  _Izenda9.Tabs,
                  { ref: 'tabs', activeTabKey: data.currentTab, className: 'left-tab', canChangeTab: canChangeTab },
                  _react2.default.createElement(
                    _Izenda9.Tab,
                    {
                      title: localization.getText('SUBSCRIPTION_LABEL_SCHEDULE'),
                      tabKey: _Izenda19.default.SCHEDULER_TAB.key
                    },
                    _react2.default.createElement(_Izenda11.default, { data: data, onValidateSubscription: this.props.onValidateSubscription })
                  ),
                  _react2.default.createElement(
                    _Izenda9.Tab,
                    {
                      title: localization.getText('SUBSCRIPTION_LABEL_DELIVERY'),
                      tabKey: _Izenda19.default.DELIVERY_TAB.key
                    },
                    _react2.default.createElement(_Izenda13.default, (0, _extends3.default)({}, this.props, { data: data }))
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _Izenda8.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda8.default.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda8.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return SubscriptionPopup;
}(_react.Component), _class2.propTypes = {
  data: _propTypes2.default.object
}, _temp)) || _class);
exports.default = SubscriptionPopup;
module.exports = exports['default'];

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _desc, _value, _class, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardFilterStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Dashboard Filter Store
 */


var _Izenda = __webpack_require__(192);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(90);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(89);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(58);

var _Izenda8 = __webpack_require__(1164);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(587);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(588);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(983);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DashboardFilterStore = (_dec = (0, _mobx.action)('updateCascadingValue'), _dec2 = (0, _mobx.action)('updateCascadingFilterValue'), (_class = function () {
  (0, _createClass3.default)(DashboardFilterStore, [{
    key: 'reportFilter',
    get: function get() {
      return this.model.reportFilter;
    }
  }]);

  function DashboardFilterStore(dashboardDefinition) {
    (0, _classCallCheck3.default)(this, DashboardFilterStore);

    _initDefineProp(this, 'model', _descriptor, this);

    this.fetchFilterOperatorGroup = function () {
      return _Izenda4.default.loadFilterOperatorGroup();
    };

    this.model.dashboardDefinition = dashboardDefinition;
  }

  /**
   * Fetch filter operator group
   */


  (0, _createClass3.default)(DashboardFilterStore, [{
    key: 'getFilterData',


    /**
     * Fetch filter items.
     * @param {Number} version
     * @param {Array} filterValues
     * @param {Boolean} shouldUpdateFilterData
     * @param {Boolean} forCommon for comment filter.
     */
    value: function getFilterData(version, filterValues, shouldUpdateFilterData, forCommon) {
      var _this = this;

      return this.fetchFilterOperatorGroup().then(function (filterOperatorGroup) {
        var commonData = {
          operatorGroup: filterOperatorGroup
        };

        return _this.getConfigFieldList(commonData, filterValues, shouldUpdateFilterData, forCommon);
      });
    }

    /**
     * Calculate filter items using common filters.
     * @param {Object} commonData
     * @param {Array} subscriptionFilterFields
     * @param {Boolean} shouldUpdateFilterData
     * @param {Boolean} forCommon for comment filter.
     */

  }, {
    key: 'getConfigFieldList',
    value: function getConfigFieldList(commonData, subscriptionFilterFields, shouldUpdateFilterData, forCommon) {
      var _this2 = this;

      var mapCommonFilterToFilterDetail = (0, _mobx.action)('mapCommonFilterToFilterDetail', function (commonFilter) {
        var filterDetails = new _Izenda11.default();

        filterDetails.operatorId = commonFilter.operatorId;
        filterDetails.operatorSetting = commonFilter.operatorSetting;
        filterDetails.alias = commonFilter.displayName;
        filterDetails.name = commonFilter.name;
        filterDetails.dataType = commonFilter.dataType;
        filterDetails.value = commonFilter.value;
        filterDetails.id = commonFilter.id;
        filterDetails.visible = true;
        filterDetails.cascading = commonFilter.cascading;
        filterDetails.commonFilterRequired = (0, _fp.some)('required', commonFilter.filterFields);
        return filterDetails;
      });

      var listPromise = [];
      this.filters = forCommon ? this.model.commonFilters : this.model.clonedFilters;
      var configFieldList = this.model.reportFilter.configFieldList;


      this.model.reportFilter.configFieldList = this.filters.map(function (item) {
        var existingConfigField = (0, _fp.find)(function (configField) {
          return item.id === (0, _fp.get)('fieldDetails.id', configField);
        }, configFieldList);

        var filterDetails = mapCommonFilterToFilterDetail(item);
        var filterDetailsConfig = new _Izenda13.default(filterDetails, _this2.reportFilter.markUpdateResult.bind(_this2.reportFilter));

        filterDetailsConfig.setFilterValue = function (filterValue) {
          _Izenda13.default.prototype.setFilterValue.call(filterDetailsConfig, filterValue);
          item.setFilterValue(filterDetailsConfig.fieldDetails.value);
          item.setOperatorValue(filterDetailsConfig.fieldDetails.operatorId);
        };

        filterDetailsConfig.commonData = commonData;

        if (!(0, _fp.isNil)(subscriptionFilterFields)) {
          var matchedSubscriptionFilterField = (0, _fp.find)(function (filter) {
            return filter.commonFilterFieldId === item.id;
          }, subscriptionFilterFields);

          if (!(0, _fp.isNil)(matchedSubscriptionFilterField)) {
            filterDetailsConfig.fieldDetails.operatorId = matchedSubscriptionFilterField.operatorId;
            filterDetailsConfig.fieldDetails.value = matchedSubscriptionFilterField.value;
          }
        }

        var getFilterDataPromise = !(0, _fp.isNil)(existingConfigField) && !shouldUpdateFilterData ? _this2.copyFilterValue(filterDetailsConfig, existingConfigField) : !filterDetailsConfig.doesSupportDataSourceLazyLoading ? _this2.getOperatorValueSource(filterDetailsConfig) : null;

        listPromise.push(getFilterDataPromise);

        return filterDetailsConfig;
      });

      return (0, _bluebird.all)(listPromise);
    }

    /**
     * Copy filter value
     * @param {Object} configField
     * @param {Any} existingData
     */

  }, {
    key: 'copyFilterValue',
    value: function copyFilterValue(configField, existingConfigField) {
      configField.populateExistingSourceValue(existingConfigField);
    }

    /**
     * Fetch operator value source.
     * @param {Object} configField
     */

  }, {
    key: 'getOperatorValueSource',
    value: function getOperatorValueSource(configField) {
      var filterInfo = configField && configField.filterInfo || {};
      var fieldDetails = configField && configField.fieldDetails || {};
      var sourceType = filterInfo.sourceType;
      var dashboardDefinition = (0, _fp.invoke)('dashboardDefinition.getDashboardDefinition', this.model);

      // Remove first null item on array common filters
      if (dashboardDefinition.commonFilterFields && (0, _fp.isNil)(dashboardDefinition.commonFilterFields[0])) {
        dashboardDefinition.commonFilterFields = null;
      }

      var requestInfo = {
        dashboard: this.buildDashboardForGetFilterValue(dashboardDefinition),
        commonFilterName: fieldDetails.name
      };

      var populateData = function populateData(response) {
        configField.populateOperatorSourceValue(sourceType, response);
      };

      switch (sourceType) {
        case 'inTimePeriod':
          return _Izenda4.default.loadTimeperiods().then(populateData.bind(this));
        case 'dataSource':
          return _Izenda2.default.loadFilterFieldData(requestInfo).then(populateData.bind(this));
        case 'dataSourceTree':
          return _Izenda2.default.loadFilterFieldDataAsTree(requestInfo).then(populateData.bind(this));
        case 'fieldSource':
        default:
          return _Izenda2.default.loadFilterDataSource(requestInfo).then(populateData.bind(this));
      }
    }

    /**
     * Get partial data for filter value
     * @param  {object} pageInfo
     * @param  {object} configField
     * @param  {string} searchKey
     * @param  {boolean} isSearching
     * @param  {array} subscriptionCommonFilterFields
     * @return {Promise}
     */

  }, {
    key: 'getData',
    value: function getData(pageInfo, configField, searchKey, isSearching, subscriptionCommonFilterFields) {
      var fieldDetails = configField && configField.fieldDetails || {};
      var dashboardDefinition = (0, _fp.invokeArgs)('dashboardDefinition.getDashboardDefinition', [false], // [forSaving]
      this.model);

      if ((0, _fp.isNil)(subscriptionCommonFilterFields)) {
        dashboardDefinition.commonFilterFields = (0, _mobx.toJS)(this.filters);
        // Remove first null item on array common filters
        if (dashboardDefinition.commonFilterFields && (0, _fp.isNil)(dashboardDefinition.commonFilterFields[0])) {
          dashboardDefinition.commonFilterFields = null;
        }
      } else {
        var commonFilterFields = (0, _fp.cloneDeep)((0, _mobx.toJS)(this.filters));
        this.calculateCommonFilterFieldValues(commonFilterFields, subscriptionCommonFilterFields);
        dashboardDefinition.commonFilterFields = commonFilterFields;
      }

      var param = {
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        dashboard: this.buildDashboardForGetFilterValue(dashboardDefinition),
        commonFilterName: fieldDetails.name,
        includeAll: false,
        includeBlank: false,
        criteria: [{
          key: 'filter',
          value: searchKey
        }]
      };

      var operatorKey = (0, _fp.get)('operator.key', configField.filterInfo);
      var operatorsSupportBlank = ['equals(popup)', 'notequal(popup)', 'equals(manualentry)', 'equals(manualentrynoauto-complete)', 'notequal(manualentry)', 'notequal(manualentrynoauto-complete)', 'equals(selection)', 'notequal(selection)'];
      if ((0, _fp.includes)(operatorKey, operatorsSupportBlank)) {
        param.includeBlank = true;
      }
      if (param.includeBlank && configField.fieldDetails.operatorSetting === _Izenda6.default.SELECT_SETTINGS.MULTIPLE) {
        param.includeAll = true;
      }

      return _Izenda2.default.loadPartialFilterFieldData(param).then(function (response) {
        return configField.updateOperatorSourceDisplay(response, isSearching);
      });
    }

    /**
     * Update cascading filter value
     */

  }, {
    key: 'updateCascadingValue',
    value: function updateCascadingValue(configFields) {
      var configFieldList = this.model.reportFilter.configFieldList;
      var filterIndex = configFieldList.indexOf(configFields);

      if (filterIndex < 0) {
        return (0, _bluebird.resolve)();
      }

      var isCascadingFilter = configFields.fieldDetails.cascading;
      if (isCascadingFilter) {
        for (var i = filterIndex + 1; i < configFieldList.length; i++) {
          configFieldList[i].resetOperatorSourceDisplay();
          configFieldList[i].setFilterValue(null);

          if (!configFieldList[i].fieldDetails.cascading) {
            break;
          }
        }
      }

      return (0, _bluebird.resolve)();
    }

    /**
     * Update cascading filter value (use for subscription/scheduler)
     * @param {Object} sourceFilter
     * @param {Array} configFieldList
     * @param {Array} subscriptionCommonFilterFields
     */

  }, {
    key: 'updateCascadingFilterValue',
    value: function updateCascadingFilterValue(sourceFilter, configFieldList, subscriptionCommonFilterFields) {
      var filterIndex = configFieldList.indexOf(sourceFilter);

      if (filterIndex < 0) {
        return (0, _bluebird.resolve)();
      }

      if (sourceFilter.fieldDetails.cascading) {
        for (var i = filterIndex + 1; i < configFieldList.length; i++) {
          configFieldList[i].resetOperatorSourceDisplay();
          configFieldList[i].setFilterValue(null);
          var subscriptionCommonFilterField = (0, _fp.find)({ commonFilterFieldId: configFieldList[i].fieldDetails.id }, subscriptionCommonFilterFields);

          if (!(0, _fp.isNil)(subscriptionCommonFilterField)) {
            subscriptionCommonFilterField.value = null;
            subscriptionCommonFilterField.state !== _Izenda7.INSERT && (subscriptionCommonFilterField.state = _Izenda7.UPDATE);
          }

          if (!configFieldList[i].fieldDetails.cascading) {
            break;
          }
        }
      }

      return (0, _bluebird.resolve)();
    }

    /**
     * Build common filter value to load data source of filter in subscription/scheduler
     * @param {Array} commonFilterFields
     * @param {Array} data
     */

  }, {
    key: 'calculateCommonFilterFieldValues',
    value: function calculateCommonFilterFieldValues(commonFilterFields, data) {
      // map value from subscription/scheduler filter into commonFilterFields
      // to load data source for filters of subscription/scheduler.
      (0, _fp.forEach)(function (filter) {
        var filterIndex = (0, _fp.findIndex)(function (item) {
          return item.id === filter.commonFilterFieldId;
        }, commonFilterFields);
        filterIndex !== -1 && commonFilterFields[filterIndex].setFilterValue(filter.value);
      }, data);
    }

    /**
     * Build dashboard detail for load data source of filter
     * @param {Object} dashboardDefinition
     */

  }, {
    key: 'buildDashboardForGetFilterValue',
    value: function buildDashboardForGetFilterValue(dashboardDefinition) {
      var cloneDashboardDefinition = (0, _mobx.toJS)(dashboardDefinition);
      if (!(0, _fp.isEmpty)(cloneDashboardDefinition.dashboardParts)) {
        (0, _fp.forEach)(function (sub) {
          if (sub.state === _Izenda7.INSERT) {
            sub.id = null;
          }
        }, cloneDashboardDefinition.subscriptions);
        return cloneDashboardDefinition;
      }
      return (0, _fp.pick)(['id', 'commonFilterFields'], dashboardDefinition);
    }
  }]);
  return DashboardFilterStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    var _desc2, _value2, _obj;

    return _obj = {
      reportFilter: new _Izenda15.default(),
      dashboardDefinition: null,

      get commonFilters() {
        return (0, _fp.get)('dashboard.commonFilterFields', this.dashboardDefinition);
      },

      get clonedFilters() {
        return (0, _fp.flow)((0, _fp.get)('dashboard.commonFilterFields'), _mobx.toJS, (0, _fp.sortBy)(function (item) {
          return item.position;
        }), (0, _fp.map)(function (item) {
          return new _Izenda9.default(item);
        }))(this.dashboardDefinition);
      }
    }, (_applyDecoratedDescriptor(_obj, 'commonFilters', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_obj, 'commonFilters'), _obj), _applyDecoratedDescriptor(_obj, 'clonedFilters', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_obj, 'clonedFilters'), _obj)), _obj;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'reportFilter', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reportFilter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateCascadingValue', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateCascadingValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateCascadingFilterValue', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateCascadingFilterValue'), _class.prototype)), _class));
exports.default = DashboardFilterStore;
module.exports = exports['default'];

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonFilterField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(58);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CommonFilterField = (_class = function () {
  function CommonFilterField(data) {
    var _this = this;

    (0, _classCallCheck3.default)(this, CommonFilterField);

    _initDefineProp(this, 'id', _descriptor, this);

    _initDefineProp(this, 'name', _descriptor2, this);

    _initDefineProp(this, 'displayName', _descriptor3, this);

    _initDefineProp(this, 'value', _descriptor4, this);

    _initDefineProp(this, 'operatorId', _descriptor5, this);

    _initDefineProp(this, 'operatorSetting', _descriptor6, this);

    _initDefineProp(this, 'dashboardId', _descriptor7, this);

    _initDefineProp(this, 'filterFields', _descriptor8, this);

    _initDefineProp(this, 'filterFieldsMapping', _descriptor9, this);

    _initDefineProp(this, 'state', _descriptor10, this);

    _initDefineProp(this, 'position', _descriptor11, this);

    _initDefineProp(this, 'cascading', _descriptor12, this);

    _initDefineProp(this, 'required', _descriptor13, this);

    this.buildDataForSave = function () {
      return (0, _fp.omit)('filterFieldsMapping', _this);
    };

    this.setFilterValue = (0, _mobx.action)(function (filterValue) {
      _this.value = filterValue;
      (0, _fp.forEach)(function (item) {
        item.setFilterValue(filterValue);
      }, _this.filterFieldsMapping);
    });

    data && this.populateData(data);
  }

  /**
   * build data for save
   * @method buildDataForSave
   * @return {Object}         common filter field data
   */


  (0, _createClass3.default)(CommonFilterField, [{
    key: 'populateData',


    /**
     * Populate common filter field data to model
     * @param {Object} common filter field data
     */
    value: function populateData(data) {
      this.name = data.name;
      this.displayName = data.displayName;
      this.value = data.value;
      this.operatorId = data.operatorId;
      this.operatorSetting = data.operatorSetting;
      this.filterFields = data.filterFields;
      this.id = data.id;
      this.position = data.position;
      this.cascading = data.cascading;
      this.required = data.required;
    }

    /**
     * Update operator id
     * @param  {String} id
     */

  }, {
    key: 'setOperatorValue',
    value: function setOperatorValue(id) {
      this.operatorId = id;
      (0, _fp.forEach)(function (item) {
        item.setOperatorId(id);
      }, this.filterFieldsMapping);
    }

    /**
     * Update common filter value and all filter in dashboard
     * @method setFilterValue
     * @param  {String}       filterValue [description]
     */

  }]);
  return CommonFilterField;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'displayName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'operatorId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'operatorSetting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'dashboardId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'filterFields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'filterFieldsMapping', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'state', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda2.default.UPDATE;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'position', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'cascading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'required', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'populateData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setOperatorValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setOperatorValue'), _class.prototype)), _class);
exports.default = CommonFilterField;
module.exports = exports['default'];

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueDropdownGroup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Filter value dropdown component
 */

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(29);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OperatorValueDropdownGroup = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(OperatorValueDropdownGroup, _Component);

  function OperatorValueDropdownGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OperatorValueDropdownGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OperatorValueDropdownGroup.__proto__ || (0, _getPrototypeOf2.default)(OperatorValueDropdownGroup)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      _this.props.onChange([e.value]);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OperatorValueDropdownGroup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          filterSource = _props.filterSource,
          configField = _props.configField,
          store = _props.store;

      (0, _fp.isEmpty)(filterSource) && (0, _fp.invokeArgs)('getOperatorValueSource', [configField], store);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var filterInfo = props.filterInfo || {};
      var valueField = props.valueField;

      // For In Time Period type, use customId field
      if ((0, _fp.get)('sourceType', filterInfo) === 'inTimePeriod') {
        valueField = 'customId';
      }

      return _react2.default.createElement(_Izenda2.default, {
        options: props.filterSource,
        onChange: this.onChange,
        value: filterInfo.value && filterInfo.value[0],
        labelField: props.labelField,
        valueField: valueField,
        groupBy: props.groupBy,
        blankOption: true,
        blankOptionText: '...',
        disabled: props.disabled
      });
    }
  }]);
  return OperatorValueDropdownGroup;
}(_react.Component), _class.propTypes = {
  filterInfo: _react.PropTypes.object.isRequired,
  filterSource: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  labelField: _react.PropTypes.string.isRequired,
  valueField: _react.PropTypes.string.isRequired,
  groupBy: _react.PropTypes.string.isRequired
}, _temp2);
exports.default = OperatorValueDropdownGroup;
module.exports = exports['default'];

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueCheckBoxPopupLazyLoading.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var observer = __webpack_require__(10).observer;
  var React = __webpack_require__(0);
  var Popup = __webpack_require__(36);
  var OverflowText = __webpack_require__(68);
  var GridLayout = __webpack_require__(13);
  var ScrollBox = __webpack_require__(27);
  var LazyLoading = __webpack_require__(219);
  var localizer = __webpack_require__(12);
  var OPERATORVALUE_CHECKBOX_POPUP_HEIGHT = 300;
  var DEFAULT_ITEMS_PER_ROW = 3;

  var _require = __webpack_require__(1),
      clone = _require.clone,
      without = _require.without,
      identity = _require.identity;

  var OperatorValueCheckBoxPopup = React.createClass({
    displayName: 'OperatorValueCheckBoxPopup',

    propTypes: {
      filterSource: React.PropTypes.object.isRequired,
      filterInfo: React.PropTypes.object.isRequired,
      showPopup: React.PropTypes.bool,
      applyFormater: React.PropTypes.func,
      onChange: React.PropTypes.func
    },

    componentWillMount: function componentWillMount() {
      var filterInfo = this.props.filterInfo || {};
      this.selectedValues = clone(filterInfo.value);
    },

    handleValueChange: function handleValueChange(item) {
      item.checked = !item.checked;

      if (item.checked) {
        this.selectedValues.push(item.value);
      } else {
        this.selectedValues = without([item.value], this.selectedValues);
      }
    },

    onClosingPopup: function onClosingPopup(type) {
      var props = this.props;
      if (type === 'accept') {
        props.onChange && props.onChange(this.selectedValues);
        props.onAccept();
      } else if (type === 'cancel') {
        props.onReject();
      }
    },

    renderItemPopup: function renderItemPopup(item) {
      var applyFormater = this.props.applyFormater || identity;
      var label = applyFormater(item.value);

      return React.createElement(ItemCheckboxPopup, { item: item, label: label, onChange: this.handleValueChange });
    },

    getData: function getData(pageInfo) {
      var store = this.props.store;
      var info = {
        fromIndex: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize * DEFAULT_ITEMS_PER_ROW
      };
      store.getData(info, this.props.configField);
    },

    render: function render() {
      var props = this.props;
      var popupTitle = props.operatorGroup.fieldDetails.alias;
      var isLastPage = props.configField.operatorSourceDisplay.isLastPage;
      var source = props.configField.operatorSourceDisplay.data.length > 0 ? props.configField.operatorSourceDisplay.data : [];
      return React.createElement(
        Popup,
        { visible: true, onClosed: this.onClosingPopup, autoClose: true, type: 'none' },
        React.createElement(Popup.Header, { title: popupTitle }),
        React.createElement(
          Popup.Body,
          null,
          React.createElement(
            'div',
            { className: 'izenda-OperatorValueCheckBoxPopup' },
            React.createElement(
              ScrollBox,
              null,
              React.createElement(
                GridLayout,
                null,
                React.createElement(
                  GridLayout.Row,
                  { className: 'u_noMarginAll' },
                  React.createElement(LazyLoading, {
                    data: source,
                    viewHeight: OPERATORVALUE_CHECKBOX_POPUP_HEIGHT,
                    isLastPage: isLastPage,
                    getData: this.getData,
                    renderItem: this.renderItemPopup,
                    itemClassName: 'izenda-GridLayout-Col4'
                  })
                )
              )
            )
          )
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localizer.getText('COMMON_LABEL_OK')
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localizer.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  });

  var ItemCheckboxPopup = observer(function (props) {
    var item = props.item;

    return React.createElement(
      'div',
      { className: 'checkbox u_noMarginTop', key: 'chk-' + item.value },
      React.createElement(
        'label',
        null,
        React.createElement('input', { type: 'checkbox', value: item.value, checked: item.checked, onChange: props.onChange.bind(null, item) }),
        React.createElement(
          OverflowText,
          { tooltip: props.label },
          props.label
        )
      )
    );
  });

  module.exports = observer(OperatorValueCheckBoxPopup);
}();

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemVariables.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(133).SYSTEM_VARIABLES;

  var Label = __webpack_require__(71);
  var GridLayout = __webpack_require__(13);
  var Table = __webpack_require__(44).Table;
  var Column = __webpack_require__(44).Column;
  var Paginator = __webpack_require__(97);
  var action = __webpack_require__(2497);

  var TABLE_DEF = constants.TABLE_DEF;

  var SystemVariables = React.createClass({
    displayName: 'SystemVariables',

    render: function render() {
      var props = this.props;
      var store = props.store;
      var systemVariables = store.systemVariables;

      return React.createElement(
        GridLayout,
        { className: 'izenda-SystemVariables' },
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '12' },
            React.createElement(
              'span',
              { className: 'u_textBold' },
              constants.TITLE
            ),
            React.createElement('hr', null)
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '12' },
            React.createElement(
              Label,
              { className: '' },
              constants.INSTRUCTION
            )
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '12' },
            React.createElement(
              Table,
              { dataSource: systemVariables.variables,
                onSortChange: props.onSortChange,
                sortInfo: systemVariables.pageInfo.colSortDirs },
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['name'], {
                cell: this.renderName })),
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['dataType'], {
                cell: this.renderDataType })),
              React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['description'], {
                cell: this.renderDescription }))
            ),
            React.createElement(Paginator, { onChange: store.goToSystemVariablesPage.bind(store),
              onDropdownChange: store.onSystemVariablesPageSizeChange.bind(store),
              totalRecords: systemVariables.pageInfo.totalRecords,
              pageSize: systemVariables.pageInfo.pageSize,
              pageIndex: systemVariables.pageInfo.pageIndex })
          )
        )
      );
    },

    renderName: function renderName(detail) {
      return React.createElement(
        'span',
        {
          className: 'izenda-SystemVariables-linkable truncate overflow-text',
          title: detail.name,
          onClick: this.props.onSelect.bind(this, detail) },
        detail.name
      );
    },

    renderDataType: function renderDataType(detail) {
      return React.createElement(
        'span',
        { onClick: this.props.onSelect.bind(this, detail) },
        detail.dataType
      );
    },

    renderDescription: function renderDescription(detail) {
      return React.createElement(
        'span',
        { onClick: this.props.onSelect.bind(this, detail) },
        detail.description
      );
    }
  });

  module.exports = connect(action)(SystemVariables);
}();

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemVariablesUI.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = __webpack_require__(5);

  function SystemVariablesUI(data) {
    this.$sourceNode = null;

    var props = {
      visible: false,
      left: 0,
      top: 0,
      sourceType: null,
      cursorPosition: 0
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  };

  /**
   * populate data
   * @param  {object} data
   */
  SystemVariablesUI.prototype.populateData = m.action(function (data) {
    this.visible = data.visible;
    this.left = data.left;
    this.top = data.top;
    this.sourceType = data.sourceType;
    this.cursorPosition = data.cursorPosition;
    this.$sourceNode = data.$sourceNode;
  });

  /**
   * Update visible value
   * @param  {Boolean} value
   */
  SystemVariablesUI.prototype.updateVisible = function (value) {
    this.visible = value;
  };

  module.exports = SystemVariablesUI;
}();

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.BoardList.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Board List
 */

!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      isArray = _require.isArray,
      isEmpty = _require.isEmpty,
      map = _require.map;

  var CategoryDetail = __webpack_require__(161);
  var LazyLoadingUtils = __webpack_require__(118);

  module.exports = function (constants, itemsFieldName) {
    var defaultSearchText = '';
    function BoardList() {
      var props = {
        isLastPage: false,
        categories: [], // Array of CategoryDetail
        searchType: constants.SEARCH_CRITERIA[0].value,
        searchText: defaultSearchText,
        sortBy: constants.SORT_CRITERIA[0].value,
        sortDir: constants.SORT_TYPES.ASC,
        isEmpty: function isEmpty() {
          var isEmptyCategory = true;
          for (var i = 0; i < this.categories.length; i++) {
            if (!this.categories[i].isEmpty) {
              isEmptyCategory = false;
              break;
            }
          }
          return isEmptyCategory;
        }
      };

      m.extendObservable(this, props);
    }

    /**
     * Update search item
     * @param  {String} searchType
     */
    BoardList.prototype.setSearchType = function (searchType) {
      this.setProperty('searchType', searchType || constants.SEARCH_CRITERIA[0].value);
    };

    /**
     * Update search value
     * @param  {String} searchText
     */
    BoardList.prototype.setSearchText = function (searchText) {
      this.setProperty('searchText', searchText || defaultSearchText);
    };

    /**
     * Update sort item
     * @param  {String} sortBy
     */
    BoardList.prototype.setSortBy = function (sortBy) {
      this.setProperty('sortBy', sortBy);
    };

    /**
     * Update sort direction
     * @param  {String} sortDir
     */
    BoardList.prototype.setSortDir = function (sortDir) {
      this.setProperty('sortDir', sortDir);
    };

    /**
     * Update search information.
     * @param  {String} searchType
     * @param  {String} searchText
     * @param  {String} sortBy
     */
    BoardList.prototype.setSearchInfo = m.action(function (searchType, searchText, sortBy) {
      searchType && this.setSearchType(searchType);
      this.setSearchText(searchText);
      sortBy && this.setSortBy(sortBy);
    });

    /**
     * Set value for property by its name
     * @param  {String} key
     * @param  {Object} value
     */
    BoardList.prototype.setProperty = function (key, value) {
      this[key] = value;
    };

    /**
     * Populate categories
     * @param {Array} data
     */
    BoardList.prototype.readBoardList = m.action(function (data) {
      data = data || [];

      if (isArray(data) && !isEmpty(data)) {
        this.categories = data.map(function (item) {
          return new CategoryDetail(item);
        });
      } else {
        this.categories = [];
      }
    });

    /**
     * Update display state for all board items
     * @param  {Boolean} state
     */
    BoardList.prototype.toggleReportExpandAll = m.action(function (state) {
      this.categories.forEach(function (groupCategory) {
        groupCategory.subCategories && groupCategory.subCategories.forEach(function (category) {
          category.subCategories && category.subCategories.forEach(function (subCategory) {
            subCategory[itemsFieldName].forEach(function (board) {
              board.setStateExpanded && board.setStateExpanded(state);
            });
          });
        });
      });
    });

    /**
     * Reset subscribe all categories
     */
    BoardList.prototype.resetSubscribes = m.action(function () {
      this.categories.forEach(function (groupCategory) {
        // Reset subscription of itself
        groupCategory.resetSubscribes && groupCategory.resetSubscribes();

        // Reset subscription of its children categories
        groupCategory.subCategories && groupCategory.subCategories.forEach(function (category) {
          category.resetSubscribes && category.resetSubscribes();
        });
      });
    });

    /**
     * Poplate data
     * @param {Array} result
     * @param {Boolean} isReset
     * @param {Object} treeMap
     */
    BoardList.prototype.populate = m.action(function (result, isReset, treeMap) {
      var data = result.data;

      var categories = map(function (item) {
        var category = new CategoryDetail();
        category.populateDataForGlobalLocalCategory(item);
        return category;
      }, data);

      if (isReset) {
        this.categories.splice(0, this.categories.length);
      }

      this.isLastPage = result.isLastPage;
      LazyLoadingUtils.concatTree(this.categories, categories, treeMap, result.numOfChilds, []);
    });

    return BoardList;
  };
}();

/***/ }),
/* 1170 */,
/* 1171 */,
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportList.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(44);

var _Izenda2 = __webpack_require__(136);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(47);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2521);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(15);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _fp = __webpack_require__(1);

var _mobxReact = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputValidator = (0, _Izenda4.default)()(_Izenda8.default);
var SelectValidator = (0, _Izenda4.default)()(_Izenda6.default);
var TABLE_DEF = _Izenda2.TableDefinition.ImportSourceType;

var ImportList = (_dec = (0, _Izenda12.default)(_Izenda10.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ImportList, _Component);

  function ImportList(props) {
    (0, _classCallCheck3.default)(this, ImportList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImportList.__proto__ || (0, _getPrototypeOf2.default)(ImportList)).call(this, props));

    _this.renderFileName = function (_ref) {
      var name = _ref.name;

      return _react2.default.createElement(
        'span',
        { className: 'truncate overflow-text', title: name },
        name
      );
    };

    _this.renderType = function (data) {
      var type = _this.props.getType(data);
      return _react2.default.createElement(
        'span',
        { className: 'truncate overflow-text', title: type },
        type
      );
    };

    _this.renderNewReportName = function (data) {
      var isDashboardTab = _this.props.isDashboardTab;

      var key = isDashboardTab ? _Izenda2.KEY_NEW_REPORT_DASHBOARD_NAME : _Izenda2.KEY_NEW_REPORT_NAME;
      var validationRules = data.isReport ? data.content.type === 0 ? _Izenda2.REPORT_NAME_VALIDATION_RULES : _Izenda2.TEMPLATE_NAME_VALIDATION_RULES : _Izenda2.DASHBOARD_NAME_VALIDATION_RULES;

      return _react2.default.createElement(InputValidator, {
        className: 'form-control validator',
        value: data.content.name,
        onChange: _this.props.updateName.bind(_this.props, data),
        validations: validationRules,
        field: key,
        group: _this.rowKey + '.' + data.content.index
      });
    };

    _this.renderSaveInto = function (data) {
      var saveInto = _this.props.saveInto;


      return _react2.default.createElement(SelectValidator, {
        simpleValue: true,
        labelKey: 'name',
        valueKey: 'id',
        options: saveInto,
        value: data.saveIntoId,
        onChange: _this.props.updateSaveIntoId.bind(_this.props, data),
        tooltipPosition: 'bottom',
        field: _Izenda2.KEY_SAVE_INTO,
        group: _this.rowKey + '.' + data.content.index
      });
    };

    _this.renderCategory = function (data) {
      var store = _this.props.store;

      var categories = (0, _fp.sortBy)(function (cat) {
        return cat.name.toLowerCase();
      }, data.categories);
      var importSourceCat = (0, _fp.get)('model.importSourceCat', store);

      return _react2.default.createElement(SelectValidator, {
        simpleValue: true,
        disabled: importSourceCat,
        options: categories,
        labelKey: 'name',
        valueKey: 'id',
        value: data.content.categoryId,
        noResultsText: _Izenda2.HINT_MESSAGE.CATEGORY,
        onChange: _this.props.updateCategory.bind(_this.props, data),
        onAddNew: store.addNewCategory.bind(store, data),
        scalable: false,
        field: _Izenda2.KEY_CATEGORY,
        group: _this.rowKey + '.' + data.content.index
      });
    };

    _this.renderSubCategory = function (data) {
      var store = _this.props.store;

      var subCategories = (0, _fp.sortBy)(function (subCat) {
        return subCat.name.toLowerCase();
      }, data.subCategories);
      var importSourceCat = (0, _fp.get)('model.importSourceCat', store);

      return _react2.default.createElement(SelectValidator, {
        simpleValue: true,
        options: subCategories,
        labelKey: 'name',
        valueKey: 'id',
        value: data.content.subCategoryId,
        noResultsText: _Izenda2.HINT_MESSAGE.SUB_CATEGORY,
        onChange: _this.props.updateSubCategory.bind(_this.props, data),
        onAddNew: store.addNewSubCategory.bind(store, data),
        scalable: false,
        disabled: (0, _fp.isNil)(data.content.categoryId) || importSourceCat,
        field: _Izenda2.KEY_SUBCATEGORY,
        group: _this.rowKey + '.' + data.content.index
      });
    };

    _this.renderGear = function (data) {
      return _react2.default.createElement(
        'div',
        { className: 'u_flexHorizontal u_flexCenterAlignItems' },
        _react2.default.createElement(
          'a',
          { onClick: _this.props.openDetailFilePopup.bind(_this.props, data) },
          _react2.default.createElement('span', { className: 'icon-info-circled' })
        ),
        (!_this.props.isDashboardTab || !data.isReport) && _react2.default.createElement('span', { className: 'icon-cancel', onClick: _this.props.removeFile.bind(_this.props, data) })
      );
    };

    _this.rowKey = _this.props.isDashboardTab ? 'dashboard' : 'report';
    return _this;
  }

  (0, _createClass3.default)(ImportList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          height = _props.height,
          dataSource = _props.dataSource,
          isDashboardTab = _props.isDashboardTab;


      var newHeight = height - (_Izenda2.DEFAULT_REST_HEIGHT + _Izenda2.DEFAULT_DATABASE_MAPPING_HEIGHT) > _Izenda2.DEFAULT_TABLE_HEIGHT ? height - (_Izenda2.DEFAULT_REST_HEIGHT + _Izenda2.DEFAULT_DATABASE_MAPPING_HEIGHT) : _Izenda2.DEFAULT_TABLE_HEIGHT;

      return _react2.default.createElement(
        _Izenda.Table,
        { minHeight: newHeight, maxHeight: newHeight, dataSource: dataSource, sortInfo: true, staticRender: true },
        _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['fileName'], { cell: this.renderFileName })),
        _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['type'], { cell: this.renderType })),
        _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF[isDashboardTab ? 'newReportOrDashboardName' : 'newReportName'], {
          cell: this.renderNewReportName
        })),
        (0, _fp.isNil)(_Izenda14.default.tenantId) && _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['saveInto'], { cell: this.renderSaveInto })),
        _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['category'], { cell: this.renderCategory })),
        _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['subCategory'], { cell: this.renderSubCategory })),
        _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['gear'], { cell: this.renderGear }))
      );
    }
  }]);
  return ImportList;
}(_react.Component), _class2.propTypes = {
  height: _propTypes2.default.number,
  dataSource: _mobxReact.propTypes.arrayOrObservableArray,
  saveInto: _mobxReact.propTypes.arrayOrObservableArray,
  loadCategories: _propTypes2.default.func,
  loadSubCategories: _propTypes2.default.func,
  store: _mobxReact.propTypes.observableObject
}, _temp)) || _class);
exports.default = ImportList;
module.exports = exports['default'];

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FileUpload.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactFileupload = __webpack_require__(2525);

var _reactFileupload2 = _interopRequireDefault(_reactFileupload);

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileUpload = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FileUpload, _Component);

  function FileUpload() {
    (0, _classCallCheck3.default)(this, FileUpload);
    return (0, _possibleConstructorReturn3.default)(this, (FileUpload.__proto__ || (0, _getPrototypeOf2.default)(FileUpload)).apply(this, arguments));
  }

  (0, _createClass3.default)(FileUpload, [{
    key: 'resolveUrl',


    /**
     * resolve url
     * @param {String} path 
     */
    value: function resolveUrl(path) {
      var root = _config2.default.WebApiUrl;
      var safePath = path ? path[0] === '/' ? path.substring(1) : path : '';
      return root.concat(root.slice(-1) !== '/' ? '/'.concat(safePath) : safePath);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          localization = _props.localization,
          className = _props.className;

      options.baseUrl = this.resolveUrl(options.baseUrl);

      var btnClass = (0, _classnames2.default)('btn', 'btn-primary', {
        'btn-success': this.props.isHighLight
      });

      return _react2.default.createElement(
        _reactFileupload2.default,
        { options: options, className: className },
        _react2.default.createElement(
          'button',
          { ref: 'chooseAndUpload', className: btnClass },
          localization.getText('IMPORT_BROWSE')
        )
      );
    }
  }]);
  return FileUpload;
}(_react.Component), _class2.propTypes = {
  options: _react.PropTypes.object.isRequired,
  isHighLight: _react.PropTypes.bool
}, _class2.defaultProps = {
  isHighLight: false
}, _temp)) || _class);
exports.default = FileUpload;
module.exports = exports['default'];

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportErrorPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(27);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportErrorPopup = (_dec = (0, _Izenda6.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ImportErrorPopup, _Component);

  function ImportErrorPopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ImportErrorPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportErrorPopup.__proto__ || (0, _getPrototypeOf2.default)(ImportErrorPopup)).call.apply(_ref, [this].concat(args))), _this), _this.onClosing = function () {
      _this.props.store.hideErrorMessages();
      _this.props.onReject();
    }, _this.renderMessages = function (messages) {
      return _react2.default.createElement(
        _Izenda4.default,
        { autoHeight: true },
        messages.map(function (item, index) {
          return _react2.default.createElement(
            'p',
            { key: index },
            item
          );
        })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ImportErrorPopup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          messages = _props.messages;


      return _react2.default.createElement(
        _Izenda2.default,
        { visible: true, onClosing: this.onClosing, type: 'none', autoClose: false, sizeClass: 'modal-lg' },
        _react2.default.createElement(_Izenda2.default.Header, { title: localization.getText('IMPORT_LABEL_VALIDATION_ERRORS_FILES') }),
        _react2.default.createElement(
          _Izenda2.default.Body,
          null,
          this.renderMessages(messages)
        ),
        _react2.default.createElement(
          _Izenda2.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda2.default.ConfirmationButton,
            { key: 'accept', type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          )
        )
      );
    }
  }]);
  return ImportErrorPopup;
}(_react.Component)) || _class);
exports.default = ImportErrorPopup;
module.exports = exports['default'];

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFileContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2541);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportFileContent = (_class = function () {
  function ImportFileContent(data, localCategoryId, isReport) {
    (0, _classCallCheck3.default)(this, ImportFileContent);

    _initDefineProp(this, 'id', _descriptor, this);

    _initDefineProp(this, 'name', _descriptor2, this);

    _initDefineProp(this, 'content', _descriptor3, this);

    _initDefineProp(this, 'saveIntoId', _descriptor4, this);

    _initDefineProp(this, 'categories', _descriptor5, this);

    _initDefineProp(this, 'subCategories', _descriptor6, this);

    this.isReport = false;

    this.id = data.id;
    this.name = data.name;
    this.content = new _Izenda2.default(data.content);
    this.saveIntoId = localCategoryId;
    this.isReport = isReport;
  }

  /**
   * Buid data
   */


  (0, _createClass3.default)(ImportFileContent, [{
    key: 'buildData',
    value: function buildData() {
      return {
        content: this.content.buildData(),
        id: this.id,
        name: this.name
      };
    }

    /**
     * Update save into id
     * @param {String} saveIntoId
     */

  }, {
    key: 'updateSaveIntoId',
    value: function updateSaveIntoId(saveIntoId) {
      this.saveIntoId = saveIntoId;
    }

    /**
     * Update category
     * @param {String} categoryId
     */

  }, {
    key: 'updateCategory',
    value: function updateCategory(categoryId, categoryName) {
      this.content.categoryId = categoryId;
      this.content.categoryName = categoryName;
    }

    /**
     * Update sub-category
     * @param {String} subCategoryId
     */

  }, {
    key: 'updateSubCategory',
    value: function updateSubCategory(subCategoryId, subCategoryName) {
      this.content.subCategoryId = subCategoryId;
      this.content.subCategoryName = subCategoryName;
    }
  }]);
  return ImportFileContent;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'content', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'saveIntoId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'categories', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'subCategories', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'updateSaveIntoId', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateSaveIntoId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateSubCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateSubCategory'), _class.prototype)), _class);
exports.default = ImportFileContent;
module.exports = exports['default'];

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_WIDTH_COLUMN_TEXT = 150; // ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var DEFAULT_WIDTH_COLUMN_ICON = 50;

exports.default = {
  DEFAULT_ROW_HEIGHT: 31,
  DEFAULT_ROW_HEIGHT_HEADER: 41,
  DEFAULT_TABLE_HEIGHT: 775,
  DEFAULT_REST_HEIGHT: 36,

  get TableDefinition() {
    return {
      get ImportHistorySourceType() {
        return {
          select: {
            key: 'select',
            columnKey: 'Select',
            width: DEFAULT_WIDTH_COLUMN_ICON,
            resizable: false,
            title: '',
            sortable: false
          },
          fileName: {
            key: 'fileName',
            columnKey: 'FileName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_FILENAME');
            },
            sortable: true
          },
          typeName: {
            key: 'typeName',
            columnKey: 'TypeName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_TYPE');
            },
            sortable: true
          },
          modified: {
            key: 'modified',
            columnKey: 'Modified',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_IMPORTED_DATE');
            },
            sortable: true
          },
          modifiedBy: {
            key: 'modifiedBy',
            columnKey: 'ModifiedBy',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_IMPORTER');
            },
            sortable: true
          },
          statusName: {
            key: 'statusName',
            columnKey: 'StatusName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_IMPORT_STATUS');
            },
            sortable: true
          },
          errorMessage: {
            key: 'errorMessage',
            columnKey: 'ErrorMessage',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_FAILURE_ERROR');
            },
            sortable: true
          },
          objectName: {
            key: 'objectName',
            columnKey: 'ObjectName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_REPORT_OR_DASHBOARD_NAME');
            },
            sortable: true
          },
          saveInto: {
            key: 'saveInto',
            columnKey: 'SaveInto',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_SAVE_INTO');
            },
            sortable: true
          },
          categoryName: {
            key: 'categoryName',
            columnKey: 'CategoryName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_CATEGORY');
            },
            sortable: true
          },
          subCategoryName: {
            key: 'subCategoryName',
            columnKey: 'SubCategoryName',
            width: DEFAULT_WIDTH_COLUMN_TEXT,
            get title() {
              return _Izenda2.default.getText('IMPORT_CONSTANTS_SOURCE_TYPE_SUB_CATEGORY');
            },
            sortable: true
          },
          action: {
            key: 'action',
            columnKey: 'Action',
            width: DEFAULT_WIDTH_COLUMN_ICON,
            resizable: false,
            title: '',
            sortable: false
          }
        };
      }
    };
  }
};
module.exports = exports['default'];

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryGridStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Category Grid Store
 */
!function () {
  var extendObservable = __webpack_require__(5).extendObservable;
  var observe = __webpack_require__(5).observe;
  var advancedSettingsDataFetcher = __webpack_require__(263);
  var CategoryMetadata = __webpack_require__(986);
  var commonMessages = __webpack_require__(37);
  var uiState = __webpack_require__(15);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      some = _require.some,
      map = _require.map,
      isObject = _require.isObject,
      findIndex = _require.findIndex,
      remove = _require.remove,
      invoke = _require.invoke;

  /**
   * contructor
   */


  function CategoryGridStore(tenantId) {
    this.tenantId = tenantId || '';
    this.lastAddCategory = null;

    extendObservable(this, {
      categoryMetadatas: [],

      alertMessage: commonMessages.EMPTY_MESSAGE,
      hasChange: function hasChange() {
        return some(['isDirty', true], this.categoryMetadatas);
      }
    });
  }

  /**
   * get init store when component mount
   */
  CategoryGridStore.prototype.init = function () {
    this.observeTenantId();
    uiState.setCheckDirtyFunction(function () {
      return this.hasChange;
    }.bind(this));

    return this.getInitial();
  },
  /**
   * unlick between uiState on store
   * @return {[type]} [description]
   */
  CategoryGridStore.prototype.destroy = function () {
    this.disposeCategoryGrid();
    uiState.resetCheckDirtyFunction();
  };
  /**
   * observe tenantID on setting level
   */
  CategoryGridStore.prototype.observeTenantId = function () {
    this.disposeCategoryGrid = observe(uiState, 'tenantId', function () {
      this.getInitial(uiState.getTenantId());
    }.bind(this));
  };

  CategoryGridStore.prototype.getInitial = function () {
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
    return this.getCategories(uiState.getTenantId());
  };

  /**
   * get category from db
   */
  CategoryGridStore.prototype.getCategories = function (tenantId) {
    tenantId = tenantId || this.tenantId;
    var handleAfterGetCategories = function (result) {
      result = result || {};
      this.categoryMetadatas = result.map(function (item) {
        var categoryMetadata = new CategoryMetadata(item);
        return categoryMetadata;
      });
      return null;
    }.bind(this);

    this.categoryMetadatas = [];
    this.lastAddCategory = null;

    return advancedSettingsDataFetcher.getAllCategories(tenantId).then(handleAfterGetCategories.bind(this));
  };

  /**
   * save all category to DB
   */
  CategoryGridStore.prototype.saveCategories = function () {
    function showErrorMessages(result) {
      var message = localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED');
      if (!result.success) {
        var messageData = result.messages[0];
        if (isObject(messageData)) {
          message = messageData.messages;
        } else {
          message = messageData;
        }
      }

      this.alertMessage = {
        type: result.success ? 'success' : 'error',
        message: message
      };
      result.success && this.getCategories(uiState.getTenantId());

      return result;
    }

    var request = map(invoke('prepareRequestJSON'), this.categoryMetadatas);
    return advancedSettingsDataFetcher.saveCategories(request).then(showErrorMessages.bind(this));
  };

  /**
   * add category item
   */
  CategoryGridStore.prototype.addCategory = function (value, label) {
    var item = {
      name: label,
      id: value,
      isNew: true
    };

    var categoryMetadata = new CategoryMetadata(item);
    if (findIndex(this.categoryMetadatas, categoryMetadata) < 0) {
      this.categoryMetadatas.push(categoryMetadata);
    }
  };

  /**
   * add empty category
   */
  CategoryGridStore.prototype.addEmptyCategory = function () {
    var categoryMetadata = new CategoryMetadata();
    categoryMetadata.markDirty();
    this.categoryMetadatas.unshift(categoryMetadata);
    this.lastAddCategory = categoryMetadata;
  };

  /**
   * delete category from DB
   */
  CategoryGridStore.prototype.delCategory = function (item) {
    if (!isEmpty(item.id)) {
      var handleAfterDeleteCategory = function (result) {
        if (result.success) {
          this.categoryMetadatas = remove({
            key: item.key
          }, this.categoryMetadatas);
        } else {
          this.getCategories(null);
        }
        return result;
      }.bind(this);

      return advancedSettingsDataFetcher.deleteCategory(item.id).then(handleAfterDeleteCategory);
    } else {
      this.categoryMetadatas = remove({
        key: item.key
      }, this.categoryMetadatas);
    }
    return null;
  };

  /**
   * new name value for category
   */
  CategoryGridStore.prototype.updateCategoryName = function (item, value) {
    item.name = value;
    item.markDirty();
  };

  module.exports = CategoryGridStore;
}();

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      isUndefined = _require.isUndefined;

  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var constants = __webpack_require__(279);
  var PermissionDetail = __webpack_require__(206);
  var PermissionAccess = __webpack_require__(325);

  function TenantDetail(details) {
    details = details || {};

    m.extendObservable(trackable(this), {
      id: null,
      tenantID: '',
      name: '',
      description: '',
      active: null,
      deleted: null,
      tenantModules: [],
      isSelected: false,
      permission: null,

      hasDirty: function hasDirty() {
        return this.isDirty || this.permission.isDirty || this.permissionAccessModel.checkDirty();
      },
      displayName: function displayName() {
        return String.format('{0} - {1}', this.tenantID, this.name);
      },
      version: 0,
      created: null,
      createdBy: null,
      modified: null,
      modifiedBy: null,
      isNew: function isNew() {
        return !String.isGuidFormat(this.id);
      }
    });
    this.permissionAccessModel = new PermissionAccess();
    this.populateData(details);
  }

  TenantDetail.constraints = {
    tenantID: constants.TENANT_ID_CONSTRAINT,
    name: constants.TENANT_NAME_CONSTRAINT
  };

  /**
   * populate data
   * @param  {object} details
   */
  TenantDetail.prototype.populateData = m.action(function (details) {
    this.id = details.id;
    this.tenantID = details.tenantID;
    this.name = details.name;
    this.description = details.description;
    this.active = isUndefined(details.active) ? true : details.active;
    this.deleted = details.deleted;
    this.tenantModules = details.tenantModules;
    this.permission = new PermissionDetail(details.permission, true);
    this.version = details.version || 0;
    this.created = details.created;
    this.createdBy = details.createdBy;
    this.modified = details.modified;
    this.modifiedBy = details.modifiedBy;
  });

  /**
   * set data by key
   * @param {string} key
   */
  TenantDetail.prototype.setDataByKey = function (key, value) {
    this[key] = value;
    this.markDirty();
  };

  /**
   * update selected modules
   * @param  {object}  module
   * @param  {Boolean} isAdd
   */
  TenantDetail.prototype.updateModules = function (module, isAdd) {
    var tenantModules = this.tenantModules = this.tenantModules || [];

    this.markDirty();
    if (isAdd) {
      return !this.hasModule(module) && tenantModules.push(module.name);
    } else {
      var moduleIndex = tenantModules.indexOf(module.name);
      return moduleIndex > -1 && tenantModules.splice(moduleIndex, 1);
    }
  };

  /**
   * check the tenant detail has module
   * @param  {[Object]} module
   * @return {boolean}
   */
  TenantDetail.prototype.hasModule = function (module) {
    return this.tenantModules && this.tenantModules.indexOf(module.name) > -1;
  };

  /**
   * set the tenant selected
   * @param {boolean} newValue
   */
  TenantDetail.prototype.setSelected = function (newValue) {
    return this.isSelected = newValue;
  };

  /**
   * set tenant detail active
   * @param {boolean} newValue
   */
  TenantDetail.prototype.setActive = function (newValue) {
    return this.active = newValue;
  };

  /**
   * Update permission
   * @param {Object} permission
   */
  TenantDetail.prototype.updatePermission = function (permission) {
    this.permission = permission;
  };

  /**
   * Clean model dirty
   */
  TenantDetail.prototype.cleanDirty = function () {
    this.resetDirty();
    this.permission.cleanDirty();
    this.permissionAccessModel.cleanDirty();
  };

  /**
   * Update tenant version after save
   */
  TenantDetail.prototype.updateVersion = function () {
    this.version++;
  };

  module.exports = TenantDetail;
}();

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(631);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1196);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(327);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportViewerContainer = function (_Component) {
  (0, _inherits3.default)(ReportViewerContainer, _Component);

  function ReportViewerContainer(props) {
    (0, _classCallCheck3.default)(this, ReportViewerContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportViewerContainer.__proto__ || (0, _getPrototypeOf2.default)(ReportViewerContainer)).call(this, props));

    _this.store = new _Izenda4.default();
    _this.reportSubscriptionStore = new _Izenda8.default();
    return _this;
  }

  (0, _createClass3.default)(ReportViewerContainer, [{
    key: 'render',
    value: function render() {
      var store = this.store,
          reportSubscriptionStore = this.reportSubscriptionStore,
          props = this.props;

      return _react2.default.createElement(
        'div',
        { className: 'u_fullSize u_paddingTop' },
        _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({ store: store, reportSubscriptionStore: reportSubscriptionStore }, props))
      );
    }
  }]);
  return ReportViewerContainer;
}(_react.Component);
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerContainer.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda6.default)()(ReportViewerContainer);
module.exports = exports['default'];

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


!function () {
  var AppContext = __webpack_require__(179);

  module.exports = {
    getFileTypeByFormat: function getFileTypeByFormat(type, isReport) {
      switch (type) {
        case 'word':
          return 'docx';
        case 'excel':
          return 'xlsx';
        case 'pdf':
          return 'pdf';
        case 'csv':
          return 'csv';
        case 'query':
          return 'txt';
        case 'xml':
          return 'xml';
        case 'json':
          return 'json';
        case 'definition':
          if (isReport) {
            return 'birt';
          } else {
            return 'bidb';
          }
        default:
          return 'txt';
      }
    }
  };
}();

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportHistory.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report History Component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2587);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(88);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(36);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(146);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(97);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(44);

var _Izenda16 = __webpack_require__(2588);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(31);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(148);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(42);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(45);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyIcon = (0, _Izenda21.default)()(function (props) {
  return _react2.default.createElement(
    'a',
    { onClick: props.onClick },
    _react2.default.createElement('span', { title: _Izenda6.default.TOOL_TIP.COPY, className: 'icon-copy' })
  );
});

var DeleteIcon = (0, _Izenda21.default)()(function (props) {
  return _react2.default.createElement(
    'a',
    { onClick: props.onClick },
    _react2.default.createElement('span', { title: _Izenda6.default.TOOL_TIP.DELETE, className: 'icon-cancel' })
  );
});

var MoveIcon = (0, _Izenda21.default)()(function (props) {
  return props.activeItem ? _react2.default.createElement(
    'a',
    { onClick: props.onClick },
    _react2.default.createElement('span', { title: _Izenda6.default.TOOL_TIP.MOVE, className: 'icon-resize-full-alt' })
  ) : null;
});

var ReportHistory = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ReportHistory, _Component);

  function ReportHistory(props) {
    (0, _classCallCheck3.default)(this, ReportHistory);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportHistory.__proto__ || (0, _getPrototypeOf2.default)(ReportHistory)).call(this, props));

    _initialiseProps.call(_this);

    var reportId = props.reportId;

    _this.store = new _Izenda17.default();
    reportId && _this.store.init(reportId);
    return _this;
  }

  /**
   * Render Text column
   */


  /**
   * Render Date Time column
   */


  /**
   * Render Version column
   */


  /**
   * Render Action column
   */


  /**
   * Render Body
   */


  (0, _createClass3.default)(ReportHistory, [{
    key: 'render',
    value: function render() {
      var localization = this.props.localization;

      return _react2.default.createElement(
        _Izenda10.default,
        { visible: true, onClosing: this.onClosing, autoClose: false, type: 'none', sizeClass: 'modal-lg' },
        _react2.default.createElement(_Izenda10.default.Header, { title: localization.getText('REPORT_LABEL_REPORT_HISTORY') }),
        _react2.default.createElement(
          _Izenda10.default.Body,
          null,
          this.renderBody()
        ),
        _react2.default.createElement(
          _Izenda10.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda10.default.ConfirmationButton,
            { key: 'cancel', type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return ReportHistory;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClosing = function () {
    _this2.props.onAccept();
  };

  this.renderTextCell = function (historyItem, key) {
    return _react2.default.createElement(
      'span',
      { className: 'truncate overflow-text', title: historyItem[key] },
      historyItem[key]
    );
  };

  this.renderDateTimeCell = function (historyItem, key) {
    var data = historyItem[key] ? (0, _Izenda8.default)(_Izenda4.default.currentUser.dateFormat, historyItem[key]) : '';

    return _react2.default.createElement(
      'span',
      { className: 'truncate overflow-text', title: data },
      data
    );
  };

  this.renderVersion = function (historyItem, key) {
    var inAccessable = historyItem.inaccessable;
    if (inAccessable) {
      return _react2.default.createElement(
        'span',
        { className: 'truncate overflow-text', title: historyItem[key] },
        historyItem[key]
      );
    } else {
      var props = _this2.props;
      var viewHistoryUrl = _Izenda19.default.getReportUrl('View', {
        id: historyItem.reportId,
        version: historyItem.version
      });
      var router = props.router;
      var clickVersion = function clickVersion() {
        props.onAccept();
        router.push(viewHistoryUrl);
      };
      return _react2.default.createElement(
        'a',
        { onClick: clickVersion },
        _react2.default.createElement(
          'span',
          { className: 'truncate overflow-text', title: historyItem[key] },
          historyItem[key]
        )
      );
    }
  };

  this.renderAction = function (historyItem) {
    var props = _this2.props;
    var store = _this2.store;
    var activeItem = historyItem.status === _Izenda6.default.STATUS.ACTIVE;
    var accessPriority = historyItem.accessPriority,
        inAccessable = historyItem.inaccessable;
    var isGlobal = props.isGlobal,
        authorization = props.authorization;

    var hasReportDesignerLicense = authorization.checkLicense(_Izenda25.default.LICENSE_KEY.ReportDesigner);
    var shouldDisplayIcon = isGlobal ? _Izenda4.default.currentUser.systemAdmin && (0, _fp.isNil)(_Izenda4.default.tenantId) : true;
    var designReportUri = _Izenda19.default.getReportDesignerUrl('ReportDesignerDetail', { reportId: historyItem.reportId });

    var showCopyPopup = function showCopyPopup() {
      props.showCopy(historyItem.version);
    };

    var showMovePopup = function showMovePopup() {
      props.showMove(historyItem.version);
    };

    var deleteReport = function deleteReport() {
      var message = activeItem ? _Izenda6.default.MESSAGES.M01b : _Izenda6.default.MESSAGES.M01a;
      var deleteVersion = activeItem ? null : historyItem.version;

      props.confirmFn('Confirmation', {
        description: message
      }).then(function () {
        store.deleteReportHistory(historyItem.reportId, deleteVersion);
        // Handle delete the latest version
        if (!deleteVersion) {
          props.onAccept(historyItem.reportId);
        }
        props.deleteHistory && props.deleteHistory();
      });
    };

    var handleEditReport = function handleEditReport() {
      props.onAccept();
      props.router.push(designReportUri);
    };

    return _react2.default.createElement(
      'div',
      null,
      activeItem && hasReportDesignerLicense && accessPriority === _Izenda22.ACCESS_RIGHT.FullAccess && _react2.default.createElement('span', { onClick: handleEditReport, title: _Izenda6.default.TOOL_TIP.DESIGN, className: 'icon-pencil' }),
      (accessPriority === _Izenda22.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda22.ACCESS_RIGHT.QuickEdit || accessPriority === _Izenda22.ACCESS_RIGHT.SaveAs) && !inAccessable && _react2.default.createElement(CopyIcon, {
        onClick: showCopyPopup,
        keys: [_Izenda23.default.PERMISSION_KEY.ReportsCanCreateNewReportValue]
      }),
      accessPriority === _Izenda22.ACCESS_RIGHT.FullAccess && shouldDisplayIcon && _react2.default.createElement(MoveIcon, {
        activeItem: activeItem,
        onClick: showMovePopup,
        keys: [_Izenda23.default.PERMISSION_KEY.ReportsActionsOverwriteExistingReport]
      }),
      accessPriority === _Izenda22.ACCESS_RIGHT.FullAccess && shouldDisplayIcon && !inAccessable && _react2.default.createElement(DeleteIcon, { onClick: deleteReport, keys: [_Izenda23.default.PERMISSION_KEY.ReportsActionsDel] })
    );
  };

  this.renderBody = function () {
    var store = _this2.store;
    var model = store.model;
    var TABLE_DEF = _Izenda6.default.TABLE_DEF;

    return _react2.default.createElement(
      'section',
      { className: 'report-history' },
      _react2.default.createElement(_Izenda12.default, {
        options: _Izenda6.default.CRITERIA_LIST,
        className: 'history-search',
        searchPropClass: 'izenda-GridLayout-Col3',
        searchInputClass: 'izenda-GridLayout-Col5',
        value: model.pageInfo.searchProperty,
        onSearch: store.search.bind(store),
        onSearchPropertiesChange: store.onSearchPropertiesChange.bind(store)
      }),
      _react2.default.createElement(
        _Izenda15.Table,
        {
          dataSource: model.histories,
          onSortChange: store.onSortChange.bind(store),
          sortInfo: model.pageInfo.colSortDirs
        },
        _react2.default.createElement(_Izenda15.Column, (0, _extends3.default)({}, TABLE_DEF['version'], { cell: _this2.renderVersion })),
        _react2.default.createElement(_Izenda15.Column, (0, _extends3.default)({}, TABLE_DEF['status'], { cell: _this2.renderTextCell })),
        _react2.default.createElement(_Izenda15.Column, (0, _extends3.default)({}, TABLE_DEF['editedDate'], { cell: _this2.renderDateTimeCell })),
        _react2.default.createElement(_Izenda15.Column, (0, _extends3.default)({}, TABLE_DEF['editedBy'], { cell: _this2.renderTextCell })),
        _react2.default.createElement(_Izenda15.Column, (0, _extends3.default)({}, TABLE_DEF['action'], { cell: _this2.renderAction }))
      ),
      _react2.default.createElement(_Izenda14.default, {
        onChange: store.goToPage.bind(store),
        onDropdownChange: store.onPageSizeChange.bind(store),
        totalRecords: model.pageInfo.totalRecords,
        pageSize: model.pageInfo.pageSize,
        pageIndex: model.pageInfo.pageIndex
      })
    );
  };
}, _temp);


var EnhancedReportHistory = (0, _Izenda2.default)()(ReportHistory);
EnhancedReportHistory.$popupName = 'ReportHistory';

exports.default = EnhancedReportHistory;
module.exports = exports['default'];

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.CopyReport.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var EventsUtils = __webpack_require__(24);
  var Validator = __webpack_require__(23);
  var MobxUtils = __webpack_require__(275);
  var connect = __webpack_require__(2);
  var m = __webpack_require__(5);
  var AppStore = __webpack_require__(104);

  var action = __webpack_require__(2590);
  var constants = __webpack_require__(50);
  var CategoryDetail = __webpack_require__(161);
  var REPORT_DESIGNER_CONSTANTS = __webpack_require__(16);

  var Popup = __webpack_require__(36);
  var Select = __webpack_require__(47);
  var ValidatableInput = Validator()(__webpack_require__(17));
  var GridLayout = __webpack_require__(13);
  var Label = __webpack_require__(71);
  var Dropdown = __webpack_require__(29);

  var _require = __webpack_require__(1),
      map = _require.map,
      cloneDeep = _require.cloneDeep,
      isEmpty = _require.isEmpty;

  function preventAddNew() {
    return false;
  }

  var CopyReport = React.createClass({
    displayName: 'CopyReport',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      onClose: React.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
      return {
        version: 0
      };
    },

    componentDidMount: function componentDidMount() {
      var props = this.props;
      var store = props.store;

      (0, _bluebird.join)(AppStore.loadCategorySettings(), store.loadCategoriesForCopyPopup(store.reportType, props.saveInto), m.action(function (categorySetting, result) {
        var saveIntos = map(function (item) {
          return {
            value: item.isGlobal ? REPORT_DESIGNER_CONSTANTS.GLOBAL_REPORT_ENUM.GLOBAL : REPORT_DESIGNER_CONSTANTS.GLOBAL_REPORT_ENUM.LOCAL,
            name: item.name
          };
        }, categorySetting);
        props.updateSaveIntos(saveIntos);

        // TODO: remove and test MobxUtils
        props.updateCategories(cloneDeep(MobxUtils.toJS(store.model.copyReportCategoryList)));
      }));
    },

    renderContainer: function renderContainer() {
      var props = this.props;
      var localization = props.localization;
      var boardDetail = props.boardDetail;
      var type = boardDetail.type;
      var notifyChange = EventsUtils.notifyChange;
      var disableSubCategory = isEmpty(props.category);
      var authorization = props.authorization;

      var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
      var hasPrivilege = authorization.checkPrivileges([permissionKeys.ReportsCanCreateNewCategoryValue]);

      var addNewCategory = notifyChange(props.addNewCategory);
      var noResultsTextCategory = constants.COPY_REPORT.TEXT_CREATE_CATEGORY;
      var addNewSubCategory = notifyChange(props.addNewSubCategory);
      var noResultsTextSubCategory = constants.COPY_REPORT.TEXT_CREATE_SUB_CATEGORY;

      if (!hasPrivilege) {
        addNewCategory = preventAddNew;
        noResultsTextCategory = null;
        addNewSubCategory = preventAddNew;
        noResultsTextSubCategory = null;
      }

      var actionContent = props.isMoveReport ? constants.ACTION_TYPES.MOVE_CONTENT : constants.ACTION_TYPES.COPY_CONTENT;

      return React.createElement(
        GridLayout,
        { className: 'form-horizontal' },
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '12' },
            React.createElement(
              'p',
              { 'aria-label': 'text' },
              String.format(localization.getText('REPORTDESIGNER_LABEL_SPECIFY_DESTINATION'), actionContent),
              ' \xA0',
              React.createElement(
                'span',
                { className: 'text-lowercase' },
                props.typeName
              )
            )
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '3' },
            React.createElement(
              Label,
              { className: 'control-label u_textNormal' },
              props.typeName,
              ' ',
              localization.getText('COMMON_LABEL_NAME')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '9' },
            React.createElement(ValidatableInput, {
              value: props.reportName,
              className: 'form-control custom-input-name',
              onChange: notifyChange(props.handleChangeReportName, EventsUtils.INPUT),
              validations: type == constants.CATEGORY_TYPE.REPORT ? constants.CONSTRAINTS.NAME : constants.CONSTRAINTS.TEMPLATE_NAME,
              field: 'Name',
              type: 'text',
              autoFocus: true
            })
          )
        ),
        props.hiddenSaveintos && React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '3' },
            React.createElement(
              Label,
              { className: 'control-label u_textNormal' },
              localization.getText('COMMON_LABEL_SAVE_INTO')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '9' },
            React.createElement(Dropdown, {
              valueField: 'value',
              labelField: 'name',
              value: props.saveInto,
              onChange: props.onChangeSaveInto,
              options: props.saveIntos
            })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '3' },
            React.createElement(
              Label,
              { className: 'control-label u_textNormal' },
              localization.getText('COMMON_LABEL_CATEGORY')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '9' },
            React.createElement(Select, {
              simpleValue: true,
              options: props.categories,
              labelKey: 'name',
              valueKey: 'id',
              value: props.category,
              noResultsText: noResultsTextCategory,
              onChange: props.updateCategory,
              onAddNew: addNewCategory,
              scalable: false
            })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '3' },
            React.createElement(
              Label,
              { className: 'control-label u_textNormal' },
              localization.getText('COMMON_LABEL_SUBCATEGORY')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '9' },
            React.createElement(Select, {
              simpleValue: true,
              options: props.subCategories,
              labelKey: 'name',
              valueKey: 'id',
              value: props.subCategory,
              noResultsText: noResultsTextSubCategory,
              onChange: props.updateSubCategory,
              onAddNew: addNewSubCategory,
              disabled: disableSubCategory,
              scalable: false
            })
          )
        )
      );
    },

    render: function render() {
      var props = this.props;
      var localization = props.localization;

      var typeAction = props.isMoveReport ? constants.ACTION_TYPES.MOVE_TITLE : constants.ACTION_TYPES.COPY_TITTLE;

      return React.createElement(
        Popup,
        { visible: true, onClosing: props.onClosing, autoClose: false, type: 'none' },
        React.createElement(Popup.Header, { title: typeAction + props.typeName }),
        React.createElement(
          Popup.Body,
          null,
          this.renderContainer()
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  });

  module.exports = connect(action)(CopyReport);
  module.exports.$popupName = 'CopyReport';
}();

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SavePopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(71);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(16);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(13);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(23);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(45);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2593);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(152);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(17);

var _Izenda24 = _interopRequireDefault(_Izenda23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorInput = (0, _Izenda16.default)()(_Izenda24.default);

var SavePopup = (_dec = (0, _Izenda2.default)(_Izenda20.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SavePopup, _Component);

  function SavePopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SavePopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SavePopup.__proto__ || (0, _getPrototypeOf2.default)(SavePopup)).call.apply(_ref, [this].concat(args))), _this), _this.onReportNameChanged = function (event) {
      _this.props.setReportName(event.target.value);
    }, _this.onReportTypeChanged = function (event) {
      _this.props.changeReportType(event.value);
    }, _this.onSaveIntoChanged = function (event) {
      _this.props.updateSaveInto(event.value);
    }, _this.onCategoryChanged = function (id, name) {
      _this.props.changeCategory(id, name);
    }, _this.onSubCategoryChanged = function (id, name) {
      _this.props.changeSubCategory(id, name);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SavePopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          store = _props.store,
          reportName = _props.reportName,
          setReportName = _props.setReportName,
          updateSaveInto = _props.updateSaveInto;

      store.loadCategorySettings();
      if (store.isNewReport) {
        var isReportType = store.model.reportType === _Izenda12.default.REPORT_TYPE_ENUM.REPORT;
        var reportDefaultName = isReportType ? _Izenda12.default.DEFAULT_REPORT_NAME : _Izenda12.default.DEFAULT_TEMPLATE_NAME;
        if (reportName === _Izenda12.default.DEFAULT_REPORT_NAME) {
          setReportName(reportDefaultName);
        }
      } else {
        // The default value of SaveInto depends on Global Report checkbox.
        // But when "save as" an exist report, it's default to local category
        updateSaveInto(_Izenda12.default.GLOBAL_REPORT_ENUM.LOCAL);
      }
    }
  }, {
    key: "renderContainer",
    value: function renderContainer() {
      var _props2 = this.props,
          localization = _props2.localization,
          authorization = _props2.authorization,
          store = _props2.store,
          authorizationConstants = _props2.authorizationConstants,
          addNewCategory = _props2.addNewCategory,
          addNewSubCategory = _props2.addNewSubCategory,
          reportName = _props2.reportName,
          saveInto = _props2.saveInto;

      var model = store.model;
      var types = model.types;
      var hasLicense = authorization.checkLicense(_Izenda18.default.LICENSE_KEY.ReportTemplateComponent);
      if (!hasLicense) {
        types = (0, _fp.remove)(function (type) {
          return (0, _fp.isEqual)(type.value, "Template");
        }, types);
      }

      var categories = (0, _fp.sortBy)(function (cat) {
        return cat.name.toLowerCase();
      }, model.categories);
      var subCategories = (0, _fp.sortBy)(function (cat) {
        return cat.name.toLowerCase();
      }, model.subCategories);
      var isReportType = model.reportType === _Izenda12.default.REPORT_TYPE_ENUM.REPORT;

      var hasPrivilege = authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.ReportsCanCreateNewCategoryValue]);

      var onAddNewCategory = addNewCategory;
      var noResultsTextCategory = _Izenda12.default.HINT_MESSAGE.CATEGORY;
      var onAddNewSubCategory = addNewSubCategory;
      var noResultsTextSubCategory = _Izenda12.default.HINT_MESSAGE.SUB_CATEGORY;
      if (!hasPrivilege) {
        onAddNewCategory = false;
        noResultsTextCategory = null;
        onAddNewSubCategory = false;
        noResultsTextSubCategory = null;
      }

      var reportNameVals = isReportType ? _Izenda12.default.CONSTRAINTS.REPORT_NAME : _Izenda12.default.CONSTRAINTS.TEMPLATE_NAME;
      var statusSaveInto = store.statusSaveInto;

      if (!store.globalReportName || !store.localReportName) {
        return _react2.default.createElement(_Izenda22.default, { show: true });
      }
      var GLOBAL_REPORT = [{
        value: _Izenda12.default.GLOBAL_REPORT_ENUM.LOCAL,
        label: store.localReportName
      }, {
        value: _Izenda12.default.GLOBAL_REPORT_ENUM.GLOBAL,
        label: store.globalReportName
      }];

      return _react2.default.createElement(
        _Izenda14.default,
        { className: "form-horizontal" },
        _react2.default.createElement(
          _Izenda14.default.Row,
          null,
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "3" },
            _react2.default.createElement(
              _Izenda10.default,
              { className: "control-label u_textNormal" },
              isReportType ? localization.getText("REPORTDESIGNER_LABEL_REPORT_NAME") : localization.getText("REPORTDESIGNER_LABEL_TEMPLATE_NAME")
            )
          ),
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "9" },
            _react2.default.createElement(ValidatorInput, {
              value: reportName,
              className: "form-control",
              onChange: this.onReportNameChanged,
              validations: reportNameVals,
              field: "name",
              type: "text",
              name: "reportName"
            })
          )
        ),
        _react2.default.createElement(
          _Izenda14.default.Row,
          null,
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "3" },
            _react2.default.createElement(
              _Izenda10.default,
              { className: "control-label u_textNormal" },
              localization.getText("COMMON_LABEL_SAVE_AS")
            )
          ),
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "9" },
            _react2.default.createElement(_Izenda6.default, {
              options: types,
              onChange: this.onReportTypeChanged,
              value: store.model.reportType,
              valueField: "id",
              labelField: "name",
              disabled: store.disableReportType
            })
          )
        ),
        statusSaveInto.visible && _react2.default.createElement(
          _Izenda14.default.Row,
          null,
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "3" },
            _react2.default.createElement(
              _Izenda10.default,
              { className: "control-label u_textNormal" },
              localization.getText("COMMON_LABEL_SAVE_INTO")
            )
          ),
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "9" },
            _react2.default.createElement(_Izenda6.default, {
              options: GLOBAL_REPORT,
              onChange: this.onSaveIntoChanged,
              value: saveInto,
              valueField: "value",
              labelField: "label"
            })
          )
        ),
        _react2.default.createElement(
          _Izenda14.default.Row,
          null,
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "3" },
            _react2.default.createElement(
              _Izenda10.default,
              { className: "control-label u_textNormal" },
              localization.getText("COMMON_LABEL_CATEGORY")
            )
          ),
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "9" },
            _react2.default.createElement(_Izenda8.default, {
              simpleValue: true,
              options: categories,
              labelKey: "name",
              valueKey: "id",
              value: store.model.categoryId,
              noResultsText: noResultsTextCategory,
              onChange: this.onCategoryChanged,
              onAddNew: onAddNewCategory,
              scalable: false
            })
          )
        ),
        _react2.default.createElement(
          _Izenda14.default.Row,
          null,
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "3" },
            _react2.default.createElement(
              _Izenda10.default,
              { className: "control-label u_textNormal" },
              localization.getText("REPORTDESIGNER_LABEL_SUB_CATEGORY")
            )
          ),
          _react2.default.createElement(
            _Izenda14.default.Col,
            { cols: "9" },
            _react2.default.createElement(_Izenda8.default, {
              simpleValue: true,
              options: subCategories,
              labelKey: "name",
              valueKey: "id",
              value: model.subCategoryId,
              noResultsText: noResultsTextSubCategory,
              onChange: this.onSubCategoryChanged,
              onAddNew: onAddNewSubCategory,
              disabled: store.disableSubCategory,
              scalable: false
            })
          )
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          localization = _props3.localization,
          store = _props3.store,
          onClosing = _props3.onClosing;

      var popupTitle = !store.canSaveAs ? localization.getText("COMMON_LABEL_SAVE") : localization.getText("COMMON_LABEL_SAVE_AS");

      return _react2.default.createElement(
        _Izenda4.default,
        { visible: true, onClosing: onClosing, autoClose: false, type: "none" },
        _react2.default.createElement(_Izenda4.default.Header, { title: popupTitle }),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          this.renderContainer()
        ),
        _react2.default.createElement(
          _Izenda4.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: "accept" },
            localization.getText("COMMON_LABEL_OK")
          ),
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: "cancel" },
            localization.getText("COMMON_LABEL_CANCEL")
          )
        )
      );
    }
  }]);
  return SavePopup;
}(_react.Component), _class2.propTypes = {}, _temp2)) || _class);
exports.default = SavePopup;
module.exports = exports["default"];

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2600);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2601);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(30);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2614);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  localization: _react.PropTypes.object,
  crossFilteringDetail: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  showCrossFilteringOption: _react.PropTypes.bool,
  removeCrossFiltering: _react.PropTypes.func.isRequired,
  removeAllCrossFiltering: _react.PropTypes.func.isRequired,
  onCrossFilteringOptionClick: _react.PropTypes.func,
  hadSetting: _react.PropTypes.bool,
  resetDefaultValue: _react.PropTypes.func,
  enableCrossFilteringOption: _react.PropTypes.bool,
  enableDeleteAll: _react.PropTypes.bool
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFiltering.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Cross Filtering Component
 */

var CrossFiltering = (0, _Izenda2.default)(_Izenda10.default)(function (_ref) {
  var localization = _ref.localization,
      onCrossFilteringOptionClick = _ref.onCrossFilteringOptionClick,
      resetDefaultValue = _ref.resetDefaultValue,
      hadSetting = _ref.hadSetting,
      showCrossFilteringOption = _ref.showCrossFilteringOption,
      crossFilteringDetail = _ref.crossFilteringDetail,
      enableCrossFilteringOption = _ref.enableCrossFilteringOption,
      enableDeleteAll = _ref.enableDeleteAll,
      onRemoveAllCrossFiltering = _ref.onRemoveAllCrossFiltering,
      onRemoveCrossFiltering = _ref.onRemoveCrossFiltering;

  return _react2.default.createElement(
    'div',
    { className: 'u_table izenda-CrossFiltering u_fullWidth u_paddingLeft' },
    showCrossFilteringOption && _react2.default.createElement(
      'div',
      { className: 'izenda-CrossFiltering_FilterOptions' },
      _react2.default.createElement(_Izenda4.default, {
        onOptionClick: onCrossFilteringOptionClick,
        hadSetting: hadSetting,
        resetDefaultValue: resetDefaultValue,
        localization: localization,
        enable: enableCrossFilteringOption })
    ),
    _react2.default.createElement(
      'div',
      { className: 'izenda-CrossFiltering__SliderContainer' },
      _react2.default.createElement(_Izenda6.default, {
        crossFilteringDetail: crossFilteringDetail,
        removeCrossFiltering: onRemoveCrossFiltering,
        localization: localization })
    ),
    _react2.default.createElement(
      'div',
      { className: 'izenda-CrossFiltering__removeAllCrossFilteringItemContainer' },
      _react2.default.createElement(_Izenda8.default, { className: 'icon-trash-empty icon-removeAllCrossFilteringItem u_noPaddingAll u_noBorder',
        title: localization.getText('CROSSFILTERING_REMOVE_ALL_TOOLTIP'),
        disabled: !enableDeleteAll,
        onClick: onRemoveAllCrossFiltering })
    )
  );
});

CrossFiltering.propTypes = propTypes;

exports.default = CrossFiltering;
module.exports = exports['default'];

/***/ }),
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilterSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module CrossFilterSetting popup component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(13);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2615);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(27);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(68);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CrossFilterSetting = (_dec = (0, _Izenda2.default)(_Izenda10.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CrossFilterSetting, _Component);

  function CrossFilterSetting() {
    (0, _classCallCheck3.default)(this, CrossFilterSetting);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CrossFilterSetting.__proto__ || (0, _getPrototypeOf2.default)(CrossFilterSetting)).call(this));

    _this.renderSelectAll = function () {
      var _this$props = _this.props,
          localization = _this$props.localization,
          isIndeterminate = _this$props.isIndeterminate,
          isSelectAll = _this$props.isSelectAll,
          onSelectAll = _this$props.onSelectAll;

      var checkBoxLabel = localization.getText('COMMON_LABEL_ALL');

      return _react2.default.createElement(
        _Izenda8.default.Col,
        { className: 'checkbox u_noMarginTop', cols: 4, key: 'chk-allIndex' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda6.default, { indeterminate: isIndeterminate, type: 'checkbox', checked: isSelectAll, onChange: onSelectAll }),
          _react2.default.createElement(
            _Izenda14.default,
            { tooltip: checkBoxLabel },
            checkBoxLabel
          )
        )
      );
    };

    _this.renderContainer = function () {
      var _this$props2 = _this.props,
          selectedReportParts = _this$props2.selectedReportParts,
          onSelectReportParts = _this$props2.onSelectReportParts,
          store = _this$props2.store;


      var data = (0, _fp.flow)((0, _fp.getOr)([], 'reportBody.activeReportParts'), (0, _fp.filter)(function (reportPart) {
        return !(0, _fp.isEmpty)(reportPart.headerTitle);
      }), (0, _fp.map)(function (reportPart) {
        return {
          value: reportPart.id,
          label: (0, _fp.getOr)('', 'headerTitle', reportPart),
          checked: (0, _fp.includes)(reportPart.id, selectedReportParts),
          sortLabel: (0, _fp.toLower)((0, _fp.getOr)('', 'headerTitle', reportPart))
        };
      }), (0, _fp.sortBy)(['sortLabel']))(store);

      var reportPartOptions = data.map(function (item, index) {
        return _react2.default.createElement(
          _Izenda8.default.Col,
          { className: 'checkbox u_noMarginTop', cols: 4, key: 'chk-' + index },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              value: item.value,
              checked: item.checked,
              onChange: onSelectReportParts.bind(_this, item)
            }),
            _react2.default.createElement(
              _Izenda14.default,
              { tooltip: item.label },
              item.label
            )
          )
        );
      });

      var options = (0, _fp.concat)(_this.renderSelectAll(), reportPartOptions);

      var chunkOptions = (0, _fp.chunk)(3, options);
      return _react2.default.createElement(
        'div',
        null,
        chunkOptions.map(function (item, index) {
          return _react2.default.createElement(
            _Izenda8.default.Row,
            { key: index, className: 'u_noMarginAll' },
            item
          );
        })
      );
    };

    return _this;
  }

  (0, _createClass3.default)(CrossFilterSetting, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          onClosing = _props.onClosing;

      return _react2.default.createElement(
        _Izenda4.default,
        { visible: true, onClosing: onClosing, autoClose: false, type: 'none' },
        _react2.default.createElement(_Izenda4.default.Header, { title: localization.getText('DASHBOARD_LABEL_REPORT_PART_SELECTION') }),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          _react2.default.createElement(
            'div',
            { className: 'izenda-OperatorValueCheckBoxPopup' },
            _react2.default.createElement(
              _Izenda12.default,
              null,
              _react2.default.createElement(
                _Izenda8.default,
                null,
                this.renderContainer()
              )
            )
          )
        ),
        _react2.default.createElement(
          _Izenda4.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return CrossFilterSetting;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object
}, _temp)) || _class);
exports.default = CrossFilterSetting;
module.exports = exports['default'];

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Filters.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Filters component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = __webpack_require__(40);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(259);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(28);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(2616);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(1191);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(2618);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _FIELDS$FITLERS_PANEL = _Izenda3.FIELDS.FITLERS_PANEL_UI,
    minHeight = _FIELDS$FITLERS_PANEL.minHeight,
    maxHeight = _FIELDS$FITLERS_PANEL.maxHeight;
var Filters = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Filters, _Component);

  function Filters() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Filters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Filters.__proto__ || (0, _getPrototypeOf2.default)(Filters)).call.apply(_ref, [this].concat(args))), _this), _this.dropMessage = function (message) {
      return _this.props.confirmFn('Information', {
        description: message,
        type: 'info',
        showCloseIndicator: true
      });
    }, _this.filtersBodyRender = function () {
      var _this$props = _this.props,
          store = _this$props.store,
          viewMode = _this$props.viewMode,
          editMode = _this$props.editMode,
          uiStore = _this$props.uiStore;

      var filterFields = (0, _fp.filter)(function (field) {
        return field.state !== _Izenda3.OBJECT_STATE.DELETE;
      }, store.reportFilters.displayFilterFields);

      var types = [_Izenda3.GENNERAL.FIELD_ITEM, _Izenda3.GENNERAL.FILTER_ITEM];
      var DroppableFiltersBody = viewMode ? _Izenda11.default : (0, _Izenda5.default)(types, uiStore)(_Izenda11.default);

      return _react2.default.createElement(DroppableFiltersBody, {
        store: store,
        filterFields: filterFields,
        dropMessage: _this.dropMessage,
        viewMode: viewMode,
        editMode: editMode
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Show information message for drop action.
   */


  (0, _createClass3.default)(Filters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          showFreeze = _props.showFreeze,
          reportViewerUIStore = _props.reportViewerUIStore,
          authorization = _props.authorization,
          authorizationConstants = _props.authorizationConstants,
          afterToggled = _props.afterToggled,
          afterMove = _props.afterMove;


      var header = {
        store: store,
        showFreeze: showFreeze,
        authorization: authorization,
        reportViewerUIStore: reportViewerUIStore,
        authorizationConstants: authorizationConstants,
        component: _Izenda9.default
      };

      var filterLogicPrivilege = authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.ReportsFilterPropertiesFilterLogic]);

      var footer = {
        store: store,
        context: this.context,
        component: _Izenda13.default
      };

      var filterExpanded = _config.UIPreferences.ReportFilterSectionExpanded;

      return _react2.default.createElement(
        _Izenda7.default,
        {
          className: 'full-height',
          resizable: true,
          header: header,
          collapsible: true,
          initState: filterExpanded,
          footer: filterLogicPrivilege && footer,
          defaultValue: minHeight,
          minValue: minHeight,
          maxValue: maxHeight,
          afterToggled: afterToggled,
          afterMove: afterMove
        },
        this.filtersBodyRender()
      );
    }
  }]);
  return Filters;
}(_react.Component), _class2.propTypes = {
  viewMode: _propTypes2.default.bool,
  filtersData: _propTypes2.default.object,
  reportViewerUIStore: _propTypes2.default.object
}, _class2.defaultProps = {
  reportViewerUIStore: {}
}, _temp2)) || _class);
exports.default = Filters;
module.exports = exports['default'];

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterBody.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterBody component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _recompose = __webpack_require__(9);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(27);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(255);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1192);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2617);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(16);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraggableItem = (0, _Izenda6.default)(_Izenda12.default.GENNERAL.FILTER_ITEM, _Izenda8.default.sourceOptions);
var enhanceFilterItem = (0, _recompose.compose)(DraggableItem);
var DnDFilterItem = enhanceFilterItem(_Izenda10.default);
var FILTER_EDITOR = [{ name: 'filterProps' }];

var FilterBody = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(FilterBody, _Component);

  function FilterBody() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FilterBody);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FilterBody.__proto__ || (0, _getPrototypeOf2.default)(FilterBody)).call.apply(_ref, [this].concat(args))), _this), _this.beforeShowProps = function (filter) {
      return function () {
        var _this$props = _this.props,
            store = _this$props.store,
            reportFilters = _this$props.store.reportFilters;

        reportFilters.setConfigModeToField(filter);
        // Populate Filter Source Value
        store.getOperatorValueSource(reportFilters.configField);
      };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FilterBody, [{
    key: 'doesCanDropFieldItem',
    value: function doesCanDropFieldItem(itemType, canAccess, isOver) {
      if (itemType === _Izenda12.default.GENNERAL.FIELD_ITEM) {
        return canAccess && isOver;
      }
      return false;
    }
  }, {
    key: 'doesCannotDropFieldItem',
    value: function doesCannotDropFieldItem(itemType, canAccess, isOver) {
      if (itemType === _Izenda12.default.GENNERAL.FIELD_ITEM) {
        return !canAccess && isOver;
      }
      return false;
    }
  }, {
    key: 'doesCannotDropFilterItem',
    value: function doesCannotDropFilterItem(itemType, isOver) {
      if (itemType === _Izenda12.default.GENNERAL.FILTER_ITEM) {
        return !isOver;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var _props = this.props,
          store = _props.store,
          filterFields = _props.filterFields,
          viewMode = _props.viewMode,
          itemType = _props.itemType,
          isOver = _props.isOver,
          _props$showPosition = _props.showPosition,
          showPosition = _props$showPosition === undefined ? true : _props$showPosition;


      var canAccess = props.canAccess && props.canAccess(props.item);
      var FilterItemComponent = !viewMode ? DnDFilterItem : _Izenda10.default;

      var classes = (0, _classnames2.default)('filter-body drop-container', {
        'can-drop': this.doesCanDropFieldItem(itemType, canAccess, isOver),
        'cannot-drop': this.doesCannotDropFieldItem(itemType, canAccess, isOver) || this.doesCannotDropFilterItem(itemType, isOver)
      });

      return _react2.default.createElement(
        _Izenda4.default,
        { className: classes },
        _react2.default.createElement(
          _Izenda4.default.Row,
          { className: 'u_fullHeight u_noMarginAll' },
          _react2.default.createElement(
            _Izenda2.default,
            null,
            filterFields.map(function (field, index) {
              return _react2.default.createElement(FilterItemComponent, {
                key: field.uniqueId,
                itemData: field,
                store: store,
                propsEditors: FILTER_EDITOR,
                beforeShowProps: _this2.beforeShowProps(field),
                itemDataIndex: index,
                showPosition: showPosition
              });
            })
          )
        )
      );
    }
  }]);
  return FilterBody;
}(_react.Component)) || _class;

exports.default = FilterBody;
module.exports = exports['default'];

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _reactDom = __webpack_require__(32);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var position = null;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DnDFilterItemConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DnDFilterItemConfig
 */

exports.default = {
  sourceOptions: {
    beginDrag: function beginDrag(props) {
      return {
        itemType: _Izenda2.default.GENNERAL.FILTER_ITEM,
        position: (0, _fp.get)('itemData.position', props),
        alias: (0, _fp.get)('itemData.alias', props),
        isParameter: (0, _fp.get)('itemData.isParameter', props),
        itemDataIndex: props.itemDataIndex,
        changePosition: true
      };
    },
    endDrag: function endDrag(props, monitor, component) {
      if (!monitor.didDrop()) {
        return;
      }

      var dropResult = monitor.getDropResult();
      props = dropResult.props;
      monitor = dropResult.monitor;
      component = dropResult.component;

      if (!props || !monitor || !component) {
        return;
      }

      var item = monitor.getItem();

      if ((0, _fp.isNil)(item)) {
        return;
      }

      var dragItemIndex = item.itemDataIndex;
      var targetItemIndex = props.itemDataIndex;

      if (dragItemIndex === targetItemIndex) {
        return;
      }

      if (item.changePosition) {
        var nextIndex = item.itemDataIndex < position ? position - 1 : position;
        props.store.reportFilters.moveTo(item.itemDataIndex, nextIndex);
        return;
      }
    }
  },

  targetOptions: {
    drop: function drop(props, monitor, component) {
      if (monitor.didDrop()) {
        return;
      }

      if (props.viewMode === false && props.editMode) {
        return {
          props: props,
          monitor: monitor,
          component: component
        };
      }

      var item = monitor.getItem();

      if ((0, _fp.isNil)(item)) {
        return;
      }

      var dragItemIndex = item.itemDataIndex;
      var targetItemIndex = props.itemDataIndex;

      if (dragItemIndex === targetItemIndex) {
        return;
      }

      props.store.reportFilters.moveTo(dragItemIndex, targetItemIndex);
    },
    hover: function hover(props, monitor, component) {
      var cachedOffset = {};

      if (!monitor.canDrop()) {
        return;
      }

      var itemOffset = monitor.getClientOffset();
      var componentRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
      var itemWidth = componentRect.width / 4;
      var itemHeight = 50;

      var posItemX = itemOffset.x - componentRect.left;
      var posItemY = itemOffset.y - componentRect.top;

      if ((0, _fp.isEqual)(cachedOffset, itemOffset)) {
        return;
      }

      cachedOffset = itemOffset;

      if (posItemX > 0 && posItemY > 0 && posItemX < componentRect.width && posItemY < componentRect.height) {
        position = Math.floor(posItemX / itemWidth) + Math.floor(posItemY / itemHeight) * 4;
        var listFilter = resetStyleItem(component.props.filterFields);

        // Update position if it is more than the last position
        if (listFilter.length && position >= listFilter.length) {
          position = listFilter.length;
        }

        // Set the style for the item at the position
        if (position === listFilter.length) {
          setStyleForItem(listFilter, position - 1, 'Right');
        } else {
          setStyleForItem(listFilter, position, 'Left');
        }
      }

      function setStyleForItem(listFilter, position, type) {
        if ((0, _fp.isNil)(listFilter[position])) return;
        listFilter[position].style['border' + type + 'Style'] = _Izenda2.default.GENNERAL.BORDER_HOVER_ITEM.STYLE;
        listFilter[position].style['border' + type + 'Color'] = _Izenda2.default.GENNERAL.BORDER_HOVER_ITEM.COLOR;
      }

      function resetStyleItem(filterFields) {

        var listFilter = (0, _fp.map)(function (item) {
          var style = item.filterItemDom.style;
          style.borderLeftStyle = '';
          style.borderRightStyle = '';
          return item.filterItemDom;
        }, filterFields);

        return listFilter;
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceDropDown.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Detail component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(29);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuerySourceDropDown = (_dec = (0, _Izenda2.default)({ toClass: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(QuerySourceDropDown, _Component);

  function QuerySourceDropDown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, QuerySourceDropDown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuerySourceDropDown.__proto__ || (0, _getPrototypeOf2.default)(QuerySourceDropDown)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (newVal, fieldDetails) {
      var _this$props = _this.props,
          reportFilters = _this$props.reportFilters,
          value = _this$props.value,
          filter = _this$props.filter;

      if (fieldDetails && !fieldDetails.operatorId && reportFilters) {
        reportFilters.loadDefaultOperator(fieldDetails);
      }

      var setNewFilterDetails = (0, _mobx.action)(function () {
        filter.setFilterDetails(fieldDetails || {}, true);
        reportFilters.disableCascading();
        return true;
      });

      return (!(0, _fp.isNil)(value) ? _this.props.confirmFn('Confirmation', {
        description: _Izenda5.BUNDLE.MESSAGE.M10
      }) : (0, _bluebird.resolve)()).then(setNewFilterDetails);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(QuerySourceDropDown, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.needToValidate && this.props.validation.validate();
    }

    /**
     * Get format text
     * @param {Object} filter
     */

  }, {
    key: 'groupFormatText',
    value: function groupFormatText(field) {
      var reportPartTitle = field.reportPartTitle,
          connectionName = field.connectionName,
          querySourceCategoryName = field.querySourceCategoryName,
          sourceDataObjectName = field.sourceDataObjectName;

      var titleText = reportPartTitle ? reportPartTitle : connectionName + '.' + querySourceCategoryName + '.' + sourceDataObjectName;

      return titleText;
    }

    /**
     * Handle change
     * @param {Object} newVal
     * @param {Object} fieldDetails
     */

  }, {
    key: 'getOptionProperties',


    /**
     * Get option properties
     * @param {Object} field
     */
    value: function getOptionProperties(_ref2) {
      var isParameter = _ref2.isParameter;

      return {
        disabled: isParameter,
        style: { display: isParameter ? 'none' : 'block' }
      };
    }

    /**
     * Get label name
     * @param {Object} field
     */

  }, {
    key: 'getLabelName',
    value: function getLabelName(_ref3) {
      var sourceFieldName = _ref3.sourceFieldName;

      return sourceFieldName;
    }

    /**
     * Get value
     * @param {Object} field
     */

  }, {
    key: 'getValue',
    value: function getValue(field) {
      var querySourceType = field.querySourceType,
          reportPartTitle = field.reportPartTitle,
          reportFieldAlias = field.reportFieldAlias,
          sourceDataObjectName = field.sourceDataObjectName;

      var querySourceFieldId = querySourceType === _Izenda5.FIELD_TYPE.AggregatedField ? '' : field.querySourceFieldId;
      return reportPartTitle ? querySourceFieldId + reportPartTitle + reportFieldAlias : querySourceFieldId + sourceDataObjectName;
    }

    /**
     * Get group by value
     * @param {Object} filter
     */

  }, {
    key: 'getGroupByValue',
    value: function getGroupByValue(field) {
      var querySourceType = field.querySourceType,
          reportPartTitle = field.reportPartTitle,
          connectionName = field.connectionName,
          querySourceCategoryName = field.querySourceCategoryName,
          sourceDataObjectName = field.sourceDataObjectName;

      return reportPartTitle ? querySourceType : connectionName + '.' + querySourceCategoryName + '.' + sourceDataObjectName;
    }

    /**
     * Resolve group label.
     * @param {Object} field
     */

  }, {
    key: 'buildGroupLabel',
    value: function buildGroupLabel(field) {
      return field && field.sourceDataObjectName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$filter = _props.filter,
          querySourceFieldId = _props$filter.querySourceFieldId,
          isParameter = _props$filter.isParameter,
          sourceFieldVisible = _props$filter.sourceFieldVisible,
          sourceFieldFilterable = _props$filter.sourceFieldFilterable,
          className = _props.className,
          value = _props.value;

      var filterOptionsClassNames = (0, _classnames2.default)(className, {
        'disabled-elm': isParameter
      });

      if ((0, _fp.isUndefined)(this.isEmptyValue)) {
        this.isEmptyValue = (0, _fp.isNil)(value);
      } else {
        this.needToValidate = this.isEmptyValue && !(0, _fp.isNil)(value);
        this.isEmptyValue = (0, _fp.isNil)(value);
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({}, this.props, {
          className: filterOptionsClassNames,
          valueField: this.getValue,
          labelField: this.getLabelName,
          groupBy: this.getGroupByValue,
          maskedHidden: !(sourceFieldVisible && sourceFieldFilterable),
          onChange: this.handleChange,
          groupFormatText: this.groupFormatText,
          buildGroupLabel: this.buildGroupLabel,
          getOptionProperties: this.getOptionProperties,
          disabledBlankOption: true,
          defaultValue: '',
          key: (0, _fp.uniqueId)(querySourceFieldId),
          showTooltip: true,
          optionTooltip: 'reportPartTitle'
        }))
      );
    }
  }]);
  return QuerySourceDropDown;
}(_react.Component)) || _class);
exports.default = QuerySourceDropDown;
module.exports = exports['default'];

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBody.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(299);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(301);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(83);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(853);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(977);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(53);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(157);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2630);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SCROLLBAR_HEIGHT = 8;
var SCROLLBAR_PADDING = 2;

var ReportBody = (_dec = (0, _Izenda2.default)(_Izenda10.default), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ReportBody, _Component);

  function ReportBody(props) {
    (0, _classCallCheck3.default)(this, ReportBody);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportBody.__proto__ || (0, _getPrototypeOf2.default)(ReportBody)).call(this, props));

    _initDefineProp(_this, 'gridHeight', _descriptor, _this);

    _this.setGridView = function (ref) {
      _this.gridView = ref;
    };

    _this.setPartContainer = function (ref) {
      _this.partContainer = ref;
    };

    _this.setReportBody = function (ref) {
      _this.reportBody = ref;
    };

    _initDefineProp(_this, 'handleChangeReportPartFullScreen', _descriptor2, _this);

    _initDefineProp(_this, 'onAddItem', _descriptor3, _this);

    _initDefineProp(_this, 'onUpdateItemPositions', _descriptor4, _this);

    var _this$props = _this.props,
        width = _this$props.width,
        fullSize = _this$props.fullSize,
        infinityRows = _this$props.infinityRows,
        infinityCols = _this$props.infinityCols;


    _this.shouldNotUpdateComponent = false;
    _this.layoutStore = new _Izenda14.default(width, fullSize, infinityRows, infinityCols);
    _this.setFullHeightOnly();
    return _this;
  }

  (0, _createClass3.default)(ReportBody, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.shouldNotUpdateComponent) {
        this.shouldNotUpdateComponent = false;
        return false;
      }
      return this.props.reportBodyPanelState === nextProps.reportBodyPanelState;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          width = _props.width,
          fullSize = _props.fullSize,
          headerPanelState = _props.headerPanelState,
          titleDescriptionPanelState = _props.titleDescriptionPanelState,
          reportBodyPanelState = _props.reportBodyPanelState;

      if (nextProps.width !== width || nextProps.fullSize !== fullSize) {
        this.layoutStore.setViewWidth(nextProps.width);
        this.layoutStore.setAutoSize(nextProps.fullSize);
      }
      if (nextProps.headerPanelState !== headerPanelState || nextProps.titleDescriptionPanelState !== titleDescriptionPanelState || nextProps.reportBodyPanelState !== reportBodyPanelState) {
        this.setGridHeight();
      }
      this.setFullHeightOnly();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.finishRender && this.props.finishRender(this);
      this.addConfigReportPartActions();
      var dom = _reactDom2.default.findDOMNode(this);
      this.setGridHeight();
      this.layoutStore.setViewWidth(dom.clientWidth);
      var reportStore = this.props.store.reportStore;

      var allowToSave = (0, _fp.get)('model.allowToSave', reportStore);
      allowToSave && reportStore.alertDetails.set({
        success: true,
        message: _Izenda16.default.MESSAGES.OUTDATED_REPORT
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.finishRender && this.props.finishRender(this);
      this.setGridHeight();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.finishRender && this.props.finishRender(null);
      this.configReportPartAction && this.configReportPartAction();
    }
  }, {
    key: 'setFullHeightOnly',
    value: function setFullHeightOnly() {
      this.props.viewMode && this.layoutStore.setFullHeightOnly(true);
    }
  }, {
    key: 'setGridHeight',
    value: function setGridHeight() {
      var dom = _reactDom2.default.findDOMNode(this.gridView) || this.partContainer;
      if (dom) {
        var bottom = this.props.bottom;

        var _dom$getBoundingClien = dom.getBoundingClientRect(),
            top = _dom$getBoundingClien.top;

        this.gridHeight = window.innerHeight - (top + bottom + this.props.getOuterScrollTop());
      }
    }

    /**
     * Add new report part at position
     * @param  {Object} offset New report part position
     */

  }, {
    key: 'getGridViewScrollBox',


    /** Get scrollbox ref of grid view*/
    value: function getGridViewScrollBox() {
      return this.gridView ? this.gridView.getScrollBox() : null;
    }
  }, {
    key: 'addConfigReportPartActions',
    value: function addConfigReportPartActions() {
      var _this2 = this;

      var store = this.props.store;

      var scrollToConfigReportPart = function scrollToConfigReportPart() {
        var layoutStore = _this2.layoutStore;
        var configReportPart = (0, _fp.get)('reportBody.configReportPart', store);
        var isBackSide = (0, _fp.get)('isBackSide', configReportPart);
        var layoutItem = layoutStore.getLayoutItem(configReportPart.id);
        if (!layoutItem || !configReportPart || isBackSide) {
          return;
        }

        _this2.gridView && _this2.gridView.scrollTo({
          left: (0, _fp.get)('pxLeft', layoutItem),
          top: (0, _fp.get)('pxTop', layoutItem)
        });
      };

      var propsEditorId = _Izenda18.default.findEditorId([{
        name: 'reportPartProps'
      }]);

      this.configReportPartAction = (0, _mobx.reaction)(function () {
        var configReportPart = (0, _fp.get)('reportBody.configReportPart', store);
        var editorInfo = _Izenda18.default.getEditorInfoById(propsEditorId);
        var status = (0, _fp.getOr)({}, 'status', editorInfo);

        return {
          needScrollToConfigPart: !!configReportPart && status.reportPartProps && !configReportPart.isBackSide,
          configReportPart: configReportPart,
          configReportPartId: configReportPart && configReportPart.reportId
        };
      }, function (data) {
        if (!data.needScrollToConfigPart) {
          return;
        }

        // scroll to config report part
        // hack - in case user click on header to select report part
        // mouse-down event will be trigger to update selected-reprot part
        // and it will be conflicted to scroll-action
        setTimeout(function () {
          scrollToConfigReportPart();
        }, 200);
      });
    }
  }, {
    key: 'renderListReportPart',
    value: function renderListReportPart() {
      var _this3 = this;

      var props = this.props;
      var store = props.store,
          reportBody = props.store.reportBody;

      var activeReportParts = (0, _fp.sortBy)(['positionY', 'positionX'], reportBody.activeReportParts.slice());
      return activeReportParts.map(function (item) {
        var isBackSide = item.isBackSide,
            isNew = item.isNew,
            id = item.id;

        return _react2.default.createElement(
          _Izenda8.default,
          {
            key: id,
            id: id,
            moveToMe: isNew,
            isDraggable: !isBackSide,
            isResizable: !item.autoSize && !isBackSide,
            handle: '.report-part-header',
            cancel: '.btn, input'
          },
          _react2.default.createElement(_Izenda12.default, (0, _extends3.default)({}, props, {
            isSnapEditOn: _this3.layoutStore.isSnapEditOn,
            gridItem: item,
            store: store,
            reportBody: reportBody,
            onChangeFullScreen: _this3.handleChangeReportPartFullScreen,
            autoSize: item.autoSize
          }))
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          quickEdit = _props2.quickEdit,
          viewMode = _props2.viewMode,
          bottom = _props2.bottom,
          hasOuterScroll = _props2.hasOuterScroll,
          store = _props2.store,
          reportBody = _props2.store.reportBody;
      var snapToGrid = reportBody.snapToGrid,
          isFullScreen = reportBody.isFullScreen;

      var layoutStore = this.layoutStore;
      var layoutData = reportBody.activeReportParts.map(toReportPartLayoutItem);
      var header = {
        component: _Izenda20.default,
        store: store
      };

      var reportBodyGridClass = (0, _classnames2.default)('report-body-grid', {
        'izenda-ReportBodyGrid-editable': !viewMode
      });
      var isBackSide = (0, _fp.get)('configReportPart.isBackSide', reportBody);
      var gridHeightValue = hasOuterScroll ? null : this.gridHeight;
      var partContainerStyle = isBackSide ? { height: gridHeightValue } : {};
      var stickyScrollBottom = hasOuterScroll ? bottom : null;
      var body = isBackSide && !hasOuterScroll || isFullScreen ? _react2.default.createElement(
        'div',
        { className: 'izenda-ReportPart-Fullsize', ref: this.setPartContainer, style: partContainerStyle },
        _react2.default.createElement(_Izenda12.default, {
          store: store,
          reportBody: store.reportBody,
          gridItem: store.reportBody.configReportPart,
          onChangeFullScreen: this.handleChangeReportPartFullScreen
        })
      ) : _react2.default.createElement(
        _Izenda6.default,
        {
          stickyScrollBottom: stickyScrollBottom,
          className: reportBodyGridClass,
          alwaysShowHorizontalScroll: true,
          alwaysShowVerticalScroll: true,
          gridHeight: gridHeightValue,
          ref: this.setGridView,
          editable: !viewMode,
          fullHeight: viewMode,
          allowAddInline: !quickEdit && !viewMode,
          layoutStore: layoutStore,
          layoutData: layoutData,
          snapToGrid: snapToGrid,
          onAddItem: this.onAddItem,
          onUpdateItemPositions: this.onUpdateItemPositions
        },
        this.renderListReportPart()
      );

      return quickEdit || viewMode ? _react2.default.createElement(
        'div',
        { className: 'report-body' },
        body
      ) : _react2.default.createElement(
        _Izenda4.default,
        {
          afterToggled: this.props.afterToggled,
          header: header,
          collapsible: true,
          initState: true,
          className: 'report-body',
          ref: this.setReportBody
        },
        body
      );
    }
  }]);
  return ReportBody;
}(_react.Component), _class3.propTypes = {
  store: _propTypes2.default.object,
  fullSize: _propTypes2.default.bool,
  infinityRows: _propTypes2.default.bool,
  infinityCols: _propTypes2.default.bool,
  exportFormatSetting: _propTypes2.default.object,
  hasOuterScroll: _propTypes2.default.bool,
  getOuterScrollTop: _propTypes2.default.func
}, _class3.defaultProps = {
  fullSize: false,
  infinityRows: true,
  infinityCols: true
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'gridHeight', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'setFullHeightOnly', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setFullHeightOnly'), _class2.prototype), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'handleChangeReportPartFullScreen', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (reportPart) {
      _this4.shouldNotUpdateComponent = true;

      var reportBody = _this4.props.store.reportBody;

      reportBody.changeFullScreenMode(reportPart);

      var itemConfig = _this4.layoutStore.getLayoutItem(reportPart.id);
      if (itemConfig && itemConfig.isFullSize !== reportPart.isBackSide) itemConfig.isFullSize = reportPart.isBackSide;
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'setGridHeight', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setGridHeight'), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'onAddItem', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (offset) {
      var reportBody = _this5.props.store.reportBody;

      if (offset) {
        var left = offset.left,
            top = offset.top,
            width = offset.width,
            height = offset.height;

        reportBody.addReportPart(left, top, width, height);
      }
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'onUpdateItemPositions', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (newItemPos, manual) {
      var needPartUpdate = function needPartUpdate(part) {
        return (0, _fp.some)({ id: part.id }, newItemPos);
      };

      var setPosition = function setPosition(part) {
        var newPos = (0, _fp.find)({ id: part.id }, newItemPos);
        var left = newPos.left,
            top = newPos.top,
            width = newPos.width,
            height = newPos.height;

        part.setPosition({
          positionX: left,
          positionY: top,
          width: width,
          height: height
        }, manual);
      };

      var reportParts = _this6.props.store.reportBody.reportParts;

      (0, _fp.flow)((0, _fp.filter)(needPartUpdate), (0, _fp.forEach)(setPosition))(reportParts);
    };
  }
})), _class2)) || _class);
exports.default = ReportBody;


function toReportPartLayoutItem(item) {
  return {
    id: item.id,
    x: item.positionX,
    y: item.positionY,
    width: item.width,
    height: item.height,
    isFullSize: item.isBackSide,
    autoSize: item.autoSize,
    isLoading: function isLoading() {
      return item.isLoadingData;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportSubscribe.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);

  var connect = __webpack_require__(2);
  var SubscriptionGrid = __webpack_require__(341);
  var ReportSubscriptionConstants = __webpack_require__(133);
  var actions = __webpack_require__(2631);
  var ReportDesignerConstants = __webpack_require__(16);

  var ReportSubscribe = React.createClass({
    displayName: 'ReportSubscribe',

    PropTypes: {
      reportId: React.PropTypes.string.isRequired,
      reportType: React.PropTypes.string.isRequired,
      subscribedInstancesStore: React.PropTypes.object.isRequired,
      onClose: React.PropTypes.func
    },

    componentWillMount: function componentWillMount() {
      this.props.setType(true);
    },

    componentDidMount: function componentDidMount() {
      var reportListMode = !!this.props.onClose;
      this.props.loadData(reportListMode);
    },

    componentWillUnmount: function componentWillUnmount() {
      var subscribedInstancesStore = this.props.subscribedInstancesStore;

      subscribedInstancesStore.cleanSubscription.call(subscribedInstancesStore);
    },

    /**
     * render subscribe component
     * @return {Object} subscribe component
     */
    render: function render() {
      var props = this.props;
      var reportListMode = !!this.props.onClose;
      var subscribedInstancesStore = props.subscribedInstancesStore;

      return React.createElement(SubscriptionGrid, { reportState: ReportDesignerConstants.REPORT_STATE.SAVED,
        store: props.subscribedInstancesStore,
        pageConstants: ReportSubscriptionConstants,
        containerWidth: props.width,
        onSavePopupDesigner: props.onSaveSubscription,
        onSave: props.onSave,
        onClose: props.onClose,
        isDashboardMode: reportListMode,
        doesSaveToDB: reportListMode });
    }
  });

  module.exports = connect(actions)(ReportSubscribe);
}();

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _bluebird = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportsStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var fetcher = __webpack_require__(111);
  var reportDesignerFetcher = __webpack_require__(90);
  var Reports = __webpack_require__(2633);
  var exportFetcher = __webpack_require__(400);
  var uiState = __webpack_require__(15);
  var constants = __webpack_require__(50);
  var LazyLoadingUtils = __webpack_require__(118);
  var CategoryDetail = __webpack_require__(161);
  var PrintingUtils = __webpack_require__(76);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      isArray = _require.isArray,
      map = _require.map,
      isNil = _require.isNil,
      getOr = _require.getOr,
      get = _require.get,
      find = _require.find;

  function ReportsStore() {
    this.contentLazyLoadingStore = {};
    this.leftMenuLazyLoadingStore = {};

    var props = {
      model: new Reports(),

      // We show report when this value is not null. Otherwise, we show report list.
      selectedReportId: null,
      report: null,
      reportName: '',
      categoryId: constants.EMPTY_GUID,
      reportType: constants.CATEGORY_TYPE.REPORT,

      version: 0,
      disabled: false,

      // keep selected category/subcategory in left navigation
      selectedCategoryId: null,
      // Previous link in report list
      reportListLink: null,

      reportCategoryTree: function reportCategoryTree() {
        return this.model.reportCategoryTree;
      },

      items: function items() {
        return this.model.items;
      },

      tenantId: function tenantId() {
        return uiState.getTenantId();
      },

      isTemplateType: function isTemplateType() {
        return this.reportType === constants.CATEGORY_TYPE.TEMPLATES;
      },

      isUncategorized: function isUncategorized() {
        return this.selectedCategoryId === constants.EMPTY_GUID;
      },

      isRootCategory: function isRootCategory() {
        return this.selectedCategoryId === constants.ALL_CATEGORY_TYPES.ALL_REPORTS.id || this.selectedCategoryId === constants.ALL_CATEGORY_TYPES.ALL_TEMPLATES.id;
      }
    };

    m.extendObservable(this, props);
  }

  /**
   * Load all categories
   * @param  {Number} reportType
   * @return {array}
   */
  ReportsStore.prototype.loadAllCategories = m.action(function loadAllCategories(reportType) {
    this.reportType = reportType || constants.CATEGORY_TYPE.REPORT;

    return fetcher.loadAllCategories(this.reportType, this.tenantId).then(function (categoryList) {
      this.model.readReportCategoryTree(categoryList, this.reportType);
      return categoryList;
    }.bind(this));
  });

  /**
   * Load categories for copy popup
   * @param  {Number} reportType
   * @return {array}
   */
  ReportsStore.prototype.loadCategoriesForCopyPopup = m.action(function loadAllCategories(reportType, isGlobal) {
    this.reportType = reportType || constants.CATEGORY_TYPE.REPORT;
    var model = this.model;

    return fetcher.loadCategoriesForCopyPopup(this.reportType, this.tenantId, isGlobal).then(function (categoryList) {
      model.readCopyReportCategoryList(categoryList);
      return categoryList;
    });
  });

  /**
   * Load Subcategories by category ID for copy popup
   * @param categoryId
   * @returns {*|promise}
   */
  ReportsStore.prototype.loadSubCategoriesForCopyPopup = function (categoryId) {
    return fetcher.loadSubCategoriesForCopyPopup(categoryId);
  };

  /**
   * validate category name
   * @param  {object} category
   * @returns {Promise}
   */
  ReportsStore.prototype.validateCategoryName = function (category) {
    return fetcher.validateCategoryName(category).then(function (result) {
      return result.messages;
    });
  };

  /**
   * Validate Report Name
   * @param {Object} boardDetail
   * @returns {Promise}
   */
  ReportsStore.prototype.validateName = function (boardDetail) {
    return reportDesignerFetcher.validateReportName(boardDetail).then(function (result) {
      return result.messages;
    });
  };

  /**
   * Check valid report id
   * @param {string} reportId
   * @returns {Promise}
   */
  ReportsStore.prototype.checkValidReportId = function (reportId) {
    return reportDesignerFetcher.validateReportId(reportId);
  };

  /**
   * Validate Report Name
   * @param {Object} boardDetail
   * @returns {Promise}
   */
  ReportsStore.prototype.rename = function (boardDetail) {
    return fetcher.renameReport({
      name: boardDetail.name,
      reportKey: {
        key: boardDetail.id
      }
    }).then(function (result) {
      return result;
    });
  };

  /**
   * Delete Report
   * @param {Object} boardDetail
   * @param {Object} reportSubCategory
   * @returns {Promise}
   */
  ReportsStore.prototype.deleteReport = function (boardDetail, reportSubCategory, version) {
    var reportId = boardDetail.id;
    var data = this.buildReportKey(reportId);

    return fetcher.deleteReport(data, version).then(function (result) {
      return result && this.removeReport(reportId, reportSubCategory);
    }.bind(this));
  };

  /**
   * Remove report
   * @param {type} reportId
   * @param {type} reportSubCategory
   */
  ReportsStore.prototype.removeReport = m.action(function removeReport(reportId, reportSubCategory) {
    var reportItem = find({
      id: reportId
    }, reportSubCategory.reports);
    reportSubCategory.reports.remove(reportItem);

    if (reportSubCategory.reports.length === 0) {
      this.loadLazyLoadingReports(null, this.reportType, true, null);
      this.loadLazyLoadingCategories(this.reportType, true);
    }
    return null;
  });

  /**
   * Delete a ReportCategory by id
   * @param {string} reportCategoryId
   * @returns {promise}
   */
  ReportsStore.prototype.deleteReportCategory = m.action(function deleteReportCategory(dataSource) {
    var reportCategoryId = dataSource.id;
    if (reportCategoryId) {
      return fetcher.deleteReportCategory(reportCategoryId).then(m.action(function (result) {
        result.success && this.model.removeReportCategory(dataSource);

        // only reload report content if deleted category is activing
        var activeCategoryId = dataSource.isSubCategory ? dataSource.parentId : dataSource.id;
        if (result.success && activeCategoryId === this.selectedCategoryId || this.isRootCategory()) {
          return this.selectedCategoryId;
        }
        return null;
      }.bind(this)));
    }
    return (0, _bluebird.resolve)({ success: false });
  });

  /**
   * Copy new Report
   * @param {Object} dataObject
   * @param {Object} boardDetail
   * @returns {Promise}
   */
  ReportsStore.prototype.copyNewReport = m.action(function copyNewReport(dataObject, boardDetail, isMoveReport, version) {
    var category = dataObject.category || {};
    var subCategory = dataObject.subCategory || {};
    var tenantIdCategory = category.id ? category.tenantId : this.tenantId;
    var tenantIdSubCategory = subCategory.id ? subCategory.tenantId : this.tenantId;

    var data = {
      isGlobal: !!dataObject.saveInto,
      id: boardDetail.id,
      name: dataObject.reportName,
      version: version,
      category: {
        id: String.isGuidFormat(category.id) ? category.id : null,
        name: category.name,
        type: boardDetail.type,
        tenantId: tenantIdCategory
      },
      subCategory: {
        id: String.isGuidFormat(subCategory.id) ? subCategory.id : null,
        name: subCategory.name,
        type: boardDetail.type,
        parentId: String.isGuidFormat(category.id) ? category.id : null,
        tenantId: tenantIdSubCategory
      },
      type: boardDetail.type,
      tenantId: this.tenantId
    };

    var copyModeReportFn = isMoveReport ? fetcher.moveReport : fetcher.copyNewReport;

    return copyModeReportFn(data).then(function (result) {
      return isArray(result.messages) ? result.messages : result;
    });
  });

  /**
   * Update some additional info which was loaded previously after saving/saving as report.
   * @param {ReportDesignerFieldsStore} reportDesignerFiledsStore
   */
  ReportsStore.prototype.updateAddtionalInfo = m.action(function (reportDesignerFiledsStore) {
    this.selectedCategoryId = get('subCategoryId', reportDesignerFiledsStore.masterModel) || get('categoryId', reportDesignerFiledsStore.masterModel);
  });

  /**
   * Update selected report id
   */
  ReportsStore.prototype.updateReportId = m.action(function updateReportId(reportId, version) {
    this.selectedReportId = reportId;
    this.version = version || 0;
  });

  /**
   * Get the report information
   * @returns {String}
   */
  ReportsStore.prototype.getReportInfo = function () {
    var reportId = this.selectedReportId;

    if (!reportId) {
      return (0, _bluebird.resolve)('');
    }

    return fetcher.reportInfo(reportId, this.version).then(m.action(function (result) {
      this.reportType = result.type.toString() || constants.CATEGORY_TYPE.REPORT;
      this.reportName = result.name || '';
      this.categoryId = result.categoryId || constants.EMPTY_GUID;
      if (!this.selectedCategoryId) {
        this.selectedCategoryId = result.subCategoryId || result.categoryId;
      }
      return null;
    }.bind(this)));
  };

  /**
   * Build report key object
   */
  ReportsStore.prototype.buildReportKey = function (reportId) {
    return {
      reportKey: {
        key: reportId
      }
    };
  };

  /**
   * export report
   * @param  {string} url
   * @param  {string} format    export format
   * @param  {string} reportId  report id
   * @param  {array}  filters    report filters
   * @param  {object} successCallBack
   * @param  {object} failCallBack
   * @return {Promise}
   */
  ReportsStore.prototype.exportReport = function (url, format, reportId, filters, exportObj, successCallBack, failCallBack) {
    var filtersData = map(function (filterItem) {
      return filterItem.getFilterDetails();
    }, filters);

    return exportFetcher.export({
      url: url,
      format: format,
      reportId: reportId,
      filters: (0, _stringify2.default)(filtersData),
      draftId: get('draftId', exportObj),
      subReportFilters: (0, _stringify2.default)(getOr([], 'subReportFilter', exportObj)),
      queryString: get('queryString', exportObj),
      tenantId: this.tenantId // for export API.
    }, successCallBack, failCallBack);
  };

  /**
   * Print report
   * @param  {string} url
   * @param  {string} format    export format
   * @param  {string} reportId  report id
   * @param  {array}  filters    report filters
   * @param  {any} successCallBack
   * @param  {any} failCallBack
   * @return {Promise}
   */
  ReportsStore.prototype.printReport = function (url, format, reportId, filters, exportObj, successCallBack, failCallBack) {
    var filtersData = map(function (filterItem) {
      return filterItem.getFilterDetails();
    }, filters);

    function processSuccess(result) {
      successCallBack(result);
      PrintingUtils.printHtml(result);
    }

    return exportFetcher.export({
      fileSessionKey: String.newGuid(),
      current_tenant: uiState.getTenantId(),
      url: url,
      format: format,
      reportId: reportId,
      filters: filtersData,
      draftId: get('draftId', exportObj),
      subReportFilters: getOr([], 'subReportFilter', exportObj),
      queryString: get('queryString', exportObj),
      tenantId: this.tenantId // for export API.
    }).then(processSuccess, failCallBack);
  };

  /**
   * Send email
   * @param {String} reportId
   * @param {object} email
   * @returns {promise}
   */
  ReportsStore.prototype.sendEmail = function (draftId, email, reportId) {
    return exportFetcher.email({ reportId: reportId, draftId: draftId }, email);
  };

  ReportsStore.prototype.disable = m.action(function disable() {
    this.disabled = true;
  });

  /**
   * reset model to default
   */
  ReportsStore.prototype.resetModel = m.action(function resetModel() {
    this.reportType = constants.CATEGORY_TYPE.REPORT;
    this.selectedReportId = null;
    this.report = null;
  });

  /**
   * update renderingTime
   * @param {Number} renderingTime
   */
  ReportsStore.prototype.updateRenderingTime = function (renderingTime) {
    return fetcher.updateRenderingTime(this.selectedReportId, renderingTime);
  };

  /**
   * Read report from API
   * @param {Object} report data
   */
  ReportsStore.prototype.readReport = function (reportData) {
    this.report = reportData;
  };

  /**
   * Reset report data
   */
  ReportsStore.prototype.resetReportData = function () {
    this.report = null;
  };

  /**
   * Reset report data
   */
  ReportsStore.prototype.savePreviousLink = function (link) {
    this.reportListLink = link;
  };

  /**
   * Load report list
   * @param  {string} catId
   * @param  {string} reportType
   * @return {array}
   */
  ReportsStore.prototype.loadLazyLoadingReports = m.action(function loadLazyLoadingReports(catId, reportType, isReset, isGlobal, pageInfo) {
    this.selectedCategoryId = catId;
    pageInfo = pageInfo || this.contentLazyLoadingStore.pageInfoForFirstTime;
    isGlobal = this.convertIsGlobal(isGlobal);

    var dataObject = {
      tenantId: this.tenantId,
      type: reportType,
      isUncategorized: this.isUncategorized,
      skipItems: pageInfo.fromIndex,
      pageSize: pageInfo.pageSize,
      parentIds: pageInfo.parentIds,
      includeGlobalCategory: true,
      isGlobal: isGlobal
    };

    if (!this.isRootCategory && !this.isUncategorized) {
      dataObject.criterias = [{
        key: constants.CATEGORY_TYPE.CATEGORY_ID,
        value: this.selectedCategoryId
      }];
    }

    return fetcher.lazyLoadingReports(dataObject).bind(this).then(m.action(function (result) {
      this.items.populate(result, isReset, constants.REPORT_LIST_CONCAT_TREE_MAP);
    }));
  });

  /**
   * Load all categories
   * @param  {Number} reportType
   * @return {array}
   */
  ReportsStore.prototype.loadLazyLoadingCategories = m.action(function loadLazyLoadingCategories(reportType, isReset, pageInfo) {
    pageInfo = pageInfo || this.leftMenuLazyLoadingStore.pageInfoForFirstTime;
    this.reportType = reportType || constants.CATEGORY_TYPE.REPORT;
    var param = {
      tenantId: this.tenantId,
      type: this.reportType,
      isUncategorized: this.isUncategorized,
      skipItems: pageInfo.fromIndex,
      pageSize: pageInfo.pageSize,
      parentIds: pageInfo.parentIds,
      includeGlobalCategory: true
    };

    // TODO: null report type on view mode.
    return fetcher.loadLazyLoadingCategories(param).bind(this).then(m.action(function (result) {
      var data = result.data;
      var categories = map(function (item) {
        var globalLocalCategory = new CategoryDetail();
        globalLocalCategory.populateDataForGlobalLocalCategory(item);
        return globalLocalCategory;
      }, data);

      var menuCategories;
      if (reportType.toString() === constants.CATEGORY_TYPE.REPORT) {
        menuCategories = this.model.leftMenuReportCategories;
      } else {
        menuCategories = this.model.leftMenuTemplateCategories;
      }

      if (isReset) {
        menuCategories.splice(0, menuCategories.length);
      }

      if (!isEmpty(menuCategories)) {
        menuCategories.shift();
      }

      LazyLoadingUtils.concatTree(menuCategories, categories, constants.LEFT_MENU_CONCAT_TREE_MAP, result.numOfChilds, []);

      menuCategories.splice(0, 0, this.model.createAllItem(this.reportType));
      var dataTree = LazyLoadingUtils.parseToTree(menuCategories, constants.LEFT_MENU_TREE_MAP);

      reportType.toString() === constants.CATEGORY_TYPE.REPORT ? this.model.leftMenuReportCategoryTree = dataTree : this.model.leftMenuTemplateCategoryTree = dataTree;
      // reset the category'status to has no any new categoríe after reloaded
      this.model.resetCategoryStatus();
    }));
  });

  /**
   * search ReportCategories
   * @returns {Promise} array of ReportCategories
   */
  ReportsStore.prototype.lazyLoadingSearch = function (isGlobal, pageInfo) {
    var model = this.items;
    var isReset = isNil(pageInfo);
    pageInfo = pageInfo || this.contentLazyLoadingStore.pageInfoForFirstTime;

    var request = {
      criterias: [],
      isUncategorized: this.isUncategorized,
      sortCriteria: {
        key: model.sortBy,
        descending: model.sortDir === constants.SORT_TYPES.ASC ? false : true
      },
      tenantId: this.tenantId,
      type: this.reportType,
      skipItems: pageInfo.fromIndex,
      pageSize: pageInfo.pageSize,
      parentIds: pageInfo.parentIds,
      includeGlobalCategory: true,
      isGlobal: this.convertIsGlobal(isGlobal)
    };

    // handling criterias
    if (!this.isRootCategory && !isNil(this.selectedCategoryId)) {
      request.criterias.push({
        key: constants.CATEGORY_TYPE.CATEGORY_ID,
        value: this.selectedCategoryId
      });
    }

    (!isNil(model.searchType) || !isNil(model.searchText)) && request.criterias.push({
      key: model.searchType,
      value: model.searchText
    });

    return fetcher.lazyLoadingSearchCategories(request).then(function (result) {
      return this.items.populate(result, isReset, constants.REPORT_LIST_CONCAT_TREE_MAP);
    }.bind(this));
  };

  /**
   * Convert isGlobal
   * @param {Boolean} isGlobal
   * @returns {Boolean} has global report
   */
  ReportsStore.prototype.convertIsGlobal = function (isGlobal) {
    switch (isGlobal) {
      case 'null':
        return null;
      case 'false':
        return false;
      case 'true':
        return true;
      case undefined:
        return null;
      default:
        return isGlobal;
    }
  };

  /**
   * Register content list lazy loading store
   * @param {Object} lazyLoadingStore
   */
  ReportsStore.prototype.registerContentLazyLoadingStore = function (lazyLoadingStore) {
    this.contentLazyLoadingStore = lazyLoadingStore;
  };

  /**
   * Register left menu lazy loading store
   * @param {Object} lazyLoadingStore
   */
  ReportsStore.prototype.registerLeftMenuLazyLoadingStore = function (lazyLoadingStore) {
    this.leftMenuLazyLoadingStore = lazyLoadingStore;
  };

  /**
   * Cancel changes to remove draft
   * @return {Promise}
   */
  ReportsStore.prototype.cancelChanges = function () {
    return reportDesignerFetcher.cancelReportChanges(this.selectedReportId);
  };

  module.exports = ReportsStore;
}();

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _Izenda = __webpack_require__(31);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2634);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2638);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(631);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2645);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportRoutes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var reportRoutes = function reportRoutes() {
  var ROUTE = _Izenda2.default.getConfigRoute('Report');
  var LIST_ROUTE = _Izenda2.default.getConfigRoute('Report', 'List');
  var VIEW_ROUTE = _Izenda2.default.getConfigRoute('Report', 'View');
  var EDIT_ROUTE = _Izenda2.default.getConfigRoute('Report', 'Edit');

  return _react2.default.createElement(
    _reactRouter.Route,
    {
      path: ROUTE.path,
      component: _Izenda4.default.Container },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Izenda6.default }),
    _react2.default.createElement(_reactRouter.Route, { name: LIST_ROUTE.name, path: LIST_ROUTE.path, component: _Izenda6.default }),
    _react2.default.createElement(_reactRouter.Route, { name: VIEW_ROUTE.name, path: VIEW_ROUTE.path, component: _Izenda8.default }),
    _react2.default.createElement(_reactRouter.Route, { name: EDIT_ROUTE.name, path: EDIT_ROUTE.path, component: _Izenda10.default })
  );
};

exports.default = reportRoutes;
module.exports = exports['default'];

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2637);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(335);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * CategoryTree component
 * Example :
 * <CategoryTree store={this.props.store} />
 */
var CategoryTree = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(CategoryTree, _Component);

  function CategoryTree() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CategoryTree);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CategoryTree.__proto__ || (0, _getPrototypeOf2.default)(CategoryTree)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (node, toggleIcon, toggle, isCollapsed, parent) {
      var source = node.source,
          restProps = (0, _fp.omit)(['selectedCategoryId', 'dataTree'], _this.props);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({
          dataSource: source,
          toggleIcon: toggleIcon,
          isGlobalLocal: (0, _fp.isNil)(parent),
          getEditingCategoryTreeItem: _this.getEditingCategoryTreeItem
        }, restProps))
      );
    }, _this.getEditingCategoryTreeItem = function () {
      var dataTree = _this.props.dataTree;

      // find editing CategoryItem

      var editingCategoryTree = (0, _fp.find)('isEditing', dataTree);
      if ((0, _fp.isNil)(editingCategoryTree)) {
        // find editing SubCategoryItem
        dataTree.forEach(function (category) {
          var matched = (0, _fp.find)('isEditing', category.subCategories);
          if (matched) {
            editingCategoryTree = matched;
            return false;
          }
        });
      }

      return editingCategoryTree;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CategoryTree, [{
    key: 'getKey',
    value: function getKey(node) {
      return (0, _fp.isNil)(node.source.id) ? (0, _fp.uniqueId)(node.source.name) : node.source.id;
    }
  }, {
    key: 'shouldExpand',
    value: function shouldExpand(node) {
      return node.expand;
    }

    /**
     * Get editing CategoryItem/SubCategoryItem (used for one-instance editing purpose)
     * @return {CategoryDetail} categoryDetail
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          dataTree = _props.dataTree,
          isLastPage = _props.isLastPage,
          getData = _props.getData,
          registerLazyLoadingStore = _props.registerLazyLoadingStore;

      var getChildNodes = (0, _fp.invoke)('getChildNodes');

      return _react2.default.createElement(
        'section',
        { className: 'category-tree u_fullHeight' },
        _react2.default.createElement(_Izenda6.default, {
          className: 'u_noPaddingAll',
          nodes: dataTree,
          isLastPage: isLastPage,
          renderNode: this.renderItem,
          getKey: this.getKey,
          getChildNodes: getChildNodes,
          getData: getData,
          nodeExpand: this.shouldExpand,
          registerLazyLoadingStore: registerLazyLoadingStore
        })
      );
    }
  }]);
  return CategoryTree;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired,
  reportType: _react.PropTypes.string,
  dataTree: _react.PropTypes.object.isRequired,
  routeObject: _react.PropTypes.object.isRequired,
  routeParams: _react.PropTypes.object.isRequired,
  selectedCategoryId: _react.PropTypes.string,
  onLoadCategoryList: _react.PropTypes.func,
  onValidateCategoryName: _react.PropTypes.func,
  isLastPage: _react.PropTypes.bool,
  registerLazyLoadingStore: _react.PropTypes.func,
  getData: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = CategoryTree;
module.exports = exports['default'];

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.BoardDetailHeader.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var convertToDateTimeFormat = __webpack_require__(88);
  var TextHighLight = __webpack_require__(62);
  var GridLayout = __webpack_require__(13);
  var uiState = __webpack_require__(15);
  var routeUtils = __webpack_require__(31);

  var _require = __webpack_require__(1),
      get = _require.get;

  module.exports = function (constants) {
    var BoardName = __webpack_require__(2643)(constants);
    var SearchCriteria = constants.SEARCH_CRITERIA;

    var BoardDetailHeader = React.createClass({
      displayName: 'BoardDetailHeader',

      propTypes: {
        store: React.PropTypes.object
      },

      handleToggleButton: function handleToggleButton() {
        if (this.props.boardDetail.isEditMode) {
          return;
        }

        var boardDetail = this.props.boardDetail;
        boardDetail.setStateExpanded(!boardDetail.isShowDetail);
      },

      handleClickTitle: function handleClickTitle(e) {
        e.stopPropagation();

        var props = this.props;
        var store = props.store;

        if (props.checkValidReport) {
          var previousLink = routeUtils.getPreviousLink();
          store.savePreviousLink && store.savePreviousLink(previousLink);
        }
        props.router.push(get('detailUri.pathname', props));
      },

      renderHeaderExpanded: function renderHeaderExpanded() {
        var props = this.props;
        var localization = props.localization;

        return React.createElement(
          GridLayout,
          null,
          React.createElement(
            GridLayout.Row,
            { onClick: this.handleToggleButton },
            React.createElement(
              GridLayout.Col,
              { cols: '3', xs: '10' },
              React.createElement(BoardName, (0, _extends3.default)({
                onClick: this.handleClickTitle,
                dataDetail: props.boardDetail
              }, props))
            ),
            React.createElement(
              GridLayout.Col,
              { cols: '1', offset: '8', className: 'text-right', xs: '2' },
              React.createElement(
                'a',
                { title: localization.getText('COMMON_LABEL_COLLAPSE') },
                React.createElement('span', { className: 'icon-minus-circled' })
              )
            )
          )
        );
      },

      renderHeaderCollapsed: function renderHeaderCollapsed() {
        var props = this.props;
        var boardDetail = props.boardDetail;
        var model = props.store.items;
        var localization = props.localization;

        return React.createElement(
          GridLayout,
          null,
          React.createElement(
            GridLayout.Row,
            { onClick: this.handleToggleButton },
            React.createElement(
              GridLayout.Col,
              { cols: '2' },
              React.createElement(
                'a',
                { onClick: this.handleClickTitle },
                React.createElement(TextHighLight, {
                  highlight: model.searchText,
                  text: boardDetail.name,
                  tooltip: boardDetail.name,
                  className: 'text-bold u_textBreak',
                  notHighlight: boardDetail.isNotHighLight(model.searchType, SearchCriteria[1].value) })
              )
            ),
            React.createElement(
              GridLayout.Col,
              { cols: '6', className: 'overflow-text', title: boardDetail.description },
              React.createElement(TextHighLight, {
                highlight: model.searchText,
                text: boardDetail.description,
                tooltip: boardDetail.description,
                notHighlight: boardDetail.isNotHighLight(model.searchType, SearchCriteria[2].value) })
            ),
            React.createElement(
              GridLayout.Col,
              { cols: '3', className: 'u_textGrayColor' },
              React.createElement(
                'p',
                null,
                localization.getText('COMMON_CRITERIA_CREATED_BY'),
                ': \xA0',
                React.createElement(TextHighLight, {
                  highlight: model.searchText,
                  text: boardDetail.createdBy,
                  notHighlight: boardDetail.isNotHighLight(model.searchType, SearchCriteria[3].value) })
              ),
              React.createElement(
                'p',
                null,
                localization.getText('COMMON_CRITERIA_LAST_EDITED'),
                ': \xA0',
                React.createElement(TextHighLight, {
                  highlight: model.searchText,
                  text: convertToDateTimeFormat(uiState.currentUser.dateFormat, boardDetail.modified),
                  notHighlight: boardDetail.isNotHighLight(model.searchType, SearchCriteria[6].value) })
              )
            ),
            React.createElement(
              GridLayout.Col,
              { cols: '1', className: 'text-right' },
              React.createElement(
                'a',
                { title: localization.getText('COMMON_LABEL_EXPAND') },
                React.createElement('span', { className: 'icon-plus-circled' })
              )
            )
          )
        );
      },

      render: function render() {
        var props = this.props;
        return React.createElement(
          'div',
          { className: 'u_paddingAll' },
          props.isExpanded ? this.renderHeaderExpanded() : this.renderHeaderCollapsed()
        );
      }

    });

    return connect()(BoardDetailHeader);
  };
}();

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.BoardListHeader.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);
  var action = __webpack_require__(5).action;

  var GridLayout = __webpack_require__(13);
  var IconMenu = __webpack_require__(86);
  var DataGridSearch = __webpack_require__(146);
  var DropDown = __webpack_require__(29);
  var localizer = __webpack_require__(12);
  var UiState = __webpack_require__(15);

  module.exports = function (constants) {
    var BoardListHeader = React.createClass({
      displayName: 'BoardListHeader',

      propTypes: {
        store: React.PropTypes.object,
        isTemplateType: React.PropTypes.bool
      },

      reset: function reset() {
        var model = this.props.store.items;

        model.setSearchInfo(constants.SEARCH_CRITERIA[0].value, '', constants.SORT_CRITERIA[0].value);
      },

      getInitialState: function getInitialState() {
        return {
          isDataSearchMinSize: UiState.isMobile
        };
      },

      renderSearchDataGrid: function renderSearchDataGrid() {
        var store = this.props.store;
        var model = store.items;
        var isDataSearchMinSize = this.state.isDataSearchMinSize;

        var widthOnMobile = isDataSearchMinSize ? 3 : 12;

        return React.createElement(
          GridLayout.Col,
          { cols: '6', xs: widthOnMobile, className: 'izenda-BoardListHeader-searchContainer' },
          React.createElement(IconMenu, { className: 'u_marginRight' }),
          React.createElement(DataGridSearch, {
            options: this.props.isTemplateType ? constants.TEMPLATE_SEARCH_CRITERIA : constants.SEARCH_CRITERIA,
            value: model.searchType,
            searchValue: model.searchText,
            onSearch: this.onSearch,
            onSearchPropertiesChange: this.onSearchPropertiesChange,
            onSizeStateChange: this.onDataGridSearchSizeChange,
            responsive: true,
            ref: 'gridSearch' })
        );
      },

      renderSortControl: function renderSortControl() {
        var store = this.props.store;
        var SORT_TYPES = constants.SORT_TYPES;
        var model = store.items;
        var isDataSearchMinSize = this.state.isDataSearchMinSize;
        var isVisible = isDataSearchMinSize || !UiState.isMobile;
        var sortClassName = classnames({
          'icon-sort-name-up': model.sortDir === SORT_TYPES.ASC,
          'icon-sort-name-down': model.sortDir !== SORT_TYPES.ASC
        });
        var classContainer = classnames('text-right form-inline izenda-BoardListHeader-sortContainer', {
          'hidden-xs': !isVisible
        });

        return React.createElement(
          GridLayout.Col,
          {
            cols: '6',
            className: classContainer,
            xs: '9' },
          React.createElement(
            'span',
            null,
            localizer.getText('COMMON_LABEL_SORT_BY')
          ),
          React.createElement(DropDown, {
            options: this.props.isTemplateType ? constants.TEMPLATE_SORT_CRITERIA : constants.SORT_CRITERIA,
            className: 'u_marginLeftInnerSpace izenda-BoardListHeader-sort',
            labelField: 'label',
            valueField: 'value',
            ref: 'sortBy',
            value: model.sortBy,
            onChange: this.onSortByChange,
            blankOption: false }),
          React.createElement(
            'div',
            { className: 'izenda-BoardListHeader-iconSort' },
            React.createElement('span', { onClick: this.onSortChange, className: sortClassName })
          ),
          !UiState.isMobile && React.createElement(
            'div',
            { className: 'btn-group pull-right' },
            React.createElement(
              'button',
              { type: 'button',
                className: 'btn btn-icon u-bgLightBlue u_controlSize',
                'aria-label': localizer.getText('COMMON_LABEL_EXPAND'),
                onClick: function onClick() {
                  store.items.toggleReportExpandAll(true);
                } },
              React.createElement('span', { className: 'icon-expand-all' })
            ),
            React.createElement(
              'button',
              { type: 'button',
                className: 'btn btn-icon u-bgLightBlue u_controlSize',
                'aria-label': localizer.getText('COMMON_LABEL_COLLAPSE'),
                onClick: function onClick() {
                  store.items.toggleReportExpandAll(false);
                } },
              React.createElement('span', { className: 'icon-collapse-all' })
            )
          )
        );
      },

      render: function render() {
        return React.createElement(
          GridLayout,
          { className: 'izenda-BoardListHeader' },
          React.createElement(
            GridLayout.Row,
            null,
            this.renderSearchDataGrid(),
            this.renderSortControl()
          )
        );
      },

      onSearchPropertiesChange: function onSearchPropertiesChange(searchType, searchText) {
        var store = this.props.store;
        var model = store.items;
        var sortByComponent = this.refs.sortBy;
        var selectCtrlComponent = sortByComponent.refs.dropdown;
        model.setSearchInfo(searchType, searchText, selectCtrlComponent && selectCtrlComponent.value);
      },

      onSearch: function onSearch(searchProperty, searchText) {
        var props = this.props;
        var store = props.store;
        var model = store.items;
        var sortByComponent = this.refs.sortBy;
        var selectCtrlComponent = sortByComponent.refs.dropdown;
        model.setSearchInfo(searchProperty, searchText, selectCtrlComponent && selectCtrlComponent.value);
        store.lazyLoadingSearch(props.isGlobal);
      },

      /**
       * Handle change of sort by
       * @param {Object} e
       */
      onSortByChange: action(function (e) {
        var boardList = this.props.store.items;
        boardList.setSortBy(e.value);
        this.onSearch();
      }),

      onSortChange: function onSortChange(e) {
        e.preventDefault();
        var SORT_TYPES = constants.SORT_TYPES;
        var store = this.props.store;
        var model = store.items;
        var sortDir = model.sortDir;

        model.setSortDir(sortDir ? reverseSortDirection(sortDir) : SORT_TYPES.DESC);
        this.onSearch();

        function reverseSortDirection(sortDir) {
          return sortDir === SORT_TYPES.DESC ? SORT_TYPES.ASC : SORT_TYPES.DESC;
        }
      },

      onDataGridSearchSizeChange: function onDataGridSearchSizeChange(isMinState) {
        this.setState({
          isDataSearchMinSize: isMinState
        });
      }

    });

    return observer(BoardListHeader);
  };
}();

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerRoutes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Route = __webpack_require__(52).Route;
  var routeUtils = __webpack_require__(31);

  var ReportDesignerRoot = __webpack_require__(2646);

  var onChangeReportDesigner = function onChangeReportDesigner(prevState, nextState) {
    nextState.location.isNewReport = true;
  };

  var ReportDesignerRoutes = function ReportDesignerRoutes() {
    var ROUTE = routeUtils.getConfigRoute('ReportDesigner');
    var EDIT_ROUTE = routeUtils.getConfigRoute('ReportDesigner', 'ReportDesignerDetail');

    return React.createElement(
      Route,
      {
        path: ROUTE.path,
        component: ReportDesignerRoot.Container,
        onChange: onChangeReportDesigner },
      React.createElement(Route, {
        name: EDIT_ROUTE.name,
        path: EDIT_ROUTE.path,
        component: ReportDesignerRoot.Container })
    );
  };

  module.exports = ReportDesignerRoutes;
}();

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(68);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DataCategoryItem component
 */
var DataCategoryItem = function DataCategoryItem(props) {
  var localization = props.localization,
      isCollapsed = props.isCollapsed,
      collapseToggle = props.collapseToggle,
      dataSource = props.dataSource;


  var categoryName = dataSource.name || localization.getText('COMMON_LABEL_UNCATEGORIZED');
  var iconClass = isCollapsed ? 'icon-folder-close' : 'icon-folder-open';

  return _react2.default.createElement(
    _Izenda4.default,
    { onClick: collapseToggle, text: categoryName, className: 'selectable', tooltip: categoryName },
    _react2.default.createElement('i', { className: iconClass }),
    categoryName
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataCategoryItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

DataCategoryItem.displayName = 'DataCategoryItem';

exports.default = (0, _Izenda2.default)()(DataCategoryItem);
module.exports = exports['default'];

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(68);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(62);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(972);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DataObjectItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var DataObjectItem = function DataObjectItem(props) {
  var node = props.node,
      store = props.store,
      dataSource = props.dataSource,
      toggleIcon = props.toggleIcon,
      collapseToggle = props.collapseToggle,
      useCheckBox = props.useCheckBox,
      filterText = props.filterText,
      handleCheck = props.handleCheck;


  var objectItemClass = (0, _classnames2.default)({
    normal: !useCheckBox,
    checkbox: useCheckBox
  });

  var tooltip = dataSource.connectionName + '.' + dataSource.querySourceCategoryName + '.' + dataSource.originalName;

  var textDisplay = _Izenda2.default.advancedSettings.other.showSchemaNameValue ? dataSource.querySourceCategoryName + '.' + dataSource.name : dataSource.name;

  return _react2.default.createElement(
    'div',
    { className: objectItemClass },
    _react2.default.createElement(
      _Izenda4.default,
      {
        className: 'selectable',
        text: textDisplay,
        tooltip: tooltip,
        onClick: collapseToggle
      },
      _react2.default.createElement('i', { className: store.dataTree.getIcon(dataSource.type) }),
      _react2.default.createElement(_Izenda6.default, {
        text: textDisplay,
        tooltip: tooltip,
        highlight: filterText
      })
    ),
    _react2.default.createElement(
      'span',
      { className: 'pull-right' },
      toggleIcon,
      useCheckBox && _react2.default.createElement(_Izenda8.default, {
        type: 'checkbox',
        checked: dataSource.selected,
        onChange: handleSelect
      })
    )
  );

  function handleSelect(e) {
    handleCheck(dataSource, e.target.checked, node);
  }
};

DataObjectItem.displayName = 'DataObjectItem';

exports.default = (0, _mobxReact.observer)(DataObjectItem);
module.exports = exports['default'];

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(188);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(68);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(62);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(153);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * FieldItem component
 */
var DataFieldItem = (0, _mobxReact.observer)(function (props) {
  var field = props.itemData,
      className = props.className,
      store = props.store,
      isRegistedItem = props.isRegistedItem;

  var classes = (0, _classnames2.default)('fieldItem u_curPointer', className, {
    'registed-prop-editor': isRegistedItem
  });

  return _react2.default.createElement(
    'div',
    { className: classes, onMouseDown: props.onClick, onClick: showPropertiesEditor },
    _react2.default.createElement(
      _Izenda4.default,
      { text: field.name, tooltip: field.izendaDataType },
      _react2.default.createElement('i', { className: store.dataTree.getIcon(field.izendaDataType) }),
      _react2.default.createElement(_Izenda6.default, { highlight: props.filterText, text: field.name, tooltip: field.name })
    ),
    props.isCalculated && _react2.default.createElement('div', { title: 'Delete', className: 'icon-cancel pull-right', onClick: clickDelete })
  );

  function showPropertiesEditor() {
    _Izenda8.default.togglePropertiesEditor(true);
  }

  function clickDelete(e) {
    props.clickDelete(field);
  }
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataFieldItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

DataFieldItem.displayName = 'DataFieldItem';

exports.default = _Izenda2.default.wrapper(DataFieldItem);
module.exports = exports['default'];

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _recompose = __webpack_require__(9);

var _Izenda5 = __webpack_require__(159);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataTreeActions = (0, _recompose.withHandlers)({
  toggleSourceSelection: (0, _fp.curry)(toggleSourceSelection, 1),
  deleteCalculatedField: (0, _fp.curry)(deleteCalculatedField, 1)
});

/**
 * Toggle data source selection
 * @param  {Object} props
 * @param  {Object} dataObject
 * @param  {Boolean} selected
 * @param  {TreeNode} node
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.DataTreeActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

function toggleSourceSelection(props, dataObject, selected, node) {
  var store = props.store,
      loader = props.loader;
  var reportStore = store.reportStore,
      dataTree = store.dataTree;

  var fieldStore = reportStore.fieldsStore;
  var reportFiltersModel = fieldStore.reportFilters,
      fieldStoreDataTree = fieldStore.dataTree;

  reportStore.model.markDirty();
  reportStore.alertDetails.reset();

  if (selected) {
    // display error message if selected items exceed limitation
    if (dataTree.selectedItems.length >= _Izenda2.default.dataSourceLimitValue) {
      props.confirmFn('Information', {
        description: _Izenda4.default.BUNDLE.MESSAGE.M16,
        type: 'info',
        showCloseIndicator: true
      });
    } else {
      loader.startLoading();
      return store.startLoadingRelationship().then(store.handleChangeSelectedQuerySource.bind(store, dataObject, true, node)).then(function () {
        if (dataObject.isStoreProcedure) {
          store.model.addFilterParams(dataObject);
          return fieldStore.getFilterData(null, null, true).then(function () {
            // add parameters of stored procedures into filter if any
            reportFiltersModel.addFilterByIds(fieldStoreDataTree.parameterFieldIds, {
              isParameter: true
            });
            return (0, _bluebird.resolve)();
          });
        }
        return (0, _bluebird.resolve)();
      }).then(store.endLoadingRelationship.bind(store)).finally(loader.endLoading.bind(loader));
    }
  } else {
    return store.checkRemoveSelectedRelation(dataObject).then(function (result) {
      return confirmUnselectRelation(props, result, node);
    }).then(function () {
      // Clear config field when unselect store procedure
      dataObject.isStoreProcedure && fieldStore.reportFilters.setConfigModeToField(null);
    }).finally(loader.endLoading.bind(loader));
  }
}

/**
 * Confirm unselect relation
 * @param  {Object} props
 * @param  {Object} result
 * @param  {TreeNode} node
 * @return {Promise}
 */
function confirmUnselectRelation(props, result, node) {
  var store = props.store,
      loader = props.loader;

  var dataObject = result.dataObject;
  var reportFilters = store.reportStore.fieldsStore.reportFilters;
  var confirmMessage = store.model.reportMode === _Izenda4.default.ADVANCED ? _Izenda4.default.BUNDLE.MESSAGE.ADVANCED_UNSELECT : _Izenda4.default.BUNDLE.MESSAGE.SIMPLE_UNSELECT;

  function updateUncheckValue() {
    loader.startLoading();
    reportFilters.removeFiltersOfUncheckedDataObject(dataObject);
    return store.handleChangeSelectedQuerySource(dataObject, false, node).then(loader.endLoading.bind(loader));
  }

  if (store.model.reportMode !== _Izenda4.default.ADVANCED || result.hasRemovedRelationship) {
    return props.confirmFn('Confirmation', {
      description: String.format(confirmMessage, result.dataObject.name),
      isHTMLFormat: true
    }).then(updateUncheckValue);
  } else {
    return updateUncheckValue();
  }
}

/**
 * Delete calculated field
 * @param  {Object} props
 * @param  {Object} field
 * @return {Promise}
 */
function deleteCalculatedField(props, field) {
  var dataSourceStore = props.store,
      localization = props.localization;

  var reportStore = dataSourceStore.reportStore || {};
  var fieldStore = reportStore.fieldsStore;

  // Check has calculated field in report body
  var hasCalculatedField = fieldStore.reportBody.hasCalculatedField(field.id, field.name);
  // Check filter has use calculated field
  var filterUseCalculated = fieldStore.reportFilters.isFilterUseCalculatedField(field);
  // Check another calculated field use this calculated field
  var anotherCalculatedFieldUse = fieldStore.dataTree.isAnotherCalculatedFieldUse(field);

  if (hasCalculatedField || filterUseCalculated || anotherCalculatedFieldUse) {
    return props.confirmMessage('error', localization.getText('CALCULATED_FIELD_MESSAGE_HAS_BEEN_USED'));
  }

  return fieldStore.deleteCalculatedField(field);
}

exports.default = DataTreeActions;
module.exports = exports['default'];

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _reactDom = __webpack_require__(32);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var position = null;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DnDFieldsConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DnDFieldsConfig
 */

exports.default = {
  sourceOptions: {
    beginDrag: function beginDrag(props) {
      var itemData = props.itemData,
          _props$itemData = props.itemData,
          id = _props$itemData.id,
          visible = _props$itemData.visible,
          filterable = _props$itemData.filterable,
          isParameter = _props$itemData.isParameter,
          dataObject = props.dataObject;


      var item = {
        querySourceFieldId: id,
        visible: visible,
        filterable: filterable,
        isParameter: isParameter,
        itemType: _Izenda2.default.GENNERAL.FIELD_ITEM,
        dataObject: dataObject,
        querySourceField: itemData,
        sourceDataObjectName: dataObject.name
      };
      return item;
    }
  },

  targetOptions: {
    drop: function drop(props, monitor, component) {
      if (monitor.didDrop()) {
        return;
      }

      var _props$store = props.store,
          reportFilters = _props$store.reportFilters,
          reportStore = _props$store.reportStore;

      var item = monitor.getItem() || {};
      var changePosition = item.changePosition,
          filterable = item.filterable,
          querySourceFieldId = item.querySourceFieldId,
          sourceDataObjectName = item.sourceDataObjectName,
          dataObject = item.dataObject;


      if ((0, _fp.get)('querySourceField.isRunningField', item) === true) {
        props.dropMessage(_Izenda2.default.BUNDLE.MESSAGE.CANNOT_ADD_RUNNIG_FILTER);
        return;
      }

      if (changePosition) {
        var nextIndex = item.itemDataIndex < position ? position - 1 : position;
        reportFilters.moveTo(item.itemDataIndex, nextIndex);
        return;
      }

      if (!filterable || (0, _fp.get)('querySourceField.isCompositeField', item)) {
        props.dropMessage(_Izenda2.default.BUNDLE.MESSAGE.M02);
        return;
      }

      querySourceFieldId && reportFilters.addFilterById(querySourceFieldId, sourceDataObjectName, {
        relationshipId: dataObject && dataObject.isAlias ? dataObject.id : null
      }, position);

      position = null;
      reportStore.model.markDirty();
    },
    canAccess: function canAccess(item) {
      item = item || {};
      var _item = item,
          itemType = _item.itemType,
          visible = _item.visible,
          filterable = _item.filterable,
          isParameter = _item.isParameter;

      var isRunningField = (0, _fp.get)('querySourceField.isRunningField', item);
      var isCompositeField = (0, _fp.get)('querySourceField.isCompositeField', item);
      if (itemType === _Izenda2.default.GENNERAL.FIELD_ITEM) {
        return visible && filterable && !isParameter && !isRunningField && !isCompositeField;
      }

      return true;
    },
    canDrop: function canDrop(props, monitor) {
      var item = monitor.getItem();
      var itemType = item.itemType,
          isParameter = item.isParameter;


      if ((0, _fp.isNil)(item)) {
        return false;
      }

      return itemType !== _Izenda2.default.GENNERAL.FIELD_ITEM || !isParameter;
    },
    hover: function hover(props, monitor, component) {
      var cachedOffset = {};

      if (!monitor.canDrop()) {
        return;
      }

      var itemOffset = monitor.getClientOffset();
      var componentRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
      var itemWidth = componentRect.width / 4;
      var itemHeight = 50;

      var posItemX = itemOffset.x - componentRect.left;
      var posItemY = itemOffset.y - componentRect.top;

      if ((0, _fp.isEqual)(cachedOffset, itemOffset)) {
        return;
      }

      cachedOffset = itemOffset;

      if (posItemX > 0 && posItemY > 0 && posItemX < componentRect.width && posItemY < componentRect.height) {
        position = Math.floor(posItemX / itemWidth) + Math.floor(posItemY / itemHeight) * 4;
        var listFilter = resetStyleItem(component.props.filterFields);

        // Update position if it is more than the last position
        if (listFilter.length && position >= listFilter.length) {
          position = listFilter.length;
        }

        // Set the style for the item at the position
        if (position === listFilter.length) {
          setStyleForItem(listFilter, position - 1, 'Right');
        } else {
          setStyleForItem(listFilter, position, 'Left');
        }
      }

      function setStyleForItem(listFilter, position, type) {
        if ((0, _fp.isNil)(listFilter[position])) return;
        listFilter[position].style['border' + type + 'Style'] = _Izenda2.default.GENNERAL.BORDER_HOVER_ITEM.STYLE;
        listFilter[position].style['border' + type + 'Color'] = _Izenda2.default.GENNERAL.BORDER_HOVER_ITEM.COLOR;
      }

      function resetStyleItem(filterFields) {

        var listFilter = (0, _fp.map)(function (item) {
          var style = item.filterItemDom.style;
          style.borderLeftStyle = '';
          style.borderRightStyle = '';
          return item.filterItemDom;
        }, filterFields);

        return listFilter;
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FiltersDataSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(16);

var _mobxReact = __webpack_require__(10);

var _Izenda2 = __webpack_require__(28);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(1191);

var _Izenda5 = _interopRequireDefault(_Izenda4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FILTERS_HEADER_LABEL = _Izenda.FIELDS.FILTERS_HEADER_LABEL;
var FITLERS_PANEL_UI = _Izenda.DATA_SOURCE.FITLERS_PANEL_UI;

var FilterHeaderPanel = (0, _mobxReact.observer)(function (_ref) {
  var collapseToggle = _ref.collapseToggle;

  return _react2.default.createElement(
    "div",
    { className: "inline-table", onClick: collapseToggle },
    _react2.default.createElement("i", { className: "icon-toggle-thick" }),
    _react2.default.createElement(
      "strong",
      null,
      FILTERS_HEADER_LABEL
    )
  );
});

FilterHeaderPanel.displayName = "FilterHeaderPanel";

var FiltersDataSource = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FiltersDataSource, _Component);

  function FiltersDataSource() {
    (0, _classCallCheck3.default)(this, FiltersDataSource);
    return (0, _possibleConstructorReturn3.default)(this, (FiltersDataSource.__proto__ || (0, _getPrototypeOf2.default)(FiltersDataSource)).apply(this, arguments));
  }

  (0, _createClass3.default)(FiltersDataSource, [{
    key: "dropMessage",
    value: function dropMessage(message) {
      return this.props.confirmFn("Information", {
        description: message,
        type: "info",
        showCloseIndicator: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          store = _props.store,
          fieldStore = _props.fieldStore,
          viewMode = _props.viewMode;

      var paramFilterFields = fieldStore.reportFilters.paramFilterFields || [];

      var headerComponent = {
        component: FilterHeaderPanel
      };

      return _react2.default.createElement(
        _Izenda3.default,
        {
          className: "full-height",
          header: headerComponent,
          collapsible: true,
          initState: true,
          resizable: true,
          defaultValue: FITLERS_PANEL_UI.minHeight,
          minValue: FITLERS_PANEL_UI.minHeight,
          maxValue: FITLERS_PANEL_UI.maxHeight
        },
        _react2.default.createElement(_Izenda5.default, {
          store: fieldStore,
          filterFields: paramFilterFields,
          dropMessage: this.dropMessage,
          viewMode: viewMode,
          showPosition: false
        })
      );
    }
  }]);
  return FiltersDataSource;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp)) || _class;

exports.default = FiltersDataSource;
;
module.exports = exports["default"];

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Detail component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2673);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(638);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2675);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(83);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var FieldDetail = (_dec = (0, _Izenda2.default)({ toClass: true }, _Izenda8.default, _Izenda10.default), _dec(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(FieldDetail, _Component);

  // make sure a loader
  // triggered in child components work correctly
  function FieldDetail(props) {
    (0, _classCallCheck3.default)(this, FieldDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FieldDetail.__proto__ || (0, _getPrototypeOf2.default)(FieldDetail)).call(this, props));

    _initDefineProp(_this, 'bottom', _descriptor, _this);

    _this.setRef = function (dom) {
      _this.container = dom;
    };

    var registerObserveLoading = props.registerObserveLoading,
        isReloadView = props.isReloadView,
        store = props.store;

    _this.bottom = 0;

    registerObserveLoading(_this);

    !isReloadView && store.loadInitial();
    return _this;
  }

  (0, _createClass3.default)(FieldDetail, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.unregisterObserveLoading(this);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var rect = this.container.getBoundingClientRect();
      this.bottom = window.innerHeight - (rect.top + rect.height);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          uiStore = _props.uiStore,
          pageName = _props.pageName,
          height = _props.height;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper-content', ref: this.setRef },
        _react2.default.createElement(
          'div',
          { className: 'izenda-FieldsDetail izenda-TableLayout' },
          _react2.default.createElement(
            'div',
            { className: 'izenda-TableLayout-Cell' },
            _react2.default.createElement(_Izenda4.default, { bottom: this.bottom, height: height, store: store, uiStore: uiStore, pageName: pageName })
          ),
          _react2.default.createElement(_Izenda6.default, { fieldStore: store, reportDesignerModel: store.masterModel, uiStore: uiStore })
        )
      );
    }
  }]);
  return FieldDetail;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'bottom', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class2)) || _class);


FieldDetail.displayName = 'FieldDetail';

exports.default = FieldDetail;
module.exports = exports['default'];

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(27);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollBoxContainer = function ScrollBoxContainer(props) {
  var className = (0, _classnames2.default)('u_fullHeight', props.className);
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      _Izenda2.default,
      null,
      props.children
    )
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ScrollBoxContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = ScrollBoxContainer;
module.exports = exports['default'];

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(420);

var _fp = __webpack_require__(1);

var ORIENTATION = _Izenda.SETTINGS_KEY.ORIENTATION,
    MARGIN = _Izenda.SETTINGS_KEY.MARGIN,
    HORIZONTALLY = _Izenda.SETTINGS_KEY.HORIZONTALLY,
    VERTICALLY = _Izenda.SETTINGS_KEY.VERTICALLY,
    PAGEBREAK = _Izenda.SETTINGS_KEY.PAGEBREAK;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportingConfigAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _recompose.withHandlers)({
  /**
   * change orientation settings
   * @param  {object} props 
   * @param  {int} target 
   */
  changeOrientation: (0, _fp.curry)(function (props, target) {
    props.model.updateValueByKey(parseInt(target.value), ORIENTATION);
  }),

  /**
   * change margins settings
   * @param  {object} props 
   * @param  {int} target 
   */
  changeMargins: (0, _fp.curry)(function (props, target) {
    props.validation.reset();
    props.model.updateValueByKey(parseInt(target.value), MARGIN);
  }),

  /**
   * change horizontal settings
   * @param  {object} props 
   * @param  {object} event 
   */
  changeHorizontally: (0, _fp.curry)(function (props, event) {
    props.model.updateCenterOnPageByKey(event.target.checked, HORIZONTALLY);
  }),

  /**
   * change vertical settings
   * @param  {object} props 
   * @param  {object} event 
   */
  changeVertically: (0, _fp.curry)(function (props, event) {
    props.model.updateCenterOnPageByKey(event.target.checked, VERTICALLY);
  }),

  /**
   * change page break after report part settings
   * @param  {object} props 
   * @param  {object} event 
   */
  changePageBreak: (0, _fp.curry)(function (props, event) {
    props.model.updateValueByKey(event.target.checked, PAGEBREAK);
  }),

  /**
   * change page margin configs settings
   * @param  {object} props 
   * @param  {float} value 
   */
  changeMarginConfig: (0, _fp.curry)(function (props, value, key) {
    var marginConfig = props.model.customMarginSettings;
    marginConfig.updateValueByKey(value, key);
  })
});
module.exports = exports['default'];

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(416);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _reactRouter = __webpack_require__(52);

var _Izenda = __webpack_require__(31);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2699);

var _Izenda4 = __webpack_require__(2702);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(1215);

var _Izenda7 = _interopRequireDefault(_Izenda6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Flag creating new dashboard whenever the route enters or changed
 * @param {any} prevState
 * @param {any} nextState
 */
var setNewDashboardDefaultState = function setNewDashboardDefaultState(prevState, nextState) {
  nextState.location.state = (0, _fp.defaults)(nextState.location.state, {
    needCreateNewDashboard: true
  });
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardRoutes.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var setNewDashboardNullState = setNewDashboardDefaultState.bind(null, null);

exports.default = function () {
  var _map = [['Dashboard'], ['Dashboard', 'List'], ['Dashboard', 'Edit'], ['Dashboard', 'New']].map(function (route) {
    return _Izenda2.default.getConfigRoute(route);
  }),
      _map2 = (0, _slicedToArray3.default)(_map, 4),
      index = _map2[0],
      list = _map2[1],
      edit = _map2[2],
      add = _map2[3];

  return _react2.default.createElement(
    _reactRouter.Route,
    { path: index.path, component: _Izenda3.Container },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Izenda5.default }),
    _react2.default.createElement(_reactRouter.Route, { name: list.name, path: list.path, component: _Izenda5.default }),
    _react2.default.createElement(_reactRouter.Route, {
      name: add.name,
      path: add.path,
      component: _Izenda7.default,
      onEnter: setNewDashboardNullState,
      onChange: setNewDashboardDefaultState
    }),
    _react2.default.createElement(_reactRouter.Route, { name: edit.name, path: edit.path, component: _Izenda7.default })
  );
};

module.exports = exports['default'];

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardSubscribe.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(341);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2706);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(277);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardSubscribe = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DashboardSubscribe, _Component);

  function DashboardSubscribe(props) {
    (0, _classCallCheck3.default)(this, DashboardSubscribe);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardSubscribe.__proto__ || (0, _getPrototypeOf2.default)(DashboardSubscribe)).call(this, props));

    _initialiseProps.call(_this);

    var store = props.store,
        isSubscribe = props.store.model.dashboardDesignerMode.isSubscribe,
        subscribedInstancesStore = props.store.subscribedInstancesStore,
        isDashboardMode = props.isDashboardMode,
        id = props.id;


    store.initSubscription();
    _this.pageConstants = isSubscribe ? _Izenda6.default : _Izenda8.default;
    //Get dashboard detail with common filter here
    isDashboardMode && store.updateCommonFilter(id);
    return _this;
  }

  (0, _createClass3.default)(DashboardSubscribe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          store = _props.store,
          subscribedInstancesStore = _props.store.subscribedInstancesStore,
          dashboardDetail = _props.store.model.dashboardDetail,
          dashboard = _props.store.model.dashboardDetail.dashboard,
          subscriptions = _props.store.model.dashboardDetail.dashboard.subscriptions,
          isSubscribe = _props.store.model.dashboardDesignerMode.isSubscribe,
          id = _props.id;


      var dashboardId = id || dashboard.id;
      !(0, _fp.isNil)(dashboardId) && dashboardId !== subscribedInstancesStore.dashboardId && subscribedInstancesStore.updateDashboardId(dashboardId, isSubscribe);

      var instances = (0, _fp.filter)(function (item) {
        return item.isSubscription === isSubscribe;
      }, subscriptions.toJS());
      subscribedInstancesStore.loadInstances(instances);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.store.subscribedInstancesStore.disposeObserveSubscriptions();
    }

    /**
     * Save subscription data.
     */


    /**
     * Save subscription data.
     */


    /**
     * Save subscribed instances
     * This is used for save subscribed instances in dashboard list.
     */

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          subscribedInstancesStore = _props2.store.subscribedInstancesStore,
          dashboardDetail = _props2.store.model.dashboardDetail,
          width = _props2.width,
          isDashboardMode = _props2.isDashboardMode,
          onClose = _props2.onClose,
          doesSaveToDB = _props2.doesSaveToDB;


      return _react2.default.createElement(_Izenda4.default, {
        updateCascadingFilterValue: this.updateCascadingFilterValue,
        store: subscribedInstancesStore,
        pageConstants: this.pageConstants,
        containerWidth: width,
        isPopupMode: false,
        isDashboardMode: isDashboardMode,
        onClose: onClose,
        onSave: this.onDashboardModeSave,
        onSavePopupDesigner: this.onSaveSubscription,
        onSyncSubscription: this.syncSubscriptions,
        doesSaveToDB: doesSaveToDB,
        dashboardDetail: dashboardDetail
      });
    }
  }]);
  return DashboardSubscribe;
}(_react.Component), _class2.propTypes = {
  store: _react2.default.PropTypes.object
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSaveSubscription = function (subData) {
    var _props3 = _this2.props,
        model = _props3.store.subscribedInstancesStore.model,
        doesSaveToDB = _props3.doesSaveToDB;

    //Update for dashboard grid

    model.updateSubscribedInstances(subData);
    //Update to dashboard detail
    _this2.syncSubscriptions(model.subscribedInstances);
    doesSaveToDB && _this2.onDashboardModeSave();
  };

  this.syncSubscriptions = function (instances) {
    var _props4 = _this2.props,
        isSubscribe = _props4.store.model.dashboardDesignerMode.isSubscribe,
        dashboardDetail = _props4.store.model.dashboardDetail;

    dashboardDetail.syncSubscriptions(instances, isSubscribe);
  };

  this.onDashboardModeSave = function () {
    var _props5 = _this2.props,
        store = _props5.store,
        subscribedInstancesStore = _props5.store.subscribedInstancesStore,
        model = _props5.store.subscribedInstancesStore.model,
        isSubscribe = _props5.store.model.dashboardDesignerMode.isSubscribe,
        id = _props5.id,
        loader = _props5.loader;


    var isDirty = model.checkDirty();

    if (isDirty) {
      loader.startLoading();
      var savingInstances = model.buildDataForSaving();
      return store.saveDashboardSubscriptions(id, savingInstances).then(function (result) {
        return result.success ? subscribedInstancesStore.loadInstances(isSubscribe) : (0, _bluebird.resolve)(result);
      }).finally(loader.endLoading.bind(loader));
    }
  };

  this.updateCascadingFilterValue = function (sourceFilter, configFieldList, subscriptionCommonFilterFields) {
    _this2.props.store.dashboardFilterStore.updateCascadingFilterValue(sourceFilter, configFieldList, subscriptionCommonFilterFields);
  };
}, _temp)) || _class);
exports.default = DashboardSubscribe;
module.exports = exports["default"];

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(30);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(635);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(401);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintDashboardButton = function PrintDashboardButton(props) {
  return _react2.default.createElement(_Izenda4.default, { label: props.localization.getText('COMMON_LABEL_PRINT'), onClick: props.exportDashboard(_Izenda7.HTML.value) });
};
// ----------------------------------------------------------------------
// <copyright file='Izenda.PrintDashboardButton.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

PrintDashboardButton.displayName = 'PrintDashboardButton';

exports.default = (0, _Izenda2.default)(_Izenda6.default)(PrintDashboardButton);
module.exports = exports['default'];

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _class3, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module Action popup component
 */

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(73);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(34);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(104);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(15);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _mobx = __webpack_require__(5);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda9 = __webpack_require__(36);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(13);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(17);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(71);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(47);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(23);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2);

var _Izenda22 = _interopRequireDefault(_Izenda21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ValidatableInput = (0, _Izenda20.default)()(_Izenda14.default);
var CANCEL_TEXT = 'cancel';
var ACCEPT_TEXT = 'accept';

var ActionPopup = (_dec = (0, _Izenda22.default)(), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ActionPopup, _Component);

  function ActionPopup(props) {
    (0, _classCallCheck3.default)(this, ActionPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionPopup.__proto__ || (0, _getPrototypeOf2.default)(ActionPopup)).call(this, props));

    _initialiseProps.call(_this);

    var name = props.dashboard.name;


    _this.name = name;
    _this.selectedSaveInto = null;
    _this.categoryId = null;
    _this.category = null;
    _this.subCategoryId = null;
    _this.subCategory = null;
    _this.categories = [];
    _this.isLastPageCategorySearch = false;
    _this.subCategories = [];
    _this.isLastPageSubCategorySearch = false;
    return _this;
  }

  /**
   * Get status of subcategory control
   */


  (0, _createClass3.default)(ActionPopup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _Izenda6.default.loadCategorySettings().then((0, _mobx.action)(function (result) {
        // The value of Save Into is 'local' if the system / user is tenant level
        var isGlobal = _Izenda8.default.currentUser.systemAdmin && (0, _fp.isNil)(_Izenda8.default.tenantId) ? _this2.props.dashboard.isGlobal : false;
        _this2.localGlobalCategories = result;
        _this2.selectedSaveInto = (0, _fp.get)('id', _this2.getSaveInCategory(isGlobal, result));
      }));
    }

    /**
     * Get first global category
     * @param {boolean} isGlobal
     * @param {Array<Object>} localGlobalCategories
     */

  }, {
    key: 'getSaveInCategory',
    value: function getSaveInCategory(isGlobal, localGlobalCategories) {
      return (0, _fp.flow)((0, _fp.filter)({ isGlobal: isGlobal }), _fp.head)(localGlobalCategories);
    }

    /**
     * Fetch categories
     * @param {Object} pageInfo
     */


    /**
     * On search category
     * @param {string} key
     */


    /**
     * Reset category data source
     */


    /**
     * Fetch sub-categories
     * @param {Object} pageInfo
     */


    /**
     * On search sub-category
     * @param {string} key
     */


    /**
     * Reset sub-category data source
     */


    /**
     * Handle when click ok button
     */


    /**
     * Handle when click cancel button
     */


    /**
     * Handle when popup closing
     * @param  {Function} closeCallback function
     * @param  {string} type of close button click
     */


    /**
     * Handle on change name dashboard
     * @param  {Object} event
     */


    /**
     * On change save into option
     * @param {Object} value
     */


    /**
     * Handle when select  category
     * @param  {string} value select  category
     * @param  {string} name  select  category
     */


    /**
     * Handle when add new category
     * @param  {object} value new category
     */


    /**
     * Handle when select sub category
     * @param  {string} value select sub category
     * @param  {string} name  select sub category
     */


    /**
     * Handle when add new sub category
     * @param  {object} value new sub category
     */


    /**
     * Get selected category
     */


    /**
     * Get selected sub-category
     */


    /**
     * Prevent add new category
     */


    /**
     * Render name group
     * @param {String} label
     */


    /**
     * Render save into group
     * @param {String} label
     */


    /**
     * Render category group
     * @param {String} label
     */


    /**
     * Render sub-category group
     * @param {String} label
     */


    /**
     * Render body
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          action = _props.action,
          localization = _props.localization;

      var popupTitle = _Izenda2.default.ACTION_ENUM[action] + ' ' + _Izenda2.default.DASHBOARD;

      return _react2.default.createElement(
        _Izenda10.default,
        { visible: true, onClosing: this.onClosing, autoClose: false, type: 'none' },
        _react2.default.createElement(_Izenda10.default.Header, { title: popupTitle }),
        _react2.default.createElement(
          _Izenda10.default.Body,
          null,
          this.renderContainer()
        ),
        _react2.default.createElement(
          _Izenda10.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda10.default.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda10.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }, {
    key: 'disableSubCategory',
    get: function get() {
      return (0, _fp.isNil)(this.categoryId);
    }
  }]);
  return ActionPopup;
}(_react.Component), _class3.propTypes = {
  dashboard: _propTypes2.default.object,
  categories: _propTypes2.default.object,
  onClose: _propTypes2.default.func,
  popupConfig: _propTypes2.default.object,
  action: _propTypes2.default.number,
  actionFunc: _propTypes2.default.func
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  _initDefineProp(this, 'name', _descriptor, this);

  _initDefineProp(this, 'selectedSaveInto', _descriptor2, this);

  _initDefineProp(this, 'categoryId', _descriptor3, this);

  _initDefineProp(this, 'category', _descriptor4, this);

  _initDefineProp(this, 'subCategoryId', _descriptor5, this);

  _initDefineProp(this, 'subCategory', _descriptor6, this);

  _initDefineProp(this, 'categories', _descriptor7, this);

  _initDefineProp(this, 'isLastPageCategorySearch', _descriptor8, this);

  _initDefineProp(this, 'subCategories', _descriptor9, this);

  _initDefineProp(this, 'isLastPageSubCategorySearch', _descriptor10, this);

  this.getCategories = function (pageInfo) {
    pageInfo = pageInfo || {
      pageIndex: 1,
      pageSize: _Izenda4.default.DEFAUFT_DROPDOWN_ITEMS * _Izenda4.default.LAZY_LOADING_DEFAULT_PAGE_INDEX
    };
    var request = {
      pageIndex: pageInfo.pageIndex,
      pageSize: pageInfo.pageSize,
      type: 2,
      criteria: [{ key: 'name', value: _this3.searchCategoryKey }],
      parentIds: [_this3.selectedSaveInto],
      tenantId: _Izenda8.default.tenantId,
      includeUncategory: false
    };

    return (0, _fp.invokeArgs)('getCategoriesFunc', [request], _this3.props).then((0, _mobx.action)(function (data) {
      _this3.categories = data.categories;
      _this3.isLastPageCategorySearch = data.isLastPage;
      return data.categories;
    }));
  };

  this.handleSearchCategoryData = function (key) {
    _this3.searchCategoryKey = key;
    return _this3.getCategories(null);
  };

  this.resetCategory = function () {
    _this3.searchCategoryKey = null;
    _this3.categories = [];
  };

  this.getSubCategories = function (pageInfo) {
    if (String.isGuidFormat(_this3.categoryId)) {
      pageInfo = pageInfo || {
        pageIndex: 1,
        pageSize: _Izenda4.default.DEFAUFT_DROPDOWN_ITEMS * _Izenda4.default.LAZY_LOADING_DEFAULT_PAGE_INDEX
      };
      var request = {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        type: 2,
        criteria: [{ key: 'name', value: _this3.searchSubCategoryKey }],
        parentIds: [_this3.selectedSaveInto, _this3.categoryId],
        tenantId: _Izenda8.default.tenantId
      };

      return (0, _fp.invokeArgs)('getSubcategoriesFunc', [request], _this3.props).then((0, _mobx.action)(function (data) {
        _this3.subCategories = data.subCategories;
        _this3.isLastPageSubCategorySearch = data.isLastPage;
        return data.subCategories;
      }));
    } else {
      return (0, _bluebird.resolve)([]);
    }
  };

  this.handleSearchSubCategoryData = function (key) {
    _this3.searchSubCategoryKey = key;
    return _this3.getSubCategories(null);
  };

  this.resetSubCategory = function () {
    _this3.searchSubCategoryKey = null;
    _this3.subCategories = [];
  };

  this.onAcceptClosing = function () {
    var props = _this3.props;
    var valManager = props.validation,
        dashboard = props.dashboard,
        action = props.action;

    var formatMessage = action === _Izenda2.default.COPY_KEY ? _Izenda2.default.MESSAGE.M06b : _Izenda2.default.MESSAGE.M06a;

    var successMessage = String.format(formatMessage, _this3.name, !(0, _fp.isEmpty)(_this3.category) ? _this3.category : _Izenda2.default.UNCATEGORIZED, !(0, _fp.isEmpty)(_this3.subCategory) ? '/' + _this3.subCategory : '');

    var data = {
      id: dashboard.id,
      name: _this3.name,
      isGlobal: (0, _fp.flow)((0, _fp.filter)({ id: _this3.selectedSaveInto }), _fp.head, (0, _fp.get)('isGlobal'))(_this3.localGlobalCategories),
      categoryId: String.isGuidFormat(_this3.categoryId) ? _this3.categoryId : null,
      categoryName: _this3.category,
      subCategoryId: String.isGuidFormat(_this3.subCategoryId) ? _this3.subCategoryId : null,
      subCategoryName: _this3.subCategory
    };

    return valManager.validate().then(function (success) {
      if (success) {
        return _this3.props.actionFunc(data).then(function (result) {
          if (result.success === false) {
            var msg = result.messages || [];
            var key = (0, _fp.head)(msg) && (0, _fp.head)(msg).key;
            key ? valManager.updateErrors(result.messages) : props.onAccept((0, _fp.head)((0, _fp.get)('messages', (0, _fp.head)(msg))));
          } else {
            props.onAccept(successMessage);
            return props.onClose && props.onClose(successMessage, result);
          }
        });
      }
    });
  };

  this.onCancelClosing = function () {
    _this3.props.onReject();
  };

  this.onClosing = function (closeCallback, type) {
    if (type === ACCEPT_TEXT) {
      _this3.onAcceptClosing();
    } else if (type === CANCEL_TEXT) {
      _this3.onCancelClosing();
    }
  };

  this.onChangeName = function (e) {
    _this3.name = e.target.value;
  };

  this.onChangeCategoryType = (0, _mobx.action)(function (value) {
    _this3.selectedSaveInto = value.id;
    _this3.categoryId = null;
    _this3.category = null;
    _this3.subCategoryId = null;
    _this3.subCategory = null;
  });
  this.onChangeCategory = (0, _mobx.action)(function (value, name) {
    _this3.categoryId = value;
    _this3.category = name;
    _this3.subCategoryId = null;
    _this3.subCategory = null;
  });
  this.onAddCategory = (0, _mobx.action)(function (value) {
    _this3.categories = [value];
    _this3.subCategories = [];
    return true;
  });
  this.onChangeSubCategory = (0, _mobx.action)(function (value, name) {
    _this3.subCategoryId = value;
    _this3.subCategory = name;
  });

  this.onAddSubCategory = function (value) {
    _this3.subCategories = [value];
    return true;
  };

  this.getSelectedCategory = function () {
    return (0, _fp.isNil)(_this3.categoryId) ? null : { id: _this3.categoryId, name: _this3.category };
  };

  this.getSelectedSubCategory = function () {
    return (0, _fp.isNil)(_this3.subCategoryId) ? null : { id: _this3.subCategoryId, name: _this3.subCategory };
  };

  this.preventAddNew = function () {
    return false;
  };

  this.renderNameGroup = function (label) {
    return _react2.default.createElement(
      _Izenda12.default.Row,
      null,
      _react2.default.createElement(
        _Izenda12.default.Col,
        { cols: '3' },
        _react2.default.createElement(
          _Izenda16.default,
          { className: 'control-label u_textNormal' },
          label
        )
      ),
      _react2.default.createElement(
        _Izenda12.default.Col,
        { cols: '9' },
        _react2.default.createElement(ValidatableInput, {
          value: _this3.name,
          onChange: _this3.onChangeName,
          validations: _Izenda2.default.CONSTRAINTS.NAME,
          field: 'name',
          type: 'text',
          name: 'name',
          className: 'form-control'
        })
      )
    );
  };

  this.renderSaveIntoGroup = function (label) {
    return _react2.default.createElement(
      _Izenda12.default.Row,
      null,
      _react2.default.createElement(
        _Izenda12.default.Col,
        { cols: '3' },
        _react2.default.createElement(
          _Izenda16.default,
          { className: 'control-label u_textNormal' },
          label
        )
      ),
      _react2.default.createElement(
        _Izenda12.default.Col,
        { cols: '9' },
        _react2.default.createElement(_Izenda18.default, {
          options: _this3.localGlobalCategories,
          labelKey: 'name',
          valueKey: 'id',
          value: _this3.selectedSaveInto,
          onChange: _this3.onChangeCategoryType,
          scalable: false,
          textboxMode: false
        })
      )
    );
  };

  this.renderCategoryGroup = function (label, selectedCategory, selectCategoryHint, onAddCategory) {
    return _react2.default.createElement(
      _Izenda12.default.Row,
      null,
      _react2.default.createElement(
        _Izenda12.default.Col,
        { cols: '3' },
        _react2.default.createElement(
          _Izenda16.default,
          { className: 'control-label u_textNormal' },
          label
        )
      ),
      _react2.default.createElement(
        _Izenda12.default.Col,
        { cols: '9' },
        _react2.default.createElement(_Izenda18.default, {
          simpleValue: true,
          options: _this3.categories,
          labelKey: 'name',
          valueKey: 'id',
          value: selectedCategory,
          noResultsText: selectCategoryHint,
          onChange: _this3.onChangeCategory,
          onAddNew: onAddCategory,
          scalable: false,
          isLazyLoading: true,
          getData: _this3.getCategories,
          onSearchLazy: _this3.handleSearchCategoryData,
          onCloseMenu: _this3.resetCategory,
          isLastPage: _this3.isLastPageCategorySearch
        })
      )
    );
  };

  this.renderSubCategoryGroup = function (label, selectedSubCategory, selectSubCategoryHint, onAddSubCategory) {
    return _react2.default.createElement(
      _Izenda12.default.Row,
      null,
      _react2.default.createElement(
        _Izenda12.default.Col,
        { cols: '3' },
        _react2.default.createElement(
          _Izenda16.default,
          { className: 'control-label u_textNormal' },
          label
        )
      ),
      _react2.default.createElement(
        _Izenda12.default.Col,
        { cols: '9' },
        _react2.default.createElement(_Izenda18.default, {
          simpleValue: true,
          options: _this3.subCategories,
          labelKey: 'name',
          valueKey: 'id',
          value: selectedSubCategory,
          noResultsText: selectSubCategoryHint,
          onChange: _this3.onChangeSubCategory,
          onAddNew: onAddSubCategory,
          disabled: _this3.disableSubCategory,
          scalable: false,
          isLazyLoading: true,
          getData: _this3.getSubCategories,
          onSearchLazy: _this3.handleSearchSubCategoryData,
          onCloseMenu: _this3.resetSubCategory,
          isLastPage: _this3.isLastPageSubCategorySearch
        })
      )
    );
  };

  this.renderContainer = function () {
    var _props2 = _this3.props,
        _props2$popupConfig = _props2.popupConfig,
        DASHBOARD_NAME = _props2$popupConfig.DASHBOARD_NAME,
        SAVEINTO = _props2$popupConfig.SAVEINTO,
        CATEGORY = _props2$popupConfig.CATEGORY,
        SUBCATEGORY = _props2$popupConfig.SUBCATEGORY,
        hasCanCreateNewCategoryPrivilege = _props2.hasCanCreateNewCategoryPrivilege,
        action = _props2.action;

    var isSystemAdmin = _Izenda8.default.currentUser.systemAdmin;
    var label = String.format(_Izenda2.default.MESSAGE.M07, (0, _fp.lowerCase)(_Izenda2.default.ACTION_ENUM[action]));

    var onAddCategory = _this3.onAddCategory;
    var onAddSubCategory = _this3.onAddSubCategory;
    var selectCategoryHint = _Izenda2.default.SELECT_CATEGORY_HINT;
    var selectSubCategoryHint = _Izenda2.default.SELECT_SUB_CATEGORY_HINT;

    if (!hasCanCreateNewCategoryPrivilege) {
      onAddCategory = _this3.preventAddNew;
      selectCategoryHint = null;
      onAddSubCategory = _this3.preventAddNew;
      selectSubCategoryHint = null;
    }

    var selectedCategory = _this3.getSelectedCategory();
    var selectedSubCategory = _this3.getSelectedSubCategory();

    return _react2.default.createElement(
      _Izenda12.default,
      { className: 'form-horizontal' },
      _react2.default.createElement(
        _Izenda12.default.Row,
        null,
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '12' },
          label
        )
      ),
      _this3.renderNameGroup(DASHBOARD_NAME),
      isSystemAdmin && (0, _fp.isNil)(_Izenda8.default.tenantId) && _this3.renderSaveIntoGroup(SAVEINTO),
      _this3.renderCategoryGroup(CATEGORY, selectedCategory, selectCategoryHint, onAddCategory),
      _this3.renderSubCategoryGroup(SUBCATEGORY, selectedSubCategory, selectSubCategoryHint, onAddSubCategory)
    );
  };
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'selectedSaveInto', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'categoryId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'category', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'subCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'subCategory', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'categories', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'isLastPageCategorySearch', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'subCategories', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'isLastPageSubCategorySearch', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'disableSubCategory', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'disableSubCategory'), _class2.prototype)), _class2)) || _class);
exports.default = ActionPopup;
module.exports = exports['default'];

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2, _class3, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesigner.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2709);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2718);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2721);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2748);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(632);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(27);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(31);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(73);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(606);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(42);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _fp = __webpack_require__(1);

var _Izenda23 = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FIRST_INDEX = 0;

var DashboardAlert = (0, _Izenda2.default)()(function DashboardAlert(props) {
  var _props$alertDetails = props.alertDetails,
      message = _props$alertDetails.message,
      alertType = _props$alertDetails.alertType,
      alertKey = _props$alertDetails.key,
      success = _props$alertDetails.success,
      errors = _props$alertDetails.errors,
      showType = _props$alertDetails.showType,
      type = _props$alertDetails.type;


  return _react2.default.createElement(
    'div',
    { className: 'izenda-Alert-container' },
    _react2.default.createElement(_Izenda12.default, {
      message: message,
      alertType: alertType,
      alertKey: alertKey,
      success: success,
      errors: errors,
      type: type,
      showType: showType
    })
  );
});

var BackgroundLayer = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(BackgroundLayer, _Component);

  function BackgroundLayer(props) {
    (0, _classCallCheck3.default)(this, BackgroundLayer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BackgroundLayer.__proto__ || (0, _getPrototypeOf2.default)(BackgroundLayer)).call(this, props));

    props.store.validateBackgroundImage();
    return _this;
  }

  (0, _createClass3.default)(BackgroundLayer, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.props.store.validateBackgroundImage();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$store = this.props.store,
          dashboardDetail = _props$store.dashboardDetail,
          dashboardDesignerMode = _props$store.dashboardDesignerMode;


      var dashboard = dashboardDetail.dashboard;
      var style = {
        backgroundImage: dashboardDesignerMode.isDesigner && 'url(' + dashboard.imageUrl + ')',
        backgroundColor: dashboardDesignerMode.isDesigner && dashboard.backgroundColor
      };
      var classes = (0, _classnames2.default)('izenda-Wrapper-content izenda-DashboardDesigner-LeftContent', {
        'stretch-background-image': dashboard.stretchImage && dashboard.imageUrl,
        'center-background-image': !dashboard.stretchImage && dashboard.imageUrl
      });

      return _react2.default.createElement(
        'div',
        { className: classes, style: style },
        this.props.children
      );
    }
  }]);
  return BackgroundLayer;
}(_react.Component)) || _class);
var DashboardDesigner = (_dec2 = (0, _Izenda2.default)(), _dec2(_class2 = (_temp = _class3 = function (_Component2) {
  (0, _inherits3.default)(DashboardDesigner, _Component2);

  function DashboardDesigner() {
    (0, _classCallCheck3.default)(this, DashboardDesigner);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (DashboardDesigner.__proto__ || (0, _getPrototypeOf2.default)(DashboardDesigner)).call(this));

    _this2.handleNeedUpdateResultChanged = function (change) {
      var _this2$props = _this2.props,
          localization = _this2$props.localization,
          alertDetails = _this2$props.store.dashboardDesignerMode.alertDetails;


      if (change) {
        alertDetails.set({
          message: localization.getText('REPORTDESIGNER_UPDATE_RESULT'),
          type: _Izenda23.ALERT_TYPES.INFO,
          success: true,
          showType: _Izenda23.SHOW_TYPES.ALWAYS
        });
      } else {
        alertDetails.reset();
      }
    };

    _this2.loadOpeningDashboard = function (id, commonFilters, store) {
      var dashboardDesignerMode = (0, _fp.get)('model.dashboardDesignerMode', store);
      var props = _this2.props,
          location = _this2.props.location;


      var pageId = (0, _fp.getOr)(null, 'state.page', location);

      dashboardDesignerMode.reset();

      // Get data for edit case
      return store.loadDashboard(id, commonFilters, pageId).then(dashboardDesignerMode.setEditMode.bind(dashboardDesignerMode)).then(store.validateDashboard.bind(store)).then(function (result) {
        if (!result.success) {
          if (result.messages[0].detail) {
            return props.confirmFn('Information', {
              description: _Izenda18.default.validateFilterMessage(result),
              type: 'error',
              isHTMLFormat: true,
              showCloseIndicator: true
            });
          } else {
            return props.validation.updateErrors(result.messages);
          }
        }
        // reload dashboard when common filter values came from URI.
        if (!(0, _fp.isNil)(commonFilters) && !(0, _fp.isEmpty)(commonFilters)) {
          store.updateResults(true);
        }
        return null;
      }).then(function () {
        var renderingTime = new Date().getTime() - _this2.startTime;
        return store.updateRenderingTime(renderingTime);
      });
    };

    _this2.securityManagerStore = new _Izenda20.default();
    _this2.startTime = new Date().getTime();
    return _this2;
  }

  (0, _createClass3.default)(DashboardDesigner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var securityManagerStore = this.securityManagerStore,
          props = this.props,
          _props = this.props,
          authorization = _props.authorization,
          openPopup = _props.openPopup,
          query = _props.location.query,
          store = _props.store,
          dashboardDetail = _props.store.dashboardDetail,
          newDashboard = _props.newDashboard;

      var id = props.id || props.params.id;
      var commonFilters = _Izenda16.default.transformQueryToFilters(query);
      var hasAddNewPrivileges = authorization.checkPrivileges([_Izenda22.default.PERMISSION_KEY.DashboardsCanCreateNewDashboardValue]);

      if (!(0, _fp.isNil)(id)) {
        securityManagerStore.checkAccessPage(props, id, function (accessPriority) {
          return accessPriority !== _Izenda21.ACCESS_RIGHT.NoAccess;
        }).then(function (canAccessPage) {
          canAccessPage && _this3.loadOpeningDashboard(id, commonFilters, store);
        });
      }

      if (newDashboard && hasAddNewPrivileges) {
        openPopup(_Izenda10.default, {
          dashboardDetail: dashboardDetail
        });
      }

      this.observeNeedUpdateResult();
    }

    /**
     * Observe new need update result when new dashboard filter is created
     */

  }, {
    key: 'observeNeedUpdateResult',
    value: function observeNeedUpdateResult() {
      var dashboardFilterStore = this.props.store.dashboardFilterStore;

      // Remove old observe

      this.needUpdateResultChangedDisposer && this.needUpdateResultChangedDisposer();

      this.needUpdateResultChangedDisposer = (0, _mobx.observe)(dashboardFilterStore.reportFilter, 'needUpdateResult', this.handleNeedUpdateResultChanged);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.observeNeedUpdateResult();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      nextProps.store.startDashboardDataWorker(FIRST_INDEX);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.terminateAllWorker();
      this.needUpdateResultChangedDisposer && this.needUpdateResultChangedDisposer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          store = _props2.store,
          _props2$store = _props2.store,
          dashboardDesignerMode = _props2$store.dashboardDesignerMode,
          dashboardDetail = _props2$store.dashboardDetail;


      var classes = (0, _classnames2.default)('izenda-Wrapper-content u_paddingTopBottom u_marginLeftRight', {
        'u-bgDarkGray': dashboardDesignerMode.isPresentation
      });

      return _react2.default.createElement(
        'div',
        { className: 'izenda-DashboardDesigner izenda-Wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-header' },
          _react2.default.createElement(DashboardAlert, { alertDetails: store.dashboardDesignerMode.alertDetails }),
          _react2.default.createElement(_Izenda4.default, this.props)
        ),
        _react2.default.createElement(
          BackgroundLayer,
          this.props,
          _react2.default.createElement(
            _Izenda14.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'u_paddingLeftRight u_fullHeight' },
              _react2.default.createElement(_Izenda6.default, (0, _extends3.default)({}, this.props, { dashboardDetail: dashboardDetail })),
              _react2.default.createElement(
                'div',
                { className: classes },
                _react2.default.createElement(_Izenda8.default, (0, _extends3.default)({}, this.props, { dashboardDetail: dashboardDetail }))
              )
            )
          )
        )
      );
    }

    /**
     * Load all data for dashboard when opening
     */

  }]);
  return DashboardDesigner;
}(_react.Component), _class3.propTypes = {
  store: _mobxReact.propTypes.observableObject.isRequired,
  newDashboard: _propTypes2.default.bool.isRequired
}, _temp)) || _class2);
exports.default = DashboardDesigner;
module.exports = exports['default'];

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTileBody.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var DashboardConstants = __webpack_require__(73);
  var observer = __webpack_require__(10).observer;

  var TileComponents = {
    Text: {
      FrontSide: __webpack_require__(2724),
      BackSide: __webpack_require__(2725)
    },
    ReportPart: {
      FrontSide: __webpack_require__(2728),
      BackSide: __webpack_require__(2731)
    }
  };

  var DashboardTileBody = function DashboardTileBody(props) {
    var dashboardPart = props.dashboardPart;
    var edit = !props.viewMode;

    var type = dashboardPart.type;
    var isBackSide = dashboardPart.isBackSide;

    var Tile = type === DashboardConstants.TILE_TYPE.text.type ? TileComponents.Text : TileComponents.ReportPart;

    var SideComponent = edit && isBackSide ? Tile.BackSide : Tile.FrontSide;

    return React.createElement(SideComponent, props);
  };
  DashboardTileBody.propTypes = {
    dashboardPart: ObservablePropTypes.observableObject,
    viewMode: PropTypes.bool
  };

  module.exports = observer(DashboardTileBody);
}();

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TileTitleFrontSide.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var GridLayout = __webpack_require__(13);

  var TileTitleFrontSide = React.createClass({
    displayName: 'TileTitleFrontSide',

    propTypes: {
      dashboardPart: React.PropTypes.object.isRequired
    },

    publishFinishedRender: function publishFinishedRender() {
      var props = this.props;

      props.printingMode && props.finishedRender && props.fulfilledData
      // Work around for fontWeight is bold.
      // when bold fontWeight, it takes more time to display.
      && setTimeout(function () {
        props.finishedRender();
      }, 20);
    },

    componentDidMount: function componentDidMount() {
      this.publishFinishedRender();
    },

    componentDidUpdate: function componentDidUpdate() {
      this.publishFinishedRender();
    },

    render: function render() {
      var props = this.props;
      var dashboardPart = props.dashboardPart;
      var title = getStyle('contentTitle');
      var description = getStyle('contentDescription');
      var contentTitle = getText('contentTitle');
      var contentDescription = getText('contentDescription');

      return React.createElement(
        GridLayout,
        { className: 'u_paddingBottom' },
        contentTitle && React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { style: title.gridStyle },
            React.createElement(
              'span',
              { title: contentTitle, style: title.spanStyle },
              contentTitle
            )
          )
        ),
        contentDescription && React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { style: description.gridStyle },
            React.createElement(
              'span',
              { title: contentDescription, style: description.spanStyle },
              contentDescription
            )
          )
        )
      );

      /**
       * Get font style to use it inline style
       * @param {string} key
       * @returns {}
       */
      function getStyle(key) {

        var settings = dashboardPart[key] && dashboardPart[key].settings;

        var style = {
          fontFamily: settings.fontFamily,
          fontSize: settings.fontSize + 'px',
          fontWeight: settings.fontBold ? 'bold' : 'normal',
          textAlign: settings.alignment || 'none',
          textDecoration: settings.fontUnderline ? 'underline' : 'none',
          fontStyle: settings.fontItalic ? 'italic' : 'normal',
          color: settings.fontColor
        };

        var backgroundColor = {
          backgroundColor: settings.fontHighlightColor
        };

        return {
          gridStyle: style,
          spanStyle: backgroundColor
        };
      }

      function getText(key) {
        return dashboardPart[key] && dashboardPart[key].text;
      }
    }
  });

  module.exports = observer(TileTitleFrontSide);
}();

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.TileTitleBackSide.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var EventsUtils = __webpack_require__(24);
  var Input = __webpack_require__(17);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var action = __webpack_require__(2726);

  var CONSTANTS = __webpack_require__(73);
  var localizer = __webpack_require__(12);

  var TileSimpleInput = connect(action)(function (props) {
    var LABEL_TEXT = CONSTANTS.TILE_LABEL_TEXT;
    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: 1 },
        LABEL_TEXT[props.dataKey]
      ),
      React.createElement(
        GridLayout.Col,
        { cols: 11 },
        React.createElement(
          'div',
          { className: 'izenda-DashboardTitle-TileTitleBackSide-Input' },
          props.children,
          React.createElement(
            'a',
            { onClick: props.openPopup, title: props.title },
            React.createElement('span', { className: 'icon-setting' })
          )
        )
      )
    );
  });

  TileSimpleInput.propTypes = {
    dashboardPart: React.PropTypes.object.isRequired,
    dataKey: React.PropTypes.string.isRequired,
    title: React.PropTypes.string
  };

  var TileTitleBackSide = connect()(function (props) {
    var dashboardPart = props.dashboardPart;

    return React.createElement(
      GridLayout,
      { className: 'izenda-DashboardTile-TileTitleBackSide' },
      React.createElement(
        TileSimpleInput,
        (0, _extends3.default)({}, props, { dataKey: 'contentTitle', title: localizer.getText('DASHBOARD_LABEL_TITLE_SETTINGS') }),
        React.createElement(Input, {
          className: 'form-control',
          maxLength: CONSTANTS.TITLE_MAX_LENGTH,
          value: dashboardPart.contentTitle.text,
          onChange: EventsUtils.notifyChange(dashboardPart.updateContentTitle.bind(dashboardPart), EventsUtils.INPUT) })
      ),
      React.createElement(
        TileSimpleInput,
        (0, _extends3.default)({}, props, { dataKey: 'contentDescription', title: localizer.getText('DASHBOARD_LABEL_DESCRIPTION_SETTINGS') }),
        React.createElement('textarea', {
          className: 'form-control',
          rows: '4',
          value: dashboardPart.contentDescription.text,
          onChange: EventsUtils.notifyChange(dashboardPart.updateContentDescription.bind(dashboardPart), EventsUtils.INPUT) })
      )
    );
  });

  TileTitleBackSide.propTypes = {
    dashboardPart: React.PropTypes.object.isRequired
  };

  module.exports = TileTitleBackSide;
}();

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(979);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2729);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardFilterDescriptions = function DashboardFilterDescriptions(props) {
  var localization = props.localization,
      dashboardPart = props.dashboardPart,
      operatorSource = props.operatorSource;


  return _react2.default.createElement(
    'div',
    { className: 'u_tableRow' },
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell' },
      _react2.default.createElement(
        'label',
        null,
        localization.getText('DASHBOARD_LABEL_FILTER_DESCRIPTIONS')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell' },
      _react2.default.createElement(
        _Izenda4.default,
        { className: 'Izenda-DashboardTile-FilterDescription_GridLayout' },
        dashboardPart.fullConfigFieldList.map(function (configField, position) {
          return _react2.default.createElement(
            _Izenda4.default.Row,
            { key: position },
            _react2.default.createElement(
              _Izenda4.default.Col,
              null,
              _react2.default.createElement(_Izenda6.default, { field: configField, position: position + 1, operatorSource: operatorSource, filterSource: dashboardPart.individualConfigFieldList })
            )
          );
        })
      )
    )
  );
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardFilterDescriptions.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------


DashboardFilterDescriptions.propTypes = {
  dashboardPart: _react.PropTypes.object
};

exports.default = (0, _Izenda2.default)(_Izenda8.default)(DashboardFilterDescriptions);
module.exports = exports['default'];

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardGridLayoutUIStore.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var GridLayoutUIStore = __webpack_require__(580);
  var GridItemState = __webpack_require__(581);
  var Constants = __webpack_require__(436);
  var UiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      create = _require.create,
      round = _require.round;

  var action = __webpack_require__(5).action;
  var extendObservable = __webpack_require__(5).extendObservable;

  function DashboardGridLayoutUIStore(width, transparent, fullSizeMode) {
    GridLayoutUIStore.call(this, Constants.GRID_CELL_SIZE, // default grid cell width
    Constants.GRID_CELL_SIZE, // default grid cell height
    width, // dashboard grid width
    Constants.NUMBER_ROWS, // dashboard grid layout rows
    Constants.NUMBER_COLS, true, // allow infinity rows
    false, // allow infinity cols
    true, // view in full size mode
    true, null, null, Constants.TILE_MAX_HEIGHT);
    extendObservable(this, {
      transparent: !!transparent
    });
  }

  DashboardGridLayoutUIStore.prototype = create(GridLayoutUIStore.prototype, {
    constructor: DashboardGridLayoutUIStore
  });

  DashboardGridLayoutUIStore.prototype.setViewWidth = action(function setViewWidth(width) {
    var newCellSize = round(width / this.cols);

    this.cellWidth = newCellSize;
    this.cellHeight = newCellSize;

    GridLayoutUIStore.prototype.setViewWidth.call(this, width);

    this.recalculateLayoutPosition();
  });

  DashboardGridLayoutUIStore.prototype.setTransparent = action(function (transparent) {
    this.transparent = !!transparent;
  });

  module.exports = DashboardGridLayoutUIStore;
}();

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SliderBox.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      assign = _require.assign;

  // Fix issues IE9, matchMedia not present


  if (typeof window !== 'undefined') {
    var matchMediaPolyfill = function matchMediaPolyfill() {
      return {
        matches: false,
        addListener: function addListener() {},
        removeListener: function removeListener() {}
      };
    };
    window.matchMedia = window.matchMedia || matchMediaPolyfill;
  }
  __webpack_require__(2743);

  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var localizer = __webpack_require__(12);
  var classnames = __webpack_require__(11);
  var Slider = __webpack_require__(1185);

  var PrevArrow = React.createClass({
    displayName: 'PrevArrow',

    render: function render() {
      var prevButtonStyle = {
        zIndex: 1,
        left: this.props.centerPadding / 2 + 'px'
      };

      return React.createElement('button', (0, _extends3.default)({}, this.props, {
        title: localizer.getText('DASHBOARD_TOOLTIP_PREVIOUS_TILE'),
        className: 'slick-arrow slick-prev',
        style: prevButtonStyle
      }));
    }
  });

  var NextArrow = React.createClass({
    displayName: 'NextArrow',

    render: function render() {
      var nextButtonStyle = {
        right: this.props.centerPadding / 2 + 'px'
      };

      return React.createElement('button', (0, _extends3.default)({}, this.props, {
        title: localizer.getText('DASHBOARD_TOOLTIP_NEXT_TILE'),
        className: 'slick-arrow slick-next',
        style: nextButtonStyle
      }));
    }
  });

  var SliderBox = React.createClass({
    displayName: 'SliderBox',

    propTypes: {
      settings: React.PropTypes.object
    },

    /**
     * Init slider
     */
    initSlider: function initSlider() {
      var settings = this.props.settings;

      if (isNil(settings)) {
        return;
      }

      var newSettings = assign({
        prevArrow: React.createElement(PrevArrow, settings),
        nextArrow: React.createElement(NextArrow, settings)
      }, settings);

      newSettings.centerPadding = newSettings.centerPadding + 'px';

      return newSettings;
    },

    render: function render() {
      var sliderContainerClass = classnames('u_fullHeight izenda-SliderContainer', this.props.className);
      var settings = this.initSlider();

      return React.createElement(
        'div',
        { className: sliderContainerClass },
        React.createElement(
          Slider,
          settings,
          this.props.children
        )
      );
    }
  });

  module.exports = observer(SliderBox);
}();

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ViewerRoute.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var Route = __webpack_require__(52).Route;
  var routeUtils = __webpack_require__(31);

  var ReportPartViewer = __webpack_require__(976);
  var DashboardPartViewer = __webpack_require__(2752);
  var DashboardViewer = __webpack_require__(2754);
  var ReportBodyViewer = __webpack_require__(501);
  var viewerRoute = function viewerRoute() {
    var ROUTE = routeUtils.getConfigRoute('Viewer');
    var REPORT_PART_ROUTE = routeUtils.getConfigRoute('Viewer', 'ReportPart');
    var DASHBOARD_PART_ROUTE = routeUtils.getConfigRoute('Viewer', 'DashboardPart');
    var REPORT_BODY_ROUTE = routeUtils.getConfigRoute('Viewer', 'ReportBody');
    var DASHBOARD_ROUTE = routeUtils.getConfigRoute('Viewer', 'Dashboard');

    return React.createElement(
      Route,
      {
        path: ROUTE.path },
      React.createElement(Route, {
        name: REPORT_PART_ROUTE.name,
        path: REPORT_PART_ROUTE.path,
        component: ReportPartViewer }),
      React.createElement(Route, {
        name: DASHBOARD_PART_ROUTE.name,
        path: DASHBOARD_PART_ROUTE.path,
        component: DashboardPartViewer }),
      React.createElement(Route, {
        name: REPORT_BODY_ROUTE.name,
        path: REPORT_BODY_ROUTE.path,
        component: ReportBodyViewer }),
      React.createElement(Route, {
        name: DASHBOARD_ROUTE.name,
        path: DASHBOARD_ROUTE.path,
        component: DashboardViewer })
    );
  };

  module.exports = viewerRoute;
}();

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file='Izenda.Login.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// $FlowFixMe


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _isNil = __webpack_require__(855);

var _isNil2 = _interopRequireDefault(_isNil);

var _Izenda = __webpack_require__(60);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2761);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(152);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(28);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(23);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidateInput = (0, _Izenda12.default)()(__webpack_require__(17));
var CONSTRAINTS = _Izenda2.default.CONSTRAINTS;

var Header = function Header(_ref) {
  var message = _ref.message;

  return _react2.default.createElement(
    'div',
    null,
    !(0, _isNil2.default)(message) ? _react2.default.createElement(
      'div',
      { className: 'izenda-Account-errorMessage u_textLeft' },
      _react2.default.createElement('i', { className: 'icon-error-circled' }),
      message
    ) : null
  );
};

var Footer = function Footer(_ref2) {
  var localization = _ref2.localization,
      onClickSignIn = _ref2.onClickSignIn,
      onClickForgotPassword = _ref2.onClickForgotPassword;

  return _react2.default.createElement(
    'div',
    { className: 'u_textCenter' },
    _react2.default.createElement(
      'button',
      { className: 'btn btn-primary u_fullWidth', onClick: onClickSignIn },
      localization.getText('ACOUNT_LABEL_SIGN_IN')
    ),
    _react2.default.createElement(
      'div',
      { className: 'u_textRight izenda-Account-ForgotPassword u_textUnderline' },
      _react2.default.createElement(
        'a',
        { onClick: onClickForgotPassword },
        _react2.default.createElement(
          'span',
          null,
          localization.getText('ACOUNT_LABEL_FORGOT_PASSWORD')
        )
      )
    )
  );
};

var Login = (_dec = (0, _Izenda14.default)(_Izenda4.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login(props) {
    (0, _classCallCheck3.default)(this, Login);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call(this, props));

    if (!props.isLoggedIn(_this)) {
      props.init(_this);
    }
    return _this;
  }

  (0, _createClass3.default)(Login, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var props = this.props;

      if (!props.isLoggedIn(this)) {
        props.init(this);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      props.loader && props.loader.endLoading();
      props.registerEventHandler(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.unregisterEventHandler();
    }

    /**
     * Render organization.
     */

  }, {
    key: 'renderOrganization',
    value: function renderOrganization() {
      var _props = this.props,
          localization = _props.localization,
          model = _props.store.model,
          onChangeTenantName = _props.onChangeTenantName;


      return model.hasOrg ? _react2.default.createElement(
        _Izenda6.default.Row,
        null,
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12' },
          _react2.default.createElement('i', { className: 'icon-organization izenda-Account-Login-icon' }),
          _react2.default.createElement(ValidateInput, {
            type: 'text',
            className: 'form-control izenda-Account-Login-input',
            value: model.tenantName,
            onChange: onChangeTenantName,
            field: 'tenantName',
            placeholder: localization.getText('ACOUNT_LABEL_ORGANIZATION'),
            validations: CONSTRAINTS.tenantName
          })
        )
      ) : null;
    }

    /**
     * Render body.
     */

  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _props2 = this.props,
          localization = _props2.localization,
          model = _props2.store.model,
          onChangeUserName = _props2.onChangeUserName,
          onChangePassword = _props2.onChangePassword;


      return _react2.default.createElement(
        _Izenda6.default,
        { className: 'izenda-Account-Login-body' },
        this.renderOrganization(),
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '12' },
            _react2.default.createElement('i', { className: 'icon-useradmin izenda-Account-Login-icon' }),
            _react2.default.createElement(ValidateInput, {
              type: 'text',
              className: 'form-control izenda-Account-Login-input',
              value: model.userName,
              onChange: onChangeUserName,
              field: 'UserName',
              placeholder: localization.getText('ACOUNT_LABEL_USER_ID'),
              validations: CONSTRAINTS.userName
            })
          )
        ),
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '12' },
            _react2.default.createElement('i', { className: 'icon-pass izenda-Account-Login-icon' }),
            _react2.default.createElement(ValidateInput, {
              autoComplete: 'on',
              type: 'password',
              className: 'form-control izenda-Account-Login-input',
              value: model.password,
              onChange: onChangePassword,
              field: 'Password',
              placeholder: localization.getText('COMMON_LABEL_PASSWORD'),
              validations: CONSTRAINTS.loginPassword
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;

      var model = props.store.model;

      var header = {
        component: Header,
        message: model.message,
        className: 'izenda-Account-Login-header'
      };

      var footer = {
        component: Footer,
        onClickSignIn: props.onClickSignIn,
        className: 'izenda-Account-Login-footer',
        onClickForgotPassword: props.onClickForgotPassword,
        store: props.store,
        localization: props.localization
      };

      if (!model.enableForEnter) {
        return _react2.default.createElement(_Izenda8.default, { show: true });
      }

      return _react2.default.createElement(
        'div',
        { className: 'izenda-Account-Login u_inlineBlock' },
        _react2.default.createElement(
          _Izenda10.default,
          {
            className: 'izenda-Account-Container',
            header: header,
            footer: footer,
            panelBodyClassName: 'izenda-Account-Login-body'
          },
          this.renderBody()
        )
      );
    }
  }]);
  return Login;
}(_react.Component)) || _class);
exports.default = Login;
module.exports = exports['default'];

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file='Izenda.AccountInfo.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(60);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2766);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(23);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(152);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidateInput = (0, _Izenda12.default)()(__webpack_require__(17));
var CONSTRAINTS = _Izenda8.default.CONSTRAINTS;
// $FlowFixMe


var Header = function Header(_ref) {
  var localization = _ref.localization,
      message = _ref.message;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      null,
      localization.getText('ACOUNT_MESSAGE_PROVIDE_INFO_TO_CREATE_RESET_PASSWORD')
    ),
    !(0, _fp.isNil)(message) ? _react2.default.createElement(
      'div',
      { className: 'izenda-Account-errorMessage' },
      message
    ) : null
  );
};

var Footer = function Footer(_ref2) {
  var localization = _ref2.localization,
      onClickNext = _ref2.onClickNext;
  return _react2.default.createElement(
    'div',
    { className: 'u_textRight' },
    _react2.default.createElement(
      'button',
      { className: 'btn btn-primary izenda-Account-btn', onClick: onClickNext },
      localization.getText('ACOUNT_LABEL_NEXT')
    )
  );
};

var AccountInfo = (_dec = (0, _Izenda2.default)(_Izenda10.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AccountInfo, _Component);

  function AccountInfo(props) {
    (0, _classCallCheck3.default)(this, AccountInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AccountInfo.__proto__ || (0, _getPrototypeOf2.default)(AccountInfo)).call(this, props));

    _this.renderOrganization = function () {
      var _this$props = _this.props,
          store = _this$props.store,
          localization = _this$props.localization,
          onChangeTenantName = _this$props.onChangeTenantName;

      var model = store.model;

      return model.hasOrg ? _react2.default.createElement(
        _Izenda6.default.Row,
        null,
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: 'u_textLeft' },
          _react2.default.createElement(
            'label',
            null,
            localization.getText('ACOUNT_LABEL_ORGANIZATION')
          )
        ),
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '9' },
          _react2.default.createElement(ValidateInput, {
            type: 'text',
            className: 'form-control',
            value: model.tenantName,
            onChange: onChangeTenantName,
            field: 'tenantName',
            validations: CONSTRAINTS.tenantName
          })
        )
      ) : null;
    };

    _this.renderBody = function () {
      var _this$props2 = _this.props,
          model = _this$props2.store.model,
          localization = _this$props2.localization,
          onChangeUserName = _this$props2.onChangeUserName,
          onChangeFirstName = _this$props2.onChangeFirstName,
          onChangeLastName = _this$props2.onChangeLastName,
          onChangeEmailAddress = _this$props2.onChangeEmailAddress;


      return _react2.default.createElement(
        _Izenda6.default,
        null,
        _this.renderOrganization(),
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: 'u_textLeft' },
            _react2.default.createElement(
              'label',
              { className: 'validation required' },
              localization.getText('ACOUNT_LABEL_USER_ID')
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '9' },
            _react2.default.createElement(ValidateInput, {
              type: 'text',
              className: 'form-control',
              value: model.userName,
              onChange: onChangeUserName,
              field: 'userName',
              validations: CONSTRAINTS.userName
            })
          )
        ),
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: 'u_textLeft' },
            _react2.default.createElement(
              'label',
              { className: 'validation required' },
              localization.getText('ACOUNT_LABEL_FIRST_NAME')
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '9' },
            _react2.default.createElement(ValidateInput, {
              type: 'text',
              className: 'form-control',
              value: model.firstName,
              onChange: onChangeFirstName,
              field: 'firstName',
              validations: CONSTRAINTS.firstName
            })
          )
        ),
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: 'u_textLeft' },
            _react2.default.createElement(
              'label',
              { className: 'validation required' },
              localization.getText('ACOUNT_LABEL_LAST_NAME')
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '9' },
            _react2.default.createElement(ValidateInput, {
              type: 'text',
              className: 'form-control',
              value: model.lastName,
              onChange: onChangeLastName,
              field: 'lastName',
              validations: CONSTRAINTS.lastName
            })
          )
        ),
        _react2.default.createElement(
          _Izenda6.default.Row,
          null,
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: 'u_textLeft' },
            _react2.default.createElement(
              'label',
              null,
              localization.getText('ACOUNT_LABEL_EMAIL')
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '9' },
            _react2.default.createElement(ValidateInput, {
              type: 'text',
              className: 'form-control',
              value: model.emailAddress,
              onChange: onChangeEmailAddress,
              field: 'emailAddress',
              validations: CONSTRAINTS.emailAddress
            })
          )
        )
      );
    };

    props.checkShowOrganization(props.store);
    return _this;
  }

  /**
   * Render organization.
   */


  /**
   * Render body.
   */


  (0, _createClass3.default)(AccountInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          model = _props.store.model,
          localization = _props.localization,
          onClickNext = _props.onClickNext;

      if (!model.isCurrentStep(_Izenda8.default.STEP_KEYS.AccountInfo)) return null;

      var header = {
        component: Header,
        message: model.message,
        localization: localization
      };

      var footer = {
        component: Footer,
        onClickNext: onClickNext,
        localization: localization
      };

      if (!model.enableForEnter) {
        return _react2.default.createElement(_Izenda14.default, { show: true });
      }

      return _react2.default.createElement(
        _Izenda4.default,
        { className: 'izenda-Account-Container', header: header, footer: footer },
        this.renderBody()
      );
    }
  }]);
  return AccountInfo;
}(_react.Component)) || _class);
exports.default = AccountInfo;
module.exports = exports['default'];

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file='Izenda.ResetPassword.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1224);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2772);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2774);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2776);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPassword = (_dec = (0, _Izenda2.default)(_Izenda10.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ResetPassword, _Component);

  function ResetPassword() {
    (0, _classCallCheck3.default)(this, ResetPassword);
    return (0, _possibleConstructorReturn3.default)(this, (ResetPassword.__proto__ || (0, _getPrototypeOf2.default)(ResetPassword)).apply(this, arguments));
  }

  (0, _createClass3.default)(ResetPassword, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.updateToAccountInfoStep(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var store = this.props.store;

      return _react2.default.createElement(
        'div',
        { className: 'izenda-Account-PasswordSetup u_inlineBlock' },
        _react2.default.createElement(_Izenda4.default, { store: store }),
        _react2.default.createElement(_Izenda6.default, { store: store }),
        _react2.default.createElement(_Izenda8.default, { store: store })
      );
    }
  }]);
  return ResetPassword;
}(_react.Component)) || _class);
exports.default = ResetPassword;
module.exports = exports['default'];

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _configJson = __webpack_require__(1227);

var _configJson2 = _interopRequireDefault(_configJson);

var _Izenda = __webpack_require__(1228);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This supports to override the public path of application, for example virtual directory path.
//  In order to override the public path, the hosting page needs to set the path to window.IzendaPublicPath variable.

__webpack_require__.p = window.IzendaPublicPath || '/';
if (false) {
  var Perf = require('react-addons-perf');
  window.Perf = Perf;
}

_Izenda2.default.config(_configJson2.default);
_Izenda2.default.render(document.getElementById('izenda-root'));

exports.default = _Izenda2.default;
module.exports = exports['default'];

/***/ }),
/* 1227 */,
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(1229);

__webpack_require__(1233);

__webpack_require__(1248);

__webpack_require__(1250);

__webpack_require__(1255);

__webpack_require__(1256);

__webpack_require__(2026);

var _Izenda = __webpack_require__(1123);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2116);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2117);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2118);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2119);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2812);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2813);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2814);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2815);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2816);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2817);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SynergyRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// remove lodash add to global
_ && _.noConflict();

/**
 * The main Synergy UI object that expose to outside of library.
 */
exports.default = (0, _fp.assignAll)([_Izenda2.default, _Izenda4.default, _Izenda6.default, _Izenda8.default, _Izenda10.default, _Izenda12.default, _Izenda14.default, _Izenda16.default, _Izenda18.default, _Izenda20.default, _Izenda22.default]);
module.exports = exports['default'];

/***/ }),
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _create = __webpack_require__(442);

var _create2 = _interopRequireDefault(_create);

var _is = __webpack_require__(1239);

var _is2 = _interopRequireDefault(_is);

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="polyfill.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

if (typeof _assign2.default != 'function') {
    (function () {
        Object.assign = function (target) {
            'use strict';

            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var output = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source !== undefined && source !== null) {
                    for (var nextKey in source) {
                        if (source.hasOwnProperty(nextKey)) {
                            output[nextKey] = source[nextKey];
                        }
                    }
                }
            }
            return output;
        };
    })();
}

if (Function.prototype.name === undefined && _defineProperty2.default !== undefined) {
    Object.defineProperty(Function.prototype, 'name', {
        get: function get() {
            var funcNameRegex = /function\s([^(]{1,})\(/;
            var results = funcNameRegex.exec(this.toString());
            return results && results.length > 1 ? results[1].trim() : '';
        },
        set: function set(value) {}
    });
}

if (typeof window.CustomEvent !== 'function') {
    var CustomEvent = function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    };

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
}

if (typeof window.Map !== 'function') {
    var _Map = function _Map(iterable) {
        var _items = [];
        var _keys = [];
        var _values = [];

        // Object.is polyfill, courtesy of @WebReflection
        var is = _is2.default || function (a, b) {
            return a === b ? a !== 0 || 1 / a == 1 / b : a != a && b != b;
        };

        // More reliable indexOf, courtesy of @WebReflection
        var betterIndexOf = function betterIndexOf(value) {
            if (value != value || value === 0) {
                for (var i = this.length; i-- && !is(this[i], value);) {}
            } else {
                i = [].indexOf.call(this, value);
            }
            return i;
        };

        /**
         * MapIterator used for iterating over all entries in given map.
         *
         * @param map {Map} to iterate
         * @param kind {String} identifying what to yield. Possible values
         *      are 'keys', 'values' and 'keys+values'
         * @constructor
         */
        var MapIterator = function MapIterator(map, kind) {
            var _index = 0;

            return (0, _create2.default)({}, {
                next: {
                    value: function value() {
                        // check if index is within bounds
                        if (_index < map.items().length) {
                            switch (kind) {
                                case 'keys':
                                    return map.keys()[_index++];
                                case 'values':
                                    return map.values()[_index++];
                                case 'keys+values':
                                    return [].slice.call(map.items()[_index++]);
                                default:
                                    throw new TypeError('Invalid iterator type');
                            }
                        }
                        // TODO: make sure I'm interpreting the spec correctly here
                        throw new Error('Stop Iteration');
                    }
                },
                iterator: {
                    value: function value() {
                        return this;
                    }
                },
                toString: {
                    value: function value() {
                        return '[object Map Iterator]';
                    }
                }
            });
        };

        var _set = function _set(key, value) {
            // check if key exists and overwrite
            var index = betterIndexOf.call(_keys, key);
            if (index > -1) {
                _items[index][1] = value;
                _values[index] = value;
            } else {
                _items.push([key, value]);
                _keys.push(key);
                _values.push(value);
            }
        };

        var setItem = function setItem(item) {
            if (item.length !== 2) {
                throw new TypeError('Invalid iterable passed to Map constructor');
            }

            _set(item[0], item[1]);
        };

        // FIXME: accommodate any class that defines an @@iterator method that returns
        //      an iterator object that produces two element array-like objects
        if (Array.isArray(iterable)) {
            iterable.forEach(setItem);
        } else if (iterable !== undefined) {
            throw new TypeError('Invalid Map');
        }

        return (0, _create2.default)(MapPrototype, {
            /**
             * @return {Array} all entries in the Map, in order
             */
            items: {
                value: function value() {
                    return [].slice.call(_items);
                }
            },
            /**
             * @return {Array} all keys in the Map, in order
             */
            keys: {
                value: function value() {
                    return [].slice.call(_keys);
                }
            },
            /**
             * @return {Array} all values in the Map, in order
             */
            values: {
                value: function value() {
                    return [].slice.call(_values);
                }
            },
            /**
             * Given a key, indicate whether that key exists in this Map.
             *
             * @param key {Object} expected key
             * @return {Boolean} true if key in Map
             */
            has: {
                value: function value(key) {
                    // TODO: double-check how spec reads about null values
                    var index = betterIndexOf.call(_keys, key);
                    return index > -1;
                }
            },
            /**
             * Given a key, retrieve the value associated with that key (or undefined).
             *
             * @param key {Object}
             * @return {Object} value associated with key or undefined
             */
            get: {
                value: function value(key) {
                    var index = betterIndexOf.call(_keys, key);
                    return index > -1 ? _values[index] : undefined;
                }
            },
            /**
             * Add or overwrite entry associating key with value. Always returns undefined.
             *
             * @param key {Object} anything
             * @param value {Object} also anything
             */
            set: {
                value: _set
            },
            /**
             * Return the number of entries in this Map.
             *
             * @return {Number} number of entries
             */
            size: {
                get: function get() {
                    return _items.length;
                }
            },
            /**
             * Remove all entries in this Map. Returns undefined.
             */
            clear: {
                value: function value() {
                    _keys.length = _values.length = _items.length = 0;
                }
            },
            /**
             * Delete entry with given key, if it exists.
             *
             * @param key {Object} any possible key
             * @return {Boolean} true if an entry was deleted
             */
            'delete': {
                value: function value(key) {
                    var index = betterIndexOf.call(_keys, key);
                    if (index > -1) {
                        _keys.splice(index, 1);
                        _values.splice(index, 1);
                        _items.splice(index, 1);
                        return true;
                    }
                    return false;
                }
            },
            /**
             * Given a callback function and optional context, invoke the callback on all
             * entries in this Map.
             *
             * @param callbackFn {Function}
             */
            forEach: {
                value: function value(callbackfn /*, thisArg*/) {
                    if (typeof callbackfn != 'function') {
                        throw new TypeError('Invalid callback function given to forEach');
                    }

                    function tryNext() {
                        try {
                            return iter.next();
                        } catch (e) {
                            return undefined;
                        }
                    }

                    var iter = this.iterator();
                    var current = tryNext();
                    var next = tryNext();
                    while (current !== undefined) {
                        callbackfn.apply(arguments[1], [current[1], current[0], this]);
                        current = next;
                        next = tryNext();
                    }
                }
            },
            /**
             * Return a MapIterator object for this map.
             */
            iterator: {
                value: function value() {
                    return new MapIterator(this, 'keys+values');
                }
            },
            toString: {
                value: function value() {
                    return '[Object Map]';
                }
            }
        });
    };

    var MapPrototype = _Map.prototype;
    _Map.prototype = MapPrototype = _Map();
    window.Map = window.Map || _Map;
}

if (!String.prototype.includes) {
    Object.defineProperty(String.prototype, 'includes', {
        value: function value(search, start) {
            if (typeof start !== 'number') {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            }
            return this.indexOf(search, start) !== -1;
        }
    });
}

/***/ }),
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.BlueBirdErrorHandling.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * BlueBirdErrorHandling
 */
!function () {
  /* disabled warning on production*/
  (0, _bluebird.config)({
    // disabled all warnings
    warnings: !!false,
    cancellation: true
  });

  // suppress unhandledrejection for error have suppressUnhandledRejections
  window.addEventListener('unhandledrejection', function (e) {
    if (e.detail.reason && e.detail.reason.suppressUnhandledRejections) {
      e.preventDefault();
    }
  });
}();

/***/ }),
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(451);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(658);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1103);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1104);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.HighchartVizEngineRegistration.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

(function () {
  _Izenda2.default.registerVisualizationEngine(_Izenda8.default.Highchart, _Izenda4.default);
  _Izenda2.default.registerVisualizationEngine(_Izenda8.default.Highmap, _Izenda6.default);
})();

/***/ }),
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(55);

var _Izenda = __webpack_require__(69);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (H) {
  var WIDTH = 300;
  var HEIGHT = 200;
  var FONT_SIZE_TITLE = 10;
  var FONT_SIZE_VALUE = 13;
  var FONT_SIZE_UNIT = 8;

  var INNER_RADIUS = 100;

  var DATA_THICKNESS = 50;
  var DATA_BACKGROUND_COLOR = '#f2f2f2';
  var START_ANGLE = -90;
  var END_ANGLE = 90;

  var BASE_CHART = 'solidgauge';
  var IZENDA_CHART = 'izendaSolidGauge';

  var defaultPlotOptions = H.getOptions().plotOptions,
      baseChart = H.seriesTypes[BASE_CHART],
      wrap = H.wrap;

  defaultPlotOptions[IZENDA_CHART] = H.merge(defaultPlotOptions[BASE_CHART], {});

  H.seriesTypes[IZENDA_CHART] = H.extendClass(baseChart, {
    type: IZENDA_CHART
  });

  /** OVERRIDE HIGHCHART FUNCTION **/
  wrap(H.Chart.prototype, 'init', function (proceed, userOptions, callback) {
    var chartType = userOptions.chart.type;

    if (chartType === IZENDA_CHART) {
      userOptions = H.merge(userOptions, {
        chart: {
          margin: [FONT_SIZE_TITLE * 2, 0, 0, 0],
          spacing: [0, 0, 0, 0],
          height: HEIGHT,
          width: WIDTH
        },
        pane: {
          center: ['50%', '65%'],
          size: '85%',
          startAngle: START_ANGLE,
          endAngle: END_ANGLE,
          background: {
            backgroundColor: DATA_BACKGROUND_COLOR,
            innerRadius: '100%',
            outerRadius: 100 + DATA_THICKNESS + '%',
            shape: 'arc'
          }
        },
        plotOptions: {
          series: {
            innerRadius: '100%',
            radius: 100 + DATA_THICKNESS + '%',
            dataLabels: getDataLabelOptions((0, _fp.get)('plotOptions.series.dataLabels', userOptions))
          }
        },
        yAxis: getYaxis(userOptions.yAxis)
      });
    }

    proceed.call(this, userOptions, callback);

    function getYaxis(yAxis) {
      return {
        stops: yAxis.plotBands && yAxis.plotBands.length > 0 ? yAxis.plotBands.map(function (band) {
          return [(band.from + band.to) / (2 * Math.max(yAxis.max - yAxis.min, Math.max(band.to - band.from, 1))), band.color];
        }) : null,
        tickPositions: [yAxis.min, yAxis.max],
        innerRadius: INNER_RADIUS + '%',
        labels: getLabelOptions()
      };

      function getLabelOptions() {
        var formatter = (0, _fp.get)('yAxis.labels.formatter', userOptions);

        return {
          formatter: getFormatLabel,
          distance: 15,
          y: 20
        };

        function getFormatLabel() {
          var val = (0, _fp.isFunction)(formatter) ? formatter.call(this) : this.value;
          return String.format('<span style="font-size:{0}px">{1}</span>', FONT_SIZE_TITLE, val);
        }
      }
    }

    function getDataLabelOptions(userOptionsDataLabels) {
      var _formatter = userOptionsDataLabels.formatter;

      return {
        crop: false,
        overflow: 'none',
        enabled: true,
        useHTML: true,
        y: 0,
        borderWidth: 0,
        formatter: function formatter() {
          var point = this.point;
          var pointOpts = _Izenda2.default.getPointOptions(point);
          var pointVal = _Izenda2.default.getPointValue(point);
          var chart = this.series.chart;
          var width = chart.plotWidth / 3;
          var val = _formatter ? _formatter.apply(this, arguments) : pointVal;
          var unitLabel = (0, _fp.getOr)('', 'series.chart.options.izendaOptions.dataUnit', this);

          return String.format('<div class="solid-gauge-datalabels" style="text-align: center;width:{4}px; color:{5}">' + '<p class="value overflow-text" style="font-size:{0}px; margin:0" title="{1}">{1}</p>' + '<p class="unit overflow-text" style="font-size:{2}px; margin:0" title="{3}">{3}</span></p>', FONT_SIZE_VALUE, val, FONT_SIZE_UNIT, unitLabel, width, (0, _fp.get)('textColor', pointOpts));
        }
      };
    }
  });
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.SolidGauge.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(64);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartDefaultFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FUNCTION = _Izenda2.default.FUNCTION;
var FORMAT_KEY = _Izenda2.default.FORMAT_KEY;
var DefaultFunction = {};
var ERROR_TYPE = _Izenda2.default.ERROR_TYPE;

/* LINE CHART */
DefaultFunction[_Izenda3.CHART_TYPE.Line] = {};
// line chart - labels & separators
DefaultFunction[_Izenda3.CHART_TYPE.Line]['labels'] = DefaultFunction[_Izenda3.CHART_TYPE.Line]['separators'] = {
  Datetime: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.YEAR,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  },
  Time: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.DEFAULT_TIME,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  },
  Others: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  }
};

// line chart - values
DefaultFunction[_Izenda3.CHART_TYPE.Line]['values'] = {
  Others: {
    FUNCTION: FUNCTION.COUNT,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  }
};

// line chart - values - numeric & money
DefaultFunction[_Izenda3.CHART_TYPE.Line]['values']['Numeric'] = DefaultFunction[_Izenda3.CHART_TYPE.Line]['values']['Money'] = {
  FUNCTION: FUNCTION.SUM,
  FORMAT: FORMAT_KEY.NONE,
  ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
};

/** COLUMN, BAR, AREA, PIE, FUNNEL, DONUT, COMBINATION, TREEMAP, WATERFALL - same as Line **/
DefaultFunction[_Izenda3.CHART_TYPE.Bar] = DefaultFunction[_Izenda3.CHART_TYPE.Column] = DefaultFunction[_Izenda3.CHART_TYPE.Area] = DefaultFunction[_Izenda3.CHART_TYPE.Pie] = DefaultFunction[_Izenda3.CHART_TYPE.Funnel] = DefaultFunction[_Izenda3.CHART_TYPE.Donut] = DefaultFunction[_Izenda3.CHART_TYPE.Combination] = DefaultFunction[_Izenda3.CHART_TYPE.TreeMap] = DefaultFunction[_Izenda3.CHART_TYPE.Waterfall] = DefaultFunction[_Izenda3.CHART_TYPE.Sparkline] = DefaultFunction[_Izenda3.CHART_TYPE.Line];

/** BUBBLE - based on Line **/
DefaultFunction[_Izenda3.CHART_TYPE.Bubble] = {};

// Bubble - labels, values, bubble size - same as line - values container
DefaultFunction[_Izenda3.CHART_TYPE.Bubble]['labels'] = DefaultFunction[_Izenda3.CHART_TYPE.Bubble]['values'] = DefaultFunction[_Izenda3.CHART_TYPE.Bubble]['bubbleSize'] = {
  Numeric: {
    FUNCTION: FUNCTION.SUM,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  },
  Money: {
    FUNCTION: FUNCTION.SUM,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.ERROR_MESSAGE
  },
  Others: {
    FUNCTION: FUNCTION.COUNT,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.NOTIFY
  }
};

// Bubble - valuesLabels - same as line - labels container
DefaultFunction[_Izenda3.CHART_TYPE.Bubble]['valuesLabels'] = {
  Datetime: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.YEAR,
    ON_NULL_FUNCTION: ERROR_TYPE.NOTIFY
  },
  Time: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.DEFAULT_TIME,
    ON_NULL_FUNCTION: ERROR_TYPE.NOTIFY
  },
  Others: {
    FUNCTION: FUNCTION.GROUP,
    FORMAT: FORMAT_KEY.NONE,
    ON_NULL_FUNCTION: ERROR_TYPE.NOTIFY
  }
};

/** SCATTER - same as bubble **/
DefaultFunction[_Izenda3.CHART_TYPE.Scatter] = DefaultFunction[_Izenda3.CHART_TYPE.Bubble];

/** HEATMAP - based on Line **/
DefaultFunction[_Izenda3.CHART_TYPE.HeatMap] = {};

// Heatmap - labels, values - same as line - labels container
DefaultFunction[_Izenda3.CHART_TYPE.HeatMap]['labels'] = DefaultFunction[_Izenda3.CHART_TYPE.HeatMap]['values'] = DefaultFunction[_Izenda3.CHART_TYPE.Line]['labels'];

// Bubble - valuesLabels - same as line - values container
DefaultFunction[_Izenda3.CHART_TYPE.HeatMap]['valuesLabels'] = DefaultFunction[_Izenda3.CHART_TYPE.Line]['values'];

exports.default = DefaultFunction;
module.exports = exports['default'];

/***/ }),
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 687,
	"./af.js": 687,
	"./ar": 688,
	"./ar-dz": 689,
	"./ar-dz.js": 689,
	"./ar-kw": 690,
	"./ar-kw.js": 690,
	"./ar-ly": 691,
	"./ar-ly.js": 691,
	"./ar-ma": 692,
	"./ar-ma.js": 692,
	"./ar-sa": 693,
	"./ar-sa.js": 693,
	"./ar-tn": 694,
	"./ar-tn.js": 694,
	"./ar.js": 688,
	"./az": 695,
	"./az.js": 695,
	"./be": 696,
	"./be.js": 696,
	"./bg": 697,
	"./bg.js": 697,
	"./bm": 698,
	"./bm.js": 698,
	"./bn": 699,
	"./bn.js": 699,
	"./bo": 700,
	"./bo.js": 700,
	"./br": 701,
	"./br.js": 701,
	"./bs": 702,
	"./bs.js": 702,
	"./ca": 703,
	"./ca.js": 703,
	"./cs": 704,
	"./cs.js": 704,
	"./cv": 705,
	"./cv.js": 705,
	"./cy": 706,
	"./cy.js": 706,
	"./da": 707,
	"./da.js": 707,
	"./de": 708,
	"./de-at": 709,
	"./de-at.js": 709,
	"./de-ch": 710,
	"./de-ch.js": 710,
	"./de.js": 708,
	"./dv": 711,
	"./dv.js": 711,
	"./el": 712,
	"./el.js": 712,
	"./en-SG": 713,
	"./en-SG.js": 713,
	"./en-au": 714,
	"./en-au.js": 714,
	"./en-ca": 715,
	"./en-ca.js": 715,
	"./en-gb": 716,
	"./en-gb.js": 716,
	"./en-ie": 717,
	"./en-ie.js": 717,
	"./en-il": 718,
	"./en-il.js": 718,
	"./en-nz": 719,
	"./en-nz.js": 719,
	"./eo": 720,
	"./eo.js": 720,
	"./es": 721,
	"./es-do": 722,
	"./es-do.js": 722,
	"./es-us": 723,
	"./es-us.js": 723,
	"./es.js": 721,
	"./et": 724,
	"./et.js": 724,
	"./eu": 725,
	"./eu.js": 725,
	"./fa": 726,
	"./fa.js": 726,
	"./fi": 727,
	"./fi.js": 727,
	"./fo": 728,
	"./fo.js": 728,
	"./fr": 729,
	"./fr-ca": 730,
	"./fr-ca.js": 730,
	"./fr-ch": 731,
	"./fr-ch.js": 731,
	"./fr.js": 729,
	"./fy": 732,
	"./fy.js": 732,
	"./ga": 733,
	"./ga.js": 733,
	"./gd": 734,
	"./gd.js": 734,
	"./gl": 735,
	"./gl.js": 735,
	"./gom-latn": 736,
	"./gom-latn.js": 736,
	"./gu": 737,
	"./gu.js": 737,
	"./he": 738,
	"./he.js": 738,
	"./hi": 739,
	"./hi.js": 739,
	"./hr": 740,
	"./hr.js": 740,
	"./hu": 741,
	"./hu.js": 741,
	"./hy-am": 742,
	"./hy-am.js": 742,
	"./id": 743,
	"./id.js": 743,
	"./is": 744,
	"./is.js": 744,
	"./it": 745,
	"./it-ch": 746,
	"./it-ch.js": 746,
	"./it.js": 745,
	"./ja": 747,
	"./ja.js": 747,
	"./jv": 748,
	"./jv.js": 748,
	"./ka": 749,
	"./ka.js": 749,
	"./kk": 750,
	"./kk.js": 750,
	"./km": 751,
	"./km.js": 751,
	"./kn": 752,
	"./kn.js": 752,
	"./ko": 753,
	"./ko.js": 753,
	"./ku": 754,
	"./ku.js": 754,
	"./ky": 755,
	"./ky.js": 755,
	"./lb": 756,
	"./lb.js": 756,
	"./lo": 757,
	"./lo.js": 757,
	"./lt": 758,
	"./lt.js": 758,
	"./lv": 759,
	"./lv.js": 759,
	"./me": 760,
	"./me.js": 760,
	"./mi": 761,
	"./mi.js": 761,
	"./mk": 762,
	"./mk.js": 762,
	"./ml": 763,
	"./ml.js": 763,
	"./mn": 764,
	"./mn.js": 764,
	"./mr": 765,
	"./mr.js": 765,
	"./ms": 766,
	"./ms-my": 767,
	"./ms-my.js": 767,
	"./ms.js": 766,
	"./mt": 768,
	"./mt.js": 768,
	"./my": 769,
	"./my.js": 769,
	"./nb": 770,
	"./nb.js": 770,
	"./ne": 771,
	"./ne.js": 771,
	"./nl": 772,
	"./nl-be": 773,
	"./nl-be.js": 773,
	"./nl.js": 772,
	"./nn": 774,
	"./nn.js": 774,
	"./pa-in": 775,
	"./pa-in.js": 775,
	"./pl": 776,
	"./pl.js": 776,
	"./pt": 777,
	"./pt-br": 778,
	"./pt-br.js": 778,
	"./pt.js": 777,
	"./ro": 779,
	"./ro.js": 779,
	"./ru": 780,
	"./ru.js": 780,
	"./sd": 781,
	"./sd.js": 781,
	"./se": 782,
	"./se.js": 782,
	"./si": 783,
	"./si.js": 783,
	"./sk": 784,
	"./sk.js": 784,
	"./sl": 785,
	"./sl.js": 785,
	"./sq": 786,
	"./sq.js": 786,
	"./sr": 787,
	"./sr-cyrl": 788,
	"./sr-cyrl.js": 788,
	"./sr.js": 787,
	"./ss": 789,
	"./ss.js": 789,
	"./sv": 790,
	"./sv.js": 790,
	"./sw": 791,
	"./sw.js": 791,
	"./ta": 792,
	"./ta.js": 792,
	"./te": 793,
	"./te.js": 793,
	"./tet": 794,
	"./tet.js": 794,
	"./tg": 795,
	"./tg.js": 795,
	"./th": 796,
	"./th.js": 796,
	"./tl-ph": 797,
	"./tl-ph.js": 797,
	"./tlh": 798,
	"./tlh.js": 798,
	"./tr": 799,
	"./tr.js": 799,
	"./tzl": 800,
	"./tzl.js": 800,
	"./tzm": 801,
	"./tzm-latn": 802,
	"./tzm-latn.js": 802,
	"./tzm.js": 801,
	"./ug-cn": 803,
	"./ug-cn.js": 803,
	"./uk": 804,
	"./uk.js": 804,
	"./ur": 805,
	"./ur.js": 805,
	"./uz": 806,
	"./uz-latn": 807,
	"./uz-latn.js": 807,
	"./uz.js": 806,
	"./vi": 808,
	"./vi.js": 808,
	"./x-pseudo": 809,
	"./x-pseudo.js": 809,
	"./yo": 810,
	"./yo.js": 810,
	"./zh-cn": 811,
	"./zh-cn.js": 811,
	"./zh-hk": 812,
	"./zh-hk.js": 812,
	"./zh-tw": 813,
	"./zh-tw.js": 813
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1397;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityQuestion.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      pick = _require.pick,
      isEqual = _require.isEqual,
      find = _require.find;

  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);

  function SecurityQuestion(data, questions) {
    this.questions = questions;

    var props = {
      // DTO
      securityQuestionId: null,
      answer: null,

      // Computed
      question: function () {
        var matchingQuestion = find(function (item) {
          return isEqual(item.securityQuestionId, this.securityQuestionId);
        }.bind(this), this.questions);

        if (!isNil(matchingQuestion)) {
          return matchingQuestion.question;
        }
      }.bind(this),

      remainingQuestionList: []
    };

    m.extendObservable(trackable(this), props);
    data && this.populate(data);
  }

  SecurityQuestion.prototype.populate = m.action(function (data) {
    this.securityQuestionId = data.securityQuestionId || data.id;
    this.answer = data.answer;
  });

  SecurityQuestion.prototype.buildDataForSaving = function () {
    return pick(['securityQuestionId', 'answer'], this);
  };

  SecurityQuestion.prototype.updateProperty = function (key, value) {
    this[key] = value;
    this.markDirty();
  };

  module.exports = SecurityQuestion;
}();

/***/ }),
/* 1399 */,
/* 1400 */,
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.UrlMonitor.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

(function (w, $izenda) {
  var UrlHashMonitor = {};
  UrlHashMonitor.oldHash = '';
  UrlHashMonitor.newHash = '';
  UrlHashMonitor.oldHref = '';
  UrlHashMonitor.newHref = '';
  UrlHashMonitor.onHashChange = function (f) {
    $izenda(window).on('hashchange', function (e) {
      UrlHashMonitor.oldHash = UrlHashMonitor.newHash;
      UrlHashMonitor.newHash = w.location.hash;
      UrlHashMonitor.oldHref = UrlHashMonitor.newHref;
      UrlHashMonitor.newHref = w.location.href;
      f(e);
    });
  };
  UrlHashMonitor.init = function () {
    UrlHashMonitor.oldHash = UrlHashMonitor.newHash = w.location.hash;
    UrlHashMonitor.oldHref = UrlHashMonitor.newHref = w.location.href;
  };
  w.UrlHashMonitor = UrlHashMonitor;
  return UrlHashMonitor;
})(window, $izenda);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  // We need to generate an unit name for displayName in case of opening Sub popup (a popup is oppned in parent popup)
  var name = (0, _fp.uniqueId)('ReportViewerPopup_');
  var Comp = (0, _recompose.setDisplayName)(name)((0, _Izenda4.default)(_Izenda6.default)(ReportViewerPopup));
  // popupName is a key that help we get displayName. We need this key get display name in case of minimize code
  Comp.$popupName = name;
  return Comp;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1489);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(50);

var _Izenda8 = __webpack_require__(501);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerPopup.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function ReportViewerPopup(_ref) {
  var localization = _ref.localization,
      onClosing = _ref.onClosing,
      queryObject = _ref.queryObject,
      reportId = _ref.reportId;

  var style = {
    width: _Izenda7.SUBREPORT_POPUP.frameWidthInPercent,
    height: _Izenda7.SUBREPORT_POPUP.frameHeightInPx
  };

  return _react2.default.createElement(
    _Izenda2.default,
    { visible: true, onClosing: onClosing, type: 'none', autoClose: false, sizeClass: 'modal-lg' },
    _react2.default.createElement(_Izenda2.default.Header, { title: _Izenda7.SUBREPORT_POPUP.popupTitle }),
    _react2.default.createElement(
      _Izenda2.default.Body,
      null,
      _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(_Izenda9.default, { hideGridPopup: true, hideHeaderFooter: true, id: reportId, queryObject: queryObject })
      )
    ),
    _react2.default.createElement(
      _Izenda2.default.Footer,
      null,
      _react2.default.createElement(
        _Izenda2.default.ConfirmationButton,
        { type: 'accept' },
        localization.getText('COMMON_LABEL_OK')
      )
    )
  );
}

module.exports = exports['default'];

/***/ }),
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectContextToProps.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var AppContext = __webpack_require__(179);
  var getContext = __webpack_require__(9).getContext;

  var toProps = getContext(AppContext.createAppContextShape());
  module.exports = toProps;
}();

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PageService.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      concat = _require.concat;

  var LoadingManager = __webpack_require__(207);

  function PageService() {
    this.loadingCounter = 0;
    this.notifyLoadingChanged = null;
  }

  PageService.prototype.startLoading = function () {
    var old = this.loadingCounter++;
    if (old === 0) {
      LoadingManager.addLoadingWatcher(this);
      this.notifyLoadingChanged && this.notifyLoadingChanged.apply(null, concat([true], arguments));
    }
  };

  PageService.prototype.endLoading = function () {
    var old = this.loadingCounter;
    this.loadingCounter && --this.loadingCounter;
    if (old === 1) {
      LoadingManager.removeLoadingWatcher(this);
      this.notifyLoadingChanged && this.notifyLoadingChanged.apply(null, concat([false], arguments));
    }
  };

  PageService.prototype.registerLoadingChanged = function (func) {
    this.notifyLoadingChanged = func;
    return function () {
      delete this.notifyLoadingChanged;
    }.bind(this);
  };

  module.exports = PageService;
}();

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ValidationManager.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  __webpack_require__(55);
  var defaultStrategy = __webpack_require__(1479);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isArray = _require.isArray,
      isEmpty = _require.isEmpty,
      forEach = _require.forEach,
      invoke = _require.invoke,
      map = _require.map,
      get = _require.get,
      isNil = _require.isNil,
      toLower = _require.toLower,
      placeholder = _require.placeholder;

  function ValidationManager(validatorStrategy) {
    this.validatorStrategy = validatorStrategy || defaultStrategy;
    this.components = [];
    this.modelErrors = [];
  }

  ValidationManager.prototype.attachComponent = function (component) {
    if (this.components.indexOf(component) < 0) {
      this.components.push(component);
    }
  };

  ValidationManager.prototype.detachComponent = function (component) {
    var idx = this.components.indexOf(component);
    this.components.splice(idx, 1);
  };

  ValidationManager.prototype.validate = function (field, group) {
    var coms = filter(function (com) {
      return (!field || !isArray(field) && com.props.field === field || isArray(field) && field.indexOf(com.props.field) > -1) && (!group || com.props.group === group);
    }, this.components);

    if (isEmpty(coms)) {
      (0, _bluebird.resolve)(true);
    }

    var strategy = this.validatorStrategy;
    var maps = {
      attributes: {},
      rules: {}
    };
    var computeKey = this.getKey;
    var vals = placeholder(coms).chain().map(function (com) {
      return {
        key: computeKey(com),
        value: com.getValue(),
        rules: strategy.parseRules(com.props.validations)
      };
    }).reduce(function (rulesMap, keyedRules) {
      rulesMap.rules[keyedRules.key] = keyedRules.rules;
      rulesMap.attributes[keyedRules.key] = keyedRules.value;

      return rulesMap;
    }, maps).value();

    return strategy.validate(vals.attributes, vals.rules).then(function () {
      forEach(invoke('setSuccess'), coms);
      return true;
    }, function (errors) {
      var valErrors = strategy.parseErrors(errors);
      if (field) {
        coms.map(function (com) {
          var key = computeKey(com);
          valErrors[key] && com.setError(valErrors[key]);
        });
      } else {
        placeholder(coms).chain().map(function (com) {
          var key = computeKey(com);
          return {
            msg: valErrors[key],
            com: com
          };
        }).forEach(function (item) {
          item.msg ? item.com.setError(item.msg) : item.com.setSuccess();
        }).commit();
      }

      return false;
    });
  };

  ValidationManager.prototype.getFieldValue = function (field, group) {
    ensure(field, 'Field name must be defined');

    var com = placeholder(this.components).chain().filter(['props.group', group]).find(['props.field', field]).value();

    ensure(com, 'Cannot find component that holds value of field %s', field);

    return com.getValue();
  };

  /**
   * Update validators by errors from outside (normally it comes from API)
   * @param  {Array} errors Errors
   */
  ValidationManager.prototype.updateErrors = function (errors) {
    if (!errors) {
      return;
    }

    var computeKey = this.getKey;

    // Update model errors that don't have key value
    this.setModelErrors(filter(function (err) {
      return isNil(err.key) || isEmpty(err.key);
    }, errors));

    // Update error by group and field
    placeholder(this.components).chain().map(function (com) {
      var comErrors = filter(function (err) {
        var errorKey = String.hashKeyId(err.key);
        return com.props.group && toLower(errorKey) === toLower(com.props.group) || toLower(errorKey) === toLower(computeKey(com));
      }, errors);
      return {
        errors: comErrors,
        component: com
      };
    }).filter(function (errCom) {
      return !isEmpty(errCom.errors);
    }).forEach(function (errCom) {
      errCom.component.setError(errCom.errors);
    }).commit();
  };

  /**
   * Get computed key of component
   * @param  {Object} component React component
   * @return {String}           Key string
   */
  ValidationManager.prototype.getKey = function (component) {
    return String.hashKeyId((component.props.group ? component.props.group + '.' : '') + component.props.field);
  };

  ValidationManager.prototype.setModelErrors = function (errors) {
    this.modelErrors = errors;
  };

  /**
   * Reset field or group components to pristine state
   * @param {String} field Validation field
   * @param {String} group Validation group
   */
  ValidationManager.prototype.reset = function (field, group) {
    placeholder(this.components).chain().filter(function (com) {
      return !group || com.props.group === group;
    }).filter(function (com) {
      return !field || com.props.field === field;
    }).forEach(invoke('setPristine')).commit();
  };

  /**
   * Notify field or group components that their value has been changed,
   * but unvalidated.
   * @param {String} field Validation field
   * @param {String} group Validation group
   */
  ValidationManager.prototype.unvalidatedChange = function (field, group) {
    placeholder(this.components).chain().filter(function (com) {
      return !group || com.props.group === group;
    }).filter(function (com) {
      return !field || com.props.field === field;
    }).forEach(invoke('setUnvalidatedChange')).commit();
  };

  module.exports = ValidationManager;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ValidateStrategy.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _validate = __webpack_require__(500);
  var ValidationErrors = __webpack_require__(1480);

  module.exports = {
    parseRules: function parseRules(rules) {
      return rules;
    },
    parseErrors: function parseErrors(valErrors) {
      return valErrors.errors;
    },
    validate: function validate(attributes, rules) {
      var extraOptions = {
        fullMessages: false,
        wrapErrors: ValidationErrors,
        cleanAttributes: false
      };

      return _validate.async(attributes, rules, extraOptions);
    }
  };
}();

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function () {
  'use strict';

  var _require = __webpack_require__(1),
      create = _require.create;
  /**
   * Error object for validation. It derives Error object. It is used for wrapping
   * validation errors in an Error object to avoid warning of bluebirdjs Promise
   * resolving. If not, Bluebirdjs complaints a Promise has been rejected by
   * non Error object.
   * @param {Array} errors An error array.
   */


  function ValidationErrors(errors) {
    this.errors = errors;
  }
  ValidationErrors.prototype = create(Error.prototype, {
    constructor: ValidationErrors
  });

  module.exports = ValidationErrors;
}();

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.DialogService.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var DialogNode = __webpack_require__(1482);
  var extendObservable = __webpack_require__(5).extendObservable;

  var _require = __webpack_require__(1),
      last = _require.last,
      isNil = _require.isNil;

  function DialogService() {
    this.names = [];
    extendObservable(this, {
      child: null
    });
  }

  DialogService.prototype.registerDialog = function (name, dialogType, props) {
    ensure(this.names.indexOf(name) < 0, '%s dialog already existed', name);

    var parentName = last(this.names);
    var parent = getDialogNode(this, parentName);

    this.names.push(name);
    var level = this.names.length;

    parent.child = new DialogNode(name, dialogType, level, props);
  };

  DialogService.prototype.createUnregister = function (name) {
    return function unregister() {
      var currentDialogIndex = this.names.indexOf(name);
      if (currentDialogIndex <= 0) {
        this.child = null;
      } else {
        var parent = getDialogNode(this, this.names[currentDialogIndex - 1]);
        parent.child = null;
      }
      this.names.splice(currentDialogIndex);
    }.bind(this);
  };

  DialogService.prototype.reset = function () {
    this.names = [];
    this.child = null;
  };

  function getDialogNode(node, name) {
    if (isNil(name)) {
      return node;
    }

    var current = node.child;
    while (current && current.info.name !== name) {
      current = current.child;
    }

    return current;
  }

  module.exports = DialogService;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DialogNode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var DialogInfo = __webpack_require__(1483);
  var extendObservable = __webpack_require__(5).extendObservable;

  function DialogNode(name, type, level, props) {
    extendObservable(this, {
      info: new DialogInfo(name, type, level, props),
      child: null
    });
  }

  module.exports = DialogNode;
}();

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DialogInfo.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var extendObservable = __webpack_require__(5).extendObservable;

  function DialogInfo(name, type, level, props) {
    this.props = props;
    extendObservable(this, {
      name: name,
      type: type,
      level: level // level of node in dialog hierarchy.
    });
  }

  module.exports = DialogInfo;
}();

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportPageService.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  function ExportPageService() {
    this.addExportLoading = null;
    this.removeExportLoading = null;
  }

  /**
   * Register export loading indicator
   * @param {object}  addFunc
   * @param {object}  removeFunc
   * @returns {object}
   */
  ExportPageService.prototype.registerExportLoadingChanged = function (addFunc, removeFunc, updateErrorFunc) {
    this.addExportLoading = addFunc;
    this.removeExportLoading = removeFunc;
    this.updateError = updateErrorFunc;
    return function () {
      delete this.addExportLoading;
      delete this.removeExportLoading;
      delete this.updateError;
    }.bind(this);
  };

  /**
   * Start export loading indicator
   * @param {object}  exportFile
   */
  ExportPageService.prototype.startExportLoading = function (exportFile) {
    this.addExportLoading(exportFile);
  };

  /**
   * Start export loading indicator
   * @param {string}  fileName
   */
  ExportPageService.prototype.endExportLoading = function (fileName) {
    this.removeExportLoading(fileName);
  };

  /**
   * Update error for loading indicator
   * @param {string}  fileName
   */
  ExportPageService.prototype.updateError = function (fileName) {
    this.updateError(fileName);
  };

  module.exports = ExportPageService;
}();

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _Izenda = __webpack_require__(843);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1486);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _recompose = __webpack_require__(9);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIRMATION = 'Confirmation';
// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var dialogActions = {
  confirmFn: function confirmFn(props) {
    return function (message, options) {
      return _confirmFn(props.dialogs, message, options);
    };
  },

  confirmDirtyForm: function confirmDirtyForm(props) {
    return function (isDirty, options) {
      if (!isDirty) {
        return (0, _bluebird.resolve)();
      }

      var description = (0, _fp.get)('customMessage', options) || _Izenda6.default.dirtyMessage;
      var confirmHandle = (0, _fp.get)('onConfirmDirtyForm', options) || _fp.identity;
      return _confirmFn(props.dialogs, 'Confirmation', { description: description }).then(confirmHandle);
    };
  },

  confirmMessage: function confirmMessage(props) {
    return function (type, message) {
      return _confirmFn(props.dialogs, 'Information', {
        type: type,
        description: message,
        showCancel: false,
        showCloseIndicator: true
      });
    };
  },

  openPopup: function openPopup(props) {
    return function (type, dialogOptions) {
      return _openPopup(props.dialogs, type, dialogOptions);
    };
  }
};

/**
 * Register a confirm popup
 * @param {Object} dialogs
 * @param {string} message
 * @param {Object} options
 * @returns {Promise}
 */
function _confirmFn(dialogs, message, options) {
  var unregister = dialogs.createUnregister(CONFIRMATION);
  var confirmPromise = new _bluebird2.default(function (resolve, reject) {
    var confirmOpts = (0, _fp.assign)({
      message: message,
      onAccept: resolve,
      onReject: function onReject() {
        reject(new _Izenda2.default());
      }
    }, options || {});

    dialogs.registerDialog(CONFIRMATION, _Izenda4.default, confirmOpts);
  }).finally(unregister);

  return confirmPromise;
}

/**
 * Register a popup
 * @param {Object} dialogs
 * @param {Object} type
 * @param {Object} options
 * @returns {Promise}
 */
function _openPopup(dialogs, type, options) {
  ensure(!options || !(options.onAccept || options.onReject), 'onAccept and onReject properties is reserved for popup closing');

  var displayName = type.displayName || type.$popupName || type.name || (typeof type === 'string' ? type : 'Component');

  var unregister = dialogs.createUnregister(displayName);

  var popupPromise = new _bluebird2.default(function (resolve, reject) {
    var popupOpts = (0, _fp.assign)({
      onAccept: resolve,
      onReject: function onReject() {
        reject(new _Izenda2.default());
      }
    }, options || {});
    dialogs.registerDialog(displayName, type, popupOpts);
  }).finally(unregister);

  return popupPromise;
}

exports.default = (0, _recompose.withHandlers)(dialogActions);
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Confirmation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module: Confirmation Component
 *  <Confirmation showCancel={true|false} 
 *    type={'confirm'|'warning'|'error'} 
 *    message='This is the title' 
 *    description='This is description of confirm' >
 *  </Confirmation>
 *
 */
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var Popup = __webpack_require__(36);
  var classnames = __webpack_require__(11);
  var commonMessages = __webpack_require__(37);
  var localizer = __webpack_require__(12);

  var CONFIRMATION_MESSAGE_MAX_LENGTH = 1000;

  var _require = __webpack_require__(1),
      noop = _require.noop,
      isNil = _require.isNil,
      isFunction = _require.isFunction,
      truncate = _require.truncate;

  var Confirmation = React.createClass({
    displayName: 'Confirmation',

    propTypes: {
      confirmLabel: React.PropTypes.string,
      abortLabel: React.PropTypes.string,
      showCancel: React.PropTypes.bool,
      type: React.PropTypes.string,
      showCloseIndicator: React.PropTypes.bool,
      onAccept: React.PropTypes.func.isRequired,
      onReject: React.PropTypes.func.isRequired,
      style: React.PropTypes.object
    },
    getDefaultProps: function getDefaultProps() {
      return {
        confirmLabel: null,
        abortLabel: null,
        showCancel: true,
        type: 'confirm',
        showCloseIndicator: false,
        onAccept: noop,
        onReject: noop,
        isHTMLFormat: false
      };
    },

    componentDidMount: function componentDidMount() {
      var type = this.props.type;
      if (type !== commonMessages.MESSAGE_TYPE.INFO && type !== commonMessages.MESSAGE_TYPE.ERROR && type !== commonMessages.MESSAGE_TYPE.WARNING) {
        this.props.showCancel ? ReactDOM.findDOMNode(this.refs.cancelButton).focus() : ReactDOM.findDOMNode(this.refs.acceptButton).focus();
      }
      window.onkeyup = this.onEscape;
    },

    componentWillUnmount: function componentWillUnmount() {
      window.onkeyup = null;
    },

    rawMarkup: function rawMarkup(string) {
      return { __html: string };
    },

    onPopupClosed: function onPopupClosed(type) {
      if (type === 'accept' && isFunction(this.props.onAccept)) {
        this.props.onAccept();
      } else if (type === 'cancel' && isFunction(this.props.onReject)) {
        this.props.onReject();
      }
    },

    onPopupAccept: function onPopupAccept() {
      this.onPopupClosed('accept');
    },

    onEscape: function onEscape(e) {
      e.keyCode === 27 && this.onPopupClosed('cancel');
      e.keyCode === 13 && this.onPopupClosed('accept');
    },

    render: function render() {
      var renderCloseIndicator = function () {
        var classes = classnames('icon-cancel', 'close-indicator');
        if (this.props.showCloseIndicator) {
          return React.createElement(
            'div',
            { className: 'izenda-Confirmation-close' },
            React.createElement('span', { onClick: this.onPopupAccept, className: classes })
          );
        }
        return null;
      }.bind(this);

      var renderMessageBody = function () {
        var description = this.props.description;
        var isHTMLFormat = this.props.isHTMLFormat;

        if (isHTMLFormat) {
          return React.createElement(
            'div',
            { className: 'izenda-Confirmation-content description' },
            React.createElement('div', { dangerouslySetInnerHTML: this.rawMarkup(description) })
          );
        } else {
          var descriptionTruncate = truncate({
            length: CONFIRMATION_MESSAGE_MAX_LENGTH,
            separator: ' ',
            omission: '...'
          }, description);

          return React.createElement(
            'div',
            { className: 'izenda-Confirmation-content' },
            React.createElement(
              'span',
              { title: description, className: 'u_textBreak' },
              descriptionTruncate
            )
          );
        }
      }.bind(this);

      var iconMessageClass = classnames('confirm-message-icon', {
        'icon-help-circled confirm': this.props.type === 'confirm',
        'icon-attention-circled warning': this.props.type === commonMessages.MESSAGE_TYPE.WARNING,
        // 'icon-info-circled info': this.props.type === commonMessages.MESSAGE_TYPE.INFO,
        'icon-info-circled info': this.props.type === commonMessages.MESSAGE_TYPE.INFO_ACCEPT,
        'icon-error-circled error': this.props.type === commonMessages.MESSAGE_TYPE.ERROR
      });

      return React.createElement(
        Popup,
        { visible: true, onClosed: this.onPopupClosed, type: this.props.type, style: this.props.style },
        React.createElement(
          Popup.Body,
          null,
          React.createElement(
            'div',
            { className: 'izenda-Confirmation' },
            React.createElement(
              'div',
              { className: 'izenda-Confirmation-icon' },
              React.createElement('span', { className: iconMessageClass })
            ),
            renderMessageBody(),
            renderCloseIndicator()
          )
        ),
        this.renderFooter()
      );
    },

    renderFooter: function renderFooter() {
      var props = this.props;
      var confirmLabel = isNil(props.confirmLabel) ? localizer.getText('COMMON_LABEL_OK') : props.confirmLabel;
      var abortLabel = isNil(props.abortLabel) ? localizer.getText('COMMON_LABEL_CANCEL') : props.abortLabel;

      var renderAccept = function () {
        if (!this.props.showCloseIndicator) {
          return React.createElement(
            Popup.ConfirmationButton,
            { ref: 'acceptButton', type: 'accept' },
            confirmLabel
          );
        }
        return null;
      }.bind(this);

      var renderCancel = function () {
        if (this.props.showCancel) {
          return React.createElement(
            Popup.ConfirmationButton,
            { ref: 'cancelButton', type: 'cancel' },
            abortLabel
          );
        }
        return null;
      }.bind(this);

      var type = this.props.type;
      if (type !== commonMessages.MESSAGE_TYPE.INFO && type !== commonMessages.MESSAGE_TYPE.ERROR) {
        return React.createElement(
          Popup.Footer,
          null,
          renderAccept(),
          renderCancel()
        );
      }
      return null;
    }
  });

  module.exports = Confirmation;
}();

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Authorization.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var RouteUtils = __webpack_require__(31);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      isFunction = _require.isFunction;

  function Authorization(keys, onAuth, BaseComponent) {
    var AuthorizationComponent = React.createClass({
      displayName: 'AuthorizationComponent',

      contextTypes: {
        authorization: React.PropTypes.oneOfType([React.PropTypes.array, React.PropTypes.object])
      },

      componentWillMount: function componentWillMount() {
        var hasPrivilege = this.context.authorization.checkPrivileges(keys);
        if (!isFunction(onAuth)) {
          if (!isNil(hasPrivilege) && !hasPrivilege) {
            this.hasNoPermission = true;
            this.props.router.push(RouteUtils.getNoPermissionUrl());
          }
        } else {
          onAuth.call(null, hasPrivilege);
        }
      },

      render: function render() {
        return !this.hasNoPermission && React.createElement(BaseComponent, this.props);
      }
    });

    return observer(AuthorizationComponent);
  }

  module.exports = Authorization;
}();

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseChecker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var RouteUtils = __webpack_require__(31);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      isFunction = _require.isFunction;

  function LicenseChecker(licenseKey, onLicense, BaseComponent) {
    var LicenseCheckerComponent = React.createClass({
      displayName: 'LicenseCheckerComponent',

      contextTypes: {
        authorization: React.PropTypes.object.isRequired
      },

      componentWillMount: function componentWillMount() {
        var hasLicense = this.context.authorization.checkLicense(licenseKey);

        if (!isFunction(onLicense)) {
          if (!isNil(hasLicense) && !hasLicense) {
            this.hasNoLicense = true;
            this.props.router.push(RouteUtils.getNoPermissionUrl());
          }
        } else {
          onLicense.call(null, hasLicense);
        }
      },

      render: function render() {
        return !this.hasNoLicense && React.createElement(BaseComponent, this.props);
      }
    });

    return observer(LicenseCheckerComponent);
  }

  module.exports = LicenseChecker;
}();

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportViewerPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var PropTypes = __webpack_require__(0).PropTypes;
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var reportViewerPopupActions = compose(withHandlers({
    onClosing: curry(onClosing),
    onIFrameLoad: curry(onIFrameLoad)
  }));
  /**
   * Handle close action.
   * @param  {Object} props
   * @param  {Object} _
   */
  function onClosing(props, _) {
    props.loader.endLoading();
    return props.onAccept();
  }

  /**
   * Handle onLoad of iframe.
   * @param  {Object} props
   * @param  {Object} _
   */
  function onIFrameLoad(props, _) {
    props.loader.endLoading();
  }

  module.exports = reportViewerPopupActions;
}();

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Body Content component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(299);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(301);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(83);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(853);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(977);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportBodyContent = (_dec = (0, _Izenda2.default)(_Izenda8.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ReportBodyContent, _Component);

  function ReportBodyContent() {
    (0, _classCallCheck3.default)(this, ReportBodyContent);
    return (0, _possibleConstructorReturn3.default)(this, (ReportBodyContent.__proto__ || (0, _getPrototypeOf2.default)(ReportBodyContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportBodyContent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.layoutStore = new _Izenda12.default(null, // width,
      true, // fullSize,
      false, // infinityRows,
      false // infinityCols
      );
      this.initReportParts(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextReportParts = this.getReportParts(nextProps);

      this.reportParts.length !== nextReportParts.length && this.initReportParts(nextProps);
    }
  }, {
    key: 'getReportParts',
    value: function getReportParts(props) {
      var store = props.store;
      var reportBody = store.reportBody;

      return reportBody.activeReportParts;
    }
  }, {
    key: 'initReportParts',
    value: function initReportParts(props) {
      this.reportParts = this.getReportParts(props);

      if (props.printingMode && props.doesBreakPage) {
        // Order by position Y and then X
        this.reportParts = (0, _fp.placeholder)(this.reportParts.slice()).sortBy(['positionY', 'positionX']).value();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = props.store;

      var snapToGrid = store.reportBody.snapToGrid;
      var layoutStore = this.layoutStore;
      var layoutData = this.reportParts.map(function (item) {
        return {
          id: item.id,
          x: item.positionX,
          y: item.positionY,
          width: item.width,
          height: item.height,
          isFullSize: false,
          autoSize: item.autoSize
        };
      });

      return _react2.default.createElement(
        'div',
        { className: 'report-body' },
        _react2.default.createElement(
          _Izenda4.default,
          {
            className: 'report-body-grid u_fullSize',
            ref: 'gridView',
            printingMode: props.printingMode,
            editable: !props.viewMode,
            layoutStore: layoutStore,
            layoutData: layoutData,
            snapToGrid: snapToGrid
          },
          this.renderListReportPart()
        )
      );
    }
  }, {
    key: 'renderListReportPart',
    value: function renderListReportPart() {
      var _this2 = this;

      var props = this.props;
      var store = props.store;
      var printingMode = props.printingMode;
      var hideGridPopup = props.hideGridPopup;
      var doesBreakPage = props.doesBreakPage;
      var renderListeners = props.renderListeners;

      return this.reportParts.map(function (item, index) {
        var renderListener = (0, _fp.find)(function (listener) {
          return listener.partId === item.id;
        }, renderListeners);

        return _react2.default.createElement(
          _Izenda6.default,
          {
            key: item.id,
            id: item.id,
            printingMode: printingMode,
            isDraggable: false,
            isResizable: !item.autoSize,
            doesBreakPage: doesBreakPage,
            isFirstItem: index === 0
          },
          _react2.default.createElement(_Izenda10.default, {
            isSnapEditOn: _this2.layoutStore.isSnapEditOn,
            gridItem: item,
            store: store,
            hideGridPopup: hideGridPopup,
            autoSize: item.autoSize,
            viewMode: props.viewMode,
            printingMode: printingMode,
            setting: props.setting,
            pageBreakAfterReportPart: props.pageBreakAfterReportPart,
            doesBreakPage: props.doesBreakPage,
            exportFormatSetting: props.exportFormatSetting,
            finishedRender: renderListener && renderListener.resolve,
            isFirstReportPart: index === 0,
            isLastReportPart: index === _this2.reportParts.length - 1
          })
        );
      });
    }
  }]);
  return ReportBodyContent;
}(_react.Component)) || _class);
exports.default = ReportBodyContent;
module.exports = exports['default'];

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GridLines.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GridLayout component
 */
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ReactDOM = __webpack_require__(32);
  var GridCellState = __webpack_require__(1492);

  var query = __webpack_require__(844);
  var autorun = __webpack_require__(5).autorun;
  var observer = __webpack_require__(10).observer;
  var observablePropTypes = __webpack_require__(10).propTypes;

  /**
   * Component to paint grid layout lines and hover cell
   * @type {GridLines}
   */
  var GridLines = React.createClass({
    displayName: 'GridLines',

    /**
     * Grid cell state
     * @type {GridCellState}
     */
    cellState: null,
    propTypes: {
      layoutStore: observablePropTypes.observableObject,
      // Allow user to insert a grid item inline
      allowAddInline: React.PropTypes.bool,
      // Function to call when user adds a grid item.
      onAddItem: React.PropTypes.func,
      transparent: React.PropTypes.bool
    },
    defaultProps: {
      transparent: false
    },
    componentWillMount: function componentWillMount() {
      var layoutStore = this.props.layoutStore;
      this.cellState = new GridCellState(layoutStore.cellWidth, layoutStore.cellHeight, this.props.transparent);

      this.disposeAutoRunWidth = autorun(function () {
        this.cellState.updateDimension(this.props.layoutStore.cellWidth, this.props.layoutStore.cellHeight);
      }.bind(this));

      this.disposeAutoRunTransparent = autorun(function () {
        this.cellState.setTransparent(this.props.layoutStore.transparent);
      }.bind(this));
    },
    componentDidMount: function componentDidMount() {
      this.listen();
    },
    componentWillUnmount: function componentWillUnmount() {
      this.unlisten();
      this.disposeAutoRunWidth();
      this.disposeAutoRunTransparent();
    },
    render: function render() {
      var props = this.props;
      var layoutStore = props.layoutStore;
      var size = layoutStore.calcActualGridSize();
      var cellState = this.cellState;
      var allowAddInline = props.allowAddInline;
      var isInteracting = layoutStore.isInteracting;

      var gridLineStyle = cellState.getCellLineStyle(size.width, size.height);
      var addButtonCellStyle = cellState.getAddButtonCellStyle();

      // Only show add button when grid view allows adding inline and not be in
      // moving state and mouse hover.
      var addButtonCell = allowAddInline && !isInteracting && this.cellState.isHover ? React.createElement(
        'div',
        { className: 'grid-cell', style: addButtonCellStyle },
        React.createElement(
          'button',
          {
            type: 'button',
            className: 'btn AddItemButton',
            onClick: this.onAddItem },
          React.createElement('span', { className: 'icon-plus' })
        )
      ) : null;

      return React.createElement(
        'div',
        { ref: 'gridLines', className: 'GridLine', style: gridLineStyle },
        props.children,
        addButtonCell
      );
    },
    /**
     * Register the component DOM's event handlers.
     */
    listen: function listen() {
      var node = this.refs.gridLines;
      if (this.props.allowAddInline) {
        node.addEventListener("mousemove", this.onMouseMove, false);
        node.addEventListener("mouseleave", this.onMouseLeave, false);
      }
    },
    /**
     * Unregister the component DOM's event handlers
     */
    unlisten: function unlisten() {
      var node = this.refs.gridLines;
      if (this.props.allowAddInline) {
        node.removeEventListener("mousemove", this.onMouseMove, false);
        node.removeEventListener("mouseleave", this.onMouseLeave, false);
      }
    },
    /**
     * Handle mouse move event to update the hover cell state
     */
    onMouseMove: function onMouseMove(e) {
      if (!this.props.isMoving) {
        var offset = query.offset(this.refs.gridLines);
        var x = e.pageX - offset.left;
        var y = e.pageY - offset.top;
        if (!this.cellState.isCurrentCell(x, y)) {
          this.cellState.onPosition(x, y, true /*is hover*/);
        }
      }
    },
    /**
     * Handle mouse leave event to update the hover cell state
     */
    onMouseLeave: function onMouseLeave(e) {
      if (!this.props.isMoving) {
        this.cellState.resetPosition();
      }
    },
    /**
     * Call adding grid item
     */
    onAddItem: function onAddItem() {
      var props = this.props;
      var cellPos = this.cellState.getHoverCellPosition();

      var spare = props.layoutStore.addItemAt(cellPos.x, cellPos.y);

      props.onAddItem && props.onAddItem(spare);
    }
  });

  module.exports = observer(GridLines);
}();

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GridCellState.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var action = __webpack_require__(5).action;
  var extendObservable = __webpack_require__(5).extendObservable;

  var _require = __webpack_require__(1),
      floor = _require.floor;

  function GridCellState(cellWidth, cellHeight, transparent) {
    extendObservable(this, {
      cellWidth: cellWidth,
      cellHeight: cellHeight,
      hoverCellTop: -1,
      hoverCellLeft: -1,
      isHover: false,
      transparent: !!transparent
    });
  }

  GridCellState.prototype.setTransparent = action(function (transparent) {
    this.transparent = !!transparent;
  });

  GridCellState.prototype.updateDimension = action(function (cellWidth, cellHeight) {
    this.cellWidth = cellWidth;
    this.cellHeight = cellHeight;
  });

  GridCellState.prototype.getCellLineStyle = function (width, height) {
    return {
      height: height,
      width: width,
      backgroundSize: String.format('{0}px {1}px, {0}px {1}px', this.cellWidth, this.cellHeight),
      backgroundColor: this.transparent ? 'transparent' : undefined
    };
  };

  GridCellState.prototype.getAddButtonCellStyle = function () {
    return {
      width: this.cellWidth + 'px',
      height: this.cellHeight + 'px',
      left: this.hoverCellLeft + 'px',
      top: this.hoverCellTop + 'px',
      position: 'absolute',
      display: this.isHover ? 'block' : 'none'
    };
  };

  GridCellState.prototype.resetPosition = action(function () {
    this.hoverCellLeft = -1;
    this.hoverCellTop = -1;
    this.isHover = false;
  });

  GridCellState.prototype.onPosition = action(function (x, y, hover) {
    var snappedPos = this.snapToCellGrid(x, y);

    this.hoverCellLeft = snappedPos.x;
    this.hoverCellTop = snappedPos.y;
    this.isHover = hover;
  });

  /**
   * Get position of hover cell in grid scale
   */
  GridCellState.prototype.getHoverCellPosition = function () {
    return {
      x: floor(this.hoverCellLeft / this.cellWidth),
      y: floor(this.hoverCellTop / this.cellHeight)
    };
  };

  GridCellState.prototype.snapToCellGrid = function (x, y) {
    var slackX = this.cellWidth > 0 ? x % this.cellWidth : x;
    var slackY = this.cellHeight > 0 ? y % this.cellHeight : y;
    return {
      x: x - slackX,
      y: y - slackY
    };
  };

  GridCellState.prototype.isCurrentCell = function (x, y) {
    var snappedPos = this.snapToCellGrid(x, y);
    return this.hoverCellLeft === snappedPos.x && this.hoverCellTop === snappedPos.y;
  };

  module.exports = GridCellState;
}();

/***/ }),
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _class2, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.GridItemsContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(1497);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(27);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridItems = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GridItems, _Component);

  function GridItems() {
    (0, _classCallCheck3.default)(this, GridItems);
    return (0, _possibleConstructorReturn3.default)(this, (GridItems.__proto__ || (0, _getPrototypeOf2.default)(GridItems)).apply(this, arguments));
  }

  (0, _createClass3.default)(GridItems, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          gridLines = _props.gridLines,
          gridItems = _props.gridItems,
          layoutStore = _props.layoutStore;

      return _react2.default.createElement(
        'div',
        { className: className, style: style },
        gridLines,
        gridItems,
        _react2.default.createElement(_Izenda2.default, { layoutStore: layoutStore })
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.stickyScrollBottom === nextProps.stickyScrollBottom;
    }
  }]);
  return GridItems;
}(_react.Component), _class.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  gridLines: _propTypes2.default.object,
  gridItems: _propTypes2.default.array,
  layoutStore: _propTypes2.default.object,
  stickyScrollBottom: _propTypes2.default.number
}, _temp);
var GridItemsContainer = (_temp2 = _class2 = function (_Component2) {
  (0, _inherits3.default)(GridItemsContainer, _Component2);

  function GridItemsContainer(props) {
    (0, _classCallCheck3.default)(this, GridItemsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (GridItemsContainer.__proto__ || (0, _getPrototypeOf2.default)(GridItemsContainer)).call(this, props));
  }

  /**
   * Render grid items
   */


  (0, _createClass3.default)(GridItemsContainer, [{
    key: 'renderGridItems',
    value: function renderGridItems() {
      var _props2 = this.props,
          className = _props2.className,
          style = _props2.style,
          gridLines = _props2.gridLines,
          gridItems = _props2.gridItems,
          layoutStore = _props2.layoutStore,
          stickyScrollBottom = _props2.stickyScrollBottom;

      return _react2.default.createElement(GridItems, {
        className: className,
        style: style,
        gridLines: gridLines,
        gridItems: gridItems,
        layoutStore: layoutStore,
        stickyScrollBottom: stickyScrollBottom
      });
    }

    /**
     * Render grid items with scroll box
     */

  }, {
    key: 'renderGridItemsWithScrollBox',
    value: function renderGridItemsWithScrollBox() {
      var _props3 = this.props,
          fullHeight = _props3.fullHeight,
          fullSize = _props3.fullSize,
          scrollBoxStyle = _props3.scrollBoxStyle,
          viewClassName = _props3.viewClassName,
          stickyScrollBottom = _props3.stickyScrollBottom,
          alwaysShowHorizontalScroll = _props3.alwaysShowHorizontalScroll,
          alwaysShowVerticalScroll = _props3.alwaysShowVerticalScroll;

      return _react2.default.createElement(
        _Izenda4.default,
        {
          ref: 'scrollBox',
          stickyScrollBottom: stickyScrollBottom,
          alwaysShowHorizontalScroll: alwaysShowHorizontalScroll,
          alwaysShowVerticalScroll: alwaysShowVerticalScroll,
          fullHeight: fullHeight,
          fullSize: fullSize,
          isDisabled: fullSize,
          containerStyle: scrollBoxStyle,
          viewClassName: viewClassName
        },
        this.renderGridItems()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          printingMode = _props4.printingMode,
          editable = _props4.editable;

      return printingMode || !editable ? this.renderGridItems() : this.renderGridItemsWithScrollBox();
    }
  }]);
  return GridItemsContainer;
}(_react.Component), _class2.propTypes = {
  printingMode: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  fullSize: _propTypes2.default.bool,
  fullHeight: _propTypes2.default.bool,
  scrollBoxStyle: _propTypes2.default.object,
  viewClassName: _propTypes2.default.string,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  gridLines: _propTypes2.default.object,
  gridItems: _propTypes2.default.array,
  layoutStore: _propTypes2.default.object,
  stickyScrollBottom: _propTypes2.default.number
}, _class2.DisplayName = 'GridItemsContainer', _temp2);
exports.default = GridItemsContainer;
module.exports = exports['default'];

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GridItemOverlay.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Motion = __webpack_require__(848).Motion;
  var spring = __webpack_require__(848).spring;

  var observer = __webpack_require__(10).observer;
  var observablePropTypes = __webpack_require__(10).propTypes;
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      assign = _require.assign;
  /**
   * Grid item overlay box showing when user interacting with a grid item
   */


  var GridItemOverlay = React.createClass({
    displayName: 'GridItemOverlay',

    firstRendering: true,
    propTypes: {
      layoutStore: observablePropTypes.observableObject
    },
    render: function render() {
      var props = this.props;
      var layoutStore = props.layoutStore;
      var layoutItem = layoutStore.overlayItem;
      var position = layoutStore.overlayPosition;
      var show = layoutItem && layoutItem.isInteracting;
      var isMoving = layoutItem && layoutItem.isMoving;
      var needRenderStatic = this.firstRendering;

      this.firstRendering = !layoutStore.isInteracting;

      var isCollided = layoutItem && layoutStore.detectCollision(layoutItem.id, position);
      var isSwappable = layoutItem && isMoving && layoutStore.allowSwap && layoutStore.detectSwap(layoutItem.id, position);

      var className = classnames('GridItemOverlay', props.className, {
        'GridItemOverlay-valid': !isCollided || isSwappable,
        'GridItemOverlay-invalid': isCollided && !isSwappable
      });
      var render = needRenderStatic ? this.renderStatic : this.renderMotion;

      return render(position, show, className);
    },
    renderStatic: function renderStatic(position, show, className) {
      var style = assign({
        display: show ? 'block' : 'none',
        position: 'absolute'
      }, position);

      return React.createElement('div', { className: className, style: style });
    },
    renderMotion: function renderMotion(position, show, className) {
      var springConfig = {
        precision: 0.3,
        damping: 27,
        stiffness: 250
      };
      var positionStyle = {
        top: spring(position.top, springConfig),
        left: spring(position.left, springConfig),
        width: spring(position.width, springConfig),
        height: spring(position.height, springConfig)
      };

      return React.createElement(
        Motion,
        { style: positionStyle },
        function (interpolatingStyle) {
          var style = assign({
            display: show ? 'block' : 'none',
            position: 'absolute',
            transformStyle: 'flat'
          }, interpolatingStyle);

          return React.createElement('div', { className: className, style: style });
        }
      );
    }
  });

  module.exports = observer(GridItemOverlay);
}();

/***/ }),
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Movable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
//</copyright>
// ----------------------------------------------------------------------
!function () {
  var _propTypes;

  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var DraggableCore = __webpack_require__(359).DraggableCore;
  var MovableController = __webpack_require__(1505);

  var observer = __webpack_require__(10).observer;
  var EventName = MovableController.EventName;

  var Movable = React.createClass({
    displayName: 'Movable',

    controller: null,
    propTypes: (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, '' + EventName.Move, PropTypes.func), (0, _defineProperty3.default)(_propTypes, '' + EventName.MoveStart, PropTypes.func), (0, _defineProperty3.default)(_propTypes, '' + EventName.MoveStop, PropTypes.func), (0, _defineProperty3.default)(_propTypes, 'top', PropTypes.number), (0, _defineProperty3.default)(_propTypes, 'left', PropTypes.number), (0, _defineProperty3.default)(_propTypes, 'width', PropTypes.number), (0, _defineProperty3.default)(_propTypes, 'height', PropTypes.number), (0, _defineProperty3.default)(_propTypes, 'draggableOptions', PropTypes.object), (0, _defineProperty3.default)(_propTypes, 'minTop', PropTypes.number), (0, _defineProperty3.default)(_propTypes, 'minLeft', PropTypes.number), (0, _defineProperty3.default)(_propTypes, 'maxRight', PropTypes.number), (0, _defineProperty3.default)(_propTypes, 'maxBottom', PropTypes.number), _propTypes),
    getDefaultProps: function getDefaultProps() {
      return {
        minTop: 0,
        minLeft: 0,
        maxRight: Infinity,
        maxBottom: Infinity
      };
    },
    componentWillMount: function componentWillMount() {
      var props = this.props;

      this.controller = props.movableController || new MovableController(props.top, props.left, props.width, props.height, {
        minTop: props.minTop,
        minLeft: props.minLeft
      }, {
        maxRight: props.maxRight,
        maxBottom: props.maxBottom
      });

      this.onMoveStart = this.onMoveHandler(EventName.MoveStart);
      this.onMoveStop = this.onMoveHandler(EventName.MoveStop);
      this.onMove = this.onMoveHandler(EventName.Move);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (nextProps.maxRight !== this.props.maxRight || nextProps.maxBottom !== this.props.maxBottom) {
        this.controller.updateMaxBoundary(nextProps.maxRight, nextProps.maxBottom);
      }

      if (nextProps.top !== this.props.top || nextProps.left !== this.props.left || nextProps.width !== this.props.width || nextProps.height !== this.props.height) {

        this.controller.updatePosition(nextProps.top, nextProps.left, nextProps.width, nextProps.height);
      }
    },
    render: function render() {
      var props = this.props;

      return React.createElement(
        DraggableCore,
        (0, _extends3.default)({
          onStart: this.onMoveStart,
          onDrag: this.onMove,
          onStop: this.onMoveStop
        }, props.draggableOptions),
        props.children
      );
    },
    onMoveHandler: function onMoveHandler(eventName) {
      var controller = this.controller;
      var moveCallback = this.props[eventName];

      return function (e, dragData) {
        var top = this.props.top;
        var left = this.props.left;
        var width = this.props.width;
        var height = this.props.height;

        if (eventName === EventName.MoveStart) {
          controller.updatePosition(top, left, width, height);
        }
        controller.moveHandler(eventName, dragData, moveCallback);
      }.bind(this);
    }
  });

  module.exports = observer(Movable);
}();

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MovableController.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
//</copyright>
// ----------------------------------------------------------------------
!function () {
  var action = __webpack_require__(5).action;
  var extendObservable = __webpack_require__(5).extendObservable;
  var EventName = {
    Move: 'onMove',
    MoveStart: 'onMoveStart',
    MoveStop: 'onMoveStop'
  };

  function MovableController(top, left, width, height, topLeftBoundary, rightBottomBoundary) {
    this.width = width;
    this.height = height;
    this.topLeftBoundary = topLeftBoundary;
    this.rightBottomBoundary = rightBottomBoundary;

    extendObservable(this, {
      top: top,
      left: left,
      slackX: 0,
      slackY: 0
    });
  }

  MovableController.prototype.updateMaxBoundary = function (right, bottom) {
    this.rightBottomBoundary.maxBottom = bottom;
    this.rightBottomBoundary.maxRight = right;
  };

  MovableController.prototype.updatePosition = action(function (top, left, width, height) {
    this.top = top;
    this.left = left;
    this.width = width;
    this.height = height;
  });

  MovableController.prototype.moveHandler = action(function (eventName, dragData, movableCallback) {
    var newTop = this.top + dragData.deltaY;
    var newLeft = this.left + dragData.deltaX;

    if (eventName === EventName.Move && newTop === this.top && newLeft === this.left) {
      return;
    }

    var finalPos = this.runConstraints(newTop, newLeft);
    if (this.top !== finalPos.top) {
      this.top = finalPos.top;
    }
    if (this.left !== finalPos.left) {
      this.left = finalPos.left;
    }

    movableCallback && movableCallback({
      top: finalPos.top,
      left: finalPos.left,
      width: this.width,
      height: this.height
    });
  });

  MovableController.prototype.runConstraints = action(function (top, left) {
    var oldTop = top;
    var oldLeft = left;
    var slackX = this.slackX;
    var slackY = this.slackY;

    if (this.topLeftBoundary) {
      top = Math.max(this.topLeftBoundary.minTop, top + slackY);
      left = Math.max(this.topLeftBoundary.minLeft, left + slackX);
    }
    if (this.rightBottomBoundary) {
      top = Math.min(this.rightBottomBoundary.maxBottom, top + this.height) - this.height;
      left = Math.min(this.rightBottomBoundary.maxRight, left + this.width) - this.width;
    }

    this.slackX += oldLeft - left;
    this.slackY += oldTop - top;

    return {
      top: top,
      left: left
    };
  });

  MovableController.EventName = EventName;

  module.exports = MovableController;
}();

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

/**
 * Build position style
 * @param {any} position
 */
function getPositionStyle(position) {
  return {
    left: position.left,
    top: position.top,
    width: position.width,
    height: position.height,
    position: 'absolute'
  };
}

/**
 * Build style with display
 * @param {any} style 
 * @param {boolean} display 
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.GridViewStyleUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

function styleWithDisplay(style, display) {
  return (0, _fp.assign)(style, {
    display: display ? 'block' : 'none'
  });
}

/**
 * Transform to full size style
 * @param {any} style 
 */
function transformToFullSizeStyle(style) {
  return {
    position: 'absolute',
    width: style.width,
    height: style.height,
    top: style.top,
    left: style.left,
    transform: 'rotateY(' + (180 - style.rotate) + 'deg)',
    WebkitTransform: 'rotateY(' + (180 - style.rotate) + 'deg)',
    transformStyle: 'preserve-3d',
    zIndex: 1
  };
}

/**
 * Transform To default style
 * @param {any} style 
 * @param {boolean} needRotate 
 * @param {boolean} doesBreakPage 
 * @param {boolean} printingMode 
 * @param {any} autoSize 
 * @param {boolean} isFirstItem 
 */
function transformToDefaultStyle(style, needRotate, doesBreakPage, printingMode, autoSize, isFirstItem) {
  if (printingMode) {
    return {
      position: !doesBreakPage ? 'absolute' : 'initial',
      top: !doesBreakPage ? style.top : null,
      left: !doesBreakPage ? style.left : null,
      width: !doesBreakPage ? style.width : null,
      height: !doesBreakPage ? style.height : null,
      pageBreakInside: !isFirstItem ? 'avoid' : null
    };
  }

  return {
    position: 'absolute',
    width: style.width,
    height: style.height,
    top: style.top,
    left: style.left,
    transform: needRotate ? null : 'rotateY(' + style.rotate + 'deg)',
    WebkitTransform: needRotate ? null : 'rotateY(' + style.rotate + 'deg)',
    transformStyle: needRotate ? 'flat' : 'preserve-3d',
    zIndex: 0
  };
}

exports.default = {
  getPositionStyle: getPositionStyle,
  styleWithDisplay: styleWithDisplay,
  transformToFullSizeStyle: transformToFullSizeStyle,
  transformToDefaultStyle: transformToDefaultStyle
};
module.exports = exports['default'];

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(53);

var _Izenda2 = __webpack_require__(41);

var _Izenda3 = _interopRequireDefault(_Izenda2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _recompose.compose)((0, _recompose.withState)('stateReview', 'setStateReview', function () {
  return _Izenda3.default.canShowPreview() ? _Izenda.DIRECTION_STATE.NORMAL : _Izenda.DIRECTION_STATE.LEFT;
}), (0, _recompose.withHandlers)({
  loadReportPartData: loadReportPartData,
  beforeShowProps: beforeShowProps
}));
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartContainerActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function beforeShowProps(props) {
  return function () {
    var reportPart = props.gridItem,
        reportBody = props.reportBody;

    reportBody.setConfigReportPart(reportPart);
  };
}

function loadReportPartData(props) {
  return function () {
    var fieldsStore = props.store,
        masterModel = props.store.masterModel,
        reportPart = props.gridItem;

    return masterModel.isReadyForSubReport && fieldsStore.needUpdatePreview(reportPart);
  };
}
module.exports = exports['default'];

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report part header component
 */

var _mobx = __webpack_require__(5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(53);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(23);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(17);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda8 = __webpack_require__(13);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _fp = __webpack_require__(1);

var _Izenda10 = __webpack_require__(142);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(1637);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda14 = __webpack_require__(2);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(974);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(15);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(41);

var _Izenda21 = _interopRequireDefault(_Izenda20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ValidatableInput = (0, _Izenda5.default)({ tooltipPosition: 'bottom' })(_Izenda7.default);

var notifyChange = _EventUtils2.default.notifyChange;

var ReportPartHeader = (_dec = (0, _Izenda15.default)(_Izenda13.default), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ReportPartHeader, _Component);

  function ReportPartHeader(props) {
    (0, _classCallCheck3.default)(this, ReportPartHeader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartHeader.__proto__ || (0, _getPrototypeOf2.default)(ReportPartHeader)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      editMode: false,
      inputTitle: props.reportPart.headerTitle,
      isBackSide: props.reportPart.isBackSide
    };
    return _this;
  }

  /**
   * Change number of record
   * @param {string} value input number from UI
   * @return {any}
   */


  /**
   * Get report part config
   * @return {any} Report part config
   */


  /**
   * switch to edit report name mode for front side
   * @return {[type]} [description]
   */


  /**
   * reset state after flip side
   */


  /**
   * delete current report part
   */


  /**
   * rename report part name
   */


  /**
   * cancel edit name
   */

  /**
   * handle change side behaviour
   */


  (0, _createClass3.default)(ReportPartHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          reportPart = _props.reportPart,
          viewMode = _props.viewMode,
          selectReportPart = _props.selectReportPart,
          onMouseLeave = _props.onMouseLeave;

      var isSelectedReportPartType = !(0, _fp.isNil)(reportPart.type);
      var className = (0, _classnames2.default)('report-part-header draggableBox', this.props.className);

      return !viewMode ? _react2.default.createElement(
        'div',
        {
          className: className,
          draggable: true,
          'aria-selected': isSelectedReportPartType,
          onMouseDown: selectReportPart,
          onMouseLeave: onMouseLeave,
          onTouchStart: selectReportPart
        },
        isSelectedReportPartType ? this.renderSelectedReportHeader() : this.renderUnselectedReportHeader()
      ) : null;
    }
  }, {
    key: 'renderUnselectedReportHeader',
    value: function renderUnselectedReportHeader() {
      var localization = this.props.localization;

      var configClassName = (0, _classnames2.default)('header-control u_paddingAll text-right', {
        hide: !this.props.isShowHeaderConfig && !_Izenda19.default.isMobile
      });
      return _react2.default.createElement(
        'div',
        { className: 'full-height' },
        this.renderBlankHeader(),
        _react2.default.createElement(
          'div',
          { className: configClassName },
          _react2.default.createElement(
            'a',
            {
              className: 'btn btn-default',
              title: localization.getText('COMMON_LABEL_DELETE'),
              'data-btnName': 'btnAction',
              onClick: this.props.hasPrivileges && this.deleteReportPart
            },
            _react2.default.createElement('i', { className: 'icon-cancel' })
          )
        )
      );
    }
  }, {
    key: 'renderSelectedReportHeader',
    value: function renderSelectedReportHeader() {
      var _props2 = this.props,
          reportPart = _props2.reportPart,
          viewMode = _props2.viewMode;

      var flipIcon = {};
      reportPart.isBackSide ? (flipIcon.className = 'icon-flip-front', flipIcon.tooltip = _Izenda2.default.SWITCH_TO_PREVIEW) : (flipIcon.className = 'icon-flip-back', flipIcon.tooltip = _Izenda2.default.SWITCH_TO_CONFIGURATION);

      return !viewMode ? this.renderDesignMode() : this.renderViewMode();
    }
  }, {
    key: 'renderViewMode',
    value: function renderViewMode() {
      var configClassName = (0, _classnames2.default)('izenda-ReportPartHeader-content', {
        hide: !this.props.isShowHeaderConfig && !_Izenda19.default.isMobile
      });
      return _react2.default.createElement(
        'div',
        { className: 'full-height' },
        this.renderBlankHeader(),
        _react2.default.createElement(
          'div',
          { className: configClassName },
          _react2.default.createElement(
            'div',
            { className: 'col-md-6 title' },
            _react2.default.createElement('i', { className: this.getReportPartConfig().icon }),
            _react2.default.createElement(
              'div',
              { className: 'control-group inline-block' },
              _react2.default.createElement(
                'label',
                { className: 'control-label' },
                this.renderTitle()
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderBlankHeader',
    value: function renderBlankHeader() {
      var blankClassName = (0, _classnames2.default)('u_noMarginAll full-height', {
        hide: this.props.isShowHeaderConfig
      });
      return _react2.default.createElement('div', { className: blankClassName, onMouseEnter: this.props.onMouseEnter });
    }
  }, {
    key: 'renderDesignMode',
    value: function renderDesignMode() {
      var props = this.props;
      return _react2.default.createElement(
        'div',
        { className: 'full-height' },
        this.renderConfigHeader(),
        !props.isShowHeaderConfig ? props.reportPart.isBackSide ? this.renderBackSideHeader() : this.renderBlankHeader() : null
      );
    }

    /**
     * render backside header
     */

  }, {
    key: 'renderBackSideHeader',
    value: function renderBackSideHeader() {
      var _props3 = this.props,
          reportPart = _props3.reportPart,
          stateReview = _props3.stateReview,
          localization = _props3.localization;

      var cols = stateReview !== _Izenda2.default.DIRECTION_STATE.NORMAL || !_Izenda21.default.canShowPreview() ? 12 : 6;
      var isForm = reportPart.type === _Izenda3.REPORT_PART_TYPE.Form;
      return !_Izenda19.default.isMobile && _react2.default.createElement(
        _Izenda9.default,
        { className: 'report-part-backside-header u_noMarginAll no-gutter' },
        _react2.default.createElement(
          _Izenda9.default.Row,
          null,
          isForm && this.renderTitleOnly(this.props, reportPart.headerTitle),
          !isForm && this.renderResizeSection(cols, localization.getText('COMMON_LABEL_CONFIGURATION'), _Izenda2.default.DIRECTION.LEFT, _Izenda2.default.DIRECTION_STATE.RIGHT),
          !isForm && _Izenda21.default.canShowPreview() && this.renderResizeSection(cols, localization.getText('COMMON_LABEL_PREVIEW'), _Izenda2.default.DIRECTION.RIGHT, _Izenda2.default.DIRECTION_STATE.LEFT)
        )
      );
    }
  }, {
    key: 'renderTitleOnly',
    value: function renderTitleOnly(props, title) {
      return _react2.default.createElement(
        'div',
        { className: 'u_paddingLeft', onMouseEnter: props.onMouseEnter },
        title
      );
    }
  }, {
    key: 'renderContextMenu',
    value: function renderContextMenu() {
      var props = this.props;
      var reportPartType = props.reportPart.type;
      return _react2.default.createElement(
        'div',
        { className: 'izenda-ReportPartHeader_ContextMenu' },
        _react2.default.createElement(
          'ul',
          { className: 'izenda-ContextMenu-list' },
          _react2.default.createElement(
            'li',
            null,
            ' ',
            this.renderCopyIcon(true),
            ' '
          ),
          _react2.default.createElement(
            'li',
            null,
            ' ',
            this.renderFullScreenIcon(true),
            ' '
          ),
          _react2.default.createElement(
            'li',
            null,
            ' ',
            this.renderFlipIcon(true),
            ' '
          ),
          _react2.default.createElement('li', { className: 'izenda-ContextMenu-divider' }),
          _react2.default.createElement(
            'li',
            null,
            ' ',
            this.renderDeleteIcon(true),
            ' '
          )
        )
      );
    }

    /**
     * render Config header
     */

  }, {
    key: 'renderConfigHeader',
    value: function renderConfigHeader() {
      var _props4 = this.props,
          reportPart = _props4.reportPart,
          reportBody = _props4.reportBody,
          viewMode = _props4.viewMode,
          quickEdit = _props4.quickEdit,
          localization = _props4.localization,
          isShowHeaderConfig = _props4.isShowHeaderConfig,
          hasPrivileges = _props4.hasPrivileges;

      var content = reportPart.reportPartContent;
      var notifyChange = _EventUtils2.default.notifyChange;

      var className = (0, _classnames2.default)({
        'izenda-ReportPartHeader-content': true,
        'small-size': reportPart.width < 6 && !reportPart.isBackSide && !reportBody.isFullScreen,
        hide: !isShowHeaderConfig && !_Izenda19.default.isMobile
      });
      return _react2.default.createElement(
        _Izenda17.default,
        {
          id: reportPart.id || new Date().toISOString(),
          menuComponent: this.renderContextMenu(),
          isDisabled: viewMode && quickEdit
        },
        _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(
            'div',
            { className: 'izenda-ReportPartHeader-buttonAction' },
            this.renderCopyIcon(),
            this.renderFullScreenIcon(),
            this.renderFlipIcon(),
            this.renderDeleteIcon()
          ),
          _react2.default.createElement(
            'div',
            { className: 'izenda-ReportPartHeader-title' },
            _react2.default.createElement('i', { className: this.getReportPartConfig().icon }),
            _react2.default.createElement(
              'div',
              { className: 'control-group inline-block' },
              _react2.default.createElement(
                'label',
                { className: 'control-label' },
                this.renderTitle(),
                hasPrivileges && this.renderTitleEditIcon()
              )
            )
          ),
          !_Izenda19.default.isMobile && _react2.default.createElement(
            'div',
            { className: 'izenda-ReportPartHeader-record' },
            _react2.default.createElement(
              'label',
              { htmlFor: 'record' },
              localization.getText('REPORTDESIGNER_LABEL_NUMBER_OF_RECORDS'),
              ' '
            ),
            _react2.default.createElement(ValidatableInput, {
              className: 'inline-block form-control',
              validations: _Izenda2.default.NUMBER_OF_RECORD_LIMIT_CONSTRAINT,
              field: 'record',
              value: reportPart.numberOfRecord,
              onChange: notifyChange(this.onChangeNumberOfRecord, _EventUtils2.default.INPUT),
              onBlur: this.onBlurNumberOfRecord,
              onKeyDown: this.onKeyDownNumberOfRecords,
              readOnly: !hasPrivileges
            })
          ),
          _react2.default.createElement('div', { className: 'u_clearFix u_noMarginAll' })
        )
      );
    }

    /**
     * Render flip icon
     * @param {boolean} isContextMenu
     *
     */

  }, {
    key: 'renderFlipIcon',
    value: function renderFlipIcon(isContextMenu) {
      var props = this.props;
      var flipIcon = {};
      props.reportPart.isBackSide ? (flipIcon.className = 'icon-flip-front', flipIcon.tooltip = _Izenda2.default.SWITCH_TO_PREVIEW) : (flipIcon.className = 'icon-flip-back', flipIcon.tooltip = _Izenda2.default.SWITCH_TO_CONFIGURATION);
      return props.hasPermission(null) && _react2.default.createElement(
        'a',
        {
          className: !isContextMenu ? 'btn btn-default' : 'btn',
          title: flipIcon.tooltip,
          'data-btnName': 'btnAction',
          onClick: props.hasPrivileges && this.changeSide
        },
        _react2.default.createElement('i', { className: flipIcon.className }),
        isContextMenu && _react2.default.createElement(
          'span',
          null,
          flipIcon.tooltip
        )
      );
    }

    /**
     * Render delete icon
     * @param {boolean} isContextMenu
     *
     */

  }, {
    key: 'renderDeleteIcon',
    value: function renderDeleteIcon(isContextMenu) {
      var _props5 = this.props,
          quickEdit = _props5.quickEdit,
          hasPermission = _props5.hasPermission,
          localization = _props5.localization,
          hasPrivileges = _props5.hasPrivileges;

      return !quickEdit && hasPermission(null) && _react2.default.createElement(
        'a',
        {
          className: !isContextMenu ? 'btn btn-default' : 'btn',
          title: localization.getText('COMMON_LABEL_DELETE'),
          'data-btnName': 'btnAction',
          onClick: hasPrivileges && this.deleteReportPart
        },
        _react2.default.createElement('i', { className: 'icon-cancel' }),
        isContextMenu && _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_DELETE')
        )
      );
    }

    /**
     * Render copy icon
     * @param {boolean} isContextMenu
     *
     */

  }, {
    key: 'renderCopyIcon',
    value: function renderCopyIcon(isContextMenu) {
      var _props6 = this.props,
          reportPart = _props6.reportPart,
          quickEdit = _props6.quickEdit,
          hasPermission = _props6.hasPermission,
          localization = _props6.localization,
          hasPrivileges = _props6.hasPrivileges;

      return !quickEdit && !reportPart.isBackSide && hasPermission(null) && _react2.default.createElement(
        'a',
        {
          className: !isContextMenu ? 'btn btn-default' : 'btn',
          title: localization.getText('COMMON_LABEL_COPY'),
          'data-btnName': 'btnAction',
          onClick: hasPrivileges && this.handleCopyReportPart
        },
        _react2.default.createElement('i', { className: 'icon-copy' }),
        isContextMenu && _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_COPY')
        )
      );
    }

    /**
     * Render icon full screen
     * @return {[type]}
     */

  }, {
    key: 'renderFullScreenIcon',
    value: function renderFullScreenIcon(isContextMenu) {
      var _props7 = this.props,
          quickEdit = _props7.quickEdit,
          localization = _props7.localization,
          reportBody = _props7.reportBody;

      var iconConfig = reportBody.isFullScreen ? {
        title: localization.getText('DASHBOARD_TITLE_NORMAL_SCREEN'),
        className: 'icon-nofullscreen'
      } : {
        title: localization.getText('DASHBOARD_TITLE_FULL_SCREEN'),
        className: 'icon-fullscreen'
      };

      return !quickEdit && _react2.default.createElement(
        'a',
        {
          className: !isContextMenu ? 'btn btn-default' : 'btn',
          title: iconConfig.title,
          'data-btnName': 'btnAction',
          onClick: this.handleShowFullScreen
        },
        _react2.default.createElement('i', { className: iconConfig.className }),
        isContextMenu && _react2.default.createElement(
          'span',
          null,
          iconConfig.title
        )
      );
    }
  }, {
    key: 'renderTitleEditIcon',


    /**
     * renser title icon for front side
     * @return {any} Title edit icon
     */
    value: function renderTitleEditIcon() {
      var _props8 = this.props,
          reportPart = _props8.reportPart,
          localization = _props8.localization,
          hasPrivileges = _props8.hasPrivileges,
          viewMode = _props8.viewMode;

      var editReportFn = viewMode ? null : this.editReportName;

      if (reportPart.isBackSide) {
        return null;
      } else if (!this.state.editMode) {
        return _react2.default.createElement(
          'a',
          {
            className: 'btn btn-default',
            'data-btnName': 'btnAction',
            title: localization.getText('REPORTDESIGNER_LABEL_EDIT_REPORT_PART_NAME'),
            onClick: hasPrivileges && editReportFn
          },
          _react2.default.createElement('i', { className: 'icon-pencil-new' })
        );
      } else {
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            {
              className: 'btn btn-default u_noPaddingAll u_marginLeftInnerSpace',
              'data-btnName': 'btnAction',
              title: localization.getText('REPORTDESIGNER_LABEL_SET_NEW_REPORT_PART_NAME'),
              onClick: this.renameReportPart
            },
            _react2.default.createElement('i', { className: 'icon-ok success-color' })
          ),
          _react2.default.createElement(
            'a',
            {
              className: 'btn btn-default u_noPaddingAll u_marginLeftInnerSpace',
              'data-btnName': 'btnAction',
              title: localization.getText('REPORTDESIGNER_LABEL_REVERT_REPORT_PART_NAME'),
              onClick: this.cancelEditName
            },
            _react2.default.createElement('i', { className: 'icon-cancel' })
          )
        );
      }
    }

    /**
     * render title
     * @return {any} title
     */

  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var _props9 = this.props,
          reportPart = _props9.reportPart,
          reportBody = _props9.reportBody,
          hasPrivileges = _props9.hasPrivileges;

      var state = this.state;
      if (!reportPart.isBackSide && !this.state.editMode) {
        var truncateText = String.truncateString(reportPart.headerTitle, 10);
        return _react2.default.createElement(
          'span',
          { title: reportPart.headerTitle },
          truncateText
        );
      } else {
        var updateInputTitle = function updateInputTitle(newName) {
          this.setState({ inputTitle: newName });
        };
        var onBlurInputField = function onBlurInputField() {
          reportPart.isBackSide && this.renameReportPart();
        };
        var inputTitleValidation = (0, _fp.merge)(_Izenda2.default.CONSTRAINTS.NAME, {
          action: function action() {
            return reportBody.validateNewNameReportPart.bind(reportBody, reportPart, state.inputTitle);
          }
        }, {});
        return _react2.default.createElement(ValidatableInput, {
          className: 'form-control',
          containerClassName: 'inline-block',
          validations: inputTitleValidation,
          field: 'inputTitle',
          value: state.inputTitle,
          onChange: notifyChange(updateInputTitle.bind(this), _EventUtils2.default.INPUT),
          onBlur: onBlurInputField.bind(this),
          readOnly: !hasPrivileges,
          maxLength: 30
        });
      }
    }

    /**
     * render resize (LEFT/RIGHT) section
     * @param {number} cols: number of columns
     * @param {string} title
     * @param {string} direction
     * @param {string} title
     */

  }, {
    key: 'renderResizeSection',
    value: function renderResizeSection(cols, title, direction, iconState) {
      var stateReview = this.props.stateReview;


      var className = (0, _classnames2.default)('u_paddingLeft u_paddingRight', {
        hide: stateReview === iconState || this.props.isShowHeaderConfig,
        'child-panel-expanded': stateReview === -iconState
      });
      var titleClassName = (0, _classnames2.default)('header-panel text-center', {
        'pull-left': direction === _Izenda2.default.DIRECTION.LEFT,
        'pull-right': direction === _Izenda2.default.DIRECTION.RIGHT
      });
      var iconClassName = (0, _classnames2.default)('header-panel u_paddingLeft u_paddingRight', {
        'pull-right': direction === _Izenda2.default.DIRECTION.LEFT,
        'pull-left': direction === _Izenda2.default.DIRECTION.RIGHT
      });
      var showPreview = _Izenda21.default.canShowPreview();
      var titleCols = showPreview ? _Izenda2.default.TITLES_COLS_SHOW_PREVIEW : _Izenda2.default.TITLES_COLS_NOT_SHOW_PREVIEW;

      return _react2.default.createElement(
        _Izenda9.default.Col,
        { cols: cols, className: className },
        _react2.default.createElement(
          _Izenda9.default,
          null,
          _react2.default.createElement(
            _Izenda9.default.Row,
            null,
            _react2.default.createElement(
              _Izenda9.default.Col,
              { cols: titleCols, className: titleClassName, onMouseEnter: this.props.onMouseEnter },
              title
            ),
            showPreview && _react2.default.createElement(
              _Izenda9.default.Col,
              { cols: 1, className: iconClassName },
              this.renderExpandIcon(direction)
            )
          )
        )
      );
    }

    /**
     * render expand icon
     * @param {string} direction
     */

  }, {
    key: 'renderExpandIcon',
    value: function renderExpandIcon(direction) {
      var _props10 = this.props,
          stateReview = _props10.stateReview,
          reportPart = _props10.reportPart,
          store = _props10.store,
          setStateReview = _props10.setStateReview;

      var showPreview = _Izenda21.default.canShowPreview();

      var icon = '';
      if (direction === _Izenda2.default.DIRECTION.LEFT) {
        icon = (0, _classnames2.default)('expend-left pull-right', stateReview === _Izenda2.default.DIRECTION_STATE.NORMAL ? 'icon-right-ex' : 'icon-left-ex');
      } else {
        icon = (0, _classnames2.default)('expend-right pull-left', stateReview === _Izenda2.default.DIRECTION_STATE.NORMAL ? 'icon-left-ex' : 'icon-right-ex');
      }

      var stateReviewMode = stateReview !== _Izenda2.default.DIRECTION_STATE.NORMAL ? _Izenda2.default.DIRECTION_STATE.NORMAL : direction === _Izenda2.default.DIRECTION.LEFT ? _Izenda2.default.DIRECTION_STATE.LEFT : _Izenda2.default.DIRECTION_STATE.RIGHT;
      var setStateReviewFunc = function setStateReviewFunc() {
        setStateReview(stateReviewMode);
        reportPart.updateStateReview(stateReviewMode);
        // When direction != LEFT, call API to get new data
        store.needUpdatePreview(reportPart);
      };

      return showPreview && _react2.default.createElement('a', {
        className: icon,
        title: stateReview !== 0 ? _Izenda2.default.COLLAPSE_DEFAULT : direction === _Izenda2.default.DIRECTION.LEFT ? _Izenda2.default.EXPAND_RIGHT : _Izenda2.default.EXPAND_LEFT,
        onClick: setStateReviewFunc
      });
    }
  }]);
  return ReportPartHeader;
}(_react.Component), _class3.getDefaultProps = {
  viewMode: false, // Use for view mode only in Report Viewer
  quickEdit: false
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onBlurNumberOfRecord = function (event) {
    if (_this2.isChangedNumberOfRecord) {
      _this2.isChangedNumberOfRecord = false;

      var _props11 = _this2.props,
          store = _props11.store,
          validation = _props11.validation,
          reportPart = _props11.reportPart;

      validation.validate('record').then(function (success) {
        if (success) {
          _Izenda21.default.canShowPreview() && store.needUpdatePreview(reportPart);
        }
      });
    }
  };

  this.onKeyDownNumberOfRecords = function (event) {
    if (event.keyCode === _Izenda2.default.EVENT_ENTER_CHANGE_NUMBERS_OF_RECORDS) {
      _this2.onBlurNumberOfRecord();
    }
  };

  this.onChangeNumberOfRecord = function (value) {
    _this2.isChangedNumberOfRecord = true;
    _this2.props.reportPart.setNumberOfRecord(value);
    if (!_Izenda21.default.canShowPreview() && !_this2.props.reportPart.isBackSide) {
      _this2.props.loadReportPartData();
    }
  };

  this.getReportPartConfig = function () {
    return _Izenda11.default.getReportPartType(_this2.props.reportPart.type);
  };

  this.editReportName = function () {
    var _props12 = _this2.props,
        localization = _props12.localization,
        reportPart = _props12.reportPart;

    ensure(!reportPart.isBackSide, localization.getText('REPORTDESIGNER_MESSAGE_MUST_BE_FRONT_SIDE_TO_RUN'));
    _this2.setState({ editMode: true, inputTitle: reportPart.headerTitle });
  };

  this.componentWillReceiveProps = function (nextProps) {
    var isBackSide = _this2.state.isBackSide;
    var reportPart = _this2.props.reportPart;

    if (isBackSide !== reportPart.isBackSide || reportPart !== nextProps.reportPart) {
      _this2.setState({
        editMode: false,
        inputTitle: nextProps.reportPart.headerTitle,
        isBackSide: nextProps.reportPart.isBackSide
      });
    }
  };

  this.deleteReportPart = function () {
    var _props13 = _this2.props,
        reportPart = _props13.reportPart,
        reportBody = _props13.reportBody,
        store = _props13.store;


    _this2.props.confirmFn('Information', {
      description: String.format(_Izenda2.default.MESSAGES.M01, reportPart.headerTitle)
    }).then((0, _mobx.action)(function () {
      // Delete filter using aggregated field in this report part
      (0, _fp.forEach)(function (field) {
        store.reportFilters.removeAggregatedField(field);
      }, reportPart.fieldCollection);
      reportBody.deleteReportPart(reportPart);
      if (store) {
        (0, _fp.invokeArgs)('loadReportPartDataByCrossFiltering', [reportPart.id], store);
        (0, _fp.invoke)('deletePreviousPreviewData', store);
      }
    }));
  };

  this.renameReportPart = function () {
    var _props14 = _this2.props,
        reportPart = _props14.reportPart,
        reportBody = _props14.reportBody,
        store = _props14.store;

    var state = _this2.state;

    _this2.props.validation.validate('inputTitle').then((0, _mobx.action)(function (success) {
      if (success) {
        var defaultName = _this2.getReportPartConfig().label;
        store.reportFilters.updateAggregatedFieldReportPartTitle(reportPart.headerTitle, state.inputTitle);
        reportBody.renameReportPart(reportPart, state.inputTitle, defaultName);
        if (!reportPart.isBackSide) {
          _this2.setState({ editMode: false });
        } else {
          _this2.setState({ inputTitle: reportPart.headerTitle });
        }
      }
    }));
  };

  this.cancelEditName = function () {
    var _props15 = _this2.props,
        localization = _props15.localization,
        reportPart = _props15.reportPart;

    ensure(!reportPart.isBackSide, localization.getText('REPORTDESIGNER_MESSAGE_MUST_BE_FRONT_SIDE_TO_RUN'));
    _this2.setState({ editMode: false, inputTitle: reportPart.headerTitle });
  };

  this.changeSide = function () {
    var props = _this2.props;
    var _props16 = _this2.props,
        reportPart = _props16.reportPart,
        reportBody = _props16.reportBody,
        reportFilters = _props16.store.reportFilters;

    _this2.props.validation.validate().then((0, _mobx.action)(function (success) {
      if (success) {
        // Reset the info to update result as change side update result all the parts
        reportFilters.resetUpdateResult();
        if (props.onClick) {
          // Show report part properties panel after that change side of report part
          props.onClick().then(function () {
            reportBody.changeReportPartSide(reportPart);
          });
        } else {
          reportBody.changeReportPartSide(reportPart);
        }
        if (!_Izenda21.default.canShowPreview() && reportBody.isFullScreen && reportPart.isBackSide) {
          props.loadReportPartData();
        }
      }
    }));
  };

  _initDefineProp(this, 'handleCopyReportPart', _descriptor, this);

  _initDefineProp(this, 'handleShowFullScreen', _descriptor2, this);
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'handleCopyReportPart', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function () {
      var _props17 = _this3.props,
          reportPart = _props17.reportPart,
          reportBody = _props17.reportBody,
          store = _props17.store;

      var newReportPart = reportBody.copyReportPart(reportPart);

      // Get data for new report part
      store.needUpdatePreview(newReportPart);
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'handleShowFullScreen', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function () {
      var props = _this4.props;
      props.onChangeFullScreen && props.onChangeFullScreen(props.reportPart);
      // Show report part properties editor
      props.onClick && props.onClick();
    };
  }
})), _class2)) || _class);
exports.default = ReportPartHeader;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda = __webpack_require__(35);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(539);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1634);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1635);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1636);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(88);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartActions - common actions for all report part
 */
var refreshData = function refreshData(props, isRefreshData) {
  var reportPart = props.reportPart || {};
  var reportPartContent = reportPart.reportPartContent;

  if (!isRefreshData) {
    reportPart.clearRefreshData && reportPart.clearRefreshData();
  } else {
    reportPart.refreshData && reportPart.refreshData(reportPartContent.dataRefreshInterval, function (numRecords) {
      props.needUpdatePreview(reportPart, reportPartContent.getDrilldownInfo && reportPartContent.getDrilldownInfo(), numRecords, true);
    });
  }
};

var pointAction = function pointAction(props, fieldConfig, filters, separator) {
  // find exactly record data matched with value clicked
  var previewData = (0, _mobx.toJS)(props.reportPart.previewData);
  var previewFieldsMapping = previewData.fieldsMapping;
  var records = previewData.records;
  var foundRecords = [];

  filters.forEach(function (filterItem) {
    var field = (0, _fp.find)({ fieldNameAlias: filterItem.key }, previewFieldsMapping);
    foundRecords = foundRecords.concat((0, _fp.filter)(function (record) {
      var columnName = (0, _fp.get)('columnName', field);
      var fieldValue = (0, _fp.flow)((0, _fp.get)(columnName), _fp.toString)(record);

      var filterValue = (0, _fp.flow)((0, _fp.get)('value'), _fp.toString)(filterItem);

      var isDateTimeType = (0, _fp.get)('fieldElement.isDateTimeType', fieldConfig);
      var dateTimeFilterValue = null;

      // For date time type : filter value will be formatted value or timespan
      // Need to convert timespan to correct format to compare
      if (isDateTimeType) {
        fieldValue = (0, _Izenda14.default)(fieldConfig.fieldFormatData, fieldValue);
        dateTimeFilterValue = (0, _Izenda14.default)(fieldConfig.fieldFormatData, (0, _moment2.default)((0, _fp.toNumber)(filterValue)));
      }
      return fieldValue === filterValue || fieldValue === dateTimeFilterValue;
    }, records));
  });

  // find record by separator value
  if (separator) {
    var separatorColumnName = separator.separatorColumnName;
    var separatorValue = separator.separatorValue;

    foundRecords = foundRecords.filter(function (record) {
      return record[separatorColumnName] === separatorValue;
    });
  }
  _Izenda2.default.openHyperlinkAction(props, fieldConfig, foundRecords, _Izenda4.default);
};

var invokeAfterRenderCallBack = function invokeAfterRenderCallBack() {
  (0, _fp.invoke)('afterRenderCallBack', this.props);
};

var frontSideActions = (0, _Izenda12.default)((0, _recompose.setPropTypes)({
  reportPart: _react2.default.PropTypes.object.isRequired,
  needUpdatePreview: _react2.default.PropTypes.func.isRequired,
  getDrillDownRecords: _react2.default.PropTypes.func.isRequired,
  afterRenderCallBack: _react2.default.PropTypes.func
}), (0, _recompose.lifecycle)({
  componentDidUpdate: invokeAfterRenderCallBack,
  componentDidMount: invokeAfterRenderCallBack
}), (0, _recompose.withHandlers)({
  refreshData: (0, _fp.curry)(refreshData),
  pointAction: (0, _fp.curry)(pointAction)
}));

var composeActionDashboard = (0, _fp.memoize)((0, _recompose.compose)(_Izenda10.default, frontSideActions));
var composeActionReportPartViewer = (0, _fp.memoize)((0, _recompose.compose)(_Izenda8.default, frontSideActions));
var composeActionReport = (0, _fp.memoize)((0, _recompose.compose)(_Izenda6.default, frontSideActions));

exports.default = {
  dashboard: composeActionDashboard,
  viewer: composeActionReportPartViewer,
  report: composeActionReport
};
module.exports = exports['default'];

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartActions - common actions for all report part in report designer and viewer
 */
!function () {
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      get = _require.get;

  var action = withHandlers({
    needUpdatePreview: function needUpdatePreview(props) {
      var store = props.store;
      var loader = props.loader;

      return function () {
        return store.needUpdatePreview.apply(store, arguments);
      };
    },
    getDrillDownRecords: function getDrillDownRecords(props) {
      var store = props.store;
      return store.getDrillDownRecords.bind(store);
    },
    getFilterInfoForSubReport: function getFilterInfoForSubReport(props) {
      return function () {
        return get('store.model.reportFilter.filterInfoForSubReport', props);
      };
    }
  });

  module.exports = action;
}();

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartViewerAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartViewerAction - common actions for all report part in standalone report part`
 */
!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var mapProps = __webpack_require__(9).mapProps;

  var _require = __webpack_require__(1),
      omit = _require.omit;

  var action = compose(withHandlers({
    needUpdatePreview: function needUpdatePreview(props) {
      var store = props.store;

      return store.updatePreviewData.bind(store, props.subReportFilter);
    },
    getDrillDownRecords: function getDrillDownRecords(props) {
      var store = props.store;

      return store.getPreviewData.bind(store, props.subReportFilter);
    },
    // don't need filter info for this case
    // for embeded report we will not have fillter value to pass for next sub report
    getFilterInfoForSubReport: function getFilterInfoForSubReport(props) {
      return function () {
        return {};
      };
    }
  }), mapProps(function (props) {
    return omit(['store'], props);
  }));

  module.exports = action;
}();

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTileAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * DashboardTileAction - common actions for all report part in dashboard
 */

var action = (0, _recompose.compose)((0, _recompose.withHandlers)({
  needUpdatePreview: function needUpdatePreview(props) {
    var store = props.store,
        dashboardPart = props.dashboardPart;


    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      store.onDashboardPartDrillDown(dashboardPart);
      // remove 1st arguments : arguments because it not need in dashboard
      return store.getReportPartData.apply(store, (0, _fp.concat)([props.dashboardPart, false], (0, _fp.tail)(args)));
    };
  },
  updateDrillDownInfo: function updateDrillDownInfo(props) {
    return function () {
      props.store.onDashboardPartDrillDown(props.dashboardPart);
    };
  },
  getDrillDownRecords: function getDrillDownRecords(props) {
    var store = props.store;

    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // remove 1st arguments : report part arguments because it not need in dashboard
      return store.getDrilldownInfo.apply(store, (0, _fp.concat)([props.dashboardPart, false], (0, _fp.tail)(args)));
    };
  },
  getFilterInfoForSubReport: function getFilterInfoForSubReport(props) {
    return function () {
      return props.dashboardPart.filterInfoForSubReport();
    };
  }
}), (0, _recompose.mapProps)(function (props) {
  return (0, _fp.omit)(['store'], props);
}));

exports.default = action;
module.exports = exports['default'];

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartHeaderActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withState = __webpack_require__(9).withState;
  var LayoutUtils = __webpack_require__(153);
  var registry = __webpack_require__(540);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      flow = _require.flow,
      invokeArgs = _require.invokeArgs,
      find = _require.find,
      get = _require.get;

  var headerActions = compose(withState('isShowHeaderConfig', 'setShowHeaderConfig', false), withHandlers({
    onMouseEnter: curry(onMouseEnter),
    onMouseLeave: curry(onMouseLeave),
    selectReportPart: curry(selectReportPart),
    hasPermission: curry(hasPermission)
  }));

  /**
   * show Header Config
   */
  function onMouseEnter(props, _) {
    props.setShowHeaderConfig(true);
  }

  /**
   * hide Header Config
   */
  function onMouseLeave(props, _) {
    props.setShowHeaderConfig(false);
  }

  function selectReportPart(props, e) {
    // each button in header will be handle to show/hide props editor themself
    if (invokeArgs('getAttribute', ['data-btnName'], e.target.parentElement) === 'btnAction') {
      return;
    }

    if (invokeArgs('getAttribute', ['data-btnName'], e.target) === 'btnAction' || e.target.tagName === 'INPUT') {
      return;
    }

    if (e.button === 0) {
      props.onClick && props.onClick();
    }
    LayoutUtils.togglePropertiesEditor(true);
  }

  /**
   * Check user has permission on this type of report part
   * Remove : Copy, Delete, Switch button if don't have permission
   */
  function hasPermission(props, e) {
    var reportPartType = props.reportPart.type;

    var reportPartPrivileges = flow(find({ value: reportPartType }), get('permissions'))(registry.REPORT_PART_TYPES);

    return !reportPartPrivileges || props.authorization.checkPrivileges(reportPartPrivileges);
  }

  module.exports = headerActions;
}();

/***/ }),
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(53);

var _reactDom = __webpack_require__(32);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DnDReportPartFieldItemConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DnDReportPartFieldItemConfig
 */
exports.default = {
  sourceOptions: {
    beginDrag: function beginDrag(props) {
      return {
        querySourceField: props.itemData,
        dragItemContainer: props.container,
        itemType: _Izenda.DRAG_ITEM.REPORT_PART_FIELD_ITEM,
        onDeleteElement: props.onDeleteElement
      };
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFieldPropsContainer component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(122);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(27);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(257);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(268);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(187);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(142);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(568);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// show title of group only
var UNUSED_PROPS_NULL_CONFIG_FIELD = ['fields.dataSource.fields', 'fields.dataFormattings.fields', 'fields.headerFormating.fields', 'fields.drillDown.fields'];

var ReportPartList = (0, _mobxReact.observer)(function ReportPartList(props) {
  var reportBody = (0, _fp.get)('reportDesignerModel.reportFields.reportBody', props);
  var configReportPart = reportBody.configReportPart,
      supportReportParts = reportBody.supportReportParts;


  return _react2.default.createElement(_Izenda6.default, {
    blankOption: true,
    options: supportReportParts,
    onChange: onChangeReportPart,
    valueField: 'id',
    labelField: 'headerTitle',
    value: configReportPart && configReportPart.id
  });

  function onChangeReportPart(selectedPartTitle, selectedPart) {
    reportBody && reportBody.setConfigReportPart(selectedPart);
  }
});

var ReportPartElementList = (0, _mobxReact.observer)(function ReportPartElementList(props) {
  var reportBody = (0, _fp.get)('reportDesignerModel.reportFields.reportBody', props);
  var configReportPart = reportBody.configReportPart;
  var configField = configReportPart && configReportPart.configField;

  return _react2.default.createElement(_Izenda6.default, {
    blankOption: true,
    valueField: 'fieldName',
    labelField: 'fieldName',
    value: configField && configField.fieldName,
    options: (0, _fp.get)('configurableFieldCollection', configReportPart),
    onChange: setConfigModeToField
  });

  function setConfigModeToField(selectedElementName, selectedElement) {
    configReportPart && configReportPart.setConfigField(selectedElement);
  }
});

var ConfigFieldProperties = (0, _mobxReact.observer)(function ConfigFieldProperties(props) {
  var configReportPart = (0, _fp.get)('reportDesignerModel.reportFields.reportBody.configReportPart', props) || {};
  var configField = (0, _fp.getOr)({}, 'configField', configReportPart);
  var hasConfigField = (0, _fp.get)('fieldId', configField);
  var fieldPropsSchema = void 0,
      reportPartType = void 0,
      isInvisibleField = void 0,
      propConfig = void 0;

  var propsParams = [this, props.reportDesignerModel, props.fieldStore, (0, _fp.merge)(props, {
    configField: configField,
    fieldStore: props.fieldStore,
    fieldContainerDetails: configReportPart.getContainerDetails && configReportPart.getContainerDetails(configField)
  })];

  if (!hasConfigField) {
    isInvisibleField = false;
    fieldPropsSchema = _Izenda10.default;
    propConfig = fieldPropsSchema.apply(undefined, propsParams);
    removeUsedProps(propConfig);
  } else {
    isInvisibleField = (0, _fp.get)('field.visible', configField);
    reportPartType = _Izenda16.default.getReportPartType(configReportPart.type);
    fieldPropsSchema = (0, _fp.getOr)(_Izenda10.default, 'properties.fieldProps', reportPartType);
    propConfig = fieldPropsSchema.apply(undefined, propsParams);
  }

  var classes = (0, _classnames2.default)('field-props-content', { 'disabled-elm': !isInvisibleField });

  return _react2.default.createElement(
    'fieldset',
    { disabled: !isInvisibleField, className: classes },
    _react2.default.createElement(
      _Izenda8.default,
      null,
      _react2.default.createElement(_Izenda12.default, { propertyConfig: propConfig })
    )
  );

  function removeUsedProps(propConfig) {
    _Izenda14.default.removeProps(propConfig, UNUSED_PROPS_NULL_CONFIG_FIELD);
  }
});

var ReportPartFieldPropsContainer = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartFieldPropsContainer, _Component);

  function ReportPartFieldPropsContainer() {
    (0, _classCallCheck3.default)(this, ReportPartFieldPropsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (ReportPartFieldPropsContainer.__proto__ || (0, _getPrototypeOf2.default)(ReportPartFieldPropsContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportPartFieldPropsContainer, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var type = (0, _fp.get)('reportDesignerModel.reportFields.reportBody.configReportPart.reportPartContent.type', props);
      var localization = props.localization;

      return _react2.default.createElement(
        'section',
        { className: 'form-horizontal field-props-container' },
        _react2.default.createElement(
          'div',
          { className: 'field-props-header' },
          _react2.default.createElement(
            'div',
            { className: 'title-group' },
            _react2.default.createElement(
              'strong',
              { className: 'u_inlineBlock' },
              localization.getText('FIELD_PROPERTIES_SCHEMA_LABEL_FIELD_PROPERTIES')
            ),
            type !== _Izenda19.REPORT_PART_TYPE.Form && _react2.default.createElement(_Izenda18.default, null)
          ),
          _react2.default.createElement(
            _Izenda4.default,
            { className: 'report-parts-ctrl' },
            _react2.default.createElement(ReportPartList, props),
            _react2.default.createElement(ReportPartElementList, props)
          )
        ),
        _react2.default.createElement(ConfigFieldProperties, props)
      );
    }
  }]);
  return ReportPartFieldPropsContainer;
}(_react.Component), _class2.propTypes = {
  reportDesignerModel: _propTypes2.default.object.isRequired,
  itemProps: _propTypes2.default.object
}, _temp)) || _class);
exports.default = ReportPartFieldPropsContainer;
module.exports = exports['default'];

/***/ }),
/* 1753 */,
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FloatAffixedController.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var action = __webpack_require__(5).action;
  var extendObservable = __webpack_require__(5).extendObservable;
  var AppGlobal = __webpack_require__(41);

  var _require = __webpack_require__(1),
      find = _require.find,
      isNil = _require.isNil;

  function edgeAlignMaxSpace(amin, amax, pmin, pmax, space) {
    var rspace = space - amax;
    var lspace = amin;
    if (pmax - pmin < space - amin) return amin - pmin;
    return rspace <= lspace ? amax - pmax : amin - pmin;
  }

  function dclamp(delta, pmin, pmax, space) {
    var edgemax = pmax + delta;
    var edgemin = pmin + delta;

    if (edgemin < 0) return delta - edgemin;else if (edgemax > space) return delta + (space - edgemax);
    return delta;
  }

  function getEdgeSchemes() {
    return {
      over: {
        name: 'over',
        fits: function fits(arect, psize, viewport) {
          return psize.y <= Math.min(arect.min.y, viewport.y);
        },
        calcTranslation: function calcTranslation(arect, prect, viewport) {
          return {
            x: dclamp(edgeAlignMaxSpace(arect.min.x, arect.max.x, prect.min.x, prect.max.x, viewport.x), prect.min.x, prect.max.x, viewport.x),
            y: dclamp(arect.min.y - prect.max.y, prect.min.y, prect.max.y, viewport.y)
          };
        }
      },
      under: {
        name: 'under',
        fits: function fits(arect, psize, viewport) {
          return psize.y <= viewport.y - arect.max.y;
        },
        calcTranslation: function calcTranslation(arect, prect, viewport) {
          return {
            x: dclamp(edgeAlignMaxSpace(arect.min.x, arect.max.x, prect.min.x, prect.max.x, viewport.x), prect.min.x, prect.max.x, viewport.x),
            y: dclamp(arect.max.y - prect.min.y, prect.min.y, prect.max.y, viewport.y)
          };
        }
      },
      left: {
        name: 'left',
        fits: function fits(arect, psize, viewport) {
          return psize.x <= Math.min(arect.min.x, viewport.x);
        },
        calcTranslation: function calcTranslation(arect, prect, viewport) {
          return {
            x: dclamp(arect.min.x - prect.max.x, prect.min.x, prect.max.x, viewport.x),
            y: dclamp(edgeAlignMaxSpace(arect.min.y, arect.max.y, prect.min.y, prect.max.y, viewport.y), prect.min.y, prect.max.y, viewport.y)
          };
        }
      },
      right: {
        name: 'right',
        fits: function fits(arect, psize, viewport) {
          return psize.x <= viewport.x - arect.max.x;
        },
        calcTranslation: function calcTranslation(arect, prect, viewport) {
          return {
            x: dclamp(arect.max.x - prect.min.x, prect.min.x, prect.max.x, viewport.x),
            y: dclamp(edgeAlignMaxSpace(arect.min.y, arect.max.y, prect.min.y, prect.max.y, viewport.y), prect.min.y, prect.max.y, viewport.y)
          };
        }
      }
    };
  }

  function inflate(rect) {
    return {
      min: { x: rect.min.x, y: rect.min.y },
      max: { x: rect.max.x, y: rect.max.y }
    };
  }

  function viewportRect(element) {
    var rect = element.getBoundingClientRect();
    return {
      x: rect.left,
      y: rect.top,
      min: { x: rect.left, y: rect.top },
      max: { x: rect.left + rect.width, y: rect.top + rect.height }
    };
  }

  function rectSize(element) {
    var rect = element.getBoundingClientRect();
    return { x: rect.width, y: rect.height };
  }

  function viewportSize() {
    var element = AppGlobal.containerElement.getBoundingClientRect();
    return { x: element.width + element.left, y: element.top + element.height };
  }

  function parseEdgeAlignProps(edges) {
    var schemes = getEdgeSchemes();
    if (!edges) return [schemes.under, schemes.over, schemes.right, schemes.left];

    return edges.split(',').map(function (name) {
      return schemes[name];
    });
  }

  function FloatAffixedController() {
    extendObservable(this, {
      translation: { x: 0, y: 0 },
      schemeName: ''
    });
  }

  FloatAffixedController.prototype.isElementInView = function (element, parentElement) {
    var rect1 = element.getBoundingClientRect();
    var rect2 = parentElement.getBoundingClientRect();
    return rect1.bottom >= rect2.top && rect1.top <= rect2.bottom;
  };

  FloatAffixedController.prototype.chooseScheme = function (arect, psize, viewport) {
    if (this._scheme && this._scheme.fits(arect, psize, viewport) && this._schemes.indexOf(this._scheme) != -1) {
      return this._scheme;
    }

    this._scheme = find(function (s) {
      return s.fits(arect, psize, viewport);
    }, this._schemes) || this._schemes[0];

    return this._scheme;
  };

  FloatAffixedController.prototype.reposition = action(function (props, _popup) {
    if (isNil(_popup)) {
      return;
    }
    this._schemes = this._schemes || parseEdgeAlignProps(props.edges);

    var prect = viewportRect(_popup);
    var psize = rectSize(_popup);
    var arect = viewportRect(props.anchor);
    var viewport = viewportSize();

    var scheme = this.chooseScheme(inflate(arect), psize, viewport);
    var delta = scheme.calcTranslation(arect, prect, viewport);

    this.translation = {
      x: this.translation.x + delta.x,
      y: this.translation.y + delta.y
    };
    this.schemeName = scheme.name;
  });

  module.exports = FloatAffixedController;
}();

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(258);

var _Izenda2 = __webpack_require__(82);

var _Izenda3 = __webpack_require__(96);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var alternativeTextMessage = _Izenda.MESSAGE.M03;

exports.default = {
  schemaKey: 'RP_FIELD_PROPERTIES',
  fields: {
    /* data source section*/
    dataSource: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_DATA_SOURCE');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        // type
        querySourceType: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_TYPE');
          },
          type: 'static',
          fnValue: 'getValueByKey',
          props: {
            hiddenByState: 'hiddenByReportPartType'
          }
        },

        // name
        sourceAlias: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_NAME');
          },
          type: 'static',
          fnValue: 'getValueByKey',
          props: {
            hiddenByState: 'hiddenByReportPartType'
          }
        },

        // field name
        fieldName: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_FIELD_NAME');
          },
          type: 'static',
          fnValue: 'getFieldName'
        },

        // field name alias
        fieldNameAlias: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_FIELD_NAME_ALIAS');
          },
          component: 'CustomInput',
          fnValue: 'getFieldNameAlias',
          props: {
            beforeOnChange: 'changeFieldNameAlias',
            validations: 'getAliasValidation',
            field: 'fieldNameAlias'
          }
        },

        // data type
        dataFieldType: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_DATA_TYPE');
          },
          type: 'static',
          fnValue: 'getValueByKey',
          props: {
            hiddenByState: 'hiddenByReportPartType'
          }
        },

        // visible
        fieldItemVisible: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_VISIBLE');
          },
          type: 'checkbox',
          fnValue: 'getValueByKey',
          props: {
            hiddenByState: 'hiddenByReportPartType'
          }
        }
      }
    },

    dataFormattings: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_DATA_FORMATTING_HEADER');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        // function
        function: {
          get title() {
            return _Izenda6.default.getText('MODEL_LABEL_FUNCTION');
          },
          type: 'select',
          fnValue: 'getValueByKey',
          isHidden: 'isHiddenFunction',
          props: {
            beforeOnChange: 'beforeChangeFunction',
            options: 'getFunctions',
            labelField: 'name',
            valueField: 'id',
            disabled: 'isRunningField'
          }
        },

        format: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_FORMAT');
          },
          type: 'select',
          fnValue: 'getDataFormatType',
          props: {
            beforeOnChange: 'beforeChangeFormat',
            options: 'getDataFormats',
            labelField: 'name',
            valueField: 'customId',
            groupBy: 'category',
            showTooltip: true,
            blankOption: true,
            blankOptionText: '...'
          }
        },

        width: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_WIDTH');
          },
          component: 'SizeSetting',
          fnValue: 'getDataFormatsWidth',
          props: {
            loadValue: 'getWidthValue',
            propertyKey: 'width.value'
          }
        },

        // font family + font size
        fontFormat: {
          get title() {
            return _Izenda6.default.getText('FONT_SETTINGS_LABEL_FONT');
          },
          component: 'FontFormat',
          fnValue: 'getDataFontFormat',
          props: {
            hiddenByState: 'hiddenByReportPartType'
          }
        },

        // bold, italic, underline
        fontStyle: {
          title: '',
          component: 'FontStyle',
          fnValue: 'getDataFontStyle',
          props: {
            hiddenByState: 'hiddenByReportPartType'
          }
        },

        // alignment: left, right, center,...
        alignment: {
          get title() {
            return _Izenda6.default.getText('FONT_SETTINGS_LABEL_ALIGNMENT');
          },
          component: 'AlignmentSetting',
          fnValue: 'getDataAlignmentFormat',
          isHidden: 'isSeparator',
          props: {
            hiddenByState: true
          }
        },

        // VerticalAlignment: top, middle, bottom
        verticalAlignment: {
          title: '',
          component: 'VerticalAlignmentSetting',
          fnValue: 'getDataFormattingVerticalAlignmentFormat',
          isHidden: 'isSeparator',
          props: {
            hiddenByState: true
          }
        },

        // wordwrap
        columnWordWrap: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_WORD_WRAP');
          },
          component: 'ButtonHighlight',
          fnValue: 'getDataWordWrap',
          isHidden: 'isSeparator',
          staticProps: {
            defaultIcon: 'icon-word-wr'
          },
          props: {
            loadValue: 'getDataWordWrap',
            propertyKey: 'wordWrap',
            get description() {
              return _Izenda6.default.getText('BUTTON_HIGHLIGHT_WRAP_TEXT');
            },
            states: [{
              value: false,
              icon: 'icon-word-wr'
            }, {
              value: true,
              icon: 'icon-word-wr active'
            }],
            disabledIcon: 'icon-word-wr'
          }
        },

        // sort
        sort: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_SORT');
          },
          component: 'ButtonHighlight',
          fnValue: 'getValueByKey',
          isHidden: 'isHiddenSort',
          staticProps: {
            defaultIcon: 'icon-unsort'
          },
          props: {
            loadValue: 'getSortValue',
            propertyKey: 'sort',
            get description() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_SORT');
            },
            beforeOnChange: 'beforeChangeSorting',
            loadStates: 'getSortList',
            disabled: 'isRunningField'
          }
        },

        // color
        color: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_COLOR');
          },
          component: 'TextCellColorSettings',
          fnValue: 'getDataTypeTextCellColor',
          staticProps: {
            cellComponent: __webpack_require__(387)
          },
          props: {
            fnResetTextDefaultValue: 'fnResetTextDefaultValue',
            fnResetCellDefaultValue: 'fnResetCellDefaultValue',
            hiddenByState: 'hiddenColorByReportPartType',
            loadValue: 'getDataTypeTextCellColor'
          }
        },

        // alternative text: button to open pop-up
        alternativeText: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_ALTERNATIVE_TEXT');
          },
          type: 'btnPopup',
          fnValue: 'getAlternativeText',
          props: {
            dataType: 'getSettingDataType',
            dateTimeFormatData: 'getDateTimeFormatData',
            fnResetDefaultValue: 'resetDefaultAlternativeText',
            hadSetting: 'hasSettingAlternativeText',
            loadValue: 'getAlternativeText',
            hiddenByState: 'hiddenAlternativeTextByReportPartType'
          },
          staticProps: {
            get title() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_ALTERNATIVE_TEXT_SETTINGS');
            },
            className: 'icon-setting btn-icon',
            get popupTitle() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_ALTERNATIVE_TEXT_SETTINGS');
            },
            popupContent: __webpack_require__(387),
            popupProps: {
              type: 'none',
              autoClose: false,
              sizeClass: 'modal-lg'
            },
            popupContentProps: {
              validateMessages: alternativeTextMessage,
              valueProps: {
                get title() {
                  return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_ALTERNATIVE_TEXT');
                },
                type: 'text'
              },
              beforeClosing: 'beforeClosing'
            }
          }
        },

        // custom URL: button to open pop-up
        customURL: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_CUSTOM_URL');
          },
          type: 'btnPopup',
          fnValue: 'getCustomUrl',
          props: {
            checkUniqLinkOption: 'checkUniqLinkOption',
            hadSetting: 'hasSettingCustomURL',
            loadValue: 'getCustomUrl',
            hiddenIconSettingSubReport: 'hiddenIconSettingSubReport',
            fnResetDefaultValue: 'resetDefaultCustomURL',
            hiddenByState: 'hiddenByReportPartType'
          },
          isHidden: 'isHiddenCustomURL',
          staticProps: {
            get title() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_CUSTOM_URL_SETTINGS');
            },
            className: 'icon-setting btn-icon',
            get popupTitle() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_CUSTOM_URL_SETTINGS');
            },
            popupContent: __webpack_require__(1798),
            popupProps: {
              type: 'none',
              autoClose: false
            },
            popupContentProps: {
              beforeClosing: 'beforeClosing'
            }
          }
        },

        // embedded javascript: button to open pop-up
        embeddedJavascript: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_EMBEDDED_JAVASCRIPT');
          },
          type: 'btnPopup',
          fnValue: 'getEmbeddedScript',
          props: {
            checkUniqLinkOption: 'checkUniqLinkOption',
            hadSetting: 'hasSettingEmbeddedJavascript',
            loadValue: 'getEmbeddedScript',
            hiddenIconSettingSubReport: 'hiddenIconSettingSubReport',
            fnResetDefaultValue: 'resetDefaultEmbeddedJavascript',
            hiddenByState: 'hiddenByReportPartType'
          },
          isHidden: 'isHiddenEmbeddedJavascript',
          staticProps: {
            get title() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_EMBEDDED_JAVASCRIPT_SETTINGS');
            },
            className: 'icon-setting btn-icon',
            get popupTitle() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_EMBEDDED_JAVASCRIPT_SETTINGS');
            },
            popupContent: __webpack_require__(1799),
            popupProps: {
              type: 'none',
              autoClose: false
            },
            popupContentProps: {
              beforeClosing: 'beforeClosing'
            }
          }
        },

        // sub-total: button to open pop-up
        subTotal: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_SUBTOTAL');
          },
          component: 'CalculatedFieldProperties',
          fnValue: 'getDataSubTotal',
          props: {
            fieldStore: 'getFieldStore',
            hadSetting: 'hasSettingSubTotal',
            fieldSetting: 'getFieldSetting',
            loadValue: 'getDataSubTotal',
            fnResetDefaultValue: 'resetDefaultSubTotal',
            disabled: 'isRunningField'
          },
          isHidden: 'isHiddenSubTotal',
          staticProps: {
            requireLabel: false,
            get title() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_SUBTOTAL_SETTINGS');
            },
            type: _Izenda4.default.TYPES.SUB_TOTAL,
            className: 'icon-setting btn-icon',
            isSubTotalSetting: true
          }
        },

        // grand-total: button to open pop-up
        grandTotal: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_GRAND_TOTAL');
          },
          component: 'CalculatedFieldProperties',
          fnValue: 'getDataGrandTotal',
          props: {
            fieldStore: 'getFieldStore',
            hadSetting: 'hasSettingGrandTotal',
            loadValue: 'getDataGrandTotal',
            fnResetDefaultValue: 'resetDefaultGrandTotal',
            disabled: 'isRunningField'
          },
          staticProps: {
            requireLabel: false,
            get title() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_GRAND_TOTAL_SETTING');
            },
            className: 'icon-setting btn-icon',
            type: _Izenda4.default.TYPES.GRAND_TOTAL
          }
        }
      }
    },

    headerFormating: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_HEADER_FORMATING');
          },
          icon: 'icon-toggle-triangle'
        },
        hiddenByState: 'hiddenByReportPartType'
      },
      fields: {
        // font family + font size
        fontFormat: {
          get title() {
            return _Izenda6.default.getText('FONT_SETTINGS_LABEL_FONT');
          },
          component: 'FontFormat',
          fnValue: 'getHeaderFontFormat',
          staticProps: {
            blankOption: true
          },
          props: {
            hiddenByState: 'hiddenByReportPartType'
          }
        },

        // bold, italic, underline
        fontStyle: {
          title: '',
          component: 'FontStyle',
          fnValue: 'getHeaderFontStyle',
          props: {
            hiddenByState: 'hiddenByReportPartType'
          }
        },

        // alignment: left, right, center,...
        alignment: {
          get title() {
            return _Izenda6.default.getText('FONT_SETTINGS_LABEL_ALIGNMENT');
          },
          component: 'AlignmentSetting',
          fnValue: 'getHeaderAlignmentFormat',
          isHidden: 'isSeparator',
          props: {
            hiddenByState: true
          }
        },

        // VerticalAlignment: top, middle, bottom
        verticalAlignment: {
          title: '',
          component: 'VerticalAlignmentSetting',
          fnValue: 'getHeaderVerticalAlignmentFormat',
          isHidden: 'isSeparator',
          props: {
            hiddenByState: true
          }
        },

        // color
        color: {
          get title() {
            return _Izenda6.default.getText('COMMON_LABEL_COLOR');
          },
          component: 'ColorStyling',
          fnValue: 'getHeaderColorStyling',
          props: {
            type: 'photoshop',
            position: 'left'
          }
        },

        // wordwrap
        wordWrap: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_WORD_WRAP');
          },
          component: 'ButtonHighlight',
          fnValue: 'getValueByKey',
          staticProps: {
            defaultIcon: 'icon-word-wr'
          },
          props: {
            loadValue: 'getWordWrapValue',
            propertyKey: 'wordWrap',
            get description() {
              return _Izenda6.default.getText('BUTTON_HIGHLIGHT_WRAP_TEXT');
            },
            states: [{
              value: false,
              icon: 'icon-word-wr'
            }, {
              value: true,
              icon: 'icon-word-wr active'
            }],
            hiddenByState: 'hiddenByReportPartType'
          }
        },

        // column group
        columnGroup: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_COLUMN_GROUP');
          },
          component: 'CustomInput',
          fnValue: 'getValueByKey',
          props: {
            title: _Izenda2.MESSAGE.COLUMN_GROUP_TOOLTIP,
            hiddenByState: 'hiddenByReportPartType'
          }
        }
      }
    },

    /* drill down */
    drillDown: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_DRILL_DOWN');
          },
          icon: 'icon-toggle-triangle'
        },
        hiddenByState: 'hiddenByReportPartType'
      },
      fields: {
        // width
        subReport: {
          get title() {
            return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_SUB_REPORT');
          },
          type: 'btnPopup',
          fnValue: 'getSubReport',
          isHidden: 'isHiddenSubReport',
          props: {
            fieldStore: 'getFieldStore',
            className: 'icon-setting btn-icon',
            stypeOptions: 'stypeOptions',
            hiddenIconSettingSubReport: 'hiddenIconSettingSubReport',
            checkUniqLinkOption: 'checkUniqLinkOption',
            checkEmbeddedLinkOption: 'checkEmbeddedLinkOption',
            hadSetting: 'hasSettingSubReport',
            loadValue: 'getSubReport',
            fnResetDefaultValue: 'resetDefaultSubReport'
          },
          staticProps: {
            get title() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_SUB_REPORT_SETTING');
            },
            get popupTitle() {
              return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_SUB_REPORT_SETTING');
            },
            popupContent: __webpack_require__(1800),
            popupProps: {
              type: 'none',
              autoClose: false
            },
            popupContentProps: {
              settingsBtn: [{
                get label() {
                  return _Izenda6.default.getText('REPORT_PART_FIELD_PROP_SCHEMA_ADD_FIELD_MAPPING');
                },
                action: 'addMappingField',
                ref: 'addMappingField',
                disabledBy: 'selectedReport'
              }],
              beforeClosing: 'beforeClosing'
            }
          }
        }
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRange.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var constants = __webpack_require__(258);
  var VALUE_TYPES = constants.VALUE_TYPES;
  var DATA_TYPE = constants.DATA_TYPE;

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      last = _require.last,
      clone = _require.clone,
      isNil = _require.isNil,
      uniq = _require.uniq,
      getOr = _require.getOr,
      find = _require.find,
      uniqueId = _require.uniqueId;

  function SettingsByRange() {
    var props = {
      selectedValueType: 'value',
      settingsValue: {
        value: [],
        rangeValue: [],
        rangePercent: []
      },
      editMode: false
    };

    m.extendObservable(this, props);
  }

  SettingsByRange.prototype.setSettingValue = function (settingsValue) {
    settingsValue = settingsValue || {};
    setValueByType = setValueByType.bind(this);

    setValueByType('none');
    setValueByType('value');
    setValueByType('rangeValue');
    setValueByType('rangePercent');

    function setValueByType(valueType) {
      if (settingsValue[valueType]) {
        this.settingsValue[valueType] = m.toJS(settingsValue[valueType]);
        this.selectedValueType = valueType;
        this.editMode = true;
      } else {
        this.settingsValue[valueType] = [];
      }
    }
  };

  /**
   * Only get the current selected setting value
   * @returns {*}
   */
  SettingsByRange.prototype.getSettingValue = function () {
    var result = {};
    var selectedValue = this.selectedValueType;

    this.removeUnSelectSettingValue();
    result[selectedValue] = m.toJS(this.settingsValue[selectedValue]);

    if (isEmpty(result.rangeValue)) {
      result.rangeValue = null;
    }

    if (isEmpty(result.rangePercent)) {
      result.rangePercent = null;
    }

    if (isEmpty(result[selectedValue])) {
      result[selectedValue] = null;
    }
    return result;
  };

  SettingsByRange.prototype.removeUnSelectSettingValue = m.action(function () {
    var selectedValue = this.selectedValueType;
    var backupValue = this.settingsValue[selectedValue];

    this.settingsValue.value = [];
    this.settingsValue.rangeValue = [];
    this.settingsValue.rangePercent = [];
    this.settingsValue[selectedValue] = backupValue;
    this.removeEmptySettingValue();
  });

  /**
   * Remove empty setting value rows
   */
  SettingsByRange.prototype.removeEmptySettingValue = m.action(function (shouldCheckName) {
    var selectedValue = this.selectedValueType;

    this.settingsValue[selectedValue] = this.settingsValue[selectedValue].filter(function (item) {
      if (selectedValue === 'value') {
        return !!item.key || !!item.text;
      } else {
        return shouldCheckName ? !!item.from || !!item.to || !!item.text || !!item.name : !!item.from || !!item.to || !!item.text;
      }
    });
  });

  /**
   * Check a Row whether it have un-complete value which lack of from - to - name value
   * @param {boolean} shouldCheckName
   * @returns {boolean}
   */
  SettingsByRange.prototype.isExistsUncompleteRangeValue = function (shouldCheckName) {
    var selectedValue = this.selectedValueType;

    function haveData(value) {
      return !!(value || value === 0);
    }

    if (selectedValue !== 'value') {
      var rangeValue = find(function (item) {
        var isThisRowUnComplete = false;

        if (shouldCheckName) {
          // logical xor
          if (!(haveData(item.from) === haveData(item.to) && haveData(item.to) === haveData(item.name))) {
            isThisRowUnComplete = true;
          }
        } else {
          // logical xor
          if (!(haveData(item.from) === haveData(item.to))) {
            isThisRowUnComplete = true;
          }
        }
        return isThisRowUnComplete;
      }, this.settingsValue[selectedValue]);

      return !!rangeValue;
    }
    return false;
  };

  /**
   * Check constrains
   * It have checking duplication of value or range value
   * @returns {Array}
   */
  SettingsByRange.prototype.checkConstrains = function (dataType, cycle) {
    var selectedValue = this.selectedValueType;
    var list = this.settingsValue[selectedValue];
    var i = 0;
    var j = 0;
    var duplicate = [];
    var invalidRange = [];
    var invalidIndex = {};
    var duplicateIndex = {};

    function checkDuplicateValue() {
      for (; i <= list.length - 1; i++) {
        if (!isNil(duplicateIndex[i])) {
          continue;
        }

        for (j = i + 1; j <= list.length - 1; j++) {
          if (!isNil(duplicateIndex[j])) {
            continue;
          }

          if (list[i].key === list[j].key) {
            duplicate.push(list[j]);
            duplicateIndex[j] = j;
            if (isNil(duplicateIndex[i])) {
              duplicate.push(list[i]);
              duplicateIndex[i] = i;
            }
          }
        }
      }
    }

    function registerInvalidRange(index) {
      if (isNil(invalidIndex[index])) {
        invalidRange.push(list[index]);
        invalidIndex[index] = list[index];
      }
    }

    function checkRangeOverlapCycle(firstValue, secondValue) {
      return firstValue.from > firstValue.to && (secondValue.from > firstValue.from || secondValue.to > firstValue.from || secondValue.from < firstValue.to || secondValue.to < firstValue.to);
    }

    function checkDuplicateRangeValue() {
      if (!cycle) {
        for (; i <= list.length - 1; i++) {
          if (list[i].from >= list[i].to) {
            registerInvalidRange(i);
            continue;
          }
          for (j = i + 1; j <= list.length - 1; j++) {
            if (list[j].from >= list[j].to) {
              registerInvalidRange(j);
              continue;
            }
            list[j].from < list[i].to && list[i].from < list[j].to && duplicate.push(list[i], list[j]);
          }
        }
      } else {
        for (; i <= list.length - 1; i++) {
          for (j = i + 1; j <= list.length - 1; j++) {
            if (checkRangeOverlapCycle(list[i], list[j]) || checkRangeOverlapCycle(list[j], list[i]) || list[i].from < list[i].to && list[j].from < list[j].to && list[j].from < list[i].to && list[i].from < list[j].to) {
              duplicate.push(list[i], list[j]);
            }
          }
        }
      }
    }

    if (selectedValue === 'value') {
      checkDuplicateValue();
    } else {
      checkDuplicateRangeValue();
    }
    duplicate = uniq(duplicate);
    return {
      duplicate: duplicate,
      invalidRange: invalidRange
    };
  };

  SettingsByRange.prototype.checkDuplicateName = function () {
    var selectedValue = this.selectedValueType;
    var list = this.settingsValue[selectedValue];
    var duplicate = [];

    for (var i = 0; i <= list.length - 2; i++) {
      for (var j = i + 1; j <= list.length - 1; j++) {
        list[i].name === list[j].name && duplicate.push(list[i], list[j]);
      }
    }
    return duplicate;
  };

  SettingsByRange.prototype.setValueType = function (valueType) {
    this.selectedValueType = valueType;
  };

  SettingsByRange.prototype.setValueTypeByDataType = function (dataType, dateTimeFormatData) {
    // Only set default value for add new
    if (!this.editMode) {
      switch (dataType) {
        case DATA_TYPE.TEXT:
          this.setValueType('value');
          break;
        case DATA_TYPE.MONEY:
        case DATA_TYPE.NUMERIC:
        case DATA_TYPE.TIME:
          this.setValueType('rangeValue');
          break;
        case DATA_TYPE.DATETIME:
          var settingsValueType = getOr(['value', 'rangeValue'], 'settingByGroupBy.SETTINGS_VALUE_TYPE', dateTimeFormatData);

          this.setValueType(last(settingsValueType));
          break;
        case 'none':
          this.setValueType('none');
          break;
        default:
          this.setValueType('value');
      }
    }
  };

  SettingsByRange.prototype.addNewSetting = function (data) {
    var valueType = this.selectedValueType;

    if (data) {
      this.settingsValue[valueType].unshift(clone(data));
      return;
    }
    var valueTypeDef = VALUE_TYPES[valueType] || {};

    valueTypeDef.dataStructure.id = uniqueId('setting_');
    this.settingsValue[valueType].unshift(clone(valueTypeDef.dataStructure || {}));
  };

  module.exports = SettingsByRange;
}();

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(255);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(259);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1758);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRange.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * SettingsByRangeItemDraggable HO component
 */
var dndId = 'SettingsByRangeItemDnd';

var dragOptions = {
  beginDrag: function beginDrag(props) {
    return {
      itemIndex: props.itemIndex
    };
  }
};

var dropOptions = {
  hover: function hover(props, monitor) {
    var dragIndex = monitor.getItem().itemIndex;
    var hoverIndex = props.itemIndex;
    if (dragIndex === hoverIndex) return;
    props.onMove && props.onMove(dragIndex, hoverIndex);
    monitor.getItem().itemIndex = hoverIndex;
  }
};

var droppableRow = (0, _Izenda4.default)(dndId, dropOptions);
var draggableRow = (0, _Izenda2.default)(dndId, dragOptions, false);

exports.default = (0, _recompose.compose)(draggableRow, droppableRow)(_Izenda6.default);
module.exports = exports['default'];

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRange.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * SettingsByRangeItem component
 */


var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(258);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(260);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATA_TYPE = _Izenda2.default.DATA_TYPE;

var SettingsByRangeItem = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(SettingsByRangeItem, _Component);

  function SettingsByRangeItem(props) {
    (0, _classCallCheck3.default)(this, SettingsByRangeItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingsByRangeItem.__proto__ || (0, _getPrototypeOf2.default)(SettingsByRangeItem)).call(this, props));

    _this.state = {
      overHandle: false
    };
    return _this;
  }

  (0, _createClass3.default)(SettingsByRangeItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        overHandle: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var connectDragSource = this.props.connectDragSource;

      var isDraggableEnabled = !(0, _fp.isNil)(connectDragSource);
      var overHandle = this.state.overHandle;


      return isDraggableEnabled && overHandle ? connectDragSource(this.renderComponent()) : this.renderComponent();
    }
  }, {
    key: 'renderComponent',
    value: function renderComponent() {
      var _this2 = this;

      var _props = this.props,
          itemData = _props.itemData,
          onDelete = _props.onDelete,
          canMove = _props.canMove;
      var isOver = this.props.isOver; // is dragging over itself

      // For validation

      this.validateFromCtrlId = itemData.id + '_from';
      this.validateToCtrlId = itemData.id + '_to';
      this.validateValueCtrlId = itemData.id + '_value';
      this.validateNameCtrlId = itemData.id + '_name';

      var hoverStyle = {
        opacity: isOver ? 0 : 1
      };
      return _react2.default.createElement(
        'tr',
        { style: hoverStyle },
        canMove && _react2.default.createElement(
          'td',
          { className: 'u_alignMiddle',
            onMouseEnter: function onMouseEnter() {
              return _this2.setState({ overHandle: true });
            },
            onMouseLeave: function onMouseLeave() {
              return _this2.setState({ overHandle: false });
            } },
          _react2.default.createElement('span', { className: 'icon-drag-handle' })
        ),
        this.renderName(),
        _react2.default.createElement(
          'td',
          { className: 'u_alignMiddle' },
          this.renderRangeCtrl()
        ),
        _react2.default.createElement(
          'td',
          { className: 'u_alignMiddle' },
          this.renderValueCtrl(this.validateValueCtrlId)
        ),
        itemData.canDelete && _react2.default.createElement(
          'td',
          { className: 'u_alignMiddle' },
          _react2.default.createElement('span', { onClick: onDelete, className: 'icon-cancel' })
        )
      );
    }
  }, {
    key: 'renderName',
    value: function renderName() {
      var _props2 = this.props,
          itemData = _props2.itemData,
          valueType = _props2.valueType,
          haveName = _props2.haveName;


      var isEditName = haveName && (valueType === 'rangeValue' || valueType === 'rangePercent');

      var nameProps = {
        type: 'text',
        value: itemData.name,
        validations: _Izenda2.default.CONSTRAINTS,
        field: this.validateNameCtrlId,
        onChange: handleChange
      };

      var name = isEditName ? _react2.default.createElement(_Izenda4.default, nameProps) : _react2.default.createElement(
        'span',
        null,
        itemData.name
      );

      return haveName ? _react2.default.createElement(
        'td',
        null,
        name
      ) : null;

      function handleChange(newVal) {
        itemData.name = newVal.value;
      }
    }
  }, {
    key: 'renderRangeCtrl',
    value: function renderRangeCtrl() {
      var _props3 = this.props,
          itemData = _props3.itemData,
          valueType = _props3.valueType,
          dataType = _props3.dataType,
          dateTimeFormatData = _props3.dateTimeFormatData;


      var inputType = this.getInputTypeByDataType(dataType);
      var dateTimeFormatDataResult = this.getDateTimeFormatData(dateTimeFormatData);
      var inputControlProps = {
        groupByDateTime: (0, _fp.get)('groupBy', dateTimeFormatDataResult)
      };

      switch (valueType) {
        case 'value':
          return this.renderInputCtrl((0, _fp.isEqual)(itemData.name, 'High') || (0, _fp.isEqual)(itemData.name, 'Low') ? 'number' : inputType, itemData, 'key', itemData.id, inputControlProps);
        case 'rangeValue':
          return _react2.default.createElement(
            _Izenda6.default,
            null,
            _react2.default.createElement(
              _Izenda6.default.Row,
              null,
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: 5 },
                this.renderInputCtrl(inputType, itemData, 'from', this.validateFromCtrlId, inputControlProps)
              ),
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: 2 },
                _react2.default.createElement(
                  'span',
                  null,
                  '-'
                )
              ),
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: 5 },
                this.renderInputCtrl(inputType, itemData, 'to', this.validateToCtrlId, inputControlProps)
              )
            )
          );
        case 'rangePercent':
          return _react2.default.createElement(
            _Izenda6.default,
            null,
            _react2.default.createElement(
              _Izenda6.default.Row,
              null,
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: 5 },
                _react2.default.createElement(
                  'div',
                  { className: 'input-group' },
                  this.renderInputCtrl(inputType, itemData, 'from', this.validateFromCtrlId, inputControlProps),
                  _react2.default.createElement(
                    'span',
                    { className: 'input-group-addon' },
                    '%'
                  )
                )
              ),
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: 2, className: 'u_controlHeight' },
                _react2.default.createElement(
                  'span',
                  null,
                  '-'
                )
              ),
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: 5 },
                _react2.default.createElement(
                  'div',
                  { className: 'input-group' },
                  this.renderInputCtrl(inputType, itemData, 'to', this.validateToCtrlId, inputControlProps),
                  _react2.default.createElement(
                    'span',
                    { className: 'input-group-addon' },
                    '%'
                  )
                )
              )
            )
          );
        default:
        // do nothing
      }
    }
  }, {
    key: 'renderValueCtrl',
    value: function renderValueCtrl(validateId) {
      var itemData = this.props.itemData;


      var valueProps = this.props.valueProps || {};

      return this.renderInputCtrl(valueProps.type, itemData, 'text', validateId, (0, _fp.assign)({ className: 'value-container' }, valueProps));
    }
  }, {
    key: 'renderInputCtrl',
    value: function renderInputCtrl(dataType, source, valueKey, validateId, inputCtrlProps) {
      var valueType = this.props.valueType;


      prepareProps();
      return _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({}, inputCtrlProps, { type: dataType || 'text', onChange: changeValue }));

      function changeValue(newVal) {
        source[valueKey] = newVal.value;
      }

      function prepareProps() {
        inputCtrlProps = (0, _fp.assign)(inputCtrlProps, { value: source[valueKey] });
        dataType === 'number' && source[valueKey] === '' && (inputCtrlProps = (0, _fp.assign)(inputCtrlProps, { value: null }));
        if (valueType === 'rangePercent' && dataType === 'number') {
          inputCtrlProps = (0, _fp.assign)(inputCtrlProps, { min: 0 });
        } else if (dataType === 'select') {
          inputCtrlProps = (0, _fp.assign)(inputCtrlProps, _Izenda2.default.BOOLEAN_OPTION);
        }

        if (dataType !== 'color') {
          inputCtrlProps = (0, _fp.assign)(inputCtrlProps, { validations: _Izenda2.default.CONSTRAINTS, field: validateId });
        }

        // for Value with High/Low name >> do not require value (map > shading config, should be use through compoent-props)
        if (valueType === 'value' && ['High', 'Low'].indexOf(source.name) > -1 && source.text) {
          delete inputCtrlProps.validations;
        }
      }
    }
  }, {
    key: 'getInputTypeByDataType',
    value: function getInputTypeByDataType(dataType) {
      switch (dataType) {
        case DATA_TYPE.TEXT:
          return 'text';
        case DATA_TYPE.MONEY:
        case DATA_TYPE.NUMERIC:
          return 'number';
        case DATA_TYPE.BOOLEAN:
          return 'select';
        case DATA_TYPE.DATETIME:
          return 'datetime';
        case DATA_TYPE.TIME:
          return 'time';
        default:
          return 'text';
      }
    }
  }, {
    key: 'getDateTimeFormatData',
    value: function getDateTimeFormatData(dateTimeFormatDataFn) {
      return (0, _fp.isFunction)(dateTimeFormatDataFn) ? dateTimeFormatDataFn() : dateTimeFormatDataFn;
    }
  }]);
  return SettingsByRangeItem;
}(_react.Component)) || _class;

exports.default = SettingsByRangeItem;
module.exports = exports['default'];

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(556);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _EventUtils = __webpack_require__(24);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(309);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(388);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(109);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(396);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(169);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(29);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(170);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(562);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(68);

var _Izenda24 = _interopRequireDefault(_Izenda23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorInput = (0, _Izenda4.default)()(_Izenda6.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.InputByDataTypeRegistration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var ValidatorNumericInput = (0, _Izenda4.default)()(_Izenda12.default);
var ValidatorDropDown = (0, _Izenda4.default)()(_Izenda18.default);
var ValidatorDateTimePicker = (0, _Izenda4.default)()(_Izenda20.default);
var ValidatorDateTimePickerByDateElement = (0, _Izenda4.default)()(_Izenda22.default);
var ValidatorCustomInput = (0, _Izenda4.default)()(_Izenda14.default);

// Auto registering the built-in editor types
(function () {
  _Izenda2.default.register('checkbox', createOptionControl);
  _Izenda2.default.register('radio', createOptionControl);
  _Izenda2.default.register('text', createTextInputControl);
  _Izenda2.default.register('password', createTextInputControl);
  _Izenda2.default.register('file', createTextInputControl);
  _Izenda2.default.register('number', createNumberInputControl);
  _Izenda2.default.register('color', createColorPickerControl);
  _Izenda2.default.register('select', createSelectControl);
  _Izenda2.default.register('time', createTimePickerControl);
  _Izenda2.default.register('date', createDatePickerControl);
  _Izenda2.default.register('datetime', createDateTimePickerControl);
  _Izenda2.default.register('static', createStaticTextControl);
  _Izenda2.default.register('btnPopup', createButtonPopupControl);
  _Izenda2.default.register('btnGroup', createButtonGroupControl);
  _Izenda2.default.register('customInput', createCustomInputControl);
})();

function createOptionControl(type, props) {
  var value = props.value,
      onChange = props.onChange;

  var hasValidation = (0, _fp.has)('validations', props);

  return {
    props: {
      type: type,
      className: 'default',
      containerClassName: type,
      checked: !!value,
      onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils.CHECKBOX)
    },
    component: hasValidation ? ValidatorInput : _Izenda6.default
  };
}

function createTextInputControl(type, props) {
  var className = props.className,
      onChange = props.onChange;

  var hasValidation = (0, _fp.has)('validations', props);
  return {
    props: {
      className: (0, _classnames2.default)('form-control', className),
      containerClassName: '',
      onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils.INPUT)
    },
    component: hasValidation ? ValidatorInput : _Izenda6.default
  };
}

function createNumberInputControl(type, props) {
  var className = props.className,
      onChange = props.onChange;

  var hasValidation = (0, _fp.has)('validations', props);
  return {
    props: {
      className: className,
      onChange: (0, _EventUtils.notifyChange)(onChange)
    },
    component: hasValidation ? ValidatorNumericInput : _Izenda12.default
  };
}

function createColorPickerControl(type, props) {
  var className = props.className,
      onChange = props.onChange;

  return {
    props: {
      className: className,
      onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils.COLOR)
    },
    component: _Izenda16.default
  };
}

function createSelectControl(type, props) {
  var className = props.className,
      onChange = props.onChange;

  var hasValidation = (0, _fp.has)('validations', props);
  return {
    props: {
      className: className,
      onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils.DROPDOWN)
    },
    component: hasValidation ? ValidatorDropDown : _Izenda18.default
  };
}

function createTimePickerControl(type, props) {
  var className = props.className,
      onChange = props.onChange;

  var hasValidation = (0, _fp.has)('validations', props);

  return {
    props: {
      className: className,
      calendar: false,
      onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils.DATE)
    },
    component: hasValidation ? ValidatorDateTimePicker : _Izenda20.default
  };
}

function createDatePickerControl(type, props) {
  var className = props.className,
      onChange = props.onChange;

  var hasValidation = (0, _fp.has)('validations', props);

  return {
    props: {
      className: className,
      time: false,
      onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils.DATE)
    },
    component: hasValidation ? ValidatorDateTimePicker : _Izenda20.default
  };
}

function createDateTimePickerControl(type, props) {
  var className = props.className,
      onChange = props.onChange,
      groupByDateTime = props.groupByDateTime;

  var hasValidation = (0, _fp.has)('validations', props);

  return {
    props: {
      className: className,
      groupByDateTime: groupByDateTime,
      onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils.DATE)
    },
    component: hasValidation ? ValidatorDateTimePickerByDateElement : _Izenda22.default
  };
}

function createStaticTextControl(type, props) {
  var className = props.className,
      value = props.value;

  return {
    props: {
      className: className,
      tooltip: value
    },
    child: value,
    component: _Izenda24.default
  };
}

function createButtonPopupControl(type, props) {
  var className = props.className,
      onChange = props.onChange,
      onChangePopup = props.onChangePopup;

  return {
    props: {
      className: className,
      onClosed: onChange,
      onChange: onChangePopup
    },
    component: _Izenda8.default
  };
}

function createButtonGroupControl(type, props) {
  var className = props.className,
      onChange = props.onChange;

  return {
    props: {
      className: className,
      onChange: onChange
    },
    component: _Izenda10.default
  };
}

function createCustomInputControl(type, props) {
  var className = props.className,
      onChange = props.onChange;

  return {
    props: {
      className: (0, _classnames2.default)('form-control', className),
      containerClassName: '',
      onChange: (0, _EventUtils.notifyChange)(onChange, _EventUtils.INPUT)
    },
    component: hasValidation ? ValidatorCustomInput : _Izenda14.default
  };
}

/***/ }),
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Hue.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var domHelperEvents = __webpack_require__(308);
  var ColorDialogUtils = __webpack_require__(397);

  var Hue = React.createClass({
    displayName: 'Hue',


    componentWillUnmount: function componentWillUnmount() {
      this.unbindEventListeners();
    },

    handleChange: function handleChange(e, skip) {
      var change = ColorDialogUtils.hueCalculateChange(e, skip, this.props, this.refs.container);
      change && this.props.onChange(change);
    },

    handleMouseDown: function handleMouseDown(e) {
      this.handleChange(e, true);
      domHelperEvents.on(window, 'mousemove', this.handleChange);
      domHelperEvents.on(window, 'mouseup', this.handleMouseUp);
    },

    handleMouseUp: function handleMouseUp() {
      this.unbindEventListeners();
    },

    unbindEventListeners: function unbindEventListeners() {
      domHelperEvents.off(window, 'mousemove', this.handleChange);
      domHelperEvents.off(window, 'mouseup', this.handleMouseUp);
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'izenda-Hue' },
        React.createElement(
          'div',
          {
            className: 'izenda-Hue-container',
            ref: 'container',
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React.createElement(
            'div',
            { className: 'izenda-Hue-pointer' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                { className: 'izenda-Hue-left' },
                React.createElement('div', { className: 'izenda-Hue-leftInside' })
              ),
              React.createElement(
                'div',
                { className: 'izenda-Hue-right' },
                React.createElement('div', { className: 'izenda-Hue-rightInside' })
              )
            )
          )
        )
      );
    }
  });

  module.exports = Hue;
}();

/***/ }),
/* 1790 */,
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Saturation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var domHelperEvents = __webpack_require__(308);
  var ColorDialogUtils = __webpack_require__(397);

  var _require = __webpack_require__(1),
      throttle = _require.throttle;

  var Saturation = React.createClass({
    displayName: 'Saturation',

    componentWillUnmount: function componentWillUnmount() {
      this.unbindEventListeners();
    },

    handleChange: function handleChange(e, skip) {
      throttle(50, function () {
        this.props.onChange(ColorDialogUtils.saturationCalculateChange(e, skip, this.props, this.refs.container));
      }.bind(this))();
    },

    handleMouseDown: function handleMouseDown(e) {
      this.handleChange(e, true);
      domHelperEvents.on(window, 'mousemove', this.handleChange);
      domHelperEvents.on(window, 'mouseup', this.handleMouseUp);
    },

    handleMouseUp: function handleMouseUp() {
      this.unbindEventListeners();
    },

    unbindEventListeners: function unbindEventListeners() {
      domHelperEvents.off(window, 'mousemove', this.handleChange);
      domHelperEvents.off(window, 'mouseup', this.handleMouseUp);
    },

    render: function render() {
      var containerStyles = {
        background: 'hsl(' + this.props.hsl.h + ',100%, 50%)'
      };
      var pointerStyles = {
        top: -(this.props.hsv.v * 100) + 100 + '%',
        left: this.props.hsv.s * 100 + '%'
      };

      return React.createElement(
        'div',
        {
          className: 'izenda-Saturation',
          style: containerStyles,
          ref: 'container',
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        React.createElement(
          'div',
          { className: 'izenda-Saturation-wrapper' },
          React.createElement('div', { className: 'izenda-Saturation-content' }),
          React.createElement(
            'div',
            { className: 'izenda-Saturation-pointer', style: pointerStyles },
            React.createElement('div', { className: 'izenda-Saturation-circle' })
          )
        )
      );
    }
  });

  module.exports = Saturation;
}();

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPreviews.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var ColorPreviews = React.createClass({
    displayName: 'ColorPreviews',


    render: function render() {
      var rgb = this.props.rgb;
      var localization = this.props.localization;

      var newStyles = {
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')'
      };
      var currentStyles = {
        background: this.props.currentColor
      };

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'izenda-ColorPreviews-label' },
          localization.getText("COLOR_DIALOG_LABEL_NEW")
        ),
        React.createElement(
          'div',
          { className: 'izenda-ColorPreviews-swatches' },
          React.createElement('div', { className: 'izenda-ColorPreviews-new', style: newStyles }),
          React.createElement('div', { className: 'izenda-ColorPreviews-current', style: currentStyles })
        ),
        React.createElement(
          'div',
          { className: 'izenda-ColorPreviews-label' },
          localization.getText("COLOR_DIALOG_LABEL_CURRENT")
        )
      );
    }
  });

  module.exports = connect()(ColorPreviews);
}();

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorFields.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);

  var EditableInput = __webpack_require__(1794);
  var ColorDialogUtils = __webpack_require__(397);

  var ColorFields = React.createClass({
    displayName: 'ColorFields',


    propTypes: {
      disabled: React.PropTypes.bool,
      onChange: React.PropTypes.func,
      rgb: React.PropTypes.object,
      hsv: React.PropTypes.object,
      hex: React.PropTypes.string
    },

    handleChange: function handleChange(data) {
      var onChange = this.props.onChange;
      var rgb = this.props.rgb;
      var hsv = this.props.hsv;

      if (data['#']) {
        ColorDialogUtils.isValidHex(data['#']) && onChange({
          hex: data['#'],
          source: 'hex'
        });
      } else if (data.r || data.g || data.b) {
        onChange({
          r: data.r || rgb.r,
          g: data.g || rgb.g,
          b: data.b || rgb.b,
          source: 'rgb'
        });
      } else if (data.h || data.s || data.v) {
        onChange({
          h: data.h || hsv.h,
          s: data.s || hsv.s,
          v: data.v || hsv.v,
          source: 'hsv'
        });
      }
    },

    render: function render() {
      var rgb = this.props.rgb;
      var hsv = this.props.hsv;
      var hex = this.props.hex;

      return React.createElement(
        'div',
        { className: 'izenda-ColorFields' },
        React.createElement(EditableInput, {
          label: 'h',
          value: Math.round(hsv.h),
          onChange: this.handleChange
        }),
        React.createElement(EditableInput, {
          label: 's',
          value: Math.round(hsv.s * 100),
          onChange: this.handleChange
        }),
        React.createElement(EditableInput, {
          label: 'v',
          value: Math.round(hsv.v * 100),
          onChange: this.handleChange
        }),
        React.createElement('div', { className: 'izenda-ColorFields-divider' }),
        React.createElement(EditableInput, {
          label: 'r',
          value: rgb.r,
          onChange: this.handleChange
        }),
        React.createElement(EditableInput, {
          label: 'g',
          value: rgb.g,
          onChange: this.handleChange
        }),
        React.createElement(EditableInput, {
          label: 'b',
          value: rgb.b,
          onChange: this.handleChange
        }),
        React.createElement('div', { className: 'izenda-ColorFields-divider' }),
        React.createElement(EditableInput, {
          type: 'hex',
          label: '#',
          value: hex.replace('#', ''),
          onChange: this.handleChange
        }),
        React.createElement(
          'div',
          { className: 'izenda-ColorFields-fieldSymbols' },
          React.createElement(
            'div',
            { className: 'izenda-ColorFields-symbol' },
            '\xB0'
          ),
          React.createElement(
            'div',
            { className: 'izenda-ColorFields-symbol' },
            '%'
          ),
          React.createElement(
            'div',
            { className: 'izenda-ColorFields-symbol' },
            '%'
          )
        )
      );
    }
  });

  module.exports = ColorFields;
}();

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.EditableInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var domHelperEvents = __webpack_require__(308);

  var EditableInput = React.createClass({
    displayName: 'EditableInput',


    getInitialState: function getInitialState() {
      var props = this.props;

      return {
        value: String(props.value).toUpperCase(),
        blurValue: String(props.value).toUpperCase()
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var input = this.refs.input;

      if (nextProps.value !== this.state.value) {
        if (input === document.activeElement) {
          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
        } else {
          this.setState({ value: String(nextProps.value).toUpperCase() });
        }
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      this.unbindEventListeners();
    },

    handleBlur: function handleBlur() {
      if (this.state.blurValue) {
        this.setState({ value: this.state.blurValue, blurValue: null });
      }
    },

    handleChange: function handleChange(e) {
      if (!!this.props.label) {
        this.props.onChange((0, _defineProperty3.default)({}, this.props.label, e.target.value));
      } else {
        this.props.onChange(e.target.value);
      }

      this.setState({ value: e.target.value });
    },

    handleKeyDown: function handleKeyDown(e) {
      var number = Number(e.target.value);
      if (number) {
        var amount = this.props.arrowOffset || 1;

        // Up
        if (e.keyCode === 38) {
          if (this.props.label !== null) {
            this.props.onChange((0, _defineProperty3.default)({}, this.props.label, number + amount));
          } else {
            this.props.onChange(number + amount);
          }

          this.setState({ value: number + amount });
        }

        // Down
        if (e.keyCode === 40) {
          if (this.props.label !== null) {
            this.props.onChange((0, _defineProperty3.default)({}, this.props.label, number - amount));
          } else {
            this.props.onChange(number - amount);
          }

          this.setState({ value: number - amount });
        }
      }
    },

    handleDrag: function handleDrag(e) {
      if (this.props.dragLabel) {
        var newValue = Math.round(this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= this.props.dragMax) {
          this.props.onChange((0, _defineProperty3.default)({}, this.props.label, newValue));
        }
      }
    },

    handleMouseDown: function handleMouseDown(e) {
      if (this.props.dragLabel) {
        e.preventDefault();
        this.handleDrag(e);
        domHelperEvents.on(window, 'mousemove', this.handleDrag);
        domHelperEvents.on(window, 'mouseup', this.handleMouseUp);
      }
    },

    handleMouseUp: function handleMouseUp() {
      this.unbindEventListeners();
    },

    unbindEventListeners: function unbindEventListeners() {
      domHelperEvents.off(window, 'mousemove', this.handleDrag);
      domHelperEvents.off(window, 'mouseup', this.handleMouseUp);
    },

    render: function render() {
      var inputClasses = this.props.type === "hex" ? "izenda-EditableInput-hexInput" : "izenda-EditableInput-input";
      var labelClasses = this.props.type === "hex" ? "izenda-EditableInput-hexLabel" : "izenda-EditableInput-label";

      return React.createElement(
        'div',
        { className: 'u-posRelative izenda-EditableInput' },
        React.createElement('input', {
          className: inputClasses,
          ref: 'input',
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder
        }),
        this.props.label ? React.createElement(
          'span',
          { className: labelClasses, onMouseDown: this.handleMouseDown },
          this.props.label
        ) : null
      );
    }
  });

  module.exports = EditableInput;
}();

/***/ }),
/* 1795 */,
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimeCell.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateTimeCell = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(DateTimeCell, _Component);

  function DateTimeCell() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DateTimeCell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateTimeCell.__proto__ || (0, _getPrototypeOf2.default)(DateTimeCell)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      _this.props.type !== 'header' && _this.props.onClick(_this.props.moment);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DateTimeCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          level = _props.level,
          type = _props.type,
          invalid = _props.invalid,
          selected = _props.selected,
          today = _props.today,
          label = _props.label;

      var classes = (0, _classnames2.default)('izenda-DateTimeCell', level, type, {
        selected: selected,
        today: today,
        'outside-range': !invalid
      });

      return _react2.default.createElement(
        'div',
        { className: classes, onClick: this.handleClick },
        label
      );
    }
  }]);
  return DateTimeCell;
}(_react.Component), _class.propTypes = {
  label: _propTypes2.default.string,
  level: _propTypes2.default.string,
  type: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  today: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  classes: _propTypes2.default.object
}, _temp2);
exports.default = DateTimeCell;
module.exports = exports['default'];

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimeNav.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var DateTimeNav = function DateTimeNav(props) {
  return _react2.default.createElement(
    'div',
    { className: 'izenda-DateTimeNav' },
    _react2.default.createElement(
      'div',
      { className: 'izenda-DateTimeNav-arrow u_floatLeft', onClick: props.onPrev },
      '\xAB'
    ),
    _react2.default.createElement(
      'div',
      { className: 'izenda-DateTimeNav-title', onClick: props.onTitle },
      props.title
    ),
    _react2.default.createElement(
      'div',
      { className: 'izenda-DateTimeNav-arrow u_floatRight', onClick: props.onNext },
      '\xBB'
    )
  );
};

DateTimeNav.propTypes = {
  onPrev: _propTypes2.default.func,
  onNext: _propTypes2.default.func,
  onTitle: _propTypes2.default.func,
  title: _propTypes2.default.string
};

exports.default = DateTimeNav;
module.exports = exports['default'];

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.CustomURLBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * CustomURLBody Component
 */
!function () {
  var React = __webpack_require__(0);
  var EventsUtils = __webpack_require__(24);
  var Validator = __webpack_require__(23);
  var ValidatableInput = Validator()(__webpack_require__(17));
  var customURLConstants = __webpack_require__(82).CUSTOM_URL;
  var subReportConstant = __webpack_require__(82).SUB_REPORT;
  var messages = __webpack_require__(82).MESSAGE;
  var ViewSetting = __webpack_require__(563);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      find = _require.find,
      map = _require.map,
      uniqueId = _require.uniqueId;

  var CustomURLBody = React.createClass({
    displayName: 'CustomURLBody',

    getDefaultProps: function getDefaultProps() {
      return {
        value: {
          url: '',
          option: customURLConstants.DEFAULT_VALUE
        }
      };
    },

    getInitialState: function getInitialState() {
      var value = this.props.value;
      var selectedIcon = value.selectedIconValue;
      if (!selectedIcon || isNil(selectedIcon.icon) || isNil(selectedIcon.value)) {
        selectedIcon = {
          icon: subReportConstant.DEFAULT_ICON.icon,
          value: subReportConstant.DEFAULT_ICON.value
        };
      }

      return {
        url: value.url,
        option: value.option,
        viewSettingByLink: isNil(value.viewSettingByLink) ? true // Default value
        : value.viewSettingByLink,
        selectedIconValue: selectedIcon
      };
    },

    beforeClosing: function beforeClosing(valManager, type) {
      var props = this.props;

      if (type === 'accept' && props.checkUniqLinkOption && !props.checkUniqLinkOption(this.state, customURLConstants.NAME)) {
        return props.confirmMessage('error', messages.DUPLICATE_VIEW_SETTING);
      } else {
        return (0, _bluebird.resolve)(true);
      }
    },

    getValue: function getValue() {
      return this.state;
    },

    updateViewSettingByLink: function updateViewSettingByLink() {
      this.setState({
        viewSettingByLink: !this.state.viewSettingByLink
      });
    },

    updateSelectedViewSettingIcon: function updateSelectedViewSettingIcon(value) {
      var selectedIcon = find({ value: value }, subReportConstant.ICON_TYPES);
      if (selectedIcon) {
        this.setState({
          selectedIconValue: {
            icon: selectedIcon.icon,
            value: selectedIcon.value
          }
        });
      }
    },

    renderRadioSelection: function renderRadioSelection() {
      var notifyChange = EventsUtils.notifyChange;

      var handelChangeOption = function (value) {
        this.setState({
          option: value
        });
      }.bind(this);

      var result = map(function (option) {
        return React.createElement(
          'div',
          { key: uniqueId('url_'), className: 'radio' },
          React.createElement(
            'label',
            null,
            React.createElement('input', {
              onChange: notifyChange(handelChangeOption, EventsUtils.INPUT),
              type: 'radio',
              name: 'optradio',
              value: option,
              checked: option === this.state.option
            }),
            localizer.getText(String.format('PROPERTIES_BUILDER_CONSTANTS_CUSTOM_URL_OPTIONS_{0}', option))
          )
        );
      }.bind(this), customURLConstants.OPTIONS);

      return result;
    },

    renderViewSetting: function renderViewSetting() {
      var state = this.state;

      return this.props.hiddenIconSettingSubReport === false && React.createElement(ViewSetting, {
        viewSettingByLink: state.viewSettingByLink,
        selectedIconValue: state.selectedIconValue,
        updateSelectedViewSettingIcon: this.updateSelectedViewSettingIcon,
        updateViewSettingByLink: this.updateViewSettingByLink
      });
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;

      var handelChangeUrl = function (value) {
        this.setState({
          url: value
        });
      }.bind(this);

      return React.createElement(
        'div',
        null,
        React.createElement(
          'label',
          null,
          customURLConstants.CONTENT_DESCRIPTION
        ),
        React.createElement(ValidatableInput, {
          className: 'form-control u_resizeVertical',
          onChange: notifyChange(handelChangeUrl, EventsUtils.INPUT),
          value: this.state.url,
          validations: customURLConstants.CONSTRAINTS.URL,
          field: 'url'
        }),
        this.renderRadioSelection(),
        this.renderViewSetting()
      );
    }
  });

  module.exports = CustomURLBody;
}();

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbeddedJavaScriptBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * EmbeddedJavascript Component
 */
!function () {
  var React = __webpack_require__(0);
  var EventsUtils = __webpack_require__(24);
  var Popup = __webpack_require__(36);
  var Validator = __webpack_require__(23);
  var ValidatableTextArea = Validator()(__webpack_require__(398));
  var constants = __webpack_require__(82).EMBEDDED_JAVASCRIPT;
  var subReportConstant = __webpack_require__(82).SUB_REPORT;
  var messages = __webpack_require__(82).MESSAGE;
  var ViewSetting = __webpack_require__(563);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      find = _require.find;

  var EmbeddedJavascriptPopup = React.createClass({
    displayName: 'EmbeddedJavascriptPopup',

    getDefaultProps: function getDefaultProps() {
      return {
        value: {
          script: ''
        }
      };
    },

    getInitialState: function getInitialState() {
      var value = this.props.value;
      var selectedIcon = value.selectedIconValue;
      if (!selectedIcon || isNil(selectedIcon.icon) || isNil(selectedIcon.value)) {
        selectedIcon = {
          icon: subReportConstant.DEFAULT_ICON.icon,
          value: subReportConstant.DEFAULT_ICON.value
        };
      }

      return {
        script: this.props.value.script,
        viewSettingByLink: isNil(value.viewSettingByLink) ? true // Default value
        : value.viewSettingByLink,
        selectedIconValue: selectedIcon
      };
    },

    beforeClosing: function beforeClosing(valManager, type) {
      var props = this.props;

      if (type === 'accept' && props.checkUniqLinkOption && !props.checkUniqLinkOption(this.state, constants.NAME)) {
        return props.confirmMessage('error', messages.DUPLICATE_VIEW_SETTING);
      } else {
        return (0, _bluebird.resolve)(true);
      }
    },

    getValue: function getValue() {
      return this.state;
    },

    updateViewSettingByLink: function updateViewSettingByLink() {
      this.setState({
        viewSettingByLink: !this.state.viewSettingByLink
      });
    },

    updateSelectedViewSettingIcon: function updateSelectedViewSettingIcon(value) {
      var selectedIcon = find({ value: value }, subReportConstant.ICON_TYPES);
      if (selectedIcon) {
        this.setState({
          selectedIconValue: {
            icon: selectedIcon.icon,
            value: selectedIcon.value
          }
        });
      }
    },

    renderViewSetting: function renderViewSetting() {
      var state = this.state;

      return this.props.hiddenIconSettingSubReport === false && React.createElement(ViewSetting, {
        viewSettingByLink: state.viewSettingByLink,
        selectedIconValue: state.selectedIconValue,
        updateSelectedViewSettingIcon: this.updateSelectedViewSettingIcon,
        updateViewSettingByLink: this.updateViewSettingByLink
      });
    },

    renderBody: function renderBody() {
      var notifyChange = EventsUtils.notifyChange;
      var handleChangeScript = function (value) {
        this.setState({
          script: value
        });
      }.bind(this);

      return React.createElement(
        'div',
        { className: 'embedded-script' },
        React.createElement(
          'label',
          null,
          constants.CONTENT_DESCRIPTION
        ),
        React.createElement(ValidatableTextArea, {
          className: 'form-control',
          rows: '5',
          placeholder: localizer.getText('REPORTDESIGNER_PLACEHOLDER_PASTE_JAVASCRIPT_CODE'),
          onChange: notifyChange(handleChangeScript, EventsUtils.INPUT),
          value: this.state.script,
          validations: constants.CONSTRAINTS.SCRIPT,
          field: 'script'
        })
      );
    },

    render: function render() {
      return React.createElement(
        Popup.Body,
        null,
        this.renderBody(),
        this.renderViewSetting()
      );
    }
  });

  module.exports = EmbeddedJavascriptPopup;
}();

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2, _class3, _class4, _temp4;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReportBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * SubReportBody Component
 */

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

var _mobxReact = __webpack_require__(10);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(29);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(1808);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(314);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(185);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(399);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(82);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(16);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(1847);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(563);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatableMultiSelectDropDown = (0, _Izenda4.default)()(_Izenda8.default);
var ValidatableDropDown = (0, _Izenda4.default)()(_Izenda10.default);
var constants = _Izenda20.default.SUB_REPORT;
var messages = _Izenda20.default.MESSAGE;

var ViewSettingContainer = (0, _mobxReact.observer)(function (_ref) {
  var model = _ref.model,
      hiddenIconSettingSubReport = _ref.hiddenIconSettingSubReport;

  return model.style !== _Izenda22.default.DRIL_DOWN_STYLE.EMBEDDED && !hiddenIconSettingSubReport ? _react2.default.createElement(_Izenda26.default, {
    viewSettingByLink: model.viewSettingByLink,
    selectedIconValue: model.selectedIconValue,
    updateSelectedViewSettingIcon: model.updateSelectedViewSettingIcon.bind(model),
    updateViewSettingByLink: model.updateViewSettingByLink.bind(model)
  }) : null;
});

ViewSettingContainer.displayName = 'ViewSettingContainer';

var StyleDropdown = (0, _mobxReact.observer)(function (_ref2) {
  var model = _ref2.model,
      stypeOptions = _ref2.stypeOptions;
  return _react2.default.createElement(
    'div',
    { className: 'input-group col-md-12' },
    _react2.default.createElement(
      'label',
      { className: 'col-md-2' },
      _Izenda2.default.getText('COMMON_LABEL_STYLE')
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-md-10 ' },
      _react2.default.createElement(ValidatableDropDown, {
        className: 'col-md-12 no-padding',
        options: stypeOptions,
        onChange: _EventUtils2.default.notifyChange(model.updateStyle.bind(model), _EventUtils2.default.DROPDOWN),
        value: model.style,
        validations: constants.CONSTRAINTS.STYLE_CONSTRAINTS,
        field: 'style'
      })
    )
  );
});

StyleDropdown.displayName = 'StyleDropdown';

var ReportPartUsedDropdown = (0, _mobxReact.observer)(function (_ref3) {
  var model = _ref3.model;

  var options = _mobx2.default.toJS(model.reportParts);

  // When value = all , clear out all option
  if (model.reportPartUsed == constants.ALL_OPTION.title) {
    options = [constants.ALL_OPTION];
  } else {
    // Add All option
    !(0, _fp.isEmpty)(options) && options.splice(0, 0, constants.ALL_OPTION);
  }

  return model.style === _Izenda22.default.DRIL_DOWN_STYLE.EMBEDDED ? _react2.default.createElement(
    'div',
    { className: 'input-group col-md-12' },
    _react2.default.createElement(
      'label',
      { className: 'col-md-2' },
      _Izenda2.default.getText('REPORTDESIGNER_LABEL_REPORT_PART_USED')
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-md-10 ' },
      _react2.default.createElement(ValidatableMultiSelectDropDown, {
        className: 'col-md-12 no-padding',
        options: options,
        labelKey: 'title',
        valueKey: 'id',
        disabled: (0, _fp.isNil)(model.selectedReport) || (0, _fp.isEmpty)(model.selectedReport),
        onChange: model.updateReportPart.bind(model),
        value: model.reportPartUsed,
        blankOption: true,
        validations: constants.CONSTRAINTS.REPORT_PART_USED_CONSTRAINTS,
        field: 'reportParts',
        allowCreate: false,
        multi: true
      })
    )
  ) : null;
});

ReportPartUsedDropdown.displayName = 'ReportPartUsedDropdown';

var ReportFilterCheckbox = (0, _mobxReact.observer)(function (_ref4) {
  var model = _ref4.model;
  return _react2.default.createElement(
    'div',
    { className: 'reportFilters col-md-12' },
    _react2.default.createElement('div', { className: 'col-md-2' }),
    _react2.default.createElement(
      'div',
      { className: 'col-md-10' },
      _react2.default.createElement('input', {
        type: 'checkbox',
        checked: model.reportFilter,
        onChange: _EventUtils2.default.notifyChange(model.updateReportFilter.bind(model), _EventUtils2.default.CHECKBOX)
      }),
      _react2.default.createElement(
        'span',
        null,
        constants.SUBREPORT_FILTER_TEXT
      )
    )
  );
});

ReportFilterCheckbox.displayName = 'ReportFilterCheckbox';

var ReportDropdown = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ReportDropdown, _React$Component);

  function ReportDropdown() {
    var _ref5;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref5 = ReportDropdown.__proto__ || (0, _getPrototypeOf2.default)(ReportDropdown)).call.apply(_ref5, [this].concat(args))), _this), _this.openSearchReportPopup = function () {
      var reportId = _this.props.fieldStore.reportId;

      _this.props.openPopup(_Izenda18.default, {
        onChange: _this.changeReport,
        type: _Izenda16.default.TYPE.REPORT,
        excludeIds: (0, _fp.isNil)(reportId) ? [] : [reportId]
      });
    }, _this.changeReport = function (result) {
      var model = _this.props.model;
      var _this$props = _this.props,
          store = _this$props.fieldStore,
          notifySettingButtonState = _this$props.notifySettingButtonState;

      var report = (0, _fp.getOr)({}, 'report', result);
      var reportId = report.id || null;

      model.updateSelectedReport(report);
      store.loadSubReportData(reportId).then(model.readSubReport.bind(model));
      notifySettingButtonState(model.ADD_MAPPING_FIELD_BUTTON, !reportId);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReportDropdown, [{
    key: 'render',
    value: function render() {
      var model = this.props.model;
      return _react2.default.createElement(
        'div',
        { className: 'form-group col-md-12' },
        _react2.default.createElement(
          'label',
          { className: 'col-md-2' },
          _Izenda2.default.getText('COMMON_LABEL_REPORTS')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-9' },
          _react2.default.createElement(_Izenda6.default, { value: model.selectedReportName, className: 'form-control', disabled: true })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-1' },
          _react2.default.createElement(_Izenda14.default, { className: 'icon-search', onClick: this.openSearchReportPopup }),
          _react2.default.createElement(_Izenda14.default, { className: 'icon-cancel', onClick: this.changeReport })
        )
      );
    }
  }]);
  return ReportDropdown;
}(_react2.default.Component), _class2.displayName = 'ReportDropdown', _temp2)) || _class;

var SubReportBody = (0, _mobxReact.observer)(_class3 = (_temp4 = _class4 = function (_React$Component2) {
  (0, _inherits3.default)(SubReportBody, _React$Component2);

  function SubReportBody() {
    var _ref6;

    var _temp3, _this2, _ret2;

    (0, _classCallCheck3.default)(this, SubReportBody);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref6 = SubReportBody.__proto__ || (0, _getPrototypeOf2.default)(SubReportBody)).call.apply(_ref6, [this].concat(args))), _this2), _this2.getValue = function () {
      return _this2.model;
    }, _this2.addMappingField = function () {
      _this2.model.addMappingField();
    }, _this2.beforeClosing = function (valManager, type) {
      var _this2$props = _this2.props,
          checkUniqLinkOption = _this2$props.checkUniqLinkOption,
          confirmMessage = _this2$props.confirmMessage,
          checkEmbeddedLinkOption = _this2$props.checkEmbeddedLinkOption,
          confirmFn = _this2$props.confirmFn;

      var model = _this2.model;

      // Remove empty mapping item
      model.removeUnusedMappingField();

      // Check view option
      if (type === 'accept') {
        var errors = model.validateDuplicate();

        if (!(0, _fp.isEmpty)(errors)) {
          valManager.updateErrors(errors);

          return (0, _bluebird.resolve)(false);
        }

        // Check uniq link option
        if (model.style !== _Izenda22.default.DRIL_DOWN_STYLE.EMBEDDED && checkUniqLinkOption && !checkUniqLinkOption(model, constants.NAME)) {
          return confirmMessage('error', messages.DUPLICATE_VIEW_SETTING);
        }

        // Check embedded sub report
        if (model.style === _Izenda22.default.DRIL_DOWN_STYLE.EMBEDDED && checkEmbeddedLinkOption && !checkEmbeddedLinkOption(model.style)) {
          return confirmFn('Confirmation', {
            description: messages.EMBEDDED_LINK_SUB_REPORT
          }).return(false);
        }
      }
      return (0, _bluebird.resolve)(true);
    }, _temp3), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  (0, _createClass3.default)(SubReportBody, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.model = new _Izenda24.default();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          _props$value = _props.value,
          value = _props$value === undefined ? {} : _props$value,
          store = _props.fieldStore,
          loader = _props.loader,
          hiddenIconSettingSubReport = _props.hiddenIconSettingSubReport;

      var model = this.model;

      loader.startLoading();
      (0, _bluebird.all)([model.readInitialData(value, hiddenIconSettingSubReport), store.loadInitialSubReports(value.selectedReport).then(model.readReports.bind(model))]).finally(loader.endLoading.bind(loader));
    }
  }, {
    key: 'render',


    /**
     * [generateDataForReportTreeDropDownList this function is to prepare data to render
     * @return {[type]} list of report changed the structure
     */
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'subReport inline-block u_fullWidth' },
        _react2.default.createElement(ReportDropdown, {
          model: this.model,
          fieldStore: this.props.fieldStore,
          openPopup: this.props.openPopup,
          notifySettingButtonState: this.props.notifySettingButtonState
        }),
        _react2.default.createElement(ReportFilterCheckbox, { model: this.model }),
        _react2.default.createElement(_Izenda12.default, { model: this.model }),
        _react2.default.createElement(StyleDropdown, { model: this.model, stypeOptions: this.props.stypeOptions }),
        _react2.default.createElement(ReportPartUsedDropdown, { model: this.model }),
        _react2.default.createElement(ViewSettingContainer, { model: this.model, hiddenIconSettingSubReport: this.props.hiddenIconSettingSubReport })
      );
    }
  }]);
  return SubReportBody;
}(_react2.default.Component), _class4.propTypes = {
  fieldStore: _react2.default.PropTypes.object,
  stypeOptions: _react2.default.PropTypes.object.isRequired
}, _class4.displayName = 'SubReportBody', _temp4)) || _class3;

exports.default = SubReportBody;
module.exports = exports['default'];

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// (The MIT License)
// Copyright (c) 2015 Jed Watson.
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the 'Software'), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// ----------------------------------------------------------------------
/** https://github.com/JedWatson/react-input-autosize */

/**
 * Auto-resizing input field for React
 * A text input for React that resizes itself to the current content.
 * Example:
 *   <AutosizeInput
 *        name="form-field-name"
 *        value={inputValue}
 *        onChange={function(event) {
 *
 *        }}
 *    />
 */
!function () {
  var React = __webpack_require__(0);

  var _require = __webpack_require__(1),
      omit = _require.omit;

  var BrowserUtils = __webpack_require__(78);
  var browserWidth = 12;
  var addedWidth = 2;
  var sizerStyle = {
    position: 'absolute',
    visibility: 'hidden',
    height: 0,
    whiteSpace: 'pre',
    paddingRight: addedWidth
  };
  var isEdgeOrIE = BrowserUtils.isIEOrEdgeBrowser();
  isEdgeOrIE && (sizerStyle.paddingRight += browserWidth);
  var AutosizeInput = React.createClass({
    displayName: 'AutosizeInput',

    propTypes: {
      value: React.PropTypes.any, // field value
      defaultValue: React.PropTypes.any, // default field value
      onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
      style: React.PropTypes.object, // css styles for the outer element
      className: React.PropTypes.string, // className for the outer element
      minWidth: React.PropTypes.oneOfType([
      // minimum width for input element
      React.PropTypes.number, React.PropTypes.string]),
      inputStyle: React.PropTypes.object, // css styles for the input element
      inputClassName: React.PropTypes.string // className for the input element
    },
    getDefaultProps: function getDefaultProps() {
      return {
        minWidth: 1
      };
    },
    getInitialState: function getInitialState() {
      return {
        inputWidth: this.props.minWidth
      };
    },
    componentDidMount: function componentDidMount() {
      this.mounted = true;
      this.copyInputStyles();
      this.updateInputWidth();
    },
    componentDidUpdate: function componentDidUpdate() {
      this.updateInputWidth();
    },
    componentWillUnmount: function componentWillUnmount() {
      this.mounted = false;
    },
    copyInputStyles: function copyInputStyles() {
      if (!this.mounted || !window.getComputedStyle) {
        return;
      }
      var inputStyle = window.getComputedStyle(this.refs.input);
      var widthNode = this.refs.sizer;
      widthNode.style.fontSize = inputStyle.fontSize;
      widthNode.style.fontFamily = inputStyle.fontFamily;
      widthNode.style.fontWeight = inputStyle.fontWeight;
      widthNode.style.fontStyle = inputStyle.fontStyle;
      widthNode.style.letterSpacing = inputStyle.letterSpacing;
      if (this.props.placeholder) {
        var placeholderNode = this.refs.placeholderSizer;
        placeholderNode.style.fontSize = inputStyle.fontSize;
        placeholderNode.style.fontFamily = inputStyle.fontFamily;
        placeholderNode.style.fontWeight = inputStyle.fontWeight;
        placeholderNode.style.fontStyle = inputStyle.fontStyle;
        placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
      }
    },

    updateInputWidth: function updateInputWidth() {
      if (!this.mounted || typeof this.refs.sizer.scrollWidth === 'undefined') {
        return;
      }
      var newInputWidth;
      if (this.props.placeholder) {
        newInputWidth = Math.max(this.refs.sizer.scrollWidth, this.refs.placeholderSizer.scrollWidth);
      } else {
        newInputWidth = this.refs.sizer.scrollWidth;
      }
      if (newInputWidth < this.props.minWidth) {
        newInputWidth = this.props.minWidth;
      }
      if (newInputWidth !== this.state.inputWidth) {
        this.setState({
          inputWidth: newInputWidth
        });
      }
    },
    getInput: function getInput() {
      return this.refs.input;
    },
    focus: function focus() {
      this.refs.input.focus();
    },
    blur: function blur() {
      this.refs.input.blur();
    },
    select: function select() {
      this.refs.input.select();
    },
    render: function render() {
      var value = this.props.defaultValue || this.props.value || '';
      var rest = omit(['inputClassName', 'inputStyle', 'minWidth', 'style'], this.props);

      var wrapperStyle = this.props.style || {};
      if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
      var inputStyle = this.props.inputStyle || {};
      inputStyle.width = this.state.inputWidth;
      inputStyle.boxSizing = 'content-box';

      var placeholder = this.props.placeholder ? React.createElement(
        'div',
        { ref: 'placeholderSizer', style: sizerStyle },
        this.props.placeholder
      ) : null;

      return React.createElement(
        'div',
        { className: this.props.className, style: wrapperStyle },
        React.createElement('input', (0, _extends3.default)({ type: 'text' }, rest, { ref: 'input', className: this.props.inputClassName, style: inputStyle })),
        React.createElement(
          'div',
          { ref: 'sizer', style: sizerStyle },
          value
        ),
        placeholder
      );
    }
  });

  module.exports = AutosizeInput;
}();

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Option.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
* Option component of multi selectbox
*/
!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);

  var Option = React.createClass({
    displayName: 'Option',

    propTypes: {
      children: React.PropTypes.node,
      className: React.PropTypes.string,
      onSelect: React.PropTypes.func,
      option: React.PropTypes.object.isRequired
    },

    blockEvent: function blockEvent(event) {
      event.preventDefault();
      event.stopPropagation();
    },

    handleMouseDown: function handleMouseDown(event) {
      this.blockEvent(event);
      this.props.onSelect(this.props.option, event);
    },

    render: function render() {
      var option = this.props;

      return option.disabled ? React.createElement(
        'div',
        {
          className: option.className,
          onMouseDown: this.blockEvent,
          onClick: this.blockEvent
        },
        this.props.children
      ) : React.createElement(
        'div',
        {
          className: option.className,
          style: option.style,
          title: option.title,
          onMouseDown: this.handleMouseDown
        },
        this.props.children
      );
    }

  });

  module.exports = Option;
}();

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Value.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/** https://github.com/JedWatson/react-select */

/**
 * Value component of multi selectbox
 */
!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;

  var Value = React.createClass({
    displayName: 'Value',

    propTypes: {
      children: React.PropTypes.node,
      disabled: React.PropTypes.bool, // disabled prop passed to ReactSelect
      onClick: React.PropTypes.func, // method to handle click on value label
      onRemove: React.PropTypes.func, // method to handle removal of the value
      value: React.PropTypes.object.isRequired, // the option object for this value
      tooltip: React.PropTypes.string // tooltip for the value
    },

    getInitialState: function getInitialState() {
      var tooltip = this.props.tooltip;
      var object = this.props.value;
      var value = object.value;
      var stringValue = !isEmpty(value) ? value : '';

      var defaultValue = !isEmpty(tooltip) ? tooltip : stringValue;

      return {
        tooltip: defaultValue // set default tooltip equal value
      };
    },

    handleMouseDown: function handleMouseDown(event) {
      if (event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (this.props.onClick) {
        event.stopPropagation();
        this.props.onClick(this.props.value, event);
        return;
      }
    },

    onRemove: function onRemove(event) {
      event.preventDefault();
      event.stopPropagation();
      this.props.onRemove(this.props.value);
    },

    renderRemoveIcon: function renderRemoveIcon() {
      if (this.props.disabled || !this.props.onRemove) return;
      return React.createElement(
        'span',
        { className: 'Select-value-icon', onMouseDown: this.onRemove },
        '\xD7'
      );
    },

    renderLabel: function renderLabel() {
      var className = 'Select-value-label';
      return this.props.onClick || this.props.value.href ? React.createElement(
        'a',
        {
          className: className,
          href: this.props.value.href,
          target: this.props.value.target,
          onMouseDown: this.handleMouseDown
        },
        this.props.children
      ) : React.createElement(
        'span',
        { className: className },
        this.props.children
      );
    },

    render: function render() {
      // change the tooltip when choose different item
      var tooltip = this.props.value.optionTooltip;
      !tooltip && (tooltip = isEmpty(this.props.value.value) ? this.props.children : this.props.value.value);

      return React.createElement(
        'div',
        {
          className: classnames('Select-value', this.props.value.className),
          style: this.props.value.style,
          title: tooltip
        },
        this.renderLabel(),
        this.renderRemoveIcon()
      );
    }
  });

  module.exports = Value;
}();

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.VirtualListItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var PropTypes = React.PropTypes;

  var _require = __webpack_require__(1),
      get = _require.get,
      identity = _require.identity,
      flow = _require.flow,
      debounce = _require.debounce;

  var VirtualListItem = React.createClass({
    displayName: 'VirtualListItem',

    propTypes: {
      children: PropTypes.element,
      item: PropTypes.object
    },
    updateFunction: function updateFunction(props) {
      this.childDidUpdate = get('didUpdate', props.children) || identity;
      this.debounceSyncCoord = debounce(360, flow(this.syncCoords, this.childDidUpdate));
    },
    componentWillMount: function componentWillMount() {
      this.updateFunction(this.props);
      this.didMount = false;
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.updateFunction(nextProps);
    },
    componentDidMount: function componentDidMount() {
      this.didMount = true;
      this.syncCoords();
    },
    componentWillUnmount: function componentWillUnmount() {
      this.didMount = false;
      this.debounceSyncCoord.cancel();
    },
    render: function render() {
      return React.cloneElement(this.props.children, {
        isTrainingMode: get('item.isTrainingMode', this.props),
        didUpdate: this.debounceSyncCoord
      });
    },
    syncCoords: function syncCoords() {
      var domNode = this.didMount && ReactDOM.findDOMNode(this);

      if (domNode) {
        var virtualItem = this.props.item;
        virtualItem.updateCoords(domNode);
      }
    }
  });

  module.exports = VirtualListItem;
}();

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.VirtualListUIStore.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var action = __webpack_require__(5).action;
  var extendObservable = __webpack_require__(5).extendObservable;

  var _require = __webpack_require__(1),
      get = _require.get,
      flatMap = _require.flatMap,
      placeholder = _require.placeholder;

  function VirtualListUIStore(pageToScreenRatio, items) {
    this.pageToScreenRatio = pageToScreenRatio;
    this.numPageOnScreen = 3;
    this.training = true;

    extendObservable(this, {
      width: 0,
      startIndex: 0,
      viewportHeight: 0,
      viewportWidth: 0,
      itemHeight: 0,
      itemWidth: 0,
      pages: [],
      items: function items() {
        return flatMap(function (page) {
          return page.items.slice();
        }, this.pages.slice());
      },
      virtualHeight: function virtualHeight() {
        return placeholder(this.pages).map(get('height')).reduce(function (acc, height) {
          return acc + height;
        }, 0);
      },
      screenPageHeight: function screenPageHeight() {
        return this.viewportHeight ? this.viewportHeight * this.pageToScreenRatio : Infinity;
      },
      bufferHeight: function bufferHeight() {
        var startIndex = this.startIndex;

        return placeholder(this.pages).filter(function (page) {
          return page.id < startIndex;
        }).map(get('height')).reduce(function (acc, height) {
          return acc + height;
        }, 0);
      },
      virtualItemsOnScreen: function virtualItemsOnScreen() {
        var startIndex = this.startIndex;
        var lastIndex = Math.min(this.pages.length, startIndex + this.numPageOnScreen) - 1;
        return placeholder(this.pages).filter(function (page) {
          return page.id >= startIndex && page.id <= lastIndex;
        }).flatMap(get('items')).value();
      }
    });

    this.initialize(items, 0);
  }

  VirtualListUIStore.prototype.initialize = action(function initialize(items, getChildItems) {
    if (!items || items.length === 0) return;

    var lastPage, itemIndex, itemsLength, item;
    var childIndex, childLength, childItem, childItems;

    if (this.pages.length > 0) {
      lastPage = this.pages[this.startIndex];
    } else {
      lastPage = this.newVirtualPage();
    }

    if (this.training) {
      // Render only one item for training its height
      lastPage.append(new VirtualItem(items[0], true));
      this.training = false;
    } else {
      // Take one item dimension as default item dimension
      if (!this.itemHeight) this.itemHeight = lastPage.items[0].height;
      if (!this.itemWidth) this.itemWidth = lastPage.items[0].width;

      // Clear out training rendered items/pages.
      this.release();

      // Intentionally use for loop that give best performance on large item list.
      for (itemIndex = 0, itemsLength = items.length; itemIndex < itemsLength; itemIndex++) {
        item = items[itemIndex];
        this.append(new VirtualItem(item));

        if (getChildItems) {
          childItems = getChildItems(item);

          // Scan thru child items and append virtual item for child items
          for (childIndex = 0, childLength = childItems.length; childIndex < childLength; childIndex++) {
            childItem = childItems[childIndex];
            this.append(new VirtualItem(childItem));
          }
        }
      }
    }
  });

  VirtualListUIStore.prototype.append = action(function appendItem(item) {
    if (!item) return;
    var pages = this.pages;
    var lastPage = pages.length > 0 ? pages[pages.length - 1] : null;

    if (!lastPage || !lastPage.hasVacancy) {
      lastPage = this.newVirtualPage();
    }
    lastPage.append(item);
  });

  VirtualListUIStore.prototype.release = action(function release() {
    this.pages = [];
    VirtualItemRegistry.reset();
  });

  VirtualListUIStore.prototype.setViewportDimension = action(function setViewportDimension(width, height) {
    this.viewportWidth = width;
    this.viewportHeight = height;
    this.repartition();
  });

  VirtualListUIStore.prototype.calculateStartIndex = function (scrollTop) {
    var runningTop = 0;
    var current = placeholder(this.pages).map(function (page) {
      var pageCoord = {
        id: page.id,
        top: runningTop,
        bottom: runningTop + page.height
      };
      runningTop += page.height;
      return pageCoord;
    }).findLast(function (pageCoord) {
      return scrollTop >= pageCoord.top && scrollTop <= pageCoord.bottom;
    });

    // The top page index that is showing in viewport
    var topPageIndex = current ? current.id : 0;
    // Max start index
    var maxStartIndex = Math.max(this.pages.length - this.numPageOnScreen, 0);
    // Shift the start page index lower than showing page index
    var startIndex = Math.min(Math.max(topPageIndex - 1, 0), maxStartIndex);

    if (startIndex !== this.startIndex) {
      this.startIndex = startIndex;
    }
  };

  VirtualListUIStore.prototype.repartition = action(function repartition() {
    var index, length, itemIndex, pageLength, currPage, currItems, currItem;
    var pages = this.pages.peek();

    this.release();

    var newPage = this.newVirtualPage();

    for (index = 0, length = pages.length; index < length; index++) {
      currPage = pages[index];
      currItems = currPage.items;

      for (itemIndex = 0, pageLength = currItems.length; itemIndex < pageLength; itemIndex++) {
        currItem = currItems[itemIndex];
        if (newPage.hasVacancy) {
          newPage.append(currItem);
        } else {
          newPage = this.newVirtualPage();
          newPage.append(currItem);
        }
      }
    }
  });

  VirtualListUIStore.prototype.newVirtualPage = function () {
    var newPage = new VirtualPage(this);
    this.pages.push(newPage);
    return newPage;
  };

  function VirtualPage(parent) {
    this.id = parent.pages.length;
    this.parent = parent;
    this.items = [];

    extendObservable(this, {
      lazyLoaded: false,
      onScreen: false,
      // height : 0,
      top: function top() {
        return 0;
      },
      bottom: function bottom() {
        return this.top + this.height;
      },
      width: function width() {
        return placeholder(this.items).map(get('width')).reduce(function (acc, width) {
          return acc + (width === 0 ? parent.itemWidth : width);
        }, 0);
      },
      height: function height() {
        // return this.items.length * this.parent.itemHeight;
        return placeholder(this.items).map(get('height')).reduce(function (acc, height) {
          return acc + (height === 0 ? parent.itemHeight : height);
        }, 0);
      },
      hasVacancy: function hasVacancy() {
        return this.height < this.parent.screenPageHeight;
      }
    });
  }

  VirtualPage.prototype.append = action(function appendItem(item) {
    this.items.push(item);
  });

  function VirtualItem(dataItem, isTrainingMode) {
    this.itemIndex = VirtualItemRegistry.generateItemIndex();
    this.dataItem = dataItem;
    this.isTrainingMode = isTrainingMode;

    extendObservable(this, {
      top: 0,
      bottom: 0,
      width: 0,
      height: 0
    });
  }

  VirtualItem.prototype.updateCoords = action(function updateCoords(domElm) {
    if (domElm) {
      this.height = domElm.offsetHeight;
      this.width = domElm.offsetWidth;
    }
  });

  var VirtualItemRegistry = function () {
    var itemCount = 0;
    return {
      generateItemIndex: function generateItemIndex() {
        return itemCount++;
      },
      reset: function reset() {
        itemCount = 0;
      }
    };
  }();

  module.exports = VirtualListUIStore;
}();

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3; // ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoadingUIStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(34);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var LazyLoadingUIStore = (_dec = (0, _mobx.action)('setupDefaultData'), _dec2 = (0, _mobx.action)('setViewHeight'), _dec3 = (0, _mobx.action)('updateData'), _dec4 = (0, _mobx.action)('removeVirtualNode'), _dec5 = (0, _mobx.action)('showLoading'), (_class = function () {
  function LazyLoadingUIStore(defaultData) {
    (0, _classCallCheck3.default)(this, LazyLoadingUIStore);

    _initDefineProp(this, 'items', _descriptor, this);

    _initDefineProp(this, 'isLoading', _descriptor2, this);

    _initDefineProp(this, 'training', _descriptor3, this);

    this.isLastPage = false;
    this.itemHeight = 0;
    this.stop = false;
    this.viewHeight = 0;
    this.pageInfoForFirstTime = {};
    this.virtualNodes = [];
    this.pageSize = defaultData.defaultItemsNumber || 0;
    this.defaultItemsNumber = defaultData.defaultItemsNumber || _Izenda.LAZY_LOADING_DEFAULT_ITEMS_NUMBER;

    this.setupDefaultData(defaultData);
    this.setPageInfoForFirstTime();
  }

  /**
   * get items on screen
   * @returns {Array} items
   */


  (0, _createClass3.default)(LazyLoadingUIStore, [{
    key: 'setupDefaultData',
    value: function setupDefaultData(defaultData) {
      if (!(0, _fp.isEmpty)(defaultData.data)) {
        this.training = false;
        this.viewHeight = defaultData.viewHeight;
        this.itemHeight = defaultData.itemHeight;
        this.items = defaultData.data;
        defaultData.isLastPage && (this.stop = true);
      }
    }

    /**
     * Set view height
     * @param {Number} height view height
     */

  }, {
    key: 'setViewHeight',
    value: function setViewHeight(height) {
      this.viewHeight = height;
    }

    /**
     * update virtual node list
     * @param {Object} source
     * @param {Object} virtualNodeDom
     */

  }, {
    key: 'updateVirtualNodes',
    value: function updateVirtualNodes(source, virtualNodeDom) {
      var virtualNode = (0, _fp.find)(function (node) {
        return (0, _fp.isEqual)(node, source);
      }, this.virtualNodes);

      virtualNode['virtualNodeDom'] = virtualNodeDom;
    }

    /**
     * Set item height
     * @param {Number} itemHeight item height
     */

  }, {
    key: 'setItemHeight',
    value: function setItemHeight(itemHeight) {
      this.itemHeight = itemHeight;
    }

    /**
     * get page information
     * @returns {Object} page information
     */

  }, {
    key: 'getPageInfo',
    value: function getPageInfo(node) {
      var fromIndex = void 0,
          pageSize = void 0,
          parentIds = void 0;
      var total = this.pageSize > 0 || this.itemHeight === 0 ? this.pageSize : Math.floor(this.viewHeight / this.itemHeight);
      this.pageSize = total;

      if (this.training) {
        fromIndex = 0;
        pageSize = this.defaultItemsNumber;
        parentIds = [];
      } else {
        fromIndex = node.fromIndex;
        pageSize = total;
        parentIds = node.parentIds;
      }

      return {
        fromIndex: fromIndex,
        pageSize: pageSize,
        parentIds: parentIds
      };
    }

    /**
     *
     * @param {*} data
     * @param {*} isLastPage
     */

  }, {
    key: 'setPageInfoForFirstTime',
    value: function setPageInfoForFirstTime() {
      this.pageInfoForFirstTime = {
        fromIndex: 0,
        pageSize: this.defaultItemsNumber,
        parentIds: []
      };
    }

    /**
     * Update data
     * @param {Object} data
     * @param {Boolean} isLastPage
     */

  }, {
    key: 'updateData',
    value: function updateData(data, isLastPage) {
      this.items = data;
      this.isLoading = false;
      this.isLastPage = isLastPage;
      isLastPage && (this.stop = true);
    }

    /**
     * Get virtual node
     * @param {Object} scrollParent
     */

  }, {
    key: 'getVirtualNode',
    value: function getVirtualNode(scrollParent) {
      var _this = this;

      var isRendering = (0, _fp.some)('isRendering', this.virtualNodes);
      if (isRendering) return;

      var scrollTop = (0, _fp.get)('scrollTop', scrollParent);

      return (0, _fp.find)(function (node) {
        var contHeight = _this.viewHeight;
        var contTop = scrollTop;
        var contBottom = contTop + contHeight;

        var elemTop = node.virtualNodeDom.offsetTop;
        return contBottom >= elemTop && elemTop >= contTop && $izenda(node.virtualNodeDom).is(':visible');
      }, this.virtualNodes);
    }

    /**
     * Set rendering node
     * @param {Object} node
     */

  }, {
    key: 'setRenderingNode',
    value: function setRenderingNode(node) {
      node.isRendering = true;
    }

    /**
     * Remove virtual node
     */

  }, {
    key: 'removeVirtualNode',
    value: function removeVirtualNode() {
      var renderingNode = (0, _fp.find)('isRendering', this.virtualNodes);
      if (!(0, _fp.isNil)(renderingNode)) {
        var renderingNodeIndex = (0, _fp.findIndex)('isRendering', this.virtualNodes);
        this.virtualNodes.splice(renderingNodeIndex, 1);
      }
    }

    /**
     * Show Loading
     */

  }, {
    key: 'showLoading',
    value: function showLoading() {
      this.isLoading = true;
    }

    /**
     * Reset virtual nodes
     */

  }, {
    key: 'resetVirtualNodes',
    value: function resetVirtualNodes() {
      this.virtualNodes.splice(1, this.virtualNodes.length);
    }
  }, {
    key: 'getItemsOnViewScreen',
    get: function get() {
      return this.isLastPage ? this.items : this.training ? (0, _fp.take)(1, this.items) : this.items;
    }

    /**
     * Setup default data for lazy loading store
     * @param  {Array} data
     * @param  {Number} viewHeight
     * @param  {Number} itemHeight
     */

  }]);
  return LazyLoadingUIStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'items', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'training', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'getItemsOnViewScreen', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getItemsOnViewScreen'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setupDefaultData', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setupDefaultData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setViewHeight', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setViewHeight'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateData', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeVirtualNode', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'removeVirtualNode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showLoading', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'showLoading'), _class.prototype)), _class));
exports.default = LazyLoadingUIStore;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoadingVirtualNode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyLoadingVirtualNode = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(LazyLoadingVirtualNode, _Component);

  function LazyLoadingVirtualNode() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LazyLoadingVirtualNode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LazyLoadingVirtualNode.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadingVirtualNode)).call.apply(_ref, [this].concat(args))), _this), _this.setDom = function (dom) {
      _this.virtualNodeDom = dom;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LazyLoadingVirtualNode, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          store = _props.store,
          source = _props.source;

      store.updateVirtualNodes(source, this.virtualNodeDom);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          store = _props2.store,
          source = _props2.source;

      store.updateVirtualNodes(source, this.virtualNodeDom);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        ref: this.setDom,
        className: this.props.className,
        style: { height: '0px' } });
    }
  }]);
  return LazyLoadingVirtualNode;
}(_react.Component), _class.propTypes = {
  store: _react.PropTypes.object,
  source: _react.PropTypes.object
}, _temp2);
exports.default = LazyLoadingVirtualNode;
module.exports = exports['default'];

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReportGrid.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * SubReportGrid Component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(82);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(44);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var constants = _Izenda2.default.SUB_REPORT;
var ValidatableDropDown = (0, _Izenda4.default)()(_Izenda6.default);

var SubReportGrid = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(SubReportGrid, _React$Component);

  function SubReportGrid() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SubReportGrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SubReportGrid.__proto__ || (0, _getPrototypeOf2.default)(SubReportGrid)).call.apply(_ref, [this].concat(args))), _this), _this.renderFieldInSubReport = function (fieldItem, key, rowIndex) {
      function changeField(object, field) {
        fieldItem.fieldInSubReport = field.querySourceFieldId;
        fieldItem.relationshipInSubReport = field.relationshipId;
        fieldItem.fieldNameInSubReport = field.fieldNameInSubReport;
      }
      var options = _this.props.model.fieldInSubReport;
      var value = (0, _fp.compact)([fieldItem.relationshipInSubReport, fieldItem.fieldInSubReport]).join('_');

      return options.length !== 0 ? _react2.default.createElement(ValidatableDropDown, {
        options: options,
        onChange: changeField,
        value: value,
        labelField: 'sourceFieldName',
        valueField: 'id',
        groupBy: 'sourceDataObjectName',
        blankOption: true,
        groupFormatText: _this.groupFormatText,
        validations: constants.CONSTRAINTS.REQUIRED_CONSTRAINT,
        field: 'fieldInSubReport',
        group: constants.SUB_REPORT_GRID.VALIDATOR_GROUP + rowIndex
      }) : null;
    }, _this.renderFieldInCurrentReportPart = function (fieldItem, key, rowIndex) {
      function changeField(object) {
        fieldItem.fieldNameAlias = object.value;
      }
      var options = _this.props.model.fieldInCurrentReportPart;

      return options.length !== 0 ? _react2.default.createElement(ValidatableDropDown, {
        options: options,
        onChange: changeField,
        value: fieldItem.fieldNameAlias,
        labelField: 'name',
        valueField: 'name',
        blankOption: true,
        groupFormatText: _this.groupFormatText,
        validations: constants.CONSTRAINTS.REQUIRED_CONSTRAINT,
        field: 'fieldInCurrentReportPart',
        group: constants.SUB_REPORT_GRID.VALIDATOR_GROUP + rowIndex
      }) : null;
    }, _this.renderDeleteField = function (fieldItem, key, rowIndex) {
      function deleteField() {
        this.props.model.removeMappingField(rowIndex);
      }
      return _react2.default.createElement(
        'a',
        { onClick: deleteField.bind(_this) },
        _react2.default.createElement('span', { className: 'icon-cancel' })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SubReportGrid, [{
    key: 'groupFormatText',
    value: function groupFormatText(text) {
      return text.connectionName + '.' + text.querySourceCategoryName + '.' + text.sourceDataObjectName;
    }
  }, {
    key: 'render',
    value: function render() {
      var TABLE_DEF = constants.TABLE_DEF;

      return _react2.default.createElement(
        _Izenda7.Table,
        { dataSource: this.props.model.gridData },
        _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF.fieldInCurrentReport, { cell: this.renderFieldInCurrentReportPart })),
        _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF.fieldInSubReport, { cell: this.renderFieldInSubReport })),
        _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF.deleteField, { cell: this.renderDeleteField }))
      );
    }
  }]);
  return SubReportGrid;
}(_react2.default.Component), _class2.displayName = 'SubReportGrid', _temp2)) || _class;

exports.default = SubReportGrid;
module.exports = exports['default'];

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TableColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;

  var TableColumn = React.createClass({
    displayName: 'TableColumn',

    propTypes: {
      width: PropTypes.number,
      minWidth: PropTypes.number,
      fixed: PropTypes.bool,
      resizable: PropTypes.bool
    },
    getDefaultProps: function getDefaultProps() {
      return {
        width: 100,
        minWidth: 100,
        fixed: false,
        resizable: true
      };
    },
    render: function render() {
      return React.createElement('span', this.props);
    }
  });

  module.exports = TableColumn;
}();

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TableColumnGroup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);

  var TableColumnGroup = React.createClass({
    displayName: 'TableColumnGroup',

    render: function render() {
      return React.createElement(
        'span',
        this.props,
        this.props.title
      );
    }
  });

  module.exports = TableColumnGroup;
}();

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
  UNSORT: ''
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.TableHeaderCell.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var TableHeaderCell = function (_Component) {
  (0, _inherits3.default)(TableHeaderCell, _Component);

  function TableHeaderCell() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableHeaderCell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderCell.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderCell)).call.apply(_ref, [this].concat(args))), _this), _this.onSortChange = function (e) {
      e.preventDefault();

      var columnKey = _this.props.columnKey;

      var sortDirection = _this.sortDirection();

      // update sort direction
      sortDirection = _this.sortDirection(changeSortDirection(sortDirection));

      if (_this.props.onSortChange) {
        _this.props.onSortChange(columnKey, sortDirection);
      }

      function changeSortDirection(sortDir) {
        switch (sortDir) {
          case SortTypes.ASC:
            return SortTypes.DESC;
          case SortTypes.DESC:
            return SortTypes.UNSORT;
          case SortTypes.UNSORT:
            return SortTypes.ASC;
          default:
            return SortTypes.ASC;
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableHeaderCell, [{
    key: 'sortDirection',
    value: function sortDirection(newValue) {
      var _props = this.props,
          columnKey = _props.columnKey,
          sortInfo = _props.sortInfo;


      if (!(0, _fp.isUndefined)(newValue) && columnKey) {
        return sortInfo[columnKey] = newValue;
      } else if (!columnKey || (0, _fp.isUndefined)(sortInfo[columnKey])) {
        return null;
      } else {
        return sortInfo[columnKey];
      }
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon() {
      var sortDirection = this.sortDirection();

      if (!sortDirection) {
        return null;
      }

      var iconClass = (0, _classnames2.default)('pull-right', {
        'icon-down-open': sortDirection === SortTypes.DESC,
        'icon-up-open': sortDirection !== SortTypes.DESC
      });

      return _react2.default.createElement('i', { className: iconClass });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          sortable = _props2.sortable,
          infoIconOptions = _props2.infoIconOptions,
          title = _props2.title;

      var classHeader = (0, _classnames2.default)({ unsort: !sortable });

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'a',
          { onClick: sortable && this.onSortChange, className: classHeader, title: title },
          title
        ),
        infoIconOptions && _react2.default.createElement('span', { className: infoIconOptions.iconClass, title: infoIconOptions.iconTitle }),
        this.renderIcon()
      );
    }
  }]);
  return TableHeaderCell;
}(_react.Component);

exports.default = TableHeaderCell;
module.exports = exports['default'];

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DraggableRow.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


!function () {
  var compose = __webpack_require__(9).compose;
  var draggable = __webpack_require__(255);
  var droppable = __webpack_require__(259);
  var TableRow = __webpack_require__(934);
  var TypeComponent = 'row';

  var options = {
    beginDrag: function beginDrag(props) {
      return {
        index: props.index,
        rowData: props.rowData,
        isDroppable: false
      };
    },
    canDrag: function canDrag(props, monitor) {
      var result = props.canDrag && props.canDrag(props.rowData);
      return result;
    }
  };

  var targetOptions = {
    drop: function drop(props, monitor, component) {
      if (monitor.didDrop()) {
        return {};
      }
      var dragIndex = monitor.getItem().index;
      var hoverIndex = props.index;
      if (monitor.getItem().isDroppable) {
        props.move(dragIndex, hoverIndex, monitor.getItem().rowData, props.rowData);
      } else {
        props.warning && props.warning();
      }
    },

    canDrop: function canDrop(props, monitor) {
      var result = props.canDrop && props.canDrop(props.rowData, monitor.getItem().rowData);
      var item = monitor.getItem();
      item.isDroppable = result;
      return true;
    }
  };

  var droppableRow = droppable(TypeComponent, targetOptions);
  var draggableRow = draggable(TypeComponent, options, false);

  module.exports = compose(draggableRow, droppableRow)(TableRow);
}();

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3; // ----------------------------------------------------------------------
// <copyright file="Izenda.TableUIStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _fastdom = __webpack_require__(486);

var _fastdom2 = _interopRequireDefault(_fastdom);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var parseFloatCustom = function parseFloatCustom(value) {
  return parseFloat(value) || 0;
};

var clamp = function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
};

var getHeight = function getHeight(dom, withBorder) {
  var domStyle = window.getComputedStyle(dom);

  return parseFloatCustom(domStyle.height) - (!withBorder ? parseFloatCustom(domStyle.borderTop) + parseFloatCustom(domStyle.borderBottom) : 0);
};

var setHeight = function setHeight(value, dom) {
  dom && (dom.style.height = value && value + 'px');
};

var syncHeight = function syncHeight(elements) {
  _fastdom2.default.mutate(function () {
    (0, _fp.forEach)(function (element) {
      setHeight(null, element);
    }, elements);

    _fastdom2.default.measure(function () {
      var heightMax = (0, _fp.flow)((0, _fp.map)(function (element) {
        return !element ? 0 : getHeight(element, true);
      }), _fp.max)(elements);

      _fastdom2.default.mutate(function () {
        (0, _fp.forEach)(setHeight.bind(null, heightMax), elements);
      });
    });
  });
};

var TableUIStore = (_class = function () {
  (0, _createClass3.default)(TableUIStore, [{
    key: 'bodyHeight',
    get: function get() {
      return Math.max(0, this.tableHeight - this.headerHeight);
    }
  }]);

  function TableUIStore(defaultColumnWidth, defaultHeight, autoResize, onTableWidthChanged) {
    (0, _classCallCheck3.default)(this, TableUIStore);

    _initDefineProp(this, 'tableHeight', _descriptor, this);

    _initDefineProp(this, 'headerHeight', _descriptor2, this);

    _initDefineProp(this, 'virtualStore', _descriptor3, this);

    this.headerGroupElements = {};
    this.headerGroups = {};
    this.headerElements = [];
    this.headerElementsPivot = {};
    this.cellElements = [];
    this.columnWidths = [];
    this.defaultColumnWidth = defaultColumnWidth;
    this.border = 1;
    this.autoResize = autoResize;
    this.maxDeep = 0;
    this.onTableWidthChanged = onTableWidthChanged;

    this.tableHeight = defaultHeight;
  }

  /**
   * Register header group cell element
   */


  (0, _createClass3.default)(TableUIStore, [{
    key: 'registerHeaderCell',
    value: function registerHeaderCell(cellElem, headerColIndex, deep) {
      this.headerElements[headerColIndex] = cellElem;
      deep = (0, _fp.isNil)(deep) ? -1 : deep;
      this.maxDeep = (0, _fp.max)([this.maxDeep, deep]);

      if (!this.headerElementsPivot[deep]) {
        this.headerElementsPivot[deep] = [];
      }

      this.headerElementsPivot[deep][headerColIndex] = cellElem;
    }

    /**
     * Unregister header group cell element
     */

  }, {
    key: 'unregisterHeaderCell',
    value: function unregisterHeaderCell(cellElem, headerColIndex, deep) {
      delete this.headerElements[headerColIndex];
      deep = (0, _fp.isNil)(deep) ? -1 : deep;

      if (this.headerElementsPivot[deep]) {
        delete this.headerElementsPivot[deep][headerColIndex];
        if ((0, _fp.isEmpty)((0, _fp.compact)(this.headerElementsPivot[deep]))) {
          delete this.headerElementsPivot[deep];
        }
      }
    }

    /**
     * Register header group cell element
     */

  }, {
    key: 'registerHeaderGroupCell',
    value: function registerHeaderGroupCell(cellElem, headerColIndex) {
      this.headerGroupElements[headerColIndex] = cellElem;
    }

    /**
     * Unregister header group cell element
     */

  }, {
    key: 'unregisterHeaderGroupCell',
    value: function unregisterHeaderGroupCell(cellElem, headerColIndex) {
      delete this.headerGroupElements[headerColIndex];
    }

    /**
     * Register row cell element
     */

  }, {
    key: 'registerCell',
    value: function registerCell(cellElem, columnIndex) {
      !this.cellElements[columnIndex] && (this.cellElements[columnIndex] = []);
      this.cellElements[columnIndex].push(cellElem);
    }

    /**
     * Unregister row cell element
     */

  }, {
    key: 'unregisterCell',
    value: function unregisterCell(cellElem, columnIndex) {
      var cellIndex = void 0;
      var cells = this.cellElements[columnIndex];
      if (cells) {
        cellIndex = cells.indexOf(cellElem);
        cellIndex > -1 && cells.splice(cellIndex, 1);
      }
    }

    /**
     * Add header group info
     */

  }, {
    key: 'addHeaderGroup',
    value: function addHeaderGroup(headerGroup) {
      this.headerGroups[headerGroup.ref] = headerGroup;
    }

    /**
     * Clean header groups
     */

  }, {
    key: 'resetHeaderGroups',
    value: function resetHeaderGroups() {
      this.headerGroups = {};
    }
  }, {
    key: 'calculateHeaderGroupWidth',
    value: function calculateHeaderGroupWidth(headeGroup) {
      return (0, _fp.flow)((0, _fp.slice)(headeGroup.startColumn, headeGroup.endColumn), _fp.sum)(this.columnWidths);
    }
  }, {
    key: 'updateHeaderHeight',
    value: function updateHeaderHeight() {
      syncHeight(this.headerElementsPivot[this.maxDeep]);
    }
  }, {
    key: 'updateCellsHeight',
    value: function updateCellsHeight() {
      var cells = (0, _fp.flattenDepth)(1, this.cellElements);
      syncHeight(cells);
    }
  }, {
    key: 'getRowSpanHeight',
    value: function getRowSpanHeight(startIndex, size) {
      var end = size && startIndex + size;

      return !this.virtualStore ? 0 : (0, _fp.flow)((0, _fp.map)('height'), _fp.sum)(this.virtualStore.items.slice(startIndex, end));
    }
  }, {
    key: 'updateHeaderGroupHeight',
    value: function updateHeaderGroupHeight() {
      var _this = this;

      _fastdom2.default.measure(function () {
        (0, _fp.flow)((0, _fp.map)(_fp.identity), (0, _fp.groupBy)('deep'), _fp.toPairs, (0, _fp.sortBy)(_fp.head), (0, _fp.map)(_fp.last), (0, _fp.forEach)(function (headerGroups) {
          var keyList = (0, _fp.map)('ref', headerGroups);
          var headerGroupDoms = (0, _fp.flow)((0, _fp.pick)(keyList), (0, _fp.map)(_fp.identity))(_this.headerGroupElements);

          syncHeight(headerGroupDoms);
        }))(_this.headerGroups);
      });
    }
  }, {
    key: 'updateHeight',
    value: function updateHeight(tableHeight, headerHeight) {
      this.tableHeight = tableHeight;
      this.headerHeight = headerHeight;
    }
  }, {
    key: 'registerVirtualStore',
    value: function registerVirtualStore(virtualStore) {
      this.virtualStore = virtualStore;
    }
  }, {
    key: 'updateWidths',
    value: function updateWidths(containerWidth, colsWidths, needUpdateColumn) {
      var _this2 = this;

      var adjustedWidths = void 0;
      var defaultColumnWidth = this.defaultColumnWidth;

      var fixWidth = (0, _fp.placeholder)(colsWidths).filter('fixed').map((0, _fp.get)('width')).reduce(_fp.add) || 0;

      var dynWidth = (0, _fp.placeholder)(colsWidths).filter({
        fixed: false
      }).map((0, _fp.get)('width')).reduce(_fp.add) || 0;

      if (!this.autoResize || containerWidth === Infinity || !containerWidth || dynWidth + fixWidth > containerWidth) {
        adjustedWidths = (0, _fp.map)((0, _fp.get)('width'), colsWidths);
      } else {
        adjustedWidths = (0, _fp.map)(function (widthInfo) {
          return widthInfo.fixed ? widthInfo.width : Math.round(widthInfo.width / dynWidth * (containerWidth - fixWidth));
        }, colsWidths);
        adjustedWidths[adjustedWidths.length - 1] += containerWidth - (0, _fp.sum)(adjustedWidths);
      }

      adjustedWidths = adjustedWidths.map(function (width) {
        return width || defaultColumnWidth;
      });

      this.columnWidths = adjustedWidths;

      if (needUpdateColumn) {
        this.columnWidths.forEach(function (width, index) {
          _this2.resizeColumn(index, width, false);
        });
      }
    }
  }, {
    key: 'getColumnWidth',
    value: function getColumnWidth(index) {
      return index < this.columnWidths.length ? this.columnWidths[index] : this.defaultColumnWidth;
    }
  }, {
    key: 'resizeColumn',
    value: function resizeColumn(index, width, isUserAction) {
      var _this3 = this;

      var headerGroupWidth = 0,
          headerGroupElement = void 0,
          headerElement = void 0;
      this.columnWidths[index] = width;

      var tableWidth = (0, _fp.sum)(this.columnWidths);
      this.onTableWidthChanged(tableWidth, index);

      _fastdom2.default.mutate(function () {
        (0, _fp.forEach)(function (cellElem) {
          $izenda(cellElem).css({
            width: width + 'px',
            minWidth: width + 'px',
            maxWidth: width + 'px'
          });
        }, _this3.cellElements[index]);

        (0, _fp.flow)((0, _fp.map)(_fp.identity), (0, _fp.filter)(function (group) {
          return group.startColumn <= index && group.endColumn > index;
        }), (0, _fp.forEach)(function (headerGroup) {
          headerGroupWidth = _this3.calculateHeaderGroupWidth(headerGroup);
          headerGroupElement = _this3.headerGroupElements[headerGroup.ref];
          headerGroupElement && $izenda(headerGroupElement).css({
            width: headerGroupWidth + 'px',
            minWidth: headerGroupWidth + 'px',
            maxWidth: headerGroupWidth + 'px'
          });
        }))(_this3.headerGroups);

        if (!isUserAction) {
          headerElement = _this3.headerElements[index];
          headerElement && $izenda(headerElement).css({
            width: width + 'px',
            minWidth: width + 'px',
            maxWidth: width + 'px'
          });
        }
      });
    }

    /**
     * Update top position
     * @param {Element} currentNode
     * @param {Element} tableDom
     */

  }, {
    key: 'updateTopPosition',
    value: function updateTopPosition(currentNode, tableDom) {
      var tableHeight = tableDom.offsetHeight;
      var currentRect = currentNode.getBoundingClientRect();
      var listVirtualStickTop = $izenda(tableDom).find('.u-virtualStickTop');
      this.listStickTop = $izenda(tableDom).find('.u-stickTop');

      this.listStickTop.each(function (index, item) {
        var cloneRect = listVirtualStickTop.get(index).getBoundingClientRect();
        var newPosition = clamp(currentRect.top - cloneRect.top, 0, tableHeight - item.offsetHeight);

        item.style.setProperty('z-index', 1);
        item.style.setProperty('top', newPosition + 'px');
      });
    }

    /**
     * Reset top position
     */

  }, {
    key: 'resetTopPosition',
    value: function resetTopPosition() {
      if (this.listStickTop) {
        this.listStickTop.each(function (index, item) {
          item.style.removeProperty('z-index');
          item.style.removeProperty('top');
        });
        this.listStickTop = null;
      }
    }

    /**
     * Update left position
     * @param {Element} currentNode
     * @param {Element} tableDom
     */

  }, {
    key: 'updateLeftPosition',
    value: function updateLeftPosition(currentNode, tableDom) {
      var _this4 = this;

      var tableWidth = (0, _fp.sum)(this.columnWidths);
      var currentRect = currentNode.getBoundingClientRect();
      var listVirtualStickLeft = $izenda(tableDom).find('.u-virtualStickLeft');
      this.listStickLeft = $izenda(tableDom).find('.u-stickLeft');

      this.listStickLeft.each(function (index, item) {
        if ($izenda(item).is(':visible')) {
          var cloneRect = listVirtualStickLeft.get(index).getBoundingClientRect();
          var left = parseInt(listVirtualStickLeft.get(index).style.left || 0);
          var newPosition = clamp(currentRect.left - cloneRect.left + left, 0, tableWidth - item.offsetWidth);
          _this4.setLeftPosition(item, newPosition);
        }
      });
    }

    /**
     * Set left position
     * @param {[type]} element
     * @param {[type]} leftPosition
     */

  }, {
    key: 'setLeftPosition',
    value: function setLeftPosition(element, leftPosition) {
      if (element) {
        element.style.setProperty('z-index', 1);
        element.style.setProperty('position', 'relative');
        element.style.setProperty('left', leftPosition + 'px');
      }
    }

    /**
     * Reset left position
     */

  }, {
    key: 'resetLeftPosition',
    value: function resetLeftPosition() {
      if (this.listStickLeft) {
        this.listStickLeft.each(function (index, item) {
          item.style.removeProperty('z-index');
          item.style.removeProperty('position');
          item.style.removeProperty('left');
        });
      }
    }
  }]);
  return TableUIStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'tableHeight', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'headerHeight', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 37;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'virtualStore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return (0, _mobx.asReference)(null);
  }
}), _applyDecoratedDescriptor(_class.prototype, 'bodyHeight', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bodyHeight'), _class.prototype)), _class);
exports.default = TableUIStore;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RowSpanColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var RowSpanCell = __webpack_require__(935);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      pick = _require.pick,
      map = _require.map;
  // defer observer virtual list into smaller component


  var RowSpanCellVirtualList = observer(function (props) {
    var element = props.element;
    var init = props.init;
    var height = props.tableStore.getRowSpanHeight(init, element.size);
    var pickFn = pick(['fnGetCellStyle', 'fnGetCellContentStyle', 'cell'], props);

    return React.createElement(
      'div',
      { className: 'table-row', style: { height: height } },
      React.createElement(RowSpanCell, (0, _extends3.default)({ rowSpan: element, height: height }, pickFn, { index: props.index }))
    );
  });

  var RowSpanColumn = React.createClass({
    displayName: 'RowSpanColumn',

    propTypes: {
      tableStore: PropTypes.object.isRequired,
      rowSpan: PropTypes.object.isRequired
    },
    render: function render() {
      var props = this.props;
      var init = 0;
      var rowSPan = props.rowSpan;
      var rowSpanFn = pick(['fnGetCellStyle', 'fnGetCellContentStyle', 'cell'], rowSPan);
      var mapConvert = map.convert({ cap: false });

      return React.createElement(
        'div',
        { className: 'table-body', style: { width: props.width } },
        mapConvert(function (element, index) {
          var oldInit = init;

          init = init + element.size;
          return React.createElement(RowSpanCellVirtualList, (0, _extends3.default)({
            element: element,
            key: oldInit,
            index: index,
            init: oldInit,
            tableStore: props.tableStore
          }, rowSpanFn));
        }, rowSPan.data)
      );
    }
  });

  module.exports = observer(RowSpanColumn);
}();

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GroupHeaderCell.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      isString = _require.isString,
      isFunction = _require.isFunction;

  var GroupHeaderCell = observer(React.createClass({
    displayName: 'GroupHeaderCell',

    render: function render() {
      var props = this.props;
      if (isFunction(this.props.renderTitle)) {
        var headerTitle = this.props.renderTitle(this.props.didUpdate);
        var title = isString(headerTitle) ? headerTitle : null;
        var infoIconOptions = props.infoIconOptions;
        return React.createElement(
          'span',
          { title: title },
          headerTitle,
          infoIconOptions && React.createElement('span', { className: infoIconOptions.iconClass, title: infoIconOptions.iconTitle })
        );
      }
      return null;
    },
    componentDidMount: function componentDidMount() {
      this.props.didUpdate && this.props.didUpdate();
    },
    componentDidUpdate: function componentDidUpdate() {
      this.props.didUpdate && this.props.didUpdate();
    }
  }));

  module.exports = GroupHeaderCell;
}();

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchCriteria.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var GridLayout = __webpack_require__(13);
  var Button = __webpack_require__(30);
  var Input = __webpack_require__(17);
  var DropDown = __webpack_require__(29);
  var DateTimePicker = __webpack_require__(170);
  var EventUtils = __webpack_require__(24);
  var ReportDesignerConstants = __webpack_require__(16);

  var TextInput = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var criteria = props.criteria;

    return React.createElement(
      GridLayout.Row,
      { className: 'form-horizontal' },
      React.createElement(
        GridLayout.Col,
        { cols: 5, className: 'u_controlHeight control-label' },
        props.label
      ),
      React.createElement(
        GridLayout.Col,
        { cols: 7 },
        React.createElement(Input, {
          value: reportPartSelection.getCriteria(criteria),
          onChange: EventUtils.notifyChange(reportPartSelection.setCriteria.bind(reportPartSelection, criteria), EventUtils.INPUT)
        })
      )
    );
  });

  var DateInput = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var criteria = props.criteria;

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: 2, className: 'control-label' },
        props.label
      ),
      React.createElement(
        GridLayout.Col,
        { cols: 10 },
        React.createElement(DateTimePicker, {
          time: false,
          value: reportPartSelection.getCriteria(criteria),
          onChange: reportPartSelection.setCriteria.bind(reportPartSelection, criteria)
        })
      )
    );
  });

  var SearchDate = connect()(function (props) {
    var localization = props.localization;

    return React.createElement(
      GridLayout.Row,
      { className: 'form-horizontal' },
      React.createElement(
        GridLayout.Col,
        { cols: 3, className: 'u_controlHeight control-label' },
        props.label
      ),
      React.createElement(
        GridLayout.Col,
        { cols: 9 },
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 6 },
            React.createElement(DateInput, (0, _extends3.default)({}, props, { criteria: props.criteria + 'From', label: localization.getText('COMMON_LABEL_FROM') }))
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 6 },
            React.createElement(DateInput, (0, _extends3.default)({}, props, { criteria: props.criteria + 'To', label: localization.getText('COMMON_LABEL_TO') }))
          )
        )
      )
    );
  });

  var SaveInto = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var reportPartSelectionStore = props.reportPartSelectionStore;
    var localization = props.localization;
    var GLOBAL_CATEGORY_TYPES = [{ value: ReportDesignerConstants.GLOBAL_REPORT_ENUM.LOCAL, label: reportPartSelectionStore.localReportName }, { value: ReportDesignerConstants.GLOBAL_REPORT_ENUM.GLOBAL, label: reportPartSelectionStore.globalReportName }];

    return React.createElement(
      GridLayout.Row,
      { className: 'form-horizontal' },
      React.createElement(
        GridLayout.Col,
        { cols: 5, className: 'u_controlHeight control-label' },
        localization.getText('COMMON_LABEL_SAVE_INTO')
      ),
      React.createElement(
        GridLayout.Col,
        { cols: 7 },
        React.createElement(DropDown, { options: GLOBAL_CATEGORY_TYPES,
          labelField: 'label',
          valueField: 'value',
          blankOption: true,
          blankOptionText: localization.getText('COMMON_LABEL_ALL'),
          value: reportPartSelection.displayCriteria.isGlobal,
          onChange: EventUtils.notifyChange(reportPartSelectionStore.selectSaveInto.bind(reportPartSelectionStore), EventUtils.DROPDOWN)
        })
      )
    );
  });

  var Category = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var reportPartSelectionStore = props.reportPartSelectionStore;
    var localization = props.localization;

    return React.createElement(
      GridLayout.Row,
      { className: 'form-horizontal' },
      React.createElement(
        GridLayout.Col,
        { cols: 5, className: 'u_controlHeight control-label' },
        localization.getText('DASHBOARD_LABEL_CATEGORY')
      ),
      React.createElement(
        GridLayout.Col,
        { cols: 7 },
        React.createElement(DropDown, { options: reportPartSelection.categoryCollection,
          labelField: 'name',
          valueField: 'id',
          blankOption: true,
          blankOptionText: localization.getText('COMMON_LABEL_ALL'),
          value: reportPartSelection.displayCriteria.selectedCategory,
          onChange: EventUtils.notifyChange(reportPartSelectionStore.selectCategory.bind(reportPartSelectionStore), EventUtils.DROPDOWN),
          disabled: reportPartSelectionStore.isCategoryDisabled
        })
      )
    );
  });

  var SubCategory = connect()(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var reportPartSelectionStore = props.reportPartSelectionStore;
    var localization = props.localization;

    return React.createElement(
      GridLayout.Row,
      { className: 'form-horizontal' },
      React.createElement(
        GridLayout.Col,
        { cols: 3, className: 'u_controlHeight control-label' },
        localization.getText('DASHBOARD_LABEL_SUB_CATEGORY')
      ),
      React.createElement(
        GridLayout.Col,
        { cols: 9 },
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 6 },
            React.createElement(DropDown, { options: reportPartSelection.subCategoryCollection,
              labelField: 'name',
              valueField: 'id',
              blankOption: true,
              blankOptionText: localization.getText('COMMON_LABEL_ALL'),
              value: reportPartSelection.displayCriteria.selectedSubCategory,
              onChange: EventUtils.notifyChange(reportPartSelection.setCriteria.bind(reportPartSelection, 'selectedSubCategory'), EventUtils.DROPDOWN),
              disabled: reportPartSelectionStore.isSubCategoryDisabled
            })
          )
        )
      )
    );
  });

  var ButtonGroup = connect()(function (props) {
    var reportPartSelectionStore = props.reportPartSelectionStore;
    var loader = props.loader;
    var localization = props.localization;

    var onSearch = function onSearch() {
      loader.startLoading();
      return reportPartSelectionStore.onSearch(props.excludeIds).then(function () {
        props.showResult && props.showResult(true);
      }).finally(loader.endLoading.bind(loader));
    };
    var onReset = function onReset() {
      loader.startLoading();
      return reportPartSelectionStore.reset().finally(loader.endLoading.bind(loader));
    };

    return React.createElement(
      'div',
      { className: 'izenda-ReportPartSelectionPopup-ActionBar u_fullWidth u_inlineBlock' },
      React.createElement(
        'div',
        { className: 'u_paddingAll izenda-ActionBarRight' },
        React.createElement(Button, { onClick: onSearch, label: localization.getText('COMMON_LABEL_SEARCH') }),
        React.createElement(Button, { onClick: onReset, label: localization.getText('COMMON_LABEL_RESET') })
      )
    );
  });

  var SearchCriteria = function SearchCriteria(props) {
    var localization = props.localization;
    return React.createElement(
      'div',
      null,
      React.createElement(
        GridLayout,
        { className: 'u_paddingAll' },
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            null,
            React.createElement(
              'strong',
              null,
              localization.getText('SEARCH_RESULT_LABEL_SEARCH_CRITERIA')
            )
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 4 },
            React.createElement(SaveInto, props)
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 4 },
            React.createElement(Category, props)
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 8 },
            React.createElement(SubCategory, props)
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 4 },
            React.createElement(TextInput, (0, _extends3.default)({}, props, {
              label: localization.getText('REPORTDESIGNER_LABEL_REPORT_NAME'),
              criteria: 'reportName' }))
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 4 },
            React.createElement(TextInput, (0, _extends3.default)({}, props, {
              label: localization.getText('COMMON_CRITERIA_CREATED_BY'),
              criteria: 'createdBy' }))
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 8 },
            React.createElement(SearchDate, (0, _extends3.default)({}, props, { label: localization.getText('COMMON_CRITERIA_CREATED_DATE'), criteria: 'createdDate' }))
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 4 },
            React.createElement(TextInput, (0, _extends3.default)({}, props, {
              label: localization.getText('COMMON_CRITERIA_EDITED_BY'),
              criteria: 'lastEditedBy' }))
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 8 },
            React.createElement(SearchDate, (0, _extends3.default)({}, props, { label: localization.getText('COMMON_CRITERIA_EDITED_DATE'), criteria: 'lastEditedDate' }))
          )
        )
      ),
      React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            null,
            React.createElement(ButtonGroup, props)
          )
        )
      )
    );
  };

  module.exports = connect()(SearchCriteria);
}();

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchResult.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);

  var ReportTable = __webpack_require__(1818);
  var GridLayoutReportPartTable = __webpack_require__(1822);
  var ButtonGroup = __webpack_require__(1823);

  var SearchResult = function SearchResult(props) {
    var localization = props.localization;

    if (!props.reportPartSelection.searchStatus || !!props.reportPartSelectionStore.onSearchPromise) {
      return null;
    }
    return React.createElement(
      'div',
      null,
      React.createElement(
        GridLayout,
        { className: 'u_paddingAll' },
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            null,
            React.createElement(
              'strong',
              null,
              localization.getText('SEARCH_RESULT_LABEL_SEARCH_RESULT')
            )
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            null,
            localization.getText('DASHBOARD_MESSAGE_SELECT_REPORT_THEN_SELECT_REPORT_PART')
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            null,
            React.createElement(ReportTable, props)
          )
        ),
        React.createElement(GridLayoutReportPartTable, props)
      ),
      React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            null,
            React.createElement(ButtonGroup, props)
          )
        )
      )
    );
  };

  module.exports = connect()(SearchResult);
}();

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportTable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var action = __webpack_require__(1819);
  var Table = __webpack_require__(44).Table;
  var Column = __webpack_require__(44).Column;
  var constants = __webpack_require__(185);
  var Paginator = __webpack_require__(97);

  var TABLE_DEF_REPORT = constants.TABLE_DEF_REPORT;

  var _require = __webpack_require__(1),
      map = _require.map;

  var ReportTable = React.createClass({
    displayName: 'ReportTable',

    renderReportData: function renderReportData(dataRow, key) {
      return React.createElement(
        'div',
        { className: 'overflow-text', title: dataRow[key] },
        dataRow[key]
      );
    },
    renderSaveInto: function renderSaveInto(dataRow, key) {
      var reportPartSelectionStore = this.props.reportPartSelectionStore;
      var saveIntoText = dataRow[key] ? reportPartSelectionStore.globalReportName : reportPartSelectionStore.localReportName;
      return React.createElement(
        'div',
        { className: 'overflow-text', title: dataRow[key] },
        saveIntoText
      );
    },
    renderRadioButton: function renderRadioButton(dataRow) {
      var selectedReport = this.props.reportPartSelection.selectedReport;

      return React.createElement('input', {
        type: 'radio',
        className: 'izenda-ReportPartSelectionPopup-ReportPartGrid-radioBtn',
        checked: dataRow === selectedReport
      });
    },
    render: function render() {
      var props = this.props;
      var reportPartSelection = props.reportPartSelection;
      var reportPartSelectionStore = props.reportPartSelectionStore;
      var pageInfo = reportPartSelection.pageInfo;

      return React.createElement(
        'section',
        null,
        React.createElement(
          Table,
          {
            dataSource: reportPartSelection.reportCollection,
            sortInfo: pageInfo.colSortDirs,
            onSortChange: props.onSortChange,
            onClickRow: reportPartSelection.setSelectedReport.bind(reportPartSelection),
            minHeight: constants.TABLE_REPORT.height,
            maxHeight: constants.TABLE_REPORT.height
          },
          map(function (columnDef) {
            return React.createElement(Column, (0, _extends3.default)({}, columnDef, { cell: this[columnDef.renderMethod] }));
          }.bind(this), TABLE_DEF_REPORT)
        ),
        React.createElement(Paginator, { onChange: props.onPageChange, onDropdownChange: props.onPageSizeChange, pageInfo: pageInfo })
      );
    }
  });

  module.exports = connect(action)(ReportTable);
}();

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartSelectionPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var withHandlers = __webpack_require__(9).withHandlers;
  var m = __webpack_require__(5);

  var action = withHandlers({
    onSortChange: function onSortChange(props) {
      return m.action(function (key, value) {
        var reportPartSelection = props.reportPartSelection;
        var reportPartSelectionStore = props.reportPartSelectionStore;
        var pageInfo = reportPartSelection.pageInfo;

        pageInfo.setColSortDirs(key, value);
        reportPartSelectionStore.updateReportGrid();
      });
    },
    onPageChange: function onPageChange(props) {
      return m.action(function (pageIndex) {
        var reportPartSelection = props.reportPartSelection;
        var reportPartSelectionStore = props.reportPartSelectionStore;
        var pageInfo = reportPartSelection.pageInfo;

        pageInfo.setPageIndex(pageIndex);
        reportPartSelectionStore.updateReportGrid();
      });
    },
    onPageSizeChange: function onPageSizeChange(props) {
      return m.action(function (pageSize) {
        var reportPartSelection = props.reportPartSelection;
        var reportPartSelectionStore = props.reportPartSelectionStore;
        var pageInfo = reportPartSelection.pageInfo;

        pageInfo.setPageSize(pageSize);
        pageInfo.setPageIndex(1);
        reportPartSelectionStore.updateReportGrid();
      });
    }
  });

  module.exports = action;
}();

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DropDownList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Drop Down List component
 */
!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);

  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      get = _require.get,
      isString = _require.isString,
      isFunction = _require.isFunction,
      uniqueId = _require.uniqueId,
      keys = _require.keys,
      isNil = _require.isNil,
      find = _require.find,
      groupBy = _require.groupBy;

  var HIDDEN_SELECTED_VALUE = '***HIDDEN VALUE***';

  var DropDownList = React.createClass({
    displayName: 'DropDownList',

    propTypes: {
      id: React.PropTypes.string,
      options: React.PropTypes.oneOfType([React.PropTypes.object.isRequired, React.PropTypes.array.isRequired]),
      value: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
      maskedHidden: React.PropTypes.bool,
      valueField: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]),
      labelField: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]),
      onChange: React.PropTypes.func,
      groupBy: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]),
      groupFormatText: React.PropTypes.func,
      blankOption: React.PropTypes.bool,
      getOptionProperties: React.PropTypes.func,
      buildGroupLabel: React.PropTypes.func,
      optionTooltip: React.PropTypes.string,
      additionalKey: React.PropTypes.string
    },

    /**
     * Get default props
     */
    getDefaultProps: function getDefaultProps() {
      return {
        value: null,
        maskedHidden: false,
        valueField: 'value',
        labelField: 'label',
        onChange: null,
        disabled: false,
        blankOption: false,
        blankOptionText: ''
      };
    },

    /**
     * Get initial state
     */
    getInitialState: function getInitialState() {
      return {
        selected: this.props.value,
        hiddenSelected: this.props.maskedHidden
      };
    },

    /**
     * Component will receive props
     */
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        selected: nextProps.value,
        hiddenSelected: nextProps.maskedHidden
      });
    },

    getValue: function getValue(valueField, option) {
      if (isString(valueField)) {
        return get(valueField, option);
      } else if (isFunction(valueField)) {
        return valueField(option);
      }
    },

    renderListOption: function renderListOption(options) {
      var props = this.props;
      var getValue = this.getValue;
      options = options || [];

      return options.map(function (option, index) {
        var value = props.valueField ? getValue(props.valueField, option) : option;
        var key = props.additionalKey ? value + props.additionalKey : value;

        var label = props.labelField ? getLabel(props.labelField, option) : option;
        var additionOptionProps = props.getOptionProperties && props.getOptionProperties(option);
        var tooltip = props.showTooltip ? option[props.optionTooltip] || label : null;

        return React.createElement(
          'option',
          (0, _extends3.default)({ key: key + index, value: value }, additionOptionProps, { title: tooltip }),
          label
        );
      });

      function getLabel(labelField, option) {
        if (isString(labelField)) {
          return get(labelField, option);
        } else if (isFunction(labelField)) {
          return labelField(option);
        }
      }
    },

    /**
     * Render component
     * @returns {Object}
     */
    render: function render() {
      var state = this.state;
      var props = this.props;
      var disabledAttr = props.disabled ? 'disabled' : null;
      var classes = classnames(this.props.className, 'form-control');
      var options = this.renderListOption(props.options);

      if (props.groupBy) {
        var optionsGrouped = groupBy(function (option) {
          return isFunction(props.groupBy) ? props.groupBy(option) : option[props.groupBy];
        }, props.options) || {};
        options = keys(optionsGrouped).map(function (name) {
          var groupValue = optionsGrouped[name];
          var group = this.renderListOption(groupValue);
          var title = props.groupFormatText ? props.groupFormatText(groupValue[0]) : '';
          var label = props.buildGroupLabel ? props.buildGroupLabel(groupValue[0]) : name;
          return React.createElement(
            'optgroup',
            { key: name, label: label, title: title },
            group
          );
        }.bind(this));
      }

      props.blankOption && options.unshift(React.createElement(
        'option',
        { key: uniqueId('blankOption_'), value: '', disabled: props.disabledBlankOption },
        props.blankOptionText
      ));

      state.hiddenSelected && options.push(React.createElement(
        'option',
        { key: uniqueId('hide_'), className: 'hide', value: HIDDEN_SELECTED_VALUE },
        '\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF'
      ));

      var selectedValue = state.hiddenSelected ? HIDDEN_SELECTED_VALUE : !isNil(state.selected) ? state.selected : props.defaultValue;
      var selectedOption = find({ value: selectedValue }, props.options);
      var selectTooltip = selectedOption && selectedOption[props.labelField];

      return React.createElement(
        'select',
        {
          ref: 'selectCtrl',
          id: this.props.id,
          title: props.showTooltip ? selectTooltip : null,
          className: classes,
          value: selectedValue,
          onChange: this.handleChange,
          disabled: disabledAttr,
          onFocus: props.onFocus
        },
        options
      );
    },

    componentDidUpdate: function componentDidUpdate() {
      var selectedValue = !isNil(this.state.selected) ? this.state.selected : '';
      var selectCtrl = this.refs.selectCtrl;

      // sync value of control and component state
      if (!selectedValue && selectCtrl.value !== selectedValue) {
        selectCtrl.value = selectedValue;
      }
    },

    /**
     * Handle change
     */
    handleChange: function handleChange(e) {
      var oldValue = this.state.selected;
      var value = e.target.value;
      var getValue = this.getValue;

      this.setState({
        selected: value,
        hiddenSelected: false
      });
      if (this.props.onChange) {
        var valueField = this.props.valueField;
        var labelField = this.props.labelField;
        var selectedItem = find(function (option) {
          return value == getValue(valueField, option);
        }, this.props.options);
        var change = {
          value: e.target.value,
          label: get(labelField, selectedItem)
        };
        (0, _bluebird.resolve)(this.props.onChange(change, selectedItem)).catch(function () {
          // revert to old value if the promise is reject
          this.setState({ selected: oldValue });
        }.bind(this));
      }
    }
  });

  module.exports = observer(DropDownList);
}();

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobxReact = __webpack_require__(10);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

exports.default = (0, _recompose.compose)(_mobxReact.observer, (0, _recompose.mapProps)(function (props) {
  var pageInfo = props.pageInfo,
      totalRecords = props.totalRecords,
      pageSize = props.pageSize;


  return (0, _fp.assignAll)([(0, _fp.pick)(['pageSize', 'pageIndex', 'totalRecords'], pageInfo), {
    totalPage: (0, _fp.getOr)((0, _fp.ceil)(totalRecords / pageSize), 'totalPage', pageInfo)
  }, (0, _fp.omit)(['pageInfo'], props)]);
}), (0, _recompose.withProps)(function (props) {
  var pageSize = props.pageSize,
      pageIndex = props.pageIndex,
      currentPageSize = props.currentPageSize,
      totalRecords = props.totalRecords;

  var beginRecord = pageSize * (pageIndex - 1) + 1;
  var currentSize = (0, _fp.isNil)(currentPageSize) ? pageSize : currentPageSize;

  return {
    beginRecord: beginRecord,
    endRecord: (0, _fp.min)([beginRecord + currentSize - 1, totalRecords])
  };
})); // ----------------------------------------------------------------------
// <copyright file="Izenda.PaginatorAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);
  var Table = __webpack_require__(44).Table;
  var Column = __webpack_require__(44).Column;
  var constants = __webpack_require__(185);
  var Paginator = __webpack_require__(97);
  var Dimensions = __webpack_require__(83);
  var GridLayout = __webpack_require__(13);

  var TABLE_DEF_REPORT_PART = constants.TABLE_DEF_REPORT_PART;

  var _require = __webpack_require__(1),
      flow = _require.flow,
      isNil = _require.isNil;

  var ReportPartTable = observer(function (props) {
    var reportPartSelection = props.reportPartSelection;
    var reportPartPageInfo = reportPartSelection.reportPartPageInfo;

    /**
     * render report name cell
     * @method renderReportPartName
     * @param  {object}         dataRow Current Row being render
     * @return {React Componenet}
     */
    var renderReportPartName = function renderReportPartName(dataRow) {
      return React.createElement(
        'div',
        { className: 'overflow-text' },
        dataRow.title
      );
    };

    /**
     * render selected icon
     * @method renderRadioButton
     * @param  {object}         dataRow Current Row being render
     * @return {React Componenet}
     */
    var renderRadioButton = function renderRadioButton(dataRow) {
      return React.createElement('input', {
        type: 'radio',
        className: 'izenda-ReportPartSelectionPopup-ReportPartGrid-radioBtn',
        checked: dataRow === reportPartSelection.selectedReportPart
      });
    };

    /**
     * render report part type
     * @method renderReportPartTypeCell
     * @param  {object}         dataRow Current Row being render
     * @return {React Componenet}
     */
    var renderReportPartTypeCell = function renderReportPartTypeCell(dataRow) {
      return React.createElement(
        'div',
        { className: 'overflow-text' },
        React.createElement('span', { className: dataRow.typeIcon }),
        dataRow.reportPartTypeName
      );
    };

    return React.createElement(
      'section',
      null,
      React.createElement(
        Table,
        {
          dataSource: props.reportPartSelection.currentPageReportPartCollection,
          sortInfo: reportPartPageInfo.colSortDirs,
          onSortChange: reportPartPageInfo.setColSortDirs.bind(reportPartPageInfo),
          onClickRow: reportPartSelection.setSelectedReportPart.bind(reportPartSelection),
          minHeight: constants.TABLE_REPORT_PART.height,
          maxHeight: constants.TABLE_REPORT_PART.height
        },
        React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF_REPORT_PART.selectedIcon, { cell: renderRadioButton })),
        React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF_REPORT_PART.reportPartTitle, { cell: renderReportPartName })),
        React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF_REPORT_PART.reportPartTypeName, { cell: renderReportPartTypeCell }))
      ),
      React.createElement(Paginator, {
        onChange: reportPartPageInfo.setPageIndex.bind(reportPartPageInfo),
        onDropdownChange: flow(reportPartPageInfo.setPageSize.bind(reportPartPageInfo), reportPartPageInfo.setPageIndex.bind(reportPartPageInfo, 1)),
        totalRecords: reportPartPageInfo.totalRecords,
        pageSize: reportPartPageInfo.pageSize,
        pageIndex: reportPartPageInfo.pageIndex
      })
    );
  });

  var GridLayoutReportPartTable = connect()(function (props) {
    if (!props.showReportPart || isNil(props.reportPartSelection.selectedReport)) {
      return null;
    }
    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        null,
        React.createElement(ReportPartTable, props)
      )
    );
  });

  module.exports = connect()(GridLayoutReportPartTable);
}();

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(30);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = function ButtonGroup(props) {
  var localization = props.localization;

  return _react2.default.createElement(
    'div',
    { className: 'izenda-ReportPartSelectionPopup-ActionBar u_fullWidth u_inlineBlock' },
    _react2.default.createElement(
      'div',
      { className: 'u_paddingAll izenda-ActionBarRight' },
      _react2.default.createElement(_Izenda4.default, { onClick: props.onBack, label: localization.getText('COMMON_LABEL_BACK') }),
      _react2.default.createElement(_Izenda4.default, {
        onClick: props.onOK,
        label: localization.getText('COMMON_LABEL_OK'),
        disabled: props.checkDisabledAcceptButton()
      }),
      _react2.default.createElement(_Izenda4.default, { onClick: props.onReject, label: localization.getText('COMMON_LABEL_CANCEL') })
    )
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ButtonGroup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda2.default)()(ButtonGroup);
module.exports = exports['default'];

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchProcessBar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Loading = __webpack_require__(152);

  var SearchProcessBar = function SearchProcessBar(props) {
    var localization = props.localization;
    var searchPromise = props.reportPartSelectionStore.onSearchPromise;

    if (searchPromise && searchPromise.isPending) {
      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(
              'strong',
              { className: 'u_inlineBlock u_paddingAll' },
              localization.getText('DASHBOARD_LABEL_SEARCHING')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 8, className: 'u_controlHeight u_paddingAll' },
            React.createElement(Loading, { show: true, withoutBorder: true })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 2, onClick: searchPromise.cancel.bind(searchPromise) },
            React.createElement(
              'a',
              { className: 'u_paddingAll u_inlineBlock u_textLink' },
              localization.getText('COMMON_LABEL_CANCEL')
            )
          )
        )
      );
    }
    return null;
  };

  module.exports = connect()(SearchProcessBar);
}();

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartSelectionPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var ReportPartSelectionStore = __webpack_require__(1826);
  var ReportPartSelectionConstants = __webpack_require__(185);
  var withHandlers = __webpack_require__(9).withHandlers;
  var withProps = __webpack_require__(9).withProps;
  var compose = __webpack_require__(9).compose;
  var withState = __webpack_require__(9).withState;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil;

  var action = compose(withProps(function (props) {
    var reportPartSelectionStore = new ReportPartSelectionStore();

    return {
      reportPartSelectionStore: reportPartSelectionStore,
      showReportPart: props.type === ReportPartSelectionConstants.TYPE.REPORT_PART
    };
  }), withState('isShowResult', 'showResult', false), withHandlers({
    onBack: curry(function (props, e) {
      props.showResult(false);
    }),
    onOK: curry(function (props, e) {
      var reportPartSelection = props.reportPartSelectionStore.reportPartSelection;
      var returnObject = props.showReportPart ? reportPartSelection.selectedReportPart : reportPartSelection.selectedReport;

      props.onAccept();
      props.onChange({
        report: reportPartSelection.selectedReport,
        reportPart: reportPartSelection.selectedReportPart
      });
    }),
    checkDisabledAcceptButton: function checkDisabledAcceptButton(props) {
      return function () {
        var reportPartSelection = props.reportPartSelectionStore.reportPartSelection;

        return props.showReportPart ? isNil(reportPartSelection.selectedReportPart) : isNil(reportPartSelection.selectedReport);
      };
    }
  }));

  module.exports = action;
}();

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartSelectionStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(111);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1827);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(90);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(15);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(104);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportPartSelectionStore = (_class = function () {
  (0, _createClass3.default)(ReportPartSelectionStore, [{
    key: 'tenantId',
    get: function get() {
      return _Izenda10.default.getTenantId();
    }
  }, {
    key: 'statusSaveInto',
    get: function get() {
      return {
        visible: (0, _fp.isNil)(_Izenda10.default.tenantId) && !!_Izenda10.default.currentUser.systemAdmin
      };
    }
  }, {
    key: 'isCategoryDisabled',
    get: function get() {
      return (0, _fp.flow)((0, _fp.getOr)(null, 'displayCriteria.isGlobal'), _fp.isNil)(this.reportPartSelection);
    }
  }]);

  function ReportPartSelectionStore() {
    (0, _classCallCheck3.default)(this, ReportPartSelectionStore);

    _initDefineProp(this, 'reportPartSelection', _descriptor, this);

    _initDefineProp(this, 'onSearchPromise', _descriptor2, this);

    _initDefineProp(this, 'globalReportName', _descriptor3, this);

    _initDefineProp(this, 'localReportName', _descriptor4, this);

    this.excludeIds = [];
    this.reset();
  }

  /**
   * apply new search criteria
   * @method onSearch
   * @return {Function}
   */


  (0, _createClass3.default)(ReportPartSelectionStore, [{
    key: 'onSearch',
    value: function onSearch(excludeIds) {
      var _this = this;

      this.reportPartSelection.applyDisplayCriteria();
      this.excludeIds = excludeIds;

      return (0, _mobx.action)(function () {
        _this.onSearchPromise = _this.updateReportGrid();
        return _this.onSearchPromise.finally(function () {
          _this.onSearchPromise = null;
        });
      })();
    }

    /**
     * Cancel the observer
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this.reportPartSelection.destroy();
    }

    /**
     * load list of report after sort and paging
     * @method updateReportGrid
     * @return {Promise}     Ajax promise
     */

  }, {
    key: 'updateReportGrid',
    value: function updateReportGrid() {
      var reportPartSelection = this.reportPartSelection;
      var query = reportPartSelection.buildSearchReportQuery(this.excludeIds);

      return _Izenda2.default.searchReport(query).then(reportPartSelection.readListReport.bind(reportPartSelection));
    }

    /**
     * reset search
     * @method reset
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.reportPartSelection = new _Izenda4.default();
      this.loadCategorySettings();
      return this.loadCategories();
    }

    /**
     * To get the name text "Global/ Local"
     */

  }, {
    key: 'loadCategorySettings',
    value: function loadCategorySettings() {
      var _this2 = this;

      _Izenda12.default.loadCategorySettings().then((0, _mobx.action)(function (result) {
        var globalReportType = (0, _fp.find)({ isGlobal: true }, result);
        var localReportType = (0, _fp.find)({ isGlobal: false }, result);
        _this2.globalReportName = (0, _fp.getOr)(null, 'name', globalReportType);
        _this2.localReportName = (0, _fp.getOr)(null, 'name', localReportType);
      }));
    }

    /**
     * load category
     * @method loadCategories
     * @return {[type]}       [description]
     */

  }, {
    key: 'loadCategories',
    value: function loadCategories() {
      var reportPartSelection = this.reportPartSelection;
      var loadVisible = true;

      return _Izenda6.default.loadCategories(_Izenda8.default.REPORT_TYPE_ENUM.REPORT, this.tenantId, reportPartSelection.isGlobal, loadVisible).then(reportPartSelection.readListCategory.bind(reportPartSelection));
    }

    /**
     * set category and load subCategory
     * @method selectCategory
     * @param  {[type]}       categoryId
     * @return {Promise}
     */

  }, {
    key: 'selectCategory',
    value: function selectCategory(categoryId) {
      var reportPartSelection = this.reportPartSelection;
      var selectedCategory = (0, _fp.isEmpty)(categoryId) ? null : categoryId;
      var loadVisible = true;

      reportPartSelection.setCriteria('selectedCategory', selectedCategory);
      if ((0, _fp.isNil)(selectedCategory)) {
        return (0, _bluebird.resolve)();
      }

      return _Izenda6.default.loadSubCategories(categoryId, loadVisible).then(reportPartSelection.readListSubCategory.bind(reportPartSelection));
    }

    /**
     * set "save into" and load category
     * @method selectSaveInto
     */

  }, {
    key: 'selectSaveInto',
    value: function selectSaveInto(globalCategoryType) {
      var reportPartSelection = this.reportPartSelection;
      // Types of 'globalCategoryType' are string and number
      var type = globalCategoryType === '' ? null : globalCategoryType;
      reportPartSelection.setCriteria('isGlobal', type);
      reportPartSelection.applyDisplayCriteria();

      if (type != null) {
        this.loadCategories();
      }
    }
  }]);
  return ReportPartSelectionStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'reportPartSelection', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'onSearchPromise', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'globalReportName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'localReportName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tenantId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'statusSaveInto', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'statusSaveInto'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isCategoryDisabled', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isCategoryDisabled'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectSaveInto', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectSaveInto'), _class.prototype)), _class);
exports.default = ReportPartSelectionStore;
module.exports = exports['default'];

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTile.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var PagingModel = __webpack_require__(98);
  var ReportPartTypeManager = __webpack_require__(142);
  var moment = __webpack_require__(19);
  var uiState = __webpack_require__(15);
  var convertToDateTimeFormat = __webpack_require__(88);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      map = _require.map,
      omit = _require.omit,
      isNil = _require.isNil,
      flow = _require.flow,
      get = _require.get,
      last = _require.last,
      reject = _require.reject,
      compact = _require.compact,
      defaults = _require.defaults,
      omitBy = _require.omitBy,
      getOr = _require.getOr,
      toPairs = _require.toPairs,
      head = _require.head,
      lowerCase = _require.lowerCase,
      orderBy = _require.orderBy,
      slice = _require.slice,
      capitalize = _require.capitalize;

  function ReportPartSelection() {
    var colSortReportDirs = {
      reportname: 'DESC'
    };
    var colSortReportPartDirs = {
      title: 'DESC'
    };
    var props = {
      // for paginator of report table
      pageInfo: new PagingModel(colSortReportDirs),
      // for paginator of report part table
      reportPartPageInfo: new PagingModel(colSortReportPartDirs),
      criteria: {
        reportName: '',
        createdBy: '',
        createdDateFrom: '',
        createdDateTo: '',
        lastEditedBy: '',
        lastEditedDateFrom: '',
        lastEditedDateTo: ''
      },
      selectedReport: null,
      selectedReportPart: null,
      reportCollection: [],
      selectedCategory: null,
      selectedSubCategory: null,
      categoryCollection: [],
      subCategoryCollection: [],
      searchStatus: false,
      isGlobal: false, // true/ false/ null
      displayCriteria: {
        isGlobal: null, // 1/ 0/ null
        selectedCategory: null,
        selectedSubCategory: null,
        reportName: '',
        createdBy: '',
        createdDateFrom: '',
        createdDateTo: '',
        lastEditedBy: '',
        lastEditedDateFrom: '',
        lastEditedDateTo: ''
      },
      reportPartCollection: function reportPartCollection() {
        return this.selectedReport && this.selectedReport.reportPart;
      },
      totalReportPart: function totalReportPart() {
        return getOr(0, 'length', this.reportPartCollection);
      },
      currentPageReportPartCollection: function currentPageReportPartCollection() {
        var sortData = flow(omitBy(isEmpty), toPairs)(this.reportPartPageInfo.colSortDirs);
        var sortKey = map(head, sortData);
        var sortDirection = map(flow(last, lowerCase), sortData);
        var startItem = (this.reportPartPageInfo.pageIndex - 1) * this.reportPartPageInfo.pageSize;
        var endItem = startItem + this.reportPartPageInfo.pageSize;

        return flow(orderBy(sortKey, sortDirection), slice(startItem, endItem))(this.reportPartCollection);
      },
      tenantId: function tenantId() {
        return uiState.getTenantId();
      }
    };

    m.extendObservable(this, props);

    this.isGlobalObserve = m.observe(this.displayCriteria, 'isGlobal', function () {
      this.clearCategory();
    }.bind(this));
    this.selectedCategoryObserve = m.observe(this.displayCriteria, 'selectedCategory', function () {
      this.clearSubCategory();
    }.bind(this));
  }

  /**
   * Cancel the observer
   */
  ReportPartSelection.prototype.destroy = function () {
    this.isGlobalObserve();
    this.selectedCategoryObserve();
  };

  /**
   * apply display criteria to become real criteria
   * @method applyDisplayCritria
   * @return {[type]}            [description]
   */
  ReportPartSelection.prototype.applyDisplayCriteria = function () {
    m.transaction(function () {
      var isGlobal = this.displayCriteria.isGlobal;
      this.isGlobal = isNil(isGlobal) ? isGlobal : !!isGlobal;
      this.selectedCategory = this.displayCriteria.selectedCategory;
      this.selectedSubCategory = this.displayCriteria.selectedSubCategory;
      this.pageInfo.setPageIndex(1);
      this.reportPartPageInfo.setPageIndex(1);
      this.criteria = omit(['selectedCategory', 'selectedSubCategory'], this.displayCriteria);
    }.bind(this));
  };

  /**
   * Clear selected category
   */
  ReportPartSelection.prototype.clearCategory = function () {
    this.displayCriteria.selectedCategory = null;
  };

  /**
   * Clear selected sub-category
   */
  ReportPartSelection.prototype.clearSubCategory = function () {
    this.displayCriteria.selectedSubCategory = null;
  };

  /**
   * build query object to get list report
   * @method buildSearchReportQuery
   * @return {json}               JSON object use for api
   */
  ReportPartSelection.prototype.buildSearchReportQuery = function (excludeIds) {
    this.pageInfo.buildSortOrder();
    return {
      isGlobal: this.isGlobal,
      subcategoryid: this.selectedSubCategory,
      categoryId: this.selectedCategory,
      tenantId: this.tenantId,
      pageSize: this.pageInfo.pageSize,
      pageIndex: this.pageInfo.pageIndex,
      sortOrders: this.pageInfo.sortOrders,
      excludeIds: excludeIds,
      criteria: flow(toPairs, map(function (item) {
        return {
          key: item[0],
          value: item[1],
          operation: 1
        };
      }), reject(flow(get('value'), isEmpty)), compact)(this.criteria)
    };
  };

  /**
   * read list of category from API
   * @method readListCategory
   * @param  {[type]}         result [description]
   */
  ReportPartSelection.prototype.readListCategory = function (result) {
    this.categoryCollection = result;
  };

  /**
   * read list of sub category from api
   * @method readListSubCategory
   * @param  {[type]}            result [description]
   */
  ReportPartSelection.prototype.readListSubCategory = function (result) {
    this.subCategoryCollection = result;
  };

  /**
   * get criteria from display criteria
   * @method getCriteria
   * @param  {[type]}    key [description]
   * @return {[type]}        [description]
   */
  ReportPartSelection.prototype.getCriteria = function (key) {
    return this.displayCriteria[key];
  };

  /**
   * update criteria to display criteria
   * @method setCriteria
   * @param  {[type]}    key   [description]
   * @param  {[type]}    value [description]
   */
  ReportPartSelection.prototype.setCriteria = function (key, value) {
    this.displayCriteria[key] = value;
  };

  /**
   * set selected report part
   * @method setSelectedReportPart
   * @param  {reportPart}              reportPart Select report part
   */
  ReportPartSelection.prototype.setSelectedReportPart = function (reportPart) {
    m.transaction(function () {
      this.selectedReportPart = reportPart;
    }.bind(this));
  };

  /**
   * set selected report
   * @method setSelectedReport
   * @param  {JSON}          report Selected report
   */
  ReportPartSelection.prototype.setSelectedReport = function (report) {
    m.transaction(function () {
      this.selectedReport = report;
      this.selectedReportPart = null;
      this.reportPartPageInfo.pageIndex = 1;
      this.reportPartPageInfo.setTotalRecords(getOr(0, 'length', report.reportPart));
    }.bind(this));
  };

  /**
   * list of report receive from api
   * @method readListReport
   * @param  {result}       result Result object from api
   */
  ReportPartSelection.prototype.readListReport = m.action(function (result) {
    this.searchStatus = true;
    this.selectedReport = null;
    this.selectedReportPart = null;
    this.reportCollection = map(function (report) {
      report.reportPart = map(function (item) {
        var typeConfig = ReportPartTypeManager.getReportPartType(item.reportPartContent.type);
        var typeInfo = {
          typeIcon: typeConfig.icon,
          reportPartTypeName: capitalize(typeConfig.key)
        };

        return defaults(item, typeInfo);
      }, report.reportPart);
      report.created = convertToDateTimeFormat(uiState.currentUser.dateFormat, report.created);
      report.modified = convertToDateTimeFormat(uiState.currentUser.dateFormat, report.modified);
      return report;
    }, result.result);
    this.pageInfo.setTotalRecords(result.total);
  });

  module.exports = ReportPartSelection;
}();

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Performance.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var commonMessages = __webpack_require__(37);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      isObject = _require.isObject;

  function Performance() {
    var props = {
      queryTimeoutValue: 0,
      useNoLockValue: false,
      dataSourceLimitValue: 0,
      fieldLimitValue: 0,
      queryLimitValue: 0,
      pivotColumnLimitValue: 0,

      queryTimeoutDefaultValue: 0,
      useNoLockDefaultValue: true,
      dataSourceLimitDefaultValue: 0,
      fieldLimitDefaultValue: 0,
      pivotColumnLimitDefaultValue: 0,
      queryLimitDefaultValue: 0,
      filterLimitValue: 0,
      filterLimitDefaultValue: 0,
      alertMessage: commonMessages.EMPTY_MESSAGE,
      modified: null
    };

    m.extendObservable(trackable(this), props);
  }

  /**
   * Read performance data and fill to props
   * @param {object} result
   */
  Performance.prototype.readPerformanceData = m.action(function (result) {
    result = result || {};

    this.queryTimeoutValue = parseInt(result.queryTimeoutValue);
    this.useNoLockValue = result.useNoLockValue;
    this.dataSourceLimitValue = parseInt(result.dataSourceLimitValue);
    this.fieldLimitValue = parseInt(result.fieldLimitValue);
    this.queryLimitValue = parseInt(result.queryLimitValue);
    this.pivotColumnLimitValue = parseInt(result.pivotColumnLimitValue);
    this.filterLimitValue = parseInt(result.filterLimitValue);

    // Default value
    this.queryTimeoutDefaultValue = parseInt(result.queryTimeoutDefaultValue);
    this.useNoLockDefaultValue = result.useNoLockDefaultValue;
    this.dataSourceLimitDefaultValue = parseInt(result.dataSourceLimitDefaultValue);
    this.fieldLimitDefaultValue = parseInt(result.fieldLimitDefaultValue);
    this.queryLimitDefaultValue = parseInt(result.queryLimitDefaultValue);
    this.pivotColumnLimitDefaultValue = parseInt(result.pivotColumnLimitDefaultValue);
    this.filterLimitDefaultValue = parseInt(result.filterLimitDefaultValue);

    this.modified = result.modified;

    // Reset Dirty
    this.resetDirty();
    return null;
  });

  /**
   * Update new value
   * @param  {[type]} key    [description]
   * @param  {[type]} value) [description]
   * @return {[type]}        [description]
   */
  Performance.prototype.updateValue = m.action(function (key, value) {
    switch (key) {
      case 'queryTimeout':
        this.queryTimeoutValue = parseInt(value) || 0;
        break;
      case 'useNoLock':
        this.useNoLockValue = value;
        break;
      case 'dataSourceLimit':
        this.dataSourceLimitValue = parseInt(value) || 0;
        break;
      case 'fieldLimit':
        this.fieldLimitValue = parseInt(value) || 0;
        break;
      case 'queryLimit':
        this.queryLimitValue = parseInt(value) || 0;
        break;
      case 'pivotColumnLimit':
        this.pivotColumnLimitValue = parseInt(value) || 0;
        break;
      case 'filterLimit':
        this.filterLimitValue = parseInt(value) || 0;
        break;
    }

    this.markDirty();
  });

  /**
   * Reset default value
   * @param  {[type]} key) [description]
   * @return {[type]}      [description]
   */
  Performance.prototype.resetValue = m.action(function (key) {
    switch (key) {
      case 'queryTimeout':
        this.queryTimeoutValue = this.queryTimeoutDefaultValue;
        break;
      case 'useNoLock':
        this.useNoLockValue = this.useNoLockDefaultValue;
        break;
      case 'dataSourceLimit':
        this.dataSourceLimitValue = this.dataSourceLimitDefaultValue;
        break;
      case 'fieldLimit':
        this.fieldLimitValue = this.fieldLimitDefaultValue;
        break;
      case 'queryLimit':
        this.queryLimitValue = this.queryLimitDefaultValue;
        break;
      case 'pivotColumnLimit':
        this.pivotColumnLimitValue = this.pivotColumnLimitDefaultValue;
        break;
      case 'filterLimit':
        this.filterLimitValue = this.filterLimitDefaultValue;
        break;
    }

    this.markDirty();
  });

  /**
   * Build data for save
   */
  Performance.prototype.buildSaveData = function (tenantId) {
    return {
      queryTimeoutValue: this.queryTimeoutValue,
      useNoLockValue: this.useNoLockValue,
      dataSourceLimitValue: this.dataSourceLimitValue,
      fieldLimitValue: this.fieldLimitValue,
      queryLimitValue: this.queryLimitValue,
      pivotColumnLimitValue: this.pivotColumnLimitValue,
      filterLimitValue: this.filterLimitValue,
      tenantId: tenantId,
      modified: this.modified
    };
  };

  /**
   * Show error when value over limited
   */
  Performance.prototype.showErrorWhenOverLimited = function (name, value) {
    this.alertMessage = {
      type: 'info',
      message: String.format(localizer.getText('COMMON_MESSAGES_NUMBER_SMALLER'), name, value)
    };
  };

  /**
   * Reset error message
   */
  Performance.prototype.resetErrorMessage = function () {
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
  };

  /**
   * Show alert message after save
   */
  Performance.prototype.showAlertMessage = function (result) {
    var message = localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED');
    if (!result.success) {
      var messageData = result.messages[0];
      if (isObject(messageData)) {
        message = messageData.messages;
      } else {
        message = messageData;
      }
    }
    this.alertMessage = {
      type: result.success ? 'success' : 'error',
      message: message
    };
    return null;
  };

  module.exports = Performance;
}();

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  BUNDLE: {
    TOOLTIP: {
      get TENANT_TOOLTIP() {
        return _Izenda2.default.getText('SECURITY_TENANT_TOOLTIP');
      },
      get SHOW_TENANT_TOOLTIP() {
        return _Izenda2.default.getText('SECURITY_SHOW_TENANT_TOOLTIP');
      },
      get VISIBLE_FIELD_TOOLTIP() {
        return _Izenda2.default.getText('SECURITY_VISIBLE_FIELD_TOOLTIP');
      },
      get FILTERABLE_FIELD_TOOLTIP() {
        return _Izenda2.default.getText('SECURITY_FILTERABLE_FIELD_TOOLTIP');
      },
      get RESET_TENANT_FIELD_TOOLTIP() {
        return _Izenda2.default.getText('SECURITY_RESET_TENANT_FIELD_TOOLTIP');
      }
    },
    LABEL: {
      get TENANT_FIELD_LABEL() {
        return _Izenda2.default.getText('SECURITY_LABEL_TENANT_FIELD');
      },
      get SHOW_TENANT_FIELD_LABEL() {
        return _Izenda2.default.getText('SECURITY_LABEL_SHOW_TENANT_FIELD');
      },
      get VISIBLE_FIELD_LABEL() {
        return _Izenda2.default.getText('SECURITY_LABEL_ADDITIVE_FIELDS_AUTO_VISIBLE');
      },
      get FILTERABLE_FIELD_LABEL() {
        return _Izenda2.default.getText('SECURITY_LABEL_ADDITIVE_FIELDS_AUTO_FILTERABLE');
      },
      get SYSTEM_TENANT_FIELD_LABEL() {
        return _Izenda2.default.getText('SECURITY_LABEL_SYSTEM_TENANT_FIELD');
      }
    },
    TEXT: {
      get TENANT_FIELD_NO_RESULT_TEXT() {
        return _Izenda2.default.getText('SECURITY_TENANT_FIELD_NO_RESULT_TEXT');
      }
    }
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Secutiry.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var commonMessages = __webpack_require__(37);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      reduce = _require.reduce,
      isObject = _require.isObject;

  function Security() {
    this.tenantFieldDefaultValue = '';
    this.showTenantFieldDefaultValue = true;
    this.additiveFieldAutoVisibleDefaultValue = false;
    this.additiveFieldAutoFilterableDefaultValue = false;

    var props = {
      tenantFieldValue: '',
      tenantFields: [],
      showTenantFieldValue: false,
      additiveFieldAutoVisibleValue: false,
      additiveFieldAutoFilterableValue: false,
      tenantId: null,
      errors: [],
      isSystemMode: true,
      alertMessage: commonMessages.EMPTY_MESSAGE,
      modified: null
    };

    m.extendObservable(trackable(this), props);
  }

  /**
   * Read Securtity Data
   */
  Security.prototype.readSecuritySetting = m.action(function (result) {
    result = result || {};

    this.tenantFieldValue = result.tenantFieldValue;
    this.tenantFields = result.tenantFields;
    this.showTenantFieldValue = result.showTenantFieldValue;
    this.additiveFieldAutoVisibleValue = result.setAdditiveFieldAutoVisibleValue;
    this.additiveFieldAutoFilterableValue = result.setAdditiveFieldAutoFilterableValue;

    this.tenantFieldDefaultValue = result.tenantFieldDefaultValue;
    this.showTenantFieldDefaultValue = result.showTenantFieldDefaultValue;
    this.additiveFieldAutoVisibleDefaultValue = result.setAdditiveFieldAutoVisibleDefaultValue;
    this.additiveFieldAutoFilterableDefaultValue = result.setAdditiveFieldAutoFilterableDefaultValue;
    this.tenantId = result.tenantId;

    this.modified = result.modified;

    // Reset Dirty
    this.resetDirty();
  });

  /**
   * Reset tenant field value
   */
  Security.prototype.resetTenantFieldValue = m.action(function () {
    this.tenantFieldValue = this.tenantFieldDefaultValue;
    this.markDirty();
  });

  /**
   * Update Tenant Field
   */
  Security.prototype.updateTenantField = m.action(function (value) {
    this.tenantFieldValue = value;
    this.markDirty();
  });

  /**
   * Add new Tenant Field
   */
  Security.prototype.addNewTenantField = m.action(function (newValue) {
    this.tenantFieldValue += ';' + newValue;
    this.markDirty();
  });

  /**
   * Update Show Tenant Field
   */
  Security.prototype.updateShowTenantField = m.action(function (value) {
    this.showTenantFieldValue = value;
    this.markDirty();
  });

  /**
   * Update Additive Field Auto Filterable Value
   */
  Security.prototype.updateFieldsFilterable = m.action(function (value) {
    this.additiveFieldAutoFilterableValue = value;
    this.markDirty();
  });

  /**
   * Update Additive Field Auto Visible Value
   */
  Security.prototype.updateFieldVisible = m.action(function (value) {
    this.additiveFieldAutoVisibleValue = value;
    this.markDirty();
  });

  /**
   * Get System Tenant Fields
   */
  Security.prototype.getSystemTenantFields = function () {
    var tenantFields = this.tenantFields || [];
    return reduce(function (result, field) {
      if (field.isSystem) {
        result = result + field.name + ';';
      }
      return result;
    }, '', tenantFields);
  };

  /**
   * Build save data
   */
  Security.prototype.buildSaveData = function (tenantId) {
    return {
      tenantFieldValue: this.tenantFieldValue,
      showTenantFieldValue: this.showTenantFieldValue,
      setAdditiveFieldAutoVisibleValue: this.additiveFieldAutoVisibleValue,
      setAdditiveFieldAutoFilterableValue: this.additiveFieldAutoFilterableValue,
      tenantId: tenantId,
      modified: this.modified
    };
  };

  /**
   * Reset error message
   */
  Security.prototype.resetErrorMessage = function () {
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
  };

  /**
   * Show alert message after save
   */
  Security.prototype.showAlertMessage = function (result) {
    var message = localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED');
    if (!result.success) {
      var messageData = result.messages[0];
      if (isObject(messageData)) {
        message = messageData.messages;
      } else {
        message = messageData;
      }
    }

    this.alertMessage = {
      type: result.success ? 'success' : 'error',
      message: message
    };
    return null;
  };

  module.exports = Security;
}();

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32;
// ----------------------------------------------------------------------
// <copyright file="Izenda.OtherSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * other settings model
 */

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(939);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(54);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(264);

var _Izenda6 = __webpack_require__(37);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(15);

var _Izenda9 = _interopRequireDefault(_Izenda8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var OtherSettings = (0, _Izenda4.default)(_class = (_class2 = function () {
  function OtherSettings() {
    (0, _classCallCheck3.default)(this, OtherSettings);

    _initDefineProp(this, 'defaultSortColumnName', _descriptor, this);

    _initDefineProp(this, 'defaultTrimTimeInJoins', _descriptor2, this);

    _initDefineProp(this, 'defaultTimezoneOffset', _descriptor3, this);

    _initDefineProp(this, 'showTimeZoneOffset', _descriptor4, this);

    _initDefineProp(this, 'sortColumnNameValue', _descriptor5, this);

    _initDefineProp(this, 'sortColumnNameDefaultValue', _descriptor6, this);

    _initDefineProp(this, 'trimTimeInJoinsValue', _descriptor7, this);

    _initDefineProp(this, 'trimTimeInJoinsDefaultValue', _descriptor8, this);

    _initDefineProp(this, 'timezoneForDataOffsetValue', _descriptor9, this);

    _initDefineProp(this, 'timezoneForDataOffsetDefaultValue', _descriptor10, this);

    _initDefineProp(this, 'timezoneForTimestampOffsetValue', _descriptor11, this);

    _initDefineProp(this, 'timezoneForTimestampOffsetDefaultValue', _descriptor12, this);

    _initDefineProp(this, 'convertNullToEmptyStringValue', _descriptor13, this);

    _initDefineProp(this, 'convertNullToEmptyStringDefaultValue', _descriptor14, this);

    _initDefineProp(this, 'showSchemaNameValue', _descriptor15, this);

    _initDefineProp(this, 'showSchemaNameDefaultValue', _descriptor16, this);

    _initDefineProp(this, 'showIntroductionTextValue', _descriptor17, this);

    _initDefineProp(this, 'showIntroductionTextDefaultValue', _descriptor18, this);

    _initDefineProp(this, 'introductionTextValue', _descriptor19, this);

    _initDefineProp(this, 'introductionTextDefaultValue', _descriptor20, this);

    _initDefineProp(this, 'sendToDiskPathValue', _descriptor21, this);

    _initDefineProp(this, 'sendToDiskPathDefaultValue', _descriptor22, this);

    _initDefineProp(this, 'commonFilterSettingValue', _descriptor23, this);

    _initDefineProp(this, 'commonFilterSettingDefaultValue', _descriptor24, this);

    _initDefineProp(this, 'multipleSortOnGridHeaderValue', _descriptor25, this);

    _initDefineProp(this, 'multipleSortOnGridHeaderDefaultValue', _descriptor26, this);

    _initDefineProp(this, 'showPreviewValue', _descriptor27, this);

    _initDefineProp(this, 'showPreviewDefaultValue', _descriptor28, this);

    _initDefineProp(this, 'alertMessage', _descriptor29, this);

    _initDefineProp(this, 'tenantId', _descriptor30, this);

    _initDefineProp(this, 'modified', _descriptor31, this);

    _initDefineProp(this, 'hideReportHeaderAndFooterValue', _descriptor32, this);
  }

  (0, _createClass3.default)(OtherSettings, [{
    key: 'readOtherSettingsDetail',
    value: function readOtherSettingsDetail(otherSettings) {
      var defaultTimezoneForDataOffsetValue = 0;
      var defaultTimezoneForTimestampOffsetValue = 0;
      this.sortColumnNameValue = otherSettings.sortColumnNameValue;
      this.trimTimeInJoinsValue = otherSettings.trimTimeInJoinsValue;
      this.timezoneForDataOffsetValue = _Izenda5.TimeZoneOffset.formatTimeZone(parseInt(otherSettings.timezoneForDataOffsetValue) || defaultTimezoneForDataOffsetValue);
      this.timezoneForTimestampOffsetValue = _Izenda5.TimeZoneOffset.formatTimeZone(parseInt(otherSettings.timezoneForTimestampOffsetValue) || defaultTimezoneForTimestampOffsetValue);
      this.convertNullToEmptyStringValue = otherSettings.convertNullToEmptyStringValue;
      this.showSchemaNameValue = otherSettings.showSchemaNameValue;
      this.showIntroductionTextValue = otherSettings.showIntroductionTextValue;
      this.introductionTextValue = otherSettings.introductionTextValue;
      this.sendToDiskPathValue = otherSettings.sendToDiskPathValue;
      this.commonFilterSettingValue = otherSettings.commonFilterSettingValue;
      this.multipleSortOnGridHeaderValue = otherSettings.multipleSortOnGridHeaderValue;
      this.showPreviewValue = otherSettings.showPreviewValue;
      this.hideReportHeaderAndFooterValue = otherSettings.hideReportHeaderAndFooterValue;

      // Default value
      this.sortColumnNameDefaultValue = otherSettings.sortColumnNameDefaultValue;
      this.trimTimeInJoinsDefaultValue = otherSettings.trimTimeInJoinsDefaultValue;
      this.timezoneForDataOffsetDefaultValue = otherSettings.timezoneForDataOffsetDefaultValue;
      this.timezoneForTimestampOffsetDefaultValue = otherSettings.timezoneForTimestampOffsetDefaultValue;
      this.convertNullToEmptyStringDefaultValue = otherSettings.convertNullToEmptyStringDefaultValue;
      this.showSchemaNameDefaultValue = otherSettings.showSchemaNameDefaultValue;
      this.showIntroductionTextDefaultValue = otherSettings.showIntroductionTextDefaultValue;
      this.introductionTextDefaultValue = otherSettings.introductionTextDefaultValue;
      this.sendToDiskPathDefaultValue = otherSettings.sendToDiskPathDefaultValue;
      this.commonFilterSettingDefaultValue = otherSettings.commonFilterSettingDefaultValue;
      this.multipleSortOnGridHeaderDefaultValue = otherSettings.multipleSortOnGridHeaderDefaultValue;
      this.showPreviewDefaultValue = otherSettings.showPreviewDefaultValue;
      this.hideReportHeaderAndFooterDefaultValue = otherSettings.hideReportHeaderAndFooterDefaultValue;

      this.tenantId = otherSettings.tenantId || null;
      this.modified = otherSettings.modified;

      this.resetDirty();
      return null;
    }

    /**
     * Get bundle data
     * @return {Object}
     */

  }, {
    key: 'getBundle',
    value: function getBundle() {
      return _Izenda2.default.BUNDLE;
    }

    /**
     * Reset value
     * @param {string} key
     */

  }, {
    key: 'resetValue',
    value: function resetValue(key) {
      switch (key) {
        case 'sortColumnName':
          this.sortColumnNameValue = this.sortColumnNameDefaultValue;
          break;
        case 'trimTimeInJoins':
          this.trimTimeInJoinsValue = this.trimTimeInJoinsDefaultValue;
          break;
        case 'timezoneForDataOffset':
          this.timezoneForDataOffsetValue = this.timezoneForDataOffsetDefaultValue;
          break;
        case 'timezoneForTimestampOffset':
          this.timezoneForTimestampOffsetValue = this.timezoneForTimestampOffsetDefaultValue;
          break;
        case 'convertNullToEmptyString':
          this.convertNullToEmptyStringValue = this.convertNullToEmptyStringDefaultValue;
          break;
        case 'showSchemaName':
          this.showSchemaNameValue = this.showSchemaNameDefaultValue;
          break;
        case 'showIntroductionText':
          this.showIntroductionTextValue = this.showIntroductionTextDefaultValue;
          break;
        case 'introductionText':
          this.introductionTextValue = this.introductionTextDefaultValue;
          break;
        case 'sendToDiskPath':
          this.sendToDiskPathValue = this.sendToDiskPathDefaultValue;
          break;
        case 'commonFilterSetting':
          this.commonFilterSettingValue = this.commonFilterSettingDefaultValue;
          break;
        case 'multipleSortOnGridHeader':
          this.multipleSortOnGridHeaderValue = this.multipleSortOnGridHeaderDefaultValue;
          break;
        case 'showPreview':
          this.showPreviewValue = this.showPreviewDefaultValue;
          break;
        case 'hideReportHeaderAndFooter':
          this.hideReportHeaderAndFooterValue = this.hideReportHeaderAndFooterDefaultValue;
          break;
      }

      this.markDirty();
    }

    /**
     * Update value
     * @param {string} key
     * @param {Object} value
     */

  }, {
    key: 'updateValue',
    value: function updateValue(key, value) {
      switch (key) {
        case 'sortColumnName':
          this.sortColumnNameValue = value;
          break;
        case 'trimTimeInJoins':
          this.trimTimeInJoinsValue = value;
          break;
        case 'timezoneForDataOffset':
          if (_Izenda5.TimeZoneOffset.checkTimeZoneFormatOnTyping(value)) {
            this.timezoneForDataOffsetValue = value;
          }
          break;
        case 'timezoneForTimestampOffset':
          if (_Izenda5.TimeZoneOffset.checkTimeZoneFormatOnTyping(value)) {
            this.timezoneForTimestampOffsetValue = value;
          }
          break;
        case 'convertNullToEmptyString':
          this.convertNullToEmptyStringValue = value;
          break;
        case 'showSchemaName':
          this.showSchemaNameValue = value;
          break;
        case 'showIntroductionText':
          this.showIntroductionTextValue = value;
          break;
        case 'introductionText':
          this.introductionTextValue = value;
          break;
        case 'sendToDiskPath':
          this.sendToDiskPathValue = value;
          break;
        case 'commonFilterSetting':
          this.commonFilterSettingValue = parseInt(value);
          break;
        case 'multipleSortOnGridHeader':
          this.multipleSortOnGridHeaderValue = value;
          break;
        case 'showPreview':
          this.showPreviewValue = value;
          break;
        case 'hideReportHeaderAndFooter':
          this.hideReportHeaderAndFooterValue = value;
          break;
      }

      this.markDirty();
    }

    /**
     * Update timezone offset after typing
     * @param {string} key
     * @param {string} value
     */

  }, {
    key: 'updateTimezoneOffset',
    value: function updateTimezoneOffset(key, value) {
      var defaultTimezoneOffset = 0;
      var newValue = _Izenda5.TimeZoneOffset.formatTimeZone(parseInt(value) || defaultTimezoneOffset);

      switch (key) {
        case 'timezoneForDataOffset':
          this.timezoneForDataOffsetValue = newValue;
          break;
        case 'timezoneForTimestampOffset':
          this.timezoneForTimestampOffsetValue = newValue;
          break;
      }

      this.markDirty();
    }

    /**
     * Reset error message
     */

  }, {
    key: 'resetErrorMessage',
    value: function resetErrorMessage() {
      this.alertMessage = _Izenda7.default.EMPTY_MESSAGE;
    }
  }, {
    key: 'isAllowMultiSortDisplayed',
    get: function get() {
      return (0, _fp.isNil)(_Izenda9.default.tenantId);
    }
  }, {
    key: 'canShowPreview',
    get: function get() {
      return !_Izenda9.default.tenantId && !_Izenda9.default.onlyShowTenant;
    }

    /**
     * Read others setting detail data (mostly this data comes from API).
     * @param {Object} otherSettings
     */

  }]);
  return OtherSettings;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'defaultSortColumnName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'defaultTrimTimeInJoins', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'defaultTimezoneOffset', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'showTimeZoneOffset', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'sortColumnNameValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'sortColumnNameDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'trimTimeInJoinsValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'trimTimeInJoinsDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'timezoneForDataOffsetValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'timezoneForDataOffsetDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'timezoneForTimestampOffsetValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'timezoneForTimestampOffsetDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'convertNullToEmptyStringValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'convertNullToEmptyStringDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'showSchemaNameValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'showSchemaNameDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'showIntroductionTextValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'showIntroductionTextDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, 'introductionTextValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, 'introductionTextDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, 'sendToDiskPathValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, 'sendToDiskPathDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, 'commonFilterSettingValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, 'commonFilterSettingDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class2.prototype, 'multipleSortOnGridHeaderValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class2.prototype, 'multipleSortOnGridHeaderDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class2.prototype, 'showPreviewValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class2.prototype, 'showPreviewDefaultValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class2.prototype, 'alertMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda7.default.EMPTY_MESSAGE;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class2.prototype, 'tenantId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class2.prototype, 'modified', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class2.prototype, 'hideReportHeaderAndFooterValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'isAllowMultiSortDisplayed', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isAllowMultiSortDisplayed'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'canShowPreview', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'canShowPreview'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readOtherSettingsDetail', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readOtherSettingsDetail'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetValue'), _class2.prototype)), _class2)) || _class;

exports.default = OtherSettings;
module.exports = exports['default'];

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hasInstance = __webpack_require__(1833);

var _hasInstance2 = _interopRequireDefault(_hasInstance);

var _getIterator2 = __webpack_require__(940);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _symbol = __webpack_require__(656);

var _symbol2 = _interopRequireDefault(_symbol);

var _ownKeys = __webpack_require__(1838);

var _ownKeys2 = _interopRequireDefault(_ownKeys);

exports.default = mixin;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://raganwald.com/2015/06/26/decorators-in-es7.html
function mixin(behaviour) {
  var sharedBehaviour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var instanceKeys = (0, _ownKeys2.default)(behaviour);
  var sharedKeys = (0, _ownKeys2.default)(sharedBehaviour);
  var typeTag = (0, _symbol2.default)('isa');

  function _mixin(clazz) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(instanceKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var property = _step.value;

        (0, _defineProperty2.default)(clazz.prototype, property, {
          value: behaviour[property],
          writable: true
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    (0, _defineProperty2.default)(clazz.prototype, typeTag, { value: true });
    return clazz;
  }
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(sharedKeys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var property = _step2.value;

      (0, _defineProperty2.default)(_mixin, property, {
        value: sharedBehaviour[property],
        enumerable: sharedBehaviour.propertyIsEnumerable(property)
      });
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  (0, _defineProperty2.default)(_mixin, _hasInstance2.default, {
    value: function value(i) {
      return !!i[typeTag];
    }
  });
  return _mixin;
}
module.exports = exports['default'];

/***/ }),
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfileMenuStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var constants = __webpack_require__(1843);

  function MyProfileMenuStore() {
    this.contextMenu = constants.MENU_DEFINITION;

    m.extendObservable(this, {
      contextMenuActiveLink: constants.MENU_DEFINITION[0].key,
      menuStatus: false
    });
  }

  /**
   * Change active link
   * @param {type} newLink
   */
  MyProfileMenuStore.prototype.changeActiveLink = m.action('changeMenuItem', function (newLink) {
    if (this.contextMenuActiveLink !== newLink) {
      this.contextMenuActiveLink = newLink;
    }
  });

  /**
   * Update menu state
   * @param {type} newState
   */
  MyProfileMenuStore.prototype.updateMenuState = m.action('updateMenuState', function (newState) {
    this.menuStatus = newState;
  });

  module.exports = MyProfileMenuStore;
}();

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfileConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  MENU_DEFINITION: [{
    key: 'myPreference',
    icon: 'icon-data-source',
    title: 'My Preference'
  }, {
    key: 'securityOptions',
    icon: 'icon-fields',
    title: 'Security Options'
  }]
};
module.exports = exports['default'];

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(247);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'License/'; // ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * Get license status
   * @returns {promise}
   */
  getLicenseStatus: _Izenda4.default.memoize(function () {
    return (0, _Izenda2.default)(ROOT_URL + 'Status').get().then((0, _fp.get)('licenseStatus'));
  }),

  /**
   * Validate license
   * @param {string} licenseKey
   * @param {string} tokenKey
   * @returns {promise}
   */
  validateLicense: function validateLicense(licenseKey, tokenKey) {
    var data = {
      LicenseKey: licenseKey
    };

    if (tokenKey) {
      data.TokenKey = tokenKey;
    }

    return (0, _Izenda2.default)(ROOT_URL + 'validate').post(data);
  },


  /**
   * Get license information
   * @returns {promise}
   */
  getLicenseInformation: _Izenda4.default.memoize(function () {
    return (0, _Izenda2.default)(ROOT_URL + 'currenttoken').get();
  })
};
module.exports = exports['default'];

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure, $izenda) {

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Export.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  __webpack_require__(55);
  var config = __webpack_require__(40);
  var uiState = __webpack_require__(15);
  var AccountConstants = __webpack_require__(60);
  var AuthUtils = __webpack_require__(245);
  var SecurityManager = __webpack_require__(120);

  __webpack_require__(1846);

  /**
   * Web API data fetcher
   * @constructor
   * @param {string} path - Query url path
   * @param {Object} config - Advanced configuration.
   */
  function Export(path, config) {
    this.path = path;
    this.config = config;
  }

  /**
   * Resolve API url from path
   * @param {type} path
   * @returns {type}
   */
  Export.prototype.resolveUrl = function (path) {
    ensure(path || path !== '', 'Path of url must be provided');
    var root = config.WebApiUrl;
    var safePath = path ? path[0] === '/' ? path.substring(1) : path : '';
    return root.concat(root.slice(-1) !== '/' ? '/'.concat(safePath) : safePath);
  };

  /**
   * Download file using jquery file downloader library
   * @param  {string} method      download method
   * @param  {object} requestData request data
   * @param  {string} path        api path
   * @return {Promise}
   */
  Export.prototype.download = function (method, requestData, successCallBack, failCallBack, checkExportStatus) {
    var url = this.resolveUrl(this.path);
    var securityManager = new SecurityManager();
    var fileSession = String.newGuid();

    (0, _assign2.default)(requestData, {
      access_token: securityManager.getAccessToken(),
      current_tenant: uiState.getTenantId(),
      fileSessionKey: fileSession,
      rootPath: config.RootPath
    });

    return $izenda.fileDownload(url, {
      httpMethod: method,
      data: requestData,
      cookieValue: true,
      cookieName: fileSession,
      successCallback: successCallBack,
      failCallback: failCallBack,
      checkStatus: checkExportStatus
    });
  };

  /**
   * Export file by post method using jquery file downloader plugin
   * @param  {obhect} requesetData  request data
   * @return {Promise}
   */
  Export.prototype.post = function (requesetData, successCallBack, failCallBack, checkExportStatus) {
    return this.download('POST', requesetData, successCallBack, failCallBack, checkExportStatus);
  };

  /**
   * Export file by get method using jquery file downloader plugin
   * @param  {obhect} requesetData  request data
   * @return {Promise}
   */
  Export.prototype.get = function (requesetData, successCallBack) {
    return this.download('GET', requesetData, successCallBack);
  };

  module.exports = function (path, config) {
    return new Export(path, config);
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(26)))

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.FileDownloader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/*
 * jQuery File Download Plugin v1.4.5
 *
 * http://www.johnculviner.com
 *
 * Copyright (c) 2013 - John Culviner
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * !!!!NOTE!!!!
 * You must also write a cookie in conjunction with using this plugin as mentioned in the orignal post:
 * http://johnculviner.com/jquery-file-download-plugin-for-ajax-like-feature-rich-file-downloads/
 * !!!!NOTE!!!!
 */

(function ($izenda, window) {
  // i'll just put them here to get evaluated on script load
  var htmlSpecialCharsRegEx = /[<>&\r\n"']/gm;
  var htmlSpecialCharsPlaceHolders = {
    '<': 'lt;',
    '>': 'gt;',
    '&': 'amp;',
    '\r': '#13;',
    '\n': '#10;',
    '"': 'quot;',
    '\'': '#39;' /* single quotes just to be safe, IE8 doesn't support &apos;, so use &#39; instead */
  };

  $izenda.extend({
    //
    // $izenda.fileDownload('/path/to/url/', options)
    //  see directly below for possible 'options'
    fileDownload: function fileDownload(fileUrl, options) {
      // provide some reasonable defaults to any unspecified options below
      var settings = $izenda.extend({
        //
        // Requires jQuery UI: provide a message to display to the user
        // when the file download is being prepared before the browser's dialog appears
        //
        preparingMessageHtml: null,

        //
        // Requires jQuery UI: provide a message to display to the user when a file download fails
        //
        failMessageHtml: null,

        //
        // the stock android browser straight up doesn't support file downloads initiated
        // by a non GET: http://code.google.com/p/android/issues/detail?id=1780
        // specify a message here to display if a user tries with an android browser
        // if jQuery UI is installed this will be a dialog, otherwise it will be an alert
        // Set to null to disable the message and attempt to download anyway
        //
        androidPostUnsupportedMessageHtml: 'Unfortunately your Android browser doesn\'t support this type of file download.' + ' Please try again with a different browser.',

        //
        // Requires jQuery UI: options to pass into jQuery UI Dialog
        //
        dialogOptions: { modal: true },

        //
        // a function to call while the download is being prepared before the browser's dialog appears
        // Args:
        //  url - the original url attempted
        //
        prepareCallback: function prepareCallback(url) {},

        //
        // a function to call after a file download successfully completed
        // Args:
        //  url - the original url attempted
        //
        successCallback: function successCallback(url) {},

        //
        // a function to call after a file download request was canceled
        // Args:
        //  url - the original url attempted
        //
        abortCallback: function abortCallback(url) {},

        //
        // a function to call after a file download failed
        // Args:
        //  responseHtml    - the html that came back in response to the file download.
        //                     this won't necessarily come back depending on the browser.
        //                     in less than IE9 a cross domain error occurs because 500+ errors
        //                     cause a cross domain issue due to IE subbing out the
        //                      server's error message with a "helpful" IE built in message
        //  url             - the original url attempted
        //  error           - original error cautch from exception
        //
        failCallback: function failCallback(responseHtml, url, error) {},

        //
        // the HTTP method to use. Defaults to "GET".
        //
        httpMethod: 'GET',

        //
        // if specified will perform a "httpMethod" request to the specified 'fileUrl' using the specified data.
        // data must be an object (which will be $izenda.param serialized) or already a key=value param string
        //
        data: null,

        //
        // a period in milliseconds to poll to determine if a successful file download has occurred or not
        //
        checkInterval: 2000,

        //
        // the cookie name to indicate if a file download has occurred
        //
        cookieName: 'fileDownload',

        //
        // the cookie value for the above name to indicate that a file download has occurred
        //
        cookieValue: 'true',

        //
        // the cookie path for above name value pair
        //
        cookiePath: '/',

        //
        // if specified it will be used when attempting to clear the above name value pair
        // useful for when downloads are being served on a subdomain (e.g. downloads.example.com)
        //
        cookieDomain: null,

        //
        // the title for the popup second window as a download is processing in the case of a mobile browser
        //
        popupWindowTitle: 'Initiating file download...',

        //
        // Functionality to encode HTML entities for a POST, need this if data is an object with properties
        // whose values contains strings with quotation marks.
        // HTML entity encoding is done by replacing all &,<,>,',",\r,\n characters.
        // Note that some browsers will POST the string htmlentity-encoded
        // whilst others will decode it before POSTing.
        // It is recommended that on the server, htmlentity decoding is done irrespective.
        //
        encodeHTMLEntities: true,

        //
        // a function to check status after a file download request was called
        checkStatus: function checkStatus() {}
      }, options);

      var deferred = new $izenda.Deferred();

      // Setup mobile browser detection: Partial credit: http://detectmobilebrowser.com/
      var userAgent = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase();

      // has full support of features in iOS 4.0+, uses a new window to accomplish this.
      var isIos;
      // has full support of GET features in 4.0+ by using a new window.
      // Non - GET is completely unsupported by the browser. See above for specifying a message.
      var isAndroid;
      // there is no way to reliably guess here so all other mobile devices will GET and POST to the current window.
      var isOtherMobileBrowser;

      if (/ip(ad|hone|od)/.test(userAgent)) {
        isIos = true;
      } else if (userAgent.indexOf('android') !== -1) {
        isAndroid = true;
      } else {
        isOtherMobileBrowser = /avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|playbook|silk|iemobile|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|e\-|e\/|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|xda(\-|2|g)|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4));
      }

      var httpMethodUpper = settings.httpMethod.toUpperCase();

      if (isAndroid && httpMethodUpper !== 'GET' && settings.androidPostUnsupportedMessageHtml) {
        // the stock android browser straight up doesn't support file downloads
        // initiated by non GET requests: http://code.google.com/p/android/issues/detail?id=1780

        if ($izenda().dialog) {
          $izenda('<div>').html(settings.androidPostUnsupportedMessageHtml).dialog(settings.dialogOptions);
        }

        return deferred.reject();
      }

      var $preparingDialog = null;

      var internalCallbacks = {
        onPrepare: function onPrepare(url) {
          // wire up a jquery dialog to display the preparing message if specified
          if (settings.preparingMessageHtml) {
            $preparingDialog = $izenda('<div>').html(settings.preparingMessageHtml).dialog(settings.dialogOptions);
          } else if (settings.prepareCallback) {
            settings.prepareCallback(url);
          }
        },

        onSuccess: function onSuccess(url) {
          // remove the perparing message if it was specified
          if ($preparingDialog) {
            $preparingDialog.dialog('close');
          }

          settings.successCallback(url);

          deferred.resolve(url);
        },

        onAbort: function onAbort(url) {
          // remove the perparing message if it was specified
          if ($preparingDialog) {
            $preparingDialog.dialog('close');
          }

          settings.abortCallback(url);

          deferred.reject(url);

          // Stop call check status
          settings.checkStatus = null;
        },

        onFail: function onFail(responseHtml, url, error) {
          // remove the perparing message if it was specified
          if ($preparingDialog) {
            $preparingDialog.dialog('close');
          }

          // wire up a jquery dialog to display the fail message if specified
          if (settings.failMessageHtml) {
            $izenda('<div>').html(settings.failMessageHtml).dialog(settings.dialogOptions);
          }

          settings.failCallback(responseHtml, url, error);

          deferred.reject(responseHtml, url);
        }
      };

      internalCallbacks.onPrepare(fileUrl);

      // make settings.data a param string if it exists and isn't already
      if (settings.data !== null && typeof settings.data !== 'string') {
        settings.data = $izenda.param(settings.data);
      }

      var $iframe, downloadWindow, formDoc, $form;

      if (httpMethodUpper === 'GET') {
        if (settings.data !== null) {
          // need to merge any fileUrl params with the data object

          var qsStart = fileUrl.indexOf('?');

          if (qsStart !== -1) {
            // we have a querystring in the url

            if (fileUrl.substring(fileUrl.length - 1) !== '&') {
              fileUrl = fileUrl + '&';
            }
          } else {
            fileUrl = fileUrl + '?';
          }

          fileUrl = fileUrl + settings.data;
        }

        if (isIos || isAndroid) {
          downloadWindow = window.open(fileUrl);
          downloadWindow.document.title = settings.popupWindowTitle;
          window.focus();
        } else if (isOtherMobileBrowser) {
          window.location(fileUrl);
        } else {
          // create a temporary iframe that is used to request the fileUrl as a GET request
          $iframe = $izenda('<iframe>').hide().prop('src', fileUrl).appendTo('body');
        }
      } else {
        var formInnerHtml = '';

        if (settings.data !== null) {
          $izenda.each(settings.data.replace(/\+/g, ' ').split('&'), function () {
            var kvp = this.split('=');

            // Issue: When value contains sign '=' then the kvp array does have more than 2 items.
            // We have to join value back
            var k = kvp[0];
            kvp.shift();
            var v = kvp.join('=');
            kvp = [k, v];

            var key = settings.encodeHTMLEntities ? htmlSpecialCharsEntityEncode(decodeURIComponent(kvp[0])) : decodeURIComponent(kvp[0]);
            if (key) {
              var value = settings.encodeHTMLEntities ? htmlSpecialCharsEntityEncode(decodeURIComponent(kvp[1])) : decodeURIComponent(kvp[1]);
              formInnerHtml += '<input type="hidden" name="' + key + '" value="' + value + '" />';
            }
          });
        }

        if (isOtherMobileBrowser) {
          $form = $izenda('<form>').appendTo('body');
          $form.hide().prop('method', settings.httpMethod).prop('action', fileUrl).html(formInnerHtml);
        } else {
          if (isIos) {
            downloadWindow = window.open('about:blank');
            downloadWindow.document.title = settings.popupWindowTitle;
            formDoc = downloadWindow.document;
            window.focus();
          } else {
            $iframe = $izenda('<iframe style=\'display: none\' src=\'about:blank\'></iframe>').appendTo('body');
            formDoc = getiframeDocument($iframe);
          }

          formDoc.write('<html><head></head><body><form method=\'' + settings.httpMethod + '\' action=\'' + fileUrl + '\'>' + formInnerHtml + '</form>' + settings.popupWindowTitle + '</body></html>');
          $form = $izenda(formDoc).find('form');
        }

        $form.submit();
      }

      // check if the file download has completed every checkInterval ms
      setTimeout(checkFileDownloadComplete, settings.checkInterval);

      function checkFileDownloadComplete() {
        // has an error occured?
        // if neither containers exist below then the file download is occuring on the current window
        if (downloadWindow || $iframe) {
          // has an error occured?
          try {
            var formDoc = downloadWindow ? downloadWindow.document : getiframeDocument($iframe);

            if (formDoc && formDoc.body !== null && formDoc.body.innerHTML.length) {
              var isFailure = true;

              if ($form && $form.length) {
                var $contents = $izenda(formDoc.body).contents().first();

                try {
                  if ($contents.length && $contents[0] === $form[0]) {
                    isFailure = false;
                  }
                } catch (e) {
                  if (e && e.number == -2146828218) {
                    // IE 8-10 throw a permission denied after the form reloads
                    // on the "$contents[0] === $form[0]" comparison
                    isFailure = true;
                  } else {
                    throw e;
                  }
                }
              }

              if (isFailure) {
                // IE 8-10 don't always have the full content available right away, they need a litle bit to finish
                setTimeout(function () {
                  internalCallbacks.onFail(formDoc.body.innerHTML, fileUrl);
                  cleanUp(true);
                }, 100);

                return;
              }
            }
          } catch (err) {
            // 500 error less than IE9
            internalCallbacks.onFail('', fileUrl, err);

            cleanUp(true);

            return;
          }
        }

        // Call check export status
        settings.checkStatus && settings.checkStatus(settings.cookieName).then(function (done) {
          if (done) {
            // execute specified callback
            internalCallbacks.onSuccess(fileUrl);

            // remove cookie
            var cookieData = settings.cookieName + '=; path=' + settings.cookiePath + '; expires=' + new Date(0).toUTCString() + ';';
            if (settings.cookieDomain) cookieData += ' domain=' + settings.cookieDomain + ';';
            document.cookie = cookieData;

            // remove iframe
            cleanUp(false);
          } else {
            // keep checking...
            setTimeout(checkFileDownloadComplete, settings.checkInterval);
          }
        });
      }

      // gets an iframes document in a cross browser compatible manner
      function getiframeDocument($iframe) {
        var iframeDoc = $iframe[0].contentWindow || $iframe[0].contentDocument;
        if (iframeDoc.document) {
          iframeDoc = iframeDoc.document;
        }
        return iframeDoc;
      }

      function cleanUp(isFailure) {
        setTimeout(function () {
          if (downloadWindow) {
            if (isAndroid) {
              downloadWindow.close();
            }

            if (isIos) {
              if (downloadWindow.focus) {
                downloadWindow.focus(); // ios safari bug doesn't allow a window to be closed unless it is focused
                if (isFailure) {
                  downloadWindow.close();
                }
              }
            }
          }

          // iframe cleanup appears to randomly cause the download to fail
          // not doing it seems better than failure...
          // if ($iframe) {
          //    $iframe.remove();
          // }
        }, 0);
      }

      function htmlSpecialCharsEntityEncode(str) {
        return str.replace(htmlSpecialCharsRegEx, function (match) {
          return '&' + htmlSpecialCharsPlaceHolders[match];
        });
      }
      var promise = deferred.promise();
      promise.abort = function () {
        cleanUp();
        $iframe.attr('src', '').html('');
        internalCallbacks.onAbort(fileUrl);
      };
      return promise;
    }
  });
})($izenda, undefined || window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReport.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var constants = __webpack_require__(16);
  var subReportConstant = __webpack_require__(82).SUB_REPORT;

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      pluck = _require.pluck,
      map = _require.map,
      compact = _require.compact,
      flow = _require.flow,
      set = _require.set,
      find = _require.find;

  var CALCULATED_FIELD_CATE_NAME = 'Calculated Fields';

  function SubReport() {
    this.ADD_MAPPING_FIELD_BUTTON = 'addMappingField';

    var props = {
      fieldInCurrentReportPart: [],
      fieldInSubReport: [],
      gridData: [],
      reportParts: [],
      selectedReport: null,
      style: constants.DRIL_DOWN_STYLE.LINK_NEW_WINDOW,
      reportPartUsed: null,
      reportFilter: true,
      viewSettingByLink: true,
      selectedReportName: null,
      selectedIconValue: {
        icon: subReportConstant.DEFAULT_ICON.icon,
        value: subReportConstant.DEFAULT_ICON.value
      }
    };

    m.extendObservable(this, props);
  }

  /**
   * Read initial data from props
   * @param {Object} data
   */
  SubReport.prototype.readInitialData = m.action(function (data, hideViewSetting) {
    data = data || {};
    var viewSettingByLink = !isNil(data.viewSettingByLink) ? !!data.viewSettingByLink : true;
    var selectedIconValue = data.selectedIconValue;

    this.selectedReport = data.selectedReport;
    this.style = data.style || constants.DRIL_DOWN_STYLE.LINK_NEW_WINDOW;
    this.reportPartUsed = data.reportPartUsed || null;
    this.gridData = data.mappingFields && m.toJS(data.mappingFields);
    this.reportFilter = data.reportFilter;
    if (selectedIconValue && !isNil(selectedIconValue.icon) && !isNil(selectedIconValue.value)) {
      this.selectedIconValue = selectedIconValue;
    }
    this.viewSettingByLink = hideViewSetting ? true : viewSettingByLink;
  });

  /**
   * Read list Reports, field in current report from API
   * @param {Object} data
   */
  SubReport.prototype.readReports = m.action(function (data) {
    this.selectedReportName = data.reportData.name;
    this.fieldInCurrentReportPart = data.fieldInCurrentReportPart;
    this.readSubReport(data);
    this.populateReportsListData();
  });

  /**
   * [populateReportsListData function is to set up data when the report list have no category will store in group
   * named 'Uncategorized'
   * @param  {[type]}
   * @return {[type]}         return report list data
   */
  SubReport.prototype.populateReportsListData = m.action(function () {
    map(function (report) {
      if (!report.name && report.id === subReportConstant.UNDEFINED) {
        report.name = subReportConstant.UNCATEGORIZED;
      }
    }, this.reports);
  });

  /**
   * Read list fields in sub report from API
   * @param {Object} data
   */
  SubReport.prototype.readSubReport = m.action(function (data) {
    this.fieldInSubReport = map(function (field) {
      var valueId = compact([field.relationshipId, field.querySourceFieldId]).join('_');
      var fieldNameInSubReport = String.format('[{0}]', field.sourceFieldName);

      // if this field is Calculated field don't need to add source data object name
      if (!(field.isCalculated && field.querySourceType === CALCULATED_FIELD_CATE_NAME)) {
        fieldNameInSubReport = String.format('[{0}].{1}', field.sourceDataObjectName, fieldNameInSubReport);

        if (!field.relationshipId && field.connectionName && field.querySourceCategoryName) {
          fieldNameInSubReport = String.format('[{0}].[{1}].{2}', field.connectionName, field.querySourceCategoryName, fieldNameInSubReport);
        }
      }

      return flow(set('id', valueId), set('fieldNameInSubReport', fieldNameInSubReport))(field);
    }, data.fieldInSubReport || []);
    this.reportParts = data.reportData.reportPart || [];
  });

  /**
   * Update selected report
   * @param {String} reportId
   */
  SubReport.prototype.updateSelectedReport = m.action(function (report) {
    this.selectedReport = report.id || null;
    this.selectedReportName = report.name || null;
    // Clear mappings
    this.gridData.clear();
  });

  /**
   * Update Style
   * @param {String} value
   */
  SubReport.prototype.updateStyle = m.action(function (value) {
    this.style = value;
  });

  /**
   * Update Report Part
   * @param {String} value
   */
  SubReport.prototype.updateReportPart = function (reportParts) {
    var reportPartUsed = pluck('id', reportParts).toString();

    if (reportParts && reportParts.indexOf(subReportConstant.ALL_OPTION) > -1) {
      reportPartUsed = 'All';
    }
    this.reportPartUsed = reportPartUsed;
  };

  /**
   * Update Report Filter
   * @param {String} value
   */
  SubReport.prototype.updateReportFilter = m.action(function (value) {
    this.reportFilter = value;
  });

  /**
   * Add mapping field
   */
  SubReport.prototype.addMappingField = m.action(function () {
    this.gridData.push({
      fieldNameAlias: '',
      fieldInSubReport: '',
      relationshipInSubReport: '',
      fieldNameInSubReport: ''
    });
  });

  /**
   * Remove a mapping field
   * @param {number} index
   */
  SubReport.prototype.removeMappingField = function (index) {
    index > -1 && this.gridData.splice(index, 1);
  };

  /**
   * Remove empty field mapping's row
   */
  SubReport.prototype.removeUnusedMappingField = m.action(function () {
    // Filter empty row
    this.gridData = this.gridData.filter(function (item) {
      return item.fieldNameAlias || item.fieldInSubReport || item.relationshipInSubReport;
    });
  });

  /**
   * [updateViewSettingByLink Update the state of view setting link]
   * @param  {[type]} state [description]
   */
  SubReport.prototype.updateViewSettingByLink = m.action(function () {
    this.viewSettingByLink = !this.viewSettingByLink;
  });

  /**
   * [updateSelectedViewSettingIcon]
   * @param  {[type]} value [description]
   */
  SubReport.prototype.updateSelectedViewSettingIcon = m.action(function (value) {
    var selectedIcon = find({ value: value }, subReportConstant.ICON_TYPES);
    if (selectedIcon) {
      this.selectedIconValue = {
        icon: selectedIcon.icon,
        value: selectedIcon.value
      };
    }
  });

  SubReport.prototype.validateDuplicate = function () {
    var duplicateMap = {};
    var duplicateIndex = [];

    m.toJS(this.gridData || []).forEach(function (item, index) {
      var key = [item.fieldNameAlias, item.fieldNameInSubReport].join('_');

      if (duplicateMap[key]) {
        duplicateIndex.push(index);
      } else {
        duplicateMap[key] = true;
      }
    });

    return map(function (item) {
      return {
        key: subReportConstant.SUB_REPORT_GRID.VALIDATOR_GROUP + item,
        messages: [subReportConstant.SUB_REPORT_GRID.DUPLICATE_ERROR_MESSAGE]
      };
    }, duplicateIndex);
  };

  module.exports = SubReport;
}();

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DividerAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withState = __webpack_require__(9).withState;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var withProps = __webpack_require__(9).withProps;
  var onlyUpdateForKeys = __webpack_require__(9).onlyUpdateForKeys;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      get = _require.get;

  var DividerAction = compose(withState('position', 'setPosition', { x: 0, y: 0 }), withState('newValue', 'setNewValue', 0), withState('domNode', 'setDomNode', null), withState('defaultValue', 'setDefaultValue', function (props) {
    return props.config.defaultValue;
  }), withProps(function (props) {
    var orientation = props.orientation === 'horizontal' ? { axis: 'x', type: 'width' } : { axis: 'y', type: 'height' };

    return {
      axis: orientation.axis,
      type: orientation.type
    };
  }), withHandlers({
    onStop: curry(onStop),
    onDrag: curry(onDrag)
  }), setPropTypes({
    orientation: React.PropTypes.string.isRequired,
    nodeHandle: React.PropTypes.string.isRequired,
    config: React.PropTypes.object.isRequired,
    afterMove: React.PropTypes.func
  }), onlyUpdateForKeys(['position']));

  function onDrag(props, event, position) {
    var newValue = clampPosition(props, props.defaultValue + position[props.axis]);

    var contentEl = get(props.nodeHandle, props.domNode);
    contentEl.style[props.type] = newValue + 'px';

    props.setNewValue(newValue);
  }

  function onStop(props, event) {
    props.setDefaultValue(props.newValue);

    props.setPosition({ x: 0, y: 0 });
    props.afterMove && props.afterMove();
  }

  function clampPosition(props, value) {
    var min = props.config.minValue;
    var max = props.config.maxValue;

    return Math.min(Math.max(value, min), max);
  }

  module.exports = DividerAction;
}();

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.TextCellColorSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * TextCellColorSettings Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(260);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(34);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(258);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextCellColorSettings = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TextCellColorSettings, _Component);

  function TextCellColorSettings(props) {
    (0, _classCallCheck3.default)(this, TextCellColorSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TextCellColorSettings.__proto__ || (0, _getPrototypeOf2.default)(TextCellColorSettings)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      value: _this.props.loadValue ? _this.props.loadValue() : _this.props.value
    };
    return _this;
  }

  (0, _createClass3.default)(TextCellColorSettings, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      nextProps.value && this.setState({
        value: nextProps.loadValue ? nextProps.loadValue() : nextProps.value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          showTextColor = _props.showTextColor,
          showCellColor = _props.showCellColor;

      var classes = (0, _classnames2.default)('text-cell-color', className);

      return _react2.default.createElement(
        'div',
        { className: classes },
        showTextColor && this.renderBtn('textColor'),
        showCellColor && this.renderBtn('cellColor')
      );
    }
  }]);
  return TextCellColorSettings;
}(_react.Component), _class2.propTypes = {
  value: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  loadValue: _propTypes2.default.func,
  pointOptionList: _propTypes2.default.array
}, _class2.defaultProps = {
  value: {
    dataType: 'text',
    settingValue: {}
  },
  showTextColor: true,
  showCellColor: true,
  pointOptionList: [{}]
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.renderBtn = function (btnName) {
    var props = _this2.props;
    var state = _this2.state;
    var popupProps = {
      type: 'none',
      autoClose: false,
      sizeClass: 'modal-lg'
    };
    var BTN_INFO = {
      textColor: {
        icon: 'icon-font text-color',
        title: _Izenda6.default.getText('TEXT_CELL_COLOR_TOOLTIP_TEXT_COLOR')
      },
      cellColor: {
        icon: 'icon-tint text-color',
        title: _Izenda6.default.getText('TEXT_CELL_COLOR_TOOLTIP_CELL_COLOR')
      }
    };
    var value = props.loadValue ? props.loadValue() : props.value;

    var popupContentProps = $izenda.extend({}, props, {
      dataType: value.dataType,
      dateTimeFormatData: value.dateTimeFormatData,
      settingValue: value.settingValue[btnName],
      colorType: btnName,
      validateMessages: _Izenda7.MESSAGE.M02,
      pointOptionList: props.pointOptionList,
      isBubbleContainer: props.isBubbleContainer,
      valueProps: {
        title: _Izenda6.default.getText('COLOR_SETTING_TOOLTIP'),
        type: 'color',
        defaultColor: btnName === 'textColor' ? _Izenda4.default.textColor : _Izenda4.default.backgroundColor
      },
      beforeClosing: 'beforeClosing'
    });

    var settingValue = (0, _fp.getOr)({}, btnName, value.settingValue);
    var hadSetting = !(0, _fp.isEmpty)(settingValue.value) || !(0, _fp.isEmpty)(settingValue.rangeValue) || !(0, _fp.isEmpty)(settingValue.rangePercent) || (0, _fp.some)(function (item) {
      return !(0, _fp.isNil)(item) && (!(0, _fp.isNil)(item.value) || !(0, _fp.isNil)(item.rangePercent) || !(0, _fp.isNil)(item.rangeValue));
    }, settingValue);
    var fnResetDefaultValue = btnName === 'textColor' ? props.fnResetTextDefaultValue : props.fnResetCellDefaultValue;

    return _react2.default.createElement(_Izenda2.default, {
      type: 'btnPopup',
      popupTitle: BTN_INFO[btnName].title,
      popupContent: props.cellComponent,
      containerClassName: 'text-color',
      className: BTN_INFO[btnName].icon,
      popupProps: popupProps,
      popupContentProps: popupContentProps,
      onChange: onChange.bind(_this2),
      hadSetting: hadSetting,
      fnResetDefaultValue: fnResetDefaultValue,
      value: value,
      settingValue: settingValue
    });

    function onChange(newVal) {
      var newValue = newVal || {};
      var settingValue = state.value.settingValue;
      settingValue[btnName] = newValue.value;
      this.setState({ value: state.value }, (0, _mobx.action)(function () {
        fnResetDefaultValue();
        props.onChange && props.onChange({ value: state.value });
      }));
    }
  };
}, _temp)) || _class;

exports.default = TextCellColorSettings;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldProperties.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedFieldProperties Component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var Button = __webpack_require__(30);
  var action = __webpack_require__(1851);

  var CalculatedFieldProperties = React.createClass({
    displayName: 'CalculatedFieldProperties',

    getDefaultProps: function getDefaultProps() {
      return {
        requireLabel: true
      };
    },

    render: function render() {
      var props = this.props;
      props.uiState.update(this.props);
      return React.createElement(
        'div',
        { className: 'expression-input' },
        React.createElement(
          Button,
          {
            onClick: props.showPopup,
            title: props.title,
            disabled: props.disabled,
            className: props.className },
          props.uiState.hadSetting && React.createElement(
            'div',
            { className: 'u_floatRight u-posRelative' },
            React.createElement('i', { className: 'icon-ok u_smallIcon u-hadSetting u-colorWhite u-bgGreen' })
          )
        ),
        props.uiState.hadSetting && React.createElement(
          'span',
          null,
          React.createElement('i', {
            className: 'icon-cancel u-colorRed',
            title: props.localization.getText('PROPERTIES_EDITOR_REMOVE_SETTING'),
            onClick: props.fnResetDefaultValue
          })
        )
      );
    }
  });

  module.exports = connect(action)(CalculatedFieldProperties);
}();

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldPropertiesAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withProps = __webpack_require__(9).withProps;
  var CalculatedField = __webpack_require__(402);
  var constants = __webpack_require__(16);
  var PopupInputUIState = __webpack_require__(920);
  var GRID_STYLES = __webpack_require__(84).GRID_STYLES;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      get = _require.get,
      includes = _require.includes,
      forEach = _require.forEach;

  var CalculatedFieldPropertiesAction = compose(withProps(function () {
    return {
      uiState: new PopupInputUIState()
    };
  }), withHandlers({
    showPopup: curry(showPopup),
    fnResetDefaultValue: curry(fnResetDefaultValue)
  }));

  /**
   * Show popup
   * @param  {Object} props Component properties
   * @param  {Object} e     react event
   * @return {Object}       Data
   */
  function showPopup(props, e) {
    if (props.onClick && !props.onClick(e)) {
      return;
    }

    /**
     * Action when close popup
     * @param  {Object} calculatedData     apply dât
     */
    var closeCalculatedPopup = function closeCalculatedPopup(calculatedData) {
      if (calculatedData) {
        props.onChange && props.onChange({ value: calculatedData });
        props.uiState.update(props);
      }
    };

    var checkCanNotSetSubtotal = function checkCanNotSetSubtotal(configReportPart, configField) {
      var reportPartContent = configReportPart.reportPartContent;
      var isGridReportPart = configReportPart.type === constants.REPORT_PART_TYPE.Grid;
      var isGridPivot = isGridReportPart && get('properties.generalInfo.gridStyle', reportPartContent) === GRID_STYLES.PIVOT.value;

      return isGridReportPart && includes(configField, get('separators.elements', reportPartContent)) || isGridPivot && includes(configField, get('columns.elements', reportPartContent));
    };

    var value = props.uiState.value || {};
    var label = value.label || value.name;
    var functionName = value.function || value.functionName;
    var izendaDataType = value.dataType || value.izendaDataType;

    var data = props.fieldStore.masterModel;
    var configReportPart = data.configReportPart;
    var configField = configReportPart.configField;
    var selectedField = configReportPart.fieldCollection;
    var hasSupportDefaultTotal = get('field.hasSupportDefaultTotal', configField);
    var formatDataType = get('properties.dataFormattings.functionInfo.formatDataType', configField) || '';
    var canSetSubtotal = !checkCanNotSetSubtotal(configReportPart, configField);
    var fieldList = [];

    selectedField && forEach(function (item) {
      item.field.visible && fieldList.push({
        name: item.field.fieldNameAlias,
        description: item.field.expression,
        dataType: item.field.dataFieldType,
        fieldId: item.field.fieldId,
        schemaName: item.field.schemaName,
        querySourceName: item.field.querySourceName,
        databaseName: item.field.databaseName
      });
    }, selectedField);

    props.fieldStore.fillCalculatedFieldData(null, fieldList, false);

    var calculatedStore = props.fieldStore.calculatedStore;
    var selectedDataSourceId = calculatedStore.expressionSelection.getSelectedDataSourceId();

    if (props.isSubTotalSetting && !props.uiState.hadSetting) {
      label = String.format('Subtotal {0}', props.fieldSetting);
    }

    var initialData = {
      name: label,
      functionName: functionName,
      expression: value.expression,
      izendaDataType: izendaDataType,
      format: value.format,
      querySourceId: value.querySourceId,
      fieldDataType: value.fieldDataType,
      previewResult: value.previewResult,
      previewRecord: value.previewRecord,
      hasSupportDefaultTotal: hasSupportDefaultTotal,
      formatDataType: formatDataType,
      canSetSubtotal: canSetSubtotal
    };

    return props.openPopup(CalculatedField, {
      reportPart: data.configReportPart,
      reportDesigner: data,
      store: props.fieldStore.calculatedStore,
      onClose: closeCalculatedPopup,
      type: props.type,
      value: initialData,
      querySourceId: selectedDataSourceId,
      expressionConfig: constants.EXPRESSION_SELECTION.REPORT_PART,
      requireLabel: props.requireLabel
    });
  }

  /**
   * Reset default value.
   * @param {Object} props
   * @param {Object} e
   */
  function fnResetDefaultValue(props, e) {
    if (props.fnResetDefaultValue) {
      props.fnResetDefaultValue();
      props.onChange && props.onChange();
    }
  }

  module.exports = CalculatedFieldPropertiesAction;
}();

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _class3, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldBody.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedFieldBody component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(96);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1853);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1854);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1855);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1857);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(1858);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(1859);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(1860);

var _Izenda16 = _interopRequireDefault(_Izenda15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CalculatedFieldBody = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(CalculatedFieldBody, _React$Component);

  function CalculatedFieldBody(props) {
    (0, _classCallCheck3.default)(this, CalculatedFieldBody);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CalculatedFieldBody.__proto__ || (0, _getPrototypeOf2.default)(CalculatedFieldBody)).call(this, props));

    _this.closeExpressionSelection = function () {
      _this.expressionSelectionUI.visible = false;
    };

    _initDefineProp(_this, 'displayExpressionSelection', _descriptor, _this);

    _this.expressionSelectionUI = _mobx2.default.observable({
      visible: false,
      left: 0,
      top: 0,
      cursorPosition: 0
    });
    return _this;
  }

  /**
   * Close expression selection popover.
   */


  /**
   * Show expression selection popover.
   * @param {Number} position
   */


  (0, _createClass3.default)(CalculatedFieldBody, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        'div',
        {
          className: 'calculated-field-popup',
          onFocus: this.closeExpressionSelection },
        _react2.default.createElement(
          'div',
          { className: 'calculated-field-container form-horizontal' },
          _react2.default.createElement(_Izenda4.default, {
            store: props.store,
            type: props.type,
            localization: props.localization,
            requireLabel: props.requireLabel
          }),
          _react2.default.createElement(_Izenda6.default, {
            store: props.store,
            validation: props.validation,
            type: props.type
          }),
          _react2.default.createElement(_Izenda8.default, {
            store: props.store,
            validation: props.validation,
            type: props.type,
            localization: props.localization,
            validateExpression: props.validateExpression,
            ref: 'textareaInput',
            displayExpressionSelection: this.displayExpressionSelection,
            closeExpressionSelection: this.closeExpressionSelection,
            expressionSelectionUI: this.expressionSelectionUI
          }),
          _react2.default.createElement(_Izenda10.default, {
            store: props.store,
            validation: props.validation,
            localization: props.localization,
            type: props.type,
            reportDesigner: props.reportDesigner,
            reportPart: props.reportPart
          }),
          _react2.default.createElement(_Izenda12.default, {
            store: props.store,
            localization: props.localization,
            type: props.type
          }),
          _react2.default.createElement(_Izenda14.default, {
            store: props.store,
            localization: props.localization,
            validation: props.validation,
            type: props.type,
            updateError: props.updateError,
            reportDesigner: props.reportDesigner,
            reportPart: props.reportPart,
            startLoading: props.startLoading,
            endLoading: props.endLoading,
            querySourceId: props.querySourceId
          })
        ),
        _react2.default.createElement(_Izenda16.default, {
          expressionConfig: props.expressionConfig,
          store: props.store,
          type: props.type,
          expressionSelectionUI: this.expressionSelectionUI,
          displayExpressionSelection: this.displayExpressionSelection,
          sourceId: 'expressionInput'
        })
      );
    }
  }]);
  return CalculatedFieldBody;
}(_react2.default.Component), _class3.displayName = 'CalculatedFieldBody', _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'displayExpressionSelection', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (position) {
      // This method is used to show expression selection if it is hiding.
      // Otherwise, hide it.

      var textAreaDom = _reactDom2.default.findDOMNode(_this2.refs.textareaInput);
      var left = textAreaDom.offsetLeft + (position && position.left);
      var top = textAreaDom.offsetTop + (position && position.top + 90); // 90: height of bulb icon + 1 line

      // get current cursor position
      var cursorPosition = $izenda('#expressionInput').prop('selectionStart');

      var visible = !_this2.expressionSelectionUI.visible;

      _this2.expressionSelectionUI.visible = visible;
      _this2.expressionSelectionUI.left = left;
      _this2.expressionSelectionUI.top = top;
      _this2.expressionSelectionUI.cursorPosition = cursorPosition;
    };
  }
})), _class2)) || _class;

exports.default = CalculatedFieldBody;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda = __webpack_require__(96);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(122);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(71);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(17);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedLabel.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedLabel component
 */
var ValidatableInput = (0, _Izenda4.default)()(_Izenda10.default);

var CalculatedLabel = (0, _mobxReact.observer)(function (_ref) {
  var type = _ref.type,
      localization = _ref.localization,
      model = _ref.store.clonedModel,
      requireLabel = _ref.requireLabel;

  var notifyChange = _EventUtils2.default.notifyChange;
  var nameValidation = (type.name === _Izenda2.default.TYPES.SUB_TOTAL.name || type.name === _Izenda2.default.TYPES.GRAND_TOTAL.name) && model.functionName === _Izenda2.default.FUNCTION_NAME.NONE ? {} : _Izenda2.default.COLUMN_NAME_CONSTRAINT(type.name);
  var labelValidationOption = {};
  if (requireLabel) {
    labelValidationOption.validations = _Izenda2.default.COLUMN_NAME_CONSTRAINT(type.name);
    labelValidationOption.field = 'columnName';
  }

  return _react2.default.createElement(
    _Izenda6.default,
    { className: 'u_paddingRight' },
    _react2.default.createElement(
      _Izenda8.default,
      { className: 'col-md-3 text-left u_paddingLeft validation required' },
      type.name
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-md-9 u_noPaddingAll' },
      _react2.default.createElement(ValidatableInput, (0, _extends3.default)({
        value: model.name,
        className: 'form-control',
        field: 'name',
        onChange: notifyChange(model.changeFieldName.bind(model), _EventUtils2.default.INPUT),
        validations: nameValidation
      }, labelValidationOption, {
        type: 'text'
      }))
    )
  );
});

CalculatedLabel.displayName = 'CalculatedLabel';
exports.default = CalculatedLabel;
module.exports = exports['default'];

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedFunction component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(122);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(71);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CalculatedFunction = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  (0, _inherits3.default)(CalculatedFunction, _React$Component);

  function CalculatedFunction() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CalculatedFunction);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalculatedFunction.__proto__ || (0, _getPrototypeOf2.default)(CalculatedFunction)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'onChangeFunctionName', _descriptor, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Handle change function name event
   * @param {Object} e
   */


  (0, _createClass3.default)(CalculatedFunction, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          popupLabels = _props.type,
          model = _props.store.clonedModel;


      return popupLabels.functionLabel ? _react2.default.createElement(
        _Izenda2.default,
        { className: 'u_paddingRight' },
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'col-md-3 text-left u_paddingLeft' },
          popupLabels.functionLabel
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-9 u_noPaddingAll' },
          _react2.default.createElement(_Izenda6.default, {
            options: model.functions,
            onChange: this.onChangeFunctionName,
            value: model.functionName
          })
        )
      ) : null;
    }
  }]);
  return CalculatedFunction;
}(_react2.default.Component), _class3.displayName = 'PropertiesEditorContainer', _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'onChangeFunctionName', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (e) {
      _this2.props.store.clonedModel.changeFunctionName(e.value);
      _this2.props.validation.reset();
    };
  }
})), _class2)) || _class;

exports.default = CalculatedFunction;
module.exports = exports['default'];

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedExpression.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedExpression component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda = __webpack_require__(122);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(71);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(567);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(23);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(96);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatableTextArea = (0, _Izenda10.default)()(_Izenda8.default);

var Expression = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Expression, _React$Component);

  function Expression() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Expression);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Expression.__proto__ || (0, _getPrototypeOf2.default)(Expression)).call.apply(_ref, [this].concat(args))), _this), _this.changeExpression = function (e) {
      _this.props.closeExpressionSelection();
      _this.props.store.clonedModel.changeExpression(e.target.value);
    }, _this.blurExpression = function (e) {
      !_this.props.expressionSelectionUI.visible && _this.props.validateExpression();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Handel on change of expression.
   * @param {Object} e
   */


  /**
   * Handel on expression's blur event.
   * @param {Object} e
   */


  (0, _createClass3.default)(Expression, [{
    key: 'render',
    value: function render() {
      var notifyChange = _EventUtils2.default.notifyChange;
      var _props = this.props,
          localization = _props.localization,
          model = _props.store.clonedModel,
          type = _props.type,
          displayExpressionSelection = _props.displayExpressionSelection;

      var disabledExpression = type.functionLabel && model.functionName !== _Izenda12.default.FUNCTION_NAME.EXPRESSION;

      return _react2.default.createElement(
        _Izenda2.default,
        { className: 'u_paddingRight' },
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'col-md-3 text-left u_paddingLeft validation required' },
          localization.getText('COMMON_LABEL_EXPRESSION')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-9 u_noPaddingAll' },
          _react2.default.createElement(ValidatableTextArea, {
            id: 'expressionInput',
            value: model.expression,
            rows: '15',
            className: 'form-control',
            placeholder: _Izenda12.default.EXPRESSION_EXAMPLE,
            onChange: this.changeExpression,
            onBlur: this.blurExpression,
            validations: _Izenda12.default.EXPRESSION_CONSTRAINT(disabledExpression),
            onClickIcon: displayExpressionSelection,
            disabled: disabledExpression,
            field: 'expression',
            ref: 'expressionInput'
          })
        )
      );
    }
  }]);
  return Expression;
}(_react2.default.Component), _class2.displayName = 'Expression', _temp2)) || _class;

exports.default = Expression;
module.exports = exports['default'];

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.CaretCordinatesUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * https://github.com/component/textarea-caret-position/blob/master/index.js
 */
!function () {

    // The properties that we copy into a mirrored div.
    // Note that some browsers, such as Firefox,
    // do not concatenate properties, i.e. padding-top, bottom etc. -> padding,
    // so we have to do every single property specifically.
    var properties = ['direction', // RTL support
    'boxSizing', 'width', // on Chrome and IE, exclude the scrollbar, so the mirror div wraps exactly as the textarea does
    'height', 'overflowX', 'overflowY', // copy the scrollbar for IE

    'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderStyle', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft',

    // https://developer.mozilla.org/en-US/docs/Web/CSS/font
    'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize', 'fontSizeAdjust', 'lineHeight', 'fontFamily', 'textAlign', 'textTransform', 'textIndent', 'textDecoration', // might not make a difference, but better be safe

    'letterSpacing', 'wordSpacing', 'tabSize', 'MozTabSize'];

    var isBrowser = typeof window !== 'undefined';
    var isFirefox = isBrowser && window.mozInnerScreenX != null;

    function getCaretCoordinates(element, position) {
        if (!isBrowser) {
            throw new Error('textarea-caret-position#getCaretCoordinates should only be called in a browser');
        }

        // mirrored div
        var div = document.createElement('div');
        div.id = 'input-textarea-caret-position-mirror-div';
        document.body.appendChild(div);

        var style = div.style;
        var computed = window.getComputedStyle ? getComputedStyle(element) : element.currentStyle; // currentStyle for IE < 9

        // default textarea styles
        style.whiteSpace = 'pre-wrap';
        if (element.nodeName !== 'INPUT') style.wordWrap = 'break-word'; // only for textarea-s

        // position off-screen
        style.position = 'absolute'; // required to return coordinates properly
        style.visibility = 'hidden'; // not 'display: none' because we want rendering

        // transfer the element's properties to the div
        properties.forEach(function (prop) {
            style[prop] = computed[prop];
        });

        if (isFirefox) {
            // Firefox lies about the overflow property for textareas: https://bugzilla.mozilla.org/show_bug.cgi?id=984275
            if (element.scrollHeight > parseInt(computed.height)) style.overflowY = 'scroll';
        } else {
            style.overflow = 'hidden'; // for Chrome to not render a scrollbar; IE keeps overflowY = 'scroll'
        }

        div.textContent = element.value.substring(0, position);
        // the second special handling for input type="text" vs textarea: spaces need to be replaced with non-breaking spaces - http://stackoverflow.com/a/13402035/1269037
        if (element.nodeName === 'INPUT') div.textContent = div.textContent.replace(/\s/g, '\xA0');

        var span = document.createElement('span');
        // Wrapping must be replicated *exactly*, including when a long word gets
        // onto the next line, with whitespace at the end of the line before (#7).
        // The  *only* reliable way to do that is to copy the *entire* rest of the
        // textarea's content into the <span> created at the caret position.
        // for inputs, just '.' would be enough, but why bother?
        span.textContent = element.value.substring(position) || '.'; // || because a completely empty faux span doesn't render at all
        div.appendChild(span);

        var coordinates = {
            top: span.offsetTop + parseInt(computed['borderTopWidth']),
            left: span.offsetLeft + parseInt(computed['borderLeftWidth'])
        };

        $izenda(div).remove();

        return coordinates;
    }

    module.exports = getCaretCoordinates;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedDataType.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * DataType component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda = __webpack_require__(122);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(71);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(23);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(96);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatableDropDown = (0, _Izenda8.default)()(_Izenda6.default);

var DataType = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(DataType, _React$Component);

  function DataType() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DataType);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DataType.__proto__ || (0, _getPrototypeOf2.default)(DataType)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeDataType = function (e) {
      var _this$props = _this.props,
          store = _this$props.store,
          model = _this$props.store.clonedModel,
          valManager = _this$props.validation,
          reportDesigner = _this$props.reportDesigner,
          reportPart = _this$props.reportPart,
          enableValidateDataType = _this$props.type.enableValidateDataType;


      model.changeDataType(e.value);

      valManager.reset();

      if (enableValidateDataType) {
        // validate data type vs function which is not none, expression and default
        if (model.functionName && model.functionName !== _Izenda10.default.FUNCTION_NAME.NONE && model.functionName !== _Izenda10.default.FUNCTION_NAME.EXPRESSION && model.functionName !== _Izenda10.default.FUNCTION_NAME.DEFAULT && !model.doesFunctionAcceptDataType()) {
          valManager.updateErrors([{
            key: 'izendaDataType',
            messages: _Izenda10.default.MESSAGES.M04
          }]);
          return null;
        }

        return store.validateExpressionWithReportKey(reportDesigner, reportPart).then(function (result) {
          if (!(0, _fp.isEmpty)(result)) {
            valManager.updateErrors(result);
          }
          return null;
        });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Handle on change of data type
   * @param {Object} e
   */


  (0, _createClass3.default)(DataType, [{
    key: 'render',
    value: function render() {
      var notifyChange = _EventUtils2.default.notifyChange;
      var _props = this.props,
          localization = _props.localization,
          model = _props.store.clonedModel;


      return _react2.default.createElement(
        _Izenda2.default,
        { className: 'u_paddingRight' },
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'col-md-3 text-left u_paddingLeft' },
          localization.getText('COMMON_LABEL_DATA_TYPE')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-9 u_noPaddingAll' },
          _react2.default.createElement(ValidatableDropDown, {
            options: model.dataTypes,
            onChange: this.onChangeDataType,
            value: model.izendaDataType,
            field: 'izendaDataType'
          })
        )
      );
    }
  }]);
  return DataType;
}(_react2.default.Component), _class2.displayName = 'DataType', _temp2)) || _class;

exports.default = DataType;
module.exports = exports['default'];

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFormat.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Format component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(122);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(71);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(96);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Format = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Format, _React$Component);

  function Format() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Format);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Format.__proto__ || (0, _getPrototypeOf2.default)(Format)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeFormat = function (changed, newFormat) {
      newFormat = newFormat || {};
      _this.props.store.clonedModel.changeFormat({
        formatId: newFormat.customId,
        format: newFormat.format || '',
        groupBy: newFormat.groupBy || null,
        formatDataType: newFormat.formatDataType
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Handle change of format
   * @param {Object} changed
   * @param {Object} newFormat
   */


  (0, _createClass3.default)(Format, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          model = _props.store.clonedModel,
          typeName = _props.type.name;


      if (typeName !== _Izenda8.default.TYPES.SUB_TOTAL.name && typeName !== _Izenda8.default.TYPES.GRAND_TOTAL.name) {
        return null;
      }
      return _react2.default.createElement(
        _Izenda2.default,
        { className: 'u_paddingRight' },
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'col-md-3 text-left u_paddingLeft' },
          localization.getText('COMMON_LABEL_FORMAT')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-9 u_noPaddingAll' },
          _react2.default.createElement(_Izenda6.default, {
            options: model.formats,
            onChange: this.onChangeFormat,
            labelField: 'name',
            valueField: 'customId',
            groupBy: 'category',
            blankOption: true,
            blankOptionText: '...',
            value: (0, _fp.get)('format.formatId', model)
          })
        )
      );
    }
  }]);
  return Format;
}(_react2.default.Component), _class2.displayName = 'Format', _temp2)) || _class;

exports.default = Format;
module.exports = exports['default'];

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedPreview.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Preview component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda = __webpack_require__(122);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(71);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(96);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(35);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Preview = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Preview, _React$Component);

  function Preview() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Preview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Preview.__proto__ || (0, _getPrototypeOf2.default)(Preview)).call.apply(_ref, [this].concat(args))), _this), _this.preview = function () {
      var _this$props = _this.props,
          store = _this$props.store,
          valManager = _this$props.validation,
          reportDesigner = _this$props.reportDesigner,
          reportPart = _this$props.reportPart,
          type = _this$props.type,
          querySourceId = _this$props.querySourceId,
          startLoading = _this$props.startLoading,
          endLoading = _this$props.endLoading,
          updateError = _this$props.updateError;


      valManager.reset();

      switch (type.name) {
        case _Izenda10.default.TYPES.SUB_TOTAL.name:
        case _Izenda10.default.TYPES.GRAND_TOTAL.name:
          startLoading();
          return store.previewReportProperties(reportDesigner, reportPart).then(function (errors) {
            return updateError(errors);
          }).finally(endLoading);
        default:
          startLoading();
          return store.preview.bind(store)(querySourceId).then(function (errors) {
            return updateError(errors);
          }).finally(endLoading);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Handle preview action.
   */


  (0, _createClass3.default)(Preview, [{
    key: 'render',
    value: function render() {
      var notifyChange = _EventUtils2.default.notifyChange;
      var _props = this.props,
          localization = _props.localization,
          model = _props.store.clonedModel,
          type = _props.type;

      var previewResult = _Izenda12.default.applyFormater(model.izendaDataType, model.format.format, model.previewResult);
      var disablePreview = type.name !== _Izenda10.default.TYPES.SUB_TOTAL.name && type.name !== _Izenda10.default.TYPES.GRAND_TOTAL.name || model.functionName === _Izenda10.default.FUNCTION_NAME.EXPRESSION ? model.disablePreview : model.functionName === _Izenda10.default.FUNCTION_NAME.NONE;

      return _react2.default.createElement(
        _Izenda2.default,
        { className: 'u_paddingRight' },
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'col-md-3 text-left u_paddingLeft' },
          localization.getText('COMMON_LABEL_PREVIEW_RESULT')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-9 u_noPaddingAll flex-layout' },
          _react2.default.createElement(_Izenda8.default, {
            title: previewResult,
            value: previewResult,
            className: 'form-control u-bgGray',
            readOnly: true
          }),
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-primary previewBtn',
              disabled: disablePreview,
              onClick: this.preview },
            'Preview'
          )
        )
      );
    }
  }]);
  return Preview;
}(_react2.default.Component), _class2.displayName = 'Preview', _temp2)) || _class;

exports.default = Preview;
module.exports = exports['default'];

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PopoverContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * PopoverContainer component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(96);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(403);

var _Izenda4 = __webpack_require__(1861);

var _Izenda5 = _interopRequireDefault(_Izenda4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopoverContainer = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PopoverContainer, _React$Component);

  function PopoverContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopoverContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverContainer.__proto__ || (0, _getPrototypeOf2.default)(PopoverContainer)).call.apply(_ref, [this].concat(args))), _this), _this.updateCalculatedExpression = function (name) {
      var _this$props = _this.props,
          cursorPos = _this$props.expressionSelectionUI.cursorPosition,
          calculatedModel = _this$props.store.clonedModel,
          sourceId = _this$props.sourceId;


      if (calculatedModel) {
        var expression = calculatedModel.expression;
        var textBefore = expression.substring(0, cursorPos);
        var textAfter = expression.substring(cursorPos, expression.length);
        calculatedModel.expression = textBefore + name + textAfter;
      }
      // Focus on Calculate Expression
      $izenda('#' + sourceId).focus();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Handle on update expression
   * @param {String} name
   */


  (0, _createClass3.default)(PopoverContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$expressionSele = _props.expressionSelectionUI,
          visible = _props$expressionSele.visible,
          left = _props$expressionSele.left,
          top = _props$expressionSele.top,
          expressionSelection = _props.store.expressionSelection,
          popupType = _props.type,
          expressionConfig = _props.expressionConfig,
          displayExpressionSelection = _props.displayExpressionSelection;

      var displayDataSource = popupType.title !== _Izenda2.default.TYPES.GRAND_TOTAL.title && popupType.title !== _Izenda2.default.TYPES.SUB_TOTAL.title;
      return _react2.default.createElement(
        _Izenda3.Popover,
        { visible: visible, positionLeft: left, positionTop: top },
        _react2.default.createElement(_Izenda5.default, {
          store: expressionSelection,
          updateValue: this.updateCalculatedExpression,
          expressionConfig: expressionConfig,
          displayExpressionSelection: displayExpressionSelection,
          displayDataSource: displayDataSource
        })
      );
    }
  }]);
  return PopoverContainer;
}(_react2.default.Component), _class2.displayName = 'PopoverContainer', _temp2)) || _class;

exports.default = PopoverContainer;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionSelection.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ExpressionSelection component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(96);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(156);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(131);

var _Izenda6 = __webpack_require__(28);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(1863);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(1864);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpressionSelection = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ExpressionSelection, _React$Component);

  function ExpressionSelection() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExpressionSelection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpressionSelection.__proto__ || (0, _getPrototypeOf2.default)(ExpressionSelection)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (value) {
      _this.props.updateValue && _this.props.updateValue(value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExpressionSelection, [{
    key: 'render',
    value: function render() {
      var store = this.props.store;
      var constants = _Izenda2.default.EXPRESSION_SELECTION_TABS;

      return _react2.default.createElement(
        _Izenda7.default,
        { className: 'expression-selection-panel' },
        _react2.default.createElement(
          _Izenda5.Tabs,
          { activeTabKey: constants.fieldName.tabkey, isOnPopover: true },
          _react2.default.createElement(
            _Izenda5.Tab,
            {
              title: constants.fieldName.title,
              tabKey: constants.fieldName.tabkey },
            _react2.default.createElement(_Izenda9.default, {
              store: store.expressionFieldName,
              onSelect: this.onSelect,
              expressionConfig: this.props.expressionConfig.FIELD_NAME,
              displayDataSource: this.props.displayDataSource
            })
          ),
          _react2.default.createElement(
            _Izenda5.Tab,
            {
              title: constants.functionOperator.title,
              tabKey: constants.functionOperator.tabkey },
            _react2.default.createElement(_Izenda11.default, {
              store: store.expressionFunctionOperators,
              onSelect: this.onSelect
            })
          )
        )
      );
    }

    /**
       * Handle on select of expression.
       */

  }]);
  return ExpressionSelection;
}(_react2.default.Component), _class2.displayName = 'ExpressionSelection', _class2.defaultProps = {
  displayDataSource: true
}, _class2.propTypes = {
  store: _react2.default.PropTypes.object.isRequired
}, _temp2)) || _class;

exports.default = ExpressionSelection;
module.exports = exports['default'];

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(153);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.MenuToolbar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * MenuToolbar component
 */
var MenuToolbar = function (_Component) {
  (0, _inherits3.default)(MenuToolbar, _Component);

  function MenuToolbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuToolbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuToolbar.__proto__ || (0, _getPrototypeOf2.default)(MenuToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.dropdownRef = function (dom) {
      dom && $izenda(dom).dropdown();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuToolbar, [{
    key: 'closeMenuToolbar',
    value: function closeMenuToolbar() {
      _Izenda2.default.togglePropertiesEditor(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var menuItems = this.props.menuItems;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-MenuToolbar' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-MenuToolbar-close', onClick: this.closeMenuToolbar },
          _react2.default.createElement('span', { className: 'icon-left-open' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-MenuToolbar-menu' },
          _react2.default.createElement(
            'a',
            { ref: this.dropdownRef, className: 'btn u-colorWhite', 'data-toggle': 'dropdown' },
            _react2.default.createElement('span', { className: 'icon-menu-pro' })
          ),
          _react2.default.createElement(
            'ul',
            { className: 'dropdown-menu dropdown-menu-right' },
            menuItems
          )
        )
      );
    }
  }]);
  return MenuToolbar;
}(_react.Component);

exports.default = MenuToolbar;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldNameTab.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * FieldNameTab component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(28);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(71);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(122);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(44);

var _Izenda10 = __webpack_require__(96);

var _Izenda11 = _interopRequireDefault(_Izenda10);

__webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var constants = _Izenda11.default.FIELD_NAME;
var TABLE_DEF = _Izenda11.default.TABLE_DEFINITION.FieldName;

var FieldNameTab = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(FieldNameTab, _React$Component);

  function FieldNameTab() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FieldNameTab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FieldNameTab.__proto__ || (0, _getPrototypeOf2.default)(FieldNameTab)).call.apply(_ref, [this].concat(args))), _this), _this.renderFieldName = function (detail) {
      return _react2.default.createElement(
        'span',
        {
          className: 'selectable truncate overflow-text',
          title: detail.name,
          onMouseDown: _this.onSelect.bind(_this, detail) },
        detail.name
      );
    }, _this.renderDataType = function (detail) {
      return _react2.default.createElement(
        'span',
        { onMouseDown: _this.onSelect.bind(_this, detail) },
        detail.dataType
      );
    }, _this.renderDescription = function (detail) {
      return _react2.default.createElement(
        'span',
        { onMouseDown: _this.onSelect.bind(_this, detail) },
        detail.description
      );
    }, _this.onSortChange = function (columnKey, sortDir) {
      _this.props.store.pageInfo.setColSortDirs(columnKey, sortDir);
      _this.props.store.sort();
    }, _this.onDataSourceChange = function (e) {
      var store = _this.props.store;
      var item = store.dataSources.find(function (item) {
        return item.id === e.value;
      });
      store.updateSelectedDataSource(item);
      item && store.fetchFieldNames(item.fieldNames);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FieldNameTab, [{
    key: 'render',
    value: function render() {
      var store = this.props.store;

      return _react2.default.createElement(
        'div',
        { className: 'form-horizontal expression-tab' },
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'col-md-12 instruction' },
          constants.instruction
        ),
        this.renderDataSourceDropdown(),
        _react2.default.createElement(
          _Izenda9.Table,
          {
            dataSource: store.fieldNames,
            onSortChange: this.onSortChange,
            sortInfo: store.pageInfo.colSortDirs },
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF['fieldName'], { cell: this.renderFieldName })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF['dataType'], { cell: this.renderDataType })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF['description'], { cell: this.renderDescription }))
        )
      );
    }

    /**
     * Render data source drop-down
     */

  }, {
    key: 'renderDataSourceDropdown',
    value: function renderDataSourceDropdown() {
      var _props = this.props,
          store = _props.store,
          displayDataSource = _props.displayDataSource,
          expressionConfig = _props.expressionConfig;


      return displayDataSource ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'col-md-3 control-label data-source-label' },
          constants.dataSourceLabel
        ),
        _react2.default.createElement(
          _Izenda8.default,
          { className: 'col-md-9 data-source-container' },
          _react2.default.createElement(_Izenda6.default, {
            className: 'data-source',
            onChange: this.onDataSourceChange,
            options: store.dataSources,
            value: store.selectedDataSource && store.selectedDataSource.id,
            valueField: 'id',
            labelField: 'name',
            disabled: !expressionConfig.enableDataSource,
            isOnPopover: true
          })
        )
      ) : null;
    }

    /**
     * Render field name column
     * @param {Object} detail
     */


    /**
     * Render data type column
     * @param {Object} detail
     */


    /**
     * Render description column
     * @param {Object} detail
     */


    /**
     * Handle on sort change.
     * @param {String} columnKey
     * @param {String} sortDir
     */

  }, {
    key: 'onSelect',


    /**
     * Handle on select a field name.
     * @param {Object} detail 
     */
    value: function onSelect(detail) {
      var _props2 = this.props,
          store = _props2.store,
          selectedDataSource = _props2.store.selectedDataSource,
          expressionConfig = _props2.expressionConfig,
          displayDataSource = _props2.displayDataSource,
          onSelect = _props2.onSelect;


      var selectedName = String.format(expressionConfig.returnedOnlyFieldNameFormat, detail.name);
      var sourceInfo = displayDataSource ? selectedDataSource : detail;
      sourceInfo.dataSourceName = displayDataSource ? selectedDataSource.name : detail.querySourceName;

      if (!expressionConfig.subOrGrandTotal && sourceInfo.databaseName) {
        selectedName = String.format(expressionConfig.returnedFieldNameFormat, sourceInfo.databaseName, sourceInfo.schemaName, sourceInfo.dataSourceName, detail.name);
      }

      onSelect && onSelect(selectedName);
    }

    /**
     * Handle on change of data source
     * @param {Object} e
     */

  }]);
  return FieldNameTab;
}(_react2.default.Component), _class2.displayName = 'FieldNameTab', _class2.propTypes = {
  store: _react2.default.PropTypes.object.isRequired
}, _class2.defaultProps = {
  displayDataSource: true
}, _temp2)) || _class;

exports.default = FieldNameTab;
module.exports = exports['default'];

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FunctionOperatorTab.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * FunctionOperatorTab component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(28);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(71);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(44);

var _Izenda6 = __webpack_require__(96);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var constants = _Izenda7.default.FUNCTION_OPERATOR;
var TABLE_DEF = _Izenda7.default.TABLE_DEFINITION.FunctionOperator;

var FunctionOperatorTab = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(FunctionOperatorTab, _React$Component);

  function FunctionOperatorTab() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FunctionOperatorTab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FunctionOperatorTab.__proto__ || (0, _getPrototypeOf2.default)(FunctionOperatorTab)).call.apply(_ref, [this].concat(args))), _this), _this.renderName = function (detail) {
      return _react2.default.createElement(
        'span',
        {
          className: 'selectable truncate overflow-text',
          title: detail.name,
          onMouseDown: (0, _fp.partial)(_this.onSelect, [detail])
        },
        detail.name
      );
    }, _this.renderSyntax = function (detail) {
      return _react2.default.createElement(
        'span',
        null,
        detail.syntax
      );
    }, _this.onSortChange = function (columnKey, sortDir) {
      _this.props.store.pageInfo.setColSortDirs(columnKey, sortDir);
      _this.props.store.sort();
    }, _this.onSelect = function (detail) {
      var onSelect = _this.props.onSelect;

      onSelect && onSelect(detail.expressionSyntax);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FunctionOperatorTab, [{
    key: 'render',
    value: function render() {
      var _props$store = this.props.store,
          functionOperators = _props$store.functionOperators,
          pageInfo = _props$store.pageInfo;


      return _react2.default.createElement(
        'div',
        { className: 'expression-tab' },
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'col-md-12 instruction' },
          constants.instruction
        ),
        _react2.default.createElement(
          _Izenda5.Table,
          { dataSource: functionOperators, onSortChange: this.onSortChange, sortInfo: pageInfo.colSortDirs },
          _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF['name'], { cell: this.renderName })),
          _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF['syntax'], { cell: this.renderSyntax }))
        )
      );
    }

    /**
     * Render name column
     * @param {Object} detail
     */


    /**
     * Render syntax column
     * @param {Object} detail
     */


    /**
     * Handle on sort change of column.
     * @param {String} columnKey
     * @param {String} sortDir
     */


    /**
     * Handle on select.
     * @param {Object} detail
     */

  }]);
  return FunctionOperatorTab;
}(_react2.default.Component), _class2.displayName = 'FunctionOperatorTab', _class2.propTypes = {
  store: _react2.default.PropTypes.object.isRequired
}, _temp2)) || _class;

exports.default = FunctionOperatorTab;
module.exports = exports['default'];

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _bluebird = __webpack_require__(18);

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditor.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var ITEM_TYPE = {
    GROUP: 'GROUP',
    FIELD: 'FIELD'
  };

  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      isObject = _require.isObject,
      isFunction = _require.isFunction,
      isString = _require.isString,
      isUndefined = _require.isUndefined,
      values = _require.values,
      omit = _require.omit,
      get = _require.get;

  function PropertiesEditor() {
    this.definedSchema = {};
    this.source = {};
    this.mappingProps = {};
    this.mappingSource = {};
  }

  /**
   * Build data based on schema defined
   * @returns {observable-object}
   */
  PropertiesEditor.prototype.getDataBySchema = function () {
    var result = this.buildData('', this.definedSchema, {});
    return result;
  };

  /**
   * Build data based on schema defined
   * @param {string} schemaName
   * @param {object} schemaDef
   * @param {object} schemaSource
   * @returns {object|array}
   */
  PropertiesEditor.prototype.buildData = function (schemaName, schemaDef, schemaSource) {
    if (!isObject(schemaDef)) {
      return schemaSource;
    }

    schemaSource = schemaSource || {};
    schemaSource.itemType = isObject(schemaDef.fields) ? ITEM_TYPE.GROUP : ITEM_TYPE.FIELD;

    // get data of item
    this.getItemData(schemaName, schemaDef, schemaSource);

    // if item is group, build data for each field
    for (var fieldName in schemaDef.fields) {
      schemaSource[fieldName] = this.buildData(fieldName, schemaDef.fields[fieldName], {});
    }

    return schemaSource;
  };

  /**
   * Get data of item: value & its properties,
   * Structure: {
   *              value: [VALUE]   get from itemDef.value  or execute itemDef.fnValue
   *              props: [OBJECT]  based on itemDef.props
   *            }
   * @param {string} itemName
   * @param {object} itemDef
   * @param {object} itemSource
   * @returns {object}
   */
  PropertiesEditor.prototype.getItemData = function (itemName, itemDef, itemSource) {
    if (!isObject(itemSource)) {
      return itemSource;
    }

    itemSource = itemSource || {};

    // we should respect the original value
    itemSource.value = this.getValue(itemName, itemDef, itemSource);

    // get properties
    itemSource.props = this.getProps(itemName, itemDef, itemSource);

    return itemSource;
  };

  /**
   * Get value of item based on its definition
   * @param  {string} itemName
   * @param  {object} itemDef
   * @param  {object} itemSource
   * @param  {object} itemData
   * @return {}
   */
  PropertiesEditor.prototype.getValue = function (itemName, itemDef, itemSource) {
    var source = this.source || {};
    var mappingSource = this.mappingSource || {};
    var mappingProps = this.mappingProps || {};

    var value = null;

    // read data from [value]
    value = source[itemName] || itemDef.value;

    // read data from [fnValue]
    if (!itemDef.fnValue) {
      return value;
    }

    // read data by execute function
    var fnValue = itemDef.fnValue;

    if (isString(fnValue)) {
      if (isFunction(source[fnValue])) {
        fnValue = source[fnValue].bind(source);
      } else if (isFunction(mappingSource[fnValue])) {
        fnValue = mappingSource[fnValue];
      } else if (isFunction(mappingProps[fnValue])) {
        fnValue = mappingProps[fnValue];
      }

      return isFunction(fnValue) && fnValue(itemName, itemDef);
    }

    return fnValue;
  };

  /**
   * Get properties of item based on its definition
   * @param  {object} itemDef
   * @param  {object} itemData
   * @return {object}
   */
  PropertiesEditor.prototype.getProps = function (itemName, itemDef, itemSource) {
    var mappingSource = this.mappingSource || {};
    var result = {};
    var itemDefProps = itemDef.props;

    // if props of field is defined as an function
    if (isFunction(itemDefProps)) {
      itemDefProps = itemDefProps.call(null, itemName, itemDef);
    }

    // props is a name of function in mappingProps
    if (isString(itemDefProps) && isFunction(mappingSource[itemDefProps])) {
      itemDefProps = mappingSource[itemDefProps].call(null, itemName, itemDef);
    }

    if (!isObject(itemDefProps)) {
      return result;
    }

    itemDef = $izenda.extend(true, {}, itemDef, { props: itemDefProps });

    // if props of field is defined as an object
    var propKey, propVal;
    for (propKey in itemDefProps) {
      propVal = isString(itemDefProps[propKey]) ? this.getPropValueByKey(itemName, itemDef, itemSource, propKey) : itemDefProps[propKey];
      assignPropValue(propKey, propVal);
    }

    return result;

    function assignPropValue(propKey, propVal) {
      var keyPath = '';

      if (propVal instanceof _bluebird2.default) {
        keyPath = 'promiseProps';
      } else if (isFunction(propVal)) {
        keyPath = 'fnProps';
        // prevent mobx convert to computed-value
        propVal = m.asReference(propVal);
      } else {
        keyPath = 'values';
      }

      result[keyPath] = result[keyPath] || {};
      result[keyPath][propKey] = propVal;
    }
  };

  /**
   * Get props of item based on props-key
   * @param {type} propsKey
   * @param {type} itemDef
   * @param {type} itemData
   * @param {type} args
   * @returns {type}
   */
  PropertiesEditor.prototype.getPropValueByKey = function (itemName, itemDef, itemSource, propKey) {
    if (!itemDef || !itemDef.props || !itemDef.props[propKey]) {
      return;
    }

    var source = this.source || {};
    var mappingProps = this.mappingProps || {};
    var mappingSource = this.mappingSource || {};

    var propValue = itemDef.props[propKey];

    // if props of field is defined as an function
    if (isFunction(propValue)) {
      return propValue;
    } else if (!isString(propValue)) {
      return propValue;
    } else if (!isUndefined(mappingProps[propValue])) {
      return mappingProps[propValue];
    } else if (isFunction(source[propValue])) {
      // get data from source
      return source[propValue].call(source, itemName, itemDef, propKey);
    }
    if (isFunction(mappingSource[propValue])) {
      // get data from mappingSource
      return mappingSource[propValue].call(null, itemName, itemDef, propKey);
    }

    return propValue;
  };

  /**
   * Observer object, its properties which its type is function will be move to staticProps
   * @param  {object} dataSchema
   * @return {object}
   */
  PropertiesEditor.prototype.observerObject = function (dataSchema) {
    observerDataSchema.call(this, dataSchema);

    return dataSchema;

    function observerDataSchema(obj) {
      if (!isObject(obj) || values(ITEM_TYPE).indexOf(obj.itemType) === -1) {
        return;
      }

      m.extendObservable(obj, omit('props', obj));

      obj.props.values && m.extendObservable(obj.props.values, obj.props.values);
      obj.props.promiseProps && this.observerPromiseProp(obj.props.promiseProps);

      // for fields (if any)
      for (var fieldName in omit(['props', 'value', 'itemType'], obj)) {
        observerDataSchema.call(this, obj[fieldName]);
      }
    }
  };

  /**
   * process properties which return promise
   * @param  {object} sourceDef
   * @param  {object} sourceData
   * @return {object}
   */
  PropertiesEditor.prototype.observerPromiseProp = function (sourceDef, sourceData) {
    var propVal;

    sourceData = sourceData || sourceDef;

    for (var propKey in sourceDef) {
      propVal = sourceDef[propKey];

      if (propVal instanceof _bluebird2.default) {
        if (propVal.isFulfilled && propVal.isFulfilled()) {
          sourceData[propKey] = propVal.value();
        } else {
          setVal(propKey, propVal);
        }
      } else {
        sourceData[propKey] = propVal;
      }
    }

    return m.extendObservable(sourceData, sourceData);

    function setVal(propKey, propVal) {
      sourceData[propKey] = null;
      propVal.then(function (response) {
        sourceData[propKey] = response;
      });
    }
  };

  /**
   * Update data schemae
   * @param  {object} dataSchema
   * @param  {object} newDataSchema
   * @return {object}
   */
  PropertiesEditor.prototype.updateSchemaData = function (dataSchema, newDataSchema) {
    return m.transaction(function () {
      mergeDataSchema.call(this, dataSchema, newDataSchema);
    }.bind(this));

    function mergeDataSchema(dataSchema, newDataSchema) {
      if (!isObject(dataSchema) || values(ITEM_TYPE).indexOf(dataSchema.itemType) === -1) {
        return;
      }

      m.extendObservable(dataSchema, omit('props', newDataSchema));

      newDataSchema.props.values && m.extendObservable(dataSchema.props.values, newDataSchema.props.values);
      newDataSchema.props.promiseProps && this.observerPromiseProp(newDataSchema.props.promiseProps, dataSchema.props.promiseProps);

      // for fields (if any)
      for (var fieldName in omit(['props', 'value', 'itemType'], newDataSchema)) {
        mergeDataSchema.call(this, dataSchema[fieldName], newDataSchema[fieldName]);
      }
    }
  };

  /**
   * Set data schema
   * @param {object} dataSchema
   */
  PropertiesEditor.prototype.setDataSchema = function (dataSchema) {
    this.dataSchema = dataSchema;
  };

  /**
   * update data based on keyPath, only update value of field
   * @param  {any} newVal
   * @param  {string} key
   * @param  {string} keyPath
   * @return {undefined}
   */
  PropertiesEditor.prototype.updateDataSchemaByKey = function (newVal, key, keyPath) {
    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      others[_key - 3] = arguments[_key];
    }

    var _this = this;

    m.transaction(function () {
      var _propertyConfig;

      _this.propertyConfig.onChangeValue && (_propertyConfig = _this.propertyConfig).onChangeValue.apply(_propertyConfig, [_this.dataSchema, key, keyPath, newVal].concat(others));
    });

    // Verify and warn whether changed value has not been assigned to dataSchema
    get([].concat((0, _toConsumableArray3.default)(keyPath), [key, 'value']), this.dataSchema) === newVal && console && console.warn('The changed value has not been assigned to data schema in OnChangeValue handler');
  };

  /**
   * set properties config, these values will be used to build dataSchema
   * @param {object} propertyConfig
   */
  PropertiesEditor.prototype.setPropertyConfig = function (propertyConfig) {
    propertyConfig = propertyConfig || {};

    this.propertyConfig = propertyConfig;

    this.definedSchema = propertyConfig.definedSchema;
    this.source = propertyConfig.source;
    this.mappingProps = propertyConfig.mappingProps;
    this.mappingSource = propertyConfig.mappingSource;
  };

  module.exports = PropertiesEditor;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditor.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);

  var FormGroup = __webpack_require__(122);
  var InputByDataType = __webpack_require__(260);
  var PropertiesEditorManager = __webpack_require__(157);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      getOr = _require.getOr,
      concat = _require.concat,
      has = _require.has,
      clone = _require.clone,
      reduce = _require.reduce,
      isObject = _require.isObject,
      assign = _require.assign,
      get = _require.get,
      isFunction = _require.isFunction,
      tail = _require.tail,
      isString = _require.isString,
      isUndefined = _require.isUndefined;

  var FieldItem = m.observer(function (props) {
    var fieldDef = props.itemDef || {};
    var fieldSource = props.itemSource || {};
    var fieldSourceProps = fieldSource.props || {};
    var fieldName = props.itemName;
    var hasTitle = !isNil(fieldDef.title);
    // To render the component into the FormGroup when the component is custom and doesn't has title
    var usingGroup = fieldDef.usingGroup;

    var labelClass = classnames(['control-label', 'prop-label'], fieldDef.titleClassName || '');
    var controlClass = classnames('prop-control', fieldDef.controlClassName || '', {
      u_fullWidth: !hasTitle
    });
    var fieldClass = classnames('form-group', fieldDef.fieldClassName || '');
    var disabled = get('values.disabled', fieldSourceProps);
    var disabledInfo = fieldDef.disabledInfo;
    var content = React.createElement(
      'div',
      { className: controlClass },
      renderControl.bind(this)(),
      disabled && disabledInfo && React.createElement(
        'a',
        { className: 'icon-info' },
        React.createElement('span', { className: 'icon-info-circled', title: disabledInfo })
      )
    );
    var tooltip = getOr('', 'values.title', fieldSourceProps);

    if (hasTitle || usingGroup) {
      return React.createElement(
        FormGroup,
        { className: fieldClass, key: fieldName },
        fieldDef.title && React.createElement(
          'label',
          { className: labelClass, title: tooltip },
          fieldDef.title,
          fieldDef.infoIcon && React.createElement(
            'a',
            { className: 'icon-info' },
            React.createElement('span', { className: 'icon-info-circled', title: fieldDef.infoIcon })
          )
        ),
        content
      );
    } else {
      return content;
    }

    /**
     * render control base on props component or props type
     * @return {React} React component coresponding to the config
     */
    function renderControl() {
      if (props.component) {
        return React.createElement(props.component, (0, _extends3.default)({}, fieldDef.staticProps, fieldSourceProps.values, fieldSourceProps.fnProps, {
          keyPath: props.keyPath
        }, fieldSourceProps.promiseProps, {
          value: fieldSource.value,
          onChange: onChange.bind(this)
        }));
      } else {
        return React.createElement(InputByDataType, (0, _extends3.default)({}, fieldDef.staticProps, fieldSourceProps.values, fieldSourceProps.fnProps, {
          keyPath: props.keyPath
        }, fieldSourceProps.promiseProps, {
          type: fieldDef.type,
          value: fieldSource.value,
          onChange: onChange.bind(this)
        }));
      }
    }

    /**
     * onChange function will call updateDataSchemaByKey in propertiesEditorModel
     * @param  {object} newValue update value for this component
     */
    function onChange(newValue) {
      var propertiesEditorModel = props.parentProps.propertiesEditorModel || {};

      propertiesEditorModel.updateDataSchemaByKey && propertiesEditorModel.updateDataSchemaByKey.apply(propertiesEditorModel, concat([has('value', newValue) ? newValue.value : newValue, fieldName, props.keyPath], tail(arguments)));
    }
  });

  FieldItem.displayName = 'FieldItem';

  var GroupItem = m.observer(React.createClass({
    displayName: 'GroupItem',

    propTypes: {
      keyPath: React.PropTypes.array,
      itemName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number])
    },

    componentWillMount: function componentWillMount() {
      this.keyPath = clone(this.props.keyPath || []);
      this.props.itemName && this.keyPath.push(this.props.itemName);
    },

    render: function render() {
      var props = this.props;
      var groupName = props.itemName;
      var groupDef = props.itemDef;
      var groupSource = props.itemSource || {};

      if (isHiddenGroup()) {
        return null;
      }

      if (props.component) {
        // render group by user-defined-component
        return React.createElement(
          props.component,
          (0, _extends3.default)({
            key: groupName
          }, groupDef.props, groupDef.staticProps, {
            keyPath: this.keyPath
          }, groupSource.props.values, groupSource.props.fnProps),
          renderContent.bind(this)()
        );
      } else {
        // render group as section group
        return React.createElement(
          'section',
          (0, _extends3.default)({
            key: groupName
          }, groupDef.props, groupDef.staticProps, groupSource.props.values, groupSource.props.fnProps),
          groupDef.title ? React.createElement(
            'div',
            { className: 'title-group-container' },
            React.createElement(
              'strong',
              { className: 'title-group' },
              groupDef.title
            )
          ) : null,
          renderContent.bind(this)()
        );
      }

      /**
       * return list of react element
       * @return {React.element} [description]
       */
      function renderContent() {
        // render fields of group
        return (0, _keys2.default)(groupDef.fields).map(function (fieldName) {
          return React.createElement(GeneralItem, {
            key: fieldName,
            itemName: fieldName,
            itemDef: groupDef.fields[fieldName],
            keyPath: this.keyPath,
            parentProps: props.parentProps,
            itemSource: groupSource[fieldName]
          });
        }.bind(this));
      }

      /**
       * Hide group if all its fields are hidden
       **/
      function isHiddenGroup() {
        var countHidden = 0;
        var fieldKeys = (0, _keys2.default)(groupDef.fields);

        if (!fieldKeys.length) {
          return false;
        }

        countHidden = reduce(function (countHidden, fieldKey) {
          var hidden = groupSource[fieldKey] && isHidden(fieldKey, groupDef.fields[fieldKey], props.parentProps.mappingSource, props.itemSource);
          return hidden ? countHidden + 1 : countHidden;
        }, countHidden, fieldKeys);

        return countHidden === fieldKeys.length;
      }
    }
  }));

  /**
   * Check hidden of a component.
   * @param {String} itemName
   * @param {Object} itemDef
   * @param {Object} mappingSource
   * @param {Object} itemSource
   */
  function isHidden(itemName, itemDef, mappingSource, itemSource) {
    if (isUndefined(itemDef.isHidden)) {
      // default - item is shown
      return false;
    }
    if (isString(itemDef.isHidden)) {
      // read data from mappingSource
      var mappingValue = mappingSource[itemDef.isHidden];
      return isFunction(mappingValue) ? mappingSource[itemDef.isHidden](itemName, itemDef, itemSource) : !!mappingValue;
    }

    return !!itemDef.isHidden;
  }

  var GeneralItem = m.observer(function (props) {
    var itemName = props.itemName;
    var itemDef = props.itemDef;
    var itemSource = props.itemSource;
    var mappingSource = props.parentProps.mappingSource;

    var keyPath = props.keyPath || [];

    var propetyPanelStyle = PropertiesEditorManager.getViewStyle();
    var hiddenByState = get('props.values.hiddenByState', itemSource);

    if (itemSource && (isHidden(itemName, itemDef, mappingSource, itemSource) || !!hiddenByState && propetyPanelStyle.simpleState)) {
      return null;
    }

    var itemComponent = {};
    itemComponent.name = itemDef.fields ? GroupItem : FieldItem;

    return React.createElement(itemComponent.name, {
      itemName: itemName,
      itemDef: itemDef,
      keyPath: keyPath,
      itemSource: itemSource,
      component: itemDef.component && getComponent(itemDef.component),
      parentProps: props.parentProps
    });

    /**
     * get component from widgets list
     * @param  {string} comonentName name of component in widgets colection
     * @return {React.element|string}              react element from widgets collection
     */
    function getComponent(comonentName) {
      return props.parentProps.widgets && props.parentProps.widgets[comonentName] || comonentName;
    }
  });
  GeneralItem.displayName = 'GeneralItem';

  var PropertiesEditor = React.createClass({
    displayName: 'PropertiesEditor',

    propTypes: {
      definedSchema: React.PropTypes.object.isRequired,
      schemaData: React.PropTypes.object,
      propertiesEditorModel: React.PropTypes.object
    },

    componentWillMount: function componentWillMount(nextProps) {
      this.updateSchemaData(this.props.schemaData);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var props = this.props;
      var propertiesEditorModel = props.propertiesEditorModel || {};

      if (nextProps.definedSchema.schemaKey !== props.definedSchema.schemaKey) {
        this.updateSchemaData(nextProps.schemaData);
      } else {
        propertiesEditorModel.updateSchemaData && propertiesEditorModel.updateSchemaData(this.schemaData, nextProps.schemaData);
      }
    },

    updateSchemaData: function updateSchemaData(schemaData) {
      var propertiesEditorModel = this.props.propertiesEditorModel || {};
      this.schemaData = propertiesEditorModel.observerObject && propertiesEditorModel.observerObject(schemaData);
      propertiesEditorModel.setDataSchema && propertiesEditorModel.setDataSchema(this.schemaData);
    },

    renderItem: function renderItem(itemName, itemDef, itemSource) {
      return React.createElement(GeneralItem, {
        key: itemName,
        itemName: itemName,
        itemDef: itemDef,
        itemSource: itemSource,
        parentProps: assign(this.props, { updateSchema: this.updateSchema })
      });
    },

    render: function render() {
      var definedSchema = this.props.definedSchema;

      if (!definedSchema) {
        return null;
      }

      definedSchema = isObject(definedSchema) ? [definedSchema] : definedSchema;
      var classes = classnames(this.props.className, 'izenda-PropertiesEditor');

      return React.createElement(
        'section',
        { className: classes, 'aria-expanded': 'false' },
        definedSchema.map(function (item, index) {
          return this.renderItem(index, item, this.schemaData);
        }.bind(this))
      );
    }
  });

  module.exports = m.observer(PropertiesEditor);
}();

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _recompose = __webpack_require__(9);

var _mobx = __webpack_require__(5);

var _reactDom = __webpack_require__(32);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(259);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(53);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1868);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(316);

var _Izenda12 = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateAddingFieldToDefault = function validateAddingFieldToDefault(props, fieldCollection, isCheckRunningField) {
  var errorField = (0, _fp.filter)(function (field) {
    return isCheckRunningField ? isInvalidRunningField(props.reportPart, props.container, field.isRunningField) : (0, _Izenda11.isBinary)(field.izendaDataType || field.fieldDataType);
  }, fieldCollection);

  if ((0, _fp.isEmpty)(errorField)) {
    return {
      message: null,
      errorField: null
    };
  }
  var errorMessage = isCheckRunningField ? String.format(_Izenda6.default.MESSAGES.M28, (0, _fp.map)('name', errorField).join(', ')) : String.format(_Izenda6.default.MESSAGES.M05, (0, _fp.map)('name', errorField).join(', '));
  return {
    message: errorMessage,
    errorField: errorField
  };
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.FieldContainerAction.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FieldContainer actions
 */


var validateAddNewFieldToContainer = function validateAddNewFieldToContainer(props) {
  return function (fieldCollection) {
    var exceedMaximumField = !!props.maximumField && props.container.elements.length + fieldCollection.length > props.maximumField;

    if (exceedMaximumField) {
      return {
        message: _Izenda8.default.BUNDLE.MESSAGE.FIELDS_EXCEEDED_LIMITATION,
        errorField: fieldCollection
      };
    }
    var errorRunningField = props.validateAddingFieldToDefault(fieldCollection, true);

    if (!(0, _fp.isNil)(errorRunningField.errorField)) return errorRunningField;

    var reportPartContent = props.reportPart.reportPartContent;

    if (reportPartContent.validateCanAddField) {
      return reportPartContent.validateCanAddField(props.store.masterModel, props.container, fieldCollection);
    }
    return props.validateAddingFieldToDefault(fieldCollection, false);
  };
};

/**
 * This function is to show the confirm message to disable multi color in case of there are more than one metric.
 * @param {Object} props are properties of object
 */
var confirmTurnOffMultiColor = function confirmTurnOffMultiColor(props) {
  return function () {
    var reportPartContent = (0, _fp.get)('reportPart.reportPartContent', props);
    var validateAddMoreMetricMessage = reportPartContent.validateMoreThanOneMetric ? reportPartContent.validateMoreThanOneMetric(props.container) : null;

    if (validateAddMoreMetricMessage) {
      return props.confirmFn('Confirmation', {
        description: validateAddMoreMetricMessage
      });
    }
    return (0, _bluebird.resolve)();
  };
};

/**
 * Confirm remove regression line setting when add separator
 * @param {Object} props are properties of object
 */
var confirmRemoveRegressionLine = function confirmRemoveRegressionLine(props) {
  return function () {
    var reportPartContent = props.reportPart.reportPartContent,
        container = props.container;

    var removeRegressionLine = reportPartContent.validateRemoveRegressionLine ? reportPartContent.validateRemoveRegressionLine(container) : { remove: false };

    return removeRegressionLine.remove ? removeRegressionLine.message ? props.confirmFn('Confirmation', {
      description: removeRegressionLine.message
    }).then(reportPartContent.resetRegressionLineDefaultValue.bind(reportPartContent)) : (0, _bluebird.resolve)(reportPartContent.resetRegressionLineDefaultValue()) : (0, _bluebird.resolve)();
  };
};

var isInvalidRunningField = function isInvalidRunningField(reportPart, container, isRunningField) {
  if (!isRunningField) {
    return false;
  }
  var type = _Izenda8.default.REPORT_PART_TYPE;
  var containerType = {};
  switch (reportPart.type) {
    case type.Chart:
      containerType = { name: 'Chart', key: 'chartType' };
      break;
    case type.Gauge:
      containerType = { name: 'Gauge', key: 'reportPartStyle' };
      break;
    case type.Map:
      containerType = { name: 'Map', key: 'chartType' };
      break;
    case type.Grid:
      containerType = { name: 'Grid', key: 'gridStyle' };
      break;
  }
  var typeReport = reportPart.reportPartContent[containerType.key];
  return (0, _fp.includes)(container.name, _Izenda6.default.RUNNING_FUNCTION_INVALID_CONTAINER[containerType.name][typeReport]);
};

var validateAddNewFieldToReportPart = function validateAddNewFieldToReportPart(props) {
  return function (fieldCollection) {
    var fieldLimitValue = _Izenda2.default.advancedSettings.performance.fieldLimitValue;

    if (props.reportPart.fieldCollection.length + fieldCollection.length > fieldLimitValue) {
      return {
        message: _Izenda8.default.BUNDLE.MESSAGE.FIELDS_EXCEEDED_LIMITATION,
        errorField: fieldCollection
      };
    }

    return props.validateAddNewFieldToContainer(fieldCollection);
  };
};

var warning = function warning(props, errorMessage) {
  return props.confirmFn('Information', {
    description: errorMessage,
    type: 'error',
    showCloseIndicator: true
  });
};

var changePositionField = (0, _mobx.action)(function (props, field, position, dragItemContainer) {
  var store = props.store;
  var reportPart = props.reportPart;

  reportPart.changePositionField(field, position, dragItemContainer);
  reportPart.shouldUpdatePreview && store.needUpdatePreview();
});

var changeFieldContainer = (0, _mobx.action)(function (props, movingItem, field, position, dragItemContainer, container) {
  var isRunningField = (0, _fp.get)('field.isRunningField', field);

  if (isInvalidRunningField(props.reportPart, container, isRunningField)) {
    props.confirmMessage('error', String.format(_Izenda6.default.MESSAGES.M28, field.name));
    return;
  }

  var store = props.store;
  var reportPart = props.reportPart;

  store.reportFilters.removeAggregatedField(field);

  movingItem.onDeleteElement && movingItem.onDeleteElement(field);
  return reportPart.changeFieldContainer(field, position, dragItemContainer, container).then(function (addedField) {
    return props.onAddElement && props.onAddElement(addedField);
  }).then(function () {
    reportPart.shouldUpdatePreview && store.needUpdatePreview();
  });
});

var addField = function addField(props) {
  return function (field, querySource, position) {
    var container = props.container,
        reportPart = props.reportPart,
        content = props.reportPart.reportPartContent,
        onAddElement = props.onAddElement;


    return reportPart.insertFieldToContainer(container, field, querySource, position).then(function (addedField) {
      onAddElement && onAddElement(addedField);
      return addedField;
    }).then(function (addedField) {
      content.afterAddField && content.afterAddField();
      // This below approach is required for re-rendering (Combination chart)
      return (0, _bluebird.resolve)().return(addedField);
    });
  };
};

var openSelectionFieldPopup = function openSelectionFieldPopup(props) {
  return function () {
    return props.openPopup(_Izenda10.default, props);
  };
};

var droppableAction = (0, _Izenda4.default)([_Izenda8.default.GENNERAL.FIELD_ITEM, _Izenda6.default.DRAG_ITEM.REPORT_PART_FIELD_ITEM], {
  drop: function drop(props, monitor) {
    if (monitor.didDrop()) {
      return;
    }

    var item = monitor.getItem() || {};
    var field = item.querySourceField || {};
    var dragItemContainer = item.dragItemContainer;
    var dropPosition = props.position;
    var reportPart = props.reportPart;

    if (item.itemType !== _Izenda8.default.GENNERAL.FIELD_ITEM && item.itemType !== _Izenda6.default.DRAG_ITEM.REPORT_PART_FIELD_ITEM) {
      return;
    }

    if (field.isRunningField) {
      if (isInvalidRunningField(reportPart, props.container, field.isRunningField)) {
        props.warning(String.format(_Izenda6.default.MESSAGES.M28, field.name));
        return;
      }
    }

    if (dragItemContainer === props.container) {
      props.changePositionField(field, dropPosition, dragItemContainer);
      return;
    }

    var warningPromise = (0, _bluebird.resolve)();
    if (dragItemContainer && dragItemContainer !== props.container) {
      var confirmMessagePromise = props.container.name === _Izenda12.ContainerName.SEPARATORS ? props.confirmRemoveRegressionLine() : props.confirmTurnOffMultiColor();
      // changeFieldContainer
      confirmMessagePromise.then(function () {
        var validateChangeContainer = props.validateAddNewFieldToContainer([field]);
        if (validateChangeContainer.message) {
          warningPromise = props.warning(validateChangeContainer.message);
        }

        warningPromise.then(function () {
          !(0, _fp.includes)(field, validateChangeContainer.errorField) && props.changeFieldContainer(item, field, dropPosition, dragItemContainer, props.container);
        });
      });
      return;
    }

    var validateAddNewField = props.validateAddNewFieldToReportPart([field]);

    warningPromise = !(0, _fp.isEmpty)(validateAddNewField.message) ? props.warning(validateAddNewField.message) : props.confirmTurnOffMultiColor();

    if (props.container.name === _Izenda12.ContainerName.SEPARATORS) {
      warningPromise = props.confirmRemoveRegressionLine();
    }

    warningPromise.then(function () {
      var store = props.store;
      !(0, _fp.includes)(field, validateAddNewField.errorField) && props.addField(item.querySourceField, item.dataObject, dropPosition).then(function () {
        reportPart.shouldUpdatePreview && store.needUpdatePreview();
      });
    });
  },
  canAccess: function canAccess(props, currentDragItem) {
    var dragItem = currentDragItem || {};
    var item = dragItem.querySourceField || {};

    var isRunningField = (0, _fp.get)('isRunningField', item) || (0, _fp.get)('field.isRunningField', item);

    if (dragItem.itemType !== _Izenda8.default.GENNERAL.FIELD_ITEM && dragItem.itemType !== _Izenda6.default.DRAG_ITEM.REPORT_PART_FIELD_ITEM) {
      return false;
    }

    if (!isRunningField && dragItem.dragItemContainer === props.container) {
      return true;
    }

    var validateResult = dragItem.itemType === _Izenda8.default.GENNERAL.FIELD_ITEM ? props.validateAddNewFieldToReportPart([item]) : props.validateAddNewFieldToContainer([item]);

    return !(0, _fp.includes)(item, validateResult.errorField) && !isInvalidRunningField(props.reportPart, props.container, isRunningField);
  },
  hover: function hover(props, monitor, component) {
    var clientOffset = monitor.getClientOffset();
    var componentRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
    var listItem = (0, _reactDom.findDOMNode)(component).getElementsByClassName('field-wrapper');
    var posItemX = clientOffset.x - componentRect.left;
    var posItemY = clientOffset.y - componentRect.top;
    var exist = false;
    var elements = props.container.elements;

    if (posItemX > 0 && posItemY > 0 && posItemX < componentRect.width && posItemY < componentRect.height) {
      (0, _fp.forEach)(function (element) {
        if (element.offset.left <= clientOffset.x && clientOffset.x <= element.offset.left + element.offset.width && element.offset.top <= clientOffset.y && clientOffset.y <= element.offset.top + element.offset.height) {
          resetStyleItem();
          props.setPostition(element.position);
          setStyleForItem(element.position - 1, 'Left');
          exist = true;
        }
      }, elements);

      if (!exist && elements.length > 0) {
        resetStyleItem();
        props.setPostition(elements.length + 1);
        setStyleForItem(elements.length - 1, 'Right');
      }

      if (!elements.length) {
        props.setPostition(1);
      }
    }

    function resetStyleItem() {
      (0, _fp.forEach)(function (item) {
        item.style.borderLeftStyle = '';
        item.style.borderRightStyle = '';
      }, listItem);
    }

    function setStyleForItem(itemPosition, type) {
      if ((0, _fp.isNil)(listItem[itemPosition])) {
        return;
      }
      listItem[itemPosition].style['border' + type + 'Style'] = _Izenda8.default.GENNERAL.BORDER_HOVER_ITEM.STYLE;
      listItem[itemPosition].style['border' + type + 'Color'] = _Izenda8.default.GENNERAL.BORDER_HOVER_ITEM.COLOR;
    }
  }
});

exports.default = (0, _recompose.compose)((0, _recompose.withState)('position', 'setPostition', 1), (0, _recompose.withHandlers)({
  changePositionField: (0, _fp.curryN)(4, changePositionField),
  changeFieldContainer: (0, _fp.curryN)(6, changeFieldContainer),
  validateAddingFieldToDefault: (0, _fp.curry)(validateAddingFieldToDefault),
  addField: addField,
  /**
   * Show warning popup
   */
  warning: (0, _fp.curry)(warning)
}), (0, _recompose.withHandlers)({
  validateAddNewFieldToContainer: validateAddNewFieldToContainer
}), (0, _recompose.withHandlers)({
  confirmTurnOffMultiColor: confirmTurnOffMultiColor,
  confirmRemoveRegressionLine: confirmRemoveRegressionLine
}), (0, _recompose.withHandlers)({
  validateAddNewFieldToReportPart: validateAddNewFieldToReportPart
}), (0, _recompose.withHandlers)({
  /**
   * Show popup to select fields into container.
   * @return {Promise} Popup promise
   */
  openSelectionFieldPopup: openSelectionFieldPopup
}), droppableAction, (0, _recompose.onlyUpdateForKeys)(['isOver', 'canDrop', 'container']));
module.exports = exports['default'];

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SelectionFieldPopup.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field selection component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(946);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1873);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectionFieldPopup = (_dec = (0, _Izenda10.default)(_Izenda8.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SelectionFieldPopup, _Component);

  function SelectionFieldPopup(props) {
    (0, _classCallCheck3.default)(this, SelectionFieldPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectionFieldPopup.__proto__ || (0, _getPrototypeOf2.default)(SelectionFieldPopup)).call(this, props));

    _this.selectedData = [];
    var filterQuerySource = _this.props.store.displayFieldQuerySource;
    var defaultField = (0, _fp.head)(filterQuerySource[0].fields);

    _this.state = {
      selectedQuerySource: filterQuerySource[0],
      selectedField: defaultField
    };
    return _this;
  }

  (0, _createClass3.default)(SelectionFieldPopup, [{
    key: 'render',
    value: function render() {
      var filterQuerySource = this.props.store.displayFieldQuerySource;
      return _react2.default.createElement(
        _Izenda2.default,
        {
          visible: true,
          onClosing: this.props.closed,
          type: 'none',
          autoClose: false,
          containerClass: 'izenda-SelectionFieldPopup'
        },
        _react2.default.createElement(_Izenda2.default.Header, { title: _Izenda4.default.getText('REPORTDESIGNER_LABEL_FIELD_SELECTION') }),
        _react2.default.createElement(
          _Izenda2.default.Body,
          null,
          _react2.default.createElement(_Izenda6.default, { data: filterQuerySource, onChangeData: this.props.onChangeSeletedField })
        ),
        _react2.default.createElement(
          _Izenda2.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda2.default.ConfirmationButton,
            { type: 'accept' },
            _Izenda4.default.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda2.default.ConfirmationButton,
            { type: 'cancel' },
            _Izenda4.default.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return SelectionFieldPopup;
}(_react.Component), _class2.propTypes = {
  onAccept: _propTypes2.default.func.isRequired,
  onReject: _propTypes2.default.func.isRequired,
  validateAddNewFieldToReportPart: _propTypes2.default.func.isRequired,
  warning: _propTypes2.default.func.isRequired,
  store: _propTypes2.default.object.isRequired
}, _temp)) || _class);
exports.default = SelectionFieldPopup;
module.exports = exports['default'];

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeViewItemList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var observer = __webpack_require__(10).observer;
  var VirtualList = __webpack_require__(313);
  var TreeViewItem = __webpack_require__(1870);
  var classnames = __webpack_require__(11);

  var TreeViewItemList = React.createClass({
    displayName: 'TreeViewItemList',

    propTypes: {
      treeStore: ObservablePropTypes.observableObject
    },
    componentWillMount: function componentWillMount() {
      var props = this.props;
      var treeStore = props.treeStore;
      treeStore.setNodes(props.flattenNodes);
      //this.toggleCollapsible = treeStore.toggleCollapsibleOfNode.bind(treeStore);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var treeStore = nextProps.treeStore;
      treeStore.setNodes(nextProps.flattenNodes);
    },
    render: function render() {
      var props = this.props;
      var treeStore = props.treeStore;
      var visibleNodes = treeStore.visibleNodeList;
      var hasItems = visibleNodes.length;
      var className = classnames('izenda-TreeViewItemList', props.className);
      return hasItems ? React.createElement(VirtualList, {
        className: className,
        dataSource: visibleNodes,
        getItemKey: this.getKey,
        renderItem: this.renderItem }) : null;
    },
    renderItem: function renderItem(node) {
      var props = this.props;
      var renderNode = props.renderNode;
      var treeStore = props.treeStore;
      var expanded = treeStore.isExpanded(node);

      return React.createElement(TreeViewItem, {
        node: node,
        treeViewItemClassName: props.treeViewItemClassName,
        renderNode: renderNode,
        expanded: expanded,
        toggleCollapsible: treeStore.toggleCollapsibleOfNode.bind(treeStore) });
    },
    getKey: function getKey(node) {
      return node.key;
    }
  });

  module.exports = observer(TreeViewItemList);
}();

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeViewItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;

  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);

  var TreeViewItem = React.createClass({
    displayName: 'TreeViewItem',

    propTypes: {
      node: ObservablePropTypes.objectOrObservableObject,
      renderNode: PropTypes.func.isRequired,
      toggleCollapsible: PropTypes.func.isRequired,
      expanded: PropTypes.bool
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return nextProps.expanded !== this.props.expanded || nextProps.node !== this.props.node;
    },
    render: function render() {
      var props = this.props;
      var node = props.node;
      var renderNode = props.renderNode;
      var hasChild = node.childCount;
      var toggleIcon = hasChild ? this.renderToggleIcon() : null;
      var isCollapsed = !props.expanded;
      var level = node.level;
      var className = classnames('izenda-TreeViewItem', props.treeViewItemClassName);

      return React.createElement(
        'div',
        { className: className, style: { paddingLeft: 20 * level } },
        renderNode(node.data, toggleIcon, this.toggle, isCollapsed, node.parent)
      );
    },
    renderToggleIcon: function renderToggleIcon() {
      var expanded = this.props.expanded;
      var className = classnames('u_curPointer icon-arrow', {
        'expanded': expanded
      });
      return React.createElement('i', {
        className: className,
        onClick: this.toggle });
    },
    toggle: function toggle() {
      var props = this.props;
      var node = props.node;
      var toggleCollapsible = props.toggleCollapsible;
      toggleCollapsible(node);
    }
  });

  module.exports = observer(TreeViewItem);
}();

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FlattenTreeUIStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var extendObservable = __webpack_require__(5).extendObservable;
  var action = __webpack_require__(5).action;
  var asMap = __webpack_require__(5).asMap;

  var _require = __webpack_require__(1),
      filter = _require.filter,
      memoize = _require.memoize,
      isUndefined = _require.isUndefined;

  function FlattenTreeUIStore() {
    extendObservable(this, {
      expandedMap: asMap(),
      nodeList: [],
      visibleNodeList: function visibleNodeList() {
        var isVisible = this.memoizeIsVisible = memoize(this.isVisible.bind(this));
        var result = filter(isVisible, this.nodeList);

        this.memoizeIsVisible = null;
        return result;
      }
    });
  }

  FlattenTreeUIStore.prototype.setNodes = action(function setNodes(nodes) {
    this.nodeList = nodes;
  });

  FlattenTreeUIStore.prototype.toggleCollapsibleOfNode = action(function toggleCollapsible(node) {
    var isExpanded = this.isExpanded(node);
    node.expanded = !isExpanded;
    node.key && this.expandedMap.set(node.key, !isExpanded);
  });

  FlattenTreeUIStore.prototype.isVisible = function (node) {
    var parent = node.parent;
    if (!parent) return true;

    var parentExpanded = this.isExpanded(parent);
    if (!parentExpanded) return false;

    return this.memoizeIsVisible ? this.memoizeIsVisible(parent) : this.isVisible(parent);
  };

  /**
   * Check whether a node is expanded by user action
   * @param  {String}  key Node key
   * @return {Boolean}     True/False/Undefined
   */
  FlattenTreeUIStore.prototype.isExpanded = function (node) {
    // Take expansion user action state of node.
    var userExpanded = this.expandedMap.get(node.key);

    // Whether user didn't interact with current node yet
    var userUndefined = isUndefined(userExpanded);

    // If user didn't interact yet, take expanded value by data.
    // Otherwise, keep latest user action state.
    return userUndefined ? node.expanded : userExpanded;
  };

  module.exports = FlattenTreeUIStore;
}();

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = __webpack_require__(5);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var mapWithIndex = _fp.map.convert({ cap: false }); // ----------------------------------------------------------------------
// <copyright file="Izenda.TreeSelectionFieldAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _recompose.compose)((0, _recompose.withProps)(function (props) {
  return {
    treeData: buildTree(props.data)
  };
}), (0, _recompose.withHandlers)({
  onChange: (0, _mobx.action)((0, _fp.curry)(onChange))
}));


function buildTree(data) {
  return mapWithIndex(function (item, index) {
    return getNodeData(item, getNodesData(item), item.id + '_' + item.name, 'QuerySource', index);
  }, data);
}

function getNodesData(node) {
  return mapWithIndex(function (field, index) {
    return getNodeData(field, [], node.name + '_' + field.id + '_' + field.name, 'Field', index);
  }, node.fields);
}

function getNodeData(node, nodes, key, type, index) {
  return (0, _mobx.observable)({
    key: key,
    index: index,
    value: node.name,
    nodes: nodes,
    checked: false,
    nodeType: type,
    indeterminate: false
  });
}

function onChange(props, item, parent) {
  item.checked = !item.checked;

  if (item.nodeType === 'Field') {
    var parentNode = parent.data;
    parentNode.checked = (0, _fp.every)('checked', parentNode.nodes);
    parentNode.indeterminate = parentNode.checked ? false : (0, _fp.some)('checked', parentNode.nodes);
  } else if (item.nodeType === 'QuerySource') {
    item.indeterminate = false;
    (0, _fp.forEach)(function (node) {
      node.checked = item.checked;
    }, item.nodes);
  }

  onChangedData(props);
}

function onChangedData(props) {
  var result = [];
  (0, _fp.forEach)(function (querySource) {
    (0, _fp.forEach)(function (field) {
      if (field.checked) {
        result.push({
          field: field.index,
          querySource: querySource.index
        });
      }
    }, querySource.nodes);
  }, props.treeData);

  props.onChangeData(result);
}
module.exports = exports['default'];

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = __webpack_require__(18);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var closed = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(props, closeFunc, type) {
    var container, selectedField, result, position, validField;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(type === 'cancel')) {
              _context.next = 4;
              break;
            }

            props.onReject();
            _context.next = 15;
            break;

          case 4:
            // const props = this.props;
            container = props.container;
            selectedField = (0, _fp.map)(function (item) {
              var querySource = props.store.displayFieldQuerySource[item.querySource];
              var field = querySource.fields[item.field];

              return {
                field: field,
                querySource: querySource
              };
            }, this.selectedData);
            result = props.validateAddNewFieldToReportPart((0, _fp.map)('field', selectedField), false);
            position = container.elements.length;
            validField = false;

            if ((0, _fp.isEmpty)(selectedField)) {
              _context.next = 15;
              break;
            }

            _context.next = 12;
            return props.confirmTurnOffMultiColor();

          case 12:
            _context.next = 14;
            return props.confirmRemoveRegressionLine();

          case 14:
            (0, _bluebird.map)(selectedField, function (item) {
              if (!(0, _fp.includes)(item.field, result.errorField)) {
                position++;
                validField = true;
                return props.addField(item.field, item.querySource, position);
              }
              return (0, _bluebird.resolve)();
            }).then(function () {
              if ((0, _fp.isEmpty)(result.message)) {
                return null;
              }
              return !(0, _fp.isEmpty)(result.message) && props.warning(result.message);
            }).then(function () {
              if (validField) {
                props.onAccept();
                props.reportPart.shouldUpdatePreview && props.store.needUpdatePreview();
              }
            });

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function closed(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var _fp = __webpack_require__(1);

var _recompose = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SelectionFieldPopupAction.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field selection component
 */

exports.default = (0, _recompose.compose)((0, _recompose.withHandlers)({
  closed: (0, _fp.curry)(closed),
  onChangeSeletedField: (0, _fp.curry)(onChangeSeletedField)
}));


function onChangeSeletedField(props, data) {
  this.selectedData = data;
}
module.exports = exports['default'];

/***/ }),
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(53);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(188);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Container for Drop Field
 */

var FieldItem = function (_Component) {
  (0, _inherits3.default)(FieldItem, _Component);

  function FieldItem() {
    (0, _classCallCheck3.default)(this, FieldItem);
    return (0, _possibleConstructorReturn3.default)(this, (FieldItem.__proto__ || (0, _getPrototypeOf2.default)(FieldItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(FieldItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.itemData.offset = this.getOffset();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.itemData.offset = this.getOffset();
      // Reset style field item when hover out container
      if (!this.props.isOverContainer) {
        this.refs.fieldItem.removeAttribute('style');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = props.store;
      var reportFilters = store.reportFilters;
      var container = props.container || {};
      var canAccess = props.canAccess && props.canAccess(props.item, container);
      var item = props.itemData || {};
      var reportPart = props.reportPart;

      var deleteElement = function deleteElement() {
        reportPart.removeFieldFromContainer(container, item);
        props.onDeleteElement && props.onDeleteElement(item);
        reportFilters.removeAggregatedField(item);
        reportPart.shouldUpdatePreview && props.store.needUpdatePreview(reportPart);
      };

      var className = (0, _classnames2.default)('field-element', {
        'can-drop': doesCanDropFieldContainerItem(),
        'field-element-selected': props.isRegistedItem && isConfigField(item)
      });

      var fieldName = item.field && item.field.visible ? item.name : _Izenda2.default.FIELD_HIDDEN_LABEL;

      return _react2.default.createElement(
        'div',
        { className: 'field-wrapper', ref: 'fieldItem' },
        _react2.default.createElement(
          'div',
          { className: className, key: item.name },
          _react2.default.createElement(
            'span',
            {
              className: 'field-label overflow-text',
              onMouseDown: props.onClick,
              onTouchStart: props.onClick,
              title: fieldName
            },
            fieldName
          ),
          _react2.default.createElement('span', { className: 'icon-cancel field-icon', onClick: deleteElement })
        )
      );

      function doesCanDropFieldContainerItem() {
        return canAccess && props.isOver && props.item.dragItem !== props.itemData;
      }

      function isConfigField(field) {
        return (0, _fp.isEqual)(field, reportPart.configField);
      }
    }
  }, {
    key: 'getOffset',
    value: function getOffset() {
      return (0, _fp.pick)(['x', 'y', 'width', 'height', 'left', 'right', 'top', 'bottom'], this.refs.fieldItem.getBoundingClientRect());
    }
  }]);
  return FieldItem;
}(_react.Component);

var enhance = (0, _fp.flow)(_mobxReact.observer, _Izenda4.default.wrapper);

exports.default = enhance(FieldItem);
module.exports = exports['default'];

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ChartFrontSide component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1886);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(224);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(76);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(53);

var _Izenda10 = __webpack_require__(12);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(412);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(1908);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartBody = (0, _mobxReact.observer)(function (props) {
  var isBeingBuild = (0, _fp.get)('reportPartContent.isBeingBuild', props.reportPart);

  if (isBeingBuild) {
    return _react2.default.createElement(_Izenda4.default, props);
  } else {
    return _react2.default.createElement(
      'div',
      { className: 'default-layout' },
      _react2.default.createElement(
        'div',
        { className: 'chart-goes-here' },
        _react2.default.createElement(
          'span',
          null,
          _Izenda11.default.getText('REPORTDESIGNER_PLACEHOLDER_CHART_GOES_HERE')
        )
      )
    );
  }
});

var ChartFrontSide = (_dec = (0, _Izenda2.default)(_Izenda15.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ChartFrontSide, _Component);

  function ChartFrontSide() {
    (0, _classCallCheck3.default)(this, ChartFrontSide);
    return (0, _possibleConstructorReturn3.default)(this, (ChartFrontSide.__proto__ || (0, _getPrototypeOf2.default)(ChartFrontSide)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChartFrontSide, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var reportPartDetails = props.reportPart || {};
      var reportPartContent = reportPartDetails.reportPartContent;
      var sizeStyle = props.style ? props.style : {};
      var printingMode = props.printingMode,
          hideTitle = props.hideTitle,
          width = props.width,
          separator = props.separator,
          forExporting = props.forExporting,
          forDashboard = props.forDashboard,
          doesBreakPage = props.doesBreakPage,
          embededReportPart = props.embededReportPart;

      var classes = (0, _classnames2.default)({
        'report-part-chart-front-side': true,
        'izenda-ReportPart-smallSize': width < _Izenda9.REPORT_PART_SMALL_SIZE
      });

      if (printingMode) {
        var containerSize = {
          width: parseInt((0, _fp.get)('width', sizeStyle)),
          height: parseInt((0, _fp.get)('height', sizeStyle))
        };

        return _react2.default.createElement(
          'div',
          { className: 'report-part-chart-front-side', style: _Izenda8.default.getReportPartContainerStyle(props) },
          _react2.default.createElement(
            'div',
            { className: _Izenda8.default.getReportPartClassName(props), style: sizeStyle },
            !hideTitle && _react2.default.createElement(_Izenda6.default, {
              mode: _Izenda9.REPORT_PART_MODE.PREVIEW,
              reportPart: reportPartDetails,
              reportPartContent: reportPartContent
            }),
            _react2.default.createElement(ReportPartBody, {
              reportPart: reportPartDetails,
              finishedRender: props.finishedRender,
              fulfilledData: props.fulfilledData,
              style: sizeStyle,
              key: reportPartDetails.id,
              isPreview: true,
              printingMode: true,
              viewMode: true,
              separator: separator,
              forExporting: forExporting,
              doesBreakPage: !forDashboard && doesBreakPage && !embededReportPart,
              containerSize: containerSize,
              getSortValueForLinearChart: props.getSortValueForLinearChart,
              updateDrillComponent: props.updateDrillComponent,
              setDefaultIntervalForDatetime: props.setDefaultIntervalForDatetime,
              setPageSize: props.setPageSize,
              onDrilldown: props.onDrilldown,
              pointAction: props.pointAction
            })
          )
        );
      }

      return _react2.default.createElement(
        _Izenda13.default,
        (0, _extends3.default)({}, props, { className: classes }),
        _react2.default.createElement(_Izenda6.default, { mode: _Izenda9.REPORT_PART_MODE.PREVIEW, reportPart: reportPartDetails }),
        _react2.default.createElement(ReportPartBody, (0, _extends3.default)({}, props, { key: reportPartDetails.id }))
      );
    }
  }]);
  return ChartFrontSide;
}(_react.Component)) || _class);
exports.default = ChartFrontSide;
module.exports = exports['default'];

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(404);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(954);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(80);

var _Izenda6 = __webpack_require__(35);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartPreview = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ChartPreview, _Component);

  function ChartPreview() {
    (0, _classCallCheck3.default)(this, ChartPreview);
    return (0, _possibleConstructorReturn3.default)(this, (ChartPreview.__proto__ || (0, _getPrototypeOf2.default)(ChartPreview)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChartPreview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.updateDrillComponent.call(this);
      this.props.setDefaultIntervalForDatetime.call(this);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.updateDrillComponent.call(this);
      this.props.setDefaultIntervalForDatetime.call(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var reportPart = props.reportPart || {};
      var reportPartContent = reportPart.reportPartContent;
      var type = reportPartContent.type;
      var chartProperties = reportPart.getReportPartProperties() || {};
      var printingMode = props.printingMode;
      var doesBreakPage = reportPartContent.checkBreakPage();
      var sortLinear = props.getSortValueForLinearChart();
      var sortDrilldown = (0, _fp.get)('currentDrilldownField.properties.dataFormattings.sort', reportPartContent);
      var doesShowChartToolBar = reportPartContent.isShowMetric || reportPartContent.isShowBreadcrumb || !props.hideGridPopup;
      // turn off animation when printing.
      printingMode && $izenda.extend(true, chartProperties.commonOptions, {
        plotOptions: {
          series: {
            animation: false
          }
        }
      });

      var chartData = (0, _Izenda5.parser)(reportPartContent.activeElmsByContainers, reportPartContent.expandedLevel, {
        fieldsMapping: reportPart.previewDataFieldsMapping,
        records: reportPart.previewDataRecords,
        rawData: reportPart.previewData
      });

      $izenda.extend(true, chartProperties, {
        colors: reportPart.getThemeColors(chartProperties),
        commonActions: {
          onDrilldown: props.onDrilldown,
          setPageSize: props.setPageSize,
          pointAction: props.pointAction
        },
        sort: {
          valueXAxisForLinear: sortLinear,
          valueXAxisDrilldown: sortDrilldown,
          chartType: chartProperties.chartType
        }
      });

      // refresh data intervals
      props.refreshData && props.refreshData(true);

      if (_Izenda7.default.needToRenderLazyLoadingBar(props.reportPart, props.printingMode)) {
        return _Izenda7.default.renderLazyLoadingBar();
      }

      return _react2.default.createElement(
        _Izenda2.default,
        {
          reportPart: reportPart,
          isPreview: props.isPreview,
          type: type,
          chartType: chartProperties.chartType,
          chartOptions: chartProperties,
          seriesOptions: props.reportPart.fieldCollection,
          chartData: chartData,
          viewMode: props.viewMode,
          printingMode: printingMode,
          style: printingMode && props.style ? props.style : {},
          finishedRender: props.finishedRender,
          fulfilledData: props.fulfilledData,
          containerSize: props.containerSize,
          isLoading: reportPart.isLoadingData,
          doesBreakPage: !props.forDashboard && doesBreakPage && !props.embededReportPart,
          separator: props.separator,
          forExporting: props.forExporting
        },
        !printingMode && doesShowChartToolBar && _react2.default.createElement(_Izenda4.default, {
          hideGridPopup: props.hideGridPopup,
          reportPart: reportPart,
          onDrillDown: props.onDrilldown,
          isShowMetric: reportPartContent.isShowMetric,
          isShowBreadcrumb: reportPartContent.isShowBreadcrumb
        })
      );
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.refreshData && this.props.refreshData(false);
    }
  }]);
  return ChartPreview;
}(_react.Component), _class2.propTypes = {
  reportPart: _react.PropTypes.object.isRequired
}, _class2.contextTypes = {
  router: _react2.default.PropTypes.object
}, _temp)) || _class;

exports.default = ChartPreview;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(221);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda2 = __webpack_require__(69);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(164);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(80);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(39);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(171);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var X_AXIS_CONTAINER_NAME = 'labels';
// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeChartActions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var Y_AXIS_CONTAINER_NAME = 'values';
var SEPARATOR_CONTAINER_NAME = 'separators';
var MAX_DEFAULT_VALUE = 100;
var MIN_DEFAULT_VALUE = 0;

var getTextColor = _Izenda7.default.getTextColor;


/**
 * create data for gauge
 * @param  {Object} props [description]
 * @return {Object}       [description]
 */
var _getChartSeries = function _getChartSeries(props) {
  var dataParser = props.chartData;
  var seriesOptions = props.seriesOptions;

  var serieInfo = {
    groups: {},
    charts: []
  };

  var groupCharts = {};
  var dataStructure = dataParser.dataStructure;

  var addChart = function addChart(charts, groupInfo) {
    var chartInfos = [];
    charts.forEach(function (chart) {
      chart.id = (0, _fp.uniqueId)();
      chart.linkTo = groupInfo;
      serieInfo.charts.push(chart);
      chartInfos.push({
        id: chart.id
      });
    });
    var groupName = (0, _fp.get)('linkTo.groupName', groupInfo);
    if (groupName !== undefined) {
      (0, _fp.isNil)(groupCharts[groupName]) && (groupCharts[groupName] = []);
      groupCharts[groupName] = (0, _fp.concat)(chartInfos, groupCharts[groupName]);
    }
  };

  /**
   * process data by group
   * @param  {object}  groupedData
   * @param  {object}  dataParser
   * @return {object}
   */
  var processDataByGroup = function processDataByGroup(groupedData, dataParser) {
    var dataStructure = dataParser.dataStructure;

    if (!groupedData || !groupedData.length) {
      return {};
    }

    // find min, max & total for each value (y-axis field)
    var groupInfo = {};

    // init data
    dataStructure[Y_AXIS_CONTAINER_NAME].map(function (field) {
      groupInfo[field.fieldNameAlias] = {
        columnName: field.columnName,
        fieldName: field.fieldNameAlias,
        min: null,
        max: null,
        sum: 0
      };
    });
    var getDataByRow = function getDataByRow(row) {
      var val = void 0,
          valueInfo = void 0;

      dataStructure[Y_AXIS_CONTAINER_NAME].map(function (field) {
        var isUsingCustomFormat = _Izenda11.default.checkUsingCustomFormat(field);
        valueInfo = groupInfo[field.fieldNameAlias];
        val = isUsingCustomFormat ? row[_Izenda9.default.CUSTOM_FORMAT_PREFIX + field.columnName] : row[field.columnName];

        valueInfo.sum += val;
        valueInfo.min = (0, _fp.isNil)(valueInfo.min) ? val : Math.min(valueInfo.min, val);
        valueInfo.max = (0, _fp.isNil)(valueInfo.max) ? val : Math.max(valueInfo.max, val);
      });
    };
    groupedData.forEach(function (row) {
      getDataByRow(row);
    });

    return groupInfo;
  };

  /**
   * Create data for each gauge
   * @param  {object}  record
   * @param  {object}  valueMappingField
   * @param  {object}  xAxisField
   * @param  {object}  groupData
   * @param  {object}  otherGroupData
   * @return {object}
   */
  var getDataForChart = function getDataForChart(record, valueMappingField, xAxisField, groupData) {
    var chartName = valueMappingField.fieldNameAlias;
    var metricInfo = (0, _fp.getOr)({}, 'properties.metric', valueMappingField.reportPartElm || {});
    var isUsingCustomFormat = _Izenda11.default.checkUsingCustomFormat(valueMappingField);
    var dataValue = isUsingCustomFormat ? record[_Izenda9.default.CUSTOM_FORMAT_PREFIX + valueMappingField.columnName] : record[valueMappingField.columnName];
    var textColor = getTextColor(dataValue, (0, _fp.get)(chartName, props.seriesOptions), {
      element: valueMappingField,
      record: record
    });

    if ((0, _fp.isNil)(dataValue)) {
      throw new Error('No data to show');
    }

    var getGroupInfo = function getGroupInfo(groupData, chartName) {
      groupData = groupData || {};
      var group = void 0;

      if (groupData.linkTo) {
        group = groupData.linkTo;
      } else if (groupData.allData) {
        group = groupData.allData;
      } else {
        group = groupData;
      }

      return (0, _fp.getOr)({}, chartName, group);
    };

    var groupInfo = getGroupInfo(groupData, chartName);

    var getValueFromField = function getValueFromField(field, dataParser, record) {
      if (!(0, _fp.get)('isVisible', field)) {
        return undefined;
      }

      return _Izenda5.default.getValueOfField(field, dataParser.fieldsMapping, record);
    };

    var getDefinedThresholdValue = function getDefinedThresholdValue(thresholds) {
      var thresholdsLevels = (0, _fp.get)('levels', thresholds);

      if (!thresholds || !thresholdsLevels || !thresholdsLevels.length) {
        return [];
      }

      var re = [];
      var isNumberFrom = void 0,
          isNumberTo = void 0,
          from = void 0,
          to = void 0;

      thresholdsLevels.forEach(function (thresold) {
        from = thresold.value || getValueFromField(thresold.element, dataParser, record);
        to = thresold.valueUpper || getValueFromField(thresold.elementUpper, dataParser, record);

        isNumberFrom = (0, _fp.isNumber)(from);
        isNumberTo = (0, _fp.isNumber)(to);

        if (!(0, _fp.isNil)(from) && !isNumberFrom || !(0, _fp.isNil)(to) && !isNumberTo) {
          throw new Error(_Izenda.Message.M02);
        }

        if (isNumberFrom && isNumberTo && from >= to) {
          throw new Error(_Izenda.Message.M01);
        }

        (isNumberFrom || isNumberTo) && re.push({
          from: from,
          to: to,
          color: thresold.color
        });
      });

      return re;
    };
    var definedThreshold = getDefinedThresholdValue((0, _fp.getOr)({}, 'thresholds', metricInfo));
    var scale = getScaleInfo(dataValue, metricInfo, groupInfo, definedThreshold);
    /**
     * Check valid threshold
     */
    var isValidThreshold = function isValidThreshold(thresholds, scale) {
      if (!thresholds || !thresholds.length) {
        return true;
      }

      var re = true;
      var first = (0, _fp.head)(thresholds);
      var lastItem = (0, _fp.last)(thresholds);
      var thresholdRangeFrom = (0, _fp.isNil)(first.from) ? first.to : first.from;
      var thresholdRangeTo = (0, _fp.isNil)(lastItem.to) ? lastItem.from : lastItem.to;

      // threshold is out of scale-range
      if (scale.min > thresholdRangeFrom || scale.max < thresholdRangeTo) {
        return false;
      }

      // threshold should be in order
      var i = 1;
      var thresholdLength = thresholds.length;
      for (i; i < thresholdLength && re; i++) {
        re &= thresholds[i].from >= thresholds[i - 1].to;
      }

      return re;
    };

    if (!isValidThreshold(definedThreshold, scale)) {
      throw new Error(_Izenda.Message.M04);
    }

    var updateThreshold = function updateThreshold(thresholds, scale) {
      var first = (0, _fp.head)(thresholds);
      var lastItem = (0, _fp.last)(thresholds);

      if ((0, _fp.isNil)(first.from)) {
        first.from = scale.min;
      }

      if ((0, _fp.isNil)(lastItem.to)) {
        lastItem.to = scale.max;
      }
    };

    (0, _fp.size)(definedThreshold) && updateThreshold(definedThreshold, scale);

    /**
     * Get supplementary KPI (simple gauge)
     * @param  {object} supplementaryKPI
     * @param  {object} dataParser
     * @param  {object} record
     * @return {object}
     */
    var getSupplementaryKPI = function getSupplementaryKPI(supplementaryKPI, dataParser, record) {
      var field = supplementaryKPI.element || {};
      var fieldName = field.name || '';
      var value = supplementaryKPI.value || getValueFromField(field, dataParser, record);

      if ((0, _fp.isNil)(value)) {
        return null;
      }
      var jsFormatString = (0, _fp.get)('properties.dataFormattings.format.jsFormatString', field);
      return {
        name: fieldName,
        value: value,
        unit: supplementaryKPI.unitLabel,
        dataFormatter: function dataFormatter(value) {
          if (jsFormatString) {
            var dataType = (0, _fp.get)('properties.dataFormattings.functionInfo.formatDataType', field);
            var jsFormatId = (0, _fp.get)('properties.dataFormattings.format.formatId', field);
            return _Izenda3.default.formatDataByStringFormat(jsFormatId, value, dataType);
          }

          return (0, _fp.getOr)(value, 'fomattedValue', _Izenda7.default.getValueStyle(value, seriesOptions[fieldName], {
            element: field,
            record: record
          }));
        }
      };
    };

    return {
      commonOptions: {
        izendaOptions: {
          showLabels: (0, _fp.get)('view.showLabels', props.chartOptions),
          autoResized: true,
          scaleFrom: scale.min,
          scaleTo: scale.max,
          serieName: chartName,
          dataUnit: (0, _fp.getOr)('', 'unitLabel', metricInfo),
          threshold: definedThreshold,
          izendaHiddenAllAxis: true
        },
        series: [{
          data: [{
            y: dataValue,
            name: xAxisField && record[xAxisField.columnName],
            textColor: textColor,
            supplementaryKPI: getSupplementaryKPI((0, _fp.getOr)('', 'supplementaryKPI', metricInfo), dataParser, record),
            record: record
          }],

          xAxisField: xAxisField,
          yAxisField: valueMappingField,
          separatorField: (0, _fp.get)('linkTo.groupField', groupData),
          separatorValue: (0, _fp.get)('linkTo.groupName', groupData)
        }]
      }
    };
  };

  /**
   * Create gauge charts
   * @param  {array}  record
   * @param  {object} xAxisField
   * @param  {object}  groupData
   * @param  {object}  otherGroupData
   * @return {array}
   */
  var createGaugeChart = function createGaugeChart(record, xAxisField, groupData) {
    var series = dataStructure[Y_AXIS_CONTAINER_NAME].map(function (valueMappingField, index) {
      return function () {
        return getDataForChart(record, valueMappingField, xAxisField, groupData);
      };
    });

    return series;
  };
  /**
   * Group data by label (in case [function] of field is null)
   * @param  {array} records
   * @param  {object} groupData
   * @param  {object} otherGroupData
   * @return {object}
   */
  var groupDataByLabel = function groupDataByLabel(records, parent) {
    var groupingField = (0, _fp.nth)(dataParser.expandedLevel, dataStructure[X_AXIS_CONTAINER_NAME]);
    var groupNames = [];
    var groupedData = dataParser.groupData(groupingField, groupNames, records);
    var groupInfo = void 0,
        groupRecords = void 0,
        charts = void 0;

    if (!groupingField) {
      groupNames = ['ALL'];
      groupedData = {
        ALL: groupedData
      };
    }

    groupNames.forEach(function (groupName, groupIndex) {
      groupRecords = groupedData[groupName];

      groupInfo = $izenda.extend(false, processDataByGroup(groupRecords, dataParser), {
        groupField: groupingField,
        groupName: groupingField ? groupName : '',
        groupIndex: groupIndex,
        isShowPanel: false,
        records: groupRecords
      });

      // link to parent-group
      if (!groupInfo) {
        groupInfo = parent;
      } else {
        parent && (groupInfo = (0, _fp.set)(parent.groupField ? 'linkTo' : 'allData', parent, groupInfo));
      }

      // create gauge chart
      groupedData[groupName].forEach(function (record) {
        charts = createGaugeChart(record, groupingField, groupInfo);
        addChart(charts, groupInfo);
      });
    });
  };

  /**
   * Group data by separator field
   * @param  {array} sourceData
   * @return {object}
   */
  var groupDataBySeparator = function groupDataBySeparator() {
    var groupingField = (0, _fp.head)(dataStructure[SEPARATOR_CONTAINER_NAME]);
    var groupNames = [];
    var groupedData = dataParser.groupData(groupingField, groupNames);
    var groupInfo = void 0,
        groupRecords = void 0;

    if (!groupingField) {
      groupNames = ['ALL'];
      groupedData = {
        ALL: groupedData
      };
    }

    groupNames.forEach(function (groupName, groupIndex) {
      groupRecords = groupedData[groupName];
      groupInfo = $izenda.extend(false, processDataByGroup(groupRecords, dataParser), {
        groupField: groupingField,
        groupName: groupName,
        groupIndex: groupIndex,
        isShowPanel: true,
        records: groupRecords
      });

      groupDataByLabel(groupedData[groupName], groupInfo);
    });
  };

  /**
   *
   * @param {number} dataValue
   * @param {object} metricInfo
   * @param {object} groupInfo
   * @param {object} definedThreshold
   */
  function getScaleInfo(dataValue, metricInfo, groupInfo, definedThreshold) {
    dataValue = dataValue || 0;
    groupInfo = groupInfo || {};

    // user defined
    var min = (0, _fp.get)('scale.from', metricInfo);
    var max = (0, _fp.get)('scale.to', metricInfo);
    var hasScaleFrom = (0, _fp.isNumber)(min);
    var hasScaleTo = (0, _fp.isNumber)(max);
    var hasThreshold = !!(0, _fp.size)(definedThreshold);
    var firstThreshold = void 0,
        lastThreshold = void 0,
        tempMin = void 0,
        tempMax = void 0;

    // scale from/to is undefined >> get min/max from thresholds
    if ((0, _fp.isNil)(min)) {
      if (hasThreshold) {
        firstThreshold = (0, _fp.head)(definedThreshold);
        tempMin = firstThreshold.from || firstThreshold.to;
        min = Math.min(groupInfo.min, tempMin);
      } else {
        min = groupInfo.min;
      }
    }

    if ((0, _fp.isNil)(max)) {
      if (hasThreshold) {
        lastThreshold = (0, _fp.last)(definedThreshold);
        tempMax = lastThreshold.from || lastThreshold.to;
        max = Math.max(groupInfo.max, tempMax);
      } else {
        max = groupInfo.max;
      }
    }

    // incase min = max, auto-caculate min/max
    if ((0, _fp.isNil)(min)) {
      min = dataValue * 0.5;
    }

    if ((0, _fp.isNil)(max)) {
      max = dataValue * 1.5;
    }

    if (!(0, _fp.isNil)(min) && min === max) {
      if (min === 0) {
        min = MIN_DEFAULT_VALUE;
        max = MAX_DEFAULT_VALUE;
      } else {
        var bias = Math.ceil(Math.abs(dataValue / 2) || Math.abs(min / 2));
        min = min - bias;
        max = max + bias;
      }
    }

    if (min >= max) {
      if (hasScaleFrom && !hasScaleTo) {
        throw new Error(_Izenda.Message.M07);
      } else if (!hasScaleFrom && hasScaleTo) {
        throw new Error(_Izenda.Message.M08);
      }
      throw new Error(_Izenda.Message.M06);
    }

    return {
      min: min,
      max: max
    };
  }

  groupDataBySeparator();
  return {
    charts: serieInfo.charts,
    numberMetrics: (0, _fp.size)(dataStructure[Y_AXIS_CONTAINER_NAME]),
    groupCharts: groupCharts
  };
};

exports.default = function (props) {
  return {
    getChartSeries: function getChartSeries() {
      return _getChartSeries(props);
    }
  };
};

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

exports.default = function (props) {
  return {
    getChartSeries: function getChartSeries() {
      return _getChartSeries(props);
    }
  };
};

var _mobx = __webpack_require__(5);

var _highcharts = __webpack_require__(238);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(33);

var _Izenda2 = __webpack_require__(80);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(39);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(171);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(35);

var _Izenda9 = _interopRequireDefault(_Izenda8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PieChartActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var X_AXIS_CONTAINER_NAME = 'labels';
var Y_AXIS_CONTAINER_NAME = 'values';
var SEPARATOR_CONTAINER_NAME = 'separators';
var SORT_TYPES = _Izenda5.default.SORT_TYPES;
var GROUP_SEPARATOR = ';#';

/**
 * create data for gauge
 * @param  {any} props
 * @return {any}
 */
function _getChartSeries(props) {
  var dataParser = props.chartData;
  var dataStructure = dataParser.dataStructure;

  var serieInfo = {
    groups: {},
    charts: []
  };

  var groupCharts = {}; // { groupName: [{ chartId: id}]}
  groupDataBySeparator();

  return {
    charts: serieInfo.charts,
    numberMetrics: (0, _fp.size)(dataStructure[Y_AXIS_CONTAINER_NAME]),
    groupCharts: groupCharts
  };

  /**
   * Add chart
   * @param {any} charts
   * @param {any} groupInfo
   */
  function addChart(charts, groupInfo) {
    var chartInfos = [];
    charts = (0, _fp.isArray)(charts) ? charts : [charts];

    charts.forEach(function (chart) {
      chart.id = (0, _fp.uniqueId)();
      chart.linkTo = groupInfo;
      serieInfo.charts.push(chart);
      chartInfos.push({
        id: chart.id
      });
    });
    var groupName = (0, _fp.get)('groupName', groupInfo);
    if (groupName !== undefined) {
      (0, _fp.isNil)(groupCharts[groupName]) && (groupCharts[groupName] = []);
      groupCharts[groupName] = (0, _fp.concat)(chartInfos, groupCharts[groupName]);
    }
  }

  /**
   * Group data by separator field
   */
  function groupDataBySeparator() {
    var groupingField = (0, _fp.first)(dataStructure[SEPARATOR_CONTAINER_NAME]);
    var labelField = (0, _fp.nth)(dataParser.expandedLevel, dataStructure[X_AXIS_CONTAINER_NAME]);
    var izMultiLevel = (0, _fp.getOr)(false, 'chartOptions.optionByType.izMultiLevel', props);
    var groupNames = [];
    var groupedData = dataParser.groupData(groupingField, groupNames);
    var groupInfo = void 0,
        groupRecords = void 0,
        groupStyle = void 0;

    if (!groupingField) {
      groupNames = ['ALL'];
      groupedData = {
        ALL: groupedData
      };
    }

    // Get data
    groupNames.forEach(function (groupName, groupIndex) {
      groupRecords = groupedData[groupName];
      groupInfo = groupingField && {
        groupField: groupingField,
        groupName: groupName,
        groupIndex: groupIndex,
        isShowPanel: true,
        records: groupRecords
      };

      (props.chartType === _Izenda.CHART_TYPE.Donut || _Izenda5.default.isChartType(props.chartType, _Izenda.CHART_TYPE.TreeMap) && izMultiLevel ? createAllDrildownData : createChart)(groupRecords, labelField, groupInfo);
    });
  }

  /**
   * Create charts
   * @param  {any}  record
   * @param  {any} xAxisField
   * @param  {any}  groupInfo
   */
  function createChart(records, xAxisField, groupInfo) {
    var series = {};
    var label = void 0,
        originalLabelValue = void 0,
        value = void 0,
        chartName = void 0;

    records.forEach(function (record) {
      label = record[xAxisField.columnName];
      originalLabelValue = _Izenda9.default.getOriginalValue(xAxisField, record);

      dataStructure[Y_AXIS_CONTAINER_NAME].forEach(function (valueMappingField) {
        chartName = valueMappingField.fieldNameAlias;
        var isUsingCustomFormat = _Izenda7.default.checkUsingCustomFormat(valueMappingField);
        value = isUsingCustomFormat ? record[_Izenda5.default.CUSTOM_FORMAT_PREFIX + valueMappingField.columnName] : record[valueMappingField.columnName];

        if (!series[chartName]) {
          series[chartName] = {
            name: chartName,
            labelName: xAxisField.fieldNameAlias,
            nameField: xAxisField,
            yAxisField: valueMappingField,
            data: [],
            rawData: records,
            separatorField: (0, _fp.get)('groupField', groupInfo),
            separatorValue: (0, _fp.get)('groupName', groupInfo)
          };
        }

        (label || value) && series[chartName].data.push({
          name: (0, _fp.isNull)(label) ? 'null' : label,
          originalNameValue: (0, _fp.isNull)(originalLabelValue) ? 'null' : originalLabelValue,
          y: value,
          record: record
        });
      });
    });

    (0, _fp.forIn)(function (serie) {
      addChart([{
        commonOptions: {
          series: [serie]
        }
      }], groupInfo);
    }, series);
  }

  /**
   * Get field name
   * @param {any} field
   */
  function getFieldName(field) {
    return (0, _fp.get)('fieldNameAlias', field);
  }

  function addDonutData(source, name, originalNameValue, val, level, groupId, valueFieldName, labelFieldName, record) {
    var _props$chartOptions = props.chartOptions,
        colors = _props$chartOptions.colors,
        izMultiColor = _props$chartOptions.optionByType.izMultiColor,
        izDisableMultiColor = _props$chartOptions.commonOptions.izDisableMultiColor;

    var serieColors = colors || _highcharts2.default.getOptions().colors;
    var index = izMultiColor && !izDisableMultiColor ? (0, _fp.get)('id', groupId) % serieColors.length : 0;

    var point = {
      name: name,
      originalNameValue: originalNameValue,
      y: val,
      groupId: groupId,
      record: record,
      color: serieColors[index]
    };

    // add to source
    source.push(point);
  }

  /**
   * Create all drilldown data
   * @param {any} records
   * @param {any} labelField
   * @param {any} groupInfo
   */
  function createAllDrildownData(records, labelField, groupInfo) {
    var xDatafields = dataStructure[X_AXIS_CONTAINER_NAME];
    var xAxisFields = (0, _mobx.toJS)(xDatafields);

    xAxisFields = (0, _fp.map)(function (value) {
      var originalField = (0, _fp.find)({ fieldNameAlias: value.fieldNameAlias }, xDatafields);
      value.reportPartElm = !(0, _fp.isNil)(originalField) && !(0, _fp.isNil)(value.reportPartElm) ? (0, _fp.assign)(value.reportPartElm, {
        isDateTimeType: (0, _fp.get)('reportPartElm.isDateTimeType', originalField),
        fieldFormatData: (0, _fp.get)('reportPartElm.fieldFormatData', originalField)
      }) : value.reportPartElm;
      return value;
    }, xAxisFields);

    var series = {};
    var serie = void 0;

    dataStructure[Y_AXIS_CONTAINER_NAME].forEach(function (valField) {
      series[getFieldName(valField)] = intData(valField);
    });

    try {
      parseData(xAxisFields, records);

      (0, _keys2.default)(series).map(function (serieName) {
        serie = series[serieName];

        addChart({
          commonOptions: {
            series: {
              data: getSerieByDrilldownLevel(serie.drilldownData),
              yAxisField: serie.yAxisField,
              serieName: serieName,
              separatorField: (0, _fp.get)('groupField', groupInfo),
              separatorValue: (0, _fp.get)('groupName', groupInfo)
            }
          }
        }, groupInfo);
      });
    } catch (e) {
      return null;
    }

    function getSerieByDrilldownLevel(drilldownData) {
      var levels = [];
      var levelData = void 0;

      (0, _keys2.default)(drilldownData).forEach(function (levelName) {
        levelData = drilldownData[levelName];
        levels[(0, _fp.get)('level', levelData)] = levelData;
      });

      return levels;
    }

    function intData(valField) {
      var re = {
        yAxisField: valField,
        drilldownData: {}
      };

      var drilldownData = re.drilldownData;

      xAxisFields.forEach(function (xField, index) {
        drilldownData[getFieldName(xField)] = {
          data: [],
          nameField: xField,
          level: index
        };
      });

      return re;
    }

    function updateSerieData(xAxisField, data) {
      var xFieldName = getFieldName(xAxisField);
      var yFieldName = void 0,
          drilldownData = void 0;

      dataStructure[Y_AXIS_CONTAINER_NAME].forEach(function (yField) {
        yFieldName = getFieldName(yField);
        drilldownData = series[yFieldName].drilldownData[xFieldName];
        drilldownData.data = drilldownData.data.concat((0, _fp.getOr)([], 'data', data[yFieldName]));
      });
    }

    function parseData(xAxisFields, records, parentId) {
      var groupingField = xAxisFields.shift();
      var metricsData = void 0;

      if (!groupingField || !xAxisFields.length) {
        metricsData = getMetricData(groupingField, records, xAxisFields.length, parentId);
        updateSerieData(groupingField, metricsData);
        return metricsData;
      }

      var groupNames = [];
      var groupedData = dataParser.groupData(groupingField, groupNames, records);

      var sortValueXAxis = (0, _fp.get)('reportPartElm.properties.dataFormattings.sort', groupingField);

      if ((0, _fp.includes)(sortValueXAxis, [SORT_TYPES.ASC, SORT_TYPES.DESC])) {
        groupNames = (0, _fp.flow)(_fp.keys, (0, _fp.orderBy)([function (item) {
          return (0, _fp.isNaN)((0, _fp.toNumber)(item)) ? item : (0, _fp.toNumber)(item);
        }], [sortValueXAxis === SORT_TYPES.DESC ? (0, _fp.toLower)(SORT_TYPES.DESC) : (0, _fp.toLower)(SORT_TYPES.ASC)]))(groupedData);
      } else {
        var fieldYAxis = (0, _fp.last)(dataStructure[Y_AXIS_CONTAINER_NAME]);
        var name = fieldYAxis.columnName;
        var sortValueYAxis = (0, _fp.get)('reportPartElm.properties.dataFormattings.sort', fieldYAxis);
        groupNames = (0, _fp.flow)(_fp.keys, (0, _fp.map)(function (key) {
          return {
            key: key,
            value: (0, _fp.sumBy)(function (item) {
              return item[name];
            }, groupedData[key])
          };
        }), (0, _fp.orderBy)(['value'], [sortValueYAxis === SORT_TYPES.DESC ? (0, _fp.toLower)(SORT_TYPES.DESC) : (0, _fp.toLower)(SORT_TYPES.ASC)]), (0, _fp.map)('key'))(groupedData);
      }

      var index = 0;
      (0, _fp.forEach)(function (groupedName) {
        var groupId = {};
        var basePath = '' + index + groupedName + GROUP_SEPARATOR;
        groupId.id = (0, _fp.isNil)(parentId) || (0, _fp.isEmpty)(parentId) ? index : parentId.id;
        groupId.path = (0, _fp.isNil)(parentId) || (0, _fp.isEmpty)(parentId) ? basePath : '' + basePath + parentId.path;
        groupedData[groupedName] = {
          groupId: groupId,
          data: parseData((0, _fp.clone)(xAxisFields), groupedData[groupedName], groupId),
          records: groupedData[groupedName]
        };
        index++;
      }, groupNames);

      metricsData = getMetricDataByGroup(groupingField, groupNames, groupedData, xAxisFields.length, parentId);
      updateSerieData(groupingField, metricsData);

      return metricsData;
    }

    function getMetricDataByGroup(groupingField, groupNames, groupData, level, parentId) {
      var itemVal = void 0;
      var metricsData = {};
      var metric = void 0;
      var group = void 0;

      dataStructure[Y_AXIS_CONTAINER_NAME].forEach(function (yField) {
        metricsData[getFieldName(yField)] = {
          data: [],
          sum: 0
        };
      });

      groupNames.forEach(function (groupName) {
        group = (0, _fp.get)('data', groupData[groupName]);
        var record = (0, _fp.flow)((0, _fp.get)('records'), _fp.head)(groupData[groupName]);

        var groupNameOriginalValue = _Izenda9.default.getOriginalValue(groupingField, record);
        dataStructure[Y_AXIS_CONTAINER_NAME].forEach(function (yField) {
          var fieldName = getFieldName(yField);

          itemVal = (0, _fp.toNumber)((0, _fp.get)('sum', group[fieldName]));
          metric = metricsData[fieldName];

          addDonutData(metric.data, groupName, groupNameOriginalValue, itemVal, level, (0, _fp.get)('groupId', groupData[groupName]), fieldName, getFieldName(groupingField), createFakeRecordForGroup(group[fieldName], yField, itemVal));
          metric.sum += itemVal;
        });
      });
      return metricsData;

      function createFakeRecordForGroup(groupData, field, sum) {
        var record = (0, _fp.get)('data[0].record', groupData);
        var key = field.columnName;
        var keyPercent = 'percentage_' + key;
        var re = {};

        re[keyPercent] = sum * record[keyPercent] / record[key];
        re[key] = sum;

        return re;
      }
    }

    function getMetricData(xField, records, level, parentId) {
      var metricsData = {};

      dataStructure[Y_AXIS_CONTAINER_NAME].forEach(function (yField) {
        metricsData[getFieldName(yField)] = {
          data: [],
          sum: 0
        };
      });

      // get data for each point
      records.forEach(function (record) {
        var originalNameValue = _Izenda9.default.getOriginalValue(xField, record);
        var itemName = (0, _fp.get)(xField.columnName, record);
        var labelFieldName = getFieldName(xField);

        dataStructure[Y_AXIS_CONTAINER_NAME].forEach(function (yField) {
          var itemVal = (0, _fp.toNumber)(_Izenda9.default.getOriginalValue(yField, record));
          var valueFieldName = getFieldName(yField);
          var metric = metricsData[getFieldName(yField)];

          addDonutData(metric.data, itemName, originalNameValue, itemVal, level, parentId, valueFieldName, labelFieldName, record);
          metric.sum += itemVal;
        });
      });

      return metricsData;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(80);

var _Izenda2 = __webpack_require__(405);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(44);

var _Izenda5 = __webpack_require__(952);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(39);

var _highcharts = __webpack_require__(238);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _Izenda8 = __webpack_require__(220);

var _Izenda9 = _interopRequireDefault(_Izenda8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SparklineChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var X_AXIS_CONTAINER_NAME = 'labels';
var Y_AXIS_CONTAINER_NAME = 'values';
var SEPARATOR_CONTAINER_NAME = 'separators';
var DEFAULT_HEIGHT_SIZE = 40;
var DEFAULT_FONT_SIZE = 14;
var DEFAULT_PADDING = 10;

var SPARKLINE_CHART_OPTS = {
  commonOptions: {
    izendaHiddenAllAxis: true,
    izMargin: 0,
    'izLegend.visibility': false,
    'izMarker.radius': 1,
    izChartStyle: { overflow: 'visible' },

    /* tooltip */
    'izTooltip.enabled': true,
    'izTooltip.borderWidth': 0,
    'izTooltip.hideDelay': 0,
    'izTooltip.shared': true,
    'izTooltip.positioner': function izTooltipPositioner(w, h, point) {
      return { x: 0, y: -h / 2 };
    },
    izFillContainer: true
  },
  optionByType: {
    izValueLabel: false,
    izInverted: false,
    izStacking: null,
    izMultiColor: false
  },
  commonXYAxis: {
    /* Sparkline does not support Threshold line. So we need to reset */
    allDynamicThresholdLine: [],
    metricAllPlotLinesOption: [],
    /* End */
    xAxis: {
      izTickPositions: [],
      izStartOnTick: false,
      izEndOnTick: false,
      'izLabel.enabled': false,
      'izTitle.enabled': false,
      'izTitle.text': ''
    },
    yAxis: {
      izTickPositions: [0],
      izStartOnTick: false,
      izEndOnTick: false,
      'izLabel.enabled': false,
      'izTitle.enabled': false,
      'izTitle.text': ''
    },
    commonXYAxis: {
      izGridLine: null
    }
  }
};

var COLUMN_TYPE = {
  Total: 'Total',
  Chart: 'Chart',
  Separator: 'Separator'
};

var SparklineChart = function (_Component) {
  (0, _inherits3.default)(SparklineChart, _Component);

  function SparklineChart() {
    (0, _classCallCheck3.default)(this, SparklineChart);
    return (0, _possibleConstructorReturn3.default)(this, (SparklineChart.__proto__ || (0, _getPrototypeOf2.default)(SparklineChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(SparklineChart, [{
    key: 'renderByField',

    /**
     * Render by field
     * @param {any} fieldInfo
     * @param {any} cellSize
     * @param {Function} getContentStyle
     */
    value: function renderByField(fieldInfo, cellSize, getContentStyle) {
      var props = this.props;
      var dataParser = props.chartData,
          seriesOptions = props.seriesOptions,
          chartOptions = props.chartOptions;

      var dataStructure = dataParser.dataStructure;
      var cols = [];

      var fieldName = fieldInfo.fieldNameAlias;
      var fieldConfig = (0, _fp.getOr)({}, fieldName, seriesOptions);
      var columnProps = {
        fnGetCellContentStyle: function fnGetCellContentStyle() {
          return getContentStyle(false);
        },
        resizable: false
      };

      // add [sum] column (if any)
      if (fieldConfig.showTotal) {
        cols.push(_react2.default.createElement(_Izenda4.Column, (0, _extends3.default)({}, columnProps, {
          columnType: COLUMN_TYPE.Total,
          title: 'Total of ' + fieldName,
          className: 'align-right',
          align: 'center',
          cell: renderSumValue
        })));
      }

      // render chart
      columnProps.fnGetCellContentStyle = function () {
        return getContentStyle(true);
      };

      cols.push(_react2.default.createElement(_Izenda4.Column, (0, _extends3.default)({}, columnProps, { columnType: COLUMN_TYPE.Chart, title: fieldName, cell: renderChart })));

      return cols;

      function renderChart(rowData) {
        var dtStructure = $izenda.extend(true, {}, dataStructure);
        dtStructure.values = [fieldInfo];
        var xAxisField = (0, _fp.nth)(dataParser.expandedLevel, dtStructure[X_AXIS_CONTAINER_NAME]);

        // Clone and remove dynamic threshold because Sparkine No need Threshold
        var cloneSeriesOptions = (0, _fp.mapValues)(function (serie) {
          return (0, _fp.omit)([_Izenda7.ContainerName.DYNAMIC_THRESHOLD, 'thresholds'], serie);
        }, (0, _extends3.default)({}, seriesOptions));

        var field = xAxisField && cloneSeriesOptions[xAxisField.fieldNameAlias];
        field && (field.axisOption = (0, _extends3.default)({}, field.axisOption, { izCategory: true }));

        return _react2.default.createElement(_Izenda3.default, (0, _extends3.default)({}, props, {
          seriesOptions: cloneSeriesOptions,
          chartOptions: $izenda.extend(true, {}, chartOptions, SPARKLINE_CHART_OPTS),
          chartType: (0, _fp.get)('chartOptions.chartType', fieldConfig),
          chartData: (0, _Izenda.parser)(null, null, { fieldsMapping: null, records: rowData.data }, dtStructure)
        }));
      }

      function renderSumValue(rowData) {
        var source = dataParser.getDataByField(fieldInfo, rowData.data);
        var jsFormatString = (0, _fp.get)('reportPartElm.properties.dataFormattings.format.jsFormatString', fieldInfo);
        var totalValue = (0, _fp.sumBy)(_fp.toNumber, source.data);
        var jsFormatId = jsFormatString ? (0, _fp.get)('reportPartElm.properties.dataFormattings.format.formatId', fieldInfo) : null;
        var sum = jsFormatString ? _Izenda9.default.format(jsFormatId, totalValue) : totalValue;

        return _react2.default.createElement(
          'span',
          null,
          dataParser.getFormatData(sum, fieldConfig)
        );
      }
    }

    /**
     * Get cell size
     * @param {any} containerSize
     * @param {number} numRows
     * @param {number} numCols
     */

  }, {
    key: 'getCellSize',
    value: function getCellSize(containerSize, numRows, numCols) {
      var containerHeight = containerSize.height;
      var containerWidth = containerSize.width;

      return {
        width: containerWidth / numCols,
        height: Math.min(DEFAULT_HEIGHT_SIZE, containerHeight / (numRows + 2))
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          chartOptions = _props.chartOptions,
          seriesOptions = _props.seriesOptions,
          dataParser = _props.chartData,
          printingMode = _props.printingMode,
          isPreview = _props.isPreview,
          _props$containerSize = _props.containerSize,
          height = _props$containerSize.height,
          width = _props$containerSize.width;

      var dataStructure = dataParser.dataStructure;
      var hasSeparator = dataParser.hasSeparator(SEPARATOR_CONTAINER_NAME);
      var rowData = parseData() || [];
      var containerSize = {
        height: height - (printingMode ? 0 : DEFAULT_HEIGHT_SIZE * 2),
        width: width
      };
      var columns = getColumns.call(this);
      var cellSize = void 0;

      addSeparatorColumn(columns);
      cellSize = this.getCellSize(containerSize, (0, _fp.size)(rowData), (0, _fp.size)(columns));

      return renderUseTable(rowData, columns);

      function renderUseTable(rowData, columns) {
        var tableStyle = {
          fontSize: DEFAULT_FONT_SIZE * (cellSize.height / DEFAULT_HEIGHT_SIZE)
        };
        var colWidth = Math.ceil(containerSize.width / (0, _fp.size)(columns));
        var cols = (0, _fp.map)(function (col) {
          return _react2.default.cloneElement(col, { width: colWidth });
        }, columns);

        return _react2.default.createElement(
          _Izenda4.Table,
          {
            dataSource: rowData,
            staticRender: true,
            className: 'simple-table',
            tableStyle: tableStyle,
            showScroll: false
          },
          cols
        );
      }

      function getContentStyle(isChartColumn) {
        var padding = Math.ceil(DEFAULT_PADDING * (cellSize.height / DEFAULT_HEIGHT_SIZE) * (isChartColumn ? 0.5 : 1));
        return {
          paddingTop: padding,
          paddingBottom: padding,
          height: Math.ceil(cellSize.height) + 'px'
        };
      }

      function parseData() {
        var groupNames = [];
        var groupedData = dataParser.groupData(SEPARATOR_CONTAINER_NAME, groupNames);

        if (!hasSeparator) {
          groupNames = ['ALL'];
          groupedData = {
            ALL: groupedData
          };
        }

        var groupArr = groupNames.map(function (groupName) {
          return {
            name: groupName,
            data: groupedData[groupName]
          };
        });

        if (isPreview && !printingMode) {
          return (0, _fp.slice)(0, _Izenda7.PAGE_SIZE_BACK_SIDE, groupArr);
        }

        return groupArr;
      }

      function getColumns() {
        var _this2 = this;

        var columns = [];
        dataStructure[Y_AXIS_CONTAINER_NAME].forEach(function (field) {
          columns = (0, _fp.concat)(columns, _this2.renderByField(field, cellSize, getContentStyle) || []);
        });

        return columns;
      }

      function addSeparatorColumn(columns) {
        if (!hasSeparator) {
          return columns;
        }

        columns.unshift(getSeparatorColumn());

        return columns;

        function getSeparatorColumn() {
          var separatorInfo = dataParser.getSeparatorInfo(SEPARATOR_CONTAINER_NAME);
          var separatorOptions = (0, _fp.getOr)({}, separatorInfo.fieldNameAlias, seriesOptions);
          var pointAction = (0, _fp.get)('commonActions.pointAction', chartOptions);

          return _react2.default.createElement(_Izenda4.Column, {
            columnType: COLUMN_TYPE.Separator,
            title: separatorInfo.fieldNameAlias,
            cell: renderSeparator,
            resizable: false,
            fnGetCellContentStyle: getSeparatorContentStyle
          });

          function getSeparatorContentStyle() {
            return getContentStyle(false);
          }

          function renderSeparator(rowData) {
            var fieldSource = {
              element: separatorInfo,
              record: (0, _fp.head)(rowData.data)
            };

            return _react2.default.createElement(_Izenda6.default, {
              value: rowData && rowData.name,
              fieldName: separatorInfo.fieldNameAlias,
              configField: separatorOptions,
              fieldSource: fieldSource,
              pointAction: pointAction
            });
          }
        }
      }
    }
  }]);
  return SparklineChart;
}(_react.Component);

exports.default = (0, _mobxReact.observer)(SparklineChart);
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _bluebird = __webpack_require__(18);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _dec, _class3, _class4, _class5;

var _Izenda = __webpack_require__(39);

var _Izenda2 = __webpack_require__(2);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _recompose = __webpack_require__(9);

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda4 = __webpack_require__(951);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(97);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(405);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(952);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(1891);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(76);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.GridChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var NUMBER_PER_ROW = 2;
var PAGE_SIZE_OPTIONS = [5, 10, 20, 30, 40, 50];
var DEFAULT_PAGE_SIZE = 5;

var hasCharts = _Izenda13.default.hasCharts,
    buildChartTree = _Izenda13.default.buildChartTree,
    getNumChart = _Izenda13.default.getNumChart,
    getGroupChartInfo = _Izenda13.default.getGroupChartInfo,
    getSizePercent = _Izenda13.default.getSizePercent;

var ChartGroup = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(ChartGroup, _Component);

  function ChartGroup() {
    (0, _classCallCheck3.default)(this, ChartGroup);
    return (0, _possibleConstructorReturn3.default)(this, (ChartGroup.__proto__ || (0, _getPrototypeOf2.default)(ChartGroup)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChartGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          groupName = _props.groupName,
          groupLevels = _props.groupLevels,
          chartOptions = _props.chartOptions,
          seriesOptions = _props.seriesOptions,
          children = _props.children;

      var chartSeries = this.props.chartSeries || [];
      var groupInfo = getGroupChartInfo(chartSeries, groupLevels);
      var groupField = (0, _fp.get)('groupField', groupInfo);
      var groupFieldName = (0, _fp.get)('fieldNameAlias', groupField);
      var pointAction = (0, _fp.get)('commonActions.pointAction', chartOptions);
      var fieldConfig = (0, _fp.get)(groupFieldName, seriesOptions);

      var classesHeader = (0, _classnames2.default)('izenda-ChartWrapper-header', {
        u_borderBottom: groupInfo && groupInfo.isShowPanel
      });

      var renderTitle = function renderTitle() {
        var fieldSource = {
          element: (0, _fp.get)('groupField', groupInfo),
          record: (0, _fp.head)((0, _fp.get)('records', groupInfo))
        };
        return groupInfo && _react2.default.createElement(_Izenda11.default, {
          value: groupName,
          configField: fieldConfig,
          pointAction: pointAction,
          fieldName: groupFieldName,
          fieldSource: fieldSource,
          linkTo: groupInfo.linkTo
        });
      };

      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper grid-chart-item' },
        _react2.default.createElement(
          'div',
          { className: classesHeader },
          renderTitle()
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-ChartWrapper-content' },
          children
        )
      );
    }
  }]);
  return ChartGroup;
}(_react.Component)) || _class;

var ChartItem = (0, _mobxReact.observer)(_class2 = function (_Component2) {
  (0, _inherits3.default)(ChartItem, _Component2);

  function ChartItem() {
    (0, _classCallCheck3.default)(this, ChartItem);
    return (0, _possibleConstructorReturn3.default)(this, (ChartItem.__proto__ || (0, _getPrototypeOf2.default)(ChartItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChartItem, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          chart = _props2.chart,
          printingMode = _props2.printingMode,
          style = _props2.style,
          chartOpt = _props2.chartOptions,
          finishedRender = _props2.finishedRender;

      var chartProps = (0, _fp.omit)(['style'], this.props);

      try {
        var chartOptions = (0, _fp.isFunction)(chart) ? chart() : chart;
        chartOptions = $izenda.extend(true, {}, chartOpt, chartOptions, {
          commonOptions: {
            izendaOptions: {
              autoResized: true
            }
          }
        });

        // turn off animation when printing.
        printingMode && $izenda.extend(true, chartOptions.commonOptions, {
          plotOptions: {
            series: {
              animation: false
            }
          }
        });

        return _react2.default.createElement(
          'div',
          { style: style, className: 'grid-chart-item' },
          _react2.default.createElement(_Izenda9.default, (0, _extends3.default)({}, chartProps, { chartOptions: chartOptions }))
        );
      } catch (e) {
        if (typeof finishedRender === 'function') {
          finishedRender();
        }

        return _react2.default.createElement(
          'div',
          { style: style, className: 'grid-chart-item' },
          e.message
        );
      }
    }
  }]);
  return ChartItem;
}(_react.Component)) || _class2;

var GridItem = (_dec = (0, _Izenda3.default)(), _dec(_class3 = function (_Component3) {
  (0, _inherits3.default)(GridItem, _Component3);

  function GridItem() {
    (0, _classCallCheck3.default)(this, GridItem);
    return (0, _possibleConstructorReturn3.default)(this, (GridItem.__proto__ || (0, _getPrototypeOf2.default)(GridItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(GridItem, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props3 = this.props,
          groupName = _props3.groupName,
          itemPerRow = _props3.itemPerRow,
          itemOrder = _props3.itemOrder,
          groupLevels = _props3.groupLevels,
          renderListeners = _props3.renderListeners,
          style = _props3.style;


      var renderGroup = function renderGroup(chartTree) {
        var childGroups = (0, _fp.map)(function (childNodeName) {
          var numChartsByGroup = getNumChart(chartTree[childNodeName]);
          var itemPerRowByGroup = Math.min(numChartsByGroup, itemPerRow);
          var width = 100 / itemPerRow * itemPerRowByGroup;
          var groupSize = getSizePercent(width, 100);

          return _react2.default.createElement(GridItem, (0, _extends3.default)({}, _this4.props, {
            key: childNodeName,
            groupName: childNodeName,
            groupLevels: newGroupLevels,
            chartSeries: chartTree[childNodeName],
            style: groupSize,
            numCharts: numChartsByGroup,
            itemPerRow: itemPerRowByGroup
          }));
        }, itemOrder);

        return childGroups;
      };

      var renderChartSerie = function renderChartSerie(chartNode) {
        var charts = chartNode.charts || [];
        var itemPerRowByGroup = itemPerRow;
        var chartSize = getSizePercent(100 / itemPerRowByGroup, 100);

        return charts.map(function (chart, index) {
          var renderListener = (0, _fp.find)(function (listener) {
            return listener.partId === chart.id;
          }, renderListeners);
          return _react2.default.createElement(ChartItem, (0, _extends3.default)({}, (0, _fp.omit)(['renderListeners'], _this4.props), {
            key: index,
            groupLevels: newGroupLevels,
            style: chartSize,
            chart: chart,
            finishedRender: renderListener && renderListener.resolve
          }));
        });
      };

      var getGroupLevels = function getGroupLevels(root, newLevel) {
        return newLevel ? (0, _fp.concat)(root || [], newLevel) : root;
      };

      var chartSeries = this.props.chartSeries || [];
      var newGroupLevels = getGroupLevels(groupLevels, groupName);
      var content = void 0;

      if (hasCharts(chartSeries)) {
        content = renderChartSerie(chartSeries);
      } else if ((0, _fp.size)(chartSeries) === 1 && hasCharts(chartSeries[groupName])) {
        content = renderChartSerie(chartSeries[groupName]);
      } else {
        content = renderGroup(chartSeries);
      }

      if (!(0, _fp.isNil)(groupName)) {
        content = _react2.default.createElement(
          ChartGroup,
          (0, _extends3.default)({}, this.props, { groupName: groupName }),
          content
        );
      }

      return _react2.default.createElement(
        'section',
        { className: 'grid-chart-item', style: style },
        content
      );
    }
  }]);
  return GridItem;
}(_react.Component)) || _class3);

var Row = (0, _mobxReact.observer)(_class4 = function (_Component4) {
  (0, _inherits3.default)(Row, _Component4);

  function Row() {
    (0, _classCallCheck3.default)(this, Row);
    return (0, _possibleConstructorReturn3.default)(this, (Row.__proto__ || (0, _getPrototypeOf2.default)(Row)).apply(this, arguments));
  }

  (0, _createClass3.default)(Row, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props4 = this.props,
          chartSeries = _props4.chartSeries,
          itemPerRow = _props4.itemPerRow,
          className = _props4.className,
          style = _props4.style;

      var chartTree = buildChartTree(chartSeries);
      var chartNodes = chartTree.chartTree;
      var groupPathInOrder = chartTree.groupPathInOrder;
      var classes = (0, _classnames2.default)('izenda-GridChart_row', className);
      var content = void 0;

      var renderGroup = function renderGroup(groupName, charts, chartLevel) {
        var chartSeries = chartNodes[groupName] || charts;
        var numCharts = getNumChart(chartSeries, 0);
        var groupSize = getSizePercent(100 / itemPerRow * numCharts, 100);
        var grpName = (0, _fp.isNaN)((0, _fp.toNumber)(groupName)) ? groupName : (0, _fp.toNumber)(groupName);
        var itemOrder = (0, _fp.reduce)(function (filtered, item) {
          item[0] === grpName && item.length > 1 && filtered.push(item[1]);
          return filtered;
        }, [], groupPathInOrder);

        return _react2.default.createElement(GridItem, (0, _extends3.default)({}, _this6.props, {
          chartLevel: chartLevel,
          gridLevel: 0,
          key: groupName,
          chartSeries: chartSeries,
          style: groupSize,
          itemPerRow: numCharts,
          groupName: groupName,
          itemOrder: itemOrder
        }));
      };

      if (hasCharts(chartNodes)) {
        content = renderGroup(null, chartNodes, 0);
      } else {
        var nodeNames = _Izenda13.default.getGroupNameInOrder(chartTree.chartTree, chartTree.groups);

        content = (0, _fp.map)(renderGroup, nodeNames);
      }

      return _react2.default.createElement(
        'div',
        { style: style, className: classes },
        content
      );
    }
  }]);
  return Row;
}(_react.Component)) || _class4;

var PageChart = (0, _mobxReact.observer)(_class5 = function (_Component5) {
  (0, _inherits3.default)(PageChart, _Component5);

  function PageChart() {
    (0, _classCallCheck3.default)(this, PageChart);
    return (0, _possibleConstructorReturn3.default)(this, (PageChart.__proto__ || (0, _getPrototypeOf2.default)(PageChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(PageChart, [{
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _props5 = this.props,
          itemPerRow = _props5.itemPerRow,
          numRows = _props5.numRows,
          chartSeries = _props5.chartSeries,
          printingMode = _props5.printingMode,
          doesBreakPage = _props5.doesBreakPage;

      var numCharts = (0, _fp.size)(chartSeries);
      var rows = getRows(chartSeries);
      // When the part using page break after separator, each separator using all of its part's area to render
      var useFullSize = printingMode && doesBreakPage;
      var classes = (0, _classnames2.default)({ u_fullSize: useFullSize });

      // Calculate each separator size in a part, if use full size, the style is empty
      var rowSize = useFullSize ? {} : getSizePercent(100, 100 / numRows);
      return _react2.default.createElement(
        'div',
        { className: 'u_fullSize' },
        rows.map(function (row, index) {
          return _react2.default.createElement(Row, (0, _extends3.default)({}, _this8.props, {
            className: classes,
            itemPerRow: Math.min(itemPerRow, numCharts),
            key: index,
            style: rowSize,
            chartSeries: row
          }));
        })
      );

      function getRows(chartSeries) {
        var chartsByRow = void 0;
        var rows = [];
        var counting = 0;

        while (counting < numCharts) {
          chartsByRow = (0, _fp.slice)(counting, counting + itemPerRow, chartSeries);
          rows.push(chartsByRow);
          counting += (0, _fp.size)(chartsByRow);
        }

        return rows;
      }
    }
  }]);
  return PageChart;
}(_react.Component)) || _class5;

var GridChartContainer = function (_Component6) {
  (0, _inherits3.default)(GridChartContainer, _Component6);

  function GridChartContainer() {
    (0, _classCallCheck3.default)(this, GridChartContainer);
    return (0, _possibleConstructorReturn3.default)(this, (GridChartContainer.__proto__ || (0, _getPrototypeOf2.default)(GridChartContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(GridChartContainer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props6 = this.props,
          chartSeries = _props6.chartSeries,
          goToPage = _props6.goToPage;


      if (nextProps.chartSeries !== chartSeries) {
        goToPage(1);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props7 = this.props,
          printingMode = _props7.printingMode,
          fulfilledData = _props7.fulfilledData;

      return !(printingMode && fulfilledData === nextProps.fulfilledData);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.finishedRenderChartSerie();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.finishedRenderChartSerie();
    }
  }, {
    key: 'finishedRenderChartSerie',
    value: function finishedRenderChartSerie() {
      var _props8 = this.props,
          finishedRender = _props8.finishedRender,
          fulfilledData = _props8.fulfilledData,
          renderListeners = _props8.renderListeners;

      if (finishedRender && fulfilledData) {
        var promises = (0, _fp.map)(function (item) {
          return item.promise;
        }, renderListeners);

        (0, _bluebird.all)(promises).then(function () {
          finishedRender();
        });
      }
    }

    /**
     * Render for printing.
     */

  }, {
    key: 'printingRender',
    value: function printingRender() {
      var _this10 = this;

      var _props9 = this.props,
          doesBreakPage = _props9.doesBreakPage,
          className = _props9.className,
          chartOptions = _props9.chartOptions,
          fulfilledData = _props9.fulfilledData,
          chartData = _props9.chartData,
          chartType = _props9.chartType,
          seriesOptions = _props9.seriesOptions,
          renderListeners = _props9.renderListeners,
          children = _props9.children,
          type = _props9.type;

      var separator = this.props.separator;
      var classes = (0, _classnames2.default)('izenda-grid-chart u_fullWidth u_overflowVisible', className);
      var chartSeries = this.props.chartSeries || {};
      var chartSeriesGroups = [];
      var itemPerRow = (0, _fp.get)('view.izItemPerRow', chartOptions) || (0, _fp.get)('optionByType.izItemPerRow', chartOptions) || NUMBER_PER_ROW;
      var total = (0, _fp.size)(chartSeries);

      var chartWrapperClass = (0, _classnames2.default)({
        'u_overflowVisible u_fullHeight': doesBreakPage,
        'chart-body izenda-ChartWrapper-body': !doesBreakPage
      });

      var sectionStyle = {
        float: 'none'
      };

      /**
       * Build chart series groups by separator.
       * This is intended to use for exporting with a given separator value.
       */
      var buildChartSeriesGroupsBySeparator = function buildChartSeriesGroupsBySeparator() {
        if (!_this10.props.forExporting) return;
        // In exporting, if we do not pass value for separator then separator will be UNDEFINED_VALUE.
        (0, _fp.isNil)(separator) && (separator = _Izenda16.UNDEFINED_VALUE);
        var groupCharts = _this10.props.groupCharts;

        var selectedGroupCharts = [];
        (0, _fp.forEach)(function (groupName) {
          if (groupName === separator) {
            selectedGroupCharts[groupName] = groupCharts[groupName];
            return false;
          }
        }, (0, _keys2.default)(groupCharts));
      };

      /**
       * Build chart collection of a group.
       */
      var buildChartSeriesGroup = function buildChartSeriesGroup(groupChart, chartSeries) {
        var result = [];

        if (!groupChart) return result;

        (0, _fp.forEach)(function (info) {
          var chartData = (0, _fp.find)(function (data) {
            return data.id === info.id;
          }, chartSeries);
          chartData && result.push(chartData);
        }, groupChart);

        return result;
      };

      // item per row should be smaller than item per page;
      itemPerRow = Math.min(itemPerRow, total);
      var numRows = Math.ceil(total / itemPerRow);

      if (doesBreakPage) {
        var selectedGroupCharts = this.props.groupCharts;
        buildChartSeriesGroupsBySeparator();

        (0, _fp.forEach)(function (groupChart) {
          chartSeriesGroups.push(buildChartSeriesGroup(selectedGroupCharts[groupChart], chartSeries));
        }, (0, _keys2.default)(selectedGroupCharts));
      } else {
        chartSeriesGroups.push(chartSeries);
      }

      var components = [];
      var numOfGroups = chartSeriesGroups.length - 1;
      chartSeriesGroups.map(function (series, index) {
        components.push(_react2.default.createElement(PageChart, {
          printingMode: true,
          type: type,
          doesBreakPage: doesBreakPage,
          fulfilledData: fulfilledData,
          chartData: chartData,
          chartOptions: chartOptions,
          chartType: chartType,
          seriesOptions: seriesOptions,
          renderListeners: renderListeners,
          chartSeries: series,
          itemPerRow: itemPerRow,
          numRows: numRows,
          key: index
        }));
        index !== numOfGroups && doesBreakPage && components.push(_react2.default.createElement('div', { className: 'u_alwaysBreakAfter', key: (0, _fp.uniqueId)() }));
      });

      try {
        return _react2.default.createElement(
          'section',
          { className: classes, style: doesBreakPage ? sectionStyle : null },
          _react2.default.createElement(
            _Izenda5.default,
            this.props,
            children,
            _react2.default.createElement(
              'div',
              { className: chartWrapperClass },
              components
            )
          )
        );
      } catch (e) {
        return _react2.default.createElement(
          'span',
          null,
          'Can\'t draw chart'
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props10 = this.props,
          printingMode = _props10.printingMode,
          className = _props10.className,
          pageIndex = _props10.pageIndex,
          goToPage = _props10.goToPage,
          changePageSize = _props10.changePageSize,
          viewMode = _props10.viewMode,
          chartOptions = _props10.chartOptions,
          chartSeries = _props10.chartSeries,
          pSize = _props10.pageSize,
          children = _props10.children;


      if (printingMode) return this.printingRender();

      var classes = (0, _classnames2.default)('izenda-grid-chart u_fullHeight u_fullWidth', className);
      var itemPerRow = (0, _fp.get)('view.izItemPerRow', chartOptions) || (0, _fp.get)('optionByType.izItemPerRow', chartOptions) || NUMBER_PER_ROW;
      var izUsePagination = (0, _fp.getOr)(false, 'optionByType.izUsePagination', chartOptions);
      var total = (0, _fp.size)(chartSeries);
      var pageSize = izUsePagination ? pSize : total;

      try {
        var chartsPerPage = getChartPerPage(chartSeries, pageIndex, pageSize);

        // item per row should be smaller than item per page;
        itemPerRow = Math.min(itemPerRow, pageSize);

        var numRows = Math.ceil(Math.min(pageSize, total) / itemPerRow);
        var chartBody = (0, _classnames2.default)('chart-body izenda-ChartWrapper-body');

        return _react2.default.createElement(
          'section',
          { className: classes },
          _react2.default.createElement(
            _Izenda5.default,
            this.props,
            children,
            _react2.default.createElement(
              'div',
              { className: chartBody },
              _react2.default.createElement(PageChart, (0, _extends3.default)({}, this.props, {
                chartSeries: chartsPerPage,
                itemPerRow: itemPerRow,
                numRows: numRows,
                key: pageIndex
              }))
            ),
            izUsePagination && renderPaginator()
          )
        );
      } catch (e) {
        return _react2.default.createElement(
          'span',
          null,
          'Can\'t draw chart'
        );
      }

      function renderPaginator() {
        return _react2.default.createElement(_Izenda7.default, {
          onChange: goToPage,
          onDropdownChange: changePageSize,
          totalRecords: total,
          pageSize: pageSize,
          pageIndex: pageIndex,
          canChangePageSize: !viewMode,
          pageSizes: PAGE_SIZE_OPTIONS
        });
      }

      function getChartPerPage(chartSeries, pageIndex, pageSize) {
        var start = (pageIndex - 1) * pageSize;
        var end = Math.min(start + pageSize, (0, _fp.size)(chartSeries));

        return chartSeries.slice(start, end);
      }
    }
  }]);
  return GridChartContainer;
}(_react.Component);

/**
 * Change page size
 * @param {any} props
 * @param {number} pageSize
 */


function changePageSize(props, pageSize) {
  var setPageSize = (0, _fp.get)('commonActions.setPageSize', props.chartOptions);
  setPageSize && setPageSize(pageSize);
  props.updatePageSize && props.updatePageSize(pageSize);
  props.goToPage && props.goToPage(1);
}

exports.default = (0, _Izenda3.default)((0, _recompose.withProps)(function (props) {
  var chartSeries = void 0;
  var charts = void 0;
  var renderListeners = [];

  try {
    chartSeries = props.getChartSeries();
  } catch (e) {
    chartSeries = {};
  }
  var groupCharts = (0, _fp.getOr)([], 'groupCharts', chartSeries);
  charts = (0, _fp.getOr)([], 'charts', chartSeries);

  // build promises
  props.finishedRender && (0, _fp.forEach)(function (chart) {
    renderListeners.push(_Izenda15.default.createPartRenderPromise(chart.id));
  }, props.printingMode ? charts : (0, _fp.slice)(0, DEFAULT_PAGE_SIZE, charts));

  return {
    // only show 2 items in back-side
    chartSeries: props.isPreview && !props.printingMode ? (0, _fp.slice)(0, _Izenda.PAGE_SIZE_BACK_SIDE, charts) : charts,
    groupCharts: groupCharts,
    renderListeners: renderListeners
  };
}), (0, _recompose.withState)('pageIndex', 'goToPage', 1), (0, _recompose.withState)('pageSize', 'updatePageSize', function (props) {
  return (0, _fp.getOr)(DEFAULT_PAGE_SIZE, 'staticProperties.pageSize', props.chartOptions);
}), (0, _recompose.withHandlers)({
  changePageSize: (0, _fp.curry)(changePageSize)
}))(GridChartContainer);
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

/**
 * Is a node chart
 * @param  {object}  chartNode
 * @return {boolean}
 */
function hasCharts(chartNode) {
  return chartNode && (0, _fp.has)(chartNode.charts) && (0, _fp.isArray)(chartNode.charts);
}

/**
 * Get size based on percent
 * @param  {number} width
 * @param  {number} height
 * @return {any}
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.GridChartUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function getSizePercent(width, height) {
  return {
    width: Math.min(100, width) + '%',
    height: Math.min(100, height) + '%'
  };
}

/**
 * Get group chart info
 * @param  {any} chartNode
 * @param  {Array<any>} groupLevels
 * @return {any}
 */
function getGroupChartInfo(chartNode, groupLevels) {
  var getMaxLevels = function getMaxLevels(groupInfo, groupPath) {
    groupPath = groupPath || [];
    var groupName = (0, _fp.get)('groupName', groupInfo);
    if (!(0, _fp.isNil)(groupName)) {
      groupPath.unshift(groupName);
    }

    if ((0, _fp.has)('linkTo', groupInfo)) {
      return getMaxLevels(groupInfo.linkTo, groupPath);
    }

    return (0, _fp.size)(groupPath);
  };

  var getGroup = function getGroup(group, level) {
    if (level < 1) {
      return group;
    }

    return getGroup(group.linkTo, level - 1);
  };

  var getChart = function getChart(chartSeries) {
    if (!(0, _fp.isObject)(chartSeries)) {
      return null;
    } else if (hasCharts(chartSeries)) {
      return (0, _fp.head)(chartSeries.charts);
    } else {
      return getChart((0, _fp.get)((0, _fp.flow)([_fp.keys, _fp.head])(chartSeries), chartSeries));
    }
  };

  var chart = getChart(chartNode);

  if (!chart) {
    return null;
  }
  var groupInfo = (0, _fp.get)('linkTo', chart);
  var maxLevel = getMaxLevels(groupInfo);

  return getGroup(groupInfo, maxLevel - (0, _fp.size)(groupLevels) - 1);
}

/**
 * get number of charts
 * @param  {any} chartTree
 * @return {number}
 */
function getNumChart(chartTree) {
  if (!(0, _fp.isObject)(chartTree)) {
    return 0;
  }

  if (hasCharts(chartTree)) {
    return (0, _fp.size)(chartTree.charts);
  }

  var total = 0;

  (0, _fp.forIn)(function (childNode) {
    total += getNumChart(childNode);
  }, chartTree);

  return total;
}

/**
 * Build chart tree
 * @param  {Array<any>} serieCharts
 * @return {any}
 */
function buildChartTree(serieCharts) {
  var chartTree = {};
  var groups = {};
  var groupPath = void 0;
  var groupElement = void 0;
  var groupPathInOrder = [];

  var setData = function setData(groupPath, data, source) {
    if (!groupPath.length) {
      return;
    } else if (groupPath.length === 1) {
      source[groupPath] = data;
      return;
    } else {
      var first = groupPath.shift();
      !source[first] && (source[first] = {});

      return setData(groupPath, data, source[first]);
    }
  };

  var getGroupName = function getGroupName(groupInfo) {
    if (!(0, _fp.isObject)(groupInfo)) {
      return [];
    }

    var groupName = (0, _fp.flow)((0, _fp.get)('linkTo.groupName'), function (groupName) {
      return (0, _fp.isNull)(groupName) ? 'null' : groupName;
    })(groupInfo);

    if (!(0, _fp.isNil)(groupName)) {
      if (!(0, _fp.has)(groupName, groups)) {
        groups[groupName] = {
          info: groupInfo.linkTo,
          numElement: 1
        };
      } else {
        groups[groupName].numElement += 1;
      }

      var paths = getGroupName(groupInfo.linkTo);

      return (0, _fp.concat)(paths, groupName, []);
    } else {
      return [];
    }
  };

  serieCharts.forEach(function (chart) {
    groupPath = (0, _fp.filter)(function (group) {
      return group != undefined;
    }, getGroupName(chart));
    groupElement = (0, _fp.get)(groupPath, chartTree) || ((0, _fp.has)('charts', chartTree) ? chartTree : null);

    if (!groupElement) {
      groupPathInOrder.push(groupPath);
      setData((0, _fp.concat)(groupPath, ['charts']), [chart], chartTree);
    } else {
      groupElement.charts.push(chart);
    }
  });

  return {
    chartTree: chartTree,
    groups: groups,
    groupPathInOrder: groupPathInOrder
  };
}

/**
 * Get group name in order
 * @param {any} chartTree 
 * @param {any} groupsInfo 
 * @returns {any}
 */
function getGroupNameInOrder(chartTree, groupsInfo) {
  var groupNames = (0, _fp.keys)(chartTree);

  return (0, _fp.sortBy)(function (name) {
    return (0, _fp.get)('info.groupIndex', groupsInfo[name]);
  }, groupNames);
}

exports.default = {
  buildChartTree: buildChartTree,
  getNumChart: getNumChart,
  getGroupChartInfo: getGroupChartInfo,
  getSizePercent: getSizePercent,
  hasCharts: hasCharts,
  getGroupNameInOrder: getGroupNameInOrder
};
module.exports = exports['default'];

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Map.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(953);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(41);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(405);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda9 = __webpack_require__(1894);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

var _Izenda11 = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Map = (_dec = (0, _Izenda2.default)(_Izenda10.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Map, _Component);

  function Map() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Map);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call.apply(_ref, [this].concat(args))), _this), _this.mapRefFn = function (com) {
      return _this.mapRef = com;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Map, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          seriesMap = _props.seriesMap,
          chartOptions = _props.chartOptions,
          updateShownRecords = _props.updateShownRecords,
          filterRecordsByLatLon = _props.filterRecordsByLatLon;

      var shownRecords = seriesMap.shownRecords;
      var activePointOptionType = (0, _fp.get)('pointType', chartOptions.reportPartState.activePointOption);
      if (activePointOptionType === _Izenda11.ContainerName.LATITUDE) {
        shownRecords = filterRecordsByLatLon(this.mapRef.chart, (0, _fp.get)('bubbleSeries', seriesMap));
      }
      updateShownRecords && updateShownRecords(shownRecords);
    }
  }, {
    key: 'renderMisMatchedPoint',
    value: function renderMisMatchedPoint(misMatchedPoint) {
      // important - do not show mismatched points - it be implemented later
      return;
      if (!misMatchedPoint || !misMatchedPoint.length) {
        return null;
      }

      var pointNames = (0, _fp.map)('pointName', misMatchedPoint);
      pointNames.unshift('Mismatched points:');
      return _react2.default.createElement('span', {
        className: 'chart-info icon-info-circled u-posAbsolute u-posBottomLeft u_textWarningColor',
        title: pointNames.join('\n')
      });
    }

    /**
     * Update map ref
     * @param {Object} com
     */

  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var chartOptions = props.chartOptions,
          seriesMap = props.seriesMap;

      var izendaOptions = (0, _fp.get)('commonOptions.izendaOptions', chartOptions);

      izendaOptions.backgroundMap = (0, _fp.get)('backgroundMap', props);
      izendaOptions.seriesMap = seriesMap;

      return _react2.default.createElement(
        'section',
        { className: 'u_fullSize u-posRelative' },
        _react2.default.createElement(
          _Izenda8.default,
          (0, _extends3.default)({}, props, { chartOptions: chartOptions, ref: this.mapRefFn }),
          props.children
        ),
        this.renderMisMatchedPoint(seriesMap.misMatchedPoint)
      );
    }
  }]);
  return Map;
}(_react.Component)) || _class);

var MapContainer = function (_Component2) {
  (0, _inherits3.default)(MapContainer, _Component2);

  function MapContainer() {
    (0, _classCallCheck3.default)(this, MapContainer);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MapContainer.__proto__ || (0, _getPrototypeOf2.default)(MapContainer)).call(this));

    _this2.setMapData = function (key, value) {
      var newData = {};
      newData[key] = value;
      _this2.isMountedComponent && _this2.state.loadedCountryCodes && _this2.setState(newData);
    };

    _this2.state = {
      backgroundMap: null,
      mappingData: null,
      loadedCountryCodes: null
    };
    return _this2;
  }

  (0, _createClass3.default)(MapContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.isMountedComponent = true;
      // Get list country codes if didn't get before
      // Make sure we only get 1 times, it's a static array
      if ((0, _fp.isEmpty)(_Izenda6.default.countryCodes)) {
        _Izenda4.default.getCountryCode().then(function (result) {
          _Izenda6.default.setCountryCodes(result);
          _this3.setState({ loadedCountryCodes: true });
        });
      } else {
        this.setState({ loadedCountryCodes: true });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isMountedComponent = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props,
          state = this.state;


      return _react2.default.createElement(Map, (0, _extends3.default)({}, props, {
        backgroundMap: state.backgroundMap,
        mappingData: state.mappingData,
        setMapData: this.setMapData
      }));
    }
  }]);
  return MapContainer;
}(_react.Component);

exports.default = MapContainer;
module.exports = exports['default'];

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.MapStaticContentFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Static Content Fetcher
 */

exports.default = {
  /**
   * Get GEO file based on map name, map name is defined in MapCollectionConstants
   * @param  {string} mapName
   * @return {json}
   */
  getGEOJson: function getGEOJson(mapName) {
    mapName = mapName || 'world';
    return (0, _Izenda2.default)(['content/maps/', mapName, '.geo.json'].join('')).get();
  },


  /**
   * Get details of cities
   * @param  {array} criterias
   * @param  {array} values
   * @return {array}
   */
  getCities: function getCities(criterias, values) {
    return (0, _Izenda2.default)('databaseSetup/staticData/city').post({
      Criterias: (0, _fp.isArray)(criterias) ? criterias : [criterias],
      Values: values
    });
  },


  /**
   * Get details of postal code
   * @param  {array} criterias
   * @param  {array} values
   * @return {array}
   */
  getPostalCode: function getPostalCode(criterias, values) {
    return (0, _Izenda2.default)('databaseSetup/staticData/postalCode').post({
      Criterias: (0, _fp.isArray)(criterias) ? criterias : [criterias],
      Values: values
    });
  },


  /**
   * Get list all country
   * @return {array}
   */
  getCountryCode: function getCountryCode() {
    return (0, _Izenda2.default)('databaseSetup/staticData/countryCodes').get();
  }
};
module.exports = exports['default'];

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

__webpack_require__(55);

var _Izenda = __webpack_require__(105);

var _mobx = __webpack_require__(5);

var _recompose = __webpack_require__(9);

var _Izenda2 = __webpack_require__(35);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(406);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(41);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(953);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(164);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnhancedErrorContainer = (0, _recompose.compose)((0, _recompose.withProps)(function () {
  return {
    errors: ['Cannot load GEO file']
  };
}))(_Izenda5.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.MapActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var getPropertyFromDrillInfo = function getPropertyFromDrillInfo(drillInfo, key) {
  return (0, _fp.get)('point.pointInfo.properties[' + key + ']', drillInfo) || (0, _fp.get)('point.pointInfo[' + key + ']', drillInfo);
};

/**
 * Build series to send to hightmap
 * @param {any} mapOptions
 * @param {any} mapData
 * @param {any} backgroundMap
 * @param {any} activePointOption
 * @param {any} mappingData
 * @param {Function} fnUpdateMappingData
 */
function getSeriesMap(mapOptions, mapData, backgroundMap, activePointOption, mappingData, fnUpdateMappingData) {
  var dataStructure = (0, _fp.getOr)({}, 'dataStructure', mapData);
  var backgroundMapFeatures = (0, _fp.getOr)([], 'features', backgroundMap);

  var markedShadingPoints = [];
  var shadingSeries = {}; // shading map
  var bubbleSeries = {}; // bubble map

  var misMatchedPoint = []; // save points which do not match with map-data
  var activePointOptionType = (0, _fp.get)('pointType', activePointOption);
  var isUserDefinedPoint = activePointOptionType === _Izenda.ContainerName.LATITUDE;
  var shownRecords = [];

  var mappingKeys = void 0,
      firstMappingKey = void 0,
      shadingField = void 0,
      bubbleFields = void 0,
      activePointVal = void 0,
      activePointField = void 0,
      activePointGEOInfo = void 0,
      pointCode = void 0,
      records = void 0,
      commonBubbleOptions = void 0,
      postalCodes = void 0;

  postalCodes = (0, _mobx.toJS)((0, _fp.getOr)([], 'rawData.postalCodes', mapData));

  if (activePointOption && (activePointField = (0, _fp.first)(dataStructure[activePointOptionType]))) {
    mappingKeys = _Izenda.MappingKey[activePointOptionType];
    firstMappingKey = (0, _fp.first)(mappingKeys);

    records = (0, _mobx.toJS)((0, _fp.getOr)([], 'rawData.records', mapData));

    var currentDrillDownMapInfo = (0, _fp.flow)((0, _fp.get)('reportPartState.drilldownInfo'), _fp.last, (0, _fp.get)('mapInfo'))(mapOptions);
    var countryInfo = (0, _fp.get)('countryInfo', mapOptions);

    // Should use highmap geo point instead of server's geo point
    var useHighmapGEOPoint = false;

    if (activePointOptionType === _Izenda.ContainerName.COUNTRY || activePointOptionType === _Izenda.ContainerName.COUNTY) {
      useHighmapGEOPoint = true;
    }

    if (activePointOptionType === _Izenda.ContainerName.STATE) {
      var countryCode = (0, _fp.isEmpty)(countryInfo) ? (0, _fp.get)('backgroundMap.value', currentDrillDownMapInfo) : (0, _fp.get)('value', countryInfo);
      var currentDrillDownLevel = (0, _fp.get)('mapLevel', currentDrillDownMapInfo);

      // For drilldown to state level, exclude the other country from records
      if (!(0, _fp.isEmpty)(dataStructure.country)) {
        var countryColumnName = (0, _fp.get)(_Izenda.ContainerName.COUNTRY + '[0].columnName', dataStructure);
        var country = (0, _fp.find)(function (code) {
          return (0, _fp.toLower)(code.code2) === (0, _fp.toLower)(countryCode);
        }, _Izenda7.default.countryCodes);

        country && (records = (0, _fp.filter)(function (record) {
          return record[countryColumnName] === country.name || record[countryColumnName] === country.code2 || record[countryColumnName] === country.code3;
        }, records));
      }

      // For drilldown to country level, exclude the other state from records
      if (!(0, _fp.isEmpty)(dataStructure.state) && countryCode) {
        var cities = (0, _mobx.toJS)((0, _fp.getOr)([], 'rawData.cities', mapData));
        var stateColumnName = (0, _fp.get)(_Izenda.ContainerName.STATE + '[0].columnName', dataStructure);
        var citiesInDrilldownCountry = (0, _fp.filter)(function (city) {
          return (0, _fp.toLower)(city.countryCode) === (0, _fp.toLower)(countryCode);
        }, cities);

        var woeNameList = (0, _fp.map)('woeName', citiesInDrilldownCountry);
        var hcA2List = (0, _fp.map)('hcA2', citiesInDrilldownCountry);

        !(0, _fp.isEmpty)(citiesInDrilldownCountry) && (records = (0, _fp.filter)(function (record) {
          return (0, _fp.includes)((0, _fp.deburr)(record[stateColumnName]), (0, _fp.map)(_fp.deburr, woeNameList)) || (0, _fp.includes)(record[stateColumnName], hcA2List);
        }, records));
      }

      // Do not show state data on state level
      if (currentDrillDownLevel === _Izenda.DrilldownLevels.STATE && (0, _fp.isEmpty)(dataStructure.city)) {
        records = [];
      }

      // Use highmap geo point to make bubble center in state
      countryCode && (useHighmapGEOPoint = true);
    }

    // if active point is county, filter county not belong to state dril
    if (activePointOptionType === _Izenda.ContainerName.COUNTY) {
      var _stateColumnName = (0, _fp.flow)((0, _fp.get)('state'), _fp.head, (0, _fp.get)('columnName'))(dataStructure);

      var lastDilldownInfo = (0, _fp.last)(mapOptions.reportPartState.drilldownInfo);
      if (lastDilldownInfo) {
        // for case user drildown on map
        records = records.filter(function (item) {
          var value = item[_stateColumnName];
          // if don't have state value, no need to filter
          if ((0, _fp.isNil)(value)) {
            return true;
          }

          var properties = (0, _fp.get)('point.pointInfo.properties', lastDilldownInfo) || (0, _fp.get)('point.pointInfo', lastDilldownInfo) || {};

          return isMatchedPoint(value, properties, _Izenda.MappingKey[_Izenda.ContainerName.STATE]);
        });
      } else {
        // for case user select map on properties panel
        // TODO: will be hanlde for another ticket
      }
    }

    if ([_Izenda.ContainerName.STATE, _Izenda.ContainerName.POSTAL_CODE, _Izenda.ContainerName.CITY].indexOf(activePointOptionType) > -1 && (0, _fp.isNil)(mappingData)) {
      loadMappingData(activePointOptionType, mapData, (0, _Izenda10.getValueFromMappingField)(activePointField, records), fnUpdateMappingData);
      return {};
    } else if (isUserDefinedPoint) {
      commonBubbleOptions = {
        latField: (0, _fp.head)(dataStructure[_Izenda.ContainerName.LATITUDE]),
        lonField: (0, _fp.head)(dataStructure[_Izenda.ContainerName.LONGTITUDE]),
        isUserDefinedPoint: isUserDefinedPoint
      };
    }

    // filter city which belongs to post code.
    var lastDrillInfo = (0, _fp.last)(mapOptions.reportPartState.drilldownInfo);
    var hcA2 = getPropertyFromDrillInfo(lastDrillInfo, 'hc-a2');

    if (_Izenda.ContainerName.POSTAL_CODE === activePointOptionType) {
      var countryValue = void 0,
          name = void 0;

      if (!currentDrillDownMapInfo) {
        if ([_Izenda.DrilldownLevels.COUNTRY, _Izenda.DrilldownLevels.WORLD, _Izenda.DrilldownLevels.CONTINENT, _Izenda.DrilldownLevels.STATE].indexOf(mapOptions.commonOptions.izendaOptions.mapLevel) > -1) {
          countryValue = (0, _fp.get)('countryInfo.others.BASE_NAME', mapOptions) ? (0, _fp.get)('countryInfo.others.BASE_NAME', mapOptions) : (0, _fp.get)('countryInfo.value', mapOptions);
          name = (0, _fp.get)('stateInfo.label', mapOptions);
        }
      } else {
        switch (currentDrillDownMapInfo.mapLevel) {
          case _Izenda.DrilldownLevels.COUNTRY:
            countryValue = hcA2;
            break;
          case _Izenda.DrilldownLevels.STATE:
            countryValue = getPropertyFromDrillInfo(lastDrillInfo, 'country');
            name = getPropertyFromDrillInfo(lastDrillInfo, 'name');
            break;
        }
      }

      records = records.filter(function (record) {
        var activePointVal = (0, _Izenda10.getValueFromMappingField)(activePointField, record);
        var activePointGEOInfo = (0, _fp.flow)([(0, _fp.get)(activePointVal), _fp.head])(mappingData);

        if (!activePointGEOInfo || !countryValue) {
          return true;
        }
        var matchedPostcode = (0, _fp.find)(function (p) {
          return (0, _fp.toLower)(p.postalCode) === (0, _fp.toLower)(activePointGEOInfo.postalCode);
        }, postalCodes);

        if (!matchedPostcode) {
          return true;
        }

        if ((0, _fp.toLower)(matchedPostcode.countryCode) !== (0, _fp.toLower)(countryValue) && (0, _fp.toLower)(matchedPostcode.countryName) !== (0, _fp.toLower)(countryValue)) {
          return false;
        }
        return name ? (0, _fp.toLower)(matchedPostcode.province) === (0, _fp.toLower)(name) || (0, _fp.toLower)(matchedPostcode.province) === (0, _fp.toLower)(hcA2) : true;
      });
    }

    // filter city which belongs to state/province.
    if (_Izenda.ContainerName.CITY === activePointOptionType) {
      var compareValue = void 0,
          level = void 0;
      if (!currentDrillDownMapInfo) {
        var _country = (0, _fp.get)('countryInfo.others.BASE_NAME', mapOptions) ? (0, _fp.get)('countryInfo.others.BASE_NAME', mapOptions) : (0, _fp.get)('countryInfo.value', mapOptions);
        var state = (0, _fp.get)('stateInfo.label', mapOptions);
        if (!!state) {
          level = _Izenda.DrilldownLevels.STATE;
          compareValue = state;
        } else if (!!_country) {
          level = _Izenda.DrilldownLevels.COUNTRY;
          compareValue = _country;
        } else {
          compareValue = (0, _fp.get)('continentInfo.value', mapOptions);
          compareValue && (level = _Izenda.DrilldownLevels.CONTINENT);
        }
      } else {
        switch (currentDrillDownMapInfo.mapLevel) {
          case _Izenda.DrilldownLevels.CONTINENT:
            level = _Izenda.DrilldownLevels.CONTINENT;
            compareValue = getPropertyFromDrillInfo(lastDrillInfo, 'continent');
            break;
          case _Izenda.DrilldownLevels.COUNTRY:
            compareValue = hcA2;
            level = _Izenda.DrilldownLevels.COUNTRY;
            break;
          case _Izenda.DrilldownLevels.STATE:
            compareValue = getPropertyFromDrillInfo(lastDrillInfo, 'woe-name');
            level = _Izenda.DrilldownLevels.STATE;
            break;
        }
      }

      records = records.filter(function (record) {
        var activePointVal = (0, _Izenda10.getValueFromMappingField)(activePointField, record);
        var activePointGEOInfo = (0, _fp.flow)([(0, _fp.get)(activePointVal), _fp.head])(mappingData);

        if (!activePointGEOInfo || !compareValue) {
          return true;
        }

        switch (level) {
          case _Izenda.DrilldownLevels.CONTINENT:
            {
              var matchedCountry = (0, _fp.find)(function (continent) {
                return (0, _fp.toLower)((0, _fp.get)('properties["hc-a2"]', continent)) === (0, _fp.toLower)(activePointGEOInfo.countryCode);
              }, backgroundMapFeatures);
              return !!matchedCountry;
            }
          case _Izenda.DrilldownLevels.COUNTRY:
            return (0, _fp.toLower)(compareValue) === (0, _fp.toLower)(activePointGEOInfo.countryCode);
          case _Izenda.DrilldownLevels.STATE:
            return (0, _fp.toLower)(compareValue) === (0, _fp.toLower)(activePointGEOInfo.woeName);
        }

        return true;
      });
    }

    shadingField = (0, _fp.first)(dataStructure[_Izenda.ContainerName.SHADING_VALUES]);
    bubbleFields = dataStructure[_Izenda.ContainerName.BUBBLE_VALUES];

    // init data
    shadingField && initMapSerieData(shadingSeries, shadingField, activePointOption);
    bubbleFields && bubbleFields.forEach(function (bubbleField) {
      initMapSerieData(bubbleSeries, bubbleField, activePointOption, commonBubbleOptions);
    });

    // loop preview-records & build series
    records.forEach(function (record) {
      activePointVal = (0, _Izenda10.getValueFromMappingField)(activePointField, record);

      if (!activePointVal) {
        return true; // break forEach
      }

      if (isUserDefinedPoint) {
        // bubble series - get data from lat/long fields
        if (bubbleFields && addBubbleData(activePointOption, bubbleSeries, null, null, null, record)) {
          shownRecords.push(record);
        }
        return true; // break forEach
      }

      activePointGEOInfo = !useHighmapGEOPoint ? (0, _fp.flow)([(0, _fp.get)(activePointVal), _fp.head])(mappingData) : getGEOInfo(activePointVal, mappingKeys, backgroundMapFeatures, !!shadingField, activePointOptionType);

      // mis-matched point
      if (!activePointGEOInfo) {
        misMatchedPoint.push({
          pointName: activePointVal,
          record: record
        });

        return true; // break forEach
      }

      pointCode = (0, _fp.get)(firstMappingKey, activePointGEOInfo.properties);

      var trackShadingRecord = false;
      var trackBubbleRecord = false;
      // shading serie (only one serie)
      if (shadingField) {
        addPoint(activePointOption, shadingSeries, shadingField, record, pointCode, activePointVal, activePointGEOInfo);
        trackShadingRecord = true;
      }

      // bubble series
      if (bubbleFields) {
        trackBubbleRecord = addBubbleData(activePointOption, bubbleSeries, activePointVal, pointCode, activePointGEOInfo, record);
      }

      (trackShadingRecord || trackBubbleRecord) && shownRecords.push(record);
    });
  }

  return {
    pointOption: activePointOption,
    backgroundMap: {
      joinBy: ['hc-key', 'code'],
      data: getBackgroundPoints(backgroundMapFeatures, markedShadingPoints)
    },
    shadingSeries: shadingSeries,
    bubbleSeries: bubbleSeries,
    pointMap: [],
    misMatchedPoint: misMatchedPoint, // TODO
    shownRecords: shownRecords
  };

  /**
   * get background-map (to support highlight for point which don't have data)
   * @param {Array<any>} backgroundMapFeatures
   * @param {Array<any>} markedShadingPoints
   */
  function getBackgroundPoints(backgroundMapFeatures, markedShadingPoints) {
    var backgroundMapPoints = [];

    for (var i = 0; i < backgroundMapFeatures.length; i++) {
      !markedShadingPoints[i] && backgroundMapPoints.push({
        code: backgroundMapFeatures[i].properties['hc-key'],
        value: 0,
        pointInfo: backgroundMapFeatures[i]
      });
    }
    return backgroundMapPoints;
  }

  /**
   * init map serie data
   * @param {any} source
   * @param {any} field
   * @param {any} activePointOption
   * @param {any} commonOptions
   */
  function initMapSerieData(source, field, activePointOption, commonOptions) {
    source[field.fieldNameAlias] = $izenda.extend(true, {}, commonOptions, {
      sum: 0,
      min: Number.MAX_VALUE,
      max: Number.MIN_VALUE,
      data: [],
      field: field,
      activePointOption: activePointOption
    });
  }

  /**
   * get data for bubbleSeries field
   * @param {any} activePointOption
   * @param {any} bubbleSeries
   * @param {string} activePointVal
   * @param {string} pointCode
   * @param {any} activePointGEOInfo
   * @param {any} record
   */
  function addBubbleData(activePointOption, bubbleSeries, activePointVal, pointCode, activePointGEOInfo, record) {
    var trackRecord = false;
    bubbleFields.forEach(function (bubbleField) {
      addPoint(activePointOption, bubbleSeries, bubbleField, record, pointCode, activePointVal, activePointGEOInfo);
      trackRecord = true;
    });
    return trackRecord;
  }

  /**
   * Add point
   * @param {any} activePointOption
   * @param {any} source
   * @param {any} field
   * @param {any} record
   * @param {any} pointCode
   * @param {any} activePointVal
   * @param {any} activePointGEOInfo
   */
  function addPoint(activePointOption, source, field, record, pointCode, activePointVal, activePointGEOInfo) {
    activePointGEOInfo = (0, _fp.get)('properties', activePointGEOInfo) || activePointGEOInfo || {};

    var serie = source[field.fieldNameAlias];
    var fieldValue = field.columnName ? (0, _Izenda2.getFieldValue)(field.columnName, record) : {};
    var pointVal = fieldValue.originalValue ? fieldValue.originalValue : fieldValue.value;

    serie.sum += pointVal;
    serie.min = Math.min(serie.min, pointVal);
    serie.max = Math.max(serie.max, pointVal);

    var pointInfo = {
      originalValue: fieldValue.originalValue,
      value: fieldValue.originalValue ? fieldValue.originalValue : pointVal,
      formatedValue: fieldValue.originalValue,
      pointName: activePointVal,
      pointInfo: activePointGEOInfo,
      poinOptionName: (0, _fp.get)('field.name', activePointOption),
      valueField: field,
      nameField: activePointOption,
      record: record
    };

    pointCode && (pointInfo.code = pointCode);

    if ((0, _fp.has)('latField', serie)) {
      activePointGEOInfo.latitude = (0, _Izenda10.getValueFromMappingField)(serie.latField, record);
    }

    if ((0, _fp.has)('lonField', serie)) {
      activePointGEOInfo.longitude = (0, _Izenda10.getValueFromMappingField)(serie.lonField, record);
    }

    if (activePointGEOInfo.longitude && activePointGEOInfo.latitude) {
      $izenda.extend(pointInfo, {
        lon: activePointGEOInfo.longitude,
        lat: activePointGEOInfo.latitude
      });
    }

    serie.data.push(pointInfo);
  }

  /**
   * parse data for shading
   * @param {any} val
   * @param {any} mappingKeys
   * @param {any} backgroundMapFeatures
   * @param {boolean} needMarkPoint
   */
  function getGEOInfo(val, mappingKeys, backgroundMapFeatures, needMarkPoint, drillDownLevel) {
    // Cannot use backgroundMapFeatures.find() here, it does not work in EVO PDF.
    var pointIndex = (0, _fp.findIndex)(function (feature) {
      return isMatchedPoint(val, feature.properties, mappingKeys, drillDownLevel);
    }, backgroundMapFeatures);

    needMarkPoint && pointIndex > -1 && markShadingPoint(pointIndex);
    return pointIndex > -1 ? (0, _fp.nth)(pointIndex, backgroundMapFeatures) : null;
  }

  /**
   * Mark shading point.
   * @param {Number} index
   */
  function markShadingPoint(index) {
    markedShadingPoints[index] = true;
  }

  /**
   * Check matching point
   * @param {string} pointVal
   * @param {any} source
   * @param {Array<any>} mappingKeys
   */
  function isMatchedPoint(pointVal, source, mappingKeys, drillDownLevel) {
    return !!(0, _fp.find)(function (mappingField) {
      // for case county fips return 1001 but in highmap is 01001;
      if (mappingField === 'fips' && drillDownLevel === _Izenda.ContainerName.COUNTY) {
        return source[mappingField] / 1 === pointVal / 1;
      }
      return String.compareString((0, _fp.deburr)(source[mappingField]), (0, _fp.deburr)(pointVal));
    }, mappingKeys);
  }
}

/**
 * Load mapping data.
 * @param {string} pointType
 * @param {any} mapData
 * @param {any} values
 * @param {Function} callback
 */
function loadMappingData(pointType, mapData, values, callback) {
  var fnName = '';
  var mappingValues = [];

  switch (pointType) {
    case _Izenda.ContainerName.STATE:
      fnName = 'getCitiesByState';
      mappingValues = (0, _mobx.toJS)((0, _fp.getOr)([], 'cities', mapData));
      break;
    case _Izenda.ContainerName.CITY:
      fnName = 'getCities';
      mappingValues = (0, _mobx.toJS)((0, _fp.getOr)([], 'cities', mapData));
      break;
    case _Izenda.ContainerName.POSTAL_CODE:
      fnName = 'getPostalCode';
      mappingValues = (0, _mobx.toJS)((0, _fp.getOr)([], 'postalCodes', mapData));
      break;
    default:
    // do nothing
  }

  fnName = _Izenda9.default[fnName];
  return (0, _fp.isFunction)(fnName) && fnName(values, mappingValues).then(callback);
}

/**
 * Finf map range
 * @param {Object} mapCom
 */
function findMapRange(mapCom) {
  var mapRange = {
    min: [],
    max: []
  };

  (0, _fp.each)(function (axis) {
    mapRange.min[axis.isXAxis ? 0 : 1] = axis.min;
    mapRange.max[axis.isXAxis ? 0 : 1] = axis.max;
  }, mapCom.axes);

  return mapRange;
}

/**
 * Filter records based lat/lon
 * @param {Object} mapCom
 * @param {Object} bubbleSeries
 */
function filterRecordsByLatLon(mapCom, bubbleSeries) {
  var records = [];
  var mapRange = findMapRange(mapCom);
  var checkLat = (0, _fp.curry)((0, _fp.inRange)(mapRange.min[0], mapRange.max[0]));
  var checkLon = (0, _fp.curry)((0, _fp.inRange)(mapRange.min[1], mapRange.max[1]));

  (0, _fp.each)(function (serie) {
    (0, _fp.each)(function (point) {
      if ((0, _fp.has)('lat', point) && (0, _fp.has)('lon', point)) {
        var latlonPoint = mapCom.fromLatLonToPoint(point);
        var isValid = checkLat(latlonPoint.x) && checkLon(latlonPoint.y);
        isValid && records.push(point.record);
      } else {
        records.push(point.record);
      }
    }, serie.data);
  }, bubbleSeries);

  return records;
}

module.exports = (0, _recompose.compose)((0, _recompose.withProps)(function (props) {
  return getMapBackground();

  function getMapBackground() {
    var backgroundMap = props.backgroundMap;
    var backgroundMapName = (0, _fp.get)('commonOptions.izendaOptions.backgroundMapName', props.chartOptions);
    var activePointOption = (0, _fp.get)('commonOptions.izendaOptions.activePointOption', props.chartOptions);

    if (!backgroundMap || backgroundMap.name !== backgroundMapName) {
      _Izenda9.default.getGEOJson(backgroundMapName).then(function (backgroundMapData) {
        props.setMapData('backgroundMap', {
          name: backgroundMapName,
          geojson: backgroundMapData
        });
        return null;
      }).error(function (e) {
        return props.setMapData('backgroundMap', {});
      });

      return {
        backgroundMap: null
      };
    }

    return {
      backgroundMap: backgroundMap,
      seriesMap: getSeriesMap(props.chartOptions, props.chartData, backgroundMap.geojson, activePointOption, props.mappingData, onUpdateMappingData),
      filterRecordsByLatLon: filterRecordsByLatLon
    };

    function onUpdateMappingData(mappingData) {
      props.setMapData('mappingData', mappingData);
      return null;
    }
  }
}),
/* show | hide spinner */
(0, _recompose.branch)(function (props) {
  return (0, _fp.isObject)(props.backgroundMap) && (0, _fp.isObject)((0, _fp.get)('geojson', props.backgroundMap)) && (0, _fp.has)('backgroundMap', props.seriesMap);
}, _fp.identity, (0, _recompose.renderComponent)(_Izenda3.default.renderLazyLoadingBar)), (0, _recompose.branch)(function (props) {
  return !(0, _fp.isNil)((0, _fp.get)('geojson', props.backgroundMap));
}, _fp.identity, (0, _recompose.renderComponent)(EnhancedErrorContainer)));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartMetricsActions.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

function onChange(_ref, _ref2, element) {
  var reportPart = _ref.reportPart;
  var value = _ref2.value;

  var reportPartContent = reportPart.reportPartContent || {};
  reportPartContent.setActiveSerie(value, element);
}

exports.default = (0, _recompose.withHandlers)({
  onChange: (0, _fp.curry)(onChange)
});
module.exports = exports['default'];

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(958);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(965);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartToolbarActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

function showGridPreviewPopup(props, e) {
  props.openPopup(_Izenda2.default, {
    reportPart: props.reportPart,
    gridPreviewStore: new _Izenda4.default()
  });
}

exports.default = (0, _recompose.compose)((0, _recompose.withProps)(function () {
  return {
    hideGridPopup: false
  };
}), (0, _recompose.withHandlers)({
  showGridPreviewPopup: (0, _fp.curry)(showGridPreviewPopup)
}));
module.exports = exports['default'];

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = __webpack_require__(18);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

/**
 * Build data for grid
 */
var buildGridData = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    var _props, reportPart, gridPreviewStore, shownRecords;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _props = this.props, reportPart = _props.reportPart, gridPreviewStore = _props.gridPreviewStore, shownRecords = _props.shownRecords;
            _context.next = 3;
            return gridPreviewStore.buildGridReportParts(reportPart, shownRecords);

          case 3:
            gridPreviewStore.turnOffProcessingDataIndicator.apply(gridPreviewStore);
            return _context.abrupt('return', (0, _bluebird.resolve)());

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function buildGridData() {
    return _ref.apply(this, arguments);
  };
}();

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Handle close pop-up
 * @param {any} props
 * @param {any} e
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.GridPreviewPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Grid Popup Actions
 */
function onClosing(props, e) {
  props.onAccept();
}

/**
 * Handle change metric on grid preview popup
 * @param {any} props
 * @param {any} e
 */
function onChangeGridPreviewPopupMetric(props, e) {
  props.gridPreviewStore.updateShowingPartIndex(e.value);
}exports.default = (0, _recompose.compose)((0, _recompose.withProps)(function () {
  return {
    buildGridData: buildGridData
  };
}), (0, _recompose.withHandlers)({
  onClosing: (0, _fp.curry)(onClosing),
  onChangeGridPreviewPopupMetric: (0, _fp.curry)(onChangeGridPreviewPopupMetric)
}));
module.exports = exports['default'];

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(29);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(572);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.GridPreviewPopupMetric.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var GridPreviewPopupMetric = function GridPreviewPopupMetric(_ref) {
  var localization = _ref.localization,
      gridReportParts = _ref.gridReportParts,
      onChange = _ref.onChange,
      selectedPart = _ref.selectedPart;

  var options = (0, _fp.map)('metric', gridReportParts);

  return _react2.default.createElement(
    _Izenda6.default,
    null,
    _react2.default.createElement(
      'div',
      { className: 'u-posTopRight u-posAbsolute u_textRight' },
      _react2.default.createElement(
        'span',
        { className: 'u_paddingLeftRight' },
        localization.getText('REPORTDESIGNER_LABEL_METRICS')
      ),
      _react2.default.createElement(_Izenda4.default, {
        onChange: onChange,
        options: options,
        value: selectedPart.metric.value,
        labelField: 'label',
        valueField: 'value'
      })
    )
  );
};

GridPreviewPopupMetric.propTypes = {
  gridReportParts: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  selectedPart: _propTypes2.default.object
};

exports.default = (0, _Izenda2.default)()(GridPreviewPopupMetric);
module.exports = exports['default'];

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(90);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(111);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(269);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _mobx = __webpack_require__(5);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda9 = __webpack_require__(12);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(318);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(58);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(319);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(40);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(35);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(408);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportPartStore = (_dec = (0, _mobx.action)('setReportPartModel'), (_class = function () {
  function ReportPartStore() {
    (0, _classCallCheck3.default)(this, ReportPartStore);

    _initDefineProp(this, 'reportPart', _descriptor, this);

    _initDefineProp(this, 'readyData', _descriptor2, this);

    this.draftId = null;
    this.requestForDraft = null;
    this.pageId = null;
  }

  (0, _createClass3.default)(ReportPartStore, [{
    key: 'createReportPartModel',
    value: function createReportPartModel(reportPartDefinition) {
      return new _Izenda8.default(reportPartDefinition);
    }

    /**
    * @method getReportPartData
    * @param {Array<Object} subReportFilter
    * @param {Boolean} isPrintMode
    * @param {Number} previewRecords user can change preview records number via API
    * @param {Object} newReportPart
    */

  }, {
    key: 'getReportPartData',
    value: function getReportPartData(subReportFilter, isPrintMode, previewRecords, newReportPart) {
      return this.updatePreviewData(subReportFilter, newReportPart, null, null, isPrintMode, null, previewRecords).return(newReportPart);
    }

    /**
    * @method setReportPartModel
    * @param  {Object} newReportPart
    */

  }, {
    key: 'setReportPartModel',
    value: function setReportPartModel(newReportPart) {
      this.reportPart = newReportPart;
      this.readyData = true;
      return newReportPart;
    }

    /**
     * this method receive report def json thus reduce request to get json object
     * @method updateDefinition
     * @param {Object} reportPartDef
     * @param {Array<Object>} subReportFilter
     * @param {Boolean} isPrintMode
     * @param {Number} previewRecords user can change preview records number via API
     * 
     */

  }, {
    key: 'updateDefinition',
    value: function updateDefinition(reportPartDef, subReportFilter, isPrintMode, previewRecords) {
      // this method only modify newly created reportPart object
      // thus don't trigger re-render because this store dont' have reference to
      // this new report part object and reduce render times
      this.setReportPartModel(null);
      var newReportPart = this.createReportPartModel((0, _fp.cloneDeep)(reportPartDef));

      return this.getReportPartData(subReportFilter, isPrintMode, previewRecords, newReportPart).bind(this).then(this.setReportPartModel);
    }

    /**
     * get draft report part definition
     * @method getDraftReportPartDefinition
     * @param {Number} draftId
     * @param {String} reportPartName
     * @param {Array<Object>} subReportFilter
     * @param {Boolean} isPrintMode
     * @param {Number} previewRecords user can change preview records number via API
     */

  }, {
    key: 'getDraftReportPartDefinition',
    value: function getDraftReportPartDefinition(draftId, reportPartName, subReportFilter, isPrintMode, previewRecords) {
      // find correct report part, report part name in URL may be not in right format(uppper case etc)
      this.setReportPartModel(null);
      var formatTitle = (0, _fp.flow)(_fp.trim, _fp.toUpper);

      var reportPartNameFormated = formatTitle(reportPartName);

      return _Izenda6.default.getPrintDraftData(draftId).bind(this).then(function (report) {
        var reportPart = (0, _fp.find)(function (reportPartDefinition) {
          return reportPartDefinition.state !== _Izenda14.default.DELETE && formatTitle(reportPartDefinition.title) === reportPartNameFormated;
        }, report.reportPart);

        report.reportPart = (0, _fp.compact)([reportPart]);

        this.requestForDraft = {
          report: report,
          title: reportPart.title,
          reportKey: {
            key: report.id,
            tenantId: report.tenantId
          }
        };
        this.draftId = draftId;

        return this.createReportPartModel(reportPart);
      }).then(this.getReportPartData.bind(this, subReportFilter, isPrintMode, previewRecords)).then(this.setReportPartModel);
    }

    /**
     * this method receive report part id thus need call api request to get json object
     * @method getReportPartDefinition
     * @param {Number} id
     * @param {Array<Object>} subReportFilter
     * @param {Boolean} isPrintMode
     * @param {Number} reportId
     * @param {Number} previewRecords user can change preview records number via API
     */

  }, {
    key: 'getReportPartDefinition',
    value: function getReportPartDefinition(id, subReportFilter, isPrintMode, reportId, previewRecords) {
      // this method only modify newly created reportPart object
      // thus don't trigger re-render because this store dont' have reference to
      // this new report part object and reduce render times
      this.setReportPartModel(null);
      return _Izenda4.default.loadReportPartDefinition(id, reportId, isPrintMode ? null : this.pageId).bind(this).then(this.createReportPartModel).then(this.getReportPartData.bind(this, subReportFilter, isPrintMode, previewRecords)).then(this.setReportPartModel);
    }

    /**
     * update new preview dta for report part
     * @method updatePreviewData
     * @param {Array<Object>} subReportFilter
     * @param {Object} reportPart
     * @param {Object} drillDownData
     * @param {Number} pageIndex
     * @param {Boolean} isPrintMode
     * @param {Boolean} notUpdateFilter
     * @param {Number} previewRecords user can change preview records number via API
     */

  }, {
    key: 'updatePreviewData',
    value: function updatePreviewData(subReportFilter, reportPart, drillDownData, pageIndex, isPrintMode, notUpdateFilter, previewRecords) {
      reportPart.startLoadData();
      var embededReportDefPromise = _Izenda12.default.buildPromiseFetcher(reportPart, _Izenda4.default.loadReportPartDefinition.bind(_Izenda4.default), _Izenda4.default.loadForEdit.bind(_Izenda4.default), true, this.pageId);
      var drillInfo = reportPart.reportPartContent.getDrilldownInfo();

      if (!notUpdateFilter) {
        var filtersWithoutSeparator = (0, _fp.filter)(function (item) {
          return !item.isSeparator;
        }, drillInfo.filters);
        _Izenda16.default.addFilters(filtersWithoutSeparator);
        _Izenda16.default.cleanFilter();
      }

      var addingFitlers = (0, _fp.getOr)([], 'filters', drillDownData);

      if (_Izenda18.default.Integration && reportPart.reportPartContent.isCrossFiltering) {
        addingFitlers = _Izenda20.default.transformFilterWithReportPart(reportPart, (0, _fp.getOr)([], 'crossFilteringFilters', _Izenda16.default));
      }

      drillInfo.filters = (0, _fp.concat)(drillInfo.filters, addingFitlers);
      var colorPaletteStore = new _Izenda22.default();

      return (0, _bluebird.join)(this.getPreviewData.apply(this, [subReportFilter, reportPart, drillInfo, pageIndex, isPrintMode, previewRecords]), embededReportDefPromise, colorPaletteStore.loadThemes(), (0, _mobx.action)(function (result, embededReportDef, palettes) {
        if (!result.messages) {
          reportPart.setQueryData(result);
          reportPart.readEmbededReportDef(embededReportDef);
          reportPart.colorPalettes = palettes;
        } else {
          reportPart.setQueryData([]);
        }
        return result.messages;
      }));
    }

    /**
     * get preview data match condition
     * @method getPreviewData
     * @param {Array<Object>} subReportFilter
     * @param {Object} reportPart
     * @param {Object} drillDownData
     * @param {Number} pageIndex
     * @param {Boolean} isPrintMode
     * @param {Number} previewRecords user can change preview records number via API
     * @return {promise}
     */

  }, {
    key: 'getPreviewData',
    value: function getPreviewData(subReportFilter, reportPart, drillDownData, pageIndex, isPrintMode, previewRecords) {
      var reportPartContent = reportPart.reportPartContent;

      var requestForDraft = this.requestForDraft;

      if (!reportPart.isBeingBuild) {
        return (0, _bluebird.resolve)([]);
      }
      // apply optional params based on report part content
      var applyOptionalParam = (0, _fp.assign)(reportPartContent.optionalParams);
      // apply params based on drill down information
      var applyDrillDownData = (0, _fp.assign)(_fp.placeholder, drillDownData);
      // apply page size to filters data receive
      var applyPageSize = function applyPageSize(queryData) {
        // if print mode then we set paging to load all.
        if (isPrintMode) {
          return (0, _fp.unset)('paging', queryData);
        }
        // pagination
        if (reportPartContent.usePagination || reportPartContent.properties.usePagination || (0, _fp.get)('properties.view.usePagination', reportPartContent)) {
          return (0, _fp.assign)(queryData, {
            paging: {
              pageIndex: pageIndex || _Izenda2.default.DEFAULT_PAGE_INDEX,
              pageSize: reportPartContent.properties.pageSize || _Izenda2.default.DEFAULT_PAGE_SIZE
            }
          });
        }
        return queryData;
      };
      // merge current filtes with sub report filters
      var applySubReportFilter = function applySubReportFilter(queryData) {
        return (0, _fp.flow)((0, _fp.assign)(_fp.placeholder, (0, _fp.omit)(['filters'], subReportFilter)), (0, _fp.set)('filters', (0, _fp.compact)((0, _fp.concat)(queryData.filters, (0, _fp.getOr)([], 'filters', subReportFilter)))))(queryData);
      };

      var createBaseData = function createBaseData(queryData) {
        if (!requestForDraft) {
          return (0, _fp.assign)({
            reportId: reportPart.reportId,
            reportPartId: reportPart.id,
            loadDraft: false
          }, queryData);
        }
        return (0, _fp.flow)((0, _fp.assign)(requestForDraft), (0, _fp.set)('reportPart.report.reportPart', [reportPart.buildDataForSave()]))(queryData);
      };

      var data = {
        tenantId: _IzendaUiState2.default.getTenantId(),
        userAction: _Izenda10.default.getText('REPORTDESIGNER_LOGGING_EMBEDDED_REPORT_PART'),
        previewRecords: previewRecords
      };

      data = (0, _fp.flow)(createBaseData, applyOptionalParam, applyPageSize, applyDrillDownData, applySubReportFilter)(data);

      if (isPrintMode) {
        data.loadAll = true;
      }

      var fetchFn = requestForDraft ? _Izenda4.default.getConfigReportPartPreviewData : _Izenda4.default.getPreviewData;

      return fetchFn(data).catch(function () {
        return [];
      });
    }
  }]);
  return ReportPartStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'reportPart', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'readyData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setReportPartModel', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setReportPartModel'), _class.prototype)), _class));
exports.default = ReportPartStore;
module.exports = exports['default'];

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartQueryData.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var extendObservable = __webpack_require__(5).extendObservable;
  var asFlat = __webpack_require__(5).asFlat;

  function ReportPartQueryData(data) {
    extendObservable(this, {
      paging: data.paging || {},
      fieldsMapping: asFlat(data.fieldsMapping || []),
      sideTotalMapping: asFlat(data.sideTotalMapping || []),
      subTotalMapping: asFlat(data.subTotalMapping || []),
      grandTotalMapping: asFlat(data.grandTotalMapping || []),
      records: asFlat(data.records || []),
      cities: asFlat(data.cities || []),
      postalCodes: asFlat(data.postalCodes || [])
    });
  }

  module.exports = ReportPartQueryData;
}();

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _recompose = __webpack_require__(9);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(84);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(39);

var _Izenda4 = __webpack_require__(35);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(962);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(409);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(78);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridVerticalHorizontalActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var DEFAULT_VERTICAL_ALIGNMENT = _Izenda.DEFAULT_VALUE_PROPERTIES.VERTICAL_ALIGNMENT;
/**
 * render cell content base on value and style
 * @param {Object} props
 * @param {Array} header
 * @param {Array} dataRow
 * @param {string} columnKey
 * @param {int} rowIndex
 * @param {Object} column
 * @param {int} colIndex
 */
var fnGetCellContentStyle = function fnGetCellContentStyle(props, header, dataRow, columnKey, rowIndex, column, colIndex) {
  var reportPart = props.reportPart;
  var properties = reportPart.getReportPartProperties();
  var columns = properties.columns;

  var columnProps = {
    wordWrap: columns.wordWrap,
    alignment: columns.alignment
  };
  var isHorizontal = properties.generalInfo.gridStyle === _Izenda2.default.GRID_STYLES.HORIZONTAL.value ? 1 : 0;

  if (isHorizontal && colIndex === 0) {
    var cellStyle = (0, _fp.defaults)(_Izenda.DEFAULT_CELL_STYLE, getHeaderCellStyle(props, header, dataRow));
    return cellStyle;
  }
  return (0, _fp.defaults)(_Izenda.DEFAULT_CELL_STYLE, getCellContentStyle(header, dataRow, isHorizontal, rowIndex, colIndex, columnProps));
};

/**
 * Get color setting for Grid
 * @param {Object} header
 * @param {Array} dataRow
 * @param {boolean} isHorizontal
 * @param {int} rowIndex
 * @param {int} colIndex
 */
var getColorSettingForGrid = function getColorSettingForGrid(header, dataRow, isHorizontal, rowIndex, colIndex) {
  var columnHeader = isHorizontal ? dataRow : header;
  // set background & text color of cell follow

  var original_columnKey = _Izenda3.CUSTOM_FORMAT_PREFIX + header.columnKey;
  var cell = !(0, _fp.isNil)(dataRow[original_columnKey]) ? dataRow[original_columnKey] : !(0, _fp.isNil)(dataRow[header.columnKey]) ? dataRow[header.columnKey] : dataRow[colIndex];

  var cellData = cell && !(0, _fp.isNil)(cell.data) ? !(0, _fp.isNil)(cell.originalData) ? cell.originalData : cell.data : cell;
  var element = columnHeader.element;
  var dataSource = {
    element: {
      columnName: isHorizontal ? dataRow.columnName : header.columnKey,
      reportPartElm: element
    },
    record: isHorizontal ? dataRow[colIndex] : dataRow
  };

  var backgroundColor = _Izenda5.default.getConfigDataByRange(cellData, element.properties.dataFormattings.color.cellColor, dataSource);
  var textColor = _Izenda5.default.getConfigDataByRange(cellData, element.properties.dataFormattings.color.textColor, dataSource);

  return { backgroundColor: backgroundColor, textColor: textColor };
};

/**
 * Get cell content style
 * @param {Object} header
 * @param {Array} dataRow
 * @param {boolean} isHorizontal
 * @param {int} rowIndex
 * @param {int} colIndex
 * @param {Object} columnProps
 */
var getCellContentStyle = function getCellContentStyle(header, dataRow, isHorizontal, rowIndex, colIndex, columnProps) {
  var buildStyle = function buildStyle(item) {
    if (!item) {
      return {};
    }
    var wordWrap = columnProps.wordWrap,
        alignment = columnProps.alignment;

    // Only check wordWrap in Report Part Properties if in FieldProperties, wordWrap is null

    var isWordWraped = (0, _fp.isNil)(item.wordWrap) ? wordWrap : item.wordWrap;
    var textAlign = (0, _fp.isNil)(item.alignment) ? alignment : item.alignment;

    var _getColorSettingForGr = getColorSettingForGrid(header, dataRow, isHorizontal, rowIndex, colIndex),
        backgroundColor = _getColorSettingForGr.backgroundColor,
        textColor = _getColorSettingForGr.textColor;

    return (0, _fp.defaults)(_Izenda.DEFAULT_CELL_STYLE, {
      fontFamily: item.fontFamily,
      fontSize: item.fontSize + 'px',
      fontWeight: item.bold ? 'bold' : 'normal',
      textAlign: textAlign || 'none',
      textDecoration: item.underline ? 'underline' : 'none',
      fontStyle: item.italic ? 'italic' : 'normal',
      color: textColor || '',
      backgroundColor: backgroundColor || '',
      wordWrap: isWordWraped ? 'break-word' : 'normal',
      whiteSpace: isWordWraped ? 'normal' : 'nowrap'
    });
  };

  return buildStyle((0, _fp.get)('cellStyle', dataRow) || header.cellStyle);
};

/**
 * Render cell content base on value and style
 * @method getHeaderCellStyle
 * @param  {[type]}            dataRow        [record for this dataRow]
 * @param  {int}  rowIndex  Row index of record
 * @return {React.element}                    [cell content]
 */
var getHeaderCellStyle = function getHeaderCellStyle(props, header, dataRow) {
  var buildStyle = function buildStyle(item) {
    if (!item) {
      return {};
    }

    return (0, _fp.defaults)(_Izenda.DEFAULT_CELL_STYLE, {
      fontFamily: item.fontFamily,
      fontSize: item.fontSize + 'px',
      fontWeight: item.bold ? 'bold' : 'normal',
      textAlign: item.alignment || 'none',
      textDecoration: item.underline ? 'underline' : 'none',
      fontStyle: item.italic ? 'italic' : 'normal',
      color: item.textColor,
      backgroundColor: item.backgroundColor,
      wordWrap: item.wordWrap ? 'break-word' : 'normal',
      whiteSpace: item.wordWrap ? 'normal' : 'nowrap'
    });
  };

  return buildStyle((0, _fp.get)('style.header', dataRow) || header.style);
};

/**
 * Generate header data for vertical grid
 * @param {Object} props
 * @param {boolean} exporting
 * @return {json} object contain header and records for vertical-grid
 */
var generateHeaderDataForVertical = function generateHeaderDataForVertical(props, exporting) {
  var isPreview = props.isPreview,
      records = props.records,
      reportPart = props.reportPart,
      _props$reportPart = props.reportPart,
      previewData = _props$reportPart.previewData,
      previewDataFieldsMapping = _props$reportPart.previewDataFieldsMapping,
      _props$reportPart$rep = _props$reportPart.reportPartContent,
      columns = _props$reportPart$rep.columns,
      reportPartProperties = _props$reportPart$rep.properties;
  var columnSetting = reportPartProperties.columns,
      rowSetting = reportPartProperties.rows;

  var headers = [];
  var newRecords = (0, _mobx.isObservableArray)(records) ? records.peek() : records;

  // Max-length to show number of row
  newRecords = isPreview ? (0, _fp.take)(_Izenda2.default.RECORDS_MAX_LENGTH, newRecords) : newRecords;

  var _reportPart$getReport = reportPart.getReportPartProperties(),
      reportPartHeaderProperties = _reportPart$getReport.headers;

  var subTotalRecord = {
    className: 'sub-total',
    isSubTotal: true
  };
  var haveSubTotal = false;

  var maxHeaderHeight = (0, _fp.flow)((0, _fp.map)((0, _fp.get)('properties.headerFormating.height')), _fp.max)(columns.visibleElement);

  if (!(0, _fp.isEmpty)(columns.visibleElement)) {
    // Build header from selected columns

    headers = (0, _fp.compact)((0, _fp.map)(function (element) {
      var elementProperties = element.properties,
          _element$field = element.field,
          fieldNameAlias = _element$field.fieldNameAlias,
          fieldId = _element$field.fieldId;

      var label = (0, _fp.getOr)('', 'dataFormattings.subTotal.label', elementProperties);

      // get field mapping
      var fieldsMapping = (0, _fp.find)({ fieldId: fieldId, fieldNameAlias: fieldNameAlias }, previewDataFieldsMapping);

      if (fieldsMapping) {
        var style = elementProperties.getHeaderCellStyle(reportPartHeaderProperties);
        var cellStyle = elementProperties.getUIStyle();

        style.height = maxHeaderHeight || rowSetting.height;
        cellStyle.height = rowSetting.height;
        var columnWidth = elementProperties.dataFormattings.width.value || columnSetting.width.value;

        // check sub-total
        var subTotalMapping = (0, _fp.find)({ fieldNameAlias: fieldNameAlias }, previewData.subTotalMapping);

        if (subTotalMapping) {
          var subTotalFormat = (0, _fp.get)('dataFormattings.subTotal.format', elementProperties);
          var subTotalDataType = (0, _fp.get)('dataFormattings.subTotal.dataType', elementProperties);

          if (!(0, _fp.isNil)(records[0][subTotalMapping.columnName])) {
            subTotalRecord[fieldNameAlias] = {
              data: records[0][subTotalMapping.columnName],
              subTotalFormat: subTotalFormat,
              title: label,
              subTotalDataType: subTotalDataType
            };
          }
          haveSubTotal = true;
        } else {
          subTotalRecord[fieldNameAlias] = {
            data: '',
            title: ''
          };
        }

        return {
          fieldId: fieldsMapping.fieldId,
          columnKey: props.useFieldNameAlias ? fieldNameAlias : fieldsMapping.columnName,
          getTitle: props.renderHeader(columns, element, fieldNameAlias),
          width: columnWidth,
          style: style,
          cellStyle: cellStyle,
          element: element
        };
      }
      return null;
    }, columns.visibleElement));
    // push subtotal into datasource record of grid
    haveSubTotal && (newRecords = (0, _fp.concat)(newRecords, subTotalRecord));
  }

  var pivotColumnsPerExportedPage = reportPartProperties.view.pivotColumnsPerExportedPage;

  if (exporting && pivotColumnsPerExportedPage) {
    headers = (0, _fp.chunk)(pivotColumnsPerExportedPage, headers);
  } else {
    headers = [headers];
  }

  return (0, _fp.map)(function (page) {
    return {
      headers: processColumnGroupVertical(page),
      records: newRecords
    };
  })(headers);
};

/**
 * Process Column Group Vertical
 * @param {Object} headers
 */
var processColumnGroupVertical = function processColumnGroupVertical(headers) {
  var haveColumnGroup = (0, _fp.some)('element.properties.headerFormating.columnGroup', headers);

  if (!haveColumnGroup) {
    return headers;
  }

  var lastGroup = null;
  var listGroup = [];

  (0, _fp.forEach)(function (header) {
    var columnGroup = (0, _fp.get)('element.properties.headerFormating.columnGroup', header);

    if (lastGroup && lastGroup.title === columnGroup) {
      lastGroup.child.push(header);
    } else {
      lastGroup = {
        title: columnGroup,
        isColumnGroup: true,
        child: [header]
      };
      listGroup.push(lastGroup);
    }
  }, headers);

  return listGroup;
};

/**
 * Generate header data for horizontal gridgrid
 * @param {Object} props
 * @param {boolean} exporting
 * @return {json} object contain header and records for horizontal-grid
 */
var generateHeaderDataForHorizontal = function generateHeaderDataForHorizontal(props, exporting) {
  var records = props.records,
      reportPart = props.reportPart,
      _props$reportPart2 = props.reportPart,
      previewData = _props$reportPart2.previewData,
      previewDataFieldsMapping = _props$reportPart2.previewDataFieldsMapping,
      rows = _props$reportPart2.reportPartContent.rows;

  var pageRecords = null;
  var properties = reportPart.getReportPartProperties();
  var columnSetting = properties.columns,
      reportPartHeaderProperties = properties.headers;


  var maxWidth = (0, _fp.flow)((0, _fp.map)('properties.dataFormattings.width'), (0, _fp.maxBy)('value'))(rows.visibleElement);

  var configureWidth = {
    width: (0, _fp.get)('value', maxWidth) || columnSetting.width.value
  };

  var pivotColumnsPerExportedPage = properties.view.pivotColumnsPerExportedPage || 0;

  if (exporting && pivotColumnsPerExportedPage) {
    // make original array value into smaller chunk based on setting.
    pageRecords = (0, _fp.chunk)(pivotColumnsPerExportedPage, records.slice());
  } else if (props.isPreview) {
    // in report designer preview mode only have one chunk with maximum 50 records
    pageRecords = [(0, _fp.take)(_Izenda2.default.RECORDS_MAX_LENGTH, records.slice())];
  } else {
    // normal case only have 1 chunk with all records.
    pageRecords = [records.slice()];
  }

  var lastPage = pageRecords.length - 1;

  // each chunk will render 1 table.
  return pageRecords.map(function (page, index) {
    var headers = [];
    var dataSource = [];
    var haveSubtotalMapping = false;
    var rowSpan = void 0;

    if (!(0, _fp.isEmpty)(rows.visibleElement)) {
      headers.push(configureWidth);

      // Max-length to show number of column
      var recordsMaxLength = page.length;

      for (var i = 0; i < recordsMaxLength; i++) {
        headers.push(configureWidth);
      }

      var haveColumnGroup = (0, _fp.some)('properties.headerFormating.columnGroup', rows.visibleElement);

      var lastGroup = null;

      if (haveColumnGroup) {
        rowSpan = (0, _fp.assign)(configureWidth, { data: [] });
      }

      // Build data from selected columns
      (0, _fp.forEach)(function (element) {
        var _element$field2 = element.field,
            fieldId = _element$field2.fieldId,
            fieldNameAlias = _element$field2.fieldNameAlias;

        var fieldsMapping = (0, _fp.find)({ fieldId: fieldId, fieldNameAlias: fieldNameAlias }, previewDataFieldsMapping);

        if ((0, _fp.isNil)(fieldsMapping)) {
          return;
        }

        var columnGroup = (0, _fp.get)('properties.headerFormating.columnGroup', element);

        if (haveColumnGroup) {
          if (lastGroup && lastGroup.title === columnGroup) {
            lastGroup.size++;
          } else {
            lastGroup = {
              title: columnGroup,
              size: 1
            };
            rowSpan.data.push(lastGroup);
          }
        }

        // build data for each rows
        var row = [];

        row.push({
          className: 'header-row',
          data: element.field.fieldNameAlias
        });

        (0, _fp.forEach)(function (record) {
          row.push((0, _extends3.default)({}, record, {
            data: record[fieldsMapping.columnName],
            originalData: record[_Izenda3.CUSTOM_FORMAT_PREFIX + fieldsMapping.columnName]
          }));
        }, page);

        // sub-total
        var label = (0, _fp.getOr)('', 'properties.dataFormattings.subTotal.label', element);
        var subTotalMapping = (0, _fp.find)({ subTotalForColumnName: fieldsMapping.columnName }, previewData.subTotalMapping);

        if (!(0, _fp.isEmpty)(subTotalMapping) && index === lastPage) {
          if (!haveSubtotalMapping) {
            headers.push(configureWidth);
            haveSubtotalMapping = !haveSubtotalMapping;
          }
          var rowDataSubtotal = void 0;
          var subTotalDataType = (0, _fp.get)('properties.dataFormattings.subTotal.dataType', element);

          if (records[0][subTotalMapping.columnName]) {
            rowDataSubtotal = records[0][subTotalMapping.columnName];
          }
          row.push({
            className: 'sub-total',
            data: rowDataSubtotal,
            subTotalFormat: (0, _fp.get)('properties.dataFormattings.subTotal.format', element),
            title: label,
            subTotalDataType: subTotalDataType
          });
        } else if ((0, _fp.isEmpty)(subTotalMapping) && index === lastPage) {
          row.push({
            data: '',
            title: ''
          });
        }

        row.style = {};
        row.style.header = element.properties.getHeaderCellStyle(reportPartHeaderProperties);
        row.cellStyle = element.properties.getUIStyle();
        row.element = element;
        row.columnName = props.useFieldNameAlias ? fieldNameAlias : fieldsMapping.columnName;

        dataSource.push(row);
      }, rows.visibleElement);
    }

    return {
      headers: headers,
      records: dataSource,
      rowSpan: rowSpan
    };
  });
};

/**
 * Generate header data
 * @param {Object} props
 * @return {json} object contain header and records
 */
var generateHeaderData = function generateHeaderData(props, e) {
  var gridStyle = props.reportPart.reportPartContent.properties.generalInfo.gridStyle;
  var exporting = props.printingMode;

  if (gridStyle === _Izenda2.default.GRID_STYLES.HORIZONTAL.value) {
    return generateHeaderDataForHorizontal(props, exporting);
  }

  return generateHeaderDataForVertical(props, exporting);
};

/**
 * Get Column Group Cell Style
 * @param {Object} props
 * @param {Object} totalGroup
 * @param {Object} rowSpan
 * @param {int} rowIndex
 */
var getColumnGroupCellStyle = function getColumnGroupCellStyle(props, totalGroup, rowSpan, rowIndex, placeHolder) {
  var properties = props.reportPart.reportPartContent.properties;

  var isHorizontal = properties.generalInfo.gridStyle === _Izenda.GRID_STYLES.HORIZONTAL.value;

  var reportPartHeaderProperties = properties.headers;
  var border = properties.table && properties.table.border;
  var borderStyle = {};

  // Border mid vertical
  if (border.midVer && rowIndex !== totalGroup - 1 && !isHorizontal) {
    borderStyle = (0, _fp.assign)(borderStyle, _Izenda7.default.getBorderStyle('Right', border.midVer));
  }

  // Border mid Horizontal
  if (border.midHor && isHorizontal && rowIndex !== totalGroup - 1) {
    borderStyle = (0, _fp.assign)(borderStyle, _Izenda7.default.getBorderStyle('Bottom', border.midHor));
  }

  if (!rowSpan.title) {
    return (0, _fp.defaults)({ background: _Izenda.EMPTY_CELL_BACKGROUND_COLOR }, borderStyle);
  }

  if (border.top && (rowIndex === 0 || !isHorizontal)) {
    borderStyle = (0, _fp.assign)(borderStyle, _Izenda7.default.getBorderStyle('Top', border.top));
  }
  // Border bottom
  if (border.bottom && isHorizontal && rowIndex === totalGroup - 1) {
    borderStyle = (0, _fp.assign)(borderStyle, _Izenda7.default.getBorderStyle('Bottom', border.bottom));
  }

  // Border left
  if (border.left && (isHorizontal || rowIndex === 0)) {
    borderStyle = (0, _fp.assign)(borderStyle, _Izenda7.default.getBorderStyle('Left', border.left));
  }

  // Border right
  if (border.right && !isHorizontal && rowIndex === totalGroup - 1) {
    borderStyle = (0, _fp.assign)(borderStyle, _Izenda7.default.getBorderStyle('Right', border.right));
  }

  var backGroundColor = (0, _fp.get)('font.backgroundColor', reportPartHeaderProperties);
  var verticalAlign = (0, _fp.get)('verticalAlignment', reportPartHeaderProperties);
  var wordWrapStyle = (0, _fp.get)('wordWrap', reportPartHeaderProperties) ? {
    wordWrap: 'break-word',
    whiteSpace: 'normal'
  } : {
    wordWrap: 'normal',
    whiteSpace: 'nowrap'
  };

  return (0, _fp.defaults)((0, _fp.defaults)({ background: backGroundColor, verticalAlign: verticalAlign }, wordWrapStyle), borderStyle);
};

/**
 * Get Column group cell content style
 * @param {Object} props [report part props]
 * @param {Object} rowSpan [row span config]
 * @return {Object}          [style of cell]
 */
var getColumnGroupCellContentStyle = function getColumnGroupCellContentStyle(props, rowSpan, e) {
  if (!rowSpan.title) {
    return {};
  }
  return _Izenda9.default.createStyleObject(props.reportPart.reportPartContent.properties.getHeaderCellStyle());
};

/**
 * Get cell style of cell
 * @param  {Object} dataRow  [data row]
 * @param  {Number} rowIndex [index of row]
 * @return {Object}          [style of cell]
 */
var getCellStyle = function getCellStyle(props, header, numberOfRecord, totalColumns, dataRow, rowIndex, colIndex) {
  var reportPart = props.reportPart,
      reportPartContent = props.reportPart.reportPartContent,
      embededReportPart = props.embededReportPart;

  var isMobile = _Izenda11.default.isMobileDevice();
  var properties = reportPart.getReportPartProperties();
  var rows = properties.rows,
      columns = properties.columns,
      table = properties.table,
      isHeaderStickHorizontal = properties.isHeaderStickHorizontal;

  var isHorizontal = properties.generalInfo.gridStyle === _Izenda.GRID_STYLES.HORIZONTAL.value ? 1 : 0;
  var haveColumnGroup = (0, _fp.some)('properties.headerFormating.columnGroup', reportPartContent.rows.visibleElement);
  var hasLeftStyle = !isMobile && !embededReportPart && haveColumnGroup && colIndex === 0 && isHeaderStickHorizontal;
  // Cell background color
  var useAlternateColorRow = rows && rows.alterBackgroundColor ? 1 : 0;
  var useAlternateColorColumn = columns && columns.alterBackgroundColor ? 1 : 0;
  var columnVerticalAlignment = columns.verticalAlignment;

  var backgroundColor = (rowIndex * useAlternateColorRow + (colIndex + isHorizontal) * useAlternateColorColumn) % 2 === 0 ? table.backgroundColor : table.alternativeBackgroundColor;

  // Cell border style
  var border = table.border;
  var borderStyle = {};
  var getBorderStyle = _Izenda7.default.getBorderStyle;

  // Border middle vertical
  if (border.midVer && colIndex !== totalColumns - 1) {
    borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Right', border.midVer));
  }

  // Border middle horizontal
  if (border.midHor && rowIndex !== numberOfRecord - 1) {
    borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Bottom', border.midHor));
  }

  // Border left
  if (border.left && colIndex === 0) {
    borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Left', border.left));
  }

  // Border right
  if (border.right && colIndex === totalColumns - 1) {
    borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Right', border.right));
  }

  // Border top
  if (border.top && (0, _fp.isNil)(rowIndex)) {
    borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Top', border.top));
  }

  if (border.top && isHorizontal && rowIndex === 0) {
    borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Top', border.top));
  }

  // Border bottom
  if (border.bottom && rowIndex === numberOfRecord - 1) {
    borderStyle = (0, _fp.assign)(borderStyle, getBorderStyle('Bottom', border.bottom));
  }

  var headerStyle = isHorizontal && colIndex === 0 && dataRow ? dataRow.style.header : header.style;

  var verticalAlign = '';

  if (!isHorizontal) {
    verticalAlign = (0, _fp.isNil)(dataRow) ? header.element && header.element.properties.headerFormating.verticalAlignment || header.style.verticalAlignment : header.element && header.element.properties.dataFormattings.verticalAlignment || columnVerticalAlignment;
  } else {
    verticalAlign = (0, _fp.isNil)(dataRow) ? DEFAULT_VERTICAL_ALIGNMENT : colIndex === 0 ? dataRow.element && dataRow.element.properties.headerFormating.verticalAlignment || dataRow.style.header.verticalAlignment : dataRow.element && dataRow.element.properties.dataFormattings.verticalAlignment || columnVerticalAlignment;
  }

  return (0, _fp.defaults)(borderStyle, {
    backgroundColor: (0, _fp.isNil)(dataRow) || isHorizontal && colIndex === 0 ? headerStyle ? headerStyle.backgroundColor : _Izenda.EMPTY_CELL_BACKGROUND_COLOR : backgroundColor,
    verticalAlign: verticalAlign,
    wordWrap: columns.wordWrap,
    left: hasLeftStyle && header.width
  });
};

exports.default = (0, _recompose.compose)((0, _recompose.withState)('isLoading', 'updateLoading', true), (0, _recompose.withHandlers)({
  generateHeaderData: (0, _fp.curry)(generateHeaderData),
  fnGetCellContentStyle: (0, _fp.curry)(fnGetCellContentStyle),
  getHeaderCellStyle: (0, _fp.curry)(getHeaderCellStyle),
  getCellStyle: (0, _fp.curry)(getCellStyle),
  getColumnGroupCellStyle: (0, _fp.curry)(getColumnGroupCellStyle),
  getColumnGroupCellContentStyle: (0, _fp.curry)(getColumnGroupCellContentStyle)
}), (0, _recompose.withProps)(function (props) {
  var embededReportPart = props.embededReportPart;

  var isMobile = _Izenda11.default.isMobileDevice();
  return {
    getStickyValue: function getStickyValue(value) {
      return embededReportPart || isMobile ? false : value;
    }
  };
}));
module.exports = exports['default'];

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.RowDataObject.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * RowDataObject
 */
!function () {
  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      forEach = _require.forEach,
      map = _require.map,
      isNil = _require.isNil,
      get = _require.get,
      last = _require.last,
      concat = _require.concat,
      sumBy = _require.sumBy,
      compact = _require.compact,
      flatMap = _require.flatMap;

  var m = __webpack_require__(5);

  var RowDataObject = function RowDataObject(level, keyPath, isExpand, item) {
    var lastKey = last(item.key);
    this.key = lastKey.columnName;
    // field name alias when receive data, ensure unique, uneffected by rename fieldNameAlias
    this.uniqueFieldNameAlias = get('element.field.fieldNameAlias', lastKey);
    this.element = lastKey.element;
    this.value = lastKey.value;
    this.subKeyPath = concat(keyPath, { element: lastKey.element, value: this.value });
    this.dataForGroup = [];
    this.dataForSubTotal = [];
    this.childs = map(createRowDataObject.bind(null, level - 1, this.subKeyPath, isExpand), item.subGroup);
    isExpand = isExpand || get('element.properties.fieldItemVisible', lastKey) === false && keyPath.every(function (k) {
      return get('element.properties.fieldItemVisible', k) === false;
    });
    this.data = isNil(item.subGroup) || !isExpand ? compact(item.data) : [];
    this.subTotalMapping = null;
    // descecding level, for knowing how many sub level left to the farthest leaf
    // using for add empty cell for missing level
    this.level = level;
    // ascendingLevel level, fow knowing how many level from the root
    // using for sending api request
    this.ascendingLevel = lastKey.level;

    m.extendObservable(this, {
      isExpand: isEmpty(this.childs) ? false : !!isExpand,
      isExpandable: function isExpandable() {
        return this.level > 1;
      },
      size: function size() {
        if (isEmpty(this.childs)) {
          return 1;
        }
        return sumBy('size', this.childs);
      },
      childsData: function childsData() {
        if (isEmpty(this.childs)) {
          return this.data;
        }
        return flatMap('childsData', this.childs);
      }
    });
  };

  var createRowDataObject = function createRowDataObject(level, keyPath, isExpand, item) {
    return new RowDataObject(level, keyPath, isExpand, item);
  };

  RowDataObject.prototype.nearestAscendingLevelToExpand = function () {
    if (this.childs.length <= 0 || this.childs.some(function (c) {
      return get('element.properties.fieldItemVisible', c) === true;
    })) return this.ascendingLevel;
    return Math.min.apply(Math, (0, _toConsumableArray3.default)(this.childs.map(function (c) {
      return c.nearestAscendingLevelToExpand();
    })));
  };

  RowDataObject.prototype.buildDrillDownParams = function (forExpand) {
    return {
      expandedLevel: forExpand ? this.nearestAscendingLevelToExpand() : this.ascendingLevel - 1,
      filters: map(function (item) {
        return {
          key: item.element.field.fieldNameAlias,
          value: item.value
        };
      }, this.subKeyPath)
    };
  };

  RowDataObject.prototype.setChilds = function (rowDataObjects) {
    forEach(function (item) {
      item.level = this.level - 1;
      item.ascendingLevel = this.level + 1;
      item.subKeyPath = concat(this.subKeyPath, item.subKeyPath);
    }.bind(this), rowDataObjects);
    this.childs = rowDataObjects;
  };

  RowDataObject.prototype.toggleExpand = function (value) {
    if (isNil(value)) {
      this.isExpand = !this.isExpand;
    } else {
      this.isExpand = value;
    }
  };

  module.exports = {
    RowDataObject: RowDataObject,
    createRowDataObject: createRowDataObject
  };
}();

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleInputConfiguration.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(17);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(39);

var _Izenda6 = __webpack_require__(13);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(16);

var _Izenda9 = __webpack_require__(1904);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleInputConfiguration = (_dec = (0, _Izenda4.default)(_Izenda10.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SimpleInputConfiguration, _Component);

  function SimpleInputConfiguration() {
    (0, _classCallCheck3.default)(this, SimpleInputConfiguration);
    return (0, _possibleConstructorReturn3.default)(this, (SimpleInputConfiguration.__proto__ || (0, _getPrototypeOf2.default)(SimpleInputConfiguration)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimpleInputConfiguration, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var reportPart = props.reportPart;
      var dataKey = props.dataKey;
      var isGridOrMap = reportPart.type === _Izenda8.REPORT_PART_TYPE.Grid || reportPart.type === _Izenda8.REPORT_PART_TYPE.Map;
      var labelCols = isGridOrMap ? 3 : 12;
      var inputCols = isGridOrMap ? 9 : 12;

      var fontSetting = props.getFontSettings();
      var hadSetting = !((0, _fp.isEqual)(fontSetting, _Izenda5.DEFAULT_SETTING_VALUE.titleDescriptionNew(dataKey === 'previewTitle')) || (0, _fp.isEqual)(fontSetting, _Izenda5.DEFAULT_SETTING_VALUE.titleDescriptionDefault));

      return _react2.default.createElement(
        _Izenda7.default.Row,
        null,
        _react2.default.createElement(
          _Izenda7.default.Col,
          { cols: labelCols, xs: '3' },
          _Izenda5.LABEL_TEXT[dataKey]
        ),
        _react2.default.createElement(
          _Izenda7.default.Col,
          { cols: inputCols, xs: '9' },
          _react2.default.createElement(
            'div',
            { className: 'configuration-input' },
            _react2.default.createElement(_Izenda2.default, {
              className: 'form-control',
              value: getHeaderInfo(dataKey),
              onChange: _EventUtils2.default.notifyChange(onChangeData, _EventUtils2.default.INPUT)
            }),
            _react2.default.createElement(
              'a',
              { onClick: props.togglePopup },
              _react2.default.createElement(
                'span',
                { className: 'icon-setting', title: props.title },
                hadSetting && _react2.default.createElement(
                  'div',
                  { className: 'u_floatRight u-posRelative' },
                  _react2.default.createElement('i', { className: 'icon-ok u_smallIcon u-hadSetting u-colorWhite u-bgGreen' })
                )
              )
            )
          )
        )
      );

      /**
       * Get Title/Description text
       * @returns {String}
       */
      function getHeaderInfo() {
        var re = reportPart.getDataValueByKey(dataKey);
        return re && re.text;
      }

      /**
       * Update text for previewTitle or Description
       * @param newVal
       */
      function onChangeData(newVal) {
        var fn = dataKey === 'previewTitle' ? 'updateReportPartPreviewTitle' : 'updateReportPartDescription';
        reportPart[fn] && reportPart[fn](newVal);
      }
    }
  }]);
  return SimpleInputConfiguration;
}(_react.Component), _class2.propTypes = {
  reportPart: _react2.default.PropTypes.object.isRequired,
  dataKey: _react2.default.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = SimpleInputConfiguration;
module.exports = exports['default'];

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(964);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Save font settings and close fonts popup
 * @param settings
 */
var onSave = function onSave(props, settings) {
  var reportPart = props.reportPart;
  var fn = props.dataKey === 'previewTitle' ? 'updateTitleSettings' : 'updateDescriptionSettings';

  reportPart[fn] && reportPart[fn](settings);
};

/**
 * Toggle font popup
 */
// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleInputConfigurationAction.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var togglePopup = function togglePopup(props) {
  return function () {
    var reportPart = props.reportPart;
    var dataKey = props.dataKey;
    var fontSetting = getFontSettings(props);

    props.openPopup(_Izenda2.default, {
      title: props.title,
      font: fontSetting(),
      save: (0, _fp.curry)(onSave)(props)
    });
  };
};

var getFontSettings = function getFontSettings(props) {
  return function () {
    var reportPart = props.reportPart;
    var dataKey = props.dataKey;
    var settings = reportPart[dataKey].settings;
    var font = settings.font;
    var alignment = settings.alignment.alignment;

    return {
      fontFamily: font.family,
      fontSize: font.size,
      fontBold: font.bold,
      fontItalic: font.italic,
      fontUnderline: font.underline,
      fontColor: font.color,
      fontHighlightColor: font.highlightColor,
      alignment: alignment
    };
  };
};

exports.default = (0, _recompose.withHandlers)({ togglePopup: togglePopup, getFontSettings: getFontSettings });
module.exports = exports['default'];

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = deferComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _raf = __webpack_require__(296);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deferComponent(WrappedComponent, LoadingComponent) {
  if ((0, _fp.isNil)(LoadingComponent)) {
    LoadingComponent = null;
  }

  var DeferredWrapper = function (_Component) {
    (0, _inherits3.default)(DeferredWrapper, _Component);

    function DeferredWrapper() {
      (0, _classCallCheck3.default)(this, DeferredWrapper);

      var _this = (0, _possibleConstructorReturn3.default)(this, (DeferredWrapper.__proto__ || (0, _getPrototypeOf2.default)(DeferredWrapper)).call(this));

      _this.state = {
        shouldRender: false
      };
      return _this;
    }

    (0, _createClass3.default)(DeferredWrapper, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.requestFrame = (0, _raf2.default)(function () {
          _this2.requestFrame = (0, _raf2.default)(function () {
            return _this2.setState({ shouldRender: true });
          });
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _raf2.default.cancel(this.requestFrame);
      }
    }, {
      key: 'render',
      value: function render() {
        return this.state.shouldRender ? _react2.default.createElement(WrappedComponent, this.props) : _react2.default.createElement(LoadingComponent, null);
      }
    }]);
    return DeferredWrapper;
  }(_react.Component);

  return DeferredWrapper;
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.DeferComponent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Supporting render expensive WrappedComponent.
 */

module.exports = exports['default'];

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(64);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FUNCTION = _Izenda2.default.FUNCTION; // ----------------------------------------------------------------------
// <copyright file="Izenda.GridDefaultFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FORMAT_KEY = _Izenda2.default.FORMAT_KEY;

var GROUP_FUNCTION_FORMAT_NONE = {
  FUNCTION: FUNCTION.GROUP,
  FORMAT: FORMAT_KEY.NONE
};

var GROUP_FUNCTION_FORMAT_YEAR = {
  FUNCTION: FUNCTION.GROUP,
  FORMAT: FORMAT_KEY.YEAR
};

var SUM_FUNCTION_FORMAT_NONE = {
  FUNCTION: FUNCTION.SUM,
  FORMAT: FORMAT_KEY.NONE
};

var COUNT_FUNCTION_FORMAT_NONE = {
  FUNCTION: FUNCTION.COUNT,
  FORMAT: FORMAT_KEY.NONE
};

var GROUP_FUNCTION_FORMAT_TIME = {
  FUNCTION: FUNCTION.GROUP,
  FORMAT: FORMAT_KEY.DEFAULT_TIME
};

// Default function for Vertical without separator
var VERTICAL_DEFAULT_FUNCTION = {};

// Default function for Vertical with separator
var VERTICAL_DEFAULT_FUNCTION_WITH_SEPARATORS = {};

// Default function for Vertical with separator
var VERTICAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION = {
  separators: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Lob: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_NONE,
    Image: GROUP_FUNCTION_FORMAT_NONE,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  columns: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Lob: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_NONE,
    Image: GROUP_FUNCTION_FORMAT_NONE,
    Money: GROUP_FUNCTION_FORMAT_NONE
  }
};

// Default function for horizontal without separator
var HORIZONTAL_DEFAULT_FUNCTION = {};

// Default function for horizontal with separator
var HORIZONTAL_DEFAULT_FUNCTION_WITH_SEPARATORS = {};

// Default function for horizontal with separator
var HORIZONTAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION = {
  separators: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Lob: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_NONE,
    Image: GROUP_FUNCTION_FORMAT_NONE,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  rows: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Lob: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_NONE,
    Image: GROUP_FUNCTION_FORMAT_NONE,
    Money: GROUP_FUNCTION_FORMAT_NONE
  }
};

// Default function for pivot
var PIVOT_DEFAULT_FUNCTION = {
  columns: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  rows: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  values: {
    Numeric: SUM_FUNCTION_FORMAT_NONE,
    Text: COUNT_FUNCTION_FORMAT_NONE,
    Boolean: COUNT_FUNCTION_FORMAT_NONE,
    Datetime: COUNT_FUNCTION_FORMAT_NONE,
    Time: COUNT_FUNCTION_FORMAT_NONE,
    Money: SUM_FUNCTION_FORMAT_NONE
  },
  separators: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  }
};

// Default function for drill down
var DRILL_DOWN_DEFAULT_FUNCTION = {
  rows: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  values: {
    Numeric: SUM_FUNCTION_FORMAT_NONE,
    Text: COUNT_FUNCTION_FORMAT_NONE,
    Boolean: COUNT_FUNCTION_FORMAT_NONE,
    Datetime: COUNT_FUNCTION_FORMAT_NONE,
    Time: COUNT_FUNCTION_FORMAT_NONE,
    Money: SUM_FUNCTION_FORMAT_NONE
  },
  separators: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  }
};

exports.default = {
  PIVOT_DEFAULT_FUNCTION: PIVOT_DEFAULT_FUNCTION,
  HORIZONTAL_DEFAULT_FUNCTION: HORIZONTAL_DEFAULT_FUNCTION,
  HORIZONTAL_DEFAULT_FUNCTION_WITH_SEPARATORS: HORIZONTAL_DEFAULT_FUNCTION_WITH_SEPARATORS,
  HORIZONTAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: HORIZONTAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION,
  DRILL_DOWN_DEFAULT_FUNCTION: DRILL_DOWN_DEFAULT_FUNCTION,
  VERTICAL_DEFAULT_FUNCTION_WITH_SEPARATORS: VERTICAL_DEFAULT_FUNCTION_WITH_SEPARATORS,
  VERTICAL_DEFAULT_FUNCTION: VERTICAL_DEFAULT_FUNCTION,
  VERTICAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: VERTICAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION
};
module.exports = exports['default'];

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(64);

var DRILL_DOWN_AVAILABLE_CONFIG = {
  rows: {
    UNSUPPORTED: {
      DEFAULT: [_Izenda.FUNCTION.NONE]
    }
  },
  values: {
    UNSUPPORTED: {
      DEFAULT: [_Izenda.FUNCTION.NONE, _Izenda.FUNCTION.GROUP, _Izenda.FUNCTION.GROUP_DAYS_OLD]
    }
  },
  separators: {
    UNSUPPORTED: {
      DEFAULT: [_Izenda.FUNCTION.NONE]
    }
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.GridDefaultConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var PIVOT_AVAILABLE_CONFIG = {
  rows: {
    UNSUPPORTED: {
      DEFAULT: [_Izenda.FUNCTION.NONE]
    }
  },
  columns: {
    SUPPORTED: {
      Datetime: [_Izenda.FUNCTION.GROUP, _Izenda.FUNCTION.GROUP_DAYS_OLD],
      DEFAULT: [_Izenda.FUNCTION.GROUP]
    }
  },
  values: {
    UNSUPPORTED: {
      DEFAULT: [_Izenda.FUNCTION.NONE, _Izenda.FUNCTION.GROUP, _Izenda.FUNCTION.GROUP_DAYS_OLD]
    }
  },
  separators: {
    UNSUPPORTED: {
      DEFAULT: [_Izenda.FUNCTION.NONE]
    }
  }
};

exports.default = {
  AVAILABLE_FUNCTION_CONFIG: {
    Pivot: PIVOT_AVAILABLE_CONFIG,
    Drilldown: DRILL_DOWN_AVAILABLE_CONFIG
  }
};
module.exports = exports['default'];

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = __webpack_require__(5);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(35);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartFrontSideActions.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _recompose.compose)((0, _recompose.withProps)({
  updateDrillComponent: updateDrillComponent,
  setDefaultIntervalForDatetime: setDefaultIntervalForDatetime
}), (0, _recompose.withHandlers)({
  onDrilldown: (0, _fp.curry)(onDrilldown),
  setPageSize: (0, _fp.curry)(setPageSize),
  getSortValueForLinearChart: getSortValueForLinearChart
}));

/**
 * Update drill handler
 */

function updateDrillComponent() {
  var reportPart = (0, _fp.getOr)({}, 'reportPart', this.props);
  reportPart.onDrilldown = this.onDrilldown;
}

/**
 * Set default value for interval date time.
 */
function setDefaultIntervalForDatetime() {
  var content = (0, _fp.get)('reportPart.reportPartContent', this.props);
  content.setDefaultIntervalForDatetime();
}

/**
 * Drill handler
 * @param {Object} props
 * @param {Object} drilldownInfo
 * @param {Object} separator
 */
function onDrilldown(props, drilldownInfo, separator) {
  var reportPart = props.reportPart,
      printingMode = props.printingMode,
      reportPartContent = props.reportPart.reportPartContent,
      store = props.store,
      previewRecords = props.previewRecords;

  var canDrilldown = reportPartContent.updateDrilldownInfo(drilldownInfo, separator);

  if (canDrilldown) {
    !!props.publishDrillInfo && props.publishDrillInfo(reportPart.id, reportPart.reportPartContent.getCrossFilteringInfo());
    var loadingProcess = props.needUpdatePreview(reportPart, reportPartContent.getDrilldownInfo(), null, null, printingMode, previewRecords).then(function () {
      reportPartContent.isCrossFiltering && store && store.loadReportPartDataByCrossFiltering(reportPart.id);
    });
    props.showLoading && props.showLoading(loadingProcess);
  }
}

/**
 * Update page size
 * @param {Object} props
 * @param {Object} pageSize
 */
function setPageSize(props, pageSize) {
  return props.reportPart.reportPartContent.setPageSize(pageSize);
}

/**
 * Get sort value for chart, when xAxis type is linear
 */
function getSortValueForLinearChart(props) {
  return (0, _mobx.action)(function () {
    var reportPart = props.reportPart;

    if (!reportPart) return null;

    var reportPartContent = reportPart.reportPartContent;
    var currentDrilldownField = (0, _fp.get)('currentDrilldownField', reportPartContent);

    // Get sort value for the current drilldown field
    var sortValue = (0, _fp.get)('properties.dataFormattings.sort', currentDrilldownField);

    return (0, _Izenda.isLinear)(currentDrilldownField, reportPartContent.defaultOptionsByType) ? sortValue : null;
  });
}
module.exports = exports['default'];

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (editorComp, reportDesignerModel, fieldStore, itemProps) {
  var PERMISSION_OPERATOR = itemProps.authorizationConstants.PERMISSION_OPERATOR;
  var PERMISSION_KEY = itemProps.authorizationConstants.PERMISSION_KEY;
  var authorization = itemProps.authorization;

  var configField = itemProps.configField || {};
  var configReportPart = reportDesignerModel.configReportPart;
  var reportPartContent = configReportPart.reportPartContent;
  var fieldContainerDetails = itemProps.fieldContainerDetails || {};

  var chartFieldPropsSchema = _Izenda3.default.apply(null, arguments);
  var containerName = fieldContainerDetails.name || '';

  var mappingSource = chartFieldPropsSchema.mappingSource;
  var mappingProps = chartFieldPropsSchema.mappingProps;
  mappingProps.stypeOptions = (0, _fp.remove)({
    value: 'embedded'
  }, mappingProps.stypeOptions);

  // update schema
  _Izenda8.default.removeProps(chartFieldPropsSchema, UNUSED_PROPS);

  // show cell color
  showTextCellColor(chartFieldPropsSchema.definedSchema, containerName);

  // show alternative text
  showAternativeText(chartFieldPropsSchema.definedSchema, containerName);

  // add config to [subReport]
  addSubReportConfig(containerName);

  return chartFieldPropsSchema;

  /**
   * Disable|Enable sub report based on its container
   */
  function addSubReportConfig(containerName) {
    var mappingSource = chartFieldPropsSchema.mappingSource;

    mappingSource.isHiddenEmbeddedJavascript = isHiddenFunctionByPermissionKey(PERMISSION_KEY.ReportsFieldPropertiesEmbeddedJavaScript);
    mappingSource.isHiddenCustomURL = isHiddenFunctionByPermissionKey(PERMISSION_KEY.ReportsFieldPropertiesCustomURL);
    mappingSource.isHiddenSubReport = isHiddenFunctionByPermissionKey(PERMISSION_KEY.ReportsFieldPropertiesSubreport);

    function isHiddenFunctionByPermissionKey(permissionKey) {
      var showHidefunction = function showHidefunction() {
        var privilege = itemProps.authorization && itemProps.authorization.checkPrivileges([permissionKey]);
        if (!privilege) {
          return true;
        }
        return isShow();
      };
      return showHidefunction;
    }

    function isShow() {
      var chartType = reportPartContent.chartType;
      var isShowed = true;
      switch (chartType) {
        case _Izenda.CHART_TYPE.Line:
        case _Izenda.CHART_TYPE.Column:
        case _Izenda.CHART_TYPE.Bar:
        case _Izenda.CHART_TYPE.Area:
        case _Izenda.CHART_TYPE.Combination:
        case _Izenda.CHART_TYPE.Waterfall:
          isShowed = inContainer([_Izenda4.ContainerName.LABELS]);
          break;
        case _Izenda.CHART_TYPE.Pie:
        case _Izenda.CHART_TYPE.Funnel:
        case _Izenda.CHART_TYPE.Donut:
        case _Izenda.CHART_TYPE.TreeMap:
          isShowed = inContainer([_Izenda4.ContainerName.LABELS, _Izenda4.ContainerName.SEPARATORS]);
          break;
        case _Izenda.CHART_TYPE.HeatMap:
          isShowed = inContainer([_Izenda4.ContainerName.LABELS, _Izenda4.ContainerName.VALUES]);
          break;
        case _Izenda.CHART_TYPE.Bubble:
        case _Izenda.CHART_TYPE.Scatter:
          isShowed = inContainer([_Izenda4.ContainerName.VALUES_LABELS]);
          break;
        case _Izenda.CHART_TYPE.Sparkline:
          isShowed = inContainer([_Izenda4.ContainerName.SEPARATORS]);
          break;
      }
      return !isShowed;
    }

    function inContainer(containers) {
      return containers.indexOf(containerName) > -1;
    }
  }

  function showAternativeText(definedSchema, containerName) {
    var isShowAlternativeText = void 0;

    switch (reportPartContent.chartType) {
      case _Izenda.CHART_TYPE.Sparkline:
        isShowAlternativeText = [_Izenda4.ContainerName.LABELS, _Izenda4.ContainerName.VALUES].indexOf(containerName) > -1 ? false : true;
        break;
      default:
        isShowAlternativeText = true;
    }

    if (!isShowAlternativeText) {
      delete definedSchema.fields.dataFormattings.fields.alternativeText;
    }
  }

  function showTextCellColor(definedSchema, containerName) {
    var colorDef = (0, _fp.get)('fields.dataFormattings.fields.color', definedSchema);

    if (!colorDef) {
      return;
    }

    var isShowCellColor = void 0;

    switch (reportPartContent.chartType) {
      case _Izenda.CHART_TYPE.Pie:
      case _Izenda.CHART_TYPE.Donut:
      case _Izenda.CHART_TYPE.Funnel:
      case _Izenda.CHART_TYPE.TreeMap:
        isShowCellColor = !(containerName === _Izenda4.ContainerName.SEPARATORS);
        break;
      default:
        isShowCellColor = true;
    }

    if (!isShowCellColor) {
      return delete definedSchema.fields.dataFormattings.fields.color;
    }

    $izenda.extend(true, colorDef, {
      staticProps: {
        showTextColor: false,
        showCellColor: isShowCellColor
      }
    });
  }
};

var _Izenda = __webpack_require__(33);

var _Izenda2 = __webpack_require__(257);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(39);

var _Izenda5 = __webpack_require__(42);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(187);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsSchemaChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var UNUSED_PROPS = ['fields.dataFormattings.fields.fontFormat', 'fields.dataFormattings.fields.fontStyle', 'fields.dataFormattings.fields.alignment', 'fields.dataFormattings.fields.subTotal', 'fields.dataFormattings.fields.grandTotal', 'fields.dataFormattings.fields.width', 'fields.dataFormattings.fields.columnWordWrap', 'fields.dataFormattings.fields.verticalAlignment', 'fields.headerFormating'];

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp; //  ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormBackSide.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormBackSide component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(131);

var _Izenda2 = __webpack_require__(132);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(1911);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(970);

var _Izenda7 = _interopRequireDefault(_Izenda6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartFormHTML = (0, _Izenda7.default)(__webpack_require__(1923));

var ReportPartFormBackSide = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartFormBackSide, _Component);
  (0, _createClass3.default)(ReportPartFormBackSide, [{
    key: 'init',
    value: function init(activeKey) {
      var _props = this.props,
          reportPartContent = _props.reportPart.reportPartContent,
          store = _props.store;

      reportPartContent.setFormState(activeKey || _Izenda3.default.TAB_VISUAL.key, (0, _fp.uniqueId)('reportPartForm-'));
      // get data tree to support populate field info from html
      reportPartContent.setDataTree(store.model.dataTree);
      reportPartContent.syncFromHTMLToElements();
    }
  }]);

  function ReportPartFormBackSide(props) {
    (0, _classCallCheck3.default)(this, ReportPartFormBackSide);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartFormBackSide.__proto__ || (0, _getPrototypeOf2.default)(ReportPartFormBackSide)).call(this, props));

    _this.setSelectedTab = function (index, tabPanel, tab, activeTabKey) {
      var reportPart = _this.props.reportPart;

      // Update form definition with new information from html content.

      if (reportPart.reportPartContent.activeTabKey === _Izenda3.default.TAB_HTML.key) {
        reportPart.reportPartContent.syncFromHTMLToElements();
      }
      reportPart.reportPartContent.activeTabKey = activeTabKey;
    };

    _this.beforeChangeTab = function (index, tabPanel, tab, activeTabKey) {
      var reportPart = _this.props.reportPart;

      // Update form definition with new information from html content.

      if (reportPart.reportPartContent.activeTabKey === _Izenda3.default.TAB_HTML.key) {
        return (0, _bluebird.resolve)(true);
      } else {
        return reportPart.reportPartContent.rebuildHTMLContent(true);
      }
    };

    _this.init();
    // for case when update result populate old report part object but create new
    // report part content object, need to repopulate data for this new object
    _this.disposeObserve = (0, _mobx.observe)(_this.props.reportPart, 'reportPartContent', function (newObj, oldObj) {
      _this.init((0, _fp.get)('activeTabKey', oldObj));
    });
    return _this;
  }

  (0, _createClass3.default)(ReportPartFormBackSide, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disposeObserve();
    }

    // hack for case sync, will fix on tabs when add promise resolve for before on change.

  }, {
    key: 'render',
    value: function render() {
      var props = this.props,
          reportPart = this.props.reportPart;

      var visualTab = _Izenda3.default.TAB_VISUAL;
      var htmlTab = _Izenda3.default.TAB_HTML;

      return _react2.default.createElement(
        _Izenda.Tabs,
        {
          canChangeTab: this.beforeChangeTab,
          className: 'report-part-form full-height u-bgGray',
          activeTabKey: reportPart.reportPartContent.activeTabKey,
          onChange: this.setSelectedTab
        },
        _react2.default.createElement(
          _Izenda.Tab,
          { title: visualTab.value, tabKey: visualTab.key },
          _react2.default.createElement(_Izenda5.default, props)
        ),
        _react2.default.createElement(
          _Izenda.Tab,
          { title: htmlTab.value, tabKey: htmlTab.key },
          _react2.default.createElement(ReportPartFormHTML, props)
        )
      );
    }
  }]);
  return ReportPartFormBackSide;
}(_react.Component), _class2.propTypes = {
  reportPart: _propTypes2.default.object
}, _temp)) || _class;

exports.default = ReportPartFormBackSide;
module.exports = exports['default'];

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormVisual.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormVisual component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);
  var TinyMCE = __webpack_require__(575);
  var constants = __webpack_require__(132);
  var ReportPartFieldPropsContainerSchema = __webpack_require__(555);
  var PropertiesEditorUtils = __webpack_require__(187);

  var EmbedReportPopup = __webpack_require__(1914);
  var ReportPartFormSpellCheck = __webpack_require__(1919);
  var FieldSelectionPopup = __webpack_require__(1920);
  var ReportPartFormDnD = __webpack_require__(970);
  var ReportPartFormWrapper = ReportPartFormDnD(__webpack_require__(1922));
  var reportBodyConstants = __webpack_require__(53);

  var _require = __webpack_require__(1),
      trim = _require.trim,
      find = _require.find,
      isNil = _require.isNil,
      merge = _require.merge,
      getOr = _require.getOr,
      flow = _require.flow;

  var ReportPartFormVisual = React.createClass({
    displayName: 'ReportPartFormVisual',

    propTypes: {
      reportPart: React.PropTypes.object
    },

    handleEditorChange: function handleEditorChange(e) {
      var store = this.props.store;
      var reportPart = this.props.reportPart;
      var reportPartContent = reportPart.reportPartContent;
      var content = e.target.getContent({ no_events: true });

      reportPartContent.setHTMLContent(content, reportPart);
      store.model.markDirty();
    },

    handleClick: function handleClick(event) {
      var props = this.props;
      var selectedElement = event.target;
      var reportPart = this.props.reportPart;

      if (selectedElement.className === 'icon-cancel') {
        var fieldName = trim(selectedElement.parentElement.textContent);

        if (fieldName === reportBodyConstants.FIELD_HIDDEN_LABEL) {
          var fieldNameAttr = $izenda(selectedElement.parentElement).attr('field-name');
          var matches = fieldNameAttr.match(/\[(.*?)\]/g);
          var lastMatched = matches[matches.length - 1].replace('[', '').replace(']', '');
          fieldName = lastMatched;
        }

        var fieldDetail = find({ fieldName: fieldName }, reportPart.fieldCollection);

        if (fieldDetail) {
          var insideColumn = !flow(find({ fieldNameAlias: fieldName }), isNil)(reportPart.reportPartContent.columns.elements);

          reportPart.removeFieldFromContainer(insideColumn ? reportPart.reportPartContent.columns : reportPart.reportPartContent.separators, fieldDetail);
          reportPart.reportPartContent.editorControl.removeElement(selectedElement.parentElement);
        }
        return;
      }

      switch (selectedElement.tagName) {
        case 'FIELD':
          var fieldNameMapping = trim(selectedElement.textContent);
          if (fieldNameMapping === reportBodyConstants.FIELD_HIDDEN_LABEL) {
            var _fieldNameAttr = $izenda(selectedElement).attr('field-name');
            var _matches = _fieldNameAttr.match(/\[(.*?)\]/g);
            var _lastMatched = _matches[_matches.length - 1].replace('[', '').replace(']', '');
            fieldNameMapping = _lastMatched;
          }

          // The issue comes from Microsoft Edge.
          // After the TinyMCT re-init, we could not access to data of old Iframe.
          // The solution: Delete this property to break the reference to old iframe.
          delete reportPart.reportPartContent.selectedFieldElement;
          reportPart.reportPartContent.selectedFieldElement = selectedElement;
          var fieldMapping = find({ fieldName: fieldNameMapping }, reportPart.fieldCollection);

          if (!fieldMapping) {
            return;
          }
          var fieldData = merge(props, {
            itemData: fieldMapping,
            fieldContainerDetails: reportPart.reportPartContent.columns,
            beforeShowProps: function beforeShowProps() {
              reportPart.setConfigField(fieldMapping);
            }
          });
          var propsEditors = [{ name: 'fieldProps', getDefinedSchema: ReportPartFieldPropsContainerSchema }];

          PropertiesEditorUtils.switchToEditor(this, fieldData, propsEditors);
          break;

        case 'EMBEDDED-REPORT':
          this.props.openPopup(EmbedReportPopup, {
            reportPartContent: reportPart.reportPartContent,
            embeddedReportDOM: $izenda(event.target)
          });
          break;
        case 'SUBTOTAL':
          this.props.openPopup(FieldSelectionPopup, {
            store: this.props.store,
            reportPartContent: reportPart.reportPartContent,
            isSubTotal: true,
            selectedElement: this.getSelectionNode()
          });
          break;
        case 'GRANDTOTAL':
          this.props.openPopup(FieldSelectionPopup, {
            store: this.props.store,
            reportPartContent: reportPart.reportPartContent,
            selectedElement: this.getSelectionNode()
          });
          break;
      }
    },

    handleNodeChange: function handleNodeChange(event) {
      var content = this.props.reportPart.reportPartContent || {};
      var properties = content.properties;

      if (event.element.dir === 'ltr') {
        properties.mceDirectionLTR = true;
        properties.mceDirectionRTL = false;
      } else if (event.element.dir === 'rtl') {
        properties.mceDirectionRTL = true;
        properties.mceDirectionLTR = false;
      } else {
        properties.mceDirectionRTL = false;
        properties.mceDirectionLTR = false;
      }

      var isSelectedCell = content.getEditorControl().isSelectedCell;
      content.isSelectedCell = isSelectedCell && isSelectedCell();
    },

    handleFocus: function handleFocus() {
      var content = this.props.reportPart.reportPartContent || {};
      content.isActiveForEdit = true;
    },

    componentDidMount: function componentDidMount() {
      this.setEditorControl();
    },

    // Update the new editor control
    componentDidUpdate: function componentDidUpdate() {
      this.setEditorControl();
    },

    setEditorControl: function setEditorControl() {
      var content = this.props.reportPart.reportPartContent;
      var editor = this.domEditor || {};
      content.setEditorControl(editor);
    },

    getSelectionNode: function getSelectionNode() {
      var controlEditor = getOr({}, 'tinymce', this.domEditor);
      var controlEditorId = getOr({}, 'id', this.domEditor);
      var tinyMCEControl = controlEditor.get && controlEditor.get(controlEditorId);
      return tinyMCEControl && tinyMCEControl.selection.getNode();
    },

    handleFormatChange: function handleFormatChange(value, state) {
      var content = this.props.reportPart.reportPartContent;
      var properties = content.properties;

      for (var key in properties.format) {
        if (properties.format[key].hasOwnProperty(value)) {
          properties.format[key][value] = state;
        }
      }
    },

    handleSpellCheck: function handleSpellCheck(content, startRange, endRange) {
      var reportPart = this.props.reportPart;
      var reportPartContent = reportPart.reportPartContent;
      var htmlContent = reportPartContent.htmlContent;

      var applyChangeContent = function (value) {
        var startIndex = 0;
        var newContent = htmlContent.substring(startIndex, startRange) + value + htmlContent.substring(endRange);
        reportPartContent.setHTMLContent(newContent, reportPart);
        reportPartContent.editorControl.insertContent(value);
      }.bind(this);

      this.props.openPopup(ReportPartFormSpellCheck, {
        onAcceptChange: applyChangeContent.bind(this),
        content: content
      });
    },

    setDom: function setDom(domNode) {
      this.domEditor = domNode;
    },

    render: function render() {
      var startIndex = 0;
      var reportPart = this.props.reportPart || {};
      var reportPartContent = reportPart.reportPartContent;
      reportPartContent.convertRepeaterTag(startIndex, constants.TAB_VISUAL.key);
      var visualChars = getOr(false, 'properties.mceVisualChars', reportPartContent);
      var config = {
        paste_as_text: getOr(false, 'properties.pasteAsText', reportPartContent),
        visual: getOr(true, 'properties.mceToggleVisualAid', reportPartContent)
      };
      var classes = classnames({
        'report-part-form-visual': true
      });
      var id = reportPartContent.formState.id;
      return React.createElement(
        'div',
        { className: classes },
        React.createElement(TinyMCE, {
          ref: this.setDom,
          key: id,
          id: id,
          config: config,
          visualChars: visualChars,
          content: reportPartContent.htmlContent,
          onChange: this.handleEditorChange,
          onClick: this.handleClick,
          onNodeChange: this.handleNodeChange,
          onFocus: this.handleFocus,
          onFormatChange: this.handleFormatChange,
          onSpellCheck: this.handleSpellCheck
        }),
        React.createElement(ReportPartFormWrapper, this.props)
      );
    }
  });

  module.exports = connect()(ReportPartFormVisual);
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1912 */,
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TinyMCEjs" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var PLUGINS = ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'emoticons template paste textcolor colorpicker textpattern imagetools noneditable'];

  module.exports = {
    DEFAULT_CONFIG: {
      branding: false,
      contextmenu: "link image inserttable | cell row column deletetable | spell_checker",
      height: '100%',
      toolbar: false,
      menubar: false,
      resize: false,
      plugins: PLUGINS,
      paste_data_images: true,
      noneditable_noneditable_class: 'field-wrapper',
      valid_elements: '*[*]',
      extended_valid_elements: 'field[class|field-name],field-prop[key|value|type],repeater,embedded-report[id|class],span[class|style],datetime[class],subtotal[class],grandtotal[class],title,script[language|type|src],link[href|rel]',
      body_class: 'izenda-Tinymce',
      content_css: '/izenda-ui.css',
      //force_br_newlines: true,
      //force_p_newlines: false,
      forced_root_block: "div",
      // https://www.tinymce.com/docs/configure/content-filtering/#entity_encoding
      entity_encoding: "raw",
      valid_children: "+body[style|link]"
    },
    EVENTS: ['focusin', 'focusout', 'click', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'mouseover', 'beforepaste', 'paste', 'cut', 'copy', 'selectionchange', 'mouseout', 'mouseenter', 'mouseleave', 'keydown', 'keypress', 'keyup', 'contextmenu', 'dragend', 'dragover', 'draggesture', 'dragdrop', 'drop', 'drag', 'BeforeRenderUI', 'SetAttrib', 'PreInit', 'PostRender', 'init', 'deactivate', 'activate', 'NodeChange', 'BeforeExecCommand', 'ExecCommand', 'show', 'hide', 'ProgressState', 'LoadContent', 'SaveContent', 'BeforeSetContent', 'SetContent', 'BeforeGetContent', 'GetContent', 'VisualAid', 'remove', 'submit', 'reset', 'BeforeAddUndo', 'AddUndo', 'change', 'undo', 'redo', 'ClearUndos', 'ObjectSelected', 'ObjectResizeStart', 'ObjectResized', 'PreProcess', 'PostProcess', 'focus', 'blur', 'dirty'],
    FORMAT_CHANGES: ['alignleft', 'aligncenter', 'alignright', 'alignjustify', 'p', 'blockquote', 'div', 'pre', 'bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'code', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']
  };
}();

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(969);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1918);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmbedReportPopup = function EmbedReportPopup(props) {
  var localization = props.localization;
  return _react2.default.createElement(
    _Izenda2.default,
    { visible: true, onClosing: props.onClosing, autoClose: false, type: 'none' },
    _react2.default.createElement(_Izenda2.default.Header, { title: localization.getText('REPORTDESIGNER_LABEL_EMBEDDED_REPORT_SETTINGS') }),
    _react2.default.createElement(
      _Izenda2.default.Body,
      null,
      _react2.default.createElement(_Izenda4.default, props)
    ),
    _react2.default.createElement(
      _Izenda2.default.Footer,
      null,
      _react2.default.createElement(
        _Izenda2.default.ConfirmationButton,
        { type: 'accept' },
        localization.getText('COMMON_LABEL_OK')
      ),
      _react2.default.createElement(
        _Izenda2.default.ConfirmationButton,
        { type: 'cancel' },
        localization.getText('COMMON_LABEL_CANCEL')
      )
    )
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReportPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda8.default)(_Izenda6.default)(EmbedReportPopup);
module.exports = exports['default'];

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReport.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = __webpack_require__(5);
  var EmbedReportDetail = __webpack_require__(1916);

  function EmbedReport() {
    var props = {
      selectedReport: new EmbedReportDetail()
    };

    m.extendObservable(this, props);
  }

  /**
   * Populate data
   * @param {Object} embed report object
   */
  EmbedReport.prototype.setSelectedReport = function (report) {
    this.selectedReport.populateData(report);
  };

  module.exports = EmbedReport;
}();

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReportDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var EmbedReportPartDetail = __webpack_require__(1917);

  var _require = __webpack_require__(1),
      map = _require.map,
      split = _require.split,
      filter = _require.filter,
      includes = _require.includes;

  function EmbedReportDetail(data) {
    var props = {
      id: null,
      name: null,
      reportParts: [],
      selectedReportParts: [] // List data of EmbedReportPartDetail object
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} embed report detail data
   */
  EmbedReportDetail.prototype.populateData = m.action(function (data) {
    this.id = data.id;
    this.name = data.name;
    this.reportParts = map(function (reportPart) {
      return new EmbedReportPartDetail(reportPart);
    }, data.reportPart);
  });

  /**
   * Populate data
   * @param  {Object} embed report detail data
   */
  EmbedReportDetail.prototype.setSelectedReportPart = m.action(function (ids) {
    var listId = split(',', ids);

    this.selectedReportParts = filter(function (reportPart) {
      return includes(reportPart.id, listId);
    }, this.reportParts);
  });

  module.exports = EmbedReportDetail;
}();

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReportPartDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = __webpack_require__(5);

  function EmbedReportPartDetail(data) {
    var props = {
      id: null,
      title: null,
      width: null,
      height: null
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param {Object} embed report part detail data
   */
  EmbedReportPartDetail.prototype.populateData = m.action(function (data) {
    this.id = data.id;
    this.title = data.title;
    this.width = data.width;
    this.height = data.height;
  });

  module.exports = EmbedReportPartDetail;
}();

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(577);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CANCEL_TEXT = 'cancel';
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReportPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ACCEPT_TEXT = 'accept';

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EmbedReportPopup'), (0, _recompose.withProps)(function () {
  return {
    store: new _Izenda2.default()
  };
}), (0, _recompose.withHandlers)({
  onClosing: (0, _fp.curry)(onClosing)
}));

/**
 * Closing popup
 * @param {Object} props
 * @param {Object} obj
 * @param {string} type
 */

function onClosing(props, obj, type) {
  switch (type) {
    case ACCEPT_TEXT:
      props.reportPartContent.updateEmbeddedReportHtml(props.embeddedReportDOM, props.store.model);
      props.onAccept();
      break;
    case CANCEL_TEXT:
      props.onReject();
      break;
  }
}
module.exports = exports['default'];

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormSpellCheck.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormSpellCheck component
 */
!function () {
  var React = __webpack_require__(0);
  var Popup = __webpack_require__(36);
  var connect = __webpack_require__(2);
  var TinyMCE = __webpack_require__(575);

  var ReportPartFormSpellCheck = React.createClass({
    displayName: 'ReportPartFormSpellCheck',


    propTypes: {
      content: React.PropTypes.string
    },

    onClosing: function onClosing(cb, type) {
      switch (type) {
        case 'accept':
          this.props.onAcceptChange(this.refs.tinyEditor.getContent());
          this.props.onAccept();
          break;
        case 'cancel':
          this.props.onReject();
          break;
      }
    },

    render: function render() {
      var localization = this.props.localization;
      var config = {
        browser_spellcheck: true,
        contextmenu: false,
        statusbar: false,
        plugins: []
      };

      return React.createElement(
        Popup,
        {
          visible: true,
          onClosing: this.onClosing,
          autoClose: false,
          type: 'none'
        },
        React.createElement(Popup.Header, { title: localization.getText("REPORTDESIGNER_LABEL_SPELL_CHECKER") }),
        React.createElement(
          Popup.Body,
          null,
          React.createElement(TinyMCE, {
            id: 'izenda-FormSpellCheck',
            ref: 'tinyEditor',
            config: config,
            content: this.props.content
          })
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localization.getText("COMMON_LABEL_APPLY")
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localization.getText("COMMON_LABEL_CANCEL")
          )
        )
      );
    }
  });

  module.exports = connect()(ReportPartFormSpellCheck);
}();

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1921);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldSelectionPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FieldSelectionPopup = function FieldSelectionPopup(props) {
  var localization = props.localization;
  return _react2.default.createElement(
    _Izenda2.default,
    { visible: true, onClosing: props.onClosing, autoClose: false, type: 'none' },
    _react2.default.createElement(_Izenda2.default.Header, { title: localization.getText('REPORTDESIGNER_LABEL_FIELD_SELECTION') }),
    _react2.default.createElement(
      _Izenda2.default.Body,
      null,
      _react2.default.createElement(
        _Izenda4.default,
        { className: 'form-horizontal' },
        _react2.default.createElement(
          _Izenda4.default.Row,
          { className: 'form-group' },
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '3' },
            localization.getText('COMMON_LABEL_DATA_SOURCE')
          ),
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '9' },
            _react2.default.createElement(_Izenda6.default, {
              options: props.fieldQuerySourceList,
              onChange: props.onChangeDataSouce,
              value: props.selectedQuerySource.id,
              valueField: 'id',
              labelField: 'name'
            })
          )
        ),
        _react2.default.createElement(
          _Izenda4.default.Row,
          { className: 'form-group' },
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '3' },
            localization.getText('COMMON_LABEL_FIELD')
          ),
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '9' },
            _react2.default.createElement(_Izenda6.default, {
              options: props.selectedQuerySource.fields,
              onChange: props.onChangeField,
              value: props.selectedField.name,
              valueField: 'name',
              labelField: 'name'
            })
          )
        )
      )
    ),
    _react2.default.createElement(
      _Izenda2.default.Footer,
      null,
      _react2.default.createElement(
        _Izenda2.default.ConfirmationButton,
        { type: 'accept' },
        localization.getText('COMMON_LABEL_OK')
      ),
      _react2.default.createElement(
        _Izenda2.default.ConfirmationButton,
        { type: 'cancel' },
        localization.getText('COMMON_LABEL_CANCEL')
      )
    )
  );
};

exports.default = (0, _Izenda10.default)(_Izenda8.default)(FieldSelectionPopup);
module.exports = exports['default'];

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldSelectionPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var setDisplayName = __webpack_require__(9).setDisplayName;
  var withState = __webpack_require__(9).withState;
  var withProps = __webpack_require__(9).withProps;
  var withHandlers = __webpack_require__(9).withHandlers;

  var CANCEL_TEXT = 'cancel';
  var ACCEPT_TEXT = 'accept';

  var _require = __webpack_require__(1),
      flow = _require.flow,
      map = _require.map,
      find = _require.find,
      groupBy = _require.groupBy,
      curry = _require.curry;

  var FieldSelectionPopupActions = compose(setDisplayName('FieldSelectionPopup'), withProps(function (props) {
    var _props$reportPartCont = props.reportPartContent,
        columns = _props$reportPartCont.columns,
        separators = _props$reportPartCont.separators;

    var allElements = columns.visibleElement.concat(separators.visibleElement);
    var querySourceGroup = flow(map('field'), map(function (field) {
      return {
        id: field.fieldId,
        name: field.fieldNameAlias
      };
    }), map(function (data) {
      var querySource = find(function (fieldQuerySource) {
        return find(function (f) {
          return f.id === data.id;
        }, fieldQuerySource.fields);
      }, props.store.fieldQuerySource);

      return {
        id: data.id,
        name: data.name,
        querySourceId: querySource.id,
        querySourceName: querySource.name
      };
    }), groupBy('querySourceId'))(allElements);

    var fieldQuerySourceList = [];
    for (var key in querySourceGroup) {
      var querySourceList = querySourceGroup[key];
      var querySource = {
        id: key,
        name: querySourceList[0].querySourceName,
        fields: []
      };
      for (var i = 0; i < querySourceList.length; i++) {
        querySource.fields.push({
          id: querySourceList[i].id,
          name: querySourceList[i].name
        });
      }
      fieldQuerySourceList.push(querySource);
    }

    return {
      fieldQuerySourceList: fieldQuerySourceList
    };
  }), withState('selectedQuerySource', 'updateSelectedQuerySource', function (props) {
    return props.fieldQuerySourceList.length > 0 ? props.fieldQuerySourceList[0] : {};
  }), withState('selectedField', 'updateSelectedField', function (props) {
    return props.fieldQuerySourceList.length > 0 ? props.fieldQuerySourceList[0].fields[0] : {};
  }), withHandlers({
    onChangeDataSouce: curry(onChangeDataSouce),
    onChangeField: curry(onChangeField),
    onClosing: curry(onClosing)
  }));

  /**
   * OnChange data source
   * @param {Object} properties
   * @param {Object} data
   * @param {Object} selected query source
   */
  function onChangeDataSouce(props, data, selectedQuerySource) {
    props.updateSelectedQuerySource(selectedQuerySource);
    props.updateSelectedField(selectedQuerySource.fields[0]);
  }

  /**
   * OnChange field
   * @param {Object} properties
   * @param {String} id
   * @param {Object} selected field
   */
  function onChangeField(props, id, selectedField) {
    props.updateSelectedField(selectedField);
  }

  /**
   * Closing popup
   * @param {Object} props
   * @param {Object} data
   * @param {String} type
   */
  function onClosing(props, obj, type) {
    switch (type) {
      case ACCEPT_TEXT:
        if (props.isSubTotal) {
          props.reportPartContent.updateSubTotalHtml(props.selectedField.name, props.selectedElement);
          props.reportPartContent.rebuildHTMLContent(false);
        } else {
          props.reportPartContent.updateGrandTotalHtml(props.selectedField.name, props.selectedElement);
        }

        props.onAccept();
        break;
      case CANCEL_TEXT:
        props.onReject();
        break;
    }
  }

  module.exports = FieldSelectionPopupActions;
}();

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormWrapper.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ReportPartFormWrapper = function ReportPartFormWrapper(_ref) {
  var canDrop = _ref.canDrop;

  var classes = canDrop ? 'izenda-Wrapper can-drop' : '';

  return _react2.default.createElement('div', { className: classes });
};

exports.default = (0, _mobxReact.observer)(ReportPartFormWrapper);
module.exports = exports['default'];

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormHTML.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormHTML component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);
  var EventsUtils = __webpack_require__(24);
  var CodeMirror = __webpack_require__(1924);
  var constants = __webpack_require__(132);

  var _require = __webpack_require__(1),
      getOr = _require.getOr;

  var ReportPartFormHTML = React.createClass({
    displayName: 'ReportPartFormHTML',

    propTypes: {
      reportPart: React.PropTypes.object
    },

    handleChange: function handleChange(value) {
      var store = this.props.store;
      var reportPart = this.props.reportPart;
      var reportPartContent = reportPart.reportPartContent;

      reportPartContent.setHTMLContent && reportPartContent.setHTMLContent(value);
      store.model.markDirty();
    },

    componentDidMount: function componentDidMount() {
      var content = this.props.reportPart.reportPartContent;
      var editor = this.refs.codeEditor || {};
      content.setEditorControl(editor);
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var reportPartContent = this.props.reportPart.reportPartContent;
      reportPartContent.convertRepeaterTag(0, constants.TAB_HTML.key);
      var useCodeMirror = getOr(true, 'properties.highlightCode', reportPartContent);
      var options = {
        lineNumbers: true,
        lineWrapping: getOr(true, 'properties.wrapText', reportPartContent),
        mode: 'text/html',
        highlightSelectionMatches: true,
        indentUnit: 2,
        matchBrackets: true
      };

      var classes = classnames('report-part-form-html', { 'can-drop': this.props.canDrop });

      return React.createElement(
        'div',
        { className: classes },
        useCodeMirror ? React.createElement(CodeMirror, {
          onChange: this.handleChange,
          value: reportPartContent.htmlContent,
          reportPartContent: reportPartContent,
          options: options,
          ref: 'codeEditor' }) : React.createElement('textarea', { name: 'form',
          onChange: notifyChange(this.handleChange, EventsUtils.INPUT),
          defaultValue: reportPartContent.htmlContent })
      );
    }
  });

  module.exports = observer(ReportPartFormHTML);
}();

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CodeMirror.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CodeMirror component
 */
!function () {
  var React = __webpack_require__(0);
  var CodeMirrorExt = __webpack_require__(1925);

  var CodeMirror = React.createClass({
    displayName: 'CodeMirror',


    propTypes: {
      value: React.PropTypes.string,
      defaultValue: React.PropTypes.string,
      className: React.PropTypes.string,
      onChange: React.PropTypes.func,
      options: React.PropTypes.object,
      reportPartContent: React.PropTypes.object
    },

    getCodeMirror: function getCodeMirror() {
      return this.codeMirror;
    },

    componentDidMount: function componentDidMount() {
      var textareaNode = this.refs.textarea;

      this.codeMirror = CodeMirrorExt.fromTextArea(textareaNode, this.props.options);
      this.codeMirror.on('change', this.handleChange);
      this.codeMirror.setValue(this.props.defaultValue || this.props.value || '');

      !!this.props.reportPartContent.isFormatted && this.codeMirror.autoFormatAll();
    },

    handleChange: function handleChange(doc, change) {
      if (this.props.onChange && change.origin != 'setValue') {
        this.props.onChange(doc.getValue());
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      if (this.codeMirror) {
        this.codeMirror.toTextArea();
      }
    },

    searchCode: function searchCode(text) {
      return this.codeMirror.searchCode(text);
    },

    replaceCode: function replaceCode(text, replace) {
      return this.codeMirror.replaceCode(text, replace);
    },

    insertContent: function insertContent(text) {
      this.codeMirror.replaceSelection(text);
      this.codeMirror.setCursor(this.codeMirror.getCursor());
    },

    execCommand: function execCommand(cmd) {
      switch (cmd) {
        case 'Undo':
          this.codeMirror.execCommand('undo');
          break;
        case 'Redo':
          this.codeMirror.execCommand('redo');
          break;
        case 'Reformat':
          this.props.reportPartContent.markFormated();
          this.codeMirror.autoFormatAll();
          break;
      }
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (this.codeMirror && nextProps.value !== undefined && this.codeMirror.getValue() != nextProps.value) {

        this.codeMirror.setValue(nextProps.value);
      }

      if (this.codeMirror && nextProps.options !== this.props.options) {
        this.codeMirror.setOption('lineWrapping', nextProps.options.lineWrapping);
      }
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'izenda-CodeMirror' },
        React.createElement('textarea', {
          ref: 'textarea',
          name: this.props.path,
          defaultValue: this.props.value,
          onChange: this.valueChanged,
          autoComplete: 'off' })
      );
    }
  });

  module.exports = CodeMirror;
}();

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CodeMirrorExt.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var CodeMirror = __webpack_require__(189);
  __webpack_require__(1926);
  __webpack_require__(1930);
  __webpack_require__(971);

  var lastPos = null;
  var lastQuery = null;
  var marked = [];

  function unmark() {
    for (var i = 0; i < marked.length; ++i) {
      marked[i].clear();
    }
    marked = [];
  }

  CodeMirror.extendMode("xml", {
    commentStart: "<!--",
    commentEnd: "-->",
    newlineAfterToken: function newlineAfterToken(type, content, textAfter) {
      return type == "tag" && />$/.test(content) || /^</.test(textAfter);
    }
  });

  // CodeMirror autoFormat extension, inserts newlines and identation according to settings
  // formats a range given from: {line, ch}, to: {line, ch}
  CodeMirror.defineExtension("autoFormatRange", function (from, to) {
    var cm = this;
    var outer = cm.getMode(),
        text = cm.getRange(from, to).split("\n");
    var state = CodeMirror.copyState(outer, cm.getTokenAt(from).state);
    var tabSize = cm.getOption("tabSize");

    var out = "",
        lines = 0,
        atSol = from.ch === 0;

    function newline() {
      out += "\n";
      atSol = true;
      ++lines;
    }

    for (var i = 0; i < text.length; ++i) {
      var stream = new CodeMirror.StringStream(text[i], tabSize);
      while (!stream.eol()) {
        var inner = CodeMirror.innerMode(outer, state);
        var style = outer.token(stream, state),
            cur = stream.current();
        stream.start = stream.pos;
        if (!atSol || /\S/.test(cur)) {
          out += cur;
          atSol = false;
        }
        if (!atSol && inner.mode.newlineAfterToken && inner.mode.newlineAfterToken(style, cur, stream.string.slice(stream.pos) || text[i + 1] || "", inner.state)) {
          newline();
        }
      }
      if (!stream.pos && outer.blankLine) {
        outer.blankLine(state);
      }
      if (!atSol) {
        newline();
      }
    }

    cm.operation(function () {
      cm.replaceRange(out, from, to);
      for (var cur = from.line + 1, end = from.line + lines; cur <= end; ++cur) {
        cm.indentLine(cur, "smart");
      }
    });
  });

  // Gets full content range for given CodeMirror editor
  // @return Range object {from: {line, ch}, to: {line, ch}}
  CodeMirror.defineExtension("getFullRange", function () {
    var cm = this;
    var from, to;
    from = { line: 0, ch: 0 };
    to = cm.posFromIndex(cm.getValue().length);
    return {
      from: from,
      to: to
    };
  });

  // Extension to use autoFormatRange for the whole document
  CodeMirror.defineExtension("autoFormatAll", function () {
    var cm = this;
    var range = cm.getFullRange();
    cm.autoFormatRange(range.from, range.to);
  });

  CodeMirror.defineExtension("searchCode", function (text) {
    var cm = this;
    unmark();

    if (!cm.getSearchCursor(text).findNext()) {
      return false;
    }

    for (var _cursor = cm.getSearchCursor(text); _cursor.findNext();) {
      marked.push(cm.markText(_cursor.from(), _cursor.to(), "searched"));
    }

    if (lastQuery != text) {
      lastPos = null;
    }

    var cursor = cm.getSearchCursor(text, lastPos || cm.getCursor());
    if (!cursor.findNext()) {
      cursor = cm.getSearchCursor(text);
      if (!cursor.findNext()) {
        return;
      }
    }

    cm.setSelection(cursor.from(), cursor.to());
    lastQuery = text;
    lastPos = cursor.to();
  });

  CodeMirror.defineExtension("replaceCode", function (text, replace) {
    var cm = this;
    unmark();

    if (!cm.getSearchCursor(text).findNext()) {
      return false;
    }

    for (var cursor = cm.getSearchCursor(text); cursor.findNext();) {
      cm.replaceRange(replace, cursor.from(), cursor.to());
    }
  });

  module.exports = CodeMirror;
}();

/***/ }),
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormFrontSide.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormFrontSide component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = __webpack_require__(5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(97);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(577);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1933);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(35);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(539);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(1935);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(53);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var NUMBER_ZERO = 0;
var NUMBER_ONE = 1;

var ReportPartFormFrontSide = (_dec = (0, _Izenda2.default)(), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(ReportPartFormFrontSide, _Component);

  function ReportPartFormFrontSide() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportPartFormFrontSide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportPartFormFrontSide.__proto__ || (0, _getPrototypeOf2.default)(ReportPartFormFrontSide)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'loadedData', _descriptor, _this), _initDefineProp(_this, 'resultHTMLCode', _descriptor2, _this), _this.setDom = function (dom) {
      _this.domNode = dom;
    }, _this.goToPage = function (pageIndex) {
      var _this2 = _this,
          props = _this2.props,
          _this2$props = _this2.props,
          reportPart = _this2$props.reportPart,
          previewRecords = _this2$props.previewRecords;

      props.needUpdatePreview(reportPart, null, pageIndex, null, null, previewRecords);
    }, _this.onPageSizeChange = function (pageSize) {
      var _this3 = _this,
          props = _this3.props,
          _this3$props = _this3.props,
          reportPart = _this3$props.reportPart,
          previewRecords = _this3$props.previewRecords,
          reportPartContent = _this3$props.reportPart.reportPartContent;

      reportPartContent.changePageSize(pageSize);
      props.needUpdatePreview(reportPart, null, NUMBER_ONE, null, null, previewRecords);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReportPartFormFrontSide, [{
    key: 'triggerGenerateHTMLCode',
    value: function triggerGenerateHTMLCode() {
      var _this4 = this;

      this.generateHTMLCode().then(function (result) {
        _this4.resultHTMLCode = result;
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this5 = this;

      var props = this.props,
          reportPart = this.props.reportPart;


      var reportPartContent = reportPart.reportPartContent;

      // all ready set data tree don't need to update again
      if (!reportPartContent.dataTree) {
        var dataTree = (0, _fp.get)('store.model.dataTree', props);

        if (dataTree) {
          reportPartContent.setDataTree(dataTree);
        } else {
          var reportId = reportPart.reportId;
          var formStore = new _Izenda10.default(reportPart, (0, _fp.get)('store.reportStore.isLoadDraft', props));

          formStore.loadDataTree(reportId);
        }
      }

      this.embedReportStore = new _Izenda8.default();
      this.disposeObserveLoadDataSource = (0, _mobx.observe)(reportPartContent.dataTree, 'hasLoadDataSource', function (change) {
        change && _this5.triggerGenerateHTMLCode();
      });
      this.disposeObserveLoadRecords = (0, _mobx.observe)(reportPart, 'previewDataRecords', function () {
        _this5.triggerGenerateHTMLCode();
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this6 = this;

      this.generateHTMLCode().then(function (result) {
        _this6.loadedData = true;
        _this6.resultHTMLCode = result;
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.refreshData && this.props.refreshData(false);
      this.props.loader.endLoading();
      this.disposeObserveLoadDataSource();
      this.disposeObserveLoadRecords();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var props = this.props,
          reportPart = this.props.reportPart;


      var records = (0, _fp.getOr)([], 'previewDataRecords', reportPart);

      this.domNode && $izenda(this.domNode).off('click', '[data-hyperlinkaction=true]').on('click', '[data-hyperlinkaction=true]', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var $link = $izenda(e.currentTarget);
        var linkData = $link.data();
        var parse = (0, _fp.flow)(decodeURI, JSON.parse);
        var record = records[parseInt(linkData.recordindex, 10)];
        var selectedFieldName = parse(linkData.selectedfieldname);
        var isOpenCustomURLDirectly = linkData.isCustomURL;
        var isOpenEmbeddedJavascriptDirectly = linkData.isEmbeddedJavascript;

        var selectedField = (0, _fp.find)(function (field) {
          return field.fieldName === selectedFieldName;
        }, reportPart.fieldCollection);

        var fieldProperties = (0, _fp.getOr)({}, 'properties', selectedField);
        var subReport = (0, _fp.get)('subReport', fieldProperties);
        var customURL = (0, _fp.get)('customURL', fieldProperties);
        var embeddedJavascript = (0, _fp.get)('embeddedJavascript', fieldProperties);
        var numberOfPointActions = (0, _fp.get)('numberOfPointActions', selectedField);

        var fieldConfig = {
          subReport: subReport,
          customURL: customURL,
          embeddedJavascript: embeddedJavascript,
          numberOfPointActions: numberOfPointActions,
          fieldElement: selectedField
        };

        if (isOpenCustomURLDirectly) {
          _Izenda12.default.openCustomURL(props, customURL, [record]);
        } else if (isOpenEmbeddedJavascriptDirectly) {
          _Izenda12.default.performEmbeddedJavascript(props, customURL, [record]);
        } else {
          _Izenda12.default.openHyperlinkAction(props, fieldConfig, [record], _Izenda14.default);
        }
      });

      this.domNode && this.updateStyle();
    }
  }, {
    key: 'updateStyle',
    value: function updateStyle() {
      this.updateTableStyle();
      this.updateContainerStyle();
    }
  }, {
    key: 'updateTableStyle',
    value: function updateTableStyle() {
      $izenda(this.domNode).find('table').each(function (index, item) {
        var padding = parseInt($izenda(item).attr('cellpadding'));
        var spacing = parseInt($izenda(item).attr('cellspacing'));

        $izenda(item).css('border-spacing', spacing);
        $izenda('th,td', item).css('padding', padding);
      });
    }
  }, {
    key: 'updateContainerStyle',
    value: function updateContainerStyle() {
      var _props = this.props,
          embededReportPart = _props.embededReportPart,
          frontSidePartRef = _props.frontSidePartRef,
          reportPart = _props.reportPart;

      if (embededReportPart && !(0, _fp.isNil)(frontSidePartRef)) {
        var containerHeight = reportPart.height * _Izenda18.default.BODY_CELL_HEIGHT;
        var contentHeight = containerHeight > this.domNode.offsetHeight ? this.domNode.offsetHeight : containerHeight;
        frontSidePartRef.style.height = contentHeight + 'px';
      }
    }
  }, {
    key: 'generateHTMLCode',
    value: function generateHTMLCode() {
      var props = this.props,
          _props2 = this.props,
          store = _props2.store,
          reportPart = _props2.reportPart,
          _props2$reportPart = _props2.reportPart,
          reportPartContent = _props2$reportPart.reportPartContent,
          previewData = _props2$reportPart.previewData;


      var reportId = (0, _fp.get)('reportId', store) || reportPart.reportId;
      var records = (0, _fp.getOr)([], 'previewDataRecords', reportPart);
      var fieldsMapping = (0, _fp.getOr)([], 'fieldsMapping', previewData);
      var subTotalMapping = (0, _fp.getOr)([], 'subTotalMapping', previewData);
      var grandTotalMapping = (0, _fp.getOr)([], 'grandTotalMapping', previewData);

      return reportPartContent.generatePreviewData(props, fieldsMapping, subTotalMapping, grandTotalMapping, records, this.embedReportStore.model, reportId);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props,
          _props3 = this.props,
          viewMode = _props3.viewMode,
          reportPart = _props3.reportPart,
          _props3$reportPart = _props3.reportPart,
          reportPartContent = _props3$reportPart.reportPartContent,
          previewData = _props3$reportPart.previewData,
          printingMode = _props3.printingMode,
          finishedRender = _props3.finishedRender,
          embededReportPart = _props3.embededReportPart,
          forDashboard = _props3.forDashboard;


      var properties = (0, _fp.getOr)({}, 'properties', reportPartContent);

      var formStyles = properties.isVisibleBorder ? {
        borderStyle: properties.borderStyle,
        borderColor: properties.borderColor,
        borderWidth: properties.borderWidth
      } : {};

      formStyles.backgroundColor = properties.backgroundColor;

      var paging = (0, _fp.getOr)({}, 'paging', previewData);
      var classes = (0, _classnames2.default)('u_clearBoth with-border', { hide: !properties.usePagination });

      // refresh data intervals
      props.refreshData && props.refreshData(true);

      return _react2.default.createElement(
        'div',
        { ref: this.setDom },
        _react2.default.createElement(
          _Izenda16.default,
          {
            embeddedReports: this.resultHTMLCode.embeddedReports,
            embeddedSubReports: this.resultHTMLCode.embeddedSubReports,
            masterDomNode: this.domNode,
            finishGetData: this.loadedData,
            viewHeight: reportPart.height * _Izenda18.default.BODY_CELL_HEIGHT,
            printingMode: printingMode,
            finishedRender: finishedRender,
            embededReportPart: embededReportPart,
            viewMode: viewMode,
            forDashboard: forDashboard
          },
          _react2.default.createElement('div', {
            className: 'report-part-form-front custom-tinymce izenda-ResetCssForm',
            style: formStyles,
            dangerouslySetInnerHTML: { __html: this.resultHTMLCode.htmlContent }
          })
        ),
        !printingMode && _react2.default.createElement(_Izenda4.default, {
          onChange: this.goToPage,
          onDropdownChange: this.onPageSizeChange,
          totalRecords: paging.total || NUMBER_ZERO,
          pageSize: paging.pageSize || _Izenda6.default.DEFAULT_PAGE_SIZE,
          pageIndex: paging.pageIndex || _Izenda6.default.DEFAULT_PAGE_INDEX,
          className: classes,
          canChangePageSize: !viewMode
        })
      );
    }
  }]);
  return ReportPartFormFrontSide;
}(_react.Component), _class3.propTypes = {
  reportPart: _propTypes2.default.object
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'loadedData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'resultHTMLCode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      embeddedReports: [],
      embeddedSubReports: [],
      htmlContent: ''
    };
  }
})), _class2)) || _class);
exports.default = ReportPartFormFrontSide;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Fields View Model
 */
!function () {
  var fetcher = __webpack_require__(90);
  var ReportDesignerDataTree = __webpack_require__(578);

  function ReportPartFormStore(reportPart) {
    this.reportDesignerDataTree = new ReportDesignerDataTree();
    reportPart.reportPartContent.setDataTree(this.reportDesignerDataTree);
  }

  ReportPartFormStore.prototype.loadDataTree = function (reportId, isLoadDraft) {
    var dataTreeModel = this.reportDesignerDataTree;

    return fetcher.availableQuerySourceFields(reportId, isLoadDraft).then(dataTreeModel.readDataSource.bind(dataTreeModel));
  };

  module.exports = ReportPartFormStore;
}();

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerQuerySourceDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(223);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(272);

var _Izenda4 = __webpack_require__(54);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(91);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportDesignerQuerySourceDetail = (0, _Izenda5.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(ReportDesignerQuerySourceDetail, [{
    key: 'aliasId',
    get: function get() {
      return this.id + '_' + this.name;
    }
  }, {
    key: 'isStoreProcedure',
    get: function get() {
      return this.type === _Izenda6.NODE_TYPE.STORE_PROCEDURE;
    }
  }, {
    key: 'flattenQuerySource',
    get: function get() {
      var querySourceDetail = this;
      var category = this.name;

      return (0, _fp.flow)((0, _fp.filter)(function (item) {
        return item.izendaDataType !== _Izenda7.DATA_TYPES.LOB && item.izendaDataType !== _Izenda7.DATA_TYPES.IMAGE && item.izendaDataType !== _Izenda7.DATA_TYPES.BOOLEAN;
      }), (0, _fp.map)(function (item) {
        return {
          field: item,
          querySourceDetail: querySourceDetail,
          name: item.name,
          id: item.id,
          category: category
        };
      }))(this.fields);
    }
  }]);

  function ReportDesignerQuerySourceDetail(detail) {
    (0, _classCallCheck3.default)(this, ReportDesignerQuerySourceDetail);

    _initDefineProp(this, 'id', _descriptor, this);

    _initDefineProp(this, 'name', _descriptor2, this);

    _initDefineProp(this, 'originalName', _descriptor3, this);

    _initDefineProp(this, 'type', _descriptor4, this);

    _initDefineProp(this, 'selected', _descriptor5, this);

    _initDefineProp(this, 'visible', _descriptor6, this);

    _initDefineProp(this, 'querySourceCategoryName', _descriptor7, this);

    _initDefineProp(this, 'connectionName', _descriptor8, this);

    _initDefineProp(this, 'isAlias', _descriptor9, this);

    _initDefineProp(this, 'fields', _descriptor10, this);

    _initDefineProp(this, 'functionName', _descriptor11, this);

    _initDefineProp(this, 'expression', _descriptor12, this);

    _initDefineProp(this, 'izendaDataType', _descriptor13, this);

    _initDefineProp(this, 'dataSourceCategoryId', _descriptor14, this);

    _initDefineProp(this, 'dataSourceCategoryName', _descriptor15, this);

    _initDefineProp(this, 'numOfChilds', _descriptor16, this);

    _initDefineProp(this, 'isDynamic', _descriptor17, this);

    _initDefineProp(this, 'allowToSave', _descriptor18, this);

    this.expand = false;
    this.populateData(detail || {});
    this.resetDirty();
  }

  /**
   * Populate data
   * @param {any} detail
   */


  (0, _createClass3.default)(ReportDesignerQuerySourceDetail, [{
    key: 'populateData',
    value: function populateData(detail) {
      this.id = detail.id || null;
      this.name = detail.name || '';
      this.originalName = detail.originalName || '';
      this.type = detail.type || '';
      this.selected = detail.selected || false;
      this.visible = detail.visible || false;
      this.querySourceCategoryName = detail.querySourceCategoryName || '';
      this.connectionName = detail.connectionName || '';
      this.isAlias = detail.isAlias || false;
      this.fields = detail.fields || [];
      this.functionName = detail.functionName || '';
      this.expression = detail.expression || '';
      this.izendaDataType = detail.izendaDataType || '';
      this.dataSourceCategoryId = detail.dataSourceCategoryId || null;
      this.dataSourceCategoryName = detail.dataSourceCategoryName || '';
      this.numOfChilds = detail.numOfChilds || 0;
      this.isDynamic = detail.isDynamic || false;
      this.expand = detail.expand || false;
      this.allowToSave = detail.allowToSave || false;
    }

    /**
     * Update data
     * @param {any} detail
     */

  }, {
    key: 'updateData',
    value: function updateData(detail) {
      var field = (0, _fp.find)({ id: detail.id }, this.fields);

      if (field) {
        (0, _Izenda2.default)(field, 'name', detail.name);
        (0, _Izenda2.default)(field, 'expression', detail.expression);
        (0, _Izenda2.default)(field, 'izendaDataType', detail.izendaDataType);

        this.markDirty();

        return this;
      }
      return null;
    }

    /**
     * Check existing field name
     */

  }, {
    key: 'checkExistingFieldName',
    value: function checkExistingFieldName(id, newValue) {
      var elements = (0, _fp.filter)(function (element) {
        return element.name === newValue && element.id !== id;
      }, this.fields);

      return elements && elements.length > 0;
    }
  }]);
  return ReportDesignerQuerySourceDetail;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'originalName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'selected', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'visible', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'querySourceCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'connectionName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'isAlias', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'fields', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'functionName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'expression', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'izendaDataType', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'dataSourceCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'dataSourceCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'numOfChilds', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'isDynamic', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'allowToSave', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'aliasId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'aliasId'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isStoreProcedure', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isStoreProcedure'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'flattenQuerySource', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'flattenQuerySource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateData'), _class2.prototype)), _class2)) || _class;

exports.default = ReportDesignerQuerySourceDetail;
module.exports = exports['default'];

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(179);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(208);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(76);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(262);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(1936);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(1937);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.VirtualFormFrontSide.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var DEFAULT_SCROLL_THROTTLE = 150;
// $FlowFixMe


var NUMBER_ZERO = 0;
var NUMBER_ONE = 1;
var NUMBER_THREE = 3;
var ReportPartFormBackSide = (_dec = (0, _Izenda4.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartFormBackSide, _Component);

  function ReportPartFormBackSide(props) {
    (0, _classCallCheck3.default)(this, ReportPartFormBackSide);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartFormBackSide.__proto__ || (0, _getPrototypeOf2.default)(ReportPartFormBackSide)).call(this, props));

    _initialiseProps.call(_this);

    _this.store = new _Izenda12.default(props.viewHeight);
    return _this;
  }

  (0, _createClass3.default)(ReportPartFormBackSide, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollParent = _Izenda10.default.findScrollableParent(this.virtualForm);
      var throttleScroll = (0, _fp.debounce)({ maxWait: DEFAULT_SCROLL_THROTTLE * NUMBER_THREE }, this.onScroll);
      scrollParent && scrollParent.addEventListener('scroll', throttleScroll, {
        capture: false,
        passive: true
      });
      this.props.embededReportPart && this.publishFinishedRender();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.store.cleanUp();
      this.store.updateItems(this.getData());
      this.renderReports(NUMBER_ZERO);
      this.publishFinishedRender();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _fp.forEach)(_reactDom2.default.unmountComponentAtNode.bind(_reactDom2.default), this.needUnmount);
      (0, _fp.forEach)(function (listener) {
        _Izenda6.default.removeListener(listener.element, listener.listener);
      }, this.elementResizeListener);
      this.needUnmount = [];
      this.elementResizeListener = [];
    }

    /**
     * create context provider for ReportPartViewer
     * @param {Object} context
     */

  }, {
    key: 'createContextProvider',
    value: function createContextProvider(context) {
      return _react2.default.createClass({
        childContextTypes: {
          loader: _react2.default.PropTypes.object,
          dialogs: _react2.default.PropTypes.object,
          exportLoader: _react2.default.PropTypes.object,
          validation: _react2.default.PropTypes.object,
          authorization: _react2.default.PropTypes.object,
          authorizationConstants: _react2.default.PropTypes.object,
          localization: _react2.default.PropTypes.object
        },
        getChildContext: function getChildContext() {
          return {
            loader: context.loader,
            exportLoader: context.exportLoader,
            dialogs: context.dialogs,
            validation: context.validation,
            authorization: context.authorization,
            authorizationConstants: context.authorizationConstants,
            localization: context.localization
          };
        },
        render: function render() {
          return this.props.children;
        }
      });
    }

    /**
     * SetDom
     * @param  {Object} dom
     */


    /**
     * Get list of report part embedded
     * @return {Array}
     */


    /**
     * Call finish render
     */


    /**
     * render embedded Reports
     * @param {Array} embeddedReports
     */

  }, {
    key: 'checkNextRendering',


    /**
     * Check next render report part
     * @param  {Object} report:                [description]
     * @param  {Number} index:      number        [description]
     * @param  {String} listenerId: string        [description]
     */
    value: function checkNextRendering(report, index, listenerId) {
      var store = this.store;
      var reportPartDomId = report.reportPartDomId;
      if (!store.checkRenderedItem(reportPartDomId)) {
        store.updateRenderedIds(reportPartDomId);
        if (this.props.printingMode) {
          _Izenda8.default.getFinishedRenderPromiseById(this.renderListeners, listenerId);
          this.renderReports(index + NUMBER_ONE);
        } else {
          var reportDOM = this.reportDom;
          var hasVacancy = store.hasVacancy((0, _fp.get)('offsetHeight', reportDOM), report.reportPartDomId, index);
          if (hasVacancy) {
            this.renderReports(index + NUMBER_ONE);
          } else {
            store.updateVirtualSections();
            !(0, _fp.isEmpty)(store.virtualSections) && this.renderReports(NUMBER_ZERO);
          }
        }
      }
    }

    /**
     * set height for Embedded SubReport after finished rendering
     * @param {Object} domObject
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { ref: function ref(node) {
            return _this2.virtualForm = node;
          } },
        this.props.children
      );
    }
  }]);
  return ReportPartFormBackSide;
}(_react.Component), _class2.propTypes = {
  embeddedReports: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  embeddedSubReports: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  finishGetData: _propTypes2.default.bool,
  viewHeight: _propTypes2.default.number,
  printingMode: _propTypes2.default.bool
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.needUnmount = [];
  this.renderListeners = [];
  this.elementResizeListener = [];
  this.virtualForm = null;
  this.reportDom = null;

  this.setDom = function (dom) {
    _this3.reportDom = dom;
  };

  this.onScroll = function (scrollEvent) {
    var store = _this3.store;
    var scrollTop = scrollEvent.target.scrollTop;
    var reports = store.getItemsOnViewScreen();
    var firstReport = (0, _fp.head)(reports);
    var firstReportId = (0, _fp.get)('reportPartDomId', firstReport);

    // only render the first report if it has not rendered
    if (store.hasVirtualSection(scrollTop) && store.virtualSections.length === NUMBER_ONE && !store.checkRenderedItem(firstReportId)) {
      _this3.renderReports(NUMBER_ZERO);
    }
  };

  this.getData = function () {
    var props = _this3.props;
    return props.finishGetData ? (0, _fp.flow)(_mobx.toJS, (0, _fp.concat)((0, _mobx.toJS)(props.embeddedSubReports)))(props.embeddedReports) : [];
  };

  this.publishFinishedRender = function () {
    var props = _this3.props;

    _Izenda8.default.publishFinishedRender(_this3.renderListeners, function () {
      props.finishedRender && props.finishedRender();
    });
  };

  this.renderReports = function (startIndex) {
    var store = _this3.store;
    var reports = store.getItemsOnViewScreen();
    var report = reports[startIndex];

    if (!(0, _fp.isEmpty)(reports) && startIndex < store.items.length && !(0, _fp.isNil)(report)) {
      // get Context for ReportPartViewer
      var ContextProvider = _this3.createContextProvider(_Izenda2.default.createAppContext());
      var renderListeners = _this3.renderListeners;
      var $masterDomNode = $izenda(_this3.props.masterDomNode);

      // get list of embedded reports via className
      var embededReport = $masterDomNode.find('.' + report.reportPartDomId).get(NUMBER_ZERO);
      if (!embededReport) {
        return;
      }

      var listenerId = startIndex + '.' + report.reportPartDomId;
      _Izenda8.default.pushRenderListener(renderListeners, listenerId);
      var afterRenderCallBack = _this3.afterRenderCallBack.bind(null, embededReport);

      var isSubReport = (0, _fp.has)('fieldInfo', report);
      var restProps = void 0;
      if (isSubReport) {
        restProps = {
          reportPartDef: report.reportPartDef,
          subReportFilter: report.queryObject,
          fieldInfo: report.fieldInfo
        };
      } else {
        restProps = {
          reportPartId: report.id,
          containerWidth: report.width,
          containerHeight: report.height
        };
      }

      _reactDom2.default.render(_react2.default.createElement(
        ContextProvider,
        null,
        _react2.default.createElement(_Izenda14.default, (0, _extends3.default)({
          ref: _this3.setDom,
          notInvokeRenderCallBackAfterDidMount: true,
          printingMode: _this3.props.printingMode,
          afterRenderCallBack: afterRenderCallBack,
          finishedRender: _this3.checkNextRendering.bind(_this3, report, startIndex, listenerId),
          viewMode: _this3.props.viewMode,
          forDashboard: _this3.props.forDashboard
        }, restProps))
      ), embededReport);

      _this3.needUnmount.push(embededReport);
    } else {
      store.stop();
    }
  };

  this.afterRenderCallBack = function (domObject) {
    var props = _this3.props;
    var frontSideViewer = domObject.querySelector('.izenda-ReportPartFrontSideViewer-container');
    var listener = (0, _fp.find)({ id: domObject.id }, _this3.elementResizeListener);

    if (listener) {
      _Izenda6.default.removeListener(listener.element, listener.listener);
      _this3.elementResizeListener = (0, _fp.remove)(listener, _this3.elementResizeListener);
    }
    if (frontSideViewer) {
      listener = {
        element: frontSideViewer,
        listener: _Izenda6.default.listenTo(frontSideViewer, function () {
          // Only update table width when the container has been resized.
          domObject.style.height = props.printingMode ? '100%' : frontSideViewer.offsetHeight + 'px';
        })
      };
      _this3.elementResizeListener = (0, _fp.concat)([listener], _this3.elementResizeListener);
    }
  };
}, _temp)) || _class);
exports.default = ReportPartFormBackSide;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.VirtualFormFrontSideStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var DEFAULT_FIRST_VIEW_HEIGHT_RATIO = 10;
var DEFAULT_VIEW_HEIGHT_RATIO = 1;
var HEIGHT_BUFFER = 50;

// $FlowFixMe

var VirtualFormFrontSideStore = function () {
  function VirtualFormFrontSideStore(viewHeight) {
    (0, _classCallCheck3.default)(this, VirtualFormFrontSideStore);
    this.first = true;
    this.rendered = false;
    this.items = [];
    this.viewHeight = 0;
    this.heightForRender = 0;
    this.heightTotal = 0;
    this.heightTotalOnAViewScreen = 0;
    this.startIndex = 0;
    this.renderedIds = [];
    this.virtualSections = [];

    this.viewHeight = viewHeight;
    this.heightForRender = viewHeight;
  }

  /**
   * get container height
   * @returns {Number} container height
   */
  // When the cursor is scrolled to this position, it will render for new items


  (0, _createClass3.default)(VirtualFormFrontSideStore, [{
    key: 'getContainerHeight',
    value: function getContainerHeight() {
      return this.first ? this.viewHeight * DEFAULT_FIRST_VIEW_HEIGHT_RATIO : this.viewHeight * DEFAULT_VIEW_HEIGHT_RATIO;
    }

    /**
     * get items on screen
     * @returns {Array} items
     */

  }, {
    key: 'getItemsOnViewScreen',
    value: function getItemsOnViewScreen() {
      return this.first ? this.items : (0, _fp.slice)(this.startIndex, this.items.length, this.items);
    }

    /**
     * has vacancy
     * @param {Number} height
     * @param {String} reportPartDomId
     * @param {Number} index
     * @returns {Boolean} has vacancy
     */

  }, {
    key: 'hasVacancy',
    value: function hasVacancy(height, reportPartDomId) {
      this.heightTotal += height;
      this.heightTotalOnAViewScreen += height;

      if (this.heightTotalOnAViewScreen > this.getContainerHeight()) {
        this.heightTotalOnAViewScreen = 0;
        this.startIndex = (0, _fp.findIndex)(['reportPartDomId', reportPartDomId], this.items) + 1;
        this.first = false;
        return false;
      }

      return true;
    }

    /**
     * check cursor position and create virtual section position
     * @param {Number} scrollTop
     * @returns {Boolean}
     */

  }, {
    key: 'hasNeedToCreateVirtualSectionPosition',
    value: function hasNeedToCreateVirtualSectionPosition(scrollTop) {
      if (this.heightForRender - HEIGHT_BUFFER < scrollTop) {
        this.heightForRender += this.viewHeight;
        return true;
      }
      return false;
    }

    /**
     * check whether item is rendered or not.
     * @returns {Boolean}
     */

  }, {
    key: 'checkRenderedItem',
    value: function checkRenderedItem(reportPartDomId) {
      return (0, _fp.includes)(reportPartDomId, this.renderedIds);
    }

    /**
     * update items
     * @param {Array} data
     */

  }, {
    key: 'updateItems',
    value: function updateItems(data) {
      this.items = data;
    }

    /**
     * has virtual section
     * @param {Number} scrollTop
     * @returns {Boolean}
     */

  }, {
    key: 'hasVirtualSection',
    value: function hasVirtualSection(scrollTop) {
      if (this.hasNeedToCreateVirtualSectionPosition(scrollTop)) {
        return createVirtualSection.apply(this);
      }

      return false;

      function createVirtualSection() {
        var index = Math.floor(scrollTop / this.viewHeight);
        if (!(0, _fp.includes)(index, this.virtualSections)) {
          this.virtualSections.push(index);
          return true;
        }
        return false;
      }
    }

    /**
     * update virtual sections
     */

  }, {
    key: 'updateVirtualSections',
    value: function updateVirtualSections() {
      this.virtualSections = (0, _fp.drop)(1, this.virtualSections);
    }

    /**
     * stop rendering
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.heightForRender = this.heightTotal;
    }

    /**
     * update items which is rendered
     */

  }, {
    key: 'updateRenderedIds',
    value: function updateRenderedIds(reportPartDomId) {
      this.renderedIds.push(reportPartDomId);
    }

    /**
     * Clean up all render items.
     */

  }, {
    key: 'cleanUp',
    value: function cleanUp() {
      this.renderedIds.splice(0, this.renderedIds.length);
      this.viewHeight = 0;
      this.heightForRender = 0; // When the cursor is scrolled to this position, it will render for new items
      this.heightTotal = 0;
      this.heightTotalOnAViewScreen = 0;
      this.first = true;
      this.rendered = false;
      this.startIndex = 0;
      this.virtualSections.splice(0, this.virtualSections.length);
    }
  }]);
  return VirtualFormFrontSideStore;
}();

exports.default = VirtualFormFrontSideStore;
module.exports = exports['default'];

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(407);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbeddedReport.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _mobxReact.observer)(function (props) {
  var containerWidth = props.containerWidth || (0, _fp.get)('properties.dataFormattings.width.value', props.fieldInfo) || 0;
  var containerHeight = props.containerHeight;
  var omitProps = ['height', 'width', 'containerHeight', 'containerWidth', 'fieldInfo'];
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({
      containerWidth: containerWidth,
      containerHeight: containerHeight
    }, (0, _fp.omit)(omitProps, props), {
      embededReportPart: true
    }))
  );
});

// $FlowFixMe

module.exports = exports['default'];

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPropsFormSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var AppGlobal = __webpack_require__(41);
  var SCHEMA_DEF = __webpack_require__(1939);
  var TinyMCEUtils = __webpack_require__(1950);
  var constants = __webpack_require__(132);
  var ReportDesignerConstants = __webpack_require__(16);
  var Cancellation = __webpack_require__(843);
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      isEqual = _require.isEqual,
      get = _require.get,
      assign = _require.assign,
      isArray = _require.isArray,
      getOr = _require.getOr;

  var WIDGETS = {
    Panel: __webpack_require__(28),
    FontStyle: __webpack_require__(266),
    FontFormat: __webpack_require__(186),
    ColorStyling: __webpack_require__(267),
    ButtonGroup: __webpack_require__(388)
  };

  module.exports = function (reportDesignerModel, reportPart, fieldStore, itemProps) {
    ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

    var reportPartContent = reportPart.reportPartContent;

    var isHTMLTabActive = reportPart.isBackSide && reportPartContent.activeTabKey === constants.TAB_HTML.key;

    var getProperties = function getProperties(key, defaultValue) {
      if (!key) {
        var properties = reportPart && reportPart.getReportPartProperties();
        var props = m.toJS(properties);
        return props;
      }
      return reportPartContent.getReportPartProperties(key, defaultValue);
    };

    return {
      // define data to render UI
      definedSchema: SCHEMA_DEF,

      // list of widgets which are used to render UI
      widgets: WIDGETS,

      // data to binding to fields
      source: {},

      // properties for different fields
      mappingProps: {
        beforeAddField: function beforeAddField() {
          var fieldLimitValue = AppGlobal.advancedSettings.performance.fieldLimitValue;
          if (reportPart.fieldCollection.length >= fieldLimitValue) {
            return itemProps.confirmMessage('error', ReportDesignerConstants.BUNDLE.MESSAGE.FIELDS_EXCEEDED_LIMITATION).finally(function () {
              return (0, _bluebird.reject)(new Cancellation());
            });
          }

          return (0, _bluebird.resolve)(arguments);
        },
        fnResetBorderDefaultValue: reportPartContent.resetBorderDefaultValue.bind(reportPartContent),
        fnResetRefreshIntervalDefaultValue: reportPartContent.resetRefreshIntervalValue.bind(reportPartContent),
        getBorderSettings: function getBorderSettings() {
          return {
            isVisibleBorder: getProperties('isVisibleBorder', false),
            borderStyle: getProperties('borderStyle', constants.FORM_STYLE_DEFAULT.borderStyle),
            borderColor: getProperties('borderColor', constants.FORM_STYLE_DEFAULT.borderColor),
            borderWidth: getProperties('borderWidth', constants.FORM_STYLE_DEFAULT.borderWidth)
          };
        },
        hadSettingBorder: function hadSettingBorder() {
          var borderSetting = {
            isVisibleBorder: getProperties('isVisibleBorder', false),
            borderStyle: getProperties('borderStyle', constants.FORM_STYLE_DEFAULT.borderStyle),
            borderColor: getProperties('borderColor', constants.FORM_STYLE_DEFAULT.borderColor),
            borderWidth: getProperties('borderWidth', constants.FORM_STYLE_DEFAULT.borderWidth)
          };
          var defaultSetting = {
            isVisibleBorder: false,
            borderStyle: constants.FORM_STYLE_DEFAULT.borderStyle,
            borderColor: constants.FORM_STYLE_DEFAULT.borderColor,
            borderWidth: constants.FORM_STYLE_DEFAULT.borderWidth
          };

          return !isEqual(borderSetting, defaultSetting);
        },

        getDataRefreshInterval: function getDataRefreshInterval() {
          return getProperties('dataRefreshInterval', {});
        },

        hadRefreshInterval: function hadRefreshInterval() {
          var defaultSetting = constants.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
          var refreshSetting = getProperties('dataRefreshInterval', {});

          return refreshSetting.value !== defaultSetting.value || refreshSetting.updateInterval !== defaultSetting.updateInterval;
        },

        getFieldQuerySource: function getFieldQuerySource() {
          return {
            fieldQuerySource: fieldStore.fieldQuerySource
          };
        }
      },

      // defined-function which fields need to execute to get its data
      mappingSource: {
        getBackgroundColor: function getBackgroundColor() {
          return getProperties('backgroundColor', constants.FORM_STYLE_DEFAULT.backgroundColor);
        },

        hadSettingBackgroundColor: function hadSettingBackgroundColor() {
          var backgroundColor = getProperties('backgroundColor', constants.FORM_STYLE_DEFAULT.backgroundColor);

          return backgroundColor !== constants.FORM_STYLE_DEFAULT.backgroundColor;
        },

        getToolbarSetting: function getToolbarSetting() {
          return {
            pasteAsText: getProperties('pasteAsText', false)
          };
        },

        getHightlightCodeValue: function getHightlightCodeValue() {
          return getProperties('highlightCode', true);
        },

        getWrapTextValue: function getWrapTextValue() {
          return getProperties('wrapText', true);
        },

        getEditorControl: function getEditorControl() {
          return reportPartContent.getEditorControl();
        },

        getEditButtonHidden: function getEditButtonHidden() {
          var hidden = !reportPartContent.isActiveForEdit || isHTMLTabActive;
          return {
            cut: hidden,
            copy: hidden,
            paste: hidden,
            pasteAsText: hidden,
            selectAll: isHTMLTabActive,
            searchReplace: isHTMLTabActive,
            searchReplaceHTML: !isHTMLTabActive
          };
        },

        getDirectionSetting: function getDirectionSetting() {
          return {
            mceDirectionRTL: getProperties('mceDirectionRTL', false),
            mceDirectionLTR: getProperties('mceDirectionLTR', true)
          };
        },

        getShowInvisibleCharacters: function getShowInvisibleCharacters() {
          return getProperties('mceVisualChars', false);
        },

        getVisualAids: function getVisualAids() {
          return getProperties('mceToggleVisualAid', true);
        },

        getUsePagination: function getUsePagination() {
          return getProperties('usePagination', false);
        },

        getPageBreakAfterEachEntry: function getPageBreakAfterEachEntry() {
          return getProperties('pageBreakAfterEachEntry', false);
        },

        isHiddenTableCell: function isHiddenTableCell() {
          return !reportPartContent.isSelectedCell;
        },

        isActiveForEdit: function isActiveForEdit() {
          return !reportPartContent.isActiveForEdit || isHTMLTabActive;
        },

        isViewFrontSide: function isViewFrontSide() {
          return !reportPart.isBackSide;
        },

        isHiddenHTMLCode: function isHiddenHTMLCode() {
          return !reportPart.isBackSide || reportPartContent.activeTabKey !== constants.TAB_HTML.key;
        },

        getTableButtonHidden: function getTableButtonHidden() {
          var hidden = !reportPartContent.isSelectedCell;
          return {
            tableDelete: hidden,
            tableProperties: hidden
          };
        },

        isInsertHidden: function isInsertHidden() {
          return !reportPartContent.isActiveForEdit;
        },

        getFormatDateByKey: function getFormatDateByKey(key) {
          return get(key, getProperties('format'));
        },

        getReportId: function getReportId() {
          return fieldStore.reportId;
        }
      },

      onChangeValue: m.action(function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
        var groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
        var fieldData = groupData[changedKey];

        fieldData && (fieldData.value = changedValue);

        var formId = reportPartContent.formState.id;
        var formProperties = {};
        var needUpdatePreview = false;

        // Handle action with value return
        if (changedKey === 'backgroundColor') {
          formProperties.backgroundColor = get('form.backgroundColor.value', schemaData);
        }

        if (changedKey === 'border') {
          formProperties = assign(formProperties, get('form.border.value', schemaData));
        }

        if (changedKey === 'field') {
          var fields = get('insert.field.value.selectedFields', schemaData);
          var selectedFields = isArray(fields) ? fields : fields.peek();

          reportPartContent.updateContainerField();

          selectedFields.forEach(function (data) {
            reportPart.insertFieldToContainer(reportPartContent.columns, data.field, data.querySource).then(function (addedField) {
              var code = reportPartContent.getHTMLCodeField(addedField, data.querySource);
              reportPartContent.getEditorControl().insertContent(code);
            });
          });
        }
        if (changedKey === 'embedReport') {
          var value = schemaData.insert.embedReport.value;
          reportPartContent.insertEmbeddedReportHtml(value);
        }

        if (changedKey === 'wrapText') {
          formProperties.wrapText = schemaData.html.wrapText.value;
        }

        if (changedKey === 'highlightCode') {
          formProperties.highlightCode = schemaData.html.highlightCode.value;
        }

        if (changedKey === 'showInvisibleCharacters') {
          formProperties.mceVisualChars = get('view.showInvisibleCharacters.value', schemaData);
        }

        if (changedKey === 'visualAids') {
          formProperties.mceToggleVisualAid = get('view.visualAids.value', schemaData);
        }

        if (changedKey === 'dataRefreshInterval') {
          formProperties.dataRefreshInterval = get('view.dataRefreshInterval.value', schemaData);
        }

        if (changedKey === 'usePagination') {
          formProperties.usePagination = get('view.usePagination.value', schemaData);
          needUpdatePreview = true;
        }

        if (changedKey === 'pageBreakAfterEachEntry') {
          formProperties.pageBreakAfterEachEntry = get('printing.pageBreakAfterEachEntry.value', schemaData);
        }

        // Handle action by button group
        if (changedOthersInfo === 'pasteAsText') {
          formProperties.pasteAsText = !getOr(false, 'pasteAsText', getProperties());
        }

        if (changedOthersInfo === 'mceTemplateEmpty') {
          TinyMCEUtils.showNotify(formId, constants.MESSAGES.M15);
          return;
        }

        // Update model properties for form
        reportPart.setReportPartProperties(formProperties);
        // Update data when need update
        if (needUpdatePreview && AppGlobal.canShowPreview()) {
          fieldStore.needUpdatePreview();
        }
      })
    };
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPropsFormSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  schemaKey: 'RP_FORM_TYPE',
  fields: {
    form: {
      component: 'Panel',
      isHidden: 'isNotShow',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_FORM');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        border: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_BORDER');
          },
          type: 'btnPopup',
          fnValue: 'getBorderSettings',
          props: {
            hadSetting: 'hadSettingBorder',
            fnResetDefaultValue: 'fnResetBorderDefaultValue',
            loadValue: 'getBorderSettings'
          },
          staticProps: {
            get title() {
              return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_FORM_BORDER_SETTINGS');
            },
            className: 'icon-setting btn-icon',
            get popupTitle() {
              return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_FORM_BORDER_SETTINGS');
            },
            popupContent: __webpack_require__(1940),
            popupProps: {
              type: 'none'
            }
          }
        },

        backgroundColor: {
          get title() {
            return _Izenda2.default.getText('COLOR_STYLING_BACKGROUND_TOOLTIP');
          },
          type: 'color',
          fnValue: 'getBackgroundColor',
          props: {
            get title() {
              return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_BACKGROUND_COLOR_SETTINGS');
            },
            position: 'left',
            hadSetting: 'hadSettingBackgroundColor',
            loadValue: 'getBackgroundColor'
          }
        }
      }
    },
    edit: {
      component: 'Panel',
      isHidden: 'isViewFrontSide',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_EDIT');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        toolbar: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_TOOL_BAR');
          },
          component: 'ButtonGroup',
          fnValue: 'getToolbarSetting',
          props: {
            editorControl: 'getEditorControl',
            buttonsHidden: 'getEditButtonHidden',
            buttons: {
              cut: {
                className: 'icon-cut',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_CUT');
                },
                value: 'Cut',
                isExecute: true
              },
              copy: {
                className: 'icon-copy',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_COPY');
                },
                value: 'Copy',
                isExecute: true
              },
              paste: {
                className: 'icon-paste',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_PASTE');
                },
                value: 'Paste',
                isExecute: true
              },
              pasteAsText: {
                className: 'icon-pastetext',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_PASTE_AS_TEXT');
                },
                value: 'pasteAsText',
                breakLine: true
              },
              selectAll: {
                className: 'icon-select-all',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_SELECT_ALL');
                },
                value: 'selectAll',
                isExecute: true
              },
              searchReplace: {
                className: 'icon-search-replace',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_FIND_AND_REPLACE_SHORT_CUT');
                },
                value: 'SearchReplace',
                isExecute: true
              },
              searchReplaceHTML: {
                component: __webpack_require__(1941),
                className: 'icon-search-replace',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_FIND_AND_REPLACE');
                }
              },
              undo: {
                className: 'icon-back',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_UNDO');
                },
                value: 'Undo',
                isExecute: true
              },
              redo: {
                className: 'icon-next',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_REDO');
                },
                value: 'Redo',
                isExecute: true
              }
            }
          }
        }
      }
    },
    insert: {
      component: 'Panel',
      isHidden: 'isInsertHidden',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_INSERT');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        item: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_ITEM');
          },
          component: 'ButtonGroup',
          isHidden: 'isActiveForEdit',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              link: {
                className: 'icon-link',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_EDIT_LINK');
                },
                value: 'mceLink',
                isExecute: true
              },
              image: {
                className: 'icon-img',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_EDIT_IMAGE');
                },
                value: 'mceImage',
                isExecute: true
              },
              anchor: {
                className: 'icon-anchor',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_EDIT_ANCHOR');
                },
                value: 'mceAnchor',
                isExecute: true
              },
              charmap: {
                className: 'icon-special',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_SPECIAL_CHARACTER');
                },
                value: 'mceShowCharmap',
                isExecute: true,
                breakLine: true
              },
              insertDate: {
                className: 'icon-calendar',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_DATE_TIME_VALUE');
                },
                value: 'mceInsertDate',
                isExecute: true
              },
              insertRule: {
                className: 'icon-line',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_HORIZONTAL_LINE');
                },
                value: 'InsertHorizontalRule',
                isExecute: true
              },
              pageBreak: {
                className: 'icon-seperate',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_PAGE_BREAK');
                },
                value: 'mcePageBreak',
                isExecute: true
              },
              template: {
                className: 'icon-temp',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_TEMPLATE_BREAK');
                },
                value: 'mceTemplateEmpty'
              }
            }
          }
        },
        field: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_FIELD');
          },
          type: 'btnPopup',
          fnValue: 'getFieldQuerySource',
          props: {
            beforeOnChange: 'beforeAddField',
            loadValue: 'getFieldQuerySource'
          },
          staticProps: {
            get title() {
              return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_ADD_FIELD');
            },
            className: 'icon-plus-circled btn-icon',
            get popupTitle() {
              return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_FIELD_SELECTION');
            },
            popupContent: __webpack_require__(1942),
            popupProps: {
              type: 'none',
              containerClass: 'izenda-SelectionFieldPopup'
            }
          }
        },
        smartTag: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_SMART_TAG');
          },
          component: 'ButtonGroup',
          fnValue: 'getGeneralInfoByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              smartTag: {
                type: 'smartTag',
                component: __webpack_require__(1943),
                className: 'icon-tag',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_SMART_TAG');
                }
              }
            }
          }
        },
        repeater: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_REPEATER');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              repeater: {
                type: 'repeater',
                component: __webpack_require__(226),
                className: 'icon-repeat',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_REPEATER');
                }
              }
            }
          }
        },
        embedReport: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_EMBEDDED_REPORT_SETTINGS');
          },
          type: 'btnPopup',
          props: {
            reportId: 'getReportId'
          },
          staticProps: {
            get title() {
              return _Izenda2.default.getText('COMMON_LABEL_EMBEDDED_REPORT_SETTINGS');
            },
            className: 'btn-icon icon-embed',
            get popupTitle() {
              return _Izenda2.default.getText('COMMON_LABEL_EMBEDDED_REPORT_SETTINGS');
            },
            popupContent: __webpack_require__(969),
            popupProps: {
              type: 'none',
              autoClose: false
            }
          }
        }
      }
    },
    format: {
      component: 'Panel',
      isHidden: 'isActiveForEdit',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_FORMAT');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        heading: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_HEADING');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              heading: {
                type: 'heading',
                component: __webpack_require__(226),
                className: 'icon-heading',
                get title() {
                  return _Izenda2.default.getText('COMMON_LABEL_HEADING');
                }
              }
            }
          }
        },
        block: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_BLOCKS');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              block: {
                type: 'block',
                component: __webpack_require__(226),
                className: 'icon-block',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_BLOCKS');
                }
              }
            }
          }
        },
        font: {
          get title() {
            return _Izenda2.default.getText('FONT_SETTINGS_LABEL_FONT');
          },
          component: __webpack_require__(1947),
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              script: {
                superscript: {
                  className: 'icon-upno',
                  get title() {
                    return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_SUPERSCRIPT');
                  },
                  value: 'superscript'
                },
                subscript: {
                  className: 'icon-dono',
                  get title() {
                    return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_SUBSCRIPT');
                  },
                  value: 'subscript'
                }
              },
              default: {
                bold: {
                  className: 'u_textBold',
                  get title() {
                    return _Izenda2.default.getText('FONT_STYLE_BOLD_TOOLTIP');
                  },
                  value: 'bold',
                  text: 'B'
                },
                italic: {
                  className: 'u_textItalic',
                  get title() {
                    return _Izenda2.default.getText('FONT_STYLE_ITALIC_TOOLTIP');
                  },
                  value: 'italic',
                  text: 'I'
                },
                underline: {
                  className: 'u_textUnderline',
                  get title() {
                    return _Izenda2.default.getText('FONT_STYLE_UNDERLINE_TOOLTIP');
                  },
                  value: 'underline',
                  text: 'U'
                },
                strikethrough: {
                  className: 'icon-del-text',
                  get title() {
                    return _Izenda2.default.getText('COMMON_LABEL_STRIKETHROUGH');
                  },
                  value: 'strikethrough'
                }
              },
              codeScript: {
                code: {
                  className: 'icon-script',
                  get title() {
                    return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_CODE');
                  },
                  value: 'code'
                }
              }
            }
          }
        },
        alignment: {
          get title() {
            return _Izenda2.default.getText('FONT_SETTINGS_LABEL_ALIGNMENT');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              alignleft: {
                className: 'icon-align-left',
                get title() {
                  return _Izenda2.default.getText('COMMON_LABEL_ALIGN_LEFT');
                },
                value: 'JustifyLeft',
                isExecute: true
              },
              aligncenter: {
                className: 'icon-align-center',
                get title() {
                  return _Izenda2.default.getText('COMMON_LABEL_ALIGN_CENTER');
                },
                value: 'JustifyCenter',
                isExecute: true
              },
              alignright: {
                className: 'icon-align-right',
                get title() {
                  return _Izenda2.default.getText('COMMON_LABEL_ALIGN_RIGHT');
                },
                value: 'JustifyRight',
                isExecute: true
              },
              alignjustify: {
                className: 'icon-align-justify',
                get title() {
                  return _Izenda2.default.getText('COMMON_LABEL_ALIGN_JUSTIFY');
                },
                value: 'JustifyFull',
                isExecute: true
              }
            }
          }
        },
        list: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_LIST');
          },
          component: 'ButtonGroup',
          fnValue: 'getFormatDateByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              bullet: {
                type: 'bullet',
                component: __webpack_require__(226),
                className: 'icon-list-bullet',
                get title() {
                  return _Izenda2.default.getText('COMMON_LABEL_BULLET_LIST');
                }
              },
              numbered: {
                type: 'numbered',
                component: __webpack_require__(226),
                className: 'icon-numbered',
                get title() {
                  return _Izenda2.default.getText('COMMON_LABEL_NUMBERED_LIST');
                }
              }
            }
          }
        },
        indent: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INDENT');
          },
          component: 'ButtonGroup',
          fnValue: 'getGeneralInfoByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              indent: {
                className: 'icon-cl',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INCREASE_INDENT');
                },
                value: 'Indent',
                isExecute: true
              },
              outdent: {
                className: 'icon-ex',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_DECREASE_INDENT');
                },
                value: 'Outdent',
                isExecute: true
              }
            }
          }
        },
        //noneditable: {
        //  get title() { return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_NON_EDITABLE') },
        //  component: 'ButtonGroup',
        //  fnValue: 'getGeneralInfoByKey',
        //  props: {
        //    buttons: {
        //      noneditable: {
        //        className: 'icon-noedit',
        //        get title() { return localizer.getText('REPORT_PART_PROPS_FORM_SCHEMA_NON_EDITABLE') }
        //      }
        //    }
        //  }
        //},
        clearFormatting: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_CLEAR_FORMATTING');
          },
          component: 'ButtonGroup',
          fnValue: 'getGeneralInfoByKey',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              removeFormat: {
                className: 'icon-clear',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_CLEAR_FORMATTING');
                },
                value: 'RemoveFormat',
                isExecute: true
              }
            }
          }
        }
      }
    },
    table: {
      component: 'Panel',
      isHidden: 'isActiveForEdit',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('MODEL_LABEL_TABLE');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        table: {
          get title() {
            return _Izenda2.default.getText('MODEL_LABEL_TABLE');
          },
          component: 'ButtonGroup',
          props: {
            editorControl: 'getEditorControl',
            buttonsHidden: 'getTableButtonHidden',
            buttons: {
              insertTable: {
                component: __webpack_require__(1948),
                className: 'icon-table-new',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_TABLE');
                }
              },
              tableDelete: {
                className: 'icon-notable',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_DELETE_TABLE');
                },
                value: 'mceTableDelete',
                isExecute: true
              },
              tableProperties: {
                className: 'icon-setting',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_TABLE_PROPERTIES');
                },
                value: 'mceInsertTable',
                isExecute: true
              }
            }
          }
        },
        cell: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_CELL');
          },
          component: 'ButtonGroup',
          isHidden: 'isHiddenTableCell',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              cellProp: {
                className: 'icon-setting',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_CELL_PROPERTIES');
                },
                value: 'mceTableCellProps',
                isExecute: true
              },
              mergeCells: {
                className: 'icon-rcell-icon',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_MERGE_CELL');
                },
                value: 'mceTableMergeCells',
                isExecute: true
              },
              splitCell: {
                className: 'icon-acell',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_SPLIT_CELL');
                },
                value: 'mceTableSplitCells',
                isExecute: true
              }
            }
          }
        },
        row: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_ROW');
          },
          component: 'ButtonGroup',
          isHidden: 'isHiddenTableCell',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              rowBefore: {
                className: 'icon-addup',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_ROW_BEFORE');
                },
                value: 'mceTableInsertRowBefore',
                isExecute: true
              },
              rowAfter: {
                className: 'icon-adddo',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_ROW_AFTER');
                },
                value: 'mceTableInsertRowAfter',
                isExecute: true
              },
              deleteRow: {
                className: 'icon-remove-cell',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_DELETE_ROW');
                },
                value: 'mceTableDeleteRow',
                isExecute: true
              },
              rowProperties: {
                className: 'icon-setting',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_ROW_PROPERTIES');
                },
                value: 'mceTableRowProps',
                isExecute: true,
                breakLine: true
              },
              cutRow: {
                className: 'icon-cut',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_CUT_ROW');
                },
                value: 'mceTableCutRow',
                isExecute: true
              },
              copyRow: {
                className: 'icon-copy-new',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_COPY_ROW');
                },
                value: 'mceTableCopyRow',
                isExecute: true
              },
              pasteRowBefore: {
                className: 'icon-paste',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_PASTE_ROW_BEFORE');
                },
                value: 'mceTablePasteRowBefore',
                isExecute: true
              },
              pasteRowAfter: {
                className: 'icon-pastetext',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_PASTE_ROW_AFTER');
                },
                value: 'mceTablePasteRowAfter',
                isExecute: true
              }
            }
          }
        },
        column: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_COLUMN');
          },
          component: 'ButtonGroup',
          isHidden: 'isHiddenTableCell',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              insertColumnBefore: {
                className: 'icon-addle-icon',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_COLUMN_BEFORE');
                },
                value: 'mceTableInsertColBefore',
                isExecute: true
              },
              insertColumnAfter: {
                className: 'icon-addri',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_INSERT_COLUMN_AFTER');
                },
                value: 'mceTableInsertColAfter',
                isExecute: true
              },
              deleteColumn: {
                className: 'icon-remove-row',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_DELETE_COLUMN');
                },
                value: 'mceTableDeleteCol',
                isExecute: true
              }
            }
          }
        }
      }
    },
    tool: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_TOOL');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        directionality: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_DIRECTIONALITY');
          },
          component: 'ButtonGroup',
          isHidden: 'isViewFrontSide',
          fnValue: 'getDirectionSetting',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              rightToLeft: {
                className: 'icon-rblock',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_RIGHT_TO_LEFT');
                },
                value: 'mceDirectionRTL',
                isExecute: true
              },
              leftToRight: {
                className: 'icon-lblock',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_LEFT_TO_RIGHT');
                },
                value: 'mceDirectionLTR',
                isExecute: true
              }
            }
          }
        }
      }
    },
    html: {
      component: 'Panel',
      isHidden: 'isHiddenHTMLCode',
      props: {
        initState: true,
        collapsible: true,
        header: {
          title: 'HTML',
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        wrapText: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_WRAP_TEXT');
          },
          type: 'checkbox',
          fnValue: 'getWrapTextValue'
        },
        highlightCode: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_HIGHTLIGHT_CODE');
          },
          type: 'checkbox',
          fnValue: 'getHightlightCodeValue'
        },
        reformat: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_REFORMAT');
          },
          component: 'ButtonGroup',
          props: {
            editorControl: 'getEditorControl',
            buttons: {
              reformat: {
                className: 'icon-reformat',
                get title() {
                  return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_REFORMAT');
                },
                value: 'Reformat',
                isExecute: true
              }
            }
          }
        }
      }
    },
    view: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('MODEL_LABEL_VIEW');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        showInvisibleCharacters: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_SHOW_INVISIBLE_CHARACTERS');
          },
          type: 'checkbox',
          fnValue: 'getShowInvisibleCharacters'
        },
        visualAids: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_FORM_SCHEMA_SHOW_VISUAL_AIDS');
          },
          type: 'checkbox',
          fnValue: 'getVisualAids'
        },
        dataRefreshInterval: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
          },
          type: 'btnPopup',
          fnValue: 'getDataRefreshInterval',
          props: {
            hadSetting: 'hadRefreshInterval',
            fnResetDefaultValue: 'fnResetRefreshIntervalDefaultValue',
            loadValue: 'getDataRefreshInterval'
          },
          staticProps: {
            get title() {
              return _Izenda2.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
            },
            className: 'icon-setting btn-icon',
            get popupTitle() {
              return _Izenda2.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
            },
            popupContent: __webpack_require__(323),
            popupProps: {
              type: 'none',
              autoClose: false
            }
          }
        },
        usePagination: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_USE_PAGINATION');
          },
          type: 'checkbox',
          fnValue: 'getUsePagination'
        }
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FormBorderSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Form Border Settings component
 */
!function () {
  var React = __webpack_require__(0);
  var EventsUtils = __webpack_require__(24);
  var observer = __webpack_require__(10).observer;
  var Thinkness = __webpack_require__(190);
  var ColorPicker = __webpack_require__(169);
  var DashStyle = __webpack_require__(322);
  var Input = __webpack_require__(17);
  var localizer = __webpack_require__(12);
  var AppGlobal = __webpack_require__(41);

  var FormBorderSettings = React.createClass({
    displayName: 'FormBorderSettings',

    propTypes: {
      onChange: React.PropTypes.func
    },

    getInitialState: function getInitialState() {
      var value = this.props.value;
      return {
        isVisibleBorder: value.isVisibleBorder,
        borderStyle: value.borderStyle,
        borderColor: value.borderColor,
        borderWidth: value.borderWidth
      };
    },

    // Return data for update data.
    getValue: function getValue() {
      var state = this.state;
      return {
        isVisibleBorder: state.isVisibleBorder,
        borderStyle: state.borderStyle,
        borderColor: state.borderColor,
        borderWidth: state.borderWidth
      };
    },

    onChange: function onChange(key, value) {
      var newState = {};
      newState[key] = value;
      this.setState(newState);
    },

    render: function render() {
      var state = this.state;
      var notifyChange = EventsUtils.notifyChange;
      var formStyles = state.isVisibleBorder ? {
        borderStyle: state.borderStyle,
        borderColor: state.borderColor,
        borderWidth: state.borderWidth
      } : null;
      var configurationClass = AppGlobal.canShowPreview() ? 'col-md-6' : 'col-md-12';

      return React.createElement(
        'section',
        { className: 'border-settings' },
        React.createElement(
          'div',
          { className: 'row no-margin border-settings-header' },
          React.createElement(
            'div',
            { className: configurationClass + ' text-center' },
            localizer.getText('COMMON_LABEL_CONFIGURATION')
          ),
          AppGlobal.canShowPreview() && React.createElement(
            'div',
            { className: 'col-md-6 text-center' },
            localizer.getText('COMMON_LABEL_PREVIEW')
          )
        ),
        React.createElement(
          'div',
          { className: 'row no-gutter no-margin border-settings-body flex-layout' },
          React.createElement(
            'div',
            { className: configurationClass + ' text-center form-horizontal' },
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(
                'label',
                { className: 'control-label col-md-4' },
                localizer.getText('COMMON_LABEL_VISIBLE')
              ),
              React.createElement(
                'div',
                { className: 'col-md-8 text-left' },
                React.createElement(Input, {
                  className: 'default',
                  type: 'checkbox',
                  checked: !!state.isVisibleBorder,
                  onChange: notifyChange(handleOnChange.bind(this, 'isVisibleBorder'), EventsUtils.CHECKBOX)
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(
                'label',
                { className: 'control-label col-md-4' },
                localizer.getText('BORDER_SETTING_LABEL_DASH_STYLE')
              ),
              React.createElement(
                'div',
                { className: 'col-md-8' },
                React.createElement(DashStyle, {
                  disabled: !state.isVisibleBorder,
                  dashStyle: state.borderStyle,
                  onChange: handleOnChange.bind(this, 'borderStyle')
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(
                'label',
                { className: 'control-label col-md-4', 'aria-middle': 'true' },
                localizer.getText('COMMON_LABEL_COLOR')
              ),
              React.createElement(
                'div',
                { className: 'col-md-8 text-left' },
                React.createElement(
                  'div',
                  { className: 'borders-color' },
                  React.createElement(ColorPicker, {
                    disabled: !state.isVisibleBorder,
                    color: state.borderColor,
                    onChange: handleOnChange.bind(this, 'borderColor')
                  })
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement(
                'label',
                { className: 'control-label col-md-4', 'aria-middle': 'true' },
                localizer.getText('BORDER_SETTING_LABEL_THICKNESS')
              ),
              React.createElement(
                'div',
                { className: 'col-md-8' },
                React.createElement(Thinkness, {
                  disabled: !state.isVisibleBorder,
                  value: state.borderWidth,
                  onChange: handleOnChange.bind(this, 'borderWidth')
                })
              )
            )
          ),
          AppGlobal.canShowPreview() && React.createElement(
            'div',
            { className: 'col-md-6 text-center' },
            React.createElement(
              'div',
              { className: 'full-height', style: formStyles },
              localizer.getText('REPORTDESIGNER_PLACEHOLDER_DUMMY_REPORT_PART_FORM')
            )
          )
        )
      );

      function handleOnChange(value) {
        var argValue = value === 'borderWidth' ? arguments[1].value : arguments[1];
        this.onChange.call(this, arguments[0], argValue);
      }
    }
  });
  module.exports = observer(FormBorderSettings);
}();

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FormSearchPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Form Search Popup component
 */
!function () {
  var React = __webpack_require__(0);
  var EventsUtils = __webpack_require__(24);
  var Input = __webpack_require__(17);
  var GridLayout = __webpack_require__(13);
  var Popup = __webpack_require__(36);
  var Alert = __webpack_require__(61);
  var Constants = __webpack_require__(132);
  var connect = __webpack_require__(2);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var FormSearchPopup = React.createClass({
    displayName: 'FormSearchPopup',

    propTypes: {
      onChange: React.PropTypes.func
    },

    getInitialState: function getInitialState() {
      return this.setupPopupState();
    },

    setupPopupState: function setupPopupState() {
      return {
        message: '',
        searchText: '',
        replaceText: '',
        activePopup: false
      };
    },

    handleClick: function handleClick(type) {
      var editorControl = this.props.editorControl;
      var state = this.state;
      var message = '';

      if (isNil(state.searchText)) {
        return;
      }

      if (type === 'searchCode' && editorControl.searchCode(state.searchText) === false) {
        message = Constants.MESSAGES.M10;
      } else if (type === 'replaceCode' && editorControl.replaceCode(state.searchText, state.replaceText) === false) {
        message = Constants.MESSAGES.M11;
      }

      if (this.state.message !== message) {
        this.setState({ message: message });
      }
    },

    renderPopupContent: function renderPopupContent() {
      var localization = this.props.localization;
      var state = this.state;
      var notifyChange = EventsUtils.notifyChange;

      return React.createElement(
        Popup,
        { type: 'none', visible: true, onClosed: closePopup.bind(this) },
        React.createElement(Popup.Header, { title: localization.getText('REPORTDESIGNER_LABEL_FIND_AND_REPLACE') }),
        React.createElement(
          Popup.Body,
          null,
          React.createElement(
            GridLayout,
            { className: 'form-horizontal' },
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '12' },
                React.createElement(
                  Alert,
                  { type: 'info' },
                  state.message
                )
              )
            ),
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '3' },
                localization.getText('REPORTDESIGNER_LABEL_FIND')
              ),
              React.createElement(
                GridLayout.Col,
                { cols: '9' },
                React.createElement(Input, {
                  value: state.searchText,
                  onChange: notifyChange(onChangeSearchText.bind(this), EventsUtils.INPUT)
                })
              )
            ),
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '3' },
                localization.getText('REPORTDESIGNER_LABEL_REPLACE_WITH')
              ),
              React.createElement(
                GridLayout.Col,
                { cols: '9' },
                React.createElement(Input, {
                  value: state.replaceText,
                  onChange: notifyChange(onChangeReplaceText.bind(this), EventsUtils.INPUT)
                })
              )
            )
          )
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(Popup.ConfirmationButton, {
            label: localization.getText('REPORTDESIGNER_LABEL_FIND'),
            onClick: this.handleClick.bind(this, 'searchCode')
          }),
          React.createElement(Popup.ConfirmationButton, {
            label: localization.getText('REPORTDESIGNER_LABEL_REPLACE'),
            onClick: this.handleClick.bind(this, 'replaceCode')
          }),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );

      function closePopup(type) {
        this.setState(this.setupPopupState());
      }

      function onChangeSearchText(value) {
        this.setState({ searchText: value });
      }

      function onChangeReplaceText(value) {
        this.setState({ replaceText: value });
      }
    },

    render: function render() {
      return React.createElement(
        'span',
        null,
        React.createElement(
          'a',
          { className: 'btn', title: 'Find and Replace', onClick: showPopup.bind(this) },
          React.createElement('span', { className: 'icon-search-replace' })
        ),
        React.createElement(
          'span',
          { className: 'u_inlineBlock' },
          this.state.activePopup ? this.renderPopupContent() : null
        )
      );

      function showPopup() {
        this.setState({ activePopup: true });
      }
    }
  });
  module.exports = connect()(FormSearchPopup);
}();

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SelectionField.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var TreeSelectionField = __webpack_require__(946);

  var _require = __webpack_require__(1),
      get = _require.get,
      map = _require.map;

  var SelectionField = React.createClass({
    displayName: 'SelectionField',

    propTypes: {
      value: React.PropTypes.object
    },

    componentWillMount: function componentWillMount() {
      this.selectedData = [];
      this.selectedFields = [];
    },

    // Return data for update data.
    getValue: function getValue() {
      return {
        selectedFields: this.selectedFields
      };
    },

    onChangeSeletedField: function onChangeSeletedField(data) {
      var filterQuerySource = get('value.fieldQuerySource', this.props);
      this.selectedFields = map(function (item) {
        var querySource = filterQuerySource[item.querySource];
        var field = querySource.fields[item.field];

        return {
          field: field,
          querySource: querySource
        };
      }, data);

      this.selectedData = data;
    },

    render: function render() {
      var filterQuerySource = get('value.fieldQuerySource', this.props);
      return React.createElement(TreeSelectionField, { data: filterQuerySource, onChangeData: this.onChangeSeletedField });
    }
  });

  module.exports = observer(SelectionField);
}();

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SmartTag.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * IconDropdownSetting component
 */
!function () {
  var React = __webpack_require__(0);
  var SmartTagStore = __webpack_require__(1944);
  var ScrollBox = __webpack_require__(27);
  var FloatAffixed = __webpack_require__(154);
  var connect = __webpack_require__(2);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      flow = _require.flow,
      orderBy = _require.orderBy,
      groupBy = _require.groupBy,
      forEach = _require.forEach;

  var SmartTag = React.createClass({
    displayName: 'SmartTag',

    propTypes: {
      onChange: React.PropTypes.func
    },

    getInitialState: function getInitialState() {
      return {
        isOpen: false
      };
    },

    componentWillMount: function componentWillMount() {
      this.smartTagStore = new SmartTagStore();
    },

    /**
     * OnClick sub total
     */
    onClickSubtotal: function onClickSubtotal() {
      this.hideMenu();
      var props = this.props;
      if (isNil(props.editorControl)) {
        return;
      }
      props.editorControl.insertSmartTag('Subtotal');
    },

    /**
     * OnClick grand total
     */
    onClickGrandTotal: function onClickGrandTotal() {
      this.hideMenu();
      var props = this.props;
      if (isNil(props.editorControl)) {
        return;
      }
      props.editorControl.insertSmartTag('GrandTotal');
    },

    /**
     * OnClick date format
     */
    onClickDateFormat: function onClickDateFormat(dateFormat) {
      this.hideMenu();
      var props = this.props;
      if (isNil(props.editorControl)) {
        return;
      }
      props.editorControl.insertSmartTag('DateTime', dateFormat);
    },

    componentDidMount: function componentDidMount() {
      this.smartTagStore.getDateFormats();
    },

    /**
     * Render date format
     * returns {Object} date format component
     */
    renderDateFormat: function renderDateFormat() {
      var dateFormatGroup = flow(orderBy('position', 'asc'), groupBy('category'))(this.smartTagStore.model.smartTags);

      var result = [];
      for (var key in dateFormatGroup) {
        var dateFormats = dateFormatGroup[key];

        result.push(React.createElement(
          'div',
          { className: 'u_textBold', key: key },
          key
        ));
        forEach(function (dateFormat) {
          result.push(React.createElement(
            'div',
            {
              className: 'izenda-DateTimeItem u_paddingLeft',
              key: dateFormat.position,
              onClick: this.onClickDateFormat.bind(this, dateFormat.name)
            },
            dateFormat.name
          ));
        }.bind(this), dateFormats);
      }

      return result;
    },

    showMenu: function showMenu(event) {
      event.stopPropagation();
      event.preventDefault();

      this.setState({ isOpen: !this.state.isOpen });
    },

    hideMenu: function hideMenu() {
      this.setState({ isOpen: false });
    },

    /**
     * Render
     * returns {Object} component
     */
    render: function render() {
      var props = this.props;
      var data = props.data;
      var localization = props.localization;

      return React.createElement(
        'span',
        { className: 'u-posRelative izenda-SmartTag' },
        React.createElement(
          'a',
          { className: 'btn', title: data.title, ref: 'smartTag', onClick: this.showMenu },
          React.createElement('i', { className: data.className }),
          React.createElement('span', { className: 'caret' })
        ),
        this.state.isOpen && React.createElement(
          FloatAffixed,
          {
            className: 'izenda-SmartTag',
            anchor: this.refs.smartTag,
            onClickOutside: this.hideMenu,
            onParentScroll: this.hideMenu
          },
          React.createElement(
            'div',
            { className: 'izenda-SmartTag-list' },
            React.createElement(
              'div',
              { className: 'izenda-SmartTag-item' },
              React.createElement(
                'a',
                null,
                localization.getText('COMMON_LABEL_DATE_TIME')
              ),
              React.createElement(
                'div',
                { className: 'izenda-SmartTag-hover' },
                React.createElement(
                  'div',
                  { className: 'izenda-SmartTag-logo' },
                  React.createElement(
                    ScrollBox,
                    null,
                    this.renderDateFormat()
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'izenda-SmartTag-item' },
              React.createElement(
                'a',
                { onClick: this.onClickSubtotal },
                localization.getText('COMMON_LABEL_SUBTOTAL')
              )
            ),
            React.createElement(
              'div',
              { className: 'izenda-SmartTag-item' },
              React.createElement(
                'a',
                { onClick: this.onClickGrandTotal },
                localization.getText('COMMON_LABEL_GRAND_TOTAL')
              )
            )
          )
        )
      );
    }
  });

  module.exports = connect()(SmartTag);
}();

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SmartTagStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = __webpack_require__(5);
  var fetcher = __webpack_require__(90);
  var SmartTag = __webpack_require__(1945);

  function SmartTagStore() {
    var props = {
      model: new SmartTag()
    };

    m.extendObservable(this, props);
  }

  /**
   * Get reports
   */
  SmartTagStore.prototype.getDateFormats = function () {
    var dateFormatCallback = m.action(function (dateFormats) {
      this.model.populateData(dateFormats);
    }.bind(this));

    return fetcher.loadReportFieldDataFormat("datetime").then(dateFormatCallback);
  };

  module.exports = SmartTagStore;
}();

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SmartTag.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var SmartTagDetail = __webpack_require__(1946);

  var _require = __webpack_require__(1),
      map = _require.map;

  function SmartTag(data) {
    var props = {
      smartTags: [] // It's a array of SmartTag object.
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param {Object} smart tag object
   */
  SmartTag.prototype.populateData = m.action(function (data) {
    this.smartTags = map(function (d) {
      return new SmartTagDetail(d);
    }, data);
  });

  module.exports = SmartTag;
}();

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SmartTagDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = __webpack_require__(5);

  function SmartTagDetail(data) {
    var props = {
      category: null,
      created: null,
      createdBy: null,
      dataType: null,
      description: null,
      format: null,
      groupBy: null,
      id: null,
      inserted: false,
      modified: null,
      modifiedBy: null,
      name: null,
      position: null,
      state: null,
      subCategory: null,
      version: null
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} embed report detail data
   */
  SmartTagDetail.prototype.populateData = m.action(function (data) {
    this.category = data.category;
    this.created = data.created;
    this.createdBy = data.createdBy;
    this.dataType = data.dataType;
    this.description = data.description;
    this.format = data.format;
    this.groupBy = data.groupBy;
    this.id = data.id;
    this.inserted = data.inserted;
    this.modified = data.modified;
    this.modifiedBy = data.modifiedBy;
    this.name = data.name;
    this.position = parseInt(data.position, 10);
    this.state = data.state;
    this.subCategory = data.subCategory;
    this.version = data.version;
  });

  module.exports = SmartTagDetail;
}();

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.FormFontSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * FormFontSettings component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var FontFormat = __webpack_require__(186);
  var ColorStyling = __webpack_require__(267);
  var ButtonGroup = __webpack_require__(388);

  var FORMAT_CONFIG = __webpack_require__(132).FORMAT_CONFIG;

  var FormFontSettings = React.createClass({
    displayName: 'FormFontSettings',

    propTypes: {
      onChange: React.PropTypes.func
    },

    handleChange: function handleChange(item) {
      var props = this.props;
      if (item.value && !!this.props.editorControl) {
        props.editorControl.toggleFormat(item.value);
      }
    },

    handleChangeFont: function handleChangeFont(data, item) {
      var editorControl = this.props.editorControl;

      switch (item.keyChange) {
        case 'fontFamily':
          var fontFamily = FORMAT_CONFIG.FONT_NAME[data.value.fontFamily];
          editorControl.execCommand('FontName', fontFamily);
          break;
        case 'fontSize':
          var fontSize = data.value.fontSize + 'px';
          editorControl.execCommand('FontSize', fontSize);
          break;
      }
    },

    handleChangeColor: function handleChangeColor(data, item) {
      var editorControl = this.props.editorControl;

      switch (item.keyChange) {
        case 'textColor':
          editorControl.applyFormat('forecolor', data.value.textColor);
          break;
        case 'backgroundColor':
          editorControl.applyFormat('hilitecolor', data.value.backgroundColor);
          break;
      }
    },

    render: function render() {
      var props = this.props;
      var fontFormat = this.props.value || {};
      var color = {
        textColor: fontFormat.textColor,
        backgroundColor: fontFormat.backgroundColor
      };

      return React.createElement(
        'span',
        { className: 'u-posRelative izenda-FormSettings' },
        React.createElement(FontFormat, (0, _extends3.default)({}, props, { onChange: this.handleChangeFont })),
        React.createElement(ButtonGroup, (0, _extends3.default)({}, props, {
          className: 'u_inlineBlock',
          buttons: props.buttons.default,
          onChange: this.handleChange
        })),
        React.createElement('br', null),
        React.createElement(ButtonGroup, (0, _extends3.default)({}, props, {
          className: 'u_inlineBlock',
          buttons: props.buttons.script,
          onChange: this.handleChange
        })),
        React.createElement(ColorStyling, { value: color, className: 'u_inlineBlock', position: 'left', onChange: this.handleChangeColor }),
        React.createElement(ButtonGroup, (0, _extends3.default)({}, props, {
          className: 'u_inlineBlock',
          buttons: props.buttons.codeScript,
          onChange: this.handleChange
        }))
      );
    }
  });

  module.exports = observer(FormFontSettings);
}();

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.InsertTablePopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
//
/**
 * Insert Table Popup component
 */
!function () {
  var React = __webpack_require__(0);

  var _require = __webpack_require__(1),
      times = _require.times;

  var Popover = __webpack_require__(403).Popover;
  var DEFAULT_ROW_NUMBER = 10;

  var InsertTablePopup = React.createClass({
    displayName: 'InsertTablePopup',

    propTypes: {
      onChange: React.PropTypes.func
    },

    getInitialState: function getInitialState() {
      return {
        isOpen: false
      };
    },

    // Return data for update data.
    getValue: function getValue() {
      var state = this.state;
      return state;
    },

    selectGrid: function selectGrid(tx, ty) {
      var table = this.refs.gridTable;
      var x, y, focusCell, cell, active;
      table.nextSibling.innerHTML = tx + 1 + ' x ' + (ty + 1);

      for (y = 0; y < DEFAULT_ROW_NUMBER; y++) {
        for (x = 0; x < DEFAULT_ROW_NUMBER; x++) {
          cell = table.rows[y].childNodes[x].firstChild;
          active = x <= tx && y <= ty;
          cell.className = active ? 'active' : '';

          if (active) {
            focusCell = cell;
          }
        }
      }

      return focusCell && focusCell.parentNode;
    },

    handleSelectCell: function handleSelectCell(e) {
      var target = e.target,
          x,
          y;
      if (target.tagName.toUpperCase() === 'A') {
        x = parseInt(target.getAttribute('data-x'), DEFAULT_ROW_NUMBER);
        y = parseInt(target.getAttribute('data-y'), DEFAULT_ROW_NUMBER);

        if (x !== this.lastX || y !== this.lastY) {
          this.selectGrid(x, y, e.control);
          this.lastX = x;
          this.lastY = y;
        }
      }
    },

    handleInsertTable: function handleInsertTable(e) {
      if (e.target.tagName.toUpperCase() === 'A') {
        e.preventDefault();
        e.stopPropagation();
        this.props.editorControl.insertTable(this.lastX + 1, this.lastY + 1);
        this.setState({ isOpen: false });
      }
    },

    generateTableGrid: function generateTableGrid() {
      var arrayNumber = times(String, DEFAULT_ROW_NUMBER);
      var columns = function columns(y) {
        return arrayNumber.map(function (x) {
          return React.createElement(
            'td',
            { className: 'grid-cell', key: x + y },
            React.createElement('a', { 'data-x': x, 'data-y': y })
          );
        });
      };
      var rows = arrayNumber.map(function (y) {
        return React.createElement(
          'tr',
          { key: y },
          columns(y)
        );
      });

      return React.createElement(
        'table',
        {
          className: 'grid-border',
          ref: 'gridTable',
          onMouseMove: this.handleSelectCell,
          onClick: this.handleInsertTable
        },
        React.createElement(
          'tbody',
          null,
          rows
        )
      );
    },

    renderPopup: function renderPopup() {
      return React.createElement(
        Popover,
        { visible: this.state.isOpen, positionLeft: -75, positionTop: 15, onHide: this.onHidePopup, rootClose: true },
        this.generateTableGrid(),
        React.createElement(
          'div',
          { className: 'text-center' },
          '1 x 1'
        )
      );
    },

    handleClickButton: function handleClickButton() {
      this.setState({
        isOpen: true
      });
    },

    render: function render() {
      var props = this.props;
      var data = props.data;

      return React.createElement(
        'span',
        { className: 'u-posRelative insert-table' },
        React.createElement(
          'a',
          { className: 'btn', title: data.title, onClick: this.handleClickButton },
          React.createElement('i', { className: data.className })
        ),
        this.renderPopup()
      );
    }
  });
  module.exports = InsertTablePopup;
}();

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get NUMBER_CONSTRAINT() {
    return {
      get UPDATE_INTERVAL() {
        return {
          presence: {
            presence: true,
            message: _Izenda2.default.getText('DATA_REFRESH_SETTING_CONSTANTS_UPDATE_INTERVAL_MESSAGE_UPDATE_INTERVAL_IS_REQUIRED')
          },
          numericality: {
            onlyInteger: true,
            message: _Izenda2.default.getText('DATA_REFRESH_SETTING_CONSTANTS_UPDATE_INTERVAL_MESSAGE_UPDATE_INTERVAL_SHOULD_BE_NUMBER')
          }
        };
      },
      get LATEST_RECORD() {
        return {
          presence: {
            presence: true,
            message: _Izenda2.default.getText('DATA_REFRESH_SETTING_CONSTANTS_LASTEST_RECORD_MESSAGE_LASTEST_RECORDS_IS_REQUIRED')
          },
          numericality: {
            onlyInteger: true,
            message: _Izenda2.default.getText('DATA_REFRESH_SETTING_CONSTANTS_LASTEST_RECORD_MESSAGE_LASTEST_RECORDS_SHOULD_BE_NUMBER')
          }
        };
      }
    };
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.DataRefreshSettingConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var tinymce = void 0; // ----------------------------------------------------------------------
// <copyright file="Izenda.TinyMCEUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function getTinyMCEId(id) {
  tinymce = tinymce || __webpack_require__(576);
  return tinymce.get(id);
};

exports.default = {
  /**
   * Get content of Tinymce
   * @param  {[type]} id [description]
   * @return {[type]}    [description]
   */
  getContent: function getContent(id) {
    return getTinyMCEId(id).getContent();
  },

  /**
   * Execute command for tiny mce
   * @param  {String} command [description]
   * @param  {String} id      [description]
   * @return {Boolean}         [description]
   */
  execCommand: function execCommand(id, command) {
    if ((0, _fp.isNil)(command) || (0, _fp.isNil)(id)) return false;

    getTinyMCEId(id).execCommand(command, false);
  },

  /**
   * Insert content into tinymce
   * @param  {String} id      [description]
   * @param  {String} content [description]
   */
  insertContent: function insertContent(id, content) {
    getTinyMCEId(id).execCommand('mceInsertContent', false, content);
  },

  /**
   * Check dirty form input
   * @param  {String} id  [description]
   * @return {Boolean}    [description]
   */
  checkDirty: function checkDirty(id) {
    return getTinyMCEId(id).isDirty();
  },

  /**
   * [showNotify description]
   * @param  {[type]} id      [description]
   * @param  {[type]} message [description]
   */
  showNotify: function showNotify(id, message, type) {
    type = type || 'info';
    getTinyMCEId(id).windowManager.alert(message);
  },

  /**
   * Check selects a cell in inserted table anything
   * @param  {string} id [description]
   * @return {[type]}    [description]
   */
  checkSelectedCell: function checkSelectedCell(id) {
    var editor = getTinyMCEId(id);
    var selectedCells = editor.dom.select('td[data-mce-selected],th[data-mce-selected]');
    var selectedElm = selectedCells[0];
    if (!selectedElm) {
      selectedElm = editor.selection.getStart();
    }

    return editor.dom.getParent(selectedElm, 'td,th');
  }
};
module.exports = exports['default'];

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (editorComp, reportDesignerModel, fieldStore, itemProps) {
  var formFieldPropsSchema = _Izenda2.default.apply(null, arguments);

  var configField = itemProps.configField || {};

  // update schema
  formFieldPropsSchema.definedSchema = updateSchemaForForm(formFieldPropsSchema.definedSchema);

  updateSortProps(formFieldPropsSchema.definedSchema);

  return formFieldPropsSchema;

  /**
   * Remove unsed-properties
   * @param  {object} fieldSchema
   * @return {object}
   */
  function updateSchemaForForm(fieldSchema) {
    var newFieldSchema = fieldSchema;

    UNUSED_PROPS.forEach(function (pathItem) {
      newFieldSchema = (0, _fp.unset)(pathItem, newFieldSchema);
    });

    return newFieldSchema;
  }

  // TODO: remove this code.
  function updateSortProps(definedSchema) {
    var sortDef = (0, _fp.get)('fields.dataFormattings.fields.sort', definedSchema);
    var hasRepeaterPart = (0, _fp.invokeArgs)('getOtherProps', ['hasRepeaterPart'], configField.properties);

    sortDef.props.showInactiveState = !hasRepeaterPart;
  }
};

var _Izenda = __webpack_require__(257);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsSchemaForm.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var UNUSED_PROPS = ['fields.dataFormattings.fields.alignment', 'fields.dataFormattings.fields.verticalAlignment', 'fields.dataFormattings.fields.columnWordWrap', 'fields.headerFormating'];

module.exports = exports['default'];

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _dec, _class3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GaugeFrontSide component
 */

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(404);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(954);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(80);

var _Izenda8 = __webpack_require__(224);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(53);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(76);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(35);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(412);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _fp = __webpack_require__(1);

var _Izenda18 = __webpack_require__(1953);

var _Izenda19 = _interopRequireDefault(_Izenda18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GaugePreview = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GaugePreview, _Component);

  function GaugePreview() {
    (0, _classCallCheck3.default)(this, GaugePreview);
    return (0, _possibleConstructorReturn3.default)(this, (GaugePreview.__proto__ || (0, _getPrototypeOf2.default)(GaugePreview)).apply(this, arguments));
  }

  (0, _createClass3.default)(GaugePreview, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.refreshData && this.props.refreshData(false);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.updateDrillComponent.call(this);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.updateDrillComponent.call(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props,
          _props = this.props,
          viewMode = _props.viewMode,
          reportPart = _props.reportPart,
          printingMode = _props.printingMode,
          reportPartContent = _props.reportPart.reportPartContent;


      var chartProperties = (0, _mobx.toJS)(reportPart.getReportPartProperties()) || {};
      var doesBreakPage = reportPartContent.checkBreakPage();
      var type = reportPartContent.type;

      var chartData = (0, _Izenda7.parser)(reportPartContent.activeElmsByContainers, reportPartContent.expandedLevel, {
        fieldsMapping: reportPart.previewDataFieldsMapping,
        records: reportPart.previewDataRecords,
        rawData: reportPart.previewData
      }, null);

      $izenda.extend(true, chartProperties, {
        colors: reportPart.getThemeColors(chartProperties),
        commonActions: {
          onDrilldown: props.onDrilldown,
          setPageSize: props.setPageSize,
          pointAction: props.pointAction
        }
      });

      // refresh data intervals
      props.refreshData && props.refreshData(true);

      if (_Izenda15.default.needToRenderLazyLoadingBar(reportPart, printingMode)) {
        return _Izenda15.default.renderLazyLoadingBar();
      }

      return _react2.default.createElement(
        _Izenda4.default,
        {
          type: type,
          reportPart: reportPart,
          isPreview: props.isPreview,
          chartType: chartProperties.chartType,
          chartOptions: chartProperties,
          seriesOptions: props.reportPart.fieldCollection,
          chartData: chartData,
          printingMode: printingMode,
          doesBreakPage: !props.forDashboard && doesBreakPage && !props.embededReportPart,
          gaugePartType: true,
          viewMode: viewMode,
          style: printingMode && props.style ? props.style : {},
          finishedRender: props.finishedRender,
          fulfilledData: props.fulfilledData,
          isLoading: reportPart.isLoadingData,
          separator: props.separator,
          forExporting: props.forExporting
        },
        !printingMode && _react2.default.createElement(_Izenda6.default, {
          reportPart: reportPart,
          onDrillDown: props.onDrilldown,
          isShowMetric: reportPartContent.isShowMetric
        })
      );
    }
  }]);
  return GaugePreview;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object,
  reportPart: _propTypes2.default.object.isRequired
}, _temp)) || _class;

var GaugeFrontSide = (_dec = (0, _Izenda2.default)(_Izenda19.default), _dec(_class3 = function (_Component2) {
  (0, _inherits3.default)(GaugeFrontSide, _Component2);

  function GaugeFrontSide() {
    var _ref;

    var _temp2, _this2, _ret;

    (0, _classCallCheck3.default)(this, GaugeFrontSide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = GaugeFrontSide.__proto__ || (0, _getPrototypeOf2.default)(GaugeFrontSide)).call.apply(_ref, [this].concat(args))), _this2), _this2.renderGauge = function () {
      var _this3 = _this2,
          props = _this3.props;

      var sizeStyle = props.style ? props.style : {};
      var omitProps = (0, _fp.omit)(['width', 'height'], props);

      return _react2.default.createElement(GaugePreview, (0, _extends3.default)({}, omitProps, { style: sizeStyle }));
    }, _this2.renderDefaultGauge = function () {
      var localization = _this2.props.localization;


      return _react2.default.createElement(
        'div',
        { className: 'default-layout' },
        _react2.default.createElement(
          'div',
          { className: 'chart-goes-here' },
          _react2.default.createElement(
            'span',
            null,
            localization.getText('REPORTDESIGNER_PLACEHOLDER_GAUGE_GOES_HERE')
          )
        )
      );
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(GaugeFrontSide, [{
    key: 'render',
    value: function render() {
      var props = this.props,
          _props2 = this.props,
          hideTitle = _props2.hideTitle,
          printingMode = _props2.printingMode;

      var reportPartDetails = props.reportPart || {};
      var isBeingBuild = (0, _mobx.expr)(function () {
        return (0, _fp.get)('isBeingBuild', reportPartDetails.reportPartContent);
      });
      var sizeStyle = props.style ? props.style : {};
      var renderFn = printingMode || isBeingBuild ? this.renderGauge : this.renderDefaultGauge;
      var classes = (0, _classnames2.default)('report-part-gauge-front-side', {
        'izenda-ReportPart-smallSize': props.width < _Izenda11.default.REPORT_PART_SMALL_SIZE
      });

      return printingMode ? _react2.default.createElement(
        'div',
        { className: 'report-part-chart-front-side', style: _Izenda13.default.getReportPartContainerStyle(props) },
        _react2.default.createElement(
          'div',
          { className: _Izenda13.default.getReportPartClassName(props), style: sizeStyle },
          !hideTitle && _react2.default.createElement(_Izenda9.default, { mode: _Izenda10.REPORT_PART_MODE.PREVIEW, reportPart: reportPartDetails }),
          renderFn()
        )
      ) : _react2.default.createElement(
        _Izenda17.default,
        (0, _extends3.default)({}, props, { className: classes }),
        _react2.default.createElement(_Izenda9.default, { mode: _Izenda10.REPORT_PART_MODE.PREVIEW, reportPart: reportPartDetails }),
        renderFn()
      );
    }
  }]);
  return GaugeFrontSide;
}(_react.Component)) || _class3);
exports.default = GaugeFrontSide;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

/**
 * Change metric handler
 * @param {Object} props
 * @param {Object} value
 * @param {Object} element
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeFrontSideActions.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

function onChange(_ref, _ref2, element) {
  var reportPart = _ref.reportPart;
  var value = _ref2.value;

  var reportPartContent = reportPart.reportPartContent || {};
  reportPartContent.setActiveSerie(value, element);
}

/**
 * Update drill handler
 */
function updateDrillComponent() {
  var reportPart = (0, _fp.getOr)({}, 'reportPart', this.props);
  reportPart.onDrilldown = this.props.onDrilldown;
}

/**
 * Drill handler
 * @param {Object} props
 * @param {Object} drilldownValue
 * @param {Object} separatorValue
 */
function onDrilldown(props, drilldownValue, separatorValue) {
  var reportPart = props.reportPart,
      printingMode = props.printingMode,
      reportPartContent = props.reportPart.reportPartContent;


  var canDrilldown = reportPartContent.updateDrilldownInfo(drilldownValue, separatorValue);

  if (canDrilldown) {
    !!props.publishDrillInfo && props.publishDrillInfo(reportPart.id, reportPart.reportPartContent.getCrossFilteringInfo());
    var loadingProcess = props.needUpdatePreview(reportPart, reportPartContent.getDrilldownInfo(), null, null, printingMode).then(function () {
      reportPartContent.isCrossFiltering && props.store && props.store.loadReportPartDataByCrossFiltering(reportPart.id);
    });
    props.showLoading && props.showLoading(loadingProcess);
  }
}

/**
 * Update page size
 * @param {Object} props
 * @param {Object} pageSize
 */
function setPageSize(props, pageSize) {
  return props.reportPart.reportPartContent.setPageSize(pageSize);
}

exports.default = (0, _recompose.compose)((0, _recompose.withProps)({
  updateDrillComponent: updateDrillComponent
}), (0, _recompose.withHandlers)({
  onChange: (0, _fp.curry)(onChange),
  onDrilldown: (0, _fp.curry)(onDrilldown),
  setPageSize: (0, _fp.curry)(setPageSize)
}));
module.exports = exports['default'];

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

exports.default = function (editorComp, reportDesignerModel, fieldStore, itemProps) {
  var configField = itemProps.configField || {};
  var configReportPart = reportDesignerModel.configReportPart;
  var reportPartContent = configReportPart.reportPartContent;
  var fieldContainerDetails = itemProps.fieldContainerDetails || {};

  var chartType = reportPartContent.chartType;
  var containerName = fieldContainerDetails.name || '';

  var chartFieldPropsSchema = _Izenda5.default.apply(null, arguments);

  chartFieldPropsSchema.UPDATE_DATA_BY_KEY_CHANGE = (0, _fp.concat)(chartFieldPropsSchema.UPDATE_DATA_BY_KEY_CHANGE, ['fieldNameAlias']);

  var mappingSource = chartFieldPropsSchema.mappingSource;
  var mappingProps = chartFieldPropsSchema.mappingProps;
  mappingProps.stypeOptions = (0, _fp.remove)({ value: 'embedded' }, mappingProps.stypeOptions);

  // update schema
  chartFieldPropsSchema.definedSchema = updateSchemaToChart(chartFieldPropsSchema.definedSchema);

  // data formatting > color: show text color only
  showTextColor(chartFieldPropsSchema.definedSchema);

  // update action for function-properties
  updateChangeFunction(chartFieldPropsSchema);

  return chartFieldPropsSchema;

  function updateChangeFunction(schema) {
    var preBeforeChangeFunction = (0, _fp.get)('mappingProps.beforeChangeFunction', schema);
    // update for before report on change
    $izenda.extend(true, schema, {
      mappingProps: {
        beforeChangeFunction: function beforeChangeFunction(newVal) {
          if (newVal && newVal.value) {
            return (0, _fp.isFunction)(preBeforeChangeFunction) ? preBeforeChangeFunction.apply(this, arguments) : (0, _bluebird.resolve)();
          }

          return this.props.confirmMessage && this.props.confirmMessage('error', _Izenda3.default.Message.M05).then(function () {
            return (0, _bluebird.reject)(null);
          });
        }
      }
    });
  }

  /**
   * Remove unsed-properties
   * @param  {object} fieldSchema
   * @return {object}
   */
  function updateSchemaToChart(fieldSchema) {
    var updatedFieldSchema = fieldSchema;

    // remove common-unused-fields
    UNUSED_PROPS_COMMON.forEach(function (pathItem) {
      updatedFieldSchema = (0, _fp.set)([pathItem, 'isHidden'].join('.'), true, updatedFieldSchema);
    });

    // remove unused-fields based on chart type & cotainer name
    (0, _fp.getOr)([], [chartType, containerName].join('.'), UNUSED_PROPS_BY_TYPE).forEach(function (pathItem) {
      updatedFieldSchema = (0, _fp.set)([pathItem, 'isHidden'].join('.'), true, updatedFieldSchema);
    });

    return updatedFieldSchema;
  }

  function showTextColor(definedSchema) {
    var colorDef = (0, _fp.get)('fields.dataFormattings.fields.color', definedSchema);

    if (colorDef) {
      $izenda.extend(true, colorDef, {
        staticProps: {
          showTextColor: true,
          showCellColor: false
        }
      });
    }
  }
};

var _Izenda = __webpack_require__(33);

var _Izenda2 = __webpack_require__(221);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(257);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeFieldPropsSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ContainerName = _Izenda3.default.ContainerName;
var UNUSED_PROPS_COMMON = ['fields.dataFormattings.fields.fontFormat', 'fields.dataFormattings.fields.fontStyle', 'fields.dataFormattings.fields.alignment', 'fields.dataFormattings.fields.verticalAlignment', 'fields.dataFormattings.fields.subTotal', 'fields.dataFormattings.fields.grandTotal', 'fields.dataFormattings.fields.width', 'fields.dataFormattings.fields.columnWordWrap', 'fields.headerFormating'];

var UNUSED_PROPS_BY_TYPE = {};

// Solid gauge
UNUSED_PROPS_BY_TYPE[_Izenda.CHART_TYPE.SolidGauge] = {};

// Solid gauge -  values
UNUSED_PROPS_BY_TYPE[_Izenda.CHART_TYPE.SolidGauge][ContainerName.VALUES] = ['fields.dataFormattings.fields.customURL', 'fields.dataFormattings.fields.embeddedJavascript', 'fields.drillDown.fields.subReport'];

// Solid gauge -  threshold
UNUSED_PROPS_BY_TYPE[_Izenda.CHART_TYPE.SolidGauge][ContainerName.THRESHOLD] = ['fields.dataFormattings.fields.sort', 'fields.dataFormattings.fields.color', 'fields.dataFormattings.fields.alternativeText', 'fields.dataFormattings.fields.customURL', 'fields.dataFormattings.fields.embeddedJavascript', 'fields.drillDown.fields.subReport'];

// Linear gauge (same as solid gauge)
UNUSED_PROPS_BY_TYPE[_Izenda.CHART_TYPE.LinearGauge] = UNUSED_PROPS_BY_TYPE[_Izenda.CHART_TYPE.SolidGauge];

// Simple gauge (same as solid/linear gauge)
UNUSED_PROPS_BY_TYPE[_Izenda.CHART_TYPE.SimpleGauge] = UNUSED_PROPS_BY_TYPE[_Izenda.CHART_TYPE.SolidGauge];
// Simple gauge -supplementary KPI (same as values)
UNUSED_PROPS_BY_TYPE[_Izenda.CHART_TYPE.SimpleGauge][ContainerName.SUP_KPI] = UNUSED_PROPS_BY_TYPE[_Izenda.CHART_TYPE.SimpleGauge][ContainerName.VALUES];

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridBackSideConfiguration.jsx"
// company="Izenda">  Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Filters component
 */
!function () {
  var FieldContainer = __webpack_require__(306);
  var Input = __webpack_require__(17);
  var CustomCheckbox = __webpack_require__(972);
  var ReportPartTitle = __webpack_require__(224);
  var EventsUtils = __webpack_require__(24);
  var notifyChange = EventsUtils.notifyChange;
  var GridLayout = __webpack_require__(13);
  var connect = __webpack_require__(2);

  var constants = __webpack_require__(84);
  var MAXIMUM_FIELD = constants.MAXIMUM_FIELD;
  var GRID_STYLES = constants.GRID_STYLES;
  var REPORT_PART_MODE = __webpack_require__(53).REPORT_PART_MODE;

  var _require = __webpack_require__(1),
      map = _require.map,
      flow = _require.flow;

  var GRID_STYLES_GROUP_BY_CONTAINER = {
    columns: [GRID_STYLES.VERTICAL, GRID_STYLES.PIVOT],
    rows: [GRID_STYLES.HORIZONTAL, GRID_STYLES.PIVOT],
    values: [GRID_STYLES.PIVOT, GRID_STYLES.DRILL_DOWN],
    groups: [GRID_STYLES.DRILL_DOWN]
  };

  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;

  var LABEL_CLASS = 'label-column col-md-3';
  var INPUT_CLASS = 'input-column col-md-9';

  var ReportPartGridBackSideConfiguration = React.createClass({
    displayName: 'ReportPartGridBackSideConfiguration',

    propTypes: {
      store: React.PropTypes.object,
      reportPart: React.PropTypes.object
    },

    getInitialState: function getInitialState() {
      return {
        showTitleSettingPopup: false,
        showDescriptionSettingPopup: false
      };
    },

    getFontSettings: function getFontSettings(settings) {
      var font = settings.font;
      var alignment = settings.alignment.alignment;

      return {
        fontFamily: font.family,
        fontSize: font.size,
        fontBold: font.bold,
        fontItalic: font.italic,
        fontUnderline: font.underline,
        fontColor: font.color,
        fontHighlightColor: font.highlightColor,
        alignment: alignment
      };
    },

    render: function render() {
      var localization = this.props.localization;
      var reportPart = this.props.reportPart || {};
      var reportPartContent = reportPart.reportPartContent;
      var useSeparator = reportPartContent.properties.grouping.useSeparator;
      var gridStyle = reportPartContent.properties.generalInfo.gridStyle;
      var havingColumns = map('value', GRID_STYLES_GROUP_BY_CONTAINER.columns).indexOf(gridStyle) >= 0;
      var havingRows = map('value', GRID_STYLES_GROUP_BY_CONTAINER.rows).indexOf(gridStyle) >= 0;
      var havingValues = map('value', GRID_STYLES_GROUP_BY_CONTAINER.values).indexOf(gridStyle) >= 0;
      var havingGroups = map('value', GRID_STYLES_GROUP_BY_CONTAINER.groups).indexOf(gridStyle) >= 0;
      var isPivot = GRID_STYLES.PIVOT.value === gridStyle;
      var store = this.props.store;
      var maximumField = isPivot ? MAXIMUM_FIELD.PIVOT.LABEL : null;

      var updatePreviewData = function updatePreviewData() {
        reportPart.shouldUpdatePreview && store.needUpdatePreview();
      };

      return React.createElement(
        GridLayout,
        { className: 'izenda-ReportPartConfiguration' },
        React.createElement(ReportPartTitle, { mode: REPORT_PART_MODE.CONFIG, reportPart: reportPart }),
        havingColumns && React.createElement(
          'div',
          { className: 'row form-group' },
          React.createElement(
            'div',
            { className: LABEL_CLASS },
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-md-12' },
                localization.getText('REPORTDESIGNER_LABEL_COLUMNS')
              ),
              isPivot && React.createElement(
                'section',
                null,
                React.createElement(
                  'div',
                  { className: 'col-md-12' },
                  React.createElement(
                    'div',
                    { className: 'checkbox' },
                    React.createElement(
                      'label',
                      null,
                      React.createElement(Input, {
                        type: 'checkbox',
                        checked: reportPartContent.columns.properties.addSideTotal,
                        onChange: notifyChange(flow(reportPartContent.updateColumnsAddSideTotal.bind(reportPartContent), updatePreviewData), EventsUtils.CHECKBOX)
                      }),
                      localization.getText('REPORTDESIGNER_LABEL_ADD_SIDE_TOTAL')
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'col-md-12' },
                  React.createElement(
                    'div',
                    { className: 'checkbox' },
                    React.createElement(
                      'label',
                      null,
                      React.createElement(Input, {
                        type: 'checkbox',
                        checked: reportPartContent.columns.properties.useExpanders,
                        onChange: notifyChange(reportPartContent.updateColumnsUseExpanders.bind(reportPartContent), EventsUtils.CHECKBOX)
                      }),
                      localization.getText('REPORTDESIGNER_LABEL_USE_EXPANDERS')
                    )
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: INPUT_CLASS },
            React.createElement(FieldContainer, (0, _extends3.default)({}, this.props, { container: reportPartContent.columns, maximumField: maximumField }))
          )
        ),
        havingRows && React.createElement(
          'div',
          { className: 'row form-group' },
          React.createElement(
            'div',
            { className: LABEL_CLASS },
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                'div',
                { className: 'col-md-12' },
                localization.getText('REPORTDESIGNER_LABEL_ROWS')
              ),
              isPivot && React.createElement(
                'div',
                { className: 'col-md-12' },
                React.createElement(
                  'div',
                  { className: 'checkbox' },
                  React.createElement(
                    'label',
                    null,
                    React.createElement(Input, {
                      type: 'checkbox',
                      checked: reportPartContent.rows.properties.useExpanders,
                      onChange: notifyChange(flow(reportPartContent.updateRowsUseExpanders.bind(reportPartContent), updatePreviewData), EventsUtils.CHECKBOX)
                    }),
                    localization.getText('REPORTDESIGNER_LABEL_USE_EXPANDERS')
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: INPUT_CLASS },
            React.createElement(FieldContainer, (0, _extends3.default)({}, this.props, { container: reportPartContent.rows }))
          )
        ),
        havingGroups && React.createElement(
          'div',
          { className: 'row form-group' },
          React.createElement(
            'div',
            { className: LABEL_CLASS },
            React.createElement(
              'div',
              { className: 'col-md-12 row' },
              localization.getText('REPORTDESIGNER_LABEL_GROUPS')
            )
          ),
          React.createElement(
            'div',
            { className: INPUT_CLASS },
            React.createElement(FieldContainer, (0, _extends3.default)({}, this.props, { container: reportPartContent.rows }))
          )
        ),
        havingValues && React.createElement(
          'div',
          { className: 'row form-group' },
          React.createElement(
            'div',
            { className: LABEL_CLASS },
            React.createElement(
              'div',
              { className: 'col-md-12 row' },
              localization.getText('REPORTDESIGNER_LABEL_VALUES')
            )
          ),
          React.createElement(
            'div',
            { className: INPUT_CLASS },
            React.createElement(FieldContainer, (0, _extends3.default)({}, this.props, { container: reportPartContent.values }))
          )
        ),
        useSeparator && React.createElement(
          'div',
          { className: 'row form-group' },
          React.createElement(
            'div',
            { className: LABEL_CLASS },
            React.createElement(
              'div',
              { className: 'col-md-12 row' },
              localization.getText('REPORTDESIGNER_LABEL_SEPARATORS')
            )
          ),
          React.createElement(
            'div',
            { className: INPUT_CLASS },
            React.createElement(FieldContainer, (0, _extends3.default)({}, this.props, { container: reportPartContent.separators }))
          )
        )
      );
    }
  });

  module.exports = connect()(ReportPartGridBackSideConfiguration);
}();

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridFrontSide component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(571);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(959);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(963);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1957);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(84);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(1959);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(64);

var _Izenda14 = __webpack_require__(224);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(53);

var _Izenda17 = __webpack_require__(97);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(13);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(1964);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(2);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(1965);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(76);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _Izenda29 = __webpack_require__(35);

var _Izenda30 = _interopRequireDefault(_Izenda29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridPaginator = (0, _Izenda22.default)(_Izenda18.default);
var NUMBER_ONE = 1;
var NUMBER_TIMEOUT_FINISH_RENDER = 500;
var ReportPartGridFrontSide = (_dec = (0, _Izenda24.default)(_Izenda26.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartGridFrontSide, _Component);

  function ReportPartGridFrontSide(props) {
    (0, _classCallCheck3.default)(this, ReportPartGridFrontSide);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartGridFrontSide.__proto__ || (0, _getPrototypeOf2.default)(ReportPartGridFrontSide)).call(this, props));

    _initialiseProps.call(_this);

    var reportPartContent = props.reportPart.reportPartContent;


    _this.mainComponentKey = 'MainComponent';
    _this.renderListeners = [];
    _this.dispose = (0, _mobx.observe)(reportPartContent, 'changeGridStyleStatus', function (newValue) {
      !newValue && props.confirmMessage('info', _Izenda10.default.MESSAGES.M07).then(function () {
        reportPartContent.changeGridStyleStatus = true;
      });
    });
    _this.disposeInconsitentFunction = (0, _mobx.observe)(reportPartContent, 'inconsitentFunction', function (newValue) {
      newValue && props.confirmMessage('info', _Izenda13.MESSAGES.M08);
    });

    _this.buildChildPromises();
    return _this;
  }

  (0, _createClass3.default)(ReportPartGridFrontSide, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var props = this.props,
          dispose = this.dispose,
          disposeInconsitentFunction = this.disposeInconsitentFunction;

      dispose();
      disposeInconsitentFunction();
      props.refreshData && props.refreshData(false);
    }
  }, {
    key: 'publishFinishedRender',
    value: function publishFinishedRender() {
      var props = this.props,
          renderListeners = this.renderListeners;


      if (props.printingMode) {
        _Izenda28.default.publishFinishedRender(renderListeners, function () {
          props.finishedRender && props.fulfilledData && props.finishedRender();
        });
      } else {
        props.finishedRender && props.fulfilledData && props.finishedRender();
      }
    }
  }, {
    key: 'buildChildPromises',
    value: function buildChildPromises() {
      this.renderListeners.push(_Izenda28.default.createPartRenderPromise(this.mainComponentKey));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      // Set timeout for grid render
      setTimeout(function () {
        _this2.publishFinishedRender();
      }, NUMBER_TIMEOUT_FINISH_RENDER);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props,
          _props = this.props,
          reportPart = _props.reportPart,
          printingMode = _props.printingMode,
          renderPrintingMode = this.renderPrintingMode,
          renderNormalMode = this.renderNormalMode;

      // refresh data intervals

      props.refreshData && props.refreshData(true);

      if (_Izenda30.default.needToRenderLazyLoadingBar(reportPart, printingMode)) {
        return _Izenda30.default.renderLazyLoadingBar();
      }

      return printingMode ? renderPrintingMode() : renderNormalMode();
    }
  }]);
  return ReportPartGridFrontSide;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.renderHeader = (0, _fp.curry)(function (props, container, fieldElement, title, callBack) {
    var isBackSide = (0, _fp.getOr)(false, 'reportPart.isBackSide', props);
    var sortValue = props.resolveSortValue(container, fieldElement);
    var className = !isBackSide && (0, _fp.getOr)('', [sortValue, 'headerIcon'], _Izenda13.SORT_ORDERS);
    var clazzName = (0, _classnames2.default)({ u_curPointer: !isBackSide });

    var defaultStyle = {
      fontFamily: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.FAMILY,
      fontSize: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.SIZE + 'px',
      fontWeight: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.BOLD ? 'bold' : 'normal',
      textAlign: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.ALIGNMENT || 'none',
      textDecoration: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.UNDERLINE ? 'underline' : 'none',
      fontStyle: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.ITALIC ? 'italic' : 'normal',
      color: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.FONT.COLOR,
      wordWrap: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.WORDWRAP ? 'break-word' : 'normal',
      whiteSpace: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.WORDWRAP ? 'normal' : 'nowrap',
      display: _Izenda9.DEFAULT_VALUE_PROPERTIES.HEADERS.DISPLAY
    };
    if (fieldElement.hiddenSortFeature) {
      return title;
    }

    return _react2.default.createElement(
      'span',
      {
        className: clazzName,
        onClick: props.onSortChange(container, fieldElement, sortValue, props.previewRecords)
      },
      _react2.default.createElement(
        'a',
        null,
        title
      ),
      _react2.default.createElement('i', { className: className, style: defaultStyle })
    );
  });

  this.renderPrintingMode = function () {
    var props = _this3.props,
        _props2 = _this3.props,
        printingMode = _props2.printingMode,
        exportFormatSetting = _props2.exportFormatSetting,
        reportPart = _props2.reportPart,
        usePageBreakAfterSeparator = _props2.reportPart.reportPartContent.usePageBreakAfterSeparator;


    return _react2.default.createElement(
      'div',
      { style: _Izenda28.default.getReportPartContainerStyle(props) },
      _react2.default.createElement(
        'div',
        { className: _Izenda28.default.getReportPartClassName(props) },
        !usePageBreakAfterSeparator && _react2.default.createElement(_Izenda15.default, {
          mode: _Izenda16.REPORT_PART_MODE.PREVIEW,
          reportPart: reportPart,
          className: 'u_marginBottom izenda-reportPartGrid_title'
        }),
        _this3.renderMainComponent(true),
        _react2.default.createElement(_Izenda8.default, {
          reportPart: reportPart,
          staticRender: true,
          printingMode: printingMode,
          exportFormatSetting: exportFormatSetting
        })
      )
    );
  };

  this.renderNormalMode = function () {
    var _props3 = _this3.props,
        viewMode = _props3.viewMode,
        reportPart = _props3.reportPart,
        printingMode = _props3.printingMode,
        renderMainComponent = _this3.renderMainComponent,
        goToPage = _this3.goToPage,
        onPageSizeChange = _this3.onPageSizeChange;


    return _react2.default.createElement(
      _Izenda20.default,
      { className: 'izenda-GridFrontSide' },
      _react2.default.createElement(_Izenda15.default, { mode: _Izenda16.REPORT_PART_MODE.PREVIEW, reportPart: reportPart }),
      _react2.default.createElement(
        _Izenda20.default.Row,
        null,
        _react2.default.createElement(
          _Izenda20.default.Col,
          { cols: '12' },
          renderMainComponent()
        )
      ),
      _react2.default.createElement(
        _Izenda20.default.Row,
        null,
        _react2.default.createElement(_Izenda8.default, { reportPart: reportPart })
      ),
      !printingMode && _react2.default.createElement(
        _Izenda20.default.Row,
        null,
        _react2.default.createElement(
          _Izenda20.default.Col,
          { cols: '12' },
          _react2.default.createElement(GridPaginator, {
            onChange: goToPage,
            onDropdownChange: onPageSizeChange,
            reportPart: reportPart,
            canChangePageSize: !viewMode
          })
        )
      )
    );
  };

  this.goToPage = function (pageIndex) {
    var props = _this3.props,
        reportPart = _this3.props.reportPart;

    props.needUpdatePreview(reportPart, null, pageIndex, null, null, _this3.props.previewRecords);
  };

  this.onPageSizeChange = function (pageSize) {
    var props = _this3.props,
        reportPart = _this3.props.reportPart;


    reportPart.reportPartContent.changePageSize(pageSize);
    props.needUpdatePreview(reportPart, null, NUMBER_ONE, null, null, _this3.props.previewRecords);
  };

  this.renderMainComponent = function (staticRender) {
    var props = _this3.props,
        _props4 = _this3.props,
        reportPart = _props4.reportPart,
        previewDataRecords = _props4.reportPart.previewDataRecords;


    if (!reportPart.isBeingBuild) {
      return null;
    }
    if (!(0, _fp.isEmpty)(previewDataRecords)) {
      var GridComponent = _this3.getGridByName();
      var restProps = (0, _fp.omit)(['finishedRender', 'onSortChange'], props);

      if (reportPart.reportPartContent.useSeparator) {
        return _react2.default.createElement(_Izenda6.default, (0, _extends3.default)({
          records: previewDataRecords,
          mainComponent: GridComponent
        }, restProps, {
          renderHeader: _this3.renderHeader(props),
          finishedRender: _Izenda28.default.getFinishedRenderPromiseById(_this3.renderListeners, _this3.mainComponentKey)
        }));
      }
      return _react2.default.createElement(GridComponent, (0, _extends3.default)({
        records: previewDataRecords
      }, restProps, {
        staticRender: staticRender,
        renderHeader: _this3.renderHeader(props),
        finishedRender: _Izenda28.default.getFinishedRenderPromiseById(_this3.renderListeners, _this3.mainComponentKey)
      }));
    }

    return reportPart.isLoadingData ? null : _react2.default.createElement(_Izenda2.default, null);
  };

  this.getGridByName = function () {
    var gridStyle = _this3.props.reportPart.reportPartContent.properties.generalInfo.gridStyle;

    switch (gridStyle) {
      case _Izenda10.default.GRID_STYLES.PIVOT.value:
        // Pivot
        return _Izenda12.default;
      case _Izenda10.default.GRID_STYLES.DRILL_DOWN.value:
        // Drilldown
        return _Izenda12.default;
      default:
        return _Izenda4.default;
    }
  };
}, _temp)) || _class);
exports.default = ReportPartGridFrontSide;
module.exports = exports['default'];

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.GrandTotalGrid.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GrandTotalGrid component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(84);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1958);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(294);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(88);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(12);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(76);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(35);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GrandTotalGrid = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GrandTotalGrid, _Component);

  function GrandTotalGrid() {
    (0, _classCallCheck3.default)(this, GrandTotalGrid);
    return (0, _possibleConstructorReturn3.default)(this, (GrandTotalGrid.__proto__ || (0, _getPrototypeOf2.default)(GrandTotalGrid)).apply(this, arguments));
  }

  (0, _createClass3.default)(GrandTotalGrid, [{
    key: 'render',
    value: function render() {
      var reportPart = this.props.reportPart;
      var previewData = reportPart.previewData;
      var className = (0, _classnames2.default)('grant-total', {
        hide: (0, _fp.isEmpty)(previewData.grandTotalMapping),
        'has-separator': reportPart.reportPartContent.useSeparator
      });
      var reportPartElementMapping = this.getReportPartElementMapping(previewData.grandTotalMapping);

      if (!(0, _fp.isEmpty)(previewData.grandTotalMapping)) {
        var horizontalElementTypes = this.getHorizontalElementTypes();
        var horizontalRecords = this.getHorizontalRecords(reportPartElementMapping, horizontalElementTypes);
        return this.props.printingMode ? this.renderPrintingMode(reportPartElementMapping, horizontalElementTypes, horizontalRecords, className) : this.renderNormalMode(reportPartElementMapping, horizontalElementTypes, horizontalRecords, className);
      } else {
        return null;
      }
    }
  }, {
    key: 'renderNormalMode',
    value: function renderNormalMode(reportPartElementMapping, horizontalElementTypes, horizontalRecords, className) {
      return _react2.default.createElement(
        _Izenda6.default.Col,
        { className: className },
        _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({
          records: horizontalRecords
        }, this.props, {
          useFieldNameAlias: true,
          staticRender: this.props.staticRender,
          reportPartElementTypes: horizontalElementTypes
        })),
        _react2.default.createElement(
          'div',
          { className: 'grand-table' },
          this.renderVerticalGrandTotals(reportPartElementMapping, horizontalElementTypes, horizontalRecords)
        )
      );
    }
  }, {
    key: 'renderPrintingMode',
    value: function renderPrintingMode(reportPartElementMapping, horizontalElementTypes, horizontalRecords, className) {
      var props = this.props;
      var printingClassName = (0, _classnames2.default)(className, _Izenda14.default.getSeparatorClassName(props));

      return _react2.default.createElement(
        'div',
        { style: _Izenda14.default.getSeparatorContainerStyle(props) },
        _react2.default.createElement(
          'div',
          { className: printingClassName },
          _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({
            records: horizontalRecords
          }, this.props, {
            useFieldNameAlias: true,
            staticRender: this.props.staticRender,
            reportPartElementTypes: horizontalElementTypes
          })),
          _react2.default.createElement(
            'div',
            { className: 'grand-table' },
            this.renderVerticalGrandTotals(reportPartElementMapping, horizontalElementTypes, horizontalRecords)
          )
        )
      );
    }

    /**
     * render vertical (right) grand totals
     * @param  [array] reportPartElementMapping
     * @param  [array] verticalElementTypes
     * @return [array]
     */

  }, {
    key: 'renderVerticalGrandTotals',
    value: function renderVerticalGrandTotals(reportPartElementMapping, horizontalElementTypes, horizontalRecords) {
      if (!(0, _fp.isNil)(reportPartElementMapping)) {
        var previewData = this.props.reportPart.previewData;
        var columns = [];
        var record = {};

        if (!(0, _fp.isEmpty)(previewData)) {
          record = previewData.records[0];
        }

        // render Total Grand Label for Horizontal values
        columns.push(this.renderHorizontalGrandLabel(horizontalRecords));

        // render vertical rows
        var verticalRows = this.renderVerticalRows(reportPartElementMapping, horizontalElementTypes, record);
        if (!(0, _fp.isEmpty)(verticalRows)) {
          columns.push(verticalRows);
        }

        return columns;
      }
      return '';
    }

    /**
     * render horizontal Total Grand label
     * @param  [array] horizontalRecords
     * @return [array] array of horizontal Total Grand label
     */

  }, {
    key: 'renderHorizontalGrandLabel',
    value: function renderHorizontalGrandLabel(horizontalRecords) {
      var records = [];
      (0, _fp.forEach)(function (element, index) {
        records.push(_react2.default.createElement(
          'div',
          { className: 'grand-row', key: 'hor-' + element.fieldNameAlias },
          _react2.default.createElement(
            'div',
            { className: 'grand-column' },
            _react2.default.createElement(
              'div',
              { className: 'grand-cell-content u_paddingAll' },
              element.grandTotalLabel
            )
          )
        ));
      }, horizontalRecords);
      return records;
    }

    /**
     * render separator lines
     */

  }, {
    key: 'renderSeparatorLine',
    value: function renderSeparatorLine() {
      return _react2.default.createElement(
        'div',
        { className: 'grand-row' },
        renderBlankLine(),
        renderBlankLine()
      );
      function renderBlankLine() {
        return _react2.default.createElement(
          'div',
          { className: 'grand-column' },
          _react2.default.createElement('div', { className: 'grand-cell-content blank-line' })
        );
      }
    }

    /**
     * render vertical rows
     * @param  [array] reportPartElementMapping
     * @param  [array] horizontalElementTypes
     * @param  [object] record
     * @return [array] array of vertical rows
     */

  }, {
    key: 'renderVerticalRows',
    value: function renderVerticalRows(reportPartElementMapping, horizontalElementTypes, record) {
      var _this2 = this;

      var verticalRows = [];
      // render vertical Grand Total rows
      (0, _keys2.default)(reportPartElementMapping).forEach(function (key, index) {
        // skip this key if it exists in horizontalElementTypes list
        var isHorizontalType = (0, _fp.findIndex)(function (o) {
          return o === key;
        }, horizontalElementTypes);
        if (isHorizontalType >= 0) {
          return;
        }

        // create separator line
        if (verticalRows.length > 0 && !(0, _fp.isEmpty)(reportPartElementMapping[key])) {
          verticalRows.push(_this2.renderSeparatorLine());
        }

        // render vertical columns
        if (!(0, _fp.isEmpty)(reportPartElementMapping[key])) {
          verticalRows.push(_this2.renderVerticalColumns(reportPartElementMapping, key, record));
        }
      });

      return !(0, _fp.isEmpty)(verticalRows) ? _react2.default.createElement(
        'div',
        { className: 'grand-row' },
        _react2.default.createElement(
          'div',
          { className: 'grand-column' },
          _react2.default.createElement(
            'div',
            { className: 'grand-table' },
            verticalRows
          )
        )
      ) : null;
    }

    /**
     * render vertical columns
     * @param  [array] reportPartElementMapping
     * @param  [object] key
     * @param  [object] record
     * @return [array] array of vertical columns
     */

  }, {
    key: 'renderVerticalColumns',
    value: function renderVerticalColumns(reportPartElementMapping, key, record) {
      var verticalColumns = [];
      (0, _fp.forEach)(function (element, index) {
        var colValue = record[element.columnName];
        verticalColumns.push(_react2.default.createElement(
          'div',
          { className: 'grand-row', key: 'ver-' + element.fieldNameAlias },
          _react2.default.createElement(
            'div',
            { className: 'grand-column no-border-left' },
            _react2.default.createElement(
              'div',
              { className: 'grand-cell-content' },
              String.format(_Izenda12.default.getText('REPORTDESIGNER_LABEL_GRANDTOTAL_FOR'), element.grandTotalLabel, element.fieldNameAlias)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'grand-column' },
            _react2.default.createElement(
              'div',
              { className: 'grand-cell-content' },
              (0, _Izenda15.applyFormater)(element.grandTotalDataType, element.grandTotalFormat, colValue)
            )
          )
        ));
      }, reportPartElementMapping[key]);
      return verticalColumns;
    }

    /**
     * separate grandTotalMappings into 4 types ['columns', 'rows', 'values', 'separators']
     * @param  [array] grandTotalMapping
     * @return [array] array of reportPartElements
     */

  }, {
    key: 'getReportPartElementMapping',
    value: function getReportPartElementMapping(grandTotalMapping) {
      var reportPartElementTypes = ['columns', 'rows', 'values', 'separators'];
      var reportPartContent = this.props.reportPart.reportPartContent;
      var reportPartElementMapping = {};

      (0, _fp.forEach)(function (elementType) {
        reportPartElementMapping[elementType] = [];
        (0, _fp.forEach)(function (mapping) {
          var matchedMapping = (0, _fp.find)({ name: mapping.fieldNameAlias }, reportPartContent[elementType].visibleElement);
          if (matchedMapping) {
            mapping.grandTotalLabel = matchedMapping.properties.dataFormattings.grandTotal.label || mapping.fieldNameAlias;
            mapping.grandTotalFormat = (0, _fp.get)('properties.dataFormattings.grandTotal.format.format', matchedMapping);
            mapping.grandTotalDataType = matchedMapping.properties.dataFormattings.grandTotal.dataType;
            mapping.fieldFormatData = matchedMapping.fieldFormatData;
            mapping.field = matchedMapping.field;
            reportPartElementMapping[elementType].push(mapping);
          }
        }, grandTotalMapping);
      }, reportPartElementTypes);

      return reportPartElementMapping;
    }
  }, {
    key: 'getHorizontalElementTypes',
    value: function getHorizontalElementTypes() {
      var gridStyle = this.props.reportPart.reportPartContent.properties.generalInfo.gridStyle;
      switch (gridStyle) {
        case _Izenda2.default.GRID_STYLES.VERTICAL.value:
          // Vertical
          return ['columns'];
        case _Izenda2.default.GRID_STYLES.DRILL_DOWN.value:
          // Drilldown
          return ['rows', 'values'];
        case _Izenda2.default.GRID_STYLES.PIVOT.value:
          // Pivot
          return ['rows'];
        default:
          return [];
      }
    }

    /**
     * get list of horizontal records
     * @param  [array] reportPartElementMapping
     * @return [array] array of horizontal records
     */

  }, {
    key: 'getHorizontalRecords',
    value: function getHorizontalRecords(reportPartElementMapping, horizontalElementTypes) {
      if (!(0, _fp.isNil)(reportPartElementMapping)) {
        var previewData = this.props.reportPart.previewData;
        var previewDataFirstRecord = {};
        var records = [];
        if (!(0, _fp.isEmpty)(previewData)) {
          previewDataFirstRecord = previewData.records[0];
        }

        /**
         * process row data for horizontal:
         *  - group similar Grand Total label in 1 row
         *  - otherwise push in new row
         */
        var processHorizontalRows = function processHorizontalRows(type) {
          previewDataFirstRecord && (0, _fp.forEach)(function (element) {
            var matchedRow = (0, _fp.find)(function (_ref) {
              var grandTotalLabel = _ref.grandTotalLabel;

              return grandTotalLabel.toLowerCase() === element.grandTotalLabel.toLowerCase();
            }, records);
            if (matchedRow) {
              // group similar Grand Total label in 1 row
              matchedRow[element.fieldNameAlias] = previewDataFirstRecord[element.columnName];
            } else {
              // push in new row
              var record = {};
              record[element.fieldNameAlias] = previewDataFirstRecord[element.columnName];
              record.grandTotalLabel = element.grandTotalLabel || element.fieldNameAlias;
              record.fieldNameAlias = element.fieldNameAlias;
              records.push(record);
            }
          }, reportPartElementMapping[type]);
        };

        (0, _fp.forEach)(processHorizontalRows, horizontalElementTypes);

        return records;
      }
      return [];
    }
  }]);
  return GrandTotalGrid;
}(_react.Component), _class2.propTypes = {
  reportPart: _react.PropTypes.object
}, _temp)) || _class;

exports.default = GrandTotalGrid;
module.exports = exports['default'];

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGrandTotalGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(44);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda4 = __webpack_require__(84);

var _Izenda5 = __webpack_require__(88);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(294);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartGrandTotalGrid = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartGrandTotalGrid, _Component);

  function ReportPartGrandTotalGrid() {
    (0, _classCallCheck3.default)(this, ReportPartGrandTotalGrid);
    return (0, _possibleConstructorReturn3.default)(this, (ReportPartGrandTotalGrid.__proto__ || (0, _getPrototypeOf2.default)(ReportPartGrandTotalGrid)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportPartGrandTotalGrid, [{
    key: 'render',
    value: function render() {
      var gridStyle = (0, _fp.get)('reportPart.reportPartContent.properties.generalInfo.gridStyle', this.props);
      var result = this.generateHeaderData();
      var className = (0, _classnames2.default)('report-part-grid-preview', { hide: (0, _fp.isNil)(result.headers) }, { 'vertical-grid': gridStyle === _Izenda4.GRID_STYLES.VERTICAL.value }, { 'horizontal-grid': gridStyle === _Izenda4.GRID_STYLES.HORIZONTAL.value });
      var records = this.props.isPreview ? (0, _fp.take)(_Izenda4.RECORDS_MAX_LENGTH, result.records) : result.records;
      var gridWidth = (0, _fp.get)('reportPartContent.properties.columns.width.value', this.props.reportPart);

      return !(0, _fp.isEmpty)(records) && _react2.default.createElement(
        'section',
        { className: className },
        _react2.default.createElement(
          _Izenda3.Table,
          {
            showScroll: false,
            dataSource: records,
            className: 'custom-table',
            autoResize: !(gridWidth > 0),
            staticRender: this.props.staticRender
          },
          this.renderColumn(result.headers, result.records.length)
        )
      );
    }

    /**
     * Render column
     * @param {Array} headers 
     */

  }, {
    key: 'renderColumn',
    value: function renderColumn(headers) {
      var reportPart = this.props.reportPart;

      var properties = reportPart.getReportPartProperties();
      var columns = [];
      var isHorizontal = properties.generalInfo.gridStyle === _Izenda4.GRID_STYLES.HORIZONTAL.value;

      headers && headers.map(function (header, index) {
        var renderColumnContent = function renderColumnContent(dataRow) {
          // get cell data from vertical/horizontal table
          var cell = !(0, _fp.isNil)(dataRow[header.columnKey]) ? dataRow[header.columnKey] : dataRow[index];
          var cellData = cell && !(0, _fp.isNil)(cell.data) ? cell.data : cell;

          return _react2.default.createElement(
            'span',
            { key: cellData, title: cellData, className: cell && cell.className || dataRow.className },
            cellData
          );
        };

        var getCellStyle = function getCellStyle(dataRow, isHeader) {
          var item = (0, _fp.get)('style.header', dataRow) || (isHeader ? header.style : header.cellStyle);
          if (!item) return {};
          var fontFamily = item.fontFamily,
              fontSize = item.fontSize,
              bold = item.bold,
              alignment = item.alignment,
              underline = item.underline,
              italic = item.italic,
              textColor = item.textColor,
              backgroundColor = item.backgroundColor,
              wordWrap = item.wordWrap,
              height = item.height;

          var result = (0, _fp.defaults)(_Izenda4.DEFAULT_CELL_STYLE, {
            fontFamily: fontFamily,
            fontSize: fontSize + 'px',
            fontWeight: bold ? 'bold' : 'normal',
            textAlign: alignment || 'none',
            textDecoration: underline ? 'underline' : 'none',
            fontStyle: italic ? 'italic' : 'normal',
            wordWrap: wordWrap ? 'break-word' : 'normal',
            whiteSpace: wordWrap ? 'normal' : 'nowrap',
            height: wordWrap ? null : height || null
          });

          if (isHeader) {
            result.color = textColor;
            result.backgroundColor = backgroundColor;
          }

          return result;
        };

        // Get header cell style
        var getHeaderCellStyle = function getHeaderCellStyle(dataRow) {
          return getCellStyle(dataRow, true);
        };

        // Get content cell style
        var getContentCellStyle = function getContentCellStyle(dataRow) {
          return getCellStyle(dataRow, false);
        };

        // Function to get content style
        var fnGetCellContentStyle = function fnGetCellContentStyle(dataRow) {
          if (isHorizontal && index === 0) {
            return (0, _fp.defaults)(_Izenda4.DEFAULT_CELL_STYLE, getHeaderCellStyle(dataRow));
          }

          if (isHorizontal && index !== 0 || !isHorizontal) {
            return (0, _fp.defaults)(_Izenda4.DEFAULT_CELL_STYLE, getContentCellStyle(dataRow));
          }

          return _Izenda4.DEFAULT_CELL_STYLE;
        };

        columns.push(_react2.default.createElement(_Izenda3.Column, (0, _extends3.default)({
          key: header.columnKey
        }, header, {
          cell: renderColumnContent,
          fnGetCellContentStyle: fnGetCellContentStyle,
          fnGetHeaderCellContentStyle: getHeaderCellStyle
        })));
      });

      return columns;
    }

    /**
     * Parse data formatting
     * @param  {string} dataType      [description]
     * @param  {string} pattern       [description]
     * @param  {Array<any>}  listRecords   [description]
     * @param  {any} fieldsMapping [description]
     * @return {Array<any>}                [description]
     */

  }, {
    key: 'parseDataFormat',
    value: function parseDataFormat(dataType, pattern, listRecords, fieldsMapping) {
      var convertFn = dataType === 'Datetime' ? _Izenda6.default : _Izenda8.default;
      (0, _fp.forEach)(function (record) {
        if (!(0, _fp.isNil)(record[fieldsMapping])) {
          record[fieldsMapping] = convertFn(pattern, record[fieldsMapping]);
        }
      }, listRecords);

      return listRecords;
    }

    // Generate header data

  }, {
    key: 'generateHeaderData',
    value: function generateHeaderData() {
      var _this2 = this;

      var _props = this.props,
          reportPart = _props.reportPart,
          _props$reportPart = _props.reportPart,
          previewDataFieldsMapping = _props$reportPart.previewDataFieldsMapping,
          reportPartContent = _props$reportPart.reportPartContent,
          records = _props.records,
          reportPartElementTypes = _props.reportPartElementTypes,
          useFieldNameAlias = _props.useFieldNameAlias;
      var columns = reportPartContent.columns,
          _reportPartContent$pr = reportPartContent.properties,
          columnSetting = _reportPartContent$pr.columns,
          rowSetting = _reportPartContent$pr.rows;

      var headers = [];
      var newRecords = (0, _mobx.toJS)(records);
      var properties = reportPart.getReportPartProperties();
      var reportPartHeaderProperties = properties.headers;

      var subTotalRecord = {};
      var maxHeaderHeight = (0, _fp.flow)((0, _fp.map)((0, _fp.get)('properties.headerFormating.height')), _fp.max)(columns.visibleElement);
      var tableColumnWidth = (0, _fp.get)('width.value', columnSetting);

      if (!(0, _fp.isEmpty)(reportPartElementTypes)) {
        (0, _fp.forEach)(function (type) {
          (0, _fp.forEach)(function (element) {
            // get field mapping
            var fieldNameAlias = element.field.fieldNameAlias,
                elementProperties = element.properties;

            var fieldsMapping = (0, _fp.find)({ fieldNameAlias: fieldNameAlias }, previewDataFieldsMapping);
            var width = (0, _fp.get)('properties.dataFormattings.width.value', element);

            if (fieldsMapping) {
              var style = elementProperties.getHeaderCellStyle(reportPartHeaderProperties);
              var cellStyle = elementProperties.getUIStyle();
              style.height = maxHeaderHeight || rowSetting.height;
              cellStyle.height = rowSetting.height;
              headers.push({
                fieldId: fieldsMapping.fieldId,
                columnKey: useFieldNameAlias ? fieldNameAlias : fieldsMapping.columnName,
                title: fieldNameAlias,
                width: width ? width : tableColumnWidth,
                style: style,
                height: rowSetting.height,
                cellStyle: cellStyle,
                element: element
              });

              var grandTotal = (0, _fp.get)('dataFormattings.grandTotal', elementProperties);
              // conver to data format
              if (grandTotal.format.format) {
                newRecords = _this2.parseDataFormat(grandTotal.dataType, grandTotal.format.format, newRecords, fieldsMapping.fieldNameAlias);
              }
            }
          }, reportPartContent[type].visibleElement);
        }, reportPartElementTypes);

        // push subtotal into datasource record of grid
        !(0, _fp.isEmpty)(subTotalRecord) ? newRecords.push(subTotalRecord) : null;
      }

      return {
        headers: headers,
        records: newRecords
      };
    }
  }]);
  return ReportPartGrandTotalGrid;
}(_react.Component), _class2.propTypes = {
  reportPart: _propTypes2.default.object.isRequired,
  records: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired,
  reportPartElementTypes: _propTypes2.default.array
}, _temp)) || _class);
exports.default = ReportPartGrandTotalGrid;
module.exports = exports['default'];

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridPivot.js" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridPivot component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(44);

var _Izenda4 = __webpack_require__(1960);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(1961);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(84);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(320);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(321);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(35);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(1962);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(409);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(76);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(1963);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartGridPivot = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ReportPartGridPivot, _Component);

  function ReportPartGridPivot() {
    (0, _classCallCheck3.default)(this, ReportPartGridPivot);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartGridPivot.__proto__ || (0, _getPrototypeOf2.default)(ReportPartGridPivot)).call(this));

    _this.renderPageBreakPerPivotColumnSideTotaltable = function (columnDataObjects, numberOfRow, columnLocInfo) {
      var firstItem = (0, _fp.head)(columnDataObjects);
      var lastItem = (0, _fp.last)(columnDataObjects);

      return (0, _fp.flatMap)(function (header) {
        if (header.type === _Izenda13.default.COLUMN_TYPE.COLUMN && (0, _fp.every)({ type: _Izenda13.default.COLUMN_TYPE.VALUE }, header.childs)) {
          return [];
        }

        var currentColumnLocInfo = (0, _fp.clone)(columnLocInfo);

        if (currentColumnLocInfo.firstColumn && header !== firstItem) {
          currentColumnLocInfo.firstColumn = false;
        }

        if (currentColumnLocInfo.lastColumn && header !== lastItem) {
          currentColumnLocInfo.lastColumn = false;
        }

        var childSideTotalColumnLocInfo = (0, _fp.clone)(currentColumnLocInfo);

        childSideTotalColumnLocInfo.lastColumn = false;

        var childSideTotal = _this.renderPageBreakPerPivotColumnSideTotaltable(header.childs, numberOfRow, childSideTotalColumnLocInfo);

        currentColumnLocInfo.firstColumn && !(0, _fp.isEmpty)(childSideTotal) && (currentColumnLocInfo.firstColumn = false);
        // all child's side total will appear before self side total;

        return (0, _fp.concat)(childSideTotal, _this.renderExpandSideTotal(header, numberOfRow, currentColumnLocInfo));
      }, columnDataObjects);
    };

    _this.renderChildPage = function (childPages, numberOfRow, columnLocInfoOriginal) {
      var lastColumnIndex = childPages.length - 1;

      return childPages.map(function (childPage, index) {
        var currentColumnLocInfo = (0, _fp.clone)(columnLocInfoOriginal);

        currentColumnLocInfo.firstColumn && index !== 0 && (currentColumnLocInfo.firstColumn = false);
        currentColumnLocInfo.lastColumn && index !== lastColumnIndex && (currentColumnLocInfo.lastColumn = false);
        return _this.renderGroupingHeadersExporting(childPage, numberOfRow, currentColumnLocInfo);
      });
    };

    _this.renderPageBreakPerPivotColumnTable = function (dataRow, numberOfRow) {
      var _this$props = _this.props,
          columnDataObjects = _this$props.columnDataObjects,
          sideTotalColumns = _this$props.sideTotalColumns,
          pivotColumnsPerExportedPage = _this$props.pivotColumnsPerExportedPage,
          fullRowHeader = _this$props.fullRowHeader,
          onlyColumnGroupRowHeader = _this$props.onlyColumnGroupRowHeader,
          haveGroupForRow = _this$props.haveGroupForRow,
          afterRenderCallBack = _this$props.afterRenderCallBack,
          staticRender = _this$props.staticRender,
          reportPart = _this$props.reportPart,
          getStickyValue = _this$props.getStickyValue;


      var properties = reportPart.getReportPartProperties();
      var lastPageRowColumnLogInfo = { firstColumn: true, lastColumn: false, deep: 0 };
      var rowColumnHeader = _this.renderGroupingHeaders(fullRowHeader, numberOfRow, lastPageRowColumnLogInfo);

      var pages = _Izenda17.default.breakPage(columnDataObjects, pivotColumnsPerExportedPage);
      var lastPageColumnLogInfo = { firstColumn: true, lastColumn: true, deep: 0 };

      var pagesVirtualDom = (0, _fp.flow)((0, _fp.map)(function (childPages) {
        return _this.renderChildPage(childPages, numberOfRow, lastPageColumnLogInfo);
      }), (0, _fp.map)((0, _fp.concat)(rowColumnHeader)))(pages);

      // last page is for side total column.
      if (!(0, _fp.isEmpty)(sideTotalColumns)) {
        var lastPageRow = _this.renderGroupingHeaders(onlyColumnGroupRowHeader, numberOfRow, lastPageRowColumnLogInfo);
        var lastPageColumn = _this.renderPageBreakPerPivotColumnSideTotaltable(columnDataObjects, numberOfRow, lastPageRowColumnLogInfo);

        var allSideTotalColumnLogInfo = { firstColumn: false, lastColumn: true, deep: 0 };
        var allSideTotal = _this.renderGroupingHeaders(sideTotalColumns, numberOfRow, allSideTotalColumnLogInfo);

        var sideTotalColumn = (0, _fp.concat)(lastPageColumn, allSideTotal);

        if (haveGroupForRow) {
          sideTotalColumn = [_react2.default.createElement(
            _Izenda3.ColumnGroup,
            { isHidden: true, key: 'sideTotal' },
            sideTotalColumn
          )];
        }

        var lastPage = (0, _fp.concat)(lastPageRow, sideTotalColumn);

        pagesVirtualDom = (0, _fp.concat)(pagesVirtualDom, [lastPage]);
      }

      return _react2.default.createElement(
        'section',
        null,
        pagesVirtualDom.map(function (pageVirtualDom, index) {
          return _react2.default.createElement(
            'section',
            { key: index, className: 'report-part-grid-preview' },
            index > 0 && _react2.default.createElement('div', { className: 'u_alwaysBreakAfter' }),
            _react2.default.createElement(
              _Izenda3.Table,
              {
                showScroll: false,
                dataSource: dataRow,
                className: 'custom-table pivot-table',
                autoResize: false,
                afterRenderCallBack: afterRenderCallBack,
                staticRender: staticRender,
                onResizeStopCallback: _this.onResizeStopCallback,
                stickVertical: getStickyValue(properties.isHeaderStickVertical),
                stickHorizontal: getStickyValue(properties.isHeaderStickHorizontal)
              },
              pageVirtualDom
            )
          );
        })
      );
    };

    _this.renderTable = function (dataRow, numberOfRow) {
      var _this$props2 = _this.props,
          localization = _this$props2.localization,
          pageColumnHeader = _this$props2.pageColumnHeader,
          forDrillDown = _this$props2.forDrillDown,
          reportPart = _this$props2.reportPart,
          expandAll = _this$props2.expandAll,
          collapseAll = _this$props2.collapseAll,
          afterRenderCallBack = _this$props2.afterRenderCallBack,
          staticRender = _this$props2.staticRender,
          getStickyValue = _this$props2.getStickyValue;

      var properties = reportPart.getReportPartProperties();

      return _react2.default.createElement(
        'section',
        null,
        forDrillDown && !reportPart.reportPartContent.useSeparator && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('span', {
            className: 'icon-plus-circled',
            title: localization.getText('REPORT_PART_GRID_CONSTANTS_LABEL_EXPAND_ALL_TOOLTIP'),
            onClick: expandAll
          }),
          _react2.default.createElement('span', {
            className: 'icon-minus-circled',
            title: localization.getText('REPORT_PART_GRID_CONSTANTS_LABEL_COLLAPSE_ALL_TOOLTIP'),
            onClick: collapseAll
          })
        ),
        pageColumnHeader.map(function (page, index) {
          return _react2.default.createElement(
            'section',
            { key: index, className: 'report-part-grid-preview' },
            index > 0 && _react2.default.createElement('div', { className: 'u_alwaysBreakAfter' }),
            _react2.default.createElement(
              _Izenda3.Table,
              {
                showScroll: false,
                dataSource: dataRow,
                className: 'custom-table pivot-table',
                autoResize: false,
                afterRenderCallBack: afterRenderCallBack,
                staticRender: staticRender,
                onResizeStopCallback: _this.onResizeStopCallback,
                stickVertical: getStickyValue(properties.isHeaderStickVertical),
                stickHorizontal: getStickyValue(properties.isHeaderStickHorizontal)
              },
              _this.renderGroupingHeaders(page, numberOfRow)
            )
          );
        })
      );
    };

    _this.onResizeStopCallback = function (resizeInfo) {
      var index = resizeInfo.index,
          columnWidth = resizeInfo.columnWidth;
      var reportPartContent = _this.props.reportPart.reportPartContent;
      var rowCollection = reportPartContent.rows.elements,
          valueCollection = reportPartContent.values.elements,
          gridStyle = reportPartContent.gridStyle;

      var isPivotGrid = gridStyle === _Izenda9.default.GRID_STYLES.PIVOT.value;

      // Pivot cannot change value element width by resizer, only Drilldown
      var field = index < rowCollection.length ? (0, _fp.find)({ position: index + 1 }, rowCollection) : isPivotGrid ? null : (0, _fp.find)({ position: index - rowCollection.length + 1 }, valueCollection);

      field && field.updateColumnWidth(columnWidth);
    };

    _this.renderCollapsedSideTotal = function (sideTotals, numberOfRow, level, collapsedCurrrentColumnLocInfo) {
      var blankHeader = _Izenda11.default.createBlankHeaders(1, level - 1, sideTotals, true);

      return _this.renderGroupingHeaders([blankHeader], numberOfRow, collapsedCurrrentColumnLocInfo);
    };

    _this.renderCollapsedIcon = function (header) {
      var props = _this.props;
      var columnExpanders = (0, _fp.getOr)(false, 'reportPart.reportPartContent.columns.properties.useExpanders', props);
      var classNameExpandCollapse = (0, _classnames2.default)('custom-expand-collapse-icon', header.isExpand ? 'icon-minus-circled' : 'icon-plus-circled');
      // condition for appear expand/collapse icon
      var condition = !header.isLeaf && header.sideTotals && header.sideTotals.length > 0 && columnExpanders && !props.printingMode;

      return condition ? _react2.default.createElement('span', { className: classNameExpandCollapse, onClick: header.toggleExpand.bind(header) }) : null;
    };

    _this.renderExpandSideTotal = function (header, numberOfRow, currentColumnLocInfo) {
      var props = _this.props;
      var gridWidth = (0, _fp.get)('reportPart.reportPartContent.properties.columns.width.value', props);
      var _this$props3 = _this.props,
          getCellData = _this$props3.getCellData,
          getCellStyle = _this$props3.getCellStyle,
          getCellContentStyle = _this$props3.getCellContentStyle,
          fnGetHeaderCellStyle = _this$props3.fnGetHeaderCellStyle,
          fnGetHeaderCellContentStyle = _this$props3.fnGetHeaderCellContentStyle;

      var sortSideTotal = (0, _fp.sortBy)('element.position', header.sideTotals);
      var lastIndexSideTotal = sortSideTotal.length - 1;

      return sortSideTotal.map(function (sideTotal, sideTotalIndex) {
        var getSupTotalTitle = function getSupTotalTitle() {
          return sideTotal.sideTotalTitle;
        };
        var sideTotalColumnLocInfo = (0, _fp.clone)(currentColumnLocInfo);

        sideTotalColumnLocInfo.firstColumn && sideTotalIndex !== 0 && (sideTotalColumnLocInfo.firstColumn = false);
        sideTotalColumnLocInfo.lastColumn && sideTotalIndex !== lastIndexSideTotal && (sideTotalColumnLocInfo.lastColumn = false);

        var columnWidthValue = (0, _fp.get)('element.properties.dataFormattings.width.value', sideTotal);
        var width = columnWidthValue || gridWidth || undefined;

        return _react2.default.createElement(_Izenda3.Column, {
          getTitle: getSupTotalTitle,
          width: width,
          cell: _this.renderCellContent.bind(_this, sideTotal),
          fnGetCellData: getCellData(sideTotal),
          fnGetCellStyle: getCellStyle(sideTotal, sideTotalColumnLocInfo, numberOfRow),
          fnGetCellContentStyle: getCellContentStyle(sideTotal),
          fnGetHeaderCellStyle: fnGetHeaderCellStyle(sideTotal, sideTotalColumnLocInfo, numberOfRow),
          fnGetHeaderCellContentStyle: fnGetHeaderCellContentStyle(sideTotal),
          key: sideTotal.key
        });
      });
    };

    _this.getTitle = function (header, afterRenderCallBack) {
      var _this$props4 = _this.props,
          reportPart = _this$props4.reportPart,
          renderHeader = _this$props4.renderHeader,
          printingMode = _this$props4.printingMode,
          getFilterInfoForSubReport = _this$props4.getFilterInfoForSubReport;

      var previewDataFieldsMapping = reportPart.previewDataFieldsMapping;
      var title = header.title;
      var fieldElement = (0, _fp.get)('element', header);

      if (header.isLeaf || !fieldElement) {
        if (header.type !== _Izenda13.default.COLUMN_TYPE.ROW) {
          return title;
        }
        return renderHeader(reportPart.reportPartContent.rows, fieldElement, title, afterRenderCallBack);
      }
      var fieldElementProperties = (0, _fp.get)('properties', fieldElement);
      var rawRecord = header.data;

      title = _Izenda15.default.getDataFormat(title, {
        alternativeText: (0, _fp.get)('dataFormattings.alternativeText', fieldElementProperties),
        fieldFormatData: (0, _fp.get)('dataFormattings.format.format', fieldElementProperties),
        fieldDataType: (0, _fp.get)('previewDataType', fieldElement)
      }, {
        element: _Izenda15.default.buildDataSourceElement(reportPart, fieldElement),
        record: rawRecord[0]
      });

      var numberOfPointActions = (0, _fp.get)('numberOfPointActions', fieldElement) || 0;

      if (numberOfPointActions === 0) {
        return title;
      }
      return _Izenda5.default.applySubReportLink(reportPart, title, header, rawRecord, previewDataFieldsMapping, afterRenderCallBack, printingMode, _this.renderListeners, null, getFilterInfoForSubReport);
    };

    _this.renderCellContent = function (columnData, rowData, columnKey, rowIndex, column, columnIndex, afterRenderCallBack, cellData) {
      var value = cellData.value,
          source = cellData.source;
      var _this$props5 = _this.props,
          forDrillDown = _this$props5.forDrillDown,
          subTotalMapping = _this$props5.subTotalMapping,
          reportPart = _this$props5.reportPart,
          printingMode = _this$props5.printingMode,
          getFilterInfoForSubReport = _this$props5.getFilterInfoForSubReport,
          isDisplayRowExpander = _this$props5.isDisplayRowExpander,
          renderExpandIcon = _this$props5.renderExpandIcon;

      var currentRow = rowData.currentRow;
      var currentRowInfo = rowData.rowDataObjects[columnData.uniqueFieldNameAlias];
      var previewDataFieldsMapping = reportPart.previewDataFieldsMapping;
      var reportPartContent = reportPart.reportPartContent;
      var rowExpanders = reportPartContent.haveRowExpander;
      var displayValue = '';

      var fieldElement = columnData.element;

      !!(0, _fp.get)('data', value) && source && (source.record = (0, _fp.head)((0, _fp.get)('currentRow.rowDataObject.data', rowData)));

      var formatDisplayData = function formatDisplayData(originalValue, displayValue) {
        return _Izenda15.default.getDataFormat({
          value: displayValue,
          originalValue: originalValue
        }, {
          alternativeText: (0, _fp.get)('properties.dataFormattings.alternativeText', fieldElement),
          fieldFormatData: (0, _fp.get)('properties.dataFormattings.format.format', fieldElement),
          fieldDataType: (0, _fp.get)('previewDataType', fieldElement)
        }, source);
      };

      if (currentRow.isSupTotalRow && (!forDrillDown || columnData.type !== _Izenda13.default.COLUMN_TYPE.ROW || currentRow.rowDataObject.isExpand)) {
        var isDisplayCell = currentRow.rowDataObject.uniqueFieldNameAlias === columnData.uniqueFieldNameAlias;
        return _react2.default.createElement(_Izenda7.default, {
          fieldElement: fieldElement,
          columnData: columnData,
          rowData: rowData,
          subTotalMapping: subTotalMapping,
          forDrillDown: forDrillDown,
          rowExpanders: rowExpanders,
          isDisplayCell: isDisplayCell
        });
      }

      if (!!value.isEmpty) {
        return null;
      }

      if (!value.isAllRow) {
        displayValue = formatDisplayData(value.orgData, value.data);
        var numberOfPointActions = (0, _fp.get)('element.numberOfPointActions', columnData) || 0;

        if (!value.dataNotFound && numberOfPointActions > 0 && (columnData.type === _Izenda13.default.COLUMN_TYPE.ROW || columnData.type === _Izenda13.default.COLUMN_TYPE.VALUE)) {
          var id = columnIndex + '.' + rowIndex;

          displayValue = _Izenda5.default.applySubReportCellLink(reportPart, displayValue, columnData, rowData, previewDataFieldsMapping, afterRenderCallBack, printingMode, _this.renderListeners, id, getFilterInfoForSubReport);
        }
      } else {
        displayValue = value.data;
      }

      return _react2.default.createElement(
        'span',
        { className: 'u_fullInlineBlock', title: displayValue },
        isDisplayRowExpander(currentRowInfo, columnData) && renderExpandIcon(currentRowInfo.rowDataObject),
        displayValue
      );
    };

    _this.renderGroupingHeadersExporting = function (page, numberOfRow, columnLocInfoOriginal) {
      var props = _this.props;
      var _this$props6 = _this.props,
          getCellData = _this$props6.getCellData,
          fnGetHeaderCellContentForPivotHeader = _this$props6.fnGetHeaderCellContentForPivotHeader;

      var gridWidth = (0, _fp.get)('reportPart.reportPartContent.properties.columns.width.value', props);
      var parentHeader = page.columnDataObject;
      var from = page.from;
      var to = page.to;

      if (parentHeader.type === _Izenda13.default.COLUMN_TYPE.COLUMN && (0, _fp.every)({ type: _Izenda13.default.COLUMN_TYPE.VALUE }, parentHeader.childs)) {
        // if this is last level of Column it only have pivot column = 1;
        return _this.renderGroupingHeaders([parentHeader], numberOfRow, columnLocInfoOriginal)[0];
      }
      var childPages = _Izenda17.default.breakChildrenColumn(parentHeader, from, to);

      var childPageVirtualDom = _this.renderChildPage(childPages, numberOfRow, columnLocInfoOriginal);
      var columnWidthValue = (0, _fp.get)('element.properties.dataFormattings.width.value', parentHeader);
      var width = columnWidthValue || gridWidth || undefined;

      return _react2.default.createElement(
        _Izenda3.ColumnGroup,
        {
          getTitle: _this.getTitle.bind(_this, parentHeader),
          width: width,
          cell: null,
          fnGetCellData: getCellData(parentHeader),
          fnGetCellStyle: _Izenda19.default.getCellStyleForPivotHeader.bind(_this, parentHeader, columnLocInfoOriginal),
          fnGetCellContentStyle: fnGetHeaderCellContentForPivotHeader(parentHeader),
          isHidden: parentHeader.isHidden,
          key: parentHeader.key,
          fnGetHeaderCellStyle: null,
          fnGetHeaderCellContentStyle: null
        },
        childPageVirtualDom
      );
    };

    _this.renderGroupingHeaders = function (columnDataObjects, numberOfRow, columnLocInfoOriginal) {
      var headers = [];
      var _this$props7 = _this.props,
          reportPart = _this$props7.reportPart,
          getCellData = _this$props7.getCellData,
          getCellStyle = _this$props7.getCellStyle,
          fnGetHeaderCellContentForPivotHeader = _this$props7.fnGetHeaderCellContentForPivotHeader,
          getCellContentStyle = _this$props7.getCellContentStyle,
          fnGetHeaderCellStyle = _this$props7.fnGetHeaderCellStyle,
          fnGetHeaderCellContentStyle = _this$props7.fnGetHeaderCellContentStyle;

      var reportPartContent = reportPart.reportPartContent;
      var gridWidth = (0, _fp.get)('properties.columns.width.value', reportPartContent);
      var columnExpanders = (0, _fp.getOr)(false, 'columns.properties.useExpanders', reportPartContent);

      if ((0, _fp.isEmpty)(columnDataObjects)) {
        return null;
      }

      var columnLocInfo = (0, _fp.clone)(columnLocInfoOriginal) || {
        firstColumn: true,
        lastColumn: true,
        deep: 0
      };

      columnLocInfo.deep++;

      var lastColumnIndex = columnDataObjects.length - 1;
      var firstVisibleIndex = (0, _fp.findIndex)((0, _fp.negate)((0, _fp.get)('isHidden')), columnDataObjects);

      columnDataObjects.map(function (header, index) {
        var ComponentType = header.isLeaf ? _Izenda3.Column : _Izenda3.ColumnGroup;

        var currentColumnLocInfo = (0, _fp.clone)(columnLocInfo);

        currentColumnLocInfo.firstColumn && index !== firstVisibleIndex && index !== 0 && (currentColumnLocInfo.firstColumn = false);
        currentColumnLocInfo.lastColumn && index !== lastColumnIndex && (currentColumnLocInfo.lastColumn = false);

        var sideTotalArray = [];

        if (header.isExpand) {
          var sideTotalColumLocInfo = (0, _fp.clone)(currentColumnLocInfo);

          sideTotalColumLocInfo.firstColumn = false;
          sideTotalArray = _this.renderExpandSideTotal(header, numberOfRow, sideTotalColumLocInfo);
        }

        currentColumnLocInfo.lastColumn && !(0, _fp.isEmpty)(sideTotalArray) && (currentColumnLocInfo.lastColumn = false);

        var columnWidthValue = (0, _fp.get)('element.properties.dataFormattings.width.value', header);
        var width = columnWidthValue || gridWidth || undefined;
        header.canRenderHeader = true;
        if (header.element && header.element.properties) {
          header.canRenderHeader = header.element.properties.fieldItemVisible;
        }

        headers.push(_react2.default.createElement(
          ComponentType,
          {
            getTitle: _this.getTitle.bind(_this, header),
            width: width,
            isInvisible: header.isInvisible,
            canRenderHeader: header.canRenderHeader,
            cell: header.isLeaf ? _this.renderCellContent.bind(_this, header) : null,
            fnGetCellData: getCellData(header),
            fnGetCellStyle: header.isLeaf ? getCellStyle(header, currentColumnLocInfo, numberOfRow) : _Izenda19.default.getCellStyleForPivotHeader.bind(_this, header, currentColumnLocInfo),
            fnGetCellContentStyle: header.isLeaf ? getCellContentStyle(header) : fnGetHeaderCellContentForPivotHeader(header),
            key: header.key + index,
            fnGetHeaderCellStyle: header.isLeaf ? fnGetHeaderCellStyle(header, currentColumnLocInfo, numberOfRow) : null,
            fnGetHeaderCellContentStyle: header.isLeaf ? fnGetHeaderCellContentStyle(header) : null,
            iconExpandCollapse: _this.renderCollapsedIcon(header),
            isColumnHeader: header.isColumnHeader && header.level === 1
          },
          header.isExpand || !columnExpanders ? _this.renderGroupingHeaders((0, _fp.sortBy)((0, _fp.getOr)(0, 'element.position'), header.childs), numberOfRow, currentColumnLocInfo) : _this.renderCollapsedSideTotal(header.sideTotals, numberOfRow, header.level, currentColumnLocInfo)
        ));

        headers = (0, _fp.concat)(headers, sideTotalArray);
      });

      return headers;
    };

    _this.renderListeners = [];
    return _this;
  }

  (0, _createClass3.default)(ReportPartGridPivot, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          printingMode = _props.printingMode,
          finishedRender = _props.finishedRender;


      printingMode && _Izenda21.default.publishFinishedRender(this.renderListeners, function () {
        finishedRender && finishedRender();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          rowDataObject = _props2.rowDataObject,
          haveSupTotal = _props2.haveSupTotal,
          forDrillDown = _props2.forDrillDown,
          isPreview = _props2.isPreview,
          allGroupSuptotal = _props2.allGroupSuptotal,
          allRow = _props2.allRow,
          supTotalDataRow = _props2.supTotalDataRow,
          getFirstRecordForDrilldown = _props2.getFirstRecordForDrilldown,
          pageStatus = _props2.pageStatus;


      var newData = _Izenda11.default.flattenRowDataObject(rowDataObject, forDrillDown, haveSupTotal);
      isPreview && (newData = (0, _fp.take)(_Izenda9.default.MAX_ROW, newData));

      // for Pivot only
      allGroupSuptotal && (newData = (0, _fp.concat)(newData, supTotalDataRow));

      // add 'All' row at the first row for drillDown only
      allRow && (newData = getFirstRecordForDrilldown(newData));

      var numberOfRow = newData.length - 1;

      // if sucess render table using strategy 1 include these case :
      // view mode
      // drilldown export mode
      // pivot export mode : all first level have the same pivot column
      if (pageStatus) {
        return this.renderTable(newData, numberOfRow);
      }
      // render pivot table when column not match with number of pivot column per pages;
      return this.renderPageBreakPerPivotColumnTable(newData, numberOfRow);
    }

    // deep first, to get all side total columns.


    // each pages have many ColumnDataObject


    /**
     * Generate ColumnGroup/Column
     * @param  {array} columnDataObjects
     * @return {array} ColumnGroup
     */

  }]);
  return ReportPartGridPivot;
}(_react.Component), _class.propTypes = {
  reportPart: _react.PropTypes.object.isRequired,
  records: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  loader: _react.PropTypes.object.isRequired
}, _temp);
exports.default = (0, _Izenda2.default)(_Izenda23.default)(ReportPartGridPivot);
module.exports = exports['default'];

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReportLink.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var SubReportLink = __webpack_require__(573);

  var ColumnDataObject = __webpack_require__(321);
  var ProcessData = __webpack_require__(320);
  var PrintingUtils = __webpack_require__(76);

  var _require = __webpack_require__(1),
      get = _require.get;

  var applySubReportLink = function applySubReportLink(reportPart, displayValue, columnData, records, previewDataFieldsMapping, afterRenderCallBack, printingMode, renderListeners, id, getFilterInfoForSubReport) {
    var fieldElement = get('element', columnData);
    var rawRecord = ProcessData.buildRawRecordFilterForPivotGrid(columnData, records);

    PrintingUtils.pushRenderListener(renderListeners, id);

    return React.createElement(
      SubReportLink,
      {
        reportPart: reportPart,
        fieldElement: fieldElement,
        afterRenderCallBack: afterRenderCallBack,
        printingMode: printingMode,
        finishedRender: PrintingUtils.getFinishedRenderPromiseById(renderListeners, id),
        getFilterInfoForSubReport: getFilterInfoForSubReport,
        rawRecord: rawRecord
      },
      displayValue
    );
  };

  var applySubReportCellLink = function applySubReportCellLink(reportPart, displayValue, columnData, rowData, previewDataFieldsMapping, afterRenderCallBack, printingMode, renderListeners, id, getFilterInfoForSubReport) {
    var data = [];

    if (columnData.type === ColumnDataObject.COLUMN_TYPE.ROW) {
      data = rowData.rowDataObjects[columnData.uniqueFieldNameAlias].rowDataObject.childsData;
    } else {
      data = rowData.currentRow.rowDataObject.childsData;
    }
    return applySubReportLink(reportPart, displayValue, columnData, data, previewDataFieldsMapping, afterRenderCallBack, printingMode, renderListeners, id, getFilterInfoForSubReport);
  };

  module.exports = {
    applySubReportLink: applySubReportLink,
    applySubReportCellLink: applySubReportCellLink
  };
}();

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridPivot.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridPivot component
 */
!function () {
  var React = __webpack_require__(0);
  var ColumnDataObject = __webpack_require__(321);
  var ProcessData = __webpack_require__(320);
  var connect = __webpack_require__(2);
  var reportPartUtils = __webpack_require__(35);

  var _require = __webpack_require__(1),
      get = _require.get;

  var SubTotalCell = connect()(function (props) {
    var localization = props.localization;
    var rowData = props.rowData;
    var columnData = props.columnData;
    var subTotalMapping = props.subTotalMapping;
    var rowExpanders = props.rowExpanders;
    var forDrillDown = props.forDrillDown;
    var fieldElement = props.fieldElement;
    var value = ProcessData.getDataForCell(columnData, rowData, rowExpanders, forDrillDown, subTotalMapping);

    var dataFormattings = get('element.properties.dataFormattings', columnData);
    var formattedValueData = reportPartUtils.getDataFormat(value.data, {
      alternativeText: get('properties.dataFormattings.alternativeText', fieldElement),
      fieldFormatData: get('format.format', dataFormattings),
      fieldDataType: get('previewDataType', fieldElement)
    });

    if (!value.isEmpty || props.isDisplayCell) {
      var subTotal = dataFormattings.subTotal;
      return React.createElement(
        'span',
        { className: 'sub-total', title: subTotal.label },
        forDrillDown && columnData.type === ColumnDataObject.COLUMN_TYPE.ROW ? String.format(localization.getText('REPORTDESIGNER_LABEL_TOTAL_FOR'), formattedValueData) : formattedValueData
      );
    }
    return null;
  });

  module.exports = SubTotalCell;
}();

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridPivot.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridPivot component
 */
!function () {
  var _require = __webpack_require__(1),
      map = _require.map,
      flow = _require.flow,
      max = _require.max,
      min = _require.min,
      sumBy = _require.sumBy,
      times = _require.times,
      identity = _require.identity,
      filter = _require.filter;

  var markFromTo = function markFromTo(columnDataObjects) {
    var from = 0;

    return map(function (columnDataObject) {
      var to = from + columnDataObject.pivotColumn;
      var result = {
        from: from,
        to: to,
        columnDataObject: columnDataObject
      };

      from = to;
      return result;
    }, columnDataObjects);
  };

  var breakPageFromTo = function breakPageFromTo(mappingData, pageFrom, pageTo) {
    return flow(filter(function (item) {
      return !(item.to <= pageFrom || pageTo <= item.from);
    }), map(function (item) {
      return {
        from: max([pageFrom - item.from, 0]),
        to: min([item.columnDataObject.pivotColumn, pageTo - item.from]),
        columnDataObject: item.columnDataObject
      };
    }))(mappingData);
  };

  var breakChildrenColumn = function breakChildrenColumn(columnDataObject, pageFrom, pageTo) {
    var mappingColumnDataObject = markFromTo(columnDataObject.childs);

    return breakPageFromTo(mappingColumnDataObject, pageFrom, pageTo);
  };

  var breakPage = function breakPage(columnDataObjects, pivotColumnsPerExportedPage) {
    var totalPivotColumn = sumBy('pivotColumn', columnDataObjects);
    var totalPage = Math.ceil(totalPivotColumn / pivotColumnsPerExportedPage);

    var mappingColumnDataObject = markFromTo(columnDataObjects);
    var findPage = flow(times(identity), map(function (pageIndex) {
      var pageFrom = pageIndex * pivotColumnsPerExportedPage;
      var pageTo = (pageIndex + 1) * pivotColumnsPerExportedPage;

      return breakPageFromTo(mappingColumnDataObject, pageFrom, pageTo);
    }))(totalPage);

    return findPage;
  };

  module.exports = {
    breakPage: breakPage,
    breakChildrenColumn: breakChildrenColumn
  };
}();

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(320);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(35);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(78);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(321);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(84);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(409);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLLAPSE_STATUS = _Izenda10.default.COLLAPSE_STATUS;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.ReportPartGridPivotActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function getCellData(props, columnData, rowData) {
  var reportPart = props.reportPart,
      forDrillDown = props.forDrillDown,
      subTotalMapping = props.subTotalMapping;

  var rowExpanders = reportPart.reportPartContent.haveRowExpander;
  var element = columnData.element;

  var value = _Izenda2.default.getDataForCell(columnData, rowData, rowExpanders, forDrillDown, subTotalMapping);

  var source = {
    element: _Izenda4.default.buildDataSourceElement(reportPart, element),
    record: element.properties.hasRangePercent ? (0, _fp.head)(_Izenda2.default.getRawData(columnData, rowData)) : {}
  };

  return { value: value, source: source };
}

function getCellContentStyle(props, columnData, rowData, columnKey, rowIndex, column, columnIndex, cellData) {
  var value = cellData.value,
      source = cellData.source;

  var element = columnData.element;
  var cellStyle = element.properties.getUIStyle();
  var reportPartProperties = props.reportPart.getReportPartProperties();
  var columnAlignment = reportPartProperties.columns.alignment;
  var columnWordWrap = reportPartProperties.columns.wordWrap;

  // Only check wordWrap in Report Part Properties if in FieldProperties, wordWrap is null
  cellStyle.wordWrap = (0, _fp.isNil)(cellStyle.wordWrap) ? columnWordWrap : cellStyle.wordWrap;
  cellStyle.alignment = (0, _fp.isNil)(cellStyle.alignment) ? columnAlignment : cellStyle.alignment;

  var styleObject = _Izenda12.default.createStyleObject(cellStyle);

  if (!!value.isEmpty) {
    return styleObject;
  }

  var dataCellContent = !(0, _fp.isNil)(value.orgData) && value.orgData !== 'null' ? value.orgData : value.data;

  if (!rowData.currentRow.isSupTotalRow) {
    styleObject.color = _Izenda4.default.getConfigDataByRange(dataCellContent, element.properties.dataFormattings.color.textColor, source);
  }

  return styleObject;
}

function getCellStyle(props, columnData, columnLocInfo, numberOfRow, rowData, rowIndex, columnIndex, cellData) {
  var value = cellData.value,
      source = cellData.source;

  var reportPart = props.reportPart;
  var reportPartProperties = reportPart.getReportPartProperties();
  var columnVerticalAlignment = reportPartProperties && reportPartProperties.columns.verticalAlignment;
  var styleObject = {};
  var element = columnData.element;

  // Cell border style
  var borderStyle = _Izenda12.default.getCellStyleSetting(reportPart, columnLocInfo, rowIndex, columnIndex, numberOfRow);
  var currentRow = rowData.currentRow;

  if (!!value.isEmpty || currentRow.isSupTotalRow && (!props.forDrillDown || columnData.type !== _Izenda8.default.COLUMN_TYPE.ROW || currentRow.rowDataObject.isExpand)) {
    return borderStyle;
  }

  var dataCellContent = !(0, _fp.isNil)(value.orgData) && value.orgData !== 'null' ? value.orgData : value.data;

  if (!currentRow.isSupTotalRow) {
    styleObject = {
      backgroundColor: _Izenda4.default.getConfigDataByRange(dataCellContent, element.properties.dataFormattings.color.cellColor, source),
      verticalAlign: element.properties.dataFormattings.verticalAlignment || columnVerticalAlignment
    };
  }

  return (0, _fp.defaults)(borderStyle, styleObject);
}

function fnGetHeaderCellStyle(props, columnData, columnLocInfo, numberOfRow, rowData, rowIndex, columnIndex) {
  var reportPart = props.reportPart;
  var properties = reportPart.getReportPartProperties();
  var reportPartHeaderProperties = properties.headers;

  var headerStyle = _Izenda12.default.getCellStyleSetting(reportPart, columnLocInfo, rowIndex, columnIndex, numberOfRow, true);

  var elementStyle = {
    backgroundColor: columnData.element.properties.getDefaultsHeaderProperty('font.backgroundColor', reportPartHeaderProperties),
    verticalAlign: columnData.element.properties.getDefaultsHeaderProperty('verticalAlignment', reportPartHeaderProperties)
  };

  return (0, _fp.defaults)(headerStyle, elementStyle);
}

function fnGetHeaderCellContentStyle(props, columnData, e) {
  var reportPart = props.reportPart;
  var properties = reportPart.getReportPartProperties();
  var reportPartHeaderProperties = properties.headers;
  var cellStyle = columnData.element.properties.getHeaderCellStyle(reportPartHeaderProperties);

  return _Izenda12.default.createStyleObject(cellStyle);
}

function fnGetHeaderCellContentForPivotHeader(props, columnData, e) {
  var element = columnData.element;
  var reportPart = props.reportPart;

  if ((0, _fp.isNil)(columnData.element)) {
    if (columnData.isColumnGroup) {
      var properties = reportPart.getReportPartProperties();
      var reportPartHeaderProperties = properties.headers;

      return _Izenda12.default.createStyleObject({
        fontFamily: (0, _fp.get)('font.family', reportPartHeaderProperties),
        fontSize: (0, _fp.get)('font.size', reportPartHeaderProperties),
        bold: (0, _fp.get)('font.bold', reportPartHeaderProperties),
        italic: (0, _fp.get)('font.italic', reportPartHeaderProperties),
        underline: (0, _fp.get)('font.underline', reportPartHeaderProperties),
        textColor: (0, _fp.get)('font.color', reportPartHeaderProperties),
        alignment: (0, _fp.get)('alignment', reportPartHeaderProperties),
        wordWrap: (0, _fp.get)('wordWrap', reportPartHeaderProperties)
      });
    }
    return {};
  }
  var records = props.records;

  var _reportPart$getReport = reportPart.getReportPartProperties(),
      columns = _reportPart$getReport.columns;

  var columnAlignment = columns.alignment;
  var columnWordWrap = columns.wordWrap;
  var cellStyle = columnData.element.properties.getUIStyle();
  cellStyle.alignment = (0, _fp.isNil)(cellStyle.alignment) ? columnAlignment : cellStyle.alignment;
  cellStyle.wordWrap = (0, _fp.isNil)(cellStyle.wordWrap) ? columnWordWrap : cellStyle.wordWrap;

  var styleObject = _Izenda12.default.createStyleObject(cellStyle);
  var rawRecord = element.properties.hasRangePercent ? (0, _fp.head)(_Izenda2.default.buildRawRecordFilterForPivotGrid(columnData, records)) : {};

  var dataSource = {
    element: _Izenda4.default.buildDataSourceElement(reportPart, element),
    record: rawRecord
  };

  styleObject.color = _Izenda4.default.getConfigDataByRange(columnData.title, element.properties.dataFormattings.color.textColor, dataSource);

  return styleObject;
}

function isDisplayRowExpander(props, currentRowInfo, columnData) {
  var reportPart = props.reportPart;
  var reportPartContent = reportPart.reportPartContent;
  var rowExpanders = reportPartContent.haveRowExpander;

  return rowExpanders && currentRowInfo && ((currentRowInfo.rowDataObject.size > 1 || props.forDrillDown) && columnData.type === _Izenda8.default.COLUMN_TYPE.ROW && currentRowInfo.firstRow || currentRowInfo.mustHaveExpander);
}
/**
 * render exapand Icon for row
 * @param  {[type]} currentRowDataObject [Current rowDataObject]
 * @return {[type]}                      [description]
 */
function renderExpandIcon(props, currentRowDataObject) {
  var reportPart = props.reportPart,
      loader = props.loader;

  var reportPartContent = reportPart.reportPartContent;
  var rowExpanders = reportPartContent.haveRowExpander;

  if (!currentRowDataObject.isExpandable || !rowExpanders) {
    return null;
  }

  var rowExpandIcon = (0, _classnames2.default)('custom-expand-collapse-icon', currentRowDataObject.isExpand ? 'icon-minus-circled' : 'icon-plus-circled');
  var getSubData = function getSubData() {
    loader.startLoading();
    if (currentRowDataObject.isExpand) {
      if (!(0, _fp.isEmpty)(currentRowDataObject.data) || props.forDrillDown && props.haveSuptotal) {
        currentRowDataObject.toggleExpand();
        loader.endLoading();
      } else {
        props.getDrillDownRecords(reportPart, currentRowDataObject.buildDrillDownParams()).then((0, _mobx.action)(function (previewData) {
          var sideTotalColumns = props.sideTotalColumns;

          _Izenda2.default.updateSideTotalMapping(sideTotalColumns, previewData.sideTotalMapping, reportPartContent.columns);
          // update data directly to current rowDataObject
          currentRowDataObject.data = (0, _fp.map)((0, _fp.mapValues)(_fp.toString), previewData.records);
          currentRowDataObject.subTotalMapping = previewData.subTotalMapping;
          currentRowDataObject.toggleExpand();
        })).finally(loader.endLoading.bind(loader));
      }
    } else {
      if (!(0, _fp.isEmpty)(currentRowDataObject.childs) && (0, _fp.get)('isExpand', (0, _fp.head)(currentRowDataObject.childs)) || !(0, _fp.isEmpty)((0, _fp.get)('data', (0, _fp.head)(currentRowDataObject.childs))) && (0, _fp.get)('value', (0, _fp.head)(currentRowDataObject.childs)) !== 'undefined') {
        currentRowDataObject.toggleExpand();
        loader.endLoading();
      } else {
        var getChild = function getChild(data, key) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].key === key) {
              return data[i];
            }

            var found = getChild(data[i].childs, key);
            if (found) return found;
          }
        };
        props.getDrillDownRecords(reportPart, currentRowDataObject.buildDrillDownParams(true)).then(function (previewData) {
          var rowDataObjects = _Izenda2.default.createRowDataObject(previewData.records, previewData, reportPartContent.rows, []);
          var newRow = getChild(rowDataObjects, currentRowDataObject.key);
          newRow && (currentRowDataObject.childs = newRow.childs);

          currentRowDataObject.toggleExpand();
        }).finally(loader.endLoading.bind(loader));
      }
    }
  };

  return _react2.default.createElement('span', { className: rowExpandIcon, onClick: getSubData });
}

/**
 * add 'All' row at the first row for drillDown only
 * @param  {Object} newData
 * @return {Array}
 */
function getFirstRecordForDrilldown(props, newData) {
  var allRow = props.allRow;
  var allRowObject = (0, _fp.get)('currentRow.rowDataObject', allRow);

  if (allRowObject.isExpand) {
    allRow.currentRow.isSupTotalRow = false;
    return (0, _fp.concat)([allRow], newData);
  } else {
    allRow.currentRow.isSupTotalRow = props.haveSupTotal;
    return [allRow];
  }
}

var getColumnGroup = (0, _fp.get)('element.properties.headerFormating.columnGroup');

function processColumnGroup(columnList, level) {
  var setHeaderValue = function setHeaderValue(itemHeader, leaf) {
    var columnHeader = getColumnGroup(leaf);

    itemHeader.value = columnHeader;
    itemHeader.isLeaf = false;
    itemHeader.isHidden = true;
    itemHeader.level = level;
    itemHeader.isInvisible = false;
    itemHeader.isColumnGroup = true;
    itemHeader.hideTopLeftBorder = !columnHeader;
    itemHeader.childs = [leaf];
  };

  var createNewGroup = function createNewGroup(leaf) {
    var header = new _Izenda8.default.ColumnDataObject();

    setHeaderValue(header, leaf);
    return header;
  };

  var addNewGroup = function addNewGroup(acc, leaf) {
    var newGroup = createNewGroup(leaf);

    return {
      leafRowHeaders: (0, _fp.concat)(acc.leafRowHeaders, newGroup),
      lastGroup: newGroup,
      lastLeaf: leaf
    };
  };

  return (0, _fp.flow)((0, _fp.reduce)(function (acc, leaf) {
    if (acc.lastLeaf && getColumnGroup(acc.lastLeaf) === getColumnGroup(leaf)) {
      acc.lastGroup.childs = (0, _fp.concat)(acc.lastGroup.childs, leaf);
      return (0, _fp.set)('lastLeaf', leaf, acc);
    }
    return addNewGroup(acc, leaf);
  }, {
    leafRowHeaders: [],
    lastGroup: null,
    lastLeaf: null
  }), (0, _fp.get)('leafRowHeaders'))(columnList);
}

function buildPageColumnHeader(props) {
  var forDrillDown = props.forDrillDown,
      rowHeaderColumnDataObject = props.rowHeaderColumnDataObject,
      columnDataObjects = props.columnDataObjects,
      reportPart = props.reportPart,
      embededReportPart = props.embededReportPart;

  var sideTotalColumns = props.sideTotalColumns;
  var reportPartContent = reportPart.reportPartContent;
  var reportPartProperties = reportPartContent.properties;
  var pivotColumnsPerExportedPage = reportPartProperties.view.pivotColumnsPerExportedPage;
  var haveGroupForRow = (0, _fp.some)(getColumnGroup, rowHeaderColumnDataObject);
  var maxLevel = reportPartContent.columns.visibleElement.length;
  var isMobile = _Izenda6.default.isMobileDevice();

  var fullRowHeader = rowHeaderColumnDataObject;
  var onlyColumnGroupRowHeader = fullRowHeader;
  var emptyRowHeader = [_Izenda2.default.createBlankHeaders(0, 1, rowHeaderColumnDataObject)];

  if (haveGroupForRow) {
    onlyColumnGroupRowHeader = fullRowHeader = processColumnGroup(fullRowHeader, maxLevel);
    maxLevel > 1 && (fullRowHeader = [_Izenda2.default.createBlankHeaders(0, maxLevel - 1, fullRowHeader)]);
  } else if (maxLevel) {
    fullRowHeader = [_Izenda2.default.createBlankHeaders(0, maxLevel, fullRowHeader)];
  }

  var buildPage = (0, _fp.curry)(function (pageColumn) {
    var haveGroupForColumn = forDrillDown && (0, _fp.some)(getColumnGroup, pageColumn);
    var returnRow = haveGroupForColumn && !haveGroupForRow ? emptyRowHeader : fullRowHeader;
    var returnColumn = pageColumn;

    if (haveGroupForColumn) {
      returnColumn = processColumnGroup(pageColumn, 1);
    } else if (forDrillDown && haveGroupForRow) {
      returnColumn = [_Izenda2.default.createBlankHeaders(0, 1, pageColumn)];
    }

    return (0, _fp.concat)(returnRow, returnColumn);
  });

  var result = {
    pageColumnHeader: [(0, _fp.concat)(buildPage(columnDataObjects), sideTotalColumns)],
    pageStatus: true
  };
  var sideTotalPage = [];

  if (props.printingMode && pivotColumnsPerExportedPage) {
    if (forDrillDown) {
      result = {
        pageColumnHeader: (0, _fp.flow)((0, _fp.chunk)(pivotColumnsPerExportedPage), (0, _fp.map)(buildPage))(columnDataObjects),
        pageStatus: true
      };
    } else if ((0, _fp.every)({ pivotColumn: pivotColumnsPerExportedPage }, columnDataObjects)) {
      if (!(0, _fp.isEmpty)(sideTotalColumns)) {
        if (haveGroupForRow) {
          sideTotalColumns = [_Izenda2.default.createBlankHeaders(0, 1, sideTotalColumns)];
        }
        sideTotalPage = [(0, _fp.concat)(onlyColumnGroupRowHeader, sideTotalColumns)];
      }
      result = {
        pageColumnHeader: (0, _fp.flow)((0, _fp.chunk)(1), (0, _fp.map)(buildPage), (0, _fp.concat)(_fp.placeholder, sideTotalPage))(columnDataObjects),
        pageStatus: true
      };
    } else {
      result = {
        haveGroupForRow: haveGroupForRow,
        fullRowHeader: fullRowHeader,
        onlyColumnGroupRowHeader: onlyColumnGroupRowHeader,
        pageStatus: false
      };
    }
  }

  result.getStickyValue = function (value) {
    return embededReportPart || isMobile ? false : value;
  };

  return result;
}

/**
 * handling all states of Pivot grid
 * @param  {Object} nextProps
 */
function handleStates(nextProps) {
  var addSideTotal = !!(0, _fp.getOr)(false, 'reportPartContent.columns.properties.addSideTotal', nextProps.reportPart);
  var _nextProps$reportPart = nextProps.reportPart,
      reportPartContent = _nextProps$reportPart.reportPartContent,
      previewData = _nextProps$reportPart.previewData,
      subTotalMapping = _nextProps$reportPart.previewData.subTotalMapping;

  var reportPartProperties = reportPartContent.properties;
  var pivotColumnsPerExportedPage = reportPartProperties.view.pivotColumnsPerExportedPage;
  var collapseDrilldownByDefault = void 0;

  if (nextProps.printingMode) {
    collapseDrilldownByDefault = false;
  } else if (reportPartContent.collapseStatus === COLLAPSE_STATUS.EXPAND) {
    collapseDrilldownByDefault = false;
  } else if (reportPartContent.collapseStatus === COLLAPSE_STATUS.COLLAPSE) {
    collapseDrilldownByDefault = true;
  } else {
    collapseDrilldownByDefault = reportPartProperties.view.collapseDrilldownByDefault;
  }

  var rowHeaderColumnDataObject = _Izenda2.default.createRowHeadersDataObject(reportPartContent.rows);
  var columnDataObjects = _Izenda2.default.createColumnDataObject(nextProps.records, previewData, reportPartContent.columns, reportPartContent.values, reportPartContent.separators, nextProps.keyPath);
  var sideTotalColumns = [];
  var rowDataObject = _Izenda2.default.createRowDataObject(nextProps.records, previewData, reportPartContent.rows, nextProps.keyPath || [], null, !collapseDrilldownByDefault);
  var supTotalDataRow = null;
  var allRow = null;
  var haveSeparator = !(0, _fp.isEmpty)(nextProps.keyPath);
  var haveSupTotal = (0, _fp.some)(function (item) {
    var field = (0, _fp.find)(['fieldNameAlias', item.fieldNameAlias], reportPartContent.fieldCollection);
    return field && field.isVisible;
  }, subTotalMapping);
  var forDrillDown = reportPartContent.gridStyle === _Izenda10.default.GRID_STYLES.DRILL_DOWN.value;
  var isLastSeparatorVisible = (0, _fp.flow)((0, _fp.sortBy)('position'), _fp.last, (0, _fp.get)('isVisible'))(reportPartContent.separators.elements);
  var allGroupSuptotal = haveSupTotal && (!forDrillDown || haveSeparator && isLastSeparatorVisible);

  if (addSideTotal) {
    sideTotalColumns = _Izenda2.default.createSideTotal(previewData, reportPartContent.values);
    _Izenda2.default.updateSideTotalMapping(sideTotalColumns, previewData.sideTotalMapping, reportPartContent.columns);
  }

  var firstRowElement = (0, _fp.flow)((0, _fp.sortBy)('position'), _fp.head)(reportPartContent.rows.visibleElement);

  if (allGroupSuptotal) {
    var lastSeparatorElement = (0, _fp.flow)((0, _fp.sortBy)('position'), _fp.last)(reportPartContent.separators.visibleElement);
    var lastSeparatorsValue = (0, _fp.flow)((0, _fp.find)(function (item) {
      return item.element === lastSeparatorElement;
    }), (0, _fp.getOr)('', 'value'))(nextProps.keyPath);

    supTotalDataRow = _Izenda2.default.createSupTotalRowDataObject(firstRowElement.field.fieldNameAlias, rowDataObject, lastSeparatorElement, lastSeparatorsValue, previewData);
  }

  if (forDrillDown) {
    allRow = _Izenda2.default.createAllRowDataObject(firstRowElement.field.fieldNameAlias, rowDataObject, nextProps.keyPath, reportPartContent.rows.elements.length + 1);
  }

  if (!reportPartContent.useSeparator) {
    reportPartContent.setCollapseStatus(COLLAPSE_STATUS.DEFAULT);
  }

  return {
    rowDataObject: rowDataObject,
    rowHeaderColumnDataObject: rowHeaderColumnDataObject,
    columnDataObjects: columnDataObjects,
    sideTotalColumns: sideTotalColumns,
    subTotalMapping: subTotalMapping,
    forDrillDown: forDrillDown,
    haveSeparator: haveSeparator,
    haveSupTotal: haveSupTotal,
    supTotalDataRow: supTotalDataRow,
    allGroupSuptotal: allGroupSuptotal,
    allRow: allRow,
    pivotColumnsPerExportedPage: pivotColumnsPerExportedPage
  };
}

function toggleAllLevels(props, value) {
  var recursiveToggle = (0, _mobx.action)(function (rows) {
    !(0, _fp.isEmpty)(rows) && rows.forEach(function (row) {
      if (!(0, _fp.isEmpty)(row.childs)) {
        recursiveToggle(row.childs);
        row.isExpand !== value && row.toggleExpand(value);
      }
    });
  });
  recursiveToggle(props.rowDataObject);
}

function collapseAll(props, value) {
  var reportPart = props.reportPart,
      loader = props.loader,
      reportPartContent = props.reportPart.reportPartContent;
  // Always expand node All

  props.allRow.currentRow.rowDataObject.isExpand = true;

  if (props.haveSupTotal) {
    toggleAllLevels(props, false);
  } else {
    loader.startLoading();
    if (!(0, _fp.some)(function (row) {
      return (0, _fp.isEmpty)(row.data);
    }, props.rowDataObject)) {
      toggleAllLevels(props, false);
      loader.endLoading();
    } else {
      reportPartContent.setCollapseStatus(-1);
      var minLevel = 0;
      var firstVisibleLevel = Math.min.apply(Math, (0, _toConsumableArray3.default)(reportPartContent.rows.visibleElement.map(function (e) {
        return e.position;
      }))) - 1;
      minLevel = Math.max(minLevel, firstVisibleLevel);
      props.getDrillDownRecords(reportPart, { expandedLevel: minLevel, filters: [] }, reportPart.previewData.paging.pageIndex).then(function (previewData) {
        return reportPart.setQueryData(previewData);
      }).finally(loader.endLoading.bind(loader));
    }
  }
}

function expandAll(props, value) {
  var reportPart = props.reportPart,
      loader = props.loader,
      reportPartContent = props.reportPart.reportPartContent;
  // Always expand node All

  props.allRow.currentRow.rowDataObject.isExpand = true;

  if (props.haveSupTotal) {
    toggleAllLevels(props, true);
  } else {
    loader.startLoading();
    reportPartContent.setCollapseStatus(1);
    props.getDrillDownRecords(reportPart, { expandedLevel: -1, filters: [] }, reportPart.previewData.paging.pageIndex).then(function (previewData) {
      return reportPart.setQueryData(previewData);
    }).finally(loader.endLoading.bind(loader));
  }
}

exports.default = (0, _recompose.compose)((0, _recompose.withPropsOnChange)(['records'], handleStates), (0, _recompose.withHandlers)({
  renderExpandIcon: (0, _fp.curry)(renderExpandIcon),
  getFirstRecordForDrilldown: (0, _fp.curry)(getFirstRecordForDrilldown),
  isDisplayRowExpander: (0, _fp.curry)(isDisplayRowExpander),
  fnGetHeaderCellContentStyle: (0, _fp.curry)(fnGetHeaderCellContentStyle),
  fnGetHeaderCellContentForPivotHeader: (0, _fp.curry)(fnGetHeaderCellContentForPivotHeader),
  fnGetHeaderCellStyle: (0, _fp.curry)(fnGetHeaderCellStyle),
  getCellStyle: (0, _fp.curry)(getCellStyle),
  getCellContentStyle: (0, _fp.curry)(getCellContentStyle),
  collapseAll: (0, _fp.curry)(collapseAll),
  expandAll: (0, _fp.curry)(expandAll),
  getCellData: (0, _fp.curry)(getCellData)
}), _mobxReact.observer, (0, _recompose.withProps)(buildPageColumnHeader));
module.exports = exports['default'];

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GridPaginatorAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var mapProps = __webpack_require__(9).mapProps;
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);
  var reportDesignerConstants = __webpack_require__(16);

  var _require = __webpack_require__(1),
      omit = _require.omit,
      isEmpty = _require.isEmpty,
      assign = _require.assign,
      isNil = _require.isNil,
      get = _require.get;

  var action = compose(observer, mapProps(function (props) {
    var restProps = omit(['reportPart'], props);
    var reportPart = props.reportPart;
    var usePagination = get('reportPartContent.properties.view.usePagination', reportPart);
    var records = reportPart.previewDataRecords;
    var isBeingBuild = reportPart.isBeingBuild;
    var hide = !isBeingBuild || !usePagination || isEmpty(records);
    var paging = reportPart.previewData.paging || {
      total: 0,
      pageSize: reportDesignerConstants.DEFAULT_PAGE_SIZE,
      pageIndex: reportDesignerConstants.DEFAULT_PAGE_INDEX
    };

    return assign(restProps, {
      totalRecords: paging.total || 0,
      pageSize: !isNil(paging.pageSize) ? paging.pageSize : reportDesignerConstants.DEFAULT_PAGE_SIZE,
      pageIndex: !isNil(paging.pageIndex) ? paging.pageIndex : reportDesignerConstants.DEFAULT_PAGE_INDEX,
      className: classnames('with-border', { hide: hide })
    });
  }));

  module.exports = action;
}();

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(84);

var _Izenda2 = __webpack_require__(64);

var _Izenda3 = __webpack_require__(35);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(41);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * on sort change
 * @param {Object} props properties
 * @param {Object} container container
 * @param {Object} fieldElement selected field
 * @param {String} oldSortValue old sort value
 * @param {Number} previewRecords user can change preview records number via API
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridFrontSideAction.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Part Grid Front Side Action
 */
var onSortChange = function onSortChange(props, container, fieldElement, oldSortValue, previewRecords, e) {
  var reportPart = props.reportPart,
      _props$reportPart = props.reportPart,
      reportPartContent = _props$reportPart.reportPartContent,
      isBackSide = _props$reportPart.isBackSide,
      gridStyle = props.reportPart.reportPartContent.properties.generalInfo.gridStyle;

  var newSortValue = reportPartContent.getNewSortValue(container, oldSortValue, fieldElement);

  if (isBackSide || (0, _fp.get)('field.isRunningField', fieldElement)) {
    return false;
  }

  if (!_Izenda6.default.advancedSettings.other.multipleSortOnGridHeaderValue && (0, _fp.includes)(gridStyle, [_Izenda.GRID_STYLES.VERTICAL.value, _Izenda.GRID_STYLES.HORIZONTAL.value])) {
    reportPartContent.resetSortValue(container);
  }

  fieldElement.properties.setSortValue(newSortValue);
  props.needUpdatePreview(reportPart, null, null, null, null, previewRecords);
};

/**
 * resolve sorting value for selected field
 * @param {Object} props properties
 * @param {Object} container container
 * @param {Object} fieldElement selected field
 * @return {String} [sort value]
 */
var resolveSortValue = function resolveSortValue(props, container, fieldElement) {
  var sortValue = (0, _fp.get)('properties.dataFormattings.sort', fieldElement);
  var gridStyle = (0, _fp.getOr)('', 'reportPart.reportPartContent.properties.generalInfo.gridStyle', props);
  if (gridStyle === _Izenda.GRID_STYLES.VERTICAL.value || gridStyle === _Izenda.GRID_STYLES.HORIZONTAL.value) {
    var containerCollection = (0, _fp.compact)([props.reportPart.reportPartContent.columns, props.reportPart.reportPartContent.rows, props.reportPart.reportPartContent.values, props.reportPart.reportPartContent.separators]);
    var canUnsort = _Izenda4.default.checkCanUnsort(gridStyle, container, fieldElement, containerCollection);
    if (!canUnsort && ((0, _fp.isEmpty)(sortValue) || sortValue === _Izenda2.SORT_ORDERS.Unsorted.value)) {
      sortValue = _Izenda2.SORT_ORDERS.ASC.value;
    }
  }
  return sortValue;
};

var action = (0, _recompose.compose)(_recompose.pure, (0, _recompose.withHandlers)({
  onSortChange: (0, _fp.curry)(onSortChange),
  resolveSortValue: (0, _fp.curry)(resolveSortValue)
}));

exports.default = action;
module.exports = exports['default'];

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

exports.default = function (reportDesignerModel, reportPart, fieldStore, props) {
  var reportPartContent = reportPart.reportPartContent;
  var configReportPartProperties = reportPartContent.properties;

  ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

  return {
    // define data to render UI
    definedSchema: _Izenda2.default,

    // list of widgets which are used to render UI
    widgets: WIDGETS,

    // data to binding to fields
    source: configReportPartProperties,

    // properties for different fields
    mappingProps: {
      beforeChangeSeparator: function beforeChangeSeparator(newVal) {
        if (!!newVal.value || (0, _fp.isEmpty)((0, _fp.get)('separators.elements', reportPartContent))) {
          return (0, _bluebird.resolve)();
        }

        return props.confirmFn('Confirmation', {
          description: _Izenda4.default.MESSAGES.SEPARATOR_CONFIRM
        });
      },
      fnResetRefreshIntervalDefaultValue: configReportPartProperties.resetRefreshInterval.bind(configReportPartProperties),
      fnResetBorderDefaultValue: configReportPartProperties.resetBorderDefaultValue.bind(configReportPartProperties),
      getBorderSettings: function getBorderSettings() {
        return configReportPartProperties.getTableByKey('border');
      },
      hadSettingBorder: function hadSettingBorder() {
        var borderSettings = configReportPartProperties.getTableByKey('border');
        var defaultSetting = (0, _fp.cloneDeep)(_Izenda4.default.DEFAULT_SETTING_VALUE.border);

        if (!borderSettings) {
          return false;
        }

        return !(0, _fp.isEqual)(borderSettings, defaultSetting);
      },
      getDataRefreshInterval: function getDataRefreshInterval() {
        return configReportPartProperties.getViewByKey('dataRefreshInterval');
      },
      hadSettingRefreshInterval: function hadSettingRefreshInterval() {
        var defaultSetting = _Izenda4.default.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
        var refreshSetting = configReportPartProperties.getViewByKey('dataRefreshInterval');

        if (!refreshSetting) {
          return false;
        }

        return refreshSetting.value !== defaultSetting.value || refreshSetting.updateInterval !== defaultSetting.updateInterval;
      },
      getWordWrapValue: function getWordWrapValue() {
        return configReportPartProperties.headers;
      },
      getColumnsWordWrapValue: function getColumnsWordWrapValue() {
        return configReportPartProperties.columns;
      },
      getColumnAlignment: function getColumnAlignment() {
        return configReportPartProperties.columns.alignment;
      },
      getColumnVerticalAlignment: function getColumnVerticalAlignment() {
        return configReportPartProperties.columns.verticalAlignment;
      },
      filterFreezeHeaderOptions: function filterFreezeHeaderOptions(options) {
        var GRID_STYLES = _Izenda4.default.GRID_STYLES,
            _constants$FREEZE_HEA = _Izenda4.default.FREEZE_HEADERS,
            VERTICALLY = _constants$FREEZE_HEA.VERTICALLY,
            HORIZONTALLY = _constants$FREEZE_HEA.HORIZONTALLY;

        switch (reportPartContent.gridStyle) {
          case GRID_STYLES.VERTICAL.value:
            return (0, _fp.filter)(function (item) {
              return item.value === VERTICALLY.value;
            }, options);
          case GRID_STYLES.HORIZONTAL.value:
            return (0, _fp.filter)(function (item) {
              return item.value === HORIZONTALLY.value;
            }, options);
          case GRID_STYLES.DRILL_DOWN.value:
            return (0, _fp.filter)(function (item) {
              return item.value === VERTICALLY.value;
            }, options);
          default:
            return options;
        }
      }
    },

    // defined-function which fields need to execute to get its data
    mappingSource: {
      getWidthValue: function getWidthValue() {
        return configReportPartProperties.columns;
      },
      getGridStyle: function getGridStyle() {
        return (0, _fp.values)(_Izenda4.default.GRID_STYLES);
      },
      getSeparatorStyle: function getSeparatorStyle() {
        return (0, _fp.values)(_Izenda4.default.SEPARATOR_STYLE);
      },
      getHeaderFontFormat: function getHeaderFontFormat() {
        var fontConfig = configReportPartProperties.getHeadersByKey('font');

        return {
          fontFamily: fontConfig.family,
          fontSize: fontConfig.size
        };
      },
      getHeaderFontStyle: function getHeaderFontStyle() {
        var fontConfig = configReportPartProperties.getHeadersByKey('font');

        return {
          fontUnderline: fontConfig.underline,
          fontItalic: fontConfig.italic,
          fontBold: fontConfig.bold
        };
      },
      getHeaderColorStyling: function getHeaderColorStyling() {
        var fontConfig = configReportPartProperties.getHeadersByKey('font');

        return {
          textColor: fontConfig.color,
          backgroundColor: fontConfig.backgroundColor
        };
      },
      getTableColorStyling: function getTableColorStyling() {
        return {
          backgroundColor: configReportPartProperties.getTableByKey('backgroundColor')
        };
      },
      getTableAlternativeBackgroundValue: function getTableAlternativeBackgroundValue() {
        var isAlternativeColumns = configReportPartProperties.getColumnsByKey('alterBackgroundColor');
        var isAlternativeRows = configReportPartProperties.getRowsByKey('alterBackgroundColor');

        // Populate 2 flags rows, columns into table alternative background
        if (isAlternativeColumns && isAlternativeRows) {
          return _Izenda4.default.ALTERNATIVE_BACKGROUND.COLUMNS_AND_ROWS.value;
        }

        if (isAlternativeColumns) {
          return _Izenda4.default.ALTERNATIVE_BACKGROUND.COLUMNS.value;
        }

        if (isAlternativeRows) {
          return _Izenda4.default.ALTERNATIVE_BACKGROUND.ROWS.value;
        }

        return _Izenda4.default.ALTERNATIVE_BACKGROUND.NONE.value;
      },
      getTableAlternativeBackgroundOptions: function getTableAlternativeBackgroundOptions() {
        return (0, _fp.values)(_Izenda4.default.ALTERNATIVE_BACKGROUND);
      },
      isHiddenByAlternativeBackground: function isHiddenByAlternativeBackground() {
        var isAlternativeColumns = configReportPartProperties.getColumnsByKey('alterBackgroundColor');
        var isAlternativeRows = configReportPartProperties.getRowsByKey('alterBackgroundColor');

        return !isAlternativeColumns && !isAlternativeRows;
      },
      getTableAlternativeBackgroundColor: function getTableAlternativeBackgroundColor() {
        return {
          backgroundColor: configReportPartProperties.getTableByKey('alternativeBackgroundColor')
        };
      },
      isNotGridDrillDown: function isNotGridDrillDown() {
        return reportPartContent.gridStyle !== _Izenda4.default.GRID_STYLES.DRILL_DOWN.value;
      },
      getFreezeHeaderOptions: function getFreezeHeaderOptions() {
        return (0, _fp.values)(_Izenda4.default.FREEZE_HEADERS);
      },

      getFreezeHeaderValue: function getFreezeHeaderValue() {
        return configReportPartProperties.getHeadersByKey('freezeHeaders');
      }
    },

    onChangeValue: (0, _mobx.action)(function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
      var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
      var fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      /* general info section*/
      var generalInfo = schemaData.generalInfo;
      var generalInfoGridStyle = generalInfo.gridStyle.value;
      var generalInfoSeparatorStyle = generalInfo.separatorStyle.value;
      /* general info section*/

      /* table section*/
      var table = schemaData.table;

      var tableBackgroundColor = table.backgroundColor.value.backgroundColor;
      var tableAlternativeBackground = table.alternativeBackground.value;
      var tableAlternativeBackgroundColor = tableAlternativeBackground === _Izenda4.default.DEFAULT_VALUE_PROPERTIES.TABLE.ALTERNATIVE_BACKGROUND ? _Izenda4.default.DEFAULT_VALUE_PROPERTIES.TABLE.ALTERNATIVE_BACKGROUND_COLOR : table.alternativeBackgroundColor.value.backgroundColor;
      var borderSettings = (0, _fp.getOr)({}, 'border.value', table);
      /* table section*/

      /* columns section*/
      var columns = schemaData.columns;
      var columnsWidthValue = columns.width.value;
      var columnsAlternatingBgColor = tableAlternativeBackground === _Izenda4.default.ALTERNATIVE_BACKGROUND.COLUMNS.value || tableAlternativeBackground === _Izenda4.default.ALTERNATIVE_BACKGROUND.COLUMNS_AND_ROWS.value;
      var columnsWordWrap = columns.columnWordWrap.value;
      var columnsAlignment = columns.columnAlignment.value;
      var columnsVerticalAlignment = columns.columnVerticalAlignment.value;
      /* columns section*/

      /* rows section*/
      var rowsAlternatingBgColor = tableAlternativeBackground === _Izenda4.default.ALTERNATIVE_BACKGROUND.ROWS.value || tableAlternativeBackground === _Izenda4.default.ALTERNATIVE_BACKGROUND.COLUMNS_AND_ROWS.value;
      /* rows section*/

      /* headers section*/
      var headers = schemaData.headers;
      var headersAlignment = headers.alignment.value;
      var headersVerticalAlignment = headers.verticalAlignment.value;

      var headersWordWrap = headers.wordWrap.value;
      var headersRemoveHeaderForExport = headers.removeHeaderForExport.value;
      var headersFreezeHeaders = headers.freezeHeaders.value;

      var headersFontFormat = headers.fontFormat.value;
      var headersFontFormatFontFamily = headersFontFormat.fontFamily;
      var headersFontFormatFontSize = headersFontFormat.fontSize;

      var headersFontStyle = headers.fontStyle.value;
      var headersFontStyleFontBold = headersFontStyle.fontBold;
      var headersFontStyleFontItalic = headersFontStyle.fontItalic;
      var headersFontStyleFontUnderline = headersFontStyle.fontUnderline;

      var headersColor = headers.color.value;
      var headersColorTextColor = headersColor.textColor;
      var headersColorBackground = headersColor.backgroundColor;
      /* headers section*/

      /* grouping section*/
      var grouping = schemaData.grouping;
      var groupingUseSeparator = grouping.useSeparator.value;
      /* grouping section*/

      /* view section*/
      var view = schemaData.view;
      var dataRefreshInterval = view.dataRefreshInterval.value;
      var usePagination = view.usePagination.value;
      var collapseDrilldownByDefault = view.collapseDrilldownByDefault.value;
      var pivotColumnsPerExportedPage = view.pivotColumnsPerExportedPage.value;
      /* end view section*/

      /* printing section*/
      var printing = schemaData.printing;
      var usePageBreakAfterSeparator = printing.usePageBreakAfterSeparator.value;

      var data = {
        generalInfo: {
          gridStyle: generalInfoGridStyle,
          separatorStyle: generalInfoSeparatorStyle
        },
        table: {
          backgroundColor: tableBackgroundColor,
          border: borderSettings,
          alternativeBackgroundColor: tableAlternativeBackgroundColor
        },
        columns: {
          width: {
            value: columnsWidthValue
          },
          alterBackgroundColor: columnsAlternatingBgColor,
          wordWrap: columnsWordWrap,
          alignment: columnsAlignment,
          verticalAlignment: columnsVerticalAlignment
        },
        rows: {
          alterBackgroundColor: rowsAlternatingBgColor
        },
        headers: {
          font: {
            family: headersFontFormatFontFamily,
            size: headersFontFormatFontSize,
            bold: headersFontStyleFontBold,
            italic: headersFontStyleFontItalic,
            underline: headersFontStyleFontUnderline,
            color: headersColorTextColor,
            backgroundColor: headersColorBackground
          },
          alignment: headersAlignment,
          verticalAlignment: headersVerticalAlignment,
          wordWrap: headersWordWrap,
          removeHeaderForExport: headersRemoveHeaderForExport,
          freezeHeaders: headersFreezeHeaders
        },
        grouping: {
          useSeparator: groupingUseSeparator
        },
        view: {
          dataRefreshInterval: dataRefreshInterval,
          usePagination: usePagination,
          collapseDrilldownByDefault: collapseDrilldownByDefault,
          pivotColumnsPerExportedPage: pivotColumnsPerExportedPage
        },
        printing: {
          usePageBreakAfterSeparator: usePageBreakAfterSeparator
        }
      };

      var oldGridStyle = null;
      var needUpdatePreview = false;
      var promiseUpdateFunction = (0, _bluebird.resolve)();

      if (changedKey === 'gridStyle') {
        // Reset value freezeHeaders
        data.headers.freezeHeaders = null;
        headers.freezeHeaders.value = null;
        oldGridStyle = configReportPartProperties.getGeneralInfoByKey('gridStyle');

        promiseUpdateFunction = reportPartContent.changeGridStyle(oldGridStyle, generalInfoGridStyle, reportPart);
        needUpdatePreview = true;
      }

      if (changedKey === 'useSeparator' && !groupingUseSeparator) {
        reportPart.clearContainer(reportPartContent.separators);
        needUpdatePreview = true;
      }

      if (changedKey === 'usePagination') {
        needUpdatePreview = true;
      }

      if (changedKey === 'collapseDrilldownByDefault') {
        needUpdatePreview = true;
      }

      configReportPartProperties.setReportPartProperties(data);

      if (needUpdatePreview && reportPart.shouldUpdatePreview) {
        promiseUpdateFunction.then(function () {
          fieldStore.needUpdatePreview(reportPart);
        });
      }
    })
  };
};

var _Izenda = __webpack_require__(1967);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(84);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(157);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _mobx = __webpack_require__(5);

var _Izenda7 = __webpack_require__(28);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(944);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(266);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(186);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(267);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(317);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(945);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(566);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(579);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPropsGridSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var WIDGETS = {
  Panel: _Izenda8.default,
  SizeSetting: _Izenda10.default,
  FontStyle: _Izenda12.default,
  FontFormat: _Izenda14.default,
  ColorStyling: _Izenda16.default,
  AlignmentSetting: _Izenda18.default,
  VerticalAlignmentSetting: _Izenda20.default,
  ButtonHighlight: _Izenda22.default,
  CustomDropdown: _Izenda24.default
};

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPropsGridSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  schemaKey: 'RP_GRID_TYPE',
  fields: {
    /* general info */
    generalInfo: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_GENERAL_INFO');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        gridStyle: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_GRID_STYLE');
          },
          component: 'CustomDropdown',
          fnValue: 'getGeneralInfoByKey',
          props: {
            options: 'getGridStyle'
          }
        },
        separatorStyle: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_SEPARATOR_STYLE');
          },
          component: 'CustomDropdown',
          fnValue: 'getGeneralInfoByKey',
          props: {
            options: 'getSeparatorStyle'
          }
        }
      }
    },
    table: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('MODEL_LABEL_TABLE');
          },
          icon: 'icon-toggle-triangle'
        },
        hiddenByState: true
      },
      fields: {
        border: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_BORDER');
          },
          type: 'btnPopup',
          fnValue: 'getBorderSettings',
          props: {
            hadSetting: 'hadSettingBorder',
            fnResetDefaultValue: 'fnResetBorderDefaultValue',
            loadValue: 'getBorderSettings'
          },
          staticProps: {
            get title() {
              return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_GRID_BORDER_SETTINGS');
            },
            className: 'icon-setting btn-icon',
            get popupTitle() {
              return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_GRID_BORDER_SETTINGS');
            },
            popupContent: __webpack_require__(1968),
            popupProps: {
              type: 'none'
            }
          }
        },
        // color
        backgroundColor: {
          get title() {
            return _Izenda2.default.getText('COLOR_STYLING_BACKGROUND_TOOLTIP');
          },
          component: 'ColorStyling',
          fnValue: 'getTableColorStyling',
          props: {
            type: 'photoshop',
            position: 'left',
            options: {
              text: undefined,
              background: true
            }
          }
        },
        alternativeBackground: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_ALTERNATIVE_BACKGROUND');
          },
          type: 'select',
          fnValue: 'getTableAlternativeBackgroundValue',
          props: {
            options: 'getTableAlternativeBackgroundOptions'
          }
        },
        alternativeBackgroundColor: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_ALTERNATIVE_BACKGROUND_COLOR');
          },
          isHidden: 'isHiddenByAlternativeBackground',
          component: 'ColorStyling',
          fnValue: 'getTableAlternativeBackgroundColor',
          props: {
            type: 'photoshop',
            position: 'left',
            options: {
              text: undefined,
              background: true
            }
          }
        }
      }
    },
    columns: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_COLUMNS');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        width: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_WIDTH');
          },
          component: 'SizeSetting',
          fnValue: 'getColumnWidth',
          props: {
            loadValue: 'getWidthValue',
            propertyKey: 'width.value'
          }
        },

        // Text alignment
        columnAlignment: {
          get title() {
            return _Izenda2.default.getText('FONT_SETTINGS_LABEL_ALIGNMENT');
          },
          component: 'AlignmentSetting',
          fnValue: 'getColumnAlignment'
        },

        // Vertical alignment
        columnVerticalAlignment: {
          title: '',
          component: 'VerticalAlignmentSetting',
          fnValue: 'getColumnVerticalAlignment'
        },

        // wordwrap
        columnWordWrap: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_WORD_WRAP');
          },
          component: 'ButtonHighlight',
          fnValue: 'getColumnsByKey',
          staticProps: {
            defaultIcon: 'icon-word-wr'
          },
          props: {
            loadValue: 'getColumnsWordWrapValue',
            propertyKey: 'wordWrap',
            get description() {
              return _Izenda2.default.getText('BUTTON_HIGHLIGHT_WRAP_TEXT');
            },
            states: [{
              value: true,
              icon: 'icon-word-wr active'
            }, {
              value: false,
              icon: 'icon-word-wr'
            }],
            disabledIcon: 'icon-word-wr'
          }
        }
      }
    },
    headers: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_HEADERS');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        //font family + font size
        fontFormat: {
          get title() {
            return _Izenda2.default.getText('FONT_SETTINGS_LABEL_FONT');
          },
          component: 'FontFormat',
          fnValue: 'getHeaderFontFormat'
        },

        // bold, italic, underline
        fontStyle: {
          title: '',
          component: 'FontStyle',
          fnValue: 'getHeaderFontStyle'
        },

        // color
        color: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_COLOR');
          },
          component: 'ColorStyling',
          fnValue: 'getHeaderColorStyling',
          props: {
            type: 'photoshop',
            position: 'left'
          }
        },

        // alignment: left, right, center,...
        alignment: {
          get title() {
            return _Izenda2.default.getText('FONT_SETTINGS_LABEL_ALIGNMENT');
          },
          component: 'AlignmentSetting',
          fnValue: 'getHeadersByKey'
        },

        // Vertical align: top, middle, bottom
        verticalAlignment: {
          title: '',
          component: 'VerticalAlignmentSetting',
          fnValue: 'getHeadersByKey'
        },

        // wordwrap
        wordWrap: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_WORD_WRAP');
          },
          component: 'ButtonHighlight',
          fnValue: 'getHeadersByKey',
          staticProps: {
            defaultIcon: 'icon-word-wr'
          },
          props: {
            loadValue: 'getWordWrapValue',
            propertyKey: 'wordWrap',
            get description() {
              return _Izenda2.default.getText('BUTTON_HIGHLIGHT_WRAP_TEXT');
            },
            states: [{
              value: true,
              icon: 'icon-word-wr active'
            }, {
              value: false,
              icon: 'icon-word-wr'
            }],
            disabledIcon: 'icon-word-wr'
          }
        },

        freezeHeaders: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_GRID_CONSTANTS_LABEL_FREEZE_HEADERS');
          },
          type: 'select',
          fnValue: 'getFreezeHeaderValue',
          props: {
            options: 'getFreezeHeaderOptions',
            filterOptions: 'filterFreezeHeaderOptions',
            blankOption: true
          }
        },

        removeHeaderForExport: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_REMOVE_HEADER_FOR_EXPORT');
          },
          fnValue: 'getHeadersByKey',
          type: 'checkbox',
          props: {
            hiddenByState: true
          }
        }
      }
    },
    grouping: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_GROUPING');
          },
          icon: 'icon-toggle-triangle'
        },
        hiddenByState: true
      },
      fields: {
        useSeparator: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_USE_SEPARATOR');
          },
          fnValue: 'getGroupingByKey',
          type: 'checkbox',
          props: {
            beforeOnChange: 'beforeChangeSeparator'
          }
        }
      }
    },
    view: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('MODEL_LABEL_VIEW');
          },
          icon: 'icon-toggle-triangle'
        }
      },
      fields: {
        dataRefreshInterval: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
          },
          type: 'btnPopup',
          fnValue: 'getDataRefreshInterval',
          props: {
            hadSetting: 'hadSettingRefreshInterval',
            fnResetDefaultValue: 'fnResetRefreshIntervalDefaultValue',
            hiddenByState: true,
            loadValue: 'getDataRefreshInterval'
          },
          staticProps: {
            get title() {
              return _Izenda2.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
            },
            className: 'icon-setting btn-icon',
            get popupTitle() {
              return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_DATA_REFRESH_INTERVAL');
            },
            popupContent: __webpack_require__(323),
            popupProps: {
              type: 'none',
              autoClose: false
            }
          }
        },
        usePagination: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_USE_PAGINATION');
          },
          fnValue: 'getViewByKey',
          type: 'checkbox'
        },
        collapseDrilldownByDefault: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_COLLAPSE_DRILLDOWN_BY_DEFAULT');
          },
          fnValue: 'getViewByKey',
          type: 'checkbox',
          isHidden: 'isNotGridDrillDown'
        },
        pivotColumnsPerExportedPage: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_EXPORT_COLUMNS_PER_PAGE');
          },
          fnValue: 'getViewByKey',
          type: 'number',
          staticProps: {
            isDecimal: false
          }
        }
      }
    },
    printing: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_PRINTINGS');
          },
          icon: 'icon-toggle-triangle'
        },
        hiddenByState: true
      },
      fields: {
        usePageBreakAfterSeparator: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_PAGE_BREAK_AFTER_SEPARATOR');
          },
          fnValue: 'getPageBreakAfterSeparator',
          type: 'checkbox'
        }
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.BorderSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Border Settings component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(190);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(169);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(322);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(13);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(12);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BorderSettings = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(BorderSettings, _Component);

  function BorderSettings(props) {
    (0, _classCallCheck3.default)(this, BorderSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BorderSettings.__proto__ || (0, _getPrototypeOf2.default)(BorderSettings)).call(this, props));

    _this.getValue = function () {
      return _this.state.borderStyle;
    };

    _this.resetAllBorderStyle = function () {
      var currentStyle = _this.state.borderStyle;
      for (var key in currentStyle) {
        if ({}.hasOwnProperty.call(currentStyle, key)) {
          currentStyle[key] = {};
        }
      }

      _this.setState({
        borderStyle: currentStyle
      });
    };

    _this.setBorderStyle = function (value, isUpdate) {
      var nextStyle = _this.state.borderStyle;
      var res = value.split(' ');

      res.forEach(function (item) {
        var isNewStyle = nextStyle[item] && nextStyle[item].dashStyle === _this.dashStyle && nextStyle[item].color === _this.color && nextStyle[item].thinkness === _this.thinkness;

        if (!isNewStyle || isUpdate === true) {
          nextStyle[item] = {
            dashStyle: _this.dashStyle,
            color: _this.color,
            thinkness: _this.thinkness
          };
        } else {
          nextStyle[item] = {};
        }
      });

      _this.setState({ borderStyle: nextStyle });
    };

    _this.setBorderStyleAction = function (value) {
      return function (isUpdate) {
        _this.setBorderStyle(value, isUpdate);
      };
    };

    _this.handleChangeBorderStyle = function (value) {
      return function () {
        switch (value) {
          case 'none':
            _this.resetAllBorderStyle();
            _this.setBorderStyle('');
            break;
          case 'outline':
            _this.resetAllBorderStyle();
            _this.setBorderStyle('top right left bottom', true);
            break;
          case 'inline':
            _this.resetAllBorderStyle();
            _this.setBorderStyle('midVer midHor', true);
            break;
          case 'all':
            _this.setBorderStyle('top right left bottom midVer midHor', true);
        }
      };
    };

    _this.getStylesBorder = function (value) {
      var borderStyle = _this.state.borderStyle;
      switch (value) {
        case 'midVer':
          return {
            borderRightStyle: (0, _fp.get)('dashStyle', borderStyle.midVer),
            borderRightWidth: (0, _fp.get)('thinkness', borderStyle.midVer),
            borderRightColor: (0, _fp.get)('color', borderStyle.midVer)
          };
        case 'midHor':
          return {
            borderBottomStyle: (0, _fp.get)('dashStyle', borderStyle.midHor),
            borderBottomWidth: (0, _fp.get)('thinkness', borderStyle.midHor),
            borderBottomColor: (0, _fp.get)('color', borderStyle.midHor)
          };
        case 'all':
          return {
            borderTopStyle: (0, _fp.get)('dashStyle', borderStyle.top),
            borderTopWidth: (0, _fp.get)('thinkness', borderStyle.top),
            borderTopColor: (0, _fp.get)('color', borderStyle.top),
            borderRightStyle: (0, _fp.get)('dashStyle', borderStyle.right),
            borderRightWidth: (0, _fp.get)('thinkness', borderStyle.right),
            borderRightColor: (0, _fp.get)('color', borderStyle.right),
            borderBottomStyle: (0, _fp.get)('dashStyle', borderStyle.bottom),
            borderBottomWidth: (0, _fp.get)('thinkness', borderStyle.bottom),
            borderBottomColor: (0, _fp.get)('color', borderStyle.bottom),
            borderLeftStyle: (0, _fp.get)('dashStyle', borderStyle.left),
            borderLeftWidth: (0, _fp.get)('thinkness', borderStyle.left),
            borderLeftColor: (0, _fp.get)('color', borderStyle.left)
          };
      }
    };

    _this.onChangeDashStyle = function (value) {
      _this.dashStyle = value;
    };

    _this.onChangeColor = function (value) {
      _this.color = value;
    };

    _this.onChangeThickness = function (_ref) {
      var value = _ref.value;

      _this.thinkness = value;
    };

    _this.renderConfiguration = function () {
      return _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '6', className: 'text-center form-horizontal', xs: '12' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            { className: 'col-md-4 text-left u_paddingLeft' },
            _Izenda10.default.getText('BORDER_SETTING_LABEL_SETIING')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(
              'a',
              {
                title: _Izenda10.default.getText('BORDER_SETTING_LABEL_NONE'),
                className: 'icon-border',
                onClick: _this.handleChangeBorderStyle('none')
              },
              _react2.default.createElement('i', { className: 'icon-no-boder' })
            ),
            _react2.default.createElement(
              'a',
              {
                title: _Izenda10.default.getText('BORDER_SETTING_LABEL_OUTLINE'),
                className: 'icon-border',
                onClick: _this.handleChangeBorderStyle('outline')
              },
              _react2.default.createElement('i', { className: 'icon-all-boder' })
            ),
            _react2.default.createElement(
              'a',
              {
                title: _Izenda10.default.getText('BORDER_SETTING_LABEL_INSIDE'),
                className: 'icon-border',
                onClick: _this.handleChangeBorderStyle('inline')
              },
              _react2.default.createElement('i', { className: 'icon-table-noboder' })
            ),
            _react2.default.createElement(
              'a',
              {
                title: _Izenda10.default.getText('COMMON_LABEL_ALL'),
                className: 'icon-border',
                onClick: _this.handleChangeBorderStyle('all')
              },
              _react2.default.createElement('i', { className: 'icon-table-boder' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            { className: 'col-md-4 text-left u_paddingLeft' },
            _Izenda10.default.getText('BORDER_SETTING_LABEL_DASH_STYLE')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(_Izenda6.default, { dashStyle: _this.dashStyle, onChange: _this.onChangeDashStyle, className: 'u_marginRight' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            { className: 'col-md-4 text-left u_paddingLeft' },
            _Izenda10.default.getText('COMMON_LABEL_COLOR')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8 text-left' },
            _react2.default.createElement(
              'div',
              { className: 'borders-color' },
              _react2.default.createElement(_Izenda4.default, { color: _this.color, onChange: _this.onChangeColor })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            { className: 'col-md-4 text-left u_paddingLeft' },
            _Izenda10.default.getText('BORDER_SETTING_LABEL_THICKNESS')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(_Izenda2.default, { value: _this.thinkness, onChange: _this.onChangeThickness })
          )
        )
      );
    };

    _this.renderPreview = function () {
      return _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '6', className: 'text-center', xs: '0' },
        _react2.default.createElement(
          'span',
          null,
          _Izenda10.default.getText('BORDER_SETTING_TOOLTIP_APPLY_BORDER')
        ),
        _react2.default.createElement(
          _Izenda8.default,
          null,
          _react2.default.createElement(
            _Izenda8.default.Row,
            { className: 'border-settings-preview u_marginTop' },
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: '3', className: 'border-preview-right' },
              _react2.default.createElement(
                'a',
                { className: 'icon-border', onClick: _this.setBorderStyleAction('top') },
                _react2.default.createElement('i', { className: 'icon-top-boder' })
              ),
              _react2.default.createElement(
                'a',
                { className: 'icon-border', onClick: _this.setBorderStyleAction('midHor') },
                _react2.default.createElement('i', { className: 'icon-mid-hor-boder' })
              ),
              _react2.default.createElement(
                'a',
                { className: 'icon-border', onClick: _this.setBorderStyleAction('bottom') },
                _react2.default.createElement('i', { className: 'icon-bottom-boder' })
              )
            ),
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: '9', className: 'no-padding' },
              _react2.default.createElement(
                'div',
                { className: 'border-preview' },
                _react2.default.createElement('div', { className: 'border-box box1', style: _this.getStylesBorder('all') }),
                _react2.default.createElement('div', { className: 'border-box box2', style: _this.getStylesBorder('midHor') }),
                _react2.default.createElement('div', { className: 'border-box box3', style: _this.getStylesBorder('midVer') }),
                _react2.default.createElement(
                  'div',
                  { className: 'border-paragraph' },
                  _react2.default.createElement('i', { className: 'icon-pra' }),
                  _react2.default.createElement('i', { className: 'icon-pra' }),
                  _react2.default.createElement('i', { className: 'icon-pra' }),
                  _react2.default.createElement('i', { className: 'icon-pra' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'border-preview-bottom' },
                _react2.default.createElement(
                  'a',
                  { className: 'icon-border', onClick: _this.setBorderStyleAction('left') },
                  _react2.default.createElement('i', { className: 'icon-left-boder' })
                ),
                _react2.default.createElement(
                  'a',
                  { className: 'icon-border', onClick: _this.setBorderStyleAction('midVer') },
                  _react2.default.createElement('i', { className: 'icon-mid-ver-boder' })
                ),
                _react2.default.createElement(
                  'a',
                  { className: 'icon-border', onClick: _this.setBorderStyleAction('right') },
                  _react2.default.createElement('i', { className: 'icon-right-boder' })
                )
              )
            )
          )
        )
      );
    };

    _this.dashStyle = 'solid';
    _this.color = '#000';
    _this.thinkness = 1;

    var borderSettings = (0, _mobx.toJS)(props.value);

    // Border Style doesn't have structure then we shouldn't use mobx here.
    _this.state = {
      borderStyle: borderSettings
    };
    return _this;
  }

  // Return data for update data.


  /**
   * Update border style
   * @param {Object} value
   * @param {boolean} isUpdate
   */


  /**
   * Update border style
   * @param {Object} value
   * @param {boolean} isUpdate
   */


  /**
   * Handle on change border style
   * @param {string} value
   */


  /**
   * Resolve border's styles
   * @param {string} value
   */


  (0, _createClass3.default)(BorderSettings, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Izenda8.default,
        { className: 'border-settings' },
        _react2.default.createElement(
          _Izenda8.default.Row,
          { className: 'u_noMarginAll border-settings-header' },
          _react2.default.createElement(
            _Izenda8.default.Col,
            { cols: '6', className: 'text-center', xs: '12' },
            _Izenda10.default.getText('COMMON_LABEL_CONFIGURATION')
          ),
          _react2.default.createElement(
            _Izenda8.default.Col,
            { cols: '6', className: 'text-center', xs: '0' },
            _Izenda10.default.getText('COMMON_LABEL_PREVIEW')
          )
        ),
        _react2.default.createElement(
          _Izenda8.default.Row,
          { className: 'no-gutter u_noMarginAll border-settings-body' },
          this.renderConfiguration(),
          this.renderPreview()
        )
      );
    }

    /**
     * On change dash style handler
     * @param {string} value
     */


    /**
     * On change color handler
     * @param {string} value
     */


    /**
     * On change thickness handler
     * @param {string} value
     */


    /**
     * Render configuration
     */


    /**
     * Render preview
     */

  }]);
  return BorderSettings;
}(_react.Component), _class.propTypes = {
  onChange: _propTypes2.default.func,
  borderStyle: _propTypes2.default.object
}, _temp);
exports.default = BorderSettings;
module.exports = exports['default'];

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (editorComp, reportDesignerModel, fieldStore, itemProps) {
  var gridFieldPropsSchema = _Izenda2.default.apply(null, arguments);

  var container = itemProps.fieldContainerDetails;
  var configReportPart = reportDesignerModel.configReportPart;
  var reportPartContent = configReportPart.reportPartContent;
  var mappingSource = gridFieldPropsSchema.mappingSource;
  var forEachWithKey = _fp.forEach.convert({ cap: false });

  // add config to [subTotal]
  mappingSource.isHiddenSubTotal = function () {
    return (0, _fp.get)([reportPartContent.gridStyle, (0, _fp.getOr)('', 'name', container), 'hideSubTotal'].join('.'), _Izenda4.default.FIELD_PROPERTY_CONFIG);
  };

  mappingSource.isSeparator = function () {
    return (0, _fp.get)('name', container) === _Izenda4.default.CONTAINER_NAME.SEPARATORS;
  };

  function checkByKey(key) {
    return (0, _fp.get)([reportPartContent.gridStyle, (0, _fp.getOr)('', 'name', container), key].join('.'), _Izenda4.default.FIELD_PROPERTY_CONFIG);
  }

  forEachWithKey(function (removeProperties, key) {
    if (checkByKey(key)) {
      gridFieldPropsSchema.definedSchema = (0, _fp.reduce)((0, _fp.rearg)([1, 0], _fp.unset), gridFieldPropsSchema.definedSchema, removeProperties);
    }
  }, REMOVE_PROPERTY_BY_KEY);

  return gridFieldPropsSchema;
};

var _Izenda = __webpack_require__(257);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(84);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REMOVED_HEADER_FORMAT_FOR_PIVOT_COLUMN = ['fields.headerFormating.fields.fontFormat', 'fields.headerFormating.fields.fontStyle', 'fields.headerFormating.fields.alignment', 'fields.headerFormating.fields.verticalAlignment', 'fields.headerFormating.fields.columnGroup']; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsSchemaGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var REMOVED_COLUMN_GROUP = ['fields.headerFormating.fields.columnGroup'];

var REMOVED_HEADER_FORMAT_FOR_SEPARATOR = ['fields.headerFormating'];

var REMOVE_PROPERTY_BY_KEY = {
  hideConflitHeaderFormating: REMOVED_HEADER_FORMAT_FOR_PIVOT_COLUMN,
  hideColumnGroup: REMOVED_COLUMN_GROUP,
  hideAllHeaderFormating: REMOVED_HEADER_FORMAT_FOR_SEPARATOR
};

module.exports = exports['default'];

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _dec, _class4;
// ----------------------------------------------------------------------
// <copyright file="Izenda.MapFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GaugeFrontSide component
 */


var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(404);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(80);

var _Izenda6 = __webpack_require__(224);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(1971);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(53);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(315);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(15);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(76);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(35);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(412);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REPORT_PART_MODE = _Izenda11.default.REPORT_PART_MODE;

var MapChart = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(MapChart, _Component);

  function MapChart() {
    (0, _classCallCheck3.default)(this, MapChart);
    return (0, _possibleConstructorReturn3.default)(this, (MapChart.__proto__ || (0, _getPrototypeOf2.default)(MapChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(MapChart, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      nextProps.isReloadData && nextProps.reloadData();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Izenda4.default, this.props);
    }
  }]);
  return MapChart;
}(_react.Component)) || _class;

var MapPreview = (0, _mobxReact.observer)(_class2 = function (_Component2) {
  (0, _inherits3.default)(MapPreview, _Component2);

  function MapPreview(props) {
    (0, _classCallCheck3.default)(this, MapPreview);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MapPreview.__proto__ || (0, _getPrototypeOf2.default)(MapPreview)).call(this, props));

    _this2.saveCurrentReportState = function (reportPartContent) {
      _this2.activePointOptionByView = reportPartContent.activePointOption;
      _this2.isBeingBuildByView = reportPartContent.isBeingBuild;
      _this2.previousMapType = reportPartContent.chartType;
    };

    _this2.updateDrillComponent = function () {
      var reportPart = (0, _fp.getOr)({}, 'reportPart', _this2.props);
      reportPart.onDrilldown = _this2.onDrilldown;
    };

    _this2.reloadData = function () {
      var _this2$props = _this2.props,
          printingMode = _this2$props.printingMode,
          publishDrillInfo = _this2$props.publishDrillInfo,
          store = _this2$props.store,
          needUpdatePreview = _this2$props.needUpdatePreview;

      var reportPart = _this2.props.reportPart || {};
      var reportPartContent = reportPart.reportPartContent;
      !!publishDrillInfo && publishDrillInfo(reportPart.id, reportPart.reportPartContent.getCrossFilteringInfo());

      return needUpdatePreview(reportPart, (0, _fp.invoke)('getDrilldownInfo', reportPartContent), null, null, printingMode).then(function () {
        store && store.loadReportPartDataByCrossFiltering(reportPart.id);
      });
    };

    _this2.onDrilldown = (0, _mobx.action)(function (drilldown) {
      var _this2$props2 = _this2.props,
          reportBody = _this2$props2.reportBody,
          publishDrillInfo = _this2$props2.publishDrillInfo,
          store = _this2$props2.store;

      var reportPart = _this2.props.reportPart || {};
      var reportPartContent = reportPart.reportPartContent;
      // Add more info about drilling down field
      if (!(0, _fp.flow)((0, _fp.get)('point'), _fp.isNil)(drilldown)) {
        var fieldAlias = (0, _fp.get)('point.poinOptionName', drilldown);
        var drillingDownField = {
          reportPartElm: (0, _fp.find)(function (fieldElement) {
            return (0, _fp.get)('field.fieldNameAlias', fieldElement) == fieldAlias;
          }, reportPart.fieldCollection)
        };
        drilldown.point.drillingDownField = drillingDownField;
      }

      reportPartContent.updateDrilldownInfo(drilldown);
      if (!reportPartContent.isCrossFiltering) return;

      var drillDownData = {
        filters: [],
        expandedLevel: 0
      };

      var points = reportPartContent.getPoints();
      if (!(0, _fp.isEmpty)(drilldown) && !(0, _fp.isEmpty)(points)) {
        drillDownData.expandedLevel = 1; // This value is use for bill cross filtering, it is not updated into map content.

        (0, _fp.forEach)(function (p) {
          !(0, _fp.isEmpty)(p.mapInfo.backgroundMap.value) && p.point.poinOptionName && drillDownData.filters.push({
            key: p.point.poinOptionName,
            value: p.value,
            field: (0, _fp.get)('point.drillingDownField', p)
          });
        }, points);
      }

      reportBody && reportBody.updateCrossFiltering(reportPart, drillDownData);
      !!publishDrillInfo && publishDrillInfo(reportPart.id, reportPart.reportPartContent.getCrossFilteringInfo());
      reportPartContent.isCrossFiltering && store && store.loadReportPartDataByCrossFiltering(reportPart.id);
    });

    _this2.checkReloadData = function () {
      var reportPart = _this2.props.reportPart || {};
      var reportPartContent = reportPart.reportPartContent;
      var isBeingBuild = reportPartContent.isBeingBuild;
      var isBeingBuildByView = _this2.isBeingBuildByView;
      var isChangeMapType = _this2.previousMapType !== reportPartContent.chartType;

      if (!isBeingBuild || !isBeingBuildByView) {
        return false;
      }

      _this2.previousMapType = reportPartContent.chartType;
      var activePointOption = reportPartContent.activePointOption || {};
      var activePointOptionByView = _this2.activePointOptionByView || {};

      return activePointOptionByView.field !== activePointOption.field || isChangeMapType;
    };

    _this2.updateShownRecords = function (shownRecords) {
      _this2.setState({ shownRecords: shownRecords });
    };

    _this2.saveCurrentReportState((0, _fp.getOr)({}, 'reportPart.reportPartContent', props));
    _this2.state = {
      shownRecords: []
    };
    return _this2;
  }

  (0, _createClass3.default)(MapPreview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateDrillComponent();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _fp.isEqual)(this.props, nextProps) || !(0, _fp.isEqual)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateDrillComponent();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          printingMode = _props.printingMode,
          pointAction = _props.pointAction,
          refreshData = _props.refreshData,
          isPreview = _props.isPreview,
          style = _props.style,
          finishedRender = _props.finishedRender,
          fulfilledData = _props.fulfilledData,
          hideGridPopup = _props.hideGridPopup;

      var reportPart = this.props.reportPart || {};
      var reportPartContent = reportPart.reportPartContent;
      var chartProperties = reportPartContent.getMapOptions() || {};
      var type = reportPartContent.type;

      // check - if [activePointOption] is changed > get new previewData
      var needReloadData = this.checkReloadData(reportPartContent);

      this.saveCurrentReportState(reportPartContent);

      var chartData = reportPartContent.isBeingBuild && (0, _Izenda5.parser)(reportPartContent.activeElmsByContainers, reportPartContent.expandedLevel, {
        fieldsMapping: reportPart.previewDataFieldsMapping,
        records: reportPart.previewDataRecords,
        rawData: reportPart.previewData,
        cities: reportPart.cities,
        postalCodes: reportPart.postalCodes
      });

      $izenda.extend(true, chartProperties, {
        colors: reportPart.getThemeColors(chartProperties),
        commonOptions: {},
        commonActions: {
          onDrilldown: this.onDrilldown,
          pointAction: pointAction
        }
      });

      // turn off animation when printing.
      printingMode && $izenda.extend(true, chartProperties.commonOptions, {
        izendaOptions: {
          printingMode: printingMode
        }
      });

      // for refreshData - report part properties
      refreshData && refreshData(true);

      if (_Izenda19.default.needToRenderLazyLoadingBar(reportPart, printingMode)) {
        return _Izenda19.default.renderLazyLoadingBar();
      }

      return _react2.default.createElement(
        MapChart,
        {
          type: type,
          reportPart: reportPart,
          isReloadData: needReloadData,
          reloadData: this.reloadData,
          isPreview: isPreview,
          chartType: chartProperties.chartType,
          chartOptions: chartProperties,
          seriesOptions: reportPart.fieldCollection,
          printingMode: printingMode,
          finishedRender: finishedRender,
          fulfilledData: fulfilledData,
          isLoading: reportPart.isLoadingData,
          style: printingMode && style ? style : {},
          chartData: chartData,
          updateShownRecords: this.updateShownRecords
        },
        !printingMode && _react2.default.createElement(_Izenda9.default, {
          hideGridPopup: hideGridPopup,
          reportPart: reportPart,
          onDrillDown: this.onDrilldown,
          shownRecords: this.state.shownRecords
        })
      );
    }
  }]);
  return MapPreview;
}(_react.Component)) || _class2;

var MapFrontSide = (_dec = (0, _Izenda2.default)(), _dec(_class4 = function (_Component3) {
  (0, _inherits3.default)(MapFrontSide, _Component3);

  function MapFrontSide() {
    (0, _classCallCheck3.default)(this, MapFrontSide);
    return (0, _possibleConstructorReturn3.default)(this, (MapFrontSide.__proto__ || (0, _getPrototypeOf2.default)(MapFrontSide)).apply(this, arguments));
  }

  (0, _createClass3.default)(MapFrontSide, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      !_Izenda15.default.isMapDataAvailable && _Izenda13.default.getProvisioningStatus();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _fp.isEqual)(this.props, nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          hideTitle = _props2.hideTitle,
          width = _props2.width,
          printingMode = _props2.printingMode;

      var reportPartDetails = this.props.reportPart || {};
      var sizeStyle = this.props.style || {};
      var isMapDataAvailable = _Izenda15.default.isMapDataAvailable;
      var classes = (0, _classnames2.default)({
        'report-part-gauge-front-side': true,
        'izenda-ReportPartMap_frontSide': true,
        'izenda-ReportPart-smallSize': width < _Izenda11.default.REPORT_PART_SMALL_SIZE
      });

      return printingMode ? _react2.default.createElement(
        'div',
        { className: 'report-part-chart-front-side', style: _Izenda17.default.getReportPartContainerStyle(this.props) },
        _react2.default.createElement(
          'div',
          { className: _Izenda17.default.getReportPartClassName(this.props), style: sizeStyle },
          !hideTitle && _react2.default.createElement(_Izenda7.default, { mode: REPORT_PART_MODE.PREVIEW, reportPart: reportPartDetails }),
          isMapDataAvailable ? _react2.default.createElement(MapPreview, (0, _extends3.default)({}, (0, _fp.omit)(['width', 'height'], this.props), { style: sizeStyle })) : _react2.default.createElement(
            'span',
            null,
            _Izenda11.default.MESSAGES.MAP_DATA_UNAVAILABLE
          )
        )
      ) : _react2.default.createElement(
        _Izenda21.default,
        (0, _extends3.default)({}, this.props, { className: classes }),
        _react2.default.createElement(_Izenda7.default, { mode: REPORT_PART_MODE.PREVIEW, reportPart: reportPartDetails }),
        isMapDataAvailable ? _react2.default.createElement(MapPreview, (0, _fp.omit)(['width', 'height'], this.props)) : _react2.default.createElement(
          'span',
          null,
          _Izenda11.default.MESSAGES.MAP_DATA_UNAVAILABLE
        )
      );
    }
  }]);
  return MapFrontSide;
}(_react.Component)) || _class4);
exports.default = MapFrontSide;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(29);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(572);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(955);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(973);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

var _Izenda11 = __webpack_require__(1972);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PointOptions = (0, _Izenda2.default)(_Izenda12.default)(function (props) {
  var localization = props.localization,
      reportPart = props.reportPart;

  var reportPartContent = reportPart.reportPartContent || {};
  var options = reportPartContent.pointOptionsList;

  if (!options.length) {
    return null;
  }

  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'span',
      { title: 'Point Options', className: 'u_paddingRight izenda-PointOptions-text' },
      localization.getText('REPORTDESIGNER_LABEL_POINT_OPTIONS')
    ),
    _react2.default.createElement(_Izenda4.default, {
      options: reportPartContent.pointOptionsList,
      onChange: props.onChangePointOption,
      value: reportPartContent.activePointOption.value,
      valueField: 'value',
      labelField: getLabelField,
      renderInContainer: false
    })
  );

  function getLabelField(option) {
    var pointTypeName = (0, _fp.get)('pointTypeName', option);
    return localization.getText(['REPORT_PART_MAP_POINT', pointTypeName].join('_'));
  }
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.MapToolbar.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * MapToolbar component
 */


var RightSide = (0, _Izenda2.default)(_Izenda12.default)(function (props) {
  var otherProps = (0, _fp.omit)('className', props);
  var isShowMetric = (0, _fp.getOr)(true, 'reportPart.reportPartContent.isShowMetric', props);
  if ((0, _fp.get)('reportPart.reportPartContent.isBeingBuild', props)) {
    return _react2.default.createElement(
      'span',
      { className: props.className },
      !props.hideGridPopup && _react2.default.createElement(
        'a',
        { className: 'izenda-GridPopupIcon', title: props.localization.getText('GRID_POPUP_TOOLTIP') },
        _react2.default.createElement('span', { className: 'icon-grid', onClick: props.showGridPreviewPopup })
      ),
      _react2.default.createElement(PointOptions, otherProps),
      isShowMetric && _react2.default.createElement(_Izenda8.default, otherProps)
    );
  }

  return null;
});

exports.default = (0, _mobxReact.observer)(function (props) {
  return _react2.default.createElement(
    _Izenda6.default,
    { className: 'izenda-ReportPartMap_toolbar u-posRelative' },
    _react2.default.createElement(_Izenda10.default, (0, _extends3.default)({}, props, { className: 'izenda-ReportPartMapToolbar_leftSide' })),
    _react2.default.createElement(RightSide, (0, _extends3.default)({}, props, { className: 'izenda-ReportPartToolbar_rightSide u-posTopRight u-posAbsolute u_textRight' }))
  );
});
module.exports = exports['default'];

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(958);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1973);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Change point option handler
 * @param {Object} props
 * @param {Object} key
 * @param {Object} value
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeFrontSideActions.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

function onChangePointOption(props, key, value) {
  var reportPart = props.reportPart;

  var reportPartContent = reportPart.reportPartContent || {};

  reportPartContent.setActivePointOption(key, value);
}

/**
 * Show grid preview popup
 * @param {Object} props
 * @param {Object} e
 */
function showGridPreviewPopup(props, e) {
  props.openPopup(_Izenda2.default, {
    reportPart: props.reportPart,
    gridPreviewStore: new _Izenda4.default(),
    shownRecords: props.shownRecords
  });
}

exports.default = (0, _recompose.compose)((0, _recompose.withProps)(function () {
  return {
    hideGridPopup: false
  };
}), (0, _recompose.withHandlers)({
  onChangePointOption: (0, _fp.curry)(onChangePointOption),
  showGridPreviewPopup: (0, _fp.curry)(showGridPreviewPopup)
}));
module.exports = exports['default'];

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _bluebird = __webpack_require__(18);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.MapGridPreviewStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(105);

var _Izenda2 = __webpack_require__(965);

var _Izenda3 = _interopRequireDefault(_Izenda2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var MapGridPreviewStore = (_class = function (_GridPreviewStore) {
  (0, _inherits3.default)(MapGridPreviewStore, _GridPreviewStore);

  function MapGridPreviewStore() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MapGridPreviewStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MapGridPreviewStore.__proto__ || (0, _getPrototypeOf2.default)(MapGridPreviewStore)).call.apply(_ref, [this].concat(args))), _this), _this.shownRecords = [], _initDefineProp(_this, 'buildGridReportParts', _descriptor, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MapGridPreviewStore, [{
    key: 'getMappingContainers',

    /**
     * Get ordering containers of report part content by mapping definition
     * @param {Object} reportPartContent
     * @returns {Array<Object>} Collection of containers.
     */
    value: function getMappingContainers(reportPartContent) {
      var mappingToColumn = {};
      var pointType = reportPartContent.activePointOption.pointType;


      mappingToColumn[_Izenda.MAP_TYPES.World] = mappingToColumn[_Izenda.MAP_TYPES.Continent] = mappingToColumn[_Izenda.MAP_TYPES.Country] = [_Izenda.ContainerName.COUNTRY, _Izenda.ContainerName.STATE, _Izenda.ContainerName.COUNTY, _Izenda.ContainerName.CITY, _Izenda.ContainerName.POSTAL_CODE, _Izenda.ContainerName.LATITUDE];

      var mapping = mappingToColumn[reportPartContent.chartType] || [];
      var pointTypeNameIndex = (0, _fp.findIndex)(function (n) {
        return n === pointType;
      }, mapping);

      mapping.splice(pointTypeNameIndex + 1);
      pointType === _Izenda.ContainerName.LATITUDE && mapping.push(_Izenda.ContainerName.LONGTITUDE);
      if (pointType !== _Izenda.ContainerName.CITY && pointType !== _Izenda.ContainerName.POSTAL_CODE && pointType !== _Izenda.ContainerName.LATITUDE) {
        mapping.push(_Izenda.ContainerName.SHADING_VALUES);
      }
      mapping.push(_Izenda.ContainerName.BUBBLE_VALUES);

      var containers = mapping.reduce(function (result, type) {
        return (0, _fp.concat)(result, (0, _fp.get)(type, reportPartContent));
      }, []);
      return containers;
    }

    /**
     * Remove field which are not include in expand level or not the current metric
     * @param {number} expandedLevel
     * @param {string} metricContainerName
     * @param {Object} activeSerie
     */

  }, {
    key: 'applyExpandedLevelAndMetric',
    value: function applyExpandedLevelAndMetric(expandedLevel, metricContainerName, activeSerie) {
      return function (container) {
        var visibleElement = container.visibleElement,
            name = container.name;

        if ((0, _fp.some)(function (item) {
          return item === name;
        }, [_Izenda.ContainerName.SHADING_VALUES, _Izenda.ContainerName.BUBBLE_VALUES]) && !(0, _fp.isEmpty)((0, _mobx.toJS)(activeSerie))) {
          return (0, _fp.filter)(function (ele) {
            return ele === activeSerie;
          }, visibleElement);
        }
        return visibleElement;
      };
    }

    /**
     * Build vertical grid detail
     * @param {Object} reportPart
     * @param {Object} queryData
     * @param {number} index
     * @param {Array<Object>} metricContainer
     */

  }, {
    key: 'buildVerticalGridDetail',
    value: function buildVerticalGridDetail(reportPart, queryData, index, metricContainer) {
      var partDetail = (0, _get3.default)(MapGridPreviewStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(MapGridPreviewStore.prototype), 'buildVerticalGridDetail', this).call(this, reportPart, queryData, index, metricContainer);
      partDetail.partDefinition.queryData = (0, _assign2.default)({}, partDetail.partDefinition.queryData, {
        records: this.shownRecords
      });
      return partDetail;
    }

    /**
     * Build all grid report parts
     * @param {Object} reportPart
     * @param {Array<Object>} shownRecords
     */

  }]);
  return MapGridPreviewStore;
}(_Izenda3.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'buildGridReportParts', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (reportPart, shownRecords) {
      _this2.isProcessingData = true;
      var queryData = reportPart.queryData;

      var metricContainer = {
        elements: (0, _fp.flow)((0, _fp.filter)(function (con) {
          return (0, _fp.some)(function (name) {
            return name === con.name;
          }, [_Izenda.ContainerName.SHADING_VALUES, _Izenda.ContainerName.BUBBLE_VALUES]);
        }), (0, _fp.map)(function (c) {
          return c.elements;
        }))(reportPart.containerCollection)
      };

      _this2.shownRecords = shownRecords;

      _this2.gridReportParts = queryData.map(function (data, index) {
        return _this2.buildVerticalGridDetail(reportPart, data, index, metricContainer);
      });

      return (0, _bluebird.resolve)(true);
    };
  }
})), _class);
exports.default = MapGridPreviewStore;
module.exports = exports['default'];

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (editorComp, reportDesignerModel, fieldStore, itemProps) {
  var configField = itemProps.configField || {};
  var configReportPart = reportDesignerModel.configReportPart;
  var reportPartContent = configReportPart.reportPartContent;
  var fieldContainerDetails = itemProps.fieldContainerDetails || {};

  var containerName = fieldContainerDetails.name || '';
  var isPointOptionField = false,
      isValueField = false;

  if (_Izenda2.default.PointOptionsContainers.indexOf(containerName) > -1) {
    isPointOptionField = true;
  } else if (_Izenda2.default.ValuesContainers.indexOf(containerName) > -1) {
    isValueField = true;
  }

  var chartFieldPropsSchema = _Izenda4.default.apply(null, arguments);
  var mappingSource = chartFieldPropsSchema.mappingSource;
  var mappingProps = chartFieldPropsSchema.mappingProps;

  // update style options of subreport
  mappingProps.stypeOptions = (0, _fp.remove)({ value: 'embedded' }, mappingProps.stypeOptions);

  // update schema
  chartFieldPropsSchema.definedSchema = updateSchema(chartFieldPropsSchema.definedSchema);

  // data formatting: show text/cell color based on container
  showTextCellColor(chartFieldPropsSchema.definedSchema);

  return chartFieldPropsSchema;

  /**
   * Remove unsed-properties
   * @param  {object} fieldSchema
   * @return {object}
   */
  function updateSchema(fieldSchema) {
    var updatedFieldSchema = fieldSchema;
    var unusedFields = [];

    if (isPointOptionField) {
      unusedFields = UNUSED_PROPS_FOR_POINT_OPTS;
    } else if (isValueField) {
      unusedFields = UNUSED_PROPS_FOR_VALUES;
    }

    // remove common-unused-fields
    unusedFields.forEach(function (pathItem) {
      updatedFieldSchema = (0, _fp.set)([pathItem, 'isHidden'].join('.'), true, updatedFieldSchema);
    });

    return updatedFieldSchema;
  }

  function showTextCellColor(definedSchema) {
    var colorDef = (0, _fp.get)('fields.dataFormattings.fields.color', definedSchema);

    if (!colorDef) {
      return;
    }

    var textCellSettings = {
      showTextColor: isPointOptionField,
      showCellColor: isPointOptionField || isValueField
    };

    $izenda.extend(true, colorDef, {
      staticProps: {
        cellComponent: isPointOptionField ? _Izenda6.default : _Izenda8.default,
        maxColor: 'rgb(217,228,251)',
        minColor: 'rgb(79,134,189)'
      }
    }, {
      props: {
        showTextColor: textCellSettings.showTextColor,
        showCellColor: textCellSettings.showCellColor,
        pointOptionList: reportPartContent.pointOptionsList,
        isBubbleContainer: containerName === ContainerName.BUBBLE_VALUES
      }
    });
  }
};

var _Izenda = __webpack_require__(105);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(257);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(387);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1975);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContainerName = _Izenda2.default.ContainerName; // ----------------------------------------------------------------------
// <copyright file="Izenda.MapFieldPropsSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var UNUSED_PROPS_FOR_POINT_OPTS = ['fields.dataFormattings.fields.fontFormat', 'fields.dataFormattings.fields.fontStyle', 'fields.dataFormattings.fields.alignment', 'fields.dataFormattings.fields.verticalAlignment', 'fields.dataFormattings.fields.sort', 'fields.dataFormattings.fields.subTotal', 'fields.dataFormattings.fields.grandTotal', 'fields.dataFormattings.fields.width', 'fields.dataFormattings.fields.columnWordWrap', 'fields.headerFormating'];

var UNUSED_PROPS_FOR_VALUES = ['fields.dataFormattings.fields.fontFormat', 'fields.dataFormattings.fields.fontStyle', 'fields.dataFormattings.fields.alignment', 'fields.dataFormattings.fields.verticalAlignment', 'fields.dataFormattings.fields.sort', 'fields.dataFormattings.fields.subTotal', 'fields.dataFormattings.fields.grandTotal', 'fields.dataFormattings.fields.width', 'fields.dataFormattings.fields.columnWordWrap', 'fields.headerFormating', 'fields.drillDown.fields.subReport'];

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _bluebird = __webpack_require__(18);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CellColorSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(387);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(12);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

var _Izenda9 = __webpack_require__(258);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATA_TYPE = _Izenda10.default.DATA_TYPE;

var CellColorSettings = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CellColorSettings, _Component);

  function CellColorSettings(props) {
    (0, _classCallCheck3.default)(this, CellColorSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CellColorSettings.__proto__ || (0, _getPrototypeOf2.default)(CellColorSettings)).call(this, props));

    _initialiseProps.call(_this);

    _this.settingByRangeRef = null;
    var pointOptionList = props.pointOptionList || [{}];
    _this.state = { selectedPoint: pointOptionList[0].pointType };
    _this.initData();
    return _this;
  }

  /**
   * Add default data for Value settings
   */


  (0, _createClass3.default)(CellColorSettings, [{
    key: 'render',
    value: function render() {
      var selectedPoint = this.state.selectedPoint;
      var selectedSettingValue = this.settings[selectedPoint];
      var _props = this.props,
          isBubbleContainer = _props.isBubbleContainer,
          validateMessages = _props.validateMessages,
          defaultValue = _props.defaultValue,
          pointOptionList = _props.pointOptionList;


      var settingByRangeProps = {
        settingValue: selectedSettingValue,
        defaultValueType: selectedSettingValue.rangeValue ? 'rangeValue' : selectedSettingValue.value ? 'value' : 'none',
        dataType: DATA_TYPE.NUMERIC,
        haveName: true,
        isHiddenValueOption: isBubbleContainer,
        validateMessages: validateMessages,
        valueProps: {
          title: _Izenda8.default.getText('COLOR_SETTING_TOOLTIP'),
          type: 'color',
          defaultColor: defaultValue
        }
      };

      return _react2.default.createElement(
        'div',
        { className: 'izenda-CellColorSettings' },
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'u_paddingAll' },
          _react2.default.createElement(
            _Izenda4.default.Row,
            null,
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 5, className: 'u_controlHeight' },
              _react2.default.createElement(
                'span',
                null,
                _Izenda8.default.getText('COLOR_SETTING_POINT_OPTIONS')
              )
            ),
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 7 },
              _react2.default.createElement(_Izenda6.default, {
                options: pointOptionList,
                onChange: this.handleChangePlotOption,
                value: selectedPoint,
                valueField: 'pointType',
                labelField: getLabelField
              })
            )
          )
        ),
        _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, this.props, settingByRangeProps, { ref: this.setSettingByRangeRef }))
      );
      // settingByRange

      function getLabelField(option) {
        var pointTypeName = (0, _fp.get)('pointTypeName', option);
        return _Izenda8.default.getText(['REPORT_PART_MAP_POINT', pointTypeName].join('_'));
      }
    }
  }]);
  return CellColorSettings;
}(_react.Component), _class2.propTypes = {
  value: _react2.default.PropTypes.object
}, _class2.getDefaultProps = {
  settingValue: {},
  pointOptionsList: [{}]
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getValue = function () {
    _this2.settings[_this2.state.selectedPoint] = _this2.getSettingValue();
    return _this2.settings;
  };

  this.getSettingValue = function () {
    if (_this2.settingByRangeRef) {
      return _this2.settingByRangeRef.getValue();
    }
    return {};
  };

  this.initData = function () {
    var props = _this2.props;
    var settings = (0, _mobx.toJS)(props.settingValue) || {};
    var pointKeys = props.pointOptionList.map(function (point) {
      return point.pointType;
    });
    pointKeys.forEach(function (key) {
      return !settings[key] && (settings[key] = {});
    });
    _this2.settings = settings;
  };

  this.beforeClosing = function (valManager, btnType) {
    return _this2.settingByRangeRef.beforeClosing(valManager, btnType);
  };

  this.setSettingByRangeRef = function (element) {
    _this2.settingByRangeRef = element;
  };

  this.handleChangePlotOption = function (newVal, newValDetails) {
    var props = _this2.props;
    var popupContent = _this2.settingByRangeRef || {};
    var popupContentProps = props.popupContentProps || {};
    var valManager = props.validation;

    var beforeCloseFn = popupContentProps.beforeClosing;
    if (beforeCloseFn && popupContent[beforeCloseFn]) {
      return popupContent[beforeCloseFn](valManager, 'accept').then(function (canChange) {
        if (canChange) {
          return valManager.validate().then(function (success) {
            if (success) {
              _this2.settings[_this2.state.selectedPoint] = _this2.getSettingValue();
              _this2.setState({
                selectedPoint: newValDetails.pointType
              });
            } else {
              return (0, _bluebird.reject)(false);
            }
          });
        } else {
          return (0, _bluebird.reject)(false);
        }
      });
    }
    return (0, _bluebird.resolve)(true);
  };
}, _temp)) || _class;

exports.default = CellColorSettings;
module.exports = exports['default'];

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultReportPart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(188);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(540);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(12);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(315);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportTypeButton = _Izenda2.default.wrapper(function (props) {
  var rest = (0, _fp.pick)(['title', 'onClick'], props);
  return _react2.default.createElement(
    'button',
    (0, _extends3.default)({ type: 'button', className: 'btn btn-default u_noBorder u_textLeft' }, rest),
    props.children
  );
});

var DefaultReportPart = (_dec = (0, _Izenda6.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DefaultReportPart, _Component);

  function DefaultReportPart() {
    (0, _classCallCheck3.default)(this, DefaultReportPart);
    return (0, _possibleConstructorReturn3.default)(this, (DefaultReportPart.__proto__ || (0, _getPrototypeOf2.default)(DefaultReportPart)).apply(this, arguments));
  }

  (0, _createClass3.default)(DefaultReportPart, [{
    key: 'render',
    value: function render() {
      var props = this.props;

      var reportPart = props.reportPart;
      var reportBody = props.reportBody;

      var buttonLists = _Izenda4.default.REPORT_PART_TYPES.map(function (item) {
        var hasPrivilege = item.permissions ? props.authorization.checkPrivileges(item.permissions) : true;
        var hasLicense = item.licenseKey ? props.authorization.checkLicense(item.licenseKey) : true;

        return hasPrivilege && hasLicense ? _react2.default.createElement(
          ReportTypeButton,
          {
            key: item.key,
            title: item.label,
            store: props.store,
            onClick: handleSelect.bind(null, item),
            beforeShowProps: props.beforeShowProps,
            propsEditors: props.propsEditors,
            itemData: reportPart
          },
          _react2.default.createElement('span', { className: item.icon }),
          item.label
        ) : null;
      });

      return _react2.default.createElement(
        'div',
        { className: 'izenda-TableLayout u-bgWhite' },
        _react2.default.createElement(
          'div',
          { className: 'u_textRight u_textUppercase u_tableCell u_alignMiddle' },
          _react2.default.createElement(
            'div',
            { className: 'u_marginRight' },
            _react2.default.createElement(
              'p',
              null,
              _Izenda8.default.getText('REPORTDESIGNER_LABEL_TO_CREATE_REPORT_PART')
            ),
            _react2.default.createElement(
              'p',
              null,
              _Izenda8.default.getText('REPORTDESIGNER_LABEL_SELECT_A_TYPE')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_tableCell u_alignMiddle' },
          _react2.default.createElement(
            'div',
            { className: 'u_marginLeft' },
            _react2.default.createElement(
              'div',
              { className: 'btn-group-vertical' },
              buttonLists
            )
          )
        )
      );

      function handleSelect(item) {
        reportBody.setViewReportPart(reportPart, item);
      }
    }
  }]);
  return DefaultReportPart;
}(_react.Component), _class2.propTypes = {
  reportPart: _react.PropTypes.object,
  reportBody: _react.PropTypes.object
}, _temp)) || _class);
exports.default = DefaultReportPart;
module.exports = exports['default'];

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartBackSide.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartBackSide component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(53);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = __webpack_require__(27);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(142);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(975);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(41);

var _Izenda13 = _interopRequireDefault(_Izenda12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartBackSide = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(ReportPartBackSide, _Component);

  function ReportPartBackSide() {
    (0, _classCallCheck3.default)(this, ReportPartBackSide);
    return (0, _possibleConstructorReturn3.default)(this, (ReportPartBackSide.__proto__ || (0, _getPrototypeOf2.default)(ReportPartBackSide)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportPartBackSide, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          stateReview = _props.stateReview,
          type = _props.reportPart.type;

      var reportConfig = _Izenda9.default.getReportPartType(type);
      var ReportPartComponent = reportConfig.component;

      if (reportConfig.value === _Izenda5.REPORT_PART_TYPE.Form) {
        return _react2.default.createElement(
          'div',
          { className: 'izenda-ReportPartBackSide' },
          _react2.default.createElement(
            'div',
            { className: 'report-part-parent-panel u_fullSize' },
            _react2.default.createElement(ReportPartComponent.BackSide, this.props)
          )
        );
      }

      if (_Izenda2.default.isMobile) {
        return _react2.default.createElement(
          'div',
          { className: 'izenda-ReportPartBackSide' },
          _react2.default.createElement(
            'div',
            { className: 'report-part-parent-panel u_fullSize' },
            _react2.default.createElement(
              _Izenda7.default,
              null,
              _react2.default.createElement(ReportPartComponent.BackSide, this.props)
            )
          )
        );
      }

      var leftPanelClasses = (0, _classnames2.default)('child-panel u_tableCell u_alignTop', {
        hide: stateReview === _Izenda4.default.DIRECTION_STATE.RIGHT,
        'child-panel-expanded': stateReview === _Izenda4.default.DIRECTION_STATE.LEFT
      });
      var rightPanelClasses = (0, _classnames2.default)('child-panel u_tableCell u_alignTop', {
        hide: stateReview === _Izenda4.default.DIRECTION_STATE.LEFT,
        'child-panel-expanded': stateReview === _Izenda4.default.DIRECTION_STATE.RIGHT
      });

      return _react2.default.createElement(
        'div',
        { className: 'izenda-ReportPartBackSide' },
        _react2.default.createElement(
          'div',
          { className: 'report-part-parent-panel izenda-TableLayout' },
          _react2.default.createElement(
            'div',
            { className: leftPanelClasses },
            _react2.default.createElement(
              'div',
              { className: 'report-part-panel' },
              _react2.default.createElement(
                _Izenda7.default,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'report-part-panel-content panel-content' },
                  _react2.default.createElement(ReportPartComponent.BackSide, this.props)
                )
              )
            )
          ),
          _Izenda13.default.canShowPreview() && _react2.default.createElement(
            'div',
            { className: rightPanelClasses },
            _react2.default.createElement(ReportPartBackSidePreview, this.props)
          )
        )
      );
    }
  }]);
  return ReportPartBackSide;
}(_react.Component)) || _class;

exports.default = ReportPartBackSide;

var ReportPartBackSidePreview = function (_Component2) {
  (0, _inherits3.default)(ReportPartBackSidePreview, _Component2);

  function ReportPartBackSidePreview() {
    (0, _classCallCheck3.default)(this, ReportPartBackSidePreview);
    return (0, _possibleConstructorReturn3.default)(this, (ReportPartBackSidePreview.__proto__ || (0, _getPrototypeOf2.default)(ReportPartBackSidePreview)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportPartBackSidePreview, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.stateReview === this.props.stateReview;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'report-part-panel' },
        _react2.default.createElement(
          _Izenda7.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'report-part-panel-content panel-content' },
            _react2.default.createElement(_Izenda11.default, (0, _extends3.default)({}, this.props, { isPreview: true }))
          )
        )
      );
    }
  }]);
  return ReportPartBackSidePreview;
}(_react.Component);

module.exports = exports['default'];

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function () {
  var layoutComputerUtils = __webpack_require__(510);

  var SWAP_INTERSECT_RATIO = 0.33;

  var _require = __webpack_require__(1),
      clone = _require.clone,
      findIndex = _require.findIndex,
      find = _require.find,
      filter = _require.filter,
      placeholder = _require.placeholder;

  function getMaxWidth(layout) {
    return placeholder(layout).map(function (item) {
      return item.left + item.width;
    }).max() || 0;
  }

  function isCollided(layoutA, layoutB) {
    if (layoutA.id === layoutB.id) {
      return false; // same element
    }
    if (layoutA.left + layoutA.width <= layoutB.left) {
      return false; // layoutA is left of layoutB
    }
    if (layoutA.left >= layoutB.left + layoutB.width) {
      return false; // layoutA is right of layoutB
    }
    if (layoutA.top + layoutA.height <= layoutB.top) {
      return false; // layoutA is above layoutB
    }
    if (layoutA.top >= layoutB.top + layoutB.height) {
      return false; // layoutA is below layoutB
    }

    return true; // boxes overlap
  }

  function compact(layout) {
    var sorted = sortLayoutItemsByColRow(layout);
    var out = Array(layout.length);
    var compareWith = [];

    for (var i = 0, len = sorted.length; i < len; i++) {
      var l = clone(sorted[i]);
      l = compactItem(compareWith, l);
      compareWith.push(l);
      out[findIndex(sorted[i], layout)] = l;
      delete l.moved;
    }
    return out;
  }

  function compactItem(compareWith, layoutItem) {
    layoutItem.left = Math.min(getMaxWidth(compareWith), layoutItem.left);
    // Move the element up as far as it can go without colliding.
    while (layoutItem.left > 0 && !findOneCollision(compareWith, layoutItem)) {
      layoutItem.left--;
    }

    var collides;
    while (collides = findOneCollision(compareWith, layoutItem)) {
      layoutItem.left = collides.left + collides.width;
    }
    return layoutItem;
  }

  /**
   * Returns the first item this layout collides with.
   *
   * @param  {Object} layoutItem Layout item.
   * @return {Object|undefined}  A colliding layout item, or undefined.
   */
  function findOneCollision(layout, layoutItem) {
    return find(function (item) {
      return isCollided(layoutItem, item);
    }, layout);
  }

  function findAllCollisions(layout, layoutItem) {
    return filter(function (item) {
      return isCollided(layoutItem, item);
    }, layout);
  }

  /**
   *
   * @param  {Array}      layout Full layout to modify.
   * @param  {LayoutItem} layoutItem      element to move.
   * @param  {Object}     {x,y,width, height}
   * @param  {Boolean}    [isUserAction] If true, designates that the item we're moving is
   *                                     being dragged/resized by the user.
   */
  function move(layout, layoutItem, newPosition, isUserAction) {
    if (layoutItem.left === newPosition.left && layoutItem.top === newPosition.top && layoutItem.width === newPosition.width && layoutItem.height === newPosition.height) {
      return layout;
    }

    var isMovingToLeft = layoutItem.left > newPosition.left && layoutItem.width !== newPosition.width;

    layoutItem.left = newPosition.left;
    layoutItem.top = newPosition.top;
    layoutItem.width = newPosition.width;
    layoutItem.height = newPosition.height;
    layoutItem.moved = true;

    var sorted = sortLayoutItemsByColRow(layout);

    if (isMovingToLeft && Array.isArray(sorted)) {
      sorted.reverse();
    }

    var collisions = findAllCollisions(sorted, layoutItem);
    // Move each item that collides away from this element.
    for (var i = 0, len = collisions.length; i < len; i++) {
      var collision = collisions[i];
      // Short circuit so we can't infinite loop
      if (collision.moved) {
        continue;
      }

      // This makes it feel a bit more precise by waiting to swap for just a bit when moving up.
      if (layoutItem.left > collision.left && layoutItem.left - collision.left > collision.width * SWAP_INTERSECT_RATIO) {
        continue;
      }

      layout = moveElementAwayFromCollision(layout, layoutItem, collision, isUserAction);
    }

    return layout;
  }

  /**
   * This is where the magic needs to happen - given a collision, move an element away from the collision.
   * We attempt to move it up if there's room, otherwise it goes below.
   *
   * @param  {Array} layout            Full layout to modify.
   * @param  {LayoutItem} collidesWith Layout item we're colliding with.
   * @param  {LayoutItem} itemToMove   Layout item we're moving.
   * @param  {Boolean} [isUserAction]  If true, designates that the item we're moving is being dragged/resized
   *                                   by the user.
   */
  function moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction) {
    if (isUserAction) {
      var fakeItem = {
        left: itemToMove.left,
        top: itemToMove.top,
        width: itemToMove.width,
        height: itemToMove.height,
        id: -1
      };
      fakeItem.left = Math.max(collidesWith.left - itemToMove.width, 0);
      if (!findOneCollision(layout, fakeItem)) {
        return move(layout, itemToMove, fakeItem);
      }
    }

    var newPosition = {
      left: itemToMove.left + 1,
      top: itemToMove.top,
      width: itemToMove.width,
      height: itemToMove.height
    };
    return move(layout, itemToMove, newPosition);
  }

  function sortLayoutItemsByColRow(layout) {
    return [].concat(layout).sort(function (a, b) {
      if (a.left > b.left || a.left === b.left && a.top > b.top) {
        return 1;
      }
      return -1;
    });
  }

  function isEqualLayout(a, b) {
    return a.width === b.width && a.height === b.height && a.left === b.left && a.top === b.top;
  }

  module.exports = {
    compact: compact,
    move: move
  };
}();

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobxReact = __webpack_require__(10);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

exports.default = (0, _recompose.compose)(_mobxReact.observer, (0, _recompose.branch)(function (props) {
  return !(0, _fp.get)('field.fieldDetails.visible', props);
}, _recompose.renderNothing, _fp.identity), _mobxReact.observer);
// ----------------------------------------------------------------------
// <copyright file='Izenda.FilterDescriptionAction.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFormatItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var CustomInput = __webpack_require__(396);
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);
  var m = __webpack_require__(10);
  var ReportDesignerWidget = __webpack_require__(188);
  var FormatStyleUtils = __webpack_require__(981);

  var CONSTANTS = __webpack_require__(106);
  var ITEMS_TYPE = CONSTANTS.ITEMS_TYPE;
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      find = _require.find,
      startsWith = _require.startsWith,
      replace = _require.replace;

  var FormatItem = m.observer(function (props) {
    var store = props.store;
    var model = store.model;
    var formatGroup = props.formatElement;
    var listItems = formatGroup.formatItems;
    var viewMode = props.viewMode;

    var item = props.itemData || {};
    var itemSelected = item.isSelected;
    var classes = classnames(item.type, {
      'selected-item': itemSelected && !viewMode
    });
    var draggableBoxClass = classnames('format-item', {
      draggableBox: !viewMode
    });

    var cloneItem = updateImageUrl(item);
    var style = viewMode ? FormatStyleUtils.getStyle(cloneItem) : {};
    var backgroundStyle = FormatStyleUtils.getBackgroundStyle(item);
    var lineStyle = FormatStyleUtils.getLineStyle(item, viewMode);

    return React.createElement(
      'div',
      { onMouseDown: selectWidget, className: draggableBoxClass, draggable: 'true' },
      React.createElement(
        'div',
        { className: classes, style: style },
        renderItem()
      ),
      viewMode ? null : React.createElement(
        'a',
        { className: classes },
        React.createElement('span', { onClick: removeItem, className: 'icon-cancel' })
      )
    );

    /**
     * update item for relative path
     */
    function updateImageUrl(item) {
      var result = {
        font: item.font,
        alignment: item.alignment,
        imageUrl: item.imageUrl
      };
      if (item.type === 'image') {
        var imageUrl = result.imageUrl;
        if (imageUrl && imageUrl.indexOf('\\\\') >= 0) {
          result.imageUrl = '';
        } else if (!startsWith('http', imageUrl)) {
          var origin = window.location.origin;
          // Replace \ by /
          imageUrl = replace(/\\/g, '/', imageUrl);
          var relativeUrl = startsWith('/', imageUrl) ? imageUrl : '/' + imageUrl;
          result.imageUrl = '' + origin + relativeUrl;
        }
      }
      return result;
    }

    /**
     * update selected item when user click to one.
     */
    function selectWidget() {
      var onSelectingWidget = props.onClick;

      return onSelectingWidget && onSelectingWidget(props).then(function (valid) {
        valid && model.updateFormatItem && model.updateFormatItem(item, formatGroup.name);
      });
    }

    /**
     * Render format items base on it's type
     * @returns {*}
     */
    function renderItem() {
      var nameVals = {
        presence: {
          presence: true,
          message: localizer.getText('REPORTDESIGNER_MESSAGE_ITEM_NAME_REQUIRED')
        }
      };

      var onValidate = function onValidate(newName) {
        var isExisting = formatGroup && formatGroup.checkExistingFormatItemName && formatGroup.checkExistingFormatItemName(newName);
        var selectedFormatGroup = formatGroup.name;

        if (isExisting) {
          var formatGroups = find(function (item) {
            return item.value === selectedFormatGroup;
          }.bind(this), CONSTANTS.FORMAT_GROUP) || {};
          var formatGroupName = formatGroups.label;

          var message = String.format(CONSTANTS.MESSAGES.M01, formatGroupName);

          props.validationManager.updateErrors([{
            key: item.id,
            messages: [message]
          }]);
        }

        return isExisting;
      };

      // Replace system variables
      var displayValue = item.value;
      if (props.replaceSystemVariable) {
        displayValue = props.replaceSystemVariable(store, item);
      }

      switch (item.type) {
        case ITEMS_TYPE.image.value:
          return viewMode ? React.createElement('div', { className: 'image u_block full-height' }) : React.createElement(
            'div',
            { className: 'image' },
            React.createElement('span', { className: 'icon-img' }),
            React.createElement(
              'span',
              null,
              item.name
            )
          );
        case ITEMS_TYPE.text.value:
        case ITEMS_TYPE.dateTime.value:
          return viewMode ? React.createElement(
            'span',
            { style: backgroundStyle },
            displayValue
          ) : React.createElement(CustomInput, {
            className: 'form-control',
            value: item.name,
            onChange: handleTextChanged,
            validations: nameVals,
            field: item.id,
            onValidate: onValidate.bind(this)
          });
        case ITEMS_TYPE.pageNumber.value:
          return viewMode ? React.createElement('span', { style: backgroundStyle, className: 'page-number' }) : React.createElement(CustomInput, {
            className: 'form-control',
            value: item.name,
            onChange: handleTextChanged,
            validations: nameVals,
            field: item.id,
            onValidate: onValidate.bind(this)
          });
        case ITEMS_TYPE.horizontalRule.value:
          return React.createElement('div', { className: 'horizontal-rule', style: lineStyle });
        case ITEMS_TYPE.thinHorizontalRule.value:
          return React.createElement('div', { className: 'thin-horizontal-rule', style: lineStyle });
        case ITEMS_TYPE.verticalRule.value:
          return React.createElement('div', { className: 'vertical-rule', style: lineStyle });
      }
    }

    // handle change a format items' name when user edit it directly
    function handleTextChanged(value) {
      item.updateValueByKey('name', value.value);
    }

    // remove a format items when user click icon-cancel
    function removeItem() {
      listItems.splice(listItems.indexOf(item), 1);
      if (model.selectedFormatItem.id === item.id) {
        model.setSelectedFormatItem({});
      }
    }
  });

  FormatItem = ReportDesignerWidget.wrapper(FormatItem);

  module.exports = connect()(FormatItem);
}();

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AddItemPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * AddItemPopup Component
 */
!function () {

  var React = __webpack_require__(0);
  var PopupInput = __webpack_require__(309);
  var DropDown = __webpack_require__(29);
  var CONSTANTS = __webpack_require__(106);
  var EventsUtils = __webpack_require__(24);
  var classnames = __webpack_require__(11);
  var localizer = __webpack_require__(12);

  /**
   * Popup content component
   */
  var AddItemPopupContent = React.createClass({
    displayName: 'AddItemPopupContent',


    /**
    * Get initial state for component
    * @return {object}  state of component
    */
    getInitialState: function getInitialState() {
      return {
        selectValue: CONSTANTS.HEADER_FOOTER.items[0].value
      };
    },

    /**
     * Handle on change item add to format
     * @param  {string} value value select on dropdown list
     */
    onChangeSelectItem: function onChangeSelectItem(value) {
      this.setState({ selectValue: value });
    },

    /**
     * Handle get value when click ok button
     * @return {string} select value
     */
    getValue: function getValue() {
      return this.state.selectValue;
    },

    /**
     * Render component
     * @return {object} react component
     */
    render: function render() {
      return React.createElement(
        'div',
        { className: 'add-item-popup-content' },
        React.createElement(
          'span',
          null,
          'To add an item, select a type:'
        ),
        React.createElement(DropDown, { className: 'selection-item',
          options: CONSTANTS.HEADER_FOOTER.items,
          valueField: 'value',
          labelField: 'label',
          onChange: EventsUtils.notifyChange(this.onChangeSelectItem, EventsUtils.DROPDOWN),
          value: this.state.selectValue })
      );
    }
  });

  /**
   * Add item popup component
   */
  var AddItemPopup = React.createClass({
    displayName: 'AddItemPopup',


    /**
     * Define component props
     */
    propTypes: {
      onChange: React.PropTypes.func.isRequired
    },

    /**
     * Handle action when get value
     * @return {object}
     */
    onChange: function onChange(value) {
      this.props.onChange && this.props.onChange(value);
    },

    /**
    * Render component
    * @return {[type]} [description]
    */
    render: function render() {
      var className = classnames('add-format-item', this.props.className);
      return React.createElement(PopupInput, { containerClassName: className,
        className: 'btn btn-primary',
        label: localizer.getText('REPORTDESIGNER_LABEL_ADD_ITEM'),
        onChange: this.onChange,
        popupProps: {
          type: 'none',
          autoClose: true,
          sizeClass: 'modal-sm'
        },
        popupTitle: localizer.getText("REPORTDESIGNER_LABEL_ADD_ITEM"),
        popupContent: AddItemPopupContent });
    }
  });

  module.exports = AddItemPopup;
}();

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatItemPropsContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
/**
 * FormatItemPropsContainer component
 */
!function () {

  var FIELD_PROPS_TITLE = 'FORMAT PROPERTIES';
  var observer = __webpack_require__(10).observer;
  var React = __webpack_require__(0);

  var connect = __webpack_require__(2);
  var FormGroup = __webpack_require__(122);
  var DropDown = __webpack_require__(29);
  var PropertiesEditorContainer = __webpack_require__(268);
  var PropertiesEditorUtils = __webpack_require__(187);

  var CONSTANTS = __webpack_require__(106);
  var DefaultSchema = __webpack_require__(1983);

  var EventsUtils = __webpack_require__(24);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      get = _require.get;

  // show title of groups only - item is null


  var UNUSED_PROPS_NULL_CONFIG_FIELD = ['fields.generalInfo.fields', 'fields.itemFormat.fields'];

  var FormatItemPropsContainer = React.createClass({
    displayName: 'FormatItemPropsContainer',

    propTypes: {
      reportDesignerModel: React.PropTypes.object.isRequired,
      fieldStore: React.PropTypes.object.isRequired
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var props = this.props;
      var reportDesignerModel = props.reportDesignerModel || {};
      var reportField = reportDesignerModel.reportFields || {};
      var item = reportField.selectedFormatItem || {};
      var store = props.fieldStore || {};

      return React.createElement(
        'section',
        { className: 'form-horizontal field-props-container' },
        React.createElement(
          'strong',
          { className: 'title-group' },
          FIELD_PROPS_TITLE
        ),
        React.createElement(
          FormGroup,
          { className: 'report-parts-ctrl' },
          React.createElement(DropDown, { blankOption: true,
            options: CONSTANTS.FORMAT_GROUP,
            valueField: 'value',
            labelField: 'label',
            value: reportField.selectedFormatGroup,
            onChange: this.onChangeFormat }),
          React.createElement(DropDown, { blankOption: true,
            key: 'reportFields',
            valueField: 'id',
            labelField: 'name',
            value: item.id,
            options: getConfigurableFormatItem(),
            onChange: setConfigModeToFormatItem.bind(this) })
        ),
        renderFieldPropertiesEditor()
      );

      /**
      * Get all format item in format group
      * @return {array} list of format item in format group
      */
      function getConfigurableFormatItem() {
        return reportField.getFormatItems() || [];
      }

      function setConfigModeToFormatItem(value, selectItem) {
        selectItem = selectItem || {};
        reportField.updateFormatItem && reportField.updateFormatItem(selectItem, reportField.selectedFormatGroup);
      }

      /**
      * Render format item config
      * @return {[type]} [description]
      */
      function renderFieldPropertiesEditor() {
        var reportDesignerModel = props.reportDesignerModel;
        var configurationDef = DefaultSchema(reportDesignerModel, item, props.validation);
        var showDefaultProps = !get('id', item);

        showDefaultProps && removeUsedProps(configurationDef);

        return React.createElement(
          'fieldset',
          { disabled: showDefaultProps },
          React.createElement(PropertiesEditorContainer, { propertyConfig: configurationDef })
        );

        function removeUsedProps(propConfig) {
          PropertiesEditorUtils.removeProps(propConfig, UNUSED_PROPS_NULL_CONFIG_FIELD);
        }
      }
    },

    onChangeFormat: function onChangeFormat(selectedItem) {
      var props = this.props;
      var reportDesignerModel = props.reportDesignerModel || {};
      var reportField = reportDesignerModel.reportFields || {};

      reportField.updateFormatGroup(get('value', selectedItem));

      // move to selected format group
      PropertiesEditorUtils.takeAction('beforeRender', 'formatItemProps');
    }

  });
  module.exports = connect()(FormatItemPropsContainer);
}();

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatItemPropertiesSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  __webpack_require__(55);
  var m = __webpack_require__(5);
  var commonDataStore = __webpack_require__(155);
  var CONSTANTS = __webpack_require__(106);
  var DEFAULT_GROUP_BY = 'category';
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      find = _require.find,
      get = _require.get;

  var SCHEMA_DEF = {
    schemaKey: 'FORMAT_ITEM_PROPERTIES',
    props: {
      className: 'form-horizontal'
    },
    fields: {
      generalInfo: {
        component: 'Panel',
        props: {
          initState: true,
          collapsible: true,
          header: {
            get title() {
              return localizer.getText('COMMON_LABEL_GENERAL_INFO');
            },
            icon: 'icon-toggle-triangle'
          }
        },
        fields: {
          label: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_ITEM_TYPE');
            },
            type: 'static',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              field: 'label'
            }
          },

          name: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_ITEM_NAME');
            },
            component: 'CustomInput',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              validations: 'getFormatNameValidation',
              field: 'name'
            }
          },

          value: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_ITEM_VALUE');
            },
            component: 'InputByDataType',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              type: 'getInputByDataType',
              validations: {
                presence: {
                  presence: true,
                  message: localizer.getText('FORMAT_PROPERTIES_MESSAGE_ITEM_VALUE_REQUIRED')
                }
              },
              onBlur: 'validateItemValue',
              field: 'value'
            }
          },

          imageUrl: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_IMAGE_URL');
            },
            component: 'CustomInput',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              validations: {
                presence: {
                  presence: true,
                  get message() {
                    return localizer.getText('FORMAT_PROPERTIES_MESSAGE_IMAGE_URL_REQUIRED');
                  }
                }
              },
              field: 'urlImage'
            }
          },

          defaultImgBtn: {
            get title() {
              return ' ';
            },
            component: 'Button',
            isHidden: 'shouldDefaultImgBtnHidden',
            props: {
              label: localizer.getText('FORMAT_PROPERTIES_LABEL_DEFAULT_IMAGE_BUTTON'),
              onClick: 'loadDefaultImageUrl'
            }
          }
        }
      },
      itemFormat: {
        component: 'Panel',
        props: {
          initState: true,
          collapsible: true,
          header: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_ITEM_FORMATTING');
            },
            icon: 'icon-toggle-triangle'
          }
        },
        fields: {
          format: {
            get title() {
              return localizer.getText('COMMON_LABEL_FORMAT');
            },
            type: 'select',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              options: 'getDataFormats',
              labelField: 'name',
              valueField: 'name',
              groupBy: 'getGroupBy',
              showTooltip: true,
              blankOption: true,
              blankOptionText: '...'
            }
          },
          // font family + font size
          fontFormat: {
            get title() {
              return localizer.getText('FONT_SETTINGS_LABEL_FONT');
            },
            component: 'Font',
            fnValue: 'getFontFormat',
            isHidden: 'showByFormatType',
            props: {
              position: 'left'
            }
          },

          alignment: {
            get title() {
              return localizer.getText('FONT_SETTINGS_LABEL_ALIGNMENT');
            },
            component: 'AlignmentSetting',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType'
          },
          dashStyle: {
            get title() {
              return localizer.getText('BORDER_SETTING_LABEL_DASH_STYLE');
            },
            component: 'DashStyle',
            isHidden: 'showByFormatType',
            props: {
              dashStyle: 'getValueByKey'
            }
          },
          color: {
            get title() {
              return localizer.getText('COMMON_LABEL_COLOR');
            },
            component: 'ColorPicker',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              position: 'left'
            }
          },
          thickness: {
            get title() {
              return localizer.getText('BORDER_SETTING_LABEL_THICKNESS');
            },
            component: 'Thickness',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType'
          }
        }
      }
    }
  };

  var WIDGETS = {
    Panel: __webpack_require__(28),
    AlignmentSetting: __webpack_require__(317),
    Font: __webpack_require__(411),
    ColorPicker: __webpack_require__(169),
    Thickness: __webpack_require__(190),
    DashStyle: __webpack_require__(322),
    InputByDataType: __webpack_require__(260),
    CustomInput: __webpack_require__(396),
    Button: __webpack_require__(30)
  };

  module.exports = function (reportDesignerModel, item, valManager) {
    ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

    var formatType = item.type;

    var validateFormatName = function validateFormatName(newName) {
      var selectedFormatGroup = reportDesignerModel.reportFields.selectedFormatGroup;
      var selectedFormatItem = reportDesignerModel.reportFields.selectedFormatItem;
      var formatItems = reportDesignerModel.reportFields[selectedFormatGroup];
      var isExisting = formatItems.checkExistingFormatItemName && formatItems.checkExistingFormatItemName(newName, selectedFormatItem);

      var formatGroup = find(function (item) {
        return item.value === selectedFormatGroup;
      }.bind(this), CONSTANTS.FORMAT_GROUP) || {};
      var formatGroupName = formatGroup.label;

      var message = String.format(CONSTANTS.MESSAGES.M01, formatGroupName);

      if (isExisting) {
        return (0, _bluebird.resolve)(message);
      }
      return (0, _bluebird.resolve)('');
    };

    return {
      // define data to render UI
      definedSchema: SCHEMA_DEF,

      // list of widgets which are used to render UI
      widgets: WIDGETS,

      // data to binding to fields
      source: item,

      // properties for different fields
      mappingProps: {
        validateItemValue: function validateItemValue() {
          valManager.validate().then(function (success) {
            if (success) {
              valManager.reset();
            }
            return success;
          });
        },

        loadDefaultImageUrl: function loadDefaultImageUrl() {
          if (!isNil(reportDesignerModel.defaultImageUrl.value)) {
            item.updateValueByKey('imageUrl', reportDesignerModel.defaultImageUrl.value);
          }
        }
      },

      // defined-function which fields need to execute to get its data
      mappingSource: {
        getFormatNameValidation: function getFormatNameValidation() {
          return {
            presence: {
              presence: true,
              message: localizer.getText('REPORTDESIGNER_MESSAGE_ITEM_NAME_REQUIRED')
            },
            action: m.asReference(function () {
              return validateFormatName;
            })
          };
        },
        /**
         * Show hide config properties
         * @param  {string} optName
         * @return {boolean}
         */
        showByFormatType: function showByFormatType(optName) {
          var OPTIONS_BY_FORMAT_TYPE = CONSTANTS.OPTIONS_BY_FORMAT_TYPE;
          var defaultFormatOptionByType = OPTIONS_BY_FORMAT_TYPE[formatType];
          return isNil(defaultFormatOptionByType) ? true : !defaultFormatOptionByType.hasOwnProperty(optName);
        },

        /**
         * Get input control by item
         * @return {string}
         */
        getInputByDataType: function getInputByDataType() {
          if (formatType === 'text') {
            return 'text';
          } else {
            return 'static';
          }
        },

        /**
         * Get data format item
         * @return {array}
         */
        getDataFormats: function getDataFormats() {
          return commonDataStore.loadReportFieldDataFormat(formatType);
        },

        /**
         * Get option group by
         * @return {string}
         */
        getGroupBy: function getGroupBy() {
          if (formatType === CONSTANTS.ITEMS_TYPE.pageNumber.value) {
            return null;
          } else {
            return DEFAULT_GROUP_BY;
          }
        },

        getFontFormat: function getFontFormat() {
          var fontFormat = item.font || {};
          return {
            backgroundColor: fontFormat.backgroundColor,
            color: fontFormat.color,
            format: {
              fontFamily: fontFormat.family,
              fontSize: fontFormat.size
            },
            style: {
              fontBold: fontFormat.bold,
              fontItalic: fontFormat.italic,
              fontUnderline: fontFormat.underline
            }
          };
        },

        /**
         * Show hide default image button
         * @param  {string} optName
         * @return {boolean}
         */
        shouldDefaultImgBtnHidden: function shouldDefaultImgBtnHidden(optName) {
          return this.showByFormatType(optName) || isNil(reportDesignerModel.defaultImageUrl.value) || reportDesignerModel.defaultImageUrl.value === '';
        }
      },

      // mapping data from editor to report-designer- model
      onChangeValue: function onChangeValue(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
        var groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
        var fieldData = groupData[changedKey];

        fieldData && (fieldData.value = changedValue);

        var itemDetail = item;
        var generalInfo = schemaData.generalInfo;
        var itemFormat = schemaData.itemFormat;
        var fontFormat = itemFormat.fontFormat.value || {};
        var fontFamily = fontFormat.format || {};
        var fontStyle = fontFormat.style || {};

        itemDetail.setItemsDetails({
          name: generalInfo.name.value,
          value: generalInfo.value.value,
          imageUrl: generalInfo.imageUrl.value,
          format: itemFormat.format.value,
          alignment: itemFormat.alignment.value,
          color: itemFormat.color.value,
          dashStyle: itemFormat.dashStyle.value,
          thickness: itemFormat.thickness.value,
          family: fontFamily.fontFamily,
          size: fontFamily.fontSize,
          bold: fontStyle.fontBold,
          italic: fontStyle.fontItalic,
          underline: fontStyle.fontUnderline,
          textColor: fontFormat.color,
          textBackgrounColor: fontFormat.backgroundColor
        });
      }
    };
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function () {
  var GridLayoutUIStore = __webpack_require__(580);
  var CONSTANTS = __webpack_require__(106);
  var action = __webpack_require__(5).action;

  var _require = __webpack_require__(1),
      create = _require.create,
      round = _require.round;

  function ReportFormatLayoutUIStore(width, rows, cols) {
    GridLayoutUIStore.call(this, CONSTANTS.ROW_HEIGHT, // Initial square cell dim
    CONSTANTS.ROW_HEIGHT, // Initial square cell dim
    width, rows, cols, false, false, true, false);
  }

  /**
   * Inherit GridLayoutUIStore
   * @type {[type]}
   */
  ReportFormatLayoutUIStore.prototype = create(GridLayoutUIStore.prototype, {
    constructor: ReportFormatLayoutUIStore
  });

  /**
   * Override default setViewWidth to re-calculate cellWidth by new width because
   * the report format auto-scale cell dimension by its parent size.
   */
  ReportFormatLayoutUIStore.prototype.setViewWidth = action(function setViewWidth(width) {
    var newCellWidth = round(width / this.cols);

    this.cellWidth = newCellWidth;

    GridLayoutUIStore.prototype.setViewWidth.call(this, width);

    this.recalculateLayoutPosition();
  });

  module.exports = ReportFormatLayoutUIStore;
}();

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesigner.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

//child model


// Constant


__webpack_require__(55);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1986);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1991);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1995);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(325);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2003);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(16);

var _Izenda14 = __webpack_require__(986);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(58);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda18 = __webpack_require__(2004);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(585);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(586);

var _Izenda23 = __webpack_require__(42);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportDesigner = (_dec = (0, _mobx.action)('read'), _dec2 = (0, _mobx.action)('updatePreviewRecord'), _dec3 = (0, _mobx.action)('changeName'), _dec4 = (0, _mobx.action)('updateAdvanceDataSource'), _dec5 = (0, _mobx.action)('updateReportInfo'), _dec6 = (0, _mobx.action)('updateType'), _dec7 = (0, _mobx.action)('updateCategory'), _dec8 = (0, _mobx.action)('updateSubCategory'), _dec9 = (0, _mobx.action)('addSubCategory'), _dec10 = (0, _mobx.action)('addCategory'), _dec11 = (0, _mobx.action)('cleanDirty'), _dec12 = (0, _mobx.action)('updateReportOwner'), _dec13 = (0, _mobx.action)('setReportType'), _dec14 = (0, _mobx.action)('clearCategory'), _dec15 = (0, _mobx.action)('clearSubCategory'), (0, _Izenda2.default)(_class = (_class2 = function () {
  // First level
  function ReportDesigner(viewMode, reportId, isReload) {
    (0, _classCallCheck3.default)(this, ReportDesigner);

    _initDefineProp(this, 'saveAs', _descriptor, this);

    _initDefineProp(this, 'previewRecord', _descriptor2, this);

    _initDefineProp(this, 'reportName', _descriptor3, this);

    _initDefineProp(this, 'reportType', _descriptor4, this);

    _initDefineProp(this, 'categoryId', _descriptor5, this);

    _initDefineProp(this, 'categoryName', _descriptor6, this);

    _initDefineProp(this, 'subCategoryId', _descriptor7, this);

    _initDefineProp(this, 'subCategoryName', _descriptor8, this);

    _initDefineProp(this, 'ignoreCheckChange', _descriptor9, this);

    _initDefineProp(this, 'isSavingReport', _descriptor10, this);

    _initDefineProp(this, 'types', _descriptor11, this);

    _initDefineProp(this, 'categories', _descriptor12, this);

    _initDefineProp(this, 'subCategories', _descriptor13, this);

    _initDefineProp(this, 'errorMessages', _descriptor14, this);

    _initDefineProp(this, 'expandedLevel', _descriptor15, this);

    _initDefineProp(this, 'version', _descriptor16, this);

    _initDefineProp(this, 'schedules', _descriptor17, this);

    _initDefineProp(this, 'owner', _descriptor18, this);

    _initDefineProp(this, 'ownerId', _descriptor19, this);

    _initDefineProp(this, 'tenantId', _descriptor20, this);

    _initDefineProp(this, 'exportFormatSetting', _descriptor21, this);

    _initDefineProp(this, 'excludedRelationships', _descriptor22, this);

    _initDefineProp(this, 'createdBy', _descriptor23, this);

    _initDefineProp(this, 'reportDataSource', _descriptor24, this);

    _initDefineProp(this, 'reportId', _descriptor25, this);

    _initDefineProp(this, 'dynamicQuerySourceFields', _descriptor26, this);

    _initDefineProp(this, 'createdById', _descriptor27, this);

    _initDefineProp(this, 'accessPriority', _descriptor28, this);

    _initDefineProp(this, 'active', _descriptor29, this);

    _initDefineProp(this, 'isGlobal', _descriptor30, this);

    _initDefineProp(this, 'allowToSave', _descriptor31, this);

    this.dataSource = new _Izenda4.default();
    this.reportFields = new _Izenda6.default(viewMode, isReload);
    this.reportFormats = new _Izenda8.default();
    this.reportAccess = new _Izenda10.default();
    this.displayMode = new _Izenda19.default();
    this.subReportFilterFromQuery = {};
    this.subReportFilter = {};
    this.subReportMappingFields = [];
    this.export = new _Izenda12.default();
    // draft data id, use to get draft report definition
    this.draftId = null;
    // printingMode, use for printing
    this.printingMode = false;
    // default image logo for report
    this.defaultImageUrl = {};

    this.reportName = (0, _fp.isNil)(reportId) ? _Izenda13.DEFAULT_REPORT_NAME : '';
    this.reportId = reportId || null;

    this.cleanDirty();
  }
  /*common data for report data*/


  (0, _createClass3.default)(ReportDesigner, [{
    key: 'read',
    value: function read(report) {
      var category = report.category || {};
      var subCategory = report.subCategory || {};

      this.reportType = report.type;
      this.categoryId = category.id;
      this.categoryName = category.name;
      this.subCategoryId = subCategory.id;
      this.subCategoryName = subCategory.name;
      this.reportName = report.name;
      this.previewRecord = report.previewRecord;
      this.reportDataSource = report.reportDataSource;
      this.reportRelationship = report.reportRelationship;
      this.ownerId = report.ownerId;
      this.version = report.version;
      this.tenantId = report.tenantId;
      this.createdById = report.createdById;
      this.accessPriority = report.accessPriority;
      this.active = report.active;
      this.dynamicQuerySourceFields = report.dynamicQuerySourceFields;
      this.excludedRelationships = report.excludedRelationships;
      this.isGlobal = !(0, _fp.isNil)(report.isGlobal) ? report.isGlobal : false;
      this.allowToSave = report.allowToSave;

      this.reportFields.readFromReport(report);
      this.reportFormats.readFromReport(report);
      this.export.readFromReport(report);

      this.updateAdvanceDataSource(report);
      this.dataSource.readReportMode(report.advancedMode ? _Izenda13.ADVANCED : _Izenda13.SIMPLE);
      this.dataSource.readDistinct(report.isDistinct);

      this.cleanDirty();
    }

    /**
     * Build save data object
     * @param {any} section
     * @param {boolean} removeDynamicThreshold
     * @returns {object} save object
     */

  }, {
    key: 'getReportDefinition',
    value: function getReportDefinition(section) {
      var generalData = this.getGeneralData();
      var reportFieldsData = this.reportFields.buildDataForSaving(this.reportId);
      var reportFormats = this.buildReportFormatsForSaving();
      var schedules = this.buildScheduleDataForSaving();
      var exportFormatSetting = this.export.getExportConfig();
      this.reportAccess.mergeWithReportDraftAccess();
      var advancedMode = this.dataSource.reportMode === _Izenda13.ADVANCED;

      var reportDataSource = void 0;
      var reportRelationship = void 0;

      if (this.draftId) {
        reportDataSource = this.reportDataSource;
        reportRelationship = this.reportRelationship;
      } else {
        var selectedQuerySources = (0, _Izenda22.getSelectedQuerySources)(this.dataSource.dataTree.selectedTree);
        reportDataSource = !(0, _fp.isEmpty)(selectedQuerySources) ? selectedQuerySources : this.reportDataSource;
        reportRelationship = advancedMode ? this.dataSource.dataSourceDetail.dataSourceGrid : [];
      }

      return {
        reportKey: {
          key: this.reportId,
          modified: null,
          tenantId: _IzendaUiState2.default.getTenantId()
        },
        section: (0, _Izenda13.getReportSection)(section),
        saveAs: this.saveAs,
        ignoreCheckChange: this.ignoreCheckChange,
        isSavingReport: this.isSavingReport,
        report: {
          name: generalData.name,
          type: generalData.type,
          previewRecord: this.previewRecord,
          advancedMode: advancedMode,
          allowNulls: this.dataSource.allowNull,
          isDistinct: this.dataSource.distinct,
          categoryId: generalData.category.id,
          categoryName: generalData.category.name,
          category: generalData.category,
          subCategory: generalData.subCategory,
          subCategoryName: generalData.subCategory.name,
          subCategoryId: generalData.subCategory.id,
          reportDataSource: reportDataSource,
          reportRelationship: reportRelationship,
          reportFilter: reportFieldsData.reportFilter,
          reportPart: reportFieldsData.reportPart,
          header: reportFormats.header,
          footer: reportFormats.footer,
          titleDescription: reportFormats.titleDescription,
          version: this.version,
          schedules: schedules,
          ownerId: this.ownerId,
          accesses: this.updateAccesses,
          exportFormatSetting: exportFormatSetting,
          createdById: this.createdById,
          dynamicQuerySourceFields: this.dynamicQuerySourceFields,
          snapToGrid: reportFieldsData.snapToGrid,
          excludedRelationships: this.excludedRelationships,
          isGlobal: this.isGlobal,
          allowToSave: this.allowToSave,
          calculatedFields: this.reportFields.dataTree.calculatedFields
        },
        expandedLevel: this.expandedLevel
      };
    }
  }, {
    key: 'removeUnuseDynamicThresholds',
    value: function removeUnuseDynamicThresholds() {
      this.reportFields.reportBody.removeUnuseDynamicThresholds();
    }

    /**
     * Get report relationships
     * @return {any} report relationships
     */

  }, {
    key: 'getReportRelationship',
    value: function getReportRelationship() {
      if (this.draftId) {
        return this.reportRelationship;
      }
      return this.dataSource.reportMode === _Izenda13.ADVANCED ? this.dataSource.dataSourceDetail.dataSourceGrid : [];
    }

    /**
     * Build Report Format data when saving
     * @return {any} data format
     */

  }, {
    key: 'buildReportFormatsForSaving',
    value: function buildReportFormatsForSaving() {
      return {
        header: {
          visible: this.reportFormats.getHeaderFooterVisible(),
          items: this.reportFields.reportHeader.getItems()
        },
        footer: {
          visible: this.reportFormats.getHeaderFooterVisible(),
          items: this.reportFields.reportFooter.getItems()
        },
        titleDescription: {
          visible: this.reportFormats.getTitleDescriptionVisible(),
          items: this.reportFields.reportTitleDescription.getItems()
        }
      };
    }

    /**
     * add filters for sub report
     * @param  {any} filters
     * @param  {boolean} fromQuery
     */

  }, {
    key: 'setSubReportFilters',
    value: function setSubReportFilters(filters, fromQuery) {
      fromQuery ? this.subReportFilterFromQuery = filters : this.subReportFilter = filters;
    }

    /**
     * Parse url.
     * @param {any} query
     */

  }, {
    key: 'readURLOptions',
    value: function readURLOptions(query) {
      this.printingMode = !!(0, _fp.getOr)(false, 'print', query);
      this.printingMode && (this.draftId = (0, _fp.getOr)(null, 'draftId', query));
    }

    /**
     * Build Schedule data when saving
     * @return {any} schedule data
     */

  }, {
    key: 'buildScheduleDataForSaving',
    value: function buildScheduleDataForSaving() {
      if (this.isGlobal) {
        return [];
      }
      var schedules = (0, _fp.flow)((0, _fp.filter)(function (item) {
        return item.state !== _Izenda17.default.NONE;
      }), (0, _fp.forEach)(function (i) {
        if (i.state === _Izenda17.default.INSERT && !String.isGuidFormat(i.id)) {
          i.id = null;
        }
      }))(this.schedules);

      return schedules;
    }

    /**
     * Update preview record
     * @param  {any} value
     */

  }, {
    key: 'updatePreviewRecord',
    value: function updatePreviewRecord(value) {
      this.previewRecord = parseInt(value);
      this.markDirty();
    }

    /**
     * update report name in save popup
     * @param  {string} value
     */

  }, {
    key: 'changeName',
    value: function changeName(value) {
      this.reportName = value;
      this.markDirty();
    }

    /**
     * Update data source grid advance
     * @param  {any} reportInfo
     */

  }, {
    key: 'updateAdvanceDataSource',
    value: function updateAdvanceDataSource(reportInfo) {
      var reportRelationship = (0, _fp.get)('reportRelationship', reportInfo);

      if (!(0, _fp.isEmpty)(reportRelationship)) {
        var relationships = [];
        for (var index = 0; index < reportRelationship.length; index++) {
          relationships.push(new _Izenda21.default(reportRelationship[index]));
        }
        this.dataSource.dataSourceDetail.dataSourceGrid = relationships;
        this.dataSource.dataSourceDetail.dataSourceGrid.forEach(function (dataSourceGridItem) {
          dataSourceGridItem.level = dataSourceGridItem.relationshipPosition + 1;
          dataSourceGridItem.reindexKeyJoinsPosition();
        });
      }
    }

    /**
     * Update report detail.
     * @param {string} reportKey
     * @param {any} reportInfo
     * @param {boolean} isAdvancedMode
     * @param {boolean} keepReportBodyStates
     */

  }, {
    key: 'updateReportInfo',
    value: function updateReportInfo(reportKey, reportInfo, isAdvancedMode, keepReportBodyStates) {
      this.reportId = reportKey;
      this.version = reportInfo.version;

      this.reportFields.readFromReport(reportInfo, keepReportBodyStates);

      //update report info
      this.isGlobal = !(0, _fp.isNil)(reportInfo.isGlobal) ? reportInfo.isGlobal : false;
      this.categoryId = reportInfo.categoryId;
      this.categoryName = reportInfo.categoryName;
      this.subCategoryId = reportInfo.subCategoryId;
      this.subCategoryName = reportInfo.subCategoryName;
      //Update schedules
      this.schedules = reportInfo.schedules;
      this.owner = reportInfo.owner;
      this.ownerId = reportInfo.ownerId;

      this.createdBy = reportInfo.createdBy;
      this.reportAccess.populateData({
        accessList: reportInfo.accesses
      });

      isAdvancedMode && this.updateAdvanceDataSource(reportInfo);
    }

    /**
     * Update report type in save popup
     * @param  {number} value
     */

  }, {
    key: 'updateType',
    value: function updateType(value) {
      this.reportType = value;
      this.updateCategory();
      this.updateSubCategory();
      this.markDirty();
    }

    /**
     * Update report's category in save popup
     * @param  {string} id
     * @param  {string} name
     */

  }, {
    key: 'updateCategory',
    value: function updateCategory(id, name) {
      this.categoryId = id || null;
      this.categoryName = name || '';
      this.markDirty();
    }

    /**
     * Get tenant id of category.
     * @param  {string} id
     * @param  {boolean} isCategory
     * @return {any} tenantId
     */

  }, {
    key: 'getTenantIdOfCategory',
    value: function getTenantIdOfCategory(id, isCategory) {
      if (!id) {
        return _IzendaUiState2.default.getTenantId();
      }

      var dataSource = isCategory ? this.categories : this.subCategories;
      var matchingItem = (0, _fp.find)(['id', id], dataSource);

      if (matchingItem) {
        return matchingItem.tenantId;
      }

      return null;
    }

    /**
     * Update errorMessages
     * @param  {any} errorMessages
     */

  }, {
    key: 'updateErrorMessages',
    value: function updateErrorMessages(errorMessages) {
      this.errorMessages = errorMessages;
    }

    /**
     * Update report's sub-category in save popup
     * @param  {string} id
     * @param  {string} name
     */

  }, {
    key: 'updateSubCategory',
    value: function updateSubCategory(id, name) {
      this.subCategoryId = id || null;
      this.subCategoryName = name || '';
      this.markDirty();
    }

    /**
     *  Get data for validate report name
     * @return {any}
     */

  }, {
    key: 'getGeneralData',
    value: function getGeneralData() {
      var result = {
        id: this.reportId,
        name: this.reportName,
        type: this.reportType,
        category: {},
        subCategory: {}
      };

      if (!(0, _fp.isNil)(this.categoryName)) {
        result.category = {
          id: String.isGuidFormat(this.categoryId) && this.categoryId !== _Izenda13.EMPTY_GUID ? this.categoryId : null,
          name: this.categoryName,
          type: this.reportType
        };

        result.category.tenantId = this.getTenantIdOfCategory(result.category.id, true);
      }

      if (!(0, _fp.isNil)(this.subCategoryName)) {
        result.subCategory = {
          id: String.isGuidFormat(this.subCategoryId) && this.categoryId !== _Izenda13.EMPTY_GUID ? this.subCategoryId : null,
          name: this.subCategoryName,
          type: this.reportType
        };

        result.subCategory.tenantId = this.getTenantIdOfCategory(result.subCategory.id, false);
      }

      result.category.isGlobal = this.isGlobal;
      result.subCategory.isGlobal = this.isGlobal;
      return result;
    }

    /**
     * Add new sub-category in save popup
     * @param  {any} subCategory
     */

  }, {
    key: 'addSubCategory',
    value: function addSubCategory(subCategory) {
      if ((0, _fp.findIndex)(subCategory, this.subCategories) < 0) {
        this.subCategories.push(subCategory);
      }
      this.markDirty();
    }

    /**
     * Add new category in save popup
     * @param  {any} category
     */

  }, {
    key: 'addCategory',
    value: function addCategory(category) {
      if ((0, _fp.findIndex)(category, this.categories) < 0) {
        this.categories.push(category);
      }
      this.updateSubCategory();
      this.subCategories = [];
      this.markDirty();
    }

    /**
     * Map data from data return from api to model sub-category
     * @param  {array} result
     * @return {Promise}
     */

  }, {
    key: 'readSubCategoryData',
    value: function readSubCategoryData(result) {
      result = result || [];
      this.subCategories = result.map(function (item) {
        return new _Izenda15.default(item);
      });

      return (0, _bluebird.resolve)('');
    }

    /**
     * Map data from data return from api to model category
     * @param  {array} result
     * @return {any}
     */

  }, {
    key: 'readCategoryData',
    value: function readCategoryData(result) {
      result = result || [];
      this.categories = result.map(function (item) {
        return new _Izenda15.default(item);
      });
      return null;
    }

    /**
     * Mark save as for saving report
     */

  }, {
    key: 'markSaveAs',
    value: function markSaveAs() {
      this.saveAs = true;
    }

    /**
     * Reset save as
     */

  }, {
    key: 'resetSaveAs',
    value: function resetSaveAs() {
      this.saveAs = false;
    }

    /**
     * Get save permission.
     * @returns {boolean} permission
     */

  }, {
    key: 'checkSavePermission',
    value: function checkSavePermission() {
      return this.accessPriority === _Izenda23.ACCESS_RIGHT.FullAccess && !this.isGlobal || this.isGlobal && _IzendaUiState2.default.currentUser.systemAdmin && !_IzendaUiState2.default.tenantId;
    }

    /**
     * Get dirty status.
     * @return {boolean}
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty || this.dataSource.checkDirty && this.dataSource.checkDirty() || this.reportFields.checkDirty && this.reportFields.checkDirty() || this.reportFormats.checkDirty && this.reportFormats.checkDirty() || this.reportAccess.checkDirty() || this.export.checkDirty() || this.checkScheduleDirty();
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.dataSource.cleanDirty && this.dataSource.cleanDirty();
      this.reportFields.cleanDirty && this.reportFields.cleanDirty();
      this.reportFormats.cleanDirty && this.reportFormats.cleanDirty();
      this.reportAccess.cleanDirty();
      this.export.cleanDirty();
      this.resetDirty();
    }

    /**
     * Check schedule dirty
     * @return {bolean}
     */

  }, {
    key: 'checkScheduleDirty',
    value: function checkScheduleDirty() {
      for (var i = 0; i < this.schedules.length; i++) {
        if (this.schedules[i].checkDirty && this.schedules[i].checkDirty()) {
          return true;
        }
      }
      return false;
    }

    /**
     * Mark ignore check change
     * @param  {any} value
     */

  }, {
    key: 'setIgnoreCheckChange',
    value: function setIgnoreCheckChange(value) {
      this.ignoreCheckChange = !!value;
    }

    /**
     * Mark ignore check change
     * @param  {any} value
     */

  }, {
    key: 'setIsSavingReport',
    value: function setIsSavingReport(value) {
      this.isSavingReport = value;
    }

    /**
     * Update schedule
     * @param {any} scheduleInstances
     */

  }, {
    key: 'updateSchedule',
    value: function updateSchedule(scheduleInstances) {
      this.schedules = scheduleInstances;
    }

    /**
     * Update list of report owner
     * @param  {any} reportOwners
     */

  }, {
    key: 'updateReportOwner',
    value: function updateReportOwner(reportOwners) {
      var owner = (0, _fp.last)(reportOwners) || {};
      this.owner = owner.fullName;
      this.ownerId = owner.id;
      this.markDirty();
    }

    /**
     * Mark ignore check change
     */

  }, {
    key: 'resetReportId',
    value: function resetReportId() {
      this.reportId = null;
    }

    /**
     * Set report type, clear Category and Sub-category when change report type
     * @param  {number} reportType
     */

  }, {
    key: 'setReportType',
    value: function setReportType(reportType) {
      if (this.reportType != reportType) {
        this.reportType = reportType;
        this.clearCategory();
        this.clearSubCategory();
      }
    }

    /**
     * Change global report type
     * @param {number} value
     */

  }, {
    key: 'changeGlobalType',
    value: function changeGlobalType(value) {
      this.isGlobal = value;
    }

    /**
     * Clear category
     */

  }, {
    key: 'clearCategory',
    value: function clearCategory() {
      this.categoryId = null;
      this.categoryName = null;
    }

    /**
     * Clear sub-category
     */

  }, {
    key: 'clearSubCategory',
    value: function clearSubCategory() {
      this.subCategoryId = null;
      this.subCategoryName = null;
    }
  }, {
    key: 'accesses',
    get: function get() {
      return this.reportAccess.accessList;
    }
  }, {
    key: 'updateAccesses',
    get: function get() {
      return this.reportAccess.draftAccesses;
    }
  }, {
    key: 'supportReportParts',
    get: function get() {
      return (0, _fp.get)('reportBody.supportReportParts', this.reportFields);
    }
  }, {
    key: 'configReportPart',
    get: function get() {
      return (0, _fp.getOr)(null, 'reportBody.configReportPart', this.reportFields);
    }
  }, {
    key: 'hasSelectedDataSource',
    get: function get() {
      return (0, _Izenda22.haveSelectedAtLeastOneQuerySource)(this.dataSource.dataTree.selectedTree);
    }

    /**
     * Check if report is ready for call getReportPartData
     * Avoid case navigate from master report to sub report in intergration mode
     */

  }, {
    key: 'isReadyForSubReport',
    get: function get() {
      return (0, _fp.isEmpty)(this.subReportFilterFromQuery) || !(0, _fp.isEmpty)(this.subReportFilter);
    }

    /**
     * Update report info when load for edit
     * @param {object} report data
     */

  }]);
  return ReportDesigner;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'saveAs', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'previewRecord', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda13.DEFAULT_PREVIEW_RECORD;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'reportName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'reportType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda13.REPORT_TYPE_ENUM.TEMPLATE;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'categoryId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'categoryName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'subCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'subCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'ignoreCheckChange', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'isSavingReport', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'types', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda13.TYPES;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'categories', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'subCategories', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'errorMessages', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'expandedLevel', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'version', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, 'schedules', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, 'owner', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, 'ownerId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, 'tenantId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, 'exportFormatSetting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, 'excludedRelationships', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, 'createdBy', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, 'reportDataSource', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class2.prototype, 'reportId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class2.prototype, 'dynamicQuerySourceFields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class2.prototype, 'createdById', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class2.prototype, 'accessPriority', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class2.prototype, 'active', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class2.prototype, 'isGlobal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class2.prototype, 'allowToSave', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'accesses', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'accesses'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAccesses', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAccesses'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'supportReportParts', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'supportReportParts'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'configReportPart', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'configReportPart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasSelectedDataSource', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasSelectedDataSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isReadyForSubReport', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isReadyForSubReport'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'read', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'read'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updatePreviewRecord', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updatePreviewRecord'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeName', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changeName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAdvanceDataSource', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAdvanceDataSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateReportInfo', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateReportInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateType', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateCategory', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateSubCategory', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateSubCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addSubCategory', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addSubCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addCategory', [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDirty', [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateReportOwner', [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateReportOwner'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setReportType', [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clearCategory', [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clearCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clearSubCategory', [_dec15], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clearSubCategory'), _class2.prototype)), _class2)) || _class);
exports.default = ReportDesigner;
module.exports = exports['default'];

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var ReportDesignerDataSourceDetail = __webpack_require__(1987);
  var ReportDesignerDataTree = __webpack_require__(578);
  var trackable = __webpack_require__(46);

  var _require = __webpack_require__(1),
      forEach = _require.forEach,
      remove = _require.remove;

  function ReportDataSource() {
    var props = {
      dataTree: new ReportDesignerDataTree(),
      dataSourceDetail: new ReportDesignerDataSourceDetail(),
      reportMode: null,
      allowNull: false,
      distinct: false,
      filterParams: []
    };

    m.extendObservable(trackable(this), props);

    this.cleanDirty();
  }

  /**
   * Check dirty
   */
  ReportDataSource.prototype.checkDirty = function () {
    return this.isDirty || this.dataTree.checkDirty() || this.dataSourceDetail.checkDirty();
  };

  /**
   * Clean dirty
   */
  ReportDataSource.prototype.cleanDirty = function () {
    return this.resetDirty() || this.dataTree.cleanDirty() || this.dataSourceDetail.cleanDirty();
  };

  /**
   * Reset View
   */
  ReportDataSource.prototype.resetDataSourceModel = function () {
    // Reset filter text
    this.dataTree.filterText = '';
  };

  /**
   * Update Distinct value
   * @param {type} value
   */
  ReportDataSource.prototype.changeDistinct = function (value) {
    this.distinct = value;
    this.markDirty();
  };

  /**
   * Update Allow null value
   * @param {type} value
   */
  ReportDataSource.prototype.changeAllowNull = function (value) {
    this.allowNull = value;
    this.markDirty();
  };

  /**
   * Set report mode
   * @param {type} value
   */
  ReportDataSource.prototype.readReportMode = function (reportMode) {
    this.reportMode = reportMode;
    return null;
  };

  /**
   * Set distinct
   * @param {boolean} value
   */
  ReportDataSource.prototype.readDistinct = function (value) {
    this.distinct = value;
  };

  /**
   * [addFilterParams update list filter which is parameter]
   * @param {object} dataObject
   */
  ReportDataSource.prototype.addFilterParams = m.action(function (dataObject) {
    var filterFields = dataObject.fields;

    dataObject && forEach(function (field) {
      field.isParameter === true ? this.filterParams.push(field) : null;
    }.bind(this), filterFields);
    this.markDirty();

    return (0, _bluebird.resolve)();
  });

  /**
   * [removeFilterParams remove filter paramerter]
   * @param  {object} dataObject
   */
  ReportDataSource.prototype.removeFilterParams = m.action(function (dataObject) {
    dataObject && forEach(function (field) {
      this.filterParams = remove(function (filter) {
        return filter.id === field.id;
      }, this.filterParams);
    }.bind(this), dataObject.fields);
    this.markDirty();
  });

  /**
   * Read data source grid
   * Use in Report Viewer only , no need to create class ReportDesignerRelationshipDetail
   */
  ReportDataSource.prototype.readDataSourceGrid = function (relationships) {
    this.dataSourceDetail.dataSourceGrid = relationships;
  };

  module.exports = ReportDataSource;
}();

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = __webpack_require__(416);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerDataSourceDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(98);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(585);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(54);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(586);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DataSourceDetail = (0, _Izenda7.default)(_class = (_class2 = function () {
  function DataSourceDetail() {
    (0, _classCallCheck3.default)(this, DataSourceDetail);

    _initDefineProp(this, 'dataSourceGrid', _descriptor, this);

    _initDefineProp(this, 'dirtyDataSourceGrid', _descriptor2, this);

    _initDefineProp(this, 'pageInfo', _descriptor3, this);

    _initDefineProp(this, 'totalRecords', _descriptor4, this);

    _initDefineProp(this, 'aliasLevel', _descriptor5, this);

    _initDefineProp(this, 'isDataSourceGridDirty', _descriptor6, this);

    _initDefineProp(this, 'dbRelationships', _descriptor7, this);

    _initDefineProp(this, 'isLoadingRelationship', _descriptor8, this);
  }
  // used for stopping Swap Data Object of relationships in DataSource tab

  // original relationships from API

  // loading relationship (dataSourceGrid) status -> used for handling 'No record found' issue


  (0, _createClass3.default)(DataSourceDetail, [{
    key: 'availableAlias',


    /**
     * Get available alias
     * @param {any} dataItem
     */
    value: function availableAlias(dataItem) {
      return (0, _fp.filter)(function (alias) {
        return alias.level <= dataItem.level;
      }, this.aliasLevel);
    }

    /**
     * Check dirty
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty || (0, _fp.some)(['isDirty', true], this.dataSourceGrid);
    }

    /**
     * Clean dirty
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();

      this.dataSourceGrid.forEach(function (relationship) {
        relationship.cleanDirty && relationship.cleanDirty();
      });
    }

    /**
     * Reset grid
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.dataSourceGrid = [];
      this.pageInfo = new _Izenda2.default(_Izenda3.BUNDLE.SORT_ORDERS, _Izenda3.BUNDLE.DEFAULT_CRITERIA);
    }

    /**
     * Add new relationship
     * @param {any} dataTree
     * @param {boolean} isAllQuerySourceUncategorized
     */

  }, {
    key: 'addNew',
    value: function addNew(dataTree, isAllQuerySourceUncategorized) {
      var item = new _Izenda5.default();
      item.setState(_Izenda3.OBJECT_STATE.INSERT);

      if (dataTree && isAllQuerySourceUncategorized) {
        item.setJoinDataSourceCategory(_Izenda3.EMPTY_GUID);
        item.setForeignDataSourceCategory(_Izenda3.EMPTY_GUID);
      }

      this.dataSourceGrid.push(item);
      this.reindexLevelAndPosition(item);

      var selectedQuerySources = (0, _Izenda8.getSelectedQuerySources)(dataTree);

      // Self join when only one query source is selected
      if (dataTree && selectedQuerySources.length === 1) {
        var selectedDataObject = (0, _fp.head)(selectedQuerySources);
        item.setDefaultValueByQuerySource(selectedDataObject, dataTree);
        this.initAliasForAddItem(item);
      }

      this.markDataSourceGridDirty();
      this.markDirty();
    }

    /**
     * Copy relationship
     * @param {any} relationship
     */

  }, {
    key: 'copyRelationship',
    value: function copyRelationship(relationship) {
      var indexOfRelationship = this.dataSourceGrid.indexOf(relationship) + 1;
      var cloneObj = relationship.cloneRelationship();

      var item = new _Izenda5.default(cloneObj);
      item.createDataForCopying();

      item.relationshipKeyJoins.forEach(function (keyJoin) {
        keyJoin.newId();
        keyJoin.setParentId(item.getId());
      });

      !(0, _fp.isEmpty)(relationship.joinQuerySourceId) && this.updateAlias(item);
      this.dataSourceGrid.splice(indexOfRelationship, 0, item);
      this.reindexLevelAndPosition(relationship);
      this.markDataSourceGridDirty();
      this.markDirty();
    }

    /**
     * Find relationship by id
     * @param {string} id
     */

  }, {
    key: 'findRelationshipById',
    value: function findRelationshipById(id) {
      return (0, _fp.find)({ tempId: id }, this.dataSourceGrid);
    }

    /**
     * Update alias for an item
     * @param {any} item
     */

  }, {
    key: 'updateAlias',
    value: function updateAlias(item) {
      var alias = this.getNewAlias(item.joinQuerySourceName);
      item.updateRelationshipItem(_Izenda3.TABLE_DEF.ADVANCED_MODE.alias.key, alias, true);
      item.needAlias = true;

      this.updateAliasLevel(this.getAliasOption(item, alias), item);
    }

    /**
     * Get new auto increment alias
     * @param {string} joinQuerySourceName
     */

  }, {
    key: 'getNewAlias',
    value: function getNewAlias(joinQuerySourceName) {
      var regex = joinQuerySourceName + ' (\\d+)$';
      var nextNumber = ((0, _fp.flow)((0, _fp.remove)({ state: _Izenda3.OBJECT_STATE.DELETE }), (0, _fp.map)(function (x) {
        return (0, _fp.toString)(x.alias).match(regex);
      }), _fp.compact, (0, _fp.map)(function (x) {
        return (0, _fp.toNumber)(x[1]);
      }), _fp.max)(this.dataSourceGrid) || 1) + 1;

      return joinQuerySourceName + ' ' + nextNumber;
    }

    /**
     * Only call this function when user select only one Data Object.
     * The function will populate the alias automatically
     * @param  {any} item
     */

  }, {
    key: 'initAliasForAddItem',
    value: function initAliasForAddItem(item) {
      if (item.joinQuerySourceId === item.originalAliasId) {
        this.updateAlias(item);
      }
    }

    /**
     * Handle event when user select change on Data Object or foreign data object
     * @param  {any} item     Item has changed
     * @param  {string} keyEvent Data object or foreign data object field
     */

  }, {
    key: 'onDataObjectChangeToGenerateAlias',
    value: function onDataObjectChangeToGenerateAlias(item, keyEvent) {
      this.generateAliasForItem(item, keyEvent);
    }

    /**
     * Create alias for item
     * @param {any} item Item
     * @param  {string} keyEvent Data object or foreign data object field
     */

  }, {
    key: 'generateAliasForItem',
    value: function generateAliasForItem(item, keyEvent) {
      if (!(0, _fp.isEmpty)((0, _fp.trim)(item.alias)) || (0, _fp.isEmpty)(item.joinQuerySourceId)) {
        return;
      }

      var dataObjectKey = _Izenda3.TABLE_DEF.ADVANCED_MODE.dataObject.key;
      var sameJoinQSRelationships = (0, _fp.filter)(function (_ref) {
        var state = _ref.state,
            joinQuerySourceId = _ref.joinQuerySourceId,
            tempId = _ref.tempId;
        return state !== _Izenda3.OBJECT_STATE.DELETE && joinQuerySourceId === item.joinQuerySourceId && tempId !== item.tempId;
      }, this.dataSourceGrid);

      if (this.isFirstSelfJoin(item)) {
        item.isSelfJoin = true;
        this.updateAlias(item);
      } else if (((0, _fp.isUndefined)(keyEvent) || keyEvent === dataObjectKey) && sameJoinQSRelationships.length > 0 && (0, _fp.some)(function (_ref2) {
        var alias = _ref2.alias;
        return alias === '';
      }, sameJoinQSRelationships)) {
        this.updateAlias(item);
      }
      this.markDirty();
    }

    /**
     * Generate aliases for relationships, only generate alias in 2 cases below:
     *  - is self join
     *  - querySourceId of current relationship is matched with prev relationships
     */

  }, {
    key: 'generateAliases',
    value: function generateAliases() {
      var _this = this;

      this.generateAliasForSelfJoin();
      this.dataSourceGrid.forEach(function (item) {
        return _this.generateAliasForItem(item);
      });
    }

    /**
     * Generate alias for self-join
     */

  }, {
    key: 'generateAliasForSelfJoin',
    value: function generateAliasForSelfJoin() {
      var _this2 = this;

      this.dataSourceGrid.forEach(function (item) {
        return _this2.isSelfJoin(item) && item.alias === '' && _this2.updateAlias(item);
      });
    }

    /**
     * Check if item is first self-join
     * @param {any} item
     */

  }, {
    key: 'isFirstSelfJoin',
    value: function isFirstSelfJoin(item) {
      return this.isSelfJoin(item) && !this.hasAlreadyFirstSelfJoin(item.joinQuerySourceId, item.id);
    }

    /**
     * Check if item is self-join
     * @param {any} item
     */

  }, {
    key: 'isSelfJoin',
    value: function isSelfJoin(item) {
      return item.joinQuerySourceId === item.originalAliasId;
    }
    /**
     * Check if items before current item have self-join
     * @param {string} joinQuerySourceId
     * @param {string} id
     */

  }, {
    key: 'hasAlreadyFirstSelfJoin',
    value: function hasAlreadyFirstSelfJoin(joinQuerySourceId, id) {
      var items = (0, _fp.filter)(function (o) {
        return o.isSelfJoin === true && o.joinQuerySourceId === joinQuerySourceId && id !== o.id;
      }, this.dataSourceGrid);

      return items.length > 0;
    }
  }, {
    key: 'delete',
    value: function _delete(item) {
      // Delete in alias level
      this.updateAliasLevel(null, item);
      (0, _fp.isEmpty)(item.id) ? this.dataSourceGrid.splice(this.dataSourceGrid.indexOf(item), 1) : item.delete();

      this.markDataSourceGridDirty();
      this.markDirty();
    }

    /**
     * Populate Data
     * @param {any} dataSourceDetail
     * @param {any} changedDataObject
     * @param {number} reportMode
     */

  }, {
    key: 'populateData',
    value: function populateData(dataSourceDetail, changedDataObject, reportMode) {
      if (reportMode === _Izenda3.ADVANCED) {
        return this.populateDataForAdvancedMode(dataSourceDetail);
      } else {
        return this.populateDataForSimpleMode(dataSourceDetail);
      }
    }

    /**
     * Populate Data for Simple mode
     * @param {any} dataSourceDetail
     */

  }, {
    key: 'populateDataForSimpleMode',
    value: function populateDataForSimpleMode(dataSourceDetail) {
      dataSourceDetail = dataSourceDetail || {};
      this.dataSourceGrid = dataSourceDetail.result;
      this.pageInfo.totalRecords = dataSourceDetail.total;

      return (0, _bluebird.resolve)(dataSourceDetail.relatedDataSourceCategories);
    }

    /**
     * Populate Data for Advanced mode
     * @param {any} dataSourceDetail
     */

  }, {
    key: 'populateDataForAdvancedMode',
    value: function populateDataForAdvancedMode(dataSourceDetail) {
      dataSourceDetail = dataSourceDetail || {};
      setKeyJoinParentId(dataSourceDetail);

      var dataSourceDetailResult = dataSourceDetail.result;
      if (this.isDataSourceGridDirty) {
        dataSourceDetailResult = this.mergeRelationships(dataSourceDetailResult);
      }
      this.populateDataSourceGrid(this.processDbRelationships(dataSourceDetailResult, this.dirtyDataSourceGrid));

      this.dataSourceGrid = this.filterNewRelationships(this.dataSourceGrid);
      this.pageInfo.totalRecords = dataSourceDetail.total;

      this.reindexLevelAndPosition();
      // Generate alias for relationships
      this.generateAliases();

      return (0, _bluebird.resolve)();
    }

    /**
     * Process swap list relationship to avoid generate alias
     * @param {Array<any>} dbRelationships
     */

  }, {
    key: 'processDbRelationships',
    value: function processDbRelationships(dbRelationships, dirtyRelationships) {
      var result = [];
      var numberOfRelationship = dbRelationships.length;

      // Index list relationship
      dbRelationships.forEach(function (item, index) {
        item.relationshipPosition = index;
      });

      // Check if relationship is self join
      var isSelfJoin = function isSelfJoin(item) {
        return item.joinQuerySourceId === item.originalAliasId;
      };

      // Check if relationship should has alias
      var shouldHasAlias = function shouldHasAlias(item) {
        return item.alias || isSelfJoin(item);
      };

      var compareQuerySourceToGroup = function compareQuerySourceToGroup(relationship, group, key) {
        return relationship[key] === group || group === 'null' && (0, _fp.isNull)(relationship[key]);
      };

      // Relationships with alias will not be swap so they will be add at the beginning
      result.push.apply(result, (0, _toConsumableArray3.default)((0, _fp.filter)(shouldHasAlias, dbRelationships)));

      // Relationships which can be swap
      var swapableRelationships = (0, _fp.reject)(shouldHasAlias, dbRelationships);

      // Swap data objects
      while (result.length < numberOfRelationship) {
        var groups = (0, _fp.flow)((0, _fp.reject)(shouldHasAlias), (0, _fp.flatMap)(function (rs) {
          return [rs.joinQuerySourceId, rs.foreignQuerySourceId];
        }), (0, _fp.groupBy)(function (qs) {
          return qs;
        }))(swapableRelationships);

        var numberOfLink = 1;
        var hadAdd = false;
        while (!hadAdd) {
          var minLength = 0;

          var _loop = function _loop(group) {
            if (groups.hasOwnProperty(group)) {
              if (groups[group].length === numberOfLink) {
                var relationshipIndexToAdd = (0, _fp.findIndex)(function (rs) {
                  return rs.joinQuerySourceId === group || rs.foreignQuerySourceId === group || group === 'null' && ((0, _fp.isNull)(rs.joinQuerySourceId) || (0, _fp.isNull)(rs.foreignQuerySourceId));
                }, swapableRelationships);
                var relationshipToAdd = swapableRelationships[relationshipIndexToAdd];
                var isDirtyRelationship = (0, _fp.some)(function (rs) {
                  return rs.id === relationshipToAdd.id || rs.alias === relationshipToAdd.alias && rs.joinQuerySourceId === relationshipToAdd.joinQuerySourceId && rs.joinFieldId === relationshipToAdd.joinFieldId && rs.selectedForeignAlias === relationshipToAdd.selectedForeignAlias && rs.foreignFieldId === relationshipToAdd.foreignFieldId;
                }, dirtyRelationships);

                if (!isDirtyRelationship) {
                  var alreadyHasJoinQuerySourceWithoutAlias = (0, _fp.some)(function (rs) {
                    return rs.joinQuerySourceId === group && rs.alias === '';
                  }, result);

                  // Already has join query source in result => swap
                  if (compareQuerySourceToGroup(relationshipToAdd, group, 'joinQuerySourceId') && alreadyHasJoinQuerySourceWithoutAlias || compareQuerySourceToGroup(relationshipToAdd, group, 'foreignQuerySourceId') && !alreadyHasJoinQuerySourceWithoutAlias) {
                    swapRelationshipDataObject(relationshipToAdd);
                  }
                }

                result.push(relationshipToAdd);
                swapableRelationships.splice(relationshipIndexToAdd, 1);
                hadAdd = true;
                return 'break';
              }
              if (minLength < groups[group].length) {
                minLength = groups[group].length;
              }
            }
          };

          for (var group in groups) {
            var _ret = _loop(group);

            if (_ret === 'break') break;
          }
          numberOfLink = minLength;
        }
      }

      return (0, _fp.orderBy)('relationshipPosition', 'asc', result);
    }

    /**
     * Populate Data Source grid.
     * In case there are keyJoins which was not saving to database then we must keep them.
     * @param {Array<any>} combinedRelationships
     */

  }, {
    key: 'populateDataSourceGrid',
    value: function populateDataSourceGrid(combinedRelationships) {
      var _this3 = this;

      // Delete relationships which were converted to keyjoin
      var deleteConvertedRelationships = function deleteConvertedRelationships(relationships) {
        var convertedRelationshipIds = (0, _fp.flow)((0, _fp.flatMap)(function (rs) {
          return rs.relationshipKeyJoins.slice();
        }), (0, _fp.map)('convertedFromRelationshipId'), _fp.compact)(relationships);

        return convertedRelationshipIds.length < 1 ? relationships : (0, _fp.reject)(function (rs) {
          return rs.state !== _Izenda3.OBJECT_STATE.UPDATE && (0, _fp.includes)(rs.id, convertedRelationshipIds);
        }, relationships);
      };
      this.dataSourceGrid = deleteConvertedRelationships(combinedRelationships);
      this.dataSourceGrid.forEach(function (relationship) {
        _this3.updateAliasLevel(_this3.getAliasOption(relationship, relationship.alias), relationship);
      });
    }

    /**
     * Merge relationship in grid with data model relationship
     * @param {Array<any>} dbRelationships
     */

  }, {
    key: 'mergeRelationships',
    value: function mergeRelationships(dbRelationships) {
      var result = [];
      // Add relationship created by user
      // Relationship which were modify will be keep
      this.dataSourceGrid.forEach(function (gridRelationship) {
        var newRelationship = (0, _fp.find)({ tempId: gridRelationship.tempId }, dbRelationships);
        result.push(!gridRelationship.hasBeenModified && newRelationship ? newRelationship : gridRelationship);
      });

      // Add new db relationships which is not having in the grid
      return (0, _fp.orderBy)(['relationshipPosition'], ['asc'], result.concat((0, _fp.differenceBy)('tempId', dbRelationships, result)));
    }

    /**
     * Filter new relationships/keyJoins: change status to hidden if searchText no match
     * @param {Array<any>} newRelationships
     */

  }, {
    key: 'filterNewRelationships',
    value: function filterNewRelationships(newRelationships) {
      var _this4 = this;

      if ((0, _fp.isEmpty)(newRelationships)) return [];

      var searchText = this.pageInfo.searchText.toLowerCase();
      var searchProperty = (0, _fp.lowerFirst)(this.pageInfo.searchProperty);

      var updateHiddenStatus = function updateHiddenStatus(relationship) {
        var isSearchTextMatched = function isSearchTextMatched(value) {
          if ((0, _fp.isNil)(searchText) || searchText.length === 0) return true;
          return value && value.toLowerCase().indexOf(searchText) >= 0;
        };

        // recursive filtering for KeyJoins
        var filterKeyJoins = function filterKeyJoins(relationship) {
          if (!relationship.isKeyJoin) {
            relationship.relationshipKeyJoins = _this4.filterNewRelationships(relationship.relationshipKeyJoins);

            // only display parent relationship when at least 1 visible keyJoin
            var visibleKeyJoins = (0, _fp.filter)({ hidden: false }, relationship.relationshipKeyJoins);
            if (!(0, _fp.isEmpty)(visibleKeyJoins)) {
              relationship.setHidden(false);
            }
          }
        };

        var dbRelationship = (0, _fp.find)({ id: relationship.id }, newRelationships);
        if ((0, _fp.isNil)(dbRelationship)) {
          relationship.setHidden && relationship.setHidden(true);
        } else {
          // Filter all criterion in case 'ALL'
          if (searchProperty === _Izenda3.SEARCH_ALL) {
            var criterion = _Izenda3.BUNDLE.CRITERIA_LIST_ADVANCED_MODE;

            for (var index in criterion) {
              // Guard for in eslint
              if (index < criterion.length) {
                var criteriaKey = (0, _fp.lowerFirst)(criterion[index].value);
                relationship.setHidden && relationship.setHidden(!isSearchTextMatched(relationship[criteriaKey]));
                if (isSearchTextMatched(relationship[criteriaKey])) {
                  break;
                }
              }
            }
          } else {
            relationship.setHidden && relationship.setHidden(!isSearchTextMatched(relationship[searchProperty]));
          }
        }

        filterKeyJoins(relationship);
      };

      newRelationships.map(updateHiddenStatus);
      return newRelationships;
    }

    /**
     * Update alias level
     * @param {string} newAlias
     * @param {any} item
     */

  }, {
    key: 'updateAliasLevel',
    value: function updateAliasLevel(newAlias, item) {
      var existedLevel = (0, _fp.find)({ id: item.tempId }, this.aliasLevel);
      // Delete
      if (!newAlias) {
        var aliasIndex = this.aliasLevel.indexOf(existedLevel);
        if (aliasIndex >= 0) {
          this.aliasLevel.splice(aliasIndex, 1);
        }
        return;
      }

      // Add, Update
      if (!existedLevel) {
        this.aliasLevel.push({
          level: item.level,
          alias: newAlias,
          id: item.tempId,
          relationshipId: item.tempId
        });
      } else {
        existedLevel.alias = newAlias;
      }
    }

    /**
     * Remove alias level
     * @param {any} relationship
     */

  }, {
    key: 'removeAliasLevel',
    value: function removeAliasLevel(relationship) {
      var removeIndex = (0, _fp.findIndex)({ id: relationship.tempId }, this.aliasLevel);
      removeIndex >= 0 && this.aliasLevel.splice(removeIndex, 1);
    }

    /**
     * Update list alias level
     * @param {any} item
     * @param {number} newLevel
     */

  }, {
    key: 'updateAliasLevelOnly',
    value: function updateAliasLevelOnly(item, newLevel) {
      var existedLevel = (0, _fp.find)({ id: item.tempId }, this.aliasLevel);
      if (existedLevel) {
        existedLevel.level = newLevel;
      }
    }

    /**
     * Reflect changed alias on all entire places
     * @param {Object} dataSourceItem
     */

  }, {
    key: 'populateUpdatedAlias',
    value: function populateUpdatedAlias(dataSourceItem) {
      var alias = dataSourceItem.alias,
          previousAlias = dataSourceItem.previousAlias,
          joinQuerySourceId = dataSourceItem.joinQuerySourceId;

      if (!(0, _fp.isNull)(alias)) {
        this.dataSourceGrid.forEach(function (dataSource) {
          dataSource.updateForeignAlias(joinQuerySourceId, alias, previousAlias);
          dataSource.updateKeyJoinForeignAlias(joinQuerySourceId, alias, previousAlias);
        });
      }
    }

    /**
     * Get alias option
     * @param {any} item
     * @param {string} aliasText
     */

  }, {
    key: 'getAliasOption',
    value: function getAliasOption(item, aliasText) {
      return aliasText ? {
        name: aliasText,
        sourceId: item.joinQuerySourceId,
        aliasId: this.generateAliasId(item, aliasText),
        visible: true
      } : null;
    }

    /**
     * Generate alias id
     * @param {any} item
     * @param {string} aliasText
     */

  }, {
    key: 'generateAliasId',
    value: function generateAliasId(item, aliasText) {
      return item.joinQuerySourceId + '_' + aliasText;
    }

    /**
     * Move relationship or key join from current index to new index
     * @param {any} currentRow
     * @param {any} newRow
     */

  }, {
    key: 'moveRelationshipOrKeyJoin',
    value: function moveRelationshipOrKeyJoin(currentRow, newRow) {
      var isParentCurrentRow = (0, _fp.isEmpty)(currentRow.parentId);
      var isParentNewRow = (0, _fp.isEmpty)(newRow.parentId);

      if (isParentCurrentRow && isParentNewRow) {
        // Moving relationship to relationship
        this.moveRelationship(currentRow, newRow);
      } else if (!isParentCurrentRow) {
        // Moving key join to relationship
        this.moveKeyJoin(currentRow, newRow);
      }

      this.markDirty();
      return (0, _bluebird.resolve)(true);
    }

    /**
     * Move relationship
     * @param {any} currentRow
     * @param {any} newRow
     */

  }, {
    key: 'moveRelationship',
    value: function moveRelationship(currentRow, newRow) {
      // Find read index again because some rows is hidden
      var realCurrentInd = (0, _fp.findIndex)({ tempId: currentRow.tempId }, this.dataSourceGrid);
      var realNewInd = (0, _fp.findIndex)({ tempId: newRow.tempId }, this.dataSourceGrid);

      this.dataSourceGrid.splice(realCurrentInd, 1);
      this.dataSourceGrid.splice(realNewInd, 0, currentRow);
      this.updateDataAfterMoveSuccess(currentRow, newRow);
    }

    /**
     * Move key join
     * @param {any} currentRow
     * @param {any} newRow
     */

  }, {
    key: 'moveKeyJoin',
    value: function moveKeyJoin(currentRow, newRow) {
      var currentParentRelationship = getRelationship(currentRow, this.dataSourceGrid);
      var newParentRelationship = getRelationship(newRow, this.dataSourceGrid);

      // return M04 error message if target relationship joinType is "Cross"
      if (newParentRelationship.joinType === _Izenda3.JOIN_TYPE_CROSS) {
        return _Izenda3.BUNDLE.MESSAGE.M04;
      }

      // find read index again because some rows is hidden
      var realCurrentInd = (0, _fp.findIndex)({ tempId: currentRow.tempId }, currentParentRelationship.relationshipKeyJoins);
      var realNewInd = (0, _fp.isEmpty)(newRow.parentId) ? newParentRelationship.relationshipKeyJoins ? newParentRelationship.relationshipKeyJoins.length : 0 : (0, _fp.findIndex)({ tempId: newRow.tempId }, newParentRelationship.relationshipKeyJoins);

      // remove key join from current relationship, then append it to new relationship
      currentParentRelationship.relationshipKeyJoins.splice(realCurrentInd, 1);
      newParentRelationship.relationshipKeyJoins.splice(realNewInd, 0, currentRow);
      currentRow.setParentId(newParentRelationship.tempId);

      // update data after moving success
      this.updateDataAfterMoveSuccess(currentRow, newRow);
      currentParentRelationship.reindexKeyJoinsPosition();
      newParentRelationship.reindexKeyJoinsPosition();

      // Force the grid to be re-render because changes in child array do not trigger mobx re-render
      var firstRelationship = (0, _fp.head)(this.dataSourceGrid);
      this.dataSourceGrid.splice(0, 1, firstRelationship);
    }

    /**
     * Update data after moving relationship or key join
     * @param {any} currentRow
     * @param {any} newRow
     */

  }, {
    key: 'updateDataAfterMoveSuccess',
    value: function updateDataAfterMoveSuccess(currentRow, newRow) {
      // Reindex level/position/alias level
      this.reindexLevelAndPosition();
      // Change state to UPDATE for current & new relationship
      currentRow.updateState();
      newRow.updateState();

      this.markDataSourceGridDirty();
    }

    /**
     * Reindex Alias Level & Relationship Position of DataSourceGrid.
     * Then update Alias Level from new row -> end
     * @param {any} fromRowItem
     */

  }, {
    key: 'reindexLevelAndPosition',
    value: function reindexLevelAndPosition(fromRowItem) {
      var _this5 = this;

      var currentRowLevel = fromRowItem ? fromRowItem.level : 1;
      this.dataSourceGrid.forEach(function (item, index) {
        item.relationshipPosition = index;
        item.level = index + 1;

        item.relationshipKeyJoins.forEach(function (keyJoin) {
          keyJoin.level = index + 1;
        });

        if (item.level >= currentRowLevel) {
          _this5.updateAliasLevelOnly(item, index + 1);
        }
      });
    }

    /**
     * Get invalid AliasLevels of current row when moving to new row
     * @param {any} currentRow
     */

  }, {
    key: 'getInvalidAliasLevelsForRow',
    value: function getInvalidAliasLevelsForRow(currentRow) {
      var currentRelationship = getRelationship(currentRow, this.dataSourceGrid);
      var selectedForeignAlias = currentRow.isKeyJoin ? currentRow.selectedForeignSourceAlias : currentRelationship.selectedForeignAlias;
      return (0, _fp.filter)(function (o) {
        return currentRelationship.level <= o.level && selectedForeignAlias === o.alias.aliasId;
      }, this.aliasLevel);
    }

    /**
     * Check join type between two entities in one relationship
     * @param {any} currentRow
     */

  }, {
    key: 'checkExistEntities',
    value: function checkExistEntities(currentRow) {
      if (currentRow.joinQuerySourceId && currentRow.originalAliasId) {
        var existedItem = (0, _fp.find)(function (dataSource) {
          return currentRow !== dataSource && dataSource.state != _Izenda3.OBJECT_STATE.DELETE && (dataSource.joinQuerySourceId === currentRow.joinQuerySourceId && dataSource.originalAliasId === currentRow.originalAliasId && dataSource.joinType !== currentRow.joinType || dataSource.joinQuerySourceId === currentRow.originalAliasId && dataSource.originalAliasId === currentRow.joinQuerySourceId && (dataSource.joinType !== currentRow.joinType && (dataSource.joinType !== _Izenda3.JOIN_TYPE.LEFT || currentRow.joinType !== _Izenda3.JOIN_TYPE.RIGHT) && (dataSource.joinType !== _Izenda3.JOIN_TYPE.RIGHT || currentRow.joinType !== _Izenda3.JOIN_TYPE.LEFT) || dataSource.joinType === _Izenda3.JOIN_TYPE.LEFT && currentRow.joinType === _Izenda3.JOIN_TYPE.LEFT || dataSource.joinType === _Izenda3.JOIN_TYPE.RIGHT && currentRow.joinType === _Izenda3.JOIN_TYPE.RIGHT)) && dataSource.alias === currentRow.alias;
        }, this.dataSourceGrid);

        return existedItem;
      }

      return null;
    }

    /**
     * Update join type between two entities in one relationship
     * @param {any} currentRow
     * @param {any} confirm
     */

  }, {
    key: 'updateJoinTypeForSameEntities',
    value: function updateJoinTypeForSameEntities(currentRow, confirm) {
      if (currentRow.joinQuerySourceId && currentRow.originalAliasId) {
        (0, _fp.map)(function (dataSource) {
          if (currentRow !== dataSource && dataSource.state != _Izenda3.OBJECT_STATE.DELETE && dataSource.joinQuerySourceId === currentRow.originalAliasId && dataSource.originalAliasId === currentRow.joinQuerySourceId && (dataSource.joinType !== currentRow.joinType && (dataSource.joinType !== _Izenda3.JOIN_TYPE.LEFT || currentRow.joinType !== _Izenda3.JOIN_TYPE.RIGHT) && (dataSource.joinType !== _Izenda3.JOIN_TYPE.RIGHT || currentRow.joinType !== _Izenda3.JOIN_TYPE.LEFT) || dataSource.joinType === _Izenda3.JOIN_TYPE.LEFT && currentRow.joinType === _Izenda3.JOIN_TYPE.LEFT || dataSource.joinType === _Izenda3.JOIN_TYPE.RIGHT && currentRow.joinType === _Izenda3.JOIN_TYPE.RIGHT) && dataSource.alias === currentRow.alias) {
            switch (confirm ? currentRow.joinType : dataSource.joinType) {
              case _Izenda3.JOIN_TYPE.LEFT:
                if (confirm) {
                  dataSource.joinType = _Izenda3.JOIN_TYPE.RIGHT;
                } else {
                  currentRow.joinType = _Izenda3.JOIN_TYPE.RIGHT;
                }
                break;
              case _Izenda3.JOIN_TYPE.RIGHT:
                if (confirm) {
                  dataSource.joinType = _Izenda3.JOIN_TYPE.LEFT;
                } else {
                  currentRow.joinType = _Izenda3.JOIN_TYPE.LEFT;
                }
                break;
              default:
                if (confirm) {
                  dataSource.joinType = currentRow.joinType;
                } else {
                  currentRow.joinType = dataSource.joinType;
                }
            }
          }

          if (currentRow !== dataSource && dataSource.joinQuerySourceId === currentRow.joinQuerySourceId && dataSource.originalAliasId === currentRow.selectedForeignAliass && dataSource.joinType !== currentRow.joinType && dataSource.alias === currentRow.alias) {
            dataSource.joinType = currentRow.joinType;
          }

          if (dataSource.joinType === _Izenda3.JOIN_TYPE_CROSS && currentRow !== dataSource) {
            dataSource.joinFieldId = null;
            dataSource.foreignFieldId = null;
          }
        }, this.dataSourceGrid);
        this.markDirty();
      }
    }

    /**
     * remove relationships which have DataObject/Foreign DataObject same with unchecked dataObject
     * @param {any} dataObject
     */

  }, {
    key: 'removeUncheckRelationships',
    value: function removeUncheckRelationships(dataObject) {
      var _this6 = this;

      // Delete Alias level of unchecked DataObjects
      this.dataSourceGrid.forEach(function (relationship) {
        if (relationship.foreignQuerySourceId === dataObject.id || relationship.joinQuerySourceId === dataObject.id) {
          _this6.removeAliasLevel(relationship);
        }
      });

      // Filter out unchecked DataObjects
      this.dataSourceGrid.replace((0, _fp.filter)(function (relationship) {
        return relationship.foreignQuerySourceId !== dataObject.id && relationship.joinQuerySourceId !== dataObject.id;
      }, this.dataSourceGrid));

      // Reindex position before receive new relationship data so the position do not mess up
      this.reindexLevelAndPosition();
    }

    /**
     * Mark dataSourceGrid dirty
     */

  }, {
    key: 'markDataSourceGridDirty',
    value: function markDataSourceGridDirty() {
      this.isDataSourceGridDirty = true;
      this.dataSourceGrid.forEach(function (item) {
        item.setModify(true);
      });
      this.dirtyDataSourceGrid = this.dataSourceGrid;
    }

    /**
     * Reset data source grid dirty
     */

  }, {
    key: 'resetDataSourceGridDirty',
    value: function resetDataSourceGridDirty() {
      this.isDataSourceGridDirty = false;
      this.dirtyDataSourceGrid = [];
    }

    /**
     * Get id from dbRelationships
     */

  }, {
    key: 'getDbRelationshipIds',
    value: function getDbRelationshipIds() {
      return (0, _fp.flow)((0, _fp.remove)({ state: _Izenda3.OBJECT_STATE.DELETE }), (0, _fp.map)(function (item) {
        return {
          alias: item.alias,
          joinQuerySourceId: item.joinQuerySourceId,
          selectedForeignAlias: item.selectedForeignAlias,
          relationshipPosition: item.relationshipPosition,
          hasBeenModified: item.hasBeenModified,
          convertedKeyJoinIds: (0, _fp.flow)((0, _fp.map)('convertedFromRelationshipId'), _fp.compact)(item.relationshipKeyJoins.slice())
        };
      }))(this.dataSourceGrid);
    }

    /**
     * Validate data source grid
     */

  }, {
    key: 'validateDataSourceGrid',
    value: function validateDataSourceGrid() {
      var _this7 = this;

      var invalidRows = (0, _fp.filter)(function (item) {
        return !(0, _fp.isEmpty)(_this7.getInvalidAliasLevelsForRow(item));
      }, this.dataSourceGrid);

      return (0, _fp.isEmpty)(invalidRows);
    }

    /**
     * Reset alias level
     */

  }, {
    key: 'resetAliasLevel',
    value: function resetAliasLevel() {
      this.aliasLevel = [];
    }
  }, {
    key: 'totalKeyJoin',
    get: function get() {
      return (0, _fp.sumBy)('keyJoinCount', this.dataSourceGrid);
    }
  }, {
    key: 'haveRelationships',
    get: function get() {
      return !(0, _fp.isEmpty)((0, _fp.filter)({ deleted: false }, this.dataSourceGrid));
    }
  }, {
    key: 'displayDataSourceGrid',
    get: function get() {
      return (0, _fp.filter)({ deleted: false, hidden: false }, this.dataSourceGrid);
    }
  }]);
  return DataSourceDetail;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'dataSourceGrid', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'dirtyDataSourceGrid', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'pageInfo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda2.default(_Izenda3.BUNDLE.SORT_ORDERS, _Izenda3.BUNDLE.DEFAULT_CRITERIA);
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'totalRecords', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'aliasLevel', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'isDataSourceGridDirty', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'dbRelationships', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'isLoadingRelationship', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'totalKeyJoin', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'totalKeyJoin'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'haveRelationships', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'haveRelationships'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'displayDataSourceGrid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'displayDataSourceGrid'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reset', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reset'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addNew', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addNew'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'copyRelationship', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'copyRelationship'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'findRelationshipById', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'findRelationshipById'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAlias', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAlias'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'initAliasForAddItem', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'initAliasForAddItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onDataObjectChangeToGenerateAlias', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDataObjectChangeToGenerateAlias'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'delete', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'delete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateDataForSimpleMode', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateDataForSimpleMode'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateDataForAdvancedMode', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateDataForAdvancedMode'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processDbRelationships', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processDbRelationships'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateDataSourceGrid', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateDataSourceGrid'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'mergeRelationships', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'mergeRelationships'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filterNewRelationships', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filterNewRelationships'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAliasLevel', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAliasLevel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeAliasLevel', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeAliasLevel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAliasLevelOnly', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAliasLevelOnly'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateUpdatedAlias', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateUpdatedAlias'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'moveRelationshipOrKeyJoin', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'moveRelationshipOrKeyJoin'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'moveRelationship', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'moveRelationship'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'moveKeyJoin', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'moveKeyJoin'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDataAfterMoveSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDataAfterMoveSuccess'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reindexLevelAndPosition', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reindexLevelAndPosition'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateJoinTypeForSameEntities', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateJoinTypeForSameEntities'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeUncheckRelationships', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeUncheckRelationships'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetAliasLevel', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetAliasLevel'), _class2.prototype)), _class2)) || _class;

exports.default = DataSourceDetail;


function swapRelationshipDataObject(relationship) {
  var swapValue = function swapValue(item, keys) {
    var _keys = (0, _slicedToArray3.default)(keys, 2),
        firstKey = _keys[0],
        secondKey = _keys[1];

    var tempValue = item[firstKey];
    item[firstKey] = item[secondKey];
    item[secondKey] = tempValue;
  };

  _Izenda3.DATA_OBJECT_SWAP_KEYS.forEach(function (keys) {
    return swapValue(relationship, keys);
  });
  relationship.selectedForeignAlias = relationship.foreignQuerySourceId + '_' + relationship.foreignQuerySourceName;

  // switch joinType to LEFT/Right
  switch (relationship.joinType) {
    case _Izenda3.JOIN_TYPE.LEFT:
      relationship.joinType = _Izenda3.JOIN_TYPE.RIGHT;
      return;
    case _Izenda3.JOIN_TYPE.RIGHT:
      relationship.joinType = _Izenda3.JOIN_TYPE.LEFT;
      return;
    default:
      return;
  }
}

function setKeyJoinParentId(dataSourceDetail) {
  dataSourceDetail.result && dataSourceDetail.result.forEach(function (rs) {
    rs.relationshipKeyJoins.forEach(function (keyJoin) {
      keyJoin.parentId = rs.id;
    });
  });
}

function getRelationship(item, dataSourceGrid) {
  return (0, _fp.isEmpty)(item.parentId) ? item : (0, _fp.find)({ tempId: item.parentId }, dataSourceGrid);
}
module.exports = exports['default'];

/***/ }),
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerFields.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(983);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(578);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1992);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1993);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(106);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(54);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var FORMAT_GROUP_CONFIG = _Izenda10.default.FORMAT_GROUP_CONFIG;

var ReportDesignerFields = (0, _Izenda12.default)(_class = (_class2 = function () {
  function ReportDesignerFields(viewMode, isReload) {
    (0, _classCallCheck3.default)(this, ReportDesignerFields);

    _initDefineProp(this, 'dataTree', _descriptor, this);

    _initDefineProp(this, 'reportFilter', _descriptor2, this);

    _initDefineProp(this, 'reportBody', _descriptor3, this);

    _initDefineProp(this, 'reportHeader', _descriptor4, this);

    _initDefineProp(this, 'reportFooter', _descriptor5, this);

    _initDefineProp(this, 'reportTitleDescription', _descriptor6, this);

    _initDefineProp(this, 'selectedFormatItem', _descriptor7, this);

    _initDefineProp(this, 'selectedFormatGroup', _descriptor8, this);

    this.reportFilter = new _Izenda2.default(null, isReload);
    this.reportBody = new _Izenda6.default(null, viewMode);
    this.initDefaultLayout();
  }

  /**
   * init default layout
   */


  (0, _createClass3.default)(ReportDesignerFields, [{
    key: 'initDefaultLayout',
    value: function initDefaultLayout() {
      this.reportHeader.initDefaultLayout();
      this.reportFooter.initDefaultLayout();
      this.reportTitleDescription.initDefaultLayout();
      this.cleanDirty();
    }

    /**
     * read data from report
     * @param {any} report
     * @param {boolean} keepReportBodyStates
     */

  }, {
    key: 'readFromReport',
    value: function readFromReport(report, keepReportBodyStates) {
      var filter = report.reportFilter || {};
      var header = report.header || {};
      var footer = report.footer || {};
      var title = report.titleDescription || {};
      var reportPart = report.reportPart,
          snapToGrid = report.snapToGrid;

      // read report filters data

      this.reportFilter.populateData(filter);

      // read report body data
      this.reportBody.populateData(reportPart, snapToGrid, keepReportBodyStates);

      // read report header, footer and title
      this.reportHeader.populateData(header.items);
      this.reportFooter.populateData(footer.items);
      this.reportTitleDescription.populateData(title.items);

      this.dataTree.populateDataForCalculatedFields(report.calculatedFields);
    }

    /**
     * Build data for report saving
     */

  }, {
    key: 'buildDataForSaving',
    value: function buildDataForSaving(reportId) {
      var reportFilterData = this.reportFilter.buildDataForSaving();
      var reportBodyData = this.reportBody.buildDataForSaving();

      reportFilterData.reportId = reportId || null;

      return {
        reportFilter: reportFilterData,
        reportPart: reportBodyData.reportPart,
        snapToGrid: reportBodyData.snapToGrid
      };
    }

    /**
     * Get dirty status.
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty || this.dataTree.checkDirty && this.dataTree.checkDirty() || this.reportFilter.checkDirty && this.reportFilter.checkDirty() || this.reportBody.checkDirty && this.reportBody.checkDirty() || this.reportHeader.checkDirty && this.reportHeader.checkDirty() || this.reportFooter.checkDirty && this.reportFooter.checkDirty();
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();
      this.dataTree.cleanDirty && this.dataTree.cleanDirty();
      this.reportFilter.cleanDirty && this.reportFilter.cleanDirty();
      this.reportBody.cleanDirty && this.reportBody.cleanDirty();
      this.reportHeader.cleanDirty && this.reportHeader.cleanDirty();
      this.reportFooter.cleanDirty && this.reportFooter.cleanDirty();
    }

    /**
     * Set selected format group
     * @param {string} value
     */

  }, {
    key: 'updateFormatGroup',
    value: function updateFormatGroup(value) {
      if ((0, _fp.isNil)(value)) {
        return;
      }
      this.setSelectedFormatGroup(value);
      var firstItem = (0, _fp.head)(this.getFormatItems()) || {};
      this.setSelectedFormatItem(firstItem);

      this.markDirty();
    }

    /**
     * Get list format item
     * @return {array}
     */

  }, {
    key: 'getFormatItems',
    value: function getFormatItems() {
      var formatGroup = this[this.selectedFormatGroup] || {};
      var listItems = formatGroup.formatItems || [];

      return (0, _fp.sortBy)(function (item) {
        return item.name;
      }, listItems);
    }

    /**
     * Update selected format item
     * @param {object} item
     * @param {string} group
     */

  }, {
    key: 'updateFormatItem',
    value: function updateFormatItem(item, group) {
      this.setSelectedFormatGroup(group);
      this.setSelectedFormatItem(item);

      this.markDirty();
    }

    /**
     * Set selected format item
     */

  }, {
    key: 'setSelectedFormatItem',
    value: function setSelectedFormatItem(item) {
      this.selectedFormatItem.isSelected = false;
      item.isSelected = true;
      this.selectedFormatItem = item;
    }

    /**
     * Set selected format group
     */

  }, {
    key: 'setSelectedFormatGroup',
    value: function setSelectedFormatGroup(group) {
      this.selectedFormatGroup = group;
    }
  }]);
  return ReportDesignerFields;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'dataTree', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda4.default();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'reportFilter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'reportBody', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'reportHeader', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda8.default(FORMAT_GROUP_CONFIG.HEADER);
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'reportFooter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda8.default(FORMAT_GROUP_CONFIG.FOOTER);
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'reportTitleDescription', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda8.default(FORMAT_GROUP_CONFIG.TITLE_DESCRIPTION);
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'selectedFormatItem', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'selectedFormatGroup', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'initDefaultLayout', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'initDefaultLayout'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readFromReport', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readFromReport'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateFormatGroup', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateFormatGroup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateFormatItem', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateFormatItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setSelectedFormatItem', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setSelectedFormatItem'), _class2.prototype)), _class2)) || _class;

exports.default = ReportDesignerFields;
module.exports = exports['default'];

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBody.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(269);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(54);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(53);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(142);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(984);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(417);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(35);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(589);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var GridLayoutUtils = (0, _Izenda18.default)(Infinity, _Izenda7.REPORT_PART_MAX_WIDTH, _Izenda7.REPORT_PART_MAX_HEIGHT);

var ReportBody = (0, _Izenda4.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(ReportBody, [{
    key: 'activeReportParts',
    get: function get() {
      return (0, _fp.reject)('isDelete', this.reportParts);
    }
  }, {
    key: 'supportReportParts',
    get: function get() {
      return _Izenda10.default.filterSupportedReports(this.activeReportParts);
    }
  }, {
    key: 'hasInvisibleFields',
    get: function get() {
      return (0, _fp.some)('existInvisibleField', this.reportParts);
    }
  }, {
    key: 'hasAnyField',
    get: function get() {
      return (0, _fp.flow)((0, _fp.map)('fieldCollection'), (0, _fp.every)(_fp.isEmpty))(this.activeReportParts);
    }
  }, {
    key: 'aggregatedFields',
    get: function get() {
      var aggregatedFields = [];

      this.reportParts.forEach(function (reportPart) {
        aggregatedFields = (0, _fp.concat)(aggregatedFields, (0, _fp.compact)(reportPart.aggregatedFieldCollection));
      });

      return aggregatedFields;
    }
  }, {
    key: 'fields',
    get: function get() {
      var result = [];

      this.reportParts.forEach(function (reportPart) {
        result = (0, _fp.concat)(result, (0, _fp.compact)(reportPart.fieldCollection));
      });

      return result;
    }
  }, {
    key: 'enableCrossFiltering',
    get: function get() {
      var notDefaultParts = (0, _fp.filter)(function (part) {
        return !(0, _fp.isNil)(part.type);
      }, this.activeReportParts) || [];

      if (notDefaultParts.length < 1) return false;

      return (0, _fp.some)(function (part) {
        var doesSupportDrill = (0, _fp.some)(function (type) {
          return part.type === type;
        }, [_Izenda5.REPORT_PART_TYPE.Chart, _Izenda5.REPORT_PART_TYPE.Gauge, _Izenda5.REPORT_PART_TYPE.Map]);

        if (!doesSupportDrill) return false;

        return true;
      }, this.activeReportParts);
    }
  }, {
    key: 'enableDeleteAll',
    get: function get() {
      return !(0, _fp.flow)(_fp.head, (0, _fp.getOr)([], 'pillDefinitions'), _fp.isEmpty)(this.crossFilteringDetail);
    }
  }, {
    key: 'hadCrossFilteringSetting',
    get: function get() {
      return !(0, _fp.flow)((0, _fp.filter)(function (reportPart) {
        return reportPart.reportPartContent.isCrossFiltering;
      }), _fp.isEmpty)(this.activeReportParts);
    }
  }, {
    key: 'crossFilteringReportParts',
    get: function get() {
      return (0, _fp.flow)((0, _fp.getOr)([], 'activeReportParts'), (0, _fp.filter)(function (_ref) {
        var headerTitle = _ref.headerTitle,
            reportPartContent = _ref.reportPartContent;
        return !(0, _fp.isEmpty)(headerTitle) && reportPartContent.isCrossFiltering;
      }), (0, _fp.map)(function (reportPart) {
        return reportPart.id;
      }))(this);
    }
  }]);

  function ReportBody(data, viewMode) {
    (0, _classCallCheck3.default)(this, ReportBody);
    this.crossFilteringDrillFilterInfo = [];

    _initDefineProp(this, 'reportParts', _descriptor, this);

    _initDefineProp(this, 'selectedPart', _descriptor2, this);

    _initDefineProp(this, 'configReportPart', _descriptor3, this);

    _initDefineProp(this, 'viewMode', _descriptor4, this);

    _initDefineProp(this, 'isFullScreen', _descriptor5, this);

    _initDefineProp(this, 'snapToGrid', _descriptor6, this);

    _initDefineProp(this, 'crossFilteringDetail', _descriptor7, this);

    this.viewMode = viewMode;
    data && this.populateData(data);
    this.cleanDirty();
  }

  /**
   * Clean filters of cross filtering.
   */


  (0, _createClass3.default)(ReportBody, [{
    key: 'cleanDrillInfo',
    value: function cleanDrillInfo() {
      var _this = this;

      this.crossFilteringDrillFilterInfo = (0, _fp.remove)(function (item) {
        var index = (0, _fp.flow)((0, _fp.flatMap)(function (part) {
          return (0, _fp.getOr)([], 'reportPartContent.drilldown.filters', part);
        }), (0, _fp.findIndex)(function (filter) {
          return filter.key === item.key;
        }))(_this.activeReportParts);

        return index === -1;
      }, this.crossFilteringDrillFilterInfo);
    }

    /**
     * Update filters of drill data.
     * @param {Object} reportPart
     * @param {Object} drillDownData
     */

  }, {
    key: 'updateDrillInfo',
    value: function updateDrillInfo(reportPart, drillDownData) {
      var _this2 = this;

      if (!reportPart.reportPartContent.isCrossFiltering) return drillDownData;

      this.cleanDrillInfo();

      if ((0, _fp.isEmpty)(drillDownData)) {
        var drillInfo = reportPart.reportPartContent.getDrilldownInfo();
        Array.prototype.push.apply(drillInfo.filters, _Izenda16.default.transformFilterWithReportPart(reportPart, this.crossFilteringDrillFilterInfo));
        drillInfo.filters = (0, _fp.uniqBy)(function (item) {
          return (0, _stringify2.default)((0, _fp.pick)(['key', 'fieldId'], item));
        }, drillInfo.filters);
        return drillInfo;
      }

      var filters = (0, _fp.invoke)('getCrossFilteringInfo', reportPart.reportPartContent);

      (0, _fp.forEach)(function (item) {
        var index = (0, _fp.findIndex)(function (filter) {
          return filter.key === item.key;
        }, _this2.crossFilteringDrillFilterInfo);

        // Add
        if (index === -1) {
          _this2.crossFilteringDrillFilterInfo.push(item);
        } else {
          _this2.crossFilteringDrillFilterInfo[index].value = item.value;
        }
      }, filters);
    }

    /**
     * Update cross filtering detail.
     * @param {Object} reportPart
     * @param {Object} drillDownData
     */

  }, {
    key: 'updateCrossFiltering',
    value: function updateCrossFiltering(reportPart, drillDownData) {
      var firstCrossFilterDetail = (0, _fp.head)(this.crossFilteringDetail);
      if ((0, _fp.isEmpty)(firstCrossFilterDetail) || !reportPart.reportPartContent.isCrossFiltering) return this.updateDrillInfo(reportPart, drillDownData);

      var pillDefinitions = (0, _fp.get)('pillDefinitions', firstCrossFilterDetail);

      var index = (0, _fp.findIndex)(function (pill) {
        return pill.reportPart.id === reportPart.id;
      }, pillDefinitions);
      var drillInfo = reportPart.reportPartContent.getDrilldownInfo();
      var expandedLevel = (0, _fp.getOr)(0, 'expandedLevel', drillDownData) || drillInfo.expandedLevel;

      // REMOVE pill
      if (index !== -1 && expandedLevel === 0) {
        pillDefinitions.splice(index, 1);
      }

      // ADD pill
      if (index === -1 && expandedLevel !== 0 && expandedLevel !== -1) {
        pillDefinitions.push(new _Izenda14.default(reportPart.id, reportPart, (0, _fp.getOr)('', 'headerTitle', reportPart)));
      }

      // update drill info
      this.updateDrillInfo(reportPart, drillDownData);
    }

    /**
     * Remove a cross filtering item.
     * @param {Object} pill
     */

  }, {
    key: 'removePill',
    value: function removePill(pill) {
      var reportPart = pill.reportPart;
      var firstCrossFilterDetail = (0, _fp.head)(this.crossFilteringDetail);
      var pillDefinitions = (0, _fp.get)('pillDefinitions', firstCrossFilterDetail);
      var index = (0, _fp.findIndex)(function (pill) {
        return pill.reportPart.id === reportPart.id;
      }, pillDefinitions);

      index !== -1 && pillDefinitions.splice(index, 1);

      reportPart.reportPartContent.resetDrilldownInfo && reportPart.reportPartContent.resetDrilldownInfo();

      this.cleanDrillInfo();
    }

    /**
    * Remove cross filtering items belong to report part.
    * @param {Object} reportPart
    */

  }, {
    key: 'removePillByReportPart',
    value: function removePillByReportPart(reportPart) {
      var pillDefinitions = (0, _fp.flow)(_fp.head, (0, _fp.get)('pillDefinitions'))(this.crossFilteringDetail);

      var pillToDelete = (0, _fp.filter)({ 'id': reportPart.id }, pillDefinitions);

      (0, _fp.forEach)(function (pill) {
        var pillId = pill.id;
        var index = (0, _fp.findIndex)({ 'id': pillId }, pillDefinitions);
        index !== -1 && pillDefinitions.splice(index, 1);
      }, pillToDelete);

      reportPart.reportPartContent.resetDrilldownInfo && reportPart.reportPartContent.resetDrilldownInfo();
      this.cleanDrillInfo();
    }

    /**
     * Remove all cross filtering items
     */

  }, {
    key: 'removeAllPills',
    value: function removeAllPills() {
      var pillDefinitions = (0, _fp.flow)(_fp.head, (0, _fp.get)('pillDefinitions'))(this.crossFilteringDetail);

      pillDefinitions && pillDefinitions.clear();
      this.crossFilteringDrillFilterInfo = [];

      (0, _fp.forEach)(function (part) {
        part.reportPartContent.resetDrilldownInfo && part.reportPartContent.resetDrilldownInfo();
      }, this.activeReportParts);
    }

    // reset reportbody status include isFullScreen mode and config report part

  }, {
    key: 'resetReportBodyStatus',
    value: function resetReportBodyStatus() {
      this.setConfigReportPart(null);
      this.removeAllPills();
      this.isFullScreen = false;
    }

    // copy config report part status after save if it create new object

  }, {
    key: 'appliedStatusPreviousConfigReportPart',
    value: function appliedStatusPreviousConfigReportPart() {
      var previousConfigReportPart = this.configReportPart;

      var previousConfigReportPartName = (0, _fp.get)('headerTitle', previousConfigReportPart);
      var previousSide = (0, _fp.getOr)(false, 'isBackSide', previousConfigReportPart);
      var previousConfigField = (0, _fp.getOr)(null, 'configField', previousConfigReportPart);
      var previousConfigFieldName = (0, _fp.getOr)(null, 'name', previousConfigField);
      var newConfigReportPart = previousConfigReportPart && (0, _fp.find)({ headerTitle: previousConfigReportPartName }, this.supportReportParts.slice());

      if (!newConfigReportPart) {
        this.resetReportBodyStatus();
        return;
      }

      if (newConfigReportPart !== previousConfigReportPart) {
        this.setConfigReportPart(newConfigReportPart);
        this.changeReportPartSide(newConfigReportPart, previousSide);
      }

      var newConfigField = previousConfigField && (0, _fp.find)({ name: previousConfigFieldName }, newConfigReportPart.fieldCollection.slice());

      newConfigReportPart.setConfigField(newConfigField);
    }

    /**
     * Populate data of list report part
     * @param {Object} data
     * @param {Object} snapToGrid
     * @param {Boolean} keepReportBodyStates
     */

  }, {
    key: 'populateData',
    value: function populateData(data, snapToGrid, keepReportBodyStates) {
      snapToGrid = !!snapToGrid;
      var currentReportParts = this.reportParts;
      var currentPart = void 0;

      var newReportParts = data && !(0, _fp.isEmpty)(data) && data.map(function (item) {
        currentPart = (0, _fp.find)({
          headerTitle: item.title
        }, currentReportParts);
        currentPart && currentPart.readData(item);
        return currentPart || new _Izenda2.default(item);
      });

      this.reportParts.replace(newReportParts || []);
      this.snapToGrid = snapToGrid;

      if (keepReportBodyStates) {
        this.appliedStatusPreviousConfigReportPart();
      } else {
        this.resetReportBodyStatus();
      }

      if (!this.activeReportParts.length) {
        !this.viewMode && this.addReportPart();
      }

      if ((0, _fp.isEmpty)(this.crossFilteringDetail)) {
        this.crossFilteringDetail.push(new _Izenda12.default(null, null, []));
      }
    }

    /**
     * Get dirty status.
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      // Check dirty for reportParts.
      var dirtyItems = (0, _fp.filter)(function (item) {
        return item.checkDirty && item.checkDirty();
      }, this.reportParts);

      return this.isDirty || dirtyItems && dirtyItems.length > 0;
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      // clean dirty for reportParts
      (0, _fp.forEach)(function (item) {
        item.cleanDirty && item.cleanDirty();
      }, this.reportParts);

      this.resetDirty();
    }

    /**
     * Add new report part
     * @param {Integer} left
     * @param {Integer} top
     * @param {Integer} width
     * @param {Integer} height
     */

  }, {
    key: 'addReportPart',
    value: function addReportPart(left, top, width, height) {
      var length = this.reportParts.length;
      var dims = GridLayoutUtils.getDimension(this.activeReportParts, left, top);
      var partX = left || dims.positionX;
      var partY = top || dims.positionY;

      // Ensure report part width/height under its max values
      var useMaxWidth = (0, _fp.isNil)(width) || width === Infinity || width > _Izenda8.default.REPORT_PART_MAX_WIDTH;
      var useMaxHeight = (0, _fp.isNil)(height) || height === Infinity || height > _Izenda8.default.REPORT_PART_MAX_HEIGHT;
      var partWidth = useMaxWidth ? _Izenda8.default.REPORT_PART_MAX_WIDTH : width;
      var partHeight = useMaxHeight ? _Izenda8.default.REPORT_PART_MAX_HEIGHT : height;

      if (this.configReportPart && this.configReportPart.isBackSide) {
        // If user is seeing a backside report part, change it back to front-side.
        this.changeReportPartSide(this.configReportPart, false);
      }

      var part = {
        id: (0, _fp.uniqueId)('reportPart_'),
        positionX: partX,
        positionY: partY,
        width: partWidth,
        height: partHeight,
        isAddNew: true
      };

      var partDetail = new _Izenda2.default(part);

      this.reportParts.splice(length, 0, partDetail);

      // set new added-report part as config report part
      this.setConfigReportPart(partDetail);
      this.markDirty();
    }

    /**
     * Delete a report part
     * @param {Object} reportPart
     */

  }, {
    key: 'deleteReportPart',
    value: function deleteReportPart(reportPart) {
      this.isFullScreen = false;

      reportPart.isNew && this.reportParts.remove(reportPart);
      reportPart.delete();

      // reset config report part
      if (this.configReportPart === reportPart) {
        this.setConfigReportPart(null);
      }

      this.removePill({ reportPart: reportPart });
      this.markDirty();
    }

    /**
     * Copy report part
     * @param {Object} reportPart
     */

  }, {
    key: 'copyReportPart',
    value: function copyReportPart(reportPart) {
      var newName = String.generateNewName(reportPart.headerTitle, this.activeReportParts, (0, _fp.get)('headerTitle'), '()');
      var dims = GridLayoutUtils.getDefaultDimension(this.activeReportParts);
      var partX = dims.positionX;
      var partY = dims.positionY;

      var newReportPart = (0, _mobx.toJS)(reportPart.buildDataForSave());

      newReportPart = (0, _fp.assign)(newReportPart, {
        id: (0, _fp.uniqueId)('reportPart_'),
        title: newName,
        isBackSide: false,
        positionX: partX,
        positionY: partY,
        width: newReportPart.width, // constants.REPORT_PART_MAX_WIDTH ,
        height: newReportPart.height, // constants.REPORT_PART_MAX_HEIGHT,
        state: _Izenda5.OBJECT_STATE.INSERT
      });

      newReportPart = new _Izenda2.default(newReportPart, true);
      this.reportParts.splice(this.reportParts.length, 0, newReportPart);
      // set new added-report part as config report part
      this.setConfigReportPart(newReportPart);
      this.markDirty();

      return newReportPart;
    }

    /**
     * validate new name unique in report Body
     * @param  {ReportPartDetails} reportPart reportPart need update name
     * @param  {String} name       mew name for report part
     */

  }, {
    key: 'validateNewNameReportPart',
    value: function validateNewNameReportPart(reportPart, name) {
      var commonFormat = (0, _fp.flow)(_fp.trim, _fp.toUpper);

      return (0, _bluebird.resolve)(!(0, _fp.isEmpty)(name) && (0, _fp.flow)((0, _fp.reject)({
        id: reportPart.id
      }), (0, _fp.some)((0, _fp.flow)((0, _fp.get)('headerTitle'), commonFormat, (0, _fp.isEqual)(commonFormat(name)))))(this.activeReportParts) ? _Izenda8.default.MESSAGES.M02 : '');
    }

    /**
     * rename report part
     * @param  {ReportPartDetails} reportPart report part need update name
     * @param  {String} name       new report part name
     * @return {Boolean}           update success or not
     */

  }, {
    key: 'renameReportPart',
    value: function renameReportPart(reportPart, name, defaultName) {
      if ((0, _fp.isEmpty)(name)) {
        this.setDefaultName(reportPart, defaultName);
      } else {
        reportPart.setReportPartName(name);
      }
    }

    /**
     * set config report part
     * @param  {reportPartDetail} reportPart [description]
     */

  }, {
    key: 'setConfigReportPart',
    value: function setConfigReportPart(reportPart) {
      // Set config mode action for report part form
      if (reportPart && reportPart.reportPartContent) {
        (0, _fp.invoke)('configModeAction', reportPart.reportPartContent);
      }

      if (reportPart && (0, _fp.get)('id', this.configReportPart) === (0, _fp.get)('id', reportPart)) {
        return;
      }

      var isShowBackSide = (0, _fp.get)('isBackSide', this.configReportPart);

      // switch current repot part to front-side
      if (isShowBackSide) {
        this.changeReportPartSide(this.configReportPart, false);
      }

      if (!reportPart) {
        this.configReportPart = null;

        // config report part = null >> do not apply full screen
        this.resetFullScreenMode();
      } else {
        // current part is in configuration mode (back-side=true)
        // set the current to preview mode, new-config-part to preview mode as well.
        if (isShowBackSide) {
          this.changeReportPartSide(reportPart, false);
        }

        this.configReportPart = reportPart;
      }
    }

    /**
     * Change full screen mode
     * @param  {[type]} reportPart [description]
     * @return {[type]}            [description]
     */

  }, {
    key: 'changeFullScreenMode',
    value: function changeFullScreenMode(reportPart) {
      this.setConfigReportPart(reportPart);
      this.isFullScreen = !this.isFullScreen;
    }

    /**
     * Reset full screen mode
     */

  }, {
    key: 'resetFullScreenMode',
    value: function resetFullScreenMode() {
      this.isFullScreen = false;
    }

    /**
     * Change report part side (from back-side to front-side)
     * @param  {ReportPartDetails}  reportPart
     * @param  {Boolean} isBackSide
     * @return {undefined}
     */

  }, {
    key: 'changeReportPartSide',
    value: function changeReportPartSide(reportPart, isBackSide) {
      if (!reportPart) {
        return;
      }
      var newState = (0, _fp.isNil)(isBackSide) ? !reportPart.isBackSide : isBackSide;

      reportPart.isBackSide = newState;

      (0, _fp.invokeArgs)('reportPartContent.afterChangeSide', [newState], reportPart);

      // report part in configuration mode (backside=true), set it as config report part
      this.setConfigReportPart(reportPart);
    }

    /**
     * Set view report part
     * @param {ReportPartDetails} reportPart
     * @param {Object} type
     */

  }, {
    key: 'setViewReportPart',
    value: function setViewReportPart(reportPart, type) {
      // TODO: should manual get lable/icon from registry if not exists.
      reportPart.setReportPartType(type.value);
      reportPart.isBackSide = true;
      this.setConfigReportPart(reportPart);
      this.setDefaultName(reportPart, type.label);
    }

    /**
     * set default report part name
     * @param {ReportPartDetails} reportPart
     * @param {String} defaultName
     */

  }, {
    key: 'setDefaultName',
    value: function setDefaultName(reportPart, defaultName) {
      var newName = String.generateNewName(defaultName, (0, _fp.reject)({
        id: reportPart.id
      }, this.activeReportParts), (0, _fp.get)('headerTitle'));

      reportPart.setReportPartName(newName);
    }

    /**
     * Build data for report saving
     */

  }, {
    key: 'buildDataForSaving',
    value: function buildDataForSaving() {
      var data = (0, _fp.flow)((0, _fp.filter)(function (item) {
        return !(0, _fp.isNil)(item.type);
      }), (0, _fp.map)(function (item) {
        return item.buildDataForSave && item.buildDataForSave() || item;
      }))(this.reportParts);

      return {
        reportPart: data,
        snapToGrid: !!this.snapToGrid
      };
    }

    /**
     * Remove unuse dynamic threshold
     */

  }, {
    key: 'removeUnuseDynamicThresholds',
    value: function removeUnuseDynamicThresholds() {
      (0, _fp.flow)((0, _fp.filter)({ type: _Izenda5.REPORT_PART_TYPE.Chart }), (0, _fp.forEach)(function (item) {
        return item.reportPartContent.removeUnuseDynamicThresholds && item.reportPartContent.removeUnuseDynamicThresholds();
      }))(this.reportParts);
    }

    /**
     * Mark all field visible
     */

  }, {
    key: 'markVisibleAllField',
    value: function markVisibleAllField() {
      this.reportParts.forEach(function (reportPart) {
        reportPart.setAllFieldVisible();
      });
      this.markDirty();

      return (0, _bluebird.resolve)();
    }

    /**
     * Mark all field visible
     * @param {String} id
     * @param {String} name
     * @param {Object} updaptedCalField
     */

  }, {
    key: 'updateElementInfo',
    value: function updateElementInfo(id, name, updaptedCalField) {
      var changed = false;
      var originalField = (0, _fp.find)(function (fieldDetail) {
        return fieldDetail.field.fieldId === id;
      }, this.fields);

      if ((0, _fp.isNil)(originalField)) return;

      // update report parts
      this.reportParts.forEach(function (reportPart) {
        var currentChanged = reportPart.updateField(id, (0, _fp.cloneDeep)(originalField.field.fieldName), name, updaptedCalField);

        changed = changed || currentChanged;
      });
      changed && this.markDirty();
      return changed;
    }

    /**
     * Check report body has use calculated field
     * @param {String} id
     * @param {String} name
     */

  }, {
    key: 'hasCalculatedField',
    value: function hasCalculatedField(id, name) {
      return (0, _fp.some)(function (reportPart) {
        return reportPart.hasCalculatedField(id, name);
      }, this.reportParts);
    }

    /**
     * Clean all cross filtering
     */

  }, {
    key: 'cleanCrossFiltering',
    value: function cleanCrossFiltering() {
      (0, _fp.invokeMap)('setCrossFiltering', this.reportParts, false);
    }
  }]);
  return ReportBody;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'reportParts', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'selectedPart', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'configReportPart', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'viewMode', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'isFullScreen', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'snapToGrid', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'crossFilteringDetail', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'activeReportParts', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'activeReportParts'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'supportReportParts', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'supportReportParts'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasInvisibleFields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasInvisibleFields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasAnyField', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasAnyField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'aggregatedFields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'aggregatedFields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fields', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'fields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'enableCrossFiltering', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'enableCrossFiltering'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'enableDeleteAll', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'enableDeleteAll'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hadCrossFilteringSetting', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hadCrossFilteringSetting'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'crossFilteringReportParts', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'crossFilteringReportParts'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDrillInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDrillInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDrillInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDrillInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateCrossFiltering', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateCrossFiltering'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removePill', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removePill'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removePillByReportPart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removePillByReportPart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeAllPills', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeAllPills'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetReportBodyStatus', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetReportBodyStatus'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'appliedStatusPreviousConfigReportPart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'appliedStatusPreviousConfigReportPart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addReportPart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addReportPart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteReportPart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteReportPart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'copyReportPart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'copyReportPart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setConfigReportPart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setConfigReportPart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeFullScreenMode', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changeFullScreenMode'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeReportPartSide', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changeReportPartSide'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setViewReportPart', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setViewReportPart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeUnuseDynamicThresholds', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeUnuseDynamicThresholds'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'markVisibleAllField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'markVisibleAllField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateElementInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateElementInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cleanCrossFiltering', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cleanCrossFiltering'), _class2.prototype)), _class2)) || _class;

exports.default = ReportBody;
module.exports = exports['default'];

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFormatElement.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  __webpack_require__(55);

  var m = __webpack_require__(5);
  __webpack_require__(55);
  var trackable = __webpack_require__(46);
  var ReportFormatDetails = __webpack_require__(1994);
  var CONSTANTS = __webpack_require__(106);
  var DEFAULT_WIDTH_HEIGHT = 1;
  var GridLayoutUtils = __webpack_require__(589)(CONSTANTS.NUMBER_HEADER_COLS, DEFAULT_WIDTH_HEIGHT, DEFAULT_WIDTH_HEIGHT);
  var ITEMS_TYPE = CONSTANTS.ITEMS_TYPE;

  var _require = __webpack_require__(1),
      map = _require.map,
      forEach = _require.forEach,
      uniqueId = _require.uniqueId,
      get = _require.get,
      filter = _require.filter,
      every = _require.every;

  function ReportFormatElement(name, data) {
    var props = {
      name: name,
      formatItems: [],
      hasSelectedItem: function hasSelectedItem() {
        return !every(['isSelected', false], this.formatItems);
      }
    };

    m.extendObservable(trackable(this), props);

    this.populateData(data);

    this.cleanDirty();
  }

  /**
   * Populate format element from report format element data.
   * @param {Array} An array of report format element
   */
  ReportFormatElement.prototype.populateData = m.action(function (data) {
    data && this.formatItems.replace(map(function (item) {
      return new ReportFormatDetails(item);
    }, data));
  });

  /**
   * Get format items
   * @returns {Array}
   */
  ReportFormatElement.prototype.getItems = function () {
    return this.formatItems;
  };

  /**
   * Init default layout for report header
   * This is used when initialize report
   * @param {object} data
   */
  ReportFormatElement.prototype.initDefaultLayout = m.action(function () {
    var data = CONSTANTS[this.name];
    var defaultItems = (0, _keys2.default)(data).map(function (key) {
      return new ReportFormatDetails(data[key]);
    });
    this.formatItems.replace(defaultItems);
  });

  /**
   * Add new format item
   * @param {string} type
   * @param {string} width
   * @param {string} height
   */
  ReportFormatElement.prototype.addItem = m.action(function (type, width, height) {
    var item = ITEMS_TYPE[type];
    var length = this.formatItems.length;
    var dims = GridLayoutUtils.getAvaiablePosition(this.formatItems, width, height);
    var listItemsByType = filter({ type: type }, this.formatItems);
    var itemName = String.generateNewName(item.defaultName, listItemsByType, get('name'));

    width = item.width || width;
    height = item.height || height;

    var part = {
      id: uniqueId('reportFormatItems_'),
      type: type,
      label: item.label,
      positionX: dims.positionX,
      positionY: dims.positionY,
      width: dims.width,
      height: dims.height,
      name: itemName,
      value: item.defaultValue,
      minHeight: item.minHeight
    };

    var formatItemDetail = new ReportFormatDetails(part);
    this.formatItems.splice(length, 0, formatItemDetail);

    this.markDirty();
  });

  /**
   * Get dirty status
   * @returns {boolean}
   */
  ReportFormatElement.prototype.checkDirty = function () {
    var formatItems = this.formatItems;
    if (!this.isDirty) {
      for (var i = 0; i < formatItems.length; i++) {
        if (formatItems[i].isDirty) {
          return true;
        }
      }
    }
    return this.isDirty;
  };

  /**
   * Clean Dirty
   */
  ReportFormatElement.prototype.cleanDirty = m.action(function () {
    var formatItems = this.formatItems;
    forEach(m.action(function (item) {
      item.resetDirty();
    }), formatItems);

    return this.resetDirty();
  });

  /**
   * Reset selected item
   */
  ReportFormatElement.prototype.checkExistingFormatItemName = function (newName, exceptItem) {
    var names = map(get('name'), this.formatItems);

    var index = names.indexOf(newName);

    if (index >= 0) {
      names.splice(index, 1);
      return String.checkDuplicate(newName, names);
    }

    return false;
  };

  module.exports = ReportFormatElement;
}();

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFormatDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);

  var trackable = __webpack_require__(46);
  var UIConstants = __webpack_require__(34);
  var setValue = __webpack_require__(223);
  var constants = __webpack_require__(106);

  var _require = __webpack_require__(1),
      uniqueId = _require.uniqueId,
      lowerCase = _require.lowerCase;

  function ReportFormatDetails(data) {
    var props = {
      type: 'text',
      label: 'Text',
      id: uniqueId('formatDetails_'),
      positionX: 0,
      positionY: 0,
      width: 1,
      height: 1,
      /* itemProps*/
      name: '',
      sortName: function sortName() {
        return lowerCase(this.name);
      },
      value: '',
      format: null,
      font: {
        family: UIConstants.fontFamily.roboto,
        size: UIConstants.defaultFontSize,
        bold: false,
        italic: false,
        underline: false,
        color: UIConstants.textColor,
        backgroundColor: UIConstants.textBackgrounColor
      },
      alignment: null,
      color: UIConstants.borderColor,
      imageUrl: '',
      dashStyle: UIConstants.defaultDashStyles,
      thickness: UIConstants.borderWidth,
      isSelected: false,
      minHeight: constants.DEFAULT_ITEM_MIN_HEIGHT
    };

    m.extendObservable(trackable(this), props);

    data && this.populateData(data);

    this.resetDirty();
  }

  /**
   * Populate data for this report format details.
   * @param {object} data
   */
  ReportFormatDetails.prototype.populateData = m.action(function (data) {
    data = data || {};

    this.type = data.type;
    this.label = data.label;
    this.positionX = data.positionX;
    this.positionY = data.positionY;
    this.width = data.width;
    this.height = data.height;
    /* itemProps*/
    this.name = data.name;
    this.value = data.value;
    this.format = data.format;
    this.font = data.font || {
      family: UIConstants.fontFamily.roboto,
      size: UIConstants.defaultFontSize,
      bold: false,
      italic: false,
      underline: false,
      color: UIConstants.textColor,
      backgroundColor: UIConstants.textBackgrounColor
    };
    this.alignment = data.alignment;
    this.color = data.color || UIConstants.borderColor;
    this.imageUrl = data.imageUrl;
    this.dashStyle = data.dashStyle || UIConstants.defaultDashStyles;
    this.thickness = data.thickness || UIConstants.borderWidth;
    this.minHeight = data.minHeight;
  });

  /**
   * Set position this report format details.
   * @param {object} position
   */
  ReportFormatDetails.prototype.setPosition = m.action(function (position) {
    this.positionX = position.positionX;
    this.positionY = position.positionY;
    this.width = position.width;
    this.height = position.height;
    this.markDirty();
  });

  /**
   * Get value by key
   * @param  {string} key
   */
  ReportFormatDetails.prototype.getValueByKey = function (key) {
    return this[key];
  };

  /**
   * Set format items details
   * @param {object} data
   */
  ReportFormatDetails.prototype.setItemsDetails = m.action(function (data) {
    data = data || {};
    var font = this.font;

    data.name && setValue(this, 'name', data.name);
    data.value && setValue(this, 'value', data.value);
    data.imageUrl && setValue(this, 'imageUrl', data.imageUrl);
    setValue(this, 'format', data.format);
    setValue(this, 'alignment', data.alignment);
    setValue(this, 'color', data.color);
    setValue(this, 'dashStyle', data.dashStyle);
    setValue(this, 'thickness', data.thickness);
    setValue(font, 'family', data.family);
    setValue(font, 'size', data.size);
    setValue(font, 'bold', data.bold);
    setValue(font, 'italic', data.italic);
    setValue(font, 'underline', data.underline);
    setValue(font, 'color', data.textColor);
    setValue(font, 'backgroundColor', data.textBackgrounColor);

    this.markDirty();
  });

  /**
   * Set format items value
   * @param {string} key
   * @param {string} key
   */
  ReportFormatDetails.prototype.updateValueByKey = function (key, value) {
    this[key] = value;
    this.markDirty();
  };

  module.exports = ReportFormatDetails;
}();

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerFormats.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var REPORT_FORMAT = __webpack_require__(106);
  var trackable = __webpack_require__(46);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var Format = function Format(data) {
    var props = {
      name: data.name || '',
      items: data.items || [],
      visible: data.visible || false
    };

    m.extendObservable(trackable(this), props);
  };

  Format.prototype.setVisible = m.action(function (visible, markDirty) {
    var shouldDirty = isNil(markDirty) || markDirty;
    this.visible = visible;
    shouldDirty && this.markDirty();
  });

  function ReportDesignerFormats() {
    var props = {
      name: REPORT_FORMAT.TITLE,
      headerFooter: new Format(REPORT_FORMAT.HEADER_FOOTER),
      titleDescription: new Format(REPORT_FORMAT.TITLE_DESCRIPTION)
    };
    m.extendObservable(trackable(this), props);
  }

  ReportDesignerFormats.prototype.readFromReport = m.action(function (report) {
    ensure(report, 'Report cannot be null or undefined');

    var header = report.header || {};
    var title = report.titleDescription || {};
    this.headerFooter.setVisible(header.visible, false);
    this.titleDescription.setVisible(title.visible, false);
  });

  /**
   * Set visible for Header Footer
   * @param {boolean} value
   */
  ReportDesignerFormats.prototype.setHeaderFooterVisible = function (value) {
    this.headerFooter.setVisible(value);
  };

  /**
   * Get Header Footer visible
   */
  ReportDesignerFormats.prototype.getHeaderFooterVisible = function () {
    return this.headerFooter.visible;
  };

  /**
   * Set visible for Title Description
   * @param {boolean} value
   */
  ReportDesignerFormats.prototype.setTitleDescriptionVisible = function (value) {
    this.titleDescription.setVisible(value);
  };

  /**
   * Get Title Description visible
   */
  ReportDesignerFormats.prototype.getTitleDescriptionVisible = function () {
    return this.titleDescription.visible;
  };

  /**
   * Get Dirty Status
   * @returns {boolean}
   */
  ReportDesignerFormats.prototype.checkDirty = function () {
    return this.headerFooter.isDirty || this.titleDescription.isDirty;
  };

  /**
  * Clean Dirty Status
  */
  ReportDesignerFormats.prototype.cleanDirty = function () {
    this.headerFooter.resetDirty();
    this.titleDescription.resetDirty();
  };

  module.exports = ReportDesignerFormats;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleLookUp.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1997);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorSelect = (0, _Izenda6.default)()(_Izenda8.default);

var RoleLookUp = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RoleLookUp, _Component);

  function RoleLookUp() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RoleLookUp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RoleLookUp.__proto__ || (0, _getPrototypeOf2.default)(RoleLookUp)).call.apply(_ref, [this].concat(args))), _this), _this.openRolePopup = function () {
      var props = _this.props;

      props.openPopup(_Izenda4.default, {
        onChange: props.onChangeFromPopup,
        loadRoles: props.loadRoles,
        roleOption: props.roleOption
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RoleLookUp, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var localization = props.localization;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-Recipient-Container' },
        _react2.default.createElement(ValidatorSelect, {
          textboxMode: true,
          multi: true,
          hiddenMenu: true,
          searchable: false,
          clearable: false,
          disabled: props.disabled || props.readOnly,
          options: props.data,
          valueKey: props.valueField,
          labelKey: props.textField,
          value: props.value,
          field: props.field,
          group: props.group,
          onChange: props.onChange,
          validations: props.validations
        }),
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', {
            onClick: !props.readOnly && this.openRolePopup,
            className: 'icon-plus',
            title: localization.getText('USER_LABEL_SELECT_USER')
          })
        )
      );
    }
  }]);
  return RoleLookUp;
}(_react.Component)) || _class);
exports.default = RoleLookUp;
module.exports = exports['default'];

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps, _dec2, _class3, _class4, _temp2, _initialiseProps2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AddRolePopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AddUserPopup Component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(68);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(44);

var _Izenda8 = __webpack_require__(97);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(13);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(17);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(107);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(1998);

var _Izenda17 = _interopRequireDefault(_Izenda16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CANCEL_TEXT = 'cancel';
var ACCEPT_TEXT = 'accept';

var AddRoleGrid = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AddRoleGrid, _Component);

  function AddRoleGrid(props) {
    (0, _classCallCheck3.default)(this, AddRoleGrid);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddRoleGrid.__proto__ || (0, _getPrototypeOf2.default)(AddRoleGrid)).call(this, props));

    _initialiseProps.call(_this);

    var store = props.store;


    _this.search = store.search.bind(store);
    _this.goToPage = store.goToPage.bind(store);
    _this.onSortChange = store.onSortChange.bind(store);
    _this.setSearchValue = store.setSearchValue.bind(store);
    _this.onPageSizeChange = store.onPageSizeChange.bind(store);
    return _this;
  }

  (0, _createClass3.default)(AddRoleGrid, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.store.loadAllRoles();
    }

    /**
     * Render select cell
     */


    /**
     * Render table component
     */


    /**
     * Handle key press
     * @param  {Event} event
     */

  }, {
    key: 'render',
    value: function render() {
      var _props$store = this.props.store,
          pageInfo = _props$store.pageInfo,
          searchText = _props$store.searchText;


      return _react2.default.createElement(
        _Izenda11.default,
        null,
        _react2.default.createElement(
          _Izenda11.default.Row,
          null,
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: '5' },
            _react2.default.createElement(_Izenda15.default, {
              clickable: true,
              value: searchText,
              onClick: this.search,
              className: 'u-posRelative',
              onChange: this.setSearchValue,
              onKeyPress: this.handleKeyPress
            })
          )
        ),
        _react2.default.createElement(
          _Izenda11.default.Row,
          null,
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: '12' },
            this.renderTable()
          )
        ),
        _react2.default.createElement(
          _Izenda11.default.Row,
          null,
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: '12' },
            _react2.default.createElement(_Izenda9.default, {
              onChange: this.goToPage,
              onDropdownChange: this.onPageSizeChange,
              totalRecords: pageInfo.totalRecords,
              pageSize: pageInfo.pageSize,
              pageIndex: pageInfo.pageIndex,
              isDirty: this.checkDirty
            })
          )
        )
      );
    }
  }]);
  return AddRoleGrid;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.renderSelectCell = function (data) {
    var onChange = function onChange(event) {
      return data.selected = event.target.checked;
    };
    return _react2.default.createElement(_Izenda13.default, { type: 'checkbox', checked: data.selected, onChange: onChange });
  };

  this.renderRoleCell = function (data) {
    return _react2.default.createElement(_Izenda6.default, { tooltip: data.name, text: data.name });
  };

  this.renderTable = function () {
    var _props = _this2.props,
        store = _props.store,
        localization = _props.localization;


    var selectRowDefinition = {
      key: 'selected',
      width: 30,
      title: '',
      sortable: false,
      columnKey: 'selected',
      fixed: true,
      headerComponent: _Izenda13.default,
      headerComponentProps: (0, _extends3.default)({}, store.allCheckboxStatus, {
        onChange: store.toggleAllRoles.bind(store),
        type: 'checkbox'
      })
    };

    var roleDefinition = {
      key: 'name',
      width: 320,
      title: localization.getText('ROLE_SETUP_LABEL_ROLES'),
      sortable: true,
      columnKey: 'name'
    };

    return _react2.default.createElement(
      _Izenda7.Table,
      {
        dataSource: store.roles,
        onSortChange: _this2.onSortChange,
        draggableTable: false,
        sortInfo: store.pageInfo.colSortDirs
      },
      _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, selectRowDefinition, { cell: _this2.renderSelectCell })),
      _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, roleDefinition, { cell: _this2.renderRoleCell }))
    );
  };

  this.handleKeyPress = function (event) {
    if (event.key === 'Enter') {
      _this2.search();
    }
  };
}, _temp)) || _class);
var AddRolePopup = (_dec2 = (0, _Izenda2.default)(), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(AddRolePopup, _Component2);

  function AddRolePopup(props) {
    (0, _classCallCheck3.default)(this, AddRolePopup);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (AddRolePopup.__proto__ || (0, _getPrototypeOf2.default)(AddRolePopup)).call(this, props));

    _initialiseProps2.call(_this3);

    _this3.roleListStore = new _Izenda17.default(props.loadRoles, props.roleOption);
    return _this3;
  }

  /**
   * Handle when popup closing
   * @param  {Object} closeCallback function
   * @param  {Object} type of close button click
   */


  (0, _createClass3.default)(AddRolePopup, [{
    key: 'render',
    value: function render() {
      var localization = this.props.localization;


      return _react2.default.createElement(
        _Izenda4.default,
        { visible: true, onClosing: this.onClosing, autoClose: false, type: 'none' },
        _react2.default.createElement(_Izenda4.default.Header, { title: localization.getText('ROLE_SETUP_ALL_ROLES') }),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          _react2.default.createElement(AddRoleGrid, (0, _extends3.default)({}, this.props, { store: this.roleListStore }))
        ),
        _react2.default.createElement(
          _Izenda4.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return AddRolePopup;
}(_react.Component), _class4.propTypes = {
  store: _propTypes2.default.object,
  onChange: _propTypes2.default.func.isRequired
}, _initialiseProps2 = function _initialiseProps2() {
  var _this4 = this;

  this.onClosing = function (closeCallback, type) {
    var props = _this4.props;
    if (type === ACCEPT_TEXT) {
      props.onChange(_this4.roleListStore.selectedRoles);
      props.onAccept();
    } else if (type === CANCEL_TEXT) {
      props.onReject();
    }
  };
}, _temp2)) || _class3);
exports.default = AddRolePopup;
module.exports = exports['default'];

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleListStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(98);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(124);

var _Izenda4 = __webpack_require__(15);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(274);

var _Izenda7 = _interopRequireDefault(_Izenda6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RoleListStore = (_class = function () {
  (0, _createClass3.default)(RoleListStore, [{
    key: 'tenantId',
    get: function get() {
      return _Izenda5.default.getTenantId();
    }
  }, {
    key: 'selectedRoles',
    get: function get() {
      return (0, _fp.filter)(function (role) {
        return role.selected;
      }, this.roles);
    }
  }, {
    key: 'allCheckboxStatus',
    get: function get() {
      if (!this.roles.length) {
        return { checked: false };
      }
      if ((0, _fp.every)('selected', this.roles)) {
        return { checked: true };
      }
      if ((0, _fp.some)('selected', this.roles)) {
        return { indeterminate: true };
      }
      return { checked: false };
    }
  }]);

  function RoleListStore(loadRoles) {
    var roleOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, RoleListStore);

    _initDefineProp(this, 'roles', _descriptor, this);

    _initDefineProp(this, 'searchText', _descriptor2, this);

    _initDefineProp(this, 'pageInfo', _descriptor3, this);

    this.loadRoles = loadRoles;
    this.roleOption = roleOption;
  }

  /**
   * Load all user accounts
   */


  (0, _createClass3.default)(RoleListStore, [{
    key: 'loadAllRoles',
    value: function loadAllRoles() {
      var _this = this;

      this.pageInfo.buildPagingRequest();
      var pageInfo = this.pageInfo;
      var requestData = (0, _extends3.default)({}, this.roleOption, {
        criteria: pageInfo.searchCriteria || [],
        pageIndex: pageInfo.pageIndex || 1,
        pageSize: pageInfo.pageSize || 10,
        sortOrders: pageInfo.sortOrders || [{
          key: 'name',
          descending: true
        }]
      });

      var fnFetch = (0, _fp.isNil)(this.loadRoles) ? _Izenda7.default.loadAllowedSharingRolesPaging(requestData) : this.loadRoles(pageInfo);

      return fnFetch.then(function (data) {
        _this.roles = data.result;
        _this.pageInfo.totalRecords = data.total;
        return (0, _bluebird.resolve)(true);
      });
    }

    /**
     * Set search value
     * @param {string} value
     */

  }, {
    key: 'setSearchValue',
    value: function setSearchValue(event) {
      this.searchText = event.target.value;
    }

    /**
     * Toggle All Roles
     */

  }, {
    key: 'toggleAllRoles',
    value: function toggleAllRoles(event) {
      (0, _fp.forEach)(function (item) {
        item.selected = event.target.checked;
      }, this.roles);
    }

    /**
     * Handle when page size change
     */

  }, {
    key: 'onPageSizeChange',
    value: function onPageSizeChange(pageSize) {
      this.pageInfo.setPageSize(pageSize);
      return this.goToPage(1);
    }

    /**
     * Handle go to page
     * @param  {int} pageIndex
     */

  }, {
    key: 'goToPage',
    value: function goToPage(pageIndex) {
      this.pageInfo.setPageIndex(pageIndex);
      return this.loadAllRoles();
    }

    /**
     * Search subscription
     * @param  {string} searchProperty
     * @param  {string} searchText
     */

  }, {
    key: 'search',
    value: function search() {
      this.pageInfo.setSearchValues('name', this.searchText);
      return this.goToPage(1);
    }

    /**
     * Change sort orders
     * @param {string} columnKey
     * @param {object} sortDir
     */

  }, {
    key: 'onSortChange',
    value: function onSortChange(columnKey, sortDir) {
      this.pageInfo.setColSortDirs(columnKey, sortDir);
      return this.loadAllRoles();
    }
  }]);
  return RoleListStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'roles', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'searchText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'pageInfo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda2.default({ name: 'DESC' });
  }
}), _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tenantId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectedRoles', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectedRoles'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'allCheckboxStatus', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'allCheckboxStatus'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadAllRoles', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadAllRoles'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSearchValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setSearchValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleAllRoles', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleAllRoles'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onPageSizeChange', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onPageSizeChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'goToPage', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'goToPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'search', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'search'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSortChange', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSortChange'), _class.prototype)), _class);
exports.default = RoleListStore;
module.exports = exports['default'];

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(590);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.UserLookUpAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var UserLookUpAction = (0, _recompose.withHandlers)({
  openPopupAddUserPopup: (0, _fp.curry)(openPopupAddUserPopup)
});

/**
 * Open Popup AddUser Popup.
 * @param {Object} props
 */
function openPopupAddUserPopup(props, e) {
  props.openPopup(_Izenda2.default, {
    onChange: props.onChangeFromPopup,
    singleUser: props.singleUser,
    selectedItems: props.value,
    loadUsers: props.loadUsers,
    userModeType: props.userModeType
  });
}

exports.default = UserLookUpAction;
module.exports = exports['default'];

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AddUserGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AddUserGrid component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(124);

var _Izenda4 = __webpack_require__(68);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(146);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(44);

var _Izenda9 = __webpack_require__(97);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(13);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(17);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(61);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddUserGrid = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AddUserGrid, _Component);

  function AddUserGrid(props) {
    (0, _classCallCheck3.default)(this, AddUserGrid);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddUserGrid.__proto__ || (0, _getPrototypeOf2.default)(AddUserGrid)).call(this, props));

    _initialiseProps.call(_this);

    var store = props.store,
        model = props.store.model;


    _this.checkDirty = model.checkDirty.bind(model);
    _this.goToPage = store.goToPage.bind(store);
    _this.onPageSizeChange = store.onPageSizeChange.bind(store);
    _this.updateSearchCriteria = store.updateSearchCriteria.bind(store);
    _this.search = store.search.bind(store);
    return _this;
  }

  /**
   * Handle when sort grid
   */


  /**
   * Render select cell
   */


  /**
   * Render text cell
   */


  /**
   * Render roles cell
   */


  /**
   * Check all
   */


  /**
   * Render table component
   */


  (0, _createClass3.default)(AddUserGrid, [{
    key: 'render',


    /**
     * Render component
     */
    value: function render() {
      var _props$store = this.props.store,
          pageInfo = _props$store.model.pageInfo,
          alertMessage = _props$store.alertMessage;


      return _react2.default.createElement(
        _Izenda12.default,
        null,
        _react2.default.createElement(
          _Izenda12.default.Row,
          null,
          _react2.default.createElement(
            _Izenda12.default.Col,
            { cols: '12' },
            _react2.default.createElement(
              _Izenda16.default,
              { type: alertMessage.type },
              alertMessage.message
            )
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Row,
          null,
          _react2.default.createElement(
            _Izenda12.default.Col,
            { cols: '12' },
            _react2.default.createElement(_Izenda7.default, {
              options: _Izenda3.SEARCH_OPTIONS,
              value: pageInfo.searchProperty,
              onSearch: this.search,
              onSearchPropertiesChange: this.updateSearchCriteria
            })
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Row,
          null,
          _react2.default.createElement(
            _Izenda12.default.Col,
            { cols: '12' },
            this.renderTable()
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Row,
          null,
          _react2.default.createElement(
            _Izenda12.default.Col,
            { cols: '12' },
            _react2.default.createElement(_Izenda10.default, {
              onChange: this.goToPage,
              onDropdownChange: this.onPageSizeChange,
              totalRecords: pageInfo.totalRecords,
              pageSize: pageInfo.pageSize,
              pageIndex: pageInfo.pageIndex,
              isDirty: this.checkDirty
            })
          )
        )
      );
    }
  }]);
  return AddUserGrid;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object,
  selectedItems: _react.PropTypes.array
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSortChange = function () {
    var store = _this2.props.store;

    _this2.props.confirmDirtyForm(_this2.checkDirty()).then(function () {
      store.onSortChange();
    });
  };

  this.renderSelectCell = function (data, key) {
    var type = _this2.props.singleUser ? 'radio' : 'checkbox';
    var _props = _this2.props,
        selectedItems = _props.selectedItems,
        model = _props.store.model;


    var onChange = function onChange(e) {
      if (this.props.singleUser) {
        model.resetAllSelected();
      }
      data.updateSelected(e.target.checked);
    };

    // Check item in selected items, check it as default
    var selected = (0, _fp.find)({ emailAddress: data.emailAddress }, selectedItems);

    return _react2.default.createElement('input', { type: type, value: data[key], checked: selected || data[key], onChange: onChange.bind(_this2) });
  };

  this.renderTextCell = function (data, key) {
    var text = data[key] || '';
    return _react2.default.createElement(_Izenda5.default, { tooltip: text, text: text });
  };

  this.renderRoleCell = function (data, key) {
    var text = data[key] || [];
    var value = (0, _fp.join)(', ', (0, _fp.map)(function (item) {
      return item.name;
    }, (0, _fp.filter)(function (item) {
      return !(0, _fp.isEmpty)(item);
    }, text)));

    return _react2.default.createElement(_Izenda5.default, { tooltip: value, text: value });
  };

  this.checkAll = function (e) {
    var store = _this2.props.store || {};
    var model = store.model;
    var value = model.userAccountList || [];

    (0, _fp.forEach)(function (item) {
      item.updateSelected(e.target.checked);
    }, value);
  };

  this.renderTable = function () {
    var _props2 = _this2.props,
        localization = _props2.localization,
        _props2$store = _props2.store,
        model = _props2$store.model,
        isLoadingData = _props2$store.isLoadingData;


    return _react2.default.createElement(
      _Izenda8.Table,
      {
        dataSource: model.userAccountList,
        onSortChange: _this2.onSortChange,
        draggableTable: false,
        sortInfo: model.pageInfo.colSortDirs,
        isLoading: isLoadingData,
        loadingText: localization.getText('USER_MESSAGE_LOADING_TEXT')
      },
      _this2.renderColumns()
    );
  };

  this.renderColumns = function () {
    var hasSelectedAllUser = _this2.props.store.model.hasSelectedAllUser;


    var checkBoxSelectAllProps = {
      checked: hasSelectedAllUser,
      onChange: _this2.checkAll,
      type: 'checkbox'
    };

    var selectRowDefinition = _this2.props.singleUser ? _Izenda3.ADD_USER_TABLE_DEF['selected'] : (0, _fp.merge)(_Izenda3.ADD_USER_TABLE_DEF['selected'], {
      headerComponent: _Izenda14.default,
      headerComponentProps: checkBoxSelectAllProps
    }, {});

    return (0, _fp.map)(function (item) {
      switch (item.key) {
        case 'selected':
          return _react2.default.createElement(_Izenda8.Column, (0, _extends3.default)({}, selectRowDefinition, { cell: _this2.renderSelectCell }));
        case 'roles':
          return _react2.default.createElement(_Izenda8.Column, (0, _extends3.default)({}, item, { cell: _this2.renderRoleCell }));
        default:
          return _react2.default.createElement(_Izenda8.Column, (0, _extends3.default)({}, item, { cell: _this2.renderTextCell }));
      }
    }, (0, _fp.values)(_Izenda3.ADD_USER_TABLE_DEF));
  };
}, _temp)) || _class);
exports.default = AddUserGrid;
module.exports = exports['default'];

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7; // ----------------------------------------------------------------------
// <copyright file="Izenda.UserAccount.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------


var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(98);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(124);

var _Izenda6 = __webpack_require__(985);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(118);

var _Izenda9 = __webpack_require__(15);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var UserAccount = (0, _Izenda2.default)(_class = (_class2 = function () {
  function UserAccount(data) {
    (0, _classCallCheck3.default)(this, UserAccount);

    _initDefineProp(this, 'pageInfo', _descriptor, this);

    _initDefineProp(this, 'userAccountList', _descriptor2, this);

    _initDefineProp(this, 'filterText', _descriptor3, this);

    _initDefineProp(this, 'roleList', _descriptor4, this);

    _initDefineProp(this, 'languageList', _descriptor5, this);

    _initDefineProp(this, 'dateFormatList', _descriptor6, this);

    _initDefineProp(this, 'isLastPage', _descriptor7, this);

    data && this.populateData(data);
  }

  (0, _createClass3.default)(UserAccount, [{
    key: 'populateData',
    value: function populateData(data) {
      this.userAccountList = data.userAccountList;
    }

    /**
     * Populate data
     * @param  {Object} List data of user account detail
     */

  }, {
    key: 'populateUserAccountList',
    value: function populateUserAccountList(userAccount) {
      this.userAccountList = (0, _fp.map)(function (userAccountDetail) {
        return new _Izenda7.default(userAccountDetail);
      }, userAccount.result);
      this.pageInfo.totalRecords = userAccount.total;
    }

    /**
     * Populate partial data for lazy loading
     * @param  {Object} result user lazy loading list result
     * @param  {boolean} isSearching
     */

  }, {
    key: 'populateLazyUserAccountList',
    value: function populateLazyUserAccountList(_ref, isSearching) {
      var result = _ref.result,
          isLastPage = _ref.isLastPage,
          total = _ref.total;

      this.isLastPage = isLastPage;
      this.pageInfo.totalRecords = total;

      isSearching && (this.userAccountList = []);

      var newUsers = (0, _fp.map)(function (userAccountDetail) {
        return new _Izenda7.default(userAccountDetail);
      }, result);
      var selectedTenantId = _Izenda10.default.getTenantId();
      var userTenantId = (0, _fp.flow)(_fp.head, (0, _fp.get)('tenantId'))(newUsers);

      userTenantId === selectedTenantId && (0, _Izenda8.concatArray)(this.userAccountList, newUsers, 'id', !isLastPage);

      return this.userAccountList;
    }

    /**
     * Check user account dirty or not
     * @return {boolean} result of dirty
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      var dirtyItems = (0, _fp.filter)(function (item) {
        return item.checkDirty && item.checkDirty();
      }, this.userAccountList);

      return !(0, _fp.isEmpty)(dirtyItems);
    }

    /**
     * reset all selected user
     */

  }, {
    key: 'resetAllSelected',
    value: function resetAllSelected() {
      (0, _fp.forEach)(function (item) {
        if (item.selected) {
          item.updateSelected(false);
        }
      }, this.userAccountList);
    }

    /**
     * Update filter text   
     * @return {string} filterText
     */

  }, {
    key: 'updateFilterText',
    value: function updateFilterText(filterText) {
      this.filterText = filterText;
    }

    /**
     * populate Role List 
     * @param  {array} roles 
     */

  }, {
    key: 'populateRoleList',
    value: function populateRoleList(roles) {
      this.roleList = roles;
    }

    /**
     * populate Language List
     * @param  {array} languages
     */

  }, {
    key: 'populateLanguageList',
    value: function populateLanguageList(languages) {
      this.languageList = languages;
    }

    /**
     * populate Date Format List
     * @param  {array} dateFormats
     */

  }, {
    key: 'populateDateFormatList',
    value: function populateDateFormatList(dateFormats) {
      this.dateFormatList = (0, _fp.map)(function (item) {
        return {
          labelDateFormat: item,
          dateFormat: item
        };
      }, dateFormats);
    }

    /**
     * Delete user
     * @param  {Object} user
     */

  }, {
    key: 'deleteUser',
    value: function deleteUser(user) {
      this.userAccountList = (0, _fp.remove)({ id: user.id }, this.userAccountList);
    }

    /**
     * Add new user
     * @param  {Object} user
     */

  }, {
    key: 'addUser',
    value: function addUser(user) {
      var newUserDetail = new _Izenda7.default(user);
      (0, _Izenda8.concatArray)(this.userAccountList, [newUserDetail], 'id');

      return newUserDetail;
    }
  }, {
    key: 'hasSelectedAllUser',
    get: function get() {
      if ((0, _fp.isEmpty)(this.userAccountList)) {
        return false;
      }
      return (0, _fp.every)(['selected', true], this.userAccountList);
    }
  }, {
    key: 'filterUser',
    get: function get() {
      return (0, _fp.reject)('deleted', this.userAccountList);
    }

    /**
     * Populate data
     * @param  {Object} user account object
     */

  }]);
  return UserAccount;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'pageInfo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda4.default(_Izenda5.DEFAULT_VALUE.SORT_DIRS, _Izenda5.DEFAULT_VALUE.SEARCH_CRITERIA);
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'userAccountList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'filterText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'roleList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'languageList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'dateFormatList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'isLastPage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'hasSelectedAllUser', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasSelectedAllUser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filterUser', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filterUser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateUserAccountList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateUserAccountList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateLazyUserAccountList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateLazyUserAccountList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'checkDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'checkDirty'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetAllSelected', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetAllSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateFilterText', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateFilterText'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateRoleList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateRoleList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateLanguageList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateLanguageList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteUser', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteUser'), _class2.prototype)), _class2)) || _class;

exports.default = UserAccount;
module.exports = exports['default'];

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(58);

var _Izenda4 = __webpack_require__(92);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var AccessDetail = (0, _Izenda2.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(AccessDetail, [{
    key: 'hasRolesAccessor',
    get: function get() {
      return this.assignedType === _Izenda4.ASSIGN_TYPE.ROLE;
    }
  }, {
    key: 'hasUserAccessor',
    get: function get() {
      return this.assignedType === _Izenda4.ASSIGN_TYPE.USER;
    }
  }, {
    key: 'accessorsInfo',
    get: function get() {
      var _this = this;

      return this.accessors.map(function (item, index) {
        return {
          id: item,
          name: _this.accessorNames[index]
        };
      });
    }
  }]);

  function AccessDetail(data) {
    (0, _classCallCheck3.default)(this, AccessDetail);

    _initDefineProp(this, 'accessors', _descriptor, this);

    _initDefineProp(this, 'accessRight', _descriptor2, this);

    _initDefineProp(this, 'assignedType', _descriptor3, this);

    _initDefineProp(this, 'id', _descriptor4, this);

    _initDefineProp(this, 'permissionId', _descriptor5, this);

    _initDefineProp(this, 'reportId', _descriptor6, this);

    _initDefineProp(this, 'selected', _descriptor7, this);

    _initDefineProp(this, 'state', _descriptor8, this);

    _initDefineProp(this, 'accessRightId', _descriptor9, this);

    _initDefineProp(this, 'reportAccessRightId', _descriptor10, this);

    _initDefineProp(this, 'dashboardAccessRightId', _descriptor11, this);

    _initDefineProp(this, 'assignedTypeName', _descriptor12, this);

    _initDefineProp(this, 'accessorNames', _descriptor13, this);

    _initDefineProp(this, 'reportAccessRights', _descriptor14, this);

    _initDefineProp(this, 'dashboardAccessRights', _descriptor15, this);

    this.localRoles = [];
    this.tempId = (0, _fp.uniqueId)();
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} access detail data
   */


  (0, _createClass3.default)(AccessDetail, [{
    key: 'populateData',
    value: function populateData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.id = data.id;
      this.accessors = data.accessors || [];
      this.accessRight = data.accessRight;
      this.assignedType = data.assignedType;
      this.accessRightId = data.accessRightId;
      this.reportAccessRightId = data.reportAccessRightId;
      this.dashboardAccessRightId = data.dashboardAccessRightId;
      this.state = data.state;
      this.reportId = data.reportId;
      this.tempId = data.tempId || data.id;
      this.assignedTypeName = data.assignedTypeName;
      this.accessorNames = data.accessorNames || [];
      this.reportAccessRights = data.reportAccessRights;
      this.dashboardAccessRights = data.dashboardAccessRights;
    }

    /**
     * Update selected access
     * @param  {boolean} value
     */

  }, {
    key: 'updateSelected',
    value: function updateSelected(value) {
      this.selected = value;
    }

    /**
     * Check access  dirty or not
     * @return {boolean} result of dirty
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty;
    }

    /**
     * Update value by key
     * @param  {string} value
     * @param  {string} key
     */

  }, {
    key: 'updateValueByKey',
    value: function updateValueByKey(value, key) {
      this[key] = value;
      this.updateState();
      this.markDirty();
    }

    /**
     * Update access right
     * @param  {string} value
     * @param  {string} key
     */

  }, {
    key: 'updateAccessRight',
    value: function updateAccessRight(value, key) {
      this[key] = value.value;
      this.updateState();
      this.markDirty();
    }

    /**
     * delete action
     */

  }, {
    key: 'delete',
    value: function _delete() {
      this.selected = false;
      this.state = _Izenda3.DELETE;
      this.markDirty();
    }

    /**
     * Update assigned type
     * @param  {string} value
     */

  }, {
    key: 'updateAssignedType',
    value: function updateAssignedType(value) {
      this.assignedType = value;
      this.accessors = [];
      this.accessorNames = [];
      this.updateState();
      this.markDirty();
    }

    /**
     * Add more accessors
     * @param  {string} value
     */

  }, {
    key: 'addMoreAccessors',
    value: function addMoreAccessors(value) {
      var _this2 = this;

      (0, _fp.forEach)(function (item) {
        if (!(0, _fp.isEmpty)(item) && !(0, _fp.includes)(item.id, _this2.accessors)) {
          _this2.accessors.push(item.id);
          _this2.accessorNames.push(item.name || item.fullName);
        }
      }, value);
      this.updateState();
      this.markDirty();
    }

    /**
     * Build access data for save in tenant/ role settings
     * @return {object}
     */

  }, {
    key: 'buildDataForSaveAccessSettings',
    value: function buildDataForSaveAccessSettings() {
      return {
        state: this.state,
        assignedType: this.assignedType,
        accessors: this.accessors,
        tempId: this.tempId,
        id: this.id,
        reportAccessRightId: this.reportAccessRightId,
        dashboardAccessRightId: this.dashboardAccessRightId
      };
    }

    /**
     * Update state of access detail if current state # Insert
     */

  }, {
    key: 'updateState',
    value: function updateState() {
      if (this.state !== _Izenda3.INSERT) {
        this.state = _Izenda3.UPDATE;
      }
    }

    /**
     * Update accessor list
     * @param  {Array} accessors
     */

  }, {
    key: 'updateAccessorList',
    value: function updateAccessorList(accessors) {
      var _this3 = this;

      this.accessors.splice(0, this.accessors.length);
      this.accessorNames.splice(0, this.accessorNames.length);
      this.localRoles.splice(0, this.localRoles.length);

      (0, _fp.forEach)(function (item) {
        _this3.accessors.push(item.id);
        _this3.accessorNames.push(item.name || item.fullName);
        (0, _fp.isNil)(item.tenantId) && _this3.localRoles.push(item.id);
      }, accessors);
      this.updateState();
      this.markDirty();
    }

    /**
     * Remove all global roles
     */

  }, {
    key: 'removeAllGlobalRoles',
    value: function removeAllGlobalRoles() {
      this.accessors = this.localRoles;
    }
  }]);
  return AccessDetail;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'accessors', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'accessRight', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'assignedType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'permissionId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'reportId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'selected', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'state', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda3.INSERT;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'accessRightId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'reportAccessRightId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'dashboardAccessRightId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'assignedTypeName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'accessorNames', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'reportAccessRights', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'dashboardAccessRights', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'hasRolesAccessor', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasRolesAccessor'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasUserAccessor', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasUserAccessor'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'accessorsInfo', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'accessorsInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateSelected', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateValueByKey', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateValueByKey'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAccessRight', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAccessRight'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'delete', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'delete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAssignedType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAssignedType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addMoreAccessors', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addMoreAccessors'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateState', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateState'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateAccessorList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateAccessorList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeAllGlobalRoles', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeAllGlobalRoles'), _class2.prototype)), _class2)) || _class;

exports.default = AccessDetail;
module.exports = exports['default'];

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportConfigModel.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var CONSTANTS = __webpack_require__(420);
  var DEFAULT_VALUE = CONSTANTS.DEFAULT_VALUE;
  var DEFAULT_SETTINGS = CONSTANTS.DEFAULT_SETTINGS;
  var PrintConstants = __webpack_require__(222);
  var MARGIN_KEY = CONSTANTS.MARGIN_KEY;

  var _require = __webpack_require__(1),
      getOr = _require.getOr,
      uniqueId = _require.uniqueId,
      map = _require.map,
      forEach = _require.forEach,
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      invokeArgs = _require.invokeArgs,
      find = _require.find;

  function MarginSettings(data) {
    var props = {
      type: DEFAULT_VALUE,
      top: DEFAULT_VALUE,
      bottom: DEFAULT_VALUE,
      left: DEFAULT_VALUE,
      right: DEFAULT_VALUE,
      header: DEFAULT_VALUE,
      footer: DEFAULT_VALUE
    };
    m.extendObservable(trackable(this), props);
    data && this.readData(data);
  }

  /**
   * Read data for margin setting
   * @param  {object} data
   */
  MarginSettings.prototype.readData = m.action(function (data) {
    this.type = data.type;
    this.top = data.topValue;
    this.bottom = data.bottomValue;
    this.left = data.leftValue;
    this.right = data.rightValue;
    this.header = data.headerValue;
    this.footer = data.footerValue;
  });

  /**
   * Get data for savings
   * @return  {object} data
   */
  MarginSettings.prototype.prepairData = function () {
    return {
      type: this.type,
      topValue: this.top,
      bottomValue: this.bottom,
      leftValue: this.left,
      rightValue: this.right,
      headerValue: this.header,
      footerValue: this.footer
    };
  };

  /**
   * Get data for savings
   * @param  {float} value
   * @param  {string} key
   */
  MarginSettings.prototype.updateValueByKey = m.action(function (value, key) {
    this[key] = value;
    this.markDirty();
  });

  function ExportConfigModel(data) {
    var props = {
      id: uniqueId(),
      orientation: DEFAULT_VALUE,
      margins: DEFAULT_VALUE,
      centerOnPage: {
        horizontally: false,
        vertically: false
      },
      pageBreakAfterReportPart: false,
      pageSizeKey: PrintConstants.DEFAULT_PAGE_SIZE_KEY,
      scaleX: 1,
      scaleY: 1,
      marginSettings: this.initMarginSettings(DEFAULT_SETTINGS),
      getAllMarginSettings: function getAllMarginSettings() {
        return map(function (item) {
          return item.prepairData();
        }, this.marginSettings);
      },
      getMarginSetting: function getMarginSetting() {
        return find({
          type: this.margins
        }, this.marginSettings) || {};
      },
      customMarginSettings: function customMarginSettings() {
        return find({
          type: CONSTANTS.MARGIN_VALUE.CUSTOM
        }, this.marginSettings);
      },
      marginSettingInInches: function marginSettingInInches() {
        var margin = find({
          type: this.margins
        }, this.marginSettings);
        if (!margin) return {
          margin: 0
        };

        var rawMargin = m.toJS(margin);
        var unit = 'in';
        return {
          marginTop: rawMargin.top && rawMargin.top + unit,
          marginRight: rawMargin.right && rawMargin.right + unit,
          marginBottom: rawMargin.bottom && rawMargin.bottom + unit,
          marginLeft: rawMargin.left && rawMargin.left + unit,
          header: rawMargin.header && rawMargin.header + unit,
          footer: rawMargin.footer && rawMargin.footer + unit
        };
      }
    };

    m.extendObservable(trackable(this), props);
    data && this.readFromReport(data);
  }

  /**
   * Read data for export config
   * @param  {object} reportDefintions
   */
  ExportConfigModel.prototype.readFromReport = m.action(function (reportDefintions) {
    var exportConfig = reportDefintions.exportFormatSetting || {};
    var centerOnPage = exportConfig.centerOnPage || {};

    this.orientation = exportConfig.orientation;
    this.margins = exportConfig.margins;
    this.centerOnPage.horizontally = centerOnPage.horizontally;
    this.centerOnPage.vertically = centerOnPage.vertically;
    this.pageBreakAfterReportPart = exportConfig.pageBreakAfterReportPart;
    this.updateMarginSettings(exportConfig.marginSettings);
  });

  /**
   * Init margin config
   * @param  {array} data
   */
  ExportConfigModel.prototype.initMarginSettings = m.action(function (data) {
    return map(function (item) {
      return new MarginSettings(item);
    }, data);
  });

  /**
   * Update margin config
   * @param  {array} data
   */
  ExportConfigModel.prototype.updateMarginSettings = m.action(function (data) {
    forEach(function (item) {
      item && invokeArgs('readData', [item], find({
        type: item.type
      }, this.marginSettings));
    }.bind(this), data);
  });

  /**
   * Get export config for saving
   * @return  {object} data
   */
  ExportConfigModel.prototype.getExportConfig = function () {
    return {
      orientation: this.orientation,
      margins: this.margins,
      centerOnPage: this.centerOnPage,
      pageBreakAfterReportPart: this.pageBreakAfterReportPart,
      marginSettings: this.getAllMarginSettings
    };
  };

  /**
   * Update export settings by key
   * @param  {string} value
   * @param  {string} key
   */
  ExportConfigModel.prototype.updateValueByKey = m.action(function (value, key) {
    this[key] = value;
    this.markDirty();
  });

  /**
   * Update center on page settings by key
   * @param  {bool} value
   * @param  {string} key
   */
  ExportConfigModel.prototype.updateCenterOnPageByKey = m.action(function (value, key) {
    this.centerOnPage[key] = value;
    this.markDirty();
  });

  /**
   * Check model dirty
   * @return {bool} result
   */
  ExportConfigModel.prototype.checkDirty = function () {
    var dirtyItems = filter(function (item) {
      return item.checkDirty && item.checkDirty();
    }, this.marginSettings);

    return !isEmpty(dirtyItems) || this.isDirty;
  };

  /**
   * clean model dirty
   */
  ExportConfigModel.prototype.cleanDirty = m.action(function () {
    this.resetDirty();
    forEach(function (marginSetting) {
      marginSetting.resetDirty();
    }, this.marginSettings);
  });

  /**
   * Get max value by key
   * @param {string} key
   * @returns {int} max value
   */
  ExportConfigModel.prototype.getMaxByKey = function (key) {
    var pageSize = PrintConstants.getPageSize(this.pageSizeKey, this.orientation);
    var marginSetings = this.getMarginSetting;
    var minWidth = CONSTANTS.MIN_WIDTH;
    var minHeight = CONSTANTS.MIN_HEIGHT;

    var rightValue = getOr(0, 'right', marginSetings);
    var leftValue = getOr(0, 'left', marginSetings);
    var bottomValue = getOr(0, 'bottom', marginSetings);
    var topValue = getOr(0, 'top', marginSetings);
    var headerValue = getOr(0, 'header', marginSetings);
    var footerValue = getOr(0, 'footer', marginSetings);

    var result = CONSTANTS.MAX_HEIGHT;

    switch (key) {
      case MARGIN_KEY.LEFT:
        result = pageSize.widthInInches - rightValue - minWidth;
        break;
      case MARGIN_KEY.RIGHT:
        result = pageSize.widthInInches - leftValue - minWidth;
        break;
      case MARGIN_KEY.TOP:
        result = pageSize.heightInInches - minHeight - (bottomValue + headerValue + footerValue);
        break;
      case MARGIN_KEY.BOTTOM:
        result = pageSize.heightInInches - minHeight - (topValue + headerValue + footerValue);
        break;
      case MARGIN_KEY.HEADER:
        result = pageSize.heightInInches - minHeight - (bottomValue + topValue + footerValue);
        break;
      case MARGIN_KEY.FOOTER:
        result = pageSize.heightInInches - minHeight - (bottomValue + headerValue + topValue);
        break;
    }

    return Math.round(result * 100) / 100;
  };

  module.exports = ExportConfigModel;
}();

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RepportViewerMode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);

  function DisplayMode(info) {
    var props = {
      isSubscriptionMode: false,

      doesDisablePrintBtn: function doesDisablePrintBtn() {
        return this.isSubscriptionMode;
      },
      doesDisableEmailBtn: function doesDisableEmailBtn() {
        return this.isSubscriptionMode;
      },
      doesDisableExportBtn: function doesDisableExportBtn() {
        return this.isSubscriptionMode;
      },
      doesDisableEditBtn: function doesDisableEditBtn() {
        return this.isSubscriptionMode;
      },
      doesDisableUpdateResultBtn: function doesDisableUpdateResultBtn() {
        return this.isSubscriptionMode;
      }
    };

    m.extendObservable(this, props);
    info && this.populateData(info);
  }

  /**
   * Set data for model.
   * @param  {Object} info
   */
  DisplayMode.prototype.populateData = function (info) {
    this.isSubscriptionMode = info.isSubscriptionMode;
  };

  /**
   * Reset data of model.
   */
  DisplayMode.prototype.reset = function () {
    this.isSubscriptionMode = false;
  };

  /**
   * Update subscription mode.
   */
  DisplayMode.prototype.toggleSubscription = function () {
    this.isSubscriptionMode = !this.isSubscriptionMode;
  };

  module.exports = DisplayMode;
}();

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(16);

var _Izenda2 = __webpack_require__(96);

var _Izenda3 = _interopRequireDefault(_Izenda2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CalculatedField = (_class = function () {
  (0, _createClass3.default)(CalculatedField, [{
    key: 'functions',
    // list format for subtotal and grand total
    get: function get() {
      return this.loadFunctionsForDataType();
    } // Parent Id

  }, {
    key: 'disablePreview',
    get: function get() {
      var disableExpression = false;

      if (this.type.functionLabel) {
        disableExpression = !this.expression && this.functionName === _Izenda3.default.FUNCTION_NAME.EXPRESSION || this.functionName === _Izenda3.default.FUNCTION_NAME.NONE;
      } else {
        disableExpression = !this.expression;
      }

      return disableExpression || !this.validExpression;
    }
  }]);

  function CalculatedField(data) {
    (0, _classCallCheck3.default)(this, CalculatedField);

    _initDefineProp(this, 'id', _descriptor, this);

    _initDefineProp(this, 'tempId', _descriptor2, this);

    _initDefineProp(this, 'name', _descriptor3, this);

    _initDefineProp(this, 'functionName', _descriptor4, this);

    _initDefineProp(this, 'expression', _descriptor5, this);

    _initDefineProp(this, 'izendaDataType', _descriptor6, this);

    _initDefineProp(this, 'isRunningField', _descriptor7, this);

    _initDefineProp(this, 'isCompositeField', _descriptor8, this);

    _initDefineProp(this, 'format', _descriptor9, this);

    _initDefineProp(this, 'suggestedDataType', _descriptor10, this);

    _initDefineProp(this, 'previewResult', _descriptor11, this);

    _initDefineProp(this, 'querySourceId', _descriptor12, this);

    _initDefineProp(this, 'fieldDataType', _descriptor13, this);

    _initDefineProp(this, 'type', _descriptor14, this);

    _initDefineProp(this, 'validExpression', _descriptor15, this);

    _initDefineProp(this, 'previewRecord', _descriptor16, this);

    _initDefineProp(this, 'formats', _descriptor17, this);

    _initDefineProp(this, 'dataTypes', _descriptor18, this);

    _initDefineProp(this, 'hasSupportDefaultTotal', _descriptor19, this);

    _initDefineProp(this, 'formatDataType', _descriptor20, this);

    _initDefineProp(this, 'canSetSubtotal', _descriptor21, this);

    data && this.populateData(data);
  }

  /**
   * Populate data for CalculatedField
   */


  (0, _createClass3.default)(CalculatedField, [{
    key: 'populateData',
    value: function populateData(data) {
      data = data || {};
      this.id = data.id;
      this.tempId = data.tempId;
      this.name = data.name;
      this.functionName = data.functionName;
      this.expression = data.expression;
      this.izendaDataType = data.izendaDataType;
      this.isRunningField = data.isRunningField;
      this.isCompositeField = data.isCompositeField;
      this.format = data.format;
      this.suggestedDataType = data.suggestedDataType;
      this.previewResult = data.previewResult;
      this.querySourceId = data.querySourceId;
      this.fieldDataType = data.fieldDataType;
      this.type = data.type;
      this.validExpression = data.validExpression;
      this.previewRecord = data.previewRecord;
      this.formats = data.formats;
      this.hasSupportDefaultTotal = data.hasSupportDefaultTotal;
      this.formatDataType = data.formatDataType;
      this.canSetSubtotal = data.canSetSubtotal;
    }

    /**
     * Read initial dats
     * @param {any} data
     * @param {string} type
     */

  }, {
    key: 'readInitialData',
    value: function readInitialData(data, type) {
      data = data || {};

      this.name = data.name || '';
      this.functionName = data.functionName || _Izenda3.default.FUNCTION_NAME.NONE;
      this.expression = data.expression || '';
      this.izendaDataType = data.izendaDataType || null;
      this.isRunningField = data.isRunningField || false;
      this.isCompositeField = data.isCompositeField || false;
      this.tempId = data.tempId;
      this.id = data.id || null;
      this.querySourceId = data.querySourceId || '';
      this.fieldDataType = data.fieldDataType || '';
      this.type = type || _Izenda3.default.TYPES.ADD;
      this.validExpression = !!data.expression;
      this.previewRecord = data.previewRecord || null;
      this.format = data.format || {};
      this.hasSupportDefaultTotal = (0, _fp.isBoolean)(data.hasSupportDefaultTotal) ? data.hasSupportDefaultTotal : true;
      this.formatDataType = data.formatDataType || '';
      this.canSetSubtotal = (0, _fp.isBoolean)(data.canSetSubtotal) ? data.canSetSubtotal : true;

      return (0, _bluebird.resolve)();
    }
  }, {
    key: 'clone',
    value: function clone() {
      var data = (0, _mobx.toJS)(this);
      var cloned = new CalculatedField();
      cloned.readInitialData(data, data.type);
      return cloned;
    }

    /**
     * Change field name
     * @param {string} value
     */

  }, {
    key: 'changeFunctionName',
    value: function changeFunctionName(value) {
      this.functionName = value;
      this.loadSuggestedDataTypeByFunction();

      // Reset model when change function to NONE
      if (value === _Izenda3.default.FUNCTION_NAME.NONE) {
        this.resetData();
      }
    }

    /**
     * Reset model when change function to NONE
     */

  }, {
    key: 'resetData',
    value: function resetData() {
      this.name = '';
      this.expression = '';
      this.izendaDataType = null;
      this.isRunningField = false;
      this.isCompositeField = false;
      this.format = {};
      this.previewResult = '';
    }

    /**
     * Change function name
     * @param {string} value
     */

  }, {
    key: 'changeFieldName',
    value: function changeFieldName(value) {
      this.name = value;
    }

    /**
     * Change expression
     * @param {string} value
     */

  }, {
    key: 'changeExpression',
    value: function changeExpression(value) {
      this.expression = value;
    }

    /**
     * Change expression
     * @param {string} value
     */

  }, {
    key: 'changeDataType',
    value: function changeDataType(value) {
      this.izendaDataType = value;
    }

    /**
     * Change format type
     * @param {String} value
     */

  }, {
    key: 'changeFormat',
    value: function changeFormat(value) {
      this.format = value;
    }

    /**
     * Read suggestion data type when validate expression successfully
     * @param {any} result
     */

  }, {
    key: 'readDataType',
    value: function readDataType(result) {
      var resultData = result.result || {};

      if (resultData.izendaDataType) {
        this.izendaDataType = resultData.izendaDataType;
        this.isRunningField = resultData.isRunningField;
        this.isCompositeField = resultData.isCompositeField;
      }
      this.validExpression = (0, _fp.isEmpty)(result.messages);
      return result.messages;
    }

    /**
     * Read preview result
     * @param {any} result
     */

  }, {
    key: 'readPreviewResult',
    value: function readPreviewResult(result) {
      if (result.messages) return result.messages;

      this.previewResult = !(0, _fp.isNil)(result.value) ? result.value : '';
      this.izendaDataType = result.dataType;
      return null;
    }

    /**
     * Load data type by its value
     * @param {string} dataType
     */

  }, {
    key: 'loadDataTypeByValue',
    value: function loadDataTypeByValue(dataType) {
      return (0, _fp.find)(function (item) {
        return item.value === dataType;
      }, _Izenda3.default.DATA_TYPES);
    }

    /**
     * Load supported functions of a data type
     */

  }, {
    key: 'loadFunctionsForDataType',
    value: function loadFunctionsForDataType() {
      var dataType = this.getFinalDataType();
      var matchedDataType = this.loadDataTypeByValue(dataType);

      var functions = matchedDataType ? (0, _fp.map)(function (item) {
        return (0, _fp.find)({ value: item }, _Izenda3.default.FUNCTIONS);
      }, matchedDataType.functions) : [];
      return (0, _fp.remove)({ value: _Izenda3.default.FUNCTION_NAME.DEFAULT }, functions);
    }

    /**
     * Load suggested data type for function
     */

  }, {
    key: 'loadSuggestedDataTypeByFunction',
    value: function loadSuggestedDataTypeByFunction() {
      this.izendaDataType = this.calculateSuggestedDataTypeByFunction();
    }

    /**
     * Get final data type if the field apply aggregated function
     */

  }, {
    key: 'getFinalDataType',
    value: function getFinalDataType() {
      return (0, _fp.isEmpty)(this.formatDataType) ? this.fieldDataType : this.formatDataType;
    }

    /**
     * Compute suggested data type for function
     */

  }, {
    key: 'calculateSuggestedDataTypeByFunction',
    value: function calculateSuggestedDataTypeByFunction() {
      var dataType = (0, _fp.isEmpty)(this.formatDataType) ? this.fieldDataType : this.formatDataType;
      switch (this.functionName) {
        case _Izenda3.default.FUNCTION_NAME.NONE:
        case _Izenda3.default.FUNCTION_NAME.EXPRESSION:
        case _Izenda3.default.FUNCTION_NAME.DEFAULT:
          return null;
        case _Izenda3.default.FUNCTION_NAME.COUNT:
        case _Izenda3.default.FUNCTION_NAME.COUNT_DISTINCT:
          return _Izenda.DATA_TYPES.NUMERIC;
        case _Izenda3.default.FUNCTION_NAME.AVERAGE:
        case _Izenda3.default.FUNCTION_NAME.SUM:
        case _Izenda3.default.FUNCTION_NAME.SUM_DISTINCT:
        default:
          return dataType;
      }
    }
    /**
     * Check function support data type
     */

  }, {
    key: 'doesFunctionAcceptDataType',
    value: function doesFunctionAcceptDataType() {
      var suggestedDataType = this.calculateSuggestedDataTypeByFunction();
      var suggestedDataTypeDetail = this.loadDataTypeByValue(suggestedDataType);

      return suggestedDataType === this.izendaDataType || (0, _fp.indexOf)(this.izendaDataType, suggestedDataTypeDetail.toDataTypes) !== -1;
    }
  }]);
  return CalculatedField;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'tempId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'functionName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'expression', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'izendaDataType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'isRunningField', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'isCompositeField', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'format', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'suggestedDataType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'previewResult', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'querySourceId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'fieldDataType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda3.default.TYPES.ADD;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, 'validExpression', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, 'previewRecord', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, 'formats', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, 'dataTypes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda3.default.DATA_TYPES;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, 'hasSupportDefaultTotal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, 'formatDataType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, 'canSetSubtotal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'functions', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'functions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'disablePreview', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'disablePreview'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'populateData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readInitialData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readInitialData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeFunctionName', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeFunctionName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readDataType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readDataType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readPreviewResult', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readPreviewResult'), _class.prototype)), _class);
exports.default = CalculatedField;
module.exports = exports['default'];

/***/ }),
/* 2006 */,
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerScheduleStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = __webpack_require__(5);
  var SubscribedInstancesStore = __webpack_require__(327);

  function ReportDesignerScheduleStore(reportStore) {
    // master store
    this.reportStore = reportStore;
    var props = {
      /* main model of store */
      masterModel: reportStore.model,
      subscribedInstancesStore: new SubscribedInstancesStore(false)
    };

    m.extendObservable(this, props);
  }

  module.exports = ReportDesignerScheduleStore;
}();

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.SubscribedInstances.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var PagingModel = __webpack_require__(98);
  var ObjectStateConstants = __webpack_require__(58);
  var constant = __webpack_require__(133);
  var DEFAULT_VALUE = constant.DEFAULT_VALUE;
  var trackable = __webpack_require__(46);
  var SubscriptionDetails = __webpack_require__(229);
  var MobxUtils = __webpack_require__(275);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      every = _require.every,
      some = _require.some,
      forEach = _require.forEach,
      isNil = _require.isNil,
      isEqual = _require.isEqual,
      map = _require.map,
      cloneDeep = _require.cloneDeep,
      uniqueId = _require.uniqueId,
      findIndex = _require.findIndex,
      indexOf = _require.indexOf,
      get = _require.get,
      find = _require.find,
      placeholder = _require.placeholder;

  function SubscribedInstances(data) {
    var props = {
      pageInfo: new PagingModel(DEFAULT_VALUE.SORT_DIRS, DEFAULT_VALUE.SEARCH_CRITERIA),
      subscribedInstances: [], // array of SubscriptionDetails.
      emailTemplates: null,
      isSubscriptionMode: true,
      scheduleInstances: [], // array of SubscriptionDetails that is used for report designer schedule.

      activeInstances: function activeInstances() {
        return filter(function (item) {
          return item.state !== ObjectStateConstants.DELETE;
        }, this.subscribedInstances);
      },

      hasAllActiveInstancesSelected: function hasAllActiveInstancesSelected() {
        if (isEmpty(this.activeInstances)) {
          return false;
        }
        return every(['selectedValue', true], this.activeInstances);
      },

      hasActiveInstancesSelected: function hasActiveInstancesSelected() {
        if (isEmpty(this.activeInstances)) {
          return false;
        }
        return some(['selectedValue', true], this.activeInstances);
      }
    };

    m.extendObservable(trackable(this), props);
    this.cleanDirty();
  }

  /**
   * Populate data
   * @param  {object} data
   */
  SubscribedInstances.prototype.populateData = m.action(function (data) {
    data = data || {};
    this.subscribedInstances = [];

    forEach(function (item) {
      this.subscribedInstances.push(new SubscriptionDetails(item));
    }.bind(this), data.result);

    this.pageInfo.setTotalRecords(data.total);

    this.cleanDirty();
    return (0, _bluebird.resolve)({});
  });

  /**
   * Load active instance
   */
  SubscribedInstances.prototype.loadActiveInstances = function () {
    return filter(function (item) {
      return item.state !== ObjectStateConstants.DELETE;
    }, this.subscribedInstances);
  };

  /**
   * Load email templates
   * @param {object} data
   */
  SubscribedInstances.prototype.populateEmailTemplates = function (data) {
    this.emailTemplates = data;
    this.markDirty();
    return (0, _bluebird.resolve)({});
  };

  /**
   * Check dirty status
   * @return {boolean} dirty status
   */
  SubscribedInstances.prototype.checkDirty = function () {
    var dirtyItems = filter(function (item) {
      return item.checkDirty && item.checkDirty();
    }, this.subscribedInstances);

    return !isEmpty(dirtyItems) && this.isDirty;
  };

  /**
   * Clean dirty status.
   */
  SubscribedInstances.prototype.cleanDirty = function () {
    forEach(function (item) {
      item.cleanDirty && item.cleanDirty();
    }, this.subscribedInstances);

    this.resetDirty();
  };

  /**
   * Copy a subscribed instance and add it at first of subscribed instances list.
   * @param {String} id
   */
  SubscribedInstances.prototype.copySubscribedInstance = function (id) {
    this.copy(this.subscribedInstances, id);
  };

  /**
   * Copy a schedule instance and add it at first of subscribed instances list.
   * @param {String} id
   */
  SubscribedInstances.prototype.copyScheduleInstances = m.action(function (id) {
    this.scheduleInstances = this.subscribedInstances;
    this.markDirty();
  });

  /**
   * Copy a instance.
   * @param {String} id
   */
  SubscribedInstances.prototype.copy = m.action(function (instances, id) {
    var findInstance = function findInstance(id) {
      return find(function (item) {
        return item.id === id;
      }, instances);
    };

    var updateFilters = m.action(function (filters) {
      forEach(function (item) {
        item.state = ObjectStateConstants.INSERT;
        item.id = null;
        item.subscriptionId = null;
      }, filters);
    });

    var copyInstance = m.action(function (instance) {
      var clonedInstance = new SubscriptionDetails(cloneDeep(matchedInstance));
      var newName = String.generateNewName(clonedInstance.name, instances, get('name'));

      clonedInstance.updateProperty('id', uniqueId('newInstance_'));
      clonedInstance.updateProperty('name', newName);
      clonedInstance.updateProperty('state', ObjectStateConstants.INSERT);
      clonedInstance.updateProperty('subscriptionFilterFields', matchedInstance.subscriptionFilterFields && cloneDeep(MobxUtils.toJS(matchedInstance.subscriptionFilterFields)));
      clonedInstance.updateProperty('subscriptionCommonFilterFields', matchedInstance.subscriptionCommonFilterFields && cloneDeep(MobxUtils.toJS(matchedInstance.subscriptionCommonFilterFields)));

      updateFilters(clonedInstance.subscriptionFilterFields);
      updateFilters(clonedInstance.subscriptionCommonFilterFields);

      return clonedInstance;
    });

    var matchedInstance = findInstance(id);
    if (!matchedInstance) {
      return;
    }

    var newInstance = copyInstance(matchedInstance);
    instances.splice(0, 0, newInstance);
    this.pageInfo.increaseRecord();
    this.markDirty();
  });

  /**
   * Compose list of instances for saving.
   * @returns {Array}
   */
  SubscribedInstances.prototype.buildDataForSaving = function () {
    var subscribedInstances = placeholder(this.subscribedInstances).chain().filter(function (item) {
      return item.state !== ObjectStateConstants.NONE;
    }).forEach(function (i) {
      if (i.state === ObjectStateConstants.INSERT) {
        i.id = null;
      }
    }).value();

    return subscribedInstances;
  };

  /**
   * Delete subscribed instance.
   * Just remove in browser, user must save for real delete.
   * @param {Array} ids
   */
  SubscribedInstances.prototype.removeSubscribedInstances = function (ids) {
    this.delete(this.subscribedInstances, ids);
  };

  /**
   * Delete schedule instance.
   * Just remove in browser, user must save for real delete.
   * @param {Array} ids
   */
  SubscribedInstances.prototype.removeScheduleInstances = function (ids) {
    this.delete(this.scheduleInstances, ids);
  };

  /**
   * Delete instance.
   * Just remove in browser, user must save for real delete.
   * @param {Array} ids
   */
  SubscribedInstances.prototype.delete = m.action(function (instances, ids) {
    var pageInfo = this.pageInfo;
    forEach(function (id) {
      var index = findIndex(function (item) {
        return item.id === id;
      }, instances);

      if (index !== -1) {
        switch (instances[index].state) {
          case ObjectStateConstants.INSERT:
            instances.splice(index, 1);
            break;
          default:
            instances[index].updateProperty('state', ObjectStateConstants.DELETE);
            instances[index].updateSelectedValue(false);
            forEach(function (item) {
              item.state = ObjectStateConstants.DELETE;
            }, instances[index].subscriptionFilterFields);
            break;
        }

        pageInfo.descreaseRecord();
      }
    }, ids);

    this.markDirty();
  });

  /**
   * Update subscribed instance.
   * @param {Object} subscription data
   */
  SubscribedInstances.prototype.updateSubscribedInstances = m.action(function (subData) {
    var subscription = find(function (s) {
      return isEqual(s.id, subData.id);
    }, this.subscribedInstances);

    if (isNil(subscription)) {
      this.subscribedInstances.push(subData);
      this.pageInfo.increaseRecord();
    } else {
      var i = indexOf(subscription, this.subscribedInstances);
      this.subscribedInstances[i] = subData;
    }

    this.markDirty();
  });

  /**
   * Check duplicate instance name.
   * Just check with active instances.
   * @param {Object} instance
   * @returns {Boolean}
   */
  SubscribedInstances.prototype.checkDuplicateInstanceName = function (instance) {
    var matchedInstance = find(function (item) {
      return item.name.toUpperCase() === instance.name.toUpperCase() && item.id !== instance.id;
    }, this.loadActiveInstances());

    return !!matchedInstance;
  };

  /**
   * Set type mode: Subscription or Schedule
   * @param {Boolean} Subscription or Schedule
   */
  SubscribedInstances.prototype.setType = function (isSubscriptionMode) {
    this.isSubscriptionMode = isSubscriptionMode;
  };

  /**
   * Update data for schedule instances
   * @param {Boolean} isNew
   * @param {Object} data
   */
  SubscribedInstances.prototype.updateScheduleInstances = m.action(function (isNew, data) {
    if (isNew) {
      this.scheduleInstances = map(function (item) {
        return new SubscriptionDetails(item);
      }, this.subscribedInstances);
    } else {
      if (!isNil(data)) {
        var subscription = find(function (s) {
          return isEqual(s.id, data.id);
        }, this.scheduleInstances);

        if (isNil(subscription)) {
          this.scheduleInstances.push(data);
        } else {
          var i = indexOf(subscription, this.scheduleInstances);
          this.scheduleInstances[i] = data;
        }
      }
    }
    this.markDirty();
  });

  /**
   * Reset page model
   */
  SubscribedInstances.prototype.resetPageModel = function () {
    this.pageInfo = new PagingModel(DEFAULT_VALUE.SORT_DIRS, DEFAULT_VALUE.SEARCH_CRITERIA);
  };

  /**
   * Update selected all subscription item
   * @param {boolean} value
   */
  SubscribedInstances.prototype.selectAll = m.action(function (value) {
    forEach(function (item) {
      item.updateSelectedValue(value);
    }, this.activeInstances);
  });

  module.exports = SubscribedInstances;
}();

/***/ }),
/* 2009 */,
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 995,
	"./af.js": 995,
	"./ar": 996,
	"./ar-dz": 997,
	"./ar-dz.js": 997,
	"./ar-ly": 998,
	"./ar-ly.js": 998,
	"./ar-ma": 999,
	"./ar-ma.js": 999,
	"./ar-sa": 1000,
	"./ar-sa.js": 1000,
	"./ar-tn": 1001,
	"./ar-tn.js": 1001,
	"./ar.js": 996,
	"./az": 1002,
	"./az.js": 1002,
	"./be": 1003,
	"./be.js": 1003,
	"./bg": 1004,
	"./bg.js": 1004,
	"./bn": 1005,
	"./bn.js": 1005,
	"./bo": 1006,
	"./bo.js": 1006,
	"./br": 1007,
	"./br.js": 1007,
	"./bs": 1008,
	"./bs.js": 1008,
	"./ca": 1009,
	"./ca.js": 1009,
	"./cs": 1010,
	"./cs.js": 1010,
	"./cv": 1011,
	"./cv.js": 1011,
	"./cy": 1012,
	"./cy.js": 1012,
	"./da": 1013,
	"./da.js": 1013,
	"./de": 1014,
	"./de-at": 1015,
	"./de-at.js": 1015,
	"./de.js": 1014,
	"./dv": 1016,
	"./dv.js": 1016,
	"./el": 1017,
	"./el.js": 1017,
	"./en-au": 1018,
	"./en-au.js": 1018,
	"./en-ca": 1019,
	"./en-ca.js": 1019,
	"./en-gb": 1020,
	"./en-gb.js": 1020,
	"./en-ie": 1021,
	"./en-ie.js": 1021,
	"./en-nz": 1022,
	"./en-nz.js": 1022,
	"./eo": 1023,
	"./eo.js": 1023,
	"./es": 1024,
	"./es-do": 1025,
	"./es-do.js": 1025,
	"./es.js": 1024,
	"./et": 1026,
	"./et.js": 1026,
	"./eu": 1027,
	"./eu.js": 1027,
	"./fa": 1028,
	"./fa.js": 1028,
	"./fi": 1029,
	"./fi.js": 1029,
	"./fo": 1030,
	"./fo.js": 1030,
	"./fr": 1031,
	"./fr-ca": 1032,
	"./fr-ca.js": 1032,
	"./fr-ch": 1033,
	"./fr-ch.js": 1033,
	"./fr.js": 1031,
	"./fy": 1034,
	"./fy.js": 1034,
	"./gd": 1035,
	"./gd.js": 1035,
	"./gl": 1036,
	"./gl.js": 1036,
	"./he": 1037,
	"./he.js": 1037,
	"./hi": 1038,
	"./hi.js": 1038,
	"./hr": 1039,
	"./hr.js": 1039,
	"./hu": 1040,
	"./hu.js": 1040,
	"./hy-am": 1041,
	"./hy-am.js": 1041,
	"./id": 1042,
	"./id.js": 1042,
	"./is": 1043,
	"./is.js": 1043,
	"./it": 1044,
	"./it.js": 1044,
	"./ja": 1045,
	"./ja.js": 1045,
	"./jv": 1046,
	"./jv.js": 1046,
	"./ka": 1047,
	"./ka.js": 1047,
	"./kk": 1048,
	"./kk.js": 1048,
	"./km": 1049,
	"./km.js": 1049,
	"./ko": 1050,
	"./ko.js": 1050,
	"./ky": 1051,
	"./ky.js": 1051,
	"./lb": 1052,
	"./lb.js": 1052,
	"./lo": 1053,
	"./lo.js": 1053,
	"./lt": 1054,
	"./lt.js": 1054,
	"./lv": 1055,
	"./lv.js": 1055,
	"./me": 1056,
	"./me.js": 1056,
	"./mi": 1057,
	"./mi.js": 1057,
	"./mk": 1058,
	"./mk.js": 1058,
	"./ml": 1059,
	"./ml.js": 1059,
	"./mr": 1060,
	"./mr.js": 1060,
	"./ms": 1061,
	"./ms-my": 1062,
	"./ms-my.js": 1062,
	"./ms.js": 1061,
	"./my": 1063,
	"./my.js": 1063,
	"./nb": 1064,
	"./nb.js": 1064,
	"./ne": 1065,
	"./ne.js": 1065,
	"./nl": 1066,
	"./nl-be": 1067,
	"./nl-be.js": 1067,
	"./nl.js": 1066,
	"./nn": 1068,
	"./nn.js": 1068,
	"./pa-in": 1069,
	"./pa-in.js": 1069,
	"./pl": 1070,
	"./pl.js": 1070,
	"./pt": 1071,
	"./pt-br": 1072,
	"./pt-br.js": 1072,
	"./pt.js": 1071,
	"./ro": 1073,
	"./ro.js": 1073,
	"./ru": 1074,
	"./ru.js": 1074,
	"./se": 1075,
	"./se.js": 1075,
	"./si": 1076,
	"./si.js": 1076,
	"./sk": 1077,
	"./sk.js": 1077,
	"./sl": 1078,
	"./sl.js": 1078,
	"./sq": 1079,
	"./sq.js": 1079,
	"./sr": 1080,
	"./sr-cyrl": 1081,
	"./sr-cyrl.js": 1081,
	"./sr.js": 1080,
	"./ss": 1082,
	"./ss.js": 1082,
	"./sv": 1083,
	"./sv.js": 1083,
	"./sw": 1084,
	"./sw.js": 1084,
	"./ta": 1085,
	"./ta.js": 1085,
	"./te": 1086,
	"./te.js": 1086,
	"./tet": 1087,
	"./tet.js": 1087,
	"./th": 1088,
	"./th.js": 1088,
	"./tl-ph": 1089,
	"./tl-ph.js": 1089,
	"./tlh": 1090,
	"./tlh.js": 1090,
	"./tr": 1091,
	"./tr.js": 1091,
	"./tzl": 1092,
	"./tzl.js": 1092,
	"./tzm": 1093,
	"./tzm-latn": 1094,
	"./tzm-latn.js": 1094,
	"./tzm.js": 1093,
	"./uk": 1095,
	"./uk.js": 1095,
	"./uz": 1096,
	"./uz.js": 1096,
	"./vi": 1097,
	"./vi.js": 1097,
	"./x-pseudo": 1098,
	"./x-pseudo.js": 1098,
	"./yo": 1099,
	"./yo.js": 1099,
	"./zh-cn": 1100,
	"./zh-cn.js": 1100,
	"./zh-hk": 1101,
	"./zh-hk.js": 1101,
	"./zh-tw": 1102,
	"./zh-tw.js": 1102
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2010;

/***/ }),
/* 2011 */,
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemVariables.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var PagingModel = __webpack_require__(98);
  var constant = __webpack_require__(133).SYSTEM_VARIABLES;
  var DEFAULT_VALUE = constant.DEFAULT_VALUE;

  var _require = __webpack_require__(1),
      forEach = _require.forEach;

  var SystemVariable = __webpack_require__(2013);

  function SystemVariables() {
    var props = {
      pageInfo: new PagingModel(DEFAULT_VALUE.SORT_DIRS, null),
      variables: []
    };

    m.extendObservable(this, props);
  }

  /**
   * Populate data (Almost for fetching data from service).
   * @param  {object} data
   */
  SystemVariables.prototype.populateData = m.action(function (data) {
    data = data || {};
    this.variables.clear();

    forEach(function (item) {
      this.variables.push(new SystemVariable(item));
    }.bind(this), data.result);

    this.pageInfo.totalRecords = data.total;
    return (0, _bluebird.resolve)(true);
  });

  /**
   * Reset page model
   */
  SystemVariables.prototype.resetPageModel = m.action(function () {
    this.pageInfo = new PagingModel(DEFAULT_VALUE.SORT_DIRS, null);
    this.variables.clear();
  });

  module.exports = SystemVariables;
}();

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemVariable.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {

  var m = __webpack_require__(5);

  function SystemVariable(data) {

    var props = {
      id: null,
      name: null,
      dataType: null,
      description: null,
      scope: null
    };

    m.extendObservable(this, props);
    data && this.populate(data);
  };

  /**
   * Populate information.
   * @param {Object} data
   */
  SystemVariable.prototype.populate = m.action(function (data) {
    data = data || {};
    this.id = data.id;
    this.name = data.name;
    this.dataType = data.dataType;
    this.description = data.description;
    this.scope = data.scope;
  });

  module.exports = SystemVariable;
}();

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyViewerActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withProps = __webpack_require__(9).withProps;
  var PrintConstants = __webpack_require__(222);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      get = _require.get,
      curry = _require.curry;

  var actions = compose(withProps(function (props) {
    return {
      printingMode: get('location.query.print', props) === 'true' || props.printingMode && props.setting
    };
  }), withHandlers({
    getContainerStyle: curry(getContainerStyle),
    getContainerClassName: curry(getContainerClassName)
  }));

  /**
   * get config style for ReportBody container
   */
  function getContainerStyle(props, exportFormatSetting) {
    if (props.printingMode) {
      var pageSize = PrintConstants.getPageSize(exportFormatSetting.pageSizeKey, exportFormatSetting.orientation);
      return {
        height: PrintConstants.formatCSSValueInInches(pageSize.heightInInches),
        width: PrintConstants.formatCSSValueInInches(pageSize.widthInInches)
      };
    }

    return {};
  }

  /**
   * get config style for ReportBody container
   */
  function getContainerClassName(props, exportFormatSetting) {
    var centerOnPage = exportFormatSetting.centerOnPage;
    return classnames('izenda-ReportBodyViewer u-bgWhite', {
      'center-horizontal': props.printingMode && centerOnPage.horizontally,
      'center-vertical': props.printingMode && centerOnPage.vertically,
      u_fullSize: !props.printingMode,
      u_table: props.setting
    });
  }

  module.exports = actions;
}();

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(155);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  /**
   * get Function data from API
   * @method getFunctionData
   * @param  {int}        functionMode    Function Mode
   * @param  {string}        dataType     Izenda Data Type
   * @param  {string}        functionName Function name
   * @return {promise}                    Promise result filter object
   */
  getFunctionData: function getFunctionData(functionMode, dataType, functionName) {
    return _Izenda4.default.loadReportFunction(functionMode, dataType, _Izenda2.default.tenantId).then((0, _fp.flow)((0, _fp.find)({ name: functionName }), (0, _fp.defaults)({})));
  },
  /**
   * get format data from api
   * @method getFormatData
   * @param  {string}        dataType     Izenda Data Type
   * @param  {string}        functionName Function name
   * @return {promise}                    Promise result filter object
   */
  getFormatData: function getFormatData(dataType, formatName) {
    return _Izenda4.default.loadReportFieldDataFormat(dataType).then((0, _fp.flow)((0, _fp.find)({ format: formatName }), (0, _fp.defaults)({})));
  },

  /**
   * get format data from api
   * @method getFormatData
   * @param  {string}        dataType     Izenda Data Type
   * @param  {string}        functionName Function name
   * @return {promise}                    Promise result filter object
   */
  getFunction: function getFunction(functionMode, dataType) {
    return _Izenda4.default.loadReportFunction(functionMode, dataType, _Izenda2.default.tenantId);
  }
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerCommonDataUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Utils for commonDataStore
 */

module.exports = exports['default'];

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.FormDefaultConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  DefaultConfig: {
    Form: {
      DEFAULT_SORT: {
        columns: 'Unsorted'
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.LinearGauge.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      get = _require.get,
      isNumber = _require.isNumber,
      stop = _require.stop,
      tail = _require.tail,
      size = _require.size,
      getOr = _require.getOr,
      isNil = _require.isNil,
      isEmpty = _require.isEmpty;

  module.exports = function (H) {
    var CHART_SIZE_RATIO = 7;
    var PADDING = 10;
    var WIDTH = 500;
    var HEIGHT = 130;
    var UNIT_LENGTH = 20;

    var TICK_LENGTH = 3;
    var TICK_WIDTH = 1;
    var TICK_COLOR = '#fff';
    var OTHER_COLOR = '#ccc';
    var MAKER_COLOR = '#000';
    var MAKER_MIN_SIZE = 10;

    var BASE_CHART = 'column';
    var IZENDA_LINEAR_GAUGE = 'izendaLinearGauge';

    var defaultPlotOptions = H.getOptions().plotOptions,
        baseChart = H.seriesTypes[BASE_CHART],
        wrap = H.wrap,
        each = H.each;

    defaultPlotOptions[IZENDA_LINEAR_GAUGE] = H.merge(defaultPlotOptions[BASE_CHART], {});

    H.seriesTypes[IZENDA_LINEAR_GAUGE] = H.extendClass(baseChart, {
      type: IZENDA_LINEAR_GAUGE,

      drawPoints: function drawPoints() {
        var series = this,
            chart = this.chart,
            chartOptions = chart.options,
            chartType = chartOptions.chart.type,
            renderer = chart.renderer,
            makerSize = MAKER_MIN_SIZE,
            shapeArgs;

        if (chartType !== IZENDA_LINEAR_GAUGE) {
          return baseChart.prototype.drawPoints.apply(this, arguments);
        }

        // draw maker instead
        each(series.points, function (point) {
          var plotY = point.plotY,
              graphic = point.graphic;
          var markerY;

          if (isNumber(plotY) && point.y !== null) {
            shapeArgs = point.shapeArgs;

            markerY = -Math.min(chart.plotBox[get('chart.inverted', chartOptions) ? 'width' : 'height'], shapeArgs.height);

            if (graphic) {
              stop(graphic);
              // move to new position
              graphic.animate({
                translateX: makerSize / 3,
                translateY: markerY
              });
            } else {
              var startPointX = 0;
              var startPointY = point.plotY + shapeArgs.height;
              var baseX = startPointX - makerSize;
              var path = ['M', startPointX, startPointY, 'L', baseX, startPointY + makerSize / 2, baseX, startPointY - makerSize / 2];

              point.graphic = renderer.path(path).attr({
                fill: MAKER_COLOR,
                stroke: MAKER_COLOR
              }).add(series.markerGroup).animate({
                translateX: makerSize / 3,
                translateY: markerY
              });
            }
          } else if (graphic) {
            point.graphic = graphic.destroy();
          }
        });
      },

      alignDataLabel: function alignDataLabel(point, dataLabel, options, alignTo, isNew) {
        var pathWidth = getPathLengthByValue(this.chart, point.y);
        dataLabel = point.dataLabel;
        var plotSizeX = this.chart.plotSizeX;
        var plotSizeY = this.chart.plotSizeY;

        var dataLabelHeight = dataLabel.height + dataLabel.padding;
        var dataLabelWidth = dataLabel.width + dataLabel.padding;

        if (this.chart.options.chart.inverted) {
          alignTo = {
            x: plotSizeY - point.plotY - dataLabelWidth / 2,
            y: plotSizeX - pathWidth - dataLabel.height
          };

          if (alignTo.x + dataLabelWidth > plotSizeY) {
            alignTo.x = plotSizeY - dataLabelWidth;
          } else if (alignTo.x < 0) {
            alignTo.x = 0;
          }
        } else {
          alignTo = {
            x: pathWidth,
            y: Math.max(point.plotY - dataLabelHeight / 2, -dataLabelHeight / 2)
          };

          alignTo.height = plotSizeY - alignTo.y - 1;
        }

        H.Series.prototype.alignDataLabel.call(this, point, dataLabel, options, alignTo, isNew);
      }
    });

    /** override AXIS function **/
    wrap(H.Axis.prototype, 'getPlotLinePath', function (proceed, value) {
      var options = this.chart.options;
      var chartType = options.chart.type;
      var args = tail(arguments);
      var pathLine = proceed.apply(this, args);

      if (chartType === IZENDA_LINEAR_GAUGE) {
        return getLinearPath.call(this, value, pathLine);
      } else {
        return pathLine;
      }

      function getLinearPath(value, path) {
        var chart = this.chart;
        var pathLength = getPathLengthByValue(chart, value);

        if (this.horiz) {
          path[2] = path[5] - pathLength;
        } else {
          path[4] = path[1] + pathLength;
        }
        return path;
      }
    });

    function getPathLengthByValue(chart, value) {
      var izendaOptions = chart.options.izendaOptions;
      var valueRange = izendaOptions.scaleTo - izendaOptions.scaleFrom;
      var valueLength = getValue();
      var valueRatio = valueLength / valueRange;

      return Math.max(getBasedSize(), MAKER_MIN_SIZE) * valueRatio;

      function getBasedSize() {
        return Math.min(chart.plotSizeY / CHART_SIZE_RATIO, chart.plotSizeX);
      }

      function getValue() {
        if (value < izendaOptions.scaleFrom) {
          return 0;
        } else if (value > izendaOptions.scaleTo) {
          return valueRange;
        } else {
          return value - izendaOptions.scaleFrom;
        }
      }
    }

    /** OVERRIDE HIGHCHART FUNCTION **/
    wrap(H.Chart.prototype, 'init', function (proceed, userOptions, callback) {
      var izendaOptions = userOptions.izendaOptions || {};
      var isInverted = get('chart.inverted', userOptions);
      var chartType = userOptions.chart.type;

      if (chartType === IZENDA_LINEAR_GAUGE) {
        userOptions = H.merge(userOptions, {
          chart: getChartSize(isInverted),

          title: getTitleConfig(izendaOptions.showLabels, userOptions.title, isInverted),

          yAxis: {
            title: {
              enabled: true,
              text: getUnitText(izendaOptions.dataUnit),
              x: isInverted ? 0 : -5,
              margin: 0
            },
            plotBands: updatePlotBands(userOptions),
            labels: {
              style: {
                fontSize: '14px'
              }
            }
          },
          xAxis: {
            lineWidth: 0,
            tickLength: 0,
            labels: {
              enabled: false
            }
          }
        });
      }

      proceed.apply(this, [userOptions, callback]);

      function getUnitText(unitText) {
        unitText = unitText || '';
        return size(unitText) > UNIT_LENGTH ? unitText.substring(0, UNIT_LENGTH) + '...' : unitText;
      }

      function updatePlotBands(chartOptions) {
        var yAxis = chartOptions.yAxis || {};
        var plotBands = yAxis.plotBands;
        var min, max, value;

        if (!plotBands || !plotBands.length) {
          min = yAxis.min;
          max = yAxis.max;
          value = getOr(max + min / 2, 'series[0].data[0][y]', chartOptions);

          var color = isNil(chartOptions.colors) ? H.getOptions().colors[0] : isEmpty(chartOptions.colors) ? MAKER_COLOR : chartOptions.colors[0];
          return [{
            from: min,
            to: value,
            color: color
          }, {
            from: value,
            to: max,
            color: OTHER_COLOR
          }];
        }

        return plotBands;
      }

      function getTitleConfig(isShow, titleConfig, isInverted) {
        if (!isShow) {
          return $izenda.extend(titleConfig, {
            text: ''
          });
        }

        return $izenda.extend(titleConfig, {
          align: isInverted ? 'center' : 'left',
          verticalAlign: 'top',
          useHTML: true,
          text: String.format('<span style="width:{0}" class="overflow-text" title="{1}">{1}</span>', (isInverted ? WIDTH : HEIGHT) * 0.7, izendaOptions.serieName)
        });
      }

      function getChartSize(isInverted) {
        if (isInverted) {
          return {
            height: HEIGHT,
            width: WIDTH,
            margin: [PADDING * 2, PADDING, PADDING * 3, PADDING]
          };
        } else {
          return {
            height: WIDTH,
            width: HEIGHT + PADDING * 3,
            margin: [PADDING * 2, PADDING * 3, PADDING, PADDING * 4]
          };
        }
      }
    });

    wrap(H.Chart.prototype, 'getAxes', function (proceed) {
      var options = this.options;
      var izendaOptions = options.izendaOptions || {};
      var chartType = options.chart.type;
      var isInverted = get('chart.inverted', options);

      if (chartType === IZENDA_LINEAR_GAUGE) {
        this.options.xAxis = getXaxis(izendaOptions);
        this.options.yAxis = H.merge(this.options.yAxis, getYaxis(izendaOptions, this.options.yAxis, isInverted));
      }

      proceed.apply(this, tail(arguments));

      function getYaxis(izendaOptions, userOptionsYAxis, isInverted) {
        izendaOptions = izendaOptions || {};

        var min = izendaOptions.scaleFrom;
        var max = izendaOptions.scaleTo;
        var yAxis = {
          tickLength: TICK_LENGTH,
          tickWidth: TICK_WIDTH,
          tickColor: TICK_COLOR,
          gridLineColor: TICK_COLOR,
          gridLineWidth: TICK_WIDTH,
          minorTickInterval: 0,
          minorTickWidth: 0,
          minorGridLineWidth: 0,
          tickPositioner: getTickPostions
        };

        !isInverted && attachLabelFormatter(yAxis, userOptionsYAxis);

        return yAxis;

        function attachLabelFormatter(yAxis, userOptionsYAxis) {
          var oldFormatter = get('labels.formatter', userOptionsYAxis);
          yAxis.labels = {
            useHTML: true,
            formatter: function formatter() {
              return String.format('<span class="overflow-text" style="width:{0}px"><span title="{1}">{1}</span></span>', PADDING * 2, oldFormatter.apply(this, arguments));
            }
          };
        }

        function getTickPostions() {
          var axisLength = this.len;

          return isNumber(izendaOptions.intervals) ? getPositions(izendaOptions.intervals) : [min, max];

          function getPositions(interval) {
            var positions = [];
            var pos = min;
            var numTicks = Math.floor((max - min) / interval);
            var tickDistancePx = Math.floor(numTicks && axisLength / numTicks);

            if (interval < 0 || !numTicks || !tickDistancePx) {
              return [min, max];
            }

            if (tickDistancePx < 50) {
              return getPositions(Math.min(interval * 2, max - min));
            }

            while (pos + interval <= max) {
              positions.push(pos);
              pos += interval;
            }

            positions.push(max);

            return positions;
          }
        }
      }

      function getXaxis(userOptions) {
        return {
          lineWidth: 0,
          tickLength: 0,
          labels: {
            enabled: false
          }
        };
      }
    });
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleGauge.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      get = _require.get,
      last = _require.last,
      getOr = _require.getOr,
      truncate = _require.truncate,
      times = _require.times,
      inRange = _require.inRange,
      constant = _require.constant,
      toString = _require.toString;

  module.exports = function (H) {
    var PADDING = 10;
    var MIN_SIZE = 15;
    var MAX_CHARS = 10;
    var DEFAULT_MAX_CHARS = 0;
    var DEFAULT_BASED_FONT_SIZE = 0;

    var TEXT_COLOR = 'black';

    // This distance between name and value-unit in KPI container
    // var KPI_CENTRAL_DISTANCE = 10;

    var BASE_CHART_OPTS = 'pie';
    var IZENDA_CHART = 'izendaSimpleGauge';

    var defaultPlotOptions = H.getOptions().plotOptions,

    // baseChart = H.Series,
    baseChart = H.seriesTypes[BASE_CHART_OPTS],
        each = H.each;

    defaultPlotOptions[IZENDA_CHART] = H.merge(defaultPlotOptions[BASE_CHART_OPTS], {});

    H.seriesTypes[IZENDA_CHART] = H.extendClass(baseChart, {
      type: IZENDA_CHART,

      drawGraph: null,
      getSymbol: function getSymbol() {},
      searchPoint: function searchPoint() {},

      redraw: function redraw() {
        this.render();
      },

      translate: function translate() {
        this.generatePoints();
      },

      generatePoints: function generatePoints() {
        var series = this;
        var options = series.chart.options;
        var points = series.points = [];

        options.series.map(function (serie) {
          points.push(new series.pointClass(series, serie.data));
        });
      },

      drawPoint: function drawPoint(container, pointData) {
        var series = this;
        var chart = series.chart;
        var options = chart.options;
        var plotBox = chart.plotBox;
        var textColor = pointData.textColor || TEXT_COLOR;

        var serieNameContainer = chart.renderer.g('serie-name').add(container);
        var primaryContainer = chart.renderer.g('primary-kpi').add(container);
        var supKpiContainer = chart.renderer.g('sup-kpi').add(container);

        this.drawPointName(serieNameContainer, pointData, textColor);
        this.drawPrimaryKPI(primaryContainer, pointData, textColor);
        this.drawSupKPI(supKpiContainer, pointData, textColor);

        var primaryPosY = this.adjustPosition((plotBox.width - primaryContainer.getBBox().width) / 2 - PADDING, (chart.containerHeight - primaryContainer.getBBox().height) / 2 - primaryContainer.getBBox().y, primaryContainer);
        this.adjustPosition(primaryPosY.x, primaryPosY.y - serieNameContainer.getBBox().height + serieNameContainer.getBBox().y, serieNameContainer);

        var supKPIPosX = get('supplementaryKPI.name', pointData) === '' ? primaryPosY.x + primaryContainer.getBBox().width / 2 : primaryPosY.x;

        this.adjustPosition(supKPIPosX, primaryPosY.y - supKpiContainer.getBBox().y, supKpiContainer);

        // attack click event
        var onClick = get('chart.events.click', options);

        if (onClick) {
          container.element && $izenda(container.element).css({ cursor: 'pointer' }).on('click', onClick);
        }
      },

      adjustPosition: function adjustPosition(startPosX, startPosY, element) {
        element.attr({
          transform: ['translate(', Math.max(startPosX, 0), ',', Math.max(startPosY, 0), ')'].join('')
        });

        return { x: startPosX, y: startPosY };
      },

      addText: function addText(style, fontSize, content, container, maxChars) {
        maxChars = maxChars || this.maxChars;
        var adjustedText = this.adjustText(content, maxChars);
        var renderer = this.chart.renderer;

        return renderer.text(adjustedText).css($izenda.extend(style, {
          fontSize: fontSize + 'px'
        })).add(container).attr({
          title: content
        });
      },

      drawPointName: function drawPointName(container, pointData, textColor) {
        var titleSize = this.getTitleSize();
        var chart = this.chart;
        var options = chart.options;

        if (!get('izendaOptions.showLabels', options)) {
          // do not draw point name
          return;
        }

        this.addText({
          color: textColor
        }, titleSize.fontSize, pointData.serieName, container, this.maxChars * 3);
      },

      containerWidth: function containerWidth(container) {
        return container.getBBox().width;
      },

      drawPrimaryKPI: function drawPrimaryKPI(container, pointData, textColor) {
        var primarySize = this.getPrimarySize();
        var style = H.extend({
          color: textColor,
          fontSize: primarySize.unitFontSize + 'px'
        }, pointData.style);

        var primary = this.addText($izenda.extend({}, style, this.getColorByThreshold(pointData.y, textColor)), primarySize.fontSize, this.getFormattedData(pointData.y, pointData), container);

        var primaryUnit = this.addText(style, primarySize.unitFontSize, ' ' + pointData.unit, container);

        // move unit after value
        primaryUnit.attr({
          transform: ['translate(', primary.getBBox().width, ',', 0, ')'].join('')
        });
      },

      getColorByThreshold: function getColorByThreshold(value, defaultColor) {
        var series = this;
        var chart = series.chart;
        var options = chart.options || {};
        var izendaOptions = options.izendaOptions || {};
        var threshold = izendaOptions.threshold || [];
        var index = 0;

        while (index < threshold.length) {
          if (inRange(threshold[index].from, threshold[index].to, value)) {
            break;
          }
          index++;
        }

        if (value === get('to', last(threshold))) {
          index = threshold.length - 1;
        }

        return {
          color: getOr(defaultColor, 'color', threshold[index] || {})
        };
      },

      drawSupKPI: function drawSupKPI(container, pointData, textColor) {
        var supSize = this.getSupSize();
        var supplementaryKPIData = pointData.supplementaryKPI || {};

        var style = $izenda.extend({
          color: textColor
        }, supplementaryKPIData.style, {
          fontSize: supSize.fontSize + 'px'
        });

        var supKpi = this.addText(style, supSize.fontSize, supplementaryKPIData.name, container, this.maxChars * 3 / 2);

        var supKpiUnit = this.addText(style, supSize.fontSize, [this.getFormattedData(supplementaryKPIData.value, supplementaryKPIData), supplementaryKPIData.unit].join(' '), container, this.maxChars * 3 / 2);

        supKpiUnit.attr({
          transform: ['translate(', supKpi.getBBox().width + PADDING, ',', 0, ')'].join('')
        });
      },

      getFormattedData: function getFormattedData(value, valueInfo) {
        return toString(valueInfo.dataFormatter ? valueInfo.dataFormatter(value, valueInfo.record) : value);
      },

      adjustText: function adjustText(text, maxChars) {
        if (!text) {
          return '';
        }

        text = text.toString().trim();
        return truncate({ length: maxChars }, text);
      },

      findFontSize: function findFontSize(maxChars) {
        var chart = this.chart;
        var basedFontSize = 0;

        var tempString = times(constant('x'), maxChars).join('');

        do {
          basedFontSize++;
          var stringGraphic = chart.renderer.text(tempString).css({
            fontSize: basedFontSize + 'px'
          }).add();
          var stringGraphicBBox = stringGraphic.getBBox();
          stringGraphic.destroy();
        } while (stringGraphicBBox.width < chart.chartWidth - 2 * PADDING && stringGraphicBBox.height < chart.chartHeight - PADDING);

        return basedFontSize;
      },

      getTitleSize: function getTitleSize() {
        return {
          fontSize: this.basedFontSize / 3,
          maxChars: this.maxChars
        };
      },

      getPrimarySize: function getPrimarySize() {
        return {
          fontSize: this.basedFontSize,
          maxChars: this.maxChars,
          unitFontSize: this.basedFontSize / 3
        };
      },

      getSupSize: function getSupSize() {
        return {
          fontSize: this.basedFontSize / 3,
          maxChars: 3
        };
      },

      render: function render() {
        var series = this;
        var chart = series.chart;
        var data = get('series[0].data[0]', chart.options);
        var graphic;

        var basedInfo = caculateBasedSize.call(this, chart);

        this.basedFontSize = basedInfo.basedFontSize;
        this.maxChars = basedInfo.maxChars;

        // draw point
        each(series.points, function (point) {
          graphic = point.graphic;

          if (graphic) {
            return;
          }

          point.graphic = chart.renderer.g('simple-gauge').add(chart.seriesGroup);
          this.drawPoint(point.graphic, data);
        }.bind(this));

        function caculateBasedSize(chart) {
          var plotWidth = chart.plotSizeX;
          var plotHeight = chart.plotSizeY;
          var basedFontSize, maxChars;

          if (plotWidth < MIN_SIZE || plotHeight < MIN_SIZE) {
            return {
              basedFontSize: DEFAULT_BASED_FONT_SIZE,
              maxChars: DEFAULT_MAX_CHARS
            };
          }

          maxChars = MAX_CHARS;
          basedFontSize = this.findFontSize(maxChars);

          return {
            basedFontSize: basedFontSize,
            maxChars: maxChars
          };
        }
      }
    });
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Regression;

var _fp = __webpack_require__(1);

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda = __webpack_require__(33);

var _Izenda2 = __webpack_require__(176);

var _Izenda3 = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build regression line.
 * @param {Object} Highcharts Hightcharts object
 */
function Regression(Highcharts) {
  var linearType = 'linear';
  var categoryType = 'category';
  var datetimeType = 'datetime';
  var baseStep = 1;
  var period = baseStep;
  var minDistance = baseStep;

  var axisTypes = [{
    key: linearType,
    accept: function accept(source) {
      return !(0, _fp.isNil)(source) && !(0, _fp.isDate)(source.x) && !(0, _fp.isUndefined)(source.x);
    },
    getXLabel: function getXLabel(source) {
      return source.x;
    },
    nextStep: function nextStep(data, step, count) {
      return data[data.length - 1][0] + (count - data.length + 1) * step;
    }
  }, {
    key: categoryType,
    accept: function accept(source) {
      return !(0, _fp.isNil)(source) && !(0, _fp.isDate)(source.x) && (0, _fp.isUndefined)(source.x);
    },
    getXLabel: function getXLabel(source) {
      return source.xRawData;
    },
    nextStep: function nextStep(data, step, count) {
      return data[data.length - 1][0] + (count - data.length + 1) * step;
    }
  }, {
    key: datetimeType,
    accept: function accept(source) {
      return !(0, _fp.isNil)(source) && (0, _fp.isDate)(source.x) && !(0, _fp.isUndefined)(source.x);
    },
    getXLabel: function getXLabel(source) {
      return source.x;
    },
    nextStep: function nextStep(data, step, count, intervalKey) {
      var stepBasedOnIntervalKey = baseStep;
      var durationStepInMS = _moment2.default.duration(step, 'ms');
      switch (intervalKey) {
        case _Izenda2.DATE_TIME_FORMAT['Qtr'].INTERVAL_VALUE:
        case _Izenda2.DATE_TIME_FORMAT['yyyy - Qtr'].INTERVAL_VALUE:
          var monthsInAQuarter = 3;
          stepBasedOnIntervalKey = Math.round(durationStepInMS.as('M') / monthsInAQuarter);
          break;

        default:
          stepBasedOnIntervalKey = durationStepInMS.as(intervalKey);
          break;
      }
      return Date.parse((0, _moment2.default)(data[data.length - 1]['x']).add((count - data.length + 1) * stepBasedOnIntervalKey, intervalKey));
    }
  }];

  var processSerie = function processSerie(s) {
    if (s.regression && !s.rendered) {
      s.regressionSettings = s.regressionSettings || {};
      s.regressionSettings.tooltip = s.regressionSettings.tooltip || {};
      s.regressionSettings.dashStyle = s.regressionSettings.dashStyle || 'solid';
      s.regressionSettings.decimalPlaces = s.regressionSettings.decimalPlaces || 2;
      s.regressionSettings.useAllSeries = s.regressionSettings.useAllSeries || false;

      var regressionType = s.regressionSettings.type || 'linear';

      var regression = void 0;
      var extraSerie = {
        data: [],
        color: s.regressionSettings.color || '',
        yAxis: s.yAxis,
        lineWidth: s.regressionSettings.lineWidth || 2,
        marker: { enabled: false },
        isRegressionLine: true,
        visible: s.regressionSettings.visible,
        type: s.regressionSettings.linetype || 'spline',
        name: s.regressionSettings.name || 'Equation: %eq',
        id: s.regressionSettings.id,
        dashStyle: s.regressionSettings.dashStyle || 'solid',
        showInLegend: !s.regressionSettings.hideInLegend,
        tooltip: {
          valueSuffix: s.regressionSettings.tooltip.valueSuffix || ' '
        },
        extrapolate: s.regressionSettings.extrapolate || 0,
        xAxisField: s.xAxisField,
        yAxisField: s.yAxisField,
        colorByPoint: false
      };

      var mergedData = s.data;
      if (s.regressionSettings.useAllSeries) {
        mergedData = [];
        for (var di = 0; di < series.length; di++) {
          var seriesToMerge = series[di];
          mergedData = mergedData.concat(seriesToMerge.data);
        }
      }

      mergedData = numberingData(mergedData);

      if (regressionType === 'linear' && extraSerie.extrapolate === 0) {
        regression = _linear(mergedData, s.regressionSettings.decimalPlaces);
        extraSerie.type = 'line';
      } else if (regressionType === 'exponential') {
        regression = _exponential(mergedData, s.regressionSettings.decimalPlaces);
      } else if (regressionType === 'polynomial' || regressionType === 'linear' && extraSerie.extrapolate > 0) {
        var order = s.regressionSettings.order || 2;
        regressionType === 'linear' && (order = 1);
        var reportPartElm = s.xAxisField.reportPartElm;
        var fieldFormatData = reportPartElm.fieldFormatData || (0, _fp.get)('format', reportPartElm.getValueByKey('format'));
        var intervalKey = (0, _fp.get)('INTERVAL_VALUE', _Izenda2.DATE_TIME_FORMAT[fieldFormatData]);
        regression = _polynomial(mergedData, order, extraSerie.extrapolate, s.regressionSettings.decimalPlaces, intervalKey);
      } else if (regressionType === 'logarithmic') {
        regression = _logarithmic(mergedData, s.regressionSettings.decimalPlaces);
      }

      regression.rSquared = coefficientOfDetermination(mergedData, regression.points);
      regression.rValue = Math.sqrt(regression.rSquared).toFixed(s.regressionSettings.decimalPlaces);
      regression.rSquared = regression.rSquared.toFixed(s.regressionSettings.decimalPlaces);
      regression.standardError = standardError(mergedData, regression.points).toFixed(s.regressionSettings.decimalPlaces);
      extraSerie.data = regression.points;
      extraSerie.name = extraSerie.name.replace('%r2', regression.rSquared);
      extraSerie.name = extraSerie.name.replace('%r', regression.rValue);
      extraSerie.name = extraSerie.name.replace('%eq', regression.string);
      extraSerie.name = extraSerie.name.replace('%se', regression.standardError);
      extraSerie.regressionOutputs = regression;

      return extraSerie;
    }
  };

  Highcharts.wrap(Highcharts.Chart.prototype, 'init', function (proceed) {
    var originsSeries = arguments[1].series;

    var chartType = (0, _fp.get)('sort.chartType', arguments[1]);
    var extraSeries = [];
    var extrapolateCategoryCount = 0;
    resetStep();
    var series = (0, _fp.cloneDeep)(originsSeries);
    series = parseData(series, chartType);
    for (var i = 0; i < series.length; i++) {
      var s = series[i];
      if (shouldCalculateRegression(s, chartType)) {
        var extraSerie = processSerie(s);
        if (extraSerie) {
          extraSeries.push(extraSerie);
          extrapolateCategoryCount = Math.max(extraSerie.extrapolate, extrapolateCategoryCount);
        }
        arguments[1].series[i].rendered = true;
      }
    }

    if (extraSeries.length > 0) {
      arguments[1].series = originsSeries.concat(extraSeries);

      if (!(0, _fp.isNil)(arguments[1].xAxis.categories)) {
        var extrapolateCategories = new Array(extrapolateCategoryCount);
        extrapolateCategories = (0, _fp.fill)(0, extrapolateCategories.length, '', extrapolateCategories);
        arguments[1].xAxis.categories = arguments[1].xAxis.categories.concat(extrapolateCategories);
      }
    }

    proceed.apply(this, Array.prototype.slice.call(arguments, 1));
  });

  Highcharts.wrap(Highcharts.Chart.prototype, 'addSeries', function (proceed) {
    var s = arguments[1];
    resetStep();
    var extraSerie = processSerie(s);
    arguments[1].rendered = true;
    if (extraSerie) {
      this.addSeries(extraSerie);
    }
    proceed.apply(this, Array.prototype.slice.call(arguments, 1));
  });

  /**
   * Prepare data for bubble/scatter
   * @param {Array<Object>} series
   * @param {string} type
   */
  function parseData(series, type) {
    if ((0, _fp.isNil)(type) || (0, _fp.isEmpty)(series) || !(0, _fp.isArray)(series) || !(0, _Izenda3.isChartType)(type, _Izenda.CHART_TYPE.Bubble, _Izenda.CHART_TYPE.Scatter)) return series;
    return (0, _fp.flow)((0, _fp.groupBy)(function (s) {
      return s.nameFieldName;
    }), (0, _fp.map)(function (g) {
      var data = (0, _fp.flow)((0, _fp.flatMap)(function (s) {
        return s.data;
      }), (0, _fp.reduce)(function (result, items) {
        return (0, _fp.concat)(result, items);
      }, []), (0, _fp.map)(function (item) {
        return (0, _fp.pick)(['name', 'record', 'x', 'xRawData', 'y', 'yRawData', 'z'], item);
      }), (0, _fp.uniqBy)(function (r) {
        return r.x;
      }), (0, _fp.sortBy)(function (r) {
        return r.x;
      }))(g);

      g[0].data = data;
      return g[0];
    }))(series);
  }

  /**
   * Resolve axis type
   * @param {Object} record
   */
  function getAxisType(record) {
    return (0, _fp.find)(function (type) {
      return type.accept(record);
    }, axisTypes);
  }

  /**
   * Check if should calculate regression line
   * @param {Object} serie
   */
  function shouldCalculateRegression(serie, type) {
    return !(0, _fp.isNil)(type) && ((0, _Izenda3.isChartType)(type, _Izenda.CHART_TYPE.Bubble, _Izenda.CHART_TYPE.Scatter) || (0, _fp.get)('length', serie.data) > 1 && (0, _Izenda3.isChartType)(type, _Izenda.CHART_TYPE.Line, _Izenda.CHART_TYPE.Column, _Izenda.CHART_TYPE.Bar, _Izenda.CHART_TYPE.Area, _Izenda.CHART_TYPE.Combination));
  }

  /**
   * Calculate distance between 2 points on x axis.
   * @param {Object} operand1
   * @param {Object} operand2
   */
  function calculateDistance(operand1, operand2) {
    var matchingType = getAxisType(operand1);
    if (matchingType.key === categoryType) return baseStep;
    return operand2.x - operand1.x;
  }

  /**
   * Numbering x value to build regression line for nonnumeric data
   * @param {Array<Object>} data
   */
  function numberingData(data) {
    if ((0, _fp.isEmpty)(data) || !(0, _fp.isArray)(data)) return data;
    var distances = [];
    var step = Math.pow(2, 53) - 1; // Number.MAX_SAFE_INTEGER
    for (var i = 1; i < data.length; i++) {
      var distance = calculateDistance(data[i - 1], data[i]);
      distances.push({ index: i, distance: distance });
      step = Math.min(step, distance);
    }

    data[0].tempX = 1;
    for (var j = 0; j < distances.length; j++) {
      data[distances[j].index].tempX = data[distances[j].index - 1].tempX + distances[j].distance / step;
    }

    if (!(0, _fp.isEmpty)(distances)) {
      minDistance = step;
      period = distances[distances.length - 1].distance;
    }
    return data;
  }

  /**
   * Reset step setting.
   */
  function resetStep() {
    period = baseStep;
    minDistance = baseStep;
  }

  /**
   * Resolve xAxis value to calculating
   * @param {Object} record
   */
  function xValue(record) {
    return (0, _fp.isNumber)(record.x) ? record.x : record.tempX;
  }

  /**
   * Resolve xAxis value for highcharts' series
   * @param {Object} record
   */
  function xLabel(record) {
    if ((0, _fp.isNil)(record)) return undefined;
    var matchingType = getAxisType(record);
    return matchingType.getXLabel(record);
  }

  /**
   * Check whether it is category type.
   * @param {Object} record
   */
  function isCategoryType(record) {
    var matchingType = getAxisType(record);
    return matchingType.key === categoryType;
  }

  /**
   * Compare two values
   * @param {Object} operand1
   * @param {Object} operand2
   */
  function compare(operand1, operand2) {
    if (operand1[0] > operand2[0]) {
      return 1;
    }
    if (operand1[0] < operand2[0]) {
      return -1;
    }
    return 0;
  }

  /**
   * Build exponential regression detail
   * @param {Array<Object>} data
   * @param {Number} decimalPlaces
   */
  function _exponential(data, decimalPlaces) {
    var sum = [0, 0, 0, 0, 0, 0],
        results = [];

    for (var len = data.length, n = 0; n < len; n++) {
      if (!(0, _fp.isNil)(xLabel(data[n]))) {
        data[n][0] = xValue(data[n]);
        data[n][1] = data[n].y;
      }
      if (data[n][1] != null) {
        sum[0] += data[n][0];
        sum[1] += data[n][1];
        sum[2] += data[n][0] * data[n][0] * data[n][1];
        sum[3] += data[n][1] * Math.log(data[n][1]);
        sum[4] += data[n][0] * data[n][1] * Math.log(data[n][1]);
        sum[5] += data[n][0] * data[n][1];
      }
    }

    var denominator = sum[1] * sum[2] - sum[5] * sum[5];
    var A = Math.pow(Math.E, (sum[2] * sum[3] - sum[5] * sum[4]) / denominator);
    var B = (sum[1] * sum[4] - sum[5] * sum[3]) / denominator;

    var categoryType = isCategoryType(data[0]);
    for (var i = 0, _len = data.length; i < _len; i++) {
      var coordinateY = A * Math.pow(Math.E, B * data[i][0]);
      if (decimalPlaces) coordinateY = parseFloat(coordinateY.toFixed(decimalPlaces));
      var coordinate = categoryType ? coordinateY : { x: xLabel(data[i]), y: coordinateY };
      results.push(coordinate);
    }

    var fnValue = 'y = ' + Math.round(A * 100) / 100 + 'e^(' + Math.round(B * 100) / 100 + 'x)';
    return { equation: [A, B], points: results, string: fnValue };
  }

  /**
   * Build linear regression detail
   * @param {Array<Object>} data
   * @param {Number} decimalPlaces
   */
  function _linear(data, decimalPlaces) {
    var sum = [0, 0, 0, 0, 0],
        results = [],
        N = data.length;

    for (var n = 0; n < data.length; n++) {
      if (!(0, _fp.isNil)(xLabel(data[n]))) {
        data[n][0] = xValue(data[n]);
        data[n][1] = data[n].y;
      }
      if (data[n][1] != null) {
        sum[0] += data[n][0];
        sum[1] += data[n][1];
        sum[2] += data[n][0] * data[n][0];
        sum[3] += data[n][0] * data[n][1];
        sum[4] += data[n][1] * data[n][1];
      } else {
        N -= 1;
      }
    }

    var gradient = (N * sum[3] - sum[0] * sum[1]) / (N * sum[2] - sum[0] * sum[0]);
    var intercept = sum[1] / N - gradient * sum[0] / N;
    var categoryType = isCategoryType(data[0]);

    for (var i = 0, len = data.length; i < len; i++) {
      var coordinateY = data[i][0] * gradient + intercept;
      if (decimalPlaces) coordinateY = parseFloat(coordinateY.toFixed(decimalPlaces));
      var coordinate = categoryType ? coordinateY : { x: xLabel(data[i]), y: coordinateY };
      results.push(coordinate);
    }

    var fnValue = 'y = ' + Math.round(gradient * 100) / 100 + 'x + ' + Math.round(intercept * 100) / 100;
    return {
      equation: [gradient, intercept],
      points: results,
      string: fnValue
    };
  }

  /**
   * Build logarithmic regression detail
   * @param {Array<Object>} data
   * @param {Number} decimalPlaces
   */
  function _logarithmic(data, decimalPlaces) {
    var sum = [0, 0, 0, 0],
        n = 0,
        results = [];

    for (var len = data.length; n < len; n++) {
      if (!(0, _fp.isNil)(xLabel(data[n]))) {
        data[n][0] = xValue(data[n]);
        data[n][1] = data[n].y;
      }
      if (data[n][1] != null) {
        sum[0] += Math.log(data[n][0]);
        sum[1] += data[n][1] * Math.log(data[n][0]);
        sum[2] += data[n][1];
        sum[3] += Math.pow(Math.log(data[n][0]), 2);
      }
    }

    var B = (n * sum[1] - sum[2] * sum[0]) / (n * sum[3] - sum[0] * sum[0]);
    var A = (sum[2] - B * sum[0]) / n;
    var categoryType = isCategoryType(data[0]);

    for (var i = 0, _len2 = data.length; i < _len2; i++) {
      var coordinateY = A + B * Math.log(data[i][0]);
      if (decimalPlaces) coordinateY = parseFloat(coordinateY.toFixed(decimalPlaces));
      var coordinate = categoryType ? coordinateY : { x: xLabel(data[i]), y: coordinateY };
      results.push(coordinate);
    }

    var fnValue = 'y = ' + Math.round(A * 100) / 100 + ' + ' + Math.round(B * 100) / 100 + ' ln(x)';
    return { equation: [A, B], points: results, string: fnValue };
  }

  /**
   * Build polynomial regression detail
   * @param {Array<Object>} data
   * @param {Number} order
   * @param {Number} extrapolate
   * @param {Number} decimalPlaces
   * @param {String} intervalKey
   */
  function _polynomial(data, order, extrapolate, decimalPlaces, intervalKey) {
    if ((0, _fp.isUndefined)(order)) {
      order = 2;
    }
    var lhs = [],
        rhs = [],
        results = [],
        a = 0,
        b = 0,
        k = order + 1;

    for (var i = 0; i < k; i++) {
      for (var l = 0, len = data.length; l < len; l++) {
        if (!(0, _fp.isNil)(xLabel(data[l]))) {
          data[l][0] = xValue(data[l]);
          data[l][1] = data[l].y;
        }
        if (data[l][1] != null) {
          a += Math.pow(data[l][0], i) * data[l][1];
        }
      }
      lhs.push(a);
      a = 0;
      var c = [];
      for (var j = 0; j < k; j++) {
        for (var _l = 0, _len3 = data.length; _l < _len3; _l++) {
          if (data[_l][1]) {
            b += Math.pow(data[_l][0], i + j);
          }
        }
        c.push(b);
        b = 0;
      }
      rhs.push(c);
    }
    rhs.push(lhs);

    var equation = gaussianElimination(rhs, k);
    var resultLength = data.length + extrapolate;
    var matchingType = getAxisType(data[0]);
    var firstXValue = data[0]['x'];
    for (var m = 0, _len4 = resultLength; m < _len4; m++) {
      var answer = 0;
      var x = 0;
      var xExtrapolate = void 0;
      if (typeof data[m] !== 'undefined') {
        x = data[m][0];
        xExtrapolate = x;
      } else {
        x = matchingType.nextStep(data, period, m, intervalKey);
        matchingType.key === datetimeType && (x = new Date(x));
        xExtrapolate = matchingType.key === datetimeType ? (x - firstXValue) / minDistance + 1 : x;
      }

      for (var w = 0; w < equation.length; w++) {
        answer += equation[w] * Math.pow(xExtrapolate, w);
      }

      if (decimalPlaces) answer = parseFloat(answer.toFixed(decimalPlaces));
      switch (matchingType.key) {
        case linearType:
          results.push([xLabel(data[m]) || x, answer]);
          break;
        case categoryType:
          results.push([answer]);
          break;
        case datetimeType:
          results.push({ x: xLabel(data[m]) || x, y: answer });
          break;
      }
    }

    var fnValue = 'y = ';
    for (var n = equation.length - 1; n >= 0; n--) {
      if (n > 1) fnValue += Math.round(equation[n] * 100) / 100 + 'x^' + n + ' + ';else if (n === 1) fnValue += Math.round(equation[n] * 100) / 100 + 'x + ';else fnValue += Math.round(equation[n] * 100) / 100;
    }

    return { equation: equation, points: results, string: fnValue };
  }

  /**
   * Calculate gaussian elimination
   * @param {Array<Object>} data
   * @param {Number} order
   */
  function gaussianElimination(data, order) {
    var i = 0,
        j = 0,
        k = 0,
        maxrow = 0,
        tmp = 0,
        n = data.length - 1,
        x = new Array(order);
    for (i = 0; i < n; i++) {
      maxrow = i;
      for (j = i + 1; j < n; j++) {
        if (Math.abs(data[i][j]) > Math.abs(data[i][maxrow])) maxrow = j;
      }
      for (k = i; k < n + 1; k++) {
        tmp = data[k][i];
        data[k][i] = data[k][maxrow];
        data[k][maxrow] = tmp;
      }
      for (j = i + 1; j < n; j++) {
        for (k = n; k >= i; k--) {
          data[k][j] -= data[k][i] * data[i][j] / data[i][i];
        }
      }
    }
    for (j = n - 1; j >= 0; j--) {
      tmp = 0;
      for (k = j + 1; k < n; k++) {
        tmp += data[k][j] * x[k];
      }x[j] = (data[n][j] - tmp) / data[j][j];
    }
    return x;
  }

  /**
   * Resolve predicted's Y
   * @param {Object} predictPoint
   */
  function resolveYPred(predictPoint) {
    return !(0, _fp.isUndefined)(predictPoint[1]) ? predictPoint[1] : !(0, _fp.isUndefined)(predictPoint['y']) ? predictPoint['y'] : predictPoint;
  }

  /**
   * Calculate coefficient of determination
   * @param {Array<Object>} data
   * @param {Array<Object>} pred
   */
  function coefficientOfDetermination(data, pred) {
    // Sort the initial data { pred array (model's predictions) is sorted  }
    // The initial data must be sorted in the same way in order to calculate the coefficients
    data.sort(compare);

    // Calc the mean
    var mean = 0;
    var N = data.length;
    for (var i = 0; i < data.length; i++) {
      if (data[i][1] != null) {
        mean += data[i][1];
      } else {
        N--;
      }
    }
    mean /= N;

    // Calc the coefficent of determination
    var SSE = 0;
    var SSYY = 0;
    var predY = void 0;
    for (var _i = 0; _i < data.length; _i++) {
      if (data[_i][1] != null) {
        predY = resolveYPred(pred[_i]);
        SSYY += Math.pow(data[_i][1] - predY, 2);
        SSE += Math.pow(data[_i][1] - mean, 2);
      }
    }
    return 1 - SSYY / SSE;
  }

  /**
   * Calculate standard error
   * @param {Array<Object>} data
   * @param {Array<Object>} pred
   */
  function standardError(data, pred) {
    var SE = 0,
        N = data.length,
        predY = void 0;

    for (var i = 0; i < data.length; i++) {
      if (data[i][1] != null) {
        predY = predY = resolveYPred(pred[i]);
        SE += Math.pow(data[i][1] - predY, 2);
      } else {
        N--;
      }
    }
    SE = Math.sqrt(SE / (N - 2));

    return SE;
  }
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.HighchartRegression.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// based on https://github.com/streamlinesocial/highcharts-regression
// https://github.com/Tom-Alexander/regression-js/

module.exports = exports['default'];

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LineChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  module.exports = function (Highcharts) {

    var BASE_CHART = 'line';
    var IZENDA_CHART_NAME = 'izendaLine';
    var seriesTypes = Highcharts.seriesTypes;
    var defaultOptions = Highcharts.getOptions();
    var extend = Highcharts.extend;
    var extendClass = Highcharts.extendClass;

    /**
     * Extend the default options with LINE options
     */
    defaultOptions.plotOptions[IZENDA_CHART_NAME] = Highcharts.merge(defaultOptions.plotOptions[BASE_CHART], {});

    // Define izendaLine series type
    seriesTypes[IZENDA_CHART_NAME] = extendClass(seriesTypes[BASE_CHART], {
      type: IZENDA_CHART_NAME,
      izendaOptions: {
        spline: false
      },

      /**
       * Override the init method to use line or spline chart type
       */
      init: function init(chart, data) {

        var izendaOptions = chart.options.izendaOptions || {};

        if (izendaOptions.spline) {
          // extend spline chart type
          extend(this, new seriesTypes.spline());
          return seriesTypes.spline.prototype.init.apply(this, arguments);
        }

        return seriesTypes[BASE_CHART].prototype.init.apply(this, arguments);
      }
    });
  };
}();

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AreaChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      sortBy = _require.sortBy;

  module.exports = function (Highcharts) {
    var BASE_CHART = 'area';
    var IZENDA_CHART_NAME = 'izendaArea';

    var seriesTypes = Highcharts.seriesTypes;
    var defaultOptions = Highcharts.getOptions();
    var extend = Highcharts.extend;
    var extendClass = Highcharts.extendClass;

    /**
     * Extend the default options with AREA options
     */
    defaultOptions.plotOptions[IZENDA_CHART_NAME] = Highcharts.merge(defaultOptions.plotOptions[BASE_CHART], {});

    // Define izendaArea series type
    seriesTypes[IZENDA_CHART_NAME] = extendClass(seriesTypes[BASE_CHART], {
      type: IZENDA_CHART_NAME,
      izendaOptions: {
        spline: false
      },
      /**
       * Override the init method to use area or areaspline chart type
       */
      init: function init(chart, data) {

        var izendaOptions = chart.options.izendaOptions || {};

        if (izendaOptions.spline) {
          // extend spline chart type
          extend(this, new seriesTypes.areaspline());
          return seriesTypes.areaspline.prototype.init.apply(this, arguments);
        }

        return seriesTypes[BASE_CHART].prototype.init.apply(this, arguments);
      },

      /**
       * Override getStackPoints method
       * Highcharts area bug - for x-axis type = datetime, value of x is sorted by STRING
       * should be sort by datetime
       */
      getStackPoints: function getStackPoints(chart, data) {
        var stacks = seriesTypes[BASE_CHART].prototype.getStackPoints.apply(this, arguments);

        return sortBy(function (point) {
          return point.x; // sort by its data type > can be numberic or datetime
        }, stacks);
      }
    });
  };
}();

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.AutoResizedChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      get = _require.get;

  module.exports = function (H) {
    var MIN_SIZE = 15;

    /** OVERRIDE HIGHCHART FUNCTION **/
    H.wrap(H.Chart.prototype, 'init', function (proceed, userOptions, callback) {
      userOptions.chart = userOptions.chart || {};

      var chartOptions = get('chart', userOptions);

      var containerWidth = this.renderTo.offsetWidth;
      var containerHeight = this.renderTo.offsetHeight;

      if (!chartOptions.width && !chartOptions.height && Math.min(containerWidth, containerHeight) <= MIN_SIZE) {
        // container is too small >> do not draw chart
        $izenda(this.renderTo).empty().append('<i class="icon-chart-bar">');
        callback && callback.apply(this, arguments);
        return;
      }

      if (get('izendaOptions.fillContainer', userOptions)) {
        var width = get('chart.width', userOptions);
        var height = get('chart.height', userOptions);

        !width && (userOptions.chart.width = containerWidth);
        !height && (userOptions.chart.height = containerHeight);

        return proceed.call(this, userOptions, callback);
      }

      if (!get('izendaOptions.autoResized', userOptions)) {
        return proceed.call(this, userOptions, callback);
      }

      proceed.call(this, userOptions, function (chart) {
        var chartContainer = chart.container;
        var afterChartHeight = chartContainer.offsetHeight;
        var afterChartWidth = chartContainer.offsetWidth;

        var widthRatio = containerWidth / afterChartWidth;
        var heightRatio = containerHeight / afterChartHeight;
        var ratio = Math.min(widthRatio, heightRatio);

        var transform = String.format('scale({0}, {0})', ratio);
        var transformOrigin = String.format('{0} 0%', containerWidth >= afterChartWidth ? '50%' : '0%');

        // We must set this transform style directly by this way because when printing, 
        // the jQuery set the CSS using webkit prefix because the headless browser EvoPdf need it
        // but if we open the HTML file in IE, the browser can't understand webkit so no transform CSS is apply
        var cssText = chart.container.style.cssText;
        chart.container.setAttribute('style', cssText + ' \n          transform: ' + transform + '; transform-origin: ' + transformOrigin + ';\n          -webkit-transform: ' + transform + '; -webkit-transform-origin: ' + transformOrigin + ';\n          -moz-transform: ' + transform + '; -moz-transform-origin: ' + transformOrigin + ';\n          -o-transform: ' + transform + '; -o-transform-origin: ' + transformOrigin + ';');

        callback && callback.apply(this, arguments);
      });

      function adjustChartSize(chartSize) {
        var CHART_SIZE_MIN = 100;
        var basedSize = Math.min(chartSize.width, chartSize.height);
        var scaleRatio = basedSize < CHART_SIZE_MIN ? CHART_SIZE_MIN / basedSize : 1;

        chartSize.width = chartSize.width * scaleRatio;
        chartSize.height = chartSize.height * scaleRatio;
      }
    });

    /** OVERRIDE DRAW CHART DATA VALUES **/
    H.wrap(H.Series.prototype, 'drawDataLabels', function (proceed) {
      proceed.apply(this, arguments);

      var series = this,
          seriesOptions = series.options,
          options = seriesOptions.dataLabels,
          points = series.points;

      points.forEach(function (point) {
        var dataLabel = point.dataLabel;

        if (!dataLabel) {
          return;
        }

        var element = dataLabel.element;
        var attrs = options.getData && options.getData.apply(point.getLabelConfig());

        if (get('isKeepDataInMultiLevel', attrs)) {
          $izenda(element).attr($izenda.extend(attrs, {
            class: $izenda('<div>' + dataLabel.textStr + '</div>').find('a').attr('class')
          }));
          return;
        }

        $izenda(element).attr($izenda.extend(attrs, {
          class: options.className
        }));
      });
    });
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof2 = __webpack_require__(150);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * EXPERIMENTAL Highcharts module to place labels next to a series in a natural position.
 *
 * TODO:
 * this is code from https://cdnjs.cloudflare.com/ajax/libs/highcharts/4.2.7/modules/series-label.src.js
 * this is a extention of highchart to show the label for series
 * but this lib has error for Donut, Sparkline, Funel, Pie. So we have to fix that.
 * We will remove this file and apply the official version of extention series-label when we upgrade the highchart to ^= 6.0.0 so the isssue will be fixed.
 */
/* eslint indent: [2, 4] */
(function (factory) {
    if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
        module.exports = factory;
    } else {
        factory(Highcharts);
    }
})(function (H) {

    var labelDistance = 3,
        wrap = H.wrap,
        each = H.each,
        extend = H.extend,
        isNumber = H.isNumber,
        Series = H.Series,
        SVGRenderer = H.SVGRenderer,
        Chart = H.Chart;

    var _require = __webpack_require__(1),
        get = _require.get,
        includes = _require.includes,
        size = _require.size;

    H.setOptions({
        plotOptions: {
            series: {
                label: {
                    enabled: true,
                    // Allow labels to be placed distant to the graph if necessary, and
                    // draw a connector line to the graph
                    connectorAllowed: true,
                    connectorNeighbourDistance: 24, // If the label is closer than this to a neighbour graph, draw a connector
                    styles: {
                        fontWeight: 'bold'
                        // boxesToAvoid: []
                    } }
            }
        }
    });

    /**
     * Counter-clockwise, part of the fast line intersection logic
     */
    function ccw(x1, y1, x2, y2, x3, y3) {
        var cw = (y3 - y1) * (x2 - x1) - (y2 - y1) * (x3 - x1);
        return cw > 0 ? true : cw < 0 ? false : true;
    }

    /**
     * Detect if two lines intersect
     */
    function intersectLine(x1, y1, x2, y2, x3, y3, x4, y4) {
        return ccw(x1, y1, x3, y3, x4, y4) !== ccw(x2, y2, x3, y3, x4, y4) && ccw(x1, y1, x2, y2, x3, y3) !== ccw(x1, y1, x2, y2, x4, y4);
    }

    /**
     * Detect if a box intersects with a line
     */
    function boxIntersectLine(x, y, w, h, x1, y1, x2, y2) {
        return intersectLine(x, y, x + w, y, x1, y1, x2, y2) || // top of label
        intersectLine(x + w, y, x + w, y + h, x1, y1, x2, y2) || // right of label
        intersectLine(x, y + h, x + w, y + h, x1, y1, x2, y2) || // bottom of label
        intersectLine(x, y, x, y + h, x1, y1, x2, y2) // left of label
        ;
    }

    /**
     * General symbol definition for labels with connector
     */
    SVGRenderer.prototype.symbols.connector = function (x, y, w, h, options) {
        var anchorX = options && options.anchorX,
            anchorY = options && options.anchorY,
            path,
            yOffset,
            lateral = w / 2;

        if (isNumber(anchorX) && isNumber(anchorY)) {

            path = ['M', anchorX, anchorY];

            // Prefer 45 deg connectors
            yOffset = y - anchorY;
            if (yOffset < 0) {
                yOffset = -h - yOffset;
            }
            if (yOffset < w) {
                lateral = anchorX < x + w / 2 ? yOffset : w - yOffset;
            }

            // Anchor below label
            if (anchorY > y + h) {
                path.push('L', x + lateral, y + h);

                // Anchor above label
            } else if (anchorY < y) {
                path.push('L', x + lateral, y);

                // Anchor left of label
            } else if (anchorX < x) {
                path.push('L', x, y + h / 2);

                // Anchor right of label
            } else if (anchorX > x + w) {
                path.push('L', x + w, y + h / 2);
            }
        }
        return path || [];
    };

    /**
     * Points to avoid. In addition to actual data points, the label should avoid
     * interpolated positions.
     */
    Series.prototype.getPointsOnGraph = function () {
        var distance = 16,
            points = this.points,
            point,
            last,
            interpolated = [],
            i,
            deltaX,
            deltaY,
            delta,
            len,
            n,
            j,
            d,
            graph = this.graph || this.area,
            node = graph.element,
            inverted = this.chart.inverted,
            paneLeft = inverted ? this.yAxis.pos : this.xAxis.pos,
            paneTop = inverted ? this.xAxis.pos : this.yAxis.pos;

        // For splines, get the point at length (possible caveat: peaks are not correctly detected)
        if (this.getPointSpline && node.getPointAtLength) {
            // If it is animating towards a path definition, use that briefly, and reset
            if (graph.toD) {
                d = graph.attr('d');
                graph.attr({ d: graph.toD });
            }
            len = node.getTotalLength();
            for (i = 0; i < len; i += distance) {
                point = node.getPointAtLength(i);
                interpolated.push({
                    chartX: paneLeft + point.x,
                    chartY: paneTop + point.y,
                    plotX: point.x,
                    plotY: point.y
                });
            }
            if (d) {
                graph.attr({ d: d });
            }
            // Last point
            point = points[points.length - 1];
            point.chartX = paneLeft + point.plotX;
            point.chartY = paneTop + point.plotY;
            interpolated.push(point);

            // Interpolate
        } else {
            len = points.length;
            for (i = 0; i < len; i += 1) {

                point = points[i];
                last = points[i - 1];

                // Absolute coordinates so we can compare different panes
                point.chartX = paneLeft + point.plotX;
                point.chartY = paneTop + point.plotY;

                // Add interpolated points
                if (i > 0) {
                    deltaX = Math.abs(point.chartX - last.chartX);
                    deltaY = Math.abs(point.chartY - last.chartY);
                    delta = Math.max(deltaX, deltaY);
                    if (delta > distance) {

                        n = Math.ceil(delta / distance);

                        for (j = 1; j < n; j += 1) {
                            interpolated.push({
                                chartX: last.chartX + (point.chartX - last.chartX) * (j / n),
                                chartY: last.chartY + (point.chartY - last.chartY) * (j / n),
                                plotX: last.plotX + (point.plotX - last.plotX) * (j / n),
                                plotY: last.plotY + (point.plotY - last.plotY) * (j / n)
                            });
                        }
                    }
                }

                // Add the real point in order to find positive and negative peaks
                if (isNumber(point.plotY)) {
                    interpolated.push(point);
                }
            }
        }
        return interpolated;
    };

    /**
     * Check whether a proposed label position is clear of other elements
     */
    Series.prototype.checkClearPoint = function (x, y, bBox, checkDistance) {
        var distToOthersSquared = Number.MAX_VALUE,
            // distance to other graphs
        distToPointSquared = Number.MAX_VALUE,
            dist,
            connectorPoint,
            connectorEnabled = this.options.label.connectorAllowed,
            chart = this.chart,
            series,
            points,
            leastDistance = 16,
            withinRange,
            i,
            j;

        function intersectRect(r1, r2) {
            return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
        }

        /**
         * Get the weight in order to determine the ideal position. Larger distance to
         * other series gives more weight. Smaller distance to the actual point (connector points only)
         * gives more weight.
         */
        function getWeight(distToOthersSquared, distToPointSquared) {
            return distToOthersSquared - distToPointSquared;
        }

        // First check for collision with existing labels
        for (i = 0; i < chart.boxesToAvoid.length; i += 1) {
            if (intersectRect(chart.boxesToAvoid[i], {
                left: x,
                right: x + bBox.width,
                top: y,
                bottom: y + bBox.height
            })) {
                return false;
            }
        }

        // For each position, check if the lines around the label intersect with any of the
        // graphs
        for (i = 0; i < chart.series.length; i += 1) {
            series = chart.series[i];
            points = series.interpolatedPoints;
            if (series.visible && points) {
                for (j = 1; j < points.length; j += 1) {
                    // If any of the box sides intersect with the line, return
                    if (boxIntersectLine(x, y, bBox.width, bBox.height, points[j - 1].chartX, points[j - 1].chartY, points[j].chartX, points[j].chartY)) {
                        return false;
                    }

                    // But if it is too far away (a padded box doesn't intersect), also return
                    if (this === series && !withinRange && checkDistance) {
                        withinRange = boxIntersectLine(x - leastDistance, y - leastDistance, bBox.width + 2 * leastDistance, bBox.height + 2 * leastDistance, points[j - 1].chartX, points[j - 1].chartY, points[j].chartX, points[j].chartY);
                    }

                    // Find the squared distance from the center of the label
                    if (this !== series) {
                        distToOthersSquared = Math.min(distToOthersSquared, Math.pow(x + bBox.width / 2 - points[j].chartX, 2) + Math.pow(y + bBox.height / 2 - points[j].chartY, 2), Math.pow(x - points[j].chartX, 2) + Math.pow(y - points[j].chartY, 2), Math.pow(x + bBox.width - points[j].chartX, 2) + Math.pow(y - points[j].chartY, 2), Math.pow(x + bBox.width - points[j].chartX, 2) + Math.pow(y + bBox.height - points[j].chartY, 2), Math.pow(x - points[j].chartX, 2) + Math.pow(y + bBox.height - points[j].chartY, 2));
                    }
                }

                // Do we need a connector?
                if (connectorEnabled && this === series && (checkDistance && !withinRange || distToOthersSquared < Math.pow(this.options.label.connectorNeighbourDistance, 2))) {
                    for (j = 1; j < points.length; j += 1) {
                        dist = Math.min(Math.pow(x + bBox.width / 2 - points[j].chartX, 2) + Math.pow(y + bBox.height / 2 - points[j].chartY, 2), Math.pow(x - points[j].chartX, 2) + Math.pow(y - points[j].chartY, 2), Math.pow(x + bBox.width - points[j].chartX, 2) + Math.pow(y - points[j].chartY, 2), Math.pow(x + bBox.width - points[j].chartX, 2) + Math.pow(y + bBox.height - points[j].chartY, 2), Math.pow(x - points[j].chartX, 2) + Math.pow(y + bBox.height - points[j].chartY, 2));
                        if (dist < distToPointSquared) {
                            distToPointSquared = dist;
                            connectorPoint = points[j];
                        }
                    }
                    withinRange = true;
                }
            }
        }

        return !checkDistance || withinRange ? {
            x: x,
            y: y,
            weight: getWeight(distToOthersSquared, connectorPoint ? distToPointSquared : 0),
            connectorPoint: connectorPoint
        } : false;
    };

    /**
     * The main initiator method that runs on chart level after initiation and redraw. It runs in
     * a timeout to prevent locking, and loops over all series, taking all series and labels into
     * account when placing the labels.
     */
    function drawLabels(proceed) {
        var chart = this;
        proceed.call(chart);
        clearTimeout(chart.seriesLabelTimer);

        chart.seriesLabelTimer = setTimeout(function () {

            chart.boxesToAvoid = [];

            // Build the interpolated points
            if (size(chart.series) <= 0) {
                return;
            }

            chart.series;
            each(chart.series, function (series) {
                var options = series.options.label;
                if (options.enabled && series.visible && (series.graph || series.area)) {
                    series.interpolatedPoints = series.getPointsOnGraph();

                    each(options.boxesToAvoid || [], function (box) {
                        chart.boxesToAvoid.push(box);
                    });
                }
            });

            each(chart.series, function (series) {
                var yPos = get('yAxis.pos', series);
                var xPos = get('xAxis.pos', series);
                var yLen = get('yAxis.len', series);
                var xLen = get('xAxis.len', series);
                var bBox,
                    x,
                    y,
                    results = [],
                    clearPoint,
                    i,
                    best,
                    inverted = chart.inverted,
                    paneLeft = inverted ? yPos : xPos,
                    paneTop = inverted ? xPos : yPos,
                    paneWidth = chart.inverted ? yLen : xLen,
                    paneHeight = chart.inverted ? xLen : yLen,
                    points = series.interpolatedPoints;

                function insidePane(x, y, bBox) {
                    return x > paneLeft && x <= paneLeft + paneWidth - bBox.width && y >= paneTop && y <= paneTop + paneHeight - bBox.height;
                }

                if (series.visible && points) {

                    if (!series.labelBySeries) {
                        series.labelBySeries = chart.renderer.label(series.name, 0, -9999, 'connector').css(extend({
                            color: series.color
                        }, series.options.label.styles)).attr({
                            padding: 0,
                            opacity: 0,
                            stroke: series.color,
                            'stroke-width': 1
                        }).add(series.group).animate({ opacity: 1 }, { duration: 200 });
                    }

                    bBox = series.labelBySeries.getBBox();
                    bBox.width = Math.round(bBox.width);

                    // Ideal positions are centered above or below a point on right side of chart
                    for (i = points.length - 1; i > 0; i -= 1) {

                        // Right - up
                        x = points[i].chartX + labelDistance;
                        y = points[i].chartY - bBox.height - labelDistance;
                        if (insidePane(x, y, bBox)) {
                            best = series.checkClearPoint(x, y, bBox);
                        }
                        if (best) {
                            results.push(best);
                        }

                        // Right - down
                        x = points[i].chartX + labelDistance;
                        y = points[i].chartY + labelDistance;
                        if (insidePane(x, y, bBox)) {
                            best = series.checkClearPoint(x, y, bBox);
                        }
                        if (best) {
                            results.push(best);
                        }

                        // Left - down
                        x = points[i].chartX - bBox.width - labelDistance;
                        y = points[i].chartY + labelDistance;
                        if (insidePane(x, y, bBox)) {
                            best = series.checkClearPoint(x, y, bBox);
                        }
                        if (best) {
                            results.push(best);
                        }

                        // Left - up
                        x = points[i].chartX - bBox.width - labelDistance;
                        y = points[i].chartY - bBox.height - labelDistance;
                        if (insidePane(x, y, bBox)) {
                            best = series.checkClearPoint(x, y, bBox);
                        }
                        if (best) {
                            results.push(best);
                        }
                    }

                    // Brute force, try all positions on the chart in a 16x16 grid
                    if (!results.length) {
                        for (x = paneLeft + paneWidth - bBox.width; x >= paneLeft; x -= 16) {
                            for (y = paneTop; y < paneTop + paneHeight - bBox.height; y += 16) {
                                clearPoint = series.checkClearPoint(x, y, bBox, true);
                                if (clearPoint) {
                                    results.push(clearPoint);
                                }
                            }
                        }
                    }

                    if (results.length) {

                        results.sort(function (a, b) {
                            return b.weight - a.weight;
                        });

                        best = results[0];

                        chart.boxesToAvoid.push({
                            left: best.x,
                            right: best.x + bBox.width,
                            top: best.y,
                            bottom: best.y + bBox.height
                        });

                        // Move it if needed
                        if (Math.round(best.x) !== Math.round(series.labelBySeries.x) || Math.round(best.y) !== Math.round(series.labelBySeries.y)) {
                            series.labelBySeries.attr({
                                x: best.x - paneLeft,
                                y: best.y - paneTop,
                                anchorX: best.connectorPoint && best.connectorPoint.plotX,
                                anchorY: best.connectorPoint && best.connectorPoint.plotY,
                                opacity: 0
                            }).animate({ opacity: 1 });
                        }
                    } else if (series.labelBySeries) {
                        series.labelBySeries = series.labelBySeries.destroy();
                    }
                }
            });
        }, 350);
    }

    wrap(Chart.prototype, 'render', drawLabels);
    wrap(Chart.prototype, 'redraw', drawLabels);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(137)(module)))

/***/ }),
/* 2024 */,
/* 2025 */,
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2027);

__webpack_require__(2038);

__webpack_require__(2064);

__webpack_require__(2065);

__webpack_require__(2066);

__webpack_require__(2068);

__webpack_require__(2069);

__webpack_require__(2070);

__webpack_require__(2072);

__webpack_require__(2074);

__webpack_require__(2076);

__webpack_require__(2078);

__webpack_require__(2080);

__webpack_require__(2081);

__webpack_require__(2083);

__webpack_require__(2085);

__webpack_require__(2086);

__webpack_require__(2091);

__webpack_require__(2092);

__webpack_require__(2100);

__webpack_require__(2102);

__webpack_require__(2104);

__webpack_require__(2105);

__webpack_require__(2113);

__webpack_require__(2114);

__webpack_require__(2115);

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(53);

var _Izenda2 = __webpack_require__(39);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(542);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(224);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2028);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2032);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2036);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2037);

var _Izenda16 = _interopRequireDefault(_Izenda15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTitle = function createTitle(key) {
  return {
    key: key,
    mode: _Izenda.REPORT_PART_MODE.CONFIG,
    component: _Izenda8.default
  };
};

// Field container components

// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldContainerRegistration.js"
// company="Izenda">  Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var createXAxis = function createXAxis(key, _ref) {
  var axisName = _ref.axisName,
      axisCustomName = _ref.axisCustomName,
      maximumField = _ref.maximumField;
  return createContainer(key, {
    dataKey: 'labels',
    label: axisCustomName ? axisCustomName : String.format(_Izenda4.default.getText('REPORTDESIGNER_LABEL_X_AXIS_NAME'), axisName),
    maximumField: maximumField
  });
};

var createYAxis = function createYAxis(key, _ref2) {
  var axisName = _ref2.axisName,
      axisCustomName = _ref2.axisCustomName,
      maximumField = _ref2.maximumField;
  return createContainer(key, {
    dataKey: 'values',
    label: axisCustomName ? axisCustomName : String.format(_Izenda4.default.getText('REPORTDESIGNER_LABEL_Y_AXIS_NAME'), axisName),
    maximumField: maximumField
  });
};

var createChartYAxisMetrics = function createChartYAxisMetrics(key) {
  return {
    key: key,
    label: _Izenda4.default.getText('REPORTDESIGNER_LABEL_Y_AXIS_VALUES'),
    component: _Izenda10.default
  };
};

var createGaugeYAxisMetrics = function createGaugeYAxisMetrics(key) {
  return {
    key: key,
    label: _Izenda4.default.getText('REPORTDESIGNER_LABEL_Y_AXIS_VALUES'),
    component: _Izenda12.default
  };
};

var createValuesLabels = function createValuesLabels(key, _ref3) {
  var maximumField = _ref3.maximumField;
  return createContainer(key, {
    dataKey: 'valuesLabels',
    label: _Izenda2.LABEL_TEXT.valueLabel,
    maximumField: maximumField
  });
};

var createBubbleSize = function createBubbleSize(key, _ref4) {
  var maximumField = _ref4.maximumField;
  return createContainer(key, {
    dataKey: 'bubbleSize',
    label: _Izenda2.LABEL_TEXT.bubble,
    maximumField: maximumField
  });
};

var createSeparators = function createSeparators(key, _ref5) {
  var maximumField = _ref5.maximumField;
  return createContainer(key, {
    dataKey: 'separators',
    label: _Izenda4.default.getText('REPORTDESIGNER_LABEL_SEPARATORS'),
    maximumField: maximumField
  });
};

var createTotalLabel = function createTotalLabel(key, containerSchema) {
  return {
    key: key,
    label: _Izenda4.default.getText('REPORTDESIGNER_LABEL_TOTAL_LABEL'),
    component: _Izenda14.default
  };
};

var createStaticLabel = function createStaticLabel(key, _ref6) {
  var containerKey = _ref6.containerKey,
      label = _ref6.label;
  return {
    key: containerKey,
    label: label,
    component: _Izenda16.default
  };
};

var createContainer = function createContainer(key, _ref7) {
  var containerKey = _ref7.containerKey,
      label = _ref7.label,
      dataKey = _ref7.dataKey,
      height = _ref7.height,
      maximumField = _ref7.maximumField,
      isHorizontal = _ref7.isHorizontal;
  return {
    key: containerKey || key,
    label: label,
    dataKey: dataKey,
    height: height,
    maximumField: maximumField,
    isHorizontal: isHorizontal
  };
};

(function () {
  _Izenda6.default.register('chart_title', createTitle);
  _Izenda6.default.register('chart_xaxis', createXAxis);
  _Izenda6.default.register('chart_yaxis', createYAxis);
  _Izenda6.default.register('chart_yaxisMetrics', createChartYAxisMetrics);
  _Izenda6.default.register('gauge_yaxisMetrics', createGaugeYAxisMetrics);
  _Izenda6.default.register('chart_valuesLabels', createValuesLabels);
  _Izenda6.default.register('chart_bubbleSize', createBubbleSize);
  _Izenda6.default.register('chart_separators', createSeparators);
  _Izenda6.default.register('chart_totalLabel', createTotalLabel);
  _Izenda6.default.register('staticLabel', createStaticLabel);
  _Izenda6.default.register('container', createContainer);
})();

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartYAxisMetricsContainer.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(377);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2029);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartYAxisMetricsContainer = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(ChartYAxisMetricsContainer, _Component);

  function ChartYAxisMetricsContainer() {
    (0, _classCallCheck3.default)(this, ChartYAxisMetricsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (ChartYAxisMetricsContainer.__proto__ || (0, _getPrototypeOf2.default)(ChartYAxisMetricsContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChartYAxisMetricsContainer, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var label = props.label;
      var localization = props.localization;
      var reportPart = props.reportPart;
      var reportPartContent = reportPart.reportPartContent;
      var chartType = (0, _fp.get)('reportPart.reportPartContent.chartType', props);

      return _react2.default.createElement(
        _Izenda2.default,
        { label: label, reportPart: reportPart },
        _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({}, props, { type: chartType }))
      );
    }
  }]);
  return ChartYAxisMetricsContainer;
}(_react.Component)) || _class;

exports.default = ChartYAxisMetricsContainer;
module.exports = exports['default'];

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartYAxisMetrics.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(1105);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2030);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAXIMUM_METRICS = 5;

var ChartYAxisMetrics = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(ChartYAxisMetrics, _Component);

  function ChartYAxisMetrics(props) {
    (0, _classCallCheck3.default)(this, ChartYAxisMetrics);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChartYAxisMetrics.__proto__ || (0, _getPrototypeOf2.default)(ChartYAxisMetrics)).call(this, props));

    var reportPart = props.reportPart;
    var container = reportPart.reportPartContent && reportPart.reportPartContent.values;

    var dataSource = [];
    container.elements.forEach(function (field) {
      dataSource.push(field);
    });

    _this.state = {
      dataSource: (0, _fp.isEmpty)(dataSource) ? [{}] : dataSource
    };
    return _this;
  }

  (0, _createClass3.default)(ChartYAxisMetrics, [{
    key: 'render',
    value: function render() {
      var state = this.state || {};
      var props = this.props;
      var type = props.type;
      var reportPart = props.reportPart;
      var itemProps = (0, _fp.pick)(['reportPart', 'store'], props);
      var container = reportPart.reportPartContent && reportPart.reportPartContent.values;

      (0, _assign2.default)(itemProps, {
        onDeleteElement: handleDeleteElement,
        onAddElement: handleAddElement,
        onUpdateElement: handleUpdateElement,
        type: type,
        canDelete: state.dataSource.length > 1
      });

      return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({
        maximumMetrics: MAXIMUM_METRICS,
        dataSource: this.state.dataSource,
        onAddMetric: addYAxisItem.bind(this),
        onDeleteMetric: deleteYAxisItem.bind(this),
        itemComponent: _Izenda4.default
      }, itemProps));

      function handleDeleteElement(index, deleteElementId) {
        var deletedElement = (0, _fp.find)({ fieldId: deleteElementId }, container.elements);

        reportPart.removeFieldFromContainer(container, deletedElement);
        state.dataSource[index] = {};
      }

      function handleAddElement(newElement, index) {
        var dataSource = state.dataSource;
        // the newElement is created by virtual container so it's position is always 1, update it to the right position
        newElement.position = index + 1;
        if (index === dataSource.length - 1) {
          // insert field at the end of array
          return reportPart.commonInsertField(newElement.fieldName, newElement, container).then(updateDataSource);
        } else {
          // insert field in the middle
          return reportPart.commonInsertField(newElement.fieldName, newElement, container, index + 1).then(updateDataSource);
        }

        function updateDataSource(element) {
          dataSource[index] = element;
          return element;
        }
      }

      function handleUpdateElement(element, index) {
        container.elements[index] = element;
      }

      function addYAxisItem() {
        this.state.dataSource.push({});
        this.setState({
          dataSource: this.state.dataSource
        });
      }

      function deleteYAxisItem(index) {
        index < container.elements.length && reportPart.removeFieldFromContainer(container, container.elements[index]);
        this.state.dataSource.splice(index, 1);
        this.setState({
          dataSource: this.state.dataSource
        });
      }
    }
  }]);
  return ChartYAxisMetrics;
}(_react.Component)) || _class;

exports.default = ChartYAxisMetrics;
module.exports = exports['default'];

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartYAxisMetricItem.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(29);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(306);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2031);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda9 = __webpack_require__(2);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(33);

var _Izenda12 = __webpack_require__(39);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHART_DEFAULT_SETTING = _Izenda13.default.CHART_SETTINGS.DEFAULT_VALUE;
var OTHER_PROPS_KEY = _Izenda13.default.CHART_SETTINGS.OTHER_PROPS_KEY;
var isChartType = _Izenda13.default.isChartType;
var ChartYAxisMetricItem = (_dec = (0, _Izenda10.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ChartYAxisMetricItem, _Component);

  function ChartYAxisMetricItem(props) {
    (0, _classCallCheck3.default)(this, ChartYAxisMetricItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChartYAxisMetricItem.__proto__ || (0, _getPrototypeOf2.default)(ChartYAxisMetricItem)).call(this, props));

    _this.toggleSetting = function () {
      _this.setState({ showSetting: !_this.state.showSetting });
    };

    _this.handleCloseSetting = function (value) {
      value && _this.setSettings(value);
      _this.toggleSetting();
    };

    _this.state = { showSetting: false, element: _this.props.value };
    return _this;
  }

  (0, _createClass3.default)(ChartYAxisMetricItem, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ element: nextProps.value });
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var localization = props.localization;
      var type = props.type;
      var element = this.state.element;
      var elementProps = element && element.properties;
      var isCombinationStyle = isChartType(type, _Izenda11.CHART_TYPE.Combination);
      var dropDownProps = isCombinationStyle ? _Izenda13.default.COMBINE_CHART.CHART_TYPE_DROPDOWN : _Izenda13.default.SPARK_LINE_CHART.CHART_TYPE_DROPDOWN;
      var chartType = elementProps && elementProps.getOtherProps && elementProps.getOtherProps(OTHER_PROPS_KEY.chartType) || dropDownProps.value;
      var container = { elements: (0, _fp.isEmpty)(element) ? [] : [element], name: 'values' };

      var settings = {};
      if (elementProps && elementProps.getOtherProps) {
        settings = {
          dashStyle: elementProps.getOtherProps(OTHER_PROPS_KEY.dashStyle) || CHART_DEFAULT_SETTING.DASH_STYLE,
          lineWidth: elementProps.getOtherProps(OTHER_PROPS_KEY.lineWidth) || CHART_DEFAULT_SETTING.WIDTH
        };
      }

      var isColumnStyle = isChartType(chartType, _Izenda11.CHART_TYPE.Column);
      var settingDisabled = (0, _classnames2.default)({
        'disabled-elm': (0, _fp.isEmpty)(element) || isColumnStyle
      });

      var containerProps = (0, _fp.omit)(['onDeleteElement', 'onAddElement'], props);

      return _react2.default.createElement(
        'div',
        { className: 'yaxis-combination' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'label',
            { className: 'col-md-4' },
            localization.getText('COMMON_LABEL_VALUE')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({}, containerProps, {
              onDeleteElement: handleDeleteElement.bind(this),
              onAddElement: handleAddElement.bind(this),
              container: container,
              height: 40,
              showPlaceHolder: false,
              resizable: false,
              maximumField: 1
            }))
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'label',
            { className: 'col-md-4' },
            localization.getText('COMMON_LABEL_CHART_TYPE')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(
              'div',
              { className: 'metric-dropdown-container' },
              _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, dropDownProps, {
                disabled: (0, _fp.isEmpty)(element),
                onChange: handleChartTypeChanged.bind(this),
                value: chartType
              }))
            )
          )
        ),
        this.renderShowTotal(),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'label',
            { className: 'col-md-4' },
            localization.getText('REPORTDESIGNER_LABEL_SETTINGS')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(
              'a',
              { className: settingDisabled, onClick: this.toggleSetting },
              _react2.default.createElement('span', { className: 'icon-setting' })
            )
          )
        ),
        _react2.default.createElement(_Izenda8.default, {
          showSetting: this.state.showSetting,
          onClosed: this.handleCloseSetting,
          title: getSettingDialogTitle(chartType, localization),
          value: settings
        })
      );

      function getSettingDialogTitle(chartType, localization) {
        var chartTitle = '';

        var isLineStyle = isChartType(chartType, _Izenda11.CHART_TYPE.Line);
        var isAreaStyle = isChartType(chartType, _Izenda11.CHART_TYPE.Area);
        if (isLineStyle) {
          chartTitle = localization.getText('REPORTDESIGNER_LABEL_CHART_LINE');
        } else if (isAreaStyle) {
          chartTitle = localization.getText('REPORTDESIGNER_LABEL_CHART_AREA');
        }

        return [chartTitle, localization.getText('REPORTDESIGNER_LABEL_CHART_SETTINGS')].join(' ');
      }

      function handleChartTypeChanged(newVal) {
        elementProps && elementProps.setOtherProps && elementProps.setOtherProps(OTHER_PROPS_KEY.chartType, newVal.value);
        props.onUpdateElement && props.onUpdateElement(element, props.index);
        this.setState({ element: element });
      }

      function handleDeleteElement(deletedElement) {
        props.onDeleteElement && props.onDeleteElement(props.index, deletedElement.fieldId);
        this.setState({ element: {} });
      }

      function handleAddElement(newElement) {
        var _this2 = this;

        return props.onAddElement && props.onAddElement(newElement, props.index).then(function (newElement) {
          _this2.setState({
            element: newElement
          });
          return null;
        });
      }
    }
  }, {
    key: 'renderShowTotal',
    value: function renderShowTotal() {
      var props = this.props;
      var localization = props.localization;
      var element = this.state.element;
      var elementProps = element && element.properties || {};
      var type = this.props.type;
      var isCombinationStyle = isChartType(type, _Izenda11.CHART_TYPE.Combination);
      if (isCombinationStyle) return null;

      var otherProps = (0, _fp.isFunction)(elementProps.getOtherProps) && elementProps.getOtherProps();
      return _react2.default.createElement(
        'div',
        { className: 'row show-total' },
        _react2.default.createElement(
          'label',
          { className: 'col-md-4' },
          localization.getText('REPORTDESIGNER_LABEL_SHOW_TOTAL')
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-8' },
          _react2.default.createElement(_Izenda6.default, {
            type: 'checkbox',
            disabled: (0, _fp.isEmpty)(element),
            checked: otherProps && otherProps.showTotal,
            onChange: _EventUtils2.default.notifyChange(handleChange.bind(this), _EventUtils2.default.CHECKBOX)
          })
        )
      );

      function handleChange(value) {
        elementProps && elementProps.setOtherProps && elementProps.setOtherProps(OTHER_PROPS_KEY.showTotal, value);
        props.onUpdateElement && props.onUpdateElement(element, props.index);
        this.setState({ element: element });
      }
    }
  }, {
    key: 'setSettings',
    value: function setSettings(value) {
      var props = this.props;
      var element = this.state.element;
      var elementProps = element && element.properties;
      if (elementProps && elementProps.setOtherProps) {
        elementProps.setOtherProps(OTHER_PROPS_KEY.dashStyle, value.dashStyle);
        elementProps.setOtherProps(OTHER_PROPS_KEY.lineWidth, value.lineWidth);
      }
      props.onUpdateElement && props.onUpdateElement(element, props.index);
      this.setState({ element: element });
    }
  }]);
  return ChartYAxisMetricItem;
}(_react.Component)) || _class);
exports.default = ChartYAxisMetricItem;
module.exports = exports['default'];

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingDialog.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(322);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(190);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(12);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingDialog = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SettingDialog, _Component);

  function SettingDialog(props) {
    (0, _classCallCheck3.default)(this, SettingDialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingDialog.__proto__ || (0, _getPrototypeOf2.default)(SettingDialog)).call(this, props));

    _this.onClosed = function (type) {
      if (type === 'accept') {
        _this.props.onClosed(_this.state);
      }
      _this.props.onClosed();
    };

    var value = props.value;
    _this.state = {
      lineWidth: value.lineWidth,
      dashStyle: value.dashStyle
    };
    return _this;
  }

  (0, _createClass3.default)(SettingDialog, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value || {};
      this.setState({
        lineWidth: value.lineWidth,
        dashStyle: value.dashStyle
      });
    }
  }, {
    key: 'renderContainer',
    value: function renderContainer() {
      var _this2 = this;

      var handleDashStyleChanged = function handleDashStyleChanged(dashStyle) {
        _this2.setState({
          dashStyle: dashStyle
        });
      };

      var handleThicknessChanged = function handleThicknessChanged(thickness) {
        _this2.setState({
          lineWidth: thickness.value
        });
      };

      return _react2.default.createElement(
        'div',
        { className: 'setting-dialog' },
        _react2.default.createElement(
          'div',
          { className: 'row style' },
          _react2.default.createElement(
            'span',
            { className: 'col-md-4' },
            _Izenda8.default.getText('BORDER_SETTING_LABEL_DASH_STYLE')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(_Izenda4.default, { dashStyle: this.state.dashStyle, onChange: handleDashStyleChanged })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row thickness' },
          _react2.default.createElement(
            'span',
            { className: 'col-md-4' },
            _Izenda8.default.getText('BORDER_SETTING_LABEL_THICKNESS')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(_Izenda6.default, { value: this.state.lineWidth, onChange: handleThicknessChanged })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        _Izenda2.default,
        { visible: props.showSetting, onClosed: this.onClosed, type: 'none', sizeClass: 'modal-sm' },
        _react2.default.createElement(_Izenda2.default.Header, { title: props.title }),
        _react2.default.createElement(
          _Izenda2.default.Body,
          null,
          this.renderContainer()
        ),
        _react2.default.createElement(
          _Izenda2.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda2.default.ConfirmationButton,
            { key: 'accept', type: 'accept' },
            _Izenda8.default.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda2.default.ConfirmationButton,
            { key: 'cancel', type: 'cancel' },
            _Izenda8.default.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return SettingDialog;
}(_react.Component), _class2.propsType = {
  title: _react.PropTypes.string,
  showSetting: _react.PropTypes.bool,
  value: _react.PropTypes.object,
  onClosed: _react.PropTypes.func
}, _class2.defaultProps = {
  showSetting: false
}, _temp)) || _class;

exports.default = SettingDialog;
module.exports = exports['default'];

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeYAxisMetricsContainer.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(377);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2033);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GaugeYAxisMetricsContainer = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(GaugeYAxisMetricsContainer, _Component);

  function GaugeYAxisMetricsContainer() {
    (0, _classCallCheck3.default)(this, GaugeYAxisMetricsContainer);
    return (0, _possibleConstructorReturn3.default)(this, (GaugeYAxisMetricsContainer.__proto__ || (0, _getPrototypeOf2.default)(GaugeYAxisMetricsContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(GaugeYAxisMetricsContainer, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var label = props.label;
      var localization = props.localization;
      var reportPart = props.reportPart;
      var reportPartContent = reportPart.reportPartContent;
      var chartType = (0, _fp.get)('reportPart.reportPartContent.chartType', props);

      return _react2.default.createElement(
        _Izenda2.default,
        { label: label },
        _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({}, props, { type: chartType }))
      );
    }
  }]);
  return GaugeYAxisMetricsContainer;
}(_react.Component)) || _class;

exports.default = GaugeYAxisMetricsContainer;
module.exports = exports['default'];

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeYAxisMetrics.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GaugeYAxisMetrics component
 */

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(1105);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2034);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GaugeYAxisMetrics = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(GaugeYAxisMetrics, _Component);

  function GaugeYAxisMetrics() {
    (0, _classCallCheck3.default)(this, GaugeYAxisMetrics);
    return (0, _possibleConstructorReturn3.default)(this, (GaugeYAxisMetrics.__proto__ || (0, _getPrototypeOf2.default)(GaugeYAxisMetrics)).apply(this, arguments));
  }

  (0, _createClass3.default)(GaugeYAxisMetrics, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateDataSource();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.updateDataSource();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.updateContainerElement();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var state = this.state;
      var type = props.type;
      var reportPart = props.reportPart;
      var itemProps = (0, _fp.pick)(['reportPart', 'store'], props);
      var dataSource = state.dataSource;
      var container = reportPart.reportPartContent && reportPart.reportPartContent.values;

      itemProps = (0, _fp.assign)(itemProps, {
        onDeleteElement: handleDeleteElement.bind(this),
        onAddElement: handleAddElement.bind(this),
        onUpdateElement: handleUpdateElement.bind(this),
        type: type,
        canDelete: dataSource.length > 1
      });

      return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({
        maximumMetrics: props.maximumField,
        dataSource: dataSource,
        onAddMetric: onAddMetric.bind(this),
        onDeleteMetric: onDeleteMetric.bind(this),
        itemComponent: _Izenda4.default
      }, itemProps));

      function handleDeleteElement(index, deleteElement) {
        this.state.dataSource[index] = null;
        this.setState({
          dataSource: this.state.dataSource
        });
      }

      function handleAddElement(index, field, querySource, addedField) {
        this.state.dataSource[index] = field;
        this.setState({
          dataSource: this.state.dataSource
        });
      }

      function handleUpdateElement(element, index) {
        container.elements[index] = _mobx2.default.toJS(element);
      }

      function onAddMetric() {
        this.state.dataSource.push(null);
        this.setState({
          dataSource: this.state.dataSource
        });
      }

      function onDeleteMetric(index) {
        this.state.dataSource.splice(index, 1);
        this.setState({
          dataSource: this.state.dataSource
        });
      }
    }
  }, {
    key: 'updateContainerElement',
    value: function updateContainerElement() {
      var props = this.props;
      var store = props.store;
      var reportFilters = store.reportFilters;
      var reportPart = props.reportPart;
      var newDataSource = (0, _fp.compact)(this.state.dataSource);
      var valueElements = reportPart.reportPartContent.values.elements;
      var numNewValues = (0, _fp.size)(newDataSource);
      var numValues = (0, _fp.size)(valueElements);

      if (numNewValues === numValues) {
        return;
      }

      if (numNewValues < numValues) {
        var deletedElement = (0, _fp.filter)(function (elm) {
          return !newDataSource.includes(elm);
        }, valueElements);
        deletedElement = (0, _fp.head)(deletedElement);

        if (deletedElement) {
          reportPart.removeFieldFromContainer(reportPart.reportPartContent.values, deletedElement);
          reportFilters.removeAggregatedField(deletedElement);
          reportPart.shouldUpdatePreview && props.store.needUpdatePreview(reportPart);
        }
      } else {
        reportPart.reportPartContent.values.elements = newDataSource;
      }
    }
  }, {
    key: 'updateDataSource',
    value: function updateDataSource() {
      var reportPart = this.props.reportPart;
      var container = reportPart.reportPartContent && reportPart.reportPartContent.values;
      var dataSource = [];

      container.elements.forEach(function (field) {
        dataSource.push(field);
      });

      // at least one metric is showed
      this.setState({
        dataSource: dataSource.length ? dataSource : [null]
      });
    }
  }]);
  return GaugeYAxisMetrics;
}(_react.Component)) || _class;

exports.default = GaugeYAxisMetrics;
module.exports = exports['default'];

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeValueMetricItem.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GaugeValue component
 */

var _Izenda = __webpack_require__(221);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda2 = __webpack_require__(2);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(1106);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(306);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(260);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(13);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(2035);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda14 = __webpack_require__(33);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GRID_SIZE_LABEL = 3;
var GRID_SIZE_CTRL = 9;
var GRID_LABEL = 'gauge-label control-label';
var GRID_CTRL = 'gauge-control';

var GaugeValueMetricItem = (_dec = (0, _Izenda3.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(GaugeValueMetricItem, _Component);

  function GaugeValueMetricItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GaugeValueMetricItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GaugeValueMetricItem.__proto__ || (0, _getPrototypeOf2.default)(GaugeValueMetricItem)).call.apply(_ref, [this].concat(args))), _this), _this.changeMetricValue = function (changedKeyPath) {
      return function (newVal) {
        var metricModel = _this.metricModel;
        metricModel.setDataByKey && metricModel.setDataByKey(changedKeyPath, newVal);
      };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GaugeValueMetricItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.initMetricData(this.props.value);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.initMetricData(nextProps.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var localization = props.localization;

      var field = this.field = props.value;
      var metricModel = this.metricModel;
      var hasPrimaryField = !!field;

      var reportPart = props.reportPart;
      var commonProps = {
        store: props.store,
        reportPart: reportPart
      };

      return _react2.default.createElement(
        _Izenda11.default,
        { className: 'gauge-item-value form-horizontal' },
        isSimpleGauge() && renderPrimaryKPI(),
        renderValue.call(this),
        !isSimpleGauge() && renderScaleRange.call(this),
        renderUnitLabel.call(this),
        renderThreshold.call(this),
        isSimpleGauge() && renderSupplementary.call(this)
      );

      function isSimpleGauge() {
        return reportPart.reportPartContent.chartType === _Izenda14.CHART_TYPE.SimpleGauge;
      }

      function renderPrimaryKPI() {
        return _react2.default.createElement(
          _Izenda11.default.Row,
          { className: 'form-group' },
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: 12 },
            _react2.default.createElement(
              'label',
              { className: 'control-label' },
              localization.getText('REPORTDESIGNER_LABEL_PRIMARY_KPI')
            )
          )
        );
      }

      function renderValue() {
        return _react2.default.createElement(
          _Izenda11.default.Row,
          { className: 'form-group' },
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: GRID_SIZE_LABEL, className: GRID_LABEL },
            localization.getText('COMMON_LABEL_VALUE')
          ),
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: GRID_SIZE_CTRL, className: GRID_CTRL },
            _react2.default.createElement(_Izenda13.default.FieldContainer, (0, _extends3.default)({}, commonProps, {
              value: field,
              containerName: _Izenda.ContainerName.VALUES,
              onDelete: onDeleteField,
              onAdd: onAddField(props.index)
            }))
          )
        );

        function onAddField(index) {
          return function () {
            props.onAddElement && props.onAddElement.apply(this, (0, _fp.concat)([index], arguments));
          };
        }

        function onDeleteField() {
          props.onDeleteElement && props.onDeleteElement(props.index);
        }

        function updatePreviewData() {
          return props.store.needUpdatePreview();
        }
      }

      function renderScaleRange() {
        var validation = props.validations;

        var onBlur = function onBlur() {
          props.validation.validate();
        };

        var buildValidationContran = function buildValidationContran(value) {
          return {
            action: function action() {
              return metricModel.validateThreshold.bind(metricModel, value);
            }
          };
        };

        var valsFrom = buildValidationContran('from');
        var valsTo = buildValidationContran('to');

        return _react2.default.createElement(
          _Izenda11.default.Row,
          { className: 'form-group' },
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: GRID_SIZE_LABEL, className: GRID_LABEL },
            'Scale'
          ),
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: GRID_SIZE_CTRL, className: (0, _classnames2.default)(GRID_CTRL, 'scale-range') },
            _react2.default.createElement(
              'span',
              { className: 'scale-from control-label ' },
              localization.getText('COMMON_LABEL_FROM')
            ),
            _react2.default.createElement(_Izenda9.default, {
              type: 'number',
              disabled: !hasPrimaryField,
              value: (0, _fp.get)('scale.from', metricModel),
              isDecimal: true,
              onChange: _EventUtils2.default.notifyChange(this.changeMetricValue('scale.from'), _EventUtils2.default.INPUT_BY_TYPE),
              onBlur: onBlur,
              validations: valsFrom,
              field: 'from'
            }),
            _react2.default.createElement(
              'span',
              { className: 'scale-to control-label ' },
              localization.getText('COMMON_LABEL_TO')
            ),
            _react2.default.createElement(_Izenda9.default, {
              type: 'number',
              disabled: !hasPrimaryField,
              value: (0, _fp.get)('scale.to', metricModel),
              isDecimal: true,
              onChange: _EventUtils2.default.notifyChange(this.changeMetricValue('scale.to'), _EventUtils2.default.INPUT_BY_TYPE),
              onBlur: onBlur,
              validations: valsTo,
              field: 'to'
            })
          )
        );
      }

      function renderUnitLabel() {
        return _react2.default.createElement(
          _Izenda11.default.Row,
          { className: 'form-group' },
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: GRID_SIZE_LABEL, className: (0, _classnames2.default)(GRID_LABEL, 'control-label') },
            localization.getText('REPORTDESIGNER_LABEL_UNIT_LABEL')
          ),
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: GRID_SIZE_CTRL, className: GRID_CTRL },
            _react2.default.createElement(_Izenda9.default, {
              type: 'text',
              disabled: !hasPrimaryField,
              value: metricModel.unitLabel,
              onChange: _EventUtils2.default.notifyChange(this.changeMetricValue('unitLabel'), _EventUtils2.default.INPUT_BY_TYPE)
            })
          )
        );
      }

      function renderThreshold() {
        return _react2.default.createElement(_Izenda13.default.ThresholdSetting, (0, _extends3.default)({}, commonProps, {
          disabled: !hasPrimaryField,
          thresholdSetting: metricModel.thresholds,
          metricModel: metricModel
        }));
      }

      function renderSupplementary() {
        return _react2.default.createElement(_Izenda13.default.SupplementarySetting, (0, _extends3.default)({}, commonProps, {
          disabled: !hasPrimaryField,
          supplementaryKPI: metricModel.supplementaryKPI,
          metricModel: metricModel
        }));
      }
    }
  }, {
    key: 'initMetricData',
    value: function initMetricData(field) {
      this.metricModel = this.getMetricData(field);
    }
  }, {
    key: 'getMetricData',
    value: function getMetricData(field, defaultVal) {
      return (0, _fp.getOr)(defaultVal || new _Izenda5.default(), 'properties.metric', field || {});
    }
  }]);
  return GaugeValueMetricItem;
}(_react.Component)) || _class);
exports.default = GaugeValueMetricItem;
module.exports = exports['default'];

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(14);

var _extends4 = _interopRequireDefault(_extends3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(221);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(306);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(260);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notifyChange = _EventUtils2.default.notifyChange; // ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeValueSettings.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GaugeValueSettings component
 */

var GRID_LABEL = 'col-md-3 gauge-label control-label';
var GRID_CTRL = 'col-md-9 gauge-control';

/**
 * Field container: alow user to drag & drop or open pop-up to add Field
 */
var FieldContainerWrapper = (0, _mobxReact.observer)(function (props) {
  var value = {
    name: props.containerName,
    elements: (0, _fp.isEmpty)(props.value) ? [] : [props.value]
  };
  return _react2.default.createElement(_Izenda8.default, (0, _extends4.default)({}, props, {
    height: 30,
    maximumField: 1,
    showPlaceHolder: false,
    resizable: true,
    onDeleteElement: onDelete,
    onAddElement: onAdd,
    container: (0, _mobx.observable)(value)
  }));

  function onAdd(addedField) {
    props.onAdd && props.onAdd.call(null, addedField);
  }

  function onDelete() {
    props.onDelete && props.onDelete.apply(null, arguments);
  }
});

/**
 * SettingValueBy Type
 * type = static: number
 * type = dynamic: field-container
 */
var SettingValueByType = (0, _mobxReact.observer)(function (props) {
  var isStatic = props.type === _Izenda3.SETTING_VALUES.STATIC.value;
  var valueKey = props.valueKey || (isStatic ? 'value' : 'element');

  valueKey += props.isUpperBound ? 'Upper' : '';

  var value = {
    value: (0, _fp.get)(valueKey, props.dataSource || {})
  };

  var vals = props.name === _Izenda3.THRESHOLD_VALUES.LOW.value || props.name === _Izenda3.THRESHOLD_VALUES.HIGH.value ? {
    action: function action() {
      return props.metricModel.validateThreshold.bind(props.metricModel, props.name);
    }
  } : {};

  var onBlur = function onBlur() {
    props.validation.validate();
  };

  return isStatic ? _react2.default.createElement(_Izenda10.default, (0, _extends4.default)({
    type: 'number',
    isDecimal: true,
    onChange: onChange
  }, value, {
    onBlur: onBlur,
    validations: vals,
    field: props.name
  })) : _react2.default.createElement(FieldContainerWrapper, (0, _extends4.default)({}, props, { onDelete: onDeleteField.bind(undefined), onAdd: onAddField.bind(undefined) }, value));

  function onChange(newVal) {
    return props.onChange(newVal.value, props);
  }

  function onDeleteField(newVal) {
    return onChange({ value: null });
  }

  function onAddField(addedField) {
    return onChange({ value: addedField });
  }
});

/**
 * ThresholdSettingItem: name & color & operator & value
 */
var ThresholdSettingItem = (0, _mobxReact.observer)(function (props) {
  props = props || {};
  var classes = (0, _classnames2.default)('threshold-item', 'form-group');
  var thresholdData = props.thresholdData || {};
  var metricModel = props.metricModel;
  var thresholdName = thresholdData.name;

  return _react2.default.createElement(
    'fieldset',
    { className: classes },
    _react2.default.createElement(
      'span',
      { className: GRID_LABEL },
      _Izenda3.THRESHOLD_VALUES[thresholdName.toUpperCase()].label
    ),
    _react2.default.createElement(
      'div',
      { className: GRID_CTRL },
      _react2.default.createElement(_Izenda10.default, {
        type: 'color',
        value: thresholdData.color,
        onChange: _EventUtils2.default.notifyChange(changeThresholdValues('color'), _EventUtils2.default.INPUT_BY_TYPE)
      }),
      _react2.default.createElement(_Izenda6.default, {
        disabled: isDisabled(),
        options: getOperators(),
        value: thresholdData.operator,
        onChange: _EventUtils2.default.notifyChange(changeThresholdValues('operator'), _EventUtils2.default.DROPDOWN)
      }),
      renderValue(thresholdData.operator, props)
    )
  );

  function isDisabled() {
    switch (thresholdName) {
      case _Izenda3.THRESHOLD_VALUES.LOW.value:
      case _Izenda3.THRESHOLD_VALUES.HIGH.value:
        return true;
      default:
        return false;
    }
  }

  function getOperators() {
    switch (thresholdName) {
      case _Izenda3.THRESHOLD_VALUES.LOW.value:
        return [_Izenda3.THRESHOLD_OPERATORS.LESS_THAN];

      case _Izenda3.THRESHOLD_VALUES.TARGET.value:
        return [_Izenda3.THRESHOLD_OPERATORS.LESS_THAN, _Izenda3.THRESHOLD_OPERATORS.BETWEEN];

      case _Izenda3.THRESHOLD_VALUES.HIGH.value:
        return [_Izenda3.THRESHOLD_OPERATORS.GREAT_THAN];

      default:
        return [];
    }
  }

  function renderValue(operator, props) {
    switch (operator) {
      case _Izenda3.THRESHOLD_OPERATORS.LESS_THAN.value:
        return renderSettingValue({ isUpperBound: true });

      case _Izenda3.THRESHOLD_OPERATORS.BETWEEN.value:
        return _react2.default.createElement(
          'div',
          { className: 'threshold-range' },
          renderSettingValue({ isUpperBound: false }),
          renderSettingValue({ isUpperBound: true })
        );

      case _Izenda3.THRESHOLD_OPERATORS.GREAT_THAN.value:
        return renderSettingValue({ isUpperBound: false });
    }

    function renderSettingValue(settingInfo) {
      return _react2.default.createElement(SettingValueByType, (0, _extends4.default)({}, props, settingInfo, {
        type: props.type,
        containerName: _Izenda3.ContainerName.THRESHOLD,
        dataSource: thresholdData,
        onChange: changeThresholdValues(null, settingInfo, true),
        name: thresholdData.name
      }));
    }
  }

  function changeThresholdValues(keyValue, settingInfo, isSettingValue) {
    return function (newVal, otherInfo) {
      metricModel.setThresholdValue && metricModel.setThresholdValue(isSettingValue, thresholdData, keyValue, newVal, otherInfo && otherInfo.isUpperBound);
    };
  }
});

/**
 * ThresholdSetting: low & target & high
 */
var ThresholdSetting = (0, _Izenda2.default)()(function (props) {
  var localization = props.localization;
  var thresholdSetting = props.thresholdSetting || '';
  var metricModel = props.metricModel;
  var classes = (0, _classnames2.default)('form-group');
  var thresholdSettingLevels = thresholdSetting.levels;

  return _react2.default.createElement(
    'fieldset',
    { disabled: props.disabled },
    _react2.default.createElement(
      'div',
      { className: 'form-group' },
      _react2.default.createElement(
        'span',
        { className: GRID_LABEL },
        localization.getText('REPORTDESIGNER_LABEL_THRESHOLD_SETTINGS')
      ),
      _react2.default.createElement(
        'div',
        { className: GRID_CTRL },
        _react2.default.createElement(_Izenda6.default, {
          disabled: props.disabled,
          options: _Izenda4.default.getOptions('THRESHOLD_SETTINGS'),
          blankOption: true,
          blankOptionText: 'None',
          value: thresholdSetting.setting,
          onChange: _EventUtils2.default.notifyChange(metricModel.setThresholdSetting.bind(metricModel), _EventUtils2.default.DROPDOWN)
        })
      )
    ),
    thresholdSettingLevels.map(function (levelData, index) {
      var _extends2;

      return _react2.default.createElement(ThresholdSettingItem, (0, _extends4.default)({}, props, (_extends2 = {
        key: index,
        thresholdData: levelData,
        metricModel: metricModel
      }, (0, _defineProperty3.default)(_extends2, 'key', levelData.name), (0, _defineProperty3.default)(_extends2, 'type', thresholdSetting.setting), (0, _defineProperty3.default)(_extends2, 'itemIndex', index), _extends2)));
    })
  );

  function changeThesholdSetting(newVal) {
    metricModel.setValueByKey && metricModel.setValueByKey('threshold', newVal);
  }
});

/**
 * SupplementarySetting: settings & value & unit
 */
var SupplementarySetting = (0, _Izenda2.default)()(function (props) {
  var localization = props.localization;
  var valueType = (0, _fp.getOr)('', 'supplementaryKPI.valueType', props);
  var supplementaryKPI = (0, _fp.getOr)({}, 'supplementaryKPI', props);
  var metricModel = props.metricModel;

  return _react2.default.createElement(
    'fieldset',
    { disabled: props.disabled },
    _react2.default.createElement(
      'div',
      { className: 'form-group' },
      _react2.default.createElement(
        'label',
        { className: GRID_LABEL },
        localization.getText('REPORTDESIGNER_LABEL_SUPPLEMENTARY_KPI')
      ),
      _react2.default.createElement(
        'div',
        { className: GRID_CTRL },
        _react2.default.createElement(_Izenda6.default, {
          disabled: props.disabled,
          options: _Izenda4.default.getOptions('SUPP_SETTINGS'),
          blankOption: true,
          blankOptionText: 'None',
          value: supplementaryKPI.valueType,
          onChange: _EventUtils2.default.notifyChange(metricModel.setSupplementaryKPISetting.bind(metricModel), _EventUtils2.default.DROPDOWN)
        })
      )
    ),
    supplementaryKPI.valueType && _react2.default.createElement(
      'div',
      { className: 'form-group' },
      _react2.default.createElement(
        'span',
        { className: GRID_LABEL },
        localization.getText('COMMON_LABEL_VALUE')
      ),
      _react2.default.createElement(
        'div',
        { className: GRID_CTRL },
        _react2.default.createElement(SettingValueByType, (0, _extends4.default)({}, props, {
          type: valueType,
          containerName: _Izenda3.ContainerName.SUP_KPI,
          dataSource: supplementaryKPI,
          onChange: onChangeValue
        }))
      )
    ),
    supplementaryKPI.valueType && _react2.default.createElement(
      'div',
      { className: 'form-group' },
      _react2.default.createElement(
        'span',
        { className: GRID_LABEL },
        localization.getText('REPORTDESIGNER_LABEL_UNIT_LABEL')
      ),
      _react2.default.createElement(
        'div',
        { className: GRID_CTRL },
        _react2.default.createElement(_Izenda10.default, {
          type: 'text',
          value: supplementaryKPI.unitLabel,
          onChange: _EventUtils2.default.notifyChange(changeMetricValue(metricModel, 'supplementaryKPI.unitLabel'), _EventUtils2.default.INPUT_BY_TYPE)
        })
      )
    )
  );

  function onChangeValue(newVal) {
    metricModel.setSupKpiValue && metricModel.setSupKpiValue(newVal);
  }
});

function changeMetricValue(metricModel, changedKeyPath) {
  return function changeValue(newVal) {
    metricModel.setDataByKey && metricModel.setDataByKey.call(metricModel, changedKeyPath, newVal);
  };
}

exports.default = {
  FieldContainer: FieldContainerWrapper,
  SupplementarySetting: SupplementarySetting,
  ThresholdSetting: ThresholdSetting
};
module.exports = exports['default'];

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.TotalLabelContainer.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(377);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1107);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TotalLabelContainer = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(TotalLabelContainer, _Component);

  function TotalLabelContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TotalLabelContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TotalLabelContainer.__proto__ || (0, _getPrototypeOf2.default)(TotalLabelContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeData = function (value) {
      _this.props.reportPart.reportPartContent.setTotalLabel(value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TotalLabelContainer, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var reportPart = props.reportPart;
      var label = props.label;
      var reportPartContent = reportPart.reportPartContent;

      return _react2.default.createElement(
        _Izenda2.default,
        { label: label },
        _react2.default.createElement(_Izenda4.default, {
          value: (0, _fp.get)('properties.optionByType.izTotalLabel', reportPartContent),
          onChangeValue: this.onChangeData
        })
      );
    }
  }]);
  return TotalLabelContainer;
}(_react.Component)) || _class;

exports.default = TotalLabelContainer;
module.exports = exports['default'];

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(13);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.StaticLabelContainer.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var StaticLabelContainer = function (_Component) {
  (0, _inherits3.default)(StaticLabelContainer, _Component);

  function StaticLabelContainer() {
    (0, _classCallCheck3.default)(this, StaticLabelContainer);
    return (0, _possibleConstructorReturn3.default)(this, (StaticLabelContainer.__proto__ || (0, _getPrototypeOf2.default)(StaticLabelContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(StaticLabelContainer, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var label = props.label;
      return _react2.default.createElement(
        _Izenda2.default.Row,
        { className: 'u_paddingTop' },
        _react2.default.createElement(
          _Izenda2.default.Col,
          null,
          label
        )
      );
    }
  }]);
  return StaticLabelContainer;
}(_react.Component);

exports.default = StaticLabelContainer;
module.exports = exports['default'];

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(2039);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2053);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2054);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2055);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2061);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(328);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2062);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(16);

var _Izenda16 = __webpack_require__(598);

var _fp = __webpack_require__(1);

var _Izenda17 = __webpack_require__(181);

var _Izenda18 = _interopRequireDefault(_Izenda17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Default chart configuration */
_Izenda18.default.setConfiguration(_Izenda15.REPORT_PART_TYPE.Chart, {
  /**
   * Visualization engine name
   */
  visualEngine: 'Highchart',

  /**
   * Label of visualization, normally showing in chart type dropdown
   */
  visualLabel: null,

  /**
   * A CSS class to show preview image of the visualization, normally showing when hovering a chart dropdown item
   */
  visualPreviewCSS: null,

  /**
   * Type of visualization, e.g. chart type in Highcharts
   */
  visualType: null,

  /**
   * The builder class to build chart visualization options
   */
  optionsBuilder: _Izenda12.default,

  /**
   * Report part content model class
   */
  model: _Izenda14.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _fp.constant)({
    chart_title: true
  })],

  /**
   * The object contains the property editor widget component
   */
  propertyWidgets: _Izenda8.default,

  /**
   * The object contains defined schema of property editor GUI
   */
  propertySchema: _Izenda2.default,

  /**
   * The function to create the mapping properties
   */
  propertyMappingProps: _Izenda4.default,

  /**
   * The function to create the mapping source
   */
  propertyMappingSource: _Izenda6.default,

  /**
   * The function to create an value changed handler
   */
  propertyValueChange: _Izenda10.default,

  optionsMapping: {
    /**
     * The object containts common options mapping
     */
    commonOptions: _Izenda16.COMMON_OPTIONS,

    /**
     * The object contains options by type mapping
     */
    optionsByType: {},

    /**
     * The object contains the threshold options mapping
     */
    thresholdOptions: _Izenda16.THRESHOLDS_LINE,

    /**
     * The object contains the axis options mapping
     */
    axisOptions: _Izenda16.AXIS_OPTIONS
  }
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _fields2, _fields3, _fields5, _fields6, _fields7, _groups;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartPropsDefinedSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(305);

var _Izenda2 = __webpack_require__(33);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(175);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = __webpack_require__(39);

var _Izenda7 = __webpack_require__(12);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(595);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(1108);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(323);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2041);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2043);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(1109);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2045);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(2050);

var _Izenda24 = _interopRequireDefault(_Izenda23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHART_KEY = _Izenda6.CHART_SCHEMA_NAMES.CHART_KEY,
    GROUPS = _Izenda6.CHART_SCHEMA_NAMES.GROUPS,
    FIELDS = _Izenda6.CHART_SCHEMA_NAMES.FIELDS;


var getChartTypeOptions = function getChartTypeOptions() {
  return (0, _Izenda4.getAll)(_Izenda5.REPORT_PART_TYPE.Chart).map(function (_ref) {
    var label = _ref.label,
        style = _ref.style,
        previewCSS = _ref.previewCSS;
    return {
      label: label,
      value: style,
      className: previewCSS
    };
  });
};

/**
 * The common chart properties GUI schema that shares to all chart type.
 */
exports.default = {
  schemaKey: CHART_KEY,
  groups: (_groups = {}, (0, _defineProperty3.default)(_groups, GROUPS.GENERAL_INFO_GROUP, {
    title: function title() {
      return _Izenda8.default.getText('COMMON_LABEL_GENERAL_INFO');
    },
    fields: (0, _defineProperty3.default)({}, FIELDS.GENERAL_INFO_CHART_TYPE, {
      factory: _Izenda.createDropDownSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_CHART_TYPE');
      },
      value: 'getChartType',
      props: {
        defaultValue: _Izenda6.DefaultChartType,
        get options() {
          return getChartTypeOptions();
        }
      }
    })
  }), (0, _defineProperty3.default)(_groups, GROUPS.CHART_GROUP, {
    title: function title() {
      return _Izenda8.default.getText('COMMON_LABEL_CHART');
    },
    isHidden: 'isNotBuild',
    hiddenByState: true,
    className: 'getClassNameByChartStatus',
    fields: (_fields2 = {}, (0, _defineProperty3.default)(_fields2, FIELDS.CHART_BORDER, {
      factory: _Izenda.createPopupSettingSchema,
      title: function title() {
        return _Izenda8.default.getText('COMMON_LABEL_BORDER');
      },
      value: 'getBorder',
      props: {
        get reportPartType() {
          return _Izenda5.REPORT_PART_TYPE.Chart;
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_CHART_BORDER_SETTINGS');
        },
        allChartProps: 'getAllChartProps',
        hadSetting: 'hadSettingBorder',
        fnResetDefaultValue: 'fnResetBorderDefaultValue',
        loadValue: 'getBorder'
      },
      staticProps: {
        get popupTitle() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_CHART_BORDER_SETTINGS');
        },
        popupContent: _Izenda10.default
      }
    }), (0, _defineProperty3.default)(_fields2, FIELDS.CHART_BGCOLOR, {
      factory: _Izenda.createPopupSettingSchema,
      title: function title() {
        return _Izenda8.default.getText('COLOR_STYLING_BACKGROUND_TOOLTIP');
      },
      value: 'getBackgroundColor',
      props: {
        get reportPartType() {
          return _Izenda5.REPORT_PART_TYPE.Chart;
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_CHART_BACKGROUND_COLOR_SETTINGS');
        },
        allChartProps: 'getAllChartProps',
        hadSetting: 'hadSettingBackgroundColor',
        fnResetDefaultValue: 'fnResetBackgroundColorDefaultValue',
        loadValue: 'getBackgroundColor'
      },
      staticProps: {
        get popupTitle() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_CHART_BACKGROUND_COLOR_SETTINGS');
        },
        popupContent: _Izenda12.default
      }
    }), (0, _defineProperty3.default)(_fields2, FIELDS.CHART_XY_PLANE, {
      factory: _Izenda.createPopupSettingSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_XY_PLANE');
      },
      isHidden: 'hideByChartType',
      value: 'getXYPlaneSettings',
      props: {
        get reportPartType() {
          return _Izenda5.REPORT_PART_TYPE.Chart;
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_CHART_XY_PLANE_SETTINGS');
        },
        allChartProps: 'getAllChartProps',
        reportPartDetails: 'getReportPartDetails',
        fieldStore: 'getFieldStore',
        hadSetting: 'hadSettingXYPlane',
        fnResetDefaultValue: 'fnResetXYPlaneDefaultValue',
        loadValue: 'getXYPlaneSettings'
      },
      staticProps: {
        get popupTitle() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_XY_PLANE_SETTINGS');
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_XY_PLANE_SETTINGS');
        },
        popupContent: _Izenda16.default
      }
    }), (0, _defineProperty3.default)(_fields2, FIELDS.CHART_GRID_LINE, {
      factory: _Izenda.createPopupSettingSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_GRID_LINES');
      },
      isHidden: 'hideByChartType',
      value: 'getGridLines',
      props: {
        get reportPartType() {
          return _Izenda5.REPORT_PART_TYPE.Chart;
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_CHART_GRID_LINES_SETTINGS');
        },
        allChartProps: 'getAllChartProps',
        hadSetting: 'hasSettingGridLine',
        fnResetDefaultValue: 'resetDefaultGridLine',
        loadValue: 'getGridLines'
      },
      staticProps: {
        get popupTitle() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_GRID_LINES_SETTINGS');
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_GRID_LINES_SETTINGS');
        },
        popupContent: _Izenda18.default
      }
    }), (0, _defineProperty3.default)(_fields2, FIELDS.CHART_COLOR_THEME, {
      factory: _Izenda.createColorPaletteSettingSchema,
      title: function title() {
        return _Izenda8.default.getText('COMMON_LABEL_COLOR_THEME');
      },
      value: 'getColorTheme',
      props: {
        get selectionPopupTitle() {
          return _Izenda8.default.getText('COLORTHEME_POPUP_HEADER');
        },
        get defaultColorThemeLabel() {
          return _Izenda8.default.getText('COLORPALETTE_NOTHEME');
        },
        displaySettingStatus: true,
        needMaskDefault: false,
        defaultColorPalette: null
      }
    }), (0, _defineProperty3.default)(_fields2, FIELDS.CHART_MULTI_COLOR, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_MULTI_COLOR');
      },
      info: function info() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_MULTI_COLOR_INFO');
      },
      isHidden: 'hideByChartTypeAndMetrics',
      value: 'getValueByKey',
      props: {
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_MULTI_COLOR_SETTINGS');
        }
      }
    }), (0, _defineProperty3.default)(_fields2, FIELDS.CHART_MULTI_LEVEL, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_MULTI_LEVEL');
      },
      info: function info() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_MULTI_LEVEL_INFO');
      },
      isHidden: 'hideByChartType',
      value: 'getValueByKey',
      props: {
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_MULTI_COLOR_SETTINGS');
        }
      }
    }), _fields2)
  }), (0, _defineProperty3.default)(_groups, GROUPS.LABEL_GROUP, {
    title: function title() {
      return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_LABELS');
    },
    isHidden: 'isNotBuild',
    className: 'getClassNameByChartStatus',
    fields: (_fields3 = {}, (0, _defineProperty3.default)(_fields3, FIELDS.LABEL_ORIENTATION, {
      factory: _Izenda.createOrientationSettingsSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_DATA_LABELS');
      },
      isHidden: 'hideByChartType',
      value: 'getValueByKey'
    }), (0, _defineProperty3.default)(_fields3, FIELDS.LABEL_ORIENTATION_X, {
      factory: _Izenda.createOrientationSettingsSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_X_LABELS');
      },
      isHidden: 'hideByChartType',
      value: 'getLabelOrientationX'
    }), (0, _defineProperty3.default)(_fields3, FIELDS.LABEL_ORIENTATION_Y, {
      factory: _Izenda.createOrientationSettingsSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_Y_LABELS');
      },
      isHidden: 'hideByChartType',
      value: 'getLabelOrientationY'
    }), (0, _defineProperty3.default)(_fields3, FIELDS.LABEL_HOVER, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_HOVER_LABELS');
      },
      value: 'getValueByKey'
    }), _fields3)
  }), (0, _defineProperty3.default)(_groups, GROUPS.LEGENDS_GROUP, {
    title: function title() {
      return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_LEGENDS');
    },
    isHidden: 'isNotBuild',
    className: 'getClassNameByChartStatus',
    fields: (0, _defineProperty3.default)({}, FIELDS.LEGENDS_SETTINGS, {
      factory: _Izenda.createPopupSettingSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_SETTINGS');
      },
      value: 'getLegendSettings',
      isHidden: 'hideByChartType',
      props: {
        get reportPartType() {
          return _Izenda5.REPORT_PART_TYPE.Chart;
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_CHART_LEGEND_SETTINGS');
        },
        allChartProps: 'getAllChartProps',
        chartType: 'getChartType',
        hadSetting: 'hadSettingLegend',
        fnResetDefaultValue: 'fnResetLegendDefaultValue',
        loadValue: 'getLegendSettings'
      },
      staticProps: {
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_LEGEND_SETTINGS');
        },
        get popupTitle() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_LEGEND_SETTINGS');
        },
        popupContent: _Izenda20.default
      }
    })
  }), (0, _defineProperty3.default)(_groups, GROUPS.GROUPING_GROUP, {
    title: function title() {
      return _Izenda8.default.getText('COMMON_LABEL_GROUPING');
    },
    isHidden: 'isNotBuild',
    className: 'getClassNameByChartStatus',
    fields: (_fields5 = {}, (0, _defineProperty3.default)(_fields5, FIELDS.GROUPING_USE_SEPARATOR, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('COMMON_LABEL_USE_SEPARATOR');
      },
      value: 'getUseSeparator',
      isHidden: 'hideByChartType'
    }), (0, _defineProperty3.default)(_fields5, FIELDS.GROUPING_STACKING, {
      factory: _Izenda.createSelectSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_STACKED');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType',
      props: {
        blankOption: true,
        get options() {
          return _Izenda3.default.getOptions('STACK_TYPE_CHART');
        }
      }
    }), (0, _defineProperty3.default)(_fields5, FIELDS.GROUPING_BOTTOM_X_PERCENT, {
      factory: _Izenda.createNumberSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_BOTTOM_PERCENT_GROUPED_TO_OTHER');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType',
      props: {
        min: 0,
        max: 100
      }
    }), _fields5)
  }), (0, _defineProperty3.default)(_groups, GROUPS.DATA_GROUP, {
    title: function title() {
      return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_DATA');
    },
    isHidden: 'isNotBuild',
    className: 'getClassNameByChartStatus',
    fields: (_fields6 = {}, (0, _defineProperty3.default)(_fields6, FIELDS.DATA_SHOW_PERCENTAGE, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_SHOW_PERCENTAGE');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType'
    }), (0, _defineProperty3.default)(_fields6, FIELDS.DATA_VALUE_LABEL, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_SHOW_VALUE_LABELS');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType'
    }), (0, _defineProperty3.default)(_fields6, FIELDS.DATA_SLICE_LABEL, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_SHOW_SLICE_LABELS');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType'
    }), (0, _defineProperty3.default)(_fields6, FIELDS.DATA_RANGE, {
      factory: _Izenda.createSelectSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_RANGE');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType',
      props: {
        blankOption: true,
        get options() {
          return _Izenda3.default.getOptions('RANGE');
        },
        filterOptions: 'filterRangeOptions'
      }
    }), (0, _defineProperty3.default)(_fields6, FIELDS.DATA_THRESHOLDS, {
      factory: _Izenda.createPopupSettingSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_THRESHOLDS');
      },
      value: 'getThresholdSettings',
      isHidden: 'hideByChartType',
      props: {
        get reportPartType() {
          return _Izenda5.REPORT_PART_TYPE.Chart;
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_THRESHOLDS_SETTINGS');
        },
        allChartProps: 'getAllChartProps',
        reportPartDetails: 'reportPartDetails',
        fieldStore: 'getFieldStore',
        hadSetting: 'hadSettingThreshold',
        fnResetDefaultValue: 'fnResetThresholdDefaultValue',
        loadValue: 'getThresholdSettings'
      },
      staticProps: {
        containerClassName: 'threshold-config',
        get popupTitle() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_THRESHOLDS_SETTINGS');
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_THRESHOLDS_SETTINGS');
        },
        popupContent: _Izenda22.default,
        popupProps: {
          type: 'none',
          autoClose: false,
          sizeClass: 'modal-lg',
          containerClass: 'izenda-ThresholdSettings izenda-ChartSettingsPopup'
        }
      }
    }), (0, _defineProperty3.default)(_fields6, FIELDS.DATA_REGRESSION_LINE, {
      factory: _Izenda.createPopupSettingSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_REGRESSION_LINE');
      },
      value: 'getRegressionLineSettings',
      isHidden: 'hideByChartType',
      props: {
        get reportPartType() {
          return _Izenda5.REPORT_PART_TYPE.Chart;
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_REGRESSION_LINE_SETTINGS');
        },
        allChartProps: 'getAllChartProps',
        reportPartDetails: 'reportPartDetails',
        fieldStore: 'getFieldStore',
        hadSetting: 'hadSettingRegressionLine',
        fnResetDefaultValue: 'fnResetRegressionLineDefaultValue',
        loadValue: 'getRegressionLineSettings',
        warningCondition: 'hadSeparators',
        warningAction: 'removeUseSeparator'
      },
      staticProps: {
        containerClassName: '',
        get popupTitle() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_REGRESSION_LINE_SETTINGS');
        },
        get title() {
          return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_REGRESSION_LINE_SETTINGS');
        },
        popupContent: _Izenda24.default,
        popupProps: {
          type: 'none',
          autoClose: false,
          sizeClass: 'modal-lg',
          containerClass: 'izenda-RegressionLineSettings izenda-ChartSettingsPopup'
        },
        get warningMessage() {
          return _Izenda8.default.getText('REGRESSION_LINE_POPUP_WARNING');
        }
      }
    }), _fields6)
  }), (0, _defineProperty3.default)(_groups, GROUPS.VIEW_GROUP, {
    title: function title() {
      return _Izenda8.default.getText('MODEL_LABEL_VIEW');
    },
    isHidden: 'isNotBuild',
    className: 'getClassNameByChartStatus',
    fields: (_fields7 = {}, (0, _defineProperty3.default)(_fields7, FIELDS.VIEW_ZOOM, {
      factory: _Izenda.createSelectSchema,
      title: function title() {
        return _Izenda8.default.getText('SCHEMA_ZOOM');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType',
      props: {
        blankOption: true,
        get options() {
          return _Izenda3.default.getOptions('ZOOM_TYPE');
        }
      }
    }), (0, _defineProperty3.default)(_fields7, FIELDS.VIEW_INVERTED, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('COMMON_LABEL_INVERTED');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType'
    }), (0, _defineProperty3.default)(_fields7, FIELDS.VIEW_STEP, {
      factory: _Izenda.createSelectSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_STEP');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType',
      props: {
        blankOption: true,
        get options() {
          return _Izenda3.default.getOptions('STEP_TYPE');
        }
      }
    }), (0, _defineProperty3.default)(_fields7, FIELDS.VIEW_SPLINE, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_SPLINE');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType'
    }), (0, _defineProperty3.default)(_fields7, FIELDS.VIEW_PIE_CHART_STYLE, {
      factory: _Izenda.createSelectSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_PIE_CHART_STYLE');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType',
      props: {
        get options() {
          return _Izenda3.default.getOptions('PIE_CHART_STYPE');
        }
      }
    }), (0, _defineProperty3.default)(_fields7, FIELDS.VIEW_DATA_REFRESH_INTERVAL, {
      factory: _Izenda.createPopupSettingSchema,
      title: function title() {
        return _Izenda8.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
      },
      value: 'getValueByKey',
      isHidden: 'isNotBuild',
      props: {
        get reportPartType() {
          return _Izenda5.REPORT_PART_TYPE.Chart;
        },
        get title() {
          return _Izenda8.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
        },
        hiddenByState: true,
        hadSetting: 'hadSettingRefreshInterval',
        allChartProps: 'getAllChartProps',
        fnResetDefaultValue: 'fnResetRefreshIntervalDefaultValue',
        loadValue: 'getDataRefreshInterval'
      },
      staticProps: {
        get popupTitle() {
          return _Izenda8.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
        },
        popupContent: _Izenda14.default,
        popupProps: {
          type: 'none',
          autoClose: false
        }
      }
    }), (0, _defineProperty3.default)(_fields7, FIELDS.VIEW_DATA_USE_PAGINATION, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('COMMON_LABEL_USE_PAGINATION');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType'
    }), (0, _defineProperty3.default)(_fields7, FIELDS.VIEW_ITEMS_PER_ROW, {
      factory: _Izenda.createNumberSchema,
      title: function title() {
        return _Izenda8.default.getText('COMMON_LABEL_ITEM_PER_ROW');
      },
      value: 'getValueByKey',
      isHidden: 'hideByChartType',
      props: {
        min: 1,
        max: 20,
        isDecimal: false
      }
    }), (0, _defineProperty3.default)(_fields7, FIELDS.VIEW_SINGLE_YAXIS, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_SINGLE_YAXIS');
      },
      value: 'getValueByKey',
      isHidden: 'doesHideSingleYAxis'
    }), _fields7)
  }), (0, _defineProperty3.default)(_groups, GROUPS.PRINTING_GROUP, {
    title: function title() {
      return _Izenda8.default.getText('COMMON_LABEL_PRINTINGS');
    },
    isHidden: 'doesHidePageBreakAfterSeparator',
    className: 'getClassNameByChartStatus',
    fields: (0, _defineProperty3.default)({}, FIELDS.PRINTING_PAGE_BREAK_AFTER_SEPARATOR, {
      factory: _Izenda.createCheckBoxSchema,
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_PAGE_BREAK_AFTER_SEPARATOR');
      },
      value: 'getValueByKey'
    })
  }), _groups)
};
module.exports = exports['default'];

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-mixed-spaces-and-tabs */
// ----------------------------------------------------------------------
// <copyright file="Izenda.GroupRadioInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GroupRadioInput Component
 */
!function () {
  var React = __webpack_require__(0);

  var GroupRadioInput = React.createClass({
    displayName: 'GroupRadioInput',


    propTypes: {
      onChange: React.PropTypes.func.isRequired,
      options: React.PropTypes.oneOfType([React.PropTypes.object.isRequired, React.PropTypes.array.isRequired]),
      value: React.PropTypes.string
    },

    /**
     * Handle when one option click
     * @param  {object} e React event
     * @return 
     */
    handleValueChange: function handleValueChange(e) {
      this.props.onChange && this.props.onChange({ value: e.target.value });
    },

    /**
     * Render group of of radio base on input value
     */
    render: function render() {

      var selectedValue = this.props.value || this.props.options[0].value;

      var options = this.props.options.map(function (item, index) {
        return React.createElement(
          'div',
          { key: index },
          React.createElement('input', { type: 'radio',
            value: item.value,
            checked: item.value === selectedValue,
            onChange: this.handleValueChange }),
          React.createElement(
            'span',
            { title: item.label },
            ' ',
            item.label,
            ' '
          )
        );
      }.bind(this));

      return React.createElement(
        'div',
        null,
        options
      );
    }
  });

  module.exports = GroupRadioInput;
}();

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartXYPlaneSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(193);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(39);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(33);

var _Izenda6 = __webpack_require__(16);

var _Izenda7 = __webpack_require__(80);

var _Izenda8 = __webpack_require__(12);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(2042);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONSTANTS = _Izenda4.default.CHART_SETTINGS.DEFAULT_VALUE;
var FONT_STYLE = _Izenda4.default.CHART_SETTINGS.FONT_STYLE;
var VALUE_LABEL_METRICS_CHART = [_Izenda5.CHART_TYPE.HeatMap, _Izenda5.CHART_TYPE.Bubble, _Izenda5.CHART_TYPE.Scatter];
var OTHER_PROPS_AXIS_KEY = 'axis';
var OTHER_PROPS_THRESHOLD_KEY = 'threshold';
var WIDGET = {
  Axis: _Izenda11.default
};
var isChartType = _Izenda4.default.isChartType;

/**
 * Get definition of schema
 * @param {any} xOption
 * @param {any} yOption
 * @return {any}
 */

function getSchemaDef(xOption, yOption) {
  return {
    schemaKey: 'XY_PLANE_SCHEMA',
    fields: {
      xAxisTitle: {
        title: _Izenda9.default.getText('REPORTDESIGNER_TOOLTIP_X_AXIS_UPPER'),
        fieldClassName: 'axis-title-field',
        titleClassName: 'axis-title',
        controlClassName: 'axis-title-control',
        type: 'select',
        fnValue: 'getXAxisSelectedOptionValue',
        props: {
          options: xOption
        }
      },
      xAxis: {
        title: _Izenda9.default.getText('REPORTDESIGNER_TOOLTIP_X_AXIS_LOWER'),
        fieldClassName: 'u_inlineBlock u_fullWidth izenda-XYPlane-XAxis u_paddingBottom',
        titleClassName: 'axis-title-properties',
        component: 'Axis',
        fnValue: 'getXAxis',
        props: {
          type: 'xAxis',
          selectedAxis: 'getXAxisSelectedOption',
          syncXAxisType: 'syncXAxisType',
          setXAxisType: 'setXAxisType',
          disabledSyncButton: 'disabledSyncButton'
        }
      },
      yAxisTitle: {
        title: _Izenda9.default.getText('REPORTDESIGNER_TOOLTIP_Y_AXIS_UPPER'),
        fieldClassName: 'axis-title-field',
        titleClassName: 'axis-title',
        controlClassName: 'axis-title-control',
        type: 'select',
        fnValue: 'getYAxisSelectedOptionValue',
        props: {
          options: yOption
        }
      },
      yAxis: {
        title: _Izenda9.default.getText('REPORTDESIGNER_TOOLTIP_Y_AXIS_LOWER'),
        fieldClassName: 'u_inlineBlock u_fullWidth',
        titleClassName: 'axis-title-properties',
        component: 'Axis',
        fnValue: 'getYAxis',
        props: {
          type: 'yAxis',
          selectedAxis: 'getYAxisSelectedOption'
        }
      }
    }
  };
}

var ChartXYPlaneSettings = (_dec = (0, _Izenda12.exportClass)('ChartXYPlaneSettings'), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ChartXYPlaneSettings, _Component);

  function ChartXYPlaneSettings(props) {
    (0, _classCallCheck3.default)(this, ChartXYPlaneSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChartXYPlaneSettings.__proto__ || (0, _getPrototypeOf2.default)(ChartXYPlaneSettings)).call(this, props));

    _initialiseProps.call(_this);

    _this.cloneElements();
    _this.createBackupData();
    _this.initData();

    var value = props.value || {};
    var xOption = value.xAxisTitleOption || [{}];
    var yOption = value.yAxisTitleOption || [{}];

    _this.state = {
      selectedXAxisOption: xOption[_this.expandedLevel],
      selectedYAxisOption: yOption[0]
    };
    return _this;
  }

  /**
   * Get value when popup is closed
   */


  (0, _createClass3.default)(ChartXYPlaneSettings, [{
    key: 'getValue',
    value: function getValue() {
      this.updateElements('labelsElements');
      this.updateElements('valuesElements');

      // Update preview when set xAxis-type to linear
      var _props = this.props,
          reportPart = _props.reportPartDetails,
          _props$reportPartDeta = _props.reportPartDetails,
          reportPartContent = _props$reportPartDeta.reportPartContent,
          _props$reportPartDeta2 = _props$reportPartDeta.reportPartContent,
          currentDrilldownField = _props$reportPartDeta2.currentDrilldownField,
          resetSortAscending = _props$reportPartDeta2.resetSortAscending,
          fieldStore = _props.fieldStore;


      reportPartContent.isLinear() && resetSortAscending(currentDrilldownField) && fieldStore.needUpdatePreview(reportPart);

      return { metricAllOption: this.metricAllOption };
    }

    /**
     * Clone elements
     */

  }, {
    key: 'cloneElements',
    value: function cloneElements() {
      var value = this.props.value || {};
      var content = this.props.reportPartDetails.reportPartContent;
      value.labelsElements = content.labelsElements.map(function (field) {
        return field.clone();
      });
      value.valuesElements = content.valuesElements.map(function (field) {
        return field.clone();
      });
    }

    /**
     * Update elements
     * @param {any} type
     */

  }, {
    key: 'updateElements',
    value: function updateElements(type) {
      var _props2 = this.props,
          value = _props2.value,
          content = _props2.reportPartDetails.reportPartContent;


      content[type].forEach(function (item, index) {
        item.setOtherProps(null, (0, _fp.invoke)('properties.getOtherProps', value[type][index]));
      });
    }

    /**
     * Create backup data
     */

  }, {
    key: 'createBackupData',
    value: function createBackupData() {
      var value = this.props.value || {};
      this.backUpData = {
        xAxis: (0, _fp.map)(function (element) {
          return {
            backUpData: element.properties.getOtherProps(),
            element: element
          };
        }, value.labelsElements),
        yAxis: value.valuesElements.map(function (element) {
          return element.properties.getOtherProps(OTHER_PROPS_AXIS_KEY);
        })
      };
    }

    /**
     * Init data
     * Store drilldown data to this instance
     */

  }, {
    key: 'initData',
    value: function initData() {
      var props = this.props;
      var value = props.value || {};
      var reportPartDetails = props.reportPartDetails;
      this.activeSeriesKey = null;
      this.metricAllOption = value.metricAllOption;

      this.expandedLevel = reportPartDetails.reportPartContent.expandedLevel;
      this.previewData = reportPartDetails.previewData;
      this.previewDataRecords = reportPartDetails.previewDataRecords || [];
      this.previewDataFieldsMapping = reportPartDetails.previewDataFieldsMapping || [];
    }

    /**
     * Get configuration for properties editor
     * @returns {any}
     */

  }, {
    key: 'getConfigurationDef',
    value: function getConfigurationDef() {
      var _this2 = this;

      var value = this.props.value || {};
      var metricAllOption = this.metricAllOption;
      var _state = this.state,
          selectedXAxisOption = _state.selectedXAxisOption,
          selectedYAxisOption = _state.selectedYAxisOption;

      var xOption = value.xAxisTitleOption || [];
      var yOption = value.yAxisTitleOption || [];
      var backUpData = this.backUpData;

      var xField = (0, _fp.find)({ fieldName: selectedXAxisOption.value }, value.labelsElements);
      var yField = (0, _fp.find)({ fieldName: selectedYAxisOption.value }, value.valuesElements);
      this.xField = xField;
      this.yField = yField;

      return {
        definedSchema: getSchemaDef(xOption, yOption),
        widgets: WIDGET,
        source: {},
        mappingProps: {
          syncXAxisType: (0, _mobx.action)(function (newValue) {
            (0, _fp.forEach)(function (field) {
              field !== _this2.xField && field.previewDataType !== _Izenda6.DATA_TYPES.TEXT && setXAxisType(newValue, field);
            }, value.labelsElements);
          }),
          setXAxisType: (0, _mobx.action)(function (newValue) {
            _this2.xField && setXAxisType(newValue, _this2.xField);
          }),
          disabledSyncButton: function disabledSyncButton() {
            return (0, _fp.flow)((0, _fp.reduce)(function (acc, field) {
              if (field.previewDataType === _Izenda6.DATA_TYPES.TEXT) {
                return acc;
              }
              var isCategory = (0, _fp.getOr)(false, 'izCategory', field.properties.getOtherProps(OTHER_PROPS_AXIS_KEY));

              return (0, _fp.set)(isCategory, true, acc);
            }, {}), _fp.values, (0, _fp.get)('length'), (0, _fp.isEqual)(1))(value.labelsElements);
          }
        },
        mappingSource: {
          getXAxis: function getXAxis() {
            return xField && constructAxisProps(xField.getValueByKey(OTHER_PROPS_AXIS_KEY), 'xAxis', xField.fieldName, xField.previewDataType);
          },
          getYAxis: function getYAxis() {
            return (0, _fp.isEmpty)(selectedYAxisOption.value) ? constructAxisProps(metricAllOption, 'yAxis', _Izenda9.default.getText('COMMON_LABEL_ALL')) : yField && constructAxisProps(yField.getValueByKey(OTHER_PROPS_AXIS_KEY), 'yAxis', yField.fieldName, yField.previewDataType);
          },
          getXAxisSelectedOption: function getXAxisSelectedOption() {
            return selectedXAxisOption;
          },
          getYAxisSelectedOption: function getYAxisSelectedOption() {
            return selectedYAxisOption;
          },
          getXAxisSelectedOptionValue: function getXAxisSelectedOptionValue() {
            return (0, _fp.get)('value', selectedXAxisOption);
          },
          getYAxisSelectedOptionValue: function getYAxisSelectedOptionValue() {
            return (0, _fp.get)('value', selectedYAxisOption);
          }
        },
        onChangeValue: this.onChangeValue
      };

      function setXAxisType(isCategory, field) {
        if (field) {
          var overrideValue = {
            izCategory: isCategory
          };
          field.setOtherProps(OTHER_PROPS_AXIS_KEY, (0, _fp.assign)(field.getValueByKey(OTHER_PROPS_AXIS_KEY), overrideValue));
          if (isCategory) {
            // remove threshold setting if change to category
            field.setOtherProps(OTHER_PROPS_THRESHOLD_KEY, []);
          } else {
            // use back up date to revert threshold setting when change back from category to linear
            var backUp = (0, _fp.find)(function (item) {
              return item.element === field;
            }, backUpData.xAxis);

            field.setOtherProps(OTHER_PROPS_THRESHOLD_KEY, (0, _fp.get)(OTHER_PROPS_THRESHOLD_KEY, backUp.backUpData));
          }
        }
      }

      function constructAxisProps(axis, type, defaultText, dataType) {
        axis = axis || {};
        var style = axis['izTitle.style'] || {};
        return {
          //type: type,
          dataType: dataType,
          text: (0, _fp.isNil)(axis['izTitle.text']) ? defaultText : axis['izTitle.text'],
          enabled: (0, _fp.isNil)(axis['izTitle.enabled']) ? true : axis['izTitle.enabled'],
          font: {
            style: {
              fontBold: style.fontWeight === FONT_STYLE.BOLD,
              fontItalic: style.fontStyle === FONT_STYLE.ITALIC,
              fontUnderline: style.textDecoration === FONT_STYLE.UNDERLINE
            },
            format: {
              fontFamily: style.fontFamily,
              fontSize: style.fontSize
            },
            color: style.color || CONSTANTS.BLACK_COLOR,
            backgroundColor: style.backgroundColor
          },
          alignment: axis['izTitle.align'] || 'izMiddle',
          intervals: axis['izTickInterval'],
          categoryIntervals: axis['izTickCategoryInterval'],
          startingPoint: axis['izStartingPoint'],
          isCategory: axis['izCategory']
        };
      }
    }

    /**
     * Get chart data
     */

  }, {
    key: 'getChartData',
    value: function getChartData() {
      var reportPartDetails = this.props.reportPartDetails;
      var reportPartContent = reportPartDetails.reportPartContent;
      var chartType = reportPartContent.chartType;
      var key = isChartType(chartType, _Izenda5.CHART_TYPE.Combination, _Izenda5.CHART_TYPE.Sparkline) ? null : this.activeSeriesKey;
      key = (0, _fp.isString)(key) ? key : key && key.name;
      return (0, _Izenda7.parser)(reportPartContent.getActiveElmsByActiveSeries(key), this.expandedLevel, {
        fieldsMapping: this.previewDataFieldsMapping,
        records: this.previewDataRecords,
        rawData: this.previewData
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          allChartProps = _props3.allChartProps,
          value = _props3.value;

      var allProps = allChartProps();
      allProps.seriesOptions = [].concat((0, _toConsumableArray3.default)(value.labelsElements), (0, _toConsumableArray3.default)(value.valuesElements), (0, _toConsumableArray3.default)(value.separatorsElements));
      var chartOptions = {
        commonXYAxis: {
          metricAllOption: this.metricAllOption
        }
      };

      return _react2.default.createElement(_Izenda2.default, {
        className: 'xy-plane-settings',
        type: this.props.reportPartType,
        configurationDef: this.getConfigurationDef(),
        chartOptions: chartOptions,
        allChartProps: allProps,
        chartData: this.getChartData()
      });
    }
  }]);
  return ChartXYPlaneSettings;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onChangeValue = function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
    var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
    var fieldData = groupData[changedKey];

    fieldData && (fieldData.value = changedValue);

    var value = _this3.props.value;
    var xAxisTitle = schemaData.xAxisTitle;
    var yAxisTitle = schemaData.yAxisTitle;
    var xOption = value.xAxisTitleOption || [];
    var yOption = value.yAxisTitleOption || [];

    if (changedKey === 'xAxisTitle') {
      var index = (0, _fp.findIndex)({ fieldName: xAxisTitle.value }, value.labelsElements) || 0;
      return _this3.props.fieldStore.getRandomPreviewData(index).bind(_this3).then(function (result) {
        result = result || {};
        _this3.expandedLevel = index;
        _this3.previewData = result;
        _this3.previewDataRecords = result.records || [];
        _this3.previewDataFieldsMapping = result.fieldsMapping || [];
      }).finally(function () {
        updateOption.call(_this3);
      });
    } else {
      _this3.xField && _this3.xField.setOtherProps(OTHER_PROPS_AXIS_KEY, (0, _fp.assign)(_this3.xField.getValueByKey(OTHER_PROPS_AXIS_KEY), constructAxisChartOption(schemaData.xAxis || {})));
      if (!(0, _fp.get)('selectedYAxisOption.value', _this3.state)) {
        _this3.metricAllOption = (0, _fp.assign)(_this3.metricAllOption, constructAxisChartOption(schemaData.yAxis || {}));
      } else {
        _this3.yField && _this3.yField.setOtherProps(OTHER_PROPS_AXIS_KEY, (0, _fp.assign)(_this3.yField.getValueByKey(OTHER_PROPS_AXIS_KEY), constructAxisChartOption(schemaData.yAxis || {})));
      }
      // set active series key, if the charType's field container is values container
      var chartType = (0, _fp.get)('reportPartContent.chartType', _this3.props.reportPartDetails);
      !isChartType.apply(undefined, [chartType].concat(VALUE_LABEL_METRICS_CHART)) && (_this3.activeSeriesKey = yAxisTitle.value || null);
      updateOption.call(_this3);
    }

    function constructChartStyle(font) {
      font = font || {};
      font.style = font.style || {};
      font.format = font.format || {};

      var fontSize = font.format.fontSize;
      return {
        fontWeight: font.style.fontBold ? FONT_STYLE.BOLD : '',
        fontStyle: font.style.fontItalic ? FONT_STYLE.ITALIC : '',
        textDecoration: font.style.fontUnderline ? FONT_STYLE.UNDERLINE : '',
        fontSize: (0, _fp.isNil)(fontSize) || (0, _fp.flow)(_fp.toString, (0, _fp.endsWith)('px'))(fontSize) ? fontSize : fontSize + 'px',
        fontFamily: font.format.fontFamily,
        color: font.color,
        backgroundColor: font.backgroundColor
      };
    }

    function constructAxisChartOption(axis) {
      var font = axis.value.font || {};
      var isCategory = axis.value.isCategory;

      return {
        'izTitle.enabled': axis.value.enabled,
        'izTitle.text': axis.value.text,
        'izTitle.style': constructChartStyle(font),
        'izTitle.align': axis.value.alignment,
        izTickInterval: axis.value.intervals,
        izTickCategoryInterval: axis.value.categoryIntervals,
        izStartingPoint: axis.value.startingPoint,
        izStartOnTick: (0, _fp.isNil)(axis.value.startingPoint),
        izCategory: isCategory
      };
    }

    function updateOption() {
      var xAxisDateTimeFormat = (0, _fp.find)({ value: xAxisTitle.value }, xOption);
      var yAxisDateTimeFormat = (0, _fp.find)({ value: yAxisTitle.value }, yOption);

      this.setState({
        selectedXAxisOption: {
          value: xAxisTitle.value,
          dateTimeFormatData: xAxisDateTimeFormat.dateTimeFormatData
        },
        selectedYAxisOption: {
          value: yAxisTitle.value,
          dateTimeFormatData: yAxisDateTimeFormat.dateTimeFormatData
        }
      });
    }
  };
}, _temp)) || _class);
exports.default = ChartXYPlaneSettings;
module.exports = exports['default'];

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartXYPlaneSettingsAxis.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(17);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(29);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(109);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(411);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(30);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(39);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(16);

var _Izenda14 = __webpack_require__(34);

var _Izenda15 = __webpack_require__(12);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(562);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONSTANTS = _Izenda12.default.CHART_SETTINGS.XY_PLANE;
var MAX_SIGN_INT = Math.pow(2, 32);

var NumericInputWithTooltip = function NumericInputWithTooltip(props) {
  return _react2.default.createElement(
    'div',
    { className: 'row input-with-info' },
    _react2.default.createElement(
      'span',
      { className: 'col-md-4' },
      props.label
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-md-8' },
      _react2.default.createElement(_Izenda6.default, {
        value: props.value,
        isDecimal: props.dataType !== _Izenda13.DATA_TYPES.DATE_TIME,
        min: 0.0001,
        max: MAX_SIGN_INT,
        showInfoIcon: true,
        hint: props.hint,
        onChange: props.onChange
      })
    )
  );
};

var StartingPoint = function StartingPoint(props) {
  if (props.isCategory) {
    return null;
  }

  var renderControl = function renderControl() {
    var dataType = props.dataType;
    var isDisabled = dataType === _Izenda13.DATA_TYPES.TEXT || dataType === _Izenda13.DATA_TYPES.IMAGE;

    return dataType === _Izenda13.DATA_TYPES.DATE_TIME && !isDisabled ? _react2.default.createElement(
      'div',
      { className: 'numeric-input show-icon' },
      _react2.default.createElement(_Izenda18.default, {
        className: 'u_floatLeft',
        isDecimal: false,
        value: props.value,
        onChange: props.onChange,
        groupByDateTime: (0, _fp.get)('dateTimeFormatData.groupBy', props.selectedAxis)
      }),
      _react2.default.createElement(
        'a',
        null,
        _react2.default.createElement('span', { className: 'icon-info-circled', title: props.hint })
      )
    ) : _react2.default.createElement(_Izenda6.default, {
      value: props.value,
      max: MAX_SIGN_INT,
      showInfoIcon: true,
      hint: props.hint,
      disabled: isDisabled,
      onChange: props.onChange
    });
  };

  return _react2.default.createElement(
    'div',
    { className: 'row input-with-info' },
    _react2.default.createElement(
      'span',
      { className: 'col-md-4' },
      props.label
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-md-8' },
      renderControl()
    )
  );
};

var Axis = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Axis, _Component);

  function Axis(props) {
    (0, _classCallCheck3.default)(this, Axis);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Axis.__proto__ || (0, _getPrototypeOf2.default)(Axis)).call(this, props));

    _initialiseProps.call(_this);

    _this.onChangeWithDebounce = (0, _fp.debounce)(_Izenda14.DEFAULT_DEBOUNCE_TIME, props.onChange);

    var _props$value = props.value,
        text = _props$value.text,
        enabled = _props$value.enabled,
        font = _props$value.font,
        alignment = _props$value.alignment,
        intervals = _props$value.intervals,
        categoryIntervals = _props$value.categoryIntervals,
        startingPoint = _props$value.startingPoint,
        isCategory = _props$value.isCategory;

    // due to dynamic structure of state, we cannot use mobx here

    _this.state = {
      text: text,
      enabled: enabled,
      font: font,
      alignment: alignment,
      intervals: intervals,
      categoryIntervals: categoryIntervals,
      startingPoint: startingPoint,
      isCategory: isCategory,
      disabledSyncButton: true
    };
    return _this;
  }

  (0, _createClass3.default)(Axis, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _ref = nextProps.value || {},
          text = _ref.text,
          enabled = _ref.enabled,
          font = _ref.font,
          alignment = _ref.alignment,
          intervals = _ref.intervals,
          categoryIntervals = _ref.categoryIntervals,
          startingPoint = _ref.startingPoint,
          isCategory = _ref.isCategory;

      this.setState({
        text: text,
        enabled: enabled,
        font: font,
        alignment: alignment,
        intervals: intervals,
        categoryIntervals: categoryIntervals,
        startingPoint: startingPoint,
        isCategory: isCategory,
        disabledSyncButton: (0, _fp.invoke)('disabledSyncButton', nextProps)
      });
    }

    /**
     * Handle change of state
     * @param {string} key
     * @param {Object} value
     * @param {boolean} useDebounce
     */


    /**
     * Handle on change of Enabled
     * @param {Object} e
     */


    /**
     * Handle on change of Title
     * @param {Object} e
     */


    /**
     * Handle on change of Font
     * @param {Object} font
     */


    /**
     * Handle on change of Alignment
     * @param {Object} newOption
     */


    /**
     * Handle on change of Tick Interval
     * @param {Object} value
     */


    /**
     * Handle on change of Starting Point
     * @param {Object} value
     */


    /**
     * Update XAxis Type
     * @param {Object} value
     */


    /**
     * Switch to Linear
     */


    /**
     * Switch to Category
     */


    /**
     * Sync xAxis Type
     */


    /**
     * Resolve label field
     */


    /**
     * Render xAxis type
     */

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          font = _state.font,
          isCategory = _state.isCategory,
          categoryIntervals = _state.categoryIntervals,
          _intervals = _state.intervals,
          enabled = _state.enabled,
          text = _state.text,
          alignment = _state.alignment,
          startingPoint = _state.startingPoint;
      var _props = this.props,
          value = _props.value,
          type = _props.type,
          selectedAxis = _props.selectedAxis;

      var HINT = CONSTANTS[type].TOOLTIP || {};
      var ALIGN_DROPDOWN_OPTION = CONSTANTS.XY_PLANE_TITLE_OPTION;
      var intervals = isCategory ? categoryIntervals : _intervals;

      return _react2.default.createElement(
        'div',
        { className: 'axis u_fullWidth' },
        _react2.default.createElement(
          'div',
          { className: 'row title' },
          _react2.default.createElement(
            'span',
            { className: 'col-md-4' },
            _Izenda16.default.getText('COMMON_LABEL_TITLE')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(_Izenda2.default, { type: 'checkbox', checked: enabled, onChange: this.handleEnabledChange }),
            _react2.default.createElement(_Izenda2.default, { disabled: !enabled, value: text, onChange: this.handleTitleChange })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row xyplane-font-setting' },
          _react2.default.createElement(
            'span',
            { className: 'col-md-4' },
            _Izenda16.default.getText('FONT_SETTINGS_LABEL_FONT')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(_Izenda8.default, { value: font, disabled: !enabled, onChange: this.handleFontChange })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row alignment' },
          _react2.default.createElement(
            'span',
            { className: 'col-md-4' },
            _Izenda16.default.getText('FONT_SETTINGS_LABEL_ALIGNMENT')
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-8' },
            _react2.default.createElement(_Izenda4.default, {
              disabled: !enabled,
              options: ALIGN_DROPDOWN_OPTION,
              value: alignment,
              labelField: this.getLabelField,
              onChange: this.handleAlignmentChanged
            })
          )
        ),
        type === 'xAxis' && this.renderxAxisType(),
        _react2.default.createElement(NumericInputWithTooltip, {
          value: intervals,
          dataType: value.dataType,
          label: _Izenda16.default.getText('REPORTDESIGNER_LABEL_INTERVALS'),
          onChange: this.handleTickIntervalChanged,
          hint: HINT.INTERVALS
        }),
        _react2.default.createElement(StartingPoint, {
          value: startingPoint,
          dataType: value.dataType,
          label: _Izenda16.default.getText('REPORTDESIGNER_LABEL_STARTING_POINT'),
          onChange: this.handleStartingPointChanged,
          selectedAxis: selectedAxis,
          hint: HINT.STARTING_POINT,
          isCategory: isCategory
        })
      );
    }
  }]);
  return Axis;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.changeState = function (key, value, useDebounce) {
    var newState = (0, _defineProperty3.default)({}, key, value);

    _this2.setState(newState, function () {
      useDebounce ? _this2.onChangeWithDebounce({ value: _this2.state }) : _this2.props.onChange({ value: _this2.state });
    });
  };

  this.handleEnabledChange = function (e) {
    _this2.changeState('enabled', e.target.checked);
  };

  this.handleTitleChange = function (e) {
    _this2.changeState('text', e.target.value, true);
  };

  this.handleFontChange = function (font) {
    _this2.changeState('font', font.value);
  };

  this.handleAlignmentChanged = function (newOption) {
    _this2.changeState('alignment', newOption.value);
  };

  this.handleTickIntervalChanged = function (value) {
    if ((0, _fp.isNaN)(value)) {
      return;
    }
    var intervalKey = _this2.state.isCategory ? 'categoryIntervals' : 'intervals';
    _this2.changeState(intervalKey, value, true);
  };

  this.handleStartingPointChanged = function (value) {
    if ((0, _fp.isNaN)(value)) {
      return;
    }
    value === 'Invalid date' && (value = null);
    _this2.changeState('startingPoint', value, true);
  };

  this.setXAxisType = function (value) {
    _this2.props.setXAxisType(value);
    _this2.setState({
      isCategory: value,
      disabledSyncButton: (0, _fp.invoke)('disabledSyncButton', _this2.props)
    });
  };

  this.switchToLinear = function () {
    _this2.state.isCategory && _this2.setXAxisType(false);
  };

  this.switchToCategory = function () {
    !_this2.state.isCategory && _this2.setXAxisType(true);
  };

  this.syncXAxisType = function () {
    _this2.props.syncXAxisType(_this2.state.isCategory);
    _this2.setState({ disabledSyncButton: true });
  };

  this.getLabelField = function (option) {
    return _Izenda16.default.getText(['XY_PLANE_TITLE_OPTION', _this2.props.type, option.value].join('_'));
  };

  this.renderxAxisType = function () {
    var state = _this2.state;
    var value = _this2.props.value;
    return value.dataType !== _Izenda13.DATA_TYPES.TEXT && _react2.default.createElement(
      'div',
      { className: 'row input-with-info' },
      _react2.default.createElement(
        'span',
        { className: 'col-md-4' },
        _Izenda16.default.getText('XY_PLANE_LABEL_XAXIS_TYPE')
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-md-8' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-6 u_noPaddingLeft' },
          _react2.default.createElement(_Izenda2.default, { type: 'radio', checked: !state.isCategory, onChange: _this2.switchToLinear }),
          '\xA0',
          _Izenda16.default.getText('XY_PLANE_LABEL_LINEAR'),
          _react2.default.createElement('a', { title: _Izenda16.default.getText('XY_PLANE_LABEL_LINEAR_TOOLTIP'), className: 'icon-help-circled' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-md-6' },
          _react2.default.createElement(_Izenda2.default, { type: 'radio', checked: state.isCategory, onChange: _this2.switchToCategory }),
          '\xA0',
          _Izenda16.default.getText('XY_PLANE_LABEL_VALUE'),
          _react2.default.createElement('a', { title: _Izenda16.default.getText('XY_PLANE_LABEL_VALUE_TOOLTIP'), className: 'icon-help-circled' })
        ),
        _react2.default.createElement(_Izenda10.default, {
          label: _Izenda16.default.getText('XY_PLANE_LABEL_APPLY_ALL'),
          className: 'u_marginTop',
          onClick: _this2.syncXAxisType,
          disabled: state.disabledSyncButton
        })
      )
    );
  };
}, _temp);
exports.default = Axis;
module.exports = exports['default'];

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartGridLines.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var React = __webpack_require__(0);
  var ChartSettingsContainer = __webpack_require__(193);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      get = _require.get,
      assign = _require.assign;

  var WIDGET = {
    Axis: __webpack_require__(2044)
  };

  var SCHEMA_DEF = {
    schemaKey: 'GRID_LINES_SCHEMA',
    fields: {
      xAxis: {
        get title() {
          return localizer.getText('REPORTDESIGNER_TOOLTIP_X_AXIS_LOWER');
        },
        fieldClassName: 'u_inlineBlock u_fullWidth izenda-GridLine-XAxis u_paddingBottom',
        component: 'Axis',
        fnValue: 'getXAxis'
      },
      yAxis: {
        get title() {
          return localizer.getText('REPORTDESIGNER_TOOLTIP_Y_AXIS_LOWER');
        },
        fieldClassName: 'u_inlineBlock u_fullWidth',
        component: 'Axis',
        fnValue: 'getYAxis'
      }
    }
  };

  var ChartGridLinesSettings = React.createClass({
    displayName: 'ChartGridLinesSettings',

    getValue: function getValue() {
      var state = this.state;
      return {
        xAxis: state.xAxis,
        yAxis: state.yAxis
      };
    },

    getInitialState: function getInitialState() {
      var value = this.props.value || {};
      return {
        xAxis: m.toJS(value.xAxis),
        yAxis: m.toJS(value.yAxis)
      };
    },

    getConfigurationDef: function getConfigurationDef() {
      var state = this.state;
      var xAxis = state.xAxis;
      var yAxis = state.yAxis;

      return {
        definedSchema: SCHEMA_DEF,
        widgets: WIDGET,
        source: {},
        mappingSource: {
          getXAxis: function getXAxis() {
            return constructAxisProps(xAxis);
          },
          getYAxis: function getYAxis() {
            return constructAxisProps(yAxis);
          }
        },
        onChangeValue: this.onChangeValue
      };

      function constructAxisProps(axis) {
        axis = axis || {};
        return {
          visible: !!(axis['izGrid.lineWidth'] || axis['izGrid.lineDashStyle']),
          lineWidth: axis['izGrid.lineWidth'],
          lineColor: axis['izGrid.lineColor'],
          lineDashStyle: axis['izGrid.lineDashStyle']
        };
      }
    },

    render: function render() {
      var state = this.state;

      var allChartProps = this.props.allChartProps;

      var chartOptions = {
        commonXYAxis: {
          izGridLine: {
            xAxis: state.xAxis,
            yAxis: state.yAxis
          }
        }
      };

      return React.createElement(ChartSettingsContainer, {
        className: 'grid-lines-settings',
        type: this.props.reportPartType,
        configurationDef: this.getConfigurationDef(),
        assignChartOptions: chartOptions,
        allChartProps: allChartProps
      });
    },

    onChangeValue: function onChangeValue(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
      var groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
      var fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      var state = this.state;
      var xAxis = schemaData.xAxis || {};
      var yAxis = schemaData.yAxis || {};

      function constructGridLinesAxisOption(axis) {
        var value = get('value', axis, {});
        if (value.visible) {
          return {
            'izGrid.lineWidth': value.lineWidth,
            'izGrid.lineColor': value.lineColor,
            'izGrid.lineDashStyle': value.lineDashStyle
          };
        }
        return {
          'izGrid.lineWidth': undefined,
          'izGrid.lineColor': undefined,
          'izGrid.lineDashStyle': undefined
        };
      }

      this.setState({
        xAxis: assign(state.xAxis, constructGridLinesAxisOption(xAxis)),
        yAxis: assign(state.yAxis, constructGridLinesAxisOption(yAxis))
      });
    }
  });

  module.exports = ChartGridLinesSettings;
}();

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartGridLinesSettingsAxis.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);
  var Input = __webpack_require__(17);
  var ColorPicker = __webpack_require__(169);
  var DashStyle = __webpack_require__(322);
  var Thickness = __webpack_require__(190);
  var CONSTANTS = __webpack_require__(39).CHART_SETTINGS.DEFAULT_VALUE;
  var localizer = __webpack_require__(12);

  var ChartGridLinesSettingsAxis = React.createClass({
    displayName: 'ChartGridLinesSettingsAxis',


    getInitialState: function getInitialState() {
      var value = this.props.value;
      return {
        visible: value.visible,
        lineWidth: value.lineWidth || 1,
        lineColor: value.lineColor || CONSTANTS.BLACK_COLOR,
        lineDashStyle: value.lineDashStyle || CONSTANTS.DASH_STYLE
      };
    },

    changeState: function changeState(key, value) {
      var obj = {};
      obj[key] = value;
      this.setState(obj, function () {
        this.props.onChange({ value: this.state });
      }.bind(this));
    },

    handleVisibleChanged: function handleVisibleChanged(newValue) {
      this.changeState('visible', newValue);
    },

    handleLineColorChanged: function handleLineColorChanged(newValue) {
      this.changeState('lineColor', newValue);
    },

    handleChangeDashStyle: function handleChangeDashStyle(newValue) {
      this.changeState('lineDashStyle', newValue);
    },

    handleThicknessChanged: function handleThicknessChanged(thickness) {
      this.changeState('lineWidth', thickness.value);
    },

    render: function render() {

      var state = this.state;

      return React.createElement(
        'div',
        { className: 'grid-line-settings-axis' },
        React.createElement(
          'div',
          { className: 'row visible' },
          React.createElement(
            'span',
            { className: 'col-md-4' },
            localizer.getText("COMMON_LABEL_VISIBLE")
          ),
          React.createElement(Input, { type: 'checkbox', checked: state.visible,
            onChange: EventUtils.notifyChange(this.handleVisibleChanged, EventUtils.CHECKBOX) })
        ),
        React.createElement(
          'div',
          { className: 'row color' },
          React.createElement(
            'span',
            { className: 'col-md-4' },
            localizer.getText("COMMON_LABEL_COLOR")
          ),
          React.createElement(
            'div',
            { className: 'col-md-8' },
            React.createElement(ColorPicker, { disabled: !state.visible,
              color: state.lineColor,
              type: 'photoshop',
              onChange: this.handleLineColorChanged })
          )
        ),
        React.createElement(
          'div',
          { className: 'row style' },
          React.createElement(
            'span',
            { className: 'col-md-4' },
            localizer.getText("BORDER_SETTING_LABEL_DASH_STYLE")
          ),
          React.createElement(
            'div',
            { className: 'col-md-8' },
            React.createElement(DashStyle, { dashStyle: state.lineDashStyle,
              disabled: !state.visible,
              onChange: this.handleChangeDashStyle })
          )
        ),
        React.createElement(
          'div',
          { className: 'row thickness' },
          React.createElement(
            'span',
            { className: 'col-md-4' },
            localizer.getText("BORDER_SETTING_LABEL_THICKNESS")
          ),
          React.createElement(
            'div',
            { className: 'col-md-8' },
            React.createElement(Thickness, { value: state.lineWidth,
              disabled: !state.visible,
              onChange: this.handleThicknessChanged })
          )
        )
      );
    }

  });

  module.exports = ChartGridLinesSettingsAxis;
}();

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _class3, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ThresholdSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ThresholdSettings Component
 */

__webpack_require__(55);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(193);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(80);

var _Izenda4 = __webpack_require__(33);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _mobxReact = __webpack_require__(10);

var _Izenda7 = __webpack_require__(39);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var VALUE_LABEL_METRICS_CHART = [_Izenda4.CHART_TYPE.HeatMap, _Izenda4.CHART_TYPE.Bubble, _Izenda4.CHART_TYPE.Scatter];
var OTHER_PROPS_THRESHOLD_KEY = 'threshold';

/**
 * Check chart has support all metric options
 * @param {String} chartType
 */
var hasSupportAllMetric = function hasSupportAllMetric(chartType) {
  return !(0, _Izenda7.isChartType)(chartType, _Izenda4.CHART_TYPE.Scatter, _Izenda4.CHART_TYPE.Bubble, _Izenda4.CHART_TYPE.Combination, _Izenda4.CHART_TYPE.Waterfall);
};

/**
 * Get schema
 * @param {Object} xOption
 * @param {Object} yOption
 * @param {Array<any>} dataTree
 * @param {Object} reportPartContent
 * @param {Object} fieldStore
 * @param {Object} reportPartDetails
 */
function getSchema(xOption, yOption, dataTree, reportPartContent, fieldStore, reportPartDetails) {
  var chartType = reportPartDetails.reportPartContent.properties.chartType;
  return {
    schemaKey: 'THRESHOLD_SETTINGS_SCHEMA',
    fields: {
      xAxisTitle: {
        title: _Izenda6.default.getText('THREHOSLD_X_LABEL'),
        type: 'static',
        isHidden: 'isHiddenXAxis'
      },
      xAxis: {
        component: __webpack_require__(1110),
        fnValue: 'getXAxis',
        props: {
          staticThreshold: true,
          axis: 'xAxis',
          selectedAxis: 'getXAxisSelectedOption',
          dataType: 'getXAxisDataType',
          options: xOption,
          chartType: chartType
        },
        isHidden: 'isHiddenXAxis'
      },
      yAxisTitle: {
        title: _Izenda6.default.getText('THREHOSLD_Y_LABEL'),
        type: 'static',
        isHidden: 'isHiddenYAxis'
      },
      yAxis: {
        component: __webpack_require__(1110),
        fnValue: 'getYAxis',
        props: {
          selectedAxis: 'getYAxisSelectedOption',
          axis: 'yAxis',
          dataType: 'getYAxisDataType',
          options: yOption,
          dataTree: dataTree,
          reportPartContent: reportPartContent,
          fieldStore: fieldStore,
          reportPartDetails: reportPartDetails,
          chartType: chartType
        },
        isHidden: 'isHiddenYAxis'
      }
    }
  };
}

var ThresholdSettings = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ThresholdSettings, _Component);

  function ThresholdSettings(props) {
    (0, _classCallCheck3.default)(this, ThresholdSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ThresholdSettings.__proto__ || (0, _getPrototypeOf2.default)(ThresholdSettings)).call(this, props));

    _initialiseProps.call(_this);

    _this.cloneElements();
    _this.initData();
    var value = props.value || {};
    var xOption = value.xAxisTitleOption,
        yOption = value.yAxisTitleOption;


    _this.state = {
      selectedXAxisOption: xOption.length > 0 && (0, _fp.head)(xOption),
      selectedYAxisOption: yOption.length > 0 && (0, _fp.head)(yOption)
    };
    return _this;
  }

  /**
   * Get value when this popup is closed
   */


  (0, _createClass3.default)(ThresholdSettings, [{
    key: 'getValue',
    value: function getValue() {
      var _this2 = this;

      var listDynamicField = [];
      this.updateElements('labelsElements', listDynamicField);
      this.updateElements('valuesElements', listDynamicField);

      // Update threholds field in customContainers
      this.props.reportPartDetails.reportPartContent.updateDynamicThresholdFieldInContainer(this.reportPartDetails.reportPartContent.customContainers[0].elements);

      (0, _fp.forEach)(function (item) {
        var matchField = (0, _fp.find)(['id', item.izValue], _this2.props.fieldStore.dataTree.flattenQuerySourceIncludeCalculatedField);
        !(0, _fp.isNil)(matchField) && listDynamicField.push(matchField);
      }, this.allDynamicThresholdLine);

      return {
        metricAllPlotLinesOption: this.metricAllPlotLinesOption,
        dynamicThresholdField: listDynamicField,
        allDynamicThresholdLine: this.allDynamicThresholdLine
      };
    }

    /**
     * Clone elements
     */

  }, {
    key: 'cloneElements',
    value: function cloneElements() {
      this.reportPartDetails = this.props.reportPartDetails.clone();
      this.reportPartDetails.colorPalettes = this.props.reportPartDetails.colorPalettes;
    }

    /**
     * Update elements
     * @param {string} type
     */

  }, {
    key: 'updateElements',
    value: function updateElements(type, listDynamicField) {
      var _this3 = this;

      var reportPartContent = this.reportPartDetails.reportPartContent;
      var content = this.props.reportPartDetails.reportPartContent;

      content[type].forEach(function (item, index) {
        var newValue = (0, _fp.invokeArgs)('properties.getOtherProps', [OTHER_PROPS_THRESHOLD_KEY], reportPartContent[type][index]);
        item.setOtherProps(OTHER_PROPS_THRESHOLD_KEY, newValue);
        var dynamic = (0, _fp.invokeArgs)('properties.getOtherProps', [_Izenda7.ContainerName.DYNAMIC_THRESHOLD], reportPartContent[type][index]);
        item.setOtherProps(_Izenda7.ContainerName.DYNAMIC_THRESHOLD, dynamic);
        if (!(0, _fp.isNil)(dynamic)) {
          var dataTree = _this3.props.fieldStore.dataTree.flattenQuerySourceIncludeCalculatedField;
          (0, _fp.forEach)(function (item) {
            var matchField = (0, _fp.find)(['id', item.izValue], dataTree);
            !(0, _fp.isNil)(matchField) && listDynamicField.push(matchField);
          }, dynamic);
        }
      });
    }

    /**
     * Init data
     * Store drilldown data to this instance
     */

  }, {
    key: 'initData',
    value: function initData() {
      var props = this.props;
      var value = props.value || {};
      var reportPartDetails = this.reportPartDetails;
      this.activeSeriesKey = null;
      this.metricAllPlotLinesOption = value.metricAllPlotLinesOption;
      this.allDynamicThresholdLine = value.allDynamicThresholdLine;
      this.expandedLevel = 0;

      this.previewData = reportPartDetails.previewData;
      this.previewDataRecords = reportPartDetails.previewDataRecords || [];
      this.previewDataFieldsMapping = reportPartDetails.previewDataFieldsMapping || [];
    }

    /**
     * Get chart data
     */

  }, {
    key: 'getChartData',
    value: function getChartData() {
      var reportPartDetails = this.reportPartDetails;
      var reportPartContent = reportPartDetails.reportPartContent;
      var chartType = reportPartContent.chartType;
      var key = (0, _Izenda7.isChartType)(chartType, _Izenda4.CHART_TYPE.Combination, _Izenda4.CHART_TYPE.Sparkline) ? null : this.activeSeriesKey;
      key = (0, _fp.isString)(key) ? key : key && key.name;
      return (0, _Izenda3.parser)(reportPartContent.getActiveElmsByActiveSeries(key), this.expandedLevel, {
        fieldsMapping: this.previewDataFieldsMapping,
        records: this.previewDataRecords,
        rawData: this.previewData
      });
    }

    /**
     * Get configuration definition
     */

  }, {
    key: 'getConfigurationDef',
    value: function getConfigurationDef() {
      var _this4 = this;

      var chartType = (0, _fp.get)('reportPartContent.chartType', this.props.reportPartDetails);
      var props = this.props;
      var supportALlOptions = hasSupportAllMetric(chartType);

      var metricAllPlotLinesOption = supportALlOptions ? this.metricAllPlotLinesOption || [] : [];

      var allDynamicThresholdLine = supportALlOptions ? this.allDynamicThresholdLine || [] : [];
      var value = props.value || {};
      var reportPartContent = props.reportPartDetails.reportPartContent;

      var xOption = value.xAxisTitleOption || [];
      var yOption = value.yAxisTitleOption || [];

      var _state = this.state,
          selectedXAxisOption = _state.selectedXAxisOption,
          selectedYAxisOption = _state.selectedYAxisOption;


      var xField = (0, _fp.find)({ fieldName: selectedXAxisOption.value }, reportPartContent.labelsElements);
      this.xField = xField;
      var yField = (0, _fp.find)({ fieldName: selectedYAxisOption.value }, reportPartContent.valuesElements);
      var dataTree = this.props.fieldStore.dataTree.flattenQuerySourceIncludeCalculatedField;

      this.yField = yField;
      return {
        definedSchema: getSchema(xOption, yOption, dataTree, reportPartContent, this.props.fieldStore, this.reportPartDetails),
        source: {},
        onChangeValue: this.onChangeValue,
        mappingProps: {
          beforeChangeAxisTitle: function beforeChangeAxisTitle() {
            return props.validation.validate().then(function (result) {
              return result ? (0, _bluebird.resolve)() : (0, _bluebird.reject)(new Error('Validation Fail.'));
            });
          }
        },
        mappingSource: {
          getXAxis: function getXAxis() {
            var thresholds = [];
            (0, _fp.forEach)(function (item) {
              var threshold = item.getValueByKey(OTHER_PROPS_THRESHOLD_KEY) || [];

              // sync new value of metric
              (0, _fp.forEach)(function (thresholdItem) {
                thresholdItem.fieldMappingAlias = item.fieldNameAlias;
              }, threshold);

              thresholds = thresholds.concat(threshold.slice());
            }, reportPartContent.labelsElements);

            return thresholds;
          },
          getYAxis: function getYAxis() {
            var thresholds = metricAllPlotLinesOption || [];

            (0, _fp.forEach)(function (thresholdItem) {
              var thresholdFieldElement = (0, _fp.find)({ fieldName: thresholdItem.fieldName }, _this4.reportPartDetails.reportPartContent.customContainers[0].elements);
              thresholdItem.thresholdFieldElement = thresholdFieldElement;
            }, allDynamicThresholdLine);

            thresholds = thresholds.concat(allDynamicThresholdLine);

            (0, _fp.forEach)(function (item) {
              var threshold = item.getValueByKey(OTHER_PROPS_THRESHOLD_KEY) || [];

              var dynamic = !(0, _Izenda7.isChartType)(chartType, _Izenda4.CHART_TYPE.Scatter, _Izenda4.CHART_TYPE.Bubble) ? item.getValueByKey(_Izenda7.ContainerName.DYNAMIC_THRESHOLD) || [] : [];

              (0, _fp.forEach)(function (thresholdItem) {
                var thresholdFieldElement = (0, _fp.find)({ fieldName: thresholdItem.fieldName }, _this4.reportPartDetails.reportPartContent.customContainers[0].elements);
                thresholdItem.thresholdFieldElement = thresholdFieldElement;
              }, dynamic);

              (0, _fp.forEach)(function (thresholdItem) {
                thresholdItem.fieldMappingAlias = item.fieldNameAlias;
              }, dynamic);

              // sync new value of metric
              (0, _fp.forEach)(function (thresholdItem) {
                thresholdItem.fieldMappingAlias = item.fieldNameAlias;
              }, threshold);

              thresholds = thresholds.concat(threshold.slice());
              thresholds = thresholds.concat(dynamic.slice());
            }, value.valuesElements);
            return thresholds;
          },

          getXAxisSelectedOption: function getXAxisSelectedOption() {
            return selectedXAxisOption;
          },
          getXAxisSelectedOptionValue: function getXAxisSelectedOptionValue() {
            return (0, _fp.get)('value', selectedXAxisOption);
          },
          getYAxisSelectedOption: function getYAxisSelectedOption() {
            return selectedYAxisOption;
          },
          getYAxisSelectedOptionValue: function getYAxisSelectedOptionValue() {
            return (0, _fp.get)('value', selectedYAxisOption);
          },
          isHiddenXAxis: function isHiddenXAxis() {
            return reportPartContent.listLinearFieldInLabelContainer.length === 0;
          },
          isHiddenYAxis: function isHiddenYAxis() {
            return reportPartContent.listCountableFieldInValueContainer.length === 0;
          },
          getXAxisDataType: function getXAxisDataType() {
            return xField && xField.previewDataType;
          },
          getYAxisDataType: function getYAxisDataType() {
            return yField && yField.previewDataType;
          }
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var reportPartDetails = this.reportPartDetails;
      var reportPartContent = reportPartDetails.reportPartContent;

      var getProperties = function getProperties(key) {
        return reportPartContent.getReportPartProperties(key);
      };

      var chartProperties = getProperties();
      var newData = {
        chartOptions: (0, _extends3.default)({}, chartProperties, { colors: reportPartDetails.getThemeColors(chartProperties) }),
        seriesOptions: reportPartDetails.fieldCollection,
        fieldsMapping: reportPartDetails.previewDataFieldsMapping,
        chartData: (0, _Izenda3.parser)(reportPartContent.activeElmsByContainers, reportPartDetails.expandedLevel, {
          fieldsMapping: reportPartDetails.previewDataFieldsMapping,
          records: reportPartDetails.previewDataRecords,
          rawData: reportPartDetails.previewData
        })
      };

      var chartOptions = {
        commonXYAxis: {
          metricAllPlotLinesOption: this.metricAllPlotLinesOption,
          allDynamicThresholdLine: this.allDynamicThresholdLine
        }
      };

      return _react2.default.createElement(_Izenda2.default, {
        isLoading: reportPartDetails.isLoadingData,
        className: 'threshold-settings',
        type: this.props.reportPartType,
        configurationDef: this.getConfigurationDef(),
        chartOptions: chartOptions,
        allChartProps: newData,
        chartData: newData.chartData
      });
    }

    /**
     * Handle changed value of threshold setting
     * @param {Object} schemaData
     * @param {string} changedKey
     * @param {Array<string>} changedKeyPath
     * @param {Object} changedValue
     */

  }]);
  return ThresholdSettings;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  _initDefineProp(this, 'metricAllPlotLinesOption', _descriptor, this);

  this.onChangeValue = function (schemaData, changedKey, changedKeyPath, changedValue) {
    var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
    var fieldData = groupData[changedKey];
    var reportPartContent = _this5.reportPartDetails.reportPartContent;
    fieldData && (fieldData.value = changedValue);

    var value = _this5.props.value;
    var yAxisTitle = schemaData.yAxisTitle;
    var xOption = value.xAxisTitleOption,
        yOption = value.yAxisTitleOption;

    // set active series key, if the charType's field container is values container

    var chartType = (0, _fp.get)('reportPartContent.chartType', _this5.props.reportPartDetails);
    var chartTypeSupportAll = hasSupportAllMetric(chartType);

    !_Izenda7.isChartType.apply(undefined, [chartType].concat(VALUE_LABEL_METRICS_CHART)) && (_this5.activeSeriesKey = yAxisTitle.value || null);

    if (changedKey === 'xAxis') {
      // this.xField && this.xField.setOtherProps(OTHER_PROPS_THRESHOLD_KEY, schemaData.xAxis.value);
      var staticValueX = (0, _fp.groupBy)(function (item) {
        return item.fieldMappingAlias;
      }, schemaData.xAxis.value);
      (0, _fp.forEach)(function (item) {
        var data = (0, _fp.map)(function (item) {
          return item.exportToChartConfig ? item.exportToChartConfig() : item;
        }, staticValueX[item.fieldName]);

        item.setOtherProps(OTHER_PROPS_THRESHOLD_KEY, data);
      }, reportPartContent.labelsElements);
    } else {
      var valueYGroupBy = (0, _fp.groupBy)(function (item) {
        return item.thresholdType;
      }, schemaData.yAxis.value);
      var staticValue = valueYGroupBy['static'];
      var dynamicValue = valueYGroupBy['dynamic'];
      var staticValueGroupBy = (0, _fp.groupBy)(function (item) {
        return item.fieldMappingAlias;
      }, staticValue);
      var dynamicValueGroupBy = (0, _fp.groupBy)(function (item) {
        return item.fieldMappingAlias;
      }, dynamicValue);
      // dynamic value group by.
      chartTypeSupportAll && (_this5.metricAllPlotLinesOption = (0, _fp.map)(function (item) {
        return item.exportToChartConfig ? item.exportToChartConfig() : item;
      }, staticValueGroupBy['']));

      // dynamic value group by.
      chartTypeSupportAll && (_this5.allDynamicThresholdLine = (0, _fp.map)(function (item) {
        return item.exportToChartConfig ? item.exportToChartConfig() : item;
      }, dynamicValueGroupBy['']));

      (0, _fp.forEach)(function (item) {
        var data = (0, _fp.map)(function (item) {
          return item.exportToChartConfig ? item.exportToChartConfig() : item;
        }, staticValueGroupBy[item.fieldName]);

        var dynamicValue = (0, _fp.map)(function (item) {
          return item.exportToChartConfig ? item.exportToChartConfig() : item;
        }, dynamicValueGroupBy[item.fieldName]);

        item.setOtherProps(OTHER_PROPS_THRESHOLD_KEY, data);
        item.setOtherProps('dynamicThresholds', dynamicValue);
      }, reportPartContent.valuesElements);
    }

    updateState.call(_this5);

    // TODO: remove state on this component
    function updateState() {
      var xAxisDateTimeFormat = (0, _fp.find)({ value: schemaData.xAxisTitle.value }, xOption) || {};
      var yAxisDateTimeFormat = (0, _fp.find)({ value: schemaData.yAxisTitle.value }, yOption) || {};

      this.setState({
        selectedXAxisOption: {
          value: schemaData.xAxisTitle.value,
          dateTimeFormatData: xAxisDateTimeFormat.dateTimeFormatData
        },
        selectedYAxisOption: {
          value: schemaData.yAxisTitle.value,
          dateTimeFormatData: yAxisDateTimeFormat.dateTimeFormatData
        }
      });
    }
  };
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'metricAllPlotLinesOption', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class2)) || _class;

exports.default = ThresholdSettings;
module.exports = exports['default'];

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ThresholdLabelSettingsPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module ThresholdLabelSettings popup component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var Popup = __webpack_require__(36);
  var GridLayout = __webpack_require__(13);

  var FontStyle = __webpack_require__(266);
  var FontFormat = __webpack_require__(186);
  var AlignmentSetting = __webpack_require__(317);
  var ColorPicker = __webpack_require__(169);
  var Label = __webpack_require__(71);
  var constant = __webpack_require__(597);
  var UIConstants = __webpack_require__(34);

  var _require = __webpack_require__(1),
      flow = _require.flow,
      endsWith = _require.endsWith,
      toString = _require.toString;

  var ThresholdLabelSettingsPopup = React.createClass({
    displayName: 'ThresholdLabelSettingsPopup',

    getInitialState: function getInitialState() {
      var props = this.props;
      var value = props.value || {};
      var fontStyle = value.fontStyle || {};
      return {
        fontSize: value.fontSize || UIConstants.defaultFontSize,
        fontFamily: value.fontFamily || UIConstants.defaultFontFamily,
        fontBold: fontStyle.fontBold || false,
        fontItalic: fontStyle.fontItalic || false,
        fontUnderline: fontStyle.fontUnderline || false,
        textColor: value.textColor || constant.DEFAULT_VALUE.COLOR,
        alignment: value.alignment || constant.DEFAULT_VALUE.ALIGNMENT
      };
    },
    /**
     * Hanld change text color picker
     * @param  {string} value
     */
    textColorChange: function textColorChange(value) {
      this.setState({
        textColor: value
      });
    },

    /**
     * Hanld change text color alignment setting
     * @param  {object} e
     */
    alignmentSettingChange: function alignmentSettingChange(e) {
      this.setState({
        alignment: e.value
      });
    },

    /**
     * Hanld change font format
     * @param  {object} e
     */
    onChangeFontFormat: function onChangeFontFormat(e) {
      this.setState({
        fontSize: e.value.fontSize,
        fontFamily: e.value.fontFamily
      });
    },

    /**
     * Hanld change font style
     * @param  {object} e
     */
    onChangeFontStyle: function onChangeFontStyle(e) {
      var value = e.value || {};
      this.setState({
        fontBold: value.fontBold,
        fontItalic: value.fontItalic,
        fontUnderline: value.fontUnderline
      });
    },

    onClosing: function onClosing(callback, type) {
      var props = this.props;
      if (type === 'cancel') {
        return props.onReject();
      }

      if (type === 'accept') {
        var fontSize = this.state.fontSize;
        var data = {
          fontSize: flow(toString, endsWith('px'))(fontSize) ? fontSize : fontSize + 'px',
          fontFamily: this.state.fontFamily,
          fontStyle: {
            fontBold: this.state.fontBold,
            fontItalic: this.state.fontItalic,
            fontUnderline: this.state.fontUnderline
          },
          textColor: this.state.textColor,
          alignment: this.state.alignment
        };

        props.onChange({ value: data });
        return props.onAccept();
      }
    },

    renderContainer: function renderContainer(localization) {
      var state = this.state;
      var valueFontFormat = {
        fontSize: state.fontSize,
        fontFamily: state.fontFamily
      };

      var fontStyle = {
        fontBold: state.fontBold,
        fontItalic: state.fontItalic,
        fontUnderline: state.fontUnderline
      };

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 3 },
            React.createElement(
              Label,
              { className: 'control-label u_textNormal' },
              localization.getText('FONT_SETTINGS_LABEL_FONT')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 9 },
            React.createElement(FontFormat, { value: valueFontFormat, onChange: this.onChangeFontFormat }),
            React.createElement(FontStyle, { onChange: this.onChangeFontStyle, value: fontStyle }),
            React.createElement(ColorPicker, { color: this.state.textColor, onChange: this.textColorChange, iconName: 'icon-font' })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 3 },
            React.createElement(
              Label,
              { className: 'control-label u_textNormal' },
              localization.getText('FONT_SETTINGS_LABEL_ALIGNMENT')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 9 },
            React.createElement(AlignmentSetting, { value: this.state.alignment, onChange: this.alignmentSettingChange })
          )
        )
      );
    },

    render: function render() {
      var localization = this.props.localization;
      return React.createElement(
        Popup,
        { sizeClass: 'modal-sm', visible: true, onClosing: this.onClosing, autoClose: false, type: 'none' },
        React.createElement(Popup.Header, { title: localization.getText('REPORTDESIGNER_LABEL_THRESHOLD_LABEL_SETTINGS') }),
        React.createElement(
          Popup.Body,
          null,
          this.renderContainer(localization)
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  });

  module.exports = connect()(ThresholdLabelSettingsPopup);

  module.exports.$popupName = 'ThresholdLabelSettingsPopup';
}();

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(1111);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(272);

var _Izenda4 = __webpack_require__(64);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _mobx = __webpack_require__(5);

var _Izenda6 = __webpack_require__(35);

var _Izenda7 = _interopRequireDefault(_Izenda6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DESC = _Izenda5.default.SORT_ORDERS.DESC;

/**
 * Check compatible function
 * @param  {Object} props
 * @param  {array} functions
 * @param  {object} field
 * @return {boolean}
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.DynamicThresholdGridAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var checkCompatibleFunction = function checkCompatibleFunction(props, functions, field) {
  var reportPartDetails = props.reportPartDetails;
  var reportPartContent = reportPartDetails.reportPartContent;
  var metricContainer = (0, _fp.get)(reportPartContent.getMetricContainer(), reportPartContent);
  return (0, _fp.filter)(reportPartContent.checkedCompatibleFunction.bind(reportPartContent, metricContainer, {
    field: field
  }), functions);
};

/**
 * Sync dynamic threshold elements.
 */
var syncDynamicThreholdsElemnts = function syncDynamicThreholdsElemnts(props) {
  props.validation.reset();
  props.onChange({ value: props.thresholdData }, 'dynamicThresholds');
};

/**
 * Delete threshold
 * @param {object} props
 * @param {string} value
 */
var deleteThreshold = function deleteThreshold(props, value) {
  var data = props.thresholdData;

  var deleteValue = (0, _fp.get)(value, data);
  var selectedElement = (0, _fp.get)('thresholdFieldElement', deleteValue);

  // remove field in value
  if (selectedElement) {
    var reportPartDetails = props.reportPartDetails;
    var reportPartContent = reportPartDetails.reportPartContent;
    var dynamicThreshold = (0, _fp.find)({ name: 'dynamicThresholds' }, reportPartContent['customContainers']);
    reportPartDetails.removeFieldFromContainer(dynamicThreshold, selectedElement);
  }
  data.splice(value, 1);
  props.updateThresholdData(data);
  // call function sync
  syncDynamicThreholdsElemnts(props);
};

/**
 * Copy threshold
 * @param {object} props
 * @param {object} value
 */
var copyThreshold = function copyThreshold(props, value) {
  var thresholdFieldNameAlias = String.newGuid();
  var fieldStore = props.fieldStore;
  var data = props.thresholdData;
  var copyItem = (0, _fp.cloneDeep)(data[value]);
  var selectedElement = copyItem.thresholdFieldElement;

  if (selectedElement) {
    var reportPartDetails = props.reportPartDetails;
    var reportPartContent = reportPartDetails.reportPartContent;
    var dynamicThreshold = (0, _fp.find)({ name: 'dynamicThresholds' }, reportPartContent['customContainers']);

    var selectField = (0, _fp.find)({ id: selectedElement.field.fieldId }, props.dataTree);
    var dataType = selectedElement.field.dataFieldType;
    _Izenda7.default.getFunction(0, dataType).then(function (result) {
      var functions = checkCompatibleFunction(props, result, selectField);
      var functionData = (0, _fp.find)({ id: copyItem.functionId }, functions);
      reportPartDetails.insertFieldToContainer(dynamicThreshold, selectField.field, selectField.querySourceDetail, null, functionData).then(function (newElement) {
        newElement.name = thresholdFieldNameAlias;
        newElement.field.fieldNameAlias = thresholdFieldNameAlias;
        copyItem.updateFieldName(thresholdFieldNameAlias);
        return newElement;
      }).then(copyItem.updateElement.bind(copyItem)).then(function () {
        reportPartDetails.useForThreshold = true;
        reportPartDetails.refreshDataProcess = true;
        copyItem.possion = props.maxPosition + 1;
        props.updateMaxPosition(copyItem.possion);
        data.unshift(copyItem);
        return fieldStore.needUpdatePreview(reportPartDetails);
      }).then(syncDynamicThreholdsElemnts.bind(null, props));
    });
  } else {
    copyItem.updateFieldName(thresholdFieldNameAlias);
    copyItem.possion = props.maxPosition + 1;
    props.updateMaxPosition(copyItem.possion);
    data.unshift(copyItem);
    // update threshold list
    props.updateThresholdData(data);
    syncDynamicThreholdsElemnts(props);
  }
};

/**
 * Update selected fields
 * @param {Object} props
 * @param {Object} value
 */
var updateSelectedFields = function updateSelectedFields(props, fieldId, querySourceId) {
  var selectedField = (0, _fp.find)(function (field) {
    return field.id === fieldId && field.querySourceDetail.id === querySourceId;
  }, props.dataTree);
  var data = props.selectedField;
  data.push(selectedField);
  props.updateSelectedField(data);
  props.onChange({ value: props.thresholdData, selectedField: props.selectedField }, 'dynamicThresholds');
  return selectedField;
};

var addNewThreshold = function addNewThreshold(props, event) {
  var data = props.thresholdData;
  var newObject = new _Izenda2.default();
  var metric = (0, _fp.head)(props.options);
  newObject.updateFieldMappingAlias(metric.value);
  newObject.possion = props.maxPosition + 1;
  props.updateMaxPosition(newObject.possion);
  data.unshift(newObject);
  props.updateThresholdData(data);
  props.onChange({ value: props.thresholdData }, 'dynamicThresholds');
};

/**
 * Sort threshold
 * @param {Array} thresholdData
 * @param {String} key
 * @param {String} direction
 */
var sortThresholds = function sortThresholds(thresholdData, key, direction) {
  var sortedItems = [];
  if ((0, _fp.isEmpty)(direction)) {
    sortedItems = (0, _Izenda3.sortArray)(thresholdData, [{ key: 'possion', descending: true }]);
  } else {
    sortedItems = (0, _Izenda3.sortArray)(thresholdData, [{ key: key, descending: direction === DESC.value }]);
  }

  (0, _Izenda3.updateArray)(thresholdData, sortedItems, function (item) {
    return item;
  });
};

/**
 *
 * @param {Object} props
 * @param {String} columnKey
 * @param {Array} sortDir
 */
var onSortChange = function onSortChange(props, columnKey, sortDir) {
  var thresholdData = props.thresholdData;


  if (columnKey !== 'Field') return;
  sortThresholds(thresholdData, 'fieldMappingAlias', sortDir);
  props.updateThresholdData(thresholdData);
};

/**
 * Change dash type
 * @param {Object} props
 * @param {Object} rowData
 * @param {Object} changeData
 */
var onChangeDashType = function onChangeDashType(props, rowData, changeData) {
  rowData.updateDashStyle(changeData);
  syncDynamicThreholdsElemnts(props);
};

/**
 * Add dynamic threshold field
 * @param {Object} props
 * @param {Object} data
 * @param {Object} changeData
 */
var addDynamicThreholdsField = function addDynamicThreholdsField(props, data, changeData) {
  var fieldId = changeData.fieldId,
      functionId = changeData.functionId,
      functionData = changeData.functionData,
      format = changeData.format,
      querySourceId = changeData.querySourceId;

  var functionName = (0, _fp.get)('name', functionData);
  data.updateField(fieldId, fieldId, functionId, functionName, format, querySourceId);
  var selectField = updateSelectedFields(props, fieldId, querySourceId);
  // Add filed here
  var fieldStore = props.fieldStore;

  var reportPartDetails = props.reportPartDetails;
  var reportPartContent = reportPartDetails.reportPartContent;
  var dynamicThreshold = (0, _fp.find)({ name: 'dynamicThresholds' }, reportPartContent['customContainers']);
  var oldElement = data.thresholdFieldElement || {};
  if (oldElement) {
    var elementToRemove = (0, _fp.find)(function (ele) {
      return ele.fieldNameAlias === oldElement.fieldNameAlias;
    }, dynamicThreshold.elements);
    elementToRemove && reportPartDetails.removeFieldFromContainer(dynamicThreshold, elementToRemove);
  }
  reportPartDetails.insertFieldToContainer(dynamicThreshold, selectField.field, selectField.querySourceDetail, null, functionData).then(function (newElement) {
    var thresholdFieldNameAlias = String.newGuid();
    newElement.name = thresholdFieldNameAlias;
    newElement.field.fieldNameAlias = thresholdFieldNameAlias;
    data.updateFieldName(thresholdFieldNameAlias);
    return newElement;
  }).then(data.updateElement.bind(data)).then(function () {
    reportPartDetails.useForThreshold = true;
    reportPartDetails.refreshDataProcess = true;
    return fieldStore.needUpdatePreview(reportPartDetails);
  }).then(syncDynamicThreholdsElemnts.bind(null, props));
};

exports.default = (0, _recompose.compose)((0, _recompose.withState)('thresholdData', 'updateThresholdData', function (props) {
  var i = 0;
  var data = (0, _fp.map)(function (item) {
    if (!(0, _fp.isNil)(item)) {
      (0, _fp.isNil)(item.possion) && (item.possion = i);
      i++;
      var obj = new _Izenda2.default(item);
      obj.updateElement(item.thresholdFieldElement);
      return obj;
    }
  }, props.value);

  sortThresholds(data, 'possion', DESC.value);

  return data;
}), (0, _recompose.withState)('maxPosition', 'updateMaxPosition', function (_ref) {
  var value = _ref.value;

  if ((0, _fp.isNil)(value) || !(0, _mobx.isObservableArray)(value)) return 0;
  return value.slice().reduce(function (maxPossion, item) {
    return Math.max(maxPossion, (0, _fp.getOr)(0, 'possion', item));
  }, 0);
}), (0, _recompose.withState)('selectedField', 'updateSelectedField', function () {
  return [];
}), (0, _recompose.withHandlers)({
  onSortChange: (0, _fp.curry)(onSortChange),
  deleteThreshold: (0, _fp.curry)(deleteThreshold),
  copyThreshold: (0, _fp.curry)(copyThreshold),
  updateSelectedFields: (0, _fp.curry)(updateSelectedFields),
  addNewThreshold: (0, _fp.curry)(addNewThreshold),
  addDynamicThreholdsField: (0, _fp.curry)(addDynamicThreholdsField),
  onChangeDashType: (0, _fp.curry)(onChangeDashType)
}));
module.exports = exports['default'];

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AddFieldSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2049);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(34);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(1),
    isEmpty = _require.isEmpty,
    isNull = _require.isNull;

var AddFieldSetting = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(AddFieldSetting, _Component);

  function AddFieldSetting() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AddFieldSetting);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddFieldSetting.__proto__ || (0, _getPrototypeOf2.default)(AddFieldSetting)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      var _this$props = _this.props,
          dataTree = _this$props.dataTree,
          data = _this$props.data,
          reportPartContent = _this$props.reportPartContent;


      _this.props.openPopup(_Izenda2.default, {
        dataTree: dataTree,
        data: data,
        reportPartContent: reportPartContent
      }).then(_this.props.onOk);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Open add field popup
   */


  (0, _createClass3.default)(AddFieldSetting, [{
    key: 'getDisplayName',


    /**
     * Get display dynamic all
     * @param {string} fieldName
     */
    value: function getDisplayName(fieldName) {
      var localization = this.props.localization;

      return isNull(fieldName) ? localization.getText('REPORTDESIGNER_LABEL_ADD_NEW_FIELD') : isEmpty(fieldName) ? _Izenda4.default.MASKED_TEXT : fieldName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          className = _props.className;

      var displayName = this.getDisplayName(data.displayName);
      var containerClassName = className + ' u_flex u_flexCenterAlignItems ';

      return _react2.default.createElement(
        'div',
        { className: containerClassName },
        _react2.default.createElement(
          'div',
          { className: 'form-control overflow-text u_paddingLeft', title: displayName },
          !data.value && _react2.default.createElement(
            'a',
            null,
            _react2.default.createElement(
              'span',
              { onClick: this.onClick },
              displayName
            )
          ),
          data.value && _react2.default.createElement(
            'span',
            null,
            displayName
          )
        ),
        data.value && _react2.default.createElement(
          'a',
          { className: 'u_paddingLeft' },
          _react2.default.createElement('span', { className: 'icon-setting', onClick: this.onClick })
        )
      );
    }
  }]);
  return AddFieldSetting;
}(_react.Component), _class.displayName = 'AddField', _temp2);
exports.default = AddFieldSetting;
module.exports = exports['default'];

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class3, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DynamicThresholdField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(29);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(35);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(155);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(1112);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(89);

var _Izenda16 = __webpack_require__(16);

var _mobx = __webpack_require__(5);

var _Izenda17 = __webpack_require__(64);

var _Izenda18 = __webpack_require__(39);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DynamicThresholdField = (_dec = (0, _Izenda8.default)(), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(DynamicThresholdField, _Component);

  function DynamicThresholdField(props) {
    (0, _classCallCheck3.default)(this, DynamicThresholdField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DynamicThresholdField.__proto__ || (0, _getPrototypeOf2.default)(DynamicThresholdField)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        _this$props$data = _this$props.data,
        thresholdFieldElement = _this$props$data.thresholdFieldElement,
        functionId = _this$props$data.functionId,
        reportPartContent = _this$props.reportPartContent,
        dataTree = _this$props.dataTree;


    var field = (0, _fp.get)('field', thresholdFieldElement);
    if (thresholdFieldElement && field.visible) {
      _this.fieldId = field.fieldId;
      var querySourceId = (0, _fp.get)('querySourceDetail.id', (0, _fp.find)(function (item) {
        return item.querySourceDetail.name === field.sourceAlias;
      }, dataTree));
      _this.querySourceId = field.relationshipId && !String.isEmptyGuid(field.relationshipId) ? field.relationshipId : querySourceId;
      _this.format.update((0, _fp.get)('properties.dataFormattings.format', thresholdFieldElement));
      _this.dataType = field.dataFieldType;
      _this.functionId = functionId;
      _this.disableFunctions = field.isRunningField;
    }
    var hasAggregatedFunction = (0, _fp.get)('hasAggregatedFunction', field);
    var isRunningField = (0, _fp.get)('isRunningField', field);
    _this.metricContainer = (0, _fp.get)(reportPartContent.getMetricContainer(), reportPartContent);

    !hasAggregatedFunction && !isRunningField && _this.getFunctionList();
    _this.getFormats(_this.disableFunctions);
    return _this;
  }

  /**
   * On closing popup
   */


  /**
   * Onchange format value
   * @param {any} value
   * @param {any} selectedFormat
   *
   */


  /**
   * On change field
   */


  (0, _createClass3.default)(DynamicThresholdField, [{
    key: 'getFunctionList',


    /**
     * Get list of function based on data type
     * @param {Boolean} disableFunctions
     * @param {Boolean} fromChangeField
     */
    value: function getFunctionList(disableFunctions, fromChangeField) {
      var _this2 = this;

      var reportPartContent = this.props.reportPartContent;
      var dataType = this.dataType;
      if (this.dataType && !disableFunctions) {
        _Izenda10.default.getFunction(0, this.dataType).then(function (result) {
          _this2.functions = _this2.setFunctionList(result);
          var defaultFunction = reportPartContent.getDefaultFunctionFormat({ name: 'values' }, dataType);
          var functionData = (0, _fp.find)({ name: defaultFunction.FUNCTION.NAME }, result);
          !(0, _fp.isEmpty)(_this2.functions) && functionData && fromChangeField && (_this2.functionId = functionData.id);
        });
      } else {
        this.functionId = null;
        this.functions = [];
      }
    }

    /**
     * Get format by numeric
     * @param {boolean} isRunningField
     * @returns {Array<any>}
     */

  }, {
    key: 'getFormats',
    value: function getFormats(isRunningField) {
      var _this3 = this;

      var reportPartContent = this.props.reportPartContent;


      return _Izenda12.default.loadReportFieldDataFormat(_Izenda16.DATA_TYPES.NUMERIC).then(function (resultFormats) {
        _this3.formats = _Izenda10.default.filterFormatForField(reportPartContent, resultFormats, isRunningField, _Izenda18.ContainerName.VALUES);
      });
    }

    /**
     * Set default function for fields
     */

  }, {
    key: 'setFunction',
    value: function setFunction() {
      !(0, _fp.isEmpty)(this.functions) && !this.functionId && (this.functionId = (0, _fp.get)('id', (0, _fp.first)(this.functions)));
    }

    /**
     * Set correct function list for field
     * @param {Array} result
     */

  }, {
    key: 'setFunctionList',
    value: function setFunctionList(result) {
      var reportPartContent = this.props.reportPartContent;

      result = (0, _fp.concat)([_Izenda17.EMPTY_FUNCTION], result);

      if (!reportPartContent.checkedCompatibleFunction) {
        return result;
      }

      return (0, _fp.filter)(reportPartContent.checkedCompatibleFunction.bind(reportPartContent, this.metricContainer, {
        field: this.field
      }), result);
    }

    /**
     * Get value for each item in dropdown
     * @param {Object} field
     */

  }, {
    key: 'getValueField',
    value: function getValueField(field) {
      return field.id + '_' + field.querySourceDetail.id;
    }

    /**
     * Get selected value
     */

  }, {
    key: 'getValue',
    value: function getValue() {
      return this.fieldId + '_' + this.querySourceId;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          dataTree = _props.dataTree;


      return _react2.default.createElement(
        _Izenda4.default,
        { visible: true, onClosing: this.onClosing, autoClose: false, type: 'none' },
        _react2.default.createElement(_Izenda4.default.Header, { title: localization.getText('THRESHOLDS_TITLE_POPUP_CHANGE_FIELD') }),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          _react2.default.createElement(
            _Izenda6.default,
            { className: 'form-horizontal' },
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'form-group' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3' },
                localization.getText('COMMON_LABEL_FIELD')
              ),
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '9' },
                _react2.default.createElement(_Izenda2.default, {
                  value: this.getValue(),
                  options: dataTree,
                  onChange: this.onChangeField,
                  additionalValueField: 'field',
                  valueField: this.getValueField,
                  labelField: 'name',
                  groupBy: 'category'
                })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'form-group' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3' },
                localization.getText('MODEL_LABEL_FUNCTION')
              ),
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '9' },
                _react2.default.createElement(_Izenda2.default, {
                  disabled: this.disableFunctions,
                  value: this.functionId,
                  options: this.functions,
                  onChange: this.onChangeFunction,
                  valueField: 'id',
                  labelField: 'name'
                })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'form-group' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3' },
                localization.getText('COMMON_LABEL_FORMAT')
              ),
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '9' },
                _react2.default.createElement(_Izenda2.default, {
                  value: this.format.formatId,
                  options: this.formats,
                  onChange: this.onChangeFormat,
                  blankOption: true,
                  blankOptionText: _Izenda15.OPERATOR_GROUP.UNKNOWN,
                  valueField: 'customId',
                  labelField: 'name',
                  groupBy: 'category'
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _Izenda4.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return DynamicThresholdField;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  _initDefineProp(this, 'functions', _descriptor, this);

  _initDefineProp(this, 'field', _descriptor2, this);

  _initDefineProp(this, 'functionId', _descriptor3, this);

  _initDefineProp(this, 'disableFunctions', _descriptor4, this);

  _initDefineProp(this, 'format', _descriptor5, this);

  _initDefineProp(this, 'formats', _descriptor6, this);

  this.onClosing = function (callBack, type) {
    if (type === 'accept') {
      var functionData = (0, _fp.find)({ id: _this4.functionId }, _this4.functions);
      var fieldId = _this4.fieldId,
          functionId = _this4.functionId,
          format = _this4.format,
          querySourceId = _this4.querySourceId;

      _this4.props.onAccept({
        fieldId: fieldId,
        functionId: functionId,
        functionData: functionData,
        format: format,
        querySourceId: querySourceId
      });
    } else {
      _this4.props.onReject();
    }
  };

  this.onChangeFunction = function (e) {
    _this4.functionId = e.value;
  };

  this.onChangeFormat = function (_ref, selectedFormat) {
    var label = _ref.label;

    var formatValue = {
      formatId: (0, _fp.getOr)(null, 'customId', selectedFormat),
      format: (0, _fp.isEmpty)(label) ? null : (0, _fp.getOr)(null, 'format', selectedFormat),
      jsFormatString: (0, _fp.getOr)(null, 'jsFormatString', selectedFormat),
      groupBy: (0, _fp.getOr)(null, 'jsFormatString', selectedFormat),
      formatDataType: (0, _fp.getOr)(null, 'jsFormatString', selectedFormat)
    };

    _this4.format.update(formatValue);
  };

  this.onChangeField = function (_ref2) {
    var label = _ref2.label,
        additionalValue = _ref2.additionalValue;

    _this4.fieldId = additionalValue.id;
    _this4.name = label;
    _this4.field = additionalValue;
    var dataTree = _this4.props.dataTree;

    var _find = (0, _fp.find)(function (item) {
      return item.field === additionalValue;
    }, dataTree),
        querySourceDetail = _find.querySourceDetail;

    _this4.querySourceId = querySourceDetail.id;
    if (_this4.dataType !== additionalValue.izendaDataType) {
      _this4.dataType = additionalValue.izendaDataType;
      _this4.functionId = null;
    }
    var disableFunctions = additionalValue.isRunningField;
    _this4.disableFunctions = disableFunctions;

    _this4.getFunctionList(_this4.disableFunctions, true);
    _this4.format.reset();
    _this4.getFormats(_this4.disableFunctions);
  };
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'functions', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'field', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'functionId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'disableFunctions', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'format', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda14.default();
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'formats', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'getFunctionList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getFunctionList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getFormats', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getFormats'), _class2.prototype)), _class2)) || _class);


DynamicThresholdField.$popupName = 'DynamicThresholdField';
exports.default = DynamicThresholdField;
module.exports = exports['default'];

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.RegressionLineSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(193);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(39);

var _Izenda4 = __webpack_require__(12);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _fp = __webpack_require__(1);

var _Izenda6 = __webpack_require__(596);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(190);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _mobxReact = __webpack_require__(10);

var _Izenda10 = __webpack_require__(2051);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REGRESSION_TYPE = _Izenda3.CHART_SETTINGS.REGRESSION_TYPE,
    REGRESSION_TYPE_OPTIONS = _Izenda3.CHART_SETTINGS.REGRESSION_TYPE_OPTIONS,
    REGRESSION_POLYNOMIAL_ORDER = _Izenda3.CHART_SETTINGS.REGRESSION_POLYNOMIAL_ORDER,
    REGRESSION_LINEAR_DECIMAL_PLACES_MAX_VALUE = _Izenda3.CHART_SETTINGS.REGRESSION_LINEAR_DECIMAL_PLACES_MAX_VALUE,
    REGRESSION_LINEAR_DECIMAL_PLACES_MIN_VALUE = _Izenda3.CHART_SETTINGS.REGRESSION_LINEAR_DECIMAL_PLACES_MIN_VALUE,
    REGRESSION_EXTRAPOLATE_MAX_VALUE = _Izenda3.CHART_SETTINGS.REGRESSION_EXTRAPOLATE_MAX_VALUE,
    REGRESSION_EXTRAPOLATE_MIN_VALUE = _Izenda3.CHART_SETTINGS.REGRESSION_EXTRAPOLATE_MIN_VALUE;


function getSchema(fields, orderTooltip) {
  return {
    fields: {
      schemaKey: 'REGRESSION_LINE_SCHEMA',
      field: {
        title: _Izenda5.default.getText('REGRESSION_LINE_FIELD_SELECT'),
        infoIcon: _Izenda5.default.getText('REGRESSION_LINE_FIELD_SELECT_TOOLTIP'),
        type: 'select',
        fnValue: 'getField',
        props: {
          options: fields
        }
      },
      visible: {
        title: _Izenda5.default.getText('COMMON_LABEL_VISIBLE'),
        type: 'checkbox',
        fnValue: 'getVisible'
      },
      hideInLegend: {
        title: _Izenda5.default.getText('REGRESSION_LINE_HIDE_IN_LEGEND'),
        type: 'checkbox',
        fnValue: 'getHideInLegend',
        isHidden: 'isHiddenHideInLegend'
      },
      name: {
        title: _Izenda5.default.getText('COMMON_LABEL_NAME'),
        infoIcon: _Izenda5.default.getText('REGRESSION_LINE_NAME_TOOLTIP'),
        type: 'text',
        fnValue: 'getName'
      },
      type: {
        title: _Izenda5.default.getText('REGRESSION_LINE_TYPE'),
        type: 'select',
        fnValue: 'getType',
        props: {
          options: REGRESSION_TYPE_OPTIONS
        }
      },
      decimalPlaces: {
        title: _Izenda5.default.getText('REGRESSION_LINE_DECIMAL_PLACES'),
        infoIcon: _Izenda5.default.getText('REGRESSION_LINE_DECIMAL_PLACES_TOOLTIP'),
        type: 'number',
        fnValue: 'getDecimalPlaces',
        props: {
          max: REGRESSION_LINEAR_DECIMAL_PLACES_MAX_VALUE,
          min: REGRESSION_LINEAR_DECIMAL_PLACES_MIN_VALUE
        }
      },
      order: {
        title: _Izenda5.default.getText('REGRESSION_LINE_ORDER'),
        isHidden: 'isHiddenOrder',
        type: 'select',
        fnValue: 'getOrder',
        infoIcon: orderTooltip,
        props: {
          options: REGRESSION_POLYNOMIAL_ORDER
        }
      },
      color: {
        title: _Izenda5.default.getText('COMMON_LABEL_COLOR'),
        type: 'color',
        fnValue: 'getColor'
      },
      dashStyle: {
        title: _Izenda5.default.getText('BORDER_SETTING_LABEL_DASH_STYLE'),
        component: _Izenda7.default,
        fnValue: 'getDashStyle'
      },
      lineWidth: {
        title: _Izenda5.default.getText('BORDER_SETTING_LABEL_THICKNESS'),
        component: _Izenda9.default,
        fnValue: 'getLineWidth'
      },
      extrapolate: {
        title: _Izenda5.default.getText('REGRESSION_LINE_EXTRAPOLATE'),
        type: 'number',
        infoIcon: _Izenda5.default.getText('REGRESSION_LINE_EXTRAPOLATE_TOOLTIP'),
        isHidden: 'isHiddenExtrapolate',
        fnValue: 'getExtrapolate',
        props: {
          max: REGRESSION_EXTRAPOLATE_MAX_VALUE,
          min: REGRESSION_EXTRAPOLATE_MIN_VALUE
        }
      }
    }
  };
}

var RegressionLineSettings = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(RegressionLineSettings, _Component);

  function RegressionLineSettings(props) {
    (0, _classCallCheck3.default)(this, RegressionLineSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RegressionLineSettings.__proto__ || (0, _getPrototypeOf2.default)(RegressionLineSettings)).call(this, props));

    _this.store = new _Izenda11.default(props.reportPartDetails);
    return _this;
  }

  (0, _createClass3.default)(RegressionLineSettings, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.disposeDataObserver();
    }
    /**
     * On closing popup
     */

  }, {
    key: 'getValue',
    value: function getValue() {
      var reportPartContent = this.props.reportPartDetails.reportPartContent;

      this.store.updateElements(reportPartContent);
    }

    /**
     * On change data in schema
     * @param {any} schemaData
     * @param {string} changedKey
     * @param {Array<string>} keyPath
     * @param {any} newVal
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(schemaData, changedKey, keyPath, newVal) {
      schemaData[changedKey].value = newVal;
      var fieldName = schemaData.field.value;
      var store = this.store;

      var fieldIndex = (0, _fp.findIndex)({ name: fieldName }, store.serieElements);
      var field = fieldIndex >= 0 ? store.serieElements[fieldIndex] : null;
      if (field) {
        if (changedKey === 'field') {
          store.setConfigField(field);
        } else if (store[changedKey] !== schemaData[changedKey].value) {
          // Avoid unneccessary re-render chart
          switch (changedKey) {
            case 'name':
              store.changeName(field, schemaData);
              break;
            case 'decimalPlaces':
              store.changeDecimalPlaces(field, schemaData);
              break;
            case 'extrapolate':
              store.changeExtrapolate(field, schemaData);
              break;
            default:
              store.updateValue(changedKey, field, schemaData);
          }
        }
      }
    }

    /**
     * Get configuration definition
     */

  }, {
    key: 'getConfigurationDef',
    value: function getConfigurationDef() {
      var store = this.store,
          model = this.store.model;


      return {
        definedSchema: getSchema(store.buildFieldOptions(), store.orderTooltip),
        source: {},
        mappingSource: {
          getField: function getField() {
            return store.configField.fieldName;
          },
          getVisible: function getVisible() {
            return model.visible;
          },
          getHideInLegend: function getHideInLegend() {
            return model.hideInLegend;
          },
          getType: function getType() {
            return model.type;
          },
          getOrder: function getOrder() {
            return model.order;
          },
          isHiddenHideInLegend: function isHiddenHideInLegend() {
            return !model.visible;
          },
          isHiddenOrder: function isHiddenOrder() {
            return model.type !== REGRESSION_TYPE.polynomial;
          },
          isHiddenExtrapolate: function isHiddenExtrapolate() {
            var currentType = model.type;
            return (0, _fp.every)(function (regressionType) {
              return currentType !== regressionType;
            }, [REGRESSION_TYPE.polynomial, REGRESSION_TYPE.linear]);
          },
          getLineWidth: function getLineWidth() {
            return model.lineWidth;
          },
          getColor: function getColor() {
            return model.color;
          },
          getDashStyle: function getDashStyle() {
            return model.dashStyle;
          },
          getDecimalPlaces: function getDecimalPlaces() {
            return model.decimalPlaces;
          },
          getExtrapolate: function getExtrapolate() {
            return model.extrapolate;
          },
          getName: function getName() {
            return model.name;
          }
        },
        onChangeValue: this.onChangeValue.bind(this)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          reportPartType = _props.reportPartType,
          reportPartDetails = _props.reportPartDetails,
          reportPartContent = _props.reportPartDetails.reportPartContent;
      var store = this.store;

      var allProps = this.props.allChartProps();
      allProps.seriesOptions = store.valuesElements.concat(store.valuesLabelsElements).concat(reportPartContent.labelsElements).concat(reportPartContent.separatorsElements).concat(reportPartContent.bubbleSizeElements);

      return _react2.default.createElement(_Izenda2.default, {
        className: 'regression-line-settings',
        isLoading: reportPartDetails.isLoadingData,
        reportPart: reportPartDetails,
        type: reportPartType,
        configurationDef: this.getConfigurationDef(),
        allChartProps: allProps,
        chartData: store.getChartData(reportPartContent)
      });
    }
  }]);
  return RegressionLineSettings;
}(_react.Component)) || _class;

exports.default = RegressionLineSettings;
module.exports = exports['default'];

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RegressionLineStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(2052);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(39);

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda4 = __webpack_require__(34);

var _Izenda5 = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var REGRESSION_LINE_KEY = 'regression';
var REGRESSION_POLYNOMIAL_ORDER = _Izenda3.CHART_SETTINGS.REGRESSION_POLYNOMIAL_ORDER;
var RegressionLineStore = (_class = function () {
  (0, _createClass3.default)(RegressionLineStore, [{
    key: 'orderTooltip',


    /**
     * Order tooltip
     */
    get: function get() {
      return (0, _fp.get)('tooltip', (0, _fp.find)({ value: this.model.order }, REGRESSION_POLYNOMIAL_ORDER));
    }
  }]);

  function RegressionLineStore(reportPartDetails) {
    var _this = this;

    (0, _classCallCheck3.default)(this, RegressionLineStore);

    _initDefineProp(this, 'model', _descriptor, this);

    _initDefineProp(this, 'configField', _descriptor2, this);

    _initDefineProp(this, 'activeSeriesKey', _descriptor3, this);

    this.changeName = (0, _fp.debounce)(_Izenda4.DEFAULT_DEBOUNCE_TIME, (0, _mobx.action)(function (field, schemaData) {
      _this.updateValue('name', field, schemaData);
    }));
    this.changeDecimalPlaces = (0, _fp.debounce)(_Izenda4.DEFAULT_DEBOUNCE_TIME, (0, _mobx.action)(function (field, schemaData) {
      _this.updateValue('decimalPlaces', field, schemaData);
    }));
    this.changeExtrapolate = (0, _fp.debounce)(_Izenda4.DEFAULT_DEBOUNCE_TIME, (0, _mobx.action)(function (field, schemaData) {
      _this.updateValue('extrapolate', field, schemaData);
    }));

    this.model = new _Izenda2.default();

    this.cloneElements(reportPartDetails);
    this.setSerieElements(reportPartDetails);
    this.initData(reportPartDetails);

    var reportPartContent = reportPartDetails.reportPartContent;

    var activeSerie = reportPartContent.activeSerie;
    if (activeSerie) {
      var currentSerie = (0, _fp.find)(function (ele) {
        return ele.name === activeSerie.name;
      }, this.serieElements);
      this.setConfigField(currentSerie);
    } else {
      this.setConfigField((0, _fp.first)(this.serieElements));
    }
  }

  /**
   * Set config field
   */


  (0, _createClass3.default)(RegressionLineStore, [{
    key: 'setConfigField',
    value: function setConfigField(field) {
      var regressionSetting = (0, _fp.get)('regression', field.properties.getOtherProps());
      this.configField = field;
      this.activeSeriesKey = field.name;
      this.model.readData(regressionSetting);
      this.setCurrentSetting();
    }

    /**
     * Clone elements
     */

  }, {
    key: 'cloneElements',
    value: function cloneElements(reportPartDetails) {
      var content = reportPartDetails.reportPartContent;
      this.valuesElements = content.valuesElements.map(function (field) {
        return field.clone();
      });
      this.valuesLabelsElements = content.valuesLabelsElements.map(function (field) {
        return field.clone();
      });
    }

    /**
     * Set elements in series
     */

  }, {
    key: 'setSerieElements',
    value: function setSerieElements(reportPartDetails) {
      var content = reportPartDetails.reportPartContent;
      this.serieElements = content.getMetricContainer() === 'values' ? this.valuesElements : this.valuesLabelsElements;
    }

    /**
     * set current setting
     */

  }, {
    key: 'setCurrentSetting',
    value: function setCurrentSetting() {
      var _model = this.model,
          name = _model.name,
          visible = _model.visible,
          hideInLegend = _model.hideInLegend,
          type = _model.type,
          order = _model.order,
          lineWidth = _model.lineWidth,
          dashStyle = _model.dashStyle,
          color = _model.color,
          extrapolate = _model.extrapolate,
          decimalPlaces = _model.decimalPlaces;


      this.configField.setOtherProps(REGRESSION_LINE_KEY, {
        name: name,
        visible: visible,
        hideInLegend: hideInLegend,
        type: type,
        order: order,
        lineWidth: lineWidth,
        dashStyle: dashStyle,
        color: color,
        extrapolate: extrapolate,
        decimalPlaces: decimalPlaces
      });
    }

    /**
     * Init data
     * Store drilldown data to this instance
     */

  }, {
    key: 'initData',
    value: function initData(reportPartDetails) {
      var _this2 = this;

      this.setPreviewData(reportPartDetails);
      this.dataObserverDisposer = (0, _mobx.observe)(reportPartDetails, 'isLoadingData', function () {
        return _this2.setPreviewData(reportPartDetails);
      });
    }

    /**
     * Set preview data
     */

  }, {
    key: 'setPreviewData',
    value: function setPreviewData(reportPartDetails) {
      var reportPartContent = reportPartDetails.reportPartContent;
      this.expandedLevel = reportPartDetails.reportPartContent.expandedLevel;
      this.previewData = reportPartDetails.previewData;
      this.previewDataRecords = reportPartDetails.previewDataRecords || [];
      this.previewDataFieldsMapping = reportPartDetails.previewDataFieldsMapping || [];
      this.activeSeriesKey = reportPartContent.getActiveSerieKey();
    }

    /**
     * Dispose data observer
     */

  }, {
    key: 'disposeDataObserver',
    value: function disposeDataObserver() {
      this.dataObserverDisposer && this.dataObserverDisposer();
    }

    /**
     * Update value to configuration
     * @param {string} changedKey
     * @param {any} field
     * @param {any} schemaData
     */

  }, {
    key: 'updateValue',
    value: function updateValue(changedKey, field, schemaData) {
      this.model.updateValue(changedKey, schemaData[changedKey].value);
      this.setCurrentSetting();
    }

    /**
     * Change name in debounce
     */


    /**
     * Change decimal places in debounce
     */


    /**
     * Change extrapolate in debounce
     */

  }, {
    key: 'updateElements',


    /**
     * Update element when saved
     * @param {Object} reportPartContent
     */
    value: function updateElements(reportPartContent) {
      var _this3 = this;

      var updateElements = reportPartContent.getMetricContainer() === 'values' ? reportPartContent.valuesElements : reportPartContent.valuesLabelsElements;

      updateElements.forEach(function (item, index) {
        item.setOtherProps(REGRESSION_LINE_KEY, _this3.serieElements[index].properties.getOtherProps()[REGRESSION_LINE_KEY]);
      });
    }

    /**
     * Build field options
     */

  }, {
    key: 'buildFieldOptions',
    value: function buildFieldOptions() {
      return this.serieElements.map(function (_ref) {
        var name = _ref.name;
        return { value: name, label: name };
      });
    }

    /**
     * Get chart data
     */

  }, {
    key: 'getChartData',
    value: function getChartData(reportPartContent) {
      return (0, _Izenda5.parser)(reportPartContent.getActiveElmsByActiveSeries(this.activeSeriesKey), this.expandedLevel, {
        fieldsMapping: this.previewDataFieldsMapping,
        records: this.previewDataRecords,
        rawData: this.previewData
      });
    }
  }]);
  return RegressionLineStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'configField', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'activeSeriesKey', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'orderTooltip', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'orderTooltip'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setConfigField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setConfigField'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cloneElements', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cloneElements'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSerieElements', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setSerieElements'), _class.prototype)), _class);
exports.default = RegressionLineStore;
module.exports = exports['default'];

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RegressionLine.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var REGRESSION_TYPE_OPTIONS = _Izenda.CHART_SETTINGS.REGRESSION_TYPE_OPTIONS,
    REGRESSION_POLYNOMIAL_ORDER = _Izenda.CHART_SETTINGS.REGRESSION_POLYNOMIAL_ORDER,
    DEFAULT_VALUE = _Izenda.CHART_SETTINGS.DEFAULT_VALUE,
    REGRESSION_LINEAR_DECIMAL_PLACES_DEFAULT_VALUE = _Izenda.CHART_SETTINGS.REGRESSION_LINEAR_DECIMAL_PLACES_DEFAULT_VALUE;
var RegressionLine = (_class = function () {
  function RegressionLine() {
    (0, _classCallCheck3.default)(this, RegressionLine);

    _initDefineProp(this, 'hideInLegend', _descriptor, this);

    _initDefineProp(this, 'type', _descriptor2, this);

    _initDefineProp(this, 'order', _descriptor3, this);

    _initDefineProp(this, 'lineWidth', _descriptor4, this);

    _initDefineProp(this, 'dashStyle', _descriptor5, this);

    _initDefineProp(this, 'color', _descriptor6, this);

    _initDefineProp(this, 'visible', _descriptor7, this);

    _initDefineProp(this, 'field', _descriptor8, this);

    _initDefineProp(this, 'extrapolate', _descriptor9, this);

    _initDefineProp(this, 'decimalPlaces', _descriptor10, this);

    _initDefineProp(this, 'name', _descriptor11, this);

    _initDefineProp(this, 'activeSeriesKey', _descriptor12, this);
  }

  (0, _createClass3.default)(RegressionLine, [{
    key: 'readData',


    /**
     * Read data
     */
    value: function readData(regressionSetting) {
      var _ref = regressionSetting || {},
          _ref$visible = _ref.visible,
          visible = _ref$visible === undefined ? true : _ref$visible,
          _ref$hideInLegend = _ref.hideInLegend,
          hideInLegend = _ref$hideInLegend === undefined ? false : _ref$hideInLegend,
          _ref$type = _ref.type,
          type = _ref$type === undefined ? REGRESSION_TYPE_OPTIONS[0].value : _ref$type,
          _ref$order = _ref.order,
          order = _ref$order === undefined ? REGRESSION_POLYNOMIAL_ORDER[0].value : _ref$order,
          _ref$lineWidth = _ref.lineWidth,
          lineWidth = _ref$lineWidth === undefined ? DEFAULT_VALUE.WIDTH : _ref$lineWidth,
          _ref$dashStyle = _ref.dashStyle,
          dashStyle = _ref$dashStyle === undefined ? DEFAULT_VALUE.DASH_STYLE : _ref$dashStyle,
          _ref$color = _ref.color,
          color = _ref$color === undefined ? DEFAULT_VALUE.BLACK_COLOR : _ref$color,
          _ref$extrapolate = _ref.extrapolate,
          extrapolate = _ref$extrapolate === undefined ? null : _ref$extrapolate,
          _ref$name = _ref.name,
          name = _ref$name === undefined ? '' : _ref$name,
          _ref$decimalPlaces = _ref.decimalPlaces,
          decimalPlaces = _ref$decimalPlaces === undefined ? REGRESSION_LINEAR_DECIMAL_PLACES_DEFAULT_VALUE : _ref$decimalPlaces;

      this.name = name;
      this.visible = visible;
      this.hideInLegend = hideInLegend;
      this.type = type;
      this.order = order;
      this.lineWidth = lineWidth;
      this.dashStyle = dashStyle;
      this.color = color;
      this.extrapolate = extrapolate;
      this.decimalPlaces = decimalPlaces;
    }

    /**
     * Update value
     */

  }, {
    key: 'updateValue',
    value: function updateValue(key, value) {
      this[key] = value;
    }
  }]);
  return RegressionLine;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'hideInLegend', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'order', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'lineWidth', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'dashStyle', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'color', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'visible', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'field', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'extrapolate', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'decimalPlaces', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'activeSeriesKey', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'readData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateValue'), _class.prototype)), _class);
exports.default = RegressionLine;
module.exports = exports['default'];

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _Izenda = __webpack_require__(33);

var _Izenda2 = __webpack_require__(39);

var _Izenda3 = __webpack_require__(80);

var _Izenda4 = __webpack_require__(16);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (reportPartDetails, fieldStore) {
  var reportPartContent = reportPartDetails.reportPartContent || {};
  var getProperties = function getProperties(key) {
    return reportPartContent.getReportPartProperties(key);
  };
  return {
    reportPartDetails: reportPartDetails,
    getAllChartProps: function getAllChartProps() {
      var chartProperties = getProperties();
      return {
        chartOptions: (0, _extends3.default)({}, chartProperties, { colors: reportPartDetails.getThemeColors(chartProperties) }),
        seriesOptions: reportPartDetails.fieldCollection,
        chartData: (0, _Izenda3.parser)(reportPartContent.activeElmsByContainers, reportPartDetails.expandedLevel, {
          fieldsMapping: reportPartDetails.previewDataFieldsMapping,
          records: reportPartDetails.previewDataRecords,
          rawData: reportPartDetails.previewData
        })
      };
    },
    resetDefaultGridLine: reportPartContent.resetGridLineDefaultValue.bind(reportPartContent),
    fnResetBorderDefaultValue: reportPartContent.resetBorderDefaultValue.bind(reportPartContent),
    fnResetBackgroundColorDefaultValue: reportPartContent.resetBackgroundColorDefaultValue.bind(reportPartContent),
    fnResetXYPlaneDefaultValue: reportPartContent.resetXYPlaneDefaultValue.bind(reportPartContent),
    fnResetThresholdDefaultValue: reportPartContent.resetThresholdDefaultValue.bind(reportPartContent),
    fnResetRegressionLineDefaultValue: reportPartContent.resetRegressionLineDefaultValue.bind(reportPartContent),
    fnResetRefreshIntervalDefaultValue: reportPartContent.resetRefreshIntervalValue.bind(reportPartContent),
    fnResetLegendDefaultValue: reportPartContent.resetLegendDefaultValue.bind(reportPartContent),
    getBorder: function getBorder() {
      return {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };
    },
    hadSettingBorder: function hadSettingBorder() {
      var currentSetting = {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };

      return !((0, _fp.isEqual)(currentSetting, _Izenda2.DEFAULT_SETTING_VALUE.borderDefault) || (0, _fp.isEqual)(currentSetting, _Izenda2.DEFAULT_SETTING_VALUE.borderNew));
    },
    getBackgroundColor: function getBackgroundColor() {
      return {
        'izEntire.backgroundColor': getProperties('izEntire.backgroundColor'),
        'izPlot.backgroundColor': getProperties('izPlot.backgroundColor')
      };
    },
    hadSettingBackgroundColor: function hadSettingBackgroundColor() {
      var currentSetting = {
        'izEntire.backgroundColor': getProperties('izEntire.backgroundColor'),
        'izPlot.backgroundColor': getProperties('izPlot.backgroundColor')
      };

      return !((0, _fp.isEqual)(currentSetting, _Izenda2.DEFAULT_SETTING_VALUE.backGroundColorDefault) || (0, _fp.isEqual)(currentSetting, _Izenda2.DEFAULT_SETTING_VALUE.backGroundColorNew));
    },
    getXYPlaneSettings: function getXYPlaneSettings() {
      return {
        xAxisTitleOption: reportPartContent.getXAxisTitleOption(),
        yAxisTitleOption: reportPartContent.getYAxisTitleOption(),
        labelsElements: reportPartContent.labelsElements,
        valuesElements: reportPartContent.valuesElements,
        separatorsElements: reportPartContent.separatorsElements,
        metricAllOption: getProperties('metricAllOption')
      };
    },
    hadSettingXYPlane: function hadSettingXYPlane() {
      var labelsElements = reportPartContent.labelsElements,
          valuesElements = reportPartContent.valuesElements;

      var hasSettingAxis = function hasSettingAxis(elements) {
        var elementHasSetting = (0, _fp.filter)(function (item) {
          var axis = (0, _fp.get)('properties.otherProps.axis', item);
          return axis && (axis['izTitle.enabled'] || (item.previewDataTypeByFunction === _Izenda4.DATA_TYPES.DATE_TIME ? !(0, _fp.isNil)(axis.izTickInterval) && axis.izTickInterval != _Izenda2.DEFAULT_SETTING_VALUE.tickInterval : !(0, _fp.isNil)(axis.izTickInterval)) || !(0, _fp.isNil)(axis.izStartingPoint));
        }, elements);
        return !(0, _fp.isEmpty)(elementHasSetting);
      };

      return hasSettingAxis(labelsElements) || hasSettingAxis(valuesElements);
    },
    getGridLines: function getGridLines() {
      var gridLine = getProperties('izGridLine') || {};
      return { xAxis: gridLine.xAxis || {}, yAxis: gridLine.yAxis || {} };
    },
    getColorTheme: function getColorTheme() {
      var properties = getProperties() || {};
      return { colorPalette: properties.colorTheme, isDefaultTheme: properties.isDefaultTheme };
    },
    hasSettingGridLine: function hasSettingGridLine() {
      var gridLine = getProperties('izGridLine') || {};

      return !(0, _fp.isNil)(gridLine.xAxis) && !(0, _fp.isEmpty)(gridLine.xAxis) && gridLine.xAxis !== _Izenda2.DEFAULT_SETTING_VALUE.gridLineDefault || !(0, _fp.isNil)(gridLine.yAxis) && !(0, _fp.isEmpty)(gridLine.yAxis) && gridLine.yAxis !== _Izenda2.DEFAULT_SETTING_VALUE.gridLineDefault;
    },
    getLegendSettings: function getLegendSettings() {
      return {
        'izLegend.visibility': getProperties('izLegend.visibility'),
        'izLegend.horizontalAlign': getProperties('izLegend.horizontalAlign'),
        'izLegend.verticalAlign': getProperties('izLegend.verticalAlign'),
        'izLegend.borderColor': getProperties('izLegend.borderColor'),
        'izLegend.borderWidth': getProperties('izLegend.borderWidth'),
        'izLegend.fontStyling': getProperties('izLegend.fontStyling'),
        'izLegend.backgroundColor': getProperties('izLegend.backgroundColor')
      };
    },
    hadSettingLegend: function hadSettingLegend() {
      return getProperties('izLegend.visibility');
    },
    getThresholdSettings: function getThresholdSettings() {
      return {
        xAxisTitleOption: reportPartContent.getXAxisTitleOption(true),
        yAxisTitleOption: reportPartContent.getYAxisTitleOption(true, true),
        labelsElements: reportPartContent.labelsElements,
        valuesElements: reportPartContent.valuesElements,
        separatorsElements: reportPartContent.separatorsElements,
        metricAllPlotLinesOption: getProperties('metricAllPlotLinesOption'),
        allDynamicThresholdLine: getProperties('allDynamicThresholdLine')
      };
    },
    hadSettingThreshold: function hadSettingThreshold() {
      var labelsElements = reportPartContent.labelsElements;
      var valuesElements = reportPartContent.valuesElements;
      var chartType = (0, _fp.get)('properties.chartType', reportPartContent);
      var notSupportDynamic = chartType === 'Bubble' || chartType === 'Scatter';
      var notSupportALL = (0, _Izenda2.isChartType)(chartType, _Izenda.CHART_TYPE.Combination, _Izenda.CHART_TYPE.Waterfall);
      var metricAllPlotLinesOption = !notSupportALL && !notSupportDynamic ? getProperties('metricAllPlotLinesOption') : [];
      var allDynamicThresholdLine = !notSupportALL && !notSupportDynamic ? getProperties('allDynamicThresholdLine') : [];

      // here
      var hasThreshold = function hasThreshold(elements) {
        var elementHasSetting = (0, _fp.flow)((0, _fp.flatMap)(function (element) {
          return element.properties.otherProps;
        }), (0, _fp.filter)(function (otherProps) {
          return otherProps.threshold && !(0, _fp.isEmpty)(otherProps.threshold) || !notSupportDynamic && otherProps.dynamicThresholds && !(0, _fp.isEmpty)(otherProps.dynamicThresholds);
        }))(elements);
        return !(0, _fp.isEmpty)(elementHasSetting);
      };

      return hasThreshold(labelsElements) || hasThreshold(valuesElements) || !(0, _fp.isNil)(metricAllPlotLinesOption) && !(0, _fp.isEmpty)(metricAllPlotLinesOption) || !(0, _fp.isNil)(allDynamicThresholdLine) && !(0, _fp.isEmpty)(allDynamicThresholdLine);
    },
    getRegressionLineSettings: function getRegressionLineSettings() {
      return {};
    },
    hadSeparators: function hadSeparators() {
      return !(0, _fp.isEmpty)(reportPartContent.separatorsElements);
    },
    removeUseSeparator: function removeUseSeparator() {
      reportPartContent.resetSeparator(false);
      fieldStore.needUpdatePreview(reportPartDetails);
    },
    hadSettingRegressionLine: function hadSettingRegressionLine() {
      return reportPartContent.hadSettingRegressionLine();
    },
    getDataRefreshInterval: function getDataRefreshInterval() {
      return getProperties('dataRefreshInterval');
    },
    hadSettingRefreshInterval: function hadSettingRefreshInterval() {
      var defaultSetting = _Izenda2.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
      var refreshSetting = getProperties('dataRefreshInterval');

      return refreshSetting.value !== defaultSetting.value || refreshSetting.updateInterval !== defaultSetting.updateInterval;
    },
    filterRangeOptions: function filterRangeOptions(options) {
      var chartType = (0, _fp.get)('properties.chartType', reportPartContent);

      if ((0, _Izenda2.isChartType)(chartType, _Izenda.CHART_TYPE.Column, _Izenda.CHART_TYPE.Bar)) {
        return (0, _fp.filter)(function (item) {
          return item.value !== 'rangeWithAverage';
        }, options);
      }

      return options;
    }
  };
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartPropsMappingProps.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(33);

var _Izenda2 = __webpack_require__(39);

exports.default = function (reportPartDetails, fieldStore) {
  var reportPartContent = reportPartDetails.reportPartContent || {};
  var getProperties = function getProperties(key) {
    return reportPartContent.getReportPartProperties(key);
  };

  return {
    hideByChartType: function hideByChartType(optName) {
      return !(0, _fp.has)(optName, reportPartContent.defaultOptionsByType);
    },
    hideByChartTypeAndMetrics: function hideByChartTypeAndMetrics(optName) {
      var isHideByChartType = !(0, _fp.has)(optName, reportPartContent.defaultOptionsByType);
      // just only show the option only when there is one metric
      var isHideByMetrics = reportPartContent.isDisableMultiColor;

      return isHideByChartType || isHideByMetrics;
    },
    isNotBuild: function isNotBuild() {
      return !reportPartContent.isBeingBuild;
    },
    /**
     * Check to hide page break after separator.
     */doesHidePageBreakAfterSeparator: function doesHidePageBreakAfterSeparator() {
      var chartType = (0, _fp.get)('properties.chartType', reportPartContent);
      return this.isNotBuild() || !(0, _Izenda2.isChartType)(chartType, _Izenda.CHART_TYPE.Pie, _Izenda.CHART_TYPE.Donut, _Izenda.CHART_TYPE.Funnel, _Izenda.CHART_TYPE.TreeMap);
    },

    isBeingBuild: function isBeingBuild() {
      return reportPartContent.isBeingBuild;
    },
    getClassNameByChartStatus: function getClassNameByChartStatus() {
      return reportPartContent.isBeingBuild ? 'chart-being-build' : 'chart-not-build';
    },
    getChartType: function getChartType() {
      return reportPartContent.chartType;
    },
    getUseSeparator: function getUseSeparator() {
      return getProperties('izUseSeparator');
    },
    getLabelOrientationX: function getLabelOrientationX() {
      return getProperties('izLabelOrientationX') || 'izNormal';
    },
    getLabelOrientationY: function getLabelOrientationY() {
      return getProperties('izLabelOrientationY') || 'izNormal';
    },
    getValueByKey: getProperties,
    getReportPartDetails: function getReportPartDetails() {
      return reportPartDetails;
    },
    getFieldStore: function getFieldStore() {
      return fieldStore;
    },
    doesHideSingleYAxis: function doesHideSingleYAxis(optName) {
      return !(0, _fp.has)(optName, reportPartContent.defaultOptionsByType) || reportPartContent.numberOfMetric <= 1;
    }
  };
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartPropsMappingSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(28);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(579);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(423);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1114);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartPropsWidget.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  Panel: _Izenda2.default,
  CustomDropdown: _Izenda4.default,
  ColorPaletteSetting: _Izenda6.default,
  OrientationSettings: _Izenda8.default
};
module.exports = exports['default'];

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Color;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Color component (intended to use in ColorPalette)
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.Color.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function Color(_ref) {
  var value = _ref.value;

  var style = {
    backgroundColor: value
  };

  var classNames = (0, _classnames2.default)('izenda-Color', {
    'izenda-Color-noColor': !value
  });

  return _react2.default.createElement(
    'div',
    { className: classNames, style: style },
    !value && _react2.default.createElement('span', { className: 'icon-cancel' })
  );
}
module.exports = exports['default'];

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

/**
 * Initial store
 * @param {Object} props
 */
var init = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(props) {
    var store, needMaskDefault, selectedPaletteName, defaultColorThemeLabel, updateSelectedPalette, _props$value, value, paletteName;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = props.store, needMaskDefault = props.needMaskDefault, selectedPaletteName = props.selectedPaletteName, defaultColorThemeLabel = props.defaultColorThemeLabel, updateSelectedPalette = props.updateSelectedPalette, _props$value = props.value, value = _props$value === undefined ? {} : _props$value;
            paletteName = (0, _fp.isUndefined)(selectedPaletteName) ? value.colorPalette : selectedPaletteName;
            _context.next = 4;
            return store.init(paletteName, needMaskDefault, defaultColorThemeLabel);

          case 4:

            if (store.defaultColorPalette !== paletteName) {
              updateSelectedPalette && updateSelectedPalette(store.defaultColorPalette);
            }

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function init(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(2058);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(408);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Show Color Palette Selection Pop-up
 * @param {Object} props
 * @param {Object} e
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPaletteSettingActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

function showColorPaletteSelectionPopup(props, e) {
  var selectionPopupTitle = props.selectionPopupTitle,
      store = props.store,
      _props$store = props.store,
      palettes = _props$store.palettes,
      currentColorPalette = _props$store.currentColorPalette,
      onChange = props.onChange,
      displaySettingStatus = props.displaySettingStatus,
      updateSelectedPalette = props.updateSelectedPalette;


  props.openPopup(_Izenda2.default, {
    palettes: palettes,
    store: store,
    title: selectionPopupTitle,
    selectedPaletteName: currentColorPalette,
    onChange: onChange,
    displaySettingStatus: displaySettingStatus,
    updateSelectedPalette: updateSelectedPalette
  });
}

/**
 * Reset to default value if needed
 * @param {Object} props
 * @param {Object} e
 */
function resetDefaultValue(props, e) {
  var store = props.store,
      updateSelectedPalette = props.updateSelectedPalette,
      onChange = props.onChange;

  store.updateOriginalPalette(store.defaultColorPalette);

  updateSelectedPalette && updateSelectedPalette(store.defaultColorPalette);
  onChange && onChange({
    value: {
      colorPalette: store.defaultColorPalette,
      isDefaultTheme: true
    }
  });
}exports.default = (0, _recompose.compose)((0, _recompose.withProps)({
  store: new _Izenda4.default(),
  init: init
}), (0, _recompose.withHandlers)({
  showColorPaletteSelectionPopup: (0, _fp.curry)(showColorPaletteSelectionPopup),
  resetDefaultValue: (0, _fp.curry)(resetDefaultValue)
}));
module.exports = exports['default'];

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1113);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(27);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2059);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2060);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectableContext = new _Izenda13.SelectableContext();
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPaletteSelection.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var SelectableColorPalette = (0, _Izenda13.createSelectable)(_Izenda4.default, selectableContext);

exports.default = (0, _Izenda12.default)(_Izenda10.default)(function ColorPaletteSelection(props) {
  var localization = props.localization,
      title = props.title,
      palettes = props.palettes,
      selectedPaletteName = props.selectedPaletteName;

  var Cols = 3;
  var smallCols = 6;

  var renderRows = function renderRows(palettes) {
    return palettes.map(function (item, index) {
      return _react2.default.createElement(
        _Izenda6.default.Col,
        {
          cols: Cols,
          xs: smallCols,
          className: 'u_noPaddingLeft izenda-ColorPaletteSelection-Col',
          key: '' + index
        },
        _react2.default.createElement(SelectableColorPalette, {
          model: item,
          isDefaultTheme: item.isDefaultTheme,
          displaySettingStatus: props.displaySettingStatus,
          selected: selectedPaletteName === item.name,
          onClick: props.onSelectColorPalette.bind(null, item)
        })
      );
    });
  };

  return _react2.default.createElement(
    _Izenda2.default,
    { visible: true, onClosing: props.onClosing, autoClose: false, type: 'none', sizeClass: 'modal-lg' },
    _react2.default.createElement(_Izenda2.default.Header, { title: title }),
    _react2.default.createElement(
      _Izenda2.default.Body,
      null,
      _react2.default.createElement(
        'div',
        { className: 'izenda-ColorPaletteSelection' },
        _react2.default.createElement(
          _Izenda8.default,
          null,
          _react2.default.createElement(
            _Izenda6.default,
            null,
            renderRows(palettes)
          )
        )
      )
    ),
    _react2.default.createElement(
      _Izenda2.default.Footer,
      null,
      _react2.default.createElement(
        _Izenda2.default.ConfirmationButton,
        { type: 'accept' },
        localization.getText('COMMON_LABEL_OK')
      ),
      _react2.default.createElement(
        _Izenda2.default.ConfirmationButton,
        { type: 'cancel' },
        localization.getText('COMMON_LABEL_CANCEL')
      )
    )
  );
});
module.exports = exports['default'];

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(961);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * On closing popup handler.
 * @param {Object} props
 * @param {Object} closeCallback
 * @param {string} type
 */
function onClosing(props, closeCallback, type) {
  var store = props.store,
      selectedPaletteName = props.selectedPaletteName,
      updateSelectedPalette = props.updateSelectedPalette,
      onChange = props.onChange;

  if (type === 'accept') {
    var doesNeedToUpdate = store.currentColorPalette !== selectedPaletteName;

    if (doesNeedToUpdate) {
      store.updateOriginalPalette(store.currentColorPalette);
      updateSelectedPalette && updateSelectedPalette(store.currentColorPalette);
    }

    // Always call onChange with properties editor with case update isDefaultTheme
    onChange && onChange({
      value: {
        colorPalette: store.currentColorPalette,
        isDefaultTheme: store.currentColorPalette === store.defaultColorPalette
      }
    });

    return props.onAccept();
  } else if (type === 'cancel') {
    store.resetSelectedPalette();

    return props.onReject();
  }
}

/**
 * On select a color palette handler
 * @param {Object} props
 * @param {ColorPalette} colorPalette
 * @param {Object} e
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPaletteSelectionActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

function onSelectColorPalette(props, colorPalette, e) {
  props.store.updateSelectedPalette(colorPalette.name);
}

exports.default = (0, _recompose.withHandlers)({
  onClosing: (0, _fp.curry)(onClosing),
  onSelectColorPalette: (0, _fp.curry)(onSelectColorPalette)
});
module.exports = exports['default'];

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSelectable = exports.SelectableContext = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _desc2, _value2, _class3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Selectable.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SelectableState = (_class =

/**
 * Initial instant
 * @param {boolean} selected
 */
function SelectableState(selected) {
  (0, _classCallCheck3.default)(this, SelectableState);

  _initDefineProp(this, 'selected', _descriptor, this);

  this.selected = selected;
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'selected', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
var SelectableContext = exports.SelectableContext = (_class3 = function () {
  function SelectableContext() {
    (0, _classCallCheck3.default)(this, SelectableContext);

    this.observers = [];
  }

  /**
   * Register a selectable component
   * @param {string} key
   * @param {SelectableState} selectableState
   */


  (0, _createClass3.default)(SelectableContext, [{
    key: 'register',
    value: function register(key, selectableState) {
      this.observers.push({ key: key, selectableState: selectableState });
    }

    /**
     * Unregister a selectable component
     * @param {string} key
     */

  }, {
    key: 'unregister',
    value: function unregister(key) {
      var index = (0, _fp.findIndex)(function (i) {
        return i.key === key;
      }, this.observers);
      index > -1 && this.observers.splice(index, 1);
    }

    /**
     * Handle select a selectable component
     * @param {string} key
     */

  }, {
    key: 'onSelect',
    value: function onSelect(key) {
      var selectedItem = (0, _fp.find)(function (item) {
        return item.key === key;
      }, this.observers);
      if (selectedItem.selectableState.selected) return false;

      this.observers.forEach(function (item) {
        item.selectableState.selected && (item.selectableState.selected = false);
      });

      selectedItem.selectableState.selected = true;
      return true;
    }
  }]);
  return SelectableContext;
}(), (_applyDecoratedDescriptor(_class3.prototype, 'onSelect', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'onSelect'), _class3.prototype)), _class3);

/**
 * HOC makes a selectable component
 * Component mush have selected props and onClick props
 * @param {Component} WrappedComponent
 * @param {SelectableContext} context
 */

var createSelectable = exports.createSelectable = function createSelectable(WrappedComponent, context) {
  var _class4;

  var SelectableItem = (0, _mobxReact.observer)(_class4 = function (_Component) {
    (0, _inherits3.default)(SelectableItem, _Component);

    function SelectableItem(props) {
      (0, _classCallCheck3.default)(this, SelectableItem);

      var _this = (0, _possibleConstructorReturn3.default)(this, (SelectableItem.__proto__ || (0, _getPrototypeOf2.default)(SelectableItem)).call(this, props));

      _this.onClickHandler = function (e) {
        if (context.onSelect(_this.key)) {
          _this.props.onClick && _this.props.onClick(e);
        }
      };

      _this.selectableState = new SelectableState(!!props.selected);
      _this.key = (0, _fp.uniqueId)('Selectable_');
      return _this;
    }

    (0, _createClass3.default)(SelectableItem, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        context.register(this.key, this.selectableState);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        context.unregister(this.key);
      }
    }, {
      key: 'render',
      value: function render() {
        var restProps = (0, _fp.omit)(['selected'], this.props);
        return _react2.default.createElement(
          'div',
          { onClick: this.onClickHandler },
          _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, restProps, { selected: this.selectableState.selected }))
        );
      }
    }]);
    return SelectableItem;
  }(_react.Component)) || _class4;

  return SelectableItem;
};

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartPropsOnChangeValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
exports.default = function (reportPartDetails, fieldStore) {
  return (0, _mobx.action)('OnChangeChartProps', function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, derivedChange) {
    var reportPartContent = reportPartDetails.reportPartContent || {};

    var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
    var fieldData = groupData[changedKey];

    fieldData && (fieldData.value = changedValue);

    var generalInfo = (0, _fp.getOr)({}, 'generalInfo', schemaData);
    var chart = (0, _fp.getOr)({}, 'chart', schemaData);
    var labels = (0, _fp.getOr)({}, 'labels', schemaData);
    var legends = (0, _fp.getOr)({}, 'legends', schemaData);
    var grouping = (0, _fp.getOr)({}, 'grouping', schemaData);
    var data = (0, _fp.getOr)({}, 'data', schemaData);
    var view = (0, _fp.getOr)({}, 'view', schemaData);
    var printing = (0, _fp.getOr)({}, 'printing', schemaData);
    var dataRefreshInterval = getValue('dataRefreshInterval', view);
    var chartType = getValue('chartType', generalInfo);
    var izMultiColor = getMultiColorValue(changedKey, chartType, chart);
    var izMultiLevel = getValue('izMultiLevel', chart);

    var izBorder = getValue('izBorder', chart) || {};
    var izXYPlane = getValue('izXYplane', chart);
    var colorTheme = getValue('colorTheme', chart);

    var izGridline = getValue('izGridline', chart) || {};
    var izBackGroundColor = getValue('izBackgroundColor', chart) || {};
    var legendSettings = getValue('legendSettings', legends) || {};

    var thresholdSettings = getValue('izThresholds', data) || {};
    var izBottomXpercent = getValue('izBottomXpercent', grouping) || 0;
    var izPageBreakAfterSeparator = getValue('izPageBreakAfterSeparator', printing) || false;

    var chartProperties = {
      chartType: chartType,
      colorTheme: colorTheme.colorPalette,
      isDefaultTheme: colorTheme.isDefaultTheme,
      commonOptions: {
        /* border */
        'izEntire.borderColor': izBorder['izEntire.borderColor'],
        'izEntire.borderWidth': izBorder['izEntire.borderWidth'],
        'izEntire.borderStyle': izBorder['izEntire.borderStyle'] /* label orientation for data */
        , izLabelOrientation: getValue('izLabelOrientation', labels),
        izHoverLabels: getValue('izHoverLabels', labels) /*background color */
        , 'izEntire.backgroundColor': izBackGroundColor['izEntire.backgroundColor'],
        'izPlot.backgroundColor': izBackGroundColor['izPlot.backgroundColor'] /*Legend settings */
        , 'izLegend.visibility': legendSettings['izLegend.visibility'],
        'izLegend.horizontalAlign': legendSettings['izLegend.horizontalAlign'],
        'izLegend.verticalAlign': legendSettings['izLegend.verticalAlign'],
        'izLegend.borderColor': legendSettings['izLegend.borderColor'],
        'izLegend.borderWidth': legendSettings['izLegend.borderWidth'],
        'izLegend.fontStyling': legendSettings['izLegend.fontStyling'],
        'izLegend.backgroundColor': legendSettings['izLegend.backgroundColor']
      },
      optionByType: {
        /* Multi Color */
        izMultiColor: izMultiColor,
        izMultiLevel: izMultiLevel,
        izUseSeparator: getValue('izUseSeparator', grouping),
        izInverted: getValue('izInverted', view),
        izStep: getValue('izStep', view),
        izSpline: getValue('izSpline', view),
        izStacking: getValue('izStacking', grouping),
        izRange: getValue('izRange', data),
        izValueLabel: getValue('izValueLabel', data),
        izSliceLabel: getValue('izSliceLabel', data),
        izShowPercentage: changedKey === 'izBottomXpercent' && izBottomXpercent ? true : getValue('izShowPercentage', data),
        izPieChartStyle: getValue('izPieChartStyle', view),
        izBottomXpercent: izBottomXpercent,
        izZoom: getValue('izZoom', view),
        izUsePagination: getValue('izUsePagination', view),
        izItemPerRow: getValue('izItemPerRow', view),
        izSingleYAxis: getValue('izSingleYAxis', view)
      },
      commonXYAxis: {
        izGridLine: izGridline,
        izLabelOrientationY: getValue('izLabelOrientationY', labels),
        izLabelOrientationX: getValue('izLabelOrientationX', labels),
        metricAllOption: (0, _fp.get)('metricAllOption', izXYPlane),
        metricAllPlotLinesOption: (0, _fp.get)('metricAllPlotLinesOption', thresholdSettings),
        allDynamicThresholdLine: (0, _fp.get)('allDynamicThresholdLine', thresholdSettings)
      },
      view: { dataRefreshInterval: dataRefreshInterval },
      printing: { izPageBreakAfterSeparator: izPageBreakAfterSeparator }
    };

    if (changedKey === 'izThresholds') {
      fieldStore.needUpdatePreview(reportPartDetails, null, null, null, null, null, true);
    }
    if (changedKey === 'chartType') {
      reportPartContent.setChartType(chartProperties.chartType).then(function (isNeedUpdatePreviewData) {
        isNeedUpdatePreviewData && !(0, _fp.isEmpty)(isNeedUpdatePreviewData) && fieldStore.needUpdatePreview && fieldStore.needUpdatePreview(reportPartDetails);
      });

      var newMultiColor = getMultiColorValue(changedKey, chartType, chart);
      // update the value for multi color option on the Properties Panel
      if ((0, _fp.has)('izMultiColor.value', chart)) {
        chart.izMultiColor.value = newMultiColor;
      }

      // set value for report part content to make the chart changing
      reportPartContent.setMultiColor(newMultiColor);

      // Reset range value when change chart type
      if (!(0, _fp.isEmpty)(getValue('izRange', data))) {
        data.izRange.value = '';
      }
    }

    changedKey === 'izUseSeparator' && reportPartContent.resetSeparator(getValue('izUseSeparator', grouping));
    changedKey === 'izMultiColor' && reportPartContent.setMultiColorDirty();

    // if user change stage of multi level. We also reset drilldown filters and cross filters .
    if (changedKey === 'izMultiLevel') {
      if (reportPartContent.expandedLevel > 0) {
        reportPartContent.resetDrilldownInfo && reportPartContent.resetDrilldownInfo();
        fieldStore.removePillByReportPart && fieldStore.removePillByReportPart(reportPartDetails);
      }

      // if user turn on MultiLevel then Multi color also turn on.
      if (!!izMultiLevel) {
        if ((0, _fp.has)('izMultiColor.value', chart)) {
          chart.izMultiColor.value = true;
        }

        if ((0, _fp.has)('optionByType.izMultiColor', chartProperties)) {
          chartProperties.optionByType.izMultiColor = true;
        }
        reportPartContent.setMultiColor(true);
        reportPartContent.setMultiColorDirty();
      }
    }

    derivedChange && derivedChange(chartProperties);

    // Remove properties which don't have for selected chart-type
    chartProperties.optionByType = (0, _fp.omitBy)(_fp.isNil, chartProperties.optionByType);
    // Commit the change to model
    changedKey !== 'chartType' && reportPartDetails.setReportPartProperties(chartProperties);

    var reloadData = (0, _fp.includes)(changedKey, ['izRange', 'izMultiLevel']);

    var resultPromise = needToResetFunctionFormat() ? fieldStore.resetFunctionFormat(reportPartContent).then((0, _fp.constant)(true)) : (0, _bluebird.resolve)(reloadData);

    return resultPromise.then(function (needToUpdate) {
      return {
        needToUpdate: needToUpdate,
        chartProperties: chartProperties
      };
    });

    function needToResetFunctionFormat() {
      return changedKey === 'izRange' && (0, _fp.has)('izRange', reportPartContent.defaultOptionsByType) && (0, _fp.get)('optionByType.izRange', chartProperties) === '';
    }

    /**
     * Get value multi color option
     * @param {string} changedKey
     * @param {string} chartType
     * @param {Object} obj
     */
    function getMultiColorValue(changedKey, chartType, chart) {
      var defaultChartOptionByType = reportPartContent.defaultOptionsByType;
      var izMultiColorDefaultValue = (0, _fp.has)('izMultiColor', defaultChartOptionByType) && defaultChartOptionByType.izMultiColor;

      var izMultiColor = null;
      if (changedKey === 'chartType' && reportPartDetails.state === 1) {
        izMultiColor = reportPartContent.multiColorDirty ? getValue('izMultiColor', chart) : izMultiColorDefaultValue;
      } else {
        izMultiColor = getValue('izMultiColor', chart);
      }
      return izMultiColor;
    }
  });
};

/**
 * Get value
 * @param {string} key
 * @param {Object} obj
 */


function getValue(key, obj) {
  return (0, _fp.get)([key, 'value'].join('.'), obj);
}
module.exports = exports['default'];

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(20);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _defineProperty4 = __webpack_require__(94);

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _extends3 = __webpack_require__(14);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartChartContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartChartContent model
 */


var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(49);

var _Izenda5 = __webpack_require__(425);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(64);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(53);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(33);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(39);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2063);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(225);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(35);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty3.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SORT_ORDERS = _Izenda8.default.SORT_ORDERS;
var ContainerName = _Izenda14.default.ContainerName,
    COMBINE_CHART_DEFAULT_VALUE = _Izenda14.default.COMBINE_CHART.DEFAULT_VALUE,
    SPARKLINE_CHART_DEFAULT_VALUE = _Izenda14.default.SPARK_LINE_CHART.DEFAULT_VALUE;
var CHART_TYPE = _Izenda12.default.CHART_TYPE,
    METRIC_ALL = _Izenda12.default.DefaultConfig.METRIC_ALL;


var NEED_UPDATE_DATA_CHART_TYPE = [CHART_TYPE.Bubble, CHART_TYPE.Scatter, CHART_TYPE.Donut, CHART_TYPE.HeatMap, CHART_TYPE.Sparkline, CHART_TYPE.TreeMap];
var populateReportChartCustomContainer = _Izenda20.default.populateReportChartCustomContainer,
    populateReportChartContainer = _Izenda20.default.populateReportChartContainer,
    getElements = _Izenda20.default.getElements,
    hasElement = _Izenda20.default.hasElement,
    resetDefaultSetting = _Izenda20.default.resetDefaultSetting;


var NUMBER_ZERO = 0;
var NUMBER_ONE = 1;
var NUMBER_TWO = 2;
var NUMBER_THREE = 3;
var NUMBER_FINE = 5;
var NUMBER_CHECK_INDEX = -1;

var ReportPartChartContent = (_dec = (0, _Izenda4.exportClass)('ReportPartChartContent'), _dec2 = (0, _mobx.action)('setTotalLabel'), _dec3 = (0, _mobx.action)('afterInsertFieldToContainer'), _dec4 = (0, _mobx.action)('afterAddField'), _dec5 = (0, _mobx.action)('afterUpdateFunction'), _dec6 = (0, _mobx.action)('afterRemoveField'), _dec7 = (0, _mobx.action)('readData'), _dec8 = (0, _mobx.action)('setReportPartProperties'), _dec9 = (0, _mobx.action)('buildDataForSave'), _dec10 = (0, _mobx.action)('setChartType'), _dec11 = (0, _mobx.action)('convertChartType'), _dec12 = (0, _mobx.action)('initCombinationChartData'), _dec13 = (0, _mobx.action)('initSparklineChartData'), _dec14 = (0, _mobx.action)('mergeContainerElements'), _dec15 = (0, _mobx.action)('updateContainerElementsPosition'), _dec16 = (0, _mobx.action)('removeUndefined'), _dec17 = (0, _mobx.action)('resetContainer'), _dec18 = (0, _mobx.action)('resetSeparator'), _dec19 = (0, _mobx.action)('changePositionField'), _dec20 = (0, _mobx.action)('updateDrilldownInfo'), _dec21 = (0, _mobx.action)('resetDrilldownInfo'), _dec22 = (0, _mobx.action)('resetGridLineDefaultValue'), _dec23 = (0, _mobx.action)('resetBorderDefaultValue'), _dec24 = (0, _mobx.action)('resetBackgroundColorDefaultValue'), _dec25 = (0, _mobx.action)('resetXYPlaneDefaultValue'), _dec26 = (0, _mobx.action)('resetThresholdDefaultValue'), _dec27 = (0, _mobx.action)('resetRefreshIntervalValue'), _dec28 = (0, _mobx.action)('resetLegendDefaultValue'), _dec(_class = (0, _Izenda2.default)(_class = (_class2 = function (_ReportPartContent) {
  (0, _inherits3.default)(ReportPartChartContent, _ReportPartContent);

  function ReportPartChartContent(reportPartContent) {
    (0, _classCallCheck3.default)(this, ReportPartChartContent);

    // properties which do not to observer
    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartChartContent.__proto__ || (0, _getPrototypeOf2.default)(ReportPartChartContent)).call(this, _Izenda3.REPORT_PART_TYPE.Chart));

    _initDefineProp(_this, 'isCrossFiltering', _descriptor, _this);

    _initDefineProp(_this, 'title', _descriptor2, _this);

    _initDefineProp(_this, 'description', _descriptor3, _this);

    _initDefineProp(_this, 'activeSerie', _descriptor4, _this);

    _initDefineProp(_this, 'inconsitentFunction', _descriptor5, _this);

    _this.multiColorDirty = false;

    _initDefineProp(_this, 'properties', _descriptor6, _this);

    _initDefineProp(_this, 'drilldownInfo', _descriptor7, _this);

    _this.getActiveElmsByActiveSeries = function (activeSerieKey) {
      var metricContainer = _this.getMetricContainer();
      var getActiveElement = function getActiveElement(container) {
        return getElements(container, activeSerieKey, metricContainer);
      };

      var customContainersObject = (0, _fp.reduce)(function (obj, container) {
        return (0, _extends4.default)({}, obj, (0, _defineProperty5.default)({}, container.name, getActiveElement(container)));
      }, {})(_this.customContainers);

      return (0, _extends4.default)({
        labels: getActiveElement(_this.labels),
        values: getActiveElement(_this.values),
        valuesLabels: getActiveElement(_this.valuesLabels),
        separators: getActiveElement(_this.separators),
        bubbleSize: getActiveElement(_this.bubbleSize)
      }, customContainersObject);
    };

    _initDefineProp(_this, 'resetDrilldownInfo', _descriptor8, _this);

    _this.staticProperties = {};

    var props = {};

    // important - these containers save list of fields to get data and render report
    _Izenda20.default.addContainers(props, ContainerName.LABELS);
    _Izenda20.default.addContainers(props, ContainerName.VALUES);
    _Izenda20.default.addContainers(props, ContainerName.VALUES_LABELS);
    _Izenda20.default.addContainers(props, ContainerName.SEPARATORS);
    _Izenda20.default.addContainers(props, ContainerName.BUBBLE_SIZE);
    _this.addCustomContainer(ContainerName.DYNAMIC_THRESHOLD);

    (0, _mobx.extendObservable)(_this, props);

    !!reportPartContent ? _this.readData(reportPartContent) : _this.setReportPartProperties();

    // trick - access num elements of each container to trigger change
    // every have action on component (add/delete field, visible/hidden element)
    _this.drilldownReaction = (0, _mobx.reaction)(function () {
      return _this[ContainerName.LABELS].numElement + _this[ContainerName.VALUES].numElement + _this[ContainerName.VALUES_LABELS].numElement + _this[ContainerName.SEPARATORS].numElement + _this[ContainerName.BUBBLE_SIZE].numElement;
    }, _this.resetDrilldownInfo);

    _this.cleanDirty();
    return _this;
  }
  // use to show/hide fields which need to draw chart - do not save


  (0, _createClass3.default)(ReportPartChartContent, [{
    key: 'checkedCompatibleFunction',


    /**
     * check if function is compatible with element
     * @param {Object} container
     * @param {Object} element
     * @param {Object} functionInfo
     * @return {boolean}
     */
    value: function checkedCompatibleFunction(container, element, functionInfo) {
      if (!container) {
        return true;
      }

      var result = true;
      var functionName = (0, _fp.getOr)(_Izenda8.default.EMPTY_FUNCTION.name, 'name', functionInfo);
      var hasAggregatedFunction = element.field.hasAggregatedFunction;

      // If the field is in Values container of Column/Bar/Area chart type with selected Range Only,
      // then no error message is shown. Behind the scene, system will get the Min and Max function to draw those charts
      // function will not have any meaning in this case, so we will treat all function as invalid
      if (this.isChartType(this.chartType, CHART_TYPE.Column, CHART_TYPE.Area, CHART_TYPE.Bar) && container.name === 'values' && (0, _fp.get)('optionByType.izRange', this.properties)) {
        return false;
      }

      // If the user add a calculated field which contains the aggregated field
      // then the user cannot select any aggregated field in Function dropdown in
      // Field Properties Panel. The user can select “empty” function or other user
      // defined functions which has function level = field.
      if (hasAggregatedFunction) {
        result = functionInfo.userDefined || !functionName;
      }

      var checkDataTypeNumericMoney = (0, _fp.includes)(_fp.placeholder, ['Numeric', 'Money']);

      var needNumericMoneyChartTypes = [CHART_TYPE.Line, CHART_TYPE.Column, CHART_TYPE.Bar, CHART_TYPE.Area, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.Donut, CHART_TYPE.Combination, CHART_TYPE.TreeMap, CHART_TYPE.Waterfall, CHART_TYPE.Sparkline];

      if (result && (this.isChartType(this.chartType, CHART_TYPE.Bubble) && container.name === 'bubbleSize' || this.isChartType.apply(this, [this.chartType].concat(needNumericMoneyChartTypes)) && container.name === 'values')) {
        // function return Money or Numeric
        result = checkDataTypeNumericMoney(functionInfo.formatDataType) ||
        // Element data type is Money or numeric and function is empty function
        checkDataTypeNumericMoney(element.fieldDataType) && !functionName;
      }

      var config = (0, _Izenda16.default)(this.chartType);

      config = config && config[container.name];

      if (!config || !result) {
        return result;
      }

      return _Izenda20.default.checkCompatibleFunctionCommon(functionInfo, element, config);
    }

    /**
     * validate function based on container
     * @param {Object} container
     * @param {Object} functionInfo
     * @returns {Object}
     */

  }, {
    key: 'validateFunction',
    value: function validateFunction(container, functionInfo) {
      return !(0, _fp.get)('name', functionInfo) ? {
        status: true,
        useDefaultFunction: true
      } : {
        status: true
      };
    }

    /**
     * Get Default Function And Format for field in container
     * @param {Object} container
     * @param {string} dataType
     * @returns {Object}
     */

  }, {
    key: 'getDefaultFunctionFormat',
    value: function getDefaultFunctionFormat(container, dataType) {
      if (container.name === 'values' && this.defaultOptionsByType.hasOwnProperty('izRange') && !!(0, _fp.get)('optionByType.izRange', this.properties)) {
        return null;
      }

      var baseChartType = this.getBaseChartType(this.chartType) || '';
      var defaultFunction = (0, _fp.get)(this.chartType, _Izenda14.default.DefaultFunction) || (0, _fp.get)(baseChartType, _Izenda14.default.DefaultFunction);

      var byContainer = defaultFunction && defaultFunction[container.name || ''] || {};

      return _Izenda20.default.getDefaultFunction(byContainer, dataType);
    }

    /**
     * Mark dirty when user touch on Multi Color option
     */

  }, {
    key: 'setMultiColorDirty',
    value: function setMultiColorDirty() {
      this.multiColorDirty = true;
    }

    /**
     * set total label
     * @param {Object} value
     * TODO: move to report part chart content
     */

  }, {
    key: 'setTotalLabel',
    value: function setTotalLabel(value) {
      this.properties.optionByType.izTotalLabel = value;
      this.markDirty();
    }

    /**
     * action invoke after insert new field into container
     * @param {Object} container
     * @param {Object} field
     */

  }, {
    key: 'afterInsertFieldToContainer',
    value: function afterInsertFieldToContainer(container, field) {
      var metric = this.getMetricContainer();
      // set metric to the last inserted field in metric container
      container.name === metric && this.setActiveSerie(null, (0, _fp.last)(this[metric].elements));
      this.updateMultiColorPropValue();

      switch (true) {
        case this.isChartType(this.chartType, CHART_TYPE.Combination):
          this.initCombinationElementData(field);
          break;
        case this.isChartType(this.chartType, CHART_TYPE.Sparkline):
          this.initSparklineElementData(field);
          break;
      }
    }

    /**
     * After add field
     */

  }, {
    key: 'afterAddField',
    value: function afterAddField() {
      var _this2 = this;

      if (this.isBeingBuild) {
        // Reset sort value  to 'ASC' for fields in LABEL if it matches conditional linear type
        (0, _fp.forEach)(function (item) {
          _Izenda20.default.isLinear(item, _this2.defaultOptionsByType) && _this2.resetSortAscending(item);
        }, this.labelsElements);

        // Set sort value 'ASC' for first field in LABEL if there isn't any existing sorted fields
        var firstPosition = 1;
        var lengthToApplySort = 2;
        var ASC = SORT_ORDERS.ASC,
            DESC = SORT_ORDERS.DESC;

        var needSortFirstField = this.labelsElements.length >= lengthToApplySort && !(0, _fp.some)(function (field) {
          var sort = (0, _fp.get)('properties.dataFormattings.sort', field);
          return (0, _fp.includes)(sort, [ASC.value, DESC.value]);
        }, this.allFieldCollection);
        var firstField = (0, _fp.find)(function (ele) {
          return ele.position === firstPosition;
        }, this.labelsElements);
        needSortFirstField && firstField.properties.setSortValue(ASC.value);
      }
    }

    /**
     * update value of izDisableMultiColor
     * @method updateMultiColorPropValue
     */

  }, {
    key: 'updateMultiColorPropValue',
    value: function updateMultiColorPropValue() {
      this.properties.commonOptions.izDisableMultiColor = this.isDisableMultiColor;
    }

    /**
     * This function is to show the confirm message to disable multi color in case of there are more than one metric.
     * @method validateMoreThanOneMetric
     * @param {Object} container: container to add more metric
     */

  }, {
    key: 'validateMoreThanOneMetric',
    value: function validateMoreThanOneMetric(container) {
      var type = (0, _fp.get)('properties.chartType', this);
      var metricContainer = this.getMetricContainer();
      var numberOfMetrics = (0, _fp.get)('numberOfMetric', this);
      var izMultiColor = (0, _fp.get)('properties.optionByType.izMultiColor', this);
      var isDisableMultiColor = (0, _fp.get)('properties.commonOptions.izDisableMultiColor', this);
      // Sparkline and HeatMap DO NOT support multi color so we dont need to show error message
      if (isDisableMultiColor === false && !this.isChartType(type, CHART_TYPE.Sparkline, CHART_TYPE.HeatMap, CHART_TYPE.Waterfall, CHART_TYPE.Donut, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.TreeMap) && metricContainer === container.name && izMultiColor === true && numberOfMetrics > NUMBER_ZERO) {
        return _Izenda10.default.MESSAGES.M29;
      }
      return null;
    }

    /**
     * Check if report part content had setting regression line
     */

  }, {
    key: 'hadSettingRegressionLine',
    value: function hadSettingRegressionLine() {
      return (0, _fp.some)(function (ele) {
        return !(0, _fp.isEmpty)((0, _fp.get)('regression', ele.properties.getOtherProps()));
      }, this.serieChartList);
    }

    /**
     * Validate remove regression line when add separator
     */

  }, {
    key: 'validateRemoveRegressionLine',
    value: function validateRemoveRegressionLine(container) {
      return container.name === ContainerName.SEPARATORS && this.hadSettingRegressionLine() ? this.isChartType(this.chartType, CHART_TYPE.Sparkline, CHART_TYPE.HeatMap, CHART_TYPE.Waterfall, CHART_TYPE.Donut, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.TreeMap) ? { remove: true, message: null } : { remove: true, message: _Izenda10.default.MESSAGES.M30 } : { remove: false, message: null };
    }

    /**
     * after update function for field
     * @method afterUpdateFunction
     */

  }, {
    key: 'afterUpdateFunction',
    value: function afterUpdateFunction() {
      this.inconsitentFunction = (0, _fp.some)({ haveFunction: true }, this.allFieldCollection) && (0, _fp.some)(function (item) {
        return !item.haveFunction && !item.field.isRunningField;
      }, this.allFieldCollection);
    }

    /**
     * Action is invoked after removing an field from container
     * @param {Object} container
     */

  }, {
    key: 'afterRemoveField',
    value: function afterRemoveField(container) {
      // Update properties yAxis option along with deleted element
      if (container.name === this.getMetricContainer()) {
        this.updateMultiColorPropValue();
        container.elements.length === NUMBER_ONE && this.properties.commonXYAxis && (this.properties.commonXYAxis.metricAllOption = {});
        container.elements.length >= NUMBER_ONE && this.setActiveSerie(null, (0, _fp.head)(container.elements));
      }
    }

    /**
     * Init field data for Combination chart
     * @param {Object} element
     * @param {boolean} isResetData
     */

  }, {
    key: 'initCombinationElementData',
    value: function initCombinationElementData(element, isResetData) {
      var elementProps = element && element.properties;
      var otherProps = elementProps && elementProps.getOtherProps && elementProps.getOtherProps();
      otherProps = (0, _fp.merge)(otherProps, {
        chartType: isResetData ? undefined : COMBINE_CHART_DEFAULT_VALUE.chartType,
        lineWidth: isResetData ? undefined : COMBINE_CHART_DEFAULT_VALUE.lineWidth,
        dashStyle: isResetData ? undefined : COMBINE_CHART_DEFAULT_VALUE.dashStyle
      });
      elementProps && elementProps.setOtherProps && elementProps.setOtherProps(undefined, otherProps);
    }

    /**
     * Init field data for Sparkline chart
     * @param {Object} element
     * @param {boolean} isResetData
     */

  }, {
    key: 'initSparklineElementData',
    value: function initSparklineElementData(element, isResetData) {
      var elementProps = element && element.properties;
      var otherProps = elementProps && elementProps.getOtherProps && elementProps.getOtherProps();
      otherProps = (0, _fp.merge)(otherProps, {
        chartType: isResetData ? undefined : SPARKLINE_CHART_DEFAULT_VALUE.chartType,
        lineWidth: isResetData ? undefined : SPARKLINE_CHART_DEFAULT_VALUE.lineWidth,
        dashStyle: isResetData ? undefined : SPARKLINE_CHART_DEFAULT_VALUE.dashStyle,
        showTotal: false
      });
      elementProps.setOtherProps && elementProps.setOtherProps(undefined, otherProps);
    }

    /**
     * read data from api/create report part to update data
     * @param {Object} content [data from api/create report part]
     */

  }, {
    key: 'readData',
    value: function readData(content) {
      content = content || {};
      var properties = content.properties || {};
      this.isCrossFiltering = content.isCrossFiltering;
      // report part properties
      this.staticProperties = (0, _fp.get)('staticProperties', properties);
      this.setReportPartProperties((0, _fp.omit)('staticProperties', properties));
      // this.type = content.type;
      this.labels = populateReportChartContainer(content.labels, 'labels');
      this.values = populateReportChartContainer(content.values, 'values');
      populateReportChartCustomContainer(content.customContainers, this.customContainers);
      this.valuesLabels = populateReportChartContainer(content.valuesLabels, 'valuesLabels');
      this.separators = populateReportChartContainer(content.separators, 'separators');
      this.bubbleSize = populateReportChartContainer(content.bubbleSize, 'bubbleSize');
      this.settings = content.settings;
      this.setActiveSerie(null, (0, _fp.find)({ fieldName: content.selectedMetric }, this.serieChartList));
      this.updateMultiColorPropValue();
    }

    /**
     * Set data by data key
     * @param {string} key
     * @param {Object} newVal
     */

  }, {
    key: 'setDataByKey',
    value: function setDataByKey(key, newVal) {
      this[key] = newVal;
      this.markDirty();
    }

    /**
     * Get data by data key
     * @param {string} key
     * @return {Object}
     */

  }, {
    key: 'getDataByKey',
    value: function getDataByKey(key) {
      return this[key];
    }

    /**
     * get report part properties
     * @param {string} propKey
     * @return {Object}
     */

  }, {
    key: 'getReportPartProperties',
    value: function getReportPartProperties(propKey) {
      var props = this.properties || {};

      if (!propKey) {
        return (0, _fp.assign)({ staticProperties: this.staticProperties }, props);
      }

      var definedVal = (0, _fp.getOr)((0, _fp.get)(propKey, props.optionByType || {}), propKey, props.commonOptions || {});
      definedVal = (0, _fp.isUndefined)(definedVal) ? (0, _fp.get)(propKey, props.view) : definedVal;
      definedVal = (0, _fp.isUndefined)(definedVal) ? (0, _fp.get)(propKey, props.commonXYAxis) : definedVal;
      definedVal = (0, _fp.isUndefined)(definedVal) ? (0, _fp.get)(propKey, props.printing) : definedVal;

      if ((0, _fp.isUndefined)(definedVal)) {
        return (0, _fp.getOr)((0, _fp.get)(propKey, this.defaultOptionsByType || {}), propKey, this.defaultCommonOptions);
      }
      return definedVal;
    }

    /**
     * set report part properties
     * @param {Object} newProps
     */

  }, {
    key: 'setReportPartProperties',
    value: function setReportPartProperties(newProps) {
      var updateVal = function updateVal(key, defaultValue) {
        var source = newProps[key] || defaultValue;

        if ((0, _fp.isArray)(source) || (0, _mobx.isObservableArray)(source)) {
          props[key].replace(source);
        } else if ((0, _fp.isObject)(source) || (0, _mobx.isObservable)(source)) {
          source = (0, _fp.omitBy)(_fp.isUndefined, source);
          (0, _mobx.extendObservable)(props[key], (0, _mobx.toJS)(source));
        }
      };

      newProps = newProps || {};
      var props = this.properties;

      // The chart type must be updated firstly as the subsequential properties resolves upon chart type
      newProps['chartType'] && (props['chartType'] = newProps['chartType']);

      updateVal('commonOptions', this.defaultCommonOptions);
      updateVal('optionByType', this.defaultOptionsByType);
      updateVal('commonXYAxis', {});
      updateVal('view', {});
      updateVal('printing', {});

      if (!(0, _fp.isUndefined)(newProps.colorTheme) || newProps.isDefaultTheme) {
        props.isDefaultTheme = newProps.isDefaultTheme;
        props.colorTheme = newProps.colorTheme;
      }

      this.markDirty();
    }

    /**
     * build data for save
     * @returns {Object}
     */

  }, {
    key: 'buildDataForSave',
    value: function buildDataForSave() {
      var chartContent = (0, _fp.omit)(['properties', 'staticProperties', 'expandedLevel', 'drilldownInfo'], this);

      // merge static properties
      chartContent.properties = this.getReportPartProperties();
      chartContent.selectedMetric = (0, _fp.get)('activeSerie.fieldName', this);

      return chartContent;
    }

    /**
     * Remove dynamic threshold for field which were set invisible
     */

  }, {
    key: 'removeInvisibleDynamicThreshold',
    value: function removeInvisibleDynamicThreshold() {
      var elements = (0, _fp.flatMap)(function (container) {
        return container.elements.slice();
      }, this.containerCollection);
      var thresholdElements = (0, _fp.get)('elements', (0, _fp.find)({ name: ContainerName.DYNAMIC_THRESHOLD }, this.customContainers));
      var commonXYAxis = (0, _fp.get)('properties.commonXYAxis', this);
      if (thresholdElements) {
        if (commonXYAxis && !(0, _fp.isEmpty)(commonXYAxis.allDynamicThresholdLine)) {
          commonXYAxis.allDynamicThresholdLine = (0, _fp.remove)(function (setting) {
            return !(0, _fp.find)(function (ele) {
              return ele.fieldNameAlias === setting.fieldName;
            }, thresholdElements);
          }, commonXYAxis.allDynamicThresholdLine);
        }

        if (!(0, _fp.isEmpty)(elements)) {
          elements.forEach(function (ele) {
            var otherProps = ele.properties.getOtherProps();
            if (!(0, _fp.isEmpty)(otherProps.dynamicThresholds)) {
              otherProps.dynamicThresholds = (0, _fp.remove)(function (setting) {
                return !(0, _fp.find)(function (ele) {
                  return ele.fieldNameAlias === setting.fieldName;
                }, thresholdElements);
              }, otherProps.dynamicThresholds);

              // Remove completely if no setting remains
              if ((0, _fp.isEmpty)(otherProps.dynamicThresholds)) {
                resetDefaultSetting([ele], 'dynamicThresholds');
              }
            }
          });
        }
      }
    }

    /**
     * Remove all unuse threshold
     */

  }, {
    key: 'removeUnuseDynamicThresholds',
    value: function removeUnuseDynamicThresholds() {
      this.removeInvisibleDynamicThreshold();

      // Support all type of threshold
      if (this.isChartType(this.chartType, CHART_TYPE.Line, CHART_TYPE.Column, CHART_TYPE.Bar, CHART_TYPE.Area)) {
        return;
      }

      // Do not support threshold
      var removeAllSetting = this.isChartType(this.chartType, CHART_TYPE.Pie, CHART_TYPE.Donut, CHART_TYPE.Funnel, CHART_TYPE.TreeMap, CHART_TYPE.HeatMap, CHART_TYPE.Sparkline);

      // Do not support dynamic threshold
      var removeDynamic = this.isChartType(this.chartType, CHART_TYPE.Bubble, CHART_TYPE.Scatter);

      // Do not support all metric
      var removeAllMetric = this.isChartType(this.chartType, CHART_TYPE.Combination, CHART_TYPE.Waterfall, CHART_TYPE.Bubble, CHART_TYPE.Scatter);
      this.resetThresholdDefaultValue(removeAllSetting, removeDynamic, removeAllMetric);
    }

    /**
     * Get dirty status.
     * @returns {boolean}
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      var dirtyElements = _Izenda18.default.dirtyReportPartElementField(this.containerCollection);
      var checkDirty = (0, _fp.get)('checkDirty', this.properties);

      return this.isDirty || !(0, _fp.isEmpty)(dirtyElements) || (0, _fp.isFunction)(checkDirty) && checkDirty();
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();
    }

    /**
     * Set Chart type
     * @param {string} nextType
     * @returns {boolean}
     */

  }, {
    key: 'setChartType',
    value: function setChartType(nextType) {
      var previousType = this.properties.chartType;
      this.properties.chartType = nextType;
      this.isLinear() && this.resetSortAscending(this.currentDrilldownField);

      this.markDirty();

      return this.convertChartType(previousType, nextType);
    }

    /**
     * Set value for Multi Color option
     * @param {boolean} nextValue
     */

  }, {
    key: 'setMultiColor',
    value: function setMultiColor(nextValue) {
      var optionByType = (0, _fp.get)('properties.optionByType', this);
      if ((0, _fp.has)('izMultiColor', optionByType)) {
        optionByType.izMultiColor = nextValue;
      }
    }

    /**
     * Convert chart type
     * @param {string} previousType
     * @param {string} nextType
     * @return {boolean} TRUE need to update preview data, otherwise FALSE
     */

  }, {
    key: 'convertChartType',
    value: function convertChartType(previousType, nextType) {
      var _this3 = this;

      var needReloadData = false;

      switch (true) {
        case this.isChartType(previousType, CHART_TYPE.Line, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.Donut, CHART_TYPE.TreeMap):
          this.convertChartInGeneralCase(nextType);
          this.updateContainerElementsPosition(this.labels, this.values, this.bubbleSize, this.valuesLabels, this.separators);
          break;

        case this.isChartType(previousType, CHART_TYPE.Column, CHART_TYPE.Bar, CHART_TYPE.Area):
          this.convertChartInGeneralCase(nextType);
          this.updateContainerElementsPosition(this.labels, this.values, this.bubbleSize, this.valuesLabels, this.separators);
          if (!(0, _fp.isNil)(this.properties.optionByType.izRange)) {
            needReloadData = true;
            this.properties.optionByType.izRange = '';
          }
          break;

        case this.isChartType(previousType, CHART_TYPE.Combination):
          this.initCombinationChartData(true);
          this.convertFromCombinationChart(nextType);
          break;
        case this.isChartType(previousType, CHART_TYPE.HeatMap):
          this.convertFromHeatMapChart(nextType);
          break;
        case this.isChartType(previousType, CHART_TYPE.Bubble):
          this.convertFromBubbleChart(nextType);

          break;
        case this.isChartType(previousType, CHART_TYPE.Scatter):
          this.convertFromScatterChart(nextType);
          break;
        case this.isChartType(previousType, CHART_TYPE.Waterfall):
          this.convertFromWaterFallChart(nextType);
          break;
        case this.isChartType(previousType, CHART_TYPE.Sparkline):
          this.initSparklineChartData(true);
          this.convertFromSparkLineChart(nextType);
          break;
      }

      switch (true) {
        case this.isChartType(nextType, CHART_TYPE.Combination):
          this.initCombinationChartData();
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Sparkline):
          this.initSparklineChartData();
          break;
        case this.isChartType(nextType, CHART_TYPE.TreeMap):
          this.updateContainerElementsPosition(this.values);
          break;
        case this.isChartType(nextType, CHART_TYPE.Waterfall):
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Scatter):
          this.resetContainer(this.separators);
          break;
      }

      if (this.separators.elements.length) {
        this.properties.optionByType = this.properties.optionByType || {};
        this.properties.optionByType.izUseSeparator = true;
      }

      this.resetMetric();
      this.markDirty();
      this.updateMultiColorPropValue();
      // whether to update data if chart-type is changed
      if (this.isChartType.apply(this, [previousType].concat(NEED_UPDATE_DATA_CHART_TYPE)) || this.isChartType.apply(this, [nextType].concat(NEED_UPDATE_DATA_CHART_TYPE))) {
        this.resetDrilldownInfo();
        needReloadData = true;
      }

      // check function of each element >> reset to default in case invalid
      var promiseArray = (0, _fp.flow)((0, _fp.flatMap)(function (container) {
        return (0, _fp.map)(function (element) {
          var needUpdateFunction = !_this3.checkedCompatibleFunction(container, element, (0, _fp.getOr)({}, 'properties.dataFormattings.functionInfo', element));

          // update function if the current function not compatible
          if (needUpdateFunction) {
            return _Izenda20.default.setDefaultFunctionElement(_this3, container, element).then(function () {
              return needReloadData;
            });
          }

          return needReloadData;
        }, container.elements);
      }), _fp.compact)(this.containerCollection);

      return (0, _bluebird.all)(promiseArray);
      // .then(
      //   action(updateFuntionInfos =>
      //     updateFuntionInfos.map(
      //       ({ container, element, needUpdateFunction }) =>
      //         needUpdateFunction && ReportPartUtils.setDefaultFunctionElement(this, container, element)
      //     )
      //   )
      // )
      // .then(() => needReloadData);
    }

    /**
     * Convert report combination chart
     * @param {string} nextType
     */

  }, {
    key: 'convertChartInGeneralCase',
    value: function convertChartInGeneralCase(nextType) {
      switch (true) {
        case this.isChartType(nextType, CHART_TYPE.Combination):
          this.values.elements = this.removeUndefined(this.values.elements.slice(NUMBER_ZERO, NUMBER_FINE));
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.HeatMap):
          this.labels.elements = this.removeUndefined([(0, _fp.head)(this.labels.elements)]);
          var valuesElements = this.values.elements;
          this.values.elements = this.removeUndefined([(0, _fp.head)(valuesElements)]);
          this.valuesLabels.elements = this.removeUndefined([(0, _fp.nth)(NUMBER_ONE, valuesElements)]);
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Bubble):
          this.convertFromLineToBubble();
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Scatter):
          this.convertFromLineToScatter();
          break;
        case this.isChartType(nextType, CHART_TYPE.Waterfall):
          this.keepFirstElementInValueAndLabels();
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Sparkline):
          this.labels.elements = this.removeUndefined([(0, _fp.head)(this.labels.elements)]);
          this.values.elements = this.removeUndefined(this.values.elements.slice(NUMBER_ZERO, NUMBER_FINE));
          break;
      }
    }

    /**
     * Convert report combination chart
     * @param {string} nextType
     */

  }, {
    key: 'convertFromCombinationChart',
    value: function convertFromCombinationChart(nextType) {
      switch (true) {
        case this.isChartType(nextType, CHART_TYPE.HeatMap):
          this.labels.elements = this.removeUndefined([(0, _fp.head)(this.labels.elements)]);
          var valuesElement = this.values.elements;
          this.values.elements = this.removeUndefined([(0, _fp.head)(valuesElement)]);
          this.valuesLabels.elements = this.removeUndefined([(0, _fp.nth)(NUMBER_ONE, valuesElement)]);
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Waterfall):
          this.labels.elements = this.removeUndefined([(0, _fp.head)(this.labels.elements)]);
          this.values.elements = this.removeUndefined([(0, _fp.head)(this.values.elements)]);
          this.resetContainer(this.bubbleSize, this.valuesLabels);
          break;
        case this.isChartType(nextType, CHART_TYPE.Bubble):
          this.convertFromLineToBubble();
          break;
        case this.isChartType(nextType, CHART_TYPE.Scatter):
          this.convertFromLineToScatter();
          break;
        case this.isChartType(nextType, CHART_TYPE.Sparkline):
          this.labels.elements = this.removeUndefined([(0, _fp.head)(this.labels.elements)]);
          this.values.elements = this.removeUndefined(this.values.elements.splice(NUMBER_ZERO, NUMBER_FINE));
          this.resetContainer(this.separators, this.valuesLabels);
          break;
      }
    }

    /**
     * Convert report heat map chart
     * @param {string} nextType
     */

  }, {
    key: 'convertFromHeatMapChart',
    value: function convertFromHeatMapChart(nextType) {
      switch (true) {
        case this.isChartType(nextType, CHART_TYPE.Line, CHART_TYPE.Column, CHART_TYPE.Bar, CHART_TYPE.Area, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.Donut, CHART_TYPE.TreeMap, CHART_TYPE.Sparkline):
          this.values.elements = this.mergeContainerElements('values', 'valuesLabels');
          this.resetContainer(this.valuesLabels);
          break;
        case this.isChartType(nextType, CHART_TYPE.Combination):
          this.values.elements = this.removeUndefined([(0, _fp.head)(this.values.elements), (0, _fp.head)(this.valuesLabels.elements)]);
          this.resetContainer(this.valuesLabels);
          break;
        case this.isChartType(nextType, CHART_TYPE.Bubble, CHART_TYPE.Scatter):
          var valuesLabelsElements = this.valuesLabels.elements;
          this.valuesLabels.elements = this.labels.elements;
          this.labels.elements = valuesLabelsElements;
          break;
        case this.isChartType(nextType, CHART_TYPE.Waterfall):
          this.resetContainer(this.bubbleSize, this.valuesLabels);
          break;
      }
    }

    /**
     * Convert report bubble chart
     * @param {string} nextType
     */

  }, {
    key: 'convertFromBubbleChart',
    value: function convertFromBubbleChart(nextType) {
      switch (true) {
        case this.isChartType(nextType, CHART_TYPE.Line, CHART_TYPE.Column, CHART_TYPE.Bar, CHART_TYPE.Area, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.Donut, CHART_TYPE.TreeMap):
          this.values.elements = this.mergeContainerElements('labels', 'values', 'bubbleSize');
          this.labels.elements = this.valuesLabels.elements;
          this.resetContainer(this.valuesLabels, this.bubbleSize);
          break;
        case this.isChartType(nextType, CHART_TYPE.Combination):
          {
            var labelsElements = this.labels.elements;
            this.labels.elements = this.valuesLabels.elements;
            this.values.elements = this.removeUndefined([(0, _fp.head)(labelsElements), (0, _fp.head)(this.values.elements), (0, _fp.head)(this.bubbleSize.elements)]);
            this.resetContainer(this.valuesLabels, this.bubbleSize);
            break;
          }
        case this.isChartType(nextType, CHART_TYPE.HeatMap):
          this.convertFromBubbleToHeatMap();
          break;
        case this.isChartType(nextType, CHART_TYPE.Scatter):
          this.resetContainer(this.bubbleSize);
          break;
        case this.isChartType(nextType, CHART_TYPE.Waterfall):
          this.values.elements = this.labels.elements;
          this.labels.elements = this.removeUndefined([(0, _fp.head)(this.valuesLabels.elements)]);
          this.resetContainer(this.bubbleSize, this.valuesLabels, this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Sparkline):
          this.values.elements = this.mergeContainerElements('labels', 'values', 'bubbleSize');
          this.labels.elements = this.removeUndefined([(0, _fp.head)(this.valuesLabels.elements)]);
          this.resetContainer(this.bubbleSize, this.valuesLabels, this.separators);
          break;
      }
    }

    /**
     * Convert report part from scatter chart
     * @param {string} nextType
     */

  }, {
    key: 'convertFromScatterChart',
    value: function convertFromScatterChart(nextType) {
      switch (true) {
        case this.isChartType(nextType, CHART_TYPE.Line, CHART_TYPE.Column, CHART_TYPE.Bar, CHART_TYPE.Area, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.Donut, CHART_TYPE.TreeMap):
          this.values.elements = this.mergeContainerElements('labels', 'values');
          this.labels.elements = this.valuesLabels.elements;
          this.resetContainer(this.valuesLabels);
          break;
        case this.isChartType(nextType, CHART_TYPE.Combination):
          this.values.elements = this.removeUndefined([(0, _fp.head)(this.labels.elements), (0, _fp.head)(this.values.elements)]);
          this.labels.elements = this.valuesLabels.elements;
          this.resetContainer(this.valuesLabels);
          break;
        case this.isChartType(nextType, CHART_TYPE.Bubble):
          this.resetContainer(this.bubbleSize);
          break;
        case this.isChartType(nextType, CHART_TYPE.Waterfall):
          this.values.elements = this.labels.elements;
          this.labels.elements = this.removeUndefined([(0, _fp.head)(this.valuesLabels.elements)]);
          this.resetContainer(this.bubbleSize, this.valuesLabels);
          break;
        case this.isChartType(nextType, CHART_TYPE.Sparkline):
          this.values.elements = this.mergeContainerElements('labels', 'values');
          this.labels.elements = this.removeUndefined([(0, _fp.head)(this.valuesLabels.elements)]);
          this.resetContainer(this.bubbleSize, this.valuesLabels, this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.HeatMap):
          var valuesLabels = this.valuesLabels.elements;
          this.valuesLabels.elements = this.labels.elements;
          this.labels.elements = this.removeUndefined([(0, _fp.head)(valuesLabels)]);
          this.resetContainer(this.separators);
          break;
      }
    }

    /**
     * Convert report part from water fall chart
     * @param {string} nextType
     */

  }, {
    key: 'convertFromWaterFallChart',
    value: function convertFromWaterFallChart(nextType) {
      switch (true) {
        case this.isChartType(nextType, CHART_TYPE.Combination):
          this.values.elements = this.removeUndefined([(0, _fp.head)(this.values.elements)]);
          break;
        case this.isChartType(nextType, CHART_TYPE.Bubble, CHART_TYPE.Scatter):
          this.valuesLabels.elements = this.labels.elements;
          this.labels.elements = this.values.elements;
          this.resetContainer(this.values);
          break;
        case this.isChartType(nextType, CHART_TYPE.Sparkline):
          this.resetContainer(this.bubbleSize, this.valuesLabels, this.separators);
          break;
      }
    }

    /**
     * Convert report part from spark line chart
     * @param {string} nextType
     */

  }, {
    key: 'convertFromSparkLineChart',
    value: function convertFromSparkLineChart(nextType) {
      var valuesElements = this.values.elements;
      switch (true) {
        case this.isChartType(nextType, CHART_TYPE.Combination):
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.HeatMap):
          this.values.elements = this.removeUndefined([(0, _fp.head)(valuesElements)]);
          this.valuesLabels.elements = this.removeUndefined([(0, _fp.nth)(NUMBER_ONE, valuesElements)]);
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Bubble):
          this.valuesLabels.elements = this.labels.elements;
          this.labels.elements = this.removeUndefined([(0, _fp.head)(valuesElements)]);
          this.values.elements = this.removeUndefined([(0, _fp.nth)(NUMBER_ONE, valuesElements)]);
          this.bubbleSize.elements = this.removeUndefined([(0, _fp.nth)(NUMBER_THREE, valuesElements)]);
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Scatter):
          this.valuesLabels.elements = this.labels.elements;
          this.labels.elements = this.removeUndefined([(0, _fp.head)(valuesElements)]);
          this.values.elements = this.removeUndefined([(0, _fp.nth)(NUMBER_ONE, valuesElements)]);
          this.resetContainer(this.separators);
          break;
        case this.isChartType(nextType, CHART_TYPE.Waterfall):
          this.values.elements = this.removeUndefined([(0, _fp.head)(this.values.elements)]);
          this.resetContainer(this.separators);
          break;
      }
    }

    /**
     * Keep first element in value and labels
     */

  }, {
    key: 'keepFirstElementInValueAndLabels',
    value: function keepFirstElementInValueAndLabels() {
      this.labels.elements = this.removeUndefined([(0, _fp.head)(this.labels.elements)]);
      this.values.elements = this.removeUndefined([(0, _fp.head)(this.values.elements)]);
    }

    /**
     * Convert report part from line chart to bubble chart
     */

  }, {
    key: 'convertFromLineToBubble',
    value: function convertFromLineToBubble() {
      this.valuesLabels.elements = this.labels.elements;
      var valuesElements = this.values.elements;
      this.labels.elements = this.removeUndefined([(0, _fp.head)(valuesElements)]);
      this.values.elements = this.removeUndefined([(0, _fp.nth)(NUMBER_ONE, valuesElements)]);
      this.bubbleSize.elements = this.removeUndefined([(0, _fp.nth)(NUMBER_TWO, valuesElements)]);
      this.separators.elements = [];
    }

    /**
     * Convert report part from line chart to scatter chart
     */

  }, {
    key: 'convertFromLineToScatter',
    value: function convertFromLineToScatter() {
      this.valuesLabels.elements = this.labels.elements;
      var valuesElements = this.values.elements;
      this.labels.elements = this.removeUndefined([(0, _fp.head)(valuesElements)]);
      this.values.elements = this.removeUndefined([(0, _fp.nth)(NUMBER_ONE, valuesElements)]);
    }

    /**
     * Convert report part from bubble chart to heat map chart
     */

  }, {
    key: 'convertFromBubbleToHeatMap',
    value: function convertFromBubbleToHeatMap() {
      var labelsElements = this.labels.elements;
      this.labels.elements = this.removeUndefined([(0, _fp.head)(this.valuesLabels.elements)]);
      this.valuesLabels.elements = labelsElements;
      this.resetContainer(this.bubbleSize);
    }

    /**
     * Init combination chart data
     * set other props for values element
     * @param {boolean} isResetData
     */

  }, {
    key: 'initCombinationChartData',
    value: function initCombinationChartData(isResetData) {
      var _this4 = this;

      this.values.elements.forEach(function (element) {
        _this4.initCombinationElementData(element, isResetData);
      });
    }

    /**
     * Init Sparkline chart data
     * set other props for values element
     * @param {boolean} isResetData
     */

  }, {
    key: 'initSparklineChartData',
    value: function initSparklineChartData(isResetData) {
      var _this5 = this;

      this.values.elements.forEach(function (element) {
        _this5.initSparklineElementData(element, isResetData);
      });
    }

    /**
     * Merge container elements
     * @returns {Array<any>}
     */

  }, {
    key: 'mergeContainerElements',
    value: function mergeContainerElements() {
      var re = [];
      var i = void 0,
          container = void 0;

      for (i = NUMBER_ZERO; i < arguments.length; i++) {
        container = this[arguments[i]];

        if (container && !(0, _fp.isEmpty)(container.elements)) {
          // merge to result-array
          container.elements.forEach(function (elm) {
            elm.position = re.length + NUMBER_ONE;
            re.push(elm);
          });

          // reset container
          container.elements = [];
        }
      }

      return re;
    }

    /**
     * Update element position
     * This is used for merging elements of many container into one
     */

  }, {
    key: 'updateContainerElementsPosition',
    value: function updateContainerElementsPosition() {
      var args = arguments;
      for (var i = 0; i < args.length; i++) {
        args[i].elements.map(function (ele, index) {
          ele.position = index + NUMBER_ONE;
        });
      }
    }

    /**
     * Remove undefined
     * @param {Array<any>} array
     * @returns {Object}
     */

  }, {
    key: 'removeUndefined',
    value: function removeUndefined(array) {
      return (0, _fp.remove)(_fp.isUndefined, array);
    }

    /**
     * Reset container elements
     */

  }, {
    key: 'resetContainer',
    value: function resetContainer() {
      var args = arguments;
      for (var i = 0; i < args.length; i++) {
        args[i].elements = [];
      }
    }

    /**
     * Reset separator elements
     * @param {boolean} showSeparator
     */

  }, {
    key: 'resetSeparator',
    value: function resetSeparator(showSeparator) {
      !showSeparator && this.separators.elements.clear();
    }

    /**
     * Get the first values elements as default metrics options
     * @returns {Object}
     */

  }, {
    key: 'getActiveSerieKey',
    value: function getActiveSerieKey() {
      var defaultValue = (0, _fp.get)('fieldName', (0, _fp.first)(this.getMetricElements()));
      return (0, _fp.isNil)(this.activeSerie) ? defaultValue : this.activeSerie.name;
    }

    /**
     * Get metric elements
     */

  }, {
    key: 'getMetricElements',
    value: function getMetricElements() {
      return (0, _fp.get)(this.getMetricContainer() + '.visibleElement', this);
    }

    /**
     * Get active elements by active series
     * @param {string} activeSerieKey
     * @return {Object}
     */

  }, {
    key: 'getMetricContainer',


    /**
     * Get container which will be shown in metric list
     * @returns {string}
     */
    value: function getMetricContainer() {
      return this.isChartType(this.chartType, CHART_TYPE.HeatMap, CHART_TYPE.Bubble, CHART_TYPE.Scatter) ? 'valuesLabels' : 'values';
    }

    /**
     * Get container which will be used for drilldown
     * @returns {string}
     */

  }, {
    key: 'getDrildownContainer',
    value: function getDrildownContainer() {
      // always use labels to drilldown for all chart-type
      return 'labels';
    }

    /**
     * Reset metric after changed chart type;
     */

  }, {
    key: 'resetMetric',
    value: function resetMetric() {
      var metric = this.getMetricContainer();
      this.setActiveSerie(null, (0, _fp.first)(this[metric].elements));
    }

    /**
     * Set active serie key, used to show/hide serie chart in metric dropdown
     * @param {Object} activeSerieKey
     * @param {Object} activeSerieInfo
     */

  }, {
    key: 'setActiveSerie',
    value: function setActiveSerie(activeSerieKey, activeSerieInfo) {
      this.activeSerie = activeSerieInfo;
      this.markDirty();
    }

    /**
     * Reset drilldown info whenever reorder field
     */

  }, {
    key: 'changePositionField',
    value: function changePositionField() {
      this.resetDrilldownInfo();
    }

    /**
     * Update drilldown inform
     * @param {Object} drilldownValue
     * @param {Object} separatorValue
     * @returns {boolean}
     */

  }, {
    key: 'updateDrilldownInfo',
    value: function updateDrilldownInfo(drilldownValue, separatorValue) {
      if (!this.hasDrillDown) {
        return false;
      }

      var filters = (0, _fp.get)('filters', this.drilldownInfo);
      var canDrilldown = false;

      // move to top level
      if (!drilldownValue && (0, _fp.size)(filters)) {
        this.resetDrilldownInfo();
        canDrilldown = true;
        return canDrilldown;
      }

      var drilldownField = (0, _fp.get)('field', drilldownValue);
      var nextDrilldownKey = (0, _fp.get)('fieldNameAlias', drilldownField) || drilldownValue.key;
      var drillUpLevel = (0, _fp.findIndex)({ key: nextDrilldownKey }, filters);
      var field = (0, _fp.get)('field', drilldownValue);

      if (drillUpLevel > NUMBER_CHECK_INDEX) {
        // drill up
        filters.splice(drillUpLevel + NUMBER_ONE, filters.length - drillUpLevel - NUMBER_ONE);
        canDrilldown = true;
      } else if (filters.length < this[this.getDrildownContainer()].numElement - NUMBER_ONE) {
        // drill down
        canDrilldown = true;

        filters.push({
          key: nextDrilldownKey,
          value: _Izenda20.default.getOriginalValue(field, drilldownValue.record),
          field: drilldownField,
          record: (0, _fp.get)('record', drilldownValue)
        });

        separatorValue && separatorValue.field && (this.drilldownInfo.separatorValue = {
          key: (0, _fp.get)('field.fieldNameAlias', separatorValue),
          value: (0, _fp.get)('value', separatorValue),
          field: (0, _fp.get)('field', separatorValue)
        });
      }

      return canDrilldown;
    }

    /**
     * Reset drilldown info
     */

  }, {
    key: 'getDrilldownInfo',


    /**
     * Return drilldown info: expandedLevel & filters
     * @return {Object}
     */
    value: function getDrilldownInfo() {
      var filters = this.drilldownInfo.filters.map(function (filterItem) {
        return {
          key: (0, _fp.get)('key', filterItem),
          value: (0, _fp.get)('value', filterItem),
          dataType: (0, _fp.get)('field.reportPartElm.fieldDataType', filterItem)
        };
      });

      var separatorInfo = {
        key: (0, _fp.get)('key', this.drilldownInfo.separatorValue),
        value: (0, _fp.get)('value', this.drilldownInfo.separatorValue),
        isSeparator: true
      };

      filters = this.expandedLevel < NUMBER_ZERO ? [] : this.drilldownInfo.separatorValue ? filters.unshift(separatorInfo) && filters : filters;

      return {
        expandedLevel: this.expandedLevel,
        filters: filters
      };
    }

    /**
     * Return Cross Filtering info.
     * @returns {Array<any>}
     */

  }, {
    key: 'getCrossFilteringInfo',
    value: function getCrossFilteringInfo() {
      return this.drilldownInfo.filters.map(function (filterItem) {
        return {
          key: (0, _fp.get)('key', filterItem),
          value: (0, _fp.get)('value', filterItem),
          field: (0, _fp.get)('field', filterItem)
        };
      });
    }

    /**
     * Get xaxis-title options for xyplane and threshold
     * This options are retrieved base on field in label container dataType
     * @param {boolean} dataTypeCheck
     * @returns {Array<any>}
     */

  }, {
    key: 'getXAxisTitleOption',
    value: function getXAxisTitleOption(dataTypeCheck) {
      var list = dataTypeCheck ? this.listLinearFieldInLabelContainer : this.labelsElements;
      var options = list.map(function (ele) {
        return {
          value: ele.fieldName,
          label: ele.fieldName,
          dateTimeFormatData: ele.dateTimeFormatData
        };
      });
      return options || [];
    }

    /**
     * Get yaxis-title options for xyplane and threshold
     * This options are retrieved base on field in label container dataType
     * @param {boolean} dataTypeCheck
     * @returns {Array<any>}
     */

  }, {
    key: 'getYAxisTitleOption',
    value: function getYAxisTitleOption(dataTypeCheck, useForThreshold) {
      var list = dataTypeCheck ? this.listCountableFieldInValueContainer : this.valuesElements;
      var options = [];
      if ((list.length > NUMBER_ONE || useForThreshold) && !this.isChartType(this.chartType, CHART_TYPE.Combination, CHART_TYPE.Sparkline, CHART_TYPE.Bubble, CHART_TYPE.Waterfall, CHART_TYPE.Scatter)) {
        options.push({ value: '', label: METRIC_ALL });
      }
      var eleOptions = list.map(function (ele) {
        return {
          value: ele.fieldName,
          label: ele.fieldName,
          dateTimeFormatData: ele.dateTimeFormatData
        };
      });
      return options.concat(eleOptions);
    }

    /**
     * This properties is used to save the page size
     * Only use for chart-type which supported pagination: pie, donut, treemap, funnel
     * @param {Object} pageSize
     */

  }, {
    key: 'setPageSize',
    value: function setPageSize(pageSize) {
      this.staticProperties.pageSize = pageSize;
    }

    /**
     * Check need to break page when printing.
     * @returns {boolean}
     */

  }, {
    key: 'checkBreakPage',
    value: function checkBreakPage() {
      return this.properties.printing.izPageBreakAfterSeparator && this.separators.elements && this.separators.elements.length > NUMBER_ZERO;
    }

    /**
     * Action whenever element's props are changed.
     * @param {Object} element
     * @param {Object} elementProps
     * @param {string} changedKey
     */

  }, {
    key: 'changePropertiesByField',
    value: function changePropertiesByField(element, elementProps, changedKey) {
      if (changedKey === 'function' || changedKey === 'format') {
        this.resetDrilldownInfo();
      }
    }

    /**
     * Check if this field can have state Unsort
     * @param {Object} container
     * @returns {boolean}
     */

  }, {
    key: 'checkCanUnsort',
    value: function checkCanUnsort(container) {
      var containerName = (0, _fp.getOr)('', 'name', container);
      var canUnsort = false;

      switch (true) {
        case this.isChartType(this.chartType, CHART_TYPE.Line, CHART_TYPE.Column, CHART_TYPE.Bar, CHART_TYPE.Area, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.Donut, CHART_TYPE.Sparkline):
          canUnsort = containerName !== ContainerName.SEPARATORS;
          break;
        case this.isChartType(this.chartType, CHART_TYPE.Combination, CHART_TYPE.Waterfall):
          canUnsort = true;
          break;
        case this.isChartType(this.chartType, CHART_TYPE.HeatMap, CHART_TYPE.Scatter):
          canUnsort = containerName !== ContainerName.VALUES_LABELS;
          break;
        case this.isChartType(this.chartType, CHART_TYPE.Bubble):
          canUnsort = containerName !== ContainerName.VALUES_LABELS && containerName !== ContainerName.BUBBLE_SIZE;
          break;
      }

      var canUnsortForLinear = true;
      if (containerName === ContainerName.LABELS) {
        canUnsortForLinear = !_Izenda20.default.isLinear(this.selectedField, this.defaultOptionsByType);
      } else if (containerName === ContainerName.VALUES) {
        canUnsortForLinear = !this.isLinear();
      }

      return this.isBeingBuild ? canUnsort && canUnsortForLinear : canUnsort;
    }

    /**
     * Check if this field hidden
     * @param {Object} field
     * @param {Object} container
     * @returns {boolean}
     */

  }, {
    key: 'checkHiddenSortField',
    value: function checkHiddenSortField(field, container) {
      var containerName = (0, _fp.getOr)('', 'name', container);

      switch (true) {
        case this.isChartType(this.chartType, CHART_TYPE.Scatter, CHART_TYPE.HeatMap):
          return containerName === ContainerName.VALUES_LABELS;
        case this.isChartType(this.chartType, CHART_TYPE.TreeMap):
          return containerName !== ContainerName.SEPARATORS;
        case this.isChartType(this.chartType, CHART_TYPE.Bubble):
          return containerName === ContainerName.VALUES_LABELS || containerName === ContainerName.BUBBLE_SIZE;
      }

      return false;
    }

    /**
     * Reset grid line setting to default value
     */

  }, {
    key: 'resetGridLineDefaultValue',
    value: function resetGridLineDefaultValue() {
      this.properties.commonXYAxis.izGridLine = {};
      this.markDirty();
    }

    /**
     * Reset border setting to default value
     */

  }, {
    key: 'resetBorderDefaultValue',
    value: function resetBorderDefaultValue() {
      this.properties.commonOptions['izEntire.borderColor'] = _Izenda14.default.DEFAULT_SETTING_VALUE.borderDefault['izEntire.borderColor'];
      this.properties.commonOptions['izEntire.borderWidth'] = _Izenda14.default.DEFAULT_SETTING_VALUE.borderDefault['izEntire.borderWidth'];
      this.properties.commonOptions['izEntire.borderStyle'] = _Izenda14.default.DEFAULT_SETTING_VALUE.borderDefault['izEntire.borderStyle'];
      this.markDirty();
    }

    /**
     * Reset background color setting to default value
     */

  }, {
    key: 'resetBackgroundColorDefaultValue',
    value: function resetBackgroundColorDefaultValue() {
      this.properties.commonOptions['izEntire.backgroundColor'] = _Izenda14.default.DEFAULT_SETTING_VALUE.backGroundColorDefault['izEntire.backgroundColor'];
      this.properties.commonOptions['izPlot.backgroundColor'] = _Izenda14.default.DEFAULT_SETTING_VALUE.backGroundColorDefault['izPlot.backgroundColor'];
      this.markDirty();
    }

    /**
     * Reset XYPlane default setting to default value
     */

  }, {
    key: 'resetXYPlaneDefaultValue',
    value: function resetXYPlaneDefaultValue() {
      resetDefaultSetting(this.labelsElements, 'axis');
      resetDefaultSetting(this.valuesElements, 'axis');
      this.markDirty();
    }

    /**
     * Reset threshold setting to default value
     */

  }, {
    key: 'resetThresholdDefaultValue',
    value: function resetThresholdDefaultValue() {
      var removeAllSetting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var removeDynamic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var removeAllMetric = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (removeAllSetting) {
        resetDefaultSetting(this.labelsElements, 'threshold');
        resetDefaultSetting(this.valuesElements, 'threshold');
        resetDefaultSetting(this.valuesLabels.elements, 'threshold');
        resetDefaultSetting(this.bubbleSize.elements, 'threshold');
      }

      if (removeAllSetting || removeDynamic) {
        resetDefaultSetting(this.labelsElements, 'dynamicThresholds');
        resetDefaultSetting(this.valuesElements, 'dynamicThresholds');
        resetDefaultSetting(this.valuesLabels.elements, 'dynamicThresholds');
        resetDefaultSetting(this.bubbleSize.elements, 'dynamicThresholds');
        var dynamicThresholdsContainer = (0, _fp.find)({ name: ContainerName.DYNAMIC_THRESHOLD }, this.customContainers);
        dynamicThresholdsContainer.elements.clear();
      }

      var commonXYAxis = (0, _fp.get)('properties.commonXYAxis', this);
      if (commonXYAxis && (removeAllSetting || removeAllMetric)) {
        commonXYAxis.allDynamicThresholdLine = [];
        commonXYAxis.metricAllPlotLinesOption = [];
      }

      this.markDirty();
    }

    /**
     * Reset regression line setting to default value
     */

  }, {
    key: 'resetRegressionLineDefaultValue',
    value: function resetRegressionLineDefaultValue() {
      resetDefaultSetting(this.serieChartList, 'regression');

      this.markDirty();
    }

    /**
     * Reset refresh interval setting to default vale
     */

  }, {
    key: 'resetRefreshIntervalValue',
    value: function resetRefreshIntervalValue() {
      this.properties.view.dataRefreshInterval = _Izenda14.default.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
      this.markDirty();
    }

    /**
     * Reset legend setting to default
     */

  }, {
    key: 'resetLegendDefaultValue',
    value: function resetLegendDefaultValue() {
      this.properties.commonOptions['izLegend.visibility'] = false;
      this.markDirty();
    }

    /**
     * Check if ReportPart is drilling down or not
     * @returns {boolean}
     */

  }, {
    key: 'isDrillingDown',
    value: function isDrillingDown() {
      return !(0, _fp.flow)((0, _fp.get)('drilldownInfo.filters'), _fp.isEmpty)(this);
    }

    /**
     * Check if xAxis is linear type
     * @returns {boolean}
     */

  }, {
    key: 'isLinear',
    value: function isLinear() {
      return this.isBeingBuild ? _Izenda20.default.isLinear(this.currentDrilldownField, this.defaultOptionsByType) : false;
    }

    /**
     * Set configField
     * @param {Object} configField
     */

  }, {
    key: 'setConfigField',
    value: function setConfigField(configField) {
      this.isBeingBuild && _Izenda20.default.isLinear(configField, this.defaultOptionsByType) && (0, _fp.includes)(configField, this.labelsElements) && this.resetSortAscending(configField);

      this.selectedField = configField;
    }

    /**
     * Reset sort value to 'ASC' of drilldown field
     * @param {Object} configField
     * @return {boolean}
     */

  }, {
    key: 'resetSortAscending',
    value: function resetSortAscending(configField) {
      var ASC = SORT_ORDERS.ASC,
          DESC = SORT_ORDERS.DESC;

      var sort = (0, _fp.get)('properties.dataFormattings.sort', configField);
      if (!(0, _fp.includes)(sort, [ASC.value, DESC.value])) {
        configField.properties.setSortValue(ASC.value);
        return true;
      }
      return false;
    }

    /**
     * Set default tick interval for Datetime datatype
     */

  }, {
    key: 'setDefaultIntervalForDatetime',
    value: function setDefaultIntervalForDatetime() {
      var izTickInterval = (0, _fp.get)('properties.otherProps.axis.izTickInterval', this.currentDrilldownField);
      this.currentDrilldownField && this.currentDrilldownField.previewDataTypeByFunction === _Izenda3.DATA_TYPES.DATE_TIME && (0, _fp.isNil)(izTickInterval) && this.currentDrilldownField.properties.setOtherProps('axis', { izTickInterval: 1 });
    }

    /**
     * Update list dynamic threshold in field container.
     * @param {Array} elements
     */

  }, {
    key: 'updateDynamicThresholdFieldInContainer',
    value: function updateDynamicThresholdFieldInContainer(elements) {
      var dynamicThresholdsContainer = (0, _fp.find)({ name: ContainerName.DYNAMIC_THRESHOLD }, this.customContainers);
      dynamicThresholdsContainer.elements = (0, _fp.filter)(function (item) {
        return !(0, _fp.isNil)(item);
      }, elements);
    }
  }, {
    key: 'chartType',
    get: function get() {
      return this.properties.chartType;
    }
  }, {
    key: 'expandedLevel',
    get: function get() {
      return this.isChartType(this.chartType, CHART_TYPE.Donut) || this.treeMapWithMultiLevel ? _Izenda3.EXPANDED_LEVEL.ALL : this.drilldownInfo.filters.length;
    }
  }, {
    key: 'treeMapWithMultiLevel',
    get: function get() {
      var izMultiLevel = (0, _fp.get)('properties.optionByType.izMultiLevel', this);
      return this.isChartType(this.chartType, CHART_TYPE.TreeMap) && izMultiLevel;
    }
  }, {
    key: 'defaultExpandedLevel',
    get: function get() {
      return this.isChartType(this.chartType, CHART_TYPE.Donut) ? _Izenda3.EXPANDED_LEVEL.ALL : _Izenda3.EXPANDED_LEVEL[this.hasDrillDown ? 'FIRST_LEVEL' : 'ALL'];
    }
  }, {
    key: 'drilldown',
    get: function get() {
      return this.getDrilldownInfo();
    }
  }, {
    key: 'isDisableMultiColor',
    get: function get() {
      return this.numberOfMetric > NUMBER_ONE && !this.isChartType(this.chartType, CHART_TYPE.Donut, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.TreeMap);
    }
  }, {
    key: 'numberOfMetric',
    get: function get() {
      return (0, _fp.flow)((0, _fp.get)('serieChartList'), _fp.size)(this);
    }
  }, {
    key: 'serieChartList',
    get: function get() {
      var metricContainer = this.getMetricContainer();
      metricContainer = this[metricContainer] && this[metricContainer].visibleElement;

      return !metricContainer ? [] : metricContainer.map(function (elm) {
        return elm;
      });
    }
  }, {
    key: 'activeElmsByContainers',
    get: function get() {
      return this.getActiveElmsByActiveSeries((0, _fp.get)('fieldName', this.activeSerie));
    }
  }, {
    key: 'allFieldCollection',
    get: function get() {
      return (0, _fp.flow)((0, _fp.flatMap)(function (i) {
        return i.elements ? i.elements.slice() : [];
      }), (0, _fp.filter)(function (i) {
        return !!i;
      }))(this.containerCollection);
    }
  }, {
    key: 'containerCollection',
    get: function get() {
      var collection = [this.labels, this.values, this.valuesLabels, this.separators, this.bubbleSize];

      this.customContainers.forEach(function (customContainer) {
        collection.push(customContainer);
      });
      return collection;
    }
  }, {
    key: 'hasDrillDown',
    get: function get() {
      return !!(this.labels && this.labels.visibleElement && this.labels.visibleElement.length > NUMBER_ONE) && !this.isChartType(this.chartType, CHART_TYPE.Donut);
    }
  }, {
    key: 'labelsElements',
    get: function get() {
      return this.labels.visibleElement;
    }
  }, {
    key: 'valuesElements',
    get: function get() {
      return this.values.visibleElement;
    }
  }, {
    key: 'separatorsElements',
    get: function get() {
      return this.separators.visibleElement;
    }
  }, {
    key: 'valuesLabelsElements',
    get: function get() {
      return this.valuesLabels.visibleElement;
    }
  }, {
    key: 'bubbleSizeElements',
    get: function get() {
      return this.bubbleSize.visibleElement;
    }
  }, {
    key: 'isBeingBuild',
    get: function get() {
      if (this.inconsitentFunction) {
        return false;
      }
      switch (true) {
        case this.isChartType(this.chartType, CHART_TYPE.Line, CHART_TYPE.Column, CHART_TYPE.Bar, CHART_TYPE.Area, CHART_TYPE.Pie, CHART_TYPE.Funnel, CHART_TYPE.Donut, CHART_TYPE.Combination, CHART_TYPE.TreeMap, CHART_TYPE.Waterfall):
          return hasElement(this.labels, this.values);
        case this.isChartType(this.chartType, CHART_TYPE.HeatMap, CHART_TYPE.Bubble, CHART_TYPE.Scatter):
          return hasElement(this.labels, this.values, this.valuesLabels);

        case this.isChartType(this.chartType, CHART_TYPE.Sparkline):
          return hasElement(this.values, this.labels);
        default:
          return false;
      }
    }
  }, {
    key: 'listCountableFieldInLabelContainer',
    get: function get() {
      return _Izenda18.default.getCountableElements(this.labelsElements);
    }
  }, {
    key: 'listLinearFieldInLabelContainer',
    get: function get() {
      return (0, _fp.remove)('properties.otherProps.axis.izCategory', this.listCountableFieldInLabelContainer);
    }
  }, {
    key: 'listCountableFieldInValueContainer',
    get: function get() {
      return _Izenda18.default.getCountableElements(this.valuesElements);
    }
  }, {
    key: 'dataRefreshInterval',
    get: function get() {
      return (0, _fp.get)('view.dataRefreshInterval', this.properties);
    }
  }, {
    key: 'optionalParams',
    get: function get() {
      return {
        expandedLevel: this.defaultExpandedLevel
      };
    }
  }, {
    key: 'isShowMetric',
    get: function get() {
      return this.isChartType(this.chartType, CHART_TYPE.HeatMap, CHART_TYPE.Waterfall) ? false : !(0, _fp.isEmpty)(this.serieChartList) && this.serieChartList.length > NUMBER_ONE;
    }
  }, {
    key: 'isShowBreadcrumb',
    get: function get() {
      var unsupportedBreadcrumbChartTypes = [CHART_TYPE.Donut, CHART_TYPE.HeatMap, CHART_TYPE.Bubble, CHART_TYPE.Scatter, CHART_TYPE.Waterfall, CHART_TYPE.Sparkline];
      return !(this.isChartType.apply(this, [this.chartType].concat(unsupportedBreadcrumbChartTypes)) || this.treeMapWithMultiLevel);
    }
  }, {
    key: 'reportPartStyle',
    get: function get() {
      return this.properties.chartType;
    }
  }, {
    key: 'currentDrilldownField',
    get: function get() {
      var index = this.expandedLevel;
      return (0, _fp.get)('labelsElements[' + index + ']', this);
    }

    /**
     * Determine whether the report part content automatically sizes its container or not
     */

  }, {
    key: 'autoSize',
    get: function get() {
      return false;
    }
  }]);
  return ReportPartChartContent;
}(_Izenda6.default), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isCrossFiltering', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'title', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'description', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'activeSerie', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'inconsitentFunction', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'properties', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      chartType: _Izenda14.default.DefaultChartType,
      colorTheme: undefined,
      isDefaultTheme: true,
      commonOptions: {
        // 'izLegend.visibility': false
        izDisableMultiColor: false
      },
      optionByType: {
        izTotalLabel: '',
        izMultiColor: false,
        izMultiLevel: false
      },
      view: {
        dataRefreshInterval: {
          enable: false,
          updateInterval: 0,
          isAll: true,
          latestRecord: 0
        }
      },
      commonXYAxis: {},
      printing: {
        izPageBreakAfterSeparator: false
      }
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'drilldownInfo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      separatorValue: null,
      filters: []
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'chartType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'chartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'expandedLevel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'expandedLevel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'treeMapWithMultiLevel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'treeMapWithMultiLevel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'defaultExpandedLevel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'defaultExpandedLevel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'drilldown', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'drilldown'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isDisableMultiColor', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isDisableMultiColor'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'numberOfMetric', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'numberOfMetric'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'serieChartList', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'serieChartList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'activeElmsByContainers', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'activeElmsByContainers'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'allFieldCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'allFieldCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'containerCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'containerCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasDrillDown', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasDrillDown'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'labelsElements', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'labelsElements'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'valuesElements', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'valuesElements'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'separatorsElements', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'separatorsElements'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'valuesLabelsElements', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'valuesLabelsElements'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'bubbleSizeElements', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bubbleSizeElements'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isBeingBuild', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isBeingBuild'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'listCountableFieldInLabelContainer', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'listCountableFieldInLabelContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'listLinearFieldInLabelContainer', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'listLinearFieldInLabelContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'listCountableFieldInValueContainer', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'listCountableFieldInValueContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'dataRefreshInterval', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'dataRefreshInterval'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'optionalParams', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'optionalParams'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isShowMetric', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isShowMetric'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isShowBreadcrumb', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isShowBreadcrumb'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reportPartStyle', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reportPartStyle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'currentDrilldownField', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'currentDrilldownField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setTotalLabel', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setTotalLabel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterInsertFieldToContainer', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterInsertFieldToContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterAddField', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterAddField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterUpdateFunction', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterUpdateFunction'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterRemoveField', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterRemoveField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readData', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setReportPartProperties', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportPartProperties'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'buildDataForSave', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'buildDataForSave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeInvisibleDynamicThreshold', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeInvisibleDynamicThreshold'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeUnuseDynamicThresholds', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeUnuseDynamicThresholds'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setChartType', [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setChartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'convertChartType', [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'convertChartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'initCombinationChartData', [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'initCombinationChartData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'initSparklineChartData', [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'initSparklineChartData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'mergeContainerElements', [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'mergeContainerElements'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateContainerElementsPosition', [_dec15], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateContainerElementsPosition'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeUndefined', [_dec16], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeUndefined'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetContainer', [_dec17], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetSeparator', [_dec18], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetSeparator'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changePositionField', [_dec19], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changePositionField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDrilldownInfo', [_dec20], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDrilldownInfo'), _class2.prototype), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'resetDrilldownInfo', [_dec21], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function () {
      _this6.drilldownInfo = {
        filters: [],
        separatorValue: null
      };
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'resetGridLineDefaultValue', [_dec22], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetGridLineDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetBorderDefaultValue', [_dec23], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetBorderDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetBackgroundColorDefaultValue', [_dec24], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetBackgroundColorDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetXYPlaneDefaultValue', [_dec25], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetXYPlaneDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetThresholdDefaultValue', [_dec26], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetThresholdDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetRegressionLineDefaultValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetRegressionLineDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetRefreshIntervalValue', [_dec27], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetRefreshIntervalValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetLegendDefaultValue', [_dec28], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetLegendDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setDefaultIntervalForDatetime', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setDefaultIntervalForDatetime'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDynamicThresholdFieldInContainer', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDynamicThresholdFieldInContainer'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ReportPartChartContent;
module.exports = exports['default'];

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveAvailableFunction;

var _Izenda = __webpack_require__(64);

var _Izenda2 = __webpack_require__(33);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(39);

// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeAvailableFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var availableSeparator = {
  SUPPORTED: {
    Datetime: [_Izenda.FUNCTION.GROUP, _Izenda.FUNCTION.GROUP_DAYS_OLD],
    DEFAULT: [_Izenda.FUNCTION.GROUP]
  }
};

var unsupportedEmpty = {
  UNSUPPORTED: {
    DEFAULT: [_Izenda.FUNCTION.NONE]
  }
};

var groupFunctions = [_Izenda.FUNCTION.GROUP, _Izenda.FUNCTION.GROUP_DAYS_OLD];
var emptyFunctions = [_Izenda.FUNCTION.NONE];

function resolveAvailableFunction(type) {
  var isHeatMapStyle = (0, _Izenda3.isChartType)(type, _Izenda2.CHART_TYPE.HeatMap);
  var isBubbleOrScatterStyle = (0, _Izenda3.isChartType)(type, _Izenda2.CHART_TYPE.Bubble, _Izenda2.CHART_TYPE.Scatter);
  var isOthersStyles = (0, _Izenda3.isChartType)(type, _Izenda2.CHART_TYPE.Column, _Izenda2.CHART_TYPE.Bar, _Izenda2.CHART_TYPE.Area, _Izenda2.CHART_TYPE.Line, _Izenda2.CHART_TYPE.Pie, _Izenda2.CHART_TYPE.Funnel, _Izenda2.CHART_TYPE.Donut, _Izenda2.CHART_TYPE.Combination, _Izenda2.CHART_TYPE.TreeMap, _Izenda2.CHART_TYPE.Waterfall, _Izenda2.CHART_TYPE.Sparkline);

  if (isHeatMapStyle) return {
    labels: unsupportedEmpty,
    values: unsupportedEmpty,
    valuesLabels: unsupportedEmpty
  };

  if (isBubbleOrScatterStyle) return {
    labels: unsupportedEmpty,
    values: unsupportedEmpty,
    valuesLabels: unsupportedEmpty,
    bubbleSize: {
      UNSUPPORTED: {
        DEFAULT: (0, _fp.concat)(emptyFunctions, groupFunctions)
      }
    }
  };

  if (isOthersStyles) return {
    labels: unsupportedEmpty,
    values: {
      UNSUPPORTED: {
        DEFAULT: (0, _fp.concat)(emptyFunctions, groupFunctions)
      }
    },
    separators: availableSeparator
  };

  return {};
}
module.exports = exports['default'];

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1115);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STACK_TYPE_CHART_VALUES = _Izenda9.MappingValues.STACK_TYPE_CHART_VALUES,
    STEP_TYPE_VALUES = _Izenda9.MappingValues.STEP_TYPE_VALUES,
    ZOOM_TYPE_VALUES = _Izenda9.MappingValues.ZOOM_TYPE_VALUES,
    LINE_STYLE_VALUES = _Izenda9.MappingValues.LINE_STYLE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.LineChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Line, null, {
  visualType: _Izenda11.default.Line,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_LINE');
  },

  visualPreviewCSS: 'chart-line',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchema)(), (0, _Izenda8.createYAxisSchema)(), _Izenda8.createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izXYplane: { defaultValue: undefined },
      izGridline: { defaultValue: undefined },
      izMultiColor: { defaultValue: false },
      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined },

      izUseSeparator: { defaultValue: true },
      izStacking: {
        propKey: 'plotOptions.series.stacking',
        propSource: STACK_TYPE_CHART_VALUES,
        defaultValue: undefined
      },

      izThresholds: { defaultValue: undefined },
      izRegressionLine: { defaultValue: undefined },

      izInverted: { propKey: 'chart.inverted', defaultValue: false },
      izStep: { propKey: 'plotOptions.series.step', propSource: STEP_TYPE_VALUES, defaultValue: undefined },
      izSpline: { propKey: 'izendaOptions.spline', defaultValue: false },

      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },

      legendSettings: { defaultValue: true },

      izLineDashStyle: { propKey: 'dashStyle', propSource: LINE_STYLE_VALUES, defaultValue: undefined },
      izLineWidth: { propKey: 'lineWidth', defaultValue: undefined }
    }
  }
});

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1116);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STACK_TYPE_CHART_VALUES = _Izenda9.MappingValues.STACK_TYPE_CHART_VALUES,
    ZOOM_TYPE_VALUES = _Izenda9.MappingValues.ZOOM_TYPE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColumnChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Column, null, {
  visualType: _Izenda11.default.Column,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_COLUMN');
  },

  visualPreviewCSS: 'chart-column',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchema)(), (0, _Izenda8.createYAxisSchema)(), _Izenda8.createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izXYplane: { defaultValue: undefined },
      izGridline: { defaultValue: undefined },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: false },
      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: {
        defaultValue: undefined
      },
      izLabelOrientationY: {
        defaultValue: undefined
      },

      izUseSeparator: { defaultValue: true },
      izStacking: {
        propKey: 'plotOptions.series.stacking',
        propSource: STACK_TYPE_CHART_VALUES,
        defaultValue: undefined
      },

      izRange: { propKey: 'izendaOptions.range', defaultValue: undefined },
      izThresholds: { defaultValue: undefined },
      izRegressionLine: { defaultValue: undefined },

      izInverted: { propKey: 'chart.inverted', defaultValue: false },

      izValueLabel: {
        propKey: 'plotOptions.series.dataLabels.enabled',
        defaultValue: false
      },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },

      legendSettings: { defaultValue: true }
    }
  }
});

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2067);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STACK_TYPE_CHART_VALUES = _Izenda9.MappingValues.STACK_TYPE_CHART_VALUES,
    STEP_TYPE_VALUES = _Izenda9.MappingValues.STEP_TYPE_VALUES,
    ZOOM_TYPE_VALUES = _Izenda9.MappingValues.ZOOM_TYPE_VALUES,
    LINE_STYLE_VALUES = _Izenda9.MappingValues.LINE_STYLE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.BarChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Bar, null, {
  visualType: _Izenda11.default.Bar,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_BAR');
  },

  visualPreviewCSS: 'chart-bar',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchemaWithTransposedLabel)(), (0, _Izenda8.createYAxisSchemaWithTransposedLabel)(), _Izenda8.createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izXYplane: { defaultValue: undefined },
      izGridline: { defaultValue: undefined },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: false },
      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined },

      izUseSeparator: { defaultValue: true },
      izStacking: {
        propKey: 'plotOptions.series.stacking',
        propSource: STACK_TYPE_CHART_VALUES,
        defaultValue: undefined
      },

      izRange: { propKey: 'izendaOptions.range', defaultValue: undefined },
      izThresholds: { defaultValue: undefined },
      izRegressionLine: { defaultValue: undefined },

      izInverted: { propKey: 'chart.inverted', defaultValue: false },

      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },

      legendSettings: { defaultValue: true }
    }
  }
});

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.BarChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(1116);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BarChartOptionsBuilder = (_dec = (0, _Izenda5.exportClass)('BarChartOptionsBuilder'), _dec(_class = function (_ColumnChartOptionsBu) {
  (0, _inherits3.default)(BarChartOptionsBuilder, _ColumnChartOptionsBu);

  function BarChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, BarChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = BarChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(BarChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @returns {Object}
   */


  (0, _createClass3.default)(BarChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var chartOptions = (0, _get3.default)(BarChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(BarChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser);

      return (0, _fp.assignIn)(chartOptions, {
        chart: {
          type: 'column',
          inverted: !userOptions.chart.inverted
        }
      });
    }
  }]);
  return BarChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = BarChartOptionsBuilder;
module.exports = exports['default'];

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1117);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STACK_TYPE_CHART_VALUES = _Izenda9.MappingValues.STACK_TYPE_CHART_VALUES,
    STEP_TYPE_VALUES = _Izenda9.MappingValues.STEP_TYPE_VALUES,
    ZOOM_TYPE_VALUES = _Izenda9.MappingValues.ZOOM_TYPE_VALUES,
    LINE_STYLE_VALUES = _Izenda9.MappingValues.LINE_STYLE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AreaChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Area, null, {
  visualType: _Izenda11.default.Area,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_AREA');
  },

  visualPreviewCSS: 'chart-area',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchema)(), (0, _Izenda8.createYAxisSchema)(), _Izenda8.createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izXYplane: { defaultValue: undefined },
      izGridline: { defaultValue: undefined },
      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined },
      izMultiColor: { defaultValue: false },

      izUseSeparator: { defaultValue: true },
      izStacking: {
        propKey: 'plotOptions.series.stacking',
        propSource: STACK_TYPE_CHART_VALUES,
        defaultValue: undefined
      },

      izRange: { propKey: 'izendaOptions.range', defaultValue: undefined },
      izThresholds: { defaultValue: undefined },
      izRegressionLine: { defaultValue: undefined },

      izInverted: { propKey: 'chart.inverted', defaultValue: false },
      izStep: { propKey: 'plotOptions.series.step', propSource: STEP_TYPE_VALUES, defaultValue: undefined },
      izSpline: { propKey: 'izendaOptions.spline', defaultValue: undefined },

      izLineDashStyle: { propKey: 'dashStyle', propSource: LINE_STYLE_VALUES, defaultValue: undefined },
      izLineWidth: { propKey: 'lineWidth', defaultValue: undefined },

      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },

      legendSettings: { defaultValue: true }
    }
  }
});

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(427);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Pie, null, {
  visualType: _Izenda11.default.Pie,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_PIE');
  },

  visualPreviewCSS: 'chart-pie',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisCustomNameSchema)(undefined, _Izenda8.XAXIS_LABEL_KEY, true), (0, _Izenda8.createYAxisCustomNameSchema)(undefined, _Izenda8.YAXIS_VALUE_KEY, true), _Izenda8.createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izUseSeparator: { defaultValue: true },
      izBottomXpercent: { propKey: 'izendaOptions.bottomXpercent', defaultValue: 0 },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: true },
      izLabelOrientation: { defaultValue: undefined },

      izShowPercentage: { propKey: 'izendaOptions.showPercentage', defaultValue: undefined },
      izSliceLabel: { propKey: 'izendaOptions.showSliceLabel', defaultValue: undefined },
      izValueLabel: { propKey: 'izendaOptions.showValueLabel', defaultValue: undefined },

      izPieChartStyle: { propKey: 'izendaOptions.pieChartStyle', defaultValue: 'basic' },
      legendSettings: { defaultValue: true },

      izUsePagination: { defaultValue: true },
      izItemPerRow: { defaultValue: 2 }
    }
  }
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.PieChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2071);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Funnel, null, {
  visualType: _Izenda11.default.Funnel,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_FUNNEL');
  },

  visualPreviewCSS: 'chart-funnel',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisCustomNameSchema)(undefined, _Izenda8.XAXIS_LABEL_KEY, true), (0, _Izenda8.createYAxisCustomNameSchema)(undefined, _Izenda8.YAXIS_VALUE_KEY, true), _Izenda8.createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izUseSeparator: { defaultValue: true },
      izBottomXpercent: { propKey: 'izendaOptions.bottomXpercent', defaultValue: 0 },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: true },
      izLabelOrientation: { defaultValue: undefined },

      izShowPercentage: { propKey: 'izendaOptions.showPercentage', defaultValue: false },
      izSliceLabel: { propKey: 'izendaOptions.showSliceLabel', defaultValue: false },
      izValueLabel: { propKey: 'izendaOptions.showValueLabel', defaultValue: false },

      legendSettings: { defaultValue: true },

      izUsePagination: { defaultValue: true },
      izItemPerRow: { defaultValue: 2 }
    }
  }
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.FunnelChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FunnelChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(427);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FunnelChartOptionsBuilder = (_dec = (0, _Izenda3.exportClass)('FunnelChartOptionsBuilder'), _dec(_class = function (_PieChartOptionsBuild) {
  (0, _inherits3.default)(FunnelChartOptionsBuilder, _PieChartOptionsBuild);

  function FunnelChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, FunnelChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = FunnelChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(FunnelChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */


  (0, _createClass3.default)(FunnelChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var basedOptions = (0, _get3.default)(FunnelChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(FunnelChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser);

      delete basedOptions.chart.type;

      return $izenda.extend(true, {}, basedOptions, {
        plotOptions: {
          funnel: {
            neckWidth: '40%',
            neckHeight: '30%',
            width: '60%',
            center: ['30%', '50%'],
            showInLegend: true
          }
        }
      });
    }
  }]);
  return FunnelChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = FunnelChartOptionsBuilder;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2073);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Donut, null, {
  visualType: _Izenda11.default.Donut,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_DONUT');
  },

  visualPreviewCSS: 'chart-donut',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisCustomNameSchema)(undefined, _Izenda8.XAXIS_LABEL_KEY, true), (0, _Izenda8.createYAxisCustomNameSchema)(undefined, _Izenda8.YAXIS_VALUE_KEY, true), _Izenda8.createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izUseSeparator: { defaultValue: true },
      izBottomXpercent: { propKey: 'izendaOptions.bottomXpercent', defaultValue: 0 },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: true },
      izLabelOrientation: { defaultValue: undefined },

      izShowPercentage: { propKey: 'izendaOptions.showPercentage', defaultValue: false },
      izSliceLabel: { propKey: 'izendaOptions.showSliceLabel', defaultValue: false },
      izValueLabel: { propKey: 'izendaOptions.showValueLabel', defaultValue: false },

      izPieChartStyle: { propKey: 'izendaOptions.pieChartStyle', defaultValue: 'basic' },
      legendSettings: { defaultValue: true },

      izUsePagination: { defaultValue: true },
      izItemPerRow: { defaultValue: 2 }
    }
  }
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.DonutChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get3 = __webpack_require__(112);

var _get4 = _interopRequireDefault(_get3);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DonutChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(427);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(80);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(69);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DonutChartOptionsBuilder = (_dec = (0, _Izenda7.exportClass)('DonutChartOptionsBuilder'), _dec(_class = function (_PieChartOptionsBuild) {
  (0, _inherits3.default)(DonutChartOptionsBuilder, _PieChartOptionsBuild);

  function DonutChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, DonutChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = DonutChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(DonutChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */


  (0, _createClass3.default)(DonutChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var pieOptions = (0, _get4.default)(DonutChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(DonutChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser);

      var izendaOptions = userOptions.izendaOptions || {};
      var isShowDataLabel = (0, _fp.get)('plotOptions.series.dataLabels.enabled', pieOptions);

      // to reduce the size of ring if those values are shown
      var pieSize = (0, _fp.flow)((0, _fp.get)('plotOptions.pie.size'), (0, _fp.split)('%'), _fp.head, _fp.toNumber)(pieOptions);
      var pieInnerSize = (0, _fp.has)('plotOptions.pie.innerSize', pieOptions) ? Math.round(pieSize / 3) : 0;

      var series = getSeries(userOptions.series, pieSize, pieInnerSize);

      if (izendaOptions.bottomXpercent) {
        series = applyBottomPercent(izendaOptions, series, this.DefaultColors);
      }

      return $izenda.extend(true, pieOptions, {
        chart: {
          type: 'pie',
          events: {
            click: null
          }
        },
        plotOptions: {
          series: {
            point: {
              events: {
                click: null
              }
            }
          },
          pie: {
            innerSize: pieInnerSize ? pieInnerSize + '%' : 0
          }
        },
        legend: {
          labelFormatter: function labelFormatter() {
            var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};

            var _get2 = (0, _fp.get)('series.userOptions', this),
                labelName = _get2.labelName,
                nameField = _get2.nameField;

            var fieldDataType = (0, _fp.get)('reportPartElm.field.dataFieldType', nameField);
            var reportPartElm = (0, _fp.get)('reportPartElm', nameField);
            var valueStringFormated = _Izenda6.default.getFormatedValueByStringFormat(reportPartElm, this.originalNameValue, fieldDataType);
            var fieldValues = {
              value: (0, _fp.isNil)(valueStringFormated) ? this.name : valueStringFormated,
              originalValue: this.originalNameValue
            };

            return dataParser.getFormatData(fieldValues, izendaSeriesConfig[labelName]);
          }
        },
        series: series
      });

      function getSeries(series, pieSize, innerRingSize) {
        if (!series) {
          return [];
        }

        var serieName = series.serieName;
        var yAxisField = series.yAxisField;
        var serieData = series.data;

        var numSeries = serieData.length;
        var ringSize = Math.floor((pieSize - innerRingSize) / numSeries);
        var innerSize = void 0;

        var donutSeries = serieData.map(function (drilldownLevel, idx) {
          innerSize = innerRingSize + ringSize * idx;
          return {
            name: serieName,
            data: drilldownLevel.data,
            separatorField: series.separatorField,
            separatorValue: series.separatorValue,
            labelName: (0, _fp.get)('nameField.fieldNameAlias', drilldownLevel),
            nameField: drilldownLevel.nameField,
            yAxisField: yAxisField,

            innerSize: innerSize + '%',
            size: innerSize + ringSize + '%',
            dataLabels: {
              enabled: isShowDataLabel && idx === numSeries - 1
            }
          };
        });

        return donutSeries;
      }

      function applyBottomPercent(izendaOptions, series, defaultColors) {
        var topLevel = (0, _fp.head)(series);
        var colors = userOptions.colors,
            colorByPoint = userOptions.plotOptions.series.colorByPoint,
            izDisableMultiColor = userOptions.izDisableMultiColor;


        var serieColors = colors || defaultColors;
        var topData = _Izenda4.default.processDataByBottomPercent(izendaOptions.bottomXpercent, topLevel.data, 'name', 'y');

        var drilldownData = void 0;
        series[0].data = topData.newData.map(function (item, index) {
          var colorIndex = colorByPoint && !izDisableMultiColor ? index % serieColors.length : 0;
          item.color = serieColors[colorIndex];
          return item;
        });

        if (topData.otherItems && series.length > 1) {
          for (var idx = 1; idx < series.length; idx++) {
            drilldownData = series[idx];
            drilldownData.data = removeItemByGroup(drilldownData.data, topData.otherItems);
            drilldownData.data.push(topData.otherItem);
          }
        }

        return series;

        function removeItemByGroup(source, removedItems) {
          var groupIds = (0, _fp.map)(function (item) {
            return item.groupId.id;
          }, removedItems);

          return (0, _fp.reduce)(function (result, item) {
            if (!(0, _fp.includes)(item.groupId.id, groupIds)) {
              var groupItem = (0, _fp.find)(function (i) {
                return i.groupId.id === item.groupId.id;
              }, series[0].data) || {};
              return [].concat((0, _toConsumableArray3.default)(result), [(0, _extends3.default)({}, item, { color: groupItem.color })]);
            }
            return result;
          }, [], source);
        }
      }
    }
  }]);
  return DonutChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = DonutChartOptionsBuilder;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2075);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STACK_TYPE_CHART_VALUES = _Izenda9.MappingValues.STACK_TYPE_CHART_VALUES,
    STEP_TYPE_VALUES = _Izenda9.MappingValues.STEP_TYPE_VALUES,
    ZOOM_TYPE_VALUES = _Izenda9.MappingValues.ZOOM_TYPE_VALUES,
    LINE_STYLE_VALUES = _Izenda9.MappingValues.LINE_STYLE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CombinationChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Combination, null, {
  visualType: _Izenda11.default.Combination,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_COMBINATION');
  },

  visualPreviewCSS: 'chart-combo',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchema)(), _Izenda8.createYAxisMetricsSchema],

  optionsMapping: {
    optionsByType: {
      chartType: { propKey: 'type', propSource: _Izenda11.default, defaultValue: undefined },
      izLineDashStyle: { propKey: 'dashStyle', propSource: LINE_STYLE_VALUES, defaultValue: undefined },
      izLineWidth: { propKey: 'lineWidth', defaultValue: undefined },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: false },

      /* options for all line-series */
      izXYplane: { defaultValue: undefined },
      izGridline: { defaultValue: undefined },

      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined },

      izStacking: { propKey: 'plotOptions.series.stacking', propSource: STACK_TYPE_CHART_VALUES },
      izThresholds: { defaultValue: undefined },
      izRegressionLine: { defaultValue: undefined },

      izInverted: { propKey: 'chart.inverted', defaultValue: false },

      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },

      legendSettings: { defaultValue: true },

      izStep: { propKey: 'plotOptions.series.step', propSource: STEP_TYPE_VALUES, defaultValue: undefined },
      izSpline: { propKey: 'izendaOptions.spline', defaultValue: undefined },
      izSingleYAxis: { defaultValue: false }
    }
  }
});

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CombinationChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(426);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(85);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(69);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(220);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

var _Izenda11 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Y_AXIS_CONTAINER_NAME = 'values';
var CombinationChartOptionsBuilder = (_dec = (0, _Izenda11.exportClass)('CombinationChartOptionsBuilder'), _dec(_class = function (_ChartHasThresholdOpt) {
  (0, _inherits3.default)(CombinationChartOptionsBuilder, _ChartHasThresholdOpt);

  function CombinationChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, CombinationChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = CombinationChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(CombinationChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @returns {Object}
   */


  (0, _createClass3.default)(CombinationChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var _this2 = this;

      var chartOptions = (0, _get3.default)(CombinationChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(CombinationChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser, false) || {};

      var yAxisContainerName = (0, _fp.getOr)(Y_AXIS_CONTAINER_NAME, 'Y_AXIS_CONTAINER_NAME', userOptions);

      var dataStructure = dataParser.dataStructure || {};
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
      var defaultColors = this.DefaultColors;

      userOptions.chart.type = '';

      var combinationSeries = chartOptions.series;
      var thresholdSeries = chartOptions.thresholdSeries;
      var izSingleYAxis = userOptions.izSingleYAxis;

      var isMultiSeries = combinationSeries.length > 1;
      var doesTransformToSingleYAxis = izSingleYAxis && isMultiSeries && !this.chartOptions.isSetting;

      chartOptions.series = [].concat((0, _toConsumableArray3.default)(combinationSeries), (0, _toConsumableArray3.default)(thresholdSeries));

      /**
       * Get index of Y-axis field that threshold belongs to
       * @param {Object} thresholdSerie
       * @returns {number}
       */
      var getYAxisFieldOfThresholdSeries = function getYAxisFieldOfThresholdSeries(thresholdSerie) {
        var fieldOptions = _this2.fieldOptions;
        var thresholdFieldNameAlias = (0, _fp.getOr)('', 'yAxisField.fieldNameAlias', thresholdSerie);

        var indexYAxisField = (0, _fp.findIndex)(function (combinationSerie) {
          var fieldNameAlias = combinationSerie.fieldNameAlias;
          var dynamicThresholds = fieldOptions[fieldNameAlias].dynamicThresholds;

          return (0, _fp.find)({ fieldName: thresholdFieldNameAlias }, dynamicThresholds);
        }, dataStructure[yAxisContainerName]);

        return indexYAxisField < 0 ? 0 : indexYAxisField;
      };

      setConfigSerie(userOptions, chartOptions, doesTransformToSingleYAxis);

      return chartOptions;

      /**
       * Set config for series
       * @param {Object} userOptions
       * @param {Object} chartOptions
       * @param {boolean} doesTransformToSingleYAxis
       */
      function setConfigSerie(userOptions, chartOptions, doesTransformToSingleYAxis) {
        var orgYaxis = chartOptions.yAxis;
        var colors = (0, _fp.isNil)(userOptions.colors) ? defaultColors : userOptions.colors;
        chartOptions.yAxis = [];

        var lineSeries = (0, _fp.filter)(function (s) {
          return s.type === _Izenda6.default.Line || s.type === _Izenda6.default.Area;
        }, chartOptions.series);
        if (lineSeries.length > 0) {
          // Line and Area do not support colorByPoint.
          // So we need to get the colorByPoint which will be a flag to manually set color for point
          var colorByPoint = (0, _fp.get)('plotOptions.series.colorByPoint', userOptions);
          var colorOptions = {
            izMultiColor: colorByPoint,
            izDisableMultiColor: userOptions.izDisableMultiColor
          };
          _Izenda8.default.setColorPointForAreaLine(colorOptions, lineSeries, colors);

          var plotOptions = {
            series: {
              colorByPoint: false
            }
          };

          chartOptions.plotOptions = (0, _fp.merge)(chartOptions.plotOptions, plotOptions);
        }

        var buildYAxis = function buildYAxis(index, axisConfig) {
          var serie = chartOptions.series[index];
          var serieName = serie.name;
          var serieColor = serie.isThreshold ? null : colors[index];

          if (!serie.isThreshold) {
            // link to y-axis
            chartOptions.series[index] = (0, _fp.flow)((0, _fp.assignIn)((0, _fp.get)('chartOptions', izendaSeriesConfig[serieName])), (0, _fp.assignIn)({
              yAxis: index
            }))(serie);
          } else {
            var indexOfThreshold = getYAxisFieldOfThresholdSeries(serie);
            chartOptions.series[index] = (0, _fp.flow)((0, _fp.assignIn)((0, _fp.get)('chartOptions', izendaSeriesConfig[serieName])), (0, _fp.assignIn)({
              yAxis: indexOfThreshold,
              type: 'line'
            }))(serie);
          }

          var yAxisOptions = (0, _fp.assignIn)(orgYaxis, {
            title: {
              text: serieName,
              style: {
                color: serieColor
              }
            },
            labels: {
              formatter: function formatter() {
                // Format value for combination chart
                var jsFormatString = (0, _fp.get)('fieldElement.properties.dataFormattings.format.jsFormatString', izendaSeriesConfig[serieName]);
                if (jsFormatString) {
                  var jsFormatId = (0, _fp.get)('fieldElement.properties.dataFormattings.format.formatId', izendaSeriesConfig[serieName]);
                  return _Izenda10.default.format(jsFormatId, this.value);
                }

                // as new requirement, label will not apply alternative text.
                return (0, _fp.escape)(this.value);
              },

              style: {
                color: serieColor
              }
            },
            opposite: !!index,
            plotLines: getSeriesConfigOption(index, 'threshold')
          });

          // Only create y-axis for each serie - not threshold
          if (!serie.isThreshold) {
            yAxisOptions = (0, _fp.merge)(yAxisOptions, getSeriesConfigOption(index, 'axisOption'));
            !!(0, _fp.get)('title', axisConfig) && (yAxisOptions.title = (0, _fp.assign)(yAxisOptions.title, axisConfig.title));
            chartOptions.yAxis.push(yAxisOptions);
          }
        };

        if (doesTransformToSingleYAxis) {
          var axisConfig = {
            title: {
              text: _Izenda2.default.getText('COMMON_LABEL_ALL')
            }
          };

          buildYAxis(0, axisConfig);
        } else {
          for (var index = 0; index < chartOptions.series.length; index++) {
            buildYAxis(index);
          }
        }
      }

      /**
       * Get series config option by dataKey
       * @param {number} index
       * @param {string} dataKey
       * @returns {string}
       */
      function getSeriesConfigOption(index, dataKey) {
        var yAxisFields = (0, _fp.get)(Y_AXIS_CONTAINER_NAME, dataStructure);
        if (yAxisFields && yAxisFields.length > index) {
          return (0, _fp.get)(yAxisFields[index].fieldNameAlias + '.' + dataKey, izendaSeriesConfig);
        }
      }
    }
  }]);
  return CombinationChartOptionsBuilder;
}(_Izenda4.default)) || _class);
exports.default = CombinationChartOptionsBuilder;
module.exports = exports['default'];

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2077);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.TreeMap, null, {
  visualType: _Izenda11.default.TreeMap,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_TREE_MAP');
  },

  visualPreviewCSS: 'chart-treemap',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisCustomNameSchema)(undefined, _Izenda8.XAXIS_LABEL_KEY, true), (0, _Izenda8.createYAxisCustomNameSchema)(undefined, _Izenda8.YAXIS_VALUE_KEY, true), _Izenda8.createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izUseSeparator: { defaultValue: true },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: false },
      izMultiLevel: { defaultValue: false },
      izLabelOrientation: { defaultValue: undefined },

      izSliceLabel: { propKey: 'izendaOptions.showSliceLabel', defaultValue: false },
      izValueLabel: { propKey: 'izendaOptions.showValueLabel', defaultValue: false },

      legendSettings: { defaultValue: true },

      izUsePagination: { defaultValue: true },
      izItemPerRow: { defaultValue: 2 }
    }
  }
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.TreemapChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _from = __webpack_require__(646);

var _from2 = _interopRequireDefault(_from);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.TreemapChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(427);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(49);

var _fp = __webpack_require__(1);

var _Izenda4 = __webpack_require__(69);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var X_AXIS_CONTAINER_NAME = 'labels';

var TreemapChartOptionsBuilder = (_dec = (0, _Izenda3.exportClass)('TreemapChartOptionsBuilder'), _dec(_class = function (_PieChartOptionsBuild) {
  (0, _inherits3.default)(TreemapChartOptionsBuilder, _PieChartOptionsBuild);

  function TreemapChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, TreemapChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = TreemapChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(TreemapChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} userOptions User's options
   * @param {Object} dataParser Data parser
   */


  (0, _createClass3.default)(TreemapChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var basedOptions = (0, _get3.default)(TreemapChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(TreemapChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser);
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};

      delete basedOptions.chart.type;
      delete basedOptions.xAxis.plotLines;
      delete basedOptions.yAxis.plotLines;

      var series = userOptions.series;
      var customConfig = {
        series: series
      };

      if (userOptions.izMultiLevel) {
        var dataStructure = dataParser.dataStructure;
        var xDatafields = dataStructure[X_AXIS_CONTAINER_NAME];
        var xAxisFields = (0, _mobx.toJS)(xDatafields);

        xAxisFields.forEach(function (_ref2) {
          var fieldNameAlias = _ref2.fieldNameAlias;

          _Izenda5.default.addPointActionLink(true, userOptions, (0, _fp.get)('plotOptions.series.dataLabels', basedOptions), fieldNameAlias, (0, _fp.get)(fieldNameAlias, izendaSeriesConfig), null, true);
        });

        var maxLevel = (0, _fp.maxBy)(function (item) {
          return item.level;
        }, series.data).level;
        var enabledDataLabels = (0, _fp.get)('plotOptions.series.dataLabels.enabled', basedOptions);
        var data = this.parseAllSeries(userOptions.series, maxLevel);
        series = [{
          data: data,
          levels: this.buildLevelsSetting(maxLevel, enabledDataLabels),
          name: userOptions.series.serieName
        }];

        customConfig = {
          chart: {
            events: {
              click: null
            }
          },
          plotOptions: {
            series: {
              point: {
                events: {
                  click: null
                }
              }
            }
          },
          series: series
        };
      }

      return $izenda.extend(true, basedOptions, {
        plotOptions: {
          treemap: {
            layoutAlgorithm: 'squarified',
            showInLegend: true
          }
        }
      }, customConfig);
    }

    /**
     * Merge series
     * @param {Any} series
     * @param {Number} maxLevel
     */

  }, {
    key: 'parseAllSeries',
    value: function parseAllSeries(series, maxLevel) {
      if (!series) {
        return [];
      }

      var tree = [];

      var yAxisField = series.yAxisField,
          separatorField = series.separatorField,
          separatorValue = series.separatorValue,
          serieName = series.serieName;

      var concatFirstDataSets = function concatFirstDataSets(source, newCollection) {
        return [].concat(newCollection, source);
      };
      var buildTreeOfLevel = function buildTreeOfLevel(source, result, currentLevel) {
        var _find = (0, _fp.find)(function (item) {
          return item.level === currentLevel;
        }, source),
            currentDataItems = _find.data,
            nameField = _find.nameField;

        currentDataItems.forEach(function (item) {
          item.id = item.name + '_' + (0, _fp.getOr)('', 'groupId.path', item);
          item.value = item.y;
          item.yAxisField = yAxisField;
          item.nameField = nameField;
          item.labelName = (0, _fp.get)('fieldNameAlias', nameField);
          item.separatorField = separatorField;
          item.separatorValue = separatorValue;
          item.serieName = serieName;
        });

        if (currentLevel === 0) return concatFirstDataSets(result, currentDataItems);

        var parentLevel = currentLevel - 1;
        var parentDataItems = (0, _fp.find)(function (item) {
          return item.level === parentLevel;
        }, source).data;

        parentDataItems.forEach(function (_ref3) {
          var path = _ref3.groupId.path,
              name = _ref3.name;

          currentDataItems.forEach(function (i) {
            var currentPath = (0, _fp.get)('groupId.path', i);
            if (currentPath && currentPath.includes(path)) {
              i.parent = name + '_' + path;
            }
          });
        });

        result = concatFirstDataSets(result, currentDataItems);

        return buildTreeOfLevel(source, result, parentLevel);
      };

      return buildTreeOfLevel(series.data, tree, maxLevel);
    }

    /**
     * Build levels
     * @param {Number} maxLevel
     * @param {Boolean} enabled
     */

  }, {
    key: 'buildLevelsSetting',
    value: function buildLevelsSetting(maxLevel, enabled) {
      return (0, _from2.default)(Array(maxLevel + 1), function (x, i) {
        return {
          level: i,
          dataLabels: {
            enabled: enabled
          }
        };
      });
    }
  }]);
  return TreemapChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = TreemapChartOptionsBuilder;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2079);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.HeatMap, null, {
  visualType: _Izenda11.default.HeatMap,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_HEAT_MAP');
  },

  visualPreviewCSS: 'chart-heat',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchema)(1), (0, _Izenda8.createYAxisSchema)(1, _Izenda8.YAXIS_LABEL_KEY), (0, _Izenda8.createValuesLabelsSchema)(1)],

  optionsMapping: {
    optionsByType: {
      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      legendSettings: { defaultValue: true },
      izGridline: { defaultValue: undefined },
      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined }
    }
  }
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.HeatmapChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.HeatmapChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(328);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(35);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(49);

var _fp = __webpack_require__(1);

var _Izenda8 = __webpack_require__(33);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(164);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getValueFromMappingField = _Izenda11.default.getValueFromMappingField;
var X_AXIS_CONTAINER_NAME = 'labels';
var Y_AXIS_CONTAINER_NAME = 'values';
var VALUE_LABELS = 'valuesLabels';

var HeatmapChartOptionsBuilder = (_dec = (0, _Izenda7.exportClass)('HeatmapChartOptionsBuilder'), _dec(_class = function (_DefaultChartOptionsB) {
  (0, _inherits3.default)(HeatmapChartOptionsBuilder, _DefaultChartOptionsB);

  function HeatmapChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, HeatmapChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = HeatmapChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(HeatmapChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */


  (0, _createClass3.default)(HeatmapChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var dataStructure = dataParser.dataStructure || {};
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};

      var xAxisField = (0, _fp.head)(dataStructure[X_AXIS_CONTAINER_NAME]);
      if (izendaSeriesConfig[xAxisField.fieldNameAlias].fieldDataType === 'Datetime') {
        izendaSeriesConfig[xAxisField.fieldNameAlias].axisOption.izCategory = true;
      }

      var parsedOption = (0, _get3.default)(HeatmapChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(HeatmapChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, (0, _fp.merge)({
        X_AXIS_CONTAINER_NAME: X_AXIS_CONTAINER_NAME,
        Y_AXIS_CONTAINER_NAME: VALUE_LABELS,
        SEPARATOR_CONTAINER_NAME: Y_AXIS_CONTAINER_NAME
      }, userOptions), dataParser) || {};

      var yAxisField = (0, _fp.head)(dataStructure[Y_AXIS_CONTAINER_NAME]);
      var valueField = (0, _fp.head)(dataStructure[VALUE_LABELS]);

      var series = parseData(xAxisField, yAxisField, valueField);

      var COLOR_AXIS = {
        MIN_COLOR: _Izenda9.default.DefaultConfig.HeatMap.MIN_COLOR,
        MAX_COLOR: (0, _fp.isNil)(userOptions.colors) ? this.DefaultColors[0] : userOptions.colors[0]
      };

      var chartOptions = {
        // only support one series
        series: [{
          name: getFieldName(valueField),
          data: series.data,
          borderWidth: 1,

          xAxisField: xAxisField,
          yAxisField: yAxisField,
          valueField: valueField,

          dataLabels: {
            color: '#000000',
            userHTML: true,
            formatter: getDataLabels
          }
        }],

        xAxis: {
          categories: (0, _fp.map)(String, series.xAxisCat),
          axisName: getFieldName(xAxisField)
        },

        yAxis: {
          categories: (0, _fp.map)(String, series.yAxisCat),
          axisName: getFieldName(yAxisField)
        },

        plotOptions: {
          series: {
            borderWidth: 1
          }
        },

        colorAxis: {
          minColor: COLOR_AXIS.MIN_COLOR,
          maxColor: COLOR_AXIS.MAX_COLOR
        },
        legend: {
          layout: 'vertical',
          margin: 0
        }
      };

      chartOptions.xAxis = $izenda.extend(true, parsedOption.xAxis, chartOptions.xAxis);
      chartOptions.yAxis = $izenda.extend(true, parsedOption.yAxis, chartOptions.yAxis);

      // add sub-report to y-axis
      _Izenda4.default.addPointActionLink(false, userOptions, chartOptions.yAxis.labels, chartOptions.yAxis.axisName, (0, _fp.get)(chartOptions.yAxis.axisName, izendaSeriesConfig));

      return chartOptions;

      function getDataLabels() {
        var formattedValue = _Izenda4.default.getFormattedDataByPoint('value', this.point, true);
        return (0, _fp.get)('data', formattedValue);
      }

      function getFieldName(field) {
        return (0, _fp.get)('fieldNameAlias', field);
      }

      function groupData(groupInfo, groupNames) {
        var source = dataParser.records;
        var names = [];

        // groupInfo is container-name: group by first-field of container
        groupInfo = (0, _fp.isString)(groupInfo) ? (0, _fp.first)(dataStructure[groupInfo]) : groupInfo;
        var groupedData = groupInfo ? groupData(groupInfo, source) : source;
        (0, _fp.forEach)(function (name) {
          groupNames.push(name);
        }, (0, _fp.uniq)(names));

        return groupedData;

        function groupData(groupInfo, source) {
          var groupName = void 0;
          return (0, _fp.groupBy)(function (record) {
            groupName = _Izenda6.default.getOriginalValue(groupInfo, record);
            groupName = _Izenda6.default.getAlternativeText(groupName, izendaSeriesConfig[groupInfo.fieldNameAlias], groupInfo) || groupName;
            names && names.push(groupName);
            return groupName;
          }, source);
        }
      }

      function parseData(xAxisField, yAxisField, valueField) {
        var yAxisSource = getYCat(yAxisField);
        var xAxisCat = [];
        var yAxisCat = yAxisSource.arr;
        var yAxisCatObj = yAxisSource.obj;
        var serieData = [];
        var groupedData = groupData(xAxisField, xAxisCat);
        var source = void 0;
        var column = void 0,
            y = void 0,
            val = void 0;

        (0, _fp.forEach)(function (groupName) {
          source = groupedData[groupName];
          column = [];
          serieData.push(column);

          source.forEach(function (record) {
            y = (0, _fp.toString)(_Izenda6.default.getOriginalValue(yAxisField, record));
            val = _Izenda6.default.getOriginalValue(valueField, record);
            column[yAxisCatObj[y]] = {
              value: val,
              record: record
            };
          });
        }, xAxisCat);

        var data = [];
        var numRows = (0, _fp.size)(yAxisCat);
        var rowIdx = 0;

        while (rowIdx < numRows) {
          xAxisCat.forEach(function (column, colInx) {
            val = serieData[colInx][rowIdx] || {};
            val.x = colInx;
            val.y = rowIdx;
            (0, _fp.isNil)(val.value) && (val.value = 0);

            data.push(val);
          });
          rowIdx++;
        }

        return {
          xAxisCat: xAxisCat,
          yAxisCat: yAxisCat,
          data: data
        };

        function getYCat(yAxisField) {
          var values = _Izenda11.default.getListValueByField(yAxisField, dataParser.records, izendaSeriesConfig[yAxisField.fieldNameAlias]);
          var obj = {};
          values = (0, _fp.uniq)(values);

          values.forEach(function (val, idx) {
            obj[(0, _fp.toString)(val)] = idx;
          });

          return {
            arr: values,
            obj: obj
          };
        }
      }
    }
  }]);
  return HeatmapChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = HeatmapChartOptionsBuilder;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1118);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STACK_TYPE_CHART_VALUES = _Izenda9.MappingValues.STACK_TYPE_CHART_VALUES,
    STEP_TYPE_VALUES = _Izenda9.MappingValues.STEP_TYPE_VALUES,
    ZOOM_TYPE_VALUES = _Izenda9.MappingValues.ZOOM_TYPE_VALUES,
    LINE_STYLE_VALUES = _Izenda9.MappingValues.LINE_STYLE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.BubbleChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Bubble, null, {
  visualType: _Izenda11.default.Bubble,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_BUBBLE');
  },

  visualPreviewCSS: 'chart-bubble',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchema)(1, _Izenda8.XAXIS_VALUE_KEY), (0, _Izenda8.createYAxisSchema)(1), (0, _Izenda8.createValuesLabelsSchema)(), (0, _Izenda8.createBubbleSizeSchema)(1)],

  optionsMapping: {
    optionsByType: {
      izXYplane: { defaultValue: undefined },
      izInverted: { propKey: 'chart.inverted', defaultValue: false },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: false },
      izGridline: { defaultValue: undefined },
      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined },
      izThresholds: { defaultValue: undefined },
      izRegressionLine: { defaultValue: undefined },
      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },
      legendSettings: { defaultValue: true }
    }
  }
});

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2082);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STACK_TYPE_CHART_VALUES = _Izenda9.MappingValues.STACK_TYPE_CHART_VALUES,
    STEP_TYPE_VALUES = _Izenda9.MappingValues.STEP_TYPE_VALUES,
    ZOOM_TYPE_VALUES = _Izenda9.MappingValues.ZOOM_TYPE_VALUES,
    LINE_STYLE_VALUES = _Izenda9.MappingValues.LINE_STYLE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ScatterChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Scatter, null, {
  visualType: _Izenda11.default.Scatter,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_SCATTER');
  },

  visualPreviewCSS: 'chart-scatter',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchema)(1, _Izenda8.XAXIS_VALUE_KEY), (0, _Izenda8.createYAxisSchema)(1), (0, _Izenda8.createValuesLabelsSchema)()],

  optionsMapping: {
    optionsByType: {
      izXYplane: { defaultValue: undefined },
      izInverted: { propKey: 'chart.inverted', defaultValue: false },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: false },
      izGridline: { defaultValue: undefined },
      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined },
      izThresholds: { defaultValue: undefined },
      izRegressionLine: { defaultValue: undefined },
      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },
      legendSettings: { defaultValue: true }
    }
  }
});

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ScatterChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(1118);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScatterChartOptionsBuilder = (_dec = (0, _Izenda5.exportClass)('ScatterChartOptionsBuilder'), _dec(_class = function (_BubbleChartOptionsBu) {
  (0, _inherits3.default)(ScatterChartOptionsBuilder, _BubbleChartOptionsBu);

  function ScatterChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, ScatterChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = ScatterChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(ScatterChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */


  (0, _createClass3.default)(ScatterChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      // It is possible to use BubbleChartOptionsBuilder explicitly in ScatterChartConfiguration.
      // However, creating a separated class per ScatterChartConfiguration is to placeholder for
      // later change if having.
      return (0, _get3.default)(ScatterChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(ScatterChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser);
    }
  }]);
  return ScatterChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = ScatterChartOptionsBuilder;
module.exports = exports['default'];

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2084);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STACK_TYPE_CHART_VALUES = _Izenda9.MappingValues.STACK_TYPE_CHART_VALUES,
    STEP_TYPE_VALUES = _Izenda9.MappingValues.STEP_TYPE_VALUES,
    ZOOM_TYPE_VALUES = _Izenda9.MappingValues.ZOOM_TYPE_VALUES,
    LINE_STYLE_VALUES = _Izenda9.MappingValues.LINE_STYLE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.WaterfallChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Waterfall, null, {
  visualType: _Izenda11.default.Waterfall,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_WATERFALL');
  },

  visualPreviewCSS: 'chart-water',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchema)(1), (0, _Izenda8.createYAxisSchema)(1), _Izenda8.createTotalLabelSchema],

  optionsMapping: {
    optionsByType: {
      izInverted: { propKey: 'chart.inverted', defaultValue: false },
      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      legendSettings: { defaultValue: true },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },
      izMultiColor: { defaultValue: false },
      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined },

      izXYplane: { defaultValue: undefined },
      izGridline: { defaultValue: undefined },
      izThresholds: { defaultValue: undefined },

      izTotalLabel: { defaultValue: undefined }
    }
  }
});

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.WaterfallChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(426);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WaterfallChartOptionsBuilder = (_dec = (0, _Izenda5.exportClass)('WaterfallChartOptionsBuilder'), _dec(_class = function (_ChartHasThresholdOpt) {
  (0, _inherits3.default)(WaterfallChartOptionsBuilder, _ChartHasThresholdOpt);

  function WaterfallChartOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, WaterfallChartOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = WaterfallChartOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(WaterfallChartOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @returns {Object}
   */


  (0, _createClass3.default)(WaterfallChartOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var chartOptions = (0, _get3.default)(WaterfallChartOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(WaterfallChartOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser, false) || {};

      var colors = (0, _fp.isNil)(userOptions.colors) ? this.DefaultColors : userOptions.colors;
      var xAxis = chartOptions.xAxis;

      var sumTitle = escape(userOptions.izTotalLabel);

      function addSumItem(xAxis, serie) {
        var lastItem = (0, _fp.last)(serie.data);
        var biasItem = (0, _fp.nth)(-2, serie.data);
        var xAxisType = (0, _fp.getOr)('', 'type', xAxis);

        var sumItem = {
          isSum: true,
          sumTitle: sumTitle
        };

        var lastX = (0, _fp.get)('x', lastItem);
        var biasX = (0, _fp.get)('x', biasItem);
        var sumX = void 0;

        if (lastX && biasX) {
          switch (xAxisType) {
            case 'linear':
              sumX = lastX + (lastX - biasX);
              break;
            case 'datetime':
              sumX = new Date(Date.parse(lastX) + (Date.parse(lastX) - Date.parse(biasX)));
              break;
            default:
            // do nothing
          }

          sumX && (sumItem.x = sumX);
        }

        serie.data.push(sumItem);
      }

      var waterfallSeries = chartOptions.series;

      // add total label column for waterfall chart (sum all value )
      (0, _fp.forEach)(function (serie) {
        addSumItem(xAxis, serie, userOptions);
      }, waterfallSeries);

      var thresholdSeries = chartOptions.thresholdSeries;

      _Izenda4.default.setColorPointForAreaLine(userOptions, waterfallSeries, colors);

      var series = [].concat((0, _toConsumableArray3.default)(waterfallSeries), (0, _toConsumableArray3.default)(thresholdSeries));

      return {
        series: series,
        xAxis: (0, _fp.merge)(chartOptions.xAxis, {
          labels: {
            formatter: function formatter() {
              if (this.isLast) {
                return sumTitle;
              }
              var formatter = (0, _fp.get)('labels.formatter', xAxis);
              return (0, _fp.isFunction)(formatter) ? formatter.call(this) : '';
            }
          }
        }),
        yAxis: chartOptions.yAxis,
        tooltip: {
          shared: true
        }
      };
    }
  }]);
  return WaterfallChartOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = WaterfallChartOptionsBuilder;
module.exports = exports['default'];

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1115);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(99);

var _Izenda9 = __webpack_require__(33);

var _Izenda10 = __webpack_require__(85);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XAXIS_INTERVAL_KEY = 'REPORTDESIGNER_LABEL_INTERVALS';
// ----------------------------------------------------------------------
// <copyright file="Izenda.SparklineChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
var STEP_TYPE_VALUES = _Izenda9.MappingValues.STEP_TYPE_VALUES;


_Izenda2.default.extendConfiguration(_Izenda7.REPORT_PART_TYPE.Chart, _Izenda9.CHART_TYPE.Sparkline, null, {
  visualType: _Izenda11.default.Sparkline,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_CHART_TYPE_SPARKLINE');
  },

  visualPreviewCSS: 'chart-sparkline',

  optionsBuilder: _Izenda6.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _Izenda8.createXAxisSchema)(1, XAXIS_INTERVAL_KEY), _Izenda8.createYAxisMetricsSchema, _Izenda8.createSeparatorSchema],

  optionsMapping: {
    optionsByType: {
      izUseSeparator: { defaultValue: true },
      izSpline: { propKey: 'izendaOptions.spline', defaultValue: undefined },
      izStep: { propKey: 'plotOptions.series.step', propSource: STEP_TYPE_VALUES, defaultValue: undefined }
    }
  }
});

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(2087);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(181);

var _Izenda5 = _interopRequireDefault(_Izenda4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Default chart configuration */
_Izenda5.default.setConfiguration(_Izenda3.REPORT_PART_TYPE.Form, {
  /**
   * Report part content model class
   */
  model: _Izenda2.default
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultGridConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(270);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(132);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(53);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(225);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(271);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(16);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(599);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2089);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(1120);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(1121);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2090);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(34);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(1119);

var _Izenda26 = __webpack_require__(64);

var _Izenda27 = __webpack_require__(54);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _tinymce = __webpack_require__(576);

var _tinymce2 = _interopRequireDefault(_tinymce);

var _Izenda29 = __webpack_require__(600);

var _Izenda30 = _interopRequireDefault(_Izenda29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartForm.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartForm model
 */
var ASC = 'ASC';
var DESC = 'DESC';
var UNSORTED = 'Unsorted';

/**
 * create a container from data from api
 * @param  {Object} data [data from api]
 * @return {container}   [container with elements typeof ReportPartElement]
 */
var populateReportPartContainer = function populateReportPartContainer(name, data) {
  if (!data) {
    return {
      elements: [],
      name: name,
      visibleElement: _Izenda8.default.getVisibleField
    };
  }

  var pickData = (0, _fp.omit)('elements', data);
  var elements = data.elements;
  /* convert elements json object to become list of ReportPartElement*/
  var convertElements = (0, _fp.map)(function (item) {
    return new _Izenda2.default().readData(item);
  }, elements);

  (0, _mobx.extendObservable)(pickData, {
    elements: convertElements || [],
    name: name,
    visibleElement: _Izenda8.default.getVisibleField
  });

  return pickData;
};

/**
 * Rebuild the HTML markup from string content
 */
var populateHtmlContent = function populateHtmlContent(content, elements) {
  var domContent = $izenda('<div>' + content + '</div>');
  domContent.find('field').each(function (index, item) {
    var fieldNameAlias = (0, _fp.trim)($izenda(item).text());

    if (fieldNameAlias === _Izenda6.default.FIELD_HIDDEN_LABEL) {
      var fieldName = $izenda(item).attr('field-name');
      var matches = fieldName.match(/\[(.*?)\]/g);
      fieldNameAlias = matches[matches.length - 1].replace('[', '').replace(']', '');
    }

    var element = (0, _fp.find)({ name: fieldNameAlias }, elements);
    if (element && element.field.isCalculated) {
      $izenda(item).find('[key="fieldId"]').attr('value', element.fieldId);
    }

    if (element && (0, _fp.isNil)((0, _fp.get)('properties.drillDown.subReport.selectedReport', element))) {
      removeInvalidSubReport(item);
    }

    if (element && !element.field.visible) {
      $izenda(item).html($izenda(item).children().filter(function () {
        var isFieldProp = $izenda('field-prop', this);
        var hasCancelButton = $izenda('.icon-cancel', this);
        return isFieldProp || hasCancelButton;
      }));
      $izenda(item).find('[class="icon-cancel"]').prev().after(_Izenda6.default.FIELD_HIDDEN_LABEL);
    }

    var fieldId = $izenda(item).find('[key="fieldId"]').attr('value');
    if ((0, _fp.find)({ fieldId: fieldId }, elements)) return;
    $izenda(item).remove();
  });

  return domContent.html();
};

/**
 * Remove invalid subReport from html.
 * This is intent to clean html if there is no setting for sub-report on field.
 * This case occurs in copy report.
 * @param  {Object} $field
 */
var removeInvalidSubReport = function removeInvalidSubReport($field) {
  var fieldKeys = [_Izenda25.FieldPropertiesPaths.subReportSelReport.key, _Izenda25.FieldPropertiesPaths.subReportStyle.key, _Izenda25.FieldPropertiesPaths.subReportReportPartUsed.key, _Izenda25.FieldPropertiesPaths.subReportFilter.key, _Izenda25.FieldPropertiesPaths.subReportMappingFields.key, _Izenda25.FieldPropertiesPaths.subReportSelectedIconValue.key, _Izenda25.FieldPropertiesPaths.subReportSelectedIcon.key, _Izenda25.FieldPropertiesPaths.subReportViewSettingByLink.key];

  (0, _fp.forEach)(function (key) {
    $izenda('[key="' + key + '"]', $field).remove();
  }, fieldKeys);

  $izenda('.icon-menu', $field).remove();
};

var ReportPartForm = (0, _Izenda28.default)(_class = (_class2 = function () {
  function ReportPartForm(data) {
    (0, _classCallCheck3.default)(this, ReportPartForm);

    _initDefineProp(this, 'isCrossFiltering', _descriptor, this);

    _initDefineProp(this, 'type', _descriptor2, this);

    _initDefineProp(this, 'editorControl', _descriptor3, this);

    this.selectedFieldElement = {};

    _initDefineProp(this, 'activeTabKey', _descriptor4, this);

    _initDefineProp(this, 'isSelectedCell', _descriptor5, this);

    _initDefineProp(this, 'isActiveForEdit', _descriptor6, this);

    _initDefineProp(this, 'properties', _descriptor7, this);

    _initDefineProp(this, 'columns', _descriptor8, this);

    _initDefineProp(this, 'separators', _descriptor9, this);

    this.isFormatted = false;
    this.reportPartFormRepeater = null;
    this.reportPartFormEmbeddedReport = null;
    this.reportPartFormSmartTag = null;
    this.reportPartFormField = null;
    this.formState = null;
    this.htmlContent = null;
    this.dataTree = null;
    this.autoSize = false;

    _initDefineProp(this, 'updateElementPropsForRepeater', _descriptor10, this);

    this.reportPartFormRepeater = new _Izenda22.default();
    this.reportPartFormEmbeddedReport = new _Izenda16.default();
    this.reportPartFormSmartTag = new _Izenda18.default();
    this.reportPartFormField = new _Izenda20.default();

    this.formState = {};
    this.htmlContent = '';

    this.columns = populateReportPartContainer('columns');
    this.separators = populateReportPartContainer('separators');

    data && this.readData(data);

    this.cleanDirty(); // reset dirty
  }

  (0, _createClass3.default)(ReportPartForm, [{
    key: 'rebuildHtml',


    /**
     * Reuild html
     */
    value: function rebuildHtml() {
      // Convert repeater tag to comment tag
      this.convertRepeaterTag(0, _Izenda4.default.TAB_VISUAL.key);

      this.htmlContent = populateHtmlContent(this.htmlContent, (0, _fp.get)('columns.elements', this).concat((0, _fp.get)('separators.elements', this).slice()));

      // Fix for IE. Attribute order not guaranteed by specification.
      this.htmlContent = this.htmlContent.replace(/<field-prop (value=\".+?\") (key=\".+?\")>/g, '<field-prop $2 $1>');
    }

    /**
     * buildDataForSave
     * @return {Object}
     */

  }, {
    key: 'buildDataForSave',
    value: function buildDataForSave() {
      // Need call before get data when HTML tabs all save or call save
      this.rebuildHTMLContent();
      this.rearrangeFieldInColumnContainer();
      !(0, _fp.isEmpty)(this.dataTree) && this.syncFromHTMLToElements();
      this.updateSubtotalLevels();

      var formData = (0, _fp.omit)(['editorControl', 'selectedFieldElement', 'repeaterNodes'], this);
      var properties = (0, _mobx.toJS)(this.properties);

      return (0, _fp.assign)({ properties: properties }, formData);
    }

    /**
     * Set query source tree.
     * @param  {Object} dataTree
     */

  }, {
    key: 'setDataTree',
    value: function setDataTree(dataTree) {
      this.dataTree = dataTree;
    }

    /**
     * Transform field tags to column's elements
     */

  }, {
    key: 'syncFromHTMLToElements',
    value: function syncFromHTMLToElements(reportPart) {
      //
      var reportPartConfig = reportPart || this;
      !(0, _fp.isEmpty)(this.activeTabKey) && this.activeTabKey !== _Izenda4.default.TAB_VISUAL.key && !(0, _fp.isEmpty)(this.dataTree) && _Izenda14.default.syncFromHTMLToElements(this.columns, this.separators, this.htmlContent, this.dataTree, reportPartConfig);
    }

    /**
     * getReportPartProperties description
     * @param  {String} propKey
     * @param  {Object|Array|String} defaultValue
     * @return {Object|Array|String}
     */

  }, {
    key: 'getReportPartProperties',
    value: function getReportPartProperties(propKey, defaultValue) {
      var props = this.properties || {};

      if (!propKey) {
        return props;
      }

      return (0, _fp.getOr)(defaultValue, propKey, props);
    }

    /**
     * setReportPartProperties description
     * @param {Object} newProps [description]
     */

  }, {
    key: 'setReportPartProperties',
    value: function setReportPartProperties(newProps) {
      var props = (0, _mobx.toJS)(this.properties) || {};

      (0, _mobx.transaction)(function () {
        var source = newProps || {};
        source = (0, _fp.omitBy)(_fp.isUndefined, source);
        (0, _mobx.extendObservable)(props, source);
      });

      this.properties = props;
      this.markDirty();
    }

    /**
     * validate function
     * @method validateFunction
     * @param  {object}         container    container need validateFunction
     * @param  {object}         functionInfo Function need validate
     * @return {json}                      validate result
     */

  }, {
    key: 'validateFunction',
    value: function validateFunction(container, functionInfo) {
      return {
        status: true
      };
    }

    /**
     * Return data object that represents for a report part.
     */

  }, {
    key: 'getData',
    value: function getData() {
      return (0, _fp.omit)('dataSource', (0, _fp.clone)(this));
    }

    /**
     * Set HTML Content
     * @param {String} content [description]
     */

  }, {
    key: 'setHTMLContent',
    value: function setHTMLContent(content, reportPart) {
      reportPart && !reportPart.isLoadingData && this.htmlContent !== content && (reportPart.isLoadingData = true);
      this.htmlContent = content;
      this.updateElementPropsForRepeater.apply(this);
    }

    /**
     * Get HTML Code Field
     * @param  {Object} field
     * @return {String}
     */

  }, {
    key: 'getHTMLCodeField',
    value: function getHTMLCodeField(newField, dataObject) {
      var fieldName = newField.field.fieldName;
      var text = '';
      var querySourceId = (0, _fp.get)('field.querySourceId', newField);

      // in case of the field is calculated and it is Report calculated field (querySourceId has value and !== empty)
      // we just need fieldName to build HTML content
      // but if this is Data Model calculated field. We need to build HTML content like other normal field of data model.
      // That must have connection string + schema + table and field name under 
      // format[connectionName].[schema].[DataModel].[FieldName].
      // For ex: [northwind].[dbo].[Orders].[calculated field name]
      if (newField.field.isCalculated && ((0, _fp.isNil)(querySourceId) || querySourceId === _Izenda12.default.EMPTY_GUID)) {
        text = '[' + fieldName + ']';
      } else {
        var connectionName = dataObject.connectionName,
            querySourceCategoryName = dataObject.querySourceCategoryName,
            name = dataObject.name;

        text = '[' + connectionName + '].[' + querySourceCategoryName + '].[' + name + '].[' + fieldName + ']';
      }

      // If in html tab field name alias is origin field name
      var fieldNameAlias = this.activeTabKey === _Izenda4.default.TAB_HTML.key ? fieldName : newField.fieldName;

      // Generate html for field-props.
      var fieldHtml = _Izenda14.default.buildHTMLCodeFieldContent(newField, true);

      return '<field class="field-wrapper" field-name="' + text + '">' + fieldHtml + fieldNameAlias + '<span class="icon-cancel"></span></field>';
    }

    /**
     * getHTMLCodeFieldProperties
     * @param  {Object} newField
     * @param  {Object} dataObject
     * @paran  {Boolean} needUpdateSelectedField
     */

  }, {
    key: 'updateHTMLCodeFieldContent',
    value: function updateHTMLCodeFieldContent(configField, field, needUpdateSelectedField) {
      var updateField = field || this.selectedFieldElement;
      var selectedField = $izenda(updateField)[0];

      if ((0, _fp.isNil)(selectedField)) {
        return;
      }

      var htmlValue = selectedField.outerHTML;

      htmlValue = $izenda(htmlValue).removeAttr('contenteditable').removeAttr('data-mce-selected');
      var trimHtmlValue = $izenda(htmlValue)[0].outerHTML;

      var originalElementHtml = trimHtmlValue && (0, _fp.cloneDeep)(trimHtmlValue);
      var result = _Izenda14.default.buildHTMLCodeFieldContent(configField);

      $izenda(selectedField).html((configField.hasSubReport ? '<span class="icon-menu"></span>' : '') + result + configField.fieldName + '<span class="icon-cancel"></span>');

      this.htmlContent = _Izenda14.default.cleanHtmlFromTinyMCE(this.htmlContent);

      // update html content with new html of current element.
      this.htmlContent = (0, _fp.replace)(originalElementHtml, $izenda(selectedField)[0].outerHTML, this.htmlContent.replace(/(\r\n|\n|\r|(\s)+$|((\s)*\t)$)| +(?= )/gm, ''));

      this.syncHtmlContentToTinyMCE(needUpdateSelectedField);
    }

    /**
     * Set Form Id
     * @param {[type]} id [description]
     */

  }, {
    key: 'setFormState',
    value: function setFormState(activeTabKey, id) {
      if ((0, _fp.isNil)(this.formState.id)) {
        this.formState.id = id;
      }

      this.activeTabKey = activeTabKey;
    }

    /**
     * Set editorControl
     * @param {Object} editor
     */

  }, {
    key: 'setEditorControl',
    value: function setEditorControl(editor) {
      this.editorControl = editor;
    }

    /**
     * Get editorControl
     * @return {Object}
     */

  }, {
    key: 'getEditorControl',
    value: function getEditorControl() {
      return this.editorControl;
    }

    /**
     * Check all fields have function or empty
     * @return {Boolean} [description]
     */

  }, {
    key: 'isAllFieldsHaveFunctionOrEmpty',
    value: function isAllFieldsHaveFunctionOrEmpty() {
      return (0, _fp.every)(function (element) {
        return element.haveFunction === true || element.field.isRunningField;
      }, this.allVisibleElements) || (0, _fp.every)(function (element) {
        return !element.haveFunction || element.functionInfo.name === _Izenda26.FUNCTION.DAYS_OLD.NAME;
      }, this.allVisibleElements);
    }

    /**
     * Generate previewData description
     * @param {Array} fieldsMapping [description]
     * @param {Array} records       [description]
     * @param {Array} sub total mapping
     * @param {Array} grand total mapping
     * @param {Array} records
     * @param {Object} embedde report data
     * @returns {Object} { htmlContent: require, embeddedReports: optional, embeddedSubReports: optional }
     */

  }, {
    key: 'generatePreviewData',
    value: function generatePreviewData(props, fieldsMapping, subTotalMapping, grandTotalMapping, records, embeddeReportData, reportId) {
      // for report part viewer, dashboard. when repeaterNodes never created before
      if ((0, _fp.isNil)(this.repeaterNodes)) {
        var _repeaterNodes = [];
        var reportPartElements = (0, _fp.get)('columns.elements', this).concat((0, _fp.get)('separators.elements', this).slice());
        this.reportPartFormRepeater.buildRepeaterTree(this.htmlContent, reportPartElements, 0, _repeaterNodes);
        this.repeaterNodes = _repeaterNodes;
      }

      if (!this.isAllFieldsHaveFunctionOrEmpty()) {
        return (0, _bluebird.resolve)({ htmlContent: _Izenda4.default.MESSAGES.M12 });
      }

      var result = {};
      var separatorsElement = (0, _fp.get)('separators.elements', this).slice();
      var columnsElements = (0, _fp.get)('columns.elements', this).slice();
      var elements = (0, _fp.flow)((0, _fp.concat)(separatorsElement), (0, _fp.filter)('isVisible'))(columnsElements);

      var filterForSubReport = props.getFilterInfoForSubReport();

      // Date Time Smart Tag
      var newHtmlContent = this.reportPartFormSmartTag.generateDateTimeSmartTag(this.htmlContent);
      // Grandtotal Smart Tag
      newHtmlContent = this.reportPartFormSmartTag.generateGrandTotalSmartTag(elements, grandTotalMapping, records, newHtmlContent);

      var repeaterNodes = [];
      if (newHtmlContent !== this.htmlContent) {
        this.reportPartFormRepeater.buildRepeaterTree(newHtmlContent, elements, 0, repeaterNodes);
      } else {
        repeaterNodes = this.repeaterNodes;
      }

      // Subtotal Smart Tag
      newHtmlContent = this.reportPartFormSmartTag.validationSubTotalSmartTag(newHtmlContent, repeaterNodes);

      // Check to generate for repeater tag.
      if ((newHtmlContent.indexOf(_Izenda10.default.REPEATER_START) >= 0 || newHtmlContent.indexOf(_Izenda10.default.REPEATER_START_FORTABLE) >= 0) && fieldsMapping.length > 0) {
        var embeddedSubReports = {
          data: []
        };

        // const currentFields = this.columns.elements.concat(this.separators.elements).slice();
        // TODO: check this logic again.
        var repeaterNode = (0, _fp.head)(this.repeaterNodes);
        var isValidRunningRepeater = repeaterNode ? (0, _fp.get)('totalFieldRunningField.length', repeaterNode) === 0 : true;

        var htmlContent = '';

        if (!isValidRunningRepeater) {
          htmlContent = _Izenda12.default.BUNDLE.MESSAGE.CANNOT_ADD_REPEATER_RUNNING_FIELD;
        } else {
          htmlContent = this.reportPartFormRepeater.generateData(newHtmlContent, { fieldsMapping: fieldsMapping, records: records }, elements, props.reportPart, reportId, embeddedSubReports, filterForSubReport, subTotalMapping);
        }
        result = {
          htmlContent: htmlContent,
          embeddedReports: [],
          embeddedSubReports: embeddedSubReports.data
        };
      } else {
        // Generate field
        // TODO: Remove when BE validate valid field
        if ((0, _fp.isNull)(this.dataTree) || props.printingMode || props.viewMode || this.dataTree.hasLoadDataSource) {
          result = this.reportPartFormField.generateField(props, fieldsMapping, records, this.properties, this.dataTree, elements, newHtmlContent, reportId, filterForSubReport);
        } else {
          result = {
            htmlContent: '',
            embeddedReports: [],
            embeddedSubReports: []
          };
        }
      }

      // Embedded report
      return this.reportPartFormEmbeddedReport.generateEmbeddedReport(embeddeReportData, result.htmlContent).then(function (embeddedReportObj) {
        result.embeddedReports = embeddedReportObj.embeddedReports;
        result.htmlContent = embeddedReportObj.htmlContent;
        return result;
      });
    }

    /**
     * Check need to break page when printing.
     */

  }, {
    key: 'checkBreakPage',
    value: function checkBreakPage() {
      return this.properties.pageBreakAfterEachEntry || this.checkBreakPageFromHtmlContent();
    }

    /**
     * Verify break page from html content.
     */

  }, {
    key: 'checkBreakPageFromHtmlContent',
    value: function checkBreakPageFromHtmlContent() {
      var $htmlContentWrapper = $izenda('<div/>').html(this.htmlContent);
      return $izenda('[style^="page-break"]', $htmlContentWrapper).length !== 0;
    }

    /**
     * Convert repeater tag.
     * @param {Number} start position
     * @param {String} active tab key
     */

  }, {
    key: 'convertRepeaterTag',
    value: function convertRepeaterTag(start, activeTabKey) {
      if (this.hasRepeaterAndTable(this.htmlContent, activeTabKey)) {
        var placeHolderRoot = {
          placeHolders: []
        };
        this.convertTableToPlaceHolder(placeHolderRoot, activeTabKey);
        this.convertPlaceHolderToTable(placeHolderRoot.placeHolders, activeTabKey);
      }
    }

    /**
     * check to exist repeater and table in content
     * @param {String} content
     * @param {String} active tab key
     * @returns {Boolean} has repeater and table
     */

  }, {
    key: 'hasRepeaterAndTable',
    value: function hasRepeaterAndTable(content, activeTabKey) {
      var repeaterPattern = activeTabKey === _Izenda4.default.TAB_HTML.key ? _Izenda10.default.REPEATER_START_FORTABLE : _Izenda10.default.REPEATER_START;
      return content.indexOf('</table>') >= 0 && content.indexOf(repeaterPattern) >= 0;
    }

    /**
     * Convert all table to place holders
     * @param {Object} place holder root
     * @param {String} active tab key
     */

  }, {
    key: 'convertTableToPlaceHolder',
    value: function convertTableToPlaceHolder(placeHolderRoot, activeTabKey) {
      var latestBeginTable = this.htmlContent.lastIndexOf('<table');
      var latestEndTable = this.htmlContent.indexOf('</table>', latestBeginTable) + 8;

      var tableContent = this.htmlContent.substring(latestBeginTable, latestEndTable);
      var placeHolderText = '[#TABLE_PLACEHOLDER#' + placeHolderRoot.placeHolders.length + ']';
      this.htmlContent = this.htmlContent.replace(tableContent, placeHolderText);
      placeHolderRoot.placeHolders.push({
        text: placeHolderText,
        content: tableContent
      });

      if (this.htmlContent.indexOf('</table>') >= 0) {
        this.convertTableToPlaceHolder(placeHolderRoot, activeTabKey);
      }
    }

    /**
     * Convert all place holders to table
     * @param {Object} place holders
     * @param {String} active tab key
     */

  }, {
    key: 'convertPlaceHolderToTable',
    value: function convertPlaceHolderToTable(placeHolders, activeTabKey) {
      for (var i = placeHolders.length - 1; i >= 0; i--) {
        var placeHolder = placeHolders[i];
        var placeHolderText = placeHolder.text;
        var placeHolderContent = placeHolder.content;

        var content = formatRepeater(placeHolderContent, placeHolderText, activeTabKey);
        this.htmlContent = this.htmlContent.replace(placeHolderText, content);
      }

      function formatRepeater(content, text, activeTabKey) {
        if (activeTabKey === _Izenda4.default.TAB_HTML.key) {
          content = content.split(_Izenda10.default.REPEATER_START_FORTABLE).join(_Izenda10.default.REPEATER_START);
          content = content.split(_Izenda10.default.REPEATER_END_FORTABLE).join(_Izenda10.default.REPEATER_END);
        } else {
          content = content.split(_Izenda10.default.REPEATER_START).join(_Izenda10.default.REPEATER_START_FORTABLE);
          content = content.split(_Izenda10.default.REPEATER_END).join(_Izenda10.default.REPEATER_END_FORTABLE);
        }

        return content;
      }
    }

    /**
     * Update html content by changed field name.
     * @param  {String} originalName
     * @param  {String} name
     */

  }, {
    key: 'updateContentWithFieldName',
    value: function updateContentWithFieldName(originalName, name) {
      if (this.htmlContent && this.htmlContent.indexOf('[' + originalName + ']') !== -1) {
        this.htmlContent = (0, _fp.replace)('[' + originalName + ']', '[' + name + ']', this.htmlContent);
        this.syncHtmlContentToTinyMCE();
        return true;
      }
      return false;
    }

    /**
     * Set selected field element by field name alias.
     * @param  {String} fieldNameAlias
     */

  }, {
    key: 'setSelectedFieldElement',
    value: function setSelectedFieldElement(fieldNameAlias) {
      this.selectedFieldElement = this.getSelecteField(fieldNameAlias);
      this.markDirty();
    }

    /**
     * Get HTML field by field name alias
     * @param {String} fieldNameAlias
     */

  }, {
    key: 'getSelecteField',
    value: function getSelecteField(fieldNameAlias, needUpdateSelectedField) {
      var $form = this.getTinyMCEContentDOM();
      var $fields = $izenda('field:not(.mce-offscreen-selection field)', $form);
      var matchingField = {};

      (0, _fp.forEach)(function (field) {
        !needUpdateSelectedField && $izenda(field).removeAttr('data-mce-selected');
      }, $fields);

      (0, _fp.forEach)(function (field) {
        var currentAlias = (0, _fp.trim)($izenda(field).text());

        if (currentAlias === _Izenda6.default.FIELD_HIDDEN_LABEL) {
          var fieldNameAttr = $izenda(field).attr('field-name');
          var matches = fieldNameAttr.match(/\[(.*?)\]/g);
          currentAlias = matches[matches.length - 1].replace('[', '').replace(']', '');
        }

        if (currentAlias === fieldNameAlias) {
          matchingField = field;
          return false;
        }
      }, $fields);

      if (!needUpdateSelectedField) {
        $izenda(matchingField).attr('contenteditable', false);
        $izenda(matchingField).attr('data-mce-selected', 1);
      }

      return matchingField;
    }

    /**
     * Sync htmlContent to TinyMCE content.
     * @param {Boolean} needUpdateSelectedField
     */

  }, {
    key: 'syncHtmlContentToTinyMCE',
    value: function syncHtmlContentToTinyMCE(needUpdateSelectedField) {
      var form = _tinymce2.default.get(this.editorControl.id);
      form.setContent(this.htmlContent);

      !needUpdateSelectedField && this.setSelectedFieldElement((0, _fp.trim)($izenda(this.selectedFieldElement).text()));
    }

    /**
     * Get TinyMCE content DOM.
     */

  }, {
    key: 'getTinyMCEContentDOM',
    value: function getTinyMCEContentDOM() {
      var tinyMCEIFramePost = '_ifr';
      return $izenda('#' + this.formState.id + tinyMCEIFramePost).contents();
    }

    /**
     * Get drill info.
     */

  }, {
    key: 'getDrilldownInfo',
    value: function getDrilldownInfo() {
      return {
        expandedLevel: -1,
        filters: []
      };
    }

    /**
     * Check dirty status
     * @return {[boolean]} is dirty
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      return this.isDirty;
    }

    /**
     * Clean dirty status
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();
    }

    /**
     * Mark isFormatted flag
     */

  }, {
    key: 'markFormated',
    value: function markFormated() {
      this.isFormatted = true;
    }

    /**
     * check if function is compatible with element
     * @method checkedCompatibleFunction
     * @param  {Object}                  container    Container that element belong
     * @param  {Object}                  element      Element need to validate
     * @param  {Object}                  functionInfo Function infomation
     * @return {Boolean}                              Result
     */

  }, {
    key: 'checkedCompatibleFunction',
    value: function checkedCompatibleFunction(container, element, functionInfo) {
      if (functionInfo.name && element.field.hasAggregatedFunction) {
        return false;
      }

      return true;
    }

    /**
     * Update subtotal's levels property
     */

  }, {
    key: 'updateSubtotalLevels',
    value: function updateSubtotalLevels() {
      var elements = (0, _fp.get)('columns.elements', this).concat((0, _fp.get)('separators.elements', this).slice());

      if ((0, _fp.isNil)(this.repeaterNodes)) {
        var repeaterNodes = [];
        this.reportPartFormRepeater.buildRepeaterTree(this.htmlContent, elements, 0, repeaterNodes);
        this.repeaterNodes = repeaterNodes;
      }

      var lastFieldNameAliasChain = [];

      this.clearSubtotalLevels(elements);

      var resolveLastFieldNameAlias = function resolveLastFieldNameAlias(repeater) {
        if ((0, _fp.isEmpty)(repeater.fields)) {
          return (0, _fp.isEmpty)(lastFieldNameAliasChain) ? '' : (0, _fp.last)(lastFieldNameAliasChain);
        }
        var lastFieldNameAlias = (0, _fp.getOr)('', 'fieldInfo.fieldNameAlias', (0, _fp.last)(repeater.fields));
        lastFieldNameAliasChain.push(lastFieldNameAlias);
        return lastFieldNameAlias;
      };

      var process = function process(nodes) {
        (0, _fp.forEach)(function (repeater) {
          var lastFieldNameAlias = resolveLastFieldNameAlias(repeater);
          (0, _fp.flow)((0, _fp.filter)(function (tag) {
            return !!(0, _fp.get)('configField.fieldInfo', tag);
          }), (0, _fp.forEach)(function (subtotalTag) {
            var properties = subtotalTag.configField.fieldInfo.properties;
            var subTotal = (0, _fp.invokeArgs)('getDataValueByKey', ['subTotal'], properties);
            if (!!subTotal.label) {
              if (!(0, _fp.isArray)(subTotal.levels)) {
                subTotal.levels = [lastFieldNameAlias];
              } else {
                (0, _fp.findIndex)(function (i) {
                  return i === lastFieldNameAlias;
                }, subTotal.levels) === -1 && subTotal.levels.push(lastFieldNameAlias);
              }
              (0, _fp.invokeArgs)('setDataFormatByKey', ['subTotal', subTotal], properties);
            }
          }))(repeater.smartTagInContent);

          !(0, _fp.isEmpty)(repeater.childNodes) && process(repeater.childNodes);
          lastFieldNameAliasChain.pop();
        }, nodes);
      };

      process(this.repeaterNodes);
    }

    /**
     * Clear subtotal's levels
     * @param {Array<Object} elements
     */

  }, {
    key: 'clearSubtotalLevels',
    value: function clearSubtotalLevels(elements) {
      (0, _fp.forEach)(function (_ref) {
        var properties = _ref.properties;

        var subTotal = (0, _fp.invokeArgs)('getDataValueByKey', ['subTotal'], properties);
        if (!!subTotal.label && !(0, _fp.isEmpty)(subTotal.levels)) {
          subTotal.levels = [];
          (0, _fp.invokeArgs)('setDataFormatByKey', ['subTotal', subTotal], properties);
        }
      }, elements);
    }

    /**
     * read data from api/create report part to update data
     * @param {Object} content [data from api/create report part]
     */

  }, {
    key: 'readData',
    value: function readData(content) {
      content = content || {};

      this.isCrossFiltering = content.isCrossFiltering;
      this.isFormatted = content.isFormatted;
      this.columns = populateReportPartContainer('columns', content.columns);
      this.separators = populateReportPartContainer('separators', content.separators);
      this.setHTMLContent(content.htmlContent || '');

      this.rebuildHtml();
      this.setReportPartProperties(content.properties);
    }

    // Sync HTML to element for form when change from backside to front side

  }, {
    key: 'afterChangeSide',
    value: function afterChangeSide(isBackSide) {
      !isBackSide && this.syncFromHTMLToElements();
    }

    /**
     * Build repeater tree
     */

  }, {
    key: 'buildRepeaterTree',
    value: function buildRepeaterTree(setSelectedFieldElement) {
      var _this = this;

      var elements = (0, _fp.get)('columns.elements', this).concat((0, _fp.get)('separators.elements', this).slice());
      var repeaterNodes = [];
      this.reportPartFormRepeater.buildRepeaterTree(this.htmlContent, elements, 0, repeaterNodes);

      this.repeaterNodes = repeaterNodes;
      // reset hasRepeaterPart
      (0, _fp.forEach)(function (field) {
        field && (field.properties.hasRepeatPart = false);
      }, elements);

      this.repeaterNodes = repeaterNodes;

      // update sort value & hasRepeaterPart also
      var updateFieldsProperty = function updateFieldsProperty(repeaterNodes) {
        if ((0, _fp.isEmpty)(repeaterNodes)) {
          return;
        }
        (0, _fp.forEach)(function (repeaterNode) {
          var hasSupportUnsort = _this.checkRepeaterHasSupportUnsort(repeaterNode);
          // update list field config in repeater part
          (0, _fp.forEach)(function (field) {
            var fieldModel = field.fieldInfo || {};
            var onlySupportUnsort = _this.checkFieldOnlySupportUnsort(_this.repeaterNodes, repeaterNode, fieldModel);
            _this.updateSortValue(fieldModel, setSelectedFieldElement, onlySupportUnsort, hasSupportUnsort);
            fieldModel.properties.hasRepeatPart = true;
          }, repeaterNode.fields);

          updateFieldsProperty(repeaterNode.childNodes);
        }, repeaterNodes);
      };
      updateFieldsProperty(repeaterNodes);
    }

    /**
     * Update sort value for field
     * @param {Object} fieldModel
     * @param {boolean} setSelectedFieldElement
     * @param {boolean} onlySupportUnsort
     * @param {boolean} hasSupportUnsort
     */

  }, {
    key: 'updateSortValue',
    value: function updateSortValue(fieldModel, setSelectedFieldElement, onlySupportUnsort, hasSupportUnsort) {
      var currentSortValue = (0, _fp.invokeArgs)('getValueByKey', ['sort'], fieldModel.properties);
      var newValue = onlySupportUnsort ? UNSORTED : hasSupportUnsort || currentSortValue === DESC ? currentSortValue : ASC;

      if (newValue !== currentSortValue) {
        (0, _fp.invokeArgs)('setDataFormatByKey', ['sort', newValue], fieldModel.properties);
        var selecteField = this.getSelecteField(fieldModel.field.fieldNameAlias, true);
        setSelectedFieldElement && selecteField && this.updateHTMLCodeFieldContent(fieldModel, selecteField, true);
      }
    }

    /**
     * Rebuild HTML Content
     * @param {Boolean} setSelectedFieldElement
     */

  }, {
    key: 'rebuildHTMLContent',
    value: function rebuildHTMLContent(needUpdateSelectedField) {
      // Update html content from tinyMCE to report part properties for case add repeater from propeties panel
      var formEditor = _tinymce2.default.get((0, _fp.get)('editorControl.id', this));

      formEditor && (this.htmlContent = formEditor.getContent());

      this.buildRepeaterTree(needUpdateSelectedField);
      return (0, _bluebird.resolve)(true);
    }
  }, {
    key: 'insertEmbeddedReportHtml',


    /**
     * Get Embedded Report HTML
     * @param  {Array} List data of report part object
     * @return {String} embedded report html
     */
    value: function insertEmbeddedReportHtml(data) {
      this.reportPartFormEmbeddedReport.insertEmbeddedReportHtml(data, this.editorControl);
    }

    /**
     * Update Embedded Report HTML
     * @param  {Array} List data of report part object
     * @return {String} embedded report html
     */

  }, {
    key: 'updateEmbeddedReportHtml',
    value: function updateEmbeddedReportHtml(embeddedReportDOM, model) {
      this.reportPartFormEmbeddedReport.insertEmbeddedReportHtml(model, this.editorControl);
    }
    /**
     * Update subtotal HTML
     * @param  {String} List data of report part object
     */

  }, {
    key: 'updateSubTotalHtml',
    value: function updateSubTotalHtml(fieldName, selectedElement) {
      this.reportPartFormSmartTag.updateSubTotalHtml(fieldName, selectedElement);
    }
    /**
     * Update grand total Report HTML
     * @param  {String} fieldname
     */

  }, {
    key: 'updateGrandTotalHtml',
    value: function updateGrandTotalHtml(fieldName, selectedElement) {
      this.reportPartFormSmartTag.updateGrandTotalHtml(fieldName, selectedElement);
    }

    /**
     * Update container field
     * @return {[type]} [description]
     */

  }, {
    key: 'updateContainerField',
    value: function updateContainerField() {
      var result = this.reportPartFormField.updateContainerField(this.columns.elements, this.htmlContent);
      if (!(0, _fp.isNil)(result)) {
        this.columns.elements = result;
      }
    }
  }, {
    key: 'changePageSize',
    value: function changePageSize(pageSize) {
      this.properties.pageSize = pageSize;
    }

    /**
     * Action when report part is in config mode (report part properties are showed)
     */

  }, {
    key: 'configModeAction',
    value: function configModeAction() {
      this.isActiveForEdit = false;
    }

    /**
     * Reset border default value
     */

  }, {
    key: 'resetBorderDefaultValue',
    value: function resetBorderDefaultValue() {
      this.properties.isVisibleBorder = false;
      this.properties.borderColor = _Izenda4.default.FORM_STYLE_DEFAULT.borderColor;
      this.properties.borderStyle = _Izenda4.default.FORM_STYLE_DEFAULT.borderStyle;
      this.properties.borderWidth = _Izenda4.default.FORM_STYLE_DEFAULT.borderWidth;

      this.markDirty();
    }

    /**
     * Reset refesh intervalue default value
     * @param  {[type]} ) {               this.properties.dataRefreshInterval [description]
     * @return {[type]}   [description]
     */

  }, {
    key: 'resetRefreshIntervalValue',
    value: function resetRefreshIntervalValue() {
      this.properties.dataRefreshInterval = _Izenda4.default.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
      this.markDirty();
    }
    /**
     * Move all field from seperator to column container for old reporpt.
     */

  }, {
    key: 'rearrangeFieldInColumnContainer',
    value: function rearrangeFieldInColumnContainer() {
      var _this2 = this;

      var totalFields = (0, _fp.get)('totalFields', (0, _fp.head)(this.repeaterNodes));

      this.columns.elements.splice(0, this.columns.elements.length);

      (0, _fp.forEach)(function (item) {
        item && item.fieldInfo && _this2.columns.elements.push(item.fieldInfo);
      }, totalFields);

      this.separators.elements.splice(0, this.separators.elements.length);
    }

    /**
     * Found repeater node by field
     * @param {String} filedNameAlias
     */

  }, {
    key: 'foundRepeaternode',
    value: function foundRepeaternode(filedNameAlias, repeaterNodes) {
      var repeaterNode = void 0;

      var foundNode = function foundNode(filedNameAlias, object) {
        if ((0, _fp.isEmpty)(object)) return null;
        var matchLvl = (0, _fp.find)(['fieldInfo.fieldNameAlias', filedNameAlias], object.fields);
        if (matchLvl) {
          repeaterNode = object;
        } else {
          (0, _fp.forEach)(function (item) {
            foundNode(filedNameAlias, item);
          }, object.childNodes);
        }
      };

      (0, _fp.forEach)(function (item) {
        foundNode(filedNameAlias, item);
      }, repeaterNodes);

      return repeaterNode;
    }

    /**
     * Hidden sort properties on property panel
     * @param  {Object} field
     * @return {Boolean}
     */

  }, {
    key: 'checkHiddenSortField',
    value: function checkHiddenSortField(field) {
      // TODO: this logic will consider remove later when backend implement support for data grouping.
      var repeaterNode = this.foundRepeaternode(field.fieldNameAlias, this.repeaterNodes);

      return this.checkFieldOnlySupportUnsort(this.repeaterNodes, repeaterNode, field);
    }

    /**
     * Check field only support unsort function.
     * @param {*} repeaterNodes
     * @param {*} repeaterNode
     * @param {*} field
     */

  }, {
    key: 'checkFieldOnlySupportUnsort',
    value: function checkFieldOnlySupportUnsort(repeaterNodes, repeaterNode, field) {
      if ((0, _fp.isEmpty)(repeaterNode) || repeaterNode.childNodes.length > 0 || repeaterNode.level === 0) {
        return false;
      }
      // For repeater, if data has grouping, fields has aggregated function must be unsorted
      // Need check more conditions cause isAggregatedField propeties not correct.
      if ((0, _fp.get)('hasGroupingData', (0, _fp.head)(repeaterNodes))) {
        return !field.functionInfo.userDefined && field.isAggregatedField && (0, _fp.get)('functionInfo.name', field) !== _Izenda26.FUNCTION.DAYS_OLD.NAME;
      }

      return false;
    }

    /**
     * Check repeater has support unsort value
     * @param {Object} repeaterNode
     */

  }, {
    key: 'checkRepeaterHasSupportUnsort',
    value: function checkRepeaterHasSupportUnsort(repeaterNode) {
      // If no repeater.
      if ((0, _fp.isNil)(repeaterNode) || repeaterNode.level === 0 && repeaterNode.hasSupportUnsort) {
        return true;
      }
      var supportUnsortLastLevel = repeaterNode.hasSupportUnsort && (0, _fp.get)('validSubtotalSmartTag.length', repeaterNode) === 0;
      return (0, _fp.get)('hasGroupingData', (0, _fp.head)(this.repeaterNodes)) ? (0, _fp.get)('allFieldIsNotGroupingData', (0, _fp.head)(this.repeaterNodes)) ? supportUnsortLastLevel : false : supportUnsortLastLevel;
    }

    /**
     * Check field can have unsort value on propeties panel.
     * @param {Object} container
     * @param {Object} reportPartElement
     */

  }, {
    key: 'checkCanUnsort',
    value: function checkCanUnsort(container, reportPartElement) {
      var repeaterNode = this.foundRepeaternode(reportPartElement.fieldNameAlias, this.repeaterNodes);

      return this.checkRepeaterHasSupportUnsort(repeaterNode);
    }
  }, {
    key: 'optionalParams',
    get: function get() {
      if (this.properties.usePagination) {
        return {
          expandedLevel: _Izenda12.default.EXPANDED_LEVEL.ALL,
          paging: { pageIndex: _Izenda12.default.DEFAULT_PAGE_INDEX, pageSize: this.properties.pageSize }
        };
      } else {
        return {};
      }
    }
  }, {
    key: 'reportPartStyle',
    get: function get() {
      return this.type;
    }
  }, {
    key: 'allVisibleElements',
    get: function get() {
      return this.columns.visibleElement.concat(this.separators.visibleElement);
    }
  }, {
    key: 'containerCollection',
    get: function get() {
      return (0, _fp.compact)([this.columns, this.separators]);
    }
  }, {
    key: 'isBeingBuild',
    get: function get() {
      return !(0, _fp.isEmpty)(this.allVisibleElements);
    }
  }, {
    key: 'dataRefreshInterval',
    get: function get() {
      return (0, _fp.get)('dataRefreshInterval', this.properties);
    }
  }]);
  return ReportPartForm;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isCrossFiltering', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda12.default.REPORT_PART_TYPE.Form;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'editorControl', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'activeTabKey', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'isSelectedCell', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'isActiveForEdit', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'properties', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      format: {
        heading: { h1: false, h2: false, h3: false, h4: false, h5: false, h6: false },
        block: { p: true, blockquote: false, div: false, pre: false },
        font: {
          bold: false,
          italic: false,
          underline: false,
          strikethrough: false,
          superscript: false,
          subscript: false,
          code: false,
          fontFamily: _Izenda24.default.defaultFontFamily,
          fontSize: _Izenda24.default.defaultFontSize,
          textColor: _Izenda24.default.textColor,
          backgroundColor: _Izenda24.default.backgroundColor
        },
        alignment: { alignleft: false, aligncenter: false, alignright: false, alignjustify: false },
        list: { bullet: '', numbered: '' }
      },
      pasteAsText: false,
      highlightCode: true,
      wrapText: true,
      mceDirectionRTL: false,
      mceDirectionLTR: false,
      mceVisualChars: false,
      mceToggleVisualAid: true,
      usePagination: true,
      pageSize: _Izenda12.default.DEFAULT_PAGE_SIZE,
      pageBreakAfterEachEntry: false,
      dataRefreshInterval: { enable: false, updateInterval: 0, isAll: true, latestRecord: 0 }
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'columns', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'separators', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'optionalParams', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'optionalParams'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reportPartStyle', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reportPartStyle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'allVisibleElements', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'allVisibleElements'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'containerCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'containerCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isBeingBuild', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isBeingBuild'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'dataRefreshInterval', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'dataRefreshInterval'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateSubtotalLevels', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateSubtotalLevels'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clearSubtotalLevels', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clearSubtotalLevels'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterChangeSide', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterChangeSide'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'buildRepeaterTree', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'buildRepeaterTree'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'rebuildHTMLContent', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'rebuildHTMLContent'), _class2.prototype), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'updateElementPropsForRepeater', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return (0, _fp.debounce)(1000, function () {
      _this3.buildRepeaterTree(false);
    });
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'insertEmbeddedReportHtml', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'insertEmbeddedReportHtml'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateEmbeddedReportHtml', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateEmbeddedReportHtml'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateSubTotalHtml', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateSubTotalHtml'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateGrandTotalHtml', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateGrandTotalHtml'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateContainerField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateContainerField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetBorderDefaultValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetBorderDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetRefreshIntervalValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetRefreshIntervalValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'rearrangeFieldInColumnContainer', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'rearrangeFieldInColumnContainer'), _class2.prototype)), _class2)) || _class;

exports.default = ReportPartForm;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(207);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'report/'; // ----------------------------------------------------------------------
// <copyright file="Izenda.UserAccountDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var fetchers = {
  /**
   * Load report
   * @param  {string} tenantId
   * @returns {Promise}
   */
  getReports: function getReports(tenantId) {
    var url = ROOT_URL + 'reportsByTenant/';
    return (0, _Izenda2.default)((0, _fp.isNil)(tenantId) ? url : url + tenantId).get();
  },


  /**
   * Validate embedded report
   * @param  {string} tenantId
   * @param  {string} reportId
   * @param  {string} reportName
   * @param  {string} reportPartName
   * @returns {Promise}
   */
  validateEmbeddedReport: function validateEmbeddedReport(tenantId, reportId, reportName, reportPartName) {
    var url = ROOT_URL + 'validateEmbeddedReport/';
    !(0, _fp.isNil)(tenantId) && (url += tenantId);
    url = url + '?reportId=' + reportId + '&reportName=' + encodeURIComponent(reportName) + '&reportPartName=' + encodeURIComponent(reportPartName);
    return (0, _Izenda2.default)(url).get();
  }
};

_Izenda4.default.linkToLoadingProgress(fetchers);

exports.default = fetchers;
module.exports = exports['default'];

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormEmbeddedReport.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(599);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(53);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ReportPartFormEmbeddedReport = (_class = function () {
  function ReportPartFormEmbeddedReport() {
    (0, _classCallCheck3.default)(this, ReportPartFormEmbeddedReport);
  }

  (0, _createClass3.default)(ReportPartFormEmbeddedReport, [{
    key: 'insertEmbeddedReportHtml',
    value: function insertEmbeddedReportHtml(data, editorControl) {
      var _data$selectedReport = data.selectedReport,
          id = _data$selectedReport.id,
          name = _data$selectedReport.name;

      var embedReportHtml = (0, _fp.chain)(data.selectedReport.selectedReportParts).map(function (reportPart) {
        return '<embedded-report id="' + id + '" class="field-wrapper" data-width="' + reportPart.width * _Izenda4.default.BODY_CELL_WIDTH + '" data-height="' + reportPart.height * _Izenda4.default.BODY_CELL_HEIGHT + '"><span class="icon-attached"></span>' + name + '/' + reportPart.title + '</embedded-report>';
      }).join('').value();

      editorControl.insertContent(embedReportHtml);
    }

    /**
     * Update Embedded Report HTML
     * @param  {Array} List data of report part object
     */

  }, {
    key: 'updateEmbeddedReportHtml',
    value: function updateEmbeddedReportHtml(embeddedReportDOM, model) {
      this.insertEmbeddedReportHtml(model);
    }

    /**
     * Get embedded report html
     * @param {String} html
     * @returns {Object} { htmlContent, embeddedReports }
     */

  }, {
    key: 'generateEmbeddedReport',
    value: function generateEmbeddedReport(embeddeReportData, htmlContent) {
      var _this = this;

      var embeddedReportDoms = $izenda('<div>' + htmlContent + '</div>').find('embedded-report').toArray();
      var embeddedReports = [];

      return (0, _bluebird.each)(embeddedReportDoms, function (er, index) {
        var emId = $izenda(er).attr('id');
        var emContent = $izenda(er).text();
        if ($izenda(er).html()) {
          var matches = $izenda(er).html().match(/(<\/span>)(.+)/);
          (0, _fp.isArray)(matches) && (emContent = matches.pop());
        }
        return _Izenda2.default.validateEmbeddedReport(emId, emContent, embeddeReportData).then(function (result) {
          var data = $izenda(er).data();
          var width = data.width;
          var height = data.height;
          var embeddedReportHtml = $izenda(er).get(0).outerHTML;

          if ((0, _fp.isObject)(result)) {
            var reportPartObject = _this.getSubReportObject(result, index);
            reportPartObject.width = width;
            reportPartObject.height = height;
            reportPartObject.index = htmlContent.indexOf(embeddedReportHtml);

            var divText = '<div class="u_fullWidth ' + reportPartObject.reportPartDomId + '"></div>';
            embeddedReports.push(reportPartObject);

            htmlContent = htmlContent.replace(embeddedReportHtml, divText);
          } else {
            htmlContent = htmlContent.replace(embeddedReportHtml, result);
          }
        });
      }).then(function () {
        return {
          htmlContent: htmlContent,
          embeddedReports: embeddedReports
        };
      });
    }

    /**
     * Get subReport object for embedded ReportPart
     * @return {Object} subReportObject
     */

  }, {
    key: 'getSubReportObject',
    value: function getSubReportObject(result, index) {
      var embeddedReportPartId = ['EmbededReportPart', index, result.reportPartId, (0, _fp.uniqueId)('_subreport')].join('_');

      return {
        id: result.reportPartId,
        reportPartDomId: embeddedReportPartId
      };
    }
  }]);
  return ReportPartFormEmbeddedReport;
}(), (_applyDecoratedDescriptor(_class.prototype, 'insertEmbeddedReportHtml', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'insertEmbeddedReportHtml'), _class.prototype)), _class);
exports.default = ReportPartFormEmbeddedReport;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(600);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1120);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1121);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(271);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(164);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(35);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getValueFromMappingField = _Izenda10.default.getValueFromMappingField;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormRepeater.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var DEFAULT_DATA = '[##DEFAULT_DATA##]';
var SUBTOTAL_START = _Izenda8.default.SUBTOTAL_START;
var SUBTOTAL_END = _Izenda8.default.SUBTOTAL_END;

var ReportPartFormRepeater = function () {
  function ReportPartFormRepeater() {
    (0, _classCallCheck3.default)(this, ReportPartFormRepeater);
  }

  (0, _createClass3.default)(ReportPartFormRepeater, [{
    key: 'findAll',

    /**
     * Find all
     * @param  {String} string
     * @param  {String} sub string
     * @param  {Number} start
     * @param  {Object} source
     * @return {Object}
     */
    value: function findAll(string, subString, start, source) {
      if (!string || !string.length) {
        return source;
      }

      source = source || {};
      start = start || 0;

      var index = string.indexOf(subString, start);

      if (index < 0) {
        return source;
      }

      source[index] = subString;

      return this.findAll(string, subString, index + subString.length, source);
    }

    /**
     * create place holder for each pattern
     * it should have complicated structure to separate from user template
     * @param  {String} key
     * @return {String} [#&@YOUR_KEY@&#]
     */

  }, {
    key: 'createPlaceHolder',
    value: function createPlaceHolder(key) {
      return String.format('[#&@{0}@&#]', key);
    }

    /**
     * Get repated pattern, first level only
     * @param  {String} pattern
     * @return {Object}
     */

  }, {
    key: 'getRepeaterPattern',
    value: function getRepeaterPattern(pattern) {
      var _this = this;

      var beginTags = {};
      var endTags = {};
      var tagOrder = [];
      var structure = [];
      var temp = [];
      var val = void 0,
          popVal = void 0;

      // 1. find of begin/end tag of repeater
      this.findAll(pattern, _Izenda8.default.REPEATER_START, 0, beginTags);
      this.findAll(pattern, _Izenda8.default.REPEATER_START_FORTABLE, 0, beginTags);

      this.findAll(pattern, _Izenda8.default.REPEATER_END, 0, endTags);
      this.findAll(pattern, _Izenda8.default.REPEATER_END_FORTABLE, 0, endTags);

      tagOrder = (0, _fp.concat)((0, _fp.keys)(beginTags), (0, _fp.keys)(endTags));
      tagOrder = (0, _fp.flow)((0, _fp.map)(_fp.toNumber), (0, _fp.sortBy)(_fp.identity))(tagOrder);

      // 2. find position of repeater (first level only)
      temp.push((0, _fp.head)(tagOrder));
      for (var i = 1; i < tagOrder.length; i++) {
        val = tagOrder[i];
        if (isBeginTag(val)) {
          temp.push(val);
        } else {
          popVal = temp.pop();
          temp.length === 0 && structure.push([popVal, val]);
        }
      }

      // 3. get pattern of each repeated-section
      var childPattern = (0, _fp.map)(function (pair) {
        var start = pair[0];
        var end = pair[1];
        return {
          placeHolderKey: _this.createPlaceHolder([start, end].join('')),
          pattern: pattern.substring(start + (0, _fp.size)(beginTags[start]), end),
          start: start,
          end: end
        };
      }, structure);

      // 4. create placeholder for each pattern
      var newPattern = pattern;
      (0, _fp.forEach)(function (item) {
        newPattern = newPattern.replace(beginTags[item.start] + item.pattern + endTags[item.end], item.placeHolderKey);
      }, childPattern);

      return {
        placeHolderPattern: newPattern,
        repeaterParts: childPattern
      };

      function isBeginTag(indexId) {
        return (0, _fp.has)(indexId, beginTags);
      }
    }

    /**
     * Group data by field array
     * @param  {Array} fields]
     * @param  {Array} records
     * @param  {} groupNames
     * @return {Object}
     */

  }, {
    key: 'groupData',
    value: function groupData(fields, records) {
      var groupNamesArr = [];
      var groupNamesObj = {};
      var groupName = void 0;
      var getGroupName = function getGroupName(record) {
        var vals = (0, _fp.map)(function (field) {
          return getValueFromMappingField(field.fieldInfo, record) || DEFAULT_DATA;
        }, fields);

        return vals.join('_');
      };

      var groupedData = (0, _fp.groupBy)(function (record) {
        groupName = getGroupName(record);

        if (!(0, _fp.has)(groupName, groupNamesObj)) {
          groupNamesObj[groupName] = true;
          groupNamesArr.push(groupName);
        }

        return groupName;
      }, records);

      return (0, _fp.map)(function (groupName) {
        return groupedData[groupName];
      }, groupNamesArr);
    }

    /**
     * Find and search all fields in pattern and replace by a placeholder
     * @param  {String} pattern
     * @param  {Array} mappingFields
     * @param  {Number} level of repeater contain fields
     * @return {Object}
     */

  }, {
    key: 'getFields',
    value: function getFields(pattern, mappingFields, repeaterLevel) {
      var _this2 = this;

      var listFields = [];

      var $patternHtml = $izenda('<div>' + pattern + '</div>');
      var fields = $patternHtml.find('field');
      fields.each(function (index, field) {
        var fieldName = (0, _fp.trim)($izenda(field).text());
        var fieldInfo = (0, _fp.find)({ fieldNameAlias: fieldName }, mappingFields);
        var placeHolderKey = _this2.createPlaceHolder(fieldName);

        if (!fieldInfo) {
          return field;
        }
        fieldInfo.setRepeaterLevel && fieldInfo.setRepeaterLevel(repeaterLevel);
        listFields.push({
          placeHolderKey: placeHolderKey,
          fieldInfo: fieldInfo
        });

        var fieldLength = (0, _fp.head)($izenda(field)).outerHTML.length;
        var beginTagIndex = pattern.indexOf('<field');
        if (beginTagIndex >= 0) {
          var fieldContent = pattern.substr(beginTagIndex, fieldLength);
          pattern = pattern.replace(fieldContent, placeHolderKey);
        }
      });

      return {
        fields: listFields,
        pattern: pattern
      };
    }

    /**
     * Get sub-totals data
     * @param {String} pattern
     * @param {Array} fields
     * @returns {Object} sub-total data
     */

  }, {
    key: 'getSubTotals',
    value: function getSubTotals(pattern, fields) {
      var _this3 = this;

      var $patternHtml = $izenda('<div>' + pattern + '</div>');
      var $subTotals = $patternHtml.find('subtotal');
      var subTotals = [];

      $subTotals.each(function (index, subTotal) {
        var subTotalAlias = (0, _fp.trim)(subTotal.textContent);
        var groupFieldLevel = (0, _fp.getOr)('', 'fieldInfo.fieldNameAlias', (0, _fp.last)(fields));
        var placeHolderKey = _this3.createPlaceHolder(SUBTOTAL_START + subTotalAlias + SUBTOTAL_END);

        var subTotalLength = subTotal.outerHTML.length;
        var beginTagIndex = pattern.indexOf('<subtotal');
        if (beginTagIndex >= 0) {
          var subTotalContent = pattern.substr(beginTagIndex, subTotalLength);
          pattern = pattern.replace(subTotalContent, placeHolderKey);
        }

        subTotals.push({
          placeHolderKey: placeHolderKey,
          groupFieldLevel: groupFieldLevel,
          subTotalAlias: subTotalAlias
        });
      });

      return {
        subTotals: subTotals,
        pattern: pattern
      };
    }

    /**
     * Get outer data of repeater
     * @param {String} pattern
     * @param {Object} mappingFields
     * @param {Number} repeaterLevel
     * @returns {Object} outer data of repeater
     */

  }, {
    key: 'getOuterDataOfRepeater',
    value: function getOuterDataOfRepeater(pattern, mappingFields, repeaterFields) {
      var fieldData = this.getFields(pattern, mappingFields);
      repeaterFields = repeaterFields.concat(fieldData.fields);

      var subTotalData = this.getSubTotals(fieldData.pattern, repeaterFields);

      return {
        fields: fieldData.fields,
        subTotals: subTotalData.subTotals,
        pattern: subTotalData.pattern,
        repeaterFields: repeaterFields
      };
    }

    /**
     * Build smart tag configs by subtotal doms.
     * @param {Array} subTotalDoms
     * @param {number} level
     * @return{Array}
     */

  }, {
    key: 'buildSmartTagInContentRepeater',
    value: function buildSmartTagInContentRepeater(subTotalDoms, level) {
      return (0, _fp.flow)((0, _fp.map)(function (subTotalDom) {
        return new _Izenda4.default({
          name: (0, _fp.trim)(subTotalDom.textContent),
          type: 'subTotal',
          repeaterLevel: level,
          configField: {},
          subTotalDom: subTotalDom
        });
      }), _fp.compact)(subTotalDoms);
    }

    /**
     * Process subtotal smart tag.
     * @param {Array} smartTagInContent
     * @param {Array} fieldsMapping
     * @return{Array}
     */

  }, {
    key: 'processSubTotal',
    value: function processSubTotal(smartTagInContent, fieldsMapping) {
      var fieldSupportSubtotal = [];
      (0, _fp.forEach)(function (subTotal) {
        var field = (0, _fp.find)(['name', subTotal.name], fieldsMapping);
        if (field) {
          fieldSupportSubtotal.push({ fieldInfo: field });
          subTotal.configField = { fieldInfo: field };
        }
      }, smartTagInContent);
      return fieldSupportSubtotal;
    }

    /**
     * Parse user template in to HTML string
     * @param  {String} pattern
     * @param  {Object} previewData
     * @return {String}
     */

  }, {
    key: 'buildRepeaterTree',
    value: function buildRepeaterTree(pattern, fieldsMapping) {
      var _this4 = this;

      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var repeaterNodes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      try {
        var repeatedPattern = this.getRepeaterPattern(pattern);
        var fields = this.getFields((0, _fp.get)('placeHolderPattern', repeatedPattern), fieldsMapping, level);

        var hasRepeatPart = !(0, _fp.flow)((0, _fp.get)('repeaterParts'), _fp.isEmpty)(repeatedPattern);

        // get smart tag on this
        var subTotalDoms = void 0;
        try {
          subTotalDoms = $izenda('<div>' + repeatedPattern.placeHolderPattern + '</div>').find('subtotal');
        } catch (e) {}
        // do nothing


        // get field smart tag
        var smartTagInContent = this.buildSmartTagInContentRepeater(subTotalDoms, level);
        var fieldSupportSubtotal = this.processSubTotal(smartTagInContent, fieldsMapping);

        var repeaterNode = new _Izenda2.default({
          childNodes: [],
          level: level,
          fields: (0, _fp.get)('fields', fields),
          smartTagInContent: smartTagInContent,
          fieldSupportSubtotal: fieldSupportSubtotal,
          placeHolderPattern: (0, _fp.get)('placeHolderPattern', repeatedPattern),
          placeHolderKey: (0, _fp.map)(function (item) {
            return item.placeHolderKey;
          }, repeatedPattern.repeaterParts),
          pattern: (0, _fp.map)(function (item) {
            return item.pattern;
          }, repeatedPattern.repeaterParts)
        });

        repeaterNodes.push(repeaterNode);

        if (!hasRepeatPart) {
          return;
        }

        (0, _fp.forEach)(function (repeatPart) {
          _this4.buildRepeaterTree(repeatPart.pattern, fieldsMapping, level + 1, repeaterNode.childNodes);
        }, repeatedPattern.repeaterParts);
      } catch (e) {
        // do nothing
      }
    }

    /**
     * Build HTML to array of repeater and its fields
     * @param  {String} pattern
     * @param  {Object} previewData
     * @return {String}
     */

  }, {
    key: 'generateData',
    value: function generateData(pattern, previewData, visibleElement, reportPart, reportId, embeddedSubReports, overideFilterValue, subTotalMapping) {
      var _this5 = this;

      var repeaterFields = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];

      try {
        var repeatedPattern = this.getRepeaterPattern(pattern);
        var outerData = this.getOuterDataOfRepeater((0, _fp.get)('placeHolderPattern', repeatedPattern), previewData.fieldsMapping, repeaterFields);

        var hasRepeatPart = (0, _fp.flow)((0, _fp.get)('repeaterParts'), _fp.size)(repeatedPattern) > 0;

        var groupedData = hasRepeatPart ? this.groupData(outerData.fields, previewData.records) : previewData.records;

        // generic data
        var htmlContent = (0, _fp.map)(function (groupRecords) {
          var outerContent = _this5.parseData(outerData, hasRepeatPart ? (0, _fp.head)(groupRecords) : groupRecords, visibleElement, reportPart, reportId, previewData.fieldsMapping, embeddedSubReports, overideFilterValue, subTotalMapping);
          var innerContent = '';

          if (hasRepeatPart) {
            (0, _fp.forEach)(function (repeatPart) {
              innerContent = _this5.generateData(repeatPart.pattern, { records: groupRecords, fieldsMapping: previewData.fieldsMapping }, visibleElement, reportPart, reportId, embeddedSubReports, overideFilterValue, subTotalMapping, outerData.repeaterFields);

              outerContent = outerContent.replace(repeatPart.placeHolderKey, innerContent);
              innerContent = '';
            }, repeatedPattern.repeaterParts);
          }

          return outerContent.indexOf('<tr') >= 0 ? outerContent : outerContent + '<br />';
        }, groupedData);

        return htmlContent.join('');
      } catch (e) {
        return '<h1>FAIL</h1>';
      }
    }

    /**
     * Replace field by its real data and apply style also
     * @param  {String} pattern
     * @param  {Array} fields
     * @param  {Object} record
     * @return {String}
     */

  }, {
    key: 'parseData',
    value: function parseData(_ref, record, visibleElement, reportPart, reportId, fieldsMapping, embeddedSubReports, overideFilterValue, subTotalMapping) {
      var pattern = _ref.pattern,
          fields = _ref.fields,
          subTotals = _ref.subTotals;

      var reportPartFormField = new _Izenda6.default();

      // Iterates over fields and replace its data by placeholder
      fields.forEach(function (field) {
        var columnName = (0, _fp.get)('columnName', field.fieldInfo);
        var val = (0, _fp.get)(columnName, record);

        var fieldInfo = (0, _fp.find)({ fieldName: field.fieldInfo.fieldNameAlias }, visibleElement) || {};
        if (!(0, _fp.isEmpty)(fieldInfo)) {
          // this index must match the index position of record in array list
          var recordIndex = (0, _fp.findIndex)(function (testRecord) {
            return testRecord === record;
          }, reportPart.previewDataRecords);

          var data = reportPartFormField.formatField({
            reportPartElm: fieldInfo,
            columnName: columnName
          }, val, reportId, recordIndex, reportPart, record, fieldsMapping, overideFilterValue);
          if (data.embeddedSubReports.length > 0) {
            embeddedSubReports.data = embeddedSubReports.data.concat(data.embeddedSubReports);
          }

          pattern = pattern.replace(field.placeHolderKey, data.newText);
        } else {
          pattern = pattern.replace(field.placeHolderKey, '');
        }
      });

      // Iterates over subtotals and replace its data by placeholder
      subTotals.forEach(function (_ref2) {
        var placeHolderKey = _ref2.placeHolderKey,
            subTotalAlias = _ref2.subTotalAlias,
            groupFieldLevel = _ref2.groupFieldLevel;

        var columnName = (0, _fp.flow)((0, _fp.find)((0, _extends3.default)({
          fieldNameAlias: subTotalAlias
        }, !(0, _fp.isEmpty)(groupFieldLevel) && { groupFieldLevel: groupFieldLevel })), (0, _fp.get)('columnName'))(subTotalMapping);

        var fieldElement = (0, _fp.find)({ fieldName: subTotalAlias }, visibleElement);
        var dataType = (0, _fp.get)('properties.dataFormattings.subTotal.dataType', fieldElement);
        var subTotalFormat = (0, _fp.get)('properties.dataFormattings.subTotal.format', fieldElement);
        var subTotalValue = subTotalFormat && _Izenda12.default.applyFormater(dataType, subTotalFormat.format, record[columnName]);

        pattern = pattern.replace(placeHolderKey, subTotalValue);
      });

      return pattern;
    }
  }]);
  return ReportPartFormRepeater;
}();

exports.default = ReportPartFormRepeater;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(966);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(181);

var _Izenda5 = _interopRequireDefault(_Izenda4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Default chart configuration */
_Izenda5.default.setConfiguration(_Izenda3.REPORT_PART_TYPE.Grid, {
  /**
   * Report part content model class
   */
  model: _Izenda2.default
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultGridConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(2093);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2094);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2095);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2096);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2097);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2098);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(16);

var _Izenda14 = __webpack_require__(598);

var _fp = __webpack_require__(1);

var _Izenda15 = __webpack_require__(181);

var _Izenda16 = _interopRequireDefault(_Izenda15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Default chart configuration */

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultGaugeConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
_Izenda16.default.setConfiguration(_Izenda13.REPORT_PART_TYPE.Gauge, {
  /**
   * Visualization engine name
   */
  visualEngine: 'Highchart',

  /**
   * Label of visualization, normally showing in chart type dropdown
   */
  visualLabel: null,

  /**
   * A CSS class to show preview image of the visualization, normally showing when hovering a chart dropdown item
   */
  visualPreviewCSS: null,

  /**
   * Type of visualization, e.g. chart type in Highcharts
   */
  visualType: null,

  /**
   * Report part content model class
   */
  model: _Izenda12.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _fp.constant)({
    chart_title: true
  })],

  /**
   * The object contains the property editor widget component
   */
  propertyWidgets: _Izenda8.default,

  /**
   * The object contains defined schema of property editor GUI
   */
  propertySchema: _Izenda2.default,

  /**
   * The function to create the mapping properties
   */
  propertyMappingProps: _Izenda4.default,

  /**
   * The function to create the mapping source
   */
  propertyMappingSource: _Izenda6.default,

  /**
   * The function to create an value changed handler
   */
  propertyValueChange: _Izenda10.default,

  optionsMapping: {
    /**
     * The object containts common options mapping
     */
    commonOptions: _Izenda14.COMMON_OPTIONS,

    /**
     * The object contains options by type mapping
     */
    optionsByType: {},

    /**
     * The object contains the threshold options mapping
     */
    thresholdOptions: _Izenda14.THRESHOLDS_LINE,

    /**
     * The object contains the axis options mapping
     */
    axisOptions: _Izenda14.AXIS_OPTIONS
  }
});

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _fields;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultGaugePropsDefinedSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(305);

var _Izenda2 = __webpack_require__(33);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(175);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = __webpack_require__(39);

var _Izenda7 = __webpack_require__(12);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(595);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(323);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHART_KEY = _Izenda6.CHART_SCHEMA_NAMES.CHART_KEY,
    GROUPS = _Izenda6.CHART_SCHEMA_NAMES.GROUPS,
    FIELDS = _Izenda6.CHART_SCHEMA_NAMES.FIELDS;


var getChartTypeOptions = function getChartTypeOptions() {
  return (0, _Izenda4.getAll)(_Izenda5.REPORT_PART_TYPE.Gauge).map(function (_ref) {
    var label = _ref.label,
        style = _ref.style,
        previewCSS = _ref.previewCSS;
    return {
      label: label,
      value: style,
      className: previewCSS
    };
  });
};

/**
 * The common chart properties GUI schema that shares to all gauge type.
 */
exports.default = {
  schemaKey: 'RP_GAUGE_TYPE',
  groups: {
    generalInfo: {
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_GENERAL_INFO');
      },
      fields: {
        chartType: {
          factory: _Izenda.createDropDownSchema,
          title: function title() {
            return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_GAUGE_TYPE');
          },
          value: 'getChartType',
          props: {
            get options() {
              return getChartTypeOptions();
            }
          }
        }
      }
    },
    gauge: {
      title: function title() {
        return _Izenda8.default.getText('COMMON_LABEL_GAUGE');
      },
      isHidden: 'isNotBuild',
      hiddenByState: true,
      fields: {
        izBorder: {
          factory: _Izenda.createPopupSettingSchema,
          title: function title() {
            return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_BORDER');
          },
          value: 'getBorder',
          props: {
            get reportPartType() {
              return _Izenda5.REPORT_PART_TYPE.Gauge;
            },
            get title() {
              return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_GAUGE_BORDER_SETTINGS');
            },
            hiddenByState: true,
            allChartProps: 'getAllChartProps',
            hadSetting: 'hadSettingBorder',
            fnResetDefaultValue: 'fnResetBorderDefaultValue',
            loadValue: 'getSettingBorder'
          },
          staticProps: {
            get popupTitle() {
              return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_GAUGE_BORDER_SETTINGS');
            },
            popupContent: _Izenda10.default
          }
        },
        // Intervals: number input
        izIntervals: {
          factory: _Izenda.createNumberSchema,
          title: function title() {
            return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_INTERVALS');
          },
          info: function info() {
            return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_INTERVAL_OF_TICK');
          },
          isHidden: 'hideByChartType',
          value: 'getValueByKey'
        },
        colorTheme: {
          factory: _Izenda.createColorPaletteSettingSchema,
          title: function title() {
            return _Izenda8.default.getText('COMMON_LABEL_COLOR_THEME');
          },
          value: 'getColorTheme',
          props: {
            get selectionPopupTitle() {
              return _Izenda8.default.getText('COLORTHEME_POPUP_HEADER');
            },
            get defaultColorThemeLabel() {
              return _Izenda8.default.getText('COLORPALETTE_NOTHEME');
            },
            displaySettingStatus: true,
            needMaskDefault: false,
            defaultColorPalette: null,
            hiddenByState: true
          }
        }
      }
    },
    grouping: {
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_GROUPING');
      },
      isHidden: 'isNotBuild',
      className: 'getClassNameByChartStatus',
      fields: {
        izUseSeparator: {
          factory: _Izenda.createCheckBoxSchema,
          title: function title() {
            return _Izenda8.default.getText('COMMON_LABEL_USE_SEPARATOR');
          },
          value: 'getValueByKey'
        }
      }
    },
    view: {
      title: function title() {
        return _Izenda8.default.getText('MODEL_LABEL_VIEW');
      },
      isHidden: 'isNotBuild',
      fields: (_fields = {
        showLabels: {
          factory: _Izenda.createCheckBoxSchema,
          title: function title() {
            return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_SHOW_LABEL');
          },
          value: 'getValueByKey'
        },
        izInverted: {
          factory: _Izenda.createCheckBoxSchema,
          title: function title() {
            return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_INVERTED');
          },
          isHidden: 'hideByChartType',
          value: 'getValueByKey'
        }
      }, (0, _defineProperty3.default)(_fields, 'izInverted', {
        factory: _Izenda.createCheckBoxSchema,
        title: function title() {
          return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_INVERTED');
        },
        isHidden: 'hideByChartType',
        value: 'getValueByKey'
      }), (0, _defineProperty3.default)(_fields, 'dataRefreshInterval', {
        factory: _Izenda.createPopupSettingSchema,
        title: function title() {
          return _Izenda8.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
        },
        value: 'getValueByKey',
        props: {
          get reportPartType() {
            return _Izenda5.REPORT_PART_TYPE.Gauge;
          },
          get title() {
            return _Izenda8.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
          },
          hadSetting: 'hadSettingRefreshInterval',
          fnResetDefaultValue: 'fnResetRefreshIntervalDefaultValue',
          hiddenByState: true,
          loadValue: 'getSettingRefreshInterval'
        },
        staticProps: {
          get popupTitle() {
            return _Izenda8.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
          },
          popupContent: _Izenda12.default,
          popupProps: {
            type: 'none',
            autoClose: false
          }
        }
      }), (0, _defineProperty3.default)(_fields, 'izUsePagination', {
        factory: _Izenda.createCheckBoxSchema,
        title: function title() {
          return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_USE_PAGINATION');
        },
        value: 'getValueByKey'
      }), (0, _defineProperty3.default)(_fields, 'izItemPerRow', {
        factory: _Izenda.createNumberSchema,
        title: function title() {
          return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_USE_PAGINATION_ITEM_PER_ROW');
        },
        value: 'getValueByKey',
        props: {
          min: 1,
          max: 20,
          isDecimal: false
        }
      }), _fields)
    },
    printing: {
      title: function title() {
        return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_PRINTING');
      },
      isHidden: 'isNotBuild',
      fields: {
        izPageBreakAfterSeparator: {
          factory: _Izenda.createCheckBoxSchema,
          title: function title() {
            return _Izenda8.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_PAGE_BREAK_AFTER_SEPARATOR');
          },
          value: 'getValueByKey'
        }
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(221);

var _Izenda2 = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultGaugePropsMappingProps.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
exports.default = function (reportPartDetails, fieldStore) {
  var reportPartContent = reportPartDetails.reportPartContent || {};

  var getProperties = function getProperties(key) {
    if (!key) {
      var properties = reportPartDetails && reportPartDetails.getReportPartProperties();
      var props = (0, _mobx.toJS)(properties);
      return props;
    }

    return reportPartContent.getReportPartProperties(key);
  };

  return {
    getAllChartProps: function getAllChartProps() {
      var gaugeProperties = getProperties();
      return {
        chartOptions: (0, _extends3.default)({}, gaugeProperties, {
          colors: reportPartDetails.getThemeColors(gaugeProperties)
        }),
        seriesOptions: reportPartDetails.fieldCollection,
        chartData: (0, _Izenda2.parser)(reportPartContent.activeElmsByContainers, reportPartDetails.expandedLevel, {
          fieldsMapping: reportPartDetails.previewDataFieldsMapping,
          records: reportPartDetails.previewDataRecords,
          rawData: reportPartDetails.previewData
        })
      };
    },
    getSettingBorder: function getSettingBorder() {
      return {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };
    },
    hadSettingBorder: function hadSettingBorder() {
      var currentSetting = {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };

      return !((0, _fp.isEqual)(currentSetting, _Izenda.DEFAULT_SETTING_VALUE.borderDefault) || (0, _fp.isEqual)(currentSetting, _Izenda.DEFAULT_SETTING_VALUE.borderNew));
    },
    getSettingRefreshInterval: function getSettingRefreshInterval() {
      return getProperties('dataRefreshInterval');
    },
    hadSettingRefreshInterval: function hadSettingRefreshInterval() {
      var tempProp = getProperties();
      var defaultSetting = _Izenda.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
      var refreshSetting = getProperties('dataRefreshInterval');

      return refreshSetting.value !== defaultSetting.value || refreshSetting.updateInterval !== defaultSetting.updateInterval;
    },
    getColorTheme: function getColorTheme() {
      var properties = getProperties() || {};
      return {
        colorPalette: properties.colorTheme,
        isDefaultTheme: properties.isDefaultTheme
      };
    },


    fnResetBorderDefaultValue: reportPartContent.resetBorderDefaultValue.bind(reportPartContent),
    fnResetRefreshIntervalDefaultValue: reportPartContent.resetRefreshIntervalValue.bind(reportPartContent)
  };
};

module.exports = exports['default'];

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartPropsMappingSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = function (reportPartDetails, fieldStore) {
  var reportPartContent = reportPartDetails.reportPartContent || {};

  var getProperties = function getProperties(key) {
    if (!key) {
      var properties = reportPartDetails && reportPartDetails.getReportPartProperties();
      var props = (0, _mobx.toJS)(properties);
      return props;
    }

    return reportPartContent.getReportPartProperties(key);
  };

  return {
    hideByChartType: function hideByChartType(optName) {
      return !(0, _fp.has)(optName, reportPartContent.defaultOptionsByType);
    },
    isNotBuild: function isNotBuild() {
      return !reportPartContent.isBeingBuild;
    },
    isBeingBuild: function isBeingBuild() {
      return reportPartContent.isBeingBuild;
    },
    getClassNameByChartStatus: function getClassNameByChartStatus() {
      return reportPartContent.isBeingBuild ? 'chart-being-build' : 'chart-not-build';
    },
    getChartType: function getChartType() {
      return reportPartContent.chartType;
    },
    getBorder: function getBorder() {
      return {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };
    },


    getValueByKey: getProperties
  };
};

module.exports = exports['default'];

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(28);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(579);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(423);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Panel: _Izenda2.default,
  CustomDropdown: _Izenda4.default,
  ColorPaletteSetting: _Izenda6.default
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartPropsWidget.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultGaugePropsOnChangeValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
exports.default = function (reportPartDetails, fieldStore) {
  return (0, _mobx.action)('OnChangeGaugeProps', function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, derivedChange) {
    var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
    var fieldData = groupData[changedKey];

    fieldData && (fieldData.value = changedValue);

    var reportPartContent = reportPartDetails.reportPartContent || {};
    var generalInfo = (0, _fp.getOr)({}, 'generalInfo', schemaData);
    var grouping = (0, _fp.getOr)({}, 'grouping', schemaData);
    var izBorder = getValue('gauge.izBorder', schemaData) || {};
    var view = (0, _fp.getOr)({}, 'view', schemaData);
    var dataRefreshInterval = getValue('dataRefreshInterval', view) || {};
    var colorTheme = getValue('gauge.colorTheme', schemaData);

    /* printing section*/
    var printing = schemaData.printing;
    var izPageBreakAfterSeparator = printing.izPageBreakAfterSeparator.value;

    var chartProperties = {
      chartType: getValue('chartType', generalInfo),
      colorTheme: colorTheme.colorPalette,
      isDefaultTheme: colorTheme.isDefaultTheme,
      commonOptions: {
        /* border */
        'izEntire.borderColor': izBorder['izEntire.borderColor'],
        'izEntire.borderWidth': izBorder['izEntire.borderWidth'],
        'izEntire.borderStyle': izBorder['izEntire.borderStyle']
      },

      optionByType: {
        izUseSeparator: getValue('izUseSeparator', grouping),
        izInverted: getValue('izInverted', view),
        izIntervals: getValue('gauge.izIntervals', schemaData),

        izUsePagination: getValue('izUsePagination', view),
        izItemPerRow: getValue('izItemPerRow', view)
      },
      view: {
        showLabels: getValue('showLabels', view),
        dataRefreshInterval: dataRefreshInterval
      },
      printing: {
        izPageBreakAfterSeparator: izPageBreakAfterSeparator
      }
    };

    // remove properties which don't have for selected chart-type
    chartProperties.optionByType = (0, _fp.omitBy)(_fp.isNil, chartProperties.optionByType);

    if (changedKey === 'chartType') {
      reportPartContent.setChartType(chartProperties.chartType);
    }

    changedKey === 'izUseSeparator' && reportPartContent.resetSeparator(getValue('izUseSeparator', grouping));

    derivedChange && derivedChange(chartProperties);
    changedKey !== 'chartType' && reportPartDetails.setReportPartProperties(chartProperties);

    return (0, _bluebird.resolve)({
      needToUpdate: false,
      chartProperties: chartProperties
    });
  });
};

/**
 * Get value
 * @param {string} key
 * @param {Object} obj
 */


function getValue(key, obj) {
  return (0, _fp.get)([key, 'value'].join('.'), obj);
}
module.exports = exports['default'];

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGaugeContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGaugeContent model
 */

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(425);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(54);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(35);

var _Izenda6 = __webpack_require__(64);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(33);

var _Izenda9 = __webpack_require__(221);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2099);

var _Izenda12 = __webpack_require__(1106);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var NUMBER_ZERO = 0;
var NUMBER_ONE = 1;
var NUMBER_CHECK_INDEX = -1;

var ReportPartGaugeContent = (_dec = (0, _Izenda14.exportClass)('ReportPartGaugeContent'), _dec(_class = (0, _Izenda4.default)(_class = (_class2 = function (_ReportPartContent) {
  (0, _inherits3.default)(ReportPartGaugeContent, _ReportPartContent);

  function ReportPartGaugeContent(reportPartContent) {
    (0, _classCallCheck3.default)(this, ReportPartGaugeContent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartGaugeContent.__proto__ || (0, _getPrototypeOf2.default)(ReportPartGaugeContent)).call(this, _Izenda7.REPORT_PART_TYPE.Gauge));

    _initDefineProp(_this, 'isCrossFiltering', _descriptor, _this);

    _initDefineProp(_this, 'title', _descriptor2, _this);

    _initDefineProp(_this, 'description', _descriptor3, _this);

    _initDefineProp(_this, 'properties', _descriptor4, _this);

    _initDefineProp(_this, 'drilldownInfo', _descriptor5, _this);

    _initDefineProp(_this, 'activeSerie', _descriptor6, _this);

    _this.staticProperties = {};
    var props = {};
    // important - these containers save list of fields to get data and render report
    (0, _Izenda5.addContainers)(props, _Izenda9.ContainerName.LABELS);
    (0, _Izenda5.addContainers)(props, _Izenda9.ContainerName.VALUES);
    (0, _Izenda5.addContainers)(props, _Izenda9.ContainerName.SEPARATORS);

    (0, _mobx.extendObservable)(_this, props);

    reportPartContent && _this.readData(reportPartContent);

    _this.drilldownReaction = (0, _mobx.reaction)(function () {
      // trick - access num elements of each container to trigger change
      // every have action on component (add/delete field, visible/hidden element)
      return _this[_Izenda9.ContainerName.LABELS].numElement + _this[_Izenda9.ContainerName.VALUES].numElement + _this[_Izenda9.ContainerName.SEPARATORS].numElement;
    }, _this.resetDrilldownInfo.bind(_this));

    _this.cleanDirty();
    return _this;
  }
  // use to show/hide fields which need to draw chart - do not save

  // @observable type = null;


  (0, _createClass3.default)(ReportPartGaugeContent, [{
    key: 'validateFunction',


    /**
     * validate function based on container
     * @method validateFunction
     * @param {Object} container Container need validateFunction
     * @param {Function} functionInfo Function need validate
     * @return {Object}
     */
    value: function validateFunction(container, functionInfo) {
      if (!functionInfo) {
        return {
          status: false,
          useDefaultFunction: false
        };
      }

      return {
        status: true
      };
    }

    /**
     * Get Default Function And Format for field in container
     * @method getDefaultFunctionFormat
     * @param {Object} container Container have element need get default dataType
     * @param {string} dataType  Data Type for field
     * @return {Object}
     */

  }, {
    key: 'getDefaultFunctionFormat',
    value: function getDefaultFunctionFormat(container, dataType) {
      var byContainer = _Izenda10.default.DefaultFunction[this.chartType][container.name || ''] || {};
      return (0, _Izenda5.getDefaultFunction)(byContainer, dataType);
    }

    /**
     * read data from api/create report part to update data
     * @param {Object} content [data from api/create report part]
     */

  }, {
    key: 'readData',
    value: function readData(content) {
      content = content || {};
      var properties = content.properties || {};
      this.isCrossFiltering = content.isCrossFiltering;
      // this.type = content.type;
      this.labels = (0, _Izenda5.populateReportChartContainer)(content.labels, 'labels');
      this.separators = (0, _Izenda5.populateReportChartContainer)(content.separators, 'separators');
      this.values = (0, _Izenda5.populateReportChartContainer)(content.values, 'values', this.afterInsertFieldToContainer);

      this.settings = content.settings;

      // report part properties
      this.setChartType(properties.chartType);

      // report part properties
      this.staticProperties = (0, _fp.get)('staticProperties', properties);
      this.setReportPartProperties((0, _fp.omit)('staticProperties', properties));
      this.setActiveSerie(null, (0, _fp.find)({ fieldName: content.selectedMetric }, this.serieChartList));

      this.markDirty();
    }

    /**
     * Build data for save
     * @return {Object}
     */

  }, {
    key: 'buildDataForSave',
    value: function buildDataForSave() {
      var chartContent = (0, _mobx.toJS)((0, _fp.omit)(['properties', 'staticProperties', 'expandedLevel', 'drilldownInfo'], this));

      // merge static properties
      chartContent.properties = this.getReportPartProperties();
      chartContent.selectedMetric = (0, _fp.get)('activeSerie.fieldName', this);

      return chartContent;
    }

    /**
     * Set data by data key
     * @param {string} key
     * @param {Object} newVal
     */

  }, {
    key: 'setDataByKey',
    value: function setDataByKey(key, newVal) {
      this[key] = newVal;
      this.markDirty();
    }

    /**
     * Get data by data key
     * @param {string} key
     * @return {Object}
     */

  }, {
    key: 'getDataByKey',
    value: function getDataByKey(key) {
      return this[key];
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();
    }

    /**
     * get properties of report part, if propKey is null, return all properties
     * @param {string} propKey
     * @return {Object}
     */

  }, {
    key: 'getReportPartProperties',
    value: function getReportPartProperties(propKey) {
      var props = (0, _mobx.toJS)(this.properties) || {};

      if (!propKey) {
        return (0, _fp.assign)({ staticProperties: this.staticProperties }, props);
      }

      return (0, _fp.get)(propKey, props.commonOptions || {}) || (0, _fp.get)(propKey, props.optionByType || {}) || (0, _fp.get)(propKey, props.view || {}) || (0, _fp.get)(propKey, props.printing || {}) || (0, _fp.get)(propKey, this.defaultCommonOptions || {}) || (0, _fp.get)(propKey, this.defaultOptionsByType || {});
    }

    /**
     * Get metric container
     */

  }, {
    key: 'getMetricContainer',
    value: function getMetricContainer() {
      return _Izenda9.ContainerName.VALUES;
    }

    /**
     * set properties of report part
     * @param {Object} newProps
     */

  }, {
    key: 'setReportPartProperties',
    value: function setReportPartProperties(newProps) {
      var props = (0, _mobx.toJS)(this.properties) || {};
      newProps = (0, _mobx.toJS)(newProps);
      (0, _mobx.extendObservable)(props, newProps);
      this.properties = props;
      if (!(0, _fp.isUndefined)(newProps.colorTheme) || newProps.isDefaultTheme) {
        props.isDefaultTheme = newProps.isDefaultTheme;
        props.colorTheme = newProps.colorTheme;
      }

      this.markDirty();
    }

    /**
     * Get dirty status.
     * @returns {boolean}
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      var dirtyElements = (0, _fp.flow)((0, _fp.flatMap)(function (item) {
        return item.elements ? item.elements.peek() : [];
      }), (0, _fp.filter)(function (element) {
        var metric = (0, _fp.get)('properties.metric', element);
        return element.checkDirty && element.checkDirty() || metric && metric.checkDirty && metric.checkDirty();
      }))(this.containerCollection);

      var properties = this.properties || {};
      var metric = properties.metric;

      return this.isDirty || !(0, _fp.isEmpty)(dirtyElements) || properties.checkDirty && properties.checkDirty() || metric && metric.checkDirty && metric.checkDirty();
    }

    /**
     * Set Chart type
     * @param {string} nextType
     */

  }, {
    key: 'setChartType',
    value: function setChartType(nextType) {
      var previousType = this.properties.chartType;
      this.properties.chartType = nextType;
      this.convertChartType(previousType, nextType);

      this.markDirty();
    }

    /**
     * Convert chart type
     * @param {string} previousType
     * @param {string} nextType
     */

  }, {
    key: 'convertChartType',
    value: function convertChartType(previousType, nextType) {
      switch (nextType) {
        case _Izenda8.CHART_TYPE.SolidGauge:
        case _Izenda8.CHART_TYPE.LinearGauge:
          initValuesData.call(this, 'resetSupplementaryKPISetting');
          break;

        case _Izenda8.CHART_TYPE.SimpleGauge:
          initValuesData.call(this, 'resetScaleData');
          break;
        default:
        // do nothing
      }

      this.markDirty();

      function initValuesData(fnName) {
        var fieldMetricVal = void 0;

        this.values.elements.map(function (field) {
          fieldMetricVal = (0, _fp.getOr)({}, 'properties.metric', field);
          (0, _fp.isFunction)(fieldMetricVal[fnName]) && fieldMetricVal[fnName]();
          (0, _fp.invoke)('cleanDirty', fieldMetricVal);
        });
      }
    }

    /**
     * Set active serie key, used to show/hide serie chart in metric dropdown
     * @param {string} activeSerieKey
     * @param {Object} activeSerieInfo
     */

  }, {
    key: 'setActiveSerie',
    value: function setActiveSerie(activeSerieKey, activeSerieInfo) {
      this.activeSerie = activeSerieInfo;
      this.markDirty();
    }

    /**
     * reset elements of separtors
     */

  }, {
    key: 'resetSeparator',
    value: function resetSeparator() {
      this.separators.elements.clear();
    }

    /**
     * If element is inserted to values container, need to init a model
     * to manage its information: scale, threshold, supplementary KPI
     * @param {Object} container
     * @param {Object} newElement
     * @param {Object} rawData
     */

  }, {
    key: 'afterInsertFieldToContainer',
    value: function afterInsertFieldToContainer(container, newElement, rawData) {
      if (container.name === _Izenda9.ContainerName.VALUES) {
        newElement.properties.metric = new _Izenda13.default((0, _fp.getOr)({}, 'properties.metric', rawData));
      }
    }

    /**
     * After add field
     */

  }, {
    key: 'afterAddField',
    value: function afterAddField() {
      // Set sort value 'ASC' for first field in LABEL if there isn't any existing sorted fields
      var firstPosition = 1;
      var lengthToApplySort = 2;
      var ASC = _Izenda6.SORT_ORDERS.ASC,
          DESC = _Izenda6.SORT_ORDERS.DESC;

      var needSortFirstField = this.labelsElements.length >= lengthToApplySort && !(0, _fp.some)(function (field) {
        var sort = (0, _fp.get)('properties.dataFormattings.sort', field);
        return (0, _fp.includes)(sort, [ASC.value, DESC.value]);
      }, this.allFieldCollection);
      var firstField = (0, _fp.find)(function (ele) {
        return ele.position === firstPosition;
      }, this.labelsElements);
      this.isBeingBuild && needSortFirstField && firstField.properties.setSortValue(ASC.value);
    }

    /**
     * Reset drilldown info
     */

  }, {
    key: 'resetDrilldownInfo',
    value: function resetDrilldownInfo() {
      this.drilldownInfo = {
        filters: [],
        separatorValue: null
      };
    }

    /**
     * Update drilldown inform
     * @param {Object} drilldownValue
     * @param {Object} separatorValue
     * @return {boolean}
     */

  }, {
    key: 'updateDrilldownInfo',
    value: function updateDrilldownInfo(drilldownValue, separatorValue) {
      if (!this.hasDrillDown) {
        return false;
      }

      var drilldownInfo = this.drilldownInfo;
      var filters = (0, _fp.get)('filters', drilldownInfo);
      var canDrilldown = false;

      // move to top level
      if (!drilldownValue && (0, _fp.size)(filters)) {
        this.resetDrilldownInfo();
        canDrilldown = true;
        return canDrilldown;
      }

      var nextDrilldownKey = (0, _fp.get)('field.fieldNameAlias', drilldownValue) || (0, _fp.get)('key', drilldownValue);
      var drillUpLevel = (0, _fp.findIndex)({ key: nextDrilldownKey }, filters);
      var columnName = (0, _fp.get)('field.columnName', drilldownValue);

      if (drillUpLevel > NUMBER_CHECK_INDEX) {
        // drill up
        filters.splice(drillUpLevel + NUMBER_ONE, filters.length - drillUpLevel - NUMBER_ONE);
        canDrilldown = true;
      } else if (filters.length < this[_Izenda9.ContainerName.LABELS].numElement - NUMBER_ONE) {
        // drill down
        canDrilldown = true;

        filters.push({
          key: nextDrilldownKey,
          value: (0, _fp.get)(columnName, drilldownValue.record),
          field: (0, _fp.get)('field', drilldownValue),
          record: (0, _fp.get)('record', drilldownValue)
        });

        separatorValue && separatorValue.field && (drilldownInfo.separatorValue = {
          key: (0, _fp.get)('field.fieldNameAlias', separatorValue),
          value: (0, _fp.get)('value', separatorValue),
          field: (0, _fp.get)('field', separatorValue)
        });
      }

      return canDrilldown;
    }

    /**
     * Return drilldown info: expandedLevel & filters
     * @return {Object}
     */

  }, {
    key: 'getDrilldownInfo',
    value: function getDrilldownInfo() {
      var drilldownInfo = this.drilldownInfo;
      var expandedLevel = this.expandedLevel;

      var filters = drilldownInfo.filters.map(function (filter) {
        return {
          key: (0, _fp.get)('key', filter),
          value: (0, _fp.get)('value', filter),
          dataType: (0, _fp.get)('field.reportPartElm.fieldDataType', filter)
        };
      });

      var separatorInfo = {
        key: (0, _fp.get)('key', drilldownInfo.separatorValue),
        value: (0, _fp.get)('value', drilldownInfo.separatorValue),
        isSeparator: true
      };

      filters = expandedLevel < NUMBER_ZERO ? [] : drilldownInfo.separatorValue ? filters.unshift(separatorInfo) && filters : filters;

      return {
        expandedLevel: expandedLevel,
        filters: filters
      };
    }

    /**
     * Get cross filtering info.
     * @return {Array<any>} filter info
     */

  }, {
    key: 'getCrossFilteringInfo',
    value: function getCrossFilteringInfo() {
      return this.drilldownInfo.filters.map(function (filter) {
        return {
          key: (0, _fp.get)('key', filter),
          value: (0, _fp.get)('value', filter),
          field: (0, _fp.get)('field', filter)
        };
      });
    }

    /**
     * This properties is used to save the page size
     * Only use for chart-type which supported pagination: pie, donut, treemap, funnel
     * @param {number} pageSize
     */

  }, {
    key: 'setPageSize',
    value: function setPageSize(pageSize) {
      this.staticProperties.pageSize = pageSize;
    }

    /**
     * Check need to break page when printing.
     * @returns {boolean}
     */

  }, {
    key: 'checkBreakPage',
    value: function checkBreakPage() {
      return this.properties.printing.izPageBreakAfterSeparator && this.separators.elements && this.separators.elements.length > NUMBER_ZERO;
    }

    /**
     * Reset drilldown info whenever reorder field
     */

  }, {
    key: 'changePositionField',
    value: function changePositionField() {
      this.resetDrilldownInfo();
    }

    /**
     * Action whenever element's props are changed.
     * @param {Object} element
     * @param {Object} elementProps
     * @param {string} changedKey
     */

  }, {
    key: 'changePropertiesByField',
    value: function changePropertiesByField(element, elementProps, changedKey) {
      if (changedKey === 'function' || changedKey === 'format') {
        this.resetDrilldownInfo();
      }
    }

    /**
     * check if function is compatible with element
     * @method checkedCompatibleFunction
     * @param {Object} container Container that element belong
     * @param {Object} element Element need to validate
     * @param {Function} functionInfo Function infomation
     * @return {boolean}
     */

  }, {
    key: 'checkedCompatibleFunction',
    value: function checkedCompatibleFunction(container, element, functionInfo) {
      if (!container) {
        return true;
      }

      var result = true;
      var functionName = (0, _fp.getOr)(_Izenda6.EMPTY_FUNCTION.name, 'name', functionInfo);

      // If the user add a calculated field which contains the aggregated field
      // then the user cannot select any aggregated field in Function dropdown in
      // Field Properties Panel. The user can select “empty” function or other user
      // defined functions which has function level = field.
      if (element.field.hasAggregatedFunction) {
        result = functionInfo.userDefined || !functionName;
      }

      var checkDataTypeNumericMoney = (0, _fp.includes)(_fp.placeholder, ['Numeric', 'Money']);

      if (result && [_Izenda9.ContainerName.VALUES, _Izenda9.ContainerName.THRESHOLD].indexOf(container.name) > NUMBER_CHECK_INDEX) {
        // function return Money or Numeric
        result = checkDataTypeNumericMoney(functionInfo.formatDataType) ||
        // Element data type is Money or numeric and function is empty function
        checkDataTypeNumericMoney(element.fieldDataType) && !functionName;
      }

      var config = _Izenda11.AVAILABLE_FUNCTION_CONFIG[this.chartType];

      config = config && config[container.name];

      if (!config || !result) {
        return result;
      }

      return (0, _Izenda5.checkCompatibleFunctionCommon)(functionInfo, element, config);
    }

    /**
     * Check if this field can have state Unsort
     * @param {Object} container
     * @returns {boolean}
     */

  }, {
    key: 'checkCanUnsort',
    value: function checkCanUnsort(container) {
      var containerName = (0, _fp.getOr)('', 'name', container);
      var canUnsort = false;

      switch (this.chartType) {
        case _Izenda8.CHART_TYPE.SolidGauge:
        case _Izenda8.CHART_TYPE.LinearGauge:
        case _Izenda8.CHART_TYPE.SimpleGauge:
          canUnsort = containerName !== _Izenda9.ContainerName.SEPARATORS && containerName !== _Izenda9.ContainerName.THRESHOLD;
          break;
      }

      return canUnsort;
    }

    /**
     * Reset refresh interval setting to default vale
     * @return {Object} default value
     */

  }, {
    key: 'resetRefreshIntervalValue',
    value: function resetRefreshIntervalValue() {
      this.properties.view.dataRefreshInterval = _Izenda10.default.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
      this.markDirty();
      return this.properties.view.dataRefreshInterval;
    }

    /**
     * Reset border setting to default value
     * @return {Object} default value
     */

  }, {
    key: 'resetBorderDefaultValue',
    value: function resetBorderDefaultValue() {
      this.properties.commonOptions = _Izenda10.default.DEFAULT_SETTING_VALUE.borderDefault;
      this.markDirty();
      return this.properties.commonOptions;
    }

    /**
     * Check if ReportPart is drilling down or not
     * @return {boolean}
     */

  }, {
    key: 'isDrillingDown',
    value: function isDrillingDown() {
      return !(0, _fp.flow)((0, _fp.get)('drilldownInfo.filters'), _fp.isEmpty)(this);
    }
  }, {
    key: 'chartType',
    get: function get() {
      return this.properties.chartType;
    }
  }, {
    key: 'expandedLevel',
    get: function get() {
      return this.drilldownInfo.filters.length;
    }
  }, {
    key: 'drilldown',
    get: function get() {
      return this.getDrilldownInfo();
    }
  }, {
    key: 'serieChartList',
    get: function get() {
      var valuesElements = this.values.visibleElement || [];
      return valuesElements.map(function (elm) {
        return elm;
      });
    }
  }, {
    key: 'activeElmsByContainers',
    get: function get() {
      var activeSerieKey = (0, _fp.get)('fieldName', this.activeSerie);

      return {
        labels: _Izenda5.getElements.call(this, this.labels),
        values: _Izenda5.getElements.call(this, this.values, activeSerieKey),
        separators: _Izenda5.getElements.call(this, this.separators)
      };
    }
  }, {
    key: 'containerCollection',
    get: function get() {
      var basicContainers = (0, _fp.compact)([this.labels, this.values, this.separators]);

      // element for thresholds & sup-KPI (simple gauge only)
      var addedContainer = {};
      (0, _Izenda5.addContainers)(addedContainer, _Izenda9.ContainerName.THRESHOLD);
      (0, _Izenda5.addContainers)(addedContainer, _Izenda9.ContainerName.SUP_KPI);

      var thresholdsElm = addedContainer[_Izenda9.ContainerName.THRESHOLD].elements;
      var supKpiElm = addedContainer[_Izenda9.ContainerName.SUP_KPI].elements;

      this.values.visibleElement.forEach(function (element) {
        var metric = (0, _fp.get)('properties.metric', element);
        var supKPI = (0, _fp.get)('properties.metric.supplementaryKPI.element', element);

        if ((0, _fp.size)(metric.thresholds.levels)) {
          metric.thresholds.levels.forEach(function (level) {
            level.element && thresholdsElm.push(level.element);
          });
        }

        supKPI && supKpiElm.push(supKPI);
      });

      addedContainer = (0, _mobx.observable)(addedContainer);

      return (0, _fp.concat)(basicContainers, [addedContainer[_Izenda9.ContainerName.THRESHOLD], addedContainer[_Izenda9.ContainerName.SUP_KPI]]);
    }
  }, {
    key: 'isApplyScale',
    get: function get() {
      return _Izenda8.CHART_TYPE.SimpleGauge !== this.chartType;
    }
  }, {
    key: 'hasDrillDown',
    get: function get() {
      return (0, _fp.get)('numElement', this.labels) > NUMBER_ONE;
    }
  }, {
    key: 'isBeingBuild',
    get: function get() {
      return (0, _Izenda5.hasElement)(this.values);
    }
  }, {
    key: 'useSeparator',
    get: function get() {
      return (0, _fp.get)('optionByType.izUseSeparator', this.properties || {});
    }
  }, {
    key: 'dataRefreshInterval',
    get: function get() {
      return (0, _fp.get)('view.dataRefreshInterval', this.properties);
    }
  }, {
    key: 'optionalParams',
    get: function get() {
      return {
        expandedLevel: _Izenda7.EXPANDED_LEVEL[this.hasDrillDown ? 'FIRST_LEVEL' : 'ALL']
      };
    }
  }, {
    key: 'reportPartStyle',
    get: function get() {
      return this.properties.chartType;
    }
  }, {
    key: 'labelsElements',
    get: function get() {
      return this.labels.visibleElement;
    }
  }, {
    key: 'valuesElements',
    get: function get() {
      return this.values.visibleElement;
    }
  }, {
    key: 'allFieldCollection',
    get: function get() {
      return (0, _fp.flatMap)(function (item) {
        return item.elements ? item.elements.slice() : [];
      }, this.containerCollection);
    }
  }, {
    key: 'isShowMetric',
    get: function get() {
      return !(0, _fp.isEmpty)(this.serieChartList) && this.serieChartList.length > NUMBER_ONE;
    }

    /**
     * Determine whether the report part content automatically sizes its container or not
     */

  }, {
    key: 'autoSize',
    get: function get() {
      return false;
    }
  }]);
  return ReportPartGaugeContent;
}(_Izenda2.default), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isCrossFiltering', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'title', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'description', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'properties', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      chartType: _Izenda10.default.DefaultChartType,
      colorTheme: undefined,
      isDefaultTheme: true,
      optionByType: {
        izUseSeparator: true,
        izUsePagination: true,
        izItemPerRow: _Izenda10.default.ITEM_PER_ROWS
      },
      view: {
        showLabels: false,
        dataRefreshInterval: {
          enable: false,
          updateInterval: 0,
          isAll: true,
          latestRecord: 0
        }
      },
      printing: {
        izPageBreakAfterSeparator: false
      }
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'drilldownInfo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      separatorValue: null,
      filters: []
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'activeSerie', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'chartType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'chartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'expandedLevel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'expandedLevel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'drilldown', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'drilldown'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'serieChartList', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'serieChartList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'activeElmsByContainers', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'activeElmsByContainers'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'containerCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'containerCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isApplyScale', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isApplyScale'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasDrillDown', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasDrillDown'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isBeingBuild', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isBeingBuild'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'useSeparator', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'useSeparator'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'dataRefreshInterval', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'dataRefreshInterval'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'optionalParams', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'optionalParams'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reportPartStyle', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reportPartStyle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'labelsElements', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'labelsElements'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'valuesElements', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'valuesElements'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'allFieldCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'allFieldCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isShowMetric', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isShowMetric'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'buildDataForSave', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'buildDataForSave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setReportPartProperties', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportPartProperties'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setChartType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setChartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'convertChartType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'convertChartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterInsertFieldToContainer', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterInsertFieldToContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterAddField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterAddField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetDrilldownInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetDrilldownInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDrilldownInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDrilldownInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changePositionField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changePositionField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetRefreshIntervalValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetRefreshIntervalValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetBorderDefaultValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetBorderDefaultValue'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ReportPartGaugeContent;
module.exports = exports['default'];

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(64);

var _Izenda2 = __webpack_require__(33);

// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeAvailableFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var availableSeparator = {
  SUPPORTED: {
    Datetime: [_Izenda.FUNCTION.GROUP, _Izenda.FUNCTION.GROUP_DAYS_OLD],
    DEFAULT: [_Izenda.FUNCTION.GROUP]
  }
};

var groupFunctions = [_Izenda.FUNCTION.GROUP, _Izenda.FUNCTION.GROUP_DAYS_OLD];

var AVAILABLE_FUNCTION_CONFIG = {};

/* Solid Gauge, Linear Gauge, Simple Gauge */
AVAILABLE_FUNCTION_CONFIG[_Izenda2.CHART_TYPE.SolidGauge] = AVAILABLE_FUNCTION_CONFIG[_Izenda2.CHART_TYPE.SolidGauge] = AVAILABLE_FUNCTION_CONFIG[_Izenda2.CHART_TYPE.SolidGauge] = {
  values: {
    UNSUPPORTED: {
      DEFAULT: groupFunctions
    }
  },
  threshold: {
    // same as values
    UNSUPPORTED: {
      DEFAULT: groupFunctions
    }
  },
  separators: availableSeparator
};

exports.default = {
  AVAILABLE_FUNCTION_CONFIG: AVAILABLE_FUNCTION_CONFIG
};
module.exports = exports['default'];

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2101);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(601);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(16);

var _Izenda10 = __webpack_require__(33);

var _Izenda11 = __webpack_require__(85);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZOOM_TYPE_VALUES = _Izenda10.MappingValues.ZOOM_TYPE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.LinearGaugeConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda9.REPORT_PART_TYPE.Gauge, _Izenda10.CHART_TYPE.LinearGauge, null, {
  visualType: _Izenda12.default.LinearGauge,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_LINEAR_GAUGE');
  },

  visualPreviewCSS: 'gauge-linear',

  optionsBuilder: _Izenda6.default,

  fieldContainerSchema: _Izenda8.default,

  optionsMapping: {
    optionsByType: {
      izInverted: { propKey: 'chart.inverted', defaultValue: false },
      izIntervals: { propKey: 'izendaOptions.intervals', defaultValue: undefined },
      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined }
    }
  }
});

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(112);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.LinearGaugeOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(1122);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(39);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var X_AXIS_CONTAINER_NAME = 'labels';
var Y_AXIS_CONTAINER_NAME = 'values';
var VALUE_WIDTH = 50;

var LineardGaugeOptionsBuilder = (_dec = (0, _Izenda7.exportClass)('LinearGaugeOptionsBuilder'), _dec(_class = function (_SolidGaugeOptionsBui) {
  (0, _inherits3.default)(LineardGaugeOptionsBuilder, _SolidGaugeOptionsBui);

  function LineardGaugeOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, LineardGaugeOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = LineardGaugeOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(LineardGaugeOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */


  (0, _createClass3.default)(LineardGaugeOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var genericOptions = (0, _get3.default)(LineardGaugeOptionsBuilder.prototype.__proto__ || (0, _getPrototypeOf2.default)(LineardGaugeOptionsBuilder.prototype), 'buildOptionsByType', this).call(this, visualType, userOptions, dataParser) || {};

      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
      var izendaOptions = userOptions.izendaOptions;
      var serieName = izendaOptions.serieName;
      var isInverted = !(0, _fp.get)('chart.inverted', userOptions);
      var _formatter = (0, _fp.get)('plotOptions.series.dataLabels.formatter', genericOptions);

      return $izenda.extend(true, genericOptions, {
        chart: {
          inverted: isInverted
        },

        plotOptions: {
          series: {
            dataLabels: {
              formatter: function formatter() {
                var point = this.point;
                var pointOpts = _Izenda4.default.getPointOptions(point);

                var val = _formatter ? _formatter.apply(this, arguments) : _Izenda4.default.getPointValue(point);
                var textColor = (0, _fp.get)('textColor', pointOpts);
                var width = isInverted ? 'auto' : VALUE_WIDTH + 'px';

                return '<span style="width:' + width + '; color:' + textColor + '" class="overflow-text" title="' + val + '"><span>' + val + '</span></span>';
              },

              style: {
                fontSize: '14px'
              }
            }
          }
        }
      });
    }
  }]);
  return LineardGaugeOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = LineardGaugeOptionsBuilder;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2103);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(601);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(16);

var _Izenda10 = __webpack_require__(33);

var _Izenda11 = __webpack_require__(85);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZOOM_TYPE_VALUES = _Izenda10.MappingValues.ZOOM_TYPE_VALUES;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleGaugeConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda2.default.extendConfiguration(_Izenda9.REPORT_PART_TYPE.Gauge, _Izenda10.CHART_TYPE.SimpleGauge, null, {
  visualType: _Izenda12.default.SimpleGauge,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_SIMPLE_GAUGE');
  },

  visualPreviewCSS: 'gauge-simple',

  optionsBuilder: _Izenda6.default,

  fieldContainerSchema: _Izenda8.default,

  optionsMapping: {
    optionsByType: {
      izInverted: { propKey: 'chart.inverted', defaultValue: false },
      izIntervals: { propKey: 'izendaOptions.intervals', defaultValue: undefined },
      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined }
    }
  }
});

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleGaugeOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(424);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(69);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleGaugeOptionsBuilder = (_dec = (0, _Izenda5.exportClass)('SimpleGaugeOptionsBuilder'), _dec(_class = function (_HighchartOptionsBuil) {
  (0, _inherits3.default)(SimpleGaugeOptionsBuilder, _HighchartOptionsBuil);

  function SimpleGaugeOptionsBuilder() {
    var _ref;

    (0, _classCallCheck3.default)(this, SimpleGaugeOptionsBuilder);

    for (var _len = arguments.length, baseArgs = Array(_len), _key = 0; _key < _len; _key++) {
      baseArgs[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn3.default)(this, (_ref = SimpleGaugeOptionsBuilder.__proto__ || (0, _getPrototypeOf2.default)(SimpleGaugeOptionsBuilder)).call.apply(_ref, [this].concat(baseArgs)));
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */


  (0, _createClass3.default)(SimpleGaugeOptionsBuilder, [{
    key: 'buildOptionsByType',
    value: function buildOptionsByType(visualType, userOptions, dataParser) {
      var izendaOptions = userOptions.izendaOptions;
      var izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
      var firstPoint = (0, _fp.get)('series[0].data[0]', userOptions);
      var customFormat = _Izenda4.default.getCustomFormat(userOptions);
      var configData = izendaSeriesConfig[izendaOptions.serieName];
      var element = (0, _fp.find)(function (f) {
        return f.fieldNameAlias === (0, _fp.get)('fieldElement.field.fieldNameAlias', configData);
      }, dataParser.fieldsMapping);

      if (firstPoint) {
        (0, _assign2.default)(firstPoint, {
          serieName: izendaOptions.serieName,
          unit: izendaOptions.dataUnit,
          dataFormatter: function dataFormatter(value, record) {
            var fieldValue = {
              value: customFormat || value,
              originalValue: value
            };
            return dataParser.getFormatData(fieldValue, configData, { element: element, record: record });
          }
        });
      }

      return {
        chart: {
          events: {
            click: _Izenda4.default.onDrilldownGauge(userOptions, (0, _fp.head)(userOptions.series))
          }
        },
        title: {
          text: ''
        },
        series: [{ data: [firstPoint] }]
      };
    }
  }]);
  return SimpleGaugeOptionsBuilder;
}(_Izenda2.default)) || _class);
exports.default = SimpleGaugeOptionsBuilder;
module.exports = exports['default'];

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1122);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(601);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(16);

var _Izenda10 = __webpack_require__(33);

var _Izenda11 = __webpack_require__(85);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Izenda2.default.extendConfiguration(_Izenda9.REPORT_PART_TYPE.Gauge, _Izenda10.CHART_TYPE.SolidGauge, null, {
  visualType: _Izenda12.default.SolidGauge,

  get visualLabel() {
    return _Izenda4.default.getText('REPORT_PART_GAUGE_CONSTANTS_LABEL_SOLID_GAUGE');
  },

  visualPreviewCSS: 'gauge-solid',

  fieldContainerSchema: _Izenda8.default,

  optionsBuilder: _Izenda6.default
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.SolidGaugeConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(2106);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2108);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2109);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2110);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2111);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2112);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(16);

var _Izenda14 = __webpack_require__(598);

var _fp = __webpack_require__(1);

var _Izenda15 = __webpack_require__(181);

var _Izenda16 = _interopRequireDefault(_Izenda15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Default chart configuration */

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultMapConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

_Izenda16.default.setConfiguration(_Izenda13.REPORT_PART_TYPE.Map, {
  /**
   * Visualization engine name
   */
  visualEngine: 'Highmap',

  /**
   * Label of visualization, normally showing in chart type dropdown
   */
  visualLabel: null,

  /**
   * A CSS class to show preview image of the visualization, normally showing when hovering a chart dropdown item
   */
  visualPreviewCSS: null,

  /**
   * Type of visualization, e.g. chart type in Highcharts
   */
  visualType: 'map',

  /**
   * Report part content model class
   */
  model: _Izenda12.default,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [(0, _fp.constant)({
    chart_title: true
  })],

  /**
   * The object contains the property editor widget component
   */
  propertyWidgets: _Izenda8.default,

  /**
   * The object contains defined schema of property editor GUI
   */
  propertySchema: _Izenda2.default,

  /**
   * The function to create the mapping properties
   */
  propertyMappingProps: _Izenda4.default,

  /**
   * The function to create the mapping source
   */
  propertyMappingSource: _Izenda6.default,

  /**
   * The function to create an value changed handler
   */
  propertyValueChange: _Izenda10.default,

  optionsMapping: {
    /**
     * The object containts common options mapping
     */
    commonOptions: _Izenda14.COMMON_OPTIONS,

    /**
     * The object contains options by type mapping
     */
    optionsByType: {},

    /**
     * The object contains the threshold options mapping
     */
    thresholdOptions: _Izenda14.THRESHOLDS_LINE,

    /**
     * The object contains the axis options mapping
     */
    axisOptions: _Izenda14.AXIS_OPTIONS
  }
});

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(305);

var _Izenda2 = __webpack_require__(1109);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(595);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(323);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(2107);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(1108);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(16);

var _Izenda13 = __webpack_require__(175);

var _Izenda14 = __webpack_require__(12);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(265);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(105);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultMapPropsDefinedSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var getMapOptions = function getMapOptions() {
  return (0, _Izenda13.getAll)(_Izenda12.REPORT_PART_TYPE.Map).map(function (_ref) {
    var label = _ref.label,
        style = _ref.style,
        previewCSS = _ref.previewCSS;
    return {
      label: label,
      value: style,
      className: previewCSS
    };
  });
};

/**
 * The common chart properties GUI schema that shares to all map type.
 */
exports.default = {
  schemaKey: 'RP_GAUGE_TYPE',
  groups: {
    /* general info */
    generalInfo: {
      title: function title() {
        return _Izenda15.default.getText('REPORT_PART_GAUGE_PROPS_SCHEMA_LABEL_GENERAL_INFO');
      },
      fields: {
        chartType: {
          factory: _Izenda.createSelectSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_MAP_TYPE');
          },
          value: 'getChartType',
          props: {
            get options() {
              return getMapOptions();
            }
          }
        },
        continent: {
          factory: _Izenda.createSelectSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_CONTINENT');
          },
          value: 'getValueByKey',
          isHidden: 'isHiddenContinent',
          props: {
            options: _Izenda17.default.CONTINENTS
          }
        },
        country: {
          factory: _Izenda.createSelectSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_COUNTRY');
          },
          value: 'getValueByKey',
          isHidden: 'isHiddenCountry',
          props: {
            options: _Izenda17.default.COUNTRIES
          }
        },
        state: {
          factory: _Izenda.createSelectSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_STATE');
          },
          value: 'getValueByKey',
          isHidden: 'isHiddenState',
          props: {
            options: 'getStateByCountry'
          },
          staticProps: {
            blankOption: true,
            get blankOptionText() {
              return _Izenda15.default.getText('COMMON_LABEL_ALL');
            }
          }
        }
      }
    },
    /* map */
    map: {
      title: function title() {
        return _Izenda15.default.getText('COMMON_LABEL_MAP');
      },
      isHidden: 'isNotBuild',
      hiddenByState: true,
      fields: {
        izBorder: {
          factory: _Izenda.createPopupSettingSchema,
          title: function title() {
            return _Izenda15.default.getText('COMMON_LABEL_BORDER');
          },
          value: 'getBorder',
          props: {
            get reportPartType() {
              return _Izenda12.REPORT_PART_TYPE.Map;
            },
            get title() {
              return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_MAP_BORDER_SETTINGS');
            },
            allChartProps: 'getAllChartProps',
            hadSetting: 'hadSettingBorder',
            fnResetDefaultValue: 'fnResetBorderDefaultValue',
            loadValue: 'getBorder'
          },
          staticProps: {
            get popupTitle() {
              return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_MAP_BORDER_SETTINGS');
            },
            popupContent: _Izenda5.default
          }
        },
        izBackgroundColor: {
          factory: _Izenda.createPopupSettingSchema,
          title: function title() {
            return _Izenda15.default.getText('COLOR_STYLING_BACKGROUND_TOOLTIP');
          },
          value: 'getBackgroundColor',
          props: {
            get reportPartType() {
              return _Izenda12.REPORT_PART_TYPE.Map;
            },
            get title() {
              return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_MAP_BACKGROUND_COLOR_SETTINGS');
            },
            allChartProps: 'getAllChartProps',
            hadSetting: 'hadSettingBackgroundColor',
            fnResetDefaultValue: 'fnResetBackgroundColorDefaultValue',
            loadValue: 'getBackgroundColor'
          },
          staticProps: {
            get popupTitle() {
              return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_MAP_BACKGROUND_COLOR_SETTINGS');
            },
            popupContent: _Izenda11.default
          }
        },
        colorTheme: {
          factory: _Izenda.createColorPaletteSettingSchema,
          title: function title() {
            return _Izenda15.default.getText('COMMON_LABEL_COLOR_THEME');
          },
          value: 'getColorTheme',
          props: {
            get selectionPopupTitle() {
              return _Izenda15.default.getText('COLORTHEME_POPUP_HEADER');
            },
            get defaultColorThemeLabel() {
              return _Izenda15.default.getText('COLORPALETTE_NOTHEME');
            },
            displaySettingStatus: true,
            needMaskDefault: false,
            defaultColorPalette: null
          }
        }
      }
    },
    labels: {
      title: function title() {
        return _Izenda15.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_LABELS');
      },
      isHidden: 'isNotBuild',
      fields: {
        izLabelOrientation: {
          factory: _Izenda.createOrientationSettingsSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_DATA_LABELS');
          },
          value: 'getValueByKey'
        },
        izHoverLabels: {
          factory: _Izenda.createCheckBoxSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_HOVER_LABELS');
          },
          value: 'getValueByKey'
        },
        izMapLabel: {
          factory: _Izenda.createCheckBoxSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_SHOW_MAP_LABELS');
          },
          value: 'getValueByKey'
        }
      }
    },
    legends: {
      title: function title() {
        return _Izenda15.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_LEGENDS');
      },
      isHidden: 'isNotBuild',
      fields: {
        legendSettings: {
          factory: _Izenda.createPopupSettingSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORTDESIGNER_LABEL_SETTINGS');
          },
          value: 'getLegendSettings',
          props: {
            get reportPartType() {
              return _Izenda12.REPORT_PART_TYPE.Map;
            },
            get title() {
              return _Izenda15.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_CHART_LEGEND_SETTINGS');
            },
            allChartProps: 'getAllChartProps',
            chartType: 'getChartType',
            hadSetting: 'hadSettingLegend',
            fnResetDefaultValue: 'fnResetLegendDefaultValue',
            loadValue: 'getLegendSettings'
          },
          staticProps: {
            get title() {
              return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_MAP_LEGEND_SETTINGS');
            },
            get popupTitle() {
              return _Izenda15.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_LEGEND_SETTINGS');
            },
            popupContent: _Izenda3.default
          }
        }
      }
    },
    data: {
      title: function title() {
        return _Izenda15.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_DATA');
      },
      isHidden: 'isNotBuild',
      fields: {
        izValueLabel: {
          factory: _Izenda.createCheckBoxSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_LABEL_SHOW_VALUE_LABELS');
          },
          value: 'getValueByKey'
        },
        izShowTooltip: {
          factory: _Izenda.createCheckBoxSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_PROPS_CHART_SCHEMA_SHOW_TOOLTIPS');
          },
          value: 'getValueByKey'
        }
      }
    },
    view: {
      title: function title() {
        return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_VIEW');
      },
      isHidden: 'isNotBuild',
      hiddenByState: true,
      fields: {
        zoomConfig: {
          factory: _Izenda.createPopupSettingSchema,
          title: function title() {
            return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_ZOOM');
          },
          value: 'getZoomConfig',
          props: {
            get reportPartType() {
              return _Izenda12.REPORT_PART_TYPE.Map;
            },
            get title() {
              return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_ZOOM_SETTINGS');
            },
            allChartProps: 'getAllChartProps',
            hadSetting: 'hadSettingZoom',
            fnResetDefaultValue: 'fnResetZoomDefaultValue',
            loadValue: 'getZoomConfig'
          },
          staticProps: {
            get popupTitle() {
              return _Izenda15.default.getText('REPORT_PART_MAP_CONSTANTS_ZOOM_SETTINGS');
            },
            popupContent: _Izenda9.default,
            popupProps: {
              type: 'none',
              autoClose: false
            }
          }
        },
        dataRefreshInterval: {
          factory: _Izenda.createPopupSettingSchema,
          title: function title() {
            return _Izenda15.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
          },
          value: 'getValueByKey',
          props: {
            get reportPartType() {
              return _Izenda12.REPORT_PART_TYPE.Map;
            },
            get title() {
              return _Izenda15.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
            },
            hadSetting: 'hadSettingRefreshInterval',
            fnResetDefaultValue: 'fnResetRefreshIntervalDefaultValue',
            hiddenByState: true,
            loadValue: 'getDataRefreshInterval'
          },
          staticProps: {
            get popupTitle() {
              return _Izenda15.default.getText('COMMON_LABEL_DATA_REFRESH_INTERVAL_SETTING');
            },
            popupContent: _Izenda7.default,
            popupProps: {
              type: 'none',
              autoClose: false
            }
          }
        }
      }
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ZoomForMap.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * Zoom For Map Component
 */
!function () {
  var m = __webpack_require__(5);
  var React = __webpack_require__(0);
  var ChartSettingsContainer = __webpack_require__(193);
  var ChartConfig = __webpack_require__(33);
  var localizer = __webpack_require__(12);

  var ZoomConfigSettings = React.createClass({
    displayName: 'ZoomConfigSettings',

    /**
     * Get inittial state
     */
    getInitialState: function getInitialState() {
      var props = this.props;
      var value = props.value || {};
      var enabled = value['izMapNavigation.enabled'] || false;
      var horizontalAlign = value['izMapNavigation.align'] || ChartConfig.DefaultConfig.LEGEND_HORIZONTAL_ALIGNMENT;
      var verticalAlign = value['izMapNavigation.verticalAlign'] || ChartConfig.DefaultConfig.LEGEND_VERTICAL_ALIGNMENT;

      this.allChartProps = m.toJS(props.allChartProps);
      return {
        enabled: enabled,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign
      };
    },

    /**
     * Handle changed value of zoom config setting
     * @param  {object} schemaData schema data
     */
    onChangeValue: function onChangeValue(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
      var groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
      var fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      var enabled = schemaData.enabled.value;
      var horizontalAlign = schemaData.horizontalAlignment.value;
      var verticalAlign = schemaData.verticalAlignment.value;

      this.setState({
        enabled: enabled,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign
      });
    },

    /**
     * Get value of zoom config component
     */
    getValue: function getValue() {
      var state = this.state;

      return {
        'izMapNavigation.enabled': state.enabled,
        'izMapNavigation.align': state.horizontalAlign,
        'izMapNavigation.verticalAlign': state.verticalAlign
      };
    },

    getConfigurationDef: function getConfigurationDef() {
      var state = this.state;

      /**
       * Define zoom config setting component schema
       * @return {object} background component schema
       */
      var getSchema = function getSchema() {
        return {
          schemaKey: 'ZOOM_CONFIG_SCHEMA',
          fields: {
            enabled: {
              title: localizer.getText('REPORTDESIGNER_LABEL_ENABLED'),
              type: 'checkbox',
              fnValue: 'getEnabled'
            },
            horizontalAlignment: {
              title: localizer.getText('REPORTDESIGNER_LABEL_HORIZONTAL_ALIGNMENT'),
              type: 'select',
              fnValue: 'getHorizontalAlignment',
              props: {
                options: ChartConfig.getOptions('HORIZONTAL_ALIGN'),
                defaultValue: ChartConfig.DefaultConfig.LEGEND_HORIZONTAL_ALIGNMENT,
                disabled: !state.enabled
              }
            },
            verticalAlignment: {
              title: localizer.getText('REPORTDESIGNER_LABEL_VERTICAL_ALIGNMENT'),
              type: 'select',
              fnValue: 'getVerticalAlignment',
              props: {
                options: ChartConfig.getOptions('VERTICAL_ALIGN'),
                defaultValue: ChartConfig.DefaultConfig.LEGEND_VERTICAL_ALIGNMENT,
                disabled: !state.enabled
              }
            }
          }
        };
      };

      return {
        definedSchema: getSchema(),
        onChangeValue: this.onChangeValue,
        mappingSource: {
          getEnabled: function getEnabled() {
            return state.enabled;
          },

          getHorizontalAlignment: function getHorizontalAlignment() {
            return state.horizontalAlign;
          },

          getVerticalAlignment: function getVerticalAlignment() {
            return state.verticalAlign;
          }
        }
      };
    },

    render: function render() {
      var state = this.state;
      var props = this.props;

      this.allChartProps = this.allChartProps;
      var chartOptions = {
        optionByType: {
          'izMapNavigation.enabled': state.enabled,
          'izMapNavigation.align': state.horizontalAlign,
          'izMapNavigation.verticalAlign': state.verticalAlign
        }
      };

      return React.createElement(ChartSettingsContainer, {
        type: this.props.reportPartType,
        configurationDef: this.getConfigurationDef(),
        chartOptions: chartOptions,
        allChartProps: this.allChartProps
      });
    }
  });

  module.exports = ZoomConfigSettings;
}();

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(105);

var _Izenda2 = __webpack_require__(80);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultMapPropsMappingProps.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
exports.default = function (reportPartDetails, fieldStore) {
  var reportPartContent = reportPartDetails.reportPartContent || {};

  var getProperties = function getProperties(key) {
    if (!key) {
      var properties = reportPartDetails && reportPartDetails.getReportPartProperties();
      var props = (0, _mobx.toJS)(properties);
      return props;
    }

    return reportPartContent.getReportPartProperties(key);
  };

  return {
    getAllChartProps: function getAllChartProps() {
      var mapProperties = reportPartContent.getMapOptions();
      return {
        chartOptions: (0, _extends3.default)({}, mapProperties, {
          colors: reportPartDetails.getThemeColors(mapProperties)
        }),
        seriesOptions: reportPartDetails.fieldCollection,
        chartData: (0, _Izenda2.parser)(reportPartContent.activeElmsByContainers, reportPartDetails.expandedLevel, {
          fieldsMapping: reportPartDetails.previewDataFieldsMapping,
          records: reportPartDetails.previewDataRecords,
          rawData: reportPartDetails.previewData
        })
      };
    },


    fnResetBorderDefaultValue: reportPartContent.resetBorderDefaultValue.bind(reportPartContent),
    fnResetBackgroundColorDefaultValue: reportPartContent.resetBackgroundColorDefaultValue.bind(reportPartContent),
    fnResetRefreshIntervalDefaultValue: reportPartContent.resetRefreshIntervalValue.bind(reportPartContent),
    fnResetLegendDefaultValue: reportPartContent.resetLegendDefaultValue.bind(reportPartContent),
    fnResetZoomDefaultValue: reportPartContent.resetZoomDefaultValue.bind(reportPartContent),

    getBorder: function getBorder() {
      return {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };
    },
    hadSettingBorder: function hadSettingBorder() {
      var currentSetting = {
        'izEntire.borderColor': getProperties('izEntire.borderColor'),
        'izEntire.borderWidth': getProperties('izEntire.borderWidth'),
        'izEntire.borderStyle': getProperties('izEntire.borderStyle')
      };

      return !((0, _fp.isEqual)(currentSetting, _Izenda.DEFAULT_SETTING_VALUE.borderDefault) || (0, _fp.isEqual)(currentSetting, _Izenda.DEFAULT_SETTING_VALUE.borderNew));
    },
    getBackgroundColor: function getBackgroundColor() {
      return {
        'izEntire.backgroundColor': getProperties('izEntire.backgroundColor'),
        'izPlot.backgroundColor': getProperties('izPlot.backgroundColor')
      };
    },
    hadSettingBackgroundColor: function hadSettingBackgroundColor() {
      var currentSetting = {
        'izEntire.backgroundColor': getProperties('izEntire.backgroundColor'),
        'izPlot.backgroundColor': getProperties('izPlot.backgroundColor')
      };

      return !((0, _fp.isEqual)(currentSetting, _Izenda.DEFAULT_SETTING_VALUE.backGroundColorDefault) || (0, _fp.isEqual)(currentSetting, _Izenda.DEFAULT_SETTING_VALUE.backGroundColorNew));
    },
    getColorTheme: function getColorTheme() {
      var properties = getProperties() || {};
      return {
        colorPalette: properties.colorTheme,
        isDefaultTheme: properties.isDefaultTheme
      };
    },
    getZoomConfig: function getZoomConfig() {
      return {
        'izMapNavigation.enabled': getProperties('izMapNavigation.enabled'),
        'izMapNavigation.align': getProperties('izMapNavigation.align'),
        'izMapNavigation.verticalAlign': getProperties('izMapNavigation.verticalAlign')
      };
    },
    hadSettingZoom: function hadSettingZoom() {
      return getProperties('izMapNavigation.enabled');
    },
    getLegendSettings: function getLegendSettings() {
      return {
        'izLegend.visibility': getProperties('izLegend.visibility'),
        'izLegend.horizontalAlign': getProperties('izLegend.horizontalAlign'),
        'izLegend.verticalAlign': getProperties('izLegend.verticalAlign'),
        'izLegend.borderColor': getProperties('izLegend.borderColor'),
        'izLegend.borderWidth': getProperties('izLegend.borderWidth'),
        'izLegend.fontStyling': getProperties('izLegend.fontStyling'),
        'izLegend.title': getProperties('izLegend.title'),
        'izLegend.layout': getProperties('izLegend.layout'),
        'izLegend.backgroundColor': getProperties('izLegend.backgroundColor')
      };
    },
    hadSettingLegend: function hadSettingLegend() {
      return getProperties('izLegend.visibility');
    },
    getDataRefreshInterval: function getDataRefreshInterval() {
      return getProperties('dataRefreshInterval');
    },
    hadSettingRefreshInterval: function hadSettingRefreshInterval() {
      var defaultSetting = _Izenda.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
      var refreshSetting = getProperties('dataRefreshInterval');

      if (!refreshSetting) return false;

      return refreshSetting.value !== defaultSetting.value || refreshSetting.updateInterval !== defaultSetting.updateInterval;
    }
  };
};

module.exports = exports['default'];

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(265);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(105);

var _Izenda4 = __webpack_require__(16);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (reportPartDetails, fieldStore) {
  var reportPartContent = reportPartDetails.reportPartContent || {};

  var getProperties = function getProperties(key) {
    if (!key) {
      var properties = reportPartDetails && reportPartDetails.getReportPartProperties();
      var props = (0, _mobx.toJS)(properties);
      return props;
    }

    return reportPartContent.getReportPartProperties(key);
  };

  return {
    isHiddenContinent: function isHiddenContinent() {
      return !reportPartContent.isMapStyle(_Izenda3.MAP_TYPES.Continent);
    },
    isHiddenCountry: function isHiddenCountry() {
      return !reportPartContent.isMapStyle(_Izenda3.MAP_TYPES.Country);
    },
    isHiddenState: function isHiddenState() {
      var countryInfo = (0, _fp.get)('properties.countryInfo', reportPartContent);
      return !countryInfo || !(0, _fp.get)('others.STATE_LIST_NAME', countryInfo);
    },
    getStateByCountry: function getStateByCountry() {
      var countryInfo = (0, _fp.get)('properties.countryInfo', reportPartContent);
      var stateListName = (0, _fp.get)('others.STATE_LIST_NAME', countryInfo);
      return _Izenda2.default[stateListName] || [];
    },
    isNotBuild: function isNotBuild() {
      return !reportPartContent.isBeingBuild;
    },
    isBeingBuild: function isBeingBuild() {
      return reportPartContent.isBeingBuild;
    },
    getChartType: function getChartType() {
      return reportPartContent.chartType;
    },


    getValueByKey: getProperties
  };
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultMapPropsMappingSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(28);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(423);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1114);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Panel: _Izenda2.default,
  OrientationSettings: _Izenda6.default,
  ColorPaletteSetting: _Izenda4.default
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultMapPropsWidget.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(265);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (reportPartDetails, fieldStore) {
  var reportPartContent = reportPartDetails.reportPartContent || {};

  var getProperties = function getProperties(key) {
    if (!key) {
      var properties = reportPartDetails && reportPartDetails.getReportPartProperties();
      var props = toJS(properties);
      return props;
    }

    return reportPartContent.getReportPartProperties(key);
  };

  return (0, _mobx.action)('OnChangeMapProps', function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, derivedChange) {
    var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
    var fieldData = groupData[changedKey];

    fieldData && (fieldData.value = changedValue);

    var generalInfo = (0, _fp.getOr)({}, 'generalInfo', schemaData);
    var labels = (0, _fp.getOr)({}, 'labels', schemaData);
    var view = (0, _fp.getOr)({}, 'view', schemaData);
    var data = (0, _fp.getOr)({}, 'data', schemaData);
    var zoomConfig = getValue('zoomConfig', view);

    var legends = (0, _fp.getOr)({}, 'legends', schemaData);
    var legendSettings = getValue('legendSettings', legends) || {};

    var izBackGroundColor = getValue('map.izBackgroundColor', schemaData) || {};
    var izBorder = getValue('map.izBorder', schemaData) || {};
    var dataRefreshInterval = getValue('dataRefreshInterval', view);
    var colorTheme = getValue('map.colorTheme', schemaData);

    var reportPartProperties = {
      chartType: (0, _fp.get)('chartType.value', generalInfo),
      continent: (0, _fp.get)('continent.value', generalInfo),
      country: (0, _fp.get)('country.value', generalInfo),
      state: (0, _fp.get)('state.value', generalInfo),
      colorTheme: colorTheme.colorPalette,
      isDefaultTheme: colorTheme.isDefaultTheme,

      commonOptions: {
        /* border */
        'izEntire.borderColor': izBorder['izEntire.borderColor'],
        'izEntire.borderWidth': izBorder['izEntire.borderWidth'],
        'izEntire.borderStyle': izBorder['izEntire.borderStyle'],

        /* background color */
        'izEntire.backgroundColor': izBackGroundColor['izEntire.backgroundColor'],
        'izPlot.backgroundColor': izBackGroundColor['izPlot.backgroundColor'],

        /* label group */
        izLabelOrientation: getValue('izLabelOrientation', labels),
        izHoverLabels: getValue('izHoverLabels', labels),

        /* Legend settings */
        'izLegend.visibility': legendSettings['izLegend.visibility'],
        'izLegend.horizontalAlign': legendSettings['izLegend.horizontalAlign'],
        'izLegend.verticalAlign': legendSettings['izLegend.verticalAlign'],
        'izLegend.borderColor': legendSettings['izLegend.borderColor'],
        'izLegend.borderWidth': legendSettings['izLegend.borderWidth'],
        'izLegend.fontStyling': legendSettings['izLegend.fontStyling'],
        'izLegend.title': legendSettings['izLegend.title'],
        'izLegend.layout': legendSettings['izLegend.layout'],
        'izLegend.backgroundColor': legendSettings['izLegend.backgroundColor']
      },

      optionByType: {
        izValueLabel: getValue('izValueLabel', data),
        izShowTooltip: getValue('izShowTooltip', data),
        izMapLabel: getValue('izMapLabel', labels),
        'izMapNavigation.enabled': zoomConfig['izMapNavigation.enabled'],
        'izMapNavigation.align': zoomConfig['izMapNavigation.align'],
        'izMapNavigation.verticalAlign': zoomConfig['izMapNavigation.verticalAlign']
      },

      view: {
        dataRefreshInterval: dataRefreshInterval
      }
    };

    changedKey === 'continent' && (reportPartProperties.continentInfo = changedOthersInfo);
    changedKey === 'country' && (reportPartProperties.countryInfo = changedOthersInfo);
    changedKey === 'state' && (reportPartProperties.stateInfo = changedOthersInfo);

    reportPartContent.setReportPartProperties(reportPartProperties);

    if (changedKey === 'chartType') {
      reportPartContent.setChartType(reportPartProperties.chartType);

      reportPartProperties.chartType === 'Continent' && (generalInfo.continent.value = getProperties('continent'));
      reportPartProperties.chartType === 'Country' && (generalInfo.country.value = getProperties('country'));
    }

    if (changedKey === 'country') {
      reportPartContent.updatePointOptionsList();
      var countryInfo = getProperties('countryInfo');
      var stateListName = (0, _fp.get)('others.STATE_LIST_NAME', countryInfo);

      if (stateListName) {
        generalInfo.state.value = getProperties('state');
        generalInfo.state.props.values.options = _Izenda2.default[stateListName] || [];
      }
    }

    if (changedKey === 'state') {
      reportPartContent.updatePointOptionsList();
    }

    derivedChange && derivedChange(reportPartProperties);
    changedKey !== 'chartType' && reportPartDetails.setReportPartProperties(reportPartProperties);

    return (0, _bluebird.resolve)({ needToUpdate: false, chartProperties: reportPartProperties });
  });
};

/**
 * Get value
 * @param {string} key
 * @param {Object} obj
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultMapPropsOnChangeValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


function getValue(key, obj) {
  return (0, _fp.get)([key, 'value'].join('.'), obj);
}
module.exports = exports['default'];

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartMapContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartMapContent model
 */

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(16);

var _Izenda2 = __webpack_require__(54);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(425);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(225);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(35);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(33);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(105);

var _Izenda13 = __webpack_require__(265);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var hasElement = _Izenda9.default.hasElement;
var getElements = _Izenda9.default.getElements;
var getContainerByField = _Izenda9.default.getContainerByField;
var populateReportChartContainer = _Izenda9.default.populateReportChartContainer;

var ReportPartMapContent = (_dec = (0, _Izenda15.exportClass)('ReportPartMapContent'), _dec(_class = (0, _Izenda3.default)(_class = (_class2 = function (_ReportPartContent) {
  (0, _inherits3.default)(ReportPartMapContent, _ReportPartContent);

  function ReportPartMapContent(data) {
    (0, _classCallCheck3.default)(this, ReportPartMapContent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartMapContent.__proto__ || (0, _getPrototypeOf2.default)(ReportPartMapContent)).call(this, _Izenda.REPORT_PART_TYPE.Map));

    _initDefineProp(_this, 'isCrossFiltering', _descriptor, _this);

    _initDefineProp(_this, 'type', _descriptor2, _this);

    _initDefineProp(_this, 'title', _descriptor3, _this);

    _initDefineProp(_this, 'description', _descriptor4, _this);

    _initDefineProp(_this, 'properties', _descriptor5, _this);

    _this.isMapStyle = function (mapStyle) {
      return _this.isChartType(_this.chartType, mapStyle);
    };

    _this.selectedExpandedLevel = 0;
    var props = {};

    // important - these containers save list of fields to get data and render report
    _Izenda9.default.addContainers(props, _Izenda12.ContainerName.COUNTRY);
    _Izenda9.default.addContainers(props, _Izenda12.ContainerName.STATE);
    _Izenda9.default.addContainers(props, _Izenda12.ContainerName.COUNTY);
    _Izenda9.default.addContainers(props, _Izenda12.ContainerName.CITY);
    _Izenda9.default.addContainers(props, _Izenda12.ContainerName.POSTAL_CODE);
    _Izenda9.default.addContainers(props, _Izenda12.ContainerName.LATITUDE);
    _Izenda9.default.addContainers(props, _Izenda12.ContainerName.LONGTITUDE);
    _Izenda9.default.addContainers(props, _Izenda12.ContainerName.SHADING_VALUES);
    _Izenda9.default.addContainers(props, _Izenda12.ContainerName.BUBBLE_VALUES);

    _this.properties.commonOptions = (0, _fp.cloneDeep)(_this.defaultCommonOptions);
    _this.properties.optionByType = (0, _fp.cloneDeep)(_this.defaultOptionsByType);

    (0, _mobx.extendObservable)(_this, props);

    data && _this.readData(data);

    // Reaction is should only triggered after the report part map content properly loads it data.
    // If doing this before initial loading data, some initial properties reset in resetDrillDownInfo.
    var mapReactions = function mapReactions() {
      // trick - access num elements of each container to trigger change
      // every have action on component (add/delete field, visible/hidden element)
      _this.drilldownReaction = (0, _mobx.reaction)(function () {
        var name = void 0;
        var totalNum = 0;
        for (name in _Izenda12.ContainerName) {
          if (_Izenda12.ContainerName.hasOwnProperty(name)) {
            totalNum += (0, _fp.getOr)(0, 'numElement', _this[_Izenda12.ContainerName[name]]);
          }
        }

        return totalNum;
      }, _this.resetDrilldownInfo.bind(_this));

      // add action to certain field: sub report, embeded...>> turn [Show Value Labels] to ON
      _this.fieldActions = (0, _mobx.reaction)(function () {
        var numActions = 0;
        var fields = (0, _fp.flatMap)(function (item) {
          return item.elements ? item.elements.slice() : [];
        }, _this.containerCollection);

        (0, _fp.forEach)(function (field) {
          numActions += (0, _fp.flow)((0, _fp.get)('numberOfPointActions'), _fp.toNumber)(field);
        }, fields);

        return {
          numActions: numActions
        };
      }, function (re) {
        return re.numActions > 0 && (_this.properties.optionByType.izValueLabel = true);
      });
    };
    mapReactions.call(_this);

    _this.cleanDirty();
    return _this;
  }

  (0, _createClass3.default)(ReportPartMapContent, [{
    key: 'validateFunction',


    /**
     * Validate function based on container
     * @method validateFunction
     * @param  {Object} container    container need validateFunction
     * @param  {Object} functionInfo Function need validate
     * @return {Object}              validate result
     */
    value: function validateFunction(container, functionInfo) {
      if (!functionInfo) {
        return {
          status: false,
          useDefaultFunction: false
        };
      }

      return {
        status: true
      };
    }

    /**
     * Get Default Function And Format for field in container
     * @method getDefaultFunctionFormat
     * @param  {Object} container Container have element need get default dataType
     * @param  {string} dataType  Data Type for field
     * @return {Object}           default data
     */

  }, {
    key: 'getDefaultFunctionFormat',
    value: function getDefaultFunctionFormat(container, dataType) {
      var byContainer = _Izenda12.DefaultFunction[container.name || ''] || {};
      return _Izenda9.default.getDefaultFunction(byContainer, dataType);
    }

    /**
     * Read data from api/create report part to update data
     * @param {Object} content [data from api/create report part]
     */

  }, {
    key: 'readData',
    value: function readData(content) {
      content = content || {};
      var properties = content.properties || {};

      this.type = content.type;
      this.isCrossFiltering = content.isCrossFiltering;

      this.buildPointOptionsData((0, _fp.get)('elements', content[_Izenda12.ContainerName.POINT_OPTIONS]), false);
      this[_Izenda12.ContainerName.SHADING_VALUES] = populateReportChartContainer(content[_Izenda12.ContainerName.SHADING_VALUES], _Izenda12.ContainerName.SHADING_VALUES);
      this[_Izenda12.ContainerName.BUBBLE_VALUES] = populateReportChartContainer(content[_Izenda12.ContainerName.BUBBLE_VALUES], _Izenda12.ContainerName.BUBBLE_VALUES);

      this.settings = content.settings;

      // report part properties
      this.setChartType(properties.chartType);
      this.setReportPartProperties(content.properties);
      this.setActiveSerie(null, (0, _fp.find)({ fieldName: content.selectedMetric }, this.serieChartList));

      this.markDirty();
    }

    /**
     * Set data by data key
     * @param {string} key
     * @param {Object} newVal
     */

  }, {
    key: 'setDataByKey',
    value: function setDataByKey(key, newVal) {
      this[key] = newVal;
      this.markDirty();
    }

    /**
     * Get data by data key
     * @param {string} key
     */

  }, {
    key: 'getDataByKey',
    value: function getDataByKey(key) {
      return this[key];
    }

    /**
     * Clean dirty status.
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.resetDirty();
    }

    /**
     * Get Map's options
     * @returns {Object}
     */

  }, {
    key: 'getMapOptions',
    value: function getMapOptions() {
      var props = (0, _mobx.toJS)(this.properties);
      var backgroundMap = this.backgroundMap;

      return (0, _fp.merge)(props, (0, _mobx.toJS)({
        //chartType: 'Map',
        commonOptions: {
          izendaOptions: {
            backgroundMapName: backgroundMap.backgroundMap,
            mapLevel: backgroundMap.mapLevel,
            activePointOption: this.activePointOption,
            dataLabelKey: (0, _fp.getOr)('', backgroundMap.mapLevel, _Izenda12.DataLabels)
          }
        }
      }));
    }

    /**
     * Get properties of report part, if propKey is null, return all properties
     * @param  {string} propKey
     * @return {Object}
     */

  }, {
    key: 'getReportPartProperties',
    value: function getReportPartProperties(propKey) {
      var props = (0, _mobx.toJS)(this.properties) || {};

      if (!propKey) {
        return props;
      }

      var definedVal = (0, _fp.get)(propKey, props.reportPartState);
      definedVal = (0, _fp.isUndefined)(definedVal) ? (0, _fp.getOr)((0, _fp.get)(propKey, props.optionByType || {}), propKey, props.commonOptions || {}) : definedVal;
      definedVal = (0, _fp.isUndefined)(definedVal) ? (0, _fp.get)(propKey, props.view) : definedVal;
      definedVal = (0, _fp.isUndefined)(definedVal) ? (0, _fp.get)(propKey, props) : definedVal;

      return definedVal;
    }

    /**
     * Set properties of report part
     * @param {Object}
     */

  }, {
    key: 'setReportPartProperties',
    value: function setReportPartProperties(newProps) {
      var preChartType = this.chartType;
      var newReportPartState = newProps.reportPartState || {};
      var reportPartState = this.properties.reportPartState;

      // mobx limitation (v2.4.4) - cannot extend observable array
      if (newReportPartState.drilldownInfo) {
        reportPartState.drilldownInfo = newReportPartState.drilldownInfo;
      }

      if (newReportPartState.pointOptionsList) {
        reportPartState.pointOptionsList = newReportPartState.pointOptionsList;
      }
      // To keep this "activeSerie" property from disappearance
      if (!newReportPartState.activeSerie) {
        newReportPartState.activeSerie = {};
      }

      if (!(0, _fp.isUndefined)(newProps.colorTheme) || newProps.isDefaultTheme) {
        this.properties.isDefaultTheme = newProps.isDefaultTheme;
        this.properties.colorTheme = newProps.colorTheme;
      }

      (0, _mobx.extendObservable)(this.properties, newProps);
      this.convertChartType(preChartType, this.chartType);
      this.markDirty();
    }

    /**
     * Get dirty status.
     * @returns {boolean}
     */

  }, {
    key: 'checkDirty',
    value: function checkDirty() {
      var dirtyElements = _Izenda7.default.dirtyReportPartElementField(this.containerCollection);
      var properties = this.properties;

      return this.isDirty || !(0, _fp.isEmpty)(dirtyElements) || properties && properties.checkDirty && properties.checkDirty();
    }

    /**
     * Set Chart type
     * @param {string} nextType
     */

  }, {
    key: 'setChartType',
    value: function setChartType(nextType) {
      var previousType = this.properties.chartType;
      this.properties.chartType = nextType;
      this.convertChartType(previousType, nextType);
      this.markDirty();
    }

    /**
     * Convert chart type
     * @param  {string} previousType
     * @param  {string} nextType
     * @return {boolean|undefined}
     */

  }, {
    key: 'convertChartType',
    value: function convertChartType(previousType, nextType) {
      if (!previousType) {
        return false;
      }

      if (previousType === nextType) {
        return false;
      }

      this.resetDrilldownInfo();
      var props = this.properties;

      switch (nextType) {
        case _Izenda12.MAP_TYPES.World:
          {
            props.continentInfo = {};
            props.countryInfo = {};
            props.stateInfo = {};
            break;
          }

        case _Izenda12.MAP_TYPES.Continent:
          {
            props.continentInfo = _Izenda14.default.getMapInfo(_Izenda12.DefaultContinent);
            props.continent = _Izenda12.DefaultContinent;

            props.country = '';
            props.countryInfo = {};

            props.state = '';
            props.stateInfo = {};
            break;
          }

        case _Izenda12.MAP_TYPES.Country:
          {
            props.continent = '';
            props.continentInfo = {};

            props.country = _Izenda12.DefaultCountry;
            props.countryInfo = _Izenda14.default.getMapInfo(_Izenda12.DefaultCountry);

            props.state = '';
            props.stateInfo = {};
            break;
          }
      }

      this.markDirty();
    }

    /**
     * Build data for save
     * @returns {Object}
     */

  }, {
    key: 'buildDataForSave',
    value: function buildDataForSave() {
      var allPointContainers = _Izenda12.PointsOptionsOrder;
      var mapContent = (0, _mobx.toJS)((0, _fp.omit)(allPointContainers, this));
      mapContent[_Izenda12.ContainerName.POINT_OPTIONS] = (0, _mobx.toJS)(this.buildPointOptionsData(allPointContainers, true));
      mapContent.selectedMetric = (0, _fp.get)('activeSerie.fieldName', this);

      return mapContent;
    }

    /**
     * Build point option data
     * @param {Object} pointContainers
     * @param {boolean} isZipData
     */

  }, {
    key: 'buildPointOptionsData',
    value: function buildPointOptionsData(pointContainers, isZipData) {
      // Do not build point when point containers is empty
      if (!pointContainers) {
        return;
      }

      if (isZipData) {
        return combineAllPointOptions.apply(this);
      } else {
        return separateAllPointOptions.apply(this);
      }

      // combine all of elements of point-options container to 1 container with name [ContainerName.POINT_OPTIONS]
      function combineAllPointOptions() {
        var _this2 = this;

        var pointsOptions = {};
        var position = 1;

        _Izenda9.default.addContainers(pointsOptions, _Izenda12.ContainerName.POINT_OPTIONS);

        pointsOptions = pointsOptions[_Izenda12.ContainerName.POINT_OPTIONS];

        // combine all of elements of point-options container to 1 container with name [ContainerName.POINT_OPTIONS]
        pointContainers.map(function (containerName) {
          (0, _fp.map)(function (elm) {
            pointsOptions.elements.push((0, _fp.flow)((0, _fp.set)('position', position), (0, _fp.set)('properties.pointOptionType', containerName))(elm));
            position++;
          }, _this2[containerName].elements);
        });

        return pointsOptions;
      }

      function separateAllPointOptions() {
        var _this3 = this;

        // TODO
        var pointOptionType = void 0;

        pointContainers.forEach(function (elm) {
          pointOptionType = (0, _fp.get)('properties.pointOptionType', elm);
          if (!pointOptionType) {
            return;
          }
          _this3[pointOptionType] = populateReportChartContainer({ elements: [elm] }, pointOptionType);
        });
      }
    }

    /**
     * Set active serie key, used to show/hide serie chart in metric dropdown
     * @param {string} activeSerieKey
     * @param {Object} activeSerieInfo
     */

  }, {
    key: 'setActiveSerie',
    value: function setActiveSerie(activeSerieKey, activeSerieInfo) {
      var reportPartState = (0, _fp.get)('properties.reportPartState', this);
      reportPartState.activeSerie = activeSerieInfo;
      this.markDirty();
    }

    /**
     * Set active point option
     * @param {string} activePointOptionKey
     * @param {Object} activePointOption
     */

  }, {
    key: 'setActivePointOption',
    value: function setActivePointOption(activePointOptionKey, activePointOption) {
      var reportPartState = (0, _fp.get)('properties.reportPartState', this);
      reportPartState.activePointOption = activePointOption;
      this.markDirty();
    }

    /**
     * Enable show value labels
     * It's used when one of these customURL, embeddedJavascript, subreport are configured
     */

  }, {
    key: 'enableValueLabel',
    value: function enableValueLabel() {
      this.properties.optionByType.izValueLabel = true;
    }

    /**
     * Update drilldown info
     * @param {Object} drilldown
     */

  }, {
    key: 'updateDrilldownInfo',
    value: function updateDrilldownInfo(drilldown) {
      this.markDirty();

      if (!drilldown) {
        // move to top level
        return this.resetDrilldownInfo();
      }

      var drilldownInfo = this.drilldownInfo;
      var field = drilldown.field;
      var point = drilldown.point;
      var mapInfo = drilldown.mapInfo;
      var allowToDrilldown = void 0;

      var deleteChildLevel = function deleteChildLevel(fromLevel) {
        var fromLevelIndex = (0, _fp.findIndex)(function (drilldown) {
          return (0, _fp.get)('mapInfo.mapLevel', drilldown) === fromLevel;
        }, drilldownInfo);

        return fromLevelIndex > -1 ? drilldownInfo.splice(fromLevelIndex + 1, drilldownInfo.length - fromLevelIndex - 1) : null;
      };

      var addNewLevel = function addNewLevel(currentDrilldownLevel, field, point) {
        var currentDrilldownOrder = _Izenda12.DrilldownOrders.indexOf(currentDrilldownLevel);
        var nextLevel = _Izenda12.DrilldownOrders[currentDrilldownOrder + 1];
        var nextMapInfo = nextLevel && _Izenda14.default.searchMapInfoByMapLevel(nextLevel, (0, _fp.get)('pointInfo', point));

        if (nextMapInfo) {
          return drilldownInfo.push({
            field: field,
            point: point,
            mapInfo: {
              mapLevel: nextLevel,
              backgroundMap: nextMapInfo
            }
          });
        }

        return null;
      };

      if (mapInfo) {
        // drill up
        allowToDrilldown = deleteChildLevel(mapInfo.mapLevel);
      } else {
        // drill down
        allowToDrilldown = addNewLevel(this.currentDrilldownLevel, field, point);
      }

      if (allowToDrilldown) {
        return this.updatePointOptionsList(!!mapInfo);
      } else {
        return null;
      }
    }

    /**
     * Reset drilldown info
     */

  }, {
    key: 'resetDrilldownInfo',
    value: function resetDrilldownInfo() {
      var reportPartState = (0, _fp.get)('properties.reportPartState', this);
      reportPartState.drilldownInfo.clear();
      this.updatePointOptionsList(true);
      this.markDirty();
    }

    /**
     * After insert field to container
     */

  }, {
    key: 'afterInsertFieldToContainer',
    value: function afterInsertFieldToContainer() {
      this.resetDrilldownInfo();
      this.markDirty();
      return null;
    }

    /**
     * Get drilldown info
     */

  }, {
    key: 'getDrilldownInfo',
    value: function getDrilldownInfo() {
      var drilldownInfo = this.drilldownInfo;
      var filters = [];
      var expandedLevel = 0;
      var pointType = (0, _fp.get)('pointType', this.activePointOption);
      var pointTypeIndex = _Izenda12.PointsOptionsOrder.indexOf(pointType);

      var pointName = void 0,
          drilldownByField = void 0;

      for (var i = 0; i < pointTypeIndex; i++) {
        pointName = _Izenda12.PointsOptionsOrder[i];
        if (hasElement(this[pointName])) {
          expandedLevel++;

          drilldownByField = getDrilldownInfoOfField(drilldownInfo, this[pointName].visibleElement[0]);
          drilldownByField && filters.push({
            key: (0, _fp.get)('point.poinOptionName', drilldownByField),
            value: (0, _fp.get)('point.pointName', drilldownByField)
          });
        }
      }

      // for latitude options, we have to get data for both latitude & longtitude
      if (pointType === _Izenda12.ContainerName.LATITUDE) {
        expandedLevel += 1;
      }

      this.selectedExpandedLevel = expandedLevel;

      return {
        filters: filters,
        expandedLevel: expandedLevel
      };

      function getDrilldownInfoOfField(drilldownInfo, field) {
        return (0, _fp.find)(function (drilldown) {
          return (0, _fp.get)('mapInfo.mapLevel', drilldown) !== _Izenda12.DrilldownLevels.CONTINENT && (0, _fp.get)('point.poinOptionName', drilldown) === field.fieldName;
        }, drilldownInfo);
      }
    }

    /**
     * Get drilled down points.
     * @return {Array}
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var drillDownInfo = (0, _fp.getOr)([], 'drilldownInfo', this);

      return (0, _fp.map)(function (level) {
        var point = (0, _fp.getOr)({}, 'point', level);
        return (0, _fp.assign)(level, {
          value: point.name || (0, _fp.get)('mapInfo.backgroundMap.label', level)
        });
      }, drillDownInfo);
    }

    /**
     * Get Crossfilter Info.
     * @return {Array}
     */

  }, {
    key: 'getCrossFilteringInfo',
    value: function getCrossFilteringInfo() {
      var points = this.getPoints();

      var filters = [];
      if ((0, _fp.isEmpty)(points)) {
        return filters;
      }

      (0, _fp.forEach)(function (p) {
        !(0, _fp.isEmpty)(p.mapInfo.backgroundMap.value) && p.point.poinOptionName && filters.push({
          key: p.point.poinOptionName,
          value: p.value,
          field: (0, _fp.get)('point.drillingDownField', p)
        });
      }, points);

      return filters;
    }

    /**
     * Reset point options to first element
     */

  }, {
    key: 'updateActivePointOptions',
    value: function updateActivePointOptions() {
      this.setActivePointOption(null, (0, _fp.first)(this.pointOptionsList));
      this.markDirty();
    }

    /**
     * Update Point option list
     * @method updatePointOptionsList
     * @param  {boolean} isDrillUp    flag to notify user drill up. Back the point option to the top level.
     */

  }, {
    key: 'updatePointOptionsList',
    value: function updatePointOptionsList(isDrillUp) {
      var _this4 = this;

      var pointList = [];
      var activeSerie = this.activeSerie;
      var activeContainer = activeSerie && getContainerByField(this.containerCollection, activeSerie);
      var currentDrilldownLevel = this.currentDrilldownLevel;
      var showingBackgroundMapInfo = (0, _fp.flow)(_fp.last, (0, _fp.get)('mapInfo.backgroundMap'))(this.drilldownInfo);
      var hasShadingValues = void 0,
          hasBubbleValues = void 0;

      var updatePointList = function updatePointList(newList) {
        var activePointOptionType = (0, _fp.get)('pointType', _this4.activePointOption);
        var isValidActivePointOptions = (0, _fp.find)({ pointType: activePointOptionType }, newList);

        _this4.pointOptionsList.replace(newList);
        // Reset the point action to the top level when :
        // 1. The current option is not existed in options list.
        // 2. User drill up map.
        (!isValidActivePointOptions || isDrillUp) && _this4.updateActivePointOptions();
        _this4.markDirty();
      };

      var addField = function addField(container, source, containerName) {
        (0, _fp.forEach)(function (field) {
          source.push({
            label: field.fieldName,
            value: field.fieldName,
            field: field,
            pointType: containerName,
            pointTypeName: containerName === _Izenda12.ContainerName.LATITUDE ? [_Izenda12.ContainerName.LATITUDE, _Izenda12.ContainerName.LONGTITUDE].join('_') : containerName
          });
        }, container.visibleElement);
      };

      var getPointOptionsForShading = function getPointOptionsForShading(currentDrilldownLevel, showingBackgroundMapInfo) {
        var pointOptions = [];

        switch (currentDrilldownLevel) {
          case _Izenda12.DrilldownLevels.WORLD:
          case _Izenda12.DrilldownLevels.CONTINENT:
            pointOptions = [_Izenda12.ContainerName.COUNTRY];
            break;
          case _Izenda12.DrilldownLevels.COUNTRY:
            pointOptions = [_Izenda12.ContainerName.STATE];

            // only show if background-info has county-map
            if ((0, _fp.get)('others.COUNTY_MAP', showingBackgroundMapInfo)) {
              pointOptions.push(_Izenda12.ContainerName.COUNTY);
            }
            break;
          case _Izenda12.DrilldownLevels.STATE:
            pointOptions = [_Izenda12.ContainerName.COUNTY];
            break;
          default:
          // do nothing
        }

        return pointOptions;
      };

      var pointOptionsForBubble = function pointOptionsForBubble(currentDrilldownLevel, showingBackgroundMapInfo) {
        if (!hasBubbleValues) {
          return [];
        }

        // Show state point options only when drilldown level is not higher than state
        var pointOptions = currentDrilldownLevel === _Izenda12.DrilldownLevels.STATE ? [_Izenda12.ContainerName.CITY, _Izenda12.ContainerName.POSTAL_CODE] : [_Izenda12.ContainerName.STATE, _Izenda12.ContainerName.CITY, _Izenda12.ContainerName.POSTAL_CODE];

        if (hasElement.call(_this4, _Izenda12.ContainerName.LONGTITUDE) && hasElement.call(_this4, _Izenda12.ContainerName.LATITUDE)) {
          pointOptions.push(_Izenda12.ContainerName.LATITUDE);
        }

        return pointOptions;
      };

      // show all metric
      if (!activeContainer) {
        hasShadingValues = hasElement.call(this, _Izenda12.ContainerName.SHADING_VALUES);
        hasBubbleValues = hasElement.call(this, _Izenda12.ContainerName.BUBBLE_VALUES);
      } else {
        hasShadingValues = (0, _fp.get)('name', activeContainer) === _Izenda12.ContainerName.SHADING_VALUES;
        hasBubbleValues = (0, _fp.get)('name', activeContainer) === _Izenda12.ContainerName.BUBBLE_VALUES;
      }

      if (!hasShadingValues && !hasBubbleValues) {
        return updatePointList([]);
      }

      var pointOptionsShading = getPointOptionsForShading.call(this, currentDrilldownLevel, showingBackgroundMapInfo);
      var pointOptionsBubble = pointOptionsForBubble.call(this, currentDrilldownLevel);

      // remove duplicated container
      var pointContainerNames = void 0;

      if (hasShadingValues && !hasBubbleValues) {
        pointContainerNames = pointOptionsShading;
      } else {
        pointContainerNames = (0, _fp.uniq)((0, _fp.concat)(pointOptionsShading, pointOptionsBubble));
      }

      // combine containers to an array
      pointContainerNames.forEach(function (name) {
        addField(_this4[name], pointList, name);
      });

      return updatePointList(pointList);
    }

    /**
     * check if function is compatible with element
     * @method checkedCompatibleFunction
     * @param  {Object} container    Container that element belong
     * @param  {Object} element      Element need to validate
     * @param  {Object} functionInfo Function infomation
     * @return {boolean}             Result
     */

  }, {
    key: 'checkedCompatibleFunction',
    value: function checkedCompatibleFunction(container, element, functionInfo) {
      if (!container) {
        return true;
      }

      if (element.field.hasAggregatedFunction) {
        return _Izenda9.default.checkedCompatibleFunctionHasAggregatedFunction(functionInfo);
      }

      var isValues = [_Izenda12.ContainerName.SHADING_VALUES, _Izenda12.ContainerName.BUBBLE_VALUES].indexOf(container.name) > -1;
      var functionConfig = _Izenda12.FunctionConfig[isValues ? 'VALUES' : 'POINT_OPTIONS'];

      return _Izenda9.default.checkCompatibleFunctionCommon(functionInfo, element, functionConfig);
    }

    /**
     * Check need to break page when printing.
     */

  }, {
    key: 'checkBreakPage',
    value: function checkBreakPage() {
      return false;
    }

    /**
     * Reset drilldown info whenever reorder field
     */

  }, {
    key: 'changePositionField',
    value: function changePositionField() {
      this.resetDrilldownInfo();
    }

    /**
     * Check if this field can have state Unsort
     */

  }, {
    key: 'checkCanUnsort',
    value: function checkCanUnsort() {
      return false;
    }

    /**
     * Get container name
     * @param {Object} container
     * @returns {string}
     */

  }, {
    key: 'getContainerName',
    value: function getContainerName(container) {
      return container.name === _Izenda12.ContainerName.SHADING_VALUES || container.name === _Izenda12.ContainerName.BUBBLE_VALUES ? container.name : _Izenda12.ContainerName.POINT_OPTIONS;
    }

    /**
     * Reset border setting to default value
     */

  }, {
    key: 'resetBorderDefaultValue',
    value: function resetBorderDefaultValue() {
      this.properties.commonOptions['izEntire.borderColor'] = _Izenda12.DEFAULT_SETTING_VALUE.borderDefault['izEntire.borderColor'];
      this.properties.commonOptions['izEntire.borderWidth'] = _Izenda12.DEFAULT_SETTING_VALUE.borderDefault['izEntire.borderWidth'];
      this.properties.commonOptions['izEntire.borderStyle'] = _Izenda12.DEFAULT_SETTING_VALUE.borderDefault['izEntire.borderStyle'];
      this.markDirty();
    }

    /**
     * Reset background color setting to default value
     */

  }, {
    key: 'resetBackgroundColorDefaultValue',
    value: function resetBackgroundColorDefaultValue() {
      this.properties.commonOptions['izEntire.backgroundColor'] = _Izenda12.DEFAULT_SETTING_VALUE.backGroundColorDefault['izEntire.backgroundColor'];
      this.properties.commonOptions['izPlot.backgroundColor'] = _Izenda12.DEFAULT_SETTING_VALUE.backGroundColorDefault['izPlot.backgroundColor'];
      this.markDirty();
    }

    /**
     * Reset refresh interval setting to default value
     * @returns {Object}
     */

  }, {
    key: 'resetRefreshIntervalValue',
    value: function resetRefreshIntervalValue() {
      this.properties.view.dataRefreshInterval = _Izenda12.DEFAULT_SETTING_VALUE.refreshIntervalDefault;
      this.markDirty();
      return this.properties.view.dataRefreshInterval;
    }

    /**
     * Reset legend setting to default value
     * @returns {Object}
     */

  }, {
    key: 'resetLegendDefaultValue',
    value: function resetLegendDefaultValue() {
      this.properties.commonOptions['izLegend.visibility'] = false;
      this.markDirty();
      return this.properties.commonOptions;
    }

    /**
     * Reset zoom setting to default value
     * @returns {Object}
     */

  }, {
    key: 'resetZoomDefaultValue',
    value: function resetZoomDefaultValue() {
      this.properties.optionByType['izMapNavigation.enabled'] = false;
      this.markDirty();
      return this.properties.optionByType;
    }

    /**
     * Check if ReportPart is drilling down or not
     * @return {boolean}
     */

  }, {
    key: 'isDrillingDown',
    value: function isDrillingDown() {
      return this.hasDrillDown;
    }

    /**
     * Get metric container
     */

  }, {
    key: 'getMetricContainer',
    value: function getMetricContainer() {
      var activeSerieKey = (0, _fp.get)('fieldName', this.activeSerie);
      var pointType = (0, _fp.get)('pointType', this.activePointOption);

      if ((0, _fp.isEmpty)(activeSerieKey)) return null;

      if (_Izenda12.PointsOptionsForBubbleAll.indexOf(pointType) > -1 && !(0, _fp.isEmpty)(getElements(this[_Izenda12.ContainerName.BUBBLE_VALUES], activeSerieKey))) {
        return _Izenda12.ContainerName.BUBBLE_VALUES;
      }

      if (_Izenda12.PointsOptionsForShading.indexOf(pointType) > -1 && !(0, _fp.isEmpty)(getElements(this[_Izenda12.ContainerName.SHADING_VALUES], activeSerieKey))) {
        return _Izenda12.ContainerName.SHADING_VALUES;
      }
    }
  }, {
    key: 'chartType',
    get: function get() {
      return this.properties.chartType;
    }
  }, {
    key: 'drilldownInfo',
    get: function get() {
      return (0, _fp.get)('properties.reportPartState.drilldownInfo', this);
    }

    // use to show/hide fields which need to draw chart - do not save

  }, {
    key: 'activeSerie',
    get: function get() {
      return (0, _fp.get)('properties.reportPartState.activeSerie', this);
    }
  }, {
    key: 'activePointOption',
    get: function get() {
      return (0, _fp.get)('properties.reportPartState.activePointOption', this);
    }
  }, {
    key: 'pointOptionsList',
    get: function get() {
      return (0, _fp.get)('properties.reportPartState.pointOptionsList', this);
    }
  }, {
    key: 'containerCollection',
    get: function get() {
      var _this5 = this;

      var containers = [];

      (0, _fp.values)(_Izenda12.ContainerName).forEach(function (containerName) {
        _this5[containerName] && containers.push(_this5[containerName]);
      });

      return containers;
    }
  }, {
    key: 'isBeingBuild',
    get: function get() {
      var activePointOption = this.activePointOption;
      var pointType = (0, _fp.get)('pointType', activePointOption);
      var isBeingBuildShading = void 0,
          isBeingBuildBubble = void 0;

      if (_Izenda12.PointsOptionsForBubbleAll.indexOf(pointType) > -1 && hasElement.call(this, _Izenda12.ContainerName.BUBBLE_VALUES)) {
        isBeingBuildBubble = true;
      }

      if (_Izenda12.PointsOptionsForShading.indexOf(pointType) > -1 && hasElement.call(this, _Izenda12.ContainerName.SHADING_VALUES)) {
        isBeingBuildShading = true;
      }

      return isBeingBuildShading || isBeingBuildBubble;
    }
  }, {
    key: 'dataRefreshInterval',
    get: function get() {
      return (0, _fp.get)('view.dataRefreshInterval', this.properties);
    }
  }, {
    key: 'optionalParams',
    get: function get() {
      return this.getDrilldownInfo();
    }
  }, {
    key: 'serieChartList',
    get: function get() {
      var _this6 = this;

      var series = [];
      var containerNames = [];
      var pointType = (0, _fp.get)('pointType', this.activePointOption);

      if (_Izenda12.PointsOptionsForBubbleAll.indexOf(pointType) > -1) {
        containerNames.push(_Izenda12.ContainerName.BUBBLE_VALUES);
      }

      if (_Izenda12.PointsOptionsForShading.indexOf(pointType) > -1) {
        containerNames.push(_Izenda12.ContainerName.SHADING_VALUES);
      }

      containerNames.forEach(function (containerName) {
        return _this6[containerName].visibleElement.forEach(function (field) {
          series.push(field);
        });
      });

      return series;
    }
  }, {
    key: 'activeElmsByContainers',
    get: function get() {
      var containers = {};
      var activeSerieKey = (0, _fp.get)('fieldName', this.activeSerie);
      var pointType = (0, _fp.get)('pointType', this.activePointOption);

      // point options
      if ([_Izenda12.ContainerName.LATITUDE, _Izenda12.ContainerName.LONGTITUDE].indexOf(pointType) > -1) {
        containers[_Izenda12.ContainerName.LATITUDE] = getElements(this[_Izenda12.ContainerName.LATITUDE]);
        containers[_Izenda12.ContainerName.LONGTITUDE] = getElements(this[_Izenda12.ContainerName.LONGTITUDE]);
      } else {
        // add country container for state level
        // to filter state belong to drilldown country
        pointType === _Izenda12.ContainerName.STATE && (containers[_Izenda12.ContainerName.COUNTRY] = getElements(this[_Izenda12.ContainerName.COUNTRY]));

        pointType === _Izenda12.ContainerName.COUNTY && (containers[_Izenda12.ContainerName.STATE] = getElements(this[_Izenda12.ContainerName.STATE]));

        pointType && (containers[pointType] = getElements(this[pointType]));
      }

      if (_Izenda12.PointsOptionsForBubbleAll.indexOf(pointType) > -1) {
        containers[_Izenda12.ContainerName.BUBBLE_VALUES] = getElements(this[_Izenda12.ContainerName.BUBBLE_VALUES], activeSerieKey);
      }

      if (_Izenda12.PointsOptionsForShading.indexOf(pointType) > -1) {
        containers[_Izenda12.ContainerName.SHADING_VALUES] = getElements(this[_Izenda12.ContainerName.SHADING_VALUES], activeSerieKey);
      }

      return containers;
    }
  }, {
    key: 'hasDrillDown',
    get: function get() {
      return !!this.drilldownInfo.length;
    }
  }, {
    key: 'currentDrilldownLevel',
    get: function get() {
      var lastDrilldownLevel = (0, _fp.last)(this.drilldownInfo);

      if (lastDrilldownLevel) {
        return (0, _fp.get)('mapInfo.mapLevel', lastDrilldownLevel);
      } else {
        return this.mapLevelBySelectedChartType;
      }
    }
  }, {
    key: 'mapLevelBySelectedChartType',
    get: function get() {
      var props = this.properties;

      if ((0, _fp.get)('geoFile', props.stateInfo)) {
        return _Izenda12.DrilldownLevels.STATE;
      } else if ((0, _fp.get)('geoFile', props.countryInfo)) {
        return _Izenda12.DrilldownLevels.COUNTRY;
      } else if ((0, _fp.get)('geoFile', props.continentInfo)) {
        return _Izenda12.DrilldownLevels.CONTINENT;
      }
      return _Izenda12.DrilldownLevels.WORLD;
    }
  }, {
    key: 'backgroundMap',
    get: function get() {
      var properties = this.properties;
      var backgroundInfo = void 0,
          mapLevel = void 0,
          backgroundMap = void 0;

      if (!this.drilldownInfo.length) {
        if ((0, _fp.has)('geoFile', properties.stateInfo)) {
          backgroundInfo = properties.stateInfo;
          mapLevel = _Izenda12.DrilldownLevels.STATE;
        } else if ((0, _fp.has)('geoFile', properties.countryInfo)) {
          backgroundInfo = properties.countryInfo;
          mapLevel = _Izenda12.DrilldownLevels.COUNTRY;
        } else if ((0, _fp.has)('geoFile', properties.continentInfo)) {
          backgroundInfo = properties.continentInfo;
          mapLevel = _Izenda12.DrilldownLevels.CONTINENT;
        }
      } else {
        var lastDrilldownLevel = (0, _fp.last)(this.drilldownInfo);

        backgroundInfo = (0, _fp.get)('mapInfo.backgroundMap', lastDrilldownLevel);
        mapLevel = (0, _fp.get)('mapInfo.mapLevel', lastDrilldownLevel);
      }

      backgroundMap = (0, _fp.get)('geoFile', backgroundInfo);

      return {
        backgroundMap: backgroundMap || _Izenda12.DefaultGEOBackground,
        mapLevel: mapLevel || _Izenda12.DrilldownLevels.WORLD
      };
    }
  }, {
    key: 'reportPartStyle',
    get: function get() {
      return this.properties.chartType;
    }
  }, {
    key: 'isShowMetric',
    get: function get() {
      return !(0, _fp.isEmpty)(this.serieChartList) && this.serieChartList.length > 1;
    }

    /**
     * Determine whether the report part content automatically sizes its container or not
     */

  }, {
    key: 'autoSize',
    get: function get() {
      return false;
    }
  }]);
  return ReportPartMapContent;
}(_Izenda5.default), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isCrossFiltering', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'title', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'description', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'properties', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      reportPartState: {
        drilldownInfo: [],
        activeSerie: {},
        activePointOption: {},
        pointOptionsList: []
      },
      chartType: _Izenda12.DefaultChartType,
      colorTheme: undefined,
      isDefaultTheme: true,
      continentInfo: {},
      countryInfo: {},
      stateInfo: {},
      commonOptions: {},
      optionByType: {},
      view: {
        showLabels: false,
        dataRefreshInterval: {
          enable: false,
          updateInterval: 0,
          isAll: true,
          latestRecord: 0
        }
      }
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'chartType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'chartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'drilldownInfo', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'drilldownInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'activeSerie', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'activeSerie'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'activePointOption', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'activePointOption'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'pointOptionsList', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'pointOptionsList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'containerCollection', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'containerCollection'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isBeingBuild', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isBeingBuild'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'dataRefreshInterval', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'dataRefreshInterval'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'optionalParams', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'optionalParams'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'serieChartList', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'serieChartList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'activeElmsByContainers', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'activeElmsByContainers'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasDrillDown', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasDrillDown'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'currentDrilldownLevel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'currentDrilldownLevel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'mapLevelBySelectedChartType', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'mapLevelBySelectedChartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'backgroundMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'backgroundMap'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reportPartStyle', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reportPartStyle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isShowMetric', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isShowMetric'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setDataByKey', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setDataByKey'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setReportPartProperties', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setReportPartProperties'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setChartType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setChartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'convertChartType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'convertChartType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'buildDataForSave', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'buildDataForSave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'buildPointOptionsData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'buildPointOptionsData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setActiveSerie', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setActiveSerie'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setActivePointOption', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setActivePointOption'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDrilldownInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDrilldownInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetDrilldownInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetDrilldownInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterInsertFieldToContainer', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterInsertFieldToContainer'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getDrilldownInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getDrilldownInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateActivePointOptions', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateActivePointOptions'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updatePointOptionsList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updatePointOptionsList'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changePositionField', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changePositionField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetBorderDefaultValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetBorderDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetBackgroundColorDefaultValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetBackgroundColorDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetRefreshIntervalValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetRefreshIntervalValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetLegendDefaultValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetLegendDefaultValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetZoomDefaultValue', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetZoomDefaultValue'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ReportPartMapContent;
module.exports = exports['default'];

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(428);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(602);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(603);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(16);

var _Izenda12 = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Izenda2.default.extendConfiguration(_Izenda11.REPORT_PART_TYPE.Map, _Izenda12.MAP_TYPES.World, null, {
  get visualLabel() {
    return _Izenda4.default.getText('REPORT_PART_MAP_CONSTANTS_WORLD');
  },

  optionsBuilder: _Izenda6.default,

  fieldContainerSchema: _Izenda10.default,

  optionsMapping: _Izenda8.default
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.WorldMapConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(428);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(602);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(603);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(16);

var _Izenda12 = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Izenda2.default.extendConfiguration(_Izenda11.REPORT_PART_TYPE.Map, _Izenda12.MAP_TYPES.Continent, null, {
  get visualLabel() {
    return _Izenda4.default.getText('REPORT_PART_MAP_CONSTANTS_CONTINENT');
  },

  optionsBuilder: _Izenda6.default,

  fieldContainerSchema: _Izenda10.default,

  optionsMapping: _Izenda8.default
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.ContinentMapConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(428);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(602);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(603);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(16);

var _Izenda12 = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Izenda2.default.extendConfiguration(_Izenda11.REPORT_PART_TYPE.Map, _Izenda12.MAP_TYPES.Country, null, {
  get visualLabel() {
    return _Izenda4.default.getText('REPORT_PART_MAP_CONSTANTS_COUNTRY');
  },

  optionsBuilder: _Izenda6.default,

  fieldContainerSchema: _Izenda10.default,

  optionsMapping: _Izenda8.default
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.CountryMapConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(142);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Export the using Izenda components and 3rd party lib that would be useful to create custom Izenda components
 */
// ----------------------------------------------------------------------
// <copyright file="Izenda.Components.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * React lib
   */
  React: _react2.default,
  /**
   * A higher order function to create observable React component
   */
  observableReact: _mobxReact.observer,
  /**
   * Observe an instance with observable properties
   */
  observableObject: _mobx.extendObservable,
  /**
   * A higher order function to create observable action to apply all changes to observable object in one commit
   */
  observableAction: _mobx.action,
  /**
   * Register a custom report part type
   */
  ReportPartTypeManager: _Izenda2.default,
  /**
   * Register a new language text
   */
  Localizer: _Izenda6.default,
  /**
   * A higher order component to create a validatable component that works with validation UI inside Izenda app
   */
  Validator: _Izenda4.default
};
module.exports = exports['default'];

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(120);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthenApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var securityManager = new _Izenda4.default();
var AuthenApi = {
  /**
   * This function is intended to pass the user context info
   * currentUserContext:
     currentUserContext: {
       token: null
      }
    */
  setCurrentUserContext: function setCurrentUserContext(currentUserContext) {
    ensure(currentUserContext, 'Must be set current user context');
    if (currentUserContext.token !== _Izenda2.default.currentUserContext.token) {
      _Izenda2.default.currentUserContext.token = currentUserContext.token;
      securityManager.clearPermission();
    }
  }
};

exports.default = AuthenApi;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ConfigApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var cfg = __webpack_require__(40);

  module.exports = {
    /**
    * Initialize Synergy config. It must be configured properly before rendering
    * components.
    */
    config: function config(options) {
      cfg.set(options);
    }
  };
}();

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RenderApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var compose = __webpack_require__(9).compose;

  var renderAction = compose(__webpack_require__(231).defineContext, __webpack_require__(604).defineContext);

  var App = renderAction(__webpack_require__(2120));
  var ReportPartPage = __webpack_require__(2803);
  var SettingPage = __webpack_require__(2805);
  var ReportPage = __webpack_require__(2807);
  var DashboardPage = renderAction(__webpack_require__(2808));
  var DashboardViewerPage = renderAction(__webpack_require__(2809));
  var ReportViewerPage = renderAction(__webpack_require__(2810));
  var ReportDesignerPage = __webpack_require__(2811);
  var m = __webpack_require__(5);
  var IntergrateStore = __webpack_require__(319);

  var _require = __webpack_require__(1),
      forEach = _require.forEach,
      cloneDeep = _require.cloneDeep;

  var addDestroy = function addDestroy(container, resultApi) {
    resultApi.destroy = function () {
      ReactDOM.unmountComponentAtNode(container);
    };
  };

  var buildExposeFunction = function buildExposeFunction(container) {
    var returnObject = {};
    var registerExposeMethod = function registerExposeMethod(exposeMethod) {
      (0, _assign2.default)(returnObject, exposeMethod);
    };
    var unregisterExposeMethod = function unregisterExposeMethod(methodNames) {
      forEach(function (methodName) {
        delete returnObject[methodName];
      }, methodNames);
    };

    addDestroy(container, returnObject);

    return {
      returnObject: returnObject,
      registerExposeMethod: registerExposeMethod,
      unregisterExposeMethod: unregisterExposeMethod
    };
  };

  module.exports = {
    /**
     * React BI Components
     */
    Components: {
      App: App,
      Settings: SettingPage,
      ReportDesigner: ReportDesignerPage,
      ReportViewer: ReportViewerPage,
      ReportPart: ReportPartPage,
      Report: ReportPage,
      Dashboard: DashboardPage,
      DashboardViewer: DashboardViewerPage
    },

    /**
     * Expose ReactDOM Component at node to use the same version of ReactDOM for
     * both render and unmountComponentAtNode
     * @method unmountComponent
     * @param  {DOM} container
     */
    unmountComponent: function unmountComponent(container) {
      IntergrateStore.reset();
      ReactDOM.unmountComponentAtNode(container);
    },

    /**
     * Render Synergy root component to actual DOM element.
     */
    render: function render(container, integrationStyle) {
      var exposeObject = buildExposeFunction(container);

      integrationStyle = m.observable(cloneDeep(integrationStyle));

      ReactDOM.render(React.createElement(App, {
        registerExposeMethod: exposeObject.registerExposeMethod,
        unregisterExposeMethod: exposeObject.unregisterExposeMethod,
        integrationStyle: integrationStyle
      }), container);

      return exposeObject.returnObject;
    },

    /**
     * This component is intended to show only report part content.
     * params:
       * id: required. Id of report part.
       * filter: is an array of Object with key and	value for filter on subreport
       * crosssfilters: is an array of Object with key and value for filter on report
       * overridingFilterValue: to override default fillter values
       * onPublishDrillInfo: this is a function which will be invoked
       *                   when drill on a cross filtering.
       *                   Cross filtering's filter info is passed as an array of {key:'key', value:'value'}
       *
       * for Example:
       *  "id": "554D4D2F-E12A-4680-A2EC-A405DE872B7F",
       *  "filters": [
                    {
                      key: "[northwind].[dbo].[Order Details].[ProductID]",
                      value: 5
                    }
                   ]
        *  "overridingFilterValue": {
             p1value:A,
             p2value:B,
           },
        *  "crosssfilters": [
                    {
                      key: "[northwind].[dbo].[Order].[OrderID]",
                      value: 10
                    }
                   ]
           onPublishDrillInfo: function(drillInfo) { // do something }
        * container: Dom element.
     */
    renderReportPart: function render(container, params) {
      var drillParts = function drillParts(newParams, excludedPartId, fromOutside) {
        var isCachedCrossFilteringPart = IntergrateStore.isCachedCrossFilteringPart(newParams.id);
        if (isCachedCrossFilteringPart) {
          IntergrateStore.addFilters(newParams.crosssfilters);
          !fromOutside && IntergrateStore.cleanFilter();
        }
        var parts = IntergrateStore.loadUpdatingReportParts(newParams.id, excludedPartId);

        forEach(function (part) {
          part.params.crosssfilters = isCachedCrossFilteringPart ? IntergrateStore.crossFilteringFilters : newParams.crosssfilters;
          newParams.filters && (part.params.filters = newParams.filters);
          newParams.overridingFilterValue && (part.params.overridingFilterValue = newParams.overridingFilterValue);
          part.partOptions.updateAlone(part.params);
        }, parts);
      };

      var onPublishDrillInfoProgress = function onPublishDrillInfoProgress(id, filters) {
        drillParts({ id: id, crosssfilters: filters }, id);
        !!params.onPublishDrillInfo && params.onPublishDrillInfo(filters);
      };

      params.publishDrillInfo = onPublishDrillInfoProgress;
      ReactDOM.render(React.createElement(ReportPartPage, { params: params }), container);

      var partOptions = {
        updateResults: function updateResults(newParams) {
          drillParts(newParams, null, true);
        },
        updateAlone: function updateAlone(newParams) {
          ReactDOM.render(React.createElement(ReportPartPage, { params: newParams }), container);
        }
      };
      IntergrateStore.addPart({
        id: params.id,
        partOptions: partOptions,
        params: params,
        reportPart: null
      });
      return partOptions;
    },

    /**
     * This component is intended to show only setting module.
     * container: Dom element.
     */
    renderSettingPage: function render(container) {
      ReactDOM.render(React.createElement(SettingPage, null), container);
    },

    /**
     * This component is intended to show only report module.
     * container: Dom element.
     */
    renderReportPage: function render(container, integrationStyle) {
      var exposeObject = buildExposeFunction(container);

      integrationStyle = m.observable(cloneDeep(integrationStyle));

      ReactDOM.render(React.createElement(ReportPage, {
        registerExposeMethod: exposeObject.registerExposeMethod,
        unregisterExposeMethod: exposeObject.unregisterExposeMethod,
        integrationStyle: integrationStyle
      }), container);

      return exposeObject.returnObject;
    },

    /**
      * This component is intended to show only report viewer.
       * container: Dom element.
       * reportId: GUID id of report
       * filter: object filter
       * 	ex:
       * 		{
              masterReportId: '',
              inheritMasterReportFilter : true/false,
              filters: [{
                // filter based on master report field mapping
                masterReportId: '',
                // master report part id
                reportPartId: '',
                // container name
                containerName: '',
                // field mapping 2 of item with position 1 in container
                key: 'fm1_2',
                value: 'a',
                originalValue: 'b',
                dataFormat: 'c',
                linkReportFilter: true,
            	Type: 'fieldMapping'
              },
              {
                // filter based on report part element alias
                key: fieldNameAlias,
                value: 'a',
            	Type: 'fieldNameAlias'
              }],
              overridingFilterValue:{
                // overide value of filter 1 in sub report
                // p(\d+)value : p1
                  p1value: 'a',
                // overide value of filter 2 in master report
                // mp(\d+)value
                mp2value: 'b'
              }
            }
      */
    renderReportViewerPage: function render(container, reportId, filter, integrationStyle) {
      var exposeObject = buildExposeFunction(container);

      integrationStyle = m.observable(cloneDeep(integrationStyle));

      ReactDOM.render(React.createElement(ReportViewerPage, {
        reportId: reportId,
        filter: filter,
        registerExposeMethod: exposeObject.registerExposeMethod,
        unregisterExposeMethod: exposeObject.unregisterExposeMethod,
        integrationStyle: integrationStyle
      }), container);
      return exposeObject.returnObject;
    },

    /**
     * This component is intended to show dashboard.
     * container: Dom element.
     */
    renderDashboardPage: function render(container, integrationStyle) {
      var exposeObject = buildExposeFunction(container);

      integrationStyle = m.observable(cloneDeep(integrationStyle));

      ReactDOM.render(React.createElement(DashboardPage, {
        registerExposeMethod: exposeObject.registerExposeMethod,
        unregisterExposeMethod: exposeObject.unregisterExposeMethod,
        integrationStyle: integrationStyle
      }), container);

      return exposeObject.returnObject;
    },

    renderDashboardViewerPage: function render(container, dashboardId, filter, integrationStyle) {
      var exposeObject = buildExposeFunction(container);

      integrationStyle = m.observable(cloneDeep(integrationStyle));

      ReactDOM.render(React.createElement(DashboardViewerPage, {
        dashboardId: dashboardId,
        filter: filter,
        registerExposeMethod: exposeObject.registerExposeMethod,
        unregisterExposeMethod: exposeObject.unregisterExposeMethod,
        integrationStyle: integrationStyle
      }), container);

      return exposeObject.returnObject;
    },

    /**
     * This component is intended to show Report Designer Page.
     * container: Dom element.
     */
    renderReportDesignerPage: function render(container, integrationStyle) {
      var exposeObject = buildExposeFunction(container);

      integrationStyle = m.observable(cloneDeep(integrationStyle));

      ReactDOM.render(React.createElement(ReportDesignerPage, {
        registerExposeMethod: exposeObject.registerExposeMethod,
        unregisterExposeMethod: exposeObject.unregisterExposeMethod,
        integrationStyle: integrationStyle
      }), container);

      return exposeObject.returnObject;
    },

    /**
     * This component is intended to show new dashboard Page.
     * container: Dom element.
     */
    renderNewDashboardPage: function render(container, integrationStyle) {
      var exposeObject = buildExposeFunction(container);

      integrationStyle = m.observable(cloneDeep(integrationStyle));

      ReactDOM.render(React.createElement(DashboardPage, {
        registerExposeMethod: exposeObject.registerExposeMethod,
        unregisterExposeMethod: exposeObject.unregisterExposeMethod,
        integrationStyle: integrationStyle,
        isAddNew: true
      }), container);

      return exposeObject.returnObject;
    }
  };
}();

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _Izenda = __webpack_require__(194);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2121);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(31);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.App.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

__webpack_require__(2802);

var App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref, [this].concat(args))), _this), _this.history = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.history = (0, _Izenda2.default)();

      if (!_Izenda7.Integration) {
        return;
      }
      _Izenda6.default.listenHistoryChange(this.history, _Izenda7.BaseUrl);
    }
  }, {
    key: 'render',
    value: function render() {
      var synergyHistory = this.history.synergyHistory;

      return _react2.default.createElement(
        _reactRouter.Router,
        { history: synergyHistory },
        (0, _Izenda4.default)()
      );
    }
  }]);
  return App;
}(_react.Component);

exports.default = App;
module.exports = exports['default'];

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Routes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Route = __webpack_require__(52).Route;
  var IndexRedirect = __webpack_require__(52).IndexRedirect;
  var Config = __webpack_require__(40);

  var Container = __webpack_require__(605);

  // Layouts
  var FullLayout = __webpack_require__(2202);

  var SettingsRoutes = __webpack_require__(1142);
  var ReportViewerContainer = __webpack_require__(1179);
  var ReportRoutes = __webpack_require__(1197);
  var ReportDesignerRoutes = __webpack_require__(1201);
  var DashboardRoutes = __webpack_require__(1211);
  var ContentRoutes = __webpack_require__(2750).contentRoutes;
  var MyProfileRoutes = __webpack_require__(2780);
  var routeUtils = __webpack_require__(31);
  var NotFound = __webpack_require__(213);
  var NoPermission = __webpack_require__(613);
  var AccountConstants = __webpack_require__(60);
  var SecurityDetail = __webpack_require__(484);
  var uiState = __webpack_require__(15);

  var routes = function routes() {
    var BaseUrl = Config.BaseUrl || '/';
    var REPORTS_ROUTE = routeUtils.getConfigRoute('Report');
    var REPORT_VIEWER_ROUTE = routeUtils.getConfigRoute('ReportViewer');
    var REPORT_VIEWER__DETAIL_ROUTE = routeUtils.getConfigRoute('ReportViewer', 'ReportViewerDetail');
    var LOGIN_LINK = routeUtils.getRouteUrl(routeUtils.getConfigRoute('Account', 'Login'));

    function requireAuth(nextState, replace) {
      // check user browses to setting page.
      // if db is setup then we check for login process, otherwise we go to setting page for setting.
      if (nextState.params.notSetupDatabase) return;

      if (uiState.needLogin) {
        replace({ nextPathname: nextState.location.pathname }, LOGIN_LINK);
      }
    }

    /**
     * onEnter event
     * @params {Object} next state
     * @params {Object} replace
     */
    function onEnter(nextState, replace) {
      requireAuth(nextState, replace);
    }

    /**
     * onChange event
     * @params {Object} prev state
     * @params {Object} next state
     * @params {Object} replace
     */
    function onChange(prevState, nextState, replace) {
      requireAuth(nextState, replace);
    }

    return React.createElement(
      Route,
      { path: BaseUrl, component: Container },
      React.createElement(IndexRedirect, { to: LOGIN_LINK }),
      React.createElement(
        Route,
        { component: FullLayout, onEnter: onEnter, onChange: onChange },
        SettingsRoutes(),
        ReportDesignerRoutes(),
        DashboardRoutes(),
        ReportRoutes(),
        React.createElement(
          Route,
          { path: REPORT_VIEWER_ROUTE.path },
          React.createElement(Route, { path: REPORT_VIEWER__DETAIL_ROUTE.path, component: ReportViewerContainer })
        ),
        MyProfileRoutes(),
        React.createElement(Route, { path: 'NoPermission', component: NoPermission })
      ),
      ContentRoutes()
    );
  };
  module.exports = routes;
}();

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'authorization/';
// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthorizationDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * Load all permissions
   * @returns {promise}
   */
  loadAllPermissions: function loadAllPermissions() {
    return (0, _Izenda2.default)(ROOT_URL + 'permission/').get();
  },


  /**
   * Load permissions by key
   * @param {String} key
   * @returns {promise}
   */
  loadPermissionByKey: function loadPermissionByKey(key) {
    return (0, _Izenda2.default)(ROOT_URL + 'permission/' + key).get();
  },


  /**
   * Check permissions by list of keys
   * @param {Array} keys
   * @returns {promise}
   */
  checkPermissions: function checkPermissions(keys) {
    return (0, _Izenda2.default)(ROOT_URL + 'checkPermissions/' + keys).post();
  }
};
module.exports = exports['default'];

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.IntegrationSettingStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Integration Setting Store
 */
!function () {

  var m = __webpack_require__(5);
  var systemSettingFetcher = __webpack_require__(75);
  var IntegrationSetting = __webpack_require__(815);

  function IntegrationSettingStore() {
    this.integrationSetting = IntegrationSetting;
  };

  /**
   * get deployment mode
   */
  IntegrationSettingStore.prototype.getDeploymentMode = function () {
    return systemSettingFetcher.getDeploymentMode();
  };

  module.exports = IntegrationSettingStore;
}();

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(34);

var _Izenda2 = __webpack_require__(2125);

var _Izenda3 = _interopRequireDefault(_Izenda2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FIRST_LEVEL = 1;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DialogsHub.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var Dialog = (0, _mobxReact.observer)(function (props) {
  var info = props.info;
  var countOfPaddingTop = info.level - FIRST_LEVEL;

  info.props = (0, _fp.assign)({
    style: {
      paddingTop: countOfPaddingTop * _Izenda.BASE_PADDING_TOP_WITH_PARENT_PIXEL
    }
  }, info.props);

  return _react2.default.createElement((0, _Izenda3.default)(info.type), info.props);
});

var DialogsHub = (0, _mobxReact.observer)(function (props) {
  var dialogNode = props.dialog;
  var children = dialogNode ? [_react2.default.createElement(Dialog, {
    key: 'dialog_' + dialogNode.info.name,
    info: dialogNode.info
  }), _react2.default.createElement(DialogsHub, {
    key: 'dialoghub_' + dialogNode.info.name,
    dialog: dialogNode.child
  })] : null;
  var keyedProps = dialogNode ? { key: dialogNode.info.name } : null;

  return _react2.default.createElement('div', keyedProps, children);
});

exports.default = DialogsHub;
module.exports = exports['default'];

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(179);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _recompose = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withValidation = (0, _recompose.withContext)(_Izenda2.default.validationShape, _Izenda2.default.createValidationContext.bind(_Izenda2.default));
// ----------------------------------------------------------------------
// <copyright file="Izenda.DialogContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _recompose.compose)(_mobxReact.observer, withValidation);
module.exports = exports['default'];

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportLoadingIndicator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(152);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(68);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2127);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(12);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = (0, _mobxReact.observer)(function (props) {
  var exportFileName = props.name;
  var exportLabel = props.error ? props.isPrinting ? _Izenda10.default.getText('COMMON_LABEL_PRINTING_ERROR') : _Izenda10.default.getText('COMMON_LABEL_EXPORTING_ERROR') : props.isPrinting ? _Izenda10.default.getText('COMMON_LABEL_PRINTING') : _Izenda10.default.getText('COMMON_LABEL_EXPORTING');

  var className = (0, _classnames2.default)('u_textBold', {
    u_textErrorColor: props.error
  });

  return _react2.default.createElement(
    'div',
    { className: 'Izenda-Export-Loading  u-bgGray u_borderAll u_marginTop' },
    _react2.default.createElement(
      'div',
      { className: className },
      _react2.default.createElement(
        'span',
        { className: 'overflow-text u_inlineBlock  u_paddingLeft' },
        exportLabel,
        ':\xA0'
      ),
      _react2.default.createElement(_Izenda6.default, { text: exportFileName, tooltip: exportFileName, className: 'u_inlineBlock Izenda-Report-Name' }),
      _react2.default.createElement(
        'div',
        { className: 'Izenda-Remove-Icon' },
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', { className: 'icon-cancel', onClick: props.onClose })
        )
      )
    ),
    props.error ? null : _react2.default.createElement(_Izenda4.default, { show: true })
  );
});

var ExportLoadingIndicator = (_dec = (0, _Izenda2.default)(_Izenda8.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExportLoadingIndicator, _Component);

  function ExportLoadingIndicator(props) {
    (0, _classCallCheck3.default)(this, ExportLoadingIndicator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExportLoadingIndicator.__proto__ || (0, _getPrototypeOf2.default)(ExportLoadingIndicator)).call(this, props));

    _this.removeLoading = function (key) {
      return function () {
        return _this.props.onRemoveLoading(key);
      };
    };

    var exportLoader = props.exportLoader,
        onAddLoading = props.onAddLoading,
        onRemoveLoading = props.onRemoveLoading,
        onUpdateError = props.onUpdateError;

    _this.unregister = exportLoader.registerExportLoadingChanged(onAddLoading, onRemoveLoading, onUpdateError);
    return _this;
  }

  (0, _createClass3.default)(ExportLoadingIndicator, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unregister();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onRemoveLoading = _props.onRemoveLoading,
          loaders = _props.loaders;

      return _react2.default.createElement(
        'div',
        { className: 'Reporting-Export-Loading' },
        (0, _fp.map)(function (item) {
          return _react2.default.createElement(Loading, {
            error: item.error,
            name: item.name,
            key: item.key,
            isPrinting: item.isPrinting,
            onClose: _this2.removeLoading(item.key)
          });
        }, loaders)
      );
    }
  }]);
  return ExportLoadingIndicator;
}(_react.Component), _class2.propTypes = {
  loader: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = ExportLoadingIndicator;
module.exports = exports['default'];

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportLoadingIndicatorAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      filter = _require.filter,
      findIndex = _require.findIndex;

  var ExportLoadingIndicatorAction = compose(withHandlers({
    onAddLoading: curry(onAddLoading),
    onRemoveLoading: curry(onRemoveLoading),
    onUpdateError: curry(onUpdateError)
  }));

  /**
   *  Add export loading indicator
   * @param  {object} props
   * @param  {object} loadingKey
   */
  function onAddLoading(props, loader) {
    var listItem = props.loaders;
    listItem.push(loader);
  }

  /**
   * remove export loading indicaotr
   * @param  {object} props
   * @param  {object} loadingKey
   */
  function onRemoveLoading(props, loadingKey) {
    var newList = filter(function (item) {
      return item.key !== loadingKey;
    }, props.loaders);

    props.loaders.replace(newList);
  }

  /**
   * update error export loading indicaotr
   * @param  {object} props
   * @param  {object} loadingKey
   */
  function onUpdateError(props, loadingKey) {
    var listItem = props.loaders;
    var index = findIndex({
      key: loadingKey
    }, listItem);
    index !== -1 && (listItem[index].error = true);
  }

  module.exports = ExportLoadingIndicatorAction;
}();

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDndHtml5Backend = __webpack_require__(1124);

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _Izenda = __webpack_require__(179);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _reactDnd = __webpack_require__(378);

var _recompose = __webpack_require__(9);

var _Izenda3 = __webpack_require__(78);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModifiedBackend = function ModifiedBackend() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var instance = new (Function.prototype.bind.apply(_reactDndHtml5Backend2.default, [null].concat(args)))();

  // Fix Chrome not sending a DragEnd after Drop, which other browsers do and react-dnd expects
  var originalEndDragIfSourceWasRemovedFromDOM = instance.endDragIfSourceWasRemovedFromDOM;
  instance.endDragIfSourceWasRemovedFromDOM = function (e) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    if (_Izenda4.default.isChromeBrowser() && instance.clearCurrentDragSourceNode()) {
      instance.actions.endDrag();
    }
    originalEndDragIfSourceWasRemovedFromDOM.apply(undefined, [e].concat(args));
  };

  return instance;
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.EnhanceContext.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var enhanceContext = function enhanceContext(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    (0, _inherits3.default)(_class, _Component);

    function _class() {
      (0, _classCallCheck3.default)(this, _class);
      return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
    }

    (0, _createClass3.default)(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        !this.izendaContext && (this.izendaContext = _Izenda2.default.createAppContext());
        return this.izendaContext;
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);
    return _class;
  }(_react.Component), _class.childContextTypes = {
    dialogs: _propTypes2.default.object,
    validation: _propTypes2.default.object.isRequired,
    loader: _propTypes2.default.object.isRequired,
    authorization: _propTypes2.default.object.isRequired,
    authorizationConstants: _propTypes2.default.object.isRequired,
    localization: _propTypes2.default.object.isRequired,
    exportLoader: _propTypes2.default.object.isRequired
  }, _temp;
};

exports.default = (0, _recompose.compose)((0, _reactDnd.DragDropContext)(ModifiedBackend), enhanceContext);
module.exports = exports['default'];

/***/ }),
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.SystemAlert.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SystemAlert = (_dec = (0, _Izenda4.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SystemAlert, _Component);

  function SystemAlert() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SystemAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SystemAlert.__proto__ || (0, _getPrototypeOf2.default)(SystemAlert)).call.apply(_ref, [this].concat(args))), _this), _this.handleSystemError = function (systemError) {
      if (!(0, _fp.isNil)(systemError)) {
        _this.props.confirmFn('Information', {
          type: 'error',
          description: systemError,
          showCancel: false,
          showCloseIndicator: true
        }).then(_Izenda2.default.resetSystemError.bind(_Izenda2.default));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SystemAlert, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.disposeSystemError = (0, _mobx.observe)(_Izenda2.default, 'systemError', this.handleSystemError);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disposeSystemError();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return SystemAlert;
}(_react.Component)) || _class);
exports.default = SystemAlert;
module.exports = exports['default'];

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FullLayout.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);

  var Container = __webpack_require__(605);
  var TopMenu = __webpack_require__(2203);
  var Footer = __webpack_require__(2204);
  var UserMenu = __webpack_require__(2205);
  var routeUtils = __webpack_require__(31);
  var connect = __webpack_require__(2);
  var BottomNotification = __webpack_require__(2209);
  var LicenseStatusNotification = __webpack_require__(2210);

  var FullLayout = React.createClass({
    displayName: 'FullLayout',

    render: function render() {
      return React.createElement(
        'article',
        { className: 'izenda-Wrapper' },
        React.createElement(
          'header',
          { className: 'izenda-Header' },
          React.createElement(TopMenu, null),
          React.createElement(UserMenu, null)
        ),
        React.createElement(
          'main',
          { className: 'izenda-Main' },
          this.props.children
        ),
        React.createElement(
          BottomNotification,
          null,
          React.createElement(LicenseStatusNotification, null)
        ),
        React.createElement(Footer, null)
      );
    }
  });

  module.exports = connect()(FullLayout);
}();

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.TopMenu.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * TopMenu component
 */

var _mobx = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(31);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(153);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(15);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(45);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(130);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(231);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var integrationStyleAction = _Izenda14.default.checkDisplayByKey('hideTopMenu');

var TopMenu = (_dec = (0, _Izenda6.default)(integrationStyleAction), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TopMenu, _Component);

  function TopMenu(props) {
    (0, _classCallCheck3.default)(this, TopMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopMenu.__proto__ || (0, _getPrototypeOf2.default)(TopMenu)).call(this, props));

    _initialiseProps.call(_this);

    _this.accountStore = new _Izenda12.default();
    _this.menuState = (0, _mobx.observable)({
      hasSetupDatabase: null
    });
    return _this;
  }

  (0, _createClass3.default)(TopMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.accountStore.checkDatabaseSetup().bind(this).then(function (dbConfigured) {
        this.menuState.hasSetupDatabase = dbConfigured;
        return dbConfigured;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          router = _props.router,
          localization = _props.localization,
          className = _props.className;

      var links = this.getMenu(localization);
      var newLinks = [];

      var checkActiveRoute = (0, _fp.flow)((0, _fp.get)('to'), router.isActive);

      var checkIndexActiveRoute = (0, _fp.flow)((0, _fp.get)('to'), (0, _fp.partial)(router.isActive, [_fp.placeholder, true]));

      (0, _fp.forEach)(function (item) {
        if (item.childs) {
          var newItems = (0, _fp.remove)(function (child) {
            return !(0, _fp.isNil)(child.hasPrivilege) && !child.hasPrivilege || child.isHidden || !(0, _fp.isNil)(child.hasLicense) && !child.hasLicense || child.isHidden;
          }, item.childs);

          if (!(0, _fp.isEmpty)(newItems)) {
            var newChild = { childs: newItems };
            var activeLink = (0, _fp.find)(checkActiveRoute, newItems);
            var indexActiveRoute = (0, _fp.find)(checkIndexActiveRoute, newItems);

            if (activeLink) {
              newChild.className = 'active';
              if (indexActiveRoute) {
                indexActiveRoute.className = 'active';
              } else {
                activeLink.className = 'active';
              }
            }

            newLinks.push(newChild);
          }
        } else {
          if ((0, _fp.isNil)(item.hasPrivilege) || item.hasPrivilege && !item.isHidden) {
            if (router.isActive(item.to)) {
              item.className = 'active';
            }

            newLinks.push(item);
          }
        }
      }, links);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('izenda-TopMenu', className) },
        _react2.default.createElement('div', { className: 'izenda-TopMenu-logo' }),
        _react2.default.createElement(
          'nav',
          { className: 'izenda-TopMenu-nav', 'aria-expanded': 'false' },
          _react2.default.createElement(
            'ul',
            { className: 'nav' },
            newLinks.map(function (item, index) {
              return _react2.default.createElement(
                'li',
                { key: index, className: item.className },
                _this2.renderListMenu(item)
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'navbar-header' },
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'navbar-toggle', onClick: this.showExpandedMenu },
            _react2.default.createElement('span', { className: 'icon-menu u-colorWhite' })
          )
        )
      );
    }
  }]);
  return TopMenu;
}(_react.Component), _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.accountStore = _Izenda12.default;

  this.showExpandedMenu = function () {
    _Izenda4.default.toggleTopMenu();
  };

  this.renderListMenu = function (item) {
    var props = _this3.props;

    if (item.childs) {
      return item.childs.map(_this3.renderListMenu);
    }
    var to = item.to,
        className = item.className,
        title = item.title,
        icon = item.icon;

    function hideMenu() {
      _Izenda4.default.toggleTopMenu(false);

      props.confirmDirtyForm(_Izenda8.default.isDirty, { onConfirmDirtyForm: _Izenda8.default.onOkDirtyForm }).then(function () {
        props.router.push(to);
      });
    }

    return _react2.default.createElement(
      'a',
      { className: className, key: to, onClick: hideMenu },
      _react2.default.createElement('i', { className: icon }),
      _react2.default.createElement(
        'span',
        { className: 'izenda-TopMenu-title' },
        title
      )
    );
  };

  this.getMenu = function (localization) {
    var _props2 = _this3.props,
        authorization = _props2.authorization,
        authorizationConstants = _props2.authorizationConstants;


    var permissionKeys = authorizationConstants.PERMISSION_KEY;
    var permissionOperator = authorizationConstants.PERMISSION_OPERATOR;
    var hasSetupDatabase = !!_this3.menuState.hasSetupDatabase;

    return [{
      childs: [{
        to: _Izenda2.default.getReportUrl(),
        title: localization.getText('TOP_MENU_REPORTS'),
        icon: 'icon-report',
        needLicense: true,
        hasLicense: hasSetupDatabase && !_Izenda8.default.expiredLicense
      }, {
        to: _Izenda2.default.getReportDesignerUrl(),
        icon: 'icon-addnew',
        needLicense: true,
        hasPrivilege: authorization.checkPrivileges([permissionKeys.ReportsCanCreateNewReportValue]) && authorization.checkPrivileges([permissionKeys.ReportsDataSourcesSimpleDataSources, permissionKeys.ReportsDataSourcesAdvancedDataSources, permissionKeys.ReportsReportPartTypesChart, permissionKeys.ReportsReportPartTypesForm, permissionKeys.ReportsReportPartTypesGauge, permissionKeys.ReportsReportPartTypesMap, permissionKeys.ReportsFilterPropertiesFilterLogic, permissionKeys.ReportsFieldPropertiesCustomURL, permissionKeys.ReportsFieldPropertiesEmbeddedJavaScript, permissionKeys.ReportsFieldPropertiesSubreport, permissionKeys.ReportsActionsSchedule, permissionKeys.ReportsActionsConfigureAccessRights, permissionKeys.ReportsActionsEmail, permissionKeys.ReportsActionsPrint, permissionKeys.ReportsActionsExporting], permissionOperator.Or),
        hasLicense: authorization.checkLicense(_Izenda10.default.LICENSE_KEY.ReportDesigner) && hasSetupDatabase && !_Izenda8.default.expiredLicense
      }]
    }, {
      childs: [{
        to: _Izenda2.default.getDashboardUrl(),
        title: localization.getText('TOP_MENU_DASHBOARDS'),
        icon: 'icon-dashboard',
        needLicense: true,
        hasLicense: authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Dashboard) && hasSetupDatabase && !_Izenda8.default.expiredLicense
      }, {
        to: _Izenda2.default.getDashboardUrl('New'),
        icon: 'icon-addnew',
        needLicense: true,
        isHidden: _Izenda8.default.isMobile,
        hasPrivilege: authorization.checkPrivileges([permissionKeys.DashboardsCanCreateNewDashboardValue]),
        hasLicense: authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Dashboard) && hasSetupDatabase && !_Izenda8.default.expiredLicense
      }]
    }, {
      to: _Izenda2.default.getSettingsUrl(),
      title: localization.getText('TOP_MENU_SETTINGS'),
      icon: 'icon-setting',
      needLicense: false,
      isHidden: _Izenda8.default.isMobile,
      hasPrivilege: !hasSetupDatabase || authorization.checkPrivileges([permissionKeys.TenantSetupActionsCreate, permissionKeys.TenantSetupActionsEdit, permissionKeys.TenantSetupActionsDel, permissionKeys.TenantSetupPermissionsValue, permissionKeys.SystemConfigurationScheduledInstancesValue, permissionKeys.DataSetupDataModelValue, permissionKeys.DataSetupAdvancedSettingsCategory, permissionKeys.DataSetupAdvancedSettingsOthers, permissionKeys.UserSetupActionsCreate, permissionKeys.UserSetupActionsEdit, permissionKeys.UserSetupActionsDel, permissionKeys.UserSetupActionsConfigureSecurityOptions, permissionKeys.UserSetupUserRoleAssociationValue, permissionKeys.RoleSetupActionsCreate, permissionKeys.RoleSetupActionsEdit, permissionKeys.RoleSetupActionsDel, permissionKeys.RoleSetupDataModelAccessValue, permissionKeys.RoleSetupPermissionsValue, permissionKeys.RoleSetupGrantRoleWithFullReportAndDashboardAccessValue], permissionOperator.Or)
    }];
  };
}, _temp)) || _class);
exports.default = TopMenu;
module.exports = exports['default'];

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = footer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function footer() {
  var currentYear = (0, _moment2.default)(_Izenda2.default.getSystemDate).year();
  return _react2.default.createElement(
    'footer',
    { className: 'izenda-Footer' },
    _react2.default.createElement(
      'div',
      { className: 'izenda-Footer-copyright' },
      'Copyright 2016 - ' + currentYear + ' Izenda, Inc.'
    )
  );
} // ----------------------------------------------------------------------
// <copyright file="Izenda.Footer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Footer component
 */
;
module.exports = exports['default'];

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.UserMenu.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var actions = __webpack_require__(2206);
  var uiState = __webpack_require__(15);
  var routeUtils = __webpack_require__(31);
  var Config = __webpack_require__(40);

  var NotificationBoard = __webpack_require__(2207);
  var HelpSystem = __webpack_require__(2208);

  var _require = __webpack_require__(1),
      truncate = _require.truncate;

  var UserMenu = function UserMenu(props) {
    var localization = props.localization;
    var router = props.router;

    var renderMyProfileLink = function renderMyProfileLink() {
      var myProfileUrl = routeUtils.getMyProfileUrl();

      var goToProfile = function goToProfile() {
        props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(function () {
          router.push(myProfileUrl);
        });
      };

      return React.createElement(
        'li',
        null,
        React.createElement(
          'a',
          { onClick: goToProfile },
          localization.getText('USER_MENU_MY_PROFILE')
        )
      );
    };
    var fullName = truncate({ length: 30 }, uiState.currentUser.fullName);
    return React.createElement(
      'div',
      { className: 'izenda-UserMenu u-posAbsolute' },
      React.createElement(
        'div',
        { className: 'btn-group izenda-UserMenu-Info', role: 'group' },
        React.createElement(
          'a',
          {
            className: 'btn dropdown-toggle',
            ref: function ref(dom) {
              dom && $izenda(dom).dropdown();
            },
            'aria-haspopup': true,
            'aria-expanded': 'false',
            'data-toggle': 'dropdown',
            title: uiState.currentUser.fullName
          },
          fullName,
          ' \xA0',
          React.createElement('span', { className: 'caret' })
        ),
        React.createElement(
          'ul',
          { className: 'dropdown-menu' },
          !uiState.expiredLicense && renderMyProfileLink(),
          !Config.Integration && React.createElement(
            'li',
            null,
            React.createElement(
              'a',
              { onClick: props.onClickSignOut },
              localization.getText('USER_MENU_SIGN_OUT')
            )
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'izenda-UserMenu-Bell u_fullInlineBlock' },
        React.createElement(NotificationBoard, { notificationMessages: uiState.notificationMessages })
      ),
      React.createElement(HelpSystem, null)
    );
  };

  module.exports = connect(actions)(UserMenu);
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(31);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(130);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Will mount
// - load current user by token

/**
 * Handle on click sign in.
 * @param  {Object} props
 * @param  {Object} obj
 */
var onClickSignOut = function onClickSignOut(props, obj) {
  var signOutProcess = function signOutProcess() {
    var loginLink = _Izenda2.default.getRouteUrl(_Izenda2.default.getConfigRoute('Account', 'Login'));
    var loader = props.loader;

    loader.startLoading();
    return props.store.logout().then(function (result) {
      if (result) {
        props.authorization.clear();
        props.router.push(loginLink);
      }

      return (0, _bluebird.resolve)(result);
    }).finally(loader.endLoading.bind(loader));
  };
  props.confirmDirtyForm(_Izenda6.default.isDirty, { onConfirmDirtyForm: _Izenda6.default.onOkDirtyForm }).then(signOutProcess);
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.UserMenuActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var userMenuActions = (0, _recompose.compose)((0, _recompose.withProps)(function () {
  return { store: new _Izenda4.default() };
}), (0, _recompose.withHandlers)({
  onClickSignOut: (0, _fp.curry)(onClickSignOut)
}));

exports.default = userMenuActions;
module.exports = exports['default'];

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.NotificationBoard.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var classnames = __webpack_require__(11);
  var ScrollBox = __webpack_require__(27);

  var MESSAGE_TYPE = __webpack_require__(37).MESSAGE_TYPE;

  var NotificationBoard = React.createClass({
    displayName: 'NotificationBoard',


    getInitialState: function getInitialState() {
      return {
        show: false
      };
    },

    getDefaultProps: function getDefaultProps() {
      return {
        notificationMessages: []
      };
    },

    render: function render() {

      var numberOfMessage = this.props.notificationMessages.length;
      var isShowBadge = numberOfMessage > 0;

      return React.createElement(
        'div',
        { className: 'izenda-NotificationBoard u-posRelative' },
        React.createElement('span', { onClick: this.toggleNotification, className: 'icon-alert' }),
        isShowBadge && React.createElement(
          'span',
          { className: 'badge u-posAbsolute u-bgRed' },
          numberOfMessage
        ),
        this.state.show && React.createElement('span', { className: 'icon-triangle-up u-posAbsolute u-colorWhite' }),
        this.state.show && this.renderNotification()
      );
    },

    renderNotification: function renderNotification() {
      var notificationMessages = this.props.notificationMessages;
      var isHaveMessage = notificationMessages.length > 0;

      return React.createElement(
        'div',
        { className: 'izenda-NotificationBoard-Message u-posAbsolute u-bgWhite u_borderAll u_paddingAll' },
        isHaveMessage ? React.createElement(
          ScrollBox,
          { autoHeight: true, autoHeightMax: window.innerHeight / 2 },
          React.createElement(
            GridLayout,
            { className: 'u_marginBottom u_paddingAll' },
            notificationMessages.map(function (item) {
              return React.createElement(
                GridLayout.Row,
                { key: item.key },
                React.createElement(
                  GridLayout.Col,
                  { cols: 2 },
                  React.createElement('span', { className: getIconTypeClass(item.type) })
                ),
                React.createElement(
                  GridLayout.Col,
                  { className: 'u_borderBottom', cols: 10 },
                  React.createElement(
                    'span',
                    null,
                    item.message
                  )
                )
              );
            })
          )
        ) : React.createElement(
          'div',
          { className: 'u_controlHeight u_marginBottom' },
          'No Notification'
        ),
        React.createElement('span', { onClick: this.toggleNotification, className: 'icon-cancel u_floatRight u_marginRight' })
      );

      function getIconTypeClass(type) {
        return classnames({
          'icon-info-circled': type === MESSAGE_TYPE.INFO,
          'icon-error-circled': type === MESSAGE_TYPE.ERROR,
          'icon-attention-circled': type === MESSAGE_TYPE.WARNING
        });
      }
    },

    toggleNotification: function toggleNotification() {
      this.setState({
        show: !this.state.show
      });
    }

  });

  module.exports = connect()(NotificationBoard);
}();

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.HelpSystem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(1141);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var HelpSystem = (_class = function (_Component) {
  (0, _inherits3.default)(HelpSystem, _Component);

  function HelpSystem() {
    (0, _classCallCheck3.default)(this, HelpSystem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HelpSystem.__proto__ || (0, _getPrototypeOf2.default)(HelpSystem)).call(this));

    _initDefineProp(_this, 'helpSystemUrl', _descriptor, _this);

    _this.store = new _Izenda2.default();
    return _this;
  }

  (0, _createClass3.default)(HelpSystem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      return this.store.getHelpSystemUrl().then(function (url) {
        _this2.helpSystemUrl = url;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var helpSystemUrl = this.helpSystemUrl;
      var localization = this.props.localization;


      return !!helpSystemUrl ? _react2.default.createElement(
        'div',
        { className: 'izenda-UserMenu-Bell u_fullInlineBlock' },
        _react2.default.createElement(
          'div',
          { className: 'u-posRelative' },
          _react2.default.createElement('a', {
            href: helpSystemUrl,
            target: '_blank',
            rel: 'noopener noreferrer',
            title: localization.getText('COMMON_LABEL_HELP_SYSTEM'),
            className: 'icon-help-circled u_LargeIcon u-colorBlack'
          })
        )
      ) : null;
    }
  }]);
  return HelpSystem;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'helpSystemUrl', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
})), _class);
exports.default = (0, _Izenda4.default)()(HelpSystem);
module.exports = exports['default'];

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BottomNotification;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BottomNotification(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'section',
    { className: 'bottomNotification' },
    children
  );
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.BottomNotification.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


/**
 * Bottom Notification component
 */
;
module.exports = exports['default'];

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseStatusNotification.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * License Status Notification component
 */
!function () {

  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);
  var React = __webpack_require__(0);
  var EmailConstants = __webpack_require__(119);
  var LicenseInfoConstants = __webpack_require__(295);
  var AppStore = __webpack_require__(104);
  var PERMISSION_KEY = __webpack_require__(42).PERMISSION_KEY;

  var LicenseStatusNotification = React.createClass({
    displayName: 'LicenseStatusNotification',

    sendPurchaseEmail: function sendPurchaseEmail() {
      window.location = EmailConstants.EMAIL.sale;
    },

    render: function render() {
      var props = this.props;
      var licenseInfo = AppStore.licenseInfoStore.licenseInfo;
      var localization = props.localization;
      var hasSeeSystemMessagePrivilege = props.authorization.checkPrivileges([PERMISSION_KEY.SystemwideCanSeeSystemMessagesValue]);

      if (!licenseInfo.meetExprireWarningPeriod || !hasSeeSystemMessagePrivilege) {
        return null;
      }

      var message = this.buildMessage(licenseInfo.numberOfDayToExpire);

      return React.createElement(
        'div',
        null,
        React.createElement(
          'span',
          { className: 'icon-attention' },
          message
        ),
        React.createElement(
          'button',
          { className: 'btn btn-primary pull-right', onClick: this.sendPurchaseEmail },
          licenseInfo.trialLicense ? localization.getText("LICENSE_CHECKER_LABEL_READY_PURCHASE") : localization.getText("LICENSE_CHECKER_LABEL_RENEW_LICENSE")
        )
      );
    },

    /**
     * Build notify message.
     * @param {Number} numberOfDayToExpire
     */
    buildMessage: function buildMessage(numberOfDayToExpire) {
      if (numberOfDayToExpire < 0) {
        return String.format(LicenseInfoConstants.MESSAGE.MG05a, Math.abs(numberOfDayToExpire));
      } else if (numberOfDayToExpire === 0) {
        return LicenseInfoConstants.MESSAGE.MG05b;
      }
      return String.format(LicenseInfoConstants.MESSAGE.MG05, numberOfDayToExpire);
    }
  });

  module.exports = connect()(LicenseStatusNotification);
}();

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Settings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(104);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2212);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(331);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(332);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(156);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(333);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2213);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2216);

var _Izenda20 = _interopRequireDefault(_Izenda19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Settings = (_dec = (0, _Izenda8.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Settings, _Component);

  function Settings() {
    (0, _classCallCheck3.default)(this, Settings);
    return (0, _possibleConstructorReturn3.default)(this, (Settings.__proto__ || (0, _getPrototypeOf2.default)(Settings)).apply(this, arguments));
  }

  (0, _createClass3.default)(Settings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      var loader = props.loader,
          contextMenu = props.store.contextMenu;


      if (contextMenu.activeLink) {
        loader.startLoading();
        props.store.checkSettingLevel();
        // load system indicator for detecting changes
        contextMenu.loadSystemIndicator();
        contextMenu.disabledLinkBasedOnConnectionString().finally(loader.endLoading.bind(loader));
      }

      /**
       * observe detectChangeCount to invoke loadSystemIndicator
       */
      this.disposeReconnectBtnEvent = (0, _mobx.observe)(_Izenda2.default, 'detectChangeCount', function (changeCount) {
        changeCount > 0 && contextMenu.loadSystemIndicator();
      });

      this.disposeDetectVisibleConnectionString = (0, _mobx.observe)(_Izenda2.default, 'detectChangeVisibleConnection', function (changeCount) {
        changeCount > 0 && contextMenu.disabledLinkBasedOnConnectionString();
      });

      this.disposeObserveTenantID = (0, _mobx.observe)(_Izenda2.default, 'tenantId', function () {
        // reload app settings
        _Izenda4.default.loadAppSettings();

        loader.startLoading();
        contextMenu.loadSystemIndicator();
        contextMenu.disabledLinkBasedOnConnectionString().then(function () {
          if (contextMenu.isCurrentActiveLinkDisable) {
            props.confirmFn('Confirmation', {
              description: _Izenda6.default.CONFIRM_MESSAGE_CHANGE_TENANT,
              showCancel: false
            }).then(contextMenu.changeActiveLink.bind(contextMenu, _Izenda6.default.CONTEXT_MENU_REVERT_LINK));
          }
        }).finally(loader.endLoading.bind(loader));
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disposeReconnectBtnEvent();
      this.disposeDetectVisibleConnectionString();
      this.disposeObserveTenantID();
      // re-enable System Setting dropdown when exiting Settings tab
      _Izenda2.default.enableSystemSetting();
      this.props.store.onlyShowTenant(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          hasSetupDatabase = _props.hasSetupDatabase,
          params = _props.params;

      return _react2.default.createElement(
        'section',
        { className: 'izenda-Wrapper' },
        _react2.default.createElement(_Izenda10.default, { store: store }),
        _react2.default.createElement(
          _Izenda16.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'izenda-TableLayout u_paddingTopBottom' },
            _react2.default.createElement(
              _Izenda12.default,
              null,
              _react2.default.createElement(_Izenda18.default, { store: store, hasSetupDatabase: hasSetupDatabase })
            ),
            _react2.default.createElement(
              _Izenda14.default,
              null,
              _react2.default.createElement(_Izenda20.default, { store: store, params: params, hasSetupDatabase: hasSetupDatabase })
            )
          )
        )
      );
    }
  }]);
  return Settings;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = Settings;
module.exports = exports['default'];

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get CONFIRM_MESSAGE_CHANGE_TENANT() {
    return _Izenda2.default.getText('SETTINGS_CONTEXT_MENU_MESSAGE_CONFIRM_MESSAGE_CHANGE_TENANT');
  },
  CONTEXT_MENU_REVERT_LINK: 'connectionString'
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsContextMenuConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

module.exports = exports['default'];

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsLeftMenu.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(334);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(483);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _config = __webpack_require__(40);

var _Izenda7 = __webpack_require__(72);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2215);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(31);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsLeftMenu = (_dec = (0, _Izenda4.default)(_Izenda10.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SettingsLeftMenu, _Component);

  function SettingsLeftMenu(props) {
    (0, _classCallCheck3.default)(this, SettingsLeftMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingsLeftMenu.__proto__ || (0, _getPrototypeOf2.default)(SettingsLeftMenu)).call(this, props));

    _this.renderChangedIcon = function (item) {
      var localization = _this.props.localization;
      return item.isDirty && item.key !== _Izenda8.default.DataSetup ? _react2.default.createElement('span', {
        className: 'icon-attention warning-color',
        title: localization.getText('CONNECTION_DETECT_CHANGE_ICON_TOOLTIP')
      }) : null;
    };

    if (props.menu.length === 0) {
      props.router.push(_Izenda12.default.getNoPermissionUrl());
    } else {
      props.updateActiveLink((0, _fp.head)(props.menu));
    }

    _this.systemModeObserver = (0, _mobx.observe)(_IzendaUiState2.default, 'systemMode', function () {
      props.updateMenu(props.getLeftMenu());
    });
    return _this;
  }

  (0, _createClass3.default)(SettingsLeftMenu, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.systemModeObserver();
    }

    /**
     * Render icon
     * @param {Object} item
     */

  }, {
    key: 'render',
    value: function render() {
      var isActiveLicense = _config.Integration ? _Izenda6.default.integrationActiveLicense : _Izenda6.default.isActiveLicense;
      var _props$store$contextM = this.props.store.contextMenu,
          activeLink = _props$store$contextM.activeLink,
          menuStatus = _props$store$contextM.menuStatus;


      return _react2.default.createElement(_Izenda2.default, {
        dataSource: this.props.menu,
        activeKey: activeLink,
        enabled: menuStatus && isActiveLicense,
        onSelected: this.props.changeActiveKey,
        renderChangedIcon: this.renderChangedIcon
      });
    }
  }]);
  return SettingsLeftMenu;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired,
  hasSetupDatabase: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = SettingsLeftMenu;
module.exports = exports['default'];

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(854);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuItem = function (_Component) {
  (0, _inherits3.default)(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.setLinkRef = function (com) {
      _this.linkRef = com;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var item = this.props.item;

      if (item.hoverShowTooltip) {
        var tooltipOption = {
          title: item.tooltip,
          trigger: 'hover',
          placement: 'right',
          template: '<div class="tooltip tooltip-no-mobile" role="tooltip"><div class="tooltip-arrow info"></div><div class="tooltip-inner info"></div></div>'
        };
        (0, _Izenda.initTooltip)(this.linkRef, tooltipOption);
        (0, _Izenda.updateTooltip)(this.linkRef, item.tooltip);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.item.hoverShowTooltip && (0, _Izenda.destroyTooltip)(this.linkRef);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          handleClick = _props.handleClick,
          activeKey = _props.activeKey,
          enabled = _props.enabled;

      var collapseIcon = item.items ? _react2.default.createElement('i', { className: 'fontello-icon icon-toggle' }) : null;
      var isDisabled = !enabled && item.key !== activeKey;
      var classes = (0, _classnames2.default)({
        active: item.key === activeKey,
        disabled: isDisabled,
        'enable-hover': item.hoverShowTooltip
      });

      return _react2.default.createElement(
        'a',
        {
          onClick: handleClick,
          className: classes,
          'data-name': item.key,
          title: item.title,
          ref: this.setLinkRef
        },
        _react2.default.createElement('i', { className: item.icon }),
        _react2.default.createElement(
          'span',
          { className: 'izenda-MenuItem-label' },
          item.title,
          this.props.renderChangedIcon && this.props.renderChangedIcon(item)
        ),
        collapseIcon
      );
    }
  }]);
  return MenuItem;
}(_react.Component);
// ----------------------------------------------------------------------
// <copyright file="Izenda.MenuItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/* eslint-disable max-len */

exports.default = MenuItem;
module.exports = exports['default'];

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _recompose.compose)((0, _recompose.withProps)({
  getLeftMenu: getLeftMenu
}), (0, _recompose.withHandlers)({
  changeActiveKey: (0, _fp.curry)(changeActiveKey),
  updateActiveLink: (0, _fp.curry)(updateActiveLink)
}), (0, _recompose.withState)('menu', 'updateMenu', function (props) {
  return getLeftMenu.call(props);
}));

/**
 * Get left menu for settings page
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsLeftMenuActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function getLeftMenu() {
  var contextMenu = this.store.contextMenu.contextMenu,
      hasSetupDatabase = this.hasSetupDatabase,
      authorization = this.authorization;

  // For first time , not setup data base : Only DB & License is shown

  if (!hasSetupDatabase) {
    return (0, _fp.filter)({ key: 'setupAndLicense' }, contextMenu);
  }

  var menu = [];
  (0, _fp.forEach)(function (link) {
    if (link.items) {
      var newChild = (0, _fp.remove)(function (child) {
        return !checkPrivilege(child, authorization) || !checkLicense(child, authorization);
      }, link.items);
      if (newChild.length > 0) {
        var newLink = (0, _fp.clone)(link);
        newLink.items = newChild;
        menu.push(newLink);
      }
    } else {
      if (checkLicense(link, authorization) && checkPrivilege(link, authorization) && !checkIsIntegration(link, authorization)) {
        menu.push(link);
      }
    }
  }, contextMenu);

  return menu;
}

/**
 * Check privilege
 * @param {Object} link
 */
function checkPrivilege(_ref, authorization) {
  var forSystemAdmin = _ref.forSystemAdmin,
      forSystemUser = _ref.forSystemUser,
      forMultipleTenant = _ref.forMultipleTenant,
      permissionKeys = _ref.permissionKeys,
      permissionOperator = _ref.permissionOperator;
  var isSingleTenantMode = _Izenda2.default.isSingleTenantMode,
      _uiState$currentUser = _Izenda2.default.currentUser,
      systemAdmin = _uiState$currentUser.systemAdmin,
      isSystemUser = _uiState$currentUser.isSystemUser;


  if (!authorization.isCompleteLoad) return false;
  if (forSystemAdmin && !systemAdmin) return false;
  if (forSystemUser && !isSystemUser) return false;
  if (forMultipleTenant && !isSingleTenantMode) return false;

  if (permissionKeys) {
    if (permissionOperator) {
      if (!authorization.checkPrivileges(permissionKeys, permissionOperator)) {
        return false;
      }
    } else {
      if (!authorization.checkPrivileges(permissionKeys)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Check license
 * @param {Object} link
 */
function checkLicense(_ref2, authorization) {
  var licenseKey = _ref2.licenseKey;

  return !licenseKey || authorization.checkLicense(licenseKey);
}

/**
 * Check the system is running under integration mode
 * @param {Object} link
 */
function checkIsIntegration(_ref3, authorization) {
  var integrationCheck = _ref3.integrationCheck;

  return integrationCheck && authorization.isIntegrationMode();
}

/**
 * Change active key
 * @param {Object} props 
 * @param {Object} newLink 
 */
function changeActiveKey(props, newLink) {
  var settingStore = props.store,
      contextMenu = props.store.contextMenu;

  if (contextMenu.activeLink !== newLink) {
    props.confirmDirtyForm(_Izenda2.default.isDirty, { onConfirmDirtyForm: _Izenda2.default.onOkDirtyForm }).then(function () {
      settingStore.checkSettingLevel(newLink);
      contextMenu.changeActiveLink(newLink);
    });
  }
}

/**
 * Update active link
 * @param {Object} props 
 * @param {Object} link 
 */
function updateActiveLink(props, link) {
  if (link) {
    props.store.contextMenu.contextMenuActiveLink = link.key;
    props.store.contextMenu.activeLink = (0, _fp.isNil)(link.items) ? link.key : link.items[0].key;
  }
}
module.exports = exports['default'];

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2217);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2227);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2269);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2284);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2315);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2360);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2373);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2426);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2440);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2452);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(2456);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(2462);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(2507);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _Izenda29 = __webpack_require__(213);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _IzendaImport = __webpack_require__(2519);

var _IzendaImport2 = _interopRequireDefault(_IzendaImport);

var _Izenda31 = __webpack_require__(2548);

var _Izenda32 = _interopRequireDefault(_Izenda31);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsContent = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SettingsContent, _Component);

  function SettingsContent() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SettingsContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SettingsContent.__proto__ || (0, _getPrototypeOf2.default)(SettingsContent)).call.apply(_ref, [this].concat(args))), _this), _this.viewComponents = {
      setupAndLicense: {
        component: _Izenda4.default,
        storePath: 'licenseChecker'
      },
      tenantManagement: {
        component: _Izenda6.default,
        storePath: 'tenantManagement'
      },
      connectionString: {
        component: _Izenda8.default
      },
      dataModel: {
        component: _Izenda10.default,
        storePath: 'dataModel'
      },
      roleSetup: {
        component: _Izenda12.default
      },
      advanceSettings: {
        component: _Izenda14.default,
        storePath: 'advanceSettings'
      },
      copyManagement: {
        component: _Izenda16.default
      },
      databaseMapping: {
        component: _Izenda18.default
      },
      import: {
        component: _IzendaImport2.default
      },
      importHistory: {
        component: _Izenda32.default
      },
      userSetup: {
        component: _Izenda20.default
      },
      emailConfiguration: {
        component: _Izenda22.default,
        storePath: 'emailConfiguration'
      },
      reportConfiguration: {
        component: _Izenda24.default,
        storePath: 'reportConfiguration'
      },
      scheduling: {
        component: _Izenda26.default,
        storePath: 'schedulingSearch'
      },
      securityPolicies: {
        component: _Izenda28.default,
        storePath: 'securityPolicies'
      },
      notFound: {
        component: _Izenda30.default
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SettingsContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          params = _props.params,
          store = _props.store,
          activeLink = _props.store.contextMenu.activeLink,
          hasSetupDatabase = _props.hasSetupDatabase;

      var info = (0, _fp.getOr)(this.viewComponents.notFound, activeLink, this.viewComponents);
      var linkStore = (0, _fp.get)(info.storePath, store);

      return linkStore ? _react2.default.createElement(info.component, { store: linkStore, params: params, hasSetupDatabase: hasSetupDatabase }) : _react2.default.createElement(info.component, null);
    }
  }]);
  return SettingsContent;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object,
  hasSetupDatabase: _react.PropTypes.bool
}, _temp2)) || _class);
exports.default = SettingsContent;
module.exports = exports['default'];

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseChecker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------


/**
 * LicenseChecker component
 */
!function () {

  var classnames = __webpack_require__(11);

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var IconMenu = __webpack_require__(86);
  var ScrollBox = __webpack_require__(27);

  var DatabaseConfiguration = __webpack_require__(2218);
  var LicenseValidation = __webpack_require__(2221);
  var LicenseInfo = __webpack_require__(2223);
  var ProvisioningMapData = __webpack_require__(2224);
  var SystemModeSetting = __webpack_require__(2225);

  var LicenseChecker = React.createClass({
    displayName: 'LicenseChecker',


    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentDidMount: function componentDidMount() {
      var loader = this.props.loader;
      loader.startLoading();
      return this.props.store.getInitData().finally(loader.endLoading.bind(loader));
    },

    render: function render() {
      var store = this.props.store;
      var licenseInfo = store.licenseInfoStore.licenseInfo;
      var isShowProvisioning = licenseInfo.hasMapModules;
      var hasSetupDatabase = this.props.hasSetupDatabase;

      return React.createElement(
        ScrollBox,
        { shouldInjectScrollCallbackToChild: false },
        React.createElement(
          'section',
          { className: 'u_fullHeight u_paddingLeftRight' },
          React.createElement(
            'div',
            { className: 'izenda-LicenseChecker-iconMenu' },
            React.createElement(IconMenu, null)
          ),
          React.createElement(DatabaseConfiguration, { store: store }),
          renderLicenseSection()
        )
      );

      function renderLicenseSection() {
        return hasSetupDatabase ? React.createElement(
          'div',
          null,
          React.createElement(LicenseValidation, {
            store: store.licenseInfoStore,
            item: licenseInfo,
            isValidConnection: store.databaseConfiguration.isValidConnection,
            validatedConnection: store.databaseConfiguration.validatedConnection }),
          React.createElement(LicenseInfo, {
            item: licenseInfo,
            store: store.licenseInfoStore,
            validatedConnection: store.databaseConfiguration.validatedConnection }),
          React.createElement(SystemModeSetting, { store: store }),
          isShowProvisioning && React.createElement(ProvisioningMapData, null)
        ) : null;
      }
    }
  });

  module.exports = connect()(LicenseChecker);
}();

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseConfiguration.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Database Configuration component
 */
!function () {
  var React = __webpack_require__(0);
  var Panel = __webpack_require__(28);
  var ConnectionStringForm = __webpack_require__(2219);
  var LicenseCheckerConstants = __webpack_require__(45);
  var EmailConstants = __webpack_require__(119);
  var connect = __webpack_require__(2);

  var _require = __webpack_require__(1),
      get = _require.get,
      flow = _require.flow,
      head = _require.head,
      isNil = _require.isNil;

  var DatabaseConfiguration = React.createClass({
    displayName: 'DatabaseConfiguration',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentDidMount: function componentDidMount() {
      this.props.store.getSupportedDatabaseType();
    },

    onClickConnectButton: function onClickConnectButton(e) {
      e.preventDefault();
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var localization = props.localization;

      loader.startLoading();

      var valManager = this.props.validation;
      valManager.validate('connectionString').then(function (success) {
        return success ? testSuccess() : testFail();
      }).finally(loader.endLoading.bind(loader));

      function setupDatabase() {
        var resetDataInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        return props.confirmMessage('info', localization.getText('LICENSE_CHECKER_MESSAGE_CHANGE_CONNECTION')).then(store.setupDatabase.bind(store, resetDataInfo)).then(function (response) {
          if (!response.success) {
            var errorMessage = flow(get('messages'), head, get('messages'), head)(response);
            return props.confirmMessage('error', errorMessage);
          }
          return store.getConnectionInfo();
        });
      }

      function testSuccess() {
        if (store.licenseInfoStore.licenseInfo.isActiveLicense && store.databaseConfiguration.differentDatabase) {
          return props.confirmFn('Confirmation', {
            description: LicenseCheckerConstants.MESSAGE.MG07
          }).then(function () {
            return setupDatabase();
          });
        }
        return setupDatabase(false);
      }

      function testFail() {
        if (store.databaseConfiguration.hasValidConnection && !isNil(store.databaseConfiguration.connectionInfo.connectionString)) {
          return props.confirmMessage('info', LicenseCheckerConstants.MESSAGE.MG08).then(function () {
            valManager.reset('connectionString');
            store.databaseConfiguration.resetDataInfo();
            return store.getConnectionInfo();
          });
        }
        return null;
      }
    },

    render: function render() {
      var store = this.props.store;
      var localization = this.props.localization;
      return React.createElement(
        Panel,
        { header: LicenseCheckerConstants.Description, className: 'panel-default' },
        React.createElement(ConnectionStringForm, { store: store }),
        React.createElement(
          'fieldset',
          null,
          React.createElement(
            'div',
            { className: 'u_textRight' },
            React.createElement('a', { className: 'icon-mail u_marginRight', href: EmailConstants.EMAIL.connectionStringAssistance }),
            React.createElement(
              'button',
              { className: 'btn btn-primary', ref: 'connectButton', onClick: this.onClickConnectButton },
              localization.getText('COMMON_LABEL_CONNECT')
            )
          )
        )
      );
    }
  });

  module.exports = connect()(DatabaseConfiguration);
}();

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionStringForm.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Database Configuration component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var EventsUtils = __webpack_require__(24);

  var DropDown = __webpack_require__(29);

  var ConnectionStringBuilder = __webpack_require__(1144);
  var LicenseCheckerConstants = __webpack_require__(45);

  var Validator = __webpack_require__(23);
  var ValidatableSecuredInput = Validator()(__webpack_require__(614));

  var _require = __webpack_require__(1),
      merge = _require.merge,
      partial = _require.partial;

  var ConnectionStringForm = React.createClass({
    displayName: 'ConnectionStringForm',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    render: function render() {
      var store = this.props.store;

      var databaseConfiguration = store.databaseConfiguration;
      var connectionInfo = databaseConfiguration.connectionInfo;
      var validatedConnection = databaseConfiguration.validatedConnection;
      var validConnection = databaseConfiguration.isValidConnection;

      var notifyChange = EventsUtils.notifyChange;
      var notify = EventsUtils.notify;
      var localization = this.props.localization;

      return React.createElement(
        'fieldset',
        { className: 'row' },
        React.createElement(
          'div',
          { className: 'col-md-3' },
          renderDataServerType.bind(this)()
        ),
        React.createElement(
          'div',
          { className: 'col-md-9' },
          renderConnectString.bind(this)()
        )
      );

      function renderDataServerType() {
        var serverTypeItemConfig = {
          key: 'id',
          value: 'name'
        };

        function changeDataServerType(e) {
          this.props.validation.reset();
          databaseConfiguration.updateServerType(e.value);
        }

        return React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'label',
            { className: 'validation required' },
            localization.getText("LICENSE_CHECKER_LABEL_DATA_SERVER_TYPE")
          ),
          React.createElement(DropDown, { options: databaseConfiguration.supportedDatabaseType || [],
            labelField: 'name',
            valueField: 'id',
            value: connectionInfo.serverTypeId,
            onChange: changeDataServerType.bind(this),
            ref: 'dbServerType' })
        );
      };

      function renderConnectString() {
        var localization = this.props.localization;
        var connetionStringVals = merge(LicenseCheckerConstants.CONNECTION_STRING_CONSTRAINT, {
          action: function action() {
            return store.testConnection.bind(store);
          }
        }, {});

        return React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'label',
            { className: 'control-label validation required' },
            localization.getText("LICENSE_CHECKER_LABEL_CONNECTION_STRING")
          ),
          React.createElement(
            'a',
            { className: 'connection-builder pull-right',
              onClick: this.showConnectionStringBuilder },
            localization.getText("LICENSE_CHECKER_LABEL_CONNECTION_BUILDER"),
            React.createElement('i', { className: 'icon-flash' })
          ),
          React.createElement(ValidatableSecuredInput, {
            className: 'form-control',
            onReset: notify(partial(databaseConfiguration.updateConnectionString.bind(databaseConfiguration), '')),
            onFocus: this.onFocus,
            onChange: notifyChange(databaseConfiguration.updateConnectionString.bind(databaseConfiguration), EventsUtils.INPUT),
            value: connectionInfo.connectionString,
            secure: validatedConnection,
            validations: connetionStringVals,
            field: 'connectionString',
            maxLength: '500' })
        );
      };
    },

    onFocus: function onFocus() {
      this.props.validation.reset();
    },

    showConnectionStringBuilder: function showConnectionStringBuilder(e) {
      e.preventDefault();
      var model = this.props.store.databaseConfiguration;

      this.props.openPopup(ConnectionStringBuilder, {
        onOk: applyConnectionString.bind(this),
        serverType: this.props.store.databaseConfiguration.serverTypeName
      });

      function applyConnectionString(connectionString) {
        this.props.validation.reset();
        model.updateConnectionString(connectionString);
        return true;
      };
    }

  });

  module.exports = connect()(ConnectionStringForm);
}();

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get SERVER_NAME_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('CONNECTION_STRING_BUILDER_REQUIRED_SERVER_NAME')
      }
    };
  },
  get DATABASE_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: _Izenda2.default.getText('CONNECTION_STRING_BUILDER_REQUIRED_DATABASE')
      }
    };
  },

  get AUTHENTICATION_TYPES() {
    return {
      Standard: {
        value: _Izenda2.default.getText('CONNECTION_STRING_BUILDER_STANDARD_AUTHENTICATION'),
        displayPattern: '{0} ' + _Izenda2.default.getText('CONNECTION_STRING_BUILDER_TEXT_AUTHENTICATION'),
        connectionStringPattern: 'server={0};database={1};User Id={2};Password={3};'
      },
      Trusted: {
        value: _Izenda2.default.getText('CONNECTION_STRING_BUILDER_TRUSTED_AUTHENTICATION'),
        displayPattern: 'Windows ' + _Izenda2.default.getText('CONNECTION_STRING_BUILDER_TEXT_AUTHENTICATION'),
        connectionStringPattern: 'server={0};database={1};Trusted_Connection=True;'
      }
    };
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionStringBuilderConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseValidation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * License Validation component
 */
!function () {
  __webpack_require__(55);

  var React = __webpack_require__(0);

  var Panel = __webpack_require__(28);
  var EmailConstants = __webpack_require__(119);
  var LicenseInfoConstants = __webpack_require__(295);

  var Validator = __webpack_require__(23);
  var connect = __webpack_require__(2);

  var LicenseValidationInput = __webpack_require__(2222);
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;

  var LicenseValidation = React.createClass({
    displayName: 'LicenseValidation',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      // Reset license and token status when change connection string
      if (this.props.isValidConnection != nextProps.isValidConnection) {
        this.resetLicenseValidation();
      }
    },
    getLicenseInfo: function getLicenseInfo() {
      return this.props.store.licenseInfo || {};
    },

    /**
     * Render content
     */
    render: function render() {
      var licenseInfo = this.props.item;
      var props = this.props;
      var store = props.store;
      var isLicenseKey = true;
      var localization = props.localization;

      return React.createElement(
        Panel,
        { header: LicenseInfoConstants.Description, className: 'panel-default' },
        React.createElement(LicenseValidationInput, { store: store, validatedConnection: props.validatedConnection, item: licenseInfo }),
        React.createElement(
          'fieldset',
          { className: 'form-horizontal', disabled: props.validatedConnection ? null : 'disabled' },
          React.createElement(
            'div',
            { className: 'u_textRight' },
            uiState.currentUser.systemAdmin && React.createElement('span', { className: 'icon-export u_marginRight', onClick: this.exportPerformanceStatisticsTrend }),
            React.createElement('a', { className: 'icon-mail u_marginRight', href: EmailConstants.EMAIL.licenseAssistance }),
            React.createElement(
              'button',
              {
                className: 'btn btn-primary',
                disabled: !licenseInfo.enableValidateButton,
                onClick: this.onValidation
              },
              localization.getText('COMMON_LABEL_VALIDATE')
            )
          )
        )
      );
    },

    resetLicenseValidation: function resetLicenseValidation() {
      var valManager = this.props.validation;
      valManager.reset('licenseKey');
      valManager.reset('tokenKey');
    },

    onValidation: function onValidation(e) {
      e.preventDefault();
      var licenseValidation = this;
      var props = this.props;
      var store = props.store;
      var licenseInfo = this.getLicenseInfo();
      var loader = props.loader;
      loader.startLoading();

      var valManager = this.props.validation;
      var validationFields = licenseInfo.licenseOnlineMode ? 'licenseKey' : ['licenseKey', 'tokenKey'];

      valManager.validate(validationFields).then(function (success) {
        return success ? store.validateLicense() : null;
      }).then(function (saveErrors) {
        if (!isEmpty(saveErrors)) {
          var message = saveErrors[0] && saveErrors[0].messages && saveErrors[0].messages[0];

          // revert to exited license
          if (!licenseInfo.isValidLicense && licenseInfo.hasValidLicense) {
            props.confirmMessage('info', message).then(function () {
              licenseValidation.resetLicenseValidation();
              return store.getLicenseInformation();
            });
          } else {
            valManager.updateErrors(saveErrors);
          }
        }
        return null;
      }).finally(loader.endLoading.bind(loader));
    },

    exportPerformanceStatisticsTrend: function exportPerformanceStatisticsTrend(e) {
      this.props.store.exportPerformanceStatisticsTrend();
    }
  });

  module.exports = connect()(LicenseValidation);
}();

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseValidationInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * License Validation component
 */
!function () {
  __webpack_require__(55);

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);

  var LicenseInfoConstants = __webpack_require__(295);
  var Validator = __webpack_require__(23);
  var ValidatableSecuredInput = Validator()(__webpack_require__(614));

  var LicenseValidationInput = React.createClass({
    displayName: 'LicenseValidationInput',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired
    },
    /**
     * Render content
     */
    render: function render() {
      var licenseInfo = this.props.item;
      var props = this.props;
      var localization = props.localization;
      var inputClasses = classnames('form-control', { 'izenda-LicenseChecker-validationInput': licenseInfo.isValidLicense });

      return React.createElement(
        'fieldset',
        { className: 'form-horizontal izenda-LicenseValidation',
          disabled: props.validatedConnection ? null : 'disabled' },
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'label',
            { className: 'control-label col-md-2' },
            localization.getText("LICENSE_CHECKER_LABEL_LICENSE_MODE")
          ),
          React.createElement(
            'div',
            { className: 'col-md-10' },
            React.createElement(
              'div',
              { className: 'u_table' },
              React.createElement(
                'span',
                { className: 'u_tableCell u_alignMiddle' },
                localization.getText("LICENSE_CHECKER_LABEL_OFFLINE")
              ),
              React.createElement(
                'div',
                { className: 'izenda-Switch u_marginLeftRight' },
                React.createElement('input', {
                  type: 'checkbox',
                  id: 'izenda-Switch-checkbox',
                  className: 'izenda-Switch-checkbox',
                  onChange: this.onChangeLicenseMode,
                  checked: !!licenseInfo.licenseOnlineMode
                }),
                React.createElement('label', { className: 'izenda-Switch-label', htmlFor: 'izenda-Switch-checkbox' })
              ),
              React.createElement(
                'span',
                { className: 'u_tableCell u_alignMiddle' },
                localization.getText("LICENSE_CHECKER_LABEL_ONLINE")
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'label',
            { className: 'col-md-2 control-label validation required' },
            localization.getText("LICENSE_CHECKER_LABEL_LICENSE_KEY")
          ),
          React.createElement(
            'div',
            { className: 'col-md-10' },
            React.createElement(ValidatableSecuredInput, {
              className: inputClasses,
              onReset: this.resetLicenseInfo,
              onChange: this.onChangeLicenseKey,
              value: licenseInfo.licenseKey,
              secure: licenseInfo.validatedLicense,
              validations: LicenseInfoConstants.LICENSE_KEY_CONSTRAINT,
              field: 'licenseKey',
              maxLength: 'MAX'
            }),
            this.renderSuccessIcon(licenseInfo)
          )
        ),
        licenseInfo.licenseOnlineMode ? null : React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'label',
            { className: 'col-md-2 control-label validation required' },
            localization.getText("LICENSE_CHECKER_LABEL_TOKEN")
          ),
          React.createElement(
            'div',
            { className: 'col-md-10' },
            React.createElement(ValidatableSecuredInput, {
              className: inputClasses,
              onReset: this.resetLicenseInfo,
              onChange: this.onChangeToken,
              value: licenseInfo.tokenKey,
              secure: licenseInfo.validatedLicense,
              validations: LicenseInfoConstants.TOKEN_CONSTRAINT,
              field: 'tokenKey',
              maxLength: 'MAX'
            }),
            this.renderSuccessIcon(licenseInfo)
          )
        ),
        this.renderLicenseStatus()
      );
    },

    renderSuccessIcon: function renderSuccessIcon(licenseInfo) {
      return licenseInfo.isValidLicense ? React.createElement(
        'div',
        { className: 'u-posAbsolute success-color u-iconAfterInput' },
        React.createElement('span', { className: 'icon-ok' })
      ) : null;
    },

    renderLicenseStatus: function renderLicenseStatus() {
      var licenseInfo = this.props.item;

      if (!licenseInfo.validatedLicense || !licenseInfo.isValidLicense) {
        return null;
      }

      // license will be valide in the future
      if (licenseInfo.numberOfDayToValid > 0) {
        return React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-offset-2 col-md-10' },
            React.createElement(
              'div',
              { className: 'alert alert-info', role: 'alert' },
              String.format(LicenseInfoConstants.MESSAGE.MG07a, String.formatDate(licenseInfo.startDate), String.formatDate(licenseInfo.endDate))
            )
          )
        );
      }

      return null;
    },

    onChangeLicenseMode: function onChangeLicenseMode(e) {
      var licenseInfo = this.props.item;
      var newMode = e.target.checked;

      if (licenseInfo.validatedLicense && licenseInfo.isValidLicense) {
        //show message
        this.props.confirmFn('Confirmation', {
          description: getMessage()
        }).then(function () {
          this.updateLicenseMode(newMode);
          //reset validate value license/token
          this.resetLicenseValidation();
        }.bind(this));
      } else {
        this.updateLicenseMode(newMode);
      }

      /**
       * get error message when fail
       * @return {String} message show on popup
       */
      function getMessage() {
        var msgId = newMode ? 'MG01b' : 'MG01a';
        return LicenseInfoConstants.MESSAGE[msgId];
      }
    },

    updateLicenseMode: function updateLicenseMode(licenseMode) {
      this.updateLicenseInfo('licenseOnlineMode', licenseMode);
      this.updateLicenseInfo('licenseKey', '');
      this.updateLicenseInfo('tokenKey', '');
    },

    resetLicenseInfo: function resetLicenseInfo() {
      var licenseInfo = this.props.item;
      if (licenseInfo.validatedLicense) {
        this.updateLicenseInfo('licenseKey', '');
        this.updateLicenseInfo('tokenKey', '');
        this.props.validation.reset('licenseKey');
        this.props.validation.reset('tokenKey');
      }
    },

    onChangeLicenseKey: function onChangeLicenseKey(e) {
      this.updateLicenseInfo('licenseKey', e.target.value);
    },

    onChangeToken: function onChangeToken(e) {
      this.updateLicenseInfo('tokenKey', e.target.value);
    },

    updateLicenseInfo: function updateLicenseInfo(key, value) {
      var licenseInfo = this.props.item;
      licenseInfo.updateLicenseInfoByKey(key, value);
    },

    resetLicenseValidation: function resetLicenseValidation() {
      var valManager = this.props.validation;
      valManager.reset('licenseKey');
      valManager.reset('tokenKey');
    }

  });

  module.exports = connect()(LicenseValidationInput);
}();

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseInfo.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * License Info component
 */
!function () {
  __webpack_require__(55);

  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var React = __webpack_require__(0);
  var Panel = __webpack_require__(28);
  var ProductInfo = __webpack_require__(1123);

  var LicenseInfoHeader = function header(props) {
    var localization = props.localization;
    return React.createElement(
      GridLayout,
      null,
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: 2 },
          React.createElement(
            'strong',
            null,
            localization.getText("LICENSE_CHECKER_LABEL_LICENSE_INFORMATION")
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: 10 },
          React.createElement(
            'span',
            null,
            props.productVersion
          )
        )
      )
    );
  };

  var LicenseInfo = React.createClass({
    displayName: 'LicenseInfo',


    propTypes: {
      item: React.PropTypes.object.isRequired,
      store: React.PropTypes.object
    },

    render: function render() {
      var licenseInfo = this.props.item;
      var localization = this.props.localization;

      if (!licenseInfo.isValidLicense) {
        return null;
      }

      if (licenseInfo.numberOfDayToValid > 0) {
        return null;
      }
      var header = {
        component: LicenseInfoHeader,
        productVersion: ProductInfo.VERSION,
        localization: localization
      };
      return React.createElement(
        Panel,
        { header: header,
          className: classnames('panel-default', 'izenda-LicenseInfo', { 'disabled-elm': !this.props.validatedConnection }) },
        getLicense.bind(this)()
      );

      function getLicense() {
        var localization = this.props.localization;
        if (licenseInfo.licenseOnlineMode || !licenseInfo.previousStartDate) {
          return React.createElement(
            'div',
            { className: 'padding-t current-module' },
            this.renderLicenseInfo(localization.getText("LICENSE_CHECKER_LABEL_CURRENT_DURATION"), [licenseInfo.startDate, licenseInfo.licenseEndDate], localization.getText("LICENSE_CHECKER_LABEL_CURRENT_MODULE"), licenseInfo.modules, 'current-module')
          );
        } else {
          return React.createElement(
            'div',
            { className: 'row flex-layout' },
            React.createElement(
              'div',
              { className: 'col-md-6 padding-t previous-module' },
              this.renderLicenseInfo(localization.getText("LICENSE_CHECKER_LABEL_PREVIOUS_DURATION"), [licenseInfo.previousStartDate, licenseInfo.previousEndDate], localization.getText("LICENSE_CHECKER_LABEL_PREVIOUS_MODULE"), licenseInfo.previousModules)
            ),
            React.createElement(
              'div',
              { className: 'col-md-6 padding-t current-module' },
              this.renderLicenseInfo(localization.getText("LICENSE_CHECKER_LABEL_NEXT_DURATION"), [licenseInfo.startDate, licenseInfo.endDate], localization.getText("LICENSE_CHECKER_LABEL_NEXT_MODULE"), licenseInfo.modules)
            )
          );
        }
      }
    },

    renderLicenseInfo: function renderLicenseInfo(durationLabel, duration, moduleLabel, modules) {
      modules = modules || [];

      if (!duration[0] && !duration[1]) {
        return null;
      }

      return React.createElement(
        'section',
        null,
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'label',
            { className: 'col-md-2' },
            durationLabel
          ),
          React.createElement(
            'span',
            { className: 'col-md-10' },
            String.formatDate(duration[0]),
            ' - ',
            String.formatDate(duration[1])
          )
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'label',
            { className: 'col-md-2' },
            moduleLabel
          ),
          React.createElement(
            'div',
            { className: 'col-md-10 modules' },
            modules.map(function (module, index) {
              return React.createElement(
                'div',
                { key: index, className: 'module' },
                React.createElement('i', { className: 'icon-ok success-color' }),
                module.name
              );
            })
          )
        )
      );
    }
  });

  module.exports = connect()(LicenseInfo);
}();

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ProvisioningMapData.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var GridLayout = __webpack_require__(13);
  var Button = __webpack_require__(30);
  var ProvisionMapDataStore = __webpack_require__(315);
  var uiState = __webpack_require__(15);
  var PROVISIONING_STATUS = __webpack_require__(115).PROVISIONING_STATUS;

  var POLLING_PROVISION_DATA_STATUS_INTERVAL = 60000;

  var ProvisioningMapData = function ProvisioningMapData(props) {

    var loader = props.loader;
    var localization = this.props.localization;
    var canProvisioning = uiState.canProvisioning;

    return React.createElement(
      GridLayout,
      { className: 'u-bgWhite u_paddingAll' },
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: 2 },
          React.createElement(
            'span',
            { className: 'text-bold u_controlHeight' },
            localization.getText('LICENSE_CHECKER_LABEL_IMPORT_MAP_DATA')
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: 10 },
          React.createElement(Button, {
            disabled: !canProvisioning,
            className: 'u_marginRight',
            label: localization.getText('LICENSE_CHECKER_LABEL_PROVISION_MAP_DATA'),
            onClick: importMapData
          }),
          React.createElement(
            'a',
            null,
            React.createElement('span', { className: 'icon-info-circled' })
          )
        )
      )
    );

    function importMapData() {
      loader.startLoading();
      ProvisionMapDataStore.importMapData().finally(loader.endLoading.bind(loader));

      // Polling Provision status after provisioning map data, stop it when it get success or error
      var pollingProvisionStatus = setInterval(function () {
        ProvisionMapDataStore.getProvisioningStatus().then(function (result) {
          if (result !== PROVISIONING_STATUS.IMPORTING) {
            window.clearInterval(pollingProvisionStatus);
          }
        });
      }, POLLING_PROVISION_DATA_STATUS_INTERVAL);
    }
  };

  module.exports = connect()(ProvisioningMapData);
}();

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemModeSetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * System Mode Setting component
 */
!function () {
  __webpack_require__(55);
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);

  var settingConstant = __webpack_require__(167);
  var action = __webpack_require__(2226);
  var Panel = __webpack_require__(28);
  var Input = __webpack_require__(17);
  var GridLayout = __webpack_require__(13);

  var SystemModeSetting = React.createClass({
    displayName: 'SystemModeSetting',


    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var systemModeSetting = store.systemModeSetting;
      var localization = props.localization;

      return React.createElement(
        Panel,
        { header: localization.getText("LICENSE_CHECKER_SYSTEM_MODE_DESCRIPTION"),
          className: 'panel-default izenda-LicenseInfo' },
        renderSystemSettingMode()
      );

      function renderSystemSettingMode() {
        return React.createElement(
          GridLayout,
          { className: 'u-bgWhite u_paddingAll' },
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              GridLayout.Col,
              { cols: 2 },
              React.createElement(
                'span',
                { className: 'u_controlHeight' },
                localization.getText('LICENSE_CHECKER_LABEL_SYSTEM_MODE')
              )
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 10 },
              React.createElement(Input, { type: 'radio',
                checked: systemModeSetting.isSingleMode,
                onChange: props.swithToSingleTenant,
                value: settingConstant.SYSTEM_MODE }),
              React.createElement(
                'span',
                { className: 'u_marginLeftInnerSpace' },
                localization.getText('LICENSE_CHECKER_LABEL_SINGLE_TENANT')
              ),
              ' \xA0',
              React.createElement(Input, { type: 'radio',
                checked: !systemModeSetting.isSingleMode,
                onChange: props.switchToMultiTenant,
                value: settingConstant.TENANT_MODE }),
              React.createElement(
                'span',
                { className: 'u_marginLeftInnerSpace' },
                localization.getText('LICENSE_CHECKER_LABEL_MULTI_TENANT')
              )
            )
          ),
          !systemModeSetting.isSingleMode && renderUserIDProperties()
        );
      }

      function renderUserIDProperties() {
        return React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(
              'span',
              { className: 'u_controlHeight' },
              localization.getText('LICENSE_CHECKER_LABEL_USER_ID_PROPERTIES')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 10 },
            React.createElement(Input, { type: 'checkbox',
              onChange: props.changeAllowDuplicate,
              checked: systemModeSetting.allowDuplicateUser }),
            React.createElement(
              'span',
              { className: 'u_marginLeftInnerSpace' },
              localization.getText('LICENSE_CHECKER_LABEL_ALLOW_DUPLICATE_USER')
            )
          )
        );
      }
    }
  });

  module.exports = connect(action)(SystemModeSetting);
}();

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemModeSettingActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var settingConstant = __webpack_require__(167);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var SystemModeSettingActions = compose(withHandlers({
    swithToSingleTenant: curry(swithToSingleTenant),
    switchToMultiTenant: curry(switchToMultiTenant),
    changeAllowDuplicate: curry(changeAllowDuplicate)
  }));

  /**
   * Switch to Single Tenant mode
   * @param {type} props
   * @param {type} _
   */
  function swithToSingleTenant(props, _) {
    var systemModeSetting = props.store.systemModeSetting;

    return props.confirmFn('Confirmation', {
      description: props.localization.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_MULTI_TO_SINGLE')
    }).then(function () {
      var saveData = m.toJS(systemModeSetting);
      saveData.systemMode = settingConstant.SYSTEM_MODE;
      return props.store.saveSystemSetting(saveData);
    }).then(function (result) {
      var errorMessages = result.messages;
      if (!result.success) {
        props.confirmMessage('error', errorMessages[0].messages[0]);
      } else {
        systemModeSetting.switchToSingle();
      }
      return null;
    });
  }

  /**
   * Switch to Multiple Tenant mode
   * @param {type} props
   * @param {type} _
   */
  function switchToMultiTenant(props, _) {
    var systemModeSetting = props.store.systemModeSetting;

    return props.confirmFn('Confirmation', {
      description: props.localization.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_SINGLE_TO_MULTI')
    }).then(function () {
      var saveData = m.toJS(systemModeSetting);
      saveData.systemMode = settingConstant.TENANT_MODE;
      saveData.allowDuplicateUser = true;
      return props.store.saveSystemSetting(saveData);
    }).then(function (result) {
      var errorMessages = result.messages;
      if (!result.success) {
        props.confirmMessage('error', errorMessages[0].messages[0]);
      } else {
        systemModeSetting.switchToMulti();
      }
      return null;
    });
  }

  /**
   * Change allow duplicate user
   * @param {type} props
   * @param {type} _
   */
  function changeAllowDuplicate(props, e) {
    var newValue = e.target.checked;
    var systemModeSetting = props.store.systemModeSetting;
    var saveData = m.toJS(systemModeSetting);
    saveData.allowDuplicateUser = newValue;

    return props.store.saveSystemSetting(saveData).then(function (result) {
      var errorMessages = result.messages;
      if (!result.success) {
        props.confirmMessage('error', errorMessages[0].messages[0]);
      } else {
        systemModeSetting.updateAllowDuplicateUser(newValue);
      }
      return null;
    });
  }

  module.exports = SystemModeSettingActions;
}();

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2228);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2231);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2267);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(196);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(27);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2268);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantManagement.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant Management component
 */
var TenantManagement = function TenantManagement(_ref) {
  var store = _ref.store;

  return _react2.default.createElement(
    'section',
    { className: 'izenda-TenantManagement izenda-TableLayout' },
    _react2.default.createElement(
      _Izenda8.default,
      { minWidth: store.getBundle().MIDDLE_MIN_WIDTH, maxWidth: store.getBundle().MIDDLE_MAX_WIDTH },
      _react2.default.createElement(
        'div',
        { className: 'u_fullHeight u-posRelative u-bgWhite' },
        _react2.default.createElement(_Izenda6.default, { store: store }),
        _react2.default.createElement(
          'div',
          { className: 'izenda-MiddlePanel-content izenda-TenantList-content' },
          _react2.default.createElement(
            _Izenda10.default,
            null,
            _react2.default.createElement(_Izenda2.default, { store: store })
          )
        )
      )
    ),
    _react2.default.createElement(_Izenda4.default, { store: store })
  );
};

exports.default = (0, _Izenda12.default)(_Izenda14.default)(TenantManagement);
module.exports = exports['default'];

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant List component
 */
!function () {
  var React = __webpack_require__(0);

  var List = __webpack_require__(195);
  var Item = __webpack_require__(2229);
  var connect = __webpack_require__(2);

  var TenantList = React.createClass({
    displayName: 'TenantList',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    /**
     * Component did mount
     */
    componentDidMount: function componentDidMount() {
      var props = this.props;
      var loader = props.loader;
      var store = props.store;
      loader.startLoading();
      store.getModulesOfLicense().then(store.getTenantList.bind(store)).finally(loader.endLoading.bind(loader));
    },

    /*
     * Render list tenant component
     */
    render: function render() {
      var store = this.props.store;
      var tenantList = store.tenantList.filterTenants;

      return React.createElement(
        List,
        null,
        tenantList.map(function (item) {
          return React.createElement(Item, { tenantInfo: item,
            key: item.id,
            store: store });
        })
      );
    }
  });

  module.exports = connect()(TenantList);
}();

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/**
 * Tenant Item component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);
  var TextHighLight = __webpack_require__(62);
  var constants = __webpack_require__(279);
  var GridLayout = __webpack_require__(13);
  var actions = __webpack_require__(2230);
  var config = __webpack_require__(40);

  var TenantItem = React.createClass({
    displayName: 'TenantItem',

    propTypes: {
      tenantInfo: React.PropTypes.object.isRequired
    },

    /**
     * Render tenant item component
     */
    render: function render() {
      var props = this.props;
      var store = props.store;
      var tenantInfo = props.tenantInfo;
      var classes = classnames('item', 'truncate', { selected: props.tenantInfo.isSelected });
      var tenantStatus = tenantInfo.active ? constants.TENANT_STATE.DEACTIVATE : constants.TENANT_STATE.ACTIVATE;
      var authorization = props.authorization;
      var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
      var hasEditPrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsEdit]);
      var hasDelPrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsDel]);
      var canDeleteTenant = hasDelPrivilege && !config.Integration;

      return React.createElement(
        'div',
        { className: classes, onClick: props.handleSelected },
        React.createElement(
          GridLayout,
          null,
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              GridLayout.Col,
              { cols: 6, className: 'overflow-text' },
              React.createElement(TextHighLight, {
                highlight: store.tenantList.filterText,
                text: tenantInfo.displayName,
                tooltip: tenantInfo.displayName })
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 6 },
              React.createElement(
                'div',
                { className: 'pull-right' },
                hasEditPrivilege && React.createElement(
                  'a',
                  { className: classnames('izenda-TenantStatus', { 'izenda-TenantStatus-Deactivate': tenantInfo.active }),
                    onClick: props.clickVisible },
                  tenantStatus
                ),
                canDeleteTenant && React.createElement('span', { className: 'icon-cancel', onClick: props.clickDelete })
              )
            )
          )
        )
      );
    }
  });

  module.exports = connect(actions)(TenantItem);
}();

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantItemAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;

  var withHandlers = __webpack_require__(9).withHandlers;
  var commonMessages = __webpack_require__(37);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil;

  var tenantItemAction = compose(withHandlers({
    clickDelete: curry(clickDelete),
    clickVisible: curry(clickVisible),
    handleSelected: curry(handleSelected)
  }));

  /**
   * on click delete
   * @param  {object} props
   */
  function clickDelete(props, e) {
    e.stopPropagation();
    var store = props.store;
    var loader = props.loader;
    var valManager = props.validation;

    props.confirmFn('Confirmation', {
      description: store.getBundle().MESSAGE.DELETE
    }).then(function () {
      loader.startLoading();
      store.deleteTenant(props.tenantInfo.id).then(function (result) {
        if (!isNil(result.messages)) {
          valManager.updateErrors(result.messages);
        }
      }).finally(loader.endLoading.bind(loader));
    });
  }

  /**
   * click visible
   * @param  {object} props
   */
  function clickVisible(props, e) {
    e.preventDefault();
    e.stopPropagation();
    var store = props.store;
    var tenantInfo = props.tenantInfo;
    var MESSAGE = store.getBundle().MESSAGE;
    var description = MESSAGE.DEACTIVATE;
    if (tenantInfo.active) {
      props.confirmFn('Confirmation', {
        description: description
      }).then(store.deactiveTenant.bind(store, tenantInfo));
    } else {
      store.activeTenant(tenantInfo);
    }
  }

  /**
   * handle selected tenant
   * @param  {object} props
   */
  function handleSelected(props, e) {
    var loader = props.loader;
    var store = props.store;
    loader.startLoading();

    props.store.setAlertMessage(commonMessages.EMPTY_MESSAGE.type, commonMessages.EMPTY_MESSAGE.message);
    props.confirmDirtyForm(store.showingTenantCloned.hasDirty).then(function () {
      props.validation.reset();
      return props.store.loadTenant(props.tenantInfo);
    }).finally(loader.endLoading.bind(loader));
  }

  module.exports = tenantItemAction;
}();

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _bluebird = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantDetail.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant Detail component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var IconMenu = __webpack_require__(86);
  var MainContent = __webpack_require__(156);
  var Tabs = __webpack_require__(131).Tabs;
  var Tab = __webpack_require__(131).Tab;
  var Panel = __webpack_require__(28);
  var Alert = __webpack_require__(61);
  var CommonMessages = __webpack_require__(37);
  var connect = __webpack_require__(2);
  var TenantDetailTab = __webpack_require__(2232);
  var Permissions = __webpack_require__(1145);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;

  var Header = observer(function (props) {
    var store = props.store;
    var disabled = !store.showingTenantCloned.active;
    var localization = props.localization;
    var authorization = props.authorization;
    var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
    var hasEditPrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsEdit]);
    var hasCreatePrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsCreate]);

    function onAuth() {
      return {
        disabled: true
      };
    }

    return React.createElement(
      'section',
      { className: 'izenda-Wrapper-header' },
      React.createElement(IconMenu, null),
      React.createElement(
        'div',
        { className: 'izenda-Alert-container' },
        React.createElement(
          Alert,
          { type: store.alertMessage.type },
          store.alertMessage.message
        )
      ),
      (hasEditPrivilege || hasCreatePrivilege) && React.createElement(
        'fieldset',
        { className: 'pull-right', disabled: disabled },
        React.createElement(
          'button',
          { className: 'btn btn-primary', onClick: props.onSave, disabled: disabled },
          localization.getText('COMMON_LABEL_SAVE')
        ),
        React.createElement(
          'button',
          { className: 'btn btn-primary u_marginLeft', onClick: props.onCancel, disabled: disabled },
          localization.getText('COMMON_LABEL_CANCEL')
        )
      )
    );
  });

  var TenantDetail = React.createClass({
    displayName: 'TenantDetail',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.props.store.init();
      this.cloneTenantDetail();
    },

    componentWillReceiveProps: function componentWillReceiveProps() {
      this.props.validation.reset();
      this.cloneTenantDetail();
    },

    componentWillUnmount: function componentWillUnmount() {
      this.props.store.destroy();
    },

    /**
     * Clone the tenant detail
     */
    cloneTenantDetail: function cloneTenantDetail() {
      this.props.store.cloneTenantDetail();
    },

    /**
     * Save Tenant
     */
    onSave: function onSave() {
      var props = this.props;
      var store = props.store;
      var localization = this.props.localization;

      var valManager = props.validation;
      var confirmFn = props.confirmFn;

      store.alertMessage = CommonMessages.EMPTY_MESSAGE; // reset alert message

      valManager.validate().bind(this).then(function (success) {
        if (success && !store.showingTenantCloned.hasDirty) {
          store.setAlertMessage('info', localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
        } else if (success) {
          store.validateAccesses().bind(this).then(function (result) {
            if (result.success !== false) {
              confirmFn('Confirmation', {
                description: store.getBundle().MESSAGE.SAVE
              }).bind(this).then(function () {
                return success && this.saveTenant();
              });
            } else {
              this.props.validation.updateErrors(result.messages);
            }
          });
        }
      });
    },

    /**
     * save Tenant
     */
    saveTenant: function saveTenant() {
      var valManager = this.props.validation;
      var props = this.props;
      var loader = props.loader;

      loader.startLoading();

      return this.props.store.saveTenant().then(updateErrorIfAny).finally(loader.endLoading.bind(loader));

      function updateErrorIfAny(errors) {
        if (!isEmpty(errors)) {
          valManager.updateErrors(errors);
        }
        return null;
      }
    },

    /**
     * Cancel all modification
     */
    onCancel: function onCancel() {
      var store = this.props.store;
      var confirmFn = this.props.confirmFn;
      var currentTenant = store.showingTenant;
      store.alertMessage = CommonMessages.EMPTY_MESSAGE; // reset alert message
      if (store.showingTenantCloned.hasDirty) {
        confirmFn('Confirmation', {
          description: store.getBundle().MESSAGE.CANCEL
        }).then(function () {
          this.props.validation.reset();
          store.loadTenant(currentTenant);
        }.bind(this));
      }
    },

    /**
     * Validation before change tabs
     * @return {object} promise
     */
    validationBeforChangeTabs: function validationBeforChangeTabs() {
      var props = this.props;
      var store = props.store;
      return props.validation.validate().bind(this).then(function (success) {
        if (success) {
          return store.validateAccesses().bind(this).then(function (result) {
            if (result.success === false) {
              return this.props.validation.updateErrors(result.messages);
            } else {
              return (0, _bluebird.resolve)(true);
            }
          });
        }
      });
    },

    render: function render() {
      var store = this.props.store;
      var disabled = !store.showingTenantCloned.active;
      var localization = this.props.localization;
      var authorization = this.props.authorization;
      var permissionKeys = this.props.authorizationConstants.PERMISSION_KEY;
      var hasPermissionTabPrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupPermissionsValue]);

      return React.createElement(
        MainContent,
        null,
        React.createElement(
          'div',
          { className: 'izenda-Wrapper' },
          React.createElement(Header, (0, _extends3.default)({}, this.props, { onSave: this.onSave, onCancel: this.onCancel })),
          React.createElement(
            'div',
            { className: 'izenda-Wrapper-content u_paddingLeftRight' },
            React.createElement(
              Panel,
              { className: 'panel-header-custom u_fullHeight u-posRelative' },
              React.createElement(
                Tabs,
                { activeTabKey: 'details', canChangeTab: this.validationBeforChangeTabs },
                React.createElement(
                  Tab,
                  { title: localization.getText('COMMON_LABEL_DETAILS'), tabKey: 'details' },
                  React.createElement(TenantDetailTab, { store: store, showingTenant: store.showingTenantCloned })
                ),
                hasPermissionTabPrivilege ? React.createElement(
                  Tab,
                  { title: localization.getText('COMMON_LABEL_PERMISSIONS'), tabKey: 'permissions' },
                  React.createElement(Permissions, {
                    permissionStore: store.permissionStore,
                    disabledTab: disabled,
                    accessStore: store.accessStore
                  })
                ) : null
              )
            )
          )
        )
      );
    }
  });

  module.exports = connect()(TenantDetail);
}();

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantDetail.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant Detail component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);

  var Panel = __webpack_require__(28);

  var Validator = __webpack_require__(23);
  var Input = Validator()(__webpack_require__(17));
  var constants = __webpack_require__(279);
  var TenantDetailModules = __webpack_require__(2233);

  var TenantIDControl = observer(function (props) {
    var showingTenant = props.showingTenant;
    var updateTenantId = props.updateTenantId;
    var localization = props.localization;

    return React.createElement(
      'div',
      { className: 'form-group' },
      React.createElement(
        'label',
        null,
        localization.getText('TENANT_DETAIL_TAB_TENANT_ID'),
        ' ',
        React.createElement('span', { className: 'validation required' })
      ),
      React.createElement(Input, { className: 'form-control',
        type: 'text',
        maxLength: '50',
        value: showingTenant.tenantID,
        onChange: updateTenantId,
        validations: constants.TENANT_ID_CONSTRAINT,
        field: 'tenantID' })
    );
  });

  var TenantNameControl = observer(function (props) {
    var showingTenant = props.showingTenant;
    var updateTenantName = props.updateTenantName;
    var localization = props.localization;
    return React.createElement(
      'div',
      { className: 'form-group' },
      React.createElement(
        'label',
        null,
        localization.getText('COMMON_LABEL_TENANT_NAME'),
        ' ',
        React.createElement('span', { className: 'validation required' })
      ),
      React.createElement(Input, { className: 'form-control',
        type: 'text',
        maxLength: '50',
        value: showingTenant.name,
        onChange: updateTenantName,
        validations: constants.TENANT_NAME_CONSTRAINT,
        field: 'name' })
    );
  });

  var TenantDescriptionControl = observer(function (props) {
    var showingTenant = props.showingTenant;
    var updateTenantDescription = props.updateTenantDescription;
    var localization = props.localization;
    return React.createElement(
      'div',
      { className: 'form-group' },
      React.createElement(
        'label',
        null,
        localization.getText('COMMON_LABEL_DESCRIPTION')
      ),
      React.createElement(Input, { className: 'form-control',
        type: 'text',
        maxLength: '100',
        value: showingTenant.description,
        onChange: updateTenantDescription })
    );
  });

  var TenantDetailTab = React.createClass({
    displayName: 'TenantDetailTab',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var showingTenant = store.showingTenantCloned;
      var disabled = !showingTenant.active;

      return React.createElement(
        Panel,
        { className: 'u_marginLeft u_marginRight' },
        React.createElement(
          'fieldset',
          { disabled: disabled },
          React.createElement(TenantIDControl, { localization: props.localization, showingTenant: showingTenant, updateTenantId: updateDetail(showingTenant, 'tenantID') }),
          React.createElement(TenantNameControl, { localization: props.localization, showingTenant: showingTenant, updateTenantName: updateDetail(showingTenant, 'name') }),
          React.createElement(TenantDescriptionControl, { localization: props.localization, showingTenant: showingTenant, updateTenantDescription: updateDetail(showingTenant, 'description') })
        ),
        React.createElement(
          'div',
          { className: 'u_paddingTop' },
          React.createElement(TenantDetailModules, { store: store })
        )
      );
    }
  });

  function updateDetail(tenant, field) {
    return function (e) {
      tenant.setDataByKey(field, e.target.value);
    };
  }

  module.exports = connect()(TenantDetailTab);
}();

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantDetailModules.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant Detail Modules
 */
!function () {

  var React = __webpack_require__(0);
  var Input = __webpack_require__(17);
  var connect = __webpack_require__(2);

  var GridLayout = __webpack_require__(13);
  var EventUtils = __webpack_require__(24);

  var _require = __webpack_require__(1),
      chunk = _require.chunk;

  var TenantDetailModules = function TenantDetailModules(props) {

    var localization = props.localization;
    var store = props.store;
    var allModules = store.modulesOfLicense || [];
    var disabled = !store.showingTenantCloned.active;
    var showingTenant = store.showingTenantCloned;

    return React.createElement(
      'fieldset',
      { disabled: disabled },
      React.createElement(
        'label',
        { className: 'u-posAbsolute' },
        localization.getText('TENANT_DETAIL_MODULES_LABEL_MODULES')
      ),
      React.createElement(
        GridLayout,
        { className: 'Izenda-TenantDetail_GridModule' },
        chunk(3, allModules).map(renderModules)
      )
    );

    function renderModules(modules, index) {
      return React.createElement(
        GridLayout.Row,
        { key: index },
        modules.map(renderModule)
      );

      function renderModule(module, index) {
        var checked = !!showingTenant.hasModule(module);
        return React.createElement(
          GridLayout.Col,
          { cols: 4, key: index },
          React.createElement(
            'label',
            null,
            React.createElement(Input, {
              type: 'checkbox',
              checked: checked,
              onChange: EventUtils.notifyChange(showingTenant.updateModules.bind(showingTenant, module), EventUtils.CHECKBOX) }),
            React.createElement(
              'span',
              null,
              module.name
            )
          )
        );
      }
    }
  };

  TenantDetailModules.propTypes = {
    store: React.PropTypes.object.isRequired
  };

  module.exports = connect()(TenantDetailModules);
}();

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionBreadcrumb.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Link = __webpack_require__(52).Link;
  var routeUtils = __webpack_require__(31);
  var PermissionConstants = __webpack_require__(72);
  var actions = __webpack_require__(2235);
  var PermissionActions = __webpack_require__(113);
  var uiState = __webpack_require__(15);
  var SECTION = __webpack_require__(72).SECTION;
  var LicenseCheckerConstants = __webpack_require__(45);
  var SettingConstant = __webpack_require__(167);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      get = _require.get,
      map = _require.map,
      filter = _require.filter,
      remove = _require.remove;

  var PermissionBreadcrumb = React.createClass({
    displayName: 'PermissionBreadcrumb',

    componentWillMount: function componentWillMount() {
      this.props.permissionStore.model.updateSection(SECTION.SystemConfiguration);
    },

    /**
     * render component
     * @return {Object} component
     */
    render: function render() {
      var link = routeUtils.getSettingsUrl();
      var props = this.props;
      var authorization = props.authorization;
      var permissionStore = props.permissionStore;
      var permission = permissionStore.model;
      var SECTION_LIST = permission.fullReportAndDashboardAccess ? PermissionConstants.SECTION_LIST_FULL_REPORT_DASHBOARD_ACCESS : PermissionConstants.SECTION_LIST;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = props.localization;
      var currentUser = uiState.currentUser;
      var isSingleMode = uiState.systemMode === SettingConstant.SYSTEM_MODE;

      props.removeActiveClass(props);

      // remove tenant setup section when in tenant management page or in tenant setting level
      if (permissionStore.isTenantSetup || isSingleMode || tenantDetail) {
        SECTION_LIST = remove(function (section) {
          return section.key === PermissionConstants.SECTION.TenantSetup;
        }, SECTION_LIST);
      }

      // Remove section when user not has License
      SECTION_LIST = filter(function (section) {
        return !section.licenseKey || section.licenseKey && authorization.checkLicense(section.licenseKey);
      }, SECTION_LIST);

      return React.createElement(
        'fieldset',
        { disabled: this.props.disabledTab },
        React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'izenda-PermissionBreadcrumb' },
            React.createElement(
              GridLayout.Col,
              { cols: 11 },
              React.createElement(
                'span',
                { className: 'u_marginRight u_paddingTopBottom u_floatLeft' },
                React.createElement('span', { className: 'icon-chevron-down u_borderAll', onClick: this.props.toggleAll.bind(this, true) }),
                React.createElement('span', { className: 'icon-chevron-up u_borderAll', onClick: this.props.toggleAll.bind(this, false) })
              ),
              map(function (section) {
                return (isNil(tenantDetail) || this.props.checkShowGroupCommon(get(section.key, tenantDetail)) || section.key === 'access' && tenantDetail.access.tenantAccess !== 0 || section.key === 'scheduling' && tenantDetail.scheduling.tenantAccess !== 0 || section.key === 'dashboards' && tenantDetail.dashboards.tenantAccess !== 0 || !isNil(section.alwaysShow) && section.alwaysShow && currentUser.isSystemUser) && React.createElement(
                  'a',
                  { key: section.key, className: 'u_paddingTopBottom u_paddingRight u_floatLeft' },
                  React.createElement(
                    'span',
                    {
                      className: this.props.getActive(section.key),
                      onClick: this.props.setActive.bind(this.props, section.key)
                    },
                    section.value
                  )
                );
              }.bind(this), SECTION_LIST)
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textBold u_paddingTopBottom' },
              localization.getText('PERMISSION_LABEL_TENANT_ACCESS')
            )
          )
        )
      );
    }
  });

  module.exports = connect(actions, PermissionActions)(PermissionBreadcrumb);
}();

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionBreadcrumbActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var setPropTypes = __webpack_require__(9).setPropTypes;

  var ACTIVE_CLASS = 'izenda-PermissionBreadcrumb_active';

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var PermissionBreadcrumbActions = compose(setPropTypes({
    permissionStore: React.PropTypes.object.isRequired
  }), withHandlers({
    toggleAll: curry(toggleAll),
    getActive: curry(getActive),
    setActive: curry(setActive),
    removeActiveClass: curry(removeActiveClass)
  }));

  /**
   * Toggle all section
   * @param {Object} props
   */
  function toggleAll(props, isShow) {
    props.permissionStore.toggleAll(isShow);
  }

  /**
   * Get active
   * @param {Object} props
   * @param {String} section
   * @returns {String} active class
   */
  function getActive(props, section) {
    return section === props.permissionStore.model.section ? ACTIVE_CLASS : null;
  }

  /**
   * Set active
   * @param {Object} props
   * @param {Object} Event
   */
  function setActive(props, section, e) {
    props.permissionStore.model.isClickedSection = true;
    removeActiveClass(props, e);
    $izenda(e.target).addClass(ACTIVE_CLASS);
    hashLinkScroll(section);
  }

  /**
   * Hash link scroll
   * @param {Object} section
   */
  function hashLinkScroll(section) {
    var element = document.getElementsByClassName(section)[0];
    if (element) element.scrollIntoView();
  }

  /**
   * Remove active class
   * @param {Object} props
   */
  function removeActiveClass(props, _) {
    $izenda('.izenda-PermissionBreadcrumb span, .izenda-PermissionBreadcrumb a').removeClass('izenda-PermissionBreadcrumb_active');
  }

  module.exports = PermissionBreadcrumbActions;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var ScrollBox = __webpack_require__(27);
  var PermissionSystemConfiguration = __webpack_require__(2237);
  var PermissionTenantSetup = __webpack_require__(2238);
  var PermissionDataSetup = __webpack_require__(2239);
  var PermissionUserSetup = __webpack_require__(2240);
  var PermissionRoleSetup = __webpack_require__(2241);
  var PermissionReports = __webpack_require__(2242);
  var PermissionDashboards = __webpack_require__(2251);
  var PermissionAccess = __webpack_require__(2255);
  var PermissionScheduling = __webpack_require__(2262);
  var PermissionEmailing = __webpack_require__(2263);
  var PermissionExporting = __webpack_require__(2264);
  var PermissionSystemWide = __webpack_require__(2265);
  var PermissionFullReportDashboardAccess = __webpack_require__(2266);
  var CheckboxAllPermission = __webpack_require__(134);

  var PermissionBody = function PermissionBody(props) {
    var permissionStore = props.permissionStore;
    var permission = permissionStore.model;
    var accessStore = props.accessStore;
    var tenantDetail = permissionStore.tenantDetail;

    /**
     * render component
     * @return {Object} component
     */
    return React.createElement(
      'div',
      { className: 'izenda-Wrapper-content' },
      React.createElement(
        ScrollBox,
        null,
        React.createElement(
          'fieldset',
          { disabled: props.disabledTab },
          React.createElement(CheckboxAllPermission, {
            selectAllPermimssion: true,
            permission: permission,
            readOnly: this.props.readOnly,
            section: permission,
            tenantPermission: tenantDetail,
            tenantDetail: tenantDetail }),
          React.createElement(PermissionFullReportDashboardAccess, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionSystemConfiguration, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionTenantSetup, { permissionStore: permissionStore, permission: permission }),
          React.createElement(PermissionDataSetup, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionUserSetup, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionRoleSetup, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionReports, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionDashboards, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionAccess, { permissionStore: permissionStore, permission: permission, accessStore: accessStore, readOnly: props.readOnly }),
          React.createElement(PermissionScheduling, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionEmailing, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionExporting, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly }),
          React.createElement(PermissionSystemWide, { permissionStore: permissionStore, permission: permission, readOnly: props.readOnly })
        )
      )
    );
  };

  PermissionBody.propTypes = {
    permissionStore: React.PropTypes.object.isRequired
  };

  module.exports = connect()(PermissionBody);
}();

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionSystemConfiguration.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var actions = __webpack_require__(113);
  var SECTION = __webpack_require__(72).SECTION;
  var EventsUtils = __webpack_require__(24);
  var LicenseCheckerConstants = __webpack_require__(45);
  var CheckboxAllPermission = __webpack_require__(134);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      get = _require.get;

  var PermissionSystemConfiguration = React.createClass({
    displayName: 'PermissionSystemConfiguration',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.systemConfiguration = this.props.permission.systemConfiguration;
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;
      var authorization = this.props.authorization;
      var hasScheduleLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Scheduling);
      var systemConfiguration = get('systemConfiguration', tenantDetail);

      return hasScheduleLicense && (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.systemConfiguration)) && React.createElement(
        'div',
        { className: SECTION.SystemConfiguration },
        React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
            React.createElement(
              GridLayout.Col,
              { cols: 2 },
              React.createElement('a', {
                className: this.props.getIconClass('isShowSystemConfiguration'),
                onClick: this.props.toggle.bind(this, 'isShowSystemConfiguration')
              }),
              localization.getText('COMMON_LABEL_SYSTEM_CONFIGURATION')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(CheckboxAllPermission, {
                permission: permission,
                readOnly: this.props.readOnly,
                section: this.systemConfiguration,
                tenantPermission: systemConfiguration,
                tenantDetail: tenantDetail
              })
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                indeterminate: this.props.getIndeterminateCommon(this.systemConfiguration),
                checked: this.props.getCheckedCommon(this.systemConfiguration.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccessParent.bind(permission, this.systemConfiguration), EventsUtils.CHECKBOX),
                readOnly: this.props.readOnly
              })
            )
          )
        ),
        permissionStore.isShowSystemConfiguration && (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.systemConfiguration.scheduledInstances)) && React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            React.createElement(
              GridLayout.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_SCHEDULED_INSTANCES')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.systemConfiguration.scheduledInstances.value),
                onChange: notifyChange(permission.updateData.bind(permission, this.systemConfiguration.scheduledInstances, 'value'), EventsUtils.CHECKBOX)
              })
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.systemConfiguration.scheduledInstances.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccess.bind(permission, this.systemConfiguration, this.systemConfiguration.scheduledInstances), EventsUtils.CHECKBOX)
              })
            )
          )
        )
      );
    }
  });

  module.exports = connect({ toClass: true }, actions)(PermissionSystemConfiguration);
}();

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionTenantSetup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var actions = __webpack_require__(113);
  var SECTION = __webpack_require__(72).SECTION;
  var EventsUtils = __webpack_require__(24);
  var uiState = __webpack_require__(15);
  var CheckboxAllPermission = __webpack_require__(134);
  var SettingConstant = __webpack_require__(167);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      get = _require.get;

  var PermissionTenantSetup = React.createClass({
    displayName: 'PermissionTenantSetup',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      var notifyChange = EventsUtils.notifyChange;
      var permission = this.props.permission;
      this.tenantSetup = this.props.permission.tenantSetup;

      this.onChangeCreate = notifyChange(permission.updateData.bind(permission, this.tenantSetup.actions, 'create'), EventsUtils.CHECKBOX);
      this.onChangeEdit = notifyChange(permission.updateData.bind(permission, this.tenantSetup.actions, 'edit'), EventsUtils.CHECKBOX);
      this.onChangeDel = notifyChange(permission.updateData.bind(permission, this.tenantSetup.actions, 'del'), EventsUtils.CHECKBOX);
      this.onChangePermission = notifyChange(permission.updateData.bind(permission, this.tenantSetup.permissions, 'value'), EventsUtils.CHECKBOX);
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var localization = this.props.localization;
      var tenantDetail = this.props.tenantDetail;
      var tenantSetup = get('tenantSetup', tenantDetail);
      var isSingleMode = uiState.systemMode === SettingConstant.SYSTEM_MODE;

      return isNil(uiState.getTenantId()) && !permission.isTenantSetup && !isSingleMode && React.createElement(
        'div',
        { className: SECTION.TenantSetup },
        React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
            React.createElement(
              GridLayout.Col,
              { cols: 2 },
              React.createElement('a', {
                className: this.props.getIconClass('isShowTenantSetup'),
                onClick: this.props.toggle.bind(this, 'isShowTenantSetup')
              }),
              localization.getText('COMMON_LABEL_TENANT_SETUP')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(CheckboxAllPermission, {
                permission: permission,
                readOnly: this.props.readOnly,
                section: this.tenantSetup,
                tenantPermission: tenantSetup,
                tenantDetail: tenantDetail
              })
            )
          )
        ),
        permissionStore.isShowTenantSetup && React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            React.createElement(
              GridLayout.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('COMMON_LABEL_ACTIONS')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    checked: this.props.getCheckedCommon(this.tenantSetup.actions.create),
                    onChange: this.onChangeCreate
                  }),
                  React.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_CREATE')
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.tenantSetup.actions.edit),
                    onChange: this.onChangeEdit
                  }),
                  React.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_EDIT')
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.tenantSetup.actions.del),
                    onChange: this.onChangeDel
                  }),
                  React.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_DELETE')
                  )
                )
              )
            ),
            React.createElement(GridLayout.Col, { cols: 1, className: 'u_textCenter' })
          ),
          React.createElement(
            GridLayout.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            React.createElement(
              GridLayout.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_PERMISSIONS')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(Input, {
                  type: 'checkbox',
                  checked: this.props.getCheckedCommon(this.tenantSetup.permissions.value),
                  onChange: this.onChangePermission
                })
              )
            ),
            React.createElement(GridLayout.Col, { cols: 1, className: 'u_textCenter' })
          )
        )
      );
    }
  });

  module.exports = connect(actions)(PermissionTenantSetup);
}();

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionDataSetup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(113);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(72);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda10 = __webpack_require__(134);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PermissionDataSetup = (_dec = (0, _Izenda2.default)({ toClass: true }, _Izenda8.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PermissionDataSetup, _Component);

  function PermissionDataSetup(props) {
    (0, _classCallCheck3.default)(this, PermissionDataSetup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PermissionDataSetup.__proto__ || (0, _getPrototypeOf2.default)(PermissionDataSetup)).call(this, props));

    _this.dataSetup = _this.props.permission.dataSetup;
    return _this;
  }

  (0, _createClass3.default)(PermissionDataSetup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          permissionStore = _props.permissionStore,
          permission = _props.permission,
          localization = _props.localization;

      var tenantDetail = permissionStore.tenantDetail;
      var dataSetup = (0, _fp.get)('dataSetup', tenantDetail);

      return ((0, _fp.isNil)(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup)) && _react2.default.createElement(
        'div',
        { className: _Izenda9.SECTION.DataSetup },
        _react2.default.createElement(
          _Izenda4.default,
          { className: 'izenda-GridLayout-Custom' },
          _react2.default.createElement(
            _Izenda4.default.Row,
            { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 2 },
              _react2.default.createElement('a', {
                className: this.props.getIconClass('isShowDataSetup'),
                onClick: this.props.toggle.bind(this, 'isShowDataSetup')
              }),
              localization.getText('COMMON_LABEL_DATA_SETUP')
            ),
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 9 },
              _react2.default.createElement(_Izenda11.default, {
                permission: permission,
                readOnly: this.props.readOnly,
                section: this.dataSetup,
                tenantPermission: dataSetup,
                tenantDetail: tenantDetail
              })
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                indeterminate: this.props.getIndeterminateCommon(this.dataSetup),
                checked: this.props.getCheckedCommon(this.dataSetup.tenantAccess),
                onChange: permission.updateTenantAccessParentDataSetup.bind(permission, this.dataSetup)
              })
            )
          )
        ),
        permissionStore.isShowDataSetup && ((0, _fp.isNil)(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup)) && _react2.default.createElement(
          _Izenda4.default,
          { className: 'izenda-GridLayout-Custom' },
          ((0, _fp.isNil)(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup.dataModel)) && _react2.default.createElement(
            _Izenda4.default.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('COMMON_LABEL_DATA_MODEL')
            ),
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 9 },
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.dataSetup.dataModel.value),
                onChange: permission.updateDataModel.bind(permission, this.dataSetup, 'value')
              })
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.dataSetup.dataModel.tenantAccess),
                onChange: permission.updateTenantAccessDataModel.bind(permission, this.dataSetup, this.dataSetup.dataModel)
              })
            )
          ),
          ((0, _fp.isNil)(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup.dataModel.customView)) && this.props.getCheckedCommon(this.dataSetup.dataModel.value) && _react2.default.createElement(
            _Izenda4.default.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubSubCategory' },
              localization.getText('COMMON_LABEL_CUSTOM_VIEW')
            ),
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 9 },
              ((0, _fp.isNil)(tenantDetail) || tenantDetail.dataSetup.dataModel.customView.create) && _react2.default.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement(_Izenda6.default, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.dataSetup.dataModel.customView.create),
                    onChange: permission.updateDataSetup.bind(permission, this.dataSetup.dataModel.customView, 'create')
                  }),
                  _react2.default.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_CREATE')
                  )
                )
              ),
              ((0, _fp.isNil)(tenantDetail) || tenantDetail.dataSetup.dataModel.customView.edit) && _react2.default.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement(_Izenda6.default, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.dataSetup.dataModel.customView.edit),
                    onChange: permission.updateDataSetup.bind(permission, this.dataSetup.dataModel.customView, 'edit')
                  }),
                  _react2.default.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_EDIT')
                  )
                )
              ),
              ((0, _fp.isNil)(tenantDetail) || tenantDetail.dataSetup.dataModel.customView.delete) && _react2.default.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement(_Izenda6.default, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.dataSetup.dataModel.customView.delete),
                    onChange: permission.updateDataSetup.bind(permission, this.dataSetup.dataModel.customView, 'delete')
                  }),
                  _react2.default.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_DELETE')
                  )
                )
              )
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.dataSetup.dataModel.customView.tenantAccess),
                onChange: permission.updateTenantAccessCustomView.bind(permission, this.dataSetup, this.dataSetup.dataModel.customView)
              })
            )
          ),
          ((0, _fp.isNil)(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dataSetup.advancedSettings)) && _react2.default.createElement(
            _Izenda4.default.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_ADVANCED_SETTING')
            ),
            _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 9 },
              ((0, _fp.isNil)(tenantDetail) || tenantDetail.dataSetup.advancedSettings.category) && _react2.default.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement(_Izenda6.default, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.dataSetup.advancedSettings.category),
                    onChange: permission.updateDataSetup.bind(permission, this.dataSetup.advancedSettings, 'category')
                  }),
                  _react2.default.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_CATEGORY')
                  )
                )
              ),
              ((0, _fp.isNil)(tenantDetail) || tenantDetail.dataSetup.advancedSettings.others) && _react2.default.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement(_Izenda6.default, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.dataSetup.advancedSettings.others),
                    onChange: permission.updateDataSetup.bind(permission, this.dataSetup.advancedSettings, 'others')
                  }),
                  _react2.default.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_OTHERS')
                  )
                )
              )
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda4.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.dataSetup.advancedSettings.tenantAccess),
                onChange: permission.updateTenantAccessDataSetup.bind(permission, this.dataSetup, this.dataSetup.advancedSettings)
              })
            )
          )
        )
      );
    }
  }]);
  return PermissionDataSetup;
}(_react.Component), _class2.propTypes = {
  permission: _react2.default.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PermissionDataSetup;
module.exports = exports['default'];

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionUserSetup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var actions = __webpack_require__(113);
  var SECTION = __webpack_require__(72).SECTION;
  var EventsUtils = __webpack_require__(24);
  var CheckboxAllPermission = __webpack_require__(134);

  var _require = __webpack_require__(1),
      get = _require.get,
      isNil = _require.isNil;

  var PermissionUserSetup = React.createClass({
    displayName: 'PermissionUserSetup',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      var notifyChange = EventsUtils.notifyChange;
      var permission = this.props.permission;
      this.userSetup = this.props.permission.userSetup;

      this.updateTenantAccessParent = notifyChange(permission.updateTenantAccessParent.bind(permission, this.userSetup), EventsUtils.CHECKBOX);
      this.onChangeCreate = notifyChange(permission.updateData.bind(permission, this.userSetup.actions, 'create'), EventsUtils.CHECKBOX);
      this.onChangeEdit = notifyChange(permission.updateUserSetupEdit.bind(permission, this.userSetup.actions), EventsUtils.CHECKBOX);
      this.onChangeDel = notifyChange(permission.updateData.bind(permission, this.userSetup.actions, 'del'), EventsUtils.CHECKBOX);
      this.onChangeConfigureSecurityOptions = notifyChange(permission.updateData.bind(permission, this.userSetup.actions, 'configureSecurityOptions'), EventsUtils.CHECKBOX);
      this.updateTenantAccessUserSetup = notifyChange(permission.updateTenantAccess.bind(permission, this.userSetup, this.userSetup.actions), EventsUtils.CHECKBOX);
      this.onChangeUserRoleAssociation = notifyChange(permission.updateData.bind(permission, this.userSetup.userRoleAssociation, 'value'), EventsUtils.CHECKBOX);
      this.updateTenantAccessUserRoleAssociation = notifyChange(permission.updateTenantAccess.bind(permission, this.userSetup, this.userSetup.userRoleAssociation), EventsUtils.CHECKBOX);
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;
      var userSetup = get('userSetup', tenantDetail);

      return (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.userSetup)) && React.createElement(
        'div',
        { className: SECTION.UserSetup },
        React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
            React.createElement(
              GridLayout.Col,
              { cols: 2 },
              React.createElement('a', {
                className: this.props.getIconClass('isShowUserSetup'),
                onClick: this.props.toggle.bind(this, 'isShowUserSetup')
              }),
              localization.getText('COMMON_LABEL_USER_SETUP')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(CheckboxAllPermission, {
                permission: permission,
                readOnly: this.props.readOnly,
                section: this.userSetup,
                tenantPermission: userSetup,
                tenantDetail: tenantDetail
              })
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                indeterminate: this.props.getIndeterminateCommon(this.userSetup),
                checked: this.props.getCheckedCommon(this.userSetup.tenantAccess),
                onChange: this.updateTenantAccessParent
              })
            )
          )
        ),
        permissionStore.isShowUserSetup && React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.userSetup.actions)) && React.createElement(
            GridLayout.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            React.createElement(
              GridLayout.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('COMMON_LABEL_ACTIONS')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              (isNil(tenantDetail) || tenantDetail.userSetup.actions.create) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.userSetup.actions.create),
                    onChange: this.onChangeCreate
                  }),
                  React.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_CREATE')
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.userSetup.actions.edit) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.userSetup.actions.edit),
                    onChange: this.onChangeEdit
                  }),
                  React.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_EDIT')
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.userSetup.actions.del) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.userSetup.actions.del),
                    onChange: this.onChangeDel
                  }),
                  React.createElement(
                    'span',
                    null,
                    localization.getText('COMMON_LABEL_DELETE')
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.userSetup.actions.configureSecurityOptions) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    checked: this.props.getCheckedCommon(this.userSetup.actions.configureSecurityOptions),
                    onChange: this.onChangeConfigureSecurityOptions,
                    disabled: !this.props.getCheckedCommon(this.userSetup.actions.edit),
                    readOnly: this.props.readOnly
                  }),
                  React.createElement(
                    'span',
                    null,
                    localization.getText('PERMISSION_LABEL_PASSWORD_OPTIONS')
                  )
                )
              )
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.userSetup.actions.tenantAccess),
                onChange: this.updateTenantAccessUserSetup
              })
            )
          ),
          (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.userSetup.userRoleAssociation)) && React.createElement(
            GridLayout.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            React.createElement(
              GridLayout.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_USER_ROLE_ASSOCIATION')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(Input, {
                  type: 'checkbox',
                  readOnly: this.props.readOnly,
                  checked: this.props.getCheckedCommon(this.userSetup.userRoleAssociation.value),
                  onChange: this.onChangeUserRoleAssociation
                })
              )
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.userSetup.userRoleAssociation.tenantAccess),
                onChange: this.updateTenantAccessUserRoleAssociation
              })
            )
          )
        )
      );
    }
  });

  module.exports = connect(actions)(PermissionUserSetup);
}();

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(113);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(72);

var _Izenda10 = __webpack_require__(134);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PermissionRoleSetup = function PermissionRoleSetup(props) {
  var _props$permissionStor = props.permissionStore,
      tenantDetail = _props$permissionStor.tenantDetail,
      isShowRoleSetup = _props$permissionStor.isShowRoleSetup,
      permission = props.permission,
      _props$permission = props.permission,
      roleSetup = _props$permission.roleSetup,
      isTenantSetup = _props$permission.isTenantSetup,
      localization = props.localization,
      readOnly = props.readOnly;

  var tenantRoleSetup = (0, _fp.get)('roleSetup', tenantDetail);

  return ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.roleSetup)) && _react2.default.createElement(
    'div',
    { className: _Izenda9.SECTION.RoleSetup },
    _react2.default.createElement(
      _Izenda4.default,
      { className: 'izenda-GridLayout-Custom' },
      _react2.default.createElement(
        _Izenda4.default.Row,
        { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 2 },
          _react2.default.createElement('a', {
            className: props.getIconClass('isShowRoleSetup'),
            onClick: props.toggle('isShowRoleSetup')
          }),
          localization.getText('COMMON_LABEL_ROLE_SETUP')
        ),
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 9 },
          _react2.default.createElement(_Izenda11.default, {
            permission: permission,
            readOnly: readOnly,
            section: roleSetup,
            tenantPermission: tenantRoleSetup,
            tenantDetail: tenantDetail
          })
        ),
        isTenantSetup && _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 1, className: 'u_textCenter' },
          _react2.default.createElement(_Izenda6.default, {
            type: 'checkbox',
            readOnly: readOnly,
            indeterminate: props.getIndeterminateCommon(roleSetup),
            checked: props.getCheckedCommon(roleSetup.tenantAccess),
            onChange: props.permissionUpdateTenantAccessParent(roleSetup)
          })
        )
      )
    ),
    isShowRoleSetup && _react2.default.createElement(
      _Izenda4.default,
      { className: 'izenda-GridLayout-Custom' },
      ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.roleSetup.actions)) && _react2.default.createElement(
        _Izenda4.default.Row,
        { className: 'u_paddingTop u_paddingBottom' },
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
          localization.getText('COMMON_LABEL_ACTIONS')
        ),
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 9 },
          ((0, _fp.isNil)(tenantDetail) || tenantDetail.roleSetup.actions.create) && _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(roleSetup.actions.create),
                onChange: props.permissionUpdateData(roleSetup.actions, 'create')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('COMMON_LABEL_CREATE')
              )
            )
          ),
          ((0, _fp.isNil)(tenantDetail) || tenantDetail.roleSetup.actions.edit) && _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(roleSetup.actions.edit),
                onChange: props.permissionUpdateData(roleSetup.actions, 'edit')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('COMMON_LABEL_EDIT')
              )
            )
          ),
          ((0, _fp.isNil)(tenantDetail) || tenantDetail.roleSetup.actions.del) && _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(roleSetup.actions.del),
                onChange: props.permissionUpdateData(roleSetup.actions, 'del')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('COMMON_LABEL_DELETE')
              )
            )
          )
        ),
        isTenantSetup && _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 1, className: 'u_textCenter' },
          _react2.default.createElement(_Izenda6.default, {
            type: 'checkbox',
            readOnly: readOnly,
            checked: props.getCheckedCommon(roleSetup.actions.tenantAccess),
            onChange: props.permissionUpdateTenantAccess(roleSetup, roleSetup.actions)
          })
        )
      ),
      ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.roleSetup.dataModelAccess)) && _react2.default.createElement(
        _Izenda4.default.Row,
        { className: 'u_paddingTop u_paddingBottom' },
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
          localization.getText('PERMISSION_LABEL_DATA_MODEL_ACCESS')
        ),
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 9 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(roleSetup.dataModelAccess.value),
              onChange: props.permissionUpdateData(roleSetup.dataModelAccess, 'value')
            })
          )
        ),
        isTenantSetup && _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 1, className: 'u_textCenter' },
          _react2.default.createElement(_Izenda6.default, {
            type: 'checkbox',
            readOnly: readOnly,
            checked: props.getCheckedCommon(roleSetup.dataModelAccess.tenantAccess),
            onChange: props.permissionUpdateTenantAccess(roleSetup, roleSetup.dataModelAccess)
          })
        )
      ),
      ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.roleSetup.permissions)) && _react2.default.createElement(
        _Izenda4.default.Row,
        { className: 'u_paddingTop u_paddingBottom' },
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
          localization.getText('PERMISSION_LABEL_PERMISSIONS')
        ),
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 9 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(roleSetup.permissions.value),
              onChange: props.permissionUpdateData(roleSetup.permissions, 'value')
            })
          )
        ),
        isTenantSetup && _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 1, className: 'u_textCenter' },
          _react2.default.createElement(_Izenda6.default, {
            type: 'checkbox',
            readOnly: readOnly,
            checked: props.getCheckedCommon(roleSetup.permissions.tenantAccess),
            onChange: props.permissionUpdateTenantAccess(roleSetup, roleSetup.permissions)
          })
        )
      ),
      ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.roleSetup.grantRoleWithFullReportAndDashboardAccess)) && _react2.default.createElement(
        _Izenda4.default.Row,
        { className: 'u_paddingTop u_paddingBottom' },
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
          localization.getText('PERMISSION_LABEL_GRANT_ROLE_WITH_FULL_REPORT_AND_DASHBOARD_ACCESS')
        ),
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 9 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              checked: props.getCheckedCommon(roleSetup.grantRoleWithFullReportAndDashboardAccess.value),
              onChange: props.permissionUpdateData(roleSetup.grantRoleWithFullReportAndDashboardAccess, 'value'),
              readOnly: readOnly
            })
          )
        ),
        isTenantSetup && _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 1, className: 'u_textCenter' },
          _react2.default.createElement(_Izenda6.default, {
            type: 'checkbox',
            readOnly: readOnly,
            checked: props.getCheckedCommon(roleSetup.grantRoleWithFullReportAndDashboardAccess.tenantAccess),
            onChange: props.permissionUpdateTenantAccess(roleSetup, roleSetup.grantRoleWithFullReportAndDashboardAccess)
          })
        )
      )
    )
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionRoleSetup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

PermissionRoleSetup.propTypes = {
  permission: _propTypes2.default.object.isRequired
};

exports.default = (0, _Izenda2.default)(_Izenda8.default)(PermissionRoleSetup);
module.exports = exports['default'];

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReports.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);

  var PermissionReportHeader = __webpack_require__(2243);
  var PermissionReportBody = __webpack_require__(2245);
  var PermissionReportFooter = __webpack_require__(2249);
  var actions = __webpack_require__(113);
  var SECTION = __webpack_require__(72).SECTION;
  var EventsUtils = __webpack_require__(24);
  var UNCHECK_VALUE = 0;
  var CheckboxAllPermission = __webpack_require__(134);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      get = _require.get;

  var PermissionReports = React.createClass({
    displayName: 'PermissionReports',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.reports = this.props.permission.reports;
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;
      var reports = get('reports', tenantDetail);

      return !permission.fullReportAndDashboardAccess && (isNil(tenantDetail) || tenantDetail.reports.tenantAccess !== UNCHECK_VALUE) && React.createElement(
        'div',
        { className: SECTION.Reports },
        React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
            React.createElement(
              GridLayout.Col,
              { cols: 2 },
              React.createElement('a', {
                className: this.props.getIconClass('isShowReports'),
                onClick: this.props.toggle.bind(this, 'isShowReports')
              }),
              localization.getText('COMMON_LABEL_REPORTS')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(CheckboxAllPermission, {
                permission: permission,
                readOnly: this.props.readOnly,
                section: this.reports,
                tenantPermission: reports,
                tenantDetail: tenantDetail
              })
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                indeterminate: this.props.getIndeterminateCommon(this.reports),
                checked: this.props.getCheckedCommon(this.reports.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccessParent.bind(permission, this.reports), EventsUtils.CHECKBOX)
              })
            )
          )
        ),
        permissionStore.isShowReports && React.createElement(
          'div',
          null,
          React.createElement(PermissionReportHeader, this.props),
          React.createElement(PermissionReportBody, this.props),
          React.createElement(PermissionReportFooter, this.props)
        )
      );
    }
  });

  module.exports = connect({ toClass: true }, actions)(PermissionReports);
}();

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2244);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(45);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReportHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var NUMBER_ZERO = 0;

var PermissionReportHeader = function PermissionReportHeader(props) {
  var isTenantSetup = props.permission.isTenantSetup,
      localization = props.localization,
      tenantDetail = props.permissionStore.tenantDetail,
      authorization = props.authorization,
      readOnly = props.readOnly,
      reports = props.permission.reports;

  var hasReportDesignerLicense = authorization.checkLicense(_Izenda10.default.LICENSE_KEY.ReportDesigner);
  var hasChartingLicense = authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Charting);
  var hasFormLicense = authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Form);
  var hasMapLicense = authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Maps);

  return _react2.default.createElement(
    _Izenda4.default,
    { className: 'izenda-GridLayout-Custom' },
    hasReportDesignerLicense && ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.canCreateNewReport)) && _react2.default.createElement(
      _Izenda4.default.Row,
      { className: 'u_paddingTop u_paddingBottom' },
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
        localization.getText('PERMISSION_LABEL_CAN_CREATE_REPORT')
      ),
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 9 },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(_Izenda6.default, {
            type: 'checkbox',
            readOnly: readOnly,
            checked: props.getCheckedCommon(reports.canCreateNewReport.value),
            onChange: props.permissionUpdateData(reports.canCreateNewReport, 'value')
          })
        )
      ),
      isTenantSetup && _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 1, className: 'u_textCenter' },
        _react2.default.createElement(_Izenda6.default, {
          type: 'checkbox',
          readOnly: readOnly,
          checked: props.getCheckedCommon(reports.canCreateNewReport.tenantAccess),
          onChange: props.permissionUpdateTenantAccess(reports, reports.canCreateNewReport)
        })
      )
    ),
    hasReportDesignerLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.dataSources.tenantAccess !== NUMBER_ZERO) && _react2.default.createElement(
      _Izenda4.default.Row,
      { className: 'u_paddingTop u_paddingBottom' },
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
        localization.getText('PERMISSION_LABEL_DATA_SOURCES')
      ),
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 9 },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'radio',
              readOnly: readOnly,
              name: 'datasource',
              checked: props.getCheckedCommon(reports.dataSources.simpleDataSources),
              onChange: props.onChangeSimpleDataSource
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_SIMPLE_DATA_SOURCES')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'radio',
              readOnly: readOnly,
              name: 'datasource',
              checked: props.getCheckedCommon(reports.dataSources.advancedDataSources),
              onChange: props.onChangeAdvancedDataSource
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_ADVANCED_DATA_SOURCES')
            )
          )
        )
      ),
      isTenantSetup && _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 1, className: 'u_textCenter' },
        _react2.default.createElement(_Izenda6.default, {
          type: 'checkbox',
          readOnly: readOnly,
          checked: props.getCheckedCommon(reports.dataSources.tenantAccess),
          onChange: props.permissionUpdateTenantAccess(reports, reports.dataSources)
        })
      )
    ),
    hasReportDesignerLicense && ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.reportPartTypes)) && _react2.default.createElement(
      _Izenda4.default.Row,
      { className: 'u_paddingTop u_paddingBottom' },
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
        localization.getText('PERMISSION_LABEL_REPORT_PART_TYPES')
      ),
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 9 },
        hasChartingLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.reportPartTypes.chart) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(reports.reportPartTypes.chart),
              onChange: props.permissionUpdateData(reports.reportPartTypes, 'chart')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_CHART')
            )
          )
        ),
        hasFormLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.reportPartTypes.form) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(reports.reportPartTypes.form),
              onChange: props.permissionUpdateData(reports.reportPartTypes, 'form')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_FORM')
            )
          )
        ),
        hasChartingLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.reportPartTypes.gauge) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(reports.reportPartTypes.gauge),
              onChange: props.permissionUpdateData(reports.reportPartTypes, 'gauge')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_GAUGE')
            )
          )
        ),
        hasMapLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.reportPartTypes.map) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(reports.reportPartTypes.map),
              onChange: props.permissionUpdateData(reports.reportPartTypes, 'map')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_MAP')
            )
          )
        )
      ),
      isTenantSetup && _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 1, className: 'u_textCenter' },
        _react2.default.createElement(_Izenda6.default, {
          type: 'checkbox',
          readOnly: readOnly,
          checked: props.getCheckedCommon(reports.reportPartTypes.tenantAccess),
          onChange: props.permissionUpdateTenantAccess(reports, reports.reportPartTypes)
        })
      )
    ),
    ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.reportCategoriesSubcategories)) && _react2.default.createElement(
      _Izenda4.default.Row,
      { className: 'u_paddingTop u_paddingBottom' },
      _react2.default.createElement(
        _Izenda4.default.Col,
        { className: 'izenda-PermissionCategory-SubCategory' },
        localization.getText('PERMISSION_LABEL_REPORT_CATEGORIES_SUBCATEGORIES')
      )
    ),
    ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.reportCategoriesSubcategories.canCreateNewCategory)) && _react2.default.createElement(
      _Izenda4.default.Row,
      { className: 'u_paddingTop u_paddingBottom' },
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 2, className: 'izenda-PermissionCategory-SubSubCategory' },
        localization.getText('PERMISSION_LABEL_CAN_CREATE_CATEGORY')
      ),
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 9 },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(_Izenda6.default, {
            type: 'checkbox',
            readOnly: readOnly,
            checked: props.getCheckedCommon(reports.reportCategoriesSubcategories.canCreateNewCategory.value),
            onChange: props.permissionUpdateData(reports.reportCategoriesSubcategories.canCreateNewCategory, 'value')
          })
        )
      ),
      isTenantSetup && _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 1, className: 'u_textCenter' },
        _react2.default.createElement(_Izenda6.default, {
          type: 'checkbox',
          readOnly: readOnly,
          checked: props.getCheckedCommon(reports.reportCategoriesSubcategories.canCreateNewCategory.tenantAccess),
          onChange: props.permissionUpdateTenantAccess(reports, reports.reportCategoriesSubcategories.canCreateNewCategory)
        })
      )
    )
  );
};

PermissionReportHeader.propTypes = {
  permission: _propTypes2.default.object.isRequired
};

exports.default = (0, _Izenda2.default)(_Izenda8.default)(PermissionReportHeader);
module.exports = exports['default'];

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

/**
 * OnChange simple data source
 * @param {Object} props
 * @param {Boolean} value
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReportActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var onChangeSimpleDataSource = function onChangeSimpleDataSource(props, radio) {
  var checked = radio.target.checked;
  props.permission.toggleReportDataSources(checked);
};

/**
 * OnChange simple data source
 * @param {Object} props
 * @param {Boolean} value
 */
var onChangeAdvancedDataSource = function onChangeAdvancedDataSource(props, radio) {
  var checked = radio.target.checked;
  props.permission.toggleReportDataSources(!checked);
};

/**
 * Permission Update Data
 * @param {Object} props
 * @param {Object} data
 * @param {String} value
 * @param {Object} event
 */
var permissionUpdateData = function permissionUpdateData(props, data, value, event) {
  props.permission.updateData(data, value, event.target.checked);
};

/**
 * Permission Update Tenant Access
 * @param {Object} props
 * @param {Object} data
 * @param {Object} value
 * @param {Object} event
 */
var permissionUpdateTenantAccess = function permissionUpdateTenantAccess(props, data, value, event) {
  props.permission.updateTenantAccess(data, value, event.target.checked);
};

exports.default = (0, _recompose.withHandlers)({
  onChangeSimpleDataSource: (0, _fp.curry)(onChangeSimpleDataSource),
  onChangeAdvancedDataSource: (0, _fp.curry)(onChangeAdvancedDataSource),
  permissionUpdateData: (0, _fp.curry)(permissionUpdateData),
  permissionUpdateTenantAccess: (0, _fp.curry)(permissionUpdateTenantAccess)
});
module.exports = exports['default'];

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReportBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var EventsUtils = __webpack_require__(24);
  var CategoryPermission = __webpack_require__(1146);
  var constants = __webpack_require__(279).TENANT_PERMISSIONS.REPORT.CATEGORY_ACCESSIBILITY;
  var PermissionConstants = __webpack_require__(72);
  var UNCHECK_VALUE = 0;

  var PermissionReportBody = React.createClass({
    displayName: 'PermissionReportBody',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      var permissionStore = this.props.permissionStore;
      this.reports = this.props.permission.reports;
      this.afterSwitchTree = permissionStore.updateReportAccessibilityCategory.bind(permissionStore);
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permission = this.props.permission;
      var permissionStore = this.props.permissionStore;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;

      return !permissionStore.isTenantSetup && React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          { className: 'u_paddingTop u_paddingBottom u_borderBottom u_noMarginAll' },
          React.createElement(
            GridLayout.Col,
            { cols: 2, className: 'izenda-PermissionCategory-SubSubCategory' },
            localization.getText("PERMISSION_LABEL_CATEGORY_ACCESSIBILITY")
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 9 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock u_fullWidth' },
              React.createElement(CategoryPermission, (0, _extends3.default)({}, this.props, {
                typeName: PermissionConstants.SECTION.Reports,
                leftHeader: constants.AVAILABLE_TREE_HEADER,
                rightHeader: constants.SAVABLE_TREE_HEADER,
                middleHeader: constants.VISIBLE_TREE_HEADER,
                categoryPermission: this.props.permissionStore.reportCategoryAccessibility,
                afterSwitchTree: this.afterSwitchTree
              }))
            )
          ),
          permissionStore.isTenantSetup && React.createElement(
            GridLayout.Col,
            { cols: 1, className: 'u_textCenter' },
            React.createElement(Input, { type: 'checkbox',
              readOnly: this.props.readOnly,
              checked: this.props.getCheckedCommon(this.reports.reportCategoriesSubcategories.categoryAccessibility.tenantAccess),
              onChange: notifyChange(permission.updateTenantAccess.bind(permission, this.reports, this.reports.reportCategoriesSubcategories.categoryAccessibility), EventsUtils.CHECKBOX) })
          )
        )
      );
    }
  });

  module.exports = connect()(PermissionReportBody);
}();

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonTree.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var SearchTextBox = __webpack_require__(107);
  var connect = __webpack_require__(2);
  var observer = __webpack_require__(10).observer;
  var compose = __webpack_require__(9).compose;
  var mapProps = __webpack_require__(9).mapProps;
  var withHandlers = __webpack_require__(9).withHandlers;
  var Input = __webpack_require__(17);
  var TextHighLight = __webpack_require__(62);
  var TreeView = __webpack_require__(172);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      filter = _require.filter,
      get = _require.get;

  var checkboxAction = compose(withHandlers({
    onCheck: curry(function (props, e) {
      props.node.check(null);
    })
  }));

  var LeafNodeCheckBox = connect(checkboxAction)(function (props) {
    var node = props.node;

    return React.createElement(Input, {
      indeterminate: node.displayCheckedStatus === 0,
      type: 'checkbox',
      checked: node.displayCheckedStatus === 1,
      onChange: props.onCheck,
      disabled: node.disabledCheckBox || props.readOnly
    });
  });

  var LeafNodeText = observer(function (props) {
    return React.createElement(TextHighLight, { highlight: props.node.hightLightText, text: props.node.nodeText, className: 'u_textNormal' });
  });

  var NumberIndicator = observer(function (props) {
    var node = props.node;
    if (!node.showNumChildren || !node.isBranchNode) {
      return null;
    }
    return React.createElement(
      'span',
      null,
      String.format(' ({0})', node.numberOfChildren)
    );
  });

  var renderNode = function renderNode(node, toggleIcon) {
    return React.createElement(
      'div',
      { className: 'checkbox u_noMarginAll' },
      React.createElement(
        'label',
        null,
        React.createElement(LeafNodeCheckBox, { node: node }),
        React.createElement(LeafNodeText, { node: node }),
        React.createElement(NumberIndicator, { node: node })
      ),
      toggleIcon
    );
  };

  var CommonTreeSearch = compose(observer, mapProps(function (props) {
    return {
      value: props.filter.text,
      onChange: function onChange(e) {
        props.filter.text = e.target.value;
      }
    };
  }))(SearchTextBox);

  var CommonTreeBody = observer(function (props) {
    var filtersNode = filter('isDisplayNode', props.nodes);

    return React.createElement(TreeView, {
      className: 'u_paddingRight',
      nodes: filtersNode,
      renderNode: renderNode,
      getKey: get('key'),
      getChildNodes: get('displayChildNodes'),
      collapsed: false
    });
  });

  var CommonTree = connect()(function (props) {
    return React.createElement(
      'div',
      { className: 'izenda-CommonTree u_table u_fullSize u_borderAll' },
      React.createElement(
        'div',
        { className: 'u_tableRow' },
        React.createElement(
          'div',
          { className: 'u_tableCell u_paddingAll u_borderBottom' },
          props.headerIcon && React.createElement('span', { className: props.headerIcon }),
          React.createElement(
            'span',
            { className: 'u_textBold' },
            props.header
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'u_tableRow' },
        React.createElement(
          'div',
          { className: 'u_tableCell u_paddingAll u_borderBottom' },
          React.createElement(
            'div',
            { className: 'u-posRelative' },
            React.createElement(CommonTreeSearch, props)
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'u_tableRow' },
        React.createElement(
          'div',
          { className: 'u_tableCell u_fullSize' },
          React.createElement(CommonTreeBody, { nodes: props.nodes })
        )
      )
    );
  });

  CommonTree.propTypes = {
    nodes: React.PropTypes.array.isRequired,
    filter: React.PropTypes.object.isRequired
  };

  module.exports = CommonTree;
}();

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryPermissionAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var m = __webpack_require__(5);
  var observer = __webpack_require__(10).observer;
  var compose = __webpack_require__(9).compose;
  var withProps = __webpack_require__(9).withProps;
  var withHandlers = __webpack_require__(9).withHandlers;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var createTransformer = __webpack_require__(2248);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      flow = _require.flow,
      reject = _require.reject,
      forEach = _require.forEach,
      invokeArgs = _require.invokeArgs,
      isEmpty = _require.isEmpty,
      map = _require.map,
      join = _require.join,
      filter = _require.filter,
      get = _require.get,
      negate = _require.negate,
      assign = _require.assign,
      find = _require.find;

  var switchTree = function switchTree(fromNode, useFunction, toValue, props) {
    var recursiveSwitchState = m.action(flow(reject({ displayCheckedStatus: -1 }), forEach(function (node) {
      if (node.displayCheckedStatus === 1) {
        invokeArgs(useFunction, [toValue], node.basedNode);
      }
      node.checkboxStatus = false;
      recursiveSwitchState(node.displayChildNodes);
    })));

    var displayNodes = filter('isDisplayNode', fromNode);
    if (useFunction === 'toggleSavable' && toValue) {
      validateSavable(displayNodes, props);
    }

    recursiveSwitchState(displayNodes);
    props.afterSwitchTree();
  };

  /**
   * Validate savable to show error message
   * @param  {Array} displayNodes
   * @param  {Object} props
   */
  function validateSavable(displayNodes, props) {
    var buildMessageCategory = function buildMessageCategory(node) {
      var displayChildNodes = isEmpty(node.displayChildNodes) ? '' : buildMessageCategories(node.displayChildNodes);
      return String.format('<li>{0}{1}</li>', node.basedNode.name, displayChildNodes);
    };

    var buildMessageCategories = flow(reject({ displayCheckedStatus: -1 }), map(buildMessageCategory), join(''), function (text) {
      return isEmpty(text) ? '' : String.format('<ul>{0}</ul>', text);
    });

    var globalCategory = find(function (item) {
      return get('basedNode.isGlobal', item);
    }, displayNodes);

    if (globalCategory) {
      var globalNodes = get('displayChildNodes', globalCategory);
      var message = buildMessageCategories(globalNodes);
      var popupMessage = String.format(localizer.getText('ROLE_SETUP_PERMISSION_NOT_ALLOW_TO_SAVE'), props.typeName, message);

      if (message) {
        props.confirmFn('Information', {
          description: popupMessage,
          type: 'error',
          isHTMLFormat: true,
          showCloseIndicator: true
        });
      }
    }
  }

  var UserRolePermissionAction = compose(setPropTypes({
    categoryPermission: React.PropTypes.object.isRequired,
    rightHeader: React.PropTypes.string.isRequired,
    leftHeader: React.PropTypes.string.isRequired,
    middleHeader: React.PropTypes.string.isRequired
  }), withProps(function () {
    var leftTreeFilter = m.observable({ text: '' });
    var middleTreeFilter = m.observable({ text: '' });
    var rightTreeFilter = m.observable({ text: '' });
    var basedOption = {
      getChild: get('subCategories'),
      getText: get('name'),
      showNumChildren: get('showNumChildren'),
      getKey: get('displayKey'),
      checkBranchNode: negate(get('isSubCategory'))
    };

    var leftTreeOption = assign(basedOption, {
      checkDisplayNode: get('showInAvailableTree'),
      filter: leftTreeFilter
    });

    var middleTreeOption = assign(basedOption, {
      checkDisplayNode: get('showInVisibleTree'),
      filter: middleTreeFilter
    });

    var rightTreeOption = assign(basedOption, {
      checkDisplayNode: get('showInSavableTree'),
      filter: rightTreeFilter
    });

    return {
      leftTreeFilter: leftTreeFilter,
      transformerLeftTree: createTransformer(leftTreeOption),
      rightTreeFilter: rightTreeFilter,
      transformerRightTree: createTransformer(rightTreeOption),
      middleTreeFilter: middleTreeFilter,
      transformerMiddleTree: createTransformer(middleTreeOption)
    };
  }), observer, withProps(function (props) {
    var categories = props.categoryPermission.categories;

    return {
      leftTree: props.transformerLeftTree(categories),
      rightTree: props.transformerRightTree(categories),
      middleTree: props.transformerMiddleTree(categories)
    };
  }), withHandlers({
    fromLeftToMiddle: function fromLeftToMiddle(props) {
      return switchTree.bind(null, props.leftTree, 'toggleVisible', true, props);
    },
    fromMiddleToLeft: function fromMiddleToLeft(props) {
      return switchTree.bind(null, props.middleTree, 'toggleVisible', false, props);
    },
    fromRightToMiddle: function fromRightToMiddle(props) {
      return switchTree.bind(null, props.rightTree, 'toggleSavable', false, props);
    },
    fromMiddleToRight: function fromMiddleToRight(props) {
      return switchTree.bind(null, props.middleTree, 'toggleSavable', true, props);
    }
  }));

  module.exports = UserRolePermissionAction;
}();

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonTreeTransformer.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      isArrayLike = _require.isArrayLike,
      flatMap = _require.flatMap,
      invokeArgs = _require.invokeArgs,
      invokeMap = _require.invokeMap,
      isNil = _require.isNil,
      filter = _require.filter,
      every = _require.every,
      isEmpty = _require.isEmpty,
      escapeRegExp = _require.escapeRegExp,
      forEach = _require.forEach,
      isBoolean = _require.isBoolean,
      reject = _require.reject;

  var createTransformer = function createTransformer(commonTreeOption) {
    var transformer = m.createTransformer(function (basedNode) {
      if (isArrayLike(basedNode)) {
        return flatMap(transformer, basedNode);
      }
      return [new NodeModel(basedNode)];
    }, function (nodeModels) {
      invokeMap('dispose', nodeModels);
    });

    var NodeModel = function NodeModel(basedNode) {
      var props = {
        basedNode: basedNode,
        isBranchNode: function isBranchNode() {
          return commonTreeOption.checkBranchNode ? commonTreeOption.checkBranchNode(this.basedNode) : !isNil(commonTreeOption.getChild(this.basedNode));
        },
        childrenNodes: function childrenNodes() {
          if (!this.isBranchNode) {
            return [];
          }
          return transformer(commonTreeOption.getChild(this.basedNode));
        },
        displayChildNodes: function displayChildNodes() {
          return this.isBranchNode ? filter('isDisplayNode', this.childrenNodes) : [];
        },
        disabledCheckBox: function disabledCheckBox() {
          return commonTreeOption.readOnly || commonTreeOption.disabledBranchNodeWithNoDisplayChild && commonTreeOption.disabledBranchNodeWithNoDisplayChild(this.basedNode) && this.isBranchNode && every('disabledCheckBox', this.displayChildNodes);
        },
        nodeText: function nodeText() {
          return commonTreeOption.getText(this.basedNode);
        },
        hightLightText: function hightLightText() {
          return commonTreeOption.filter.text;
        },
        key: function key() {
          return commonTreeOption.getKey(this.basedNode);
        },
        isDisplayNode: function isDisplayNode() {
          var filterRegex = new RegExp(escapeRegExp(commonTreeOption.filter.text), 'i');

          var alwaysDisplay = invokeArgs('checkAlwaysDisplay', [this.basedNode], commonTreeOption);

          return alwaysDisplay || commonTreeOption.checkDisplayNode(this.basedNode) && (filterRegex.test(this.nodeText) || this.isBranchNode && !isEmpty(this.displayChildNodes));
        },
        showNumChildren: function showNumChildren() {
          return commonTreeOption.showNumChildren ? commonTreeOption.showNumChildren(this.basedNode) : !isEmpty(this.displayChildNodes);
        },
        numberOfChildren: function numberOfChildren() {
          return this.displayChildNodes.length;
        },
        checkboxStatus: false,
        displayCheckedStatus: function displayCheckedStatus() {
          var availableCheckBox = reject('disabledCheckBox', this.displayChildNodes);

          if (isEmpty(availableCheckBox)) {
            return this.checkboxStatus && !this.disabledCheckBox ? 1 : -1;
          }
          if (every({ displayCheckedStatus: 1 }, availableCheckBox)) {
            return 1;
          }
          if (every({ displayCheckedStatus: -1 }, availableCheckBox)) {
            return -1;
          }
          return 0;
        }
      };

      m.extendObservable(this, props);

      this.dispose = m.autorun(function () {
        (!this.isDisplayNode || !this.disabledCheckBox) && m.untracked(function () {
          this.checkboxStatus && (this.checkboxStatus = false);
        }.bind(this));
      }.bind(this));
    };

    NodeModel.prototype.check = m.action(function (check) {
      if (commonTreeOption.readOnly) {
        return;
      }
      var newCheckStatus = isBoolean(check) ? check : this.displayCheckedStatus !== 1;

      this.checkboxStatus = newCheckStatus;
      forEach(invokeArgs('check', [newCheckStatus]), reject('disabledCheckBox', this.displayChildNodes));
    });

    return transformer;
  };

  module.exports = createTransformer;
}();

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2250);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(45);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReportFooter.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var PermissionReportFooter = function PermissionReportFooter(props) {
  var permission = props.permission,
      permissionStore = props.permissionStore,
      localization = props.localization,
      authorization = props.authorization,
      readOnly = props.readOnly;

  var reports = permission.reports;
  var tenantDetail = permissionStore.tenantDetail;
  var hasReportDesignerLicense = authorization.checkLicense(_Izenda10.default.LICENSE_KEY.ReportDesigner);
  var hasScheduleLicense = authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Scheduling);
  var hasAlertingLicense = authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Alerting);
  var hasExportLicense = authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Exporting);

  var renderActionsContent = function renderActionsContent() {
    var actionsContent = [];

    // row 1 includes label action, schedule, subscribe, configure access rights
    actionsContent.push(_react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_paddingTop u_paddingBottom', key: 'actionsContent_0' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
        localization.getText('COMMON_LABEL_ACTIONS')
      ),
      hasScheduleLicense && hasReportDesignerLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.schedule) && _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 2 },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda8.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(reports.actions.schedule),
              onChange: props.permissionUpdateData(reports.actions, 'schedule')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_SCHEDULE')
            )
          )
        )
      ),
      hasAlertingLicense && hasScheduleLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.registerForAlerts) && _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 2 },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda8.default, {
              type: 'checkbox',
              readOnly: readOnly,
              disabled: !props.getCheckedCommon(reports.actions.schedule),
              checked: props.getCheckedCommon(reports.actions.registerForAlerts),
              onChange: props.permissionUpdateData(reports.actions, 'registerForAlerts')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_REGISTER_TO_ALERTS')
            )
          )
        )
      ),
      hasScheduleLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.subscribe) && _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 2 },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda8.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(reports.actions.subscribe),
              onChange: props.permissionUpdateData(reports.actions, 'subscribe')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_SUBSCRIBE')
            )
          )
        )
      ),
      hasReportDesignerLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.configureAccessRights) && _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 3 },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda8.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(reports.actions.configureAccessRights),
              onChange: props.permissionUpdateData(reports.actions, 'configureAccessRights')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_CONFIGURE_ACCESS_RIGHT')
            )
          )
        )
      ),
      permission.isTenantSetup && _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 1, className: 'u_textCenter u_floatRight' },
        _react2.default.createElement(_Izenda8.default, {
          type: 'checkbox',
          readOnly: readOnly,
          checked: props.getCheckedCommon(reports.actions.tenantAccess),
          onChange: props.permissionUpdateTenantAccess(reports, reports.actions)
        })
      )
    ));

    // row 2 includes email, print, exporting
    if ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.email || tenantDetail.reports.actions.print || tenantDetail.reports.actions.exporting) {
      actionsContent.push(_react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_paddingTop u_paddingBottom', key: 'actionsContent_1' },
        _react2.default.createElement(_Izenda6.default.Col, { cols: 2, className: 'izenda-PermissionCategory-SubCategory' }),
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.email) && _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 2 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda8.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(reports.actions.email),
                onChange: props.permissionUpdateData(reports.actions, 'email')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('COMMON_LABEL_EMAIL')
              )
            )
          )
        ),
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.print) && _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 2 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda8.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(reports.actions.print),
                onChange: props.permissionUpdateData(reports.actions, 'print')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('COMMON_LABEL_PRINT')
              )
            )
          )
        ),
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.exporting) && _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 5 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda8.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(reports.actions.exporting),
                onChange: props.permissionUpdateData(reports.actions, 'exporting')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('COMMON_LABEL_EXPORT')
              )
            )
          )
        ),
        _react2.default.createElement(_Izenda6.default.Col, { cols: 1 })
      ));
    }

    // row 3 includes View Report History, Unarchive Report Versions
    if ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.viewReportHistory || tenantDetail.reports.actions.unarchiveReportVersions) {
      actionsContent.push(_react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_paddingTop u_paddingBottom', key: 'actionsContent_2' },
        _react2.default.createElement(_Izenda6.default.Col, { cols: 2, className: 'izenda-PermissionCategory-SubCategory' }),
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.viewReportHistory) && _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 2 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda8.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(reports.actions.viewReportHistory),
                onChange: props.permissionUpdateData(reports.actions, 'viewReportHistory')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('PERMISSION_LABEL_VIEW_REPORT_HISTORY')
              )
            )
          )
        ),
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.unarchiveReportVersions) && _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 7 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda8.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(reports.actions.unarchiveReportVersions),
                onChange: props.permissionUpdateData(reports.actions, 'unarchiveReportVersions')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('PERMISSION_LABEL_UNARCHIVE_REPORT_VERSIONS')
              )
            )
          )
        ),
        _react2.default.createElement(_Izenda6.default.Col, { cols: 1 })
      ));
    }

    // row 4 includes del, overwrite existing report
    if ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.del || tenantDetail.reports.actions.overwriteExistingReport) {
      actionsContent.push(_react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_paddingTop u_paddingBottom', key: 'actionsContent_3' },
        _react2.default.createElement(_Izenda6.default.Col, { cols: 2, className: 'izenda-PermissionCategory-SubCategory' }),
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.del) && _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 2 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda8.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(reports.actions.del),
                onChange: props.permissionUpdateData(reports.actions, 'del')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('COMMON_LABEL_DELETE')
              )
            )
          )
        ),
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.actions.overwriteExistingReport) && _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 7 },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock izenda-PermissionCategory-group' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda8.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: props.getCheckedCommon(reports.actions.overwriteExistingReport),
                onChange: props.permissionUpdateData(reports.actions, 'overwriteExistingReport')
              }),
              _react2.default.createElement(
                'span',
                null,
                localization.getText('PERMISSION_LABEL_OVERWRITE_EXISTING_REPORT')
              )
            )
          )
        ),
        _react2.default.createElement(_Izenda6.default.Col, { cols: 1 })
      ));
    }
    return actionsContent;
  };

  return _react2.default.createElement(
    _Izenda6.default,
    { className: 'izenda-GridLayout-Custom' },
    ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.filterProperties)) && _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_paddingTop u_paddingBottom' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
        localization.getText('COMMON_LABEL_FILTER_PROPERTIES')
      ),
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 9 },
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.filterProperties.filterLogic) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda8.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(reports.filterProperties.filterLogic),
              onChange: props.permissionUpdateData(reports.filterProperties, 'filterLogic')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_FILTER_LOGIC')
            )
          )
        ),
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.filterProperties.crossFiltering) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda8.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(reports.filterProperties.crossFiltering),
              onChange: props.permissionUpdateData(reports.filterProperties, 'crossFiltering')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_CROSS_FILTERING')
            )
          )
        )
      ),
      permission.isTenantSetup && _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 1, className: 'u_textCenter' },
        _react2.default.createElement(_Izenda8.default, {
          type: 'checkbox',
          readOnly: readOnly,
          checked: props.getCheckedCommon(reports.filterProperties.tenantAccess),
          onChange: props.permissionUpdateTenantAccess(reports, reports.filterProperties)
        })
      )
    ),
    ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.fieldProperties)) && _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_paddingTop u_paddingBottom' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
        localization.getText('COMMON_LABEL_FIELD_PROPERTIES')
      ),
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 9 },
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.fieldProperties.customURL) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda8.default, {
              type: 'checkbox',
              readOnly: readOnly,
              name: 'fieldProperties',
              checked: props.getCheckedCommon(reports.fieldProperties.customURL),
              onChange: props.permissionUpdateData(reports.fieldProperties, 'customURL')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_CUSTOM_URL')
            )
          )
        ),
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.fieldProperties.embeddedJavaScript) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda8.default, {
              type: 'checkbox',
              readOnly: readOnly,
              name: 'fieldProperties',
              checked: props.getCheckedCommon(reports.fieldProperties.embeddedJavaScript),
              onChange: props.permissionUpdateData(reports.fieldProperties, 'embeddedJavaScript')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_EMBEDDED_JAVASCRIPT')
            )
          )
        ),
        ((0, _fp.isNil)(tenantDetail) || tenantDetail.reports.fieldProperties.subreport) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda8.default, {
              type: 'checkbox',
              readOnly: readOnly,
              name: 'fieldProperties',
              checked: props.getCheckedCommon(reports.fieldProperties.subreport),
              onChange: props.permissionUpdateData(reports.fieldProperties, 'subreport')
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_SUBREPORT')
            )
          )
        )
      ),
      permission.isTenantSetup && _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: 1, className: 'u_textCenter' },
        _react2.default.createElement(_Izenda8.default, {
          type: 'checkbox',
          readOnly: readOnly,
          checked: props.getCheckedCommon(reports.fieldProperties.tenantAccess),
          onChange: props.permissionUpdateTenantAccess(reports, reports.fieldProperties)
        })
      )
    ),
    ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.actions)) && renderActionsContent()
  );
};

PermissionReportFooter.propTypes = {
  readOnly: _propTypes2.default.bool,
  authorization: _propTypes2.default.object,
  localization: _propTypes2.default.object,
  tenantDetail: _propTypes2.default.object,
  permissionStore: _propTypes2.default.object,
  permission: _propTypes2.default.object.isRequired,
  checkShowGroupCommon: _propTypes2.default.func,
  getCheckedCommon: _propTypes2.default.func
};

exports.default = (0, _Izenda2.default)(_Izenda4.default)(PermissionReportFooter);
module.exports = exports['default'];

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

/**
 * Permission Update Data
 * @param {Object} props
 * @param {Object} data
 * @param {String} value
 * @param {Object} event
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReportFooterAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var permissionUpdateData = function permissionUpdateData(props, data, value, event) {
  props.permission.updateData(data, value, event.target.checked);
};

/**
 * Permission Update Tenant Access
 * @param {Object} props
 * @param {Object} data
 * @param {Object} value
 * @param {Object} event
 */
var permissionUpdateTenantAccess = function permissionUpdateTenantAccess(props, data, value, event) {
  props.permission.updateTenantAccess(data, value, event.target.checked);
};

exports.default = (0, _recompose.withHandlers)({
  permissionUpdateData: (0, _fp.curry)(permissionUpdateData),
  permissionUpdateTenantAccess: (0, _fp.curry)(permissionUpdateTenantAccess)
});
module.exports = exports['default'];

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionDashboards.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);

  var PermissionDashboardHeader = __webpack_require__(2252);
  var PermissionDashboardBody = __webpack_require__(2253);
  var PermissionDashboardFooter = __webpack_require__(2254);
  var actions = __webpack_require__(113);
  var SECTION = __webpack_require__(72).SECTION;
  var EventsUtils = __webpack_require__(24);
  var UNCHECK_VALUE = 0;
  var LicenseCheckerConstants = __webpack_require__(45);
  var CheckboxAllPermission = __webpack_require__(134);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      get = _require.get;

  var PermissionDashboards = React.createClass({
    displayName: 'PermissionDashboards',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.dashboards = this.props.permission.dashboards;
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;
      var authorization = this.props.authorization;
      var hasDashboardLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Dashboard);
      var dashboards = get('dashboards', tenantDetail);

      return hasDashboardLicense && !permission.fullReportAndDashboardAccess && (isNil(tenantDetail) || tenantDetail.dashboards.tenantAccess !== UNCHECK_VALUE) && React.createElement(
        'div',
        { className: SECTION.Dashboards },
        React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
            React.createElement(
              GridLayout.Col,
              { cols: 2 },
              React.createElement(
                'div',
                { id: 'hash', className: 'u_inlineBlock ' },
                React.createElement('a', {
                  className: this.props.getIconClass('isShowDashboards'),
                  onClick: this.props.toggle.bind(this, 'isShowDashboards')
                }),
                React.createElement(
                  'span',
                  null,
                  localization.getText('PERMISSION_LABEL_DASHBOARDS')
                )
              )
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(CheckboxAllPermission, {
                permission: permission,
                readOnly: this.props.readOnly,
                section: this.dashboards,
                tenantPermission: dashboards,
                tenantDetail: tenantDetail
              })
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                indeterminate: this.props.getIndeterminateCommon(this.dashboards),
                checked: this.props.getCheckedCommon(this.dashboards.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccessParent.bind(permission, this.dashboards), EventsUtils.CHECKBOX)
              })
            )
          )
        ),
        permissionStore.isShowDashboards && React.createElement(
          'div',
          null,
          React.createElement(PermissionDashboardHeader, this.props),
          React.createElement(PermissionDashboardBody, this.props),
          React.createElement(PermissionDashboardFooter, this.props)
        )
      );
    }
  });

  module.exports = connect(actions)(PermissionDashboards);
}();

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionDashboardHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var EventsUtils = __webpack_require__(24);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var PermissionDashboardHeader = React.createClass({
    displayName: 'PermissionDashboardHeader',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.dashboards = this.props.permission.dashboards;
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permission = this.props.permission;
      var tenantDetail = this.props.permissionStore.tenantDetail;
      var localization = this.props.localization;
      return React.createElement(
        GridLayout,
        { className: 'izenda-GridLayout-Custom' },
        (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dashboards.canCreateNewDashboard)) && React.createElement(
          GridLayout.Row,
          { className: 'u_paddingTop u_paddingBottom' },
          React.createElement(
            GridLayout.Col,
            { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
            localization.getText('PERMISSION_LABEL_CAN_CREATE_DASHBOARD')
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 9 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.dashboards.canCreateNewDashboard.value),
                onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.canCreateNewDashboard, 'value'), EventsUtils.CHECKBOX)
              })
            )
          ),
          permission.isTenantSetup && React.createElement(
            GridLayout.Col,
            { cols: 1, className: 'u_textCenter' },
            React.createElement(Input, {
              type: 'checkbox',
              readOnly: this.props.readOnly,
              checked: this.props.getCheckedCommon(this.dashboards.canCreateNewDashboard.tenantAccess),
              onChange: notifyChange(permission.updateTenantAccess.bind(permission, this.dashboards, this.dashboards.canCreateNewDashboard), EventsUtils.CHECKBOX)
            })
          )
        ),
        (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dashboards.dashboardCategoriesSubcategories)) && React.createElement(
          GridLayout.Row,
          { className: 'u_paddingTop u_paddingBottom' },
          React.createElement(
            GridLayout.Col,
            { className: 'izenda-PermissionCategory-SubCategory' },
            localization.getText('PERMISSION_LABEL_DASHBOARD_CATEGORIES_SUBCATEGORIES')
          )
        ),
        (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory)) && React.createElement(
          GridLayout.Row,
          { className: 'u_paddingTop u_paddingBottom' },
          React.createElement(
            GridLayout.Col,
            { cols: 2, className: 'izenda-PermissionCategory-SubSubCategory' },
            localization.getText('PERMISSION_LABEL_CAN_CREATE_CATEGORY')
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 9 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory.value),
                onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory, 'value'), EventsUtils.CHECKBOX)
              })
            )
          ),
          permission.isTenantSetup && React.createElement(
            GridLayout.Col,
            { cols: 1, className: 'u_textCenter' },
            React.createElement(Input, {
              type: 'checkbox',
              readOnly: this.props.readOnly,
              checked: this.props.getCheckedCommon(this.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory.tenantAccess),
              onChange: notifyChange(permission.updateTenantAccess.bind(permission, this.dashboards, this.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory), EventsUtils.CHECKBOX)
            })
          )
        )
      );
    }
  });

  module.exports = connect()(PermissionDashboardHeader);
}();

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionDashboardBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var EventsUtils = __webpack_require__(24);
  var CategoryPermission = __webpack_require__(1146);
  var constants = __webpack_require__(279).TENANT_PERMISSIONS.DASHBOARD.CATEGORY_ACCESSIBILITY;
  var PermissionConstants = __webpack_require__(72);
  var UNCHECK_VALUE = 0;

  var PermissionDashboardBody = React.createClass({
    displayName: 'PermissionDashboardBody',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      var permissionStore = this.props.permissionStore;
      this.dashboards = this.props.permission.dashboards;
      this.afterSwitchTree = permissionStore.updateDashboardAccessibilityCategory.bind(permissionStore);
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;

      return !permissionStore.isTenantSetup && React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          { className: 'u_paddingTop u_paddingBottom u_borderBottom u_noMarginAll' },
          React.createElement(
            GridLayout.Col,
            { cols: 2, className: 'izenda-PermissionCategory-SubSubCategory' },
            localization.getText("PERMISSION_LABEL_CATEGORY_ACCESSIBILITY")
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 9 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock u_fullWidth' },
              React.createElement(CategoryPermission, (0, _extends3.default)({}, this.props, {
                typeName: PermissionConstants.SECTION.Dashboards,
                leftHeader: constants.AVAILABLE_TREE_HEADER,
                rightHeader: constants.SAVABLE_TREE_HEADER,
                middleHeader: constants.VISIBLE_TREE_HEADER,
                categoryPermission: this.props.permissionStore.dashboardCategoryAccessibility,
                afterSwitchTree: this.afterSwitchTree
              }))
            )
          ),
          permissionStore.isTenantSetup && React.createElement(
            GridLayout.Col,
            { cols: 1, className: 'u_textCenter' },
            React.createElement(Input, { type: 'checkbox',
              readOnly: this.props.readOnly,
              checked: this.props.getCheckedCommon(this.dashboards.dashboardCategoriesSubcategories.categoryAccessibility.tenantAccess),
              onChange: notifyChange(permission.updateTenantAccess.bind(permission, this.dashboards, this.dashboards.dashboardCategoriesSubcategories.categoryAccessibility), EventsUtils.CHECKBOX) })
          )
        )
      );
    }
  });

  module.exports = connect()(PermissionDashboardBody);
}();

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionDashboardFooter.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var EventsUtils = __webpack_require__(24);
  var LicenseCheckerConstants = __webpack_require__(45);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var PermissionDashboardFooter = React.createClass({
    displayName: 'PermissionDashboardFooter',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.dashboards = this.props.permission.dashboards;
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permission = this.props.permission;
      var tenantDetail = this.props.permissionStore.tenantDetail;
      var localization = this.props.localization;
      var authorization = this.props.authorization;
      var hasScheduleLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Scheduling);
      var hasExportLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Exporting);

      return (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dashboards.actions)) && React.createElement(
        GridLayout,
        { className: 'izenda-GridLayout-Custom' },
        React.createElement(
          GridLayout.Row,
          { className: 'u_paddingTop u_paddingBottom' },
          React.createElement(
            GridLayout.Col,
            { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
            localization.getText('COMMON_LABEL_ACTIONS')
          ),
          hasScheduleLicense && (isNil(tenantDetail) || tenantDetail.dashboards.actions.schedule) && React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'checkbox',
                  readOnly: this.props.readOnly,
                  checked: this.props.getCheckedCommon(this.dashboards.actions.schedule),
                  onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.actions, 'schedule'), EventsUtils.CHECKBOX)
                }),
                React.createElement(
                  'span',
                  null,
                  localization.getText('COMMON_LABEL_SCHEDULE')
                )
              )
            )
          ),
          hasScheduleLicense && (isNil(tenantDetail) || tenantDetail.dashboards.actions.subscribe) && React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'checkbox',
                  readOnly: this.props.readOnly,
                  checked: this.props.getCheckedCommon(this.dashboards.actions.subscribe),
                  onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.actions, 'subscribe'), EventsUtils.CHECKBOX)
                }),
                React.createElement(
                  'span',
                  null,
                  localization.getText('COMMON_LABEL_SUBSCRIBE')
                )
              )
            )
          ),
          (isNil(tenantDetail) || tenantDetail.dashboards.actions.configureAccessRights) && React.createElement(
            GridLayout.Col,
            { cols: 5 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'checkbox',
                  readOnly: this.props.readOnly,
                  checked: this.props.getCheckedCommon(this.dashboards.actions.configureAccessRights),
                  onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.actions, 'configureAccessRights'), EventsUtils.CHECKBOX)
                }),
                React.createElement(
                  'span',
                  null,
                  localization.getText('PERMISSION_LABEL_CONFIGURE_ACCESS_RIGHT')
                )
              )
            )
          ),
          permission.isTenantSetup && React.createElement(
            GridLayout.Col,
            { cols: 1, className: 'u_textCenter pull-right' },
            React.createElement(Input, {
              type: 'checkbox',
              readOnly: this.props.readOnly,
              checked: this.props.getCheckedCommon(this.dashboards.actions.tenantAccess),
              onChange: notifyChange(permission.updateTenantAccess.bind(permission, this.dashboards, this.dashboards.actions), EventsUtils.CHECKBOX)
            })
          )
        ),
        (isNil(tenantDetail) || tenantDetail.dashboards.actions.email || tenantDetail.dashboards.actions.print) && React.createElement(
          GridLayout.Row,
          { className: 'u_paddingTop u_paddingBottom' },
          React.createElement(GridLayout.Col, { cols: 2, className: 'izenda-PermissionCategory-SubCategory' }),
          (isNil(tenantDetail) || tenantDetail.dashboards.actions.email) && React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'checkbox',
                  readOnly: this.props.readOnly,
                  checked: this.props.getCheckedCommon(this.dashboards.actions.email),
                  onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.actions, 'email'), EventsUtils.CHECKBOX)
                }),
                React.createElement(
                  'span',
                  null,
                  localization.getText('COMMON_LABEL_EMAIL')
                )
              )
            )
          ),
          hasExportLicense && (isNil(tenantDetail) || tenantDetail.dashboards.actions.print) && React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'checkbox',
                  readOnly: this.props.readOnly,
                  checked: this.props.getCheckedCommon(this.dashboards.actions.print),
                  onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.actions, 'print'), EventsUtils.CHECKBOX)
                }),
                React.createElement(
                  'span',
                  null,
                  localization.getText('COMMON_LABEL_PRINT')
                )
              )
            )
          ),
          hasExportLicense && (isNil(tenantDetail) || tenantDetail.dashboards.actions.exporting) && React.createElement(
            GridLayout.Col,
            { cols: 5 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'checkbox',
                  readOnly: this.props.readOnly,
                  checked: this.props.getCheckedCommon(this.dashboards.actions.exporting),
                  onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.actions, 'exporting'), EventsUtils.CHECKBOX)
                }),
                React.createElement(
                  'span',
                  null,
                  localization.getText('COMMON_LABEL_EXPORT')
                )
              )
            )
          ),
          React.createElement(GridLayout.Col, { cols: 1 })
        ),
        (isNil(tenantDetail) || tenantDetail.dashboards.actions.del || tenantDetail.dashboards.actions.overwriteExistingDashboard) && React.createElement(
          GridLayout.Row,
          { className: 'u_paddingTop u_paddingBottom' },
          React.createElement(GridLayout.Col, { cols: 2, className: 'izenda-PermissionCategory-SubCategory' }),
          (isNil(tenantDetail) || tenantDetail.dashboards.actions.del) && React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'checkbox',
                  readOnly: this.props.readOnly,
                  checked: this.props.getCheckedCommon(this.dashboards.actions.del),
                  onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.actions, 'del'), EventsUtils.CHECKBOX)
                }),
                React.createElement(
                  'span',
                  null,
                  localization.getText('COMMON_LABEL_DELETE')
                )
              )
            )
          ),
          (isNil(tenantDetail) || tenantDetail.dashboards.actions.overwriteExistingDashboard) && React.createElement(
            GridLayout.Col,
            { cols: 7 },
            React.createElement(
              'div',
              { className: 'u_inlineBlock izenda-PermissionCategory-group' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'checkbox',
                  readOnly: this.props.readOnly,
                  checked: this.props.getCheckedCommon(this.dashboards.actions.overwriteExistingDashboard),
                  onChange: notifyChange(permission.updateData.bind(permission, this.dashboards.actions, 'overwriteExistingDashboard'), EventsUtils.CHECKBOX)
                }),
                React.createElement(
                  'span',
                  null,
                  localization.getText('PERMISSION_LABEL_OVERWRITE_EXISTING_DASHBOARD')
                )
              )
            )
          ),
          React.createElement(GridLayout.Col, { cols: 1 })
        )
      );
    }
  });

  module.exports = connect()(PermissionDashboardFooter);
}();

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionAccess.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(113);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda5 = __webpack_require__(1147);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(13);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(17);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(615);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(72);

var _Izenda14 = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNCHECK_VALUE = 0;

var PermissionAccess = (_dec = (0, _Izenda2.default)({ toClass: true }, _Izenda4.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(PermissionAccess, _Component);

  function PermissionAccess() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PermissionAccess);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PermissionAccess.__proto__ || (0, _getPrototypeOf2.default)(PermissionAccess)).call.apply(_ref, [this].concat(args))), _this), _this.loadUsers = function (pageInfo) {
      var permissionStore = _this.props.permissionStore;

      return permissionStore.loadAvailableUsers(pageInfo);
    }, _this.loadRoles = function (pageInfo) {
      var permissionStore = _this.props.permissionStore;

      return permissionStore.loadAvailableRoles(pageInfo);
    }, _this.onSearchAccess = function (searchKey) {
      var permissionStore = _this.props.permissionStore;

      permissionStore.loadPartialPermissionAccess(null, true, searchKey);
    }, _this.loadAccessLimits = function (pageInfo) {
      var permissionStore = _this.props.permissionStore;

      permissionStore.loadPartialPermissionAccess(pageInfo);
    }, _this.updateSelectedNode = function (node, parent, accessModel) {
      var permissionStore = _this.props.permissionStore;

      permissionStore.updateAccessLimitData(node, parent, accessModel);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PermissionAccess, [{
    key: 'render',
    value: function render() {
      var notifyChange = _EventUtils2.default.notifyChange;
      var _props = this.props,
          permissionStore = _props.permissionStore,
          accessStore = _props.accessStore,
          permission = _props.permission,
          readOnly = _props.readOnly,
          localization = _props.localization;
      var tenantDetail = permissionStore.tenantDetail;
      var access = permission.access;


      return !permission.fullReportAndDashboardAccess && ((0, _fp.isNil)(tenantDetail) || tenantDetail.access.tenantAccess !== UNCHECK_VALUE) && _react2.default.createElement(
        'div',
        { className: _Izenda13.SECTION.Access },
        _react2.default.createElement(
          _Izenda8.default,
          { className: 'izenda-GridLayout-Custom' },
          _react2.default.createElement(
            _Izenda8.default.Row,
            { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 11 },
              _react2.default.createElement('a', {
                className: this.props.getIconClass('isShowAccess'),
                onClick: this.props.toggle.bind(this, 'isShowAccess')
              }),
              localization.getText('COMMON_LABEL_ACCESS')
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda10.default, {
                type: 'checkbox',
                readOnly: readOnly,
                indeterminate: this.props.getIndeterminateCommon(access),
                checked: this.props.getCheckedCommon(access.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccessParent.bind(permission, access), _EventUtils2.default.CHECKBOX)
              })
            )
          )
        ),
        permissionStore.isShowAccess && _react2.default.createElement(
          _Izenda8.default,
          null,
          ((0, _fp.isNil)(tenantDetail) || tenantDetail.access.accessLimits.tenantAccess !== UNCHECK_VALUE) && _react2.default.createElement(
            _Izenda8.default.Row,
            { className: 'u_paddingTop u_paddingBottom u_borderBottom u_noMarginAll' },
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_ACCESS_LIMITS')
            ),
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 9 },
              _react2.default.createElement(
                'div',
                { className: 'u_inlineBlock u_fullWidth' },
                _react2.default.createElement(_Izenda6.default, (0, _extends3.default)({}, this.props, {
                  getData: this.loadAccessLimits,
                  searchRoles: this.onSearchAccess,
                  rolePermission: permissionStore.roleAccessLimits,
                  accessModel: accessStore.model,
                  updateSelectedNode: this.updateSelectedNode
                }))
              )
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda10.default, {
                type: 'checkbox',
                readOnly: readOnly,
                checked: this.props.getCheckedCommon(access.accessLimits.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccess.bind(permission, access, access.accessLimits), _EventUtils2.default.CHECKBOX)
              })
            )
          ),
          ((0, _fp.isNil)(tenantDetail) || tenantDetail.access.accessDefaults.tenantAccess !== UNCHECK_VALUE) && _react2.default.createElement(
            _Izenda8.default.Row,
            { className: 'u_paddingTop u_paddingBottom u_noMarginAll' },
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_ACCESS_DEFAULT')
            ),
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 9 },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_Izenda12.default, {
                  store: this.props.accessStore,
                  tableDef: _Izenda14.PERMISSION_ACCESS_TABLE_DEF,
                  searchOptions: _Izenda14.PERMISSION_SEARCH_OPTIONS,
                  accessMode: _Izenda14.ACCESS_MODE.TENANT,
                  loadUsers: this.loadUsers,
                  loadRoles: this.loadRoles,
                  readOnly: readOnly
                })
              )
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda10.default, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(access.accessDefaults.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccess.bind(permission, access, access.accessDefaults), _EventUtils2.default.CHECKBOX)
              })
            )
          )
        )
      );
    }
  }]);
  return PermissionAccess;
}(_react.Component), _class2.propTypes = {
  permissionStore: _propTypes2.default.object.isRequired,
  permission: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = PermissionAccess;
module.exports = exports['default'];

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor; // ----------------------------------------------------------------------
// <copyright file="Izenda.FlattenTreeUIStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var FlattenTreeUIStore = (_class = function () {
  function FlattenTreeUIStore() {
    (0, _classCallCheck3.default)(this, FlattenTreeUIStore);

    _initDefineProp(this, "nodeList", _descriptor, this);
  }

  (0, _createClass3.default)(FlattenTreeUIStore, [{
    key: "setNodes",
    value: function setNodes(nodes) {
      this.nodeList = nodes;
    }
  }, {
    key: "toggleCollapsibleOfNode",
    value: function toggleCollapsibleOfNode(node) {
      var isExpanded = this.isExpanded(node);
      node.data.expand = !isExpanded;
      node.data.source.expand = !isExpanded;
    }
  }, {
    key: "isVisible",
    value: function isVisible(node) {
      var parent = node.parent;
      if (!parent) return true;

      var parentExpanded = this.isExpanded(parent);
      if (!parentExpanded) return false;

      return this.isVisible(parent);
    }

    /**
     * Check whether a node is expanded by user action
     * @param  {String}  key Node key
     * @return {Boolean}     True/False/Undefined
     */

  }, {
    key: "isExpanded",
    value: function isExpanded(node) {
      return node.data.expand;
    }
  }, {
    key: "visibleNodeList",
    get: function get() {
      var isVisible = this.isVisible.bind(this);
      var result = (0, _fp.filter)(isVisible, this.nodeList);
      return result;
    }
  }]);
  return FlattenTreeUIStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "nodeList", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "visibleNodeList", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "visibleNodeList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNodes", [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "setNodes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCollapsibleOfNode", [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "toggleCollapsibleOfNode"), _class.prototype)), _class);
exports.default = FlattenTreeUIStore;
module.exports = exports["default"];

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoadingTreeViewItemList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var observer = __webpack_require__(10).observer;
  var LazyLoading = __webpack_require__(219);
  var LazyLoadingTreeViewItem = __webpack_require__(2258);
  var classnames = __webpack_require__(11);

  var LazyLoadingTreeViewItemList = React.createClass({
    displayName: 'LazyLoadingTreeViewItemList',

    propTypes: {
      treeStore: ObservablePropTypes.observableObject,
      isLastPage: React.PropTypes.bool.isRequired,
      registerLazyLoadingStore: React.PropTypes.func
    },
    componentWillMount: function componentWillMount() {
      var props = this.props;
      var treeStore = props.treeStore;
      treeStore.setNodes(props.flattenNodes);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var treeStore = nextProps.treeStore;
      treeStore.setNodes(nextProps.flattenNodes);
    },

    render: function render() {
      var props = this.props;
      var treeStore = props.treeStore;
      var visibleNodes = treeStore.visibleNodeList;
      var hasItems = visibleNodes.length;
      var className = classnames('izenda-TreeViewItemList', props.className);

      return React.createElement(LazyLoading, {
        className: className,
        data: visibleNodes,
        isLastPage: props.isLastPage,
        getData: props.getData,
        renderItem: this.renderItem,
        viewHeight: props.viewHeight,
        itemHeight: props.itemHeight,
        defaultItemsNumber: props.defaultItemsNumber,
        registerLazyLoadingStore: props.registerLazyLoadingStore });
    },

    renderItem: function renderItem(node, pageSize, loadVirtualNode) {
      var props = this.props;
      var renderNode = props.renderNode;
      var treeStore = props.treeStore;
      var expanded = treeStore.isExpanded(node);

      return React.createElement(LazyLoadingTreeViewItem, {
        node: node,
        treeViewItemClassName: props.treeViewItemClassName,
        renderNode: renderNode,
        expanded: expanded,
        toggleCollapsible: treeStore.toggleCollapsibleOfNode.bind(treeStore),
        getData: props.getData,
        pageSize: pageSize,
        loadVirtualNode: loadVirtualNode });
    },
    getKey: function getKey(node) {
      return node.key;
    }
  });

  module.exports = observer(LazyLoadingTreeViewItemList);
}();

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeViewItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;

  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);

  var LazyLoadingTreeViewItem = React.createClass({
    displayName: 'LazyLoadingTreeViewItem',

    propTypes: {
      node: ObservablePropTypes.objectOrObservableObject,
      renderNode: PropTypes.func.isRequired,
      toggleCollapsible: PropTypes.func.isRequired,
      expanded: PropTypes.bool
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return nextProps.expanded !== this.props.expanded || nextProps.node !== this.props.node;
    },

    render: function render() {
      var props = this.props;
      var node = props.node;
      var renderNode = props.renderNode;
      var hasChild = node.childCount;
      var expanded = node.data.expand;
      var toggleIcon = hasChild ? this.renderToggleIcon(expanded) : null;
      var isCollapsed = !expanded;
      var level = node.level;
      var className = classnames('izenda-TreeViewItem', props.treeViewItemClassName);

      return React.createElement(
        'div',
        { className: className, style: { paddingLeft: 20 * level } },
        renderNode(node.data, toggleIcon, this.toggle, isCollapsed, node.parent)
      );
    },

    renderToggleIcon: function renderToggleIcon(expanded) {
      var className = classnames('u_curPointer icon-arrow', {
        'expanded': expanded
      });
      return React.createElement('i', {
        className: className,
        onClick: this.toggle });
    },

    toggle: function toggle() {
      var props = this.props;
      var node = props.node;
      var toggleCollapsible = props.toggleCollapsible;
      toggleCollapsible(node);
      props.loadVirtualNode();
      // node.expanded && this.getData();
      // node.expanded && props.loadVirtualNode();
    },

    getData: function getData() {
      var props = this.props,
          node = props.node,
          parentIds = [];

      getParentIds(node, parentIds);

      node.data.source.numOfChilds !== node.childCount && props.getData({
        fromIndex: node.childCount,
        pageSize: props.pageSize,
        parentIds: parentIds
      });

      function getParentIds(node, parentIds) {
        parentIds.push(node.data.source.id);
        node.parent && getParentIds(node.parent, parentIds);
      }
    }

  });

  module.exports = observer(LazyLoadingTreeViewItem);
}();

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SharePermissionComponent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Share Permission Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda = __webpack_require__(23);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(92);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2260);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(13);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(29);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorDropDown = (0, _Izenda2.default)()(_Izenda12.default);
var notifyChange = _EventUtils2.default.notifyChange;

var SharePermissionComponent = (_dec = (0, _Izenda4.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SharePermissionComponent, _Component);

  function SharePermissionComponent() {
    (0, _classCallCheck3.default)(this, SharePermissionComponent);
    return (0, _possibleConstructorReturn3.default)(this, (SharePermissionComponent.__proto__ || (0, _getPrototypeOf2.default)(SharePermissionComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SharePermissionComponent, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var _props$data = props.data,
          data = _props$data === undefined ? {} : _props$data,
          isGlobal = props.isGlobal;

      var assignType = isGlobal ? (0, _fp.initial)(_Izenda6.default.ASSIGNED_TYPE) : _Izenda6.default.ASSIGNED_TYPE;
      var onChange = notifyChange(props.change, _EventUtils2.default.DROPDOWN);

      return _react2.default.createElement(
        _Izenda10.default.Row,
        { className: 'u_noBorder' },
        _react2.default.createElement(
          _Izenda10.default.Col,
          { cols: '3', className: 'u_noBorder' },
          _react2.default.createElement(ValidatorDropDown, {
            field: 'assignType',
            group: data.tempId,
            validations: _Izenda6.default.CONSTRAINTS.SHARE_WITH,
            blankOption: true,
            options: assignType,
            value: data.assignedType,
            valueField: 'value',
            labelField: 'label',
            onChange: onChange,
            disabled: props.readOnly
          })
        ),
        _react2.default.createElement(
          _Izenda10.default.Col,
          { cols: '9', className: 'u_noBorder' },
          _react2.default.createElement(_Izenda8.default, {
            data: props.data,
            selectedValue: data.assignedType,
            store: props.store,
            users: props.users,
            roles: props.roles,
            loadUsers: props.loadUsers,
            loadRoles: props.loadRoles,
            readOnly: props.readOnly
          })
        )
      );
    }
  }]);
  return SharePermissionComponent;
}(_react.Component), _class2.propTypes = {
  data: _react2.default.PropTypes.object,
  store: _mobxReact.propTypes.observableObject,
  users: _mobxReact.propTypes.arrayOrObservableArray,
  roles: _mobxReact.propTypes.arrayOrObservableArray
}, _temp)) || _class);
exports.default = SharePermissionComponent;
module.exports = exports['default'];

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ControlBySharePermission.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Control By Share Permission component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(92);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ControlBySharePermission = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ControlBySharePermission, _Component);

  function ControlBySharePermission() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ControlBySharePermission);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ControlBySharePermission.__proto__ || (0, _getPrototypeOf2.default)(ControlBySharePermission)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeFromPopup = function (value) {
      _this.props.data.addMoreAccessors(value);
    }, _this.onChange = function (value) {
      _this.props.data.updateAccessorList(value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ControlBySharePermission, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var selectedValue = props.selectedValue,
          data = props.data;

      var componentInfo = (0, _fp.get)(selectedValue, _Izenda3.COMPONENT_CONFIG);

      if ((0, _fp.isNil)(componentInfo)) {
        return null;
      }

      var propsByType = selectedValue === _Izenda3.ASSIGNED_TYPE[2].value ? {
        loadUsers: props.loadUsers,
        validations: _Izenda3.CONSTRAINTS.USER,
        onChangeFromPopup: this.onChangeFromPopup
      } : {
        loadRoles: props.loadRoles,
        validations: _Izenda3.CONSTRAINTS.ROLE,
        onChangeFromPopup: this.onChangeFromPopup,
        roleOption: props.store.getRoleOption && props.store.getRoleOption()
      };

      return _react2.default.createElement(componentInfo.component, (0, _extends3.default)({}, componentInfo.props, propsByType, {
        field: 'accessor',
        group: data.tempId,
        value: data.accessorsInfo,
        onChange: this.onChange,
        readOnly: props.readOnly,
        disabled: props.readOnly
      }));
    }
  }]);
  return ControlBySharePermission;
}(_react.Component)) || _class);
exports.default = ControlBySharePermission;
module.exports = exports['default'];

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessGridAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var MobxPropTypes = __webpack_require__(10).propTypes;
  var PropTypes = __webpack_require__(0).PropTypes;
  var withHandlers = __webpack_require__(9).withHandlers;
  var CONSTANT = __webpack_require__(92);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil,
      isEmpty = _require.isEmpty,
      forEach = _require.forEach;

  var AccessGridAction = withHandlers({
    onClickDelete: curry(onClickDelete),
    onClickAdd: curry(onClickAdd),
    checkAll: curry(checkAll),
    deleteAccess: curry(deleteAccess),
    changeShareWith: curry(changeShareWith),
    changeAccessRight: curry(changeAccessRight),
    onChangeSelectCell: curry(onChangeSelectCell),
    onSortChange: curry(onSortChange),
    updateSearchCriteria: curry(updateSearchCriteria),
    onPageSizeChange: curry(onPageSizeChange),
    search: curry(search),
    checkDirty: checkDirty
  });

  /**
   * Deleted all access
   * @param  {object} props
   * @param  {object} event
   */
  function onClickDelete(props, event) {
    var store = props.store;
    var model = store.model;
    props.validation.reset();
    var message = props.accessMode === CONSTANT.ACCESS_MODE.TENANT ? CONSTANT.MESSAGE.M02b : CONSTANT.MESSAGE.M01b;
    props.confirmFn('Confirmation', { description: message }).then(function () {
      model.deleteAccess();
    });
  }

  /**
   * Add new access
   * @param  {object} props
   * @param  {object} event
   */
  function onClickAdd(props, event) {
    props.validation.reset();
    var store = props.store;
    var model = store.model;
    model.addAccess();
  }

  /**
   * Check all access
   * @param  {object} props
   * @param  {object} value
   * @param  {object} event
   */
  function checkAll(props, value, event) {
    var store = props.store;
    var model = store.model;
    forEach(function (item) {
      item.updateSelected(value);
    }, model.accessList);
  }

  /**
   * Delete single access
   * @param  {object} props
   * @param  {object} item
   * @param  {object} event
   */
  function deleteAccess(props, item, event) {
    var store = props.store;
    var model = store.model;
    props.validation.reset();
    var message = props.accessMode === CONSTANT.ACCESS_MODE.TENANT ? CONSTANT.MESSAGE.M02a : CONSTANT.MESSAGE.M01a;
    props.confirmFn('Confirmation', { description: message }).then(function () {
      item.delete();
      model.pageInfo.descreaseRecord();
    });
  }

  /**
   * Change share type access
   * @param  {object} props
   * @param  {object} item
   * @param  {object} value
   * @param  {object} event
   */
  function changeShareWith(props, item, value, event) {
    if (!isNil(value) && !isEmpty(value)) {
      value = parseInt(value);
    }
    item.updateAssignedType(value, 'assignedType');
  }

  /**
   * Change access right access
   * @param  {object} props
   * @param  {object} item
   * @param  {object} value
   * @param  {object} event
   */
  function changeAccessRight(props, item, key, value, event) {
    item.updateAccessRight(value, key);
  }

  /**
   * Change slected access
   * @param  {object} props
   * @param  {object} item
   * @param  {object} value
   * @param  {object} event
   */
  function onChangeSelectCell(props, item, value, event) {
    item.updateSelected(value);
  }

  /**
   * Handle on sort change, if access mode # report ignore dirty form warmning
   * @param  {object} props   react compponet props
   * @param  {object} value   new sort value
   */
  function onSortChange(props, columnKey, sortDir) {
    var store = props.store;
    var model = store.model;
    props.validation.reset();
    if (props.accessMode !== CONSTANT.ACCESS_MODE.REPORT) {
      return props.confirmDirtyForm(model.checkDirty()).then(store.onSortChange.bind(store, columnKey, sortDir));
    } else {
      return store.onSortChange(columnKey, sortDir);
    }
  }

  /**
   * Search access.
   * @param  {object} props          component props
   * @param  {object} searchProperty search criteria
   * @param  {string} searchText     search value
   * @return {object}                promise result
   */
  function search(props, searchProperty, searchText) {
    var store = props.store;
    var model = store.model;
    props.validation.reset();
    if (props.accessMode !== CONSTANT.ACCESS_MODE.REPORT) {
      return props.confirmDirtyForm(model.checkDirty()).then(store.search.bind(store, searchProperty, searchText, props.accessMode));
    } else {
      return store.search.bind(store, searchProperty, searchText)();
    }
  }

  /**
   * Search access.
   * @param  {object} props          component props
   * @param  {object} searchProperty search criteria
   * @param  {string} searchText     search value
   * @return {object}                promise result
   */
  function updateSearchCriteria(props, searchProperty, searchText) {
    props.validation.reset();
    props.store.updateSearchCriteria(searchProperty, searchText);
  }

  /**
   * Check dirty for change paging, update sort, will ignore in report access
   * @param  {object} props component props
   * @return {boolean}      result
   */
  function checkDirty(props) {
    return function () {
      var store = props.store;
      var model = store.model;

      if (props.accessMode !== CONSTANT.ACCESS_MODE.REPORT) {
        return model.checkDirty();
      } else {
        return false;
      }
    };
  }

  /**
   * Search access.
   * @param  {object} props      component props
   * @param  {object} pageSize   page size
   * @return {object}            promise result
   */
  function onPageSizeChange(props, pageSize, event) {
    props.validation.reset();
    return props.store.onPageSizeChange(pageSize);
  }

  module.exports = AccessGridAction;
}();

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionScheduling.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda = __webpack_require__(113);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(13);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(72);

var _Izenda10 = __webpack_require__(1147);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(134);

var _Izenda13 = _interopRequireDefault(_Izenda12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNCHECK_VALUE = 0;

var PermissionScheduling = (_dec = (0, _Izenda4.default)({ toClass: true }, _Izenda2.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(PermissionScheduling, _Component);

  function PermissionScheduling() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PermissionScheduling);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PermissionScheduling.__proto__ || (0, _getPrototypeOf2.default)(PermissionScheduling)).call.apply(_ref, [this].concat(args))), _this), _this.onSearchSchedule = function (searchKey) {
      var permissionStore = _this.props.permissionStore;

      permissionStore.loadPartialPermissionSchedule(null, true, searchKey);
    }, _this.updateSelectedNode = function (node, parent, accessModel) {
      var permissionStore = _this.props.permissionStore;

      permissionStore.updateSchedulingLimitsData(node, parent, accessModel);
    }, _this.loadSchedulingLimits = function (pageInfo) {
      var permissionStore = _this.props.permissionStore;

      permissionStore.loadPartialPermissionSchedule(pageInfo);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PermissionScheduling, [{
    key: 'render',
    value: function render() {
      var notifyChange = _EventUtils2.default.notifyChange;
      var _props = this.props,
          permissionStore = _props.permissionStore,
          permission = _props.permission,
          localization = _props.localization;
      var tenantDetail = permissionStore.tenantDetail;
      var scheduling = permission.scheduling;

      var tenantPermission = (0, _fp.get)('scheduling', tenantDetail);

      return !permission.fullReportAndDashboardAccess && ((0, _fp.isNil)(tenantDetail) || tenantDetail.scheduling.tenantAccess !== UNCHECK_VALUE) && _react2.default.createElement(
        'div',
        { className: _Izenda9.SECTION.Scheduling },
        _react2.default.createElement(
          _Izenda8.default,
          { className: 'izenda-GridLayout-Custom' },
          _react2.default.createElement(
            _Izenda8.default.Row,
            { className: 'u_textBold u_paddingTopBottom izenda-PermissionCategory-Header u_noMarginAll' },
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 2 },
              _react2.default.createElement('a', {
                className: this.props.getIconClass('isShowScheduling'),
                onClick: this.props.toggle.bind(this, 'isShowScheduling')
              }),
              localization.getText('COMMON_LABEL_SCHEDULING')
            ),
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 9 },
              _react2.default.createElement(_Izenda13.default, {
                permission: permission,
                readOnly: this.props.readOnly,
                section: scheduling,
                tenantPermission: tenantPermission,
                tenantDetail: tenantDetail
              })
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                indeterminate: this.props.getIndeterminateCommon(scheduling),
                checked: this.props.getCheckedCommon(scheduling.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccessParent.bind(permission, scheduling), _EventUtils2.default.CHECKBOX)
              })
            )
          )
        ),
        permissionStore.isShowScheduling && _react2.default.createElement(
          _Izenda8.default,
          null,
          ((0, _fp.isNil)(tenantDetail) || tenantDetail.scheduling.schedulingLimits.tenantAccess !== UNCHECK_VALUE) && _react2.default.createElement(
            _Izenda8.default.Row,
            { className: 'u_paddingTop u_paddingBottom u_noMarginAll u_borderBottom' },
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_SCHEDULING_LIMITS')
            ),
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 9 },
              _react2.default.createElement(
                'div',
                { className: 'u_inlineBlock u_fullWidth' },
                _react2.default.createElement(_Izenda11.default, (0, _extends3.default)({}, this.props, {
                  getData: this.loadSchedulingLimits,
                  searchRoles: this.onSearchSchedule,
                  rolePermission: permissionStore.roleSchedulingLimits,
                  updateSelectedNode: this.updateSelectedNode
                }))
              )
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(scheduling.schedulingLimits.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccess.bind(permission, scheduling, scheduling.schedulingLimits), _EventUtils2.default.CHECKBOX)
              })
            )
          ),
          ((0, _fp.isNil)(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.scheduling.schedulingScope)) && _react2.default.createElement(
            _Izenda8.default.Row,
            { className: 'u_paddingTop u_paddingBottom u_noMarginAll' },
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_SCHEDULING_SCOPE')
            ),
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 9 },
              ((0, _fp.isNil)(tenantDetail) || tenantDetail.scheduling.schedulingScope.systemUsers) && _react2.default.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement(_Izenda6.default, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(scheduling.schedulingScope.systemUsers),
                    onChange: notifyChange(permission.updateData.bind(permission, scheduling.schedulingScope, 'systemUsers'), _EventUtils2.default.CHECKBOX)
                  }),
                  _react2.default.createElement(
                    'span',
                    null,
                    localization.getText('PERMISSION_LABEL_SYSTEM_USERS')
                  )
                )
              ),
              ((0, _fp.isNil)(tenantDetail) || tenantDetail.scheduling.schedulingScope.externalUsers) && _react2.default.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement(_Izenda6.default, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(scheduling.schedulingScope.externalUsers),
                    onChange: notifyChange(permission.updateData.bind(permission, scheduling.schedulingScope, 'externalUsers'), _EventUtils2.default.CHECKBOX)
                  }),
                  _react2.default.createElement(
                    'span',
                    null,
                    localization.getText('PERMISSION_LABEL_EXTERNAL_USERS')
                  )
                )
              )
            ),
            permission.isTenantSetup && _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: 1, className: 'u_textCenter' },
              _react2.default.createElement(_Izenda6.default, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(scheduling.schedulingScope.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccess.bind(permission, scheduling, scheduling.schedulingScope), _EventUtils2.default.CHECKBOX)
              })
            )
          )
        )
      );
    }
  }]);
  return PermissionScheduling;
}(_react.Component), _class2.propTypes = {
  permissionStore: _propTypes2.default.object.isRequired,
  permission: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = PermissionScheduling;
module.exports = exports['default'];

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionEmailing.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(113);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(72);

var _Izenda10 = __webpack_require__(45);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(134);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PermissionEmailing = (_dec = (0, _Izenda2.default)({ toClass: true }, _Izenda8.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PermissionEmailing, _Component);

  function PermissionEmailing(props) {
    (0, _classCallCheck3.default)(this, PermissionEmailing);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PermissionEmailing.__proto__ || (0, _getPrototypeOf2.default)(PermissionEmailing)).call(this, props));

    _initialiseProps.call(_this);

    _this.emailing = props.permission.emailing;
    return _this;
  }

  (0, _createClass3.default)(PermissionEmailing, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var permissionStore = props.permissionStore,
          tenantDetail = props.permissionStore.tenantDetail,
          fullReportAndDashboardAccess = props.permission.fullReportAndDashboardAccess;


      return !fullReportAndDashboardAccess && ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(tenantDetail.emailing)) && _react2.default.createElement(
        'div',
        { className: _Izenda9.SECTION.Emailing },
        this.renderEmailSession(),
        permissionStore.isShowEmailing && _react2.default.createElement(
          _Izenda4.default,
          { className: 'izenda-GridLayout-Custom' },
          this.renderDeliveryMethod(),
          this.renderAttachmentType()
        )
      );
    }
  }]);
  return PermissionEmailing;
}(_react.Component), _class2.propTypes = {
  permission: _propTypes2.default.object.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onShowEmailingToggle = function () {
    _this2.props.toggle('isShowEmailing');
  };

  this.onChangeEmailingTenantAccess = function (e) {
    var permission = _this2.props.permission;

    permission.updateTenantAccessParent(_this2.emailing, e.target.checked);
  };

  this.onChangeDeliveryMethod = function (method) {
    return function (e) {
      var permission = _this2.props.permission;

      permission.updateData(_this2.emailing.deliveryMethod, method, e.target.checked);
    };
  };

  this.onChangeLinkDeliveryMethod = this.onChangeDeliveryMethod('link');
  this.onChangeEmbeddedHTMLDeliveryMethod = this.onChangeDeliveryMethod('embeddedHTML');
  this.onChangeAttachmentDeliveryMethod = this.onChangeDeliveryMethod('attachment');

  this.onChangeDeliveryMethodTenantAccess = function (e) {
    var permission = _this2.props.permission;

    permission.updateTenantAccess(_this2.emailing, _this2.emailing.deliveryMethod, e.target.checked);
  };

  this.onChangeAttachmentType = function (type) {
    return function (e) {
      var permission = _this2.props.permission;

      permission.updateData(_this2.emailing.attachmentType, type, e.target.checked);
    };
  };

  this.onChangeWordAttachmentType = this.onChangeAttachmentType('word');
  this.onChangeExcelAttachmentType = this.onChangeAttachmentType('excel');
  this.onChangePdfAttachmentType = this.onChangeAttachmentType('pdf');
  this.onChangeCsvAttachmentType = this.onChangeAttachmentType('csv');
  this.onChangeXmlAttachmentType = this.onChangeAttachmentType('xml');
  this.onChangeJsonAttachmentType = this.onChangeAttachmentType('json');
  this.onChangeDefinitionAttachmentType = this.onChangeAttachmentType('definition');

  this.onChangeAttachmentTypeTenantAccess = function (e) {
    var permission = _this2.props.permission;

    permission.updateTenantAccess(_this2.emailing, _this2.emailing.attachmentType, e.target.checked);
  };

  this.renderDeliveryMethod = function () {
    var props = _this2.props;
    var tenantDetail = props.permissionStore.tenantDetail,
        permission = props.permission,
        localization = props.localization,
        authorization = props.authorization,
        readOnly = props.readOnly;

    var hasExportLicense = authorization.checkLicense(_Izenda11.default.LICENSE_KEY.Exporting);
    var currentEmailing = _this2.emailing;

    var emailing = (0, _fp.get)('emailing', tenantDetail);

    return ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(emailing.deliveryMethod)) && _react2.default.createElement(
      _Izenda4.default.Row,
      { className: 'u_paddingTop u_paddingBottom' },
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
        localization.getText('COMMON_LABEL_DELIVERY_METHOD')
      ),
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 9 },
        ((0, _fp.isNil)(tenantDetail) || emailing.deliveryMethod.link) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.deliveryMethod.link),
              onChange: _this2.onChangeLinkDeliveryMethod
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_LINK')
            )
          )
        ),
        ((0, _fp.isNil)(tenantDetail) || emailing.deliveryMethod.embeddedHTML) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.deliveryMethod.embeddedHTML),
              onChange: _this2.onChangeEmbeddedHTMLDeliveryMethod
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_EMBEDDED_HTML')
            )
          )
        ),
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || emailing.deliveryMethod.attachment) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.deliveryMethod.attachment),
              onChange: _this2.onChangeAttachmentDeliveryMethod
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_ATTACHMENT')
            )
          )
        )
      ),
      permission.isTenantSetup && _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 1, className: 'u_textCenter' },
        _react2.default.createElement(_Izenda6.default, {
          type: 'checkbox',
          readOnly: readOnly,
          checked: props.getCheckedCommon(currentEmailing.deliveryMethod.tenantAccess),
          onChange: _this2.onChangeDeliveryMethodTenantAccess
        })
      )
    );
  };

  this.renderAttachmentType = function () {
    var props = _this2.props;
    var tenantDetail = props.permissionStore.tenantDetail,
        permission = props.permission,
        localization = props.localization,
        authorization = props.authorization,
        readOnly = props.readOnly;

    var hasExportLicense = authorization.checkLicense(_Izenda11.default.LICENSE_KEY.Exporting);
    var currentEmailing = _this2.emailing;

    var emailing = (0, _fp.get)('emailing', tenantDetail);

    return ((0, _fp.isNil)(tenantDetail) || props.checkShowGroupCommon(emailing.attachmentType)) && _react2.default.createElement(
      _Izenda4.default.Row,
      { className: 'u_paddingTop u_paddingBottom' },
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
        localization.getText('COMMON_LABEL_ATTACHMENT_TYPE')
      ),
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 9 },
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || emailing.attachmentType.word) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.attachmentType.word),
              onChange: _this2.onChangeWordAttachmentType
            }),
            _react2.default.createElement(
              'span',
              null,
              'Word'
            )
          )
        ),
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || emailing.attachmentType.excel) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.attachmentType.excel),
              onChange: _this2.onChangeExcelAttachmentType
            }),
            _react2.default.createElement(
              'span',
              null,
              'Excel'
            )
          )
        ),
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || emailing.attachmentType.pdf) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.attachmentType.pdf),
              onChange: _this2.onChangePdfAttachmentType
            }),
            _react2.default.createElement(
              'span',
              null,
              'PDF'
            )
          )
        ),
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || emailing.attachmentType.csv) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.attachmentType.csv),
              onChange: _this2.onChangeCsvAttachmentType
            }),
            _react2.default.createElement(
              'span',
              null,
              'CSV'
            )
          )
        ),
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || emailing.attachmentType.xml) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.attachmentType.xml),
              onChange: _this2.onChangeXmlAttachmentType
            }),
            _react2.default.createElement(
              'span',
              null,
              'XML'
            )
          )
        ),
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || emailing.attachmentType.json) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.attachmentType.json),
              onChange: _this2.onChangeJsonAttachmentType
            }),
            _react2.default.createElement(
              'span',
              null,
              'JSON'
            )
          )
        ),
        hasExportLicense && ((0, _fp.isNil)(tenantDetail) || emailing.attachmentType.definition) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              readOnly: readOnly,
              checked: props.getCheckedCommon(currentEmailing.attachmentType.definition),
              onChange: _this2.onChangeDefinitionAttachmentType
            }),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('PERMISSION_LABEL_DEFINITION')
            ),
            _react2.default.createElement('span', { className: 'icon-info-circled', title: localization.getText('TENANT_TOOLTIP_DEFINITION_TYPE') })
          )
        )
      ),
      permission.isTenantSetup && _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 1, className: 'u_textCenter' },
        _react2.default.createElement(_Izenda6.default, {
          type: 'checkbox',
          readOnly: readOnly,
          checked: props.getCheckedCommon(currentEmailing.attachmentType.tenantAccess),
          onChange: _this2.onChangeAttachmentTypeTenantAccess
        })
      )
    );
  };

  this.renderEmailSession = function () {
    var props = _this2.props;
    var tenantDetail = props.permissionStore.tenantDetail,
        permission = props.permission,
        localization = props.localization,
        readOnly = props.readOnly;

    var emailing = (0, _fp.get)('emailing', tenantDetail);

    return _react2.default.createElement(
      _Izenda4.default,
      { className: 'izenda-GridLayout-Custom' },
      _react2.default.createElement(
        _Izenda4.default.Row,
        { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 2 },
          _react2.default.createElement('a', { className: props.getIconClass('isShowEmailing'), onClick: _this2.onShowEmailingToggle }),
          localization.getText('COMMON_LABEL_EMAILING')
        ),
        _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 9 },
          _react2.default.createElement(_Izenda13.default, {
            permission: permission,
            readOnly: readOnly,
            section: _this2.emailing,
            tenantPermission: emailing,
            tenantDetail: tenantDetail
          })
        ),
        permission.isTenantSetup && _react2.default.createElement(
          _Izenda4.default.Col,
          { cols: 1, className: 'u_textCenter' },
          _react2.default.createElement(_Izenda6.default, {
            type: 'checkbox',
            readOnly: readOnly,
            indeterminate: props.getIndeterminateCommon(_this2.emailing),
            checked: props.getCheckedCommon(_this2.emailing.tenantAccess),
            onChange: _this2.onChangeEmailingTenantAccess
          })
        )
      )
    );
  };
}, _temp)) || _class);
exports.default = PermissionEmailing;
module.exports = exports['default'];

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionExporting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var actions = __webpack_require__(113);
  var SECTION = __webpack_require__(72).SECTION;
  var EventsUtils = __webpack_require__(24);
  var LicenseCheckerConstants = __webpack_require__(45);
  var CheckboxAllPermission = __webpack_require__(134);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      get = _require.get;

  var PermissionEmailing = React.createClass({
    displayName: 'PermissionEmailing',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.exporting = this.props.permission.exporting;
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;
      var authorization = this.props.authorization;
      var hasExportLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Exporting);
      var exporting = get('exporting', tenantDetail);

      return hasExportLicense && !permission.fullReportAndDashboardAccess && (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.exporting)) && React.createElement(
        'div',
        { className: SECTION.Exporting },
        React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
            React.createElement(
              GridLayout.Col,
              { cols: 2 },
              React.createElement('a', {
                className: this.props.getIconClass('isShowExporting'),
                onClick: this.props.toggle.bind(this, 'isShowExporting')
              }),
              localization.getText('COMMON_LABEL_EXPORTING')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(CheckboxAllPermission, {
                permission: permission,
                readOnly: this.props.readOnly,
                section: this.exporting,
                tenantPermission: exporting,
                tenantDetail: tenantDetail
              })
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                indeterminate: this.props.getIndeterminateCommon(this.exporting),
                checked: this.props.getCheckedCommon(this.exporting.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccessParent.bind(permission, this.exporting), EventsUtils.CHECKBOX)
              })
            )
          )
        ),
        permissionStore.isShowExporting && React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.exporting.exportingFormat)) && React.createElement(
            GridLayout.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            React.createElement(
              GridLayout.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_EXPORTING_FORMAT')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              (isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.word) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.exporting.exportingFormat.word),
                    onChange: notifyChange(permission.updateData.bind(permission, this.exporting.exportingFormat, 'word'), EventsUtils.CHECKBOX)
                  }),
                  React.createElement(
                    'span',
                    null,
                    'Word'
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.excel) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.exporting.exportingFormat.excel),
                    onChange: notifyChange(permission.updateData.bind(permission, this.exporting.exportingFormat, 'excel'), EventsUtils.CHECKBOX)
                  }),
                  React.createElement(
                    'span',
                    null,
                    'Excel'
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.pdf) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.exporting.exportingFormat.pdf),
                    onChange: notifyChange(permission.updateData.bind(permission, this.exporting.exportingFormat, 'pdf'), EventsUtils.CHECKBOX)
                  }),
                  React.createElement(
                    'span',
                    null,
                    'PDF'
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.csv) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.exporting.exportingFormat.csv),
                    onChange: notifyChange(permission.updateData.bind(permission, this.exporting.exportingFormat, 'csv'), EventsUtils.CHECKBOX)
                  }),
                  React.createElement(
                    'span',
                    null,
                    'CSV'
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.xml) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.exporting.exportingFormat.xml),
                    onChange: notifyChange(permission.updateData.bind(permission, this.exporting.exportingFormat, 'xml'), EventsUtils.CHECKBOX)
                  }),
                  React.createElement(
                    'span',
                    null,
                    'XML'
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.json) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.exporting.exportingFormat.json),
                    onChange: notifyChange(permission.updateData.bind(permission, this.exporting.exportingFormat, 'json'), EventsUtils.CHECKBOX)
                  }),
                  React.createElement(
                    'span',
                    null,
                    'JSON'
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.queryExecution) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.exporting.exportingFormat.queryExecution),
                    onChange: notifyChange(permission.updateData.bind(permission, this.exporting.exportingFormat, 'queryExecution'), EventsUtils.CHECKBOX)
                  }),
                  React.createElement(
                    'span',
                    null,
                    localization.getText('PERMISSION_LABEL_QUERY_EXECUTION')
                  )
                )
              ),
              (isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.definition) && React.createElement(
                'div',
                { className: 'u_inlineBlock izenda-PermissionCategory-group_left' },
                React.createElement(
                  'label',
                  null,
                  React.createElement(Input, {
                    type: 'checkbox',
                    readOnly: this.props.readOnly,
                    checked: this.props.getCheckedCommon(this.exporting.exportingFormat.definition),
                    onChange: notifyChange(permission.updateData.bind(permission, this.exporting.exportingFormat, 'definition'), EventsUtils.CHECKBOX)
                  }),
                  React.createElement(
                    'span',
                    null,
                    localization.getText('PERMISSION_LABEL_DEFINITION')
                  ),
                  React.createElement('span', {
                    className: 'icon-info-circled',
                    title: localization.getText('TENANT_TOOLTIP_DEFINITION_TYPE')
                  })
                )
              )
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.exporting.exportingFormat.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccess.bind(permission, this.exporting, this.exporting.exportingFormat), EventsUtils.CHECKBOX)
              })
            )
          )
        )
      );
    }
  });

  module.exports = connect({ toClass: true }, actions)(PermissionEmailing);
}();

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionSystemWide.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var actions = __webpack_require__(113);
  var SECTION = __webpack_require__(72).SECTION;
  var EventsUtils = __webpack_require__(24);
  var CheckboxAllPermission = __webpack_require__(134);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      get = _require.get;

  var PermissionSystemWide = React.createClass({
    displayName: 'PermissionSystemWide',

    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.systemwide = this.props.permission.systemwide;
    },

    render: function render() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;
      var systemwide = get('systemwide', tenantDetail);

      return (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.systemwide)) && React.createElement(
        'div',
        { className: SECTION.SystemWide },
        React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header' },
            React.createElement(
              GridLayout.Col,
              { cols: 2 },
              React.createElement('a', {
                className: this.props.getIconClass('isShowSystemWide'),
                onClick: this.props.toggle.bind(this, 'isShowSystemWide')
              }),
              localization.getText('COMMON_LABEL_SYSTEM_WIDE')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(CheckboxAllPermission, {
                permission: permission,
                readOnly: this.props.readOnly,
                section: this.systemwide,
                tenantPermission: systemwide,
                tenantDetail: tenantDetail
              })
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                indeterminate: this.props.getIndeterminateCommon(this.systemwide),
                checked: this.props.getCheckedCommon(this.systemwide.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccessParent.bind(permission, this.systemwide), EventsUtils.CHECKBOX)
              })
            )
          )
        ),
        permissionStore.isShowSystemWide && React.createElement(
          GridLayout,
          { className: 'izenda-GridLayout-Custom' },
          (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.systemwide.canSeeSystemMessages)) && React.createElement(
            GridLayout.Row,
            { className: 'u_paddingTop u_paddingBottom' },
            React.createElement(
              GridLayout.Col,
              { cols: 2, className: 'izenda-PermissionCategory-SubCategory' },
              localization.getText('PERMISSION_LABEL_CAN_SEE_SYSTEM_MESSAGES')
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 9 },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.systemwide.canSeeSystemMessages.value),
                onChange: notifyChange(permission.updateData.bind(permission, this.systemwide.canSeeSystemMessages, 'value'), EventsUtils.CHECKBOX)
              })
            ),
            permission.isTenantSetup && React.createElement(
              GridLayout.Col,
              { cols: 1, className: 'u_textCenter' },
              React.createElement(Input, {
                type: 'checkbox',
                readOnly: this.props.readOnly,
                checked: this.props.getCheckedCommon(this.systemwide.canSeeSystemMessages.tenantAccess),
                onChange: notifyChange(permission.updateTenantAccess.bind(permission, this.systemwide, this.systemwide.canSeeSystemMessages), EventsUtils.CHECKBOX)
              })
            )
          )
        )
      );
    }
  });

  module.exports = connect({ toClass: true }, actions)(PermissionSystemWide);
}();

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionFullReportDashboardAccess.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(71);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

var _Izenda9 = __webpack_require__(113);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PermissionFullReportDashboardAccess = (_dec = (0, _Izenda2.default)(_Izenda10.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(PermissionFullReportDashboardAccess, _Component);

  function PermissionFullReportDashboardAccess() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PermissionFullReportDashboardAccess);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PermissionFullReportDashboardAccess.__proto__ || (0, _getPrototypeOf2.default)(PermissionFullReportDashboardAccess)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
      var permission = (0, _fp.get)('props.permission', _this);
      var isChecked = (0, _fp.get)('target.checked', event);
      permission.updateFullReportAndDashBoardAccess(isChecked);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PermissionFullReportDashboardAccess, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          permission = _props.permission,
          localization = _props.localization,
          authorization = _props.authorization,
          permissionKeys = _props.authorizationConstants.PERMISSION_KEY;

      var hasFullReportAndDashboard = authorization.checkPrivileges([permissionKeys.RoleSetupGrantRoleWithFullReportAndDashboardAccessValue]);
      return !permission.isTenantSetup && hasFullReportAndDashboard && _react2.default.createElement(
        _Izenda4.default,
        { className: 'izenda-GridLayout-Custom' },
        _react2.default.createElement(
          _Izenda4.default.Row,
          { className: 'u_paddingTop u_paddingBottom' },
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: 2, className: 'u_textBold izenda-PermissionCategory-SubCategory' },
            localization.getText("PERMISSION_LABEL_FULLREPORTDASHBOARDACCESS")
          ),
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: 9 },
            _react2.default.createElement(_Izenda6.default, {
              type: 'checkbox',
              checked: this.props.getCheckedCommon(permission.fullReportAndDashboardAccess),
              onChange: this.onChange
            }),
            _react2.default.createElement(
              _Izenda8.default,
              {
                className: 'u_marginLeftRight u_paddingRight u_alignMiddle u_textNormal' },
              _react2.default.createElement('span', { className: 'icon-info-circled', title: localization.getText("PERMISSION_ICON_TOOLTIP_FULLREPORTDASHBOARDACCESS") })
            )
          )
        )
      );
    }
  }]);
  return PermissionFullReportDashboardAccess;
}(_react.Component), _class2.propTypes = {
  permission: _react2.default.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = PermissionFullReportDashboardAccess;
module.exports = exports['default'];

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantListHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var EventUtils = __webpack_require__(24);
  var SearchTextBox = __webpack_require__(107);
  var config = __webpack_require__(40);

  /**
   * Tenant List Header
   * @param {object} props The component's props that must have 'store' property
   */
  var TenantListHeader = function TenantListHeader(props) {
    var store = props.store;
    var tenantList = store.tenantList;
    var addTenant = function addTenant() {
      props.validation.reset();
      store.addTenant();
    };
    var updateFilter = store.updateFilterText.bind(store);
    var localization = props.localization;
    var authorization = props.authorization;
    var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
    var hasCreatePrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsCreate]);
    var canCreateTenant = hasCreatePrivilege && !config.Integration;

    return React.createElement(
      'div',
      { className: 'izenda-MiddlePanel-search' },
      canCreateTenant && React.createElement(
        'a',
        {
          className: 'overflow-text u_block',
          onClick: addTenant,
          title: localization.getText('TENANT_LIST_HEADER_ADD_TENANT') },
        React.createElement('span', { className: 'icon-plus' }),
        localization.getText('TENANT_LIST_HEADER_ADD_TENANT')
      ),
      React.createElement(
        'div',
        { className: 'search-box' },
        React.createElement(SearchTextBox, {
          value: tenantList.filterText,
          onChange: EventUtils.notifyChange(updateFilter, EventUtils.INPUT) })
      ),
      React.createElement('hr', null)
    );
  };
  TenantListHeader.propTypes = {
    store: React.PropTypes.object.isRequired
  };

  module.exports = connect()(TenantListHeader);
}();

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantManagementActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var lifecycle = __webpack_require__(9).lifecycle;
  var withProps = __webpack_require__(9).withProps;
  var setPropTypes = __webpack_require__(9).setPropTypes;

  var TenantManagementActions = compose(setPropTypes({
    store: React.PropTypes.object.isRequired
  }));

  module.exports = TenantManagementActions;
}();

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.Connection.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
  * @module Connection component
  */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2270);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2277);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(196);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2279);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2283);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Connection = (_dec = (0, _Izenda12.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Connection, _Component);

  function Connection() {
    (0, _classCallCheck3.default)(this, Connection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Connection.__proto__ || (0, _getPrototypeOf2.default)(Connection)).call(this));

    _this.masterStore = new _Izenda8.default();
    _this.detailStore = new _Izenda10.default(_this.masterStore);
    return _this;
  }

  (0, _createClass3.default)(Connection, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.masterStore.dispose();
      this.masterStore.disposeChangeTenant();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "izenda-TableLayout" },
        _react2.default.createElement(
          _Izenda6.default,
          { ref: "connectionsPanel" },
          _react2.default.createElement(_Izenda4.default, { store: this.masterStore })
        ),
        _react2.default.createElement(_Izenda2.default, {
          store: this.detailStore,
          item: this.detailStore.item,
          dbTypeList: this.masterStore.dbTypeList
        })
      );
    }
  }]);
  return Connection;
}(_react.Component)) || _class);
exports.default = Connection;
module.exports = exports["default"];

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionConfig.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * @module ConnectionConfig component
 * @example
 *   <ConnectionConfig>
 *     <Header></Header>
 *     <ConnectionDetail>
 *       <ConnectionBuilderModal></ConnectionBuilderModal>
 *     </ConnectionDetail>
 *     <ConnectButton></ConnectButton>
 *     <DataSourceTree></DataSourceTree>
 *   </ConnectionConfig>
 */
!function () {
  var constants = __webpack_require__(197);
  var React = __webpack_require__(0);
  var Header = __webpack_require__(2271);
  var ScrollBox = __webpack_require__(27);
  var ConnectionDetail = __webpack_require__(2272);
  var ConnectButton = __webpack_require__(2273);
  var DataSourceTreeContainer = __webpack_require__(2274);
  var commonMessages = __webpack_require__(37);
  var MESSAGE_TYPE = commonMessages.MESSAGE_TYPE;
  var connect = __webpack_require__(2);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;

  var getConnectLabel = function getConnectLabel(connectionDetail) {
    /*
     * Just display 'Reconnect' when (AND operator):
     *   - Editing Connection
     *   - DataSource of Tree does not empty
     *   - Connection String does not change
     */
    return connectionDetail.needReloadDetectChange ? constants.CONNECT_TYPE.RECONNECT : constants.CONNECT_TYPE.CONNECT;
  };

  var ConnectionConfig = React.createClass({
    displayName: 'ConnectionConfig',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired,
      dbTypeList: React.PropTypes.object.isRequired
    },
    componentDidMount: function componentDidMount() {
      this.props.store.init();
    },
    componentWillUnmount: function componentWillUnmount() {
      this.props.store.destroy();
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (this.props.item !== nextProps.item) {
        this.props.validation.reset();
        this.props.item.setAlertMessage(commonMessages.EMPTY_MESSAGE);
      }
    },
    render: function render() {
      // Connection detail store
      var store = this.props.store;
      var item = this.props.item;
      var disabled = !item.isConnectionStringReady;

      var connectBtnLabel = getConnectLabel(this.props.item);

      return React.createElement(
        'div',
        { className: 'izenda-TableLayout-Cell' },
        React.createElement(
          'section',
          { className: 'izenda-Wrapper' },
          React.createElement(Header, {
            ref: 'Header',
            onCancel: this.onCancel,
            onSave: this.onSave,
            disabled: !item.visible,
            alertMessage: item.alertMessage,
            onResetAlert: this.resetAlertMessage
          }),
          React.createElement(
            'div',
            { className: 'izenda-Wrapper-content' },
            React.createElement(
              ScrollBox,
              null,
              React.createElement(
                'div',
                { className: 'u_fullHeight u_paddingLeftRight' },
                React.createElement(ConnectionDetail, (0, _extends3.default)({}, this.props, { onTestConnection: this.onTestConnection })),
                React.createElement(ConnectButton, {
                  onConnectButtonClick: this.onConnectToDataSource,
                  connectBtnLabel: connectBtnLabel,
                  disabled: disabled
                }),
                React.createElement(DataSourceTreeContainer, {
                  store: store,
                  disabled: disabled,
                  item: item,
                  isAddNew: isEmpty(this.props.item.id)
                })
              )
            )
          )
        )
      );
    },

    /**
     * Retrieve connection detail and update via API.
     */
    onSave: function onSave() {
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var validationManager = props.validation;
      var item = props.item;
      var localization = props.localization;

      validate.call(this);

      function validate() {
        var confirmFn = props.confirmFn;
        var confirmMessage = props.confirmMessage;

        loader.startLoading();
        this.onTestConnection().then(function (validateSchemaStatus) {
          item.setAlertMessage(commonMessages.EMPTY_MESSAGE);

          if (!item.canSave) {
            item.setAlertMessage({
              type: MESSAGE_TYPE.INFO,
              messages: commonMessages.SUPP_MSG_028
            });
            return;
          }

          if (item.canSave && validateSchemaStatus) {
            return confirmFn('Confirmation', {
              description: item.needConfirmMessageForAvailableDatasouceChange ? constants.M05 : localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
            }).then(function () {
              return store.save();
            });
          } else if (!validateSchemaStatus) {
            confirmMessage('error', constants.MISMATCH_CONNECIONSTRING_DATASOURCE);
          }
          return null;
        }).then(function (saveErrors) {
          if (!isEmpty(saveErrors)) {
            validationManager.updateErrors(saveErrors);
          }
          return null;
        }).finally(loader.endLoading.bind(loader));
      }
    },

    /**
     * Cancel changes that user made for connection.
     */
    onCancel: function onCancel() {
      var store = this.props.store;
      var item = store.item;
      var validationManager = this.props.validation;
      var localization = this.props.localization;

      if (item.isDirty) {
        this.props.confirmFn('Confirmation', {
          description: localization.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST')
        }).then(function () {
          validationManager.reset();
          return store.load(item.id);
        });
      } else {
        item.setAlertMessage({
          type: MESSAGE_TYPE.INFO,
          messages: commonMessages.SUPP_MSG_028
        });
      }
    },
    /**
     * Test input connection string associated with database server type.
     */
    onTestConnection: function onTestConnection() {
      var store = this.props.store;
      var loader = this.props.loader;
      var confirmMessage = this.props.confirmMessage;

      var item = this.props.item;
      var valManager = this.props.validation;

      loader.startLoading();
      return valManager.validate('connectionString').then(function (success) {
        if (success) {
          store.populateDatabaseName();
          return success;
        } else if (!item.isNew) {
          return confirmMessage('info', constants.REVERSE_CONNECTION_STRING).then(function () {
            valManager.reset('connectionString');
            store.load(item.id);
            return null;
          });
        }
        return (0, _bluebird.reject)();
      }).then(function (validationStatus) {
        if (item.isCurrentConnectionStringSameAsSavedConnectionString) {
          return validationStatus;
        } else {
          return store.validateSchema();
        }
      }).finally(loader.endLoading.bind(loader));
    },

    /**
     * Connect to data source by its current connection string
     */
    onConnectToDataSource: function onConnectToDataSource() {
      // Set force:true to enforce loading new data source from API
      var store = this.props.store;
      var loader = this.props.loader;
      var item = store.item;

      if (!item.isConnectionStringReady) {
        return;
      }
      var connectToDataSource = item.isCurrentConnectionStringSameAsSavedConnectionString ? store.connectToDataSource(item, true) : this.props.confirmFn('Confirmation', {
        description: constants.NEW_CONNECTIONSTRING_DIFFERENT_SCHEMA
      }).then(store.connectToDataSource.bind(store, item, true));

      loader.startLoading();

      function onReconnectComplete() {
        if (!item.canSave) {
          item.markDirty();
        }
      }

      return connectToDataSource.finally(onReconnectComplete.bind(this)).then(loader.endLoading.bind(loader));
    },

    resetAlertMessage: function resetAlertMessage() {
      var store = this.props.store;
      var item = store.item;
      item.setAlertMessage(commonMessages.EMPTY_MESSAGE);
    }
  });

  module.exports = connect()(ConnectionConfig);
}();

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Header.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Header component
 */
!function () {
  "use strict";

  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var Button = __webpack_require__(30);
  var ActionBar = __webpack_require__(147);
  var Alert = __webpack_require__(61);
  var IconMenu = __webpack_require__(86);

  var Header = React.createClass({
    displayName: 'Header',

    propTypes: {
      disabled: React.PropTypes.bool.isRequired,
      onSave: React.PropTypes.func.isRequired,
      onCancel: React.PropTypes.func.isRequired,
      alertMessage: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var alertMessage = props.alertMessage;

      return React.createElement(
        'section',
        { className: 'izenda-Wrapper-header' },
        React.createElement(IconMenu, null),
        React.createElement(
          Alert,
          { type: alertMessage.type, onAutoHide: props.onResetAlert },
          alertMessage.message
        ),
        React.createElement(ActionBar, {
          onSave: props.onSave,
          onCancel: props.onCancel,
          disabled: props.disabled })
      );
    }
  });

  module.exports = observer(Header);
}();

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionDetail.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ConnectionDetail component
 */
!function () {
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);
  var EventsUtils = __webpack_require__(24);

  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var Panel = __webpack_require__(28);
  var Label = __webpack_require__(71);
  var Span = __webpack_require__(1148);
  var FormGroup = __webpack_require__(122);
  var DropDown = __webpack_require__(29);
  var Icon = __webpack_require__(314);
  var Button = __webpack_require__(30);
  var ConnectionStringBuilder = __webpack_require__(1144);
  var constants = __webpack_require__(197);

  var Validator = __webpack_require__(23);
  var ValidatableInput = Validator()(__webpack_require__(17));
  var ValidatableSecuredInput = Validator()(__webpack_require__(614));

  var _require = __webpack_require__(1),
      merge = _require.merge,
      partial = _require.partial,
      findLast = _require.findLast;

  var ConnectionDetail = React.createClass({
    displayName: 'ConnectionDetail',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired,
      dbTypeList: React.PropTypes.object.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var store = nextProps.store;
      var loader = nextProps.loader;
      // Only load data when showing different connection.
      if (this.props.item.id !== nextProps.item.id) {
        loader.startLoading();
        store.load(nextProps.item.id).finally(loader.endLoading.bind(loader));
      }
    },
    render: function render() {
      var store = this.props.store;
      var detail = this.props.item;
      var dbTypeList = this.props.dbTypeList;
      var localization = this.props.localization;
      var disabled = !detail.visible;

      var notifyChange = EventsUtils.notifyChange;
      var notify = EventsUtils.notify;

      var connStringVals = merge(constants.CONNECTION_STRING_CONSTRAINT, {
        action: function action() {
          return store.validateConnection.bind(store);
        }
      }, {});
      var inputClasses = classnames('form-control', { 'izenda-ConnectringString-input': detail.isSecured });

      return React.createElement(
        Panel,
        { className: 'connection-string-validation-container' },
        React.createElement(
          Label,
          null,
          localization.getText('CONNECTION_LABEL_DATABASE_NAME')
        ),
        React.createElement(
          FormGroup,
          null,
          React.createElement(ValidatableInput, {
            field: 'name',
            validations: constants.DATABASE_NAME_CONSTRAINT,
            className: 'form-control',
            onChange: notifyChange(detail.setName.bind(detail), EventsUtils.INPUT),
            value: detail.name,
            disabled: disabled
          })
        ),
        React.createElement(
          'div',
          { className: 'row' },
          React.createElement(
            'div',
            { className: 'col-md-4' },
            React.createElement(
              FormGroup,
              null,
              React.createElement(
                Label,
                { className: 'validation required' },
                localization.getText('CONNECTION_LABEL_DATA_SERVER_TYPE')
              ),
              React.createElement(DropDown, {
                disabled: disabled,
                labelField: 'name',
                valueField: 'id',
                options: dbTypeList,
                value: detail.serverTypeId,
                onChange: notifyChange(detail.setServerTypeId.bind(detail), EventsUtils.DROPDOWN),
                ref: 'dbServerType'
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-8' },
            React.createElement(
              'div',
              { className: 'row' },
              React.createElement(
                Label,
                { className: 'col-md-6 validation required' },
                localization.getText('CONNECTION_LABEL_CONNECTION_STRING')
              ),
              React.createElement(
                'div',
                {
                  disabled: disabled,
                  className: 'text-right u_paddingRight connection-string-builder',
                  onClick: this.showConnectionStringBuilder
                },
                React.createElement(
                  Span,
                  { className: 'no-padding-left-right' },
                  localization.getText('CONNECTION_LABEL_CONNECTION_BUILDER')
                ),
                React.createElement(Icon, { className: 'icon-flash' })
              )
            ),
            React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                { className: 'u_inlineBlock u-posRelative izenda-ConnectringString-wrapper' },
                React.createElement(ValidatableSecuredInput, {
                  className: inputClasses,
                  onReset: notify(partial(detail.setConnectionString.bind(detail), '')),
                  onFocus: this.onResetConnectionString,
                  onChange: notifyChange(detail.setConnectionString.bind(detail), EventsUtils.INPUT),
                  value: detail.securedConnectionString,
                  secure: detail.isSecured,
                  enabled: !disabled,
                  validations: connStringVals,
                  onValidated: this.onValidated,
                  field: 'connectionString',
                  maxLength: '500'
                }),
                detail.isSecured ? React.createElement('span', { className: 'u_inlineBlock u-posAbsolute icon-ok success-color valid-connection' }) : null
              ),
              React.createElement(Button, {
                label: localization.getText('COMMON_LABEL_TEST'),
                onClick: this.props.onTestConnection,
                disabled: disabled,
                className: 'u_inlineBlock u_marginLeft pull-right'
              })
            )
          )
        )
      );
    },

    onValidated: function onValidated(success) {
      this.props.item.isConnectionStringValid = success;
    },

    /**
     * [onResetConnectionString function]
     * is to reset connection string validation value
     */
    onResetConnectionString: function onResetConnectionString() {
      var detail = this.props.item;
      if (detail.isSecured || detail.isDirty) {
        this.props.validation.reset('connectionString');
      }
    },

    /**
     * Display Connection string builder popup that allows user to enter the
     * information of a connection string.
     * @param  {Object} e React-event object
     */
    showConnectionStringBuilder: function showConnectionStringBuilder(e) {
      e.preventDefault();
      if (!this.props.item.visible === true) {
        return;
      }

      var applyConnectionString = function applyConnectionString(connectionString) {
        var item = this.props.store.item;
        item.setConnectionString(connectionString);
        return true;
      }.bind(this);

      var dbTypeList = this.props.dbTypeList;
      var serverTypeId = this.props.item.serverTypeId;
      var serverTypeName = findLast({ id: serverTypeId }, dbTypeList).name;

      return this.props.openPopup(ConnectionStringBuilder, {
        onOk: applyConnectionString.bind(this),
        serverType: serverTypeName
      });
    }
  });

  module.exports = connect()(ConnectionDetail);
}();

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectButton.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ConnectButton component
 */
!function () {
  "use strict";

  var React = __webpack_require__(0);
  var Span = __webpack_require__(1148);
  var Icon = __webpack_require__(314);

  var ConnectButton = React.createClass({
    displayName: 'ConnectButton',

    propTypes: {
      onConnectButtonClick: React.PropTypes.func.isRequired,
      connectBtnLabel: React.PropTypes.string
    },

    render: function render() {
      return React.createElement(
        'section',
        { className: 'section-connect' },
        React.createElement(
          'div',
          { className: 'btn btn-primary u_marginBottom u_fullWidth',
            onClick: this.props.onConnectButtonClick,
            disabled: this.props.disabled },
          React.createElement(
            Span,
            { className: 'no-padding-left-right' },
            this.props.connectBtnLabel
          ),
          React.createElement(Icon, { className: 'icon-flash' })
        )
      );
    }
  });

  module.exports = ConnectButton;
}();

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTreeContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSourceTreeContainer component
 */
!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var connectionConstants = __webpack_require__(197);
  var DataSourceTree = __webpack_require__(2275);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;
  /**
   * Selection data source tree that shows available and selected query source
   * in two data source tree UI.
   */


  var DataSourceTreeContainer = React.createClass({
    displayName: 'DataSourceTreeContainer',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },
    render: function render() {
      var props = this.props;
      var store = this.props.store;
      var item = this.props.item;
      var localization = props.localization;

      if (isEmpty(item.dbSource)) {
        return null;
      }
      var className = classnames('row', 'datasource-container', { 'disabled-elm': props.disabled });
      return React.createElement(
        'div',
        { className: className },
        React.createElement(
          'label',
          { className: 'col-md-12' },
          connectionConstants.GUIDECONTENT
        ),
        React.createElement(
          'div',
          { className: 'col-md-6' },
          React.createElement(DataSourceTree, {
            store: store,
            tree: item.availableQuerySourceTree,
            showSelected: false,
            title: localization.getText('CONNECTION_AVAILABLE_DATA_SOURCE')
          })
        ),
        React.createElement(
          'div',
          { className: 'col-md-6' },
          React.createElement(DataSourceTree, {
            store: store,
            tree: item.selectedQuerySourceTree,
            showSelected: true,
            title: localization.getText('CONNECTION_VISIBLE_DATA_SOURCE')
          })
        )
      );
    }
  });

  module.exports = connect()(DataSourceTreeContainer);
}();

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTree.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSourceTree component
 */
!function () {
  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);
  var connect = __webpack_require__(2);
  var TreeView = __webpack_require__(172);

  var Panel = __webpack_require__(28);
  var DataSourceTreeItem = __webpack_require__(2276);
  var Input = __webpack_require__(17);

  var _require = __webpack_require__(1),
      get = _require.get,
      includes = _require.includes,
      has = _require.has,
      filter = _require.filter;

  function searchBox(tree, localization) {
    var notifyChange = EventUtils.notifyChange;
    return React.createElement(
      'div',
      { className: 'search-box' },
      React.createElement(
        'div',
        { className: 'input-group col-md-12' },
        React.createElement(Input, {
          type: 'text',
          className: 'form-control',
          placeholder: localization.getText('COMMON_PLACEHOLDER_SEARCH'),
          value: tree.filter,
          onChange: notifyChange(tree.setFilter.bind(tree), EventUtils.INPUT)
        })
      )
    );
  }

  var DataSourceTree = React.createClass({
    displayName: 'DataSourceTree',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      tree: React.PropTypes.object.isRequired,
      title: React.PropTypes.string.isRequired,
      showSelected: React.PropTypes.bool
    },
    render: function render() {
      var props = this.props;
      var store = props.store;
      var tree = props.tree;
      var showSelected = props.showSelected;
      var localization = props.localization;

      var header = {
        title: this.props.title,
        className: 'title',
        icon: showSelected ? 'icon-eye' : 'icon-menu'
      };

      return React.createElement(
        Panel,
        { header: header, className: 'datasource-tree u_noMarginAll' },
        searchBox(tree, localization),
        React.createElement(
          'div',
          { className: 'datasource-tree-wraper' },
          React.createElement(TreeView, {
            nodes: tree.root.childNodes,
            getChildNodes: this.getChildNodes,
            renderNode: this.renderNode,
            getKey: get('id'),
            nodeExpand: this.isSingleSchemaExpandNode
          })
        )
      );
    },
    renderNode: function renderNode(node, toggleIcon) {
      var props = this.props;
      var store = props.store;
      var tree = props.tree;
      var showSelected = props.showSelected;

      return React.createElement(DataSourceTreeItem, {
        key: node.id,
        node: node,
        store: store,
        filter: tree.filter,
        showSelected: showSelected,
        toggleIcon: toggleIcon
      });
    },

    isSingleSchemaExpandNode: function isSingleSchemaExpandNode(node) {
      var props = this.props;
      var tree = props.tree;
      var isMultipleSchemas = tree.root.childNodes.length > 1;
      if (!isMultipleSchemas) {
        return includes(node, tree.root.childNodes);
      }
      return false;
    },

    getChildNodes: function getChildNodes(node) {
      var props = this.props;
      var showSelected = props.showSelected;
      var select = function select(node) {
        return !has('selected', node.dataSource) || node.dataSource.selected === showSelected;
      };
      return filter(select, node.childNodes);
    }
  });

  module.exports = connect()(DataSourceTree);
}();

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTreeItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSourceTreeItem component
 */
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);

  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);
  var constants = __webpack_require__(197);

  var TextHighLight = __webpack_require__(62);

  var _require = __webpack_require__(1),
      has = _require.has,
      some = _require.some,
      cond = _require.cond,
      matches = _require.matches,
      constant = _require.constant,
      isNil = _require.isNil,
      filter = _require.filter;

  var DataSourceTreeItem = React.createClass({
    displayName: 'DataSourceTreeItem',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      node: React.PropTypes.object.isRequired,
      filter: React.PropTypes.string,
      showSelected: React.PropTypes.bool,
      toggleIcon: React.PropTypes.element
    },
    render: function render() {
      var node = this.props.node;
      var dataSource = node.dataSource;
      var filterString = this.props.filter;
      var showSelected = this.props.showSelected;
      var toggleIcon = this.props.toggleIcon;

      var containerClasses = classnames({
        'disabled-elm': isEmptyGroup(node)
      });
      var textClasses = classnames('u_curPointer', {
        'tree-item': !node.isTypeGroup()
      });
      var childCount = node.childCount(function (child) {
        return !has('selected', child.dataSource) || child.dataSource.selected === showSelected;
      });

      function isEmptyGroup(node) {
        return node.isTypeGroup() && childCount === 0;
      }

      function showNumChildren(node, count) {
        if (node.isTypeGroup() && node.childNodes) {
          return React.createElement(
            'span',
            null,
            ' (',
            count,
            ')'
          );
        }
        return null;
      }

      // function showToggleTriangle (node) {
      //   if (node.isTypeGroup && childCount > 0) {
      //    return (<i
      //     className='icon-toggle-triangle'
      //     onClick={toggle} />)
      //   }
      //   return null;
      // }

      return React.createElement(
        'div',
        { className: containerClasses, key: node.id },
        React.createElement(
          'label',
          {
            className: textClasses,
            key: node.id,
            disabled: isEmptyGroup(node) ? 'disabled' : null,
            onClick: this.onClick
          },
          React.createElement(TextHighLight, { highlight: filterString, text: node.name }),
          showNumChildren(node, childCount),
          renderChangesIcon(node, childCount)
        ),
        toggleIcon
      );

      /**
       * Render changes icon for data sources
       * @param  {QuerySourceNode} node
       * @param  {Number} childCount Child Nodes count
       */
      function renderChangesIcon(node, childCount) {
        var hasChangesIcon = '';

        // render changes icon for TypeGroup (Table/View/SP/Function) level
        if (node.isTypeGroup() && node.childNodes) {
          hasChangesIcon = filterPhysicalChanges(node).length > 0 ? React.createElement('span', { className: 'icon-attention warning-color', title: constants.DATA_SOURCE_CHANGES }) : '';
        } else if (childCount > 0) {
          // render changes icon for DB level
          var change = some(function (type) {
            return filterPhysicalChanges(type).length > 0;
          }, node.childNodes);

          if (change) {
            hasChangesIcon = React.createElement('span', { className: 'icon-attention warning-color', title: constants.DATA_SOURCE_CHANGES });
          }
        } else {
          hasChangesIcon = renderChangesIconForField(node);
        }
        return hasChangesIcon;
      }

      /**
       * render changes icon for field level
       * @param  {QuerySourceNode} node
       */
      function renderChangesIconForField(node) {
        var isNew = checkChangedStatus(node.approval, node.change, constants.DETECTED_CHANGE_LEVEL.ADDED);
        var isEdit = checkChangedStatus(node.approval, node.change, constants.DETECTED_CHANGE_LEVEL.MODIFIED);
        var isDelete = checkChangedStatus(node.approval, node.change, constants.DETECTED_CHANGE_LEVEL.DELETED);

        var className = classnames({
          'icon-fields success-color': isNew,
          'icon-attention warning-color': isEdit,
          'icon-fields fail-color': isDelete
        });

        var title = cond([[matches({ isNew: true }), constant(constants.NEW_DATA_SOURCE)], [matches({ isEdit: true }), constant(constants.DATA_SOURCE_CHANGES)], [matches({ isDelete: true }), constant(constants.DELETED_DATA_SOURCE)]])({ isNew: isNew, isEdit: isEdit, isDelete: isDelete });

        return React.createElement('span', { className: className, title: title });
      }

      /**
       * filter physical changes base on approval/change/selected
       * @param  {QuerySourceNode} node
       */
      function filterPhysicalChanges(node) {
        return filter(function (o) {
          return (isNil(o.approval) || o.approval < 1) && o.change && o.change !== constants.DETECTED_CHANGE_LEVEL.NONE && o.selected == showSelected;
        }, node.childNodes);
      }

      function checkChangedStatus(approval, change, changeLevel) {
        return (isNil(approval) || approval < 1) && change === changeLevel;
      }
    },

    /**
     * Handle toggle selection of a query source.
     * @param  {Object} e React-event object
     */
    onClick: function onClick(e) {
      var props = this.props;
      var item = props.store.item;
      var localization = props.localization;
      var confirmFn = props.confirmFn;
      var showSelected = props.showSelected;
      var node = props.node;
      var dataSource = node.dataSource;

      var toggleSelected = function toggleSelected() {
        if (node.toggleSelect(showSelected)) {
          item.markDirty();
          item.markAvailableDataSourceChange();
        }
      };

      if (dataSource.group) {
        var needMessagePopup = some({
          selected: showSelected,
          disabled: true
        }, dataSource.querySources);
        needMessagePopup ? confirmFn('Confirmation', {
          description: localization.getText('CONNECTION_CAN_NOT_MOVE_CUSTOM_VIEW'),
          showCancel: false
        }).then(toggleSelected) : toggleSelected();
      } else if (dataSource.disabled) {
        confirmFn('Information', {
          type: 'error',
          description: localization.getText('CONNECTION_CAN_NOT_MOVE_CUSTOM_VIEW'),
          showCancel: false,
          showCloseIndicator: true
        });
      } else {
        toggleSelected();
      }
    }
  });

  module.exports = connect()(DataSourceTreeItem);
}();

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Connection List component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var EventUtils = __webpack_require__(24);

  var ScrollBox = __webpack_require__(27);
  var SearchTextBox = __webpack_require__(107);
  var List = __webpack_require__(195);
  var ConnectionItem = __webpack_require__(2278);
  var compare = __webpack_require__(422);

  var notifyChange = EventUtils.notifyChange;
  var notify = EventUtils.notify;

  var ConnectionList = React.createClass({
    displayName: 'ConnectionList',

    propTypes: {
      isMiddlePanelMinimum: React.PropTypes.bool,
      store: React.PropTypes.object.isRequired
    },
    getDefaultProps: function getDefaultProps() {
      return {
        isMiddlePanelMinimum: false
      };
    },

    componentDidMount: function componentDidMount() {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.loadList().finally(loader.endLoading.bind(loader));
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return !compare(nextProps, this.props);
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'izenda-ConnectionList u_fullHeight u-posRelative u-bgWhite' },
        this.getRenderHeaderContent(),
        this.getRenderListConnection()
      );
    },

    getRenderHeaderContent: function getRenderHeaderContent() {
      var props = this.props;
      var store = props.store;
      var localization = props.localization;

      return React.createElement(
        'div',
        { className: 'izenda-MiddlePanel-search' },
        React.createElement(
          'a',
          {
            className: 'u_block overflow-text',
            onClick: this.addNewConnection,
            title: localization.getText("CONNECTION_LABEL_ADD_CONNECTION") },
          React.createElement('span', { className: 'icon-plus' }),
          localization.getText("CONNECTION_LABEL_ADD_CONNECTION")
        ),
        React.createElement(
          'div',
          { className: 'search-box' },
          React.createElement(SearchTextBox, { value: store.filter,
            onChange: notifyChange(store.setFilter.bind(store), EventUtils.INPUT),
            onKeyPress: this.selectSearchedConnection })
        ),
        React.createElement('hr', null)
      );
    },

    getRenderListConnection: function getRenderListConnection() {
      var isMiddlePanelMinimum = this.props.isMiddlePanelMinimum;
      var store = this.props.store;

      return React.createElement(
        'div',
        { className: 'izenda-ConnectionList-content izenda-MiddlePanel-content' },
        React.createElement(
          ScrollBox,
          null,
          React.createElement(
            List,
            { itemClass: 'connection-string-item' },
            store.filteredConnections.map(function (item, idx) {
              return React.createElement(ConnectionItem, {
                key: idx,
                dataSource: item,
                store: store,
                isMiddlePanelMinimum: isMiddlePanelMinimum });
            })
          )
        )
      );
    },

    /**
     * When there is only one item in searched connection list, user can press enter
     * to select it.
     * @param  {Object} event React-event
     */
    selectSearchedConnection: function selectSearchedConnection(event) {
      if (event.key === 'Enter') {
        var store = this.props.store;
        if (store.filteredConnections.length === 1) {
          store.item = store.filteredConnections[0];
        }
      }
    },

    /**
     * Add a new connection. New connection detail is showed.
     */
    addNewConnection: function addNewConnection() {
      this.props.store.filter = '';
      this.props.store.addConnection();
    }
  });

  module.exports = connect()(ConnectionList);
}();

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Connection Item component
 */
!function () {
  var React = __webpack_require__(0);
  var action = __webpack_require__(5).action;

  var classnames = __webpack_require__(11);
  var constants = __webpack_require__(197);

  var uiState = __webpack_require__(15);

  var TextHighLight = __webpack_require__(62);
  var connect = __webpack_require__(2);

  var ConnectionItem = React.createClass({
    displayName: 'ConnectionItem',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      dataSource: React.PropTypes.object.isRequired,
      isMiddlePanelMinimum: React.PropTypes.bool.isRequired
    },

    onToggleVisibility: function onToggleVisibility(e) {
      e.stopPropagation();
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var dataSource = this.props.dataSource;

      var message = this.props.dataSource.visible ? constants.VISIBLE_MESSAGE : constants.INVISIBLE_MESSAGE;

      props.confirmFn('Confirmation', {
        description: message
      }).then(loader.startLoading.bind(loader)).then(function () {
        return store.updateToggleVisibility(dataSource);
      }).finally(loader.endLoading.bind(loader));
      return false;
    },

    onDelete: function onDelete(e) {
      var props = this.props;
      var loader = props.loader;

      e.stopPropagation();
      props.confirmFn('Confirmation', {
        description: constants.DELETE_MESSAGE
      }).then(loader.startLoading.bind(loader)).then(function () {
        return props.store.deleteConnection(props.dataSource);
      }).finally(loader.endLoading.bind(loader));
    },

    onSelect: function onSelect(e) {
      e.stopPropagation();
      var store = this.props.store;
      var dataSource = this.props.dataSource;
      var loader = this.props.loader;
      var setConnection = action('setConnection', function () {
        store.item = dataSource;
      });

      // Only re-select a current item when it's actually differrent regarding to
      // its id value.
      if (store.item.id != dataSource.id) {
        this.props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(setConnection);
      }
    },

    render: function render() {
      var dataSource = this.props.dataSource;
      var selectedId = this.props.store.item.id;
      var filter = this.props.store.filter;
      var localization = this.props.localization;

      var selectedClass = classnames('truncate', 'overflow-text', {
        selected: dataSource.id === selectedId
      });

      var serverTypeNameClasses = classnames('pull-left', {
        hidden: this.props.isMiddlePanelMinimum
      });

      var iconClasses = classnames('white-space-normal', {
        'icon-eye': dataSource.visible,
        'icon-eye-off': !dataSource.visible
      }, 'pull-right');

      var detectChangesIcon = dataSource.change !== constants.DETECTED_CHANGE_LEVEL.NONE ? React.createElement('span', {
        className: 'icon-attention warning-color pull-left',
        title: localization.getText('CONNECTION_DETECT_CHANGE_ICON_TOOLTIP')
      }) : '';
      var tooltip = '';
      tooltip = tooltip.concat('[', dataSource.serverTypeName, '] ', dataSource.name);
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: selectedClass, onClick: this.onSelect },
          React.createElement(
            'strong',
            { className: serverTypeNameClasses },
            '[',
            dataSource.serverTypeName,
            ']\xA0'
          ),
          React.createElement(TextHighLight, {
            className: 'pull-left connection-string-name',
            highlight: filter,
            text: dataSource.name,
            tooltip: tooltip
          }),
          detectChangesIcon,
          React.createElement('span', { className: 'icon-cancel pull-right white-space-normal', onClick: this.onDelete }),
          React.createElement('span', { className: iconClasses, onClick: this.onToggleVisibility })
        )
      );
    }
  });

  module.exports = connect()(ConnectionItem);
}();

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var dataFetcher = __webpack_require__(616);
  var uiState = __webpack_require__(15);
  var constants = __webpack_require__(197);

  var Connections = __webpack_require__(2280);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      isNil = _require.isNil,
      create = _require.create,
      head = _require.head,
      escapeRegExp = _require.escapeRegExp,
      findIndex = _require.findIndex,
      find = _require.find;

  function ConnectionStore() {
    var observable = {
      // A filtered connection list that matches the filter string
      filteredConnections: function filteredConnections() {
        var filterRegex = new RegExp(escapeRegExp(this.filter), 'i');
        var match = function match(item) {
          return filterRegex.test(item.name);
        };
        return filter(match, this.list);
      },
      tenantId: function tenantId() {
        return uiState.getTenantId();
      }
    };

    Connections.call(observable);

    // Extend the store from connections model and make it observable
    m.extendObservable(this, observable);

    this.dispose = m.observe(this.list, function () {
      // Move current connection to next eligible connection in the list
      // whenever the list changed.
      this.nextConnection(this.item ? this.item.id : null);
    }.bind(this));

    // whenever uiState changed the tenant.
    this.disposeChangeTenant = m.observe(uiState, 'tenantId', function (change) {
      this.addConnection();
      this.loadList(change);
    }.bind(this));
  }
  ConnectionStore.prototype = create(Connections.prototype, {
    constructor: ConnectionStore
  });

  /**
   * Move to next eligible connection in showing list.
   */
  ConnectionStore.prototype.nextConnection = m.action(function (startId) {
    if ((isNil(this.item) || isNil(this.item.id)) && isNil(startId)) {
      if (isEmpty(this.list)) {
        // Case of intial loading the empty list, a new connection detail is active
        // in order to allow adding new connection.
        this.addConnection();
      } else {
        // Case of first loading (active item is undefined), move to first connection
        var firstItem = head(this.list);
        this.item = firstItem;
      }
    } else if (this.item.id !== startId) {
      var next = find(['id', startId], this.filteredConnections) || find(['id', startId], this.list);
      if (isNil(next)) {
        this.addConnection();
      } else {
        this.item = next;
      }
    } else if (this.tenantId) {
      // In case of when change tenant then get the first value of list connection string
      var _firstItem = head(this.list);
      isNil(_firstItem) ? this.addConnection() : this.item = _firstItem;
    }
  });

  /**
   * Load all connections and supported db types from API
   * @return {Promise} A promise of loading connection list
   */
  ConnectionStore.prototype.loadList = m.action(function (tenantId) {
    var store = this;
    var tenant = isEmpty(tenantId) ? this.tenantId : tenantId;
    return (0, _bluebird.join)(dataFetcher.getAllConnectionString(tenant), dataFetcher.getSupportedDatabaseType(), m.action(function (connectionList, dbTypeList) {
      // Defer notifying changes until reading finished
      store.readDbTypeList(dbTypeList);
      store.readConnectionList(connectionList);
      return null;
    })).then(function () {
      if (isEmpty(store.list)) {
        store.addConnection();
      }
    });
  });

  /**
   * Update toggled visibility of connection item
   * @param  {connectionDetail} item
   */
  ConnectionStore.prototype.updateToggleVisibility = m.action(function (item) {
    var updateVisibility = item.visible ? dataFetcher.invisible : dataFetcher.visible;

    return updateVisibility(item.id).then(m.action(function () {
      uiState.increaseDetectChangeVisibleConnection();
      item.toggleVisibility();
      return (0, _bluebird.resolve)();
    }));
  });

  /**
   * Delete a connection. Side effect of deletion is moving selected item
   * in the list to next one.
   * @param  {Object} delItem Deleted connection
   * @param  {Promise} A promise of deletion
   */
  ConnectionStore.prototype.deleteConnection = m.action(function (delItem) {
    // Find next available connection in the list by round-robin ordering pattern
    var findNextId = function findNextId(availableList, fullList, current) {
      function nextEligible(list) {
        if (delItem.id === current.id && list.length > 1) {
          var index = findIndex(['id', delItem.id], list);
          // If deleted item is the last item, then take first one, but the next one.
          return index === list.length - 1 ? list[0].id : list[index + 1].id;
        } else if (delItem.id !== current.id) {
          return current.id;
        }
        return null;
      }

      return nextEligible(availableList) || nextEligible(fullList);
    };

    return dataFetcher.delete(delItem.id).then(function () {
      var store = this;
      m.transaction(function () {
        uiState.increaseDetectChangeVisibleConnection();
        // Select next item in filtered connection list
        var nextId = findNextId(store.filteredConnections, store.list, store.item);
        store.nextConnection(nextId);

        // Delete connection detail instance in the list
        var idx = findIndex(['id', delItem.id], store.list);
        store.list.splice(idx, 1);
      });
      return null;
    }.bind(this)).then(function () {
      // only notify ContextMenu if this connection has changes
      if (delItem.change !== constants.DETECTED_CHANGE_LEVEL.NONE) {
        uiState.increaseDetectChangeCount();
      }
    });
  });

  /**
   * Add a new connection to list.
   * @param {Object} connectionDetail Added connection
   */
  ConnectionStore.prototype.addConnectionToList = m.action(function (connectionDetail) {
    this.list.push(connectionDetail);
  });

  module.exports = ConnectionStore;
}();

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.Connections.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var ConnectionDetail = __webpack_require__(2281);
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      map = _require.map;

  function Connections() {
    var props = {
      item: new ConnectionDetail(),
      list: [],
      filter: '',
      dbTypeList: []
    };

    m.extendObservable(this, props);
  }

  /**
   * Set new filter value for connection list.
   * @param {string} newFilter Searching text
   */
  Connections.prototype.setFilter = function (newFilter) {
    this.filter = newFilter || '';
  };

  /**
   * Read connection list and map connection data to connection detail instance.
   * That keeps all item in list will be instance of connection detail. It also
   * updates the observable connection list, then the UI will be updated accordingly.
   * @param  {Array} connList Array of connection list that returned from API
   */
  Connections.prototype.readConnectionList = m.action(function (connList) {
    // Populate connection detail item instance from its data
    var createConnectionDetail = function createConnectionDetail(itemData) {
      var item = new ConnectionDetail();
      item.readDetail(itemData);
      return item;
    };

    // Clean current list and append new connection list
    this.list.replace(map(createConnectionDetail, connList));
  });

  /**
   * Read database type list. It provides list of db type options to connection
   * detail UI. It will reload full database type list in current store.
   * @param  {Array} dbTypeList The database type list that returns from API
   */
  Connections.prototype.readDbTypeList = m.action(function (dbTypeList) {
    // Clean current list and append new database type list
    this.dbTypeList.replace(dbTypeList);
  });

  /**
   * Add new connection and mark it as selected item.
   */
  Connections.prototype.addConnection = m.action(function (id) {
    this.item = new ConnectionDetail();
    this.item.id = id;

    return (0, _bluebird.resolve)(this.item);
  });

  module.exports = Connections;
}();

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2282);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(197);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(37);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ConnectionDetail = (_dec = (0, _mobx.action)('readDetail'), _dec2 = (0, _mobx.action)('readDbSource'), _dec3 = (0, _mobx.action)('setConnectionStringStatus'), _dec4 = (0, _mobx.action)('setConnectionString'), _dec5 = (0, _mobx.action)('setName'), _dec6 = (0, _mobx.action)('setServerTypeId'), (0, _Izenda2.default)(_class = (_class2 = function () {
  function ConnectionDetail() {
    (0, _classCallCheck3.default)(this, ConnectionDetail);

    _initDefineProp(this, 'id', _descriptor, this);

    _initDefineProp(this, 'connectionString', _descriptor2, this);

    _initDefineProp(this, 'previousConnectionStringHasDataSource', _descriptor3, this);

    _initDefineProp(this, 'name', _descriptor4, this);

    _initDefineProp(this, 'serverTypeId', _descriptor5, this);

    _initDefineProp(this, 'serverTypeName', _descriptor6, this);

    _initDefineProp(this, 'visible', _descriptor7, this);

    _initDefineProp(this, 'isSelected', _descriptor8, this);

    _initDefineProp(this, 'change', _descriptor9, this);

    _initDefineProp(this, 'dbSource', _descriptor10, this);

    _initDefineProp(this, 'connectionStringChanged', _descriptor11, this);

    _initDefineProp(this, 'isNewConnectionStringWithoutUpdateDataSource', _descriptor12, this);

    _initDefineProp(this, 'isCurrentConnectionStringSameAsSavedConnectionString', _descriptor13, this);

    _initDefineProp(this, 'isConnectionStringValid', _descriptor14, this);

    _initDefineProp(this, 'isAvailableDataSourceChange', _descriptor15, this);

    _initDefineProp(this, 'alertMessage', _descriptor16, this);
  } // default is MSSQL


  (0, _createClass3.default)(ConnectionDetail, [{
    key: 'readDetail',
    value: function readDetail(detail) {
      this.id = detail.id;
      this.connectionString = detail.connectionString;
      this.name = detail.name;
      this.serverTypeId = detail.serverTypeId;
      this.visible = detail.visible;
      this.change = detail.physicalChange;
      this.isConnectionStringValid = !!detail.id;
      this.connectionStringChanged = false;

      if (detail.serverTypeName) {
        this.serverTypeName = detail.serverTypeName;
      }
      this.resetDirty();
      this.resetAvailableDataSourceChange();
    }
  }, {
    key: 'resetAvailableDataSourceChange',
    value: function resetAvailableDataSourceChange() {
      this.isAvailableDataSourceChange = false;
    }
  }, {
    key: 'markAvailableDataSourceChange',
    value: function markAvailableDataSourceChange() {
      this.isAvailableDataSourceChange = true;
    }

    /**
     * Read data sources (mostly this data comes from API)
     * @param  {Object} dbSource
     */

  }, {
    key: 'readDbSource',
    value: function readDbSource(dbSource) {
      var querySources = dbSource && (0, _fp.forEach)(function (schema) {
        schema.querySources = (0, _fp.filter)(function (detail) {
          return !(detail.type === _Izenda6.default.QUERY_SOURCE_TYPE.VIEW && detail.isCustomQuerySource);
        }, schema.querySources);
      }, dbSource.querySources);
      this.dbSource = querySources || [];
      this.isNewConnectionStringWithoutUpdateDataSource = false;

      //for new item copy current connection to previous connection for test
      this.isNew && this.saveCurrentToPreviousConnectionStringHasDataSource();

      this.resetAvailableDataSourceChange();
    }

    /**
     * Reset status when load saved connection
     */

  }, {
    key: 'setConnectionStringStatus',
    value: function setConnectionStringStatus() {
      this.isCurrentConnectionStringSameAsSavedConnectionString = true;
      this.isNewSchemaMatchPrevious = true;
    }

    /**
     * Set previous connection string that alreay connect
     */

  }, {
    key: 'saveCurrentToPreviousConnectionStringHasDataSource',
    value: function saveCurrentToPreviousConnectionStringHasDataSource() {
      this.previousConnectionStringHasDataSource = this.connectionString;
    }

    /**
     * Read test result to know new connection is the same as saved connection string
     * @param  {Object} result receive from api
     */

  }, {
    key: 'readTestResult',
    value: function readTestResult(result) {
      this.isCurrentConnectionStringSameAsSavedConnectionString = this.isNew || !result.differentDatabase;
    }

    /**
     * Read test result to know new connection is the same schema as saved connection
     * @param  {Boolean} result receive from api
     */

  }, {
    key: 'readStatusValidateSchema',
    value: function readStatusValidateSchema(result) {
      this.isNewSchemaMatchPrevious = result;
    }

    /**
     * Set new connection string
     * @param {String} val New connection string
     */

  }, {
    key: 'setConnectionString',
    value: function setConnectionString(val) {
      this.connectionStringChanged = this.connectionString != val || (0, _fp.isEmpty)(val);
      this.isConnectionStringValid = !this.connectionStringChanged;
      this.isNewConnectionStringWithoutUpdateDataSource = true;
      this.isCurrentConnectionStringSameAsSavedConnectionString = false;
      this.isNewSchemaMatchPrevious = false;
      this.connectionString = val;
      this.markDirty();
    }

    /**
     * Toggle visibility of connection
     * @return {[type]} [description]
     */

  }, {
    key: 'toggleVisibility',
    value: function toggleVisibility() {
      this.visible = !this.visible;
    }

    /**
     * Set new connection name
     * @param {String} val New connection name value
     */

  }, {
    key: 'setName',
    value: function setName(val) {
      this.name = val;
      this.markDirty();
    }

    /**
     * Mark connection string is valid or not.
     * @param {Boolean} isValid
     */

  }, {
    key: 'setConnectionStringValid',
    value: function setConnectionStringValid(isValid) {
      this.isConnectionStringValid = isValid;
    }

    /**
     * Set database server type id.
     * @param {String} val New database server type id (UUID string)
     */

  }, {
    key: 'setServerTypeId',
    value: function setServerTypeId(val) {
      this.serverTypeId = val;
      this.markDirty();
    }
  }, {
    key: 'setChange',
    value: function setChange(val) {
      this.change = val;
    }

    /**
     * Return data object that represents for a connection. It consists only
     * selected query source object.
     */

  }, {
    key: 'getData',
    value: function getData(forValidation) {
      var take = function take(source) {
        return !forValidation && (!(0, _fp.has)('selected', source) || source.selected);
      };
      var getSelectedChild = function getSelectedChild(querySource) {
        var children = querySource.querySources;
        var restProps = (0, _fp.omit)('querySources', querySource);
        return (0, _fp.assign)(restProps, {
          querySources: children ? (0, _fp.flow)((0, _fp.filter)(take), (0, _fp.map)(getSelectedChild))(children) : null
        }, {});
      };
      var querySources = (0, _mobx.toJS)((0, _fp.flow)((0, _fp.filter)(take), (0, _fp.map)(getSelectedChild))(this.dbSource));

      return {
        id: this.id,
        name: this.name,
        serverTypeId: this.serverTypeId,
        connectionString: this.connectionString,
        visible: this.visible,
        dBSource: {
          querySources: (0, _fp.isEmpty)(querySources) ? [] : querySources
        }
      };
    }
  }, {
    key: 'setAlertMessage',
    value: function setAlertMessage(newAlertMessage) {
      this.alertMessage = newAlertMessage;
    }
  }, {
    key: 'isConnectionStringReady',

    //Derived state props
    get: function get() {
      return this.visible && !(0, _fp.isEmpty)(this.connectionString) && this.isConnectionStringValid;
    }
  }, {
    key: 'isSecured',
    get: function get() {
      return this.isConnectionStringValid;
    }
  }, {
    key: 'securedConnectionString',
    get: function get() {
      return this.isSecured ? _Izenda6.default.CONNECTION_STRING_HASH : this.connectionString;
    }
  }, {
    key: 'availableQuerySourceTree',
    get: function get() {
      return new _Izenda4.default(this.dbSource);
    }
  }, {
    key: 'selectedQuerySourceTree',
    get: function get() {
      return new _Izenda4.default(this.dbSource);
    }
  }, {
    key: 'isNew',
    get: function get() {
      return !this.id;
    }
  }, {
    key: 'haveDataSource',
    get: function get() {
      return !(0, _fp.isEmpty)(this.dbSource);
    }
  }, {
    key: 'needConfirmMessageForAvailableDatasouceChange',
    get: function get() {
      return !this.isNew && this.isAvailableDataSourceChange;
    }
  }, {
    key: 'needConfirmWhenLeaving',
    get: function get() {
      return this.isDirty && this.visible;
    }
  }, {
    key: 'canSave',
    get: function get() {
      return this.isDirty || this.change !== 0;
    }
  }, {
    key: 'notNeedToValidateSchema',
    get: function get() {
      //don't have data souce or already click connect
      // or new connection string is match with previous connection string already load datasource
      return !this.haveDataSource || !this.connectionStringChanged || !this.isNewConnectionStringWithoutUpdateDataSource || this.isNew && this.connectionString === this.previousConnectionStringHasDataSource || this.isCurrentConnectionStringSameAsSavedConnectionString || this.isNewSchemaMatchPrevious;
    }
  }, {
    key: 'needReloadDetectChange',
    get: function get() {
      return !this.isNew && (this.isCurrentConnectionStringSameAsSavedConnectionString || !this.connectionStringChanged);
    }

    /**
     * Connection detail validation constraints
     * @type {Object}
     */

  }], [{
    key: 'constraints',
    get: function get() {
      return {
        name: _Izenda6.default.DATABASE_NAME_CONSTRAINT,
        connectionString: _Izenda6.default.CONNECTION_STRING_CONSTRAINT
      };
    }

    /**
     * Read connection detail data (mostly this data comes from API).
     * @param  {Object} detail
     */

  }]);
  return ConnectionDetail;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'connectionString', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'previousConnectionStringHasDataSource', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'serverTypeId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda6.default.SERVER_TYPE.MSSQL;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'serverTypeName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'visible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'isSelected', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'change', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'dbSource', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'connectionStringChanged', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'isNewConnectionStringWithoutUpdateDataSource', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'isCurrentConnectionStringSameAsSavedConnectionString', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'isConnectionStringValid', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'isAvailableDataSourceChange', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'alertMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda8.default.EMPTY_MESSAGE;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'isConnectionStringReady', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isConnectionStringReady'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isSecured', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isSecured'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'securedConnectionString', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'securedConnectionString'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'availableQuerySourceTree', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'availableQuerySourceTree'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'selectedQuerySourceTree', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'selectedQuerySourceTree'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isNew', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isNew'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'haveDataSource', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'haveDataSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'needConfirmMessageForAvailableDatasouceChange', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'needConfirmMessageForAvailableDatasouceChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'needConfirmWhenLeaving', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'needConfirmWhenLeaving'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'canSave', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'canSave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'notNeedToValidateSchema', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'notNeedToValidateSchema'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'needReloadDetectChange', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'needReloadDetectChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readDetail', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readDetail'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readDbSource', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readDbSource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setConnectionStringStatus', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setConnectionStringStatus'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setConnectionString', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setConnectionString'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setName', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setServerTypeId', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setServerTypeId'), _class2.prototype)), _class2)) || _class);
exports.default = ConnectionDetail;
module.exports = exports['default'];

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  // TODO: This list should be collected from API and it varies per database
  // server types.
  var SourceTypes = {
    TABLE: 'Table',
    VIEW: 'View',
    PROCEDURE: 'Stored Procedure',
    FUNCTION: 'Function'
  };

  var _require = __webpack_require__(1),
      has = _require.has,
      isEmpty = _require.isEmpty,
      map = _require.map,
      partition = _require.partition,
      uniqueId = _require.uniqueId,
      escapeRegExp = _require.escapeRegExp,
      concat = _require.concat,
      invoke = _require.invoke,
      matchesProperty = _require.matchesProperty,
      filter = _require.filter,
      values = _require.values,
      placeholder = _require.placeholder;

  /**
   * Check whether query source has name that matches the filter string (non-case
   * sensitive)
   * @param  {String}  filter
   * @return {Boolean} Matched or not
   */


  function isMatchedSource(filterItem) {
    return function (item) {
      var filterRegex = new RegExp(escapeRegExp(filterItem), 'i');
      return !has('type', item) || filterRegex.test(item.name);
    };
  }

  /**
   * Recursively create child nodes of a query source node. It allows to auto-group
   * child nodes by its type.
   * @param  {String} filter                        Name-matching filter string
   * @param  {Boolean} autoGroupByType              Group by query source type
   * @param  {Function} querySourceNodeTransformer  Query source node factory
   * @param  {Array} querySources                   Query source array
   * @return {Array}                                Query source node array
   */
  function createChildNodes(filterItem, autoGroupByType, querySourceNodeTransformer, querySources) {
    var match = isMatchedSource(filterItem);
    var selectSatisfiedSources = filter(match, querySources);
    var childNodes = [];
    var processingSources = selectSatisfiedSources;
    if (autoGroupByType) {
      // Divide query sources into type and non-type category
      // It returns two 2 arrays according to type and non-type category.
      var groups = partition(has('type'), selectSatisfiedSources);
      var typeGroup = groups[0];
      var nonTypeGroup = groups[1];

      if (!isEmpty(typeGroup)) {
        processingSources = nonTypeGroup;

        childNodes = values(SourceTypes).map(function (type) {
          return {
            id: uniqueId(type),
            name: type,
            group: true,
            querySources: filter(function (item) {
              return item.type === type;
            }, typeGroup)
          };
        }).map(querySourceNodeTransformer(filterItem, false));
      }
    }

    var rest = map(querySourceNodeTransformer(filterItem, autoGroupByType), processingSources);

    return concat(childNodes, rest);
  }

  /**
   * Reactive query source -> node transformer
   * @param  {Object} querySource
   * @return {QuerySourceNode}
   */
  var querySourceNodeTransformer = function querySourceNodeTransformer(filterItem, autoGroupByType) {
    return function (querySource) {
      return new QuerySourceNode(filterItem, autoGroupByType, querySource);
    };
    // return m.createTransformer(function (querySource) {
    //    return new QuerySourceNode(filter, autoGroupByType, querySource);
    // });
  };

  /**
   * It is a model of a node in query source tree. It carries the query source
   * instance and relevant UI info.
   * @param {[type]} filter          [description]
   * @param {[type]} autoGroupByType [description]
   * @param {[type]} item            [description]
   */
  function QuerySourceNode(filterItem, autoGroupByType, item) {
    this.dataSource = item;
    this.id = item.id;
    this.name = item.name;
    var props = {
      change: item.physicalChange,
      approval: item.approval,
      selected: item.selected,
      childNodes: function childNodes() {
        return isEmpty(item.querySources) ? [] : createChildNodes(filterItem, autoGroupByType, querySourceNodeTransformer, item.querySources);
      }
    };

    m.extendObservable(this, props);
  }

  /**
   * Toggle selection of current node and its child nodes regarding to
   * the selecting status.
   * @param  {bool} showSelected Only toggle selection of selecting status.
   */
  QuerySourceNode.prototype.toggleSelect = m.action('toggleSelectQuerySource', function (showSelected) {
    var dataSource = this.dataSource;
    if (dataSource.group && this.childNodes) {
      return placeholder(this.childNodes).filter(matchesProperty('dataSource.selected', showSelected)).map(invoke('toggleSelect')).some(Boolean);
    } else if (!dataSource.disabled && has('selected', dataSource)) {
      dataSource.selected = !dataSource.selected;
      return true;
    }
    return false;
  });

  /**
   * Count child nodes that satisfies passing predication.
   * @param  {Function} predicate
   */
  QuerySourceNode.prototype.childCount = function (predicate) {
    return placeholder(this.childNodes).filter(predicate).value().length;
  };

  /**
   * Is typed group node of query source (ie. tables, functions, SPs...)
   * @return {Boolean}
   */
  QuerySourceNode.prototype.isTypeGroup = function () {
    return !!this.dataSource.group;
  };

  /**
   * Tree model of query source. It starts by default root node (id:#root).
   * @param {Array} querySources Query source array
   */
  function QuerySourceTree(querySources) {
    // Only take query sources that satisfies predication
    var props = {
      filter: '',
      root: function root() {
        return querySourceNodeTransformer(this.filter, true)({
          id: '#root',
          name: 'root',
          querySources: querySources
        });
      }
    };

    m.extendObservable(this, props);
  }

  /**
   * Set name-matching filter string for query source tree.
   * Whenever it set, all decendant node's name must satisfy filter string.
   * @param {String} newVal New filter string value.
   */
  QuerySourceTree.prototype.setFilter = function (newVal) {
    this.filter = newVal;
  };

  module.exports = QuerySourceTree;
}();

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionDetailStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      isNil = _require.isNil,
      get = _require.get;

  var m = __webpack_require__(5);
  var dataFetcher = __webpack_require__(616);
  var uiState = __webpack_require__(15);
  var constants = __webpack_require__(197);
  var localizer = __webpack_require__(12);

  /**
   * Call testConnectionString API
   * @param  {ConnectionDetail} connectionDetail
   * @return {Promise} A promise of API invoke
   */
  function testConnectionApi(connectionDetail) {
    var connectionStringRequest = {
      ServerTypeId: connectionDetail.serverTypeId,
      ConnectionString: connectionDetail.connectionString,
      ConnectionId: connectionDetail.id
    };
    return dataFetcher.testConnectionString(connectionStringRequest);
  }

  /**
   * Call validateSchemaApi API
   * @param  {ConnectionDetail} connectionDetail
   * @return {Promise} A promise of API invoke
   */
  function validateSchemaApi(connectionDetail) {
    var connectionStringRequest = connectionDetail.getData(true);
    return dataFetcher.validateSchema(connectionStringRequest);
  }

  /**
   * Call getDatabaseName API
   * @param  {ConnectionDetail} connectionDetail
   * @return {Promise} A promise of API call
   */
  function getDbNameApi(connectionDetail) {
    var getDatabaseNameRequest = {
      ServerTypeId: connectionDetail.serverTypeId,
      ConnectionString: connectionDetail.connectionString
    };

    return dataFetcher.getDatabaseName(getDatabaseNameRequest);
  }

  /**
   * It encapsulates the connection detail app logic (side-effect likes API invoke
   * and UI logic)
   * @class ConnectionDetailStore
   * @param {ConnectionStore} masterStore Connection store
   */
  function ConnectionDetailStore(masterStore) {
    this.masterStore = masterStore;
    this.onInvalidConnectionString = function (msg) {};

    var props = {
      item: function item() {
        return this.masterStore.item;
      },
      dbTypeList: function dbTypeList() {
        return this.masterStore.dbTypeList;
      },
      tenantId: function tenantId() {
        return uiState.getTenantId();
      }
    };

    m.extendObservable(this, props);
  }
  /**
   * link between store and uiState\
   */
  ConnectionDetailStore.prototype.init = m.action(function () {
    uiState.setCheckDirtyFunction(function () {
      return this.item.needConfirmWhenLeaving;
    }.bind(this));
  });

  /**
   * unlink between store and uiState\
   */
  ConnectionDetailStore.prototype.destroy = m.action(function () {
    uiState.resetCheckDirtyFunction();
  });
  /**
   * Load connection data by its id from API
   * @return {Promise} A promise of loading connection data
   */
  ConnectionDetailStore.prototype.load = m.action(function () {
    var store = this;

    var connectionDetail = this.item;
    var setDetailToStore = m.action(function (detail) {
      connectionDetail.setConnectionStringStatus();
      connectionDetail.readDetail(detail);
      return detail;
    });

    if (!isEmpty(connectionDetail.id)) {
      // Only load connection if its id existed.
      return dataFetcher.getConnectionString(connectionDetail.id).then(get('connection')).then(setDetailToStore).then(store.connectToDataSource.bind(store));
    } else {
      // If it is new (its id is emtpy), just read its default detail.
      return (0, _bluebird.resolve)();
      // return store.masterStore.addConnection();
    }
  });

  ConnectionDetailStore.prototype.reloadDetectChanges = m.action(function () {
    var connectionDetail = this.item;
    if (isEmpty(connectionDetail.id)) {
      return;
    }

    var updateChanges = function updateChanges(detail) {
      connectionDetail.setChange(detail.physicalChange);
      uiState.increaseDetectChangeCount();
      return detail;
    };

    // Only load connection if its id existed.
    return dataFetcher.getConnectionString(connectionDetail.id).then(get('connection')).then(updateChanges);
  });

  /**
   * Connect to data source by input connection string in order to getting
   * its database schema including its physical shema changes against previous
   * saved schema.
   * @param  {ConnectionDetail} detail
   * @param  {bool} force  Force re-load data source regardless to its existing one.
   */
  ConnectionDetailStore.prototype.connectToDataSource = m.action(function (detail, force) {
    var isEmptyDataSource = isEmpty(detail.dbSource);
    var needReloadDetectChange = detail.needReloadDetectChange;
    // Retrieve data source from API as current data source is empty or force to do so
    var retrieveDataSource = null;

    if (!isEmptyDataSource && !force) {
      // don't need to call api
      retrieveDataSource = (0, _bluebird.resolve)({
        dBSource: detail.dbSource
      });
    } else {
      // need to call api
      retrieveDataSource = !needReloadDetectChange ? dataFetcher.getRemoteSchema(detail.connectionString, detail.serverTypeId) : dataFetcher.reloadRemoteSchema(detail);
    }

    var updateDbSource = m.action(function (result) {
      if (result.success === false) {
        this.updateErrorMessage(result);
      } else {
        this.item.readDbSource(result.dBSource);
        if ((!isEmptyDataSource || force) && needReloadDetectChange) {
          // reload change to detail & notify changes to contextmenu
          this.reloadDetectChanges();
        }
      }
      return null;
    }.bind(this));

    return retrieveDataSource.then(updateDbSource);
  });

  /**
   * Populate database name by current connection string when user doesn't
   * enter its name.
   * @return {Promise}
   */
  ConnectionDetailStore.prototype.populateDatabaseName = m.action(function () {
    var connectionDetail = this.item;
    return isEmpty(connectionDetail.name) ? getDbNameApi(connectionDetail).then(function (dbName) {
      dbName && connectionDetail.setName(dbName);
      return !isEmpty(dbName);
    }) : (0, _bluebird.resolve)(false);
  });

  /**
   * Validate current connection string
   * @return {Promise}
   */
  ConnectionDetailStore.prototype.validateConnection = function () {
    var connectionDetail = this.item;
    return !connectionDetail.connectionString ? (0, _bluebird.resolve)('') : testConnectionApi(connectionDetail).then(function (result) {
      connectionDetail.readTestResult(result);
      return result.messages;
    }.bind(this)).then(function (errorMessages) {
      var isSuccess = isNil(errorMessages) || isEmpty(errorMessages);
      connectionDetail.setConnectionStringValid(isSuccess);
      return errorMessages;
    });
  };

  ConnectionDetailStore.prototype.validateSchema = function () {
    var connectionDetail = this.item;
    if (connectionDetail.notNeedToValidateSchema) {
      return (0, _bluebird.resolve)(true);
    } else if (connectionDetail.isNew) {
      return (0, _bluebird.resolve)(false);
    }

    return validateSchemaApi(connectionDetail).then(function (success) {
      connectionDetail.readStatusValidateSchema(success);
      return success;
    });
  };

  ConnectionDetailStore.prototype.save = m.action('save', function () {
    var data = this.item.getData();
    data.tenantId = uiState.getTenantId();

    var reloadStoreAfterSaved = m.action(function (result) {
      if (result.success && isEmpty(data.id)) {
        // Get server type short name from the list and assign back to
        // current connection detail in case of adding new connection.
        var serverType = this.dbTypeList.find(function (item) {
          return item.id === data.serverTypeId;
        });
        this.item.serverTypeName = serverType.shortName;
        this.item.id = result.connectionId;
        this.masterStore.addConnectionToList(this.item);
        uiState.increaseDetectChangeVisibleConnection();
      } else {
        /**
         * If this connection has changes:
         *   - Reload datasourcetree
         *   - Reload change to detail
         *   - Notify changes to contextmenu
         */
        if (this.item.change !== constants.DETECTED_CHANGE_LEVEL.NONE) {
          this.connectToDataSource(this.item, true);
        }
      }

      if (result.success) {
        /** in case of add new connection string
         * then re-load to get connection string encryption
         */
        this.load();
        this.masterStore.loadList(uiState.tenantId);
        this.item.resetDirty();
        uiState.increaseDetectChangeCount();
        this.item.resetAvailableDataSourceChange();
        this.item.setAlertMessage({
          type: 'success',
          message: localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED')
        });
      } else {
        this.updateErrorMessage(result);
      }

      return result.messages;
    }.bind(this));

    return dataFetcher.updateConnectionString(data).then(reloadStoreAfterSaved);
  });

  /**
   * update error message
   * @param  {Object} result
   */
  ConnectionDetailStore.prototype.updateErrorMessage = function (result) {
    var messageError = !isEmpty(result.messages) && result.messages[0].key === '' ? result.messages[0].messages[0] : null;
    this.item.setAlertMessage({ type: 'error', message: messageError });
  };

  module.exports = ConnectionDetailStore;
}();

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.DataModel.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Data Model component
 */


var _Izenda = __webpack_require__(198);

var _Izenda2 = __webpack_require__(15);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda4 = __webpack_require__(196);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(334);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(2285);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(213);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(1150);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda14 = __webpack_require__(2);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QUERY_SOURCE_TYPE_STORE_PATH = 'querySourceType';
var RELATIONSHIP_STORE_PATH = 'relationship';
var TABLE_TYPE = 'Table';
var VIEW_TYPE = 'View';
var STORED_PROCEDURE_TYPE = 'Stored Procedure';
var FUNCTION_TYPE = 'Function';

var viewComponents = {
  tables: {
    component: _Izenda9.default,
    storePath: QUERY_SOURCE_TYPE_STORE_PATH,
    props: {
      querySourceType: TABLE_TYPE
    }
  },
  views: {
    component: _Izenda9.default,
    storePath: QUERY_SOURCE_TYPE_STORE_PATH,
    props: {
      querySourceType: VIEW_TYPE
    }
  },
  storeprocedures: {
    component: _Izenda9.default,
    storePath: QUERY_SOURCE_TYPE_STORE_PATH,
    props: {
      querySourceType: STORED_PROCEDURE_TYPE
    }
  },
  functions: {
    component: _Izenda9.default,
    storePath: QUERY_SOURCE_TYPE_STORE_PATH,
    props: {
      querySourceType: FUNCTION_TYPE
    }
  },
  relationship: {
    component: _Izenda13.default,
    storePath: RELATIONSHIP_STORE_PATH
  },

  notFound: {
    component: _Izenda11.default
  }
};

function getComponentInfo(key) {
  return (0, _fp.getOr)(viewComponents.notFound, key, viewComponents);
}

var DataModel = (_dec = (0, _Izenda15.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(DataModel, _Component);

  function DataModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DataModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DataModel.__proto__ || (0, _getPrototypeOf2.default)(DataModel)).call.apply(_ref, [this].concat(args))), _this), _this.changeItem = function (newLink) {
      _this.props.confirmDirtyForm(_Izenda3.default.isDirty, {
        onConfirmDirtyForm: _Izenda3.default.onOkDirtyForm
      }).then(function () {
        _this.props.store.changeSelectItem(newLink);
        // Reset search text
        var info = getComponentInfo(newLink);
        var store = (0, _fp.get)(info.storePath, _this.props.store);
        var pageInfo = store.pageInfo;
        // Only set search value to any page that has search box
        pageInfo && pageInfo.setSearchValues && pageInfo.setSearchValues(_Izenda.DEFAULT_SEARCH_PROPERTY, '');
        return null;
      });
    }, _this.renderChangedIcon = function (_ref2) {
      var backendType = _ref2.backendType;

      var isChange = _this.props.store.loadItemIndicator(backendType) === _Izenda.CHANGED_INDICATOR;
      var className = (0, _classnames2.default)({
        'icon-attention warning-color': isChange
      });

      var title = isChange && _Izenda.DATA_SOURCE_CHANGES;

      return _react2.default.createElement('span', { className: className, title: title });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DataModel, [{
    key: 'componentDidMount',


    /**
     * Handle when componet did mount
     */
    value: function componentDidMount() {
      this.props.store.init();
    }

    /**
     * handle when componentWillunmount
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var store = this.props.store;
      var mainContent = _react2.default.createElement(
        'div',
        { className: 'izenda-TableLayout-Cell' },
        this.renderRightContent()
      );
      var middelPanel = this.props.store.indicator && _react2.default.createElement(
        _Izenda5.default,
        null,
        _react2.default.createElement(_Izenda7.default, {
          dataSource: this.props.store.dataModelMenu,
          activeKey: this.props.store.activeLink,
          enabled: true,
          onSelected: this.changeItem,
          renderChangedIcon: this.renderChangedIcon,
          className: 'izenda-DataModel-Middle'
        })
      );

      return _react2.default.createElement(
        'div',
        { className: 'izenda-TableLayout' },
        middelPanel,
        mainContent
      );
    }

    /**
     * Handle change selected item
     */

  }, {
    key: 'renderRightContent',


    /**
     * Render right content when click middle panel
     */
    value: function renderRightContent() {
      var info = getComponentInfo(this.props.store.activeLink);
      var store = (0, _fp.get)(info.storePath, this.props.store);
      return store ? _react2.default.createElement(info.component, (0, _extends3.default)({}, info.props, { store: store, parentStore: this.props.store })) : _react2.default.createElement(info.component, null);
    }

    /**
     * Render changed icon
     */

  }]);
  return DataModel;
}(_react.Component)) || _class);
exports.default = DataModel;
module.exports = exports['default'];

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceType.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * QuerySourceType component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(30);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(37);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(86);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(147);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(146);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(61);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2286);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2287);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(198);

var _Izenda22 = __webpack_require__(1149);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuerySourceType = (_dec = (0, _Izenda16.default)(_Izenda18.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(QuerySourceType, _Component);

  function QuerySourceType() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, QuerySourceType);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuerySourceType.__proto__ || (0, _getPrototypeOf2.default)(QuerySourceType)).call.apply(_ref, [this].concat(args))), _this), _this.updateQuerySourceType = (0, _mobx.action)(function (querySourceType) {
      var props = _this.props;
      var loader = props.loader,
          store = props.store;


      props.updateLoading(true);
      loader.startLoading();
      store.setQuerySourceType(querySourceType).then(props.updateLoading.bind(props, false)).finally(loader.endLoading.bind(loader));
    }), _this.renderAlertMessage = function () {
      var store = _this.props.store;


      var resetAlertMessageFunc = function resetAlertMessageFunc() {
        store.alertMessage = _Izenda6.default.EMPTY_MESSAGE;
      };

      return store.alertMessage.message && _react2.default.createElement(
        'div',
        { className: 'izenda-Alert-container' },
        _react2.default.createElement(
          _Izenda14.default,
          { type: store.alertMessage.type, onAutoHide: resetAlertMessageFunc },
          store.alertMessage.message
        )
      );
    }, _this.onAddCustomView = function () {
      _this.props.openPopup(_Izenda23.default, { store: _this.props.store });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(QuerySourceType, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.store.init();
      this.updateQuerySourceType(this.props.querySourceType);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.destroy();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var props = this.props;

      if (nextProps.querySourceType !== props.querySourceType) {
        props.store.alertMessage = _Izenda6.default.EMPTY_MESSAGE;
        this.updateQuerySourceType(nextProps.querySourceType);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.querySourceType !== this.props.querySourceType;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = props.store,
          authorization = props.authorization,
          PERMISSION_KEY = props.authorizationConstants.PERMISSION_KEY;

      var isTabView = (0, _fp.get)('parentStore.activeLink', props) === _Izenda21.QUERY_SOURCE_TYPE.VIEW;
      var canAddCustomView = authorization.checkPrivileges([PERMISSION_KEY.DataSetupDataModelCustomViewCreate]);

      return _react2.default.createElement(
        'section',
        { className: 'izenda-Wrapper izenda-QuerySource' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-header' },
          _react2.default.createElement(_Izenda8.default, { className: 'u_marginRightInnerSpace' }),
          this.renderAlertMessage(),
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock' },
            _react2.default.createElement(_Izenda12.default, {
              options: store.getCriteriaList,
              value: store.pageInfo.searchProperty,
              onSearch: props.onSearch,
              searchValue: store.pageInfo.searchText
            })
          ),
          _react2.default.createElement(
            _Izenda10.default,
            { onSave: props.onSave, onCancel: props.onCancel },
            isTabView && canAddCustomView && _react2.default.createElement(_Izenda4.default, { onClick: this.onAddCustomView, label: _Izenda2.default.getText('DATA_MODEL_LABEL_ADD_CUSTOM_VIEW') })
          )
        ),
        _react2.default.createElement(_Izenda20.default, {
          store: props.store,
          querySourceType: props.querySourceType,
          width: props.width,
          height: props.height,
          searchProperty: props.searchProperty,
          searchValue: props.searchValue,
          isNotHighLight: props.isNotHighLight,
          isLoading: props.isLoading
        })
      );
    }
  }]);
  return QuerySourceType;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = QuerySourceType;
module.exports = exports['default'];

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var withState = __webpack_require__(9).withState;
  var withHandlers = __webpack_require__(9).withHandlers;
  var CommonMessages = __webpack_require__(37);
  var querySourceTypeConstants = __webpack_require__(159);
  var uiState = __webpack_require__(15);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var actions = compose(withState('searchProperty', 'updateSearchProperty', 'All'), withState('searchValue', 'updateSearchValue', ''), withState('isLoading', 'updateLoading', true), withHandlers({
    isNotHighLight: curry(isNotHighLight),
    onSave: curry(onSave),
    onSearch: curry(onSearch),
    onCancel: curry(onCancel)
  }));

  function onSave(props, event) {
    var store = props.store;
    var loader = props.loader;
    var valManager = props.validation;

    if (!store.canSave) {
      store.alertMessage = { type: CommonMessages.MESSAGE_TYPE.INFO, message: localizer.getText('COMMON_MESSAGES_NO_CHANGES_FOUND') };
      return;
    }

    var isFieldInvisibleOrUnfilterable = store.isFieldInvisibleOrUnfilterable();
    var savePromise = (0, _bluebird.resolve)();

    if (isFieldInvisibleOrUnfilterable) {
      savePromise = props.confirmFn('Confirmation', {
        description: querySourceTypeConstants.BUNDLE.MESSAGE.MG03
      });
    }

    savePromise.then(function () {
      loader.startLoading();
      store.updateQuerySource().then(function (response) {
        if (!response.success) {
          valManager.reset();
          valManager.updateErrors(response.messages);
        } else {
          // reload right
          store.resetData();
          store.loadQuerySources();
          // reload indicator middle
          props.parentStore.loadIndicator();
          // reload indicator left
          uiState.increaseDetectChangeCount();
          // update alert message
          store.alertMessage = { type: CommonMessages.MESSAGE_TYPE.SUCCESS, message: localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED') };
        }
      }).finally(loader.endLoading.bind(loader));
    }, function () {
      store.reload();
    });
  }

  function onSearch(props, searchProperty, searchText) {
    var store = props.store;
    var loader = props.loader;

    props.updateSearchProperty(searchProperty);
    props.updateSearchValue(searchText);

    return props.confirmDirtyForm(store.hasChange).then(function () {
      loader.startLoading();
      store.search(searchProperty, searchText).finally(loader.endLoading.bind(loader));
    });
  }

  function onCancel(props, event) {
    var store = props.store;
    var loader = props.loader;

    props.confirmDirtyForm(store.hasChange).then(loader.startLoading.bind(loader)).then(store.reload.bind(store)).finally(loader.endLoading.bind(loader));
  }

  function isNotHighLight(props, field) {
    return props.searchProperty === 'All' ? false : props.searchProperty !== field;
  }

  module.exports = actions;
}();

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeContent.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda.QuerySourceTypeContent component
 */
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);
  var ScrollBox = __webpack_require__(27);
  var Dimensions = __webpack_require__(83);
  var QuerySourceTypeList = __webpack_require__(2288);
  var QuerySourceTypeDetails = __webpack_require__(2308);
  var QuerySourceTypeConfig = __webpack_require__(159).QUERY_SOURCE_TYPE;
  var observable = __webpack_require__(5).observable;

  var _require = __webpack_require__(1),
      indexOf = _require.indexOf;

  var QuerySourceTypeContent = React.createClass({
    displayName: 'QuerySourceTypeContent',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.uiStore = observable({
        defaultHeight: 0
      });
    },

    componentDidMount: function componentDidMount() {
      var domNode = ReactDOM.findDOMNode(this);
      if (this.uiStore.defaultHeight != domNode.clientHeight) {
        this.uiStore.defaultHeight = domNode.clientHeight;
      }
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var height = props.height > 0 ? props.height : this.uiStore.defaultHeight;
      var querySourceIndex = indexOf(store.selectedQuerySource, store.querySourceList);

      return React.createElement(
        'div',
        { className: 'izenda-Wrapper-content' },
        React.createElement(
          ScrollBox,
          null,
          React.createElement(
            'section',
            { className: 'u_paddingLeftRight u_fullHeight' },
            React.createElement(QuerySourceTypeList, {
              store: store,
              querySourceType: this.props.querySourceType,
              height: height,
              searchProperty: props.searchProperty,
              searchValue: props.searchValue,
              isNotHighLight: props.isNotHighLight,
              isLoading: props.isLoading
            }),
            store.selectedQuerySource && props.querySourceType !== QuerySourceTypeConfig.FUNCTION && React.createElement(QuerySourceTypeDetails, {
              store: store.selectedQuerySource,
              querySourceType: store.querySourceType,
              querySourceIndex: querySourceIndex,
              height: height,
              searchProperty: props.searchProperty,
              searchValue: props.searchValue
            })
          )
        )
      );
    }
  });

  module.exports = connect(Dimensions)(QuerySourceTypeContent);
}();

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * QuerySourceTypeList component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(37);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(198);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(159);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(44);

var _Izenda8 = __webpack_require__(97);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(2289);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(2290);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(2291);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(2292);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(617);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(68);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(23);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(2);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _Izenda26 = __webpack_require__(1149);

var _Izenda27 = _interopRequireDefault(_Izenda26);

var _Izenda28 = __webpack_require__(2296);

var _Izenda29 = _interopRequireDefault(_Izenda28);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (0, _Izenda23.default)()(__webpack_require__(17));
var QuerySourceType = _Izenda6.default.QUERY_SOURCE_TYPE;

var QuerySourceTypeList = (_dec = (0, _Izenda25.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(QuerySourceTypeList, _Component);

  function QuerySourceTypeList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, QuerySourceTypeList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuerySourceTypeList.__proto__ || (0, _getPrototypeOf2.default)(QuerySourceTypeList)).call.apply(_ref, [this].concat(args))), _this), _this.getRowProps = function (spDetails) {
      var store = _this.props.store;

      if (!store.selectedQuerySource) {
        return null;
      }

      return {
        className: spDetails.isSelected ? 'selected-row' : ''
      };
    }, _this.renderDbName = function (querySourceDetailsVM) {
      return _react2.default.createElement(
        'span',
        {
          className: 'truncate overflow-text',
          title: querySourceDetailsVM.getDbName(),
          onClick: _this.showQuerySourceDetail.bind(_this, querySourceDetailsVM)
        },
        querySourceDetailsVM.getDbName()
      );
    }, _this.renderReturnedValue = function (querySourceDetailsVM) {
      var returnValue = querySourceDetailsVM.getReturnedValue();
      return _react2.default.createElement(_Izenda21.default, { text: returnValue, tooltip: returnValue });
    }, _this.renderInputParams = function (querySourceDetailsVM) {
      var inputParams = querySourceDetailsVM.getInputParams();
      return _react2.default.createElement(_Izenda21.default, { text: inputParams, tooltip: inputParams });
    }, _this.renderFunctionName = function (querySourceDetailsVM) {
      var functionName = querySourceDetailsVM.getDbSourceName();
      var className = void 0,
          title = void 0;
      switch (querySourceDetailsVM.details.physicalChange) {
        case _Izenda3.DETECTED_CHANGE_LEVEL.MODIFIED:
          className = 'icon-attention warning-color';
          title = _Izenda4.default.FUNCTION_CHANGE;
          break;
        case _Izenda3.DETECTED_CHANGE_LEVEL.DELETED:
          className = 'icon-fields fail-color';
          title = _Izenda4.default.DELETED_FUNCTION;
          break;
        case _Izenda3.DETECTED_CHANGE_LEVEL.ADDED:
          className = 'icon-fields success-color';
          title = _Izenda4.default.FUNCTION_ADD;
          break;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { title: title },
          functionName
        ),
        className && _react2.default.createElement('span', { className: className, title: title })
      );
    }, _this.renderDbSourceName = function (querySourceDetailsVM) {
      var props = _this.props;
      var store = props.store;
      var renderChangedIcon = function renderChangedIcon() {
        var change = querySourceDetailsVM.details.physicalChange;
        var approval = querySourceDetailsVM.details.approval;
        var querySourceFieldApprovalLevel = _Izenda4.default.APPROVAL_LEVEL.QUERY_SOURCE_FIELD;
        var querySourceApprovalLevel = _Izenda4.default.APPROVAL_LEVEL.QUERY_SOURCE;
        var noneChangeLevel = _Izenda4.default.DETECTED_CHANGE_LEVEL.NONE;
        var deletedChangeLevel = _Izenda4.default.DETECTED_CHANGE_LEVEL.DELETED;
        var addedChangeLevel = _Izenda4.default.DETECTED_CHANGE_LEVEL.ADDED;

        var isQuerySourceAdd = approval === querySourceApprovalLevel && change === addedChangeLevel;

        var isEdit = !isQuerySourceAdd && approval < querySourceFieldApprovalLevel && change !== noneChangeLevel && change !== deletedChangeLevel;

        var isDelete = approval < querySourceFieldApprovalLevel && change === deletedChangeLevel;

        var className = (0, _classnames2.default)({
          'icon-attention warning-color': isEdit,
          'icon-fields fail-color': isDelete,
          'icon-fields success-color': isQuerySourceAdd
        });

        var title = (0, _fp.cond)([[(0, _fp.matches)({ isEdit: true }), (0, _fp.constant)(_Izenda4.default.DATA_SOURCE_CHANGES)], [(0, _fp.matches)({ isDelete: true }), (0, _fp.constant)(_Izenda4.default.DELETED_DATA_SOURCE)], [(0, _fp.matches)({ isQuerySourceAdd: true }), (0, _fp.constant)(_Izenda4.default.NEW_DATA_SOURCE)]])({ isEdit: isEdit, isDelete: isDelete, isQuerySourceAdd: isQuerySourceAdd });

        return _react2.default.createElement('span', { className: className, title: title });
      };

      var renderExecError = function renderExecError() {
        var isError = !(0, _fp.isEmpty)(querySourceDetailsVM.executeErrorMessage);
        var classes = (0, _classnames2.default)({ 'icon-attention': isError }, 'fail-color');

        return _react2.default.createElement('span', { className: classes, title: querySourceDetailsVM.executeErrorMessage });
      };

      var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
      var isCustomQuerySource = querySourceDetailsVM.details.isCustomQuerySource;
      var canEditCustomView = props.authorization.checkPrivileges([permissionKeys.DataSetupDataModelCustomViewEdit]);

      var classes = (0, _classnames2.default)({
        'source-name': isCustomQuerySource && canEditCustomView,
        u_curPointer: isCustomQuerySource && canEditCustomView
      });

      return _react2.default.createElement(
        'span',
        {
          className: 'truncate overflow-text',
          onClick: _this.showQuerySourceDetail.bind(_this, querySourceDetailsVM),
          title: querySourceDetailsVM.getDbSourceName()
        },
        _react2.default.createElement(
          'span',
          { className: classes, onClick: onEditCustomView.bind(_this) },
          querySourceDetailsVM.getDbSourceName()
        ),
        renderChangedIcon(),
        renderExecError()
      );

      function onEditCustomView() {
        if (isCustomQuerySource && canEditCustomView) {
          props.openPopup(_Izenda27.default, {
            store: store,
            detail: querySourceDetailsVM.details
          });
        }
      }
    }, _this.showQuerySourceDetail = function (querySourceDetailsVM, event) {
      event.preventDefault();
      var props = _this.props;
      var loader = props.loader,
          store = props.store;


      store.alertMessage = _Izenda2.default.EMPTY_MESSAGE;
      if (store.selectedQuerySource.getId() === querySourceDetailsVM.getId()) {
        return;
      }

      props.confirmDirtyForm(store.selectedQuerySource.hasDetailChange).then(function () {
        loader.startLoading();
        store.setShowingQuerySource(querySourceDetailsVM).finally(loader.endLoading.bind(loader));
      });
    }, _this.renderDbSourceAlias = function (querySourceDetailsVM, key, index) {
      var classes = (0, _classnames2.default)('form-group', { 'has-error': querySourceDetailsVM.aliasError });
      var alias = querySourceDetailsVM.getDbSourceAlias() || '';
      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(Input, {
          type: 'text',
          className: 'form-control',
          value: alias,
          onChange: updateValue,
          title: alias,
          field: 'QuerySources[' + index + '].Alias'
        })
      );

      function updateValue(e) {
        return querySourceDetailsVM.setDbSourceAlias(e.target.value);
      }
    }, _this.renderButtonCtrls = function (item) {
      var props = _this.props;
      var store = props.store,
          localization = props.localization,
          authorization = props.authorization;

      var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
      var isCustomQuerySource = item.details.isCustomQuerySource;
      var canDeleteCustomView = authorization.checkPrivileges([permissionKeys.DataSetupDataModelCustomViewDelete]);

      var onRelationshipClick = function onRelationshipClick() {
        _this.handleActionShowRelationshipDataSource(item);
      };
      var onDeleteCustomView = function onDeleteCustomView() {
        props.confirmFn('Confirmation', {
          description: localization.getText('QUERY_SOURCE_TYPE_CONFIG_MESSAGE_DELETE_CUSTOM_VIEW')
        }).then(function () {
          return store.deleteCustomQuerySource(item);
        }).then(function (_ref2) {
          var success = _ref2.success;
          return success && store.reload();
        });
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          { onClick: onRelationshipClick },
          _react2.default.createElement('span', { className: 'icon-resize-small' })
        ),
        isCustomQuerySource && canDeleteCustomView && _react2.default.createElement(
          'a',
          { onClick: onDeleteCustomView },
          _react2.default.createElement('span', { className: 'icon-cancel' })
        )
      );
    }, _this.handleActionShowRelationshipDataSource = function (item) {
      var props = _this.props;
      var store = props.store;

      var datasource = !!item.details ? item.details : null;
      var relationship = new _Izenda19.default(datasource);
      relationship.initData(true);
      store.relationship = relationship;
      props.openPopup(_Izenda29.default, { store: store });
    }, _this.onSortChange = function (columnKey, sortDir) {
      var props = _this.props;
      var store = props.store,
          loader = props.loader;


      return props.confirmDirtyForm(store.hasChange).then(function () {
        loader.startLoading();
        store.pageInfo.setColSortDirs(columnKey, sortDir);
        return store.loadQuerySources().finally(loader.endLoading.bind(loader));
      });
    }, _this.onPageSizeChange = function (pageSize) {
      var props = _this.props;
      var store = props.store,
          loader = props.loader;


      return props.confirmDirtyForm(store.hasChange).then(function () {
        loader.startLoading();
        store.pageInfo.setPageSize(pageSize);
        return store.goToPage(1).finally(loader.endLoading.bind(loader));
      });
    }, _this.goToPage = function (pageIndex) {
      var props = _this.props;
      var store = props.store,
          loader = props.loader;


      return props.confirmDirtyForm(store.hasChange).then(function () {
        loader.startLoading();
        return store.goToPage(pageIndex).finally(loader.endLoading.bind(loader));
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(QuerySourceTypeList, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = this.props.store;
      var newHeight = props.height > 0 && QuerySourceType.FUNCTION === store.querySourceType ? props.height - _Izenda4.default.DEFAULT_REST_HEIGHT : _Izenda4.default.DEFAULT_TABLE_HEIGHT;
      var TABLE_DEF = _Izenda3.TableDefinition.QuerySourceType;

      return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
          _Izenda7.Table,
          {
            dataSource: store.querySourceList,
            rowProps: this.getRowProps,
            onSortChange: this.onSortChange,
            sortInfo: store.pageInfo.colSortDirs,
            minHeight: newHeight,
            maxHeight: newHeight,
            isLoading: props.isLoading
          },
          QuerySourceType.FUNCTION !== store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['category'], { cell: _Izenda11.default.render.bind(this) })),
          _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['dbName'], { cell: this.renderDbName })),
          QuerySourceType.FUNCTION !== store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['dbSourceName'], { cell: this.renderDbSourceName })),
          QuerySourceType.FUNCTION === store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['functionName'], { cell: this.renderFunctionName })),
          QuerySourceType.FUNCTION !== store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['dbSourceAlias'], { cell: this.renderDbSourceAlias })),
          QuerySourceType.STORED_PROC === store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['dynamic'], { align: 'center', cell: _Izenda17.default.render.bind(this) })),
          QuerySourceType.FUNCTION === store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['returnedValue'], { cell: this.renderReturnedValue })),
          QuerySourceType.FUNCTION === store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['inputParams'], { cell: this.renderInputParams })),
          QuerySourceType.FUNCTION === store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['fieldLevel'], { align: 'center', cell: _Izenda13.default.render.bind(this) })),
          QuerySourceType.FUNCTION === store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['expressionLevel'], { align: 'center', cell: _Izenda15.default.render })),
          QuerySourceType.FUNCTION !== store.querySourceType && _react2.default.createElement(_Izenda7.Column, (0, _extends3.default)({}, TABLE_DEF['controlBtn'], { align: 'center', cell: this.renderButtonCtrls }))
        ),
        _react2.default.createElement(_Izenda9.default, {
          onChange: this.goToPage,
          onDropdownChange: this.onPageSizeChange,
          totalRecords: store.totalRecords,
          pageSize: store.pageInfo.pageSize,
          pageIndex: store.pageInfo.pageIndex
        })
      );
    }

    /**
     * This function is to render column Database Name
     * {params} querySourceDetailsVM
     */


    /**
     * This function is to render column Database Source Alias
     * {params} querySourceDetailsVM
     */

  }]);
  return QuerySourceTypeList;
}(_react.Component), _class2.propTypes = {
  store: _react2.default.PropTypes.object.isRequired,
  searchProperty: _react2.default.PropTypes.string,
  searchValue: _react2.default.PropTypes.string
}, _temp2)) || _class);
exports.default = QuerySourceTypeList;
module.exports = exports['default'];

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Category Column component
 */

!function () {
  var React = __webpack_require__(0);
  var Select = __webpack_require__(47);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      find = _require.find,
      trim = _require.trim,
      template = _require.template;

  function preventAddNew() {
    return false;
  }

  function renderCategory(querySourceTypeDetails) {
    var props = this.props;

    var querySourceVM = props.store;
    var inputProps = { maxLength: '50' };
    var onAddNew = addNewCategories;
    var noResultsText = localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_CATEGORY_COLUMN_ENTER_TO_CREATE_COLUMN');

    // If user does not have DataSetupAdvancedSettingsCategory permission, then he cannot add new category.
    if (!props.authorization.checkPrivileges([props.authorizationConstants.PERMISSION_KEY.DataSetupAdvancedSettingsCategory])) {
      onAddNew = preventAddNew;
      noResultsText = null;
    }

    return React.createElement(Select, { simpleValue: true, options: querySourceVM.categoryList.categoryMetadatas,
      labelKey: 'name',
      valueKey: 'id',
      inputProps: inputProps,
      value: querySourceTypeDetails.getCategory(),
      noResultsText: noResultsText,
      onChange: updateValue,
      onAddNew: onAddNew });

    function updateValue(value, label, isNew) {
      value = null;
      var existedCategory = find({ 'name': trim(label) }, querySourceVM.categoryList.categoryMetadatas);
      if (existedCategory) {
        value = existedCategory.isNew ? null : existedCategory.id;
        label = existedCategory.name;
        isNew = existedCategory.isNew;
      }
      return querySourceTypeDetails.setCategory(value, label, isNew);
    }

    function addNewCategories(newObject) {
      var isExist = find({ 'name': trim(newObject.name) }, querySourceVM.categoryList.categoryMetadatas);
      !isExist && querySourceVM.categoryList.addCategory(trim(newObject.id), trim(newObject.name), null);
    }
  }

  module.exports = {
    render: renderCategory
  };
}();

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldLevelColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Function Level Column component
 */
!function () {

  var React = __webpack_require__(0);

  function renderFieldLevel(querySourceTypeDetails) {
    var inputParams = querySourceTypeDetails.getInputParams() || '';
    var checkboxFieldLevel = inputParams.indexOf(',') > -1 ? true : false;
    return React.createElement(
      'div',
      null,
      React.createElement('input', { type: 'checkbox',
        checked: querySourceTypeDetails.getFieldLevel(),
        onChange: checkChangeFieldLevel,
        disabled: checkboxFieldLevel })
    );

    function checkChangeFieldLevel(e) {
      querySourceTypeDetails.setFieldLevel(e.target.checked);
    }
  }

  module.exports = {
    render: renderFieldLevel
  };
}();

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionLevelColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Function Level Column component
 */
!function () {

  var React = __webpack_require__(0);

  function renderExpressionLevel(querySourceTypeDetails) {
    return React.createElement(
      "div",
      null,
      React.createElement("input", { type: "checkbox",
        checked: querySourceTypeDetails.getExpressionLevel(),
        onChange: checkChangeExpressionLevel })
    );

    function checkChangeExpressionLevel(e) {
      querySourceTypeDetails.setExpressionLevel(e.target.checked);
    }
  }

  module.exports = {
    render: renderExpressionLevel
  };
}();

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DynamicColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Dynamic Column component
 */
!function () {
  var React = __webpack_require__(0);

  function renderDynamic(querySourceTypeDetails) {
    var props = this.props;
    var MESSAGE = this.props.store.getBundle().MESSAGE;

    return React.createElement('input', {
      type: 'checkbox',
      checked: querySourceTypeDetails.isDynamic(),
      disabled: querySourceTypeDetails.isStatic(),
      onChange: updateValue.bind(this)
    });

    function updateValue(e) {
      var newValue = e.target.checked;
      var setDynamic = function setDynamic() {
        querySourceTypeDetails.setDynamic(newValue);
      };

      if (!querySourceTypeDetails.isDynamic()) {
        props.confirmFn('Confirmation', {
          description: MESSAGE.MG02
        }).then(function () {
          setDynamic();
        });
      } else {
        setDynamic();
      }
    }
  }

  module.exports = {
    render: renderDynamic
  };
}();

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

var _Izenda = __webpack_require__(191);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2294);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(46);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(160);

var _Izenda8 = __webpack_require__(58);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelationshipDetail(item) {
  item.querySources = [];
  item.querySourceFields = [];
  item.foreignQuerySources = [];
  item.foreignQuerySourceFields = [];
  item.generalEror = '';
  item.error = {};
  item.errors = item.errors || [];
  item.position = !(0, _fp.isNil)(item.position) ? parseInt(item.position) : (0, _fp.uniqueId)();
  item.positionId = item.positionId;
  item.editable = true;
  item.state = !(0, _fp.isNil)(item.state) ? item.state : _Izenda9.default.INSERT;

  item.joinConnectionId = !String.isEmptyGuid(item.joinConnectionId) ? item.joinConnectionId : null;
  item.joinQuerySourceId = !String.isEmptyGuid(item.joinQuerySourceId) ? item.joinQuerySourceId : null;
  item.foreignConnectionId = !String.isEmptyGuid(item.foreignConnectionId) ? item.foreignConnectionId : null;
  item.foreignQuerySourceId = !String.isEmptyGuid(item.foreignQuerySourceId) ? item.foreignQuerySourceId : null;
  this.validator = new _Izenda4.default();

  (0, _mobx.extendObservable)((0, _Izenda6.default)(this), item);
  this.InitData(item);
}
// $FlowFixMe

// eslint-disable-next-line max-len

// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

RelationshipDetail.prototype.InitData = _mobx2.default.action(function (item) {
  if (!(0, _fp.isEmpty)(item.joinConnectionId)) {
    this.reloadQuerySources(item.joinConnectionId).then(function (result) {
      this.querySources = result;
    }.bind(this));
  }

  if (!(0, _fp.isEmpty)(item.joinQuerySourceId)) {
    this.reloadQuerySourceFields(item.joinQuerySourceId).then(function (result) {
      this.querySourceFields = result;
    }.bind(this));
  }

  if (!(0, _fp.isEmpty)(item.foreignConnectionId)) {
    this.reloadQuerySources(item.foreignConnectionId).then(function (result) {
      this.foreignQuerySources = result;
    }.bind(this));
  }

  if (!(0, _fp.isEmpty)(item.foreignConnectionId)) {
    this.reloadQuerySourceFields(item.foreignQuerySourceId).then(function (result) {
      this.foreignQuerySourceFields = result;
    }.bind(this));
  }
});

RelationshipDetail.prototype.getQuerySourceOptions = function (querySources) {
  return (0, _fp.map)(function (n) {
    return {
      key: n.id,
      value: n.name,
      valueDisplay: n.category + '.' + n.name
    };
  }, querySources);
};

RelationshipDetail.prototype.getListQuerySource = function () {
  return this.getQuerySourceOptions(this.querySources);
};

RelationshipDetail.prototype.getListForeignQuerySource = function () {
  return this.getQuerySourceOptions(this.foreignQuerySources);
};

RelationshipDetail.prototype.getListJoinField = function () {
  return this.querySourceFields;
};

RelationshipDetail.prototype.getListForeignJoinField = function () {
  return this.foreignQuerySourceFields;
};

RelationshipDetail.prototype.setDatabase = _mobx2.default.action(function (id) {
  this.joinConnectionId = id;
  this.setQuerySource(null);
  (0, _fp.isEmpty)(this.joinConnectionId) ? this.querySources = [] : this.reloadQuerySources(this.joinConnectionId).then(function (result) {
    this.querySources = result;
  }.bind(this));
  this.updateState();
});

RelationshipDetail.prototype.setQuerySource = _mobx2.default.action(function (id) {
  this.joinQuerySourceId = id;
  this.joinFieldId = null;
  (0, _fp.isEmpty)(this.joinQuerySourceId) ? this.querySourceFields = [] : this.reloadQuerySourceFields(this.joinQuerySourceId).then(function (result) {
    this.querySourceFields = result;
  }.bind(this));
  this.joinQuerySourceName = (0, _fp.get)('name', (0, _fp.find)(function (i) {
    return i.id === id;
  }, this.querySources));
  this.updateState();
  this.markDirty();
});

RelationshipDetail.prototype.setJoinType = _mobx2.default.action(function (id) {
  if (this.joinType === id) {
    return;
  }
  this.joinType = id;
  this.updateState();
  this.markDirty();
});

/** 
 * Set PositionId for a Relationship
 * @param {number} id
 */
RelationshipDetail.prototype.setPositionId = _mobx2.default.action(function (id) {
  this.positionId = id;
  this.updateState();
  this.markDirty();
});

RelationshipDetail.prototype.getJoinType = function () {
  return this.joinType;
};

RelationshipDetail.prototype.isCrossType = function () {
  return this.joinType === _Izenda7.JOIN_TYPE_CROSS;
};

RelationshipDetail.prototype.getDatabase = function () {
  return this.joinConnectionId;
};

RelationshipDetail.prototype.getQuerySource = function () {
  return this.joinQuerySourceId;
};

RelationshipDetail.prototype.setJoinField = _mobx2.default.action(function (id) {
  this.joinFieldId = id;
  this.updateState();
  this.markDirty();
});

RelationshipDetail.prototype.getJoinField = function () {
  return this.joinFieldId;
};

RelationshipDetail.prototype.setForeignDatabase = _mobx2.default.action(function (id) {
  this.foreignConnectionId = id;
  this.setForeignQuerySource(null);
  (0, _fp.isEmpty)(this.foreignConnectionId) ? this.foreignQuerySources = [] : this.reloadQuerySources(this.foreignConnectionId).then(function (result) {
    this.foreignQuerySources = result;
  }.bind(this));
  this.updateState();
  this.markDirty();
});

RelationshipDetail.prototype.setForeignQuerySource = _mobx2.default.action(function (id) {
  this.foreignQuerySourceId = id;
  this.foreignFieldId = null;
  (0, _fp.isEmpty)(this.foreignQuerySourceId) ? this.foreignQuerySourceFields = [] : this.reloadQuerySourceFields(this.foreignQuerySourceId).then(function (result) {
    this.foreignQuerySourceFields = result;
  }.bind(this));
  this.foreignQuerySourceName = (0, _fp.get)('name', (0, _fp.find)(function (i) {
    return i.id === id;
  }, this.foreignQuerySources));
  this.updateState();
  this.markDirty();
});

RelationshipDetail.prototype.getForeignDatabase = function () {
  return this.foreignConnectionId;
};

RelationshipDetail.prototype.getForeignQuerySource = function () {
  return this.foreignQuerySourceId;
};

RelationshipDetail.prototype.setForeignField = _mobx2.default.action(function (id) {
  this.foreignFieldId = id;
  this.updateState();
  this.markDirty();
});

RelationshipDetail.prototype.getForeignField = function () {
  return this.foreignFieldId;
};

/*
* if relationship is system then return true
*/
RelationshipDetail.prototype.isDisableJoinType = function () {
  var disabled = this.systemRelationship === true;
  return disabled;
};

/*
* if relationship is system then return true
*/
RelationshipDetail.prototype.isDisableDatabase = function () {
  var disabled = this.systemRelationship === true;
  return disabled;
};

/*
* if relationship is system then return true
*/
RelationshipDetail.prototype.isDisableForeignDatabase = function () {
  var disabled = this.systemRelationship === true;
  return disabled;
};

/*
* if connection database is empty or relationship is system then return true
*/
RelationshipDetail.prototype.isDisableDataObject = function () {
  var database = this.getDatabase();
  var disabled = (0, _fp.isEmpty)(database) || this.systemRelationship === true;
  return disabled;
};

/*
* if foreign connection database is empty or relationship is system then return true
*/
RelationshipDetail.prototype.isDisableForeignDataObject = function () {
  var database = this.getForeignDatabase();
  var disabled = (0, _fp.isEmpty)(database) || this.systemRelationship === true;
  return disabled;
};

/*
* if QuerySource is empty or relationship is system or joinType is Cross then return true
*/
RelationshipDetail.prototype.isDisableJoinField = function () {
  var querySource = this.getQuerySource();
  var disabled = (0, _fp.isEmpty)(querySource) || this.systemRelationship === true || this.joinType === _Izenda7.JOIN_TYPE_CROSS;
  return disabled;
};

/*
* if Foreign QuerySource is empty or relationship is system or joinType is Cross then return true
*/
RelationshipDetail.prototype.isDisableForeignField = function () {
  var querySource = this.getForeignQuerySource();
  var disabled = (0, _fp.isEmpty)(querySource) || this.systemRelationship === true || this.joinType === _Izenda7.JOIN_TYPE_CROSS;
  return disabled;
};

/*
* field: is field of relationship item
*/
RelationshipDetail.prototype.isDisableField = function (field) {
  var disabled = false;
  switch (field) {
    case _Izenda7.FIELDCHECK.JOIN_QUERYSOURCE_FIELD:
      disabled = this.isDisableDataObject();
      break;
    case _Izenda7.FIELDCHECK.JOIN_FIELD:
      disabled = this.isDisableJoinField();
      break;
    case _Izenda7.FIELDCHECK.FOREIGN_QUERYSOURCE_FIELD:
      disabled = this.isDisableForeignDataObject();
      break;
    case _Izenda7.FIELDCHECK.FOREIGN_FIELD:
      disabled = this.isDisableForeignField();
      break;
    case _Izenda7.FIELDCHECK.JOIN_TYPE:
      disabled = this.isDisableJoinType();
      break;
    case _Izenda7.FIELDCHECK.DATABASE_FIELD:
      disabled = this.isDisableDatabase();
      break;
    case _Izenda7.FIELDCHECK.FOREIGN_DATABASE_FIELD:
      disabled = this.isDisableForeignDatabase();
      break;
  }
  return disabled;
};

/**
 * set editable for a relationship
 * @param {boolean} isEditable
 */
RelationshipDetail.prototype.setEditable = function (isEditable) {
  this.editable = isEditable;
};

/**
 * reload Query Source base on the connection id
 */
RelationshipDetail.prototype.reloadQuerySources = function (joinConnectionId) {
  var assign = function (result) {
    return result || {};
  }.bind(this);

  return _Izenda2.default.getQuerySourcesInfo(joinConnectionId).then(assign);
};

/**
 * Get data for Join Field dropdow list
 */
RelationshipDetail.prototype.reloadQuerySourceFields = function (joinQuerySourceId) {
  var assign = function (result) {
    return result || {};
  }.bind(this);

  return _Izenda2.default.getBasicQuerySourceFieldsInfo(joinQuerySourceId).then(assign);
};

/**
 * Validate detail of relationship
 */
RelationshipDetail.prototype.validate = function () {
  this.error = this.validator.validate(this, this.isCrossType());
  return (0, _fp.isEmpty)(this.error);
};

/**
 * Update state
 */
RelationshipDetail.prototype.updateState = function () {
  // just update state to UPDATE when editing existing item
  this.id && this.setState(_Izenda9.default.UPDATE);
};

/**
 * Set state
 */
RelationshipDetail.prototype.setState = function (state) {
  this.state = state;
};

exports.default = RelationshipDetail;
module.exports = exports['default'];

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipDetailValidator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Relationship Detail Validator
 */
!function () {
  var validate = __webpack_require__(500);

  function RelationshipDetailValidator() {
    var setupValidate = function setupValidate() {
      validate.validators.presence.options = { message: "Required" };
    };

    this.constraints = {
      joinType: { presence: true },
      joinConnectionId: { presence: true },
      joinQuerySourceId: { presence: true },
      joinFieldId: { presence: true },
      foreignConnectionId: { presence: true },
      foreignQuerySourceId: { presence: true },
      foreignFieldId: { presence: true }
    };

    setupValidate();
  }

  /**
   * Validate a relationship detail
   */
  RelationshipDetailValidator.prototype.validate = function (obj, isCrossType, options) {
    options = options || { fullMessages: false };

    this.constraints.joinFieldId.presence = !isCrossType;
    this.constraints.foreignFieldId.presence = !isCrossType;

    return validate(obj, this.constraints, options) || {};
  };

  module.exports = RelationshipDetailValidator;
}();

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12; // ----------------------------------------------------------------------
// <copyright file="Izenda.CustomView.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CustomViewModel = (_class = function CustomViewModel() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _classCallCheck3.default)(this, CustomViewModel);

  _initDefineProp(this, 'databases', _descriptor, this);

  _initDefineProp(this, 'schemas', _descriptor2, this);

  _initDefineProp(this, 'viewName', _descriptor3, this);

  _initDefineProp(this, 'databaseId', _descriptor4, this);

  _initDefineProp(this, 'databaseName', _descriptor5, this);

  _initDefineProp(this, 'schemaId', _descriptor6, this);

  _initDefineProp(this, 'schemaName', _descriptor7, this);

  _initDefineProp(this, 'query', _descriptor8, this);

  this.isLastPageDatabase = false;
  this.isLastPageSchema = false;
  this.id = null;

  _initDefineProp(this, 'updateViewName', _descriptor9, this);

  _initDefineProp(this, 'setDatabase', _descriptor10, this);

  _initDefineProp(this, 'setSchema', _descriptor11, this);

  _initDefineProp(this, 'updateQuery', _descriptor12, this);

  this.id = item.id;
  this.viewName = item.realName;
  this.databaseId = item.connectionId;
  this.databaseName = item.connectionName;
  this.schemaId = item.categoryId;
  this.schemaName = item.querySourceCategoryName;
  this.query = item.customDefinition;
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'databases', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'schemas', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'viewName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'databaseId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'databaseName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'schemaId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'schemaName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'query', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'updateViewName', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this = this;

    return function (_ref) {
      var name = _ref.target.value;

      _this.viewName = name;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'setDatabase', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (id, name) {
      _this2.databaseId = id;
      _this2.databaseName = name;
      _this2.schemaId = null;
      _this2.schemaName = null;
      _this2.schemas = [];
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'setSchema', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (id, name) {
      _this3.schemaId = id;
      _this3.schemaName = name;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'updateQuery', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (_ref2) {
      var query = _ref2.target.value;

      _this4.query = query;
    };
  }
})), _class);
exports.default = CustomViewModel;
module.exports = exports['default'];

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1150);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RelationshipPopup = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RelationshipPopup, _Component);

  function RelationshipPopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RelationshipPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RelationshipPopup.__proto__ || (0, _getPrototypeOf2.default)(RelationshipPopup)).call.apply(_ref, [this].concat(args))), _this), _this.onClosePopup = function () {
      var _this$props = _this.props,
          onAccept = _this$props.onAccept,
          store = _this$props.store;

      onAccept && onAccept();
      delete store.relationship;
      store.relationship = null;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RelationshipPopup, [{
    key: 'render',
    value: function render() {
      var store = this.props.store;

      var relationship = store.relationship;
      var dataObjectName = !!relationship ? relationship.dataObjectName : '';

      return _react2.default.createElement(
        _Izenda4.default,
        { visible: true, sizeClass: 'modal-relationship-size', type: 'border-none', onClosed: this.onClosePopup },
        _react2.default.createElement(_Izenda4.default.Header, { title: 'Relationships - ' + dataObjectName }),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          !!relationship && _react2.default.createElement(_Izenda6.default, { store: relationship, isPopup: true, onClosePopup: this.onClosePopup })
        ),
        _react2.default.createElement(_Izenda4.default.Footer, null)
      );
    }
  }]);
  return RelationshipPopup;
}(_react.Component)) || _class);
exports.default = RelationshipPopup;
module.exports = exports['default'];

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderJoinType;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(199);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(47);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.JoinTypeColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Join Type Column component
 */

var ValidateSelect = (0, _Izenda4.default)()(_Izenda6.default);

function renderJoinType(relationshipItem) {
  var store = this.props.store;
  var checkExistEntitiesFunc = checkExistEntities.bind(this, relationshipItem);
  var options = {
    options: store.joinTypes,
    valueKey: 'key',
    labelKey: 'value',
    simpleValue: true
  };

  function checkExistEntities(relationshipItem, value, label, isNew) {
    var currentJoinType = relationshipItem.joinType;
    var result = this.props.store.resetNewValueToDefault(value, label, isNew);
    relationshipItem.setJoinType(result.value, result.label, isNew);
    this.checkExistEntities(relationshipItem, currentJoinType, relationshipItem.setJoinType);
  }

  return _react2.default.createElement(_Izenda2.default, {
    relationshipItem: relationshipItem,
    store: store,
    fieldCheck: 'joinType',
    selectedFunction: relationshipItem.getJoinType(),
    setFunction: checkExistEntitiesFunc,
    rowIndex: relationshipItem.position,
    component: ValidateSelect,
    componentOptions: options
  });
}
module.exports = exports['default'];

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PositionIdInput;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(199);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(109);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(160);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PositionIdColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var ValidateInput = (0, _Izenda4.default)()(_Izenda6.default);
// $FlowFixMe
function PositionIdInput(relationshipItem) {
  var relationshipVM = this.props.store;
  // Only allow number in positionId input
  var pattern = _Izenda8.default.POSITION_ID.PATTERN;
  var options = {
    isDecimal: false,
    format: _Izenda8.default.POSITION_ID.FORMAT
  };

  function updateValue(e) {
    if (pattern.test(e) || (0, _fp.isNil)(e)) {
      return relationshipItem.setPositionId(e);
    }
    if (e === 0) {
      relationshipItem.setPositionId(null);
    }
  }

  return _react2.default.createElement(_Izenda2.default, {
    classes: 'form-control u_overflowHidden',
    relationshipItem: relationshipItem,
    store: relationshipVM,
    fieldCheck: 'positionId',
    setFunction: updateValue,
    selectedFunction: relationshipItem.positionId,
    rowIndex: relationshipItem.position,
    component: ValidateInput,
    componentOptions: options,
    validationsRules: ''
  });
}
module.exports = exports['default'];

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = render;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(199);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(47);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Database Column component
 */

var ValidateSelect = (0, _Izenda4.default)()(_Izenda6.default);

function render(relationshipItem) {
  var relationshipVM = this.props.store;
  var options = {
    options: relationshipVM.databases,
    valueKey: 'key',
    labelKey: 'value',
    simpleValue: true
  };

  return _react2.default.createElement(_Izenda2.default, {
    relationshipItem: relationshipItem,
    store: relationshipVM,
    fieldCheck: 'joinConnectionId',
    selectedFunction: relationshipItem.getDatabase(),
    setFunction: updateValue,
    rowIndex: relationshipItem.position,
    component: ValidateSelect,
    componentOptions: options
  });

  function updateValue(value, label, isNew) {
    var result = relationshipVM.resetNewValueToDefault(value, label, isNew);
    return relationshipItem.setDatabase(result.value, result.label, isNew);
  }
}
module.exports = exports['default'];

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = render;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(199);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidateSelect = (0, _Izenda6.default)()(_Izenda8.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataObjectColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Data Object Column component
 */

function render(relationshipItem) {
  var relationshipVM = this.props.store;
  var updateValueFunc = updateValue.bind(this, relationshipItem);
  var options = {
    options: relationshipItem.getListQuerySource(),
    valueKey: 'key',
    labelKey: _Izenda2.default.advancedSettings.other.showSchemaNameValue ? 'valueDisplay' : 'value',
    simpleValue: true
  };

  return _react2.default.createElement(_Izenda4.default, {
    relationshipItem: relationshipItem,
    store: relationshipVM,
    fieldCheck: 'joinQuerySourceId',
    selectedFunction: relationshipItem.getQuerySource(),
    setFunction: updateValueFunc,
    rowIndex: relationshipItem.position,
    component: ValidateSelect,
    componentOptions: options
  });

  function updateValue(relationshipItem, value, label, isNew) {
    var currentJoinQuerySourceId = relationshipItem.joinQuerySourceId;
    var result = relationshipVM.resetNewValueToDefault(value, label, isNew);
    relationshipItem.setQuerySource(result.value, result.label, isNew);
    this.checkExistEntities(relationshipItem, currentJoinQuerySourceId, relationshipItem.setQuerySource);
  }
}
module.exports = exports['default'];

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = render;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(199);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(160);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidateSelect = (0, _Izenda6.default)()(_Izenda8.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.JoinFieldColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Join Field Column component
 */

function render(relationshipItem) {
  var relationshipVM = this.props.store;
  var joinFieldRule = relationshipItem.joinType === 'Cross' ? {} : _Izenda4.default.REQUIRED_CONSTRAINT;
  var options = {
    options: relationshipItem.getListJoinField(),
    valueKey: 'key',
    labelKey: 'value',
    simpleValue: true
  };

  function updateValue(value, label, isNew) {
    var result = relationshipVM.resetNewValueToDefault(value, label, isNew);
    return relationshipItem.setJoinField(result.value, result.label, isNew);
  }

  return _react2.default.createElement(_Izenda2.default, {
    relationshipItem: relationshipItem,
    store: relationshipVM,
    fieldCheck: 'joinFieldId',
    selectedFunction: relationshipItem.getJoinField(),
    setFunction: updateValue,
    rowIndex: relationshipItem.position,
    validationsRules: joinFieldRule,
    component: ValidateSelect,
    componentOptions: options
  });
}
module.exports = exports['default'];

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = render;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(199);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(47);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ForeignDatabaseColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Foreign Database Column component
 */

var ValidateSelect = (0, _Izenda4.default)()(_Izenda6.default);

function render(relationshipItem) {
  var relationshipVM = this.props.store;
  var options = {
    options: relationshipVM.databases,
    valueKey: 'key',
    labelKey: 'value',
    simpleValue: true
  };

  return _react2.default.createElement(_Izenda2.default, {
    relationshipItem: relationshipItem,
    store: relationshipVM,
    fieldCheck: 'foreignConnectionId',
    selectedFunction: relationshipItem.getForeignDatabase(),
    setFunction: updateValue,
    rowIndex: relationshipItem.position,
    component: ValidateSelect,
    componentOptions: options
  });

  function updateValue(value, label, isNew) {
    var result = relationshipVM.resetNewValueToDefault(value, label, isNew);
    return relationshipItem.setForeignDatabase(result.value, result.label, isNew);
  }
}
module.exports = exports['default'];

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = render;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(199);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidateSelect = (0, _Izenda6.default)()(_Izenda8.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.ForeignDataObjectColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Foreign Data Object Column component
 */

function render(relationshipItem) {
  var relationshipVM = this.props.store;
  var updateValueFunc = updateValue.bind(this, relationshipItem);
  var options = {
    options: relationshipItem.getListForeignQuerySource(),
    valueKey: 'key',
    labelKey: _Izenda2.default.advancedSettings.other.showSchemaNameValue ? 'valueDisplay' : 'value',
    simpleValue: true
  };

  return _react2.default.createElement(_Izenda4.default, {
    relationshipItem: relationshipItem,
    store: relationshipVM,
    fieldCheck: 'foreignQuerySourceId',
    selectedFunction: relationshipItem.getForeignQuerySource(),
    setFunction: updateValueFunc,
    rowIndex: relationshipItem.position,
    component: ValidateSelect,
    componentOptions: options
  });

  function updateValue(relationshipItem, value, label, isNew) {
    var currentForeignQuerySourceId = relationshipItem.foreignQuerySourceId;
    var result = relationshipVM.resetNewValueToDefault(value, label, isNew);
    relationshipItem.setForeignQuerySource(result.value, result.label, isNew);
    this.checkExistEntities(relationshipItem, currentForeignQuerySourceId, relationshipItem.setForeignQuerySource);
  }
}
module.exports = exports['default'];

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = render;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(199);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(160);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidateSelect = (0, _Izenda6.default)()(_Izenda8.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.ForeignJoinFieldColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Foreign Join Field Column component
 */

function render(relationshipItem) {
  var relationshipVM = this.props.store;
  var fieldRule = relationshipItem.joinType === 'Cross' ? {} : _Izenda4.default.REQUIRED_CONSTRAINT;
  var options = {
    options: relationshipItem.getListForeignJoinField(),
    valueKey: 'key',
    labelKey: 'value',
    simpleValue: true
  };

  return _react2.default.createElement(_Izenda2.default, {
    relationshipItem: relationshipItem,
    store: relationshipVM,
    fieldCheck: 'foreignFieldId',
    selectedFunction: relationshipItem.getForeignField(),
    setFunction: updateValue,
    rowIndex: relationshipItem.position,
    validationsRules: fieldRule,
    component: ValidateSelect,
    componentOptions: options
  });

  function updateValue(value, label, isNew) {
    var result = relationshipVM.resetNewValueToDefault(value, label, isNew);
    return relationshipItem.setForeignField(result.value, result.label, isNew);
  }
}
module.exports = exports['default'];

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActionColumn;

var _Izenda = __webpack_require__(160);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ActionColumn(relationshipDetails) {
  var parentProps = this.props;
  var onCopyIconClick = function onCopyIconClick() {
    var validation = parentProps.validation;


    parentProps.store.copy(relationshipDetails).then(function () {
      validation.validate();
      return null;
    });
  };

  var onDeleteIconClick = function onDeleteIconClick(relationship) {
    var store = parentProps.store,
        validation = parentProps.validation;

    // Check this relationship is used in report

    store.hasReportUseRelationship(relationship).then(function (hasUsed) {
      var confirmMessage = hasUsed ? _Izenda2.default.CONFIRM_DELETE_RELATIONSHIP_HAS_USED : _Izenda2.default.CONFIRM_DELETE_RELATIONSHIP;

      parentProps.confirmFn('Confirmation', {
        description: confirmMessage
      }).then(function () {
        return store.handleDeleteAction(relationship);
      }).then(function (relationships) {
        validation.reset();
        if ((0, _fp.some)(function (item) {
          return !(0, _fp.isNil)(item);
        }, relationships)) {
          var allErrors = store.getInvalidErrors(_Izenda.FIELDCHECK);
          validation.updateErrors(allErrors);
        }
      });
    });
  };

  /**
   * Render component
   */
  var renderErrorIcon = function renderErrorIcon() {
    var generalEror = relationshipDetails.generalEror;
    return !(0, _fp.isEmpty)(generalEror) ? _react2.default.createElement('span', { className: 'icon-attention fail-color error-icon-size', title: generalEror }) : '';
  };

  var renderCopyIcon = function renderCopyIcon() {
    return _react2.default.createElement(
      'a',
      { onClick: onCopyIconClick },
      _react2.default.createElement('span', { title: 'Copy Relationship', className: 'icon-copy' })
    );
  };

  var renderDeleteIcon = function renderDeleteIcon() {
    var onDelete = function onDelete() {
      return onDeleteIconClick(relationshipDetails);
    };
    var isSystemRelationship = relationshipDetails.systemRelationship;
    var classes = (0, _classnames2.default)('icon-cancel', {
      'disabled-elm': isSystemRelationship
    });
    return _react2.default.createElement(
      'a',
      { onClick: isSystemRelationship ? null : onDelete },
      _react2.default.createElement('span', { title: 'Delete Relationship', className: classes })
    );
  };

  /**
   * Render
   */
  return _react2.default.createElement(
    'div',
    { className: 'action-in-cell u_textCenter' },
    renderErrorIcon(),
    renderCopyIcon(),
    renderDeleteIcon()
  );
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Action column for relationship list
 */
module.exports = exports['default'];

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.InvalidRelationship.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Invalid Relationship component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(86);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(30);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(147);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(146);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(618);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(61);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(37);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2307);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(617);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(1151);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvalidRelationship = (_dec = (0, _Izenda2.default)(_Izenda22.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(InvalidRelationship, _Component);

  function InvalidRelationship() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, InvalidRelationship);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = InvalidRelationship.__proto__ || (0, _getPrototypeOf2.default)(InvalidRelationship)).call.apply(_ref, [this].concat(args))), _this), _this.resetAlertMessage = function () {
      var store = _this.props.store;

      store.alertMessage = _Izenda16.default.EMPTY_MESSAGE;
    }, _this.viewExistingRelationship = function () {
      var props = _this.props;
      var store = new _Izenda20.default();
      store.setEditable(false);
      store.initData(true).then(function () {
        props.openPopup(_Izenda18.default, { store: store, updateLoading: props.updateLoading });
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(InvalidRelationship, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      var store = props.store,
          loader = props.loader,
          validation = props.validation,
          isPopup = props.isPopup;


      props.updateLoading(true);
      loader.startLoading();
      store.initData(isPopup).then(function () {
        props.updateLoading(false);
        loader.endLoading();

        var allErrors = store.getInvalidErrors(_Izenda23.FIELDCHECK);
        validation.updateErrors(allErrors);
      });
    }
  }, {
    key: 'render',


    /**
     * render main function
     */
    value: function render() {
      var _props = this.props,
          store = _props.store,
          alertMessage = _props.store.alertMessage,
          localization = _props.localization;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-header' },
          _react2.default.createElement(_Izenda4.default, null),
          _react2.default.createElement(
            'div',
            { className: 'izenda-Alert-container' },
            _react2.default.createElement(
              _Izenda14.default,
              { type: alertMessage.type, onAutoHide: this.resetAlertMessage },
              alertMessage.message
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock' },
            _react2.default.createElement(_Izenda10.default, {
              onSearch: this.props.onSearch,
              value: store.pageInfo.searchProperty,
              options: store.getCriteriaList()
            })
          ),
          _react2.default.createElement(
            _Izenda8.default,
            { onSave: this.props.onSave, onCancel: this.props.onCancel },
            _react2.default.createElement(_Izenda6.default, { onClick: this.viewExistingRelationship, label: localization.getText('RELATIONSHIP_LABEL_VIEW_EXISTING') }),
            _react2.default.createElement(_Izenda6.default, { onClick: this.props.onAdd, label: localization.getText('REPORTDESIGNER_LABEL_ADD_RELATIONSHIP') })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _Izenda14.default,
              { type: 'error', autoHide: false, className: 'u_marginLeft u_marginRight u_marginBottom' },
              localization.getText('RELATIONSHIP_MESSAGES_INVALID_MESSAGE')
            )
          ),
          _react2.default.createElement(_Izenda12.default, {
            store: store,
            width: this.props.width,
            isPopup: this.props.isPopup,
            isLoading: this.props.isLoading,
            isHidePaging: true,
            isSort: true
          })
        )
      );
    }
  }]);
  return InvalidRelationship;
}(_react.Component)) || _class);


InvalidRelationship.defaultProps = {
  isPopup: false
};

InvalidRelationship.propTypes = {
  store: _propTypes2.default.object.isRequired,
  querySourceId: _propTypes2.default.string,
  isPopup: _propTypes2.default.bool
};

exports.default = InvalidRelationship;
module.exports = exports['default'];

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.ExistingRelationshipPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Existing Relationship Popup component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(618);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(146);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(12);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExistingRelationshipPopup = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ExistingRelationshipPopup, _Component);

  function ExistingRelationshipPopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExistingRelationshipPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExistingRelationshipPopup.__proto__ || (0, _getPrototypeOf2.default)(ExistingRelationshipPopup)).call.apply(_ref, [this].concat(args))), _this), _this.onClosePopup = function () {
      var onAccept = _this.props.onAccept;

      onAccept && onAccept();
    }, _this.onSearch = function (searchProperty, searchText) {
      var props = _this.props;
      var store = props.store;
      var valManager = _this.props.validation;

      return props.confirmDirtyForm(store.hasChange).then(function () {
        this.props.validation.reset();
        store.resetData();
        store.pageInfo.setSearchValues(searchProperty, searchText);

        props.updateLoading(true);
        props.loader.startLoading();
        return store.getRelationships().then(props.updateLoading.bind(props, false)).finally(function () {
          props.loader.endLoading();
          valManager.validate();
        });
      }.bind(_this));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExistingRelationshipPopup, [{
    key: 'renderContent',
    value: function renderContent(store) {
      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-header' },
          _react2.default.createElement(
            'div',
            { className: 'u_inlineBlock' },
            _react2.default.createElement(_Izenda8.default, {
              onSearch: this.onSearch,
              value: store.pageInfo.searchProperty,
              options: store.getCriteriaList()
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          _react2.default.createElement(_Izenda6.default, { store: store, width: this.props.width, isLoading: this.props.isLoading, isHideActionColumn: true })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var store = this.props.store;

      return _react2.default.createElement(
        _Izenda4.default,
        { visible: true, sizeClass: 'modal-relationship-size', type: 'border-none', onClosed: this.onClosePopup },
        _react2.default.createElement(_Izenda4.default.Header, { title: _Izenda10.default.getText('RELATIONSHIP_LABEL_EXISTING_RELATIONSHIPS') }),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          this.renderContent(store)
        ),
        _react2.default.createElement(
          _Izenda4.default.Footer,
          null,
          _react2.default.createElement(_Izenda4.default.ConfirmationButton, { onClick: this.onClosePopup, label: _Izenda10.default.getText('COMMON_LABEL_OK') })
        )
      );
    }
  }]);
  return ExistingRelationshipPopup;
}(_react.Component)) || _class);
exports.default = ExistingRelationshipPopup;
module.exports = exports['default'];

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(198);

var _Izenda2 = __webpack_require__(159);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda5 = __webpack_require__(44);

var _Izenda6 = __webpack_require__(30);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(2309);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(2310);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(17);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(23);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(402);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(96);

var _Izenda19 = __webpack_require__(68);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _fp = __webpack_require__(1);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda21 = __webpack_require__(619);

var _Izenda22 = _interopRequireDefault(_Izenda21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TABLE_DEF = _Izenda.TableDefinition.QuerySourceTypeDetails;

var ValidatorInput = (0, _Izenda15.default)()(_Izenda13.default);

var QuerySourceTypeDetails = (_dec = (0, _Izenda4.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(QuerySourceTypeDetails, _Component);

  function QuerySourceTypeDetails(props) {
    (0, _classCallCheck3.default)(this, QuerySourceTypeDetails);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuerySourceTypeDetails.__proto__ || (0, _getPrototypeOf2.default)(QuerySourceTypeDetails)).call(this, props));

    _this.onSortChange = function (columnKey, sortDir) {
      var _this$props = _this.props,
          store = _this$props.store,
          _this$props$store = _this$props.store,
          hasDetailChange = _this$props$store.hasDetailChange,
          pageInfo = _this$props$store.pageInfo;


      var confirmPromise = (0, _bluebird.resolve)();
      if (hasDetailChange) {
        confirmPromise = _this.props.confirmDirtyForm(hasDetailChange);
      }

      confirmPromise.then(function () {
        pageInfo.setColSortDirs(columnKey, sortDir);
        store.loadQuerySourceFields();
      });
    };

    _this.renderColumnName = function (fieldDetailsStore) {
      var _fieldDetailsStore$de = fieldDetailsStore.details,
          physicalChange = _fieldDetailsStore$de.physicalChange,
          approval = _fieldDetailsStore$de.approval,
          matchedTenant = _fieldDetailsStore$de.matchedTenant;


      var isCalculated = !!fieldDetailsStore.details.isCalculated;
      var columnName = fieldDetailsStore.getColumnName();

      var renderChangedIcon = function renderChangedIcon() {
        var isNew = approval < _Izenda.APPROVAL_LEVEL.QUERY_SOURCE_FIELD && physicalChange === _Izenda.DETECTED_CHANGE_LEVEL.ADDED;
        var isEdit = approval < _Izenda.APPROVAL_LEVEL.QUERY_SOURCE_FIELD && physicalChange === _Izenda.DETECTED_CHANGE_LEVEL.MODIFIED;
        var isDelete = approval < _Izenda.APPROVAL_LEVEL.QUERY_SOURCE_FIELD && physicalChange === _Izenda.DETECTED_CHANGE_LEVEL.DELETED;

        var className = (0, _classnames2.default)({
          'icon-data success-color': isNew,
          'icon-move-data warning-color': isEdit,
          'icon-data fail-color': isDelete
        });

        var title = (0, _fp.cond)([[(0, _fp.matches)({ isNew: true }), (0, _fp.constant)(_Izenda.NEW_FIELD)], [(0, _fp.matches)({ isEdit: true }), (0, _fp.constant)(_Izenda.DATA_TYPE_CHANGES)], [(0, _fp.matches)({ isDelete: true }), (0, _fp.constant)(_Izenda.DELETED_FIELD)]])({ isNew: isNew, isEdit: isEdit, isDelete: isDelete });

        return _react2.default.createElement(_Izenda20.default, { className: className, tooltip: title });
      };

      var renderTenantFieldIcon = function renderTenantFieldIcon() {
        var className = (0, _classnames2.default)('u_paddingLeft', {
          'icon-group': matchedTenant
        });
        return _react2.default.createElement('span', { className: className, title: _Izenda.TENANT_FIELD });
      };

      var editCalculatedField = function editCalculatedField() {
        var store = _this.props.store;

        store.editingQuerySourceField = fieldDetailsStore;
        store.loadFieldNameForExpression(fieldDetailsStore);
        store.loadFieldNameForExpression();

        _this.props.openPopup(_Izenda17.default, {
          store: store.calculatedStore,
          onClose: _this.closeCalculatedPopup,
          type: _Izenda18.TYPES.EDIT,
          querySourceId: store.details.id,
          value: fieldDetailsStore.details,
          expressionConfig: _Izenda.EXPRESSION_SELECTION,
          isCheckDuplicateWithActualField: false
        });
      };

      return isCalculated ? _react2.default.createElement(
        'span',
        { className: 'truncate overflow-text', title: columnName, onClick: editCalculatedField },
        _react2.default.createElement(
          'span',
          { className: 'source-name' },
          columnName
        ),
        renderTenantFieldIcon(),
        renderChangedIcon()
      ) : _react2.default.createElement(
        'span',
        { title: columnName, className: 'truncate overflow-text' },
        columnName,
        renderTenantFieldIcon(),
        renderChangedIcon()
      );
    };

    _this.isHighLight = function (fieldDetailsStore) {
      var _this$props2 = _this.props,
          searchProperty = _this$props2.searchProperty,
          searchValue = _this$props2.searchValue;

      if (searchValue.length === 0) {
        return false;
      }

      switch (searchProperty) {
        case 'All':
          return String.searchString(fieldDetailsStore.getColumnName(), searchValue, true) || String.searchString(fieldDetailsStore.getDataType(), searchValue, true) || String.searchString(fieldDetailsStore.getColumnAlias(), searchValue, true);
        case 'ColumnName':
          return String.searchString(fieldDetailsStore.getColumnName(), searchValue, true);
        case 'ColumnAlias':
          return String.searchString(fieldDetailsStore.getColumnAlias(), searchValue, true);
        default:
          return false;
      }
    };

    _this.renderDataType = function (fieldDetailsStore) {
      var dataType = fieldDetailsStore.getDataType();
      return _react2.default.createElement(_Izenda20.default, { tooltip: dataType, text: dataType });
    };

    _this.renderDeleteColumn = function (fieldDetailsStore) {
      var _this$props3 = _this.props,
          store = _this$props3.store,
          loader = _this$props3.loader;
      var _fieldDetailsStore$de2 = fieldDetailsStore.details,
          approval = _fieldDetailsStore$de2.approval,
          physicalChange = _fieldDetailsStore$de2.physicalChange,
          isCalculated = _fieldDetailsStore$de2.isCalculated;

      var isDelete = approval < _Izenda.APPROVAL_LEVEL.QUERY_SOURCE_FIELD && physicalChange === _Izenda.DETECTED_CHANGE_LEVEL.DELETED;
      var disabled = !isCalculated && !isDelete;
      var classes = (0, _classnames2.default)('icon-cancel', {
        'disabled-elm': disabled
      });

      var deleteField = function deleteField() {
        if (!disabled) {
          var deletePromise = (0, _bluebird.resolve)();
          if (isCalculated) {
            deletePromise = store.hasReportUseCalculatedField(fieldDetailsStore).then(function (hasUsed) {
              var confirmMessage = hasUsed ? _Izenda18.MESSAGES.M02 : _Izenda18.MESSAGES.M01;
              return _this.props.confirmFn('Confirmation', {
                description: confirmMessage
              });
            });
          }

          deletePromise.then(function () {
            loader.startLoading();
            return store.deleteField(fieldDetailsStore).finally(loader.endLoading.bind(loader));
          });
        }
      };

      return _react2.default.createElement(
        'a',
        { onClick: deleteField },
        _react2.default.createElement('span', { className: classes })
      );
    };

    _this.renderColumnAlias = function (fieldDetailsStore, key, index) {
      var classes = (0, _classnames2.default)('form-group', {
        'has-error': fieldDetailsStore.aliasError
      });
      var querySourceIndex = _this.props.querySourceIndex;


      var updateValue = function updateValue(_ref) {
        var value = _ref.target.value;

        return fieldDetailsStore.setColumnAlias(value);
      };

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(ValidatorInput, {
          type: 'text',
          className: 'form-control',
          value: fieldDetailsStore.getColumnAlias(),
          onChange: updateValue,
          title: fieldDetailsStore.getColumnAlias(),
          field: 'QuerySources[' + querySourceIndex + '].QuerySourceFields[' + index + '].Alias'
        })
      );
    };

    _this.renderVisible = function (fieldDetailsStore) {
      var isVisible = fieldDetailsStore.isVisible,
          isDisabledVisible = fieldDetailsStore.isDisabledVisible;


      var updateValue = function updateValue(_ref2) {
        var checked = _ref2.target.checked;

        return fieldDetailsStore.setVisible(checked);
      };

      return _react2.default.createElement(_Izenda13.default, {
        type: 'checkbox',
        checked: isVisible,
        onChange: updateValue,
        disabled: isDisabledVisible
      });
    };

    _this.renderFilterable = function (fieldDetailsStore) {
      var isFilterable = fieldDetailsStore.isFilterable,
          isDisabledFilterable = fieldDetailsStore.isDisabledFilterable;


      var updateValue = function updateValue(_ref3) {
        var checked = _ref3.target.checked;

        return fieldDetailsStore.setFilterable(checked);
      };

      return _react2.default.createElement(_Izenda13.default, {
        type: 'checkbox',
        checked: isFilterable,
        onChange: updateValue,
        disabled: isDisabledFilterable
      });
    };

    _this.closeCalculatedPopup = function (calculatedData) {
      // Update calculated field
      var store = _this.props.store;

      calculatedData && store.addCalculateField(calculatedData);
    };

    _this.renderFilterValueColumns = _Izenda9.default.render.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuerySourceTypeDetails, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          height = _props.height,
          querySourceType = _props.querySourceType,
          editingQuerySourceField = _props.store.editingQuerySourceField;

      var displayFieldList = store.displayFieldList || [];
      var newHeight = height > 0 ? height - _Izenda.DEFAULT_DETAIL_REST_HEIGHT : _Izenda.DEFAULT_TABLE_HEIGHT;
      newHeight = newHeight > _Izenda.DEFAULT_TABLE_HEIGHT ? newHeight : _Izenda.DEFAULT_TABLE_HEIGHT;

      return _react2.default.createElement(
        'section',
        { className: 'izenda-SubTable' },
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(
              'strong',
              { className: 'db-name' },
              store.getDbSourceName()
            )
          ),
          this.renderAddCalculatedFieldButton(),
          this.renderExecuteButton()
        ),
        _react2.default.createElement(
          _Izenda5.Table,
          {
            dataSource: displayFieldList,
            onSortChange: this.onSortChange,
            sortInfo: store.pageInfo.colSortDirs,
            isHighLight: this.isHighLight,
            minHeight: newHeight,
            maxHeight: newHeight,
            isLoading: true
          },
          _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF.columnName, { cell: this.renderColumnName })),
          _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF.dataType, { cell: this.renderDataType })),
          _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF.columnAlias, { cell: this.renderColumnAlias })),
          _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF.filter, { align: 'center', cell: this.renderFilterValueColumns })),
          _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF.visible, { align: 'center', cell: this.renderVisible })),
          _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF.filterable, { align: 'center', cell: this.renderFilterable })),
          _Izenda2.QUERY_SOURCE_TYPE.STORED_PROC !== querySourceType && _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF.deletable, { align: 'center', cell: this.renderDeleteColumn }))
        ),
        editingQuerySourceField && store.isEditingFilter && _react2.default.createElement(_Izenda11.default, { querySourceDetailStore: store })
      );
    }

    /**
     * On sort change
     * @param {string} columnKey
     * @param {string} sortDir
     */


    /**
     * Render column name
     * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
     */


    /**
     * Is the text highlight when match searching
     * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
     */


    /**
     * Render Data Type column
     * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
     */


    /**
     * Render Delete column
     * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
     */


    /**
     * Render Column Alias
     * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
     * @param {string} key
     * @param {number} index
     */


    /**
     * Render Visible column
     * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
     */


    /**
     * Render Filterable column
     * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
     */

  }, {
    key: 'renderExecuteButton',


    /**
     * Render Execute button
     */
    value: function renderExecuteButton() {
      var _props2 = this.props,
          localization = _props2.localization,
          querySourceType = _props2.querySourceType,
          store = _props2.store;

      if (_Izenda2.QUERY_SOURCE_TYPE.STORED_PROC !== querySourceType) {
        return null;
      }

      var onExecuteClick = function onExecuteClick() {
        store.executeStoreProc();
      };

      return _react2.default.createElement(_Izenda7.default, {
        label: localization.getText('COPY_MANAGEMENT_LABEL_EXECUTE'),
        className: 'u_floatRight',
        onClick: onExecuteClick,
        disabled: store.isDynamic()
      });
    }

    /**
     * Render Add Calculated Field button
     */

  }, {
    key: 'renderAddCalculatedFieldButton',
    value: function renderAddCalculatedFieldButton() {
      var _this2 = this;

      var _props3 = this.props,
          localization = _props3.localization,
          store = _props3.store,
          querySourceType = _props3.querySourceType;

      if (_Izenda2.QUERY_SOURCE_TYPE.STORED_PROC === querySourceType) {
        return null;
      }

      var onAddButtonClick = function onAddButtonClick() {
        store.loadFieldNameForExpression();

        _this2.props.openPopup(_Izenda17.default, {
          store: store.calculatedStore,
          onClose: _this2.closeCalculatedPopup,
          type: _Izenda18.TYPES.ADD,
          querySourceId: store.details.id,
          value: {},
          expressionConfig: _Izenda.EXPRESSION_SELECTION,
          isCheckDuplicateWithActualField: false
        });
      };

      return _react2.default.createElement(_Izenda7.default, {
        className: 'u_floatRight',
        label: localization.getText('COPY_MANAGEMENT_LABEL_ADD_FIELD'),
        onClick: onAddButtonClick
      });
    }

    /**
     * On close Calculated Field popup
     * @param {Object} calculatedData
     */

  }]);
  return QuerySourceTypeDetails;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object.isRequired,
  searchProperty: _propTypes2.default.string,
  searchValue: _propTypes2.default.string
}, _temp)) || _class);
exports.default = QuerySourceTypeDetails;
module.exports = exports['default'];

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(159);

var _Izenda2 = __webpack_require__(619);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(228);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Render filter value column
 * @param {QuerySourceFieldDetailsStore} querySourceFieldStore
 */
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterValuesColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Filter Value Column render function
 */
function renderFilterValues(querySourceFieldStore) {
  var filterValue = querySourceFieldStore.getFilterValues();
  var type = filterValue.type;
  var isDisableFilterLookup = querySourceFieldStore.isDisableFilterLookup;
  var _props = this.props,
      store = _props.store,
      querySourceType = _props.querySourceType;

  var isInvalidFilterLookup = querySourceFieldStore.isInvalidFilterLookup;
  // Only support filter lookup for Table/Views/Param on Stored
  var showEditIcon = querySourceType !== _Izenda.QUERY_SOURCE_TYPE.STORED_PROC || querySourceFieldStore.isParameter;

  function showFilterValueDialog() {
    store.editingQuerySourceField = querySourceFieldStore;
    store.isEditingFilter = true;
  }

  /**
   * Render popup content when using user defined filter
   */
  function renderUserDefined() {
    var displayValue = filterValue.userDefinedValues.join();
    return _react2.default.createElement(
      'div',
      { className: 'filterValueText', title: displayValue },
      _react2.default.createElement(
        'span',
        null,
        displayValue
      )
    );
  }

  /**
   * Render popup content when using lookup key
   */
  function renderDatabaseFilter() {
    var querySourceName = filterValue.querySourceName,
        lookupKeyQuerySourceFieldName = filterValue.lookupKeyQuerySourceFieldName,
        displayQuerySourceFieldName = filterValue.displayQuerySourceFieldName;

    var fieldName = lookupKeyQuerySourceFieldName + '-' + displayQuerySourceFieldName;
    var tooltip = querySourceName + '\n' + fieldName;

    return _react2.default.createElement(
      'div',
      { className: 'filterValueText', title: tooltip },
      querySourceName,
      _react2.default.createElement('br', null),
      fieldName
    );
  }

  /**
   * Render popup content base on user type
   */
  function renderDisplayValue() {
    switch ((0, _fp.toString)(type)) {
      case _Izenda.FILTER_TYPE.DB_STRUCTURE:
        return renderDatabaseFilter();
      case _Izenda.FILTER_TYPE.USER_DEFINED:
        return renderUserDefined();
      default:
        return _react2.default.createElement('div', { className: 'filterValueText' });
    }
  }

  /**
   * Render invalid filter lookup icon
   */
  function renderInvalidFilterLookup() {
    var filterLookupStatus = querySourceFieldStore.getFilterLookupStatus();
    var databaseName = filterValue.databaseName,
        querySourceCategoryAndName = filterValue.querySourceName,
        lookupKeyQuerySourceFieldName = filterValue.lookupKeyQuerySourceFieldName,
        displayQuerySourceFieldName = filterValue.displayQuerySourceFieldName,
        querySourceCategoryName = filterValue.querySourceCategoryName;

    // Build invalid field(s)

    var buildField = function buildField(fieldType) {
      if (!querySourceCategoryName) {
        return [];
      }
      var querySourceName = querySourceCategoryAndName.substring(querySourceCategoryName.length + 1);
      var fullQuerySourceName = [databaseName, querySourceCategoryName, querySourceName];
      switch (fieldType) {
        case 'Lookup':
          return [].concat(fullQuerySourceName, [lookupKeyQuerySourceFieldName]);
        case 'Display':
          return [].concat(fullQuerySourceName, [displayQuerySourceFieldName]);
        case 'Both':
        default:
          return [].concat(fullQuerySourceName, [lookupKeyQuerySourceFieldName + ']-[' + displayQuerySourceFieldName]);
      }
    };

    // Add bracket
    var buildFullPath = function buildFullPath(fieldType) {
      return (0, _fp.flow)((0, _fp.map)(function (part) {
        return '[' + part + ']';
      }), (0, _fp.join)('.'))(buildField(fieldType));
    };

    // Get tooltip text
    var getTooltip = function getTooltip() {
      switch (filterLookupStatus) {
        case _Izenda4.FILTER_LOOKUP_STATUSES.INVALID_CONNECTION:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_LOOKUP_CONNECTION'), buildFullPath('Both'));
        case _Izenda4.FILTER_LOOKUP_STATUSES.INVALID_QUERY_SOURCE:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_LOOKUP_QUERY_SOURCE'), buildFullPath('Both'));
        case _Izenda4.FILTER_LOOKUP_STATUSES.LOOKUP_IS_TENANT_FIELD:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_TENANT_FIELD'), buildFullPath('Lookup'));
        case _Izenda4.FILTER_LOOKUP_STATUSES.LOOKUP_INVISIBLE:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_INVISIBLE_FIELD'), buildFullPath('Lookup'));
        case _Izenda4.FILTER_LOOKUP_STATUSES.DISPLAY_IS_TENANT_FIELD:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_TENANT_FIELD'), buildFullPath('Display'));
        case _Izenda4.FILTER_LOOKUP_STATUSES.DISPLAY_INVISIBLE:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_INVISIBLE_FIELD'), buildFullPath('Display'));
        case _Izenda4.FILTER_LOOKUP_STATUSES.LOOKUP_IS_TENANT_FIELD | _Izenda4.FILTER_LOOKUP_STATUSES.DISPLAY_IS_TENANT_FIELD:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_TENANT_BOTH_FIELD'), buildFullPath('Both'));
        case _Izenda4.FILTER_LOOKUP_STATUSES.LOOKUP_INVISIBLE | _Izenda4.FILTER_LOOKUP_STATUSES.DISPLAY_INVISIBLE:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_INVISIBLE_BOTH_FIELD'), buildFullPath('Both'));
        case _Izenda4.FILTER_LOOKUP_STATUSES.LOOKUP_IS_TENANT_FIELD | _Izenda4.FILTER_LOOKUP_STATUSES.DISPLAY_INVISIBLE:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_TENANT_FIELD'), buildFullPath('Lookup')) + '\n' + String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_INVISIBLE_FIELD'), buildFullPath('Display'));
        case _Izenda4.FILTER_LOOKUP_STATUSES.LOOKUP_INVISIBLE | _Izenda4.FILTER_LOOKUP_STATUSES.DISPLAY_IS_TENANT_FIELD:
          return String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_INVISIBLE_FIELD'), buildFullPath('Lookup')) + '\n' + String.format(_Izenda6.default.getText('DATA_MODEL_TOOLTIP_INVALID_FILTER_TENANT_FIELD'), buildFullPath('Display'));
        default:
          return '';
      }
    };

    return _react2.default.createElement('span', { className: 'icon-info-circled filterLookupErrorIndicator', title: getTooltip() });
  }

  var onClick = isDisableFilterLookup ? _fp.noop : showFilterValueDialog;

  return showEditIcon && _react2.default.createElement(
    'div',
    { className: 'u-posRelative' },
    renderDisplayValue(),
    isInvalidFilterLookup && (0, _fp.toString)(type) === _Izenda.FILTER_TYPE.DB_STRUCTURE && renderInvalidFilterLookup(),
    _react2.default.createElement('icon', {
      'data-toggle': 'modal',
      className: 'btn icon-pencil filterValueIcon center',
      onClick: onClick,
      disabled: isDisableFilterLookup
    })
  );
}

exports.default = {
  render: renderFilterValues
};
module.exports = exports['default'];

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(2311);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2313);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * FilterValueContainer
 */
var FilterValueContainer = function FilterValueContainer(props) {
  var store = new _Izenda4.default(props.querySourceDetailStore);
  return _react2.default.createElement(_Izenda2.default, { store: store });
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.FilterValueContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * StoredProc component
 */
exports.default = FilterValueContainer;
module.exports = exports['default'];

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.FiltterValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2312);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda9 = __webpack_require__(228);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterValue = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FilterValue, _Component);

  function FilterValue() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FilterValue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FilterValue.__proto__ || (0, _getPrototypeOf2.default)(FilterValue)).call.apply(_ref, [this].concat(args))), _this), _this.updateFilterMode = function (event) {
      var value = event.target.value;
      var store = _this.props.store;

      store.updateFilterMode(value);
    }, _this.onClosingPopup = function (close, type) {
      var _this2 = _this,
          store = _this2.props.store;

      if (type === 'accept') {
        _this.props.validation.validate().then(function (success) {
          if (success) {
            store.saveFillerValue();
            close();
            store.resetPopup();
          }
        });
      } else if (type === 'cancel') {
        close();
        store.resetPopup();
      }
    }, _this.onChangeDbName = function (newValue) {
      _this.props.store.setDbName({ key: newValue.value, value: newValue.label }).then(function () {
        return _this.props.validation.validate();
      });
    }, _this.onChangeTable = function (newValue) {
      _this.props.store.setTable({ key: newValue.value, value: newValue.label }).then(function () {
        return _this.props.validation.validate();
      });
    }, _this.onChangeLookupKey = function (newValue) {
      _this.props.store.setLookupKey({ key: newValue.value, value: newValue.label });
    }, _this.onChangeDisplayValue = function (newValue) {
      _this.props.store.setDisplayValue({ key: newValue.value, value: newValue.label });
    }, _this.onChangeUserDefinedFilterValue = function (value) {
      _this.props.store.setUserDefinedFilterValue(value);
    }, _this.onAddNewUserDefinedFilterValue = function (newOption) {
      _this.props.store.addNewFilterValue(newOption);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FilterValue, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.props.store;

      store.getDatabaseList();
      store.getSystemVariables();
    }

    /**
     * Update filter mode
     * @param {Event} event Change option event
     */


    /**
     * On closing popup
     * @param {Function} close Close popup function
     * @param {string} type Close action
     */


    /**
     * On change DB
     * @param {Object} newValue New DB
     */


    /**
     * On change table
     * @param {Object} newValue New table
     */


    /**
     * On change lookup
     * @param {Object} newValue New lookup key
     */


    /**
     * On change display value
     * @param {Object} newValue New display value
     */


    /**
     * On change user defined value
     * @param {Object} value value
     */


    /**
     * On add new user defined value
     * @param {Object} newOption New value
     */

  }, {
    key: 'renderFilterByKey',


    /**
     * Render content in DB lookup mode
     */
    value: function renderFilterByKey() {
      var _props = this.props,
          store = _props.store,
          dbStructureValue = _props.store.dbStructureValue,
          localization = _props.localization;


      return _react2.default.createElement(
        'section',
        { className: 'form-horizontal' },
        _react2.default.createElement(_Izenda6.default, {
          options: store.connectionList,
          onChange: this.onChangeDbName,
          value: dbStructureValue.database.key,
          label: localization.getText('COMMON_LABEL_DATABASE_NAME')
        }),
        _react2.default.createElement(_Izenda6.default, {
          options: store.tableList,
          onChange: this.onChangeTable,
          value: dbStructureValue.table.key,
          label: localization.getText('COMMON_LABEL_TABLE_NAME')
        }),
        _react2.default.createElement(_Izenda6.default, {
          options: store.fieldList,
          onChange: this.onChangeLookupKey,
          value: dbStructureValue.lookupKey.key,
          label: localization.getText('SETTINGS_LABEL_LOOKUP_KEY')
        }),
        _react2.default.createElement(_Izenda6.default, {
          options: store.fieldList,
          onChange: this.onChangeDisplayValue,
          value: dbStructureValue.displayValue.key,
          label: localization.getText('SETTINGS_LABEL_DISPLAY_VALUE')
        })
      );
    }

    /**
     * Render content in user defined mode
     */

  }, {
    key: 'renderDefinedFilterValue',
    value: function renderDefinedFilterValue() {
      var _props2 = this.props,
          localization = _props2.localization,
          store = _props2.store;

      return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(_Izenda8.default, {
          multi: true,
          simpleValue: true,
          options: this.props.store.userDefinedOptions,
          labelKey: 'name',
          valueKey: 'id',
          value: store.userDefinedValue,
          noResultsText: localization.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_FILTER_VALUE_ENTER_TO_CREATE_NEW_FILTER_VALUE'),
          onChange: this.onChangeUserDefinedFilterValue,
          onAddNew: this.onAddNewUserDefinedFilterValue,
          scalable: false
        })
      );
    }

    /**
     * Render control by mode
     * @param {number} filterMode The field filter mode
     */

  }, {
    key: 'renderControlByMode',
    value: function renderControlByMode(filterMode) {
      var store = this.props.store;


      return filterMode === store.filterMode && (filterMode === _Izenda9.FILTER_MODE.DbStructure ? this.renderFilterByKey() : this.renderDefinedFilterValue());
    }

    /**
     * Render filter value popup content
     * @param {string} groupName
     * @param {string} filterMode
     * @param {string} title
     */

  }, {
    key: 'renderFilterContent',
    value: function renderFilterContent(groupName, filterMode, title) {
      var store = this.props.store;

      return _react2.default.createElement(
        'div',
        { className: 'radio' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement('input', {
            type: 'radio',
            name: groupName,
            value: filterMode,
            checked: store.filterMode === filterMode,
            onChange: this.updateFilterMode
          }),
          title
        ),
        this.renderControlByMode(filterMode)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          store = _props3.store,
          localization = _props3.localization;


      return _react2.default.createElement(
        _Izenda4.default,
        { type: 'none', visible: store.showPopup, autoClose: false, onClosing: this.onClosingPopup },
        _react2.default.createElement(_Izenda4.default.Header, { title: localization.getText('SETTINGS_LABEL_FILTER_VALUE') }),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          _react2.default.createElement(
            'form',
            null,
            this.renderFilterContent('optradio', _Izenda9.FILTER_MODE.DbStructure, localization.getText('SETTINGS_LABEL_FILTER_LOOKUP')),
            this.renderFilterContent('optradio', _Izenda9.FILTER_MODE.UserDefined, localization.getText('SETTINGS_LABEL_USER_DEFINE'))
          )
        ),
        _react2.default.createElement(
          _Izenda4.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return FilterValue;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = FilterValue;
module.exports = exports['default'];

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(29);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(228);

var _mobxReact = __webpack_require__(10);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.LabelDropDownList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var ValidatorDropDown = (0, _Izenda4.default)()(_Izenda2.default);
var LabelDropDownList = function LabelDropDownList(props) {
  return _react2.default.createElement(
    'div',
    { className: 'form-group' },
    _react2.default.createElement(
      'label',
      { className: 'control-label col-xs-4' },
      props.label
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-xs-8' },
      _react2.default.createElement(ValidatorDropDown, {
        group: props.label,
        validations: _Izenda5.CONSTRAINTS,
        options: props.options,
        onChange: props.onChange,
        value: props.value,
        valueField: 'key',
        labelField: 'value'
      })
    )
  );
};

LabelDropDownList.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.object.isRequired,
  label: _propTypes2.default.string.isRequired
};

exports.default = (0, _mobxReact.observer)(LabelDropDownList);
module.exports = exports['default'];

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8; // ----------------------------------------------------------------------
// <copyright file="Izenda.FilterValueStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(228);

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda2 = __webpack_require__(2314);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(75);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(159);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var FilterValueStore = (_class = function () {
  (0, _createClass3.default)(FilterValueStore, [{
    key: 'tenantId',
    get: function get() {
      return _IzendaUiState2.default.getTenantId();
    }
  }, {
    key: 'showPopup',
    get: function get() {
      return !(0, _fp.isNil)(this.editingFilterValue) && this.querySourceDetailStore.isEditingFilter;
    }
  }]);

  function FilterValueStore(querySourceDetailStore) {
    (0, _classCallCheck3.default)(this, FilterValueStore);

    _initDefineProp(this, 'filterMode', _descriptor, this);

    _initDefineProp(this, 'connectionList', _descriptor2, this);

    _initDefineProp(this, 'tableList', _descriptor3, this);

    _initDefineProp(this, 'fieldList', _descriptor4, this);

    _initDefineProp(this, 'displayValueList', _descriptor5, this);

    _initDefineProp(this, 'dbStructureValue', _descriptor6, this);

    _initDefineProp(this, 'userDefinedValue', _descriptor7, this);

    _initDefineProp(this, 'userDefinedOptions', _descriptor8, this);

    this.querySourceDetailStore = querySourceDetailStore;
    this.firstLoad = true;
    this.editingQuerySourceField = querySourceDetailStore.editingQuerySourceField;
    this.editingFilterValue = this.editingQuerySourceField.getFilterValues();

    this.filterMode = !(0, _fp.isNil)(this.editingFilterValue) && (0, _fp.toString)(this.editingFilterValue.type) === _Izenda6.FILTER_TYPE.USER_DEFINED ? _Izenda.FILTER_MODE.UserDefined : _Izenda.FILTER_MODE.DbStructure;

    this.dbStructureValue = {
      database: this.editingFilterValue && this.editingFilterValue.databaseId ? { key: this.editingFilterValue.databaseId, value: this.editingFilterValue.databaseName } : {},
      table: this.editingFilterValue && this.editingFilterValue.querySourceId ? { key: this.editingFilterValue.querySourceId, value: this.editingFilterValue.querySourceName } : {},
      lookupKey: this.editingFilterValue && this.editingFilterValue.lookupKeyQuerySourceFieldId ? {
        key: this.editingFilterValue.lookupKeyQuerySourceFieldId,
        value: this.editingFilterValue.lookupKeyQuerySourceFieldName
      } : {},
      displayValue: this.editingFilterValue && this.editingFilterValue.displayQuerySourceFieldId ? {
        key: this.editingFilterValue.displayQuerySourceFieldId,
        value: this.editingFilterValue.displayQuerySourceFieldName
      } : {}
    };
    this.userDefinedValue = this.editingFilterValue && this.editingFilterValue.userDefinedValues ? this.editingFilterValue.userDefinedValues.join(',') : '';

    this.setCurrentValueToOptions();
  }

  /**
   * Update Filter mode
   * @param {type} filterMode
   */


  (0, _createClass3.default)(FilterValueStore, [{
    key: 'updateFilterMode',
    value: function updateFilterMode(filterMode) {
      this.filterMode = filterMode;
    }

    /**
     * Set value for dropdown
     * @param {Array<Object>} response
     * @param {Object} properties
     * @param {Function} functionSetData
     * @param {Function} functionsSetEmpty
     */

  }, {
    key: 'setValueForDropDown',
    value: function setValueForDropDown(response, properties, functionSetData, functionsSetEmpty) {
      var _this = this;

      var setEmptyData = function setEmptyData() {
        functionSetData.call(_this, {});
        functionsSetEmpty.forEach(function (functionToSet) {
          return functionToSet.call(_this, {});
        });
        return (0, _bluebird.resolve)();
      };

      if (!(0, _fp.isEmpty)(response)) {
        var allAvailableKeys = (0, _fp.map)('key', response);
        return properties.key ? (0, _fp.includes)(properties.key, allAvailableKeys) ? functionSetData.call(this, properties) : setEmptyData() : functionSetData.call(this, (0, _fp.first)(response));
      } else {
        return setEmptyData();
      }
    }

    /**
     * Get Database list
     */

  }, {
    key: 'getDatabaseList',
    value: function getDatabaseList() {
      var _this2 = this;

      return _Izenda3.default.getDatabaseList(this.tenantId).then(function (response) {
        _this2.connectionList = response;
        return _this2.setValueForDropDown(response, _this2.dbStructureValue.database, _this2.setDbName, [_this2.setTable, _this2.setLookupKey, _this2.setDisplayValue]);
      });
    }

    /**
     * Set current value to options
     */

  }, {
    key: 'setCurrentValueToOptions',
    value: function setCurrentValueToOptions() {
      var _this3 = this;

      if (this.userDefinedValue) {
        var userDefineValueList = (0, _fp.map)(function (value) {
          return {
            name: value,
            id: value,
            isNew: true
          };
        }, (0, _fp.split)(',', this.userDefinedValue));

        userDefineValueList.forEach(function (value) {
          return _this3.addNewFilterValue(value);
        });
      }
    }

    /**
     * Get system variables
     */

  }, {
    key: 'getSystemVariables',
    value: function getSystemVariables() {
      var _this4 = this;

      return _Izenda5.default.getSystemVariables().then(function (response) {
        if (!(0, _fp.isEmpty)(response)) {
          response.forEach(function (option) {
            return _this4.userDefinedOptions.push({
              name: option,
              id: option,
              isNew: false
            });
          });
        }
      });
    }

    /**
     * Get table list
     * @param {string} connectionId The connection id
     */

  }, {
    key: 'getTableList',
    value: function getTableList(connectionId) {
      var _this5 = this;

      return _Izenda3.default.getTableList(connectionId).then(function (response) {
        _this5.tableList = response;
        return _this5.setValueForDropDown(response, _this5.dbStructureValue.table, _this5.setTable, [_this5.setLookupKey, _this5.setDisplayValue]);
      });
    }

    /**
     * Get field list
     * @param {string} tableId The table id
     */

  }, {
    key: 'getFieldList',
    value: function getFieldList(tableId) {
      var _this6 = this;

      return _Izenda3.default.getFieldList(tableId).then(function (response) {
        _this6.fieldList = response;

        _this6.setValueForDropDown(response, _this6.dbStructureValue.lookupKey, _this6.setLookupKey, []);
        _this6.setValueForDropDown(response, _this6.dbStructureValue.displayValue, _this6.setDisplayValue, []);

        _this6.firstLoad = false;
      });
    }

    /**
     * Set DB Name after get list database
     * @param {any} newValue Contains info of the new db
     */

  }, {
    key: 'setDbName',
    value: function setDbName(newValue) {
      this.dbStructureValue.database = newValue;
      if (!this.firstLoad) this.dbStructureValue.table = {};
      this.tableList = [];
      if (newValue.key) {
        return this.getTableList(newValue.key);
      }
    }

    /**
     * Set Table after get list table
     * @param {any} newValue Contains info of the new table
     */

  }, {
    key: 'setTable',
    value: function setTable(newValue) {
      this.dbStructureValue.table = newValue;
      if (!this.firstLoad) {
        this.dbStructureValue.lookupKey = {};
        this.dbStructureValue.displayValue = {};
      }
      this.fieldList = [];
      if (newValue.key) {
        return this.getFieldList(newValue.key);
      }
    }

    /**
     * Set Lookup key value
     * @param {string} newValue New lookup key
     */

  }, {
    key: 'setLookupKey',
    value: function setLookupKey(newValue) {
      this.dbStructureValue.lookupKey = newValue;
    }

    /**
     * Set display value
     * @param {string} newValue New display value
     */

  }, {
    key: 'setDisplayValue',
    value: function setDisplayValue(newValue) {
      this.dbStructureValue.displayValue = newValue;
    }

    /**
     * Save filter value
     */

  }, {
    key: 'saveFillerValue',
    value: function saveFillerValue() {
      this.editingQuerySourceField.setFilterValues(this.getFilterValue());
      this.editingQuerySourceField.setValidFilterLookup();
    }

    /**
     * Get Filter value
     */

  }, {
    key: 'getFilterValue',
    value: function getFilterValue() {
      if (this.filterMode === _Izenda.FILTER_MODE.DbStructure) {
        return {
          type: _Izenda6.FILTER_TYPE.DB_STRUCTURE,
          databaseName: this.dbStructureValue.database.value,
          databaseId: this.dbStructureValue.database.key,
          querySourceName: this.dbStructureValue.table.value,
          querySourceId: this.dbStructureValue.table.key,
          lookupKeyQuerySourceFieldName: this.dbStructureValue.lookupKey.value,
          lookupKeyQuerySourceFieldId: this.dbStructureValue.lookupKey.key,
          displayQuerySourceFieldName: this.dbStructureValue.displayValue.value,
          displayQuerySourceFieldId: this.dbStructureValue.displayValue.key,
          userDefinedValues: []
        };
      } else {
        return {
          type: _Izenda6.FILTER_TYPE.USER_DEFINED,
          userDefinedValues: (0, _fp.split)(',', this.userDefinedValue)
        };
      }
    }

    /**
     * Set user defined value
     * @param {string} value User defined value
     */

  }, {
    key: 'setUserDefinedFilterValue',
    value: function setUserDefinedFilterValue(value) {
      this.userDefinedValue = value;
    }

    /**
     * Reset popup
     */

  }, {
    key: 'resetPopup',
    value: function resetPopup() {
      this.querySourceDetailStore.editingQuerySourceField = null;
      this.querySourceDetailStore.isEditingFilter = false;
    }

    /**
     * Add new filter value
     * @param {any} newValue New filter value
     */

  }, {
    key: 'addNewFilterValue',
    value: function addNewFilterValue(newValue) {
      if (!(0, _fp.some)((0, _fp.omit)(['isNew'], newValue), this.userDefinedOptions)) {
        this.userDefinedOptions.push(newValue);
      }
    }
  }]);
  return FilterValueStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'filterMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'connectionList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'tableList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'fieldList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'displayValueList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'dbStructureValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'userDefinedValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'userDefinedOptions', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tenantId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showPopup', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'showPopup'), _class.prototype)), _class);
exports.default = FilterValueStore;
module.exports = exports['default'];

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterValueDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

var ROOT_URL = 'dataModel/';

exports.default = {
  getDatabaseList: function getDatabaseList(tenantId) {
    tenantId = (0, _fp.isEmpty)(tenantId) ? '' : tenantId;
    return (0, _Izenda2.default)('connection/basicinfo/' + tenantId).get();
  },
  getTableList: function getTableList(connectionId) {
    return (0, _Izenda2.default)(ROOT_URL + 'basicQuerySourcesInfo/' + connectionId + '/Table').get();
  },
  getFieldList: function getFieldList(connectionId) {
    return (0, _Izenda2.default)(ROOT_URL + 'basicQuerySourceFieldsInfo/' + connectionId).get();
  }
};
module.exports = exports['default'];

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleSetup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2316);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2319);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(196);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2345);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(27);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2348);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(156);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2);

var _Izenda16 = _interopRequireDefault(_Izenda15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoleSetup = (_dec = (0, _Izenda16.default)(_Izenda12.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RoleSetup, _Component);

  function RoleSetup() {
    (0, _classCallCheck3.default)(this, RoleSetup);
    return (0, _possibleConstructorReturn3.default)(this, (RoleSetup.__proto__ || (0, _getPrototypeOf2.default)(RoleSetup)).apply(this, arguments));
  }

  (0, _createClass3.default)(RoleSetup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.store !== nextProps.store) {
        nextProps.loadData();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.disposeChangeTenant();
      this.props.store.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          authorization = _props.authorization,
          PERMISSION_KEY = _props.authorizationConstants.PERMISSION_KEY;

      var isNew = store.roleDetail.isNew;
      var allowCreate = authorization.checkPrivileges([PERMISSION_KEY.RoleSetupActionsCreate]);
      var allowEdit = authorization.checkPrivileges([PERMISSION_KEY.RoleSetupActionsEdit]);

      return _react2.default.createElement(
        'div',
        { className: 'izenda-TableLayout' },
        _react2.default.createElement(
          _Izenda6.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'u_fullHeight u-posRelative u-bgWhite' },
            _react2.default.createElement(
              'div',
              { className: 'izenda-MiddlePanel-search' },
              _react2.default.createElement(_Izenda8.default, { store: store, readOnly: !allowCreate })
            ),
            _react2.default.createElement(
              'div',
              { className: 'izenda-MiddlePanel-content' },
              _react2.default.createElement(
                _Izenda10.default,
                null,
                _react2.default.createElement(_Izenda2.default, { store: store, readOnly: !allowEdit })
              )
            )
          )
        ),
        _react2.default.createElement(
          _Izenda14.default,
          null,
          _react2.default.createElement(_Izenda4.default, { store: store, readOnly: !(allowEdit || isNew) })
        )
      );
    }
  }]);
  return RoleSetup;
}(_react.Component)) || _class);
exports.default = RoleSetup;
module.exports = exports['default'];

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant List component
 */
!function () {
  var React = __webpack_require__(0);
  var Item = __webpack_require__(2317);
  var connect = __webpack_require__(2);

  var RoleList = connect()(function () {
    var props = this.props;
    var store = props.store;
    var roleList = store.roleList.filterRole;

    return React.createElement(
      'div',
      null,
      roleList.map(function (item) {
        return React.createElement(Item, { roleInfo: item,
          store: store,
          key: item.id,
          readOnly: props.readOnly });
      })
    );
  });

  RoleList.propTypes = {
    store: React.PropTypes.object.isRequired
  };

  module.exports = RoleList;
}();

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/**
 * Tenant Item component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);
  var TextHighLight = __webpack_require__(62);
  var constants = __webpack_require__(232);
  var GridLayout = __webpack_require__(13);
  var action = __webpack_require__(2318);
  var DeleteIcon = __webpack_require__(1152);
  var PERMISSION_KEY = __webpack_require__(42).PERMISSION_KEY;

  var RoleItem = action(function (props) {
    var store = props.store;
    var roleInfo = props.roleInfo;
    var displayName = roleInfo.name;
    var classes = classnames('u_paddingAll u_curPointer', 'truncate', { 'u-bgGray': props.roleInfo.isSelected });
    var tenantStatus = roleInfo.active ? constants.ROLE_STATE.DEACTIVATE : constants.ROLE_STATE.ACTIVATE;
    var onClick = !props.readOnly && props.onToggleActive;
    var hasEditPrivilege = props.authorization.checkPrivileges([PERMISSION_KEY.RoleSetupActionsEdit]);

    return React.createElement(
      'div',
      { className: classes, onClick: props.onSelectRole },
      React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          { className: 'izenda-RoleItem' },
          React.createElement(
            GridLayout.Col,
            { cols: 7, className: 'overflow-text' },
            React.createElement(TextHighLight, {
              highlight: store.roleList.filterText,
              text: displayName,
              tooltip: displayName })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 5 },
            React.createElement(
              'div',
              { className: 'pull-right' },
              hasEditPrivilege && React.createElement(
                'a',
                { className: classnames('izenda-TenantStatus', { 'izenda-TenantStatus-Deactivate': roleInfo.active }),
                  onClick: onClick },
                tenantStatus
              ),
              React.createElement(DeleteIcon, { keys: [props.authorizationConstants.PERMISSION_KEY.RoleSetupActionsDel],
                onClick: props.onDelete,
                disabled: props.readOnly })
            )
          )
        )
      )
    );
  });

  RoleItem.propTypes = {
    roleInfo: React.PropTypes.object.isRequired,
    store: React.PropTypes.object.isRequired
  };

  module.exports = connect()(RoleItem);
}();

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleItemAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(232);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      get = _require.get;

  var roleSetupAction = compose(connect(), withHandlers({
    onToggleActive: curry(onToggleActive),
    onDelete: curry(onDelete),
    onSelectRole: curry(onSelectRole)
  }), observer);

  /**
   * [on Toggle Active ]
   * @param  {object} props
   */
  function onToggleActive(props, e) {
    var loader = props.loader;
    var store = props.store;
    var role = props.roleInfo;

    e.stopPropagation();
    var togglePromise = role.active ? props.confirmFn('Confirmation', {
      description: constants.MESSAGE.DEACTIVE
    }) : (0, _bluebird.resolve)();

    loader.startLoading();
    togglePromise.then(store.toggleActive.bind(store, props.roleInfo)).then(function (result) {
      // Handle toggle error here
      if (result.success === false) {
        var listMessage = get('messages', result);
        if (listMessage) {
          var messageObj = listMessage[0];
          var messages = get('messages', messageObj);
          if (messages) {
            return props.confirmMessage('error', messages[0]);
          }
        }
      }
    }).finally(loader.endLoading.bind(loader));
  }

  /**
   * [onDelete action]
   * @param  {object} props
   */
  function onDelete(props, e) {
    var loader = props.loader;
    var store = props.store;

    e.stopPropagation();
    loader.startLoading();
    props.confirmFn('Confirmation', {
      description: constants.MESSAGE.DELETE
    }).then(store.deleteRole.bind(store, props.roleInfo)).finally(loader.endLoading.bind(loader));
  }

  /**
   * [on Select Role action]
   * @param  {object} props
   */
  function onSelectRole(props, e) {
    e.stopPropagation();
    if (props.roleInfo.isSelected) {
      return;
    }

    var loader = props.loader;
    var store = props.store;

    loader.startLoading();
    props.confirmDirtyForm(store.isDirty).then(function () {
      props.validation.reset();
      return store.selectRole(props.roleInfo);
    }).finally(loader.endLoading.bind(loader));
  }

  module.exports = roleSetupAction;
}();

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2320);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var RoleDetail = function RoleDetail(_ref) {
  var store = _ref.store,
      readOnly = _ref.readOnly;
  var _store$roleDetail = store.roleDetail,
      key = _store$roleDetail.key,
      active = _store$roleDetail.active;

  return _react2.default.createElement(
    'div',
    { className: 'izenda-Wrapper', key: key },
    _react2.default.createElement(_Izenda2.default, { store: store, readOnly: readOnly || !active })
  );
};

RoleDetail.propTypes = {
  store: _propTypes2.default.object.isRequired,
  readOnly: _propTypes2.default.bool
};

exports.default = (0, _mobxReact.observer)(RoleDetail);
module.exports = exports['default'];

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(86);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(147);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2321);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2323);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2324);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2325);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.GeneralInfo.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function GeneralInfo(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'izenda-Wrapper-header' },
      _react2.default.createElement(_Izenda4.default, null),
      _react2.default.createElement(_Izenda10.default, { store: props.store }),
      !props.readOnly && _react2.default.createElement(_Izenda6.default, { onSave: props.onSave, onCancel: props.onCancel })
    ),
    _react2.default.createElement(
      'div',
      { className: 'izenda-Wrapper-content' },
      _react2.default.createElement(
        'div',
        { className: 'u_paddingLeftRight u_fullHeight' },
        _react2.default.createElement(_Izenda8.default, { store: props.store, readOnly: props.readOnly }),
        _react2.default.createElement(_Izenda14.default, { store: props.store, readOnly: props.readOnly })
      )
    )
  );
}

exports.default = (0, _Izenda2.default)(_Izenda12.default)(GeneralInfo);
module.exports = exports['default'];

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2322);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleName.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
var RoleName = function RoleName(_ref) {
  var localization = _ref.localization,
      store = _ref.store,
      readOnly = _ref.readOnly;

  return _react2.default.createElement(
    'div',
    { className: 'izenda-RoleName u_paddingInner u-bgWhite' },
    _react2.default.createElement(
      'div',
      { className: 'izenda-RoleName-label' },
      _react2.default.createElement(
        'label',
        { className: 'validation required control-label' },
        localization.getText('ROLE_SETUP_ROLE_DETAIL_LABEL_ROLE_NAME')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'izenda-RoleName-control' },
      _react2.default.createElement(_Izenda4.default, { store: store, readOnly: readOnly })
    )
  );
};

RoleName.propTypes = {
  store: _propTypes2.default.object.isRequired,
  readOnly: _propTypes2.default.bool
};

exports.default = (0, _Izenda2.default)()(RoleName);
module.exports = exports['default'];

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(24);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(232);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleNameInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ValidatorInput = (0, _Izenda4.default)()(_Izenda6.default);

function RoleNameInput(_ref) {
  var store = _ref.store,
      readOnly = _ref.readOnly;

  var roleDetail = store.roleDetail;
  var disabled = !roleDetail;

  return _react2.default.createElement(ValidatorInput, {
    className: 'inline-block form-control',
    field: 'Name',
    validations: _Izenda9.CONSTRAINTS.ROLE_NAME,
    value: (0, _fp.get)('name', roleDetail),
    onChange: !disabled && _Izenda8.default.notifyChange(roleDetail.updateName.bind(roleDetail), _Izenda8.default.INPUT),
    disabled: !roleDetail || readOnly
  });
}

RoleNameInput.propTypes = {
  store: _propTypes2.default.object.isRequired,
  readOnly: _propTypes2.default.bool
};

exports.default = (0, _Izenda2.default)()(RoleNameInput);
module.exports = exports['default'];

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(61);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RoleAlert(_ref) {
  var store = _ref.store;

  var alertMessage = store.alertMessage;
  if (!alertMessage.message) {
    return null;
  }

  return _react2.default.createElement(
    _Izenda4.default,
    { type: alertMessage.type },
    alertMessage.message
  );
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleAlert.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda2.default)()(RoleAlert);
module.exports = exports['default'];

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(37);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(232);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeneralInfoAction = (0, _recompose.withHandlers)({
  onSave: (0, _fp.curry)(onSave),
  onCancel: (0, _fp.curry)(onCancel)
});

/**
 * [onSave]
 * @param  {object} props
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.GeneralInfoAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function onSave(props, e) {
  var store = props.store;
  e.stopPropagation();
  e.preventDefault();

  props.validation.validate().then(function (success) {
    if (success) {
      if (store.isDirty) {
        store.validateAccesses().then(function (result) {
          if (result.success !== false) {
            if (store.roleDetail.isNew) {
              handleSave(props);
            } else {
              props.confirmFn('Confirmation', { description: _Izenda4.default.getText('COMMON_MESSAGES_CONFIRM_SAVE') }).then(function () {
                return handleSave(props);
              });
            }
          } else {
            props.validation.updateErrors(result.messages);
          }
        });
      } else {
        store.updateAlertMessage(_Izenda2.default.MESSAGE_TYPE.INFO, _Izenda4.default.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
      }
    }
  });
}

/**
 * [handleSave action]
 * @param  {object} props
 */
function handleSave(props) {
  var store = props.store;
  var loader = props.loader;

  loader.startLoading();
  store.save().then(function (messages) {
    var popupMessage = (0, _fp.flow)(_fp.toPairs, (0, _fp.map)(function (pair) {
      var key = pair[0];
      var value = pair[1];
      var currentError = (0, _fp.find)({ key: key }, messages);
      if (!currentError) {
        return '';
      }
      messages = (0, _fp.reject)({ key: key }, messages);
      return handlerError(currentError, value);
    }), _fp.compact, (0, _fp.join)('<br>'))(_Izenda6.default.PERMISSION_ERROR);
    if (popupMessage) {
      props.confirmFn('Information', {
        description: popupMessage,
        type: 'error',
        isHTMLFormat: true,
        showCloseIndicator: true
      });
    }

    messages && props.validation.updateErrors(messages);
  }).then(loader.endLoading.bind(loader));
}

function handlerError(messages, settingByKey) {
  var buildMessageCategory = function buildMessageCategory(category) {
    var subCategories = (0, _fp.isEmpty)(category.subCategories) ? '' : buildMessageCategories(category.subCategories);

    return String.format('<li>{0}{1}</li>', category.name, subCategories);
  };
  var buildMessageCategories = (0, _fp.flow)((0, _fp.sortBy)([function (category) {
    return category.id === _Izenda6.default.EMPTY_GUID;
  }, (0, _fp.flow)((0, _fp.get)('name'), _fp.toUpper)]), (0, _fp.map)(buildMessageCategory), (0, _fp.join)(''), function (text) {
    return String.format('<ul>{0}</ul>', text);
  });

  return String.format(_Izenda6.default.MESSAGE.PERMISSION_ERROR, settingByKey.type, settingByKey.permission, buildMessageCategories(messages.detail));
}

/**
 * [onCancel]
 * @param  {object} props
 */
function onCancel(props, e) {
  var loader = props.loader,
      store = props.store;

  e.stopPropagation();
  e.preventDefault();

  if (store.isDirty) {
    props.confirmFn('Confirmation', {
      description: _Izenda4.default.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
    }).then(function () {
      loader.startLoading();
      return store.cancel().finally(loader.endLoading.bind(loader));
    }).finally(loader.endLoading.bind(loader));
  } else {
    store.updateAlertMessage(_Izenda2.default.MESSAGE_TYPE.INFO, _Izenda4.default.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
  }
}

exports.default = GeneralInfoAction;
module.exports = exports['default'];

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.MainContentRoleSetup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(131);

var _Izenda4 = __webpack_require__(1145);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(2326);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(2328);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(2342);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainContentRoleSetup = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(MainContentRoleSetup, _Component);

  function MainContentRoleSetup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MainContentRoleSetup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MainContentRoleSetup.__proto__ || (0, _getPrototypeOf2.default)(MainContentRoleSetup)).call.apply(_ref, [this].concat(args))), _this), _this.validationBeforeChangeTabs = function () {
      var _this$props = _this.props,
          store = _this$props.store,
          validation = _this$props.validation;

      return validation.validate().then(function (success) {
        if (success) {
          return store.validateAccesses().then(function (result) {
            if (result.success === false) {
              return validation.updateErrors(result.messages);
            } else {
              return (0, _bluebird.resolve)(true);
            }
          });
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MainContentRoleSetup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          readOnly = _props.readOnly,
          localization = _props.localization,
          authorization = _props.authorization,
          PERMISSION_KEY = _props.authorizationConstants.PERMISSION_KEY;

      var dataModelAccessPrivilege = authorization.checkPrivileges([PERMISSION_KEY.RoleSetupDataModelAccessValue]);
      var permissionsPrivilege = authorization.checkPrivileges([PERMISSION_KEY.RoleSetupPermissionsValue]);
      var userRoleAssociation = authorization.checkPrivileges([PERMISSION_KEY.UserSetupUserRoleAssociationValue]);
      var tabs = [];

      dataModelAccessPrivilege && tabs.push(_react2.default.createElement(
        _Izenda3.Tab,
        {
          key: 'dataModelAccess',
          title: localization.getText('ROLE_SETUP_DATA_MODEL_ACCESS'),
          tabKey: 'dataModelAccess',
          className: 'u_fullSize'
        },
        _react2.default.createElement(_Izenda7.default, { dataModelAccess: store.dataModelAccess, readOnly: readOnly, store: store })
      ));

      permissionsPrivilege && tabs.push(_react2.default.createElement(
        _Izenda3.Tab,
        { key: 'permissions', title: localization.getText('COMMON_LABEL_PERMISSIONS'), tabKey: 'permissions' },
        _react2.default.createElement(_Izenda5.default, { permissionStore: store.permissionStore, accessStore: store.accessStore, readOnly: readOnly })
      ));

      userRoleAssociation && tabs.push(_react2.default.createElement(
        _Izenda3.Tab,
        { key: 'users', title: localization.getText('ROLE_SETUP_USERS'), tabKey: 'users', className: 'u_fullSize' },
        _react2.default.createElement(_Izenda11.default, { store: store.usersRoleSetupStore, readOnly: readOnly })
      ));

      tabs.push(_react2.default.createElement(
        _Izenda3.Tab,
        {
          key: 'permissionSummary',
          title: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY'),
          tabKey: 'permissionSummary'
        },
        _react2.default.createElement(_Izenda9.default, { store: store })
      ));

      var activeTabKey = (0, _fp.head)(tabs).props.tabKey;

      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper-content u_marginLeftRight izenda-Role-content u-bgWhite' },
        _react2.default.createElement(
          _Izenda3.Tabs,
          { activeTabKey: activeTabKey, canChangeTab: this.validationBeforeChangeTabs },
          tabs
        )
      );
    }
  }]);
  return MainContentRoleSetup;
}(_react.Component)) || _class);
exports.default = MainContentRoleSetup;
module.exports = exports['default'];

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2327);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DataModelAccess(props) {
  var store = props.store,
      dataModelAccess = props.dataModelAccess,
      readOnly = props.readOnly,
      localization = props.localization;


  return _react2.default.createElement(
    'div',
    { className: 'izenda-Wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'izenda-Wrapper-header' },
      _react2.default.createElement(
        'div',
        { className: 'u_paddingTopBottom' },
        localization.getText('ROLE_SETUP_DATA_MODEL_HEADER')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'izenda-Wrapper-content u_paddingLeftRight' },
      _react2.default.createElement(_Izenda4.default, { dataModel: dataModelAccess, readOnly: readOnly, store: store })
    )
  );
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataModelAccess.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda2.default)()(DataModelAccess);
module.exports = exports['default'];

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleDataModelAccessTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(17);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(107);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(62);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(335);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoleDataModelAccessTree = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RoleDataModelAccessTree, _Component);

  function RoleDataModelAccessTree() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RoleDataModelAccessTree);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RoleDataModelAccessTree.__proto__ || (0, _getPrototypeOf2.default)(RoleDataModelAccessTree)).call.apply(_ref, [this].concat(args))), _this), _this.handleSearch = function (evt) {
      var _this$props = _this.props,
          dataModel = _this$props.dataModel,
          store = _this$props.store;

      _this.resetScrollPosition();

      dataModel.filterText = evt.target.value;
      store.searchDataSourceItems(dataModel.filterText);
    }, _this.handleToggleShowQuerySource = function (evt) {
      var _this$props2 = _this.props,
          store = _this$props2.store,
          loader = _this$props2.loader;

      _this.resetScrollPosition();

      loader.startLoading();
      store.handleToggleShowSelectedQuerySource(evt.target.checked).then(function () {
        return loader.endLoading();
      });
    }, _this.renderNode = function (node, toggleIcon, toggle, isCollapsed, parent) {
      var source = node.source,
          disabled = node.disabled,
          showTotal = node.showTotal;

      var onChangeFunc = _this.handleChange.bind(_this, node, parent);
      var filterText = _this.props.dataModel.filterText;

      return _react2.default.createElement(
        'div',
        { className: 'checkbox u_noMarginAll' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda4.default, {
            type: 'checkbox',
            indeterminate: source.indeterminate,
            checked: disabled ? false : source.checked,
            onChange: onChangeFunc,
            disabled: disabled
          }),
          _react2.default.createElement(_Izenda8.default, { text: source.name, highlight: filterText, className: 'u_textNormal' }),
          showTotal && _react2.default.createElement(
            'span',
            { className: 'selectable u_inline' },
            '(',
            source.numOfCheckedChilds + '/' + source.numOfChilds,
            ')'
          )
        ),
        toggleIcon
      );
    }, _this.getKey = function (node) {
      return node.source.id + '_' + node.source.parentId;
    }, _this.getTreeScrollbox = function (element) {
      _this.treeScrollbox = element;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RoleDataModelAccessTree, [{
    key: 'resetScrollPosition',
    value: function resetScrollPosition() {
      // Scroll to top when reload data model access
      this.treeScrollbox.scrollVertical(0);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(node, parent, evt) {
      node.onChange(node.source, parent, evt);
      this.props.store.handleChangeDataSourceItems(node, parent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$dataModel = _props.dataModel,
          displayData = _props$dataModel.displayData,
          isLastPage = _props$dataModel.isLastPage,
          filterText = _props$dataModel.filterText,
          showCheckedQuerySource = _props$dataModel.showCheckedQuerySource,
          store = _props.store,
          localization = _props.localization;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-CommonTree u_table u_fullSize u_borderAll' },
        _react2.default.createElement(
          'div',
          { className: 'u_tableRow' },
          _react2.default.createElement(
            'div',
            { className: 'u_tableCell u_paddingAll u_borderBottom' },
            _react2.default.createElement('span', { className: 'icon-menu' }),
            _react2.default.createElement(
              'span',
              { className: 'u_textBold' },
              localization.getText('ROLE_SETUP_CONSTANT_DATA_MODEL_ACCESS_TREE_HEADER')
            ),
            _react2.default.createElement(
              'div',
              { className: 'checkbox u_inline u_marginLeft' },
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement(_Izenda4.default, { type: 'checkbox', checked: showCheckedQuerySource, onChange: this.handleToggleShowQuerySource }),
                _react2.default.createElement(
                  'span',
                  null,
                  localization.getText('COMMON_LABEL_SHOW_SELECTED_ITEMS_ONLY')
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_tableRow' },
          _react2.default.createElement(
            'div',
            { className: 'u_tableCell u_paddingAll u_borderBottom' },
            _react2.default.createElement(
              'div',
              { className: 'u-posRelative' },
              _react2.default.createElement(_Izenda6.default, { debounceOnChange: true, value: filterText, onChange: this.handleSearch })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_tableRow' },
          _react2.default.createElement(
            'div',
            { className: 'u_tableCell u_fullSize' },
            !(0, _fp.isNil)(store.roleDetail.key) && _react2.default.createElement(_Izenda10.default, {
              nodes: displayData,
              getKey: this.getKey,
              isLastPage: isLastPage,
              className: 'u_paddingRight u_paddingBottom',
              renderNode: this.renderNode,
              getTreeScrollbox: this.getTreeScrollbox,
              getChildNodes: (0, _fp.invoke)('getChildNodes'),
              defaultItemsNumber: _Izenda11.DEFAULT_ITEMS_LAZY_LOADING,
              viewHeight: store.lazyLoadingStore.viewHeight,
              itemHeight: store.lazyLoadingStore.itemHeight,
              getData: store.getConnectionDetailInfo.bind(store),
              registerLazyLoadingStore: store.registerLazyLoadingStore.bind(store)
            })
          )
        )
      );
    }
  }]);
  return RoleDataModelAccessTree;
}(_react.Component)) || _class);
exports.default = RoleDataModelAccessTree;
module.exports = exports['default'];

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionSummary.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda3 = __webpack_require__(27);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2330);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2331);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2332);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2333);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2334);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2335);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2336);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(2337);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(2338);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(2339);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _Izenda29 = __webpack_require__(2340);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _Izenda31 = __webpack_require__(2341);

var _Izenda32 = _interopRequireDefault(_Izenda31);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PermissionSummary = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PermissionSummary, _Component);

  /**
   * component Will Mount
   */
  function PermissionSummary(props) {
    (0, _classCallCheck3.default)(this, PermissionSummary);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PermissionSummary.__proto__ || (0, _getPrototypeOf2.default)(PermissionSummary)).call(this, props));

    _this.renderColumnHeader = function () {
      var model = _this.props.store.permissionSummaryStore.model;


      var header = [];
      (0, _fp.forEach)(function (summary) {
        header.push(_react2.default.createElement(
          _Izenda6.default.Col,
          {
            cols: '1',
            title: summary.name,
            className: 'grid-small-column u_borderRight u-bgGrayBlue text-bold u_textTruncate',
            key: summary.id
          },
          summary.name
        ));
      }, model.permissionSummary);
      return header;
    };

    var loader = props.loader;
    loader.startLoading();
    props.store.loadPermissionSummary().finally(loader.endLoading.bind(loader));
    return _this;
  }

  (0, _createClass3.default)(PermissionSummary, [{
    key: 'render',


    /**
     * render component
     */
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          model = _props.store.permissionSummaryStore.model;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-PermissionSummaryTab u_fullHeight u-posBottomLeft u-posAbsolute u_fullWidth u_paddingAll' },
        _react2.default.createElement(
          _Izenda6.default,
          { className: 'u_fullHeight u_fullWidth' },
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'izenda-PermissionSummaryTab-TopRow u_noMarginAll u_noPaddingAll' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              {
                cols: '12',
                className: 'u_noMarginAll u_noPaddingAll  izenda-HeaderCustomLabelHeight u_borderAll'
              },
              _react2.default.createElement(
                _Izenda6.default.Col,
                {
                  cols: '3',
                  className: 'u_paddingLeft u_table u_borderRight u_fullHeight u-bgGrayBlue text-bold'
                },
                _react2.default.createElement(
                  'div',
                  { className: 'u_tableCell u_alignMiddle' },
                  _react2.default.createElement('span', {
                    className: 'icon-chevron-down u_noMarginAll u_borderAll u-bgWhite',
                    onClick: model.updateExpendCollapseAll.bind(model, true)
                  }),
                  _react2.default.createElement('span', {
                    className: 'icon-chevron-up u_noMarginAll u_borderAll u-bgWhite',
                    onClick: model.updateExpendCollapseAll.bind(model, false)
                  })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'u_tableCell u_alignMiddle' },
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_PERMISSION')
                )
              ),
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '9', className: 'u_noPaddingAll u_table text-center' },
                _react2.default.createElement(
                  'div',
                  { className: 'grid-small-column' },
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_ROLES')
                ),
                _react2.default.createElement(
                  _Izenda6.default.Col,
                  { cols: '12', className: 'u_noPaddingAll u_borderTop' },
                  !(0, _fp.isEmpty)(model.permissionSummary) && this.renderColumnHeader()
                )
              )
            )
          ),
          _react2.default.createElement(
            _Izenda4.default,
            { className: 'izenda-PermissionSummaryTab-Detail' },
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(
                  _Izenda6.default.Col,
                  {
                    cols: '3',
                    className: 'grid-small-column u_borderRight u-bgGrayBlue text-bold u_paddingLeft'
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'u_paddingLeft' },
                    localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_FULL_REPORT_AND_DASHBOARD_ACCESS')
                  )
                ),
                _react2.default.createElement(_Izenda8.default, { className: 'u-bgGray', model: model, keysPath: 'fullReportAndDashboardAccess' })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda10.default, { model: model })
              )
            ),
            _IzendaUiState2.default.currentUser.isSystemUser && _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda12.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda14.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda16.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda18.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda20.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda22.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda24.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray ' },
                _react2.default.createElement(_Izenda26.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda28.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda30.default, { model: model })
              )
            ),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginAll u_borderAll u_noBorderTop' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '12', className: 'u_noPaddingAll u-bgGray' },
                _react2.default.createElement(_Izenda32.default, { model: model })
              )
            )
          )
        )
      );
    }
  }]);
  return PermissionSummary;
}(_react.Component), _class2.propTypes = {
  store: _react2.default.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PermissionSummary;
module.exports = exports['default'];

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessDefaultGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AddUserGrid component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(68);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(44);

var _Izenda6 = __webpack_require__(97);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(13);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(92);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(620);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccessDefaultGrid = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AccessDefaultGrid, _Component);

  function AccessDefaultGrid(props) {
    (0, _classCallCheck3.default)(this, AccessDefaultGrid);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AccessDefaultGrid.__proto__ || (0, _getPrototypeOf2.default)(AccessDefaultGrid)).call(this, props));

    _this.onPageSizeChange = function (value) {
      _this.store.onPageSizeChange(value);
    };

    _this.goToPage = function (value) {
      _this.store.goToPage(value);
    };

    var loadUsers = props.loadUsers,
        userModeType = props.userModeType;

    _this.store = new _Izenda13.default(loadUsers, userModeType);
    return _this;
  }

  (0, _createClass3.default)(AccessDefaultGrid, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          loader = _props.loader,
          data = _props.data;

      this.store.updateAccessOrigin(data);
      loader.startLoading();
      this.store.loadAllAccess(data).finally(loader.endLoading.bind(loader));
    }

    /**
     *
     * @param {Object} data     cell data
     * @param {number} key      cell key
     * @param {number} rowIndex cell index
     * @param {number} column   cell column
     */

  }, {
    key: 'renderTextCell',
    value: function renderTextCell(data, key, rowIndex, column) {
      var text = data[key] || '';
      return _react2.default.createElement(_Izenda4.default, { tooltip: text, text: text });
    }

    /**
     *
     * @param {Object} data     cell data
     * @param {number} key      cell key
     * @param {number} rowIndex cell index
     * @param {number} column   cell column
     */

  }, {
    key: 'renderAccessorCell',
    value: function renderAccessorCell(data, key, rowIndex, column) {
      var text = data[key] || [];

      var value = (0, _fp.join)(', ', (0, _fp.map)(function (item) {
        return item;
      }, (0, _fp.filter)(function (item) {
        return !(0, _fp.isEmpty)(item);
      }, text)));

      return _react2.default.createElement(
        'div',
        { title: value },
        (0, _fp.map)(function (item) {
          return _react2.default.createElement(_Izenda4.default, { text: item, tooltip: item, key: item });
        }, (0, _fp.take)(3, text))
      );
    }

    /**
     * Render table component
     */

  }, {
    key: 'renderTable',
    value: function renderTable() {
      var _this2 = this;

      var store = this.store,
          _store = this.store,
          model = _store.model,
          pageInfo = _store.model.pageInfo;

      /**
       * Render columns component
       */

      var renderColumns = function renderColumns() {
        return (0, _fp.map)(function (item) {
          switch (item.key) {
            case 'accessorNames':
              return _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, item, { cell: _this2.renderAccessorCell }));
            default:
              return _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, item, { cell: _this2.renderTextCell }));
          }
        }, (0, _fp.values)(_Izenda11.default.ACCESS_DEFAULT_GRID));
      };

      return _react2.default.createElement(
        _Izenda5.Table,
        {
          dataSource: model.visibleAccessList,
          onSortChange: store.onSortChange.bind(store),
          draggableTable: false,
          sortInfo: pageInfo.colSortDirs
        },
        renderColumns()
      );
    }
  }, {
    key: 'render',


    /**
     * Render component
     */
    value: function render() {
      var store = this.store,
          _store2 = this.store,
          model = _store2.model,
          pageInfo = _store2.model.pageInfo;


      var currentPageSize = (0, _fp.getOr)(0, 'length', model.visibleAccessList);
      return _react2.default.createElement(
        _Izenda9.default,
        null,
        _react2.default.createElement(
          _Izenda9.default.Row,
          null,
          _react2.default.createElement(
            _Izenda9.default.Col,
            { cols: '12' },
            this.renderTable()
          )
        ),
        _react2.default.createElement(
          _Izenda9.default.Row,
          null,
          _react2.default.createElement(
            _Izenda9.default.Col,
            { cols: '12' },
            _react2.default.createElement(_Izenda7.default, {
              onChange: this.goToPage,
              onDropdownChange: this.onPageSizeChange,
              pageInfo: pageInfo,
              currentPageSize: currentPageSize
            })
          )
        )
      );
    }
  }]);
  return AccessDefaultGrid;
}(_react.Component)) || _class);
exports.default = AccessDefaultGrid;
module.exports = exports['default'];

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemConfiguration.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var SystemConfiguration = (0, _Izenda2.default)()(function (props) {
  var model = props.model,
      localization = props.localization;


  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('COMMON_LABEL_SYSTEM_CONFIGURATION'),
    model: model
  };
  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderTop' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
          _react2.default.createElement(
            'span',
            { className: 'u_smallIcon u_alignMiddle' },
            '\u26AB'
          ),
          _react2.default.createElement(
            'span',
            null,
            localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SYSTEM_CONFIGURATION_LABEL_SCHEDULE_INSTANCES')
          )
        ),
        _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'systemConfiguration.scheduledInstances.value' })
      )
    )
  );
});

exports.default = SystemConfiguration;
module.exports = exports['default'];

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantSetup.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var TenantSetup = (0, _Izenda2.default)()(function (props) {
  var model = props.model,
      localization = props.localization;


  var className = 'grid-small-column u_borderRight u-bgWhite';
  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('CONTEXT_MENU_LABEL_TENANT_SETUP'),
    model: model
  };
  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default,
      null,
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_ACTION')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true, model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_CREATE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'tenantSetup.actions.create' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_EDIT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'tenantSetup.actions.edit' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_DELETE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'tenantSetup.actions.del' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_SETUP_LABEL_PERMISSIONS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true, model: model, keysPath: 'tenantSetup.permissions.value' })
        )
      )
    )
  );
});

exports.default = TenantSetup;
module.exports = exports['default'];

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSetup.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataSetup = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(DataSetup, _Component);

  function DataSetup() {
    (0, _classCallCheck3.default)(this, DataSetup);
    return (0, _possibleConstructorReturn3.default)(this, (DataSetup.__proto__ || (0, _getPrototypeOf2.default)(DataSetup)).apply(this, arguments));
  }

  (0, _createClass3.default)(DataSetup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          model = _props.model,
          localization = _props.localization;

      var header = {
        component: _Izenda10.default,
        headerName: localization.getText('COMMON_LABEL_DATA_SETUP'),
        model: model
      };

      var titleClasses = 'grid-small-column u_borderRight u-bgWhite';

      return _react2.default.createElement(
        _Izenda4.default,
        {
          className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
          header: header,
          collapsible: true,
          expanedOption: model.collapseAll
        },
        _react2.default.createElement(
          _Izenda6.default,
          null,
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: titleClasses },
                _react2.default.createElement(
                  'span',
                  { className: 'u_smallIcon u_alignMiddle' },
                  '\u26AB'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_DATA_MODEL')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dataSetup.dataModel.value' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: titleClasses },
                _react2.default.createElement(
                  'span',
                  { className: 'u_smallIcon u_alignMiddle' },
                  '\u26AB'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CUSTOM_VIEW')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { isParent: true })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: titleClasses },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_CREATE')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dataSetup.dataModel.customView.create' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: titleClasses },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_EDIT')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dataSetup.dataModel.customView.edit' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: titleClasses },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_DELETE')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dataSetup.dataModel.customView.delete' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: titleClasses },
                _react2.default.createElement(
                  'span',
                  { className: 'u_smallIcon u_alignMiddle' },
                  '\u26AB'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_ADVANCED_SETTING')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { isParent: true })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: titleClasses },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CATEGORIES')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dataSetup.advancedSettings.category' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: titleClasses },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_OTHERS')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dataSetup.advancedSettings.others' })
            )
          )
        )
      );
    }
  }]);
  return DataSetup;
}(_react.Component)) || _class);
exports.default = DataSetup;
module.exports = exports['default'];

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSetup.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda2.default)()(function (props) {
  var localization = props.localization,
      model = props.model;

  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('COMMON_LABEL_USER_SETUP'),
    model: model
  };

  var className = 'grid-small-column u_borderRight u-bgWhite';
  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default,
      null,
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_ACTION')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true, model: model, keysPath: 'userSetup.userRoleAssociation.value' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_CREATE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'userSetup.actions.create' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_EDIT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'userSetup.actions.edit' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_DELETE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'userSetup.actions.del' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_USER_SETUP_LABEL_CONFIGURE_SECURITY_OPTIONS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'userSetup.actions.configureSecurityOptions' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_USER_SETUP_LABEL_USER_ROLE_ASSOCIATION')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'userSetup.userRoleAssociation.value' })
        )
      )
    )
  );
});
module.exports = exports['default'];

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleSetup.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var RoleSetup = (0, _Izenda2.default)()(function (props) {
  var model = props.model,
      localization = props.localization;


  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('COMMON_LABEL_ROLE_SETUP'),
    model: model
  };
  var className = 'grid-small-column u_borderRight u-bgWhite';
  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderTop' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: className },
          _react2.default.createElement(
            'span',
            { className: 'u_smallIcon u_alignMiddle' },
            '\u26AB'
          ),
          _react2.default.createElement(
            'span',
            null,
            localization.getText('COMMON_LABEL_ACTION')
          )
        ),
        _react2.default.createElement(_Izenda8.default, { isParent: true })
      )
    ),
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderTop' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: className },
          _react2.default.createElement(
            'span',
            { className: 'izenda-Permission-FirstChild' },
            localization.getText('COMMON_LABEL_CREATE')
          )
        ),
        _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'roleSetup.actions.create' })
      )
    ),
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderTop' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: className },
          _react2.default.createElement(
            'span',
            { className: 'izenda-Permission-FirstChild' },
            localization.getText('COMMON_LABEL_EDIT')
          )
        ),
        _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'roleSetup.actions.edit' })
      )
    ),
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderTop' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: className },
          _react2.default.createElement(
            'span',
            { className: 'izenda-Permission-FirstChild' },
            localization.getText('COMMON_LABEL_DELETE')
          )
        ),
        _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'roleSetup.actions.del' })
      )
    ),
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderTop' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: className },
          _react2.default.createElement(
            'span',
            { className: 'u_smallIcon u_alignMiddle' },
            '\u26AB'
          ),
          _react2.default.createElement(
            'span',
            null,
            localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_SETUP_LABEL_DATA_MODEL_ACCESS')
          )
        ),
        _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'roleSetup.dataModelAccess.value' })
      )
    ),
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderTop' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: className },
          _react2.default.createElement(
            'span',
            { className: 'u_smallIcon u_alignMiddle' },
            '\u26AB'
          ),
          _react2.default.createElement(
            'span',
            null,
            localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_SETUP_LABEL_PERMISSIONS')
          )
        ),
        _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'roleSetup.permissions.value' })
      )
    ),
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderTop' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: className },
          _react2.default.createElement(
            'span',
            { className: 'u_smallIcon u_alignMiddle' },
            '\u26AB'
          ),
          _react2.default.createElement(
            'span',
            {
              title: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_SETUP_LABEL_GRANT_ROLE_WITH_FULL_REPORT_AND_DASHBOARD_ACCESS')
            },
            localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_SETUP_LABEL_GRANT_ROLE_WITH_FULL_REPORT_AND_DASHBOARD_ACCESS')
          )
        ),
        _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'roleSetup.grantRoleWithFullReportAndDashboardAccess.value' })
      )
    )
  );
});

exports.default = RoleSetup;
module.exports = exports['default'];

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(72);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reports = (0, _Izenda2.default)()(function (props) {
  var model = props.model,
      localization = props.localization;

  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('COMMON_LABEL_REPORTS'),
    model: model
  };

  var className = 'grid-small-column u_borderRight u-bgWhite';
  var mediumClassName = 'grid-medium-column u_borderRight u-bgWhite';

  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default,
      null,
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_CAN_CREATE_NEW_REPORTS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.canCreateNewReport.value' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_DATA_SOURCES')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true, model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_SIMPLE_DATA_SOURCE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, {
            model: model,
            keysPath: 'reports.dataSources.simpleDataSources',
            showRadioButton: true,
            isParent: true
          })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_ADVANCED_DATA_SOURCE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, {
            model: model,
            keysPath: 'reports.dataSources.advancedDataSources',
            showRadioButton: true,
            isParent: true
          })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_REPORT_PART_TYPES')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true, model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CHART')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.reportPartTypes.chart' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_FORM')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.reportPartTypes.form' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_GAUGE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.reportPartTypes.gauge' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_MAP')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.reportPartTypes.map' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_REPORT_CATEGORIES_SUBCATEGORIES')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true, model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_CAN_CREATE_NEW_REPORTS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, {
            model: model,
            keysPath: 'reports.reportCategoriesSubcategories.canCreateNewCategory.value'
          })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CATEGORIES_ACCESSIBILITY')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true, model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: mediumClassName },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-SecondChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_VISIBLE_CATEGORIES')
            )
          ),
          _react2.default.createElement(_Izenda8.default, {
            isParent: true,
            notShowBlankCharacter: true,
            model: model,
            showRole: true,
            popupTitle: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_VISIBLE_REPORT_CATEGORIES'),
            popupMessage: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_REPORT_VIEW'),
            treeType: _Izenda12.default.TREE_TYPE.CATEGORY,
            visibleCategories: true,
            keysPath: 'reports.reportCategoriesSubcategories.categoryAccessibility.categories'
          })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: mediumClassName },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-SecondChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CATEGORIES_ALLOWED_FOR_SAVING_REPORTS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, {
            isParent: true,
            notShowBlankCharacter: true,
            model: model,
            showRole: true,
            popupTitle: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SAVING_REPORT_CATEGORIES'),
            popupMessage: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_REPORT_SAVE'),
            treeType: _Izenda12.default.TREE_TYPE.CATEGORY,
            savableCategories: true,
            keysPath: 'reports.reportCategoriesSubcategories.categoryAccessibility.categories'
          })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_FILTERS_PROPERTIES')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_FILTERS_LOGIC')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.filterProperties.filterLogic' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CROSS_FILTERING')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.filterProperties.crossFiltering' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_FIELD_PROPERTIES')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_CUSTOM_URL')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.fieldProperties.customURL' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_EMBEDDED_JAVASCRIPT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.fieldProperties.embeddedJavaScript' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_SUBREPORT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.fieldProperties.subreport' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_ACTIONS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true, model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_SCHEDULE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.schedule' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_REGISTER_FOR_ALERTS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.registerForAlerts' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_SUBSCRIBE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.subscribe' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CONFIGURE_ACCESS_RIGHT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.configureAccessRights' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_EMAIL')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.email' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_PRINT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.print' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_EXPORT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.exporting' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_VIEW_REPORT_HISTORY')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.viewReportHistory' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_UNARCHIVE_REPORT_VERSIONS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.unarchiveReportVersions' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_DELETE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.del' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_OVERWRITE_EXISTING_REPORT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'reports.actions.overwriteExistingReport' })
        )
      )
    )
  );
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.Reports.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

exports.default = Reports;
module.exports = exports['default'];

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Dashboards.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(72);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dashboards = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Dashboards, _Component);

  function Dashboards() {
    (0, _classCallCheck3.default)(this, Dashboards);
    return (0, _possibleConstructorReturn3.default)(this, (Dashboards.__proto__ || (0, _getPrototypeOf2.default)(Dashboards)).apply(this, arguments));
  }

  (0, _createClass3.default)(Dashboards, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          model = _props.model,
          localization = _props.localization;


      var header = {
        component: _Izenda10.default,
        headerName: localization.getText('COMMON_LABEL_DASHBOARDS'),
        model: model
      };
      var mediumClassName = 'grid-medium-column u_borderRight u-bgWhite';

      return _react2.default.createElement(
        _Izenda4.default,
        {
          className: 'u_fullHeight u_noMarginAll u_noBorder',
          header: header,
          collapsible: true,
          expanedOption: model.collapseAll
        },
        _react2.default.createElement(
          _Izenda6.default,
          null,
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'u_smallIcon u_alignMiddle' },
                  '\u26AB'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  localization.getText('PERMISSION_LABEL_CAN_CREATE_DASHBOARD')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dashboards.canCreateNewDashboard.value' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'u_smallIcon u_alignMiddle' },
                  '\u26AB'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_DASHBOARD_CATEGORIES_SUBCATEGORIES')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, isParent: true })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('PERMISSION_LABEL_CAN_CREATE_DASHBOARD')
                )
              ),
              _react2.default.createElement(_Izenda8.default, {
                model: model,
                keysPath: 'dashboards.dashboardCategoriesSubcategories.canCreateNewCategory.value'
              })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_ACCESSIBILITY')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, isParent: true })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: mediumClassName },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-SecondChild' },
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_VISIBLE_CATEGORIES')
                )
              ),
              _react2.default.createElement(_Izenda8.default, {
                notShowBlankCharacter: true,
                model: model,
                isParent: true,
                showRole: true,
                visibleCategories: true,
                treeType: _Izenda12.default.TREE_TYPE.CATEGORY,
                popupTitle: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_VISIBLE_DASHBOARD_CATEGORIES'),
                popupMessage: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_DASHBOARD_VIEW'),
                keysPath: 'dashboards.dashboardCategoriesSubcategories.categoryAccessibility.categories'
              })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: mediumClassName },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-SecondChild' },
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CATEGORIES_ALLOWED_FOR_SAVING_DASHBOARD')
                )
              ),
              _react2.default.createElement(_Izenda8.default, {
                notShowBlankCharacter: true,
                model: model,
                isParent: true,
                savableCategories: true,
                showRole: true,
                popupTitle: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SAVING_DASHBOARD_CATEGORIES'),
                popupMessage: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_DASHBOARD_SAVE'),
                treeType: _Izenda12.default.TREE_TYPE.CATEGORY,
                keysPath: 'dashboards.dashboardCategoriesSubcategories.categoryAccessibility.categories'
              })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'u_smallIcon u_alignMiddle' },
                  '\u26AB'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  localization.getText('COMMON_LABEL_ACTIONS')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, isParent: true })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_SCHEDULE')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dashboards.actions.schedule' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_SUBSCRIBE')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dashboards.actions.subscribe' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CONFIGURE_ACCESS')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dashboards.actions.configureAccessRights' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_EMAIL')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dashboards.actions.email' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_EXPORT')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dashboards.actions.exporting' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_PRINT')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dashboards.actions.print' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('COMMON_LABEL_DELETE')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dashboards.actions.del' })
            )
          ),
          _react2.default.createElement(
            _Izenda6.default.Row,
            { className: 'u_noMarginAll u_borderTop' },
            _react2.default.createElement(
              _Izenda6.default.Col,
              { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
                _react2.default.createElement(
                  'span',
                  { className: 'izenda-Permission-FirstChild' },
                  localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_OVERWRITE_EXISTING_DASHBOARD')
                )
              ),
              _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'dashboards.actions.overwriteExistingDashboard' })
            )
          )
        )
      );
    }
  }]);
  return Dashboards;
}(_react.Component)) || _class);
exports.default = Dashboards;
module.exports = exports['default'];

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(72);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Access = (0, _Izenda2.default)()(function (props) {
  var model = props.model,
      localization = props.localization;


  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_HEADER_NAME_ACCESS'),
    model: model
  };
  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noBorder ',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default,
      null,
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ACCESS_LIMITS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, {
            model: model,
            keysPath: 'access.accessLimits.value',
            isParent: true,
            showRole: true,
            notShowBlankCharacter: true,
            treeType: _Izenda12.default.TREE_TYPE.ACCESS,
            popupTitle: localization.getText('PERMISSION_LABEL_ACCESS_LIMITS'),
            popupMessage: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_ACCESS_LIMIT')
          })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ACCESS_DEFAULT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, {
            model: model,
            keysPath: 'access.accessDefaults.value',
            isParent: true,
            showRole: true,
            isAccessDefault: true,
            notShowBlankCharacter: true,
            treeType: _Izenda12.default.TREE_TYPE.ACCESS,
            popupTitle: localization.getText('PERMISSION_LABEL_ACCESS_DEFAULT'),
            popupMessage: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_ACCESS_DEFAULT')
          })
        )
      )
    )
  );
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.Access.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

exports.default = Access;
module.exports = exports['default'];

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Scheduling.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
var Scheduling = (0, _Izenda2.default)()(function (props) {
  var model = props.model,
      localization = props.localization;


  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('COMMON_LABEL_SCHEDULING'),
    model: model
  };
  var className = 'grid-small-column u_borderRight u-bgWhite';
  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default,
      null,
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SCHEDULING_LABEL_SCHEDULING_LIMITS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, {
            isParent: true,
            showRole: true,
            model: model,
            keysPath: 'scheduling.schedulingLimits.value',
            popupTitle: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SCHEDULING_LABEL_SCHEDULING_LIMITS'),
            popupMessage: localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_SCHEDULE_LIMIT')
          })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SCHEDULING_LABEL_SCHEDULING_SCOPE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SCHEDULING_LABEL_SYSTEM_USERS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'scheduling.schedulingScope.systemUsers' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SCHEDULING_LABEL_EXTERNAL_USERS')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'scheduling.schedulingScope.externalUsers' })
        )
      )
    )
  );
});

exports.default = Scheduling;
module.exports = exports['default'];

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Emailing.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var Emailing = (0, _Izenda2.default)()(function (props) {
  var model = props.model,
      localization = props.localization;

  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('COMMON_LABEL_EMAILING'),
    model: props.model
  };
  var className = 'grid-small-column u_borderRight u-bgWhite';
  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default,
      null,
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_DELIVERY_METHOD')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_LINK')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.deliveryMethod.link', model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_EMBEDDED_HTML')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.deliveryMethod.embeddedHTML', model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('COMMON_LABEL_ATTACHMENT')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.deliveryMethod.attachment', model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_ATTACHMENT_TYPE')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { isParent: true })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              'Word'
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.attachmentType.word', model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              'Excel'
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.attachmentType.excel', model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              'PDF'
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.attachmentType.pdf', model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              'CSV'
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.attachmentType.csv', model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              'XML'
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.attachmentType.xml', model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              'JSON'
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.attachmentType.json', model: model })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'izenda-Permission-FirstChild' },
              localization.getText('PERMISSION_LABEL_DEFINITION')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { keysPath: 'emailing.attachmentType.definition', model: model })
        )
      )
    )
  );
});

exports.default = Emailing;
module.exports = exports['default'];

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Exporting.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var Exporting = (0, _Izenda2.default)()(function (props) {
  var model = props.model,
      localization = props.localization;

  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('COMMON_LABEL_EXPORTING'),
    model: model
  };

  var className = 'grid-small-column u_borderRight u-bgWhite';
  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default,
      null,
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_WORD')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'exporting.exportingFormat.word' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_EXCEL')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'exporting.exportingFormat.excel' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_PDF')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'exporting.exportingFormat.pdf' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CSV')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'exporting.exportingFormat.csv' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_XML')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'exporting.exportingFormat.xml' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_JSON')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'exporting.exportingFormat.json' })
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: className },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_QUERY_EXECUTION')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'exporting.exportingFormat.queryExecution' })
        )
      )
    ),
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderTop' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '3', className: className },
          _react2.default.createElement(
            'span',
            { className: 'u_smallIcon u_alignMiddle' },
            '\u26AB'
          ),
          _react2.default.createElement(
            'span',
            null,
            localization.getText('PERMISSION_LABEL_DEFINITION')
          )
        ),
        _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'exporting.exportingFormat.definition' })
      )
    )
  );
});

exports.default = Exporting;
module.exports = exports['default'];

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(125);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(135);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemWide.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var SystemWide = (0, _Izenda2.default)()(function (props) {
  var model = props.model,
      localization = props.localization;


  var header = {
    component: _Izenda10.default,
    headerName: localization.getText('COMMON_LABEL_SYSTEM_WIDE'),
    model: model
  };
  return _react2.default.createElement(
    _Izenda4.default,
    {
      className: 'u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder',
      header: header,
      collapsible: true,
      expanedOption: model.collapseAll
    },
    _react2.default.createElement(
      _Izenda6.default,
      null,
      _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginAll u_borderTop' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: '12', className: 'u_noPaddingAll u-bgGrayBlue' },
          _react2.default.createElement(
            _Izenda6.default.Col,
            { cols: '3', className: 'grid-small-column u_borderRight u-bgWhite' },
            _react2.default.createElement(
              'span',
              { className: 'u_smallIcon u_alignMiddle' },
              '\u26AB'
            ),
            _react2.default.createElement(
              'span',
              null,
              localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SYSTEM_WIDE_LABEL_CAN_SEE_SYSTEM_MESSAGES')
            )
          ),
          _react2.default.createElement(_Izenda8.default, { model: model, keysPath: 'systemwide.canSeeSystemMessages.value' })
        )
      )
    )
  );
});

exports.default = SystemWide;
module.exports = exports['default'];

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.UsersRoleSetup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda3 = __webpack_require__(232);

var _Izenda4 = __webpack_require__(2343);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(17);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(13);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(27);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(219);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(2344);

var _Izenda15 = _interopRequireDefault(_Izenda14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersRoleSetup = (_dec = (0, _Izenda2.default)(_Izenda15.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(UsersRoleSetup, _Component);

  function UsersRoleSetup(props) {
    (0, _classCallCheck3.default)(this, UsersRoleSetup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UsersRoleSetup.__proto__ || (0, _getPrototypeOf2.default)(UsersRoleSetup)).call(this, props));

    _initialiseProps.call(_this);

    var store = props.store;

    _this.registerLazyLoadingStore = store.registerLazyLoadingStore.bind(store);
    _this.getData = props.getData.bind(null);
    return _this;
  }

  (0, _createClass3.default)(UsersRoleSetup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          _props$store = _props.store,
          _props$store$lazyLoad = _props$store.lazyLoadingStore,
          lazyLoadingStore = _props$store$lazyLoad === undefined ? {} : _props$store$lazyLoad,
          _props$store$model = _props$store.model,
          searchedUserName = _props$store$model.searchedUserName,
          usersList = _props$store$model.usersList,
          isLastPage = _props$store$model.isLastPage;


      var usersData = usersList.length ? usersList : [];

      return _react2.default.createElement(
        'div',
        { className: 'izenda-UsersRoleSetup u_fullHeight' },
        _react2.default.createElement(
          _Izenda9.default,
          { className: 'u_paddingLeftRight' },
          _react2.default.createElement(
            _Izenda9.default.Row,
            null,
            _react2.default.createElement(
              _Izenda9.default.Col,
              { cols: '12' },
              _react2.default.createElement(
                'p',
                { className: 'u_paddingAll' },
                _Izenda3.ROLE_SETUP.USERS
              ),
              _react2.default.createElement(
                'div',
                { className: 'u_table u_fullSize u_borderAll' },
                _react2.default.createElement(
                  'div',
                  { className: 'u_tableRow' },
                  _react2.default.createElement(
                    'div',
                    { className: 'u_tableCell u_paddingAll u_borderBottom' },
                    _react2.default.createElement('i', { className: 'icon-useradmin' }),
                    _react2.default.createElement(
                      'label',
                      null,
                      localization.getText('ROLE_SETUP_USERS_LABEL_ASSIGN_USERS')
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'u_tableRow' },
                  _react2.default.createElement(
                    'div',
                    { className: 'u_tableCell u_paddingAll u_borderBottom' },
                    _react2.default.createElement(_Izenda7.default, {
                      placeholder: localization.getText('ROLE_SETUP_USERS_LABEL_SEARCH'),
                      value: searchedUserName,
                      onChange: this.handleSearchUsers
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'u_tableRow' },
                  _react2.default.createElement(
                    'div',
                    { className: 'u_tableCell u_fullSize' },
                    _react2.default.createElement(
                      _Izenda11.default,
                      { className: 'izenda-CustomContent-Container' },
                      _react2.default.createElement(_Izenda13.default, {
                        className: 'izenda-CustomContainerTable',
                        itemKey: 'id',
                        data: usersData,
                        isLastPage: isLastPage,
                        getData: this.getData,
                        renderItem: this.renderUser,
                        viewHeight: lazyLoadingStore.viewHeight,
                        itemHeight: lazyLoadingStore.itemHeight,
                        registerLazyLoadingStore: this.registerLazyLoadingStore
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return UsersRoleSetup;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired,
  onCheckUser: _react.PropTypes.func
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleSearchUsers = function (event) {
    _this2.props.store.searchUsers(event.target.value);
  };

  this.renderUser = function (user) {
    var _props2 = _this2.props,
        onCheckUser = _props2.onCheckUser,
        store = _props2.store;


    return _react2.default.createElement(
      'div',
      { className: 'izenda-CustomRow' },
      _react2.default.createElement(_Izenda5.default, { onCheckUser: onCheckUser, user: user, searchedUserName: store.model.searchedUserName })
    );
  };
}, _temp)) || _class);
exports.default = UsersRoleSetup;
module.exports = exports['default'];

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.UsersRoleItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(17);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(62);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersRoleItem = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(UsersRoleItem, _Component);

  function UsersRoleItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, UsersRoleItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UsersRoleItem.__proto__ || (0, _getPrototypeOf2.default)(UsersRoleItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckUser = function (event) {
      var _this$props = _this.props,
          user = _this$props.user,
          onCheckUser = _this$props.onCheckUser;

      onCheckUser(user, event.target.checked);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(UsersRoleItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          searchedUserName = _props.searchedUserName;


      return _react2.default.createElement(
        'label',
        null,
        _react2.default.createElement(_Izenda2.default, {
          className: 'izenda-CustomCheckBox',
          type: 'checkbox',
          value: user.id,
          onChange: this.handleCheckUser,
          checked: user.assigned
        }),
        _react2.default.createElement(_Izenda4.default, { highlight: searchedUserName, text: user.fullName })
      );
    }
  }]);
  return UsersRoleItem;
}(_react.Component)) || _class;

exports.default = UsersRoleItem;
module.exports = exports['default'];

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _react = __webpack_require__(0);

var _fp = __webpack_require__(1);

exports.default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  store: _react.PropTypes.object.isRequired
}), (0, _recompose.withHandlers)({
  onCheckUser: (0, _fp.curry)(onCheckUser),
  getData: getData
}));

/**
   * handle action Check User
   * @param  {object} props 
   * @param  {object} user  
   * @param  {boolean} value 
   */

// ----------------------------------------------------------------------
// <copyright file="Izenda.UsersRoleSetupAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function onCheckUser(props, user, value) {
  user && props.store.model.toggleAssignUser(user);
}

/**
   * Get Data for lazy loading
   * @param {Object} pageInfo
   * @param {boolean} isSearching
   */
function getData(props) {
  return function (pageInfo, isSearching) {
    var loader = props.loader,
        store = props.store,
        searchedUserName = props.store.model.searchedUserName;

    var isFirstLoad = pageInfo && (0, _fp.get)('fromIndex', pageInfo) === 0;
    isFirstLoad && loader.startLoading();
    return store.getPartialUsers(pageInfo, isSearching, searchedUserName).finally(loader.endLoading.bind(loader));
  };
}
module.exports = exports['default'];

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleListHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var RoleListSearchBox = __webpack_require__(2346);
  var action = __webpack_require__(2347);

  var AuthorizationValidator = __webpack_require__(148);
  var AuthorizationConstants = __webpack_require__(42);

  var AddRole = AuthorizationValidator()(function (props) {
    var localizer = __webpack_require__(12);
    return React.createElement(
      'a',
      {
        className: 'overflow-text izenda-AddTenantLink',
        onClick: props.onClick,
        title: localizer.getText('ROLE_SETUP_ROLE_LIST_HEADER_ADD_ROLE') },
      React.createElement('span', { className: 'icon-plus' }),
      localizer.getText('ROLE_SETUP_ROLE_LIST_HEADER_ADD_ROLE')
    );
  });

  /**
   * Role List Header
   * @param {object} props The component's props that must have 'store' property
   */
  var RoleListHeader = function RoleListHeader(props) {
    return React.createElement(
      'div',
      { className: 'header-panel' },
      React.createElement(AddRole, {
        onClick: props.addRole,
        keys: [AuthorizationConstants.PERMISSION_KEY.RoleSetupActionsCreate] }),
      React.createElement(
        'div',
        { className: 'search-box' },
        React.createElement(RoleListSearchBox, props)
      ),
      React.createElement('hr', null)
    );
  };

  RoleListHeader.propTypes = {
    store: React.PropTypes.object.isRequired
  };

  module.exports = action(RoleListHeader);
}();

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(24);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(107);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoleListSearchBox = (0, _mobxReact.observer)(function (props) {
  var roleList = props.store.roleList;


  return _react2.default.createElement(_Izenda4.default, {
    value: roleList.filterText,
    onChange: _Izenda2.default.notifyChange(roleList.updateFilterText.bind(roleList), _Izenda2.default.INPUT) });
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleListSearchBox.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

RoleListSearchBox.propTypes = {
  store: _propTypes2.default.object.isRequired
};

exports.default = RoleListSearchBox;
module.exports = exports['default'];

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleItemAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var connect = __webpack_require__(2);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var roleSetupAction = compose(connect(), withHandlers({
    addRole: curry(function (props, e) {
      e.stopPropagation();
      var loader = props.loader;
      var store = props.store;
      props.validation.reset();

      if (!props.readOnly) {
        loader.startLoading();
        props.confirmDirtyForm(store.isDirty).then(store.addRole.bind(store)).finally(loader.endLoading.bind(loader));
      }
    })
  }), observer);

  module.exports = roleSetupAction;
}();

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2349);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var roleSetupAction = (0, _recompose.withProps)(function (_ref) {
  var loader = _ref.loader;

  var store = new _Izenda2.default();
  var loadData = function loadData() {
    store.init();
    loader.startLoading();
    store.loadDataRoleSetup().finally(function () {
      return loader.endLoading();
    });
  };
  var disposeChangeTenant = (0, _mobx.reaction)(function () {
    return store.tenantId;
  }, loadData);

  return {
    store: store,
    loadData: loadData,
    disposeChangeTenant: disposeChangeTenant
  };
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleSetupAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = roleSetupAction;
module.exports = exports['default'];

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleSetupStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(274);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(278);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(37);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2350);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2352);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2353);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(227);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2354);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(1153);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(206);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(232);

var _Izenda24 = __webpack_require__(620);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _Izenda26 = __webpack_require__(2358);

var _Izenda27 = _interopRequireDefault(_Izenda26);

var _Izenda28 = __webpack_require__(12);

var _Izenda29 = _interopRequireDefault(_Izenda28);

var _fp = __webpack_require__(1);

var _Izenda30 = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var IS_TENANT_SETUP = false;

var RoleSetupStore = (_class = function () {
  function RoleSetupStore() {
    var _this = this;

    (0, _classCallCheck3.default)(this, RoleSetupStore);

    _initDefineProp(this, 'roleList', _descriptor, this);

    _initDefineProp(this, 'roleDetail', _descriptor2, this);

    _initDefineProp(this, 'alertMessage', _descriptor3, this);

    this.roleList = new _Izenda10.default();
    this.roleDetail = new _Izenda12.default();
    this.alertMessage = {};
    this.accessStore = new _Izenda25.default();
    this.usersRoleSetupStore = new _Izenda18.default();
    this.permissionStore = new _Izenda20.default(this.roleDetail.permission, this.tenantId, IS_TENANT_SETUP);
    this.permissionSummaryStore = new _Izenda27.default();
    this.dataModelAccess = new _Izenda14.default(this.roleDetail);

    this.lazyLoadingStore = {};
    this.loadPartialDataModelAccess = null;
    this.disposeAutoUpdateTenantId = (0, _mobx.autorun)(function () {
      _this.permissionStore && (_this.permissionStore.tenantId = _this.tenantId);
    });
  }

  (0, _createClass3.default)(RoleSetupStore, [{
    key: 'init',


    /**
     * initial for role setup store
     * @method init
     */
    value: function init() {
      var _this2 = this;

      // whenever uiState changed the tenant.
      _Izenda6.default.setCheckDirtyFunction(function () {
        return _this2.isDirty;
      });
      this.cancelLoadDataModelAccess();
    }

    /**
     * destroy observe
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      _Izenda6.default.resetCheckDirtyFunction();
      this.disposeAutoUpdateTenantId();
    }

    /**
     * Load Data role setup tenant and role list
     * @return {Promise}
     */

  }, {
    key: 'loadDataRoleSetup',
    value: function loadDataRoleSetup() {
      return (0, _bluebird.all)([this.loadTenant(), this.getRoleList()]);
    }

    /**
     * get role list for current tenant
     */

  }, {
    key: 'getRoleList',
    value: function getRoleList() {
      var _this3 = this;

      return _Izenda2.default.getRoleList(this.tenantId).then((0, _mobx.action)(function (list) {
        _this3.roleList.readRoleList(list);

        if (_this3.roleList.isEmpty) {
          return _this3.addRole();
        }
        return _this3.selectRole((0, _fp.head)(list));
      }));
    }

    /**
     * add new role
     */

  }, {
    key: 'addRole',
    value: function addRole() {
      var _this4 = this;

      this.cancelLoadDataModelAccess();

      return this.loadTenantDetail().then((0, _mobx.action)(function (tenantDetail) {
        _this4.updateTenantDetail(tenantDetail);

        _this4.roleDetail.resetData(_this4.tenantId, _this4.permissionStore.tenantDetail);
        // load new user list
        _this4.loadUserList();

        _this4.dataModelAccess.reset();
        _this4.permissionStore.setRoleDetailId(null);
        (0, _fp.invoke)('unselectRole', _this4.roleList.configRole);

        // update access model and load data for access grid
        _this4.accessStore.updateModel(_this4.roleDetail.permissionAccessModel);
        _this4.accessStore.initialAccessGrid(_this4.roleDetail.permission.access.accessDefaults.value);
        _this4.roleDetail.changeRole();

        return true;
      }));
    }

    /**
     * select role for configRole
     * @param {any} roleListDetail
     * @return {Promise}  Promise to get new data from api for this role
     */

  }, {
    key: 'selectRole',
    value: function selectRole(roleListDetail) {
      var _this5 = this;

      this.cancelLoadDataModelAccess();

      return (0, _bluebird.join)(_Izenda2.default.loadRole(roleListDetail.id), this.loadTenantDetail(), (0, _mobx.action)(function (roleDetail, tenantDetail) {
        _this5.permissionStore.reset();
        _this5.permissionStore.setRoleDetailId(roleListDetail.id);
        _this5.permissionSummaryStore.model.updateRoleSelected(roleListDetail.id);

        _this5.updateTenantDetail(tenantDetail);
        _this5.roleList.configRole.unselectRole();
        _this5.roleList.selectRole(roleListDetail.id);

        _this5.resetAlertMessage();
        _this5.dataModelAccess.reset();

        // load access
        _this5.accessStore.updateModel(_this5.roleDetail.permissionAccessModel);
        _this5.roleDetail.populateData(roleDetail);
        _this5.roleDetail.changeRole();

        _this5.accessStore.initialAccessGrid(roleDetail.permission.access.accessDefaults.value);
        // Load user list
        _this5.loadUserList();

        _this5.dataModelAccess.showCheckedQuerySource = roleDetail.showCheckedQuerySource;
        return true;
      }));
    }

    /**
     * Build load tenant detail promises.
     */

  }, {
    key: 'loadTenantDetail',
    value: function loadTenantDetail() {
      return (0, _fp.isNil)(this.tenantId) ? (0, _bluebird.resolve)(null) : _Izenda4.default.loadTenant(this.tenantId);
    }

    /**
     * Update tenant detail
     * @param {any} tenantDetail
     */

  }, {
    key: 'updateTenantDetail',
    value: function updateTenantDetail(tenantDetail) {
      if (!tenantDetail) {
        return;
      }
      var permission = (0, _fp.get)('permission', tenantDetail);
      var permissionDetail = new _Izenda22.default(permission);
      this.permissionStore.updateTenantDetail(permissionDetail);
    }

    /**
     * delete role
     * @param {any} role
     * @return {Promise} Promise for calling delete api
     */

  }, {
    key: 'deleteRole',
    value: function deleteRole(role) {
      var _this6 = this;

      return _Izenda2.default.deleteRole(role.id).then(function () {
        role.delete();
        if (_this6.roleList.isEmpty) {
          return _this6.addRole();
        } else if (role.id === _this6.roleDetail.id) {
          return _this6.selectRole(_this6.roleList.findNextRole(role));
        }
        return null;
      });
    }

    /**
     * toggle active status
     * @param {any} role
     * @return {Promise} Promise for change active status
     */

  }, {
    key: 'toggleActive',
    value: function toggleActive(role) {
      var _this7 = this;

      var api = role.active ? _Izenda2.default.deactivateRole : _Izenda2.default.activateRole;
      var tenantId = _Izenda6.default.getTenantId();
      return api(role.id, tenantId).then(function (result) {
        if (result.success) {
          role.toggleActive();
          role.id === _this7.roleDetail.id && _this7.roleDetail.toggleActive();
        }
        return result;
      });
    }

    /**
     * update alert message
     * @method updateAlertMessage
     * @param  {string}           type
     * @param  {string}           message
     */

  }, {
    key: 'updateAlertMessage',
    value: function updateAlertMessage(type, message) {
      this.alertMessage = {
        type: type,
        message: message
      };
    }

    /**
     * reset alert message
     */

  }, {
    key: 'resetAlertMessage',
    value: function resetAlertMessage() {
      this.alertMessage = {};
    }

    /**
     * Load users
     */

  }, {
    key: 'loadUserList',
    value: function loadUserList() {
      this.usersRoleSetupStore.model.reload(this.roleDetail.users);
      return (0, _bluebird.resolve)(null);
    }

    /**
     * Load tenant detail
     * @return {Promise} Promise
     */

  }, {
    key: 'loadTenant',
    value: function loadTenant() {
      var _this8 = this;

      if (!(0, _fp.isNil)(this.tenantId)) {
        return _Izenda4.default.loadTenant(this.tenantId).then(function (data) {
          return new _Izenda22.default(data.permission);
        }).then(function (permissionDetail) {
          return _this8.permissionStore.tenantDetail = permissionDetail;
        });
      }

      return (0, _bluebird.resolve)(true);
    }

    /**
     * save roleInfo
     * @return {Promise} Promise api
     */

  }, {
    key: 'save',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var updatedAccess, saveData, result, messages;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Get update access
                updatedAccess = this.roleDetail.permissionAccessModel.getAccessForSave();
                // Update list access default

                this.roleDetail.permission.updateAccessDefault(updatedAccess);

                saveData = this.roleDetail.prepareDataForSave();

                saveData.users = this.usersRoleSetupStore.model.selectedUsers;
                saveData.visibleQuerySourcesTree = this.dataModelAccess.visibleQuerySourcesTree;
                saveData.showCheckedQuerySource = this.dataModelAccess.showCheckedQuerySource;

                _context.next = 8;
                return _Izenda2.default.saveRole(saveData);

              case 8:
                result = _context.sent;
                messages = this.processResponseSaveRoleSetup(result);

                if (!saveData.showCheckedQuerySource) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return this.getConnectionDetailInfo(null, true);

              case 13:
                return _context.abrupt('return', messages);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _ref.apply(this, arguments);
      }

      return save;
    }()

    /**
     * Process response save role setup
     * @param  {Object} result
     * @return {Array}
     */

  }, {
    key: 'processResponseSaveRoleSetup',
    value: function processResponseSaveRoleSetup(result) {
      if (!result.messages) {
        var savedData = result.role;
        var isNew = this.roleDetail.isNew;
        this.dataModelAccess.resetCacheTree();

        if (isNew) {
          this.roleList.addRole(savedData);
          this.permissionStore.setRoleDetailId(savedData.id);
        } else {
          this.roleList.configRole.readBasicInfo(savedData);
        }

        this.roleDetail.populateData(savedData);
        this.accessStore.updateAccessOrigin(savedData.permission.access.accessDefaults.value);

        this.updateAlertMessage(_Izenda8.default.MESSAGE_TYPE.SUCCESS, _Izenda29.default.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
        // save success then clean dirty
        this.cleanDirty();

        // reload access grid
        return this.accessStore.loadAllAccess(savedData.permission.access.accessDefaults.value);
      }

      return result.messages;
    }

    /**
     * clean Dirty
     */

  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      this.roleDetail.resetDirty();
      this.roleDetail.permission.resetDirty();
      this.roleDetail.permissionAccessModel.resetDirty();
      this.usersRoleSetupStore.model.cleanDirty();
      this.permissionStore.model.resetDirty();
    }

    /**
     * cancel role
     * @return {Promise} Promise api
     */

  }, {
    key: 'cancel',
    value: function cancel() {
      if ((0, _fp.get)('isNew', this.roleDetail)) {
        return this.addRole();
      }
      return this.selectRole(this.roleDetail);
    }

    /**
     * load Permission Summary
     * @return {Promise}
     */

  }, {
    key: 'loadPermissionSummary',
    value: function loadPermissionSummary() {
      this.permissionSummaryStore.model.permissionSummary = [];
      return this.permissionSummaryStore.loadPermissionSummary(this.tenantId);
    }

    /**
     * Save Role Setup
     * @return {promise}
     */

  }, {
    key: 'saveRoleSetup',
    value: function saveRoleSetup() {
      return _Izenda2.default.saveRole(this.roleDetail);
    }

    /**
     * Validation for access
     * @return {Promise} result of validation
     */

  }, {
    key: 'validateAccesses',
    value: function validateAccesses() {
      var updatedAccess = this.roleDetail.permissionAccessModel.getAccessForSave(true);

      var needAPICall = !(0, _fp.isEmpty)(updatedAccess);

      return needAPICall ? _Izenda16.default.validateAccesses(updatedAccess) : (0, _bluebird.resolve)(true);
    }

    /**
     * Cancel promise load data model access tree when loading
     */

  }, {
    key: 'cancelLoadDataModelAccess',
    value: function cancelLoadDataModelAccess() {
      if (this.loadPartialDataModelAccess && this.loadPartialDataModelAccess.isPending()) {
        this.loadPartialDataModelAccess.cancel();
      }
    }

    /**
     * Get connection detail info
     * @return {Promise}
     */

  }, {
    key: 'getConnectionDetailInfo',
    value: function getConnectionDetailInfo(pageInfo, isReset, searchKey) {
      var _this9 = this;

      var _dataModelAccess = this.dataModelAccess,
          visibleQuerySourcesTree = _dataModelAccess.visibleQuerySourcesTree,
          filterText = _dataModelAccess.filterText,
          showCheckedQuerySource = _dataModelAccess.showCheckedQuerySource;

      pageInfo = pageInfo || this.lazyLoadingStore.pageInfoForFirstTime;
      searchKey = searchKey || filterText;

      var params = {
        tenantId: this.tenantId,
        roleId: this.roleDetail.id,
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        parentIds: pageInfo.parentIds,
        visibleQuerySourcesTree: visibleQuerySourcesTree,
        criteria: [{
          key: 'DataSourceName',
          value: searchKey
        }, {
          key: 'ShowCheckedQuerySource',
          value: showCheckedQuerySource
        }]
      };

      this.loadPartialDataModelAccess = _Izenda2.default.loadPartialDataModelAccess(params);

      return this.loadPartialDataModelAccess.then(function (data) {
        _this9.processDataModelAccess(isReset, searchKey, data);
        _this9.loadPartialDataModelAccess = null;
        return data;
      });
    }

    /**
     * Process lazy loading data model access
     * @param  {Boolean} isReset
     * @param  {String} searchKey
     * @param  {Object} response
     */

  }, {
    key: 'processDataModelAccess',
    value: function processDataModelAccess(isReset, searchKey, response) {
      var dataModelAccess = this.dataModelAccess;
      dataModelAccess.isLastPage = response.isLastPage;
      isReset && dataModelAccess.resetData();

      if (toString(searchKey) !== toString(this.dataModelAccess.filterText)) {
        return;
      }

      var newData = dataModelAccess.convertData(response.data);
      (0, _Izenda30.concatTree)(dataModelAccess.connectionList, newData, _Izenda23.DATA_SOURCE_CONCAT_TREE_MAP, response.numOfChilds, []);
      (0, _Izenda30.updateTree)(dataModelAccess.connectionList, this.dataModelAccess.visibleQuerySourcesTree, _Izenda23.DATA_SOURCE_TREE_MAP, ['checked', 'interacted', 'indeterminate', 'numOfCheckedChilds']);
      dataModelAccess.displayData = (0, _Izenda30.parseToTree)(dataModelAccess.connectionList, _Izenda23.DATA_SOURCE_TREE_MAP);
    }

    /**
     * Search connection details
     * @param  {String} searchKey
     * @return {Promise}
     */

  }, {
    key: 'searchDataSourceItems',
    value: function searchDataSourceItems(searchKey) {
      this.getConnectionDetailInfo(null, true, searchKey);
    }

    /**
     * Register LazyLoading Store
     * @param  {Object} store
     */

  }, {
    key: 'registerLazyLoadingStore',
    value: function registerLazyLoadingStore(store) {
      this.lazyLoadingStore = store;
    }

    /**
     * Handle change data source item
     * @param  {Object} node
     * @param  {Object} parent
     */

  }, {
    key: 'handleChangeDataSourceItems',
    value: function handleChangeDataSourceItems(node, parent) {
      if (this.dataModelAccess.showCheckedQuerySource) {
        !node.source.checked && (node.source.uncheckedSSO = true);
      }
      (0, _Izenda30.updateInteractiveTree)(node, parent, this.dataModelAccess.visibleQuerySourcesTree);
    }

    /**
     * Handle toggle show query source
     * @param  {boolean} checked
     */

  }, {
    key: 'handleToggleShowSelectedQuerySource',
    value: function handleToggleShowSelectedQuerySource(checked) {
      // cancel load data model access if it loading
      this.cancelLoadDataModelAccess();
      // set flag showCheckedQuerySource
      this.dataModelAccess.setShowCheckedQuerySource(checked);
      // reset flag uncheckedSSO
      this.resetUncheckSSO(this.dataModelAccess.visibleQuerySourcesTree);

      // reload data model access
      return this.getConnectionDetailInfo(null, true);
    }

    /**
     * Reset UncheckSSO
     * @param  {Array} tree
     */

  }, {
    key: 'resetUncheckSSO',
    value: function resetUncheckSSO(tree) {
      var _this10 = this;

      (0, _fp.forEach)(function (item) {
        item.uncheckedSSO = false;
        _this10.resetUncheckSSO(item.childNodes);
      }, tree);
    }
  }, {
    key: 'isDirty',
    get: function get() {
      return this.roleDetail.hasChange || this.usersRoleSetupStore.model.isDirty || this.permissionStore.model.isDirty || this.dataModelAccess.hasChange;
    }
  }, {
    key: 'tenantId',
    get: function get() {
      return _Izenda6.default.getTenantId();
    }
  }]);
  return RoleSetupStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'roleList', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'roleDetail', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'alertMessage', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'isDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tenantId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addRole', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addRole'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectRole', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectRole'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteRole', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteRole'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleActive', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleActive'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadUserList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadUserList'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadTenant', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadTenant'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'save', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'save'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'processResponseSaveRoleSetup', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'processResponseSaveRoleSetup'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cleanDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cleanDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cancel', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cancel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadPermissionSummary', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadPermissionSummary'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getConnectionDetailInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getConnectionDetailInfo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'processDataModelAccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'processDataModelAccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'searchDataSourceItems', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'searchDataSourceItems'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleChangeDataSourceItems', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleChangeDataSourceItems'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleToggleShowSelectedQuerySource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleToggleShowSelectedQuerySource'), _class.prototype)), _class);
exports.default = RoleSetupStore;
module.exports = exports['default'];

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleList.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      map = _require.map,
      flow = _require.flow,
      get = _require.get,
      _isEmpty = _require.isEmpty,
      toUpper = _require.toUpper,
      reject = _require.reject,
      escapeRegExp = _require.escapeRegExp,
      sortBy = _require.sortBy,
      head = _require.head,
      invoke = _require.invoke,
      find = _require.find,
      filter = _require.filter;

  var RoleListDetail = __webpack_require__(2351);
  var upperCaseName = flow(get('name'), toUpper);

  function RoleList() {
    m.extendObservable(this, {
      roleList: [],
      configRole: new RoleListDetail(),
      filterText: '',
      filterRole: function filterRole() {
        var filterRegex = new RegExp(escapeRegExp(this.filterText), 'i');
        var validateName = flow(get('name'), filterRegex.test.bind(filterRegex));

        return flow(filter(validateName), sortBy(upperCaseName))(this.validRole);
      },
      validRole: function validRole() {
        return reject('deleted', this.roleList);
      },
      isEmpty: function isEmpty() {
        return _isEmpty(this.validRole);
      }
    });
  }

  /**
   * read role list from api
   */
  RoleList.prototype.readRoleList = m.action(function (roleList) {
    this.roleList = map(function (role) {
      return new RoleListDetail(role);
    }, roleList);
  });

  RoleList.prototype.findNextRole = m.action(function (role) {
    var oldName = upperCaseName(role);
    var nextRole = find(function (testRole) {
      return upperCaseName(testRole) > oldName;
    }, this.validRole);

    return nextRole || head(this.validRole);
  });

  RoleList.prototype.addRole = m.action(function (role) {
    var newRole = new RoleListDetail(role);

    this.roleList.push(newRole);
    invoke('unselectRole', this.configRole);
    this.configRole = newRole;
    this.configRole.selectRole();
    return newRole;
  });

  RoleList.prototype.selectRole = m.action(function (roleId) {
    var newConfigRole = find(['id', roleId], this.roleList);

    this.configRole.unselectRole();
    newConfigRole.selectRole();
    this.configRole = newConfigRole;
  });

  /**
   * update filter text
   */
  RoleList.prototype.updateFilterText = m.action(function (filterText) {
    this.filterText = filterText;
  });

  module.exports = RoleList;
}();

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleListDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);

  var RoleListDetail = function RoleListDetail(data) {
    var props = {
      id: null,
      name: null,
      active: null,
      tenantID: null,
      detailInfo: null,
      deleted: false,
      isSelected: false
    };

    m.extendObservable(trackable(this), props);
    data && this.readBasicInfo(data);
  };

  RoleListDetail.prototype.readBasicInfo = m.action(function (data) {
    this.id = data.id;
    this.name = data.name;
    this.active = data.active;
    this.deleted = data.deleted;
    this.tenantID = data.tenantID;
  });

  /**
   * unselect role
   */
  RoleListDetail.prototype.unselectRole = m.action(function () {
    this.isSelected = false;
  });

  /**
   * select role
   */
  RoleListDetail.prototype.selectRole = m.action(function () {
    this.isSelected = true;
  });

  /**
   * delete current role
   */
  RoleListDetail.prototype.delete = m.action(function () {
    this.deleted = true;
  });

  /**
   * toggle active status
   */
  RoleListDetail.prototype.toggleActive = m.action(function () {
    this.active = !this.active;
  });

  module.exports = RoleListDetail;
}();

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(206);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(325);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(54);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RoleDetail = (0, _Izenda6.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(RoleDetail, [{
    key: 'hasChange',
    get: function get() {
      return this.isDirty || this.permission.isDirty || this.permissionAccessModel.checkDirty();
    }
  }, {
    key: 'isNew',
    get: function get() {
      return !String.isGuidFormat(this.id);
    }
  }]);

  function RoleDetail(data) {
    (0, _classCallCheck3.default)(this, RoleDetail);

    _initDefineProp(this, 'key', _descriptor, this);

    _initDefineProp(this, 'users', _descriptor2, this);

    _initDefineProp(this, 'permission', _descriptor3, this);

    _initDefineProp(this, 'visibleQuerySources', _descriptor4, this);

    _initDefineProp(this, 'name', _descriptor5, this);

    _initDefineProp(this, 'tenantId', _descriptor6, this);

    _initDefineProp(this, 'active', _descriptor7, this);

    _initDefineProp(this, 'deleted', _descriptor8, this);

    _initDefineProp(this, 'id', _descriptor9, this);

    _initDefineProp(this, 'state', _descriptor10, this);

    _initDefineProp(this, 'inserted', _descriptor11, this);

    _initDefineProp(this, 'version', _descriptor12, this);

    _initDefineProp(this, 'created', _descriptor13, this);

    _initDefineProp(this, 'createdBy', _descriptor14, this);

    _initDefineProp(this, 'modified', _descriptor15, this);

    _initDefineProp(this, 'modifiedBy', _descriptor16, this);

    this.permissionAccessModel = new _Izenda4.default();
    this.basedProps = {
      users: [],
      name: null,
      active: true,
      id: null
    };
    data && this.populateData(data);
  }

  (0, _createClass3.default)(RoleDetail, [{
    key: 'changeRole',
    value: function changeRole() {
      this.key = (0, _fp.uniqueId)('RoleDetail_');
    }
  }, {
    key: 'toggleActive',
    value: function toggleActive() {
      this.active = !this.active;
    }
  }, {
    key: 'resetData',
    value: function resetData(tenantId, tenantDetail) {
      this.populateData((0, _fp.cloneDeep)(this.basedProps));
      this.tenantId = tenantId;

      // Get tenant data and populate to role.
      tenantDetail && this.permission.populateData(tenantDetail, this.permission.propsCloned, this.permission);
    }

    /**
     * Populate data
     * @param {Object} data
     */

  }, {
    key: 'populateData',
    value: function populateData(data) {
      this.users = data.users;
      this.permission.populateData(data.permission, this.permission.propsCloned, this.permission);
      this.visibleQuerySources = data.visibleQuerySources;
      this.name = data.name;
      this.tenantId = data.tenantId;
      this.active = data.active;
      this.deleted = data.deleted;
      this.id = data.id;
      this.state = data.state;
      this.inserted = data.inserted;
      this.version = data.version;
      this.created = data.created;
      this.createdBy = data.createdBy;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
      this.resetDirty();
    }

    /**
     * update name of role
     */

  }, {
    key: 'updateName',
    value: function updateName(newName) {
      this.name = newName;
      this.markDirty();
    }

    /**
     * Set Visible QuerySources
     * @param {Object} visibleQuerySources
     */

  }, {
    key: 'setVisibleQuerySources',
    value: function setVisibleQuerySources(visibleQuerySources) {
      this.visibleQuerySources = visibleQuerySources;
      this.markDirty();
    }

    /**
     * Prepare Data For Save
     * @return {Object}
     */

  }, {
    key: 'prepareDataForSave',
    value: function prepareDataForSave() {
      var data = (0, _fp.omit)(['id', 'basedProps', 'permissionAccessModel', 'key'], this);
      if (!this.isNew) {
        data.id = this.id;
      }

      return data;
    }
  }]);
  return RoleDetail;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'key', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'users', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'permission', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda2.default(null, false);
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'visibleQuerySources', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'tenantId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'active', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'deleted', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'state', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'inserted', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'version', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'created', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'createdBy', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'modified', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'modifiedBy', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'hasChange', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isNew', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isNew'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeRole', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changeRole'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleActive', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleActive'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateName', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setVisibleQuerySources', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setVisibleQuerySources'), _class2.prototype)), _class2)) || _class;

exports.default = RoleDetail;
module.exports = exports['default'];

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleDataModelAccess.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RoleDataModelAccess = (0, _Izenda2.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(RoleDataModelAccess, [{
    key: 'hasChange',
    get: function get() {
      return this.isDirty || !(0, _fp.isEmpty)(this.visibleQuerySourcesTree);
    }
  }]);

  function RoleDataModelAccess(roleDetail) {
    (0, _classCallCheck3.default)(this, RoleDataModelAccess);

    _initDefineProp(this, 'displayData', _descriptor, this);

    _initDefineProp(this, 'connectionList', _descriptor2, this);

    _initDefineProp(this, 'filterText', _descriptor3, this);

    _initDefineProp(this, 'showCheckedQuerySource', _descriptor4, this);

    this.isLastPage = false;
    this.visibleQuerySources = [];
    this.roleDetail = roleDetail;
    this.visibleQuerySourcesTree = [];
  }

  /**
   * Set show checked query source
   * @param {boolean} checked
   */


  (0, _createClass3.default)(RoleDataModelAccess, [{
    key: 'setShowCheckedQuerySource',
    value: function setShowCheckedQuerySource(checked) {
      this.markDirty();
      this.showCheckedQuerySource = checked;
    }

    /**
     * Reset data model access
     * @param  {string} type
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.resetDirty();
      this.resetCacheTree();
      this.resetData();
      this.filterText = '';
      this.showCheckedQuerySource = false;
    }

    /**
     * Reset cache tree
     */

  }, {
    key: 'resetCacheTree',
    value: function resetCacheTree() {
      this.resetDirty();
      this.visibleQuerySourcesTree.length = 0;
    }

    /**
     * Reset data tree
     */

  }, {
    key: 'resetData',
    value: function resetData() {
      this.displayData.length = 0;
      this.connectionList.length = 0;
    }

    /**
     * Read role data model access from data that normally returns from server API
     * @method readData
     * @param {array} data List Of connection
     */

  }, {
    key: 'readData',
    value: function readData(data) {
      this.connectionList = data;
    }

    /**
     * Convert data
     * @type {Array}
     */

  }, {
    key: 'convertData',
    value: function convertData(data) {
      return (0, _mobx.observable)(data);
    }
  }]);
  return RoleDataModelAccess;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'displayData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'connectionList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'filterText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'showCheckedQuerySource', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'hasChange', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setShowCheckedQuerySource', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setShowCheckedQuerySource'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reset', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reset'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetCacheTree', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetCacheTree'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'readData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'readData'), _class2.prototype)), _class2)) || _class;

exports.default = RoleDataModelAccess;
module.exports = exports['default'];

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2; // ----------------------------------------------------------------------
// <copyright file="Izenda.UsersRoleSetupStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2355);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(124);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(75);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * The store handles UI and logic of Users of a Role Setup
 */
var UsersRoleSetupStore = (_class = function () {
  (0, _createClass3.default)(UsersRoleSetupStore, [{
    key: 'tenantId',
    get: function get() {
      return _Izenda2.default.getTenantId();
    }
  }, {
    key: 'isDirty',
    get: function get() {
      return this.configUser.isDirty;
    }
  }]);

  function UsersRoleSetupStore(selectedUser) {
    (0, _classCallCheck3.default)(this, UsersRoleSetupStore);

    _initDefineProp(this, 'configUser', _descriptor, this);

    _initDefineProp(this, 'alertMessage', _descriptor2, this);

    this.model = new _Izenda4.default(selectedUser);
  }

  /**
  * reset alert message
  */


  (0, _createClass3.default)(UsersRoleSetupStore, [{
    key: 'resetAlertMessage',
    value: function resetAlertMessage() {
      this.alertMessage = {};
    }

    /**
     * Register LazyLoading Store
     * @param  {Object} store
     */

  }, {
    key: 'registerLazyLoadingStore',
    value: function registerLazyLoadingStore(store) {
      this.lazyLoadingStore = store;
    }

    /**
     * Load partial user list by lazy loading
     * @return {promise}
     */

  }, {
    key: 'getPartialUsers',
    value: function getPartialUsers(pageInfo, isSearching) {
      var _this = this;

      var searchText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      pageInfo = pageInfo || this.lazyLoadingStore.pageInfoForFirstTime;

      var params = {
        tenantId: this.tenantId,
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        criteria: [{
          key: _Izenda6.default.USER_LIST_SEARCH_KEY,
          value: searchText
        }]
      };

      var parseUsers = function parseUsers(result) {
        var filterText = (0, _fp.get)('searchedUserName', _this.model);
        if (searchText === filterText || (0, _fp.isEmpty)(searchText) === (0, _fp.isEmpty)(filterText)) {
          _this.model.populateLazyUserList(result, isSearching);
        }
      };

      return _Izenda8.default.getPartialUsers(params).then(parseUsers);
    }

    /**
     * Search users by search text
     * @param {String} searchText 
     */

  }, {
    key: 'searchUsers',
    value: function searchUsers(searchText) {
      this.model.updateSearchedUserName(searchText);

      this.getPartialUsers(null, true, searchText);
    }
  }]);
  return UsersRoleSetupStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'configUser', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'alertMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tenantId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDirty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDirty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetAlertMessage', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetAlertMessage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getPartialUsers', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getPartialUsers'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'searchUsers', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'searchUsers'), _class.prototype)), _class);
exports.default = UsersRoleSetupStore;
module.exports = exports['default'];

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _class4, _desc2, _value2, _class5, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
// ----------------------------------------------------------------------
// <copyright file="Izenda.UsersRoleSetup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(124);

var _Izenda6 = __webpack_require__(118);

var _Izenda7 = __webpack_require__(98);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * User inside Role setup
 */
var User = (0, _Izenda2.default)(_class = (_class2 = function () {
  function User(_ref, assigned) {
    var id = _ref.id,
        userName = _ref.userName,
        emailAddress = _ref.emailAddress,
        firstName = _ref.firstName,
        lastName = _ref.lastName,
        fullName = _ref.fullName,
        state = _ref.state;
    (0, _classCallCheck3.default)(this, User);

    _initDefineProp(this, 'assigned', _descriptor, this);

    this.id = id;
    this.userName = userName;
    this.emailAddress = emailAddress;
    this.firstName = firstName;
    this.lastName = lastName;
    this.fullName = fullName;
    this.state = state;
    this.assigned = assigned;
  }

  /**
   * Toggle the assigment status of user to the role
   */


  /**
   * Indicates whether the user is assigned to the role
   */


  (0, _createClass3.default)(User, [{
    key: 'toggleAssign',
    value: function toggleAssign() {
      this.assigned = !this.assigned;
      this.markDirty();
    }
  }]);
  return User;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'assigned', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'toggleAssign', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleAssign'), _class2.prototype)), _class2)) || _class;

/* UsersRoleSetup model */


var UsersRoleSetup = (0, _Izenda2.default)(_class4 = (_class5 = function () {
  (0, _createClass3.default)(UsersRoleSetup, [{
    key: 'filterUser',


    /**
     * A filtered user list
     */


    /**
     * Indicates the lazy loading has reached the last page
     */


    /**
     * The ID of assigned users
     */
    get: function get() {
      var filterRegex = new RegExp((0, _fp.escapeRegExp)(this.searchedUserName), 'i');
      return (0, _fp.isNil)(this.searchedUserName) ? this.usersList : (0, _fp.filter)((0, _fp.flow)((0, _fp.get)(['fullName']), filterRegex.test.bind(filterRegex)), this.usersList);
    }

    /**
     * Indicates the users role setup has been changed
     */


    /**
     * The pagination info using by lazy loading
     */


    /**
     * The filtered user name
     */

  }, {
    key: 'hasChanged',
    get: function get() {
      return this.isDirty || (0, _fp.some)('isDirty', this.usersList);
    }

    /**
     * Gets selected users object however it just has id property.
     * Used for posting back to API for saving assigned users of the role
     */

  }, {
    key: 'selectedUsers',
    get: function get() {
      return (0, _fp.map)(function (id) {
        return { id: id };
      }, this.selectedUserIds);
    }
  }]);

  function UsersRoleSetup(selectedUsers) {
    (0, _classCallCheck3.default)(this, UsersRoleSetup);

    _initDefineProp(this, 'usersList', _descriptor2, this);

    _initDefineProp(this, 'selectedUserIds', _descriptor3, this);

    _initDefineProp(this, 'searchedUserName', _descriptor4, this);

    _initDefineProp(this, 'isLastPage', _descriptor5, this);

    _initDefineProp(this, 'pageInfo', _descriptor6, this);

    this.reload(selectedUsers);
  }

  /**
   * Appending the user list from lazy loading
   * @param  {Object} result user lazy loading list result
   * @param  {boolean} isSearching
   */


  (0, _createClass3.default)(UsersRoleSetup, [{
    key: 'populateLazyUserList',
    value: function populateLazyUserList(_ref2, isSearching) {
      var _this = this;

      var result = _ref2.result,
          isLastPage = _ref2.isLastPage,
          total = _ref2.total;

      this.isLastPage = isLastPage;
      this.pageInfo.totalRecords = total;

      isSearching && (this.usersList = []);

      var newUsers = (0, _fp.map)(function (user) {
        var assigned = _this.selectedUserIds.indexOf(user.id) >= 0;
        return new User(user, assigned);
      }, result);

      var selectedTenantId = _Izenda4.default.getTenantId();
      var userTenantId = (0, _fp.flow)(_fp.head, (0, _fp.get)('tenantId'))(result);

      userTenantId === selectedTenantId && (0, _Izenda6.concatArray)(this.usersList, newUsers, 'id', !isLastPage);

      return this.usersList;
    }

    /**
     * Update searched user name
     * @param  {string} text
     */

  }, {
    key: 'updateSearchedUserName',
    value: function updateSearchedUserName(text) {
      this.searchedUserName = text;
    }

    /**
     * Toggle user assignment to the role
     * @param {User} user 
     */

  }, {
    key: 'toggleAssignUser',
    value: function toggleAssignUser(user) {
      if (user.assigned) {
        this.selectedUserIds.remove(user.id);
      } else {
        this.selectedUserIds.push(user.id);
      }

      user.toggleAssign();
      this.markDirty();
    }
  }, {
    key: 'cleanDirty',
    value: function cleanDirty() {
      (0, _fp.forEach)(function (user) {
        user.resetDirty && user.resetDirty();
      }, this.usersList);
      this.resetDirty();
    }

    /**
     * Reset the state of users role setup when changing selecting role
     * @param {Array<any>} selectedUsers 
     */

  }, {
    key: 'reload',
    value: function reload(selectedUsers) {
      this.usersList = [];
      this.selectedUserIds = selectedUsers !== null ? (0, _fp.map)((0, _fp.get)('id'), selectedUsers) : [];
      this.pageInfo = new _Izenda8.default(_Izenda5.DEFAULT_VALUE.SORT_DIRS, _Izenda5.DEFAULT_VALUE.SEARCH_CRITERIA);
      this.isLastPage = false;
      this.searchedUserName = '';
    }
  }]);
  return UsersRoleSetup;
}(), (_descriptor2 = _applyDecoratedDescriptor(_class5.prototype, 'usersList', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class5.prototype, 'selectedUserIds', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class5.prototype, 'searchedUserName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class5.prototype, 'isLastPage', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class5.prototype, 'pageInfo', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class5.prototype, 'filterUser', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'filterUser'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'hasChanged', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'hasChanged'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'populateLazyUserList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'populateLazyUserList'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'updateSearchedUserName', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'updateSearchedUserName'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'toggleAssignUser', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'toggleAssignUser'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'cleanDirty', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'cleanDirty'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'reload', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'reload'), _class5.prototype)), _class5)) || _class4;

exports.default = UsersRoleSetup;
module.exports = exports['default'];

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.RolePermission.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RolePermission = (_class = function () {
  function RolePermission() {
    (0, _classCallCheck3.default)(this, RolePermission);

    _initDefineProp(this, 'roles', _descriptor, this);

    _initDefineProp(this, 'displayData', _descriptor2, this);

    _initDefineProp(this, 'filterText', _descriptor3, this);

    this.lazyLoadingStore = {};
    this.isLastPage = false;
  }

  /**
   * Register lazy loading store
   * @param  {Object} store
   */


  (0, _createClass3.default)(RolePermission, [{
    key: 'registerLazyLoadingStore',
    value: function registerLazyLoadingStore(store) {
      this.lazyLoadingStore = store;
    }

    /**
     * Convert data
     * @param  {Array} data
     * @return {Array}
     */

  }, {
    key: 'convertData',
    value: function convertData(data) {
      return (0, _mobx.observable)(data);
    }

    /**
     * Reset data
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.roles = [];
      this.displayData = [];
      this.filterText = '';
    }
  }]);
  return RolePermission;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'roles', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'displayData', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'filterText', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, 'reset', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reset'), _class.prototype)), _class);
exports.default = RolePermission;
module.exports = exports['default'];

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryAccessibility.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      some = _require.some,
      map = _require.map,
      forEach = _require.forEach,
      flow = _require.flow,
      pick = _require.pick,
      invokeMap = _require.invokeMap,
      find = _require.find;

  var Category = function Category(data, hideNumber) {
    var props = {
      id: null,
      displayKey: function displayKey() {
        return String.format('{0}-{1}-{2}', this.id, this.tenantId, !!this.isGlobal /* true|false*/);
      },
      name: null,
      visible: false,
      canVisible: true,
      savable: false,
      canSavable: true,
      subCategories: [],
      parentId: null,
      tenantId: null,
      isGlobal: false,
      showNumChildren: !hideNumber,

      isSubCategory: function isSubCategory() {
        return isEmpty(this.subCategories.slice());
      },
      showInAvailableTree: function showInAvailableTree() {
        return !this.visible || some('showInAvailableTree', this.subCategories);
      },
      showInSavableTree: function showInSavableTree() {
        return this.savable || some('showInSavableTree', this.subCategories);
      },
      showInVisibleTree: function showInVisibleTree() {
        return this.visible && !this.savable || some('showInVisibleTree', this.subCategories);
      }
    };

    m.extendObservable(this, props);

    data && this.readBasicInfo(data);
  };

  /**
   * read category information
   */
  Category.prototype.readBasicInfo = m.action(function (data) {
    this.id = data.id;
    this.name = data.name;
    this.tenantId = data.tenantId;
    this.subCategories = map(function (subCategogy) {
      return new Category(subCategogy);
    }, data.subCategories);
    this.parentId = data.parentId;
    this.isGlobal = data.isGlobal;
  });

  /**
   * change Cateogry visible property
   */
  Category.prototype.toggleVisible = m.action(function (newValue) {
    this.visible = this.canVisible && newValue;
  });

  /**
   * change category savable property
   */
  Category.prototype.toggleSavable = m.action(function (newValue) {
    this.savable = !this.isGlobal && newValue;
  });

  /**
   * Build data saving for item category/ sub-category
   * @return {object}  category
   */
  Category.prototype.prepareDataForSave = m.action(function (newValue) {
    return {
      id: this.id,
      savable: this.showInSavableTree,
      tenantId: this.tenantId,
      name: this.name,
      isGlobal: this.isGlobal,
      subCategories: flow(filter(function (item) {
        return item.showInVisibleTree || item.showInSavableTree;
      }), map(function (note) {
        return {
          id: note.id,
          savable: note.savable,
          tenantId: note.tenantId,
          name: note.name,
          subCategories: flow(filter('visible'), map(pick(['id', 'savable', 'tenantId', 'name'])))(note.subCategories)
        };
      }))(this.subCategories)
    };
  });

  var CategoryAccessibility = function CategoryAccessibility(isTenantSetup) {
    var props = {
      categories: []
    };
    this.isTenantSetup = !!isTenantSetup;

    m.extendObservable(this, props);
  };

  CategoryAccessibility.prototype.reset = function () {
    this.categories = [];
  };

  /**
   * build categoris list
   * @method populateData
   * @param  {[type]}     data [description]\
   */
  CategoryAccessibility.prototype.populateData = m.action(function (data) {
    this.categories = map(function (category) {
      return new Category(category, true);
    }, data);
  });

  /**
   * Build visible and savable item for saving
   * @return {array} list visible/ savable categories/ sub-categories
   */
  CategoryAccessibility.prototype.prepareDataForSave = function () {
    return flow(filter(function (item) {
      return item.showInVisibleTree || item.showInSavableTree;
    }), invokeMap('prepareDataForSave'))(this.categories);
  };

  /**
   * read permission model
   */
  CategoryAccessibility.prototype.readCategoryAccessibility = m.action(function (data) {
    var recursiveToggle = function recursiveToggle(data, source) {
      forEach(function (item) {
        var note = find({ id: item.id, tenantId: item.tenantId }, source);
        if (note) {
          note.toggleSavable(item.savable);
          note.toggleVisible(true);
        }
        item && note && recursiveToggle(item.subCategories, note.subCategories);
      }, data);
    };
    recursiveToggle(data, this.categories);
  });

  module.exports = CategoryAccessibility;
}();

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionSummaryStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(274);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2359);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var PermissionSummaryStore = (_class = function () {
  function PermissionSummaryStore(tenantId, model) {
    (0, _classCallCheck3.default)(this, PermissionSummaryStore);

    _initDefineProp(this, 'tenantId', _descriptor, this);

    _initDefineProp(this, 'model', _descriptor2, this);

    this.tenantId = tenantId || null;
    this.model = model || new _Izenda4.default();
  }

  /**
   * loadPermissionSummary
   * @param  {string} tenantId
   * @return {Promise}
   */


  (0, _createClass3.default)(PermissionSummaryStore, [{
    key: 'loadPermissionSummary',
    value: function loadPermissionSummary(tenantId) {
      tenantId = tenantId || this.tenantId;
      var readPermissionSummay = (0, _mobx.action)(function (result) {
        if ((0, _fp.isNil)(result.message)) {
          this.model.populateData(result);
        }
      });
      return _Izenda2.default.loadPermissionSummary(tenantId).bind(this).then(readPermissionSummay);
    }
  }]);
  return PermissionSummaryStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, 'loadPermissionSummary', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadPermissionSummary'), _class.prototype)), _class);
exports.default = PermissionSummaryStore;
module.exports = exports['default'];

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionSummary.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(206);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var PermissionSummary = (_class = function () {
  function PermissionSummary(data) {
    (0, _classCallCheck3.default)(this, PermissionSummary);

    _initDefineProp(this, 'permissionSummary', _descriptor, this);

    _initDefineProp(this, 'selectedRoleId', _descriptor2, this);

    _initDefineProp(this, 'collapseAll', _descriptor3, this);

    data && this.populateData(data);
  }

  /**
   * populate data
   * @param {object} data
   */


  (0, _createClass3.default)(PermissionSummary, [{
    key: 'populateData',
    value: function populateData(data) {
      var _this = this;

      (0, _fp.forEach)(function (item) {
        _this.permissionSummary.push({
          id: item.id,
          name: item.name,
          permission: new _Izenda2.default(item.permission, false)
        });
      }, data);
      this.setShowingRoleList();
    }

    /**
     * update Role Selected
     * @param  {string} roleId
     */

  }, {
    key: 'updateRoleSelected',
    value: function updateRoleSelected(roleId) {
      this.selectedRoleId = roleId;
    }

    /**
     * set Showing Role List
     */

  }, {
    key: 'setShowingRoleList',
    value: function setShowingRoleList() {
      var permissionIndex = (0, _fp.findIndex)({ id: this.selectedRoleId }, this.permissionSummary);
      if (permissionIndex > 0) {
        var temp = this.permissionSummary[0];
        this.permissionSummary[0] = this.permissionSummary[permissionIndex];
        this.permissionSummary[permissionIndex] = temp;
      }
    }
  }, {
    key: 'updateExpendCollapseAll',
    value: function updateExpendCollapseAll(state) {
      this.collapseAll = state;
    }
  }]);
  return PermissionSummary;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'permissionSummary', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'selectedRoleId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'collapseAll', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'populateData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRoleSelected', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRoleSelected'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setShowingRoleList', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setShowingRoleList'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateExpendCollapseAll', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateExpendCollapseAll'), _class.prototype)), _class);
exports.default = PermissionSummary;
module.exports = exports['default'];

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Advanced Settings component
 */
!function () {
  var connect = __webpack_require__(2);

  var MiddlePanel = __webpack_require__(196);
  var MainContent = __webpack_require__(156);
  var ContextMenu = __webpack_require__(334);
  var ScrollBox = __webpack_require__(27);
  var AdvancedSettingsConstants = __webpack_require__(2361);
  var uiState = __webpack_require__(15);

  var React = __webpack_require__(0);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      head = _require.head,
      placeholder = _require.placeholder;

  var viewComponents = {
    performance: {
      component: __webpack_require__(2362),
      storePath: 'performance'
    },
    security: {
      component: __webpack_require__(2365),
      storePath: 'security'
    },
    others: {
      component: __webpack_require__(2369),
      storePath: 'others'
    },
    category: {
      component: __webpack_require__(2371),
      storePath: 'category'
    },
    notFound: {
      component: __webpack_require__(213)
    }
  };

  function getComponentInfo(key) {
    return placeholder(viewComponents).get(key, viewComponents.notFound);
  }

  var AdvancedSettings = React.createClass({
    displayName: 'AdvancedSettings',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      var authorization = this.props.authorization;
      this.menu = filter(function (item) {
        // Do not show menu which is for system user, when current user is not a system user.
        if (item.forSystemAdmin && !uiState.currentUser.systemAdmin) return false;

        if (item.permissionKeys) {
          if (item.permissionOperator) {
            if (!authorization.checkPrivileges(item.permissionKeys, item.permissionOperator)) {
              return false;
            }
          } else {
            if (!authorization.checkPrivileges(item.permissionKeys)) {
              return false;
            }
          }
        }
        return true;
      }, AdvancedSettingsConstants.MENU);

      this.setInitialSelectedItem();
    },

    /**
     * Build initial selected item.
     */
    setInitialSelectedItem: function setInitialSelectedItem() {
      var initialSelectedItem = head(this.menu);
      initialSelectedItem && this.changeItem(initialSelectedItem.key);
    },

    /**
     * Handle change selected item
     */
    changeItem: function changeItem(newLink) {
      var store = this.props.store;
      if (store.activeLink !== newLink) {
        this.props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(function () {
          store.changeSelectItem(newLink);
        });
      }
    },

    /**
     * Render right content when click middle panel
     */
    renderRightContent: function renderRightContent() {
      var info = getComponentInfo(this.props.store.activeLink);
      var store = info.storePath ? placeholder(this.props.store).get(info.storePath) : null;
      return store ? React.createElement(info.component, { store: store }) : React.createElement(info.component, null);
    },
    /**
     * Render middle panel
     */
    renderMiddlePanel: function renderMiddlePanel() {
      return React.createElement(
        MiddlePanel,
        null,
        React.createElement(ContextMenu, {
          dataSource: this.menu,
          activeKey: this.props.store.activeLink,
          enabled: true,
          onSelected: this.changeItem,
          className: 'izenda-DataModel-Middle'
        })
      );
    },

    /**
     * Render main content
     */
    renderMainContent: function renderMainContent() {
      return React.createElement(
        'div',
        { className: 'izenda-TableLayout-Cell' },
        this.renderRightContent()
      );
    },
    render: function render() {
      var store = this.props.store;

      return React.createElement(
        'div',
        { className: 'izenda-AdvancedSettings izenda-TableLayout' },
        this.renderMiddlePanel(),
        this.renderMainContent()
      );
    }
  });

  module.exports = connect()(AdvancedSettings);
}();

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(42);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(12);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedSettingConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  get MENU() {
    return [{
      key: 'performance',
      icon: 'icon-gauge',
      title: _Izenda4.default.getText('ADVANCED_SETTINGS_CONSTANTS_LABEL_MENU_PERFORMANCE'),
      forSystemAdmin: true
    }, {
      key: 'security',
      icon: 'icon-lock',
      title: _Izenda4.default.getText('ADVANCED_SETTINGS_CONSTANTS_LABEL_MENU_SECURITY'),
      forSystemAdmin: true
    }, {
      key: 'category',
      icon: 'icon-list-bullet',
      title: _Izenda4.default.getText('ADVANCED_SETTINGS_CONSTANTS_LABEL_MENU_CATEGORY'),
      permissionKeys: [_Izenda2.default.PERMISSION_KEY.DataSetupAdvancedSettingsCategory]
    }, {
      key: 'others',
      icon: 'icon-resize-small-alt',
      title: _Izenda4.default.getText('COMMON_LABEL_OTHERS'),
      permissionKeys: [_Izenda2.default.PERMISSION_KEY.DataSetupAdvancedSettingsOthers]
    }];
  }
};
module.exports = exports['default'];

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Performance.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Performace component
 */
!function () {
  var React = __webpack_require__(0);

  var IconMenu = __webpack_require__(86);
  var GridLayout = __webpack_require__(13);
  var ActionBar = __webpack_require__(147);
  var Alert = __webpack_require__(61);
  var EventsUtils = __webpack_require__(24);

  var actions = __webpack_require__(2363);

  var Validator = __webpack_require__(23);
  var Input = Validator()(__webpack_require__(17));
  var constants = __webpack_require__(2364);
  var connect = __webpack_require__(2);

  var PerformanceAlert = connect()(function (props) {
    var alertMessage = this.props.performanceModel.alertMessage;

    return React.createElement(
      'div',
      { className: 'izenda-Alert-container' },
      React.createElement(
        Alert,
        { type: alertMessage.type },
        alertMessage.message
      )
    );
  });

  var PerformanceGrid = connect()(function (props) {
    var notifyChange = EventsUtils.notifyChange;
    var store = props.store;
    var performanceModel = store.performanceModel;
    var localization = props.localization;

    function renderFormgroupItem(label, title, input, resetFuntion) {
      return React.createElement(
        'div',
        { className: 'form-group item' },
        React.createElement(
          'span',
          { className: 'col-md-7 col-xs-5 control-label' },
          label,
          ' \xA0 ',
          React.createElement('span', { className: 'icon-info-circled', title: title })
        ),
        React.createElement(
          'div',
          { className: 'col-md-3 col-xs-6' },
          input
        ),
        React.createElement(
          'div',
          { className: 'col-md-2 col-xs-1 control-label' },
          React.createElement('span', { className: 'icon-ccw resetButton',
            onClick: resetFuntion,
            title: localization.getText('PERFORMANCE_RESET_TO_DEFAULT') })
        )
      );
    }

    function renderTimeoutInput() {
      return React.createElement(
        'div',
        { className: 'u_table' },
        React.createElement(Input, {
          type: 'text',
          name: constants.FIELD_NAMES.QUERY_TIME_OUT,
          className: 'form-control',
          maxLength: 6,
          value: performanceModel.queryTimeoutValue,
          onChange: notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.QUERY_TIME_OUT), EventsUtils.INPUT),
          validations: constants.getLimitConstraint(constants.FIELD_NAMES.QUERY_TIME_OUT),
          field: constants.FIELD_NAMES.QUERY_TIME_OUT }),
        React.createElement(
          'span',
          { className: 'u_tableCell' },
          '\xA0(s)'
        )
      );
    }

    function renderNoLockInput() {
      return React.createElement(Input, {
        type: 'checkbox',
        name: 'noLock',
        checked: performanceModel.useNoLockValue,
        onChange: notifyChange(performanceModel.updateValue.bind(performanceModel, 'useNoLock'), EventsUtils.CHECKBOX) });
    }

    function renderDataSourceInput() {
      return React.createElement(Input, {
        type: 'text',
        name: constants.FIELD_NAMES.DATA_SOURCE_LIMIT,
        className: 'form-control',
        maxLength: 6,
        value: performanceModel.dataSourceLimitValue,
        onChange: notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.DATA_SOURCE_LIMIT), EventsUtils.INPUT),
        validations: constants.getLimitConstraint(constants.FIELD_NAMES.DATA_SOURCE_LIMIT),
        field: constants.FIELD_NAMES.DATA_SOURCE_LIMIT });
    }

    function renderFieldLimitInput() {
      return React.createElement(Input, {
        type: 'text',
        name: constants.FIELD_NAMES.FIELD_LIMIT,
        className: 'form-control',
        maxLength: 6,
        value: performanceModel.fieldLimitValue,
        onChange: notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.FIELD_LIMIT), EventsUtils.INPUT),
        validations: constants.getLimitConstraint(constants.FIELD_NAMES.FIELD_LIMIT),
        field: constants.FIELD_NAMES.FIELD_LIMIT });
    }

    function renderQueryLimitInput() {
      return React.createElement(Input, {
        type: 'text',
        name: constants.FIELD_NAMES.QUERY_LIMIT,
        className: 'form-control',
        maxLength: 10,
        value: performanceModel.queryLimitValue,
        onChange: notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.QUERY_LIMIT), EventsUtils.INPUT),
        validations: constants.getLimitConstraint(constants.FIELD_NAMES.QUERY_LIMIT),
        field: constants.FIELD_NAMES.QUERY_LIMIT });
    }

    function renderPivotColumnLimitInput() {
      return React.createElement(Input, {
        type: 'text',
        name: constants.FIELD_NAMES.PIVOT_COLUMN_LIMIT,
        className: 'form-control',
        maxLength: 6,
        value: performanceModel.pivotColumnLimitValue,
        onChange: notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.PIVOT_COLUMN_LIMIT), EventsUtils.INPUT),
        validations: constants.getLimitConstraint(constants.FIELD_NAMES.PIVOT_COLUMN_LIMIT),
        field: constants.FIELD_NAMES.PIVOT_COLUMN_LIMIT });
    }

    function renderFilterLimitInput() {
      return React.createElement(Input, {
        type: 'text',
        name: constants.FIELD_NAMES.FILTER_LIMIT,
        className: 'form-control',
        maxLength: 6,
        value: performanceModel.filterLimitValue,
        onChange: notifyChange(performanceModel.updateValue.bind(performanceModel, constants.FIELD_NAMES.FILTER_LIMIT), EventsUtils.INPUT),
        validations: constants.getLimitConstraint(constants.FIELD_NAMES.FILTER_LIMIT),
        field: constants.FIELD_NAMES.FILTER_LIMIT });
    }

    return React.createElement(
      'div',
      { className: 'form-horizontal', role: 'form' },
      React.createElement(
        'div',
        { className: 'form-group' },
        React.createElement(
          'strong',
          { className: 'col-md-7 col-xs-6 control-label' },
          localization.getText("COMMON_LABEL_NAME")
        ),
        React.createElement(
          'strong',
          { className: 'col-md-5 col-xs-6 control-label' },
          localization.getText("COMMON_LABEL_VALUE")
        )
      ),
      renderFormgroupItem(localization.getText("PERFORMANCE_LABEL_QUERY_TIMEOUT"), localization.getText('PERFORMANCE_TIMEOUT_TOOLTIP'), renderTimeoutInput(), performanceModel.resetValue.bind(performanceModel, 'queryTimeout')),
      renderFormgroupItem(localization.getText("PERFORMANCE_LABEL_USE_NO_LOCK"), localization.getText('PERFORMANCE_NOLOCK_TOOLTIP'), renderNoLockInput(), performanceModel.resetValue.bind(performanceModel, 'useNoLock')),
      renderFormgroupItem(localization.getText("PERFORMANCE_LABEL_DATA_SOURCE_LIMIT"), localization.getText('PERFORMANCE_DATASOURCE_TOOLTIP'), renderDataSourceInput(), performanceModel.resetValue.bind(performanceModel, 'dataSourceLimit')),
      renderFormgroupItem(localization.getText("PERFORMANCE_FIELD_LIMIT"), localization.getText('PERFORMANCE_FIELD_LIMIT_TOOLTIP'), renderFieldLimitInput(), performanceModel.resetValue.bind(performanceModel, 'fieldLimit')),
      renderFormgroupItem(localization.getText("PERFORMANCE_QUERY_LIMIT"), localization.getText('PERFORMANCE_QUERY_LIMIT_TOOLTIP'), renderQueryLimitInput(), performanceModel.resetValue.bind(performanceModel, 'queryLimit')),
      renderFormgroupItem(localization.getText("PERFORMANCE_PIVOT_COLUMN_LIMIT"), localization.getText('PERFORMANCE_PIVOT_COLUMN_LIMIT_TOOLTIP'), renderPivotColumnLimitInput(), performanceModel.resetValue.bind(performanceModel, 'pivotColumnLimit')),
      renderFormgroupItem(localization.getText("PERFORMANCE_FILTER_LIMIT"), localization.getText('PERFORMANCE_FILTER_LIMIT_TOOLTIP'), renderFilterLimitInput(), performanceModel.resetValue.bind(performanceModel, 'filterLimit'))
    );
  });

  var Performance = React.createClass({
    displayName: 'Performance',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentDidMount: function componentDidMount() {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.init().finally(loader.endLoading.bind(loader));
    },

    componentWillUnmount: function componentWillUnmount() {
      this.props.store.destroy();
    },

    render: function render() {
      var props = this.props;
      var performanceModel = props.store.performanceModel;

      return React.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-header' },
          React.createElement(IconMenu, null),
          React.createElement(PerformanceAlert, { performanceModel: performanceModel }),
          React.createElement(ActionBar, { onSave: props.onSave, onCancel: props.onCancel })
        ),
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          React.createElement(
            GridLayout,
            { className: 'u_fullHeight u_paddingLeftRight' },
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                null,
                React.createElement(PerformanceGrid, props)
              )
            )
          )
        )
      );
    }
  });

  module.exports = connect(actions)(Performance);
}();

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PerformanceAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var mobx = __webpack_require__(5);
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withState = __webpack_require__(9).withState;
  var withHandlers = __webpack_require__(9).withHandlers;

  var commonMessages = __webpack_require__(37);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isEmpty = _require.isEmpty;

  var PerformanceAction = compose(withHandlers({
    onSave: curry(onSave),
    onCancel: curry(onCancel)
  }));

  function onCancel(props, _) {
    var store = props.store;
    var localization = props.localization;

    if (store.performanceModel.isDirty) {
      props.confirmFn('Confirmation', {
        description: localization.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST')
      }).then(loadInitalData.bind(null, props));
    }
  }

  function loadInitalData(props) {
    var loader = props.loader;
    var store = props.store;

    props.validation.reset();

    loader.startLoading();
    store.getInitial().finally(loader.endLoading.bind(loader));
  }

  function onSave(props, e) {
    var store = props.store;
    var loader = props.loader;
    var performanceModel = store.performanceModel;
    var valManager = props.validation;
    var localization = props.localization;

    performanceModel.alertMessage = commonMessages.EMPTY_MESSAGE;
    loader.startLoading();

    return valManager.validate().then(function (success) {
      if (success && !performanceModel.isDirty) {
        performanceModel.alertMessage = {
          type: 'info',
          message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
        };
      } else if (success) {
        return props.confirmFn('Confirmation', {
          description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
        }).then(store.onSave.bind(store));
      }
      return null;
    }.bind(this)).then(function (saveErrors) {
      if (!isEmpty(saveErrors)) {
        valManager.updateErrors(saveErrors);
      }
      return null;
    }).finally(loader.endLoading.bind(loader));
  }

  module.exports = PerformanceAction;
}();

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIMIT_CONSTRAINT = {
  queryTimeout: ['PERFORMANCE_QUERY_TIMEOUT_REQUIRED', 'PERFORMANCE_QUERY_TIMEOUT_NUMBERICALITY', 'PERFORMANCE_QUERY_TIMEOUT_GREATER_THAN_0', 'PERFORMANCE_QUERY_TIMEOUT_LESS_THAN_MAX_INT'],
  dataSourceLimit: ['PERFORMANCE_DS_LIMIT_REQUIRED', 'PERFORMANCE_DS_LIMIT_NUMBERICALITY', 'PERFORMANCE_DS_LIMIT_GREATER_THAN_0', 'PERFORMANCE_DS_LIMIT_LESS_THAN_MAX_INT'],
  fieldLimit: ['PERFORMANCE_FIELD_LIMIT_REQUIRED', 'PERFORMANCE_FIELD_LIMIT_NUMBERICALITY', 'PERFORMANCE_FIELD_LIMIT_GREATER_THAN_0', 'PERFORMANCE_FIELD_LIMIT_LESS_THAN_MAX_INT'],
  queryLimit: ['PERFORMANCE_QUERY_LIMIT_REQUIRED', 'PERFORMANCE_QUERY_LIMIT_NUMBERICALITY', 'PERFORMANCE_QUERY_LIMIT_GREATER_THAN_0', 'PERFORMANCE_QUERY_LIMIT_LESS_THAN_MAX_INT'],
  pivotColumnLimit: ['PERFORMANCE_PIVOT_COLUMN_LIMIT_REQUIRED', 'PERFORMANCE_PIVOT_COLUMN_LIMIT_NUMBERICALITY', 'PERFORMANCE_PIVOT_COLUMN_LIMIT_GREATER_THAN_0', 'PERFORMANCE_PIVOT_COLUMN_LIMIT_LESS_THAN_MAX_INT'],
  filterLimit: ['PERFORMANCE_FILTER_LIMIT_REQUIRED', 'PERFORMANCE_FILTER_LIMIT_NUMBERICALITY', 'PERFORMANCE_FILTER_LIMIT_GREATER_THAN_0', 'PERFORMANCE_FILTER_LIMIT_LESS_THAN_MAX_INT']
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.PerformanceConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = {
  MAX_INT: Math.pow(2, 31),
  FIELD_NAMES: {
    QUERY_TIME_OUT: 'queryTimeout',
    DATA_SOURCE_LIMIT: 'dataSourceLimit',
    FIELD_LIMIT: 'fieldLimit',
    QUERY_LIMIT: 'queryLimit',
    PIVOT_COLUMN_LIMIT: 'pivotColumnLimit',
    FILTER_LIMIT: 'filterLimit'
  },

  getLimitConstraint: function getLimitConstraint(key) {
    return {
      presence: {
        presence: true,
        get message() {
          return _Izenda2.default.getText(LIMIT_CONSTRAINT[key][0]);
        }
      },
      numericality: {
        onlyInteger: true,
        get notOnlyInteger() {
          return _Izenda2.default.getText(LIMIT_CONSTRAINT[key][1]);
        },
        greaterThanOrEqualTo: 0,
        get notGreaterThanOrEqualTo() {
          return _Izenda2.default.getText(LIMIT_CONSTRAINT[key][2]);
        },
        lessThanOrEqualTo: Math.pow(2, 31) - 1,
        get notLessThanOrEqualTo() {
          return _Izenda2.default.getText(LIMIT_CONSTRAINT[key][3]);
        }
      }
    };
  }
};
module.exports = exports['default'];

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Security.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Security Component
 */
!function () {
  var React = __webpack_require__(0);

  var IconMenu = __webpack_require__(86);
  var GridLayout = __webpack_require__(13);
  var ActionBar = __webpack_require__(147);
  var ErrorContainer = __webpack_require__(406);
  var SecurityAdditiveField = __webpack_require__(2366);
  var SecurityConfigTenant = __webpack_require__(2367);
  var Alert = __webpack_require__(61);
  var commonMessages = __webpack_require__(37);
  var connect = __webpack_require__(2);

  var Security = React.createClass({
    displayName: 'Security',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    loadInitialData: function loadInitialData() {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.getInitial().finally(loader.endLoading.bind(loader));
    },

    componentDidMount: function componentDidMount() {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.init().finally(loader.endLoading.bind(loader));
    },

    onSave: function onSave(e) {
      var props = this.props;
      var loader = props.loader;
      var store = props.store;
      var model = store.model;
      var localization = props.localization;

      model.resetErrorMessage();

      if (model.isDirty) {
        loader.startLoading();

        props.confirmFn('Confirmation', {
          description: localization.getText("COMMON_MESSAGES_CONFIRM_SAVE")
        }).then(store.saveTenantSecurity.bind(store)).then(store.loadSecurity.bind(store)).then(model.readSecuritySetting.bind(model)).finally(loader.endLoading.bind(loader));
      } else {
        model.alertMessage = {
          type: 'info',
          message: localization.getText("COMMON_MESSAGES_NO_CHANGES_FOUND")
        };
      }
    },

    onCancel: function onCancel() {
      var store = this.props.store;
      var model = store.model;
      var localization = this.props.localization;
      if (model.isDirty) {
        this.props.confirmFn('Confirmation', {
          description: localization.getText("COMMON_MESSAGES_CONFIRM_CHANGES_LOST")
        }).then(this.loadInitialData);
      }
    },

    render: function render() {
      var store = this.props.store;
      var model = store.model;
      return React.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-header' },
          React.createElement(IconMenu, null),
          React.createElement(
            Alert,
            { type: model.alertMessage.type },
            model.alertMessage.message
          ),
          React.createElement(ActionBar, { onSave: this.onSave, onCancel: this.onCancel }),
          React.createElement(ErrorContainer, { errors: model.errors })
        ),
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          React.createElement(
            'div',
            { className: 'u_paddingLeftRight' },
            React.createElement(SecurityConfigTenant, { store: store }),
            React.createElement(SecurityAdditiveField, { store: store })
          )
        )
      );
    },

    componentWillUnmount: function componentWillUnmount() {
      this.props.store.destroy();
    }
  });

  module.exports = connect()(Security);
}();

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Security.AdditiveField.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Security Additive Field Component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;

  var Panel = __webpack_require__(28);
  var Button = __webpack_require__(30);
  var EventsUtils = __webpack_require__(24);

  var SecurityAdditiveField = React.createClass({
    displayName: 'SecurityAdditiveField',


    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    renderVisibleField: function renderVisibleField(bundle) {
      var notifyChange = EventsUtils.notifyChange;
      var model = this.props.store.model;

      return React.createElement(
        'div',
        { className: 'form-group' },
        React.createElement(
          'label',
          { className: 'col-md-7 col-xs-6 control-label field-name' },
          React.createElement(
            'span',
            null,
            bundle.LABEL.VISIBLE_FIELD_LABEL
          ),
          React.createElement('i', { className: 'icon-info-circled',
            title: bundle.TOOLTIP.VISIBLE_FIELD_TOOLTIP })
        ),
        React.createElement(
          'div',
          { className: 'col-md-5 col-xs-6' },
          React.createElement('input', { type: 'checkbox',
            checked: model.additiveFieldAutoVisibleValue,
            onChange: notifyChange(model.updateFieldVisible.bind(model), EventsUtils.CHECKBOX) })
        )
      );
    },

    renderFilterableField: function renderFilterableField(bundle) {
      var notifyChange = EventsUtils.notifyChange;
      var model = this.props.store.model;

      return React.createElement(
        'div',
        { className: 'form-group' },
        React.createElement(
          'label',
          { className: 'col-md-7 col-xs-6 control-label field-name' },
          React.createElement(
            'span',
            null,
            bundle.LABEL.FILTERABLE_FIELD_LABEL
          ),
          React.createElement('i', { className: 'icon-info-circled',
            title: bundle.TOOLTIP.FILTERABLE_FIELD_TOOLTIP })
        ),
        React.createElement(
          'div',
          { className: 'col-md-5 col-xs-6' },
          React.createElement('input', { type: 'checkbox',
            checked: model.additiveFieldAutoFilterableValue,
            onChange: notifyChange(model.updateFieldsFilterable.bind(model), EventsUtils.CHECKBOX) })
        )
      );
    },

    render: function render() {
      var store = this.props.store;
      var bundle = store.getBundle();

      return React.createElement(
        'div',
        { className: 'form-horizontal' },
        this.renderVisibleField(bundle),
        this.renderFilterableField(bundle)
      );
    }
  });

  module.exports = observer(SecurityAdditiveField);
}();

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Security.ConfigTenant.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Security Config Tenant Component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var Panel = __webpack_require__(28);
  var Button = __webpack_require__(30);
  var Select = __webpack_require__(47);
  var ErrorContainer = __webpack_require__(406);
  var EventsUtils = __webpack_require__(24);
  var action = __webpack_require__(2368);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;

  var SecurityConfigTenant = React.createClass({
    displayName: 'SecurityConfigTenant',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    onClickResetTenantFieldValue: function onClickResetTenantFieldValue() {
      this.props.store.model.resetTenantFieldValue();
    },

    renderTenantField: function renderTenantField() {
      var props = this.props;
      var store = props.store;
      var model = store.model;
      var notifyChange = EventsUtils.notifyChange;
      var bundle = store.getBundle();

      var systemField = function systemField() {
        var fields = model.getSystemTenantFields();
        if (model.isSystemMode || isEmpty(fields)) {
          return null;
        } else {
          return React.createElement(
            'div',
            { className: 'field-center' },
            bundle.LABEL.SYSTEM_TENANT_FIELD_LABEL + fields
          );
        }
      };

      return React.createElement(
        'div',
        { className: 'form-group u_fullHeight' },
        React.createElement(
          'label',
          { className: 'col-md-7 col-xs-6 field-name control-label' },
          React.createElement(
            'span',
            null,
            bundle.LABEL.TENANT_FIELD_LABEL
          ),
          React.createElement('i', { className: 'icon-info-circled', title: bundle.TOOLTIP.TENANT_TOOLTIP })
        ),
        React.createElement(
          'div',
          { className: 'col-md-5 col-xs-6 tenant-fields' },
          React.createElement(
            'div',
            { className: 'col-md-10 u_inlineBlock no-padding' },
            systemField(),
            React.createElement(Select, {
              value: model.tenantFieldValue,
              multi: true,
              delimiter: ';',
              simpleValue: true,
              joinValues: true,
              onAddNew: props.addNewTenantField,
              options: props.getTenantFieldOptions(model.tenantFieldValue),
              onBlur: props.blurTenantField,
              onChange: props.changeTenantField,
              onBlurResetsInput: false,
              noResultsText: bundle.TEXT.TENANT_FIELD_NO_RESULT_TEXT,
              isInsertOnBlur: true,
              textboxMode: true,
              subClassName: 'u_fullHeight'
            })
          ),
          React.createElement(
            'div',
            { className: 'col-md-2 col-xs-1 control-label' },
            React.createElement('i', {
              className: 'icon-ccw reset-tenant-field',
              title: bundle.TOOLTIP.RESET_TENANT_FIELD_TOOLTIP,
              onClick: this.onClickResetTenantFieldValue
            })
          )
        )
      );
    },

    render: function render() {
      var store = this.props.store;
      var model = store.model;
      var notifyChange = EventsUtils.notifyChange;
      var bundle = store.getBundle();

      return React.createElement(
        'div',
        { className: 'form-horizontal' },
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'label',
            { className: 'col-md-7 col-xs-6 control-label field-name' },
            React.createElement(
              'span',
              null,
              bundle.LABEL.SHOW_TENANT_FIELD_LABEL
            ),
            React.createElement('i', { className: 'icon-info-circled', title: bundle.TOOLTIP.SHOW_TENANT_TOOLTIP })
          ),
          React.createElement(
            'div',
            { className: 'col-md-5 col-xs-6' },
            React.createElement('input', {
              type: 'checkbox',
              className: 'show-tenant-field',
              checked: model.showTenantFieldValue,
              onChange: notifyChange(model.updateShowTenantField.bind(model), EventsUtils.CHECKBOX)
            })
          )
        ),
        this.renderTenantField()
      );
    }
  });

  module.exports = connect(action)(SecurityConfigTenant);
}();

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityConfigTenant.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil,
      isEmpty = _require.isEmpty,
      split = _require.split,
      last = _require.last;

  var SecurityConfigTenant = compose(withHandlers({
    getTenantFieldOptions: curry(getTenantFieldOptions),
    changeTenantField: curry(changeTenantField),
    addNewTenantField: curry(addNewTenantField),
    blurTenantField: curry(blurTenantField)
  }));

  /**
   * Handle change tenant field
   * @param props
   * @param newVal
   */
  function getTenantFieldOptions(props, tenantFieldValue) {
    if (isNil(tenantFieldValue) || isEmpty(tenantFieldValue)) {
      return [];
    }

    return split(';', tenantFieldValue).map(function (item) {
      return {
        label: item,
        value: item
      };
    });
  }

  /**
   * Handle change tenant field
   * @param props
   * @param newVal
   */
  function changeTenantField(props, newVal) {
    var store = props.store;
    var model = store.model;

    if (last(newVal) === ';') {
      newVal = newVal.slice(0, -1);
    }

    model.updateTenantField(newVal);
  }

  /**
   * Handle add new tenant field
   * @param props
   * @param newVal
   */
  function addNewTenantField(props, newData) {
    var store = props.store || {};
    var model = store.model;
    if (!model || isEmpty(newData.value.trim())) {
      return;
    }

    var options = split(';', model.tenantFieldValue);
    // Not in list , add new item
    options.indexOf(newData.value) === -1 && model.addNewTenantField(newData.value);
  }

  /**
   * Handle blur tenant field
   * @param props
   * @param value
   */
  function blurTenantField(props, value) {
    addNewTenantField(props, value);
  }

  module.exports = SecurityConfigTenant;
}();

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Others.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Others component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda3 = __webpack_require__(2370);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(61);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(86);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(147);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(27);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorInput = (0, _Izenda6.default)()(_Izenda8.default);

var OthersAlert = (0, _Izenda2.default)()(function (props) {
  var alertMessage = props.alertMessage;

  return _react2.default.createElement(
    'div',
    { className: 'izenda-Alert-container' },
    _react2.default.createElement(
      _Izenda10.default,
      { type: alertMessage.type },
      alertMessage.message
    )
  );
});

var OthersContent = (0, _Izenda2.default)()(function (props) {
  var store = props.store,
      localization = props.localization;

  var model = store.otherSettings;
  var bundle = model.getBundle();
  var constraints = {
    presence: {
      presence: true,
      message: localization.getText('OTHER_SETTINGS_INTRODUCTION_TEXT_REQUIRED')
    }
  };
  var SAMEFIELD_SAMEDBSCHEMA = 0;
  var SAMEFIELD_SAMEDBSCHEMA_OR_CONNECTIONSTRING = 1;
  var SAMEALIAS = 2;

  var renderFormgroupItem = function renderFormgroupItem(label, title, resetFunction, control, className) {
    className = (0, _classnames2.default)('form-group item', className);
    return _react2.default.createElement(
      'div',
      { className: className },
      _react2.default.createElement(
        'span',
        { className: 'col-md-6 col-xs-5 control-label' },
        label,
        ' \xA0 ',
        _react2.default.createElement('span', { className: 'icon-info-circled', title: title })
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-md-4 col-xs-6' },
        ' ',
        control,
        ' '
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-md-2 col-xs-1 control-label' },
        _react2.default.createElement('span', { className: 'icon-ccw resetButton', onClick: resetFunction, title: bundle.RESET_TO_DEFAULT })
      )
    );
  };

  var resetValueFn = function resetValueFn(propKey) {
    return function () {
      model.resetValue(propKey);
    };
  };

  var updateValueFn = function updateValueFn(propKey, paramPath) {
    return function (e) {
      var value = paramPath ? (0, _fp.get)(paramPath, e) : e;
      model.updateValue(propKey, value);
    };
  };

  var updateTimezoneOffsetFn = function updateTimezoneOffsetFn(propKey, paramPath) {
    return function (e) {
      var value = paramPath ? (0, _fp.get)(paramPath, e) : e;
      model.updateTimezoneOffset(propKey, value);
    };
  };

  return _react2.default.createElement(
    'div',
    { className: 'form-horizontal', role: 'form' },
    _react2.default.createElement(
      'div',
      { className: 'form-group' },
      _react2.default.createElement(
        'strong',
        { className: 'col-md-6 col-xs-6 control-label' },
        localization.getText('COMMON_LABEL_NAME')
      ),
      _react2.default.createElement(
        'strong',
        { className: 'col-md-6 col-xs-6 control-label' },
        localization.getText('COMMON_LABEL_VALUE')
      )
    ),
    renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_SORT_COLUMN_NAME'), localization.getText('OTHER_SETTINGS_SORT_COLUMN_NAME'), resetValueFn('sortColumnName'), _react2.default.createElement(ValidatorInput, {
      type: 'checkbox',
      name: 'trimTimeInJoin',
      onChange: updateValueFn('sortColumnName', _EventUtils2.default.CHECKBOX),
      checked: store.otherSettings.sortColumnNameValue
    })),
    renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_TRIM_TIME_IN_JOINS'), localization.getText('OTHER_SETTINGS_TRIM_TIME_IN_JOINS'), resetValueFn('trimTimeInJoins'), _react2.default.createElement(ValidatorInput, {
      type: 'checkbox',
      name: 'trimTimeInJoin',
      onChange: updateValueFn('trimTimeInJoins', _EventUtils2.default.CHECKBOX),
      checked: store.otherSettings.trimTimeInJoinsValue
    })),
    renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_TIMEZONE_FOR_DATA_OFFSET'), localization.getText('OTHER_SETTINGS_TIMEZONE_FOR_DATA_ZONE'), resetValueFn('timezoneForDataOffset'), _react2.default.createElement(ValidatorInput, {
      type: 'text',
      className: 'form-control',
      name: 'timezoneForDataOffset',
      onChange: updateValueFn('timezoneForDataOffset', _EventUtils2.default.INPUT),
      onBlur: updateTimezoneOffsetFn('timezoneForDataOffset', _EventUtils2.default.INPUT),
      value: store.otherSettings.timezoneForDataOffsetValue
    })),
    renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_TIMEZONE_FOR_TIMESTAMP_OFFSET'), localization.getText('OTHER_SETTINGS_TIMEZONE_FOR_TIMESTAMP_ZONE'), resetValueFn('timezoneForTimestampOffset'), _react2.default.createElement(ValidatorInput, {
      type: 'text',
      className: 'form-control',
      name: 'timezoneForTimestampOffset',
      onChange: updateValueFn('timezoneForTimestampOffset', _EventUtils2.default.INPUT),
      onBlur: updateTimezoneOffsetFn('timezoneForTimestampOffset', _EventUtils2.default.INPUT),
      value: store.otherSettings.timezoneForTimestampOffsetValue
    })),
    renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_CONVERT_NULL_TO_EMPTY_STRING'), localization.getText('OTHER_SETTINGS_CONVERT_NULL_TO_EMPTY_STRING'), resetValueFn('convertNullToEmptyString'), _react2.default.createElement(ValidatorInput, {
      type: 'checkbox',
      name: 'convertNullToEmptyString',
      onChange: updateValueFn('convertNullToEmptyString', _EventUtils2.default.CHECKBOX),
      checked: store.otherSettings.convertNullToEmptyStringValue
    })),
    renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_SHOW_SCHEMA_NAME'), localization.getText('OTHER_SETTINGS_SHOW_SCHEMA_NAME'), resetValueFn('showSchemaName'), _react2.default.createElement(ValidatorInput, {
      type: 'checkbox',
      name: 'showSchemaName',
      onChange: updateValueFn('showSchemaName', _EventUtils2.default.CHECKBOX),
      checked: store.otherSettings.showSchemaNameValue
    })),
    renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_SHOW_INTRODUCTION_NAME'), localization.getText('OTHER_SETTINGS_SHOW_INTRODUCTION_NAME'), resetValueFn('showIntroductionText'), _react2.default.createElement(ValidatorInput, {
      type: 'checkbox',
      name: 'showIntroductionText',
      onChange: updateValueFn('showIntroductionText', _EventUtils2.default.CHECKBOX),
      checked: store.otherSettings.showIntroductionTextValue
    })),
    store.otherSettings.showIntroductionTextValue && renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_INTRODUCTION_TEXT'), localization.getText('OTHER_SETTINGS_INTRODUCTION_TEXT'), resetValueFn('introductionText'), _react2.default.createElement(ValidatorInput, {
      type: 'text',
      className: 'form-control',
      name: 'introductionText',
      validations: constraints,
      field: 'introductionText',
      onChange: updateValueFn('introductionText', _EventUtils2.default.INPUT),
      value: store.otherSettings.introductionTextValue
    })),
    renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_SEND_TO_DISK_PATH'), localization.getText('OTHER_SETTINGS_SEND_TO_DISK_PATH'), resetValueFn('sendToDiskPath'), _react2.default.createElement(ValidatorInput, {
      type: 'text',
      className: 'form-control',
      name: 'sendToDiskPath',
      onChange: updateValueFn('sendToDiskPath', _EventUtils2.default.INPUT),
      value: store.otherSettings.sendToDiskPathValue
    })),
    renderFormgroupItem(localization.getText('OTHER_SETTINGS_LABEL_DETERMINE_COMMON_FILTER'), localization.getText('OTHER_SETTINGS_TOOLTIP_DETERMINE_COMMON_FILTER'), resetValueFn('commonFilterSetting'), _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'label',
        { className: 'izenda-commonFilterItem' },
        _react2.default.createElement('input', {
          type: 'radio',
          name: 'commonFilter',
          onChange: updateValueFn('commonFilterSetting', _EventUtils2.default.INPUT),
          checked: store.otherSettings.commonFilterSettingValue === SAMEFIELD_SAMEDBSCHEMA,
          value: '0'
        }),
        _react2.default.createElement(
          'span',
          { className: 'control-label' },
          localization.getText('OTHER_SETTINGS_SAMEFIELD_SAMEDBSCHEMA')
        )
      ),
      _react2.default.createElement(
        'label',
        { className: 'izenda-commonFilterItem' },
        _react2.default.createElement('input', {
          type: 'radio',
          name: 'commonFilter',
          onChange: updateValueFn('commonFilterSetting', _EventUtils2.default.INPUT),
          checked: store.otherSettings.commonFilterSettingValue === SAMEFIELD_SAMEDBSCHEMA_OR_CONNECTIONSTRING,
          value: '1'
        }),
        _react2.default.createElement(
          'span',
          { className: 'control-label' },
          localization.getText('OTHER_SETTINGS_SAMEFIELD_SAMEDBSCHEMA_OR_CONNECTIONSTRING')
        )
      ),
      _react2.default.createElement(
        'label',
        { className: 'izenda-commonFilterItem' },
        _react2.default.createElement('input', {
          type: 'radio',
          name: 'commonFilter',
          onChange: updateValueFn('commonFilterSetting', _EventUtils2.default.INPUT),
          checked: store.otherSettings.commonFilterSettingValue === SAMEALIAS,
          value: '2'
        }),
        _react2.default.createElement(
          'span',
          { className: 'control-label' },
          localization.getText('OTHER_SETTINGS_SAMEALIAS')
        )
      )
    ), 'izenda-commonFilter'),
    store.otherSettings.isAllowMultiSortDisplayed && renderFormgroupItem(localization.getText('OTHER_SETTING_LABEL_MULTIPLE_SORT_ON_GRID_HEADER'), localization.getText('OTHER_SETTING_MULTIPLE_SORT_ON_GRID_HEADER'), resetValueFn('multipleSortOnGridHeader'), _react2.default.createElement(ValidatorInput, {
      type: 'checkbox',
      name: 'multipleSortOnGridHeader',
      onChange: updateValueFn('multipleSortOnGridHeader', _EventUtils2.default.CHECKBOX),
      checked: store.otherSettings.multipleSortOnGridHeaderValue
    })),
    model.canShowPreview && renderFormgroupItem(localization.getText('OTHER_SETTING_LABEL_SHOW_PREVIEW_HEADER'), localization.getText('OTHER_SETTING_LABEL_SHOW_PREVIEW_TOOLTIP'), resetValueFn('showPreview'), _react2.default.createElement(ValidatorInput, {
      type: 'checkbox',
      name: 'showPreview',
      onChange: updateValueFn('showPreview', _EventUtils2.default.CHECKBOX),
      checked: store.otherSettings.showPreviewValue
    })),
    renderFormgroupItem(localization.getText('OTHER_SETTING_LABEL_HIDE_HEADER_FOOTER_IN_REPORT'), localization.getText('OTHER_SETTING_LABEL_HIDE_HEADER_FOOTER_IN_REPORT_TOOLTIP'), resetValueFn('hideReportHeaderAndFooter'), _react2.default.createElement(ValidatorInput, {
      type: 'checkbox',
      name: 'hideReportHeaderAndFooter',
      onChange: updateValueFn('hideReportHeaderAndFooter', _EventUtils2.default.CHECKBOX),
      checked: store.otherSettings.hideReportHeaderAndFooterValue
    }))
  );
});

var Others = (_dec = (0, _Izenda2.default)(_Izenda4.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Others, _Component);

  function Others() {
    (0, _classCallCheck3.default)(this, Others);
    return (0, _possibleConstructorReturn3.default)(this, (Others.__proto__ || (0, _getPrototypeOf2.default)(Others)).apply(this, arguments));
  }

  (0, _createClass3.default)(Others, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          loader = _props.loader,
          store = _props.store;


      loader.startLoading();
      store.init().finally(loader.endLoading.bind(loader));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var model = props.store.otherSettings;

      return _react2.default.createElement(
        _Izenda16.default,
        null,
        _react2.default.createElement(
          'section',
          { className: 'izenda-Wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'izenda-Wrapper-header' },
            _react2.default.createElement(_Izenda12.default, null),
            _react2.default.createElement(OthersAlert, { alertMessage: model.alertMessage }),
            _react2.default.createElement(_Izenda14.default, { onSave: props.onSave, onCancel: props.onCancel })
          ),
          _react2.default.createElement(
            'div',
            { className: 'izenda-Wrapper-content' },
            _react2.default.createElement(
              'div',
              { className: 'u_paddingLeftRight' },
              _react2.default.createElement(OthersContent, props)
            )
          )
        )
      );
    }
  }]);
  return Others;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = Others;
module.exports = exports['default'];

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.OthersAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var mobx = __webpack_require__(5);
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withState = __webpack_require__(9).withState;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isEmpty = _require.isEmpty;

  var commonMessages = __webpack_require__(37);

  var OthersAction = compose(withHandlers({
    onSave: curry(onSave),
    onCancel: curry(onCancel)
  }));

  function onCancel(props, e) {
    var loader = props.loader;
    var store = props.store;
    var model = store.otherSettings;

    loader.startLoading();
    props.confirmDirtyForm(model.isDirty).then(store.getInitial.bind(store)).finally(loader.endLoading.bind(loader));
  }

  function onSave(props, e) {
    var store = props.store;
    var loader = props.loader;
    var model = store.otherSettings;
    var localization = props.localization;
    model.alertMessage = commonMessages.EMPTY_MESSAGE;

    return props.validation.validate().then(function (result) {
      if (result) {
        if (model.isDirty) {
          loader.startLoading();

          return props.confirmFn('Confirmation', {
            description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
          }).then(store.onSave.bind(store)).finally(loader.endLoading.bind(loader));
        } else {
          model.alertMessage = {
            type: 'info',
            message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
          };
        }
      }
    }).then(function (saveErrors) {
      if (!isEmpty(saveErrors)) {
        valManager.updateErrors(saveErrors);
      }
      return null;
    });
  }

  module.exports = OthersAction;
}();

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Category.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Category component
 */
!function () {
  var React = __webpack_require__(0);

  var IconMenu = __webpack_require__(86);
  var ActionBar = __webpack_require__(147);
  var CategoryGrid = __webpack_require__(2372);
  var Alert = __webpack_require__(61);
  var ErrorContainer = __webpack_require__(406);
  var commonMessages = __webpack_require__(37);
  var connect = __webpack_require__(2);

  var Category = React.createClass({
    displayName: 'Category',


    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    onSave: function onSave() {
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var localization = props.localization;
      store.alertMessage = commonMessages.EMPTY_MESSAGE;

      var valManager = this.props.validation;

      valManager.validate().then(function (success) {
        loader.startLoading();
        if (success && !store.hasChange) {
          store.alertMessage = {
            type: 'info',
            message: localization.getText("COMMON_MESSAGES_NO_CHANGES_FOUND")
          };
        } else if (success) {
          return props.confirmFn('Confirmation', {
            description: localization.getText("COMMON_MESSAGES_CONFIRM_SAVE")
          }).then(function () {
            return store.saveCategories();
          });
        }
        return null;
      }.bind(this)).then(function (result) {
        if (result && !result.success) {
          valManager.updateErrors(result.messages);
        }
        return null;
      }).finally(loader.endLoading.bind(loader));
    },

    /**
    * Handle cancel button's click event
    */
    onCancel: function onCancel() {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      this.props.confirmDirtyForm(store.hasChange).then(store.getInitial.bind(store)).finally(loader.endLoading.bind(loader));
    },

    /**
    * Reset validation on security page
    */
    resetValidation: function resetValidation() {
      this.props.validation.reset();
    },

    /**
    * render button save and cancel
    */
    renderHeader: function renderHeader() {
      return React.createElement(ActionBar, { onSave: this.onSave, onCancel: this.onCancel });
    },

    /**
    * render main grid
    */
    renderGrid: function renderGrid() {
      var store = this.props.store;
      return React.createElement(CategoryGrid, { ref: 'categoryGrid', store: store });
    },

    /**
    * render main function
    */
    render: function render() {
      var store = this.props.store;
      return React.createElement(
        'section',
        { className: 'izenda-Wrapper' },
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-header' },
          React.createElement(IconMenu, null),
          React.createElement(
            Alert,
            { type: store.alertMessage.type },
            store.alertMessage.message
          ),
          this.renderHeader(),
          React.createElement(ErrorContainer, { errors: store.errors })
        ),
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-content u_marginLeftRight' },
          this.renderGrid()
        )
      );
    },

    componentWillUnmount: function componentWillUnmount() {
      this.props.store.destroy();
    },

    componentWillMount: function componentWillMount() {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.init().finally(loader.endLoading.bind(loader));
    }

  });

  module.exports = connect()(Category);
}();

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Category Grid component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(27);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1154);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

var _Izenda9 = __webpack_require__(17);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorInput = (0, _Izenda4.default)()(_Izenda10.default);

var CategoryGrid = (_dec = (0, _Izenda2.default)({ toClass: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(CategoryGrid, _Component);

  function CategoryGrid() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CategoryGrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CategoryGrid.__proto__ || (0, _getPrototypeOf2.default)(CategoryGrid)).call.apply(_ref, [this].concat(args))), _this), _this.handleChangeTextbox = function (e, item) {
      var store = _this.props.store;

      store.updateCategoryName(item, e.target.value);
    }, _this.onAddNew = function () {
      var store = _this.props.store;

      store.addEmptyCategory();
    }, _this.onSave = function () {
      var store = _this.props.store;

      store.saveCategories();
    }, _this.handleDelete = function (item) {
      var _this$props = _this.props,
          store = _this$props.store,
          localization = _this$props.localization;


      _this.props.confirmFn('Confirmation', {
        description: localization.getText('CATEGORY_MESSAGE_CONFIRM_DELETE')
      }).then(function () {
        store.delCategory(item);
      });
    }, _this.renderGridHeader = function () {
      var localization = _this.props.localization;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-CategoryGrid-header izenda-Wrapper-header' },
        _react2.default.createElement(
          'div',
          { className: 'column-left u_floatLeft' },
          _react2.default.createElement(
            'span',
            { className: 'validation required' },
            localization.getText('CATEGORY_LABEL_NAME')
          ),
          _react2.default.createElement('span', { className: 'icon-info-circled', title: localization.getText('CATEGORY_LABEL_NAME_TOOLTIP') })
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_floatRight' },
          _this.renderHeaderAddButton()
        )
      );
    }, _this.renderHeaderAddButton = function () {
      var localization = _this.props.localization;


      return _react2.default.createElement(
        'a',
        { onClick: _this.onAddNew, className: 'link-add' },
        localization.getText('CATEGORY_LABEL_ADD_NEW'),
        _react2.default.createElement('span', { className: 'icon-addnew' })
      );
    }, _this.renderGrid = function () {
      var store = _this.props.store;

      var categories = store.categoryMetadatas;
      var cats = categories.map(function (item, index) {
        {
          return _this.renderCatItem(item, index);
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper-content' },
        _react2.default.createElement(
          _Izenda6.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'u_table u-bgWhite izenda-CategoryGrid-content' },
            cats
          )
        )
      );
    }, _this.renderCatItem = function (item, index) {
      /**
       * handle textbox event
       */
      var textChange = function textChange(event) {
        _this.handleChangeTextbox(event, item);
      };

      var onDelete = function onDelete() {
        _this.handleDelete(item);
      };

      var hassError = (0, _classnames2.default)('u_tableCell u_fullWidth u_borderRight u_paddingInner', {
        'has-error': !(0, _fp.isEmpty)(item.error)
      });

      var _this2 = _this,
          store = _this2.props.store;

      return _react2.default.createElement(
        'div',
        { key: item.key, className: 'izenda-CategoryGrid-row u_tableRow u_alignMiddle' },
        _react2.default.createElement(
          'div',
          { className: hassError },
          _react2.default.createElement(ValidatorInput, {
            className: 'form-control',
            onChange: textChange,
            value: item.name,
            maxLength: '50',
            autoFocus: item === store.lastAddCategory,
            validations: _Izenda8.default.CONSTRAINTS,
            field: '[' + index + '].Name'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_tableCell u_paddingAll u_alignMiddle' },
          _react2.default.createElement(
            'a',
            { className: 'link-remove', onClick: onDelete },
            _react2.default.createElement('span', { className: 'icon-minus' })
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /**
   * Handle onChange for textbox on grid
   * @param {Object} event
   */


  /**
   * Handle onChange for textbox on grid
   * @param {Object} event
   */


  /**
   * render grid header with 2 columns: Category Name and Add new link
   */


  /**
   * render add new button
   */


  /**
   * render category grid
   */


  /**
   * render category item
   */


  (0, _createClass3.default)(CategoryGrid, [{
    key: 'render',


    /**
     * render main function
     */
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        this.renderGridHeader(),
        this.renderGrid()
      );
    }
  }]);
  return CategoryGrid;
}(_react.Component)) || _class);
exports.default = CategoryGrid;
module.exports = exports['default'];

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.CopyManagement.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
  * @module CopyManagement component
  */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var WorkspaceDetail = __webpack_require__(2374);
  var WorkspaceList = __webpack_require__(2411);

  var MiddlePanel = __webpack_require__(196);

  var WorkspaceStore = __webpack_require__(2413);
  var WorkspaceDetailStore = __webpack_require__(2425);

  var CopyManagement = React.createClass({
    displayName: 'CopyManagement',

    componentWillMount: function componentWillMount() {
      this.workspaceStore = new WorkspaceStore();
      this.workspaceDetailStore = new WorkspaceDetailStore(this.workspaceStore);
    },

    componentDidMount: function componentDidMount() {
      var loader = this.props.loader;
      loader.startLoading();
      this.workspaceStore.loadList().finally(loader.endLoading.bind(loader));
    },

    componentWillUnmount: function componentWillUnmount() {
      this.workspaceStore.dispose();
    },

    render: function render() {
      return React.createElement(
        'section',
        { className: 'izenda-CopyManagement izenda-TableLayout' },
        React.createElement(
          MiddlePanel,
          null,
          React.createElement(WorkspaceList, { store: this.workspaceStore })
        ),
        React.createElement(
          'div',
          { className: 'izenda-TableLayout-Cell' },
          React.createElement(WorkspaceDetail, {
            store: this.workspaceDetailStore,
            item: this.workspaceDetailStore.item })
        )
      );
    }
  });

  module.exports = connect()(CopyManagement);
}();

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(91);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobxReact = __webpack_require__(10);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda3 = __webpack_require__(27);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(37);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2375);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2376);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2378);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2382);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2387);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2391);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2392);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(2393);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(2395);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(2397);

var _Izenda28 = _interopRequireDefault(_Izenda27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * @module WorkspaceDetail component
 * @example
 *   <WorkspaceDetail>
 *     <ActionBar></ActionBar>
 *     <HeaderSection></HeaderSection>
 *     <AdditionalItems></AdditionalItems>
 *     <SourceDestinationSettings></SourceDestinationSettings>
 *   </WorkspaceDetail>
 */

var WorkspaceDetail = function (_Component) {
  (0, _inherits3.default)(WorkspaceDetail, _Component);

  function WorkspaceDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, WorkspaceDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WorkspaceDetail.__proto__ || (0, _getPrototypeOf2.default)(WorkspaceDetail)).call.apply(_ref, [this].concat(args))), _this), _this.onOpenPopup = function (isSaveAs) {
      return _this.props.openPopup(_Izenda12.default, {
        onClosing: _this.onSave,
        store: _this.props.store,
        isSaveAs: isSaveAs
      });
    }, _this.onSave = function (isSaveAs) {
      var _this$props = _this.props,
          item = _this$props.item,
          _this$props$item = _this$props.item,
          canSave = _this$props$item.canSave,
          isNew = _this$props$item.isNew,
          store = _this$props.store,
          localization = _this$props.localization;


      if (canSave || isSaveAs) {
        // handle concurrency when save old item
        // because when save as or save new item it had already handled in Save Workspace pop up
        return store.save(isSaveAs).then(function (result) {
          if (!isNew && !isSaveAs) {
            return _this.reloadDataPopup(result);
          }
          return result;
        });
      } else {
        item.alertMessage = {
          type: _Izenda8.default.MESSAGE_TYPE.INFO,
          message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
        };
        return (0, _bluebird.resolve)();
      }
    }, _this.onOpenSavePopup = function () {
      var _this$props2 = _this.props,
          isNew = _this$props2.item.isNew,
          loader = _this$props2.loader;


      if (isNew) {
        return _this.onOpenPopup(false);
      } else {
        loader.startLoading();
        return _this.onSave(false).finally(loader.endLoading.bind(loader));
      }
    }, _this.onOpenSaveAsPopUp = function () {
      _this.onOpenPopup(true);
    }, _this.onCancel = function () {
      var _this$props3 = _this.props,
          loader = _this$props3.loader,
          _this$props3$item = _this$props3.item,
          isNew = _this$props3$item.isNew,
          id = _this$props3$item.id,
          store = _this$props3.store;

      if (isNew) {
        store.masterStore.filter = '';
        store.masterStore.addWorkspace();
      } else {
        loader.startLoading();
        store.load(id).finally(loader.endLoading.bind(loader));
      }
    }, _this.onRefresh = function () {
      var _this$props4 = _this.props,
          loader = _this$props4.loader,
          store = _this$props4.store;


      loader.startLoading();
      store.checkHashCodeSource().finally(loader.endLoading.bind(loader));
    }, _this.onRunCopy = function () {
      var item = _this.props.store.item;


      item.resetValueForRunCopy();
      item.setCanRunCopyStatus(false);
      _this.onValidate().then(function (result) {
        result && result.success && _this.handleOverwriteConfirmation();
        return null;
      });
    }, _this.handleOverwriteConfirmation = function () {
      var _this$props5 = _this.props,
          store = _this$props5.store,
          _this$props5$store$it = _this$props5.store.item,
          copyDataModel = _this$props5$store$it.copyDataModel,
          copyAdvancedSettings = _this$props5$store$it.copyAdvancedSettings,
          copyDashboard = _this$props5$store$it.copyDashboard,
          copyReport = _this$props5$store$it.copyReport,
          copyTenantPermissions = _this$props5$store$it.copyTenantPermissions,
          copyRolePermission = _this$props5$store$it.copyRolePermission;


      var cancelCopy = function cancelCopy() {
        return null;
      };

      return (0, _bluebird.resolve)().then(function () {
        // if checkbox copy data model checked
        // then call api to get the conflicting data model need to confirm overwrite
        // if cancel copy data model then continue to run copy with the others or cancel Run Copy
        if (copyDataModel) {
          return store.checkConnectionHasDataModel().then(_this.handleRunCopyDataModel).catch(cancelCopy);
        }
        return null;
      }).then(function () {
        // if checkbox copy advanced settings checked
        // then call api to get the conflicting advanced settings need to confirm overwrite
        // if cancel copy advanced settings then continue to run copy with the others or cancel Run Copy
        if (copyAdvancedSettings) {
          return store.detectConflictingAdvancedSettings().then(_this.handleRunCopyAdvancedSetting).catch(cancelCopy);
        }
        return null;
      }).then(function () {
        // if checkbox copy dashboard checked
        // then call api to get the conflicting dashboards need to confirm overwrite
        // if cancel copy reports then continue to run copy with the others or cancel Run Copy
        if (copyDashboard) {
          return store.detectConflictingDashboards().then(_this.handleRunCopyDashboard).catch(cancelCopy);
        }
        return null;
      }).then(function () {
        // if checkbox copy report checked
        // then call api to get the conflicting reports need to confirm overwrite
        // if cancel copy reports then continue to run copy with the others or cancel Run Copy
        if (copyReport) {
          return store.detectConflictingReports().then(_this.handleRunCopyReport).catch(cancelCopy);
        }
        return null;
      }).then(function () {
        // if checkbox copy report checked
        // then call api to get the conflicting advanced settings need to confirm overwrite
        // if cancel copy advanced settings then continue to run copy with the others or cancel Run Copy
        if (copyReport) {
          return store.detectConflictingTemplates().then(_this.handleRunCopyTemplate).catch(cancelCopy);
        }
        return null;
      }).then(function () {
        // if checkbox copy tenant permissions checked
        // then call api to get the conflicting tenant permissions need to confirm overwrite
        // if cancel copy tenant permissions then continue to run copy with the others or cancel Run Copy
        if (copyTenantPermissions) {
          return store.detectConflictingTenantPermissions().then(_this.handleRunCopyTenantPermissions).catch(cancelCopy);
        }
        return null;
      }).then(function () {
        // if checkbox copy role permissions checked
        // then call api to get the conflicting role permissions need to confirm overwrite
        // if click cancel then cancel Run Copy
        if (copyRolePermission) {
          return store.detectConflictingRolePermission().then(_this.handleRunCopyRolePermissions).catch(cancelCopy);
        }
        return null;
      }).then(_this.handleRunCopy);
    }, _this.handleRunCopy = function () {
      var props = _this.props;
      var valManager = props.validation,
          store = props.store,
          item = props.store.item,
          loader = props.loader,
          localization = props.localization;

      // do not execute run copy

      if (!item.isReadyToRunCopy) {
        item.showAlertMessage('info', localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_NO_RUN_COPY_INFO_MESSAGE'));
        return null;
      }

      // Execute Run copy
      loader.startLoading();
      return store.runCopy().then(function (result) {
        if (result && !(0, _fp.isEmpty)(result.messages)) {
          valManager.updateErrors(result.messages);
        }

        if (result && result.data && result.data.hadCopiedFilterLookup) {
          return props.confirmFn('Information', {
            type: 'info',
            description: _Izenda2.default.COPY_FILTER_LOOKUP_MESSAGE,
            showCloseIndicator: true
          });
        }
      }).finally(loader.endLoading.bind(loader));
    }, _this.handleRunCopyDataModel = function (result) {
      if ((0, _fp.isNil)(result)) {
        return null;
      }
      var props = _this.props;
      var store = props.store,
          item = props.store.item,
          localization = props.localization;


      if (result.showRunCopyDataModelPopup) {
        return props.openPopup(_Izenda22.default, {
          title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_DATA_MODEL_OVERWRITE_CONFIRMATION'),
          informationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_DATA_MODEL_INFORMATION'),
          confirmationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_DATA_MODEL_CONFIRMATION'),
          treeComponent: _Izenda24.default,
          tree: result.tree,
          store: store
        }).then(function () {
          // count item selected in data source tree
          // if have no item selected then cancel Run Copy
          item.getDataModelForRunCopy('copyOption');
          item.setCanRunCopyStatus(true);
        }).catch(function () {
          // if cancel then set value overwrite false
          item.getDataModelForRunCopy('copyOption', false, false);
        });
      } else {
        _this.handleErrorRunCopy(result);
      }
    }, _this.handleRunCopyAdvancedSetting = function (result) {
      if ((0, _fp.isNil)(result)) {
        return null;
      }

      var props = _this.props;
      var store = props.store,
          item = props.store.item,
          localization = props.localization;


      if (result.showRunCopyAdvancedSettingsPopup) {
        return props.openPopup(_Izenda22.default, {
          props: props,
          title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ADVANCED_DATA_SETTING_OVERWRITE_CONFIRMATION'),
          informationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_ADVANCED_SETTING_INFORMATION'),
          confirmationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_ADVANCED_SETTING_CONFIRMATION'),
          treeComponent: _Izenda24.default,
          tree: result.tree,
          store: store
        }).then(function () {
          // count item selected in data source tree
          // if have no item selected then cancel Run Copy
          item.getDataModelForRunCopy('copyAdvancedSettingOption', true);
          item.setCanRunCopyStatus(true);
        }).catch(function () {
          // if cancel then set value overwrite false
          item.getDataModelForRunCopy('copyAdvancedSettingOption', true, false);
        });
      } else {
        _this.handleErrorRunCopy(result);
      }
    }, _this.handleRunCopyDashboard = function (result) {
      if ((0, _fp.isNil)(result)) {
        return null;
      }

      var props = _this.props;
      var item = props.store.item,
          localization = props.localization;


      if (result.showRunCopyDashboardPopup) {
        return props.openPopup(_Izenda22.default, {
          props: props,
          title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_DASHBOARD_OVERWRITE_CONFIRMATION'),
          informationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_DASHBOARD_INFORMATION'),
          confirmationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_DASHBOARD_CONFIRMATION'),
          treeComponent: _Izenda26.default,
          tree: result.tree,
          leafKey: 'dashboards'
        }).then(function () {
          item.getDataDashboardsForRunCopy();
          item.setCanRunCopyStatus(true);
        }).catch(function () {
          // if cancel then set value overwrite false
          item.getDataDashboardsForRunCopy(false);
        });
      } else {
        _this.handleErrorRunCopy(result);
      }
    }, _this.handleRunCopyReport = function (result) {
      if ((0, _fp.isNil)(result)) {
        return null;
      }

      var props = _this.props;
      var item = props.store.item,
          localization = props.localization;


      if (result.showRunCopyReportPopup) {
        return props.openPopup(_Izenda22.default, {
          title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_REPORT_OVERWRITE_CONFIRMATION'),
          informationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_REPORT_INFORMATION'),
          confirmationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_REPORT_CONFIRMATION'),
          treeComponent: _Izenda26.default,
          tree: result.tree,
          leafKey: 'reports'
        }).then(function () {
          item.getDataReportsForRunCopy('copyReportOption');
          item.setCanRunCopyStatus(true);
        }).catch(function () {
          // if cancel then set value overwrite false
          item.getDataReportsForRunCopy('copyReportOption', false);
        });
      } else {
        _this.handleErrorRunCopy(result);
      }
    }, _this.handleRunCopyTemplate = function (result) {
      if ((0, _fp.isNil)(result)) {
        return null;
      }

      var props = _this.props;
      var item = props.store.item,
          localization = props.localization;


      if (result.showRunCopyTemplatePopup) {
        return props.openPopup(_Izenda22.default, {
          props: props,
          title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_TEMPLATE_OVERWRITE_CONFIRMATION'),
          informationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_TEMPLATE_INFORMATION'),
          confirmationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_TEMPLATE_CONFIRMATION'),
          treeComponent: _Izenda26.default,
          tree: result.tree,
          leafKey: 'reports'
        }).then(function () {
          item.getDataReportsForRunCopy('copyTemplateOption');
          item.setCanRunCopyStatus(true);
        }).catch(function () {
          // if cancel then set value overwrite false
          item.getDataReportsForRunCopy('copyTemplateOption', false);
        });
      } else {
        _this.handleErrorRunCopy(result);
      }
    }, _this.handleRunCopyTenantPermissions = function (result) {
      if ((0, _fp.isNil)(result)) {
        return null;
      }

      var props = _this.props;
      var store = props.store,
          item = props.store.item,
          localization = props.localization;


      if (result.showRunCopyTenantPermissionPopup) {
        return props.openPopup(_Izenda22.default, {
          props: props,
          title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_TENANT_PERMISSIONS_OVERWRITE_CONFIRMATION'),
          informationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_TENANT_PERMISSIONS_INFORMATION'),
          confirmationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_TENANT_PERMISSIONS_CONFIRMATION'),
          treeComponent: _Izenda24.default,
          tree: result.tree,
          store: store
        }).then(function () {
          // count item selected in data source tree
          // if have no item selected then cancel Run Copy
          item.getDataModelForRunCopy('copyTenantPermissionOption', true);
          item.setCanRunCopyStatus(true);
        }).catch(function () {
          // if cancel then set value overwrite false
          item.getDataModelForRunCopy('copyTenantPermissionOption', true, false);
        });
      } else {
        _this.handleErrorRunCopy(result);
      }
    }, _this.handleRunCopyRolePermissions = function (result) {
      if ((0, _fp.isNil)(result)) {
        return null;
      }

      var props = _this.props;
      var store = props.store,
          item = props.store.item,
          localization = props.localization;


      if (result.showRunCopyRolePermissionPopup) {
        return props.openPopup(_Izenda22.default, {
          props: props,
          title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ROLE_PERMISSIONS_OVERWRITE_CONFIRMATION'),
          informationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_ROLE_PERMISSIONS_INFORMATION'),
          confirmationMessage: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_RUN_COPY_OVERWRITE_CONFIRM_ROLE_PERMISSIONS_CONFIRMATION'),
          treeComponent: _Izenda24.default,
          tree: result.tree,
          store: store
        }).then(function () {
          // count item selected in data source tree
          // if have no item selected then cancel Run Copy
          item.getDataModelForRunCopy('copyRolePermissionOption');
          item.setCanRunCopyStatus(true);
        }).catch(function () {
          // if cancel then set value overwrite false
          item.getDataModelForRunCopy('copyRolePermissionOption', false, false);
        });
      } else {
        _this.handleErrorRunCopy(result);
      }
    }, _this.handleErrorRunCopy = function (result) {
      _this.handleError(result);
      _this.reloadDataPopup(result);
    }, _this.onValidate = function () {
      var _this$props6 = _this.props,
          store = _this$props6.store,
          item = _this$props6.store.item,
          loader = _this$props6.loader,
          valManager = _this$props6.validation;

      var showPopupConcurrency = false; // show pop up concurrency at the first time
      item.setAlertMessage(_Izenda8.default.EMPTY_MESSAGE);

      // handle Error After Validate then return result
      var handleErrorAfterValidate = function handleErrorAfterValidate(result) {
        // handle error after bind respond of each promise
        _this.handleError(result);
        // Check have concurrency or not
        // if concurrency of Source then show reload data popup
        // if concurrency of Destination then do nothing
        if (!(0, _fp.isEmpty)(result.messages) && (0, _fp.isEmpty)(result.messages[0].key)) {
          if (result.messages[0].detail && result.messages[0].detail.source === _Izenda2.default.CONCURRENCY_ERROR.SOURCE && !showPopupConcurrency) {
            _this.reloadDataPopup(result);
            showPopupConcurrency = true;
          } else {
            // Concurrency of Destination connection
            loader.startLoading();
            store.handleAfterConcurrency(result.messages[0].detail).finally(loader.endLoading.bind(loader));
          }
        }
        return result;
      };

      // handle validate
      var handleValidate = function handleValidate(success) {
        var successObject = { success: true };
        if (success) {
          loader.startLoading();
          // Loop every workspace tenants to validate
          if (item.copyDataModel || item.copyReport || item.copyDashboard) {
            return (0, _bluebird.map)(item.workspaceTenants, function (tenant) {
              return store.validateWorkspaceTenant(tenant, false).then(handleErrorAfterValidate);
            }).then(function (results) {
              // results is an array of return result of all promise(s)
              if (_this.checkResultAfterValidate(results)) {
                return (0, _bluebird.resolve)(successObject);
              }
              return null;
            }).finally(loader.endLoading.bind(loader));
          } else {
            return (0, _bluebird.resolve)(successObject).finally(loader.endLoading.bind(loader));
          }
        }
      };
      // validate UI
      return valManager.validate().then(handleValidate);
    }, _this.handleError = function (result) {
      var valManager = _this.props.validation;
      if (!(0, _fp.isEmpty)(result.messages) && !(0, _fp.isEmpty)(result.messages[0].key)) {
        valManager.updateErrors(result.messages);
      }
    }, _this.reloadDataPopup = function (result) {
      var props = _this.props;
      var store = props.store,
          loader = props.loader;


      if (!(0, _fp.isEmpty)(result.messages) && (0, _fp.isEmpty)(result.messages[0].key)) {
        return props.confirmFn('Confirmation', {
          description: result.messages[0].messages[0],
          showCancel: false
        }).then(function () {
          loader.startLoading();
          return store.handleAfterConcurrency(result.messages[0].detail).finally(loader.endLoading.bind(loader));
        });
      }

      return result;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(WorkspaceDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.store.init();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.destroy();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          loader = _props.loader,
          store = _props.store,
          item = _props.item,
          validation = _props.validation;


      if (item !== nextProps.item) {
        item.resetSelectedTenant();
        validation.reset();
        item.setAlertMessage(_Izenda8.default.EMPTY_MESSAGE);
        if (nextProps.item.id) {
          loader.startLoading();
          return store.load(nextProps.item.id).then(store.loadRolesAndPermissions.bind(store, nextProps.item.sourceId)).finally(loader.endLoading.bind(loader));
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // Workspace detail store
      var _props2 = this.props,
          item = _props2.item,
          _props2$item = _props2.item,
          selectedTenant = _props2$item.selectedTenant,
          visible = _props2$item.visible,
          alertMessage = _props2$item.alertMessage,
          copyRoles = _props2$item.copyRoles,
          copyRolePermission = _props2$item.copyRolePermission,
          store = _props2.store;


      return selectedTenant ? _react2.default.createElement(_Izenda16.default, { store: store }) : _react2.default.createElement(
        'section',
        { className: 'izenda-Wrapper' },
        _react2.default.createElement(_Izenda10.default, {
          item: item,
          onCancel: this.onCancel,
          onSave: this.onOpenSavePopup,
          onSaveAs: this.onOpenSaveAsPopUp,
          onRefresh: this.onRefresh,
          onRunCopy: this.onRunCopy,
          onValidate: this.onValidate,
          disabled: !visible,
          alertMessage: alertMessage
        }),
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          _react2.default.createElement(
            _Izenda4.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'u_paddingLeftRight' },
              _react2.default.createElement(_Izenda18.default, { store: store, item: item }),
              _react2.default.createElement(_Izenda14.default, { store: store, item: item }),
              _react2.default.createElement(_Izenda28.default, { store: store, item: item }),
              copyRoles && _react2.default.createElement(_Izenda20.default, { store: store, id: _Izenda2.default.MODULE_ANCHORS.ROLE_SETTING }),
              copyRolePermission && _react2.default.createElement(_Izenda20.default, {
                store: store,
                id: _Izenda2.default.MODULE_ANCHORS.ROLE_PERMISSION_SETTING,
                permissionSetting: true
              })
            )
          )
        )
      );
    }

    /**
     * Retrieve connection detail and update via API.
     */


    /**
     * open SaveAs popup
     */


    /**
     * Cancel changes that user made for workspace.
     */


    /**
     * refresh workspace detail
     */


    /**
     * Run copy selected sources
     */

  }, {
    key: 'checkResultAfterValidate',


    /**
     * check Result After Validate
     * @param  {Array<Object>} results
     * @return {boolean}
     */
    value: function checkResultAfterValidate(results) {
      return (0, _fp.some)(function (item) {
        return item.success;
      }, results);
    }

    /**
     * handle Overwrite Confirmation
     */


    /**
     * handle Run Copy
     * @return {promise}
     */


    /**
     * handle Run Copy Data Model
     * @param  {object} result
     */


    /**
     * handle Run Copy Advanced Setting
     * @param  {object} result
     */


    /**
     * handle Run Copy Dashboard
     * @param  {object} result
     */


    /**
     * handle Run Copy Report
     * @param  {object} result
     */


    /**
     * handle Run Copy Report
     * @param  {object} result
     */


    /**
     * handle Run Copy Tenant Permissions
     * @param  {object} result
     */


    /**
     * handle Run Copy Role Permissions
     * @param  {object} result
     */


    /**
     * handle Error RunCopy
     * @param  {promise} result
     */


    /**
     * validate required field
     */


    /**
     * handle Error
     * @param  {object} result
     */


    /**
     * reload Data Popup
     * @param  {object} result
     */

  }]);
  return WorkspaceDetail;
}(_react.Component);

exports.default = (0, _mobxReact.observer)((0, _Izenda6.default)()(WorkspaceDetail));
module.exports = exports['default'];

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ActionBar component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var ActionButton = __webpack_require__(233);
  var IconMenu = __webpack_require__(86);
  var Button = __webpack_require__(30);
  var Alert = __webpack_require__(61);
  var GridLayout = __webpack_require__(13);

  var ActionBar = React.createClass({
    displayName: 'ActionBar',

    propTypes: {
      item: React.PropTypes.object.isRequired,
      disabled: React.PropTypes.bool.isRequired,
      onSave: React.PropTypes.func.isRequired,
      onSaveAs: React.PropTypes.func.isRequired,
      onCancel: React.PropTypes.func.isRequired,
      onRefresh: React.PropTypes.func.isRequired,
      onRunCopy: React.PropTypes.func.isRequired,
      onValidate: React.PropTypes.func.isRequired,
      alertMessage: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var localization = props.localization;
      var item = props.item;
      var alertMessage = props.alertMessage;

      return React.createElement(
        'div',
        { className: 'izenda-Wrapper-header' },
        React.createElement(IconMenu, null),
        React.createElement(
          Alert,
          { className: 'pull-left', type: alertMessage.type },
          alertMessage.message
        ),
        React.createElement(
          'div',
          { className: 'izenda-ActionBarRight' },
          React.createElement(
            ActionButton,
            null,
            React.createElement(Button, { label: localization.getText("COPY_MANAGEMENT_LABEL_REFRESH"),
              onClick: props.onRefresh }),
            React.createElement(Button, { label: localization.getText("COPY_MANAGEMENT_LABEL_RUN_COPY"),
              onClick: props.onRunCopy,
              disabled: !item.activeRunCopy }),
            React.createElement(Button, { label: localization.getText("COMMON_LABEL_VALIDATE"),
              onClick: props.onValidate,
              className: 'btn-success',
              disabled: !item.activeValidation })
          ),
          this.renderSaveButton(),
          React.createElement(Button, { label: localization.getText("COMMON_LABEL_CANCEL"),
            onClick: props.onCancel })
        )
      );
    },

    renderSaveButton: function renderSaveButton() {
      var props = this.props;
      var localization = props.localization;

      if (!props.item.isNew) {
        return React.createElement(
          'div',
          { className: 'btn-group' },
          React.createElement(
            Button,
            { className: 'btn btn-primary dropdown-toggle',
              'data-toggle': 'dropdown' },
            localization.getText('COMMON_LABEL_SAVE'),
            ' \xA0',
            React.createElement('span', { className: 'caret' })
          ),
          React.createElement(
            'ul',
            { className: 'dropdown-menu' },
            React.createElement(
              'li',
              null,
              React.createElement(
                'a',
                { onClick: props.onSave },
                localization.getText('COMMON_LABEL_SAVE')
              )
            ),
            React.createElement(
              'li',
              null,
              React.createElement(
                'a',
                { onClick: props.onSaveAs },
                localization.getText('COMMON_LABEL_SAVE_AS')
              )
            )
          )
        );
      } else {
        return React.createElement(Button, { className: 'u_marginLeft',
          label: localization.getText("COMMON_LABEL_SAVE"),
          onClick: props.onSave });
      }
    }
  });

  module.exports = connect()(ActionBar);
}();

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SaveWorkspacePopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Save Workspace component
 */
!function () {
  var compute = __webpack_require__(5).expr;
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(91);

  var EventUtils = __webpack_require__(24);
  var React = __webpack_require__(0);
  var Popup = __webpack_require__(36);
  var uiState = __webpack_require__(15);

  var Validator = __webpack_require__(23);
  var ValidateInput = Validator()(__webpack_require__(17));
  var ValidateDropDown = Validator()(__webpack_require__(29));
  var GridLayout = __webpack_require__(13);
  var actions = __webpack_require__(2377);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;

  var SaveWorkspacePopup = React.createClass({
    displayName: 'SaveWorkspacePopup',

    componentWillMount: function componentWillMount() {
      var props = this.props;
      var store = props.store;
      // Set default ownerId is user log in
      var ownerList = store.masterStore.ownerList;
      if (!isEmpty(ownerList)) {
        store.item.ownerId = uiState.currentUser.id;
      }
    },

    render: function render() {
      var props = this.props;
      var localization = props.localization;

      return React.createElement(
        Popup,
        { visible: true, type: 'none', onClosing: props.onClosing, autoClose: false },
        React.createElement(Popup.Header, {
          title: props.store.item.isNew ? localization.getText('COMMON_LABEL_SAVE') : localization.getText('COMMON_LABEL_SAVE_AS')
        }),
        React.createElement(
          Popup.Body,
          null,
          React.createElement(
            'div',
            { className: 'izenda-SaveWorkspacePopup' },
            React.createElement(
              GridLayout,
              null,
              React.createElement(
                GridLayout.Row,
                null,
                React.createElement(
                  GridLayout.Col,
                  { cols: 2 },
                  React.createElement(
                    'label',
                    { className: 'validation required' },
                    localization.getText('COMMON_LABEL_NAME')
                  )
                ),
                React.createElement(
                  GridLayout.Col,
                  { cols: 10 },
                  React.createElement(ValidateInput, {
                    type: 'text-box',
                    className: 'form-control',
                    value: props.workspaceName,
                    validations: constants.SAVE_WORKSPACE_CONSTRAINTS.NAME,
                    onChange: EventUtils.notifyChange(props.setWorkspaceName, EventUtils.INPUT),
                    field: 'Name'
                  })
                )
              ),
              React.createElement(
                GridLayout.Row,
                null,
                React.createElement(
                  GridLayout.Col,
                  { cols: 2 },
                  React.createElement(
                    'label',
                    { className: 'validation required' },
                    localization.getText('COMMON_LABEL_OWNER')
                  )
                ),
                React.createElement(
                  GridLayout.Col,
                  { cols: 10 },
                  React.createElement(ValidateDropDown, {
                    className: 'u_fullWidth',
                    options: props.store.masterStore.ownerList,
                    onChange: EventUtils.notifyChange(props.onChangeOwner.bind(props), EventUtils.DROPDOWN),
                    value: props.store.item.ownerId,
                    valueField: 'id',
                    labelField: 'fullName',
                    validations: constants.SAVE_WORKSPACE_CONSTRAINTS.OWNER,
                    field: 'ownerList'
                  })
                )
              ),
              React.createElement(
                GridLayout.Row,
                null,
                React.createElement(
                  GridLayout.Col,
                  { cols: 2 },
                  React.createElement(
                    'label',
                    null,
                    localization.getText('COMMON_LABEL_DESCRIPTION')
                  )
                ),
                React.createElement(
                  GridLayout.Col,
                  { cols: 10 },
                  React.createElement('textarea', {
                    className: 'form-control izenda-Description',
                    onChange: EventUtils.notifyChange(props.updateWorkspaceDescription.bind(props), EventUtils.INPUT),
                    value: props.store.item.description
                  })
                )
              )
            )
          )
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_SAVE')
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  });

  module.exports = connect(actions)(SaveWorkspacePopup);
}();

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SaveWorkspacePopupAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var withState = __webpack_require__(9).withState;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isBoolean = _require.isBoolean,
      isEmpty = _require.isEmpty;

  var saveWorkspacePopupAction = compose(withState('workspaceName', 'setWorkspaceName', function (props) {
    return props.store.item.name;
  }), withHandlers({
    onClosing: curry(onClosing),
    updateWorkspaceName: curry(updateWorkspaceName),
    onChangeOwner: curry(onChangeOwner),
    updateWorkspaceDescription: curry(updateWorkspaceDescription)
  }));

  /**
   * on closing pop up save work space
   */
  function onClosing(props, closeCallback, type) {
    var valManager = props.validation;
    var loader = props.loader;
    var item = props.store.item;

    if (type === 'accept') {
      valManager.validate(['Name', 'ownerList']).then(function (success) {
        if (success) {
          item.updateWorkspaceName(props.workspaceName);
          onSave(props);
        }
      });
    } else if (type === 'cancel') {
      props.onReject();
    }
  };

  /**
   * handle onSave
   * @return {promise}
   */
  function onSave(props) {
    var loader = props.loader;

    loader.startLoading();
    props.onClosing(props.isSaveAs).then(function (result) {
      isBoolean(result) && result ? props.onAccept() : handleError(props, result);
      return result;
    }).finally(loader.endLoading.bind(loader));
  };

  /**
   * handle Error
   * @param  {object} result
   */
  function handleError(props, result) {
    var loader = props.loader;
    var valManager = props.validation;

    if (!isEmpty(result.messages) && isEmpty(result.messages[0].key)) {
      return props.confirmFn('Confirmation', {
        description: result.messages[0].messages[0],
        showCancel: false
      }).then(function () {
        loader.startLoading();
        props.onReject();
        props.store.handleAfterConcurrency(result.messages[0].detail).finally(loader.endLoading.bind(loader));
      });
    } else {
      valManager.updateErrors(result.messages);
      return null;
    }
  };

  /**
   * update Workspace Name
   * @param  {object} props
   * @param  {string} name
   */
  function updateWorkspaceName(props, name) {
    props.store.item.updateWorkspaceName(name);
  };

  /**
   * onChange Owner
   * @param  {object} props
   * @param  {object} ownerId
   */
  function onChangeOwner(props, ownerId) {
    props.store.item.updateOwnerList(ownerId);
  };

  /**
   * update Workspace Description
   * @param  {object} props
   * @param  {string} desc
   */
  function updateWorkspaceDescription(props, desc) {
    props.store.item.updateWorkspaceDescription(desc);
  };

  module.exports = saveWorkspacePopupAction;
}();

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AdditionalItems.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * AdditionalItems component
 */
!function () {
  "use strict";

  var React = __webpack_require__(0);
  var GridLayout = __webpack_require__(13);
  var Panel = __webpack_require__(28);
  var Label = __webpack_require__(71);
  var Source = __webpack_require__(2379);
  var Destination = __webpack_require__(2380);
  var ItemsToCopy = __webpack_require__(2381);
  var connect = __webpack_require__(2);
  var observer = __webpack_require__(10).observer;

  var AdditionalItems = React.createClass({
    displayName: 'AdditionalItems',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired,
      disabled: React.PropTypes.bool
    },

    render: function render() {
      var store = this.props.store;
      var item = this.props.item;
      var localization = this.props.localization;

      return React.createElement(
        Panel,
        null,
        React.createElement(
          GridLayout,
          null,
          React.createElement(
            GridLayout.Row,
            { className: 'u_table u_fullWidth u_noMarginAll' },
            React.createElement(
              GridLayout.Col,
              { cols: 6, className: 'u_tableCell u_alignMiddle u_floatNone u_noPaddingLeft' },
              React.createElement(Source, { store: this.props.store, title: localization.getText("COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SOURCE") })
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 6, className: 'u_tableCell u_alignMiddle u_floatNone' },
              React.createElement(Destination, { store: this.props.store, title: localization.getText("COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_DESTINATIONS") })
            )
          ),
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              GridLayout.Col,
              { cols: 12 },
              React.createElement('hr', null)
            )
          )
        ),
        React.createElement(ItemsToCopy, {
          item: item,
          disabled: this.props.disabled,
          store: store })
      );
    }
  });

  module.exports = observer(connect()(AdditionalItems));
}();

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.Source.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Source component
 */
!function () {
  "use strict";

  var m = __webpack_require__(5);
  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);
  var connect = __webpack_require__(2);
  var commonMessages = __webpack_require__(37);

  var DropDown = __webpack_require__(29);

  var Source = React.createClass({
    displayName: 'Source',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      title: React.PropTypes.string.isRequired
    },

    render: function render() {
      var props = this.props;
      var store = props.store;

      return React.createElement(
        'div',
        { className: 'u_table u_fullWidth' },
        React.createElement(
          'div',
          { className: 'u_tableCell u_alignMiddle' },
          this.props.title
        ),
        React.createElement(
          'div',
          { className: 'u_tableCell u_fullWidth u_paddingLeft' },
          React.createElement(DropDown, { options: props.store.masterStore.availableSources,
            onChange: EventUtils.notifyChange(this.onChangeSourceDropDown, EventUtils.DROPDOWN),
            value: props.store.item.sourceId,
            valueField: 'id', labelField: 'name' })
        )
      );
    },

    onChangeSourceDropDown: m.action(function (sourceId) {
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var item = store.item;

      item.setAlertMessage(commonMessages.EMPTY_MESSAGE);
      item.setSource(sourceId);
      item.resetWorkspaceTenantsStatus();
      loader.startLoading();
      item.updateDataForDestination(sourceId);
      item.updateSelectedTenantsForDestination(item.selectedDestinationTenantIDs, sourceId);

      (0, _bluebird.all)([store.loadSourceConnections(sourceId), store.loadRolesAndPermissions(sourceId)]).then(function () {
        // load source for copy reports - need to load source connection first
        store.loadReports(sourceId, item.copyReport);
        store.loadDashboards(sourceId, item.copyDashboard);
        return null;
      }).finally(loader.endLoading.bind(loader));
    })
  });

  module.exports = connect()(Source);
}();

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Destination.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Destination component
 */
!function () {

  var m = __webpack_require__(5);
  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);
  var connect = __webpack_require__(2);

  var constants = __webpack_require__(91);
  var commonMessages = __webpack_require__(37);

  var Validator = __webpack_require__(23);
  var Select = Validator()(__webpack_require__(47));
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var Destination = React.createClass({
    displayName: 'Destination',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      title: React.PropTypes.string.isRequired
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var options = store.item.destinationDropdownOpts;

      return React.createElement(
        'div',
        { className: 'u_table u_fullWidth' },
        React.createElement(
          'div',
          { className: 'u_tableCell u_alignMiddle' },
          this.props.title
        ),
        React.createElement(
          'div',
          { className: 'u_tableCell u_fullWidth u_alignMiddle' },
          React.createElement(Select, {
            multi: true,
            simpleValue: true,
            className: 'col-md-12',
            options: options,
            labelKey: 'name',
            valueKey: 'id',
            noResultsText: 'No result',
            onChange: this.updateSelectedTenant,
            allowCreate: false,
            value: store.item.selectedDestinationTenantIDs,
            validations: constants.DESTINATION_CONSTRAINTS,
            blankOption: true,
            disabled: isNil(store.item.sourceId)
          })
        )
      );
    },

    updateSelectedTenant: function updateSelectedTenant(tenantId) {
      var store = this.props.store;
      store.item.setAlertMessage(commonMessages.EMPTY_MESSAGE);
      store.item.updateSelectedTenantsForDestination(tenantId).then(store.loadDistinctConnections.bind(store));
    }
  });

  module.exports = observer(connect()(Destination));
}();

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
//  ----------------------------------------------------------------------
//  <copyright file="Izenda.ItemsToCopy.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(13);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda3 = __webpack_require__(17);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(71);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemsToCopy = (_dec = (0, _Izenda8.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ItemsToCopy, _Component);

  function ItemsToCopy() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ItemsToCopy);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemsToCopy.__proto__ || (0, _getPrototypeOf2.default)(ItemsToCopy)).call.apply(_ref, [this].concat(args))), _this), _this.renderCheckbox = function (checkboxs, key) {
      var item = _this.props.item;

      var checkboxDef = checkboxs[key];
      var anchorSetting = checkboxDef[3];
      var scrollIntoViewFunc = _this.scrollIntoView.bind(null, anchorSetting);
      var classNames = 'u_paddingRight u_alignMiddle u_inlineBlock u_textLink u_textUnderline u_marginBottomSmall';

      return _react2.default.createElement(
        'span',
        { key: key },
        _react2.default.createElement(_Izenda4.default, { type: 'checkbox', checked: item[key], id: key, onChange: checkboxDef[0], disabled: checkboxDef[2] }),
        item[key] && anchorSetting ? _react2.default.createElement(
          'span',
          { className: classNames, onClick: scrollIntoViewFunc },
          checkboxDef[1]
        ) : _react2.default.createElement(
          _Izenda6.default,
          { className: 'u_paddingRight u_alignMiddle u_textNormal', htmlFor: key },
          checkboxDef[1]
        )
      );
    }, _this.scrollIntoView = function (anchorSetting) {
      var element = document.querySelector('#' + anchorSetting);
      element && element.scrollIntoView();
    }, _this.onCopyDataModelChanged = function (event) {
      var item = _this.props.item;

      item.resetWorkspaceTenantsStatus();
      item.setPropertyValue('copyDataModel', event.target.checked);
      item.updateQuerySourceTree();
      item.reCalculateSelectedSources();
    }, _this.onCopyRolesChanged = function (event) {
      var item = _this.props.item;

      item.setPropertyValue('copyRoles', event.target.checked);
    }, _this.onCopyRolePermissionChanged = function (event) {
      var item = _this.props.item;

      item.setPropertyValue('copyRolePermission', event.target.checked);
    }, _this.onCopyTenantPermissionsChanged = function (event) {
      var item = _this.props.item;

      item.setPropertyValue('copyTenantPermissions', event.target.checked);
    }, _this.onCopyAdvancedSettingsChanged = function (event) {
      _this.props.item.setPropertyValue('copyAdvancedSettings', event.target.checked);
    }, _this.onCopyDashboardChanged = function (event) {
      var _this2 = _this,
          props = _this2.props,
          _this2$props = _this2.props,
          item = _this2$props.item,
          store = _this2$props.store;

      var newValue = event.target.checked;

      if (newValue) {
        var loader = props.loader;
        loader.startLoading();
        store.loadDashboards(item.sourceId, true).finally(loader.endLoading.bind(loader));
      }
      item.resetWorkspaceTenantsStatus();
      item.setPropertyValue('copyDashboard', newValue);
    }, _this.onCopyReportChanged = function (event) {
      var _this3 = _this,
          props = _this3.props,
          _this3$props = _this3.props,
          item = _this3$props.item,
          store = _this3$props.store;

      var newValue = event.target.checked;

      if (newValue) {
        var loader = props.loader;
        loader.startLoading();
        store.loadReports(item.sourceId, true).finally(loader.endLoading.bind(loader));
      }
      item.resetWorkspaceTenantsStatus();
      item.setPropertyValue('copyReport', newValue);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ItemsToCopy, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          item = _props.item,
          localization = _props.localization;


      var CHECKBOX_DEFINITIONS = {
        copyDataModel: [this.onCopyDataModelChanged, localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_DATA_MODEL'), item.disableItemsToCopy],
        copyAdvancedSettings: [this.onCopyAdvancedSettingsChanged, localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ADVANCED_DATA_SETTING'), item.disableItemsToCopy],
        copyDashboard: [this.onCopyDashboardChanged, localization.getText('COMMON_LABEL_DASHBOARDS'), item.disableItemsToCopy],
        copyReport: [this.onCopyReportChanged, localization.getText('COMMON_LABEL_REPORTS'), item.disableItemsToCopy],
        copyTenantPermissions: [this.onCopyTenantPermissionsChanged, localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_TENANT_PERMISSIONS'), item.disableItemsToCopy || item.isSystemSource],
        copyRoles: [this.onCopyRolesChanged, localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ROLES'), item.disableItemsToCopy || item.isSystemSource],
        copyRolePermission: [this.onCopyRolePermissionChanged, localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ROLE_PERMISSIONS'), item.disableItemsToCopy || item.isSystemSource]
      };

      return _react2.default.createElement(
        _Izenda2.default,
        null,
        _react2.default.createElement(
          _Izenda2.default.Row,
          null,
          _react2.default.createElement(
            _Izenda2.default.Col,
            { cols: 12 },
            _react2.default.createElement(
              'span',
              { className: 'text-bold u_inlineBlock' },
              localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ITEMS_TO_COPY')
            ),
            _react2.default.createElement(
              'span',
              { className: 'u_inlineBlock u_alignTop' },
              (0, _keys2.default)(CHECKBOX_DEFINITIONS).map(function (key) {
                return _this4.renderCheckbox(CHECKBOX_DEFINITIONS, key);
              })
            )
          )
        )
      );
    }

    /**
     * scroll Into View
     * @param  {object} anchorSetting
     */


    /**
     * on Copy Data Model Changed
     * @param  {object} event
     */


    /**
     * on Copy Roles Changed
     * @param  {object} event
     */


    /**
     * on Copy Role Permission Changed
     * @param  {object} event
     */


    /**
     * on Copy Tenant Permissions Changed
     * @param  {object} event
     */


    /**
     * on Copy Advanced Settings Changed
     * @param  {object} event
     */


    /**
     * on copy dashboard changed
     * @param  {object} event
     */


    /**
     * on copy report changed
     * @param  {object} event
     */

  }]);
  return ItemsToCopy;
}(_react.Component)) || _class);
exports.default = ItemsToCopy;
module.exports = exports['default'];

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedCopy.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
* Advanced Copy component
*/
!function () {
  "use strict";

  __webpack_require__(55);

  var React = __webpack_require__(0);
  var m = __webpack_require__(5);
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);

  var ScrollBox = __webpack_require__(27);
  var GridLayout = __webpack_require__(13);
  var Panel = __webpack_require__(28);
  var AdvancedCopyToolbar = __webpack_require__(2383);
  var SourceDestinationContainer = __webpack_require__(2384);
  var Mapping = __webpack_require__(1155);

  var AdvancedCopy = React.createClass({
    displayName: 'AdvancedCopy',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.init();
    },

    init: m.action(function () {
      var store = this.props.store;
      var item = store.item;
      var selectedTenant = item.selectedTenant;
      var loader = this.props.loader;

      // load destination connections data source
      loader.startLoading();
      store.loadDestinationConnections().then(selectedTenant.resetDirty).then(item.updateMappingData.bind(item, selectedTenant)).finally(loader.endLoading.bind(loader));
    }),

    renderHeader: function renderHeader() {
      var store = this.props.store;
      var selectedTenant = store.item.selectedTenant;
      var localization = this.props.localization;

      return React.createElement(
        Panel,
        null,
        React.createElement(
          GridLayout,
          null,
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              GridLayout.Col,
              { cols: 12 },
              React.createElement(
                'span',
                { className: 'text-bold u_inlineBlock' },
                localization.getText("COPY_MANAGEMENT_LABEL_DATA_ADVANCED_OPTIONS")
              ),
              React.createElement(
                'span',
                { className: 'u_inlineBlock text-bold' },
                '\xA0 ',
                selectedTenant.tenantName
              )
            )
          )
        )
      );
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var item = store.item;
      var selectedTenant = item.selectedTenant;

      return React.createElement(
        'section',
        { className: 'izenda-Wrapper' },
        React.createElement(AdvancedCopyToolbar, { store: store }),
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          React.createElement(
            ScrollBox,
            null,
            React.createElement(
              'div',
              { className: 'u_paddingLeftRight' },
              this.renderHeader(),
              React.createElement(Mapping, {
                store: store,
                tenantMode: true,
                item: item,
                dataSource: selectedTenant.dataMapping,
                addMapping: selectedTenant.addMapping.bind(selectedTenant),
                width: props.width }),
              React.createElement(SourceDestinationContainer, {
                store: store })
            )
          )
        )
      );
    }
  });

  module.exports = connect()(AdvancedCopy);
}();

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedCopyToolbar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * AdvancedCopyToolbar component
 */
!function () {

  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(91);

  var IconMenu = __webpack_require__(86);
  var ActionButton = __webpack_require__(233);
  var Button = __webpack_require__(30);
  var GridLayout = __webpack_require__(13);
  var Alert = __webpack_require__(61);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      isNil = _require.isNil;

  var AdvancedCopyToolbar = React.createClass({
    displayName: 'AdvancedCopyToolbar',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    render: function render() {
      var store = this.props.store;
      var item = store.item;
      var alertMessage = this.props.store.item.alertMessage;
      var localization = this.props.localization;

      return React.createElement(
        'div',
        { className: 'izenda-Wrapper-header' },
        React.createElement(IconMenu, null),
        React.createElement(
          Alert,
          { type: alertMessage.type, className: 'pull-left' },
          alertMessage.message
        ),
        React.createElement(
          'div',
          { className: 'izenda-ActionBarRight' },
          React.createElement(
            ActionButton,
            null,
            React.createElement(Button, {
              label: localization.getText('COPY_MANAGEMENT_LABEL_REFRESH'),
              onClick: this.refreshWorkspaceTenant
            }),
            React.createElement(Button, {
              label: localization.getText('COPY_MANAGEMENT_LABEL_VALIDATE'),
              onClick: this.onValidate,
              className: 'btn-success',
              disabled: item.selectedTenant.status === constants.STATUS_OF_DESTINATION.READY_TO_COPY
            })
          ),
          React.createElement(Button, { label: localization.getText('COMMON_LABEL_OK'), onClick: item.updateWorkspaceTenant.bind(item) }),
          React.createElement(Button, {
            label: localization.getText('COMMON_LABEL_CANCEL'),
            onClick: item.setSelectedTenant.bind(item, null)
          })
        )
      );
    },

    /**
     * handle validate event
     */
    onValidate: function onValidate() {
      var props = this.props;
      var valManager = props.validation;
      var loader = props.loader;

      // Run validate
      valManager.validate().then(function (success) {
        if (success) {
          loader.startLoading();
          return this.handleValidation();
        }
      }.bind(this)).finally(loader.endLoading.bind(loader));
    },

    /**
     * handle validation error
     */
    handleValidation: function handleValidation() {
      var props = this.props;
      var valManager = props.validation;

      return props.store.validateWorkspaceTenant(null, true).bind(this).then(function (result) {
        if (isNil(result.workspaceTenant)) {
          !isEmpty(result.messages) && isEmpty(result.messages[0].key) ? this.hanldeConcurrency(result) : valManager.updateErrors(result.messages);
          return null;
        }
      });
    },

    hanldeConcurrency: function hanldeConcurrency(result) {
      var props = this.props;
      var valManager = props.validation;
      var loader = props.loader;

      // show pop up confirmation
      return props.confirmFn('Confirmation', {
        description: result.messages[0].messages[0],
        showCancel: false
      }).then(function () {
        loader.startLoading();
        props.store.handleAfterConcurrency(result.messages[0].detail).finally(loader.endLoading.bind(loader));
      });
    },

    refreshWorkspaceTenant: function refreshWorkspaceTenant() {
      var props = this.props;
      var loader = props.loader;

      loader.startLoading();
      props.store.checkHashCodeSource().finally(loader.endLoading.bind(loader));
    }
  });

  module.exports = connect()(AdvancedCopyToolbar);
}();

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * SourceDestinationContainer component
 */
!function () {

  __webpack_require__(55);
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);
  var SourceTree = __webpack_require__(621);
  var classnames = __webpack_require__(11);
  var GridLayout = __webpack_require__(13);

  var _require = __webpack_require__(1),
      find = _require.find,
      get = _require.get;

  /**
   * Selection data source tree that shows available and selected query source
   * in two data source tree UI.
   */


  var SourceDestinationContainer = React.createClass({
    displayName: 'SourceDestinationContainer',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },
    render: function render() {
      var props = this.props;
      var store = this.props.store;
      var tenantDetail = store.item.selectedTenant;
      var localization = props.localization;

      var source = find({ id: store.item.sourceId }, store.tenantList);
      var sourceTitle = String.format('{0}: {1}', localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SOURCE'), source.name);
      var destinationTitle = String.format('{0}: {1}', localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_DESTINATION'), tenantDetail.tenantName);

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          { className: 'col-md-12 text-bold' },
          localization.getText('COPY_MANAGEMENT_LABEL_DATE_MODEL_COMPARISON')
        ),
        React.createElement(
          GridLayout.Row,
          { className: 'workspace-container' },
          React.createElement(
            GridLayout.Col,
            { cols: 6 },
            React.createElement(SourceTree, {
              store: store,
              tree: tenantDetail.querySourceTree,
              isTenant: true,
              title: sourceTitle,
              showSelected: showNode,
              showFieldNode: true,
              showIcon: true,
              hideDropdown: true,
              className: 'izenda-advancedCopyTree'
            })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 6 },
            React.createElement(SourceTree, {
              store: store,
              tree: tenantDetail.destinationQuerySourceTree,
              isDestination: true,
              title: destinationTitle,
              showFieldNode: true,
              hideDropdown: true,
              className: 'izenda-advancedCopyTree'
            })
          )
        )
      );

      function showNode(obj) {
        // obj is child of FieldNode >> its status depends on its parent-node
        return get('parentNode.isFieldNode', obj) ? isShow(obj.parentNode) : isShow(obj);

        function isShow(node) {
          // always show group item: table, view, stored proc...
          if (get('initData.group', obj) || get('dataSource.group', obj)) {
            return true;
          }
          node = node.initData || node;
          return node.checked || node.belongToCopiedReport;
        }
      }
    }
  });

  module.exports = connect()(SourceDestinationContainer);
}();

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(91);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(37);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(62);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(17);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceTreeItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * SourceTreeItem component
 */

var NODE_TYPE = _Izenda4.default.NODE_TYPE;

var NUMBER_ZERO = 0;
var NUMBER_CHECK_INDEX = -1;

var SourceTreeItem = function SourceTreeItem(props) {
  /**
   * handle onCheck event
   * @param  {Object} event
   */
  var onCheck = function onCheck(event) {
    (0, _mobx.action)(function () {
      store.item.resetWorkspaceTenantsStatus();
      store.item.setAlertMessage(_Izenda6.default.EMPTY_MESSAGE);
      node.setChecked(event.target.checked);
      store.item.reCalculateSelectedSources();
    })();
  };

  var isEmptyGroup = function isEmptyGroup(node) {
    return node.isTypeGroup() && childCount === NUMBER_ZERO;
  };

  /**
   * show number of children
   * @param  {QuerySourceNode} node
   * @param  {Number} childCount Child Nodes count
   */
  var showNumChildren = function showNumChildren(node, count) {
    if (node.isTypeGroup() && node.childNodes) {
      return _react2.default.createElement(
        'span',
        null,
        ' (',
        count,
        ') '
      );
    }
    return null;
  };

  var getNodeStyle = function getNodeStyle(node) {
    var hasChild = !(0, _fp.isEmpty)(node.childNodes);
    var isDataObject = [NODE_TYPE.STORE_PROCEDURE, NODE_TYPE.FUNCTION, NODE_TYPE.TABLE, NODE_TYPE.VIEW].indexOf((0, _fp.get)('name', node.parentNode)) > NUMBER_CHECK_INDEX;

    if (node.isTypeGroup()) {
      //  node.group != null > table, store proc, view
      return hasChild ? getNodeStyleForQuerySouce(node) : null;
    } else if (isDataObject) {
      // data source: child of QuerySourceType
      return getNodeStyleForDataObject(node);
    } else if (hasChild) {
      // connection node, data object node
      // do nothing
      return checkConsistentGroupObject(node);
    } else {
      // no child > field
      return getNodeStyleForField(node);
    }
  };

  var getNodeStyleForQuerySouce = function getNodeStyleForQuerySouce(node) {
    var icon = void 0;
    if (hasChildNodesChanges(node, _Izenda4.default.DETECTED_CHANGE_LEVEL.ADDED).length > NUMBER_ZERO) {
      icon = getPhysicalChangesIcon(_Izenda4.default.DETECTED_CHANGE_LEVEL.ADDED);
    } else if (hasChildNodesChanges(node, _Izenda4.default.DETECTED_CHANGE_LEVEL.NONE).length > NUMBER_ZERO) {
      icon = getPhysicalChangesIcon(_Izenda4.default.DETECTED_CHANGE_LEVEL.NONE);
    }

    return {
      icon: icon
    };
  };

  var getNodeStyleForDataObject = function getNodeStyleForDataObject(node) {
    var parentType = (0, _fp.get)('name', node.parentNode);
    var hasChild = !(0, _fp.isEmpty)(node.childNodes);
    var className = (0, _classnames2.default)({
      'u-colorBlue': checkLinkToCopiedReport(node)
    });

    return {
      icon: hasChild || [NODE_TYPE.STORE_PROCEDURE, NODE_TYPE.FUNCTION].indexOf(parentType) > NUMBER_CHECK_INDEX ? getPhysicalChangesIcon(node.change) : null,
      className: className
    };
  };

  var checkConsistentGroupObject = function checkConsistentGroupObject(node) {
    return {
      icon: !(0, _fp.isEmpty)(node.childNodes) && getPhysicalChangesIcon(node.change)
    };
  };

  /**
   * filter physical changes for TypeGroup level
   * @param  {QuerySourceNode} node
   */
  var hasChildNodesChanges = function hasChildNodesChanges(node, changeLevel) {
    return (0, _fp.filter)(function (o) {
      return o.change >= changeLevel;
    }, node.childNodes);
  };

  /**
   * filter physical changes for TypeGroup level
   * @param  {Number} change
   */
  var getPhysicalChangesIcon = function getPhysicalChangesIcon(change) {
    return change > _Izenda4.default.DETECTED_CHANGE_LEVEL.NONE ? _react2.default.createElement('span', { className: 'icon-attention warning-color', title: _Izenda4.default.INCONSISTENT_DATA_MODEL }) : change === _Izenda4.default.DETECTED_CHANGE_LEVEL.NONE ? _react2.default.createElement('span', { className: 'icon-ok-circled success-color', title: _Izenda4.default.CONSISTENT_DATA_MODEL }) : null;
  };

  /**
   * render changes icon for field level
   * @param  {QuerySourceNode} node
   */
  var getNodeStyleForField = function getNodeStyleForField(node) {
    var isAdded = checkChangedStatus(node.change, _Izenda4.default.DETECTED_CHANGE_LEVEL.ADDED);
    var isEdited = checkChangedStatus(node.change, _Izenda4.default.DETECTED_CHANGE_LEVEL.MODIFIED);

    var className = (0, _classnames2.default)({
      u_textLineThrough: isAdded,
      'icon-move-data warning-color': isEdited,
      'u-colorBlue': checkLinkToCopiedReport(node)
    });

    var title = (0, _fp.cond)([[(0, _fp.matches)({ isNew: true }), (0, _fp.constant)(_Izenda4.default.CONSISTENT_DATA_MODEL)], [(0, _fp.matches)({ isAdded: true }), (0, _fp.constant)(_Izenda4.default.INCONSISTENT_DATA_MODEL)], [(0, _fp.matches)({ isEdited: true }), (0, _fp.constant)(_Izenda4.default.CHANGED_DATA_TYPE)]])({ isAdded: isAdded, isEdited: isEdited });

    if (isAdded) {
      return {
        className: className
      };
    } else {
      return {
        className: (0, _classnames2.default)({
          'u-colorBlue': checkLinkToCopiedReport(node)
        }),
        icon: _react2.default.createElement('span', { className: className, title: title })
      };
    }
  };

  /**
   * Check Changed Status
   * @param  {Number} change
   * @param  {Number} changeLevel
   */
  var checkChangedStatus = function checkChangedStatus(change, changeLevel) {
    return change === changeLevel;
  };

  var checkLinkToCopiedReport = function checkLinkToCopiedReport(node) {
    return !node.checked && ((0, _fp.get)('parentNode.initData.belongToCopiedReport', node) || (0, _fp.get)('parentNode.belongToCopiedReport', node) || (0, _fp.get)('initData.belongToCopiedReport', node) || (0, _fp.get)('belongToCopiedReport', node));
  };

  var store = props.store,
      node = props.node,
      toggleCollapse = props.toggleCollapse;

  var filterItem = props.filter;

  var containerClasses = (0, _classnames2.default)('checkbox', {
    'disabled-elm': isEmptyGroup(node)
  });
  var showCheckboxClass = (0, _classnames2.default)({
    hidden: !props.showCheckbox
  });

  var childCount = node.childCount(function (child) {
    if ((0, _fp.isFunction)(props.showSelected)) {
      return props.showSelected(child);
    }

    return props.showSelected ? child.dataSource.checked : true;
  });

  var toggle = function toggle() {
    toggleCollapse();
  };

  // Get style for node: icon, className & style
  var nodeStyle = props.showIcon ? getNodeStyle(node) : {};

  return _react2.default.createElement(
    'div',
    { className: containerClasses, key: node.id },
    _react2.default.createElement(_Izenda10.default, {
      type: 'checkbox',
      checked: node.dataSource.checked,
      onChange: onCheck,
      className: showCheckboxClass
    }),
    _react2.default.createElement(
      'label',
      {
        className: 'u_paddingLeft u_textTruncate u_alignBottom',
        key: node.id,
        disabled: isEmptyGroup(node) ? 'disabled' : null
      },
      _react2.default.createElement(_Izenda8.default, {
        highlight: filterItem,
        text: node.name,
        className: (0, _fp.get)('className', nodeStyle),
        style: (0, _fp.get)('style', nodeStyle),
        tooltip: node.name
      }),
      showNumChildren(node, childCount),
      (0, _fp.get)('icon', nodeStyle)
    ),
    !isEmptyGroup(node) && _react2.default.createElement('i', { className: 'icon-toggle-triangle', onClick: toggle })
  );
};

SourceTreeItem.propTypes = {
  store: _propTypes2.default.object.isRequired,
  node: _propTypes2.default.object.isRequired,
  filter: _propTypes2.default.string,
  showCheckbox: _propTypes2.default.bool,
  showIcon: _propTypes2.default.bool,
  showSelected: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool])
};

exports.default = (0, _Izenda2.default)()(SourceTreeItem);
module.exports = exports['default'];

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;

  var EventUtils = __webpack_require__(24);
  var GridLayout = __webpack_require__(13);
  var Button = __webpack_require__(30);
  var Input = __webpack_require__(17);
  var Label = __webpack_require__(71);

  var constants = __webpack_require__(91);
  var observer = __webpack_require__(10).observer;

  /*
  * Header Component
  */
  var MappingHeader = React.createClass({
    displayName: 'MappingHeader',

    propTypes: {
      item: PropTypes.object.isRequired,
      addMapping: PropTypes.func.isRequired,
      localization: PropTypes.object.isRequired,
      tenantMode: PropTypes.bool
    },
    getDefaultProps: function getDefaultProps() {
      return {
        tenantMode: false
      };
    },
    render: function render() {
      var props = this.props;
      var localization = props.localization;
      var item = props.item;
      var addMapping = props.addMapping;
      var headerText = props.tenantMode ? constants.MAPPING_HEADER.TENANT : constants.MAPPING_HEADER.GLOBAL;

      var mappingTooltip = props.tenantMode ? constants.MAPPING_HEADER.SPECIFIC_MAPPING_TOOLTIP : constants.MAPPING_HEADER.ALL_MAPPING_TOOLTIP;
      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          { className: 'u_table u_fullWidth' },
          React.createElement(
            GridLayout.Col,
            {
              cols: 2,
              className: 'u_tableCell u_alignMiddle text-bold u_floatNone' },
            headerText,
            React.createElement('span', { className: 'icon-info-circled', title: mappingTooltip })
          ),
          !props.tenantMode && React.createElement(
            GridLayout.Col,
            {
              cols: 3,
              className: 'u_tableCell u_alignMiddle u_floatNone' },
            React.createElement(Input, {
              type: 'checkbox',
              checked: item.mergeDuplicateMappings,
              id: 'mergeDuplicate',
              onChange: EventUtils.notifyChange(this.onMergeDuplicateChanged, EventUtils.CHECKBOX) }),
            React.createElement(
              Label,
              {
                className: 'u_paddingRight u_alignMiddle u_textNormal',
                htmlFor: 'mergeDuplicate' },
              localization.getText("COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_MERGE_DUPLICATE_MAPPINGS"),
              React.createElement('span', { className: 'icon-info-circled', title: constants.MAPPING_HEADER.MERGE_DUPLICATE_TOOLTIP })
            )
          ),
          React.createElement(
            GridLayout.Col,
            {
              cols: 7,
              className: 'u_tableCell u_alignMiddle pull-right text-right' },
            React.createElement(Button, {
              label: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ADD_MAPPING'),
              onClick: addMapping })
          )
        )
      );
    },

    onMergeDuplicateChanged: function onMergeDuplicateChanged(newValue) {
      var workspace = this.props.item;
      workspace.setPropertyValue('mergeDuplicateMappings', newValue);
    }
  });

  module.exports = observer(MappingHeader);
}();

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.HeaderSection.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * HeaderSection component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);

  var Panel = __webpack_require__(28);
  var Header = __webpack_require__(2388);
  var Body = __webpack_require__(2389);
  var Footer = __webpack_require__(2390);

  var HeaderSection = React.createClass({
    displayName: 'HeaderSection',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var detail = props.item;
      var detailStore = props.store;
      var header = {
        expanedOption: true,
        component: Header,
        detail: detail,
        detailStore: detailStore
      };
      var footer = {
        component: Footer,
        detail: detail
      };
      var isNew = detailStore.item.isNew;

      return isNew ? React.createElement(
        'div',
        { className: 'panel-heading workspace-header' },
        React.createElement(Header, { detail: detail, detailStore: detailStore })
      ) : React.createElement(
        Panel,
        { header: header,
          footer: footer,
          collapsible: true,
          className: 'header-section' },
        React.createElement(Body, this.props)
      );
    }
  });

  module.exports = observer(connect({ toClass: true })(HeaderSection));
}();

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Header.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ActionBar component
 */
!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);
  var EventUtils = __webpack_require__(24);

  var constants = __webpack_require__(91);
  var connect = __webpack_require__(2);
  var Button = __webpack_require__(30);
  var ActionBar = __webpack_require__(147);
  var Alert = __webpack_require__(61);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var Validator = __webpack_require__(23);
  var ValidatableInput = Validator()(Input);
  var convertToDateTimeFormat = __webpack_require__(88);
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var Header = React.createClass({
    displayName: 'Header',

    getInitialState: function getInitialState() {
      var detail = this.props.detail;

      return {
        editWorkspaceName: false,
        workspaceName: detail.name || ''
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.updateEditWorkspaceName(false);
      this.updateWorkspaceName(nextProps.detail.name);
    },

    updateEditWorkspaceName: function updateEditWorkspaceName(state) {
      this.setState({
        editWorkspaceName: state
      });
    },

    updateWorkspaceName: function updateWorkspaceName(value) {
      this.setState({
        workspaceName: value
      });
    },

    render: function render() {
      var detail = this.props.detail;
      var detailStore = this.props.detailStore;
      var localization = this.props.localization;
      var editClassName = classnames('icon-pencil selectable', { hide: isNil(detail.id) });
      var createdDate = convertToDateTimeFormat(uiState.currentUser.dateFormat, detail.created);

      if (!this.state.editWorkspaceName) {
        return React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'text-bold u_inlineBlock', onClick: this.props.collapseToggle },
            detail.name,
            ' | ',
            createdDate || detail.createdAsString
          ),
          React.createElement('i', {
            className: editClassName,
            title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_RENAME'),
            onClick: handleRenameClick.bind(this)
          })
        );
      } else {
        return React.createElement(
          'div',
          null,
          React.createElement(ValidatableInput, {
            className: 'form-control',
            containerClassName: 'u_inlineBlock',
            field: 'Name',
            validations: constants.SAVE_WORKSPACE_CONSTRAINTS.WORKSPACE_NAME,
            value: this.state.workspaceName,
            onBlur: renameWorkspace.bind(this),
            onChange: EventUtils.notifyChange(this.updateWorkspaceName, EventUtils.INPUT)
          }),
          React.createElement(
            'span',
            null,
            React.createElement(
              'a',
              {
                className: 'btn btn-default custom-button',
                title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SET_WORKSPACE_NAME'),
                onClick: renameWorkspace.bind(this)
              },
              React.createElement('i', { className: 'icon-ok-circled' })
            ),
            React.createElement(
              'a',
              {
                className: 'btn btn-default custom-button',
                title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_REVERT_WORKSPACE_NAME'),
                onClick: canceleditWorkspaceName.bind(this)
              },
              React.createElement('i', { className: 'icon-cancel-circled' })
            )
          )
        );
      }

      function handleRenameClick() {
        this.updateEditWorkspaceName(true);
        this.updateWorkspaceName(this.props.detail.name);
      }

      function renameWorkspace() {
        var valManager = this.props.validation;

        valManager.validate('Name').then(function (success) {
          success && detailStore.validateWorkspaceName(this.state.workspaceName).then(function (result) {
            if (result === true) {
              this.updateEditWorkspaceName(false);
              detail.updateWorkspaceName(this.state.workspaceName);
              return true;
            } else if (!result.success) {
              valManager.updateErrors(result.messages);
              return false;
            }
          }.bind(this));
        }.bind(this));
      }

      function canceleditWorkspaceName() {
        this.updateEditWorkspaceName(false);
        this.updateWorkspaceName(this.props.detail.name);
      }
    }
  });

  module.exports = connect()(Header);
}();

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Body.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Body component
 */
!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);
  var EventUtils = __webpack_require__(24);

  var connect = __webpack_require__(2);
  var Button = __webpack_require__(30);

  var Alert = __webpack_require__(61);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var DropDown = __webpack_require__(29);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var Body = React.createClass({
    displayName: 'Body',

    getInitialState: function getInitialState() {
      return {
        isEditDesc: false,
        description: this.props.item.description
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.showEditDesc(false);
      this.updateDesc(nextProps.item.description);
    },

    showEditDesc: function showEditDesc(state) {
      this.setState({
        isEditDesc: state
      });
    },

    updateDesc: function updateDesc(desc) {
      this.setState({
        description: desc
      });
    },

    render: function render() {
      var props = this.props;
      var detail = props.item;
      var localization = this.props.localization;

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 1 },
            localization.getText('COMMON_LABEL_OWNER'),
            ': '
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(DropDown, {
              valueField: 'id',
              labelField: 'fullName',
              options: props.store.masterStore.ownerList,
              onChange: EventUtils.notifyChange(onChangeOwner.bind(this), EventUtils.DROPDOWN),
              value: detail.ownerId
            })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 1 },
            localization.getText('COMMON_LABEL_DESCRIPTION'),
            ': '
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 11 },
            this.renderEditDescription()
          )
        )
      );

      function onChangeOwner(ownerId) {
        this.props.item.updateOwnerList(ownerId);
      }
    },

    renderEditDescription: function renderEditDescription() {
      var detail = this.props.item;
      var state = this.state;
      var localization = this.props.localization;
      var editClassName = classnames('icon-pencil selectable', { hide: isNil(detail.id) });

      if (state.isEditDesc) {
        return React.createElement(
          'div',
          { className: 'izenda-EditDesciption u_inlineBlock' },
          React.createElement(Input, {
            className: 'form-control u_inlineBlock',
            value: state.description,
            onChange: EventUtils.notifyChange(this.updateDesc, EventUtils.INPUT)
          }),
          React.createElement(
            'span',
            { className: '' },
            React.createElement(
              'a',
              {
                className: 'btn btn-default custom-button',
                title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SET_DESCRIPTION'),
                onClick: onChangeDescription.bind(this)
              },
              React.createElement('i', { className: 'icon-ok-circled' })
            ),
            React.createElement(
              'a',
              {
                className: 'btn btn-default custom-button',
                title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_REVERT_DESCRIPTION'),
                onClick: cancelEditDescription.bind(this)
              },
              React.createElement('i', { className: 'icon-cancel-circled' })
            )
          )
        );
      } else {
        return React.createElement(
          'div',
          null,
          React.createElement(
            'span',
            null,
            state.description
          ),
          React.createElement('i', {
            className: editClassName,
            title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_RENAME'),
            onClick: showEditMode.bind(this)
          })
        );
      }

      function showEditMode() {
        this.showEditDesc(true);
      }

      /**
       * onRenameDescriptionClick this function is to update description in model
       */
      function onChangeDescription() {
        detail.updateWorkspaceDescription(state.description);
        this.showEditDesc(false);
      }

      function cancelEditDescription() {
        this.showEditDesc(false);
        this.updateDesc(detail.description);
      }
    }
  });

  module.exports = connect()(Body);
}();

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Footer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Footer component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var ActionBar = __webpack_require__(147);
  var GridLayout = __webpack_require__(13);
  var convertToDateTimeFormat = __webpack_require__(88);
  var uiState = __webpack_require__(15);

  var Footer = React.createClass({
    displayName: 'Footer',

    render: function render() {
      var detail = this.props.detail;
      var createdDate = convertToDateTimeFormat(uiState.currentUser.dateFormat, detail.created);
      var modifiedDate = convertToDateTimeFormat(uiState.currentUser.dateFormat, detail.modified);
      var localization = this.props.localization;

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 3 },
            React.createElement(
              'span',
              null,
              localization.getText('COMMON_LABEL_CREATED'),
              ': '
            ),
            React.createElement(
              'span',
              { className: 'date-text' },
              createdDate || detail.createdAsString
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 9 },
            React.createElement(
              'span',
              null,
              localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_LAST_MODIFIED'),
              ': '
            ),
            React.createElement(
              'span',
              { className: 'date-text' },
              modifiedDate
            )
          )
        )
      );
    }
  });

  module.exports = connect()(Footer);
}();

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RolesCopySetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Mapping component
 */
!function () {
  "use strict";

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);

  var Input = __webpack_require__(17);
  var EventUtils = __webpack_require__(24);
  var Panel = __webpack_require__(28);
  var GridLayout = __webpack_require__(13);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      find = _require.find,
      chunk = _require.chunk;

  var RolesCopySetting = connect()(function (props) {
    var header = {
      title: props.permissionSetting ? 'Roles & Permissions Copy Settings' : 'Roles Copy Settings',
      icon: 'icon-toggle-triangle',
      className: 'u_noPaddingLeft u-bgGray'
    };
    var store = props.store;
    return React.createElement(
      Panel,
      { header: header,
        className: 'header-section',
        collapsible: true,
        expanedOption: true,
        id: props.id },
      React.createElement(PanelBody, { store: store, permissionSetting: props.permissionSetting })
    );
  });

  var PanelBody = connect()(function (props) {
    var store = props.store;
    var item = store.item;
    var selectedSource = find({ 'id': item.sourceId }, store.tenantList);
    var headerText = props.localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SELECT_ROLES_TO_COPY');
    var fn = props.permissionSetting ? item.selectAllRolePermissions.bind(item) : item.selectAllRole.bind(item);
    var checked = props.permissionSetting ? item.allRoleCopyPermissionChecked : item.allRoleCopyChecked;
    var listRoles = props.permissionSetting ? item.roleListPermission : item.roleList;

    return React.createElement(
      GridLayout,
      null,
      React.createElement(
        GridLayout.Row,
        { className: 'u_noMarginAll u-bgLightBlue u_paddingAll' },
        React.createElement(
          'span',
          { className: 'u_marginLeft' },
          headerText
        )
      ),
      React.createElement(
        GridLayout.Row,
        { className: 'u_noMarginAll u_borderAll u_paddingAll' },
        !isEmpty(listRoles) && React.createElement(
          GridLayout.Col,
          { cols: '12' },
          React.createElement(
            GridLayout.Col,
            { cols: '3' },
            React.createElement(
              'label',
              null,
              React.createElement(Input, { type: 'checkbox',
                checked: checked,
                onChange: EventUtils.notifyChange(fn, EventUtils.CHECKBOX)
              }),
              React.createElement(
                'span',
                null,
                'All'
              )
            )
          ),
          React.createElement(ListTenant, { store: store, permissionSetting: props.permissionSetting })
        )
      )
    );
  });

  var ListTenant = connect()(function (props) {
    var store = props.store;
    var item = store.item;
    var listRoles = props.permissionSetting ? item.roleListPermission : item.roleList;
    var copiedRoleType = props.permissionSetting ? 'copiedRolePermission' : 'copiedRoles';
    var chunkOptions = chunk(4, listRoles);
    var renderTenant = function renderTenant(items) {
      var listTenant = [];
      items.forEach(function (tenant) {
        listTenant.push(React.createElement(
          GridLayout.Col,
          { cols: '3', key: tenant.id },
          React.createElement(
            'label',
            { className: 'u_textTruncate' },
            React.createElement(Input, { type: 'checkbox',
              key: tenant.id,
              value: tenant.id,
              checked: tenant.checked,
              onChange: EventUtils.notifyChange(item.selectedRoleCopy.bind(item, listRoles, copiedRoleType, tenant.id), EventUtils.CHECKBOX)
            }),
            React.createElement(
              'span',
              { title: tenant.name },
              tenant.name
            )
          )
        ));
      });
      return listTenant;
    };
    return React.createElement(
      GridLayout.Col,
      { cols: '9' },
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: '12' },
          chunkOptions.map(function (items, index) {
            return React.createElement(
              GridLayout.Row,
              { key: index },
              renderTenant(items)
            );
          })
        )
      )
    );
  });

  module.exports = connect()(RolesCopySetting);
}();

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RunCopyPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  "use strict";

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);
  var Popup = __webpack_require__(36);
  var GridLayout = __webpack_require__(13);
  var EventsUtils = __webpack_require__(24);

  var RunCopyPopup = React.createClass({
    displayName: 'RunCopyPopup',

    propTypes: {
      tree: React.PropTypes.object.isRequired,
      treeComponent: React.PropTypes.func.isRequired,
      title: React.PropTypes.string.isRequired,
      informationMessage: React.PropTypes.string.isRequired,
      confirmationMessage: React.PropTypes.string.isRequired
    },

    render: function render() {
      var props = this.props;
      var localization = props.localization;

      return React.createElement(
        Popup,
        { visible: true, type: 'none', onClosing: this.onClosing, autoClose: false },
        React.createElement(Popup.Header, { title: props.title }),
        React.createElement(
          Popup.Body,
          null,
          React.createElement(
            'div',
            { className: 'run-copy-info' },
            React.createElement(
              GridLayout,
              null,
              React.createElement(
                GridLayout.Row,
                null,
                React.createElement(
                  'div',
                  { className: 'confirmation-info' },
                  React.createElement(
                    'p',
                    null,
                    props.informationMessage
                  ),
                  React.createElement(
                    'p',
                    null,
                    props.confirmationMessage
                  )
                )
              )
            )
          ),
          React.createElement(
            GridLayout,
            null,
            React.createElement(
              GridLayout.Row,
              { className: 'izenda-runCopyTree u_borderAll' },
              this.renderTree()
            )
          )
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    },

    renderTree: function renderTree() {
      var props = this.props;

      return React.createElement(props.treeComponent, {
        store: props.store,
        tree: props.tree,
        leafKey: props.leafKey,
        showCheckbox: true });
    },

    /**
     * onClosing popup
     */
    onClosing: function onClosing(closeCallback, type) {
      var props = this.props;

      if (type === 'accept') {
        return props.onAccept();
      } else if (type === 'cancel') {
        return props.onReject();
      }
    }
  });

  module.exports = connect()(RunCopyPopup);
}();

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceTree.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * SourceTree component
 */
!function () {
  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);

  var m = __webpack_require__(5);
  var observer = __webpack_require__(10).observer;
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);

  var Panel = __webpack_require__(28);
  var List = __webpack_require__(195);
  var ScrollBox = __webpack_require__(27);
  var CollapsibleList = __webpack_require__(410);
  var SourceTreeItem = __webpack_require__(2394);
  var SearchTextBox = __webpack_require__(107);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;

  function createTreeItem(tree, store, props) {
    return function (node) {
      return React.createElement(SourceTreeItem, {
        key: node.id,
        node: node,
        store: store,
        filter: tree.filter.text,
        showCheckbox: props.showCheckbox,
        showIcon: props.showIcon
      });
    };
  }

  /**
   * check rules of display nodes/fields of QuerySourceTree
   * @param  {Object}  querySourceNode
   * @param  {Boolean} showFieldNode
   * @return {Boolean} should display TreeNode (true) or TreeItem (false)
   */
  function checkDisplayingNode(querySourceNode, showFieldNode) {
    // only display TreeNode if childNodes have items or this node is TypeGroup
    if (!isEmpty(querySourceNode.childNodes) || querySourceNode.isTypeGroup()) {
      // only display TreeNode if this node is FieldNode & showFieldNode is ON
      return querySourceNode.isFieldNode && showFieldNode || !querySourceNode.isFieldNode ? true : false;
    }
    return false;
  }

  /**
   * display TreeNode/TreeItem of QuerySourceTree
   * @param  {Object}  tree
   * @param  {Object}  store
   * @param  {Object}  querySourceNode
   * @param  {Object} props
   * @return {Object} TreeNode/TreeItem
   */
  function treeNode(tree, store, querySourceNode, props) {
    var treeItem = createTreeItem(tree, store, props);

    return checkDisplayingNode(querySourceNode, props.showFieldNode) ? React.createElement(
      CollapsibleList,
      {
        className: 'panel-group collapsible-list-items datasource',
        key: querySourceNode.id,
        autoCollapse: false,
        defaultExpand: true
      },
      React.createElement(
        CollapsibleList.Item,
        { expanded: true, key: querySourceNode.id },
        React.createElement(
          CollapsibleList.ItemHeader,
          { className: 'panel-heading' },
          treeItem(querySourceNode)
        ),
        React.createElement(
          CollapsibleList.ItemBody,
          { className: 'panel-body' },
          React.createElement(
            List,
            { className: 'list-group', key: querySourceNode.id },
            querySourceNode.childNodes.map(function (child) {
              return props.showSelected && !child.checked ? querySourceNode.isFieldNode ? treeItem(child) : null : treeNode(tree, store, child, props);
            })
          )
        )
      )
    ) : treeItem(querySourceNode);
  }

  var SourceTree = React.createClass({
    displayName: 'SourceTree',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      tree: React.PropTypes.object.isRequired,
      showSelected: React.PropTypes.bool,
      showCheckbox: React.PropTypes.bool,
      showFieldNode: React.PropTypes.bool,
      showIcon: React.PropTypes.bool
    },
    render: function render() {
      var props = this.props;
      var store = props.store;
      var tree = props.tree;

      return React.createElement(
        Panel,
        { className: 'workspace-tree' },
        React.createElement(
          'div',
          { className: 'workspace-tree-wraper' },
          React.createElement(
            ScrollBox,
            null,
            tree.root.map(function (treeRootItem) {
              return treeRootItem.childNodes.map(function (node) {
                return props.showSelected && !node.checked ? null : treeNode(tree, store, node, props);
              });
            })
          )
        )
      );
    }
  });

  module.exports = connect()(SourceTree);
}();

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceTreeItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * SourceTreeItem component
 */
!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);

  var m = __webpack_require__(5);
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);

  var TextHighLight = __webpack_require__(62);
  var Input = __webpack_require__(17);
  var EventUtils = __webpack_require__(24);

  var SourceTreeItem = React.createClass({
    displayName: 'SourceTreeItem',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      node: React.PropTypes.object.isRequired,
      filter: React.PropTypes.string,
      showCheckbox: React.PropTypes.bool,
      showIcon: React.PropTypes.bool
    },
    render: function render() {
      var store = this.props.store;
      var node = this.props.node;
      var dataSource = node.dataSource;
      var filter = this.props.filter;
      var toggleCollapse = this.props.toggleCollapse;

      var containerClasses = classnames('checkbox', {
        'disabled-elm': isEmptyGroup(node)
      });
      var showCheckboxClass = classnames('u_noMarginAll', {
        'hidden': !this.props.showCheckbox
      });

      var childCount = node.childCount();
      var toggle = function toggle() {
        toggleCollapse();
      };

      return React.createElement(
        'div',
        { className: containerClasses, key: node.id },
        React.createElement(Input, { type: 'checkbox',
          checked: node.dataSource.checked,
          onChange: EventUtils.notifyChange(this.onCheck, EventUtils.CHECKBOX),
          className: showCheckboxClass }),
        React.createElement(
          'label',
          {
            className: 'tree-item',
            key: node.id,
            disabled: isEmptyGroup(node) ? 'disabled' : null },
          React.createElement(TextHighLight, { highlight: filter, text: node.name })
        ),
        !isEmptyGroup(node) ? React.createElement('i', { className: 'icon-toggle-triangle', onClick: toggle }) : null
      );

      function isEmptyGroup(node) {
        return node.isTypeGroup() && childCount === 0;
      }
    },

    /**
     * handle onCheck event
     * @param  {Boolean} checked
     */
    onCheck: m.action(function (checked) {
      this.props.node.setChecked(checked);
    })
  });

  module.exports = connect()(SourceTreeItem);
}();

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RunCopyTree.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * RunCopyTree component
 */
!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var TreeView = __webpack_require__(172);
  var Input = __webpack_require__(17);
  var TextHighLight = __webpack_require__(62);
  var actions = __webpack_require__(2396);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      invoke = _require.invoke;

  var RunCopyTree = React.createClass({
    displayName: 'RunCopyTree',

    propTypes: {
      tree: React.PropTypes.object.isRequired,
      leafKey: React.PropTypes.string.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.tree = this.props.buildTree(this.props.tree);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextState) {
      this.tree = this.props.buildTree(nextProps.tree);
    },

    /**
     * Render node
     * @param {Object} node
     * @param {String} toggleIcon
     * @param {Boolean} toggle
     * @param {Boolean} isCollapsed
     */
    renderNode: function renderNode(node, toggleIcon, toggle, isCollapsed, parent) {
      var props = this.props;
      var leafKey = props.leafKey;
      var source = node.source;
      var onChangeFunc;
      var isLastItem = false;

      switch (node.nodeType) {
        case 'All':
          onChangeFunc = props.onChangeAll.bind(props, source, parent);
          break;
        case 'Tenant':
          onChangeFunc = props.onChangeTenant.bind(props, source, parent);
          break;
        case 'Category':
          onChangeFunc = props.onChangeCategory.bind(props, source, parent);
          break;
        case 'SubCategory':
          onChangeFunc = props.onChangeSubCategory.bind(props, source, parent);
          break;
        case leafKey:
          onChangeFunc = props.onChangeLeafNode.bind(props, source, parent);
          isLastItem = true;
          break;
        default:
          return null;
      }

      return this.renderData(node.source, toggleIcon, toggle, isCollapsed, parent, isLastItem, onChangeFunc);
    },

    /**
     * Render data
     * @param {Object} node
     * @param {String} toggleIcon
     * @param {Boolean} toggle
     * @param {Boolean} isCollapsed
     */
    renderData: function renderData(source, toggleIcon, toggle, isCollapsed, parent, isLastItem, onChangeFunc) {
      var props = this.props;
      var name = isEmpty(source.name) ? 'UNCATEGORIZED' : source.name;

      return React.createElement(
        'div',
        null,
        React.createElement(Input, {
          type: 'checkbox',
          indeterminate: source.indeterminate,
          checked: source.checked,
          onChange: onChangeFunc
        }),
        React.createElement(TextHighLight, {
          highlight: props.filterText,
          onClick: toggle,
          text: name,
          className: 'selectable u_inline u_paddingLeft',
          tooltip: name
        }),
        isLastItem ? null : toggleIcon
      );
    },

    render: function render() {
      var props = this.props;
      var getChildNodes = invoke('getChildNodes');

      return React.createElement(TreeView, {
        className: 'u_paddingRight',
        nodes: this.tree,
        renderNode: this.renderNode,
        getKey: props.getKey,
        getChildNodes: getChildNodes,
        collapsed: false
      });
    }
  });

  module.exports = connect(actions)(RunCopyTree);
}();

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RunCopyTreeActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var observable = __webpack_require__(5).observable;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      map = _require.map,
      forEach = _require.forEach,
      isNil = _require.isNil,
      flow = _require.flow,
      filter = _require.filter,
      size = _require.size,
      find = _require.find,
      get = _require.get,
      split = _require.split,
      noop = _require.noop,
      isPlainObject = _require.isPlainObject,
      some = _require.some,
      isEqual = _require.isEqual;

  var RunCopyTreeActions = compose(withHandlers({
    buildTree: curry(buildTree),
    getKey: curry(getKey),
    onChangeAll: curry(onChangeAll),
    onChangeTenant: curry(onChangeTenant),
    onChangeCategory: curry(onChangeCategory),
    onChangeSubCategory: curry(onChangeSubCategory),
    onChangeLeafNode: curry(onChangeLeafNode)
  }));

  /**
   * Build tree
   * @param {Object} props
   * @param {Object} data
   * @returns {Object} tree
   */
  function buildTree(props, data) {
    var leafKey = props.leafKey;

    var root = function root() {
      var childNodes = map(getTenant, data.tenants);
      data.indeterminate = checkIndeterminate(childNodes);

      return {
        nodeType: data.name,
        source: data,
        getChildNodes: function getChildNodes() {
          return childNodes;
        }
      };
    };

    var getTenant = function getTenant(tenant) {
      var childNodes = map(getCategory, tenant.categories);
      tenant.indeterminate = checkIndeterminate(childNodes);

      return {
        nodeType: 'Tenant',
        source: tenant,
        getChildNodes: function getChildNodes() {
          return childNodes;
        }
      };
    };

    var getCategory = function getCategory(category) {
      var childNodes;
      if (category.subCategories.length > 0) {
        childNodes = getLeafNodeForCategoryAndSubCategory(category.subCategories);
      }
      category.indeterminate = checkIndeterminate(childNodes);

      return {
        nodeType: 'Category',
        source: category,
        getChildNodes: function getChildNodes() {
          return childNodes;
        }
      };
    };

    var getLeafNodeForCategoryAndSubCategory = function getLeafNodeForCategoryAndSubCategory(subCategories) {
      var data = [];
      forEach(function (subCategory) {
        if (isNil(subCategory.id)) {
          data = data.concat(getLeafNodes(subCategory[leafKey]));
        } else {
          data = data.concat(getSubCategory(subCategory));
        }
      }, subCategories);

      return data;
    };

    var getSubCategory = function getSubCategory(subCategory) {
      var childNodes = getLeafNodes(subCategory[leafKey]);
      subCategory.indeterminate = checkIndeterminate(childNodes);

      return {
        nodeType: 'SubCategory',
        source: subCategory,
        getChildNodes: function getChildNodes() {
          return childNodes;
        }
      };
    };

    var getLeafNodes = function getLeafNodes(leafs) {
      return map(getLeafNode, leafs);
    };

    var getLeafNode = function getLeafNode(leaf) {
      return {
        nodeType: leafKey,
        source: leaf,
        getChildNodes: noop
      };
    };

    buildMapProps(leafKey);
    return isPlainObject(data) ? [root()] : null;
  }

  /**
   * Get key
   * @param {Object} props
   * @param {Object} node
   * @returns {String} id
   */
  function getKey(props, node) {
    return node.source.id;
  }

  /**
   * Check indeterminate
   * @param {Object} data
   * @returns {Boolean} has indeterminate
   */
  function checkIndeterminate(data) {
    if (!isNil(data) && !isNil(data[0])) {
      var isExistOneIndeterminate = flow(map('source'), map(function (d) {
        return { indeterminate: d.indeterminate };
      }), some({ indeterminate: true }))(data);
      if (isExistOneIndeterminate) return true;

      var countChecked = flow(map('source'), filter({ checked: true }), size)(data);
      return countChecked !== 0 && data.length !== countChecked;
    }
  }

  /**
   * onchange all
   * @param {Object} props
   * @param {Object} source
   * @param {Object} parent
   * @param {Object} input
   */
  function onChangeAll(props, source, parent, e) {
    var leafKey = props.leafKey;
    var check = e.target.checked;
    source.checked = check;
    source.indeterminate = false;
    updateCheckTenants(leafKey, source.tenants, check);
  }

  /**
   * onchange tenant
   * @param {Object} props
   * @param {Object} source
   * @param {Object} parent
   * @param {Object} input
   */
  function onChangeTenant(props, source, parent, e) {
    var leafKey = props.leafKey;
    var check = e.target.checked;
    source.checked = check;
    source.indeterminate = false;
    updateCheckCategories(leafKey, source.categories, check);
    updateParentNode(parent, check);
  }

  /**
   * onchange category
   * @param {Object} props
   * @param {Object} source
   * @param {Object} parent
   * @param {Object} input
   */
  function onChangeCategory(props, source, parent, e) {
    var leafKey = props.leafKey;
    var check = e.target.checked;
    source.checked = check;
    source.indeterminate = false;
    updateCheckSubCategories(leafKey, source.subCategories, check);
    updateParentNode(parent, check);
  }

  /**
   * onchange sub category
   * @param {Object} props
   * @param {Object} source
   * @param {Object} parent
   * @param {Object} input
   */
  function onChangeSubCategory(props, source, parent, e) {
    var leafKey = props.leafKey;
    var check = e.target.checked;
    source.checked = check;
    source.indeterminate = false;
    updateCheckLeafNodes(source[leafKey], e.target.checked);
    updateParentNode(parent, check);
  }

  /**
   * onchange leaf node
   * @param {Object} props
   * @param {Object} source
   * @param {Object} parent
   * @param {Object} input
   */
  function onChangeLeafNode(props, source, parent, e) {
    var check = e.target.checked;
    source.checked = check;
    updateParentNode(parent, check);
  }

  /**
   * update check tenants
   * @param {String} leaf key
   * @param {Object} tenants
   * @param {Object} check
   */
  function updateCheckTenants(leafKey, tenants, check) {
    forEach(function (tenant) {
      tenant.checked = check;
      tenant.indeterminate = false;
      updateCheckCategories(leafKey, tenant.categories, check);
    }, tenants);
  }

  /**
   * update check categories
   * @param {String} leaf key
   * @param {Object} categories
   * @param {Object} check
   */
  function updateCheckCategories(leafKey, categories, check) {
    forEach(function (category) {
      category.checked = check;
      category.indeterminate = false;
      updateCheckSubCategories(leafKey, category.subCategories, check);
    }, categories);
  }

  /**
   * update check sub categories
   * @param {String} leaf key
   * @param {Object} categories
   * @param {Object} check
   */
  function updateCheckSubCategories(leafKey, subCategories, check) {
    forEach(function (subCategory) {
      subCategory.checked = check;
      subCategory.indeterminate = false;
      updateCheckLeafNodes(subCategory[leafKey], check);
    }, subCategories);
  }

  /**
   * update check leaf nodes
   * @param {Object} leaf nodes
   * @param {Object} check
   */
  function updateCheckLeafNodes(leafs, check) {
    forEach(function (leaf) {
      leaf.checked = check;
    }, leafs);
  }

  /**
   * update parent node
   * @param {Object} parent
   * @param {Object} check
   */
  function updateParentNode(parent, check) {
    if (!isNil(parent)) {
      parent.data.source.checked = check ? check : !isCheckedLastNode(parent);
      parent.data.source.indeterminate = checkIndeterminate(parent.data.getChildNodes());
      if (!isNil(parent.parent)) {
        updateParentNode(parent.parent, check);
      }
    }
  }

  var mapProps = [];
  function buildMapProps(leafKey) {
    mapProps.push({ level: 0, prop: 'tenants' });
    mapProps.push({ level: 1, prop: 'categories' });
    mapProps.push({ level: 2, prop: 'subCategories,' + leafKey });
    mapProps.push({ level: 3, prop: leafKey });
  }

  /**
   * check last node
   * @param {Object} parent
   * @returns {Boolean} last node
   */
  function isCheckedLastNode(parent) {
    var props = flow(find(function (mapItem) {
      return isEqual(mapItem.level, parent.level);
    }), get('prop'), split(','))(mapProps);

    var isLast = true;
    forEach(function (d) {
      if (!isNil(d.id) && d.checked) {
        isLast = false;
        return false;
      }
      forEach(function (r) {
        if (r.checked) {
          isLast = false;
          return false;
        }
      }, d[props[1]]);

      if (!isLast) return false;
    }, parent.data.source[props[0]]);

    return isLast;
  }

  module.exports = RunCopyTreeActions;
}();

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2398);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2409);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1155);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(91);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2410);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SourceDestinationSettings(props) {
  var store = props.store,
      item = props.item;

  var title = props.buildTitle(props);

  var header = {
    title: title,
    icon: 'icon-toggle-triangle',
    className: 'u_noPaddingLeft u-bgGray',
    item: item,
    showCopyPositionId: item.copyDataModel,
    component: _Izenda8.default
  };

  var isShowDataModelSection = item.copyDataModel || item.copyDashboard || item.copyReport;

  // this section is used for copy data model, copy dashboard and copy report
  if (!isShowDataModelSection) {
    return null;
  }

  return _react2.default.createElement(
    _Izenda4.default,
    {
      collapsible: true,
      header: header,
      className: 'u_fullWidth',
      expanedOption: true,
      id: _Izenda12.default.MODULE_ANCHORS.DATA_MODEL_SETTING },
    _react2.default.createElement(_Izenda6.default, {
      store: store,
      item: item }),
    item.showMappingGrid && _react2.default.createElement(_Izenda10.default, {
      store: store,
      item: item,
      dataSource: item.workspaceMappings,
      addMapping: item.addWorkspaceMapping.bind(item) })
  );
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataModelSettings component
 */

SourceDestinationSettings.propTypes = {
  store: _propTypes2.default.object.isRequired,
  item: _propTypes2.default.object.isRequired
};

exports.default = (0, _Izenda2.default)(_Izenda14.default)(SourceDestinationSettings);
module.exports = exports['default'];

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestination.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * SourceDestination component
 */
!function () {
  "use strict";

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var SourceTree = __webpack_require__(621);
  var DestinationGrid = __webpack_require__(2399);
  var ReportContainer = __webpack_require__(2400);
  var DataModel = __webpack_require__(2406);
  var Dashboard = __webpack_require__(2407);
  var GridLayout = __webpack_require__(13);
  var classnames = __webpack_require__(11);
  var actions = __webpack_require__(2408);
  var observer = __webpack_require__(10).observer;

  var SourceDestination = React.createClass({
    displayName: 'SourceDestination',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var store = this.props.store;
      var item = this.props.item;
      var localization = this.props.localization;

      return React.createElement(
        'div',
        { className: 'izenda-sourceDestination' },
        React.createElement(DataModel, { store: store, workspaceDetail: item }),
        React.createElement(Dashboard, { workspaceDetail: item }),
        React.createElement(ReportContainer, { workspaceDetail: item, store: store }),
        React.createElement(DestinationGrid, { store: store })
      );
    }
  });

  //module.exports = observer(connect(actions)(SourceDestination));
  module.exports = connect(actions)(SourceDestination);
}();

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Destination.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Destination component
 */
!function () {
  var m = __webpack_require__(5);
  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);

  var constants = __webpack_require__(91);

  var Panel = __webpack_require__(28);
  var List = __webpack_require__(195);
  var Validator = __webpack_require__(23);
  var Select = Validator()(__webpack_require__(47));
  var Table = __webpack_require__(44).Table;
  var Column = __webpack_require__(44).Column;
  var Dimensions = __webpack_require__(83);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      isNil = _require.isNil;

  var DestinationGrid = React.createClass({
    displayName: 'DestinationGrid',

    render: function render() {
      var props = this.props;
      var store = props.store;
      var localization = props.localization;
      var height = props.height;
      var item = store.item;
      var dataSourceGrid = item.workspaceTenants;
      var TABLE_DEF = constants.TABLE_DESTINATION_DEFINITION;
      var tableClassName = classnames('default-table u_fullHeight u_fullWidth u_noBorder', {
        'hidden': isNil(item.selectedDestinationTenantIDs)
      });

      return !isEmpty(dataSourceGrid) && React.createElement(
        'div',
        { className: 'u_tableCell' },
        localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_DESTINATION_GRID'),
        React.createElement(
          Panel,
          { className: 'izenda-CopyManagementDestinationGrid u_borderAll' },
          React.createElement(
            Table,
            {
              dataSource: dataSourceGrid,
              onSortChange: this.onSortChange,
              sortInfo: item.pageInfo.colSortDirs,
              className: tableClassName,
              minHeight: 362,
              maxHeight: 362 },
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['tenantName'], {
              cell: this.renderTenant })),
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['status'], {
              cell: this.renderStatus })),
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['action'], {
              cell: this.renderActionColumn }))
          )
        )
      );
    },
    /**
     * Render tenant cell
     */
    renderTenant: function renderTenant(dataRow, key) {
      return React.createElement(
        'div',
        { className: 'overflow-text' },
        dataRow[key]
      );
    },
    /**
     * Rendern status cell
     */
    renderStatus: function renderStatus(dataRow, key) {
      var dataRowKey = constants.STATUS_OF_DESTINATION[dataRow[key]];
      var colorSetting = dataRowKey.class;
      return React.createElement(
        'div',
        null,
        React.createElement(
          'span',
          { className: classnames('u_inline', colorSetting) },
          dataRowKey.status
        ),
        React.createElement('span', { className: dataRowKey.iconClass, title: constants.VALIDATION_ERROR_TOOLTIP })
      );
    },
    /**
     * Render tenant action column
     */
    renderActionColumn: function renderActionColumn(dataRow, key, rowIndex, column) {
      var props = this.props;
      var dataRowKey = constants.STATUS_OF_DESTINATION[dataRow[key]];
      var colorSetting = dataRowKey.iconOkClass;
      var localization = props.localization;
      var loader = props.loader;
      var store = props.store;
      var goToTenantMode = function goToTenantMode(tenant) {
        return store.goToTenantMode(tenant).finally(loader.endLoading.bind(loader));
      };
      var gotoAdvancedMode = function gotoAdvancedMode(tenant) {
        loader.startLoading();
        if (tenant.status !== constants.STATUS_OF_DESTINATION.NEED_VALIDATION) {
          this.onValidate.bind(this, tenant)().then(goToTenantMode.bind(this, tenant));
        } else {
          goToTenantMode(tenant);
        }
      };

      return React.createElement(
        'div',
        null,
        React.createElement(
          'a',
          { onClick: this.onValidate.bind(this, dataRow) },
          React.createElement('span', { title: localization.getText("COMMON_LABEL_VALIDATE"), className: classnames('icon-ok', colorSetting) })
        ),
        React.createElement(
          'a',
          { onClick: gotoAdvancedMode.bind(this, dataRow) },
          React.createElement('span', { title: localization.getText("COPY_MANAGEMENT_LABEL_ADVANCED_SETTINGS"), className: 'icon-setting' })
        ),
        React.createElement(
          'a',
          { onClick: this.onDelete.bind(this, dataRow) },
          React.createElement('span', { title: localization.getText("COMMON_LABEL_DELETE"), className: 'icon-cancel' })
        )
      );
    },
    onSortChange: function onSortChange(columnKey, sortDir) {
      var item = this.props.item;
      item.onSortChange(columnKey, sortDir);
    },
    /**
     * on Validate a workspace tenant
     * @param  {object} dataRow
     * @return {[type]}         [description]
     */
    onValidate: function onValidate(tenant) {
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var valManager = props.validation;

      loader.startLoading();
      return store.validateWorkspaceTenant(tenant, true).then(function (result) {
        if (!isEmpty(result.messages)) {
          if (!isEmpty(result.messages[0].key)) {
            valManager.updateErrors(result.messages);
          } else {
            return props.confirmFn('Confirmation', {
              description: result.messages[0].messages[0],
              showCancel: false
            }).then(function () {
              loader.startLoading();
              return store.handleAfterConcurrency(result.messages[0].detail).finally(loader.endLoading.bind(loader));
            });
          }
        }
      }).finally(loader.endLoading.bind(loader));
    },
    /**
     * Delete a tenant destination
     */
    onDelete: function onDelete(tenant, e) {
      var props = this.props;
      var loader = props.loader;
      var item = props.store.item;

      e.stopPropagation();
      props.confirmFn('Confirmation', {
        description: String.format(constants.M11, tenant.tenantName)
      }).then(function () {
        loader.startLoading();
        item.deleteDestinationTenant(tenant);
        return props.store.loadDistinctConnections().finally(loader.endLoading.bind(loader));
      });
    }
  });

  module.exports = connect(Dimensions)(DestinationGrid);
}();

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportContainer.jsx" company="Izenda">  Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var m = __webpack_require__(5);
  var connect = __webpack_require__(2);
  var Tabs = __webpack_require__(131).Tabs;
  var Tab = __webpack_require__(131).Tab;
  var Loading = __webpack_require__(152);
  var Panel = __webpack_require__(28);
  var Reports = __webpack_require__(2401);
  var Templates = __webpack_require__(2403);
  var SearchTextBox = __webpack_require__(107);
  var LazyLoadingTree = __webpack_require__(2404);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      uniqueId = _require.uniqueId;

  var SearchBox = connect()(function (props) {
    function onChange(filterText, e) {
      props.workspaceDetail[filterText] = e.target.value;
      $izenda('input', $izenda(ReactDOM.findDOMNode(this.refs.searchBox))).focus();
    }

    var filterText = props.isReport ? props.workspaceDetail.reportFilterText : props.workspaceDetail.templateFilterText;
    return React.createElement(SearchTextBox, {
      ref: 'searchBox',
      key: uniqueId(),
      className: 'search-box',
      value: filterText,
      onChange: onChange.bind(this, props.isReport ? 'reportFilterText' : 'templateFilterText')
    });
  });

  var ReportContainer = React.createClass({
    displayName: 'ReportContainer',

    propTypes: {
      workspaceDetail: React.PropTypes.object.isRequired
    },

    getInitialState: function getInitialState() {
      return {
        activeTabKey: 'reports',
        isReport: true
      };
    },

    /**
     * onchange tab
     * @param {Number} index
     * @param {String} tabPanel
     * @param {String} tabMenu
     * @param {String} activeTabKey
     */
    changeTab: function changeTab(index, tabPanel, tabMenu, activeTabKey) {
      this.setState({
        activeTabKey: activeTabKey,
        isReport: activeTabKey === 'reports'
      });
    },

    render: function render() {
      var props = this.props;
      var localization = props.localization;

      return React.createElement(
        'div',
        { className: 'u_tableCell u_paddingRight' },
        localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_PLEASE_SELECT_REPORT'),
        React.createElement(
          Panel,
          { className: 'u_borderAll workspace-tree u_noMarginAll' },
          React.createElement(SearchBox, { workspaceDetail: props.workspaceDetail, isReport: this.state.isReport }),
          React.createElement(
            Tabs,
            { activeTabKey: this.state.activeTabKey, onChange: this.changeTab },
            React.createElement(
              Tab,
              { title: 'Reports', tabKey: 'reports', className: 'izenda-reportContainer' },
              React.createElement(Reports, { workspaceDetail: props.workspaceDetail, store: props.store })
            ),
            React.createElement(
              Tab,
              { title: 'Templates', tabKey: 'templates', className: 'izenda-reportContainer' },
              React.createElement(Templates, { workspaceDetail: props.workspaceDetail })
            )
          )
        )
      );
    }
  });

  var LazyLoadingReport = observer(React.createClass({
    displayName: 'LazyLoadingReport',

    render: function render() {
      var props = this.props;
      return React.createElement(LazyLoadingTree, {
        data: props.workspaceDetail.treeReports,
        isLastPage: props.workspaceDetail.isLastPage,
        getData: props.store.lazyLoadingReports.bind(props.store)
      });
    }
  }));

  module.exports = connect()(function (props) {
    return props.workspaceDetail && props.workspaceDetail.copyReport ? React.createElement(ReportContainer, props) : null;
  });
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(622);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Reports.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * Reports component
 */
var Templates = function Templates(props) {
  var workspaceDetail = props.workspaceDetail,
      _props$workspaceDetai = props.workspaceDetail,
      sourceReports = _props$workspaceDetai.sourceReports,
      sourceReportsPrev = _props$workspaceDetai.sourceReportsPrev,
      reportFilterText = _props$workspaceDetai.reportFilterText,
      resetPrevData = _props$workspaceDetai.resetPrevData,
      resetWorkspaceTenantsStatus = _props$workspaceDetai.resetWorkspaceTenantsStatus;


  return _react2.default.createElement(_Izenda4.default, { data: sourceReports,
    dataPrev: sourceReportsPrev,
    filterText: reportFilterText,
    resetPrevData: resetPrevData.bind(workspaceDetail),
    resetWorkspaceTenantsStatus: resetWorkspaceTenantsStatus.bind(workspaceDetail),
    leafKey: 'reports'
  });
};

Templates.propTypes = {
  workspaceDetail: _propTypes2.default.object.isRequired
};

exports.default = (0, _Izenda2.default)()(Templates);
module.exports = exports['default'];

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var observable = __webpack_require__(5).observable;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      toUpper = _require.toUpper,
      filter = _require.filter,
      map = _require.map,
      flow = _require.flow,
      isNil = _require.isNil,
      isEmpty = _require.isEmpty,
      isPlainObject = _require.isPlainObject,
      some = _require.some,
      size = _require.size,
      forEach = _require.forEach,
      noop = _require.noop,
      isEqual = _require.isEqual,
      find = _require.find,
      get = _require.get,
      split = _require.split;

  var TreeActions = compose(withHandlers({
    buildTree: curry(buildTree),
    getKey: curry(getKey),
    onChangeAll: curry(onChangeAll),
    onChangeCategory: curry(onChangeCategory),
    onChangeSubCategory: curry(onChangeSubCategory),
    onChangeLeafNode: curry(onChangeLeafNode)
  }));

  /**
   * Build report tree
   * @param {Object} props
   * @param {Object} data
   * @returns {Object} tree
   */
  function buildTree(props, data, filterText) {
    var leafKey = props.leafKey;
    filterText = toUpper(filterText);

    var root = function root() {
      var childNodes = flow(map(getCategory), filter(function (c) {
        return !isNil(c);
      }))(data.categories);
      if (isEmpty(childNodes) && toUpper(data.name).indexOf(filterText) === -1) {
        return null;
      }

      data.indeterminate = checkIndeterminate(childNodes);
      data.checked = data.indeterminate ? true : getAllChecked(props.dataPrev, data, data.categories);
      props.resetPrevData();

      return {
        nodeType: data.name,
        source: data,
        getChildNodes: function getChildNodes() {
          return childNodes;
        }
      };
    };

    var getCategory = function getCategory(category) {
      var childNodes;
      if (category.subCategories.length > 0) {
        childNodes = getLeafNodeForCategoryAndSubCategory(category.subCategories);
        childNodes = filter(function (c) {
          return !isNil(c);
        }, childNodes);
      }

      if (isEmpty(childNodes)) {
        var name = isNil(category.name) ? 'UNCATEGORIZED' : category.name;
        if (toUpper(name).indexOf(filterText) === -1) {
          return null;
        }
      }

      category.indeterminate = checkIndeterminate(childNodes);
      category.checked = category.indeterminate ? true : getCategoryChecked(leafKey, props.dataPrev, category, category.subCategories);

      return {
        nodeType: 'Category',
        source: category,
        getChildNodes: function getChildNodes() {
          return childNodes;
        }
      };
    };

    var getLeafNodeForCategoryAndSubCategory = function getLeafNodeForCategoryAndSubCategory(subCategories) {
      var data = [];
      forEach(function (subCategory) {
        if (isNil(subCategory.id)) {
          data = data.concat(getLeafNodes(subCategory[leafKey]));
        } else {
          data = data.concat(getSubCategory(subCategory));
        }
      }, subCategories);

      return data;
    };

    var getSubCategory = function getSubCategory(subCategory) {
      var childNodes = getLeafNodes(subCategory[leafKey]);
      if (isEmpty(childNodes)) {
        if (isNil(subCategory.name)) {
          return null;
        } else {
          if (toUpper(subCategory.name).indexOf(filterText) === -1) {
            return null;
          }
        }
      }

      subCategory.indeterminate = checkIndeterminate(childNodes);
      subCategory.checked = subCategory.indeterminate ? true : getSubCategoryChecked(props.dataPrev, subCategory, subCategory[leafKey]);

      return {
        nodeType: 'SubCategory',
        source: subCategory,
        getChildNodes: function getChildNodes() {
          return childNodes;
        }
      };
    };

    var getLeafNodes = function getLeafNodes(leafs) {
      return map(getLeafNode, filter(function (leaf) {
        return toUpper(leaf.name).indexOf(filterText) > -1;
      }, leafs));
    };

    var getLeafNode = function getLeafNode(leaf) {
      leaf.checked = getLeafNodeChecked(props.dataPrev, leaf);

      return {
        nodeType: leafKey,
        source: leaf,
        getChildNodes: noop
      };
    };

    buildMapProps(leafKey);
    return isPlainObject(data) ? [root()] : null;
  }

  /**
   * Build report tree
   * @param {Object} props
   * @param {Object} node
   * @returns {String} id
   */
  function getKey(props, node) {
    return node.source.id;
  }

  /**
   * Check indeterminate
   * @param {Object} data
   * @returns {Boolean} has indeterminate
   */
  function checkIndeterminate(data) {
    if (!isNil(data) && !isNil(data[0])) {
      var isExistOneIndeterminate = flow(map('source'), map(function (d) {
        return { indeterminate: d.indeterminate };
      }), some({ indeterminate: true }))(data);
      if (isExistOneIndeterminate) return true;

      var countChecked = flow(map('source'), filter({ checked: true }), size)(data);
      return countChecked !== 0 && data.length !== countChecked;
    }
  }

  /**
   * Get checked for all checkbox
   * @param {Object} data previous
   * @param {Object} source
   * @param {Object} category list
   * @returns {Boolean} checked
   */
  function getAllChecked(dataPrev, source, categories) {
    var id = source.id;
    var checked = source.checked;

    if (!isEmpty(dataPrev)) {
      checked = !some({ checked: false }, categories);
    }
    return checked;
  }

  /**
   * Get checked for category checkbox
   * @param {String} leaf key
   * @param {Object} data previous
   * @param {Object} source
   * @param {Object} category list
   * @returns {Boolean} checked
   */
  function getCategoryChecked(leafKey, dataPrev, source, subCategories) {
    var id = source.id;
    var checked = source.checked;

    if (!isEmpty(dataPrev)) {
      forEach(function (subCategory) {
        if (isNil(subCategory.id)) checked = true;else {
          if (!subCategory.checked) {
            checked = false;
            return false;
          }
        }

        forEach(function (leaf) {
          if (!leaf.checked) {
            checked = false;
            return false;
          }
        }, subCategory[leafKey]);

        if (!checked) return false;
      }, subCategories);
    }
    return checked;
  }

  /**
   * Get checked for sub-category checkbox
   * @param {Object} data previous
   * @param {Object} source
   * @param {Object} category list
   * @returns {Boolean} checked
   */
  function getSubCategoryChecked(dataPrev, source, leafs) {
    var id = source.id;
    var checked = source.checked;

    if (!isEmpty(dataPrev)) {
      checked = !some({ checked: false }, leafs);
    }
    return checked;
  }

  /**
   * Get checked for leaf node checkbox
   * @param {Object} data previous
   * @param {Object} source
   * @returns {Boolean} checked
   */
  function getLeafNodeChecked(dataPrev, source) {
    var id = source.id;
    var checked = source.checked;

    if (!isEmpty(dataPrev)) {
      var prev = find(function (prev) {
        return isEqual(prev.id, id);
      }, dataPrev);
      if (!isNil(prev)) {
        checked = prev.checked;
      }
    }
    return checked;
  }

  /**
   * onchange all
   * @param {Object} props
   * @param {Object} source
   * @param {Object} parent
   * @param {Object} input
   */
  function onChangeAll(props, source, parent, e) {
    var leafKey = props.leafKey;
    var check = e.target.checked;
    source.checked = check;
    source.indeterminate = false;
    updateStatusForDestinationGrid(props);
    updateCheckCategories(leafKey, source.categories, check);
  }

  /**
   * onchange category
   * @param {Object} props
   * @param {Object} source
   * @param {Object} parent
   * @param {Object} input
   */
  function onChangeCategory(props, source, parent, e) {
    var leafKey = props.leafKey;
    var check = e.target.checked;
    source.checked = check;
    source.indeterminate = false;
    updateStatusForDestinationGrid(props);
    updateCheckSubCategories(leafKey, source.subCategories, check);
    updateParentNode(parent, check);
  }

  /**
   * onchange sub category
   * @param {Object} props
   * @param {Object} source
   * @param {Object} parent
   * @param {Object} input
   */
  function onChangeSubCategory(props, source, parent, e) {
    var leafKey = props.leafKey;
    var check = e.target.checked;
    source.checked = check;
    source.indeterminate = false;
    updateStatusForDestinationGrid(props);
    updateCheckLeafNodes(source[leafKey], e.target.checked);
    updateParentNode(parent, check);
  }

  /**
   * onchange report
   * @param {Object} props
   * @param {Object} source
   * @param {Object} parent
   * @param {Object} input
   */
  function onChangeLeafNode(props, source, parent, e) {
    var check = e.target.checked;
    source.checked = check;
    updateStatusForDestinationGrid(props);
    updateParentNode(parent, check);
  }

  /**
   * Update status for destination grid
   */
  function updateStatusForDestinationGrid(props) {
    props.resetWorkspaceTenantsStatus();
  }

  /**
   * update check categories
   * @param {String} leaf key
   * @param {Object} categories
   * @param {Object} check
   */
  function updateCheckCategories(leafKey, categories, check) {
    forEach(function (category) {
      category.checked = check;
      category.indeterminate = false;
      updateCheckSubCategories(leafKey, category.subCategories, check);
    }, categories);
  }

  /**
   * update check sub categories
   * @param {String} leaf key
   * @param {Object} categories
   * @param {Object} check
   */
  function updateCheckSubCategories(leafKey, subCategories, check) {
    forEach(function (subCategory) {
      subCategory.checked = check;
      subCategory.indeterminate = false;
      updateCheckLeafNodes(subCategory[leafKey], check);
    }, subCategories);
  }

  /**
   * update check leaf nodes
   * @param {Object} leafs
   * @param {Object} check
   */
  function updateCheckLeafNodes(leafs, check) {
    forEach(function (leaf) {
      leaf.checked = check;
    }, leafs);
  }

  /**
   * update parent node
   * @param {Object} parent
   * @param {Object} check
   */
  function updateParentNode(parent, check) {
    if (!isNil(parent)) {
      parent.data.source.checked = check ? check : !isCheckedLastNode(parent);
      parent.data.source.indeterminate = checkIndeterminate(parent.data.getChildNodes());
      if (!isNil(parent.parent)) {
        updateParentNode(parent.parent, check);
      }
    }
  }

  var mapProps = [];
  function buildMapProps(leafKey) {
    mapProps.push({ level: 0, prop: 'categories' });
    mapProps.push({ level: 1, prop: 'subCategories,' + leafKey });
    mapProps.push({ level: 2, prop: leafKey });
  }

  /**
   * check last node
   * @param {Object} parent
   * @returns {Boolean} last node
   */
  function isCheckedLastNode(parent) {
    var props = flow(find(function (mapItem) {
      return isEqual(mapItem.level, parent.level);
    }), get('prop'), split(','))(mapProps);

    var isLast = true;
    forEach(function (d) {
      if (!isNil(d.id) && d.checked) {
        isLast = false;
        return false;
      }
      forEach(function (r) {
        if (r.checked) {
          isLast = false;
          return false;
        }
      }, d[props[1]]);

      if (!isLast) return false;
    }, parent.data.source[props[0]]);

    return isLast;
  }

  module.exports = TreeActions;
}();

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(622);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Templates.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * Templates component
 */
var Templates = function Templates(props) {
  var workspaceDetail = props.workspaceDetail,
      _props$workspaceDetai = props.workspaceDetail,
      sourceTemplates = _props$workspaceDetai.sourceTemplates,
      sourceTemplatesPrev = _props$workspaceDetai.sourceTemplatesPrev,
      templateFilterText = _props$workspaceDetai.templateFilterText,
      resetPrevData = _props$workspaceDetai.resetPrevData,
      resetWorkspaceTenantsStatus = _props$workspaceDetai.resetWorkspaceTenantsStatus;

  return _react2.default.createElement(_Izenda4.default, {
    data: sourceTemplates,
    dataPrev: sourceTemplatesPrev,
    filterText: templateFilterText,
    resetPrevData: resetPrevData.bind(workspaceDetail),
    resetWorkspaceTenantsStatus: resetWorkspaceTenantsStatus.bind(workspaceDetail),
    leafKey: 'reports'
  });
};

Templates.propTypes = {
  workspaceDetail: _propTypes2.default.object.isRequired
};

exports.default = (0, _Izenda2.default)()(Templates);
module.exports = exports['default'];

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Tree.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * Tree component
 */
!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var LazyLoadingTreeView = __webpack_require__(335);
  var Input = __webpack_require__(17);
  var TextHighLight = __webpack_require__(62);
  var actions = __webpack_require__(2405);
  var PropTypes = React.PropTypes;

  var _require = __webpack_require__(1),
      invoke = _require.invoke;

  var LazyLoadingTree = React.createClass({
    displayName: 'LazyLoadingTree',

    propTypes: {
      data: PropTypes.object.isRequired,
      getData: PropTypes.func.isRequired,
      isLastPage: PropTypes.bool.isRequired
    },

    /**
     * Render node
     * @param {Object} node
     * @param {String} toggleIcon
     * @param {Boolean} toggle
     * @param {Boolean} isCollapsed
     */
    renderNode: function renderNode(node, toggleIcon, toggle, isCollapsed, parent) {
      var source = node.source,
          onChangeFunc = node.onChange.bind(null, source, parent),
          isLeafNode = node.isLeafNode,
          showTotal = node.showTotal,
          disabled = node.disabled,
          props = this.props,
          name = source.name;

      return React.createElement(
        'div',
        null,
        React.createElement(Input, {
          type: 'checkbox',
          indeterminate: source.indeterminate,
          checked: disabled ? false : source.checked,
          onChange: onChangeFunc,
          disabled: disabled
        }),
        React.createElement(TextHighLight, {
          highlight: props.filterText,
          onClick: toggle,
          text: name,
          className: 'selectable u_inline u_paddingLeft',
          tooltip: name
        }),
        showTotal && React.createElement(
          'span',
          { className: 'selectable u_inline u_paddingLeft' },
          '(',
          source.numOfChilds,
          ')'
        ),
        !isLeafNode && toggleIcon
      );
    },

    render: function render() {
      var props = this.props;
      var getChildNodes = invoke('getChildNodes');

      return React.createElement(LazyLoadingTreeView, {
        className: 'u_paddingRight',
        nodes: props.data,
        isLastPage: props.isLastPage,
        renderNode: this.renderNode,
        getKey: props.getKey,
        getChildNodes: getChildNodes,
        collapsed: false,
        getData: props.getData
      });
    }
  });

  module.exports = connect(actions)(LazyLoadingTree);
}();

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoadingTreeActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var withHandlers = __webpack_require__(9).withHandlers;
  var observable = __webpack_require__(5).observable;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil,
      uniqueId = _require.uniqueId;

  var TreeActions = withHandlers({
    getKey: curry(getKey)
  });

  /**
   * Build report tree
   * @param {Object} props
   * @param {Object} node
   * @returns {String} id
   */
  function getKey(props, node) {
    return isNil(node.source.id) ? uniqueId(node.source.name) : node.source.id;
  }

  module.exports = TreeActions;
}();

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DataModel.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!function () {
  "use strict";

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var SourceTree = __webpack_require__(621);
  var observer = __webpack_require__(10).observer;

  var DataModel = React.createClass({
    displayName: 'DataModel',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      workspaceDetail: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var workspaceDetail = props.workspaceDetail;
      var localization = props.localization;

      return workspaceDetail.copyDataModel && React.createElement(
        'div',
        { className: 'u_tableCell u_paddingRight' },
        localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_PLEASE_SELECT_DATASOURCE'),
        React.createElement(SourceTree, {
          store: store,
          isDataModel: true,
          tree: workspaceDetail.querySourceTree,
          workspaceDetail: workspaceDetail,
          title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SOURCE'),
          showCheckbox: true })
      );
    }
  });

  module.exports = observer(connect()(DataModel));
}();

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Dashboard.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!function () {
  "use strict";

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var Tree = __webpack_require__(622);
  var Panel = __webpack_require__(28);
  var observer = __webpack_require__(10).observer;
  var SearchTextBox = __webpack_require__(107);

  var SearchBox = connect()(function (props) {
    function onChange(e) {
      props.workspaceDetail.dashboardFilterText = e.target.value;
    }

    return React.createElement(SearchTextBox, { className: 'search-box',
      value: props.workspaceDetail.dashboardFilterText,
      onChange: onChange });
  });

  var Dashboard = React.createClass({
    displayName: 'Dashboard',

    propTypes: {
      workspaceDetail: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var localization = props.localization;
      var workspaceDetail = props.workspaceDetail;

      return workspaceDetail.copyDashboard && React.createElement(
        'div',
        { className: 'u_tableCell u_paddingRight' },
        localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_PLEASE_SELECT_DASHBOARD'),
        React.createElement(
          Panel,
          { className: 'u_borderAll workspace-tree u_noMarginAll' },
          React.createElement(SearchBox, { workspaceDetail: workspaceDetail }),
          React.createElement(
            'div',
            { className: 'izenda-dashboardContainer' },
            React.createElement(Tree, {
              data: workspaceDetail.sourceDashboards,
              dataPrev: workspaceDetail.sourceDashboardsPrev,
              filterText: workspaceDetail.dashboardFilterText,
              resetPrevData: workspaceDetail.resetDashboardPrevData.bind(workspaceDetail),
              resetWorkspaceTenantsStatus: workspaceDetail.resetWorkspaceTenantsStatus.bind(workspaceDetail),
              leafKey: 'dashboards'
            })
          )
        )
      );
    }
  });

  module.exports = observer(connect()(Dashboard));
}();

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      filter = _require.filter;

  var SourceDestinationActions = compose(withHandlers({
    getWidthRatio: curry(getWidthRatio)
  }));

  /**
   * Get ratio width
   * @param {Object} props
   * @returns {String}
   */
  function getWidthRatio(props, d) {
    var item = props.item;
    var ratios = new Array(4);
    var selecteds = [item.copyDataModel, item.copyDashboard, item.copyReport, true];
    var count = filter(function (s) {
      return s === true;
    }, selecteds).length;
    if (count > 0) {
      var ratio = 12 / count;
      if (item.copyDataModel) {
        ratios[0] = ratio;
      }
      if (item.copyDashboard) {
        ratios[1] = ratio;
      }
      if (item.copyReport) {
        ratios[2] = ratio;
      }

      ratios[3] = ratio;
    }

    return ratios;
  }

  module.exports = SourceDestinationActions;
}();

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SourceDestinationSettingsHeader(_ref) {
  var item = _ref.item,
      icon = _ref.icon,
      title = _ref.title,
      collapseToggle = _ref.collapseToggle,
      style = _ref.style,
      className = _ref.className,
      showCopyPositionId = _ref.showCopyPositionId;

  var onCopyPositionIdCheck = function onCopyPositionIdCheck(e) {
    item.setCopyPositionId(e.target.checked);
  };

  return _react2.default.createElement(
    'div',
    { className: 'u-posRelative' },
    _react2.default.createElement(
      'strong',
      { onClick: collapseToggle, style: style, className: className },
      icon ? _react2.default.createElement('i', { className: icon }) : null,
      title
    ),
    showCopyPositionId && _react2.default.createElement(
      'div',
      { className: 'u-posAbsolute u-posAbsoluteCenter' },
      _react2.default.createElement(
        'label',
        { className: 'u_noMarginBottom' },
        _react2.default.createElement('input', {
          type: 'checkbox',
          checked: item.copyPositionId,
          onChange: onCopyPositionIdCheck,
          className: 'u_noMarginTop u_alignMiddle'
        }),
        _react2.default.createElement(
          'span',
          { className: 'u_paddingRight u_alignMiddle u_textNormal u_inlineBlock' },
          _Izenda2.default.getText('COMMON_LABEL_COPY_RELATIONSHIP_POSITION_ID')
        )
      )
    )
  );
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationSettingsHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _mobxReact.observer)(SourceDestinationSettingsHeader);
module.exports = exports['default'];

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationSettingsActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var SourceDestinationSettingsActions = compose(withHandlers({
    buildTitle: curry(buildTitle)
  }));

  /**
   * Build title
   * @param {Object} props
   * @returns {String} title
   */
  function buildTitle(props, _) {
    var localization = props.localization;
    var item = props.item;
    var title = '';
    var copySettingsText = localization.getText('COMMON_LABEL_COPY_SETTINGS');

    if (item.copyDataModel) {
      title = localization.getText('COMMON_LABEL_DATA_MODEL');
    }

    if (item.copyDashboard) {
      title += (title === '' ? '' : ', ') + localization.getText('COMMON_LABEL_DASHBOARDS');
    }

    if (item.copyReport) {
      title += (title === '' ? '' : ', ') + localization.getText('COMMON_LABEL_REPORT');
    }

    if (title !== '') {
      title += ' ' + copySettingsText;
      var lastIndex = title.lastIndexOf(',');
      if (lastIndex >= 0) {
        title = title.substring(0, lastIndex) + ' and' + title.substring(lastIndex + 1, title.length);
      }
      return title;
    } else {
      return copySettingsText;
    }
  }

  module.exports = SourceDestinationSettingsActions;
}();

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Workspace List component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var EventUtils = __webpack_require__(24);

  var ScrollBox = __webpack_require__(27);
  var SearchTextBox = __webpack_require__(107);
  var List = __webpack_require__(195);
  var WorkspaceItem = __webpack_require__(2412);

  var notifyChange = EventUtils.notifyChange;
  var notify = EventUtils.notify;

  var observer = __webpack_require__(10).observer;

  var WorkspaceList = React.createClass({
    displayName: 'WorkspaceList',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },
    render: function render() {
      return React.createElement(
        'div',
        { className: 'workspace-panel u_fullHeight u-posRelative' },
        this.getRenderHeaderContent(),
        this.getRenderListWorkspace()
      );
    },

    getRenderHeaderContent: function getRenderHeaderContent() {
      var store = this.props.store;
      var localization = this.props.localization;

      return React.createElement(
        'div',
        { className: 'header-panel' },
        React.createElement(
          'a',
          {
            className: 'connection-builder-link btn-add-connection overflow-text text-bold',
            onClick: this.addNewWorkspace,
            title: localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ADD_WORKSPACE') },
          React.createElement('span', { className: 'icon-plus' }),
          localization.getText('COPY_MANAGEMENT_WORK_SPACE_LIST_ADD_WORKSPACE')
        ),
        React.createElement(
          'div',
          { className: 'search-box' },
          React.createElement(SearchTextBox, { value: store.filter,
            onChange: notifyChange(store.setFilter.bind(store), EventUtils.INPUT),
            onKeyPress: this.selectSearchedWorkspace })
        ),
        React.createElement(
          'div',
          { className: 'checkbox-show-workspace overflow-text' },
          React.createElement('input', { type: 'checkbox',
            checked: store.showOnlyMyWorkspace,
            onClick: this.onChangeOnlyShowMyWorkspace,
            className: 'u_noMarginLeft',
            id: 'showOnlyMyWorkspace' }),
          React.createElement(
            'label',
            { htmlFor: 'showOnlyMyWorkspace', className: 'u_textNormal' },
            localization.getText('COPY_MANAGEMENT_WORK_SPACE_LIST_SHOW_ONLY_MY_WORKSPACES')
          )
        ),
        React.createElement('hr', null)
      );
    },

    getRenderListWorkspace: function getRenderListWorkspace() {
      var store = this.props.store;

      return React.createElement(
        'div',
        { className: 'list-workspace-item' },
        React.createElement(
          ScrollBox,
          null,
          React.createElement(
            List,
            { itemClass: 'workspace-item-custom' },
            store.filteredWorkspaces.map(function (item, idx) {
              return React.createElement(WorkspaceItem, {
                key: idx,
                dataSource: item,
                store: store });
            })
          )
        )
      );
    },

    /**
     * When there is only one item in searched workspace list, user can press enter
     * to select it.
     * @param  {Object} event React-event
     */
    selectSearchedWorkspace: function selectSearchedWorkspace(event) {
      if (event.key === 'Enter') {
        var store = this.props.store;
        if (store.filteredWorkspaces.length === 1) {
          store.item = store.filteredWorkspaces[0];
        }
      }
    },

    /**
     * Add a new workspace. New workspace detail is showed.
     */
    addNewWorkspace: function addNewWorkspace() {
      this.props.store.filter = '';
      this.props.store.addWorkspace();
    },

    onChangeOnlyShowMyWorkspace: function onChangeOnlyShowMyWorkspace(event) {
      var store = this.props.store;
      store.updateShowWorkspace(event.target.checked);
      store.loadList(store.tenantId).then(store.handleShowMyWorkspace.bind(store));
    }
  });

  module.exports = observer(connect()(WorkspaceList));
}();

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Workspace Item component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);
  var constants = __webpack_require__(91);
  var uiState = __webpack_require__(15);
  var TextHighLight = __webpack_require__(62);
  var observer = __webpack_require__(10).observer;

  var WorkspaceItem = React.createClass({
    displayName: 'WorkspaceItem',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      dataSource: React.PropTypes.object.isRequired
    },

    onDelete: function onDelete(e) {
      var props = this.props;
      var loader = props.loader;

      e.stopPropagation();
      props.confirmFn('Confirmation', {
        description: constants.M01
      }).then(function () {
        loader.startLoading();
        return props.store.deleteWorkspace(props.dataSource).finally(loader.endLoading.bind(loader));
      }.bind(this));
    },

    onSelect: function onSelect(e) {
      e.stopPropagation();
      var store = this.props.store;
      var dataSource = this.props.dataSource;

      // Only re-select a current item when it's actually differrent regarding to
      // its id value.
      if (store.item.id != dataSource.id) {
        this.props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(function () {
          store.item = dataSource;
        });
      }
    },

    render: function render() {
      var dataSource = this.props.dataSource;
      var selectedId = this.props.store.item.id;
      var filter = this.props.store.filter;

      var selectedClass = classnames('truncate', 'overflow-text', {
        selected: dataSource.id === selectedId
      });

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: selectedClass, onClick: this.onSelect },
          React.createElement(TextHighLight, {
            className: 'pull-left workspace-name',
            highlight: filter,
            text: dataSource.name,
            tooltip: dataSource.name
          }),
          React.createElement('span', { className: 'icon-cancel white-space-normal', onClick: this.onDelete })
        )
      );
    }
  });

  module.exports = observer(connect()(WorkspaceItem));
}();

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      isNil = _require.isNil,
      findIndex = _require.findIndex,
      concat = _require.concat,
      toUpper = _require.toUpper,
      head = _require.head,
      escapeRegExp = _require.escapeRegExp,
      create = _require.create,
      find = _require.find,
      sortBy = _require.sortBy;

  var m = __webpack_require__(5);
  var dataFetcher = __webpack_require__(1156);
  var tenantFetcher = __webpack_require__(278);
  var systemFetcher = __webpack_require__(75);
  var constants = __webpack_require__(91);
  var Workspaces = __webpack_require__(2414);

  function WorkspaceStore() {
    var observable = {
      // A filtered workspace list that matches the filter string
      filteredWorkspaces: function filteredWorkspaces() {
        var filterRegex = new RegExp(escapeRegExp(this.filter), 'i');
        var match = function match(item) {
          return filterRegex.test(item.name);
        };
        return sortBy(function (item) {
          return toUpper(item.name);
        }, this.list.filter(match));
      },
      // available sources for Source Dropdown: only display System & tenants
      // which not available in destination tenants
      availableSources: function availableSources() {
        var selectedDestinationTenantIDs = this.item.selectedDestinationTenantIDs;
        var selectedSource = this.item.isSystemSource ? [] : find({ id: this.item.sourceId }, this.tenantList);

        return isNil(selectedDestinationTenantIDs) ? this.tenantList : this.item.isSelectAllTenants ? concat(constants.systemSource, selectedSource) : filter(function (item) {
          return selectedDestinationTenantIDs.indexOf(item.id) === -1;
        }, this.tenantList);
      }
    };

    Workspaces.call(observable);

    // Extend the store from workspaces model and make it observable
    m.extendObservable(this, observable);

    this.dispose = m.observe(this.list, function () {
      // Move current workspace to next eligible workspace in the list
      // whenever the list changed.
      this.nextWorkspace(this.item ? this.item.id : null);
    }.bind(this));
  }

  WorkspaceStore.prototype = create(Workspaces.prototype, {
    constructor: WorkspaceStore
  });

  /**
   * Move to next eligible workspace in showing list.
   */
  WorkspaceStore.prototype.nextWorkspace = function (startId) {
    if ((isNil(this.item) || isNil(this.item.id)) && isNil(startId)) {
      if (isEmpty(this.list)) {
        // Case of intial loading the empty list, a new workspace detail is active
        // in order to allow adding new workspace.
        this.addWorkspace();
      } else {
        // Case of first loading (active item is undefined), move to first workspace
        var first = head(this.list);
        this.item = first;
      }
    } else if (this.item.id !== startId) {
      var next = find(['id', startId], this.filteredWorkspaces) || find(['id', startId], this.list);
      if (isNil(next)) {
        this.addWorkspace();
      } else {
        this.item = next;
      }
    } else if (this.tenantId) {
      // In case of when change tenant then get the first value of list workspace string
      var firstItem = head(this.list);
      isNil(firstItem) ? this.addWorkspace() : this.item = firstItem;
    }
  };

  /**
   * Load all workspaces and supported db types from API
   * @return {Promise} A promise of loading workspace list
   */
  WorkspaceStore.prototype.loadList = m.action(function () {
    var store = this;
    var showOnlyMyWorkspace = store.showOnlyMyWorkspace;

    return (0, _bluebird.join)(dataFetcher.getAllWorkspaces(showOnlyMyWorkspace), tenantFetcher.getAllNameTenantList(), systemFetcher.getAllUsers(), function (workspaceList, tenantList, userList) {
      // Defer notifying changes until reading finished
      store.readTenantList(tenantList);
      store.readWorkspaceList(workspaceList);
      store.updateOwnerList(userList);
      return null;
    }).then(function () {
      if (isEmpty(store.list)) {
        store.addWorkspace();
      }
    });
  });

  /**
   * Delete a workspace. Side effect of deletion is moving selected item
   * in the list to next one.
   * @param  {Object} delItem Deleted workspace
   * @param  {Promise} A promise of deletion
   */
  WorkspaceStore.prototype.deleteWorkspace = m.action(function (delItem) {
    // Find next available Workspace in the list by round-robin ordering pattern
    var findNextId = function findNextId(availableList, fullList, current) {
      function nextEligible(list) {
        if (delItem.id === current.id && list.length > 1) {
          var index = findIndex(['id', delItem.id], list);
          // If deleted item is the last item, then take first one, but the next one.
          return index === list.length - 1 ? list[0].id : list[index + 1].id;
        } else if (delItem.id !== current.id) {
          return current.id;
        }
        return null;
      }

      return nextEligible(availableList) || nextEligible(fullList);
    };

    return dataFetcher.delete(delItem.id).then(function () {
      var store = this;
      // Select next item in filtered Workspace list
      var nextId = findNextId(store.filteredWorkspaces, store.list, store.item);
      store.nextWorkspace(nextId);

      // Delete Workspace detail instance in the list
      var idx = findIndex(['id', delItem.id], store.list);
      store.list.splice(idx, 1);
      return null;
    }.bind(this));
  });

  module.exports = WorkspaceStore;
}();

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Workspaces.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var WorkspaceDetail = __webpack_require__(2415);
  var constants = __webpack_require__(91);
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      map = _require.map,
      forEach = _require.forEach,
      concat = _require.concat;

  function Workspaces() {
    var props = {
      item: new WorkspaceDetail(),
      list: [],
      filter: '',
      tenantList: [],
      showOnlyMyWorkspace: false,
      ownerList: []
    };

    m.extendObservable(this, props);
  }

  /**
   * Set new filter value for connection list.
   * @param {string} newFilter Searching text
   */
  Workspaces.prototype.setFilter = function (newFilter) {
    this.filter = newFilter || '';
  };

  /**
   * Read connection list and map connection data to connection detail instance.
   * That keeps all item in list will be instance of connection detail. It also
   * updates the observable connection list, then the UI will be updated accordingly.
   * @param  {Array} connList Array of connection list that returned from API
   */
  Workspaces.prototype.readWorkspaceList = function (connList) {
    // Populate connection detail item instance from its data
    var createWorkspaceDetail = function createWorkspaceDetail(itemData) {
      var item = new WorkspaceDetail();
      item.readDetail(itemData);
      return item;
    };

    // Clean current list and append new connection list
    this.list.splice.apply(this.list, [0, this.list.length].concat(map(createWorkspaceDetail, connList)));
  };

  /**
   * Read tenant list from API, then concat with 'System' object.
   * @param  {Array} tenantList The tenant list that returns from API
   */
  Workspaces.prototype.readTenantList = function (tenantList) {
    this.tenantList = concat(constants.systemSource, tenantList);
    map(function (item) {
      item.tenantName = item.name;
      item.tenantUniqueName = item.tenantID;
      item.name = item.id !== constants.systemSource.id ? String.format('{0} - {1}', item.tenantID, item.name) : item.name;
      item.tenantID = item.id;
    }, this.tenantList);
  };

  /**
   * Add new connection and mark it as selected item.
   */
  Workspaces.prototype.addWorkspace = function (id) {
    this.item = new WorkspaceDetail();
    this.item.id = id || null;
    this.item.markDirty();
    this.item.getOriginalTenantList(this.tenantList);
  };

  /**
   * [updateShowWorkspace is to update the status of show only my workspace]
   * @param  {[boolean]} state [description]
   */
  Workspaces.prototype.updateShowWorkspace = function (state) {
    this.showOnlyMyWorkspace = state;
  };

  /**
   * handleShowMyWorkspace is to handle the selected workspace on the middle panel after load list
   */
  Workspaces.prototype.handleShowMyWorkspace = function () {
    var itemExisted = false;
    forEach(function (newItem) {
      if (this.item.id === newItem.id) {
        this.item = newItem;
        itemExisted = true;
      }
    }.bind(this), this.list);

    if (!itemExisted) {
      this.item = this.list[0];
    }
  };

  /**
   * [updateOwnerList description]
   * @param  {[Array]} state [description]
   */
  Workspaces.prototype.updateOwnerList = function (ownerList) {
    this.ownerList = ownerList;
  };

  /**
   * Add a new workspace to list.
   * @param {Object} workspaceDetail Added workspace
   */
  Workspaces.prototype.addWorkspaceToList = m.action(function (workspaceDetail) {
    this.list.push(workspaceDetail);
  });

  module.exports = Workspaces;
}();

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  __webpack_require__(55);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      every = _require.every,
      some = _require.some,
      forEach = _require.forEach,
      map = _require.map,
      isNil = _require.isNil,
      flow = _require.flow,
      getOr = _require.getOr,
      omit = _require.omit,
      get = _require.get,
      union = _require.union,
      toLower = _require.toLower,
      join = _require.join,
      split = _require.split,
      tail = _require.tail,
      sortBy = _require.sortBy,
      concat = _require.concat,
      flatMap = _require.flatMap,
      includes = _require.includes,
      matchesProperty = _require.matchesProperty,
      isBoolean = _require.isBoolean,
      find = _require.find;

  var QuerySourceTree = __webpack_require__(623);

  var m = __webpack_require__(5);
  var constants = __webpack_require__(91);
  var trackable = __webpack_require__(46);
  var CopyManagementUtils = __webpack_require__(1157);

  var WorkspaceTenant = __webpack_require__(2416);
  var WorkspaceDetailCopyReport = __webpack_require__(2418);
  var WorkspaceMapping = __webpack_require__(1158);
  var CategoryDetail = __webpack_require__(161);

  var commonMessages = __webpack_require__(37);
  var DateFormatter = __webpack_require__(2424).DateFormatter;
  var PagingModel = __webpack_require__(98);
  var localizer = __webpack_require__(12);

  function WorkspaceDetail() {
    this.sourceReportsPrev = [];
    this.sourceTemplatesPrev = [];
    this.sourceDashboardsPrev = [];
    this.isLastPage = false;
    this.isLastPageOfDataModel = false;

    var props = {
      fakeReports: {},
      treeReports: [],
      fakeDataModels: {},
      treeDataModels: [],
      // State properties
      id: null,
      name: constants.DEFAULT_WORKSPACE_NAME,
      description: '',
      tenantId: null,
      ownerId: null,
      createdBy: null,
      created: null,
      createdAsString: new DateFormatter().formatUTCDate(new Date(), 'MM/dd/yyyy hh:mm:ss'),
      modified: null,
      copyDataModel: false,
      copyAdvancedSettings: false,
      copyTenantPermissions: false,
      copyRoles: false,
      copyRolePermission: false,
      copyDashboard: false,
      copyReport: false,
      mergeDuplicateMappings: false,
      sourceId: null,
      sourceHashCode: null,
      selectAllTenants: false,
      sourceDataModelJSON: null,
      isSelected: false,
      sourceConnections: [],
      workspaceTenants: [],
      workspaceMappings: [],

      // Temporary properties
      pageInfo: new PagingModel(constants.DESTINATION_SORT_DIR),
      alertMessage: commonMessages.EMPTY_MESSAGE,
      tenantListForDestination: [],
      originalTenantList: [],
      selectedDestinationTenantIDs: null,
      destinationGridData: [],
      destinationDropdownOpts: [],

      // selected databases/dataobjects from SourceTree used for Mappings grid
      selectedDatabases: [],
      selectedDataObjects: [],

      distinctConnections: [],
      // Use for Advanced Copy page
      selectedTenant: null,

      // Run Copy properties
      runCopyDataModels: [],
      conflictingReportTree: [],
      conflictingDashboardTree: [],
      copyOption: {},
      copyPositionId: false,
      copyAdvancedSettingOption: {},
      copyDashboardOption: {},
      copyReportOption: {},
      copyTemplateOption: {},
      copyTenantPermissionOption: {},
      copyRolePermissionOption: {},
      copiedRoles: [],
      copiedRolePermission: [],
      connectionConfirmation: [], // Run copy override confirmation
      canRunCopy: false,

      // All hash codes
      allHashcodes: {
        advancedSettings: '',
        tenantPermission: '',
        roles: '',
        rolePermissions: '',
        reports: '',
        templates: '',
        dashboards: ''
      },

      // copied report list
      sourceReports: {},
      sourceTemplates: {},
      sourceDashboards: {},

      // For filter
      reportFilterText: '',
      templateFilterText: '',
      dashboardFilterText: '',

      // Computed properties
      querySourceTree: function querySourceTree() {
        return new QuerySourceTree(this.sourceConnections);
      },
      runCopyQuerySourceTree: function runCopyQuerySourceTree() {
        return new QuerySourceTree(this.runCopyDataModels);
      },
      isNew: function isNew() {
        return !this.id;
      },
      haveDataSource: function haveDataSource() {
        return !isEmpty(this.sourceConnections);
      },
      needConfirmWhenLeaving: function needConfirmWhenLeaving() {
        return this.isDirty;
      },
      canSave: function canSave() {
        return this.isDirty;
      },
      displaySourceConnections: function displaySourceConnections() {
        return map(function (connection) {
          connection.fullDBName = String.format('[{0}] {1}', connection.serverTypeName, connection.databaseName);
          connection.databaseTooltip = String.format('{0} - {1} - {2}', connection.serverTypeName, connection.databaseServer, connection.databaseName);
          return connection;
        }, this.sourceConnections);
      },
      showMappingGrid: function showMappingGrid() {
        // Mapping grid is visible if and only if
        // the user selects an item in the Source and Destination(s) dropdown
        return this.selectedDestinationTenantIDs && this.sourceId;
      },

      // has at least one item is checked to copy
      hasItemToCopy: function hasItemToCopy() {
        return some(function (item) {
          return item;
        }, [this.copyDataModel, this.copyAdvancedSettings, this.copyDashboard, this.copyReport, this.copyTenantPermissions, this.copyRoles, this.copyRolePermission]);
      },

      activeRunCopy: function activeRunCopy() {
        // no item is selected in Source and Destination(s) dropdown
        // no “items to copy” is selected
        // then Run Copy button is disabled.
        return !isNil(this.sourceId) && !isNil(this.selectedDestinationTenantIDs) && this.hasItemToCopy;
      },
      activeValidation: function activeValidation() {
        // Data Model checkbox is selected in the Items to Copy section
        // AND At least a destination has status = Needs Validation
        return (this.copyDataModel || this.copyReport || this.copyDashboard) && some({ status: 0 }, this.workspaceTenants);
      },
      allRoleCopyChecked: function allRoleCopyChecked() {
        return every({ checked: true }, this.roleList);
      },
      // Run copy roles & roles Permission
      roleList: [],
      allRoleCopyPermissionChecked: function allRoleCopyPermissionChecked() {
        return every({ checked: true }, this.roleListPermission);
      },
      roleListPermission: [],
      disableItemsToCopy: function disableItemsToCopy() {
        return isNil(this.sourceId) || isNil(this.selectedDestinationTenantIDs);
      },
      isSystemSource: function isSystemSource() {
        return this.sourceId === constants.systemSource.id;
      },
      isSelectAllTenants: function isSelectAllTenants() {
        return this.selectedDestinationTenantIDs === constants.systemSource.id;
      },
      isReadyToRunCopy: function isReadyToRunCopy() {
        // if click Ok in any conflicting pop up
        // then check selected item in there or not
        // if click on copy role permission
        // then check the role name selected
        // and check selected item in conflicting pop up
        return this.canRunCopy && (this.checkHasSelectedConflictingItem(this.copyOption) || this.checkHasSelectedConflictingItem(this.copyAdvancedSettingOption) || this.checkHasSelectedConflictingItem(this.copyDashboardOption) || this.checkHasSelectedConflictingItem(this.copyReportOption) || this.checkHasSelectedConflictingItem(this.copyTemplateOption) || this.checkHasSelectedConflictingItem(this.copyTenantPermissionOption) || this.checkHasSelectedConflictingItem(this.copyRolePermissionOption)) || this.copyDataModel && isEmpty(this.copyOption) || this.copyAdvancedSettings && isEmpty(this.copyAdvancedSettingOption) || this.copyDashboard && isEmpty(this.copyDashboardOption) || this.copyReport && isEmpty(this.copyReportOption) || this.copyReport && isEmpty(this.copyTemplateOption) || this.copyTenantPermissions && isEmpty(this.copyTenantPermissionOption) || this.copyRoles && !isEmpty(this.copiedRoles) || this.copyRolePermission && !isEmpty(this.copiedRolePermission) && (this.checkHasSelectedConflictingItem(this.copyRolePermissionOption) || isEmpty(this.copyRolePermissionOption));
      },

      // copy report
      selectedDatabaseForCopiedReport: function selectedDatabaseForCopiedReport() {
        return filter(function (connection) {
          CopyManagementUtils.updateDataSoucreBasedOnLinkedReport(connection);
          return connection.belongToCopiedReport;
        }, this.sourceConnections);
      },

      // mapping: list of connections
      mapppingDatabasesSource: function mapppingDatabasesSource() {
        return union(this.selectedDatabases, this.selectedDatabaseForCopiedReport);
      },

      // mapping: list of objects
      mapppingDataObjects: function mapppingDataObjects() {
        var mapppingDatabasesSource = this.mapppingDatabasesSource;
        var re = {};

        forEach(function (connection) {
          re[connection.fullDBName] = flow(getOr([], 'dbSource.querySources'), filter(filterDataObject))(connection);
        }, mapppingDatabasesSource);

        return re;

        function filterDataObject(schema) {
          return schema.checked || schema.belongToCopiedReport // for copy data model
          ; // for copy report/template
        }
      }
    };

    m.extendObservable(trackable(this), props);
  }

  /**
   * workspace detail validation constraints
   * @type {Object}
   */
  WorkspaceDetail.constraints = {
    name: constants.WORKSPACE_NAME_CONSTRAINT
  };

  /**
   * Read workspace detail data (mostly this data comes from API).
   * @param  {Object} detail
   */
  WorkspaceDetail.prototype.readDetail = m.action(function (detail) {
    this.id = detail.id;
    this.name = detail.name;
    this.description = detail.description;
    this.tenantId = detail.tenantId;
    this.ownerId = detail.ownerId;
    this.createdBy = detail.createdBy;
    this.created = detail.created;
    this.modified = detail.modified;
    this.copyDataModel = detail.copyDataModel;
    this.copyPositionId = detail.copyPositionId;
    this.copyRoles = detail.copyRoles;
    this.copyRolePermission = detail.copyRolePermission;
    this.copyAdvancedSettings = detail.copyAdvancedSettings;
    this.copyTenantPermissions = detail.copyTenantPermissions;
    this.copyDashboard = detail.copyDashboard;
    this.copyReport = detail.copyReport;
    this.mergeDuplicateMappings = detail.mergeDuplicateMappings;
    this.sourceId = detail.sourceId;
    this.sourceHashCode = detail.sourceHashCode;
    this.selectAllTenants = detail.selectAllTenants;
    this.sourceDataModelJSON = detail.sourceDataModelJSON;

    this.workspaceTenants = map(function (tenant) {
      return new WorkspaceTenant(tenant);
    }, detail.workspaceTenants);

    this.readSourceConnections(detail.sourceConnections);

    this.setSourceReports(detail.sourceReports, detail.sourceTemplates);
    this.setSourceDashboards(detail.sourceDashboards);

    this.workspaceMappings = map(function (mappingItem) {
      return new WorkspaceMapping(mappingItem, this.mapppingDatabasesSource);
    }.bind(this), detail.workspaceMappings);
    var allHashcodes = detail.allHashcodes;
    this.allHashcodes = {
      advancedSettings: !isNil(allHashcodes) ? allHashcodes.advancedSettings : '',
      tenantPermission: !isNil(allHashcodes) ? allHashcodes.tenantPermission : '',
      roles: !isNil(allHashcodes) ? allHashcodes.roles : '',
      rolePermissions: !isNil(allHashcodes) ? allHashcodes.rolePermissions : '',
      dashboards: !isNil(allHashcodes) ? allHashcodes.dashboards : '',
      reports: !isNil(allHashcodes) ? allHashcodes.reports : '',
      templates: !isNil(allHashcodes) ? allHashcodes.templates : ''
    };
    this.copiedRoles = detail.copiedRoles;
    this.copiedRolePermission = detail.copiedRolePermission;
    this.resetDirty();

    return (0, _bluebird.resolve)();
  });

  /**
   * [loadInitialData description]
   * @return {[type]} [description]
   */
  WorkspaceDetail.prototype.loadInitialData = m.action(function () {
    this.updateDataForDestination(this.sourceId);

    // calculate selected Databases/DataObjects for Mappings grid
    this.calcSelectedDatabases();
    this.calcSelectedDataObjects();

    if (isEmpty(this.workspaceTenants) && this.selectAllTenants) {
      this.updateSelectedTenantsForDestination(constants.systemSource.id);
    } else if (!isEmpty(this.workspaceTenants)) {
      var selectedTenant = [];
      forEach(function (item) {
        selectedTenant.push(item.tenantId);
      }, this.workspaceTenants);
      selectedTenant = join(',', selectedTenant);
      this.updateSelectedTenantsForDestination(selectedTenant);
    }
    this.workspaceTenants.forEach(function (item) {
      item.name = item.tenantName;
      item.tenantName = String.format('{0} - {1}', item.tenantUniqueName, item.tenantName);
    });
  });

  /**
   * Read data sources (mostly this data comes from API)
   * @param  {Object} dbSource
   */
  WorkspaceDetail.prototype.readSourceConnections = m.action(function (sourceConnections) {
    this.sourceConnections = sourceConnections || [];
    this.reCalculateSelectedSources();
  });

  /**
   * Read distinct connection
   */
  WorkspaceDetail.prototype.readDistinctConnections = m.action(function (connections) {
    var displayConnections = map(function (connection) {
      connection.fullDBName = String.format('[{0}] {1}', connection.serverTypeName, connection.databaseName);
      connection.databaseTooltip = String.format('{0} - {1} - {2}', connection.serverTypeName, connection.databaseServer, connection.databaseName);
      return connection;
    }, connections);

    this.distinctConnections = displayConnections;
  });

  /**
   * Set AlertMessage
   */
  WorkspaceDetail.prototype.setAlertMessage = function (newAlertMessage) {
    this.alertMessage = newAlertMessage;
  };

  /**
   * Set Copy PositionId
   * @param {any} value
   */
  WorkspaceDetail.prototype.setCopyPositionId = function (value) {
    this.copyPositionId = value;
    this.markDirty();
  };

  /**
   * Set property value
   * @param {type} property
   * @param {type} value
   */
  WorkspaceDetail.prototype.setPropertyValue = function (property, value) {
    // Reset alert message
    this.setAlertMessage(commonMessages.EMPTY_MESSAGE);
    this[property] = value;
  };

  /**
   * [getOriginalTenantList generate original tenant list and change 'System' to 'All Tenants']
   * @param  {[Array]} options [description]
   * @return {[Array]}         [description]
   */
  WorkspaceDetail.prototype.getOriginalTenantList = m.action(function (options) {
    this.originalTenantList = m.toJS(options) || [];

    !isEmpty(this.originalTenantList) && forEach(function (item) {
      if (item.id === constants.systemSource.id) {
        item.name = localizer.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_ALL_TENANTS');
      }
    }, this.originalTenantList);
    this.loadInitialData();

    return (0, _bluebird.resolve)();
  });

  /**
   * create new Workspace Tenant from DB object
   * @param  {Object} detail
   * @return {Object} detail
   */
  WorkspaceDetail.prototype.newWorkspaceTenant = function (detail) {
    var tenant = new WorkspaceTenant({
      tenantId: detail.id,
      tenantName: detail.name,
      name: detail.tenantName,
      workspaceId: detail.workspaceId,
      tenantUniqueName: detail.tenantUniqueName,
      status: detail.status,
      state: detail.state,
      inserted: detail.inserted,
      version: detail.version,
      created: detail.created,
      createdBy: detail.createdBy,
      modified: detail.modified,
      modifiedBy: detail.modifiedBy,
      destinationConnections: detail.destinationConnections,
      sourceConnections: detail.sourceConnections,
      dataMapping: detail.dataMapping
    });

    return tenant;
  };

  /**
   * Update data selected tenant for Dropdownlist and datasource in Destination Grid
   * @param  {String} tenantId
   * @return {Promise}
   */
  WorkspaceDetail.prototype.updateSelectedTenantsForDestination = m.action(function (tenantId, sourceId) {
    sourceId = sourceId || '';

    if (tenantId) {
      this.selectedDestinationTenantIDs = tenantId;
      var tenantIdList = split(',', this.selectedDestinationTenantIDs);
      var allTenant = find(function (item) {
        return item === constants.systemSource.id;
      }, tenantIdList);

      if (this.selectAllTenants === true || allTenant) {
        forEach(function (tenant) {
          !find({ tenantId: tenant.id }, this.workspaceTenants) && this.workspaceTenants.push(this.newWorkspaceTenant(tenant));
        }.bind(this), tail(this.destinationDropdownOpts));

        this.workspaceTenants = allTenant ? sortBy(function (tenant) {
          return toLower(tenant.tenantName);
        }, this.workspaceTenants) : this.workspaceTenants;
        this.selectedDestinationTenantIDs = constants.systemSource.id;
        this.selectAllTenants = true;
      } else {
        /**
         * when add new tenant in dropdown list
         * find item is not belong to data source grid and push it
         */
        this.workspaceTenants = filter(function (item) {
          return includes(item.tenantId, tenantIdList) && item.tenantId != sourceId;
        }.bind(this), this.workspaceTenants);

        /**
         * remove source item in tenantIds
         */
        this.selectedDestinationTenantIDs = this.selectedDestinationTenantIDs.replace(sourceId.toString(), '');

        /**
         * remove the tenant in dropdown list
         * then remove the workspace in datasource grid
         */
        forEach(function (itemData) {
          var tenant = find({ id: itemData }, this.destinationDropdownOpts);
          var workspace = find({ tenantId: itemData }, this.workspaceTenants);
          if (tenant && !workspace) {
            this.workspaceTenants.push(this.newWorkspaceTenant(tenant));
          }
        }.bind(this), tenantIdList);
      }
    } else {
      this.resetDataForDestination();
    }

    return (0, _bluebird.resolve)();
  });

  /**
   * reset data for Destination
   */
  WorkspaceDetail.prototype.resetDataForDestination = m.action(function () {
    this.selectedDestinationTenantIDs = null;
    this.workspaceTenants = [];
    this.selectAllTenants = false;
    this.markDirty();
  });

  /**
   * [updateDataForDestination this function is to update the selected value in source dropdown]
   * @param  {[string]} sourceId
   */
  WorkspaceDetail.prototype.updateDataForDestination = m.action(function (sourceId) {
    this.destinationDropdownOpts = isNil(sourceId) ? this.originalTenantList : filter(function (item) {
      return item.id !== sourceId || item.id === constants.systemSource.id;
    }.bind(this), this.originalTenantList);
  });

  /**
   * [onSortChange update sort infor]
   * @param  {[string]} columnKey
   * @param  {[object]} sortDir
   */
  WorkspaceDetail.prototype.onSortChange = function (columnKey, sortDir) {
    this.pageInfo.setColSortDirs(columnKey, sortDir);
  };

  /**
   * [updateOwner ]
   * @param  {[string]} ownerId [description]
   */
  WorkspaceDetail.prototype.updateOwnerList = function (ownerId) {
    this.ownerId = ownerId;
  };

  /**
   *  Update errorMessages
   */
  WorkspaceDetail.prototype.showAlertMessage = function (type, message) {
    this.alertMessage = {
      type: type,
      message: message
    };
    return null;
  };

  /**
   *  Update Workspace name
   */
  WorkspaceDetail.prototype.updateWorkspaceName = m.action(function (name) {
    this.name = name;
    this.markDirty();
  });

  /**
   * Update Workspace description
   */
  WorkspaceDetail.prototype.updateWorkspaceDescription = function (description) {
    this.description = description;
  };

  /**
   * Re-calculate selected databases/dataobjects of DataSourceTree,
   * then re-update sourceConnections for all tenants when master SourceTree changes
   */
  WorkspaceDetail.prototype.reCalculateSelectedSources = m.action(function () {
    this.calcSelectedDatabases();
    this.calcSelectedDataObjects();
    this.updateWorkspaceTenants();
  });

  /**
   * calc selected Databases of Source Tree
   */
  WorkspaceDetail.prototype.calcSelectedDatabases = function () {
    this.selectedDatabases = this.displaySourceConnections.filter(matchesProperty('checked', true));
  };

  /**
   * calc selected Data Objects of Source Tree
   */
  WorkspaceDetail.prototype.calcSelectedDataObjects = function () {
    var matchedArray = [];

    map(function (connection) {
      // filter checked Data Objects
      var checkedDataObjects = filter({ checked: true }, connection.dbSource.querySources);
      matchedArray = concat(checkedDataObjects, matchedArray);
    }, this.sourceConnections);

    this.selectedDataObjects = matchedArray;
  };

  /**
   * re-update sourceConnections for all tenants when master SourceTree changes
   */
  WorkspaceDetail.prototype.updateWorkspaceTenants = m.action(function () {
    map(function (tenant) {
      tenant.readSourceConnections(this.mapppingDatabasesSource);
    }.bind(this), this.workspaceTenants);
  });

  /**
   * Set selected tenant to display advanced copy
   */
  WorkspaceDetail.prototype.setSelectedTenant = m.action(function (tenant, databaseSources) {
    var sourceConnections = tenant && !isEmpty(tenant.sourceConnections) ? tenant.sourceConnections : this.mapppingDatabasesSource;
    var tenantMapping = this.workspaceMappings.filter(function (mapping) {
      return tenant && !!find({
        tenantId: tenant.tenantId
      }, mapping.workspaceMappingTenants);
    }.bind(this));

    tenantMapping = tenantMapping.map(function (mapping) {
      var newMapping = new WorkspaceMapping(mapping, this.mapppingDatabasesSource, databaseSources);
      newMapping.workspaceMappingTenants = filter(function (mappingTenant) {
        return mappingTenant.tenantId === tenant.tenantId;
      }, newMapping.workspaceMappingTenants);

      return newMapping;
    }.bind(this), tenantMapping);

    this.selectedTenant = tenant ? new WorkspaceTenant(tenant, tenantMapping, databaseSources, sourceConnections) : null;

    // Reset alert message
    this.setAlertMessage(commonMessages.EMPTY_MESSAGE);
    return (0, _bluebird.resolve)();
  });

  /**
   * Update work space tenant from advanced copy to master page
   */
  WorkspaceDetail.prototype.updateWorkspaceTenant = m.action(function () {
    var selectedTenant = this.selectedTenant;

    // Find editing workspace tenant first
    var editTenant = find({ tenantId: selectedTenant.tenantId }, this.workspaceTenants);
    // Populate workspace data
    editTenant.poppulateData(selectedTenant);

    // Split mapping item
    var deleteMappings = this.splitMapping();

    for (var i = deleteMappings.length - 1; i >= 0; i--) {
      this.workspaceMappings.splice(deleteMappings[i], 1);
    }

    // Merge mappings from advanced copy to workspace mappings
    var newMappings = this.mergeMapping();
    this.workspaceMappings = this.workspaceMappings.concat(newMappings);

    // Back to main screen
    this.selectedTenant = null;
  });

  /**
   * Merge mapping from advanced copy to global mapping
   */
  WorkspaceDetail.prototype.mergeMapping = m.action(function () {
    var selectedTenant = this.selectedTenant;
    var advancedMappings = selectedTenant.dataMapping;
    var newMappings = [];

    forEach(function (advancedMapping) {
      var matchMapping = filter(function (workspaceMapping) {
        return workspaceMapping.compare(advancedMapping, selectedTenant);
      }, this.workspaceMappings);

      // If match mappings have tenant equal  selected tenant
      var matchSelectedTenant = find(function (mapping) {
        return !!find({ tenantId: selectedTenant.tenantId }, mapping.workspaceMappingTenants);
      }, matchMapping);
      if (matchSelectedTenant) {
        if (matchSelectedTenant.workspaceMappingTenants.length === 1) {
          matchSelectedTenant.toDatabaseName = advancedMapping.toDatabaseName;
          matchSelectedTenant.toObject = advancedMapping.toObject;
        }
        return;
      }

      // Merge to the first item
      if (matchMapping.length > 0 && matchMapping[0]) {
        var workspaceMappingTenant = matchMapping[0].workspaceMappingTenants;
        var existedSelectedTenant = find({ tenantId: selectedTenant.tenantId }, workspaceMappingTenant);
        !existedSelectedTenant && matchMapping[0].addMappingTenant(selectedTenant.tenantId);
      } else {
        advancedMapping.addMappingTenant(selectedTenant.tenantId);
        newMappings.push(new WorkspaceMapping(advancedMapping, this.mapppingDatabasesSource));
      }
    }.bind(this), advancedMappings);

    return newMappings;
  });

  /**
   * Split mapping from advanced copy to global mapping
   */
  WorkspaceDetail.prototype.splitMapping = m.action(function () {
    var selectedTenant = this.selectedTenant;
    var workspaceMappings = this.workspaceMappings;
    var advancedMappings = selectedTenant.dataMapping;
    var deleteMappings = [];

    var globalMappings = workspaceMappings.filter(function (mapping) {
      return selectedTenant && !!find({ tenantId: selectedTenant.tenantId }, mapping.workspaceMappingTenants);
    });

    forEach(function (globalMapping) {
      var existMapping = find(function (advancedMapping) {
        return globalMapping.compare(advancedMapping, selectedTenant);
      }, advancedMappings);

      // If not exist, remove this tenant in list tenant
      if (!existMapping) {
        var globalMappingTenants = globalMapping.workspaceMappingTenants;
        var removedTenant = find({ tenantId: selectedTenant.tenantId }, globalMapping.workspaceMappingTenants);
        if (removedTenant && globalMappingTenants.length === 1) {
          var globalMappingIndex = workspaceMappings.indexOf(globalMapping);
          deleteMappings.push(globalMappingIndex);
        } else if (removedTenant) {
          var removeIndex = globalMappingTenants.indexOf(removedTenant);
          globalMappingTenants.splice(removeIndex, 1);
        }
      }
    }, globalMappings);

    return deleteMappings;
  });

  /**
   * Add new workspace mapping
   */
  WorkspaceDetail.prototype.addWorkspaceMapping = function () {
    var newMappingItem = new WorkspaceMapping();

    this.workspaceMappings.push(newMappingItem);
  };

  /**
   * Get data for saving Workspace Detail
   */
  WorkspaceDetail.prototype.getDataForSave = function (isSaveAs) {
    var cloneWorkspaceTenants = m.toJS(this.workspaceTenants);
    var workspaceDetails = {
      workspace: {
        id: isSaveAs ? null : this.id,
        name: this.name,
        description: this.description,
        tenantId: this.tenantId,
        ownerId: this.ownerId,
        created: this.created || null,
        createdBy: this.createdBy,
        deleted: this.deleted,
        modified: this.modified,
        modifiedBy: this.modifiedBy,
        copyDataModel: this.copyDataModel,
        copyPositionId: this.copyDataModel ? this.copyPositionId : false,
        copyRoles: this.copyRoles,
        copyRolePermission: this.copyRolePermission,
        copyAdvancedSettings: this.copyAdvancedSettings,
        copyTenantPermissions: this.copyTenantPermissions,
        copyDashboard: this.copyDashboard,
        copyReport: this.copyReport,
        mergeDuplicateMappings: this.mergeDuplicateMappings,
        sourceId: this.sourceId,
        sourceHashCode: this.sourceHashCode,
        state: this.state || 0,
        selectAllTenants: this.selectAllTenants,
        workspaceTenants: cloneWorkspaceTenants.map(omit(['sourceConnections', 'destinationConnections'])),
        workspaceMappings: this.workspaceMappings,
        copyOption: this.copyOption,
        copyAdvancedSettingOption: this.copyAdvancedSettingOption,
        copyDashboardOption: this.copyDashboardOption,
        copyReportOption: this.copyReportOption,
        copyTemplateOption: this.copyTemplateOption,
        copyTenantPermissionOption: this.copyTenantPermissionOption,
        copyRolePermissionOption: this.copyRolePermissionOption,
        copiedRoles: this.copyRoles ? this.copiedRoles : [],
        copiedRolePermission: this.copyRolePermission ? this.copiedRolePermission : [],
        allHashcodes: {
          advancedSettings: this.allHashcodes.advancedSettings || '',
          tenantPermission: this.allHashcodes.tenantPermission || '',
          roles: this.allHashcodes.roles || '',
          rolePermissions: this.allHashcodes.rolePermissions || '',
          dashboards: this.allHashcodes.dashboards || '',
          reports: this.allHashcodes.reports || '',
          templates: this.allHashcodes.templates || ''
        },
        sourceDashboards: this.copyDashboard ? this.sourceDashboards.categories : []
      },
      selectedSources: this.omitProperties(this.mapppingDatabasesSource, 'querySourceFields')
    };

    // data for copy reports (user reports & templates)
    if (this.copyReport) {
      workspaceDetails.workspace.sourceReports = m.toJS(get('categories', this.sourceReports));
      workspaceDetails.workspace.sourceTemplates = m.toJS(get('categories', this.sourceTemplates));
    }

    return workspaceDetails;
  };

  /**
   * [getAllDestinationConnection description]
   * @return {Array}
   */
  WorkspaceDetail.prototype.getAllDestinationConnection = function () {
    var destination = [];
    forEach(function (workspace) {
      forEach(function (connection) {
        destination.push(connection.id);
      }, workspace.destinationConnections);
    }.bind(this), this.workspaceTenants);

    return destination;
  };

  /**
   * get matched SourceTree For Run Copy Popup
   * @return {Array} QuerySourceTree
   */
  WorkspaceDetail.prototype.getMatchedSourceTreeForRunCopy = m.action(function (result, isCopyDataModel) {
    var runCopyDataModels = m.toJS(forEach(function (tenant) {
      return forEach(function (destination) {
        return result.indexOf(destination.id) >= 0;
      }, tenant);
    }, this.workspaceTenants));
    // remove tenant with status different with Ready to copy
    if (isCopyDataModel) {
      runCopyDataModels = filter(function (tenant) {
        return tenant.status === constants.STATUS_OF_DESTINATION.READY_TO_COPY;
      }, runCopyDataModels);
    }

    // Set source tree for tenant
    runCopyDataModels.forEach(function (tenant) {
      var querySoure = find({ id: tenant.tenantId }, result);
      if (querySoure) {
        tenant.querySources = querySoure.roles;
      } else {
        tenant.querySources = tenant.destinationConnections;
      }
      tenant.checked = true;
      tenant.name = tenant.tenantName;
      tenant.querySources.forEach(function (querySource) {
        querySource.checked = true;
      });
    });

    // build the data model for run copy source tree
    this.runCopyDataModels = [{
      id: 'all',
      name: 'All',
      checked: true,
      dbSource: {
        querySources: runCopyDataModels
      }
    }];

    return this.runCopyQuerySourceTree;
  });

  /**
   * [getSourceTreeTenantForRunCopy description]
   * @param  {[type]} result [description]
   * @return {[type]}        [description]
   */
  WorkspaceDetail.prototype.getSourceTreeTenantForRunCopy = m.action(function (result) {
    var runCopyDataModels = m.toJS(this.workspaceTenants);

    // Set source tree for tenant
    runCopyDataModels.forEach(function (tenant) {
      if (result.indexOf(tenant.tenantId) >= 0) {
        tenant.checked = true;
        tenant.name = tenant.tenantName;
      }
    });

    // build the data model for run copy source tree
    this.runCopyDataModels = [{
      id: 'all',
      name: 'All',
      checked: true,
      dbSource: {
        querySources: runCopyDataModels
      }
    }];

    return this.runCopyQuerySourceTree;
  });

  /**
   * Get conflicting report tree
   * @param {Object} result
   */
  WorkspaceDetail.prototype.getConflictingDashboardTree = m.action(function (result) {
    this.conflictingDashboardTree = !isEmpty(result) ? {
      name: 'All',
      id: 'All',
      checked: true,
      indeterminate: false,
      tenants: map(getTenants, result)
    } : [];

    function getTenants(tenant) {
      return {
        name: tenant.tenantName,
        id: tenant.tenantId,
        checked: tenant.checked,
        indeterminate: false,
        categories: map(function (category) {
          return new CategoryDetail(category, true);
        }, tenant.categories)
      };
    }

    return this.conflictingDashboardTree;
  });

  /**
   * Get conflicting report tree
   * @param {Object} result
   */
  WorkspaceDetail.prototype.getConflictingReportTree = m.action(function (result) {
    this.conflictingReportTree = !isEmpty(result) ? {
      name: 'All',
      id: 'All',
      checked: true,
      indeterminate: false,
      tenants: map(getTenants, result)
    } : [];

    function getTenants(tenant) {
      return {
        name: tenant.tenantName,
        id: tenant.tenantId,
        checked: tenant.checked,
        indeterminate: false,
        categories: map(function (category) {
          return new CategoryDetail(category);
        }, tenant.categories)
      };
    }

    return this.conflictingReportTree;
  });

  /**
   * omit properties out of dataTree
   * @param [Array]  dataTree
   * @param {String} iteratee
   * @return [Array]
   */
  WorkspaceDetail.prototype.omitProperties = function (selectedDatabases, iteratee) {
    var cloneArr = m.toJS(selectedDatabases);
    cloneArr.map(function (connection) {
      delete connection.querySources;
      nestedOmit(connection.dbSource.querySources);
    });

    function nestedOmit(querySources) {
      map(function (source, index) {
        delete source[iteratee];
        !isEmpty(source.querySources) && nestedOmit(source.querySources);
      }, querySources);
    }
    return cloneArr;
  };

  /**
   * Reset selected tenant
   */
  WorkspaceDetail.prototype.resetSelectedTenant = function () {
    this.selectedTenant = null;
  };

  /**
   * get Data Model For RunCopy
   * @return {[type]}
   */
  WorkspaceDetail.prototype.getDataModelForRunCopy = m.action(function (itemToCopy, onlyGetTenant, selected) {
    forEach(function (tenant) {
      if (onlyGetTenant) {
        this[itemToCopy][tenant.tenantId] = isBoolean(selected) ? selected : tenant.checked;
      } else {
        forEach(function (querySource) {
          this[itemToCopy][querySource.id] = isBoolean(selected) ? selected : querySource.checked;
        }.bind(this), tenant.querySources);
      }
    }.bind(this), this.runCopyDataModels[0].dbSource.querySources);
  });

  /**
   * Get dashboard data for run copy
   * @param {String} option
   * @param {Boolean} cancel
   */
  WorkspaceDetail.prototype.getDataDashboardsForRunCopy = m.action(function (cancel) {
    this.copyDashboardOption = {};
    forEach(function (tenant) {
      forEach(function (category) {
        forEach(function (subCategory) {
          forEach(function (dashboard) {
            this.copyDashboardOption[dashboard.id] = !isNil(cancel) ? false : dashboard.checked;
          }.bind(this), subCategory.dashboards);
        }.bind(this), category.subCategories);
      }.bind(this), tenant.categories);
    }.bind(this), this.conflictingDashboardTree.tenants);
  });

  /**
   * Get report data for run copy
   * @param {String} option
   */
  WorkspaceDetail.prototype.getDataReportsForRunCopy = m.action(function (option, cancel) {
    this[option] = {};
    forEach(function (tenant) {
      forEach(function (category) {
        forEach(function (subCategory) {
          forEach(function (report) {
            this[option][report.id] = !isNil(cancel) ? false : report.checked;
          }.bind(this), subCategory.reports);
        }.bind(this), category.subCategories);
      }.bind(this), tenant.categories);
    }.bind(this), this.conflictingReportTree.tenants);
  });

  /**
   * Find Selected database
   */
  WorkspaceDetail.prototype.findSelectedDatabase = function (fullDBName) {
    var selectedDB = find({ fullDBName: fullDBName }, this.mapppingDatabasesSource);

    return selectedDB;
  };

  /**
   * Find Selected source connection
   */
  WorkspaceDetail.prototype.findSelectedConnection = function (fullDBName) {
    var selectedTenant = this.selectedTenant || {};
    var selectedConnection = find({ fullDBName: fullDBName }, selectedTenant.databaseSources);

    return selectedConnection;
  };

  /**
   * Delete Destination tenant
   */
  WorkspaceDetail.prototype.deleteDestinationTenant = m.action(function (tenant) {
    var deletedIndex = this.workspaceTenants.indexOf(tenant);

    this.workspaceTenants.splice(deletedIndex, 1);

    // Remove item in selected destination
    this.selectedDestinationTenantIDs = flatMap(function (tenant) {
      return tenant.tenantId;
    }, this.workspaceTenants).toString();
    this.selectAllTenants = false;
  });

  /**
   * set sourceId
   */
  WorkspaceDetail.prototype.setSource = m.action(function (sourceId) {
    this.sourceId = sourceId;
    if (this.isSystemSource) {
      this.copyTenantPermissions = false;
      this.copyRoles = false;
      this.copyRolePermission = false;
    }

    this.resetDataSourceForCopy();
  });

  /**
   * populate Roles And Permissions
   * @param  {object}  result
   * @param  {Boolean} isLoadRoles
   */
  WorkspaceDetail.prototype.populateRolesAndPermissions = function (result, isLoadRoles) {
    this.roleList = map(function (role) {
      var savedRole = !!find(function (roleId) {
        return roleId === role.id;
      }, this.copiedRoles);
      return {
        id: role.id,
        name: role.name,
        checked: savedRole
      };
    }.bind(this), result.data);

    this.roleListPermission = map(function (role) {
      var savedRole = !!find(function (roleId) {
        return roleId === role.id;
      }, this.copiedRolePermission);
      return {
        id: role.id,
        name: role.name,
        checked: savedRole
      };
    }.bind(this), result.data);

    this.allHashcodes.roles = result.roleHashcode || '';
    this.allHashcodes.rolePermissions = result.permissionHashcode || '';
  };

  /**
   * select All Role
   * @param  {Boolean}  value
   */
  WorkspaceDetail.prototype.selectAllRole = m.action(function (value) {
    this.copiedRoles = [];
    this.roleList.forEach(function (role) {
      role.checked = value;
      value && this.copiedRoles.push(role.id);
    }.bind(this));
  });

  /**
   * select All Role Permission
   * @param  {Boolean}  value
   */
  WorkspaceDetail.prototype.selectAllRolePermissions = m.action(function (value) {
    this.copiedRolePermission = [];
    this.roleListPermission.forEach(function (item) {
      item.checked = value;
      value && this.copiedRolePermission.push(item.id);
    }.bind(this));
  });

  /**
   * selected Role Copy
   * @param  {string} tenantId
   * @param  {Boolean} value
   */
  WorkspaceDetail.prototype.selectedRoleCopy = m.action(function (listRoles, copiedRoleType, tenantId, value) {
    this[copiedRoleType] = [];
    forEach(function (item) {
      item.id === tenantId ? item.checked = value : null;
      item.checked && this[copiedRoleType].push(item.id);
    }.bind(this), listRoles);
    this.markDirty();
  });

  /**
   * reset Value For Run Copy
   */
  WorkspaceDetail.prototype.resetValueForRunCopy = m.action(function () {
    this.copyOption = {};
    this.copyAdvancedSettingOption = {};
    this.copyDashboardOption = {};
    this.copyReportOption = {};
    this.copyTenantPermissionOption = {};
    this.copyRolePermissionOption = {};
  });

  /**
   * set Can Run Copy Status
   * @param  {boolean} state
   */
  WorkspaceDetail.prototype.setCanRunCopyStatus = m.action(function (state) {
    this.canRunCopy = state;
  });

  /**
   * check Has Selected Conflicting Item Or Not
   * @param  {object} options
   */
  WorkspaceDetail.prototype.checkHasSelectedConflictingItem = function (options) {
    return some(function (item) {
      return item === true;
    }, options);
  };

  /**
   * get checked querySources for re-populating sourceConnections when concurrency occurs
   * @return [Array]
   */
  WorkspaceDetail.prototype.getSelectedQuerySources = function () {
    var selectedQuerySources = {};

    var handleQuerySources = function handleQuerySources(querySources) {
      forEach(function (querySource) {
        if (!querySource.checked) {
          return;
        }

        selectedQuerySources[querySource.id] = querySource.name;

        var querySources = querySource.dbSource ? querySource.dbSource.querySources : querySource.querySources;
        handleQuerySources(querySources);
      }, querySources);
    };

    handleQuerySources(this.sourceConnections);

    return selectedQuerySources;
  };

  /**
   * re-populate checked querySources of current Workspace when concurrency occurs
   * @param {Array} sourceConnections
   * @param {Array} selectedQuerySources
   */
  WorkspaceDetail.prototype.populateCheckedQuerySources = m.action(function (sourceConnections, selectedQuerySources) {
    var handleQuerySources = function handleQuerySources(querySources) {
      forEach(function (querySource) {
        if (selectedQuerySources[querySource.id] === querySource.name) {
          querySource.checked = true;
          var querySources = querySource.dbSource ? querySource.dbSource.querySources : querySource.querySources;
          handleQuerySources(querySources);
        } else {
          return;
        }
      }, querySources);
    };

    handleQuerySources(sourceConnections);

    this.readSourceConnections(sourceConnections);
  });

  /**
   * update value ToObject of tenant after separate mapping from the mainpage
   */
  WorkspaceDetail.prototype.updateMappingData = m.action(function (selectedTenant) {
    selectedTenant = selectedTenant || this.selectedTenant;
    var dataMapping = selectedTenant.dataMapping;

    dataMapping.forEach(function (mappingItem) {
      // For Database type : Disabled dropdown and show database alias name
      if (mappingItem.type === constants.MAPPING_TYPE.Database) {
        var selectedDB = this.findSelectedDatabase(mappingItem.fromDatabaseName);
        if (selectedDB && isEmpty(mappingItem.fromObject)) {
          mappingItem.fromObject = selectedDB.name;
        }

        var selectedToDataSource = find({ fullDBName: mappingItem.toDatabaseName }, selectedTenant.databaseSources);
        if (selectedToDataSource && isEmpty(mappingItem.toObject)) {
          mappingItem.toObject = selectedToDataSource.name;
        }
      }
    }.bind(this));
  });

  /**
   * Set source reports to copy
   * @param  {object} options
   */
  WorkspaceDetail.prototype.setHashCodeForReports = m.action(function (reportHashCode, templateHashCode) {
    this.allHashcodes.reports = reportHashCode;
    this.allHashcodes.templates = templateHashCode;
  });

  /**
   * Get source reports previous
   */
  WorkspaceDetail.prototype.getSourceReportsPrev = m.action(function () {
    this.sourceReportsPrev.push({ id: this.sourceReports.id, checked: this.sourceReports.checked });
    forEach(function (category) {
      this.sourceReportsPrev.push({ id: category.id, checked: category.checked });
      forEach(function (subCategory) {
        this.sourceReportsPrev.push({ id: subCategory.id, checked: subCategory.checked });
        forEach(function (report) {
          this.sourceReportsPrev.push({ id: report.id, checked: report.checked });
        }.bind(this), subCategory.reports);
      }.bind(this), category.subCategories);
    }.bind(this), this.sourceReports.categories);
  });

  /**
   * Get source templates previous
   */
  WorkspaceDetail.prototype.getSourceTemplatesPrev = m.action(function () {
    this.sourceTemplatesPrev.push({ id: this.sourceTemplates.id, checked: this.sourceTemplates.checked });
    forEach(function (category) {
      this.sourceTemplatesPrev.push({ id: category.id, checked: category.checked });
      forEach(function (subCategory) {
        this.sourceTemplatesPrev.push({ id: subCategory.id, checked: subCategory.checked });
        forEach(function (report) {
          this.sourceTemplatesPrev.push({ id: report.id, checked: report.checked });
        }.bind(this), subCategory.reports);
      }.bind(this), category.subCategories);
    }.bind(this), this.sourceTemplates.categories);
  });

  /**
   * Get source dashboards previous
   */
  WorkspaceDetail.prototype.getSourceDashboardsPrev = m.action(function () {
    this.sourceDashboardsPrev.push({ id: this.sourceDashboards.id, checked: this.sourceDashboards.checked });
    forEach(function (category) {
      this.sourceDashboardsPrev.push({ id: category.id, checked: category.checked });
      forEach(function (subCategory) {
        this.sourceDashboardsPrev.push({ id: subCategory.id, checked: subCategory.checked });
        forEach(function (dashboard) {
          this.sourceDashboardsPrev.push({ id: dashboard.id, checked: dashboard.checked });
        }.bind(this), subCategory.dashboards);
      }.bind(this), category.subCategories);
    }.bind(this), this.sourceDashboards.categories);
  });

  /**
   * Reset previous data
   */
  WorkspaceDetail.prototype.resetPrevData = m.action(function () {
    this.sourceReportsPrev = [];
    this.sourceTemplatesPrev = [];
  });

  /**
   * Reset previous data
   */
  WorkspaceDetail.prototype.resetDashboardPrevData = m.action(function () {
    this.sourceDashboardsPrev = [];
  });

  /**
   * Reset previous data
   */
  WorkspaceDetail.prototype.resetDataSourceForCopy = m.action(function () {
    this.resetCopyReportSource();
    this.resetCopyDashboardSource();
  });

  /**
   * Update query source
   */
  WorkspaceDetail.prototype.updateQuerySourceTree = m.action(function () {
    var querySources = this.querySourceTree.querySources;
    var checked = this.copyDataModel;
    forEach(function (querySoure) {
      querySoure.checked = checked;
      forEach(function (dbQuerySource) {
        dbQuerySource.checked = checked;
        forEach(function (qs) {
          qs.checked = checked;
          forEach(function (querySourceField) {
            querySourceField.checked = checked;
          }, qs.querySourceFields);
        }, dbQuerySource.querySources);
      }, querySoure.dbSource.querySources);
    }, querySources);
  });

  /**
   * Set hasd code for dashboard
   * @param  {String} hash code
   */
  WorkspaceDetail.prototype.setHashCodeForDashboards = m.action(function (hashCode) {
    this.allHashcodes.dashboards = hashCode;
  });

  /**
   * reset Workspace Tenants status to need validation
   */
  WorkspaceDetail.prototype.resetWorkspaceTenantsStatus = m.action(function (tenant) {
    var selectedTenant = tenant || this.selectedTenant;
    if (selectedTenant) {
      selectedTenant.setDirty();
      selectedTenant.readSourceConnections(this.mapppingDatabasesSource);
    } else {
      this.workspaceTenants.forEach(function (tenant) {
        tenant.setDirty();
        tenant.readSourceConnections(this.mapppingDatabasesSource);
      }.bind(this));
    }

    this.alertMessage.message = '';
    this.markDirty();
  });

  WorkspaceDetailCopyReport(WorkspaceDetail);

  module.exports = WorkspaceDetail;
}();

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceTenant.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// Workspace Tenant model
!function () {

  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var CopyManagementUtils = __webpack_require__(1157);
  var ObjectStateConstants = __webpack_require__(58);
  var QuerySourceTree = __webpack_require__(623);
  var WorkspaceMapping = __webpack_require__(1158);
  var constants = __webpack_require__(91);

  var _require = __webpack_require__(1),
      map = _require.map,
      has = _require.has,
      forEach = _require.forEach,
      find = _require.find;

  function WorkspaceTenant(data, tenantMapping, databaseSources, sourceConnections) {
    var props = {
      tenantName: '',
      name: '',
      tenantUniqueName: null,
      workspaceId: null,
      tenantId: null,
      status: 0,
      state: ObjectStateConstants.NONE,
      inserted: false,
      version: null,
      created: null,
      createdBy: null,
      modified: null,
      modifiedBy: null,
      destinationHashCode: null,
      dataMapping: [], // Advanced Copy Mapping Grid
      databaseSources: [], // Connection Detail\
      sourceConnections: sourceConnections,
      destinationConnections: [],
      querySourceTree: new QuerySourceTree([], null, true),
      destinationQuerySourceTree: new QuerySourceTree([], null, true)
    };

    m.extendObservable(trackable(this), props);

    data && this.poppulateData(data, tenantMapping, databaseSources, sourceConnections);
    this.resetDirty();
  }

  /**
   * Populate Workspace tenant data
   * @param {type} data
   */
  WorkspaceTenant.prototype.poppulateData = m.action(function (data, tenantMapping, databaseSources, sourceConnections) {
    this.tenantName = data.tenantName || '';
    this.name = data.name || '';
    this.tenantUniqueName = data.tenantUniqueName || null;
    this.workspaceId = data.workspaceId || null;
    this.tenantId = data.tenantId || null;
    this.status = data.status || 0;
    this.state = data.state || ObjectStateConstants.NONE;
    this.inserted = data.inserted || false;
    this.version = data.version || null;
    this.created = data.created || null;
    this.createdBy = data.createdBy || null;
    this.modified = data.modified || null;
    this.modifiedBy = data.modifiedBy || null;
    this.destinationHashCode = data.destinationHashCode;
    this.readDestinationConnections(data.destinationConnections);
    this.readSourceConnections(sourceConnections);

    this.dataMapping = map(function (mappingItem) {
      if (mappingItem.toObject && mappingItem.toObject.indexOf(constants.TENANT_TOKEN) > -1) {
        mappingItem.toObject = mappingItem.toObject.replace(constants.TENANT_TOKEN, this.tenantUniqueName);
      }
      if (mappingItem.toObject && mappingItem.toObject.indexOf(constants.TENANT_NAME_TOKEN) > -1) {
        mappingItem.toObject = mappingItem.toObject.replace(constants.TENANT_NAME_TOKEN, this.name);
      }

      return mappingItem;
    }.bind(this), tenantMapping);

    this.databaseSources = map(function (database) {
      database.fullDBName = String.format('[{0}] {1}', database.serverTypeName, database.databaseName);
      database.databaseTooltip = String.format('{0} - {1} - {2}', database.serverTypeName, database.databaseServer, database.databaseName);
      return database;
    }, databaseSources);
  });

  /**
   * Populate Workspace tenant data
   * @param {type} data
   * @param {Boolean} isDetail - get tenant detail
   */
  WorkspaceTenant.prototype.poppulateDataAfterValidate = m.action(function (data, isDetail) {
    this.status = data.status || 0;
    this.destinationHashCode = data.destinationHashCode;
    !!isDetail && this.readSourceConnections(data.sourceConnections);
    !!isDetail && this.readDestinationConnections(data.destinationConnections);
    this.markDirty();
  });

  /**
   * Read data sources (mostly this data comes from API)
   * @param  {Object} dbSource
   */
  WorkspaceTenant.prototype.readSourceConnections = m.action(function (sourceConnections) {
    forEach(function (connection) {
      // update value for copy report to show/hide connection which has query-object link to copied reports
      !has('belongToCopiedReport', connection) && CopyManagementUtils.updateDataSoucreBasedOnLinkedReport(connection);
    }, sourceConnections);

    this.sourceConnections = sourceConnections;
    this.querySourceTree.setQuerySources(sourceConnections);
  });

  /**
   * Read destinationConnections (mostly this data comes from API)
   * @param  {Object} destinationConnections
   */
  WorkspaceTenant.prototype.readDestinationConnections = m.action(function (destinationConnections) {
    this.destinationConnections = destinationConnections;
    this.destinationQuerySourceTree.setQuerySources(destinationConnections);
  });

  /**
   * Set property value
   * @param {type} property
   * @param {type} value
   */
  WorkspaceTenant.prototype.setPropertyValue = function (property, value) {
    this[property] = value;
    this.setDirty();
  };

  /**
   * Add mapping
   */
  WorkspaceTenant.prototype.addMapping = function () {
    var newMappingItem = new WorkspaceMapping({ workspaceId: this.workspaceId });

    this.dataMapping.push(newMappingItem);
    this.setDirty();
  };

  /**
   * get mapping list for this tenant
   * @param {array} workspaceMappings
   * @param {array} mappings
   */
  WorkspaceTenant.prototype.getMappingsForTenant = function (workspaceMappings) {
    return workspaceMappings.filter(function (mapping) {
      return !!find({ tenantId: this.tenantId }, mapping.workspaceMappingTenants);
    }.bind(this));
  };

  /**
   * Set dirty
   */
  WorkspaceTenant.prototype.setDirty = m.action(function () {
    this.markDirty();
    this.status = 0;
  });

  module.exports = WorkspaceTenant;
}();

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceMappingTenant.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  'use strict';

  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);

  function WorkspaceMappingTenant(data) {
    var props = {
      //State props
      workspaceMappingId: null,
      tenantId: null,
      tenantName: '',
      id: null,
      state: 0,
      inserted: true,
      version: null,
      created: null,
      createdBy: null,
      modified: null,
      modifiedBy: null
    };

    m.extendObservable(trackable(this), props);

    data && this.readMappingTenant(data);
  }

  /**
   * Read mapping tenant data
   * @param {Object} data
   */
  WorkspaceMappingTenant.prototype.readMappingTenant = m.action(function (data) {
    this.workspaceMappingId = data.workspaceMappingId || null;
    this.tenantId = data.tenantId || null;
    this.tenantName = data.tenantName || '';
    this.id = data.id || null;
    this.state = data.state || 0;
    this.inserted = data.inserted || true;
    this.version = data.version || null;
    this.created = data.created || null;
    this.createdBy = data.createdBy || null;
    this.modified = data.modified || null;
    this.modifiedBy = data.modifiedBy || null;
  });

  module.exports = WorkspaceMappingTenant;
}();

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceDetailCopyReport.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var CategoryDetail = __webpack_require__(161);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      some = _require.some,
      forEach = _require.forEach,
      map = _require.map,
      isNil = _require.isNil,
      flow = _require.flow,
      getOr = _require.getOr,
      get = _require.get,
      has = _require.has,
      compact = _require.compact,
      find = _require.find;

  function markCopiedItem(item, flag) {
    item.checked = flag;
  }

  function markCopied(item) {
    markCopiedItem(item, true);
  }

  function unmarkCopied(item) {
    markCopiedItem(item, false);
  }

  module.exports = function (BaseClass) {
    /**
     * Set source reports to copy
     * @param  {object} options
     */
    BaseClass.prototype.setSourceReports = m.action(function (reportList, templateList) {
      // reset current data
      this.resetCopyReportSource();

      var workspace = this;

      // set report list to model
      setData.call(this, reportList, 'sourceReports');
      setData.call(this, templateList, 'sourceTemplates');

      // reaction - [checked] value is changed, search linked query source and update [belongToCopiedReport] value
      this.addActionToReportList(get('categories', this.sourceReports), addActionForCheckedStatus);
      this.addActionToReportList(get('categories', this.sourceTemplates), addActionForCheckedStatus);

      m.observe(this, 'copyReport', function () {
        var sourceReports = get('categories', this.sourceReports);
        var sourceTemplates = get('categories', this.sourceTemplates);

        if (workspace.copyReport) {
          this.addActionToReportList(sourceReports, markCopied, true);
          this.addActionToReportList(sourceTemplates, markCopied, true);
        } else {
          this.addActionToReportList(sourceReports, unmarkCopied, true);
          this.addActionToReportList(sourceTemplates, unmarkCopied, true);
        }

        // update checked of root element
        this.sourceReports.checked = !some({ checked: false }, sourceReports);
        this.sourceTemplates.checked = !some({ checked: false }, sourceTemplates);
      }.bind(this));

      function setData(listData, sourceKey) {
        var categories = map(function (item) {
          return new CategoryDetail(item, true);
        }, listData);
        var checked = !some({ checked: false }, categories);

        this[sourceKey] = !isEmpty(listData) ? {
          name: 'All',
          id: 'All',
          checked: checked,
          indeterminate: false,
          categories: categories
        } : [];
      }

      function addActionForCheckedStatus(report) {
        report.checked && linkToSourceConnection(report);

        // reaction for checked prop
        m.observe(report, 'checked', function (change) {
          linkToSourceConnection(report);
        });
      }

      function linkToSourceConnection(report) {
        var linkedQuerySouces;
        var isChecked = report.checked ? 1 : -1;

        // search linked query source in sourceConnection
        linkedQuerySouces = workspace.findQuerySouceFromConnectionSource(report.reportDataSource);

        linkedQuerySouces.forEach(function (querySource) {
          workspace.updateBelongToCopiedReport(isChecked, querySource);
        });
      }
    });

    BaseClass.prototype.updateBelongToCopiedReport = m.action(function (isChecked, querySouce) {
      if (isNil(querySouce)) {
        return null;
      }

      if (!has('numberLinkedCopiedReports', querySouce)) {
        querySouce.numberLinkedCopiedReports = 0;
      }

      querySouce.numberLinkedCopiedReports += isChecked;
      querySouce.numberLinkedCopiedReports < 0 && (querySouce.numberLinkedCopiedReports = 0);
      querySouce.belongToCopiedReport = querySouce.numberLinkedCopiedReports > 0;
    });

    BaseClass.prototype.findQuerySouceFromConnectionSource = function (querySouceInfos) {
      var sourceConnections = this.sourceConnections;
      var result = map(findQuerySouce, querySouceInfos || []);

      return compact(result);

      function findQuerySouce(querySourceInfo) {
        return flow(find({ id: querySourceInfo.connectionId }), // find based on connectionID

        getOr([], 'dbSource.querySources'), // find based on categories
        find({ id: querySourceInfo.querySourceCategoryId }), getOr([], 'querySources'), // find based on query source object
        find({ id: querySourceInfo.querySourceId }))(sourceConnections);
      }
    };

    BaseClass.prototype.addActionToReportList = function (reportCat, fnAction, isApplyToCat) {
      this.addActionByCategories('reports', reportCat, fnAction, isApplyToCat);
    };

    BaseClass.prototype.addActionByCategories = function (dataKey, categories, fnAction, isApplyToCat) {
      forEach(function (category) {
        // report of category
        takeAction(category);
        isApplyToCat && fnAction(category);

        // report of sub-category
        forEach(function (subCat) {
          takeAction(subCat);
          isApplyToCat && fnAction(subCat);
        }, category.subCategories);
      }, categories);

      function takeAction(category) {
        forEach(fnAction, getOr([], dataKey, category));
      }
    };

    BaseClass.prototype.resetCopyReportSource = function () {
      // unlink current reports to data-model query sources
      var sourceReports = get('categories', this.sourceReports);
      var sourceTemplates = get('categories', this.sourceTemplates);
      sourceReports && this.addActionToReportList(sourceReports, unmarkCopied, true);
      sourceTemplates && this.addActionToReportList(sourceTemplates, unmarkCopied, true);

      this.sourceReports = {};
      this.sourceTemplates = {};
    };

    /**
     * Set source dashboards
     * @param {Object} dashboard list
     * @param {Boolean} For Concurrency
     */
    BaseClass.prototype.setSourceDashboards = m.action(function setSourceDashboards(dashboardList, forConcurrency) {
      // reset current data
      (this.copyDashboard && !this.copyReport || forConcurrency) && this.resetCopyDashboardSource();

      var workspace = this;
      var categories = map(function (item) {
        return new CategoryDetail(item, true);
      }, dashboardList);
      var checked = !some({ checked: false }, categories);

      // asign dashboard source
      this.sourceDashboards = !isEmpty(dashboardList) ? {
        name: 'All',
        id: 'All',
        checked: checked,
        indeterminate: false,
        categories: categories
      } : [];

      // reaction - [checked] value is changed, search linked query source and update [belongToCopiedReport] value
      this.addActionToDashboardList(get('categories', this.sourceDashboards), addActionForCheckedStatus);

      m.observe(this, 'copyDashboard', function () {
        var copyDashboard = this.copyDashboard;

        this.addActionToDashboardList(get('categories', this.sourceDashboards), function (item) {
          item.checked = copyDashboard;
        }, true);

        // update checked of root element
        this.sourceDashboards.checked = !some({ checked: false }, this.sourceDashboards);
      }.bind(this));

      function addActionForCheckedStatus(dashboard) {
        dashboard.checked && linkToSourceConnection(dashboard);

        // reaction for checked prop
        m.observe(dashboard, 'checked', function (change) {
          linkToSourceConnection(dashboard);
        });

        function linkToSourceConnection(dashboard) {
          var isChecked = dashboard.checked ? 1 : -1;
          var linkedQuerySouces;

          dashboard.dashboardParts.forEach(function (dashboardPart) {
            linkedQuerySouces = workspace.findQuerySouceFromConnectionSource(dashboardPart.reportDataSource || []);
            linkedQuerySouces.forEach(function (querySource) {
              workspace.updateBelongToCopiedReport(isChecked, querySource);
            });
          });
        }
      }
    });

    BaseClass.prototype.addActionToDashboardList = function (dashboardCat, fnAction, isApplyToCat) {
      this.addActionByCategories('dashboards', dashboardCat, fnAction, isApplyToCat);
    };

    BaseClass.prototype.resetCopyDashboardSource = function () {
      // unlink current reports to data-model query sources
      var sourceDashboards = get('categories', this.sourceDashboards);
      sourceDashboards && this.addActionToDashboardList(sourceDashboards, unmarkCopied, true);

      this.sourceDashboards = {};
    };
  };
}();

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.StaticDashboardDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var constants = __webpack_require__(73);
  var convertToNumeralFormat = __webpack_require__(294);

  function StaticDashboardDetail(data) {

    var props = {
      id: null,
      name: '',
      type: null,
      previewRecord: 0,
      advancedMode: false,
      allowNulls: false,
      isDistinct: false,
      categoryId: null,
      categoryName: null,
      subCategoryId: null,
      subCategoryName: null,
      tenantId: null,
      description: null,
      createdBy: null,
      createdDate: null,
      modifiedBy: null,
      version: 0,
      numberOfView: 0,
      renderingTime: 0,
      owner: null,
      lastViewed: null,
      state: 0,
      modified: null,
      dateTimeNow: null,
      isShowDetail: false,
      accessPriority: null,
      movable: false,
      deletable: false,
      copyable: false,

      isEmpty: function isEmpty() {
        return this.id === constants.EMPTY_GUID;
      },
      renderingTimeInSeconds: function renderingTimeInSeconds() {
        return convertToNumeralFormat('0.00', this.renderingTime / 1000) + ' s';
      }
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate information.
   * @param  {Object} data
   */
  StaticDashboardDetail.prototype.populateData = m.action(function (data) {
    data = data || {};
    this.id = data.id;
    this.type = data.type;
    this.name = data.name;
    this.previewRecord = data.previewRecord;
    this.advancedMode = data.advancedMode;
    this.allowNulls = data.allowNulls;
    this.isDistinct = data.isDistinct;
    this.categoryId = data.categoryId;
    this.categoryName = data.categoryName;
    this.subCategoryId = data.subCategoryId;
    this.subCategoryName = data.subCategoryName;
    this.tenantId = data.tenantId;
    this.description = data.description;
    this.createdBy = data.createdBy;
    this.createdDate = data.createdDate;
    this.modifiedBy = data.modifiedBy;
    this.version = data.version;
    this.numberOfView = data.numberOfView;
    this.renderingTime = data.renderingTime;
    this.owner = data.owner;
    this.lastViewed = data.lastViewed;
    this.state = data.state;
    this.modified = data.modified;
    this.dateTimeNow = data.dateTimeNow;
    this.isShowDetail = data.isShowDetail || false;
    this.accessPriority = data.accessPriority;
    this.created = data.created;
    this.isGlobal = data.isGlobal;
    this.deletable = data.deletable;
    this.copyable = data.copyable;
    this.movable = data.movable;
  });

  /**
   * Update show/hide status
   * @param  {Boolean} state
   */
  StaticDashboardDetail.prototype.setStateExpanded = function (state) {
    this.isShowDetail = state;
  };

  /**
   * Update name
   * @param  {String} name
   */
  StaticDashboardDetail.prototype.setDashboardName = function (name) {
    this.name = name;
  };

  /**
   * check if this field will be highlighted or not
   * @param {Object} searchType
   * @param {Object} field
   * @returns {Promise}
   */
  StaticDashboardDetail.prototype.isNotHighLight = function (searchType, field) {
    return searchType !== constants.SEARCH_CRITERIA[0].value && searchType !== field;
  };

  /**
   * Set edit mode
   * @param {boolean} isEditMode
   */
  StaticDashboardDetail.prototype.setEditMode = function (isEditMode) {
    this.isEditMode = isEditMode;
  };

  module.exports = StaticDashboardDetail;
}();

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceDashboardDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      map = _require.map;

  var DashboardTile = __webpack_require__(336);

  function WorkspaceDashboardDetail(data) {
    var props = {
      commonFilterFields: [],
      accesses: [],
      subscriptions: [],
      dashboardParts: [],
      name: '',
      description: null,
      categoryId: null,
      categoryName: null,
      subCategoryId: null,
      subCategoryName: null,
      tenantId: null,
      backgroundColor: '',
      imageUrl: null,
      stretchImage: false,
      id: null,
      state: 0,
      inserted: false,
      version: null,
      created: null,
      createdBy: null,
      createdById: null,
      modified: null,
      modifiedBy: null,
      showFilterDescription: true,
      ownerId: '',
      lastViewed: null,
      accessPriority: 1,
      checked: false
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} dashboard detail object
   */
  WorkspaceDashboardDetail.prototype.populateData = m.action(function (data) {
    data = data || {};

    var newParts = map(function (item) {
      return new DashboardTile(item);
    }, data.dashboardParts);

    this.commonFilterFields = data.commonFilterFields;
    this.accesses = data.accesses;
    this.subscriptions = data.subscriptions;
    this.dashboardParts.replace(newParts);

    this.commonFilterFields = data.commonFilterFields;
    this.name = data.name;
    this.description = data.description;
    this.categoryId = data.categoryId;
    this.categoryName = data.categoryName;
    this.subCategoryId = data.subCategoryId;
    this.subCategoryName = data.subCategoryName;
    this.tenantId = data.tenantId;
    this.backgroundColor = data.backgroundColor;
    this.imageUrl = data.imageUrl;
    this.stretchImage = data.stretchImage;
    this.id = data.id;
    this.state = data.state;
    this.inserted = data.inserted;
    this.version = data.version;
    this.created = data.created;
    this.createdBy = data.createdBy;
    this.createdById = data.createdById;
    this.modified = data.modified;
    this.modifiedBy = data.modifiedBy;
    this.showFilterDescription = data.showFilterDescription;
    this.ownerId = data.ownerId;
    this.accessPriority = data.accessPriority;
    this.lastViewed = data.lastViewed;
    this.checked = data.checked;
  });

  module.exports = WorkspaceDashboardDetail;
}();

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPartFilterField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var ObjectStateConstants = __webpack_require__(58);

  var _require = __webpack_require__(1),
      omit = _require.omit;

  function DashboardPartFilterField(data) {
    var props = {
      filterFieldId: null,
      value: null,
      operatorId: null,
      isCommon: true,
      filterField: null,
      configField: null,
      operatorSetting: null,
      displayName: null,
      state: null,
      id: null,
      version: null
    };

    m.extendObservable(trackable(this), props);

    data && this.populateData(data);
  }

  /**
   * Populate information.
   * @param  {Object} data
   */
  DashboardPartFilterField.prototype.populateData = m.action(function (data) {
    this.filterFieldId = data.filterFieldId;
    this.value = data.value;
    this.operatorId = data.operatorId;
    this.isCommon = data.isCommon;
    this.filterField = data.filterField;
    this.displayName = data.displayName;
    this.state = data.state;
    this.id = data.id;
    this.version = data.version;

    this.resetDirty();
  });

  /**
   * Set operator id.
   * @param  {String} id
   */
  DashboardPartFilterField.prototype.setOperatorId = m.action(function (id) {
    this.operatorId = id;
    this.filterField.operatorId = id;

    this.markDirty();
  });

  /**
   * set filter value
   * @method setFilterValue
   * @param  {[type]}       filterValue [description]
   */
  DashboardPartFilterField.prototype.setFilterValue = m.action(function (filterValue) {
    this.value = filterValue;
    this.filterField.value = filterValue;
    this.state === ObjectStateConstants.NONE && (this.state = ObjectStateConstants.UPDATE);

    this.markDirty();
  });

  /**
   * set operatorSetting
   * @method setOperatorSetting
   * @param  {[type]}           operatorSetting [description]
   */
  DashboardPartFilterField.prototype.setOperatorSetting = function (operatorSetting) {
    this.operatorSetting = operatorSetting;

    this.markDirty();
  };

  /**
   * Update state.
   * @param {Number} value
   */
  DashboardPartFilterField.prototype.updateState = function (value) {
    this.state = value;

    this.markDirty();
  };

  /**
   * build data for save
   * @method buildDataForSaving
   * @return {[type]}           [description]
   */
  DashboardPartFilterField.prototype.buildDataForSaving = function () {
    return m.toJS(omit(['configField'], this));
  };

  module.exports = DashboardPartFilterField;
}();

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TitleModel.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var UIConstants = __webpack_require__(34);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      clone = _require.clone;

  /**
   * Title model contain a title input which have text and font settings
   * @constructor
   */


  function TitleModel(data) {
    var props = {
      text: '',
      settings: {
        fontFamily: '',
        fontSize: UIConstants.defaultFontSize,
        fontBold: true,
        fontItalic: false,
        fontUnderline: false,
        fontColor: '',
        fontHighlightColor: '',
        alignment: ''
      }
    };

    m.extendObservable(this, props);

    data && this.populateData(data);
  }

  TitleModel.prototype.populateData = function (data) {
    if (isNil(data)) {
      return;
    }
    m.transaction(function () {
      this.updateText(data.text);
      this.updateSettings(clone(m.toJS(data.settings)));
    }.bind(this));
  };

  /**
   * Update Text
   * @param {string} text
   */
  TitleModel.prototype.updateText = function (text) {
    this.text = text;
  };

  /**
   * Update setting
   * @param {object} settings
   */
  TitleModel.prototype.updateSettings = function (settings) {
    this.settings = settings;
  };

  module.exports = TitleModel;
}();

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var constants = __webpack_require__(50);
  var convertToNumeralFormat = __webpack_require__(294);

  function ReportDetail(data) {
    // do not need to observer
    this.reportDataSource = [];

    var props = {
      id: '0',
      name: '',
      type: constants.CATEGORY_TYPE.REPORT,
      previewRecord: 0,
      advancedMode: false,
      allowNulls: false,
      isDistinct: false,
      categoryId: null,
      categoryName: null,
      subCategoryId: null,
      subCategoryName: null,
      tenantId: null,
      description: null,
      createdBy: null,
      created: null,
      modifiedBy: null,
      version: 0,
      numberOfView: 0,
      renderingTime: 0,
      owner: null,
      lastView: null,
      state: 0,
      modified: null,
      dateTimeNow: null,
      isShowDetail: false,
      lastViewed: null,
      isSubscribeMode: false,
      deletable: true,
      copyable: true,
      movable: true,
      accessPriority: null,
      checked: false,
      indeterminate: false,
      isGlobal: false,
      allowToSave: false,

      isEmpty: function isEmpty() {
        return this.id === constants.EMPTY_GUID;
      },
      renderingTimeInSeconds: function renderingTimeInSeconds() {
        return convertToNumeralFormat('0.00', this.renderingTime / 1000) + ' s';
      }
    };

    m.extendObservable(this, props);

    data && this.populateData(data);
  }

  ReportDetail.prototype.populateData = m.action(function (data) {
    data = data || {};

    this.id = data.id;
    this.type = data.type;
    this.name = data.name;
    this.previewRecord = data.previewRecord;
    this.advancedMode = data.advancedMode;
    this.allowNulls = data.allowNulls;
    this.isDistinct = data.isDistinct;
    this.categoryId = data.categoryId;
    this.categoryName = data.categoryName;
    this.subCategoryId = data.subCategoryId;
    this.subCategoryName = data.subCategoryName;
    this.tenantId = data.tenantId;
    this.description = data.description;
    this.createdBy = data.createdBy;
    this.created = data.created;
    this.modifiedBy = data.modifiedBy;
    this.version = data.version;
    this.numberOfView = data.numberOfView;
    this.renderingTime = data.renderingTime;
    this.owner = data.owner;
    this.lastView = data.lastView;
    this.state = data.state;
    this.modified = data.modified;
    this.dateTimeNow = data.dateTimeNow;
    this.isShowDetail = data.isShowDetail || false;
    this.lastViewed = data.lastViewed;
    this.isEditMode = false;
    this.deletable = data.deletable;
    this.copyable = data.copyable;
    this.movable = data.movable;
    this.accessPriority = data.accessPriority;
    this.checked = data.checked;
    this.isGlobal = data.isGlobal;
    this.allowToSave = data.allowToSave;

    this.reportDataSource = data.reportDataSource;
  });

  ReportDetail.prototype.setStateExpanded = function (state) {
    this.isShowDetail = state;
  };

  ReportDetail.prototype.setReportName = function (name) {
    this.name = name;
  };

  /**
   * check if this field will be highlighted or not
   * @param {Object} searchType
   * @param {Object} field
   * @returns {Promise}
   */
  ReportDetail.prototype.isNotHighLight = function (searchType, field) {
    return searchType !== constants.SEARCH_CRITERIA[0].value && searchType !== field;
  };

  /**
   * Set edit mode
   * @param {boolean} isEditMode
   */
  ReportDetail.prototype.setEditMode = function (isEditMode) {
    this.isEditMode = isEditMode;
  };

  /**
   * Toggle subscribe mode
   */
  ReportDetail.prototype.toggleSubscribeMode = function () {
    this.isSubscribeMode = !this.isSubscribeMode;
  };

  module.exports = ReportDetail;
}();

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="DateFormatter.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Date formatter utility
 */
var Izenda = function () {
  'use strict';

  /**
   * Constructor
   */

  function DateFormatter() {}

  /**
  * Formats the given date by the given pattern in UTC without timezone specific information.<br />
  * Following switches are supported:
  * <ul>
  * <li>yyyy: The year</li>
  * <li>MM: the month</li>
  * <li>dd: the day of month<li>
  * <li>hh: the hour<li>
  * <li>mm: minutes</li>
  * </ul>
  * @param {Date} dateValue the date to format
  * @param {String} formatPattern the format pattern
  * @return {String} formatted date string
  * @static
  */
  DateFormatter.prototype.formatUTCDate = function (dateValue, formatPattern) {
    var day = formatNumber(dateValue.getDate(), 2);
    var month = formatNumber(dateValue.getMonth() + 1, 2);
    var yearLong = formatNumber(dateValue.getFullYear(), 4);
    var yearShort = formatNumber(dateValue.getFullYear().toString().substring(3, 4), 2);
    var year = formatPattern.indexOf("yyyy") > -1 ? yearLong : yearShort;
    var hour = formatNumber(dateValue.getHours(), 2);
    var minute = formatNumber(dateValue.getMinutes(), 2);
    var second = formatNumber(dateValue.getSeconds(), 2);
    var dateString = formatPattern.replace(/dd/g, day).replace(/MM/g, month).replace(/y{1,4}/g, year);
    dateString = dateString.replace(/hh/g, hour).replace(/mm/g, minute).replace(/ss/g, second);
    return dateString;
  };

  /**
   * Add prefix zero (0) to string
   * @param {string} source
   * @param {number} length
   * @returns {string}
   */
  function addZero(source, length) {
    while (source.length < length) {
      source = "0" + source;
    }
    return source;
  }

  /**
   * Format number
   * @param {number} number
   * @param {number} numberOfvarters
   * @returns {string}
   */
  function formatNumber(number, numberOfLetters) {
    var dataString = number.toString();
    return addZero(dataString, numberOfLetters);
  }

  return { DateFormatter: DateFormatter };
}();

module.exports = { DateFormatter: Izenda.DateFormatter };

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceDetailStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      map = _require.map,
      isNil = _require.isNil,
      omit = _require.omit,
      get = _require.get,
      flatMap = _require.flatMap,
      has = _require.has,
      isArray = _require.isArray,
      keys = _require.keys,
      each = _require.each,
      find = _require.find;

  var m = __webpack_require__(5);
  var dataFetcher = __webpack_require__(1156);
  var reportFetcher = __webpack_require__(111);
  var roleSetupFetcher = __webpack_require__(274);
  var connectionStringDataFetcher = __webpack_require__(616);
  var uiState = __webpack_require__(15);
  var constants = __webpack_require__(91);
  var localizer = __webpack_require__(12);
  var dashboardFetcher = __webpack_require__(192);
  var CategoryDetail = __webpack_require__(161);
  var LazyLoadingUtils = __webpack_require__(118);
  var QuerySourceTree = __webpack_require__(623);

  /**
   * It encapsulates the connection detail app logic (side-effect likes API invoke
   * and UI logic)
   * @class WorkspaceDetailStore
   * @param {ConnectionStore} masterStore Connection store
   */
  function WorkspaceDetailStore(masterStore) {
    this.masterStore = masterStore;
    this.onInvalidWorkspace = function (msg) {};

    var props = {
      item: function item() {
        return this.masterStore.item;
      },
      tenantId: function tenantId() {
        return uiState.getTenantId();
      },
      tenantList: function tenantList() {
        return this.masterStore.tenantList;
      }
    };

    m.extendObservable(this, props);
  }
  /**
   * link between store and uiState
   */
  WorkspaceDetailStore.prototype.init = function () {
    uiState.setCheckDirtyFunction(function () {
      return this.item.needConfirmWhenLeaving;
    }.bind(this));
  };

  /**
   * unlink between store and uiState
   */
  WorkspaceDetailStore.prototype.destroy = function () {
    uiState.resetCheckDirtyFunction();
  };

  /**
   * Load connection data by its id from API
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.load = m.action(function (workspaceId) {
    var store = this;
    workspaceId = workspaceId || this.item.id;
    return dataFetcher.getWorkspaceDetail(workspaceId).bind(this).then(m.action(function (workspaceDetail) {
      // Defer notifying changes until reading finished
      return (0, _bluebird.all)([store.item.readDetail(workspaceDetail), store.item.getOriginalTenantList(store.tenantList)]);
    })).then(this.loadDistinctConnections);
  });

  /**
   * load Distinct Connections
   * @return {promise}
   */
  WorkspaceDetailStore.prototype.loadDistinctConnections = m.action(function () {
    var item = this.item;
    var listTenants = flatMap(function (tenant) {
      return tenant.tenantId;
    }, item.workspaceTenants);

    if (!isEmpty(listTenants)) {
      return dataFetcher.loadDistinctConnections(listTenants).then(function (listConnection) {
        isArray(listConnection) && item.readDistinctConnections(listConnection);
        return (0, _bluebird.resolve)('');
      });
    } else {
      return (0, _bluebird.resolve)(true);
    }
  });

  /**
   * Load connection data by its id from API
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.loadSourceConnections = m.action(function (sourceId) {
    var item = this.item;
    return connectionStringDataFetcher.getConnectionDetailInfo(sourceId, true, { defaultChecked: item.copyDataModel }).then(function (result) {
      item.setPropertyValue('sourceHashCode', result.hashCode);
      item.readSourceConnections(result.connections);
      return result;
    });
  });

  /**
   * load Destination Connections
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.loadDestinationConnections = m.action(function (tenantId) {
    var tenant = find({ tenantId: tenantId }, this.item.workspaceTenants) || this.item.selectedTenant;

    if (tenant) {
      var data = {
        tenantId: tenant.tenantId,
        mappings: tenant.dataMapping
      };
      return dataFetcher.loadDestinationConnections(data).then(function (result) {
        if (isNil(result.messages)) {
          tenant.destinationHashCode = result.hashCode;
          tenant.readDestinationConnections(result.connections);
        }
        return null;
      });
    }

    return (0, _bluebird.resolve)();
  });

  /**
   * save workspace detail
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.save = function (isSaveAs) {
    var data = this.item.getDataForSave(isSaveAs);

    return dataFetcher.saveWorkspaceDetail(data).then(function (result) {
      if (!isNil(result.success) && !result.success) {
        return result;
      } else {
        this.masterStore.loadList();
        this.item.readDetail(result);
        this.item.showAlertMessage('success', localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
        return true;
      }
    }.bind(this));
  };

  /**
   * validate Workspace Tenant
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.validateWorkspaceTenant = m.action(function (tenant, isDetail) {
    var item = this.item;
    var selectedTenant = tenant || item.selectedTenant;
    var cloneTenant = m.toJS(selectedTenant);
    var mappings = !!item.selectedTenant ? cloneTenant.dataMapping : cloneTenant.getMappingsForTenant(item.workspaceMappings);

    var data = {
      workspaceTenant: omit(['sourceConnections', 'destinationConnections', 'databaseSources'], cloneTenant),
      mappings: mappings,
      sourceId: item.sourceId,
      sourceHashCode: item.sourceHashCode,
      selectedSources: item.omitProperties(item.mapppingDatabasesSource, 'querySourceFields'),
      selectedReports: m.toJS(get('categories', item.sourceReports)),
      selectedTemplates: m.toJS(get('categories', item.sourceTemplates)),
      selectedDashboards: m.toJS(get('categories', item.sourceDashboards)),
      loadWorkspaceTenantConnections: isDetail
    };

    return dataFetcher.validateWorkspaceTenant(data).then(function (result) {
      if (isNil(result.messages)) {
        selectedTenant.poppulateDataAfterValidate(result.workspaceTenant, isDetail);
      }

      return result;
    }.bind(this));
  });

  /**
   * validate Workspace Tenant
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.goToTenantMode = function (tenant) {
    var item = this.item;

    return connectionStringDataFetcher.getConnectionDetailInfo(tenant.tenantId, false, { removeEmptyParent: false }).then(function (result) {
      return item.setSelectedTenant(tenant, result.connections);
    });
  };

  /**
   * check connection has data model
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.checkConnectionHasDataModel = m.action(function () {
    var data = this.item.getAllDestinationConnection();

    return dataFetcher.checkConnectionHasDataModel(data).then(function (result) {
      // display Run Copy Data Model Popup if result is not empty
      return !isEmpty(result) ? {
        showRunCopyDataModelPopup: true,
        tree: this.item.getMatchedSourceTreeForRunCopy(result, true)
      } : null;
    }.bind(this));
  });

  /**
   * detect Conflicting Advanced Settings
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.detectConflictingAdvancedSettings = m.action(function () {
    var data = this.item.getDataForSave().workspace;

    return dataFetcher.detectConflictingAdvancedSettings(data).bind(this).then(function (result) {
      // display Run Copy Advanced Settings Popup if result is not empty
      return !isEmpty(result) ? {
        showRunCopyAdvancedSettingsPopup: true,
        tree: this.item.getSourceTreeTenantForRunCopy(result)
      } : null;
    });
  });

  /**
   * detect Conflicting Dashboard
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.detectConflictingDashboards = m.action(function () {
    var data = this.item.getDataForSave().workspace;

    return dataFetcher.detectConflictingDashboards(data).bind(this).then(function (result) {
      // display Run Copy Dashboards Popup if result is not empty
      return !isEmpty(result) ? {
        showRunCopyDashboardPopup: true,
        tree: this.item.getConflictingDashboardTree(result)
      } : null;
    });
  });

  /**
   * detect Conflicting Reports
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.detectConflictingReports = m.action(function () {
    var data = this.item.getDataForSave().workspace;

    return dataFetcher.detectConflictingReports(data).bind(this).then(function (result) {
      // display Run Copy Reports Popup if result is not empty
      return !isEmpty(result) ? {
        showRunCopyReportPopup: true,
        tree: this.item.getConflictingReportTree(result)
      } : null;
    });
  });

  /**
   * detect Conflicting Reports
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.detectConflictingTemplates = m.action(function () {
    var data = this.item.getDataForSave().workspace;

    return dataFetcher.detectConflictingTemplates(data).bind(this).then(function (result) {
      // display Run Copy Reports Popup if result is not empty
      return !isEmpty(result) ? {
        showRunCopyTemplatePopup: true,
        tree: this.item.getConflictingReportTree(result)
      } : null;
    });
  });

  /**
   * detect Conflicting Tenant Permissions
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.detectConflictingTenantPermissions = m.action(function () {
    var data = this.item.getDataForSave().workspace;

    return dataFetcher.detectConflictingTenantPermissions(data).bind(this).then(function (result) {
      // display Run Copy Tenant Permission Popup if result is not empty
      return !isEmpty(result) ? {
        showRunCopyTenantPermissionPopup: true,
        tree: this.item.getSourceTreeTenantForRunCopy(result)
      } : null;
    });
  });

  /**
   * detect Conflicting Role Permission
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.detectConflictingRolePermission = m.action(function () {
    var data = this.item.getDataForSave().workspace;

    return dataFetcher.detectConflictingRolePermission(data).bind(this).then(function (result) {
      // display Run Copy Role Permission Popup if result is not empty
      return !isEmpty(result) ? {
        showRunCopyRolePermissionPopup: true,
        tree: this.item.getMatchedSourceTreeForRunCopy(result)
      } : null;
    });
  });

  /**
   * run copy workspace detail
   * @return {Promise} A promise of loading connection data
   */
  WorkspaceDetailStore.prototype.runCopy = function () {
    return dataFetcher.runCopy(this.item.getDataForSave()).then(function (result) {
      if (result.success) {
        this.item.showAlertMessage('success', constants.RUN_COPY_SUCCESS);
        !isEmpty(result.data) && !isEmpty(result.data.destinationHashCodes) && keys(result.data.destinationHashCodes).forEach(function (item) {
          var tenant = find({ tenantId: item }, this.item.workspaceTenants);
          if (tenant) {
            tenant.destinationHashCode = result.data.destinationHashCodes[item];
          }
        }.bind(this));
      } else if (isEmpty(result.messages[0].key)) {
        this.item.showAlertMessage('error', result.messages[0].messages[0]);
      }

      return result;
    }.bind(this));
  };

  /**
   * validate Workspace Name
   * @return {Promise} A promise after validation workspace name
   */
  WorkspaceDetailStore.prototype.validateWorkspaceName = function (name) {
    return dataFetcher.validateWorkspaceName({
      Id: this.item.id,
      Name: name
    });
  };

  /**
   * check Hash Code Source
   */
  WorkspaceDetailStore.prototype.checkHashCodeSource = m.action(function () {
    var sourceId = this.item.sourceId;

    return (0, _bluebird.join)(connectionStringDataFetcher.getConnectionDetailInfo(sourceId, false, {
      defaultChecked: false
    }), this.loadDistinctConnections(), m.action(function (result) {
      this.handleRefreshWorkspace(result);
      if (this.item.copyReport) {
        this.item.getSourceReportsPrev();
        this.item.getSourceTemplatesPrev();
        this.loadReports(sourceId, false);
      }

      if (this.item.copyDashboard) {
        this.item.getSourceDashboardsPrev();
        this.item.resetWorkspaceTenantsStatus();
        this.loadDashboards(sourceId, false);
      }

      return (0, _bluebird.resolve)();
    }.bind(this)));
  });

  /**
   * check Hash Code Destination Workspace Tenant
   * @param  {object} workspaceTenant
   */
  WorkspaceDetailStore.prototype.checkHashCodeDestinaWorkspaceTenant = m.action(function (workspaceTenant) {
    return dataFetcher.loadDestinationConnections({
      tenantId: workspaceTenant.tenantId,
      mappings: workspaceTenant.dataMapping
    }).then(this.handleRefreshWorkspaceTenant.bind(this, workspaceTenant));
  });

  /**
   * handle refresh workspace detail
   * @param  {promise} result
   */
  WorkspaceDetailStore.prototype.handleRefreshWorkspace = m.action(function (result) {
    var selectedTenant = this.item.selectedTenant;
    // check hashcode of every workspace tenant
    if (this.item.sourceHashCode === result.hashCode) {
      return selectedTenant ? this.checkHashCodeDestinaWorkspaceTenant(selectedTenant) : this.item.workspaceTenants.forEach(this.checkHashCodeDestinaWorkspaceTenant.bind(this));
    } else {
      // bind data source connection
      this.item.readSourceConnections(result.connections);
      // reset status list workspace tenant
      return this.item.resetWorkspaceTenantsStatus();
    }
  });

  /**
   * handle Refresh Workspace Tenant
   * @param  {object} workspaceTenant
   * @param  {promise} result
   */
  WorkspaceDetailStore.prototype.handleRefreshWorkspaceTenant = m.action(function (result, workspaceTenant) {
    if (workspaceTenant.destinationHashCode !== result.hashCode) {
      workspaceTenant.setPropertyValue('destinationHashCode', result.hashCode);
      workspaceTenant.readDestinationConnections(result.connections);
      workspaceTenant.setDirty();
    }
  });

  /**
   * handle after Concurrency occur
   */
  WorkspaceDetailStore.prototype.handleAfterConcurrency = m.action(function (detail) {
    var sourceId = this.item.sourceId;
    this.resetHashCodeAfterConcurrency();

    if (this.item.copyRoles || this.item.copyRolePermission) {
      this.loadRolesAndPermissions(sourceId);
    }

    // Workspace Tenant Source Connection Concurrency
    if (!isNil(detail)) {
      if (detail.source === constants.CONCURRENCY_ERROR.SOURCE) {
        // reload destination connection
        this.item.workspaceTenants.forEach(function (item) {
          this.loadDestinationConnections(item.tenantId);
        }.bind(this));
        return (0, _bluebird.all)([connectionStringDataFetcher.getConnectionDetailInfo(sourceId, true, { defaultChecked: false }), this.item.getSelectedQuerySources()]).then(function (results) {
          var dbResult = results[0];
          var selectedQuerySources = results[1];
          this.item.setPropertyValue('sourceHashCode', dbResult.hashCode);
          this.item.populateCheckedQuerySources(dbResult.connections, selectedQuerySources);
          // Refresh data source tree in advanced copy mode
          if (this.item.selectedTenant) {
            this.item.selectedTenant.readSourceConnections(this.item.sourceConnections);
            this.item.selectedTenant.setDirty();
          } else {
            this.item.resetWorkspaceTenantsStatus();
          }
        }.bind(this)).then(function () {
          this.loadReportAfterConcurrency();
          this.loadDashboardAfterConcurrency();

          return (0, _bluebird.resolve)();
        }.bind(this));
      } else {
        // reset tenant to need validation
        var tenant = find({ tenantId: detail.tenantId }, this.item.workspaceTenants);
        tenant && tenant.setDirty();
        // Workspace Tenant Destination Connection Concurrency
        this.loadReportAfterConcurrency();
        this.loadDashboardAfterConcurrency();
        return this.loadDestinationConnections(detail.tenantId);
      }
    } else {
      this.loadReportAfterConcurrency();
      this.loadDashboardAfterConcurrency();
      return (0, _bluebird.resolve)(true);
    }
  });

  /**
   * Load reports after concurrency
   */
  WorkspaceDetailStore.prototype.loadReportAfterConcurrency = m.action(function () {
    if (this.item.copyReport) {
      this.item.getSourceReportsPrev();
      this.item.getSourceTemplatesPrev();
      this.item.resetWorkspaceTenantsStatus();
      this.loadReports(this.item.sourceId, false);
    }
  });

  /**
   * Load dashboards after concurrency
   */
  WorkspaceDetailStore.prototype.loadDashboardAfterConcurrency = m.action(function () {
    if (this.item.copyDashboard) {
      this.item.getSourceDashboardsPrev();
      this.item.resetWorkspaceTenantsStatus();
      this.loadDashboards(this.item.sourceId, false, true);
    }
  });

  /**
   * reset Hash Code After Concurrency
   */
  WorkspaceDetailStore.prototype.resetHashCodeAfterConcurrency = m.action(function () {
    this.item.allHashcodes.advancedSettings = '';
    this.item.allHashcodes.tenantPermission = '';
  });

  /**
   * load Roles And Permissions
   * @param  {string} sourceId
   * @return {promise}
   */
  WorkspaceDetailStore.prototype.loadRolesAndPermissions = function (sourceId) {
    var workspaceDetail = this.item;
    var tenantId = sourceId || workspaceDetail.sourceId;
    tenantId = tenantId !== constants.systemSource.id ? tenantId : null;

    return roleSetupFetcher.getRoleList(tenantId, true).then(m.action(function getRolesAndPermissions(result) {
      workspaceDetail.populateRolesAndPermissions(result);
      return result;
    }));
  };

  /**
   * Load report
   * @return {Object} promise
   */
  WorkspaceDetailStore.prototype.loadReports = function (sourceId, defaultChecked) {
    var workspaceDetail = this.item;

    return (0, _bluebird.join)(reportFetcher.loadReportCategories({ tenantId: sourceId, type: 0, defaultChecked: defaultChecked, includeGlobalCategory: false }, true), reportFetcher.loadReportCategories({ tenantId: sourceId, type: 1, defaultChecked: defaultChecked, includeGlobalCategory: false }, true), m.action(function (reportList, templateList) {
      workspaceDetail.setSourceReports.call(workspaceDetail, reportList.data, templateList.data);
      workspaceDetail.setHashCodeForReports.call(workspaceDetail, reportList.hashcode, templateList.hashcode);
    }));
  };

  /**
   * Load dashboard
   * @param {String} sourceId
   * @param {Boolean} defaultChecked
   * @param {Boolean} forConcurrency
   * @return {Object} promise
   */
  WorkspaceDetailStore.prototype.loadDashboards = function (sourceId, defaultChecked, forConcurrency) {
    return dashboardFetcher.loadDashboardCategories({
      tenantId: sourceId,
      defaultChecked: defaultChecked,
      includeDashboardPart: true,
      IncludeGlobalCategory: false
    }, true).bind(this).then(m.action(function (dashboard) {
      this.item.setSourceDashboards(dashboard.data, forConcurrency);
      this.item.setHashCodeForDashboards(dashboard.hashcode);
    }));
  };

  WorkspaceDetailStore.prototype.loadReportsForCopy = function () {
    var workspaceDetail = this.item;
    var sourceId = workspaceDetail.sourceId;

    // if report list already loaded >> do nothing
    if (has('categories', workspaceDetail.sourceReports) && has('categories', workspaceDetail.sourceTemplates)) {
      return (0, _bluebird.resolve)();
    }

    return this.loadReports(sourceId, true);
  };

  WorkspaceDetailStore.prototype.lazyLoadingReports = m.action(function (pageInfo) {
    var workspaceDetail = this.item;

    return reportFetcher.lazyLoadingReports({
      tenantId: workspaceDetail.sourceId,
      isUncategorized: false,
      criterias: [{ key: 'CategoryId' }],
      skipItems: pageInfo.fromIndex,
      pageSize: pageInfo.pageSize,
      parentIds: pageInfo.parentIds,
      defaultChecked: true
    }, true).then(m.action(function (result) {
      var listData = result.data;
      if (!isEmpty(listData)) {
        var categories = map(function (item) {
          return new CategoryDetail(item, true);
        }, listData);

        isEmpty(workspaceDetail.fakeReports) && (workspaceDetail.fakeReports = {
          name: 'All',
          id: 'All',
          numOfCheckedChilds: result.numOfCheckedChilds,
          numOfChilds: result.numOfChilds,
          checked: true,
          indeterminate: false,
          categories: []
        });

        workspaceDetail.isLastPage = result.isLastPage;
        LazyLoadingUtils.concatTree(workspaceDetail.fakeReports.categories, categories, constants.REPORT_LIST_CONCAT_TREE_MAP, result.numOfChilds, []);
        workspaceDetail.treeReports = LazyLoadingUtils.parseToTree([workspaceDetail.fakeReports], constants.REPORT_LIST_TREE_MAP);
      }
    }.bind(this)));
  });

  /**
   * Load data source (lazy)
   * @param {Object} pageInfo
   */
  WorkspaceDetailStore.prototype.loadLazyDataSources = m.action(function (pageInfo) {
    var workspaceDetail = this.item;
    var SourceTypeDefinitions = constants.SOURCE_TYPE_DEFINITIONS;

    /**
     * Create query source object.
     * @param {String} prefixId
     * @param {String} type
     */
    function createQuerySourceTypeObject(prefixId, type) {
      return [{
        id: prefixId + type,
        name: type,
        numOfCheckedChilds: 0,
        numOfChilds: 0,
        checked: false,
        indeterminate: false,
        items: []
      }];
    }

    /**
     * Create query source objects.
     * @param {Object} schema
     */
    function createQuerySourceTypeObjects(schema) {
      each(function (item) {
        !schema[item.CollectionKey] && (schema[item.CollectionKey] = createQuerySourceTypeObject(schema.id, item.Key));
      }, SourceTypeDefinitions);
    }

    /**
     * Update query source object.
     * @param {Object} schema
     * @param {String} type
     */
    function updateQuerySourceTypeObject(schema, type) {
      var collection = schema[type];
      var info = collection[0];
      var config = find({
        CollectionKey: type
      }, SourceTypeDefinitions);

      config && (info.numOfChilds = schema[config.totalChildrenKey]);
      config && (info.numOfCheckedChilds = schema[config.numOfCheckedChildren]);
      // info.numOfCheckedChilds =  filter({
      //   checked: true
      // }, info.items).length;
      info.indeterminate = info.numOfChilds !== 0 && info.numOfChilds != info.numOfCheckedChilds && info.numOfCheckedChilds > 0;
    }

    /**
     * Update query source objects
     * @param {Object} schema
     */
    function updateQuerySourceTypeObjects(schema) {
      each(function (item) {
        updateQuerySourceTypeObject(schema, item.CollectionKey);
      }, SourceTypeDefinitions);
    }

    /**
     * Transform connections to display on lazy tree.
     * @param {Array} connections
     */
    function transformConnections(connections) {
      for (var i = 0; i < connections.length; i++) {
        // move out schema from dbSource
        connections[i].querySources = connections[i].dbSource.querySources;

        // loop schemas
        var schemas = connections[i].querySources;
        for (var j = 0; j < schemas.length; j++) {
          var schema = schemas[j];
          var querySources = schema.querySources;

          createQuerySourceTypeObjects(schema);

          for (var k = 0; k < querySources.length; k++) {
            var item = querySources[k];
            var config = find({
              Key: item.type
            }, SourceTypeDefinitions);
            config && schema[config.CollectionKey][0].items.push(item);
          }

          updateQuerySourceTypeObjects(schema);
        }
      }
      return connections;
    }

    return connectionStringDataFetcher.getLazyConnectionDetailInfo({
      tenantId: workspaceDetail.sourceId,
      defaultChecked: workspaceDetail.copyDataModel,
      loadField: false,
      pageIndex: pageInfo.pageIndex,
      pageSize: pageInfo.pageSize
    }).then(m.action(function (result) {
      if (!isEmpty(result.connections)) {
        !workspaceDetail.fakeDataModels.connections && (workspaceDetail.fakeDataModels.connections = []);
        var querySourceTree = new QuerySourceTree(result.connections);
        var connections = transformConnections(querySourceTree.querySources);

        LazyLoadingUtils.concatTree(workspaceDetail.fakeDataModels.connections, connections, constants.DATE_MODEL_CONCAT_TREE_MAP);
        workspaceDetail.isLastPageOfDataModel = result.isLastPage;
        workspaceDetail.treeDataModels = LazyLoadingUtils.parseToTree(workspaceDetail.fakeDataModels.connections, constants.DATE_MODEL_TREE_MAP);
      }
    }));
  });

  module.exports = WorkspaceDetailStore;
}();

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2427);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2429);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2436);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(27);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMapping.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Database Mapping component
 */
var DatabaseMapping = function (_Component) {
  (0, _inherits3.default)(DatabaseMapping, _Component);

  function DatabaseMapping() {
    (0, _classCallCheck3.default)(this, DatabaseMapping);
    return (0, _possibleConstructorReturn3.default)(this, (DatabaseMapping.__proto__ || (0, _getPrototypeOf2.default)(DatabaseMapping)).apply(this, arguments));
  }

  (0, _createClass3.default)(DatabaseMapping, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.initial(this.props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.destroy(this.props.store);
    }
  }, {
    key: 'render',
    value: function render() {
      var store = this.props.store;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-DatabaseMapping u_fullHeight u-posRelative' },
        _react2.default.createElement(_Izenda2.default, { store: store }),
        _react2.default.createElement(
          'div',
          { className: 'u_fullHeight u_paddingLeftRight' },
          _react2.default.createElement(
            _Izenda8.default,
            null,
            _react2.default.createElement(_Izenda6.default, { store: store })
          )
        )
      );
    }
  }]);
  return DatabaseMapping;
}(_react.Component);

exports.default = (0, _Izenda10.default)(_Izenda4.default)(DatabaseMapping);
module.exports = exports['default'];

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Action Bar component
 */
!function () {
  var React = __webpack_require__(0);
  var MobxPropTypes = __webpack_require__(10).propTypes;
  var connect = __webpack_require__(2);
  var Button = __webpack_require__(30);
  var Alert = __webpack_require__(61);
  var GridLayout = __webpack_require__(13);

  var _require = __webpack_require__(1),
      getOr = _require.getOr;

  var actions = __webpack_require__(2428);

  var ActionBar = function ActionBar(props) {
    var localization = props.localization;
    var responseMessage = getOr(null, 'responseMessage', props.store);

    return React.createElement(
      GridLayout,
      { className: 'u_paddingBottom' },
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: '7' },
          responseMessage && React.createElement(
            Alert,
            { className: 'u_floatLeft u_marginLeft', type: responseMessage.type },
            responseMessage.message
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '5' },
          React.createElement(Button, {
            label: localization.getText('COMMON_LABEL_CANCEL'),
            className: 'u_marginLeftRight u_floatRight',
            onClick: props.onCancel
          }),
          React.createElement(Button, {
            label: localization.getText('COMMON_LABEL_SAVE'),
            className: 'u_marginLeft u_floatRight',
            onClick: props.onSave
          }),
          React.createElement(Button, {
            label: localization.getText('DATABASE_MAPPING_BUTTON_ADD_MAPPING'),
            className: 'u_marginLeft u_floatRight',
            onClick: props.onAddMapping
          })
        )
      )
    );
  };

  ActionBar.propTypes = {
    store: MobxPropTypes.observableObject
  };

  module.exports = connect(actions)(ActionBar);
}();

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBarActions.js" company="Izenda">
// Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var pure = __webpack_require__(9).pure;
  var withHandlers = __webpack_require__(9).withHandlers;
  var localization = __webpack_require__(12);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var actionBarActions = compose(pure, withHandlers({
    onSave: curry(onSave),
    onCancel: curry(onCancel),
    onAddMapping: curry(onAddMapping)
  }));

  /**
   * Handle on save database mapping.
   * @param {Object} props
   * @param {Object} e
   */
  function onSave(props, e) {
    var valManager = props.validation;
    var loader = props.loader;
    var store = props.store;

    if (!store.databaseMappingDetail.checkDirty()) {
      store.setAlertDetail('success', localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
      return;
    }

    store.databaseMappingDetail.resetMessage();

    valManager.validate().then(function (success) {
      if (success) {
        return store.saveDataMapping();
      }
    }).finally(loader.endLoading.bind(loader));
  }

  /**
   * Handle on cancel database mapping.
   * @param {Object} props
   * @param {Object} e
   */
  function onCancel(props, e) {
    var store = props.store;
    var confirmFn = props.confirmFn;
    handleErrorValidation(props);

    if (store.databaseMappingDetail.checkDirty()) {
      confirmFn('Confirmation', {
        description: localization.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
      }).then(function () {
        store.loadDataMapping();
      });
    }
  }

  /**
   * Add mapping handler.
   * @param {Object} props
   * @param {Object} e
   */
  function onAddMapping(props, e) {
    handleErrorValidation(props);
    props.store.addMapping();
  }

  /**
   * Handle error validations when user makes an action.
   * @param {Object} props
   */
  function handleErrorValidation(props) {
    props.validation.reset();
  }

  module.exports = actionBarActions;
}();

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingActions.js" company="Izenda">  
// Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var pure = __webpack_require__(9).pure;
  var withProps = __webpack_require__(9).withProps;
  var withHandlers = __webpack_require__(9).withHandlers;

  var DatabaseMappingStore = __webpack_require__(2430);

  var databaseMappingActions = compose(pure, withProps(function () {
    return {
      store: new DatabaseMappingStore()
    };
  }), withHandlers({
    initial: initial,
    destroy: destroy
  }));

  /**
   * Initial store.
   */
  function initial() {
    return function (props) {
      var loader = props.loader;
      var store = props.store;

      loader.startLoading();
      return store.init().finally(loader.endLoading.bind(loader));
    };
  }

  /**
   * Handle before leave page.
   */
  function destroy() {
    return function (store) {
      store.destroy();
    };
  }

  module.exports = databaseMappingActions;
}();

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Database Mapping Store
 */
!function () {
  var m = __webpack_require__(5);
  var uiState = __webpack_require__(15);
  var fetcher = __webpack_require__(2431);
  var tenantFetcher = __webpack_require__(278);

  var MappingTenant = __webpack_require__(1160);
  var DatabaseMappingDetail = __webpack_require__(2432);
  var ResponseMessage = __webpack_require__(2434);
  var constants = __webpack_require__(337);
  var LazySelectDataSource = __webpack_require__(2435);
  var MAPPING_TYPE = constants.MAPPING_TYPE;
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      forEach = _require.forEach,
      map = _require.map,
      isNil = _require.isNil,
      concat = _require.concat,
      sortBy = _require.sortBy,
      first = _require.first,
      getOr = _require.getOr,
      find = _require.find;

  function DatabaseMappingStore() {
    this.typeOptions = constants.MAPPING_TYPES;
    m.extendObservable(this, {
      originalTenants: [], // Collection of MappingTenant
      fromDatabaseNameDataSource: new LazySelectDataSource(constants.DATABASE_NAME_OPTION_MAPPINGS, constants.DATABASE_NAME_KEY),
      toDatabaseNameDataSource: new LazySelectDataSource(constants.DATABASE_NAME_OPTION_MAPPINGS, constants.DATABASE_NAME_KEY),
      objectDataSources: [], // { id: constants.DATABASE_NAME_KEY, value: LazySelectDataSource }
      databaseMappingDetail: new DatabaseMappingDetail(),
      responseMessage: new ResponseMessage(), // Object of ResponseMessage

      mappingTenants: function mappingTenants() {
        // data source for mapping drop down.
        return concat([constants.ALL_MAPPINGS_OPTION], sortBy(['tenantId'], this.originalTenants));
      },
      tenantOptions: function tenantOptions() {
        // data source for mapping select component.
        return concat([constants.ALL_TENANT_OPTION], sortBy(['tenantId'], this.originalTenants));
      }
    });
  }

  /**
   * Initial database mapping.
   * Static collections, load mapping detail
   */
  DatabaseMappingStore.prototype.init = m.action(function init() {
    uiState.setCheckDirtyFunction(function () {
      return this.databaseMappingDetail.checkDirty();
    }.bind(this));

    return (0, _bluebird.join)(tenantFetcher.getAllNameTenantList(), this.loadDatabaseNames(true), this.loadDatabaseNames(false), this.loadDataMapping(), function (tenantList) {
      this.originalTenants = map(function (item) {
        return new MappingTenant(item);
      }, tenantList);

      if (isNil(this.databaseMappingDetail.selectedTenantId)) {
        this.databaseMappingDetail.setPropertyValue('selectedTenantId', constants.ALL_TENANT_ID, true);
      }
    }.bind(this));
  });

  /**
   * Unlink between store and uiState
   */
  DatabaseMappingStore.prototype.destroy = function () {
    uiState.resetCheckDirtyFunction();
    this.databaseMappingDetail.destroy();
  };

  /**
   * Load database names (lazy loading)
   * @param {Boolean} isFrom
   * @param {Object} pageInfo
   */
  DatabaseMappingStore.prototype.loadDatabaseNames = function (isFrom, pageInfo) {
    var dataSource = isFrom ? this.fromDatabaseNameDataSource : this.toDatabaseNameDataSource;
    var request = {
      skipItems: pageInfo ? pageInfo.fromIndex : dataSource.skipItems,
      pageSize: pageInfo ? pageInfo.pageSize : dataSource.pageSize,
      loadFromDatabase: isFrom
    };

    return fetcher.loadDatabaseNames(request).bind(this).then(function (response) {
      var detail = {
        skipItems: response.skipItems,
        pageSize: response.pageSize,
        isLastPage: response.isLastPage,
        items: response.result
      };
      return dataSource.setDetail(detail);
    });
  };

  /**
   * Load objects (lazy loading)
   * @param {Object} mappingItem
   * @param {Object} pageInfo
   */
  DatabaseMappingStore.prototype.loadObjects = m.action(function loadObjects(mappingItem, pageInfo) {
    var databaseServer = mappingItem.fromServer;
    var fromDatabaseName = mappingItem.fromDatabaseName;
    var optionFromDatabaseNameValue = mappingItem.optionFromDatabaseNameValue;
    var type = mappingItem.type;
    var request, objects;

    var matchingDataSource = find(function (item) {
      return item.id === optionFromDatabaseNameValue;
    }, this.objectDataSources);

    if (isNil(matchingDataSource)) {
      matchingDataSource = m.observable({
        id: optionFromDatabaseNameValue,
        schemaObjects: new LazySelectDataSource(constants.OBJECT_OPTION_MAPPINGS, constants.OBJECT_KEY),
        databaseObject: new LazySelectDataSource(constants.OBJECT_OPTION_MAPPINGS, constants.OBJECT_KEY)
      });

      this.objectDataSources.push(matchingDataSource);
    }

    objects = type === MAPPING_TYPE.Schema ? matchingDataSource.schemaObjects : matchingDataSource.databaseObject;

    request = {
      skipItems: pageInfo ? pageInfo.fromIndex : objects.skipItems,
      pageSize: pageInfo ? pageInfo.pageSize : objects.pageSize,
      databaseServer: databaseServer,
      databaseName: fromDatabaseName,
      type: type
    };

    var setFirstOption = function setFirstOption() {
      var value;
      if (MAPPING_TYPE.Database === type) {
        var firstDatabase = first(objects.items);
        value = firstDatabase && firstDatabase[constants.OBJECT_KEY];
        mappingItem.setPropertyValue('fromObject', value);
      }
      mappingItem.setPropertyValue('fromObject', value);
    };

    return fetcher.loadObjects(request).then(function (response) {
      var detail = {
        skipItems: response.skipItems,
        pageSize: response.pageSize,
        isLastPage: response.isLastPage,
        items: response.result
      };
      objects.setDetail(detail);
      setFirstOption();
    });
  });

  /**
   * Get object data source.
   * @param {String} databaseName
   */
  DatabaseMappingStore.prototype.getObjectDataSource = function (databaseName) {
    return find(function (item) {
      return item.id === databaseName;
    }, this.objectDataSources);
  };

  /**
   * Add a new mapping.
   */
  DatabaseMappingStore.prototype.addMapping = function () {
    var firstDatabase = first(this.fromDatabaseNameDataSource.items);
    var databaseName = firstDatabase && firstDatabase.labelField;
    var server = firstDatabase && firstDatabase.databaseServer;

    this.databaseMappingDetail.addMapping(server, databaseName);
  };

  /**
   * Set alert detail.
   * @param {Object} type
   * @param {Object} message
   */
  DatabaseMappingStore.prototype.setAlertDetail = function (type, message) {
    this.responseMessage = new ResponseMessage(type, message);
  };

  /**
   * Load database mapping.
   */
  DatabaseMappingStore.prototype.loadDataMapping = function () {
    return fetcher.loadDataMapping().bind(this).then(function (response) {
      var success = getOr(true, 'success', response);
      if (success) {
        this.databaseMappingDetail.populate(response);
      }
    });
  };

  /**
   * Save database mapping.
   */
  DatabaseMappingStore.prototype.saveDataMapping = m.action(function () {
    this.databaseMappingDetail.mergeMappings();
    var request = this.databaseMappingDetail.buildDataForSaving();
    return fetcher.saveDataMapping(request).bind(this).then(function (response) {
      if (response.success) {
        this.setAlertDetail('success', localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
        this.databaseMappingDetail.resetDirty();
        return this.loadDataMapping();
      } else {
        forEach(function (message) {
          var index = message.key;
          var info = message.messages[0];
          this.databaseMappingDetail.setMappingError(index, info);
        }.bind(this), response.messages);
      }
    });
  });

  module.exports = DatabaseMappingStore;
}();

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(70);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_URL = 'DataModel/'; // ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Database Mapping Fetcher.
 */

exports.default = {
  /**
   * Load Database names
   * @param {Object} request
   */
  loadDatabaseNames: function loadDatabaseNames(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadDatabaseNames').post(request);
  },


  /**
   * Load objects
   * @param {Object} request
   */
  loadObjects: function loadObjects(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'loadDatabaseObjects').post(request);
  },


  /**
   * Save data mapping
   * @param {Object} request
   */
  saveDataMapping: function saveDataMapping(request) {
    return (0, _Izenda2.default)(ROOT_URL + 'databaseMapping').post(request);
  },


  /**
   * Load data mapping
   */
  loadDataMapping: function loadDataMapping() {
    return (0, _Izenda2.default)(ROOT_URL + 'databaseMapping').get();
  }
};
module.exports = exports['default'];

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var ObjectStateConstants = __webpack_require__(58);
  var constants = __webpack_require__(337);
  var DatabaseMapping = __webpack_require__(2433);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      some = _require.some,
      forEach = _require.forEach,
      map = _require.map,
      isNil = _require.isNil,
      isEqual = _require.isEqual,
      flow = _require.flow,
      uniqBy = _require.uniqBy,
      flatten = _require.flatten,
      concat = _require.concat,
      uniq = _require.uniq,
      find = _require.find;

  function DatabaseMappingDetail(data) {
    var props = {
      mappings: [], // Collection of DatabaseMapping
      doesMergeDuplicate: false,
      selectedTenantId: null,
      selectedMappings: function selectedMappings() {
        var result;
        if (isEqual(constants.ALL_TENANT_ID, this.selectedTenantId)) {
          result = this.mappings;
        } else {
          result = filter(function (item) {
            return item.hasTenant(this.selectedTenantId);
          }.bind(this), this.mappings);
        }

        return filter(function (item) {
          return !item.checkState(ObjectStateConstants.DELETE);
        }, result);
      },
      doesShowMergeDuplicateMapping: function doesShowMergeDuplicateMapping() {
        return constants.ALL_TENANT_ID === this.selectedTenantId;
      }
    };

    m.extendObservable(trackable(this), props);
    data && this.populate(data);

    this.disposeObserveMergeDuplicate = m.observe(this, 'doesMergeDuplicate', function () {
      this.mergeMappings();
    }.bind(this));

    this.resetDirty();
  }

  /**
   * Clean.
   */
  DatabaseMappingDetail.prototype.destroy = function () {
    this.disposeObserveMergeDuplicate();
  };

  /**
   * Populate data.
   * @param {Object} data
   */
  DatabaseMappingDetail.prototype.populate = m.action(function populate(data) {
    this.mappings.clear();
    forEach(function (item) {
      this.mappings.push(new DatabaseMapping(item));
    }.bind(this), data);
  });

  /**
   * Delete a mapping.
   * @param {String} id
   */
  DatabaseMappingDetail.prototype.deleteMapping = m.action(function deleteMapping(id) {
    var mapping = find({
      id: id
    }, this.mappings);

    if (isNil(mapping)) {
      return;
    }

    if (mapping.isNew()) {
      this.mappings.remove(mapping);
      this.markDirty();
    } else {
      mapping.setPropertyValue('state', ObjectStateConstants.DELETE);
    }
  });

  /**
   * Add a new mapping.
   */
  DatabaseMappingDetail.prototype.addMapping = m.action(function addMapping(fromServer, fromDatabaseName) {
    this.mappings.unshift(new DatabaseMapping({
      tenants: [constants.ALL_TENANT_ID],
      state: ObjectStateConstants.INSERT,
      fromServer: fromServer,
      fromDatabaseName: fromDatabaseName
    }));
    this.markDirty();
  });

  /**
   * Update value of property.
   * @param {String} key
   * @param {Object} value
   */
  DatabaseMappingDetail.prototype.setPropertyValue = m.action(function updatePropertyValue(key, value, donotSetDirty) {
    this[key] = value;
    !donotSetDirty && this.markDirty();
  });

  /**
   * Check dirty status.
   */
  DatabaseMappingDetail.prototype.checkDirty = function () {
    if (this.isDirty) {
      return this.isDirty;
    }

    var result = false;
    forEach(function (item) {
      if (item.isDirty) {
        result = item.isDirty;
        return false;
      }
    }, this.mappings);

    return result;
  };

  /**
   * Calculate data for saving.
   */
  DatabaseMappingDetail.prototype.buildDataForSaving = function () {
    return flow(map(function (item) {
      return item.buildDataForSaving();
    }), filter(function (item) {
      return item.state !== ObjectStateConstants.NONE;
    }))(this.mappings);
  };

  /**
   * Merge mappings
   */
  DatabaseMappingDetail.prototype.mergeMappings = m.action(function mergeMappings() {
    if (!this.doesMergeDuplicate || this.mappings.length <= 1) return;

    var pureMappings = this.mappings.peek();
    var distinctMappings = uniqBy('hashValue', this.mappings.peek());

    var prepareMappings = m.action(function () {
      forEach(function (item) {
        var matchingItems = flow(filter(function (mapping) {
          return item.hashValue === mapping.hashValue;
        }), map(function (item) {
          return item.tenants.peek();
        }), flatten, concat(item.tenants.peek()), uniq)(pureMappings);

        var doesHasAllTenant = some(function (item) {
          return constants.ALL_TENANT_ID === item;
        }, matchingItems);
        doesHasAllTenant && (matchingItems = [constants.ALL_TENANT_ID]);

        item.tenants = matchingItems;
      }, distinctMappings);
    });

    var merge = m.action(function () {
      var doesNeedToSetDirty = false;
      var i = this.mappings.length - 1;
      for (; i >= 0; i--) {
        var matchItem = find(function (item) {
          return this.mappings[i].id === item.id;
        }.bind(this), distinctMappings);

        if (matchItem) {
          this.mappings[i].tenants = matchItem.tenants;
          doesNeedToSetDirty = true;
        } else {
          this.deleteMapping(this.mappings[i].id);
        }
      }

      doesNeedToSetDirty && this.markDirty();
    }.bind(this));

    prepareMappings();
    merge();
  });

  /**
   * Update mapping error details
   * @param {Number} index
   * @param {String} message
   */
  DatabaseMappingDetail.prototype.setMappingError = function (index, message) {
    this.mappings[index].setPropertyValue('message', message);
  };

  /**
   * Reset mapping errors.
   */
  DatabaseMappingDetail.prototype.resetMessage = m.action(function () {
    forEach(function (item) {
      item.setPropertyValue('message', null);
    }, this.mappings);
  });

  module.exports = DatabaseMappingDetail;
}();

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMapping.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var ObjectStateConstants = __webpack_require__(58);
  var constants = __webpack_require__(337);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      isNil = _require.isNil,
      flow = _require.flow,
      first = _require.first,
      cloneDeep = _require.cloneDeep,
      trim = _require.trim,
      replace = _require.replace,
      uniqueId = _require.uniqueId,
      split = _require.split,
      indexOf = _require.indexOf,
      remove = _require.remove,
      difference = _require.difference,
      startsWith = _require.startsWith;

  function DatabaseMapping(data) {
    var staticProps = {
      version: null,
      id: null
    };

    var observableProps = {
      fromServer: null,
      fromDatabaseName: null,
      optionFromDatabaseNameValue: function optionFromDatabaseNameValue() {
        return buildOptionValue(this.fromServer, this.fromDatabaseName);
      },
      optionFromTooltipValue: function optionFromTooltipValue() {
        return buildTooltip(this.fromServer, this.fromDatabaseName);
      },
      type: null,
      fromObject: null,
      toServer: null,
      toDatabaseName: null,
      optionToDatabaseNameValue: function optionToDatabaseNameValue() {
        return buildOptionValue(this.toServer, this.toDatabaseName);
      },
      optionToTooltipValue: function optionToTooltipValue() {
        return buildTooltip(this.toServer, this.toDatabaseName);
      },
      toObject: null,
      tenants: [], // Array of tenant ids.
      state: ObjectStateConstants.NONE,
      selectAllTenants: function selectAllTenants() {
        var firstTenant = first(this.tenants);
        return this.tenants.length === 1 && firstTenant === constants.ALL_TENANT_ID;
      },
      displayTenants: function displayTenants() {
        return this.tenants.peek().join();
      },
      hashValue: function hashValue() {
        return String.format(constants.MAPPING_HASH_PATTERN, this.fromServer, this.fromDatabaseName, this.type, this.fromObject, this.toServer, this.toDatabaseName, this.toObject);
      },
      message: null,
      showMessage: function showMessage() {
        return !isNil(this.message);
      },
      isMappingToGridDisabled: function isMappingToGridDisabled() {
        return isNil(this.fromDatabaseName) || isNil(this.type) || isNil(this.fromObject);
      }
    };

    m.extendObservable(trackable(this), observableProps);
    (0, _assign2.default)(this, staticProps);

    data && this.populate(data);
    this.resetDirty();

    /**
     * Build default buildTooltip
     * (Use for lazy loading.)
     * @param {String} serverName
     * @param {String} composedDatabaseName
     */
    function buildTooltip(serverName, composedDatabaseName) {
      if (isNil(serverName) || isNil(composedDatabaseName)) {
        return;
      }
      var regex = new RegExp('\\[\\w*\\]\\s');
      var cloneValue = cloneDeep(composedDatabaseName);
      var matches = regex.exec(cloneValue);

      var serverTypeName = trim(matches[0]);
      var databaseName = replace(matches[0], '', cloneValue);
      return String.format('{0} - {1} - {2}', serverTypeName, serverName, databaseName);
    }

    /**
     * Build option value.
     * @param {String} server
     * @param {String} databaseName
     */
    function buildOptionValue(server, databaseName) {
      return databaseName ? String.format('{0} - {1}', server, databaseName) : null;
    }
  }

  /**
   * Populate data.
   * @param {Object} data
   */
  DatabaseMapping.prototype.populate = m.action(function populate(data) {
    this.id = data.id || uniqueId(constants.ID_PREFIX);
    this.version = data.version;
    this.state = data.state;

    this.fromServer = data.fromServer;
    this.fromDatabaseName = data.fromDatabaseName;
    this.type = data.type || constants.MAPPING_TYPES[0].value;
    this.fromObject = data.fromObject;
    this.toServer = data.toServer;
    this.toDatabaseName = data.toDatabaseName;
    this.toObject = data.toObject;
    this.tenants = data.tenants ? data.tenants : [constants.ALL_TENANT_ID];
  });

  /**
   * Update value of property.
   * @param {String} key
   * @param {Object} value
   */
  DatabaseMapping.prototype.setPropertyValue = m.action(function setPropertyValue(key, value) {
    this[key] = value;
    this.markDirty();
  });

  /**
   * Update Mapping Tenant
   */
  DatabaseMapping.prototype.updateMappingTenant = m.action(function (tenants) {
    var selectedTenants = split(',', tenants);
    var newTenantId = difference(selectedTenants, this.tenants)[0];

    if (newTenantId === constants.ALL_TENANT_ID) {
      this.tenants = [constants.ALL_TENANT_ID];
    } else {
      this.tenants = filter(function (item) {
        return item !== constants.ALL_TENANT_ID;
      }, selectedTenants);
    }

    this.markDirty();
  });

  /**
   * Verify mapping has a specific tenant
   * @param {String} id
   */
  DatabaseMapping.prototype.hasTenant = function (id) {
    var hasAllTenant = indexOf(constants.ALL_TENANT_ID, this.tenants) !== -1;
    var isFirstTenantEmpty = flow(first, isEmpty)(this.tenants);

    if (hasAllTenant || isFirstTenantEmpty) {
      return true;
    }

    return indexOf(id, this.tenants) !== -1;
  };

  /**
   * Verify state with a specific state.
   * @param {String} state
   */
  DatabaseMapping.prototype.checkState = function (state) {
    return this.state === state;
  };

  /**
   * Calculate data for saving.
   */
  DatabaseMapping.prototype.buildDataForSaving = function () {
    var result = {
      id: this.isNew() ? null : this.id,
      fromServer: this.fromServer,
      fromDatabaseName: this.fromDatabaseName,
      type: this.type,
      fromObject: this.fromObject,
      toServer: this.toServer,
      toDatabaseName: this.toDatabaseName,
      toObject: this.toObject,
      tenants: !this.selectAllTenants ? remove(isEmpty, this.tenants) : null,
      state: this.state,
      version: this.version,
      selectAllTenants: this.selectAllTenants
    };

    this.isDirty && this.state === ObjectStateConstants.NONE && (result.state = ObjectStateConstants.UPDATE);
    return result;
  };

  /**
   * Check whether this is a new one.
   */
  DatabaseMapping.prototype.isNew = function () {
    return startsWith(constants.ID_PREFIX, this.id);
  };

  module.exports = DatabaseMapping;
}();

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ResponseMessage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var ResponseMessage = function ResponseMessage(type, message) {
    this.type = type;
    this.message = message;
  };

  module.exports = ResponseMessage;
}();

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _desc, _value, _class, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.LazySelectDataSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(34);

var _Izenda2 = __webpack_require__(118);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var LazySelectDataSource = (_dec = (0, _mobx.action)('setDetail'), (_class = function () {
  function LazySelectDataSource(mappings, key) {
    (0, _classCallCheck3.default)(this, LazySelectDataSource);
    this.mappingDefinitions = null;
    this.propertyKey = null;
    this.isLastPage = false;
    this.skipItems = 0;
    this.pageSize = _Izenda.LAZY_LOADING_DEFAULT_ITEMS_NUMBER;

    _initDefineProp(this, 'items', _descriptor, this);

    mappings && (this.mappingDefinitions = mappings);
    key && (this.propertyKey = key);
  }

  /**
   * Populate detail (Almost data from API.)
   * @param {Object} detail
   */


  (0, _createClass3.default)(LazySelectDataSource, [{
    key: 'setDetail',
    value: function setDetail(detail) {
      var _this = this;

      this.skipItems = detail.skipItems;
      this.pageSize = detail.pageSize;
      this.isLastPage = detail.isLastPage;

      /**
       * Map source value to target based on mapping definition.
       */
      var mapFunc = function mapFunc() {
        return (0, _fp.map)(function (item) {
          var object = {};
          (0, _fp.forEach)(function (mapping) {
            var value = null;
            if ((0, _fp.isFunction)(mapping.source)) {
              value = mapping.source(item);
            } else {
              value = item[mapping.source];
            }
            object[mapping.target] = value;
          }, _this.mappingDefinitions);

          return object;
        }, detail.items);
      };

      (0, _Izenda2.concatArray)(this.items, mapFunc(), this.propertyKey, !this.isLastPage);
    }
  }]);
  return LazySelectDataSource;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'items', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setDetail', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setDetail'), _class.prototype)), _class));
exports.default = LazySelectDataSource;
module.exports = exports['default'];

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2437);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2438);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Mapping Detail component
 */
var MappingDetail = function MappingDetail(props) {
  var store = props.store;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_Izenda2.default, { store: store }),
    _react2.default.createElement(_Izenda4.default, { store: store })
  );
};

MappingDetail.propTypes = {
  store: _mobxReact.propTypes.observableObject
};

exports.default = MappingDetail;
module.exports = exports['default'];

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobxReact = __webpack_require__(10);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(29);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(624);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingTenant.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Mapping Tenant component
 */
var MappingTenant = function MappingTenant(props) {
  var localization = props.localization,
      _props$store = props.store,
      mappingTenants = _props$store.mappingTenants,
      onChangeMappingTenant = _props$store.onChangeMappingTenant,
      databaseMappingDetail = _props$store.databaseMappingDetail;

  return _react2.default.createElement(
    _Izenda4.default,
    { className: 'izenda-MappingTenant' },
    _react2.default.createElement(
      _Izenda4.default.Row,
      null,
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: '1' },
        _react2.default.createElement(
          'label',
          null,
          localization.getText('DATABASE_MAPPING_LABEL_MAPPING_DROPBOX')
        )
      ),
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: '4' },
        _react2.default.createElement(_Izenda2.default, {
          options: mappingTenants,
          onChange: onChangeMappingTenant,
          value: databaseMappingDetail.selectedTenantId,
          labelField: 'displayValue',
          valueField: 'id' })
      )
    )
  );
};

MappingTenant.propTypes = {
  store: _mobxReact.propTypes.observableObject
};

exports.default = (0, _Izenda6.default)(_Izenda8.default)(MappingTenant);
module.exports = exports['default'];

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Mapping.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Mapping component
 */
!function () {
  var React = __webpack_require__(0);
  var MobxPropTypes = __webpack_require__(10).propTypes;
  var ReactDOM = __webpack_require__(32);
  var observable = __webpack_require__(5).observable;
  var constants = __webpack_require__(337);
  var TABLE_DEF = constants.TABLE_DEF;
  var connect = __webpack_require__(2);
  var Dimensions = __webpack_require__(83);
  var Validator = __webpack_require__(23);

  var DropDown = Validator()(__webpack_require__(29));
  var Table = __webpack_require__(44).Table;
  var Column = __webpack_require__(44).Column;
  var ColumnGroup = __webpack_require__(44).ColumnGroup;
  var Select = Validator()(__webpack_require__(47));
  var ValidatableInput = Validator()(__webpack_require__(17));
  var MergeDuplicateMapping = __webpack_require__(2439);

  var actions = __webpack_require__(624);

  var Mapping = React.createClass({
    displayName: 'Mapping',

    propTypes: {
      store: MobxPropTypes.observableObject.isRequired
    },
    render: function render() {
      var props = this.props;
      var size = this.size;

      /*
      * Render Mapping Table.
      */
      var renderMappingTable = function renderMappingTable() {
        var localization = props.localization;
        var databaseMappingDetail = props.store.databaseMappingDetail;
        var dataSource = databaseMappingDetail.selectedMappings;
        var doesShowMergeDuplicateMapping = databaseMappingDetail.doesShowMergeDuplicateMapping;
        var height = size.height;
        doesShowMergeDuplicateMapping && (height = height - constants.MAPPING_HEIGHT);

        return React.createElement(
          Table,
          {
            dataSource: dataSource,
            minHeight: height },
          React.createElement(
            ColumnGroup,
            { title: localization.getText('COMMON_LABEL_FROM') },
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['fromDatabaseName'], {
              cell: renderFromDatabaseName })),
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['type'], {
              cell: renderType })),
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['fromObject'], {
              cell: renderFromObject }))
          ),
          React.createElement(
            ColumnGroup,
            { title: localization.getText('COMMON_LABEL_TO') },
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['toDatabaseName'], {
              cell: renderToDatabaseName })),
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['toObject'], {
              cell: renderToObject })),
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['tenant'], {
              cell: renderTenant }))
          ),
          React.createElement(
            ColumnGroup,
            { title: '\xA0' },
            React.createElement(Column, (0, _extends3.default)({}, TABLE_DEF['action'], {
              cell: renderActionColumn }))
          )
        );
      };

      /*
      * Render From Database column
      */
      var renderFromDatabaseName = function renderFromDatabaseName(mappingItem, key, rowIndex, column) {
        var store = props.store;

        var onChangeMappingItem = props.onChangeDatabaseName.bind(this, 'fromDatabaseName', mappingItem);
        var value = mappingItem.optionFromDatabaseNameValue && {
          valueField: mappingItem.optionFromDatabaseNameValue,
          labelField: mappingItem.fromDatabaseName,
          optionTooltip: mappingItem.optionFromTooltipValue
        };

        var options = store.fromDatabaseNameDataSource.items.length > 0 ? store.fromDatabaseNameDataSource.items : [];
        return React.createElement(Select, {
          options: options,
          simpleValue: true,
          searchable: false,
          onChange: onChangeMappingItem,
          value: value,
          valueKey: 'valueField',
          labelKey: 'labelField',
          optionTooltip: 'optionTooltip',
          validations: constants.REQUIRE_CONSTRAINT,
          isLazyLoading: true,
          isLastPage: store.fromDatabaseNameDataSource.isLastPage,
          getData: store.loadDatabaseNames.bind(store, true) });
      };

      /*
      * Render To Database column
      */
      var renderToDatabaseName = function renderToDatabaseName(mappingItem, key, rowIndex, column) {
        var store = props.store;

        var onChangeMappingItem = props.onChangeDatabaseName.bind(this, 'toDatabaseName', mappingItem);
        var value = mappingItem.optionToDatabaseNameValue && {
          valueField: mappingItem.optionToDatabaseNameValue,
          labelField: mappingItem.toDatabaseName,
          optionTooltip: mappingItem.optionToTooltipValue
        };
        var options = store.toDatabaseNameDataSource.items.length > 0 ? store.toDatabaseNameDataSource.items : [];

        return React.createElement(Select, {
          options: options,
          simpleValue: true,
          searchable: false,
          onChange: onChangeMappingItem,
          value: value,
          valueKey: 'valueField',
          labelKey: 'labelField',
          optionTooltip: 'optionTooltip',
          field: key + rowIndex,
          validations: constants.REQUIRE_CONSTRAINT,
          isLazyLoading: true,
          isLastPage: store.toDatabaseNameDataSource.isLastPage,
          getData: store.loadDatabaseNames.bind(store, false),
          disabled: mappingItem.isMappingToGridDisabled });
      };

      /*
      * Render Type column
      */
      var renderType = function renderType(mappingItem, key, rowIndex, column) {
        var onChangeMappingItem = props.onChangeType.bind(this, key, mappingItem);

        return React.createElement(DropDown, { options: props.store.typeOptions,
          onChange: onChangeMappingItem,
          value: mappingItem[key],
          additionalKey: key + rowIndex });
      };

      /*
      * Render From Object column.
      */
      var renderFromObject = function renderFromObject(mappingItem, key, rowIndex, column) {
        var store = props.store;
        var onChangeMappingItem = props.onChangeMappingItem.bind(this, key, mappingItem);
        var disabled = mappingItem.type === constants.MAPPING_TYPE.Database;
        var dataSource = store.getObjectDataSource(mappingItem.optionFromDatabaseNameValue);
        var dataSourceDetail = dataSource && (mappingItem.type === constants.MAPPING_TYPE.Schema ? dataSource.schemaObjects : dataSource.databaseObject);

        var value = mappingItem.fromObject && {
          valueField: mappingItem.fromObject,
          labelField: mappingItem.fromObject
        };

        var options = dataSourceDetail && dataSourceDetail.items.length > 0 ? dataSourceDetail.items : [];

        return React.createElement(Select, {
          options: options,
          simpleValue: true,
          searchable: false,
          onChange: onChangeMappingItem,
          value: value,
          valueKey: 'valueField',
          labelKey: 'labelField',
          field: key + rowIndex,
          validations: constants.REQUIRE_CONSTRAINT,
          disabled: disabled,
          isLazyLoading: true,
          isLastPage: dataSourceDetail ? dataSourceDetail.isLastPage : false,
          getData: store.loadObjects.bind(store, mappingItem) });
      };

      /*
      * Render To Object column
      */
      var renderToObject = function renderToObject(mappingItem, key, rowIndex, column) {
        var onChangeMappingItem = props.onChangeMappingItem.bind(this, key, mappingItem);
        return React.createElement(ValidatableInput, {
          onChange: onChangeMappingItem,
          value: mappingItem[key],
          className: 'form-control',
          field: key + rowIndex,
          maxLength: 256,
          validations: constants.REQUIRE_CONSTRAINT,
          disabled: mappingItem.isMappingToGridDisabled });
      };

      /**
      * Render Tenant(s) column
      */
      var renderTenant = function renderTenant(mappingItem, key, rowIndex, column) {
        var options = props.store.tenantOptions;
        var localization = props.localization;

        return React.createElement(
          'div',
          { className: 'select-box' },
          React.createElement(Select, {
            multi: true,
            simpleValue: true,
            options: options,
            labelKey: 'displayValue',
            valueKey: 'id',
            noResultsText: localization.getText('COMMON_MESSAGES_NO_RESULT'),
            allowCreate: false,
            onChange: mappingItem.updateMappingTenant.bind(mappingItem),
            value: mappingItem.displayTenants,
            field: key + rowIndex,
            validations: constants.REQUIRE_CONSTRAINT,
            disabled: mappingItem.isMappingToGridDisabled })
        );
      };

      /*
      * Render Action Column
      */
      var renderActionColumn = function renderActionColumn(mappingItem, key, rowIndex, column) {
        var onDeleteMapping = props.onDeleteMapping.bind(this, mappingItem);
        var localization = props.localization;
        return React.createElement(
          'div',
          null,
          React.createElement(
            'a',
            { onClick: onDeleteMapping, className: 'action-column' },
            React.createElement('span', { title: localization.getText('COMMON_LABEL_DELETE'),
              className: 'icon-cancel' })
          ),
          mappingItem.showMessage && React.createElement('span', { title: mappingItem.message,
            className: 'icon-info-circled u_textErrorColor' })
        );
      };

      var databaseMappingDetail = props.store.databaseMappingDetail;
      return React.createElement(
        'div',
        { className: 'izenda-MappingDetail' },
        databaseMappingDetail.doesShowMergeDuplicateMapping && React.createElement(MergeDuplicateMapping, { store: props.store }),
        renderMappingTable()
      );
    },

    componentDidMount: function componentDidMount() {
      var dom = ReactDOM.findDOMNode(this);
      var newHeight = dom.clientHeight;
      newHeight > 0 && newHeight !== this.size.height && (this.size.height = newHeight);
    },

    componentWillMount: function componentWillMount() {
      this.size = observable({ height: this.props.height });
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.size.height = nextProps.height;
    }
  });

  module.exports = connect(actions, Dimensions)(Mapping);
}();

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MergeDuplicateMapping.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Merge Duplicate Mapping component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var MobxPropTypes = __webpack_require__(10).propTypes;
  var Input = __webpack_require__(17);

  var actions = __webpack_require__(624);

  var MergeDuplicateMapping = connect(actions)(function (props) {
    var localization = props.localization;
    return React.createElement(
      'div',
      { className: 'checkbox u_paddingLeft u_paddingTop izenda-MappingDetail-MergeDuplicateMappings' },
      React.createElement(
        'label',
        null,
        React.createElement(Input, {
          type: 'checkbox',
          checked: props.mergeDuplicateMappings,
          onChange: props.onChangeMergeDuplicateMappings }),
        localization.getText('DATABASE_MAPPING_CHECKBOX_MERGE_DUPLICATE_MAPPINGS'),
        React.createElement('span', { className: 'icon-info-circled', title: localization.getText('COPY_MANAGEMENT_MERGE_DUPLICATE_TOOLTIP') })
      )
    );
  });

  MergeDuplicateMapping.propTypes = {
    store: MobxPropTypes.observableObject
  };

  module.exports = MergeDuplicateMapping;
}();

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.UserSetup.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
/**
 * User Setup component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(219);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobxReact = __webpack_require__(10);

var _Izenda5 = __webpack_require__(27);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2441);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2443);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(196);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2450);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(419);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(34);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_ITEM_HEIGHT = 37;
var UserSetup = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(UserSetup, _Component);

  function UserSetup(props) {
    (0, _classCallCheck3.default)(this, UserSetup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserSetup.__proto__ || (0, _getPrototypeOf2.default)(UserSetup)).call(this, props));

    _initialiseProps.call(_this);

    var loader = props.loader;


    _this.store = new _Izenda16.default();
    _this.registerLazyLoadingStore = _this.store.registerLazyLoadingStore.bind(_this.store);
    _this.loadData = function () {
      loader.startLoading();
      return _this.store.loadAllUserSetup().finally(loader.endLoading.bind(loader));
    };
    return _this;
  }

  (0, _createClass3.default)(UserSetup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.store.init();
      this.loadData();
      var loader = this.props.loader;


      this.disposeChangeTenant = (0, _mobx.observe)(this.store, 'tenantId', function () {
        loader.startLoading();
        _this2.loadData().then(_this2.store.getPartialUsers.bind(_this2.store, null, true)).finally(loader.endLoading.bind(loader));
      });
    }
  }, {
    key: 'componentWillUnMount',
    value: function componentWillUnMount() {
      this.store.destroy();
      this.disposeChangeTenant();
    }

    /**
     * Render User Item
     * @param {Object} item
     */


    /**
     * Get Data for lazy loading
     * @param {Object} pageInfo
     * @param {boolean} isSearching
     */


    /**
     * Search user list - search lazy
     * @param {String} searchKey
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          authorization = _props.authorization,
          authorizationConstants = _props.authorizationConstants;

      var store = this.store;
      var model = store.model;
      var readOnly = !authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.UserSetupActionsEdit]);

      return _react2.default.createElement(
        'div',
        { className: 'izenda-TableLayout' },
        _react2.default.createElement(
          _Izenda12.default,
          { minWidth: 0, maxWidth: 250 },
          _react2.default.createElement(
            'div',
            { className: 'u_fullHeight u-posRelative u-bgWhite' },
            _react2.default.createElement(
              'div',
              { className: 'izenda-MiddlePanel-search' },
              _react2.default.createElement(_Izenda14.default, { store: store, searchUser: this.searchUser })
            ),
            _react2.default.createElement(
              'div',
              { className: 'izenda-MiddlePanel-content' },
              _react2.default.createElement(
                _Izenda6.default,
                null,
                _react2.default.createElement(_Izenda4.default, {
                  data: model.filterUser,
                  isLastPage: model.isLastPage,
                  getData: this.getData,
                  renderItem: this.renderUserItem,
                  viewHeight: _Izenda18.default.MIDDLE_PANEL_LIST_MAX_HEIGHT,
                  itemHeight: USER_ITEM_HEIGHT,
                  registerLazyLoadingStore: this.registerLazyLoadingStore,
                  itemKey: 'id'
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-TableLayout-Cell' },
          store.configUserCloned ? _react2.default.createElement(_Izenda10.default, { store: store, readOnly: readOnly }) : null
        )
      );
    }
  }]);
  return UserSetup;
}(_react.Component), _class2.PropTypes = {
  store: _react2.default.PropTypes.object.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.renderUserItem = function (item) {
    var _props2 = _this3.props,
        authorization = _props2.authorization,
        authorizationConstants = _props2.authorizationConstants;

    var readOnly = !authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.UserSetupActionsEdit]);

    return _react2.default.createElement(_Izenda8.default, { userInfo: item, store: _this3.store, key: item.id, readOnly: readOnly });
  };

  this.getData = function (pageInfo, isSearching) {
    var loader = _this3.props.loader;

    var isFirstLoad = pageInfo && (0, _fp.get)('fromIndex', pageInfo) === 0;
    isFirstLoad && loader.startLoading();
    return _this3.store.getPartialUsers(pageInfo, isSearching).finally(loader.endLoading.bind(loader));
  };

  this.searchUser = function (searchKey) {
    var model = (0, _fp.get)('store.model', _this3);

    model.updateFilterText(searchKey);
    return _this3.store.getPartialUsers(null, true, searchKey);
  };
}, _temp)) || _class);
exports.default = UserSetup;
module.exports = exports['default'];

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.UserItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/**
 * Tenant Item component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);
  var TextHighLight = __webpack_require__(62);
  var constants = __webpack_require__(124);
  var GridLayout = __webpack_require__(13);
  var action = __webpack_require__(2442);
  var DeleteIcon = __webpack_require__(1152);
  var AuthorizationValidator = __webpack_require__(148);

  var AuthorizedActiveOrDeactiveUser = AuthorizationValidator()(function ActiveOrDeactiveUser(_ref) {
    var active = _ref.active,
        onClick = _ref.onClick,
        userStatus = _ref.userStatus;

    var classes = classnames('izenda-UserStatus u_textUnderline', { 'izenda-UserStatus-Deactivate': !active });
    return React.createElement(
      'a',
      {
        className: classes,
        onClick: onClick },
      userStatus
    );
  });

  var UserItem = action(function (props) {
    var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
    var store = props.store;
    var userInfo = props.userInfo;
    var displayName = userInfo.fullName;
    var authorization = props.authorization;
    var classes = classnames('u_paddingAll u_curPointer', 'truncate', { 'u-bgGray': userInfo.selected });
    var userStatus = userInfo.active ? constants.USER_STATE.DEACTIVATE : constants.USER_STATE.ACTIVATE;
    var isIntegrationMode = authorization.isIntegrationMode();
    var onClick = (isIntegrationMode || userInfo.status !== constants.NUMBER_INACTIVE_REASON_STATUS.NO_PASSWORD_SET) && !props.readOnly && props.onToggleActive;

    return React.createElement(
      'div',
      { className: classes, onClick: props.onSelectUser },
      React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          { className: 'izenda-RoleItem' },
          React.createElement(
            GridLayout.Col,
            { cols: 7, className: 'overflow-text' },
            React.createElement(TextHighLight, {
              highlight: store.model.filterText,
              text: displayName,
              tooltip: displayName })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 5 },
            React.createElement(
              'div',
              { className: 'pull-right' },
              React.createElement(AuthorizedActiveOrDeactiveUser, {
                keys: [permissionKeys.UserSetupActionsEdit],
                onClick: onClick,
                active: userInfo.active,
                userStatus: userStatus
              }),
              React.createElement(DeleteIcon, {
                keys: [permissionKeys.UserSetupActionsDel],
                onClick: props.onDelete,
                disabled: props.readOnly,
                integrationHidden: true
              })
            )
          )
        )
      )
    );
  });

  module.exports = connect()(UserItem);
}();

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.UserItemAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var withProps = __webpack_require__(9).withProps;
  var withHandlers = __webpack_require__(9).withHandlers;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var PropTypes = __webpack_require__(0).PropTypes;
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(124);
  var observer = __webpack_require__(10).observer;
  var commonMessage = __webpack_require__(37);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil,
      isEmpty = _require.isEmpty;

  var userItemAction = compose(setPropTypes({
    userInfo: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  }), connect(), withHandlers({
    onToggleActive: curry(onToggleActive),
    onDelete: curry(onDelete),
    onSelectUser: curry(onSelectUser)
  }));

  /**
   * [on Toggle Active user set up
   * @param  {object} props
   * @param  {object} e
   */
  function onToggleActive(props, e) {
    var loader = props.loader;
    var store = props.store;
    var userInfo = props.userInfo;
    var handleSetUserStatus = function handleSetUserStatus(activate) {
      loader.startLoading();
      store.setUserStatus(userInfo, activate).then(showErrorPopup.bind(null, props)).finally(loader.endLoading.bind(loader));
    };

    if (userInfo.active) {
      props.confirmFn('Confirmation', {
        description: constants.MESSAGE.DEACTIVE
      }).then(function () {
        handleSetUserStatus(false);
      });
    } else {
      handleSetUserStatus(true);
    }
  }

  /**
   * [onDelete user detail
   * @param  {object} props
   * @param  {object} e
   */
  function onDelete(props, e) {
    e.preventDefault();
    e.stopPropagation();

    var loader = props.loader;
    var store = props.store;
    var handleDelete = function handleDelete() {
      return props.confirmFn('Confirmation', {
        description: constants.MESSAGE.DELETE
      }).then(function () {
        loader.startLoading();
        store.deleteUser(props.userInfo).then(showErrorPopup.bind(null, props)).finally(loader.endLoading.bind(loader));
      });
    };
    if (props.userInfo.systemAdmin) {
      store.checkLastSystemAdmin().then(function (result) {
        if (result.data) {
          return props.confirmMessage('error', constants.MESSAGE.LAST_SYSTEM_ADMIN);
        } else {
          handleDelete();
        }
      });
    } else {
      handleDelete();
    }
  }

  /**
   * show Error Popup
   * @param  {object} props
   * @param  {object} result
   */
  function showErrorPopup(props, result) {
    if (!isNil(result.messages) && !isEmpty(result.messages[0])) {
      return props.confirmMessage('error', result.messages[0].messages[0]);
    }
  }

  /**
   * on Select User
   * @param  {object} props
   * @param  {object} e
   */
  function onSelectUser(props, e) {
    var loader = props.loader;
    var store = props.store;
    var valManager = props.validation;

    valManager.reset();
    props.confirmDirtyForm(store.isDirty).then(store.selectUser.bind(store, props.userInfo)).finally(loader.endLoading.bind(loader));
  }

  module.exports = userItemAction;
}();

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class3, _dec3, _class5, _dec4, _class7, _dec5, _class9, _dec6, _class11, _dec7, _class13, _dec8, _class15;
// ----------------------------------------------------------------------
// <copyright file="Izenda.UserSetupDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(124);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2444);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(28);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(13);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(27);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(17);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(23);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(47);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(29);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(120);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(2448);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(40);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatableInput = (0, _Izenda18.default)()(_Izenda16.default);
var ValidatabSelect = (0, _Izenda18.default)()(_Izenda20.default);

/**
 * UserAlertInfo component
 */
var UserAlertInfo = (0, _Izenda2.default)()(function (_ref) {
  var store = _ref.store;

  var configUser = store.configUserCloned;
  var headerClass = (0, _classnames2.default)('u_floatLeft u_fullWidth izenda-HeaderInformation', configUser.active ? 'izenda-HeaderActive' : 'izenda-HeaderInActive');
  var className = (0, _classnames2.default)('izenda-CustomHeader', configUser.active ? 'izenda-ActivateUser' : 'izenda-InactivateUser');

  return _react2.default.createElement(
    _Izenda12.default.Row,
    { className: (0, _classnames2.default)(configUser.isNew ? 'hidden' : null) },
    _react2.default.createElement(
      _Izenda12.default.Col,
      { cols: '12' },
      _react2.default.createElement(
        'div',
        { className: headerClass },
        _react2.default.createElement('i', { className: 'icon-attention' }),
        _react2.default.createElement(
          'span',
          { className: className },
          configUser.inactiveReason
        )
      )
    )
  );
});

/**
 * UserSystemAdminInfo component
 */
var UserSystemAdminInfo = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(UserSystemAdminInfo, _Component);

  function UserSystemAdminInfo() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, UserSystemAdminInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = UserSystemAdminInfo.__proto__ || (0, _getPrototypeOf2.default)(UserSystemAdminInfo)).call.apply(_ref2, [this].concat(args))), _this), _this.onChangeSystemAdmin = function (e) {
      _this.props.store.configUserCloned.updateSelectedSystemAdmin(e.target.checked);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /**
   * On change system admin
   * @param {any} e
   */


  (0, _createClass3.default)(UserSystemAdminInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          localization = _props.localization;

      var configUser = store.configUserCloned;
      return _react2.default.createElement(
        _Izenda12.default.Row,
        null,
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '2' },
          _react2.default.createElement(
            'label',
            { className: 'u_controlHeight control-label' },
            localization.getText('USER_SETUP_LABEL_SYSTEM_ADMIN')
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '10' },
          _react2.default.createElement(_Izenda16.default, { type: 'checkbox', checked: configUser.systemAdmin, onChange: this.onChangeSystemAdmin })
        )
      );
    }
  }]);
  return UserSystemAdminInfo;
}(_react.Component)) || _class);

/**
 * UserIdInfo component
 */

var UserIdInfo = (_dec2 = (0, _Izenda2.default)(), _dec2(_class3 = function (_Component2) {
  (0, _inherits3.default)(UserIdInfo, _Component2);

  function UserIdInfo() {
    var _ref3;

    var _temp2, _this2, _ret2;

    (0, _classCallCheck3.default)(this, UserIdInfo);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = UserIdInfo.__proto__ || (0, _getPrototypeOf2.default)(UserIdInfo)).call.apply(_ref3, [this].concat(args))), _this2), _this2.onChangeUserName = function (e) {
      _this2.props.store.configUserCloned.updateUserName(e.target.value);
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }
  /**
   * On change user name
   * @param {any} e
   */


  (0, _createClass3.default)(UserIdInfo, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          store = _props2.store,
          localization = _props2.localization,
          readOnly = _props2.readOnly;

      var configUser = store.configUserCloned;
      return _react2.default.createElement(
        _Izenda12.default.Row,
        null,
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '2' },
          _react2.default.createElement(
            'label',
            { className: 'validation required u_controlHeight control-label' },
            localization.getText('USER_SETUP_LABEL_USER_ID')
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '10' },
          _react2.default.createElement(ValidatableInput, {
            field: 'UserName',
            className: 'form-control',
            value: configUser.userName,
            validations: _Izenda4.default.USER_SETUP_CONSTRAINTS.USER_ID,
            onChange: this.onChangeUserName,
            readOnly: readOnly
          })
        )
      );
    }
  }]);
  return UserIdInfo;
}(_react.Component)) || _class3);

/**
 * UserFirstNameInfo component
 */

var UserFirstNameInfo = (_dec3 = (0, _Izenda2.default)(), _dec3(_class5 = function (_Component3) {
  (0, _inherits3.default)(UserFirstNameInfo, _Component3);

  function UserFirstNameInfo() {
    var _ref4;

    var _temp3, _this3, _ret3;

    (0, _classCallCheck3.default)(this, UserFirstNameInfo);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref4 = UserFirstNameInfo.__proto__ || (0, _getPrototypeOf2.default)(UserFirstNameInfo)).call.apply(_ref4, [this].concat(args))), _this3), _this3.onChangeFirstName = function (e) {
      _this3.props.store.configUserCloned.updateFirstName(e.target.value);
    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
  }
  /**
   * On change first name
   * @param {any} e
   */


  (0, _createClass3.default)(UserFirstNameInfo, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          store = _props3.store,
          localization = _props3.localization,
          readOnly = _props3.readOnly;

      var configUser = store.configUserCloned;
      return _react2.default.createElement(
        _Izenda12.default.Row,
        null,
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '2' },
          _react2.default.createElement(
            'span',
            { className: 'validation required u_controlHeight control-label' },
            localization.getText('USER_SETUP_LABEL_FIRST_NAME')
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '10' },
          _react2.default.createElement(ValidatableInput, {
            field: 'firstName',
            className: 'form-control',
            value: configUser.firstName,
            validations: _Izenda4.default.USER_SETUP_CONSTRAINTS.FIRST_NAME,
            onChange: this.onChangeFirstName,
            readOnly: readOnly
          })
        )
      );
    }
  }]);
  return UserFirstNameInfo;
}(_react.Component)) || _class5);

/**
 * UserLastNameInfo component
 */

var UserLastNameInfo = (_dec4 = (0, _Izenda2.default)(), _dec4(_class7 = function (_Component4) {
  (0, _inherits3.default)(UserLastNameInfo, _Component4);

  function UserLastNameInfo() {
    var _ref5;

    var _temp4, _this4, _ret4;

    (0, _classCallCheck3.default)(this, UserLastNameInfo);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp4 = (_this4 = (0, _possibleConstructorReturn3.default)(this, (_ref5 = UserLastNameInfo.__proto__ || (0, _getPrototypeOf2.default)(UserLastNameInfo)).call.apply(_ref5, [this].concat(args))), _this4), _this4.onChangeLastName = function (e) {
      _this4.props.store.configUserCloned.updateLastName(e.target.value);
    }, _temp4), (0, _possibleConstructorReturn3.default)(_this4, _ret4);
  }
  /**
   * On change last name
   * @param {any} e
   */


  (0, _createClass3.default)(UserLastNameInfo, [{
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          store = _props4.store,
          localization = _props4.localization,
          readOnly = _props4.readOnly;

      var configUser = store.configUserCloned;
      return _react2.default.createElement(
        _Izenda12.default.Row,
        null,
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '2' },
          _react2.default.createElement(
            'span',
            { className: 'validation required u_controlHeight control-label' },
            localization.getText('USER_SETUP_LABEL_LAST_NAME')
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '10' },
          _react2.default.createElement(ValidatableInput, {
            field: 'lastName',
            className: 'form-control',
            value: configUser.lastName,
            validations: _Izenda4.default.USER_SETUP_CONSTRAINTS.LAST_NAME,
            onChange: this.onChangeLastName,
            readOnly: readOnly
          })
        )
      );
    }
  }]);
  return UserLastNameInfo;
}(_react.Component)) || _class7);

/**
 * UserEmailInfo component
 */

var UserEmailInfo = (_dec5 = (0, _Izenda2.default)(), _dec5(_class9 = function (_Component5) {
  (0, _inherits3.default)(UserEmailInfo, _Component5);

  function UserEmailInfo() {
    var _ref6;

    var _temp5, _this5, _ret5;

    (0, _classCallCheck3.default)(this, UserEmailInfo);

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _ret5 = (_temp5 = (_this5 = (0, _possibleConstructorReturn3.default)(this, (_ref6 = UserEmailInfo.__proto__ || (0, _getPrototypeOf2.default)(UserEmailInfo)).call.apply(_ref6, [this].concat(args))), _this5), _this5.onChangeEmail = function (e) {
      _this5.props.store.configUserCloned.updateEmail(e.target.value);
    }, _temp5), (0, _possibleConstructorReturn3.default)(_this5, _ret5);
  }
  /**
   * On change email
   * @param {any} e
   */


  (0, _createClass3.default)(UserEmailInfo, [{
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          store = _props5.store,
          localization = _props5.localization,
          readOnly = _props5.readOnly;

      var configUser = store.configUserCloned;
      return _react2.default.createElement(
        _Izenda12.default.Row,
        null,
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '2' },
          _react2.default.createElement(
            'span',
            { className: 'u_controlHeight control-label' },
            localization.getText('COMMON_LABEL_EMAIL')
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '10' },
          _react2.default.createElement(ValidatableInput, {
            className: 'form-control',
            value: configUser.emailAddress,
            onChange: this.onChangeEmail,
            readOnly: readOnly,
            field: 'emailAddress',
            validations: _Izenda4.default.USER_SETUP_CONSTRAINTS.EMAIL
          })
        )
      );
    }
  }]);
  return UserEmailInfo;
}(_react.Component)) || _class9);

/**
 * UserRoleInfo component
 */

var UserRoleInfo = (_dec6 = (0, _Izenda2.default)(), _dec6(_class11 = function (_Component6) {
  (0, _inherits3.default)(UserRoleInfo, _Component6);

  function UserRoleInfo() {
    var _ref7;

    var _temp6, _this6, _ret6;

    (0, _classCallCheck3.default)(this, UserRoleInfo);

    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _ret6 = (_temp6 = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref7 = UserRoleInfo.__proto__ || (0, _getPrototypeOf2.default)(UserRoleInfo)).call.apply(_ref7, [this].concat(args))), _this6), _this6.onChangeRole = function (value) {
      _this6.props.store.configUserCloned.updateRole(value);
    }, _temp6), (0, _possibleConstructorReturn3.default)(_this6, _ret6);
  }
  /**
   * On change role
   * @param {any} value
   */


  (0, _createClass3.default)(UserRoleInfo, [{
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          store = _props6.store,
          localization = _props6.localization,
          readOnly = _props6.readOnly,
          disabled = _props6.disabled;

      var configUser = store.configUserCloned;
      return _react2.default.createElement(
        _Izenda12.default.Row,
        null,
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '2' },
          _react2.default.createElement(
            'span',
            { className: 'validation required u_controlHeight control-label' },
            localization.getText('COMMON_LABEL_ROLE')
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '10' },
          _react2.default.createElement(ValidatabSelect, {
            multi: true,
            simpleValue: true,
            options: store.model.roleList,
            labelKey: 'name',
            valueKey: 'id',
            field: 'roles',
            noResultsText: localization.getText('COMMON_MESSAGES_NO_RESULT'),
            allowCreate: false,
            onChange: this.onChangeRole,
            value: configUser.rolesValue,
            validations: _Izenda4.default.USER_SETUP_CONSTRAINTS.ROLE,
            readOnly: readOnly,
            disabled: disabled
          })
        )
      );
    }
  }]);
  return UserRoleInfo;
}(_react.Component)) || _class11);

/**
 * UserTimeZoneInfo component
 */

var UserTimeZoneInfo = (_dec7 = (0, _Izenda2.default)(), _dec7(_class13 = function (_Component7) {
  (0, _inherits3.default)(UserTimeZoneInfo, _Component7);

  function UserTimeZoneInfo() {
    var _ref8;

    var _temp7, _this7, _ret7;

    (0, _classCallCheck3.default)(this, UserTimeZoneInfo);

    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _ret7 = (_temp7 = (_this7 = (0, _possibleConstructorReturn3.default)(this, (_ref8 = UserTimeZoneInfo.__proto__ || (0, _getPrototypeOf2.default)(UserTimeZoneInfo)).call.apply(_ref8, [this].concat(args))), _this7), _this7.validateTimezoneValue = function (value) {
      var localization = _this7.props.localization;

      return (0, _fp.isEmpty)(value) || /^[-\+]?\d+([\.,]\d+)?$/g.test(value || '') ? '' : localization.getText('COMMON_MESSAGES_INVALID_TIMEZONE');
    }, _this7.onChangeTimezoneDataOffset = function (e) {
      _this7.props.store.configUserCloned.updateTimezoneDataOffset(e.target.value);
    }, _this7.onClickResetValueTimeZone = function () {
      _this7.props.store.configUserCloned.resetValueTimeZone('dataOffset');
    }, _this7.onChangeTimezoneTimestampOffset = function (e) {
      _this7.props.store.configUserCloned.updateTimezoneTimestampOffset(e.target.value);
    }, _this7.resetTimezoneTimestampOffset = function () {
      _this7.props.store.configUserCloned.resetValueTimeZone('timestampOffset');
    }, _temp7), (0, _possibleConstructorReturn3.default)(_this7, _ret7);
  }

  /**
   * Check if timzezone value is valid
   * @param {string} value  value to be validated
   * return {string}        empty if valid
   */


  /**
   * On change timezone data offset
   * @param {any} e
   */


  /**
   * On click reset value timezone.
   */


  /**
   * On change timezone timestamp offset
   * @param {any} e
   */


  /**
   * On click timezone timestamp offset
   */


  (0, _createClass3.default)(UserTimeZoneInfo, [{
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _props7 = this.props,
          store = _props7.store,
          localization = _props7.localization,
          readOnly = _props7.readOnly;

      var configUser = store.configUserCloned;
      var validateTimezoneValueAction = {
        action: function action(value) {
          return _this8.validateTimezoneValue.bind(_this8, value);
        }
      };
      return _react2.default.createElement(
        _Izenda12.default.Row,
        null,
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '2' },
          _react2.default.createElement(
            'span',
            { className: 'u_controlHeight control-label' },
            localization.getText('USER_SETUP_LABEL_TIME_ZONE')
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '10' },
          _react2.default.createElement(
            _Izenda12.default.Col,
            { cols: '12', className: 'u_noPaddingAll' },
            _react2.default.createElement(
              _Izenda12.default.Col,
              { cols: '1', className: 'u_noPaddingAll' },
              _react2.default.createElement(
                'span',
                { className: 'u_controlHeight control-label' },
                localization.getText('USER_SETUP_LABEL_DATA_OFFSET')
              )
            ),
            _react2.default.createElement(
              _Izenda12.default.Col,
              { cols: '2', className: 'u_noPaddingAll' },
              _react2.default.createElement(ValidatableInput, {
                className: 'form-control',
                field: 'DataOffset',
                value: configUser.dataOffset,
                onChange: this.onChangeTimezoneDataOffset,
                validations: validateTimezoneValueAction,
                readOnly: readOnly
              })
            ),
            _react2.default.createElement(
              _Izenda12.default.Col,
              { cols: '1' },
              _react2.default.createElement('i', { className: 'icon-ccw u_controlHeight control-label', onClick: this.onClickResetValueTimeZone })
            ),
            _react2.default.createElement(
              _Izenda12.default.Col,
              { cols: '2' },
              _react2.default.createElement(
                'span',
                { className: 'u_controlHeight control-label' },
                localization.getText('USER_SETUP_LABEL_TIMESTAMP_OFFSET')
              )
            ),
            _react2.default.createElement(
              _Izenda12.default.Col,
              { cols: '2 u_noPaddingAll' },
              _react2.default.createElement(ValidatableInput, {
                className: 'form-control',
                field: 'TimestampOffset',
                value: configUser.timestampOffset,
                onChange: this.onChangeTimezoneTimestampOffset,
                validations: validateTimezoneValueAction,
                readOnly: readOnly
              })
            ),
            _react2.default.createElement(
              _Izenda12.default.Col,
              { cols: '1' },
              _react2.default.createElement('i', { className: 'icon-ccw u_controlHeight control-label', onClick: this.resetTimezoneTimestampOffset })
            ),
            _react2.default.createElement(_Izenda12.default.Col, { cols: '3', className: 'u_noPaddingAll' })
          )
        )
      );
    }
  }]);
  return UserTimeZoneInfo;
}(_react.Component)) || _class13);

/**
 * UserRoleInfo component
 */

var UserLanguageInfo = (_dec8 = (0, _Izenda2.default)(), _dec8(_class15 = function (_Component8) {
  (0, _inherits3.default)(UserLanguageInfo, _Component8);

  function UserLanguageInfo() {
    var _ref9;

    var _temp8, _this9, _ret8;

    (0, _classCallCheck3.default)(this, UserLanguageInfo);

    for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    return _ret8 = (_temp8 = (_this9 = (0, _possibleConstructorReturn3.default)(this, (_ref9 = UserLanguageInfo.__proto__ || (0, _getPrototypeOf2.default)(UserLanguageInfo)).call.apply(_ref9, [this].concat(args))), _this9), _this9.onUpdateLanguage = function (value) {
      _this9.props.store.configUserCloned.updateLanguage(value);
    }, _this9.onUpdateDateFormat = function (value) {
      _this9.props.store.configUserCloned.updateDateFormat(value);
    }, _temp8), (0, _possibleConstructorReturn3.default)(_this9, _ret8);
  }
  /**
   * On update language.
   * @param {any} value
   */


  /**
   * On update data format.
   * @param {any} value
   */


  (0, _createClass3.default)(UserLanguageInfo, [{
    key: 'render',
    value: function render() {
      var _props8 = this.props,
          store = _props8.store,
          localization = _props8.localization;

      var configUser = store.configUserCloned;
      return _react2.default.createElement(
        _Izenda12.default.Row,
        null,
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '2' },
          _react2.default.createElement(
            'span',
            { className: 'u_controlHeight control-label' },
            localization.getText('COMMON_LABEL_LANGUAGE')
          )
        ),
        _react2.default.createElement(
          _Izenda12.default.Col,
          { cols: '10' },
          _react2.default.createElement(
            _Izenda12.default.Col,
            { cols: '3', className: 'u_noPaddingAll' },
            _react2.default.createElement(_Izenda22.default, {
              options: store.model.languageList,
              labelField: 'language',
              valueField: 'cultureName',
              onChange: this.onUpdateLanguage,
              value: configUser.cultureName
            })
          ),
          _react2.default.createElement(_Izenda12.default.Col, { cols: '1' }),
          _react2.default.createElement(
            _Izenda12.default.Col,
            { cols: '2' },
            _react2.default.createElement(
              'span',
              { className: 'u_controlHeight control-label' },
              localization.getText('COMMON_LABEL_DATE_FORMAT')
            )
          ),
          _react2.default.createElement(
            _Izenda12.default.Col,
            { cols: '3', className: 'u_noPaddingAll' },
            _react2.default.createElement(_Izenda22.default, {
              options: store.model.dateFormatList,
              labelField: 'labelDateFormat',
              valueField: 'dateFormat',
              onChange: this.onUpdateDateFormat,
              value: configUser.dateFormat
            })
          )
        )
      );
    }
  }]);
  return UserLanguageInfo;
}(_react.Component)) || _class15);


var UserSetupDetail = (0, _Izenda26.default)(function (_ref10) {
  var store = _ref10.store,
      authorizationConstants = _ref10.authorizationConstants,
      onSave = _ref10.onSave,
      onCancel = _ref10.onCancel,
      readOnly = _ref10.readOnly;

  var permissionKeys = authorizationConstants.PERMISSION_KEY;
  var configUser = store.configUserCloned;
  var securityManager = new _Izenda24.default();
  var userRoleAssociation = securityManager.checkPrivileges([permissionKeys.UserSetupUserRoleAssociationValue]);

  return _react2.default.createElement(
    'div',
    { className: 'izenda-Wrapper' },
    _react2.default.createElement(_Izenda8.default, { store: store, onSave: onSave, onCancel: onCancel, readOnly: readOnly }),
    _react2.default.createElement(
      'div',
      { className: 'izenda-Wrapper-content izenda-UserSetupMainContent' },
      _react2.default.createElement(
        _Izenda14.default,
        null,
        _react2.default.createElement(
          'div',
          { className: 'u_paddingLeftRight' },
          _react2.default.createElement(
            _Izenda10.default,
            null,
            _react2.default.createElement(
              _Izenda12.default,
              null,
              _react2.default.createElement(UserAlertInfo, { store: store }),
              (0, _fp.isNull)(_Izenda6.default.getTenantId()) && _Izenda6.default.currentUser.systemAdmin && _react2.default.createElement(UserSystemAdminInfo, { store: store }),
              _react2.default.createElement(UserIdInfo, { store: store, readOnly: _Izenda28.default.Integration }),
              _react2.default.createElement(UserFirstNameInfo, { store: store }),
              _react2.default.createElement(UserLastNameInfo, { store: store }),
              _react2.default.createElement(UserEmailInfo, { store: store }),
              !configUser.systemAdmin && _react2.default.createElement(UserRoleInfo, { disabled: !userRoleAssociation, store: store }),
              _react2.default.createElement(UserTimeZoneInfo, { store: store }),
              _react2.default.createElement(UserLanguageInfo, { store: store })
            )
          )
        )
      )
    )
  );
});

exports.default = UserSetupDetail;
module.exports = exports['default'];

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(86);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(148);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(30);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(61);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2445);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ActionBar component
 */

var ActionBar = (0, _Izenda10.default)(function (props) {
  var AuthorizationButton = (0, _Izenda4.default)()(_Izenda6.default);
  var _props$store = props.store,
      alertMessage = _props$store.alertMessage,
      configUserCloned = _props$store.configUserCloned,
      localization = props.localization,
      authorization = props.authorization,
      authorizationConstants = props.authorizationConstants,
      readOnly = props.readOnly,
      onClickPasswordOptions = props.onClickPasswordOptions,
      onSave = props.onSave,
      onCancel = props.onCancel;

  var isAllowConfigPasswordOption = !readOnly && authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.UserSetupActionsConfigureSecurityOptions]);
  var enableBtn = authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.UserSetupActionsCreate, authorizationConstants.PERMISSION_KEY.UserSetupActionsEdit], authorizationConstants.PERMISSION_OPERATOR.Or);
  return _react2.default.createElement(
    'div',
    { className: 'izenda-Wrapper-header' },
    _react2.default.createElement(_Izenda2.default, null),
    _react2.default.createElement(
      _Izenda8.default,
      { className: 'u_floatLeft', type: alertMessage.type },
      alertMessage.message
    ),
    _react2.default.createElement(
      'div',
      { className: 'izenda-ActionBarRight' },
      _react2.default.createElement(AuthorizationButton, {
        label: localization.getText('USER_SETUP_LABEL_PASSWORD_OPTIONS'),
        onClick: onClickPasswordOptions,
        disabled: configUserCloned.isNew || configUserCloned.formHasErrors || !isAllowConfigPasswordOption,
        keys: [authorizationConstants.PERMISSION_KEY.UserSetupActionsConfigureSecurityOptions],
        integrationHidden: true
      }),
      _react2.default.createElement(_Izenda6.default, {
        label: localization.getText('COMMON_LABEL_SAVE'),
        className: 'u_marginLeft',
        onClick: onSave,
        disabled: !enableBtn
      }),
      _react2.default.createElement(_Izenda6.default, {
        label: localization.getText('COMMON_LABEL_CANCEL'),
        className: 'u_marginLeft',
        onClick: onCancel,
        disabled: !enableBtn
      })
    )
  );
});

exports.default = ActionBar;
module.exports = exports['default'];

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBarAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var withProps = __webpack_require__(9).withProps;
  var withHandlers = __webpack_require__(9).withHandlers;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var PropTypes = __webpack_require__(0).PropTypes;
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(124);
  var observer = __webpack_require__(10).observer;
  var commonMessage = __webpack_require__(37);
  var PasswordOptions = __webpack_require__(2446);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var actionBarAction = compose(setPropTypes({
    store: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
  }), connect(), withHandlers({
    onClickPasswordOptions: curry(onClickPasswordOptions)
  }));

  /**
   * Click Password Options
   */
  function onClickPasswordOptions(props, e) {
    props.openPopup(PasswordOptions, { store: props.store });

    props.store.configUserCloned.addEmailRecipient();
  }

  module.exports = actionBarAction;
}();

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordOptions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ActionBar component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(124);

  var GridLayout = __webpack_require__(13);
  var Popup = __webpack_require__(36);
  var Input = __webpack_require__(17);
  var Button = __webpack_require__(30);
  var EventsUtils = __webpack_require__(24);
  var action = __webpack_require__(2447);

  var UserLookUp = __webpack_require__(418);

  var PasswordOptions = action(function (props) {
    var store = props.store;
    var userAccountList = store.model.userAccountList.peek();
    var recipientValue = store.configUserCloned.recipientValue.toJS();
    var configUserCloned = store.configUserCloned;
    var validations = configUserCloned.sendEmail ? constants.USER_SETUP_CONSTRAINTS.RECIPIENTS : null;
    var localization = props.localization;

    var iconCopyTooltip = document.queryCommandSupported("copy") ? localization.getText('USER_SETUP_LABEL_COPY_PASSWORD_LINK') : localization.getText('USER_SETUP_LABEL_COPY_PASTE');

    return React.createElement(
      Popup,
      { visible: true, type: 'none', onClosing: props.onClosing, autoClose: false },
      React.createElement(Popup.Header, { title: localization.getText('USER_SETUP_LABEL_PASSWORD_OPTIONS'), className: 'u_floatLeft' }),
      React.createElement(
        Popup.Body,
        null,
        React.createElement(
          GridLayout,
          { className: 'izenda-PasswordOptions' },
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(Button, { label: localization.getText('USER_SETUP_LABEL_GENERATE_PASSWORD_LINK'), className: 'u_floatLeft', onClick: props.onGeneratePasswordLink })
          ),
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              'div',
              { className: 'izenda-PasswordLinkCustom u_inlineBlock' },
              React.createElement(Input, { className: 'form-control u_inlineBlock',
                id: 'izenda-PasswordLinkCustom',
                value: configUserCloned.passwordLink, disabled: true }),
              React.createElement('i', { className: 'icon-copy u-posAbsolute izenda-IconCopyClipBoard',
                title: iconCopyTooltip,
                onClick: props.onCopyPasswordLink })
            )
          ),
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              'label',
              null,
              React.createElement('input', { type: 'checkbox',
                className: 'u_floatLeft',
                checked: configUserCloned.sendEmail,
                onChange: EventsUtils.notifyChange(props.updateSendEmailState, EventsUtils.CHECKBOX) }),
              React.createElement(
                'span',
                { className: 'u_floatLeft u_marginLeft' },
                constants.PASSWORD_OPSTIONS.SEND_PASSWORD
              )
            )
          ),
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              'span',
              { className: 'validation required u_floatLeft u_marginLeft' },
              constants.PASSWORD_OPSTIONS.EMAIL
            )
          ),
          React.createElement(
            'fieldset',
            { disabled: !configUserCloned.sendEmail },
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(UserLookUp, { open: false,
                disabled: !configUserCloned.sendEmail,
                onToggle: function onToggle() {
                  return false;
                },
                data: userAccountList,
                valueField: 'emailAddress',
                textField: 'emailAddress',
                value: recipientValue,
                onChange: props.addRecipients,
                validations: validations,
                field: 'Recipients',
                onChangeFromPopup: props.getRecipients,
                usingPopup: true })
            )
          )
        )
      ),
      React.createElement(
        Popup.Footer,
        null,
        React.createElement(
          Popup.ConfirmationButton,
          { type: 'accept' },
          localization.getText('COMMON_LABEL_SAVE')
        ),
        React.createElement(
          Popup.ConfirmationButton,
          { type: 'cancel' },
          localization.getText('COMMON_LABEL_CANCEL')
        )
      )
    );
  });

  module.exports = PasswordOptions;
}();

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordOptionsAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var PropTypes = __webpack_require__(0).PropTypes;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var UserAccountStore = __webpack_require__(419);
  var connect = __webpack_require__(2);
  var withHandlers = __webpack_require__(9).withHandlers;
  var fetcher = __webpack_require__(75);
  var uiState = __webpack_require__(15);
  var MESSAGE = __webpack_require__(37);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var passwordOptionsAction = compose(setPropTypes({
    store: PropTypes.object.isRequired
  }), connect(), withHandlers({
    onGeneratePasswordLink: curry(onGeneratePasswordLink),
    onCopyPasswordLink: curry(onCopyPasswordLink),
    updateSendEmailState: curry(updateSendEmailState),
    getRecipients: curry(getRecipients),
    addRecipients: curry(addRecipients),
    onClosing: curry(onClosing)
  }));

  /**
   * generate Password Link
   */
  function onGeneratePasswordLink(props, e) {
    var store = props.store;
    store.generatePasswordLink().then(function (result) {
      if (!result.success) {
        store.alertMessage = {
          type: 'error',
          message: result.messages
        };
      }
    });
  }

  /**
   * Copy Password Link
   */
  function onCopyPasswordLink(props, e) {
    var inputText = document.querySelector('#izenda-PasswordLinkCustom');
    if (inputText) {
      inputText.disabled = false;
      inputText.select();
      document.execCommand('copy');
      inputText.disabled = true;
    }
  }

  /**
   * Update state of sending email
   * @param props
   * @param state
   */
  function updateSendEmailState(props, state) {
    var store = props.store;
    var configUserCloned = store.configUserCloned;
    fetcher.isHavemailConfiguration(uiState.tenantId).then(function (result) {
      !result.success && props.confirmMessage('error', result.message);
      result.success && configUserCloned.updateSendEmailState(state);
    });
  }

  /**
   * get Recipients
   * @param  {array} userAccountList
   */
  function getRecipients(props, userAccountList) {
    var valManager = props.validation;
    valManager.reset();
    return props.store.configUserCloned.getRecipients(userAccountList);
  }

  /**
   * add Recipients
   * @param  {array} userAccountList
   */
  function addRecipients(props, userAccountList) {
    return props.store.configUserCloned.addRecipients(userAccountList);
  }

  /**
   * onClosing pop up
   * @param  {function} closeCallBack
   * @param  {string} type
   */
  function onClosing(props, closeCallBack, type) {
    var valManager = props.validation;
    var loader = props.loader;
    var onSavePassword = function onSavePassword(validateSuccess) {
      if (validateSuccess) {
        loader.startLoading();
        props.store.savePasswordOptions().then(function (success) {
          return success && props.onAccept();
        }).finally(loader.endLoading.bind(loader));
      }
    };

    if (type === 'accept') {
      valManager.validate().then(onSavePassword);
    } else if (type === 'cancel') {
      props.store.configUserCloned.resetRecipientValue();
      props.store.configUserCloned.resetPasswordLink();
      props.onReject();
    }
  }

  module.exports = passwordOptionsAction;
}();

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.UserSetUpDetailAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var PropTypes = __webpack_require__(0).PropTypes;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var UserAccountStore = __webpack_require__(419);
  var connect = __webpack_require__(2);
  var withHandlers = __webpack_require__(9).withHandlers;
  var fetcher = __webpack_require__(75);
  var uiState = __webpack_require__(15);
  var MESSAGE = __webpack_require__(37);
  var localizer = __webpack_require__(12);
  var ValidateRoleAssociation = __webpack_require__(2449);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil,
      isBoolean = _require.isBoolean,
      isEmpty = _require.isEmpty;

  var userSetUpDetailAction = compose(connect(), withHandlers({
    onSave: curry(onSave),
    onCancel: curry(onCancel)
  }));

  /**
   * save user set up detail
   */
  function onSave(props, obj) {
    var valManager = props.validation;
    var loader = props.loader;
    var validateFields = ['UserName', 'firstName', 'lastName', 'roles', 'emailAddress', 'DataOffset', 'TimestampOffset'];
    var configUser = props.store.configUserCloned;

    valManager.validate(validateFields).then(function (success) {
      configUser.updateFormHasErrors(!success);
      if (success) {
        loader.startLoading();
        props.store.validateUserRoleAssociation().then(function (result) {
          if (isBoolean(result) && result) {
            // promise return true then execute Save
            return handleSave(props);
          } else {
            return props.openPopup(ValidateRoleAssociation, {
              store: props.store,
              data: result.messages[0].detail,
              messageKey: result.messages[0].key
            });
          }
        }).finally(loader.endLoading.bind(loader));
      }
    });
  }

  /**
   * handle Save
   * @param  {object} props
   */
  function handleSave(props, obj) {
    var loader = props.loader;
    var store = props.store;
    var localization = props.localization;

    var valManager = props.validation;
    loader.startLoading();
    return store.save().then(function (result) {
      if (!isNil(result.messages)) {
        isEmpty(result.messages[0].key) ? store.alertMessage = {
          type: 'info',
          message: result.messages[0].messages[0]
        } : valManager.updateErrors(result.messages);
      }
      result.hasChangeLanguage && props.confirmMessage('info', localization.getText('USER_MESSAGE_CHANGE_LANGUAGE'));
      return null;
    }).finally(loader.endLoading.bind(loader));
  }

  /**
   * cancel modification and reload
   */
  function onCancel(props, obj) {
    var loader = props.loader;
    props.validation.reset();
    props.store.cloneUserSetupDetail();
  }

  module.exports = userSetUpDetailAction;
}();

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ValidateRoleAssociation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ValidateRoleAssociation component
 */
!function () {

  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(124);

  var GridLayout = __webpack_require__(13);
  var Popup = __webpack_require__(36);
  var Input = __webpack_require__(17);
  var Button = __webpack_require__(30);
  var EventsUtils = __webpack_require__(24);

  var _require = __webpack_require__(1),
      forEach = _require.forEach,
      isEmpty = _require.isEmpty;

  var ValidateRoleAssociation = connect()(function (props) {
    var store = props.store;
    var configUserCloned = store.configUserCloned;
    var validations = configUserCloned.sendEmail ? constants.USER_SETUP_CONSTRAINTS.RECIPIENTS : null;
    var localization = props.localization;
    var renderCategories = function renderCategories() {
      var listCategories = [];
      forEach(function (category) {
        listCategories.push(React.createElement(
          GridLayout.Row,
          { key: category.id },
          React.createElement(
            GridLayout.Col,
            { cols: '12' },
            category.name,
            !isEmpty(category.subCategories) && renderSubCategories(category.subCategories)
          )
        ));
      }, props.data);

      return listCategories;
    };

    var renderSubCategories = function renderSubCategories(subCategories) {
      var listSubcategory = [];
      forEach(function (subCate) {
        listSubcategory.push(React.createElement(
          GridLayout.Row,
          { key: subCate.id },
          React.createElement(GridLayout.Col, { cols: '1' }),
          React.createElement(
            GridLayout.Col,
            { cols: '11' },
            subCate.name
          )
        ));
      }, subCategories);

      return listSubcategory;
    };

    return React.createElement(
      Popup,
      { visible: true, type: 'error', onClosing: props.onReject, autoClose: false },
      React.createElement(Popup.Header, { title: localization.getText('COMMON_MESSAGES_ERROR'), className: 'u_floatLeft' }),
      React.createElement(
        Popup.Body,
        null,
        React.createElement(
          GridLayout,
          { className: 'izenda-PasswordOptions' },
          React.createElement(
            GridLayout.Row,
            null,
            constants.VALIDATE_RESULT_ROLE_ASSOCIATION_KEYS[props.messageKey]
          ),
          renderCategories(),
          React.createElement(
            GridLayout.Row,
            null,
            localization.getText('USER_SETUP_ERROR_ROLE_ASSOCIATION_MESSAGE')
          )
        )
      ),
      React.createElement(
        Popup.Footer,
        null,
        React.createElement(
          Popup.ConfirmationButton,
          { type: 'cancel' },
          localization.getText('COMMON_LABEL_OK')
        )
      )
    );
  });

  module.exports = ValidateRoleAssociation;
}();

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleListHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var SearchBox = __webpack_require__(2451);
  var connect = __webpack_require__(2);

  var AuthorizationValidator = __webpack_require__(148);
  var AuthorizationConstants = __webpack_require__(42);

  var AddUser = AuthorizationValidator()(function (props) {
    var localization = props.localization;
    return React.createElement(
      'a',
      {
        className: 'overflow-text izenda-AddTenantLink',
        onClick: props.onClick,
        title: localization.getText('USER_SETUP_LABEL_ADD_USER') },
      React.createElement('span', { className: 'icon-plus' }),
      localization.getText('USER_SETUP_LABEL_ADD_USER')
    );
  });

  /**
   * Role List Header
   * @param {object} props The component's props that must have 'store' property
   */
  var UserSetupHeader = function UserSetupHeader(props) {
    var store = props.store;
    var onClickAddUser = function onClickAddUser() {
      props.validation.reset();
      store.addUser();
    };
    return React.createElement(
      'div',
      { className: 'header-panel' },
      React.createElement(AddUser, {
        localization: props.localization,
        onClick: onClickAddUser,
        keys: [AuthorizationConstants.PERMISSION_KEY.UserSetupActionsCreate],
        integrationHidden: true }),
      React.createElement(
        'div',
        { className: 'search-box' },
        React.createElement(SearchBox, { searchUser: props.searchUser, store: props.store })
      ),
      React.createElement('hr', null)
    );
  };

  UserSetupHeader.propTypes = {
    store: React.PropTypes.object.isRequired
  };

  module.exports = connect()(UserSetupHeader);
}();

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(24);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(107);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchBox.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var propTypes = {
  store: _react.PropTypes.object.isRequired,
  searchUser: _react.PropTypes.func
};

var SearchBox = (0, _mobxReact.observer)(function (_ref) {
  var store = _ref.store,
      searchUser = _ref.searchUser;

  var model = store.model;

  return _react2.default.createElement(_Izenda4.default, {
    value: model.filterText,
    onChange: _Izenda2.default.notifyChange(searchUser, _Izenda2.default.INPUT)
  });
});

SearchBox.propTypes = propTypes;
SearchBox.displayName = 'SearchBox';

exports.default = SearchBox;
module.exports = exports["default"];

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfiguration.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobxReact = __webpack_require__(10);

var _Izenda3 = __webpack_require__(2453);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobx = __webpack_require__(5);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(13);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(17);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(30);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(61);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2454);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2455);

var _Izenda18 = _interopRequireDefault(_Izenda17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfigurationHeader = (0, _mobxReact.observer)(function ConfigurationHeader(props) {
  var useSystemConfiguration = props.useSystemConfiguration,
      localization = props.localization;


  return _react2.default.createElement(
    _Izenda8.default,
    { className: 'u-bgWhite u_paddingAll' },
    _react2.default.createElement(
      _Izenda8.default.Row,
      null,
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: 3 },
        _react2.default.createElement(_Izenda10.default, {
          type: 'radio',
          className: 'u_marginRight',
          checked: useSystemConfiguration,
          onChange: props.enableSystemConfig
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('SMTP_CONFIGURATION_LABEL_USE_SYSTEM_CONFIGURATION')
        )
      ),
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: 3 },
        _react2.default.createElement(_Izenda10.default, {
          type: 'radio',
          className: 'u_marginRight',
          checked: !useSystemConfiguration,
          onChange: props.enableCustomConfig
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('SMTP_CONFIGURATION_LABEL_USE_CUSTOM_CONFIGURATION')
        )
      )
    )
  );
});

var ActionHeader = (0, _mobxReact.observer)(function ActionHeader(props) {
  var alertDetails = props.alertDetails,
      localization = props.localization;


  return _react2.default.createElement(
    'div',
    { className: 'izenda-Wrapper-header' },
    _react2.default.createElement(
      'div',
      { className: 'izenda-Alert-container' },
      _react2.default.createElement(
        _Izenda14.default,
        { type: alertDetails.alertType, onAutoHide: props.onAutoHide },
        alertDetails.message
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'pull-right' },
      _react2.default.createElement(_Izenda12.default, {
        onClick: props.onSave,
        label: localization.getText('COMMON_LABEL_SAVE'),
        className: 'btn btn-default u_marginRight'
      }),
      _react2.default.createElement(_Izenda12.default, { onClick: props.onCancel, label: localization.getText('COMMON_LABEL_CANCEL') })
    )
  );
});

var EmailConfiguration = (_dec = (0, _Izenda2.default)(_Izenda4.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(EmailConfiguration, _Component);

  function EmailConfiguration() {
    (0, _classCallCheck3.default)(this, EmailConfiguration);
    return (0, _possibleConstructorReturn3.default)(this, (EmailConfiguration.__proto__ || (0, _getPrototypeOf2.default)(EmailConfiguration)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmailConfiguration, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          store = _props.store,
          loader = _props.loader;

      store.init();

      loader.startLoading();
      store.loadEmailConfiguration().finally(loader.endLoading.bind(loader));
      this.disposeObserveTenantID = (0, _mobx.observe)(_Izenda6.default, 'tenantId', function () {
        store.loadEmailConfiguration();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.destroy();
      this.props.resetAlert();
      this.disposeObserveTenantID();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = props.store,
          localization = props.localization;
      var emailConfiguration = store.clonedEmailConfiguration,
          isShowConfiguration = store.isShowConfiguration,
          alertDetails = store.alertDetails;
      var useSystemConfiguration = emailConfiguration.useSystemConfiguration;


      return _react2.default.createElement(
        'div',
        { className: 'u_paddingAll' },
        _react2.default.createElement(ActionHeader, {
          onSave: props.saveConfig,
          onCancel: props.cancelChangeConfig,
          alertDetails: alertDetails,
          onAutoHide: props.resetAlert,
          localization: localization
        }),
        _react2.default.createElement(
          'div',
          { className: 'izenda-Wrapper-content u_paddingAll' },
          isShowConfiguration && _react2.default.createElement(ConfigurationHeader, {
            useSystemConfiguration: useSystemConfiguration,
            enableSystemConfig: props.enableSystemConfig,
            enableCustomConfig: props.enableCustomConfig,
            localization: localization
          }),
          !useSystemConfiguration && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Izenda16.default, { config: emailConfiguration }),
            _react2.default.createElement(_Izenda18.default, { config: emailConfiguration })
          )
        )
      );
    }
  }]);
  return EmailConfiguration;
}(_react.Component)) || _class);
exports.default = EmailConfiguration;
module.exports = exports['default'];

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(119);

var _fp = __webpack_require__(1);

exports.default = (0, _recompose.withHandlers)({
  /**
   * Enable System configuration
   */
  enableSystemConfig: function enableSystemConfig(props) {
    return function () {
      props.store.clonedEmailConfiguration.setValueByKey('useSystemConfiguration', true);
    };
  },

  /**
   * Enable Custom configuration
   */
  enableCustomConfig: function enableCustomConfig(props) {
    return function () {
      props.store.clonedEmailConfiguration.setValueByKey('useSystemConfiguration', false);
    };
  },

  /**
   * Cancel Change config
   */
  cancelChangeConfig: function cancelChangeConfig(props) {
    return function () {
      var valManager = props.validation,
          localization = props.localization,
          store = props.store;
      var emailConfiguration = store.clonedEmailConfiguration,
          alertDetails = store.alertDetails;


      valManager.reset();

      if (!emailConfiguration.isDirty) {
        showNoChangesFound(alertDetails, localization);
      } else {
        return props.confirmFn('Confirmation', {
          description: localization.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
        }).then(function () {
          store.cancelChangeConfiguration();
          emailConfiguration.resetDirty();
          alertDetails.reset();
        });
      }
    };
  },

  /**
   * Save email config
   */
  saveConfig: function saveConfig(props) {
    return function () {
      var valManager = props.validation,
          localization = props.localization,
          store = props.store,
          loader = props.loader;
      var emailConfiguration = store.clonedEmailConfiguration,
          alertDetails = store.alertDetails;


      if (!emailConfiguration.isDirty) {
        showNoChangesFound(alertDetails, localization);
      } else {
        valManager.validate().then(function (success) {
          if (success && validateEmailAddress(props)) {
            return props.confirmFn('Confirmation', {
              description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
            }).then(function () {
              loader.startLoading();
              return store.saveEmailConfiguration();
            }).then(function (result) {
              var messages = result.messages || {};
              messages.length && (messages = messages[0].messages && messages[0].messages[0]);
              messages = result.success ? localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED') : messages;
              store.alertDetails.set({
                success: result.success,
                message: messages
              });
            }).finally(loader.endLoading.bind(loader));
          }
        });
      }
    };
  },

  /**
   * Reset alert details
   */
  resetAlert: function resetAlert(props) {
    return function () {
      return props.store.alertDetails.reset();
    };
  }
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfigurationAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function showNoChangesFound(alertDetails, localization) {
  alertDetails.set({
    success: true,
    message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
  });
}

function validateEmailAddress(props) {
  var valManager = props.validation;

  var email = (0, _fp.get)('store.clonedEmailConfiguration.emailFromAddress', props);
  var messages = [];
  if (email && !_Izenda.EMAIL_VALIDATION.REGEX.test(email)) {
    messages.push({
      key: 'emailFromAddress',
      messages: [_Izenda.EMAIL_VALIDATION.MESSAGE([email])]
    });
  }
  !(0, _fp.isEmpty)(messages) && valManager.updateErrors(messages);
  return (0, _fp.isEmpty)(messages);
}
module.exports = exports['default'];

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SMTPConfiguration.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);
  var connect = __webpack_require__(2);
  var observer = __webpack_require__(10).observer;

  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withState = __webpack_require__(9).withState;

  var GridLayout = __webpack_require__(13);
  var EmailConfigInput = __webpack_require__(1161);
  var Input = __webpack_require__(17);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var action = compose(withState('show', 'setShow', true), withHandlers({
    onChange: curry(handleChangeConfig),
    toggleShow: curry(toggleShow)
  }));

  function handleChangeConfig(props, dataKey, value) {
    props.config.setValueByKey(dataKey, value);
  }

  function toggleShow(props, _) {
    props.setShow(!props.show);
  }

  var SMTPConfiguration = function SMTPConfiguration(props) {
    var config = props.config;
    var localization = props.localization;
    var show = props.show;
    var collapseIcon = show ? 'icon-triangle-down' : 'icon-triangle-right';
    var titleIcon = show ? localization.getText('COMMON_LABEL_COLLAPSE') : localization.getText('COMMON_LABEL_EXPAND');

    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'u-bgGray u_paddingAll' },
        React.createElement(
          'a',
          { onClick: props.toggleShow },
          React.createElement('span', { title: titleIcon, className: collapseIcon })
        ),
        React.createElement(
          'span',
          null,
          localization.getText('SMTP_CONFIGURATION_LABEL_SMTP_CONFIGURATION')
        )
      ),
      show && React.createElement(
        GridLayout,
        { className: 'u-bgWhite u_paddingAll' },
        React.createElement(EmailConfigInput, {
          title: localization.getText('SMTP_CONFIGURATION_LABEL_SMTP_SERVER'),
          value: config.server,
          dataKey: 'server',
          isRequired: true,
          onChange: props.onChange
        }),
        React.createElement(EmailConfigInput, {
          title: localization.getText('SMTP_CONFIGURATION_LABEL_SMTP_PORT'),
          value: config.port,
          dataKey: 'port',
          isRequired: true,
          type: 'numeric',
          onChange: props.onChange
        }),
        React.createElement(EmailConfigInput, {
          title: localization.getText('SMTP_CONFIGURATION_LABEL_SMTP_SECURE_CONNECTION'),
          value: config.secureConnection,
          dataKey: 'secureConnection',
          type: 'checkbox',
          onChange: props.onChange
        }),
        React.createElement(EmailConfigInput, {
          title: localization.getText('SMTP_CONFIGURATION_LABEL_SMTP_LOGIN'),
          value: config.login,
          dataKey: 'login',
          onChange: props.onChange
        }),
        React.createElement(EmailConfigInput, {
          type: 'password',
          title: localization.getText('SMTP_CONFIGURATION_LABEL_SMTP_PASSWORD'),
          value: config.password,
          dataKey: 'password',
          onChange: props.onChange
        })
      )
    );
  };

  module.exports = connect(action)(SMTPConfiguration);
}();

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailInfo.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var EventUtils = __webpack_require__(24);
  var connect = __webpack_require__(2);

  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withState = __webpack_require__(9).withState;

  var EmailConfigInput = __webpack_require__(1161);
  var GridLayout = __webpack_require__(13);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var action = compose(withState('show', 'setShow', true), withHandlers({
    onChange: curry(handleChangeConfig),
    toggleShow: curry(toggleShow)
  }));

  function handleChangeConfig(props, dataKey, value) {
    props.config.setValueByKey(dataKey, value);
  }

  function toggleShow(props, _) {
    props.setShow(!props.show);
  }

  var EmailInfo = function EmailInfo(props) {
    var config = props.config;
    var localization = props.localization;
    var show = props.show;
    var collapseIcon = show ? 'icon-triangle-down' : 'icon-triangle-right';
    var titleIcon = show ? localization.getText('COMMON_LABEL_COLLAPSE') : localization.getText('COMMON_LABEL_EXPAND');

    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'u-bgGray u_paddingAll' },
        React.createElement(
          'a',
          { onClick: props.toggleShow },
          React.createElement('span', { title: titleIcon, className: collapseIcon })
        ),
        React.createElement(
          'span',
          null,
          localization.getText('EMAIL_LABEL_EMAIL_INFO')
        )
      ),
      show && React.createElement(
        GridLayout,
        { className: 'u-bgWhite u_paddingAll' },
        React.createElement(EmailConfigInput, {
          title: localization.getText('EMAIL_LABEL_DISPLAY_NAME'),
          value: config.displayName,
          dataKey: 'displayName',
          onChange: props.onChange
        }),
        React.createElement(EmailConfigInput, {
          title: localization.getText('EMAIL_LABEL_EMAIL_FROM_ADDRESS'),
          value: config.emailFromAddress,
          dataKey: 'emailFromAddress',
          isRequired: true,
          onChange: props.onChange
        })
      )
    );
  };

  module.exports = connect(action)(EmailInfo);
}();

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfiguration.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportConfiguration component
 */
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var actions = __webpack_require__(435);
  var ReportConfigurationHeader = __webpack_require__(2457);
  var ReportConfigurationContent = __webpack_require__(2458);
  var ScrollBox = __webpack_require__(27);

  var ReportConfiguration = React.createClass({
    displayName: 'ReportConfiguration',

    componentDidMount: function componentDidMount() {
      var loader = this.props.loader;
      loader.startLoading();
      this.props.store.initData().finally(loader.endLoading.bind(loader));
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'izenda-ReportConfiguration u_fullHeight u-posRelative' },
        React.createElement(ReportConfigurationHeader, this.props),
        React.createElement(
          'div',
          { className: 'u_fullHeight' },
          React.createElement(
            ScrollBox,
            null,
            React.createElement(ReportConfigurationContent, this.props)
          )
        )
      );
    }
  });

  module.exports = connect(actions)(ReportConfiguration);
}();

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfigurationHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportConfigurationHeader component
 */
!function () {
  "use strict";

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var Button = __webpack_require__(30);
  var Alert = __webpack_require__(61);
  var GridLayout = __webpack_require__(13);

  var actions = __webpack_require__(435);

  var ReportConfigurationHeader = function ReportConfigurationHeader(props) {
    var localization = props.localization;
    var alertDetail = props.store.alertDetail;
    return React.createElement(
      GridLayout,
      { className: 'u_paddingBottom' },
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: '7' },
          React.createElement(
            Alert,
            { className: 'u_floatLeft u_marginLeft', type: alertDetail.alertType },
            alertDetail.message
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '5' },
          React.createElement(Button, { label: localization.getText('COMMON_LABEL_CANCEL'), className: 'u_marginLeftRight u_floatRight', onClick: props.onCancel }),
          React.createElement(Button, { label: localization.getText('COMMON_LABEL_SAVE'), className: 'u_marginLeft u_floatRight', onClick: props.onSave })
        )
      )
    );
  };

  module.exports = connect(actions)(ReportConfigurationHeader);
}();

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfigurationContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportConfigurationContent component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(435);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2459);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(28);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(17);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(30);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(109);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(13);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2460);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2461);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VersionHeaderPanel = (0, _Izenda2.default)()(function (props) {
  var localization = props.localization;

  return _react2.default.createElement(
    'div',
    { onClick: props.collapseToggle },
    _react2.default.createElement(
      'div',
      { className: 'u_inlineBlock u_marginRight' },
      _react2.default.createElement('i', { className: 'icon-toggle-triangle' }),
      _react2.default.createElement(
        'strong',
        null,
        localization.getText('SYSTEM_CONFIGURATION_REPORT_LABEL_VERSION')
      )
    ),
    _react2.default.createElement(_Izenda12.default, {
      onClick: props.onClearArchivedVersion,
      disabled: !props.store.reportConfiguration.enforceVersionHistory,
      label: localization.getText('SYSTEM_CONFIGURATION_REPORT_CLEAR_ARCHIVED_VERSIONS_NOW')
    })
  );
});

var DefaultImageHeaderPanel = (0, _Izenda2.default)()(function (props) {
  var localization = props.localization;

  return _react2.default.createElement(
    'div',
    { onClick: props.collapseToggle },
    _react2.default.createElement('i', { className: 'icon-toggle-triangle' }),
    _react2.default.createElement(
      'strong',
      null,
      localization.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_HEADER_IMAGE')
    )
  );
});

var ReportVersionStorage = (0, _Izenda2.default)()(function (props) {
  var model = props.store.reportConfiguration,
      localization = props.localization;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('hr', null),
    _react2.default.createElement(
      'p',
      null,
      localization.getText('SYSTEM_CONFIGURATION_REPORT_LABEL_VERSION_STORAGE')
    ),
    _react2.default.createElement(
      'div',
      { className: 'u_marginLeft input-group' },
      _react2.default.createElement(
        'span',
        null,
        localization.getText('SYSTEM_CONFIGURATION_REPORT_ARCHIVE_VERSION_TO_KEEPS')
      ),
      _react2.default.createElement(_Izenda14.default, {
        className: 'u_marginLeftRight u_inlineBlock',
        min: 0,
        max: 20,
        value: model.numOfArchivedVersionToKeep,
        onBlur: props.setNumOfArchivedVersionToKeep.bind(props, model.numOfArchivedVersionToKeep),
        onChange: model.setValueByKey.bind(model, 'numOfArchivedVersionToKeep')
      }),
      _react2.default.createElement(
        'a',
        { onClick: model.resetNumOfArchivedVersionToKeep.bind(model), title: 'Reset value' },
        _react2.default.createElement('span', { className: 'icon-ccw resetButton' })
      )
    ),
    _react2.default.createElement(
      _Izenda16.default,
      { className: 'u_marginLeft' },
      _react2.default.createElement(
        _Izenda16.default.Row,
        null,
        _react2.default.createElement(
          _Izenda16.default.Col,
          { cols: '3' },
          _react2.default.createElement(
            'div',
            { className: 'checkbox' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda10.default, {
                type: 'checkbox',
                checked: model.removeArchivedVersions,
                onChange: props.onCheckRemoveArchivedVersions
              }),
              localization.getText('SYSTEM_CONFIGURATION_REPORT_REMOVE_ARCHIVED_VERSIONS')
            )
          )
        ),
        model.removeArchivedVersions && _react2.default.createElement(_Izenda6.default, props)
      )
    )
  );
});

var ReportConfigurationContent = (_dec = (0, _Izenda2.default)(_Izenda4.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ReportConfigurationContent, _Component);

  function ReportConfigurationContent() {
    (0, _classCallCheck3.default)(this, ReportConfigurationContent);
    return (0, _possibleConstructorReturn3.default)(this, (ReportConfigurationContent.__proto__ || (0, _getPrototypeOf2.default)(ReportConfigurationContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportConfigurationContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.store.init();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = props.store,
          model = props.store.reportConfiguration,
          localization = props.localization;

      var header = {
        className: 'u-bgGray',
        component: VersionHeaderPanel,
        onClearArchivedVersion: props.onClearArchivedVersion,
        store: store
      };
      var defaultImageHeader = {
        className: 'u-bgGray',
        component: DefaultImageHeaderPanel
      };

      return _react2.default.createElement(
        'div',
        { className: 'u_paddingLeftRight izenda-ReportConfiguration' },
        (0, _fp.isNil)(store.tenantId) && _react2.default.createElement(
          _Izenda8.default,
          { header: header, collapsible: true, expanedOption: true },
          _react2.default.createElement(
            'p',
            null,
            localization.getText('SYSTEM_CONFIGURATION_REPORT_LABEL_VERSION_HISTORY')
          ),
          _react2.default.createElement(
            'div',
            { className: 'checkbox' },
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_Izenda10.default, {
                type: 'checkbox',
                checked: model.enforceVersionHistory,
                onChange: props.setEnforceVersionHistory
              }),
              localization.getText('SYSTEM_CONFIGURATION_REPORT_ENFORCE_VERSION_HISTORY')
            )
          ),
          model.enforceVersionHistory && _react2.default.createElement(ReportVersionStorage, props)
        ),
        _react2.default.createElement(
          _Izenda8.default,
          { header: defaultImageHeader, collapsible: true, expanedOption: true },
          _react2.default.createElement(
            'div',
            { className: 'u_marginLeft' },
            _react2.default.createElement(
              'span',
              null,
              localization.getText('SYSTEM_CONFIGURATION_REPORT_RELATIVE_PATH_OR_URL')
            ),
            _react2.default.createElement(
              'div',
              { className: 'u_inlineBlock u_marginLeft' },
              _react2.default.createElement(_Izenda10.default, {
                type: 'text',
                maxLength: 256,
                value: model.defaultImageUrl.value,
                onChange: props.defaultImageUrlHander
              })
            )
          )
        ),
        store.doesNeedToValidateGlobalAndLocalNames() && _react2.default.createElement(_Izenda18.default, { store: store }),
        _react2.default.createElement(_Izenda20.default, { store: store })
      );
    }
  }]);
  return ReportConfigurationContent;
}(_react.Component)) || _class);
exports.default = ReportConfigurationContent;
module.exports = exports['default'];

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfigurationRecurrent.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportConfigurationRecurrent component
 */
!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);
  var EventsUtils = __webpack_require__(24);
  var connect = __webpack_require__(2);

  var moment = __webpack_require__(19);
  var momentTimezone = __webpack_require__(276);

  var actions = __webpack_require__(435);
  var Input = __webpack_require__(17);
  var NumericInput = __webpack_require__(109);
  var GridLayout = __webpack_require__(13);

  var Validator = __webpack_require__(23);
  var DateTimePicker = Validator()(__webpack_require__(170));
  var constants = __webpack_require__(939);

  var RecurrenceTime = connect()(function (props) {
    var model = props.model;
    var recurrentSetting = model.recurrentReportSetting;
    var recurrenceType = model.recurrentReportSetting.recurrenceType;
    var disabledNumberInput = recurrenceType !== props.type || recurrentSetting.once;

    return React.createElement(
      'div',
      null,
      React.createElement(
        'label',
        null,
        React.createElement(Input, {
          type: 'radio',
          checked: recurrenceType === props.type,
          disabled: recurrentSetting.once,
          onChange: EventsUtils.notifyChange(model.setRecurrenceType.bind(model, props.type), EventsUtils.RADIO) }),
        'Every'
      ),
      React.createElement(NumericInput, {
        min: constants.ARCHIVED_VERSIONS_MIN_VALUE,
        max: constants.ARCHIVED_VERSIONS_MAX_VALUE,
        disabled: disabledNumberInput,
        value: disabledNumberInput ? null : model.recurrentReportSetting.occurValue,
        onChange: model.setValueByKey.bind(model, "occurValue") }),
      React.createElement(
        'label',
        null,
        props.labelType
      )
    );
  });

  var ReportConfigurationRecurrent = React.createClass({
    displayName: 'ReportConfigurationRecurrent',

    render: function render() {
      var props = this.props;
      var model = props.store.reportConfiguration;
      var recurrentSetting = model.recurrentReportSetting;

      return React.createElement(
        GridLayout.Col,
        { cols: '9' },
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '2' },
            React.createElement(
              'div',
              { className: 'radio' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'radio',
                  name: 'optradio',
                  checked: recurrentSetting.once,
                  onChange: EventsUtils.notifyChange(model.setTypeArchived.bind(model, "once"), EventsUtils.RADIO) }),
                'Once'
              )
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '5' },
            React.createElement(
              'span',
              null,
              'At Date'
            ),
            React.createElement(DateTimePicker, {
              field: 'atDate',
              validations: recurrentSetting.once ? constants.requiredConstraints("At Date") : {},
              containerClassName: 'izenda-ReportConfiguration-control',
              time: false,
              disabled: !recurrentSetting.once,
              value: recurrentSetting.atDate,
              onChange: model.setValueByKey.bind(model, "atDate")
            })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '5' },
            React.createElement(
              'span',
              null,
              'At Time'
            ),
            React.createElement(DateTimePicker, {
              field: 'atTime',
              validations: recurrentSetting.once ? constants.requiredConstraints("At Time") : {},
              containerClassName: 'izenda-ReportConfiguration-control',
              calendar: false,
              disabled: !recurrentSetting.once,
              value: momentTimezone(recurrentSetting.atTime),
              onChange: props.onChangeTime.bind(props, "atTime")
            })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '2' },
            React.createElement(
              'div',
              { className: 'radio' },
              React.createElement(
                'label',
                null,
                React.createElement(Input, {
                  type: 'radio',
                  name: 'optradio',
                  checked: recurrentSetting.recurrence,
                  onChange: EventsUtils.notifyChange(model.setTypeArchived.bind(model, "recurrence"), EventsUtils.RADIO) }),
                'Recurrence'
              )
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '5' },
            React.createElement(
              'span',
              null,
              'Start Date'
            ),
            React.createElement(DateTimePicker, {
              field: 'startDate',
              validations: recurrentSetting.recurrence ? constants.requiredConstraints("Start Date") : {},
              containerClassName: 'izenda-ReportConfiguration-control',
              time: false,
              disabled: !recurrentSetting.recurrence,
              value: recurrentSetting.startDate,
              onChange: model.setValueByKey.bind(model, "startDate")
            })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '5' },
            React.createElement(
              'span',
              null,
              'Start Time'
            ),
            React.createElement(DateTimePicker, {
              field: 'startTime',
              validations: recurrentSetting.recurrence ? constants.requiredConstraints("Start Time") : {},
              containerClassName: 'izenda-ReportConfiguration-control',
              calendar: false,
              disabled: !recurrentSetting.recurrence,
              value: momentTimezone(recurrentSetting.startTime),
              onChange: props.onChangeTime.bind(props, "startTime")
            })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '5', offset: '2' },
            React.createElement(RecurrenceTime, { model: model, type: 0, labelType: 'day(s)' })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '5' },
            React.createElement(RecurrenceTime, { model: model, type: 1, labelType: 'week(s)' })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '5', offset: '2' },
            React.createElement(RecurrenceTime, { model: model, type: 2, labelType: 'month(s)' })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '5' },
            React.createElement(RecurrenceTime, { model: model, type: 3, labelType: 'year(s)' })
          )
        )
      );
    }
  });

  module.exports = connect(actions)(ReportConfigurationRecurrent);
}();

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.GlobalAndLocalNames.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Global And Local Names component
 */
!function () {
  var React = __webpack_require__(0);
  var EventsUtils = __webpack_require__(24);
  var notifyChange = EventsUtils.notifyChange;
  var connect = __webpack_require__(2);
  var Validator = __webpack_require__(23);
  var constants = __webpack_require__(625);

  var Panel = __webpack_require__(28);
  var GridLayout = __webpack_require__(13);
  var ValidateInput = Validator()(__webpack_require__(17));

  var GlobalAndLocalNames = function GlobalAndLocalNames(props) {

    var GlobalAndLocalNamesHeaderPanel = connect()(function (props) {
      var localization = props.localization;

      return React.createElement(
        'div',
        { onClick: props.collapseToggle },
        React.createElement('i', { className: 'icon-toggle-triangle' }),
        React.createElement(
          'strong',
          null,
          localization.getText('SYSTEM_CONFIGURATION_REPORT_GLOBAL_AND_LOCAL_NAMES')
        )
      );
    });

    var localization = props.localization;
    var store = props.store;
    var model = store.reportConfiguration;
    var header = {
      className: 'u-bgGray',
      component: GlobalAndLocalNamesHeaderPanel
    };
    return React.createElement(
      Panel,
      { header: header, collapsible: true, expanedOption: true, panelBodyClassName: 'izenda-ReportConfiguration-GlobalLocalName_Body' },
      React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '2' },
            React.createElement(
              'label',
              { className: 'u_marginLeft' },
              localization.getText('SYSTEM_CONFIGURATION_REPORT_GLOBAL_NAME')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '6' },
            React.createElement(ValidateInput, { type: 'text',
              className: 'form-control',
              maxLength: 256,
              value: model.globalCategoryName,
              onChange: notifyChange(model.setValueByKey.bind(model, 'globalCategoryName'), EventsUtils.INPUT),
              field: 'globalCategoryName',
              validations: constants.CONSTRAINTS.GLOBAL_NAME })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '2' },
            React.createElement(
              'label',
              { className: 'u_marginLeft' },
              localization.getText('SYSTEM_CONFIGURATION_REPORT_LOCAL_NAME')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '6' },
            React.createElement(ValidateInput, { type: 'text',
              className: 'form-control',
              maxLength: 256,
              value: model.localCategoryName,
              onChange: notifyChange(model.setValueByKey.bind(model, 'localCategoryName'), EventsUtils.INPUT),
              field: 'localCategoryName',
              validations: constants.CONSTRAINTS.LOCAL_NAME })
          )
        )
      )
    );
  };

  module.exports = connect()(GlobalAndLocalNames);
}();

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultColorTheme.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Default Color Theme Component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(423);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultColorTheme = (_dec = (0, _Izenda6.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(DefaultColorTheme, _Component);

  function DefaultColorTheme() {
    (0, _classCallCheck3.default)(this, DefaultColorTheme);
    return (0, _possibleConstructorReturn3.default)(this, (DefaultColorTheme.__proto__ || (0, _getPrototypeOf2.default)(DefaultColorTheme)).apply(this, arguments));
  }

  (0, _createClass3.default)(DefaultColorTheme, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.props.store;

      this.loadDefaultThemeObserver = (0, _mobx.observe)(_Izenda2.default, 'tenantId', function () {
        store.reportConfiguration.resetData();
        store.loadDefaultTheme();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.loadDefaultThemeObserver();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          _props$store = _props.store,
          reportConfiguration = _props$store.reportConfiguration,
          defaultColorTheme = _props$store.reportConfiguration.defaultColorTheme;


      var DefaultColorThemeHeaderPanel = (0, _Izenda6.default)()(function (props) {
        return _react2.default.createElement(
          'div',
          { onClick: props.collapseToggle },
          _react2.default.createElement('i', { className: 'icon-toggle-triangle' }),
          _react2.default.createElement(
            'strong',
            null,
            localization.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_COLOR_THEME_HEADER')
          )
        );
      });

      var header = {
        className: 'u-bgGray',
        component: DefaultColorThemeHeaderPanel
      };

      return _react2.default.createElement(
        _Izenda4.default,
        {
          header: header,
          collapsible: true,
          expanedOption: true,
          panelBodyClassName: 'izenda-ReportConfiguration-DefaultColorTheme_Body'
        },
        _react2.default.createElement(
          'div',
          { className: 'izenda-ReportConfiguration-DefaultColorTheme_Info' },
          localization.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_COLOR_THEME_INFO')
        ),
        !(0, _fp.isUndefined)(defaultColorTheme.value) && _react2.default.createElement(_Izenda8.default, {
          selectedPaletteName: defaultColorTheme.value,
          selectionPopupTitle: localization.getText('COLORTHEME_POPUP_HEADER_DEFAULT'),
          defaultColorThemeLabel: localization.getText('COLORPALETTE_NODEFAULT'),
          displaySettingStatus: false,
          updateSelectedPalette: reportConfiguration.setValueByKey.bind(reportConfiguration, 'defaultColorTheme'),
          needMaskDefault: false
        })
      );
    }
  }]);
  return DefaultColorTheme;
}(_react.Component)) || _class);
exports.default = DefaultColorTheme;
module.exports = exports['default'];

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2463);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2467);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(27);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Scheduling = function Scheduling(props) {
  var store = props.store;

  return _react2.default.createElement(
    'div',
    { className: 'izenda-Wrapper izenda-Scheduling' },
    _react2.default.createElement(
      _Izenda8.default,
      null,
      _react2.default.createElement(
        'div',
        { className: 'u_paddingLeftRight' },
        _react2.default.createElement(_Izenda4.default, { store: store }),
        _react2.default.createElement(_Izenda6.default, { store: store })
      )
    )
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.Scheduling.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda2.default)()(Scheduling);
module.exports = exports['default'];

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchCriteria.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);

  var EventUtils = __webpack_require__(24);
  var classnames = __webpack_require__(11);
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);
  var actions = __webpack_require__(2464);

  var ReportingType = __webpack_require__(2465);
  var GridLayout = __webpack_require__(13);
  var DropDown = __webpack_require__(29);
  var Button = __webpack_require__(30);
  var Validator = __webpack_require__(23);
  var DateTimePicker = Validator()(__webpack_require__(170));

  var Select = __webpack_require__(47);
  var CONSTANTS = __webpack_require__(158);
  var LicenseCheckerConstants = __webpack_require__(45);

  var _require = __webpack_require__(1),
      remove = _require.remove;

  var CriteriaMultiSelect = observer(function (props) {
    return React.createElement(
      GridLayout.Col,
      { cols: 3 },
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: 4, className: 'u_textRight' },
          React.createElement(
            'label',
            { className: 'control-label' },
            props.title
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: 8 },
          React.createElement(Select, {
            multi: true,
            value: props.value,
            options: props.options,
            valueKey: 'value',
            labelKey: 'label',
            onChange: handleChangeOption
          })
        )
      )
    );

    function handleChangeOption(listSelectOption) {
      props.onChange(props.dataKey, listSelectOption);
    }
  });

  var CriteriaOption = observer(function (props) {
    return React.createElement(
      GridLayout.Col,
      { cols: 3 },
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: 4, className: 'u_textRight' },
          React.createElement(
            'label',
            { className: 'control-label u_textRight' },
            props.title
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: 8 },
          React.createElement(DropDown, {
            value: props.value,
            options: props.options,
            onChange: EventUtils.notifyChange(handleChangeOption, EventUtils.DROPDOWN)
          })
        )
      )
    );

    function handleChangeOption(newVal) {
      props.onChange(props.dataKey, newVal);
    }
  });

  var DateOption = observer(function (props) {
    var className = classnames({ u_textRight: !props.isToDate, u_textLeft: props.isToDate });
    return React.createElement(
      GridLayout.Col,
      { cols: 3 },
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: props.isToDate ? 1 : 4, className: className },
          React.createElement(
            'label',
            { className: 'control-label' },
            props.title
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: 8 },
          React.createElement(DateTimePicker, {
            value: props.value,
            time: false,
            onChange: handleChange,
            field: props.dataKey,
            onBlur: props.onBlur
          })
        )
      )
    );

    function handleChange(value) {
      props.onChange(props.dataKey, value);
    }
  });

  var SearchCriteria = function SearchCriteria(props) {
    var store = props.store;
    var criteria = store.criteria;
    var recurrenceOptions = criteria.recurrenceOptions;
    var deliveryMethodOptions = criteria.deliveryMethodOptions;
    var createdByOptions = criteria.createdByOptions.peek();
    var recipientsOptions = criteria.recipientsOptions.peek();
    var instanceTypes = CONSTANTS.INSTANCE_TYPE;
    var localization = props.localization;
    var authorization = props.authorization;
    var hasAlertingLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Alerting);

    // Don't show Schechuled Alert & Subscribed Alert if don't have Alerting License
    if (!hasAlertingLicense) {
      instanceTypes = remove({ alertingLicense: true }, instanceTypes);
    }

    return React.createElement(
      'div',
      { className: 'u_marginBottom u_borderAll' },
      React.createElement(
        'div',
        { className: 'izenda-SearchCriteria-Header u_paddingAll' },
        React.createElement(
          'span',
          { className: 'u_textBold' },
          localization.getText('SEARCH_RESULT_LABEL_SEARCH_CRITERIA')
        )
      ),
      React.createElement(
        GridLayout,
        { className: 'izenda-SearchCriteria-Body u_paddingAll form-horizontal' },
        React.createElement(ReportingType, { criteria: criteria, onAddNewReportName: props.handleAddNewReportName, store: store }),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(CriteriaMultiSelect, {
            dataKey: 'instanceType',
            title: localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_INSTANCE_TYPE'),
            value: criteria.getMultiValueCriteria('instanceType'),
            onChange: props.handleChangeMultiValuesCriteria,
            options: instanceTypes
          }),
          React.createElement(CriteriaMultiSelect, {
            dataKey: 'recurrence',
            title: localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECURRENCE'),
            value: criteria.getMultiValueCriteria('recurrence'),
            onChange: props.handleChangeMultiValuesCriteria,
            options: recurrenceOptions
          }),
          React.createElement(CriteriaMultiSelect, {
            dataKey: 'deliveryType',
            title: localization.getText('COMMON_LABEL_DELIVERY_TYPE'),
            value: criteria.getMultiValueCriteria('deliveryType'),
            onChange: props.handleChangeDeliveryType,
            options: CONSTANTS.DELIVERY_TYPE
          }),
          React.createElement(CriteriaMultiSelect, {
            dataKey: 'deliveryMethod',
            title: localization.getText('COMMON_LABEL_DELIVERY_METHOD'),
            value: criteria.getMultiValueCriteria('deliveryMethod'),
            onChange: props.handleChangeMultiValuesCriteria,
            options: deliveryMethodOptions
          })
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(CriteriaMultiSelect, {
            dataKey: 'exportFileType',
            title: localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_EXPORT_FILE_TYPE'),
            value: criteria.getMultiValueCriteria('exportFileType'),
            onChange: props.handleChangeMultiValuesCriteria,
            options: CONSTANTS.EXPORT_FILE_TYPE
          }),
          React.createElement(CriteriaMultiSelect, {
            dataKey: 'createdBy',
            title: localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_CREATED_BY'),
            value: criteria.getMultiValueCriteria('createdBy'),
            onChange: props.handleChangeMultiValuesCriteria,
            options: createdByOptions
          }),
          !criteria.isHiddenRecipients && React.createElement(CriteriaMultiSelect, {
            dataKey: 'recipients',
            title: localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_RECIPENT'),
            value: criteria.getMultiValueCriteria('recipients'),
            onChange: props.handleChangeMultiValuesCriteria,
            options: recipientsOptions
          })
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(CriteriaOption, {
            dataKey: 'lastSuccessfulRun',
            title: localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_LAST_SUCCESS_RUN'),
            value: criteria.lastSuccessfulRun,
            onChange: props.handleChangeCriteria,
            options: CONSTANTS.LAST_SUCCESS_RUN
          }),
          React.createElement(GridLayout.Col, { cols: 3 }),
          ' ',
          React.createElement(CriteriaOption, {
            dataKey: 'nextScheduledRun',
            title: localization.getText('SCHEDULING_SEARCH_CONSTANT_LABEL_NEXT_SCHEDULED_RUN'),
            value: criteria.nextScheduledRun,
            onChange: props.handleChangeCriteria,
            options: CONSTANTS.NEXT_SCHEDULED_RUN
          })
        ),
        React.createElement(
          GridLayout.Row,
          null,
          criteria.isDateLastSuccessRun ? React.createElement(DateOption, {
            dataKey: 'lastSuccessfulRunFrom',
            title: localization.getText('COMMON_LABEL_FROM'),
            value: criteria.lastSuccessfulRunFrom,
            onChange: props.handleChangeCriteria,
            onBlur: props.validateLastSuccessfulRunDate
          }) : React.createElement(GridLayout.Col, { cols: 3 }),
          criteria.isDateLastSuccessRun ? React.createElement(DateOption, {
            isToDate: true,
            dataKey: 'lastSuccessfulRunTo',
            title: localization.getText('COMMON_LABEL_TO'),
            value: criteria.lastSuccessfulRunTo,
            onChange: props.handleChangeCriteria,
            onBlur: props.validateLastSuccessfulRunDate
          }) : React.createElement(GridLayout.Col, { cols: 3 }),
          criteria.isNextScheduledRun && React.createElement(DateOption, {
            dataKey: 'nextScheduledRunFrom',
            title: localization.getText('COMMON_LABEL_FROM'),
            value: criteria.nextScheduledRunFrom,
            onChange: props.handleChangeCriteria,
            onBlur: props.validateNextScheduledRunDate
          }),
          criteria.isNextScheduledRun && React.createElement(DateOption, {
            isToDate: true,
            dataKey: 'nextScheduledRunTo',
            title: localization.getText('COMMON_LABEL_TO'),
            value: criteria.nextScheduledRunTo,
            onChange: props.handleChangeCriteria,
            onBlur: props.validateNextScheduledRunDate
          })
        )
      ),
      React.createElement(
        'div',
        { className: 'izenda-SearchCriteria-Footer u_paddingAll u_textRight' },
        React.createElement(
          Button,
          { className: 'u_marginRight', onClick: props.handleSearch },
          React.createElement('span', { className: 'icon-search' }),
          ' ',
          localization.getText('COMMON_LABEL_SEARCH')
        ),
        React.createElement(
          'button',
          { className: 'btn btn-default', onClick: props.resetData },
          React.createElement(
            'span',
            null,
            localization.getText('COMMON_LABEL_RESET')
          )
        )
      )
    );
  };

  module.exports = connect(actions)(SearchCriteria);
}();

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchCriteriaAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var lifecycle = __webpack_require__(9).lifecycle;
  var observe = __webpack_require__(5).observe;
  var uiState = __webpack_require__(15);
  var compareDateStringFormat = __webpack_require__(264).compareDateStringFormat;
  var VALIDATE_DATE_MESSAGE = __webpack_require__(158).VALIDATE_DATE_MESSAGE;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      last = _require.last,
      isEmpty = _require.isEmpty,
      filter = _require.filter,
      map = _require.map,
      get = _require.get,
      findIndex = _require.findIndex;

  var SearchCriteriaAction = compose(withHandlers({
    handleChangeMultiValuesCriteria: curry(handleChangeMultiValuesCriteria),
    handleChangeCriteria: curry(handleChangeCriteria),
    handleChangeDeliveryType: curry(handleChangeDeliveryType),
    handleAddNewReportName: curry(handleAddNewReportName),
    handleSearch: curry(handleSearch),
    resetData: curry(resetData),
    validateLastSuccessfulRunDate: curry(validateLastSuccessfulRunDate),
    validateNextScheduledRunDate: curry(validateNextScheduledRunDate)
  }), lifecycle({
    componentDidMount: function componentDidMount() {
      var props = this.props;
      var store = props.store;
      initData(props);
      this.disposeObserveTenantID = observe(uiState, 'tenantId', function () {
        store.resetData();
        initData(props);
      });
    },
    componentWillUnmount: function componentWillUnmount() {
      this.disposeObserveTenantID();
    }
  }));

  /**
   * Init search criteria data
   * @param props
   */
  function initData(props) {
    var store = props.store;
    var loader = props.loader;
    loader.startLoading();
    (0, _bluebird.join)(store.loadEmailTemplates(), store.loadReportDashboardName(), store.loadCreatorByTenant(), store.loadRecipientsByTenant()).finally(loader.endLoading.bind(loader));
  }

  /**
   * Handle Change Multivalues Criteria
   * If "All" selected, other criteria is automatically removed
   * If not "All" selected, "All" criteria is removed
   * @param props
   * @param key
   * @param options
   */
  function handleChangeMultiValuesCriteria(props, key, options) {
    if (options.length === 0) {
      options = [{
        value: '',
        label: 'All'
      }];
    }
    var lastOption = last(options);
    if (isEmpty(lastOption.value)) {
      options = [lastOption];
    } else {
      options = filter(function (item) {
        return !!item.value;
      }, options);
    }
    options = map(get('value'), options).join(';');
    props.store.criteria.setValueByKey(key, options);
  }

  /**
   * Change Single criteria
   * @param props
   * @param key
   * @param value
   */
  function handleChangeCriteria(props, key, value) {
    props.store.criteria.setValueByKey(key, value);
  }

  /**
   * Set delivery type, reset delivery method
   * @param props
   * @param key
   * @param value
   */
  function handleChangeDeliveryType(props, key, value) {
    handleChangeMultiValuesCriteria(props, key, value);
    props.store.criteria.setValueByKey('deliveryMethod', '');
  }

  /**
   * Add a user specified Report Name to reportDashboardNames's option data
   * @param props
   * @param newData
   */
  function handleAddNewReportName(props, newData) {
    if (isEmpty(newData.value.trim())) {
      return;
    }
    var reportDashboardNameOptions = props.store.criteria.reportDashboardNameOptions;
    var index = findIndex({ value: newData.value }, reportDashboardNameOptions);
    index === -1 && props.store.criteria.reportDashboardNameOptions.push({
      label: newData.label,
      value: newData.value,
      isNew: newData.isNew
    });
  }

  /**
   * Handle searching
   * Put the calling to db into window.setTimeout() to make it run after other control fire onBlur event
   * @param props
   */
  function handleSearch(props, _) {
    window.setTimeout(function () {
      var loader = props.loader;
      loader.startLoading();
      props.store.loadSchedules().finally(loader.endLoading.bind(loader));
    }, 0);
  }

  /**
   * Reset the page back to it's first launched state
   * @param props
   */
  function resetData(props, _) {
    props.store.resetData();
  }

  function validateLastSuccessfulRunDate(props, _) {
    validateDate(props, 'lastSuccessfulRunFrom', 'lastSuccessfulRunTo');
  }

  function validateNextScheduledRunDate(props, _) {
    validateDate(props, 'nextScheduledRunFrom', 'nextScheduledRunTo');
  }

  function validateDate(props, from, to) {
    var valManager = props.validation;
    var criteria = props.store.criteria;
    valManager.reset();
    if (compareDateStringFormat(criteria[from], criteria[to])) {
      valManager.updateErrors(constructValidateMessage([from, to]));
    }
  }

  function constructValidateMessage(keys) {
    return keys.map(function (key) {
      return {
        key: key,
        messages: [VALIDATE_DATE_MESSAGE]
      };
    });
  }

  module.exports = SearchCriteriaAction;
}();

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportingType.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var action = __webpack_require__(2466);
  var GridLayout = __webpack_require__(13);
  var DropDown = __webpack_require__(29);
  var Select = __webpack_require__(47);
  var LicenseCheckerConstants = __webpack_require__(45);
  var CONSTANTS = __webpack_require__(158);

  var _require = __webpack_require__(1),
      remove = _require.remove;

  var ReportingType = function ReportingType(props) {
    var criteria = props.criteria;
    var localization = props.localization;
    var hasDashboardLicense = props.authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Dashboard);
    var reportTypeOption = remove(function (type) {
      return !hasDashboardLicense && type.value === 'Dashboard';
    }, CONSTANTS.REPORT_TYPE);

    return React.createElement(
      GridLayout.Row,
      { className: 'u_marginBottom' },
      React.createElement(
        GridLayout.Col,
        { cols: 1, className: 'u_textRight' },
        React.createElement(
          'label',
          { className: 'control-label' },
          localization.getText('SYSTEM_CONFIGURATION_LABEL_REPORTING_TYPE')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { cols: 11, className: 'izenda-SearchCriteria_ReportType' },
        React.createElement(DropDown, {
          className: 'u_floatLeft',
          value: criteria.reportType,
          options: reportTypeOption,
          onChange: props.handleChangeReportType
        }),
        React.createElement(Select, {
          className: 'u_floatLeft',
          placeholder: localization.getText('SYSTEM_CONFIGURATION_PLACEHOLDER_REPORT_OR_DASHBOARD_NAME'),
          value: criteria.name,
          multi: true,
          delimiter: ';',
          simpleValue: true,
          joinValues: true,
          onAddNew: props.onAddNewReportName,
          options: criteria.reportDashboardNameOptions,
          onBlur: props.handleBlur,
          onChange: props.handleChangeReportName,
          onInputChange: props.handleInputChange,
          onBlurResetsInput: false,
          isInsertOnBlur: true
        })
      )
    );
  };

  module.exports = connect(action)(ReportingType);
}();

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportingTypeAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!function () {

  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var SearchCriteriaAction = compose(withHandlers({
    handleChangeReportName: curry(handleChangeReportName),
    handleChangeReportType: curry(handleChangeReportType),
    handleBlur: curry(handleBlur)
  }));

  /**
   * Handle change report name
   * @param props
   * @param newVal
   */
  function handleChangeReportName(props, newVal) {
    props.criteria.setValueByKey('name', newVal);
  }

  /**
   * Handle change report type
   * @param props
   * @param newVal
   */
  function handleChangeReportType(props, newVal) {
    var loader = props.loader;
    loader.startLoading();
    props.criteria.setValueByKey('reportType', newVal.value);
    props.store.loadReportDashboardName().finally(loader.endLoading.bind(loader));
  }

  /**
   * Handle unfocus report/dashboard input control
   * @param props
   * @param value
   */
  function handleBlur(props, value) {
    props.onAddNewReportName(value);
  }

  module.exports = SearchCriteriaAction;
}();

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchResult.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var ScrollBox = __webpack_require__(27);
  var SearchGridResult = __webpack_require__(2468);

  var SearchResult = function SearchResult(props) {

    var store = props.store;
    var searchResult = store.searchResult;
    var isEmpty = searchResult.isEmpty;
    var systemSearchResult = searchResult.systemSearchResult;
    var tenantSearchResult = searchResult.tenantSearchResult;
    var localization = props.localization;

    return React.createElement(
      'div',
      { className: 'izenda-SearchResult' },
      React.createElement(
        'div',
        { className: 'izenda-SearchResult-Header u_paddingAll' },
        React.createElement(
          'span',
          { className: 'u_textBold' },
          localization.getText("SEARCH_RESULT_LABEL_SEARCH_RESULT")
        )
      ),
      !isEmpty ? React.createElement(
        'div',
        { className: 'izenda-SearchResult-Content', style: { height: 500 } },
        React.createElement(
          ScrollBox,
          null,
          !systemSearchResult.isEmpty && React.createElement(SearchGridResult, { data: systemSearchResult, name: 'System', store: store }),
          renderTenantSchedules(tenantSearchResult)
        )
      ) : React.createElement(
        'div',
        { className: 'u_paddingAll' },
        localization.getText("COMMON_MESSAGES_NO_RECORD_FOUND")
      )
    );

    /**
     * Render tenant's grid schedules
     * @returns {Array}
     */
    function renderTenantSchedules(tenantSearchResult) {
      var keys = tenantSearchResult.keys();
      return keys.map(function (key, index) {
        if (!tenantSearchResult.get(key).isEmpty) {
          return React.createElement(SearchGridResult, { key: index, data: tenantSearchResult.get(key), name: key, store: store });
        }
      });
    }
  };

  module.exports = connect()(SearchResult);
}();

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchGridResult.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var EventUtils = __webpack_require__(24);

  var action = __webpack_require__(2469);
  var Paginator = __webpack_require__(97);
  var Table = __webpack_require__(44).Table;
  var Column = __webpack_require__(44).Column;
  var AffixContainer = __webpack_require__(629);
  var Input = __webpack_require__(17);
  var Button = __webpack_require__(30);
  var OverflowText = __webpack_require__(68);
  var CONSTANTS = __webpack_require__(158);
  var TABLE_DEF = CONSTANTS.TABLE_DEF;
  var ACTION_TEXT = CONSTANTS.ACTION_TEXT;
  var TOOLTIP = CONSTANTS.TOOLTIP;

  var _require = __webpack_require__(1),
      getOr = _require.getOr,
      map = _require.map,
      split = _require.split,
      merge = _require.merge,
      values = _require.values;

  var SearchGridFooter = connect()(function (props) {
    var data = props.data;
    var pageInfo = data.pageInfo;

    return React.createElement(Paginator, {
      onChange: props.goToPage,
      onDropdownChange: props.onSetPageSize,
      pageInfo: pageInfo,
      currentPageSize: getOr(0, 'length', data.schedules)
    });
  });

  var SearchGridResult = React.createClass({
    displayName: 'SearchGridResult',

    getInitialState: function getInitialState() {
      return {
        show: true
      };
    },

    /**
     * Render selectable cell
     */
    renderSelectCell: function renderSelectCell(schedule, key) {
      var handleChange = function handleChange(value) {
        schedule.updateSelected(value);
      };

      return React.createElement(Input, {
        type: 'checkbox',
        value: schedule.getDataByKey(key),
        checked: schedule.getDataByKey(key),
        onChange: EventUtils.notifyChange(handleChange, EventUtils.CHECKBOX)
      });
    },

    /**
     * Render Action button cell
     */
    renderAction: function renderAction(schedule, key, rowIndex) {
      var props = this.props;
      return React.createElement(
        'div',
        null,
        React.createElement(
          'a',
          null,
          React.createElement('span', { title: ACTION_TEXT.EditText, className: 'icon-pencil', onClick: handleClickEdit, value: schedule })
        ),
        React.createElement(
          'a',
          null,
          React.createElement('span', {
            title: ACTION_TEXT.DeleteText,
            className: 'icon-cancel',
            onClick: handleDeleteSchedule,
            value: rowIndex
          })
        )
      );

      /**
       * Handle edit button, open edit popup
       */
      function handleClickEdit() {
        props.openEditPopup(schedule);
      }

      /**
       * handle delete schedule
       */
      function handleDeleteSchedule() {
        props.deleteSchedule(schedule);
      }
    },

    /**
     * Render text cell
     */
    renderTextCell: function renderTextCell(schedule, key) {
      var value = schedule.getDataByKey(key);
      switch (key) {
        case 'recipients':
          return React.createElement(OverflowText, { tooltip: value, text: value });
        default:
          return React.createElement(
            'span',
            { title: value },
            value
          );
      }
    },

    /**
     * render separated line for one cell
     */
    renderSeparatedLine: function renderSeparatedLine(value, separator) {
      if (value) {
        return map(function (item) {
          return React.createElement(
            'span',
            { title: item },
            item
          );
        }, split(separator, value));
      }
    },

    /**
     * Render columns
     * @returns {Array}
     */
    renderColumns: function renderColumns() {
      var data = this.props.data;

      var checkBoxSelectAllProps = {
        checked: data.isAllChecked,
        onChange: EventUtils.notifyChange(handleSelectHeaderChange, EventUtils.CHECKBOX),
        type: 'checkbox'
      };

      var headerSelectDef = merge(TABLE_DEF['selected'], {
        headerComponent: Input,
        headerComponentProps: checkBoxSelectAllProps
      });

      return map(function (item) {
        switch (item.key) {
          case 'selected':
            return React.createElement(Column, (0, _extends3.default)({}, headerSelectDef, { cell: this.renderSelectCell }));
          case 'action':
            return React.createElement(Column, (0, _extends3.default)({}, item, { cell: this.renderAction }));
          default:
            return React.createElement(Column, (0, _extends3.default)({}, item, { cell: this.renderTextCell }));
        }
      }.bind(this), values(TABLE_DEF));

      function handleSelectHeaderChange(value) {
        data.updateSelected(value);
      }
    },

    render: function render() {
      var props = this.props;
      var data = props.data;
      var collapseIcon = this.state.show ? 'icon-triangle-down' : 'icon-triangle-right';
      var titleIcon = this.state.show ? TOOLTIP.COLLAPSE : TOOLTIP.EXPAND;
      return React.createElement(
        AffixContainer,
        { getAffix: this.getAffix },
        React.createElement(
          'div',
          { ref: 'affix', className: 'izenda-SearchResult_Affix u_paddingAll u_fullWidth u_inlineBlock' },
          React.createElement(
            'a',
            { onClick: this.toggleShowGrid },
            React.createElement('span', { title: titleIcon, className: collapseIcon })
          ),
          React.createElement(
            'span',
            { className: 'u_controlHeight' },
            props.name
          ),
          React.createElement(Button, {
            disabled: !data.isOneChecked,
            label: 'Delete',
            className: 'u_floatRight',
            onClick: props.deleteSelectedSchedules
          })
        ),
        this.state.show ? React.createElement(
          'div',
          null,
          React.createElement(
            Table,
            {
              dataSource: data.schedules,
              onSortChange: props.handleChangeSortDirs,
              draggableTable: false,
              sortInfo: data.pageInfo.colSortDirs
            },
            this.renderColumns()
          ),
          React.createElement(SearchGridFooter, { data: props.data, goToPage: props.goToPage, onSetPageSize: props.setPageSize })
        ) : null
      );
    },

    /**
     * get affix dom for sticky header
     */
    getAffix: function getAffix() {
      return this.refs.affix;
    },

    /**
     * Toggle show grid or not
     */
    toggleShowGrid: function toggleShowGrid() {
      this.setState({
        show: !this.state.show
      });
    }
  });

  module.exports = connect(action)(SearchGridResult);
}();

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchGridResultAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withProps = __webpack_require__(9).withProps;
  var withHandlers = __webpack_require__(9).withHandlers;
  var ObjectStateConstants = __webpack_require__(58);
  var SubscriptionPopupDesigner = __webpack_require__(1162);
  var SubscriptionDetails = __webpack_require__(229);
  var constants = __webpack_require__(277);
  var DashboardStore = __webpack_require__(338);
  var ReportDesignerConstants = __webpack_require__(16);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      getOr = _require.getOr,
      isNil = _require.isNil,
      findIndex = _require.findIndex,
      map = _require.map,
      get = _require.get,
      filter = _require.filter;

  var SearchGridResultAction = compose(withProps(function () {
    return {
      dashboardStore: new DashboardStore()
    };
  }), withHandlers({
    openEditPopup: curry(openEditPopup),
    deleteSchedule: curry(deleteSchedule),
    deleteSelectedSchedules: function deleteSelectedSchedules(props) {
      return function () {
        _deleteSelectedSchedules(props);
      };
    },
    goToPage: curry(goToPage),
    setPageSize: curry(setPageSize),
    handleChangeSortDirs: curry(handleChangeSortDirs)
  }));

  /**
   * Open edit schedule popup
   * @param props
   * @param schedule
   * @returns {*}
   */
  function openEditPopup(props, schedule) {
    var dashboardStore = props.dashboardStore;
    var id = getOr(null, 'subscription.dashboardId', schedule);
    var dashboardDetail = null;
    if (!isNil(id)) {
      dashboardDetail = getOr(null, 'model.dashboardDetail', dashboardStore);
      dashboardStore.loadDashboard(id);
    }
    var store = props.store;
    schedule.subscription.updateDataForEditMode({
      emailTemplates: store.emailTemplates,
      state: ObjectStateConstants.UPDATE,
      isSubscription: schedule.subscription.isSubscription
    });

    return props.openPopup(SubscriptionPopupDesigner, {
      reportState: ReportDesignerConstants.REPORT_STATE.SAVED,
      dashboardDetail: dashboardDetail,
      data: schedule.subscription,
      onSave: store.saveSchedule,
      onCheckDuplicateInstanceName: props.data.checkDuplicateScheduleName,
      onValidateSubscription: store.validateSchedule
    }).then(function (subscription) {
      updateGridAfterUpdateData(props.data, schedule, subscription);
    });
  }

  /**
   * Update a grid update update schedule
   * @param data
   * @param schedule
   * @param subscription
   */
  function updateGridAfterUpdateData(data, schedule, subscription) {
    schedule.subscription = new SubscriptionDetails(subscription);
    var index = findIndex({ id: schedule.id }, data.schedules);
    index > -1 && (data.schedules[index] = schedule);
  }

  /**
   * Delete schedule
   * @param props
   * @param schedule
   */
  function deleteSchedule(props, schedule) {
    var loader = props.loader;
    props.confirmFn('Confirmation', {
      description: constants.MESSAGE.M01a
    }).then(function () {
      loader.startLoading();
      return props.store.deleteSchedules([schedule.id]);
    }).then(function () {
      // Update grid after delete a schedule
      props.data.deleteSchedule(schedule);
    }).finally(loader.endLoading.bind(loader));
  }

  /**
   * Delete selected schedules
   * @param {object} props
   */
  function _deleteSelectedSchedules(props) {
    var loader = props.loader;
    var schedules = props.data.schedules;
    var getDeletedId = compose(map(get('id')), filter({ selected: true }));
    var deletedIds = getDeletedId(schedules);
    var isAllChecked = props.data.isAllChecked;
    props.confirmFn('Confirmation', {
      description: constants.MESSAGE.M01b
    }).then(function () {
      loader.startLoading();
      return props.store.deleteSchedules(deletedIds);
    }).then(function () {
      isAllChecked ? props.store.updateGridSchedules(props.data) : props.data.deleteSelectedSchedules();
    }).finally(loader.endLoading.bind(loader));
  }

  /**
   * Handle going to specific page
   * @param props
   * @param pageIndex
   */
  function goToPage(props, pageIndex) {
    var data = props.data;
    data.setPageIndex(pageIndex);
    props.store.updateGridSchedules(data);
  }

  /**
   * Set number row showed on grid, reload data
   * @param props
   * @param pageSize
   */
  function setPageSize(props, pageSize) {
    props.data.setPageSize(pageSize);
    props.store.updateGridSchedules(props.data);
  }

  /**
   * Change sort column, then reload data
   * @param {object} props
   * @param {string} key
   * @param {string} sortType
   */
  function handleChangeSortDirs(props, key, sortType) {
    var loader = props.loader;
    loader.startLoading();
    props.data.setColSortDirs(key, sortType);
    props.store.updateGridSchedules(props.data).finally(loader.endLoading.bind(loader));
  }

  module.exports = SearchGridResultAction;
}();

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Schedule.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(29);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(170);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2471);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(133);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(994);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(230);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(27);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(277);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(158);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(45);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(115);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatableDateTimePicker = (0, _Izenda6.default)()(_Izenda8.default);
var DATE_TIME_FORMAT = _Izenda26.default.DATE_TIME_FORMAT;

var Schedule = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Schedule, _Component);

  function Schedule(props) {
    (0, _classCallCheck3.default)(this, Schedule);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Schedule.__proto__ || (0, _getPrototypeOf2.default)(Schedule)).call(this, props));

    _initialiseProps.call(_this);

    _this.init();
    return _this;
  }

  /**
   * Init data
   */


  (0, _createClass3.default)(Schedule, [{
    key: 'init',
    value: function init() {
      var data = this.props.data;

      this.recurrenceList = data.type === _Izenda22.default.INSTANCE_TYPE_VALUE.SUBSCRIBE_REPORTING_ITEM || data.type === _Izenda22.default.INSTANCE_TYPE_VALUE.SCHEDULE_REPORT ? _Izenda16.default.RECURRENCE_REPORTLIST : _Izenda16.default.RECURRENCE_ALERTLIST;
    }

    /**
     * Get subscription type
     * @return {String} subscription type
     */

  }, {
    key: 'getSubscriptionType',
    value: function getSubscriptionType() {
      var props = this.props.data || {};
      return props.type;
    }

    /**
     * Get timezone
     * @return {String} timezone string
     */

  }, {
    key: 'getTimezone',
    value: function getTimezone() {
      var props = this.props.data || {};
      return props.timeZoneValue;
    }

    /**
     * Validate instance data.
     */

  }, {
    key: 'validateInstance',
    value: function validateInstance() {
      var props = this.props,
          _props = this.props,
          data = _props.data,
          validation = _props.validation;

      validation.reset();
      return validation.validate().then(function (success) {
        if (success) {
          props.onValidateSubscription(data).then(function (result) {
            validation.updateErrors(result.messages);
            return (0, _bluebird.resolve)('');
          });
        }
      });
    }

    /**
     * Onchange timezone dropdownlist
     * @param {Object} input
     */

  }, {
    key: 'getStartDate',


    /**
     * Get start date
     * @return {Object} start date
     */
    value: function getStartDate() {
      var props = this.props.data;
      return props.startDate;
    }

    /**
     * onchange startdate picker
     * @param {Object} date
     */

  }, {
    key: 'getStartTime',


    /**
     * Get start time
     * @return {Object} timezone
     */
    value: function getStartTime() {
      var props = this.props.data;
      return !isNaN(Date.parse(props.startTime)) ? props.startTime : null;
    }

    /**
     * onChange start time
     * @param {Object} date
     */

  }, {
    key: 'getRecurrenceList',


    /**
     * Get recurrence list
     * @return {Array<any>} Recurrence list
     */
    value: function getRecurrenceList() {
      return this.recurrenceList;
    }

    /**
     * Get recurrence
     */

  }, {
    key: 'getRecurrence',
    value: function getRecurrence() {
      var props = this.props.data;
      return props.recurrenceType.toString();
    }

    /**
     * onchange subscription type
     * @param {Object} data
     */


    /**
     * onchange recurrence
     * @param {Object} data
     */

  }, {
    key: 'renderCustomRecurrence',


    // Render custom component
    value: function renderCustomRecurrence() {
      var props = this.props.data;
      return parseInt(props.recurrenceType, 10) === parseInt(_Izenda12.default.CUSTOM_RECURRENCE, 10) ? _react2.default.createElement(_Izenda10.default, (0, _extends3.default)({}, this.props, {
        subscription: props,
        validateEndDateWithStartDate: this.validateEndDateWithStartDate
      })) : null;
    }

    /**
     * Render component
     */

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          data = _props2.data,
          authorization = _props2.authorization,
          localization = _props2.localization,
          PERMISSION_KEY = _props2.authorizationConstants.PERMISSION_KEY;

      var hasAlertingLicense = authorization.checkLicense(_Izenda24.default.LICENSE_KEY.Alerting);
      var alertPermission = authorization.checkPrivileges([PERMISSION_KEY.ReportsActionsRegisterForAlerts]);

      var typeOptions = data.isSubscription ? _Izenda12.default.SUBSCRIPTION_TYPE : _Izenda20.default.SCHEDULE_TYPE;

      if (!alertPermission) {
        typeOptions = (0, _fp.filter)(function (item) {
          return !data.isSubscription && item.value !== _Izenda20.default.SCHEDULE_TYPE_VALUES.scheduleAlert || data.isSubscription && item.value !== _Izenda12.default.SUBSCRIPTION_TYPE_VALUES.subscriptionAlert;
        }, typeOptions);
      }

      if (!hasAlertingLicense) {
        typeOptions = (0, _fp.remove)(function (item) {
          return item.value === _Izenda20.default.SCHEDULE_TYPE_VALUES.scheduleAlert || item.value === _Izenda12.default.SUBSCRIPTION_TYPE_VALUES.subscriptionAlert;
        }, typeOptions);
      }

      return _react2.default.createElement(
        'div',
        { className: 'izenda-SubscriptionDesigner-Container' },
        _react2.default.createElement(
          _Izenda18.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'form-horizontal schedule' },
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-3 control-label' },
                data.isSubscription ? localization.getText('SUBSCRIPTION_LABEL_SUBSCRIPTION_TYPE') : localization.getText('SUBSCRIPTION_LABEL_SCHEDULING_TYPE')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-9' },
                _react2.default.createElement(_Izenda4.default, {
                  options: typeOptions,
                  value: this.getSubscriptionType(),
                  onChange: this.onChangeSubscriptionType
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-3 control-label' },
                localization.getText('SUBSCRIPTION_LABEL_TIME_ZONE')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-9' },
                _react2.default.createElement(_Izenda4.default, {
                  options: _Izenda14.default.TIMEZONE,
                  value: this.getTimezone(),
                  onChange: this.onChangeTimezone
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-3 control-label' },
                localization.getText('SUBSCRIPTION_LABEL_START_DATE')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-3' },
                _react2.default.createElement(ValidatableDateTimePicker, {
                  time: false,
                  value: this.getStartDate(),
                  onChange: this.onChangeStartDate,
                  validations: _Izenda12.default.CONTRAINTS.START_DATE,
                  storeFormat: DATE_TIME_FORMAT,
                  field: 'startDate'
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-3 control-label' },
                localization.getText('SUBSCRIPTION_LABEL_START_TIME')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-3' },
                _react2.default.createElement(ValidatableDateTimePicker, {
                  calendar: false,
                  value: this.getStartTime(),
                  onChange: this.onChangeStartTime,
                  validations: _Izenda12.default.CONTRAINTS.START_TIME,
                  storeFormat: DATE_TIME_FORMAT,
                  field: 'startTime'
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-3 control-label' },
                localization.getText('SUBSCRIPTION_LABEL_RECURRENCE')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-9' },
                _react2.default.createElement(_Izenda4.default, {
                  options: this.getRecurrenceList(),
                  value: this.getRecurrence(),
                  onChange: this.onChangeRecurrence
                })
              )
            ),
            _react2.default.createElement('hr', { className: 'izenda-full-hr' }),
            this.renderCustomRecurrence()
          )
        )
      );
    }
  }]);
  return Schedule;
}(_react.Component), _class2.propTypes = {
  data: _propTypes2.default.object
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onChangeTimezone = function (input) {
    var props = _this2.props.data || {};

    props.updateProperty && props.updateProperty('timeZoneName', input.label);
    props.updateProperty && props.updateProperty('timeZoneValue', input.value);

    _this2.validateInstance();
  };

  this.onChangeStartDate = function (date) {
    var props = _this2.props.data;
    props.updateProperty && props.updateProperty('startDate', date);

    _this2.validateEndDateWithStartDate(true);
  };

  this.onChangeStartTime = function (data) {
    var props = _this2.props.data;
    props.updateProperty && props.updateProperty('startTime', data);
  };

  this.onChangeSubscriptionType = function (data) {
    var props = _this2.props.data;
    var subscriptionType = data.value;

    _this2.recurrenceList = subscriptionType === _Izenda22.default.INSTANCE_TYPE_VALUE.SUBSCRIBE_REPORTING_ITEM || subscriptionType === _Izenda20.default.SCHEDULE_REPORT ? _Izenda16.default.RECURRENCE_REPORTLIST : _Izenda16.default.RECURRENCE_ALERTLIST;

    if (!(0, _fp.isNil)(props.updateProperty)) {
      props.updateProperty('type', subscriptionType);
      props.updateProperty('recurrenceType', _this2.recurrenceList[0].value);
    }
  };

  this.onChangeRecurrence = function (newData) {
    var _props3 = _this2.props,
        data = _props3.data,
        validation = _props3.validation;

    data.updateProperty && data.updateProperty('recurrenceType', newData.value);

    validation.reset('startDate');
    validation.reset('endDate');
    _this2.validateEndDateWithStartDate(true);
  };

  this.validateEndDateWithStartDate = function (isStartDate) {
    var _props4 = _this2.props,
        data = _props4.data,
        validation = _props4.validation;

    var endTimeOfDay = '11:59:59 PM';
    var startDateField = 'startDate';
    var endDateField = 'endDate';

    if (data.isEndAfter || !data.isEndBy || data.isEndless) {
      return;
    }

    var startDate = new Date(data.startDate + ' ' + data.startTime);
    var endDate = new Date(data.endDate + ' ' + endTimeOfDay);

    if ((0, _fp.gt)(startDate, endDate)) {
      var message = isStartDate ? _Izenda12.default.MESSAGE.M03b : _Izenda12.default.MESSAGE.M03a;
      var key = isStartDate ? startDateField : endDateField;
      validation.updateErrors([{
        key: key,
        messages: [message]
      }]);
    } else {
      validation.reset(startDateField);
      validation.reset(endDateField);
    }
  };
}, _temp)) || _class);
exports.default = Schedule;
module.exports = exports['default'];

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2472);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2477);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CustomRecurrence.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'text-center izenda-text-bold' },
      _Izenda6.default.getText('SUBSCRIPTION_LABEL_CUSTOMER_RECERRENCE')
    ),
    _react2.default.createElement('hr', null),
    _react2.default.createElement(_Izenda2.default, props),
    _react2.default.createElement('hr', null),
    _react2.default.createElement(_Izenda4.default, props)
  );
};

module.exports = exports['default'];

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RecurrencePattern.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = __webpack_require__(5);
  var React = __webpack_require__(0);
  var Input = __webpack_require__(17);
  var DailyRecurrence = __webpack_require__(2473);
  var WeeklyRecurrence = __webpack_require__(2474);
  var MonthlyRecurrence = __webpack_require__(2475);
  var YearlyRecurrence = __webpack_require__(2476);
  var ScheduleConstants = __webpack_require__(230);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      find = _require.find;

  var RecurrencePattern = React.createClass({
    displayName: 'RecurrencePattern',

    propTypes: {
      data: React.PropTypes.object
    },

    getInitialState: function getInitialState() {
      return {
        isDaily: true,
        isWeekly: false,
        isMonthly: false,
        isYearly: false
      };
    },

    componentWillMount: function componentWillMount() {
      var props = this.props.data;

      this.setState({
        isDaily: props.recurrencePattern === ScheduleConstants.RECURRENCE_PATTERN[0].value,
        isWeekly: props.recurrencePattern === ScheduleConstants.RECURRENCE_PATTERN[1].value,
        isMonthly: props.recurrencePattern === ScheduleConstants.RECURRENCE_PATTERN[2].value,
        isYearly: props.recurrencePattern === ScheduleConstants.RECURRENCE_PATTERN[3].value
      });
    },

    /**
     * get checked
     * @return {boolean} checked
     */
    getChecked: function getChecked(recurrence) {
      var props = this.props.data;
      return props.recurrencePattern == recurrence;
    },

    /**
     * onclick recurrence radio
     * @param {object} event
     */
    onClickRecurrence: m.action(function (e) {
      var id = e.target.id;
      var recurrencePattern = find(function (r) {
        return r.label === id;
      }, ScheduleConstants.RECURRENCE_PATTERN);

      var props = this.props.data;
      props.recurrencePattern = recurrencePattern.value;
      // Re-build the recurrencePatternSetting
      this.props.subscription.buildRecurrencePatternSetting();

      this.setState({
        isDaily: id === ScheduleConstants.RECURRENCE_PATTERN[0].label,
        isWeekly: id === ScheduleConstants.RECURRENCE_PATTERN[1].label,
        isMonthly: id === ScheduleConstants.RECURRENCE_PATTERN[2].label,
        isYearly: id === ScheduleConstants.RECURRENCE_PATTERN[3].label
      });
    }),

    /**
     * Render daily section
     * @return {component} DailyRecurrence component
     */
    renderDaily: function renderDaily() {
      return this.state.isDaily ? React.createElement(DailyRecurrence, this.props) : null;
    },

    /**
     * Render weekly section
     * @return {component} WeeklyRecurrence component
     */
    renderWeekly: function renderWeekly() {
      return this.state.isWeekly ? React.createElement(WeeklyRecurrence, this.props) : null;
    },

    /**
     * Render monthly section
     * @return {component} MonthlyRecurrence component
     */
    renderMonthly: function renderMonthly() {
      return this.state.isMonthly ? React.createElement(MonthlyRecurrence, this.props) : null;
    },

    /**
     * Render yearly section
     * @return {component} YearlyRecurrence component
     */
    renderYearly: function renderYearly() {
      return this.state.isYearly ? React.createElement(YearlyRecurrence, this.props) : null;
    },

    /**
     * Render componennt
     * @return {component} component
     */
    render: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          null,
          localizer.getText('DASHBOARD_LABEL_RECURRENCE_PATTERN')
        ),
        React.createElement('hr', null),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'group-schedule' },
            React.createElement(
              'div',
              { className: 'col-md-3' },
              React.createElement(Input, {
                id: 'daily',
                type: 'radio',
                name: 'recurrence',
                onClick: this.onClickRecurrence,
                checked: this.getChecked(ScheduleConstants.RECURRENCE_PATTERN[0].value)
              }),
              React.createElement(
                'span',
                { className: 'radio-label' },
                localizer.getText('SUBSCRIPTION_LABEL_DAILY')
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-3' },
              React.createElement(Input, {
                id: 'weekly',
                type: 'radio',
                name: 'recurrence',
                onClick: this.onClickRecurrence,
                checked: this.getChecked(ScheduleConstants.RECURRENCE_PATTERN[1].value)
              }),
              React.createElement(
                'span',
                { className: 'radio-label' },
                localizer.getText('SUBSCRIPTION_LABEL_WEEKLY')
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-3' },
              React.createElement(Input, {
                id: 'monthly',
                type: 'radio',
                name: 'recurrence',
                onClick: this.onClickRecurrence,
                checked: this.getChecked(ScheduleConstants.RECURRENCE_PATTERN[2].value)
              }),
              React.createElement(
                'span',
                { className: 'radio-label' },
                localizer.getText('SUBSCRIPTION_LABEL_MONTHLY')
              )
            ),
            React.createElement(
              'div',
              { className: 'col-md-3' },
              React.createElement(Input, {
                id: 'yearly',
                type: 'radio',
                name: 'recurrence',
                onClick: this.onClickRecurrence,
                checked: this.getChecked(ScheduleConstants.RECURRENCE_PATTERN[3].value)
              }),
              React.createElement(
                'span',
                { className: 'radio-label' },
                localizer.getText('SUBSCRIPTION_LABEL_YEARLY')
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'border' },
          React.createElement(
            'div',
            { className: 'group' },
            this.renderDaily(),
            this.renderWeekly(),
            this.renderMonthly(),
            this.renderYearly()
          )
        )
      );
    }
  });

  module.exports = RecurrencePattern;
}();

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DailyRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  "use strict";

  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var Input = __webpack_require__(17);

  var DailyRecurrence = React.createClass({
    displayName: 'DailyRecurrence',

    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function componentWillMount() {
      this.recurrence = this.props.data.dailyRecurrencePatternSetting;
    },

    /**
     * onchange every radio
     */
    onChangeEvery: function onChangeEvery() {
      this.recurrence.isEveryWeekday = false;
      this.props.data.markDirty();
    },

    /**
     * get every data
     */
    getEveryInput: function getEveryInput() {
      return this.recurrence.recurrenceDay;
    },

    /**
     * onchange every input
     */
    onChangeEveryInput: function onChangeEveryInput(data) {
      this.recurrence.isEveryWeekday = false;
      this.recurrence.recurrenceDay = parseInt(data.target.value, 10);
      this.props.data.markDirty();
    },

    /**
     * onchange every weekday radio
     */
    onChangeEveryWeekday: function onChangeEveryWeekday() {
      this.recurrence.isEveryWeekday = true;
      this.props.data.markDirty();
    },

    /**
     * Render component
     */
    render: function render() {
      var localizer = __webpack_require__(12);

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement(Input, { type: 'radio',
              name: 'daily',
              checked: !this.recurrence.isEveryWeekday,
              onChange: this.onChangeEvery }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('SUBSCRIPTION_LABEL_EVERY')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement(Input, { value: this.getEveryInput(),
              onChange: this.onChangeEveryInput,
              disabled: this.recurrence.isEveryWeekday })
          ),
          React.createElement(
            'div',
            { className: 'col-md-3 control-label no-padding-left' },
            localizer.getText('SUBSCRIPTION_LABEL_DAYS')
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-12' },
            React.createElement(Input, { type: 'radio',
              name: 'daily',
              checked: this.recurrence.isEveryWeekday,
              onChange: this.onChangeEveryWeekday }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('SUBSCRIPTION_LABEL_EVERY_WEEKDAY')
            )
          )
        )
      );
    }
  });

  module.exports = m.observer(DailyRecurrence);
}();

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.WeeklyRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var NumericInput = __webpack_require__(109);
  var ScheduleConstants = __webpack_require__(230);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      pull = _require.pull,
      join = _require.join,
      split = _require.split,
      indexOf = _require.indexOf;

  var WeeklyRecurrence = React.createClass({
    displayName: 'WeeklyRecurrence',

    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function componentWillMount() {
      this.recurrence = this.props.data.weeklyRecurrencePatternSetting;
      this.days = [];
    },

    /**
     * Get recur every input
     * @return {number} recurrence week
     */
    getRecurEvery: function getRecurEvery() {
      return this.recurrence.recurrenceWeek;
    },

    /**
     * onchange recur every input
     * @param {object} data
     */
    onChangeRecurEvery: function onChangeRecurEvery(data) {
      this.recurrence.recurrenceWeek = data;
      this.props.data.markDirty();
    },

    /**
     * onchange day
     * @param {object} data
     */
    onChangeDay: function onChangeDay(input) {
      var d = input.target;
      if (d.checked) {
        this.days.push(d.value);
      } else {
        this.days = pull(d.value, this.days);
      }
      this.recurrence.selectedDayValue = join(',', this.days);
      this.props.data.markDirty();
    },

    /**
     * Get checked
     */
    getChecked: function getChecked(dayOfWeek) {
      this.days = this.recurrence.selectedDayValue.length > 0 ? split(',', this.recurrence.selectedDayValue) : [];
      return indexOf(dayOfWeek.toString(), this.days) >= 0;
    },

    /**
     * Render
     * @return {object} component
     */
    render: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3 control-label' },
            localizer.getText('SUBSCRIPTION_LABEL_RECUR_EVERY')
          ),
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement(NumericInput, { value: this.getRecurEvery(), onChange: this.onChangeRecurEvery, max: Math.pow(2, 32) })
          ),
          React.createElement(
            'div',
            { className: 'col-md-3 control-label no-padding-left' },
            localizer.getText('SUBSCRIPTION_LABEL_WEEKS'),
            ' '
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement('input', {
              type: 'checkbox',
              value: ScheduleConstants.DAYOFWEEK.SUNDAY,
              onChange: this.onChangeDay,
              checked: this.getChecked(ScheduleConstants.DAYOFWEEK.SUNDAY)
            }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('COMMON_LABEL_SUNDAY')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement('input', {
              type: 'checkbox',
              value: ScheduleConstants.DAYOFWEEK.MONDAY,
              onChange: this.onChangeDay,
              checked: this.getChecked(ScheduleConstants.DAYOFWEEK.MONDAY)
            }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('COMMON_LABEL_MONDAY')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement('input', {
              type: 'checkbox',
              value: ScheduleConstants.DAYOFWEEK.TUESDAY,
              onChange: this.onChangeDay,
              checked: this.getChecked(ScheduleConstants.DAYOFWEEK.TUESDAY)
            }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('COMMON_LABEL_TUESDAY')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement('input', {
              type: 'checkbox',
              value: ScheduleConstants.DAYOFWEEK.WEDNESDAY,
              onChange: this.onChangeDay,
              checked: this.getChecked(ScheduleConstants.DAYOFWEEK.WEDNESDAY)
            }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('COMMON_LABEL_WEDNESDAY')
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement('input', {
              type: 'checkbox',
              value: ScheduleConstants.DAYOFWEEK.THURSDAY,
              onChange: this.onChangeDay,
              checked: this.getChecked(ScheduleConstants.DAYOFWEEK.THURSDAY)
            }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('COMMON_LABEL_THURSDAY')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement('input', {
              type: 'checkbox',
              value: ScheduleConstants.DAYOFWEEK.FRIDAY,
              onChange: this.onChangeDay,
              checked: this.getChecked(ScheduleConstants.DAYOFWEEK.FRIDAY)
            }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('COMMON_LABEL_FRIDAY')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement('input', {
              type: 'checkbox',
              value: ScheduleConstants.DAYOFWEEK.SATURDAY,
              onChange: this.onChangeDay,
              checked: this.getChecked(ScheduleConstants.DAYOFWEEK.SATURDAY)
            }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('COMMON_LABEL_SATURDAY')
            )
          )
        )
      );
    }
  });

  module.exports = m.observer(WeeklyRecurrence);
}();

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MonthlyRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  "use strict";

  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var Input = __webpack_require__(17);
  var Dropdown = __webpack_require__(29);
  var ScheduleConstants = __webpack_require__(230);
  var localizer = __webpack_require__(12);

  var MonthlyRecurrence = React.createClass({
    displayName: 'MonthlyRecurrence',

    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function componentWillMount() {
      this.recurrence = this.props.data.monthlyRecurrencePatternSetting;
    },

    /**
     * Check day radio
     */
    getCheckedDay: function getCheckedDay() {
      return !this.recurrence.useOrdinalDay;
    },

    /**
     * onchange day radio
     */
    onChangeDay: function onChangeDay(input) {
      this.recurrence.useOrdinalDay = false;
      this.props.data.markDirty();
    },

    /**
     * Get day
     */
    getDay: function getDay() {
      return this.recurrence.day;
    },

    /**
     * onchange day input
     */
    onChangeDayInput: function onChangeDayInput(input) {
      this.recurrence.day = input.target.value;
      this.props.data.markDirty();
    },

    /**
     * Get month
     */
    getMonth: function getMonth() {
      return this.recurrence.recurrenceMonth;
    },

    /**
     * Check day radio
     */
    getCheckedThe: function getCheckedThe() {
      return this.recurrence.useOrdinalDay;
    },

    /**
     * Onchange The radio
     */
    onChangeThe: function onChangeThe(input) {
      this.recurrence.useOrdinalDay = true;
      this.props.data.markDirty();
    },

    /**
     * onchange month input
     */
    onChangeMonth: function onChangeMonth(input) {
      this.recurrence.recurrenceMonth = input.target.value;
      this.props.data.markDirty();
    },

    /**
     * get ordinal day
     */
    getOrdinal: function getOrdinal() {
      return this.recurrence.ordinalDay || ScheduleConstants.ORDINAL_LIST[0];
    },

    /**
     * onchange ordinal day
     */
    onChangeOrdinal: function onChangeOrdinal(input) {
      this.recurrence.ordinalDay = input.value;
      this.props.data.markDirty();
    },

    /**
     * get day name
     */
    getDayName: function getDayName() {
      return this.recurrence.ordinalDayValue || ScheduleConstants.DAYNAME_LIST[0];
    },

    /**
     * onchange day name
     */
    onChangeDayName: function onChangeDayName(input) {
      this.recurrence.ordinalDayValue = input.value;
      this.props.data.markDirty();
    },

    /**
     * get ordinal month
     */
    getOrdinalMonth: function getOrdinalMonth() {
      return this.recurrence.ordinalRecurrenceMonth;
    },

    /**
     * onchange ordinal month dropdownlist
     */
    onChangeOrdinalMonth: function onChangeOrdinalMonth(input) {
      this.recurrence.ordinalRecurrenceMonth = input.target.value;
      this.props.data.markDirty();
    },

    /**
     * Render component
     */
    render: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement(Input, { type: 'radio',
              name: 'monthlyRecurrence',
              checked: this.getCheckedDay(),
              onChange: this.onChangeDay }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('SUBSCRIPTION_LABEL_DAY')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-2' },
            React.createElement(Input, { value: this.getDay(),
              onChange: this.onChangeDayInput,
              disabled: this.recurrence.useOrdinalDay })
          ),
          React.createElement(
            'div',
            { className: 'col-md-1 no-padding-left control-label' },
            localizer.getText('SUBSCRIPTION_LABEL_OF_EVERY')
          ),
          React.createElement(
            'div',
            { className: 'col-md-2 no-padding-left' },
            React.createElement(Input, { value: this.getMonth(),
              onChange: this.onChangeMonth,
              disabled: this.recurrence.useOrdinalDay })
          ),
          React.createElement(
            'div',
            { className: 'col-md-3 no-padding-left control-label' },
            localizer.getText('SUBSCRIPTION_LABEL_MONTHS')
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement(Input, { type: 'radio',
              name: 'monthlyRecurrence',
              checked: this.getCheckedThe(),
              onChange: this.onChangeThe }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('SUBSCRIPTION_LABEL_THE')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-2' },
            React.createElement(Dropdown, { options: ScheduleConstants.ORDINAL_LIST,
              value: this.getOrdinal(),
              onChange: this.onChangeOrdinal,
              disabled: !this.recurrence.useOrdinalDay })
          ),
          React.createElement(
            'div',
            { className: 'col-md-2 no-padding-left' },
            React.createElement(Dropdown, { options: ScheduleConstants.DAYNAME_LIST,
              value: this.getDayName(),
              onChange: this.onChangeDayName,
              disabled: !this.recurrence.useOrdinalDay })
          ),
          React.createElement(
            'div',
            { className: 'col-md-1 no-padding-left control-label' },
            localizer.getText('SUBSCRIPTION_LABEL_OF_EVERY')
          ),
          React.createElement(
            'div',
            { className: 'col-md-2 no-padding-left' },
            React.createElement(Input, { value: this.getOrdinalMonth(),
              onChange: this.onChangeOrdinalMonth,
              disabled: !this.recurrence.useOrdinalDay })
          ),
          React.createElement(
            'div',
            { className: 'col-md-1 no-padding-left control-label' },
            localizer.getText('SUBSCRIPTION_LABEL_MONTHS')
          )
        )
      );
    }
  });

  module.exports = m.observer(MonthlyRecurrence);
}();

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.YearlyRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  "use strict";

  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var Input = __webpack_require__(17);
  var Dropdown = __webpack_require__(29);
  var ScheduleConstants = __webpack_require__(230);
  var localizer = __webpack_require__(12);

  var YearlyRecurrence = React.createClass({
    displayName: 'YearlyRecurrence',

    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function componentWillMount() {
      this.recurrence = this.props.data.yearlyRecurrencePatternSetting;
    },

    /**
    * get year input
    */
    getYear: function getYear() {
      return this.recurrence.recurrenceYear;
    },

    /**
    * onchange year input
    */
    onChangeYear: function onChangeYear(input) {
      this.recurrence.recurrenceYear = input.target.value;
      this.props.data.markDirty();
    },

    /**
    * Get checked on radio
    */
    getCheckedOn: function getCheckedOn() {
      return !this.recurrence.useOrdinalDay;
    },

    /**
    * onchange on radio
    */
    onChangeOn: function onChangeOn(input) {
      this.recurrence.useOrdinalDay = false;
      this.props.data.markDirty();
    },

    /**
    * Get month
    */
    getMonth: function getMonth() {
      return this.recurrence.monthValue || ScheduleConstants.MONTHNAME_LIST[0];
    },

    /**
    * Onchange month
    * @param {object} input
    */
    onChangeMonth: function onChangeMonth(input) {
      this.recurrence.monthValue = input.value;
      this.props.data.markDirty();
    },

    /**
    * Get day
    */
    getDay: function getDay() {
      return this.recurrence.day;
    },

    /**
    * Onchange day
    * @param {object} input
    */
    onChangeDay: function onChangeDay(input) {
      this.recurrence.day = input.target.value;
      this.props.data.markDirty();
    },

    /**
    * Get checked on the radio
    */
    getCheckedOnThe: function getCheckedOnThe() {
      return this.recurrence.useOrdinalDay;
    },

    /**
    * onchange on the radio
    * @param {object} input
    */
    onChangeOnThe: function onChangeOnThe(input) {
      this.recurrence.useOrdinalDay = true;
      this.props.data.markDirty();
    },

    /**
    * Get ordinal day
    */
    getOrdinal: function getOrdinal() {
      return this.recurrence.ordinalDay || ScheduleConstants.ORDINAL_LIST[0];
    },

    /**
    * Onchange ordinal day
    */
    onChangeOrdinal: function onChangeOrdinal(input) {
      this.recurrence.ordinalDay = input.value;
      this.props.data.markDirty();
    },

    /**
    * Get day name
    */
    getDayName: function getDayName() {
      return this.recurrence.ordinalDayValue || ScheduleConstants.DAYNAME_LIST[0];
    },

    /**
    * Onchange day name
    */
    onChangeDayName: function onChangeDayName(input) {
      this.recurrence.ordinalDayValue = input.value;
      this.props.data.markDirty();
    },

    /**
    * Get month
    */
    getOrdinalMonth: function getOrdinalMonth() {
      return this.recurrence.ordinalMonthValue || ScheduleConstants.MONTHNAME_LIST[0];
    },

    /**
    * Onchange month
    */
    onChangeOrdinalMonth: function onChangeOrdinalMonth(input) {
      this.recurrence.ordinalMonthValue = input.value;
      this.props.data.markDirty();
    },

    /**
    * Render component
    */
    render: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3 control-label' },
            localizer.getText('SUBSCRIPTION_LABEL_RECUR_EVERY')
          ),
          React.createElement(
            'div',
            { className: 'col-md-1 no-padding-left' },
            React.createElement(Input, { value: this.getYear(),
              onChange: this.onChangeYear })
          ),
          React.createElement(
            'div',
            { className: 'col-md-3 control-label no-padding-left' },
            localizer.getText('SUBSCRIPTION_LABEL_YEARS'),
            ' '
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement(Input, { type: 'radio',
              name: 'yearlyRecurrence',
              checked: this.getCheckedOn(),
              onChange: this.onChangeOn }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('SUBSCRIPTION_LABEL_ON')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-2 no-padding-left' },
            React.createElement(Dropdown, { options: ScheduleConstants.MONTHNAME_LIST,
              value: this.getMonth(),
              onChange: this.onChangeMonth,
              disabled: this.recurrence.useOrdinalDay })
          ),
          React.createElement(
            'div',
            { className: 'col-md-2 no-padding-left' },
            React.createElement(Input, { value: this.getDay(),
              onChange: this.onChangeDay,
              disabled: this.recurrence.useOrdinalDay })
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement(Input, { type: 'radio',
              name: 'yearlyRecurrence',
              checked: this.getCheckedOnThe(),
              onChange: this.onChangeOnThe }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('SUBSCRIPTION_LABEL_ON_THE')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-2 no-padding-left' },
            React.createElement(Dropdown, { options: ScheduleConstants.ORDINAL_LIST,
              value: this.getOrdinal(),
              onChange: this.onChangeOrdinal,
              disabled: !this.recurrence.useOrdinalDay })
          ),
          React.createElement(
            'div',
            { className: 'col-md-2 no-padding-left' },
            React.createElement(Dropdown, { options: ScheduleConstants.DAYNAME_LIST,
              value: this.getDayName(),
              onChange: this.onChangeDayName,
              disabled: !this.recurrence.useOrdinalDay })
          ),
          React.createElement(
            'div',
            { className: 'control-label of' },
            localizer.getText('SUBSCRIPTION_LABEL_OF')
          ),
          React.createElement(
            'div',
            { className: 'col-md-2' },
            React.createElement(Dropdown, { options: ScheduleConstants.MONTHNAME_LIST,
              value: this.getOrdinalMonth(),
              onChange: this.onChangeOrdinalMonth,
              disabled: !this.recurrence.useOrdinalDay })
          )
        )
      );
    }
  });

  module.exports = m.observer(YearlyRecurrence);
}();

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RangeRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  "use strict";

  var m = __webpack_require__(5);
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var Validator = __webpack_require__(23);
  var DateTimePicker = __webpack_require__(170);
  var Input = __webpack_require__(17);
  var NumericInput = __webpack_require__(109);
  var ValidatableDateTimePicker = Validator()(DateTimePicker);
  var momentTimezone = __webpack_require__(276);
  var localizer = __webpack_require__(12);
  var DEFAULT_OCCURRENCE = __webpack_require__(230).DEFAULT_OCCURRENCE;
  var AppGlobalConstants = __webpack_require__(115);
  var DATE_FORMAT = AppGlobalConstants.DATE_FORMAT;

  var RangeRecurrence = React.createClass({
    displayName: 'RangeRecurrence',

    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function componentWillMount() {
      this.subData = this.props.data;
    },

    /**
     * get checked for no end date radio
     * @return {boolean} isEndless
     */
    getCheckedNoEndDate: function getCheckedNoEndDate() {
      return this.subData.isEndless;
    },

    /**
     * onchange no end date radio
     */
    onChangeNoEndDate: function onChangeNoEndDate() {
      m.transaction(function () {
        this.subData.isEndAfter = false;
        this.subData.isEndBy = false;
        this.subData.isEndless = true;
        this.subData.markDirty();
      }.bind(this));
    },

    /**
     * get checked for end after radio
     */
    getCheckedEndAfter: function getCheckedEndAfter() {
      return this.subData.isEndAfter;
    },

    /**
     * onchange end after radio
     */
    onChangeEndAfter: function onChangeEndAfter() {
      m.transaction(function () {
        this.subData.isEndAfter = true;
        this.subData.isEndBy = false;
        this.subData.isEndless = false;
        this.subData.occurrence = DEFAULT_OCCURRENCE;
        this.subData.markDirty();
      }.bind(this));
    },

    /**
     * get checked for end by radio
     * @return {boolean} isEndBy
     */
    getCheckedEndBy: function getCheckedEndBy() {
      return this.subData.isEndBy;
    },

    /**
     * onchange end by radio
     */
    onChangeEndBy: function onChangeEndBy() {
      m.transaction(function () {
        this.subData.isEndAfter = false;
        this.subData.isEndBy = true;
        this.subData.isEndless = false;
        this.subData.endDate = momentTimezone().format(DATE_FORMAT);
        this.subData.markDirty();
        this.props.validateEndDateWithStartDate(false); // false is End date vs Start date
      }.bind(this));
    },

    /**
     * get occurrence
     * @return {number} occurrence
     */
    getOccurrence: function getOccurrence() {
      return this.subData.occurrence;
    },

    /**
     * onchange occurrence input
     */
    onChangeOccurrence: function onChangeOccurrence(value) {
      this.subData.updateProperty && this.subData.updateProperty('occurrence', value);
    },

    /**
     * get end by datepicker
     * @return {Date} endDate
     */
    getEndBy: function getEndBy() {
      return this.subData.endDate && momentTimezone(this.subData.endDate).format(DATE_FORMAT) || momentTimezone();
    },

    /**
     * onchange end by datepicker
     * @param {object} date
     */
    onChangeEndByDatePicker: function onChangeEndByDatePicker(date) {
      this.subData.updateProperty && this.subData.updateProperty('endDate', date);
      this.props.validateEndDateWithStartDate(false); // false is End date vs Start date
    },

    /**
     * Render componennt
     */
    render: function render() {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          null,
          localizer.getText('DASHBOARD_LABEL_RANGE_OF_RECURRENCE')
        ),
        React.createElement('hr', null),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-12 control-label' },
            React.createElement(Input, { type: 'radio',
              name: 'range',
              checked: this.getCheckedNoEndDate(),
              onChange: this.onChangeNoEndDate }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('SUBSCRIPTION_LABEL_NO_END_DAY')
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3 control-label' },
            React.createElement(Input, { type: 'radio',
              name: 'range',
              checked: this.getCheckedEndAfter(),
              onChange: this.onChangeEndAfter }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('SUBSCRIPTION_LABEL_END_AFTER')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement(NumericInput, {
              value: this.getOccurrence(),
              onChange: this.onChangeOccurrence,
              disabled: !this.getCheckedEndAfter(),
              max: Math.pow(2, 32) })
          ),
          React.createElement(
            'div',
            { className: 'col-md-3 control-label no-padding-left' },
            localizer.getText('SUBSCRIPTION_LABEL_OCCURRENCES')
          )
        ),
        React.createElement(
          'div',
          { className: 'form-group' },
          React.createElement(
            'div',
            { className: 'col-md-3 control-label' },
            React.createElement(Input, { type: 'radio',
              name: 'range',
              checked: this.getCheckedEndBy(),
              onChange: this.onChangeEndBy }),
            React.createElement(
              'span',
              { className: 'radio-label' },
              localizer.getText('SUBSCRIPTION_LABEL_END_BY')
            )
          ),
          React.createElement(
            'div',
            { className: 'col-md-3' },
            React.createElement(ValidatableDateTimePicker, { time: false,
              value: this.getEndBy(),
              onChange: this.onChangeEndByDatePicker,
              disabled: !this.getCheckedEndBy(),
              field: 'endDate' })
          )
        )
      );
    }
  });

  module.exports = observer(RangeRecurrence);
}();

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Delivery.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(398);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(133);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2479);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2495);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(567);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(27);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(403);

var _Izenda22 = __webpack_require__(1167);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(1168);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _Izenda26 = __webpack_require__(158);

var _Izenda27 = _interopRequireDefault(_Izenda26);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorDropdown = (0, _Izenda4.default)()(_Izenda6.default);

var Delivery = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Delivery, _Component);

  function Delivery(props) {
    (0, _classCallCheck3.default)(this, Delivery);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Delivery.__proto__ || (0, _getPrototypeOf2.default)(Delivery)).call(this, props));

    _this.onChangeExportFileType = function (dropdown) {
      _this.subData.updateProperty("exportFileType", dropdown.value);
    };

    _this.onChangeAttachmentType = function (dropdown) {
      _this.subData.updateProperty("exportAttachmentType", dropdown.value);
    };

    _this.onChangeDeliveryType = function (e) {
      _this.subData.updateProperty("deliveryType", e.value);
    };

    _this.onChangeDeliveryMethod = function (e) {
      _this.subData.updateProperty("deliveryMethod", e.value);
    };

    _this.onChangeEmailSubject = function (input) {
      _this.subData.updateProperty("emailSubject", input.target.value);
    };

    _this.onChangeEmailBody = function (e) {
      _this.subData.updateProperty("emailBody", e.target.value);
    };

    _this.showSystemVariablesPopupForSubject = function (position) {
      _this.showSystemVariablesPopup(_Izenda12.default.ELEMENTS.EMAIL_SUBJECT.KEY, position);
    };

    _this.showSystemVariablesPopupForBody = function (position) {
      _this.showSystemVariablesPopup(_Izenda12.default.ELEMENTS.EMAIL_BODY.KEY, position);
    };

    _this.onSelectSystemVariable = function (name) {
      var sourceValue = _this.systemVariablesUI.sourceType === _Izenda12.default.ELEMENTS.EMAIL_SUBJECT.KEY ? _this.subData.emailSubject : _this.subData.emailBody;
      var sourceKey = _this.systemVariablesUI.sourceType === _Izenda12.default.ELEMENTS.EMAIL_SUBJECT.KEY ? "emailSubject" : "emailBody";

      var cursorPos = _this.systemVariablesUI.cursorPosition;
      var textBefore = sourceValue.substring(0, cursorPos);
      var textAfter = sourceValue.substring(cursorPos, sourceValue.length);
      _this.subData.updateProperty(sourceKey, textBefore + name + textAfter);

      _this.systemVariablesUI.updateVisible(false);
      _this.systemVariablesUI.$sourceNode.focus();
    };

    _this.subData = props.data;
    _this.originalDeliveryMethod = _this.subData.deliveryMethod;
    _this.originalEmailBody = _this.subData.emailBody;

    _this.disposeDeliveryType = (0, _mobx.observe)(_this.subData, "deliveryType", function () {
      _this.observeDeliveryType();
    });

    _this.disposeDeliveryMethod = (0, _mobx.observe)(_this.subData, "deliveryMethod", function (value) {
      _this.observeDeliveryMethod(value);
    });

    _this.init();
    return _this;
  }

  /**
   * Init data
   */


  (0, _createClass3.default)(Delivery, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      if (this.subData.type === _Izenda12.default.SUBSCRIPTION_TYPE_VALUES.subscriptionAlert || this.subData.type === _Izenda27.default.INSTANCE_TYPE_VALUE.SCHEDULE_ALERT) {
        this.subData.deliveryType = "Email";
      }

      var availableDeliveryTypes = this.getDeliveryTypeList();
      var firstTypeValue = (0, _fp.flow)(_fp.head, (0, _fp.get)("value"))(availableDeliveryTypes);
      var isValidType = (0, _fp.any)(function (item) {
        return item.value === _this2.subData.deliveryType;
      }, availableDeliveryTypes);
      !isValidType && (this.subData.deliveryType = firstTypeValue);

      this.observeDeliveryType();
      this.observeDeliveryMethod(this.subData.deliveryMethod);
      this.systemVariablesUI = new _Izenda25.default();
    }

    /**
     * Observe delivery type.
     */

  }, {
    key: "observeDeliveryType",
    value: function observeDeliveryType() {
      this.loadDeliveryMethod();
      var method = this.subData.deliveryMethod;
      var listMethod = this.deliveryMethods;

      if (listMethod && (0, _fp.isNil)((0, _fp.find)(function (item) {
        return (0, _fp.isEqual)(item.value, method);
      }, listMethod)) && listMethod.length !== 0) {
        this.subData.deliveryMethod = (0, _fp.head)(this.deliveryMethods).value;
      }

      this.isEmail = this.subData.deliveryType === "Email";
    }

    /**
     * Observe delivery method.
     * @param {string} value
     */

  }, {
    key: "observeDeliveryMethod",
    value: function observeDeliveryMethod(value) {
      this.subData.deliveryMethod = value;
      this.loadExportFileTypes();
      this.loadExportAttachmentTypes();

      this.subData.deliveryType === "Email" && this.getEmailBody();
    }

    /**
     * Load delivery method list
     */

  }, {
    key: "loadDeliveryMethod",
    value: function loadDeliveryMethod() {
      var deliveryType = this.subData.deliveryType;
      var matchedDeliveryType = (0, _fp.find)(function (item) {
        return item.value === deliveryType;
      }, _Izenda12.default.DELIVERY_TYPE);

      if (!matchedDeliveryType) return null;

      this.deliveryMethods = matchedDeliveryType.deliveryMethod;
      if (this.subData.deliveryType === "Email") {
        var _props = this.props,
            authorization = _props.authorization,
            _props$authorizationC = _props.authorizationConstants,
            permissionKeys = _props$authorizationC.PERMISSION_KEY,
            permissionOperators = _props$authorizationC.PERMISSION_OPERATOR;

        var hasLinkPrivilege = authorization.checkPrivileges([permissionKeys.EmailingDeliveryMethodLink]);
        var hasEmbeddedHTMLPrivilege = authorization.checkPrivileges([permissionKeys.EmailingDeliveryMethodEmbeddedHTML]);
        var hasAttachmentPrivilege = authorization.checkPrivileges([permissionKeys.EmailingDeliveryMethodAttachment]);

        this.deliveryMethods = (0, _fp.filter)(function (method) {
          return (hasLinkPrivilege || method.value !== "Link") && (hasEmbeddedHTMLPrivilege || method.value !== "Embedded HTML") && (hasAttachmentPrivilege || method.value !== "Attachment");
        }, this.deliveryMethods);
      }
    }

    /**
     * Load export file types dropdownlist
     */

  }, {
    key: "loadExportFileTypes",
    value: function loadExportFileTypes() {
      this.isShowExportFileTypes = false;
      if (this.subData.deliveryType === "File Location" && this.subData.deliveryMethod === "Send to disk") {
        this.isShowExportFileTypes = true;
        this.exportFileTypes = this.filterExportFileTypesWithPermission(_Izenda12.default.EXPORT_TYPE);

        if ((0, _fp.isNil)(this.exportFileTypes) || this.exportFileTypes.length === 0) {
          return;
        }

        if (this.subData.exportFileType) return;

        var pdfType = (0, _fp.find)(function (item) {
          return item.value === "PDF";
        }, this.exportFileTypes);

        if (pdfType) {
          this.subData.exportFileType = pdfType.value;
        } else {
          this.subData.exportFileType = (0, _fp.head)(this.exportFileTypes).value;
        }
      }
    }

    /**
     * Get file types based on permissions
     * @param {Array<any>} fileTypes
     */

  }, {
    key: "filterExportFileTypesWithPermission",
    value: function filterExportFileTypesWithPermission(fileTypes) {
      var _props2 = this.props,
          authorization = _props2.authorization,
          _props2$authorization = _props2.authorizationConstants,
          permissionKeys = _props2$authorization.PERMISSION_KEY,
          permissionOperators = _props2$authorization.PERMISSION_OPERATOR;


      var hasPdfPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatPdf]);
      var hasWordPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatWord]);
      var hasExcelPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatExcel]);
      var hasCsvPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatCsv]);
      var hasXmlPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatXml]);
      var hasJsonPrivilege = authorization.checkPrivileges([permissionKeys.ExportingExportingFormatJson]);

      var filterFileTypes = (0, _fp.filter)(function (fileType) {
        return (hasWordPrivilege || fileType.value !== "Word") && (hasExcelPrivilege || fileType.value !== "Excel") && (hasPdfPrivilege || fileType.value !== "PDF") && (hasCsvPrivilege || fileType.value !== "CSV") && (hasXmlPrivilege || fileType.value !== "XML") && (hasJsonPrivilege || fileType.value !== "JSON");
      }, fileTypes);

      return filterFileTypes;
    }

    /**
     * Get file types based on permissions
     * @param {Array<any>} fileTypes
     */

  }, {
    key: "filterAttachmentTypesWithPermission",
    value: function filterAttachmentTypesWithPermission(fileTypes) {
      var _props3 = this.props,
          authorization = _props3.authorization,
          _props3$authorization = _props3.authorizationConstants,
          permissionKeys = _props3$authorization.PERMISSION_KEY,
          permissionOperators = _props3$authorization.PERMISSION_OPERATOR;


      var hasPdfPrivilege = authorization.checkPrivileges([permissionKeys.EmailingAttachmentTypePdf]);
      var hasWordPrivilege = authorization.checkPrivileges([permissionKeys.EmailingAttachmentTypeWord]);
      var hasExcelPrivilege = authorization.checkPrivileges([permissionKeys.EmailingAttachmentTypeExcel]);
      var hasCsvPrivilege = authorization.checkPrivileges([permissionKeys.EmailingAttachmentTypeCsv]);
      var hasXmlPrivilege = authorization.checkPrivileges([permissionKeys.EmailingAttachmentTypeXml]);
      var hasJsonPrivilege = authorization.checkPrivileges([permissionKeys.EmailingAttachmentTypeJson]);

      var filterFileTypes = (0, _fp.filter)(function (fileType) {
        return (hasWordPrivilege || fileType.value !== "Word") && (hasExcelPrivilege || fileType.value !== "Excel") && (hasPdfPrivilege || fileType.value !== "PDF") && (hasCsvPrivilege || fileType.value !== "CSV") && (hasXmlPrivilege || fileType.value !== "XML") && (hasJsonPrivilege || fileType.value !== "JSON");
      }, fileTypes);

      return filterFileTypes;
    }

    /**
     * Check delivery email type permission.
     */

  }, {
    key: "deliveryEmailTypePermission",
    value: function deliveryEmailTypePermission() {
      var _props4 = this.props,
          authorization = _props4.authorization,
          permissionKeys = _props4.authorizationConstants.PERMISSION_KEY;

      var hasLinkPrivilege = authorization.checkPrivileges([permissionKeys.EmailingDeliveryMethodLink]);
      var hasEmbeddedHTMLPrivilege = authorization.checkPrivileges([permissionKeys.EmailingDeliveryMethodEmbeddedHTML]);
      var hasAttachmentPrivilege = authorization.checkPrivileges([permissionKeys.EmailingDeliveryMethodAttachment]);

      return hasLinkPrivilege || hasEmbeddedHTMLPrivilege || hasAttachmentPrivilege;
    }

    /**
     * onchange export file type dropdown
     * @param {any} dropdown
     */


    /**
     * on change attachment type
     * @param {any} dropdown
     */

  }, {
    key: "loadExportAttachmentTypes",


    /**
     * Load export attachment types dropdown
     */
    value: function loadExportAttachmentTypes() {
      this.isShowExportAttachmentTypes = false;
      if (this.subData.deliveryType === "Email" && this.subData.deliveryMethod === "Attachment") {
        this.isShowExportAttachmentTypes = true;
        this.exportAttachmentTypes = this.filterAttachmentTypesWithPermission(_Izenda12.default.EXPORT_TYPE);

        if ((0, _fp.isNil)(this.exportAttachmentTypes) || this.exportAttachmentTypes.length === 0) {
          return;
        }

        if (this.subData.exportAttachmentType) return;

        var pdfType = (0, _fp.find)(function (item) {
          return item.value === "PDF";
        }, this.exportAttachmentTypes);

        if (pdfType) {
          this.subData.exportAttachmentType = pdfType.value;
        } else {
          this.subData.exportAttachmentType = (0, _fp.head)(this.exportAttachmentTypes).value;
        }
      }
    }

    /**
     * get delivery type
     */

  }, {
    key: "getDeliveryType",
    value: function getDeliveryType() {
      return this.subData.deliveryType;
    }

    /**
     * onchange delivery type
     * @param {any} e
     */

  }, {
    key: "getDeliveryTypeList",


    /**
     * get delivery type list
     * @return {Array} deliveryType
     */
    value: function getDeliveryTypeList() {
      var types = [];
      if (this.subData.type === _Izenda27.default.INSTANCE_TYPE_VALUE.SUBSCRIBE_REPORTING_ITEM || this.subData.type === _Izenda27.default.INSTANCE_TYPE_VALUE.SCHEDULE_REPORT) {
        types = _Izenda12.default.DELIVERY_TYPE;
      } else {
        types = (0, _fp.pullAt)([1], _Izenda12.default.DELIVERY_TYPE);
      }

      !this.deliveryEmailTypePermission() && (types = (0, _fp.filter)(function (item) {
        return item.value !== _Izenda27.default.DELIVERY_TYPE_VALUE.EMAIL;
      }, types));
      return types;
    }

    /**
     * get delivery method
     */

  }, {
    key: "getDeliveryMethod",
    value: function getDeliveryMethod() {
      return this.subData.deliveryMethod;
    }

    /**
     * onchange delivery method dropdown
     * @param {any} e
     */

  }, {
    key: "getEmailSubject",


    /**
     * get email subject
     * @return {String} emailSubject
     */
    value: function getEmailSubject() {
      return this.subData.emailSubject;
    }

    /**
     * onchange email subject
     * @param {any} input
     */

  }, {
    key: "getEmailBody",


    /**
     * get email boy
     */
    value: function getEmailBody() {
      var deliveryMethod = this.subData.deliveryMethod;

      if (this.originalDeliveryMethod === deliveryMethod) {
        this.subData.emailBody = this.originalEmailBody;
        return;
      }

      var matchedBody = (0, _fp.find)(function (item) {
        return deliveryMethod === item.key;
      }, this.subData.emailTemplates);

      this.subData.updateProperty("emailBody", matchedBody && matchedBody.value);
    }

    /**
     * Handle onchange of Email Body
     * @param {any} e
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disposeDeliveryType();
      this.disposeDeliveryMethod();
    }

    /**
     * Show system variable popover for subject.
     * @param {number} position
     */


    /**
     * Show system variable popover for body.
     * @param {number} position
     */

  }, {
    key: "showSystemVariablesPopup",


    /**
     * Show system variable popover.
     * @param {string} sourceType
     * @param {number} position
     */
    value: function showSystemVariablesPopup(sourceType, position) {
      var domNode = _reactDom2.default.findDOMNode(this.refs[sourceType]);
      var scrollBoxValues = this.refs.scrollBox.getValues();
      var left = domNode.offsetParent.offsetLeft + (position && position.left + 20) - scrollBoxValues.scrollLeft;
      var top = domNode.offsetParent.offsetTop + (position && position.top + 150) - scrollBoxValues.scrollTop;
      var $sourceNode = sourceType === _Izenda12.default.ELEMENTS.EMAIL_SUBJECT.KEY ? $izenda(_Izenda12.default.ELEMENTS.EMAIL_SUBJECT.CLASS) : $izenda(_Izenda12.default.ELEMENTS.EMAIL_BODY.CLASS);
      var cursorPosition = $izenda($sourceNode).prop("selectionStart");

      var currentVisible = this.systemVariablesUI.visible;

      this.systemVariablesUI.populateData({
        visible: !currentVisible,
        left: left,
        top: top,
        sourceType: sourceType,
        cursorPosition: cursorPosition,
        $sourceNode: $sourceNode
      });
    }

    /**
     * Render system variable popover component.
     */

  }, {
    key: "renderSystemVariablesPopover",
    value: function renderSystemVariablesPopover() {
      return _react2.default.createElement(
        _Izenda21.Popover,
        {
          visible: this.systemVariablesUI.visible,
          positionLeft: this.systemVariablesUI.left,
          positionTop: this.systemVariablesUI.top
        },
        _react2.default.createElement(_Izenda23.default, { store: this.props.store, onSelect: this.onSelectSystemVariable })
      );
    }

    /**
     * Handle select system variable.
     * @param {string} name
     */

  }, {
    key: "renderExportFileType",


    /**
     * render export file type
     */
    value: function renderExportFileType() {
      if (this.isShowExportFileTypes) {
        return _react2.default.createElement(
          "div",
          { className: "form-group" },
          _react2.default.createElement(
            "div",
            { className: "col-md-3 control-label" },
            this.props.localization.getText("SUBSCRIPTION_LABEL_EXPORT_FILE_TYPE")
          ),
          _react2.default.createElement(
            "div",
            { className: "col-md-9" },
            _react2.default.createElement(ValidatorDropdown, {
              options: this.exportFileTypes,
              value: this.subData.exportFileType,
              onChange: this.onChangeExportFileType
            })
          )
        );
      }
      return null;
    }

    /**
     * render export attachment type dropdownlist
     */

  }, {
    key: "renderExportAttachmentType",
    value: function renderExportAttachmentType() {
      if (this.isShowExportAttachmentTypes) {
        return _react2.default.createElement(
          "div",
          { className: "form-group" },
          _react2.default.createElement(
            "div",
            { className: "col-md-3 control-label" },
            this.props.localization.getText("SUBSCRIPTION_LABEL_EXPORT_ATTACHMENT_TYPE")
          ),
          _react2.default.createElement(
            "div",
            { className: "col-md-9" },
            _react2.default.createElement(ValidatorDropdown, {
              options: this.exportAttachmentTypes,
              value: this.subData.exportAttachmentType,
              onChange: this.onChangeAttachmentType
            })
          )
        );
      }
      return null;
    }

    /**
     * render email subject textbox
     */

  }, {
    key: "renderEmailSubject",
    value: function renderEmailSubject() {
      if (this.isEmail) {
        return _react2.default.createElement(
          "div",
          { className: "form-group" },
          _react2.default.createElement(
            "div",
            { className: "col-md-3 control-label" },
            this.props.localization.getText("SUBSCRIPTION_LABEL_EMAIL_SUBJECT")
          ),
          _react2.default.createElement(
            "div",
            { className: "col-md-9" },
            _react2.default.createElement(_Izenda18.default, {
              type: "input",
              value: this.getEmailSubject(),
              className: "form-control email-subject",
              onChange: this.onChangeEmailSubject,
              onClickIcon: this.showSystemVariablesPopupForSubject,
              ref: _Izenda12.default.ELEMENTS.EMAIL_SUBJECT.KEY
            })
          )
        );
      }
      return null;
    }

    /**
     * render email body textbox
     */

  }, {
    key: "renderEmailBody",
    value: function renderEmailBody() {
      if (this.isEmail) {
        return _react2.default.createElement(
          "div",
          { className: "form-group" },
          _react2.default.createElement(
            "div",
            { className: "col-md-3 control-label" },
            this.props.localization.getText("SUBSCRIPTION_LABEL_EMAIL_BODY")
          ),
          _react2.default.createElement(
            "div",
            { className: "col-md-9" },
            _react2.default.createElement(_Izenda18.default, {
              value: this.subData.emailBody,
              rows: "10",
              cols: "50",
              className: "form-control email-body",
              onChange: this.onChangeEmailBody,
              onClickIcon: this.showSystemVariablesPopupForBody,
              ref: _Izenda12.default.ELEMENTS.EMAIL_BODY.KEY
            })
          )
        );
      }
      return null;
    }

    /**
     * render recipient component
     */

  }, {
    key: "renderRecipient",
    value: function renderRecipient() {
      if (this.isEmail) {
        return !this.subData.isSubscription ? _react2.default.createElement(_Izenda16.default, this.props) : null;
      }
      return null;
    }

    /**
     * render component
     */

  }, {
    key: "render",
    value: function render() {
      var localization = this.props.localization;

      return _react2.default.createElement(
        "div",
        { className: "izenda-SubscriptionDesigner-Container" },
        _react2.default.createElement(
          _Izenda20.default,
          { ref: "scrollBox" },
          _react2.default.createElement(
            "div",
            { className: "form-horizontal schedule" },
            _react2.default.createElement(
              "div",
              { className: "text-center izenda-text-bold u_marginBottom" },
              localization.getText("SUBSCRIPTION_LABEL_DELIVERY_RECIPIENT")
            ),
            _react2.default.createElement(
              "div",
              { className: "form-group" },
              _react2.default.createElement(
                "div",
                { className: "col-md-3 control-label" },
                localization.getText("SUBSCRIPTION_LABEL_DELIVERY_TYPE")
              ),
              _react2.default.createElement(
                "div",
                { className: "col-md-9" },
                _react2.default.createElement(ValidatorDropdown, {
                  options: this.getDeliveryTypeList(),
                  labelField: "label",
                  valueField: "value",
                  value: this.getDeliveryType(),
                  onChange: this.onChangeDeliveryType,
                  field: "DeliveryType",
                  validations: _Izenda12.default.CONTRAINTS.DELIVERY_TYPE
                })
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "form-group" },
              _react2.default.createElement(
                "div",
                { className: "col-md-3 control-label" },
                localization.getText("COMMON_LABEL_DELIVERY_METHOD")
              ),
              _react2.default.createElement(
                "div",
                { className: "col-md-9" },
                _react2.default.createElement(ValidatorDropdown, {
                  options: this.deliveryMethods,
                  value: this.getDeliveryMethod(),
                  onChange: this.onChangeDeliveryMethod,
                  field: "DeliveryMethod",
                  validations: _Izenda12.default.CONTRAINTS.DELIVERY_METHOD
                })
              )
            ),
            this.renderExportFileType(),
            this.renderExportAttachmentType(),
            this.renderRecipient(),
            this.renderEmailSubject(),
            this.renderEmailBody(),
            _react2.default.createElement("hr", null),
            _react2.default.createElement(_Izenda14.default, this.props)
          )
        ),
        this.renderSystemVariablesPopover()
      );
    }
  }]);
  return Delivery;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object
}, _temp)) || _class);
exports.default = Delivery;
module.exports = exports["default"];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterValueSelection.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
//</copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

var _Izenda = __webpack_require__(421);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1163);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(324);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2480);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(12);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterValueSelection = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FilterValueSelection, _Component);

  function FilterValueSelection(props) {
    (0, _classCallCheck3.default)(this, FilterValueSelection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FilterValueSelection.__proto__ || (0, _getPrototypeOf2.default)(FilterValueSelection)).call(this, props));

    _this.showFilter = function () {
      return _this.store.model.reportFilter.configFieldList.length > 0 && (0, _fp.filter)(function (config) {
        return config.filterInfo.operator.name !== "...";
      }, _this.store.model.reportFilter.configFieldList).length > 0;
    };

    var dashboardDetail = props.dashboardDetail,
        data = props.data,
        reportState = props.reportState;

    _this.store = null;
    var subscriptionFilterValues = null;

    if (dashboardDetail) {
      _this.store = new _Izenda4.default(dashboardDetail);
      subscriptionFilterValues = data.subscriptionCommonFilterFields;
      _this.store.getFilterData(null, subscriptionFilterValues).then(function () {
        var isDashboard = true;
        var subscriptionData = _this.props.data;
        var subscriptionCommonFilterFields = data.subscriptionCommonFilterFields;
        var configFieldList = (0, _fp.get)('store.model.reportFilter.configFieldList', _this);
        var commonfilters = (0, _fp.get)('store.filters', _this);
        if (subscriptionCommonFilterFields.length == 0) {
          _this.initDefaultFilters(subscriptionData, configFieldList, isDashboard, commonfilters);
        }
      });
    } else {
      var masterStore = new _Izenda6.default();
      _this.store = new _Izenda2.default(masterStore, true, reportState);
      _this.store.reportStore.model.reportId = data.reportId;
      subscriptionFilterValues = data.subscriptionFilterFields;
      _this.store.loadReportFilter().then(function (result) {
        _this.store.getFilterData(null, subscriptionFilterValues).then(function () {
          var isDashboard = false;
          var _this$store$model$rep = _this.store.model.reportFilter,
              configFieldList = _this$store$model$rep.configFieldList,
              filterFields = _this$store$model$rep.filterFields;

          var subscriptionData = _this.props.data;
          // set default value for subscription filter based on report filter value
          if (data.subscriptionFilterFields.length == 0) {
            _this.initDefaultFilters(subscriptionData, configFieldList, isDashboard, result);
          }
        });
      });
    }
    return _this;
  }

  /**
   * init default filter value for report and dashboard subscription
   */


  (0, _createClass3.default)(FilterValueSelection, [{
    key: "initDefaultFilters",
    value: function initDefaultFilters(subscriptionData, configFieldList, isDashboard, reportFilters) {
      (0, _fp.forEach)(function (item) {
        var filterFieldId = item.fieldDetails.id;
        var reportFilter = isDashboard ? (0, _fp.find)({ 'id': filterFieldId }, reportFilters) : (0, _fp.find)({ 'sourceFieldName': item.sourceFieldName }, reportFilters);
        var value = reportFilter.value,
            operatorId = reportFilter.operatorId,
            operatorSetting = reportFilter.operatorSetting;

        item.updateFilterValue(subscriptionData, filterFieldId, isDashboard, value, operatorId, operatorSetting);
      }, configFieldList);
    }

    /**
     * Show filter
     * @returns {Boolean}
     */

  }, {
    key: "render",


    /**
     * Render Component
     * @returns {Object} component
     */
    value: function render() {
      return this.showFilter() ? _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "text-center izenda-text-bold" },
          _Izenda10.default.getText("SUBSCRIPTION_LABEL_FILTER_VALUE_SELECTION")
        ),
        _react2.default.createElement(_Izenda8.default, (0, _extends3.default)({}, this.props, {
          filterStore: this.store,
          filters: this.store.model.reportFilter,
          isLazyLoading: true
        }))
      ) : null;
    }
  }]);
  return FilterValueSelection;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object
}, _class2.displayName = "FilterValueSelection", _temp)) || _class;

exports.default = FilterValueSelection;
module.exports = exports["default"];

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterSubscription.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(626);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(628);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(89);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterSubscription = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FilterSubscription, _Component);

  function FilterSubscription(props) {
    (0, _classCallCheck3.default)(this, FilterSubscription);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FilterSubscription.__proto__ || (0, _getPrototypeOf2.default)(FilterSubscription)).call(this, props));

    _initialiseProps.call(_this);

    if (!!props.dashboardDetail) {
      _this.originalGetData = props.filterStore.getData;
      props.filterStore.getData = _this.customGetData();
    }
    return _this;
  }

  /**
   * Handle change of operator value.
   * @param {object} item
   * @param {number} index
   */


  /**
   * Render operator value component.
   */


  /**
   * Render operator component.
   */


  (0, _createClass3.default)(FilterSubscription, [{
    key: "doesRenderOperator",


    /**
     * Check need to render operator.
     * @param {string} operatorGroupName
     * @param {string} operatorName
     */
    value: function doesRenderOperator(operatorGroupName, operatorName) {
      return operatorGroupName === _Izenda8.default.OPERATOR_GROUP_KEYS.BOOLEAN || (0, _fp.any)(function (value) {
        return operatorName === value;
      }, _Izenda8.default.OPERATOR_KEYS);
    }
  }, {
    key: "buildHintMessage",
    value: function buildHintMessage(item) {
      var message = null;
      var fieldDetails = item.fieldDetails;
      var operatorKey = item.filterInfo.operator.key;
      var keys = ["equals(manualentry)", "equals(manualentrynoauto-complete)", "notequal(manualentry)", "notequal(manualentrynoauto-complete)", "equals(selection)", "notequal(selection)"];

      var index = (0, _fp.findIndex)(function (item) {
        return item === operatorKey;
      }, keys);

      if (index === -1) return message;

      if (fieldDetails.operatorSetting === _Izenda8.default.SELECT_SETTINGS.MULTIPLE) {
        message = _Izenda8.default.SELECT_TEXT.MULTIPLE;
      } else {
        message = _Izenda8.default.SELECT_TEXT.SINGLE;
      }

      return message;
    }

    /**
     * Render Filter Subscription component
     * @returns {object} component
     */

  }, {
    key: "render",


    /**
     * Render Component
     * @returns {object} component
     */
    value: function render() {
      return _react2.default.createElement(
        _Izenda6.default,
        null,
        this.renderFilterSubscription()
      );
    }
  }]);
  return FilterSubscription;
}(_react.Component), _class2.displayName = "FilterSubscription", _class2.propTypes = {
  filters: _react.PropTypes.object
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onChangeOperatorValue = function (item, index) {
    return function (value) {
      var isDashboardDetail = !!_this2.props.dashboardDetail;
      var _props = _this2.props,
          filters = _props.filters,
          data = _props.data,
          updateCascadingFilterValue = _props.updateCascadingFilterValue;

      var filterFieldId = isDashboardDetail ? item.fieldDetails.id : filters.visibleConfigFields[index] && filters.visibleConfigFields[index].id || item.fieldDetails.id;

      item.updateFilterValue(data, filterFieldId, isDashboardDetail, value, item.selectedOperatorId);
      updateCascadingFilterValue && updateCascadingFilterValue(item, filters.visibleConfigFields, isDashboardDetail ? data.subscriptionCommonFilterFields : data.subscriptionFilterFields);
    };
  };

  this.customGetData = function () {
    var _props2 = _this2.props,
        dashboardDetail = _props2.dashboardDetail,
        _props2$data = _props2.data,
        subscriptionCommonFilterFields = _props2$data.subscriptionCommonFilterFields,
        subscriptionFilterFields = _props2$data.subscriptionFilterFields,
        filterStore = _props2.filterStore;

    var filterFields = !!dashboardDetail ? subscriptionCommonFilterFields : subscriptionFilterFields;
    var originalGetData = _this2.originalGetData;
    return function (pageInfo, configField, searchKey, isSearching) {
      return originalGetData.call(filterStore, pageInfo, configField, searchKey, isSearching, filterFields);
    };
  };

  this.renderOperatorValue = function (item, index, reportFilter) {
    var props = _this2.props;
    var isDashboardDetail = !!props.dashboardDetail;
    var filterFieldId = isDashboardDetail ? item.fieldDetails.id : reportFilter.filterFields[index] && reportFilter.filterFields[index].id || item.fieldDetails.id;
    var filterInfo = item.filterInfo;

    if (_this2.doesRenderOperator(filterInfo.group.name, filterInfo.operator.name)) {
      return null;
    }

    return _react2.default.createElement(_Izenda2.default, {
      filterSource: item.operatorSourceValue,
      filterInfo: item.filterInfo,
      operatorGroup: item,
      viewMode: true,
      isLazyLoading: props.isLazyLoading,
      store: props.filterStore,
      configField: item,
      onChange: _this2.onChangeOperatorValue(item, index)
    });
  };

  this.updateSourceValue = function (item, index, reportFilter) {
    var isDashboardDetail = !!_this2.props.dashboardDetail;
    var filterFieldId = isDashboardDetail ? item.fieldDetails.id : reportFilter.filterFields[index] && reportFilter.filterFields[index].id || item.fieldDetails.id;

    return function () {
      var _item$setOperatorIdSu;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_item$setOperatorIdSu = item.setOperatorIdSubscription).call.apply(_item$setOperatorIdSu, [item, _this2.props.data, filterFieldId, isDashboardDetail].concat(args));
    };
  };

  this.renderOperator = function (item, index, reportFilter) {
    var filterInfo = item.filterInfo;

    if (!_this2.doesRenderOperator(filterInfo.group.name, filterInfo.operator.name)) return null;

    return _react2.default.createElement(_Izenda4.default, {
      notInReportDesignerMode: true,
      configField: item,
      updateSourceValue: _this2.updateSourceValue(item, index, reportFilter)
    });
  };

  this.renderFilterSubscription = function () {
    var reportFilter = _this2.props.filters;
    return reportFilter.visibleConfigFields.map(function (item, index) {
      var fieldDetails = item.fieldDetails;
      var filterLabel = fieldDetails.alias;
      var hintMessage = _this2.buildHintMessage(item);

      return _react2.default.createElement(
        _Izenda6.default.Row,
        { key: index },
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 3, className: "control-label" },
          index + 1,
          ".",
          filterLabel
        ),
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 3, className: "control-label" },
          item.filterInfo.operator.label
        ),
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 5 },
          _this2.renderOperator(item, index, reportFilter),
          _this2.renderOperatorValue(item, index, reportFilter)
        ),
        _react2.default.createElement(
          _Izenda6.default.Col,
          { cols: 1 },
          hintMessage && _react2.default.createElement("span", {
            className: "icon-info-circled izenda-FilterSubscription-hintIcon u_inlineBlock",
            title: hintMessage
          })
        )
      );
    });
  };
}, _temp)) || _class;

exports.default = FilterSubscription;
module.exports = exports["default"];

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueDatetime.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueDatetime component
 */
!function () {
  var m = __webpack_require__(10);
  var React = __webpack_require__(0);

  var OperatorValueOneDatePicker = __webpack_require__(2482);
  var OperatorValueTwoDatePicker = __webpack_require__(2483);
  var OperatorValueInput = __webpack_require__(627);
  var OperatorValueDropdownGroup = __webpack_require__(1165);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      placeholder = _require.placeholder;

  /**
   * Get component render function
   * @param  {object} object Component object
   * @param  {string} key Operator filter key
   * @return {function} Render component function
   */


  function getComponentRender(object, key) {
    return placeholder(object).get(key);
  }

  /**
   * Datetime filter value
   * @type {Object}
   */
  var dateTimeFilterComponents = {
    'equals(date)': {
      component: OperatorValueOneDatePicker,
      props: {
        time: false
      }
    },
    'equals(date&time)': {
      component: OperatorValueOneDatePicker
    },
    'equals(time)': {
      component: OperatorValueOneDatePicker,
      props: {
        calendar: false
      }
    },
    'notequal(date)': {
      component: OperatorValueOneDatePicker,
      props: {
        time: false
      }
    },
    'notequal(date&time)': {
      component: OperatorValueOneDatePicker
    },
    'notequal(time)': {
      component: OperatorValueOneDatePicker,
      props: {
        calendar: false
      }
    },
    'between(date)': {
      component: OperatorValueTwoDatePicker,
      props: {
        time: false
      }
    },
    'between(date&time)': {
      component: OperatorValueTwoDatePicker
    },
    'between(time)': {
      component: OperatorValueTwoDatePicker,
      props: {
        calendar: false
      }
    },
    'notbetween(date)': {
      component: OperatorValueTwoDatePicker,
      props: {
        time: false
      }
    },
    'notbetween(date&time)': {
      component: OperatorValueTwoDatePicker
    },
    'notbetween(time)': {
      component: OperatorValueTwoDatePicker,
      props: {
        calendar: false
      }
    },
    intimeperiod: {
      component: OperatorValueDropdownGroup,
      props: {
        labelField: 'name',
        valueField: 'id',
        groupBy: 'type'
      }
    },
    lessthandaysold: {
      component: OperatorValueInput,
      props: {
        isNumberInput: true
      }
    },
    equalsdaysold: {
      component: OperatorValueInput,
      props: {
        isNumberInput: true
      }
    },
    greaterthandaysold: {
      component: OperatorValueInput,
      props: {
        isNumberInput: true
      }
    },
    'islessthan(date)': {
      component: OperatorValueOneDatePicker,
      props: {
        time: false
      }
    },
    'islessthan(date&time)': {
      component: OperatorValueOneDatePicker
    },
    'islessthan(time)': {
      component: OperatorValueOneDatePicker,
      props: {
        calendar: false
      }
    },
    'isgreaterthan(date)': {
      component: OperatorValueOneDatePicker,
      props: {
        time: false
      }
    },
    'isgreaterthan(date&time)': {
      component: OperatorValueOneDatePicker
    },
    'isgreaterthan(time)': {
      component: OperatorValueOneDatePicker,
      props: {
        calendar: false
      }
    }
  };

  /**
   * [FilterValueDatetime description]
   * @param {[type]} props [description]
   */
  var OperatorValueDatetime = function OperatorValueDatetime(props) {
    var filterSource = this.props.filterSource;
    var filterInfo = this.props.filterInfo;
    var operator = filterInfo.operator || {};

    var key = operator.key;
    var componentInfo = getComponentRender(dateTimeFilterComponents, key);

    if (isNil(componentInfo)) {
      return null;
    }

    return React.createElement(componentInfo.component, (0, _extends3.default)({}, componentInfo.props, props));
  };

  module.exports = m.observer(OperatorValueDatetime);
}();

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueOneDatePicker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * One datetime picker component
 */
!function () {
  __webpack_require__(55);
  var React = __webpack_require__(0);
  var DateTimePicker = __webpack_require__(170);
  var Constants = __webpack_require__(16);

  var OperatorValueOneDatePicker = React.createClass({
    displayName: 'OperatorValueOneDatePicker',


    propTypes: {
      filterInfo: React.PropTypes.object.isRequired
    },

    /**
      * When change value of datepicker, set state value
      * @param  {string} newVal
      */
    onChange: function onChange(newVal) {
      this.props.onChange([newVal]);
    },

    render: function render() {
      var props = this.props;
      var filterInfo = props.filterInfo || {};
      var dateString = filterInfo.value && filterInfo.value[0];

      return React.createElement(DateTimePicker, {
        onChange: this.onChange,
        value: dateString,
        disabled: props.disabled,
        time: props.time,
        calendar: props.calendar });
    }
  });

  module.exports = OperatorValueOneDatePicker;
}();

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueTwoDatePicker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Two datetime picker component
 */
!function () {

  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var DateTimePicker = __webpack_require__(170);
  var Constants = __webpack_require__(16);
  var GridLayout = __webpack_require__(13);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var OperatorValueTwoDatePicker = React.createClass({
    displayName: 'OperatorValueTwoDatePicker',

    propTypes: {
      filterInfo: React.PropTypes.object.isRequired
    },

    /**
     * When change value of datepicker
     * @param  {string} newVal
     */
    onChangeLessThanDate: function onChangeLessThanDate(newVal) {
      var greaterDate = isNil(this.props.filterInfo.value) ? null : this.props.filterInfo.value[1];
      var value = [newVal, greaterDate];
      this.props.onChange(value);
    },

    /**
     * When change value of datepicker
     * @param  {string} newVal
     */
    onChangeGreaterDate: function onChangeGreaterDate(newVal) {
      var lessThanDate = isNil(this.props.filterInfo.value) ? null : this.props.filterInfo.value[0];
      var value = [lessThanDate, newVal];
      this.props.onChange(value);
    },

    render: function render() {
      var props = this.props;
      var filterInfo = props.filterInfo || {};
      var lessThanDateString = filterInfo.value && filterInfo.value[0];
      var greaterDateString = filterInfo.value && filterInfo.value[1];
      return React.createElement(
        GridLayout,
        { className: 'u_paddingAll' },
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(DateTimePicker, {
            onChange: this.onChangeLessThanDate,
            value: lessThanDateString,
            disabled: props.disabled,
            time: props.time,
            calendar: props.calendar
          })
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(DateTimePicker, {
            onChange: this.onChangeGreaterDate,
            value: greaterDateString,
            disabled: props.disabled,
            time: props.time,
            calendar: props.calendar
          })
        )
      );
    }
  });

  module.exports = OperatorValueTwoDatePicker;
}();

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueComparison.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueComparison component
 */
!function () {
  var m = __webpack_require__(10);
  var React = __webpack_require__(0);

  var OperatorValueInput = __webpack_require__(627);
  var OperatorValueTwoInput = __webpack_require__(2485);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      placeholder = _require.placeholder;
  /**
   * Get component render function
   * @param  {object} object Component object
   * @param  {string} key Operator filter key
   * @return {function} Render component function
   */


  function getComponentRender(object, key) {
    return placeholder(object).get(key);
  }

  /**
   * Datetime filter value
   * @type {Object}
   */
  var comparisonFilterComponents = {
    notbetween: {
      component: OperatorValueTwoInput
    },
    between: {
      component: OperatorValueTwoInput
    },
    notgreaterthan: {
      component: OperatorValueInput
    },
    notlessthan: {
      component: OperatorValueInput
    },
    isgreaterthan: {
      component: OperatorValueInput
    },
    islessthan: {
      component: OperatorValueInput
    }
  };

  /**
   * OperatorValueComparison description
   * @param {type} props description
   */
  var OperatorValueComparison = function OperatorValueComparison(props) {
    var operator = props.filterInfo.operator || {};
    var key = operator.key;
    var componentInfo = getComponentRender(comparisonFilterComponents, key);

    if (isNil(componentInfo)) {
      return null;
    }

    return React.createElement(componentInfo.component, props);
  };

  module.exports = m.observer(OperatorValueComparison);
}();

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueTwoInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueTwoInput component
 */
!function () {
  'use strict';

  var m = __webpack_require__(10);
  var React = __webpack_require__(0);
  var Input = __webpack_require__(17);
  var GridLayout = __webpack_require__(13);
  var OperatorValueTwoInput = React.createClass({
    displayName: 'OperatorValueTwoInput',

    propTypes: {
      filterInfo: React.PropTypes.object.isRequired,
      onChange: React.PropTypes.func
    },

    render: function render() {

      var props = this.props;
      var filterInfo = props.filterInfo || {};
      return React.createElement(
        GridLayout,
        { className: 'u_paddingAll' },
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(Input, { onChange: onChangeLessThanString.bind(this),
            value: filterInfo.value && filterInfo.value[0],
            className: 'form-control',
            disabled: props.disabled })
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(Input, { onChange: onChangeGreaterThanString.bind(this),
            value: filterInfo.value && filterInfo.value[1],
            className: 'form-control',
            disabled: props.disabled })
        )
      );

      function onChangeLessThanString(e) {
        var greaterThanString = this.props.filterInfo.value[1] || '';
        this.props.onChange && this.props.onChange([e.target.value, greaterThanString]);
      };

      function onChangeGreaterThanString(e) {
        var lessThanString = this.props.filterInfo.value[0] || '';
        this.props.onChange && this.props.onChange([lessThanString, e.target.value]);
      };
    }
  });

  module.exports = OperatorValueTwoInput;
}();

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _mobxReact = __webpack_require__(10);

var _mobxReact2 = _interopRequireDefault(_mobxReact);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2487);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2489);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2490);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2492);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1166);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2493);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2494);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(16);

var _Izenda16 = __webpack_require__(115);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda18 = __webpack_require__(15);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Datetime filter value
 * @type {Object}
 */
var comparisonFilterComponents = {
  'equals(popup)': {
    component: _Izenda2.default
  },
  'equals(tree)': {
    component: _Izenda6.default
  },
  'equals(checkbox)': {
    component: _Izenda4.default
  },
  'notequal(popup)': {
    component: _Izenda2.default
  },
  'notequal(checkbox)': {
    component: _Izenda4.default
  },
  'notequal(tree)': {
    component: _Izenda6.default
  },
  'equals(manualentry)': {
    component: _Izenda8.default,
    subComponent: _Izenda12.default,
    props: {
      labelField: 'label',
      valueField: 'value'
    }
  },
  'equals(manualentrynoauto-complete)': {
    component: _Izenda14.default,
    props: {
      labelField: 'label',
      valueField: 'value'
    }
  },
  'notequal(manualentry)': {
    component: _Izenda8.default,
    subComponent: _Izenda12.default,
    props: {
      labelField: 'label',
      valueField: 'value'
    }
  },
  'notequal(manualentrynoauto-complete)': {
    component: _Izenda14.default,
    props: {
      labelField: 'label',
      valueField: 'value'
    }
  },
  'equals(selection)': {
    component: _Izenda8.default,
    subComponent: _Izenda12.default,
    props: {
      labelField: 'label',
      valueField: 'value',
      isSelect: true
    }
  },
  'notequal(selection)': {
    component: _Izenda8.default,
    subComponent: _Izenda12.default,
    props: {
      labelField: 'label',
      valueField: 'value',
      isSelect: true
    }
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueEquivalence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueEquivalence component
 */

var action = (0, _recompose.compose)((0, _recompose.withHandlers)({
  applyFormater: function applyFormater(props) {
    var configField = props.configField || {};
    var fieldDetails = configField.fieldDetails || {};
    var dataType = fieldDetails.dataType;
    var applyFormater = _fp.identity;

    if (dataType === _Izenda15.DATA_TYPES.DATE_TIME) {
      var displayDateFormat = _Izenda19.default.currentUser.dateFormat;
      var displayDateTimeFomat = [displayDateFormat, _Izenda16.TIME_FORMAT].join(' ');

      applyFormater = function applyFormater(value) {
        var momentObject = (0, _moment2.default)(value, _Izenda16.DATE_TIME_FORMAT, true);

        if (momentObject.isValid()) {
          return momentObject.format(displayDateTimeFomat);
        }
        return value;
      };
    }
    return applyFormater;
  }
}), _mobxReact2.default.observer);

var OperatorValueEquivalence = action(function (props) {
  var operator = props.filterInfo.operator || {};
  var key = operator.key;
  var componentInfo = comparisonFilterComponents[key];

  if ((0, _fp.isNil)(componentInfo)) {
    return null;
  }

  var Component = componentInfo.component;
  if (props.isLazyLoading && (0, _fp.has)('subComponent', componentInfo)) {
    Component = componentInfo.subComponent;
  }

  return _react2.default.createElement(Component, (0, _extends3.default)({}, componentInfo.props, props, { applyFormater: props.applyFormater }));
});

OperatorValueEquivalence.displayName = 'OperatorValueEquivalence';

exports.default = OperatorValueEquivalence;
module.exports = exports['default'];

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PopupButton.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * PopupButton component
 */
!function () {
  var React = __webpack_require__(0);

  var Button = __webpack_require__(30);
  var OperatorValueCheckBoxPopup = __webpack_require__(2488);
  var OperatorValueCheckBoxPopupLazyLoading = __webpack_require__(1166);
  var connect = __webpack_require__(2);
  var ScrollBox = __webpack_require__(27);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      flow = _require.flow,
      identity = _require.identity,
      isEmpty = _require.isEmpty,
      map = _require.map,
      join = _require.join,
      filter = _require.filter;

  var PopupButton = React.createClass({
    displayName: 'PopupButton',

    propTypes: {
      filterSource: React.PropTypes.object.isRequired,
      filterInfo: React.PropTypes.object.isRequired,
      applyFormater: React.PropTypes.func
    },
    getDefaultProps: function getDefaultProps() {
      return {
        applyFormater: identity
      };
    },

    handleShowPopup: function handleShowPopup() {
      var Component = this.props.isLazyLoading ? OperatorValueCheckBoxPopupLazyLoading : OperatorValueCheckBoxPopup;
      this.props.openPopup(Component, this.props);
    },

    render: function render() {
      var props = this.props;
      var filterValues = props.filterInfo.value;
      var applyFormater = this.props.applyFormater;
      var value = flow(filter(function (item) {
        return !isEmpty(item);
      }), map(applyFormater), join(', '))(filterValues);

      return React.createElement(
        'div',
        null,
        React.createElement(Button, { disabled: props.disabled, label: '...', onClick: this.handleShowPopup, className: 'btn-popup' }),
        React.createElement(
          'div',
          { className: 'filter-value' },
          React.createElement(
            ScrollBox,
            { autoHeight: true, autoHeightMax: 150 },
            value
          )
        )
      );
    }
  });

  module.exports = connect()(PopupButton);
}();

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueCheckBoxPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Checkbox Container component
 */
!function () {
  var m = __webpack_require__(5);
  var React = __webpack_require__(0);
  var Popup = __webpack_require__(36);
  var OverflowText = __webpack_require__(68);
  var GridLayout = __webpack_require__(13);
  var constants = __webpack_require__(89);
  var BLANK = constants.DEFAUFT_VALUE.BLANK;
  var ScrollBox = __webpack_require__(27);
  var localizer = __webpack_require__(12);

  var _require = __webpack_require__(1),
      without = _require.without,
      identity = _require.identity,
      clone = _require.clone,
      includes = _require.includes,
      chunk = _require.chunk,
      invokeArgs = _require.invokeArgs;

  var OperatorValueCheckBoxPopup = React.createClass({
    displayName: 'OperatorValueCheckBoxPopup',

    propTypes: {
      filterSource: React.PropTypes.object.isRequired,
      filterInfo: React.PropTypes.object.isRequired,
      showPopup: React.PropTypes.bool,
      applyFormater: React.PropTypes.func,
      onChange: React.PropTypes.func
    },

    getInitialState: function getInitialState() {
      return {
        selectedValues: null
      };
    },

    handleValueChange: function handleValueChange(item, data) {
      var selectedValues = this.state.selectedValues;

      if (!item.checked) {
        selectedValues.push(item.value);
      } else {
        selectedValues = without([item.value], selectedValues);
      }

      this.setState({ selectedValues: selectedValues });
    },

    onClosingPopup: function onClosingPopup(type) {
      var props = this.props;
      if (type === 'accept') {
        props.onChange && props.onChange(this.state.selectedValues);
        this.setState({ selectedValues: null });
        props.onAccept();
      } else if (type === 'cancel') {
        this.setState({ selectedValues: null });
        props.onReject();
      }
    },

    populateSelectedValues: function populateSelectedValues(filterInfo) {
      filterInfo = filterInfo || {};
      var filterValues = clone(filterInfo.value);
      this.setState({
        selectedValues: filterValues
      });
    },

    componentWillMount: function componentWillMount() {
      this.populateSelectedValues(this.props.filterInfo);
    },

    /**
     * Handle when receive react property
     * @param  {object} nextProps react property
     */
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.populateSelectedValues(nextProps.filterInfo);
    },

    render: function render() {
      var props = this.props;
      var filterValues = this.state.selectedValues || [];
      var popupTitle = this.props.operatorGroup.fieldDetails.alias;
      var source = m.toJS(props.filterSource || []);
      // add BLANK option to the first element
      source.splice(0, 0, BLANK);
      var applyFormater = this.props.applyFormater || identity;

      var data = source.map(function (value) {
        return {
          value: value,
          label: applyFormater(value),
          checked: includes(value, filterValues)
        };
      });

      var options = data.map(function (item, index) {
        return React.createElement(
          GridLayout.Col,
          { className: 'checkbox u_noMarginTop', cols: 4, key: 'chk-' + index },
          React.createElement(
            'label',
            null,
            React.createElement('input', {
              type: 'checkbox',
              value: item.value,
              checked: item.checked,
              onChange: this.handleValueChange.bind(this, item, data)
            }),
            React.createElement(
              OverflowText,
              { tooltip: item.label },
              item.label
            )
          )
        );
      }.bind(this));

      var chunkOptions = chunk(3, options);

      return React.createElement(
        Popup,
        { visible: true, onClosed: this.onClosingPopup, autoClose: true, type: 'none' },
        React.createElement(Popup.Header, { title: popupTitle }),
        React.createElement(
          Popup.Body,
          null,
          React.createElement(
            'div',
            { className: 'izenda-OperatorValueCheckBoxPopup' },
            React.createElement(
              ScrollBox,
              null,
              React.createElement(
                GridLayout,
                null,
                chunkOptions.map(function (item, index) {
                  return React.createElement(
                    GridLayout.Row,
                    { key: index, className: 'u_noMarginAll' },
                    item
                  );
                })
              )
            )
          )
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localizer.getText('COMMON_LABEL_OK')
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localizer.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  });

  module.exports = OperatorValueCheckBoxPopup;
}();

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueCheckBoxList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Checkbox Container component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var constants = __webpack_require__(89);
  var ALL = constants.DEFAUFT_VALUE.ALL;
  var BLANK = constants.DEFAUFT_VALUE.BLANK;
  var NULL = constants.DEFAUFT_VALUE.NULL;
  var ScrollBox = __webpack_require__(27);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      identity = _require.identity,
      isEmpty = _require.isEmpty,
      invokeArgs = _require.invokeArgs;

  var OperatorValueCheckBoxList = observer(React.createClass({
    displayName: 'OperatorValueCheckBoxList',

    propTypes: {
      onChange: React.PropTypes.func,
      filterSource: React.PropTypes.object.isRequired,
      filterInfo: React.PropTypes.object.isRequired,
      applyFormater: React.PropTypes.func
    },
    getDefaultProps: function getDefaultProps() {
      return {
        applyFormater: identity
      };
    },

    // TODO: remove this block of code below when applying lazyload.
    // Try to get data (in subreport inherited filter) if filtersource is empty.
    componentDidMount: function componentDidMount() {
      isEmpty(this.props.filterSource) && invokeArgs('getOperatorValueSource', [this.props.configField], this.props.store);
    },

    handleValueChange: function handleValueChange(item, data) {
      var selectedValues = isEmpty(this.props.filterInfo.value[0]) ? [] : this.props.filterInfo.value;
      var sourceValues = this.props.filterSource.map(function (item) {
        return item;
      });

      if (selectedValues.length === 1 && selectedValues[0] === ALL) {
        selectedValues = sourceValues;
        selectedValues.push(BLANK);
      }

      if (!item.checked) {
        selectedValues.push(item.value);
      } else {
        selectedValues = filter(function (i) {
          return i !== item.value;
        }, selectedValues);
      }

      // For check all
      if (item.value === ALL && !item.checked) {
        selectedValues = [ALL];
      } else if (item.value === ALL && item.checked) {
        selectedValues = [];
      } else if (item.value !== ALL && !item.checked && selectedValues.length === sourceValues.length + 1) {
        selectedValues = [ALL];
      }

      var onChange = this.props.onChange;
      onChange && onChange(selectedValues);
    },

    mapDataSource: function mapDataSource(source, filterValues, isCheckAll) {
      var applyFormater = this.props.applyFormater;
      return source.map(function (value) {
        var checked = isCheckAll ? true : filterValues.indexOf(value) > -1;
        return {
          value: value,
          label: applyFormater(value),
          checked: checked
        };
      });
    },

    render: function render() {
      var source = [ALL, BLANK, NULL];
      var props = this.props;
      var filterSource = props.filterSource || [];
      var filterValues = props.filterInfo.value || [];

      // convert obser to normal array
      var filterSourceArray = filterSource.map(function (item) {
        return item;
      });

      // Add filter value
      source.push.apply(source, (0, _toConsumableArray3.default)(filterSourceArray));
      // Map filter source with filter value
      var data = filterValues.length === 1 && filterValues[0] === ALL ? this.mapDataSource(source, filterValues, true) : this.mapDataSource(source, filterValues, false);

      var options = data.map(function (item, index) {
        return React.createElement(
          'div',
          { className: 'checkbox', key: 'chk-' + index },
          React.createElement(
            'label',
            null,
            React.createElement('input', {
              type: 'checkbox',
              value: item.value,
              checked: item.checked ? true : false,
              onChange: this.handleValueChange.bind(this, item, data),
              disabled: props.disabled
            }),
            React.createElement(
              'span',
              { title: item.label },
              ' ',
              item.label
            )
          )
        );
      }.bind(this));

      return React.createElement(
        'div',
        { className: 'filter-value' },
        React.createElement(
          ScrollBox,
          { autoHeight: true, autoHeightMax: constants.MAX_HEIGHT },
          options
        )
      );
    }
  }));

  module.exports = OperatorValueCheckBoxList;
}();

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueComboTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Dropdown Tree Select Container component
 */

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2491);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(17);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(47);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(154);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(27);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ALL_TEXT = '[All]';
var NUMBER_ZERO = 0;

var TreeDropDown = (0, _mobxReact.observer)(function (props) {
  var hideTreeView = props.hideTreeView,
      applyFormater = props.applyFormater,
      handleChangeTreeSelect = props.handleChangeTreeSelect,
      disabled = props.disabled,
      _props$observableObje = props.observableObject,
      isOpen = _props$observableObje.isOpen,
      selectedItems = _props$observableObje.selectedItems,
      comboTreeDom = props.masterDom.comboTreeDom;


  if (!isOpen) {
    return null;
  }
  return _react2.default.createElement(
    _Izenda8.default,
    { anchor: comboTreeDom, onClickOutside: hideTreeView, onParentScroll: hideTreeView },
    _react2.default.createElement(_Izenda2.default, {
      data: selectedItems,
      applyFormater: applyFormater,
      onChange: handleChangeTreeSelect,
      disabled: disabled
    })
  );
});

var SelectedValue = (0, _mobxReact.observer)(function (props) {
  var onChangeSelect = props.onChangeSelect,
      disabled = props.disabled;

  var selectedValues = (0, _fp.map)(function (item) {
    return { id: item.value, label: props.applyFormater(item.text) };
  }, this.props.observableObject.selectedValues);

  var allValue = (0, _fp.find)({ id: ALL_TEXT }, selectedValues);
  if (!(0, _fp.isEmpty)(allValue)) {
    selectedValues = [allValue];
  }

  if ((0, _fp.isEmpty)(selectedValues)) {
    return null;
  }

  return selectedValues.length > NUMBER_ZERO && _react2.default.createElement(_Izenda6.default, {
    searchable: false,
    multi: true,
    options: selectedValues,
    onChange: onChangeSelect,
    value: selectedValues,
    disabled: disabled,
    scalable: false,
    textboxMode: true,
    valueKey: 'id',
    labelField: 'label',
    inputMaxHeight: 50
  });
});

var OperatorValueComboTree = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(OperatorValueComboTree, _Component);

  function OperatorValueComboTree(props) {
    (0, _classCallCheck3.default)(this, OperatorValueComboTree);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OperatorValueComboTree.__proto__ || (0, _getPrototypeOf2.default)(OperatorValueComboTree)).call(this, props));

    _initDefineProp(_this, 'hideTreeView', _descriptor, _this);

    _initDefineProp(_this, 'handleShowTreeView', _descriptor2, _this);

    _initDefineProp(_this, 'handleChangeTreeSelect', _descriptor3, _this);

    _initDefineProp(_this, 'onChangeSelect', _descriptor4, _this);

    _this.setComboTreeDom = function (dom) {
      _this.dom.comboTreeDom = dom;
    };

    _this.observableObject = (0, _mobx.observable)({
      totalNodes: null,
      selectedValues: [],
      selectedItems: (0, _mobx.asReference)([]),
      isOpen: false
    });
    _this.tryGetData = false;
    _this.dom = {};
    _this.inititalTree(props);
    return _this;
  }

  (0, _createClass3.default)(OperatorValueComboTree, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.filterSource !== nextProps.filterSource) {
        this.inititalTree(nextProps);
      }
    }
  }, {
    key: 'inititalTree',
    value: function inititalTree(props) {
      var filterSource = props.filterSource,
          configField = props.configField,
          store = props.store,
          value = props.filterInfo.value;

      var data = (0, _mobx.toJS)(filterSource);

      // TODO: need to delete block of code below when applying lazy load for tree
      if (!this.tryGetData && (0, _fp.isEmpty)(data)) {
        // try to get data for sub report (inherited filter)
        (0, _fp.invokeArgs)('getOperatorValueSource', [configField], store);
        this.tryGetData = true;
      }
      // END
      var includesAll = (0, _fp.includes)(ALL_TEXT, value);
      var counter = -1;

      var forEachNode = function forEachNode(nodes, parentText) {
        (0, _fp.forEach)(function (node) {
          var checked = includesAll || (0, _fp.includes)(node.value, value) || parentText && (0, _fp.includes)(parentText + '\\' + node.value, value);
          counter++;
          node.key = counter;
          (0, _mobx.extendObservable)(node, { checked: checked });
          forEachNode(node.nodes, node.value);
        }, nodes);
      };

      forEachNode(data);

      if (data.length > NUMBER_ZERO) {
        var values = [];
        this.getSelectedValues(data, values);
        this.observableObject.totalNodes = counter;
        this.observableObject.selectedValues = values;
        this.observableObject.selectedItems = data;
      }
    }
  }, {
    key: 'findSelectedItem',


    /**
     * Find selected item on list filter value data
     * @param {Array} data filter value data
     * @param {Object} selectedItem
     */
    value: function findSelectedItem(data, selectedItem) {
      var item = {
        selected: {},
        parents: []
      };

      var findItem = function findItem(data, selectedItem, item, parentNode) {
        var i = void 0;

        for (i = NUMBER_ZERO; i < data.length; i++) {
          if (!(0, _fp.isNil)(item.selected.value)) {
            break;
          }

          var d = data[i];

          if (d.value === selectedItem.value || parentNode && parentNode.value + '\\' + d.value === selectedItem.value) {
            item.selected = d;
          } else {
            if (d.nodes && d.nodes.length) {
              item.parents.push(d);
              findItem(d.nodes, selectedItem, item, d);
              if ((0, _fp.isNil)(item.selected.value)) {
                item.parents = removeFn(item.parents, d);
              }
            }
          }
        }
      };

      var removeFn = function removeFn(parents, d) {
        (0, _fp.remove)(function (item) {
          return item === d;
        }, parents);
      };

      findItem(data, selectedItem, item);

      return item;
    }

    // Update for All checkbox

  }, {
    key: 'updateAll',
    value: function updateAll(data, isChecked) {
      var _this2 = this;

      (0, _fp.forEach)(function (d) {
        d.checked = isChecked;
        if (d.nodes && d.nodes.length) {
          _this2.updateAll(d.nodes, isChecked);
        }
      }, data);

      return data;
    }

    // Uncheck all children

  }, {
    key: 'uncheckChildren',
    value: function uncheckChildren(item) {
      var _this3 = this;

      item.nodes && (0, _fp.forEach)(function (d) {
        d.checked = false;
        if (d.nodes && d.nodes.length) {
          _this3.uncheckChildren(d);
        }
      }, item.nodes);
    }

    // Get selected values which displays in text field.

  }, {
    key: 'getSelectedValues',
    value: function getSelectedValues(data, selectedValues, parent) {
      var _this4 = this;

      var getComputedValue = function getComputedValue(node, key) {
        return (0, _fp.isNil)(parent) || parent[key] === ALL_TEXT || !parent[key] ? node[key] : parent[key] + '\\' + node[key];
      };

      (0, _fp.forEach)(function (node) {
        if (node.checked) {
          var value = getComputedValue(node, 'value');
          var text = getComputedValue(node, 'text');
          selectedValues.push({ text: text, value: value });
        }
        if (node.nodes && node.nodes.length) {
          _this4.getSelectedValues(node.nodes, selectedValues, node);
        }
      }, data);
    }

    // Check all options is selected

  }, {
    key: 'isAllOptionSelected',
    value: function isAllOptionSelected(data) {
      var _this5 = this;

      var result = true;

      (0, _fp.forEach)(function (d) {
        if (!d.checked) {
          result = false;
          return false; // Break the loop
        }

        if (d.nodes && d.nodes.length) {
          result = result && _this5.isAllOptionSelected(d.nodes);
        }
      }, data);

      return result;
    }

    // Check all row

  }, {
    key: 'checkAllSelected',
    value: function checkAllSelected(data, selectedValues) {
      var allNode = (0, _fp.head)(data);
      var allOptionsSelected = this.isAllOptionSelected((0, _fp.get)('nodes', allNode));

      if (allOptionsSelected) {
        var allItem = this.findSelectedItem(data, { value: ALL_TEXT }).selected;

        allItem.checked = true;
        selectedValues = [];
        selectedValues.push({ text: ALL_TEXT, value: ALL_TEXT });
      }

      return selectedValues;
    }

    // Check all unselected

  }, {
    key: 'checkAllUnSelected',
    value: function checkAllUnSelected(data, selectedValues) {
      if ((0, _fp.size)(selectedValues) === NUMBER_ZERO && (0, _fp.size)((0, _fp.filter)(function (v) {
        return v.checked;
      }, data[0].nodes)) === NUMBER_ZERO) {
        var allItem = data[0];

        allItem.checked = false;
        selectedValues = [];
      }

      return selectedValues;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          applyFormater = _props.applyFormater,
          disabled = _props.disabled;

      return _react2.default.createElement(
        'div',
        { className: 'combo-tree' },
        _react2.default.createElement(
          _Izenda10.default,
          { autoHeight: true, autoHeightMax: 85 },
          _react2.default.createElement(
            'div',
            { className: 'combo', ref: this.setComboTreeDom },
            _react2.default.createElement(_Izenda4.default, { type: 'text', className: 'form-control' }),
            _react2.default.createElement(
              'button',
              { className: 'combo-picker', onMouseDown: this.handleShowTreeView, disabled: disabled },
              _react2.default.createElement('i', { className: 'icon-triangle-down' })
            ),
            _react2.default.createElement(SelectedValue, {
              applyFormater: applyFormater,
              observableObject: this.observableObject,
              disabled: disabled,
              onChangeSelect: this.onChangeSelect
            })
          ),
          _react2.default.createElement(TreeDropDown, {
            masterDom: this.dom,
            hideTreeView: this.hideTreeView,
            applyFormater: applyFormater,
            observableObject: this.observableObject,
            disabled: disabled,
            handleChangeTreeSelect: this.handleChangeTreeSelect
          })
        )
      );
    }
  }]);
  return OperatorValueComboTree;
}(_react.Component), _class3.propTypes = {
  filterSource: _propTypes2.default.object.isRequired,
  filterInfo: _propTypes2.default.object.isRequired
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'inititalTree', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'inititalTree'), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, 'hideTreeView', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function () {
      _this6.observableObject.isOpen = false;
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'handleShowTreeView', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function () {
      _this7.observableObject.isOpen = !_this7.observableObject.isOpen;
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'handleChangeTreeSelect', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this8 = this;

    return function (item) {
      var data = _this8.observableObject.selectedItems;
      var selectedValues = [];

      if (item.checked) {
        if (item.value === ALL_TEXT) {
          _this8.updateAll(data, true);
          selectedValues.push({ text: item.value, value: item.value });
        } else {
          var selectedItem = _this8.findSelectedItem(data, item);

          selectedItem.selected.checked = true;
          // Update parent node
          (0, _fp.forEach)(function (parent) {
            var isAllSelected = this.isAllOptionSelected((0, _fp.get)('nodes', parent));
            isAllSelected && (parent.checked = true);
          }.bind(_this8), (0, _fp.reverse)(selectedItem.parents));
          // Update children node
          _this8.updateAll([selectedItem.selected], true);

          _this8.getSelectedValues(data, selectedValues);
        }
      } else {
        if (item.value === ALL_TEXT) {
          _this8.updateAll(data, false);
        } else {
          var _selectedItem = _this8.findSelectedItem(data, item);

          // Update parent node
          (0, _fp.forEach)(function (parent) {
            parent.checked = false;
          }, _selectedItem.parents);

          // Update children node
          _this8.updateAll([_selectedItem.selected], false);
          _this8.getSelectedValues(data, selectedValues);

          // Filter All text.
          selectedValues = (0, _fp.filter)(function (s) {
            return s !== ALL_TEXT;
          }, selectedValues);
        }
      }

      selectedValues = _this8.checkAllSelected(data, selectedValues);
      selectedValues = _this8.checkAllUnSelected(data, selectedValues);

      // get the value with format [parentValue]//[childValue] as string format only. Back-end is accepting this format.
      var onChangeValue = (0, _fp.flatMap)('value', selectedValues);
      _this8.props.onChange(onChangeValue);
      _this8.observableObject.selectedValues = selectedValues;
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'onChangeSelect', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this9 = this;

    return function (items) {
      var newItems = (0, _fp.map)(function (item) {
        return item.id;
      }, items);

      var data = _this9.observableObject.selectedItems;

      if (newItems.length === NUMBER_ZERO) {
        _this9.updateAll(data, false);
      } else {
        var item = (0, _fp.filter)(function (i) {
          return (0, _fp.indexOf)(i.value, newItems) < NUMBER_ZERO;
        }, _this9.observableObject.selectedValues);

        var selectedItem = _this9.findSelectedItem(data, { value: (0, _fp.get)('value', item[0]) });
        selectedItem.selected.checked = false;

        // Uncheck parents
        (0, _fp.forEach)(function (parent) {
          parent.checked = false;
        }, selectedItem.parents);

        // Uncheck children
        _this9.uncheckChildren(selectedItem.selected);

        // Get selected values after uncheck children
        newItems = [];
        _this9.getSelectedValues(data, newItems);
      }
      // get the value with format [parentValue]//[childValue] as string format only. Back-end is accepting this format.
      var onChangeValue = (0, _fp.flatMap)('value', newItems);
      _this9.props.onChange(onChangeValue);
      _this9.observableObject.selectedValues = newItems;
    };
  }
})), _class2)) || _class;

exports.default = OperatorValueComboTree;
module.exports = exports['default'];

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeSelect.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Checkbox Container component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var OverflowText = __webpack_require__(68);
  var TreeView = __webpack_require__(172);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      get = _require.get;

  var TreeItem = observer(React.createClass({
    displayName: 'TreeItem',

    propTypes: {
      item: React.PropTypes.object.isRequired,
      onCheckChange: React.PropTypes.func.isRequired,
      applyFormater: React.PropTypes.func
    },

    handleChange: function handleChange(event) {
      this.props.onCheckChange({
        value: event.target.value,
        checked: event.target.checked
      });
    },

    render: function render() {
      var props = this.props;
      var item = props.item;
      var applyFormater = props.applyFormater;
      var classIcon = classnames('u_noMarginLeft', {
        'icon-triangle-down': !props.isCollapsed,
        'icon-triangle-right': props.isCollapsed
      });

      return React.createElement(
        'span',
        { className: 'overflow-text', value: item.value },
        props.toggleIcon && React.createElement('i', { className: classIcon, onClick: props.toggle }),
        React.createElement(
          'label',
          { className: 'u_noPaddingTop checkbox-inline' },
          React.createElement('input', { type: 'checkbox', checked: item.checked, value: item.value, onChange: this.handleChange }),
          React.createElement(OverflowText, { text: applyFormater(item.text), tooltip: item.text })
        )
      );
    }
  }));

  var TreeSelect = React.createClass({
    displayName: 'TreeSelect',

    propTypes: {
      className: React.PropTypes.string,
      data: React.PropTypes.array,
      onChange: React.PropTypes.func
    },
    renderNode: function renderNode(node, toggleIcon, toggle, isCollapsed) {
      var props = this.props;
      var onCheckChange = props.onChange;
      var applyFormater = props.applyFormater;

      return React.createElement(TreeItem, {
        onCheckChange: onCheckChange,
        applyFormater: applyFormater,
        item: node,
        toggleIcon: toggleIcon,
        toggle: toggle,
        isCollapsed: isCollapsed
      });
    },

    render: function render() {
      var props = this.props;
      var treeData = props.data || [];

      return React.createElement(
        'div',
        { className: 'TreeSelect u_borderAll u_borderRadius u-bgWhite ' + (this.props.className || '') },
        React.createElement(TreeView, {
          className: 'u_noPaddingRight',
          treeViewItemClassName: 'u_noPaddingTop',
          nodes: treeData,
          renderNode: this.renderNode,
          getKey: get('key'),
          getChildNodes: get('nodes'),
          collapsed: false
        })
      );
    }
  });

  module.exports = TreeSelect;
}();

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueSelectBox.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueSelexBox component
 */
!function () {
  var stringUtils = __webpack_require__(55);
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(89);
  var Validator = __webpack_require__(23);
  var Select = Validator()(__webpack_require__(47));
  var Input = __webpack_require__(17);
  var ALL = constants.DEFAUFT_VALUE.ALL;
  var BLANK = constants.DEFAUFT_VALUE.BLANK;
  var NULL = constants.DEFAUFT_VALUE.NULL;

  var _require = __webpack_require__(1),
      identity = _require.identity,
      map = _require.map,
      concat = _require.concat,
      isNil = _require.isNil,
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      isArray = _require.isArray,
      placeholder = _require.placeholder;

  var OPTION_ALL = {
    value: ALL,
    label: ALL
  };
  var OPTION_BLANK = {
    value: BLANK,
    label: BLANK
  };

  var OPTION_NULL = {
    value: NULL,
    label: NULL
  };

  var OperatorValueSelectBox = React.createClass({
    displayName: 'OperatorValueSelectBox',

    /**
     * Define property type
     */
    propTypes: {
      filterSource: React.PropTypes.object.isRequired,
      filterInfo: React.PropTypes.object.isRequired,
      viewMode: React.PropTypes.bool,
      applyFormater: React.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
      return {
        applyFormater: identity
      };
    },

    /**
     * Define initial state
     */
    getInitialState: function getInitialState() {
      return {
        value: null,
        validInput: true,
        options: [],
        errorMessage: ''
      };
    },

    /**
     * Populate options.
     */
    populateOptions: function populateOptions(filterSource) {
      // Convert obser array to array
      var filterSourceArray = filterSource.length && filterSource.slice();

      var defaultOption = [OPTION_ALL, OPTION_BLANK, OPTION_NULL];

      var applyFormater = this.props.applyFormater;

      var dataOptions = map(function (item) {
        return {
          value: item,
          label: applyFormater(item)
        };
      }, filterSourceArray);

      this.setState({
        options: concat(defaultOption, dataOptions)
      });
    },

    componentWillMount: function componentWillMount() {
      this.populateOptions(this.props.filterSource);
    },

    /**
     * Handle when receive react property
     * @param  {object} nextProps react property
     */
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.populateOptions(nextProps.filterSource);

      // Get error message for validate format base on data type
      var dataType = this.props.operatorGroup.fieldDetails.dataType;
      var errorMessage = this.getDataByKey(constants.ERROR_MESSAGE_BY_DATA_TYPE, dataType);

      this.setState({
        errorMessage: errorMessage
      });
    },

    /**
     * get error message by key
     * @param  {object} object error message collection
     * @param  {string} key    key
     * @return {string}
     */
    getDataByKey: function getDataByKey(object, key) {
      return placeholder(object).get(key);
    },

    /**
     * Handle switch component to select multiple or signle
     * @param  {object} e React event
     */
    switchToSingleOrMultiple: function switchToSingleOrMultiple(value) {
      var validation = this.props.validation;

      validation.reset();

      var isMultipleMode = this.checkMultipleMode(this.props.operatorGroup.fieldDetails.operatorSetting);
      var isMultipleCheck = this.checkMultipleMode(value);
      var sourceValue = this.props.filterInfo.value;
      var values = this.getValueFromSource(sourceValue.sort()) || [];

      if (isMultipleMode === isMultipleCheck) {
        return;
      }

      var result = isMultipleCheck ? [values.value] : values.length > 0 ? [values[0].value] : [];

      this.props.onChange && this.props.onChange(result);
      this.props.operatorGroup.fieldDetails.setOperatorSetting(value);
    },

    /**
     * Handle switch component to signle
     */
    swithToSingle: function swithToSingle() {
      this.switchToSingleOrMultiple(constants.SELECT_SETTINGS.SINGLE);
    },

    /**
     * Handle switch component to multiple
     */
    switchToMultiple: function switchToMultiple() {
      this.switchToSingleOrMultiple(constants.SELECT_SETTINGS.MULTIPLE);
    },

    /**
     * Handle when change value of selectbox
     * @param  {object} selectValues list select value
     */
    onChangeSelect: function onChangeSelect(selectValues) {
      // when remove value
      if (isNil(selectValues) || selectValues && selectValues.length === 0) {
        this.props.onChange && this.props.onChange([]);
        return;
      }

      var isMultipleMode = this.checkMultipleMode(this.props.operatorGroup.fieldDetails.operatorSetting);
      var result = void 0;

      if (isMultipleMode) {
        result = selectValues[selectValues.length - 1].value === ALL ? [ALL] : map(function (item) {
          return item.value;
        }, filter(function (item) {
          return item.value !== ALL && !isEmpty(item.value);
        }, selectValues));
      } else {
        result = map(function (item) {
          return item.value;
        }, selectValues);
      }

      this.props.onChange && this.props.onChange(result);
    },

    /**
     * Handle when add new value of selectbox
     * @param  {object} newValue new value of select box
     * @return {boolean}         result of add new value
     */
    onAddNewSelect: function onAddNewSelect(newValue) {
      if (this.props.isSelect) {
        return false;
      }

      var dataType = this.props.operatorGroup.fieldDetails.dataType;

      if (!this.validationValue(newValue.value, dataType)) {
        var valManager = this.props.validation;

        valManager.updateErrors([{ key: constants.CONSTRAINTS_NAME + this.props.index, messages: this.state.errorMessage }]);
        return false;
      }

      return true;
    },

    /**
     * Validation when add new value for selectbox
     * @param  {object} value    validate value
     * @param  {string} dataType data type of value
     * @return {boolean}         result of validate
     */
    validationValue: function validationValue(value, dataType) {
      switch (dataType) {
        case constants.DATA_TYPE.TEXT:
          return true;
        case constants.DATA_TYPE.MONEY:
        case constants.DATA_TYPE.NUMBER:
          return String.isPatternFormat(value, constants.REGEX.NUMBER);
        case constants.DATA_TYPE.DATE:
          return String.isPatternFormat(value, constants.REGEX.DATETIMEFORMAT);
        default:
          return true;
      }
    },

    /**
     * Get value from source for selectbox
     * @param  {array} filter value
     * @return         array or object base on component multiple or single settings
     */
    getValueFromSource: function getValueFromSource(source) {
      var applyFormater = this.props.applyFormater;

      var result;
      var isMultipleMode = this.checkMultipleMode(this.props.operatorGroup.fieldDetails.operatorSetting);

      if (isMultipleMode) {
        result = isArray(source) ? map(function (item) {
          return { value: item, label: applyFormater(item) };
        }, source) : [];
        // Remove empty value
        if (result.length === 1 && isEmpty(result[0].value)) {
          result = [];
        }
      } else {
        result = isArray(source) && !isEmpty(source[0]) ? { value: source[0], label: applyFormater(source[0]) } : null;
      }
      return result;
    },

    /*
     */
    checkMultipleMode: function checkMultipleMode(value) {
      return value === constants.SELECT_SETTINGS.MULTIPLE;
    },

    renderSelectBox: function renderSelectBox() {
      var fieldDetails = this.props.operatorGroup.fieldDetails;
      var isMultipleMode = this.checkMultipleMode(fieldDetails.operatorSetting);

      return this.props.viewMode ? null : React.createElement(
        'div',
        null,
        React.createElement(Input, {
          type: 'radio',
          checked: !isMultipleMode,
          onChange: this.swithToSingle,
          value: constants.SELECT_SETTINGS.SINGLE
        }),
        constants.SELECT_MODE.SINGLE,
        ' \xA0',
        React.createElement(Input, {
          type: 'radio',
          checked: isMultipleMode,
          onChange: this.switchToMultiple,
          value: constants.SELECT_SETTINGS.MULTIPLE
        }),
        ' ',
        constants.SELECT_MODE.MULTIPLE
      );
    },

    /**
     * Render component
     */
    render: function render() {
      var props = this.props;
      var sourceValue = props.filterInfo.value;
      var isMultipleMode = this.checkMultipleMode(props.operatorGroup.fieldDetails.operatorSetting);
      var values = this.getValueFromSource(sourceValue);

      var constraints = constants.CONSTRAINTS;

      return React.createElement(
        'div',
        { className: 'manual-entry' },
        this.renderSelectBox(),
        React.createElement(
          'div',
          { className: 'select-box-container' },
          React.createElement(Select, {
            multi: isMultipleMode,
            options: this.state.options,
            labelKey: props.labelField,
            valueKey: props.valueField,
            scalable: false,
            value: values,
            onChange: this.onChangeSelect,
            onAddNew: this.onAddNewSelect,
            field: constants.CONSTRAINTS_NAME + props.index,
            validations: constraints,
            disabled: props.disabled,
            inputMaxHeight: 85
          })
        )
      );
    }
  });

  module.exports = connect()(OperatorValueSelectBox);
}();

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueSelectBoxLazyLoading.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueSelectBox component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(89);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

var _Izenda9 = __webpack_require__(47);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = (0, _Izenda6.default)()(_Izenda10.default);
var _constants$DEFAUFT_VA = _Izenda4.default.DEFAUFT_VALUE,
    ALL = _constants$DEFAUFT_VA.ALL,
    NULL = _constants$DEFAUFT_VA.NULL,
    BLANK = _constants$DEFAUFT_VA.BLANK;

var EMPTY = '';

var OperatorValueSelectBox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(OperatorValueSelectBox, _Component);

  function OperatorValueSelectBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OperatorValueSelectBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OperatorValueSelectBox.__proto__ || (0, _getPrototypeOf2.default)(OperatorValueSelectBox)).call.apply(_ref, [this].concat(args))), _this), _this.getDataByKey = function (object, key) {
      return (0, _fp.placeholder)(object).get(key);
    }, _this.switchToSingleOrMultiple = function (value) {
      var props = _this.props;
      var validation = props.validation,
          operatorGroup = props.operatorGroup,
          operatorSetting = props.operatorGroup.fieldDetails.operatorSetting,
          sourceValue = props.filterInfo.value;


      validation.reset();

      var isMultipleMode = _this.checkMultipleMode(operatorSetting);
      var isMultipleCheck = _this.checkMultipleMode(value);
      var values = _this.getValueFromSource(sourceValue.sort()) || [];

      if (isMultipleMode === isMultipleCheck) {
        return;
      }

      var result = isMultipleCheck ? [values.value] : [];

      props.onChange && props.onChange(result);
      operatorGroup.fieldDetails.setOperatorSetting(value);
    }, _this.removeOption = function (keyValue) {
      var data = (0, _fp.get)('configField.operatorSourceDisplay.data', _this.props);
      var firstItem = (0, _fp.find)({ key: keyValue }, data);
      data.remove(firstItem);
    }, _this.switchToSingle = function () {
      _this.removeOption(ALL);
      _this.switchToSingleOrMultiple(_Izenda4.default.SELECT_SETTINGS.SINGLE);
    }, _this.switchToMultiple = function () {
      var data = (0, _fp.get)('configField.operatorSourceDisplay.data', _this.props);
      if (!(0, _fp.isEmpty)(data) && !(0, _fp.isEmpty)((0, _fp.difference)((0, _fp.flatMap)('key', data), [NULL, BLANK, EMPTY]))) {
        var startIndex = 0;
        var deleteCount = 0;
        data.splice(startIndex, deleteCount, {
          key: ALL,
          value: ALL,
          label: ALL
        });
      }
      _this.switchToSingleOrMultiple(_Izenda4.default.SELECT_SETTINGS.MULTIPLE);
    }, _this.onChangeSelect = function (selectValues) {
      var props = _this.props;
      // when remove value
      if ((0, _fp.isEmpty)(selectValues)) {
        props.onChange && props.onChange([]);
        return;
      }
      var result = [];
      var operatorSetting = props.operatorGroup.fieldDetails.operatorSetting;

      var isMultipleMode = _this.checkMultipleMode(operatorSetting);

      if (isMultipleMode) {
        result = (0, _fp.last)(selectValues).value === ALL ? [ALL] : (0, _fp.flow)((0, _fp.uniqBy)('value'), (0, _fp.filter)(function (item) {
          return item.value !== ALL && !(0, _fp.isEmpty)(item.value);
        }), (0, _fp.map)(function (item) {
          return item.value;
        }))(selectValues);
      } else {
        result = (0, _fp.isNil)(selectValues) ? [] : [selectValues.value];
      }

      if ((0, _fp.isArray)(selectValues)) {
        if ((0, _fp.get)('isNew', (0, _fp.last)(selectValues))) {
          _this.resetSearchData();
        }
      } else if ((0, _fp.isObject)(selectValues) && selectValues.isNew) {
        _this.resetSearchData();
      }

      props.onChange && props.onChange(result);
    }, _this.onAddNewSelect = function (newValue) {
      var _this$props = _this.props,
          isSelect = _this$props.isSelect,
          dataType = _this$props.operatorGroup.fieldDetails.dataType,
          valManager = _this$props.validation,
          index = _this$props.index;

      if (isSelect) {
        return false;
      }

      var errorMessage = _this.getDataByKey(_Izenda4.default.ERROR_MESSAGE_BY_DATA_TYPE, dataType);
      if (!_this.validationValue(newValue.value, dataType)) {
        valManager.updateErrors([{ key: _Izenda4.default.CONSTRAINTS_NAME + index, messages: errorMessage }]);
        return false;
      }

      return true;
    }, _this.getValueFromSource = function (source) {
      var result = void 0;
      var _this$props2 = _this.props,
          operatorSetting = _this$props2.operatorGroup.fieldDetails.operatorSetting,
          applyFormater = _this$props2.applyFormater;

      var isMultipleMode = _this.checkMultipleMode(operatorSetting);

      if (isMultipleMode) {
        var oneItemArraySize = 1;
        result = (0, _fp.isArray)(source) ? (0, _fp.map)(function (item) {
          return {
            value: item,
            label: applyFormater(item)
          };
        }, source) : [];
        // Remove empty value
        if (result.length === oneItemArraySize && (0, _fp.isEmpty)((0, _fp.head)(result).value)) {
          result = [];
        }
      } else {
        var firstSourceItem = (0, _fp.head)(source);
        result = (0, _fp.isArray)(source) && !(0, _fp.isEmpty)(firstSourceItem) ? { value: firstSourceItem, label: applyFormater(firstSourceItem) } : null;
      }
      return result;
    }, _this.checkMultipleMode = function (value) {
      return value === _Izenda4.default.SELECT_SETTINGS.MULTIPLE;
    }, _this.renderSelectBox = function () {
      var _this$props3 = _this.props,
          _this$props3$operator = _this$props3.operatorGroup.fieldDetails,
          operatorSetting = _this$props3$operator.operatorSetting,
          dataType = _this$props3$operator.dataType,
          isParameter = _this$props3$operator.isParameter,
          viewMode = _this$props3.viewMode;

      var isMultipleMode = _this.checkMultipleMode(operatorSetting);

      return viewMode ? null : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock' },
          _react2.default.createElement(_Izenda8.default, {
            type: 'radio',
            checked: !isMultipleMode,
            onChange: _this.switchToSingle,
            value: _Izenda4.default.SELECT_SETTINGS.SINGLE
          }),
          _Izenda4.default.SELECT_MODE.SINGLE,
          ' \xA0'
        ),
        (dataType === 'Text' || !isParameter) && _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock' },
          _react2.default.createElement(_Izenda8.default, {
            type: 'radio',
            checked: isMultipleMode,
            onChange: _this.switchToMultiple,
            value: _Izenda4.default.SELECT_SETTINGS.MULTIPLE
          }),
          _Izenda4.default.SELECT_MODE.MULTIPLE,
          ' \xA0'
        )
      );
    }, _this.checkReturnOptions = function () {
      var data = (0, _fp.get)('configField.operatorSourceDisplay.data', _this.props);
      var firstItem = (0, _fp.find)({ key: ALL }, data);

      if (firstItem) {
        var fieldDetails = (0, _fp.get)('operatorGroup.fieldDetails', _this.props);
        if ((0, _fp.isNil)(fieldDetails.operatorSetting)) {
          fieldDetails.setOperatorSetting(_Izenda4.default.SELECT_SETTINGS.SINGLE);
        }
        if (fieldDetails.isParameter && !(0, _fp.isEmpty)(data) && (0, _fp.isEmpty)((0, _fp.difference)((0, _fp.flatMap)('key', data), [ALL, NULL, BLANK, EMPTY]))) {
          data.remove(firstItem);
        }
      }

      return data;
    }, _this.getData = function (pageInfo, isSearching) {
      var _this$props4 = _this.props,
          store = _this$props4.store,
          configField = _this$props4.configField;

      return store.getData(pageInfo, configField, _this.searchKey, isSearching).then(_this.checkReturnOptions);
    }, _this.resetSearchData = function () {
      if (_this.searchKey) {
        _this.searchKey = null;
        _this.props.configField.resetOperatorSourceDisplay();
      }
    }, _this.handleSearchData = function (key, pageInfo) {
      _this.searchKey = key;
      return _this.getData(pageInfo, true);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OperatorValueSelectBox, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.configField.resetOperatorSourceDisplay();
    }

    /**
     * get error message by key
     * @param  {Object} object error message collection
     * @param  {string} key    key
     * @return {string}
     */


    /**
     * Handle switch component to select multiple or signle
     * @param  {Object} e React event
     */


    /**
     * Handle switch component to single
     */


    /**
     * Handle switch component to multiple
     */


    /**
     * Handle when change value of selectbox
     * @param  {Array<Object>} selectValues list select value
     */


    /**
     * Handle when add new value of selectbox
     * @param  {Object} newValue new value of select box
     */

  }, {
    key: 'validationValue',


    /**
     * Validation when add new value for selectbox
     * @param  {Object} value    validate value
     * @param  {string} dataType data type of value
     * @return {boolean}         result of validate
     */
    value: function validationValue(value, dataType) {
      switch (dataType) {
        case _Izenda4.default.DATA_TYPE.TEXT:
          return true;
        case _Izenda4.default.DATA_TYPE.TIME:
          return String.isPatternFormat(value, _Izenda4.default.REGEX.TIME);
        case _Izenda4.default.DATA_TYPE.MONEY:
        case _Izenda4.default.DATA_TYPE.NUMBER:
          return String.isPatternFormat(value, _Izenda4.default.REGEX.NUMBER);
        case _Izenda4.default.DATA_TYPE.DATE:
          return String.isPatternFormat(value, _Izenda4.default.REGEX.DATETIMEFORMAT);
        default:
          return true;
      }
    }

    /**
     * Get value from source for selectbox
     * @param  {Obect} source value
     * @return         array or Object base on component multiple or single settings
     */


    /*
     */

    /**
     * When API returns data, check if there's values; otherwise, remove option [ALL]
     */

  }, {
    key: 'render',


    /**
     * Render component
     */
    value: function render() {
      var _props = this.props,
          sourceValue = _props.filterInfo.value,
          operatorSetting = _props.operatorGroup.fieldDetails.operatorSetting,
          _props$configField$op = _props.configField.operatorSourceDisplay,
          data = _props$configField$op.data,
          isLastPage = _props$configField$op.isLastPage,
          labelField = _props.labelField,
          valueField = _props.valueField,
          isSelect = _props.isSelect,
          index = _props.index,
          disabled = _props.disabled;

      var isMultipleMode = this.checkMultipleMode(operatorSetting);
      var values = this.getValueFromSource(sourceValue);
      var constraints = _Izenda4.default.CONSTRAINTS;
      // HACK: Define data length to mobx 2.4.x trigger rendered
      // NOSONAR
      var dataLength = data.length; // eslint-disable-line no-unused-vars

      return _react2.default.createElement(
        'div',
        { className: 'manual-entry' },
        this.renderSelectBox(),
        _react2.default.createElement(
          'div',
          { className: 'select-box-container' },
          _react2.default.createElement(Select, {
            multi: isMultipleMode,
            options: data,
            labelKey: labelField,
            valueKey: valueField,
            scalable: false,
            value: values,
            onChange: this.onChangeSelect,
            onAddNew: isSelect ? _fp.identity : this.onAddNewSelect,
            field: _Izenda4.default.CONSTRAINTS_NAME + index,
            validations: constraints,
            disabled: disabled,
            inputMaxHeight: 85,
            onCloseMenu: this.resetSearchData,
            getData: this.getData,
            onSearchLazy: this.handleSearchData,
            isLastPage: isLastPage,
            isLazyLoading: true
          })
        )
      );
    }
  }]);
  return OperatorValueSelectBox;
}(_react.Component), _class.propTypes = {
  filterSource: _propTypes2.default.object.isRequired,
  filterInfo: _propTypes2.default.object.isRequired,
  viewMode: _propTypes2.default.bool,
  applyFormater: _propTypes2.default.func
}, _class.defaultProps = {
  applyFormater: _fp.identity
}, _temp2);
exports.default = (0, _Izenda2.default)()(OperatorValueSelectBox);
module.exports = exports['default'];

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueInputWithMode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(89);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLANK = _Izenda9.DEFAUFT_VALUE.BLANK,
    NULL = _Izenda9.DEFAUFT_VALUE.NULL;

var SelectValidator = (0, _Izenda4.default)()(_Izenda8.default);

var OperatorValueInputWithMode = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(OperatorValueInputWithMode, _Component);

  function OperatorValueInputWithMode() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OperatorValueInputWithMode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OperatorValueInputWithMode.__proto__ || (0, _getPrototypeOf2.default)(OperatorValueInputWithMode)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      errorMessage: ''
    }, _this.switchToSingleOrMultiple = function (value) {
      var _this$props = _this.props,
          validation = _this$props.validation,
          onChange = _this$props.onChange,
          filterInfo = _this$props.filterInfo,
          fieldDetails = _this$props.operatorGroup.fieldDetails;

      validation.reset();

      if (value === fieldDetails.operatorSetting) {
        return;
      }

      var values = _this.getValueFromSource(filterInfo.value.sort()) || [];
      var result = value === _Izenda9.SELECT_SETTINGS.MULTIPLE ? [values.value] : [];
      onChange && onChange(result);
      fieldDetails.setOperatorSetting(value);
    }, _this.swithToSingle = function () {
      _this.switchToSingleOrMultiple(_Izenda9.SELECT_SETTINGS.SINGLE);
    }, _this.switchToMultiple = function () {
      _this.switchToSingleOrMultiple(_Izenda9.SELECT_SETTINGS.MULTIPLE);
    }, _this.onChangeInput = function (selectValues) {
      var onChange = _this.props.onChange;

      var isMultipleMode = _this.checkMultipleMode();
      var result = [];

      // when remove value
      if (!(0, _fp.isNil)(selectValues)) {
        if (isMultipleMode) {
          result = (0, _fp.map)(function (item) {
            return item.value;
          }, selectValues);
        } else {
          result = [selectValues.value];
        }
      }

      onChange && onChange(result);
    }, _this.onAddNewInput = function (newValue) {
      var _this$props2 = _this.props,
          validation = _this$props2.validation,
          operatorGroup = _this$props2.operatorGroup;

      var dataType = operatorGroup.fieldDetails.dataType;
      var errorMessage = (0, _fp.get)(dataType, _Izenda9.ERROR_MESSAGE_BY_DATA_TYPE);

      if (!_this.validationValue(newValue.value, dataType)) {
        validation.updateErrors([{ key: _Izenda9.CONSTRAINTS_NAME, messages: errorMessage }]);
        return false;
      }

      return true;
    }, _this.getValueFromSource = function (source) {
      var applyFormater = _this.props.applyFormater;

      var isMultipleMode = _this.checkMultipleMode();
      var result = void 0;

      if (isMultipleMode) {
        result = (0, _fp.map)(function (item) {
          return { value: item, label: applyFormater(item) };
        }, source);
        // Remove empty value
        if (result.length === 1 && (0, _fp.isEmpty)(result[0].value)) {
          result = [];
        }
      } else {
        result = (0, _fp.isEmpty)(source) ? null : { value: source[0], label: applyFormater(source[0]) };
      }

      return result;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Handle switch component to select multiple or signle
   * @param  {object} e React event
   */


  /**
   * Handle switch component to signle
   */


  /**
  * Handle switch component to multiple
  */


  /**
   * Handle when change value of selectbox
   * @param  {object} selectValues list select value
   */


  /**
   * Handle when add new value of selectbox
   * @param  {object} newValue new value of select box
   * @return {boolean}         result of add new value
   */


  (0, _createClass3.default)(OperatorValueInputWithMode, [{
    key: 'validationValue',


    /**
     * Validation when add new value for selectbox
     * @param  {object} value    validate value
     * @param  {string} dataType data type of value
     * @return {boolean}         result of validate
     */
    value: function validationValue(value, dataType) {
      switch (dataType) {
        case _Izenda9.DATA_TYPE.TEXT:
          return true;
        case _Izenda9.DATA_TYPE.TIME:
          return String.isPatternFormat(value, _Izenda9.REGEX.TIME);
        case _Izenda9.DATA_TYPE.MONEY:
        case _Izenda9.DATA_TYPE.NUMBER:
          return String.isPatternFormat(value, _Izenda9.REGEX.NUMBER) || value.toUpperCase() === NULL || value.toUpperCase() === BLANK;
        case _Izenda9.DATA_TYPE.DATE:
          return String.isPatternFormat(value, _Izenda9.REGEX.DATETIMEFORMAT) || value.toUpperCase() === NULL || value.toUpperCase() === BLANK;
        default:
          return true;
      }
    }

    /**
     * Get value from source for selectbox
     * @param  {array} filter value
     * @return         array or object base on component multiple or single settings
     */

  }, {
    key: 'checkMultipleMode',
    value: function checkMultipleMode() {
      return this.props.operatorGroup.fieldDetails.operatorSetting === _Izenda9.SELECT_SETTINGS.MULTIPLE;
    }
  }, {
    key: 'renderSelectBox',
    value: function renderSelectBox() {
      var isMultipleMode = this.checkMultipleMode();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Izenda6.default, {
          type: 'radio',
          checked: !isMultipleMode,
          onChange: this.swithToSingle,
          value: _Izenda9.SELECT_SETTINGS.SINGLE
        }),
        _Izenda9.SELECT_MODE.SINGLE,
        ' \xA0',
        _react2.default.createElement(_Izenda6.default, {
          type: 'radio',
          checked: isMultipleMode,
          onChange: this.switchToMultiple,
          value: _Izenda9.SELECT_SETTINGS.MULTIPLE
        }),
        ' ',
        _Izenda9.SELECT_MODE.MULTIPLE
      );
    }

    /**
     * Render component
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewMode = _props.viewMode,
          filterInfo = _props.filterInfo,
          labelField = _props.labelField,
          valueField = _props.valueField,
          disabled = _props.disabled;

      var isMultipleMode = this.checkMultipleMode();
      var values = this.getValueFromSource(filterInfo.value);

      return _react2.default.createElement(
        'div',
        { className: 'manual-entry' },
        !viewMode && this.renderSelectBox(),
        _react2.default.createElement(
          'div',
          { className: 'select-box-container' },
          _react2.default.createElement(SelectValidator, {
            multi: isMultipleMode,
            options: [],
            labelKey: labelField,
            valueKey: valueField,
            scalable: false,
            value: values,
            onChange: this.onChangeInput,
            onAddNew: this.onAddNewInput,
            field: _Izenda9.CONSTRAINTS_NAME,
            validations: _Izenda9.CONSTRAINTS,
            disabled: disabled,
            textboxMode: true,
            noResultsText: null,
            inputMaxHeight: 0
          })
        )
      );
    }
  }]);
  return OperatorValueInputWithMode;
}(_react.Component), _class2.propTypes = {
  filterInfo: _react2.default.PropTypes.object.isRequired,
  viewMode: _react2.default.PropTypes.bool,
  applyFormater: _react2.default.PropTypes.func
}, _class2.defaultProps = { applyFormater: _fp.identity }, _temp2)) || _class);
exports.default = OperatorValueInputWithMode;
module.exports = exports['default'];

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(23);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(277);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(133);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2496);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(47);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorSelect = (0, _Izenda2.default)()(_Izenda12.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.Recipient.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda6.default)(_Izenda10.default)(function Recipient(props) {
  var users = props.data.getRecipients();
  var localization = props.localization;


  return _react2.default.createElement(
    'div',
    { className: 'form-group' },
    _react2.default.createElement(
      'div',
      { className: 'col-md-3 control-label' },
      localization.getText('SUBSCRIPTION_LABEL_RECIPIENTS')
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-md-9' },
      _react2.default.createElement(
        'div',
        { className: 'izenda-Recipient-Container' },
        _react2.default.createElement(ValidatorSelect, {
          textboxMode: true,
          multi: true,
          searchable: true,
          clearable: false,
          options: [],
          valueKey: 'emailAddress',
          labelKey: 'emailAddress',
          value: users,
          validations: _Izenda4.default.CONTRAINTS.RECIPIENTS,
          field: _Izenda8.default.FIELD_KEY.Recipients,
          onChange: props.addRecipients,
          onAddNew: props.onAddNewSelect
        }),
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', {
            onClick: props.openPopupAddUserPopup,
            className: 'icon-plus',
            title: localization.getText('USER_LABEL_SELECT_USER')
          })
        )
      )
    )
  );
});
module.exports = exports['default'];

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(590);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(92);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.RecipientAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _recompose.withHandlers)({
  openPopupAddUserPopup: openPopupAddUserPopup,
  addRecipients: (0, _fp.curry)(addRecipients),
  onAddNewSelect: onAddNewSelect
});

/**
 * Open add user popup
 * @param  {Object} props props
 */

function openPopupAddUserPopup(props) {
  return function () {
    props.openPopup(_Izenda2.default, {
      onChange: props.data.addMoreRecipients.bind(props.data),
      userModeType: _Izenda4.default.USER_ACCESS_MODE.SCHEDULE,
      validateEmails: true
    });
  };
}

/**
 * Validate new email
 * @param  {Object} props props
 */
function onAddNewSelect(props) {
  return function () {
    var authorization = props.authorization;

    var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
    return authorization.checkPrivileges([permissionKeys.SchedulingSchedulingScopeExternalUsers]);
  };
}

/**
 * Add new email
 * @param  {Object} add recipients
 * @param  {Array<any>} userAccountList user
 */
function addRecipients(props, userAccountList) {
  props.data.addRecipients(userAccountList);
}
module.exports = exports['default'];

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemVariablesAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var PropTypes = __webpack_require__(0).PropTypes;
  var withHandlers = __webpack_require__(9).withHandlers;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var lifecycle = __webpack_require__(9).lifecycle;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var systemVariablesAction = compose(setPropTypes({
    store: PropTypes.object.isRequired,
    onSelect: PropTypes.func
  }), lifecycle({
    componentDidMount: function componentDidMount() {
      var props = this.props;
      var loader = props.loader;

      props.loader.startLoading();
      props.store.fetchSystemVariables().then(loader.endLoading.bind(loader));
    },
    componentWillUnmount: function componentWillUnmount() {
      this.props.store.systemVariables.resetPageModel();
    }
  }), withHandlers({
    onSortChange: curry(onSortChange),
    onSelect: curry(onSelect)
  }));

  /**
   * Handle sort change.
   * @param  {Object} props
   * @param  {String} columnKey
   * @param  {String} sortDir
   */
  function onSortChange(props, columnKey, sortDir) {
    props.store.sortSystemVariables(columnKey, sortDir);
  }

  /**
   * Handle on select.
   * @param  {Object} props
   * @param  {Object} detail
   */
  function onSelect(props, detail) {
    props.onSelect && props.onSelect(detail.name);
  }

  module.exports = systemVariablesAction;
}();

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.InstanceName.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  "use strict";

  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;
  var Validator = __webpack_require__(23);
  var Input = __webpack_require__(17);
  var ValidatableInput = Validator()(Input);
  var ReportSubscriptionConstants = __webpack_require__(133);
  var localizer = __webpack_require__(12);

  var InstanceName = function InstanceName(props) {
    /**
     * Get instance name
     */
    function getInstanceName() {
      return props.data ? props.data.name : '';
    };

    /**
     * onchange instance name
     * @param {object} input
     */
    function onChangeInstanceName(input) {
      props.data.updateProperty('name', input.target.value);
    };

    return React.createElement(
      'div',
      { className: 'form-group Izenda-Subscription-InstanceName' },
      React.createElement(
        'div',
        { className: 'col-md-3 control-label' },
        localizer.getText('SUBSCRIPTION_LABEL_INSTANCE_NAME')
      ),
      React.createElement(
        'div',
        { className: 'col-md-9' },
        React.createElement(ValidatableInput, { className: 'form-control',
          onChange: onChangeInstanceName,
          value: getInstanceName(),
          validations: ReportSubscriptionConstants.CONTRAINTS.INSTANCE_NAME,
          field: 'name' })
      )
    );
  };

  InstanceName.propTypes = {
    data: React.PropTypes.object
  };

  module.exports = observer(InstanceName);
}();

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Dashboard.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Dashboard
 */

!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var CategoryDetail = __webpack_require__(161);
  var DashboardDetail = __webpack_require__(2500);
  var DashboardConstants = __webpack_require__(73);
  var DashboardDesignerMode = __webpack_require__(2502);
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      remove = _require.remove,
      isEmpty = _require.isEmpty,
      isEqual = _require.isEqual,
      find = _require.find;

  var DashboardList = __webpack_require__(1169)(DashboardConstants, 'dashboards');

  function Dashboard(data) {
    this.isLeftMenuLastPage = false;

    var props = {
      leftMenuCategories: [],
      leftMenuCategoryTree: [],
      categoryTree: [], // It's a array of the CategoryDetail item
      dashboardDetail: new DashboardDetail(), // For new/edit dashboard
      items: new DashboardList(),
      dashboardDesignerMode: new DashboardDesignerMode(), // Control button status
      autoDurationMinute: 0,
      autoDurationSecond: 0,
      localGlobalCategories: []
    };

    m.extendObservable(trackable(this), props);
    data && this.populateData(data);
  }

  /**
   * Clone dashboard object
   */
  Dashboard.prototype.clone = m.action('clone dashboard', function (saveAs) {
    var dashboard = new Dashboard();
    dashboard.dashboardDetail = new DashboardDetail(this.dashboardDetail);

    /**
     * if dashboard is global, it is being opened in a tenant or not a system admin
     * when save as, reset dashboard to local, reset its cat/subcategory.
     */
    if (dashboard.dashboardDetail.dashboard.isGlobal && (!uiState.currentUser.systemAdmin || !isNil(uiState.tenantId))) {
      dashboard.dashboardDetail.dashboard.isGlobal = false;
      dashboard.dashboardDetail.dashboard.categoryId = null;
      dashboard.dashboardDetail.dashboard.categoryName = null;
      dashboard.dashboardDetail.dashboard.subCategoryId = null;
      dashboard.dashboardDetail.dashboard.subCategoryName = null;
    }
    dashboard.dashboardDetail.saveAs = saveAs;
    return dashboard;
  });

  /**
   * Populate data
   * @param  {Object} dashboard object
   */
  Dashboard.prototype.populateData = m.action('load dashboard', function (data) {
    m.transaction(function () {
      this.categoryTree = data.categoryTree;
      this.dashboardDetail = data.dashboardDetail;
      this.dashboardList = data.dashboardList;
      this.dashboardDesignerMode = data.dashboardDesignerMode;
      this.autoDurationMinute = data.autoDurationMinute;
      this.autoDurationSecond = data.autoDurationSecond;
    }.bind(this));
  });

  /**
   * create new Dashboard
   * @method createNewDashboard
   */
  Dashboard.prototype.createNewDashboard = m.action('new dashboard', function () {
    this.dashboardDetail = new DashboardDetail();
  });

  /**
   * Get category tree for dashboard
   * @param {object} category list
   */
  Dashboard.prototype.readDashboardCategoryTree = m.action('load category tree', function (categoryList) {
    categoryList = categoryList || [];

    this.categoryTree = categoryList.map(function (item) {
      if (!isEmpty(item.subCategories)) {
        item.subCategories = item.subCategories.map(function (subItem) {
          return new CategoryDetail(subItem);
        });
      }
      return new CategoryDetail(item);
    });

    var allDashboardItem = new CategoryDetail();
    allDashboardItem.populateData(DashboardConstants.ALL_CATEGORY_TYPES.ALL_DASHBOARDS);
    this.categoryTree.splice(0, 0, allDashboardItem);
  });

  /**
   * Delete a ReportCategory out of reportCategoryTree
   * @param {object} reportCategory
   * @returns {promise}
   */
  Dashboard.prototype.removeCategory = m.action('remove category', function (category) {
    if (!category.isSubCategory) {
      this.categoryTree = remove({ id: category.id }, this.categoryTree);
    } else {
      var parent = find({ id: category.parentId }, this.categoryTree);
      parent.subCategories = remove({ id: category.id }, parent.subCategories);
    }
  });

  /**
   *  Add new category in save popup
   */
  Dashboard.prototype.addCategory = m.action('add category', function (category) {
    this.dashboardDetail.updateSubCategory();

    this.markDirty();
  });

  /**
   *  Add new sub-category in save popup
   */
  Dashboard.prototype.addSubCategory = m.action('add subCategory', function (categoryId, subCategory) {
    this.markDirty();
  });

  /**
   * Get category
   * @param {String} categoryId
   */
  Dashboard.prototype.getAllCategory = m.action(function (categories) {
    this.categoryTree = categories;
  });

  /**
   * Get sub category
   * @param {String} categoryId
   */
  Dashboard.prototype.getSubCategory = function (categoryId) {
    var category = find(function (c) {
      return isEqual(c.id, categoryId);
    }, this.categoryTree);
    return category && category.subCategories;
  };

  /**
   * Update auto duration minute
   * @param {Numeric} auto duration
   */
  Dashboard.prototype.updateAutoDurationMinute = function (minute) {
    this.autoDurationMinute = minute;
  };

  /**
   * Update auto duration second
   * @param {Numeric} auto duration
   */
  Dashboard.prototype.updateAutoDurationSecond = function (second) {
    this.autoDurationSecond = second;
  };

  /**
   * create all item
   * @returns {Object} all item
   */
  Dashboard.prototype.createAllItem = function () {
    var item = new CategoryDetail();
    var data = DashboardConstants.ALL_CATEGORY_TYPES.ALL_DASHBOARDS;
    item.populateData(data);
    return item;
  };

  /**
   * Clean list accessor for global dashboard
   */
  Dashboard.prototype.cleanListAccessors = m.action('cleanListAccessors', function () {
    var dashboardDetail = this.dashboardDetail;
    var isGlobal = dashboardDetail.dashboard.isGlobal;
    var accessModel = dashboardDetail.accessModel;
    // Clear all sharing with user if change to global
    isGlobal && accessModel.clearAllUserAccessor();
    // Clean all global roles on access detail.
    !isGlobal && accessModel.removeAllGlobalRolesOnAccessor();
  });

  module.exports = Dashboard;
}();

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);

  var DashboardTile = __webpack_require__(336);
  var CommonFilterField = __webpack_require__(1164);
  var ObjectStateConstants = __webpack_require__(58);
  var DashboardGridConstants = __webpack_require__(436);
  var trackable = __webpack_require__(46);
  var GridLayoutUtils = __webpack_require__(589)(DashboardGridConstants.NUMBER_COLS, DashboardGridConstants.DEFAULT_TILE_WIDTH, DashboardGridConstants.DEFAULT_TILE_HEIGHT);
  var constants = __webpack_require__(73);
  var AccessModel = __webpack_require__(325);
  var uiState = __webpack_require__(15);
  var ACCESS_RIGHT = __webpack_require__(42).ACCESS_RIGHT;
  var DashboardPartDrillDownInfo = __webpack_require__(2501);
  var CrossFilteringDetail = __webpack_require__(984);
  var PillDefinition = __webpack_require__(417);
  var ReportDesignerConstants = __webpack_require__(16);
  var FUNCTION_GROUP_NAME = __webpack_require__(64).FUNCTION.GROUP.NAME;
  var SubscriptionDetails = __webpack_require__(229);

  var _require = __webpack_require__(1),
      find = _require.find,
      omitBy = _require.omitBy,
      findIndex = _require.findIndex,
      indexOf = _require.indexOf,
      last = _require.last,
      reject = _require.reject,
      concat = _require.concat,
      clone = _require.clone,
      compact = _require.compact,
      defaults = _require.defaults,
      defaultsAll = _require.defaultsAll,
      without = _require.without,
      toNumber = _require.toNumber,
      sortBy = _require.sortBy,
      flatMap = _require.flatMap,
      filter = _require.filter,
      isEmpty = _require.isEmpty,
      map = _require.map,
      forEach = _require.forEach,
      omit = _require.omit,
      uniqueId = _require.uniqueId,
      invoke = _require.invoke,
      isNil = _require.isNil,
      isEqual = _require.isEqual,
      flow = _require.flow,
      negate = _require.negate,
      invokeMap = _require.invokeMap,
      get = _require.get;

  function DashboardDetail(data) {
    var accessModel = data ? data.accessModel : {};
    var props = {
      saveAs: false,
      dashboard: {
        dashboarPartDrillDowns: [],
        crossFilteringDetails: [],
        commonFilterFields: [], // array of CommonFilterField's objects.
        accesses: [],
        subscriptions: [], // It's a array of SubscriptionDetails object.
        dashboardParts: [],
        name: constants.DASHBOARD_DEFAULT_NAME,
        description: null,
        isGlobal: false,
        categoryTypeName: null,
        categoryId: null,
        categoryName: null,
        subCategoryId: null,
        subCategoryName: null,
        tenantId: null,
        backgroundColor: '',
        imageUrl: null,
        stretchImage: false,
        id: null,
        state: 0,
        inserted: false,
        version: null,
        created: null,
        createdBy: null,
        createdById: null,
        modified: null,
        modifiedBy: null,
        showFilterDescription: false,
        owner: uiState.currentUser.fullName,
        ownerId: uiState.currentUser.id,
        lastViewed: null,
        movable: false,
        deletable: false,
        copyable: false,
        isNewDashboard: function isNewDashboard() {
          return !String.isGuidFormat(this.id);
        },
        activeDashboardParts: function activeDashboardParts() {
          return filter({ isDelete: false }, this.dashboardParts);
        },
        reportPartDashboardParts: function reportPartDashboardParts() {
          return filter('isReportPartType', this.activeDashboardParts);
        },
        fullScreenDashboardPart: function fullScreenDashboardPart() {
          return find({ isFullScreenMode: true }, this.activeDashboardParts);
        },
        transparentDashboardGrid: function transparentDashboardGrid() {
          return !!(this.backgroundColor || this.imageUrl);
        },
        accessPriority: ACCESS_RIGHT.FullAccess
      },
      accessModel: new AccessModel(accessModel),
      updatedAccess: function updatedAccess() {
        return this.accessModel.accessList;
      }
    };
    this.preset = null;
    m.extendObservable(trackable(this), props);
    data && this.populateData(data);

    this.cleanDirty();
  }

  /**
   * Check Dirty for Dashboard Detail
   * @returns {type}
   */
  DashboardDetail.prototype.checkDirty = function () {
    var dirtyDashboardTiles = filter(function (dashboardTile) {
      return dashboardTile.checkDirty();
    }, this.dashboard.dashboardParts);

    return this.isDirty || !isEmpty(dirtyDashboardTiles) || this.accessModel.checkDirty();
  };

  /**
   * Clean Dirty for Dashboard Detail
   * @param {type} ) {
   */
  DashboardDetail.prototype.cleanDirty = m.action(function () {
    // Reset dirty dashboard detail
    this.resetDirty();

    // Reset dirty dashboard parts
    forEach(function (dashboardPart) {
      dashboardPart.cleanDirty();
    }, this.dashboard.dashboardParts);

    // Clean Dirty access model
    this.accessModel.cleanDirty();
  });

  /**
   * Populate data
   * @param  {Object} dashboard detail object
   */
  DashboardDetail.prototype.populateData = m.action(function (data) {
    data = data || {};
    this.saveAs = data.saveAs;
    this.readDashboardDefinition(data.dashboard);
  });

  /**
   * Populate data to dashboard model from dashboard definition model
   * @param  {Object} dashboard detail object
   */
  DashboardDetail.prototype.readDashboardDefinition = m.action(function (definition, commonFilters) {
    if (isNil(definition)) {
      return;
    }
    var newParts = map(function (item) {
      return new DashboardTile(item);
    }, definition.dashboardParts);

    this.dashboard.commonFilterFields = definition.commonFilterFields;
    this.dashboard.accesses = definition.accesses;
    this.dashboard.subscriptions = definition.subscriptions;
    this.dashboard.dashboardParts.replace(newParts);

    this.readCommonFilters(definition.commonFilterFields, commonFilters);
    this.dashboard.name = definition.name;
    this.dashboard.description = definition.description;
    this.dashboard.categoryId = definition.categoryId;
    this.dashboard.categoryName = definition.categoryName;
    this.dashboard.subCategoryId = definition.subCategoryId;
    this.dashboard.subCategoryName = definition.subCategoryName;
    this.dashboard.tenantId = definition.tenantId;
    this.dashboard.backgroundColor = definition.backgroundColor;
    this.dashboard.imageUrl = definition.imageUrl;
    this.dashboard.stretchImage = definition.stretchImage;
    this.dashboard.id = definition.id;
    this.dashboard.state = definition.state;
    this.dashboard.inserted = definition.inserted;
    this.dashboard.version = definition.version;
    this.dashboard.created = definition.created;
    this.dashboard.createdBy = definition.createdBy;
    this.dashboard.createdById = definition.createdById;
    this.dashboard.modified = definition.modified;
    this.dashboard.modifiedBy = definition.modifiedBy;
    this.dashboard.showFilterDescription = definition.showFilterDescription;
    this.dashboard.owner = definition.owner;
    this.dashboard.ownerId = definition.ownerId;
    this.dashboard.accessPriority = definition.accessPriority || ACCESS_RIGHT.FullAccess;
    this.dashboard.lastViewed = definition.lastViewed;
    this.dashboard.isGlobal = definition.isGlobal;
    this.dashboard.copyable = definition.copyable;
    this.dashboard.movable = definition.movable;
    this.dashboard.deletable = definition.deletable;
  });

  /**
   * return data objet for save
   * @method buildDataForSaving
   * @return {[type]}           [description]
   */
  DashboardDetail.prototype.buildDataForSaving = function () {
    return {
      saveAs: this.saveAs,
      dashboard: this.getDashboardDefinition(true)
    };
  };

  /**
   * return dashboard definition
   * @method getDashboardDefinition
   * @return {[type]}               [description]
   */
  DashboardDetail.prototype.getDashboardDefinition = function (forSaving) {
    var dashboardDefinition = omit(['categoryId', 'subCategoryId', 'dashboardParts', 'subscriptions', 'commonFilterFields'], this.dashboard);
    var dashboard = this.dashboard;

    dashboardDefinition.categoryId = String.isGuidFormat(dashboard.categoryId) ? dashboard.categoryId : null;
    dashboardDefinition.subCategoryId = String.isGuidFormat(dashboard.subCategoryId) ? dashboard.subCategoryId : null;

    // Update for dashboard parts.
    dashboardDefinition.dashboardParts = flow(filter(function (dashboardTile) {
      return negate(isNil)(dashboardTile.type) || dashboardTile.contentFromPreset;
    }), invokeMap('prepareDataForSave'), m.toJS, compact)(dashboard.dashboardParts);

    dashboardDefinition.commonFilterFields = invokeMap('buildDataForSave', m.toJS(dashboard.commonFilterFields));

    if (this.isDirty && this.dashboard.state === ObjectStateConstants.NONE) {
      dashboardDefinition.state = ObjectStateConstants.UPDATE;
    }

    // Update for dashboard subscription
    dashboardDefinition.subscriptions = this.updateSubscription(forSaving);
    // update for dashboard access here.
    dashboardDefinition.accesses = this.updatedAccess;
    // update tenantId:
    dashboardDefinition.tenantId = uiState.getTenantId();

    return dashboardDefinition;
  };

  /**
   * toggle show filter description
   * @method toggleShowFilterDescription
   * @param  {[type]}                 value [description]
   */
  DashboardDetail.prototype.toggleShowFilterDescription = m.action(function () {
    this.dashboard.showFilterDescription = !this.dashboard.showFilterDescription;
    this.markDirty();
  });

  /**
   * read preset data and generate dashboard parts
   * @method readPreset
   * @param  {JSON}   preset Preset config
   */
  DashboardDetail.prototype.readPreset = m.action(function (preset) {
    ensure(isEmpty(this.dashboard.dashboardParts), 'already have dashboard parts');
    this.preset = clone(preset);
    this.dashboard.dashboardParts.replace(map(function (tile) {
      var data = defaults(tile, {
        id: uniqueId('dashboardTile_'),
        dashboardId: get('id', this.dashboard),
        state: ObjectStateConstants.INSERT,
        dashboardPartContent: {
          contentFromPreset: true
        }
      });

      return new DashboardTile(data);
    }.bind(this), preset.tiles));
    this.markDirty();
  });

  /**
   * add mew tile in dashboard
   * @method addDashboardTile
   * @param  {Object}         position Location of new tiles
   * @return {DashboardTile}           New DashboardTile just created
   */
  DashboardDetail.prototype.addDashboardTile = m.action(function addDashboardTile(x, y, newDashboardPartDefinition) {
    var newDimension = GridLayoutUtils.getDimension(this.dashboard.activeDashboardParts, x, y);
    var data = defaultsAll([newDimension, {
      id: uniqueId('dashboardTile_'),
      dashboardId: get('id', this.dashboard),
      state: ObjectStateConstants.INSERT
    }, newDashboardPartDefinition]);
    forEach(function (filterItem) {
      filterItem.id = null;
      filterItem.state = ObjectStateConstants.INSERT;
    }, data.filters);

    var newDashboardPart = new DashboardTile(data);

    newDashboardPart.markDirty();

    this.dashboard.dashboardParts.push(newDashboardPart);
    this.markDirty();
    return newDashboardPart;
  });

  /**
   * copy dashboardPart
   * @method copyDashboardPart
   * @param  {DashboardTile}          dashboardPart Original DashboardTile
   * @return {DashboardTile}                 New Dashboard Tile just created
   */
  DashboardDetail.prototype.copyDashboardPart = m.action(function (dashboardPart) {
    var dashboardPartDefinition = dashboardPart.prepareDataForSave();

    var data = defaults(dashboardPartDefinition, {
      title: String.generateNewName(dashboardPart.title, this.dashboard.activeDashboardParts, get('title'), '()')
    });

    return this.addDashboardTile(null, null, data);
  });

  /**
   * delete dashboardPart
   * @method deleteDashboardPart
   * @param  {object}            dashboardPart Dashboard Part need delete
   */
  DashboardDetail.prototype.deleteDashboardPart = m.action(function (dashboardPart) {
    if (dashboardPart.isNew) {
      this.dashboard.dashboardParts.remove(dashboardPart);
    } else {
      dashboardPart.delete();
    }
    this.markDirty();
  });

  /**
   * rename dashboard Part, if newName is empty use default name
   * @method renameDashboardPart
   * @param  {dashboardPart}     dashboardPart Dashboard Part object neeed modify
   * @param  {String}            newName       New Name of dashboard part
   */
  DashboardDetail.prototype.renameDashboardPart = m.action(function (dashboardPart, newName) {
    if (isEmpty(newName)) {
      var defaultName = dashboardPart.getDefaultName;
      var otherDashboardParts = without([dashboardPart], this.dashboard.activeDashboardParts);

      newName = String.generateNewName(defaultName, otherDashboardParts, get('title'));
    }

    dashboardPart.setTitle(newName);

    this.updatePillTooltip(dashboardPart);
    this.markDirty();
  });

  /**
   * validate dashboard name not duplicate with other
   * @method validateNewNameDashboardPart
   * @param  {dashboardPart}     dashboardPart Dashboard Part object neeed modify
   * @param  {String}            newName       New Name of dashboard part
   * @return {Promise}                         Promise for validation
   */
  DashboardDetail.prototype.validateNewNameDashboardPart = function (dashboardPart, newName) {
    if (!isEmpty(newName)) {
      var otherObject = without([dashboardPart], this.dashboard.activeDashboardParts);

      if (String.checkDuplicate(newName, otherObject, get('title'))) {
        return (0, _bluebird.resolve)(DashboardGridConstants.DUPLICATE_MESSAGE);
      }
    }
    this.markDirty();
    return (0, _bluebird.resolve)('');
  };

  /**
   * set type and defaultName for dashboard part
   * @method setType
   * @param  {dashboardPart}    dashboardPart Dashboard Part object neeed modify
   * @param  {object}           type           Dashboard Part Type
   * @param  {object}           report         Report Definition object
   * @param  {object}           reportPart     Report Part Definition Part Type
   */
  DashboardDetail.prototype.setType = m.action(function (dashboardPart, type, report, reportPart) {
    ensure(!isNil(type) && !isNil(dashboardPart), 'Must have dashboardPart and type');
    dashboardPart.setType(type, report, reportPart);
    this.switchDashboardPartSide(dashboardPart, !reportPart);
    this.renameDashboardPart(dashboardPart);
    this.markDirty();
  });

  /**
   * switch dashboardPart, if new side is back side, switch other dashbboard part to front side
   * @param: {DashboardTile} dashboardPart     Current dashboard part need to switch side
   * @param: {boolean}       isBackSide        is New side back side, if fall will switch from previous side
   */
  DashboardDetail.prototype.switchDashboardPartSide = m.action(function (dashboardPart, isBackSide) {
    dashboardPart.toggleSide(isBackSide);
    if (dashboardPart.isBackSide) {
      flow(without([dashboardPart]), filter('isBackSide'), forEach(invoke('toggleSide')))(this.dashboard.activeDashboardParts);
    }
  });

  /**
   * Update dashboard name in save popup
   * @param {string} name
   */
  DashboardDetail.prototype.changeName = m.action(function (name) {
    this.dashboard.name = name;
    this.markDirty();
  });

  /**
   * Update dashboard description
   * @param {string} value
   */
  DashboardDetail.prototype.setDescription = m.action(function (value) {
    this.dashboard.description = value;
    this.markDirty();
  });

  /**
   * Update background image
   * @param {String} imageUrl
   * @param {Boolean} stretchImage
   */
  DashboardDetail.prototype.setBackgroundImage = m.action(function (imageUrl, stretchImage) {
    this.dashboard.imageUrl = imageUrl;
    this.dashboard.stretchImage = stretchImage;
    this.markDirty();
  });

  /**
   * Update background color
   * @param {String} imageUrl
   * @param {Boolean} stretchImage
   */
  DashboardDetail.prototype.setBackgroundColor = m.action(function (color) {
    this.dashboard.backgroundColor = color;
    this.markDirty();
  });

  /**
   * Handle when change dashboard's category type, reload list category.
   * @param {GUI|string} value [is 0 or 1]
   * @param {string} name [new category type name (global or local category)]
   */
  DashboardDetail.prototype.changeCategoryType = m.action(function (value) {
    this.dashboard.isGlobal = value.isGlobal;
    this.markDirty();
  });

  /**
   * Handle when change dashboard's category, reload list sub-category
   * @param {GUI|string} id [new category id]
   * @param {string} name [new category name]
   * @return {promise} [promise result from API]
   */
  DashboardDetail.prototype.changeCategory = m.action(function (id, name) {
    this.dashboard.categoryId = id || null;
    this.dashboard.categoryName = name || '';
    this.markDirty();
  });

  /**
   *  Update dashboard's sub-category in save popup
   */
  DashboardDetail.prototype.updateSubCategory = m.action(function (id, name) {
    this.dashboard.subCategoryId = id || null;
    this.dashboard.subCategoryName = name || '';
    this.markDirty();
  });

  /**
   *  Get data for validate dashboard name
   */
  DashboardDetail.prototype.getInitialData = function () {
    var result = {
      id: null,
      name: this.dashboard.name,
      isGlobal: !!this.dashboard.isGlobal,
      categoryId: String.isGuidFormat(this.dashboard.categoryId) ? this.dashboard.categoryId : null,
      categoryName: this.dashboard.categoryName,
      subCategoryId: String.isGuidFormat(this.dashboard.subCategoryId) ? this.dashboard.subCategoryId : null,
      subCategoryName: this.dashboard.subCategoryName,
      tenantId: uiState.getTenantId()
    };

    return result;
  };

  /**
   *  read common filter field from api
   * @method readCommonFilters
   * @param  {[type]}          result [description]
   * @return {[type]}                 [description]
   */
  DashboardDetail.prototype.readCommonFilters = m.action(function (result, commonFilters) {
    var commonFilterFields = this.dashboard.commonFilterFields = flow(map(function (commonFilterField) {
      var filterItem = new CommonFilterField(commonFilterField);

      // Populate filter values to common filter.
      if (!isNil(commonFilters) && !isEmpty(commonFilters)) {
        var matchedFilter = find(function (item) {
          return filterItem.position === toNumber(item.positionString);
        }, commonFilters);

        matchedFilter && (filterItem.value = matchedFilter.value);
      }

      return filterItem;
    }), sortBy(['position']))(result);

    var filterMapping = flatMap(function (commonFilterField) {
      return map(function (filterField) {
        return {
          filterFieldId: filterField.filterFieldId,
          commonFilterField: commonFilterField
        };
      }, commonFilterField.filterFields);
    }, commonFilterFields);

    flow(flatMap(flow(get('filters'), invoke('peek'))), forEach(function (filterField) {
      var commonFilterField = flow(find(['filterFieldId', filterField.filterFieldId]), get('commonFilterField'))(filterMapping);

      if (isNil(commonFilterField)) {
        filterField.isCommon = false;
      } else {
        filterField.isCommon = true;
        var commonFilterFieldValue = commonFilterField.value;
        if (!isNil(commonFilterFieldValue)) {
          filterField.value = commonFilterFieldValue;
        }
        commonFilterField.filterFieldsMapping.push(filterField);
      }
    }))(this.dashboard.reportPartDashboardParts);
  });

  /**
   *  Update subcription
   */
  DashboardDetail.prototype.updateSubscription = m.action(function (forSaving) {
    var clearnedSubscriptions = map(function (sub) {
      var subcription = new SubscriptionDetails(sub);
      if (subcription.state === ObjectStateConstants.INSERT) {
        subcription.id = null;
      }
      return subcription;
    }, this.dashboard.subscriptions);

    if (forSaving) {
      this.dashboard.subscriptions = clearnedSubscriptions;
    }

    return invokeMap('omitData', m.toJS(clearnedSubscriptions));
  });

  /**
   * Sync Subscription.
   * @param  {Object} subscribedInstances
   * @param  {Boolean} isSubscribe
   */
  DashboardDetail.prototype.syncSubscriptions = m.action(function (subscribedInstances, isSubscribe) {
    var cloneSubscribedInstances = subscribedInstances.toJS();
    var subscriptions = this.dashboard.subscriptions;
    var hasChange = false;

    for (var i = subscriptions.length - 1; i >= 0; i--) {
      var index = findIndex(function (instance) {
        return instance.id === subscriptions[i].id;
      }, cloneSubscribedInstances);

      if (index !== -1) {
        // Update
        if (!isEqual(subscriptions[i], cloneSubscribedInstances[index])) {
          subscriptions[i] = cloneSubscribedInstances[index];
          hasChange = true;
        }
        cloneSubscribedInstances.splice(index, 1);
      } else if (subscriptions[i].isSubscription === isSubscribe) {
        // remove
        subscriptions.splice(i, 1);
        hasChange = true;
      }
    }

    // add
    forEach(function (item) {
      subscriptions.push(item);
    }, cloneSubscribedInstances);

    hasChange && this.markDirty();
  });

  /**
   * Update dashboard owner
   * @param  {array} dashboardOwner   list selected dasahboard owner
   */
  DashboardDetail.prototype.updateDashboardOwner = m.action(function (dashboardOwner) {
    var owner = last(dashboardOwner) || {};
    this.dashboard.owner = owner.fullName;
    this.dashboard.ownerId = owner.id;
    this.markDirty();
  });

  /**
   * update common filter when click subscription on dashboard list
   * @param  {array}
   */
  DashboardDetail.prototype.updateCommonFilter = m.action(function (data) {
    this.dashboard.commonFilterFields = map(function (item) {
      return new CommonFilterField(item);
    }, data);
  });

  /**
   * Update drilldown in Dashboard tile to list this.dashboard.dashboarPartDrillDowns
   * If drilldown of dashboardPart already exist -> replace with the new info.
   * If drillDownData.expandedLevel <= 0 (back to All level) -> remove drillDown.
   */

  DashboardDetail.prototype.updateDrillDownCollection = function (dashboardPart) {
    // if report part is not cross filtering --> goodbye, no future cross filter actions need to be run.
    if (!this.isCrossFiltering(dashboardPart)) {
      return;
    }
    var dashboardPartDrillDownInfo = new DashboardPartDrillDownInfo(dashboardPart);
    var currentDrillDowns = get('dashboarPartDrillDowns', this.dashboard);
    var index = indexOf(find(['dashboardPart.id', dashboardPart.id], currentDrillDowns), currentDrillDowns);

    var isDrillDown = invoke('reportPart.reportPartContent.isDrillingDown', dashboardPart);
    if (index >= 0) {
      isDrillDown ? currentDrillDowns.splice(index, 1, dashboardPartDrillDownInfo) : currentDrillDowns.splice(index, 1);
    } else {
      isDrillDown && currentDrillDowns.push(dashboardPartDrillDownInfo);
    }
  };

  /**
   * Remove related dashboardPart DrillDown out of collection.
   * @param dashboardPart: DashboardTile
   */

  DashboardDetail.prototype.removeDrillDownInCollection = function (dashboardPart) {
    // if report part is not cross filtering --> goodbye, no future cross filter actions need to be run.
    if (!this.isCrossFiltering(dashboardPart)) {
      return;
    }
    var currentDrillDowns = get('dashboarPartDrillDowns', this.dashboard);
    var drillDown = this.getRelatedDrillDown(dashboardPart);

    var index = indexOf(drillDown, currentDrillDowns);
    index >= 0 && currentDrillDowns.splice(index, 1);
  };

  /**
   * Find related Drill down.
   * @param dashboardPart: DashboardTile
   */

  DashboardDetail.prototype.getRelatedDrillDown = function (dashboardPart) {
    if (!this.isCrossFiltering(dashboardPart)) {
      return null;
    }
    return flow(get('dashboarPartDrillDowns'), find(['dashboardPart.id', dashboardPart.id]))(this.dashboard);
  };

  /**
   * Get all dashboard parts, which has cross filtering with @param drilledDownDashboardPart
   * @param drilledDownDashboardPart
   * return collection of related crossfiltering dashboard part,
   * which has the same report id with currentDownDashboardPart's report id.
   */

  DashboardDetail.prototype.getRelatedCrossFilteringDashboardParts = function (dashboardPart) {
    var _this = this;

    // if report part is not cross filtering --> goodbye, no future cross filter actions need to be run.
    if (!this.isCrossFiltering(dashboardPart)) {
      return [];
    }
    // get dashboardparts with has same reportId and isCrossFiltering
    var dashboardPartCandidates = flow(get('dashboardParts'), filter(function (part) {
      return part.reportId === dashboardPart.reportId && _this.isCrossFiltering(part);
    }), reject(['id', dashboardPart.id]))(this.dashboard);

    return dashboardPartCandidates;
  };

  /**
   * Get filtering (cross filtering) for dashbard part.
   * return cross filtering array for a dashboard part. [{key: '', value: ''}]
   * @param dashboardPart: DashboardTile
   */

  DashboardDetail.prototype.getCrossFilteringForDashboardPart = function (dashboardPart, hasCrossFiltering) {
    var _this2 = this;

    // if report part is not cross filtering --> goodbye, no future cross filter actions need to be run.

    if (!hasCrossFiltering && !this.isCrossFiltering(dashboardPart)) {
      return [];
    }

    // get dashboardparts with has same reportId and isCrossFiltering
    var dashboardPartCandidates = flow(get('dashboarPartDrillDowns'), filter(function (dashboarPartDrillDown) {
      return dashboarPartDrillDown.dashboardPart.reportId === dashboardPart.reportId && _this2.isCrossFiltering(dashboarPartDrillDown.dashboardPart);
    }), reject(['dashboardPart.id', dashboardPart.id]))(this.dashboard);

    var crossFiltering = [];
    forEach(function (dashboardPartDrillDown) {
      var filters = _this2.getCrossFiltering(dashboardPart, dashboardPartDrillDown.dashboardPart);
      crossFiltering = concat(crossFiltering, filters);
    }, dashboardPartCandidates);
    return crossFiltering;
  };

  /**
   * Get Alias function in filtering dashboard part which related to driling down dashboard part.
   * @param {DashboardTile} dashboardPart: filtering dashboard part (which is filtering).
   * @param {DashboardTile} drillingDownDashboardPart: drilling down dashboard part.
   */
  DashboardDetail.prototype.getCrossFiltering = function (dashboardPart, drillingDownDashboardPart) {
    var _this3 = this;

    var crossfilteringInfoes = invoke('reportPart.getCrossFilteringFilter', drillingDownDashboardPart);
    var crossFilteringFilters = [];
    forEach(function (crossFilteringInfo) {
      if (!isNil(crossFilteringInfo.field)) {
        var _scanRelatedField = _this3.scanRelatedField(dashboardPart, crossFilteringInfo.field),
            key = _scanRelatedField.key,
            fieldId = _scanRelatedField.fieldId;

        var filterItem = {
          isCrossFilter: true,
          fieldId: fieldId,
          key: key,
          value: crossFilteringInfo.value,
          dataFormat: get('field.reportPartElm.properties.dataFormattings.format.formatId', crossFilteringInfo)
        };
        filterItem = omitBy(isNil, filterItem);
        crossFilteringFilters.push(filterItem);
      }
    }, crossfilteringInfoes);

    return crossFilteringFilters;
  };

  /**
   * get field alias which applied function in dashboard part and related to input field
   * @param {DashboardTile} dashboardPart: filtering dashboardPart.
   * @param {any} field: field
   */
  DashboardDetail.prototype.scanRelatedField = function (dashboardPart, field) {
    var groupFunctionName = FUNCTION_GROUP_NAME;
    var reportPartElm = get('reportPartElm', field);
    var functionName = get('reportPartElm.properties.dataFormattings.functionInfo.name', field);
    // If function is Group --> act it like a normal field
    functionName === groupFunctionName && (functionName = null);
    var _reportPartElm$field = reportPartElm.field,
        sourceAlias = _reportPartElm$field.sourceAlias,
        fieldId = _reportPartElm$field.fieldId,
        fieldName = _reportPartElm$field.fieldName,
        fieldNameAlias = _reportPartElm$field.fieldNameAlias,
        relationshipId = _reportPartElm$field.relationshipId;

    var key = '[' + sourceAlias + '].[' + fieldName + ']';
    var finalFieldId = null;
    var finalKey = '';
    // Process finding related function.
    if (!isNil(functionName)) {
      var elementCandidates = flow(get('reportPart.elementInfo'), filter(function (info) {
        return get('element.field.sourceAlias', info) === sourceAlias && get('element.field.fieldName', info) === fieldName && get('element.field.relationshipId', info) === relationshipId;
      }))(dashboardPart);

      // search by function.
      if (!isEmpty(elementCandidates)) {
        forEach(function (elementCandidate) {
          var elementFunctionName = get('element.properties.dataFormattings.functionInfo.name', elementCandidate);
          elementFunctionName === groupFunctionName && (elementFunctionName = null);
          if (elementFunctionName === functionName) {
            finalKey = isNil(functionName) ? key : get('element.field.fieldNameAlias', elementCandidate);
            return false;
          }
        }, elementCandidates);
      }
    } else {
      // normal field.
      if (isNil(relationshipId) || relationshipId === constants.EMPTY_GUID) {
        finalFieldId = fieldId;
        finalKey = null;
      } else {
        finalKey = key;
      }
    }

    return {
      key: finalKey,
      fieldId: finalFieldId
    };
  };

  /**
   * Logic to update related pills when doing drilldown on a report part.
   * expected that dashboard.dashboarPartDrillDowns is already changed.
   * @param dashboardPart: DashboardTile
   */

  DashboardDetail.prototype.onDrillDownUpdatePill = function (dashboardPart) {
    var relatedDrillDownInfo = flow(get('dashboarPartDrillDowns'), find(['dashboardPart.id', dashboardPart.id]))(this.dashboard);

    var relatedPill = this.findRelatedPill(dashboardPart);

    // drillDown is removed --> remove Pill
    !isNil(relatedPill) ? isNil(relatedDrillDownInfo) && this.removePill(get('report.id', dashboardPart), get('id', dashboardPart)) : !isNil(relatedDrillDownInfo) && this.addPill(relatedDrillDownInfo);
  };

  /**
   * Remove a pill whith related to reportId and dashboardId
   * After removing pill, if the crossfilter which contain pill is empty -> remove that cross filtering also.
   * @param reportId: string
   * @param dashboardPartId: string.
   */

  DashboardDetail.prototype.removePill = function (reportId, dashboardPartId) {
    var existingCrossFiltering = get('crossFilteringDetails', this.dashboard);
    var relatedCrossFiltering = find(['reportId', reportId], existingCrossFiltering);

    if (!isNil(relatedCrossFiltering)) {
      var pillIndex = indexOf(find(['parentId', dashboardPartId], relatedCrossFiltering.pillDefinitions), relatedCrossFiltering.pillDefinitions);
      pillIndex >= 0 && relatedCrossFiltering.pillDefinitions.splice(pillIndex, 1);

      if (isEmpty(relatedCrossFiltering.pillDefinitions)) {
        var crossFilteringIndex = indexOf(relatedCrossFiltering, existingCrossFiltering);
        existingCrossFiltering.splice(crossFilteringIndex, 1);
      }
    }
  };

  /**
   * Add new Pill
   * @param drillDownInfo: DashboardPartDrillDownInfo
   */

  DashboardDetail.prototype.addPill = function (drillDownInfo) {
    var findCrossFiltering = this.findRelatedCrossFiltering(drillDownInfo.dashboardPart);

    var dashboardPartId = get('dashboardPart.id', drillDownInfo);
    var pillDefinition = new PillDefinition(dashboardPartId, get('dashboardPart.reportPart', drillDownInfo), drillDownInfo.dashboardPart.editingTitle);
    pillDefinition.parentId = dashboardPartId;

    if (isNil(findCrossFiltering)) {
      var _drillDownInfo$dashbo = drillDownInfo.dashboardPart.report,
          reportName = _drillDownInfo$dashbo.name,
          reportId = _drillDownInfo$dashbo.id;

      findCrossFiltering = new CrossFilteringDetail(reportId, reportName, [pillDefinition]);
      var existingCrossFiltering = get('crossFilteringDetails', this.dashboard);
      existingCrossFiltering.push(findCrossFiltering);
    } else {
      findCrossFiltering.pillDefinitions.push(pillDefinition);
    }
  };

  /**
   * Update the exiting pill which related to drillDownInfo, drill down or drill up an exsixting pill.
   * @param drillDownInfo: DashboardPartDrillDownInfo
   */

  DashboardDetail.prototype.updatePill = function (drillDownInfo) {
    var findCrossFiltering = flow(get('crossFilteringDetails'), find(['report.id', drillDownInfo.dashboardPart.report.id]))(this.dashboard);
    var newPillDefinition = new PillDefinition(get('dashboardPart.reportPart', drillDownInfo));
    var existingPillDefinition = find(['dashboardId', get('dashboardPart.id', drillDownInfo)], findCrossFiltering.pillDefinitions);
    var existingPillIndex = indexOf(existingPillDefinition, findCrossFiltering.pillDefinitions);
    findCrossFiltering.pillDefinitions.splice(existingPillIndex, 1, newPillDefinition);
  };

  /**
   * find related Cross Filtering
   * @param dashboardPart: DashbordTile
   */

  DashboardDetail.prototype.findRelatedCrossFiltering = function (dashboardPart) {
    var reportId = get('report.id', dashboardPart);
    var relatedCrossFiltering = reportId && flow(get('crossFilteringDetails'), find(['reportId', dashboardPart.report.id]))(this.dashboard);
    return relatedCrossFiltering;
  };

  /**
   * find associated Pill which related to dashboard part.
   * @param dashboardPart: DashboardTile
   * return PillDefinition
   */

  DashboardDetail.prototype.findRelatedPill = function (dashboardPart) {
    var crossFiltering = this.findRelatedCrossFiltering(dashboardPart);

    var relatedPill = flow(get('pillDefinitions'), find(['parentId', dashboardPart.id]))(crossFiltering);

    return relatedPill;
  };

  /**
   * update Pill's tooltip
   * @param dashboardPart: DashboardTile
   */

  DashboardDetail.prototype.updatePillTooltip = function (dashboardPart) {
    var relatedPill = this.findRelatedPill(dashboardPart);
    !isNil(relatedPill) && (relatedPill.tooltip = dashboardPart.editingTitle);
  };
  /**
   * Function to identify if that dashboard part is Cross filtering or not?
   * @param dashboardPart: check if dash board tile is cross filtering.
   */

  DashboardDetail.prototype.isCrossFiltering = function (dashboardPart) {
    return get('reportPart.reportPartContent.isCrossFiltering', dashboardPart);
  };

  /**
   * Action when click remove pill in crossfiltering bar.
   */

  DashboardDetail.prototype.onClearDrillDown = function (dashboardPart) {
    var reportPartContent = get('reportPart.reportPartContent', dashboardPart);
    reportPartContent && invoke('resetDrilldownInfo', reportPartContent);
  };


  DashboardDetail.prototype.removeAllCrossFilterings = function () {
    var array = this.dashboard.crossFilteringDetails;
    !isEmpty(array) && array.splice(0, array.length);
  };


  DashboardDetail.prototype.removeAllDrillDowns = function () {
    var array = this.dashboard.dashboarPartDrillDowns;
    !isEmpty(array) && array.splice(0, array.length);
  };

  /**
   * Calculate color for cross filterings.
   */

  DashboardDetail.prototype.calculateCrossFilteringColors = function () {
    var crossfilteringDetails = get('crossFilteringDetails', this.dashboard);
    var index = 0;
    forEach(function (crossfilteringDetail) {
      var alternative = !(index % 2);
      index++;
      forEach(function (pill) {
        pill.alternative = alternative;
      }, crossfilteringDetail.pillDefinitions);
    }, crossfilteringDetails);
  };

  /**
   * get all report types, which are allowed for crossfiltering.
   */

  function allowedCrossFilteringReportTypes() {
    var reportPartTypes = ReportDesignerConstants.REPORT_PART_TYPE;
    return [reportPartTypes.Chart, reportPartTypes.Gauge, reportPartTypes.Map];
  }

  /**
   * check if dashboardpart is valid for cross filtering.
   * @param {DashboardTile} dashboardPart dashboard part need to check.
   */

  DashboardDetail.prototype.isAllowedCrossFiltering = function (dashboardPart) {
    var allowedReportPartTypes = allowedCrossFilteringReportTypes();
    var reportPartType = get('reportPart.reportPartContent.type', dashboardPart);
    return !flow(find(function (type) {
      return type == reportPartType;
    }), isNil)(allowedReportPartTypes);
  };

  module.exports = DashboardDetail;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _Izenda = __webpack_require__(336);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardPartDrillDownInfo = function DashboardPartDrillDownInfo(dashboardPart) {
  (0, _classCallCheck3.default)(this, DashboardPartDrillDownInfo);

  this.dashboardPart = dashboardPart;
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPartDrillDownInfo.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INCreadDashboardDefinition.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

exports.default = DashboardPartDrillDownInfo;
module.exports = exports['default'];

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerMode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(326);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DashboardDesignerMode = (_class = function () {
  (0, _createClass3.default)(DashboardDesignerMode, [{
    key: 'isDesigner',
    get: function get() {
      return !this.isPresentation && !this.isAccess && !this.isSubscribe && !this.isFullscreen && !this.isSchedule;
    }
  }, {
    key: 'isDisabledCloseButton',
    get: function get() {
      return this.isAccess || this.isSubscribe || this.isSchedule;
    }
  }, {
    key: 'isDisabledAcessButton',
    get: function get() {
      return !this.isAccess && !this.isDesigner;
    }
  }, {
    key: 'isDisabledSubscribeButton',
    get: function get() {
      return !this.isSubscribe && !this.isDesigner;
    }
  }, {
    key: 'isDisabledScheduleButton',
    get: function get() {
      return !this.isSchedule && !this.isDesigner;
    }
  }, {
    key: 'isDisabledPresentationButton',
    get: function get() {
      return !this.isPresentation && !this.isDesigner;
    }
  }]);

  function DashboardDesignerMode(data) {
    (0, _classCallCheck3.default)(this, DashboardDesignerMode);

    _initDefineProp(this, 'isPresentation', _descriptor, this);

    _initDefineProp(this, 'isAccess', _descriptor2, this);

    _initDefineProp(this, 'isSubscribe', _descriptor3, this);

    _initDefineProp(this, 'isEdit', _descriptor4, this);

    _initDefineProp(this, 'isFullscreen', _descriptor5, this);

    _initDefineProp(this, 'isSchedule', _descriptor6, this);

    _initDefineProp(this, 'alertDetails', _descriptor7, this);

    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param {Object} data
   */


  (0, _createClass3.default)(DashboardDesignerMode, [{
    key: 'populateData',
    value: function populateData(data) {
      data = data || {};
      this.isPresentation = data.isPresentation;
      this.isAccess = data.isAccess;
      this.isSchedule = data.isSchedule;
      this.isSubscribe = data.isSubscribe;
      this.isEdit = data.isEdit;
      this.isFullscreen = data.isFullscreen;
    }

    /**
     * Reset data
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.isPresentation = false;
      this.isAccess = false;
      this.isSubscribe = false;
      this.isFullscreen = false;
      this.isEdit = false;
      this.isSchedule = false;
      this.errorMessage = '';
    }

    /**
     * Enable presentation mode
     */

  }, {
    key: 'togglePresentation',
    value: function togglePresentation() {
      this.isFullscreen = false;
      this.isPresentation = !this.isPresentation;
    }

    /**
     * Toggle access status
     */

  }, {
    key: 'toggleAccess',
    value: function toggleAccess() {
      this.isAccess = !this.isAccess;
    }

    /**
     * Toggle schedule status
     */

  }, {
    key: 'toggleSchedule',
    value: function toggleSchedule() {
      this.isSchedule = !this.isSchedule;
    }

    /**
     * Toggle subscribe status
     */

  }, {
    key: 'toggleSubscribe',
    value: function toggleSubscribe() {
      this.isSubscribe = !this.isSubscribe;
    }

    /**
     * Edit mode
     */

  }, {
    key: 'setEditMode',
    value: function setEditMode() {
      this.isEdit = true;
    }

    /**
     * Subscribe mode
     * @param {boolean} isSubscribe
     */

  }, {
    key: 'switchSubscribeMode',
    value: function switchSubscribeMode(isSubscribe) {
      this.isSubscribe = isSubscribe;
    }

    /**
     * Set Alert Details
     * @param {object} data
     */

  }, {
    key: 'setAlertDetails',
    value: function setAlertDetails(data) {
      this.alertDetails.set(data);
    }

    /**
     * Reset Alert message
     */

  }, {
    key: 'resetAlertDetails',
    value: function resetAlertDetails() {
      this.alertDetails.reset();
    }

    /**
     * Toggle full screen
     */

  }, {
    key: 'toggleFullscreen',
    value: function toggleFullscreen() {
      this.isPresentation = false;
      this.isFullscreen = true;
    }

    /**
     * Exit full screen
     */

  }, {
    key: 'exitFullscreen',
    value: function exitFullscreen() {
      this.isPresentation = true;
      this.isFullscreen = false;
    }
  }]);
  return DashboardDesignerMode;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isPresentation', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'isAccess', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'isSubscribe', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'isEdit', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'isFullscreen', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'isSchedule', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'alertDetails', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda2.default();
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isDesigner', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDesigner'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDisabledCloseButton', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDisabledCloseButton'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDisabledAcessButton', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDisabledAcessButton'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDisabledSubscribeButton', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDisabledSubscribeButton'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDisabledScheduleButton', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDisabledScheduleButton'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isDisabledPresentationButton', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isDisabledPresentationButton'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'populateData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reset', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reset'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePresentation', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePresentation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setAlertDetails', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setAlertDetails'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetAlertDetails', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetAlertDetails'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleFullscreen', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleFullscreen'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'exitFullscreen', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'exitFullscreen'), _class.prototype)), _class);
exports.default = DashboardDesignerMode;
module.exports = exports['default'];

/***/ }),
/* 2503 */,
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EdgeDetector.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var Utils = __webpack_require__(262);
  var domHelperEvents = __webpack_require__(308);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      throttle = _require.throttle;

  var EdgeDetector = React.createClass({
    displayName: 'EdgeDetector',

    propTypes: {
      onChanged: PropTypes.func
    },
    getDefaultProps: function getDefaultProps() {
      return {
        onChanged: null
      };
    },
    componentDidMount: function componentDidMount() {
      var _this = this;

      var throttleScroll = throttle(250, this.handleScroll);

      this.scrollableAncestor = Utils.findScrollableParent(this.boundary);
      this.scrollableAncestor && domHelperEvents.on(this.scrollableAncestor, 'scroll', throttleScroll);

      this.unlisten = function () {
        _this.scrollableAncestor && domHelperEvents.off(_this.scrollableAncestor, 'scroll', throttleScroll);
      };

      this.handleScroll(null);
    },
    componentDidUpdate: function componentDidUpdate() {
      this.handleScroll(null);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.unlisten();
    },

    render: function render() {
      return React.createElement(
        'div',
        { ref: this.refBoundary, className: this.props.className },
        this.props.children
      );
    },
    refBoundary: function refBoundary(node) {
      this.boundary = node;
    },
    handleScroll: function handleScroll(event) {
      try {
        var bounds = this.getBounds();
        var isOnEdge = this.isOnEdge(bounds);

        var previousState = this.previousState;

        if (previousState === isOnEdge) {
          return;
        }
        this.previousState = isOnEdge;
        this.props.onChanged && this.props.onChanged(isOnEdge);
      } catch (e) {
        // do nothing
      }
    },
    getBounds: function getBounds() {
      var boundaryRect = this.boundary.getBoundingClientRect();
      var scrollTop = this.scrollableAncestor.getBoundingClientRect().top;
      var scrollHeight = this.scrollableAncestor.clientHeight;

      return {
        top: boundaryRect.top,
        bottom: boundaryRect.bottom,
        viewportTop: scrollTop,
        viewportBottom: scrollTop + scrollHeight
      };
    },
    isOnEdge: function isOnEdge(bounds) {
      if (bounds.viewportBottom - bounds.viewportTop === 0) {
        return false;
      }
      return bounds.viewportTop >= bounds.top && bounds.viewportTop <= bounds.bottom;
    }
  });

  module.exports = observer(EdgeDetector);
}();

/***/ }),
/* 2505 */,
/* 2506 */,
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityPoliciesDetail.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var action = __webpack_require__(173);
  var constants = __webpack_require__(162);

  var GridLayout = __webpack_require__(13);
  var Panel = __webpack_require__(28);
  var Alert = __webpack_require__(61);
  var MainContent = __webpack_require__(156);
  var Input = __webpack_require__(17);

  var ActionBar = __webpack_require__(2510);
  var ScrollBox = __webpack_require__(27);
  var PasswordPolicies = __webpack_require__(2511);
  var AccountLockoutPolicies = __webpack_require__(2518);

  var SecurityPoliciesDetail = React.createClass({
    displayName: 'SecurityPoliciesDetail',


    componentDidMount: function componentDidMount() {
      var props = this.props;
      var loader = props.loader;
      var store = props.store;

      loader.startLoading();
      store.init();
      store.loadSecurityPoliciesDetail().finally(loader.endLoading.bind(loader));
    },

    render: function render() {
      var props = this.props;
      var store = props.store;

      return React.createElement(
        'div',
        { className: 'izenda-SecurityPoliciesDetail u_fullHeight u-posRelative' },
        React.createElement(ActionBar, { store: store, onSave: props.onSave, onCancel: props.onCancel }),
        React.createElement(
          'div',
          { className: 'u_fullHeight izenda-SecurityPoliciesPanel' },
          React.createElement(
            ScrollBox,
            null,
            React.createElement(
              'div',
              { className: 'izenda-ControlPanel' },
              React.createElement(PasswordPolicies, { store: store }),
              React.createElement(AccountLockoutPolicies, { store: store })
            )
          )
        )
      );
    }

  });

  module.exports = connect(action)(SecurityPoliciesDetail);
}();

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityPoliciesStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty;

  var extendObservable = __webpack_require__(5).extendObservable;
  var uiState = __webpack_require__(15);
  var m = __webpack_require__(5);
  var SecurityPolicies = __webpack_require__(2509);
  var fetcher = __webpack_require__(75);
  var commonMessages = __webpack_require__(37);
  var localizer = __webpack_require__(12);

  function SecurityPoliciesStore() {
    extendObservable(this, {
      model: new SecurityPolicies(),
      alertMessage: commonMessages.EMPTY_MESSAGE
    });
  }

  /**
   * init state store
   */
  SecurityPoliciesStore.prototype.init = m.action(function () {
    uiState.setCheckDirtyFunction(function () {
      return this.model.isDirty;
    }.bind(this));
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
  });

  /**
   * load Security Policies Detail
   * @returns {promise}
   */
  SecurityPoliciesStore.prototype.loadSecurityPoliciesDetail = m.action(function () {
    var model = this.model;
    var readSecuritPoliciesDetail = m.action(function (result) {
      model.readSecuritPolicies(result);
    });
    return fetcher.loadSecurityPolicies().then(readSecuritPoliciesDetail);
  });

  /**
   * save security policies
   * @return {promise}
   */
  SecurityPoliciesStore.prototype.save = m.action(function () {
    var model = this.model;
    var data = model.getDataForSave();

    var handleAfterSave = m.action(function (result) {
      if (isEmpty(result.messages)) {
        model.readSecuritPolicies(result);
        this.setAlertMessage('success', localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
        return true;
      }

      return result;
    });
    return fetcher.saveSecurityPolicies(data).bind(this).then(handleAfterSave);
  });

  /**
   * set Alert Message
   * @param {string} type
   * @param {string} message
   */
  SecurityPoliciesStore.prototype.setAlertMessage = function (type, message) {
    this.alertMessage = {
      type: type,
      message: message
    };
  };

  module.exports = SecurityPoliciesStore;
}();

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityPolicies.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var constants = __webpack_require__(162);

  var _require = __webpack_require__(1),
      forEach = _require.forEach,
      isNil = _require.isNil,
      isEmpty = _require.isEmpty,
      toNumber = _require.toNumber,
      isUndefined = _require.isUndefined,
      isString = _require.isString,
      keys = _require.keys,
      isBoolean = _require.isBoolean,
      isNumber = _require.isNumber;

  function SecurityPolicies(data) {
    var props = {
      id: null,
      state: 0,
      inserted: false,
      version: null,
      created: null,
      createdBy: null,
      modified: null,
      modifiedBy: null,
      /* Password Policies */
      // Password Complexity
      minNumberOfPasswordLenght: null,
      maxNumberOfPasswordLenght: null,
      passwordLength: false,
      minNumberOfSpecialCharacter: null,
      maxNumberOfSpecialCharacter: null,
      numberSpecialCharacters: false,
      minNumberOfUppercaseCharacter: null,
      maxNumberOfUppercaseCharacter: null,
      numberUppercaseCharacters: false,
      minNumberOfLowercaseCharacter: null,
      maxNumberOfLowercaseCharacter: null,
      numberLowercaseCharacters: false,
      minNumberOfNumericCharacter: null,
      maxNumberOfNumericCharacter: null,
      numberNumericCharacters: false,
      maxNumberOfRepeatSequential: null,
      maxNumberSequentialRepeated: false,
      // Password Validity
      minNumberOfPasswordAge: null,
      maxNumberOfPasswordAge: null,
      passwordAge: false,
      // Password Expiry Notification
      notifyUseDuring: null,
      notifyUser: false,
      // Password History
      numberOfPasswordToKeep: null,
      enforcePasswordHistory: false,
      // Password Link
      passwordLinkValidity: null,
      passwordLinkValidityChecked: false,
      // Security Questions
      numberOfQuestionProfile: null,
      numberOfQuestionResetPassword: null,
      useSecurityQuestions: false,
      /* Account Lockout Policies */
      numberOfFailedLogonAllowed: null,
      numberFailedLogonAttemptsAllowed: false,
      numberOfFailedAnswerAllowed: null,
      numberFailedSecurityQuestionAttemptsAllowed: false,
      lockoutPeriod: null,

      // calculated value
      minPasswordLength: function minPasswordLength() {
        return this.toNumber(this.minNumberOfSpecialCharacter) + this.toNumber(this.minNumberOfUppercaseCharacter) + this.toNumber(this.minNumberOfLowercaseCharacter) + this.toNumber(this.minNumberOfNumericCharacter);
      },
      maxPasswordLength: function maxPasswordLength() {
        return this.toNumber(this.maxNumberOfSpecialCharacter) + this.toNumber(this.maxNumberOfUppercaseCharacter) + this.toNumber(this.maxNumberOfLowercaseCharacter) + this.toNumber(this.maxNumberOfNumericCharacter);
      },
      enableSecurityQuestionToResetPassword: function enableSecurityQuestionToResetPassword() {
        return this.useSecurityQuestions && this.toNumber(this.numberOfQuestionProfile) > 0;
      },
      enableLockoutPeriod: function enableLockoutPeriod() {
        return this.toNumber(this.numberOfFailedLogonAllowed) !== 0 || this.toNumber(this.numberOfFailedAnswerAllowed) !== 0;
      }
    };

    m.extendObservable(trackable(this), props);
    this.readSecuritPolicies(data);
  }

  /**
   * Read Securtity Data
   */
  SecurityPolicies.prototype.readSecuritPolicies = m.action(function (data) {
    data = data || {};
    forEach(function (key) {
      if (!isUndefined(this[key])) {
        this[key] = data[key];
      }
    }.bind(this), keys(data));

    // populate data
    this.populateData();

    // Reset Dirty
    this.resetDirty();
  });

  /**
   * update Value by Key
   * @param  {string} key
   * @param  {string} value
   */
  SecurityPolicies.prototype.updateValueByKey = function (key, value, requiredMinValue) {
    requiredMinValue = requiredMinValue || constants.REQUIRED_MIN_VALUE;
    if (!isBoolean(value)) {
      if (isString(value) && isEmpty(value)) {
        this[key] = null;
      } else {
        value = this.toNumber(value);
        if (isNumber(value) && value >= requiredMinValue) {
          this[key] = value;
        }
      }
    } else {
      this[key] = value;
    }
    this.markDirty();
  };

  /**
   * check Has Data
   * @param  {string} min
   * @param  {string} max
   * @return {boolean}
   */
  SecurityPolicies.prototype.checkHasData = function (min, max) {
    return !isNil(min) || !isNil(max);
  };

  /**
   * populate checkbox Data
   */
  SecurityPolicies.prototype.populateData = m.action(function () {
    this.passwordLength = this.checkHasData(this.minNumberOfPasswordLenght, this.maxNumberOfPasswordLenght);
    this.numberSpecialCharacters = this.checkHasData(this.minNumberOfSpecialCharacter, this.maxNumberOfSpecialCharacter);
    this.numberUppercaseCharacters = this.checkHasData(this.minNumberOfUppercaseCharacter, this.maxNumberOfUppercaseCharacter);
    this.numberLowercaseCharacters = this.checkHasData(this.minNumberOfLowercaseCharacter, this.maxNumberOfLowercaseCharacter);
    this.numberNumericCharacters = this.checkHasData(this.minNumberOfNumericCharacter, this.maxNumberOfNumericCharacter);
    this.maxNumberSequentialRepeated = this.checkHasData(this.maxNumberOfRepeatSequential);
    this.passwordAge = this.checkHasData(this.minNumberOfPasswordAge, this.maxNumberOfPasswordAge);
    this.notifyUser = this.checkHasData(this.notifyUseDuring);
    this.enforcePasswordHistory = this.checkHasData(this.numberOfPasswordToKeep);
    this.passwordLinkValidityChecked = this.checkHasData(this.passwordLinkValidity);
    this.useSecurityQuestions = this.checkHasData(this.numberOfQuestionProfile, this.numberOfQuestionResetPassword);
    this.numberFailedLogonAttemptsAllowed = this.checkHasData(this.numberOfFailedLogonAllowed);
    this.numberFailedSecurityQuestionAttemptsAllowed = this.checkHasData(this.numberOfFailedAnswerAllowed);
  });

  /**
   * toNumber
   * @param  {number} number
   * @return {number}
   */
  SecurityPolicies.prototype.toNumber = function (number) {
    if (isString(number) && isEmpty(number)) {
      return null;
    }
    return toNumber(number) || 0;
  };

  /**
   * auto Calculate Number of Min Password Length
   * @return
   */
  SecurityPolicies.prototype.autoCalculateMinPasswordLength = function () {
    if (this.minNumberOfPasswordLenght < this.minPasswordLength) {
      this.minNumberOfPasswordLenght = this.minPasswordLength;
    }
  };

  /**
   * auto Calculate Number of Max Password Length
   * @return {}
   */
  SecurityPolicies.prototype.autoCalculateMaxPasswordLength = function () {
    if (this.maxNumberOfPasswordLenght < this.maxPasswordLength) {
      this.maxNumberOfPasswordLenght = this.maxPasswordLength;
    }
  };

  /**
   * get Data From Setting from UI
   * @return {value}
   */
  SecurityPolicies.prototype.getDataFromSetting = function (condition, value) {
    if (isNil(value)) {
      return value;
    }
    return condition ? this.toNumber(value) : null;
  };

  /**
   * get Data For Save
   * @return {object}
   */
  SecurityPolicies.prototype.getDataForSave = m.action(function () {
    var data = {
      id: this.id,
      state: this.state,
      inserted: this.inserted,
      version: this.version,
      created: this.created,
      createdBy: this.createdBy,
      modified: this.modified,
      modifiedBy: this.modifiedB,
      /* Password Policies */
      // Password Complexity
      minNumberOfPasswordLenght: this.getDataFromSetting(this.passwordLength, this.minNumberOfPasswordLenght),
      maxNumberOfPasswordLenght: this.getDataFromSetting(this.passwordLength, this.maxNumberOfPasswordLenght),
      minNumberOfSpecialCharacter: this.getDataFromSetting(this.numberSpecialCharacters, this.minNumberOfSpecialCharacter),
      maxNumberOfSpecialCharacter: this.getDataFromSetting(this.numberSpecialCharacters, this.maxNumberOfSpecialCharacter),
      minNumberOfUppercaseCharacter: this.getDataFromSetting(this.numberUppercaseCharacters, this.minNumberOfUppercaseCharacter),
      maxNumberOfUppercaseCharacter: this.getDataFromSetting(this.numberUppercaseCharacters, this.maxNumberOfUppercaseCharacter),
      minNumberOfLowercaseCharacter: this.getDataFromSetting(this.numberLowercaseCharacters, this.minNumberOfLowercaseCharacter),
      maxNumberOfLowercaseCharacter: this.getDataFromSetting(this.numberLowercaseCharacters, this.maxNumberOfLowercaseCharacter),
      minNumberOfNumericCharacter: this.getDataFromSetting(this.numberNumericCharacters, this.minNumberOfNumericCharacter),
      maxNumberOfNumericCharacter: this.getDataFromSetting(this.numberNumericCharacters, this.maxNumberOfNumericCharacter),
      maxNumberOfRepeatSequential: this.getDataFromSetting(this.maxNumberSequentialRepeated, this.maxNumberOfRepeatSequential),
      // Password Validity
      minNumberOfPasswordAge: this.getDataFromSetting(this.passwordAge, this.minNumberOfPasswordAge),
      maxNumberOfPasswordAge: this.getDataFromSetting(this.passwordAge, this.maxNumberOfPasswordAge),
      // Password Expiry Notification
      notifyUseDuring: this.getDataFromSetting(this.notifyUser, this.notifyUseDuring),
      // Password History
      numberOfPasswordToKeep: this.getDataFromSetting(this.enforcePasswordHistory, this.numberOfPasswordToKeep),
      // Password Link
      passwordLinkValidity: this.getDataFromSetting(this.passwordLinkValidityChecked, this.passwordLinkValidity),
      // Security Questions
      numberOfQuestionProfile: this.getDataFromSetting(this.useSecurityQuestions, this.numberOfQuestionProfile),
      numberOfQuestionResetPassword: this.getDataFromSetting(this.enableSecurityQuestionToResetPassword, this.numberOfQuestionResetPassword),
      /* Account Lockout Policies */
      numberOfFailedLogonAllowed: this.getDataFromSetting(this.numberFailedLogonAttemptsAllowed, this.numberOfFailedLogonAllowed),
      numberOfFailedAnswerAllowed: this.getDataFromSetting(this.numberFailedSecurityQuestionAttemptsAllowed, this.numberOfFailedAnswerAllowed),
      lockoutPeriod: this.getDataFromSetting(this.enableLockoutPeriod, this.lockoutPeriod)
    };

    return data;
  });

  module.exports = SecurityPolicies;
}();

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ActionBar component
 */
!function () {
  "use strict";

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var Button = __webpack_require__(30);
  var Alert = __webpack_require__(61);
  var GridLayout = __webpack_require__(13);

  var ActionBar = connect()(function (props) {
    var localization = props.localization;
    var alertMessage = props.store.alertMessage;
    return React.createElement(
      GridLayout,
      { className: 'izenda-SecurityPoliesActionBar u_paddingBottom' },
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: '7' },
          React.createElement(
            Alert,
            { className: 'u_floatLeft u_marginLeft', type: alertMessage.type },
            alertMessage.message
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '5' },
          React.createElement(Button, { label: localization.getText('COMMON_LABEL_CANCEL'), className: 'u_marginLeftRight u_floatRight', onClick: props.onCancel }),
          React.createElement(Button, { label: localization.getText('COMMON_LABEL_SAVE'), className: 'u_marginLeft u_floatRight', onClick: props.onSave })
        )
      )
    );
  });

  module.exports = ActionBar;
}();

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2512);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2513);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2514);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2515);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2516);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2517);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(173);

var _Izenda18 = _interopRequireDefault(_Izenda17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordPolicies.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var Header = (0, _Izenda2.default)()(function (props) {
  var localization = props.localization;
  return _react2.default.createElement(
    'div',
    { onClick: props.collapseToggle },
    _react2.default.createElement('i', { className: 'icon-toggle-triangle' }),
    _react2.default.createElement(
      'label',
      { className: 'panel-title' },
      localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_POLICY')
    )
  );
});

var PasswordPolicies = (0, _Izenda2.default)(_Izenda18.default)(function (props) {
  var header = {
    component: Header
  };

  return _react2.default.createElement(
    _Izenda4.default,
    { className: 'u_fullHeight u_noMarginAll', header: header, collapsible: true, expanedOption: true },
    _react2.default.createElement(_Izenda6.default, props),
    _react2.default.createElement(_Izenda8.default, props),
    _react2.default.createElement(_Izenda10.default, props),
    _react2.default.createElement(_Izenda12.default, props),
    _react2.default.createElement(_Izenda14.default, props),
    _react2.default.createElement(_Izenda16.default, props)
  );
});

exports.default = PasswordPolicies;
module.exports = exports['default'];

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(162);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(173);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda7 = __webpack_require__(13);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(23);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(17);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordComplexity.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ValidatableInput = (0, _Izenda10.default)()(_Izenda12.default);
var notifyChange = _EventUtils2.default.notifyChange;

var PasswordComplexity = (0, _Izenda2.default)(_Izenda6.default)(function (props) {
  var localization = props.localization;
  return _react2.default.createElement(
    _Izenda8.default,
    null,
    _react2.default.createElement(
      _Izenda8.default.Row,
      { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        _react2.default.createElement(
          'span',
          { className: 'u_textBold u_marginLeft' },
          localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_COMPLEXITY')
        )
      )
    ),
    _react2.default.createElement(PasswordLength, props),
    _react2.default.createElement(NumberSpecialCharacters, props),
    _react2.default.createElement(NumberUppercaseCharacters, props),
    _react2.default.createElement(NumberLowercaseCharacters, props),
    _react2.default.createElement(NumberNumericCharacters, props),
    _react2.default.createElement(NumberSequentialRepeatedCharacters, props)
  );
});

var PasswordLength = (0, _Izenda2.default)(_Izenda6.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var minField = 'minNumberOfPasswordLenght';
  var maxField = 'maxNumberOfPasswordLenght';
  var validateField = [minField, maxField];
  var validations = function validations(isMinField, sumValue) {
    return _Izenda4.default.numberLimitConstraints(isMinField, localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_PASSWORD_LENGTH'), localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_PASSWORD_LENGTH'), model[minField], model[maxField], sumValue);
  };
  return _react2.default.createElement(
    _Izenda8.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda8.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda12.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model.passwordLength,
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, 'passwordLength'), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_LENGTH')
          )
        )
      ),
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '8' },
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_FROM')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          disabled: !model.passwordLength,
          value: model[minField],
          onBlur: props.onBlurFocusField.bind(props, validateField),
          field: minField,
          validations: validations(true, model.minPasswordLength),
          onChange: notifyChange(model.updateValueByKey.bind(model, minField), _EventUtils2.default.INPUT)
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_TO')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          disabled: !model.passwordLength,
          value: model[maxField],
          onBlur: props.onBlurFocusField.bind(props, validateField),
          field: maxField,
          validations: validations(false, model.maxPasswordLength),
          onChange: notifyChange(model.updateValueByKey.bind(model, maxField), _EventUtils2.default.INPUT)
        })
      )
    )
  );
});

var NumberSpecialCharacters = (0, _Izenda2.default)(_Izenda6.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var minField = 'minNumberOfSpecialCharacter';
  var maxField = 'maxNumberOfSpecialCharacter';
  var validateField = [minField, maxField, 'minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght'];
  var validations = function validations(isMinField) {
    return _Izenda4.default.numberLimitConstraints(isMinField, 'Min No. of Special Characters', 'Max No. of Special Characters', model[minField], model[maxField]);
  };
  return _react2.default.createElement(
    _Izenda8.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda8.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda12.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model.numberSpecialCharacters,
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, 'numberSpecialCharacters'), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_OF_SPECIAL_CHARACTERS')
          )
        )
      ),
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '8' },
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_FROM')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          field: minField,
          disabled: !model.numberSpecialCharacters,
          value: model[minField],
          onBlur: props.onBlurFocusField.bind(props, validateField),
          onChange: notifyChange(props.onChangeSettingValueMinPasswordLength.bind(props, minField), _EventUtils2.default.INPUT),
          validations: validations(true)
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_TO')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          field: maxField,
          disabled: !model.numberSpecialCharacters,
          value: model[maxField],
          onBlur: props.onBlurFocusField.bind(props, validateField),
          onChange: notifyChange(props.onChangeSettingValueMaxPasswordLength.bind(props, maxField), _EventUtils2.default.INPUT),
          validations: validations(false)
        })
      )
    )
  );
});

var NumberUppercaseCharacters = (0, _Izenda2.default)(_Izenda6.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var minField = 'minNumberOfUppercaseCharacter';
  var maxField = 'maxNumberOfUppercaseCharacter';
  var validateField = [minField, maxField, 'minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght'];
  var validations = function validations(isMinField) {
    return _Izenda4.default.numberLimitConstraints(isMinField, localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_NO_OF_UPPERCASE_CHARACTERS'), localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_NO_OF_UPPERCASE_CHARACTERS'), model[minField], model[maxField]);
  };
  return _react2.default.createElement(
    _Izenda8.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda8.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda12.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model.numberUppercaseCharacters,
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, 'numberUppercaseCharacters'), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_OF_UPPERCASE_CHARACTERS')
          )
        )
      ),
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '8' },
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_FROM')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          field: minField,
          disabled: !model.numberUppercaseCharacters,
          value: model[minField],
          onBlur: props.onBlurFocusField.bind(props, validateField),
          onChange: notifyChange(props.onChangeSettingValueMinPasswordLength.bind(props, minField), _EventUtils2.default.INPUT),
          validations: validations(true)
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_TO')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          field: maxField,
          disabled: !model.numberUppercaseCharacters,
          value: model[maxField],
          onBlur: props.onBlurFocusField.bind(props, validateField),
          onChange: notifyChange(props.onChangeSettingValueMaxPasswordLength.bind(props, maxField), _EventUtils2.default.INPUT),
          validations: validations(false)
        })
      )
    )
  );
});

var NumberLowercaseCharacters = (0, _Izenda2.default)(_Izenda6.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var minField = 'minNumberOfLowercaseCharacter';
  var maxField = 'maxNumberOfLowercaseCharacter';
  var validateField = [minField, maxField, 'minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght'];
  var validations = function validations(isMinField) {
    return _Izenda4.default.numberLimitConstraints(isMinField, localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_NO_OF_LOWERCASE_CHARACTERS'), localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_NO_OF_LOWERCASE_CHARACTERS'), model[minField], model[maxField]);
  };
  return _react2.default.createElement(
    _Izenda8.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda8.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda12.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model.numberLowercaseCharacters,
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, 'numberLowercaseCharacters'), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_OF_LOWERCASE_CHARACTERS')
          )
        )
      ),
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '8' },
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_FROM')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          field: minField,
          disabled: !model.numberLowercaseCharacters,
          onBlur: props.onBlurFocusField.bind(props, validateField),
          value: model[minField],
          onChange: notifyChange(props.onChangeSettingValueMinPasswordLength.bind(props, minField), _EventUtils2.default.INPUT),
          validations: validations(true)
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_TO')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          disabled: !model.numberLowercaseCharacters,
          value: model[maxField],
          onBlur: props.onBlurFocusField.bind(props, validateField),
          field: maxField,
          onChange: notifyChange(props.onChangeSettingValueMaxPasswordLength.bind(props, maxField), _EventUtils2.default.INPUT),
          validations: validations(false)
        })
      )
    )
  );
});

var NumberNumericCharacters = (0, _Izenda2.default)(_Izenda6.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var minField = 'minNumberOfNumericCharacter';
  var maxField = 'maxNumberOfNumericCharacter';
  var validateField = [minField, maxField, 'minNumberOfPasswordLenght', 'maxNumberOfPasswordLenght'];
  var validations = function validations(isMinField) {
    return _Izenda4.default.numberLimitConstraints(isMinField, localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_NO_OF_NUMBERIC_CHARACTERS'), localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_NO_OF_NUMBERIC_CHARACTERS'), model[minField], model[maxField]);
  };
  return _react2.default.createElement(
    _Izenda8.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda8.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda12.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model.numberNumericCharacters,
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, 'numberNumericCharacters'), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_OF_NUMBERIC_CHARACTERS')
          )
        )
      ),
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '8' },
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_FROM')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          disabled: !model.numberNumericCharacters,
          field: minField,
          onBlur: props.onBlurFocusField.bind(props, validateField),
          value: model[minField],
          onChange: notifyChange(props.onChangeSettingValueMinPasswordLength.bind(props, minField), _EventUtils2.default.INPUT),
          validations: validations(true)
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_TO')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          disabled: !model.numberNumericCharacters,
          field: maxField,
          onBlur: props.onBlurFocusField.bind(props, validateField),
          value: model[maxField],
          onChange: notifyChange(props.onChangeSettingValueMaxPasswordLength.bind(props, maxField), _EventUtils2.default.INPUT),
          validations: validations(false)
        })
      )
    )
  );
});

var NumberSequentialRepeatedCharacters = (0, _Izenda2.default)(_Izenda6.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var field = 'maxNumberSequentialRepeated';
  var validateField = 'maxNumberOfRepeatSequential';
  return _react2.default.createElement(
    _Izenda8.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda8.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda12.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model[field],
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, field), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MAX_NO_OF_REPEAT_CHARACTERS')
          )
        )
      ),
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '8' },
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput-Position form-control u_inlineBlock',
          disabled: !model[field],
          value: model[validateField],
          onBlur: props.onBlurFocusField.bind(props, [validateField]),
          field: validateField,
          onChange: notifyChange(model.updateValueByKey.bind(model, validateField), _EventUtils2.default.INPUT),
          validations: _Izenda4.default.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_MIN_PASSWORD_AGE'))
        })
      )
    )
  );
});

exports.default = PasswordComplexity;
module.exports = exports['default'];

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(162);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(173);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(23);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordValidity.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ValidatableInput = (0, _Izenda12.default)()(_Izenda8.default);
var notifyChange = _EventUtils2.default.notifyChange;
var minField = 'minNumberOfPasswordAge';
var maxField = 'maxNumberOfPasswordAge';

var PasswordValidity = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  return _react2.default.createElement(
    _Izenda6.default,
    null,
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        _react2.default.createElement(
          'span',
          { className: 'u_textBold u_marginLeft' },
          localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_VALIDITY')
        )
      )
    ),
    _react2.default.createElement(PasswordAge, props)
  );
});

var PasswordAge = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var validateField = [minField, maxField];
  var validations = function validations(isMinField) {
    return _Izenda4.default.numberLimitConstraints(isMinField, _Izenda4.default.PASSWORD_VALIDITY.MIN_PASSWORD_AGE, _Izenda4.default.PASSWORD_VALIDITY.MAX_PASSWORD_AGE, model[minField], model[maxField]);
  };
  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda8.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model.passwordAge,
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, 'passwordAge'), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_AGE')
          )
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '8' },
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_FROM')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          disabled: !model.passwordAge,
          field: minField,
          onBlur: props.onBlurFocusField.bind(props, validateField),
          value: model[minField],
          onChange: notifyChange(model.updateValueByKey.bind(model, minField), _EventUtils2.default.INPUT),
          validations: validations(true)
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_TO')
        ),
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput form-control u_inlineBlock u_marginLeftRight',
          disabled: !model.passwordAge,
          field: maxField,
          value: model[maxField],
          onBlur: props.onBlurFocusField.bind(props, validateField),
          onChange: notifyChange(model.updateValueByKey.bind(model, maxField), _EventUtils2.default.INPUT),
          validations: validations(false)
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_DAYS')
        )
      )
    )
  );
});

exports.default = PasswordValidity;
module.exports = exports['default'];

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(162);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(173);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(23);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordExpiryNotification.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ValidatableInput = (0, _Izenda12.default)()(_Izenda8.default);
var notifyChange = _EventUtils2.default.notifyChange;

var PasswordExpiryNotification = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  return _react2.default.createElement(
    _Izenda6.default,
    null,
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        _react2.default.createElement(
          'span',
          { className: 'u_textBold u_marginLeft' },
          localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_EXPIRY_NOTIFICATION')
        )
      )
    ),
    _react2.default.createElement(NotifyUser, props),
    _react2.default.createElement(NotifyUseDuring, props)
  );
});

var NotifyUser = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var field = 'notifyUser';
  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda8.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model[field],
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, field), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NOTIFY_USER')
          )
        )
      ),
      _react2.default.createElement(_Izenda6.default.Col, { cols: '8' })
    )
  );
});

var NotifyUseDuring = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var field = 'notifyUseDuring';
  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'span',
          { className: 'izenda-CustomInput-Position' },
          localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NOTIFY_USE_DURING')
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '8' },
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput-Position form-control u_inlineBlock u_marginRight',
          disabled: !model.notifyUser,
          field: field,
          value: model[field],
          onBlur: props.onBlurFocusField.bind(props, [field]),
          onChange: notifyChange(model.updateValueByKey.bind(model, field), _EventUtils2.default.INPUT),
          validations: _Izenda4.default.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NOTIFY_USE_DURING'))
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_DAYS_TO_PASSWORD_EXPIRY')
        )
      )
    )
  );
});

exports.default = PasswordExpiryNotification;
module.exports = exports['default'];

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(162);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(173);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(23);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordHistory.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ValidatableInput = (0, _Izenda12.default)()(_Izenda8.default);
var notifyChange = _EventUtils2.default.notifyChange;

var PasswordHistory = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  return _react2.default.createElement(
    _Izenda6.default,
    null,
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        _react2.default.createElement(
          'span',
          { className: 'u_textBold u_marginLeft' },
          localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_HISTORY')
        )
      )
    ),
    _react2.default.createElement(EnforcePasswordHistory, props),
    _react2.default.createElement(NumberPasswordKeep, props)
  );
});

var EnforcePasswordHistory = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var field = 'enforcePasswordHistory';
  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda8.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model[field],
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, field), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_ENFORCE_PASSWORD_HISTORY')
          )
        )
      ),
      _react2.default.createElement(_Izenda6.default.Col, { cols: '8' })
    )
  );
});

var NumberPasswordKeep = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var field = 'numberOfPasswordToKeep';
  var valueField = 'enforcePasswordHistory';
  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'span',
          { className: 'izenda-CustomInput-Position' },
          localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_PASSWORD_TO_KEEP')
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '8' },
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput-Position form-control u_inlineBlock',
          disabled: !model[valueField],
          field: valueField,
          onBlur: props.onBlurFocusField.bind(props, [field]),
          value: model[field],
          onChange: notifyChange(props.onChangeRequiredValue.bind(props, field, _Izenda4.default.REQUIRED_VALUE_NO_PASSWORD_KEEP), _EventUtils2.default.INPUT),
          validations: _Izenda4.default.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_NO_PASSWORD_TO_KEEP'))
        })
      )
    )
  );
});

exports.default = PasswordHistory;
module.exports = exports['default'];

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(162);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(173);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(23);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordLink.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ValidatableInput = (0, _Izenda12.default)()(_Izenda8.default);
var notifyChange = _EventUtils2.default.notifyChange;

var PasswordLink = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  return _react2.default.createElement(
    _Izenda6.default,
    null,
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        _react2.default.createElement(
          'span',
          { className: 'u_textBold u_marginLeft' },
          localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_LINK')
        )
      )
    ),
    _react2.default.createElement(PasswordLinkValidity, props)
  );
});

var PasswordLinkValidity = (0, _Izenda2.default)(_Izenda10.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var field = 'passwordLinkValidityChecked';
  var validateField = 'passwordLinkValidity';
  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda8.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model[field],
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, field), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_LINK_VALIDITY')
          )
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '8' },
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput-Position form-control u_inlineBlock u_marginRight',
          disabled: !model[field],
          field: validateField,
          onBlur: props.onBlurFocusField.bind(props, [validateField]),
          value: model[validateField],
          onChange: notifyChange(model.updateValueByKey.bind(model, validateField), _EventUtils2.default.INPUT),
          validations: _Izenda4.default.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_LINK_VALIDITY'))
        }),
        _react2.default.createElement(
          'span',
          null,
          localization.getText('COMMON_LABEL_HOURS')
        )
      )
    )
  );
});

exports.default = PasswordLink;
module.exports = exports['default'];

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(162);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(23);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(17);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(173);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatableInput = (0, _Izenda8.default)()(_Izenda10.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityQuestions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var minField = 'numberOfQuestionResetPassword';
var maxField = 'numberOfQuestionProfile';
var notifyChange = _EventUtils2.default.notifyChange;

var SecurityQuestions = (0, _Izenda2.default)(_Izenda12.default)(function (props) {
  var localization = props.localization;
  return _react2.default.createElement(
    _Izenda6.default,
    null,
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        _react2.default.createElement(
          'span',
          { className: 'u_textBold u_marginLeft' },
          localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_SECURITY_QUESTION')
        )
      )
    ),
    _react2.default.createElement(SecurityQuestionsMessage, props),
    _react2.default.createElement(UseSecurityQuestions, props),
    _react2.default.createElement(SecurityQuestionsUserProfile, props),
    _react2.default.createElement(SecurityQuestionsResetPassword, props)
  );
});

var SecurityQuestionsMessage = (0, _Izenda2.default)(_Izenda12.default)(function (props) {
  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement('i', { className: 'icon-info-circled u_marginLeftRight' }),
      _react2.default.createElement(
        'span',
        null,
        _Izenda4.default.SECURITY_QUESTIONS
      )
    )
  );
});

var UseSecurityQuestions = (0, _Izenda2.default)(_Izenda12.default)(function (props) {
  var localization = props.localization;
  var model = props.store.model;
  var field = 'useSecurityQuestions';
  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda10.default, {
            type: 'checkbox',
            className: 'u_marginLeft',
            checked: model[field],
            onChange: notifyChange(props.onChangeValueCheckbox.bind(props, field), _EventUtils2.default.CHECKBOX)
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeft' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_USE_SECURITY_QUESTION')
          )
        )
      ),
      _react2.default.createElement(_Izenda6.default.Col, { cols: '8' })
    )
  );
});

var SecurityQuestionsUserProfile = (0, _Izenda2.default)(_Izenda12.default)(function (props) {
  var model = props.store.model;
  var validations = function validations(isMinField) {
    return _Izenda4.default.securityQuestionConstraint(isMinField, _Izenda4.default.SECURITY_QUESTION_FIELD_NAME.RESET_PASSWORD, _Izenda4.default.SECURITY_QUESTION_FIELD_NAME.USER_PROFILE, model[minField], model[maxField]);
  };

  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'span',
          { className: 'izenda-CustomInput-Position' },
          _Izenda4.default.SECURITY_QUESTION_FIELD_NAME.USER_PROFILE
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '8' },
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput-Position form-control u_inlineBlock',
          disabled: !model.useSecurityQuestions,
          onBlur: props.onBlurFocusField.bind(props, [minField, maxField]),
          field: maxField,
          value: model[maxField],
          onChange: notifyChange(props.onChangeRequiredValue.bind(props, maxField, _Izenda4.default.REQUIRED_VALUE_NO_SECURITY_QUESTIONS), _EventUtils2.default.INPUT),
          validations: validations(false)
        })
      )
    )
  );
});

var SecurityQuestionsResetPassword = (0, _Izenda2.default)(_Izenda12.default)(function (props) {
  var model = props.store.model;
  var validations = function validations(isMinField) {
    return _Izenda4.default.securityQuestionConstraint(isMinField, _Izenda4.default.SECURITY_QUESTION_FIELD_NAME.RESET_PASSWORD, _Izenda4.default.SECURITY_QUESTION_FIELD_NAME.USER_PROFILE, model[minField], model[maxField]);
  };
  var enable = model.useSecurityQuestions && (0, _fp.toNumber)(model[maxField]) !== 0;

  return _react2.default.createElement(
    _Izenda6.default.Row,
    { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
    _react2.default.createElement(
      _Izenda6.default.Col,
      { cols: '12', className: 'u_noPaddingAll' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '4' },
        _react2.default.createElement(
          'span',
          { className: 'izenda-CustomInput-Position' },
          _Izenda4.default.SECURITY_QUESTION_FIELD_NAME.RESET_PASSWORD
        )
      ),
      _react2.default.createElement(
        _Izenda6.default.Col,
        { cols: '8' },
        _react2.default.createElement(ValidatableInput, {
          type: 'input',
          containerClassName: 'u_inline',
          className: 'izenda-CustomInput-Position form-control u_inlineBlock',
          onBlur: props.onBlurFocusField.bind(props, [minField, maxField]),
          field: minField,
          disabled: !enable,
          value: model[minField],
          onChange: notifyChange(props.onChangeRequiredPositiveValue.bind(props, minField), _EventUtils2.default.INPUT),
          validations: validations(true)
        })
      )
    )
  );
});

exports.default = SecurityQuestions;
module.exports = exports['default'];

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountLockoutPolicies.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var constants = __webpack_require__(162);

  var EventsUtils = __webpack_require__(24);
  var notifyChange = EventsUtils.notifyChange;
  var GridLayout = __webpack_require__(13);
  var Panel = __webpack_require__(28);
  var Input = __webpack_require__(17);
  var action = __webpack_require__(173);
  var Validator = __webpack_require__(23);
  var ValidatableInput = Validator()(__webpack_require__(17));

  var Header = connect()(function (props) {
    var localization = props.localization;
    return React.createElement(
      'div',
      { onClick: props.collapseToggle },
      React.createElement('i', { className: 'icon-toggle-triangle' }),
      React.createElement(
        'label',
        { className: 'panel-title' },
        localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_ACCOUNT_LOCKOUT_POLICIES')
      )
    );
  });

  var AccountLockoutPolicies = connect(action)(function (props) {
    var header = {
      component: Header
    };

    return React.createElement(
      Panel,
      { className: 'u_fullHeight u_noMarginAll',
        header: header,
        collapsible: true,
        expanedOption: true },
      React.createElement(
        GridLayout,
        null,
        React.createElement(FailedLogonAttemptsAllowed, props),
        React.createElement(FailedSecurityQuestionAttemptsAllowed, props),
        React.createElement(LockoutPeriod, props)
      )
    );
  });

  var FailedLogonAttemptsAllowed = connect(action)(function (props) {
    var localization = props.localization;
    var model = props.store.model;
    var field = 'numberFailedLogonAttemptsAllowed';
    var valueField = 'numberOfFailedLogonAllowed';
    return React.createElement(
      GridLayout.Row,
      { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
      React.createElement(
        GridLayout.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        React.createElement(
          GridLayout.Col,
          { cols: '4' },
          React.createElement(
            'label',
            null,
            React.createElement(Input, { type: 'checkbox',
              className: 'u_marginLeft',
              checked: model[field],
              onChange: notifyChange(props.onChangeValueCheckbox.bind(props, field), EventsUtils.CHECKBOX)
            }),
            React.createElement(
              'span',
              { className: 'u_marginLeft' },
              localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_FAILED_LOGON_ATTEMPTS_ALLOWED')
            )
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '8' },
          React.createElement(ValidatableInput, {
            type: 'input',
            containerClassName: 'u_inline',
            field: valueField,
            className: 'izenda-CustomInput-Position form-control u_inlineBlock',
            disabled: !model[field],
            value: model[valueField],
            onBlur: props.onBlurFocusField.bind(props, [valueField]),
            onChange: notifyChange(props.onChangeRequiredValue.bind(props, valueField, constants.REQUIRED_VALUE_NO_PASSWORD_KEEP), EventsUtils.INPUT),
            validations: constants.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_FAILED_LOGON_ATTEMPTS_ALLOWED'))
          })
        )
      )
    );
  });

  var FailedSecurityQuestionAttemptsAllowed = connect(action)(function (props) {
    var localization = props.localization;
    var model = props.store.model;
    var field = 'numberFailedSecurityQuestionAttemptsAllowed';
    var valueField = 'numberOfFailedAnswerAllowed';
    return React.createElement(
      GridLayout.Row,
      { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
      React.createElement(
        GridLayout.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        React.createElement(
          GridLayout.Col,
          { cols: '4' },
          React.createElement(
            'label',
            null,
            React.createElement(Input, { type: 'checkbox',
              className: 'u_marginLeft',
              checked: model[field],
              onChange: notifyChange(props.onChangeValueCheckbox.bind(props, field), EventsUtils.CHECKBOX)
            }),
            React.createElement(
              'span',
              { className: 'u_marginLeft' },
              localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_FAILED_SECURITY_QUESTION_ATTEMPTS_ALLOWED')
            )
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '8' },
          React.createElement(ValidatableInput, {
            type: 'input',
            containerClassName: 'u_inline',
            className: 'izenda-CustomInput-Position form-control u_inlineBlock',
            disabled: !model[field],
            value: model[valueField],
            field: valueField,
            onBlur: props.onBlurFocusField.bind(props, [valueField]),
            onChange: notifyChange(props.onChangeRequiredValue.bind(props, valueField, constants.REQUIRED_VALUE_NO_PASSWORD_KEEP), EventsUtils.INPUT),
            validations: constants.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_FAILED_LOGON_ATTEMPTS_ALLOWED'))
          })
        )
      )
    );
  });

  var LockoutPeriod = connect(action)(function (props) {
    var localization = props.localization;
    var model = props.store.model;
    var enabled = model.enableLockoutPeriod;

    var field = 'lockoutPeriod';
    var constraint = enabled ? constants.requiredConstraints(localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_LOCKOUT_PERIOD')) : {};

    return React.createElement(
      GridLayout.Row,
      { className: 'u_noMarginAll u_borderBottom izenda-ItemContentHeight' },
      React.createElement(
        GridLayout.Col,
        { cols: '12', className: 'u_noPaddingAll' },
        React.createElement(
          GridLayout.Col,
          { cols: '4' },
          React.createElement(
            'span',
            { className: 'izenda-CustomInput-Position' },
            localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_LOCKOUT_PERIOD')
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '8' },
          React.createElement(ValidatableInput, {
            type: 'input',
            containerClassName: 'u_inline',
            className: 'izenda-CustomInput-Position form-control u_inlineBlock u_marginRight',
            value: model[field],
            field: field,
            onBlur: props.onBlurFocusField.bind(props, [field]),
            disabled: !enabled,
            onChange: notifyChange(model.updateValueByKey.bind(model, field), EventsUtils.INPUT),
            validations: constraint
          }),
          React.createElement(
            'span',
            null,
            localization.getText('COMMON_LABEL_MINS')
          )
        )
      )
    );
  });

  module.exports = AccountLockoutPolicies;
}();

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Import.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(131);

var _Izenda2 = __webpack_require__(27);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(2520);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(2523);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(2524);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(2);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(2538);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(2544);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _mobx = __webpack_require__(5);

var _Izenda16 = __webpack_require__(2546);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(83);

var _Izenda19 = _interopRequireDefault(_Izenda18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Import = (_dec = (0, _Izenda11.default)(_Izenda13.default, _Izenda19.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Import, _Component);

  function Import(props) {
    (0, _classCallCheck3.default)(this, Import);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Import.__proto__ || (0, _getPrototypeOf2.default)(Import)).call(this, props));

    _this.setDom = function (dom) {
      _this.domNode = dom;
    };

    _this.uiStore = (0, _mobx.observable)({
      defaultHeight: 0
    });
    return _this;
  }

  (0, _createClass3.default)(Import, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.uiStore.defaultHeight != this.domNode.clientHeight) {
        this.uiStore.defaultHeight = this.domNode.clientHeight;
      }
    }
  }, {
    key: 'renderImportTabs',
    value: function renderImportTabs() {
      var _props = this.props,
          store = _props.store,
          _props$store = _props.store,
          model = _props$store.model,
          hasErrorReportTab = _props$store.hasErrorReportTab,
          hasErrorDashboardTab = _props$store.hasErrorDashboardTab,
          activeTabKey = _props.store.model.activeTabKey;

      var height = this.props.height > 0 ? this.props.height : this.uiStore.defaultHeight;
      var reportTabTitle = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          store.reportTabTitle
        ),
        hasErrorReportTab && _react2.default.createElement('span', { className: 'icon-attention warning-color' })
      );
      var dashboardTabTitle = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          store.dashboardTabTitle
        ),
        hasErrorDashboardTab && _react2.default.createElement('span', { className: 'icon-attention warning-color' })
      );

      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper-content' },
        _react2.default.createElement(
          _Izenda3.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'u_fullHeight u_paddingLeftRight' },
            _react2.default.createElement(
              _Izenda.Tabs,
              {
                activeTabKey: activeTabKey,
                panelClassName: 'u_noMarginAll',
                onChange: model.changeActiveTabKey.bind(model),
                canChangeTab: this.props.canChangeTab
              },
              _react2.default.createElement(
                _Izenda.Tab,
                { title: reportTabTitle, tabKey: 'report' },
                _react2.default.createElement(_Izenda5.default, { height: height, store: store })
              ),
              _react2.default.createElement(
                _Izenda.Tab,
                { title: dashboardTabTitle, tabKey: 'dashboard' },
                _react2.default.createElement(_Izenda7.default, { height: height, store: store })
              )
            ),
            _react2.default.createElement(_Izenda17.default, { store: store })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          store = _props2.store,
          hasFileLoaded = _props2.store.hasFileLoaded;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-Import izenda-TableLayout', ref: this.setDom },
        _react2.default.createElement(
          'div',
          { className: 'izenda-TableLayout-Cell' },
          hasFileLoaded ? _react2.default.createElement(
            'section',
            { className: 'izenda-Wrapper' },
            _react2.default.createElement(_Izenda9.default, { store: store }),
            this.renderImportTabs()
          ) : _react2.default.createElement(_Izenda15.default, { store: store })
        )
      );
    }
  }]);
  return Import;
}(_react.Component)) || _class);
exports.default = Import;
module.exports = exports['default'];

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportTab.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ---------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1172);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportTab = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ReportTab, _Component);

  function ReportTab() {
    (0, _classCallCheck3.default)(this, ReportTab);
    return (0, _possibleConstructorReturn3.default)(this, (ReportTab.__proto__ || (0, _getPrototypeOf2.default)(ReportTab)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportTab, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.validation.updateErrors(this.props.store.errorMessages);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          height = _props.height,
          store = _props.store;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Izenda4.default, {
          height: height,
          dataSource: store.model.reports,
          saveInto: store.saveInto,
          loadCategories: store.loadCategories,
          loadSubCategories: store.loadSubCategories,
          store: store
        })
      );
    }
  }]);
  return ReportTab;
}(_react.Component)) || _class);
exports.default = ReportTab;
module.exports = exports['default'];

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(416);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(136);

var _Izenda2 = __webpack_require__(2522);

var _Izenda3 = _interopRequireDefault(_Izenda2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportListActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _recompose.withHandlers)({
  getType: (0, _fp.curry)(getType),
  updateCategory: (0, _fp.curry)(updateCategory),
  updateName: (0, _fp.curry)(updateName),
  updateSubCategory: (0, _fp.curry)(updateSubCategory),
  updateSaveIntoId: (0, _fp.curry)(updateSaveIntoId),
  removeFile: (0, _fp.curry)(removeFile),
  openDetailFilePopup: (0, _fp.curry)(openDetailFilePopup)
});

/**
 * Get type
 * @param {Object} props
 * @param {Object} data
 */

function getType(props, data) {
  if (data.isReport) {
    return (0, _Izenda.getReportType)(data.content.type);
  } else {
    return props.localization.getText('COMMON_LABEL_DASHBOARD');
  }
}

/**
 * Update name
 * @param {Object} props
 * @param {Object} importFileContent
 * @param {Object} event
 */
function updateName(props, importFileContent, event) {
  props.store.updateName(importFileContent, event.target.value);
  updateErrorMessages(props);
}

/**
 * Update save into id
 * @param {Object} props
 * @param {Object} importFileContent
 * @param {String} saveIntoId
 */
function updateSaveIntoId(props, importFileContent, saveIntoId) {
  props.store.updateSaveIntoId(importFileContent, saveIntoId);
  updateErrorMessages(props);
}

/**
 * Update category
 * @param {Object} props
 * @param {Object} importFileContent
 * @param {String} categoryId
 */
function updateCategory(props, importFileContent, categoryId, categoryName) {
  props.store.updateCategory(importFileContent, categoryId, categoryName);
  updateErrorMessages(props);
}

/**
 * Update sub category
 * @param {Object} props
 * @param {Object} importFileContent
 * @param {String} subCategoryId
 */
function updateSubCategory(props, importFileContent, subCategoryId, subCategoryName) {
  props.store.updateSubCategory(importFileContent, subCategoryId, subCategoryName);
  updateErrorMessages(props);
}

/**
 * Update error messages
 * @param {Object} data
 */
function updateErrorMessages(_ref) {
  var validation = _ref.validation,
      store = _ref.store;

  validation.reset();
  validation.updateErrors(store.errorMessages);
}

/**
 * Remove file
 * @param {Object} props
 * @param {Object} data
 */
function removeFile(props, _ref2) {
  var id = _ref2.id,
      name = _ref2.name,
      index = _ref2.content.index;
  var store = props.store,
      validation = props.validation,
      isDashboardTab = props.isDashboardTab;

  props.confirmFn('Information', {
    description: String.format(props.localization.getText('IMPORT_DELETE_MESSAGE'), name),
    type: 'warning',
    showCloseIndicator: false
  }).then(function () {
    store.removeFiles([id]).then(function (isSuccess) {
      if (isSuccess) {
        isDashboardTab ? store.updateDashboards(id, index) : store.updateReports(id, index);
        store.updateDatabaseMappings().then(function () {
          if (store.hasErrorOnClientSideReportTab && store.model.activeTabKey === 'report' || store.hasErrorOnClientSideDashboardTab && store.model.activeTabKey === 'dashboard') {
            validation.validate().then(function (status) {
              status && updateErrorMessages(props);
            });
          } else {
            updateErrorMessages(props);
          }
        });
      }
    });
  });
}

/**
 * Get detail file then open detail file popup
 * @param {Object} props
 * @param {Object} report
 */
function openDetailFilePopup(props, data) {
  var store = props.store;

  var fileInfo = store.getFileInfo(data);
  var isReport = data.isReport;
  var typeAccess = isReport ? _Izenda.TYPE_ACCESS_REPORT : _Izenda.TYPE_ACCESS_DASHBOARD;
  var title = getTitleDetailPopup(props, data);

  store.getDetailFile(fileInfo, typeAccess).then(function (result) {
    var _result = (0, _slicedToArray3.default)(result, 2),
        content = _result[0],
        loadAccessRights = _result[1];

    props.openPopup(_Izenda3.default, {
      title: title,
      content: content,
      loadAccessRights: loadAccessRights
    });
  });
}

/**
 * Get title popup
 * @param {Object} data
 * @param {Object} props
 * @returns {String}
 */
function getTitleDetailPopup(props, data) {
  var localization = props.localization;

  if (data.isReport) {
    if (data.content.type === 0) {
      return localization.getText('IMPORT_REPORT_INFORMATION');
    } else {
      return localization.getText('IMPORT_TEMPLATE_INFORMATION');
    }
  } else {
    return localization.getText('IMPORT_DASHBOARD_INFORMATION');
  }
}
module.exports = exports['default'];

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DetailFilePopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(27);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(36);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(44);

var _Izenda6 = __webpack_require__(136);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TABLE_DEF = _Izenda6.TableDefinition.ReportInformation;

var DetailFilePopup = (_dec = (0, _Izenda8.default)(), _dec(_class = (_temp2 = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(DetailFilePopup, _PureComponent);

  function DetailFilePopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DetailFilePopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DetailFilePopup.__proto__ || (0, _getPrototypeOf2.default)(DetailFilePopup)).call.apply(_ref, [this].concat(args))), _this), _this.renderShare = function (data) {
      return _react2.default.createElement(
        'div',
        { className: 'izenda-GridLayout' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-GridLayout-Row' },
          _react2.default.createElement(
            'label',
            { className: 'izenda-GridLayout-Col1 u_marginTop' },
            data.assignedTypeName
          ),
          _react2.default.createElement(
            'div',
            { className: 'u_textBreak Select--multi izenda-GridLayout-Col11' },
            data.accessorNames && _this.renderRoles(data.accessorNames)
          )
        )
      );
    }, _this.renderAccess = function (data) {
      var loadAccessRights = _this.props.loadAccessRights;

      var accessRightName = (0, _fp.find)({ id: data.accessRightId }, loadAccessRights);
      var accessName = accessRightName ? accessRightName.name : '';

      return _react2.default.createElement(
        'label',
        null,
        accessName
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DetailFilePopup, [{
    key: 'renderDataItem',


    /**
     * Render item's data information
     * @param {string} label
     * @param {string} value
     */
    value: function renderDataItem(label, value) {
      return _react2.default.createElement(
        'div',
        { className: 'izenda-GridLayout-Row' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-GridLayout-Col3' },
          label
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-GridLayout-Col9 u_textBreak' },
          value
        )
      );
    }

    /**
     * Render table data information
     */

  }, {
    key: 'renderDataInformation',
    value: function renderDataInformation() {
      var _props = this.props,
          localization = _props.localization,
          content = _props.content;
      var settingLevel = content.settingLevel,
          databases = content.databases,
          querySources = content.querySources,
          customViews = content.customViews,
          calculatedFields = content.calculatedFields;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'u_textBold u_marginBottom' },
          localization.getText('IMPORT_DATA_INFORMATION')
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_borderAll u_borderRadius' },
          _react2.default.createElement(
            _Izenda2.default,
            { className: 'izenda-DataInformation-Container' },
            _react2.default.createElement(
              'div',
              { className: 'izenda-GridLayout u_paddingAll' },
              this.renderDataItem(_Izenda6.TitlesData['settingLevel'], settingLevel),
              this.renderDataItem(_Izenda6.TitlesData['databases'], (0, _fp.join)('; ', databases)),
              this.renderDataItem(_Izenda6.TitlesData['dataSources'], (0, _fp.join)('; ', querySources)),
              this.renderDataItem(_Izenda6.TitlesData['customViews'], (0, _fp.join)('; ', customViews)),
              this.renderDataItem(_Izenda6.TitlesData['calculatedFields'], (0, _fp.join)('; ', calculatedFields))
            )
          )
        )
      );
    }

    /**
     * Render accessor roles names with border-box
     * @param {Array} accessorNames
     */

  }, {
    key: 'renderRoles',
    value: function renderRoles(accessorNames) {
      return accessorNames.map(function (accessorName, index) {
        return _react2.default.createElement(
          'div',
          { key: index, className: 'Select-value', title: accessorName },
          _react2.default.createElement(
            'span',
            { className: 'Select-value-label' },
            accessorName
          )
        );
      });
    }

    /**
     * Render share column
     * @param {Object} data
     */


    /**
     * Rebder access column
     * @param {Object} data
     */

  }, {
    key: 'renderAccessRights',


    /**
     * Render table access rights
     */
    value: function renderAccessRights() {
      var _props2 = this.props,
          localization = _props2.localization,
          accessRights = _props2.content.accessRights;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'u_textBold u_paddingTopBottom' },
          localization.getText('COMMON_LABEL_ACCESS_RIGHT')
        ),
        _react2.default.createElement(
          'div',
          { className: 'u_borderAll u_borderRadius' },
          _react2.default.createElement(
            'div',
            { className: 'u_clearBoth' },
            _react2.default.createElement(
              _Izenda5.Table,
              { dataSource: accessRights, sortInfo: true },
              _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF['shareWith'], { cell: this.renderShare })),
              _react2.default.createElement(_Izenda5.Column, (0, _extends3.default)({}, TABLE_DEF['accessRights'], { cell: this.renderAccess }))
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          localization = _props3.localization,
          title = _props3.title;


      return _react2.default.createElement(
        _Izenda4.default,
        { visible: true, onClosing: this.props.onReject, type: 'none', autoClose: false, sizeClass: 'modal-lg' },
        _react2.default.createElement(_Izenda4.default.Header, { title: title }),
        _react2.default.createElement(
          _Izenda4.default.Body,
          null,
          this.renderDataInformation(),
          this.renderAccessRights()
        ),
        _react2.default.createElement(
          _Izenda4.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda4.default.ConfirmationButton,
            { key: 'accept', type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          )
        )
      );
    }
  }]);
  return DetailFilePopup;
}(_react.PureComponent), _class2.propTypes = {
  title: _propTypes2.default.string,
  content: _propTypes2.default.object,
  loadAccessRights: _propTypes2.default.array
}, _temp2)) || _class);
exports.default = DetailFilePopup;
module.exports = exports['default'];

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTab.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1172);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardTab = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(DashboardTab, _Component);

  function DashboardTab() {
    (0, _classCallCheck3.default)(this, DashboardTab);
    return (0, _possibleConstructorReturn3.default)(this, (DashboardTab.__proto__ || (0, _getPrototypeOf2.default)(DashboardTab)).apply(this, arguments));
  }

  (0, _createClass3.default)(DashboardTab, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.validation.updateErrors(this.props.store.errorMessages);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          height = _props.height,
          store = _props.store;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Izenda4.default, {
          isDashboardTab: true,
          height: height,
          dataSource: store.model.dashboards,
          saveInto: store.saveInto,
          loadCategories: store.loadCategories,
          loadSubCategories: store.loadSubCategories,
          store: store
        })
      );
    }
  }]);
  return DashboardTab;
}(_react.Component)) || _class);
exports.default = DashboardTab;
module.exports = exports['default'];

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportBar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(86);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(30);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1173);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(17);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2526);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(1174);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(136);

var _mobxReact = __webpack_require__(10);

var _fp = __webpack_require__(1);

var _Izenda16 = __webpack_require__(70);

var _Izenda17 = _interopRequireDefault(_Izenda16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportBar = (_dec = (0, _Izenda6.default)(_Izenda12.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ImportBar, _Component);

  function ImportBar() {
    (0, _classCallCheck3.default)(this, ImportBar);
    return (0, _possibleConstructorReturn3.default)(this, (ImportBar.__proto__ || (0, _getPrototypeOf2.default)(ImportBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(ImportBar, [{
    key: 'render',
    value: function render() {
      var props = this.props,
          _props = this.props,
          localization = _props.localization,
          store = _props.store,
          model = _props.store.model;

      var options = {
        baseUrl: 'importManagement/file',
        param: {
          batchId: String.newGuid()
        },
        requestHeaders: (0, _Izenda17.default)().getAuthHeader(),
        chooseAndUpload: true,
        multiple: true,
        accept: (0, _fp.join)([_Izenda15.FILE_EXTENSION.REPORT, _Izenda15.FILE_EXTENSION.DASHBOARD], ','),
        wrapperDisplay: 'inline',
        uploadSuccess: function uploadSuccess(content) {
          store.appendContent(content);
          if (!(0, _fp.isEmpty)(content.invalidFileMessages)) {
            props.openPopup(_Izenda14.default, { messages: content.invalidFileMessages, store: store });
          }
        }
      };

      return _react2.default.createElement(
        'section',
        { className: 'izenda-Wrapper-header' },
        _react2.default.createElement(_Izenda2.default, { className: 'u_marginRightInnerSpace' }),
        _react2.default.createElement(_Izenda8.default, { options: options, isHighlight: false, className: 'u_inlineBlock' }),
        _react2.default.createElement(
          'a',
          null,
          _react2.default.createElement('span', { className: 'icon-info-circled', title: localization.getText('INSTRUCTION_BROWSE_FILES') })
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-ActionBarRight' },
          _react2.default.createElement(_Izenda10.default, { type: 'checkbox', checked: model.importCategory, onChange: props.updateImportCategory }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeftInnerSpace u_textNormal u_marginBottomSmall' },
            localization.getText('IMPORT_THE_SOURCE_CATEGORY_SUBCATEGORY')
          ),
          _react2.default.createElement(
            'a',
            null,
            _react2.default.createElement('span', {
              className: 'icon-info-circled',
              title: localization.getText('TOOLTIP_IMPORT_THE_SOURCE_CATEGORY_SUBCATEGORY')
            })
          ),
          _react2.default.createElement(_Izenda10.default, { className: 'u_marginLeft', type: 'checkbox', checked: model.importAccessRights, onChange: props.updateImportAccessRights }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeftInnerSpace u_textNormal u_marginBottomSmall' },
            localization.getText('IMPORT_THE_SOURCE_ACCESS_RIGHT')
          ),
          _react2.default.createElement(
            'a',
            null,
            _react2.default.createElement('span', {
              className: 'icon-info-circled',
              title: localization.getText('TOOLTIP_IMPORT_THE_SOURCE_ACCESS_RIGHT')
            })
          ),
          _react2.default.createElement(_Izenda10.default, {
            className: 'u_marginLeft',
            type: 'checkbox',
            checked: model.importFilterValues,
            onChange: props.updateImportTheFilterValues
          }),
          _react2.default.createElement(
            'span',
            { className: 'u_marginLeftInnerSpace u_textNormal u_marginBottomSmall' },
            localization.getText('IMPORT_THE_FILTER_VALUES')
          ),
          _react2.default.createElement(
            'a',
            null,
            _react2.default.createElement('span', {
              className: 'icon-info-circled',
              title: localization.getText('TOOLTIP_IMPORT_THE_FILTER_VALUES') })
          ),
          _react2.default.createElement(_Izenda4.default, { label: localization.getText('COMMON_LABEL_IMPORT'), onClick: this.props.startImportProcess })
        )
      );
    }
  }]);
  return ImportBar;
}(_react.Component), _class2.propTypes = {
  store: _mobxReact.propTypes.observableObject
}, _temp)) || _class);
exports.default = ImportBar;
module.exports = exports['default'];

/***/ }),
/* 2525 */,
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _mobx = __webpack_require__(5);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2527);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2531);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2533);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportBarActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function openMappingErrorPopup(props, value) {
  props.openPopup(_Izenda4.default, {
    errorMessages: props.store.getErrorsPopup()
  });
}

function openImportProgressPopup(props, importFiles) {
  var store = props.store;

  return props.openPopup(_Izenda6.default, { store: store, importFiles: importFiles });
}

function startImportProcess(props, value) {
  var store = props.store,
      validation = props.validation,
      loader = props.loader;

  validation.validate().then((0, _mobx.action)(function (status) {
    store.model.activeTabKey === 'report' && (store.hasErrorOnClientSideReportTab = !status);
    store.model.activeTabKey === 'dashboard' && (store.hasErrorOnClientSideDashboardTab = !status);

    if (status) {
      loader.startLoading();
      return store.validate().then(function (result) {
        if (!(0, _fp.isNil)(result.messages)) {
          (0, _fp.some)({ key: 'dataModelConsistency' }, result.messages) ? openMappingErrorPopup(props) : validation.updateErrors(result.messages);
        } else {
          return validateOverwrite(props).then(function (_ref) {
            var success = _ref.success,
                data = _ref.data;
            return success && openImportProgressPopup(props, data);
          }).then(store.finishImport.bind(store));
        }
      }).finally(loader.endLoading.bind(loader));
    }
    return (0, _bluebird.resolve)(false);
  }));
}

/**
 * Validate overwrite reports/dashboards
 * @param {any} props
 */
function validateOverwrite(props) {
  var store = props.store;

  return store.validateOverride().then(function (overwriteInfo) {
    return (0, _fp.isEmpty)(overwriteInfo.subCategories) ? store.beginImport() : props.openPopup(_Izenda2.default, { store: store, overwriteInfo: overwriteInfo }).then(store.beginImport.bind(store));
  });
}

/**
 * Update import access rights
 * @param {Object} props
 */
function updateImportAccessRights(props, value) {
  var model = props.store.model;

  model.toggleImportAccessRights();
}

/**
 * Update import access rights
 * @param {Object} props
 */
function updateImportCategory(props, value) {
  var store = props.store;
  store.toggleImportCategory();
}

/**
 * Update import the filter values
 * @param {Object} props
 */
function updateImportTheFilterValues(props, value) {
  var model = props.store.model;

  model.toggleImportTheFilterValues();
}

var actions = (0, _recompose.withHandlers)({
  startImportProcess: (0, _fp.curry)(startImportProcess),
  updateImportAccessRights: (0, _fp.curry)(updateImportAccessRights),
  updateImportTheFilterValues: (0, _fp.curry)(updateImportTheFilterValues),
  updateImportCategory: (0, _fp.curry)(updateImportCategory)
});

exports.default = actions;
module.exports = exports['default'];

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportOverwriteConfirmationPopup.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2528);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(2530);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportOverwriteConfirmationPopup = (_dec = (0, _Izenda4.default)(_Izenda6.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ImportOverwriteConfirmationPopup, _Component);

  function ImportOverwriteConfirmationPopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ImportOverwriteConfirmationPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportOverwriteConfirmationPopup.__proto__ || (0, _getPrototypeOf2.default)(ImportOverwriteConfirmationPopup)).call.apply(_ref, [this].concat(args))), _this), _this.onClosing = function (callBack, type) {
      var overwriteOption = [];
      (0, _fp.forEach)(function (node) {
        return node.updateOverwriteOption(overwriteOption);
      }, _this.props.overwriteOptionTree);
      _this.props.onClosing(overwriteOption, type);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ImportOverwriteConfirmationPopup, [{
    key: 'renderBody',
    value: function renderBody() {
      var _props = this.props,
          localization = _props.localization,
          overwriteOptionTree = _props.overwriteOptionTree;

      var messages = (0, _fp.split)('\n', localization.getText('IMPORT_OVERWRITE_CONFIMATION_POPUP_DESCRIPTION'));

      return _react2.default.createElement(
        'div',
        { className: 'izenda-ImportOverwriteConfirmationPopup' },
        (0, _fp.map)(function (message) {
          return _react2.default.createElement(
            'div',
            { key: (0, _fp.uniqueId)('mes') },
            _react2.default.createElement(
              'label',
              null,
              message
            )
          );
        }, messages),
        _react2.default.createElement(_Izenda8.default, { overwriteOptionTree: overwriteOptionTree })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var localization = props.localization;


      return _react2.default.createElement(
        _Izenda2.default,
        { visible: true, onClosing: this.onClosing, type: 'none', autoClose: false },
        _react2.default.createElement(_Izenda2.default.Header, {
          tooltip: localization.getText('IMPORT_OVERWRITE_CONFIMATION_POPUP_TOOLTIP'),
          title: localization.getText('IMPORT_OVERWRITE_CONFIMATION_POPUP_TITLE')
        }),
        _react2.default.createElement(
          _Izenda2.default.Body,
          null,
          this.renderBody()
        ),
        _react2.default.createElement(
          _Izenda2.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda2.default.ConfirmationButton,
            { key: 'accept', type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda2.default.ConfirmationButton,
            { key: 'cancel', type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return ImportOverwriteConfirmationPopup;
}(_react.Component), _class2.propTypes = {
  overwriteOptionTree: _mobxReact.propTypes.arrayOrObservableArray
}, _temp2)) || _class);
exports.default = ImportOverwriteConfirmationPopup;
module.exports = exports['default'];

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2529);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportOverwriteConfirmationPopupAction.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function onClosing(props, overwriteOption, type) {
  type === 'accept' ? props.onAccept(overwriteOption) : props.onReject();
}

function convertToTree(overwriteInfo) {
  return (0, _mobx.observable)([new _Izenda2.default(overwriteInfo)]);
}

exports.default = (0, _recompose.compose)((0, _recompose.withHandlers)({
  onClosing: (0, _fp.curry)(onClosing)
}), (0, _recompose.withProps)(function (_ref) {
  var overwriteInfo = _ref.overwriteInfo;
  return { overwriteOptionTree: convertToTree(overwriteInfo) };
}));
module.exports = exports['default'];

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportOverwriteTreeNode.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportOverwriteTreeNode = (_class = function () {
  (0, _createClass3.default)(ImportOverwriteTreeNode, [{
    key: 'checked',
    get: function get() {
      return (0, _fp.isEmpty)(this.childs) ? this.selfChecked : (0, _fp.every)('checked', this.childs);
    }
  }, {
    key: 'isLeafNode',
    get: function get() {
      return (0, _fp.isEmpty)(this.childs);
    }
  }, {
    key: 'indeterminate',
    get: function get() {
      if ((0, _fp.some)('indeterminate', this.childs)) {
        return true;
      }
      var count = (0, _fp.size)((0, _fp.filter)('checked', this.childs));
      return !this.isLeafNode && count !== 0 && count !== (0, _fp.size)(this.childs);
    }
  }]);

  function ImportOverwriteTreeNode(node, parentNode) {
    (0, _classCallCheck3.default)(this, ImportOverwriteTreeNode);

    _initDefineProp(this, 'selfChecked', _descriptor, this);

    _initDefineProp(this, 'childs', _descriptor2, this);

    this.key = '';
    this.destinationId = null;
    this.name = null;
    this.fileKey = null;

    this.setData(node, parentNode);
  }

  /**
   * Set data
   * @param {any} node
   * @param {any} parentNode
   */


  (0, _createClass3.default)(ImportOverwriteTreeNode, [{
    key: 'setData',
    value: function setData(node, parentNode) {
      var _this = this;

      this.name = node.name;
      this.destinationId = node.destinationId;
      this.fileKey = node.fileKey;
      this.key = (0, _fp.getOr)('Root', 'key', parentNode) + '_' + this.name;
      this.childs = (0, _fp.map)(function (child) {
        return new ImportOverwriteTreeNode(child, _this);
      }, (0, _fp.concat)(node.objects || [], node.subCategories || []));
    }

    /**
     * Change status of this node and its child nodes
     * @param {boolean} checked
     */

  }, {
    key: 'changeNodeStatus',
    value: function changeNodeStatus(checked) {
      this.selfChecked = checked;
      (0, _fp.forEach)(function (node) {
        return node.changeNodeStatus(checked);
      }, this.childs);
    }

    /**
     * Update selected overwrite option
     * @param {Array<any>} previousOption
     */

  }, {
    key: 'updateOverwriteOption',
    value: function updateOverwriteOption(previousOption) {
      if (this.isLeafNode) {
        previousOption.push({ fileKey: this.fileKey, destinationId: this.destinationId, isOverwrite: this.checked });
      } else {
        (0, _fp.forEach)(function (child) {
          return child.updateOverwriteOption(previousOption);
        }, this.childs);
      }
      return previousOption;
    }
  }]);
  return ImportOverwriteTreeNode;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'selfChecked', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'childs', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'checked', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'checked'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isLeafNode', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isLeafNode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'indeterminate', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'indeterminate'), _class.prototype)), _class);
exports.default = ImportOverwriteTreeNode;
module.exports = exports['default'];

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportOverwriteInfoTree.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(172);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(62);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportOverwriteOptionTree = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ImportOverwriteOptionTree, _Component);

  function ImportOverwriteOptionTree() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ImportOverwriteOptionTree);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportOverwriteOptionTree.__proto__ || (0, _getPrototypeOf2.default)(ImportOverwriteOptionTree)).call.apply(_ref, [this].concat(args))), _this), _this.renderNode = function (node, toggleIcon) {
      var onChange = function onChange(e) {
        node.changeNodeStatus(e.target.checked);
      };

      var textClassName = (0, _classnames2.default)({ unchecked: !node.checked && node.isLeafNode });

      return _react2.default.createElement(
        'div',
        { className: 'checkbox u_noMarginAll' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement(_Izenda6.default, { type: 'checkbox', checked: node.checked, onChange: onChange, indeterminate: node.indeterminate }),
          _react2.default.createElement(_Izenda8.default, {
            className: textClassName,
            text: node.name,
            tooltip: node.name
          }),
          node.checked && node.isLeafNode && _react2.default.createElement('span', { className: 'icon-ok checked' })
        ),
        toggleIcon
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ImportOverwriteOptionTree, [{
    key: 'render',
    value: function render() {
      var overwriteOptionTree = this.props.overwriteOptionTree;

      return _react2.default.createElement(
        'div',
        { className: 'tree-content u_borderAll' },
        _react2.default.createElement(_Izenda4.default, {
          nodes: overwriteOptionTree,
          getKey: (0, _fp.get)('key'),
          getChildNodes: (0, _fp.get)('childs'),
          renderNode: this.renderNode,
          collapsed: false
        })
      );
    }
  }]);
  return ImportOverwriteOptionTree;
}(_react.Component), _class2.propTypes = {
  overwriteOptionTree: _mobxReact.propTypes.arrayOrObservableArray.isRequired
}, _temp2)) || _class);
exports.default = ImportOverwriteOptionTree;
module.exports = exports['default'];

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingErrorPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2532);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MappingErrorPopup = (_dec = (0, _Izenda6.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MappingErrorPopup, _Component);

  function MappingErrorPopup() {
    (0, _classCallCheck3.default)(this, MappingErrorPopup);
    return (0, _possibleConstructorReturn3.default)(this, (MappingErrorPopup.__proto__ || (0, _getPrototypeOf2.default)(MappingErrorPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(MappingErrorPopup, [{
    key: 'renderPopupBody',
    value: function renderPopupBody() {
      var _props = this.props,
          localization = _props.localization,
          errorMessages = _props.errorMessages;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'u_paddingRight u_paddingBottom' },
          _react2.default.createElement(
            'div',
            null,
            localization.getText('IMPORT_MAPPING_ERROR_INCONSISTENT_DATA')
          ),
          _react2.default.createElement(
            'div',
            { className: 'u_marginTop' },
            localization.getText('IMPORT_MAPPING_ERROR_GUIDES')
          )
        ),
        _react2.default.createElement(_Izenda4.default, { errorMessages: errorMessages })
      );
    }
  }, {
    key: 'renderPopupFooter',
    value: function renderPopupFooter() {
      var localization = this.props.localization;

      return _react2.default.createElement(
        _Izenda2.default.ConfirmationButton,
        { key: 'accept', type: 'accept' },
        localization.getText('COMMON_LABEL_OK')
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var localization = this.props.localization;

      return _react2.default.createElement(
        _Izenda2.default,
        { visible: true, onClosing: this.props.onReject, type: 'none', autoClose: false, sizeClass: 'modal-lg' },
        _react2.default.createElement(_Izenda2.default.Header, { title: localization.getText('IMPORT_MAPPING_ERROR_POPUP_TITLE') }),
        _react2.default.createElement(
          _Izenda2.default.Body,
          null,
          this.renderPopupBody()
        ),
        _react2.default.createElement(
          _Izenda2.default.Footer,
          null,
          this.renderPopupFooter()
        )
      );
    }
  }]);
  return MappingErrorPopup;
}(_react.Component), _class2.propTypes = {
  errorMessages: _propTypes2.default.array
}, _temp)) || _class);
exports.default = MappingErrorPopup;
module.exports = exports['default'];

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingErrorTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIO

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(172);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MappingErrorTree = (_dec = (0, _Izenda4.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MappingErrorTree, _Component);

  function MappingErrorTree() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MappingErrorTree);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MappingErrorTree.__proto__ || (0, _getPrototypeOf2.default)(MappingErrorTree)).call.apply(_ref, [this].concat(args))), _this), _this.getChildNodes = function (node) {
      if (node.report) return node.errors;
      if (node.dashboard) return node.dashboard.reports;
      return [];
    }, _this.renderNode = function (node, toggleIcon) {
      if (!node.report && !node.dashboard) {
        return _this.renderErrorMessage(node);
      }
      return _this.renderErrorLocation(node, toggleIcon);
    }, _this.nodeExpand = function () {
      return true;
    }, _this.getKey = function () {
      return (0, _fp.uniqueId)('MappingErrorTree_');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * @param {Object} node
   * @returns {Array}
   */


  (0, _createClass3.default)(MappingErrorTree, [{
    key: 'renderErrorMessage',


    /**
     * Render error messages
     * @param {Object} node
     */
    value: function renderErrorMessage(node) {
      var fieldStart = node.indexOf('[');
      var fieldEnd = node.indexOf(']');

      var field = node.substring(fieldStart + 1, fieldEnd);
      var type = node.substring(0, fieldStart);
      var others = node.substring(fieldEnd + 2);

      return _react2.default.createElement(
        'label',
        { className: 'u_marginLeftInnerSpace' },
        type,
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            { className: 'u_marginRightInnerSpace' },
            field
          ),
          others
        )
      );
    }

    /**
     * Render error messages
     * @param {Object} node
     * @param {Object} toggleIcon
     */

  }, {
    key: 'renderErrorLocation',
    value: function renderErrorLocation(node, toggleIcon) {
      var localization = this.props.localization;


      var textError = node.report ? localization.getText('CONTEXT_MENU_LABEL_REPORT') + ': ' + node.report : localization.getText('CONTEXT_MENU_LABEL_DASHBOARD') + ': ' + node.dashboard.dashboard;

      return _react2.default.createElement(
        'div',
        null,
        toggleIcon,
        _react2.default.createElement(
          'label',
          { className: 'u_marginLeftInnerSpace' },
          textError
        )
      );
    }

    /**
     * Set node always expands
     * @returns {boolean}
     */


    /**
     * Create uniqueId for node
     * @returns {string}
     */

  }, {
    key: 'render',
    value: function render() {
      var errorMessages = this.props.errorMessages;


      return _react2.default.createElement(
        'div',
        { className: 'u_fullSize u_borderAll izenda-MappingError-tree' },
        _react2.default.createElement(_Izenda2.default, {
          collapsed: false,
          nodes: errorMessages,
          getKey: this.getKey,
          renderNode: this.renderNode,
          getChildNodes: this.getChildNodes,
          nodeExpand: this.nodeExpand
        })
      );
    }
  }]);
  return MappingErrorTree;
}(_react.Component), _class2.propTypes = {
  errorMessages: _propTypes2.default.array
}, _temp2)) || _class);
exports.default = MappingErrorTree;
module.exports = exports['default'];

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressPopup.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(36);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2534);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2536);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _mobx = __webpack_require__(5);

var _Izenda9 = __webpack_require__(30);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportProgressPopup = (_dec = (0, _Izenda4.default)(_Izenda6.default), _dec(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(ImportProgressPopup, _Component);

  function ImportProgressPopup(props) {
    (0, _classCallCheck3.default)(this, ImportProgressPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImportProgressPopup.__proto__ || (0, _getPrototypeOf2.default)(ImportProgressPopup)).call(this, props));

    _initDefineProp(_this, 'importProgressList', _descriptor, _this);

    _initDefineProp(_this, 'isImportProcessCompleted', _descriptor2, _this);

    _initDefineProp(_this, 'isClickCancelBefore', _descriptor3, _this);

    _initDefineProp(_this, 'updateStatus', _descriptor4, _this);

    _this.onClickCancel = function () {
      _this.isClickCancelBefore = true;
      clearInterval(_this.getStatusInterval);
      _this.props.onCancelImport(_this.importProgressList).then(function () {
        _this.isImportProcessCompleted = true;
      });
    };

    _this.onClickOk = function () {
      _this.props.onClosing(_this.importProgressList);
    };

    var importFiles = _this.props.importFiles;

    _this.importProgressList = _this.props.convertToImportProgressList(importFiles);
    return _this;
  }

  (0, _createClass3.default)(ImportProgressPopup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getStatusInterval = setInterval(this.updateStatus, _Izenda11.IMPORT_STATUS_REFRESH_INTERVAL);
    }

    /**
     * Update import status
     */


    /**
     * On click cancel button
     */


    /**
     * On click ok button
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.getStatusInterval);
    }
  }, {
    key: 'render',
    value: function render() {
      var localization = this.props.localization;


      return _react2.default.createElement(
        _Izenda2.default,
        { visible: true, type: 'none', autoClose: false },
        _react2.default.createElement(_Izenda2.default.Header, { showCloseButton: false, title: localization.getText('IMPORT_PROGRESS_POPUP_TITLE') }),
        _react2.default.createElement(
          _Izenda2.default.Body,
          null,
          _react2.default.createElement(_Izenda8.default, { importProgressList: this.importProgressList })
        ),
        _react2.default.createElement(
          _Izenda2.default.Footer,
          null,
          _react2.default.createElement(_Izenda2.default.ConfirmationButton, {
            disabled: !this.isImportProcessCompleted,
            onClick: this.onClickOk,
            label: localization.getText('COMMON_LABEL_OK')
          }),
          _react2.default.createElement(_Izenda2.default.ConfirmationButton, {
            disabled: this.isClickCancelBefore || this.isImportProcessCompleted,
            onClick: this.onClickCancel,
            label: localization.getText('IMPORT_PROGRESS_POPUP_CANCEL_IMPORT')
          })
        )
      );
    }
  }]);
  return ImportProgressPopup;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'importProgressList', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isImportProcessCompleted', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'isClickCancelBefore', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'updateStatus', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.props.updateImportStatus(_this2.importProgressList).then(function (completed) {
        if (completed) {
          clearInterval(_this2.getStatusInterval);
          _this2.isImportProcessCompleted = true;
        }
      });
    };
  }
})), _class2)) || _class);
exports.default = ImportProgressPopup;
module.exports = exports['default'];

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2535);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(630);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * On closing popup
 * @param {Object} props 
 * @param {Array} importProgressList 
 */
function onClosing(props, importProgressList) {
  props.onAccept(importProgressList);
}

/**
 * On cancel import process
 * @param {Object} props 
 * @param {Array} importProgressList 
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressPopupAction.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function onCancelImport(props, importProgressList) {
  var store = props.store;

  var data = (0, _fp.map)('id', importProgressList);
  return store.cancelImport(data).then(function (result) {
    setNewImportStatus(result, importProgressList);
  });
}

/**
 * Update import status
 * @param {Object} props 
 * @param {Array} importProgressList 
 */
function updateImportStatus(props, importProgressList) {
  var data = (0, _fp.map)('id', importProgressList);
  return _Izenda4.default.getImportStatus(data).then(function (result) {
    setNewImportStatus(result, importProgressList);
    return (0, _fp.every)(function (item) {
      return item.status === _Izenda5.ImportStatus.SUCCESS.value || item.status === _Izenda5.ImportStatus.FAILED.value;
    }, importProgressList);
  });
}

/**
 * Set new import status for each file
 * @param {Array} result 
 * @param {Array} importProgressList 
 */
function setNewImportStatus(result, importProgressList) {
  (0, _fp.forEach)(function (item) {
    var matchedItem = (0, _fp.find)(function (newItem) {
      return newItem.id === item.id;
    }, result);
    matchedItem && (item.status = matchedItem.status);
  }, importProgressList);
}

/**
 * Convert array file to import progress list
 * @param {Object} props 
 * @param {Array} fileList 
 */
function convertToImportProgressList(props, fileList) {
  return (0, _fp.map)(function (file) {
    return new _Izenda2.default(file);
  }, fileList);
}

exports.default = (0, _recompose.withHandlers)({
  onClosing: (0, _fp.curry)(onClosing),
  onCancelImport: (0, _fp.curry)(onCancelImport),
  updateImportStatus: (0, _fp.curry)(updateImportStatus),
  convertToImportProgressList: (0, _fp.curry)(convertToImportProgressList)
});
module.exports = exports['default'];

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressItem.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportProgressItem = (_class = function () {
  function ImportProgressItem(data) {
    (0, _classCallCheck3.default)(this, ImportProgressItem);

    _initDefineProp(this, 'status', _descriptor, this);

    _initDefineProp(this, 'errorCode', _descriptor2, this);

    this.objectName = null;
    this.id = null;
    this.fileKey = null;

    this.setData(data);
  }

  (0, _createClass3.default)(ImportProgressItem, [{
    key: 'setData',
    value: function setData(data) {
      this.objectName = data.objectName;
      this.status = data.status;
      this.errorCode = data.errorCode;
      this.id = data.id;
      this.fileKey = data.fileKey;
    }
  }]);
  return ImportProgressItem;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'status', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'errorCode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setData'), _class.prototype)), _class);
exports.default = ImportProgressItem;
module.exports = exports['default'];

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressList.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(13);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(136);

var _Izenda4 = __webpack_require__(27);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(2537);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _mobxReact = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportProgressList = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(ImportProgressList, _Component);

  function ImportProgressList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ImportProgressList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportProgressList.__proto__ || (0, _getPrototypeOf2.default)(ImportProgressList)).call.apply(_ref, [this].concat(args))), _this), _this.isScrollBoxDirty = false, _this.setScrollBox = function (dom) {
      _this.scrollBox = dom;
    }, _this.onScroll = function () {
      _this.isScrollBoxDirty = true;
    }, _this.onUpdateStatus = function (dom) {
      if (!_this.isScrollBoxDirty) {
        var currentScrollTop = _this.scrollBox.getScrollTop();
        var itemOffsetTop = dom.offsetTop;
        itemOffsetTop > currentScrollTop && _this.scrollBox.scrollTo({ left: 0, top: itemOffsetTop });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ImportProgressList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var importProgressList = this.props.importProgressList;


      return _react2.default.createElement(
        _Izenda5.default,
        {
          ref: this.setScrollBox,
          viewClassName: 'izenda-ImportProgressPopup',
          autoHeight: true,
          autoHeightMax: _Izenda3.IMPORT_PROGRESS_LIST_MAX_HEIGHT,
          triggerOnScrollWhenScrollTo: false,
          onScroll: this.onScroll
        },
        _react2.default.createElement(
          _Izenda2.default,
          { className: 'izenda-ImportProgressList' },
          importProgressList.map(function (item) {
            return _react2.default.createElement(_Izenda7.default, { key: (0, _fp.uniqueId)(), onUpdateStatus: _this2.onUpdateStatus, item: item });
          })
        )
      );
    }
  }]);
  return ImportProgressList;
}(_react.Component)) || _class;

exports.default = ImportProgressList;
module.exports = exports['default'];

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressViewItem.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(68);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(136);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(10);

var _Izenda4 = __webpack_require__(13);

var _Izenda5 = _interopRequireDefault(_Izenda4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportProgressViewItem = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(ImportProgressViewItem, _Component);

  function ImportProgressViewItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ImportProgressViewItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportProgressViewItem.__proto__ || (0, _getPrototypeOf2.default)(ImportProgressViewItem)).call.apply(_ref, [this].concat(args))), _this), _this.setRef = function (dom) {
      _this.dom = dom;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ImportProgressViewItem, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var status = this.props.item.status;


      if (status === _Izenda3.ImportStatus.SUCCESS.value || status === _Izenda3.ImportStatus.FAILED.value) {
        this.props.onUpdateStatus(this.dom);
      }
    }

    /**
     * Get file status description
     * @param {number} status 
     */

  }, {
    key: 'getStatusDescription',
    value: function getStatusDescription(status) {
      switch (status) {
        case _Izenda3.ImportStatus.SUCCESS.value:
          return _Izenda3.ImportStatus.SUCCESS.label;
        case _Izenda3.ImportStatus.FAILED.value:
          return _Izenda3.ImportStatus.FAILED.label;
        default:
          return _Izenda3.ImportStatus.NOT_PROCESSED.label;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$item = this.props.item,
          status = _props$item.status,
          objectName = _props$item.objectName;

      var iconClassName = (0, _classnames2.default)({
        'icon-ok-circled success': status === _Izenda3.ImportStatus.SUCCESS.value,
        'icon-cancel-circled failed': status === _Izenda3.ImportStatus.FAILED.value
      });

      var statusDescription = this.getStatusDescription(status);

      return _react2.default.createElement(
        'div',
        { ref: this.setRef },
        _react2.default.createElement(
          _Izenda5.default.Row,
          { className: 'izenda-ImportProgressItem u_noMarginAll' },
          _react2.default.createElement(
            _Izenda5.default.Col,
            { cols: '4' },
            _react2.default.createElement(_Izenda2.default, { tooltip: objectName, text: objectName })
          ),
          _react2.default.createElement(
            _Izenda5.default.Col,
            { cols: '1' },
            _react2.default.createElement('span', { className: iconClassName })
          ),
          _react2.default.createElement(
            _Izenda5.default.Col,
            { cols: '7' },
            _react2.default.createElement(_Izenda2.default, { tooltip: statusDescription, text: statusDescription })
          )
        )
      );
    }
  }]);
  return ImportProgressViewItem;
}(_react.Component)) || _class;

exports.default = ImportProgressViewItem;
module.exports = exports['default'];

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = __webpack_require__(5);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(2539);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(194);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(78);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2543);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actions = (0, _recompose.compose)((0, _recompose.withProps)(function () {
  return {
    store: new _Izenda2.default(),
    originalOnPageHide: window.onpagehide
  };
}), (0, _recompose.withHandlers)({
  canChangeTab: (0, _fp.curry)(canChangeTab)
}), (0, _Izenda8.default)({
  onbeforeunload: registerOnBeforeUnloadHandler,
  onpagehide: registerOnPageHideHandler,
  onlistenbefore: registerOnBackHandler,
  onpageshow: registerOnPageShowHandler
}));

/**
 * Validate before change tabs.
 * @param {Object} props
 * @param {Object} value
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function canChangeTab(props, value) {
  var validation = props.validation,
      store = props.store;


  return validation.validate().then((0, _mobx.action)(function (status) {
    store.model.activeTabKey === 'report' && (store.hasErrorOnClientSideReportTab = !status);
    store.model.activeTabKey === 'dashboard' && (store.hasErrorOnClientSideDashboardTab = !status);

    if (status) {
      if (store.hasErrorReportTab && store.model.activeTabKey === 'report') {
        validation.updateErrors(store.errorMessages);
        return false;
      }

      if (store.hasErrorDashboardTab && store.model.activeTabKey === 'dashboard') {
        validation.updateErrors(store.errorMessages);
        return false;
      }

      return true;
    }

    validation.updateErrors(store.errorMessages);
    return false;
  }));
}

/**
 * Custom onBeforeUnload handler.
 */
function registerOnBeforeUnloadHandler() {
  var _props = this.props,
      store = _props.store,
      localization = _props.localization;

  return function () {
    return store.checkDirty() ? localization.getText('IMPORT_CONFORM_REMOVE_ALL_FILE') : null;
  };
}

/**
 * Custom onPageHide handler.
 */
function registerOnPageHideHandler() {
  var props = this.props,
      store = this.props.store;

  return function () {
    store.checkDirty() && store.removeFilesSync();
    props.originalOnPageHide && props.originalOnPageHide();
  };
}

/**
 * Register back handler.
 */
function registerOnBackHandler() {
  var props = this.props,
      _props2 = this.props,
      store = _props2.store,
      localization = _props2.localization,
      authorization = _props2.authorization;

  var _getHistory = (0, _Izenda4.default)(authorization.isIntegrationMode()),
      synergyHistory = _getHistory.synergyHistory;

  return synergyHistory.listenBefore(function (location) {
    if (location.action === 'POP') {
      if (!store.checkDirty()) return true;
      props.confirmDirtyForm(true, {
        customMessage: localization.getText('IMPORT_CONFORM_REMOVE_ALL_FILE'),
        onConfirmDirtyForm: store.onOkDirtyForm.bind(store)
      }).then(synergyHistory.goBack);
      return false;
    }
  });
}

/**
 * Register onPageShow handler.
 */
function registerOnPageShowHandler() {
  return function (event) {
    if (_Izenda6.default.isSafariBrowser() && event && event.persisted) {
      window.location.reload();
    }
  };
}

exports.default = actions;
module.exports = exports['default'];

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__(20);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _defineProperty4 = __webpack_require__(94);

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2540);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(191);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(630);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(227);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(104);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(111);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(192);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(118);

var _Izenda16 = __webpack_require__(15);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _fp = __webpack_require__(1);

var _Izenda18 = __webpack_require__(34);

var _Izenda19 = __webpack_require__(1175);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(12);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(54);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty3.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportStore = (0, _Izenda24.default)(_class = (_class2 = function () {
  function ImportStore() {
    var _this = this;

    (0, _classCallCheck3.default)(this, ImportStore);

    _initDefineProp(this, 'model', _descriptor, this);

    _initDefineProp(this, 'saveInto', _descriptor2, this);

    this.reportLocalCategories = { categories: (0, _mobx.observable)([]), isLastPage: false };
    this.templateLocalCategories = { categories: (0, _mobx.observable)([]), isLastPage: false };
    this.reportGlobalCategories = { categories: (0, _mobx.observable)([]), isLastPage: false };
    this.templateGlobalCategories = { categories: (0, _mobx.observable)([]), isLastPage: false };
    this.dashboardLocalCategories = { categories: (0, _mobx.observable)([]), isLastPage: false };
    this.dashboardGlobalCategories = { categories: (0, _mobx.observable)([]), isLastPage: false };

    _initDefineProp(this, 'databaseNamesTo', _descriptor3, this);

    _initDefineProp(this, 'showErrorMessages', _descriptor4, this);

    _initDefineProp(this, 'hasErrorOnServerSideReportTab', _descriptor5, this);

    _initDefineProp(this, 'hasErrorOnClientSideReportTab', _descriptor6, this);

    _initDefineProp(this, 'hasErrorOnServerSideDashboardTab', _descriptor7, this);

    _initDefineProp(this, 'hasErrorOnClientSideDashboardTab', _descriptor8, this);

    this.tempSubCategories = [];
    this.errorMessages = [];

    this.checkDirty = function () {
      return _this.isDirty;
    };

    this.model = new _Izenda2.default();
    this.initial();
    this.didOverwriteHandles = false;
  }

  (0, _createClass3.default)(ImportStore, [{
    key: 'initial',
    value: function initial() {
      var _this2 = this;

      _Izenda10.default.loadCategorySettings().bind(this).then((0, _mobx.action)(function (result) {
        _this2.saveInto = result;
      }));
      this.getDatabaseNamesTo();
      _Izenda17.default.setCheckDirtyFunction(this.checkDirty, this.onOkDirtyForm.bind(this), _Izenda22.default.getText('IMPORT_CONFORM_REMOVE_ALL_FILE'));
    }

    /**
     * Reset data
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.resetDirty();
      this.model = new _Izenda2.default();
      this.saveInto = null;

      this.resetCategories(this.reportLocalCategories);
      this.resetCategories(this.reportGlobalCategories);
      this.resetCategories(this.templateLocalCategories);
      this.resetCategories(this.templateGlobalCategories);
      this.resetCategories(this.dashboardLocalCategories);
      this.resetCategories(this.dashboardGlobalCategories);

      this.resetArray(this.databaseNamesTo);
      this.errorMessages = [];
      this.showErrorMessages = false;

      this.hasErrorOnClientSideReportTab = false;
      this.hasErrorOnServerSideReportTab = false;
      this.hasErrorOnClientSideDashboardTab = false;
      this.hasErrorOnServerSideDashboardTab = false;

      this.resetArray(this.tempSubCategories);

      this.initial();
    }

    /**
     * Reset categories
     * @param {Object} category
     */

  }, {
    key: 'resetCategories',
    value: function resetCategories(category) {
      this.resetArray(category.categories);
      category.isLastPage = false;
    }

    /**
     * Reset array
     * @param {Array} arr
     */

  }, {
    key: 'resetArray',
    value: function resetArray(arr) {
      !(0, _fp.isEmpty)(arr) && arr.splice(0, arr.length);
    }

    /**
     * Populate content for import page
     * @param {Object} content
     */

  }, {
    key: 'createImportContent',
    value: function createImportContent(content) {
      var localCategoryId = (0, _fp.find)({ isGlobal: false }, this.saveInto).id;
      this.model.create(content, localCategoryId);
      this.showErrorMessages = !(0, _fp.isEmpty)(this.model.invalidFileMessages) || content.hasInvalidFile;
      this.loadInitialCategories();
      this.getDatabaseNamesTo();
      this.markDirty();
    }

    /**
     * Append data
     * @param {Object} content
     */

  }, {
    key: 'appendContent',
    value: function appendContent(content) {
      var importSourceCat = (0, _fp.get)('model.importSourceCat', this);
      var localCategoryId = (0, _fp.find)({ isGlobal: false }, this.saveInto).id;
      var newFiles = this.model.appendContent(content, localCategoryId);
      this.loadInitialCategories();
      if (importSourceCat) {
        this.updateSourceCategoryForImportFiles(newFiles);
      }
    }

    /**
     * Get data for database names
     */

  }, {
    key: 'getDatabaseNamesTo',
    value: function getDatabaseNamesTo() {
      var _this3 = this;

      // Get all items, not for lazyloading
      var requestData = {
        skipItems: -1,
        tenantId: _Izenda17.default.tenantId
      };

      _Izenda4.default.getConnectionInfo(requestData).bind(this).then((0, _mobx.action)(function (response) {
        _this3.databaseNamesTo = response.result;
      }));
    }

    /**
     * Load initial data for categories
     */

  }, {
    key: 'loadInitialCategories',
    value: function loadInitialCategories() {
      var _this4 = this;

      var data = [].concat((0, _toConsumableArray3.default)(this.model.reports), (0, _toConsumableArray3.default)(this.model.dashboards));
      (0, _fp.forEach)(function (d) {
        if (d.isReport) {
          _this4.processReportCategories(d);
        } else {
          _this4.processDashboardCategories(d);
        }
      }, data);
    }

    /**
     * Process report categories
     * @param {Object} report
     * @return {Promise}
     */

  }, {
    key: 'processReportCategories',
    value: function processReportCategories(report) {
      var contentType = (0, _fp.get)('content.type', report);
      var category = this.getReportCategoriesInfo(report.content, contentType);
      if ((0, _fp.isEmpty)(category.categories)) {
        return this.loadReportTemplateCategories(report);
      } else {
        report.categories = category.categories;
        report.isLastPage = category.isLastPage;
        return (0, _bluebird.resolve)();
      }
    }

    /**
     * Process dashboard categories
     * @param {Object} dashboard
     * @return {Promise}
     */

  }, {
    key: 'processDashboardCategories',
    value: function processDashboardCategories(dashboard) {
      var category = this.getDashboardCategoriesInfo(dashboard.content);
      if ((0, _fp.isEmpty)(category.categories)) {
        return this.loadDashboardCategories(dashboard);
      } else {
        dashboard.categories = category.categories;
        dashboard.isLastPage = category.isLastPage;
        return (0, _bluebird.resolve)();
      }
    }

    /**
     * Import the files
     * @param {Array<any>} overwriteOption
     * @return {Promise}
     */

  }, {
    key: 'beginImport',
    value: function beginImport(overwriteOption) {
      var data = this.model.buildData();

      // Do not import non overwrite files
      var removeFunction = (0, _fp.remove)(function (report) {
        var matchedItem = (0, _fp.find)(function (_ref) {
          var fileKey = _ref.fileKey;
          return fileKey === report.id;
        }, overwriteOption);
        return !!matchedItem && !matchedItem.isOverwrite;
      });

      data.reports = removeFunction(data.reports);
      data.dashboards = removeFunction(data.dashboards);

      // Do not call import API when there is no file to import
      if ((0, _fp.isEmpty)(data.reports) && (0, _fp.isEmpty)(data.dashboards)) {
        return (0, _bluebird.resolve)([]);
      }

      // Append overwrite option
      var postData = (0, _fp.extend)(data, {
        overwriteOption: (0, _fp.reduce)(function (option, item) {
          return (0, _fp.extend)(option, (0, _defineProperty5.default)({}, item.destinationId, item.isOverwrite));
        }, {}, overwriteOption)
      });
      return _Izenda6.default.importFiles(postData);
    }

    /**
     * Finish import, clean up files
     * @param {Array} importFiles
     */

  }, {
    key: 'finishImport',
    value: function finishImport(importFiles) {
      var completedFileIds = (0, _fp.flow)((0, _fp.filter)(function (_ref2) {
        var status = _ref2.status;
        return status === _Izenda25.ImportStatus.SUCCESS.value || status === _Izenda25.ImportStatus.FAILED.value;
      }), (0, _fp.map)('fileKey'))(importFiles);

      this.model.removeCompletedFiles(completedFileIds);
      return this.updateDatabaseMappings();
    }

    /**
     * Update database mappings
     */

  }, {
    key: 'updateDatabaseMappings',
    value: function updateDatabaseMappings() {
      var _this5 = this;

      return this.getDatabaseMappings().then(function (databaseMappings) {
        (0, _fp.isEmpty)(_this5.model.reports) && (0, _fp.isEmpty)(_this5.model.dashboards) && _this5.reset();

        var _loop = function _loop() {
          var _model$databaseMappin = _this5.model.databaseMappings[i],
              fromDatabaseName = _model$databaseMappin.fromDatabaseName,
              fromSchema = _model$databaseMappin.fromSchema,
              serverType = _model$databaseMappin.serverType;

          if (!(0, _fp.some)(function (currentMapping) {
            return (0, _fp.toLower)(fromDatabaseName) === (0, _fp.toLower)(currentMapping.fromDatabaseName) && (0, _fp.toLower)(fromSchema) === (0, _fp.toLower)(currentMapping.fromSchema) && (0, _fp.toLower)(serverType) === (0, _fp.toLower)(currentMapping.serverType);
          }, databaseMappings)) {
            _this5.updateErrorMessages(i, ['toDatabaseName'], '');
          }
        };

        for (var i = 0; i < _this5.model.databaseMappings.length; i++) {
          _loop();
        }

        _this5.model.updateDatabaseMappings(databaseMappings);
      });
    }

    /**
     * Cancel import progress
     * @param {Array} data
     */

  }, {
    key: 'cancelImport',
    value: function cancelImport(data) {
      return _Izenda6.default.cancelImport(data);
    }

    /**
     * Get database mappings
     */

  }, {
    key: 'getDatabaseMappings',
    value: function getDatabaseMappings() {
      return _Izenda6.default.getDatabaseMappings(this.model.fileIds);
    }

    /**
     * Get temporary report categories info.
     * @param {Object} report
     * @returns {Object} category
     */

  }, {
    key: 'getReportCategoriesInfo',
    value: function getReportCategoriesInfo(_ref3) {
      var isGlobal = _ref3.isGlobal,
          type = _ref3.type;

      if (isGlobal) {
        if (type === 0) {
          return this.reportGlobalCategories;
        } else {
          return this.templateGlobalCategories;
        }
      } else {
        if (type === 0) {
          return this.reportLocalCategories;
        } else {
          return this.templateLocalCategories;
        }
      }
    }

    /**
     * Get temporary dashboard categories info.
     * @param {Object} dashboard
     * @returns {Object} category
     */

  }, {
    key: 'getDashboardCategoriesInfo',
    value: function getDashboardCategoriesInfo(_ref4) {
      var isGlobal = _ref4.isGlobal;

      if (isGlobal) {
        return this.dashboardGlobalCategories;
      } else {
        return this.dashboardLocalCategories;
      }
    }

    /**
     * Lazy loading data for report or template categories
     * @param {Object} report
     * @param {Object} pageInfo
     * @return {Promise}
     */

  }, {
    key: 'loadReportTemplateCategories',
    value: function loadReportTemplateCategories(report) {
      var contentType = (0, _fp.get)('content.type', report);
      var category = this.getReportCategoriesInfo(report.content, contentType);
      var saveIntoId = report.saveIntoId || (0, _fp.find)({ isGlobal: false }, this.saveInto).id;

      var request = {
        skipItems: -1,
        type: contentType,
        parentIds: [saveIntoId],
        tenantId: _Izenda17.default.tenantId
      };

      report.categories = category.categories;

      return _Izenda12.default.loadLazyLoadingAllowedSavingCategories(request).bind(this).then((0, _mobx.action)(function (response) {
        (0, _Izenda15.concatArray)(report.categories, response.data, 'id');
      }));
    }

    /**
     * Lazy loading for dashboard categories
     * @param {Object} dashboard
     * @param {Object} pageInfo
     * @return {Promise}
     */

  }, {
    key: 'loadDashboardCategories',
    value: function loadDashboardCategories(dashboard) {
      var _this6 = this;

      var saveIntoId = dashboard.saveIntoId || (0, _fp.find)({ isGlobal: false }, this.saveInto).id;
      var request = {
        skipItems: -1,
        type: dashboard.content.type,
        includeUncategory: false,
        parentIds: [saveIntoId],
        tenantId: _Izenda17.default.tenantId
      };

      return _Izenda14.default.loadLazyLoadCategories(request).then((0, _mobx.action)(function (response) {
        var category = _this6.getDashboardCategoriesInfo(dashboard.content);
        (0, _Izenda15.concatArray)(category.categories, response.data, 'id');
        dashboard.categories = category.categories;
      }));
    }

    /**
     * Update name
     * @param {Object} importFileContent
     * @param {String} name
     */

  }, {
    key: 'updateName',
    value: function updateName(importFileContent, name) {
      importFileContent.content.name = name;
      this.updateErrorMessages(importFileContent.content.index, ['category', 'subCategory'], this.model.activeTabKey);
    }

    /**
     * Update save into id
     * @param {Object} importFileContent
     * @param {String} saveIntoId
     */

  }, {
    key: 'updateSaveIntoId',
    value: function updateSaveIntoId(importFileContent, saveIntoId) {
      var _this7 = this;

      var importSourceCat = (0, _fp.get)('model.importSourceCat', this);
      var loadCategoryFunc = importFileContent.isReport ? this.processReportCategories : this.processDashboardCategories;

      importFileContent.updateSaveIntoId(saveIntoId);
      importFileContent.content.isGlobal = (0, _fp.find)(function (category) {
        return category.id === saveIntoId;
      }, this.saveInto).isGlobal;
      importFileContent.content.categoryId = null;
      importFileContent.content.subCategoryId = null;
      this.resetArray(importFileContent.subCategories);
      this.updateErrorMessages(importFileContent.content.index, this.model.activeTabKey === 'report' ? ['category', 'subCategory'] : ['saveInto'], this.model.activeTabKey);

      var processSourceCatFunc = function processSourceCatFunc(importFileContent) {
        if (importSourceCat) {
          _this7.updateSourceCategoryForImportFiles([importFileContent]);
        }
      };

      loadCategoryFunc.call(this, importFileContent).then(function () {
        processSourceCatFunc(importFileContent);
      });
    }

    /**
     * Update category
     * @param {Object} importFileContent
     * @param {String} categoryId
     * @param {String} categoryName
     */

  }, {
    key: 'updateCategory',
    value: function updateCategory(importFileContent, categoryId, categoryName) {
      importFileContent.updateCategory(categoryId, categoryName);
      this.resetArray(importFileContent.subCategories);
      importFileContent.updateSubCategory(null, null);
      this.updateErrorMessages(importFileContent.content.index, ['category', 'subCategory'], this.model.activeTabKey);

      if (importFileContent.isReport) {
        return this.loadReportTemplateSubCategories(importFileContent);
      } else {
        return this.loadDashboardSubCategories(importFileContent);
      }
    }

    /**
     * Lazy loading for report or template sub-category
     * @param {Object} report
     * @param {Object} pageInfo
     * @param {Boolean} isReset
     */

  }, {
    key: 'loadReportTemplateSubCategories',
    value: function loadReportTemplateSubCategories(report) {
      var tempSubCategories = this.getTempSubCategories(report);

      if (!String.isGuidFormat(report.content.categoryId)) {
        report.subCategories = tempSubCategories;
        return (0, _bluebird.resolve)();
      } else {
        var request = {
          skipItems: -1,
          type: report.content.type,
          parentIds: [report.saveIntoId, report.content.categoryId],
          tenantId: _Izenda17.default.tenantId
        };

        return _Izenda12.default.loadLazyLoadAllowedSavingSubCategories(request).then((0, _mobx.action)(function (response) {
          report.subCategories = (0, _fp.concat)(response.data, tempSubCategories);
        }));
      }
    }

    /**
     * Lazy loading for dashboard sub-category
     * @param {Object} dashboard
     * @param {Object} pageInfo
     */

  }, {
    key: 'loadDashboardSubCategories',
    value: function loadDashboardSubCategories(dashboard) {
      var tempSubCategories = this.getTempSubCategories(dashboard);

      if (!String.isGuidFormat(dashboard.content.categoryId)) {
        dashboard.subCategories = tempSubCategories;
        return (0, _bluebird.resolve)();
      } else {
        var request = {
          skipItems: -1,
          type: dashboard.content.type,
          includeUncategory: false,
          parentIds: [dashboard.saveIntoId, dashboard.content.categoryId],
          tenantId: _Izenda17.default.tenantId
        };

        return _Izenda14.default.loadLazyLoadSubcategories(request).then((0, _mobx.action)(function (response) {
          dashboard.subCategories = (0, _fp.concat)(response.data, tempSubCategories);
        }));
      }
    }

    /**
    * Check/uncheck import category checkbox
    */

  }, {
    key: 'toggleImportCategory',
    value: function toggleImportCategory() {
      this.model.toggleImportCategory();
      this.processImportSourceCategory();
    }

    /**
    * To process the category when user cick Import Source Category
    */

  }, {
    key: 'processImportSourceCategory',
    value: function processImportSourceCategory() {
      var _this8 = this;

      var _model = this.model,
          reports = _model.reports,
          dashboards = _model.dashboards,
          importSourceCat = _model.importSourceCat;

      var files = [].concat((0, _toConsumableArray3.default)(reports), (0, _toConsumableArray3.default)(dashboards));
      if (importSourceCat) {
        this.updateSourceCategoryForImportFiles(files);
      } else {
        (0, _fp.forEach)(function (importFileContent) {
          _this8.removeNewCategory(importFileContent);
          _this8.updateCategory(importFileContent);
        }, files);
      }
    }

    /**
    * process the source category for a report/dashboard imported
    * @param {Object} importFileContent: file will be imported
    */

  }, {
    key: 'updateSourceCategoryForImportFiles',
    value: function updateSourceCategoryForImportFiles(importFileContents) {
      var _this9 = this;

      (0, _fp.forEach)(function (importFileContent) {
        var originalCategoryName = (0, _fp.get)('content.originalCategoryName', importFileContent);
        var catSelected = !(0, _fp.isEmpty)(originalCategoryName) ? (0, _fp.find)(function (cat) {
          return !(0, _fp.isEmpty)(cat.name) && cat.name.toLowerCase() == originalCategoryName.toLowerCase();
        }, importFileContent.categories) : null;
        _this9.populateImportSourceCategory(importFileContent, catSelected);
      }, importFileContents);
    }

    /**
    * if checkbox import source ategory is selected
    * @param {Object} importFileContent: file will be imported
    * @param {Object} catSelected: category may be existing on destination
    */

  }, {
    key: 'populateImportSourceCategory',
    value: function populateImportSourceCategory(importFileContent, catSelected) {
      var _this10 = this;

      var categoryId = (0, _fp.get)('id', catSelected);
      var originalSubCategoryName = (0, _fp.get)('content.originalSubCategoryName', importFileContent);
      var originalCategoryName = (0, _fp.get)('content.originalCategoryName', importFileContent);
      // if the category from source is the same category from destination
      if (!(0, _fp.isNil)(catSelected)) {
        this.updateCategory(importFileContent, categoryId, originalCategoryName).then(function () {
          var subCategoryId = !(0, _fp.isEmpty)(originalSubCategoryName) ? (0, _fp.flow)((0, _fp.find)(function (cat) {
            return !(0, _fp.isEmpty)(cat.name) && cat.name.toLowerCase() == originalSubCategoryName.toLowerCase();
          }), (0, _fp.get)('id'))(importFileContent.subCategories) : null;

          if (!(0, _fp.isNil)(subCategoryId)) {
            // if sub category is existing in destination
            _this10.updateSubCategory(importFileContent, subCategoryId, originalSubCategoryName);
          } else {
            // if destination does not have the category
            if (!(0, _fp.isEmpty)(originalSubCategoryName)) {
              _this10.populateNewSubCat(importFileContent, originalSubCategoryName);
            }
          }
        });
      } else {
        // if the category from source which could not find in the destination
        if (!(0, _fp.isEmpty)(originalCategoryName)) {
          var newCat = {
            id: originalCategoryName,
            isNew: true,
            name: originalCategoryName
          };
          this.addNewCategory(importFileContent, newCat, true);
          if (!(0, _fp.isEmpty)(originalSubCategoryName)) {
            this.populateNewSubCat(importFileContent, originalSubCategoryName);
          }
        } else {
          this.updateCategory(importFileContent);
        }
      }
    }

    /**
    * To add new subcat and make this subcat populated
    * @param {Object} importFileContent: file will be imported
    * @param {string} subCatName: category name
    */

  }, {
    key: 'populateNewSubCat',
    value: function populateNewSubCat(importFileContent, subCatName) {
      if (!(0, _fp.isEmpty)(subCatName)) {
        var newSubCat = {
          id: subCatName,
          isNew: true,
          name: subCatName
        };
        this.addNewSubCategory(importFileContent, newSubCat, true);
      }
    }
    /**
     * Load categories
     * @param {Object} importFileContent
     * @param {Object} pageInfo
     * @param {String} searchValue
     */

  }, {
    key: 'loadCategories',
    value: function loadCategories(importFileContent, pageInfo) {
      var loadCategoriesFunc = importFileContent.isReport ? this.loadReportTemplateCategories : this.loadDashboardCategories;

      return loadCategoriesFunc.call(this, importFileContent, pageInfo);
    }

    /**
     * Load data for sub categories
     * @param {Object} importFileContent
     * @param {Object} pageInfo
     * @param {String} searchValue
     */

  }, {
    key: 'loadSubCategories',
    value: function loadSubCategories(importFileContent, pageInfo) {
      var loadSubCategoriesFunc = importFileContent.isReport ? this.loadReportTemplateSubCategories : this.loadDashboardSubCategories;

      return loadSubCategoriesFunc.call(this, importFileContent, pageInfo);
    }

    /**
     * Update sub-category
     * @param {Object} importFileContent
     * @param {String} subCategoryId
     * @param {String} subCategoryName
     */

  }, {
    key: 'updateSubCategory',
    value: function updateSubCategory(importFileContent, subCategoryId, subCategoryName) {
      importFileContent.updateSubCategory(subCategoryId, subCategoryName);
      this.updateErrorMessages(importFileContent.content.index, ['category', 'subCategory'], this.model.activeTabKey);
    }

    /**
     * Validate import's content
     */

  }, {
    key: 'validate',
    value: function validate() {
      var _this11 = this;

      return _Izenda6.default.validateImportContent(this.model.buildData()).then(function (result) {
        _this11.updateExistingErrorInEachTab(result.messages);
        _this11.errorMessages = result.messages;
        return (0, _bluebird.resolve)(result);
      });
    }

    /**
     * Get overwrite info tree
     */

  }, {
    key: 'validateOverride',
    value: function validateOverride() {
      return _Izenda6.default.validateOverride(this.model.buildData());
    }

    /**
     * Update error messages
     * @param {Number} index
     */

  }, {
    key: 'updateErrorMessages',
    value: function updateErrorMessages(index, columnKeys, tabKey) {
      // Build keys need to update.
      var keys = (0, _fp.map)(function (columnKey) {
        return (0, _fp.isEmpty)(tabKey) ? index + '.' + columnKey : tabKey + '.' + index + '.' + columnKey;
      }, columnKeys);

      // Get rows which are related together.
      var group = (0, _fp.flow)((0, _fp.find)(function (message) {
        return message.key.indexOf((0, _fp.isEmpty)(tabKey) ? index + '.' : tabKey + '.' + index + '.') >= 0;
      }), (0, _fp.get)('detail'))(this.errorMessages);

      // Remove its row
      this.errorMessages = (0, _fp.filter)(function (message) {
        return !(0, _fp.includes)(message.key, keys);
      }, this.errorMessages);

      // After its row then getting remain error rows
      var remainErrorRows = (0, _fp.filter)(function (message) {
        return message.detail === group;
      }, this.errorMessages);

      // If it is last one, remove all rows which related together.
      if (remainErrorRows.length / columnKeys.length === 1) {
        this.errorMessages = (0, _fp.filter)(function (message) {
          return message.detail !== group;
        }, this.errorMessages);
      }

      // Update error icon for each tab
      this.updateExistingErrorInEachTab(this.errorMessages);
    }

    /**
     * Update 2 flag to check to exist error for each tab
     * @param {Array} errorMessages
     */

  }, {
    key: 'updateExistingErrorInEachTab',
    value: function updateExistingErrorInEachTab(errorMessages) {
      this.hasErrorOnServerSideReportTab = (0, _fp.some)(function (message) {
        return message.key.indexOf('report') >= 0;
      }, errorMessages);
      this.hasErrorOnServerSideDashboardTab = (0, _fp.some)(function (message) {
        return message.key.indexOf('dashboard') >= 0;
      }, errorMessages);
    }
    /**
     * Get errors popup
     * @returns {Array}
     */

  }, {
    key: 'getErrorsPopup',
    value: function getErrorsPopup() {
      return (0, _fp.find)({ key: 'dataModelConsistency' }, this.errorMessages).detail;
    }

    /**
     * Group valid files type
     * @type {Array}
     */

  }, {
    key: 'groupByValidFiles',
    value: function groupByValidFiles(files) {
      return (0, _fp.groupBy)(function (file) {
        return (0, _fp.endsWith)(_Izenda25.FILE_EXTENSION.REPORT, file.name) || (0, _fp.endsWith)(_Izenda25.FILE_EXTENSION.DASHBOARD, file.name);
      }, files);
    }

    /**
     * Get invalid messages
     * @type {Array}
     */

  }, {
    key: 'getInvalidMessages',
    value: function getInvalidMessages(files) {
      return (0, _fp.map)(function (item) {
        var fileName = item.name.replace(/(^.*[\\\/]|\.[^/.]+$)/, '');
        return fileName + ' - ' + _Izenda22.default.getText('IMPORT_LABEL_INVALID_FILE_FORMAT');
      }, files);
    }

    /**
     * Upload files
     * @type {Promise}
     */

  }, {
    key: 'uploadFiles',
    value: function uploadFiles(files) {
      var _this12 = this;

      var _groupByValidFiles = this.groupByValidFiles(files),
          validFiles = _groupByValidFiles.true,
          invalidFiles = _groupByValidFiles.false;

      this.model.invalidFileMessages = this.getInvalidMessages(invalidFiles);

      return _Izenda6.default.uploadFiles(validFiles).then(function (content) {
        _this12.createImportContent(content);
        return content;
      });
    }

    /**
     * Hide error messages
     */

  }, {
    key: 'hideErrorMessages',
    value: function hideErrorMessages() {
      this.showErrorMessages = false;
      this.resetArray(this.model.invalidFileMessages);
    }

    /**
     * Get schemas
     * @param {Object} data
     */

  }, {
    key: 'getSchemas',
    value: function getSchemas(databaseNameId) {
      var requestData = {
        skipItems: -1,
        connectionId: databaseNameId
      };

      return _Izenda4.default.getSchemas(requestData).then(function (response) {
        return response.result;
      });
    }

    /**
     * Remove importing files
     */

  }, {
    key: 'removeFiles',
    value: function removeFiles(fileIds) {
      return _Izenda6.default.removeFiles(fileIds);
    }

    /**
     * Remove importing files (sync)
     */

  }, {
    key: 'removeFilesSync',
    value: function removeFilesSync() {
      !(0, _fp.isEmpty)(this.model.fileIds) && _Izenda6.default.removeFilesSync(this.model.fileIds);
      this.resetDirty();
    }

    /**
     * Handle clean dirty form
     */

  }, {
    key: 'onOkDirtyForm',
    value: function onOkDirtyForm() {
      !(0, _fp.isEmpty)(this.model.fileIds) && this.removeFiles(this.model.fileIds);
      this.reset();
    }

    /**
     * Check dirty form
     * @returns {boolean} A boolean value indicates dirty form status.
     */

  }, {
    key: 'updateReports',


    /**
     * Update report list
     * @param {String} id
     * @param {Number} index
     */
    value: function updateReports(id, index) {
      this.updateErrorMessages(index, ['category', 'subCategory'], this.model.activeTabKey);
      this.arrangeErrorRows(index, 1);
      this.model.arrangeIndex(index, 1, false);
      this.model.updateReports(id);
      if ((0, _fp.isEmpty)(this.model.reports)) {
        this.hasErrorOnClientSideReportTab = false;
        this.hasErrorOnServerSideReportTab = false;
      }
    }

    /**
     * Update dashboard list
     * @param {String} id
     * @param {Number} index
     */

  }, {
    key: 'updateDashboards',
    value: function updateDashboards(id, index) {
      var start = (0, _fp.findIndex)({ id: id }, this.model.dashboards);
      var end = (0, _fp.findLastIndex)({ id: id }, this.model.dashboards);

      for (var i = start; i < end; i++) {
        this.updateErrorMessages(i, ['category', 'subCategory'], this.model.activeTabKey);
      }
      this.arrangeErrorRows(end, end - start + 1);
      this.model.arrangeIndex(index, end - start + 1, true);
      this.model.updateDashboards(id);
      if ((0, _fp.isEmpty)(this.model.dashboards)) {
        this.hasErrorOnClientSideDashboardTab = false;
        this.hasErrorOnServerSideDashboardTab = false;
      }
    }

    /**
     * Arrange error rows
     * @param {Number} index
     * @param {Number} step
     */

  }, {
    key: 'arrangeErrorRows',
    value: function arrangeErrorRows(index, step) {
      var _this13 = this;

      var filterByIndex = function filterByIndex(_ref5) {
        var key = _ref5.key;

        if (key.indexOf('' + _this13.model.activeTabKey) >= 0) {
          var rowIndex = key.substring(key.indexOf('.') + 1, key.lastIndexOf('.'));
          return parseInt(rowIndex, 10) > index;
        }
        return false;
      };

      var updateKey = function updateKey(message) {
        var key = message.key;

        var rowIndex = key.substring(key.indexOf('.') + 1, key.lastIndexOf('.'));
        var columnKey = key.substring(message.key.lastIndexOf('.') + 1, key.length);
        message.key = _this13.model.activeTabKey + '.' + (rowIndex - step) + '.' + columnKey;
      };

      (0, _fp.flow)((0, _fp.filter)(filterByIndex), (0, _fp.forEach)(updateKey))(this.errorMessages);
    }

    /**
     * Get file's info to use fetch to get file's detail
     * @param {ImportFileContent} data
     * @returns {any}
     */

  }, {
    key: 'getFileInfo',
    value: function getFileInfo(data) {
      var type = this.model.activeTabKey === 'report' ? _Izenda25.TYPE_REPORT : _Izenda25.TYPE_DASHBOARD;
      var fileId = data.id;
      var objectId = data.isReport && this.model.activeTabKey === 'dashboard' ? data.content.id : '';

      return { type: type, fileId: fileId, objectId: objectId };
    }

    /**
     * Get detail file and load access rights to show on popup
     * @param {Object} any
     * @param {number} typeAccess
     * @returns {Array}
     */

  }, {
    key: 'getDetailFile',
    value: function getDetailFile(fileInfo, typeAccess) {
      return (0, _bluebird.all)([_Izenda6.default.getDetailFile(fileInfo), _Izenda8.default.loadAccessRight(typeAccess)]);
    }

    /**
     * Remove new category
     * @param {Object} importFileContent
     * @param {Object} category
     */

  }, {
    key: 'removeNewCategory',
    value: function removeNewCategory(importFileContent) {
      var categories = importFileContent.categories,
          subCategories = importFileContent.subCategories;

      var lastIndexFunc = function lastIndexFunc(categories) {
        return (0, _fp.findLastIndex)({ isNew: true }, categories);
      };

      var removeCategoryNewStatusFunc = function removeCategoryNewStatusFunc(cats) {
        var lastIndex = lastIndexFunc(cats);
        while (lastIndex > -1) {
          cats.splice(lastIndex, 1);
          lastIndex = lastIndexFunc(cats);
        }
      };

      removeCategoryNewStatusFunc(categories);
      removeCategoryNewStatusFunc(subCategories);
      this.resetArray(this.tempSubCategories);
      this.updateCategory(importFileContent);
    }

    /**
     * Add new category
     * @param {Object} importFileContent
     * @param {Object} category
     * @param {Object} selected
     */

  }, {
    key: 'addNewCategory',
    value: function addNewCategory(importFileContent, category, selected) {
      if ((0, _fp.findIndex)(category, importFileContent.categories) < 0) {
        importFileContent.categories.push(category);
      }

      if (selected) {
        this.updateCategory(importFileContent, category.id, category.name);
      } else {
        this.updateCategory(importFileContent);
      }
    }

    /**
     * Add new sub-category
     * @param {Object} importFileContent
     * @param {Object} subCategory
     * @param {Object} selected
     */

  }, {
    key: 'addNewSubCategory',
    value: function addNewSubCategory(importFileContent, subCategory, selected) {
      this.addForAllSubCategories(importFileContent, subCategory);
      if (selected) {
        this.updateSubCategory(importFileContent, subCategory.id, subCategory.name);
      } else {
        this.updateSubCategory(importFileContent);
      }

      // When user enter to add a sub-category, it is cached which will use for loading sub-category data.
      this.tempSubCategories.push({
        saveIntoId: importFileContent.saveIntoId,
        categoryName: importFileContent.content.categoryName,
        isReport: importFileContent.isReport,
        subCategory: subCategory
      });
    }

    /**
     * Add sub category for all sub categories dropdown
     * @param {Object} importFileContent
     * @param {Object} subCategory
     */

  }, {
    key: 'addForAllSubCategories',
    value: function addForAllSubCategories(_ref6, subCategory) {
      var saveIntoId = _ref6.saveIntoId,
          categoryName = _ref6.content.categoryName,
          isReport = _ref6.isReport;

      (0, _fp.flow)((0, _fp.filter)(function (importFileContent) {
        return importFileContent.saveIntoId === saveIntoId && importFileContent.content.categoryName === categoryName && importFileContent.isReport === isReport;
      }), (0, _fp.map)('subCategories'), (0, _fp.forEach)(function (subCategories) {
        subCategories.push(subCategory);
      }))([].concat((0, _toConsumableArray3.default)(this.model.reports), (0, _toConsumableArray3.default)(this.model.dashboards)));
    }

    /**
     * Get temporary sub-categories
     * @param {Object} importFileContent
     * @returns {Array} temporary sub-categories
     */

  }, {
    key: 'getTempSubCategories',
    value: function getTempSubCategories(importFileContent) {
      var subCategories = (0, _fp.flow)((0, _fp.filter)({
        saveIntoId: importFileContent.saveIntoId,
        categoryName: importFileContent.content.categoryName,
        isReport: importFileContent.isReport
      }), (0, _fp.map)('subCategory'))(this.tempSubCategories) || [];

      return subCategories;
    }
  }, {
    key: 'reportTabTitle',
    get: function get() {
      return _Izenda22.default.getText('COMMON_LABEL_REPORT') + ((0, _fp.isEmpty)(this.model.reports) ? '' : ' (' + this.model.reports.length + ')');
    }
  }, {
    key: 'dashboardTabTitle',
    get: function get() {
      return _Izenda22.default.getText('COMMON_LABEL_DASHBOARD') + ((0, _fp.isEmpty)(this.model.dashboards) ? '' : ' (' + (0, _fp.filter)({ isReport: false }, this.model.dashboards).length + ')');
    }
  }, {
    key: 'hasErrorReportTab',
    get: function get() {
      return this.hasErrorOnServerSideReportTab || this.hasErrorOnClientSideReportTab;
    }
  }, {
    key: 'hasErrorDashboardTab',
    get: function get() {
      return this.hasErrorOnServerSideDashboardTab || this.hasErrorOnClientSideDashboardTab;
    }
  }, {
    key: 'hasFileLoaded',
    get: function get() {
      return (!(0, _fp.isEmpty)(this.model.reports) || !(0, _fp.isEmpty)(this.model.dashboards)) && !this.showErrorMessages;
    }

    /**
     * Initial data
     */

  }]);
  return ImportStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'saveInto', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'databaseNamesTo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'showErrorMessages', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'hasErrorOnServerSideReportTab', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'hasErrorOnClientSideReportTab', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'hasErrorOnServerSideDashboardTab', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'hasErrorOnClientSideDashboardTab', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'reportTabTitle', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reportTabTitle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'dashboardTabTitle', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'dashboardTabTitle'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasErrorReportTab', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasErrorReportTab'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasErrorDashboardTab', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasErrorDashboardTab'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hasFileLoaded', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hasFileLoaded'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'initial', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'initial'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reset', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reset'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'createImportContent', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'createImportContent'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'appendContent', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'appendContent'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getDatabaseNamesTo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getDatabaseNamesTo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadInitialCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadInitialCategories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processReportCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processReportCategories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processDashboardCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processDashboardCategories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'finishImport', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'finishImport'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDatabaseMappings', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDatabaseMappings'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getDatabaseMappings', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getDatabaseMappings'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadReportTemplateCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadReportTemplateCategories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadDashboardCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadDashboardCategories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateName', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateSaveIntoId', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateSaveIntoId'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadReportTemplateSubCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadReportTemplateSubCategories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadDashboardSubCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadDashboardSubCategories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleImportCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleImportCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processImportSourceCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'processImportSourceCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateSourceCategoryForImportFiles', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateSourceCategoryForImportFiles'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateImportSourceCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateImportSourceCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadCategories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadSubCategories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadSubCategories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateSubCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateSubCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'validate', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'validate'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'validateOverride', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'validateOverride'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateExistingErrorInEachTab', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateExistingErrorInEachTab'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getErrorsPopup', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getErrorsPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'uploadFiles', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'uploadFiles'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideErrorMessages', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hideErrorMessages'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getSchemas', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getSchemas'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateReports', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateReports'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateDashboards', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateDashboards'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getFileInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getFileInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'removeNewCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeNewCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addNewCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addNewCategory'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addNewSubCategory', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addNewSubCategory'), _class2.prototype)), _class2)) || _class;

exports.default = ImportStore;
module.exports = exports['default'];

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = __webpack_require__(74);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Import.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(1175);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2542);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Import = (_class = function () {
  function Import() {
    (0, _classCallCheck3.default)(this, Import);

    _initDefineProp(this, 'batchId', _descriptor, this);

    _initDefineProp(this, 'importSourceCat', _descriptor2, this);

    _initDefineProp(this, 'importAccessRights', _descriptor3, this);

    _initDefineProp(this, 'importFilterValues', _descriptor4, this);

    _initDefineProp(this, 'reports', _descriptor5, this);

    _initDefineProp(this, 'dashboards', _descriptor6, this);

    _initDefineProp(this, 'tenantId', _descriptor7, this);

    _initDefineProp(this, 'hasInvalidFile', _descriptor8, this);

    _initDefineProp(this, 'systemVersion', _descriptor9, this);

    _initDefineProp(this, 'databaseMappings', _descriptor10, this);

    this.invalidFileMessages = [];
    this.activeTabKeys = [{ key: 'report', index: 1 }, { key: 'dashboard', index: 2 }];
    this.activeTabKey = 'report';
  }

  (0, _createClass3.default)(Import, [{
    key: 'create',
    value: function create(content, localCategoryId) {
      var _populate = this.populate(content, localCategoryId),
          reports = _populate.reports,
          dashboards = _populate.dashboards,
          databaseMappings = _populate.databaseMappings;

      this.reports = reports;
      this.dashboards = dashboards;
      this.databaseMappings = databaseMappings;
      this.updateActiveTabKey(content);
    }

    /**
     * append file content after browse more files
     * @param {Object} content
     * @param {string} localCategoryId
     * @returns {Array} return a list of report and dashboard content files
     */

  }, {
    key: 'appendContent',
    value: function appendContent(content, localCategoryId) {
      var _populate2 = this.populate(content, localCategoryId),
          reports = _populate2.reports,
          dashboards = _populate2.dashboards,
          databaseMappings = _populate2.databaseMappings;

      Array.prototype.push.apply(this.reports, reports);
      Array.prototype.push.apply(this.dashboards, dashboards);
      Array.prototype.push.apply(this.databaseMappings, databaseMappings);

      this.updateActiveTabKey(content);
      return [].concat((0, _toConsumableArray3.default)(reports), (0, _toConsumableArray3.default)(dashboards));
    }

    /**
     * Update report list
     * @param {String} id
     */

  }, {
    key: 'updateReports',
    value: function updateReports(id) {
      var index = (0, _fp.findIndex)({ id: id }, this.reports);
      index !== -1 && this.reports.splice(index, 1);
    }

    /**
     * Update dashboard list
     * @param {String} id
     */

  }, {
    key: 'updateDashboards',
    value: function updateDashboards(id) {
      var start = (0, _fp.findIndex)({ id: id }, this.dashboards);
      var end = (0, _fp.findLastIndex)({ id: id }, this.dashboards);
      this.dashboards.splice(start, end - start + 1);
    }

    /**
     * Populate data
     * @param {Object} content
     * @param {String} localCategoryId
     */

  }, {
    key: 'populate',
    value: function populate(content, localCategoryId) {
      var _this = this;

      this.batchId = content.batchId;
      this.importAccessRights = content.importAccessRights;
      this.importFilterValues = content.importFilterValues;
      this.tenantId = content.tenantId;
      this.hasInvalidFile = content.hasInvalidFile;
      this.systemVersion = content.systemVersion;
      Array.prototype.push.apply(this.invalidFileMessages, content.invalidFileMessages);

      // Check then get the new database mapping to append
      var databaseMappings = [];
      if (!(0, _fp.isEmpty)(this.databaseMappings)) {
        var differences = (0, _fp.differenceWith)(function (current, toMerge) {
          return (0, _fp.toLower)(current.fromDatabaseName) === (0, _fp.toLower)(toMerge.fromDatabaseName) && (0, _fp.toLower)(current.fromSchema) === (0, _fp.toLower)(toMerge.fromSchema) && (0, _fp.toLower)(current.serverType) === (0, _fp.toLower)(toMerge.serverType);
        }, content.databaseMappings, this.databaseMappings);
        (0, _fp.forEach)(function (difference) {
          databaseMappings.push(new _Izenda4.default(difference));
        }, differences);
      } else {
        // If this.databaseMappings is empty, no need to check each item, push all
        (0, _fp.forEach)(function (databaseMapping) {
          databaseMappings.push(new _Izenda4.default(databaseMapping));
        }, content.databaseMappings);
      }

      // Update index for report list
      for (var i = 0; i < content.reports.length; i++) {
        content.reports[i].content.index = this.reports.length + i;
      }
      var reports = (0, _fp.map)(function (report) {
        return new _Izenda2.default(report, localCategoryId, true);
      }, content.reports);

      var dashboards = [];

      var _loop = function _loop(_i) {
        var dashboard = content.dashboards[_i];
        dashboard.content.index = _this.dashboards.length + dashboards.length;
        dashboards.push(new _Izenda2.default(dashboard, localCategoryId, false));

        if (!(0, _fp.isEmpty)(dashboard.reports)) {
          for (var _i2 = 0; _i2 < dashboard.reports.length; _i2++) {
            dashboard.reports[_i2].index = _this.dashboards.length + dashboards.length + _i2;
          }

          Array.prototype.push.apply(dashboards, (0, _fp.map)(function (report) {
            return new _Izenda2.default({ id: dashboard.id, content: report }, localCategoryId, true);
          }, dashboard.reports));
        }
      };

      for (var _i = 0; _i < content.dashboards.length; _i++) {
        _loop(_i);
      }

      return { reports: reports, dashboards: dashboards, databaseMappings: databaseMappings };
    }

    /**
     * Update active tab key
     * @param {Object} content
     */

  }, {
    key: 'updateActiveTabKey',
    value: function updateActiveTabKey(content) {
      if (!(0, _fp.isEmpty)(content.reports) && !(0, _fp.isEmpty)(content.dashboards)) {
        return;
      }

      if (!(0, _fp.isEmpty)(content.reports)) {
        this.activeTabKey = 'report';
      } else if (!(0, _fp.isEmpty)(content.dashboards)) {
        this.activeTabKey = 'dashboard';
      } else {
        this.activeTabKey = 'report';
      }
    }

    /**
     * Change active tab key.
     * @param {Number} index
     */

  }, {
    key: 'changeActiveTabKey',
    value: function changeActiveTabKey(index) {
      this.activeTabKey = (0, _fp.find)({ index: index }, this.activeTabKeys).key;
    }

    /**
     * Create object data to validate through APIs
     * @returns {Object}
     */

  }, {
    key: 'buildData',
    value: function buildData() {
      var data = {
        batchId: null,
        dashboards: [],
        databaseMappings: [],
        hasInvalidFile: null,
        importSourceCat: null,
        importAccessRights: null,
        importFilterValues: null,
        reports: [],
        systemVersion: null,
        tenantId: null
      };

      data.batchId = this.batchId;
      data.dashboards = this.buildDashboards(this.dashboards);
      data.databaseMappings = this.buildDatabaseMappings(this.databaseMappings);
      data.hasInvalidFile = this.hasInvalidFile;
      data.importAccessRights = this.importAccessRights;
      data.importSourceCat = this.importSourceCat;
      data.importFilterValues = this.importFilterValues;
      data.reports = this.buildReports(this.reports);
      data.systemVersion = this.systemVersion;
      data.tenantId = _Izenda6.default.tenantId;
      return data;
    }

    /**
     * Create dashboards to validate through APIs
     * @param {Array} dashboardModel
     * @returns {Array}
     */

  }, {
    key: 'buildDashboards',
    value: function buildDashboards(dashboardsModel) {
      var dashboards = [];
      (0, _fp.forEach)(function (dashboard) {
        if (!dashboard.isReport) {
          var dashboardData = dashboard.buildData();
          dashboardData.reports = [];
          var dashboardReports = (0, _fp.filter)({ id: dashboard.id, isReport: true }, dashboardsModel);
          (0, _fp.forEach)(function (report) {
            dashboardData.reports.push(report.content.buildData());
          }, dashboardReports);
          dashboards.push(dashboardData);
        }
      }, dashboardsModel);
      return dashboards;
    }

    /**
     * Create database mappings to validate through APIs
     * @param {Array} databaseMappingsModel
     * @returns {Array}
     */

  }, {
    key: 'buildDatabaseMappings',
    value: function buildDatabaseMappings(databaseMappingsModel) {
      var databaseMappings = [];
      (0, _fp.forEach)(function (databaseMapping) {
        databaseMappings.push((0, _fp.pick)(['fromDatabaseName', 'fromSchema', 'serverType', 'toDatabase', 'toSchema'], databaseMapping));
      }, databaseMappingsModel);
      return databaseMappings;
    }

    /**
     * Create reports to validate through APIs
     * @param {Array} reportsModel
     * @returns {Array}
     */

  }, {
    key: 'buildReports',
    value: function buildReports(reportsModel) {
      var reports = [];
      (0, _fp.forEach)(function (report) {
        reports.push(report.buildData());
      }, reportsModel);
      return reports;
    }

    /**
     * Remove completed file
     * @param {Array} importFiles
     */

  }, {
    key: 'removeCompletedFiles',
    value: function removeCompletedFiles(importFiles) {
      var removeFile = (0, _fp.remove)(function (file) {
        return (0, _fp.includes)(file.id, importFiles);
      });

      this.reports = removeFile(this.reports);
      this.dashboards = removeFile(this.dashboards);
    }

    /**
     * Set database mappings
     * @param {Array} databaseMappings
     */

  }, {
    key: 'updateDatabaseMappings',
    value: function updateDatabaseMappings(databaseMappings) {
      this.databaseMappings.replace((0, _fp.remove)(function (currentMapping) {
        return !(0, _fp.find)(function (newMapping) {
          return (0, _fp.toLower)(currentMapping.fromDatabaseName) === (0, _fp.toLower)(newMapping.fromDatabaseName) && (0, _fp.toLower)(currentMapping.fromSchema) === (0, _fp.toLower)(newMapping.fromSchema) && (0, _fp.toLower)(currentMapping.serverType) === (0, _fp.toLower)(newMapping.serverType);
        }, databaseMappings);
      }, this.databaseMappings));
    }

    /**
     * Update selected to database name
     */

  }, {
    key: 'updateSelectedToDatabaseName',
    value: function updateSelectedToDatabaseName(databaseMapping, id, value, schemas) {
      var groupIndexs = [];
      databaseMapping.setSelectedToDatabaseName(id, value);
      databaseMapping.toSchemas = schemas;

      this.databaseMappings.forEach(function (item, index) {
        if (item.fromDatabaseNameLabel === databaseMapping.fromDatabaseNameLabel && item.fromSchema !== databaseMapping.fromSchema) {
          groupIndexs.push(index.toString());

          if ((0, _fp.isNil)(item.selectedToDatabaseName)) {
            item.setSelectedToDatabaseName(id, value);
            item.toSchemas = schemas;
          }
        }
      });

      return groupIndexs;
    }

    /**
     * Arrange index
     * @param {Number} index
     * @param {Number} step
     */

  }, {
    key: 'arrangeIndex',
    value: function arrangeIndex(index, step, isDashboardTab) {
      (0, _fp.flow)((0, _fp.filter)(function (importFileContent) {
        return importFileContent.content.index > index + step - 1;
      }), (0, _fp.forEach)(function (importFileContent) {
        importFileContent.content.index = importFileContent.content.index - step;
      }))(isDashboardTab ? this.dashboards : this.reports);
    }

    /**
    * Update import category
    */

  }, {
    key: 'toggleImportCategory',
    value: function toggleImportCategory() {
      this.importSourceCat = !this.importSourceCat;
    }

    /**
     * Update import access rights
     */

  }, {
    key: 'toggleImportAccessRights',
    value: function toggleImportAccessRights() {
      this.importAccessRights = !this.importAccessRights;
    }

    /**
     * Update import the filter values
     */

  }, {
    key: 'toggleImportTheFilterValues',
    value: function toggleImportTheFilterValues() {
      this.importFilterValues = !this.importFilterValues;
    }
  }, {
    key: 'fileIds',
    get: function get() {
      var ids = [];
      var extractIdsFn = function extractIdsFn(collection) {
        return collection.reduce(function (result, _ref) {
          var id = _ref.id;

          result.push(id);
          return result;
        }, ids);
      };
      this.reports && extractIdsFn(this.reports);
      this.dashboards && extractIdsFn(this.dashboards);
      return ids;
    }

    /**
     * create new data
     * @param {Object} content
     * @param {String} localCategoryId
     */

  }]);
  return Import;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'batchId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'importSourceCat', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'importAccessRights', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'importFilterValues', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'reports', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'dashboards', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'hasInvalidFile', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'systemVersion', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'databaseMappings', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'fileIds', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fileIds'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'create', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'create'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'appendContent', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'appendContent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateReports', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateReports'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDashboards', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateDashboards'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeCompletedFiles', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'removeCompletedFiles'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDatabaseMappings', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateDatabaseMappings'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateSelectedToDatabaseName', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateSelectedToDatabaseName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'arrangeIndex', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'arrangeIndex'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleImportAccessRights', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleImportAccessRights'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleImportTheFilterValues', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleImportTheFilterValues'), _class.prototype)), _class);
exports.default = Import;
module.exports = exports['default'];

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFileReportDashboardContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportFileReportDashboardContent = (_class = function () {
  function ImportFileReportDashboardContent(content) {
    (0, _classCallCheck3.default)(this, ImportFileReportDashboardContent);

    _initDefineProp(this, 'categoryId', _descriptor, this);

    _initDefineProp(this, 'categoryName', _descriptor2, this);

    _initDefineProp(this, 'id', _descriptor3, this);

    _initDefineProp(this, 'isGlobal', _descriptor4, this);

    _initDefineProp(this, 'name', _descriptor5, this);

    _initDefineProp(this, 'subCategoryId', _descriptor6, this);

    _initDefineProp(this, 'subCategoryName', _descriptor7, this);

    _initDefineProp(this, 'type', _descriptor8, this);

    _initDefineProp(this, 'index', _descriptor9, this);

    _initDefineProp(this, 'sourceId', _descriptor10, this);

    this.originalCategoryName = null;
    this.originalSubCategoryName = null;

    this.categoryId = content.categoryId;
    this.originalCategoryName = content.categoryName;
    this.id = content.id;
    this.isGlobal = content.isGlobal;
    this.name = content.name;
    this.subCategoryId = content.subCategoryId;
    this.originalSubCategoryName = content.subCategoryName;
    this.type = content.type;
    this.index = content.index;
    this.sourceId = content.sourceId;
  }

  (0, _createClass3.default)(ImportFileReportDashboardContent, [{
    key: 'updateName',
    value: function updateName(event) {
      this.name = event.target.value;
    }
  }, {
    key: 'buildData',
    value: function buildData() {
      return {
        categoryId: String.isGuidFormat(this.categoryId) ? this.categoryId : null,
        categoryName: this.categoryName,
        id: this.id,
        isGlobal: this.isGlobal,
        name: this.name,
        subCategoryId: String.isGuidFormat(this.subCategoryId) ? this.subCategoryId : null,
        subCategoryName: this.subCategoryName,
        type: this.type,
        index: this.index,
        sourceId: this.sourceId
      };
    }
  }]);
  return ImportFileReportDashboardContent;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'categoryId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'categoryName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'isGlobal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'subCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'subCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'index', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'sourceId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, 'updateName', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateName'), _class.prototype)), _class);
exports.default = ImportFileReportDashboardContent;
module.exports = exports['default'];

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFileDatabaseMappingContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportFileDatabaseMappingContent = (_class = function () {
  (0, _createClass3.default)(ImportFileDatabaseMappingContent, [{
    key: 'fromDatabaseNameLabel',
    // Change, depend on selectedDatabaseNameTo
    // Default APIs send 0000-0000...
    get: function get() {
      return '[' + this.serverType + '] ' + this.fromDatabaseName;
    } // Default APIs send 0000-0000...

    // APIs don't have
    // Haven't used

  }]);

  function ImportFileDatabaseMappingContent(contentDatabaseMapping) {
    (0, _classCallCheck3.default)(this, ImportFileDatabaseMappingContent);

    _initDefineProp(this, 'fromDatabaseName', _descriptor, this);

    _initDefineProp(this, 'fromSchema', _descriptor2, this);

    _initDefineProp(this, 'serverType', _descriptor3, this);

    _initDefineProp(this, 'toDatabase', _descriptor4, this);

    _initDefineProp(this, 'toSchema', _descriptor5, this);

    _initDefineProp(this, 'selectedToDatabaseName', _descriptor6, this);

    _initDefineProp(this, 'selectedToDatabaseNameId', _descriptor7, this);

    _initDefineProp(this, 'toSchemas', _descriptor8, this);

    _initDefineProp(this, 'selectedToSchema', _descriptor9, this);

    _initDefineProp(this, 'selectedToSchemaId', _descriptor10, this);

    var fromDatabaseName = contentDatabaseMapping.fromDatabaseName,
        fromSchema = contentDatabaseMapping.fromSchema,
        serverType = contentDatabaseMapping.serverType,
        toDatabase = contentDatabaseMapping.toDatabase,
        toSchema = contentDatabaseMapping.toSchema;

    this.fromDatabaseName = fromDatabaseName;
    this.fromSchema = fromSchema;
    this.serverType = serverType;

    this.toDatabase = toDatabase;
    this.toSchema = toSchema;

    this.selectedToDatabaseName = null;
    this.selectedToDatabaseNameId = null;
    this.toSchemas = null;
    this.selectedToSchema = null;
    this.selectedToSchemaId = null;
  }

  /**
   * Set the selected ToDatabaseName
   * @param {string} id
   * @param {string} value
   */


  (0, _createClass3.default)(ImportFileDatabaseMappingContent, [{
    key: 'setSelectedToDatabaseName',
    value: function setSelectedToDatabaseName(id, value) {
      if (this.selectedToDatabaseNameId != id) {
        this.selectedToDatabaseNameId = id;
        this.selectedToDatabaseName = value;
        this.toDatabase = id;

        // Reset to schema
        this.selectedToSchemaId = null;
        this.selectedToSchema = null;
      }
    }

    /**
     * Set the selected ToSchema
     * @param {string} id
     * @param {string} value
     */

  }, {
    key: 'setSelectedToSchema',
    value: function setSelectedToSchema(id, value) {
      this.selectedToSchemaId = id;
      this.selectedToSchema = value;
      this.toSchema = id;
    }
  }]);
  return ImportFileDatabaseMappingContent;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'fromDatabaseName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'fromSchema', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'serverType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'toDatabase', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'toSchema', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'selectedToDatabaseName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'selectedToDatabaseNameId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'toSchemas', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'selectedToSchema', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'selectedToSchemaId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'fromDatabaseNameLabel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fromDatabaseNameLabel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSelectedToDatabaseName', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setSelectedToDatabaseName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSelectedToSchema', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setSelectedToSchema'), _class.prototype)), _class);
exports.default = ImportFileDatabaseMappingContent;
module.exports = exports['default'];

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.WithNavigator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * This HOC supports to register and unregister event handlers.
 * Use it with recompose module
 *
 * import { compose } from 'recompose';
 * import withNavigator from 'share/components/hoc/Izenda.WithNavigator';
 *
 * compose(
 *   withNavigator({
 *    onMyEvent: () => { // register handler },
 *    // others
 *   })
 * )
 */

var events = [{
  name: 'onbeforeunload',
  isWindowEvent: true
}, {
  name: 'onpagehide',
  isWindowEvent: true
}, {
  name: 'onpageshow',
  isWindowEvent: true
}, {
  name: 'onlistenbefore', // react-router event
  isWindowEvent: false
}];

var EventHandler = function () {
  function EventHandler(eventName, handlerFn) {
    (0, _classCallCheck3.default)(this, EventHandler);

    this.eventName = eventName;
    this.setHander(handlerFn);
  }

  /**
   * Register handler
   * @param {Object} handlerFn
   */


  (0, _createClass3.default)(EventHandler, [{
    key: 'setHander',
    value: function setHander(handlerFn) {
      if ((0, _fp.isFunction)(handlerFn)) {
        if (this.isWindowEvent()) {
          this.restoreFn = window[this.eventName];
          window[this.eventName] = handlerFn();
        } else {
          this.restoreFn = handlerFn();
        }
      }
    }

    /**
     * Reset handler
     */

  }, {
    key: 'restoreHandler',
    value: function restoreHandler() {
      this.restoreFn && this.restoreFn();
    }

    /**
     * Check this is a window's event
     */

  }, {
    key: 'isWindowEvent',
    value: function isWindowEvent() {
      var _this = this;

      return (0, _fp.findIndex)(function (e) {
        return e.name === _this.eventName && e.isWindowEvent;
      }, events) !== -1;
    }
  }]);
  return EventHandler;
}();

var withNavigator = function withNavigator(spec) {
  return function (BaseComponent) {
    var Navigator = function (_Component) {
      (0, _inherits3.default)(Navigator, _Component);

      function Navigator(props) {
        (0, _classCallCheck3.default)(this, Navigator);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (Navigator.__proto__ || (0, _getPrototypeOf2.default)(Navigator)).call(this, props));

        _this2.handlers = [];
        (0, _keys2.default)(spec).forEach(function (hook) {
          var matchingEvent = (0, _fp.find)(function (e) {
            return e.name === hook;
          }, events);
          !(0, _fp.isNil)(matchingEvent) && _this2.handlers.push(new EventHandler(matchingEvent.name, spec[hook].bind(_this2)));
        });
        return _this2;
      }

      (0, _createClass3.default)(Navigator, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.handlers.forEach(function (h) {
            return h.restoreHandler();
          });
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(BaseComponent, this.props);
        }
      }]);
      return Navigator;
    }(_react.Component);

    return Navigator;
  };
};

exports.default = withNavigator;
module.exports = exports['default'];

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.Import.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(70);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1174);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(136);

var _Izenda8 = __webpack_require__(2545);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(1173);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportFile = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ImportFile, _Component);

  function ImportFile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ImportFile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportFile.__proto__ || (0, _getPrototypeOf2.default)(ImportFile)).call.apply(_ref, [this].concat(args))), _this), _this.handleDropFiles = function (files) {
      var _this$props = _this.props,
          store = _this$props.store,
          loader = _this$props.loader;

      loader.startLoading();
      store.uploadFiles(files).then(_this.handleAfterUploadFiles).finally(loader.endLoading.bind(loader));
    }, _this.handleAfterUploadFiles = function () {
      var _this$props2 = _this.props,
          store = _this$props2.store,
          invalidFileMessages = _this$props2.store.model.invalidFileMessages;

      if (!(0, _fp.isEmpty)(invalidFileMessages)) {
        _this.props.openPopup(_Izenda6.default, { messages: invalidFileMessages, store: store });
      }

      return (0, _bluebird.resolve)();
    }, _this.renderDropzone = function (_ref2) {
      var isOver = _ref2.isOver;
      var localization = _this.props.localization;

      var classes = (0, _classnames2.default)('izenda-ImportFile-description', { isOver: isOver });
      return _react2.default.createElement(
        'div',
        { className: classes },
        localization.getText('IMPORT_LABEL_DRAG_AND_DROP_FILES')
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ImportFile, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          localization = _props.localization,
          store = _props.store;

      var options = {
        baseUrl: 'importManagement/file',
        param: {
          batchId: String.newGuid()
        },
        requestHeaders: (0, _Izenda4.default)().getAuthHeader(),
        chooseAndUpload: true,
        multiple: true,
        accept: (0, _fp.join)([_Izenda7.FILE_EXTENSION.REPORT, _Izenda7.FILE_EXTENSION.DASHBOARD], ','),
        wrapperDisplay: 'inline',
        uploadSuccess: function uploadSuccess(content) {
          store.createImportContent(content);
          _this2.handleAfterUploadFiles();
        }
      };

      return _react2.default.createElement(
        'div',
        { className: 'u_flexVertical u_alignItemCenter u_flexJustifyCenter u_fullHeight' },
        _react2.default.createElement(_Izenda9.default, { onDrop: this.handleDropFiles, render: this.renderDropzone }),
        _react2.default.createElement(
          'span',
          { className: 'u_marginAll' },
          localization.getText('COMMON_LABEL_OR')
        ),
        _react2.default.createElement(_Izenda11.default, { isHighlight: false, options: options })
      );
    }
  }]);
  return ImportFile;
}(_react.Component)) || _class);
exports.default = ImportFile;
module.exports = exports['default'];

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(9);

var _reactDnd = __webpack_require__(378);

var _reactDndHtml5Backend = __webpack_require__(1124);

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Target = function Target(_ref) {
  var canDrop = _ref.canDrop,
      isOver = _ref.isOver,
      connectDropTarget = _ref.connectDropTarget,
      render = _ref.render;
  return _react2.default.createElement(
    _reactDnd.DragDropContextProvider,
    { backend: _reactDndHtml5Backend2.default },
    connectDropTarget(_react2.default.createElement(
      'div',
      null,
      render({ canDrop: canDrop, isOver: isOver })
    ))
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.FileDropzone.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FileDropzone = (0, _recompose.compose)((0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default), (0, _reactDnd.DropTarget)(function (_ref2) {
  var accepts = _ref2.accepts;
  return accepts || [_reactDndHtml5Backend.NativeTypes.FILE];
}, {
  drop: function drop(props, monitor) {
    if (monitor) {
      var _monitor$getItem = monitor.getItem(),
          files = _monitor$getItem.files;

      props.onDrop(files, monitor.internalMonitor);
    }
  }
}, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
}))(Target);

FileDropzone.displayName = 'FileDropzone';
FileDropzone.propTypes = {
  onDrop: _propTypes2.default.func.isRequired,
  render: _propTypes2.default.func.isRequired,
  accepts: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = FileDropzone;
module.exports = exports['default'];

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingList.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(44);

var _Izenda2 = __webpack_require__(136);

var _Izenda3 = __webpack_require__(47);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2547);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectValidator = (0, _Izenda6.default)()(_Izenda4.default);
var TABLE_DEF = _Izenda2.TableDefinition.DatabaseMappingSourceType;

var DatabaseMappingList = (_dec = (0, _Izenda10.default)(_Izenda8.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(DatabaseMappingList, _Component);

  function DatabaseMappingList(props) {
    (0, _classCallCheck3.default)(this, DatabaseMappingList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DatabaseMappingList.__proto__ || (0, _getPrototypeOf2.default)(DatabaseMappingList)).call(this, props));

    _this.renderDatabaseNameFrom = function (data) {
      var fromDatabaseName = data.fromDatabaseName,
          serverType = data.serverType;

      var label = '[' + serverType + '] ' + fromDatabaseName;
      return _react2.default.createElement(
        'span',
        { className: 'truncate overflow-text', title: label },
        label
      );
    };

    _this.renderSchemaFrom = function (_ref) {
      var fromSchema = _ref.fromSchema;

      return _react2.default.createElement(
        'span',
        { className: 'truncate overflow-text', title: fromSchema },
        fromSchema
      );
    };

    _this.renderDatabaseNameTo = function (data, columnKey, index) {
      var selectedToDatabaseNameId = data.selectedToDatabaseNameId;

      var databaseNamesTo = _this.props.store.databaseNamesTo;
      (0, _fp.forEach)(function (item) {
        item.label = '[' + item.serverTypeName + '] ' + item.name;
      }, databaseNamesTo);

      return _react2.default.createElement(SelectValidator, {
        scalable: false,
        options: databaseNamesTo,
        simpleValue: true,
        labelKey: 'label',
        valueKey: 'id',
        value: selectedToDatabaseNameId,
        onChange: _this.props.onChangeToDatabaseName.bind(_this, data),
        validations: _Izenda2.REQUIRED_VALIDATION_RULES,
        field: _Izenda2.KEY_TO_DATABASE_NAME,
        group: index.toString()
      });
    };

    _this.renderSchemaTo = function (data, columnKey, index) {
      var selectedToSchemaId = data.selectedToSchemaId,
          toSchemas = data.toSchemas;


      return _react2.default.createElement(SelectValidator, {
        scalable: false,
        simpleValue: true,
        options: toSchemas,
        labelKey: 'value',
        valueKey: 'key',
        value: selectedToSchemaId,
        onChange: data.setSelectedToSchema.bind(data),
        validations: _Izenda2.REQUIRED_VALIDATION_RULES,
        field: _Izenda2.KEY_TO_SCHEMA,
        group: index.toString()
      });
    };

    return _this;
  }

  (0, _createClass3.default)(DatabaseMappingList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          store = _props.store;

      var newHeight = _Izenda2.DEFAULT_DATABASE_MAPPING_HEIGHT;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'panel-heading u-bgWhite' },
          _react2.default.createElement(
            'strong',
            null,
            ' ',
            localization.getText('CONTEXT_MENU_LABEL_DATABASE_MAPPING')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'u-bgWhite izenda-DatabaseMapping' },
          _react2.default.createElement(
            _Izenda.Table,
            { minHeight: newHeight, maxHeight: newHeight, dataSource: store.model.databaseMappings, sortInfo: true },
            _react2.default.createElement(
              _Izenda.ColumnGroup,
              { title: localization.getText('COMMON_LABEL_FROM') },
              _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['physicalDatabase'], { cell: this.renderDatabaseNameFrom })),
              _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['schema'], { cell: this.renderSchemaFrom }))
            ),
            _react2.default.createElement(
              _Izenda.ColumnGroup,
              { title: localization.getText('COMMON_LABEL_TO') },
              _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['databaseName'], { cell: this.renderDatabaseNameTo })),
              _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF['schema'], { cell: this.renderSchemaTo }))
            )
          )
        )
      );
    }
  }]);
  return DatabaseMappingList;
}(_react.Component)) || _class);
exports.default = DatabaseMappingList;
module.exports = exports['default'];

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(136);

/**
 * Handle when change selected to database name
 * @param {Object} props
 * @param {Object} data
 * @param {string} id
 * @param {string} value
 */
function onChangeToDatabaseName(props, data, id, value) {
  var store = props.store,
      model = props.store.model;


  store.getSchemas(id).then(function (schemas) {
    var groupIndexs = model.updateSelectedToDatabaseName(data, id, value, schemas);
    groupIndexs.forEach(function (item) {
      props.validation.reset(_Izenda.KEY_TO_DATABASE_NAME, item);
    });
  });
}
// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMappingListActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _recompose.withHandlers)({
  onChangeToDatabaseName: (0, _fp.curry)(onChangeToDatabaseName)
});
module.exports = exports['default'];

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistory.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2549);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2551);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2553);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportHistory = (_dec = (0, _Izenda8.default)(_Izenda6.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ImportHistory, _Component);

  function ImportHistory() {
    (0, _classCallCheck3.default)(this, ImportHistory);
    return (0, _possibleConstructorReturn3.default)(this, (ImportHistory.__proto__ || (0, _getPrototypeOf2.default)(ImportHistory)).apply(this, arguments));
  }

  (0, _createClass3.default)(ImportHistory, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.disposeChangeTenant();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          loadHistories = _props.loadHistories;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-Import izenda-TableLayout' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-TableLayout-Cell' },
          _react2.default.createElement(
            'section',
            { className: 'izenda-Wrapper' },
            _react2.default.createElement(_Izenda2.default, { store: store, loadHistories: loadHistories }),
            _react2.default.createElement(_Izenda4.default, { store: store, loadHistories: loadHistories })
          )
        )
      );
    }
  }]);
  return ImportHistory;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object,
  loadHistories: _propTypes2.default.func,
  disposeChangeTenant: _propTypes2.default.func
}, _temp)) || _class);
exports.default = ImportHistory;
module.exports = exports['default'];

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryBar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(30);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(86);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda5 = __webpack_require__(2550);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportHistoryBar = (_dec = (0, _Izenda8.default)(_Izenda6.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ImportHistoryBar, _Component);

  function ImportHistoryBar() {
    (0, _classCallCheck3.default)(this, ImportHistoryBar);
    return (0, _possibleConstructorReturn3.default)(this, (ImportHistoryBar.__proto__ || (0, _getPrototypeOf2.default)(ImportHistoryBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(ImportHistoryBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          model = _props.store.model;


      return _react2.default.createElement(
        'section',
        { className: 'izenda-Wrapper-header' },
        _react2.default.createElement(_Izenda4.default, { className: 'u_marginRightInnerSpace' }),
        _react2.default.createElement(
          'div',
          { className: 'izenda-ActionBarRight' },
          _react2.default.createElement(_Izenda2.default, {
            disabled: model.isNoChecked,
            onClick: this.props.handleDelete,
            label: localization.getText('COMMON_LABEL_DELETE')
          })
        )
      );
    }
  }]);
  return ImportHistoryBar;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object,
  loadHistories: _propTypes2.default.func
}, _temp)) || _class);
exports.default = ImportHistoryBar;
module.exports = exports['default'];

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

/**
 * Handle delete selected item
 * @param {Object} props
 * @param {Object} data
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryBarActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function handleDelete(props, data) {
  var store = props.store,
      _props$store = props.store,
      model = _props$store.model,
      _props$store$model = _props$store.model,
      historyFiles = _props$store$model.historyFiles,
      pageIndex = _props$store$model.pageIndex;


  props.confirmFn('Information', {
    description: props.localization.getText('IMPORT_DELETE_SELECTED_MESSAGE'),
    type: 'warning',
    showCloseIndicator: false
  }).then(function () {
    store.deleteHistories().then(function (response) {
      var success = response.success;

      if (success) {
        // Check if delete all in page, return previous page
        if (historyFiles.length === model.getSelectedIds().length && pageIndex > 1) {
          model.updatePageIndex(pageIndex - 1);
        }
        props.loadHistories();
      }
      return (0, _bluebird.resolve)(success);
    });
  });
}

var actions = (0, _recompose.withHandlers)({
  handleDelete: (0, _fp.curry)(handleDelete)
});

exports.default = actions;
module.exports = exports['default'];

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryList.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(44);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda2 = __webpack_require__(17);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(97);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(1176);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(2552);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(15);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(83);

var _Izenda14 = _interopRequireDefault(_Izenda13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TABLE_DEF = _Izenda6.TableDefinition.ImportHistorySourceType;

var ImportHistoryList = (_dec = (0, _Izenda10.default)(_Izenda8.default, _Izenda14.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ImportHistoryList, _Component);

  function ImportHistoryList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ImportHistoryList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImportHistoryList.__proto__ || (0, _getPrototypeOf2.default)(ImportHistoryList)).call.apply(_ref, [this].concat(args))), _this), _this.setDom = function (dom) {
      _this.domNode = dom;
    }, _this.renderSelectCell = function (dataItem) {
      return _react2.default.createElement('input', {
        type: 'checkbox',
        checked: dataItem.isSelected,
        onChange: _this.props.handleCheckItem.bind(_this.props, dataItem)
      });
    }, _this.renderTextCell = function (dataItem, columnKey) {
      return _react2.default.createElement(
        'span',
        { className: 'truncate overflow-text', title: dataItem[columnKey] },
        dataItem[columnKey]
      );
    }, _this.renderDateCell = function (dataItem) {
      return _react2.default.createElement(
        'span',
        { className: 'truncate overflow-text', title: dataItem.dateLabel },
        dataItem.dateLabel
      );
    }, _this.renderActionCell = function (dataItem) {
      var handleDeleteItem = _this.props.handleDeleteItem;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          { className: 'action-column' },
          _react2.default.createElement('span', { className: 'icon-cancel', onClick: handleDeleteItem.bind(_this.props, dataItem) })
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Set dom
   * @param {Object} dom
   */


  (0, _createClass3.default)(ImportHistoryList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var model = this.props.store.model;

      if (model.tableHeight != this.domNode.clientHeight) {
        model.setTableHeight(this.domNode.clientHeight);
      }
      model.resetPageInfo();
      this.props.loadHistories();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var model = this.props.store.model;


      model.setTableHeight(nextProps.height);
    }

    /**
     * Render checkbox cell
     * @param {Object} dataItem
     */


    /**
     * Render label cell
     * @param {Object} dataItem
     * @param {String} columnKey
     */


    /**
     * Render date cell
     * @param {Object} dataItem
     */


    /**
     * Render action cell
     * @param {Object} dataItem
     */

  }, {
    key: 'renderColumns',


    /**
     * Render columns
     */
    value: function renderColumns() {
      var _this2 = this;

      var _props = this.props,
          _props$store$model = _props.store.model,
          isAllChecked = _props$store$model.isAllChecked,
          isEmptyHistories = _props$store$model.isEmptyHistories,
          handleCheckAll = _props.handleCheckAll;

      var checkBoxSelectAllProps = {
        onChange: handleCheckAll,
        type: 'checkbox',
        checked: isAllChecked,
        disabled: isEmptyHistories
      };

      var selectRowDefinition = (0, _fp.merge)(TABLE_DEF['select'], {
        headerComponent: _Izenda3.default,
        headerComponentProps: checkBoxSelectAllProps
      });

      return (0, _fp.map)(function (item) {
        switch (item.key) {
          case 'select':
            return _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, selectRowDefinition, { align: 'center', cell: _this2.renderSelectCell }));
          case 'fileName':
          case 'typeName':
          case 'modifiedBy':
          case 'statusName':
          case 'errorMessage':
          case 'objectName':
          case 'categoryName':
          case 'subCategoryName':
            return _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, item, { cell: _this2.renderTextCell }));
          case 'modified':
            return _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, item, { cell: _this2.renderDateCell }));
          case 'saveInto':
            return !_Izenda12.default.tenantId && _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, item, { cell: _this2.renderTextCell })); // Only show in System mode
          case 'action':
            return _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, item, { align: 'center', cell: _this2.renderActionCell }));
          default:
            return _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, item, { cell: _this2.renderTextCell }));
        }
      }, (0, _fp.values)(TABLE_DEF));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$store$model2 = this.props.store.model,
          tableHeight = _props$store$model2.tableHeight,
          historyFiles = _props$store$model2.historyFiles,
          sortInfo = _props$store$model2.sortInfo,
          total = _props$store$model2.total,
          pageSize = _props$store$model2.pageSize,
          pageIndex = _props$store$model2.pageIndex;

      var newHeight = this.props.height > 0 ? this.props.height - _Izenda6.DEFAULT_REST_HEIGHT : tableHeight - _Izenda6.DEFAULT_REST_HEIGHT;

      return _react2.default.createElement(
        'section',
        { className: 'izenda-Wrapper-content', ref: this.setDom },
        _react2.default.createElement(
          'div',
          { className: 'u_fullHeight u_paddingLeftRight' },
          _react2.default.createElement(
            _Izenda.Table,
            {
              maxHeight: newHeight,
              minHeight: newHeight,
              dataSource: historyFiles,
              onSortChange: this.props.onSortChange,
              sortInfo: sortInfo,
              staticRender: true
            },
            this.renderColumns()
          ),
          _react2.default.createElement(_Izenda5.default, {
            onChange: this.props.goToPage.bind(this.props),
            onDropdownChange: this.props.onPageSizeChange.bind(this.props),
            totalRecords: total,
            pageSize: pageSize,
            pageIndex: pageIndex
          })
        )
      );
    }
  }]);
  return ImportHistoryList;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object,
  loadHistories: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = ImportHistoryList;
module.exports = exports['default'];

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

/**
 * Handle check all
 * @param {Object} props
 * @param {Object} data
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryListActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function handleCheckAll(props, data) {
  var model = props.store.model;


  if (!(0, _fp.isEmpty)(model.historyFiles)) {
    model.updateCheckAll();
  }
}

/**
 * Handle check each item
 * @param {Object} props
 * @param {Object} data
 */
function handleCheckItem(props, data) {
  data.updateSelected();
}

/**
 * Handle delete item
 * @param {Object} props
 * @param {Object} data
 */
function handleDeleteItem(props, data) {
  var store = props.store,
      _props$store = props.store,
      model = _props$store.model,
      _props$store$model = _props$store.model,
      historyFiles = _props$store$model.historyFiles,
      pageIndex = _props$store$model.pageIndex;
  var fileName = data.fileName;

  props.confirmFn('Information', {
    description: String.format(props.localization.getText('IMPORT_DELETE_MESSAGE'), fileName),
    type: 'warning',
    showCloseIndicator: false
  }).then(function () {
    store.deleteHistories(data).then(function (success) {
      if (success) {
        // Check if delete all in page, return previous page
        if (historyFiles.length === 1 && pageIndex > 1) {
          model.updatePageIndex(pageIndex - 1);
        }
        props.loadHistories();
      }
      return (0, _bluebird.resolve)(success);
    });
  });
}

/**
 * Go to page
 * @param {Object} props
 * @param {Number} pageIndex
 */
function goToPage(props, pageIndex) {
  var model = props.store.model;

  model.updatePageIndex(pageIndex);

  props.loadHistories();
}

/**
 * On page size change
 * @param {Object} props
 * @param {Number} pageSize
 */
function onPageSizeChange(props, pageSize) {
  var model = props.store.model;

  model.updatePageSize(pageSize);

  props.loadHistories();
}

/**
 *On sort change, only support single-sort
 * @param {Object} props
 * @param {string} columnKey
 * @param {*} sortDir
 */
function onSortChange(props, columnKey, sortDir) {
  var model = props.store.model;

  model.setSortInfo(columnKey, sortDir); // Set to show in UI

  props.loadHistories();
}

var actions = (0, _recompose.withHandlers)({
  handleCheckAll: (0, _fp.curry)(handleCheckAll),
  handleCheckItem: (0, _fp.curry)(handleCheckItem),
  handleDeleteItem: (0, _fp.curry)(handleDeleteItem),
  goToPage: (0, _fp.curry)(goToPage),
  onPageSizeChange: (0, _fp.curry)(onPageSizeChange),
  onSortChange: (0, _fp.curry)(onSortChange)
});

exports.default = actions;
module.exports = exports['default'];

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2554);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actions = (0, _recompose.withProps)(function (props) {
  var store = new _Izenda2.default();
  var loader = props.loader;

  var loadHistories = function loadHistories() {
    loader.startLoading();
    store.loadData().finally(loader.endLoading.bind(loader));
  };
  var disposeChangeTenant = (0, _mobx.reaction)(function () {
    store.model.resetPageInfo();
    return store.tenantId;
  }, loadHistories);

  return {
    store: store,
    loadHistories: loadHistories,
    disposeChangeTenant: disposeChangeTenant
  };
});
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = actions;
module.exports = exports['default'];

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(54);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2555);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(630);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportHistoryStore = (0, _Izenda4.default)(_class = (_class2 = function () {
  (0, _createClass3.default)(ImportHistoryStore, [{
    key: 'tenantId',
    get: function get() {
      return _Izenda2.default.getTenantId();
    }
  }]);

  function ImportHistoryStore() {
    (0, _classCallCheck3.default)(this, ImportHistoryStore);

    _initDefineProp(this, 'model', _descriptor, this);

    _initDefineProp(this, 'response', _descriptor2, this);

    this.model = new _Izenda6.default();
  }

  /**
   * Load data
   */


  (0, _createClass3.default)(ImportHistoryStore, [{
    key: 'loadData',
    value: function loadData() {
      var _this = this;

      var data = this.model.getRequestPage(this.tenantId);

      return _Izenda8.default.loadImportHistories(data).then(function (response) {
        _this.response = response;
        _this.populate(_this.response);

        return (0, _bluebird.resolve)(response);
      });
    }

    /**
     * Delete history 1 file or multiples
     * @param {Object} historyFile
     * @returns {Promise}
     */

  }, {
    key: 'deleteHistories',
    value: function deleteHistories(historyFile) {
      var historiesToDelete = [];
      this.model.deletedId = '';

      if ((0, _fp.isNil)(historyFile)) {
        historiesToDelete = this.model.getSelectedIds(); // If not put in parameter, delete selected histories
      } else {
        historiesToDelete.push(historyFile.id);
        this.model.deletedId = historyFile.id;
      }

      return _Izenda8.default.deleteHistories(historiesToDelete);
    }

    /**
     * Populate model
     * @param {Object} response
     */

  }, {
    key: 'populate',
    value: function populate(response) {
      this.model.populate(response);
    }
  }]);
  return ImportHistoryStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'model', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'response', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'tenantId'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteHistories', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteHistories'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populate', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populate'), _class2.prototype)), _class2)) || _class;

exports.default = ImportHistoryStore;
module.exports = exports['default'];

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistory.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2556);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1176);

var _Izenda4 = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportHistory = (_class = function () {
  function ImportHistory() {
    (0, _classCallCheck3.default)(this, ImportHistory);

    _initDefineProp(this, 'historyFiles', _descriptor, this);

    _initDefineProp(this, 'deletedId', _descriptor2, this);

    _initDefineProp(this, 'tableHeight', _descriptor3, this);

    _initDefineProp(this, 'pageIndex', _descriptor4, this);

    _initDefineProp(this, 'total', _descriptor5, this);

    _initDefineProp(this, 'pageSize', _descriptor6, this);

    _initDefineProp(this, 'sortOrders', _descriptor7, this);

    _initDefineProp(this, 'isLastPage', _descriptor8, this);

    _initDefineProp(this, 'sortInfo', _descriptor9, this);
  }

  // For paging
  // Use to send through APIs


  (0, _createClass3.default)(ImportHistory, [{
    key: 'setTableHeight',
    // Use in UI

    /**
     * Set table height
     */
    value: function setTableHeight(tableHeight) {
      this.tableHeight = tableHeight;
    }

    /**
     * Find suitable page index
     * @returns {number}
     */

  }, {
    key: 'findSuitablePageIndex',
    value: function findSuitablePageIndex() {
      var maxRows = (this.tableHeight - _Izenda3.DEFAULT_REST_HEIGHT) / _Izenda3.DEFAULT_ROW_HEIGHT;
      return (0, _fp.find)(function (size) {
        return maxRows <= size;
      }, _Izenda4.PAGING_SIZE_OPTIONS) || (0, _fp.last)(_Izenda4.PAGING_SIZE_OPTIONS);
    }

    /**
     * Get if all are checked
     * @returns {Boolean}
     */

  }, {
    key: 'resetPageInfo',
    value: function resetPageInfo() {
      this.pageIndex = 1;
      this.total = 0;
      this.pageSize = this.findSuitablePageIndex();
      this.sortInfo = {};
      this.sortOrders = [];
      this.isLastPage = true;

      this.deletedId = '';
      this.resetHistoryFiles();
    }

    /**
     * Check if historyFiles is empty, to disable button delete or not
     * @returns {Boolean}
     */

  }, {
    key: 'resetHistoryFiles',
    value: function resetHistoryFiles() {
      this.historyFiles = [];
    }

    /**
     * Populate history files
     * @param {Object} response
     */

  }, {
    key: 'populate',
    value: function populate(response) {
      var _this = this;

      var result = response.result,
          total = response.total,
          isLastPage = response.isLastPage;


      this.total = total;
      this.isLastPage = isLastPage;

      var selectedIds = (0, _fp.isEmpty)(this.deletedId) ? [] : (0, _fp.filter)(function (id) {
        return id != _this.deletedId;
      }, this.getSelectedIds());

      this.historyFiles = (0, _fp.map)(function (historyFile) {
        return new _Izenda2.default(historyFile, (0, _fp.includes)(historyFile.id, selectedIds));
      }, result);

      this.deletedId = '';
    }

    /**
     * Update check all items
     */

  }, {
    key: 'updateCheckAll',
    value: function updateCheckAll() {
      var shouldAllChecked = !this.isAllChecked; // Keep the next status of check all, hard-set to every item

      (0, _fp.forEach)(function (historyFile) {
        historyFile.updateSelected(shouldAllChecked);
      }, this.historyFiles);
    }

    /**
     * Get data to request page
     * @param {String} tenantId
     * @returns {Object}
     */

  }, {
    key: 'getRequestPage',
    value: function getRequestPage(tenantId) {
      var pageIndex = this.pageIndex,
          pageSize = this.pageSize,
          sortOrders = this.sortOrders;

      return { tenantId: tenantId, pageIndex: pageIndex, pageSize: pageSize, sortOrders: sortOrders };
    }

    /**
     * Update page index selected
     * @param {Number} pageIndex
     */

  }, {
    key: 'updatePageIndex',
    value: function updatePageIndex(pageIndex) {
      this.pageIndex = pageIndex;
    }

    /**
     * Update page size of table
     * @param {Number} pageSize
     */

  }, {
    key: 'updatePageSize',
    value: function updatePageSize(pageSize) {
      this.pageSize = pageSize;
      this.pageIndex = 1;
    }

    /**
     * Get selected histories'id
     * @returns {Array<String>}
     */

  }, {
    key: 'getSelectedIds',
    value: function getSelectedIds() {
      var selectedIds = [];

      (0, _fp.forEach)(function (historyFile) {
        if (historyFile.isSelected) {
          selectedIds.push(historyFile.id);
        }
      }, this.historyFiles);

      return selectedIds;
    }

    /**
     * Set sort info in UI, but only SET ONE at time
     * @param {String} columnKey
     * @param {String} sortDir
     */

  }, {
    key: 'setSortInfo',
    value: function setSortInfo(columnKey, sortDir) {
      this.sortInfo = {};
      this.sortOrders = [];

      if (!(0, _fp.isEmpty)(sortDir)) {
        this.sortInfo[columnKey] = sortDir; // Single-sort
        this.sortOrders.push({
          key: columnKey,
          descending: sortDir === 'DESC' ? true : false
        });
      }
    }
  }, {
    key: 'isAllChecked',
    get: function get() {
      return !(0, _fp.isEmpty)(this.historyFiles) && (0, _fp.every)({ isSelected: true }, this.historyFiles);
    }

    /**
     * Get if not any checked, to disable button delete
     */

  }, {
    key: 'isNoChecked',
    get: function get() {
      return (0, _fp.isEmpty)(this.historyFiles) || (0, _fp.every)({ isSelected: false }, this.historyFiles);
    }

    /**
     * Reset page info when change tenant
     */

  }, {
    key: 'isEmptyHistories',
    get: function get() {
      return (0, _fp.isEmpty)(this.historyFiles);
    }

    /**
     * Reset after reloading
     */

  }]);
  return ImportHistory;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'historyFiles', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'deletedId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'tableHeight', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'pageIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'total', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'pageSize', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 10;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'sortOrders', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'isLastPage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'sortInfo', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setTableHeight', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setTableHeight'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'findSuitablePageIndex', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'findSuitablePageIndex'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isAllChecked', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isAllChecked'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isNoChecked', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isNoChecked'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetPageInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetPageInfo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isEmptyHistories', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isEmptyHistories'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetHistoryFiles', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetHistoryFiles'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'populate', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'populate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateCheckAll', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateCheckAll'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getRequestPage', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getRequestPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updatePageIndex', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updatePageIndex'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updatePageSize', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updatePageSize'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getSelectedIds', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getSelectedIds'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSortInfo', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setSortInfo'), _class.prototype)), _class);
exports.default = ImportHistory;
module.exports = exports['default'];

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFileContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(88);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ImportHistoryFileContent = (_class = function () {

  /**
   * Constructor
   * @param {Object} content
   * @param {Boolean} isSelected
   */
  function ImportHistoryFileContent(content, isSelected) {
    (0, _classCallCheck3.default)(this, ImportHistoryFileContent);

    _initDefineProp(this, 'isSelected', _descriptor, this);

    _initDefineProp(this, 'id', _descriptor2, this);

    _initDefineProp(this, 'fileKey', _descriptor3, this);

    _initDefineProp(this, 'fileName', _descriptor4, this);

    _initDefineProp(this, 'type', _descriptor5, this);

    _initDefineProp(this, 'typeName', _descriptor6, this);

    _initDefineProp(this, 'modified', _descriptor7, this);

    _initDefineProp(this, 'modifiedBy', _descriptor8, this);

    _initDefineProp(this, 'status', _descriptor9, this);

    _initDefineProp(this, 'statusName', _descriptor10, this);

    _initDefineProp(this, 'errorCode', _descriptor11, this);

    _initDefineProp(this, 'errorMessage', _descriptor12, this);

    _initDefineProp(this, 'objectId', _descriptor13, this);

    _initDefineProp(this, 'objectName', _descriptor14, this);

    _initDefineProp(this, 'saveInto', _descriptor15, this);

    _initDefineProp(this, 'categoryId', _descriptor16, this);

    _initDefineProp(this, 'categoryName', _descriptor17, this);

    _initDefineProp(this, 'subCategoryId', _descriptor18, this);

    _initDefineProp(this, 'subCategoryName', _descriptor19, this);

    _initDefineProp(this, 'subCategory', _descriptor20, this);

    var id = content.id,
        fileKey = content.fileKey,
        fileName = content.fileName,
        type = content.type,
        typeName = content.typeName,
        modified = content.modified,
        modifiedBy = content.modifiedBy,
        status = content.status,
        statusName = content.statusName,
        errorCode = content.errorCode,
        errorMessage = content.errorMessage,
        objectId = content.objectId,
        objectName = content.objectName,
        saveInto = content.saveInto,
        categoryId = content.categoryId,
        categoryName = content.categoryName,
        subCategoryId = content.subCategoryId,
        subCategoryName = content.subCategoryName;


    this.id = id;
    this.fileKey = fileKey;
    this.fileName = fileName;
    this.type = type;
    this.typeName = typeName;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
    this.status = status;
    this.statusName = statusName;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.objectId = objectId;
    this.objectName = objectName;
    this.saveInto = saveInto;
    this.categoryId = categoryId;
    this.categoryName = categoryName;
    this.subCategoryId = subCategoryId;
    this.subCategoryName = subCategoryName;

    // Remember previous status isChecked
    if (isSelected) {
      this.isSelected = true;
    }
  }

  /**
   * Update selected
   * @param {boolean} value
   */


  (0, _createClass3.default)(ImportHistoryFileContent, [{
    key: 'updateSelected',
    value: function updateSelected(value) {
      if (typeof value === 'undefined') {
        this.isSelected = !this.isSelected;
      } else {
        this.isSelected = value;
      }
    }

    /**
     * Convert date time
     * @returns {string}
     */

  }, {
    key: 'dateLabel',
    get: function get() {
      return (0, _Izenda4.default)(_Izenda2.default.currentUser.dateFormat, this.modified);
    }
  }]);
  return ImportHistoryFileContent;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isSelected', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'fileKey', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'fileName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'typeName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'modified', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'modifiedBy', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'status', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'statusName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'errorCode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'errorMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'objectId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, 'objectName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, 'saveInto', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, 'categoryId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, 'categoryName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, 'subCategoryId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, 'subCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, 'subCategory', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'updateSelected', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateSelected'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'dateLabel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'dateLabel'), _class.prototype)), _class);
exports.default = ImportHistoryFileContent;
module.exports = exports['default'];

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingLevel.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _fp = __webpack_require__(1);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(245);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(167);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(104);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SettingLevel = (_dec = (0, _mobx.action)('loadInitial'), _dec2 = (0, _mobx.action)('readSystemMode'), _dec3 = (0, _mobx.action)('readTenants'), (_class = function () {
  (0, _createClass3.default)(SettingLevel, [{
    key: 'selectedTenant',
    get: function get() {
      return _Izenda6.default.tenantId;
    }
  }, {
    key: 'disableRoleDropdown',
    get: function get() {
      return this.disableSystemSetting || _Izenda6.default.onlyShowTenant || !_Izenda6.default.currentUser.systemAdmin;
    }
  }, {
    key: 'disableSystemSetting',
    get: function get() {
      return _Izenda6.default.disableSystemSetting || _Izenda6.default.systemMode;
    }
  }]);

  function SettingLevel(store) {
    (0, _classCallCheck3.default)(this, SettingLevel);

    _initDefineProp(this, 'tenants', _descriptor, this);

    this.store = store;
    this.availableLevels = (0, _fp.filter)(function (availableLevel) {
      return _Izenda6.default.currentUser.isSystemUser || availableLevel.value !== 'System';
    }, _Izenda4.default.availableLevels);
  }

  /**
   * get selected level
   */


  (0, _createClass3.default)(SettingLevel, [{
    key: 'selectedLevel',
    value: function selectedLevel() {
      return _Izenda6.default.tenantId || _Izenda6.default.onlyShowTenant ? 'Tenant' : 'System';
    }

    /**
     * show tenants
     */

  }, {
    key: 'showTenants',
    value: function showTenants() {
      return this.selectedLevel() === 'Tenant';
    }

    /**
     * Load initial
     * @param {number} systemMode
     */

  }, {
    key: 'loadInitial',
    value: function loadInitial(systemMode) {
      this.readSystemMode(systemMode);
    }

    /**
     * Read system mode
     * @param {number} systemMode
     */

  }, {
    key: 'readSystemMode',
    value: function readSystemMode(systemMode) {
      this.systemMode = systemMode;
      _Izenda6.default.systemMode = systemMode;
    }

    /**
     * Read tenants
     * @param {boolean} shouldLoadDefaultTenant
     * @param {array} tenants
     */

  }, {
    key: 'readTenants',
    value: function readTenants(shouldLoadDefaultTenant, tenants) {
      this.tenants = tenants;
      if (shouldLoadDefaultTenant && (0, _fp.isNil)(this.selectedTenant)) {
        this.setSelectedTenant((0, _fp.isEmpty)(this.tenants) ? null : this.tenants[0].id);
      }
    }

    /**
     * Change tenant
     */

  }, {
    key: 'changeTenant',
    value: function changeTenant(change) {
      this.setSelectedTenant(change.value);
    }

    /**
     * Set tenant ID of UIState
     */

  }, {
    key: 'setSelectedTenant',
    value: function setSelectedTenant(tenantId) {
      var currentTenantId = _Izenda6.default.tenantId;
      _Izenda6.default.setTenantId(tenantId);
      // Store in cookie
      !!tenantId ? _Izenda2.default.setSelectedTenant(tenantId) : _Izenda2.default.removeSelectedTenant();

      if (tenantId !== currentTenantId) {
        _Izenda8.default.loadAppSettings();
      }
    }
  }]);
  return SettingLevel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'tenants', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'selectedTenant', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectedTenant'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'disableRoleDropdown', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'disableRoleDropdown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'disableSystemSetting', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'disableSystemSetting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadInitial', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadInitial'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readSystemMode', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readSystemMode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readTenants', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'readTenants'), _class.prototype)), _class));
exports.default = SettingLevel;
module.exports = exports['default'];

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseCheckerStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * License Checker Store
 */
!function () {

  var m = __webpack_require__(5);
  var databaseSetupDataFetcher = __webpack_require__(942);
  var systemSettingFetcher = __webpack_require__(75);
  var uiState = __webpack_require__(15);

  var DatabaseConfiguration = __webpack_require__(2559);
  var SystemModeSetting = __webpack_require__(2560);

  function LicenseCheckerStore() {
    this.databaseConfiguration = new DatabaseConfiguration();
    this.licenseInfoStore = __webpack_require__(565);
    this.systemModeSetting = new SystemModeSetting();

    m.observe(this.databaseConfiguration, function (change) {

      var connectionStatus = change.object;

      if (change.name === 'isValidConnection') {

        if (connectionStatus.isValidConnection) {
          this.licenseInfoStore.getLicenseInformation();
          this.licenseInfoStore.getLicenseStatus();
        } else {
          this.licenseInfoStore.licenseInfo.resetLicenseInfo();
        }
      }
    }.bind(this));
  }

  /**
   * Get init data (connection string)
   */
  LicenseCheckerStore.prototype.getInitData = function () {
    return (0, _bluebird.all)(this.getConnectionInfo(), this.loadSystemSetting());
  };

  /**
   * get suppported database type
   */
  LicenseCheckerStore.prototype.getSupportedDatabaseType = function () {
    return databaseSetupDataFetcher.getSupportedDatabaseType().then(function (response) {
      this.databaseConfiguration.updateSupportedDatabaseType(response);
    }.bind(this));
  };

  /**
   * Test connection string
   * @param {string} serverType
   * @param {string} connectionString
   */
  LicenseCheckerStore.prototype.testConnection = function () {
    var connectionInfo = this.databaseConfiguration.connectionInfo;

    return databaseSetupDataFetcher.testConnection(connectionInfo.serverTypeId, connectionInfo.connectionString).then(function (response) {
      response = response || {};

      this.databaseConfiguration.readTestConnectionStatus(response);

      return response.messages;
    }.bind(this));
  };

  /**
   * Setup Data base after test connection successfully
   * @param {string} serverType
   * @param {string} connectionString
   * @returns {promise}
   */
  LicenseCheckerStore.prototype.setupDatabase = function (resetDataInfo) {
    var connectionInfo = this.databaseConfiguration.connectionInfo;
    //reset dataInfo
    resetDataInfo && this.databaseConfiguration.resetDataInfo();
    return databaseSetupDataFetcher.setupDatabase(connectionInfo.serverTypeId, connectionInfo.connectionString).then(function (response) {
      this.databaseConfiguration.setValidConnection(response);
      if (response.success) {
        this.licenseInfoStore.getLicenseInformation();
        this.licenseInfoStore.getLicenseStatus();
        uiState.increaseDetectChangeVisibleConnection();
        uiState.increaseDetectChangeCount();
      }
      return response;
    }.bind(this));
  };

  /**
   * Get connection info
   * @returns {promise}
   */
  LicenseCheckerStore.prototype.getConnectionInfo = function () {

    return databaseSetupDataFetcher.getConnectionInfo().then(function (response) {

      this.databaseConfiguration.updateConnectionInfo(response);

      return null;
    }.bind(this));
  };

  /**
   * Save System Setting mode
   * @returns {promise}
   */
  LicenseCheckerStore.prototype.saveSystemSetting = m.action(function (data) {
    return systemSettingFetcher.saveSystemModeSettings(data).then(m.action(function (result) {
      result.success && (uiState.systemMode = data.systemMode);
      return result;
    }));
  });

  /**
   * Load System Setting mode
   * @returns {promise}
   */
  LicenseCheckerStore.prototype.loadSystemSetting = function () {
    return systemSettingFetcher.loadSystemModeSettings().then(this.systemModeSetting.readSystemModeSetting.bind(this.systemModeSetting));
  };

  module.exports = LicenseCheckerStore;
}();

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var constants = __webpack_require__(45);

  var _require = __webpack_require__(1),
      findLast = _require.findLast;

  function DatabaseConfiguration() {
    // for first time to get connection info
    this.hasValidConnection = false;
    this.differentDatabase = true;

    m.extendObservable(this, {
      supportedDatabaseType: [],
      connectionInfo: {},
      isValidConnection: false,
      validatedConnection: false,
      validationError: '',
      serverTypeName: function serverTypeName() {
        var serverTypeId = this.connectionInfo.serverTypeId;

        return findLast({ id: serverTypeId }, this.supportedDatabaseType).name;
      }
    });
  }

  /**
   * Get list of supported database types
   */
  DatabaseConfiguration.prototype.updateSupportedDatabaseType = function (supportedDatabaseTypes) {
    this.supportedDatabaseType = supportedDatabaseTypes;
  };

  /**
   * reset database connection information
   */
  DatabaseConfiguration.prototype.resetDataInfo = function () {
    this.isValidConnection = false;
  };

  /**
   * read connection status
   * @param  {object} status [status receive from api]
   */
  DatabaseConfiguration.prototype.readTestConnectionStatus = function (status) {
    m.transaction(function () {
      // After Validated connection string will be hidden
      this.validatedConnection = true;
      this.differentDatabase = status.differentDatabase;

      if (!status.success) {
        this.validationError = status.messages && status.messages[0];
      }
    }.bind(this));
  };

  /**
   * set isValidConnection value
   * @param {object} response
   * @param {string} connectionString
   */
  DatabaseConfiguration.prototype.setValidConnection = function (response) {
    this.isValidConnection = response.success;
  };

  /**
   * [update connection info]
   * @param  {object} response [response from api]
   */
  DatabaseConfiguration.prototype.updateConnectionInfo = function (response) {
    m.transaction(function () {
      this.validationError = '';
      this.connectionInfo = response;
      if (this.connectionInfo.serverTypeId === constants.SERVER_TYPE.UNKNOWN) {
        this.connectionInfo.serverTypeId = constants.SERVER_TYPE.MSSQL; // default server type is MSSQL
      }
      this.hasValidConnection = this.isValidConnection = this.validatedConnection = !!response.connectionString;
    }.bind(this));
  };

  /**
   * Update server type
   * @param {type} value
   */
  DatabaseConfiguration.prototype.updateServerType = function (value) {
    this.connectionInfo.serverTypeId = value;
    this.connectionInfo.connectionString = '';
    this.resetConnectionStatus();
  };

  /**
   * Update connection string
   * @param {type} value
   */
  DatabaseConfiguration.prototype.updateConnectionString = function (value) {
    this.connectionInfo.connectionString = value;

    this.resetConnectionStatus();
  };

  /**
   * Reset connection string
   */
  DatabaseConfiguration.prototype.resetConnectionString = function () {
    this.connectionInfo.connectionString = '';
  };

  /**
   * Reset connection status
   * @param {type} key
   * @param {type} value
   */
  DatabaseConfiguration.prototype.resetConnectionStatus = function () {
    if (this.validatedConnection) {
      this.validatedConnection = false;
    }
  };

  module.exports = DatabaseConfiguration;
}();

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemModeSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var extendObservable = __webpack_require__(5).extendObservable;
  var settingConstant = __webpack_require__(167);

  function SystemModeSetting() {
    var props = {
      systemMode: settingConstant.TENANT_MODE,
      allowDuplicateUser: true,
      isSingleMode: function isSingleMode() {
        return this.systemMode === settingConstant.SYSTEM_MODE;
      }
    };

    extendObservable(this, props);
  };

  /**
   * Read system mode setting drom API
   * @param  {object} data [receive from API]
   */
  SystemModeSetting.prototype.readSystemModeSetting = m.action(function (data) {
    this.systemMode = data.systemMode;
    this.allowDuplicateUser = data.allowDuplicateUser;
  });

  /**
   * Switch to single mode
   * @param {int} mode
   */
  SystemModeSetting.prototype.switchToSingle = m.action(function () {
    this.systemMode = settingConstant.SYSTEM_MODE;
    this.allowDuplicateUser = false;
  });

  /**
   * Switch to multi mode
   * @param {int} mode
   */
  SystemModeSetting.prototype.switchToMulti = m.action(function () {
    this.systemMode = settingConstant.TENANT_MODE;
    this.allowDuplicateUser = true;
  });

  /**
   * Allow duplicate user
   * @param {int} allowDuplicate
   */
  SystemModeSetting.prototype.updateAllowDuplicateUser = function (allowDuplicate) {
    this.allowDuplicateUser = allowDuplicate;
  };

  module.exports = SystemModeSetting;
}();

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2; // ----------------------------------------------------------------------
// <copyright file="Izenda.DataModelStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Data Model Store
 */


var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2562);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(617);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(191);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(15);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(198);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DataModelStore = (_class = function () {
  function DataModelStore() {
    (0, _classCallCheck3.default)(this, DataModelStore);

    _initDefineProp(this, 'activeLink', _descriptor, this);

    _initDefineProp(this, 'indicator', _descriptor2, this);

    this.dataModelMenu = _Izenda9.MENU;

    this.querySourceType = new _Izenda2.default();
    this.relationship = new _Izenda4.default();
  }

  (0, _createClass3.default)(DataModelStore, [{
    key: 'init',


    /**
     * observe to uiState
     */
    value: function init() {
      var _this = this;

      this.loadIndicator();
      !this.disposeObserveTenantID && (this.disposeObserveTenantID = (0, _mobx.observe)(_Izenda8.default, 'tenantId', function () {
        _this.loadIndicator();
      }));
    }

    /**
     * dispose observe
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this.disposeObserveTenantID && this.disposeObserveTenantID();
      this.disposeObserveTenantID = null;
    }

    /**
     * Update active Link
     */

  }, {
    key: 'changeSelectItem',
    value: function changeSelectItem(newLink) {
      this.activeLink = newLink;
    }

    /**
     * Load indicator for data model types
     */

  }, {
    key: 'loadIndicator',
    value: function loadIndicator() {
      var _this2 = this;

      var afterLoadIndicator = function afterLoadIndicator(result) {
        _this2.indicator = result;
        return null;
      };
      return _Izenda6.default.loadIndicator(_Izenda8.default.getTenantId()).then(afterLoadIndicator);
    }

    /**
     * Load indicator for a data model type by its backendType
     */

  }, {
    key: 'loadItemIndicator',
    value: function loadItemIndicator(backendType) {
      var marchingItem = (0, _fp.find)(function (o) {
        return o.key === backendType;
      }, this.indicator);

      return marchingItem && marchingItem.value;
    }
  }]);
  return DataModelStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'activeLink', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda9.QUERY_SOURCE_TYPE.TABLE;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'indicator', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'changeSelectItem', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'changeSelectItem'), _class.prototype)), _class);
exports.default = DataModelStore;
module.exports = exports['default'];

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _bluebird = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var QuerySourceType = __webpack_require__(159).QUERY_SOURCE_TYPE;
  var uiState = __webpack_require__(15);

  var BUNDLE = __webpack_require__(159).BUNDLE;

  var m = __webpack_require__(5);
  var action = __webpack_require__(5).action;
  var observable = __webpack_require__(5).observable;
  var concatArray = __webpack_require__(118).concatArray;
  var fetcher = __webpack_require__(191);

  var CategoryGridStore = __webpack_require__(1177);
  var QuerySourceTypeDetailsStore = __webpack_require__(2563);
  var Paging = __webpack_require__(98);
  var CommonMessages = __webpack_require__(37);

  var ExpressionSelection = __webpack_require__(988);
  var ExpressionFieldName = __webpack_require__(591);
  var ExpressionFunctionOperator = __webpack_require__(592);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      some = _require.some,
      map = _require.map,
      isNil = _require.isNil,
      omit = _require.omit,
      flatMap = _require.flatMap,
      findIndex = _require.findIndex,
      each = _require.each,
      clone = _require.clone,
      find = _require.find;

  function QuerySourceTypeStore() {
    // important - query source will decide which columns will be show
    this.hasDynamicFeature = false;

    m.extendObservable(this, {
      querySourceType: '',
      relationship: null,
      categoryList: new CategoryGridStore(),
      querySourceList: [],
      selectedQuerySource: null,
      isLoading: true,
      totalRecords: 0,
      pageInfo: new Paging(),
      hasChange: function hasChange() {
        return some(['isDirty', true], this.querySourceList) || some(['hasDetailChange', true], this.querySourceList);
      },
      canSave: function canSave() {
        var selectedFieldsList = [];
        if (this.selectedQuerySource) {
          var selectedQuerySourceId = this.selectedQuerySource.getId();
          var index = findIndex(function (item) {
            return item.getId() === selectedQuerySourceId;
          }, this.querySourceList);
          selectedFieldsList = this.querySourceList[index].getFieldLists();
        }

        return this.hasChange || some('details.physicalChange', this.querySourceList) || some('details.allowToSave', selectedFieldsList);
      },
      getCriteriaList: function getCriteriaList() {
        var CriteriaCollection = BUNDLE.CRITERIALIST;
        return CriteriaCollection[this.querySourceType] || CriteriaCollection.DEFAULT_CRITERIA_LIST;
      },
      showPopup: false,
      alertMessage: CommonMessages.EMPTY_MESSAGE
    });
  }

  /**
   * init for query source type, call when QuerySourceTypeStore mount
   * @return {[type]} [description]
   */
  QuerySourceTypeStore.prototype.init = function () {
    this.alertMessage = CommonMessages.EMPTY_MESSAGE;
    this.observeTenantId();
    uiState.setCheckDirtyFunction(function () {
      return this.hasChange;
    }.bind(this));
  };

  QuerySourceTypeStore.prototype.destroy = m.action(function () {
    this.disposeQuerySourceType();
    uiState.resetCheckDirtyFunction();
  });

  /**
   * observe tenantID on setting level
   */
  QuerySourceTypeStore.prototype.observeTenantId = function () {
    this.disposeQuerySourceType = m.observe(uiState, 'tenantId', function () {
      this.goToPage(1);
    }.bind(this));
  };

  /**
   * Get init data (list of stored procedure)
   */
  QuerySourceTypeStore.prototype.setQuerySourceType = m.action(function (querySourceType) {
    this.querySourceType = querySourceType;
    // Get categories list
    // this.categoryList.getCategories();
    // important - must be reset all data
    this.resetData();
    this.resetPagingInfo();
    // get data based on new query-source-type
    return this.loadQuerySources();
  });

  /**
   *Search data
   */
  QuerySourceTypeStore.prototype.search = m.action(function (searchProperty, searchText) {
    this.resetData();
    this.pageInfo.setSearchValues(searchProperty, searchText);
    return this.goToPage(1);
  });

  /**
   * Reload data when save fail or cancel
   */
  QuerySourceTypeStore.prototype.reload = m.action(function () {
    this.resetData();
    this.loadQuerySources();
  });

  /**
   * Get init data (list of stored procedure)
   */
  QuerySourceTypeStore.prototype.resetData = m.action(function () {
    // TODO should use other way
    this.querySourceList = [];
    this.selectedQuerySource = null;
    this.isLoading = true;
    this.totalRecords = 0;
  });

  QuerySourceTypeStore.prototype.resetPagingInfo = m.action(function () {
    // reset paging information
    var DefaultSortCollection = BUNDLE.SORTDEFAULTLIST;
    var colSortDir = clone(DefaultSortCollection[this.querySourceType] || DefaultSortCollection.DEFAULT_SORT);
    this.pageInfo = new Paging(colSortDir, BUNDLE.DEFAULT_CRITERIA);
  });

  /**
   * Get init data (list of stored procedure)
   */
  QuerySourceTypeStore.prototype.loadQuerySources = m.action(function () {
    var pageInfo = {
      pageSize: this.pageInfo.pageSize,
      pageIndex: this.pageInfo.pageIndex
    };
    var tenantId = uiState.getTenantId() || null;
    this.selectedQuerySource = null;

    // TODO for sort
    this.pageInfo.buildPagingRequest();
    var sortOrders = this.pageInfo.sortOrders;

    // re-load datasource category before load querysource
    // because the categories group have new item already added but never updated
    return (0, _bluebird.join)(this.categoryList.getCategories(tenantId), fetcher.loadQuerySources(tenantId, this.querySourceType, pageInfo, sortOrders, this.pageInfo.searchCriteria), function (categories, querySources) {
      return this.populateData(querySources);
    }.bind(this));
  });

  /**
   * Go to page
   * @param {number} pageIndex
   * @returns
   */
  QuerySourceTypeStore.prototype.goToPage = m.action(function (pageIndex) {
    var pageInfo = this.pageInfo;

    pageInfo.setPageIndex(pageIndex);

    return this.loadQuerySources();
  });

  /**
   * Create list of query source details
   * @param {array} spDetails
   */
  QuerySourceTypeStore.prototype.populateData = m.action(function (querySourceDetails) {
    querySourceDetails = querySourceDetails || {};
    var querySourceList = querySourceDetails.result;

    this.totalRecords = querySourceDetails.total;

    // create list of QuerySourceTypeDetailsVM
    var newData = map(function (querySource) {
      return new QuerySourceTypeDetailsStore(querySource);
    }, querySourceList);

    // update dynamic feature based on data of query-source
    querySourceList.length > 0 && (this.hasDynamicFeature = hasDynamicFeature(querySourceList[0]));

    // update page info
    var pageInfo = this.pageInfo;
    pageInfo.totalRecords = querySourceDetails.total;

    // update data to UI
    m.transaction(function () {
      // update to model
      this.querySourceList = newData;

      // set first item as showing item
      newData.length > 0 && this.querySourceType !== QuerySourceType.FUNCTION && this.setShowingQuerySource(newData[0]);
    }.bind(this));

    function hasDynamicFeature(querySource) {
      return querySource && querySource.extendedProperties && querySource.extendedProperties.Dynamic;
    }

    return null;
  });

  QuerySourceTypeStore.prototype.setShowingQuerySource = m.action(function (selectedQuerySource) {
    // select the same item: do nothing
    if (this.selectedQuerySource && this.selectedQuerySource.getId() === selectedQuerySource.getId()) {
      return;
    }

    // mark the previous store proc as unselected
    if (this.selectedQuerySource) {
      this.selectedQuerySource.isSelected = false;
      this.selectedQuerySource.fieldList = [];
    }

    // update new selected query-source
    this.selectedQuerySource = selectedQuerySource;
    selectedQuerySource.isSelected = true;

    var querySourceList = this.querySourceList;
    var selectedQuerySourceDetail = selectedQuerySource && selectedQuerySource.details;
    var selectedQuerySourceId = selectedQuerySourceDetail && selectedQuerySourceDetail.id;

    return (0, _bluebird.join)(
    // get schema details
    selectedQuerySource.loadQuerySourceFields(),
    // get funtion/operators
    fetcher.fetchFunctionOperators(uiState.getTenantId(), selectedQuerySourceId, true), function (querySourceFields, functionOperators) {
      var querySourceListDetails = flatMap(function (item) {
        return item.details;
      }, querySourceList);

      m.transaction(function () {
        selectedQuerySource.calculatedStore.expressionSelection = new ExpressionSelection({
          expressionFieldName: new ExpressionFieldName({
            selectedDataSource: selectedQuerySourceDetail,
            dataSources: querySourceListDetails
          }),
          expressionFunctionOperators: new ExpressionFunctionOperator({
            functionOperators: functionOperators
          })
        });

        selectedQuerySource.loadFieldNameForExpression();
      });
      return null;
    });
  });

  QuerySourceTypeStore.prototype.fetchAllQuerySourceList = function () {
    return fetcher.loadAllQuerySources(uiState.getTenantId(), this.querySourceType);
  };

  QuerySourceTypeStore.prototype.getBundle = function () {
    return BUNDLE;
  };

  QuerySourceTypeStore.prototype.isFieldInvisibleOrUnfilterable = function () {
    if (isNil(this.selectedQuerySource)) return;
    var selectedQuerySourceId = this.selectedQuerySource.getId();

    var index = findIndex(function (item) {
      return item.getId() === selectedQuerySourceId;
    }, this.querySourceList);

    var fieldList = this.querySourceList[index].getFieldLists();
    var itemChanged = find(function (o) {
      return o.isChangeToInvisible == true || o.isChangeToUnfilterable == true;
    }, fieldList);

    return !isEmpty(itemChanged);
  };

  QuerySourceTypeStore.prototype.updateQuerySource = m.action(function () {
    var buildQuerySources = function () {
      var result = [];

      each(function (item) {
        var originDetails = item.getDetails();
        var details = omit(['extendedProperties', 'querySourceFields'], originDetails);
        details.type = this.querySourceType;
        details.extendedProperties = (0, _stringify2.default)(originDetails.extendedProperties);
        details.querySourceFields = [];
        // Set id = null when add new category
        details.dataSourceCategoryId = details.isNewCategory ? null : details.dataSourceCategoryId;
        result.push(details);
      }.bind(this), this.querySourceList);

      return result;
    }.bind(this);

    var buildQuerySourceFields = function (querySources) {
      if (this.selectedQuerySource) {
        var selectedQuerySourceId = this.selectedQuerySource.getId();

        var index = findIndex(function (item) {
          return item.getId() === selectedQuerySourceId;
        }, this.querySourceList);

        var fieldLists = this.querySourceList[index].getFieldLists();
        each(function (item) {
          var fieldDetails = item.getDetails() || {};
          var details = omit('filteredValue', fieldDetails);
          var filteredValue = fieldDetails.filteredValue;
          details.filteredValue = (0, _stringify2.default)(filteredValue);
          querySources[index].querySourceFields.push(details);
        }, fieldLists);
      }
    }.bind(this);

    var buildUpdatingQuerySourceData = function () {
      var result = {};

      result.tenantId = uiState.getTenantId();
      result.querySources = buildQuerySources();
      buildQuerySourceFields(result.querySources);

      return result;
    }.bind(this);

    var querySourceData = buildUpdatingQuerySourceData();
    return fetcher.updateQuerySource(querySourceData);
  });

  QuerySourceTypeStore.prototype.deleteCustomQuerySource = function (item) {
    return fetcher.deleteCustomQuerySource({ id: item.details.id });
  };

  QuerySourceTypeStore.prototype.getDatabases = action(function (customView, pageInfo, isReset) {
    var data = {
      tenantId: uiState.getTenantId(),
      skipItems: pageInfo.fromIndex,
      pageSize: pageInfo.pageSize
    };

    return fetcher.getDatabases(data).then(action(function (response) {
      customView.isLastPageDatabase = response.isLastPage;
      isReset && (customView.databases = []);
      var databases = map(function (item) {
        return observable(item);
      }, response.result);

      return concatArray(customView.databases, databases, 'key', !response.isLastPage);
    }));
  });

  QuerySourceTypeStore.prototype.getSchemas = action(function (customView, pageInfo, isReset) {
    var data = {
      connectionId: customView.databaseId,
      skipItems: pageInfo.fromIndex,
      pageSize: pageInfo.pageSize
    };

    return fetcher.getSchemas(data).then(action(function (response) {
      customView.isLastPageSchema = response.isLastPage;
      isReset && (customView.schemas = []);
      var schemas = map(function (item) {
        return observable(item);
      }, response.result);

      return concatArray(customView.schemas, schemas, 'key', !response.isLastPage);
    }));
  });

  QuerySourceTypeStore.prototype.validateCustomQuerySource = function (customView) {
    var data = {
      id: customView.id,
      name: customView.viewName,
      connectionId: customView.databaseId,
      categoryId: customView.schemaId,
      customDefinition: customView.query
    };

    return fetcher.validateCustomQuerySource(data);
  };

  QuerySourceTypeStore.prototype.saveCustomQuerySource = function (customView) {
    var data = {
      id: customView.id,
      name: customView.viewName,
      connectionId: customView.databaseId,
      categoryId: customView.schemaId,
      customDefinition: customView.query
    };

    return fetcher.saveCustomQuerySource(data);
  };

  module.exports = QuerySourceTypeStore;
}();

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

var _stringify = __webpack_require__(93);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(77);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeDetailsStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var extendObservable = __webpack_require__(5).extendObservable;

  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      find = _require.find,
      filter = _require.filter,
      uniqueId = _require.uniqueId,
      some = _require.some,
      map = _require.map,
      reduce = _require.reduce,
      pick = _require.pick,
      chain = _require.chain;

  var trackable = __webpack_require__(46);

  var fetcher = __webpack_require__(191);
  var reportFetcher = __webpack_require__(90);
  var QuerySourceFieldDetailsStore = __webpack_require__(619);
  var PagingModel = __webpack_require__(98);
  var constants = __webpack_require__(198);

  var CalculatedFieldStore = __webpack_require__(987);
  var ObjectStateConstants = __webpack_require__(58);
  var uiState = __webpack_require__(15);
  var FILTER_LOOKUP_STATUSES = __webpack_require__(228).FILTER_LOOKUP_STATUSES;

  function QuerySourceTypeDetailsVM(details) {
    details = details || {};
    details.extendedProperties = JSON.parse(details.extendedProperties || '{}');

    var colSortDir = {
      ColumnName: 'DESC'
    };

    extendObservable(trackable(this), {
      details: details,
      aliasError: '',
      executeErrorMessage: '',
      isSelected: false,
      fieldList: [],
      displayFieldList: function displayFieldList() {
        return this.fieldList.filter(function (field) {
          return field.details.state != ObjectStateConstants.DELETE;
        });
      },
      pageInfo: new PagingModel(colSortDir),
      editingQuerySourceField: null,
      hasDetailChange: function hasDetailChange() {
        return some(['isDirty', true], this.fieldList);
      },
      isEditingFilter: false,
      calculatedStore: new CalculatedFieldStore()
    });
  }

  QuerySourceTypeDetailsVM.prototype.getId = function () {
    return this.details && this.details.id;
  };

  QuerySourceTypeDetailsVM.prototype.getCategory = function () {
    var details = this.details;
    return details.dataSourceCategoryId || details.dataSourceCategoryName;
  };

  QuerySourceTypeDetailsVM.prototype.setCategory = function (id, name, isNew) {
    this.details.dataSourceCategoryId = id;
    this.details.dataSourceCategoryName = name;
    this.details.isNewCategory = isNew;
    this.markDirty();
  };

  QuerySourceTypeDetailsVM.prototype.getDbName = function () {
    var details = this.details || {};

    return details.connectionName;
  };

  QuerySourceTypeDetailsVM.prototype.getDbSourceName = function () {
    return this.details.name;
  };

  QuerySourceTypeDetailsVM.prototype.getDbSourceAlias = function () {
    return this.details.alias;
  };
  QuerySourceTypeDetailsVM.prototype.getReturnedValue = function () {
    return this.details.extendedProperties.ReturnedValue;
  };
  QuerySourceTypeDetailsVM.prototype.getInputParams = function () {
    return this.details.extendedProperties.InputParams;
  };
  QuerySourceTypeDetailsVM.prototype.setDbSourceAlias = function (alias) {
    // reset value of aliasError
    this.aliasError && (this.aliasError = '');
    this.details.alias = alias;
    this.markDirty();
  };

  QuerySourceTypeDetailsVM.prototype.getFieldLevel = function () {
    var extendedProperties = this.details.extendedProperties || {};

    return extendedProperties.FieldLevel;
  };

  QuerySourceTypeDetailsVM.prototype.setFieldLevel = function (isFieldLevel) {
    var extendedProperties = this.details.extendedProperties = this.details.extendedProperties || {};

    extendedProperties.FieldLevel = isFieldLevel;
    this.markDirty();
  };

  QuerySourceTypeDetailsVM.prototype.getExpressionLevel = function () {
    var extendedProperties = this.details.extendedProperties || {};

    return extendedProperties.ExpressionLevel;
  };

  QuerySourceTypeDetailsVM.prototype.setExpressionLevel = function (isExpressionLevel) {
    var extendedProperties = this.details.extendedProperties = this.details.extendedProperties || {};

    extendedProperties.ExpressionLevel = isExpressionLevel;
    this.markDirty();
  };
  QuerySourceTypeDetailsVM.prototype.isDynamic = function () {
    var extendedProperties = this.details.extendedProperties || {};

    return extendedProperties.Dynamic;
  };

  QuerySourceTypeDetailsVM.prototype.setDynamic = function (isDynamic) {
    var extendedProperties = this.details.extendedProperties = this.details.extendedProperties || {};

    // TODO - bich
    extendedProperties.Dynamic = isDynamic;
    this.markDirty();
  };

  QuerySourceTypeDetailsVM.prototype.isStatic = function () {
    var extendedProperties = this.details.extendedProperties || {};

    return extendedProperties.Static;
  };

  QuerySourceTypeDetailsVM.prototype.getQuerySourceDetailsType = function () {
    var extendedProperties = this.details.extendedProperties || {};

    // TODO - bich - stored procedure only
    return extendedProperties.storedProcType;
  };

  QuerySourceTypeDetailsVM.prototype.loadQuerySourceFields = m.action(function () {
    var data = (0, _assign2.default)({}, this.details);

    data.extendedProperties = (0, _stringify2.default)(data.extendedProperties);

    this.pageInfo.buildPagingRequest();
    var sortOrders = this.pageInfo.sortOrders;

    return fetcher.loadQuerySourceFields(data, sortOrders, null, uiState.getTenantId()).then(this.populateData.bind(this));
  });

  QuerySourceTypeDetailsVM.prototype.populateData = m.action(function (querySourceTypeDetails) {
    querySourceTypeDetails = querySourceTypeDetails || {};

    var fieldList = querySourceTypeDetails.result || [];
    var querySourceFieldApprovalLevel = constants.APPROVAL_LEVEL.QUERY_SOURCE_FIELD;
    var deletedChangeLevel = constants.DETECTED_CHANGE_LEVEL.DELETED;

    var newData = map(function (fieldDetail) {
      var isDelete = fieldDetail.approval < querySourceFieldApprovalLevel && fieldDetail.physicalChange === deletedChangeLevel;

      if (isDelete) {
        fieldDetail.visible = false;
        fieldDetail.filterable = false;
      }

      return new QuerySourceFieldDetailsStore(fieldDetail);
    }, fieldList);

    // Allow save when have physical change
    if (some(['physicalChange', 1], fieldList)) {
      this.markDirty();
    }

    this.fieldList = newData;

    return this.fieldList;
  });

  /**
   * Delete field , only calculted field can be deleted
   * @param {Object} deletedField
   */
  QuerySourceTypeDetailsVM.prototype.deleteField = function (deletedField) {
    var deletePromise = (0, _bluebird.resolve)(true);

    if (String.isGuidFormat(deletedField.details.id)) {
      deletePromise = fetcher.deleteQuerySourceField(deletedField.details.id);
    }
    return deletePromise.bind(this).then(function (status) {
      if (status) {
        deletedField.details.state = ObjectStateConstants.DELETE;
        this.markDirty();
      }
      return status;
    });
  };

  /**
   * Check if the calculted field is used in existing report
   * @param {Object} deletedField
   */
  QuerySourceTypeDetailsVM.prototype.hasReportUseCalculatedField = function (deletedField) {
    if (!deletedField.details.id) return (0, _bluebird.resolve)(false);

    return reportFetcher.hasReportUseCalculatedField(deletedField.details.id);
  };

  QuerySourceTypeDetailsVM.prototype.loadFieldNameForExpression = function (fieldDetails) {
    var details = fieldDetails && fieldDetails.details;

    var items = chain(this.fieldList).flatMap(function (item) {
      return item.details;
    }).filter(function (item) {
      // Do not get deleted item
      if (item.state == ObjectStateConstants.DELETE || item.physicalChange === constants.DETECTED_CHANGE_LEVEL.DELETED) {
        return false;
      }

      // Do not get current editing item
      // - get if current editing is undefined
      if (!details || item.id && item.state != ObjectStateConstants.UPDATE) {
        return true;
      }

      // - filter temp item
      if (details.tempId !== undefined && item.tempId !== undefined) {
        return item.tempId !== details.tempId;
      }

      // - filter real item
      return details.id !== item.id;
    }).map(function (item) {
      return {
        id: item.id,
        name: item.alias || item.name,
        dataType: item.dataType || item.izendaDataType,
        description: item.expression,
        tempId: item.tempId
      };
    }).value();

    this.calculatedStore.expressionSelection.expressionFieldName.fetchFieldNames(items);
  },
  /*
  * post execute store procedure
  */
  QuerySourceTypeDetailsVM.prototype.executeStoreProc = function () {
    this.markDirty();
    var parseErrorMessage = function parseErrorMessage(messages) {
      return messages && reduce(function (result, ele) {
        var msg = reduce(function (childResult, childEle) {
          return childResult ? childResult + ', ' + childEle : childEle;
        }, '', ele.messages);
        return result ? result + ', ' + msg : msg;
      }, '', messages);
    };

    var afterExecStoredProc = function (result) {
      if (!result.success) {
        this.executeErrorMessage = parseErrorMessage(result.messages);
      } else {
        this.executeErrorMessage = '';
      }
      return result.data;
    }.bind(this);

    this.pageInfo.buildPagingRequest();
    var sortOrders = this.pageInfo.sortOrders;

    fetcher.executeStoredProc(this.getId(), this.getParams(), sortOrders).then(afterExecStoredProc).then(this.populateData.bind(this));
  };

  /*
    * Get list of params from list of schema details
    */
  QuerySourceTypeDetailsVM.prototype.getParams = function () {
    var fieldList = this.fieldList;

    return map(function (item) {
      var returnObject = pick(['id', 'name', 'filteredValue'], item.details);
      returnObject.filteredValue = (0, _stringify2.default)(returnObject.filteredValue);
      return returnObject;
    }, filter({ isParameter: true }, fieldList));
  };

  QuerySourceTypeDetailsVM.prototype.getDetails = function () {
    return this.details;
  };

  QuerySourceTypeDetailsVM.prototype.getFieldLists = function () {
    return this.fieldList;
  };

  QuerySourceTypeDetailsVM.prototype.get = function () {
    return this.fieldList;
  };

  /**
   * Add calculated field
   * TODO : Need refactor : move to model
   * @param {type} calculatedData
   */
  QuerySourceTypeDetailsVM.prototype.addCalculateField = m.action(function (calculatedData) {
    var newField = {
      alias: '',
      visible: true,
      filterable: !(calculatedData.isRunningField || calculatedData.isCompositeField),
      isCalculated: true,
      izendaDataType: calculatedData.izendaDataType,
      name: calculatedData.name,
      expression: calculatedData.expression,
      id: calculatedData.id,
      tempId: calculatedData.tempId,
      isRunningField: calculatedData.isRunningField,
      isCompositeField: calculatedData.isCompositeField,
      filterLookupStatus: FILTER_LOOKUP_STATUSES.VALID
    };

    // Add mode
    if (!newField.id && !newField.tempId) {
      newField.tempId = uniqueId();
      newField.state = ObjectStateConstants.INSERT;
      newField.position = this.fieldList.length;
      var field = new QuerySourceFieldDetailsStore(newField);
      field.markDirty();
      this.fieldList.push(field);
    } else {
      var editedField = find(function (o) {
        return newField.id && o.details.id === newField.id || newField.tempId && o.details.tempId === newField.tempId;
      }, this.fieldList);

      if (editedField) {
        editedField.details.izendaDataType = calculatedData.izendaDataType;
        editedField.details.name = calculatedData.name;
        editedField.details.expression = calculatedData.expression;
        editedField.details.isRunningField = calculatedData.isRunningField;
        editedField.details.isCompositeField = calculatedData.isCompositeField;
        editedField.details.filterable = !(calculatedData.isRunningField || calculatedData.isCompositeField);
        // Update state = EDIT for existing calculated field
        if (editedField.details.id) {
          editedField.details.state = ObjectStateConstants.UPDATE;
        }
        editedField.markDirty();
      }
    }
    this.loadFieldNameForExpression();
    this.markDirty();
  });

  QuerySourceTypeDetailsVM.prototype.resetCalculatedStore = function () {
    this.calculatedStore = new CalculatedFieldStore();
  };

  module.exports = QuerySourceTypeDetailsVM;
}();

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedSettingsStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Data Model Store
 */
!function () {

  var extendObservable = __webpack_require__(5).extendObservable;

  var PerformanceStore = __webpack_require__(936);
  var OthersStore = __webpack_require__(938);
  var CategoryGridStore = __webpack_require__(1177);
  var SecurityStore = __webpack_require__(937);

  function AdvancedSettingsStore() {
    this.performance = new PerformanceStore();
    this.others = new OthersStore();
    this.category = new CategoryGridStore();
    this.security = new SecurityStore();

    extendObservable(this, {
      activeLink: 'performance'
    });
  }

  /**
   * Update active Link
   */
  AdvancedSettingsStore.prototype.changeSelectItem = function (newLink) {
    this.activeLink = newLink;
  };

  module.exports = AdvancedSettingsStore;
}();

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantManagementStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);
  var fetcher = __webpack_require__(278);
  var accessFetcher = __webpack_require__(227);
  var TenantDetails = __webpack_require__(1178);
  var TenantList = __webpack_require__(2566);
  var constants = __webpack_require__(279);
  var CommonMessages = __webpack_require__(37);
  var MobxUtils = __webpack_require__(275);
  var PermissionStore = __webpack_require__(1153);
  var AccessStore = __webpack_require__(620);
  var IS_TENANT_SETUP = true;
  var localizer = __webpack_require__(12);
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      isBoolean = _require.isBoolean,
      map = _require.map,
      find = _require.find,
      findIndex = _require.findIndex,
      cloneDeep = _require.cloneDeep;

  function TenantManagementStore() {
    m.extendObservable(this, {
      showingTenantCloned: {},
      showingTenant: new TenantDetails(),
      tenantList: new TenantList(),
      modulesOfLicense: [],
      alertMessage: ''
    });
    this.accessStore = new AccessStore();
  }

  /**
   * inititial for role setup store
   * @method init
   */
  TenantManagementStore.prototype.init = function () {
    // whenever uiState changed the tenant.
    uiState.setCheckDirtyFunction(function () {
      return this.showingTenantCloned.hasDirty;
    }.bind(this));
  };

  /**
   * destroy observe
   * @method destroy
   */
  TenantManagementStore.prototype.destroy = function () {
    uiState.resetCheckDirtyFunction();
  };

  /**
   * Get Initial Data
   */
  TenantManagementStore.prototype.getTenantList = function (isSelectFirstTenant) {
    this.resetAlertMessage();

    var tenantList = m.action(function (result) {
      result = result || [];
      this.tenantList.populateData(result);

      if (result.length > 0) {
        if (!isBoolean(isSelectFirstTenant) && isSelectFirstTenant) {
          var tenant = this.tenantList.getFilterList()[0];
          this.loadTenant(tenant);
        }
      } else {
        this.addTenant();
      }

      return result;
    }.bind(this));

    return fetcher.getAllBasicTenantList().then(tenantList);
  };

  /**
   * Get modules of License
   */
  TenantManagementStore.prototype.getModulesOfLicense = function () {
    return fetcher.getAllModulesOfLicense().then(function (result) {
      this.modulesOfLicense = result || [];
      return result;
    }.bind(this));
  };

  /**
   * Set showing tenant
   */
  TenantManagementStore.prototype.setShowingTenant = m.action(function (tenant) {
    // reset data of previous tenant
    this.showingTenant && this.showingTenant.setSelected(false);

    // update new selected tenant
    tenant && (this.showingTenant = tenant);
    this.showingTenant.setSelected(true);
  });

  /**
   * set showing tenant by index
   * @param {number} index
   */
  TenantManagementStore.prototype.setShowingTenantByIndex = function (index) {
    var list = this.tenantList.tenantList;
    this.loadTenant(list[index]);
  };

  /**
   * Add tenant
   */
  TenantManagementStore.prototype.addTenant = m.action(function () {
    this.showingTenant.setSelected(false);
    this.showingTenantCloned.setSelected(false);

    // Extract all modules's name and add it to a new Tenant
    var tenantModules = map(function (modules) {
      return modules.name;
    }.bind(this), this.modulesOfLicense);

    this.showingTenantCloned = new TenantDetails({ tenantModules: tenantModules });

    this.permissionStore = new PermissionStore(this.showingTenantCloned.permission, null, IS_TENANT_SETUP);
    this.accessStore.updateModel(this.showingTenantCloned.permissionAccessModel);
    this.accessStore.initialAccessGrid();

    this.resetAlertMessage();
  });

  /**
   * Update Filter Text
   * @param newValue
   */
  TenantManagementStore.prototype.updateFilterText = function (newValue) {
    this.tenantList.filterText = newValue;
    if (this.tenantList.filterTenants.length > 0) {
      this.setShowingTenant(this.tenantList.filterTenants[0]);
    }
  };

  /**
   * Save tenant
   * @param tenant
   * @returns {*|Promise.<T>}
   */
  TenantManagementStore.prototype.saveTenant = function () {
    function setAlertMessage(response) {
      this.alertMessage = {
        type: response.success ? 'success' : 'error',
        message: response.success ? localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED') : response.messages[0].messages || null
      };
      return response.messages;
    }

    var savedTenant = this.showingTenantCloned;

    // //Get update access
    var updatedAccess = this.showingTenantCloned.permissionAccessModel.getAccessForSave();
    // //Update list access default
    savedTenant.permission.updateAccessDefault(updatedAccess);

    return fetcher.saveTenant(savedTenant).then(function (response) {
      if (response.success) {
        if (savedTenant.isNew) {
          this.getTenantList(false).then(function () {
            var tenantDetail = find({ id: response.tenant.id }, this.tenantList.tenantList);
            tenantDetail && this.loadTenant(tenantDetail);
          }.bind(this));
        } else {
          this.showingTenant.populateData(response.tenant);
          this.loadTenant(this.showingTenant);
        }

        this.showingTenantCloned.cleanDirty();
        this.showingTenant.updateVersion();
        this.accessStore.updateAccessOrigin(this.showingTenantCloned.permission.access.accessDefaults.value);
      }
      return response;
    }.bind(this)).then(setAlertMessage.bind(this));
  };

  /**
   * Delete tenant
   * @param id
   * @returns {*|Promise.<T>}
   */
  TenantManagementStore.prototype.deleteTenant = m.action(function (id) {
    var showingTenantIndex = findIndex(function (tenant) {
      return tenant.id === id;
    }, this.tenantList.tenantList);

    var setTenant = m.action(function () {
      var list = this.tenantList.tenantList;
      if (list.length > 0) {
        if (showingTenantIndex >= list.length) {
          showingTenantIndex = list.length - 1;
        }
        this.setShowingTenantByIndex(showingTenantIndex);
      }
    });

    return fetcher.deleteTenant(id).then(function (response) {
      if (response.success) {
        this.getTenantList().bind(this).then(setTenant);
        return (0, _bluebird.resolve)(true);
      }
      return response;
    }.bind(this));
  });

  /**
   * Active Tenant
   * @param id
   * @returns {Promise.<T>}
   */
  TenantManagementStore.prototype.activeTenant = function (tenant) {
    tenant.setActive(true);
    this.showingTenant === tenant && this.setTenantStatus(tenant, true);
    return fetcher.activeTenant(tenant.id);
  };

  /**
   * set status of the virtunal tenant detail
   * @param  {object} tenant
   * @param  {boolean} state)
   */
  TenantManagementStore.prototype.setTenantStatus = m.action(function (tenant, state) {
    tenant && (this.showingTenant = tenant);
    this.showingTenant.setActive(state);
    this.cloneTenantDetail();
  });

  /**
   * Deactive Tenant
   * @param id
   * @returns {Promise.<T>}
   */
  TenantManagementStore.prototype.deactiveTenant = m.action(function (tenant) {
    tenant.setActive(false);
    this.showingTenant === tenant && this.setTenantStatus(tenant, false);
    return fetcher.deactiveTenant(tenant.id);
  });

  /**
   * Get Bundle
   */
  TenantManagementStore.prototype.getBundle = function () {
    return constants;
  };

  /**
   * Set Alert message
   */
  TenantManagementStore.prototype.setAlertMessage = function (type, message) {
    this.alertMessage = {
      type: type,
      message: message
    };
  };

  /**
   * Reset Alert message
   */
  TenantManagementStore.prototype.resetAlertMessage = function () {
    this.alertMessage = CommonMessages.EMPTY_MESSAGE;
  };

  /**
   * clone to new virtual TenantDetail
   * @return {Object} [this.showingTenantCloned]
   */
  TenantManagementStore.prototype.cloneTenantDetail = function () {
    this.showingTenantCloned = new TenantDetails(cloneDeep(MobxUtils.toJS(this.showingTenant)));
  };

  /**
   * Load tenant detail
   * @return {Object} Promise
   */
  TenantManagementStore.prototype.loadTenant = m.action(function (tenant) {
    var tenantDetail = m.action(function (result) {
      tenant.populateData(result);
      this.setShowingTenant(tenant);
      this.cloneTenantDetail();
      this.permissionStore = new PermissionStore(this.showingTenantCloned.permission, tenant.id, IS_TENANT_SETUP);
      this.accessStore.updateModel(this.showingTenantCloned.permissionAccessModel);
      this.accessStore.initialAccessGrid(result.permission.access.accessDefaults.value);
      return (0, _bluebird.resolve)();
    });

    return fetcher.loadTenant(tenant.id).bind(this).then(tenantDetail);
  });

  /**
   * Validation list accesses setting
   * @return {object} Promise result
   */
  TenantManagementStore.prototype.validateAccesses = function () {
    var updatedAccess = this.showingTenantCloned.permissionAccessModel.getAccessForSave(true);
    return accessFetcher.validateAccesses(updatedAccess);
  };

  module.exports = TenantManagementStore;
}();

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantListModel.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var m = __webpack_require__(5);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      map = _require.map,
      escapeRegExp = _require.escapeRegExp;

  var TenantDetails = __webpack_require__(1178);

  function TenantList() {
    m.extendObservable(this, {
      tenantList: [],
      filterText: '',
      filterTenants: function filterTenants() {
        var filterRegex = new RegExp(escapeRegExp(this.filterText), 'i');

        return filter(function (tenant) {
          return !tenant.deleted && filterRegex.test(tenant.displayName);
        }, this.tenantList);
      }
    });
  }

  TenantList.prototype.populateData = function (tenantList) {
    tenantList = tenantList || [];

    this.tenantList = map(function (tenant) {
      return new TenantDetails(tenant);
    }, tenantList);
  };

  TenantList.prototype.getFilterList = function () {
    return this.filterTenants;
  };

  module.exports = TenantList;
}();

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SchedulingSearchStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var extendObservable = __webpack_require__(5).extendObservable;
  var uiState = __webpack_require__(15);
  var SchedulingSearchCriteria = __webpack_require__(2568);
  var SchedulingSearchResult = __webpack_require__(2569);
  var PagingModel = __webpack_require__(98);
  var systemFetcher = __webpack_require__(75);
  var CONSTANTS = __webpack_require__(158);
  var PAGE_SEARCH_SIZE = CONSTANTS.PAGE_SEARCH_SIZE;
  var SEARCH_KEY = CONSTANTS.SEARCH_KEY;
  var DEFAULT_SORT_ORDER = CONSTANTS.DEFAULT_SORT_ORDER;
  var REPORT_TYPE_VALUE = CONSTANTS.REPORT_TYPE_VALUE;

  var dashboardFetcher = __webpack_require__(192);
  var reportFetcher = __webpack_require__(111);

  function SchedulingSearchStore() {

    extendObservable(this, {
      criteria: new SchedulingSearchCriteria(),
      pageInfo: new PagingModel(DEFAULT_SORT_ORDER),
      searchResult: new SchedulingSearchResult(),
      emailTemplates: null
    });
  }

  /**
   * Load Email Template
   * @returns {*}
   */
  SchedulingSearchStore.prototype.loadEmailTemplates = function () {
    return dashboardFetcher.fetchEmailTemplates(CONSTANTS.TEMPLATE_TYPE).then(function (result) {
      this.emailTemplates = result;
      return result;
    }.bind(this));
  };

  /**
   * Load Schedules
   * @return {Promise}
   */
  SchedulingSearchStore.prototype.loadSchedules = function () {
    var criteria = this.buildCriteriaData();
    var params = {
      systemLevel: !uiState.tenantId,
      tenantId: uiState.tenantId,
      pageIndex: 1,
      pageSize: PAGE_SEARCH_SIZE,
      sortOrders: this.pageInfo.buildSortOrder(),
      criteria: criteria
    };
    return systemFetcher.loadSchedules(params).then(function (result) {
      this.searchResult.populateData(result);
      return result;
    }.bind(this));
  };

  /**
   * Update schedules on one grid
   * @param data
   */
  SchedulingSearchStore.prototype.updateGridSchedules = function (data) {
    var criteria = this.buildCriteriaData();
    var pageInfo = data.pageInfo;
    var params = {
      systemLevel: false,
      tenantId: !!data.tenantId ? data.tenantId : null,
      pageIndex: pageInfo.pageIndex,
      pageSize: pageInfo.pageSize,
      sortOrders: pageInfo.buildSortOrder(),
      criteria: criteria
    };
    return systemFetcher.loadSchedules(params).then(function (result) {
      this.searchResult.populateData(result, data.pageInfo);
      return result;
    }.bind(this));
  };

  /**
   * Load report dashbord name
   * @param tenantId
   * @returns {*}
   */
  SchedulingSearchStore.prototype.loadReportDashboardName = function (tenantId) {
    var reportingType = this.criteria.reportType;
    reportingType = REPORT_TYPE_VALUE[reportingType];
    tenantId = tenantId || uiState.tenantId;
    return systemFetcher.getReportDashboardNameByTenant(reportingType || 0, tenantId).bind(this).then(function (result) {
      this.criteria.setValueByKey('reportDashboardNameOptions', result.map(function (item) {
        return {
          value: item,
          label: item
        };
      }));
    });
  };

  /**
   * Load creator by tenant
   * @param tenantId
   * @returns {*}
   */
  SchedulingSearchStore.prototype.loadCreatorByTenant = function (tenantId) {
    tenantId = tenantId || uiState.tenantId;
    return systemFetcher.getCreatedByTenant(tenantId).then(function (result) {
      this.criteria.setOptionByKey('createdByOptions', result);
    }.bind(this));
  };

  /**
   * Load recipients by tenant
   * @param tenantId
   * @returns {*}
   */
  SchedulingSearchStore.prototype.loadRecipientsByTenant = function (tenantId) {
    tenantId = tenantId || uiState.tenantId;
    return systemFetcher.getRecipientByTenant(tenantId).then(function (result) {
      this.criteria.setOptionByKey('recipientsOptions', result);
    }.bind(this));
  };

  /**
   * Build search criteria array
   * @returns {Array}
   */
  SchedulingSearchStore.prototype.buildCriteriaData = function () {
    var criteria = this.criteria.buildDataForSearch();
    var criteriaKeys = (0, _keys2.default)(SEARCH_KEY);
    return criteriaKeys.map(function (key) {
      return {
        key: SEARCH_KEY[key],
        value: criteria[key]
      };
    });
  };

  /**
   * Save Schedules
   * @param {object} subscription
   * @returns {promise}
   */
  SchedulingSearchStore.prototype.saveSchedule = function (subscription) {
    var postData;
    var saveFunction;
    if (subscription.dashboardId) {
      postData = {
        id: subscription.dashboardId,
        subscriptions: [subscription]
      };
      saveFunction = dashboardFetcher.saveSubscriptions;
    } else {
      postData = [subscription];
      saveFunction = reportFetcher.updateSubscriptions;
    }
    return saveFunction(postData);
  };

  /**
   * Validate Schedule
   * @param {object} schedule
   * @param {object} commonFilterFields
   * @returns {*|Promise}
   */
  SchedulingSearchStore.prototype.validateSchedule = function (schedule, commonFilterFields) {
    var fetcher = schedule.dashboardId ? dashboardFetcher : reportFetcher;
    return fetcher.validateSubscription(schedule.omitData(), commonFilterFields);
  };

  /**
   * Delete one or many schedules
   * @param {array} data
   */
  SchedulingSearchStore.prototype.deleteSchedules = function (data) {
    return systemFetcher.deleteSchedules(data);
  };

  /**
   * Reset Search result data
   */
  SchedulingSearchStore.prototype.resetData = function () {
    this.searchResult = new SchedulingSearchResult();
    this.pageInfo = new PagingModel(DEFAULT_SORT_ORDER);
    this.criteria.resetData();
  };

  module.exports = SchedulingSearchStore;
}();

/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.SchedulingSearchCriteria.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Scheduling Search Criteria
 */
!function () {
  var extendObservable = __webpack_require__(5).extendObservable;
  var action = __webpack_require__(5).action;
  var CONSTANTS = __webpack_require__(158);
  var LAST_SUCCESS_RUN_VALUE = CONSTANTS.LAST_SUCCESS_RUN_VALUE;
  var DELIVERY_TYPE_VALUE = CONSTANTS.DELIVERY_TYPE_VALUE;
  var DELIVER_METHOD_VALUE = CONSTANTS.DELIVER_METHOD_VALUE;
  var DELIVERY_METHOD = CONSTANTS.DELIVERY_METHOD;
  var RECURRENCE = CONSTANTS.RECURRENCE;
  var INSTANCE_TYPE_VALUE = CONSTANTS.INSTANCE_TYPE_VALUE;
  var RECURRENCE_VALUE = CONSTANTS.RECURRENCE_VALUE;
  var DEFAULT_OPTION = CONSTANTS.DEFAULT_OPTION;

  var _require = __webpack_require__(1),
      compose = _require.compose,
      concat = _require.concat,
      clone = _require.clone,
      map = _require.map,
      split = _require.split,
      cloneDeep = _require.cloneDeep;

  var buildOptionFromData = compose(concat(DEFAULT_OPTION), map(function (item) {
    return {
      value: item,
      label: item
    };
  }));

  function SchedulingSearchCriteria() {
    var originCriteria = {
      reportType: '',
      name: '',
      instanceType: '',
      recurrence: '',
      createdBy: '',
      deliveryType: '',
      deliveryMethod: '',
      exportFileType: '',
      recipients: '',
      lastSuccessfulRun: '',
      lastSuccessfulRunFrom: '',
      lastSuccessfulRunTo: '',
      nextScheduledRun: '',
      nextScheduledRunFrom: '',
      nextScheduledRunTo: '',
      reportDashboardNameOptions: [],
      createdByOptions: [DEFAULT_OPTION],
      recipientsOptions: [DEFAULT_OPTION]
    };
    this.originCriteria = originCriteria;

    extendObservable(this, clone(originCriteria));
    extendObservable(this, {
      isDateLastSuccessRun: function isDateLastSuccessRun() {
        return this.lastSuccessfulRun === LAST_SUCCESS_RUN_VALUE.DATE;
      },
      isNextScheduledRun: function isNextScheduledRun() {
        return this.nextScheduledRun === LAST_SUCCESS_RUN_VALUE.DATE;
      },
      isHiddenRecipients: function isHiddenRecipients() {
        return this.instanceType === INSTANCE_TYPE_VALUE.SUBSCRIBE_REPORTING_ITEM || this.instanceType === INSTANCE_TYPE_VALUE.SUBSCRIBE_ALERT;
      },
      deliveryMethodOptions: function deliveryMethodOptions() {
        var deliveryType = this.deliveryType;
        if (!deliveryType) {
          return DELIVERY_METHOD;
        }
        if (deliveryType.indexOf(DELIVERY_TYPE_VALUE.EMAIL) > -1 && deliveryType.indexOf(DELIVERY_TYPE_VALUE.FILE_LOCATION) > -1) {
          return DELIVERY_METHOD;
        } else if (deliveryType.indexOf(DELIVERY_TYPE_VALUE.EMAIL) > -1) {
          return DELIVERY_METHOD.filter(function (item) {
            return item.value !== DELIVER_METHOD_VALUE.SEND_TO_DISK;
          });
        } else if (deliveryType.indexOf(DELIVERY_TYPE_VALUE.FILE_LOCATION) > -1) {
          return DELIVERY_METHOD.filter(function (item) {
            return item.value === DELIVER_METHOD_VALUE.SEND_TO_DISK || item.value === DELIVER_METHOD_VALUE.EMPTY;
          });
        }
      },
      recurrenceOptions: function recurrenceOptions() {
        var instanceType = this.instanceType;
        if (!instanceType) {
          return RECURRENCE;
        }
        if (instanceType.indexOf(INSTANCE_TYPE_VALUE.SUBSCRIBE_ALERT) === -1 && instanceType.indexOf(INSTANCE_TYPE_VALUE.SUBSCRIBE_REPORTING_ITEM) === -1) {
          return RECURRENCE.filter(function (item) {
            return item.value !== RECURRENCE_VALUE.EVERY_HOURLY || item.value !== RECURRENCE_VALUE.EVERY_DAILY;
          });
        } else if (instanceType.indexOf(INSTANCE_TYPE_VALUE.SCHEDULE_ALERT) === -1 && instanceType.indexOf(INSTANCE_TYPE_VALUE.SCHEDULE_REPORT) === -1) {
          return RECURRENCE.filter(function (item) {
            return item.value === RECURRENCE_VALUE.EVERY_HOURLY || item.value === RECURRENCE_VALUE.EVERY_DAILY || item.value === RECURRENCE_VALUE.EMPTY || item.value === RECURRENCE_VALUE.CUSTOM;
          });
        }
      }
    });
  }

  /**
   * Set Criteria value by it's key
   * @param {string} key
   * @param {string} value
   */
  SchedulingSearchCriteria.prototype.setValueByKey = function (key, value) {
    this[key] = value;
  };

  /**
   * Set Criteria Option by key
   * @param {string} key
   * @param {array} data
   */
  SchedulingSearchCriteria.prototype.setOptionByKey = function (key, data) {
    this[key] = buildOptionFromData(data);
  };

  /**
   * Get Criteria for multi value
   * @param {string} key
   * @returns {Array}
   */
  SchedulingSearchCriteria.prototype.getMultiValueCriteria = function (key) {
    return split(';', this[key]);
  };

  /**
   * Reset All Criteria to origin
   */
  SchedulingSearchCriteria.prototype.resetData = action(function () {
    var keys = (0, _keys2.default)(this.originCriteria);
    keys.forEach(function (key) {
      this[key] = this.originCriteria[key];
    }.bind(this));
  });

  /**
   * Build Data for Search
   * @returns {object}
   */
  SchedulingSearchCriteria.prototype.buildDataForSearch = function () {
    var result = cloneDeep(this);
    if (!this.isDateLastSuccessRun) {
      result.lastSuccessfulRunFrom = null;
      result.lastSuccessfulRunTo = null;
    }
    if (!this.isNextScheduledRun) {
      result.nextScheduledRunFrom = null;
      result.nextScheduledRunTo = null;
    }
    return result;
  };

  module.exports = SchedulingSearchCriteria;
}();

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.SchedulingSearchResult.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var _require = __webpack_require__(1),
      find = _require.find;

  var extendObservable = __webpack_require__(5).extendObservable;
  var asMap = __webpack_require__(5).asMap;
  var action = __webpack_require__(5).action;
  var SchedulingSearchGrid = __webpack_require__(2570);

  function SchedulingSearchResult(data) {
    extendObservable(this, {
      systemSearchResult: new SchedulingSearchGrid(),
      tenantSearchResult: asMap({}),
      isEmpty: function isEmpty() {
        var isEmpty = true;
        var tenantSearchResult = this.tenantSearchResult;
        var keys = tenantSearchResult.keys();
        for (var i = 0; i < keys.length; i++) {
          isEmpty = tenantSearchResult.get(keys[i]).isEmpty;
          if (!isEmpty) {
            break;
          }
        }
        return this.systemSearchResult.isEmpty && isEmpty;
      }
    });

    data && this.populateData(data);
  }

  /**
   * Populate search result data
   */
  SchedulingSearchResult.prototype.populateData = action(function (data, pageInfo) {
    var result = data.result;
    // System Schedules
    var systemSchedule = find({ tenantId: null, tenantName: null }, result);
    systemSchedule && (this.systemSearchResult = new SchedulingSearchGrid(systemSchedule, pageInfo));

    // Tenant Scheduling
    result.filter(function (item) {
      return !!item.tenantId && !!item.tenantName;
    }).forEach(function (tenantSchedules) {
      this.tenantSearchResult.set(tenantSchedules.tenantName, new SchedulingSearchGrid(tenantSchedules, pageInfo));
    }.bind(this));
  });

  module.exports = SchedulingSearchResult;
}();

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.SchedulingSearchGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var extendObservable = __webpack_require__(5).extendObservable;
  var action = __webpack_require__(5).action;
  var SchedulingSearchRow = __webpack_require__(2571);
  var CONSTANTS = __webpack_require__(158);
  var PagingModel = __webpack_require__(98);
  var DEFAULT_SORT_ORDER = CONSTANTS.DEFAULT_SORT_ORDER;

  var _require = __webpack_require__(1),
      clone = _require.clone,
      some = _require.some,
      findIndex = _require.findIndex,
      map = _require.map,
      times = _require.times;

  function SchedulingSearchGrid(data, pageInfo) {
    var colSortDirs = pageInfo && pageInfo.colSortDirs;

    extendObservable(this, {
      pageInfo: new PagingModel(colSortDirs || clone(DEFAULT_SORT_ORDER)),
      tenantId: null,
      tenantName: null,
      schedules: [],
      isAllChecked: function isAllChecked() {
        return !some({ selected: false }, this.schedules);
      },
      isOneChecked: function isOneChecked() {
        return some({ selected: true }, this.schedules);
      },
      isEmpty: function isEmpty() {
        return this.schedules.length === 0;
      }
    });

    data && this.populateData(data, pageInfo);
  }

  /**
   * Populate data
   * @param {object} data
   */
  SchedulingSearchGrid.prototype.populateData = action(function (data) {
    this.pageInfo.setPageIndex(data.pageIndex);
    this.pageInfo.setPageSize(data.pageSize);
    this.pageInfo.setTotalRecords(data.total);
    this.tenantId = data.tenantId;
    this.tenantName = data.tenantName;
    this.schedules = map(function (item) {
      return new SchedulingSearchRow(item);
    }, data.result);
  });

  /**
   * Update selected for whole grid
   * @param {string} value
   */
  SchedulingSearchGrid.prototype.updateSelected = action(function (value) {
    this.schedules.forEach(function (schedule) {
      schedule.updateSelected(value);
    });
  });

  /**
   * Check duplicate schedule name in one grid
   * @param {object} schedule
   * @returns {boolean}
   */
  SchedulingSearchGrid.prototype.checkDuplicateScheduleName = function (schedule) {
    return findIndex(function (item) {
      var name = item.getDataByKey('name');
      return name && schedule.name && name.toUpperCase() === schedule.name.toUpperCase() && item.getDataByKey('id') !== schedule.id && item.getDataByKey('dashboardId') === schedule.dashboardId && item.getDataByKey('reportId') === schedule.reportId;
    }, this.schedules) > -1;
  };

  /**
   * Set page index for grid
   * @param {number} pageIndex
   */
  SchedulingSearchGrid.prototype.setPageIndex = function (pageIndex) {
    this.pageInfo.setPageIndex(pageIndex);
  };

  /**
   * Set page Size for grid
   * @param {number} pageSize
   */
  SchedulingSearchGrid.prototype.setPageSize = action(function (pageSize) {
    this.pageInfo.setPageSize(pageSize);
    this.pageInfo.setPageIndex(1);
  });

  /**
   * Set column sort
   * @param {string} key
   * @param {string} sortType
   */
  SchedulingSearchGrid.prototype.setColSortDirs = function (key, sortType) {
    this.pageInfo.setColSortDirs(key, sortType);
  };

  /**
   * Delete a schedule
   * @param {object} schedule
   */
  SchedulingSearchGrid.prototype.deleteSchedule = action(function (schedule) {
    var index = findIndex({ id: schedule.id }, this.schedules);
    if (index > -1) {
      this.schedules.splice(index, 1);
      this.pageInfo.descreaseRecord();
    }
  });

  /**
   * Delete selected schedules
   */
  SchedulingSearchGrid.prototype.deleteSelectedSchedules = action(function () {
    var numberSelectedSchedules = this.schedules.filter(function (item) {
      return item.selected;
    }).length;
    this.schedules = this.schedules.filter(function (item) {
      return !item.selected;
    });
    var pageInfo = this.pageInfo;
    times(pageInfo.descreaseRecord.bind(pageInfo), numberSelectedSchedules);
  });

  module.exports = SchedulingSearchGrid;
}();

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.SchedulingSearchRow.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var extendObservable = __webpack_require__(5).extendObservable;
  var action = __webpack_require__(5).action;
  var SubscriptionDetails = __webpack_require__(229);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  function SchedulingSearchRow(data) {
    var props = {
      subscription: new SubscriptionDetails(),
      reportingType: '',
      reportDashboardName: '',
      createdBy: '',
      selected: false,
      id: function id() {
        return this.subscription.id;
      }
    };

    extendObservable(this, props);

    data && this.populateData(data);
  }

  /**
   * Populate data
   */
  SchedulingSearchRow.prototype.populateData = action(function (data) {
    this.subscription.populate(data);
    this.reportingType = data.reportingType;
    this.reportDashboardName = data.reportDashboardName;
    this.createdBy = data.createdBy;
  });

  /**
   * get data by key
   * @param key
   * @returns {*}
   */
  SchedulingSearchRow.prototype.getDataByKey = function (key) {
    var result = this[key];
    isNil(result) && (result = this.subscription[key]);
    return result;
  };

  /**
   * Update selected
   * @param value
   */
  SchedulingSearchRow.prototype.updateSelected = function (value) {
    this.selected = value;
  };

  module.exports = SchedulingSearchRow;
}();

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfigurationStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var _Izenda3 = __webpack_require__(2573);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(326);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(75);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var EmailConfigurationStore = (_class = function () {
  function EmailConfigurationStore() {
    (0, _classCallCheck3.default)(this, EmailConfigurationStore);

    _initDefineProp(this, 'emailConfiguration', _descriptor, this);

    _initDefineProp(this, 'clonedEmailConfiguration', _descriptor2, this);

    _initDefineProp(this, 'alertDetails', _descriptor3, this);
  }

  (0, _createClass3.default)(EmailConfigurationStore, [{
    key: 'loadEmailConfiguration',


    /**
     * Load email configuration
     */
    value: function loadEmailConfiguration() {
      var _this = this;

      return _Izenda8.default.loadEmailConfiguration(_Izenda2.default.tenantId).then(function (result) {
        _this.emailConfiguration = new _Izenda4.default(result);
        _this.clonedEmailConfiguration = _this.emailConfiguration.clone();
        return result;
      });
    }

    /**
     * Save email configuration
     */

  }, {
    key: 'saveEmailConfiguration',
    value: function saveEmailConfiguration() {
      var _this2 = this;

      return _Izenda8.default.saveEmailConfiguration(this.clonedEmailConfiguration.buildDataForSave()).then(function (result) {
        if (result.success) {
          _this2.emailConfiguration.populateData(_this2.clonedEmailConfiguration);
          _this2.resetDirty();
        }
        return result;
      });
    }

    /**
     * Cancel change
     */

  }, {
    key: 'cancelChangeConfiguration',
    value: function cancelChangeConfiguration() {
      this.clonedEmailConfiguration = this.emailConfiguration.clone();
    }

    /**
     * Reset dirty
     */

  }, {
    key: 'resetDirty',
    value: function resetDirty() {
      this.emailConfiguration.resetDirty();
      this.clonedEmailConfiguration.resetDirty();
    }

    /**
     * Init email configuration store
     */

  }, {
    key: 'init',
    value: function init() {
      var _this3 = this;

      _Izenda2.default.setCheckDirtyFunction(function () {
        return _this3.emailConfiguration.isDirty || _this3.clonedEmailConfiguration.isDirty;
      });
    }

    /**
     * Destroy email configuration store
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      _Izenda2.default.resetCheckDirtyFunction();
    }
  }, {
    key: 'isShowConfiguration',
    get: function get() {
      return _Izenda2.default.tenantId;
    }
  }]);
  return EmailConfigurationStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'emailConfiguration', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda4.default();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'clonedEmailConfiguration', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda4.default();
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'alertDetails', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda6.default();
  }
}), _applyDecoratedDescriptor(_class.prototype, 'isShowConfiguration', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isShowConfiguration'), _class.prototype)), _class);
exports.default = EmailConfigurationStore;
module.exports = exports['default'];

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var EmailConfiguration = (0, _Izenda2.default)(_class = (_class2 = function () {
  function EmailConfiguration(data) {
    (0, _classCallCheck3.default)(this, EmailConfiguration);

    _initDefineProp(this, 'id', _descriptor, this);

    _initDefineProp(this, 'tenantId', _descriptor2, this);

    _initDefineProp(this, 'server', _descriptor3, this);

    _initDefineProp(this, 'port', _descriptor4, this);

    _initDefineProp(this, 'secureConnection', _descriptor5, this);

    _initDefineProp(this, 'login', _descriptor6, this);

    _initDefineProp(this, 'password', _descriptor7, this);

    _initDefineProp(this, 'displayName', _descriptor8, this);

    _initDefineProp(this, 'emailFromAddress', _descriptor9, this);

    _initDefineProp(this, 'useSystemConfiguration', _descriptor10, this);

    _initDefineProp(this, 'version', _descriptor11, this);

    _initDefineProp(this, 'created', _descriptor12, this);

    _initDefineProp(this, 'createdBy', _descriptor13, this);

    _initDefineProp(this, 'modified', _descriptor14, this);

    _initDefineProp(this, 'modifiedBy', _descriptor15, this);

    data && this.populateData(data);
  }

  /**
   * Set value by key
   * @param {string} key 
   * @param {any} value 
   */


  (0, _createClass3.default)(EmailConfiguration, [{
    key: 'setValueByKey',
    value: function setValueByKey(key, value) {
      this[key] = value;
      this.markDirty();
    }

    /**
     * Populate Data
     */

  }, {
    key: 'populateData',
    value: function populateData(data) {
      this.useSystemConfiguration = data.useSystemConfiguration;
      this.tenantId = data.tenantId || _Izenda4.default.tenantId;
      // Ignore other data when it belong to a tenant which use system configuration
      if (this.tenantId && this.useSystemConfiguration) return;
      this.id = data.id;
      this.server = data.server;
      this.port = data.port;
      this.secureConnection = data.secureConnection;
      this.login = data.login;
      this.password = data.password;
      this.displayName = data.displayName;
      this.emailFromAddress = data.emailFromAddress;
      this.useSystemConfiguration = data.useSystemConfiguration;
      this.version = data.version;
      this.created = data.createdBy;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
    }

    /**
     * Clone a EmailConfiguration
     * @returns {EmailConfiguration}
     */

  }, {
    key: 'clone',
    value: function clone() {
      return new EmailConfiguration(this);
    }

    /**
     * Build data for save, remove useSystemConfiguration property if system in system's mode
     */

  }, {
    key: 'buildDataForSave',
    value: function buildDataForSave() {
      return !this.tenantId ? (0, _fp.omit)(['useSystemConfiguration'], this) : this;
    }
  }]);
  return EmailConfiguration;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'tenantId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'server', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'port', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'secureConnection', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'login', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'password', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'displayName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'emailFromAddress', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'useSystemConfiguration', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'version', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'created', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'createdBy', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'modified', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'modifiedBy', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'setValueByKey', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setValueByKey'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype)), _class2)) || _class;

exports.default = EmailConfiguration;
module.exports = exports['default'];

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _bluebird = __webpack_require__(18);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfigurationStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Report Configuration Store
 */


var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(75);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(263);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(111);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(15);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2575);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(326);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportConfigurationStore = (_class = function () {
  function ReportConfigurationStore() {
    var _this = this;

    (0, _classCallCheck3.default)(this, ReportConfigurationStore);

    _initDefineProp(this, 'reportConfiguration', _descriptor, this);

    _initDefineProp(this, 'alertDetail', _descriptor2, this);

    this.disposeTenantObservation = (0, _mobx.observe)(_Izenda8.default, 'tenantId', function () {
      _this.loadDefaultImageUrl();
    });
  }

  (0, _createClass3.default)(ReportConfigurationStore, [{
    key: 'initData',
    value: function initData() {
      this.alertDetail = {};
      return this.loadData();
    }

    /**
     * Load data
     * @returns {Promise}
     */

  }, {
    key: 'loadData',
    value: function loadData() {
      var _this2 = this;

      var populateData = (0, _mobx.action)(function (data) {
        data && _this2.reportConfiguration.populateData(data);
        return (0, _bluebird.resolve)(data);
      });

      return (0, _bluebird.all)([_Izenda2.default.getReportConfiguration().bind(this).then(populateData), this.loadDefaultImageUrl(), this.loadDefaultTheme()]);
    }

    /**
     * Load default image URL
     * @returns {Promise}
     */

  }, {
    key: 'loadDefaultImageUrl',
    value: function loadDefaultImageUrl() {
      var _this3 = this;

      return _Izenda4.default.getDefaultImageUrl(this.tenantId).then(function (data) {
        if (!(0, _fp.isNil)(data) && data != '') {
          _this3.reportConfiguration.defaultImageUrl = data;
        } else {
          _this3.reportConfiguration.defaultImageUrl = {
            value: '',
            tenantId: _this3.tenantId
          };
        }
        return null;
      });
    }

    /**
     * Reset data
     * @returns {Promise}
     */

  }, {
    key: 'onCancel',
    value: function onCancel() {
      this.alertDetail = {};
      return this.loadData();
    }

    /**
     * Save data
     * @returns {Promise}
     */

  }, {
    key: 'onSave',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var data, saveConfigurationResult, saveUrlResult, saveThemeResult;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(0, _fp.isNil)(this.tenantId)) {
                  _context.next = 7;
                  break;
                }

                data = this.reportConfiguration.buildDataForSaving();
                _context.next = 4;
                return _Izenda2.default.saveReportConfiguration(data);

              case 4:
                saveConfigurationResult = _context.sent;

                if ((0, _fp.getOr)(true, 'success', saveConfigurationResult)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', saveConfigurationResult);

              case 7:
                _context.next = 9;
                return _Izenda4.default.saveDefaultImageUrl(this.reportConfiguration.defaultImageUrl);

              case 9:
                saveUrlResult = _context.sent;

                if ((0, _fp.getOr)(true, 'success', saveUrlResult)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt('return', saveUrlResult);

              case 12:
                _context.next = 14;
                return _Izenda4.default.saveDefaultTheme(this.reportConfiguration.defaultColorTheme);

              case 14:
                saveThemeResult = _context.sent;

                if ((0, _fp.getOr)(true, 'success', saveThemeResult)) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt('return', saveThemeResult);

              case 17:

                this.reportConfiguration.resetDirty();
                return _context.abrupt('return', { success: true });

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSave() {
        return _ref.apply(this, arguments);
      }

      return onSave;
    }()
    /**
     * clear archived version
     * @returns {Promise}
     */

  }, {
    key: 'onClearArchivedVersion',
    value: function onClearArchivedVersion() {
      return _Izenda6.default.clearArchivedVersion();
    }

    /**
     * Update alert detail
     * @param {string} type
     * @param {string} message
     */

  }, {
    key: 'updateAlertMessage',
    value: function updateAlertMessage(type, message) {
      this.alertDetail = {
        alertType: type,
        message: message
      };
    }

    /**
     * Init store
     */

  }, {
    key: 'init',
    value: function init() {
      var _this4 = this;

      this.alertDetail = {};
      _Izenda8.default.setCheckDirtyFunction(function () {
        return _this4.reportConfiguration.isDirty;
      });
    }

    /**
     * Destroy
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this.disposeTenantObservation();
      _Izenda8.default.resetCheckDirtyFunction();
    }

    /**
     * Check need to validate global and local name.
     * @returns {boolean}
     */

  }, {
    key: 'doesNeedToValidateGlobalAndLocalNames',
    value: function doesNeedToValidateGlobalAndLocalNames() {
      return (0, _fp.isNil)(this.tenantId) && !!_Izenda8.default.currentUser.systemAdmin;
    }

    /**
     * Load default theme.
     * @returns {Promise}
     */

  }, {
    key: 'loadDefaultTheme',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var defaultTheme;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _Izenda4.default.getDefaultTheme(this.tenantId);

              case 2:
                defaultTheme = _context2.sent;


                if (!(0, _fp.isNil)(defaultTheme) && defaultTheme != '') {
                  this.reportConfiguration.defaultColorTheme = defaultTheme;
                } else {
                  this.reportConfiguration.defaultColorTheme = {
                    value: null,
                    tenantId: this.tenantId
                  };
                }
                return _context2.abrupt('return', (0, _bluebird.resolve)(null));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadDefaultTheme() {
        return _ref2.apply(this, arguments);
      }

      return loadDefaultTheme;
    }()
  }, {
    key: 'tenantId',
    get: function get() {
      return _Izenda8.default.getTenantId();
    }

    /**
     * Initial data
     * @returns {Promise}
     */

  }]);
  return ReportConfigurationStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'reportConfiguration', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda10.default();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'alertDetail', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _Izenda12.default();
  }
}), _applyDecoratedDescriptor(_class.prototype, 'tenantId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tenantId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onCancel', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onCancel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSave', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSave'), _class.prototype)), _class);
exports.default = ReportConfigurationStore;
module.exports = exports['default'];

/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

var _Izenda = __webpack_require__(54);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(625);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(115);

var _fp = __webpack_require__(1);

var _Izenda6 = __webpack_require__(15);

var _Izenda7 = _interopRequireDefault(_Izenda6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ReportConfiguration = (0, _Izenda2.default)(_class = (_class2 = function () {

  /**
   * Init instant
   * @param {Object} data
   */
  function ReportConfiguration(data) {
    (0, _classCallCheck3.default)(this, ReportConfiguration);

    _initDefineProp(this, 'enforceVersionHistory', _descriptor, this);

    _initDefineProp(this, 'numOfArchivedVersionToKeep', _descriptor2, this);

    _initDefineProp(this, 'removeArchivedVersions', _descriptor3, this);

    _initDefineProp(this, 'recurrentReportSetting', _descriptor4, this);

    _initDefineProp(this, 'defaultImageUrl', _descriptor5, this);

    _initDefineProp(this, 'globalCategoryName', _descriptor6, this);

    _initDefineProp(this, 'localCategoryName', _descriptor7, this);

    _initDefineProp(this, 'defaultColorTheme', _descriptor8, this);

    this.numOfArchivedVersionToKeepDefault = 0;
    data && this.populateData(data);
  }

  /**
   * Reset data
   */


  (0, _createClass3.default)(ReportConfiguration, [{
    key: 'resetData',
    value: function resetData() {
      this.resetDirty();
      this.defaultColorTheme.value = undefined;
    }

    /**
     * populate data
     * @param {Object} data
     */

  }, {
    key: 'populateData',
    value: function populateData(data) {
      this.enforceVersionHistory = data.enforceVersionHistory;
      this.numOfArchivedVersionToKeep = data.numOfArchivedVersionToKeep;
      this.numOfArchivedVersionToKeepDefault = data.numOfArchivedVersionToKeepDefault;
      this.removeArchivedVersions = data.removeArchivedVersions;
      this.globalCategoryName = data.globalCategoryName || _Izenda4.default.DEFAULT_VALUES.GLOBAL_NAME;
      this.localCategoryName = data.localCategoryName || _Izenda4.default.DEFAULT_VALUES.LOCAL_NAME;

      this.populateRecurrentReport(data.recurrentReportSetting);
      this.resetDirty();
    }

    /**
     * Populate recurrent report
     * @param {Object} data
     */

  }, {
    key: 'populateRecurrentReport',
    value: function populateRecurrentReport(data) {
      this.recurrentReportSetting.once = data.once;
      this.recurrentReportSetting.recurrence = data.recurrence;
      this.recurrentReportSetting.recurrenceType = data.recurrenceType;
      this.recurrentReportSetting.occurValue = data.occurValue;
      this.setupDate(data.once, data);
    }

    /**
     * Setup date
     * @param {Object} once
     * @param {Object} data
     */

  }, {
    key: 'setupDate',
    value: function setupDate(once, data) {
      data = data || {};
      var startDate = data.startDate ? (0, _moment2.default)(data.startDate).format(_Izenda7.default.currentUser.dateFormat) : null;

      if (once) {
        this.recurrentReportSetting.atDate = startDate;
        this.recurrentReportSetting.atTime = data.startTime || null;
        this.recurrentReportSetting.startDate = null;
        this.recurrentReportSetting.startTime = null;
      } else {
        this.recurrentReportSetting.startDate = startDate;
        this.recurrentReportSetting.startTime = data.startTime || null;
        this.recurrentReportSetting.atDate = null;
        this.recurrentReportSetting.atTime = null;
      }
    }

    /**
     * Compose saving data
     * @returns {Object}
     */

  }, {
    key: 'buildDataForSaving',
    value: function buildDataForSaving() {
      var recurrence = this.recurrentReportSetting;
      var date = recurrence.once ? recurrence.atDate : recurrence.startDate;
      var time = recurrence.once ? recurrence.atTime : recurrence.startTime;
      var dateFormat = _Izenda7.default.currentUser.dateFormat;
      var dateFormatted = (0, _moment2.default)(date, dateFormat).isValid() ? (0, _moment2.default)(date, dateFormat).format(_Izenda5.DATE_FORMAT) : date;

      return {
        enforceVersionHistory: this.enforceVersionHistory,
        numOfArchivedVersionToKeep: this.numOfArchivedVersionToKeep,
        removeArchivedVersions: this.removeArchivedVersions,
        recurrentReportSetting: {
          once: recurrence.once,
          recurrence: recurrence.recurrence,
          startDate: dateFormatted,
          startTime: time,
          recurrenceType: recurrence.recurrenceType,
          occurValue: recurrence.occurValue
        },
        globalCategoryName: this.globalCategoryName,
        localCategoryName: this.localCategoryName
      };
    }

    /**
     * Update property by key
     * @param {string} key
     * @param {Object} value
     */

  }, {
    key: 'setValueByKey',
    value: function setValueByKey(key, value) {
      switch (key) {
        case 'enforceVersionHistory':
          this.enforceVersionHistory = value;
          break;
        case 'numOfArchivedVersionToKeep':
          this.numOfArchivedVersionToKeep = parseInt(value) || 0;
          break;
        case 'removeArchivedVersions':
          this.removeArchivedVersions = value;
          break;
        case 'occurValue':
          this.recurrentReportSetting.occurValue = parseInt(value) || 0;
          break;
        case 'startDate':
          this.recurrentReportSetting.startDate = value;
          break;
        case 'startTime':
          this.recurrentReportSetting.startTime = value;
          break;
        case 'atDate':
          this.recurrentReportSetting.atDate = value;
          break;
        case 'atTime':
          this.recurrentReportSetting.atTime = value;
          break;
        case 'defaultImageUrl':
          this.defaultImageUrl.value = value;
          break;
        case 'globalCategoryName':
          this.globalCategoryName = value;
          break;
        case 'localCategoryName':
          this.localCategoryName = value;
          break;
        case 'defaultColorTheme':
          this.defaultColorTheme.value = value;
          break;
      }
      this.markDirty();
    }

    /**
     * Update type archived
     * @param {string} key
     * @param {Object} value
     */

  }, {
    key: 'setTypeArchived',
    value: function setTypeArchived(key, value) {
      switch (key) {
        case 'once':
          this.recurrentReportSetting.once = true;
          this.recurrentReportSetting.recurrence = false;
          break;
        case 'recurrence':
          this.recurrentReportSetting.once = false;
          this.recurrentReportSetting.recurrence = true;
          break;
      }
      this.setupDate(key === 'once');
      this.markDirty();
    }

    /**
     * reset num of archived version to keep.
     */

  }, {
    key: 'resetNumOfArchivedVersionToKeep',
    value: function resetNumOfArchivedVersionToKeep() {
      this.numOfArchivedVersionToKeep = this.numOfArchivedVersionToKeepDefault;
    }

    /**
     * Update num of archived version to keep.
     * @param {Object} value
     */

  }, {
    key: 'setNumOfArchivedVersionToKeep',
    value: function setNumOfArchivedVersionToKeep(value) {
      var newValue = parseInt(value) || 0;
      if (newValue >= 0 && newValue <= 20) {
        this.numOfArchivedVersionToKeep = newValue;
      }
    }

    /**
     * Update recurrence key
     * @param {Object} key
     * @param {Object} value
     */

  }, {
    key: 'setRecurrenceType',
    value: function setRecurrenceType(key, value) {
      this.recurrentReportSetting.recurrenceType = key;
      this.markDirty();
    }

    /**
     * Check duplicate global and local names.
     * @returns {boolean}
     */

  }, {
    key: 'doesDuplicateGlobalAndLocalName',
    value: function doesDuplicateGlobalAndLocalName() {
      return !!this.globalCategoryName && (0, _fp.isEqual)((0, _fp.trim)(this.globalCategoryName), (0, _fp.trim)(this.localCategoryName));
    }
  }]);
  return ReportConfiguration;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'enforceVersionHistory', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'numOfArchivedVersionToKeep', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'removeArchivedVersions', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'recurrentReportSetting', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      once: false,
      recurrence: false,
      startDate: null,
      startTime: null,
      recurrenceType: 0,
      occurValue: 0,
      atDate: null,
      atTime: null
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'defaultImageUrl', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      value: ''
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'globalCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda4.default.DEFAULT_VALUES.GLOBAL_NAME;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'localCategoryName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda4.default.DEFAULT_VALUES.LOCAL_NAME;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'defaultColorTheme', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      value: undefined
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'resetData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateData', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateData'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'populateRecurrentReport', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'populateRecurrentReport'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setupDate', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setupDate'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setValueByKey', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setValueByKey'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setTypeArchived', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setTypeArchived'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setRecurrenceType', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setRecurrenceType'), _class2.prototype)), _class2)) || _class;

exports.default = ReportConfiguration;
module.exports = exports['default'];

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerToolbar.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(148);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(30);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(632);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(233);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2577);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda13 = __webpack_require__(42);

var _Izenda14 = __webpack_require__(45);

var _Izenda15 = __webpack_require__(633);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailButton = (0, _Izenda2.default)()(_Izenda6.default);
var AuthorizationButton = (0, _Izenda2.default)()(_Izenda6.default);
var ExportReportBtn = (0, _Izenda2.default)()(function (props) {
  return _react2.default.createElement(_Izenda16.default.ExportReportButton, props);
});
var PrintBtn = (0, _Izenda2.default)()(function (props) {
  return _react2.default.createElement(_Izenda16.default.PrintReportButton, props);
});
EmailButton.displayName = 'EmailButton';
AuthorizationButton.displayName = 'AuthorizationButton';
ExportReportBtn.displayName = 'ExportReportBtn';

var ReportViewerToolbar = (_dec = (0, _Izenda4.default)(_Izenda12.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportViewerToolbar, _Component);

  function ReportViewerToolbar(props) {
    (0, _classCallCheck3.default)(this, ReportViewerToolbar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportViewerToolbar.__proto__ || (0, _getPrototypeOf2.default)(ReportViewerToolbar)).call(this, props));

    var displayMode = props.fieldStore.reportStore.model.displayMode;
    _this.toggleSubscription = displayMode.toggleSubscription.bind(displayMode);
    _this.exposeIntegrationMethod();
    return _this;
  }

  (0, _createClass3.default)(ReportViewerToolbar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.registerExposeMethod !== nextProps.registerExposeMethod || this.props.updateResults !== nextProps.updateResults) {
        this.removeIntegrationMethod();
        this.exposeIntegrationMethod();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeIntegrationMethod();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var reportStore = this.props.fieldStore.reportStore;
      reportStore.alertDetails.reset();
    }
  }, {
    key: 'removeIntegrationMethod',
    value: function removeIntegrationMethod() {
      (0, _fp.invokeArgs)('unregisterExposeMethod', [['updateResults']], this.props);
    }
  }, {
    key: 'exposeIntegrationMethod',
    value: function exposeIntegrationMethod() {
      var method = {
        updateResults: this.props.updateResults.bind(null, null)
      };

      (0, _fp.invokeArgs)('registerExposeMethod', [method], this.props);
    }

    /**
     * Check save permission.
     */

  }, {
    key: 'checkPermissionOfSave',
    value: function checkPermissionOfSave() {
      var _props = this.props,
          authorization = _props.authorization,
          PERMISSION_KEY = _props.authorizationConstants.PERMISSION_KEY;


      return authorization.checkPrivileges([PERMISSION_KEY.ReportsCanCreateNewReportValue]);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var localization = props.localization,
          store = props.store,
          fieldStore = props.fieldStore,
          authorization = props.authorization,
          editMode = props.editMode,
          reportId = props.reportId,
          designerStore = props.designerStore,
          boardDetail = props.boardDetail,
          location = props.location,
          reportSubscriptionStore = props.reportSubscriptionStore;
      var reportStore = fieldStore.reportStore,
          _fieldStore$reportSto = fieldStore.reportStore.model,
          displayMode = _fieldStore$reportSto.displayMode,
          accessPriority = _fieldStore$reportSto.accessPriority,
          active = _fieldStore$reportSto.active;
      var reportName = store.reportName,
          reportType = store.reportType,
          selectedCategoryId = store.selectedCategoryId;

      var viewMode = !editMode;
      var doesShowSaveButton = this.checkPermissionOfSave();
      var hasScheduleLicense = authorization.checkLicense(_Izenda14.LICENSE_KEY.Scheduling);
      var hasExportLicense = authorization.checkLicense(_Izenda14.LICENSE_KEY.Exporting);

      var subscribeClassName = (0, _classnames2.default)({
        'izenda-Button_active': displayMode.isSubscriptionMode
      });

      var _reportStore$alertDet = reportStore.alertDetails,
          message = _reportStore$alertDet.message,
          alertType = _reportStore$alertDet.alertType,
          alertKey = _reportStore$alertDet.key,
          success = _reportStore$alertDet.success,
          errors = _reportStore$alertDet.errors,
          showType = _reportStore$alertDet.showType,
          type = _reportStore$alertDet.type;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper-header' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-Alert-container' },
          _react2.default.createElement(_Izenda8.default, {
            message: message,
            alertType: alertType,
            alertKey: alertKey,
            success: success,
            errors: errors,
            type: type,
            showType: showType
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-ActionBarRight' },
          _react2.default.createElement(
            _Izenda10.default,
            null,
            props.checkDisplayShowHideHeaderFooter(fieldStore) && _react2.default.createElement(_Izenda6.default, {
              onClick: props.onDisplayShowHideHeaderFooter,
              label: props.getShowHideHeaderFooterLabel(designerStore, localization)
            }),
            (accessPriority === _Izenda13.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda13.ACCESS_RIGHT.QuickEdit || accessPriority === _Izenda13.ACCESS_RIGHT.SaveAs) && active && !viewMode && _react2.default.createElement(_Izenda16.default.ViewReportButton, {
              reportId: reportId,
              disabled: viewMode,
              store: store,
              location: location
            }),
            hasScheduleLicense && _react2.default.createElement(AuthorizationButton, {
              label: localization.getText('COMMON_LABEL_SUBSCRIBE'),
              className: subscribeClassName,
              onClick: this.toggleSubscription,
              keys: [_Izenda13.PERMISSION_KEY.ReportsActionsSubscribe]
            }),
            hasExportLicense && _react2.default.createElement(PrintBtn, {
              name: reportName,
              store: store,
              print: store.printReport,
              designerStore: designerStore,
              id: reportId,
              disabled: displayMode.doesDisablePrintBtn,
              keys: [_Izenda13.PERMISSION_KEY.ReportsActionsPrint]
            }),
            _react2.default.createElement(EmailButton, {
              label: localization.getText('COMMON_LABEL_EMAIL'),
              onClick: props.openEmailPopup,
              disabled: displayMode.doesDisableEmailBtn,
              keys: [_Izenda13.PERMISSION_KEY.ReportsActionsEmail]
            }),
            hasExportLicense && _react2.default.createElement(ExportReportBtn, {
              name: reportName,
              store: store,
              'export': store.exportReport,
              designerStore: designerStore,
              id: reportId,
              disabled: displayMode.doesDisableExportBtn,
              keys: [_Izenda13.PERMISSION_KEY.ReportsActionsExporting]
            }),
            _react2.default.createElement(_Izenda16.default.EditReportButton, {
              store: store,
              reportId: reportId,
              reportType: reportType,
              categoryId: selectedCategoryId,
              viewMode: viewMode,
              boardDetail: boardDetail,
              confirmFn: props.confirmFn,
              onSave: props.onSave,
              disabled: displayMode.doesDisableEditBtn,
              location: location,
              fieldStore: fieldStore,
              accessPriority: accessPriority,
              active: active
            }),
            accessPriority !== _Izenda13.ACCESS_RIGHT.Locked && _react2.default.createElement(_Izenda16.default.UpdateReportButton, {
              updateResults: props.updateResults,
              disabled: displayMode.doesDisableUpdateResultBtn
            }),
            doesShowSaveButton && (accessPriority === _Izenda13.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda13.ACCESS_RIGHT.QuickEdit || accessPriority === _Izenda13.ACCESS_RIGHT.SaveAs) && _react2.default.createElement(_Izenda16.default.SaveReportButton, {
              reportStore: store,
              fieldStore: fieldStore,
              subscribedInstancesStore: reportSubscriptionStore,
              onSave: props.onSave,
              viewMode: viewMode,
              confirmFn: props.confirmFn,
              accessPriority: accessPriority,
              boardDetail: boardDetail,
              active: active,
              keepDisplay: true
            }),
            accessPriority !== _Izenda13.ACCESS_RIGHT.Locked && _react2.default.createElement(_Izenda16.default.CancelViewReportButton, {
              confirmFn: props.confirmFn,
              checkDirty: props.checkDirty,
              cancelReport: props.cancelReport,
              keepDisplay: true
            }),
            _react2.default.createElement(_Izenda16.default.CloseViewReportButton, {
              reportId: reportId,
              reportType: reportType,
              categoryId: selectedCategoryId,
              fieldStore: fieldStore,
              location: location,
              store: store
            })
          )
        )
      );
    }
  }]);
  return ReportViewerToolbar;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object.isRequired,
  reportId: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = ReportViewerToolbar;
module.exports = exports['default'];

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(437);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(225);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(119);

var _Izenda6 = __webpack_require__(16);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(37);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(50);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(12);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(604);

var _fp = __webpack_require__(1);

var _Izenda15 = __webpack_require__(231);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(15);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var integrationStyleAction = _Izenda16.default.checkDisplayByKey('hideToolbar');
/**
 * Open Email Popup
 * @param {Object} props
 * @param {Object} e
 * @returns {Object}
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportViewerToolbarActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/* eslint-disable no-unused-vars */

var openEmailPopup = function openEmailPopup(props, e) {
  var designerStore = props.designerStore,
      boardDetail = props.boardDetail,
      localization = props.localization,
      store = props.store;


  var handleCloseEmailPopup = function handleCloseEmailPopup(email) {
    if (!email) {
      return false;
    }
    // No need to check filters when email report link
    if ((0, _fp.get)('deliveryMethod', email) === _Izenda5.DELIVERY_METHOD.link) {
      return store.sendEmail(null, email, boardDetail.id);
    }

    return designerStore.savePrintDraft().get('id').then(function (prinDraftId) {
      return _Izenda4.default.checkRequiredFilters(designerStore, prinDraftId).then(function (isValidFilter) {
        if (!isValidFilter) {
          return localization.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_REQUIRED_FILTER_EMAIL');
        }
        return store.sendEmail(prinDraftId, email, props.reportId);
      });
    });
  };

  props.openPopup(_Izenda2.default, {
    onClosed: handleCloseEmailPopup,
    type: _Izenda5.EMAIL_TYPE.report,
    reportId: boardDetail.id
  });
};

/**
 * Update Results
 * @param {Object} props
 * @param {Object} _
 * @returns {Object}
 */
var updateResults = function updateResults(props, _) {
  var _props$fieldStore = props.fieldStore,
      reportStore = _props$fieldStore.reportStore,
      reportFilters = _props$fieldStore.reportFilters,
      loader = props.loader;

  var validateFilterMessage = checkFilterRule(reportFilters);

  if (!validateFilterMessage) {
    // Update config field list for report filter info
    props.editMode && reportFilters.updateConfigFieldList();
    loader.startLoading();
    return reportStore.detectSchemaChange().then(function (result) {
      return result.hasChanged ? props.confirmFn('Information', {
        description: _Izenda11.default.MESSAGES.UPDATE_RESULT(result.filterFields),
        type: 'info',
        isHTMLFormat: true,
        showCloseIndicator: true
      }).then(reportStore.updateResults.bind(reportStore)) : props.updateReportParts();
    }).finally(function () {
      reportFilters.resetUpdateResult();
      loader.endLoading();
      return true;
    });
  } else {
    return props.confirmFn('Information', {
      description: validateFilterMessage,
      type: 'info',
      isHTMLFormat: true,
      showCloseIndicator: true
    }).then(function () {
      return false;
    });
  }
};

/**
 * Show Filter Warning Message
 * @param {Object} props
 * @returns {boolean}
 */
var showFilterWarningMessage = function showFilterWarningMessage(props) {
  var warningMessage = props.fieldStore && props.fieldStore.getUnspecifiedFilterWarning();
  return warningMessage ? props.confirmFn('Information', {
    type: _Izenda9.default.MESSAGE_TYPE.INFO_ACCEPT,
    description: warningMessage,
    showCancel: false
  }) : (0, _bluebird.resolve)(false);
};

/*
 *	Check filter rules before save
 * @param {Array<Object>} reportFilters
 * @returns {Object}
 */
var checkFilterRule = function checkFilterRule(reportFilters) {
  var emptyRequiredParamFilters = reportFilters.emptyRequiredParamFilters,
      emptyNotVisibleRequiredFilter = reportFilters.emptyNotVisibleRequiredFilter,
      emptyVisibleRequiredFilter = reportFilters.emptyVisibleRequiredFilter;
  // For filter made from input param

  if (!(0, _fp.isEmpty)(emptyRequiredParamFilters)) {
    if (!(0, _fp.isEmpty)(emptyNotVisibleRequiredFilter)) {
      return _Izenda11.default.MESSAGES.EMPTY_REQUIRED_PARAM_FILTER(emptyRequiredParamFilters, emptyNotVisibleRequiredFilter);
    }
    return _Izenda11.default.MESSAGES.EMPTY_FILTER_PARAM(emptyRequiredParamFilters);
  }

  // For normal filter
  if (!(0, _fp.isEmpty)(emptyNotVisibleRequiredFilter)) {
    return _Izenda11.default.MESSAGES.EMPTY_REQUIRED_FILTER(emptyNotVisibleRequiredFilter);
  }
  if (!(0, _fp.isEmpty)(emptyVisibleRequiredFilter)) {
    return _Izenda11.default.MESSAGES.EMPTY_VISIBLE_REQUIRED_FILTER(emptyVisibleRequiredFilter);
  }

  return null;
};

/**
 * Save report
 * @param {Object} props
 * @returns {Object}
 */
var saveReport = function saveReport(props) {
  var fieldStore = props.fieldStore,
      loader = props.loader,
      validation = props.validation,
      reportSubscriptionStore = props.reportSubscriptionStore,
      inheritFilter = props.location.query.inheritFilter;

  var reportDesignerStore = fieldStore.reportStore;

  reportDesignerStore.model.setIgnoreCheckChange();

  loader.startLoading();
  return updateResults(props, null).then(function (result) {
    return result && (0, _bluebird.join)(reportDesignerStore.saveReport(_Izenda7.default.PAGE_NAME.FIELDS, true /* save from viewer*/), reportSubscriptionStore.saveInstances(), function (saveReportResult, saveSubscriptionResult) {
      if (saveReportResult.messages && saveReportResult.messages.length > 0) {
        var messageKey = saveReportResult.messages[0].key;

        props.confirmFn('Information', {
          description: saveReportResult.messages[0].messages[0],
          type: _Izenda9.default.MESSAGE_TYPE.INFO,
          showCloseIndicator: true,
          isHTMLFormat: true
        }).then(function () {
          if (messageKey === _Izenda7.default.MESSAGE_KEY.CONCURRENCY) {
            return props.confirmFn('Confirmation', {
              description: _Izenda13.default.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST')
            }).then(function () {
              return props.cancelReport();
            });
          }
        });
      }
      validation.reset();
      var success = saveReportResult.success && saveSubscriptionResult.success;

      success && fieldStore.getFilterData();
      if (saveSubscriptionResult.success) {
        reportSubscriptionStore.loadInstances();
      }

      // Update Error for report
      if (!saveReportResult.success) {
        validation.updateErrors(saveReportResult.messages);
      }
      return success;
    });
  }).then(function (result) {
    inheritFilter && props.resetReport();
    return result ? showFilterWarningMessage(props).then(function () {
      return result;
    }) : result;
  }).finally(loader.endLoading.bind(loader));
};

/**
 * Save Report Designer:
 *  - Validate data > if data valid:
 *    + open Save Popup for new Report
 *    + only save for existing Report
 * @param {Object} props
 * @param {Object} saveDesign
 * @returns {Object}
 */
var onSave = function onSave(props, saveDesign) {
  var store = props.store,
      fieldStore = props.fieldStore;
  var reportFilters = fieldStore.reportFilters,
      reportStore = fieldStore.reportStore,
      reportBody = fieldStore.model.reportBody;


  reportStore.canSaveAs = false;

  // Reset alert message
  reportStore.alertDetails.set({
    message: _Izenda9.default.EMPTY_MESSAGE.message
  });

  // Filter Validation
  var checkFilterMessage = checkFilterRule(reportFilters);

  if (checkFilterMessage) {
    return props.confirmFn('Information', {
      description: checkFilterMessage,
      type: 'info',
      isHTMLFormat: true,
      showCloseIndicator: true
    });
  }
  var allowToSave = (0, _fp.get)('masterModel.allowToSave', fieldStore);

  if (checkDirty(props) || (0, _fp.isBoolean)(saveDesign) && !!saveDesign || allowToSave) {
    if (reportBody.hasInvisibleFields) {
      var object = _Izenda11.default.reportTypeName(store.reportType);
      var message = String.format(_Izenda11.default.MESSAGES.SAVE_REPORT, object);

      return props.confirmFn('Confirmation', {
        description: message
      }).then(saveReport.bind(null, props), function () {
        return reportBody.markVisibleAllField().then(saveReport.bind(null, props));
      });
    }

    return saveReport(props);
  } else {
    reportStore.alertDetails.set({
      success: true,
      message: _Izenda13.default.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
    });
    return (0, _bluebird.resolve)(false);
  }
};

/**
 * Check Dirty
 * @param {Object} props
 * @param {Object} e
 * @returns {boolean}
 */
var checkDirty = function checkDirty(props, _) {
  var reportSubscriptionStore = props.reportSubscriptionStore,
      _props$fieldStore2 = props.fieldStore,
      reportStore = _props$fieldStore2.reportStore,
      accessPriority = _props$fieldStore2.reportStore.model.accessPriority,
      authorization = props.authorization,
      authorizationConstants = props.authorizationConstants,
      boardDetail = props.boardDetail;

  var savePermission = authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.ReportsActionsOverwriteExistingReport]) && accessPriority === _Izenda19.ACCESS_RIGHT.FullAccess && !boardDetail.isGlobal || boardDetail.isGlobal && _Izenda18.default.currentUser.systemAdmin && !_Izenda18.default.tenantId;
  if (savePermission) {
    return reportStore.model.checkDirty() || reportSubscriptionStore.model.checkDirty();
  } else {
    return false;
  }
};

/**
 * Handle click on Show/Hide header & footer button
 * @param {Object} props
 * @param {Object} e
 */
var onDisplayShowHideHeaderFooter = function onDisplayShowHideHeaderFooter(props, e) {
  var designerStore = props.designerStore;

  designerStore && (designerStore.isShowingHeaderFooter = !designerStore.isShowingHeaderFooter);
};

/**
 * Resolve label of Show/Hide header & footer button
 * @param {Object} designerStore
 * @param {Object} localization
 * @returns {string} The label of Show/Hide Header and Footer button
 */
var getShowHideHeaderFooterLabel = function getShowHideHeaderFooterLabel(_ref, localization) {
  var isShowingHeaderFooter = _ref.isShowingHeaderFooter;

  var key = isShowingHeaderFooter ? 'COMMON_LABEL_HIDE_REPORT_HEADER_FOOTER' : 'COMMON_LABEL_SHOW_REPORT_HEADER_FOOTER';
  return localization.getText(key);
};

/**
 * Check to display Show/Hide header & footer button
 * @param {Object} fieldStore
 * @returns {boolean} Indicate to display the Show/Hide Header and Footer button
 */
var checkDisplayShowHideHeaderFooter = function checkDisplayShowHideHeaderFooter(fieldStore) {
  return (0, _fp.get)('masterModel.reportFormats.headerFooter.visible', fieldStore);
};

var ReportViewerToolbarActions = (0, _recompose.compose)((0, _recompose.withHandlers)({
  openEmailPopup: (0, _fp.curry)(openEmailPopup),
  onSave: (0, _fp.curry)(onSave),
  checkDirty: (0, _fp.curry)(checkDirty),
  updateResults: (0, _fp.curry)(updateResults),
  onDisplayShowHideHeaderFooter: (0, _fp.curry)(onDisplayShowHideHeaderFooter)
}), (0, _recompose.withProps)({
  getShowHideHeaderFooterLabel: getShowHideHeaderFooterLabel,
  checkDisplayShowHideHeaderFooter: checkDisplayShowHideHeaderFooter
}), _Izenda14.accessContext, (0, _recompose.mapProps)(function (props) {
  return (0, _fp.omit)(['unregisterExposeMethod', 'registerExposeMethod'], props);
}), integrationStyleAction);

exports.default = ReportViewerToolbarActions;
module.exports = exports['default'];

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailActions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var PropTypes = __webpack_require__(0).PropTypes;
  var compose = __webpack_require__(9).compose;
  var mapProps = __webpack_require__(9).mapProps;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withState = __webpack_require__(9).withState;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var constants = __webpack_require__(119);
  var fetcher = __webpack_require__(75);
  var reportsDataFetcher = __webpack_require__(111);
  var dashboardDataFetcher = __webpack_require__(192);
  var uiState = __webpack_require__(15);
  var DEFAULT_SUBJECT = constants.EMAIL_SUBJECT.DEFAULT;
  var MESSAGE = constants.MESSAGE;

  var _require = __webpack_require__(1),
      assign = _require.assign,
      curry = _require.curry,
      isBoolean = _require.isBoolean,
      isEmpty = _require.isEmpty,
      split = _require.split,
      pluck = _require.pluck,
      uniq = _require.uniq,
      chain = _require.chain,
      forEach = _require.forEach;

  var Email = __webpack_require__(2579);
  var localizer = __webpack_require__(12);

  var emailActions = compose(mapProps(function (props) {
    var email = new Email();
    email.setDataByKey('type', props.type);
    email.setDataByKey('subject', DEFAULT_SUBJECT[props.type]);
    return assign(props, { email: email });
  }), withState('loadingPromise', 'setLoadingPromise', null), withHandlers({
    onClosing: curry(onClosing),
    setToAddress: curry(setToAddress),
    setCcAddress: curry(setCcAddress),
    setSubject: curry(setSubject),
    setDeliveryMethod: curry(setDeliveryMethod),
    setAttachment: curry(setAttachment),
    setEmailBody: curry(setEmailBody),
    addNewEmail: curry(addNewEmail),
    addToEmailFromPopup: curry(addToEmailFromPopup),
    addCcEmailFromPopup: curry(addCcEmailFromPopup),
    getEmailTemplates: curry(getEmailTemplates)
  }), setPropTypes({
    onClosed: PropTypes.func,
    deliveryMethod: PropTypes.string
  }));

  /**
   * Closing Popup
   */
  function onClosing(props, cb, type) {
    var valManager = props.validation;
    if (type === 'accept') {
      fetcher.isHavemailConfiguration(uiState.tenantId).then(function (result) {
        if (result.success) {
          return valManager.validate().then(function (success) {
            if (success && validateEmailFormat(props)) {
              valManager.reset();
              var onclosedPromise = props.onClosed(props.email.buildForSend());
              onclosedPromise.then(function (onClosedResult) {
                var msg;
                if (isBoolean(onClosedResult)) {
                  msg = onClosedResult ? MESSAGE.M12a : MESSAGE.M12b;
                } else {
                  msg = onClosedResult;
                  props.setLoadingPromise(null);
                  props.confirmMessage('error', msg);
                  return;
                }
                props.confirmFn('Confirmation', {
                  description: msg
                }).catch(function () {
                  props.onAccept();
                }).finally(function () {
                  props.setLoadingPromise(null);
                });
              });
              props.setLoadingPromise(onclosedPromise);
            }
            return success;
          });
        } else {
          props.confirmMessage('error', result.message);
        }
      });
    } else {
      valManager.reset();
      props.onReject();
      props.onClosed();
    }
  }

  /**
   * Validate email format for to, cc email
   */
  function validateEmailFormat(props) {
    var validation = props.validation;
    var email = props.email;
    var messages = [];

    // Check to emails
    var invalidToEmails = checkEmail(email, 'to');

    // Check cc emails
    var invalidCcEmails = checkEmail(email, 'cc');

    // Add error messages
    !isEmpty(invalidToEmails) && messages.push(invalidToEmails);
    !isEmpty(invalidCcEmails) && messages.push(invalidCcEmails);

    // Update errors to validation manager
    !isEmpty(messages) && validation.updateErrors(messages);

    return isEmpty(messages);
  }

  /**
   * Check list email if invalid
   * Return error message of invalid email
   */
  function checkEmail(email, type) {
    var emails = split(';', email[type]);
    var invalidEmails = [];
    forEach(function (email) {
      if (email && !constants.EMAIL_VALIDATION.REGEX.test(email)) {
        invalidEmails.push(email);
      }
    }, emails);

    return !isEmpty(invalidEmails) ? {
      key: type,
      messages: [constants.EMAIL_VALIDATION.MESSAGE(invalidEmails)]
    } : null;
  }

  /**
   * Set to'semail Address
   * @param props
   * @param value
   */
  function setToAddress(props, value) {
    props.email.setDataByKey('to', composeEmailValue(value));
  }

  /**
   * Set Cc's email address
   * @param props
   * @param value
   */
  function setCcAddress(props, value) {
    props.email.setDataByKey('cc', composeEmailValue(value));
  }

  /**
   * Handle add new email
   * @param props
   * @param newData
   */
  function addNewEmail(props, newData) {
    return;
  }

  /**
   * Set email subject
   * @param props
   * @param value
   */
  function setSubject(props, value) {
    props.email.setDataByKey('subject', value.target.value);
  }

  /**
   * Set email delivery method
   * @param props
   * @param value
   */
  function setDeliveryMethod(props, emailBody, value) {
    props.email.setDeliveryMethod(emailBody, value);
  }

  /**
   * Set attachment type
   * @param props
   * @param value
   */
  function setAttachment(props, value) {
    props.email.setDataByKey('attachmentType', value.value);
  }

  /**
   * Set email body
   * @param props
   * @param value
   */
  function setEmailBody(props, value) {
    props.email.setDataByKey('body', value.target.value);
  }

  /**
   * Add rececipients email to from popup.
   * @param {Object} userAccountList
   */
  function addToEmailFromPopup(props, userAccountList) {
    addEmails(props.email, 'to', userAccountList);
  }

  /**
   * Add rececipients email cc from popup.
   * @param {Object} userAccountList
   */
  function addCcEmailFromPopup(props, userAccountList) {
    addEmails(props.email, 'cc', userAccountList);
  }

  /**
   * Add list email when select in popup
   * @param {Obejct} email
   * @param {string} label : to, cc
   * @param {Array} userAccountList
   */
  function addEmails(email, label, userAccountList) {
    var addEmails = pluck('emailAddress', userAccountList);
    var currentEmails = split(';', email[label]);
    var newEmails = chain(currentEmails).concat(addEmails).compact().value();

    if (addEmails.length > 0) {
      email[label] = uniq(newEmails).join(';');
    }
  }

  /**
   * Compose to email value
   * @param {Array} emails
   */
  function composeEmailValue(emailValue) {
    var emails = chain(emailValue).split(';').compact().value();

    return uniq(emails).join(';');
  }

  /**
   * Get email templates
   */
  function getEmailTemplates(props, type) {
    var fetcher = type === constants.EMAIL_TYPE.dashboard ? dashboardDataFetcher : reportsDataFetcher;
    return fetcher.fetchEmailTemplates(constants.TEMPLATE_TYPE);
  }

  module.exports = emailActions;
}();

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Email.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(119);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Email = (_class = function () {
  function Email() {
    (0, _classCallCheck3.default)(this, Email);

    _initDefineProp(this, 'to', _descriptor, this);

    _initDefineProp(this, 'cc', _descriptor2, this);

    _initDefineProp(this, 'subject', _descriptor3, this);

    _initDefineProp(this, 'deliveryMethod', _descriptor4, this);

    _initDefineProp(this, 'attachmentType', _descriptor5, this);

    _initDefineProp(this, 'body', _descriptor6, this);

    _initDefineProp(this, 'type', _descriptor7, this);
  }

  (0, _createClass3.default)(Email, [{
    key: 'setDataByKey',


    /**
     * Set email properties by key
     * @param {string} key
     * @param {string} value
     */
    value: function setDataByKey(key, value) {
      this[key] = value;
    }

    /**
     * Replace email body's new line by br tag in html
     * @returns {object}
     */

  }, {
    key: 'buildForSend',
    value: function buildForSend() {
      var email = (0, _mobx.toJS)(this);
      email.body = email.body.replace(/\n/g, '<br>');
      return email;
    }

    /**
     * Set email body
     * @param {string} emailBody 
     */

  }, {
    key: 'setEmailBody',
    value: function setEmailBody(emailBody) {
      var normalizeEmailBody = emailBody && emailBody.split(/<br\/?>/).map(_fp.trim).join('\n');
      this.setDataByKey('body', normalizeEmailBody);
    }

    /**
     * Set delivery method
     * @param {string} emailBody
     * @param {string} value
     */

  }, {
    key: 'setDeliveryMethod',
    value: function setDeliveryMethod(emailBody, value) {
      this.setDataByKey('deliveryMethod', value);
      this.setEmailBody(emailBody);
    }
  }]);
  return Email;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'to', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'cc', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'subject', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'deliveryMethod', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda.DELIVERY_METHOD.link;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'attachmentType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda.ATTACH_TYPE_OPTIONS[2].value;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'body', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return _Izenda.EMAIL_TYPE.report;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'setDeliveryMethod', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setDeliveryMethod'), _class.prototype)), _class);
exports.default = Email;
module.exports = exports['default'];

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(152);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchProcessBar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda2.default)()(function EmailProgressBar(props) {
  var localization = props.localization;

  var promiseFunction = props.promiseFunction;

  var onCancelHandler = function onCancelHandler() {
    props.setLoadingPromise(null);
    promiseFunction.cancel();
  };

  return promiseFunction && promiseFunction.isPending() && _react2.default.createElement(
    _Izenda4.default,
    null,
    _react2.default.createElement(
      _Izenda4.default.Row,
      null,
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 2 },
        _react2.default.createElement(
          'strong',
          { className: 'u_inlineBlock u_paddingAll' },
          localization.getText('EMAIL_LABEL_SENDING')
        )
      ),
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 8, className: 'u_controlHeight u_paddingAll' },
        _react2.default.createElement(_Izenda6.default, { show: true, withoutBorder: true })
      ),
      _react2.default.createElement(
        _Izenda4.default.Col,
        { cols: 2, onClick: onCancelHandler },
        _react2.default.createElement(
          'a',
          { className: 'u_paddingAll u_inlineBlock u_textLink' },
          localization.getText('COMMON_LABEL_CANCEL')
        )
      )
    )
  );
});
module.exports = exports['default'];

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(119);

var _Izenda10 = __webpack_require__(2582);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var ValidatorSelect = (0, _Izenda6.default)()(_Izenda8.default);

exports.default = (0, _Izenda2.default)(_Izenda11.default)(function EmailInput(props) {
  var localization = props.localization,
      value = props.value,
      label = props.label,
      isRequired = props.isRequired;


  var options = value ? (0, _fp.split)(';', value).map(function (item) {
    return { label: item, value: item };
  }) : [];

  return _react2.default.createElement(
    _Izenda4.default.Row,
    null,
    _react2.default.createElement(
      _Izenda4.default.Col,
      { cols: 2, className: 'Izenda-EmailPopup-Input' },
      _react2.default.createElement(
        'span',
        null,
        props.label
      )
    ),
    _react2.default.createElement(
      _Izenda4.default.Col,
      { cols: 10 },
      _react2.default.createElement(
        'div',
        { className: 'izenda-Email-Container' },
        _react2.default.createElement(ValidatorSelect, {
          value: value,
          containerClassName: 'u_fullWidth',
          multi: true,
          delimiter: ';',
          simpleValue: true,
          joinValues: true,
          options: options,
          onAddNew: props.addNewEmail,
          onBlur: props.addNewEmail,
          onChange: props.onChange,
          onBlurResetsInput: false,
          noResultsText: localization.getText('USER_MESSAGE_ENTER_TO_ADD_EMAIL'),
          isInsertOnBlur: true,
          textboxMode: true,
          validations: isRequired && _Izenda9.REQUIRE_CONSTRAINTS,
          field: label,
          clearable: false
        }),
        _react2.default.createElement(
          'div',
          { className: 'u-posAbsolute u-iconAfterInput' },
          _react2.default.createElement('span', {
            onClick: props.openPopupAddUserPopup,
            className: 'icon-plus',
            title: localization.getText('USER_LABEL_SELECT_USER')
          })
        )
      )
    )
  );
});
module.exports = exports['default'];

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailInputActions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var AddUserPopup = __webpack_require__(590);
  var ACCESS_CONSTANT = __webpack_require__(92);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      toLower = _require.toLower;

  var emailInputActions = compose(withHandlers({
    openPopupAddUserPopup: curry(openPopupAddUserPopup)
  }));

  /**
   * Open add user popup
   * @param {Object} props
   */
  function openPopupAddUserPopup(props, e) {
    props.openPopup(AddUserPopup, {
      onChange: props.addRecipientsFromPopup,
      selectedItems: props.email[toLower(props.label)],
      userModeType: ACCESS_CONSTANT.USER_ACCESS_MODE.SCHEDULE,
      validateEmails: true
    });
  }

  module.exports = emailInputActions;
}();

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(52);

var _Izenda = __webpack_require__(31);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda5 = __webpack_require__(200);

var _Izenda6 = __webpack_require__(340);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewReportButton = function ViewReportButton(props) {
  var localization = props.localization,
      reportId = props.reportId,
      disabled = props.disabled,
      store = props.store,
      location = props.location;

  var query = {};
  query['' + _Izenda5.SOURCE_PATH_QUERY_KEY] = store.reportListLink || _Izenda7.default.getValueByKey((0, _fp.get)('location.query', props), _Izenda5.SOURCE_PATH_QUERY_KEY);

  var viewUrl = {
    pathname: _Izenda2.default.getReportUrl('View', { id: reportId }),
    state: {
      fromQuickEdit: true
    },
    query: query
  };

  var buttonClasses = (0, _classnames2.default)('btn', 'btn-primary', { disabled: disabled });
  return _react2.default.createElement(
    _reactRouter.Link,
    { className: buttonClasses, to: viewUrl, disabled: disabled },
    localization.getText('REPORT_LABEL_VIEW_MODE')
  );
};
// ----------------------------------------------------------------------
// <copyright file='Izenda.ViewReportButton.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

ViewReportButton.propTypes = {
  reportId: _propTypes2.default.string.isRequired,
  disabled: _propTypes2.default.bool.isRequired
};

exports.default = (0, _Izenda4.default)()(ViewReportButton);
module.exports = exports['default'];

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.SubscribeReportButton.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Link = __webpack_require__(52).Link;
  var Button = __webpack_require__(30);
  var SubscriptionPopup = __webpack_require__(2585);
  var ReportSubscriptionConstants = __webpack_require__(133);
  var PopupInput = __webpack_require__(309);
  var SubscriptionGrid = __webpack_require__(341);
  var REPORT_DESIGNER_CONSTANST = __webpack_require__(16);
  var connect = __webpack_require__(2);

  var observer = __webpack_require__(10).observer;
  var routeUtils = __webpack_require__(31);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      find = _require.find;

  var SubscribeReportButton = React.createClass({
    displayName: 'SubscribeReportButton',

    propTypes: {
      reportId: React.PropTypes.string.isRequired,
      reportType: React.PropTypes.string.isRequired,
      store: React.PropTypes.object.isRequired
    },

    render: function render() {
      var props = this.props;
      var localization = props.localization;
      var store = props.store;
      var reportId = props.reportId;
      var reportType = props.reportType;

      var popupTitle = this.getPopupTitle(reportType);

      return React.createElement(
        'div',
        { className: 'report-subscription btn-group floatNone u_marginLeft' },
        React.createElement(PopupInput, {
          className: 'btn btn-primary',
          label: localization.getText('COMMON_LABEL_SUBSCRIBE'),
          onChange: this.onChange,
          popupProps: {
            type: 'none',
            autoClose: false,
            sizeClass: 'modal-lg',
            showSubscriptionPopup: this.props.showSubscriptionPopup,
            emailTemplates: store.model.emailTemplates
          },
          popupContentProps: {
            confirmButtonLabel: localization.getText('COMMON_LABEL_SAVE'),
            beforeClosing: 'beforeClosing',
            showSubscriptionPopup: this.props.showSubscriptionPopup,
            emailTemplates: store.model.emailTemplates
          },
          popupTitle: popupTitle,
          popupContent: SubscriptionGrid,
          store: store,
          onClick: this.onClick,
          pageConstants: ReportSubscriptionConstants,
          onSavePopupDesigner: this.onSaveSubscription,
          isPopupMode: true,
          disabled: props.disabled
        })
      );
    },

    /**
     * Save subscription data.
     */
    onSaveSubscription: function onSaveSubscription(subData) {
      this.props.store.model.updateSubscribedInstances(subData);
    },

    /**
     * Handle action when get value
     * @return {object}
     */
    onChange: function onChange(value) {
      var store = this.props.store;
      store && store.saveInstances();
    },

    /**
     * Load data when open popup
     * @return {object}  Promise
     */
    onClick: function onClick() {
      var store = this.props.store;
      store && store.updateReportId(this.props.reportId);
      return store && store.loadInstances();
    },

    getPopupTitle: function getPopupTitle(reportType) {
      var reportTypes = REPORT_DESIGNER_CONSTANST.TYPES;
      var localization = this.props.localization;
      var reportTypeDefine = find(function (item) {
        return item.id === parseInt(reportType, 10);
      }.bind(this), reportTypes) || {};

      var reportTypeName = reportTypeDefine.value || '';
      return String.format(localization.getText('REPORT_LABEL_NUMBER_OF_SUBSCRIPTION'), reportTypeName);
    }
  });

  module.exports = connect()(SubscribeReportButton);
}();

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(94);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SubscriptionPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * SubscriptionPopup Component
 */
!function () {
  __webpack_require__(55);

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var PopupInput = __webpack_require__(309);
  var SubscriptionGrid = __webpack_require__(341);
  var classnames = __webpack_require__(11);
  var REPORT_DESIGNER_CONSTANST = __webpack_require__(16);

  var _require = __webpack_require__(1),
      find = _require.find,
      isNil = _require.isNil;

  var SubscriptionPopup = React.createClass({
    displayName: 'SubscriptionPopup',

    /**
     * Handle action when get value
     * @return {object}
     */
    onChange: function onChange(value) {
      var store = this.props.store;
      store && store.saveInstances();
    },

    /**
     * Load data when open popup
     * @return {object}  Promise
     */
    onClick: function onClick() {
      var store = this.props.store;
      store.updateReportId(this.props.reportId);
      return store.loadInstances();
    },

    /**
     * Render component
     * @return {[type]} [description]
     */
    render: function render() {
      var localization = this.props.localization;

      var reportTypes = REPORT_DESIGNER_CONSTANST.TYPES;
      var reportTypeDefine = find(function (item) {
        return item.id === parseInt(this.props.reportType, 10);
      }.bind(this), reportTypes) || {};

      var reportType = reportTypeDefine.value;
      var popupTitle = String.format('{0} {1}', reportType, localization.getText('SUBSCRIPTION_LABEL_SUBSCRIPTION'));

      var store = this.props.store || {};
      var containerClassName = classnames('report-subscription', (0, _defineProperty3.default)({}, '' + this.props.className, !isNil(this.props.className)));

      return React.createElement(PopupInput, {
        containerClassName: containerClassName,
        className: 'btn btn-primary',
        label: localization.getText('COMMON_LABEL_SUBSCRIBE'),
        onChange: this.onChange,
        popupProps: {
          type: 'none',
          autoClose: false,
          sizeClass: 'modal-lg',
          showSubscriptionPopup: this.props.showSubscriptionPopup,
          emailTemplates: store.model.emailTemplates
        },
        popupContentProps: {
          confirmButtonLabel: localization.getText('COMMON_LABEL_SAVE'),
          beforeClosing: 'beforeClosing',
          showSubscriptionPopup: this.props.showSubscriptionPopup,
          emailTemplates: store.model.emailTemplates
        },
        popupTitle: popupTitle,
        popupContent: SubscriptionGrid,
        store: store,
        onClick: this.onClick,
        pageConstants: this.props.pageConstants,
        onSavePopupDesigner: this.props.onSavePopupDesigner,
        isPopupMode: true
      });
    }
  });

  module.exports = connect()(SubscriptionPopup);
}();

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(30);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1181);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1182);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(31);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(12);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(42);

var _Izenda14 = __webpack_require__(50);

var _Izenda15 = __webpack_require__(45);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(15);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(200);

var _fp = __webpack_require__(1);

var _Izenda20 = __webpack_require__(340);

var _Izenda21 = _interopRequireDefault(_Izenda20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullAccess = _Izenda13.ACCESS_RIGHT.FullAccess,
    QuickEdit = _Izenda13.ACCESS_RIGHT.QuickEdit,
    SaveAs = _Izenda13.ACCESS_RIGHT.SaveAs;
// ----------------------------------------------------------------------
// <copyright file='Izenda.EditReportButton.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var buildSourcePath = function buildSourcePath(props) {
  return props.store.reportListLink || _Izenda21.default.getValueByKey((0, _fp.get)('location.query', props), _Izenda19.SOURCE_PATH_QUERY_KEY);
};

var EditReportButton = function EditReportButton(props) {
  var quickEdit = function quickEdit() {
    var goToQuickEdit = function goToQuickEdit() {
      var reportId = props.reportId;

      var editUrl = _Izenda10.default.getReportUrl('Edit', { id: reportId });
      var query = {};
      query['' + _Izenda19.SOURCE_PATH_QUERY_KEY] = buildSourcePath(props);
      props.router.push({ pathname: editUrl, query: query });
    };
    var masterModel = props.fieldStore.masterModel;

    var isDirty = masterModel.checkDirty();
    if (isDirty) {
      props.confirmFn('Confirmation', {
        description: localization.getText('REPORT_DESIGNER_MESSAGE_CONFIRM_QUICK_EDIT')
      }).then(function () {
        goToQuickEdit();
      });
    } else {
      goToQuickEdit();
    }
  };

  var designReport = function designReport() {
    var authorization = props.authorization,
        masterModel = props.fieldStore.masterModel,
        reportId = props.reportId,
        accessPriority = props.accessPriority;

    var isDirty = masterModel.checkDirty();
    var designUrl = _Izenda10.default.getReportDesignerUrl('ReportDesignerDetail', { reportId: reportId });
    var canOverwriteExistingReport = authorization.checkPrivileges([_Izenda13.PERMISSION_KEY.ReportsActionsOverwriteExistingReport]);
    var saveReportPromise = isDirty && canOverwriteExistingReport && accessPriority === FullAccess ? props.onSave : _bluebird.resolve;
    var query = {};
    query['' + _Izenda19.SOURCE_PATH_QUERY_KEY] = buildSourcePath(props);

    return saveReportPromise(true).then(function (success) {
      success && props.router.push({
        pathname: designUrl,
        query: query
      });
    });
  };

  var showCopyPopup = function showCopyPopup(version) {
    openCopyReportPopup(version || 0, false);
  };

  var showMovePopup = function showMovePopup(version) {
    openCopyReportPopup(version || 0, true);
  };

  var openCopyReportPopup = function openCopyReportPopup(version, isMove) {
    props.openPopup(_Izenda6.default, {
      store: props.store,
      boardDetail: props.boardDetail,
      isMoveReport: isMove,
      version: version
    }).then(function (message, newReportId, newCateInfo) {
      closeCopyPopup(message, newReportId, newCateInfo);
    });
  };

  var closeCopyPopup = function closeCopyPopup(message, newReportId, newCateInfo) {
    var router = props.router,
        fieldStore = props.fieldStore,
        viewMode = props.viewMode;


    newReportId && newCateInfo && fieldStore.reportStore.updateReportCategory(newCateInfo.category, newCateInfo.subCategory);
    if (message) {
      return props.confirmFn('Information', {
        description: message,
        type: 'info',
        showCloseIndicator: true
      }).then(function () {
        if ((0, _fp.isString)(newReportId)) {
          !viewMode && router.push(buildViewerLink(newReportId));
        } else {
          router.push(props.location.pathname);
        }
      });
    }
  };

  var buildViewerLink = function buildViewerLink(newReportId) {
    return _Izenda10.default.getReportUrl('Edit', { id: newReportId });
  };

  var showHistory = function showHistory() {
    var isGlobal = (0, _fp.getOr)(false, 'boardDetail.isGlobal', props);
    props.openPopup(_Izenda4.default, {
      showCopy: showCopyPopup,
      showMove: showMovePopup,
      reportId: props.reportId,
      masterStore: props.store,
      isGlobal: isGlobal,
      deleteHistory: deleteHistory
    });
  };

  var deleteHistory = function deleteHistory() {
    var router = props.router,
        reportType = props.reportType,
        reportId = props.reportId;


    if ((0, _fp.get)('state.fromList', props.location)) {
      router.goBack();
    } else {
      var reportInfo = (0, _fp.getOr)({}, 'masterModel', props.fieldStore);
      var categoryId = _Izenda14.EMPTY_GUID;

      var assignCategoryId = function assignCategoryId(catId) {
        String.isGuidFormat(catId) && catId !== _Izenda14.EMPTY_GUID && (categoryId = catId);
      };

      assignCategoryId(reportInfo.categoryId);
      assignCategoryId(reportInfo.subCategoryId);

      var reportUrl = _Izenda10.default.getReportUrl('List', {
        reportType: reportType,
        catId: categoryId,
        reportId: reportId
      });
      router.push(reportUrl);
    }
  };

  var localization = props.localization,
      authorization = props.authorization,
      accessPriority = props.accessPriority,
      active = props.active,
      boardDetail = props.boardDetail,
      viewMode = props.viewMode,
      disabled = props.disabled;


  var canOverwriteExistingReport = authorization.checkPrivileges([_Izenda13.PERMISSION_KEY.ReportsActionsOverwriteExistingReport]);

  var canCreateReport = authorization.checkPrivileges([_Izenda13.PERMISSION_KEY.ReportsCanCreateNewReportValue]);

  var doesShowViewReportHistoryBtn = authorization.checkPrivileges([_Izenda13.PERMISSION_KEY.ReportsActionsViewReportHistory]);

  var doesShowQuickEditBtn = (accessPriority === FullAccess || accessPriority === QuickEdit || accessPriority === SaveAs) && viewMode && active;
  var doesShowDesignBtn = (accessPriority === FullAccess || accessPriority === SaveAs) && active && canOverwriteExistingReport;
  var doesShowCopyBtn = (accessPriority === FullAccess || accessPriority === QuickEdit || accessPriority === SaveAs) && canCreateReport;
  var doesShowMoveBtn = accessPriority === FullAccess && canOverwriteExistingReport && active && !boardDetail.isGlobal || boardDetail.isGlobal && _Izenda18.default.currentUser.systemAdmin && !_Izenda18.default.tenantId;
  var hasReportDesignerLicense = authorization.checkLicense(_Izenda16.default.LICENSE_KEY.ReportDesigner);

  return (doesShowQuickEditBtn || doesShowDesignBtn || doesShowCopyBtn || doesShowMoveBtn || doesShowViewReportHistoryBtn) && _react2.default.createElement(
    'div',
    { className: 'btn-group' },
    _react2.default.createElement(
      _Izenda2.default,
      {
        className: 'dropdown-toggle',
        'data-toggle': 'dropdown',
        label: localization.getText('COMMON_LABEL_EDIT'),
        disabled: disabled
      },
      _react2.default.createElement('span', { className: 'caret' })
    ),
    _react2.default.createElement(
      'ul',
      { className: 'dropdown-menu' },
      doesShowQuickEditBtn && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { onClick: quickEdit },
          localization.getText('REPORT_LABEL_QUICK_EDIT')
        )
      ),
      hasReportDesignerLicense && doesShowDesignBtn && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { onClick: designReport },
          localization.getText('REPORT_LABEL_DESIGN')
        )
      ),
      doesShowCopyBtn && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { onClick: showCopyPopup },
          _Izenda12.default.getText('COMMON_LABEL_COPY')
        )
      ),
      doesShowMoveBtn && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { onClick: showMovePopup },
          _Izenda12.default.getText('COMMON_LABEL_MOVE')
        )
      ),
      doesShowViewReportHistoryBtn && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { onClick: showHistory },
          localization.getText('REPORT_LABEL_VIEW_HISTORY')
        )
      )
    )
  );
};

EditReportButton.propTypes = {
  reportId: _propTypes2.default.string.isRequired,
  viewMode: _propTypes2.default.bool.isRequired,
  store: _propTypes2.default.object.isRequired,
  confirmFn: _propTypes2.default.func.isRequired,
  boardDetail: _propTypes2.default.object
};

EditReportButton.contextTypes = {
  router: _propTypes2.default.object
};

exports.default = (0, _Izenda8.default)()(EditReportButton);
module.exports = exports['default'];

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  CRITERIA_LIST: [{
    value: 'All',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_ALL');
    }
  }, {
    value: 'Version',
    get label() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_VERSION');
    }
  }, {
    value: 'Status',
    get label() {
      return _Izenda2.default.getText('COMMON_LABEL_STATUS');
    }
  }, {
    value: 'Modified',
    get label() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_EDITED_DATE');
    }
  }, {
    value: 'ModifiedBy',
    get label() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_EDITED_BY');
    }
  }],
  TABLE_DEF: {
    version: {
      key: 'version',
      columnKey: 'version',
      width: 100,
      get title() {
        return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_VERSION');
      },
      sortable: true
    },
    status: {
      key: 'status',
      columnKey: 'status',
      width: 100,
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_STATUS');
      },
      sortable: true
    },
    editedDate: {
      key: 'modified',
      columnKey: 'modified',
      width: 200,
      get title() {
        return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_EDITED_DATE');
      },
      sortable: true
    },
    editedBy: {
      key: 'modifiedBy',
      columnKey: 'modifiedBy',
      width: 215,
      get title() {
        return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_EDITED_BY');
      },
      sortable: true
    },
    action: {
      width: 150,
      resizable: false,
      fixed: true,
      align: 'center',
      get title() {
        return _Izenda2.default.getText('COMMON_LABEL_ACTION');
      }
    }
  },
  TABLE_WIDTH: 590,
  TOOL_TIP: {
    get DESIGN() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_DESIGN');
    },
    get COPY() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_COPY');
    },
    get MOVE() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_MOVE');
    },
    get DELETE() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_DELETE');
    }
  },
  STATUS: {
    get ACTIVE() {
      return _Izenda2.default.getText('COMMON_LABEL_ACTIVE');
    },
    get ARCHIVED() {
      return _Izenda2.default.getText('COMMON_LABEL_ARCHIVED');
    }
  },
  MESSAGES: {
    get M01a() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_MESSAGE_DELETE_ARCHIVED');
    },
    get M01b() {
      return _Izenda2.default.getText('REPORT_HISTORY_CONSTANTS_MESSAGE_DELETE_ACTIVE');
    }
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportHistoryConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportHistoryStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Report History Store
 */
!function () {
  var m = __webpack_require__(5);
  var fetcher = __webpack_require__(111);
  var ReportHistoryModel = __webpack_require__(2589);

  var _require = __webpack_require__(1),
      remove = _require.remove;

  function ReportHistoryStore() {
    this.model = new ReportHistoryModel();
    this.reportId = null;
  }

  /**
   * Read initial data
   */
  ReportHistoryStore.prototype.init = function (reportId) {
    this.reportId = reportId;

    return this.loadReportHistory();
  };

  /**
   * Load report history
   */
  ReportHistoryStore.prototype.loadReportHistory = function () {
    var model = this.model;
    model.pageInfo.buildPagingRequest();

    return fetcher.loadReportHistory(null, model.pageInfo, this.reportId).then(model.readHistory.bind(model));
  };

  /**
   * Go to page
   * @param {type} pageIndex
   * @returns {type}
   */
  ReportHistoryStore.prototype.goToPage = function (pageIndex) {
    var pageInfo = this.model.pageInfo;

    pageInfo.setPageIndex(pageIndex);

    return this.loadReportHistory();
  };

  /**
   * Search Report History
   * @param {type} searchProperty
   * @param {type} searchText
   * @returns {type}
   */
  ReportHistoryStore.prototype.search = function (searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);

    return this.goToPage(1);
  };

  /**
   * Change sort orders
   * @param {type} columnKey
   * @param {type} sortDir
   */
  ReportHistoryStore.prototype.onSortChange = function (columnKey, sortDir) {
    this.model.pageInfo.setColSortDirs(columnKey, sortDir);

    return this.loadReportHistory();
  };

  /**
   * Change page size
   * @param {type} pageSize
   * @returns {type}
   */
  ReportHistoryStore.prototype.onPageSizeChange = function (pageSize) {
    this.model.pageInfo.setPageSize(pageSize);

    return this.goToPage(1);
  };

  /**
   * On change Seach properties
   * @param {type} searchProperty
   * @param {type} searchText
   * @returns {type}
   */
  ReportHistoryStore.prototype.onSearchPropertiesChange = function (searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);
  };

  /**
   * Delete Report
   * @param {String} reportId
   * @param {String} version
   * @returns {Promise}
   */
  ReportHistoryStore.prototype.deleteReportHistory = m.action(function (reportId, version) {
    return fetcher.deleteReportHistory(reportId, version).then(function (result) {
      var histories = this.model.histories;
      this.model.histories = remove(function (item) {
        return item.version === version;
      }, histories);
      return result;
    }.bind(this)).then(this.loadReportHistory.bind(this));
  });

  module.exports = ReportHistoryStore;
}();

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportHistory.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var PagingModel = __webpack_require__(98);

  function ReportHistory() {
    var colSortDir = {
      version: 'DESC'
    };

    var defaultSearchProperty = 'All';

    var props = {
      histories: [],
      pageInfo: new PagingModel(colSortDir, defaultSearchProperty)
    };

    m.extendObservable(this, props);
  }

  /**
   * Read histories list
   * @param {Object} data
   */
  ReportHistory.prototype.readHistory = m.action(function (data) {
    data = data || {};
    var result = data.result || [];

    this.histories = result;

    // update page info
    this.pageInfo.totalRecords = data.total;

    return null;
  });

  module.exports = ReportHistory;
}();

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(50);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(161);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CopyReportAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var CopyReportAction = (0, _recompose.compose)((0, _recompose.setDisplayName)('CopyReport'), (0, _recompose.withState)('reportName', 'handleChangeReportName', function (props) {
  return props.boardDetail.name;
}), (0, _recompose.withState)('category', 'changeCategory', function () {
  return null;
}), (0, _recompose.withState)('saveIntos', 'updateSaveIntos', function () {
  return [];
}), (0, _recompose.withState)('subCategory', 'changeSubCategory', function () {
  return null;
}), (0, _recompose.withState)('subCategories', 'updateSubCategories', function () {
  return [];
}), (0, _recompose.withState)('categories', 'updateCategories', function () {
  return [];
}), (0, _recompose.withState)('saveInto', 'updateSaveInto', function (props) {
  return (
    // convert isGlobal to 0 and 1 for dropdown list, if tenant user default value is 0
    (0, _fp.isNil)(_Izenda6.default.tenantId) ? +props.boardDetail.isGlobal : 0
  );
}), (0, _recompose.mapProps)(function (props) {
  var localization = props.localization;
  var typeName = props.boardDetail.type == _Izenda2.default.CATEGORY_TYPE.REPORT ? localization.getText('COMMON_LABEL_REPORT') : localization.getText('COMMON_LABEL_TEMPLATE');
  var hiddenSaveintos = _Izenda6.default.currentUser.systemAdmin && (0, _fp.isNil)(_Izenda6.default.tenantId);

  return (0, _fp.assign)(props, { typeName: typeName, hiddenSaveintos: hiddenSaveintos });
}), (0, _recompose.withHandlers)({
  handleValidate: (0, _fp.curry)(handleValidate),
  updateCategory: (0, _fp.curry)(updateCategory),
  hasNewCategory: (0, _fp.curry)(hasNewCategory),
  addNewCategory: (0, _fp.curry)(addNewCategory),
  updateSubCategory: (0, _fp.curry)(updateSubCategory),
  addNewSubCategory: (0, _fp.curry)(addNewSubCategory),
  onClosing: (0, _fp.curry)(onClosing),
  onChangeSaveInto: (0, _fp.curry)(onChangeSaveInto)
}));

/**
 * Detect that user enter a new category or new subcategory
 * @param {Object} props components property
 */
function hasNewCategory(props) {
  var categories = props.categories,
      subCategories = props.subCategories;

  var hasNewCat = (0, _fp.find)(['isNew', true], categories);
  var hasNewSubCat = (0, _fp.find)(['isNew', true], subCategories);
  return !(0, _fp.isNil)(hasNewCat) || !(0, _fp.isNil)(hasNewSubCat);
}

/**
 * Handle validate when save or copy report/template
 * @param   {Object}  props components property
 * @return  {Promise}
 */
function handleValidate(props) {
  var store = props.store,
      loader = props.loader,
      valManager = props.validation,
      type = props.boardDetail.type,
      isMoveReport = props.isMoveReport,
      reportName = props.reportName,
      category = props.category,
      subCategory = props.subCategory,
      boardDetail = props.boardDetail,
      version = props.version;

  var contentType = type === Number(_Izenda2.default.CATEGORY_TYPE.REPORT) ? 'report' : 'template';

  var formatMessage = isMoveReport ? _Izenda2.default.MESSAGES.M06b : _Izenda2.default.MESSAGES.M06a;

  var successMessage = String.format(formatMessage, contentType, reportName, !(0, _fp.isEmpty)(category) ? category.name : _Izenda2.default.UNCATEGORIZED, !(0, _fp.isEmpty)(subCategory) ? '/' + subCategory.name : '');

  var dataObject = (0, _fp.pick)(['reportName', 'category', 'subCategory', 'saveInto'], props);

  return valManager.validate().then(function (success) {
    if (success) {
      loader.startLoading();
      return store.copyNewReport(dataObject, boardDetail, isMoveReport, version).then(function (response) {
        if ((0, _fp.isArray)(response)) {
          valManager.updateErrors(response);
          if ((0, _fp.isNil)(response[0].key) || (0, _fp.isEmpty)(response[0].key)) {
            props.confirmMessage('info', response[0].messages);
          }
          return false;
        }

        return response;
      }).then(function (result) {
        store.model.hasNewCategory = hasNewCategory(props);
        return result && props.onAccept(successMessage, result, dataObject);
      }).finally(loader.endLoading.bind(loader));
    }
  });
}

/**
 * Add new category
 * @param {Object} props Component props
 * @param {Object} item  New category item added
 */
function addNewCategory(props, item) {
  props.updateCategories((0, _fp.concat)(item, props.categories));
}

/**
 * Update selected category
 * @param {Object} props Component props
 * @param {String} item  category id
 * @param {String} name  category name
 * @param {Bool}   isNew
 */
function updateCategory(props, item, name, isNew) {
  // update selected category
  props.changeCategory({ id: item, name: name });

  // reset selected sub category
  props.changeSubCategory(null);

  // reload sub category list if have category id another case set subcategories to empty array
  if (!isNew) {
    props.store.loadSubCategoriesForCopyPopup(item).then(function (subCategories) {
      subCategories && props.updateSubCategories(subCategories.map(function (cate) {
        return new _Izenda4.default(cate);
      }));
    });
  } else {
    props.updateSubCategories([]);
  }
}

/**
 * Add new sub category
 * @param {Object} props Components props
 * @param {Object} item  New sub category
 */
function addNewSubCategory(props, item) {
  props.updateSubCategories((0, _fp.concat)(item, props.subCategories));
}

/**
 * Update selected  sub category
 * @param {Object} props Component props
 * @param {String} item  category id
 * @param {String} name  category name
 */
function updateSubCategory(props, item, name) {
  props.changeSubCategory({ id: item, name: name });
}

/** Onclosing popup */
function onClosing(props, callBack, type) {
  if (type === 'accept') {
    return handleValidate(props);
  } else {
    props.onReject();
  }
}

/**
 * Change save into dropdown
 * @param {Object} props  Component property
 * @param {Object} item   Selected item.
 */
function onChangeSaveInto(props, item) {
  props.updateSaveInto(item.value);
  props.changeCategory(null);
  props.changeSubCategory(null);
  var store = props.store;

  props.store.loadCategoriesForCopyPopup(store.reportType, item.value).then(function () {
    props.updateCategories((0, _fp.cloneDeep)((0, _mobx.toJS)(store.model.copyReportCategoryList)));
  });
}

exports.default = CopyReportAction;
module.exports = exports['default'];

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(30);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.UpdateReportButton.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
var UpdateReportButton = function UpdateReportButton(props) {
  var localization = props.localization,
      updateResults = props.updateResults,
      disabled = props.disabled;

  return _react2.default.createElement(_Izenda2.default, {
    label: localization.getText('REPORTDESIGNER_LABEL_UPDATE_RESULT'),
    onClick: updateResults,
    disabled: disabled,
    className: 'btn-success'
  });
};

UpdateReportButton.propTypes = {
  updateResults: _propTypes2.default.func.isRequired
};

exports.default = (0, _Izenda4.default)()(UpdateReportButton);
module.exports = exports['default'];

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file='Izenda.SaveReportButton.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Button = __webpack_require__(30);
  var SavePopup = __webpack_require__(1183);
  var ACCESS_RIGHT = __webpack_require__(42).ACCESS_RIGHT;

  var connect = __webpack_require__(2);
  var routeUtils = __webpack_require__(31);
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var SaveReportButton = React.createClass({
    displayName: 'SaveReportButton',

    propTypes: {
      fieldStore: React.PropTypes.object.isRequired,
      subscribedInstancesStore: React.PropTypes.object.isRequired,
      viewMode: React.PropTypes.bool.isRequired,
      confirmFn: React.PropTypes.func.isRequired
    },
    render: function render() {
      var props = this.props;
      var accessPriority = props.accessPriority;
      var localization = this.props.localization;
      var saveAsPermission = props.authorization.checkPrivileges([props.authorizationConstants.PERMISSION_KEY.ReportsCanCreateNewReportValue]) && (accessPriority === ACCESS_RIGHT.FullAccess || accessPriority === ACCESS_RIGHT.QuickEdit || accessPriority === ACCESS_RIGHT.SaveAs);

      var savePermission = props.authorization.checkPrivileges([props.authorizationConstants.PERMISSION_KEY.ReportsActionsOverwriteExistingReport]) && accessPriority === ACCESS_RIGHT.FullAccess && !props.boardDetail.isGlobal || props.boardDetail.isGlobal && uiState.currentUser.systemAdmin && !uiState.tenantId;

      if (saveAsPermission && savePermission && props.active) {
        return React.createElement(
          'div',
          { className: 'btn-group' },
          React.createElement(
            Button,
            {
              className: 'dropdown-toggle',
              'data-toggle': 'dropdown',
              label: localization.getText('COMMON_LABEL_SAVE')
            },
            React.createElement('span', { className: 'caret' })
          ),
          React.createElement(
            'ul',
            { className: 'dropdown-menu' },
            React.createElement(
              'li',
              null,
              React.createElement(
                'a',
                { onClick: this.props.onSave },
                localization.getText('COMMON_LABEL_SAVE')
              )
            ),
            React.createElement(
              'li',
              null,
              React.createElement(
                'a',
                { onClick: this.onSaveAs },
                localization.getText('COMMON_LABEL_SAVE_AS')
              )
            )
          )
        );
      }

      if (savePermission && props.active) {
        return React.createElement(Button, { onClick: props.onSave, label: localization.getText('COMMON_LABEL_SAVE') });
      }

      if (saveAsPermission) {
        return React.createElement(Button, { onClick: this.onSaveAs, label: localization.getText('COMMON_LABEL_SAVE_AS') });
      }

      return null;
    },
    /**
     * Save As Report Designer:
     *  - Validate data > if data valid > open SaveAs Popup for new Report
     */
    onSaveAs: function onSaveAs() {
      var props = this.props;
      var fieldStore = props.fieldStore;
      var reportDesignerStore = fieldStore.reportStore;
      reportDesignerStore.canSaveAs = true;

      // TODO : Validate Filter here

      return this.openPopup(true);
    },

    openPopup: function openPopup(saveAs) {
      var props = this.props;
      var fieldStore = props.fieldStore;
      var reportDesignerStore = fieldStore.reportStore;

      function showSavePopup() {
        return props.openPopup(SavePopup, {
          store: reportDesignerStore,
          onSaved: this.onCloseSavePopup,
          saveAsMode: saveAs,
          fieldStore: fieldStore
        });
      }

      return isNil(reportDesignerStore.model.categoryId) || reportDesignerStore.model.isGlobal && !isNil(reportDesignerStore.fieldsStore.tenantId) && saveAs ? reportDesignerStore.loadCategories().then(showSavePopup.bind(this)) : (0, _bluebird.join)(reportDesignerStore.loadCategories(), reportDesignerStore.loadSubCategories(reportDesignerStore.model.categoryId)).then(showSavePopup.bind(this));
    },

    onCloseSavePopup: function onCloseSavePopup(newReportId) {
      var router = this.props.router;

      if (newReportId) {
        this.props.reportStore && this.props.reportStore.resetReportData();
        router.push(this.buildViewerLink(newReportId));
      }
    },
    buildViewerLink: function buildViewerLink(newReportId) {
      var mode = this.props.viewMode ? 'View' : 'Edit';

      return routeUtils.getReportUrl(mode, { id: newReportId });
    }
  });

  module.exports = connect()(SaveReportButton);
}();

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _react = __webpack_require__(0);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(50);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SavePopupAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _recompose.compose)((0, _recompose.withState)('reportName', 'setReportName', function (props) {
  return props.store.model.reportName;
}), (0, _recompose.withState)('originalReportName', 'setOriginalReportName', function (props) {
  return props.store.model.reportName;
}), (0, _recompose.withState)('originalReportType', 'setOriginalReportType', function (props) {
  return props.store.model.reportType;
}), (0, _recompose.withState)('originalCategoryId', 'setOriginalCategoryId', function (props) {
  return props.store.model.categoryId;
}), (0, _recompose.withState)('originalCategoryName', 'setOriginalCategoryName', function (props) {
  return props.store.model.categoryName;
}), (0, _recompose.withState)('originalSubCategoryId', 'setOriginalSubCategoryId', function (props) {
  return props.store.model.subCategoryId;
}), (0, _recompose.withState)('saveInto', 'changeSaveInto', function (props) {
  return props.store.model.isGlobal ? _Izenda2.default.GLOBAL_REPORT_ENUM.GLOBAL : _Izenda2.default.GLOBAL_REPORT_ENUM.LOCAL;
}), (0, _recompose.withState)('originalSaveInto', 'changeOriginalSaveInto', function (props) {
  return props.store.model.isGlobal;
}), (0, _recompose.withHandlers)({
  onClosing: (0, _fp.curry)(onClosing),
  onAcceptClosing: (0, _fp.curry)(onAcceptClosing),
  onCancelClosing: (0, _fp.curry)((0, _mobx.action)(onCancelClosing)),
  detectReportChange: (0, _fp.curry)(detectReportChange),
  saveReport: (0, _fp.curry)(saveReport),
  changeCategory: (0, _fp.curry)(changeCategory),
  addNewCategory: (0, _fp.curry)(addNewCategory),
  changeReportType: (0, _fp.curry)(changeReportType),
  changeSubCategory: (0, _fp.curry)(changeSubCategory),
  addNewSubCategory: (0, _fp.curry)(addNewSubCategory),
  updateSaveInto: (0, _fp.curry)(updateSaveInto)
}), (0, _recompose.setPropTypes)({
  store: _react.PropTypes.object.isRequired,
  section: _react.PropTypes.string,
  onSaved: _react.PropTypes.func
}));

/**
 * Update "Save Into" in save popup
 * @param {any} props
 * @param {number} value
 */

function updateSaveInto(props, value) {
  // Dropdown pass 2 arguments to onChange event, this makes error in withState (recompose)
  props.changeSaveInto(value);
  var store = props.store;
  store.loadCategories(store.model.reportType, null, !!value);
  store.clearCategory();
  store.clearSubCategory();
}

/**
 * Save report
 * @param {any} props
 * @return {promise}
 */
function saveReport(props) {
  var store = props.store,
      section = props.section,
      fieldStore = props.fieldStore,
      confirmFn = props.confirmFn,
      saveAsMode = props.saveAsMode,
      isNew = props.isNew,
      onSaved = props.onSaved,
      disableReport = props.disableReport;


  store.model.setIgnoreCheckChange();

  // Save as in Report Viewer
  if (!section && fieldStore) {
    var reportBody = fieldStore.reportBody;
    if (reportBody.hasInvisibleFields) {
      return confirmFn('Confirmation', {
        description: _Izenda4.default.MESSAGES.SAVE_AS_REPORT,
        isHTMLFormat: true
      }).then(function () {
        return store.saveReport(_Izenda2.default.PAGE_NAME.FIELDS).then(function (result) {
          (saveAsMode || isNew) && result.success && onSaved && onSaved(result.reportId);
        });
      });
    }
  }

  // Save as in Report Designer
  return store.saveReport(section).then(function (result) {
    result.isDisableReport && disableReport && disableReport();

    (saveAsMode || isNew) && result.success && onSaved && onSaved(result.reportId);
    return result;
  });
}

/**
 * Detect report change
 * @param {any} props
 * @return {promise}
 */
function detectReportChange(props) {
  var store = props.store,
      section = props.section,
      disableReport = props.disableReport,
      confirmFn = props.confirmFn;


  return store.detectReportChange(section).then(function (result) {
    if (!result.success) {
      var error = result.messages[0];

      switch (error.key) {
        case _Izenda2.default.DETECT_CHANGE.PHYSICAL:
          confirmFn('Information', {
            description: error.messages[0],
            type: 'info',
            showCloseIndicator: true,
            isHTMLFormat: true
          }).then(disableReport);
          break;
        case _Izenda2.default.DETECT_CHANGE.LOGICAL:
          return confirmFn('Confirmation', {
            description: error.messages[0],
            isHTMLFormat: true
          }).then(saveReport.bind(null, props));
      }
      return null;
    }

    return saveReport(props);
  });
}

/**
 * When click button OK on popup
 * @param {any} props
 * @return {promise}
 */
function onAcceptClosing(props) {
  var store = props.store,
      saveAsMode = props.saveAsMode,
      validation = props.validation,
      reportName = props.reportName,
      saveInto = props.saveInto,
      section = props.section;

  var model = store.model;
  saveAsMode && model.markSaveAs();
  var valManager = validation;

  return valManager.validate().then(function (success) {
    if (success) {
      valManager.reset();
      return store.validate(reportName).then(function (messages) {
        if (!messages) {
          !!saveInto !== model.isGlobal && model.changeGlobalType(!!saveInto);
          model.changeName(reportName);
          return section ? detectReportChange(props) : saveReport(props);
        }
        valManager.updateErrors(messages);
      });
    }
    return false;
  }).then(function (saveResult) {
    if (saveResult && !(0, _fp.isEmpty)(saveResult.messages)) {
      valManager.updateErrors(saveResult.messages);
    } else if (saveResult) {
      store.model.resetSaveAs();
      store.setNewReport(false);
      props.onAccept();
    }
    return null;
  });
}

/**
 * When click button Cancel on popup
 * @param {any} props
 */
function onCancelClosing(props) {
  var store = props.store,
      originalReportName = props.originalReportName,
      originalReportType = props.originalReportType,
      originalSaveInto = props.originalSaveInto,
      originalCategoryId = props.originalCategoryId,
      originalCategoryName = props.originalCategoryName,
      originalSubCategoryId = props.originalSubCategoryId,
      validation = props.validation,
      onReject = props.onReject;

  var model = store.model;

  model.changeName(originalReportName);
  model.updateType(originalReportType);
  store.changeSaveInto(originalSaveInto).then(function () {
    if (store.saveAsMode && store.model.isGlobal && !(0, _fp.isNil)(store.accessStore.tenantId)) {
      model.updateCategory(originalCategoryId, originalCategoryName);
    } else {
      store.changeCategory(originalCategoryId).then(function () {
        model.updateSubCategory(originalSubCategoryId);
      });
    }
  });

  validation.reset();
  onReject();
  store.model.resetSaveAs();
}

/**
 * Handle when popup closing
 * @param {any} props
 * @param  {Function} closeCallback
 * @param  {string} type
 */
function onClosing(props, closeCallBack, type) {
  if (type === 'accept') {
    onAcceptClosing(props);
  } else if (type === 'cancel') {
    onCancelClosing(props);
  }
}

/**
 * Change category for report
 * @param {any} props
 * @param  {string} id
 * @param  {string} name
 */
function changeCategory(props, id, name) {
  props.store.changeCategory(id, name);
}

/**
 * Add new category for report
 * @param {any} props
 * @param  {any} value
 */
function addNewCategory(props, value) {
  props.store.model.addCategory(value);
}

/**
 * Change type of report
 * @param {any} props
 * @param  {number} value
 */
function changeReportType(props, value) {
  var validation = props.validation,
      store = props.store,
      reportName = props.reportName,
      setReportName = props.setReportName;

  validation.reset();
  store.changeType(value);

  if (store.isNewReport && (reportName === _Izenda2.default.DEFAULT_REPORT_NAME || reportName === _Izenda2.default.DEFAULT_TEMPLATE_NAME)) {
    var isReportType = store.model.reportType === _Izenda2.default.REPORT_TYPE_ENUM.REPORT;
    var reportDefaultName = isReportType ? _Izenda2.default.DEFAULT_REPORT_NAME : _Izenda2.default.DEFAULT_TEMPLATE_NAME;
    setReportName(reportDefaultName);
  }
}

/**
 * Change subCategory for report
 * @param {any} props
 * @param  {string} id
 * @param  {string} name
 */
function changeSubCategory(props, id, name) {
  props.store.model.updateSubCategory(id, name);
}

/**
 * Add new subCategory for report
 * @param {any} props
 * @param  {any} value
 */
function addNewSubCategory(props, value) {
  props.store.model.addSubCategory(value);
}
module.exports = exports['default'];

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.CancelViewReportButton.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Button = __webpack_require__(30);

  var constants = __webpack_require__(50);
  var connect = __webpack_require__(2);

  var CancelViewReportButton = React.createClass({
    displayName: 'CancelViewReportButton',

    render: function render() {
      var localization = this.props.localization;
      return React.createElement(Button, { label: localization.getText('COMMON_LABEL_CANCEL'), onClick: this.onCancel });
    },
    onCancel: function onCancel(e) {
      var props = this.props;
      var confirmFn = props.confirmFn;

      return props.checkDirty(null) ? confirmFn('Confirmation', {
        description: constants.MESSAGES.CANCEL
      }).then(function () {
        props.cancelReport && props.cancelReport();
      }) : props.cancelReport && props.cancelReport();
    }
  });

  module.exports = connect()(CancelViewReportButton);
}();

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(30);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(31);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(50);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(340);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(200);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseViewReportButton = (0, _Izenda6.default)()(function (props) {
  var store = props.store,
      localization = props.localization,
      router = props.router,
      reportType = props.reportType,
      reportId = props.reportId,
      disabled = props.disabled,
      fieldStore = props.fieldStore;

  var reportListLink = store.reportListLink || _Izenda10.default.getValueByKey((0, _fp.get)('location.query', props), _Izenda11.SOURCE_PATH_QUERY_KEY);

  if (reportListLink) {
    return _react2.default.createElement(BackButton, {
      onClickFn: router.push.bind(router, reportListLink),
      localization: localization,
      disabled: disabled
    });
  }

  var reportInfo = (0, _fp.getOr)({}, 'masterModel', props.fieldStore);
  var categoryId = null;

  var assignCategoryId = function assignCategoryId(catId) {
    String.isGuidFormat(catId) && catId !== _Izenda8.default.EMPTY_GUID && (categoryId = catId);
  };

  assignCategoryId(reportInfo.categoryId);
  assignCategoryId(reportInfo.subCategoryId);

  var closeReport = function closeReport() {
    var isGlobal = fieldStore.masterModel.isGlobal;
    var reportListUrl = _Izenda4.default.getReportUrl('List', {
      reportType: reportType,
      catId: categoryId,
      reportId: reportId,
      isGlobal: isGlobal
    });
    // Reset selected report
    store.updateReportId(null, null);

    router.push(reportListUrl);
  };

  return _react2.default.createElement(
    'a',
    { className: 'btn btn-primary', disabled: disabled, 'aria-label': 'Close', onClick: closeReport },
    localization.getText('COMMON_LABEL_CLOSE')
  );
});
// ----------------------------------------------------------------------
// <copyright file='Izenda.CloseViewReportButton.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var BackButton = function BackButton(props) {
  var localization = props.localization,
      disabled = props.disabled;

  var labelClose = localization.getText('COMMON_LABEL_CLOSE');
  return _react2.default.createElement(
    _Izenda2.default,
    { className: 'btn btn-primary', onClick: props.onClickFn, disabled: disabled, 'aria-label': labelClose },
    labelClose
  );
};

CloseViewReportButton.propTypes = {
  reportType: _propTypes2.default.string.isRequired,
  reportId: _propTypes2.default.string.isRequired,
  categoryId: _propTypes2.default.string
};

exports.default = CloseViewReportButton;
module.exports = exports['default'];

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(30);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(635);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(401);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintReportButton = function PrintReportButton(props) {
  return _react2.default.createElement(_Izenda4.default, {
    label: props.localization.getText("COMMON_LABEL_PRINT"),
    onClick: props.exportReport(_Izenda7.HTML.value)
  });
}; // ----------------------------------------------------------------------
// <copyright file='Izenda.PrintReportButton.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

PrintReportButton.displayName = "PrintReportButton";

exports.default = (0, _Izenda2.default)(_Izenda6.default)(PrintReportButton);
module.exports = exports["default"];

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerHeader.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(29);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2598);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda7 = __webpack_require__(13);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUBSCRIPTION_MODE_COL_NUMBER = 12;
var NON_SUBSCRIPTION_MODE_COL_NUMBER = 8;

var ReportViewerHeader = (_dec = (0, _Izenda10.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportViewerHeader, _Component);

  function ReportViewerHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportViewerHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportViewerHeader.__proto__ || (0, _getPrototypeOf2.default)(ReportViewerHeader)).call.apply(_ref, [this].concat(args))), _this), _this.changePreviewRecord = function (e) {
      var _this$props = _this.props,
          fieldStore = _this$props.fieldStore,
          model = _this$props.fieldStore.reportStore.model;

      model.updatePreviewRecord(e.value);
      fieldStore.reportFilters.resetUpdateResult();
      _this.props.updateReportParts();
    }, _this.changeName = function (name) {
      var model = _this.props.fieldStore.reportStore.model;


      model.changeName(name);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Change preview record
   * @param {Event} e
   */


  /**
   * Change report name
   * @param {string} name
   */


  (0, _createClass3.default)(ReportViewerHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          _props$fieldStore$rep = _props.fieldStore.reportStore,
          model = _props$fieldStore$rep.model,
          isSubscriptionMode = _props$fieldStore$rep.model.displayMode.isSubscriptionMode,
          boardDetail = _props.boardDetail;


      var previewRecordsContainerClassName = (0, _classnames2.default)({
        u_none: isSubscriptionMode,
        u_block: !isSubscriptionMode
      });

      var reportNameCols = isSubscriptionMode ? SUBSCRIPTION_MODE_COL_NUMBER : NON_SUBSCRIPTION_MODE_COL_NUMBER;

      return _react2.default.createElement(
        _Izenda8.default,
        null,
        _react2.default.createElement(
          _Izenda8.default.Row,
          { className: 'izenda-ReportHeader' },
          _react2.default.createElement(
            _Izenda8.default.Col,
            { cols: reportNameCols, className: 'report-name' },
            !(0, _fp.isNil)(boardDetail) && _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({}, this.props, { dataDetail: boardDetail, updateName: this.changeName }))
          ),
          _react2.default.createElement(
            _Izenda8.default.Col,
            { cols: '4', className: previewRecordsContainerClassName },
            _react2.default.createElement(
              'div',
              { className: 'u_table u_fullWidth u_paddingInner u-bgWhite preview-records' },
              _react2.default.createElement(
                'span',
                { className: 'u_tableCell control-label' },
                localization.getText('REPORTDESIGNER_LABEL_PREVIEW_RECORDS')
              ),
              _react2.default.createElement(
                'div',
                { className: 'u_tableCell u_fullWidth' },
                _react2.default.createElement(_Izenda2.default, {
                  options: _Izenda6.default.PREVIEW_RECORD,
                  value: model.previewRecord,
                  labelField: 'label',
                  valueField: 'value',
                  onChange: this.changePreviewRecord
                })
              )
            )
          )
        )
      );
    }
  }]);
  return ReportViewerHeader;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object,
  boardDetail: _propTypes2.default.object,
  fieldStore: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = ReportViewerHeader;
module.exports = exports['default'];

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportName.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var connect = __webpack_require__(2);
  var EventsUtils = __webpack_require__(24);
  var notifyChange = EventsUtils.notifyChange;
  var Validator = __webpack_require__(23);
  var Link = __webpack_require__(52).Link;
  var constants = __webpack_require__(50);
  var Config = __webpack_require__(40);
  var TextHighLight = __webpack_require__(62);
  var Input = Validator()(__webpack_require__(17));
  var UiState = __webpack_require__(15);
  var ACCESS_RIGHT = __webpack_require__(42).ACCESS_RIGHT;

  var SearchCriteria = constants.SEARCH_CRITERIA;

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      isEmpty = _require.isEmpty,
      get = _require.get;

  var ReportName = React.createClass({
    displayName: 'ReportName',

    propTypes: {
      store: React.PropTypes.object,
      dataDetail: React.PropTypes.object
    },

    getInitialState: function getInitialState() {
      this.originalReportName = this.props.dataDetail.name;
      return { editMode: false };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataDetail.name != this.props.dataDetail.name) {
        this.originalReportName = nextProps.dataDetail.name;
      }
    },

    /**
     * Handle enter
     * @param {Object} event
     */
    handleEnter: function handleEnter(e) {
      if (e.key === 'Enter') {
        this.handleSaveReportName();
      }
    },

    /**
     * Handle save report name
     */
    handleSaveReportName: function handleSaveReportName(e) {
      this.props.dataDetail.setEditMode && this.props.dataDetail.setEditMode(true);

      // Stop event blur if current event is mouse down
      if (e && e.type === 'mousedown') {
        e.preventDefault();
        e.stopPropagation();
      }

      var props = this.props;
      var loader = props.loader;
      var dataDetail = this.props.dataDetail;
      var valManager = this.props.validation;
      var reportDesignerModel = props.fieldStore.masterModel;
      var reportGeneralData = reportDesignerModel.getGeneralData();

      if (dataDetail.name === this.originalReportName) {
        this.setState({ editMode: false });
        return;
      }

      reportGeneralData.name = dataDetail.name;
      valManager.validate('reportName').then(function (success) {
        if (success) {
          loader.startLoading();
          return props.store.validateName(reportGeneralData).then(function (response) {
            if (isNil(response)) {
              this.props.dataDetail.setEditMode && this.props.dataDetail.setEditMode(false);
              props.updateName && props.updateName(dataDetail.name);
              this.originalReportName = props.dataDetail.name;
              this.setState({ editMode: false });
            } else {
              ReactDOM.findDOMNode(this.refs.inputName.refs.editor).focus();
            }
            if (!isEmpty(response)) {
              // Change error key to reportName
              response.map(function (message) {
                message.key = 'reportName';
              });
              valManager.updateErrors(response);
            }
          }.bind(this)).finally(loader.endLoading.bind(loader));
        }
      }.bind(this));
    },

    /**
     * Handle cancel button
     */
    handleCancelRename: function handleCancelRename() {
      this.setState({ editMode: false });
      this.props.dataDetail.name = this.originalReportName;
    },

    /**
     * Rename
     * @param {Object} event
     */
    handleRename: function handleRename(e) {
      this.setState({ editMode: true });
      e.preventDefault();
      e.stopPropagation();
    },

    /**
     * Change report name
     * @param {Object} input
     */
    onChangeReportName: function onChangeReportName(input) {
      this.props.dataDetail.name = input.target.value;
      this.setState({ editMode: this.state.editMode });
    },

    /**
     * Render report name component with edit mode
     * @return {Object} component
     */
    renderEditReportName: function renderEditReportName() {
      var localization = this.props.localization;
      var dataDetail = this.props.dataDetail;

      return React.createElement(
        'div',
        { className: 'title-edit form-group' },
        React.createElement(
          'div',
          { className: 'input-group' },
          React.createElement(Input, {
            ref: 'inputName',
            value: dataDetail.name,
            onChange: this.onChangeReportName,
            onKeyPress: this.handleEnter,
            onBlur: this.handleSaveReportName,
            field: 'reportName',
            validations: constants.CONSTRAINTS.NAME,
            className: 'form-control',
            autoFocus: true
          }),
          React.createElement(
            'span',
            { className: 'input-group-btn' },
            React.createElement(
              'button',
              {
                className: 'btn btn-default',
                onMouseDown: this.handleSaveReportName,
                title: localization.getText('COMMON_TOOLTIP_UPDATE_CHANGE')
              },
              React.createElement('span', { className: 'icon-ok success-color' })
            ),
            React.createElement(
              'button',
              {
                className: 'btn btn-default',
                onMouseDown: this.handleCancelRename,
                title: localization.getText('COMMON_TOOLTIP_CANCEL_CHANGE')
              },
              React.createElement('span', { className: 'icon-cancel' })
            )
          )
        )
      );
    },

    /**
     * Render report name component with view mode
     * @return {Object} component
     */
    renderViewReportName: function renderViewReportName() {
      var props = this.props;
      var localization = props.localization;
      var dataDetail = props.dataDetail;
      var model = get('store.items', props);

      return React.createElement(
        'div',
        { className: 'u_flexHorizontal' },
        React.createElement(
          'div',
          { className: 'u_textTruncate' },
          React.createElement(TextHighLight, {
            highlight: model.searchText,
            text: dataDetail.name,
            className: 'text-bold',
            notHighlight: dataDetail.isNotHighLight && dataDetail.isNotHighLight(model.searchType, SearchCriteria[1].value)
          })
        ),
        React.createElement(
          'div',
          { className: 'u_fullInlineBlock' },
          this.showEditReportName() && React.createElement(
            'a',
            { onClick: this.handleRename },
            React.createElement('span', { className: 'icon-pencil-new', title: localization.getText('COMMON_TOOLTIP_RENAME') })
          )
        )
      );
    },

    /** User can edit report name follow priority as below:
     *    System Admin (global & local reports)
     *    Local report
     *      Tenant has full report dashboard access
     *      Tenant is creator || owner of this report
     */
    showEditReportName: function showEditReportName() {
      var props = this.props;
      var currentUser = UiState.currentUser;
      var reportDesignerModel = get('fieldStore.masterModel', props);

      if (currentUser.systemAdmin) {
        return true;
      }

      if (!get('boardDetail.isGlobal', props) && !isNil(UiState.tenantId)) {
        return reportDesignerModel.accessPriority === ACCESS_RIGHT.FullAccess || reportDesignerModel.createdById === currentUser.id || reportDesignerModel.ownerId === currentUser.id;
      }

      return false;
    },

    /**
     * Render component
     * @return {Object} component
     */
    render: function render() {
      var dataDetail = this.props.dataDetail;

      return React.createElement(
        'div',
        null,
        this.state.editMode ? this.renderEditReportName() : this.renderViewReportName()
      );
    }
  });

  module.exports = connect()(ReportName);
}();

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file='Izenda.FilterItem.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Filter Item component
 */

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(42);

var _Izenda2 = __webpack_require__(89);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(628);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(626);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda8 = __webpack_require__(13);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(68);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(27);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(2);

var _Izenda15 = _interopRequireDefault(_Izenda14);

__webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterItem = (_dec = (0, _Izenda15.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FilterItem, _Component);

  function FilterItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FilterItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FilterItem.__proto__ || (0, _getPrototypeOf2.default)(FilterItem)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeOperatorValue = function (value) {
      var _this2 = _this,
          props = _this2.props;

      var configField = props.configField || {};
      configField.setFilterValue && configField.setFilterValue(value);
      props.updateCascadingValue && props.updateCascadingValue();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * Handle change of operator value.
   * @param {string} value
   */


  (0, _createClass3.default)(FilterItem, [{
    key: 'renderOperatorValue',


    /**
     * Render operator value component.
     */
    value: function renderOperatorValue() {
      var props = this.props,
          _props = this.props,
          _props$configField = _props.configField,
          configField = _props$configField === undefined ? {} : _props$configField,
          viewMode = _props.viewMode,
          index = _props.index,
          accessPriority = _props.accessPriority,
          isLazyLoading = _props.isLazyLoading;

      var filterInfo = configField.filterInfo;
      var filterSource = configField.operatorSourceValue;

      if (this.doesRenderOperator(filterInfo.group.name, filterInfo.operator.name)) return null;

      return _react2.default.createElement(_Izenda7.default, {
        filterSource: filterSource,
        filterInfo: filterInfo,
        configField: configField,
        operatorGroup: configField,
        onChange: this.onChangeOperatorValue,
        index: index,
        viewMode: viewMode,
        disabled: accessPriority === _Izenda.ACCESS_RIGHT.Locked,
        store: props.fieldStore,
        isLazyLoading: isLazyLoading
      });
    }

    /**
     * Render operator component.
     */

  }, {
    key: 'renderOperator',
    value: function renderOperator() {
      var props = this.props,
          isLazyLoading = this.props.isLazyLoading;

      var configField = props.configField || {};
      var filterInfo = configField.filterInfo;

      if (!this.doesRenderOperator(filterInfo.group.name, filterInfo.operator.name)) return null;

      return _react2.default.createElement(_Izenda5.default, {
        notInReportDesignerMode: true,
        configField: configField,
        updateSourceValue: _fp.noop,
        isLazyLoading: isLazyLoading
      });
    }

    /**
     * Check need to render operator.
     * @param {String} operatorGroupName
     * @param {String} operatorName
     */

  }, {
    key: 'doesRenderOperator',
    value: function doesRenderOperator(operatorGroupName, operatorName) {
      return operatorGroupName === _Izenda3.default.OPERATOR_GROUP_KEYS.BOOLEAN || (0, _fp.any)(function (value) {
        return operatorName === value;
      }, _Izenda3.default.OPERATOR_KEYS);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var configField = props.configField || {};
      var fieldDetails = configField.fieldDetails || {};
      var filterInfo = configField.filterInfo;
      var isRequiredFilter = fieldDetails.required;

      var label = fieldDetails.alias;
      var operator = filterInfo.operator.name === _Izenda3.default.OPERATOR_GROUP.UNKNOWN ? _Izenda3.default.DEFAUFT_OPERATOR_LABEL : filterInfo.operator.name;

      var mode = _Izenda3.default.SHOW_MODE_OPERATOR.indexOf(filterInfo.operator.key) > -1 ? configField.fieldDetails.operatorSetting === _Izenda3.default.SELECT_SETTINGS.MULTIPLE ? ' - ' + _Izenda3.default.SELECT_TEXT.MULTIPLE : ' - ' + _Izenda3.default.SELECT_TEXT.SINGLE : '';
      var defaultToolTip = label + ' - ' + operator + mode;
      var tooltipOperator = fieldDetails.commonFilterRequired ? defaultToolTip + ' \n ' + props.localization.getText('DASHBOARD_TOOLTIP_REQUIRED_FILTER') : defaultToolTip;

      var filterTextclassnames = (0, _classnames2.default)('normal', { 'required-before': isRequiredFilter });

      return _react2.default.createElement(
        _Izenda9.default.Col,
        { cols: '3', xs: '12' },
        _react2.default.createElement(
          'div',
          { className: 'report-filter-item' },
          _react2.default.createElement(
            'div',
            { className: 'filter-item-label form-group u_noMarginAll' },
            _react2.default.createElement(
              'div',
              { className: 'filter-label' },
              _react2.default.createElement(
                _Izenda11.default,
                { tooltip: tooltipOperator, className: filterTextclassnames },
                _react2.default.createElement(
                  'span',
                  null,
                  label,
                  ' '
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'operator' },
                  String.format(' - {0}{1}', operator, mode)
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'filter-item-value form-group u_paddingAll u_borderAll' },
            _react2.default.createElement(
              _Izenda13.default,
              null,
              this.renderOperator(),
              this.renderOperatorValue()
            )
          )
        )
      );
    }
  }]);
  return FilterItem;
}(_react.Component), _class2.propTypes = {
  configField: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = FilterItem;
module.exports = exports['default'];

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(13);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(30);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilteringOption.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Cross Filtering Option Component
 */

var propTypes = {
  onOptionClick: _react.PropTypes.func,
  localization: _react.PropTypes.object,
  hadSetting: _react.PropTypes.bool,
  resetDefaultValue: _react.PropTypes.func,
  enable: _react.PropTypes.bool
};

var CrossFilteringOption = (0, _mobxReact.observer)(function (_ref) {
  var onOptionClick = _ref.onOptionClick,
      localization = _ref.localization,
      resetDefaultValue = _ref.resetDefaultValue,
      hadSetting = _ref.hadSetting,
      enable = _ref.enable;

  return _react2.default.createElement(
    'div',
    { className: 'izenda-CrossFiltering__CrossFilteringOption' },
    _react2.default.createElement(
      'span',
      { className: 'control-label u_alignMiddle' },
      localization.getText('CROSSFILTERING_OPTION_LABEL')
    ),
    _react2.default.createElement(
      'div',
      { className: 'u_fullInlineBlock' },
      _react2.default.createElement(
        _Izenda4.default,
        { className: 'btn btn-primary btn-icon icon-setting',
          onClick: onOptionClick,
          title: localization.getText('CROSSFILTERING_OPTION_TOOLTIP'),
          disabled: !enable },
        hadSetting && _react2.default.createElement(
          'div',
          { className: 'u_floatRight u-posRelative' },
          _react2.default.createElement('i', { className: 'icon-ok u_smallIcon u-hadSetting u-colorWhite u-bgGreen' })
        )
      ),
      hadSetting && _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'icon-cancel u-colorRed',
          title: localization.getText('PROPERTIES_EDITOR_REMOVE_SETTING'),
          onClick: resetDefaultValue })
      )
    )
  );
});

CrossFilteringOption.propTypes = propTypes;

exports.default = CrossFilteringOption;
module.exports = exports['default'];

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilteringSlider.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Cross Filtering Slider Component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _reactSlick = __webpack_require__(1185);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _Izenda3 = __webpack_require__(2613);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(83);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrevArrow = (0, _mobxReact.observer)(function (_ref) {
  var localization = _ref.localization,
      className = _ref.className,
      onClick = _ref.onClick;

  return _react2.default.createElement('button', { title: localization.getText('CROSSFILTERING_PREVIOUS_TOOLTIP'), className: className, onClick: onClick });
});

var NextArrow = (0, _mobxReact.observer)(function (_ref2) {
  var localization = _ref2.localization,
      className = _ref2.className,
      onClick = _ref2.onClick;

  return _react2.default.createElement('button', { title: localization.getText('CROSSFILTERING_NEXT_TOOLTIP'), className: className, onClick: onClick });
});

var CrossFilteringSlider = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(CrossFilteringSlider, _React$Component);

  function CrossFilteringSlider(props) {
    (0, _classCallCheck3.default)(this, CrossFilteringSlider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CrossFilteringSlider.__proto__ || (0, _getPrototypeOf2.default)(CrossFilteringSlider)).call(this, props));

    _this.renderCrossFilteringGroups = function (localization, crossFilteringDetail, styles, removeCrossFiltering) {
      var onRemoveCrossFiltering = function onRemoveCrossFiltering(pill) {
        removeCrossFiltering(pill);
        // recalculate items to show.
        for (var index = 0; index < _this.settings.slidesToShow - 1; index++) {
          _this.slider.slickPrev();
        }
      };

      var pills = (0, _fp.flatMap)(function (group) {
        return group.pillDefinitions.toJS();
      }, crossFilteringDetail);

      return pills.map(function (item, index) {
        return _react2.default.createElement(
          'div',
          { key: item.id, style: styles },
          _react2.default.createElement(_Izenda4.default, { localization: localization, pill: item, removeCrossFiltering: onRemoveCrossFiltering })
        );
      });
    };

    _this.setRef = function (component) {
      _this.slider = component;
    };

    _this.slider = null;

    _this.settings = {
      autoplay: false,
      centerMode: false,
      dots: false,
      draggable: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: _react2.default.createElement(PrevArrow, { localization: props.localization }),
      nextArrow: _react2.default.createElement(NextArrow, { localization: props.localization })
    };
    return _this;
  }

  /**
   * Render cross filtering group
   * @param {Object} localization
   * @param {Array} crossFilteringDetail
   * @param {Object} styles
   * @param {Function} removeCrossFiltering
   */


  /**
   * Set ref
   * @param {Object} component
   */


  (0, _createClass3.default)(CrossFilteringSlider, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          crossFilteringDetail = _props.crossFilteringDetail,
          localization = _props.localization,
          removeCrossFiltering = _props.removeCrossFiltering,
          width = _props.width;

      var styles = {
        width: width / this.settings.slidesToShow
      };
      var hasFilter = (0, _fp.flow)(_fp.head, (0, _fp.get)('pillDefinitions'), _fp.isEmpty)(crossFilteringDetail);

      return _react2.default.createElement(
        'div',
        null,
        !hasFilter && _react2.default.createElement(
          _reactSlick2.default,
          (0, _extends3.default)({ ref: this.setRef }, this.settings),
          this.renderCrossFilteringGroups(localization, crossFilteringDetail, styles, removeCrossFiltering)
        )
      );
    }
  }]);
  return CrossFilteringSlider;
}(_react2.default.Component), _class.propTypes = {
  crossFilteringDetail: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  removeCrossFiltering: _react.PropTypes.func.isRequired,
  localization: _react.PropTypes.object.isRequired
}, _class.displayName = 'CrossFilteringSlider', _temp);
exports.default = (0, _Izenda2.default)(_Izenda6.default)(CrossFilteringSlider);
module.exports = exports['default'];

/***/ }),
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(956);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(973);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilterItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Cross Filtering Item Component
 */

var REPORT_PART_TYPE = _Izenda6.default.REPORT_PART_TYPE;
var PILL_COLOR = {
  LIGHT_BLUE: '#cee5f3',
  DARK_BLUE: '#b2cbdb'
};

var propTypes = {
  pill: _react.PropTypes.object.isRequired,
  removeCrossFiltering: _react.PropTypes.func,
  localization: _react.PropTypes.object.isRequired,
  isLast: _react.PropTypes.bool
};

var CrossFilterItem = (0, _mobxReact.observer)(function (_ref) {
  var removeCrossFiltering = _ref.removeCrossFiltering,
      pill = _ref.pill,
      localization = _ref.localization,
      isLast = _ref.isLast;

  var reportPart = (0, _fp.getOr)({}, 'reportPart', pill);
  var tooltip = (0, _fp.getOr)('', 'tooltip', pill);
  var alternative = (0, _fp.getOr)(false, 'alternative', pill);

  var reportPartName = (0, _fp.getOr)('', 'headerTitle', reportPart);
  var reportPartType = (0, _fp.getOr)(null, 'type', reportPart);
  var Drill = function () {
    switch (reportPartType) {
      case REPORT_PART_TYPE.Chart:
      case REPORT_PART_TYPE.Gauge:
        return _Izenda2.default;
      case REPORT_PART_TYPE.Map:
        return _Izenda4.default;
      default:
        return null;
    }
  }();

  var style = {
    backgroundColor: alternative ? PILL_COLOR.DARK_BLUE : PILL_COLOR.LIGHT_BLUE
  };

  return _react2.default.createElement(
    'div',
    { className: 'izenda-CrossFiltering__CrossFilteringItem u-posRelative', style: style },
    _react2.default.createElement(
      'div',
      { className: 'overflow-text' },
      _react2.default.createElement(
        'strong',
        { title: tooltip },
        reportPartName
      ),
      ':',
      Drill && _react2.default.createElement(Drill, {
        reportPart: reportPart,
        hideAllLevel: true,
        onDrillDown: reportPart.onDrilldown,
        className: 'izenda-CrossFiltering__Drill'
      }),
      _react2.default.createElement('a', {
        className: 'icon-cancel icon-removeCrossFilteringItem',
        title: localization.getText('CROSSFILTERING_REMOVE_TOOLTIP'),
        onMouseDown: removeCrossFiltering.bind(null, pill, isLast),
        onTouchStart: removeCrossFiltering.bind(null, pill, isLast)
      })
    )
  );
});

CrossFilterItem.propTypes = propTypes;

exports.default = CrossFilterItem;
module.exports = exports['default'];

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var onRemoveAllCrossFiltering = function onRemoveAllCrossFiltering(_ref) {
  var confirmFn = _ref.confirmFn,
      localization = _ref.localization,
      removeAllCrossFiltering = _ref.removeAllCrossFiltering;
  return function () {
    confirmFn('Confirmation', {
      description: localization.getText('CROSSFILTERING_REMOVE_ALL_CONFIRM')
    }).then(removeAllCrossFiltering);
  };
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilteringActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var onRemoveCrossFiltering = function onRemoveCrossFiltering(_ref2) {
  var removeCrossFiltering = _ref2.removeCrossFiltering;
  return function (pill) {
    removeCrossFiltering(pill);
  };
};

var crossFilteringActions = (0, _recompose.compose)((0, _recompose.withHandlers)({
  onRemoveAllCrossFiltering: onRemoveAllCrossFiltering,
  onRemoveCrossFiltering: onRemoveCrossFiltering
}));

exports.default = crossFilteringActions;
module.exports = exports['default'];

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Handle when select select all check box
 * @param {Object} props  Components props
 * @param {Object} e      React event
 */
var onSelectAll = function onSelectAll(props, e) {
  var status = (0, _fp.get)('target.checked', e);

  if (status) {
    props.updateSelectedReportParts(props.allReportParts);
  } else {
    props.updateSelectedReportParts([]);
  }
};

/**
 * On clossing cross filter setting popup
 * @param {Object} props component property
 * @param {function} callBack onClosing callback
 * @param {string} type accpet or cancel
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilterSettingAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module CrossFilterSettingAction popup component
 */

var onClosing = function onClosing(props, callBack, type) {
  if (type === 'accept') {
    var reportParts = (0, _fp.getOr)([], 'store.reportBody.activeReportParts', props);
    var reportBody = (0, _fp.getOr)({}, 'store.reportBody', props);
    var originCrossFilteringReportParts = (0, _fp.getOr)([], 'store.reportBody.crossFilteringReportParts', props);
    var selectedReportParts = (0, _fp.getOr)([], 'selectedReportParts', props);

    var changedReport = (0, _fp.difference)(selectedReportParts, originCrossFilteringReportParts);
    if (selectedReportParts.length !== originCrossFilteringReportParts.length || changedReport.length > 0) {
      // reset all drill of all active repports.
      reportBody.removeAllPills();

      (0, _fp.flow)((0, _fp.filter)(function (id) {
        return !(0, _fp.includes)(id, selectedReportParts);
      }), (0, _fp.forEach)(_mobx2.default.action(function (id) {
        var reportPart = (0, _fp.find)({ id: id }, reportParts);
        reportPart.reportPartContent.resetDrilldownInfo && reportPart.reportPartContent.resetDrilldownInfo();
        props.store.needUpdatePreview(reportPart, null, null, null, null, true);
      })))(reportBody.crossFilteringReportParts);

      reportParts.forEach(function (reportPart) {
        var crossFilteringValue = (0, _fp.includes)(reportPart.id, selectedReportParts);
        reportPart.setCrossFiltering(crossFilteringValue);
      });

      props.store.loadReportPartDataByCrossFiltering();
    }

    props.onAccept();
  } else {
    props.onReject();
  }
};

/**
 * On select report part
 * @param {Object} props
 * @param {Object} selectReportPart
 * @param {Object} e
 */
var onSelectReportParts = function onSelectReportParts(props, selectReportPart, e) {
  var status = (0, _fp.get)('target.checked', e);
  var selectedReportParts = props.selectedReportParts;
  if (status) {
    selectedReportParts.push(selectReportPart.value);
  } else {
    selectedReportParts = (0, _fp.without)([selectReportPart.value], selectedReportParts);
  }
  props.updateSelectedReportParts(selectedReportParts);
};

/**
 * Props change when selected report part change
 * @param {*} props
 */
var handleStates = function handleStates(props) {
  var isSelectAll = false;
  var isIndeterminate = false;

  if (props.selectedReportParts.length === props.allReportParts.length) {
    isSelectAll = true;
  } else if (props.selectedReportParts.length !== 0) {
    isIndeterminate = true;
  }

  return {
    isIndeterminate: isIndeterminate,
    isSelectAll: isSelectAll
  };
};

var CrossFilterSettingAction = (0, _recompose.compose)((0, _recompose.withState)('selectedReportParts', 'updateSelectedReportParts', function (props) {
  var selectedReportParts = (0, _fp.flow)((0, _fp.getOr)([], 'store.reportBody.activeReportParts'), (0, _fp.filter)(function (_ref) {
    var headerTitle = _ref.headerTitle,
        reportPartContent = _ref.reportPartContent;
    return !(0, _fp.isEmpty)(headerTitle) && reportPartContent.isCrossFiltering;
  }), (0, _fp.map)(function (reportPart) {
    return reportPart.id;
  }))(props);

  return selectedReportParts;
}), (0, _recompose.mapProps)(function (props) {
  var allReportParts = (0, _fp.flow)((0, _fp.getOr)([], 'store.reportBody.activeReportParts'), (0, _fp.filter)(function (_ref2) {
    var headerTitle = _ref2.headerTitle;
    return !(0, _fp.isEmpty)(headerTitle);
  }), (0, _fp.map)(function (reportPart) {
    return reportPart.id;
  }))(props);

  return (0, _fp.merge)(props, {
    allReportParts: allReportParts
  });
}), (0, _recompose.withPropsOnChange)(['selectedReportParts'], handleStates), (0, _recompose.withHandlers)({
  onSelectAll: (0, _fp.curry)(onSelectAll),
  onClosing: (0, _fp.curry)(onClosing),
  onSelectReportParts: (0, _fp.curry)(onSelectReportParts)
}));

exports.default = CrossFilterSettingAction;
module.exports = exports['default'];

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(16);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _mobxReact2 = _interopRequireDefault(_mobxReact);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda2 = __webpack_require__(1184);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(2);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(1189);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(50);

var _Izenda9 = _interopRequireDefault(_Izenda8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterHeader component
 */

var FilterHeader = function FilterHeader(_ref) {
  var store = _ref.store,
      showFreeze = _ref.showFreeze,
      reportViewerUIStore = _ref.reportViewerUIStore,
      authorization = _ref.authorization,
      authorizationConstants = _ref.authorizationConstants,
      collapseToggle = _ref.collapseToggle,
      openPopup = _ref.openPopup;

  var reportFilters = store.reportFilters || {};
  var headerButtonClass = (0, _classnames2.default)('u_table izenda-FilterHeader__headerButton', {
    'header-button': showFreeze
  });

  var showCrossFilteringOption = authorization.checkPrivileges([authorizationConstants.PERMISSION_KEY.FullReportAndDashboardAccess, authorizationConstants.PERMISSION_KEY.ReportsFilterPropertiesCrossFiltering], authorizationConstants.PERMISSION_OPERATOR.Or);

  var addNewFilter = function addNewFilter() {
    var defaultData = {
      sourceFieldVisible: true,
      sourceFieldFilterable: true
    };
    reportFilters.addFilter.call(reportFilters, defaultData);
    store.reportStore.model.markDirty();
  };

  var onClickFreeze = function onClickFreeze() {
    reportViewerUIStore.doesFreeze = !reportViewerUIStore.doesFreeze;
  };

  var onChangeVisible = function onChangeVisible(e) {
    reportFilters.setVisible(e.target.checked);
  };

  var onCrossFilteringOptionClick = function onCrossFilteringOptionClick() {
    openPopup(_Izenda7.default, {
      store: store
    });
  };

  var removePill = function removePill(pill) {
    return store.removePill.call(store, pill);
  };
  var removeAllPills = function removeAllPills() {
    return store.removeAllPills.call(store);
  };
  var resetCrossFilterDefaultValue = function resetCrossFilterDefaultValue() {
    return store.resetCrossFilterDefaultValue.call(store);
  };
  var freezeLabelBtn = reportViewerUIStore.doesFreeze ? _Izenda9.default.UNFREEZE_BTN_LABEL : _Izenda9.default.FREEZE_BTN_LABEL;

  return _react2.default.createElement(
    'div',
    { className: 'u_table izenda-FilterHeader u_fullWidth' },
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell u_paddingRight u_alignMiddle',
        onClick: collapseToggle },
      _react2.default.createElement('i', { className: 'icon-toggle-thick' }),
      _react2.default.createElement(
        'strong',
        null,
        _Izenda.FIELDS.FILTERS_HEADER_LABEL
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell u_alignMiddle u_textNoWrap' },
      _react2.default.createElement(
        'label',
        { className: 'checkbox-inline' },
        _react2.default.createElement('input', { type: 'checkbox',
          checked: reportFilters.visible,
          onChange: onChangeVisible }),
        _Izenda.FIELDS.SHOW_FILTERS_LABEL
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell u_alignMiddle u_fullWidth izenda-FilterHeader__CrossFilteringContainer' },
      _react2.default.createElement(_Izenda3.default, {
        hadSetting: store.reportBody.hadCrossFilteringSetting,
        crossFilteringDetail: store.reportBody.crossFilteringDetail,
        showCrossFilteringOption: showCrossFilteringOption,
        enableCrossFilteringOption: store.reportBody.enableCrossFiltering,
        enableDeleteAll: store.reportBody.enableDeleteAll,
        removeCrossFiltering: removePill,
        removeAllCrossFiltering: removeAllPills,
        onCrossFilteringOptionClick: onCrossFilteringOptionClick,
        resetDefaultValue: resetCrossFilterDefaultValue })
    ),
    _react2.default.createElement(
      'div',
      { className: headerButtonClass },
      _react2.default.createElement(
        'button',
        { className: 'btn btn-primary', onClick: addNewFilter },
        _Izenda.FIELDS.ADD_FILTER_LABEL
      ),
      showFreeze && _react2.default.createElement(
        'button',
        { className: 'btn btn-primary btn-freeze u_marginLeft', onClick: onClickFreeze },
        freezeLabelBtn
      )
    )
  );
};

exports.default = (0, _Izenda5.default)()(FilterHeader);
module.exports = exports['default'];

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterItem component
 */
!function () {
  var FILTER_CONTROL_CLASS = 'filter-control';

  var CONSTANTS = __webpack_require__(16);

  var m = __webpack_require__(5);
  var compose = __webpack_require__(9).compose;

  var observer = __webpack_require__(10).observer;
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var classnames = __webpack_require__(11);
  var classHelper = __webpack_require__(1170);
  var LayoutUtils = __webpack_require__(153);

  var Input = __webpack_require__(17);
  var GridLayout = __webpack_require__(13);
  var Validator = __webpack_require__(23);
  var QuerySourceDropDown = Validator()(__webpack_require__(1193));
  var DropDown = Validator()(__webpack_require__(29));
  var ReportDesignerWidget = __webpack_require__(188);

  var _require = __webpack_require__(1),
      get = _require.get,
      filter = _require.filter,
      concat = _require.concat;

  var FilterItem = observer(React.createClass({
    displayName: 'FilterItem',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      itemData: React.PropTypes.object.isRequired,
      showPosition: React.PropTypes.bool.isRequired
    },

    componentDidUpdate: function componentDidUpdate() {
      // Reset style filter item when hover out container
      var _props = this.props,
          isOverContainer = _props.isOverContainer,
          itemData = _props.itemData;

      if (isOverContainer === false && itemData.filterItemDom) {
        itemData.filterItemDom.removeAttribute('style');
      }
    },

    setFilterDom: function setFilterDom(domElement) {
      this.props.itemData.filterItemDom = domElement;
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var field = props.itemData;
      var showPosition = props.showPosition;
      var reportFilters = store.reportFilters || {};
      var reportBody = store.reportBody || {};
      var aggregatedFields = reportBody.aggregatedFields || [];
      var filtersCommonData = reportFilters.commonData || {};
      var isVisible = field.sourceFieldVisible && field.sourceFieldFilterable;

      var renderFailIcon = function renderFailIcon() {
        if (isVisible) {
          return null;
        }
        return React.createElement('span', { className: 'icon-attention fail-color', title: CONSTANTS.BUNDLE.TOOLTIP.FILTER.M07 });
      };

      var querySource = filtersCommonData.querySource || [];
      var options = concat(m.toJS(filter({ isRunningField: false, isCompositeField: false }, querySource)), aggregatedFields);
      var parameterOptions = [{ value: field.sourceFieldName, label: field.sourceFieldName }];
      var isParameter = field.isParameter;
      return React.createElement(
        'div',
        {
          className: 'filter-wrapper',
          onMouseDown: this.onClickFilter,
          onTouchStart: this.onClickFilter,
          ref: this.setFilterDom
        },
        React.createElement(
          'div',
          { className: 'filter-control' },
          React.createElement(
            'span',
            { className: 'filter-position' },
            showPosition ? field.position : ''
          ),
          isParameter ? React.createElement(
            'div',
            null,
            React.createElement(DropDown, {
              disabled: true,
              options: parameterOptions,
              value: field.sourceFieldName,
              maskedHidden: !(field.sourceFieldVisible && field.sourceFieldFilterable),
              validations: CONSTANTS.REQUIRED_CONSTRAINT,
              field: 'Filters' + field.uniqueId
            })
          ) : React.createElement(QuerySourceDropDown, {
            options: options,
            disabled: !isVisible,
            filter: field,
            value: field.getFilterId(),
            validations: CONSTANTS.REQUIRED_CONSTRAINT,
            field: 'Filters' + field.uniqueId,
            reportFilters: reportFilters
          }),
          renderFailIcon(),
          isParameter ? null : React.createElement('a', {
            className: 'icon-cancel remove-filter',
            onMouseDown: this.removeFilterItem,
            onTouchStart: this.removeFilterItem
          })
        )
      );
    },

    removeFilterItem: function removeFilterItem(e) {
      e.preventDefault();
      e.stopPropagation();
      var props = this.props;
      var store = props.store;
      var field = props.itemData;
      var reportFilters = store.reportFilters || {};

      if (field.isParameter) {
        return props.confirmFn('Error', {
          description: CONSTANTS.CANNOT_DELETE_PARAM_SP,
          showCancel: false
        });
      }

      store.updateReportDesignerCascadingFilter(field);
      reportFilters.removeFilter && reportFilters.removeFilter(field);
      store.reportFilters.setConfigModeToField(null);
      props.validation.validate();
    },

    onClickFilter: m.action(function (e) {
      var props = this.props;

      if (classHelper.hasClass(e.target.className, 'remove-filter')) {
        return this.removeFilterItem(e);
      }

      if (e.target.className.indexOf('izenda-Dropdown') > -1) {
        return;
      }

      LayoutUtils.togglePropertiesEditor(true);
      props.onClick && props.onClick(arguments);
    })
  }));

  var FilterItemContainer = observer(function (props) {
    var field = props.itemData;
    var classes = classnames(props.className, 'u_noPaddingAll', {
      'selected-filter-item': props.isRegistedItem && isConfigField()
    });

    return React.createElement(
      GridLayout.Col,
      { className: classes, cols: '3' },
      React.createElement(FilterItem, (0, _extends3.default)({}, props, { checkRegistedItem: isConfigField }))
    );

    function isConfigField() {
      return props.itemData === get('reportFilters.configField.fieldDetails', props.store);
    }
  });

  module.exports = ReportDesignerWidget.wrapper(FilterItemContainer);
}();

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(23);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(17);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(37);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorInput = (0, _Izenda5.default)()(_Izenda7.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.FiltersFooter.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterItem component
 */

exports.default = (0, _Izenda2.default)()(function FiltersFooter(props) {
  var store = props.store || {};
  var reportFilters = store.reportFilters || {};
  var valManager = props.validation;

  var onChangeLogic = function onChangeLogic(e) {
    reportFilters.setLogic(e.target.value);
  };

  var onValidateSyntax = function onValidateSyntax() {
    var alertDetails = store.getAlertDetail();

    alertDetails.reset(false);

    valManager.reset('filterLogic');
    return store.validateFilterSyntax().then(function (saveErrors) {
      if (!(0, _fp.isEmpty)(saveErrors)) {
        if (saveErrors === _Izenda3.FIELDS.M24) {
          return props.confirmFn('Information', {
            type: _Izenda9.default.MESSAGE_TYPE.INFO_ACCEPT,
            description: _Izenda3.FIELDS.M24,
            showCancel: false
          }).then(function () {
            return props.confirmFn('Information', {
              type: _Izenda9.default.MESSAGE_TYPE.INFO_ACCEPT,
              description: _Izenda3.FIELDS.M25,
              showCancel: false
            }).then(function () {
              return reportFilters.setLogic('');
            });
          });
        } else {
          valManager.updateErrors(saveErrors);
        }
      } else {
        alertDetails.set({ message: _Izenda3.FIELDS.VALID_FILTER_LOGIC_MESSAGE, success: true });
      }
      return null;
    });
  };

  return _react2.default.createElement(
    'div',
    { className: 'u_table' },
    _react2.default.createElement(
      'span',
      { className: 'u_tableCell control-label' },
      _Izenda3.FIELDS.FILTER_LOGIC_LABEL
    ),
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell u_fullWidth' },
      _react2.default.createElement(ValidatorInput, {
        value: reportFilters.logic,
        placeholder: _Izenda3.FIELDS.FILTER_LOGIC_PLACEHOLDER,
        onChange: onChangeLogic,
        className: 'form-control u_inlineBlock',
        containerClassName: '',
        validations: {},
        maxLength: '2000',
        field: 'filterLogic'
      })
    ),
    _react2.default.createElement(
      'button',
      { className: 'btn btn-primary u_tableCell u_marginLeft', onClick: onValidateSyntax },
      _Izenda3.FIELDS.VALIDATE_SYNTAX_LABEL
    )
  );
});
module.exports = exports['default'];

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RightPanel.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Right Panel component for Report designer
 */
!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var RightPanel = React.createClass({
    displayName: 'RightPanel',

    getDefaultProps: function getDefaultProps() {
      return {
        initState: true
      };
    },

    getInitialState: function getInitialState() {
      return {
        isExpanded: this.props.initState
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState({
        isExpanded: nextProps.initState
      });
    },

    toggleRightPanel: function toggleRightPanel(newState) {
      if (!isNil(newState) && newState === this.state.isExpanded) {
        return;
      }
      this.setState({
        isExpanded: newState !== undefined ? newState : !this.state.isExpanded
      });
    },

    render: function render() {
      var sectionClass = classnames({
        'izenda-RightPanel': true,
        expanded: this.state.isExpanded,
        collapsed: !this.state.isExpanded
      });

      return React.createElement(
        'div',
        { className: sectionClass, 'aria-expanded': 'false' },
        React.createElement(
          'div',
          { className: 'u_marginRight u_fullHeight u-bgWhite u-posRelative' },
          this.renderCollapsibleSection(),
          React.createElement(
            'section',
            { className: this.props.className },
            this.props.children
          )
        )
      );
    },

    renderCollapsibleSection: function renderCollapsibleSection() {
      var iconClass = classnames({
        'collapse-icon': true,
        'icon-right-open': this.state.isExpanded,
        'icon-left-open': !this.state.isExpanded
      });

      return React.createElement(
        'div',
        { className: 'collapsible' },
        React.createElement('i', { className: iconClass, onClick: toggleRightPanel.bind(this) }),
        React.createElement(
          'span',
          { className: 'u_textBold' },
          this.props.title
        )
      );

      function toggleRightPanel() {
        return this.toggleRightPanel();
      }
    }
  });

  module.exports = RightPanel;
}();

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerPropertiesEditors.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Designer Properties Editors component
 */
!function () {
  var m = __webpack_require__(5);

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var ReportsConstants = __webpack_require__(50);

  var PropertiesEditorTabsContainer = __webpack_require__(2621);
  var ReportDesignerWidget = __webpack_require__(188);
  var PropertiesEditorUtils = __webpack_require__(187);
  var PropertiesEditorManager = __webpack_require__(157);

  var FilterPropsContainerSchema = __webpack_require__(2622);
  var ReportPartFieldPropsContainerSchema = __webpack_require__(555);
  var ReportPartPropsContainerSchema = __webpack_require__(2626);
  var ReportPartFormatPropsSchema = __webpack_require__(582);

  var _require = __webpack_require__(1),
      get = _require.get,
      getOr = _require.getOr,
      isNil = _require.isNil,
      concat = _require.concat;

  function getTabList(reportDesingerModel, fieldStore, props) {
    var context = this;
    props = props || {};
    var localization = props.localization;

    context.fieldEditor = context.fieldEditor || 'fieldProps';

    return {
      filterProps: {
        title: localization.getText('COMMON_LABEL_FILTER_PROPERTIES'),
        defaultSchema: FilterPropsContainerSchema
      },

      dataSourceFieldProps: {
        title: localization.getText('COMMON_LABEL_FIELD_PROPERTIES'),
        onRender: function onRender() {
          context.fieldEditor = 'dataSourceFieldProps';
        },
        isShow: function isShow() {
          return !props.dataSourceMode && context.fieldEditor === 'dataSourceFieldProps';
        }
      },

      fieldProps: {
        title: localization.getText('COMMON_LABEL_FIELD_PROPERTIES'),
        defaultSchema: ReportPartFieldPropsContainerSchema,
        onRender: function onRender() {
          context.fieldEditor = 'fieldProps';
        },
        beforeRender: function beforeRender(activeEditor, editorInfo) {
          // show backSide of config report part
          var reportBody = get('reportFields.reportBody', reportDesingerModel);
          var configReportPart = getOr({}, 'configReportPart', reportBody);

          !isNil(get('type', configReportPart)) && reportBody.changeReportPartSide(configReportPart, true);
        },

        isShow: function isShow() {
          return !props.dataSourceMode && context.fieldEditor === 'fieldProps';
        }
      },

      reportPartProps: {
        title: localization.getText('REPORTDESIGNER_LABEL_REPORT_PART_PROPERTIES'),
        defaultSchema: ReportPartPropsContainerSchema,
        isShow: function isShow() {
          return !props.dataSourceMode;
        }
      },

      formatItemProps: {
        title: localization.getText('REPORTDESIGNER_LABEL_FORMAT_PROPERTIES'),
        defaultSchema: ReportPartFormatPropsSchema,
        isShow: function isShow() {
          return !props.dataSourceMode && (fieldStore.isVisibleHeaderFooter || fieldStore.isVisibleTitleDescription);
        }
      }
    };
  }

  var ReportDesignerPropertiesEditors = React.createClass({
    displayName: 'ReportDesignerPropertiesEditors',

    componentWillMount: function componentWillMount() {
      var props = this.props;
      var store = props.fieldStore;

      this.configReportPartId;

      // tracking - add new filter >> switch to filter tab (show filter editor)
      this.configFilterAction = m.reaction(function () {
        return get('reportFilters.newestFilter', store);
      }, switchToFilterTab);

      // tracking - add new element to report part >> switch to [report part field properties] tab (show report part field editor)
      this.configReportPartFieldAction = m.reaction(function () {
        return get('reportBody.configReportPart.newestField', store);
      }, switchToReportPartField.bind(this));

      function switchToFilterTab(newestFilter) {
        if (!newestFilter) {
          return;
        }

        var reportFilters = get('reportFilters', store);
        newestFilter = get('newestFilter', reportFilters);

        PropertiesEditorUtils.switchToEditor(null, {
          itemData: newestFilter,
          beforeShowProps: function beforeShowProps() {
            reportFilters.setConfigModeToField(newestFilter);
          }
        }, [{ name: 'filterProps' }]);
      }

      function switchToReportPartField(newestField) {
        if (!newestField) {
          return;
        }

        var configReportPart = getOr({}, 'reportBody.configReportPart', store);
        newestField = get('newestField', configReportPart);

        if (this.configReportPartId !== configReportPart.id) {
          this.configReportPartId = configReportPart.id;
          return;
        }

        PropertiesEditorUtils.switchToEditor(null, {
          itemData: newestField,
          beforeShowProps: function beforeShowProps() {
            configReportPart && configReportPart.setConfigField(newestField);
          }
        }, [{
          name: 'fieldProps',
          getDefinedSchema: ReportPartFieldPropsContainerSchema
        }]);
      }
    },

    componentWillUnmount: function componentWillUnmount() {
      this.configFilterAction();
      this.configReportPartFieldAction();
    },

    render: function render() {
      var props = this.props;

      var defaultParams = [props.reportDesignerModel, props.fieldStore];
      var tabList = getTabList.apply(this, concat(defaultParams, props));

      return React.createElement(PropertiesEditorTabsContainer, {
        className: 'horizontal-tabs',
        defaultParams: defaultParams,
        editors: tabList,
        onChangeActiveEditor: props.onActiveEditor
      });
    }
  });

  module.exports = connect()(ReportDesignerPropertiesEditors);
}();

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditorTabsContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(78);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(157);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(268);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(131);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var PropertiesEditorTabsContainer = (_dec = (0, _Izenda2.default)(), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(PropertiesEditorTabsContainer, _Component);

  function PropertiesEditorTabsContainer(props) {
    (0, _classCallCheck3.default)(this, PropertiesEditorTabsContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PropertiesEditorTabsContainer.__proto__ || (0, _getPrototypeOf2.default)(PropertiesEditorTabsContainer)).call(this, props));

    _initialiseProps.call(_this);

    var editors = props.editors,
        defaultParams = props.defaultParams;


    _this.propConfigByTabs = {};

    var defaultConfigByTabs = _Izenda6.default.addEditor(_this, editors, defaultParams);
    $izenda.extend(_this.propConfigByTabs, defaultConfigByTabs);
    return _this;
  }

  /**
   * List of editor are registed, first editor will be show as active tab
   * @param {[Array]} editorsInfo
   */


  (0, _createClass3.default)(PropertiesEditorTabsContainer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // reset config of all editor-properties
      this.propConfigByTabs = {};
      _Izenda6.default.resetEditor(this.props.editors);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          editors = _props.editors,
          className = _props.className;

      var isResponsive = _Izenda4.default.isMobileDevice();
      var propConfigByTabs = this.propConfigByTabs;

      (0, _fp.invoke)('onRender', editors[this.activeTab]);

      return _react2.default.createElement(
        _Izenda9.Tabs,
        {
          activeTabKey: this.activeTab,
          className: className,
          isResponsive: isResponsive,
          canChangeTab: canChangeTab,
          beforeChangeTab: this.beforeRender,
          onChange: this.afterRender
        },
        (0, _fp.map)(renderTab, getShowingTabNames(editors))
      );

      function getShowingTabNames(editors) {
        var editorNames = (0, _fp.keys)(editors);

        return (0, _fp.filter)(function (name) {
          return (0, _fp.has)('isShow', editors[name]) ? (0, _fp.invoke)('isShow', editors[name]) : true;
        }, editorNames);
      }

      function canChangeTab() {
        var nextTab = (0, _fp.last)(arguments);

        return _Izenda6.default.canSwitch([{
          name: nextTab
        }]);
      }

      function renderTab(tabKey) {
        var tabInfo = editors[tabKey];

        if ((0, _fp.has)('isShow', tabInfo) && !tabInfo.isShow()) {
          return null;
        }

        var classes = (0, _classnames2.default)({
          'tab-properties': !isResponsive
        });

        return _react2.default.createElement(
          _Izenda9.Tab,
          { title: tabInfo.title, tabKey: tabKey, key: tabKey, headerClassName: classes },
          _react2.default.createElement(_Izenda8.default, {
            className: 'u_fullHeight izenda-PropertiesContainer',
            propertyConfig: propConfigByTabs[tabKey]
          })
        );
      }
    }
  }]);
  return PropertiesEditorTabsContainer;
}(_react.Component), _class3.propTypes = {
  editors: _propTypes2.default.object.isRequired,
  defaultParams: _propTypes2.default.array,
  onChangeActiveEditor: _propTypes2.default.func,
  onSetActiveEditor: _propTypes2.default.func
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setEditorInfo = function (editorInfo) {
    _this2.editorInfo = editorInfo;
  };

  this.setPropertySchemas = function (editorId, editorsInfo, activeEditor) {
    var propConfigByTabs = _this2.propConfigByTabs,
        props = _this2.props;


    editorsInfo = editorsInfo || [];

    editorsInfo.forEach(function (editor) {
      editor.schemaDef && (propConfigByTabs[editor.name] = editor.schemaDef);
    });

    _this2.editorId = editorId;
    _this2.activeTab = activeEditor;

    props.onSetActiveEditor && props.onSetActiveEditor(_this2.activeTab);
    props.onChangeActiveEditor && props.onChangeActiveEditor(_this2.activeTab);
  };

  _initDefineProp(this, 'beforeRender', _descriptor, this);

  _initDefineProp(this, 'afterRender', _descriptor2, this);
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'beforeRender', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (newActiveEditor) {
      var editors = _this3.props.editors;

      var propsEditorId = _Izenda6.default.findEditorId([{
        name: newActiveEditor
      }]);

      _Izenda6.default.takeAction.call(null, propsEditorId, 'beforeRender', newActiveEditor, editors[newActiveEditor]);
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'afterRender', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (index, selectedPanel, selectedTabMenu, activeTabKey) {
      var props = _this4.props,
          editors = _this4.props.editors;


      var propsEditorId = _Izenda6.default.findEditorId([{
        name: activeTabKey
      }]);

      props.onChangeActiveEditor && props.onChangeActiveEditor(activeTabKey);

      _Izenda6.default.takeAction.call(null, propsEditorId, 'afterRender', activeTabKey, editors[activeTabKey]);
      _Izenda6.default.setActiveEditor(activeTabKey);
    };
  }
})), _class2)) || _class);
exports.default = PropertiesEditorTabsContainer;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterPropsContainerSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  __webpack_require__(55);

  var MESSAGES = __webpack_require__(16).BUNDLE.MESSAGE;

  var SCHEMA_DEF = {
    title: '',
    component: 'FilterPropsContainer',
    props: {
      reportDesignerModel: 'reportDesignerModel',
      fieldStore: 'fieldStore'
    },
    fields: {}
  };

  var WIDGETS = {
    FilterPropsContainer: __webpack_require__(2623)
  };

  module.exports = function (editorComp, reportDesignerModel, fieldStore) {
    //var configField = itemProps.itemData;

    ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

    return {
      // define data to render UI
      definedSchema: SCHEMA_DEF,

      // list of widgets which are used to render UI
      widgets: WIDGETS,

      // properties for different fields
      mappingProps: {
        reportDesignerModel: reportDesignerModel,
        fieldStore: fieldStore
      },

      // defined-function which fields need to execute to get its data
      mappingSource: {},

      onChangeValue: function onChangeValue(schemaData, changedKey, changedKeyPath, changedOthersInfo) {}
    };
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterPropsContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterPropsContainer component
 */
!function () {
  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);

  var withProps = __webpack_require__(9).withProps;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var withState = __webpack_require__(9).withState;
  var withHandlers = __webpack_require__(9).withHandlers;

  var branch = __webpack_require__(9).branch;
  var renderComponent = __webpack_require__(9).renderComponent;

  var React = __webpack_require__(0);
  var FormGroup = __webpack_require__(122);
  var DropDown = __webpack_require__(29);
  var ScrollBox = __webpack_require__(27);

  var PropertiesEditorContainer = __webpack_require__(268);
  var ReportDesignerConstants = __webpack_require__(16);
  var PropertiesEditorUtils = __webpack_require__(187);
  var FilterPropertiesSchema = __webpack_require__(2624);
  var classnames = __webpack_require__(11);
  var ToggleViewModePropertyEditor = __webpack_require__(568);
  var compare = __webpack_require__(422);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      getOr = _require.getOr,
      isNil = _require.isNil,
      curry = _require.curry;

  // show title of group only


  var UNUSED_PROPS_NULL_CONFIG_FILTER = ['fields.sourceInfo.fields', 'fields.filterOperator.fields', 'fields.filterSettings.fields', 'fields.filterFormating.fields'];

  var FilterPropsContainer = observer(function (props) {
    var localization = props.localization;

    var configFilter = props.getConfigFilter();
    var configFilterValue = getValue(configFilter.fieldDetails);

    return React.createElement(
      'section',
      { className: 'form-horizontal field-props-container' },
      React.createElement(
        'div',
        { className: 'field-props-header' },
        React.createElement(
          'div',
          { className: 'title-group' },
          React.createElement(
            'strong',
            { className: 'u_textUppercase u_inlineBlock' },
            localization.getText('COMMON_LABEL_FILTER_PROPERTIES')
          ),
          React.createElement(ToggleViewModePropertyEditor, null)
        ),
        React.createElement(
          FormGroup,
          { className: 'report-parts' },
          React.createElement(DropDown, {
            blankOption: true,
            options: props.getFilterList(),
            valueField: getValue,
            labelField: getLabel,
            onChange: onChangeFilter,
            value: configFilterValue
          })
        )
      ),
      React.createElement(
        'fieldset',
        { disabled: isNil(configFilterValue), className: 'field-props-content' },
        React.createElement(
          ScrollBox,
          null,
          React.createElement(FilterDetailsContainer, {
            alias: props.reportFilter.configField.fieldDetails.alias,
            reportDesignerModel: props.reportDesignerModel,
            fieldStore: props.fieldStore,
            reportFilter: props.reportFilter,
            validation: props.validation,
            querySourceFieldId: configFilter.fieldDetails.querySourceFieldId
          })
        )
      )
    );

    function onChangeFilter(val, item) {
      var args = arguments;
      return props.validation.validate().then(function (isValid) {
        if (isValid) {
          props.setFilterConfig.apply(null, args);
        } else {
          throw new Error('error');
        }
      });
    }

    function getLabel(filter) {
      return filter ? [String.format('[{0}]', filter.position), filter.alias].join(' ') : '';
    }

    function getValue(filter) {
      return filter ? [filter.position, filter.alias].join('') : null;
    }
  });

  FilterPropsContainer.displayName = 'FilterPropsContainer';

  var FilterDetailsContainer = observer(React.createClass({
    displayName: 'FilterDetailsContainer',

    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return nextProps.querySourceFieldId !== this.props.querySourceFieldId;
    },

    render: function render() {
      var props = this.props;
      var valManager = props.validation;
      var propConfig = FilterPropertiesSchema(this, props.reportDesignerModel, props.fieldStore, props.reportFilter, valManager);

      isEmpty(props.alias) && removeUsedProps(propConfig);

      return React.createElement(PropertiesEditorContainer, { propertyConfig: propConfig });

      function removeUsedProps(propConfig) {
        PropertiesEditorUtils.removeProps(propConfig, UNUSED_PROPS_NULL_CONFIG_FILTER);
      }
    }
  }));

  FilterDetailsContainer.displayName = 'FilterDetailsContainer';

  function setFilterConfig(props, seletedItem, newConfigField) {
    var reportFilter = props.reportFilter;
    reportFilter.setConfigModeToField && reportFilter.setConfigModeToField(newConfigField);
  }

  function getFilterList(props) {
    return function () {
      var reportFilter = props.reportFilter;
      return getOr([], 'filterFields', reportFilter);
    };
  }

  function getConfigFilter(props) {
    return function () {
      var reportFilter = props.reportFilter;
      return getOr(null, 'configField', reportFilter);
    };
  }

  module.exports = connect(setPropTypes({
    reportDesignerModel: React.PropTypes.object.isRequired,
    fieldStore: React.PropTypes.object.isRequired
  }), withProps(function (props) {
    var reportFilter = getOr({}, 'reportFields.reportFilter', props.reportDesignerModel);
    var configFilter = reportFilter.configField;

    return {
      reportFilter: reportFilter
    };
  }), withHandlers({
    setFilterConfig: curry(setFilterConfig),
    getFilterList: curry(getFilterList),
    getConfigFilter: curry(getConfigFilter)
  }))(FilterPropsContainer);
}();

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

exports.default = getFilterSchema;

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(2625);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(264);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(155);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(106);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(12);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(1193);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(28);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(628);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(266);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(186);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(566);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _Izenda24 = __webpack_require__(267);

var _Izenda25 = _interopRequireDefault(_Izenda24);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WIDGETS = {
  QuerySourceDropDown: _Izenda13.default,
  Panel: _Izenda15.default,
  OperatorGroup: _Izenda17.default,
  FontStyle: _Izenda19.default,
  FontFormat: _Izenda21.default,
  ButtonHighlight: _Izenda23.default,
  ColorStyling: _Izenda25.default
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterPropertiesSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function getFilterSchema(editorComp, reportDesignerModel, fieldStore, reportFilter, valManager) {
  ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

  var configField = reportFilter.configField || {};

  var validateFilterAlias = function validateFilterAlias(newName) {
    var isExisting = reportFilter.checkExistingFilter && reportFilter.checkExistingFilter(newName, reportFilter.configField.fieldDetails);

    var formatGroup = (0, _fp.find)(function (item) {
      return item.value === _Izenda9.default.FORMAT_GROUP_CONFIG.FILTER;
    }, _Izenda9.default.FORMAT_GROUP) || {};
    var formatGroupName = formatGroup.label;
    var message = String.format(_Izenda9.default.MESSAGES.M01, formatGroupName);

    return (0, _bluebird.resolve)(isExisting ? message : '');
  };

  return {
    // define data to render UI
    definedSchema: _Izenda2.default,

    // list of widgets which are used to render UI
    widgets: WIDGETS,

    // data to binding to fields
    source: configField,

    // properties for different fields
    mappingProps: {
      validateItemValue: function validateItemValue() {
        valManager.validate().then(function (success) {
          success && valManager.reset();
          return success;
        });
      },

      configField: configField,

      fieldDetails: configField.fieldDetails,

      updateSourceValue: fieldStore.getOperatorValueSource && fieldStore.getOperatorValueSource.bind(fieldStore),

      filterAliasInputType: configField.fieldDetails.sourceFieldFilterable && configField.fieldDetails.sourceFieldVisible ? 'text' : 'password',

      isFilterAliasDisabled: configField.fieldDetails.sourceFieldFilterable === false || configField.fieldDetails.sourceFieldVisible === false,

      isParameter: configField.fieldDetails.isParameter,

      fieldStore: fieldStore,

      reportFilters: fieldStore.reportFilters,

      isDisableCascading: configField.fieldDetails.isDisableCascading,

      getSortTypeValue: function getSortTypeValue() {
        return configField.fieldDetails;
      }
    },

    // defined-function which fields need to execute to get its data
    mappingSource: {
      getAliasValidation: function getAliasValidation() {
        return {
          presence: {
            presence: true,
            message: _Izenda11.default.getText('FILTER_PROPERTIES_MESSAGE_FILTER_ALIAS_VALUE_REQUIRED')
          },
          action: (0, _mobx.asReference)(function () {
            return validateFilterAlias;
          })
        };
      },

      getQuerySource: function getQuerySource() {
        var querySource = reportFilter.commonData && reportFilter.commonData.querySource;
        querySource && (0, _fp.forEach)(function (item) {
          return item.groupByValue = String.format('{0}.{1}.{2}', item.connectionName, item.querySourceCategoryName, item.sourceDataObjectName);
        }, querySource);

        // Add aggregated Fields
        var reportBody = fieldStore.reportBody || {};
        var aggregatedFields = reportBody.aggregatedFields || [];
        return (0, _fp.concat)((0, _mobx.toJS)(querySource), aggregatedFields);
      },

      getQuerySourceValue: function getQuerySourceValue() {
        return configField.fieldDetails.getFilterId && configField.fieldDetails.getFilterId();
      },
      getDataFormat: function getDataFormat() {
        var fieldDetails = configField.fieldDetails || {};
        return fieldStore.loadDataType(fieldDetails.dataType);
      },
      getFontStyle: function getFontStyle() {
        return {
          fontBold: !!configField.getValueByKey('fontBold'),
          fontItalic: !!configField.getValueByKey('fontItalic'),
          fontUnderline: !!configField.getValueByKey('fontUnderline')
        };
      },
      getFontFormat: function getFontFormat() {
        return {
          fontFamily: configField.getValueByKey('fontFamily'),
          fontSize: configField.getValueByKey('fontSize')
        };
      },
      getColorStyling: function getColorStyling() {
        return {
          textColor: configField.getValueByKey('textColor'),
          backgroundColor: configField.getValueByKey('backgroundColor')
        };
      },

      getFilterAlias: function getFilterAlias() {
        return configField.getValueByKey('alias');
      },
      getDataFormats: function getDataFormats() {
        var fieldDetails = configField.fieldDetails || {};
        var dataType = fieldDetails.dataType;

        return _Izenda7.default.loadFilterDataFormat(dataType).then(function (formats) {
          return (
            // filter date time format that current user setting can supported
            dataType !== _Izenda3.DATA_TYPES.DATE_TIME ? formats : _Izenda5.default.filterDateTimeFormat(formats)
          );
        });
      },

      isAggregatedField: function isAggregatedField() {
        return !!configField.fieldDetails.reportPartTitle;
      },
      isPhysicalField: function isPhysicalField() {
        return !configField.fieldDetails.reportPartTitle;
      },
      isFilterFormatingHidden: function isFilterFormatingHidden() {
        return !reportFilter.visible;
      },
      isHiddenUseLookup: function isHiddenUseLookup() {
        return !(0, _fp.get)('filterInfo.operator.allowLookup', configField) || !configField.fieldDetails.showUseLookupCheckbox;
      }
    },

    // mapping data from editor to report-designer- model
    onChangeValue: function onChangeValue(schemaData, key, changedKeyPath, changedValue) {
      var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
      var fieldData = groupData[key];

      fieldData && (fieldData.value = changedValue);

      var sourceInfo = schemaData.sourceInfo || {};
      var filterSettings = schemaData.filterSettings || {};
      var filterFormating = schemaData.filterFormating || {};
      var filterOperator = schemaData.filterOperator || {};

      var fontFormat = filterFormating.fontFormat.value || {};
      var fontStyle = filterFormating.fontStyle.value || {};
      var color = filterFormating.color.value || {};

      configField.fieldDetails.setFilterDetails && configField.fieldDetails.setFilterDetails({
        // Source Info value
        sourceDataObjectName: sourceInfo.sourceDataObjectName.value,
        querySourceType: sourceInfo.querySourceType.value,
        querySourceFieldId: configField.fieldDetails.querySourceFieldId,

        // Filter lookup setting
        filterLookupType: configField.fieldDetails.filterLookupType,
        filterLookupStatus: configField.fieldDetails.filterLookupStatus,
        useLookup: filterOperator.useLookup.value,

        // Filter Settings Details
        alias: filterSettings.alias.value,
        visible: filterSettings.visible.value,
        required: filterSettings.required.value,
        cascading: filterSettings.cascading.value,
        sortType: filterSettings.sortType.value,

        // Filter Formating Details
        dataFormatId: filterFormating.dataFormatId.value,

        fontFamily: fontFormat.fontFamily,
        fontSize: fontFormat.fontSize,

        fontBold: fontStyle.fontBold,
        fontItalic: fontStyle.fontItalic,
        fontUnderline: fontStyle.fontUnderline,

        textColor: color.textColor,
        backgroundColor: color.backgroundColor
      });

      // update source filter when change sort type settings
      if (key === 'sortType') {
        fieldStore.getOperatorValueSource(configField);
      }

      // Update disable cascading and reset filter source when use lookup of a field is change
      if (key === 'useLookup') {
        reportFilter.disableCascading();
        configField.resetOperatorSourceDisplay();
      }
    }
  };
}
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  schemaKey: 'FILTER_PROPERTIES',
  fields: {
    sourceInfo: {
      component: 'Panel',
      props: {
        disabled: 'isFilterAliasDisabled'
      },
      staticProps: {
        initState: true,
        collapsible: true,
        header: {
          title: 'Source',
          icon: 'icon-toggle-triangle'
        },
        className: 'u_fullWidth'
      },

      fields: {
        querySourceType: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_TYPE');
          },
          isHidden: 'isAggregatedField',
          type: 'static',
          fnValue: 'getValueByKey',
          props: {
            hiddenByState: true
          }
        },

        sourceDataObjectName: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_NAME');
          },
          isHidden: 'isAggregatedField',
          type: 'static',
          fnValue: 'getValueByKey',
          props: {
            hiddenByState: true
          }
        },

        querySourceFieldId: {
          get title() {
            return _Izenda2.default.getText('FILTER_PROPERTIES_SCHEMA_LABEL_FILTER_NAME');
          },
          isHidden: 'isAggregatedField',
          fnValue: 'getQuerySourceValue',
          component: 'QuerySourceDropDown',
          props: {
            filter: 'fieldDetails',
            options: 'getQuerySource',
            reportFilters: 'reportFilters'
          }
        },

        reportPartTitle: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_REPORT_PART');
          },
          isHidden: 'isPhysicalField',
          type: 'static',
          fnValue: 'getValueByKey'
        },

        querySourceAggregatedField: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_FIELD_NAME');
          },
          isHidden: 'isPhysicalField',
          fnValue: 'getQuerySourceValue',
          component: 'QuerySourceDropDown',
          props: {
            filter: 'fieldDetails',
            options: 'getQuerySource'
          }
        }
      }
    },

    filterOperator: {
      component: 'Panel',
      staticProps: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('FILTER_PROPERTIES_SCHEMA_LABEL_FILTER_OPERATOR');
          },
          icon: 'icon-toggle-triangle'
        },
        className: 'u_fullWidth'
      },
      props: {
        disabled: 'isFilterAliasDisabled'
      },
      fields: {
        filterDetailOperator: {
          component: 'OperatorGroup',
          usingGroup: true,
          props: {
            configField: 'configField',
            updateSourceValue: 'updateSourceValue',
            reportFilters: 'reportFilters',
            store: 'fieldStore',
            isLazyLoading: true
          }
        },
        useLookup: {
          type: 'checkbox',
          fnValue: 'getValueByKey',
          get title() {
            return _Izenda2.default.getText('FILTER_PROPERTIES_SCHEMA_LABEL_USE_LOOKUP');
          },
          isHidden: 'isHiddenUseLookup'
        }
      }
    },

    filterSettings: {
      component: 'Panel',
      staticProps: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('FILTER_PROPERTIES_SCHEMA_LABEL_FILTER_SETTINGS');
          },
          icon: 'icon-toggle-triangle'
        },
        className: 'u_fullWidth'
      },
      props: {
        disabled: 'isFilterAliasDisabled'
      },
      fields: {
        alias: {
          get title() {
            return _Izenda2.default.getText('FILTER_PROPERTIES_SCHEMA_LABEL_FILTER_ALIAS');
          },
          type: 'text',
          fnValue: 'getFilterAlias',
          props: {
            type: 'filterAliasInputType',
            disabled: 'isFilterAliasDisabled',
            isMasked: 'isFilterAliasDisabled',
            validations: 'getAliasValidation',
            field: 'alias',
            onBlur: 'validateItemValue'
          }
        },
        visible: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_VISIBLE');
          },
          type: 'checkbox',
          fnValue: 'getValueByKey'
        },
        required: {
          get title() {
            return _Izenda2.default.getText('COMMON_CONSTRAINT_REQUIRED');
          },
          type: 'checkbox',
          fnValue: 'getValueByKey'
        },
        cascading: {
          get title() {
            return _Izenda2.default.getText('FILTER_PROPERTIES_SCHEMA_LABEL_CASCADING');
          },
          type: 'checkbox',
          fnValue: 'getValueByKey',
          disabledInfo: _Izenda2.default.getText('COMMON_LABEL_CONTROL_DISABLE_INFO'),
          props: {
            hiddenByState: true,
            disabled: 'isDisableCascading'
          }
        },
        sortType: {
          get title() {
            return _Izenda2.default.getText('FILTER_PROPERTIES_SCHEMA_LABEL_SORT');
          },
          component: 'ButtonHighlight',
          fnValue: 'getValueByKey',
          staticProps: {
            defaultIcon: 'icon-unsort'
          },
          props: {
            loadValue: 'getSortTypeValue',
            propertyKey: 'sortType',
            hiddenByState: true,
            get description() {
              return _Izenda2.default.getText('FILTER_PROPERTIES_SCHEMA_LABEL_SORT');
            },
            disabledIcon: 'icon-unsort',
            states: [{ value: 'ASC', icon: 'icon-sort-name-up' }, { value: 'DESC', icon: 'icon-sort-name-down' }]
          }
        }
      }
    },

    filterFormating: {
      component: 'Panel',
      isHidden: 'isFilterFormatingHidden',
      props: {
        disabled: 'isFilterAliasDisabled'
      },
      staticProps: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('FILTER_PROPERTIES_SCHEMA_LABEL_FILTER_FORMATTING');
          },
          icon: 'icon-toggle-triangle'
        },
        className: 'u_fullWidth'
      },

      fields: {
        dataFormatId: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_FORMAT');
          },
          type: 'select',
          fnValue: 'getValueByKey',
          props: {
            options: 'getDataFormats',
            labelField: 'name',
            valueField: 'id',
            groupBy: 'category',
            showTooltip: true,
            blankOption: true,
            blankOptionText: '...'
          }
        },

        // font family + font size
        fontFormat: {
          get title() {
            return _Izenda2.default.getText('FONT_SETTINGS_LABEL_FONT');
          },
          component: 'FontFormat',
          fnValue: 'getFontFormat'
        },

        // bold, italic, underline
        fontStyle: {
          title: '',
          component: 'FontStyle',
          fnValue: 'getFontStyle'
        },

        color: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_COLOR');
          },
          component: 'ColorStyling',
          fnValue: 'getColorStyling',
          props: {
            type: 'photoshop',
            position: 'left',
            disabled: 'isFilterAliasDisabled'
          }
        }
      }
    }
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.FilterPropertiesSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(16);

var _Izenda2 = __webpack_require__(187);

var _Izenda3 = __webpack_require__(2627);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGES = _Izenda.BUNDLE.MESSAGES; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPropsContainerSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var SCHEMA_DEF = {
  title: '',
  component: 'ReportPartPropsContainer',
  props: {
    reportDesignerModel: 'reportDesignerModel',
    fieldStore: 'fieldStore'
  },
  fields: {}
};

var WIDGETS = {
  ReportPartPropsContainer: _Izenda4.default
};

/**
 * Create report part properties editor container schema
 */

exports.default = function (editorComp, reportDesignerModel, fieldStore) {
  ensure(!!reportDesignerModel, 'reportDesignerModel must be set');
  var mappingProps = { reportDesignerModel: reportDesignerModel, fieldStore: fieldStore };
  return (0, _Izenda2.createSchema)(SCHEMA_DEF, WIDGETS, mappingProps);
};

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPropsContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(142);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(28);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(122);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(29);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(27);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(268);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(16);

var _Izenda16 = __webpack_require__(568);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(2628);

var _Izenda19 = _interopRequireDefault(_Izenda18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Properties editor container of Report Part.
 * This component displays the report part's properties in Properties editor panel of Report Designer
 */
var ReportPartPropsContainer = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartPropsContainer, _Component);

  function ReportPartPropsContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportPartPropsContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportPartPropsContainer.__proto__ || (0, _getPrototypeOf2.default)(ReportPartPropsContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeReportPart = function (selectedPartTitle, selectedPart) {
      var reportBody = (0, _fp.get)('reportDesignerModel.reportFields.reportBody', _this.props);
      ensure(!!reportBody, 'Cannot find report body inside report designer model bound to the properties editor');

      reportBody.setConfigReportPart(selectedPart);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReportPartPropsContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          reportDesignerModel = _props.reportDesignerModel,
          localization = _props.localization;

      var options = this.getAccessibleReportParts(reportDesignerModel.supportReportParts);
      var configReportPartId = (0, _fp.get)('configReportPart.id', reportDesignerModel);
      var configReportPartType = (0, _fp.get)('configReportPart.type', reportDesignerModel);

      var unknowType = (0, _fp.isNil)(configReportPartId) || (0, _fp.isNil)(configReportPartType);

      //TODO: consider to move this logic out to Form schema
      var showViewMode = configReportPartType !== _Izenda15.REPORT_PART_TYPE.Form && !unknowType;

      return _react2.default.createElement(
        'section',
        { className: 'form-horizontal field-props-container' },
        _react2.default.createElement(
          'div',
          { className: 'field-props-header' },
          _react2.default.createElement(
            'div',
            { className: 'title-group ' },
            _react2.default.createElement(
              'strong',
              { className: 'u_inlineBlock' },
              localization.getText('REPORT_PART_PROPERTIES_CONTAINER_REPORT_PART_PROPERTIES')
            ),
            showViewMode && _react2.default.createElement(_Izenda17.default, null)
          ),
          _react2.default.createElement(
            _Izenda8.default,
            { className: 'report-parts' },
            _react2.default.createElement(_Izenda10.default, {
              blankOption: true,
              options: options,
              onChange: this.onChangeReportPart,
              valueField: 'id',
              labelField: 'headerTitle',
              value: unknowType ? null : configReportPartId
            })
          )
        ),
        _react2.default.createElement(
          'fieldset',
          { className: 'field-props-content', disabled: !configReportPartId },
          _react2.default.createElement(
            _Izenda12.default,
            null,
            unknowType ? this.renderCommonSectionProps() : this.renderPropertiesEditorByReportType()
          )
        )
      );
    }
  }, {
    key: 'renderPropertiesEditorByReportType',
    value: function renderPropertiesEditorByReportType() {
      var props = this.props;
      var configReportPart = props.reportDesignerModel.configReportPart;
      var reportPartType = configReportPart && _Izenda4.default.getReportPartType(configReportPart.type);
      var reportPartPropertiesConfig = reportPartType && (0, _fp.get)('properties.reportPart', reportPartType);
      var propConfig = void 0;
      var localization = props.localization;

      if (reportPartPropertiesConfig) {
        propConfig = reportPartPropertiesConfig && reportPartPropertiesConfig(props.reportDesignerModel, configReportPart, props.fieldStore, props);
        return _react2.default.createElement(_Izenda14.default, { propertyConfig: propConfig });
      }

      return reportPartType && reportPartType.label && _react2.default.createElement(
        'strong',
        null,
        localization.getText('REPORTDESIGNER_MESSAGE_DO_NOT_SUPPORT') + ' [' + reportPartType.label + ']'
      );
    }
  }, {
    key: 'renderCommonSectionProps',
    value: function renderCommonSectionProps() {
      var propConfig = {
        definedSchema: _Izenda19.default,
        source: null,
        widgets: {
          Panel: _Izenda6.default
        },
        onChangeValue: function onChangeValue() {}
      };

      return _react2.default.createElement(_Izenda14.default, { propertyConfig: propConfig });
    }

    /**
     * Get the accessible report parts base on current user permissions
     * @param {Array<Object>} reportParts Available report parts
     */

  }, {
    key: 'getAccessibleReportParts',
    value: function getAccessibleReportParts(reportParts) {
      var authorization = this.props.authorization;

      var checkPrivileges = function checkPrivileges(reportPartType) {
        var reportPartConfig = (0, _fp.find)(function (item) {
          return item.value === reportPartType;
        }, _Izenda15.REPORT_PART_PERMISSIONS);

        if (!(0, _fp.isNil)(reportPartConfig) && reportPartConfig.permissions) {
          return authorization.checkPrivileges(reportPartConfig.permissions);
        }
        return true;
      };

      return (0, _fp.filter)(function (item) {
        return checkPrivileges(item.type);
      }, reportParts);
    }
  }]);
  return ReportPartPropsContainer;
}(_react.Component), _class2.propTypes = {
  reportDesignerModel: _react.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = ReportPartPropsContainer;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  schemaKey: 'RP_COMMON_SECTION_PROPERTIES',
  fields: {
    /* general info */
    generalInfo: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_GENERAL_INFO');
          },
          icon: 'icon-toggle-triangle'
        }
      }
    },

    /* header */
    headers: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('REPORT_PART_PROPS_GRID_SCHEMA_LABEL_HEADERS');
          },
          icon: 'icon-toggle-triangle'
        }
      }
    },

    /* grouping */
    grouping: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_GROUPING');
          },
          icon: 'icon-toggle-triangle'
        }
      }
    },

    /* view */
    view: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('MODEL_LABEL_VIEW');
          },
          icon: 'icon-toggle-triangle'
        }
      }
    },

    /* printing */
    printing: {
      component: 'Panel',
      props: {
        initState: true,
        collapsible: true,
        header: {
          get title() {
            return _Izenda2.default.getText('COMMON_LABEL_PRINTINGS');
          },
          icon: 'icon-toggle-triangle'
        }
      }
    }
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartCommonSectionPropsSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerContent.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = __webpack_require__(1);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(978);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1194);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(414);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(415);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(584);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(76);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(27);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportViewerContent = (_dec = (0, _Izenda2.default)({ toClass: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportViewerContent, _Component);

  function ReportViewerContent(props) {
    (0, _classCallCheck3.default)(this, ReportViewerContent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportViewerContent.__proto__ || (0, _getPrototypeOf2.default)(ReportViewerContent)).call(this, props));

    _this.setReportHeader = function (ref) {
      _this.reportHeader = ref;
    };

    _this.setReportTitle = function (ref) {
      _this.reportTitle = ref;
    };

    _this.setFilterDescription = function (ref) {
      _this.reportFilterDescription = ref;
    };

    _this.setReportBody = function (ref) {
      _this.reportBody = ref;
    };

    _this.setReportFooter = function (ref) {
      _this.reportFooter = ref;
    };

    _this.setOuterScrollBox = function (ref) {
      _this.scrollBox = ref;
    };

    _this.setGridViewScrollBox = function (ref) {
      if (ref) {
        _this.gridViewScrollBox = ref.getGridViewScrollBox();
        _this.handleStickyScroll();
      }
    };

    _this.onScroll = function (_ref) {
      var scrollLeft = _ref.target.scrollLeft;
      var editMode = _this.props.editMode;

      if (!editMode && !_this.isSupportSticky) {
        var setNewPosition = function setNewPosition(elements) {
          elements.forEach(function (element) {
            element && (element.style.left = scrollLeft + 'px');
          });
        };
        setNewPosition([_this.reportHeader, _this.reportTitle, _this.reportFilterDescription, _this.reportFooter]);
      }
      if (editMode) {
        _this.handleStickyScroll();
      }
    };

    _this.handleStickyScroll = function () {
      if (_this.scrollBox && _this.gridViewScrollBox) {
        var shouldStickScroll = _this.checkShouldStickScroll();
        shouldStickScroll ? _this.gridViewScrollBox.stickHorizontalScroll() : _this.gridViewScrollBox.unstickHorizontalScroll();
      }
    };

    _this.getOuterScrollTop = function () {
      return _this.scrollBox ? _this.scrollBox.getScrollTop() : 0;
    };

    _this.getInvalidFilters = function (reportFilters) {
      var emptyRequiredParamFilters = reportFilters.emptyRequiredParamFilters,
          emptyNotVisibleRequiredFilter = reportFilters.emptyNotVisibleRequiredFilter,
          emptyVisibleRequiredFilter = reportFilters.emptyVisibleRequiredFilter;

      var indexFieldMap = function indexFieldMap(filter, index) {
        return { index: index, filter: filter };
      };
      return (0, _fp.flow)((0, _fp.concat)(emptyNotVisibleRequiredFilter.map(indexFieldMap)), (0, _fp.concat)(emptyVisibleRequiredFilter.map(indexFieldMap)), (0, _fp.uniqBy)(function (item) {
        return item.filter.alias + item.index;
      }))(emptyRequiredParamFilters.map(indexFieldMap));
    };

    _this.isSupportSticky = (0, _Izenda17.isSupportSticky)();
    return _this;
  }

  /**
   * Build list filter
   * @param {Array} filters
   */


  (0, _createClass3.default)(ReportViewerContent, [{
    key: 'buildListFilter',
    value: function buildListFilter(filters) {
      if ((0, _fp.isEmpty)(filters)) {
        return null;
      }
      var indexStep = 1;
      return _react2.default.createElement(
        'div',
        { className: 'u-center izenda-ReportViewer-FilterList' },
        filters.map(function (filter) {
          return _react2.default.createElement(
            'p',
            { key: filter.index },
            'Filter #' + (filter.index + indexStep) + ' - ' + filter.filter.alias
          );
        })
      );
    }

    /**
     * Set ref for report header
     */


    /**
     * Set ref for report title
     */


    /**
     * Set ref for filter description
     */


    /**
     * Set ref for report body
     */


    /**
     * Set ref for report footer
     */


    /**
     * Set ref for outer scrollbox
     */


    /**
     * Set ref for grid view scrollbox
     */


    /**
     * Handle on outer scroll
     */


    /**
     * Handle sticky scroll
     */

  }, {
    key: 'checkHasOuterScroll',


    /**
     * Check content has outer scroll
     */
    value: function checkHasOuterScroll() {
      var _props = this.props,
          store = _props.store,
          reportStore = _props.store.reportStore,
          editMode = _props.editMode;

      return reportStore.isShowingHeaderFooter && store.isVisibleHeaderFooter || !editMode;
    }

    /**
     * Check should stick horizontal scroll
     */

  }, {
    key: 'checkShouldStickScroll',
    value: function checkShouldStickScroll() {
      if (this.checkHasOuterScroll() && this.scrollBox && this.gridViewScrollBox) {
        var scrollTop = this.scrollBox.getScrollTop();
        var bodyDOM = _reactDom2.default.findDOMNode(this.reportBody);
        var headerHeight = (0, _fp.getOr)(0, 'offsetHeight', this.reportHeader);
        var titleHeight = (0, _fp.getOr)(0, 'offsetHeight', this.reportTitle);
        var filterDesHeight = (0, _fp.getOr)(0, 'offsetHeight', this.reportFilterDescription);
        var trackHeight = this.scrollBox.getTrackHeight();
        return headerHeight + titleHeight + filterDesHeight + bodyDOM.clientHeight + trackHeight >= this.props.viewerContentHeight + scrollTop && this.gridViewScrollBox.isInsideOfViewport();
      }
      return false;
    }

    /**
     * Get scroll top value of outer scrollbox
     */

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          store = _props2.store,
          _props2$store = _props2.store,
          reportFilters = _props2$store.reportFilters,
          reportStore = _props2$store.reportStore,
          editMode = _props2.editMode,
          localization = _props2.localization,
          className = _props2.className,
          isFullSize = _props2.isFullSize,
          bottom = _props2.bottom,
          viewerContentHeight = _props2.viewerContentHeight;

      var viewerContentClass = (0, _classnames2.default)(className, 'u-bgWhite', 'izenda-ReportViewer-FilterError');
      var isTitleDescriptionVisible = (0, _fp.get)('reportFormats.titleDescription.visible', store);
      var hasOuterScroll = this.checkHasOuterScroll();
      var style = viewerContentHeight ? { height: viewerContentHeight } : null;
      var reportFormatClassNames = (0, _classnames2.default)({
        'u-stickLeft': this.isSupportSticky,
        'u-posRelative': !this.isSupportSticky
      });
      var validatedFilters = this.getInvalidFilters(reportFilters);

      if (!(0, _fp.isEmpty)(validatedFilters)) {
        return _react2.default.createElement(
          'div',
          { className: 'u_paddingLeftRight', ref: this.props.setViewerContentRef },
          _react2.default.createElement(
            'div',
            { className: viewerContentClass, style: style },
            _react2.default.createElement(
              'div',
              { className: 'u-center' },
              localization.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_REQUIRE_AND_VISIBLE_FIELD'),
              this.buildListFilter(validatedFilters)
            )
          )
        );
      }

      var content = _react2.default.createElement(
        _Izenda16.default,
        {
          fullWidth: editMode,
          viewClassName: (0, _classnames2.default)({ u_paddingLeftRight: editMode, 'viewer-mode': !editMode }),
          onScroll: this.onScroll,
          onUpdate: this.handleStickyScroll,
          ref: this.setOuterScrollBox
        },
        reportStore.isShowingHeaderFooter && _react2.default.createElement(
          'div',
          { className: reportFormatClassNames, ref: this.setReportHeader },
          _react2.default.createElement(_Izenda8.default, { store: store, viewMode: true, replaceSystemVariable: _Izenda14.default.replaceSystemVariable })
        ),
        isTitleDescriptionVisible && _react2.default.createElement(
          'div',
          { className: reportFormatClassNames, ref: this.setReportTitle },
          _react2.default.createElement(_Izenda12.default, { store: store, viewMode: true })
        ),
        _react2.default.createElement(
          'div',
          { className: reportFormatClassNames, ref: this.setFilterDescription },
          _react2.default.createElement(_Izenda4.default, { store: store })
        ),
        _react2.default.createElement(
          'div',
          { ref: this.setReportBody },
          _react2.default.createElement(_Izenda6.default, {
            getOuterScrollTop: this.getOuterScrollTop,
            finishRender: this.setGridViewScrollBox,
            bottom: bottom,
            fullSize: isFullSize,
            store: store,
            viewMode: !editMode,
            quickEdit: !!editMode,
            hasOuterScroll: hasOuterScroll
          })
        ),
        reportStore.isShowingHeaderFooter && _react2.default.createElement(
          'div',
          { className: reportFormatClassNames, ref: this.setReportFooter },
          _react2.default.createElement(_Izenda10.default, { store: store, viewMode: true, replaceSystemVariable: _Izenda14.default.replaceSystemVariable })
        )
      );

      return _react2.default.createElement(
        'div',
        { className: className, style: style, ref: this.props.setViewerContentRef },
        editMode ? content : _react2.default.createElement(
          'div',
          { className: 'u_paddingLeftRight u_fullHeight' },
          content
        )
      );
    }
  }]);
  return ReportViewerContent;
}(_react.Component), _class2.displayName = 'ReportViewerContent', _class2.propTypes = {
  store: _propTypes2.default.object
}, _class2.defaultProps = {
  className: 'content-container'
}, _temp)) || _class);
exports.default = ReportViewerContent;
module.exports = exports['default'];

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(17);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _Izenda2.default)()(function (_ref) {
  var store = _ref.store,
      localization = _ref.localization,
      collapseToggle = _ref.collapseToggle;

  return _react2.default.createElement(
    'div',
    { className: 'u_table izenda-FilterHeader' },
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell u_paddingRight', onClick: collapseToggle },
      _react2.default.createElement('i', { className: 'icon-toggle-thick' }),
      _react2.default.createElement(
        'strong',
        null,
        localization.getText('REPORTDESIGNER_LABEL_REPORT_BODY')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell u_alignMiddle' },
      _react2.default.createElement(
        'label',
        { className: 'checkbox-inline' },
        _react2.default.createElement(_Izenda4.default, { type: 'checkbox', checked: store.reportBody.snapToGrid, onChange: store.toggleSnapToGrid.bind(store) }),
        localization.getText('REPORTDESIGNER_LABEL_REPORT_BODY_SNAP_MODE_CHECKBOX')
      )
    )
  );
}); // ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportBodyHeader component
 */

module.exports = exports['default'];

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportSubscribeActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil,
      filter = _require.filter;

  var ReportSubscribeActions = compose(withHandlers({
    onSaveSubscription: curry(onSaveSubscription),
    onSave: function onSave(props) {
      return _onSave.bind(null, props);
    },
    setType: curry(setType),
    loadData: function loadData(props) {
      return _loadData.bind(null, props);
    }
  }));

  /**
   * Save subscription data.
   */
  function onSaveSubscription(props, subData) {
    // Update for report subscribe grid
    props.subscribedInstancesStore.model.updateSubscribedInstances(subData);

    // Save subcription if in report list mode
    var reportListMode = !!props.onClose;
    reportListMode && _onSave(props);
  }

  /**
   * Save subscription when add new.
   */
  function _onSave(props, _) {
    var subscribedInstancesStore = props.subscribedInstancesStore;
    // Update for report subscribe grid
    var loader = props.loader;
    loader.startLoading();
    return subscribedInstancesStore.saveInstances().then(function (result) {
      if (result.success) {
        subscribedInstancesStore.loadInstances();
      }
      return result;
    }).finally(loader.endLoading.bind(loader));
  }

  /**
   * Set subscribe type
   * @param {Object} properties
   * @param {Boolean} subscribe mode
   */
  function setType(props, isSubscribe) {
    var subscribedInstancesStore = props.subscribedInstancesStore;
    subscribedInstancesStore.model.setType(isSubscribe);
  }

  /**
   * Set subscribe type
   * @param {Object} properties
   * @param {Boolean} report list mode : load new data
   */
  function _loadData(props, reportListMode) {
    var subscribedInstancesStore = props.subscribedInstancesStore;
    var reportId = props.reportId;

    if (!isNil(reportId)) {
      // Get data for edit case
      subscribedInstancesStore.updateReportId(reportId);
    }

    var instances = reportListMode ? [] : filter(function (item) {
      return item.isSubscription === true;
    }, subscribedInstancesStore.model.subscribedInstances.toJS());

    subscribedInstancesStore.loadInstances(instances);
  }

  module.exports = ReportSubscribeActions;
}();

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actions = (0, _recompose.compose)((0, _recompose.withHandlers)({
  disableReport: (0, _fp.curry)(disableReport),
  detectReportChange: (0, _fp.curry)(detectReportChange),
  handleCascadingChanged: (0, _fp.curry)(handleCascadingChanged),
  handleNeedUpdateResultChanged: (0, _fp.curry)(handleNeedUpdateResultChanged)
}));

/**
 * Handle cascading change
 * @param {Object} props
 * @param {boolean} change
 */
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportViewerActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function handleCascadingChanged(props, change) {
  change && props.confirmFn('Information', {
    type: 'info',
    description: _Izenda2.default.CASCADING_CHANGED_MESSAGE,
    showCloseIndicator: true
  });
}

/**
 * Handle need update result changed
 * @param {Object} props
 * @param {boolean} change
 * @param {AlertDetails} alertDetails
 */
function handleNeedUpdateResultChanged(props, change, alertDetails) {
  var localization = props.localization;


  if (change) {
    alertDetails.set({
      message: localization.getText('REPORTDESIGNER_UPDATE_RESULT'),
      type: _Izenda3.ALERT_TYPES.INFO,
      success: true,
      showType: _Izenda3.SHOW_TYPES.ALWAYS
    });
  } else {
    alertDetails.reset();
  }
}

/**
 * Disable report action in case of report being invalid
 */
function disableReport(props, _) {
  props.store.disable();
  return false;
}

/**
 * Detect report change
 * @return {Promise} { boolean }
 */
function detectReportChange(props, store, pageName) {
  // var store = this.masterStore;

  return store.detectReportChange(pageName).then(function (result) {
    if (result.success) {
      return (0, _bluebird.resolve)(true);
    }

    var error = result.messages[0];
    switch (error.key) {
      case _Izenda2.default.DETECT_CHANGE.PHYSICAL:
        return props.confirmFn('Information', {
          description: error.messages[0],
          type: 'info',
          showCloseIndicator: true
        }).then(disableReport.bind(null, props));
      case _Izenda2.default.DETECT_CHANGE.LOGICAL:
        return props.confirmFn('Confirmation', {
          description: error.messages[0]
        });
    }
    return (0, _bluebird.resolve)(false);
  });
}

exports.default = actions;
module.exports = exports['default'];

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.Reports.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Reports
 */

!function () {
  var m = __webpack_require__(5);
  var trackable = __webpack_require__(46);
  var constants = __webpack_require__(50);
  var ReportList = __webpack_require__(1169)(constants, 'reports');
  var CategoryDetail = __webpack_require__(161);

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      remove = _require.remove,
      find = _require.find;

  function Reports() {
    this.isLeftMenuReportLastPage = false;
    this.isLeftMenuTemplateLastPage = false;

    var props = {
      leftMenuReportCategories: [],
      leftMenuReportCategoryTree: [],
      leftMenuTemplateCategories: [],
      leftMenuTemplateCategoryTree: [],
      reportCategoryTree: [],
      copyReportCategoryList: [],
      items: new ReportList()
    };

    m.extendObservable(trackable(this), props);
    this.hasNewCategory = false;
  }

  Reports.prototype.resetCategoryStatus = function () {
    this.hasNewCategory = false;
  };

  Reports.prototype.readReportCategoryTree = m.action(function readReportCategoryTree(categoryList, reportType) {
    ensure(reportType, 'Report part type must be defined');

    categoryList = categoryList || [];

    this.reportCategoryTree = categoryList.map(function (item) {
      if (!isEmpty(item.subCategories)) {
        item.subCategories = item.subCategories.map(function (subItem) {
          return new CategoryDetail(subItem);
        });
      }
      return new CategoryDetail(item);
    });

    // add ALL REPORTS/ALL TEMPLATES category to first rows
    var allReportItem = this.createAllItem(reportType);
    this.reportCategoryTree.splice(0, 0, allReportItem);
  });

  /**
   * Read category List showed on CopyReport popup
   */
  Reports.prototype.readCopyReportCategoryList = m.action(function (categoryList) {
    categoryList = categoryList || [];

    this.copyReportCategoryList = categoryList.map(function (item) {
      if (!isEmpty(item.subCategories)) {
        item.subCategories = item.subCategories.map(function (subItem) {
          return new CategoryDetail(subItem);
        });
      }
      return new CategoryDetail(item);
    });
  });

  /**
   * Delete a ReportCategory out of reportCategoryTree
   * @param {object} reportCategory
   * @returns {promise}
   */
  Reports.prototype.removeReportCategory = m.action(function removeReportCategory(reportCategory) {
    if (!reportCategory.isSubCategory) {
      this.reportCategoryTree.replace(remove({ id: reportCategory.id }, this.reportCategoryTree));
    } else {
      var parent = find({ id: reportCategory.parentId }, this.reportCategoryTree);
      parent.subCategories.replace(remove({ id: reportCategory.id }, parent.subCategories));
    }
  });

  /**
   * reset ReportList model
   */
  Reports.prototype.resetReportList = m.action(function resetReportList() {
    this.items = new ReportList();
  });

  /**
   * create all item
   * @param {Number} reportType report Type
   * @returns {Object} all item
   */
  Reports.prototype.createAllItem = function (reportType) {
    var item = new CategoryDetail();
    var data = reportType.toString() === constants.CATEGORY_TYPE.REPORT ? constants.ALL_CATEGORY_TYPES.ALL_REPORTS : constants.ALL_CATEGORY_TYPES.ALL_TEMPLATES;
    item.populateData(data);
    return item;
  };

  module.exports = Reports;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportsRoot.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {

  var React = __webpack_require__(0);
  var Reports = __webpack_require__(2635);
  var ReportsStore = __webpack_require__(1196);
  var SubscribedInstancesStore = __webpack_require__(327);
  var LicenseCheckerConstants = __webpack_require__(45);
  var connect = __webpack_require__(2);
  var routeUtils = __webpack_require__(31);
  var uiState = __webpack_require__(15);

  var ReportsContainer = connect()(React.createClass({
    displayName: 'ReportsContainer',

    componentWillMount: function componentWillMount() {
      // License is expired, navigate to Settings pages
      if (uiState.expiredLicense) {
        var settingLink = routeUtils.getSettingsUrl();
        this.props.router.push(settingLink);
      }

      this.store = new ReportsStore();
      this.reportSubscriptionStore = new SubscribedInstancesStore();
    },
    render: function render() {
      return !uiState.expiredLicense && React.createElement(Reports, (0, _extends3.default)({}, this.props, {
        store: this.store,
        reportSubscriptionStore: this.reportSubscriptionStore }));
    }
  }));

  module.exports = {
    Component: Reports,
    Store: ReportsStore,
    Container: ReportsContainer
  };
}();

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Reports.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

var _Izenda5 = __webpack_require__(332);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2636);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(156);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(333);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(331);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(339);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(31);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reports = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Reports, _Component);

  function Reports(props) {
    (0, _classCallCheck3.default)(this, Reports);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Reports.__proto__ || (0, _getPrototypeOf2.default)(Reports)).call(this, props));

    _initialiseProps.call(_this);

    return _this;
  }

  (0, _createClass3.default)(Reports, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.settingStore = new _Izenda16.default();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      var store = this.props.store;

      // observe changing tenantId, then reload data for Reports
      this.disposeObserveTenantId = _mobx2.default.observe(_Izenda4.default, 'tenantId', function () {
        !_Izenda4.default.keepState && props.router.push({
          pathname: _Izenda18.default.getReportUrl()
        });
      });

      this.enableSystemSetting(props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _fp.isEmpty)(nextProps.params) && nextProps.params !== this.props.params) {
        this.props.store.resetModel();
      }

      this.enableSystemSetting(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disposeObserveTenantId();
      this.settingStore.destroy();
    }

    /**
     * Enable system setting level base on report viewer or report list
     * @param  {Object} props Component props
     */

  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = props.store,
          params = props.params,
          children = props.children,
          reportSubscriptionStore = props.reportSubscriptionStore;

      var hasNewCategory = (0, _fp.get)('model.hasNewCategory', store);

      var reportType = !(0, _fp.isNil)(params) && !(0, _fp.isNil)(params.reportType) ? params.reportType : '0';
      // Only show report left navigate on report list and disable system lvl
      var showReportLeftNavigate = (0, _fp.isNil)(params.id);

      return _react2.default.createElement(
        'section',
        { className: 'izenda-Reports' },
        _react2.default.createElement(_Izenda14.default, { store: this.settingStore }),
        _react2.default.createElement(
          _Izenda12.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'izenda-TableLayout u_paddingTopBottom' },
            showReportLeftNavigate && _react2.default.createElement(
              _Izenda6.default,
              { className: 'izenda-Content-Sidebar', hasScrollBox: false },
              _react2.default.createElement(_Izenda8.default, {
                store: store,
                reportType: reportType,
                isReload: (0, _fp.isEmpty)(params) || hasNewCategory
              })
            ),
            _react2.default.createElement(
              _Izenda10.default,
              null,
              children && _react2.default.cloneElement(children, {
                store: store,
                reportSubscriptionStore: reportSubscriptionStore
              })
            )
          )
        )
      );
    }
  }]);
  return Reports;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _initialiseProps = function _initialiseProps() {
  this.enableSystemSetting = function (props) {
    // disable system setting on report viewer mode
    if (!(0, _fp.isNil)(props.params.id)) {
      _Izenda4.default.updateDisableSystemSetting();
    } else {
      _Izenda4.default.enableSystemSetting();
    }
  };
}, _temp)) || _class);
exports.default = Reports;
module.exports = exports['default'];

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportLeftNavigation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var Tabs = __webpack_require__(131).Tabs;
  var Tab = __webpack_require__(131).Tab;
  var CategoryTree = __webpack_require__(1198);
  var routeUtils = __webpack_require__(31);
  var LicenseCheckerConstants = __webpack_require__(45);

  var CONSTANTS = __webpack_require__(50);
  var CATEGORY_TYPE = CONSTANTS.CATEGORY_TYPE;

  var compare = __webpack_require__(422);

  var _require = __webpack_require__(1),
      isEqual = _require.isEqual,
      toString = _require.toString;

  var ReportLeftNavigation = React.createClass({
    displayName: 'ReportLeftNavigation',

    propTypes: {
      store: React.PropTypes.object
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var nextStore = nextProps.store;
      var nextReportType = nextProps.reportType;
      var _props = this.props,
          store = _props.store,
          reportType = _props.reportType;


      if (!compare(nextStore, store) || !isEqual(nextReportType, reportType) || nextProps.isReload) {
        var loader = nextProps.loader;
        var _reportType = nextReportType || nextStore.reportType;

        loader.startLoading();
        nextStore.loadLazyLoadingCategories(_reportType, true).finally(loader.endLoading.bind(loader));
      }
    },

    render: function render() {
      var props = this.props;
      var localization = props.localization;
      var store = props.store;
      var reportType = props.reportType || store.reportType;
      var authorization = props.authorization;
      var hasTemplateLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.ReportTemplateComponent);

      var reportTabRouteParams = {
        reportType: { dataKey: '', value: CATEGORY_TYPE.REPORT },
        catId: { dataKey: 'id', value: null },
        isGlobal: { dataKey: 'isGlobal', value: null }
      };

      var templateTabRouteParams = {
        reportType: { dataKey: '', value: CATEGORY_TYPE.TEMPLATES },
        catId: { dataKey: 'id', value: null },
        isGlobal: { dataKey: 'isGlobal', value: null }
      };

      return React.createElement(
        'div',
        null,
        React.createElement(
          Tabs,
          { activeTabKey: toString(reportType), className: 'left-tab', navigationClass: 'u-bgDarkBlue' },
          React.createElement(
            Tab,
            { title: localization.getText("COMMON_LABEL_REPORTS"),
              tabKey: CATEGORY_TYPE.REPORT,
              href: getLink.call(this, CATEGORY_TYPE.REPORT, reportType),
              className: 'u_fullHeight' },
            this.renderCategoryTree(reportTabRouteParams, store.model.leftMenuReportCategoryTree, store.model.isLeftMenuReportLastPage)
          ),
          hasTemplateLicense && React.createElement(
            Tab,
            { title: localization.getText("COMMON_LABEL_TEMPLATES"),
              tabKey: CATEGORY_TYPE.TEMPLATES,
              href: getLink.call(this, CATEGORY_TYPE.TEMPLATES, reportType),
              className: 'u_fullHeight' },
            this.renderCategoryTree(templateTabRouteParams, store.model.leftMenuTemplateCategoryTree, store.model.isLeftMenuTemplateLastPage)
          )
        )
      );

      function getLink(reportType, currentReportType) {
        return reportType !== currentReportType ? routeUtils.getReportUrl('List', {
          reportType: reportType,
          isGlobal: null
        }) : null;
      }
    },

    /**
     * Render Report Category Tree
     * @param {object} routeParams
     */
    renderCategoryTree: function renderCategoryTree(routeParams, dataTree, isLastPage) {
      var props = this.props;
      var store = props.store;
      var reportType = props.reportType || store.reportType;

      return React.createElement(CategoryTree, {
        store: store,
        reportType: reportType,
        dataTree: dataTree,
        isLastPage: isLastPage,
        selectedCategoryId: store.selectedCategoryId,
        routeObject: routeUtils.getConfigRoute('Report', 'List'),
        routeParams: routeParams,
        onDeleteCategory: store.deleteReportCategory.bind(store),
        onLoadCategoryList: handleLoadReportList,
        onValidateCategoryName: store.validateCategoryName.bind(store),
        registerLazyLoadingStore: store.registerLeftMenuLazyLoadingStore.bind(store),
        getData: store.loadLazyLoadingCategories.bind(store, reportType, false) });

      /**
       * Load Report List with category ID and type of report
       * @param catId
       * @returns {Promise}
       */
      function handleLoadReportList(catId) {
        return store.loadLazyLoadingReports(catId, reportType, true, null);
      }
    }
  });

  module.exports = connect()(ReportLeftNavigation);
}();

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = __webpack_require__(63);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(68);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(17);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _reactRouter = __webpack_require__(52);

var _Izenda9 = __webpack_require__(15);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(31);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(1154);

var _Izenda14 = __webpack_require__(153);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _mobx = __webpack_require__(5);

var _bluebird = __webpack_require__(18);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _fp = __webpack_require__(1);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ValidatorInput = (0, _Izenda4.default)()(_Izenda8.default);

var CategoryItem = (_dec = (0, _Izenda2.default)(), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(CategoryItem, _Component);

  function CategoryItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CategoryItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CategoryItem.__proto__ || (0, _getPrototypeOf2.default)(CategoryItem)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, "categoryState", _descriptor, _this), _this.onSave = function (e) {
      e.preventDefault();
      e.stopPropagation();

      var _this$props = _this.props,
          dataSource = _this$props.dataSource,
          id = _this$props.dataSource.id,
          validation = _this$props.validation;


      return validation.validate("name").then((0, _mobx.action)(function (success) {
        if (success) {
          _this.categoryState.editMode = false;
          dataSource.updateIsEditing(false);
          return _this.loadReportList(id);
        } else {
          dataSource.updateIsEditing(true);
          return _bluebird2.default.reject();
        }
      }));
    }, _this.onEnter = function (e) {
      if (e.key === "Enter") _this.onSave(e);
    }, _this.onCancel = (0, _mobx.action)(function (e) {
      var _this2 = _this,
          categoryState = _this2.categoryState,
          originalName = _this2.categoryState.originalName,
          dataSource = _this2.props.dataSource;


      categoryState.editMode = false;
      dataSource.updateName(originalName);
      dataSource.updateIsEditing(false);
    }), _this.updateDataSourceName = function (e) {
      var name = e.target.value;
      var dataSource = _this.props.dataSource;

      dataSource.updateName(name);
    }, _this.handleClickLink = function () {
      var _this$props2 = _this.props,
          routeParams = _this$props2.routeParams,
          dataSource = _this$props2.dataSource,
          routeObject = _this$props2.routeObject,
          confirmDirtyForm = _this$props2.confirmDirtyForm,
          router = _this$props2.router;


      var parseRouteParams = function parseRouteParams() {
        var result = {};
        var keys = (0, _keys2.default)(routeParams);
        keys.forEach(function (key) {
          result[key] = routeParams[key].dataKey === "reportId" || routeParams[key].dataKey === "dashboardId" ? null : routeParams[key].value || dataSource[routeParams[key].dataKey];
        });

        return result;
      };

      var link = _Izenda12.default.getRouteUrl(routeObject, parseRouteParams());

      confirmDirtyForm(_Izenda10.default.isDirty, { onConfirmDirtyForm: _Izenda10.default.onOkDirtyForm }).then(function () {
        router.push({
          pathname: link,
          state: {
            keepState: true
          }
        });
      });

      _Izenda15.default.toggleSideBar(false);
      _Izenda15.default.toggleIconMenu(false);
    }, _this.handleRenameClick = function (e) {
      var _this$props3 = _this.props,
          dataSource = _this$props3.dataSource,
          getEditingCategoryTreeItem = _this$props3.getEditingCategoryTreeItem,
          onValidateCategoryName = _this$props3.onValidateCategoryName;


      var enableEditMode = (0, _mobx.action)(function (result) {
        if ((0, _fp.isNil)(result)) {
          e.persist();
          _this.categoryState.editMode = true;
          dataSource.updateIsEditing(true);
        }
      });

      var editingCategoryTreeItem = getEditingCategoryTreeItem();
      if (editingCategoryTreeItem) {
        onValidateCategoryName(editingCategoryTreeItem).then(enableEditMode);
      } else {
        enableEditMode();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CategoryItem, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.categoryState.originalName = nextProps.dataSource.name;
    }
  }, {
    key: "loadReportList",
    value: function loadReportList(catId) {
      var _props = this.props,
          loader = _props.loader,
          onLoadCategoryList = _props.onLoadCategoryList;


      loader.startLoading();
      return onLoadCategoryList && onLoadCategoryList(catId).finally(loader.endLoading.bind(loader));
    }
  }, {
    key: "renderEditModeName",
    value: function renderEditModeName() {
      var _props2 = this.props,
          dataSource = _props2.dataSource,
          _props2$dataSource = _props2.dataSource,
          isSubCategory = _props2$dataSource.isSubCategory,
          name = _props2$dataSource.name,
          onValidateCategoryName = _props2.onValidateCategoryName,
          localization = _props2.localization;


      var categoryConstraints = isSubCategory ? _Izenda13.CATEGORY_TREE.CONSTRAINTS.SUB_CATEGORY_NAME : _Izenda13.CATEGORY_TREE.CONSTRAINTS.CATEGORY_NAME;

      var nameValidation = (0, _fp.merge)(categoryConstraints, {
        action: function action() {
          return onValidateCategoryName && onValidateCategoryName.bind(null, dataSource);
        }
      });

      return _react2.default.createElement(
        "div",
        { className: "title-edit form-group" },
        _react2.default.createElement(
          "div",
          { className: "input-group" },
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(ValidatorInput, {
              value: name,
              onChange: this.updateDataSourceName,
              onKeyPress: this.onEnter,
              onBlur: this.onSave,
              field: "name",
              validations: nameValidation,
              className: "form-control",
              autoFocus: true
            })
          ),
          _react2.default.createElement(
            "span",
            { className: "input-group-btn" },
            _react2.default.createElement(
              "button",
              {
                className: "btn btn-default",
                title: localization.getText("COMMON_TOOLTIP_UPDATE_CHANGE"),
                onMouseDown: this.onSave
              },
              _react2.default.createElement("span", { className: "icon-ok success-color" })
            ),
            _react2.default.createElement(
              "button",
              {
                className: "btn btn-default",
                title: localization.getText("COMMON_TOOLTIP_CANCEL_CHANGE"),
                onMouseDown: this.onCancel
              },
              _react2.default.createElement("span", { className: "icon-cancel" })
            )
          )
        )
      );
    }
  }, {
    key: "renderReadonlyName",
    value: function renderReadonlyName() {
      var _props3 = this.props,
          dataSource = _props3.dataSource,
          name = _props3.dataSource.name,
          toggleIcon = _props3.toggleIcon;


      var toggleIconClassName = (0, _fp.get)("props.className", toggleIcon);
      var isShowTriangleIcon = (0, _fp.get)("subCategories.length", dataSource);

      return _react2.default.createElement(
        "span",
        null,
        _react2.default.createElement(
          _Izenda6.default,
          { className: "selectable", text: name, tooltip: name },
          _react2.default.createElement(
            "a",
            { onClick: this.handleClickLink },
            name
          )
        ),
        toggleIcon && (0, _react.cloneElement)(toggleIcon, { className: (0, _classnames2.default)(toggleIconClassName, "izenda-Arrow-Icon") })
      );
    }
  }, {
    key: "renderReadonlyActions",
    value: function renderReadonlyActions() {
      var _props4 = this.props,
          isGlobalLocal = _props4.isGlobalLocal,
          localization = _props4.localization;

      return !isGlobalLocal && _react2.default.createElement(
        "div",
        { className: "pull-right" },
        _react2.default.createElement("i", {
          className: "icon-pencil selectable",
          title: localization.getText("COMMON_TOOLTIP_RENAME"),
          onClick: this.handleRenameClick
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props5 = this.props,
          dataSource = _props5.dataSource,
          localization = _props5.localization;

      var isHideReadonlyActions = this.categoryState.editMode || dataSource.isUneditable;

      return _react2.default.createElement(
        "div",
        null,
        this.categoryState.editMode ? this.renderEditModeName() : this.renderReadonlyName(),
        !isHideReadonlyActions && this.renderReadonlyActions()
      );
    }
  }]);
  return CategoryItem;
}(_react.Component), _class3.displayName = "CategoryItem", _class3.propTypes = {
  dataSource: _react.PropTypes.object.isRequired,
  routeObject: _react.PropTypes.object.isRequired,
  routeParams: _react.PropTypes.object.isRequired,
  onLoadCategoryList: _react.PropTypes.func,
  onValidateCategoryName: _react.PropTypes.func,
  toggleIcon: _react.PropTypes.object,
  isGlobalLocal: _react.PropTypes.bool
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "categoryState", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      originalName: this.props.dataSource.name,
      editMode: false
    };
  }
})), _class2)) || _class);
exports.default = CategoryItem;
module.exports = exports["default"];

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobxReact = __webpack_require__(10);

var _Izenda3 = __webpack_require__(2639);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(27);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(313);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda9 = __webpack_require__(13);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(50);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(1200);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(219);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2644);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportList.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ReportListHeader = (0, _Izenda14.default)(_Izenda12.default);

var ReportList = function (_Component) {
  (0, _inherits3.default)(ReportList, _Component);

  function ReportList(props) {
    (0, _classCallCheck3.default)(this, ReportList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportList.__proto__ || (0, _getPrototypeOf2.default)(ReportList)).call(this, props));

    _this.renderSubReport = function (groupInfo) {
      var _this$props = _this.props,
          isGlobalExpand = _this$props.isGlobalExpand,
          isLocalExpand = _this$props.isLocalExpand,
          toggle = _this$props.toggle,
          reportId = _this$props.params.reportId,
          reportSubscriptionStore = _this$props.reportSubscriptionStore,
          store = _this$props.store;


      if ((0, _fp.has)('globalLocalCategory', groupInfo)) {
        return renderGlobalLocalCategory.call(_this, groupInfo);
      }

      return _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({}, groupInfo, {
        selectedReportId: reportId,
        reportSubscriptionStore: reportSubscriptionStore,
        store: store
      }));

      function renderGlobalLocalCategory(groupInfo) {
        var isGlobal = groupInfo.isGlobal;
        var expandCollapse = (0, _classnames2.default)({
          'icon-minus-circled': isGlobal && isGlobalExpand || !isGlobal && isLocalExpand,
          'icon-plus-circled': isGlobal && !isGlobalExpand || !isGlobal && !isLocalExpand
        });

        var className = (0, _classnames2.default)({
          u_paddingTop: !isGlobal && this.globalLocalCount === 2
        });

        return _react2.default.createElement(
          _Izenda10.default,
          { className: className },
          _react2.default.createElement(
            _Izenda10.default.Row,
            { className: 'u_paddingTopBottom u_noMarginAll izenda-GlobalLocalItem' },
            _react2.default.createElement(
              _Izenda10.default.Col,
              { cols: 11 },
              _react2.default.createElement(
                'div',
                { className: 'u_textBold u_textUppercase' },
                groupInfo.globalLocalCategory.name
              )
            ),
            _react2.default.createElement(
              _Izenda10.default.Col,
              { cols: 1 },
              _react2.default.createElement(
                'div',
                { className: 'u_floatRight' },
                _react2.default.createElement(
                  'a',
                  { onClick: toggle.bind(this.props, isGlobal) },
                  _react2.default.createElement('span', { className: expandCollapse })
                )
              )
            )
          )
        );
      }
    };

    return _this;
  }

  (0, _createClass3.default)(ReportList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.loader.startLoading();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          loader = _props.loader,
          store = _props.store;

      store.resetReportData();
      loader.endLoading();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var restNextProps = (0, _fp.omit)(['isGlobalExpand', 'isLocalExpand'], nextProps);
      var restProps = (0, _fp.omit)(['isGlobalExpand', 'isLocalExpand'], this.props);
      if (!(0, _fp.isEqual)(restNextProps, restProps)) {
        var store = nextProps.store,
            _nextProps$params = nextProps.params,
            catId = _nextProps$params.catId,
            reportType = _nextProps$params.reportType,
            isGlobal = _nextProps$params.isGlobal,
            loader = nextProps.loader;

        this.isReload = true;

        loader.startLoading();
        store.loadLazyLoadingReports(catId, reportType, true, isGlobal).finally(loader.endLoading.bind(loader));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          loader = _props2.loader,
          store = _props2.store,
          _props2$params = _props2.params,
          isGlobal = _props2$params.isGlobal,
          catId = _props2$params.catId,
          reportType = _props2$params.reportType,
          isGlobalExpand = _props2.isGlobalExpand,
          isLocalExpand = _props2.isLocalExpand;


      this.globalLocalCount = 0;
      var reportList = getReportList.call(this, store.items.categories);
      var getData = getDataFunc();

      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        _react2.default.createElement(ReportListHeader, {
          ref: 'reportListHeader',
          store: store,
          isTemplateType: store.isTemplateType,
          className: 'izenda-Wrapper-header',
          isGlobal: isGlobal
        }),
        _react2.default.createElement(
          'section',
          { className: 'izenda-ReportList-content izenda-Wrapper-content u_paddingLeftRight' },
          _react2.default.createElement(
            _Izenda6.default,
            null,
            _react2.default.createElement(_Izenda16.default, {
              data: reportList,
              isLastPage: store.items.isLastPage,
              getData: getData,
              renderItem: this.renderSubReport,
              registerLazyLoadingStore: store.registerContentLazyLoadingStore.bind(store),
              loader: (0, _fp.isNil)(this.isReload) && loader
            })
          )
        )
      );

      function getReportList(globalLocalCategories) {
        var _this2 = this;

        var reportList = [],
            reports = void 0,
            numReports = void 0;

        (0, _fp.forEach)(function (globalLocalCategory) {
          _this2.globalLocalCount++;

          if (globalLocalCategory.isVirtualNode) {
            reportList.push(globalLocalCategory);
            return;
          }

          reportList.push({
            key: globalLocalCategory.isGlobal ? 'GlobalCategory_' + isGlobalExpand : 'LocalCategory_' + isLocalExpand,
            isGlobal: globalLocalCategory.isGlobal,
            globalLocalCategory: globalLocalCategory
          });

          (globalLocalCategory.isGlobal && isGlobalExpand || !globalLocalCategory.isGlobal && isLocalExpand) && (0, _fp.forEach)(function (category) {
            if (category.isVirtualNode) {
              reportList.push(category);
              return;
            }

            if (category.canDelete) return;

            (0, _fp.forEach)(function (subCategory) {
              if (subCategory.isVirtualNode) {
                reportList.push(subCategory);
                return;
              }

              if (subCategory.canDelete) return;

              reports = (0, _fp.getOr)([], 'reports', subCategory);
              numReports = (0, _fp.size)(reports);

              reports.forEach(function (report, index) {
                if (report.isVirtualNode) {
                  reportList.push(report);
                  return;
                }

                reportList.push({
                  key: report.id,
                  isGlobal: category.isGlobal,
                  isFirstItem: index === 0,
                  isLastItem: index === numReports - 1,
                  reportCategory: category,
                  reportSubCategory: subCategory,
                  report: report
                });
              }, subCategory.reports);
            }, category.subCategories);
          }, globalLocalCategory.subCategories);
        }, globalLocalCategories);

        return reportList;
      }

      function getDataFunc() {
        return !(0, _fp.isEmpty)(store.items.searchText) ? store.lazyLoadingSearch.bind(store, isGlobal) : store.loadLazyLoadingReports.bind(store, catId, reportType, false, isGlobal);
      }
    }
  }]);
  return ReportList;
}(_react.Component);

ReportList.propTypes = {
  store: _react.PropTypes.object
};

exports.default = (0, _Izenda2.default)(_Izenda18.default)(ReportList);
module.exports = exports['default'];

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportItem.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var observer = __webpack_require__(10).observer;
  var React = __webpack_require__(0);

  var ReportDetail = __webpack_require__(2640);
  var constants = __webpack_require__(50);
  var TextHighLight = __webpack_require__(62);
  var AffixContainer = __webpack_require__(629);
  var classnames = __webpack_require__(11);

  var SearchCriteria = constants.SEARCH_CRITERIA;

  var ReportItem = React.createClass({
    displayName: 'ReportItem',

    propTypes: {
      store: React.PropTypes.object
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var reportSubscriptionStore = props.reportSubscriptionStore;
      var reportSubCategory = props.reportSubCategory;
      var reportCategory = props.reportCategory;
      //var reports = reportSubCategory.reports;
      var cateName = getCateName();

      var report = props.report;

      var classes = classnames('panel panel-default izenda-ReportItem', {
        'izenda-ReportItem_last': props.isLastItem
      });
      var classesHeader = classnames('izenda-ReportItemHeader panel-heading text-uppercase sticky', {
        'u_block': props.isFirstItem,
        'u_none': props.isTrainingMode
      });

      return React.createElement(
        AffixContainer,
        { className: classes,
          getAffix: this.getAffix,
          affixClass: 'show-header' },
        React.createElement(
          'div',
          { ref: 'affix',
            className: classesHeader },
          getHeaderName()
        ),
        React.createElement(ReportDetail, (0, _extends3.default)({}, props, {
          className: props.isFirstItem ? 'u_noMarginTop' : '',
          store: store,
          pretext: cateName,
          boardDetail: report,
          reportSubCategory: reportSubCategory,
          reportSubscriptionStore: reportSubscriptionStore }))
      );

      function getCateName() {
        var cateName = reportCategory.isUncategorized ? constants.UNCATEGORIZED : reportCategory.name;

        return cateName + (reportSubCategory.isUncategorized ? '' : '-' + reportSubCategory.name);
      }

      function getHeaderName() {
        if (reportCategory.isUncategorized) {
          return constants.UNCATEGORIZED;
        }

        if (reportSubCategory.isUncategorized) {
          return React.createElement(TextHighLight, { highlight: store.items.searchText,
            text: reportCategory.name,
            className: 'text-bold',
            notHighlight: isNotHighLight(store.items.searchType, SearchCriteria[7].value) });
        }

        return React.createElement(
          'span',
          null,
          React.createElement(TextHighLight, { highlight: store.items.searchText,
            text: reportCategory.name,
            className: 'text-bold',
            notHighlight: isNotHighLight(store.items.searchType, SearchCriteria[7].value) }),
          '\xA0-\xA0',
          React.createElement(TextHighLight, { highlight: store.items.searchText,
            text: reportSubCategory.name,
            className: 'text-bold',
            notHighlight: isNotHighLight(store.items.searchType, SearchCriteria[8].value) })
        );
      }

      function isNotHighLight(searchType, field) {
        return searchType === constants.SEARCH_CRITERIA[0].value ? false : searchType === field ? false : true;
      }
    },

    getAffix: function getAffix() {
      return this.refs.affix;
    }
  });

  module.exports = observer(ReportItem);
}();

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportDetail.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2641);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1181);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(88);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(1182);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(62);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(1195);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(31);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(148);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(42);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(15);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _fp = __webpack_require__(1);

var _Izenda25 = __webpack_require__(50);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(1199);

var _Izenda28 = _interopRequireDefault(_Izenda27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchCriteria = _Izenda26.default.SEARCH_CRITERIA;
var ReportDetailHeader = (0, _Izenda28.default)(_Izenda26.default);

var ViewHistoryIcon = (0, _Izenda20.default)()(function (props) {
  return _react2.default.createElement(
    'a',
    { onClick: props.onClick, title: 'View History' },
    _react2.default.createElement('span', { className: 'icon-history' })
  );
});

var ReportDetail = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportDetail, _Component);

  function ReportDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportDetail.__proto__ || (0, _getPrototypeOf2.default)(ReportDetail)).call.apply(_ref, [this].concat(args))), _this), _this.viewHistory = function (success) {
      var props = _this.props;
      var store = props.store,
          reportSubCategory = props.reportSubCategory,
          router = props.router,
          isGlobal = props.isGlobal,
          reportId = props.boardDetail.id;


      if (success) {
        props.openPopup(_Izenda8.default, {
          showCopy: _this.viewCopyPopup,
          showMove: _this.viewMovePopup,
          reportId: reportId,
          masterStore: store,
          isGlobal: isGlobal
        }).then(function (reportId) {
          if (reportId) {
            store.removeReport(reportId, reportSubCategory).then(function (result) {
              !(0, _fp.isEmpty)(result) && router.push(_Izenda18.default.getReportUrl());
            });
          }
        });
      }
    }, _this.renderItemInfo = function (text, value, field) {
      var _this$props = _this.props,
          model = _this$props.store.items,
          boardDetail = _this$props.boardDetail;

      return _react2.default.createElement(
        'div',
        { className: 'form-group row' },
        _react2.default.createElement(
          'label',
          { className: 'col-xs-6 control-label u_textGrayColor' },
          text,
          ': '
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6' },
          _react2.default.createElement(_Izenda14.default, {
            highlight: model.searchText,
            text: (0, _fp.toString)(value),
            notHighlight: boardDetail.isNotHighLight(model.searchType, field)
          })
        )
      );
    }, _this.viewCopyPopup = function (version) {
      _this.openCopyReportPopup(version, false);
    }, _this.viewMovePopup = function (version) {
      _this.openCopyReportPopup(version, true);
    }, _this.openCopyReportPopup = function (version, isMove) {
      var props = _this.props;
      var store = props.store,
          boardDetail = props.boardDetail;

      var latestVersion = 0;
      props.openPopup(_Izenda12.default, {
        store: store,
        boardDetail: boardDetail,
        isMoveReport: isMove,
        version: (0, _fp.isNumber)(version) ? version : latestVersion
      }).then(function (message) {
        _this.onCloseCopyPopup(message, isMove);
      });
    }, _this.onCloseCopyPopup = function (message, isMove) {
      var props = _this.props;
      var store = props.store,
          loader = props.loader,
          boardDetail = props.boardDetail,
          router = props.router;


      if (message) {
        return props.confirmFn('Information', {
          description: message,
          type: 'info',
          showCloseIndicator: true
        }).then(function () {
          loader.startLoading();
          if (isMove) {
            router.push(_Izenda18.default.getReportUrl('List', { reportType: boardDetail.type }));
          } else {
            router.push(_Izenda18.default.getReportUrl('List', (0, _fp.assign)({ reportType: boardDetail.type }, store.selectedCategoryId && { catId: store.selectedCategoryId })));
          }
          return null;
        }).finally(loader.endLoading.bind(loader));
      }
    }, _this.closeSubcribe = function () {
      _this.props.boardDetail.toggleSubscribeMode();
    }, _this.checkValidReport = function () {
      var props = _this.props;
      var store = props.store,
          reportId = props.boardDetail.id;

      return store.checkValidReportId(reportId).then(function (result) {
        if (!result.success && !(0, _fp.isEmpty)(result.messages)) {
          var message = (0, _fp.head)(result.messages) || {};
          var errorMessage = (0, _fp.head)(message.messages) || '';
          props.confirmMessage('error', errorMessage);
        }
        return result.success;
      });
    }, _this.viewReportHistory = function () {
      _this.checkValidReport().then(_this.viewHistory);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Open report history popup
   */


  (0, _createClass3.default)(ReportDetail, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var store = props.store,
          reportSubscriptionStore = props.reportSubscriptionStore,
          boardDetail = props.boardDetail,
          _props$boardDetail = props.boardDetail,
          reportId = _props$boardDetail.id,
          expanedOption = _props$boardDetail.isShowDetail,
          accessPriority = _props$boardDetail.accessPriority,
          isSubscribeMode = _props$boardDetail.isSubscribeMode,
          authorization = props.authorization,
          permissionKeys = props.authorizationConstants.PERMISSION_KEY,
          reportSubCategory = props.reportSubCategory;

      var renderItemInfo = this.renderItemInfo;
      var detailUri = {
        pathname: _Izenda18.default.getReportUrl('View', { id: reportId }),
        state: {
          fromList: true
        }
      };

      var header = {
        store: store,
        boardDetail: boardDetail,
        expanedOption: expanedOption,
        component: ReportDetailHeader,
        detailUri: detailUri,
        checkValidReport: this.checkValidReport,
        accessPriority: accessPriority,
        hasRenamePermission: authorization.checkPrivileges([permissionKeys.ReportsActionsOverwriteExistingReport])
      };

      var footer = {
        store: store,
        boardDetail: boardDetail,
        reportSubCategory: reportSubCategory,
        component: _Izenda6.default,
        checkValidReport: this.checkValidReport,
        reportSubscriptionStore: reportSubscriptionStore,
        viewCopyPopup: this.viewCopyPopup,
        viewMovePopup: this.viewMovePopup
      };

      var DetailBody = function DetailBody(props) {
        var boardDetail = props.boardDetail || {};
        var localization = props.localization;
        return _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-md-6 col-xs-12 report-description' },
            boardDetail.description
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-md-6 col-xs-12 report-detail-info' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-6' },
                renderItemInfo(localization.getText('REPORT_LABEL_REPORT_OWNER'), boardDetail.owner, 'none'),
                renderItemInfo(localization.getText('COMMON_CRITERIA_CREATED_BY'), boardDetail.createdBy, SearchCriteria[3].value),
                renderItemInfo(localization.getText('COMMON_CRITERIA_EDITED_BY'), boardDetail.modifiedBy, SearchCriteria[5].value),
                renderItemInfo(localization.getText('COMMON_CRITERIA_NUMBER_OF_VIEWS'), boardDetail.numberOfView, 'none'),
                renderItemInfo(localization.getText('COMMON_CRITERIA_AVERAGE_RENDERING_TIME'), boardDetail.renderingTimeInSeconds, 'none')
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-md-6' },
                _react2.default.createElement(
                  'div',
                  { className: 'form-group row' },
                  _react2.default.createElement(
                    'label',
                    { className: 'col-xs-6 control-label u_textGrayColor' },
                    localization.getText('REPORT_LABEL_VERSION')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    ' ',
                    boardDetail.version,
                    !boardDetail.type && _react2.default.createElement(ViewHistoryIcon, {
                      onClick: _this2.viewReportHistory,
                      keys: [_Izenda22.default.PERMISSION_KEY.ReportsActionsViewReportHistory]
                    })
                  )
                ),
                renderItemInfo(localization.getText('COMMON_CRITERIA_CREATED_DATE'), (0, _Izenda10.default)(_Izenda24.default.currentUser.dateFormat, boardDetail.created), SearchCriteria[4].value),
                renderItemInfo(localization.getText('COMMON_CRITERIA_EDITED_DATE'), (0, _Izenda10.default)(_Izenda24.default.currentUser.dateFormat, boardDetail.modified), SearchCriteria[6].value),
                renderItemInfo(localization.getText('COMMON_CRITERIA_LAST_VIEWED'), (0, _Izenda10.default)(_Izenda24.default.currentUser.dateFormat, boardDetail.lastViewed), 'none')
              )
            )
          )
        );
      };

      return _react2.default.createElement(
        _Izenda4.default,
        {
          renderCollapseContent: true,
          header: header,
          initState: (0, _fp.get)('expanedOption', header),
          footer: !isSubscribeMode && footer,
          collapsible: true,
          className: (0, _classnames2.default)('report-detail', props.className)
        },
        isSubscribeMode ? _react2.default.createElement(_Izenda16.default, {
          reportId: boardDetail.id,
          reportType: boardDetail.type,
          subscribedInstancesStore: reportSubscriptionStore,
          onClose: this.closeSubcribe
        }) : _react2.default.createElement(DetailBody, { boardDetail: boardDetail, localization: props.localization })
      );
    }
  }]);
  return ReportDetail;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = ReportDetail;
module.exports = exports['default'];

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(148);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(42);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(233);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(30);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(633);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2642);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(12);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(45);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(15);

var _Izenda20 = _interopRequireDefault(_Izenda19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportDetailFooter.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var EmailButton = (0, _Izenda4.default)()(_Izenda10.default);

var SubscribeBtn = (0, _Izenda4.default)()(function (props) {
  return _react2.default.createElement(_Izenda10.default, (0, _extends3.default)({ label: _Izenda16.default.getText('COMMON_LABEL_SUBSCRIBE') }, props));
});

var ExportBtn = (0, _Izenda4.default)()(function (props) {
  return _react2.default.createElement(_Izenda12.default.ExportReportButton, props);
});

var DeleteBtn = (0, _Izenda4.default)()(function (props) {
  return _react2.default.createElement(_Izenda10.default, (0, _extends3.default)({ label: _Izenda16.default.getText('COMMON_LABEL_DELETE') }, props));
});

var MoveBtn = (0, _Izenda4.default)()(function (props) {
  return _react2.default.createElement(_Izenda10.default, (0, _extends3.default)({ label: _Izenda16.default.getText('COMMON_LABEL_MOVE') }, props));
});

var CopyBtn = (0, _Izenda4.default)()(function (props) {
  return _react2.default.createElement(_Izenda10.default, (0, _extends3.default)({ label: _Izenda16.default.getText('COMMON_LABEL_COPY') }, props));
});

var PrintBtn = (0, _Izenda4.default)()(function (props) {
  return _react2.default.createElement(_Izenda12.default.PrintReportButton, props);
});

var ReportDetailFooter = function ReportDetailFooter(props) {
  var localization = props.localization,
      store = props.store,
      authorization = props.authorization;

  var boardDetail = props.boardDetail || {};
  var reportId = boardDetail.id;
  var hasExportingLicense = authorization.checkLicense(_Izenda18.default.LICENSE_KEY.Exporting);
  var hasReportDesginerLicense = authorization.checkLicense(_Izenda18.default.LICENSE_KEY.ReportDesigner);
  var hasScheduleLicense = authorization.checkLicense(_Izenda18.default.LICENSE_KEY.Scheduling);
  var _AuthorizationConstan = _Izenda6.default.PERMISSION_KEY,
      ReportsActionsEmail = _AuthorizationConstan.ReportsActionsEmail,
      ReportsActionsOverwriteExistingReport = _AuthorizationConstan.ReportsActionsOverwriteExistingReport;

  var checkShowMenuRight = authorization.checkPrivileges([ReportsActionsEmail]);
  var hasOverwriteExistingReport = authorization.checkPrivileges([ReportsActionsOverwriteExistingReport]);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-md-12 text-right' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-ActionBar' },
          _react2.default.createElement(
            _Izenda8.default,
            null,
            _react2.default.createElement(
              _Izenda10.default,
              { onClick: props.handleClickOpen },
              localization.getText('COMMON_LABEL_OPEN')
            ),
            boardDetail.accessPriority !== _Izenda5.ACCESS_RIGHT.Locked && boardDetail.accessPriority !== _Izenda5.ACCESS_RIGHT.ViewOnly && boardDetail.accessPriority !== _Izenda5.ACCESS_RIGHT.NoAccess && _react2.default.createElement(
              'div',
              { className: 'btn-group' },
              _react2.default.createElement(
                _Izenda10.default,
                {
                  className: 'dropdown-toggle',
                  'data-toggle': 'dropdown',
                  label: localization.getText('COMMON_LABEL_EDIT') },
                _react2.default.createElement('span', { className: 'caret' })
              ),
              _react2.default.createElement(
                'ul',
                { className: 'dropdown-menu' },
                (boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.FullAccess || boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.QuickEdit || boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.SaveAs) && _react2.default.createElement(
                  'li',
                  null,
                  ' ',
                  _react2.default.createElement(
                    'a',
                    { onClick: props.handleClickQuickEdit },
                    localization.getText('REPORT_LABEL_QUICK_EDIT')
                  )
                ),
                hasReportDesginerLicense && hasOverwriteExistingReport && (boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.FullAccess || boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.SaveAs) && _react2.default.createElement(
                  'li',
                  null,
                  ' ',
                  _react2.default.createElement(
                    'a',
                    { onClick: props.handleClickDesign },
                    localization.getText('REPORT_LABEL_DESIGN')
                  )
                )
              )
            ),
            boardDetail.copyable && (boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.FullAccess || boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.QuickEdit || boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.SaveAs) && _react2.default.createElement(CopyBtn, {
              onClick: props.handleClickCopy, keys: [_Izenda6.default.PERMISSION_KEY.ReportsCanCreateNewReportValue] }),
            boardDetail.movable && (boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.FullAccess && !boardDetail.isGlobal || boardDetail.isGlobal && _Izenda20.default.currentUser.systemAdmin && !_Izenda20.default.tenantId) && _react2.default.createElement(MoveBtn, {
              onClick: props.handleClickMove,
              keys: [_Izenda6.default.PERMISSION_KEY.ReportsActionsOverwriteExistingReport] }),
            hasExportingLicense && !boardDetail.type && _react2.default.createElement(PrintBtn, {
              store: store,
              print: store.printReport,
              id: reportId,
              name: boardDetail.name,
              keys: [_Izenda6.default.PERMISSION_KEY.ReportsActionsPrint] }),
            !boardDetail.type && hasExportingLicense && _react2.default.createElement(ExportBtn, {
              store: store,
              'export': store.exportReport,
              id: reportId,
              name: boardDetail.name,
              keys: [_Izenda6.default.PERMISSION_KEY.ReportsActionsExporting],
              menuRight: !boardDetail.deletable || boardDetail.accessPriority !== _Izenda5.ACCESS_RIGHT.FullAccess || !!boardDetail.type || !checkShowMenuRight }),
            !boardDetail.type && _react2.default.createElement(EmailButton, {
              onClick: props.openEmailPopup,
              label: localization.getText('COMMON_LABEL_EMAIL'),
              keys: [_Izenda6.default.PERMISSION_KEY.ReportsActionsEmail] }),
            hasScheduleLicense && !boardDetail.type && _react2.default.createElement(SubscribeBtn, {
              onClick: props.handleClickSubscribe,
              keys: [_Izenda6.default.PERMISSION_KEY.ReportsActionsSubscribe] }),
            boardDetail.deletable && boardDetail.accessPriority === _Izenda5.ACCESS_RIGHT.FullAccess && _react2.default.createElement(DeleteBtn, {
              onClick: props.deleteReport,
              keys: [_Izenda6.default.PERMISSION_KEY.ReportsActionsDel] })
          )
        )
      )
    )
  );
};
exports.default = (0, _Izenda2.default)(_Izenda14.default)(ReportDetailFooter);
module.exports = exports['default'];

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(437);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(50);

var _Izenda4 = __webpack_require__(31);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(119);

var _Izenda7 = __webpack_require__(225);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(200);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Delete Report
 * @param {object} props
 * @param {object} event
 */
var deleteReport = function deleteReport(props, event) {
  var boardDetail = props.boardDetail,
      reportSubCategory = props.reportSubCategory,
      loader = props.loader,
      store = props.store,
      router = props.router;

  var message = boardDetail.type === 0 ? _Izenda3.MESSAGES.M05a : _Izenda3.MESSAGES.M05b;

  props.confirmFn('Confirmation', {
    description: String.format(message, boardDetail.name)
  }).then(function () {
    loader.startLoading();
    return store.deleteReport(boardDetail, reportSubCategory);
  }).then(function (result) {
    !(0, _fp.isEmpty)(result) && router.push(_Izenda5.default.getReportUrl('List', {
      reportType: boardDetail.type
    }));
    return null;
  }).finally(loader.endLoading.bind(loader));
};

/**
 * Save Subscription
 * @param {object} props
 * @param {object} subData
 */

// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportDetailFooterActions.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var onSaveSubscription = function onSaveSubscription(props, subData) {
  props.reportSubscriptionStore.model.updateSubscribedInstances(subData);
};

/**
 * on Click Design
 * @param {object} props
 */
var onClickDesign = function onClickDesign(props) {
  var boardDetail = props.boardDetail || {};
  props.history.push('/new/' + boardDetail.id);
};

/**
 * Open Email Popup
 * @param {object} props
 * @param {object} e
 */
var openEmailPopup = function openEmailPopup(props, e) {
  props.checkValidReport().then(function (result) {
    if (!result) {
      return;
    }
    var designerStore = props.designerStore,
        store = props.store,
        boardDetail = props.boardDetail,
        localization = props.localization;

    var reportId = boardDetail.id;

    var handleCloseEmailPopup = function handleCloseEmailPopup(email) {
      if (!email) {
        return false;
      }
      // No need to check filters when email report link
      if ((0, _fp.get)('deliveryMethod', email) === _Izenda6.DELIVERY_METHOD.link) {
        return store.sendEmail(null, email, reportId);
      }

      return _Izenda8.default.checkRequiredFilters(designerStore, reportId).then(function (isValidFilter) {
        if (!isValidFilter) {
          return localization.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_REQUIRED_FILTER_EMAIL');
        }
        return store.sendEmail(null, email, reportId);
      });
    };

    props.openPopup(_Izenda2.default, {
      onClosed: handleCloseEmailPopup,
      type: _Izenda6.EMAIL_TYPE.report,
      reportId: reportId
    });
  });
};

/**
 * Click Open
 * @param {object} props
 * @param {object} _
 */
var handleClickOpen = function handleClickOpen(props, _) {
  var store = props.store,
      router = props.router;

  var boardDetail = props.boardDetail || {};
  var reportId = boardDetail.id;
  var viewUrl = _Izenda5.default.getReportUrl('View', { id: reportId });
  store.updateReportId(reportId);
  var previousLink = _Izenda5.default.getPreviousLink();

  store.savePreviousLink && store.savePreviousLink(previousLink);
  router.push(viewUrl);
};

/**
 * Click QuickEdit
 * @param {object} props
 * @param {object} _
 */
var handleClickQuickEdit = function handleClickQuickEdit(props, _) {
  var store = props.store,
      router = props.router;

  props.checkValidReport().then(function (result) {
    var boardDetail = props.boardDetail || {};
    var previousLink = _Izenda5.default.getPreviousLink();

    store.savePreviousLink && store.savePreviousLink(previousLink);
    var editUrl = _Izenda5.default.getReportUrl('Edit', { id: boardDetail.id });
    result && router.push(editUrl);
  });
};

/**
 * Click Design
 * @param {object} props
 * @param {object} _
 */
var handleClickDesign = function handleClickDesign(props, _) {
  var boardDetail = props.boardDetail || {};
  var reportId = boardDetail.id;
  var query = {};
  query['' + _Izenda9.SOURCE_PATH_QUERY_KEY] = _Izenda5.default.getPreviousLink();

  var viewReportDesignerUrl = {
    pathname: _Izenda5.default.getReportDesignerUrl('ReportDesignerDetail', {
      reportId: reportId
    }),
    query: query
  };
  props.router.push(viewReportDesignerUrl);
};

/**
 * Click Subscribe
 * @param {object} props
 * @param {object} _
 */
var handleClickSubscribe = function handleClickSubscribe(props, _) {
  var model = props.store.model;
  model.items.resetSubscribes();
  var boardDetail = props.boardDetail || {};
  props.checkValidReport().then(function (result) {
    result && boardDetail.toggleSubscribeMode();
  });
};

/**
 * Click Copy
 * @param {object} props
 * @param {object} _
 */
var handleClickCopy = function handleClickCopy(props, _) {
  return props.checkValidReport().then(function (result) {
    result && props.viewCopyPopup();
  });
};

/**
 * Click Move
 * @param {object} props
 * @param {object} _
 */
var handleClickMove = function handleClickMove(props, _) {
  return props.checkValidReport().then(function (result) {
    result && props.viewMovePopup();
  });
};

/**
 * Click Export
 * @param {object} props
 * @param {any} callBack
 */
var handleClickExport = function handleClickExport(props, callBack) {
  return props.checkValidReport().then(function (result) {
    result && callBack();
  });
};

exports.default = (0, _recompose.compose)((0, _recompose.withHandlers)({
  deleteReport: (0, _fp.curry)(deleteReport),
  onSaveSubscription: (0, _fp.curry)(onSaveSubscription),
  onClickDesign: (0, _fp.curry)(onClickDesign),
  openEmailPopup: (0, _fp.curry)(openEmailPopup),
  handleClickOpen: (0, _fp.curry)(handleClickOpen),
  handleClickQuickEdit: (0, _fp.curry)(handleClickQuickEdit),
  handleClickDesign: (0, _fp.curry)(handleClickDesign),
  handleClickSubscribe: (0, _fp.curry)(handleClickSubscribe),
  handleClickCopy: (0, _fp.curry)(handleClickCopy),
  handleClickMove: (0, _fp.curry)(handleClickMove),
  handleClickExport: (0, _fp.curry)(handleClickExport)
}), (0, _recompose.setPropTypes)({
  store: _propTypes2.default.object.isRequired
}));
module.exports = exports['default'];

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.BoardName.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

// This component is only used for name of report/dashboard part on lists.
!function () {

  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var connect = __webpack_require__(2);

  var Validator = __webpack_require__(23);
  var TextHighLight = __webpack_require__(62);
  var Input = Validator()(__webpack_require__(17));
  var ACCESS_RIGHT = __webpack_require__(42).ACCESS_RIGHT;
  var uiState = __webpack_require__(15);

  var _require = __webpack_require__(1),
      isObject = _require.isObject;

  module.exports = function (constants) {
    var SearchCriteria = constants.SEARCH_CRITERIA;

    var BoardName = React.createClass({
      displayName: 'BoardName',

      propTypes: {
        store: React.PropTypes.object,
        dataDetail: React.PropTypes.object
      },

      getInitialState: function getInitialState() {
        this.originalName = this.props.dataDetail.name;
        return { editMode: false };
      },

      /**
       * Handle enter
       * @param {Object} event
       */
      handleEnter: function handleEnter(e) {
        if (e.key === 'Enter') {
          this.handleSaveName();
        }
      },

      handleSaveName: function handleSaveName(e) {
        var props = this.props;
        var dataDetail = props.dataDetail;
        dataDetail.setEditMode && dataDetail.setEditMode(true);

        // Stop event blur if current event is mouse down
        if (e && e.type === 'mousedown') {
          e.preventDefault();
          e.stopPropagation();
        }

        var valManager = this.props.validation;
        if (dataDetail.name === this.originalName) {
          dataDetail.setEditMode && dataDetail.setEditMode(false);
          this.setState({ editMode: false });
          return;
        }
        var loader = this.props.loader;

        valManager.validate('name').then(function (success) {
          if (success) {
            loader.startLoading();
            return props.store.rename(dataDetail).then(function (response) {
              // If rename is successfully then API just returns boolean value, otherwise it returns an object.
              if (!isObject(response)) {
                dataDetail.setEditMode && dataDetail.setEditMode(false);
                props.updateName && props.updateName(dataDetail.name);
                this.originalName = props.dataDetail.name;
                this.setState({ editMode: false });
              } else {
                ReactDOM.findDOMNode(this.refs.inputName.refs.editor).focus();
                valManager.updateErrors(response.messages);
              }
            }.bind(this)).finally(loader.endLoading.bind(loader));
          }
        }.bind(this));
      },

      /**
       * Handle cancel button
       */
      handleCancelRename: function handleCancelRename() {
        var props = this.props;
        var dataDetail = props.dataDetail;
        dataDetail.setEditMode && dataDetail.setEditMode(false);
        this.setState({ editMode: false });
        this.props.dataDetail.name = this.originalName;
      },

      /**
       * Rename
       * @param {Object} event
       */
      handleRename: function handleRename(e) {
        var props = this.props;
        var dataDetail = props.dataDetail;
        dataDetail.setEditMode && dataDetail.setEditMode(true);
        this.setState({ editMode: true });

        e.preventDefault();
        e.stopPropagation();
      },

      /**
       * Change name
       * @param {Object} input
       */
      onChangeName: function onChangeName(input) {
        this.props.dataDetail.name = input.target.value;
        this.setState({ editMode: this.state.editMode });
      },

      /**
       * Render name component with edit mode
       * @return {Object} component
       */
      renderEditName: function renderEditName() {
        var dataDetail = this.props.dataDetail;
        var localization = this.props.localization;

        return React.createElement(
          'div',
          { className: 'title-edit form-group' },
          React.createElement(
            'div',
            { className: 'input-group' },
            React.createElement(Input, {
              ref: 'inputName',
              value: dataDetail.name,
              onChange: this.onChangeName,
              onKeyPress: this.handleEnter,
              onBlur: this.handleSaveName,
              field: 'name',
              validations: constants.CONSTRAINTS.NAME,
              className: 'form-control',
              autoFocus: true
            }),
            React.createElement(
              'span',
              { className: 'input-group-btn' },
              React.createElement(
                'button',
                {
                  className: 'btn btn-default',
                  onMouseDown: this.handleSaveName,
                  title: localization.getText('COMMON_TOOLTIP_UPDATE_CHANGE')
                },
                React.createElement('span', { className: 'icon-ok success-color' })
              ),
              React.createElement(
                'button',
                {
                  className: 'btn btn-default',
                  onMouseDown: this.handleCancelRename,
                  title: localization.getText('COMMON_TOOLTIP_CANCEL_CHANGE')
                },
                React.createElement('span', { className: 'icon-cancel' })
              )
            )
          )
        );
      },

      /**
       * Render name component with view mode
       * @return {Object} component
       */
      renderViewName: function renderViewName() {
        var props = this.props;
        var dataDetail = props.dataDetail;
        var model = props.store.items || {};

        return React.createElement(
          'div',
          { className: 'u_flexHorizontal' },
          React.createElement(
            'div',
            { className: 'u_textTruncate' },
            React.createElement(
              'a',
              { onClick: props.onClick },
              React.createElement(TextHighLight, {
                highlight: model.searchText,
                text: dataDetail.name,
                className: 'text-bold',
                notHighlight: dataDetail.isNotHighLight && dataDetail.isNotHighLight(model.searchType, SearchCriteria[1].value)
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'u_fullInlineBlock' },
            ((props.accessPriority === ACCESS_RIGHT.FullAccess || props.accessPriority === ACCESS_RIGHT.QuickEdit || props.accessPriority === ACCESS_RIGHT.SaveAs) && props.hasRenamePermission && !dataDetail.isGlobal || dataDetail.isGlobal && uiState.currentUser.systemAdmin && !uiState.tenantId) && React.createElement(
              'a',
              { onClick: this.handleRename },
              React.createElement('span', { className: 'icon-pencil-new', title: this.props.localization.getText('COMMON_TOOLTIP_RENAME') })
            )
          )
        );
      },

      /**
       * Render component
       * @return {Object} component
       */
      render: function render() {
        return React.createElement(
          'div',
          null,
          this.state.editMode ? this.renderEditName() : this.renderViewName()
        );
      }
    });

    return connect()(BoardName);
  };
}();

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportListAction.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withState = __webpack_require__(9).withState;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var action = compose(withState('isGlobalExpand', 'updateGlobalExpand', true), withState('isLocalExpand', 'updateLocalExpand', true), withHandlers({
    toggle: curry(toggle)
  }));

  function toggle(props, isGlobal) {
    if (isGlobal) {
      props.updateGlobalExpand(!props.isGlobalExpand);
    } else {
      props.updateLocalExpand(!props.isLocalExpand);
    }
  }

  module.exports = action;
}();

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(631);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportEditor.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ReportEditor = function ReportEditor(props) {
  return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, props, { editMode: true }));
};

exports.default = ReportEditor;
module.exports = exports['default'];

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Store = exports.Component = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2647);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(324);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2698);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(42);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(45);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(31);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(15);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(40);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

var _Izenda19 = __webpack_require__(340);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportDesignerRoot = (_dec = (0, _Izenda8.default)({ licenseKey: _Izenda12.default.LICENSE_KEY.ReportDesigner }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ReportDesignerRoot, _Component);

  function ReportDesignerRoot(props) {
    (0, _classCallCheck3.default)(this, ReportDesignerRoot);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportDesignerRoot.__proto__ || (0, _getPrototypeOf2.default)(ReportDesignerRoot)).call(this, props));

    _this.checkPermissions(props);
    _this.loadInitial(props);
    return _this;
  }

  (0, _createClass3.default)(ReportDesignerRoot, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isLocationChanged = !(0, _fp.get)('location.state.keepState', nextProps) && nextProps.location.key !== this.props.location.key;
      this.checkPermissions(nextProps);
      if (isLocationChanged) {
        this.loadInitial(nextProps, true);
      }
    }

    /**
     * Check permission for report designer page
     * @param {object} props 
     */

  }, {
    key: 'checkPermissions',
    value: function checkPermissions(props) {
      var authorization = props.authorization,
          router = props.router,
          reportId = props.params.reportId;

      var hasAddNewPrivileges = authorization.checkPrivileges([_Izenda10.default.PERMISSION_KEY.ReportsCanCreateNewReportValue]);
      var hasOverwritePrivilege = authorization.checkPrivileges([_Izenda10.default.PERMISSION_KEY.ReportsActionsOverwriteExistingReport]);

      if ((0, _fp.isNil)(reportId) && !hasAddNewPrivileges || !(0, _fp.isNil)(reportId) && !hasOverwritePrivilege) {
        router.push(_Izenda14.default.getNoPermissionUrl());
      }
    }
    /**
     * Init state for report designer page
     * @param {object} props 
     * @param {boolean} isReload Indicate whether user cancel the change and the report designer is reload
     */

  }, {
    key: 'loadInitial',
    value: function loadInitial(props, isReload) {
      // License is expired, navigate to Settings pages
      if (_Izenda16.default.expiredLicense) {
        var settingLink = _Izenda14.default.getSettingsUrl();
        props.router.push(settingLink);
      }

      var reportId = props.params.reportId,
          location = props.location;

      this.key = (0, _fp.uniqueId)('ReportDesignerLocationID_');

      this.store = new _Izenda4.default(false, reportId, null, isReload);
      this.store.updateReportListURI(_Izenda20.default.getValueByKey((0, _fp.get)('query', location), _Izenda21.SOURCE_PATH_QUERY_KEY));
      this.menuStore = new _Izenda6.default(reportId);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var isNewDefault = (0, _fp.isNil)(this.props.params.reportId);
      return !_Izenda16.default.expiredLicense && _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({
        key: this.key,
        store: this.store,
        menuStore: this.menuStore,
        isNewDefault: isNewDefault
      }, this.props));
    }
  }]);
  return ReportDesignerRoot;
}(_react.Component)) || _class);
exports.Component = _Izenda2.default;
exports.Store = _Izenda4.default;
exports.Container = ReportDesignerRoot;

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _bluebird = __webpack_require__(18);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesigner.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

var _Izenda7 = __webpack_require__(332);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(156);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(333);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2648);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2649);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2650);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2659);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2672);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(2681);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(2683);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(2688);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _Izenda29 = __webpack_require__(2693);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _Izenda31 = __webpack_require__(331);

var _Izenda32 = _interopRequireDefault(_Izenda31);

var _Izenda33 = __webpack_require__(339);

var _Izenda34 = _interopRequireDefault(_Izenda33);

var _Izenda35 = __webpack_require__(104);

var _Izenda36 = _interopRequireDefault(_Izenda35);

var _Izenda37 = __webpack_require__(45);

var _Izenda38 = _interopRequireDefault(_Izenda37);

var _Izenda39 = __webpack_require__(2697);

var _Izenda40 = _interopRequireDefault(_Izenda39);

var _Izenda41 = __webpack_require__(78);

var _Izenda42 = _interopRequireDefault(_Izenda41);

var _Izenda43 = __webpack_require__(61);

var _Izenda44 = _interopRequireDefault(_Izenda43);

var _Izenda45 = __webpack_require__(606);

var _Izenda46 = _interopRequireDefault(_Izenda45);

var _Izenda47 = __webpack_require__(42);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportDesigner = (_dec = (0, _Izenda2.default)(_Izenda40.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportDesigner, _Component);

  function ReportDesigner(props) {
    (0, _classCallCheck3.default)(this, ReportDesigner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportDesigner.__proto__ || (0, _getPrototypeOf2.default)(ReportDesigner)).call(this, props));

    _this.registerUpdateResultFuntion = function (updateResults) {
      _this.updateResultFunction = updateResults;
    };

    _this.onPageChange = function (nextPage, currentPage) {
      if (nextPage === currentPage) {
        return;
      }

      var _this$props = _this.props,
          store = _this$props.store,
          onPageChanging = _this$props.onPageChanging;

      var changePageStatus = {
        isChangePage: true,
        currentPage: currentPage,
        nextPage: nextPage
      };
      if (nextPage === _Izenda4.default.PAGE_NAME.FIELDS || nextPage === _Izenda4.default.PAGE_NAME.FORMATS) {
        store.switchToDesignReportContainer = false;
        _this.updateResultFunction(changePageStatus).then(function (success) {
          success && onPageChanging(nextPage, currentPage, false);
        });
      } else {
        store.switchToDesignReportContainer = true;
        _this.updateResultFunction(changePageStatus).then(function (success) {
          success && onPageChanging(nextPage, currentPage, true);
        });
      }
    };

    _this.getContextMenu = function (reportDef) {
      var _this$props2 = _this.props,
          menuStore = _this$props2.menuStore,
          authorization = _this$props2.authorization,
          isNewDefault = _this$props2.isNewDefault,
          PERMISSION_KEY = _this$props2.authorizationConstants.PERMISSION_KEY,
          _this$props2$store = _this$props2.store,
          dataSourceStore = _this$props2$store.dataSourceStore,
          advancedMode = _this$props2$store.advancedMode,
          contextMenuActiveLink = _this$props2.menuStore.contextMenuActiveLink;

      if (advancedMode) {
        var hasDataSourcePermission = authorization.checkPrivileges([PERMISSION_KEY.ReportsDataSourcesAdvancedDataSources]) || authorization.checkPrivileges([PERMISSION_KEY.FullReportAndDashboardAccess]);

        !hasDataSourcePermission && menuStore.excludeMenuItemByKey('DataSource');

        if (!hasDataSourcePermission || !isNewDefault) {
          var dataSourceStoreLoadInitialFunc = contextMenuActiveLink ? dataSourceStore.loadInitial : dataSourceStore.loadInitialWithUpdateFilter;

          // Load Data Source Data if not have this tab
          return dataSourceStoreLoadInitialFunc.call(dataSourceStore).then(dataSourceStore.loadDataSourceDetail.bind(dataSourceStore)).then(function () {
            // all data is loaded sucessfully >> enable context menu
            menuStore.updateMenuState(true);
            menuStore.updateMenuStatus(true);
            return reportDef;
          });
        }
      }

      // init menu context, status = disabled
      // its status will be enabled when report data is loaded successfully
      menuStore.updateMenuStatus(true);
      return (0, _bluebird.resolve)(reportDef);
    };

    _this.settingStore = new _Izenda34.default();
    _this.securityManagerStore = new _Izenda46.default();
    _this.init();
    return _this;
  }

  (0, _createClass3.default)(ReportDesigner, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var props = this.props,
          securityManagerStore = this.securityManagerStore,
          _props = this.props,
          store = _props.store,
          menuStore = _props.menuStore,
          loader = _props.loader,
          authorization = _props.authorization,
          detectReportChange = _props.detectReportChange;


      loader.startLoading();
      store.init();

      // Get menu base on privileges & license
      menuStore.filterContextMenuByLicense(authorization);
      _Izenda6.default.isMobile && menuStore.filterContextMenuForMobile();

      if ((0, _fp.isNil)(store.model.reportId)) {
        store.loadDefaultAccess().finally(loader.endLoading.bind(loader));
      } else {
        securityManagerStore.checkAccessPage(props, store.model.reportId, function (accessPriority) {
          return accessPriority === _Izenda47.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda47.ACCESS_RIGHT.SaveAs;
        }).bind(this).then(function (canAccessPage) {
          canAccessPage && store.cancelChanges().then(function () {
            store.loadReportDesigner().bind(_this2).then(_this2.getContextMenu).then(function (reportDef) {
              var noPermission = reportDef && !(0, _fp.isNil)(reportDef.messages) && !(0, _fp.isEmpty)(reportDef.messages[0].detail) && reportDef.messages[0].detail === 'NoPermission';

              return !noPermission ? detectReportChange() : null;
            }).finally(loader.endLoading.bind(loader));
          });

          !canAccessPage && loader.endLoading();
        });
      }

      // reload performance in advanced settings
      _Izenda36.default.loadPerformance();
      if (store.isNewReport) {
        menuStore.enableMenuItems.length > 0 && (menuStore.contextMenuActiveLink = menuStore.enableMenuItems[0].key);
      }

      this.setDisableSettingLevel(menuStore.contextMenuActiveLink);
    }

    /**
     * Only enable setting level in ReportDesigner when DataSource tab is opened
     * @param {string} contextMenuActiveLink
     */

  }, {
    key: 'setDisableSettingLevel',
    value: function setDisableSettingLevel(contextMenuActiveLink) {
      contextMenuActiveLink === _Izenda4.default.PAGE_NAME.DATA_SOURCE ? _Izenda6.default.enableSystemSetting() : _Izenda6.default.updateDisableSystemSetting();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      var menuStore = this.props.menuStore;

      this.setDisableSettingLevel(menuStore.contextMenuActiveLink);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // observe changing tenantId, then reload data for Report Designer
      this.disposeObserveTenantId = _mobx2.default.observe(_Izenda6.default, 'tenantId', this.props.handleTenantChange);
      // Observe the changes of cascading
      this.cascadingChangedDisposer = _mobx2.default.observe(this.props.store, 'showCascadingChangedMessage', this.props.handleCascadingChanged);
      // Observe the changes of need update result
      this.needUpdateResultDisposer = _mobx2.default.observe(this.props.store, 'needUpdateResult', this.props.handleNeedUpdateResultChanged);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disposeObserveTenantId && this.disposeObserveTenantId();
      this.cascadingChangedDisposer && this.cascadingChangedDisposer();
      this.needUpdateResultDisposer && this.needUpdateResultDisposer();
      this.props.store.destroy();
      this.settingStore.destroy();
    }

    /**
     * Register the update result function
     */

    /**
     * Handle when change page
     */


    /**
     * Get context menu
     */

  }, {
    key: 'render',
    value: function render() {
      var settingStore = this.settingStore,
          onPageChange = this.onPageChange,
          registerUpdateResultFuntion = this.registerUpdateResultFuntion,
          _props2 = this.props,
          store = _props2.store,
          route = _props2.route,
          params = _props2.params,
          localization = _props2.localization,
          disableReport = _props2.disableReport,
          authorization = _props2.authorization,
          detectReportChange = _props2.detectReportChange,
          menuStore = _props2.menuStore,
          isNewDefault = _props2.isNewDefault,
          location = _props2.location,
          saveDraftReport = _props2.saveDraftReport,
          fieldsStore = _props2.store.fieldsStore;

      // Filter Report Designer tab by license

      var REPORT_DESIGNER_TAB = (0, _fp.filter)(function (tab) {
        return authorization.checkLicense(_Izenda38.default.LICENSE_KEY.Scheduling) || tab !== 'Schedule';
      }, _Izenda4.default.REPORT_DESIGNER_TAB);

      return _react2.default.createElement(
        'section',
        { className: 'izenda-Wrapper' },
        _react2.default.createElement(_Izenda32.default, { store: settingStore }),
        _react2.default.createElement(
          _Izenda12.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'izenda-TableLayout u_paddingTopBottom' },
            !(0, _fp.isNil)(menuStore.contextMenuActiveLink) && _react2.default.createElement(
              _Izenda8.default,
              { isExpanded: isExpanded(menuStore) },
              _react2.default.createElement(_Izenda14.default, {
                menuStore: menuStore,
                onPageChanging: onPageChange,
                disableReportDesigner: store.disableReportDesigner,
                dataSource: menuStore.visibleMenuItems
              })
            ),
            !store.disableReportDesigner && !(0, _fp.isNil)(menuStore.contextMenuActiveLink) ? _react2.default.createElement(
              _Izenda10.default,
              null,
              _react2.default.createElement(
                _Izenda16.default,
                { componentKey: menuStore.contextMenuActiveLink },
                REPORT_DESIGNER_TAB.map(function (pageName) {
                  return _react2.default.createElement(_Izenda16.default.Item, {
                    key: pageName,
                    componentKey: pageName,
                    component: _Izenda18.default,
                    pageName: pageName,
                    pageInfo: getPageInfo(pageName),
                    store: store,
                    menuStore: menuStore,
                    fieldsStore: fieldsStore,
                    isNewDefault: isNewDefault,
                    disableReport: disableReport,
                    detectReportChange: detectReportChange,
                    route: route,
                    location: location,
                    saveDraftReport: saveDraftReport,
                    registerUpdateResultFuntion: registerUpdateResultFuntion,
                    params: params
                  });
                })
              )
            ) : !(0, _fp.isNil)(menuStore.contextMenuActiveLink) && _react2.default.createElement(
              'section',
              { className: 'izenda-MainContent' },
              _react2.default.createElement(
                _Izenda44.default,
                { type: 'error', autoHide: false },
                localization.getText('COMMON_MESSAGES_NOPERMISSION_VIEWREPORT')
              )
            )
          )
        )
      );
    }
  }]);
  return ReportDesigner;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object.isRequired
}, _temp)) || _class);
exports.default = ReportDesigner;


function getPageInfo(pageName) {
  switch (pageName) {
    case 'DataSource':
      return _Izenda20.default;
    case 'Fields':
      return _Izenda22.default;
    case 'Formats':
      return _Izenda24.default;
    case 'Exporting':
      return _Izenda30.default;
    case 'Schedule':
      return _Izenda26.default;
    case 'Access':
      return _Izenda28.default;
    default:
      throw 'Not found ' + pageName;
  }
}

/*  collapse Sidebar when switching to Field tab */
function isExpanded(menuStore) {
  if (_Izenda42.default.isMobileDevice()) {
    return true;
  }
  return menuStore.contextMenuActiveLink === _Izenda4.default.PAGE_NAME.DATA_SOURCE;
}
module.exports = exports['default'];

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(334);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportDesignerMenu = function ReportDesignerMenu(props) {
  var menuStore = props.menuStore,
      onPageChanging = props.onPageChanging,
      dataSource = props.dataSource,
      disableReportDesigner = props.disableReportDesigner;


  return _react2.default.createElement(_Izenda4.default, { dataSource: dataSource,
    activeKey: menuStore.contextMenuActiveLink,
    enabled: menuStore.menuStatus && !disableReportDesigner,
    isValidLicense: true,
    onSelected: onPageChanging });
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerMenu.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
exports.default = (0, _Izenda2.default)()(ReportDesignerMenu);
module.exports = exports['default'];

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.RenderSwitcher.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var NotFound = __webpack_require__(213);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      find = _require.find,
      isPlainObject = _require.isPlainObject,
      omit = _require.omit,
      assignAll = _require.assignAll;

  var RenderSwitcher = observer(React.createClass({
    displayName: 'RenderSwitcher',

    render: function render() {
      var props = this.props;
      var componentKey = props.componentKey;
      var restProps = omit(['componentKey', 'component'], props);

      var children = React.Children.toArray(props.children);

      var child = find(function (childComponent) {
        return childComponent.props.componentKey === componentKey;
      }, children);

      var renderingComponent = props.component;
      var renderingProps, renderingChild, renderingChildProps;

      var isRenderChildAsRoot = !renderingComponent;

      if (child) {
        var childComponent = child.props.component;
        ensure(childComponent, 'RenderSwitcher.Item requires component property');

        if (isPlainObject(childComponent)) {
          restProps = assignAll([childComponent, child.props, restProps]);
        } else {
          renderingChild = childComponent;
          renderingChildProps = omit(['componentKey', 'component'], child.props);
        }
      }

      var childElement = React.createElement(renderingChild || NotFound, renderingChildProps);

      return isRenderChildAsRoot ? childElement : React.createElement(renderingComponent, restProps, renderingChild ? childElement : null);
    }
  }));

  RenderSwitcher.Item = React.createClass({
    displayName: 'Item',

    render: function render() {
      return null;
    }
  });

  module.exports = RenderSwitcher;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportDesignerContent component
 */


var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__(9);

var _Izenda3 = __webpack_require__(2651);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(196);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2652);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda9 = __webpack_require__(2656);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2658);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(16);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(78);

var _Izenda16 = _interopRequireDefault(_Izenda15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_WIDTH = 0;

var ReportDesignerContent = (_dec = (0, _Izenda2.default)({ toClass: true }, (0, _recompose.onlyUpdateForKeys)(['pageName', 'isNewReport']), _Izenda4.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ReportDesignerContent, _Component);

  function ReportDesignerContent(props) {
    (0, _classCallCheck3.default)(this, ReportDesignerContent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportDesignerContent.__proto__ || (0, _getPrototypeOf2.default)(ReportDesignerContent)).call(this, props));

    var store = props.store,
        pageInfo = props.pageInfo;

    pageInfo.setStore(store);
    props.registerUpdateResultFuntion(props.onUpdateResults.bind(_this));
    return _this;
  }

  (0, _createClass3.default)(ReportDesignerContent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var store = nextProps.store,
          pageInfo = nextProps.pageInfo,
          pageName = nextProps.pageName;

      var isPageChanged = pageName !== this.props.pageName;

      if (isPageChanged) {
        pageInfo.setStore(store);
        pageInfo.reloadView && pageInfo.reloadView();
        store.validateReportId(false);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      var model = props.store.model;
      var handleErrorMessages = props.handleErrorMessages;

      // Observe change selected item in data source tree
      this.dispose = (0, _mobx.observe)(model, 'hasSelectedDataSource', function (change) {
        props.menuStore.updateMenuState(change);
      });

      // Observe error messages from child pages
      this.disposeErrorMessages = (0, _mobx.observe)(model, 'errorMessages', handleErrorMessages);
      props.store.validateReportId(false);

      // observe schedule tab with global report
      model.isGlobal && props.menuStore.toggleInvisibleItem('Schedule', !model.isGlobal);
      this.disposeScheduleTab = (0, _mobx.observe)(model, 'isGlobal', function (value) {
        props.menuStore.toggleInvisibleItem('Schedule', !value);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var pageInfo = this.props.pageInfo;

      pageInfo.destroy && pageInfo.destroy();

      this.dispose && this.dispose();

      this.disposeErrorMessages();

      _IzendaUiState2.default.enableSystemSetting();

      this.disposeScheduleTab();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = props.store,
          fieldsStore = props.fieldsStore,
          pageName = props.pageName,
          pageInfo = props.pageInfo;

      var onUpdateResults = props.onUpdateResults;
      var onAddReportPart = props.onAddReportPart;
      var onSave = props.onSave;
      var location = props.location;
      var onSaveAs = props.onSaveAs;
      var onCancelReport = props.onCancelReport;
      var onPreview = props.onPreview;
      var middlePanel = pageInfo.renderMiddlePanel ? pageInfo.renderMiddlePanel() : null;
      var mainPanel = pageInfo.renderMainContent();
      var doesShowOverlay = pageName === _Izenda14.default.PAGE_NAME.DATA_SOURCE && store.isEnableOverlay && !_Izenda16.default.isMobileDevice();

      return _react2.default.createElement(
        'section',
        { className: 'izenda-ReportDesigner izenda-TableLayout' },
        middlePanel && _react2.default.createElement(
          _Izenda6.default,
          { minWidth: MIN_WIDTH, hidden: store.disabled },
          middlePanel
        ),
        _react2.default.createElement(
          'div',
          { className: 'izenda-TableLayout-Cell', hidden: store.disabled },
          _react2.default.createElement(
            _Izenda10.default,
            {
              showOverlay: doesShowOverlay,
              classNames: 'izenda-Wrapper',
              OverlayComponent: _Izenda12.default,
              overlayComponentProps: { classNames: 'izenda-ReportDesigner-Overlay' }
            },
            _react2.default.createElement(
              'section',
              { className: 'izenda-Wrapper' },
              _react2.default.createElement(_Izenda8.default, {
                showUpdateResult: props.showUpdateResult,
                store: store,
                fieldsStore: fieldsStore,
                pageName: pageName,
                onUpdateResults: onUpdateResults,
                onAddReportPart: onAddReportPart,
                onSave: onSave,
                onSaveAs: onSaveAs,
                location: location,
                onCancelReport: onCancelReport,
                onPreview: onPreview
              }),
              mainPanel
            )
          )
        )
      );
    }
  }]);
  return ReportDesignerContent;
}(_react.Component)) || _class);
exports.default = ReportDesignerContent;
module.exports = exports['default'];

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _Izenda = __webpack_require__(1183);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(37);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _mobx = __webpack_require__(5);

var _recompose = __webpack_require__(9);

var _Izenda6 = __webpack_require__(31);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(12);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(15);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _fp = __webpack_require__(1);

var _Izenda12 = __webpack_require__(340);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportDesignerContentActions = (0, _recompose.compose)((0, _recompose.withState)('isNew', 'updateNew', function (props) {
  return props.isNewDefault;
}), (0, _recompose.withHandlers)({
  onUpdateResults: (0, _fp.curry)(onUpdateResults),
  onAddReportPart: (0, _fp.curry)(onAddReportPart),
  onSave: (0, _fp.curry)(onSave),
  onSaveAs: (0, _fp.curry)(onSaveAs),
  onCancelReport: onCancelReport,
  onPreview: onPreview,
  handleErrorMessages: handleErrorMessages
}), (0, _recompose.withProps)(function (props) {
  var pageName = props.pageName;

  var showUpdateResult = pageName === _Izenda5.PAGE_NAME.DATA_SOURCE || pageName === _Izenda5.PAGE_NAME.FIELDS || pageName === _Izenda5.PAGE_NAME.FORMATS;
  return { showUpdateResult: showUpdateResult };
}));
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerContentActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function onSaved(props, reportId) {
  var oldReportId = (0, _fp.get)('params.reportId', props);

  if (oldReportId !== reportId) {
    props.router.push({
      pathname: _Izenda7.default.getReportDesignerUrl('ReportDesignerDetail', {
        reportId: reportId
      }),
      state: {
        keepState: true
      }
    });
  }
}

function onUpdateResults(props, changePageStatus) {
  var loader = props.loader,
      reportFilters = props.fieldsStore.reportFilters,
      _props$store = props.store,
      model = _props$store.model,
      reportMode = _props$store.model.dataSource.reportMode,
      accessStore = _props$store.accessStore,
      store = props.store;


  var isChangePage = (0, _fp.getOr)(false, 'isChangePage', changePageStatus);
  var currentPage = (0, _fp.get)('currentPage', changePageStatus);
  var nextPage = (0, _fp.get)('nextPage', changePageStatus);

  var validateCyclePromise = (!isChangePage || currentPage === _Izenda5.PAGE_NAME.DATA_SOURCE) && reportMode === _Izenda5.ADVANCED ? store.validateCycleRelationships.bind(store) : function () {
    return (0, _bluebird.resolve)({ success: true });
  };

  // we do validate if user navigate to other screen from Data Source screen
  // we also do validate if user click update resolve or click save/save as
  var needValidateRelationship = isChangePage && currentPage === _Izenda5.PAGE_NAME.DATA_SOURCE || !isChangePage;

  loader.startLoading();
  store.model.setIsSavingReport(!isChangePage);
  reportFilters.resetUpdateResult();
  return (0, _bluebird.join)(validateReport(props, needValidateRelationship), validateCyclePromise(), function (result, validateCycleResult) {
    var finalResult = result.success && validateCycleResult.success;
    if (finalResult) {
      return props.saveDraftReport(!isChangePage, nextPage).then(function (result) {
        return props.pageName === _Izenda5.PAGE_NAME.ACCESS ? accessStore.initialAccessReportPage(model.reportId, model.reportAccess.draftAccesses, model.isGlobal).then(function () {
          return result;
        }) : (0, _bluebird.resolve)(result);
      });
    } else {
      var messages = result.messages || validateCycleResult.messages;
      return messages && messages.length > 0 ? props.confirmFn('Information', {
        description: messages[0].messages[0],
        type: 'info',
        isHTMLFormat: true,
        showCloseIndicator: true
      }).then(function () {
        return finalResult;
      }) : (0, _bluebird.resolve)(finalResult);
    }
  }).finally(loader.endLoading.bind(loader));
}

/**
 * Call to add new report part in report body
 */
function onAddReportPart(props, _) {
  var store = props.store;


  return store.addNewReportPart();
}

/**
 * Save the whole report
 */
function onSave(props, _) {
  var store = props.store,
      loader = props.loader,
      isNew = props.isNew,
      updateNew = props.updateNew,
      fieldsStore = props.fieldsStore,
      canSaveAs = props.store.canSaveAs,
      pageName = props.pageName;

  var allowToSave = (0, _fp.get)('masterModel.allowToSave', fieldsStore);
  var changePageStatus = {
    isChangePage: false,
    currentPage: pageName,
    nextPage: pageName
  };

  store.model.setIsSavingReport(true);

  if (isNew || store.model.checkDirty() || allowToSave) {
    return onUpdateResults(props, changePageStatus).then(function (result) {
      if (result) {
        return showFilterWarningMessage(props).then(function () {
          return canSaveAs ? saveReport(props) : openPopup(props, false);
        });
      }
      return false;
    }).then(function (success) {
      success && updateNew(false);
    }).finally(loader.endLoading.bind(loader));
  } else {
    store.alertDetails.set({
      success: true,
      message: _Izenda9.default.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
    });
  }
}

/**
 * Save As Report Designer:
 *  - Validate data > if data valid > open SaveAs Popup for new Report
 */
function onSaveAs(props, _) {
  var store = props.store;

  store.model.setIsSavingReport(true);
  store.setSaveAsMode(true);
  store.alertDetails && store.alertDetails.reset();
  var needValidateRelationship = true;
  return validateReport(props, needValidateRelationship).then(function (result) {
    if (result && !result.success) {
      store.model.updateErrorMessages(result.messages);
    }
    return result && result.success && showFilterWarningMessage(props).then(function () {
      return openPopup(props, true);
    });
  });
}

/**
 * Show messages and update error indicators accordingly with
 * error messages of report designer model.
 */
function handleErrorMessages(props) {
  return function (errorMessages) {
    var validation = props.validation,
        model = props.pageInfo.store.model;


    var isMessageArray = Array.isArray(errorMessages) || (0, _mobx.isObservableArray)(errorMessages);
    var isNotEmptyMessagesArray = isMessageArray && !(0, _fp.isEmpty)(errorMessages);
    var isErrorMessage = !(0, _fp.isNil)(errorMessages) && !(0, _fp.isEmpty)(errorMessages);

    if (isNotEmptyMessagesArray) {
      // handle general messages
      var generalMsg = (0, _fp.find)({ key: '' }, errorMessages);
      var distinctMsg = (0, _fp.find)({ key: _Izenda5.MESSAGE_KEY.DISTINCT }, errorMessages);
      var concurrencyMsg = (0, _fp.find)({ key: _Izenda5.MESSAGE_KEY.CONCURRENCY }, errorMessages);

      if (!(0, _fp.isEmpty)(generalMsg) || !(0, _fp.isEmpty)(distinctMsg) || !(0, _fp.isEmpty)(concurrencyMsg)) {
        var message = generalMsg ? generalMsg.messages[0] : distinctMsg ? distinctMsg.messages[0] : concurrencyMsg.messages[0];

        props.confirmFn('Information', {
          description: message,
          type: _Izenda4.default.MESSAGE_TYPE.INFO,
          showCloseIndicator: true,
          isHTMLFormat: true
        }).then(function () {
          if (!(0, _fp.isEmpty)(concurrencyMsg)) {
            var store = props.store,
                reportId = props.store.model.reportId,
                loader = props.loader,
                router = props.router,
                location = props.location;

            var query = null;
            if (store.reportListURI) {
              var spathQuery = {};
              spathQuery['' + _Izenda14.SOURCE_PATH_QUERY_KEY] = store.reportListURI;
              query = _Izenda13.default.mergeQuery(location.query, spathQuery);
            }

            var viewReportDesignerUrl = reportId && !store.isNewReport ? _Izenda7.default.getReportDesignerUrl('ReportDesignerDetail', { reportId: reportId }) : _Izenda7.default.getReportDesignerUrl();

            var confirmFn = store.model.checkDirty() ? props.confirmFn('Confirmation', {
              description: store.getBundle().MESSAGE.CANCEL
            }) : (0, _bluebird.resolve)(true);

            var reportDesignerURI = { pathname: viewReportDesignerUrl };

            !store.isNewReport && query && (reportDesignerURI.query = query);

            return confirmFn.then(loader.startLoading.bind(loader)).then(store.cancelChanges.bind(store)).then(function () {
              router.push(reportDesignerURI);
            }).finally(loader.endLoading.bind(loader));
          }
        });
      }
      // uncheck Distinct checkbox if error
      if (!(0, _fp.isEmpty)(distinctMsg)) {
        model.changeDistinct(false);
      }

      // handle message for grid
      validation.updateErrors(errorMessages);
    } else if (isErrorMessage) {
      props.confirmFn('Information', {
        description: errorMessages,
        type: _Izenda4.default.MESSAGE_TYPE.INFO,
        showCloseIndicator: true
      });
      props.store.model.updateErrorMessages('');
    }
  };
}

/**
 * Cancel all changes of report designer
 * @return {Promise}       An action promise
 */
function onCancelReport(props) {
  return function () {
    var store = props.store,
        reportId = props.store.model.reportId,
        loader = props.loader,
        router = props.router,
        location = props.location;


    var query = null;
    if (store.reportListURI) {
      var spathQuery = {};
      spathQuery['' + _Izenda14.SOURCE_PATH_QUERY_KEY] = store.reportListURI;
      query = _Izenda13.default.mergeQuery(location.query, spathQuery);
    }

    var viewReportDesignerUrl = reportId && !store.isNewReport ? _Izenda7.default.getReportDesignerUrl('ReportDesignerDetail', { reportId: reportId }) : _Izenda7.default.getReportDesignerUrl();

    var confirmFn = store.model.checkDirty() ? props.confirmFn('Confirmation', {
      description: store.getBundle().MESSAGE.CANCEL
    }) : (0, _bluebird.resolve)(true);

    var reportDesignerURI = { pathname: viewReportDesignerUrl };

    !store.isNewReport && query && (reportDesignerURI.query = query);

    return confirmFn.then(loader.startLoading.bind(loader)).then(store.cancelChanges.bind(store)).then(function () {
      router.push(reportDesignerURI);
    }).finally(loader.endLoading.bind(loader));
  };
}

/**
 * Validate filter logic syntax
 * @return {Promise}            An action boolean promise
 */
function validateFilterSyntax(store, validation) {
  return store.validateFilterSyntax().then(function (result) {
    // Update validation errors to show the error message.
    !result.success && validation.updateErrors(result.messages);
    return (0, _bluebird.resolve)(result.success);
  });
}

/**
 * Open SavePopup
 * @return {Promise}        A popup promise
 */
function openPopup(props, saveAs) {
  var store = props.store;
  // Set Report type when open save popup
  // Fieldless report : Template is default.

  if (store.disableReportType) {
    store.model.setReportType(_Izenda5.REPORT_TYPE_ENUM.TEMPLATE);
  } else {
    store.model.setReportType(_Izenda5.REPORT_TYPE_ENUM.REPORT);
  }

  var loadPromise = (0, _fp.isNil)(store.model.categoryId) || store.saveAsMode ? store.loadCategories() : (0, _bluebird.join)(store.loadCategories(), store.loadSubCategories(store.model.categoryId));

  return loadPromise.then(function () {
    return props.openPopup(_Izenda2.default, {
      store: store,
      saveAsMode: saveAs,
      isNew: props.isNew,
      section: props.pageName,
      onSaved: (0, _fp.curry)(onSaved)(props),
      disableReport: props.disableReport
    });
  });
}

function showFilterWarningMessage(props) {
  var store = props.store,
      pageName = props.pageName;

  var warningMessage = store.getUnspecifiedFilterWarning();
  if (warningMessage && (pageName === _Izenda5.PAGE_NAME.FIELDS || pageName === _Izenda5.PAGE_NAME.FORMATS)) {
    return props.confirmFn('Information', {
      type: _Izenda4.default.MESSAGE_TYPE.INFO_ACCEPT,
      description: warningMessage,
      showCancel: false
    });
  } else {
    return (0, _bluebird.resolve)(false);
  }
}

/**
 * Validate all rules for current report
 * Validation steps:
 *   + Validate Filter syntax
 *   + Detect report changes
 *   + Validate Relationship Syntax
 */
function validateReport(props, needValidateRelationship) {
  var validation = props.validation,
      store = props.store,
      _props$store2 = props.store,
      dataTree = _props$store2.dataSourceStore.dataTree,
      reportMode = _props$store2.model.dataSource.reportMode,
      pageName = props.pageName,
      localization = props.localization;


  var validateRelationshipPromise = needValidateRelationship ? reportMode === _Izenda5.ADVANCED ? store.validateRelationshipSyntax.bind(store) : store.validateSimpleModeRelationship.bind(store) : function () {
    return (0, _bluebird.resolve)({ success: true });
  };

  store.resetAlertDetails();

  var handleValidationSteps = function handleValidationSteps() {
    return validation.validate().then(function (success) {
      !success && store.setAlertDetails({
        errors: [{ message: _Izenda9.default.getText('COMMON_MESSAGES_GENERAL_ERROR') }],
        success: false
      });
      return success ? props.detectReportChange(props, pageName) : { success: false };
    }).then(function (result) {
      return result.success ? validateRelationshipPromise() : result;
    }).then(function (result) {
      if (result && result.success) {
        return store.validateReport();
      }
      return result;
    }).then(function (result) {
      if (result && !result.success && !(0, _fp.isEmpty)(result.messages)) {
        var messageHasKey = (0, _fp.find)(function (m) {
          return !(0, _fp.isEmpty)(m.key);
        }, result.messages);
        if (!(0, _fp.isNil)(messageHasKey)) {
          validation.updateErrors(result.messages);
          return { success: false };
        }
        return result;
      }
      return { success: result.success };
    }).then(function (result) {
      if (result && result.success) {
        return store.detectSchemaChange(pageName);
      }
      return result;
    }).then(function (result) {
      result = result || { success: false };

      if (result.success === false) {
        return result;
      }

      // Change Schema
      if (result.hasChanged) {
        // In Data Source page
        if (pageName === _Izenda5.PAGE_NAME.DATA_SOURCE) {
          !dataTree.hasDynamicStore() ? props.confirmMessage('error', localization.getText('REPORTDESIGNER_MESSAGE_CHANGE_SCHEMA_NON_DYNAMIC')) : store.updateResults();
          return { success: false };
        } else {
          // In Field Page
          dataTree.hasDynamicStore() ? props.confirmMessage('info', localization.getText('REPORTDESIGNER_MESSAGE_CHANGE_SCHEMA_DYNAMIC')) : props.confirmMessage('error', localization.getText('REPORTDESIGNER_MESSAGE_CHANGE_SCHEMA_NON_DYNAMIC'));
          return { success: false };
        }
      }
      return { success: true };
    });
  };

  return validateFilterSyntax(store, validation).then(function (valid) {
    return valid ? handleValidationSteps() : { success: false };
  });
}

/**
 * Save report
 */
function saveReport(props) {
  var store = props.store,
      pageName = props.pageName,
      disableReport = props.disableReport;

  store.model.setIgnoreCheckChange();

  return store.saveReport(pageName).then(function (result) {
    result.isDisableReport && disableReport();
    return result.success;
  });
}

/**
 * On click Preview button
 * @return {Promise} An action promise
 */
function onPreview(props) {
  return function () {
    var store = props.store,
        _props$store3 = props.store,
        reportId = _props$store3.model.reportId,
        canSaveAs = _props$store3.canSaveAs,
        localization = props.localization,
        router = props.router;


    var query = null;
    if (store.reportListURI) {
      var spathQuery = {};
      spathQuery['' + _Izenda14.SOURCE_PATH_QUERY_KEY] = store.reportListURI;
      query = _Izenda13.default.mergeQuery(props.location.query, spathQuery);
    }

    var preview = function preview() {
      var viewReportUrl = {
        pathname: _Izenda7.default.getReportUrl('View', { id: reportId }),
        state: {
          fromReportDesigner: true
        }
      };

      query && (viewReportUrl.query = query);

      router.push(viewReportUrl);
    };

    if (!canSaveAs) {
      return props.confirmMessage('warning', localization.getText('REPORTDESIGNER_MESSAGE_SAVE_BEFORE_PREVIEW'));
    } else {
      return props.confirmDirtyForm(_Izenda11.default.isDirty, {
        onConfirmDirtyForm: _Izenda11.default.onOkDirtyForm,
        customMessage: localization.getText('REPORTDESIGNER_MESSAGE_CONFIRM_PREVIEW')
      }).then(preview);
    }
  };
}

exports.default = reportDesignerContentActions;
module.exports = exports['default'];

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerToolBar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Designer ToolBar component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(148);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(42);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(30);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(233);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(86);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(632);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2653);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2654);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(16);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(633);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(45);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(2655);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACCESS_RIGHT = _Izenda4.default.ACCESS_RIGHT;
var ExportBtn = (0, _Izenda2.default)()(function (props) {
  return _react2.default.createElement(_Izenda20.default.ExportReportButton, props);
});

var ReportDesignerToolBar = (_dec = (0, _Izenda22.default)(_Izenda26.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportDesignerToolBar, _Component);

  function ReportDesignerToolBar() {
    (0, _classCallCheck3.default)(this, ReportDesignerToolBar);
    return (0, _possibleConstructorReturn3.default)(this, (ReportDesignerToolBar.__proto__ || (0, _getPrototypeOf2.default)(ReportDesignerToolBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportDesignerToolBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.resetAlertDetails(this.props.store);
    }

    /**
     * Alert dismiss handler.
     */

  }, {
    key: 'onDismiss',
    value: function onDismiss() {
      // We need to reset "needUpdateResult" property, otherwise alert won't appear after being closed.
      var reportFilters = (0, _fp.get)('fieldsStore.reportFilters', this.props);
      if (!(0, _fp.isNil)(reportFilters)) reportFilters.needUpdateResult = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var store = props.store,
          _props$store = props.store,
          model = _props$store.model,
          canSaveGlobalReport = _props$store.canSaveGlobalReport,
          localization = props.localization,
          authorization = props.authorization,
          pageName = props.pageName,
          showUpdateResult = props.showUpdateResult;

      var accessPriority = model.accessPriority || ACCESS_RIGHT.FullAccess;
      var canSaveAs = store.canSaveAs && props.checkPermissionOfSaveAsButton(props);
      var onUpdateResults = props.onUpdateResults;
      var onAddReportPart = props.onAddReportPart;
      var onSave = props.onSave;
      var onSaveAs = props.onSaveAs;
      var onPreview = props.onPreview;
      var onCancelReport = props.onCancelReport;
      var hasExportLicense = authorization.checkLicense(_Izenda24.default.LICENSE_KEY.Exporting);

      var allowAdd = pageName === _Izenda18.default.PAGE_NAME.FIELDS;
      var doesShowSaveButton = props.checkPermissionOfSaveButton(props);
      var onDismiss = this.onDismiss.bind(this);

      var _store$alertDetails = store.alertDetails,
          message = _store$alertDetails.message,
          alertType = _store$alertDetails.alertType,
          alertKey = _store$alertDetails.key,
          success = _store$alertDetails.success,
          errors = _store$alertDetails.errors,
          showType = _store$alertDetails.showType,
          type = _store$alertDetails.type;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper-header' },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock u_fullWidth' },
          _react2.default.createElement(_Izenda10.default, { key: pageName }),
          _react2.default.createElement(
            'div',
            { className: 'izenda-Alert-container' },
            _react2.default.createElement(_Izenda12.default, {
              message: message,
              alertType: alertType,
              alertKey: alertKey,
              success: success,
              errors: errors,
              type: type,
              showType: showType,
              onDismiss: onDismiss
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'izenda-ActionBarRight' },
            _react2.default.createElement(
              _Izenda8.default,
              null,
              props.checkDisplayShowHideHeaderFooter(pageName, store) && _react2.default.createElement(_Izenda6.default, {
                onClick: props.onDisplayShowHideHeaderFooter,
                label: props.getShowHideHeaderFooterLabel(localization, store)
              }),
              hasExportLicense && _react2.default.createElement(ExportBtn, {
                reportDesignerMode: true,
                name: model.reportName,
                store: store,
                print: store.printReport,
                'export': store.exportReport,
                id: model.reportId,
                keys: [_Izenda4.default.PERMISSION_KEY.ReportsActionsExporting]
              }),
              showUpdateResult && _react2.default.createElement(
                'a',
                { className: 'btn btn-primary btn-success', onClick: onUpdateResults },
                localization.getText('REPORTDESIGNER_LABEL_UPDATE_RESULT')
              ),
              _react2.default.createElement(_Izenda14.default, { allowAdd: allowAdd, onAdd: onAddReportPart }),
              doesShowSaveButton && _react2.default.createElement(_Izenda16.default, {
                canSaveGlobalReport: canSaveGlobalReport,
                canSaveAs: canSaveAs,
                onSave: onSave,
                onSaveAs: onSaveAs,
                version: model.version,
                keepDisplay: true,
                accessPriority: accessPriority
              }),
              _react2.default.createElement(_Izenda6.default, { onClick: onCancelReport, label: localization.getText('COMMON_LABEL_CANCEL'), keepDisplay: true }),
              _react2.default.createElement(_Izenda6.default, { onClick: onPreview, label: localization.getText('COMMON_LABEL_REPORT_VIEWER') })
            )
          )
        )
      );
    }
  }]);
  return ReportDesignerToolBar;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object.isRequired,
  fieldsStore: _propTypes2.default.object.isRequired,
  pageName: _propTypes2.default.string.isRequired,
  onUpdateResults: _propTypes2.default.func.isRequired,
  onAddReportPart: _propTypes2.default.func.isRequired,
  onSave: _propTypes2.default.func.isRequired,
  onSaveAs: _propTypes2.default.func.isRequired,
  onCancelReport: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = ReportDesignerToolBar;
module.exports = exports['default'];

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(30);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AddReportPartButton.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
var AddReportPartButton = function AddReportPartButton(props) {
  var localization = props.localization,
      allowAdd = props.allowAdd,
      onAdd = props.onAdd;

  return allowAdd ? _react2.default.createElement(_Izenda2.default, {
    className: 'btn-success',
    onClick: onAdd,
    label: localization.getText('REPORTDESIGNER_LABEL_ADD_REPORT_PART')
  }) : null;
};

AddReportPartButton.propTypes = {
  allowAdd: _propTypes2.default.bool.isRequired,
  onAdd: _propTypes2.default.func.isRequired
};

exports.default = (0, _Izenda4.default)()(AddReportPartButton);
module.exports = exports['default'];

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SaveReportDesignerButton.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var Button = __webpack_require__(30);

  var observer = __webpack_require__(10).observer;
  var connect = __webpack_require__(2);
  var ACCESS_RIGHT = __webpack_require__(42).ACCESS_RIGHT;

  var SaveReportDesignerButton = function SaveReportDesignerButton(props) {
    var localization = props.localization;
    var accessPriority = props.accessPriority;
    var saveAsPermission = props.authorization.checkPrivileges([props.authorizationConstants.PERMISSION_KEY.ReportsCanCreateNewReportValue]) && (accessPriority === ACCESS_RIGHT.FullAccess || accessPriority === ACCESS_RIGHT.SaveAs);

    var savePermission = props.authorization.checkPrivileges([props.authorizationConstants.PERMISSION_KEY.ReportsActionsOverwriteExistingReport]) && accessPriority === ACCESS_RIGHT.FullAccess;

    var canSaveAs = props.canSaveAs;
    var canSaveGlobalReport = props.canSaveGlobalReport;
    var onSave = props.onSave;
    var onSaveAs = props.onSaveAs;

    if (canSaveGlobalReport && canSaveAs && saveAsPermission && savePermission) {
      return React.createElement(
        'div',
        { className: 'btn-group' },
        React.createElement(
          Button,
          {
            className: 'dropdown-toggle',
            'data-toggle': 'dropdown',
            label: localization.getText("COMMON_LABEL_SAVE") },
          React.createElement('span', { className: 'caret' })
        ),
        React.createElement(
          'ul',
          { className: 'dropdown-menu' },
          React.createElement(
            'li',
            null,
            React.createElement(
              'a',
              { onClick: onSave },
              localization.getText("COMMON_LABEL_SAVE")
            )
          ),
          React.createElement(
            'li',
            null,
            React.createElement(
              'a',
              { onClick: onSaveAs },
              localization.getText("COMMON_LABEL_SAVE_AS")
            )
          )
        )
      );
    }

    if (canSaveGlobalReport && savePermission || !props.version) {
      return React.createElement(Button, {
        onClick: onSave,
        label: localization.getText("COMMON_LABEL_SAVE") });
    }

    if (canSaveAs && saveAsPermission) {
      return React.createElement(Button, {
        onClick: onSaveAs,
        label: localization.getText("COMMON_LABEL_SAVE_AS") });
    }

    return null;
  };

  SaveReportDesignerButton.propTypes = {
    canSaveAs: React.PropTypes.bool.isRequired,
    onSave: React.PropTypes.func.isRequired,
    onSaveAs: React.PropTypes.func.isRequired
  };

  module.exports = connect()(SaveReportDesignerButton);
}();

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check permission of save button.
 * @param {Object} props
 * @returns {boolean} Indicate to Save permission
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerToolBarActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/* eslint-disable no-unused-vars */

var checkPermissionOfSaveButton = function checkPermissionOfSaveButton(props) {
  var model = props.store.model,
      authorization = props.authorization,
      _props$authorizationC = props.authorizationConstants,
      permissionKeys = _props$authorizationC.PERMISSION_KEY,
      permissionOperator = _props$authorizationC.PERMISSION_OPERATOR;

  var accessPriority = model.accessPriority || _Izenda3.ACCESS_RIGHT.FullAccess;
  var rightAccessPriority = accessPriority === _Izenda3.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda3.ACCESS_RIGHT.SaveAs;

  if (authorization.checkPrivileges([permissionKeys.FullReportAndDashboardAccess]) && rightAccessPriority) return true;

  if (model.version) {
    return authorization.checkPrivileges([permissionKeys.ReportsCanCreateNewReportValue, permissionKeys.ReportsActionsOverwriteExistingReport], permissionOperator.Or) && rightAccessPriority;
  }

  return authorization.checkPrivileges([permissionKeys.ReportsCanCreateNewReportValue]) && rightAccessPriority;
};

/**
 * Check permission of save as button.
 * @param {Object} props
 * @returns {boolean} Indicate to Save As permission
 */
var checkPermissionOfSaveAsButton = function checkPermissionOfSaveAsButton(_ref) {
  var authorization = _ref.authorization,
      permissionKeys = _ref.authorizationConstants.PERMISSION_KEY;
  return authorization.checkPrivileges([permissionKeys.ReportsCanCreateNewReportValue]);
};

/**
 * Check to display the Show/Hide Header Footer button
 * @param {string} pageName
 * @param {Object} store
 * @returns {boolean} Indicate to display button
 */
var checkDisplayShowHideHeaderFooter = function checkDisplayShowHideHeaderFooter(pageName, store) {
  return pageName === _Izenda2.default.PAGE_NAME.FIELDS && (0, _fp.get)('model.reportFormats.headerFooter.visible', store);
};

/**
 * Get label of Show/Hide Header Footer button
 * @param {Object} localization
 * @param {Object} store
 * @returns {string} The label of button
 */
var getShowHideHeaderFooterLabel = function getShowHideHeaderFooterLabel(localization, _ref2) {
  var isShowingHeaderFooter = _ref2.isShowingHeaderFooter;

  var key = isShowingHeaderFooter ? 'COMMON_LABEL_HIDE_REPORT_HEADER_FOOTER' : 'COMMON_LABEL_SHOW_REPORT_HEADER_FOOTER';
  return localization.getText(key);
};

/**
 * On display Show/Hide Header Footer button handler
 * @param {Object} props
 * @param {Object} e
 */
var onDisplayShowHideHeaderFooter = function onDisplayShowHideHeaderFooter(_ref3, e) {
  var store = _ref3.store;

  store.isShowingHeaderFooter = !store.isShowingHeaderFooter;
};

/**
 * Reset alert detail.
 * @param {Object} store
 */
var resetAlertDetails = function resetAlertDetails(_ref4) {
  var alertDetails = _ref4.alertDetails;

  alertDetails.reset();
};

exports.default = (0, _recompose.compose)((0, _recompose.withHandlers)({
  onDisplayShowHideHeaderFooter: (0, _fp.curry)(onDisplayShowHideHeaderFooter)
}), (0, _recompose.withProps)({
  checkPermissionOfSaveButton: checkPermissionOfSaveButton,
  checkPermissionOfSaveAsButton: checkPermissionOfSaveAsButton,
  checkDisplayShowHideHeaderFooter: checkDisplayShowHideHeaderFooter,
  getShowHideHeaderFooterLabel: getShowHideHeaderFooterLabel,
  resetAlertDetails: resetAlertDetails
}));
module.exports = exports['default'];

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withOverlay = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.OverlayContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2657);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverlayContainer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OverlayContainer, _Component);

  function OverlayContainer() {
    (0, _classCallCheck3.default)(this, OverlayContainer);
    return (0, _possibleConstructorReturn3.default)(this, (OverlayContainer.__proto__ || (0, _getPrototypeOf2.default)(OverlayContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(OverlayContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          OverlayComponent = _props.OverlayComponent,
          showOverlay = _props.showOverlay,
          classNames = _props.classNames;
      var overlayComponentProps = this.props.overlayComponentProps;

      var overlayClassNames = ['izenda-Overlay-Fallback', (0, _fp.get)('classNames', overlayComponentProps)].join(' ');

      overlayComponentProps = (0, _fp.omit)(['classNames'], overlayComponentProps);

      if (!!showOverlay) {
        return _react2.default.createElement(
          'section',
          { className: classNames },
          children,
          _react2.default.createElement(OverlayComponent, (0, _extends3.default)({ className: overlayClassNames }, overlayComponentProps))
        );
      }

      return children;
    }
  }]);
  return OverlayContainer;
}(_react.Component), _class.defaultProps = {
  OverlayComponent: _Izenda2.default
}, _temp);
var withOverlay = exports.withOverlay = function withOverlay(Component, OverlayComponent) {
  return function (props) {
    var showOverlay = props.showOverlay,
        classNames = props.classNames,
        overlayComponentProps = props.overlayComponentProps;

    var childrenProps = (0, _fp.omit)(['showOverlay', 'classNames', 'overlayComponentProps'], props);
    return _react2.default.createElement(
      OverlayContainer,
      {
        showOverlay: showOverlay,
        className: classNames,
        OverlayComponent: OverlayComponent,
        overlayComponentProps: overlayComponentProps
      },
      _react2.default.createElement(Component, childrenProps)
    );
  };
};

exports.default = OverlayContainer;

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverlayFallbackComponent = function OverlayFallbackComponent(_ref) {
  var className = _ref.className,
      style = _ref.style;

  var classNames = ['izenda-Overlay-Fallback', className].join(' ');
  return _react2.default.createElement('div', { className: classNames, style: style });
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.OverlayFallbackComponent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = OverlayFallbackComponent;
module.exports = exports['default'];

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerDataSourceOverlay.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ReportDesignerDataSourceOverlay = function ReportDesignerDataSourceOverlay(_ref) {
  var className = _ref.className;

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      { className: 'izenda-ReportDesigner-OverlayContent' },
      _react2.default.createElement('i', { className: 'icon-big-arr' }),
      _Izenda2.default.getText('REPORTDESIGNER_DATASOURCE_OVERLAY_LABEL')
    )
  );
};

exports.default = ReportDesignerDataSourceOverlay;
module.exports = exports['default'];

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSource.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSource component
 */
!function () {
  var ReportDesignerDataSourceStore = __webpack_require__(593);

  var React = __webpack_require__(0);
  var DataSourceTreeContainer = __webpack_require__(2660);
  var DnDFieldsConfig = __webpack_require__(1206);
  var DataSourceDetail = __webpack_require__(2662);

  module.exports = {
    setStore: function setStore(store) {
      this.store = store.dataSourceStore;
      this.fieldStore = store.fieldsStore;
    },

    destroy: function destroy() {
      delete this['store'];
      delete this['fieldStore'];
    },

    reloadView: function reloadView() {
      return this.store.loadInitial();
    },

    renderMiddlePanel: function renderMiddlePanel() {
      return React.createElement(DataSourceTreeContainer, { store: this.store });
    },

    renderMainContent: function renderMainContent(ref) {
      return React.createElement(DataSourceDetail, { store: this.store, fieldStore: this.fieldStore, ref: ref, uiStore: DnDFieldsConfig.targetOptions });
    }
  };
}();

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTreeContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSourceTree component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda3 = __webpack_require__(2661);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(16);

var _Izenda6 = __webpack_require__(107);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(17);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataSourceTreeContainer = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(DataSourceTreeContainer, _Component);

  function DataSourceTreeContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DataSourceTreeContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DataSourceTreeContainer.__proto__ || (0, _getPrototypeOf2.default)(DataSourceTreeContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onDistinctChange = function (e) {
      var store = _this.props.store;

      store.reportStore.model.markDirty();
      store.model.changeDistinct(e.target.checked);
    }, _this.onChangeSearchText = function (e) {
      var store = _this.props.store;

      var searchKey = e.target.value;
      store.dataTree.filterText = searchKey;
      store.lazyLoadingQuerySource(null, true, searchKey);
    }, _this.renderControls = function () {
      var _this$props = _this.props,
          localization = _this$props.localization,
          _this$props$store = _this$props.store,
          model = _this$props$store.model,
          dataTree = _this$props$store.dataTree;

      var showAllowNull = dataTree.showAllowNull && model.reportMode === _Izenda5.SIMPLE;

      return _react2.default.createElement(
        'div',
        { className: 'header-panel' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-MiddlePanel-checkbox' },
          _react2.default.createElement(
            'div',
            { className: 'overflow-text' },
            _react2.default.createElement(_Izenda9.default, { type: 'checkbox', checked: model.distinct, onChange: _this.onDistinctChange }),
            _react2.default.createElement(
              'span',
              { className: 'u_marginLeftInnerSpace' },
              localization.getText('REPORTDESIGNER_LABEL_DISTINCT')
            )
          )
        ),
        showAllowNull && _react2.default.createElement(
          'div',
          { className: 'izenda-MiddlePanel-checkbox' },
          _react2.default.createElement(
            'div',
            { className: 'overflow-text', title: _Izenda5.BUNDLE.MESSAGE.ALLOW_NULL_TOOLTIP },
            _react2.default.createElement(_Izenda9.default, {
              type: 'checkbox',
              onChange: _EventUtils2.default.notifyChange(model.changeAllowNull.bind(model), _EventUtils2.default.CHECKBOX)
            }),
            _react2.default.createElement(
              'span',
              { className: 'u_marginLeftInnerSpace' },
              localization.getText('REPORTDESIGNER_LABEL_ALLOW_NULLS')
            )
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DataSourceTreeContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          loader = _props.loader,
          store = _props.store;

      loader.startLoading();

      return store.startLoadingRelationship().then(store.loadInitial.bind(store)).then(store.endLoadingRelationship.bind(store)).finally(loader.endLoading.bind(loader));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          store = _props2.store,
          _props2$store = _props2.store,
          dataTree = _props2$store.dataTree,
          reportMode = _props2$store.model.reportMode;


      return _react2.default.createElement(
        'section',
        { className: 'u_fullHeight u-posRelative u-bgWhite' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-MiddlePanel-search' },
          this.renderControls(),
          _react2.default.createElement(
            'div',
            { className: 'search-box' },
            _react2.default.createElement(_Izenda7.default, { value: dataTree.filterText, onChange: this.onChangeSearchText })
          ),
          _react2.default.createElement('hr', null)
        ),
        !(0, _fp.isNil)(reportMode) && _react2.default.createElement(_Izenda4.default, { className: 'izenda-MiddlePanel-content', store: store })
      );
    }
  }]);
  return DataSourceTreeContainer;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = DataSourceTreeContainer;
module.exports = exports['default'];

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps; // ----------------------------------------------------------------------
// <copyright file="Izenda.DataTreeLazyLoading.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = __webpack_require__(335);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(1202);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(1203);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(1204);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(1205);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataTreeLazyLoading = (_dec = (0, _Izenda2.default)(_Izenda13.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DataTreeLazyLoading, _Component);

  function DataTreeLazyLoading(props) {
    (0, _classCallCheck3.default)(this, DataTreeLazyLoading);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DataTreeLazyLoading.__proto__ || (0, _getPrototypeOf2.default)(DataTreeLazyLoading)).call(this, props));

    _initialiseProps.call(_this);

    var store = props.store;

    _this.lazyLoadingQuerySource = store.lazyLoadingQuerySource.bind(store);
    _this.registerLazyLoadingStore = store.registerLazyLoadingStore.bind(store);
    return _this;
  }

  (0, _createClass3.default)(DataTreeLazyLoading, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var _props$store = props.store,
          dataTree = _props$store.dataTree,
          _props$store$lazyLoad = _props$store.lazyLoadingStore,
          lazyLoadingStore = _props$store$lazyLoad === undefined ? {} : _props$store$lazyLoad;

      var displayData = dataTree.displayData;
      var classes = (0, _classnames2.default)('reports-dtsourcetree', props.className);
      var getChildNodes = (0, _fp.invoke)('getChildNodes');

      var nodes = displayData.length === 1 && !displayData[0].name ? displayData[0].getChildNodes() : displayData;

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(_Izenda5.default, {
          nodes: nodes,
          getKey: this.getKey,
          className: 'u_paddingRight',
          renderNode: this.renderNode,
          getChildNodes: getChildNodes,
          viewHeight: lazyLoadingStore.viewHeight,
          itemHeight: lazyLoadingStore.itemHeight,
          isLastPage: dataTree.isLastPage,
          getData: this.lazyLoadingQuerySource,
          defaultItemsNumber: _Izenda3.LAZY_LOADING_DATA_SOURCE_TREE_ITEMS,
          registerLazyLoadingStore: this.registerLazyLoadingStore
        })
      );
    }
  }]);
  return DataTreeLazyLoading;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired,
  expandFieldLevel: _react.PropTypes.bool,
  useCheckBox: _react.PropTypes.bool
}, _class2.defaultProps = {
  expandFieldLevel: false,
  useCheckBox: true
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.renderNode = function (node, toggleIcon, toggle, isCollapsed) {
    var source = node.source,
        nodeType = node.nodeType;


    switch (nodeType) {
      case 'Category':
        {
          return _this2.renderCategory(source, toggle, isCollapsed);
        }
      case 'QuerySource':
        {
          return _this2.renderQuerySource(source, toggleIcon, toggle, isCollapsed, node);
        }
      case 'Field':
        {
          return _this2.renderField(source);
        }
      default:
        {
          return null;
        }
    }
  };

  this.renderCategory = function (node, toggle, isCollapsed) {
    return _react2.default.createElement(_Izenda7.default, { dataSource: node, collapseToggle: toggle, isCollapsed: isCollapsed });
  };

  this.renderQuerySource = function (source, toggleIcon, toggle, isCollapsed, node) {
    var _props = _this2.props,
        store = _props.store,
        useCheckBox = _props.useCheckBox,
        toggleSourceSelection = _props.toggleSourceSelection;

    var filterText = store.dataTree.filterText;

    return _react2.default.createElement(_Izenda9.default, {
      node: node,
      store: store,
      dataSource: source,
      filterText: filterText,
      toggleIcon: toggleIcon,
      collapseToggle: toggle,
      useCheckBox: useCheckBox,
      isCollapsed: isCollapsed,
      handleCheck: toggleSourceSelection
    });
  };

  this.renderField = function (node) {
    var store = _this2.props.store;


    return _react2.default.createElement(_Izenda11.default, { store: store, itemData: node, filterText: store.dataTree.filterText });
  };

  this.getKey = function (node) {
    return node.source.id + '_' + node.source.name;
  };
}, _temp)) || _class);
exports.default = DataTreeLazyLoading;
module.exports = exports['default'];

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2663);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2664);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(439);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(27);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(638);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataSourceDetail = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DataSourceDetail, _Component);

  function DataSourceDetail(props) {
    (0, _classCallCheck3.default)(this, DataSourceDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DataSourceDetail.__proto__ || (0, _getPrototypeOf2.default)(DataSourceDetail)).call(this, props));

    var loader = props.loader,
        fieldStore = props.fieldStore;

    // Show progress bar for any promises that are not finished when navigate from Field to DataSource

    var isLoading = (0, _fp.get)("isLoading", fieldStore);
    isLoading && loader.startLoading();
    _this.disposeLoader = (0, _mobx.observe)(fieldStore, "isLoading", function (newValue) {
      newValue ? loader.startLoading() : loader.endLoading();
    });
    return _this;
  }

  (0, _createClass3.default)(DataSourceDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var store = this.props.store;

      store.dataSourceDetail.resetAliasLevel();
      return store.loadDataSourceDetail();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _props = this.props,
          loader = _props.loader,
          fieldStore = _props.fieldStore;

      fieldStore.isLoading && loader.endLoading();
      this.disposeLoader();
    }
  }, {
    key: "renderDataSourceGrid",
    value: function renderDataSourceGrid() {
      var _props2 = this.props,
          store = _props2.store,
          width = _props2.width,
          fieldStore = _props2.fieldStore;

      var DataSourceGrid = store.model.reportMode === _Izenda4.default.ADVANCED ? _Izenda8.default : _Izenda6.default;

      return _react2.default.createElement(DataSourceGrid, { store: store, width: width, fieldStore: fieldStore });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          store = _props3.store,
          fieldStore = _props3.fieldStore,
          uiStore = _props3.uiStore;
      var reportStore = store.reportStore;


      return _react2.default.createElement(
        "div",
        { className: "izenda-Wrapper-content" },
        _react2.default.createElement(
          "div",
          { className: "izenda-TableLayout" },
          _react2.default.createElement(
            "div",
            { className: "izenda-TableLayout-Cell" },
            _react2.default.createElement(
              _Izenda12.default,
              null,
              _react2.default.createElement(
                "div",
                { className: "u_fullHeight u_paddingLeftRight" },
                _react2.default.createElement(_Izenda10.default, { store: reportStore, name: reportStore.model.reportName, showTooltip: true, isPreviewRecord: true }),
                this.renderDataSourceGrid()
              )
            )
          ),
          _react2.default.createElement(_Izenda14.default, {
            fieldStore: fieldStore,
            reportDesignerModel: fieldStore.masterModel,
            uiStore: uiStore,
            dataSourceMode: true
          })
        )
      );
    }
  }]);
  return DataSourceDetail;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = DataSourceDetail;
module.exports = exports["default"];

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceGridSimple.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(44);

var _Izenda2 = __webpack_require__(13);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(97);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(438);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(1207);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(16);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(68);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(146);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var TABLE_DEF = _Izenda11.default.TABLE_DEF.SIMPLE_MODE;
var CRITERIA_LIST_SIMPLE_MODE = _Izenda11.default.BUNDLE.CRITERIA_LIST_SIMPLE_MODE;

var DataSourceGridSimple = (_dec = (0, _mobx.action)("onSortChange"), _dec2 = (0, _mobx.action)("onSearch"), _dec3 = (0, _mobx.action)("onPageSizeChange"), _dec4 = (0, _mobx.action)("onPageChange"), (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(DataSourceGridSimple, _Component);

  function DataSourceGridSimple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DataSourceGridSimple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DataSourceGridSimple.__proto__ || (0, _getPrototypeOf2.default)(DataSourceGridSimple)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, "onSortChange", _descriptor, _this), _initDefineProp(_this, "onSearch", _descriptor2, _this), _initDefineProp(_this, "onPageSizeChange", _descriptor3, _this), _initDefineProp(_this, "onPageChange", _descriptor4, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DataSourceGridSimple, [{
    key: "renderCategory",
    value: function renderCategory(_ref2) {
      var category = _ref2.category;

      return _react2.default.createElement(_Izenda13.default, { text: category, tooltip: category });
    }
  }, {
    key: "renderDbName",
    value: function renderDbName(_ref3) {
      var databaseName = _ref3.databaseName;

      return _react2.default.createElement(_Izenda13.default, { text: databaseName, tooltip: databaseName });
    }
  }, {
    key: "renderSchemaName",
    value: function renderSchemaName(_ref4) {
      var schemaName = _ref4.schemaName;

      return _react2.default.createElement(_Izenda13.default, { text: schemaName, tooltip: schemaName });
    }
  }, {
    key: "renderDataObject",
    value: function renderDataObject(_ref5) {
      var dataObject = _ref5.dataObject;

      return _react2.default.createElement(_Izenda13.default, { text: dataObject, tooltip: dataObject });
    }
  }, {
    key: "renderDataObjectType",
    value: function renderDataObjectType(_ref6) {
      var dataObjectType = _ref6.dataObjectType;

      return _react2.default.createElement(_Izenda13.default, { text: dataObjectType, tooltip: dataObjectType });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          store = _props.store,
          fieldStore = _props.fieldStore;
      var dataSourceDetail = store.dataSourceDetail;
      var dataSourceGrid = dataSourceDetail.dataSourceGrid,
          isLoadingRelationship = dataSourceDetail.isLoadingRelationship,
          _dataSourceDetail$pag = dataSourceDetail.pageInfo,
          searchProperty = _dataSourceDetail$pag.searchProperty,
          colSortDirs = _dataSourceDetail$pag.colSortDirs,
          totalRecords = _dataSourceDetail$pag.totalRecords,
          pageSize = _dataSourceDetail$pag.pageSize,
          pageIndex = _dataSourceDetail$pag.pageIndex;


      return _react2.default.createElement(
        _Izenda3.default,
        { className: "data-source-grid" },
        _react2.default.createElement(
          _Izenda7.default,
          { className: "izenda-FilterDatasource u_noMarginAll" },
          _react2.default.createElement(_Izenda9.default, { store: store, fieldStore: fieldStore, viewMode: true })
        ),
        _react2.default.createElement(
          _Izenda3.default.Row,
          null,
          _react2.default.createElement(
            _Izenda3.default.Col,
            { cols: "8" },
            _react2.default.createElement(_Izenda15.default, { options: CRITERIA_LIST_SIMPLE_MODE, value: searchProperty, onSearch: this.onSearch })
          )
        ),
        _react2.default.createElement(
          _Izenda.Table,
          {
            dataSource: dataSourceGrid,
            onSortChange: this.onSortChange,
            sortInfo: colSortDirs,
            isLoading: isLoadingRelationship
          },
          !store.model.dataTree.noCategory && _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF["category"], { cell: this.renderCategory })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF["dbName"], { cell: this.renderDbName })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF["schemaName"], { cell: this.renderSchemaName })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF["dataObject"], { cell: this.renderDataObject })),
          _react2.default.createElement(_Izenda.Column, (0, _extends3.default)({}, TABLE_DEF["dataObjectType"], { cell: this.renderDataObjectType }))
        ),
        _react2.default.createElement(_Izenda5.default, {
          onChange: this.onPageChange,
          onDropdownChange: this.onPageSizeChange,
          totalRecords: totalRecords,
          pageSize: pageSize,
          pageIndex: pageIndex
        })
      );
    }
  }]);
  return DataSourceGridSimple;
}(_react.Component), _class3.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "onSortChange", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (columnKey, sortDir) {
      var store = _this2.props.store;


      store.dataSourceDetail.pageInfo.setColSortDirs(columnKey, sortDir);
      store.searchDataSource();
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "onSearch", [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (searchProperty, searchText) {
      var store = _this3.props.store;
      var dataSourceDetail = store.dataSourceDetail;


      store.dataSourceDetail.reset();
      store.dataSourceDetail.pageInfo.setSearchValues(searchProperty, searchText);
      store.searchDataSource();
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "onPageSizeChange", [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (pageSize) {
      var store = _this4.props.store;

      store.dataSourceDetail.pageInfo.setPageSize(pageSize);
      store.goToPage(1);
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "onPageChange", [_dec4], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (page) {
      var store = _this5.props.store;

      store.goToPage(page);
    };
  }
})), _class2)) || _class);
exports.default = DataSourceGridSimple;
module.exports = exports["default"];

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceGridAdvanced.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var _Izenda3 = __webpack_require__(2665);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(15);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(44);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda10 = __webpack_require__(13);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(438);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(1207);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(146);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(30);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(586);

var _Izenda21 = __webpack_require__(993);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var TABLE_DEF = _Izenda8.default.TABLE_DEF.ADVANCED_MODE;

var DataSourceGridAdvanced = (_dec = (0, _Izenda2.default)({ toClass: true }, _Izenda4.default), _dec2 = (0, _mobx.action)("onSearch"), _dec3 = (0, _mobx.action)("onSearchPropertiesChange"), _dec4 = (0, _mobx.action)("onDataGridSearchSizeChange"), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(DataSourceGridAdvanced, _Component);

  function DataSourceGridAdvanced() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DataSourceGridAdvanced);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DataSourceGridAdvanced.__proto__ || (0, _getPrototypeOf2.default)(DataSourceGridAdvanced)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, "gridState", _descriptor, _this), _initDefineProp(_this, "onSearch", _descriptor2, _this), _initDefineProp(_this, "onSearchPropertiesChange", _descriptor3, _this), _this.canDrop = function (target, source) {
      var _this$props = _this.props,
          dataSourceGrid = _this$props.store.dataSourceDetail.dataSourceGrid,
          localization = _this$props.localization;

      var isParentCurrentRow = (0, _fp.isEmpty)(source.parentId);
      var isParentNewRow = (0, _fp.isEmpty)(target.parentId);

      if (!isParentCurrentRow) {
        var newParentRelationship = isParentNewRow ? target : (0, _fp.find)({ tempId: target.parentId }, dataSourceGrid);

        if (newParentRelationship.joinType === _Izenda7.JOIN_TYPE_CROSS || isParentCurrentRow && !isParentNewRow) {
          _this.warningMessage = localization.getText("REPORTDESIGNER_MESSAGE_CANNOT_DROP_KEYJOIN_HAVING_CROSS_JOIN");
          return false;
        }
      } else if (isParentCurrentRow && !isParentNewRow) {
        _this.warningMessage = localization.getText("REPORTDESIGNER_MESSAGE_CANNOT_DROP_RELATIONSHIP_IN_KEYJOIN_DEST");
        return false;
      }

      return true;
    }, _initDefineProp(_this, "onDataGridSearchSizeChange", _descriptor4, _this), _this.warning = function () {
      return _this.warningMessage && _this.props.confirmFn("Information", {
        description: _this.warningMessage,
        type: "error",
        showCloseIndicator: true
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DataSourceGridAdvanced, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      this.resetWarningMessage();
    }
  }, {
    key: "resetWarningMessage",
    value: function resetWarningMessage() {
      this.warningMessage = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          store = _props.store,
          localization = _props.localization,
          fieldStore = _props.fieldStore,
          rebuildSearchOptions = _props.rebuildSearchOptions,
          onAddRelationship = _props.onAddRelationship,
          onValidateSyntax = _props.onValidateSyntax,
          getChildItems = _props.getChildItems,
          onMoveRelationship = _props.onMoveRelationship;
      var _store$dataTree = store.dataTree,
          isAllDataOjectUncategory = _store$dataTree.isAllDataOjectUncategory,
          selectedTree = _store$dataTree.selectedTree,
          dataSourceDetail = store.dataSourceDetail,
          reportStore = store.reportStore,
          isAllQuerySourceUncategorized = store.isAllQuerySourceUncategorized;


      var disableAddRelationship = !(0, _Izenda20.haveSelectedAtLeastOneQuerySource)(selectedTree);

      var displayDataSourceGrid = dataSourceDetail.displayDataSourceGrid,
          _dataSourceDetail$pag = dataSourceDetail.pageInfo,
          searchProperty = _dataSourceDetail$pag.searchProperty,
          colSortDirs = _dataSourceDetail$pag.colSortDirs,
          haveRelationships = dataSourceDetail.haveRelationships,
          totalKeyJoin = dataSourceDetail.totalKeyJoin,
          isLoadingRelationship = dataSourceDetail.isLoadingRelationship;


      var flattenArraySourceGrid = (0, _fp.flattenDeep)(displayDataSourceGrid);
      var isDataSearchMinSize = this.gridState.isDataSearchMinSize;

      var isVisible = isDataSearchMinSize || !_Izenda6.default.isMobile;
      var widthOnMobile = isDataSearchMinSize ? 1 : 12;
      var actionBarClass = (0, _classnames2.default)({ "hidden-xs": !isVisible });

      return _react2.default.createElement(
        _Izenda11.default,
        { className: "data-source-grid" },
        _react2.default.createElement(
          _Izenda13.default,
          { className: "izenda-FilterDatasource u_noMarginAll" },
          _react2.default.createElement(_Izenda15.default, { store: store, fieldStore: fieldStore, viewMode: true })
        ),
        _react2.default.createElement(
          _Izenda11.default.Row,
          null,
          _react2.default.createElement(
            _Izenda11.default.Col,
            { cols: "7", xs: widthOnMobile },
            _react2.default.createElement(_Izenda17.default, {
              responsive: true,
              options: rebuildSearchOptions(this.props),
              value: searchProperty,
              onSearch: this.onSearch,
              onSearchPropertiesChange: this.onSearchPropertiesChange,
              onSizeStateChange: this.onDataGridSearchSizeChange
            })
          ),
          _react2.default.createElement(
            _Izenda11.default.Col,
            { className: actionBarClass, cols: "5", xs: "11" },
            _react2.default.createElement(
              "div",
              { className: "izenda-ActionBarRight" },
              _react2.default.createElement(_Izenda19.default, {
                className: "add-relationship-button",
                label: localization.getText("REPORTDESIGNER_LABEL_ADD_RELATIONSHIP"),
                onClick: onAddRelationship,
                disabled: disableAddRelationship
              }),
              _react2.default.createElement(_Izenda19.default, {
                label: localization.getText("REPORTDESIGNER_LABEL_FIELDS_VALIDATE_SYNTAX"),
                onClick: onValidateSyntax,
                disabled: !haveRelationships
              })
            )
          )
        ),
        _react2.default.createElement(
          _Izenda9.Table,
          {
            dataSource: flattenArraySourceGrid,
            onSortChange: this.onSortChange,
            getChildItems: getChildItems,
            sortInfo: colSortDirs,
            draggableTable: true,
            move: onMoveRelationship,
            canDrag: (0, _fp.constant)(true),
            canDrop: this.canDrop,
            warning: this.warning,
            keyJoinCount: totalKeyJoin,
            isLoading: isLoadingRelationship
          },
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["alias"], { cell: this.props.renderAlias })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["joinType"], { cell: this.props.renderJoinType })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["operator"], { cell: this.props.renderOperator })),
          !isAllQuerySourceUncategorized && _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["category"], { cell: this.props.renderCategory })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["dataObject"], { cell: this.props.renderDataObject })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["joinField"], { cell: this.props.renderJoinField })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["comparisonOperator"], { cell: this.props.renderComparision })),
          !isAllQuerySourceUncategorized && _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["foreignCategory"], { cell: this.props.renderCategory })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["foreignDataObject"], { cell: this.props.renderForeignDataObject })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["foreignJoinfield"], { cell: this.props.renderForeignJoinField })),
          _react2.default.createElement(_Izenda9.Column, (0, _extends3.default)({}, TABLE_DEF["action"], { align: "center", cell: this.props.renderAction }))
        )
      );
    }
  }]);
  return DataSourceGridAdvanced;
}(_react.Component), _class3.propTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "gridState", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      isDataSearchMinSize: _Izenda6.default.isMobile
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "onSearch", [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (searchProperty, searchText) {
      var store = _this2.props.store;


      store.dataSourceDetail.pageInfo.setSearchValues(searchProperty, searchText);
      store.loadDataSourceDetail();
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "onSearchPropertiesChange", [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (searchProperty, searchText) {
      var store = _this3.props.store;

      store.dataSourceDetail.pageInfo.setSearchValues(searchProperty, searchText);
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "onDataGridSearchSizeChange", [_dec4], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (isMinState) {
      _this4.gridState.isDataSearchMinSize = isMinState;
    };
  }
})), _class2)) || _class);
exports.default = DataSourceGridAdvanced;
module.exports = exports["default"];

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(144);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(145);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _bluebird = __webpack_require__(18);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

__webpack_require__(55);

var _Izenda = __webpack_require__(41);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda3 = __webpack_require__(23);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(17);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(109);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(29);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2666);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2667);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2668);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(2669);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2670);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(218);

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

var _Izenda22 = __webpack_require__(16);

var _Izenda23 = _interopRequireDefault(_Izenda22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceGridAdvancedActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var Input = (0, _Izenda4.default)()(_Izenda6.default);
var NumericInput = (0, _Izenda4.default)()(_Izenda8.default);
var DropDown = (0, _Izenda4.default)()(_Izenda10.default);
var DateTimeSelector = (0, _Izenda4.default)()(_Izenda12.default);
var FOREIGN_DATA_OBJECT_KEY = _Izenda23.default.TABLE_DEF.ADVANCED_MODE.foreignDataObject.key;
var CRITERIA_LIST_ADVANCED_MODE = _Izenda23.default.BUNDLE.CRITERIA_LIST_ADVANCED_MODE;

/**
 * Build drop-down component for data object.
 * @param {any} dataSourceItem
 * @param {string} key
 * @param {string} categoryKey
 * @param {any} store
 * @param {number} rowIndex
 * @param {any} column
 * @param {any} valManager
 */
function getDropdownForDataObject(dataSourceItem, key, categoryKey, store, rowIndex, column, valManager) {
  var isKeyJoin = dataSourceItem.isKeyJoin === true;
  var isForeignDataObject = key === _Izenda23.default.TABLE_DEF.ADVANCED_MODE.foreignDataObject.key;
  var comparisonType = findComparisonType((0, _fp.get)('comparisonOperator', dataSourceItem));
  var dataObjects = getSelectedDataObjects(dataSourceItem, categoryKey, store, isKeyJoin);

  // Return Empty cell if comparison type != Field
  if (comparisonType !== _Izenda23.default.COMPARISION_TYPE.FIELD && isForeignDataObject) {
    return null;
  }

  // Concat option with invalidAlias
  if (dataSourceItem.invalidAlias) {
    dataSourceItem.invalidAlias.alias.id = dataSourceItem.invalidAlias.alias.aliasId;
    dataObjects = (0, _fp.concat)(dataSourceItem.invalidAlias.alias, dataObjects);
  }

  // Filter data object for key join
  if (isKeyJoin) {
    dataObjects = filterDataObjectForKeyJoin(dataSourceItem, dataObjects, store);
  }

  var useAliasId = isForeignDataObject || isKeyJoin === true;
  var options = getDropdownOptions(dataObjects, true, useAliasId);
  var dataTree = store.dataTree;
  var dataSourceDetail = store.dataSourceDetail;

  return _react2.default.createElement(_Izenda18.default, {
    options: options,
    dataObjects: dataObjects,
    dataSourceItem: dataSourceItem,
    dataTree: dataTree,
    dataSourceDetail: dataSourceDetail,
    fieldName: key,
    rowIndex: rowIndex,
    checkJoinTypeEntities: checkJoinTypeEntities,
    store: store
  });
}

/**
 * Filter data object value for key join.
 * @param {any} dataSourceItem
 * @param {array} dataObjects
 * @param {any} store
 */
function filterDataObjectForKeyJoin(dataSourceItem, dataObjects, store) {
  var upperRelationships = findUpperRelationships(dataSourceItem, store);

  var upperDataObjectKeys = (0, _fp.concat)((0, _fp.flatMap)('joinQuerySourceId', upperRelationships), (0, _fp.flow)((0, _fp.flatMap)('selectedForeignAlias'), (0, _fp.map)(function (selectedAlias) {
    return (0, _fp.flow)((0, _fp.split)('_'), _fp.head)(selectedAlias);
  }))(upperRelationships));

  return (0, _fp.filter)(function (dataObject) {
    return upperDataObjectKeys.indexOf(dataObject.id) > -1;
  }, dataObjects);
}

/**
 * Find relationships which level is lesser than level of specify item's relationship.
 * @param {any} dataSourceItem
 * @param {any} store
 */
function findUpperRelationships(dataSourceItem, store) {
  var currentRelationship = (0, _fp.find)({ tempId: dataSourceItem.parentId }, store.dataSourceDetail.dataSourceGrid);

  if ((0, _fp.isEmpty)(currentRelationship)) {
    return [];
  }

  var upperRelationships = (0, _fp.filter)(function (item) {
    return item.level <= currentRelationship.level;
  }, store.dataSourceDetail.dataSourceGrid);

  return upperRelationships;
}

/**
 * Build drop-down component for category
 * @param {any} dataSourceItem
 * @param {string} key
 * @param {any} store
 * @param {number} rowIndex
 */
function getDropdownForCategory(dataSourceItem, key, store, rowIndex) {
  var categoryOptions = dataSourceItem.isKeyJoin === true ? getCategoryForKeyJoin(store, dataSourceItem) : getCategoryForRelationship(store);

  return _react2.default.createElement(_Izenda16.default, {
    dataSourceItem: dataSourceItem,
    categoryOptions: categoryOptions,
    fieldName: key,
    rowIndex: rowIndex,
    dataSourceDetail: store.dataSourceDetail
  });
}

/**
 * Get categories for relationship.
 * @param {any} store
 */
function getCategoryForRelationship(store) {
  var selectedTree = store.dataTree.selectedTree;


  return (0, _fp.flow)((0, _fp.filter)(function (category) {
    return (0, _fp.some)('selected', category.querySource);
  }), (0, _fp.map)(function (category) {
    return {
      label: category.name || _Izenda23.default.UNCATEGORIZED,
      value: category.id
    };
  }))(selectedTree);
}

/**
 * Get categories for key join.
 * @param {any} store
 * @param {any} dataSourceItem
 */
function getCategoryForKeyJoin(store, dataSourceItem) {
  var upperRelationships = findUpperRelationships(dataSourceItem, store);

  var relationshipCategoryKeys = (0, _fp.reduce)(function (result, relationship) {
    var readyCategory = relationship.joinDataSourceCategoryId && !(0, _fp.includes)(relationship.joinDataSourceCategoryId, result);
    readyCategory && result.push(relationship.joinDataSourceCategoryId);

    var readyForeignCategory = relationship.foreignDataSourceCategoryId && !(0, _fp.includes)(relationship.foreignDataSourceCategoryId, result);
    readyForeignCategory && result.push(relationship.foreignDataSourceCategoryId);
    return result;
  }, [], upperRelationships);

  // Get categories for key join, remove category which is not in higher order than key join's parent
  return (0, _fp.remove)(function (item) {
    return !(0, _fp.includes)(item.value, relationshipCategoryKeys);
  }, getCategoryForRelationship(store));
}

/**
 * Collect data object and foreign data object
 * @param  {array} upperRelationships are relationship created higher level
 * @return {array} the list objects data object
 */
function buildKeyJoinList(upperRelationships) {
  var objects = (0, _fp.reduce)(function (result, relationship) {
    var readyDataObject = relationship.joinQuerySourceId && (0, _fp.isEmpty)((0, _fp.find)({
      aliasId: relationship.joinQuerySourceId + '_' + (0, _fp.trim)(relationship.joinQuerySourceName)
    }, result));

    readyDataObject && result.push({
      aliasId: relationship.joinQuerySourceId + '_' + (0, _fp.trim)(relationship.joinQuerySourceName),
      name: (0, _fp.trim)(relationship.joinQuerySourceName)
    });

    var readyForeignAlias = relationship.selectedForeignAlias && (0, _fp.isEmpty)((0, _fp.find)({ aliasId: (0, _fp.trim)(relationship.selectedForeignAlias) }, result));

    readyForeignAlias && result.push({
      aliasId: (0, _fp.trim)(relationship.selectedForeignAlias),
      name: (0, _fp.trim)(relationship.foreignQuerySourceName)
    });

    return result;
  }, [], upperRelationships);

  return objects;
}

/**
 * Transform a list selected data included aliases to data object
 * @param  {array} objects            list object will be transformed
 * @param  {string} dataSourceItemKey  property name
 * @param  {array} selectedCategories category selected for current keyjoin
 * @return {array}                    List data object are ready for the keyjoin
 */
function transformKeyJoinToDataObject(objects, dataSourceItemKey, selectedCategories) {
  var dataObjects = (0, _fp.reduce)(function (result, item) {
    var dataObject = (0, _fp.find)({ aliasId: item.aliasId }, selectedCategories[dataSourceItemKey].dataObjects);

    // if new alias dataObject generated then that doesn't exist in the selected categories.
    // So we need to find the source dataObject and clone and push to keyjoin list
    if ((0, _fp.isNil)(dataObject)) {
      var id = item.aliasId && item.aliasId.substring(0, 36);
      var _dataObject = (0, _fp.find)({ id: id }, selectedCategories[dataSourceItemKey].dataObjects);

      if (!(0, _fp.isNil)(_dataObject)) {
        var aliasObject = (0, _fp.clone)(_dataObject);
        aliasObject.name = item.name;
        aliasObject.aliasId = item.aliasId;
        result.push(aliasObject);
      }
    } else {
      result.push(dataObject);
    }
    return result;
  }, [], objects);

  return dataObjects;
}

/**
 * Build list data object for key join
 * @param  {any} dataSourceItem    current keyjoin
 * @param  {string} categoryKey    category property name
 * @param  {any} store             the main store
 * @return {array}                 return list data object
 */
function getKeyJoinDataObjects(dataSourceItem, categoryKey, store) {
  var dataTree = store.dataTree;
  var selectedCategories = dataTree.selectedCategories;
  var dataSourceItemKey = dataSourceItem[categoryKey];

  if ((0, _fp.isEmpty)(dataSourceItemKey)) {
    return [];
  }

  var currentRelationship = (0, _fp.find)({ tempId: dataSourceItem.parentId }, store.dataSourceDetail.dataSourceGrid);

  if ((0, _fp.isEmpty)(currentRelationship)) {
    return [];
  }

  var upperRelationships = (0, _fp.filter)(function (item) {
    return item.level <= currentRelationship.level;
  }, store.dataSourceDetail.dataSourceGrid);

  var objects = buildKeyJoinList(upperRelationships);
  var dataObjects = transformKeyJoinToDataObject(objects, dataSourceItemKey, selectedCategories);
  return dataObjects;
}

/**
 * Get selected data objects.
 * @param {any} dataSourceItem
 * @param {string} categoryKey
 * @param {any} store
 * @param {boolean} isKeyJoin
 */
function getSelectedDataObjects(dataSourceItem, categoryKey, store, isKeyJoin) {
  var selectedTree = store.dataTree.selectedTree;

  var dataSourceItemKey = dataSourceItem[categoryKey];

  var category = (0, _fp.find)({ id: dataSourceItemKey }, selectedTree);
  var dataObjectsBelongToCategory = [];
  if (category) {
    dataObjectsBelongToCategory = (0, _fp.filter)({ selected: true }, category.querySource);
  }

  if ((0, _fp.isEmpty)(dataSourceItemKey)) {
    return [];
  }

  var availableAlias = [];
  if (categoryKey === _Izenda23.default.TABLE_DEF.ADVANCED_MODE.foreignCategory.key || isKeyJoin) {
    availableAlias = (0, _fp.reduce)(function (result, aliasDetail) {
      var dataObject = (0, _fp.find)({ id: aliasDetail.alias.sourceId }, dataObjectsBelongToCategory);
      if (!(0, _fp.isNil)(dataObject)) {
        var aliasObject = _mobx2.default.toJS(dataObject);
        aliasObject.name = (0, _fp.trim)(aliasDetail.alias.name);
        aliasObject.aliasId = (0, _fp.trim)(aliasDetail.alias.aliasId);
        aliasObject.isDataSourceAlias = true;

        var notInAliasCollection = (0, _fp.isEmpty)((0, _fp.find)({ aliasId: (0, _fp.trim)(aliasObject.aliasId) }, result));
        var notDataObjectList = (0, _fp.isEmpty)((0, _fp.find)({ aliasId: (0, _fp.trim)(aliasObject.aliasId) }, dataObjectsBelongToCategory));
        if (notInAliasCollection && notDataObjectList) {
          result.push(aliasObject);
        }
      }
      return result;
    }, [], store.dataSourceDetail.availableAlias(dataSourceItem));
  }

  return !(0, _fp.isEmpty)(dataObjectsBelongToCategory) ? (0, _fp.concat)(availableAlias, dataObjectsBelongToCategory) : [];
}

/**
 * get options for Dropdown list
 * @param {array} list
 * @param {boolean} isNotRemoveItem
 * @param {boolean} useAliasId
 */
function getDropdownOptions(list, isNotRemoveItem, useAliasId) {
  var options = [];
  var showSchemaName = _Izenda2.default.advancedSettings.other.showSchemaNameValue;
  var newList = (0, _fp.flow)((0, _fp.filter)(function (item) {
    return (item.visible || isNotRemoveItem) && !item.isCalculated;
  }), (0, _fp.map)(function (item) {
    return {
      label: item.name,
      value: !!useAliasId ? item.aliasId : item.id,
      visible: item.visible,
      isDataSourceAlias: item.isDataSourceAlias,
      labelDisplay: showSchemaName && !item.isDataSourceAlias && item.querySourceCategoryName ? item.querySourceCategoryName + '.' + item.name : item.name
    };
  }))(list);

  options.splice.apply(options, [1, 0].concat(newList));
  return options;
}

/**
 * Create dropdown list for field of Data Object and Foreign Data object
 * @param  {any} dataSourceItem current relationship item
 * @param  {any} column
 * @param  {string} dataObjectKey  dataObject field
 * @param  {string} categoryKey    category field of relationship item
 * @param  {any} store
 * @param  {number} rowIndex
 * @param  {any} valManager
 * @param  {boolean} isForeignJoinField
 */
function getDropdownForJoinField(dataSourceItem, column, dataObjectKey, categoryKey, store, rowIndex, valManager, isForeignJoinField) {
  var comparisonType = findComparisonType((0, _fp.get)('comparisonOperator', dataSourceItem));

  // Return Empty cell if comparison type != Field
  if (comparisonType !== _Izenda23.default.COMPARISION_TYPE.FIELD && isForeignJoinField) {
    return null;
  }

  function changeJoinField() {
    store.reportStore.model.markDirty();
    store.reportStore.dataSourceStore.dataSourceDetail.markDataSourceGridDirty();
    valManager.reset();
  }

  return _react2.default.createElement(_Izenda20.default, {
    dataSourceItem: dataSourceItem,
    dataObjectKey: dataObjectKey,
    categoryKey: categoryKey,
    getDataObjects: getSelectedDataObjects,
    getDropdownOptions: getDropdownOptions,
    store: store,
    onChange: changeJoinField,
    rowIndex: rowIndex,
    column: column
  });
}

/**
 * Verify join type entities
 * @param {any} store
 * @param {any} item
 */
function checkJoinTypeEntities(props, store, item) {
  var dataSourceDetail = store.dataSourceDetail;

  var existedItem = dataSourceDetail.checkExistEntities.call(dataSourceDetail, item);

  if (existedItem) {
    var message = String.format(_Izenda23.default.BUNDLE.MESSAGE.CHANGE_JOIN_TYPE, existedItem.joinQuerySourceName, existedItem.foreignQuerySourceName);

    return props.confirmFn('Confirmation', {
      description: message
    }).then(function () {
      dataSourceDetail.updateJoinTypeForSameEntities.call(dataSourceDetail, item, true);
      return true;
    }).catch(function () {
      dataSourceDetail.updateJoinTypeForSameEntities.call(dataSourceDetail, item, false);
      return false;
    });
  }

  return (0, _bluebird.resolve)(true);
}

/**
 * Find Comparison Type
 * @param {string} comparisonOperator
 * @returns {string} comparison type
 */
function findComparisonType(comparisonOperator) {
  return (0, _fp.flow)((0, _fp.find)({ value: comparisonOperator }), (0, _fp.get)('type'))(_Izenda23.default.COMPARISION_OPTIONS);
}

/**
 * Get Comparison Value control, when comparison operator != Field group
 * @param {any} dataSourceItem
 * @param {any} store
 */
function getComparisonValue(dataSourceItem, store) {
  var COMPARISION_TYPE = _Izenda23.default.COMPARISION_TYPE;
  var DATA_TYPES = _Izenda23.default.DATA_TYPES;
  var comparisonType = findComparisonType((0, _fp.get)('comparisonOperator', dataSourceItem));

  function changeComparisionValue(value) {
    dataSourceItem.setComparisionValue && dataSourceItem.setComparisionValue(value);
    store.dataSourceDetail.markDirty();
    store.dataSourceDetail.markDataSourceGridDirty();
  }

  var commonProps = {
    value: dataSourceItem.comparisonValue,
    field: 'comparisonValue',
    group: 'Relationships' + dataSourceItem.tempId
  };

  var joinField = getJoinField(dataSourceItem, store);

  switch (comparisonType) {
    case COMPARISION_TYPE.VALUE:
      // Only accept Number for Numeric/Money type
      if (joinField && [DATA_TYPES.NUMERIC, DATA_TYPES.MONEY].indexOf(joinField.izendaDataType) > -1) {
        return _react2.default.createElement(NumericInput, (0, _extends3.default)({}, commonProps, { onChange: changeComparisionValue }));
      } else {
        return _react2.default.createElement(Input, (0, _extends3.default)({}, commonProps, {
          className: 'form-control col-md-12',
          onChange: _EventUtils2.default.notifyChange(changeComparisionValue, _EventUtils2.default.INPUT)
        }));
      }
    case COMPARISION_TYPE.TIME:
      return _react2.default.createElement(DateTimeSelector, (0, _extends3.default)({}, commonProps, {
        time: comparisonType !== COMPARISION_TYPE.DATE,
        calendar: comparisonType !== COMPARISION_TYPE.TIME,
        onChange: changeComparisionValue,
        returnAs: _Izenda21.Types.TIME
      }));
    case COMPARISION_TYPE.DATE:
    case COMPARISION_TYPE.DATE_TIME:
      return _react2.default.createElement(DateTimeSelector, (0, _extends3.default)({}, commonProps, {
        time: comparisonType !== COMPARISION_TYPE.DATE,
        calendar: comparisonType !== COMPARISION_TYPE.TIME,
        onChange: changeComparisionValue
      }));
  }

  return null;
}

/**
 * Get join field
 * @param {any} dataSourceItem
 * @param {any} store
 */
function getJoinField(dataSourceItem, store) {
  var selectedDataObjects = getSelectedDataObjects(dataSourceItem, _Izenda23.default.TABLE_DEF.ADVANCED_MODE.category.key, store);

  return (0, _fp.flow)((0, _fp.flatMap)(function (querySource) {
    return querySource.fields.slice();
  }), (0, _fp.find)({ id: dataSourceItem.joinFieldId }))(selectedDataObjects);
}

exports.default = (0, _recompose.withHandlers)({
  /**
   * Occur when a relationship is added
   */
  onAddRelationship: (0, _fp.curry)(function (props, _) {
    var store = props.store;
    var dataSourceDetail = store.dataSourceDetail,
        selectedTree = store.dataTree.selectedTree,
        reportStore = store.reportStore,
        isAllQuerySourceUncategorized = store.isAllQuerySourceUncategorized;


    dataSourceDetail.addNew(selectedTree, isAllQuerySourceUncategorized);
    reportStore.model.markDirty();
  }),

  /**
   * Occur when click validate syntax button
   */
  onValidateSyntax: (0, _fp.curry)(function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(props, _) {
      var reportStore, validation, localization, validateResult, validateSyntaxResult, validateCycleResult;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reportStore = props.store.reportStore, validation = props.validation, localization = props.localization;


              reportStore.alertDetails.reset();
              _context.next = 4;
              return validation.validate();

            case 4:
              validateResult = _context.sent;

              if (!validateResult) {
                _context.next = 13;
                break;
              }

              _context.next = 8;
              return reportStore.validateRelationshipSyntax();

            case 8:
              validateSyntaxResult = _context.sent;
              _context.next = 11;
              return reportStore.validateCycleRelationships();

            case 11:
              validateCycleResult = _context.sent;


              if (validateSyntaxResult.success && validateCycleResult.success) {
                reportStore.setAlertDetails({
                  success: true,
                  message: localization.getText('REPORTDESIGNER_MESSAGE_VALID_SQL_STATEMENT')
                });
              } else {
                !validateSyntaxResult.success && reportStore.model.updateErrorMessages(validateSyntaxResult.messages);
                !validateCycleResult.success && reportStore.setAlertDetails({
                  success: false,
                  errors: [{ message: (0, _fp.get)('messages[0].messages[0]', validateCycleResult) }]
                });
              }

            case 13:
              return _context.abrupt('return', validateResult);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }()),

  /**
   * Handle moving relationship between rows:
   * 1. Move rows in dataSourceGrid
   * 2. Reindex AliasLevel
   * 3. Handle invalid aliases
   * @param {number} currentIndex
   * @param {number} newIndex
   */
  onMoveRelationship: (0, _fp.curry)(function (props, currentIndex, newIndex, currentRow, newRow) {
    if ((0, _fp.isNil)(currentRow) || (0, _fp.isNil)(newRow) || currentRow === newRow) {
      return;
    }

    var store = props.store,
        validation = props.validation,
        localization = props.localization;
    var dataSourceDetail = store.dataSourceDetail;
    var dataSourceGrid = dataSourceDetail.dataSourceGrid;


    validation.reset();

    var handleInvalidAlias = function handleInvalidAlias(item) {
      var invalidAliasLevels = dataSourceDetail.getInvalidAliasLevelsForRow(item);

      // Only one invalid Alias at same time
      item.invalidAlias = invalidAliasLevels.length > 0 ? (0, _fp.first)(invalidAliasLevels) : null;

      if (invalidAliasLevels > 0) {
        var message = item.isKeyJoin ? localization.getText('COMMON_MESSAGES_INVALID_KEY_JOIN') : localization.getText('COMMON_MESSAGES_INVALID_RELATIONSHIP');

        validation.updateErrors([{
          key: 'Relationships' + item.validationKey + FOREIGN_DATA_OBJECT_KEY,
          message: [message]
        }]);
      }
    };

    dataSourceDetail.moveRelationshipOrKeyJoin(currentRow, newRow, _Izenda22.VALIDATION_KEY).then(function () {
      dataSourceGrid.map(function (item) {
        handleInvalidAlias(item);
      });

      store.reportStore.model.markDirty();
    });
  }),

  /**
   * Rebuild search options
   */
  rebuildSearchOptions: (0, _fp.curry)(function (props, _) {
    var isAllQuerySourceUncategorized = props.store.isAllQuerySourceUncategorized;


    return !isAllQuerySourceUncategorized ? CRITERIA_LIST_ADVANCED_MODE : (0, _fp.reject)({ label: 'Category' }, CRITERIA_LIST_ADVANCED_MODE);
  }),

  /**
   * Get childs item
   */
  getChildItems: (0, _fp.curry)(function (props, item) {
    return item.displayKeyJoins;
  }),

  renderAlias: (0, _fp.curry)(function (_ref2, dataSourceItem, key) {
    var valManager = _ref2.validation,
        store = _ref2.store;

    if ((0, _fp.isNil)(dataSourceItem[key])) {
      return '';
    }
    var dataSourceDetail = store.dataSourceDetail,
        dataModel = store.reportStore.model;

    var dataObjectKey = _Izenda23.default.TABLE_DEF.ADVANCED_MODE.dataObject.key;

    function aliasTextChange(e) {
      valManager.reset();
      dataSourceItem.setAlias(e.target.value);
      dataModel.markDirty();
      dataSourceDetail.markDataSourceGridDirty();
    }

    var blurAlias = function blurAlias(e) {
      // Revert to previous alias if current value is blank, data source needs alias, and joinQuerySourceId has value.
      if (!e.target.value && dataSourceItem.needAlias && dataSourceItem[dataObjectKey]) {
        dataSourceItem.alias = dataSourceItem.previousAlias;
      }

      // Handle for manually input alias
      if (e.target.value && !dataSourceItem.needAlias) {
        dataSourceItem.needAlias = true;
      }

      if (dataSourceItem.alias !== dataSourceItem.previousAlias) {
        dataSourceDetail.populateUpdatedAlias(dataSourceItem);
      }

      dataSourceDetail.updateAliasLevel(dataSourceDetail.getAliasOption(dataSourceItem, dataSourceItem[key]), dataSourceItem);
    };

    function focusAlias() {
      if (dataSourceItem.needAlias) {
        dataSourceItem.previousAlias = dataSourceItem.alias;
      }
    }

    return _react2.default.createElement(Input, {
      className: 'form-control col-md-12',
      containerClassName: '',
      value: dataSourceItem[key],
      maxLength: '100',
      onChange: aliasTextChange,
      onFocus: focusAlias,
      onBlur: blurAlias,
      field: key,
      group: 'Relationships' + dataSourceItem.tempId,
      shouldFocus: true
    });
  }),

  renderJoinType: (0, _fp.curry)(function (props, dataSourceItem, key, rowIndex, column) {
    var store = props.store,
        reportStore = props.store.reportStore,
        valManager = props.validation,
        confirmFn = props.confirmFn;


    if ((0, _fp.isNil)(dataSourceItem[key])) {
      return '';
    }

    var checkJoinType = function checkJoinType(object) {
      checkJoinTypeEntities(props, store, dataSourceItem).then(function (result) {
        if (result && object.value === _Izenda23.default.JOIN_TYPE_CROSS) {
          dataSourceItem.joinFieldId = null;
          dataSourceItem.foreignFieldId = null;
        }
      });
    };

    var changeJoinType = function changeJoinType(object) {
      valManager.reset();
      reportStore.model.markDirty();
      reportStore.dataSourceStore.dataSourceDetail.markDataSourceGridDirty();

      // Clear key join when user select Cross
      if (object.value === _Izenda23.default.JOIN_TYPE_CROSS && !(0, _fp.isEmpty)(dataSourceItem.relationshipKeyJoins)) {
        confirmFn('Confirmation', {
          description: _Izenda23.default.BUNDLE.MESSAGE.SELECT_CROSS_JOIN
        }).then(function () {
          dataSourceItem.updateJoinType(key, object.value);
          checkJoinType(object);
        });
      } else {
        dataSourceItem.updateJoinType(key, object.value);
        checkJoinType(object);
      }
    };

    return _react2.default.createElement(DropDown, {
      options: _Izenda23.default.JOIN_TYPES,
      onChange: changeJoinType,
      value: dataSourceItem[key],
      valueField: 'value',
      labelField: 'label',
      validations: _Izenda23.default.REQUIRED_CONSTRAINT,
      field: key,
      group: 'Relationships' + dataSourceItem.tempId
    });
  }),

  renderOperator: (0, _fp.curry)(function (_ref3, dataSourceItem, key, rowIndex, column) {
    var valManager = _ref3.validation,
        reportStore = _ref3.store.reportStore;

    if ((0, _fp.isNil)(dataSourceItem[key])) {
      return '';
    }

    var changeOperator = function changeOperator(object) {
      valManager.reset();
      dataSourceItem.updateKeyJoinItem(key, object.value);
      reportStore.model.markDirty();
      reportStore.dataSourceStore.dataSourceDetail.markDataSourceGridDirty();
    };

    return _react2.default.createElement(DropDown, {
      options: _Izenda23.default.OPERATOR_TYPES,
      onChange: changeOperator,
      value: dataSourceItem[key],
      valueField: 'label',
      labelField: 'label',
      validations: _Izenda23.default.REQUIRED_CONSTRAINT,
      field: key,
      group: 'Relationships' + dataSourceItem.tempId
    });
  }),

  renderCategory: (0, _fp.curry)(function (_ref4, dataSourceItem, key, rowIndex, column) {
    var store = _ref4.store;

    var isForeignCategory = key === _Izenda23.default.TABLE_DEF.ADVANCED_MODE.foreignCategory.key;
    var comparisonType = findComparisonType((0, _fp.get)('comparisonOperator', dataSourceItem));
    var isAllQuerySourceUncategorized = store.isAllQuerySourceUncategorized;


    if (!isAllQuerySourceUncategorized && isForeignCategory && comparisonType !== _Izenda23.default.COMPARISION_TYPE.FIELD) {
      return getComparisonValue(dataSourceItem, store);
    }

    return getDropdownForCategory(dataSourceItem, key, store, rowIndex);
  }),

  renderDataObject: (0, _fp.curry)(function (_ref5, dataSourceItem, key, rowIndex, column) {
    var valManager = _ref5.validation,
        store = _ref5.store;

    var categoryKey = _Izenda23.default.TABLE_DEF.ADVANCED_MODE.category.key;
    return getDropdownForDataObject(dataSourceItem, key, categoryKey, store, rowIndex, valManager);
  }),

  renderForeignDataObject: (0, _fp.curry)(function (_ref6, dataSourceItem, key, rowIndex, column) {
    var valManager = _ref6.validation,
        store = _ref6.store,
        needShowComparisonValueInDataObjectCol = _ref6.store.dataTree.isAllDataOjectUncategory;

    var categoryKey = _Izenda23.default.TABLE_DEF.ADVANCED_MODE.foreignCategory.key;
    var comparisonType = findComparisonType((0, _fp.get)('comparisonOperator', dataSourceItem));

    // The category column will be hidden if all data objects are uncategorized.
    // So it needs to show comparison value in here if the category column is hidden.
    // It only show comparison value in either category column (if showing) or foreign data object column, not both.
    if (needShowComparisonValueInDataObjectCol && comparisonType !== _Izenda23.default.COMPARISION_TYPE.FIELD) {
      return getComparisonValue(dataSourceItem, store);
    }

    return getDropdownForDataObject(dataSourceItem, key, categoryKey, store, rowIndex, valManager);
  }),

  renderJoinField: (0, _fp.curry)(function (_ref7, dataSourceItem, key, rowIndex, column) {
    var valManager = _ref7.validation,
        store = _ref7.store;

    var dataObjectKey = _Izenda23.default.TABLE_DEF.ADVANCED_MODE.dataObject.key;
    var categoryKey = _Izenda23.default.TABLE_DEF.ADVANCED_MODE.category.key;
    return getDropdownForJoinField(dataSourceItem, column, dataObjectKey, categoryKey, store, rowIndex, valManager);
  }),

  renderForeignJoinField: (0, _fp.curry)(function (_ref8, dataSourceItem, key, rowIndex, column) {
    var valManager = _ref8.validation,
        store = _ref8.store;

    var dataObjectKey = _Izenda23.default.TABLE_DEF.ADVANCED_MODE.foreignDataObject.key;
    var categoryKey = _Izenda23.default.TABLE_DEF.ADVANCED_MODE.foreignCategory.key;
    return getDropdownForJoinField(dataSourceItem, column, dataObjectKey, categoryKey, store, rowIndex, valManager, true);
  }),

  renderAction: (0, _fp.curry)(function (_ref9, dataSourceItem) {
    var store = _ref9.store;

    return _react2.default.createElement(_Izenda14.default, { relationshipDetails: dataSourceItem, store: store });
  }),

  renderComparision: (0, _fp.curry)(function (_ref10, dataSourceItem, key) {
    var store = _ref10.store;

    var trimTimeInJoins = _Izenda2.default.advancedSettings.other.trimTimeInJoinsValue;
    var options = !!dataSourceItem.isKeyJoin ? _Izenda23.default.COMPARISION_OPTIONS : (0, _fp.filter)({ forRelationship: true }, _Izenda23.default.COMPARISION_OPTIONS);
    var joinField = getJoinField(dataSourceItem, store);
    var isAllQuerySourceUncategorized = store.isAllQuerySourceUncategorized;

    // Filter option by data type

    if (joinField) {
      options = (0, _fp.filter)(function (option) {
        return option.DATA_TYPES.indexOf(joinField.izendaDataType) > -1 && (!trimTimeInJoins || option.type != _Izenda23.default.COMPARISION_TYPE.DATE_TIME);
      }, options);
    }

    function changeComparision(value) {
      var currentComparisionType = findComparisonType(dataSourceItem.comparisonOperator);
      var newComparisionType = findComparisonType(value);

      dataSourceItem.setComparisionOperator && dataSourceItem.setComparisionOperator(value);
      // Reset comparision value when change to another type
      if (currentComparisionType !== newComparisionType) {
        dataSourceItem.setComparisionValue(null);

        // When user switch back to field comparision, set correct data source category
        var categoryDataSource = _Izenda23.default.EMPTY_GUID;
        if (newComparisionType === _Izenda23.default.COMPARISION_TYPE.FIELD && isAllQuerySourceUncategorized) {
          categoryDataSource = _Izenda22.EMPTY_GUID;
        }
        dataSourceItem.setForeignDataSourceCategory && dataSourceItem.setForeignDataSourceCategory(categoryDataSource);
      }
      store.dataSourceDetail.markDirty();
      store.dataSourceDetail.markDataSourceGridDirty();
    }

    return _react2.default.createElement(DropDown, {
      groupBy: 'group',
      options: options,
      value: dataSourceItem[key],
      onChange: _EventUtils2.default.notifyChange(changeComparision, _EventUtils2.default.DROPDOWN),
      disabledBlankOption: true,
      disabled: !dataSourceItem.joinFieldId,
      field: key,
      group: 'Relationships' + dataSourceItem.tempId,
      showTooltip: true
    });
  })
});
module.exports = exports['default'];

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(150);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimeSelector.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var classnames = __webpack_require__(11);
  var Moment = __webpack_require__(19);
  var connect = __webpack_require__(2);

  var FloatAffixed = __webpack_require__(154);

  var Types = __webpack_require__(218).Types;
  var Units = __webpack_require__(218).Units;
  var Keys = __webpack_require__(218).Keys;
  var Levels = __webpack_require__(218).Levels;
  var DateTimeCalendar = __webpack_require__(933);

  var AppGlobalConstants = __webpack_require__(115);
  var DATE_TIME_FORMAT = AppGlobalConstants.DATE_TIME_FORMAT;
  var TIME_FORMAT = AppGlobalConstants.TIME_FORMAT;
  var DATE_FORMAT = AppGlobalConstants.DATE_FORMAT;
  var DEFAULT_DATE_FORMAT = "MM/DD/YYYY";
  var uiState = __webpack_require__(15);

  var ISOregex = /((\d{4}\-\d\d\-\d\d)[tT]([\d:\.]*)?)([zZ]|([+\-])(\d\d):?(\d\d))/;
  var minutesOfDay = function minutesOfDay(m) {
    return Moment(m).minutes() + Moment(m).hours() * 60;
  };

  var DateTimeSelector = React.createClass({
    displayName: 'DateTimeSelector',

    above: false,

    propTypes: {
      time: PropTypes.bool,
      calendar: PropTypes.bool,
      min: PropTypes.any,
      max: PropTypes.any,
      format: PropTypes.string,
      onChangeInput: PropTypes.func,
      returnAs: PropTypes.oneOf([Types.ISO, Types.JS_DATE, Types.MOMENT, Types.STRING]),
      closeOnSelect: PropTypes.bool,
      closeOnBlur: PropTypes.bool,
      placeholder: PropTypes.string,
      name: PropTypes.string,
      options: PropTypes.object,
      disabled: PropTypes.bool,
      visible: PropTypes.bool,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onSelect: PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
      return {
        closeOnSelect: true,
        closeOnBlur: true,
        visible: false,
        calendar: true,
        time: true,
        returnAs: Types.STRING
      };
    },

    getInitialState: function getInitialState() {
      return {
        datetime: this.getDateTimeInput().datetime,
        input: this.getDateTimeInput().input,
        type: this.getDateTimeInput().type,
        visible: false,
        level: this.getDefaultLevel()
      };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      if (this.props != nextProps) {
        this.validate(this.getDateTimeInput(nextProps).datetime, null, true);
        this.setState({
          datetime: this.getDateTimeInput(nextProps).datetime,
          input: this.getDateTimeInput(nextProps).input
        });
      }
    },

    getDateTimeInput: function getDateTimeInput(props) {
      props = props || this.props;
      var prop = props.value || null;
      var datetime, input, type;

      var setDefautDateTimeInput = function setDefautDateTimeInput() {
        datetime = Moment();
        input = null;
        type = Types.MOMENT;
      };

      if (prop === null) {
        setDefautDateTimeInput();
      } else {

        datetime = this.parse(prop);
        if (datetime && datetime.isValid()) {
          input = datetime.format(this.format(props));
          switch (typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop)) {
            case 'object':
              if (Moment.isDate(prop)) {
                type = Types.JS_DATE;
              } else if (Moment.isMoment(prop)) {
                type = Types.MOMENT;
              } else {
                type = null;
              }
              break;
            case 'string':
              if (prop.match(ISOregex)) {
                type = Types.ISO;
              } else {
                type = Types.STRING;
              }
              break;
          }
        } else {
          setDefautDateTimeInput();
        }
      }

      return {
        datetime: datetime,
        input: input,
        type: type
      };
    },

    getDefaultLevel: function getDefaultLevel() {
      if (this.props.time) {
        return Units.HOUR;
      } else {
        return Units.DAY;
      }
    },

    format: function format(props) {
      props = props || this.props;

      if (typeof props.displayFormat !== 'undefined') {
        return props.displayFormat;
      } else if (props.calendar === false) {
        return TIME_FORMAT;
      } else {
        var dateFormat = uiState.currentUser.dateFormat || DEFAULT_DATE_FORMAT;
        return props.time ? dateFormat + ' ' + TIME_FORMAT : dateFormat;
      }
    },

    storeFormat: function storeFormat(props) {
      props = props || this.props;
      if (typeof props.storeFormat !== 'undefined') {
        return props.storeFormat;
      } else if (!props.time) {
        return DATE_FORMAT;
      } else {
        return DATE_TIME_FORMAT;
      }
    },

    toggle: function toggle(visible) {
      // Attempt to exit early
      if (visible === this.state.visible || this.props.disabled) {
        return;
      }
      if (typeof visible === 'undefined') {
        visible = !this.state.visible;
      }
      if (visible !== this.state.visible) {
        this.setState({ visible: visible });
      }
    },

    parse: function parse(input) {
      if (input === null) {
        return null;
      }
      var parsing = Moment(input, this.storeFormat(), true);
      if (!parsing.isValid()) {
        var parsingUserFormat = Moment(input, this.format(), true);
        parsing = !parsingUserFormat.isValid() ? null : parsingUserFormat;
      }
      return parsing;
    },

    save: function save(saving) {
      var datetime = this.state.datetime;
      this.setState({
        datetime: saving,
        input: saving.format(this.format())
      });

      if (this.validate(saving, null, true)) this.commit(saving);
    },

    validate: function validate(datetime, timeUnit, isSaving) {
      var outsideRange = false;

      if (this.props.min && Moment(datetime).isBefore(this.props.min)) {
        outsideRange = true;
      }
      if (this.props.max && Moment(datetime).isAfter(this.props.max)) {
        outsideRange = true;
      }

      if (outsideRange && timeUnit !== 'hours') {
        if (Moment(datetime).isSame(this.props.min, timeUnit) || Moment(datetime).isSame(this.props.max, timeUnit)) {
          outsideRange = false;
        }
      }

      return !outsideRange;
    },

    commit: function commit(datetime) {
      var returnAs = this.props.returnAs || this.state.type;
      var result;
      switch (returnAs) {
        case Types.ISO:
          result = datetime.toISOString();
          break;
        case Types.JS_DATE:
          result = datetime.toDate();
          break;
        case Types.MOMENT:
          result = datetime;
          break;
        case Types.STRING:
          result = Moment(datetime).format(this.storeFormat());
          break;
        case Types.TIME:
          result = datetime.format(this.format());
          break;
      }

      this.props.onChange && this.props.onChange(result);
    },

    onBlurInput: function onBlurInput(e) {
      var datetime = this.state.datetime || Moment();

      if (this.above) {
        this._input.focus();
      } else if (this.props.closeOnBlur) {
        this.toggle(false);
        if (this.props.onBlur) this.props.onBlur(e);
      }
      if (this.state.input == datetime.format(this.format())) {
        return;
      } else {
        datetime = this.parse(this.state.input);
        if (datetime && datetime.isValid()) {
          this.save(datetime);
        } else {
          this.setState({ input: null });
          this.props.onChange && this.props.onChange(null);
        }
      }
    },

    onChangeInput: function onChangeInput(e) {
      if (this.props.onChangeInput) this.props.onChangeInput(e);

      var input = e.target.value;
      var datetime = Moment(input, this.format(), true);
      if (datetime.isValid()) {
        this.save(datetime);
      } else if (input === '') {
        this.setState({
          datetime: null,
          input: ''
        });
        this.props.onChange && this.props.onChange(null);
      } else {
        this.setState({ input: input });
      }
    },

    onSelect: function onSelect(datetime, close, timeUnit) {
      var shouldClose = close;
      var visible = this.state.visible;
      var closeOnSelect = this.props.closeOnSelect;

      if (timeUnit) {
        if (!this.validate(datetime, timeUnit.unit)) shouldClose = false;
      } else {
        if (!this.validate(datetime)) shouldClose = false;
      }

      if (close && shouldClose === false) return;

      var willBeVisible = closeOnSelect && shouldClose ? !visible : visible;

      this.setState({ visible: willBeVisible });
      this.save(datetime);

      if (this.props.onSelect) this.props.onSelect(datetime, willBeVisible);
    },

    onKeyDown: function onKeyDown(e) {
      var code = e.keyCode;
      var datetime = this.state.datetime || Moment();
      var lvl = Levels[this.state.level];

      switch (code) {
        case Keys.UP:
          this.onSelect(datetime.subtract(lvl.key.span, lvl.key.unit));
          break;
        case Keys.DOWN:
          this.onSelect(datetime.add(lvl.key.span, lvl.key.unit));
          break;
        case Keys.ENTER:
          if (lvl.down) {
            this.setState({ level: lvl.down });
          } else {
            if (this.state.input == datetime.format(this.format())) {
              if (!this.validate(datetime)) {
                this.toggle(true);
              }
            } else {
              if (!this.state.visible) this.toggle(true);
              datetime = this.parse(this.state.input);
              if (datetime) {
                this.save(datetime);
              } else {
                this.setState({ input: null });
              }
            }
          }
          break;
      }
    },

    onCalendarClick: function onCalendarClick() {
      if (this.props.disabled) return;
      this._input.focus();
      this.setState({
        level: Units.DAY,
        visible: true
      });
    },

    onTimeClick: function onTimeClick() {
      if (this.props.disabled) return;
      this._input.focus();
      this.setState({
        level: Units.HOUR,
        visible: true
      });
    },

    handleAbove: function handleAbove(bool) {
      return typeof bool === 'undefined' ? this.above : this.above = bool;
    },

    setLevel: function setLevel(level) {
      this.setState({ level: level });
    },

    setDomNode: function setDomNode(input) {
      this._input = input;
    },

    renderControlButtons: function renderControlButtons() {
      var state = this.state;
      return React.createElement(
        'div',
        { className: 'izenda-DateTimePicker-controls' },
        this.props.calendar && React.createElement(
          'button',
          { className: 'izenda-DateTimePicker-button', onClick: this.onCalendarClick },
          React.createElement('span', { className: 'icon-calendar-new' })
        ),
        this.props.time && React.createElement(
          'button',
          { className: 'izenda-DateTimePicker-button', onClick: this.onTimeClick },
          React.createElement('span', { className: 'icon-clock' })
        )
      );
    },

    render: function render() {
      var mainClasses = classnames(this.props.className, {
        'izenda-DateTimePicker': true,
        'once-control': !(this.props.calendar && this.props.time)
      });
      var inputClasses = classnames('izenda-DateTimePicker-input');

      return React.createElement(
        'div',
        { className: mainClasses },
        React.createElement('input', {
          type: 'text',
          ref: this.setDomNode,
          value: this.state.input || '',
          onBlur: this.onBlurInput,
          onKeyDown: this.onKeyDown,
          onChange: this.onChangeInput,
          placeholder: this.props.placeholder,
          name: this.props.name,
          className: inputClasses,
          disabled: this.props.disabled
        }),
        this.renderControlButtons(),
        this.state.visible && React.createElement(
          FloatAffixed,
          {
            anchor: this._input,
            onClickOutside: this.toggle.bind(this, false),
            onParentScroll: this.toggle.bind(this, false)
          },
          React.createElement(DateTimeCalendar, {
            id: this.props.id,
            datetime: this.state.datetime,
            onSelect: this.onSelect,
            above: this.handleAbove,
            level: this.state.level,
            setLevel: this.setLevel,
            validate: this.validate,
            options: this.props.options
          })
        )
      );
    }
  });

  module.exports = connect({ toClass: true })(DateTimeSelector);
}();

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.GridActionColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobx = __webpack_require__(5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var GridActionColumn = (_dec = (0, _Izenda2.default)(), _dec2 = (0, _mobx.action)('onClickDelete'), _dec3 = (0, _mobx.action)('onClickCopy'), _dec4 = (0, _mobx.action)('onAddKeyJoin'), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(GridActionColumn, _Component);

  function GridActionColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GridActionColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GridActionColumn.__proto__ || (0, _getPrototypeOf2.default)(GridActionColumn)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'onClickDelete', _descriptor, _this), _initDefineProp(_this, 'onClickCopy', _descriptor2, _this), _initDefineProp(_this, 'onAddKeyJoin', _descriptor3, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GridActionColumn, [{
    key: 'renderAddIcon',
    value: function renderAddIcon() {
      var _props = this.props,
          localization = _props.localization,
          relationshipDetails = _props.relationshipDetails;

      var disableAddIcon = relationshipDetails.joinType === _Izenda4.default.JOIN_TYPES[3].label;

      var addIconClass = (0, _classnames2.default)('icon-plus', { 'disabled-elm': disableAddIcon });

      return (0, _fp.isNil)(relationshipDetails.isKeyJoin) && _react2.default.createElement(
        'a',
        { onClick: !disableAddIcon && this.onAddKeyJoin },
        _react2.default.createElement('span', { title: localization.getText('REPORTDESIGNER_LABEL_ADD_KEY_JOIN'), className: addIconClass })
      );
    }
  }, {
    key: 'renderCopyIcon',
    value: function renderCopyIcon() {
      var _props2 = this.props,
          relationshipDetails = _props2.relationshipDetails,
          localization = _props2.localization;

      var copyTooltip = relationshipDetails.isKeyJoin ? localization.getText('REPORTDESIGNER_TOOLTIP_COPY_KEY_JOIN') : localization.getText('REPORTDESIGNER_TOOLTIP_COPY_RELATIONSHIP');

      return _react2.default.createElement(
        'a',
        { onClick: this.onClickCopy },
        _react2.default.createElement('span', { title: copyTooltip, className: 'icon-copy' })
      );
    }
  }, {
    key: 'renderDeleteIcon',
    value: function renderDeleteIcon() {
      var _props3 = this.props,
          relationshipDetails = _props3.relationshipDetails,
          localization = _props3.localization;

      var deleteTooltip = relationshipDetails.isKeyJoin ? localization.getText('REPORTDESIGNER_TOOLTIP_DELETE_KEY_JOIN') : localization.getText('REPORTDESIGNER_TOOLTIP_DELETE_RELATIONSHIP');

      return _react2.default.createElement(
        'a',
        { onClick: this.onClickDelete },
        _react2.default.createElement('span', { title: deleteTooltip, className: 'icon-cancel' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderAddIcon(),
        this.renderCopyIcon(),
        this.renderDeleteIcon()
      );
    }
  }]);
  return GridActionColumn;
}(_react.Component), _class3.propTypes = {
  relationshipDetails: _react.PropTypes.object.isRequired,
  store: _react.PropTypes.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'onClickDelete', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      var _props4 = _this2.props,
          confirmFn = _props4.confirmFn,
          store = _props4.store,
          localization = _props4.localization,
          relationshipDetails = _props4.relationshipDetails;
      var isKeyJoin = relationshipDetails.isKeyJoin,
          relationshipKeyJoins = relationshipDetails.relationshipKeyJoins,
          parentId = relationshipDetails.parentId;
      var dataSourceDetail = store.dataSourceDetail,
          reportStore = store.reportStore;


      var confirmDeleteMessage = !(0, _fp.isNil)(isKeyJoin) ? localization.getText('REPORTDESIGNER_MESSAGE_DELETE_KEYJOIN') : (0, _fp.get)('length', relationshipKeyJoins) > 0 ? localization.getText('REPORTDESIGNER_MESSAGE_CONFIRM_DELETE_RELATIONSHIP_WITH_KEYJOIN') : localization.getText('REPORTDESIGNER_MESSAGE_CONFIRM_DELETE_RELATIONSHIP');

      confirmFn('Confirmation', { description: confirmDeleteMessage }).then(function () {
        !(0, _fp.isNil)(isKeyJoin) ? dataSourceDetail.findRelationshipById(parentId).deleteKeyJoin(relationshipDetails) : dataSourceDetail.delete(relationshipDetails);

        reportStore.model.markDirty();
        dataSourceDetail.markDataSourceGridDirty();
      });
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'onClickCopy', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function () {
      var _props5 = _this3.props,
          store = _props5.store,
          relationshipDetails = _props5.relationshipDetails;
      var dataSourceDetail = store.dataSourceDetail,
          reportStore = store.reportStore;
      var isKeyJoin = relationshipDetails.isKeyJoin,
          parentId = relationshipDetails.parentId;

      !(0, _fp.isNil)(isKeyJoin) ? dataSourceDetail.findRelationshipById(parentId).copyKeyJoin(relationshipDetails) : dataSourceDetail.copyRelationship(relationshipDetails);
      reportStore.model.markDirty();
      dataSourceDetail.markDataSourceGridDirty();
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'onAddKeyJoin', [_dec4], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function () {
      var _props6 = _this4.props,
          store = _props6.store,
          relationshipDetails = _props6.relationshipDetails;
      var reportStore = store.reportStore,
          isAllDataOjectUncategory = store.dataTree.isAllDataOjectUncategory,
          dataSourceDetail = store.dataSourceDetail;


      relationshipDetails.addNewKeyJoin(isAllDataOjectUncategory);
      reportStore.model.markDirty();
      dataSourceDetail.markDataSourceGridDirty();
    };
  }
})), _class2)) || _class);
exports.default = GridActionColumn;
module.exports = exports['default'];

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerCategoryDropdown.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Category Dropdown component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(29);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DropDownValidator = (0, _Izenda6.default)()(_Izenda4.default);

var ReportDesignerCategoryDropdown = (_dec = (0, _mobx.action)("onChangeDropdown"), (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(ReportDesignerCategoryDropdown, _Component);

  function ReportDesignerCategoryDropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportDesignerCategoryDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportDesignerCategoryDropdown.__proto__ || (0, _getPrototypeOf2.default)(ReportDesignerCategoryDropdown)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, "onChangeDropdown", _descriptor, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReportDesignerCategoryDropdown, [{
    key: "getUpperCategoryIds",
    value: function getUpperCategoryIds(currentRelationship) {
      var dataSourceDetail = this.props.dataSourceDetail;

      var upperRelationships = !(0, _fp.isEmpty)(currentRelationship) ? (0, _fp.filter)(function (item) {
        return item.level <= currentRelationship.level;
      }, dataSourceDetail.dataSourceGrid) : [];
      var categoryIds = [];

      (0, _fp.forEach)(function (relationship) {
        var joinDataSourceCategoryId = relationship.joinDataSourceCategoryId,
            foreignDataSourceCategoryId = relationship.foreignDataSourceCategoryId;

        var readyCategory = joinDataSourceCategoryId && !(0, _fp.includes)(joinDataSourceCategoryId, categoryIds);
        readyCategory && categoryIds.push(joinDataSourceCategoryId);

        var readyForeignCategory = foreignDataSourceCategoryId && !(0, _fp.includes)(foreignDataSourceCategoryId, categoryIds);
        readyForeignCategory && categoryIds.push(foreignDataSourceCategoryId);
      }, upperRelationships);

      return categoryIds;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          fieldName = _props.fieldName,
          dataSourceItem = _props.dataSourceItem,
          categoryOptions = _props.categoryOptions;


      return _react2.default.createElement(DropDownValidator, {
        options: categoryOptions,
        onChange: this.onChangeDropdown,
        value: dataSourceItem[fieldName],
        validateAttribute: fieldName,
        valueField: "value",
        labelField: "label",
        blankOption: true,
        hideIcon: true,
        showTooltip: true,
        validations: _Izenda2.default.REQUIRED_CONSTRAINT,
        field: fieldName,
        group: "Relationships" + dataSourceItem.tempId
      });
    }
  }]);
  return ReportDesignerCategoryDropdown;
}(_react.Component), _class3.propTypes = {
  dataSourceItem: _react.PropTypes.object.isRequired,
  categoryOptions: _react.PropTypes.array.isRequired,
  fieldName: _react.PropTypes.string.isRequired,
  dataSourceDetail: _react.PropTypes.object
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "onChangeDropdown", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (_ref2) {
      var value = _ref2.value,
          label = _ref2.label;
      var _props2 = _this2.props,
          dataSourceItem = _props2.dataSourceItem,
          fieldName = _props2.fieldName,
          onChange = _props2.onChange,
          dataSourceDetail = _props2.dataSourceDetail;

      var categoryKey = _Izenda2.default.TABLE_DEF.ADVANCED_MODE.category.key;

      if (!dataSourceItem.isKeyJoin) {
        var categoryIds = _this2.getUpperCategoryIds(dataSourceItem);
        dataSourceItem.resetKeyJoinCategory(categoryIds);
      }

      fieldName === categoryKey ? dataSourceItem.setJoinDataSourceCategory(value, label) : dataSourceItem.setForeignDataSourceCategory(value, label);
      dataSourceDetail.markDataSourceGridDirty();
    };
  }
})), _class2)) || _class);
exports.default = ReportDesignerCategoryDropdown;
module.exports = exports["default"];

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerDataObjectDropdown.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Data object Dropdown component
 */


var _mobx = __webpack_require__(5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(16);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(29);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(23);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var DropDownValidator = (0, _Izenda8.default)()(_Izenda6.default);

var ReportDesignerDataObjectDropdown = (_dec = (0, _Izenda2.default)(), _dec2 = (0, _mobx.action)('setQuerySourceAndPrimaryKey'), _dec3 = (0, _mobx.action)('changeDataObject'), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(ReportDesignerDataObjectDropdown, _Component);

  function ReportDesignerDataObjectDropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportDesignerDataObjectDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportDesignerDataObjectDropdown.__proto__ || (0, _getPrototypeOf2.default)(ReportDesignerDataObjectDropdown)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'changeDataObject', _descriptor, _this), _this.focusForeignDataObject = (0, _mobx.action)('focusForeignDataObject', function (input) {
      var _this$props = _this.props,
          dataSourceItem = _this$props.dataSourceItem,
          fieldName = _this$props.fieldName,
          validation = _this$props.validation;

      // Clear the violated alias value

      if (dataSourceItem.invalidAlias) {
        dataSourceItem.setForeignQuerySource(null, null);
        dataSourceItem.invalidAlias = null;
        validation.reset(fieldName, 'Relationships' + dataSourceItem.tempId);
      }
    }), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReportDesignerDataObjectDropdown, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          options = _props.options,
          key = _props.fieldName,
          dataSourceItem = _props.dataSourceItem,
          isKeyJoin = _props.dataSourceItem.isKeyJoin;


      if (!(0, _fp.isEqual)(nextProps.options, options) && isKeyJoin) {
        var querySourcePropertyName = this.getQuerySourcePropertyName();
        var currentValue = dataSourceItem[querySourcePropertyName];
        if (!(0, _fp.some)({ value: currentValue }, nextProps.options)) {
          var updateFn = key === _Izenda4.default.TABLE_DEF.ADVANCED_MODE.dataObject.key ? dataSourceItem.setJoinQuerySource : dataSourceItem.setForeignQuerySource;
          updateFn.call(dataSourceItem, null, null);
        }
      }
    }
  }, {
    key: 'getQuerySourcePropertyName',
    value: function getQuerySourcePropertyName() {
      var _props2 = this.props,
          isKeyJoin = _props2.dataSourceItem.isKeyJoin,
          key = _props2.fieldName;


      if (isKeyJoin) {
        return key === _Izenda4.default.TABLE_DEF.ADVANCED_MODE.dataObject.key ? _Izenda4.default.TABLE_DEF.ADVANCED_MODE.selectedJoinSourceAlias.key : _Izenda4.default.TABLE_DEF.ADVANCED_MODE.selectedForeignSourceAlias.key;
      } else {
        return key;
      }
    }

    /**
     * Get the first primary key base on dataObjects
     * @param  {object} currentDataObject
     * @return {string} id of primary field
     */

  }, {
    key: 'getPrimaryKeyByDataObject',
    value: function getPrimaryKeyByDataObject(currentDataObject) {
      if (!(0, _fp.isEmpty)(currentDataObject)) {
        return (0, _fp.flow)((0, _fp.filter)(function (field) {
          var ext = !(0, _fp.isEmpty)(field.extendedProperties) ? JSON.parse(field.extendedProperties) : {};
          return !(0, _fp.isEmpty)(ext) && ext.PrimaryKey;
        }), (0, _fp.orderBy)(['name'], ['asc']), _fp.head)(currentDataObject.fields);
      }
    }
  }, {
    key: 'setQuerySourceAndPrimaryKey',
    value: function setQuerySourceAndPrimaryKey(primaryKey, fieldName, dataSourceItem) {
      var objectChanged = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      if (fieldName === _Izenda4.default.TABLE_DEF.ADVANCED_MODE.dataObject.key) {
        dataSourceItem.setJoinQuerySource(objectChanged.value, objectChanged.label);
        !(0, _fp.isEmpty)(primaryKey) && dataSourceItem.setJoinField(primaryKey.id, primaryKey.name);
      } else {
        dataSourceItem.setForeignQuerySource(objectChanged.value, objectChanged.label, objectChanged.isDataSourceAlias);
        !(0, _fp.isEmpty)(primaryKey) && dataSourceItem.setForeignField(primaryKey.id, primaryKey.name);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          options = _props3.options,
          dataTree = _props3.dataTree,
          key = _props3.fieldName,
          dataSourceItem = _props3.dataSourceItem,
          _props3$dataSourceIte = _props3.dataSourceItem,
          isJoinQuerySourceReady = _props3$dataSourceIte.isJoinQuerySourceReady,
          isforeignQuerySourceReady = _props3$dataSourceIte.isforeignQuerySourceReady,
          tempId = _props3$dataSourceIte.tempId;


      var dataObjectKey = _Izenda4.default.TABLE_DEF.ADVANCED_MODE.dataObject.key;
      // Disable when user does not selected category
      var disabled = key === dataObjectKey ? !isJoinQuerySourceReady : !isforeignQuerySourceReady;
      var isAllDataOjectUncategory = dataTree.isAllDataOjectUncategory;
      // If all data object uncategory,
      disabled = disabled && !isAllDataOjectUncategory;
      var querySourcePropertyName = this.getQuerySourcePropertyName();

      return _react2.default.createElement(DropDownValidator, {
        options: options,
        onChange: this.changeDataObject,
        onFocus: this.focusForeignDataObject,
        value: dataSourceItem[querySourcePropertyName],
        disabled: disabled,
        valueField: 'value',
        labelField: 'labelDisplay',
        blankOption: true,
        hideIcon: true,
        showTooltip: true,
        validations: _Izenda4.default.REQUIRED_CONSTRAINT,
        field: key,
        group: 'Relationships' + tempId
      });
    }
  }]);
  return ReportDesignerDataObjectDropdown;
}(_react.Component), _class3.propTypes = {
  dataObjects: _react.PropTypes.array,
  options: _react.PropTypes.array.isRequired,
  dataTree: _react.PropTypes.object.isRequired,
  dataSourceItem: _react.PropTypes.object.isRequired,
  dataSourceDetail: _react.PropTypes.object.isRequired,
  fieldName: _react.PropTypes.string.isRequired
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'setQuerySourceAndPrimaryKey', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setQuerySourceAndPrimaryKey'), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, 'changeDataObject', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (object, selectedItem) {
      var _props4 = _this2.props,
          store = _props4.store,
          dataSourceDetail = _props4.dataSourceDetail,
          dataSourceItem = _props4.dataSourceItem,
          _props4$dataSourceIte = _props4.dataSourceItem,
          isKeyJoin = _props4$dataSourceIte.isKeyJoin,
          joinType = _props4$dataSourceIte.joinType,
          key = _props4.fieldName,
          dataObjects = _props4.dataObjects,
          checkJoinTypeEntities = _props4.checkJoinTypeEntities;


      var currentDataObject = void 0;
      var dataObjectKey = _Izenda4.default.TABLE_DEF.ADVANCED_MODE.dataObject.key;

      if (isKeyJoin) {
        currentDataObject = (0, _fp.find)({ aliasId: object.value }, dataObjects);
      } else {
        currentDataObject = key === dataObjectKey ? (0, _fp.find)({ id: object.value }, dataObjects) : (0, _fp.find)({ aliasId: object.value }, dataObjects);
      }

      var primaryKey = _this2.getPrimaryKeyByDataObject(currentDataObject);

      if (joinType !== _Izenda4.default.JOIN_TYPE_CROSS) {
        _this2.setQuerySourceAndPrimaryKey(primaryKey, key, dataSourceItem, selectedItem);
      } else {
        var updateDataObjectFn = key === dataObjectKey ? dataSourceItem.setJoinQuerySource : dataSourceItem.setForeignQuerySource;

        updateDataObjectFn.call(dataSourceItem, object.value, object.label);
      }

      // generate alias if DataObject is Relationship
      if (!isKeyJoin) {
        dataSourceDetail.onDataObjectChangeToGenerateAlias(dataSourceItem, key);
      }

      checkJoinTypeEntities && checkJoinTypeEntities(_this2.props, store, dataSourceItem);
      store.reportStore.dataSourceStore.dataSourceDetail.markDataSourceGridDirty();
    };
  }
})), _class2)) || _class);
exports.default = ReportDesignerDataObjectDropdown;
module.exports = exports['default'];

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _descriptor, _class3, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerJoinFieldDropdown.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Join field Dropdown component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(5);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(29);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(2);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DropDownValidator = (0, _Izenda6.default)()(_Izenda4.default);
var ReportDesignerJoinFieldDropdown = (_dec = (0, _Izenda8.default)(), _dec2 = (0, _mobx.action)("changeJoinField"), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ReportDesignerJoinFieldDropdown, _Component);

  function ReportDesignerJoinFieldDropdown(props) {
    (0, _classCallCheck3.default)(this, ReportDesignerJoinFieldDropdown);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportDesignerJoinFieldDropdown.__proto__ || (0, _getPrototypeOf2.default)(ReportDesignerJoinFieldDropdown)).call(this, props));

    _initDefineProp(_this, "changeJoinField", _descriptor, _this);

    _this.oldValue = null;
    _this.newValue = null;

    var dataSourceItem = props.dataSourceItem,
        key = props.column.key;

    _this.joinFieldObserve = (0, _mobx.observe)(dataSourceItem, key, function (newValue, oldValue) {
      _this.oldValue = oldValue;
      _this.newValue = newValue;
    });
    return _this;
  }

  (0, _createClass3.default)(ReportDesignerJoinFieldDropdown, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // Need to reset validation indicator if its value changed from NULL to a not NULL value.
      if ((0, _fp.isNil)(this.oldValue) && !(0, _fp.isNil)(this.newValue)) {
        var _props = this.props,
            dataObjectKey = _props.dataObjectKey,
            validation = _props.validation,
            dataSourceItem = _props.dataSourceItem;

        var key = dataObjectKey === _Izenda2.default.TABLE_DEF.ADVANCED_MODE.dataObject.key ? _Izenda2.default.TABLE_DEF.ADVANCED_MODE.joinField.key : _Izenda2.default.TABLE_DEF.ADVANCED_MODE.foreignJoinfield.key;
        validation.validate(key, "Relationships" + dataSourceItem.tempId);
      }
    }
  }, {
    key: "componentWilUnmount",
    value: function componentWilUnmount() {
      this.joinFieldObserve();
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          dataSourceItem = _props2.dataSourceItem,
          dataObjectKey = _props2.dataObjectKey,
          categoryKey = _props2.categoryKey,
          store = _props2.store,
          key = _props2.column.key,
          getDataObjects = _props2.getDataObjects,
          getDropdownOptions = _props2.getDropdownOptions;


      var joinFieldKey = _Izenda2.default.TABLE_DEF.ADVANCED_MODE.joinField.key;
      var selectedJoinSourceAlias = _Izenda2.default.TABLE_DEF.ADVANCED_MODE.selectedJoinSourceAlias.key;
      var selectedForeignSourceAlias = _Izenda2.default.TABLE_DEF.ADVANCED_MODE.selectedForeignSourceAlias.key;
      var isFieldReady = key == joinFieldKey ? !dataSourceItem.isJoinFieldReady : !dataSourceItem.isForeignFieldReady;
      var isCrossJoin = dataSourceItem.joinType === _Izenda2.default.JOIN_TYPE_CROSS;

      var dataObjects = getDataObjects(dataSourceItem, categoryKey, store, dataSourceItem.isKeyJoin);
      var currentDataObject = void 0;
      // There are two cases:
      // Case 1: is keyjoin
      if (dataSourceItem.isKeyJoin) {
        currentDataObject = dataObjectKey === _Izenda2.default.TABLE_DEF.ADVANCED_MODE.dataObject.key ? (0, _fp.find)({ aliasId: dataSourceItem[selectedJoinSourceAlias] }, dataObjects) : (0, _fp.find)({ aliasId: dataSourceItem[selectedForeignSourceAlias] }, dataObjects);
        // Case 2: is relationship
      } else {
        currentDataObject = dataObjectKey === _Izenda2.default.TABLE_DEF.ADVANCED_MODE.foreignDataObject.key ? (0, _fp.find)({ aliasId: dataSourceItem[dataObjectKey] }, dataObjects) : (0, _fp.find)({ id: dataSourceItem[dataObjectKey] }, dataObjects);
      }

      currentDataObject = currentDataObject || {}; // prevent null object

      var options = (0, _fp.isNil)(currentDataObject) ? [] : getDropdownOptions(currentDataObject.fields, false, false);
      var selectedItems = (0, _fp.find)({ id: dataSourceItem[key] }, currentDataObject.fields);
      var isMaskedHiddenForField = currentDataObject && dataSourceItem[key] && ((0, _fp.isEmpty)(selectedItems) || selectedItems.inaccessible);
      var validationRule = isCrossJoin ? {} : _Izenda2.default.REQUIRED_CONSTRAINT;

      return _react2.default.createElement(DropDownValidator, {
        options: options,
        onChange: this.changeJoinField,
        value: dataSourceItem[key],
        disabled: isFieldReady || isCrossJoin,
        maskedHidden: isMaskedHiddenForField,
        valueField: "value",
        labelField: "label",
        blankOption: true,
        hideIcon: true,
        showTooltip: true,
        validations: validationRule,
        field: key,
        group: "Relationships" + dataSourceItem.tempId
      });
    }
  }]);
  return ReportDesignerJoinFieldDropdown;
}(_react.Component), _class3.propTypes = {
  store: _react.PropTypes.object.isRequired,
  dataSourceItem: _react.PropTypes.object.isRequired,
  dataObjectKey: _react.PropTypes.string.isRequired,
  categoryKey: _react.PropTypes.string.isRequired,
  getDataObjects: _react.PropTypes.func,
  getDropdownOptions: _react.PropTypes.func,
  column: _react.PropTypes.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "changeJoinField", [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (object) {
      var _props3 = _this2.props,
          store = _props3.store,
          dataSourceItem = _props3.dataSourceItem,
          column = _props3.column,
          _props3$column = _props3.column,
          key = _props3$column.key,
          labelKey = _props3$column.props.labelKey,
          onChange = _props3.onChange,
          dataObjectKey = _props3.dataObjectKey;


      var isJoinField = dataObjectKey === _Izenda2.default.TABLE_DEF.ADVANCED_MODE.dataObject.key;

      dataSourceItem[key] = object.value;
      dataSourceItem[labelKey] = object.label;
      onChange && onChange(object.value);

      dataSourceItem.isKeyJoin ? dataSourceItem.updateKeyJoinItem(key, object.value) : dataSourceItem.updateRelationshipItem(key, object.value);
      store.reportStore.dataSourceStore.dataSourceDetail.markDataSourceGridDirty();

      // Reset comparison value when change join field
      if (isJoinField) {
        dataSourceItem.setComparisionOperator && dataSourceItem.setComparisionOperator(_Izenda2.default.DEFAULT_COMPARISION_OPERATOR);
      }
    };
  }
})), _class2)) || _class);
exports.default = ReportDesignerJoinFieldDropdown;
module.exports = exports["default"];

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportNameEditorActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;
  var withState = __webpack_require__(9).withState;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry,
      get = _require.get;

  var ReportNameEditorActions = compose(withState('reportName', 'updateReportName', get('name')), withState('editMode', 'updateEditMode', false), withHandlers({
    onSave: curry(onSave),
    onCancel: curry(onCancel),
    onEdit: curry(onEdit),
    onKeyPress: onKeyPress,
    onBlur: onBlur,
    onChangeGlobalValue: curry(onChangeGlobalValue)
  }));

  function onEdit(props, _) {
    props.updateEditMode(true);
  }

  function onCancel(props, _) {
    props.updateReportName(props.name);
    props.updateEditMode(false);
  }

  function onSave(props, _) {
    var validation = props.validation;
    var reportDesignerModel = props.store.model;
    return validation.validate('reportName').then(function (success) {
      if (success) {
        reportDesignerModel.changeName(props.reportName);
        props.updateEditMode(false);
      }
      return success;
    });
  }

  function onKeyPress(props) {
    return function (e) {
      if (e.key === 'Enter') {
        onSave(props);
      } else if (e.key === 'Escape') {
        onCancel(props);
      }
    };
  }

  function onBlur(props) {
    return function (e) {
      e.preventDefault();
      e.stopPropagation();
      onSave(props);
    };
  }

  /**
   * Update value of global value check box
   * @param {Object}  props
   * @param {Boolean} value
   */
  function onChangeGlobalValue(props, value) {
    var accessStore = props.store.accessStore;

    // validate access list and warning if change to global report
    var result = accessStore.validateAccessListOnUpdateGlobalReport(value, true);

    if (result) {
      props.confirmFn('warning', { description: result }).then(function () {
        // call update global type update
        props.store.changeGlobalType(value);

        // update list access
        accessStore.updateListAccessor(value);
      });
    } else {
      props.store.changeGlobalType(value);
    }
  }

  module.exports = ReportNameEditorActions;
}();

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(1208);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2676);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1206);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  setStore: function setStore(store) {
    this.store = store.fieldsStore;
    this.isReloadView = false;
  },

  destroy: function destroy() {
    delete this['store'];
    this.isReloadView = false;
  },

  reloadView: function reloadView() {
    this.isReloadView = true;
    return this.store.loadInitial();
  },

  renderMiddlePanel: function renderMiddlePanel() {
    return _react2.default.createElement(_Izenda4.default, { store: this.store, uiStore: _Izenda6.default.sourceOptions });
  },

  renderMainContent: function renderMainContent(ref) {
    return _react2.default.createElement(_Izenda2.default, {
      ref: ref,
      store: this.store,
      uiStore: _Izenda6.default.targetOptions,
      isReloadView: this.isReloadView,
      pageName: _Izenda8.default.PAGE_NAME.FIELDS
    });
  }
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.Fields.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Fields component
 */

module.exports = exports['default'];

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
// ----------------------------------------------------------------------
// <copyright file="Izenda.LeftContentFieldDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/* eslint-disable react/no-find-dom-node */

/**
 * Field Detail component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(106);

var _Izenda2 = __webpack_require__(2);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(27);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(438);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(1190);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(414);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(1194);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(415);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(439);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(584);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(157);

var _Izenda21 = _interopRequireDefault(_Izenda20);

var _Izenda22 = __webpack_require__(2674);

var _Izenda23 = _interopRequireDefault(_Izenda22);

var _fp = __webpack_require__(1);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__(5);

var _Izenda24 = __webpack_require__(16);

var _Izenda25 = _interopRequireDefault(_Izenda24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var LeftContent = (_dec = (0, _Izenda3.default)(_Izenda23.default), _dec(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(LeftContent, _Component);

  function LeftContent(props) {
    (0, _classCallCheck3.default)(this, LeftContent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LeftContent.__proto__ || (0, _getPrototypeOf2.default)(LeftContent)).call(this, props));

    _initDefineProp(_this, 'containerHeight', _descriptor, _this);

    _initDefineProp(_this, 'headerPanelState', _descriptor2, _this);

    _initDefineProp(_this, 'titleDescriptionPanelState', _descriptor3, _this);

    _initDefineProp(_this, 'reportBodyPanelState', _descriptor4, _this);

    _initDefineProp(_this, 'adjustContainerHeight', _descriptor5, _this);

    _this.setContainer = function (ref) {
      _this.container = ref;
    };

    _this.updateScrollBoxRef = function (ref) {
      _this.scrollBox = ref;
    };

    _this.updateFilterSectionRef = function (ref) {
      _this.filtersSection = ref;
    };

    _this.updateReportBodySectionRef = function (ref) {
      _this.reportBodySection = ref;
    };

    _this.setGridViewScrollBox = function (ref) {
      if (ref) {
        _this.gridViewScrollBox = ref.getGridViewScrollBox();
        _this.updateStickyScroll();
      }
    };

    _this.getOuterScrollTop = function () {
      return _this.scrollBox ? _this.scrollBox.getScrollTop() : 0;
    };

    _initDefineProp(_this, 'afterToggledFilterPanel', _descriptor6, _this);

    _initDefineProp(_this, 'updateStickyScroll', _descriptor7, _this);

    _this.showReportHeaderAndFooter = function (_ref) {
      var pageName = _ref.pageName,
          reportStore = _ref.store.reportStore;

      return pageName === _Izenda25.default.PAGE_NAME.FORMATS || reportStore.isShowingHeaderFooter;
    };

    _this.containerHeight = 0;
    _this.sections = {};
    _this.headerPanelState = true;
    _this.titleDescriptionPanelState = true;
    _this.reportBodyPanelState = true;
    return _this;
  }
  /**
   * Add editor actions
   */


  (0, _createClass3.default)(LeftContent, [{
    key: 'addEditorActions',
    value: function addEditorActions() {
      var _this2 = this;

      var store = this.props.store;
      var propsEditorId = _Izenda21.default.findEditorId([{
        name: 'fieldProps'
      }, {
        name: 'reportPartProps'
      }]);

      var scrollTo = function scrollTo(sectionName) {
        var scrollBox = _this2.scrollBox;
        var node = _this2[sectionName];
        node = node && _reactDom2.default.findDOMNode(node);

        (0, _fp.invokeArgs)('scrollTo', [{
          left: 0,
          top: (0, _fp.get)('offsetTop', node)
        }], scrollBox);
      };

      var beforeShowEditor = function beforeShowEditor(sectionName) {
        return function () {
          scrollTo(sectionName);
        };
      };

      var scrollToConfigFormatSection = function scrollToConfigFormatSection() {
        var selectedFormatGroup = (0, _fp.get)('model.selectedFormatGroup', store);

        switch (selectedFormatGroup) {
          case _Izenda.FORMAT_GROUP_CONFIG.HEADER:
            return scrollTo('reportHeaderSection');
          case _Izenda.FORMAT_GROUP_CONFIG.TITLE_DESCRIPTION:
            return scrollTo('reportTitleSection');
          case _Izenda.FORMAT_GROUP_CONFIG.FOOTER:
            return scrollTo('reportFooterSection');
          default:
          // do nothing
        }
      };

      _Izenda21.default.addHandlers(propsEditorId, 'beforeRender', {
        filterProps: beforeShowEditor('filtersSection'),
        fieldProps: beforeShowEditor('reportBodySection'),
        reportPartProps: beforeShowEditor('reportBodySection'),
        formatItemProps: scrollToConfigFormatSection
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addEditorActions();
      this.adjustContainerHeight();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.height !== this.props.height) {
        this.adjustContainerHeight();
      }
    }
  }, {
    key: 'checkShouldStickScroll',


    /** Check should stick horizontal scroll */
    value: function checkShouldStickScroll() {
      if (this.checkHasOuterScroll() && this.scrollBox && this.gridViewScrollBox) {
        var scrollTop = this.scrollBox.getScrollTop();
        var headerDOM = _reactDom2.default.findDOMNode(this.refs.reportHeaderSection);
        var titleDOM = _reactDom2.default.findDOMNode(this.refs.reportTitleSection);
        var bodyDOM = _reactDom2.default.findDOMNode(this.reportBodySection);
        var headerHeight = (0, _fp.getOr)(0, 'offsetHeight', headerDOM);
        var titleHeight = (0, _fp.getOr)(0, 'offsetHeight', titleDOM);
        var trackHeight = this.scrollBox.getTrackHeight();
        return headerHeight + titleHeight + bodyDOM.clientHeight + trackHeight >= this.containerHeight + scrollTop && this.gridViewScrollBox.isInsideOfViewport();
      }
      return false;
    }
  }, {
    key: 'afterToggledFormatPanel',
    value: function afterToggledFormatPanel(sectionName, state) {
      switch (sectionName) {
        case 'reportHeaderSection':
          this.headerPanelState = state;
          break;
        case 'reportTitleSection':
          this.titleDescriptionPanelState = state;
          break;
        case 'reportBodySection':
          this.reportBodyPanelState = state;
          break;
        default:
          break;
      }
    }
  }, {
    key: 'checkHasOuterScroll',
    value: function checkHasOuterScroll() {
      var store = this.props.store;

      return store.isVisibleHeaderFooter && this.showReportHeaderAndFooter(this.props) || store.isVisibleTitleDescription;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var store = props.store;
      var reportStore = store.reportStore;
      var isFullScreen = (0, _fp.get)('reportBody.isFullScreen', store);
      var showReportHeaderAndFooter = this.showReportHeaderAndFooter(props);

      var renderFormatContainer = function renderFormatContainer(Component, showComponent, sectionName, isLastSection) {
        if (!showComponent || isFullScreen) {
          return null;
        }
        var classes = (0, _classnames2.default)('report-format-panel', { u_noMarginBottom: isLastSection });
        return _react2.default.createElement(
          _Izenda7.default,
          { className: classes, ref: sectionName },
          _react2.default.createElement(Component, { afterToggled: _this3.afterToggledFormatPanel.bind(_this3, sectionName), store: store })
        );
      };

      var hasOuterScroll = this.checkHasOuterScroll();
      var isReportBodyLastSection = hasOuterScroll && (!showReportHeaderAndFooter || !store.isVisibleHeaderFooter) && store.isVisibleTitleDescription;
      var classes = (0, _classnames2.default)('izenda-ReportGroupPanel content-container', {
        'izenda-ReportGroupPanel-Fullsize': isFullScreen,
        u_noMarginBottom: isFullScreen || isReportBodyLastSection
      });

      var filterPanelClass = (0, _classnames2.default)('izenda-FilterGroupPanel u_noMarginAll', {
        u_none: isFullScreen
      });

      var reportContentContainerStyle = { height: this.containerHeight };
      var scrollBoxStyle = hasOuterScroll ? null : { height: this.containerHeight + (isFullScreen ? 0 : this.props.bottom) };

      var reportContent = _react2.default.createElement(
        'div',
        { className: 'u_paddingLeftRight' },
        showReportHeaderAndFooter && renderFormatContainer(_Izenda11.default, store.isVisibleHeaderFooter, 'reportHeaderSection'),
        renderFormatContainer(_Izenda19.default, store.isVisibleTitleDescription, 'reportTitleSection'),
        _react2.default.createElement(
          _Izenda7.default,
          { className: classes, ref: this.updateReportBodySectionRef },
          _react2.default.createElement(_Izenda13.default, (0, _extends3.default)({
            afterToggled: this.afterToggledFormatPanel.bind(this, 'reportBodySection'),
            headerPanelState: this.headerPanelState,
            titleDescriptionPanelState: this.titleDescriptionPanelState,
            reportBodyPanelState: this.reportBodyPanelState,
            finishRender: this.setGridViewScrollBox
          }, props, {
            store: store,
            hasOuterScroll: hasOuterScroll,
            getOuterScrollTop: this.getOuterScrollTop
          }))
        ),
        showReportHeaderAndFooter && renderFormatContainer(_Izenda15.default, store.isVisibleHeaderFooter, 'reportFooterSection', true)
      );

      return _react2.default.createElement(
        'div',
        { className: 'u_fullHeight u-posRelative' },
        _react2.default.createElement(
          'div',
          { className: 'u_paddingLeftRight' },
          _react2.default.createElement(_Izenda17.default, {
            store: reportStore,
            name: reportStore.model.reportName,
            showTooltip: false,
            isPreviewRecord: true,
            onChangePreviewRecord: props.updateResults
          }),
          _react2.default.createElement(
            _Izenda7.default,
            { className: filterPanelClass, ref: this.updateFilterSectionRef },
            _react2.default.createElement(_Izenda9.default, {
              afterMove: this.afterToggledFilterPanel,
              afterToggled: this.afterToggledFilterPanel,
              store: store,
              uiStore: props.uiStore
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: reportContentContainerStyle, ref: this.setContainer },
          _react2.default.createElement(
            _Izenda5.default,
            {
              containerStyle: scrollBoxStyle,
              onScroll: this.updateStickyScroll,
              onUpdate: this.updateStickyScroll,
              ref: this.updateScrollBoxRef
            },
            reportContent
          )
        )
      );
    }
  }]);
  return LeftContent;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'containerHeight', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'headerPanelState', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'titleDescriptionPanelState', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'reportBodyPanelState', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'adjustContainerHeight', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function () {
      if (_this4.container) {
        var top = _this4.container.getBoundingClientRect().top;
        // Subtract footer and padding
        _this4.containerHeight = window.innerHeight - (top + _this4.props.bottom);
      }
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'afterToggledFilterPanel', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function () {
      _this5.adjustContainerHeight();
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'updateStickyScroll', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function () {
      if (_this6.scrollBox && _this6.gridViewScrollBox) {
        var shouldStickScroll = _this6.checkShouldStickScroll();
        shouldStickScroll ? _this6.gridViewScrollBox.stickHorizontalScroll() : _this6.gridViewScrollBox.unstickHorizontalScroll();
      }
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'afterToggledFormatPanel', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterToggledFormatPanel'), _class2.prototype)), _class2)) || _class);
exports.default = LeftContent;
module.exports = exports['default'];

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.LeftContentActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var leftContentActions = withHandlers({
    updateResults: curry(updateResults)
  });

  /**
   * update results for Fields/Formats tab
   */
  function updateResults(props, _) {
    var loader = props.loader;
    var fieldsStore = props.store;
    var fieldsModel = fieldsStore.model;

    loader.startLoading();
    return fieldsStore.updateReportsParts().then(fieldsModel.cleanDirty.bind(fieldsModel)).finally(loader.endLoading.bind(loader));
  }

  module.exports = leftContentActions;
}();

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _mobx = __webpack_require__(5);

// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldDetailActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var fieldDetailActions = (0, _recompose.compose)((0, _recompose.withHandlers)({
  registerObserveLoading: registerObserveLoading,
  unregisterObserveLoading: unregisterObserveLoading
}));

/**
 * Register observe loading.
 * @param {any} props
 */
function registerObserveLoading(props) {
  return function (component) {
    var _component$props = component.props,
        loader = _component$props.loader,
        store = _component$props.store;


    component.dispose = (0, _mobx.observe)(store, "isLoading", function (newValue) {
      newValue ? loader.startLoading() : loader.endLoading();
    });
  };
}

/**
 * Unregister observe loading.
 * @param {any} props
 */
function unregisterObserveLoading(props) {
  return function (component) {
    var _component$props2 = component.props,
        loader = _component$props2.loader,
        store = _component$props2.store;

    store.isLoading && loader.endLoading();
    component.dispose();
  };
}

exports.default = fieldDetailActions;
module.exports = exports["default"];

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldTreeContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Data Tree Container component
 */
!function () {

  var connect = __webpack_require__(2);

  var React = __webpack_require__(0);

  var SearchTextBox = __webpack_require__(107);
  var DataTree = __webpack_require__(2677);
  var CalculatedField = __webpack_require__(402);
  var constants = __webpack_require__(16);

  var FieldTreeContainer = React.createClass({
    displayName: 'FieldTreeContainer',


    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    renderTopContent: function renderTopContent() {
      var localization = this.props.localization;
      function handleClickAddCalculatedField() {
        this.renderCalculatedField();
      }

      return React.createElement(
        'div',
        { className: 'header-panel' },
        React.createElement(
          'a',
          { onClick: handleClickAddCalculatedField.bind(this), className: 'overflow-text u_block' },
          React.createElement('span', { className: 'icon-plus' }),
          localization.getText('COMMON_LABEL_ADD_CALCULATED_FIELD')
        )
      );
    },

    renderSearchBox: function renderSearchBox() {
      var store = this.props.store;

      return React.createElement(
        'div',
        { className: 'search-box' },
        React.createElement(SearchTextBox, {
          value: store.dataTree.filterText,
          onChange: onChangeSearchText })
      );

      function onChangeSearchText(e) {
        store.dataTree.filterText = e.target.value;
      }
    },

    closeCalculatedPopup: function closeCalculatedPopup(calculatedData) {
      var store = this.props.store;
      calculatedData && store.addCalculatedField(calculatedData);
    },

    renderCalculatedField: function renderCalculatedField() {
      var calculatedStore = this.props.store.calculatedStore;
      var masterModel = this.props.store.masterModel;
      var sourceId = calculatedStore.expressionSelection.getSelectedDataSourceId();
      this.props.store.fillCalculatedFieldData(null, null, true);
      this.props.openPopup(CalculatedField, {
        store: calculatedStore,
        onClose: this.closeCalculatedPopup,
        expressionConfig: constants.EXPRESSION_SELECTION.MIDDLE_FIELD,
        querySourceId: sourceId,
        isCheckDuplicateWithActualField: true,
        value: { previewRecord: masterModel.previewRecord }
      });
    },

    render: function render() {
      return React.createElement(
        'section',
        { className: 'izenda-FieldTreeContainer u_fullHeight u-posRelative u-bgWhite' },
        React.createElement(
          'div',
          { className: 'izenda-MiddlePanel-search' },
          this.renderTopContent(),
          this.renderSearchBox(),
          React.createElement('hr', null)
        ),
        React.createElement(DataTree, {
          className: 'izenda-MiddlePanel-content',
          store: this.props.store,
          useCheckBox: false,
          expandFieldLevel: true,
          uiStore: this.props.uiStore })
      );
    }
  });

  module.exports = connect()(FieldTreeContainer);
}();

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTree.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var draggable = __webpack_require__(255);

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);

  var TreeView = __webpack_require__(172);
  var DataCategoryItem = __webpack_require__(1202);
  var DataObjectItem = __webpack_require__(1203);
  var DataFieldItem = __webpack_require__(1204);
  var Actions = __webpack_require__(1205);

  var classnames = __webpack_require__(11);
  var constants = __webpack_require__(16);

  var FieldPropertiesSchema = __webpack_require__(2678);
  var CalculatedFieldPropertiesSchema = __webpack_require__(2679);

  var CALCULATED_FIELD_CATE_NAME = 'Calculated Fields';

  var _require = __webpack_require__(1),
      invoke = _require.invoke,
      get = _require.get,
      isNil = _require.isNil,
      isEmpty = _require.isEmpty,
      map = _require.map,
      noop = _require.noop,
      filter = _require.filter;

  /**
   * DataTree component
   * Example :
   * <DataTree store={this.props.store} />
   */


  var DataTree = React.createClass({
    displayName: 'DataTree',

    propTypes: {
      store: React.PropTypes.object.isRequired,
      expandFieldLevel: React.PropTypes.bool,
      useCheckBox: React.PropTypes.bool
    },
    getDefaultProps: function getDefaultProps() {
      return {
        expandFieldLevel: false,
        useCheckBox: true
      };
    },
    shouldComponentUpdate: function shouldComponentUpdate() {
      return false;
    },
    render: function render() {
      var props = this.props;
      var classes = classnames('reports-dtsourcetree', props.className);

      var nodes = this.buildTree();
      var getChildNodes = invoke('getChildNodes');

      return React.createElement(
        'div',
        { className: classes },
        React.createElement(TreeView, {
          className: 'u_paddingRight',
          nodes: nodes,
          renderNode: this.renderNode,
          getKey: this.getKey,
          getChildNodes: getChildNodes,
          nodeExpand: this.shouldExpand
        })
      );
    },

    renderNode: function renderNode(node, toggleIcon, toggle, isCollapsed) {

      switch (node.nodeType) {
        case 'Category':
          {
            return this.renderCategory(node.source, toggleIcon, toggle, isCollapsed);
          }
        case 'QuerySource':
          {
            return this.renderQuerySource(node.source, toggleIcon, toggle, isCollapsed);
          }
        case 'Field':
          {
            return this.renderField(node.source, node.querySource, toggleIcon, toggle, isCollapsed);
          }
        default:
          {
            return null;
          }
      }
    },

    renderCategory: function renderCategory(node, toggleIcon, toggle, isCollapsed) {
      return React.createElement(DataCategoryItem, { dataSource: node, collapseToggle: toggle, isCollapsed: isCollapsed });
    },

    renderQuerySource: function renderQuerySource(node, toggleIcon, toggle, isCollapsed) {
      var store = this.props.store;
      var toggleSourceSelection = this.props.toggleSourceSelection;
      var filterText = store.dataTree.filterText;
      var useCheckBox = this.props.useCheckBox;

      return React.createElement(DataObjectItem, {
        dataSource: node,
        filterText: filterText,
        store: store,
        useCheckBox: useCheckBox,
        handleCheck: toggleSourceSelection,
        toggleIcon: toggleIcon,
        collapseToggle: toggle,
        isCollapsed: isCollapsed
      });
    },

    renderField: function renderField(node, querySource, toggleIcon, toggle, isCollapsed) {
      var props = this.props;
      var store = props.store;
      var isCalculatedField = querySource.name === CALCULATED_FIELD_CATE_NAME && node.isCalculated;

      var buildFieldItem = function buildFieldItem() {
        return React.createElement(DataFieldItem, {
          itemData: node,
          filterText: store.dataTree.filterText,
          store: store,
          isCalculated: isCalculatedField,
          clickDelete: props.deleteCalculatedField
        });
      };

      var buildDraggableFieldItem = function buildDraggableFieldItem(uiStore) {
        var DraggableFieldItem = draggable(constants.GENNERAL.FIELD_ITEM, uiStore)(DataFieldItem);

        return React.createElement(DraggableFieldItem, {
          itemData: node,
          filterText: store.dataTree.filterText,
          dataObject: querySource,
          itemDataKey: 'id',
          propsEditors: getDefinedSchemaByFieldType(node),
          isRerenderOnActive: true,
          checkRegistedItem: checkRegistedItem,
          store: store,
          isCalculated: isCalculatedField,
          clickDelete: props.deleteCalculatedField
        });
      };

      if (props.uiStore) {
        return buildDraggableFieldItem(props.uiStore);
      }
      return buildFieldItem();

      function checkRegistedItem(registedInfo) {
        return get('props.itemData', registedInfo) === node;
      }

      function getDefinedSchemaByFieldType(item) {
        var definedSchema;

        if (item.isCalculated && !isNil(item.reportId)) {
          definedSchema = CalculatedFieldPropertiesSchema;
        } else {
          definedSchema = FieldPropertiesSchema;
        }

        return [{
          name: 'dataSourceFieldProps',
          getDefinedSchema: definedSchema
        }];
      }
    },

    buildTree: function buildTree() {
      var store = this.props.store;
      var uncategorized = store.dataTree.filterSource.length === 1 && !store.dataTree.filterSource[0].name;

      var extendCate = function extendCate(cate) {
        return {
          nodeType: 'Category',
          source: cate,
          getChildNodes: function getChildNodes() {
            if (cate.name === CALCULATED_FIELD_CATE_NAME) {
              isEmpty(cate.filterQuerySource) && (cate.filterQuerySource = []);
              return map(extendField(cate.filterQuerySource[0]), get('filterFields', cate.filterQuerySource[0]));
            }
            return map(extendQuerySource, cate.filterQuerySource);
          }
        };
      };

      var extendQuerySource = function extendQuerySource(querySource) {
        return {
          nodeType: 'QuerySource',
          source: querySource,
          getChildNodes: function getChildNodes() {
            return map(extendField(querySource), filter({ inaccessible: false, visible: true }, querySource.filterFields));
          }
        };
      };

      var extendField = function extendField(querySource) {
        return function (field) {
          return {
            nodeType: 'Field',
            source: field,
            querySource: querySource,
            getChildNodes: noop
          };
        };
      };

      var tree = map(extendCate, store.dataTree.filterSource);
      return uncategorized ? tree[0].getChildNodes() : tree;
    },
    getKey: function getKey(node) {
      // It must append name because there is possible of self-reference that has
      // same id but different name.
      var suffix = node.nodeType === 'Field' ? '_' + node.querySource.name : '';
      return node.source.id + '_' + node.source.name + suffix;
    },
    shouldExpand: function shouldExpand(node) {
      var expandFieldLevel = this.props.expandFieldLevel;
      var hasFilterText = this.props.store.dataTree.filterText.length > 0;
      return node.nodeType === 'Category' || hasFilterText || expandFieldLevel && node.nodeType === 'QuerySource';
    }
  });

  module.exports = connect(Actions)(DataTree);
}();

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.UIContants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var localizer = __webpack_require__(12);
  var SCHEMA_DEF = {
    get title() {
      return localizer.getText('FIELD_PROPERTIES_SCHEMA_LABEL_FIELD_PROPERTIES');
    },
    schemaKey: 'DATASOURCE_FIELD_PROPERTIES',
    props: {
      className: 'form-horizontal field-props-container'
    },
    fields: {
      wrapperContent: {
        component: 'ScrollBoxContainer',
        props: {
          className: 'scrollbox-container'
        },
        fields: {
          dataSource: {
            component: 'Panel',
            props: {
              initState: true,
              collapsible: true,
              header: {
                get title() {
                  return localizer.getText('COMMON_LABEL_DATA_SOURCE');
                },
                icon: 'icon-toggle-triangle'
              }
            },

            fields: {
              dataType1: {
                get title() {
                  return localizer.getText('COMMON_LABEL_TYPE');
                },
                type: 'static',
                fnValue: 'getDataObjectType'
              },

              dataObjectName: {
                get title() {
                  return localizer.getText('COMMON_LABEL_NAME');
                },
                type: 'static',
                fnValue: 'getDataObjectName'
              },

              name: {
                get title() {
                  return localizer.getText('COMMON_LABEL_FIELD_NAME');
                },
                type: 'static'
              },

              izendaDataType: {
                get title() {
                  return localizer.getText('COMMON_LABEL_DATA_TYPE');
                },
                type: 'static'
              }
            }
          }
        }
      }
    }
  };

  module.exports = function (editorComp, reportDesignerModel, fieldStore, itemProps) {
    ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

    return {
      // define data to render UI
      definedSchema: SCHEMA_DEF,

      // list of widgets which are used to render UI
      widgets: {
        Panel: __webpack_require__(28),
        ScrollBoxContainer: __webpack_require__(1209)
      },

      // data to binding to fields
      source: itemProps && itemProps.itemData || {},

      // defined-function which fields need to execute to get its data
      mappingSource: {
        getDataObjectName: function getDataObjectName() {
          return itemProps.dataObject && itemProps.dataObject.name;
        },

        getDataObjectType: function getDataObjectType() {
          return itemProps.dataObject && itemProps.dataObject.type;
        }
      }
    };
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (editorComp, reportDesignerModel, fieldStore, itemProps) {
  var configField = itemProps.dataObject;
  var reportFields = reportDesignerModel.reportFields;
  var SCHEMA_DEF = {
    title: _Izenda3.default.getText('CALCULATED_FIELD_PROPERTIES_SCHEMA_LABEL_FIELD_PROPERTIES'),
    schemaKey: 'DATASOURCE_CALCULATED_FIELD_PROPERTIES',
    props: {
      className: 'form-horizontal field-props-container'
    },
    fields: {
      wrapperContent: {
        component: 'ScrollBoxContainer',
        props: {
          className: 'scrollbox-container'
        },
        fields: {
          dataSource: {
            component: 'Panel',
            props: {
              initState: true,
              collapsible: true,
              header: {
                title: _Izenda3.default.getText('COMMON_LABEL_DATA_SOURCE'),
                icon: 'icon-toggle-triangle'
              }
            },

            fields: {
              // Type
              fieldType: {
                title: _Izenda3.default.getText('COMMON_LABEL_TYPE'),
                type: 'static',
                fnValue: 'getDataObjectType'
              },
              // Field Name
              name: {
                title: _Izenda3.default.getText('COMMON_LABEL_FIELD_NAME'),
                type: 'text',
                props: {
                  onBlur: 'onBlurFieldName',
                  validations: {
                    presence: {
                      presence: true,
                      message: _Izenda3.default.getText('CALCULATED_FIELD_PROPERTIES_SCHEMA_MESSAGE_FIELD_NAME')
                    }
                  },
                  field: 'fieldName'
                }
              },
              // Data Type
              izendaDataType: {
                title: _Izenda3.default.getText('COMMON_LABEL_DATA_TYPE'),
                type: 'static'
              },
              // Expression
              expression: {
                title: _Izenda3.default.getText('COMMON_LABEL_EXPRESSION'),
                component: 'ExpressionInput',
                fnValue: 'getExpression',
                props: {
                  title: _Izenda3.default.getText('CALCULATED_FIELD_CONSTANTS_FUNCTION_TYPE_EDIT_TITLE'),
                  loadValue: 'getExpression'
                },
                staticProps: {
                  className: 'icon-setting btn-icon expression-icon',
                  reportDesignerModel: reportDesignerModel,
                  fieldStore: itemProps.store
                }
              }
            }
          }
        }
      }
    }
  };

  return {
    // define data to render UI
    definedSchema: SCHEMA_DEF,

    // list of widgets which are used to render UI
    widgets: {
      Panel: __webpack_require__(28),
      ExpressionInput: __webpack_require__(2680),
      ScrollBoxContainer: __webpack_require__(1209)
    },

    // data to binding to fields
    source: itemProps && itemProps.itemData || {},

    // properties for different fields
    mappingProps: {
      onBlurFieldName: function onBlurFieldName(e) {
        e.preventDefault();
        e.stopPropagation();
        var validation = itemProps.validation;
        var localization = itemProps.localization;
        var newValue = e.target.value.trim();

        // check require
        if (!newValue) {
          validation.updateErrors([{
            key: 'fieldName',
            messages: [MESSAGES.M01]
          }]);
          return;
        }

        // check contain character ']'
        if (newValue && (newValue.indexOf(']') > -1 || newValue.indexOf('[') > -1)) {
          validation.updateErrors([{
            key: 'fieldName',
            messages: localization.getText('CALCULATED_FIELD_MESSAGE_INVALID_NAME')
          }]);
          return;
        }

        // check dupplicate
        var matchingField = (0, _fp.placeholder)(reportFields.dataTree.details).chain().flatMap(function (item) {
          return item.querySource.toJSON();
        }).flatMap(function (querySource) {
          return querySource.fields.toJSON();
        }).find(function (element) {
          return element.isCalculated && element.name === newValue && element.id !== itemProps.itemData.id;
        }).value();

        if (matchingField) {
          validation.updateErrors([{
            key: 'fieldName',
            messages: [MESSAGES.M08]
          }]);
        } else {
          if (itemProps.itemData.name !== newValue) {
            itemProps.itemData.name = newValue;
            if (configField.updateData(itemProps.itemData)) {
              itemProps.store.addCalculatedField(itemProps.itemData);
            }
          }
        }
      },

      getExpression: function getExpression() {
        return itemProps && itemProps.itemData;
      }
    },

    // defined-function which fields need to execute to get its data
    mappingSource: {
      getDataObjectName: function getDataObjectName() {
        return itemProps.itemData && itemProps.itemData.name;
      },

      getDataObjectType: function getDataObjectType() {
        return 'Calculated Field';
      },

      getExpression: function getExpression() {
        return itemProps && itemProps.itemData;
      }
    },

    onChangeValue: function onChangeValue(schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo) {
      var groupData = changedKeyPath && changedKeyPath.length ? (0, _fp.get)(changedKeyPath, schemaData) : schemaData;
      var fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      // Just update for calculated field data, not for separate property
      var data = schemaData.wrapperContent.dataSource.expression.value;
      if (configField.updateData(data) && changedKey === 'expression') {
        // Reset data for lazyloading
        var filterDetailsConfig = (0, _fp.get)('reportFilter.configField', reportFields);
        filterDetailsConfig && filterDetailsConfig.resetOperatorSourceDisplay();

        // Reset the values of filter user set
        var filterFields = (0, _fp.get)('reportFilter.filterFields', reportFields);
        var filterDetails = (0, _fp.find)({ sourceFieldName: data.name }, filterFields);
        filterDetails && filterDetails.updateByKey('value', null);

        itemProps.store.addCalculatedField(data).then(function () {
          // update name value
          schemaData.wrapperContent.dataSource.name.value = data.name;
          itemProps.validation.reset();
        });
      }
    }
  };
};

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(16);

var _Izenda2 = __webpack_require__(12);

var _Izenda3 = _interopRequireDefault(_Izenda2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGES = _Izenda.BUNDLE.MESSAGE; // ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldPropertiesSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(30);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(402);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(96);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpressionInput = (_dec = (0, _Izenda10.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExpressionInput, _Component);

  function ExpressionInput(props) {
    (0, _classCallCheck3.default)(this, ExpressionInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExpressionInput.__proto__ || (0, _getPrototypeOf2.default)(ExpressionInput)).call(this, props));

    _this.renderPopup = function () {
      var _this$props = _this.props,
          loadValue = _this$props.loadValue,
          openPopup = _this$props.openPopup,
          calculatedStore = _this$props.fieldStore.calculatedStore;

      var source = loadValue();
      var selectedDataSourceId = calculatedStore.expressionSelection.getSelectedDataSourceId();

      var details = {
        name: source.name,
        expression: source.expression,
        izendaDataType: source.izendaDataType,
        id: source.id
      };

      openPopup(_Izenda4.default, {
        store: calculatedStore,
        onClose: _this.closeCalculatedPopup,
        type: _this.state.calculatedPopupType,
        value: details,
        querySourceId: selectedDataSourceId,
        expressionConfig: _Izenda8.default.EXPRESSION_SELECTION.MIDDLE_FIELD
      });
    };

    _this.closeCalculatedPopup = function (calculatedData) {
      var onChange = _this.props.onChange;

      if (calculatedData) {
        onChange && onChange({ value: calculatedData });
      }
    };

    _this.state = {
      calculatedPopupType: _Izenda6.default.TYPES.EDIT
    };

    var value = props.value,
        fieldStore = props.fieldStore;

    fieldStore.fillCalculatedFieldData(value.id, null, true);
    return _this;
  }

  (0, _createClass3.default)(ExpressionInput, [{
    key: "renderButton",
    value: function renderButton() {
      var props = this.props;

      return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, props, { onClick: this.renderPopup }));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _props = this.props,
          rows = _props.rows,
          expression = _props.value.expression;


      return _react2.default.createElement("textarea", {
        readOnly: true,
        rows: rows,
        className: "expression-content",
        value: expression || ""
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "expression-input" },
        this.renderContent(),
        this.renderButton()
      );
    }

    /**
     * When popup is closed
     * @param {any} calculatedData 
     */

  }]);
  return ExpressionInput;
}(_react.Component), _class2.defaultProps = {
  rows: 5
}, _temp)) || _class);
exports.default = ExpressionInput;
module.exports = exports["default"];

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(1208);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2682);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(583);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  /**
   * Update store
   * @param {Object} store 
   */
  setStore: function setStore(store) {
    this.store = store.fieldsStore;
  },


  /** 
   * Destroy store
  */
  destroy: function destroy() {
    delete this['store'];
  },


  /** 
   * Reload view
   * @returns {Object}
  */
  reloadView: function reloadView() {
    this.isReloadView = true;
    return this.store.loadInitial();
  },


  /** 
   * Render middle panel
   * @returns {Object}
  */
  renderMiddlePanel: function renderMiddlePanel() {
    return _react2.default.createElement(_Izenda4.default, { store: this.store, uiStore: _Izenda6.default.sourceOptions });
  },


  /** 
   * Render main content
   * @param {String|(com: any) => void} ref
   * @returns {Object}
  */
  renderMainContent: function renderMainContent(ref) {
    return _react2.default.createElement(_Izenda2.default, {
      ref: ref,
      store: this.store,
      uiStore: _Izenda6.default.targetOptions,
      isReloadView: this.isReloadView,
      pageName: _Izenda8.default.PAGE_NAME.FORMATS
    });
  }
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.Formats.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Formats components
 */

module.exports = exports['default'];

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class3;
// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatsTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Format Data Tree component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(195);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(28);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(68);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(583);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(53);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(255);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopItemHeaderComponent = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(TopItemHeaderComponent, _Component);

  function TopItemHeaderComponent() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TopItemHeaderComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TopItemHeaderComponent.__proto__ || (0, _getPrototypeOf2.default)(TopItemHeaderComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      _this.props.onChange(e.target.checked);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TopItemHeaderComponent, [{
    key: 'render',
    value: function render() {
      var _props$topItem = this.props.topItem,
          name = _props$topItem.name,
          visible = _props$topItem.visible,
          items = _props$topItem.items;

      return _react2.default.createElement(
        _Izenda6.default,
        { text: name, tooltip: name },
        _react2.default.createElement('input', {
          className: 'pull-left u_marginRightInnerSpace',
          type: 'checkbox',
          checked: visible,
          onChange: this.onChange
        }),
        _react2.default.createElement(
          'div',
          { onClick: this.props.collapseToggle },
          _react2.default.createElement(
            'span',
            null,
            name
          ),
          (0, _fp.isEmpty)(items) ? null : _react2.default.createElement(
            'a',
            null,
            _react2.default.createElement('i', { className: 'icon-toggle-triangle' })
          )
        )
      );
    }
  }]);
  return TopItemHeaderComponent;
}(_react.Component)) || _class;

var Item = (0, _mobxReact.observer)(function (_ref2) {
  var label = _ref2.subItem.label;
  return _react2.default.createElement(
    _Izenda6.default,
    { key: label, text: label, tooltip: label },
    label
  );
});

var DraggableItem = (0, _Izenda12.default)(_Izenda10.default.DRAG_ITEM.REPORT_PART_FIELD_ITEM, _Izenda8.default.sourceOptions)(Item);

var FormatsTree = (0, _mobxReact.observer)(_class3 = function (_Component2) {
  (0, _inherits3.default)(FormatsTree, _Component2);

  function FormatsTree() {
    (0, _classCallCheck3.default)(this, FormatsTree);
    return (0, _possibleConstructorReturn3.default)(this, (FormatsTree.__proto__ || (0, _getPrototypeOf2.default)(FormatsTree)).apply(this, arguments));
  }

  (0, _createClass3.default)(FormatsTree, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          store = _props.store,
          name = _props.store.reportFormats.name;


      var FormatHeaderComponent = function FormatHeaderComponent() {
        return _react2.default.createElement(
          _Izenda6.default,
          { text: name, tooltip: name, onClick: _this3.props.collapseToggle },
          name,
          _react2.default.createElement(
            'a',
            null,
            _react2.default.createElement('i', { className: 'icon-toggle-triangle' })
          )
        );
      };

      var header = {
        component: FormatHeaderComponent
      };

      return _react2.default.createElement(
        _Izenda4.default,
        { header: header, collapsible: true, initState: true, className: 'Izenda-FormatTree_Panel u_fullHeight' },
        this.renderFormats(store)
      );
    }

    /**
     * Render list format item in middle panel
     * @param {Object} store
     */

  }, {
    key: 'renderFormats',
    value: function renderFormats(store) {
      var _store$reportFormats = store.reportFormats,
          headerFooter = _store$reportFormats.headerFooter,
          titleDescription = _store$reportFormats.titleDescription;

      var topItems = [headerFooter, titleDescription];

      var renderTopItem = function renderTopItem(topItem, index) {
        var renderListSubItem = function renderListSubItem() {
          if ((0, _fp.isEmpty)(topItem.items)) {
            return null;
          }
          return _react2.default.createElement(
            _Izenda2.default,
            null,
            topItem.items.map(function (subItem, index) {
              return _react2.default.createElement(DraggableItem, { key: index, subItem: subItem });
            })
          );
        };

        // set item visible or not
        var handleVisibleChanged = function handleVisibleChanged(checked) {
          topItem.setVisible(checked);

          !checked && store.reportStore.resetShowingHeaderFooter();
        };

        var header = {
          component: TopItemHeaderComponent,
          onChange: handleVisibleChanged,
          topItem: topItem
        };

        return _react2.default.createElement(
          _Izenda4.default,
          { key: index, header: header, collapsible: true, initState: true },
          renderListSubItem()
        );
      };

      return _react2.default.createElement(
        'section',
        null,
        topItems.map(renderTopItem)
      );
    }
  }]);
  return FormatsTree;
}(_react.Component)) || _class3;

exports.default = FormatsTree;
module.exports = exports['default'];

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2684);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Schedule.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Schedule component
 */
exports.default = {
  setStore: function setStore(store) {
    this.store = store.scheduleStore;
  },
  destroy: function destroy() {
    delete this.store;
  },
  renderMainContent: function renderMainContent() {
    var store = this.store;
    var subscribedInstancesStore = store.subscribedInstancesStore;

    return _react2.default.createElement(_Izenda2.default, { store: store, subscribedInstancesStore: subscribedInstancesStore });
  }
};
module.exports = exports['default'];

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ScheduleContainer component
 */
!function () {

  var React = __webpack_require__(0);
  var ScheduleHeader = __webpack_require__(2685);
  var ScheduleBody = __webpack_require__(2686);
  var connect = __webpack_require__(2);
  var ScrollBox = __webpack_require__(27);

  var ScheduleContainer = connect()(function (props) {
    return React.createElement(
      'div',
      { className: 'izenda-Wrapper-content' },
      React.createElement(
        ScrollBox,
        null,
        React.createElement(
          'div',
          { className: 'u_fullHeight u_paddingLeftRight' },
          React.createElement(ScheduleHeader, props),
          React.createElement(ScheduleBody, props)
        )
      )
    );
  });

  ScheduleContainer.propTypes = {
    store: React.PropTypes.object.isRequired,
    subscribedInstancesStore: React.PropTypes.object.isRequired
  };

  module.exports = ScheduleContainer;
}();

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(439);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScheduleContainer = function ScheduleContainer(props) {
  var reportStore = props.store.reportStore;
  var reportName = reportStore.model.reportName;

  return (0, _fp.isNil)(reportName) ? null : _react2.default.createElement(
    'div',
    { className: 'u_paddingRight' },
    _react2.default.createElement(_Izenda2.default, { store: reportStore, name: reportName, showTooltip: false, isPreviewRecord: false })
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ScheduleContainer component
 */
/**
 */


ScheduleContainer.propTypes = {
  store: _propTypes2.default.object.isRequired
};

exports.default = (0, _Izenda4.default)()(ScheduleContainer);
module.exports = exports['default'];

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ScheduleBody component
 */
!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var actions = __webpack_require__(2687);
  var SubscriptionGrid = __webpack_require__(341);
  var DashboardSchedulingConstants = __webpack_require__(277);
  var Dimensions = __webpack_require__(83);
  var ReportDesignerConstants = __webpack_require__(16);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var ScheduleBody = React.createClass({
    displayName: 'ScheduleBody',

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function componentWillMount() {
      var subscribedInstancesStore = this.props.subscribedInstancesStore;
      subscribedInstancesStore.model.setType(false);
      subscribedInstancesStore.updateReportId(this.props.store.masterModel.reportId);
    },

    componentDidMount: function componentDidMount() {
      var subscribedInstancesStore = this.props.subscribedInstancesStore;
      if (!isNil(this.props.id)) {
        // Get data for edit case
        subscribedInstancesStore.updateReportId(this.props.store.masterModel.reportId);
      }

      subscribedInstancesStore.loadSchedules(true, this.props.store.masterModel.schedules);
    },

    /**
     * render component
     * @return {Object} component
     */
    render: function render() {
      var props = this.props;
      var subscribedInstancesStore = props.subscribedInstancesStore;

      return React.createElement(SubscriptionGrid, { reportState: ReportDesignerConstants.REPORT_STATE.DRAFT,
        store: props.subscribedInstancesStore,
        pageConstants: DashboardSchedulingConstants,
        containerWidth: props.width,
        isPopupMode: false,
        onSavePopupDesigner: props.onSaveSchedule,
        onSearch: subscribedInstancesStore.searchSchedules.bind(subscribedInstancesStore),
        onDelete: props.onDeleteSchedule,
        onCopy: props.onCopySchedule });
    }
  });

  module.exports = connect(actions, Dimensions)(ScheduleBody);
}();

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleBodyActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var defaultProps = __webpack_require__(9).defaultProps;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var scheduleBodyActions = compose(withHandlers({
    onSaveSchedule: curry(onSaveSchedule),
    onDeleteSchedule: curry(onDeleteSchedule),
    onCopySchedule: curry(onCopySchedule)
  }));

  /**
   * Save schedule data.
   * @param {Object} props
   * @param {Object} schedule data
   */
  function onSaveSchedule(props, schedule) {
    var subscribedInstances = props.subscribedInstancesStore.model;
    // Update for grid
    subscribedInstances.updateSubscribedInstances(schedule);
    // Update data for search & paging.
    subscribedInstances.updateScheduleInstances(false, schedule);
    // Update to report designer
    props.store.reportStore.model.updateSchedule(subscribedInstances.scheduleInstances);
  }

  /**
   * Delete schedule.
   * @param {Object} props
   * @param {Object} schedule data
   */
  function onDeleteSchedule(props, ids) {
    var subscribedInstances = props.subscribedInstancesStore.model;
    // Remove for grid
    subscribedInstances.removeSubscribedInstances(ids);
    // Remove data for search & paging.
    subscribedInstances.removeScheduleInstances(ids);
    // Update to report designer
    props.store.reportStore.model.updateSchedule(subscribedInstances.scheduleInstances);
  }

  /**
   * Copy schedule.
   * @param {Object} props
   * @param {Object} schedule data
   */
  function onCopySchedule(props, id) {
    var subscribedInstances = props.subscribedInstancesStore.model;
    // Update for grid
    subscribedInstances.copySubscribedInstance(id);
    // Copy data for search & paging.
    subscribedInstances.copyScheduleInstances(id);
    // Update to report designer
    props.store.reportStore.model.updateSchedule(subscribedInstances.scheduleInstances);
  }

  module.exports = scheduleBodyActions;
}();

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2689);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.Access.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Access component
 */
exports.default = {
  setStore: function setStore(store) {
    this.store = store;
  },
  renderMainContent: function renderMainContent() {
    return _react2.default.createElement(_Izenda2.default, { store: this.store });
  }
};
module.exports = exports['default'];

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AccessContainer component
 */

!function () {

  var React = __webpack_require__(0);
  var AccessHeader = __webpack_require__(2690);
  var AccessBody = __webpack_require__(2691);
  var connect = __webpack_require__(2);
  var AccessStore = __webpack_require__(594);
  var ScrollBox = __webpack_require__(27);

  var AccessContainer = React.createClass({
    displayName: 'AccessContainer',


    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    /**
     * render component
     * @return {Object} react component
     */
    render: function render() {
      var props = this.props;

      return React.createElement(
        'div',
        { className: 'izenda-Wrapper-content' },
        React.createElement(
          ScrollBox,
          null,
          React.createElement(
            'div',
            { className: 'u_fullHeight u_paddingLeftRight' },
            React.createElement(AccessHeader, props),
            React.createElement(AccessBody, (0, _extends3.default)({}, props, { accessStore: props.store.accessStore }))
          )
        )
      );
    }
  });

  module.exports = connect()(AccessContainer);
}();

/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(439);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(23);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(13);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(12);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(418);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(92);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccessHeader = function AccessHeader(props) {
  var reportStore = props.store;
  var model = reportStore.model,
      accessStore = reportStore.accessStore;

  var owner = (0, _fp.isEmpty)(model.ownerId) ? [] : [{
    id: model.ownerId,
    name: model.owner
  }];

  return _react2.default.createElement(
    _Izenda8.default,
    null,
    _react2.default.createElement(
      _Izenda8.default.Row,
      null,
      _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: model.isGlobal ? 12 : 6 },
        _react2.default.createElement(_Izenda4.default, {
          accessPage: true,
          store: reportStore,
          name: model.reportName,
          showTooltip: false,
          isPreviewRecord: false
        })
      ),
      !model.isGlobal && _react2.default.createElement(
        _Izenda8.default.Col,
        { cols: '6' },
        _react2.default.createElement(
          'div',
          { className: 'form-horizontal u_marginBottom' },
          _react2.default.createElement(
            'div',
            { className: 'form-group u-bgWhite u_paddingInner u_noMarginAll' },
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: '1' },
              _react2.default.createElement(
                'label',
                { className: 'control-label' },
                _Izenda10.default.getText('COMMON_LABEL_OWNER')
              )
            ),
            _react2.default.createElement(
              _Izenda8.default.Col,
              { cols: '11' },
              _react2.default.createElement(_Izenda12.default, {
                usedCurrentUser: true,
                useSearchName: true,
                data: accessStore.users.peek(),
                value: owner,
                usingPopup: true,
                onChange: model.updateReportOwner.bind(model),
                onChangeFromPopup: model.updateReportOwner.bind(model),
                valueField: 'id',
                textField: 'name',
                singleUser: true,
                validations: _Izenda14.default.CONSTRAINTS.REPORT_OWNER,
                field: 'owner',
                userModeType: _Izenda14.default.USER_ACCESS_MODE.ACCESS,
                useEmailInOptions: true
              })
            )
          )
        )
      )
    )
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ScheduleContainer component
 */

AccessHeader.propTypes = {
  store: _react2.default.PropTypes.object.isRequired
};

exports.default = (0, _Izenda2.default)()(AccessHeader);
module.exports = exports['default'];

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AccessBody component
 */
!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var AccessGrid = __webpack_require__(615);
  var CONSTANT = __webpack_require__(92);
  var actions = __webpack_require__(2692);

  var AccessBody = React.createClass({
    displayName: 'AccessBody',


    /**
     * render component
     * @return {Object} react component
     */
    render: function render() {
      var props = this.props;
      var store = props.store;

      return React.createElement(AccessGrid, {
        isGlobal: store.model.isGlobal,
        store: store.accessStore,
        users: store.accessStore.users,
        roles: store.accessStore.roles,
        tableDef: CONSTANT.ACCESS_TABLE_DEF,
        searchOptions: CONSTANT.SEARCH_OPTIONS,
        accessMode: CONSTANT.ACCESS_MODE.REPORT,
        userModeType: CONSTANT.USER_ACCESS_MODE.ACCESS });
    }
  });

  module.exports = connect(actions)(AccessBody);
}();

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessBodyAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var lifecycle = __webpack_require__(9).lifecycle;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var React = __webpack_require__(0);

  var accessBodyAction = compose(setPropTypes({
    store: React.PropTypes.object.isRequired
  }), lifecycle({
    /**
     * Load all access when go to access page
     */
    componentDidMount: function componentDidMount() {
      var props = this.props;
      var store = props.store;
      var accessStore = store.accessStore;
      var reportModel = store.model;
      var loader = props.loader;
      loader.startLoading();
      accessStore.initialAccessReportPage(reportModel.reportId, reportModel.reportAccess.draftAccesses, reportModel.isGlobal).finally(loader.endLoading.bind(loader));
    },

    /**
     * Load all access after save
     */
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var store = nextProps.store;
      var accessStore = store.accessStore;
      var reportModel = store.model;
      var loader = nextProps.loader;
      loader.startLoading();
      accessStore.loadAllAccess(reportModel.reportId, reportModel.accesses, reportModel.isGlobal).finally(loader.endLoading.bind(loader));
    }
  }));

  module.exports = accessBodyAction;
}();

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2694);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2696);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  setStore: function setStore(store) {
    this.store = store;
  },
  destroy: function destroy() {
    delete this['store'];
  },
  renderMiddlePanel: function renderMiddlePanel() {
    return _react2.default.createElement(_Izenda4.default, { store: this.store, model: this.store.model.export });
  },
  renderMainContent: function renderMainContent() {
    return _react2.default.createElement(_Izenda2.default, { model: this.store.model.export, store: this.store });
  }
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.Exporting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportingContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _Izenda = __webpack_require__(76);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(222);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(208);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(420);

var _Izenda8 = __webpack_require__(13);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(2695);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(71);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(1210);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(2);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda18 = __webpack_require__(109);

var _Izenda19 = _interopRequireDefault(_Izenda18);

var _Izenda20 = __webpack_require__(23);

var _Izenda21 = _interopRequireDefault(_Izenda20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LEFT = 'left';
var RIGHT = 'right';
var FORMAT = '#,###.00';
var ValidatorNumbericInput = (0, _Izenda21.default)()(_Izenda19.default);

var MarginInfo = (0, _mobxReact.observer)(function (props) {
  var name = props.name,
      className = props.className,
      position = props.position,
      key = props.value,
      model = props.model,
      _props$model = props.model,
      margins = _props$model.margins,
      getMarginSetting = _props$model.getMarginSetting;

  var onChange = function onChange(val) {
    props.onChange(val, key);
  };

  var max = model.getMaxByKey(key) || _Izenda7.MAX_HEIGHT;

  var marginLabel = _react2.default.createElement(
    _Izenda13.default,
    null,
    name
  );
  var marginInput = _react2.default.createElement(ValidatorNumbericInput, {
    disabled: margins !== _Izenda7.MARGIN_VALUE.CUSTOM,
    value: getMarginSetting[key],
    onChange: onChange,
    format: FORMAT,
    field: key,
    containerClassName: 'margin-config',
    max: max,
    min: 0
  });

  return _react2.default.createElement(
    'div',
    { className: 'u_tableRow' },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(className, 'u_tableCell') },
      position === LEFT ? marginLabel : marginInput,
      position === RIGHT ? marginLabel : marginInput
    )
  );
});

MarginInfo.displayName = 'MarginInfo';

var ExportingContainer = (_dec = (0, _Izenda17.default)(_Izenda15.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ExportingContainer, _Component);

  function ExportingContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExportingContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExportingContainer.__proto__ || (0, _getPrototypeOf2.default)(ExportingContainer)).call.apply(_ref, [this].concat(args))), _this), _this.setPrintablePage = function (printablePage) {
      _this.printablePage = printablePage;
    }, _this.getScaleX = function () {
      var printablePageNode = (0, _reactDom.findDOMNode)(_this.printablePage);
      var dpi = _Izenda2.default.getDPI();
      var _this$props = _this.props,
          model = _this$props.model,
          _this$props$model = _this$props.model,
          pageSizeKey = _this$props$model.pageSizeKey,
          orientation = _this$props$model.orientation;

      var _PrintConstants$getPa = _Izenda4.default.getPageSize(pageSizeKey, orientation),
          widthInInches = _PrintConstants$getPa.widthInInches;

      model.scaleX = printablePageNode.getBoundingClientRect().width / (dpi * widthInInches);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExportingContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.getScaleX();
      var printablePageNode = (0, _reactDom.findDOMNode)(this.printablePage);
      _Izenda6.default.listenTo(printablePageNode, this.getScaleX);

      this.unlisten = function () {
        _Izenda6.default.removeListener(printablePageNode, _this2.getScaleX);
      };
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unlisten();
      this.unlisten = null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          changeMarginConfig = _props.changeMarginConfig,
          fieldsStore = _props.store.fieldsStore,
          model = _props.model,
          _props$model2 = _props.model,
          orientation = _props$model2.orientation,
          getMarginSetting = _props$model2.getMarginSetting,
          centerOnPage = _props$model2.centerOnPage;

      var marginSetting = orientation === _Izenda7.ORIENTATION_VALUE.PORTRAIT ? _Izenda7.COLS_LAYOUT.MEDIUM : _Izenda7.COLS_LAYOUT.MIN;
      var review = orientation === _Izenda7.ORIENTATION_VALUE.PORTRAIT ? _Izenda7.COLS_LAYOUT.MEDIUM : _Izenda7.COLS_LAYOUT.MAX;

      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper-content u_paddingLeftRight izenda-Exporting' },
        _react2.default.createElement(
          _Izenda9.default,
          { className: 'u_fullHeight u-posRelative' },
          _react2.default.createElement(
            _Izenda9.default.Row,
            { className: 'u_fullHeight u-posRelative' },
            _react2.default.createElement(
              _Izenda9.default.Col,
              { cols: marginSetting, className: 'u_fullHeight u_table u_textRight' },
              _react2.default.createElement(MarginInfo, {
                value: _Izenda7.MARGIN_KEY.TOP,
                className: 'u_alignTop',
                name: _Izenda7.MARGIN_INPUT.TOP,
                model: model,
                onChange: changeMarginConfig,
                position: LEFT
              }),
              _react2.default.createElement(MarginInfo, {
                value: _Izenda7.MARGIN_KEY.LEFT,
                className: 'u_alignMiddle',
                name: _Izenda7.MARGIN_INPUT.LEFT,
                model: model,
                onChange: changeMarginConfig,
                position: LEFT
              }),
              _react2.default.createElement(MarginInfo, {
                value: _Izenda7.MARGIN_KEY.BOTTOM,
                className: 'u_alignBottom',
                name: _Izenda7.MARGIN_INPUT.BOTTOM,
                model: model,
                onChange: changeMarginConfig,
                position: LEFT
              })
            ),
            _react2.default.createElement(
              _Izenda9.default.Col,
              { cols: review, className: 'u_fullHeight u-posRelative u_noPaddingRight u_noPaddingLeft' },
              _react2.default.createElement(
                'div',
                { className: 'izenda-Exporting-report' },
                _react2.default.createElement(_Izenda11.default, {
                  ref: this.setPrintablePage,
                  top: getMarginSetting.top,
                  right: getMarginSetting.right,
                  bottom: getMarginSetting.bottom,
                  left: getMarginSetting.left,
                  header: getMarginSetting.header,
                  footer: getMarginSetting.footer,
                  horizontally: centerOnPage.horizontally,
                  vertically: centerOnPage.vertically,
                  orientation: orientation,
                  store: fieldsStore,
                  exportFormatSetting: model,
                  viewMode: false
                })
              )
            ),
            _react2.default.createElement(
              _Izenda9.default.Col,
              { cols: marginSetting, className: 'u_fullHeight u_table' },
              _react2.default.createElement(MarginInfo, {
                value: _Izenda7.MARGIN_KEY.HEADER,
                className: 'u_alignTop',
                name: _Izenda7.MARGIN_INPUT.HEADER,
                model: model,
                onChange: changeMarginConfig,
                position: RIGHT
              }),
              _react2.default.createElement(MarginInfo, {
                value: _Izenda7.MARGIN_KEY.RIGHT,
                className: 'u_alignMiddle',
                name: _Izenda7.MARGIN_INPUT.RIGHT,
                model: model,
                onChange: changeMarginConfig,
                position: RIGHT
              }),
              _react2.default.createElement(MarginInfo, {
                value: _Izenda7.MARGIN_KEY.FOOTER,
                className: 'u_alignBottom',
                name: _Izenda7.MARGIN_INPUT.FOOTER,
                model: model,
                onChange: changeMarginConfig,
                position: RIGHT
              })
            )
          )
        )
      );
    }
  }]);
  return ExportingContainer;
}(_react.Component), _class2.PropTypes = {
  model: _react.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = ExportingContainer;
module.exports = exports['default'];

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PrintablePage.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var PrintConstants = __webpack_require__(222);
  var GridLayout = __webpack_require__(13);
  var classnames = __webpack_require__(11);
  var ReportHeader = __webpack_require__(414);
  var ReportFooter = __webpack_require__(415);
  var ReportBodyViewer = __webpack_require__(501);
  var PrintingUtils = __webpack_require__(76);
  var ScrollBox = __webpack_require__(27);

  var PrintablePage = React.createClass({
    displayName: 'PrintablePage',

    getDefaultProps: function getDefaultProps() {
      return {
        viewMode: true
      };
    },
    render: function render() {
      var props = this.props;
      function getSizeUi(value) {
        return value < PrintConstants.MIN_SIZE_UI_SETTING ? PrintConstants.MIN_SIZE_UI_SETTING : value;
      }

      var pageSizeKey = props.pageSizeKey || PrintConstants.DEFAULT_PAGE_SIZE_KEY;
      var pageMargins = {
        top: getSizeUi(props.top),
        right: getSizeUi(props.right),
        bottom: getSizeUi(props.bottom),
        left: getSizeUi(props.left)
      };

      var contentSizeInInches = PrintConstants.getBodyContentSizeInInches(pageSizeKey, pageMargins, props.header, props.footer, props.orientation);

      var scaleX = props.exportFormatSetting.scaleX;
      var lineSize = PrintConstants.MIN_SIZE_UI_SETTING / 2;

      var pageSize = PrintConstants.getPageSize(props.pageSizeKey, props.orientation);
      var col0WidthInPercent = pageMargins.left * 100 / pageSize.widthInInches;
      var col1WidthInPercent = lineSize * 100 / pageSize.widthInInches;
      var col3WidthInPercent = lineSize * 100 / pageSize.widthInInches;
      var col4WidthInPercent = pageMargins.right * 100 / pageSize.widthInInches;
      var col2WidthInPercent = 100 - Math.round(col0WidthInPercent + col1WidthInPercent + col3WidthInPercent + col4WidthInPercent);

      var row0HeightInPercent = pageMargins.top * 100 / pageSize.heightInInches;
      var row1HeightInPercent = lineSize * 100 / pageSize.widthInInches;
      var row3HeightInPercent = lineSize * 100 / pageSize.widthInInches;
      var row4HeightInPercent = pageMargins.bottom * 100 / pageSize.heightInInches;
      var row2HeightInPercent = 100 - Math.round(row0HeightInPercent + row1HeightInPercent + row3HeightInPercent + row4HeightInPercent);

      var columnStyles = [{ // col 00
        width: PrintConstants.formatCSSValueInPercent(col0WidthInPercent)
      }, { // col 01
        width: PrintConstants.formatCSSValueInPercent(col1WidthInPercent)
      }, { // col 02
        width: PrintConstants.formatCSSValueInPercent(col2WidthInPercent)
      }, { // col 03
        width: PrintConstants.formatCSSValueInPercent(col3WidthInPercent)
      }, { // col 04
        width: PrintConstants.formatCSSValueInPercent(col4WidthInPercent)
      }];

      var rowStyles = [{ // row 00
        height: PrintConstants.formatCSSValueInPercent(row0HeightInPercent)
      }, { // row 01
        height: PrintConstants.formatCSSValueInPercent(row1HeightInPercent)
      }, { // row 02
        height: PrintConstants.formatCSSValueInPercent(row2HeightInPercent)
      }, { // row 03
        height: PrintConstants.formatCSSValueInPercent(row3HeightInPercent)
      }, { // row 04
        height: PrintConstants.formatCSSValueInPercent(row4HeightInPercent)
      }];

      return React.createElement(
        GridLayout,
        { className: 'izenda-PrintablePage u_fullSize' },
        React.createElement(
          GridLayout.Row,
          { className: 'u_noMarginAll u_noPaddingAll', style: { height: rowStyles[0].height } },
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[0].width } }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(GridLayout.Col, { cols: '8', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[2].width } }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[4].width } })
        ),
        React.createElement(
          GridLayout.Row,
          { className: 'non-height u_noMarginAll u_noPaddingAll u_fullWidth u_table' },
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[0].width } }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(GridLayout.Col, { cols: '8', className: 'y-line u_noMarginAll u_noPaddingAll', style: { width: columnStyles[2].width } }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[4].width } })
        ),
        React.createElement(
          GridLayout.Row,
          { className: 'u_noMarginAll u_noPaddingAll', style: { height: rowStyles[2].height } },
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[0].width } }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'x-line non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(
            GridLayout.Col,
            { cols: '8', className: 'u_noMarginAll u_noPaddingAll u_fullSize', style: { width: columnStyles[2].width } },
            renderContent()
          ),
          React.createElement(GridLayout.Col, { cols: '1', className: 'x-line non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[4].width } })
        ),
        React.createElement(
          GridLayout.Row,
          { className: 'non-height u_noMarginAll u_noPaddingAll u_fullWidth u_table' },
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[0].width } }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(GridLayout.Col, { cols: '8', className: 'y-line u_noMarginAll u_noPaddingAll', style: { width: columnStyles[2].width } }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[4].width } })
        ),
        React.createElement(
          GridLayout.Row,
          { className: 'u_noMarginAll u_noPaddingAll', style: { height: rowStyles[4].height } },
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[0].width } }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(GridLayout.Col, { cols: '8', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[2].width } }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'non-width u_noMarginAll u_noPaddingAll u_fullHeight' }),
          React.createElement(GridLayout.Col, { cols: '1', className: 'u_noMarginAll u_noPaddingAll', style: { width: columnStyles[4].width } })
        )
      );

      function renderContent() {
        var contentContainerHeightInInches = contentSizeInInches.heightOfContentInInches + props.header + props.footer;
        var headerHeightInPercent = Math.round(props.header * 100 / contentContainerHeightInInches);
        var footerHeightInPercent = Math.round(props.footer * 100 / contentContainerHeightInInches);
        var contentHeightInPercent = 100 - (headerHeightInPercent + footerHeightInPercent);

        var contentContainerClassName = classnames('u_noMarginAll u_noPaddingAll u_fullSize');

        var contentClassName = classnames('u_tableCell', {
          'u_alignTop': !props.vertically,
          'u_alignMiddle': props.vertically
        });

        var headerContainerClassName = classnames('u_noMarginAll u_noPaddingAll u_fullSize u_table');

        var headerClassName = classnames('u_tableCell', {
          'u_alignTop': !props.vertically,
          'u_alignMiddle': props.vertically
        });

        var footerContainerClassName = classnames('u_noMarginAll u_noPaddingAll u_fullSize u_table');

        var footerClassName = classnames('u_tableCell', {
          'u_alignTop': !props.vertically,
          'u_alignMiddle': props.vertically
        });
        var viewMode = props.viewMode;

        return React.createElement(
          GridLayout,
          { className: 'u_fullSize' },
          React.createElement(
            GridLayout.Row,
            { className: 'u_noMarginAll u_noPaddingAll u_overflowHidden',
              style: { height: PrintConstants.formatCSSValueInPercent(headerHeightInPercent) } },
            React.createElement(
              GridLayout.Col,
              { className: headerContainerClassName },
              React.createElement(ReportHeader, { className: headerClassName,
                setting: true,
                viewMode: true,
                horizontalAlign: props.horizontally,
                replaceSystemVariable: PrintingUtils.replaceSystemVariable,
                store: props.store })
            )
          ),
          React.createElement(
            GridLayout.Row,
            { className: 'body-content u_noMarginAll u_noPaddingAll',
              style: { height: PrintConstants.formatCSSValueInPercent(contentHeightInPercent) } },
            React.createElement(
              ScrollBox,
              null,
              React.createElement(
                GridLayout.Col,
                { className: contentContainerClassName, style: PrintingUtils.buildScaleStyle(scaleX) },
                React.createElement(ReportBodyViewer, {
                  className: contentClassName,
                  id: props.store.reportId,
                  exportFormatSetting: props.exportFormatSetting,
                  printingMode: true,
                  setting: true,
                  viewMode: viewMode })
              )
            )
          ),
          React.createElement(
            GridLayout.Row,
            { className: 'footer-content u_noMarginAll u_noPaddingAll u_overflowHidden',
              style: { height: PrintConstants.formatCSSValueInPercent(footerHeightInPercent) } },
            React.createElement(
              GridLayout.Col,
              { className: footerContainerClassName },
              React.createElement(ReportFooter, { className: footerClassName,
                setting: true,
                viewMode: true,
                horizontalAlign: props.horizontally,
                store: props.store })
            )
          )
        );
      }
    }
  });

  module.exports = connect({ toClass: true })(PrintablePage);
}();

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportingConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(13);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1210);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(420);

var _Izenda8 = __webpack_require__(71);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(29);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(17);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(68);

var _Izenda15 = _interopRequireDefault(_Izenda14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ORIENTATION = _Izenda7.LABEL.ORIENTATION,
    MARGIN = _Izenda7.LABEL.MARGIN,
    CENTER_ON_PAGE = _Izenda7.LABEL.CENTER_ON_PAGE,
    HORIZONTALLY = _Izenda7.LABEL.HORIZONTALLY,
    VERTICALLY = _Izenda7.LABEL.VERTICALLY,
    PAGE_BREAK = _Izenda7.LABEL.PAGE_BREAK;
var ExportingConfig = (_dec = (0, _Izenda4.default)(_Izenda6.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ExportingConfig, _Component);

  function ExportingConfig() {
    (0, _classCallCheck3.default)(this, ExportingConfig);
    return (0, _possibleConstructorReturn3.default)(this, (ExportingConfig.__proto__ || (0, _getPrototypeOf2.default)(ExportingConfig)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExportingConfig, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          model = _props.model,
          changeOrientation = _props.changeOrientation,
          changeMargins = _props.changeMargins,
          changeHorizontally = _props.changeHorizontally,
          changeVertically = _props.changeVertically,
          changePageBreak = _props.changePageBreak;
      var orientation = model.orientation,
          margins = model.margins,
          _model$centerOnPage = model.centerOnPage,
          horizontally = _model$centerOnPage.horizontally,
          vertically = _model$centerOnPage.vertically,
          pageBreakAfterReportPart = model.pageBreakAfterReportPart;


      return _react2.default.createElement(
        'section',
        { className: 'u_fullHeight u-posRelative u-bgWhite u_overflowHidden' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-ExportingConfig' },
          _react2.default.createElement(
            _Izenda2.default,
            { className: 'form-horizontal u_paddingAll' },
            _react2.default.createElement(
              _Izenda2.default.Row,
              null,
              _react2.default.createElement(
                _Izenda2.default.Col,
                { cols: _Izenda7.LABEL_COL },
                _react2.default.createElement(
                  _Izenda9.default,
                  { className: 'control-label u_textNormal' },
                  ORIENTATION
                )
              ),
              _react2.default.createElement(
                _Izenda2.default.Col,
                { cols: _Izenda7.CONTROL_COL },
                _react2.default.createElement(_Izenda11.default, {
                  options: _Izenda7.ORIENTATION_OPTIONS,
                  value: orientation,
                  valueField: 'value',
                  labelField: 'label',
                  onChange: changeOrientation
                })
              )
            ),
            _react2.default.createElement(
              _Izenda2.default.Row,
              null,
              _react2.default.createElement(
                _Izenda2.default.Col,
                { cols: _Izenda7.LABEL_COL },
                _react2.default.createElement(
                  _Izenda9.default,
                  { className: 'control-label u_textNormal' },
                  MARGIN
                )
              ),
              _react2.default.createElement(
                _Izenda2.default.Col,
                { cols: _Izenda7.CONTROL_COL },
                _react2.default.createElement(_Izenda11.default, {
                  options: _Izenda7.MARGIN_OPTIONS,
                  value: margins,
                  valueField: 'value',
                  labelField: 'label',
                  onChange: changeMargins
                })
              )
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              _Izenda2.default.Row,
              null,
              _react2.default.createElement(
                _Izenda2.default.Col,
                { cols: _Izenda7.LABEL_COL },
                _react2.default.createElement(
                  _Izenda9.default,
                  { className: 'control-label u_textNormal' },
                  CENTER_ON_PAGE
                )
              ),
              _react2.default.createElement(
                _Izenda2.default.Col,
                { cols: _Izenda7.CONTROL_COL },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_Izenda13.default, { checked: horizontally, type: 'checkbox', onChange: changeHorizontally }),
                  ' ',
                  HORIZONTALLY
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_Izenda13.default, { checked: vertically, type: 'checkbox', onChange: changeVertically }),
                  ' ',
                  VERTICALLY
                )
              )
            ),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              _Izenda2.default.Row,
              null,
              _react2.default.createElement(
                _Izenda2.default.Col,
                { cols: _Izenda7.LABEL_COL },
                _react2.default.createElement(
                  _Izenda9.default,
                  { className: 'control-label u_textNormal' },
                  PAGE_BREAK
                )
              ),
              _react2.default.createElement(
                _Izenda2.default.Col,
                { cols: _Izenda7.CONTROL_COL },
                _react2.default.createElement(_Izenda13.default, { checked: pageBreakAfterReportPart, type: 'checkbox', onChange: changePageBreak })
              )
            )
          )
        )
      );
    }
  }]);
  return ExportingConfig;
}(_react.Component)) || _class);
exports.default = ExportingConfig;
module.exports = exports['default'];

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(50);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _IzendaUiState = __webpack_require__(15);

var _IzendaUiState2 = _interopRequireDefault(_IzendaUiState);

var _Izenda5 = __webpack_require__(31);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _fp = __webpack_require__(1);

var _Izenda7 = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportDesignerActions = (0, _recompose.withHandlers)({
  disableReport: (0, _fp.curry)(disableReport),
  onPageChanging: (0, _fp.curry)(onPageChanging),
  saveDraftReport: (0, _fp.curry)(saveDraftReport),
  detectReportChange: (0, _fp.curry)(detectReportChange),
  handleTenantChange: (0, _fp.curry)(handleTenantChange),
  handleCascadingChanged: (0, _fp.curry)(handleCascadingChanged),
  handleNeedUpdateResultChanged: (0, _fp.curry)(handleNeedUpdateResultChanged)
});

/**
 * On page changing action that happens when user navigates to other section
 * of report designer.
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function onPageChanging(props, nextPage, currentPage) {
  // Return if pageName is active
  var menuStore = props.menuStore;
  if (menuStore.contextMenuActiveLink === nextPage) {
    return;
  }
  menuStore.changeActiveLink(nextPage);
}

/**
 * Save draft report
 */
function saveDraftReport(props, e) {
  var store = props.store,
      model = props.store.model;

  model.setIgnoreCheckChange();

  return store.saveDraftReport(props.pageName, (0, _fp.isBoolean)(e) && e).then(function (result) {
    return result.isDisableReport ? disableReport(props) : result.success;
  });
}

/**
 * Save draft report only when report physical data is unchanged.
 */
function saveDraftIfNeeded(props, pageName) {
  confirmWhenErrors(props);

  return detectReportChange(props, pageName).then(function (result) {
    if ((0, _fp.isNil)(result) || result.success) {
      pageName === _Izenda2.default.PAGE_NAME.DATA_SOURCE ? _IzendaUiState2.default.enableSystemSetting() : _IzendaUiState2.default.updateDisableSystemSetting();
    }
    return (0, _fp.isNil)(result) || result.success ? saveDraftReport(props) : null;
  });
}

/**
 * Disable report action in case of report being invalid
 */
function disableReport(props, _) {
  props.menuStore.updateMenuState(false);
  props.store.disable();
  return false;
}

/**
 * Confirm user when detected report data changed.
 */
function confirmWhenErrors(props) {
  var confirmFn = props.confirmFn;
  return function (result) {
    var success = result.success;
    if (success) {
      return true;
    }
    var error = result.messages[0];
    switch (error.key) {
      case _Izenda2.default.DETECT_CHANGE.PHYSICAL:
        return confirmFn('Information', {
          description: error.messages[0],
          type: 'info',
          showCloseIndicator: true
        }).then((0, _fp.constant)(false));
      case _Izenda2.default.DETECT_CHANGE.LOGICAL:
        return confirmFn('Confirmation', {
          description: error.messages[0]
        }).then((0, _fp.constant)(true));
      default:
        return false;
    }
  };
}

/**
 * Detect report change before save
 * Validation steps:
 *   + Detect report changes
 *   + Validate data object limitation
 *     -> invalid: disable report
 *   + Check Filter rules
 * @return {Promise} { success: boolean, messages: messages }
 */
function detectReportChange(props, pageName) {
  var store = props.store;

  return store.detectReportChange(pageName).then(function (result) {
    if (result.success) {
      return (0, _bluebird.resolve)({ success: true });
    }

    var error = result.messages[0];
    switch (error.key) {
      case _Izenda2.default.DETECT_CHANGE.PHYSICAL:
        return props.confirmFn('Information', {
          description: error.messages[0],
          type: 'info',
          showCloseIndicator: true
        }).then(disableReport.bind(null, props));
      case _Izenda2.default.DETECT_CHANGE.LOGICAL:
        return props.confirmFn('Confirmation', {
          description: error.messages[0]
        }).then(function (result) {
          if (result && result.success) {
            return checkFilterRules(props);
          }
          return result ? result : { success: true };
        });
      case '':
        return props.confirmFn('Information', {
          description: error.messages[0],
          type: 'info',
          showCloseIndicator: true
        }).then(function () {
          return { success: false };
        });
      default:
        return result;
    }
  }).then(function (result) {
    return result && result.success ? store.checkDataObjectLimitation() : result;
  }).then(function (result) {
    if (result && result.success) {
      return checkShouldUpdateResults(props);
    }
    return result ? result : { success: true };
  });
}

/**
 * check should update results
 * @return {Promise} { success: true/false }
 */
function checkShouldUpdateResults(props) {
  if (props.menuStore.contextMenuActiveLink === _Izenda2.default.PAGE_NAME.DATA_SOURCE) {
    var isDirty = checkDataSourceDirty(props);
    return isDirty.success ? checkFilterRules(props) : isDirty;
  }

  return checkFilterRules(props);
}

/**
 * check filter rules
 * @return {Promise} { success: true/false }
 */
function checkDataSourceDirty(props) {
  var dataSourceDetail = props.store.dataSourceStore.dataSourceDetail;

  var message = dataSourceDetail.isDataTreeDirty ? _Izenda4.default.MESSAGES.NEED_UPDATE_RESULTS : null;

  if (message) {
    props.confirmFn('Information', {
      description: message,
      type: 'info',
      showCloseIndicator: true,
      isHTMLFormat: true
    });
    return { success: false };
  }

  return { success: true };
}

/**
 * check filter rules
 * @return {Promise} { success: true/false }
 */
function checkFilterRules(props) {
  var reportFilters = props.store.fieldsStore.reportFilters;

  var message = null;

  // for SP filters
  if (!(0, _fp.isEmpty)(reportFilters.emptyRequiredParamFilters)) {
    message = _Izenda4.default.MESSAGES.EMPTY_FILTER_PARAM(reportFilters.emptyRequiredParamFilters);
  }

  // For normal filters
  if ((0, _fp.isNil)(message) && !(0, _fp.isEmpty)(reportFilters.emptyNotVisibleRequiredFilter)) {
    message = _Izenda4.default.MESSAGES.EMPTY_REQUIRED_FILTER(reportFilters.emptyNotVisibleRequiredFilter);
  }

  // Need Update Results
  if ((0, _fp.isNil)(message) && reportFilters.needUpdateResult) {
    message = _Izenda4.default.MESSAGES.NEED_UPDATE_RESULTS;
  }

  if (message) {
    props.confirmFn('Information', {
      description: message,
      type: 'info',
      showCloseIndicator: true,
      isHTMLFormat: true
    });
    return { success: false };
  }

  return { success: true };
}

/**
 * handle tenant changing
 */
function handleTenantChange(props, change) {
  !_IzendaUiState2.default.keepState && props.router.push({
    pathname: _Izenda6.default.getReportDesignerUrl()
  });
}

/**
 * Handle cascading change
 * @param {Object} props
 * @param {boolean} change
 */
function handleCascadingChanged(props, change) {
  change && props.confirmFn('Information', {
    type: 'info',
    description: _Izenda2.default.CASCADING_CHANGED_MESSAGE,
    showCloseIndicator: true
  });
}

/**
 * Handle need update result changed
 * @param {Object} props
 * @param {boolean} change
 */
function handleNeedUpdateResultChanged(props, change) {
  var alertDetails = props.store.alertDetails,
      localization = props.localization;


  if (change) {
    alertDetails.set({
      message: localization.getText('REPORTDESIGNER_UPDATE_RESULT'),
      type: _Izenda7.ALERT_TYPES.INFO,
      success: true,
      showType: _Izenda7.SHOW_TYPES.ALWAYS
    });
  } else {
    alertDetails.reset();
  }
}

exports.default = reportDesignerActions;
module.exports = exports['default'];

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getOwnPropertyDescriptor = __webpack_require__(25);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _bluebird = __webpack_require__(18);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _desc, _value, _class, _descriptor, _desc2, _value2, _class3, _descriptor2, _descriptor3, _descriptor4;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerMenuStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(16);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(90);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * Menu Item Class
 */
var MenuItem = (_class = function MenuItem(detail) {
  (0, _classCallCheck3.default)(this, MenuItem);

  _initDefineProp(this, 'visible', _descriptor, this);

  detail = detail || {};
  this.key = detail.key;
  this.icon = detail.icon;
  this.title = detail.title;
  this.permissions = detail.permissions;
  this.licenseKey = detail.licenseKey;
  this.tooltip = detail.tooltip;
  this.hoverShowTooltip = detail.hoverShowTooltip;
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'visible', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
})), _class);

/**
 * Report Designer Menu Store
 */

var ReportDesignerMenuStore = (_class3 = function () {
  function ReportDesignerMenuStore(reportId) {
    (0, _classCallCheck3.default)(this, ReportDesignerMenuStore);

    _initDefineProp(this, 'enableMenuItems', _descriptor2, this);

    _initDefineProp(this, 'contextMenuActiveLink', _descriptor3, this);

    _initDefineProp(this, 'menuStatus', _descriptor4, this);

    this.contextMenu = _Izenda2.default.MENU_DEFINITION;
    this.populateMenuItems();
    this.reportId = reportId;
  }

  (0, _createClass3.default)(ReportDesignerMenuStore, [{
    key: 'changeActiveLink',
    value: function changeActiveLink(newLink) {
      if (this.contextMenuActiveLink !== newLink) {
        this.contextMenuActiveLink = newLink;
      }
    }

    /**
     * Update menu state
     * @param {Boolean} newState
     */

  }, {
    key: 'updateMenuState',
    value: function updateMenuState(newState) {
      this.menuStatus = newState;
    }

    /**
     * Remove menu item out off current enable menu items.
     * @param  {String} key
     */

  }, {
    key: 'excludeMenuItemByKey',
    value: function excludeMenuItemByKey(key) {
      var matchingItem = (0, _fp.find)(function (item) {
        return item.key === key;
      }, this.enableMenuItems);
      this.enableMenuItems.remove(matchingItem);
    }

    /**
     * Toggle item visible or invisible
     * @param {String}  key
     * @param {Boolean} value
     */

  }, {
    key: 'toggleInvisibleItem',
    value: function toggleInvisibleItem(key, value) {
      var matchingItem = (0, _fp.find)(function (item) {
        return item.key === key;
      }, this.enableMenuItems);

      matchingItem && (matchingItem.visible = value);
    }

    /**
     * Build menu items from config data.
     */

  }, {
    key: 'populateMenuItems',
    value: function populateMenuItems() {
      var _this = this;

      this.enableMenuItems.clear();
      (0, _fp.forEach)(function (item) {
        _this.enableMenuItems.push(new MenuItem(item));
      }, this.contextMenu);
    }

    /**
     * Rebuild menu based on privilege and license.
     * @param {Object} authorization
     */

  }, {
    key: 'filterContextMenuByLicense',
    value: function filterContextMenuByLicense(authorization) {
      var _this2 = this;

      this.populateMenuItems();
      (0, _fp.forEach)(function (item) {
        if (!((0, _fp.isNil)(item.permissions) || authorization.checkPrivileges(item.permissions)) || !((0, _fp.isNil)(item.licenseKey) || authorization.checkLicense(item.licenseKey))) {
          _this2.excludeMenuItemByKey(item.key);
        }
      }, this.contextMenu);
    }

    /**
     * Filter Context Menu For Mobile
     */

  }, {
    key: 'filterContextMenuForMobile',
    value: function filterContextMenuForMobile() {
      var _this3 = this;

      (0, _fp.forEach)(function (item) {
        if (item.excludeForMobile === true) {
          _this3.excludeMenuItemByKey(item.key);
        }
      }, this.contextMenu);
    }

    /**
     * Update menu status.
     * @param {Boolean} menuStatus
     */

  }, {
    key: 'updateMenuStatus',
    value: function updateMenuStatus(menuStatus) {
      var _this4 = this;

      var noMenuItem = 0;
      if (this.enableMenuItems.length > noMenuItem) {
        this.validateReportIdNoCache(this.reportId).then(function (validationStatus) {
          _this4.contextMenuActiveLink = _Izenda2.default.MENU_ACTIVE_LINK;
          if (validationStatus === _Izenda2.default.FILTER_CHANGE_STATE.ADDED || validationStatus === _Izenda2.default.FILTER_CHANGE_STATE.UPDATED) {
            _this4.contextMenuActiveLink = _Izenda2.default.MENU_DATASOURCE_LINK;
          }
        });
        this.menuStatus = (0, _fp.isNil)(menuStatus) ? true : menuStatus;
      }
    }

    /**
     * Get report update status to set menu active link
     * @param {string} reportId
     */

  }, {
    key: 'validateReportIdNoCache',
    value: function validateReportIdNoCache(reportId) {
      if ((0, _fp.isNil)(reportId)) return (0, _bluebird.resolve)(true);
      return _Izenda4.default.validateReportIdNoCache(reportId, false).then(function (result) {
        if (!result.success) {
          if (reportId) {
            var messagesResult = result.messages;
            var msg = !(0, _fp.isNil)(messagesResult) && (0, _fp.isArray)(messagesResult) && messagesResult.length > 0 && !(0, _fp.isEmpty)(messagesResult[0].key) ? messagesResult[0].key : _Izenda6.default.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_INVALID_REPORT');
            return msg;
          }
        }
        return result.message;
      });
    }
  }, {
    key: 'visibleMenuItems',
    get: function get() {
      return (0, _fp.filter)('visible', this.enableMenuItems);
    }

    /**
     * Change active link
     * @param {String} newLink
     */

  }]);
  return ReportDesignerMenuStore;
}(), (_descriptor2 = _applyDecoratedDescriptor(_class3.prototype, 'enableMenuItems', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, 'contextMenuActiveLink', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'menuStatus', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'visibleMenuItems', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'visibleMenuItems'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'changeActiveLink', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'changeActiveLink'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'excludeMenuItemByKey', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'excludeMenuItemByKey'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'toggleInvisibleItem', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'toggleInvisibleItem'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'populateMenuItems', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'populateMenuItems'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'filterContextMenuByLicense', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'filterContextMenuByLicense'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'filterContextMenuForMobile', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'filterContextMenuForMobile'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'updateMenuStatus', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'updateMenuStatus'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'validateReportIdNoCache', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'validateReportIdNoCache'), _class3.prototype)), _class3);
exports.default = ReportDesignerMenuStore;
module.exports = exports['default'];

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Dashboard = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2700);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(338);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(45);

var _Izenda8 = __webpack_require__(31);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(15);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardContainer = (_dec = (0, _Izenda2.default)({ licenseKey: _Izenda7.LICENSE_KEY.Dashboard }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(DashboardContainer, _Component);

  function DashboardContainer(props) {
    (0, _classCallCheck3.default)(this, DashboardContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardContainer.__proto__ || (0, _getPrototypeOf2.default)(DashboardContainer)).call(this, props));

    _this.initState();
    return _this;
  }

  (0, _createClass3.default)(DashboardContainer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isLocationChanged = !(0, _fp.get)('location.state.keepState', nextProps) && nextProps.location.key !== this.props.location.key;
      isLocationChanged && this.initState();
    }
  }, {
    key: 'initState',
    value: function initState() {
      // License is expired, navigate to Settings pages
      if (_Izenda11.default.expiredLicense) {
        var settingLink = _Izenda9.default.getSettingsUrl();
        this.props.router.push(settingLink);
      }

      this.locationKey = (0, _fp.uniqueId)('DashboardLocationKey_');
      this.store = new _Izenda6.default();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var id = !(0, _fp.isNil)(this.props.params) ? this.props.params.id : null;
      var newDashboard = !!(0, _fp.get)('needCreateNewDashboard', this.props.location.state);

      return !_Izenda11.default.expiredLicense && _react2.default.createElement(_Izenda4.default, (0, _extends3.default)({
        key: this.locationKey,
        id: id,
        newDashboard: newDashboard,
        store: this.store
      }, this.props));
    }
  }]);
  return DashboardContainer;
}(_react.Component)) || _class);
exports.Dashboard = _react.Component;
exports.Container = DashboardContainer;

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.Dashboard.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobx = __webpack_require__(5);

var _Izenda5 = __webpack_require__(2701);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(331);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(156);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(333);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(339);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(31);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _fp = __webpack_require__(1);

var _Izenda17 = __webpack_require__(42);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(40);

var _Izenda20 = _interopRequireDefault(_Izenda19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dashboard = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Dashboard, _Component);

  function Dashboard(props) {
    (0, _classCallCheck3.default)(this, Dashboard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Dashboard.__proto__ || (0, _getPrototypeOf2.default)(Dashboard)).call(this, props));

    _this.checkPermissionEntryDashboard = function () {
      var _this$props = _this.props,
          id = _this$props.id,
          newDashboard = _this$props.newDashboard,
          authorization = _this$props.authorization,
          router = _this$props.router;

      var isDashboardList = (0, _fp.isNil)(id) && !newDashboard;
      if (!isDashboardList) {
        var hasAddNewPrivileges = authorization.checkPrivileges([_Izenda18.default.PERMISSION_KEY.DashboardsCanCreateNewDashboardValue]);
        if (newDashboard && !hasAddNewPrivileges) {
          router.push(_Izenda16.default.getNoPermissionUrl());
        }
      }
    };

    _this.settingStore = new _Izenda14.default();
    _this.checkPermissionEntryDashboard();
    return _this;
  }

  (0, _createClass3.default)(Dashboard, [{
    key: 'updateSystemSetting',


    /**
     * Disable system level on dashboard viewer mode
     */
    value: function updateSystemSetting() {
      if (!(0, _fp.isNil)(this.props.id) || this.props.newDashboard) {
        _Izenda4.default.updateDisableSystemSetting();
      } else {
        _Izenda4.default.enableSystemSetting();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;

      // observe changing tenantId, then reload data for Dashboard
      this.disposeObserveTenantId = (0, _mobx.observe)(_Izenda4.default, 'tenantId', function () {
        // when changing tenant, if dashboard is new --> cancel all changes
        // (only remaining selected preset) otherwise redirect to dashboard list.
        if (props.newDashboard) {
          props.store.cancelDashboard();
        } else {
          props.router.push({
            pathname: _Izenda16.default.getDashboardUrl()
          });
        }
      });

      this.updateSystemSetting();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateSystemSetting();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disposeObserveTenantId();
      this.settingStore.destroy();
    }

    /**
     * Check permission entry dashboard page
     */

  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var id = props.id,
          store = props.store,
          newDashboard = props.newDashboard,
          children = props.children;

      // Only show dashboard left navigate for dashboard list and disable setting lvl

      var showDashboardLeftNavigate = (0, _fp.isNil)(id) && !newDashboard;

      return _react2.default.createElement(
        'section',
        { className: 'izenda-TableLayout' },
        _react2.default.createElement(_Izenda8.default, { store: this.settingStore }),
        _react2.default.createElement(
          _Izenda12.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'izenda-TableLayout u_paddingTopBottom' },
            showDashboardLeftNavigate && _react2.default.createElement(_Izenda6.default, { store: store }),
            _react2.default.createElement(
              _Izenda10.default,
              null,
              children && _react2.default.cloneElement(children, {
                id: id,
                store: store,
                newDashboard: newDashboard
              })
            )
          )
        )
      );
    }
  }]);
  return Dashboard;
}(_react.Component), _class2.propTypes = {
  store: _mobxReact.propTypes.observableObject.isRequired,
  id: _propTypes2.default.string,
  newDashboard: _propTypes2.default.bool.isRequired
}, _temp)) || _class);
exports.default = Dashboard;
module.exports = exports['default'];

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardLeftNavigation.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1198);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(332);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(31);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _mobx = __webpack_require__(5);

var _Izenda9 = __webpack_require__(15);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardLeftNavigation = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DashboardLeftNavigation, _Component);

  function DashboardLeftNavigation(props) {
    (0, _classCallCheck3.default)(this, DashboardLeftNavigation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardLeftNavigation.__proto__ || (0, _getPrototypeOf2.default)(DashboardLeftNavigation)).call(this, props));

    _this.validateCategoryName = function (category) {
      var store = _this.props.store;

      return store.validateCategoryName(category);
    };

    _this.registerLeftMenuLazyLoadingStore = function (lazyLoadingStore) {
      var store = _this.props.store;

      store.registerLeftMenuLazyLoadingStore(lazyLoadingStore);
    };

    _this.loadLazyLoadingCategories = function (pageInfo) {
      var store = _this.props.store;

      store.loadLazyLoadingCategories(false, pageInfo);
    };

    _this.loadDashboardList = function (catId) {
      var store = _this.props.store;

      return store.lazyLoadingDashboards(catId, true, null);
    };

    _this.urlList = _Izenda8.default.getConfigRoute("Dashboard", "List");
    return _this;
  }

  (0, _createClass3.default)(DashboardLeftNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          loader = _props.loader,
          store = _props.store;

      //observe tenant change --> reload data itself and close loader.

      this.disposeObserveTenantId = (0, _mobx.observe)(_Izenda10.default, "tenantId", function () {
        store.loadLazyLoadingCategories(true, null).finally(loader.endLoading.bind(loader));
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disposeObserveTenantId();
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          store = _props2.store,
          _props2$store$model = _props2.store.model,
          dataTree = _props2$store$model.leftMenuCategoryTree,
          isLeftMenuLastPage = _props2$store$model.isLeftMenuLastPage,
          _props2$store$dashboa = _props2.store.dashboardDesignerMode,
          isPresentation = _props2$store$dashboa.isPresentation,
          isFullscreen = _props2$store$dashboa.isFullscreen,
          selectedCategoryId = _props2.store.selectedCategoryId;


      var routeParams = {
        catId: { dataKey: "id", value: null },
        dashboardId: { dataKey: "dashboardId", value: null },
        isGlobal: { dataKey: "isGlobal", value: null }
      };

      return !isPresentation && !isFullscreen && _react2.default.createElement(
        _Izenda6.default,
        { className: "izenda-Content-Sidebar", isHiddenOnCollapsed: true, hasScrollBox: false },
        _react2.default.createElement(_Izenda4.default, {
          store: store,
          dataTree: dataTree,
          isLastPage: isLeftMenuLastPage,
          selectedCategoryId: selectedCategoryId,
          routeObject: this.urlList,
          routeParams: routeParams,
          onLoadCategoryList: this.loadDashboardList,
          onValidateCategoryName: this.validateCategoryName,
          registerLazyLoadingStore: this.registerLeftMenuLazyLoadingStore,
          getData: this.loadLazyLoadingCategories
        })
      );
    }
  }]);
  return DashboardLeftNavigation;
}(_react.Component), _class2.propTypes = {
  store: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = DashboardLeftNavigation;
module.exports = exports["default"];

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var actions = __webpack_require__(2703);

  var classnames = __webpack_require__(11);
  var constants = __webpack_require__(73);
  var ScrollBox = __webpack_require__(27);
  var VirtualList = __webpack_require__(313);
  var DashboardItem = __webpack_require__(2704);
  var GridLayout = __webpack_require__(13);
  var DashboardListHeader = __webpack_require__(1200)(constants);
  var LazyLoading = __webpack_require__(219);

  var _require = __webpack_require__(1),
      omit = _require.omit,
      forEach = _require.forEach,
      isEqual = _require.isEqual,
      isNil = _require.isNil,
      has = _require.has,
      isEmpty = _require.isEmpty,
      size = _require.size,
      getOr = _require.getOr;

  var DashboardList = React.createClass({
    displayName: 'DashboardList',

    propTypes: {
      store: React.PropTypes.object
    },

    componentDidMount: function componentDidMount() {
      this.props.loader.startLoading();
      this.props.store.dashboardDesignerMode.reset();
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var restNextProps = omit(['isGlobalExpand', 'isLocalExpand'], nextProps);
      var restProps = omit(['isGlobalExpand', 'isLocalExpand'], this.props);
      if (!isEqual(restNextProps, restProps)) {
        this.isReload = true;
        this.loadDashboardList(nextProps);
      }
    },

    loadDashboardList: function loadDashboardList(props) {
      var catId = props.params.catId,
          isGlobal = props.params.isGlobal,
          loader = props.loader;

      loader.startLoading();
      props.store.lazyLoadingDashboards(catId, true, isGlobal).finally(loader.endLoading.bind(loader));
    },

    render: function render() {
      var props = this.props;
      var store = props.store;
      var subscriptionStore = props.subscriptionStore;
      this.globalLocalCount = 0;
      var dashboardList = getDashboardList.call(this, store.items.categories);
      var getData = getDataFunc();

      return React.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        React.createElement(DashboardListHeader, { ref: 'dashboardListHeader', store: store, isGlobal: props.isGlobal }),
        React.createElement(
          'section',
          { className: 'izenda-DashboardList izenda-Wrapper-content u_paddingLeftRight' },
          React.createElement(
            ScrollBox,
            null,
            React.createElement(LazyLoading, {
              data: dashboardList,
              isLastPage: store.items.isLastPage,
              getData: getData,
              renderItem: renderDashboard.bind(this),
              registerLazyLoadingStore: store.registerContentLazyLoadingStore.bind(store),
              loader: isNil(this.isReload) && props.loader
            })
          )
        )
      );

      function getDashboardList(globalLocalCategories) {
        var dashboardList = [];
        var dashboards, numDashboards;

        forEach(function (globalLocalCategory) {
          this.globalLocalCount++;

          if (globalLocalCategory.isVirtualNode) {
            dashboardList.push(globalLocalCategory);
            return;
          }

          dashboardList.push({
            key: globalLocalCategory.isGlobal ? 'GlobalCategory_' + props.isGlobalExpand : 'LocalCategory_' + props.isLocalExpand,
            isGlobal: globalLocalCategory.isGlobal,
            globalLocalCategory: globalLocalCategory
          });

          (globalLocalCategory.isGlobal && props.isGlobalExpand || !globalLocalCategory.isGlobal && props.isLocalExpand) && forEach(function (category) {
            if (category.isVirtualNode) {
              dashboardList.push(category);
              return;
            }

            if (category.canDelete) return;

            forEach(function (subCategory) {
              if (subCategory.isVirtualNode) {
                dashboardList.push(subCategory);
                return;
              }

              if (subCategory.canDelete) return;

              dashboards = getOr([], 'dashboards', subCategory);
              numDashboards = size(dashboards);

              dashboards.forEach(function (dashboard, index) {
                if (dashboard.isVirtualNode) {
                  dashboardList.push(dashboard);
                  return;
                }

                dashboardList.push({
                  key: dashboard.id,
                  isGlobal: category.isGlobal,
                  isFirstItem: index === 0,
                  isLastItem: index === numDashboards - 1,
                  category: category,
                  subCategory: subCategory,
                  dashboard: dashboard
                });
              }, subCategory.dashboards);
            }, category.subCategories);
          }, globalLocalCategory.subCategories);
        }.bind(this), globalLocalCategories);

        return dashboardList;
      }

      function renderGlobalLocalCategory(groupInfo) {
        var isGlobal = groupInfo.isGlobal;
        var expandCollapse = classnames({
          'icon-minus-circled': isGlobal && props.isGlobalExpand || !isGlobal && props.isLocalExpand,
          'icon-plus-circled': isGlobal && !props.isGlobalExpand || !isGlobal && !props.isLocalExpand
        });

        var className = classnames({
          u_paddingTop: !isGlobal && this.globalLocalCount === 2
        });

        return React.createElement(
          GridLayout,
          { className: className },
          React.createElement(
            GridLayout.Row,
            { className: 'u_paddingTopBottom u_noMarginAll u-bgWhite' },
            React.createElement(
              GridLayout.Col,
              { cols: 11 },
              React.createElement(
                'div',
                { className: 'u_textBold u_textUppercase' },
                groupInfo.globalLocalCategory.name
              )
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 1 },
              React.createElement(
                'div',
                { className: 'u_floatRight' },
                React.createElement(
                  'a',
                  { onClick: props.toggle.bind(props, isGlobal) },
                  React.createElement('span', { className: expandCollapse })
                )
              )
            )
          )
        );
      }

      function renderDashboard(groupInfo) {
        if (has('globalLocalCategory', groupInfo)) {
          return renderGlobalLocalCategory.call(this, groupInfo);
        }

        return React.createElement(DashboardItem, (0, _extends3.default)({}, groupInfo, {
          selectedDashboardId: props.params.dashboardId,
          store: store,
          subscriptionStore: subscriptionStore
        }));
      }

      function getDataFunc() {
        return !isEmpty(store.items.searchText) ? store.lazyLoadingSearch.bind(store, props.params.isGlobal) : store.lazyLoadingDashboards.bind(store, props.params.catId, false, props.params.isGlobal);
      }
    }
  });

  module.exports = connect(actions)(DashboardList);
}();

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardListAction.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withState = __webpack_require__(9).withState;
  var withHandlers = __webpack_require__(9).withHandlers;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var action = compose(withState('isGlobalExpand', 'updateGlobalExpand', true), withState('isLocalExpand', 'updateLocalExpand', true), withHandlers({
    toggle: curry(toggle)
  }));

  function toggle(props, isGlobal) {
    if (isGlobal) {
      props.updateGlobalExpand(!props.isGlobalExpand);
    } else {
      props.updateLocalExpand(!props.isLocalExpand);
    }
  }

  module.exports = action;
}();

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardItem.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(73);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobxReact = __webpack_require__(10);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda3 = __webpack_require__(629);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(62);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2705);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchCriteria = _Izenda2.default.SEARCH_CRITERIA;

var DashboardItem = (0, _mobxReact.observer)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(DashboardItem, _Component);

  function DashboardItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DashboardItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DashboardItem.__proto__ || (0, _getPrototypeOf2.default)(DashboardItem)).call.apply(_ref, [this].concat(args))), _this), _this.setRefAffix = function (dom) {
      dom && (_this.affix = dom);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DashboardItem, [{
    key: 'render',
    value: function render() {
      var props = this.props,
          _props = this.props,
          isFirstItem = _props.isFirstItem,
          isTrainingMode = _props.isTrainingMode,
          isLastItem = _props.isLastItem,
          store = _props.store,
          subscriptionStore = _props.subscriptionStore,
          subCategory = _props.subCategory,
          category = _props.category,
          dashboard = _props.dashboard;


      var classes = (0, _classnames2.default)('panel panel-default izenda-DashboardItem', {
        'izenda-DashboardItem_last': isLastItem
      });
      var classesHeader = (0, _classnames2.default)('panel-heading text-uppercase izenda-DashboardItemHeader', {
        u_block: isFirstItem,
        u_none: isTrainingMode
      });

      return _react2.default.createElement(
        _Izenda4.default,
        { className: classes, affixClass: 'show-header', getAffix: this.getAffix },
        _react2.default.createElement(
          'div',
          { ref: this.setRefAffix, className: classesHeader },
          getHeaderName()
        ),
        _react2.default.createElement(_Izenda8.default, (0, _extends3.default)({}, props, {
          className: isFirstItem ? 'u_noMarginTop' : '',
          store: store,
          boardDetail: dashboard,
          subCategory: subCategory,
          subscriptionStore: subscriptionStore
        }))
      );

      function getHeaderName() {
        if (category.isUncategorized) {
          return _Izenda2.default.UNCATEGORIZED;
        }

        if (subCategory.isUncategorized) {
          return _react2.default.createElement(_Izenda6.default, {
            highlight: store.items.searchText,
            text: category.name,
            className: 'text-bold',
            notHighlight: isNotHighLight(store.items.searchType, SearchCriteria[7].value)
          });
        }

        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_Izenda6.default, {
            highlight: store.items.searchText,
            text: category.name,
            className: 'text-bold',
            notHighlight: isNotHighLight(store.items.searchType, SearchCriteria[7].value)
          }),
          '\xA0 -\xA0',
          _react2.default.createElement(_Izenda6.default, {
            highlight: store.items.searchText,
            text: subCategory.name,
            className: 'text-bold',
            notHighlight: isNotHighLight(store.items.searchType, SearchCriteria[8].value)
          })
        );
      }

      function isNotHighLight(searchType, field) {
        return searchType !== _Izenda2.default.SEARCH_CRITERIA[0].value && searchType !== field;
      }
    }
  }, {
    key: 'getAffix',
    value: function getAffix() {
      return this.affix;
    }
  }]);
  return DashboardItem;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object
}, _temp2)) || _class;

exports.default = DashboardItem;
module.exports = exports['default'];

/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class3, _class4, _temp2, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardDetail.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(73);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1212);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda7 = __webpack_require__(13);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(28);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(62);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(88);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(31);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2707);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardDetailHeader = __webpack_require__(1199)(_Izenda2.default);

var Body = (_dec = (0, _Izenda14.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Body, _Component);

  function Body() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Body);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Body.__proto__ || (0, _getPrototypeOf2.default)(Body)).call.apply(_ref, [this].concat(args))), _this), _this.renderItemInfo = function (text, value, field) {
      var _this$props = _this.props,
          boardDetail = _this$props.boardDetail,
          model = _this$props.store.items;


      return _react2.default.createElement(
        _Izenda8.default.Row,
        { className: 'form-group' },
        _react2.default.createElement(
          _Izenda8.default.Col,
          { cols: '6', xs: '6' },
          _react2.default.createElement(
            'label',
            { className: 'control-label u_textGrayColor' },
            text,
            ': '
          )
        ),
        _react2.default.createElement(
          _Izenda8.default.Col,
          { cols: '6', xs: '6' },
          _react2.default.createElement(_Izenda12.default, {
            highlight: model.searchText,
            text: value,
            className: 'u_textNormal',
            notHighlight: boardDetail.isNotHighLight(model.searchType, field)
          })
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Body, [{
    key: 'render',
    value: function render() {
      var SearchCriteria = _Izenda2.default.SEARCH_CRITERIA;
      var _props = this.props,
          boardDetail = _props.boardDetail,
          localization = _props.localization;

      return _react2.default.createElement(
        _Izenda8.default,
        null,
        _react2.default.createElement(
          _Izenda8.default.Row,
          null,
          _react2.default.createElement(
            _Izenda8.default.Col,
            {
              cols: '6',
              xs: '12',
              className: 'dashboard-description overflow-text',
              title: boardDetail.description
            },
            boardDetail.description
          ),
          _react2.default.createElement(
            _Izenda8.default.Col,
            { cols: '6', xs: '12', className: 'dashboard-detail-info' },
            _react2.default.createElement(
              _Izenda8.default.Row,
              null,
              _react2.default.createElement(
                _Izenda8.default.Col,
                { cols: '6' },
                this.renderItemInfo(localization.getText('COMMON_CRITERIA_DASHBOARD_OWNER'), boardDetail.owner, 'none'),
                this.renderItemInfo(localization.getText('COMMON_CRITERIA_CREATED_BY'), boardDetail.createdBy, SearchCriteria[3].value),
                this.renderItemInfo(localization.getText('COMMON_CRITERIA_EDITED_BY'), boardDetail.modifiedBy, SearchCriteria[5].value),
                this.renderItemInfo(localization.getText('COMMON_CRITERIA_NUMBER_OF_VIEWS'), boardDetail.numberOfView, 'none'),
                this.renderItemInfo(localization.getText('COMMON_CRITERIA_AVERAGE_RENDERING_TIME'), boardDetail.renderingTimeInSeconds, 'none')
              ),
              _react2.default.createElement(
                _Izenda8.default.Col,
                { cols: '6' },
                this.renderItemInfo(localization.getText('COMMON_CRITERIA_VERSION'), boardDetail.version && boardDetail.version.toString(), 'none'),
                this.renderItemInfo(localization.getText('COMMON_CRITERIA_CREATED_DATE'), (0, _Izenda16.default)(_Izenda4.default.currentUser.dateFormat, boardDetail.created), SearchCriteria[4].value),
                this.renderItemInfo(localization.getText('COMMON_CRITERIA_EDITED_DATE'), (0, _Izenda16.default)(_Izenda4.default.currentUser.dateFormat, boardDetail.modified), SearchCriteria[6].value),
                this.renderItemInfo(localization.getText('COMMON_CRITERIA_LAST_VIEWED'), (0, _Izenda16.default)(_Izenda4.default.currentUser.dateFormat, boardDetail.lastViewed), 'none')
              )
            )
          )
        )
      );
    }
  }]);
  return Body;
}(_react.Component)) || _class);
var DashboardDetail = (_dec2 = (0, _Izenda14.default)(), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(DashboardDetail, _Component2);

  function DashboardDetail(props) {
    (0, _classCallCheck3.default)(this, DashboardDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (DashboardDetail.__proto__ || (0, _getPrototypeOf2.default)(DashboardDetail)).call(this, props));

    _initialiseProps.call(_this2);

    var boardDetail = props.boardDetail,
        selectedDashboardId = props.selectedDashboardId;

    var activeItem = boardDetail.id === selectedDashboardId;

    boardDetail.setStateExpanded(activeItem);

    return _this2;
  }

  (0, _createClass3.default)(DashboardDetail, [{
    key: 'render',
    value: function render() {
      var props = this.props,
          _props2 = this.props,
          boardDetail = _props2.boardDetail,
          store = _props2.store,
          _props2$store = _props2.store,
          model = _props2$store.model,
          _props2$store$model = _props2$store.model,
          dashboardDesignerMode = _props2$store$model.dashboardDesignerMode,
          dashboard = _props2$store$model.dashboardDetail.dashboard,
          authorization = _props2.authorization,
          localization = _props2.localization;


      var detailUri = {
        pathname: _Izenda18.default.getDashboardUrl('Edit', { id: boardDetail.id }),
        state: {
          fromList: true
        }
      };

      var permissionKeys = props.authorizationConstants.PERMISSION_KEY;

      var header = {
        store: store,
        boardDetail: boardDetail,
        expanedOption: boardDetail.isShowDetail,
        component: DashboardDetailHeader,
        detailUri: detailUri,
        accessPriority: boardDetail.accessPriority,
        hasRenamePermission: authorization.checkPrivileges([permissionKeys.DashboardsActionsOverwriteExistingDashboard])
      };

      var footer = {
        store: store,
        boardDetail: boardDetail,
        subCategory: props.subCategory,
        component: _Izenda20.default,
        detailUri: detailUri
      };

      var isSubscribeMode = dashboard.id === boardDetail.id ? dashboardDesignerMode.isSubscribe : false;

      return _react2.default.createElement(
        _Izenda10.default,
        {
          renderCollapseContent: true,
          header: header,
          footer: !isSubscribeMode && footer,
          collapsible: true,
          expanedOption: boardDetail.isShowDetail,
          className: (0, _classnames2.default)('dashboard-detail', props.className)
        },
        isSubscribeMode ? _react2.default.createElement(_Izenda6.default, (0, _extends3.default)({}, this.props, {
          id: boardDetail.id,
          isDashboardMode: true,
          onClose: this.onCloseSubscribe,
          doesSaveToDB: true
        })) : _react2.default.createElement(Body, { boardDetail: boardDetail, store: store })
      );
    }
  }]);
  return DashboardDetail;
}(_react.Component), _class4.propTypes = {
  store: _propTypes2.default.object
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onCloseCopyPopup = function (message) {
    var props = _this3.props;
    var loader = props.loader;

    if (message) {
      return props.confirmFn('Information', {
        description: message,
        type: 'info',
        showCloseIndicator: true
      }).then(function () {
        loader.startLoading();
        return props.store.loadDashboardsData(props.DashboardDetail.type);
      }).finally(loader.endLoading.bind(loader));
    }
  };

  this.onCloseSubscribe = function () {
    var dashboardDesignerMode = _this3.props.store.model.dashboardDesignerMode;


    dashboardDesignerMode.switchSubscribeMode(false);
  };
}, _temp2)) || _class3);
exports.default = DashboardDetail;
module.exports = exports['default'];

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get SEARCH_OPTION() {
    return [{ value: 'All', label: _Izenda2.default.getText('COMMON_LABEL_ALL') }, { value: 'Name', label: _Izenda2.default.getText('COMMON_LABEL_INSTANCE_NAME') }, { value: 'Schedule', label: _Izenda2.default.getText('COMMON_LABEL_SCHEDULE') }, { value: 'FilterValueSelection', label: _Izenda2.default.getText('COMMON_LABEL_FILTER_VALUE_SELECTION') }, { value: 'DeliveryType', label: _Izenda2.default.getText('COMMON_LABEL_DELIVERY_TYPE') }, { value: 'DeliveryMethod', label: _Izenda2.default.getText('COMMON_LABEL_DELIVERY_METHOD') }];
  },
  get PAGE_TEXT() {
    return {
      AddText: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_ADD'),
      EditText: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_EDIT'),
      CopyText: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_COPY'),
      DeleteText: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_DELETE')
    };
  },
  get TABLE_DEF() {
    return {
      selectedValue: { key: 'selectedValue', width: 30, title: '', sortable: false },
      name: {
        key: 'name',
        width: 200,
        title: _Izenda2.default.getText('COMMON_LABEL_INSTANCE_NAME'),
        sortable: true,
        columnKey: 'name'
      },
      schedule: {
        key: 'schedule',
        width: 450,
        title: _Izenda2.default.getText('COMMON_LABEL_SCHEDULE'),
        sortable: true,
        columnKey: 'schedule'
      },
      filterValueSelection: {
        key: 'filterValueSelection',
        width: 300,
        title: _Izenda2.default.getText('COMMON_LABEL_FILTER_VALUE_SELECTION'),
        sortable: true,
        columnKey: 'filterValueSelection'
      },
      deliveryType: {
        key: 'deliveryType',
        width: 300,
        title: _Izenda2.default.getText('COMMON_LABEL_DELIVERY_TYPE'),
        sortable: true,
        columnKey: 'deliveryType'
      },
      deliveryMethodView: {
        key: 'deliveryMethodView',
        width: 150,
        title: _Izenda2.default.getText('COMMON_LABEL_DELIVERY_METHOD'),
        sortable: true,
        columnKey: 'deliveryMethodView'
      },
      action: {
        key: 'action',
        width: 80,
        title: _Izenda2.default.getText('COMMON_LABEL_ACTION'),
        sortable: false,
        fixed: true
      }
    };
  },
  get MESSAGE() {
    return {
      M01a: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_DELETE_SUBSCRIBED_INSTANCE'),
      M01b: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_DELETE_SELECTED_SUBSCRIBED_INSTANCE'),
      M03a: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_RECURRENCE_END_DATE'),
      M03b: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_START_DATE_CANNOT_AFTER_END_DATE'),
      M05: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_NAME_ALREADY_EXIST'),
      requiredOccurrence: _Izenda2.default.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_OCCURRENCE_IS_REQUIRED')
    };
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardSubscriptionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//
/**
 * DashboardSubscriptionConstants
 */

module.exports = exports['default'];

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(42);

var _Izenda2 = __webpack_require__(45);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _Izenda4 = __webpack_require__(233);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(30);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(634);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(13);

var _Izenda11 = _interopRequireDefault(_Izenda10);

var _Izenda12 = __webpack_require__(148);

var _Izenda13 = _interopRequireDefault(_Izenda12);

var _Izenda14 = __webpack_require__(2);

var _Izenda15 = _interopRequireDefault(_Izenda14);

var _Izenda16 = __webpack_require__(1213);

var _Izenda17 = _interopRequireDefault(_Izenda16);

var _Izenda18 = __webpack_require__(2708);

var _Izenda19 = _interopRequireDefault(_Izenda18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardDetailFooter.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var AuthorizationButton = (0, _Izenda13.default)()(_Izenda7.default);
var AuthorizationPrintDashboardButton = (0, _Izenda13.default)()(_Izenda17.default);
var AuthorizationExportButton = (0, _Izenda13.default)()(_Izenda9.default);

var DashboardDetailFooter = function DashboardDetailFooter(_ref) {
  var copyDashboard = _ref.copyDashboard,
      detailUri = _ref.detailUri,
      localization = _ref.localization,
      authorizationConstants = _ref.authorizationConstants,
      boardDetail = _ref.boardDetail,
      authorization = _ref.authorization,
      store = _ref.store,
      moveDashboard = _ref.moveDashboard,
      openEmailPopup = _ref.openEmailPopup,
      subscribeDashboard = _ref.subscribeDashboard,
      deleteDashboard = _ref.deleteDashboard;

  var permissionKeys = authorizationConstants.PERMISSION_KEY;

  var hasScheduleLicense = authorization.checkLicense(_Izenda3.default.LICENSE_KEY.Scheduling);
  var hasExportLicense = authorization.checkLicense(_Izenda3.default.LICENSE_KEY.Exporting);
  var accessPriority = boardDetail.accessPriority,
      name = boardDetail.name,
      dashboardId = boardDetail.id;


  return _react2.default.createElement(
    _Izenda11.default,
    null,
    _react2.default.createElement(
      _Izenda11.default.Row,
      null,
      _react2.default.createElement(
        _Izenda11.default.Col,
        { cols: '12', className: 'text-right' },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock izenda-ActionBar' },
          _react2.default.createElement(
            _Izenda5.default,
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: detailUri },
              _react2.default.createElement(_Izenda7.default, { className: 'pull-left', label: localization.getText('COMMON_LABEL_OPEN') })
            ),
            (accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs) && boardDetail.copyable && _react2.default.createElement(AuthorizationButton, {
              label: localization.getText('COMMON_LABEL_COPY'),
              onClick: copyDashboard,
              keys: [permissionKeys.DashboardsCanCreateNewDashboardValue]
            }),
            accessPriority === _Izenda.ACCESS_RIGHT.FullAccess && boardDetail.movable && _react2.default.createElement(AuthorizationButton, {
              label: localization.getText('COMMON_LABEL_MOVE'),
              onClick: moveDashboard,
              keys: [permissionKeys.DashboardsActionsOverwriteExistingDashboard]
            }),
            hasExportLicense && _react2.default.createElement(AuthorizationPrintDashboardButton, {
              store: store,
              'export': store.printDashboard,
              id: dashboardId,
              name: name,
              keys: [permissionKeys.DashboardsActionsPrint]
            }),
            hasExportLicense && _react2.default.createElement(AuthorizationExportButton, {
              store: store,
              'export': store.exportDashboard,
              id: dashboardId,
              isDashboard: true,
              name: name,
              keys: [permissionKeys.DashboardsActionsExporting]
            }),
            _react2.default.createElement(AuthorizationButton, {
              onClick: openEmailPopup,
              label: localization.getText('COMMON_LABEL_EMAIL'),
              keys: [permissionKeys.DashboardsActionsEmail]
            }),
            hasScheduleLicense && _react2.default.createElement(AuthorizationButton, {
              label: localization.getText('COMMON_LABEL_SUBSCRIBE'),
              onClick: subscribeDashboard,
              keys: [permissionKeys.DashboardsActionsSubscribe]
            }),
            accessPriority === _Izenda.ACCESS_RIGHT.FullAccess && boardDetail.deletable && _react2.default.createElement(AuthorizationButton, {
              label: localization.getText('COMMON_LABEL_DELETE'),
              onClick: deleteDashboard,
              keepDisplay: true,
              keys: [permissionKeys.DashboardsActionsDel]
            })
          )
        )
      )
    )
  );
};

exports.default = (0, _Izenda15.default)(_Izenda19.default)(DashboardDetailFooter);
module.exports = exports['default'];

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(73);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(119);

var _recompose = __webpack_require__(9);

var _Izenda4 = __webpack_require__(437);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(1214);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _Izenda8 = __webpack_require__(78);

var _Izenda9 = _interopRequireDefault(_Izenda8);

var _Izenda10 = __webpack_require__(31);

var _Izenda11 = _interopRequireDefault(_Izenda10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardDetailFooterActions = (0, _recompose.compose)((0, _recompose.withHandlers)({
  deleteDashboard: (0, _fp.curry)(deleteDashboard),
  openEmailPopup: (0, _fp.curry)(openEmailPopup),
  handlePrint: (0, _fp.curry)(handlePrint),
  moveDashboard: (0, _fp.curry)(moveDashboard),
  copyDashboard: (0, _fp.curry)(copyDashboard),
  subscribeDashboard: (0, _fp.curry)(subscribeDashboard)
}), (0, _recompose.setPropTypes)({
  store: _propTypes2.default.object,
  boardDetail: _propTypes2.default.object
}));

/**
 * Handle action when click delete dashboard button
 */

// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardDetailFooterActions.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
function deleteDashboard(props, e) {
  var store = props.store,
      loader = props.loader,
      subCategory = props.subCategory,
      boardDetail = props.boardDetail;

  var message = _Izenda2.default.MESSAGE.M01;

  props.confirmFn('Confirmation', {
    description: String.format(message, boardDetail.name)
  }).then(function () {
    loader.startLoading();
    return store.deleteDashboard(boardDetail.id, subCategory);
  }).then(function (result) {
    !(0, _fp.isEmpty)(result) && props.router.push(_Izenda11.default.getDashboardUrl());
  }).finally(loader.endLoading.bind(loader));
}

/**
 * Handle subscribe of dashboard.
 * @param {Object} props
 * @param {Object} e
 */
function subscribeDashboard(props, e) {
  var boardDetail = props.boardDetail || {};
  var _props$store$model = props.store.model,
      dashboard = _props$store$model.dashboardDetail.dashboard,
      dashboardDesignerMode = _props$store$model.dashboardDesignerMode;

  dashboard.id = boardDetail.id;
  dashboard.subscriptions.clear();

  dashboardDesignerMode.switchSubscribeMode(true);
}

/**
 * Open Email Popup
 */
function openEmailPopup(props, _) {
  var boardDetail = props.boardDetail,
      store = props.store;

  var handleCloseEmailPopup = function handleCloseEmailPopup(email) {
    return email && store.sendEmail(boardDetail.id, email);
  };

  props.openPopup(_Izenda5.default, {
    onClosed: handleCloseEmailPopup,
    type: _Izenda3.EMAIL_TYPE.dashboard,
    dashboardId: boardDetail.id
  });
}

/**
 * Print Report
 */
function handlePrint(props, e) {
  var id = props.boardDetail.id;

  var url = _Izenda11.default.getViewerUrl('Dashboard', { id: id });

  _Izenda9.default.openNewTab(_Izenda11.default.makeAbsoluteUrl(url, 'print=true'));
}

/**
 * Handle when click move button
 */
function moveDashboard(props, e) {
  openActionPopup(props, _Izenda2.default.MOVE_KEY);
}

/**
 * Handle when click copy button
 */
function copyDashboard(props, e) {
  openActionPopup(props, _Izenda2.default.COPY_KEY);
}

/**
 * Open Action Popup
 */
function openActionPopup(props, action) {
  var store = props.store,
      _props$boardDetail = props.boardDetail,
      boardDetail = _props$boardDetail === undefined ? {} : _props$boardDetail,
      loader = props.loader,
      authorization = props.authorization,
      authorizationConstants = props.authorizationConstants;

  var model = store.model;

  /**
   * Get action function base on move or copy
   * @param  {Object} data dashboard data
   * @return {Object}      Promise
   */
  var getActionFunc = function getActionFunc(data) {
    var functionCall = action === _Izenda2.default.COPY_KEY ? store.copyDashboard : store.moveDashboard;
    return functionCall.bind(store)(data);
  };

  var permissionKeys = authorizationConstants.PERMISSION_KEY;

  props.openPopup(_Izenda7.default, {
    action: action,
    actionFunc: getActionFunc,
    dashboard: boardDetail,
    getCategoriesFunc: store.lazyLoadCategories,
    getSubcategoriesFunc: store.lazyLoadSubCategories,
    popupConfig: _Izenda2.default.SAVE_POPUP_CONFIG,
    hasCanCreateNewCategoryPrivilege: authorization.checkPrivileges([permissionKeys.DashboardsCanCreateNewCategoryValue])
  }).then(function (message) {
    return props.confirmMessage('info', message);
  }).then(function () {
    loader.startLoading();
    // reload dashboards panel
    // reload category left panel
    return (0, _bluebird.all)([store.lazyLoadingDashboards(store.selectedCategoryId, true), store.loadLazyLoadingCategories(true)]);
  }).then(function () {
    model.items.isEmpty && props.router.push(_Izenda11.default.getDashboardUrl());
  }).finally(loader.endLoading.bind(loader));
}

exports.default = DashboardDetailFooterActions;
module.exports = exports['default'];

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _descriptor;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerToolbar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(42);

var _Izenda2 = __webpack_require__(73);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(119);

var _Izenda5 = __webpack_require__(45);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(15);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _mobx = __webpack_require__(5);

var _Izenda9 = __webpack_require__(2710);

var _Izenda10 = __webpack_require__(2711);

var _Izenda11 = __webpack_require__(2712);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _Izenda13 = __webpack_require__(437);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(233);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(30);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(2713);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(634);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(1214);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(2715);

var _Izenda26 = _interopRequireDefault(_Izenda25);

var _Izenda27 = __webpack_require__(2);

var _Izenda28 = _interopRequireDefault(_Izenda27);

var _Izenda29 = __webpack_require__(78);

var _Izenda30 = _interopRequireDefault(_Izenda29);

var _Izenda31 = __webpack_require__(31);

var _Izenda32 = _interopRequireDefault(_Izenda31);

var _Izenda33 = __webpack_require__(1213);

var _Izenda34 = _interopRequireDefault(_Izenda33);

var _Izenda35 = __webpack_require__(2717);

var _Izenda36 = _interopRequireDefault(_Izenda35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ToggleButton = (0, _Izenda28.default)()(function (props) {
  var buttonStatus = props.store.dashboardDesignerMode,
      label = props.label;

  var isActive = props.checkActive(buttonStatus);
  var isDisabled = props.checkDisable(buttonStatus);

  return _react2.default.createElement(_Izenda18.default, {
    className: (0, _classnames2.default)({ 'izenda-Button_active': isActive }),
    disabled: isDisabled,
    label: label,
    onClick: props.toggleAction
  });
});

var CancelButton = (0, _Izenda28.default)()(function (props) {
  var store = props.store,
      localization = props.localization;


  var cancelDashboard = function cancelDashboard() {
    var loader = props.loader;


    loader.startLoading();

    return props.confirmDirtyForm(store.isDirty).then(store.cancelDashboard.bind(store)).finally(loader.endLoading.bind(loader));
  };

  return _react2.default.createElement(_Izenda18.default, { label: localization.getText('COMMON_LABEL_CANCEL'), onClick: cancelDashboard });
});

var PresentationButton = (0, _Izenda28.default)()(function (props) {
  var _props$store = props.store,
      buttonStatus = _props$store.dashboardDesignerMode,
      dashboard = _props$store.dashboardDetail.dashboard,
      localization = props.localization;

  var isEnabled = !(0, _fp.isEmpty)(dashboard.activeDashboardParts);

  // Presentation class name.
  var preClassName = (0, _classnames2.default)('btn btn-primary', {
    'izenda-Button_active': buttonStatus.isPresentation
  });

  return _react2.default.createElement(
    _Izenda18.default,
    {
      className: preClassName,
      title: localization.getText('DASHBOARD_LABEL_PRESENTATION_MODE'),
      onClick: buttonStatus.togglePresentation.bind(buttonStatus),
      disabled: buttonStatus.isDisabledPresentationButton || !isEnabled
    },
    _react2.default.createElement('i', { className: 'icon-slideshow' })
  );
});

var CloseButton = (0, _Izenda28.default)()(function (props) {
  var store = props.store,
      buttonStatus = props.store.dashboardDesignerMode,
      localization = props.localization,
      location = props.location,
      router = props.router;


  if (buttonStatus.isDisabledCloseButton) {
    return _react2.default.createElement(_Izenda18.default, { 'aria-label': 'Close', disabled: true, label: localization.getText('COMMON_LABEL_CLOSE') });
  }

  if ((0, _fp.get)('state.fromList', location)) {
    return _react2.default.createElement(
      _Izenda18.default,
      {
        className: 'btn btn-primary',
        onClick: router.goBack.bind(router),
        disabled: buttonStatus.isDisabledCloseButton,
        'aria-label': 'Close'
      },
      localization.getText('COMMON_LABEL_CLOSE')
    );
  }

  if (String.isGuidFormat((0, _fp.get)('dashboardDetail.dashboard.id', store))) {
    var dashboardDetail = (0, _fp.getOr)({}, 'dashboardDetail.dashboard', store);
    var categoryId = null;

    var assignCategoryId = function assignCategoryId(catId) {
      String.isGuidFormat(catId) && catId !== _Izenda3.default.EMPTY_GUID && (categoryId = catId);
    };

    assignCategoryId(dashboardDetail.categoryId);
    assignCategoryId(dashboardDetail.subCategoryId);

    return _react2.default.createElement(
      _reactRouter.Link,
      {
        to: _Izenda32.default.getDashboardUrl('List', { catId: categoryId }),
        className: 'btn btn-primary',
        disabled: buttonStatus.isDisabledCloseButton,
        'aria-label': 'Close'
      },
      localization.getText('COMMON_LABEL_CLOSE')
    );
  }
  return _react2.default.createElement(
    _reactRouter.Link,
    {
      to: _Izenda32.default.getDashboardUrl(),
      className: 'btn btn-primary',
      disabled: buttonStatus.isDisabledCloseButton,
      'aria-label': 'Close'
    },
    localization.getText('COMMON_LABEL_CLOSE')
  );
});

/**
 * save dashboard popup
 */
var SaveDashboardPopup = (0, _Izenda28.default)()(function (props) {
  var clonedModel = props.clonedModel,
      _props$clonedModel = props.clonedModel,
      dashboardDetail = _props$clonedModel.dashboardDetail,
      _props$clonedModel$da = _props$clonedModel.dashboardDetail,
      _props$clonedModel$da2 = _props$clonedModel$da.dashboard,
      reportName = _props$clonedModel$da2.name,
      isGlobal = _props$clonedModel$da2.isGlobal,
      categoryId = _props$clonedModel$da2.categoryId,
      categoryName = _props$clonedModel$da2.categoryName,
      subCategoryId = _props$clonedModel$da2.subCategoryId,
      subCategoryName = _props$clonedModel$da2.subCategoryName,
      saveAs = _props$clonedModel$da.saveAs,
      store = props.store;


  var model = {
    reportName: reportName,
    isGlobal: isGlobal,
    categoryId: categoryId,
    categoryName: categoryName,
    subCategoryId: subCategoryId,
    subCategoryName: subCategoryName,
    saveAs: saveAs
  };

  var closeSavePopup = function closeSavePopup() {
    props.closeSavePopup();
    props.onReject();
  };

  return _react2.default.createElement(_Izenda26.default, {
    model: model,
    changeName: dashboardDetail.changeName.bind(dashboardDetail),
    changeCategoryType: dashboardDetail.changeCategoryType.bind(dashboardDetail),
    changeCategory: dashboardDetail.changeCategory.bind(dashboardDetail),
    addCategory: clonedModel.addCategory.bind(clonedModel),
    updateSubCategory: dashboardDetail.updateSubCategory.bind(dashboardDetail),
    addSubCategory: clonedModel.addSubCategory.bind(clonedModel, categoryId),
    getCategoriesFunc: store.lazyLoadCategories,
    getSubcategoriesFunc: store.lazyLoadSubCategories,
    validate: store.validateDashboardName.bind(store, dashboardDetail),
    onClose: closeSavePopup,
    save: props.saveDashboard,
    popupConfig: _Izenda3.default.SAVE_POPUP_CONFIG,
    store: store,
    isDashboard: true
  });
});

var DashboardDesignerToolbar = (_dec = (0, _Izenda28.default)(_Izenda36.default), _dec(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(DashboardDesignerToolbar, _Component);

  function DashboardDesignerToolbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DashboardDesignerToolbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DashboardDesignerToolbar.__proto__ || (0, _getPrototypeOf2.default)(DashboardDesignerToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.addDashboardTile = function () {
      var dashboardDetail = _this.props.store.dashboardDetail;
      dashboardDetail.addDashboardTile();
    }, _this.removeIntegrationMethod = function () {
      (0, _fp.invokeArgs)('unregisterExposeMethod', [['updateResults']], _this.props);
    }, _this.exposeIntegrationMethod = function (props) {
      var method = {
        updateResults: _this.updateResults
      };

      (0, _fp.invokeArgs)('registerExposeMethod', [method], props);
    }, _this.updateResults = function () {
      var props = _this.props;
      var loader = props.loader,
          store = props.store;

      var clonedModel = _this.clonedModel || {};

      loader.startLoading();

      return store.validateDashboard(clonedModel).then(function (result) {
        if (result.success) {
          return store.updateResults();
        } else {
          if (result.messages[0].detail) {
            return props.confirmFn('Information', {
              description: _Izenda3.default.validateFilterMessage(result),
              type: 'error',
              isHTMLFormat: true,
              showCloseIndicator: true
            });
          } else {
            return props.validation.updateErrors(result.messages);
          }
        }
      }).finally(loader.endLoading.bind(loader));
    }, _initDefineProp(_this, 'saveDashboard', _descriptor, _this), _this.closeSavePopup = function () {
      _this.clonedModel = null;
    }, _this.openEmailPopup = function () {
      var store = _this.props.store;
      var handleCloseEmailPopup = function handleCloseEmailPopup(email) {
        return email && store.sendEmail(store.dashboardDetail.dashboard.id, email);
      };

      _this.props.openPopup(_Izenda14.default, {
        onClosed: handleCloseEmailPopup,
        type: _Izenda4.EMAIL_TYPE.dashboard,
        dashboardId: store.dashboardDetail.dashboard.id || _Izenda3.default.EMPTY_GUID
      });
    }, _this.renderEmailControl = function (isDisabled) {
      return _react2.default.createElement(_Izenda18.default, {
        label: _this.props.localization.getText('COMMON_LABEL_EMAIL'),
        disabled: isDisabled,
        onClick: _this.openEmailPopup
      });
    }, _this.onClickBackgroundColor = function () {
      var dashboardDetail = _this.props.store.dashboardDetail;


      return _this.props.openPopup(_Izenda20.default, {
        color: (0, _fp.get)('dashboard.backgroundColor', dashboardDetail),
        onAcceptColor: dashboardDetail.setBackgroundColor.bind(dashboardDetail)
      });
    }, _this.onClickDashboardDescription = function () {
      var store = _this.props.store;
      var dashboardDetail = store.dashboardDetail || {};
      var dashboard = dashboardDetail.dashboard || {};
      var description = (0, _fp.cloneDeep)(dashboard.description);
      var CommonPopup = (0, _Izenda12.default)('DashboardDescription', _Izenda10.propTypes);

      return _this.props.openPopup(CommonPopup, {
        Content: _Izenda10.DashboardDescriptionContent,
        constants: _Izenda10.constants,
        description: description,
        save: _this.onSaveDashboardDescription
      });
    }, _this.onClickBackgroundImage = function () {
      var store = _this.props.store;
      var dashboardDetail = store.dashboardDetail || {};
      var dashboard = dashboardDetail.dashboard || {};
      var imageUrl = (0, _fp.cloneDeep)(dashboard.imageUrl);
      var stretchImage = dashboard.stretchImage;
      var CommonPopup = (0, _Izenda12.default)(_Izenda9.propTypes);

      return _this.props.openPopup(CommonPopup, {
        Content: _Izenda9.BackgroundImageContent,
        constants: _Izenda9.constants,
        imageUrl: imageUrl,
        stretchImage: stretchImage,
        save: _this.onSaveBackgroundImage,
        store: store
      });
    }, _this.buildEditDropdown = function (dom) {
      dom && $izenda(dom).dropdown();
    }, _this.renderEditControl = function (isDisabled) {
      var _this$props = _this.props,
          localization = _this$props.localization,
          authorization = _this$props.authorization,
          permissionKeys = _this$props.authorizationConstants.PERMISSION_KEY,
          store = _this$props.store,
          dashboardDetail = _this$props.store.dashboardDetail;

      var isEditMode = store.dashboardDesignerMode.isEdit;
      var showFilterDescription = (0, _fp.get)('dashboard.showFilterDescription', dashboardDetail);
      var accessPriority = dashboardDetail.dashboard.accessPriority;

      var dashboardModel = (0, _fp.getOr)({}, 'dashboard', dashboardDetail);

      var hasOverwritePrivilege = authorization.checkPrivileges([permissionKeys.DashboardsActionsOverwriteExistingDashboard]);

      var hasCopyPrivilege = authorization.checkPrivileges([permissionKeys.DashboardsCanCreateNewDashboardValue]);

      var doesShowDashboardDescriptionBtn = accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs;

      var doesShowBackgroundColorBtn = accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs;

      var doesShowBackgroundImageBtn = accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs;

      var doesShowCopyBtn = (accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs) && isEditMode && hasCopyPrivilege && dashboardModel.copyable;

      var doesShowMoveBtn = accessPriority === _Izenda.ACCESS_RIGHT.FullAccess && hasOverwritePrivilege && isEditMode && dashboardModel.movable;

      var doesShowFilterDescriptionBtn = accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs;

      return (doesShowDashboardDescriptionBtn || doesShowBackgroundColorBtn || doesShowBackgroundImageBtn || doesShowCopyBtn || doesShowMoveBtn || doesShowFilterDescriptionBtn) && _react2.default.createElement(
        'div',
        { className: 'btn-group' },
        _react2.default.createElement(
          'button',
          {
            ref: _this.buildEditDropdown,
            className: 'btn btn-primary dropdown-toggle',
            disabled: isDisabled,
            'data-toggle': 'dropdown'
          },
          localization.getText('COMMON_LABEL_EDIT'),
          '\xA0',
          _react2.default.createElement('span', { className: 'caret' })
        ),
        _react2.default.createElement(
          'ul',
          { className: 'dropdown-menu' },
          doesShowDashboardDescriptionBtn && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { onClick: _this.onClickDashboardDescription },
              localization.getText('DASHBOARD_LABEL_DASHBOARD_DESCRIPTION')
            )
          ),
          doesShowBackgroundColorBtn && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { onClick: _this.onClickBackgroundColor },
              localization.getText('DASHBOARD_LABEL_SET_BACKGROUND_COLOR')
            )
          ),
          doesShowBackgroundImageBtn && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { onClick: _this.onClickBackgroundImage },
              localization.getText('DASHBOARD_LABEL_SET_BACKGROUND_IMAGE')
            )
          ),
          doesShowCopyBtn && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { onMouseDown: _this.copyDashboard },
              localization.getText('COMMON_LABEL_COPY')
            )
          ),
          doesShowMoveBtn && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { onMouseDown: _this.moveDashboard },
              localization.getText('COMMON_LABEL_MOVE')
            )
          ),
          doesShowFilterDescriptionBtn && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { onMouseDown: dashboardDetail.toggleShowFilterDescription.bind(dashboardDetail) },
              showFilterDescription ? localization.getText('COMMON_LABEL_HIDE') : localization.getText('COMMON_LABEL_SHOW'),
              ' ',
              localization.getText('DASHBOARD_MESSAGE_FILTER_DESCIPTIONS_ON_TILE')
            )
          )
        )
      );
    }, _this.getActionFunc = function (action, data) {
      var _this$props2 = _this.props,
          store = _this$props2.store,
          _this$props2$store = _this$props2.store,
          copyDashboard = _this$props2$store.copyDashboard,
          moveDashboard = _this$props2$store.moveDashboard;

      var functionCall = action === _Izenda3.default.COPY_KEY ? copyDashboard : moveDashboard;

      return functionCall.bind(store)(data);
    }, _this.openPopup = function (action) {
      var props = _this.props;
      var store = props.store,
          authorization = props.authorization,
          permissionKeys = props.authorizationConstants.PERMISSION_KEY,
          model = props.store.model;

      var boardDetail = model.dashboardDetail.dashboard || {};
      var dashboard = {
        name: boardDetail.name,
        id: boardDetail.id,
        isGlobal: boardDetail.isGlobal
      };

      props.openPopup(_Izenda24.default, {
        dashboard: dashboard,
        popupConfig: _Izenda3.default.SAVE_POPUP_CONFIG,
        action: action,
        actionFunc: _this.getActionFunc.bind(_this, action),
        getCategoriesFunc: store.lazyLoadCategories,
        getSubcategoriesFunc: store.lazyLoadSubCategories,
        hasCanCreateNewCategoryPrivilege: authorization.checkPrivileges([permissionKeys.DashboardsCanCreateNewCategoryValue])
      }).then(function (message) {
        return props.confirmMessage('info', message);
      });
    }, _this.copyDashboard = function () {
      _this.openPopup(_Izenda3.default.COPY_KEY);
    }, _this.moveDashboard = function () {
      _this.openPopup(_Izenda3.default.MOVE_KEY);
    }, _this.onSaveDashboardDescription = function (value) {
      var dashboardDetail = (0, _fp.getOr)({}, 'dashboardDetail', _this.props.store);

      dashboardDetail.setDescription(value);
    }, _this.onSaveBackgroundImage = function (imageUrl, stretchImage) {
      var dashboardDetail = (0, _fp.getOr)({}, 'dashboardDetail', _this.props.store);

      dashboardDetail.setBackgroundImage(imageUrl, stretchImage);
    }, _this.handlePrint = function () {
      var _this$props3 = _this.props,
          store = _this$props3.store,
          dashboardId = _this$props3.store.model.dashboardDetail.dashboard.id;


      store.saveDraftDataForPrint().then(function (draftId) {
        var url = _Izenda32.default.getViewerUrl('Dashboard', { id: dashboardId });

        _Izenda30.default.openNewTab(_Izenda32.default.makeAbsoluteUrl(url, 'print=true&draftId=' + draftId));
        return null;
      });
    }, _this.onClickAccess = function () {
      var _this$props4 = _this.props,
          store = _this$props4.store,
          buttonStatus = _this$props4.store.dashboardDesignerMode,
          validation = _this$props4.validation;


      if (buttonStatus.isAccess) {
        validation.validate().then(function (result) {
          if (result) {
            store.validateAccesses().then(function (result) {
              if (result.success) {
                buttonStatus.toggleAccess();
              } else {
                validation.updateErrors(result.messages);
              }
            });
          }
        });
      } else {
        buttonStatus.toggleAccess();
        store.initAccess();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DashboardDesignerToolbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.exposeIntegrationMethod(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.registerExposeMethod !== nextProps) {
        this.removeIntegrationMethod();
        this.exposeIntegrationMethod(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeIntegrationMethod();
    }

    /**
     * Update result
     */


    /**
     * Save dashboard
     */


    /**
     * Close save popup
     */

  }, {
    key: 'renderSaveControl',


    /**
     * render save control
     */
    value: function renderSaveControl() {
      var _this2 = this;

      var onClickSave = function onClickSave(saveAs) {
        var props = _this2.props;
        var _props = _this2.props,
            validation = _props.validation,
            store = _props.store;

        validation.validate().then(function (result) {
          if (result) {
            store.validateAccesses().then(function (result) {
              if (result.success) {
                var canSave = saveAs ? hasSaveAsPrivilege : hasSavePrivilege;
                _this2.clonedModel = store.model.clone(saveAs);

                canSave && props.openPopup(SaveDashboardPopup, {
                  clonedModel: _this2.clonedModel,
                  closeSavePopup: _this2.closeSavePopup,
                  saveDashboard: _this2.saveDashboard,
                  store: store,
                  save: _this2.saveDashboard
                });
              } else {
                validation.updateErrors(result.messages);
              }
            });
          }
        });
      };

      var _props2 = this.props,
          authorization = _props2.authorization,
          permissionKeys = _props2.authorizationConstants.PERMISSION_KEY,
          newDashboard = _props2.newDashboard,
          localization = _props2.localization,
          store = _props2.store;

      var hasSavePrivilege = newDashboard || authorization.checkPrivileges([permissionKeys.DashboardsActionsOverwriteExistingDashboard]);

      var hasSaveAsPrivilege = authorization.checkPrivileges([permissionKeys.DashboardsCanCreateNewDashboardValue]);

      var accessPriority = store.dashboardDetail.dashboard.accessPriority;
      var isSystemAdmin = _Izenda8.default.currentUser.systemAdmin;
      var isSystemLevel = (0, _fp.isNil)(_Izenda8.default.tenantId);
      var boardDetail = (0, _fp.getOr)({}, 'dashboard', store.model.dashboardDetail);

      var doesShowSaveBtn = hasSavePrivilege && accessPriority === _Izenda.ACCESS_RIGHT.FullAccess && !(boardDetail.isGlobal && !isSystemAdmin) && !(boardDetail.isGlobal && !isSystemLevel);

      var doesShowSaveAsBtn = hasSaveAsPrivilege && (accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs);

      if (store.dashboardDesignerMode.isEdit) {
        return (doesShowSaveBtn || doesShowSaveAsBtn) && _react2.default.createElement(
          'div',
          { className: 'btn-group' },
          _react2.default.createElement(
            'button',
            {
              ref: function ref(dom) {
                dom && $izenda(dom).dropdown();
              },
              className: 'btn btn-primary dropdown-toggle',
              'data-toggle': 'dropdown'
            },
            localization.getText('COMMON_LABEL_SAVE'),
            '\xA0',
            _react2.default.createElement('span', { className: 'caret' })
          ),
          _react2.default.createElement(
            'ul',
            { className: 'dropdown-menu' },
            doesShowSaveBtn && _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { onClick: this.saveDashboard },
                localization.getText('COMMON_LABEL_SAVE')
              )
            ),
            doesShowSaveAsBtn && _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { onClick: onClickSave.bind(this, true) },
                localization.getText('COMMON_LABEL_SAVE_AS')
              )
            )
          )
        );
      }

      return hasSavePrivilege && _react2.default.createElement(_Izenda18.default, {
        label: _Izenda3.default.TOOLBAR_CONTROL[4].label,
        onClick: onClickSave.bind(this, false),
        keepDisplay: true
      });
    }

    /**
     * Open Email Popup
     */


    /**
     * render email control
     */


    /**
     * on click background Color button
     */


    /**
     * handle click on dashboard description.
     */


    /**
     * handle click on Set Background Image.
     */


    /**
     * Build edit dropdown element
     */


    /**
     * render edit control
     * @param  {boolean} isDisabled
     */


    /**
     * Get action function base on move or copy2
     * @param  {string} action
     * @param  {Object} data dashboard data
     */


    /**
     * Open popup
     * @param  {int} action type
     */


    /**
     * Handle when click copy button
     */


    /**
     * Handle when click move button
     */


    /**
     * Handle save dashboard description.
     * @param {String} value
     */


    /**
     * Handle save background image.
     * @param {String} imageUrl
     * @param {Boolean} stretchImage
     */


    /**
     * Handle Print
     */


    /**
     * Handle when click access button
     */

  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var localization = props.localization,
          authorization = props.authorization,
          permissionKeys = props.authorizationConstants.PERMISSION_KEY,
          store = props.store,
          id = props.id,
          buttonStatus = props.store.dashboardDesignerMode;

      var name = (0, _fp.getOr)('', 'dashboardDetail.dashboard.name', store);
      var isAccess = buttonStatus.isAccess;
      var isSchedule = buttonStatus.isSchedule;
      var isSubscribe = buttonStatus.isSubscribe;
      var isAccessOrScheduleOrSubscribe = isAccess || isSchedule || isSubscribe;
      var hasSchedulePrivilege = authorization.checkPrivileges([permissionKeys.DashboardsActionsSchedule]);
      var hasSubscribePrivilege = authorization.checkPrivileges([permissionKeys.DashboardsActionsSubscribe]);
      var hasAccessPrivilege = authorization.checkPrivileges([permissionKeys.DashboardsActionsConfigureAccessRights]);
      var hasEmailPrivilege = authorization.checkPrivileges([permissionKeys.DashboardsActionsEmail]);
      var hasPrintPrivilege = authorization.checkPrivileges([permissionKeys.DashboardsActionsPrint]);
      var hasExportPrivilege = authorization.checkPrivileges([permissionKeys.DashboardsActionsExporting]);
      var accessPriority = store.dashboardDetail.dashboard.accessPriority;
      var hasScheduleLicense = authorization.checkLicense(_Izenda6.default.LICENSE_KEY.Scheduling);
      var hasExportLicense = authorization.checkLicense(_Izenda6.default.LICENSE_KEY.Exporting);
      var restProps = (0, _fp.omit)(['registerExposeMethod', 'unregisterExposeMethod', 'integrationStyle'], props);

      if ((0, _fp.get)('integrationStyle.hideDashboardToolbar', props)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'u_controlHeight u_marginBottom u_clearFix' },
        _react2.default.createElement(
          'div',
          { className: 'izenda-ActionBarRight' },
          _react2.default.createElement(
            _Izenda16.default,
            null,
            _react2.default.createElement(PresentationButton, restProps),
            hasAccessPrivilege && (accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs) && _react2.default.createElement(ToggleButton, (0, _extends3.default)({}, restProps, {
              label: _Izenda3.default.TOOLBAR_CONTROL[1].label,
              checkActive: (0, _fp.get)('isAccess'),
              checkDisable: (0, _fp.get)('isDisabledAcessButton'),
              toggleAction: this.onClickAccess
            })),
            hasSubscribePrivilege && ((accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs) && !hasSchedulePrivilege || accessPriority === _Izenda.ACCESS_RIGHT.Locked || accessPriority === _Izenda.ACCESS_RIGHT.ViewOnly) && _react2.default.createElement(ToggleButton, (0, _extends3.default)({}, restProps, {
              label: _Izenda3.default.TOOLBAR_CONTROL[2].label,
              checkActive: (0, _fp.get)('isSubscribe'),
              checkDisable: (0, _fp.get)('isDisabledSubscribeButton'),
              toggleAction: buttonStatus.toggleSubscribe.bind(buttonStatus)
            })),
            hasSchedulePrivilege && hasScheduleLicense && (accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs) && !store.dashboardDetail.dashboard.isGlobal && _react2.default.createElement(ToggleButton, (0, _extends3.default)({}, restProps, {
              label: _Izenda3.default.TOOLBAR_CONTROL[3].label,
              checkActive: (0, _fp.get)('isSchedule'),
              checkDisable: (0, _fp.get)('isDisabledScheduleButton'),
              toggleAction: buttonStatus.toggleSchedule.bind(buttonStatus)
            })),
            this.renderEditControl(isAccessOrScheduleOrSubscribe),
            hasExportLicense && hasPrintPrivilege && _react2.default.createElement(_Izenda34.default, {
              disabled: isAccessOrScheduleOrSubscribe,
              id: id,
              name: name,
              store: store,
              isDesignerMode: true,
              'export': store.printDashboard
            }),
            hasExportLicense && hasExportPrivilege && _react2.default.createElement(_Izenda22.default, {
              id: id,
              isDashboard: true,
              name: name,
              store: store,
              isDesignerMode: true,
              'export': store.exportDashboard
            }),
            hasEmailPrivilege && this.renderEmailControl(isAccessOrScheduleOrSubscribe),
            (accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs || accessPriority === _Izenda.ACCESS_RIGHT.ViewOnly) && _react2.default.createElement(_Izenda18.default, {
              label: localization.getText('DASHBOARD_LABEL_UPDATE_RESULTS'),
              disabled: isAccessOrScheduleOrSubscribe,
              onClick: this.updateResults,
              className: 'btn-success'
            }),
            (accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs) && _react2.default.createElement(_Izenda18.default, {
              label: localization.getText('DASHBOARD_LABEL_ADD_DASHBOARD_TILE'),
              disabled: isAccessOrScheduleOrSubscribe,
              onClick: this.addDashboardTile,
              className: 'btn-success'
            }),
            this.renderSaveControl(),
            (accessPriority === _Izenda.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda.ACCESS_RIGHT.SaveAs) && _react2.default.createElement(CancelButton, (0, _extends3.default)({}, restProps, { keepDisplay: true })),
            _react2.default.createElement(CloseButton, restProps)
          )
        )
      );
    }
  }]);
  return DashboardDesignerToolbar;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'saveDashboard', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function () {
      var props = _this3.props;
      var localization = props.localization,
          loader = props.loader,
          store = props.store,
          validation = props.validation,
          router = props.router;

      var clonedModel = _this3.clonedModel || {};
      var dashboardDetail = clonedModel.dashboardDetail || {};

      var saveDashboard = function saveDashboard() {
        return validation.validate().then(function (success) {
          if (success) {
            loader.startLoading();
            return store.validateDashboard(clonedModel).then(function (result) {
              if (result.success) {
                return store.saveDashboard(clonedModel).then(function (saveResult) {
                  var errorMessage = (0, _fp.get)('messages', saveResult);

                  if (errorMessage) {
                    return props.confirmMessage('info', errorMessage[0].messages[0]);
                  } else if (saveResult.success) {
                    // Reset alert message
                    store.dashboardDesignerMode.resetAlertDetails();

                    var newLocationId = (0, _fp.get)('dashboard.id', saveResult);
                    var oldLocationId = (0, _fp.get)('location.query.id', saveResult);

                    newLocationId !== oldLocationId && router.push({
                      pathname: _Izenda32.default.getDashboardUrl('Edit', {
                        id: newLocationId
                      }),
                      state: {
                        keepState: true
                      }
                    });
                  }

                  return saveResult;
                });
              }
              if (result.messages[0].detail) {
                return props.confirmFn('Information', {
                  description: _Izenda3.default.validateFilterMessage(result),
                  type: 'error',
                  isHTMLFormat: true,
                  showCloseIndicator: true
                });
              } else {
                validation.updateErrors(result.messages);
              }
              return result.success;
            }).finally(loader.endLoading.bind(loader)).return(success);
          }

          return success;
        });
      };

      var savingConfirm = function savingConfirm() {
        return props.confirmFn('Confirmation', {
          description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
        }).then(saveDashboard);
      };

      if (!store.isDirty && !dashboardDetail.saveAs) {
        store.dashboardDesignerMode.setAlertDetails({
          success: true,
          message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
        });
      } else {
        var dashboardModel = !dashboardDetail.saveAs ? store.model : _this3.clonedModel;
        if (dashboardModel.dashboardDetail.dashboard.isGlobal) {
          var dashboardDefinition = dashboardModel.dashboardDetail.getDashboardDefinition();
          return store.validateGlobalDashboard(dashboardDefinition).then(function (response) {
            if (response.success) {
              return savingConfirm();
            } else {
              return props.confirmFn('Error', {
                description: response.messages[0].messages[0],
                showCancel: false
              });
            }
          });
        }
        return savingConfirm();
      }
    };
  }
})), _class2)) || _class);
exports.default = DashboardDesignerToolbar;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.BackgroundImageContent.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var GridLayout = __webpack_require__(13);
  var Input = __webpack_require__(17);
  var Validator = __webpack_require__(23);
  var ValidatableInput = Validator()(Input);
  var EventsUtils = __webpack_require__(24);
  var dashboardConstants = __webpack_require__(73);

  var _require = __webpack_require__(1),
      cloneDeep = _require.cloneDeep;

  var propTypes = {
    save: React.PropTypes.func,
    close: React.PropTypes.func,
    imageUrl: React.PropTypes.string,
    stretchImage: React.PropTypes.bool,
    store: React.PropTypes.object.isRequired
  };

  var BackgroundImageContent = React.createClass({
    displayName: 'BackgroundImageContent',

    propTypes: propTypes,

    getInitialState: function getInitialState() {
      return this.populateSate(this.props);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      this.setState(this.populateSate(nextProps));
    },

    /**
     * Build state information.
     * @param {Object} props
     * @return {Object}
     */
    populateSate: function populateSate(props) {
      var imageUrl = props.imageUrl || '';
      var stretchImage = props.stretchImage;

      return {
        imageUrl: imageUrl,
        stretchImage: stretchImage,
        originalUrl: cloneDeep(imageUrl),
        originalStretchImage: stretchImage
      };
    },

    onClosing: function onClosing(type) {
      var props = this.props;

      if (type === 'cancel') {
        return props.onReject();
      }

      var state = this.state;
      var imageUrl = state.imageUrl;
      var originalUrl = state.originalUrl;
      var stretchImage = state.stretchImage;
      var originalStretchImage = state.originalStretchImage;

      if (imageUrl !== originalUrl || stretchImage !== originalStretchImage) {
        return props.validation.validate('backgroundImage').then(function (success) {
          if (success) {
            props.save(imageUrl, stretchImage);
            props.onAccept();
          }
        });
      }
      return props.onAccept();
    },

    /**
     * Handle change value of image url control.
     * @param {String} type
     */
    onChangeImageUrl: function onChangeImageUrl(value) {
      this.setState({
        imageUrl: value
      });
    },

    /**
     * Handle change value of stretch image control.
     * @param {String} type
     */
    onChangeStretchImage: function onChangeStretchImage(value) {
      this.setState({
        stretchImage: value
      });
    },

    /**
     * Render body of popup.
     * @param {Object}
     */
    render: function render() {
      var state = this.state;
      var store = this.props.store;
      var constants = dashboardConstants.BACKGROUND_IMAGE;

      var backgroundImageValidation = {
        action: function action() {
          return store.validateImageUrl.bind(store, state.imageUrl);
        }
      };

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(
              'span',
              null,
              constants.IMAGE_URL_LABEL
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 10 },
            React.createElement(ValidatableInput, {
              field: 'backgroundImage',
              className: 'form-control',
              validations: backgroundImageValidation,
              value: state.imageUrl,
              onChange: EventsUtils.notifyChange(this.onChangeImageUrl, EventsUtils.INPUT)
            })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 2 },
            React.createElement(
              'span',
              null,
              constants.STRETCH_IMAGE_LABEL
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: 10 },
            React.createElement('input', {
              type: 'checkbox',
              checked: state.stretchImage,
              onChange: EventsUtils.notifyChange(this.onChangeStretchImage, EventsUtils.CHECKBOX)
            })
          )
        )
      );
    }
  });

  module.exports = {
    BackgroundImageContent: BackgroundImageContent,
    propTypes: propTypes,
    constants: dashboardConstants.BACKGROUND_IMAGE
  };
}();

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDescriptionContent.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var GridLayout = __webpack_require__(13);
  var EventsUtils = __webpack_require__(24);

  var dashboardConstants = __webpack_require__(73);
  var propTypes = {
    save: React.PropTypes.func,
    description: React.PropTypes.string
  };

  var _require = __webpack_require__(1),
      cloneDeep = _require.cloneDeep;

  var DashboardDescriptionContent = React.createClass({
    displayName: 'DashboardDescriptionContent',

    propTypes: propTypes,

    getInitialState: function getInitialState() {
      return this.populateSate(this.props);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var newState = this.populateSate(nextProps);
      this.setState(newState);
    },

    /**
     * Build state information.
     * @param {Object} props
     * @return {Object}
     */
    populateSate: function populateSate(props) {
      var description = props.description || '';
      return {
        description: description,
        originalDesc: cloneDeep(description)
      };
    },

    /**
     * Handle close popup.
     * @param {String} type
     */
    onClosing: function onClosing(type) {
      var props = this.props;
      if (type === 'cancel') {
        return props.onReject();
      }

      var state = this.state;
      var description = state.description;
      var originalDesc = state.originalDesc;

      if (type === 'accept') {
        description !== originalDesc && props.save(description);
        return props.onAccept();
      }
    },

    /**
     * Handle change value of description control.
     * @param {String} type
     */
    onChangeDescription: function onChangeDescription(value) {
      this.setState({
        description: value
      });
    },

    /**
     * Render body of popup.
     * @param {Object}
     */
    render: function render() {
      var state = this.state;

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 12 },
            React.createElement(
              'span',
              null,
              dashboardConstants.DESCRIPTION.DESCRIPTION_LABEL
            )
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: 12 },
            React.createElement('textarea', {
              className: 'form-control',
              rows: '3',
              value: state.description,
              onChange: EventsUtils.notifyChange(this.onChangeDescription, EventsUtils.INPUT)
            })
          )
        )
      );
    }
  });

  module.exports = {
    DashboardDescriptionContent: DashboardDescriptionContent,
    propTypes: propTypes,
    constants: dashboardConstants.DESCRIPTION
  };
}();

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonDashboardPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var Popup = __webpack_require__(36);
  var connect = __webpack_require__(2);

  var _require = __webpack_require__(1),
      assign = _require.assign,
      omit = _require.omit;

  module.exports = function (displayName, propTypes) {
    return connect()(React.createClass({
      displayName: displayName,
      propTypes: assign({
        Content: React.PropTypes.func,
        constants: React.PropTypes.object
      }, propTypes),

      /**
       * Handle close popup.
       * @param {Object} cb: callback function
       * @param {String} type
       */
      onClosing: function onClosing(cb, type) {
        var props = this.props;
        var content = this.refs.content;
        content.onClosing && content.onClosing(type);
      },

      render: function render() {
        var props = this.props;
        var Content = props.Content;
        var contentPros = omit(['Content', 'constants'], props);
        var localization = props.localization;

        return React.createElement(
          Popup,
          { visible: true, onClosing: this.onClosing, type: 'none', autoClose: false, sizeClass: 'modal-lg' },
          React.createElement(Popup.Header, { title: props.constants.TITLE }),
          React.createElement(
            Popup.Body,
            null,
            React.createElement(Content, (0, _extends3.default)({ ref: 'content' }, contentPros))
          ),
          React.createElement(
            Popup.Footer,
            null,
            React.createElement(
              Popup.ConfirmationButton,
              { type: 'accept' },
              localization.getText('COMMON_LABEL_OK')
            ),
            React.createElement(
              Popup.ConfirmationButton,
              { type: 'cancel' },
              localization.getText('COMMON_LABEL_CANCEL')
            )
          )
        );
      }
    }));
  };
}();

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPickerPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Color Picker component
 */
!function () {
  var React = __webpack_require__(0);

  var ColorDialog = __webpack_require__(932);
  var Popup = __webpack_require__(36);
  var connect = __webpack_require__(2);
  var action = __webpack_require__(2714);

  var ColorPickerPopup = function ColorPickerPopup(props) {
    return React.createElement(
      Popup,
      {
        visible: true,
        sizeClass: 'izenda-ColorPickerPopup',
        type: 'none' },
      React.createElement(
        Popup.Body,
        { className: 'u_noPaddingAll' },
        React.createElement(ColorDialog, {
          color: props.selectedColor,
          onAccept: props.handleAccept,
          onCancel: props.hideColorPicker,
          onChange: props.handleOnChange })
      )
    );
  };

  module.exports = connect(action)(ColorPickerPopup);
}();

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPickerPopupAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Color Picker component
 */
!function () {
  var React = __webpack_require__(0);
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withState = __webpack_require__(9).withState;
  var onlyUpdateForPropTypes = __webpack_require__(9).onlyUpdateForPropTypes;
  var setPropTypes = __webpack_require__(9).setPropTypes;

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var ColorPickerPopupAction = compose(withState('selectedColor', 'setColor', function (props) {
    return props.color;
  }), withHandlers({
    handleOnChange: curry(function (props, color) {
      props.setColor(color.hex);
    }),
    handleAccept: function handleAccept(props) {
      return function () {
        props.onAcceptColor(props.selectedColor);
        props.onAccept();
      };
    },
    hideColorPicker: function hideColorPicker(props) {
      return props.onReject;
    }
  }), onlyUpdateForPropTypes, setPropTypes({
    onAcceptColor: React.PropTypes.func.isRequired,
    onAccept: React.PropTypes.func.isRequired,
    onReject: React.PropTypes.func.isRequired,
    color: React.PropTypes.string
  }));

  module.exports = ColorPickerPopupAction;
}();

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.SavePopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(36);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(47);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(71);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(16);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(73);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(23);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(17);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(15);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(2716);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(104);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatorInput = (0, _Izenda16.default)()(_Izenda18.default);

var SavePopup = (_dec = (0, _Izenda2.default)(_Izenda22.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SavePopup, _Component);

  function SavePopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SavePopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SavePopup.__proto__ || (0, _getPrototypeOf2.default)(SavePopup)).call.apply(_ref, [this].concat(args))), _this), _this.getSaveInCategory = function (isGlobal, localGlobalCategories) {
      return (0, _fp.flow)((0, _fp.filter)({ isGlobal: isGlobal }), _fp.head)(localGlobalCategories);
    }, _this.getSelectedCategory = function (model) {
      return (0, _fp.isNil)(model.categoryId) ? null : { id: model.categoryId, name: model.categoryName };
    }, _this.getSelectedSubCategory = function (model) {
      return (0, _fp.isNil)(model.subCategoryId) ? null : { id: model.subCategoryId, name: model.subCategoryName };
    }, _this.changeReportName = function (event) {
      _this.props.changeNameHandler(event.target.value);
    }, _this.doesShowSaveInto = function () {
      return (0, _fp.isNil)(_Izenda20.default.tenantId) && !!_Izenda20.default.currentUser.systemAdmin;
    }, _this.renderContainer = function () {
      var props = _this.props;
      var model = props.model,
          componentState = props.componentState,
          authorization = props.authorization,
          PERMISSION_KEY = props.authorizationConstants.PERMISSION_KEY,
          localization = props.localization,
          popupConfig = props.popupConfig,
          changeSaveInHandler = props.changeSaveInHandler,
          changeCategoryHandler = props.changeCategoryHandler,
          getCategories = props.getCategories,
          searchCategoryDataHandler = props.searchCategoryDataHandler,
          resetCategory = props.resetCategory,
          changeSubCategoryHandler = props.changeSubCategoryHandler,
          getSubCategories = props.getSubCategories,
          searchSubCategoryDataHandler = props.searchSubCategoryDataHandler,
          resetSubCategory = props.resetSubCategory,
          isDashboard = props.isDashboard;

      // process to create temp category type id

      var selectedSaveInto = (0, _fp.get)('id', _this.getSaveInCategory(model.isGlobal, componentState.localGlobalCategories));
      var hasPrivilege = authorization.checkPrivileges([PERMISSION_KEY.DashboardsCanCreateNewCategoryValue]);

      var selectedCategory = _this.getSelectedCategory(model);
      var selectedSubCategory = _this.getSelectedSubCategory(model);

      var selectCategoryHint = localization.getText('REPORTDESIGNER_MESSAGE_HINT_CATEGORY');
      var selectSubCategoryHint = localization.getText('REPORTDESIGNER_MESSAGE_HINT_SUB_CATEGORY');
      var addNewCategory = props.addNewCategoryHandler;
      var addNewSubCategory = props.addNewSubCategoryHandler;
      if (!hasPrivilege) {
        addNewCategory = function addNewCategory() {
          return false;
        };
        selectCategoryHint = null;
        addNewSubCategory = function addNewSubCategory() {
          return false;
        };
        selectSubCategoryHint = null;
      }

      var reportNameVals = (0, _fp.merge)(_Izenda12.default.CONSTRAINTS.REPORT_NAME, {
        action: function action() {
          return props.validate;
        }
      }, {});

      var nameValidation = isDashboard ? _Izenda14.default.CONSTRAINTS.NAME : reportNameVals;

      return _react2.default.createElement(
        _Izenda4.default,
        { className: 'form-horizontal' },
        _react2.default.createElement(
          _Izenda4.default.Row,
          null,
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '3' },
            _react2.default.createElement(
              _Izenda10.default,
              { className: 'control-label' },
              popupConfig.DASHBOARD_NAME
            )
          ),
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '9' },
            _react2.default.createElement(ValidatorInput, {
              value: model.reportName,
              className: 'form-control',
              onChange: _this.changeReportName,
              validations: nameValidation,
              field: 'reportName',
              type: 'text',
              name: 'reportName'
            })
          )
        ),
        _this.doesShowSaveInto() && _react2.default.createElement(
          _Izenda4.default.Row,
          null,
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '3' },
            _react2.default.createElement(
              _Izenda10.default,
              { className: 'control-label' },
              popupConfig.SAVEINTO
            )
          ),
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '9' },
            _react2.default.createElement(_Izenda8.default, {
              options: componentState.localGlobalCategories,
              labelKey: 'name',
              valueKey: 'id',
              value: selectedSaveInto,
              onChange: changeSaveInHandler,
              scalable: false,
              textboxMode: false
            })
          )
        ),
        _react2.default.createElement(
          _Izenda4.default.Row,
          null,
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '3' },
            _react2.default.createElement(
              _Izenda10.default,
              { className: 'control-label' },
              popupConfig.CATEGORY
            )
          ),
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '9' },
            _react2.default.createElement(_Izenda8.default, {
              simpleValue: true,
              options: componentState.categories,
              labelKey: 'name',
              valueKey: 'id',
              value: selectedCategory,
              noResultsText: selectCategoryHint,
              onChange: changeCategoryHandler,
              onAddNew: addNewCategory,
              scalable: false,
              isLazyLoading: true,
              getData: getCategories,
              onSearchLazy: searchCategoryDataHandler,
              onCloseMenu: resetCategory,
              isLastPage: componentState.isLastPageCategorySearch
            })
          )
        ),
        _react2.default.createElement(
          _Izenda4.default.Row,
          null,
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '3' },
            _react2.default.createElement(
              _Izenda10.default,
              { className: 'control-label' },
              popupConfig.SUBCATEGORY
            )
          ),
          _react2.default.createElement(
            _Izenda4.default.Col,
            { cols: '9' },
            _react2.default.createElement(_Izenda8.default, {
              simpleValue: true,
              options: componentState.subCategories,
              labelKey: 'name',
              valueKey: 'id',
              value: selectedSubCategory,
              noResultsText: selectSubCategoryHint,
              onChange: changeSubCategoryHandler,
              onAddNew: addNewSubCategory,
              disabled: (0, _fp.isNil)(model.categoryId),
              scalable: false,
              isLazyLoading: true,
              getData: getSubCategories,
              onSearchLazy: searchSubCategoryDataHandler,
              onCloseMenu: resetSubCategory,
              isLastPage: componentState.isLastPageSubCategorySearch
            })
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SavePopup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props$model = this.props.model,
          reportName = _props$model.reportName,
          reportType = _props$model.reportType,
          categoryId = _props$model.categoryId,
          subCategoryId = _props$model.subCategoryId,
          isGlobal = _props$model.isGlobal;

      _Izenda24.default.loadCategorySettings().then(function (result) {
        _this2.props.updateComponentState((0, _fp.set)('localGlobalCategories', result));
      });

      this.props.updateOriginalState({
        reportName: reportName,
        reportType: reportType,
        categoryId: categoryId,
        subCategoryId: subCategoryId,
        isGlobal: isGlobal
      });
    }

    /**
     * Check to display Save Into component.
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          model = _props.model,
          onClosing = _props.onClosing;


      var popupTitle = !model.saveAs ? localization.getText('COMMON_LABEL_SAVE') : localization.getText('COMMON_LABEL_SAVE_AS');

      return _react2.default.createElement(
        _Izenda6.default,
        { visible: true, onClosing: onClosing, autoClose: false, type: 'none' },
        _react2.default.createElement(_Izenda6.default.Header, { title: popupTitle }),
        _react2.default.createElement(
          _Izenda6.default.Body,
          null,
          this.renderContainer()
        ),
        _react2.default.createElement(
          _Izenda6.default.Footer,
          null,
          _react2.default.createElement(
            _Izenda6.default.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_OK')
          ),
          _react2.default.createElement(
            _Izenda6.default.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  }]);
  return SavePopup;
}(_react.Component), _class2.propTypes = {
  onClose: _react.PropTypes.func.isRequired,
  validate: _react.PropTypes.func.isRequired,
  popupConfig: _react.PropTypes.object.isRequired,
  model: _react.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = SavePopup;
module.exports = exports['default'];

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module Action SavePopup component
 */

!function () {
  var compose = __webpack_require__(9).compose;
  var setPropTypes = __webpack_require__(9).setPropTypes;
  var PropTypes = __webpack_require__(0).PropTypes;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withState = __webpack_require__(9).withState;
  var lifecycle = __webpack_require__(9).lifecycle;
  var m = __webpack_require__(5);
  var UIConstants = __webpack_require__(34);
  var uiState = __webpack_require__(15);
  var appStore = __webpack_require__(104);
  var concatArray = __webpack_require__(118).concatArray;
  var reportsConstant = __webpack_require__(50);

  var _require = __webpack_require__(1),
      curry = _require.curry,
      flow = _require.flow,
      set = _require.set,
      get = _require.get,
      clone = _require.clone,
      head = _require.head,
      filter = _require.filter;

  var categorySearchKey = null;
  var subCategorySearchKey = null;

  var savePopupActions = compose(withState('componentState', 'updateComponentState', function () {
    return {
      categories: [],
      isLastPageCategorySearch: false,
      subCategories: [],
      isLastPageSubCategorySearch: false,
      localGlobalCategories: []
    };
  }), withState('original', 'updateOriginalState', function () {
    return {
      reportName: '',
      reportType: '',
      categoryId: null,
      subCategoryId: null,
      isGlobal: false
    };
  }), withHandlers({
    onClosing: curry(onClosing),
    changeNameHandler: changeNameHandler,
    changeSaveInHandler: curry(m.action(changeSaveInHandler)),
    changeCategoryHandler: curry(m.action(changeCategoryHandler)),
    addNewCategoryHandler: curry(m.action(addNewCategoryHandler)),
    changeSubCategoryHandler: curry(m.action(changeSubCategoryHandler)),
    addNewSubCategoryHandler: m.action(addNewSubCategoryHandler),
    getCategories: curry(getCategories),
    getSubCategories: m.action(getSubCategories),
    searchCategoryDataHandler: curry(searchCategoryDataHandler),
    searchSubCategoryDataHandler: m.action(searchSubCategoryDataHandler),
    resetCategory: curry(resetCategory),
    resetSubCategory: m.action(resetSubCategory)
  }));

  function onClosing(props) {
    return function (closeCallBack, type) {
      var hidePopup = function hidePopup() {
        props.onClose();
      };

      if (type === 'accept') {
        onAcceptClosing(props, hidePopup);
      } else if (type === 'cancel') {
        onCancelClosing(props, hidePopup);
      }
    };
  }

  /**
   * When click button Cancel on popup
   * @param  {Object} hidePopup function
   */
  function onCancelClosing(props, hidePopup) {
    hidePopup();
    props.validation.reset();
  }

  function onAcceptClosing(props, hidePopup) {
    var store = props.store;
    var model = props.model;

    model.saveAsMode && model.markSaveAs();
    var valManager = props.validation;

    return valManager.validate().then(function (success) {
      if (success) {
        valManager.reset();

        if (!!props.original.isGlobal != model.isGlobal) {
          var description = model.isGlobal ? props.localization.getText('DASHBOARD_CONSTANTS_REPORT_MESSAGE_SELECTING_GLOBAL') : props.localization.getText('DASHBOARD_CONSTANTS_REPORT_MESSAGE_UNSELECTING_GLOBAL');
          return props.confirmFn('Confirmation', {
            description: description
          }).then(function () {
            return model.section ? detectReportChange(props) : props.save().then(function (result) {
              result && hidePopup();
            });
          });
        } else {
          return model.section ? detectReportChange(props) : props.save().then(function (result) {
            result && hidePopup();
          });
        }
      }
      return success;
    }).then(function (saveResult) {
      return saveResult ? props.onClose(saveResult.reportId) : null;
    });
  }

  function detectReportChange(props) {
    var store = props.store;
    var section = props.section;

    return store.detectReportChange(section).then(function (result) {
      if (!result.success) {
        var error = result.messages[0];

        switch (error.key) {
          case Constants.DETECT_CHANGE.PHYSICAL:
            props.confirmFn('Information', {
              description: error.messages[0],
              type: 'info',
              showCloseIndicator: true
            }).then(props.disableReport);
            break;
          case Constants.DETECT_CHANGE.LOGICAL:
            return props.confirmFn('Confirmation', {
              description: error.messages[0]
            }).then(saveReport.bind(null, props));
            break;
        }
        return null;
      }

      return saveReport(props);
    }.bind(this));
  }

  /**
   * Is this function being used?
   * @param {} props
   */
  function saveReport(props) {
    var store = props.store;
    var section = props.section;

    model.setIgnoreCheckChange();

    // Save as in Report Viewer
    if (!props.section && props.fieldStore) {
      var reportBody = props.fieldStore.reportBody;
      if (reportBody.hasInvisibleFields) {
        return props.confirmFn('Confirmation', {
          description: reportsConstant.MESSAGES.SAVE_AS_REPORT
        }).then(function () {
          return store.saveReport(Constants.PAGE_NAME.FIELDS);
        });
      }
    }

    // Save as in Report Designer
    return store.saveReport(section).then(function (result) {
      if (result.isDisableReport) {
        props.disableReport && props.disableReport();
      }
      return result;
    });
  }

  function changeNameHandler(props) {
    return function (name) {
      props.changeName(name);
    };
  }

  function changeSaveInHandler(props) {
    return function (value) {
      props.changeCategoryType(value);
      props.changeCategory(null, null);
      props.updateSubCategory(null, null);

      var newState = flow(set('categories', []), set('subCategories', []))(props.componentState);
      props.updateComponentState(newState);
    };
  }

  function changeCategoryHandler(props) {
    return function (key, value) {
      props.changeCategory(key, value);
      props.updateSubCategory(null, null);
      var state = set('subCategories', [], props.componentState);
      props.updateComponentState(state);
    };
  }

  function resetCategory(props) {
    return function () {
      if (categorySearchKey) {
        categorySearchKey = null;
      }
      var state = set('categories', [], props.componentState);
      props.updateComponentState(state);
    };
  }

  function getCategories(props) {
    return function (pageInfo) {
      return getCategoriesData(props, pageInfo, false);
    };
  }

  function getCategoriesData(props, pageInfo, isReset) {
    var store = props.store;
    var selectedLocalGlobalCategoryId = get('id', getSaveInCategory(props.model.isGlobal, props.componentState.localGlobalCategories));

    var request = {
      skipItems: pageInfo.fromIndex,
      pageSize: pageInfo.pageSize,
      type: 2,
      criteria: [{ key: 'name', value: categorySearchKey }],
      parentIds: [selectedLocalGlobalCategoryId],
      includeUncategory: false,
      tenantId: uiState.tenantId
    };

    return props.getCategoriesFunc(request).then(function (data) {
      var newState = clone(props.componentState);
      if (isReset) {
        newState.categories = [];
      }
      concatArray(newState.categories, data.categories, 'id', !data.isLastPage);
      newState.isLastPageCategorySearch = data.isLastPage;

      props.updateComponentState(newState);
      return data.categories;
    });
  }

  function searchCategoryDataHandler(props) {
    return function (key, pageInfo) {
      categorySearchKey = key;
      return getCategoriesData(props, pageInfo, true);
    };
  }

  function addNewCategoryHandler(props) {
    return function (category) {
      var oldState = clone(props.componentState);
      var newState = flow(set('categories', [category]), set('subCategories', []))(oldState);
      props.updateComponentState(newState);
      return true;
    };
  }

  function changeSubCategoryHandler(props) {
    return function (key, value) {
      props.updateSubCategory(key, value);
    };
  }

  function addNewSubCategoryHandler(props) {
    return function (subCategory) {
      var newState = set('subCategories', [subCategory], props.componentState);
      props.updateComponentState(newState);
      return true;
    };
  }

  function getSaveInCategory(isGlobal, localGlobalCategories) {
    return flow(filter({ isGlobal: isGlobal }), head)(localGlobalCategories);
  }

  function getSubCategories(props) {
    return function (pageInfo) {
      return getSubCategoriesData(props, pageInfo, false);
    };
  }

  function getSubCategoriesData(props, pageInfo, isReset) {
    if (String.isGuidFormat(props.model.categoryId)) {
      var selectedLocalGlobalCategoryId = get('id', getSaveInCategory(props.model.isGlobal, props.componentState.localGlobalCategories));

      var request = {
        skipItems: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize,
        type: 2,
        criteria: [{ key: 'name', value: subCategorySearchKey }],
        parentIds: [selectedLocalGlobalCategoryId, props.model.categoryId],
        tenantId: uiState.tenantId
      };
      return props.getSubcategoriesFunc(request).then(function (data) {
        var newState = clone(props.componentState);
        if (isReset) {
          newState.subCategories = [];
        }
        concatArray(newState.subCategories, data.subCategories, 'id', !data.isLastPage);
        newState.isLastPageSubCategorySearch = data.isLastPage;

        props.updateComponentState(newState);
        return data.subCategories;
      });
    } else {
      return (0, _bluebird.resolve)([]);
    }
  }

  function searchSubCategoryDataHandler(props) {
    return function (key, pageInfo) {
      subCategorySearchKey = key;
      return getSubCategoriesData(props, pageInfo, true);
    };
  }

  function resetSubCategory(props) {
    return function () {
      if (subCategorySearchKey) {
        subCategorySearchKey = null;
        var state = set('subCategories', [], props.componentState);
        props.updateComponentState(state);
      }
    };
  }
  module.exports = savePopupActions;
}();

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerToolbarAction.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var compose = __webpack_require__(9).compose;

  var exposeMethodAction = __webpack_require__(604).accessContext;
  var integrationStyleAction = __webpack_require__(231).accessContext;

  var action = compose(exposeMethodAction, integrationStyleAction);

  module.exports = action;
}();

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var GridLayout = __webpack_require__(13);
  var connect = __webpack_require__(2);
  var NameEditor = __webpack_require__(2719);
  var DashboardConstants = __webpack_require__(73);
  var Config = __webpack_require__(40);
  var classnames = __webpack_require__(11);
  var RWNumberPicker = __webpack_require__(923).NumberPicker;
  var UserLookUp = __webpack_require__(418);
  var CONSTANT = __webpack_require__(92);
  var uiState = __webpack_require__(15);
  var Input = __webpack_require__(17);
  var Label = __webpack_require__(71);
  var action = __webpack_require__(2720);
  var observer = __webpack_require__(10).observer;

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      get = _require.get;

  var GlobalDashBoard = observer(function (props) {
    var store = props.store;
    var isNewDashboard = isNil(get('id', props.store.dashboardDetail.dashboard));

    return React.createElement(
      'div',
      { className: props.clsName + ' u_paddingTop' },
      React.createElement(
        Label,
        null,
        React.createElement(Input, {
          className: 'u_marginRight',
          checked: store.dashboardDetail.dashboard.isGlobal,
          disabled: !isNewDashboard,
          type: 'checkbox',
          onChange: props.updateGlobalDashboardCheckbox
        }),
        DashboardConstants.GLOBAL_DASHBOARD
      )
    );
  });

  var DashboardDesignerHeader = function DashboardDesignerHeader(props) {
    var localization = props.localization;
    /**
     * Exit slide show.
     */
    function exitSlideShow() {
      props.store.dashboardDesignerMode.togglePresentation();
    }

    /**
     * Show dashboard with fullscreen mode.
     */
    function fullscreen() {
      props.store.dashboardDesignerMode.toggleFullscreen();
    }

    /**
     * render left header component
     * @return {Object} left header component
     */
    function renderLeftHeader() {
      var store = props.store;
      var model = store.model.dashboardDetail;
      var ownerValue = isNil(model.dashboard.ownerId) ? [] : [{
        id: model.dashboard.ownerId,
        name: model.dashboard.owner
      }];

      var clsName = classnames(' u_alignMiddle u_fullWidth u_paddingLeft', {
        'izenda-DashboardDesigner-Header-DashboarName': !isNil(props.dashboardDetail.dashboard.name)
      });

      var changeName = model.markDirty;
      var isGlobal = model.dashboard.isGlobal;

      var showGlobalCheckbox = isNil(uiState.tenantId) && uiState.currentUser.systemAdmin || model.dashboard.isGlobal && !isNil(model.dashboard.id);

      var dashboardNameCols = 6;
      // Technical Debt.
      if (showGlobalCheckbox) {
        dashboardNameCols = isGlobal ? 9 : 4;
      }

      if (store.dashboardDesignerMode.isAccess) {
        return React.createElement(
          GridLayout,
          null,
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              GridLayout.Col,
              { cols: dashboardNameCols, className: 'u_marginBottom' },
              React.createElement(
                'div',
                { className: clsName },
                React.createElement(NameEditor, (0, _extends3.default)({}, props, {
                  store: store,
                  dataDetail: props.dashboardDetail.dashboard,
                  validationMessage: DashboardConstants.CONSTRAINTS.NAME,
                  changeName: changeName,
                  title: localization.getText('COMMON_TOOLTIP_RENAME')
                }))
              )
            ),
            showGlobalCheckbox && React.createElement(
              GridLayout.Col,
              { cols: '3', className: 'u_marginBottom' },
              React.createElement(GlobalDashBoard, (0, _extends3.default)({}, props, { clsName: clsName }))
            ),
            !model.dashboard.isGlobal && React.createElement(
              GridLayout.Col,
              { cols: showGlobalCheckbox ? 5 : 6, className: 'u_marginBottom' },
              React.createElement(
                'div',
                { className: 'form-horizontal' },
                React.createElement(
                  'div',
                  { className: 'form-group u-bgWhite u_paddingInner u_noMarginAll' },
                  React.createElement(
                    GridLayout.Col,
                    { cols: '2', className: 'u_textRight' },
                    React.createElement(
                      'label',
                      { className: 'control-label' },
                      localization.getText('COMMON_LABEL_OWNER')
                    )
                  ),
                  React.createElement(
                    GridLayout.Col,
                    { cols: '10' },
                    React.createElement(UserLookUp, {
                      usedCurrentUser: true,
                      useSearchName: true,
                      data: store.accessStore.users.peek(),
                      value: ownerValue,
                      usingPopup: true,
                      onChange: store.model.dashboardDetail.updateDashboardOwner.bind(store.model.dashboardDetail),
                      onChangeFromPopup: store.model.dashboardDetail.updateDashboardOwner.bind(store.model.dashboardDetail),
                      valueField: 'id',
                      textField: 'name',
                      singleUser: true,
                      validations: CONSTANT.CONSTRAINTS.DASHBOARD_OWNER,
                      field: 'owner',
                      userModeType: CONSTANT.USER_ACCESS_MODE.ACCESS,
                      useEmailInOptions: true
                    })
                  )
                )
              )
            )
          )
        );
      }
      return React.createElement(
        'div',
        { className: 'u_tableCell u_fullWidth' },
        React.createElement(
          GridLayout,
          null,
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              GridLayout.Col,
              { cols: showGlobalCheckbox ? 9 : 12, className: 'u_marginBottom' },
              React.createElement(
                'div',
                { className: clsName },
                React.createElement(NameEditor, (0, _extends3.default)({}, props, {
                  store: store,
                  dataDetail: props.dashboardDetail.dashboard,
                  validationMessage: DashboardConstants.CONSTRAINTS.NAME,
                  changeName: changeName,
                  title: localization.getText('COMMON_TOOLTIP_RENAME')
                }))
              )
            ),
            showGlobalCheckbox && React.createElement(
              GridLayout.Col,
              { cols: '3', className: 'u_marginBottom' },
              React.createElement(GlobalDashBoard, (0, _extends3.default)({}, props, { clsName: clsName }))
            )
          )
        )
      );
    }

    /**
     * OnChange minute for fullscreen.
     */
    function onChangeMinute(minute) {
      props.store.model.updateAutoDurationMinute(minute || 0);
    }

    /**
     * OnChange second for fullscreen.
     */
    function onChangeSecond(second) {
      props.store.model.updateAutoDurationSecond(second || 0);
    }

    /**
     * render right header component
     * @return {Object} right header component
     */
    function renderRightHeader() {
      var model = props.store.model;
      if (!props.store.dashboardDesignerMode.isPresentation) {
        return null;
      }
      return React.createElement(
        'div',
        { className: 'u_tableCell' },
        React.createElement(
          'div',
          { className: 'izenda-DashboardDesigner-Header-PresentControl u_paddingInner' },
          !uiState.isMobile && React.createElement(
            'span',
            null,
            React.createElement(
              'span',
              null,
              localization.getText('DASHBOARD_LABEL_SHOW_NEXT_SLIDE_AFTER')
            ),
            React.createElement(RWNumberPicker, {
              min: 0,
              max: 59,
              defaultValue: 0,
              className: 'u_inlineBlock u_marginLeft izenda-PresentationBar-Button',
              value: model.autoDurationMinute,
              onChange: onChangeMinute
            }),
            React.createElement(
              'span',
              null,
              '\xA0',
              localization.getText('COMMON_LABEL_MINS')
            ),
            React.createElement(RWNumberPicker, {
              min: 0,
              max: 59,
              className: 'u_inlineBlock u_marginLeft izenda-PresentationBar-Button',
              defaultValue: 0,
              value: model.autoDurationSecond,
              onChange: onChangeSecond
            }),
            React.createElement(
              'span',
              null,
              '\xA0',
              localization.getText('COMMON_LABEL_SECS')
            ),
            React.createElement('i', {
              title: localization.getText('DASHBOARD_LABEL_FULLSCREEN_MODE'),
              className: 'icon-fullscreen u_inlineBlock u_marginLeft selectable',
              onClick: fullscreen
            })
          ),
          React.createElement('i', {
            title: localization.getText('DASHBOARD_LABEL_EXIT_PRESENTATION_MODE'),
            className: 'icon-exit-slideshow u_inlineBlock u_marginLeft selectable',
            onClick: exitSlideShow
          })
        )
      );
    }

    return React.createElement(
      'div',
      { className: 'izenda-DashboardDesigner-Header' },
      React.createElement(
        'div',
        { className: 'u_table u_fullWidth' },
        renderLeftHeader(),
        renderRightHeader()
      )
    );
  };

  DashboardDesignerHeader.propTypes = {
    store: React.PropTypes.object,
    dashboardDetail: React.PropTypes.object
  };

  module.exports = connect(action)(DashboardDesignerHeader);
}();

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.NameEditor.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var connect = __webpack_require__(2);

  var Validator = __webpack_require__(23);
  var constants = __webpack_require__(50);
  var TextHighLight = __webpack_require__(62);
  var Input = Validator()(__webpack_require__(17));
  var ACCESS_RIGHT = __webpack_require__(42).ACCESS_RIGHT;
  var SearchCriteria = constants.SEARCH_CRITERIA;

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var NameEditor = React.createClass({
    displayName: 'NameEditor',

    propTypes: {
      store: React.PropTypes.object,
      dataDetail: React.PropTypes.object,
      validationMessage: React.PropTypes.object,
      title: React.PropTypes.string,
      changeName: React.PropTypes.func
    },

    componentWillMount: function componentWillMount() {
      this.originalName = this.props.dataDetail.name;
    },

    getInitialState: function getInitialState() {
      return {
        editMode: false
      };
    },

    /**
     * Handle enter
     * @param {Object} event
     */
    handleEnter: function handleEnter(e) {
      if (e.key === 'Enter') {
        this.handleSave();
      }
    },

    /**
     * Handle save report name
     */
    handleSave: function handleSave(e) {
      // Stop event blur if current event is mouse down
      if (e && e.type === 'mousedown') {
        e.preventDefault();
        e.stopPropagation();
      }

      var props = this.props;
      var dataDetail = this.props.dataDetail;
      var valManager = this.props.validation;
      var loader = this.props.loader;

      if (dataDetail.name === this.originalName) {
        props.changeName && props.changeName();
        this.setState({ editMode: false });
        return;
      }

      loader.startLoading();
      valManager.validate('Name').then(function (success) {
        if (success) {
          return props.store.validateName(dataDetail, dataDetail.name).then(function (response) {
            if (isNil(response)) {
              this.originalName = props.dataDetail.name;
              props.changeName && props.changeName();
              this.setState({ editMode: false });
            } else {
              ReactDOM.findDOMNode(this.refs.inputName.refs.editor).focus();
            }
            valManager.updateErrors(response);
          }.bind(this));
        }
      }.bind(this)).finally(loader.endLoading.bind(loader));
    },

    /**
     * Handle cancel button
     */
    handleCancel: function handleCancel() {
      this.setState({ editMode: false });
      this.props.dataDetail.name = this.originalName;
    },

    /**
     * Rename
     * @param {Object} event
     */
    handleRename: function handleRename(e) {
      this.originalName = this.props.dataDetail.name;
      this.setState({ editMode: true });
      e.preventDefault();
      e.stopPropagation();
    },

    /**
     * Change name
     * @param {Object} input
     */
    onChangeName: function onChangeName(input) {
      this.props.dataDetail.name = input.target.value;
      this.setState({ editMode: this.state.editMode });
    },

    /**
     * Render report name component with edit mode
     * @return {Object} component
     */
    renderNameWithEditMode: function renderNameWithEditMode(localization) {
      var dataDetail = this.props.dataDetail;

      return React.createElement(
        'div',
        { className: 'title-edit' },
        React.createElement(
          'div',
          { className: 'input-group' },
          React.createElement(Input, {
            ref: 'inputName',
            value: dataDetail.name,
            onChange: this.onChangeName,
            onKeyPress: this.handleEnter,
            onBlur: this.handleSave,
            field: 'Name',
            validations: this.props.validationMessage,
            className: 'form-control',
            autoFocus: true
          }),
          React.createElement(
            'span',
            { className: 'input-group-btn' },
            React.createElement(
              'button',
              {
                className: 'btn btn-default',
                onMouseDown: this.handleSave,
                title: localization.getText('COMMON_TOOLTIP_UPDATE_CHANGE')
              },
              React.createElement('span', { className: 'icon-ok success-color' })
            ),
            React.createElement(
              'button',
              {
                className: 'btn btn-default',
                onMouseDown: this.handleCancel,
                title: localization.getText('COMMON_TOOLTIP_CANCEL_CHANGE')
              },
              React.createElement('span', { className: 'icon-cancel' })
            )
          )
        )
      );
    },

    /**
     * Render name with view mode
     * @return {Object} component
     */
    renderNameWithViewMode: function renderNameWithViewMode() {
      var dataDetail = this.props.dataDetail;
      var model = this.props.store.items || {};
      var accessPriority = dataDetail.accessPriority;
      var isPencilButtonVisible = this.props.newDashboard || accessPriority === ACCESS_RIGHT.FullAccess || accessPriority === ACCESS_RIGHT.SaveAs;

      return React.createElement(
        'div',
        { className: 'u_flexHorizontal' },
        React.createElement(
          'div',
          { className: 'u_textTruncate' },
          React.createElement(TextHighLight, {
            highlight: model.searchText,
            text: dataDetail.name,
            className: 'text-bold',
            notHighlight: dataDetail.isNotHighLight && dataDetail.isNotHighLight(model.searchType, SearchCriteria[1].value)
          })
        ),
        isPencilButtonVisible && React.createElement(
          'div',
          { className: 'u_fullInlineBlock' },
          React.createElement(
            'a',
            { onClick: this.handleRename },
            React.createElement('span', { className: 'icon-pencil-new', title: this.props.title })
          )
        )
      );
    },

    /**
     * Render component
     * @return {Object} component
     */
    render: function render() {
      var dataDetail = this.props.dataDetail;
      var localization = this.props.localization;

      return React.createElement(
        'div',
        { className: 'izenda-NameEditor u_paddingTop' },
        this.state.editMode ? this.renderNameWithEditMode(localization) : this.renderNameWithViewMode()
      );
    }
  });

  module.exports = connect()(NameEditor);
}();

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _fp = __webpack_require__(1);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerHeaderAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _recompose.withHandlers)({
  updateGlobalDashboardCheckbox: (0, _fp.curry)(updateGlobalDashboardCheckbox)
});

/**
 * Update global dashboard checkbox
 * @param {*} props
 * @param {*} e
 */

function updateGlobalDashboardCheckbox(props, e) {
  var value = e.target.checked;
  // validate access list and warning if change to global report
  var store = props.store;

  if ((0, _fp.isEmpty)(store.accessStore)) {
    store.initAccess();
  }
  var accessStore = store.accessStore;

  var result = accessStore.validateAccessListOnUpdateGlobalReport(value);

  if (result) {
    props.confirmFn('warning', { description: result }).then(function () {
      // call update global type update
      store.changeGlobalType(value);

      // update list access
      accessStore.updateListAccessor(value);
    });
  } else {
    store.changeGlobalType(value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerBody.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = __webpack_require__(5);

var _mobx2 = _interopRequireDefault(_mobx);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1212);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(636);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2722);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2742);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(83);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2745);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2746);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(342);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(92);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(615);

var _Izenda22 = _interopRequireDefault(_Izenda21);

var _Izenda23 = __webpack_require__(15);

var _Izenda24 = _interopRequireDefault(_Izenda23);

var _Izenda25 = __webpack_require__(231);

var _Izenda26 = _interopRequireDefault(_Izenda25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonFilterAction = _Izenda26.default.checkDisplayByKey("hideCommonFilter");
var CommonFilter = commonFilterAction(_Izenda6.default);

var DashboardDesignerBody = (_dec = (0, _Izenda2.default)(_Izenda12.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DashboardDesignerBody, _Component);

  function DashboardDesignerBody() {
    (0, _classCallCheck3.default)(this, DashboardDesignerBody);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardDesignerBody.__proto__ || (0, _getPrototypeOf2.default)(DashboardDesignerBody)).call(this));

    _this.handleFreezeSection = function () {
      _this.reportViewerUIStore = {};
      (0, _Izenda14.default)(_this.reportViewerUIStore);

      _this.doesFreezeDisposer = _mobx2.default.observe(_this.reportViewerUIStore, "doesFreeze", function () {
        if (!_this.reportViewerUIStore.doesFreeze) {
          $izenda(".content-container").scrollTop(0);
        }
      });
    };

    _this.updateView = function () {
      var viewerContentNode = _reactDom2.default.findDOMNode(_this.refs.viewerContent);
      _this.reportViewerUIStore.viewerContentTop = viewerContentNode && viewerContentNode.getBoundingClientRect().top;
    };

    _this.onRemovingPillHandler = function () {
      var _store$onRemovingPill;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var store = _this.props.store;
      return (_store$onRemovingPill = store.onRemovingPillHandler).call.apply(_store$onRemovingPill, [store].concat(args));
    };

    _this.onRemovingAllPillHandler = function () {
      var _store$onRemovingAllP;

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = _this.props.store;
      return (_store$onRemovingAllP = store.onRemovingAllPillHandler).call.apply(_store$onRemovingAllP, [store].concat(args));
    };

    _this.renderDesigner = function () {
      var store = _this.props.store;
      var dashboardDetail = store.dashboardDetail,
          _store$dashboardDetai = store.dashboardDetail.dashboard,
          crossFilteringDetails = _store$dashboardDetai.crossFilteringDetails,
          accessPriority = _store$dashboardDetai.accessPriority,
          configFields = store.dashboardFilterStore.model.reportFilter.displayConfigFields;


      var contentContainerClassName = (0, _classnames2.default)("Izenda-DashboardGrid_Section", {
        scrollable: _this.reportViewerUIStore.doesFreeze
      });

      var dashboardDesignerContentClassName = (0, _classnames2.default)("izenda-DashboardDesignerContent", {
        u_none: !store.dashboardDesignerMode.isDesigner || !!dashboardDetail.dashboard.fullScreenDashboardPart
      });

      var dashboardDesignerContainerClassName = (0, _classnames2.default)("u_noMarginAll u_noPaddingAll u_fullHeight", {
        u_none: !store.dashboardDesignerMode.isDesigner
      });

      return _react2.default.createElement(
        "div",
        { className: dashboardDesignerContainerClassName },
        dashboardDetail.dashboard.fullScreenDashboardPart && _react2.default.createElement(_Izenda18.default, (0, _extends3.default)({}, _this.props, {
          dashboardPart: dashboardDetail.dashboard.fullScreenDashboardPart,
          dashboardDetail: dashboardDetail,
          viewMode: false
        })),
        _react2.default.createElement(
          "div",
          { className: dashboardDesignerContentClassName },
          _react2.default.createElement(CommonFilter, {
            accessPriority: accessPriority,
            configFields: configFields,
            uiStore: _this.reportViewerUIStore,
            fieldStore: store.dashboardFilterStore,
            haveFreeze: !_Izenda24.default.isMobile,
            crossFilteringDetails: crossFilteringDetails,
            removeCrossFiltering: _this.onRemovingPillHandler,
            removeAllCrossFiltering: _this.onRemovingAllPillHandler,
            showCrossFilteringOption: false,
            hadSetting: false,
            enableDeleteAll: true,
            isLazyLoading: true
          }),
          _react2.default.createElement(_Izenda8.default, (0, _extends3.default)({
            ref: "viewerContent",
            className: contentContainerClassName
          }, _this.props, {
            dashboardDetail: dashboardDetail,
            reportViewerUIStore: _this.reportViewerUIStore,
            style: { height: _this.reportViewerUIStore.viewerContentHeight }
          }))
        )
      );
    };

    _this.renderPresentation = function () {
      return _this.props.store.dashboardDesignerMode.isPresentation ? _react2.default.createElement(_Izenda10.default, _this.props) : null;
    };

    _this.renderFullscreen = function () {
      return _this.props.store.dashboardDesignerMode.isFullscreen ? _react2.default.createElement(_Izenda16.default, _this.props) : null;
    };

    _this.renderSubscribe = function () {
      return _this.props.store.dashboardDesignerMode.isSubscribe ? _react2.default.createElement(_Izenda4.default, _this.props) : null;
    };

    _this.renderScheduling = function () {
      return _this.props.store.dashboardDesignerMode.isSchedule ? _react2.default.createElement(_Izenda4.default, _this.props) : null;
    };

    _this.renderAccess = function () {
      var store = _this.props.store;
      return store.dashboardDesignerMode.isAccess ? _react2.default.createElement(_Izenda22.default, {
        isDashboard: true,
        dashboardId: store.dashboardDetail.dashboard.id,
        isGlobal: store.dashboardDetail.dashboard.isGlobal,
        store: store.accessStore,
        users: store.accessStore.users,
        roles: store.accessStore.roles,
        tableDef: _Izenda20.default.ACCESS_TABLE_DEF,
        searchOptions: _Izenda20.default.SEARCH_OPTIONS,
        accessMode: _Izenda20.default.ACCESS_MODE.DASHBOARD
      }) : null;
    };

    _this.reportViewerUIStore = {};
    return _this;
  }

  (0, _createClass3.default)(DashboardDesignerBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFreezeSection();
      this.updateView();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.doesFreezeDisposer();
    }

    /**
       * Handle freeze section
       */


    /**
     * Update layout after resized filter panel.
     */


    /**
     * Handle on remove pill
     */


    /**
     * Handle on remove all pill
     */


    /**
     * render designer component
     * @return {Object} designer component
     */


    /**
     * render presentation component
     * @return {Object} presentation component
     */


    /**
     * render presentation component
     * @return {Object} presentation component
     */


    /**
     * render subscribe component
     * @return {Object} subscribe component
     */


    /**
     * render scheduling component
     * @return {Object} scheduling component
     */


    /**
     * render access component
     * @return {Object} access component
     */

  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "izenda-DashboardDesignerBody u_fullHeight" },
        this.renderDesigner(),
        this.renderPresentation(),
        this.renderSubscribe(),
        this.renderScheduling(),
        this.renderFullscreen(),
        this.renderAccess()
      );
    }
  }]);
  return DashboardDesignerBody;
}(_react.Component), _class2.propTypes = {
  store: _react.PropTypes.object
}, _class2.displayName = "DashboardDesignerBody", _temp)) || _class);
exports.default = DashboardDesignerBody;
module.exports = exports["default"];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _bluebird = __webpack_require__(18);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(299);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(301);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(342);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(83);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(1220);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(436);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _fp = __webpack_require__(1);

var _Izenda17 = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var newPromise = (0, _fp.memoize)(function () {
  var resolvePromise = null;
  var renderPromise = new _bluebird2.default(function (resolve) {
    resolvePromise = resolve;
  });
  return {
    promise: renderPromise,
    resolve: resolvePromise
  };
});

var DashboardGrid = (_dec = (0, _Izenda2.default)({ toClass: true }, _Izenda12.default), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(DashboardGrid, _Component);

  function DashboardGrid(props) {
    (0, _classCallCheck3.default)(this, DashboardGrid);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardGrid.__proto__ || (0, _getPrototypeOf2.default)(DashboardGrid)).call(this, props));

    _initialiseProps.call(_this);

    _this.layoutStore = null;
    var width = props.width;
    var dashboardDetail = props.store.dashboardDetail;

    _this.layoutStore = new _Izenda14.default(width, dashboardDetail.dashboard.transparentDashboardGrid);
    _this.disposeAutoRunTransparent = (0, _mobx.autorun)(function () {
      _this.layoutStore.setTransparent(dashboardDetail.dashboard.transparentDashboardGrid);
    });
    return _this;
  }

  (0, _createClass3.default)(DashboardGrid, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disposeAutoRunTransparent();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.width !== this.props.width) {
        // sync dashboard grid width with layout.
        // As layout keeps 12 cols, the cell grid size is kept to update.
        this.layoutStore.setViewWidth(nextProps.width);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props = this.props,
          id = _props.id,
          width = _props.width,
          newDashboard = _props.newDashboard;

      return nextProps.width !== width || nextProps.newDashboard !== newDashboard || nextProps.id !== id;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props,
          _props2 = this.props,
          store = _props2.store,
          dashboardDetail = _props2.store.dashboardDetail,
          printingMode = _props2.printingMode,
          renderListeners = _props2.renderListeners;

      var parts = dashboardDetail.dashboard.activeDashboardParts;
      var layoutData = parts.map(toLayoutItem);

      var editDashboard = this.checkPermission();

      var gridItems = parts.map(function (dashboardPart) {
        var tPromise = newPromise(dashboardPart.id);
        renderListeners && renderListeners.push(tPromise.promise);
        return _react2.default.createElement(
          _Izenda8.default,
          {
            key: dashboardPart.id,
            id: dashboardPart.id,
            isNew: dashboardPart.isNew,
            isDraggable: !dashboardPart.isFullSize && editDashboard,
            isResizable: !dashboardPart.isFullSize && editDashboard,
            handle: '.draggableBox',
            printingMode: printingMode,
            cancel: '.btn, input, a[href]'
          },
          _react2.default.createElement(_Izenda10.default, (0, _extends3.default)({
            editDashboard: editDashboard
          }, props, {
            store: store,
            dashboardPart: dashboardPart,
            viewMode: !!props.viewMode,
            finishedRender: tPromise.resolve
          }))
        );
      });

      return _react2.default.createElement(
        'section',
        { className: props.className, style: props.style, ref: this.setDom },
        _react2.default.createElement(
          _Izenda6.default,
          {
            className: 'izenda-DashboardGrid',
            layoutStore: this.layoutStore,
            layoutData: layoutData,
            editable: !props.viewMode && !_Izenda4.default.isMobile,
            allowAddInline: !props.viewMode && !_Izenda4.default.isMobile && editDashboard,
            onAddItem: this.onAddItem,
            printingMode: printingMode,
            onUpdateItemPositions: this.onUpdateItemPositions
          },
          gridItems
        )
      );
    }

    /**
     * Add new dashboard part
     * @param  {Object} position Position of new dashboard part
     */

    /**
     * Update new dashboard tile positions
     * @param  {Object} newItemPositions           New positions
     */

  }]);
  return DashboardGrid;
}(_react.Component), _class3.propTypes = {
  store: _propTypes2.default.object.isRequired,
  width: _propTypes2.default.number.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setDom = function (dom) {
    dom && _this2.layoutStore.setViewWidth(dom.clientWidth);
  };

  this.checkPermission = function () {
    var _props3 = _this2.props,
        authorization = _props3.authorization,
        newDashboard = _props3.newDashboard,
        dashboardDetail = _props3.store.dashboardDetail;

    var isSystemAdmin = _Izenda4.default.currentUser.systemAdmin;
    var isSystemLevel = (0, _fp.isNil)(_Izenda4.default.tenantId);
    var accessPriority = dashboardDetail.dashboard.accessPriority;

    var hasSavePrivilege = newDashboard || authorization.checkPrivileges([_Izenda17.PERMISSION_KEY.DashboardsActionsOverwriteExistingDashboard]);

    var hasSaveAsPrivilege = authorization.checkPrivileges([_Izenda17.PERMISSION_KEY.DashboardsCanCreateNewDashboardValue]);
    var boardDetail = (0, _fp.getOr)({}, 'dashboard', dashboardDetail);

    return hasSavePrivilege && accessPriority === _Izenda17.ACCESS_RIGHT.FullAccess && !(boardDetail.isGlobal && !isSystemAdmin) && !(boardDetail.isGlobal && !isSystemLevel) || hasSaveAsPrivilege && (accessPriority === _Izenda17.ACCESS_RIGHT.FullAccess || accessPriority === _Izenda17.ACCESS_RIGHT.SaveAs);
  };

  this.onAddItem = function (position) {
    position = position || { left: 0, top: 0 };
    var dashboardDetail = _this2.props.store.dashboardDetail;
    dashboardDetail.addDashboardTile(position.left, position.top);
  };

  _initDefineProp(this, 'onUpdateItemPositions', _descriptor, this);
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'onUpdateItemPositions', [_mobx.action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (newItemPositions) {
      var needPartUpdate = function needPartUpdate(tile) {
        return (0, _fp.some)({ id: tile.id }, newItemPositions);
      };

      var setOriginalPosition = function setOriginalPosition(tile) {
        if (!_Izenda4.default.isMobile) {
          tile.originalPosition = null;
        } else {
          (0, _fp.isNil)(tile.originalPosition) && tile.setOriginalPosition({
            positionX: tile.positionX,
            positionY: tile.positionY,
            width: tile.width,
            height: tile.height
          });
        }
      };

      var setPosition = function setPosition(tile) {
        var newPos = (0, _fp.find)({ id: tile.id }, newItemPositions);
        tile.setPosition({
          positionX: newPos.left,
          positionY: newPos.top,
          width: newPos.width,
          height: newPos.height
        });
      };

      var dashboardTiles = _this3.props.store.dashboardDetail.dashboard.dashboardParts;

      (0, _fp.forEach)(setOriginalPosition)(dashboardTiles);

      (0, _fp.flow)((0, _fp.filter)(needPartUpdate), (0, _fp.forEach)(setPosition))(dashboardTiles);
    };
  }
})), _class2)) || _class);

/**
 * 
 * @param {object} item 
 * @param {number} index 
 * @return {object} item data
 */

exports.default = DashboardGrid;
function toLayoutItem(item, index) {
  if (_Izenda4.default.isMobile) {
    return {
      id: item.id,
      x: 0,
      y: index,
      width: _Izenda16.default.DEFAULT_TILE_WIDTH,
      height: item.height,
      isFullSize: item.isFullSize
    };
  } else {
    var originalPosition = (0, _fp.getOr)(null, 'originalPosition', item);
    return !(0, _fp.isNil)(originalPosition) ? {
      id: item.id,
      x: originalPosition.positionX,
      y: originalPosition.positionY,
      width: originalPosition.width,
      height: originalPosition.height,
      isFullSize: item.isFullSize
    } : {
      id: item.id,
      x: item.positionX,
      y: item.positionY,
      width: item.width,
      height: item.height,
      isFullSize: item.isFullSize
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.BlankDashboardTile.js" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(10);

var _Izenda3 = __webpack_require__(73);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(399);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(185);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(13);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlankDashboardTile = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(BlankDashboardTile, _Component);

  function BlankDashboardTile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BlankDashboardTile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BlankDashboardTile.__proto__ || (0, _getPrototypeOf2.default)(BlankDashboardTile)).call.apply(_ref, [this].concat(args))), _this), _this.onClickIcon = function (item) {
      var _this2 = _this,
          props = _this2.props,
          _this2$props = _this2.props,
          store = _this2$props.store,
          loader = _this2$props.loader,
          dashboardPart = _this2$props.dashboardPart,
          dashboardDetail = _this2$props.dashboardDetail,
          viewMode = _this2$props.viewMode;


      if (viewMode) {
        return;
      } else if (item.needPopup) {
        props.openPopup(_Izenda6.default, {
          onChange: function onChange(result) {
            var dashboardPartType = (0, _fp.clone)(item);
            var report = result.report;
            var reportPart = result.reportPart;

            loader.startLoading();
            store.setDashboardTileType(dashboardPart, dashboardPartType, reportPart, report).finally(loader.endLoading.bind(loader));
          },

          type: _Izenda8.default.TYPE.REPORT_PART
        });
      } else {
        dashboardDetail.setType(dashboardPart, (0, _fp.clone)(item));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BlankDashboardTile, [{
    key: 'publishFinishedRender',
    value: function publishFinishedRender() {
      var props = this.props;
      // This is intended to alert the component has finished rendering.
      // Printing is listening on this.
      props.finishedRender && props.finishedRender();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.publishFinishedRender();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.publishFinishedRender();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          localization = _props.localization,
          disabled = _props.disabled;


      var listButtons = (0, _fp.values)(_Izenda4.default.TILE_TYPE).map(function (item) {
        return _react2.default.createElement(
          'button',
          {
            disabled: disabled,
            className: 'btn btn-default izenda-BlankDashboardTile-TileType-btn',
            key: item.type,
            title: item.label,
            onClick: _this3.onClickIcon.bind(_this3, item)
          },
          _react2.default.createElement('span', { className: item.icon }),
          item.label
        );
      });

      return _react2.default.createElement(
        _Izenda10.default,
        { className: 'izenda-BlankDashboardTile u_overflowHidden u_fullSize' },
        _react2.default.createElement(
          _Izenda10.default.Row,
          { className: 'izenda-BlankDashboardTile-TileType u_flex u_fullHeight u_noMarginAll u_alignItemCenter' },
          _react2.default.createElement(
            _Izenda10.default.Col,
            { cols: 6, className: 'u_textRight u_textUppercase u_paddingTop' },
            _react2.default.createElement(
              'p',
              null,
              localization.getText('DASHBOARD_MESSAGE_CREATE_DASHBOARD_TILE')
            ),
            _react2.default.createElement(
              'p',
              null,
              localization.getText('DASHBOARD_LABEL_SELECT_A_TYPE')
            )
          ),
          _react2.default.createElement(
            _Izenda10.default.Col,
            { cols: 6 },
            _react2.default.createElement(
              'div',
              { className: 'btn-group-vertical' },
              listButtons
            )
          )
        )
      );
    }
  }]);
  return BlankDashboardTile;
}(_react.Component), _class2.propTypes = {
  dashboardPart: _mobxReact.propTypes.observableObject.isRequired,
  dashboardDetail: _mobxReact.propTypes.observableObject.isRequired,
  store: _mobxReact.propTypes.observableObject.isRequired,
  viewMode: _propTypes2.default.bool
}, _temp2)) || _class);
exports.default = BlankDashboardTile;
module.exports = exports['default'];

/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.TextTileFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobxReact = __webpack_require__(10);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda = __webpack_require__(1217);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(27);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(76);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextTileFrontSide = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TextTileFrontSide, _Component);

  function TextTileFrontSide() {
    (0, _classCallCheck3.default)(this, TextTileFrontSide);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TextTileFrontSide.__proto__ || (0, _getPrototypeOf2.default)(TextTileFrontSide)).call(this));

    _this.publishFinishedRender = function () {
      var props = _this.props;
      props.printingMode && _Izenda6.default.publishFinishedRender(_this.renderListeners, function () {
        props.finishedRender && props.finishedRender();
      });
    };

    _this.state = {
      textTitleHeight: 0
    };

    _this.renderListeners = [];
    _this.tileTitleFrontSideKey = 'TileTitleFrontSide';
    _Izenda6.default.pushRenderListener(_this.renderListeners, _this.tileTitleFrontSideKey);
    return _this;
  }

  (0, _createClass3.default)(TextTileFrontSide, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.publishFinishedRender();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.publishFinishedRender();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dashboardPart = _props.dashboardPart,
          printingMode = _props.printingMode,
          cellWidth = _props.cellWidth,
          fulfilledData = _props.fulfilledData;

      var htmlText = dashboardPart.getBodyText();
      var bodyConfig = dashboardPart.getBodyConfig();
      var renderListeners = this.renderListeners;

      if (printingMode) {
        var style = dashboardPart.getContainerSize(cellWidth);
        return _react2.default.createElement(
          'div',
          { className: 'u_paddingTop u_paddingBottom', style: style },
          _react2.default.createElement(
            'div',
            { className: 'u_paddingLeft u_paddingRight u_fullSize' },
            _react2.default.createElement(_Izenda2.default, {
              dashboardPart: dashboardPart,
              finishedRender: _Izenda6.default.getFinishedRenderPromiseById(renderListeners, this.tileTitleFrontSideKey),
              fulfilledData: fulfilledData,
              printingMode: printingMode
            }),
            _react2.default.createElement(
              'div',
              { className: 'u_table u_fullSize' },
              _react2.default.createElement('div', { className: 'u_tableCell', style: getBodyStyle(), dangerouslySetInnerHTML: { __html: htmlText } })
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'u_paddingTop u_paddingBottom u_fullSize' },
        _react2.default.createElement(
          _Izenda4.default,
          { viewClassName: 'u_paddingLeft u_paddingRight' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Izenda2.default, this.props),
            _react2.default.createElement(
              'div',
              { className: 'u_table u_fullSize' },
              _react2.default.createElement('div', { className: 'u_tableCell', style: getBodyStyle(), dangerouslySetInnerHTML: { __html: htmlText } })
            )
          )
        )
      );

      /**
           * Get vertical align style for body text
           */
      function getBodyStyle() {
        var verticalAlign = (0, _classnames2.default)({
          top: bodyConfig.alignTop,
          middle: bodyConfig.alignMiddle,
          bottom: bodyConfig.alignBottom
        });
        return {
          verticalAlign: verticalAlign
        };
      }
    }
  }]);
  return TextTileFrontSide;
}(_react.Component), _class2.displayName = "TextTileFrontSide", _class2.propTypes = {
  dashboardPart: _react.PropTypes.object.isRequired
}, _temp)) || _class;

exports.default = TextTileFrontSide;
module.exports = exports['default'];

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TextTileBackSide.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var connect = __webpack_require__(2);

  var TileTitleBackSide = __webpack_require__(1218);
  var TextTileToolbar = __webpack_require__(2727);
  var TinyMCE = __webpack_require__(575);
  var GridLayout = __webpack_require__(13);
  var localizer = __webpack_require__(12);

  var TextTileBackSide = React.createClass({
    displayName: 'TextTileBackSide',


    propTypes: {
      dashboardPart: React.PropTypes.object.isRequired
    },

    render: function render() {
      var dashboardPart = this.props.dashboardPart;
      var text = dashboardPart.getBodyText();
      var config = dashboardPart.getBodyConfig();

      return React.createElement(
        'div',
        { className: 'izenda-DashboardTile-TextTileBackSide' },
        React.createElement(TileTitleBackSide, { dashboardPart: dashboardPart }),
        React.createElement(
          GridLayout,
          { className: 'u_marginTop' },
          React.createElement(
            GridLayout.Row,
            null,
            React.createElement(
              GridLayout.Col,
              { cols: 1 },
              React.createElement(
                'span',
                null,
                localizer.getText('DASHBOARD_LABEL_BODY_TEXT')
              )
            ),
            React.createElement(
              GridLayout.Col,
              { cols: 11 },
              React.createElement(
                'div',
                { className: 'izenda-DashboardTitle-TileTitleBackSide-TinyMCE' },
                React.createElement(TextTileToolbar, {
                  dashboardPart: dashboardPart,
                  config: config,
                  onExecCommand: this.execCommand,
                  onApplyFormat: this.applyFormat,
                  onToggleFormat: this.toggleFormat,
                  onApplyListFormat: this.applyListFormat
                }),
                React.createElement(TinyMCE, {
                  ref: 'tinyMce',
                  id: 'tinyMceId',
                  content: text,
                  onChange: handleContentChange,
                  config: { statusbar: false },
                  onFormatChange: handleFormatChange
                })
              )
            )
          )
        )
      );

      /**
       * Handle change tiny mce content
       * @param (event) e
       */
      function handleContentChange(e) {
        dashboardPart.bodyContent.text = e.target.getContent();
        dashboardPart.markDirty && dashboardPart.markDirty();
      }

      /**
       * Handle change font format
       * @param {object} value
       * @param {string} state
       */
      function handleFormatChange(value, state) {
        dashboardPart.bodyContent.config[value] = state;
        dashboardPart.markDirty && dashboardPart.markDirty();
      }
    },

    execCommand: function execCommand(key, value) {
      this.refs.tinyMce.execCommand(key, value);
    },

    applyFormat: function applyFormat(key, value) {
      this.refs.tinyMce.applyFormat(key, value);
    },

    toggleFormat: function toggleFormat(value) {
      this.refs.tinyMce.toggleFormat(value);
    },

    applyListFormat: function applyListFormat(key, value) {
      this.refs.tinyMce.applyListFormat(key, value);
    }
  });

  module.exports = TextTileBackSide;
}();

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TileTitleBackSide.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var withHandlers = __webpack_require__(9).withHandlers;
  var FontSettingsPopup = __webpack_require__(964);

  var _require = __webpack_require__(1),
      curry = _require.curry;
  /**
   * Save font settings and close fonts popup
   * @param settings
   */


  var save = function save(props, settings) {
    var dashboardPart = props.dashboardPart;
    var fn = props.dataKey === 'contentTitle' ? 'updateContentTitleSettings' : 'updateContentDescriptionSettings';

    dashboardPart[fn] && dashboardPart[fn](settings);
  };

  /**
   * Toggle font settings popup
   */
  var openPopup = function openPopup(props) {
    return function () {
      var dataKey = props.dataKey;
      var dashboardPart = props.dashboardPart;

      function getFontSettings() {
        return dashboardPart[dataKey].settings;
      }

      props.openPopup(FontSettingsPopup, {
        title: props.title,
        font: getFontSettings(),
        save: curry(save)(props)
      });
    };
  };

  module.exports = withHandlers({
    openPopup: openPopup
  });
}();

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.TextTileToolbar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * TextTileToolbar component
 */
!function () {
  var React = __webpack_require__(0);
  var observer = __webpack_require__(10).observer;

  var FontFormat = __webpack_require__(186);
  var ColorStyling = __webpack_require__(267);
  var ButtonGroup = __webpack_require__(388);
  var FORMAT_CONFIG = __webpack_require__(132).FORMAT_CONFIG;

  var TOOLBAR_BUTTON_CONFIG = __webpack_require__(1159);
  var BUTTON_STYLE = TOOLBAR_BUTTON_CONFIG.BUTTON_STYLE;
  var BUTTON_ALIGN = TOOLBAR_BUTTON_CONFIG.BUTTON_ALIGN;
  var BUTTON_ALIGN_VERTICAL = TOOLBAR_BUTTON_CONFIG.BUTTON_ALIGN_VERTICAL;
  var BUTTON_LIST = TOOLBAR_BUTTON_CONFIG.BUTTON_LIST;
  var BUTTON_INDENT = TOOLBAR_BUTTON_CONFIG.BUTTON_INDENT;

  var TextTileToolbar = function TextTileToolbar(props) {

    var dashboardPart = props.dashboardPart;
    var config = props.config;

    function handleChangeFont(data, item) {
      switch (item.keyChange) {
        case 'fontFamily':
          var fontFamily = FORMAT_CONFIG.FONT_NAME[data.value.fontFamily];
          props.onExecCommand('FontName', fontFamily);
          break;
        case 'fontSize':
          var fontSize = data.value.fontSize + 'px';
          props.onExecCommand('FontSize', fontSize);
          break;
      }
    }

    function handleChangeColor(data, item) {
      switch (item.keyChange) {
        case 'textColor':
          props.onApplyFormat('forecolor', data.value.textColor);
          break;
        case 'backgroundColor':
          props.onApplyFormat('hilitecolor', data.value.backgroundColor);
          break;
      }
    }

    function handleChangeAlignVertical(data) {
      var value = data && data.value;
      dashboardPart.setVerticalAlignConfig(value);
    }

    function handleChangeFormatButton(item) {
      props.onToggleFormat(item.value);
    }

    return React.createElement(
      'div',
      { className: 'izenda-DashboardTile-TextTileFrontSide-Toolbar' },
      React.createElement(FontFormat, {
        className: 'u_inlineBlock u_floatLeft',
        onChange: handleChangeFont,
        value: config }),
      React.createElement(ButtonGroup, {
        className: 'u_inlineBlock',
        buttons: BUTTON_STYLE,
        onChange: handleChangeFormatButton,
        value: config }),
      React.createElement(ColorStyling, {
        className: 'u_inlineBlock izenda-DashboardTile-TextTileFrontSide-Toolbar-ColorStyling',
        onChange: handleChangeColor,
        value: config }),
      React.createElement(ButtonGroup, {
        className: 'u_inlineBlock',
        buttons: BUTTON_ALIGN,
        onExecCommand: props.onExecCommand,
        value: config }),
      React.createElement(ButtonGroup, {
        className: 'u_inlineBlock',
        buttons: BUTTON_ALIGN_VERTICAL,
        value: config,
        onChange: handleChangeAlignVertical }),
      React.createElement(ButtonGroup, {
        className: 'u_inlineBlock',
        buttons: BUTTON_LIST,
        applyListFormat: props.onApplyListFormat,
        value: config }),
      React.createElement(ButtonGroup, {
        className: 'u_inlineBlock',
        buttons: BUTTON_INDENT,
        onExecCommand: props.onExecCommand,
        value: config })
    );
  };

  TextTileToolbar.propTypes = {
    onExecCommand: React.PropTypes.func.isRequired,
    onApplyFormat: React.PropTypes.func.isRequired,
    config: React.PropTypes.object.isRequired
  };

  module.exports = TextTileToolbar;
}();

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _class3, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTileFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(142);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1217);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(27);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1219);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(76);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(35);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(412);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(83);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(155);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _fp = __webpack_require__(1);

var _Izenda19 = __webpack_require__(2730);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _mobx = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ConditionalFilterDescription = (0, _mobxReact.observer)(function ConditionalFilterDescription(_ref) {
  var store = _ref.store,
      dashboardPart = _ref.dashboardPart;

  if (!store.dashboardDetail.dashboard.showFilterDescription) {
    return null;
  }
  return _react2.default.createElement(_Izenda8.default, { dashboardPart: dashboardPart });
});

var ReportPartTileFrontSide = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ReportPartTileFrontSide, _Component);

  function ReportPartTileFrontSide() {
    (0, _classCallCheck3.default)(this, ReportPartTileFrontSide);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartTileFrontSide.__proto__ || (0, _getPrototypeOf2.default)(ReportPartTileFrontSide)).call(this));

    _initDefineProp(_this, 'dashboardInfoHeight', _descriptor, _this);

    _this.publishFinishedRender = function () {
      var props = _this.props;

      props.printingMode && _Izenda10.default.publishFinishedRender(_this.renderListeners, function () {
        props.finishedRender && props.finishedRender();
      });
    };

    _this.setSectionRef = function (dom) {
      dom && (_this.sectionRef = dom);
    };

    _this.renderListeners = [];
    _this.tileTitleFrontSideKey = 'TileTitleFrontSide';
    _this.frontSideKey = 'FrontSide';
    _Izenda10.default.pushRenderListener(_this.renderListeners, _this.tileTitleFrontSideKey);
    _Izenda10.default.pushRenderListener(_this.renderListeners, _this.frontSideKey);
    _Izenda18.default.loadCustomDataFormat();
    return _this;
  }

  (0, _createClass3.default)(ReportPartTileFrontSide, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.publishFinishedRender();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.printingMode) {
        var node = this.sectionRef || {};
        this.dashboardInfoHeight = node && node.getBoundingClientRect().height;
      }

      this.publishFinishedRender();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(this.props.printingMode && this.props.fulfilledData === nextProps.fulfilledData);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dashboardPart = _props.dashboardPart,
          reportPart = _props.dashboardPart.reportPart,
          printingMode = _props.printingMode,
          cellWidth = _props.cellWidth,
          fulfilledData = _props.fulfilledData,
          store = _props.store;

      var renderListeners = this.renderListeners;

      if (_Izenda12.default.needToRenderLazyLoadingBar(reportPart, printingMode)) {
        return _Izenda12.default.renderLazyLoadingBar();
      }

      var FrontSide = _Izenda2.default.getReportFrontSide(reportPart.type, _Izenda2.default.DISPLAY_SECTION.Dashboard);
      var haveScrollBox = _Izenda2.default.getReportPartType(reportPart.type).haveDashboardScroll;
      var viewClassName = printingMode ? 'u-posRelative' : '';
      var haveEmptyRequiredFilter = !(0, _fp.isEmpty)(dashboardPart.emptyVisibleRequiredFilter());
      var dashboardElement = haveEmptyRequiredFilter ? _react2.default.createElement(_Izenda20.default, { filters: dashboardPart.emptyVisibleRequiredFilter() }) : _react2.default.createElement(
        'section',
        { ref: this.setSectionRef },
        _react2.default.createElement(_Izenda4.default, {
          dashboardPart: dashboardPart,
          printingMode: printingMode,
          finishedRender: _Izenda10.default.getFinishedRenderPromiseById(renderListeners, this.tileTitleFrontSideKey),
          fulfilledData: fulfilledData
        }),
        _react2.default.createElement(ConditionalFilterDescription, this.props)
      );

      // get new real height of report part (minus height of dashboardElement).
      var reportPartElementStyle = printingMode ? dashboardPart.getReportPartSize(cellWidth, {
        width: 0,
        height: this.dashboardInfoHeight || 0
      }) : null;
      var lookupErrorMessage = reportPart.getLookupErrorMessage();
      var reportPartElement = (0, _fp.isEmpty)(dashboardPart.emptyVisibleRequiredFilter()) ? !!lookupErrorMessage ? lookupErrorMessage : _react2.default.createElement(FrontSide, {
        reportPart: reportPart,
        store: store,
        style: reportPartElementStyle,
        dashboardPart: dashboardPart,
        printingMode: printingMode,
        forDashboard: true,
        finishedRender: _Izenda10.default.getFinishedRenderPromiseById(renderListeners, this.frontSideKey),
        fulfilledData: fulfilledData
      }) : null;

      if (haveScrollBox || printingMode || haveEmptyRequiredFilter) {
        var className = (0, _classnames2.default)({
          u_fullSize: !printingMode
        });

        return _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(
            _Izenda6.default,
            { fullSize: printingMode, viewClassName: viewClassName },
            _react2.default.createElement(
              'div',
              { className: 'u_fullSize' },
              dashboardElement,
              reportPartElement
            )
          )
        );
      }

      return _react2.default.createElement(ReportPartTileFrontSideWrapper, { dashboardElement: dashboardElement, reportPartElement: reportPartElement });
    }
  }]);
  return ReportPartTileFrontSide;
}(_react.Component), _class3.displayName = 'ReportPartTileFrontSide', _class3.propTypes = {
  dashboardPart: _react.PropTypes.object.isRequired,
  store: _react.PropTypes.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'dashboardInfoHeight', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class;

var ReportPartTileFrontSideWrapper = (0, _Izenda16.default)((0, _mobxReact.observer)(function (_ref2) {
  var dashboardElement = _ref2.dashboardElement,
      reportPartElement = _ref2.reportPartElement;

  return _react2.default.createElement(
    'div',
    { className: 'u_fullSize' },
    _react2.default.createElement(
      'div',
      { className: 'u_fullHeight u_overflowHidden' },
      _react2.default.createElement(
        _Izenda14.default,
        null,
        dashboardElement,
        reportPartElement
      )
    )
  );
}));

exports.default = ReportPartTileFrontSide;
module.exports = exports['default'];

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardFilterDescriptionsAction.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var observer = __webpack_require__(10).observer;
  var branch = __webpack_require__(9).branch;
  var renderNothing = __webpack_require__(9).renderNothing;

  var _require = __webpack_require__(1),
      isEmpty = _require.isEmpty,
      identity = _require.identity;

  var action = compose(observer, branch(function (props) {
    return isEmpty(props.dashboardPart.fullConfigFieldList);
  }, renderNothing, identity));

  module.exports = action;
}();

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__(1);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobx = __webpack_require__(5);

var mobx = _interopRequireWildcard(_mobx);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPartRequiredFilter.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
var DashboardPartRequiredFilter = function DashboardPartRequiredFilter(_ref) {
  var localization = _ref.localization,
      filters = _ref.filters;

  var buildListFilter = function buildListFilter(filtersList) {
    if ((0, _fp.isEmpty)(filtersList)) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      { className: 'u-center izenda-ReportViewer-FilterList' },
      filtersList.map(function (filter) {
        return _react2.default.createElement(
          'p',
          { key: filter.filterField.position },
          'Filter #' + filter.filterField.position + ' - ' + filter.filterField.alias
        );
      })
    );
  };

  return _react2.default.createElement(
    'div',
    { className: 'u_table u_fullSize' },
    _react2.default.createElement(
      'div',
      { className: 'u_tableCell u_alignMiddle u_textCenter' },
      localization.getText('REPORTS_CONSTANTS_REPORT_MESSAGE_SELECT_REQUIRE_AND_VISIBLE_FIELD'),
      buildListFilter(filters)
    )
  );
};

exports.default = (0, _Izenda2.default)()(DashboardPartRequiredFilter);
module.exports = exports['default'];

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTileBackSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2732);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1218);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(13);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(27);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(1219);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(324);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(421);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(16);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(231);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(636);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var integrationStyleAction = _Izenda18.default.checkDisplayByKey('hideDashboardPartFilter');
var ReportFilter = integrationStyleAction(_Izenda20.default);

var ReportPartFilter = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportPartFilter, _Component);

  function ReportPartFilter(props) {
    (0, _classCallCheck3.default)(this, ReportPartFilter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPartFilter.__proto__ || (0, _getPrototypeOf2.default)(ReportPartFilter)).call(this, props));

    _this.customGetData = function () {
      var reportDesignerFieldsStore = _this.reportDesignerFieldsStore;
      var originalGetData = _this.originalGetData;
      return function (pageInfo, configField, searchKey, isSearching) {
        return originalGetData.call(reportDesignerFieldsStore, pageInfo, configField, searchKey, isSearching, true);
      };
    };

    _this.masterStore = new _Izenda12.default(true, props.dashboardPart.reportId);
    _this.reportDesignerFieldsStore = new _Izenda14.default(_this.masterStore, true, _Izenda16.default.REPORT_STATE.SAVED);
    _this.masterStore.fieldsStore.masterModel.read(props.dashboardPart.report);
    var configFields = (0, _fp.map)(function (item) {
      return item.configField;
    }, props.dashboardPart.filters);
    _this.reportDesignerFieldsStore.model.reportFilter.populateFilterList((0, _fp.map)(function (item) {
      return item.fieldDetails;
    }, configFields));
    _this.reportDesignerFieldsStore.model.reportFilter.configFieldList = configFields;

    _this.originalGetData = _this.reportDesignerFieldsStore.getData;
    _this.reportDesignerFieldsStore.getData = _this.customGetData();
    return _this;
  }

  (0, _createClass3.default)(ReportPartFilter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dashboardPart = _props.dashboardPart,
          accessPriority = _props.accessPriority,
          _props$dashboardPart = _props.dashboardPart,
          filters = _props$dashboardPart.filters,
          individualConfigFieldList = _props$dashboardPart.individualConfigFieldList;


      var operatorSource = (0, _fp.get)('store.dashboardFilterStore.model.reportFilter.displayConfigFields', this.props);

      if ((0, _fp.isEmpty)(filters)) {
        return null;
      }
      return _react2.default.createElement(
        _Izenda6.default.Row,
        { className: 'u_noMarginRight u_noMarginLeft' },
        _react2.default.createElement(
          _Izenda6.default.Col,
          null,
          _react2.default.createElement(
            ReportFilter,
            {
              haveFreeze: false,
              configFields: individualConfigFieldList,
              isLazyLoading: true,
              fieldStore: this.reportDesignerFieldsStore,
              accessPriority: accessPriority
            },
            _react2.default.createElement(_Izenda10.default, { dashboardPart: dashboardPart, operatorSource: operatorSource })
          )
        )
      );
    }
  }]);
  return ReportPartFilter;
}(_react.Component), _class2.displayName = 'ReportPartFilter', _temp)) || _class;

var ReportPartTileBackSide = function ReportPartTileBackSide(props) {
  return _react2.default.createElement(
    _Izenda6.default,
    { className: 'report-part-back-side u_fullSize u_table' },
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_tableRow u_fullHeight' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { className: 'u_overflowAuto u_fullHeight' },
        _react2.default.createElement(
          _Izenda8.default,
          null,
          _react2.default.createElement(
            _Izenda6.default,
            { className: 'u_paddingTop u_paddingBottom' },
            _react2.default.createElement(ReportPartFilter, props),
            _react2.default.createElement(
              _Izenda6.default.Row,
              { className: 'u_noMarginRight u_noMarginLeft' },
              _react2.default.createElement(
                _Izenda6.default.Col,
                null,
                _react2.default.createElement(_Izenda4.default, { dashboardPart: props.dashboardPart })
              )
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _Izenda6.default.Row,
      { className: 'u_tableRow report-part-footer' },
      _react2.default.createElement(
        _Izenda6.default.Col,
        { className: 'u_controlHeight u_marginTop u_marginBottom' },
        _react2.default.createElement(_Izenda2.default, { dashboardPart: props.dashboardPart, store: props.store })
      )
    )
  );
};

ReportPartTileBackSide.propTypes = {
  dashboardPart: _react.PropTypes.object.isRequired,
  store: _react.PropTypes.object.isRequired
};

ReportPartTileBackSide.displayName = 'ReportPartTileBackSide';

exports.default = (0, _mobxReact.observer)(ReportPartTileBackSide);
module.exports = exports['default'];

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTileBackSideFooter.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);
  var Link = __webpack_require__(52).Link;
  var actionBarConfig = __webpack_require__(2733);
  var Button = __webpack_require__(30);

  var withProps = __webpack_require__(9).withProps;

  var ReportPartSelectionPopup = __webpack_require__(399);
  var ReportPartSelectionConstants = __webpack_require__(185);

  var _require = __webpack_require__(1),
      filter = _require.filter,
      forEach = _require.forEach,
      clone = _require.clone,
      isNil = _require.isNil,
      findIndex = _require.findIndex;

  var FooterButton = connect()(function (props) {
    if (props.hasPrivilege && !props.hasPrivilege() || props.hasLicense && !props.hasLicense()) return null;

    if (props.link) {
      return React.createElement(
        Link,
        { className: 'u_marginLeft', to: props.link },
        React.createElement(Button, { label: props.label })
      );
    }

    return React.createElement(Button, { label: props.label, onClick: props.onClick });
  });

  /**
   * Check having right access priority.
   * @ param {Object} item
   * @ param {Array} accessPriority
   */
  var checkAccessPriority = function checkAccessPriority(item, accessPriority) {
    if (!item.accessPriority) return true;
    return findIndex(function (i) {
      return i === accessPriority;
    }, item.accessPriority) !== -1;
  };

  var FooterButtonGroup = connect()(function (props) {
    if (props.hasPrivilege && !props.hasPrivilege()) return null;
    var accessPriority = props.accessPriority;

    var groupPrivileges = filter(function (item) {
      return item.hasPrivilege;
    }, props.btnGroup);

    var hasAccessPriority = false;
    forEach(function (item) {
      hasAccessPriority = checkAccessPriority(item, accessPriority) || hasAccessPriority;
      if (hasAccessPriority) return false;
    }, props.btnGroup);

    return hasAccessPriority && groupPrivileges.length > 0 && React.createElement(
      'div',
      { className: 'btn-group dropup u_marginLeft' },
      React.createElement(
        'button',
        {
          ref: function ref(dom) {
            dom && $izenda(dom).dropdown();
          },
          className: 'btn btn-primary dropdown-toggle',
          'data-toggle': 'dropdown'
        },
        props.label,
        '\xA0',
        React.createElement('span', { className: 'caret' })
      ),
      React.createElement(
        'ul',
        { className: 'dropdown-menu' },
        props.btnGroup.map(function (option) {
          var state = option.state;
          var linkClass = classnames({ 'disabled-link': state.disabled });
          var hasRightAccessPriority = checkAccessPriority(option, accessPriority);

          return !state.hide && option.hasPrivilege && hasRightAccessPriority ? React.createElement(
            'li',
            { key: option.key, className: linkClass },
            option.link && !state.disabled ? React.createElement(
              Link,
              { to: option.link },
              option.label
            ) : React.createElement(
              'a',
              option.props,
              option.label
            )
          ) : null;
        })
      )
    );
  });

  var action = withProps(function (props) {
    return {
      onSelectReportPartButton: function onSelectReportPartButton() {
        var dashboardPart = props.dashboardPart;
        var store = props.store;
        var dashboardPartType = clone(props.dashboardPart.typeConfig);
        var loader = props.loader;

        props.openPopup(ReportPartSelectionPopup, {
          onChange: function onChange(result) {
            var reportPart = result.reportPart;
            var report = result.report;

            loader.startLoading();
            store.setDashboardTileType(dashboardPart, dashboardPartType, reportPart, report).finally(loader.endLoading.bind(loader));
          },
          type: ReportPartSelectionConstants.TYPE.REPORT_PART
        });
      }
    };
  });

  var ReportPartTileBackSideFooter = connect(action)(function (props) {
    var dashboardPart = props.dashboardPart;
    var reportPart = dashboardPart.reportPart;
    var buttonConfig = actionBarConfig(reportPart.reportId, reportPart.id, props);
    buttonConfig = filter(function (config) {
      return (isNil(config.hasPrivilege) || config.hasPrivilege) && (isNil(config.hasLicense) || config.hasLicense);
    }, buttonConfig);

    return React.createElement(
      'div',
      { className: 'izenda-ActionBarRight u_paddingRight' },
      buttonConfig.map(function (info) {
        return info.btnGroup ? React.createElement(FooterButtonGroup, (0, _extends3.default)({}, info, { accessPriority: reportPart.accessPriority })) : React.createElement(FooterButton, info);
      })
    );
  });

  ReportPartTileBackSideFooter.propsType = {
    dashboardPart: React.PropTypes.object.isRequired,
    onSelectReportPartButton: React.PropTypes.func.isRequired
  };
  module.exports = ReportPartTileBackSideFooter;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (reportId, reportPartId, props) {
  var viewUrl = _Izenda2.default.getReportUrl('View', {
    id: reportId
  });
  var editUrl = _Izenda2.default.getReportUrl('Edit', {
    id: reportId
  });

  var viewReportDesignerUrl = _Izenda2.default.getReportDesignerUrl('ReportDesignerDetail', {
    reportId: reportId
  });

  var handlePrint = function handlePrint() {
    var url = _Izenda2.default.getViewerUrl('ReportBody', {
      id: reportId
    });
    var filterInfo = props.dashboardPart.filterInfoForReport;

    var queryString = $izenda.param(filterInfo || {});
    _Izenda4.default.openNewTab(_Izenda2.default.makeAbsoluteUrl(url, 'print=true&' + queryString));
  };

  var authorization = props.authorization;
  var permissionKeys = props.authorizationConstants.PERMISSION_KEY;

  var exportReportPart = function exportReportPart(format) {
    var name = props.dashboardPart.reportPart.headerTitle;
    var exportLoader = props.exportLoader;
    var key = (0, _fp.uniqueId)(name);

    exportLoader.startExportLoading({
      name: String.format('{0}.{1}', name, _Izenda8.default.getFileTypeByFormat(format)),
      key: key,
      error: false
    });

    var url = window.location.href;
    var filters = props.dashboardPart.filters;

    return props.store.exportReportPart(url, format, reportPartId, reportId, filters, props.dashboardPart.id, exportLoader.endExportLoading.bind(exportLoader, key), exportLoader.updateError.bind(exportLoader, key));
  };

  return [{
    key: 'open',
    get label() {
      return _Izenda6.default.getText('REPORT_PART_TILE_BACK_SIDE_FOOTER_CONFIG_OPEN');
    },
    link: viewUrl
  }, {
    key: 'edit',
    get label() {
      return _Izenda6.default.getText('REPORT_PART_TILE_BACK_SIDE_FOOTER_CONFIG_EDIT');
    },
    state: { disabled: false, hide: false },
    btnGroup: [{
      key: 'quickEdit',
      get label() {
        return _Izenda6.default.getText('REPORT_PART_TILE_BACK_SIDE_FOOTER_CONFIG_QUICK_EDIT');
      },
      state: { disabled: false, hide: false },
      link: editUrl,
      hasPrivilege: authorization.checkPrivileges([permissionKeys.ReportsCanCreateNewReportValue, permissionKeys.ReportsActionsOverwriteExistingReport], props.authorizationConstants.PERMISSION_OPERATOR.Or),
      accessPriority: [_Izenda12.default.ACCESS_RIGHT.FullAccess, _Izenda12.default.ACCESS_RIGHT.QuickEdit, _Izenda12.default.ACCESS_RIGHT.SaveAs]
    }, {
      key: 'design',
      get label() {
        return _Izenda6.default.getText('REPORT_PART_TILE_BACK_SIDE_FOOTER_CONFIG_DESIGN');
      },
      state: { disabled: false, hide: false },
      link: viewReportDesignerUrl,
      hasPrivilege: authorization.checkPrivileges([permissionKeys.ReportsActionsOverwriteExistingReport, permissionKeys.ReportsCanCreateNewReportValue], props.authorizationConstants.PERMISSION_OPERATOR.Or),
      accessPriority: [_Izenda12.default.ACCESS_RIGHT.FullAccess, _Izenda12.default.ACCESS_RIGHT.SaveAs]
    }]
  }, {
    key: 'html',
    get label() {
      return _Izenda6.default.getText('COMMON_LABEL_PRINT');
    },
    state: { disabled: false, hide: false },
    hasLicense: function hasLicense() {
      return authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Exporting);
    },

    onClick: handlePrint,
    hasPrivilege: function hasPrivilege() {
      return authorization.checkPrivileges([permissionKeys.ReportsActionsPrint]);
    }
  }, {
    key: 'export',
    get label() {
      return _Izenda6.default.getText('COMMON_LABEL_EXPORT');
    },
    state: { disabled: false, hide: false },
    hasLicense: authorization.checkLicense(_Izenda10.default.LICENSE_KEY.Exporting),
    btnGroup: [{
      key: 'word',
      label: 'Word',
      state: {
        disabled: false,
        hide: false
      },
      props: {
        onClick: exportReportPart.bind(this, 'word')
      },
      hasPrivilege: authorization.checkPrivileges([permissionKeys.ExportingExportingFormatWord])
    }, {
      key: 'excel',
      label: 'Excel',
      state: {
        disabled: false,
        hide: false
      },
      props: {
        onClick: exportReportPart.bind(this, 'excel')
      },
      hasPrivilege: authorization.checkPrivileges([permissionKeys.ExportingExportingFormatExcel])
    }, {
      key: 'pdf',
      label: 'PDF',
      state: {
        disabled: false,
        hide: false
      },
      props: {
        onClick: exportReportPart.bind(this, 'pdf')
      },
      hasPrivilege: authorization.checkPrivileges([permissionKeys.ExportingExportingFormatPdf], props.authorizationConstants.PERMISSION_OPERATOR.Or)
    }, {
      key: 'csv',
      label: 'CSV',
      state: {
        disabled: false,
        hide: false
      },
      props: {
        onClick: exportReportPart.bind(this, 'csv')
      },
      hasPrivilege: authorization.checkPrivileges([permissionKeys.ExportingExportingFormatCsv], props.authorizationConstants.PERMISSION_OPERATOR.Or)
    }, {
      key: 'xml',
      label: 'XML',
      state: {
        disabled: false,
        hide: false
      },
      props: {
        onClick: exportReportPart.bind(this, 'xml')
      },
      hasPrivilege: authorization.checkPrivileges([permissionKeys.ExportingExportingFormatXml], props.authorizationConstants.PERMISSION_OPERATOR.Or)
    }, {
      key: 'json',
      label: 'JSON',
      state: {
        disabled: false,
        hide: false
      },
      props: {
        onClick: exportReportPart.bind(this, 'json')
      },
      hasPrivilege: authorization.checkPrivileges([permissionKeys.ExportingExportingFormatJson], props.authorizationConstants.PERMISSION_OPERATOR.Or)
    }, {
      key: 'query',
      label: 'Query Execution',
      state: {
        disabled: false,
        hide: false
      },
      props: {
        onClick: exportReportPart.bind(this, 'query')
      },
      hasPrivilege: authorization.checkPrivileges([permissionKeys.ExportingExportingFormatQueryExecution], props.authorizationConstants.PERMISSION_OPERATOR.Or)
    }],
    hasPrivilege: function hasPrivilege() {
      return authorization.checkPrivileges([permissionKeys.ReportsActionsExporting], props.authorizationConstants.PERMISSION_OPERATOR.Or);
    }
  }, {
    key: 'selectReportPart',
    get label() {
      return _Izenda6.default.getText('REPORT_PART_TILE_BACK_SIDE_FOOTER_CONFIG_SELECT_REPORT_PART');
    },
    onClick: props.onSelectReportPartButton,
    hasPrivilege: function hasPrivilege() {
      return authorization.checkPrivileges([permissionKeys.DashboardsActionsOverwriteExistingDashboard, permissionKeys.DashboardsCanCreateNewDashboardValue], props.authorizationConstants.PERMISSION_OPERATOR.Or);
    }
  }];
};

var _Izenda = __webpack_require__(31);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(78);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(12);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1180);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(45);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(42);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTileBackSideFooterConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTileHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

var _Izenda3 = __webpack_require__(2735);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2736);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2737);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2738);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2739);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2740);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(2741);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(15);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(974);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _Izenda21 = __webpack_require__(73);

var _Izenda22 = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardTileHeader = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(DashboardTileHeader, _Component);

  function DashboardTileHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DashboardTileHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DashboardTileHeader.__proto__ || (0, _getPrototypeOf2.default)(DashboardTileHeader)).call.apply(_ref, [this].concat(args))), _this), _this.onUpdateData = function () {
      var _this$props = _this.props,
          store = _this$props.store,
          loader = _this$props.loader,
          dashboardPart = _this$props.dashboardPart;


      loader.startLoading();
      store.getReportPartData(dashboardPart).finally(loader.endLoading.bind(loader));
    }, _this.getListControl = function () {
      var _this$props2 = _this.props,
          editDashboard = _this$props2.editDashboard,
          dashboardPart = _this$props2.dashboardPart,
          viewMode = _this$props2.viewMode,
          dashboardDetail = _this$props2.dashboardDetail,
          store = _this$props2.store,
          disableViewReport = _this$props2.dashboardPart.disableViewReport;

      var refreshButton = _react2.default.createElement(_Izenda10.default, { key: 'refreshBtn', dashboardPart: dashboardPart, onUpdateData: _this.onUpdateData });
      var fullScreenButton = _react2.default.createElement(_Izenda8.default, { key: 'fsBtn', dashboardPart: dashboardPart });

      if (!editDashboard) return [refreshButton, fullScreenButton];

      var isEditable = !(0, _fp.isNil)(dashboardPart.type) && !viewMode && !disableViewReport;
      var copyButton = _react2.default.createElement(_Izenda14.default, { key: 'copyBtn', store: store, dashboardPart: dashboardPart });
      var flipButton = _react2.default.createElement(_Izenda6.default, { key: 'flipBtn', dashboardPart: dashboardPart, dashboardDetail: dashboardDetail });
      var deleteButton = _react2.default.createElement(_Izenda12.default, { key: 'delBtn', store: store, dashboardPart: dashboardPart, viewMode: viewMode });

      return isEditable ? [refreshButton, copyButton, fullScreenButton, flipButton, deleteButton] : [deleteButton];
    }, _this.renderContextMenu = function (buttons) {
      return _react2.default.createElement(
        'div',
        { className: 'izenda-ReportPartHeader_ContextMenu' },
        _react2.default.createElement(
          'ul',
          { className: 'izenda-ContextMenu-list' },
          (0, _fp.map)(function (button) {
            return _react2.default.createElement(
              'li',
              { key: button.key },
              (0, _react.cloneElement)(button, { showLabel: true })
            );
          }, buttons)
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DashboardTileHeader, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var editDashboard = props.editDashboard,
          store = props.store,
          viewMode = props.viewMode,
          presentationMode = props.presentationMode,
          dashboardPart = props.dashboardPart,
          dashboardDetail = props.dashboardDetail,
          _props$dashboardPart = props.dashboardPart,
          disableViewReport = _props$dashboardPart.disableViewReport,
          disableViewReportMessageKey = _props$dashboardPart.disableViewReportMessageKey;

      var isSelectedReportPartType = !(0, _fp.isNil)(dashboardPart.type);
      var isEditable = isSelectedReportPartType && !viewMode && !disableViewReport;
      var buttons = this.getListControl();

      var noPermission = (0, _fp.isNil)(disableViewReportMessageKey) && (0, _fp.isEmpty)(disableViewReportMessageKey) ? false : disableViewReportMessageKey === _Izenda22.NO_PERMISSION;

      var className = (0, _classnames2.default)('draggableBox u_fullWidth izenda-DashboardTile-Content-Header u_overflowHidden', {
        'u-posAbsolute': !viewMode,
        'izenda-DashboardTile-Content-Header-slid': !viewMode,
        'izenda-DashboardTile-Content-Header-fixed': viewMode && !store.dashboardDesignerMode.isFullscreen,
        'izenda-ReportPartHeader-content': true,
        'small-size': dashboardPart.width < _Izenda21.DASHBOARD_PART_MIN_WIDTH && isSelectedReportPartType && !dashboardPart.isBackSide && !dashboardPart.isFullScreenMode && !presentationMode && !_Izenda18.default.isMobile
      });

      return _react2.default.createElement(
        _Izenda20.default,
        {
          id: dashboardPart.id,
          isDisabled: !isSelectedReportPartType,
          menuComponent: this.renderContextMenu(buttons)
        },
        _react2.default.createElement(
          'div',
          { className: className, 'aria-selected': isSelectedReportPartType },
          !_Izenda18.default.isMobile && _react2.default.createElement(
            'div',
            { className: 'izenda-ReportPartHeader-buttonAction' },
            buttons
          ),
          _react2.default.createElement(
            'div',
            { className: 'izenda-ReportPartHeader-title' },
            isSelectedReportPartType && !noPermission && _react2.default.createElement(_Izenda16.default, {
              disabled: !editDashboard,
              dashboardDetail: dashboardDetail,
              dashboardPart: dashboardPart,
              viewMode: viewMode
            })
          ),
          !_Izenda18.default.isMobile && _react2.default.createElement(
            'div',
            { className: 'izenda-ReportPartHeader-record' },
            isEditable && _react2.default.createElement(_Izenda4.default, { key: 'previewRecord', dashboardPart: dashboardPart, onUpdateData: this.onUpdateData })
          )
        )
      );
    }
  }]);
  return DashboardTileHeader;
}(_react.Component), _class2.propTypes = {
  store: _mobxReact.propTypes.observableObject.isRequired,
  dashboardDetail: _mobxReact.propTypes.observableObject.isRequired,
  dashboardPart: _mobxReact.propTypes.observableObject.isRequired,
  viewMode: _propTypes2.default.bool
}, _temp2)) || _class);
exports.default = DashboardTileHeader;
module.exports = exports['default'];

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _EventUtils = __webpack_require__(24);

var _EventUtils2 = _interopRequireDefault(_EventUtils);

var _Izenda = __webpack_require__(53);

var _Izenda2 = __webpack_require__(17);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _Izenda4 = __webpack_require__(23);

var _Izenda5 = _interopRequireDefault(_Izenda4);

var _Izenda6 = __webpack_require__(12);

var _Izenda7 = _interopRequireDefault(_Izenda6);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidatableInput = (0, _Izenda5.default)()(_Izenda3.default); // ----------------------------------------------------------------------
// <copyright file="Izenda.PreviewRecord.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var PreviewRecord = (0, _mobxReact.observer)(function (_ref) {
  var dashboardPart = _ref.dashboardPart,
      _ref$dashboardPart = _ref.dashboardPart,
      reportPart = _ref$dashboardPart.reportPart,
      showNumberOfRecord = _ref$dashboardPart.showNumberOfRecord,
      numberOfRecordDisplayValue = _ref$dashboardPart.numberOfRecordDisplayValue,
      setNumberOfRecord = _ref$dashboardPart.setNumberOfRecord,
      onUpdateData = _ref.onUpdateData;

  if (!showNumberOfRecord) {
    return null;
  }

  var onBlur = function onBlur() {
    onUpdateData();
  };
  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === 13) {
      onUpdateData();
    }
  };

  return _react2.default.createElement(
    'span',
    { className: 'u_inlineBlock' },
    _react2.default.createElement(
      'label',
      { htmlFor: 'record' },
      _Izenda7.default.getText('DASHBOARD_LABEL_NUMBER_OF_RECORDS')
    ),
    _react2.default.createElement(ValidatableInput, {
      containerClassName: 'u_inlineBlock u_alignMiddle',
      className: 'form-control',
      disabled: (0, _fp.isNil)(reportPart),
      validations: _Izenda.NUMBER_OF_RECORD_LIMIT_CONSTRAINT,
      field: 'record',
      value: numberOfRecordDisplayValue,
      onChange: (0, _EventUtils.notifyChange)(setNumberOfRecord.bind(dashboardPart), _EventUtils2.default.INPUT),
      onBlur: onBlur,
      onKeyDown: onKeyDown
    })
  );
});

PreviewRecord.propTypes = {
  dashboardPart: _mobxReact.propTypes.observableObject.isRequired,
  onUpdateData: _react.PropTypes.func
};

exports.default = PreviewRecord;
module.exports = exports['default'];

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(53);

var _Izenda2 = __webpack_require__(73);

var _Izenda3 = _interopRequireDefault(_Izenda2);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerFilters.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var FlipButton = (0, _mobxReact.observer)(function (_ref) {
  var dashboardPart = _ref.dashboardPart,
      _ref$dashboardPart = _ref.dashboardPart,
      isBackSide = _ref$dashboardPart.isBackSide,
      reportPart = _ref$dashboardPart.reportPart,
      type = _ref$dashboardPart.type,
      dashboardDetail = _ref.dashboardDetail,
      switchDashboardPartSide = _ref.dashboardDetail.switchDashboardPartSide,
      showLabel = _ref.showLabel;

  var flipIcon = isBackSide ? { className: 'icon-flip-front', tooltip: _Izenda.SWITCH_TO_PREVIEW } : { className: 'icon-flip-back', tooltip: _Izenda.SWITCH_TO_CONFIGURATION };

  var isDashboardText = type === _Izenda3.default.TILE_TYPE.text.type;
  var flipClass = (0, _classnames2.default)({ 'disabled-elm': (0, _fp.isNil)(reportPart) && !isDashboardText }, { btn: !(0, _fp.isNil)(reportPart) || isDashboardText });

  return _react2.default.createElement(
    'a',
    {
      className: flipClass,
      title: flipIcon.tooltip,
      onClick: switchDashboardPartSide.bind(dashboardDetail, dashboardPart, null)
    },
    _react2.default.createElement('i', { className: flipIcon.className }),
    showLabel && _react2.default.createElement(
      'span',
      null,
      flipIcon.tooltip
    )
  );
});

FlipButton.propTypes = {
  dashboardPart: _mobxReact.propTypes.observableObject.isRequired,
  dashboardDetail: _mobxReact.propTypes.observableObject.isRequired
};

exports.default = FlipButton;
module.exports = exports['default'];

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.FullScreenButton.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var connect = __webpack_require__(2);

  var FullScreenButton = connect()(function (props) {
    var dashboardPart = props.dashboardPart;
    var localization = props.localization;

    var fullScreenIcon = dashboardPart.isFullScreenMode ? { className: 'icon-nofullscreen', label: localization.getText('DASHBOARD_TITLE_NORMAL_SCREEN') } : { className: 'icon-fullscreen', label: localization.getText('DASHBOARD_TITLE_FULL_SCREEN') };

    return React.createElement(
      'a',
      {
        className: 'btn u_noBorderAll',
        title: fullScreenIcon.label,
        onClick: dashboardPart.toggleFullScreenMode.bind(dashboardPart) },
      React.createElement('i', { className: fullScreenIcon.className }),
      props.showLabel && React.createElement(
        'span',
        null,
        fullScreenIcon.label
      )
    );
  });

  FullScreenButton.propTypes = {
    dashboardPart: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = FullScreenButton;
}();

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.RefreshButton.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var connect = __webpack_require__(2);

  var RefreshButton = connect()(function (props) {
    var dashboardPart = props.dashboardPart;
    var localization = props.localization;

    if (!dashboardPart.showRefeshButton) {
      return null;
    }
    var onClick = function onClick() {
      props.onUpdateData();
    };

    return React.createElement(
      'a',
      { className: 'btn u_noBorderAll', title: localization.getText('COPY_MANAGEMENT_LABEL_REFRESH'), onClick: onClick },
      React.createElement('i', { className: 'icon-refresh' }),
      props.showLabel && React.createElement(
        'span',
        null,
        localization.getText('COPY_MANAGEMENT_LABEL_REFRESH')
      )
    );
  });

  RefreshButton.propTypes = {
    dashboardPart: ObservablePropTypes.observableObject.isRequired,
    onUpdateData: PropTypes.func
  };

  module.exports = RefreshButton;
}();

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DeleteButton.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var DashboardGridConstants = __webpack_require__(436);

  var connect = __webpack_require__(2);

  var DeleteButton = connect()(function (props) {
    var store = props.store;
    var viewMode = props.viewMode;
    var dashboardPart = props.dashboardPart;
    var loader = props.loader;
    var confirmFn = props.confirmFn;

    if (viewMode) {
      return null;
    }

    var deleteDashboardPart = function deleteDashboardPart() {
      loader.startLoading();
      return store.deleteDashboardPart(dashboardPart).finally(loader.endLoading.bind(loader));
    };

    var onDelete = function onDelete(e) {
      e.stopPropagation();

      return confirmFn('Information', {
        description: String.format(DashboardGridConstants.DELETE_CONFIRM_MESSAGE, dashboardPart.title)
      }).then(deleteDashboardPart);
    };

    return React.createElement(
      'a',
      { className: 'btn u_noBorderAll', title: DashboardGridConstants.DELETE_ICON_TOOLTIP, onClick: onDelete },
      React.createElement('i', { className: 'icon-cancel' }),
      props.showLabel && React.createElement(
        'span',
        null,
        DashboardGridConstants.DELETE_ICON_TOOLTIP
      )
    );
  });

  DeleteButton.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired,
    dashboardPart: ObservablePropTypes.observableObject.isRequired,
    viewMode: PropTypes.bool
  };

  module.exports = DeleteButton;
}();

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(73);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.CopyButton.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

var CopyButton = (0, _Izenda4.default)()(function (_ref) {
  var loader = _ref.loader,
      store = _ref.store,
      localization = _ref.localization,
      showLabel = _ref.showLabel,
      dashboardPart = _ref.dashboardPart,
      _ref$dashboardPart = _ref.dashboardPart,
      isBackSide = _ref$dashboardPart.isBackSide,
      reportPart = _ref$dashboardPart.reportPart,
      type = _ref$dashboardPart.type;

  var isDashboardText = type === _Izenda2.default.TILE_TYPE.text.type;
  var copyClass = (0, _classnames2.default)({ 'disabled-elm': (0, _fp.isNil)(reportPart) && !isDashboardText }, { btn: !(0, _fp.isNil)(reportPart) || isDashboardText });

  return !isBackSide && _react2.default.createElement(
    'a',
    { className: copyClass, title: localization.getText('COMMON_LABEL_COPY'), onClick: copy },
    _react2.default.createElement('i', { className: 'icon-copy' }),
    showLabel && _react2.default.createElement(
      'span',
      null,
      localization.getText('COMMON_LABEL_COPY')
    )
  );

  function copy() {
    loader.startLoading();
    return store.copyDashboardPart(dashboardPart).finally(loader.endLoading.bind(loader));
  }
});

CopyButton.propTypes = {
  store: _mobxReact.propTypes.observableObject.isRequired,
  dashboardPart: _mobxReact.propTypes.observableObject.isRequired
};

exports.default = CopyButton;
module.exports = exports['default'];

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.NameInput.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var EventsUtils = __webpack_require__(24);
  var notifyChange = EventsUtils.notifyChange;
  var connect = __webpack_require__(2);
  var routeUtils = __webpack_require__(31);

  var Link = __webpack_require__(52).Link;
  var Input = __webpack_require__(17);
  var Validator = __webpack_require__(23);
  var uiState = __webpack_require__(15);
  var ValidatableInput = Validator()(Input);

  var _require = __webpack_require__(1),
      trim = _require.trim;

  var NameInput = React.createClass({
    displayName: 'NameInput',

    propTypes: {
      dashboardPart: ObservablePropTypes.observableObject.isRequired,
      dashboardDetail: ObservablePropTypes.observableObject.isRequired,
      viewMode: PropTypes.bool
    },
    getInitialState: function getInitialState() {
      return {
        editMode: false
      };
    },
    render: function render() {
      var typeConfig = this.props.dashboardPart.typeConfig;

      return React.createElement(
        'span',
        null,
        React.createElement('i', { className: typeConfig.icon }),
        React.createElement(
          'span',
          null,
          this.renderName(),
          this.renderIcon()
        )
      );
    },
    /**
     * render dashboard Part name
     * @method renderName
     * @return {React Componenet}
     */
    renderName: function renderName() {
      var props = this.props;
      var dashboardPart = props.dashboardPart;
      var dashboardDetail = props.dashboardDetail;
      var edit = !props.viewMode;
      var truncateText = String.truncateString(dashboardPart.title, 17);

      var inputTitleValidation = {
        action: function action() {
          return dashboardDetail.validateNewNameDashboardPart.bind(dashboardDetail, dashboardPart, dashboardPart.editingTitle);
        }
      };

      if (edit && dashboardPart.isBackSide || this.state.editMode) {
        return React.createElement(ValidatableInput, {
          containerClassName: 'u_inlineBlock u_alignMiddle',
          className: 'form-control',
          field: 'inputTitle_' + dashboardPart.id,
          validations: inputTitleValidation,
          value: dashboardPart.editingTitle,
          onChange: notifyChange(this.updateInputTitle, EventsUtils.INPUT),
          onBlur: dashboardPart.isBackSide && this.renamePart
        });
      }
      if (dashboardPart.isReportPartType) {
        return React.createElement(
          'a',
          { onClick: this.onNameClick, href: '#' },
          React.createElement(
            'span',
            { title: dashboardPart.title },
            truncateText
          )
        );
      }
      return React.createElement(
        'span',
        { title: dashboardPart.title },
        truncateText
      );
    },

    /**
     * check dirty before user navigate to report part link
     * @method onNameClick
     */
    onNameClick: function onNameClick(e) {
      e.preventDefault();
      var props = this.props;
      var isDirty = props.dashboardPart.isDirty || props.dashboardDetail.isDirty;
      var url = routeUtils.getReportUrl('View', { id: props.dashboardPart.reportId });
      props.confirmDirtyForm(isDirty, {
        onConfirmDirtyForm: uiState.onOkDirtyForm
      }).then(function () {
        props.router.push(url);
      });
    },
    /**
     * render dashboard Part name icon
     * @method renderIcon
     * @return {React Componenet}
     */
    renderIcon: function renderIcon() {
      var props = this.props;
      var dashboardPart = props.dashboardPart;
      var viewMode = props.viewMode;
      var disabled = props.disabled;
      var localization = props.localization;

      if (viewMode || dashboardPart.isBackSide || disabled) {
        return null;
      }
      if (!this.state.editMode) {
        return React.createElement(
          'a',
          {
            className: 'btn btn-default u_noBorderAll',
            title: localization.getText('DASHBOARD_TITLE_EDIT_REPORT_PART_NAME'),
            onClick: this.editName
          },
          React.createElement('i', { className: 'icon-pencil-new' })
        );
      }
      return React.createElement(
        'span',
        null,
        React.createElement(
          'a',
          {
            className: 'btn btn-default u_noBorderAll',
            title: localization.getText('DASHBOARD_TITLE_SET_NEW_DASHBOARD_PART_NAME'),
            onClick: this.renamePart
          },
          React.createElement('i', { className: 'icon-ok success-color' })
        ),
        React.createElement(
          'a',
          {
            className: 'btn btn-default u_noBorderAll',
            title: localization.getText('DASHBOARD_TITLE_REVERT_DASHBOARD_PART_NAME'),
            onClick: this.viewName
          },
          React.createElement('i', { className: 'icon-cancel' })
        )
      );
    },

    /**
     * update input title
     * @method updateInputTitle
     * @param  {sting}         newName  New Name
     */
    updateInputTitle: function updateInputTitle(newName) {
      this.props.dashboardPart.setEditingTitle(newName);
    },

    /**
     * rename dashboard part name
     */
    renamePart: function renamePart() {
      var dashboardPart = this.props.dashboardPart;
      var dashboardDetail = this.props.dashboardDetail;

      return this.props.validation.validate('inputTitle_' + dashboardPart.id).then(function (success) {
        if (success) {
          dashboardDetail.renameDashboardPart(dashboardPart, trim(dashboardPart.editingTitle));
          if (!dashboardPart.isBackSide) {
            this.setState({ editMode: false });
          }
        }
      }.bind(this));
    },

    /**
     * switch to view mode
     * @method viewName
     */
    viewName: function viewName() {
      var dashboardPart = this.props.dashboardPart;

      dashboardPart.setEditingTitle(dashboardPart.title);
      this.setState({ editMode: false });
    },

    /**
     * swtich to edit mode
     * @method editName
     */
    editName: function editName() {
      this.setState({ editMode: true });
    }
  });

  module.exports = connect()(NameInput);
}();

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(20);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _desc, _value, _class2, _descriptor, _class3, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPresentation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobxReact = __webpack_require__(10);

var _mobx = __webpack_require__(5);

var _Izenda = __webpack_require__(342);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1221);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SCREEN_RATIO = 7;

var DashboardPresentation = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(DashboardPresentation, _Component);

  function DashboardPresentation(props) {
    (0, _classCallCheck3.default)(this, DashboardPresentation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardPresentation.__proto__ || (0, _getPrototypeOf2.default)(DashboardPresentation)).call(this, props));

    _initDefineProp(_this, 'width', _descriptor, _this);

    _this.width = props.width;
    return _this;
  }

  (0, _createClass3.default)(DashboardPresentation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var containerDOM = _reactDom2.default.findDOMNode(this);
      var newWidth = containerDOM.clientWidth;
      newWidth > 0 && newWidth !== this.width && (this.width = newWidth);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.width > 0 && nextProps.width !== this.width) {
        this.width = nextProps.width;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dashboardDetail = this.props.store.dashboardDetail;

      var centerPadding = Math.round(this.width / SCREEN_RATIO);
      var settings = null;

      if (dashboardDetail.dashboard.activeDashboardParts.length > 1) {
        settings = {
          centerMode: true,
          centerPadding: centerPadding,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          lazyLoad: true,
          draggable: false
        };
      }

      // Effect when resize event
      var style = {
        width: this.width ? +this.width + 'px' : '100%'
      };

      var dashboardTileStyle = {
        width: this.width ? this.width - centerPadding * 2 : '100%'
      };

      /**
       * Render dashboard tiles
       */
      var renderDashboardTiles = function renderDashboardTiles() {
        return (0, _fp.map)(function (dashboardPart) {
          return _react2.default.createElement(
            'div',
            { key: dashboardPart.id, className: 'u_fullHeight' },
            _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, _this2.props, {
              dashboardPart: dashboardPart,
              dashboardTileStyle: dashboardTileStyle,
              viewMode: true,
              presentationMode: true
            }))
          );
        }, dashboardDetail.dashboard.activeDashboardParts);
      };

      /**
       * Render slider box
       */
      return _react2.default.createElement(
        'div',
        { className: 'u_fullHeight', style: style },
        dashboardDetail.dashboard.activeDashboardParts.length > 1 ? _react2.default.createElement(
          _Izenda4.default,
          { settings: settings, className: 'izenda-DashboardPresentation-SliderContainer', key: (0, _fp.uniqueId)() },
          renderDashboardTiles()
        ) : renderDashboardTiles()
      );
    }
  }]);
  return DashboardPresentation;
}(_react.Component), _class3.propTypes = {
  store: _react.PropTypes.object
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'width', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class;

exports.default = DashboardPresentation;
module.exports = exports['default'];

/***/ }),
/* 2743 */,
/* 2744 */,
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportViewerUIStoreFactory.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var m = __webpack_require__(5);
  var constants = __webpack_require__(50);

  module.exports = function (store) {
    m.extendObservable(store, {
      doesFreeze: false,
      viewerContentTop: 0,
      viewerContentHeight: function viewerContentHeight() {
        if (!this.doesFreeze) {
          return constants.FITLERS_PANEL_UI.fullHeight;
        }
        var footerElement = $izenda("footer");
        var footerHeight = footerElement.length > 0 ? footerElement[0].getBoundingClientRect().height : 0;
        var paddingBottomOfContainer = parseInt($izenda(".main-wrapper").css("padding-bottom"), 10) || 0;
        var newHeight = $izenda(window).height() - this.viewerContentTop - footerHeight - paddingBottomOfContainer - 10;

        return newHeight;
      }
    });
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardFullscreen.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(32);
  var connect = __webpack_require__(2);
  var DashboardTile = __webpack_require__(342);
  var SliderBox = __webpack_require__(1221);
  var Fullscreen = __webpack_require__(2747);
  var classnames = __webpack_require__(11);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      assign = _require.assign,
      map = _require.map;

  var SCREEN_RATIO = 7;

  var DashboardFullscreen = function DashboardFullscreen(props) {
    var dashboardDetail = props.store.dashboardDetail;
    var localization = props.localization;

    // Config for slider
    var centerPadding = Math.round(this.props.width / SCREEN_RATIO);
    var settings = null;
    if (dashboardDetail.dashboard.activeDashboardParts.length > 1) {
      settings = {
        centerMode: true,
        centerPadding: centerPadding,
        slidesToShow: 1,
        arrows: true,
        dots: false,
        lazyLoad: true,
        pauseOnHover: false,
        draggable: false
      };

      if ((props.store.model.autoDurationMinute || props.store.model.autoDurationSecond) && props.store.dashboardDesignerMode.isFullscreen) {
        var minute = 0;
        if (!isNil(props.store.model.autoDurationMinute)) minute = props.store.model.autoDurationMinute;

        var second = 0;
        if (!isNil(props.store.model.autoDurationSecond)) second = props.store.model.autoDurationSecond;

        settings = assign({
          autoplaySpeed: minute * 60 * 1000 + second * 1000,
          autoplay: true
        }, settings);
      }
    }

    // Effect when resize event
    var style = {
      width: this.props.width + 'px',
      paddingBottom: '50px'
    };

    function exitCallback() {
      props.store.dashboardDesignerMode.exitFullscreen();
    }

    /**
     * Render dashboard tiles
     */
    function renderDashboardTiles() {
      return map(function (dashboardPart) {
        return React.createElement(
          'div',
          { key: dashboardPart.id, className: 'u_fullHeight' },
          React.createElement(DashboardTile, (0, _extends3.default)({}, props, { dashboardPart: dashboardPart, viewMode: true, fullScreen: true }))
        );
      }, dashboardDetail.dashboard.activeDashboardParts);
    }

    /**
     * Render slider box
     */
    function renderSliderBox() {
      return React.createElement(
        'div',
        { className: 'u_fullHeight', style: style },
        dashboardDetail.dashboard.activeDashboardParts.length > 1 ? React.createElement(
          SliderBox,
          { settings: settings },
          renderDashboardTiles()
        ) : renderDashboardTiles()
      );
    }

    return React.createElement(
      Fullscreen,
      { exitCallback: exitCallback },
      !isNil(props.dashboardDetail.dashboard.name) && React.createElement(
        'div',
        { className: 'u_paddingAll dashboard-name' },
        props.dashboardDetail.dashboard.name,
        React.createElement('i', {
          title: localization.getText('DASHBOARD_TITLE_EXIT_FULL_SCREEN_MODE'),
          className: 'icon-cancel u_inlineBlock u_marginLeft pull-right selectable',
          onClick: exitCallback
        })
      ),
      renderSliderBox()
    );
  };

  DashboardFullscreen.propTypes = {
    store: React.PropTypes.object
  };

  module.exports = connect()(DashboardFullscreen);
}();

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Fullscreen.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  'use strict';

  var React = __webpack_require__(0);

  var Fullscreen = React.createClass({
    displayName: 'Fullscreen',

    propTypes: {
      exitCallback: React.PropTypes.func
    },

    fn: function fn() {
      var val;
      var valLength;
      var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
      // new WebKit
      ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
      // old WebKit (Safari 5.1)
      ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];

      var i = 0;
      var l = fnMap.length;
      var ret = {};

      for (; i < l; i++) {
        val = fnMap[i];
        if (val && val[1] in document) {
          for (i = 0, valLength = val.length; i < valLength; i++) {
            ret[fnMap[0][i]] = val[i];
          }
          return ret;
        }
      }

      return false;
    },
    request: function request(elem) {
      var request = this.fn().requestFullscreen;

      elem = elem || document.documentElement;

      // Work around Safari 5.1 bug: reports support for
      // keyboard in fullscreen even though it doesn't.
      // Browser sniffing, since the alternative with
      // setTimeout is even worse.
      if (/5\.1[\.\d]* Safari/.test(navigator.userAgent)) {
        elem[request]();
      } else {
        var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
        elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
      }
    },
    exit: function exit() {
      document[this.fn().exitFullscreen]();
    },
    toggle: function toggle(elem) {
      if (this.isFullscreen()) {
        this.exit();
      } else {
        this.request(elem);
      }
    },
    isFullscreen: function isFullscreen() {
      return Boolean(document[this.fn().fullscreenElement]);
    },
    element: {
      enumerable: true,
      get: function get() {
        return document[this.fn().fullscreenElement];
      }
    },
    enabled: {
      enumerable: true,
      get: function get() {
        // Coerce to boolean in case of old WebKit
        return Boolean(document[this.fn().fullscreenEnabled]);
      }
    },

    /**
     * Init fullscreen
     */
    initFullscreen: function initFullscreen() {
      var fullscreen = this.refs.fullscreen;
      this.toggle(fullscreen);

      document.addEventListener(this.fn().fullscreenchange, this.exitHandler, false);
    },

    /**
     * Exit handler
     */
    exitHandler: function exitHandler() {
      if (!this.isFullscreen()) {
        this.props.exitCallback();
      }
    },

    componentDidMount: function componentDidMount() {
      this.initFullscreen();
    },

    render: function render() {
      return React.createElement(
        'div',
        { ref: 'fullscreen', className: 'u_fullHeight izenda-Fullscreen u-bgDarkGray' },
        this.props.children
      );
    }
  });

  module.exports = Fullscreen;
}();

/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPresetPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = __webpack_require__(0);
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var Popup = __webpack_require__(36);
  var DashboardPresetConstants = __webpack_require__(2749);
  var GridLayout = __webpack_require__(13);
  var classnames = __webpack_require__(11);
  var connect = __webpack_require__(2);

  var _require = __webpack_require__(1),
      flow = _require.flow;

  var MAX_COLS = 12;

  var PresetIcon = function PresetIcon(props) {
    var dashboardDetail = props.dashboardDetail;
    var preset = props.preset;
    var onClick = flow(dashboardDetail.readPreset.bind(dashboardDetail, preset), props.onClosing);
    var className = classnames('izenda-DashboardPresetPopup-Icon', preset.icon);

    return React.createElement(
      'div',
      { title: preset.tooltip, className: 'izenda-DashboardPresetPopup-IconBox', onClick: onClick },
      React.createElement('div', { className: className })
    );
  };

  var DashboardPresetPopup = React.createClass({
    displayName: 'DashboardPresetPopup',

    propTypes: {
      dashboardDetail: ObservablePropTypes.observableObject.isRequired
    },
    render: function render() {
      var props = this.props;
      var dashboardDetail = props.dashboardDetail;
      var onClosing = this.onClosing;

      return React.createElement(
        Popup,
        { visible: true, onClosing: onClosing, autoClose: false, type: 'none' },
        React.createElement(Popup.Header, { title: DashboardPresetConstants.POPUP_HEADER }),
        React.createElement(
          Popup.Body,
          { className: 'izenda-DashboardPresetPopup' },
          React.createElement(
            GridLayout,
            null,
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: MAX_COLS },
                DashboardPresetConstants.POPUP_TEXT
              )
            ),
            React.createElement(
              GridLayout.Row,
              null,
              DashboardPresetConstants.OPTIONS.map(function (preset, index) {
                return React.createElement(
                  GridLayout.Col,
                  { key: index, cols: '4', xs: '6' },
                  React.createElement(PresetIcon, {
                    key: preset.tooltip,
                    dashboardDetail: dashboardDetail,
                    preset: preset,
                    onClosing: onClosing
                  })
                );
              })
            )
          )
        )
      );
    },

    /**
     * Handle when popup closing
     * @param  {Object} closeCallback function
     * @param  {Object} type of close button click
     */
    onClosing: function onClosing(closeCallback, type) {
      this.props.onReject();
    }
  });

  module.exports = connect()(DashboardPresetPopup);
}();

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(12);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get POPUP_HEADER() {
    return _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_POPUP_HEADER');
  },
  get POPUP_TEXT() {
    return _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_POPUP_TEXT');
  },
  get OPTIONS() {
    return [{
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_BLANK_DASHBOARD'),
      icon: 'icon-layout-01 u_hidden',
      tiles: []
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_ONE_TITLE_PER_ROW'),
      icon: 'icon-layout-01',
      tiles: [{ positionX: 0, positionY: 0, width: 12, height: 4 }, { positionX: 0, positionY: 4, width: 12, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_TWO_TITLES_ON_FIRST_ROW'),
      icon: 'icon-layout-02',
      tiles: [{ positionX: 0, positionY: 0, width: 6, height: 4 }, { positionX: 6, positionY: 0, width: 6, height: 4 }, { positionX: 0, positionY: 4, width: 12, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_TWO_TITLES_PER_ROW'),
      icon: 'icon-layout-03',
      tiles: [{ positionX: 0, positionY: 0, width: 6, height: 4 }, { positionX: 6, positionY: 0, width: 6, height: 4 }, { positionX: 0, positionY: 4, width: 6, height: 4 }, { positionX: 6, positionY: 4, width: 6, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_THREE_TITLES_PER_ROW'),
      icon: 'icon-layout-04',
      tiles: [{ positionX: 0, positionY: 0, width: 4, height: 4 }, { positionX: 4, positionY: 0, width: 4, height: 4 }, { positionX: 8, positionY: 0, width: 4, height: 4 }, { positionX: 0, positionY: 4, width: 4, height: 4 }, { positionX: 4, positionY: 4, width: 4, height: 4 }, { positionX: 8, positionY: 4, width: 4, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_ONE_TITLE_FIRST_ROW'),
      icon: 'icon-layout-05',
      tiles: [{ positionX: 0, positionY: 0, width: 12, height: 4 }, { positionX: 0, positionY: 4, width: 6, height: 4 }, { positionX: 6, positionY: 4, width: 6, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_THREE_ROW_ONE_TITLE_PER_ROW'),
      icon: 'icon-layout-06',
      tiles: [{ positionX: 0, positionY: 0, width: 12, height: 4 }, { positionX: 0, positionY: 4, width: 12, height: 4 }, { positionX: 0, positionY: 8, width: 12, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_THREE_ROW_TWO_TITLES_PER_ROW'),
      icon: 'icon-layout-07',
      tiles: [{ positionX: 0, positionY: 0, width: 6, height: 4 }, { positionX: 6, positionY: 0, width: 6, height: 4 }, { positionX: 0, positionY: 4, width: 6, height: 4 }, { positionX: 6, positionY: 4, width: 6, height: 4 }, { positionX: 0, positionY: 8, width: 6, height: 4 }, { positionX: 6, positionY: 8, width: 6, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_TWO_ROW_TWO_ON_FIRST_THREE_ON_SECOND'),
      icon: 'icon-layout-08',
      tiles: [{ positionX: 0, positionY: 0, width: 6, height: 4 }, { positionX: 6, positionY: 0, width: 6, height: 4 }, { positionX: 0, positionY: 4, width: 4, height: 4 }, { positionX: 4, positionY: 4, width: 4, height: 4 }, { positionX: 8, positionY: 4, width: 4, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_THREE_ROW_ONE_TITLE_ON_FIRST_ROW_TWO_ON_SECOND_ONE_ON_THIRD'),
      icon: 'icon-layout-09',
      tiles: [{ positionX: 0, positionY: 0, width: 12, height: 4 }, { positionX: 0, positionY: 4, width: 6, height: 4 }, { positionX: 6, positionY: 4, width: 6, height: 4 }, { positionX: 0, positionY: 8, width: 12, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_THREE_ROW_ONE_TITLE_ON_FIRST_ROW_TWO_ON_SECOND_THREE_ON_THIRD'),
      icon: 'icon-layout-10',
      tiles: [{ positionX: 0, positionY: 0, width: 12, height: 4 }, { positionX: 0, positionY: 4, width: 6, height: 4 }, { positionX: 6, positionY: 4, width: 6, height: 4 }, { positionX: 0, positionY: 8, width: 4, height: 4 }, { positionX: 4, positionY: 8, width: 4, height: 4 }, { positionX: 8, positionY: 8, width: 4, height: 4 }]
    }, {
      tooltip: _Izenda2.default.getText('DASHBOARD_PRESET_CONSTANT_THREE_ROW_ONE_TITLE_ON_FIRST_ROW_THREE_ON_SECOND_ONE_ON_THIRD'),
      icon: 'icon-layout-11',
      tiles: [{ positionX: 0, positionY: 0, width: 12, height: 4 }, { positionX: 0, positionY: 4, width: 4, height: 4 }, { positionX: 4, positionY: 4, width: 4, height: 4 }, { positionX: 8, positionY: 4, width: 4, height: 4 }, { positionX: 0, positionY: 8, width: 12, height: 4 }]
    }];
  }
}; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPresetConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentRoutes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _Izenda = __webpack_require__(2751);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1222);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2759);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contentRoutes = function contentRoutes() {
  return _react2.default.createElement(
    _reactRouter.Route,
    {
      component: _Izenda2.default },
    (0, _Izenda4.default)(),
    (0, _Izenda6.default)()
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ContentRoutes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.contentRoutes = contentRoutes;

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContentLayout;

// ----------------------------------------------------------------------
// <copyright file="Izenda.ContentLayout.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

function ContentLayout(_ref) {
  var children = _ref.children;

  return children;
}
module.exports = exports["default"];

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPartViewer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Dashboard Part Viewer component
 */

/**
 * This component is intended to show only dashboard part content.
 * Parameters locate in the params property.
 * id: required. Id of report part
 *
 * Example build URI:
 * var ContentRoutes = require('routes/Izenda.ContentRoutes').contentRoutes;
 * var ROUTE = require('routes/Izenda.ContentRoutes').route;
 * var uri = routeUtils.getViewerUrl(
 *   'DashboardPart',
 *   {
 *     id: '00867012-9060-4347-8460-ac41aa3291f2'
 *   }
 * );
 * // result: /viewer/dashboardpart/00867012-9060-4347-8460-ac41aa3291f2
 */

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var DashboardPartStore = __webpack_require__(2753);
  var DashboardTile = __webpack_require__(342);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var DashboardPartViewer = React.createClass({
    displayName: 'DashboardPartViewer',

    propTypes: {
      params: React.PropTypes.object
    },

    getInitialState: function getInitialState() {
      return {
        part: null,
        sourceStore: null
      };
    },

    componentWillMount: function componentWillMount() {
      this.store = new DashboardPartStore();
    },

    componentDidMount: function componentDidMount() {
      var props = this.props;
      var loader = props.loader;
      var params = props.params;

      loader.startLoading();
      this.store.loadReportPartContentFromDashboard(params.id).then(function (result) {
        this.setState({
          part: result.part,
          sourceStore: result.sourceStore
        });
      }.bind(this)).finally(loader.endLoading.bind(loader));
    },

    render: function render() {
      var state = this.state;
      var dashboardPart = state.part;
      var sourceStore = state.sourceStore;

      return !isNil(dashboardPart) ? React.createElement(DashboardTile, { dashboardPart: dashboardPart, viewMode: true, store: sourceStore, printingMode: true }) : null;
    }
  });

  module.exports = connect()(DashboardPartViewer);
}();

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPartStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var ReportPartDetails = __webpack_require__(269);
  var DashboardTile = __webpack_require__(336);

  var DashboardStore = __webpack_require__(338);

  function DashboardPartStore() {
    this.sourceStore = new DashboardStore();
  }

  /**
   * Load definition and data of dashboard's part.
   * @param  {String} dashboardPartId
   */
  DashboardPartStore.prototype.loadReportPartContentFromDashboard = function (dashboardPartId) {
    var sourceStore = this.sourceStore;
    var content;

    return sourceStore.loadDashboardPartDefinition(dashboardPartId).then(function (info) {
      content = new DashboardTile(info);
      if (content.reportPartId) {
        return sourceStore.loadReportPartDefinition(content.reportPartId);
      }

      return (0, _bluebird.resolve)();
    }).then(function (detail) {
      if (detail) {
        content.reportPart = new ReportPartDetails(detail);
        return sourceStore.getReportPartData(content);
      }
      return (0, _bluebird.resolve)();
    }).then(function (result) {
      return {
        part: content,
        sourceStore: sourceStore
      };
    });
  };

  module.exports = DashboardPartStore;
}();

/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardViewer.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * This component is intended to show only report body content.
 * Parameters locate in the params property.
 * id: required. Id of report part.
 *
 * Example build URI:
 * var ContentRoutes = require('routes/Izenda.ContentRoutes');
 * var uri = routeUtils.getViewerUrl(\
 *   'Dashboard',
 *   {
 *     id: 'e395dca2-088a-4ff2-8c54-9412fca495bf',
 *   }
 * );
 * // result: /viewer/dashboard/e395dca2-088a-4ff2-8c54-9412fca495bf
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(338);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(76);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(222);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardViewer = (_dec = (0, _Izenda2.default)({ toClass: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DashboardViewer, _Component);

  function DashboardViewer(props) {
    (0, _classCallCheck3.default)(this, DashboardViewer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardViewer.__proto__ || (0, _getPrototypeOf2.default)(DashboardViewer)).call(this, props));

    _this.state = {
      renderListeners: null,
      scaleX: 1,
      cellWidth: 0
    };

    _this.store = new _Izenda4.default();
    var loader = props.loader,
        location = props.location,
        params = props.params;

    _this.store.readURLOptions(location.query);

    loader.startLoading();
    _this.store.loadDashboard(params.id).then(function () {
      var dashboard = _this.store.dashboardDetail.dashboard;
      var activeDashboardParts = dashboard.activeDashboardParts;
      var listeners = [];
      (0, _fp.forEach)(function (part) {
        listeners.push(_Izenda6.default.createPartRenderPromise(part.id));
      }, activeDashboardParts);
      _this.setState({
        renderListeners: listeners
      });
    });
    return _this;
  }

  /**
     * get scale on x-axis.
     */


  (0, _createClass3.default)(DashboardViewer, [{
    key: 'getScaleX',
    value: function getScaleX() {
      var dpi = _Izenda6.default.getDPI();
      var node = _reactDom2.default.findDOMNode(this.refs.dashboardContent);
      var pageSize = _Izenda8.default.getPageSize();
      var widthPageSizeInPx = dpi * pageSize.widthInInches;
      var nodeWidthInPx = node.getBoundingClientRect().width;

      this.setState({
        scaleX: widthPageSizeInPx / nodeWidthInPx,
        cellWidth: nodeWidthInPx / 12
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getScaleX();
    }
  }, {
    key: 'render',
    value: function render() {
      var DashboardGridContent = __webpack_require__(2755);
      var style = _Izenda6.default.buildScaleStyle(this.state.scaleX);

      return _react2.default.createElement(
        'div',
        { className: 'u_fullSize izenda-DashboardViewer u_fullInlineBlock', ref: 'dashboardContent', style: style },
        _react2.default.createElement(DashboardGridContent, {
          store: this.store,
          dashboardDetail: this.store.dashboardDetail,
          printingMode: true,
          viewMode: true,
          cellWidth: this.state.cellWidth,
          renderListeners: this.state.renderListeners
        })
      );
    }
  }]);
  return DashboardViewer;
}(_react.Component), _class2.displayName = 'DashboardViewer', _temp)) || _class);
exports.default = DashboardViewer;
module.exports = exports['default'];

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardGridContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _mobxReact = __webpack_require__(10);

var _Izenda3 = __webpack_require__(299);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(301);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2756);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(83);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(1220);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardDesignerGrid = (_dec = (0, _Izenda2.default)(_Izenda10.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DashboardDesignerGrid, _Component);

  function DashboardDesignerGrid(props) {
    (0, _classCallCheck3.default)(this, DashboardDesignerGrid);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardDesignerGrid.__proto__ || (0, _getPrototypeOf2.default)(DashboardDesignerGrid)).call(this, props));

    _this.layoutStore = null;
    _this.parts = [];

    var width = props.width;
    var dashboardDetail = _this.props.store.dashboardDetail;

    _this.layoutStore = new _Izenda12.default(width, dashboardDetail.dashboard.transparentDashboardGrid, true);
    _this.initParts(_this.props);
    return _this;
  }

  (0, _createClass3.default)(DashboardDesignerGrid, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextReportParts = this.getParts(nextProps);

      this.parts.length != nextReportParts.length && this.initParts(nextProps);
    }

    /**
     * Get active parts.
     */

  }, {
    key: 'getParts',
    value: function getParts(_ref) {
      var store = _ref.store;

      return (0, _fp.get)('dashboardDetail.dashboard.activeDashboardParts', store);
    }

    /**
     * Prepare parts for printing
     */

  }, {
    key: 'initParts',
    value: function initParts(props) {
      this.parts = this.getParts(props);
    }
  }, {
    key: 'toLayoutItem',
    value: function toLayoutItem(item) {
      return {
        id: item.id,
        x: item.positionX,
        y: item.positionY,
        width: item.width,
        height: item.height,
        isFullSize: item.isFullSize,
        autoSize: item.reportPart && item.reportPart.autoSize
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          printingMode = _props.printingMode,
          renderListeners = _props.renderListeners,
          cellWidth = _props.cellWidth;

      var layoutData = this.parts.map(this.toLayoutItem);

      this.parts = (0, _fp.placeholder)(this.parts.slice()).sortBy(['positionY', 'positionX']).value();

      var gridItems = this.parts.map(function (dashboardPart) {
        var renderListener = (0, _fp.find)(function (listener) {
          return listener.partId === dashboardPart.id;
        }, renderListeners);

        return _react2.default.createElement(
          _Izenda6.default,
          {
            key: dashboardPart.id,
            id: dashboardPart.id,
            isDraggable: false,
            isResizable: false,
            printingMode: printingMode,
            cancel: '.btn, input, a[href]'
          },
          _react2.default.createElement(_Izenda8.default, {
            printingMode: printingMode,
            dashboardDetail: store.dashboardDetail,
            store: store,
            dashboardPart: dashboardPart,
            finishedRender: renderListener && renderListener.resolve,
            cellWidth: cellWidth
          })
        );
      });

      return _react2.default.createElement(
        'section',
        { className: 'Izenda-DashboardGrid_Section' },
        _react2.default.createElement(
          _Izenda4.default,
          {
            className: 'izenda-DashboardGrid',
            layoutStore: this.layoutStore,
            layoutData: layoutData,
            forDashboard: true,
            printingMode: printingMode
          },
          gridItems
        )
      );
    }
  }]);
  return DashboardDesignerGrid;
}(_react.Component), _class2.displayName = 'DashboardDesignerGrid', _class2.propTypes = {
  store: _react.PropTypes.object.isRequired,
  width: _react.PropTypes.number.isRequired
}, _temp)) || _class);
exports.default = DashboardDesignerGrid;
module.exports = exports['default'];

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTileContent.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(10);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Izenda3 = __webpack_require__(2757);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(1216);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(179);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(413);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2758);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardTileContent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DashboardTileContent, _Component);

  function DashboardTileContent(props) {
    (0, _classCallCheck3.default)(this, DashboardTileContent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardTileContent.__proto__ || (0, _getPrototypeOf2.default)(DashboardTileContent)).call(this, props));

    _this.state = {
      fulfilledData: false
    };

    var store = props.store,
        dashboardPart = props.dashboardPart;

    store.loadDashboardPart(dashboardPart, true).then(function () {
      _this.setState({ fulfilledData: true });
    });
    return _this;
  }

  (0, _createClass3.default)(DashboardTileContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.finishedRender !== nextState.finishedRender) {
        return true;
      }

      if (this.state.fulfilledData === nextState.fulfilledData) {
        return false;
      }
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          dashboardDetail = _props.dashboardDetail,
          dashboardPart = _props.dashboardPart,
          store = _props.store,
          printingMode = _props.printingMode,
          finishedRender = _props.finishedRender,
          cellWidth = _props.cellWidth;


      var disableViewReport = dashboardPart.disableViewReport;
      var type = dashboardPart.type;
      var dashboardTileBodyClass = (0, _classnames2.default)('izenda-DashboardTile-Content-Body', 'u_noPaddingAll u_noMarginAll', 'izenda-DashboardTile-Content-Body-fixed', {
        'u_table u_fullSize': disableViewReport
      });
      var style = printingMode ? { position: 'relative' } : {};

      var tileBody = _react2.default.createElement(
        'div',
        { className: dashboardTileBodyClass, style: style },
        !disableViewReport ? _react2.default.createElement(_Izenda6.default, {
          dashboardPart: dashboardPart,
          viewMode: true,
          store: store,
          printingMode: printingMode,
          fulfilledData: this.state.fulfilledData,
          finishedRender: finishedRender,
          cellWidth: cellWidth
        }) : _react2.default.createElement(_Izenda12.default, { finishedRender: finishedRender })
      );

      var blankBody = _react2.default.createElement(
        'div',
        { className: dashboardTileBodyClass, style: style },
        _react2.default.createElement(_Izenda4.default, {
          cellWidth: cellWidth,
          dashboardPart: dashboardPart,
          finishedRender: finishedRender
        })
      );

      var body = (0, _fp.isNil)(type) ? blankBody : tileBody;
      var dashboardTileClass = (0, _classnames2.default)('izenda-DashboardTile u_noPaddingAll u_noMarginAll', {
        'u_fullSize ': disableViewReport
      });

      var dashboardTileContentClass = (0, _classnames2.default)('izenda-DashboardTile-Content u-posRelative u_noPaddingAll u_noMarginAll', {
        'u_fullSize ': disableViewReport
      });

      return _react2.default.createElement(
        'div',
        { className: dashboardTileClass },
        _react2.default.createElement(
          'div',
          { className: dashboardTileContentClass },
          body,
          _react2.default.createElement(_Izenda10.default, null)
        )
      );
    }
  }]);
  return DashboardTileContent;
}(_react.Component), _class.displayName = 'DashboardTileContent', _class.propTypes = {
  store: _mobxReact.propTypes.observableObject.isRequired,
  dashboardPart: _mobxReact.propTypes.observableObject.isRequired,
  dashboardDetail: _mobxReact.propTypes.observableObject.isRequired
}, _temp);


var tileLoader = {};
exports.default = (0, _Izenda2.default)({
  context: {
    childContextTypes: _Izenda8.default.loaderShape,
    getChildContext: function getChildContext(_ref) {
      var dashboardPart = _ref.dashboardPart;

      if (!tileLoader[dashboardPart.id]) {
        tileLoader[dashboardPart.id] = _Izenda8.default.createLoaderContext();
      }
      return tileLoader[dashboardPart.id];
    }
  }
})(DashboardTileContent);
module.exports = exports['default'];

/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlankDashboardTileContent = function (_Component) {
  (0, _inherits3.default)(BlankDashboardTileContent, _Component);

  function BlankDashboardTileContent() {
    (0, _classCallCheck3.default)(this, BlankDashboardTileContent);
    return (0, _possibleConstructorReturn3.default)(this, (BlankDashboardTileContent.__proto__ || (0, _getPrototypeOf2.default)(BlankDashboardTileContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(BlankDashboardTileContent, [{
    key: 'publishFinishedRender',
    value: function publishFinishedRender() {
      var props = this.props;
      props.finishedRender && props.finishedRender();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.publishFinishedRender();
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var cellWidth = props.cellWidth,
          scaleX = props.scaleX;

      var style = props.dashboardPart.getContainerSize(cellWidth, scaleX);

      return _react2.default.createElement('div', { className: 'u_noPaddingAll u_noMarginAll', style: style });
    }
  }]);
  return BlankDashboardTileContent;
}(_react.Component);
// ----------------------------------------------------------------------
// <copyright file='Izenda.BlankDashboardTileContent.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = BlankDashboardTileContent;
module.exports = exports['default'];

/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// ----------------------------------------------------------------------
// <copyright file="Izenda.NoPermissionPartTile.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoPermissionPartTile = (_dec = (0, _Izenda2.default)(), _dec(_class = function (_Component) {
  (0, _inherits3.default)(NoPermissionPartTile, _Component);

  function NoPermissionPartTile() {
    (0, _classCallCheck3.default)(this, NoPermissionPartTile);
    return (0, _possibleConstructorReturn3.default)(this, (NoPermissionPartTile.__proto__ || (0, _getPrototypeOf2.default)(NoPermissionPartTile)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoPermissionPartTile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;

      props.finishedRender && props.finishedRender();
    }
  }, {
    key: 'render',
    value: function render() {
      var localization = this.props.localization;

      return _react2.default.createElement(
        'div',
        { className: 'u_tableCell u_alignMiddle u_textCenter' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('span', { className: 'icon-info-circled u_LargeIcon' })
        ),
        localization.getText('COMMON_MESSAGES_NOPERMISSION_VIEWREPORT')
      );
    }
  }]);
  return NoPermissionPartTile;
}(_react.Component)) || _class);
exports.default = NoPermissionPartTile;
module.exports = exports['default'];

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _Izenda = __webpack_require__(31);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2760);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2763);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1223);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(2771);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2778);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountRoutes = function AccountRoutes() {
  var ROUTE = _Izenda2.default.getConfigRoute('Account');
  var ACTIVATION_ROUTE = _Izenda2.default.getConfigRoute('Account', 'Activation');
  var LOGIN_ROUTE = _Izenda2.default.getConfigRoute('Account', 'Login');
  var RESET_ROUTE = _Izenda2.default.getConfigRoute('Account', 'ResetPassword');
  var FORGOT_ROUTE = _Izenda2.default.getConfigRoute('Account', 'ForgotPassword');

  return _react2.default.createElement(
    _reactRouter.Route,
    { path: ROUTE.path, component: _Izenda4.default.Container },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Izenda8.default }),
    _react2.default.createElement(_reactRouter.Route, { name: ACTIVATION_ROUTE.name, path: ACTIVATION_ROUTE.path, component: _Izenda6.default }),
    _react2.default.createElement(_reactRouter.Route, { name: LOGIN_ROUTE.name, path: LOGIN_ROUTE.path, component: _Izenda8.default }),
    _react2.default.createElement(_reactRouter.Route, { name: RESET_ROUTE.name, path: RESET_ROUTE.path, component: _Izenda10.default }),
    _react2.default.createElement(_reactRouter.Route, { name: FORGOT_ROUTE.name, path: FORGOT_ROUTE.path, component: _Izenda12.default })
  );
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountRoutes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = AccountRoutes;
module.exports = exports['default'];

/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(1223);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(130);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(27);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var AccountRootContainer = function AccountRootContainer(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    _Izenda6.default,
    null,
    _react2.default.createElement(
      'article',
      { className: 'izenda-Wrapper izenda-Account' },
      _react2.default.createElement(
        'header',
        { className: 'izenda-Account-Header u_block u_fullWidth u_textCenter u-posAbsolute' },
        _react2.default.createElement('div', { className: 'izenda-Logo izenda-Account-logo u_inlineBlock u_fullHeight' })
      ),
      _react2.default.createElement(
        'main',
        { className: 'izenda-Account-Main u_fullWidth u_textCenter u-posAbsolute' },
        children
      )
    )
  );
};
exports.default = { Component: _Izenda2.default, Container: AccountRootContainer, Store: _Izenda4.default };
module.exports = exports['default'];

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _curry = __webpack_require__(2762);

var _curry2 = _interopRequireDefault(_curry);

var _Izenda = __webpack_require__(60);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(130);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(104);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(329);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(315);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(15);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(440);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _compose = __webpack_require__(825);

var _compose2 = _interopRequireDefault(_compose);

var _withHandlers = __webpack_require__(823);

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _withProps = __webpack_require__(822);

var _withProps2 = _interopRequireDefault(_withProps);

var _Izenda15 = __webpack_require__(12);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(31);

var _Izenda18 = _interopRequireDefault(_Izenda17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYBOARD_ENTER_CODE = 13;

/**
 * Check does need to login.
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.LoginActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
// $FlowFixMe
function isLoggedIn() {
  return function (component) {
    var _component$props = component.props,
        authorization = _component$props.authorization,
        router = _component$props.router;

    if (!_Izenda12.default.needLogin && authorization.checkLoginStatus()) {
      var defaultLink = authorization.getDefaultLink(_Izenda18.default);
      router.push(defaultLink);
      return true;
    }

    return false;
  };
}

/**
 * Remove auth's cookies.
 */
function init() {
  return function (component) {
    var _component$props2 = component.props,
        store = _component$props2.store,
        authorization = _component$props2.authorization;

    _Izenda12.default.resetExportingLoadings();
    authorization.clear();
    _Izenda14.default.checkShowOrganization()(store);
  };
}

/**
 * Register event handler
 */
function registerEventHandler() {
  return function register(component) {
    // $FlowFixMe
    $izenda(document).on('keypress', function (e) {
      var key = e.which;
      if (key === KEYBOARD_ENTER_CODE) {
        return signIn(component.props);
      }
    });
  };
}

/**
 * Unregister event handler
 */
function unregisterEventHandler() {
  return function unregister() {
    // $FlowFixMe
    $izenda(document).off('keypress');
  };
}

/**
 * Handle on change tenant name.
 * @param  {Object} props
 * @param  {String} value
 */
function onChangeTenantName(props, event) {
  props.store.model.updateProperty('tenantName', event.target.value);
}

/**
 * Handle on change user name.
 * @param  {Object} props
 * @param  {String} value
 */
function onChangeUserName(props, event) {
  props.store.model.updateProperty('userName', event.target.value);
}

/**
 * Handle on change password.
 * @param  {Object} props
 * @param  {String} value
 */
function onChangePassword(props, event) {
  props.store.model.updateProperty('password', event.target.value);
}

/**
 * Sign in action.
 * @param  {Object} props
 */
function signIn(props) {
  var store = props.store;
  var url = buildRedirectTo(props);
  var loader = props.loader;

  store.model.updateProperty('message');
  loader.startLoading();

  props.validation.validate().then(function (result) {
    if (result) {
      return _Izenda6.default.licenseInfoStore.getLicenseStatus().then(function (licenseStatus) {
        if (licenseStatus) {
          var expiredLicense = licenseStatus.numberOfDayToExpire < 0;
          _Izenda12.default.updateLicenseStatus(expiredLicense);
        }

        return result;
      });
    }
    return result;
  }).then(function (result) {
    if (result) {
      return store.login().then(function (result) {
        var data = result.data || {};

        if (result.success && !data.systemAdmin && _Izenda12.default.expiredLicense) {
          return props.confirmMessage('error', _Izenda16.default.getText('COMMON_MESSAGES_EXPIRED_LICENSE'));
        }

        if (result.success && !data.isExpired) {
          _Izenda12.default.setNeedLogin(false);
          store.model.resetForLogin();

          return _Izenda14.default.setUpAuthInfo(result, props, url, true).then(function () {
            return _Izenda10.default.getProvisioningStatus();
          });
        }

        if (data.isExpired) {
          return props.confirmMessage('info', _Izenda2.default.MESSAGES.M04).then(function () {
            var resetPasswordLink = _Izenda18.default.getRouteUrl(_Izenda18.default.getConfigRoute('Account', 'ResetPassword'), {
              id: data.id
            });
            store.model.resetForLogin();
            props.router.push(resetPasswordLink);
            return (0, _bluebird.resolve)(true);
          });
        }

        return store.loadGeneralErrorMessage(result.messages);
      });
    }
    return (0, _bluebird.resolve)(false);
  }).finally(loader.endLoading.bind(loader));
}

/**
 * Handle on click sign in.
 * @param  {Object} props
 */
function onClickSignIn(props) {
  return function () {
    return signIn(props);
  };
}

/**
 * Build redirect to URL.
 * @param  {Object} props
 */
function buildRedirectTo(props) {
  var query = props.location.query;
  return query.redirectTo ? query.redirectTo : null;
}

/**
 * Handle on click forgot password.
 * @param  {Object} props
 * @param  {Object} obj
 */
function onClickForgotPassword(props) {
  return function () {
    props.store.loadSystemConfig().then(function (result) {
      if (!result.numberOfQuestionProfile) {
        return props.confirmMessage('error', _Izenda2.default.MESSAGES.M08).then(function () {
          return (0, _bluebird.resolve)(false);
        });
      }

      var uriConfig = {
        pathname: _Izenda18.default.getRouteUrl(_Izenda18.default.getConfigRoute('Account', 'ForgotPassword')),
        state: {}
      };
      props.store.model.userName && (uriConfig.state.userName = props.store.model.userName);
      props.store.model.tenantName && (uriConfig.state.tenantName = props.store.model.tenantName);
      props.router.push(uriConfig);

      return (0, _bluebird.resolve)(true);
    });
  };
}

exports.default = (0, _compose2.default)((0, _withProps2.default)({
  store: new _Izenda4.default(),
  authorizationStore: new _Izenda8.default()
}), (0, _withHandlers2.default)({
  isLoggedIn: isLoggedIn,
  init: init,
  registerEventHandler: registerEventHandler,
  unregisterEventHandler: unregisterEventHandler,
  onChangeTenantName: (0, _curry2.default)(onChangeTenantName),
  onChangeUserName: (0, _curry2.default)(onChangeUserName),
  onChangePassword: (0, _curry2.default)(onChangePassword),
  onClickSignIn: onClickSignIn,
  onClickForgotPassword: onClickForgotPassword
}));
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2762 */,
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fp = __webpack_require__(1);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2764);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2765);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2770);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.Activation.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var Activation = function (_Component) {
  (0, _inherits3.default)(Activation, _Component);

  function Activation() {
    (0, _classCallCheck3.default)(this, Activation);
    return (0, _possibleConstructorReturn3.default)(this, (Activation.__proto__ || (0, _getPrototypeOf2.default)(Activation)).apply(this, arguments));
  }

  (0, _createClass3.default)(Activation, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.initStore(this);
      this.props.authorization.clear();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.validateExpirationPasswordLink(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var isExpiration = this.store.model.isExpiration;

      if ((0, _fp.isNil)(isExpiration)) return null;

      return isExpiration ? _react2.default.createElement(_Izenda4.default, null) : _react2.default.createElement(_Izenda6.default, { store: this.store });
    }
  }]);
  return Activation;
}(_react.Component);

exports.default = (0, _Izenda2.default)(_Izenda8.default)(Activation);
module.exports = exports['default'];

/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(60);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExpirationPassword() {
  return _react2.default.createElement(
    'div',
    { className: 'izenda-Account-errorMessage u_inlineBlock u_borderAll u_paddingAll izenda-Account-expirationPassword' },
    _react2.default.createElement('i', { className: 'icon-error-circled' }),
    _Izenda4.default.MESSAGES.M15
  );
}
// ----------------------------------------------------------------------
// <copyright file='Izenda.ExpirationPassword.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = (0, _Izenda2.default)()(ExpirationPassword);
module.exports = exports['default'];

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1224);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2767);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(2769);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordSetup = function (_Component) {
  (0, _inherits3.default)(PasswordSetup, _Component);

  function PasswordSetup() {
    (0, _classCallCheck3.default)(this, PasswordSetup);
    return (0, _possibleConstructorReturn3.default)(this, (PasswordSetup.__proto__ || (0, _getPrototypeOf2.default)(PasswordSetup)).apply(this, arguments));
  }

  (0, _createClass3.default)(PasswordSetup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.updateToAccountInfoStep(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          isExpiration = _props.store.model.isExpiration;

      if (isExpiration) return null;

      return _react2.default.createElement(
        'div',
        { className: 'izenda-Account-PasswordSetup u_inlineBlock' },
        _react2.default.createElement(_Izenda4.default, { store: store }),
        _react2.default.createElement(_Izenda6.default, { store: store })
      );
    }
  }]);
  return PasswordSetup;
}(_react.Component);
// ----------------------------------------------------------------------
// <copyright file='Izenda.PasswordSetup.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


exports.default = (0, _Izenda2.default)(_Izenda8.default)(PasswordSetup);
module.exports = exports['default'];

/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = __webpack_require__(18);

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(440);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Handle on change tenant name
 * @param  {Object} props
 * @param  {Object} value
 */
function onChangeTenantName(props, e) {
  props.store.model.updateProperty('tenantName', e.target.value);
}

/**
 * Handle on change user name.
 * @param  {Object} props
 * @param  {Object} value
 */

// $FlowFixMe

// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountInfoActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

function onChangeUserName(props, e) {
  props.store.model.updateProperty('userName', e.target.value);
}

/**
 * Handle on change first name.
 * @param  {Object} props
 * @param  {Object} value
 */
function onChangeFirstName(props, e) {
  props.store.model.updateProperty('firstName', e.target.value);
}

/**
 * Handle on change last name.
 * @param  {Object} props
 * @param  {Object} value
 */
function onChangeLastName(props, e) {
  props.store.model.updateProperty('lastName', e.target.value);
}

/**
 * Handle on change email address.
 * @param  {Object} props
 * @param  {Object} value
 */
function onChangeEmailAddress(props, e) {
  props.store.model.updateProperty('emailAddress', e.target.value);
}

/**
 * Handle on click next.
 * @param  {Object} props
 */
function onClickNext(props) {
  return function () {
    var store = props.store,
        validation = props.validation;


    validation.validate().then(function (result) {
      if (result) {
        return store.validatePasswordLink().then(function (result) {
          if (!(0, _fp.isNil)(result.messages)) {
            validation.updateErrors(result.messages);
          }
        });
      }
      return (0, _bluebird.resolve)(false);
    });
  };
}

var accountInfoActions = (0, _recompose.withHandlers)({
  checkShowOrganization: _Izenda2.default.checkShowOrganization,
  onChangeTenantName: (0, _fp.curry)(onChangeTenantName),
  onChangeUserName: (0, _fp.curry)(onChangeUserName),
  onChangeFirstName: (0, _fp.curry)(onChangeFirstName),
  onChangeLastName: (0, _fp.curry)(onChangeLastName),
  onChangeEmailAddress: (0, _fp.curry)(onChangeEmailAddress),
  onClickNext: onClickNext
});

exports.default = accountInfoActions;
module.exports = exports['default'];

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.SecurityInfo.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var Panel = __webpack_require__(28);
  var GridLayout = __webpack_require__(13);
  var DropDown = __webpack_require__(29);
  var AccountConstants = __webpack_require__(60);
  var EventUtils = __webpack_require__(24);
  var Validator = __webpack_require__(23);
  var ValidateInput = Validator()(__webpack_require__(17));
  var actions = __webpack_require__(2768);

  var _require = __webpack_require__(1),
      isNil = _require.isNil,
      concat = _require.concat,
      orderBy = _require.orderBy;

  var Header = function header(props) {
    var localization = props.localization;

    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        null,
        localization.getText('ACOUNT_MESSAGE_PROVIDE_NEW_PASSWORD_SECURITY_TO_FURTHER_PROCEED')
      ),
      !isNil(props.message) ? React.createElement(
        'div',
        { className: 'izenda-Account-errorMessage u_textLeft' },
        props.message
      ) : null
    );
  };

  var Footer = function footer(props) {
    var localization = props.localization;

    return React.createElement(
      'div',
      { className: 'u_textRight' },
      React.createElement(
        'button',
        { className: 'btn btn-primary izenda-Account-btn', onClick: props.onClickBack },
        localization.getText('ACOUNT_LABEL_BACK')
      ),
      React.createElement(
        'button',
        { className: 'btn btn-primary izenda-Account-btn', onClick: props.onClickSubmit },
        localization.getText('ACOUNT_LABEL_SUBMIT')
      )
    );
  };

  var SecurityInfo = React.createClass({
    displayName: 'SecurityInfo',

    /**
     * Render security questions
     */
    renderSecurityQuestions: function renderSecurityQuestions() {
      var props = this.props;
      var model = props.store.model;
      var questions = model.userSecurityQuestions;
      var localization = props.localization;

      if (!questions.length) return null;
      var index = 0;
      return questions.map(function (question) {
        var options = concat(question, model.securityQuestions);
        options = orderBy(['question'], ['asc'], options);
        index++;
        return React.createElement(
          GridLayout.Row,
          { key: index },
          React.createElement(
            GridLayout,
            null,
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '4', className: 'u_textRight' },
                React.createElement(
                  'label',
                  { className: 'validation required' },
                  localization.getText('ACOUNT_LABEL_SECURITY_QUESTION'),
                  ' ',
                  index
                )
              ),
              React.createElement(
                GridLayout.Col,
                { cols: '8', className: 'izenda-SecurityInfo-Question' },
                renderQuestion(question, options)
              )
            ),
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '4', className: 'u_textRight' },
                React.createElement(
                  'label',
                  { className: 'validation required' },
                  localization.getText('ACOUNT_LABEL_YOUR_ANSWER')
                )
              ),
              React.createElement(
                GridLayout.Col,
                { cols: '8', className: 'izenda-SecurityInfo-Question' },
                renderAnswer(question)
              )
            )
          )
        );
      }.bind(this));

      /**
       * Render question.
       */
      function renderQuestion(question, options) {
        return React.createElement(DropDown, {
          options: options,
          labelField: 'question',
          valueField: 'securityQuestionId',
          value: question.securityQuestionId,
          onChange: EventUtils.notifyChange(updateValue, EventUtils.SELECT),
          validations: AccountConstants.CONSTRAINTS.question
        });

        /**
         * Handle change question.
         */
        function updateValue(data) {
          props.onChangeQuestion(question, data.value);
        }
      }

      /**
       * Render answer.
       */
      function renderAnswer(question) {
        return React.createElement(ValidateInput, {
          type: 'text',
          className: 'form-control',
          value: question.answer,
          onChange: EventUtils.notifyChange(updateValue, EventUtils.INPUT),
          field: 'answer-' + question.securityQuestionId,
          validations: AccountConstants.CONSTRAINTS.answer
        });

        /**
         * Handle change answer.
         */
        function updateValue(data) {
          props.onChangeAnswer(question, data);
        }
      }
    },

    /**
     * Render separator between password and security question.
     */
    renderSeparator: function renderSeparator() {
      var props = this.props;
      var model = props.store.model;
      var questions = model.userSecurityQuestions;
      if (!questions.length) return null;
      return React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: '12' },
          React.createElement('hr', { className: 'u_noMarginAll' })
        )
      );
    },

    /**
     * Render body.
     */
    renderBody: function renderBody() {
      var props = this.props;
      var model = props.store.model;
      var localization = props.localization;

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '4', className: 'u_textLeft' },
            React.createElement(
              'label',
              { className: 'validation required' },
              localization.getText('ACOUNT_LABEL_NEW_PASSWORD')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '8' },
            React.createElement(ValidateInput, {
              type: 'password',
              className: 'form-control',
              value: model.password,
              onChange: EventUtils.notifyChange(props.onChangePassword, EventUtils.INPUT),
              field: 'password',
              validations: AccountConstants.CONSTRAINTS.password
            })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '4', className: 'u_textLeft' },
            React.createElement(
              'label',
              { className: 'validation required' },
              localization.getText('ACOUNT_LABEL_CONFIRM_NEW_PASSWORD')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '8' },
            React.createElement(ValidateInput, {
              type: 'password',
              className: 'form-control',
              value: model.confirmPassword,
              onChange: EventUtils.notifyChange(props.onChangeConfirmPassword, EventUtils.INPUT),
              field: 'confirmPassword',
              validations: AccountConstants.CONSTRAINTS.confirmPassword
            })
          )
        ),
        this.renderSeparator(),
        this.renderSecurityQuestions()
      );
    },

    render: function render() {
      var props = this.props;
      var model = this.props.store.model;
      if (!model.isCurrentStep(AccountConstants.STEP_KEYS.SecurityInfo)) return null;

      var header = {
        component: Header,
        message: model.message,
        localization: props.localization
      };

      var footer = {
        component: Footer,
        onClickBack: props.onClickBack,
        onClickSubmit: props.onClickSubmit,
        localization: props.localization
      };

      return React.createElement(
        Panel,
        { className: 'izenda-Account-Container', header: header, footer: footer },
        this.renderBody()
      );
    }
  });

  module.exports = connect(actions)(SecurityInfo);
}();

/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityInfoActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withProps = __webpack_require__(9).withProps;
  var AccountConstants = __webpack_require__(60);
  var AccountUtils = __webpack_require__(440);
  var AuthorizationStore = __webpack_require__(329);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var securityInfoActions = compose(withProps(function () {
    return {
      authorizationStore: new AuthorizationStore()
    };
  }), withHandlers({
    onChangePassword: curry(onChangePassword),
    onChangeConfirmPassword: curry(onChangeConfirmPassword),
    onChangeQuestion: curry(onChangeQuestion),
    onChangeAnswer: curry(onChangeAnswer),
    onClickBack: curry(onClickBack),
    onClickSubmit: curry(onClickSubmit)
  }));

  /**
   * Handle on change password.
   * @param  {Object} props
   * @param  {String} value
   */
  function onChangePassword(props, value) {
    props.store.model.updateProperty('password', value);
  }

  /**
   * Handle on change confirm password.
   * @param  {Object} props
   * @param  {String} value
   */
  function onChangeConfirmPassword(props, value) {
    props.store.model.updateProperty('confirmPassword', value);
  }

  /**
   * Handle on change question.
   * @param  {Object} props
   * @param  {Object} question
   * @param  {String} value
   */
  function onChangeQuestion(props, question, value) {
    props.store.model.updateUserSecurityQuestion(question, 'securityQuestionId', value);
  }

  /**
   * Handle on change Answer.
   * @param  {Object} props
   * @param  {Object} question
   * @param  {String} value
   */
  function onChangeAnswer(props, question, value) {
    props.store.model.updateUserSecurityQuestion(question, 'answer', value);
  }

  /**
   * Handle on click back.
   * @param  {Object} props
   * @param  {Object} obj
   */
  function onClickBack(props, obj) {
    props.store.model.updateCurrentStep(AccountConstants.STEP_KEYS.AccountInfo);
  }

  /**
   * Handle on click submit.
   * @param  {Object} props
   * @param  {Object} obj
   */
  function onClickSubmit(props, obj) {
    var store = props.store;
    return props.validation.validate().then(function (result) {
      if (result) {
        var loader = props.loader;
        loader.startLoading();
        return store.passwordAndSecurityQuestion().then(function (result) {
          if (result.success) {
            return props.confirmMessage('info', AccountConstants.MESSAGES.M02).then(function () {
              return AccountUtils.setUpAuthInfo(result, props);
            });
          }

          return store.loadGeneralErrorMessage(result.messages);
        }).finally(loader.endLoading.bind(loader));
      }
      return (0, _bluebird.resolve)(false);
    });
  }

  module.exports = securityInfoActions;
}();

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordSetupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var AccountConstants = __webpack_require__(60);

  var passwordSetupActions = compose(withHandlers({
    updateToAccountInfoStep: updateToAccountInfoStep
  }));

  /**
   * Update to account info step.
   */
  function updateToAccountInfoStep() {
    return function (component) {
      var model = component.props.store.model;

      if (!model.isExpiration) {
        model.updateCurrentStep(AccountConstants.STEP_KEYS.AccountInfo);
        // TODO hanlde show/hide organization
      }
    };
  }

  module.exports = passwordSetupActions;
}();

/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.ActivationActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var AccountConstants = __webpack_require__(60);
  var AccountStore = __webpack_require__(130);

  var activationActions = compose(withHandlers({
    initStore: initStore,
    validateExpirationPasswordLink: validateExpirationPasswordLink
  }));

  /**
   * Initial store.
   */
  function initStore() {
    return function (component) {
      component.store = new AccountStore();
    };
  }

  /**
   * Validate expiration of password link.
   */
  function validateExpirationPasswordLink() {
    return function (component) {
      var props = component.props;
      var query = props.location.query;
      var verification = query.verification;
      var store = component.store;
      var loader = props.loader;

      loader.startLoading();
      return store.validateExpirationPasswordLink(verification).then(function (result) {
        store.updateInfoAfterCheckedPasswordLink(verification, result.success ? result.data.isExpired : null);
        return (0, _bluebird.resolve)(result.success);
      }).finally(loader.endLoading.bind(loader));
    };
  }

  module.exports = activationActions;
}();

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class; // ----------------------------------------------------------------------
// <copyright file='Izenda.ResetPasswordWrapper.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1225);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2777);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPasswordWrapper = (_dec = (0, _Izenda2.default)(_Izenda6.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ResetPasswordWrapper, _Component);

  function ResetPasswordWrapper() {
    (0, _classCallCheck3.default)(this, ResetPasswordWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (ResetPasswordWrapper.__proto__ || (0, _getPrototypeOf2.default)(ResetPasswordWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(ResetPasswordWrapper, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.initStore(this);
      this.props.updateUserId(this);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Izenda4.default, { store: this.store });
    }
  }]);
  return ResetPasswordWrapper;
}(_react.Component)) || _class);
exports.default = ResetPasswordWrapper;
module.exports = exports['default'];

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.SimpleSecurityInfo.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var Panel = __webpack_require__(28);
  var GridLayout = __webpack_require__(13);
  var AccountConstants = __webpack_require__(60);
  var EventUtils = __webpack_require__(24);
  var Validator = __webpack_require__(23);
  var ValidateInput = Validator()(__webpack_require__(17));
  var actions = __webpack_require__(2773);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var Header = function header(props) {
    var localization = props.localization;

    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        null,
        localization.getText('ACOUNT_MESSAGE_PROVIDE_NEW_PASSWORD_SECURITY_TO_FURTHER_PROCEED')
      ),
      !isNil(props.message) ? React.createElement(
        'div',
        { className: 'izenda-Account-errorMessage izenda-Account-errorMessage-info u_textLeft' },
        props.message
      ) : null
    );
  };

  var Footer = function footer(props) {
    var localization = props.localization;

    return React.createElement(
      'div',
      { className: 'u_textRight' },
      React.createElement(
        'button',
        { className: 'btn btn-primary izenda-Account-btn', onClick: props.onClickBack },
        localization.getText('ACOUNT_LABEL_BACK')
      ),
      React.createElement(
        'button',
        { className: 'btn btn-primary izenda-Account-btn', onClick: props.onClickNext },
        localization.getText('ACOUNT_LABEL_NEXT')
      )
    );
  };

  var SimpleSecurityInfo = React.createClass({
    displayName: 'SimpleSecurityInfo',

    /**
     * Render security questions
     */
    renderSecurityQuestions: function renderSecurityQuestions() {
      var props = this.props;
      var model = props.store.model;
      var questions = model.userSecurityQuestions;
      if (!questions.length) return null;
      return questions.map(function (question) {
        return React.createElement(
          GridLayout.Row,
          { key: question.question },
          React.createElement(
            GridLayout,
            null,
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '11', offset: '1', className: 'izenda-SecurityInfo-Question u_textLeft' },
                React.createElement(
                  'label',
                  { className: 'validation required' },
                  question.question
                )
              )
            ),
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '11', offset: '1', className: 'izenda-SecurityInfo-Question' },
                renderAnswer(question)
              )
            )
          )
        );
      }.bind(this));

      /**
       * Render answer.
       */
      function renderAnswer(question) {
        return React.createElement(ValidateInput, {
          type: 'text',
          className: 'form-control',
          value: question.answer,
          onChange: EventUtils.notifyChange(updateValue, EventUtils.INPUT),
          field: 'answer-' + question.securityQuestionId,
          validations: AccountConstants.CONSTRAINTS.answer
        });

        /**
         * Handle change answer.
         */
        function updateValue(data) {
          props.onChangeAnswer(question, data);
        }
      }
    },

    /**
     * Render body.
     */
    renderBody: function renderBody() {
      var props = this.props;
      var model = props.store.model;
      return React.createElement(
        GridLayout,
        null,
        this.renderSecurityQuestions()
      );
    },

    render: function render() {
      var props = this.props;
      var model = this.props.store.model;
      if (!model.isCurrentStep(AccountConstants.STEP_KEYS.QuestionInfo)) return null;

      var header = {
        component: Header,
        message: model.message,
        localization: props.localization
      };

      var footer = {
        component: Footer,
        onClickBack: props.onClickBack,
        onClickNext: props.onClickNext,
        store: props.store,
        localization: props.localization
      };

      return React.createElement(
        Panel,
        { className: 'izenda-Account-Container', header: header, footer: footer },
        this.renderBody()
      );
    }
  });

  module.exports = connect(actions)(SimpleSecurityInfo);
}();

/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleSecurityInfoActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var AccountConstants = __webpack_require__(60);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var simpleSecurityInfoActions = compose(withHandlers({
    onChangeAnswer: curry(onChangeAnswer),
    onClickBack: curry(onClickBack),
    onClickNext: curry(onClickNext)
  }));

  /**
   * Handle on change Answer.
   * @param  {Object} props
   * @param  {Object} question
   * @param  {String} value
   */
  function onChangeAnswer(props, question, value) {
    props.store.model.updateUserSecurityQuestion(question, 'answer', value);
  }

  /**
   * Handle on click back.
   * @param  {Object} props
   * @param  {Object} obj
   */
  function onClickBack(props, obj) {
    props.store.model.updateCurrentStep(AccountConstants.STEP_KEYS.AccountInfo);
  }

  /**
   * Handle on click next.
   * @param  {Object} props
   * @param  {Object} obj
   */
  function onClickNext(props, obj) {
    return props.validation.validate().then(function (result) {
      if (result) {
        var loader = props.loader;
        loader.startLoading();
        return props.store.validateSecurityQuestion().then(function (result) {
          if (result.success) {
            return props.store.model.updateCurrentStep(AccountConstants.STEP_KEYS.PasswordInfo);
          }

          return props.store.loadGeneralErrorMessage(result.messages);
        }).finally(loader.endLoading.bind(loader));
      }
      return (0, _bluebird.resolve)(false);
    });
  }

  module.exports = simpleSecurityInfoActions;
}();

/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file='Izenda.PasswordInfo.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var Panel = __webpack_require__(28);
  var GridLayout = __webpack_require__(13);
  var AccountConstants = __webpack_require__(60);
  var EventUtils = __webpack_require__(24);
  var Validator = __webpack_require__(23);
  var ValidateInput = Validator()(__webpack_require__(17));
  var actions = __webpack_require__(2775);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var Header = function header(props) {
    var localization = props.localization;

    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        null,
        localization.getText('ACOUNT_MESSAGE_PROVIDE_NEW_PASSWORD_SECURITY_TO_FURTHER_PROCEED')
      ),
      !isNil(props.message) ? React.createElement(
        'div',
        { className: 'izenda-Account-errorMessage izenda-Account-errorMessage-info u_textLeft' },
        props.message
      ) : null
    );
  };

  var Footer = function footer(props) {
    var localization = props.localization;

    return React.createElement(
      'div',
      { className: 'u_textRight' },
      React.createElement(
        'button',
        { className: 'btn btn-primary izenda-Account-btn', onClick: props.onClickBack },
        localization.getText('ACOUNT_LABEL_BACK')
      ),
      React.createElement(
        'button',
        { className: 'btn btn-primary izenda-Account-btn', onClick: props.onClickSubmit },
        localization.getText('ACOUNT_LABEL_SUBMIT')
      )
    );
  };

  var PasswordInfo = React.createClass({
    displayName: 'PasswordInfo',

    /**
     * Render body.
     */
    renderBody: function renderBody() {
      var props = this.props;
      var model = props.store.model;
      var localization = props.localization;

      return React.createElement(
        GridLayout,
        null,
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '4', className: 'u_textLeft' },
            React.createElement(
              'label',
              { className: 'validation required' },
              localization.getText('ACOUNT_LABEL_NEW_PASSWORD')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '8' },
            React.createElement(ValidateInput, {
              type: 'password',
              className: 'form-control',
              value: model.password,
              onChange: EventUtils.notifyChange(props.onChangePassword, EventUtils.INPUT),
              field: 'password',
              validations: AccountConstants.CONSTRAINTS.password
            })
          )
        ),
        React.createElement(
          GridLayout.Row,
          null,
          React.createElement(
            GridLayout.Col,
            { cols: '4', className: 'u_textLeft' },
            React.createElement(
              'label',
              { className: 'validation required' },
              localization.getText('ACOUNT_LABEL_CONFIRM_NEW_PASSWORD')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '8' },
            React.createElement(ValidateInput, {
              type: 'password',
              className: 'form-control',
              value: model.confirmPassword,
              onChange: EventUtils.notifyChange(props.onChangeConfirmPassword, EventUtils.INPUT),
              field: 'confirmPassword',
              validations: AccountConstants.CONSTRAINTS.confirmPassword
            })
          )
        )
      );
    },

    render: function render() {
      var props = this.props;
      var model = this.props.store.model;
      if (!model.isCurrentStep(AccountConstants.STEP_KEYS.PasswordInfo)) return null;

      var header = {
        component: Header,
        message: model.message,
        localization: props.localization
      };

      var footer = {
        component: Footer,
        onClickBack: props.onClickBack,
        onClickSubmit: props.onClickSubmit,
        localization: props.localization
      };

      return React.createElement(
        Panel,
        { className: 'izenda-Account-Container', header: header, footer: footer },
        this.renderBody()
      );
    }
  });

  module.exports = connect(actions)(PasswordInfo);
}();

/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityInfoActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var withProps = __webpack_require__(9).withProps;
  var AccountConstants = __webpack_require__(60);
  var Config = __webpack_require__(40);
  var AccountUtils = __webpack_require__(440);
  var AuthorizationStore = __webpack_require__(329);
  var routeUtils = __webpack_require__(31);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var securityInfoActions = compose(withProps(function () {
    return {
      authorizationStore: new AuthorizationStore()
    };
  }), withHandlers({
    onChangePassword: curry(onChangePassword),
    onChangeConfirmPassword: curry(onChangeConfirmPassword),
    onClickBack: curry(onClickBack),
    onClickSubmit: curry(onClickSubmit)
  }));

  /**
   * Handle on change password.
   * @param  {Object} props
   * @param  {String} value
   */
  function onChangePassword(props, value) {
    props.store.model.updateProperty('password', value);
  }

  /**
   * Handle on change confirm password.
   * @param  {Object} props
   * @param  {String} value
   */
  function onChangeConfirmPassword(props, value) {
    props.store.model.updateProperty('confirmPassword', value);
  }

  /**
   * Handle on click back.
   * @param  {Object} props
   * @param  {Object} obj
   */
  function onClickBack(props, obj) {
    props.store.model.updateCurrentStep(AccountConstants.STEP_KEYS.QuestionInfo);
  }

  /**
   * Handle on click submit.
   * @param  {Object} props
   * @param  {Object} obj
   */
  function onClickSubmit(props, obj) {
    return props.validation.validate().then(function (result) {
      if (result) {
        var loader = props.loader;
        var store = props.store;
        loader.startLoading();
        return store.updatePassword().then(function (result) {
          if (result.success) {
            return AccountUtils.setUpAuthInfo(result, props);
          }

          return store.loadGeneralErrorMessage(result.messages);
        }).finally(loader.endLoading.bind(loader));
      }
      return (0, _bluebird.resolve)(false);
    });
  }

  module.exports = securityInfoActions;
}();

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ResetPasswordActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var AccountConstants = __webpack_require__(60);
  var AccountStore = __webpack_require__(130);

  var resetPasswordActions = compose(withHandlers({
    updateToAccountInfoStep: updateToAccountInfoStep
  }));

  /**
   * Update to account info step.
   */
  function updateToAccountInfoStep(props) {
    return function (component) {
      var model = component.props.store.model;
      model.updateCurrentStep(AccountConstants.STEP_KEYS.AccountInfo);
    };
  }

  module.exports = resetPasswordActions;
}();

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ResetPasswordWrapperActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var AccountStore = __webpack_require__(130);
  var AccountConstants = __webpack_require__(60);

  var resetPasswordWrapperActions = compose(withHandlers({
    initStore: initStore,
    updateUserId: updateUserId
  }));

  /**
   * Initial store.
   */
  function initStore() {
    return function (component) {
      component.store = new AccountStore(AccountConstants.MODES.RESET_PASSWORD);
    };
  }

  /**
   * Update user's id.
   */
  function updateUserId() {
    return function (component) {
      var props = component.props;
      var id = props.params.id;

      component.store.model.updateProperty('id', id);
    };
  }

  module.exports = resetPasswordWrapperActions;
}();

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1225);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2779);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file='Izenda.ForgotPasswordWrapper.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var ForgotPasswordWrapper = function (_Component) {
  (0, _inherits3.default)(ForgotPasswordWrapper, _Component);

  function ForgotPasswordWrapper() {
    (0, _classCallCheck3.default)(this, ForgotPasswordWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (ForgotPasswordWrapper.__proto__ || (0, _getPrototypeOf2.default)(ForgotPasswordWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(ForgotPasswordWrapper, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.initStore(this);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Izenda4.default, { store: this.store });
    }
  }]);
  return ForgotPasswordWrapper;
}(_react.Component);

exports.default = (0, _Izenda2.default)(_Izenda6.default)(ForgotPasswordWrapper);
module.exports = exports['default'];

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ForgotPasswordWrapperActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var AccountStore = __webpack_require__(130);
  var AccountConstants = __webpack_require__(60);

  var forgotPasswordWrapperActions = compose(withHandlers({
    initStore: initStore
  }));

  /**
   * Initial store.
   */
  function initStore() {
    return function (component) {
      component.store = new AccountStore(AccountConstants.MODES.FORGOT_PASSWORD);
      var state = component.props.location.state;
      if (state) {
        component.store.model.updateProperty('userName', state.userName);
        component.store.model.updateProperty('tenantName', state.tenantName);
      }
    };
  }

  module.exports = forgotPasswordWrapperActions;
}();

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _Izenda = __webpack_require__(2781);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfileRoutes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = function () {
    var ROUTE = _config2.default.RoutesMerge.MyProfile;

    return _react2.default.createElement(_reactRouter.Route, { path: ROUTE.path, component: _Izenda2.default.Container });
};

module.exports = exports['default'];

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2782);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(130);

var _Izenda4 = _interopRequireDefault(_Izenda3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyProfileRoot = function (_Component) {
  (0, _inherits3.default)(MyProfileRoot, _Component);

  function MyProfileRoot() {
    (0, _classCallCheck3.default)(this, MyProfileRoot);
    return (0, _possibleConstructorReturn3.default)(this, (MyProfileRoot.__proto__ || (0, _getPrototypeOf2.default)(MyProfileRoot)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyProfileRoot, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.accountStore = new _Izenda4.default();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({}, this.props, { store: this.accountStore }));
    }
  }]);
  return MyProfileRoot;
}(_react.Component);
// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfileRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

exports.default = { Container: MyProfileRoot };
module.exports = exports['default'];

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _initialiseProps;
// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfile.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(15);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(332);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(156);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(333);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(2783);

var _Izenda12 = _interopRequireDefault(_Izenda11);

var _Izenda13 = __webpack_require__(2793);

var _Izenda14 = _interopRequireDefault(_Izenda13);

var _Izenda15 = __webpack_require__(331);

var _Izenda16 = _interopRequireDefault(_Izenda15);

var _Izenda17 = __webpack_require__(339);

var _Izenda18 = _interopRequireDefault(_Izenda17);

var _Izenda19 = __webpack_require__(334);

var _Izenda20 = _interopRequireDefault(_Izenda19);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var viewComponents = {
  myPreference: {
    component: _Izenda12.default
  },
  securityOptions: {
    component: _Izenda14.default
  },
  notFound: {
    component: __webpack_require__(213)
  }
};

function getComponentInfo(key) {
  return (0, _fp.placeholder)(viewComponents).get(key, viewComponents.notFound);
}

var MyProfile = (_dec = (0, _Izenda2.default)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyProfile, _Component);

  function MyProfile(props) {
    (0, _classCallCheck3.default)(this, MyProfile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MyProfile.__proto__ || (0, _getPrototypeOf2.default)(MyProfile)).call(this, props));

    _initialiseProps.call(_this);

    _this.settingStore = new _Izenda18.default();
    _Izenda4.default.currentUser.systemAdmin && _Izenda4.default.setDisableSettingLevel(true);
    return _this;
  }

  (0, _createClass3.default)(MyProfile, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _Izenda4.default.enableSystemSetting();
      this.settingStore.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var model = this.props.store.contextMenu;
      var renderChangedIcon = function renderChangedIcon(item) {
        return item.isDirty ? _react2.default.createElement('span', { className: 'icon-attention warning-color', title: 'Data source changes' }) : '';
      };

      return _react2.default.createElement(
        'section',
        { className: 'izenda-Wrapper' },
        _react2.default.createElement(_Izenda16.default, { store: this.settingStore }),
        _react2.default.createElement(
          _Izenda10.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'izenda-TableLayout u_paddingTopBottom' },
            _react2.default.createElement(
              _Izenda6.default,
              null,
              _react2.default.createElement(_Izenda20.default, {
                dataSource: model.contextMenu,
                activeKey: model.contextMenuActiveLink,
                enabled: true,
                onSelected: this.changeActiveKey,
                renderChangedIcon: renderChangedIcon
              })
            ),
            _react2.default.createElement(
              _Izenda8.default,
              null,
              this.renderContent()
            )
          )
        )
      );
    }
  }]);
  return MyProfile;
}(_react.Component), _class2.propTypes = {
  store: _propTypes2.default.object.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.renderContent = function () {
    var store = _this2.props.store;

    var info = getComponentInfo(store.contextMenu.contextMenuActiveLink);
    return _react2.default.createElement(info.component, { store: store });
  };

  this.changeActiveKey = function (newLink) {
    var props = _this2.props,
        contextMenu = _this2.props.store.contextMenu;


    if (contextMenu.contextMenuActiveLink !== newLink) {
      props.confirmDirtyForm(_Izenda4.default.isDirty, { onConfirmDirtyForm: _Izenda4.default.onOkDirtyForm }).then(function () {
        contextMenu.changeActiveLink(newLink);
      });
    }
  };
}, _temp)) || _class);
exports.default = MyProfile;
module.exports = exports['default'];

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreference.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var ScrollBox = __webpack_require__(27);
  var MyProfileToolbar = __webpack_require__(2784);
  var MyPreferenceId = __webpack_require__(2786);
  var MyPreferenceFirstName = __webpack_require__(2787);
  var MyPreferenceLastName = __webpack_require__(2788);
  var MyPreferenceEmail = __webpack_require__(2789);
  var MyPreferenceRole = __webpack_require__(2790);
  var MyPreferenceTimeZone = __webpack_require__(2791);
  var MyPreferenceLanguageInfo = __webpack_require__(2792);

  var MyPreference = React.createClass({
    displayName: 'MyPreference',

    PropTypes: {
      store: ObservablePropTypes.observableObject.isRequired
    },

    componentDidMount: function componentDidMount() {
      var store = this.props.store;
      store.init();
      store.getMyProfile();
    },

    componentWillUnmount: function componentWillUnmount() {
      this.props.store.destroy();
    },

    render: function render() {
      var store = this.props.store;

      return React.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        React.createElement(MyProfileToolbar, { store: store }),
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          React.createElement(
            ScrollBox,
            null,
            React.createElement(
              'div',
              { className: 'u_paddingLeftRight' },
              React.createElement(
                GridLayout,
                { className: 'u_paddingAll u-bgWhite' },
                React.createElement(MyPreferenceId, { store: store }),
                React.createElement(MyPreferenceFirstName, { store: store }),
                React.createElement(MyPreferenceLastName, { store: store }),
                React.createElement(MyPreferenceEmail, { store: store }),
                React.createElement(MyPreferenceRole, { store: store }),
                React.createElement(MyPreferenceTimeZone, { store: store }),
                React.createElement(MyPreferenceLanguageInfo, { store: store })
              )
            )
          )
        )
      );
    }
  });

  module.exports = connect()(MyPreference);
}();

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// ----------------------------------------------------------------------
// <copyright file='Izenda.MyProfileToolbar.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(639);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(2);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(86);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(30);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _mobxReact = __webpack_require__(10);

var _Izenda9 = __webpack_require__(2785);

var _Izenda10 = _interopRequireDefault(_Izenda9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyProfileToolbar = (_dec = (0, _Izenda4.default)(_Izenda10.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyProfileToolbar, _Component);

  function MyProfileToolbar() {
    (0, _classCallCheck3.default)(this, MyProfileToolbar);
    return (0, _possibleConstructorReturn3.default)(this, (MyProfileToolbar.__proto__ || (0, _getPrototypeOf2.default)(MyProfileToolbar)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyProfileToolbar, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.model.reset();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          localization = _props.localization,
          alertMessage = _props.store.model.alertMessage;


      return _react2.default.createElement(
        'div',
        { className: 'izenda-Wrapper-header' },
        _react2.default.createElement(
          'div',
          { className: 'u_inlineBlock u_fullWidth' },
          _react2.default.createElement(_Izenda6.default, null),
          _react2.default.createElement(_Izenda2.default, { alertMessage: alertMessage }),
          _react2.default.createElement(
            'div',
            { className: 'izenda-ActionBarLeft u_paddingTop' },
            _react2.default.createElement(
              'strong',
              { className: 'u_textUppercase' },
              localization.getText('USER_MENU_MY_PROFILE')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'izenda-ActionBarRight' },
            _react2.default.createElement(_Izenda8.default, { label: localization.getText('COMMON_LABEL_SAVE'), onClick: this.props.onSave }),
            _react2.default.createElement(_Izenda8.default, { label: localization.getText('COMMON_LABEL_CANCEL'), onClick: this.props.onCancel })
          )
        )
      );
    }
  }]);
  return MyProfileToolbar;
}(_react.Component), _class2.propTypes = {
  store: _mobxReact.propTypes.observableObject.isRequired
}, _temp)) || _class);
exports.default = MyProfileToolbar;
module.exports = exports['default'];

/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__(9);

var _Izenda = __webpack_require__(15);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(37);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Save my profile
 * @param {Object} props
 */

// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfileToolbarActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var onSave = function onSave(props) {
  return function () {
    var loader = props.loader,
        localization = props.localization,
        validation = props.validation,
        _props$store = props.store,
        model = _props$store.model,
        isDirty = _props$store.model.isDirty;


    validation.validate().then(function (success) {
      if (success) {
        loader.startLoading();

        if (isDirty) {
          return handleSave(props);
        } else {
          model.alertMessage = {
            type: _Izenda4.default.MESSAGE_TYPE.INFO,
            message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
          };
        }
      }
    }).finally(loader.endLoading.bind(loader));
  };
};

/**
 * @param {Object} props
 */
var handleSave = function handleSave(props) {
  var localization = props.localization,
      validation = props.validation,
      store = props.store,
      model = props.store.model;

  return props.confirmFn('Confirmation', {
    description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
  }).then(function () {
    return store.save().then(function (result) {
      if (!(0, _fp.isNil)(result.messages)) {
        (0, _fp.isEmpty)(result.messages[0].key) ? model.alertMessage = {
          type: 'info',
          message: result.messages[0].messages[0]
        } : validation.updateErrors(result.messages);
      } else {
        model.alertMessage = {
          type: _Izenda4.default.MESSAGE_TYPE.SUCCESS,
          message: localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED')
        };
      }

      result.hasChangeLanguage && props.confirmMessage('info', localization.getText('USER_MESSAGE_CHANGE_LANGUAGE'));
      return result;
    });
  });
};

/**
 * Cancel
 * @param {Object} props
 */
var onCancel = function onCancel(props) {
  return function () {
    var localization = props.localization,
        _props$store2 = props.store,
        model = _props$store2.model,
        isDirty = _props$store2.model.isDirty;

    if (isDirty) {
      props.confirmFn('Confirmation', {
        description: localization.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
      }).then(function () {
        model.reset(_Izenda2.default.currentUser);
        model.resetDirty();
      });
    } else {
      model.alertMessage = {
        type: _Izenda4.default.MESSAGE_TYPE.INFO,
        message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
      };
    }
  };
};

exports.default = (0, _recompose.withHandlers)({
  onSave: onSave,
  onCancel: onCancel
});
module.exports = exports['default'];

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceId.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var AccountConstants = __webpack_require__(60);
  var Input = __webpack_require__(17);
  var Validator = __webpack_require__(23);
  var ValidatableInput = Validator()(Input);
  var GridLayout = __webpack_require__(13);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var actions = __webpack_require__(441);

  var MyPreferenceId = function MyPreferenceId(props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
    var hasUserSetupPermissions = props.authorization.checkPrivileges([permissionKeys.UserSetupActionsEdit]);
    var disabled = !(currentUser.systemAdmin || hasUserSetupPermissions);

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'label',
          { className: 'validation required u_controlHeight control-label' },
          localization.getText('USER_SETUP_LABEL_USER_ID')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { cols: '10' },
        React.createElement(ValidatableInput, { field: 'userName',
          className: 'form-control',
          value: currentUser.userName,
          disabled: disabled,
          validations: AccountConstants.CONSTRAINTS.userName,
          onChange: this.props.updateValue.bind(this.props, "userName") })
      )
    );
  };

  MyPreferenceId.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect(actions)(MyPreferenceId);
}();

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceFirstName.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var AccountConstants = __webpack_require__(60);
  var Input = __webpack_require__(17);
  var Validator = __webpack_require__(23);
  var ValidatableInput = Validator()(Input);
  var GridLayout = __webpack_require__(13);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var actions = __webpack_require__(441);

  var MyPreferenceFirstName = function MyPreferenceFirstName(props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'span',
          { className: 'validation required u_controlHeight control-label' },
          localization.getText('USER_SETUP_LABEL_FIRST_NAME')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { cols: '10' },
        React.createElement(ValidatableInput, { field: 'firstName',
          className: 'form-control',
          value: currentUser.firstName,
          validations: AccountConstants.CONSTRAINTS.firstName,
          onChange: this.props.updateValue.bind(this.props, "firstName") })
      )
    );
  };

  MyPreferenceFirstName.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect(actions)(MyPreferenceFirstName);
}();

/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceLastName.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var AccountConstants = __webpack_require__(60);
  var Input = __webpack_require__(17);
  var Validator = __webpack_require__(23);
  var ValidatableInput = Validator()(Input);
  var GridLayout = __webpack_require__(13);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var actions = __webpack_require__(441);

  var MyPreferenceLastName = function MyPreferenceLastName(props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'span',
          { className: 'validation required u_controlHeight control-label' },
          localization.getText('USER_SETUP_LABEL_LAST_NAME')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { cols: '10' },
        React.createElement(ValidatableInput, { field: 'lastName',
          className: 'form-control',
          value: currentUser.lastName,
          validations: AccountConstants.CONSTRAINTS.lastName,
          onChange: this.props.updateValue.bind(this.props, 'lastName') })
      )
    );
  };

  MyPreferenceLastName.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect(actions)(MyPreferenceLastName);
}();

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(2);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(13);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _mobxReact = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceEmail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var MyPreferenceEmail = function MyPreferenceEmail(props) {
  var currentUser = props.store.model,
      localization = props.localization;

  return _react2.default.createElement(
    _Izenda4.default.Row,
    null,
    _react2.default.createElement(
      _Izenda4.default.Col,
      { cols: '2' },
      _react2.default.createElement(
        'span',
        { className: 'u_controlHeight control-label' },
        localization.getText('COMMON_LABEL_EMAIL')
      )
    ),
    _react2.default.createElement(
      _Izenda4.default.Col,
      { cols: '10' },
      _react2.default.createElement(
        'label',
        { className: 'u_controlHeight control-label' },
        currentUser.emailAddress
      )
    )
  );
};
MyPreferenceEmail.propTypes = {
  store: _mobxReact.PropTypes.observableObject.isRequired
};
exports.default = (0, _Izenda2.default)()(MyPreferenceEmail);
module.exports = exports['default'];

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceRole.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var ObservablePropTypes = __webpack_require__(10).propTypes;

  var MyPreferenceRole = function MyPreferenceRole(props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'span',
          { className: 'u_controlHeight control-label' },
          localization.getText('COMMON_LABEL_ROLE')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { cols: '10' },
        React.createElement(
          'ul',
          null,
          currentUser.roles && currentUser.roles.map(function (role) {
            return React.createElement(
              'li',
              { key: role.id },
              role.name
            );
          })
        )
      )
    );
  };

  MyPreferenceRole.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect()(MyPreferenceRole);
}();

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceTimezone.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var NumbericInput = __webpack_require__(109);
  var Validator = __webpack_require__(23);
  var ValidatableNumbericInput = Validator()(NumbericInput);
  var GridLayout = __webpack_require__(13);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var actions = __webpack_require__(441);
  var MIN_OFFSET = -23;
  var MAX_OFFSET = 23;

  var MyPreferenceTimezone = function MyPreferenceTimezone(props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'span',
          { className: 'u_controlHeight control-label' },
          localization.getText('USER_SETUP_LABEL_TIME_ZONE')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { cols: '10' },
        React.createElement(
          GridLayout.Col,
          { cols: '12', className: 'u_noPaddingAll' },
          React.createElement(
            GridLayout.Col,
            { cols: '1', className: 'u_noPaddingAll' },
            React.createElement(
              'span',
              { className: 'u_controlHeight control-label' },
              localization.getText('USER_SETUP_LABEL_DATA_OFFSET')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '2', className: 'u_noPaddingAll' },
            React.createElement(ValidatableNumbericInput, { className: 'form-control',
              value: currentUser.dataOffset,
              min: MIN_OFFSET,
              max: MAX_OFFSET,
              onChange: this.props.updateValue.bind(this.props, 'dataOffset') })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '1' },
            React.createElement('i', { className: 'icon-ccw u_controlHeight control-label', onClick: this.props.resetDataOffset })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '2' },
            React.createElement(
              'span',
              { className: 'u_controlHeight control-label' },
              localization.getText('USER_SETUP_LABEL_TIMESTAMP_OFFSET')
            )
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '2 u_noPaddingAll' },
            React.createElement(ValidatableNumbericInput, { className: 'form-control',
              value: currentUser.timestampOffset,
              min: MIN_OFFSET,
              max: MAX_OFFSET,
              onChange: this.props.updateValue.bind(this.props, 'timestampOffset') })
          ),
          React.createElement(
            GridLayout.Col,
            { cols: '1' },
            React.createElement('i', { className: 'icon-ccw u_controlHeight control-label', onClick: this.props.resetTimestampOffset })
          )
        )
      )
    );
  };

  MyPreferenceTimezone.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect(actions)(MyPreferenceTimezone);
}();

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceLanguageInfo.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var EventsUtils = __webpack_require__(24);
  var notifyChange = EventsUtils.notifyChange;
  var GridLayout = __webpack_require__(13);
  var DropDown = __webpack_require__(29);
  var ObservablePropTypes = __webpack_require__(10).propTypes;

  var MyPreferenceLanguageInfo = function MyPreferenceLanguageInfo(props) {
    var localization = props.localization;
    var currentUser = props.store.model;

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'span',
          { className: 'u_controlHeight control-label' },
          localization.getText('COMMON_LABEL_LANGUAGE')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { cols: '10' },
        React.createElement(
          GridLayout.Col,
          { cols: '3', className: 'u_noPaddingAll' },
          React.createElement(DropDown, { options: currentUser.languageList,
            labelField: 'language',
            valueField: 'cultureName',
            value: currentUser.cultureName,
            onChange: notifyChange(currentUser.updateProperty.bind(currentUser, 'cultureName'), EventsUtils.DROPDOWN) })
        ),
        React.createElement(GridLayout.Col, { cols: '1' }),
        React.createElement(
          GridLayout.Col,
          { cols: '2' },
          React.createElement(
            'span',
            { className: 'u_controlHeight control-label' },
            localization.getText('COMMON_LABEL_DATE_FORMAT')
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '3', className: 'u_noPaddingAll' },
          React.createElement(DropDown, { options: currentUser.dateFormatList,
            labelField: 'labelDateFormat',
            valueField: 'dateFormat',
            value: currentUser.dateFormat,
            onChange: notifyChange(currentUser.updateProperty.bind(currentUser, 'dateFormat'), EventsUtils.DROPDOWN) })
        )
      )
    );
  };

  MyPreferenceLanguageInfo.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect()(MyPreferenceLanguageInfo);
}();

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityOptions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var ScrollBox = __webpack_require__(27);
  var GridLayout = __webpack_require__(13);
  var Password = __webpack_require__(2794);
  var SecurityQuestion = __webpack_require__(2798);
  var connect = __webpack_require__(2);
  var IconMenu = __webpack_require__(86);

  var SecurityOptions = React.createClass({
    displayName: 'SecurityOptions',

    propTypes: {
      store: ObservablePropTypes.observableObject.isRequired
    },

    componentDidMount: function componentDidMount() {
      //this.props.store.populateTenantInfo();
    },

    render: function render() {
      var store = this.props.store;
      var localization = this.props.localization;

      return React.createElement(
        'div',
        { className: 'izenda-Wrapper' },
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-header' },
          React.createElement(IconMenu, null),
          React.createElement(
            'div',
            { className: 'izenda-ActionBarLeft u_paddingTop' },
            React.createElement(
              'strong',
              { className: 'u_textUppercase' },
              localization.getText("USER_MENU_MY_PROFILE")
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'izenda-Wrapper-content' },
          React.createElement(
            ScrollBox,
            null,
            React.createElement(
              'div',
              { className: 'u_paddingLeftRight' },
              React.createElement(
                GridLayout,
                { className: 'u_paddingAll u-bgWhite' },
                React.createElement(Password, { store: store }),
                store.model.numberOfQuestionProfile && React.createElement(SecurityQuestion, { store: store })
              )
            )
          )
        )
      );
    }
  });

  module.exports = connect()(SecurityOptions);
}();

/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.Password.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var actions = __webpack_require__(2795);
  var momentTimezone = __webpack_require__(276);

  var Password = function Password(props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'p',
          null,
          localization.getText('COMMON_LABEL_PASSWORD')
        )
      ),
      React.createElement(GridLayout.Col, { cols: '6' }),
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'p',
          null,
          localization.getText('COMMON_CRITERIA_LAST_EDITED'),
          ':\xA0'
        ),
        React.createElement(
          'p',
          null,
          momentTimezone(currentUser.passwordLastChanged).format('MM/DD/YYYY')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { className: 'u_textRight', cols: '2' },
        React.createElement(
          'p',
          null,
          React.createElement(
            'a',
            { onClick: props.openChangePasswordPopup },
            localization.getText('COMMON_LABEL_CHANGE_PASSWORD')
          )
        )
      )
    );
  };

  Password.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect(actions)(Password);
}();

/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var ChangePasswordPopup = __webpack_require__(2796);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var PasswordActions = compose(withHandlers({
    openChangePasswordPopup: curry(openChangePasswordPopup)
  }));

  /**
   * Open change password popup
   * @param {Object} props
   * @param placeholder
   */
  function openChangePasswordPopup(props, _) {
    props.openPopup(ChangePasswordPopup, {
      store: props.store
    });
  }

  module.exports = PasswordActions;
}();

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ChangePasswordPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  'use strict';

  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Popup = __webpack_require__(36);
  var Validator = __webpack_require__(23);
  var Input = __webpack_require__(17);
  var ValidatableInput = Validator()(Input);
  var AccountConstants = __webpack_require__(60);
  var actions = __webpack_require__(2797);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var MyProfileAlert = __webpack_require__(639);

  var ChangePasswordPopup = React.createClass({
    displayName: 'ChangePasswordPopup',

    propTypes: {
      store: ObservablePropTypes.observableObject.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.props.store.model.resetValidation();
    },

    /**
     * Render component
     */
    render: function render() {
      var localization = this.props.localization;

      return React.createElement(
        Popup,
        { visible: true,
          onClosing: this.props.onClosing,
          autoClose: false,
          type: 'none',
          sizeClass: 'modal-xs' },
        React.createElement(Popup.Header, { title: localization.getText('COMMON_LABEL_CHANGE_PASSWORD') }),
        React.createElement(
          Popup.Body,
          null,
          React.createElement(MyProfileAlert, { alertMessage: this.props.store.model.alertMessage }),
          React.createElement(
            GridLayout,
            null,
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '4' },
                React.createElement(
                  'label',
                  { className: 'validation required u_controlHeight control-label' },
                  localization.getText('COMMON_LABEL_CURRENT_PASSWORD')
                )
              ),
              React.createElement(
                GridLayout.Col,
                { cols: '8' },
                React.createElement(ValidatableInput, { field: 'currentPassword',
                  type: 'password',
                  className: 'form-control',
                  value: this.props.currentPassword,
                  validations: AccountConstants.CONSTRAINTS.currentPassword,
                  onChange: this.props.updateCurrentPassword })
              )
            ),
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '4' },
                React.createElement(
                  'label',
                  { className: 'validation required u_controlHeight control-label' },
                  localization.getText('ACOUNT_LABEL_NEW_PASSWORD')
                )
              ),
              React.createElement(
                GridLayout.Col,
                { cols: '8' },
                React.createElement(ValidatableInput, { field: 'password',
                  type: 'password',
                  className: 'form-control',
                  value: this.props.newPassword,
                  validations: AccountConstants.CONSTRAINTS.password,
                  onChange: this.props.updateNewPassword })
              )
            ),
            React.createElement(
              GridLayout.Row,
              null,
              React.createElement(
                GridLayout.Col,
                { cols: '4' },
                React.createElement(
                  'label',
                  { className: 'validation required u_controlHeight control-label' },
                  localization.getText('ACOUNT_LABEL_CONFIRM_NEW_PASSWORD')
                )
              ),
              React.createElement(
                GridLayout.Col,
                { cols: '8' },
                React.createElement(ValidatableInput, { field: 'confirmPassword',
                  type: 'password',
                  className: 'form-control',
                  value: this.props.confirmNewPassword,
                  validations: AccountConstants.CONSTRAINTS.confirmPassword,
                  onChange: this.props.updateConfirmNewPassword })
              )
            )
          )
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_SAVE')
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  });

  module.exports = connect(actions)(ChangePasswordPopup);
}();

/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ChangePasswordPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withState = __webpack_require__(9).withState;
  var withHandlers = __webpack_require__(9).withHandlers;
  var CommonMessages = __webpack_require__(37);

  var CANCEL_TEXT = 'cancel';
  var ACCEPT_TEXT = 'accept';

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil;

  var ChangePasswordPopupActions = compose(withState('currentPassword', 'setCurrentPassword', ''), withState('newPassword', 'setNewPassword', ''), withState('confirmNewPassword', 'setConfirmNewPassword', ''), withHandlers({
    onClosing: curry(onClosing),
    updateCurrentPassword: curry(updateCurrentPassword),
    updateNewPassword: curry(updateNewPassword),
    updateConfirmNewPassword: curry(updateConfirmNewPassword)
  }));

  /**
   * Update current password
   */
  function updateCurrentPassword(props, input) {
    props.setCurrentPassword(input.target.value);
  }

  /**
   * Update new password
   */
  function updateNewPassword(props, input) {
    props.setNewPassword(input.target.value);
  }

  /**
   * Update confirm new password
   */
  function updateConfirmNewPassword(props, input) {
    props.setConfirmNewPassword(input.target.value);
  }

  /**
   * When click button OK on popup
   * @return {Promise} promise to handle async action
   */
  function onAcceptClosing(props) {
    var valManager = props.validation;
    var loader = props.loader;

    valManager.validate().then(function (success) {
      if (success) {
        loader.startLoading();
        props.store.updateNewPassword(props.currentPassword, props.newPassword).then(function (result) {
          if (!isNil(result.messages)) {
            valManager.updateErrors(result.messages);
            props.store.model.alertMessage = {
              type: CommonMessages.MESSAGE_TYPE.ERROR,
              message: result.messages[0].messages[0]
            };
          } else {
            props.onAccept();
          }
          return null;
        });
      }
    }).finally(loader.endLoading.bind(loader));
  }

  /**
   * When click button Cancel on popup
   * @param  {Object} hidePopup function
   */
  function onCancelClosing(props) {
    props.validation.reset();
    props.onReject();
  }

  /**
   * Closing popup
   * @param {text} type
   */
  function onClosing(props, callback, type) {
    switch (type) {
      case ACCEPT_TEXT:
        onAcceptClosing(props);
        break;
      case CANCEL_TEXT:
        onCancelClosing(props);
        break;
    }
  }

  module.exports = ChangePasswordPopupActions;
}();

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityQuestion.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var momentTimezone = __webpack_require__(276);
  var actions = __webpack_require__(2799);

  var _require = __webpack_require__(1),
      isNil = _require.isNil;

  var SecurityQuestion = function SecurityQuestion(props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return React.createElement(
      GridLayout.Row,
      null,
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'p',
          null,
          localization.getText('COMMON_LABEL_SECURITY_QUESTIONS')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { cols: '6' },
        currentUser.userSecurityQuestions.map(function (securityQuestion) {
          return React.createElement(
            'p',
            { key: securityQuestion.securityQuestionId },
            securityQuestion.question
          );
        })
      ),
      React.createElement(
        GridLayout.Col,
        { cols: '2' },
        React.createElement(
          'p',
          null,
          localization.getText('COMMON_CRITERIA_LAST_EDITED'),
          ':\xA0'
        ),
        React.createElement(
          'p',
          null,
          !isNil(currentUser.securityQuestionLastChanged) && momentTimezone(currentUser.securityQuestionLastChanged).format('MM/DD/YYYY')
        )
      ),
      React.createElement(
        GridLayout.Col,
        { className: 'u_textRight', cols: '2' },
        React.createElement(
          'p',
          null,
          React.createElement(
            'a',
            { onClick: props.openChangeSecurityQuestionsPopup },
            localization.getText('COMMON_LABEL_CHANGE_SECURITY_QUESTION')
          )
        )
      )
    );
  };

  SecurityQuestion.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect(actions)(SecurityQuestion);
}();

/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityQuestionActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {
  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var ChangeSecurityQuestionsPopup = __webpack_require__(2800);

  var _require = __webpack_require__(1),
      curry = _require.curry;

  var SecurityQuestionActions = compose(withHandlers({
    openChangeSecurityQuestionsPopup: curry(openChangeSecurityQuestionsPopup)
  }));

  /**
   * Open change password popup
   * @param {Object} props
   * @param placeholder
   */
  function openChangeSecurityQuestionsPopup(props, _) {
    props.openPopup(ChangeSecurityQuestionsPopup, {
      store: props.store
    });
  }

  module.exports = SecurityQuestionActions;
}();

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ChangeSecurityQuestionsPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

!function () {
  var React = __webpack_require__(0);
  var connect = __webpack_require__(2);
  var GridLayout = __webpack_require__(13);
  var Popup = __webpack_require__(36);
  var Validator = __webpack_require__(23);
  var Input = __webpack_require__(17);
  var ValidatableInput = Validator()(Input);
  var AccountConstants = __webpack_require__(60);
  var actions = __webpack_require__(2801);
  var ObservablePropTypes = __webpack_require__(10).propTypes;
  var MyProfileAlert = __webpack_require__(639);
  var DropDown = __webpack_require__(29);
  var EventsUtils = __webpack_require__(24);
  var notifyChange = EventsUtils.notifyChange;

  var _require = __webpack_require__(1),
      map = _require.map;

  var SecurityQuestionAndAnswer = connect()(function (props) {
    var localization = props.localization;
    var question = props.question;
    var accountInfo = props.accountInfo;
    var index = props.index;
    var remainingQuestionList = accountInfo.getRemainingQuestionList(question);

    return React.createElement(
      GridLayout,
      { className: 'u_paddingTop' },
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: '4' },
          React.createElement(
            'label',
            { className: 'validation required u_controlHeight control-label' },
            localization.getText('COMMON_LABEL_SECURITY_QUESTION'),
            ' ',
            index
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '8' },
          React.createElement(DropDown, {
            options: remainingQuestionList,
            labelField: 'question',
            valueField: 'securityQuestionId',
            value: question.securityQuestionId,
            onChange: notifyChange(question.updateProperty.bind(question, 'securityQuestionId'), EventsUtils.DROPDOWN)
          })
        )
      ),
      React.createElement(
        GridLayout.Row,
        null,
        React.createElement(
          GridLayout.Col,
          { cols: '4' },
          React.createElement(
            'label',
            { className: 'validation required u_controlHeight control-label' },
            localization.getText('COMMON_LABEL_YOUR_ANSWER')
          )
        ),
        React.createElement(
          GridLayout.Col,
          { cols: '8' },
          React.createElement(ValidatableInput, {
            field: 'yourAnswer',
            className: 'form-control',
            value: question.answer,
            validations: AccountConstants.CONSTRAINTS.yourAnswer,
            onChange: notifyChange(question.updateProperty.bind(question, 'answer'), EventsUtils.INPUT)
          })
        )
      )
    );
  });

  var ChangeSecurityQuestionsPopup = React.createClass({
    displayName: 'ChangeSecurityQuestionsPopup',

    propTypes: {
      store: ObservablePropTypes.observableObject.isRequired
    },

    componentWillMount: function componentWillMount() {
      this.props.store.model.getSelectedQuestionList();
    },

    renderSecurityQuestionAndAnswer: function renderSecurityQuestionAndAnswer() {
      var index = 1;
      return map(function (question) {
        return React.createElement(SecurityQuestionAndAnswer, {
          key: question.securityQuestionId,
          accountInfo: this.props.store.model,
          question: question,
          index: index++
        });
      }.bind(this), this.props.store.model.selectedQuestionList);
    },

    /**
     * Render component
     */
    render: function render() {
      var localization = this.props.localization;

      return React.createElement(
        Popup,
        { visible: true, onClosing: this.props.onClosing, autoClose: false, type: 'none', sizeClass: 'modal-xs-responsive' },
        React.createElement(Popup.Header, { title: localization.getText('COMMON_LABEL_CHANGE_SECURITY_QUESTION') }),
        React.createElement(
          Popup.Body,
          null,
          React.createElement(MyProfileAlert, { alertMessage: this.props.store.model.alertMessage }),
          this.renderSecurityQuestionAndAnswer()
        ),
        React.createElement(
          Popup.Footer,
          null,
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'accept' },
            localization.getText('COMMON_LABEL_SAVE')
          ),
          React.createElement(
            Popup.ConfirmationButton,
            { type: 'cancel' },
            localization.getText('COMMON_LABEL_CANCEL')
          )
        )
      );
    }
  });

  module.exports = connect(actions)(ChangeSecurityQuestionsPopup);
}();

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------
// <copyright file="Izenda.ChangeSecurityQuestionsPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var compose = __webpack_require__(9).compose;
  var withHandlers = __webpack_require__(9).withHandlers;
  var CommonMessages = __webpack_require__(37);

  var CANCEL_TEXT = 'cancel';
  var ACCEPT_TEXT = 'accept';

  var _require = __webpack_require__(1),
      curry = _require.curry,
      isNil = _require.isNil;

  var ChangeSecurityQuestionsPopupActions = compose(withHandlers({
    onClosing: curry(onClosing)
  }));

  /**
   * When click button OK on popup
   * @return {Promise} promise to handle async action
   */
  function onAcceptClosing(props) {
    var valManager = props.validation;
    var loader = props.loader;

    valManager.validate().then(function (success) {
      if (success) {
        loader.startLoading();
        props.store.updateSecurityQuesitions().then(function (result) {
          if (!isNil(result.messages)) {
            valManager.updateErrors(result.messages);
            props.store.model.alertMessage = {
              type: CommonMessages.MESSAGE_TYPE.ERROR,
              message: result.messages[0].messages[0]
            };
          } else {
            props.onAccept();
          }
          return null;
        });
      }
    }).finally(loader.endLoading.bind(loader));
  }

  /**
   * When click button Cancel on popup
   * @param  {Object} hidePopup function
   */
  function onCancelClosing(props) {
    props.store.model.resetAnswers();
    props.validation.reset();
    props.onReject();
  }

  /**
   * Closing popup
   * @param {text} type
   */
  function onClosing(props, callback, type) {
    switch (type) {
      case ACCEPT_TEXT:
        onAcceptClosing(props);
        break;
      case CANCEL_TEXT:
        onCancelClosing(props);
        break;
    }
  }

  module.exports = ChangeSecurityQuestionsPopupActions;
}();

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(ensure) {

var _bluebird = __webpack_require__(18);

// ----------------------------------------------------------------------
// <copyright file="Izenda.InitValidate.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  "use strict";
  /* Implement custom validators and further global settings of validate.js */

  var validate = __webpack_require__(500);

  /**
   * A validator that invoke async function of a store. Usually uses for server-side
   * validation.
   * @param  {any} value         Value to validate
   * @param  {Object} options
   * @param  {string} key        Validating field
   * @param  {Object} attributes Object to validate
   * @return {Promise}           A promise of action result
   */
  validate.validators.storeAction = function (value, options, key, attributes) {
    ensure(options, 'storeAction validator options cannot be nil');
    ensure(options.action, 'storeAction validator options must contains "action" string');
    ensure(options.store, 'storeAction validator options must contains "store" instance');

    var result = options.store[options.action].call(options.store, value, key, attributes);

    return (0, _bluebird.resolve)(result);
  };

  validate.validators.action = function (value, options, key, attributes) {
    return (0, _bluebird.resolve)(options(value, key, attributes));
  };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Part Container component
 */

/**
 * This component is intended to show only report part content.
 * Parameters locate in the params property:
   * id: required. Id of report part.
   * filter: is an array of Object with key and	value
   * previewRecords: > 0 valid number, get number of records; < 0 invalid number; -1 get all records
   * 	for Example:
   *  "id": "554D4D2F-E12A-4680-A2EC-A405DE872B7F",
   *  "filters": [
	              {
	                key: "[northwind].[dbo].[Order Details].[ProductID]",
	                value: 5
	              }
               ],
   *  "previewRecords": 100
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(21);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Izenda = __webpack_require__(177);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(31);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(407);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(640);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _queryString = __webpack_require__(2804);

var _queryString2 = _interopRequireDefault(_queryString);

var _Izenda9 = __webpack_require__(319);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _config = __webpack_require__(40);

var _config2 = _interopRequireDefault(_config);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ReportPartPage, _Component);

  function ReportPartPage() {
    (0, _classCallCheck3.default)(this, ReportPartPage);
    return (0, _possibleConstructorReturn3.default)(this, (ReportPartPage.__proto__ || (0, _getPrototypeOf2.default)(ReportPartPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReportPartPage, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _Izenda10.default.removePart(this.props.params.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var params = this.props.params;

      var childProps = {
        reportPartId: params.id,
        publishDrillInfo: params.publishDrillInfo,
        crosssfilters: params.crosssfilters,
        previewRecords: params.previewRecords
      };

      _config2.default && (childProps.page = _Izenda10.default.syncPageManifest());
      var query = {};

      if (params.useQueryParam) {
        if (params.useHash) {
          query = _Izenda4.default.getHashLocation().query;
        } else {
          query = _queryString2.default.parse(location.search);
        }

        childProps = (0, _fp.flow)((0, _fp.pick)(['width', 'height', 'hideTitle', 'separator']), (0, _fp.merge)(childProps), (0, _fp.merge)({
          printingMode: (0, _fp.toLower)(query.print) === 'true',
          location: location,
          subReportFilterFromQuery: _Izenda2.default.convertQueryToFilter(query),
          forExporting: query.width && query.height,
          query: query,
          intergrateMode: true
        }))(query);
      } else {
        childProps = (0, _fp.merge)(childProps, {
          subReportFilter: {
            filters: params.filters,
            overridingFilterValue: params.overridingFilterValue
          }
        });
      }

      return _react2.default.createElement(
        _Izenda8.default,
        null,
        _react2.default.createElement(_Izenda6.default, (0, _extends3.default)({ containerSizeFixed: false }, childProps))
      );
    }
  }]);
  return ReportPartPage;
}(_react.Component), _class.propTypes = {
  params: _propTypes2.default.object
}, _temp);
exports.default = ReportPartPage;
module.exports = exports['default'];

/***/ }),
/* 2804 */,
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(640);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1143);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _config = __webpack_require__(40);

var _Izenda5 = __webpack_require__(194);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(31);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(280);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _reactRouter = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Setting page component
 */

var SettingPage = function (_Component) {
  (0, _inherits3.default)(SettingPage, _Component);

  function SettingPage(props) {
    (0, _classCallCheck3.default)(this, SettingPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SettingPage.__proto__ || (0, _getPrototypeOf2.default)(SettingPage)).call(this, props));

    _this.history = (0, _Izenda6.default)(_config.Integration);
    if (!_config.Integration) return (0, _possibleConstructorReturn3.default)(_this);
    _Izenda8.default.listenHistoryChange(_this.history, _this.getSettingRoute().path);
    return _this;
  }

  /**
   * Get setting route
   */


  (0, _createClass3.default)(SettingPage, [{
    key: 'getSettingRoute',
    value: function getSettingRoute() {
      return { path: _Izenda8.default.getSettingsUrl() };
    }
  }, {
    key: 'render',
    value: function render() {
      var synergyHistory = this.history.synergyHistory;

      return _react2.default.createElement(
        _reactRouter.Router,
        { history: synergyHistory },
        (0, _Izenda10.default)(this.getSettingRoute())
      );
    }
  }]);
  return SettingPage;
}(_react.Component);

exports.default = SettingPage;
module.exports = exports['default'];

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Izenda = __webpack_require__(1215);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(338);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(2);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(45);

var _fp = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var DashboardDesignerContainer = function (_Component) {
  (0, _inherits3.default)(DashboardDesignerContainer, _Component);

  function DashboardDesignerContainer() {
    (0, _classCallCheck3.default)(this, DashboardDesignerContainer);
    return (0, _possibleConstructorReturn3.default)(this, (DashboardDesignerContainer.__proto__ || (0, _getPrototypeOf2.default)(DashboardDesignerContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(DashboardDesignerContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.store = new _Izenda4.default();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var id = !(0, _fp.isNil)(this.props.params) ? this.props.params.id : null;
      var newDashboard = !!(0, _fp.get)('needCreateNewDashboard', this.props.location.state);

      return _react2.default.createElement(
        'div',
        { className: 'u_fullSize u_paddingTop' },
        _react2.default.createElement(_Izenda2.default, (0, _extends3.default)({ id: id, store: this.store, newDashboard: newDashboard }, this.props))
      );
    }
  }]);
  return DashboardDesignerContainer;
}(_react.Component);

exports.default = (0, _Izenda6.default)({ licenseKey: _Izenda7.LICENSE_KEY.Dashboard })(DashboardDesignerContainer);
module.exports = exports['default'];

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _config = __webpack_require__(40);

var _Izenda = __webpack_require__(194);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(31);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(280);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report page component
 */
var ReportPage = function (_Component) {
  (0, _inherits3.default)(ReportPage, _Component);

  function ReportPage(props) {
    (0, _classCallCheck3.default)(this, ReportPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportPage.__proto__ || (0, _getPrototypeOf2.default)(ReportPage)).call(this, props));

    _this.history = (0, _Izenda2.default)(_config.Integration);
    if (!_config.Integration) return (0, _possibleConstructorReturn3.default)(_this);
    _Izenda4.default.listenHistoryChange(_this.history, _this.getReportRoute().path);
    return _this;
  }

  /**
   * Get report route
   */


  (0, _createClass3.default)(ReportPage, [{
    key: 'getReportRoute',
    value: function getReportRoute() {
      return { path: _Izenda4.default.getReportUrl('Report') };
    }
  }, {
    key: 'render',
    value: function render() {
      var synergyHistory = this.history.synergyHistory;

      return _react2.default.createElement(
        _reactRouter.Router,
        { history: synergyHistory },
        (0, _Izenda6.default)(this.getReportRoute())
      );
    }
  }]);
  return ReportPage;
}(_react.Component);

exports.default = ReportPage;
module.exports = exports['default'];

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Dashboard page component
 */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _config = __webpack_require__(40);

var _Izenda = __webpack_require__(194);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(31);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(280);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DashboardPage, _Component);

  function DashboardPage(props) {
    (0, _classCallCheck3.default)(this, DashboardPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardPage.__proto__ || (0, _getPrototypeOf2.default)(DashboardPage)).call(this, props));

    var isAddNew = props.isAddNew;

    _this.mainRoute = { path: _Izenda4.default.getDashboardUrl(isAddNew ? 'New' : 'Dashboard') };
    _this.history = (0, _Izenda2.default)(_config.Integration);

    if (!_config.Integration) return (0, _possibleConstructorReturn3.default)(_this);
    _Izenda4.default.listenHistoryChange(_this.history, _this.mainRoute.path);
    return _this;
  }

  (0, _createClass3.default)(DashboardPage, [{
    key: 'render',
    value: function render() {
      var synergyHistory = this.history.synergyHistory;

      return _react2.default.createElement(
        _reactRouter.Router,
        { history: synergyHistory },
        (0, _Izenda6.default)(this.mainRoute)
      );
    }
  }]);
  return DashboardPage;
}(_react.Component), _class.propTypes = {
  isAddNew: _react.PropTypes.bool
}, _temp);
exports.default = DashboardPage;
module.exports = exports['default'];

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardViewerPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _config = __webpack_require__(40);

var _Izenda = __webpack_require__(194);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(31);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(280);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardViewerPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DashboardViewerPage, _Component);

  function DashboardViewerPage(props) {
    (0, _classCallCheck3.default)(this, DashboardViewerPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DashboardViewerPage.__proto__ || (0, _getPrototypeOf2.default)(DashboardViewerPage)).call(this, props));

    if (!_config.Integration) return (0, _possibleConstructorReturn3.default)(_this);
    _this.history = (0, _Izenda2.default)(_config.Integration);
    var dashboardRoute = _this.getDashboardRoute();
    _Izenda4.default.listenHistoryChange(_this.history, dashboardRoute.path, dashboardRoute.query);
    return _this;
  }

  /**
   * Get dashboard route
   */


  (0, _createClass3.default)(DashboardViewerPage, [{
    key: 'getDashboardRoute',
    value: function getDashboardRoute() {
      var _props = this.props,
          dashboardId = _props.dashboardId,
          filter = _props.filter;

      return {
        path: _Izenda4.default.getDashboardUrl('DashboardViewer', { id: dashboardId }),
        query: filter
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var synergyHistory = this.history.synergyHistory;

      return _react2.default.createElement(
        _reactRouter.Router,
        { history: synergyHistory },
        (0, _Izenda6.default)(this.getDashboardRoute())
      );
    }
  }]);
  return DashboardViewerPage;
}(_react.Component), _class.propTypes = {
  dashboardId: _react2.default.PropTypes.string,
  filter: _react2.default.PropTypes.object
}, _temp);
exports.default = DashboardViewerPage;
module.exports = exports['default'];

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($izenda) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportViewerPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Viewer Page component
 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _config = __webpack_require__(40);

var _Izenda = __webpack_require__(194);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(31);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(280);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(177);

var _Izenda8 = _interopRequireDefault(_Izenda7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportViewerPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ReportViewerPage, _Component);

  function ReportViewerPage(props) {
    (0, _classCallCheck3.default)(this, ReportViewerPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportViewerPage.__proto__ || (0, _getPrototypeOf2.default)(ReportViewerPage)).call(this, props));

    var reportId = props.reportId,
        filter = props.filter;

    _this.history = (0, _Izenda2.default)(_config.Integration);
    if (!_config.Integration) return (0, _possibleConstructorReturn3.default)(_this);
    _Izenda4.default.listenHistoryChange(_this.history, _this.getReportViewerRoute(reportId, filter).path, _this.getQuery(filter));
    return _this;
  }

  /**
   * Get report viewer route
   * @param {String} reportId
   * @param {Object} filter
   */


  (0, _createClass3.default)(ReportViewerPage, [{
    key: 'getReportViewerRoute',
    value: function getReportViewerRoute(reportId, filter) {
      return {
        path: _Izenda4.default.getReportViewerUrl('ReportViewerDetail', { id: reportId }),
        query: this.getQuery(filter)
      };
    }

    /**
     * Get query
     * @param {Object} filter
     */

  }, {
    key: 'getQuery',
    value: function getQuery(filter) {
      return _Izenda8.default.convertFilterToQuery(filter);
    }

    /**
     * Change url
     * @param {Object} nextProps
     */

  }, {
    key: 'changeUrl',
    value: function changeUrl(nextProps) {
      var reportId = nextProps.reportId,
          filter = nextProps.filter;


      if (reportId) {
        var reportViewerRoute = this.getReportViewerRoute(reportId, filter);
        var reportLink = reportViewerRoute.path,
            query = reportViewerRoute.query;

        query.forceUpdate = true;
        var queryString = $izenda.param(query);

        this.history.push(reportLink + '?' + queryString);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.changeUrl(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          reportId = _props.reportId,
          filter = _props.filter;

      var reportViewerRoute = this.getReportViewerRoute(reportId, filter);
      var synergyHistory = this.history.synergyHistory;


      return _react2.default.createElement(
        _reactRouter.Router,
        { history: synergyHistory },
        (0, _Izenda6.default)(reportViewerRoute)
      );
    }
  }]);
  return ReportViewerPage;
}(_react.Component), _class.propTypes = {
  reportId: _react.PropTypes.string,
  filter: _react.PropTypes.object
}, _temp);
exports.default = ReportViewerPage;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(52);

var _config = __webpack_require__(40);

var _Izenda = __webpack_require__(194);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(31);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(280);

var _Izenda6 = _interopRequireDefault(_Izenda5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Designer Page
 */

var ReportDesignerPage = function (_Component) {
  (0, _inherits3.default)(ReportDesignerPage, _Component);

  function ReportDesignerPage() {
    (0, _classCallCheck3.default)(this, ReportDesignerPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportDesignerPage.__proto__ || (0, _getPrototypeOf2.default)(ReportDesignerPage)).call(this));

    _this.history = (0, _Izenda2.default)(_config.Integration);
    if (!_config.Integration) return (0, _possibleConstructorReturn3.default)(_this);
    _Izenda4.default.listenHistoryChange(_this.history, _this.getReportDesignerRoute().path);
    return _this;
  }

  /**
   * Get report designer route
   */


  (0, _createClass3.default)(ReportDesignerPage, [{
    key: 'getReportDesignerRoute',
    value: function getReportDesignerRoute() {
      return { path: _Izenda4.default.getReportDesignerUrl('ReportDesigner') };
    }
  }, {
    key: 'render',
    value: function render() {
      var synergyHistory = this.history.synergyHistory;

      return _react2.default.createElement(
        _reactRouter.Router,
        { history: synergyHistory },
        (0, _Izenda6.default)(this.getReportDesignerRoute())
      );
    }
  }]);
  return ReportDesignerPage;
}(_react.Component);

exports.default = ReportDesignerPage;
module.exports = exports['default'];

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(220);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  /**
   * Register a JS format string with format function
   */
  addJsFormat: function addJsFormat(formatName, formatFn) {
    _Izenda2.default.addJsFormat(formatName, formatFn);
  }
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.JsFormatApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _Izenda = __webpack_require__(65);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(181);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(425);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(16);

var _Izenda8 = __webpack_require__(33);

var _Izenda9 = __webpack_require__(171);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(69);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportPartUtils = (0, _extends3.default)({}, _Izenda10.default, _Izenda12.default);
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * Get the report part type constants
   */
  get REPORT_PART_TYPES() {
    return _Izenda7.REPORT_PART_TYPE;
  },

  /**
   * Get the chart style constants
   */
  get CHART_STYLES() {
    return _Izenda8.CHART_TYPE;
  },

  /**
   * Get the utility functions that help to manipulate options on the custom chart options builder
   */
  get ReportPartUtils() {
    return ReportPartUtils;
  },

  /**
   * Set configuration of a report part type. It is typically using for customizing the existing report part type (i.e. Chart, Gauge or Map).
   * Instead of setting a new configuration, it recommends getting the current configuration via getReportPartConfiguration, change appropreate property,
   * then set it back using this function. By changing this configuration, it would impact to all report part styles of the particular report part type. For example,
   * adding a new field container schema to the Chart configuration will result the new field container appears in all chart type configuration designer.
   * @param {string} reportPartType Report part type
   * @param {Object} configuration Report part type configuration
   * @param {string} configuration.visualEngine The name of default visualization engine. It will be used as default visualization engine if the report part style configuration
   * doesn't specify explicitly
   * @param {Function} configuration.optionsBuilder The options builder class or constructor function to build visualization options
   * @param {Function} configuration.model The report part content model class or constructor function. This class/constructor is used to construct ReportPartContent object
   * @param {Array} configuration.fieldContainerSchema An array of field container schema
   * @param {Array} configuration.propertyWidgets An array of custom React components to create property editor.It would be useful in case of using a custom React component directly in the propertySchema property, instead of
   * using registerPropertyEditor to register a custom property editor by type.
   * @param {Object} configuration.propertySchema The object contains defined schema of property editor of report part in designer
   * @param {Function} configuration.propertyMappingProps The function to create the mapping properties object
   * @param {Function} configuration.propertyMappingSource The function to create the mapping source object
   * @param {Function} configuration.propertyValueChange The function to create value change handler
   * @param {Object} [configuration.optionsMapping] Mapping to visualization options. This settings is optional as you can write code in options builder to populate visualization object
   * @example
   * setReportPartConfiguration(REPORT_PART_TYPES.Chart, {
   *    visualEngine: 'Highchart',
   *    // The builder class to build chart visualization options
   *    optionsBuilder: CustomHighchartOptionBuilder,
   *    // Report part content model class
   *    model: CustomReportPartChartContent,
   *    // Default field container schema
   *    fieldContainerSchema: null,
   *    // Array of custom React component to create property editor.
   *    // It would be useful in case of using a custom React component directly in the propertySchema property, instead of
   *    // using registerPropertyEditor to register a custom property editor by type.
   *    propertyWidgets: [],
   *    // The object contains defined schema of property editor of report part in designer
   *    propertySchema: {
   *      schemaKey: 'Example',
   *      groups: {
   *        example_group_name: {
   *          title: 'Example Group',
   *          fields: {
   *            example_field_name: {
   *              factory: createDropDownSchema,
   *              title: 'Title of example_field_name',
   *              value: '<any property name or getter function of propertyMappingProps, propertyMappingSource object>',
   *              props: {
   *                defaultValue: 'value1',
   *                options: ['value1', 'value2']
   *              }
   *            }
   *          }
   *        }
   *      }
   *    },
   *    // The function to create the mapping properties
   *    propertyMappingProps: function (reportPartDetails, fieldStore) {
   *      return {
   *        otherProperty: 'Value1'
   *      }
   *    },
   *    // The function to create the mapping source
   *    propertyMappingSource: function (reportPartDetails, fieldStore) {
   *      return {
   *        example_field_name: 'Value1'
   *      }
   *    },
   *    // The function to create an value changed handler
   *    propertyValueChange: function (reportPartDetails, fieldStore) {
   *      return function (schemaData, changedKey, changedKeyPath, changedValue, changedOthersInfo, derivedChange) {
   *        // It must return a Promise with chartProperties object.
   *        return Promise.resolve({ needToUpdate: false, chartProperties: reportPartProperties })
   *      }
   *    },
   *    // Mapping to visualization options.
   *    // This settings is optional as you can write code in options builder to populate visualization object
   *    optionsMapping: null
   * });
   */
  setReportPartConfiguration: function setReportPartConfiguration(reportPartType, configuration) {
    _Izenda4.default.setConfiguration(reportPartType, configuration);
  },


  /**
   * Get configuration of a report part type
   * @param {string} reportPartType Report part type
   * @example <caption>Gets the report part configuration object of Chart</caption>
   * getReportPartConfiguration(REPORT_PART_TYPES.Chart)
   */
  getReportPartConfiguration: function getReportPartConfiguration(reportPartType) {
    return _Izenda4.default.getConfiguration(reportPartType);
  },


  /**
   * Extends report part with a new style configuration.
   * The new style appears on the Chart type list of Chart, Gauge style list of Gauge or Map type list of Map which depends on which REPORT_PART_TYPES is specified.
   * @param {string} reportPartType The report part type
   * @param {string} reportPartStyle The new report part style
   * @param {string} baseStyle A chart type that new chart derives on
   * @param {Object} configuration New chart type configuration
   * @param {string} [configuration.visualEngine] The name of visualization engine. The default visualization engine which is defined in report part configuration is used if it doesn't specify here.
   * @param {string} configuration.visualType Visual type to identify which visualization type to be rendered. For example, it would be "type" property of Highchart options.
   * @param {string} configuration.visualLabel The label text of this report part style showing in the chart type dropdown of report designer.
   * @param {Function} configuration.optionsBuilder The options builder class or constructor function to build visualization options
   * @param {Array} [configuration.fieldContainerSchema] An array of field container schema.
   * @param {Array} [configuration.propertyWidgets] An array of custom React components to create property editor.It would be useful in case of using a custom React component directly in the propertySchema property, instead of
   * using registerPropertyEditor to register a custom property editor by type.
   * @param {Object} [configuration.propertySchema] The object contains defined schema of property editor of report part in designer
   * @param {Function} [configuration.propertyMappingProps] The function to create the mapping properties object
   * @param {Function} [configuration.propertyMappingSource] The function to create the mapping source object
   * @param {Function} [configuration.propertyValueChange] The function to create value change handler
   * @param {Object} [configuration.optionsMapping] Mapping to visualization options. This settings is optional as you can write code in options builder to populate visualization object
   * @example <caption>Extend Chart with an additional 3D Column chart type</caption>
   * extendReportPartStyleConfiguration(REPORT_PART_TYPES.Chart, '3DColumn', CHART_STYLES.Column, {
   *    visualType: 'column',
   *    visualLabel: '3D Column',
   *    propertySchema: {
   *       groups: {
   *         chart: {
   *           fields: {
   *             '3d': {
   *               factory: createCheckBoxSchema,
   *               title: 'Enable 3D',
   *               value: 'getValueByKey',
   *               props: {
   *                 title: 'Enable 3D'
   *               }
   *             }
   *           }
   *         }
   *       }
   *    },
   *    propertyValueChange: (reportPartDetails, fieldStore) => (
   *       chartProperties,
   *       schemaData,
   *       changedKey,
   *       changedKeyPath,
   *       changedValue,
   *       changedOthersInfo
   *     ) => {
   *       const threeDOptions = schemaData.chart['3d'];
   *       chartProperties.optionByType['3d'] = threeDOptions ? threeDOptions.value : false;
   *    },
   *    optionsBuilder: ThreeDColumnChartOptionsBuilder,
   *    optionsMapping: {
   *       optionsByType: {
   *         '3d': { propKey: 'chart.options3d.enabled', defaultValue: true }
   *       }
   *    }
   * })
   */
  extendReportPartStyleConfiguration: function extendReportPartStyleConfiguration(reportPartType, reportPartStyle, baseStyle, configuration) {
    return _Izenda2.default.extendConfiguration(reportPartType, reportPartStyle, baseStyle, configuration);
  }
};
module.exports = exports['default'];

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(556);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertyEditorApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * Register property editor with its factory function to create a custom property editor inside
   * Report Designer's property panel.
   * @param {string} type Editor type key
   * @param {Function} factory Function to create editor component
   * @example <caption>Register a text input property editor</caption>
   * registerPropertyEditor('text', function (type, props) {
   *  return {
   *    component: Input,
   *    props: {
   *      className: 'form-control',
   *      onChange: props.onChange
   *    }
   *  };
   * })
   */
  registerPropertyEditor: function registerPropertyEditor(type, factory) {
    _Izenda2.default.containKey(type) && _Izenda2.default.unregister(type);
    _Izenda2.default.register(type, factory);
  },


  /**
   * Create a dropdown editor schema in Properties editor panel.
   * This function is used as the factory property value of propertySchema of report part/style configuration
   * @param {Object} props The editor properties
   * @param {string} props.title The title of label
   * @param {string} [props.info] The information tooltip of dropdown editor
   * @param {Any} props.value The value of selected item of dropdown editor
   * @param {Object} props.props The component properties
   * @param {boolean} [props.isHidden=false] Hide the editor or not.
   * @example <caption>An example of how using the function to create a dropdown list field schema in report part property schema</caption>
   *  {
   *       factory: createDropDownSchema,
   *       title: 'Example Dropdown',
   *       value: 'getChartType',
   *       props: {
   *         defaultValue: 'value1',
   *         options: ['value1', 'value2']
   *       }
   *  }
   */
  createDropDownPropertySchema: _Izenda3.createDropDownSchema,

  /**
   * Create a popup editor schema in Properties editor panel. It appears as a label and a gear button which opens the popup dialog.
   * This function is used as the factory property value of propertySchema of report part/style configuration
   * @param {Object} props The editor properties
   * @param {string} props.title The title of label
   * @param {string} [props.info] The information tooltip of editor
   * @param {Any} props.value The value of selected item of editor
   * @param {Object} props.props The component computational properties
   * @param {Object} props.staticProps The component's static properties
   * @param {boolean} [props.isHidden=false] Hide the editor or not.
   * @example
   * {
   *   factory: createPopupSettingSchema,
   *   title: 'Border',
   *   value: 'getBorder',
   *   props: {
   *     reportPartType: REPORT_PART_TYPE.Chart,
   *     title: 'Border Settings',
   *     // The Border settings dialog uses chart properties to render the preview
   *     allChartProps: 'getAllChartProps',
   *     // Getter function or property to determine whether the setting exists
   *     hadSetting: 'hadSettingBorder',
   *     // Function to reset the setting value
   *     fnResetDefaultValue: 'fnResetBorderDefaultValue',
   *     // Getter function to retrieve value
   *     loadValue: 'getBorder'
   *   },
   *   staticProps: {
   *     popupTitle: 'Border Settings',
   *     popupContent: ChartBorderSettings
   *   }
   * }
   */
  createPopupSettingPropertySchema: _Izenda3.createPopupSettingSchema,

  /**
   * Create a checkbox editor schema in Properties editor panel. It appears as a label and a checkbox.
   * This function is used as the factory property value of propertySchema of report part/style configuration
   * @param {Object} props The editor properties
   * @param {string} props.title The title of label
   * @param {string} [props.info] The information tooltip of editor
   * @param {Any} props.value The value of selected item of editor
   * @param {boolean} [props.isHidden=false] Hide the editor or not.
   * @example
   *  izSeparator: {
   *     factory: createCheckBoxSchema,
   *     title: 'Use Separator',
   *     // 'getValueByKey' is a default getter function of Chart that allows to get the value of a property of chart properties by its field name, ie. izSeparator
   *     value: 'getValueByKey'
   *  }
   */
  createCheckBoxPropertySchema: _Izenda3.createCheckBoxSchema,

  /**
   * Create a select editor schema in Properties editor panel. It appears as a label and select control.
   * This function is used as the factory property value of propertySchema of report part/style configuration
   * @param {Object} props The editor properties
   * @param {string} props.title The title of editor
   * @param {string} [props.info] The information tooltip of editor
   * @param {Any} props.value The value of selected item of editor
   * @param {Object} props.props The component computational properties
   * @param {Object} props.staticProps The component's static properties
   * @param {boolean} [props.isHidden=false] Hide the editor or not.
   * @example <caption>Create a selection list of state with default blank option is All</caption>
   * {
   *     factory: createSelectSchema,
   *     title: 'State',
   *     value: 'getValueByKey',
   *     props: {
   *       options: 'getStateByCountry'
   *     },
   *     staticProps: {
   *       blankOption: true,
   *       blankOptionText: 'All'
   *     }
   *   }
   */
  createSelectPropertySchema: _Izenda3.createSelectSchema,

  /**
   * Create a number editor schema in Properties editor panel. It appears as a label and number input control.
   * This function is used as the factory property value of propertySchema of report part/style configuration
   * @param {Object} props The editor properties
   * @param {string} props.title The title of label
   * @param {string} [props.info] The information tooltip of editor
   * @param {Any} props.value The value of selected item of editor
   * @param {Object} props.props The component properties
   * @param {boolean} [props.isHidden=false] Hide the editor or not.
   * @example
   * {
   *     factory: createNumberSchema,
   *     title: 'Item Per Row',
   *     value: 'getValueByKey',
   *     props: {
   *       min: 1,
   *       max: 20,
   *       isDecimal: false
   *     }
   * }
   */
  createNumberPropertySchema: _Izenda3.createNumberSchema,

  /**
   * Create a color palette editor schema in Properties editor panel. It appears as a label and color palette input control.
   * This function is used as the factory property value of propertySchema of report part/style configuration
   * @param {Object} props The editor properties
   * @param {string} props.title The title of label
   * @param {string} [props.info] The information tooltip of editor
   * @param {Any} props.value The value of selected item of editor
   * @param {Object} props.props The component properties
   * @param {boolean} [props.isHidden=false] Hide the editor or not.
   * @example
   * {
   *     factory: createColorPaletteSettingSchema,
   *     title: 'Color Theme',
   *     value: 'getColorTheme',
   *     props: {
   *       selectionPopupTitle:'Select Color Theme',
   *       defaultColorThemeLabel:'No Theme',
   *       displaySettingStatus: true,
   *       needMaskDefault: false,
   *       defaultColorPalette: null,
   *       hiddenByState: true
   *     }
   * }
   */
  createColorPaletteSettingPropertySchema: _Izenda3.createColorPaletteSettingSchema,

  /**
   * Create a text orientation editor schema in Properties editor panel. It appears as a label and text orientation input control.
   * This function is used as the factory property value of propertySchema of report part/style configuration
   * @param {Object} props The editor properties
   * @param {string} props.title The title of label
   * @param {string} [props.info] The information tooltip of editor
   * @param {Any} props.value The value of selected item of editor
   * @param {boolean} [props.isHidden=false] Hide the editor or not
   * @example
   * {
   *     factory: createOrientationSettingsSchema,
   *     title: 'Label Orientation',
   *     value: 'getValueByKey'
   * }
   */
  createOrientationSettingPropertySchema: _Izenda3.createOrientationSettingsSchema
};
module.exports = exports['default'];

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(542);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldContainerApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * Register field container with its factory function in order to create a custom field
   * container in Report Designer's report part configuration. Most of the time, using createFieldContainerSchema function
   * to create labeled box of fields fits in the same way with current Values, Labels... field containers.
   * @param {string} type Field container type, i.e. chart_label, grid_rows...
   * @param {Function} factory Function to create field container
   * @example <caption>Create an custom metric fields container using CustomMetricReactComponent</caption>
   *  // Note that it requires to create a React component to render the custom metric GUI
   *  registerFieldContainer('custom_metric', function (type, containerProps){
   *    return {
   *      key: type,
   *      component: CustomMetricReactComponent,
   *      props : containerProps
   *    }
   *  });
   */
  registerFieldContainer: function registerFieldContainer(type, factory) {
    _Izenda2.default.containKey(type) && _Izenda2.default.unregister(type);
    _Izenda2.default.register(type, factory);
  },


  /**
   * Create a label and an input box of fields which allows to add/remove or drag/drop a field into.
   * @param {string} containerKey An unique container key to identify which container is
   * @param {string|Function} label The label text value or a function return a text
   * @param {string} dataKey Data key to access container information of report part content's property
   * @param {int} height Pixel height of container. Leave it null or undefined to use default height.
   * @param {int} maximumField Maximum number of fields in the container. Leave it null or undefined to unlimit the number of fields
   * @param {boolean} [isHorizontal=false] Is horizontal alignment between label and input box. Default value is false.
   * @example <caption>Create Z-Axis Values field container with dataKey is ZValues, having default height and 1 field maximum</caption>
   *  createFieldContainerSchema('ZValues', 'Z-Axis Values', 'ZValues', null, 1)
   */
  createFieldContainerSchema: _Izenda3.createContainerSchema,

  /**
   * Create a static label only without input box
   * @param {string} key The unique container key
   * @param {string|Function} label The label text value or a function return a text
   * @example
   *  createStaticLabelSchema('LabelPoint', () => localizer.getText('LABEL_POINT_OPTIONS'))
   */
  createStaticLabelFieldContainerSchema: _Izenda3.createStaticLabelSchema,

  /**
   * Create a conditional label and a input box of fields which allows to add/remove or drag/drop a field into.
   * @param {Function} predicateFn A predicate to determine whether render the container or not. It receives report part detail object as a parameter.
   * @param {string} containerKey key
   * @param {string|Function} label The label text value or a function return a text
   * @param {string} dataKey Data key to access container information of report part content's property
   * @param {int} height Pixel height of container. Leave it null or undefined to use default height.
   * @param {int} maximumField Maximum number of fields in the container. Leave it null or undefined to unlimit the number of fields
   * @param {boolean} [isHorizontal=false] Is horizontal alignment between label and input box. Default value is false.
   * @example <caption>Create an example container with dataKey is exampleContainer, having default height and 1 field maximum</caption>
   *  createConditionalContainerSchema(
   *    function(reportPartDetail) {
   *      return true;
   *    },
   *    'exampleContainer',
   *    () => localizer.getText('ExampleContainer'),
   *    'exampleContainer',
   *    null,
   *    1,
   *    true
   *  )
   */
  createConditionalFieldContainerSchema: _Izenda3.createConditionalContainerSchema
};
module.exports = exports['default'];

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(451);

var _Izenda2 = _interopRequireDefault(_Izenda);

var _Izenda3 = __webpack_require__(1104);

var _Izenda4 = _interopRequireDefault(_Izenda3);

var _Izenda5 = __webpack_require__(658);

var _Izenda6 = _interopRequireDefault(_Izenda5);

var _Izenda7 = __webpack_require__(1103);

var _Izenda8 = _interopRequireDefault(_Izenda7);

var _Izenda9 = __webpack_require__(424);

var _Izenda10 = _interopRequireDefault(_Izenda9);

var _Izenda11 = __webpack_require__(428);

var _Izenda12 = _interopRequireDefault(_Izenda11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------
// <copyright file="Izenda.VisualizationApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

exports.default = {
  /**
   * Get the built-in visualization name constants
   */
  get VISUALIZATION_NAMES() {
    return _Izenda4.default;
  },

  /**
   * Register a visualization engine with a name
   * @param {string} name The name of visualization engine
   * @param {Function} vizEngineClazz The class or constructor function of visualization engine.
   * This class must inherit from VizEngine class.
   * @example
   * class D3 extends VizEngine {
   *    draw(chartContainer, chartType, options, onCompleted) {
   *      //Implement the drawing logic into chartContainer here.
   *    }
   * }
   *
   * registerVisualizationEngine('D3', D3);
   */
  registerVisualizationEngine: function registerVisualizationEngine(name, vizEngineClazz) {
    _Izenda2.default.registerVisualizationEngine(name, vizEngineClazz);
  }
};
module.exports = exports['default'];

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Izenda = __webpack_require__(657);

var _Izenda2 = _interopRequireDefault(_Izenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  /**
   * Get the class by name
   * @param {string} name Name of class
   * @example <caption>Get VizEngine class</caption>
   * getClass('VizEngine')
   */
  getClass: function getClass(name) {
    return _Izenda2.default.get(name);
  }
};
// ----------------------------------------------------------------------
// <copyright file="Izenda.ClassProviderApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

module.exports = exports['default'];

/***/ })
],[1226]);
});


// WEBPACK FOOTER //
// izenda_ui.js